/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(2083);
	module.exports = __webpack_require__(2145);


/***/ },
/* 1 */
/***/ function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(2250);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 3 */
/***/ function(module, exports) {

	/**
	 * @module zrender/core/util
	 */
	// 用于处理merge时无法遍历Date等对象的问题
	var BUILTIN_OBJECT = {
	  '[object Function]': 1,
	  '[object RegExp]': 1,
	  '[object Date]': 1,
	  '[object Error]': 1,
	  '[object CanvasGradient]': 1,
	  '[object CanvasPattern]': 1,
	  // For node-canvas
	  '[object Image]': 1,
	  '[object Canvas]': 1
	};
	var TYPED_ARRAY = {
	  '[object Int8Array]': 1,
	  '[object Uint8Array]': 1,
	  '[object Uint8ClampedArray]': 1,
	  '[object Int16Array]': 1,
	  '[object Uint16Array]': 1,
	  '[object Int32Array]': 1,
	  '[object Uint32Array]': 1,
	  '[object Float32Array]': 1,
	  '[object Float64Array]': 1
	};
	var objToString = Object.prototype.toString;
	var arrayProto = Array.prototype;
	var nativeForEach = arrayProto.forEach;
	var nativeFilter = arrayProto.filter;
	var nativeSlice = arrayProto.slice;
	var nativeMap = arrayProto.map;
	var nativeReduce = arrayProto.reduce; // Avoid assign to an exported variable, for transforming to cjs.
	
	var methods = {};
	
	function $override(name, fn) {
	  // Clear ctx instance for different environment
	  if (name === 'createCanvas') {
	    _ctx = null;
	  }
	
	  methods[name] = fn;
	}
	/**
	 * Those data types can be cloned:
	 *     Plain object, Array, TypedArray, number, string, null, undefined.
	 * Those data types will be assgined using the orginal data:
	 *     BUILTIN_OBJECT
	 * Instance of user defined class will be cloned to a plain object, without
	 * properties in prototype.
	 * Other data types is not supported (not sure what will happen).
	 *
	 * Caution: do not support clone Date, for performance consideration.
	 * (There might be a large number of date in `series.data`).
	 * So date should not be modified in and out of echarts.
	 *
	 * @param {*} source
	 * @return {*} new
	 */
	
	
	function clone(source) {
	  if (source == null || typeof source !== 'object') {
	    return source;
	  }
	
	  var result = source;
	  var typeStr = objToString.call(source);
	
	  if (typeStr === '[object Array]') {
	    if (!isPrimitive(source)) {
	      result = [];
	
	      for (var i = 0, len = source.length; i < len; i++) {
	        result[i] = clone(source[i]);
	      }
	    }
	  } else if (TYPED_ARRAY[typeStr]) {
	    if (!isPrimitive(source)) {
	      var Ctor = source.constructor;
	
	      if (source.constructor.from) {
	        result = Ctor.from(source);
	      } else {
	        result = new Ctor(source.length);
	
	        for (var i = 0, len = source.length; i < len; i++) {
	          result[i] = clone(source[i]);
	        }
	      }
	    }
	  } else if (!BUILTIN_OBJECT[typeStr] && !isPrimitive(source) && !isDom(source)) {
	    result = {};
	
	    for (var key in source) {
	      if (source.hasOwnProperty(key)) {
	        result[key] = clone(source[key]);
	      }
	    }
	  }
	
	  return result;
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} target
	 * @param {*} source
	 * @param {boolean} [overwrite=false]
	 */
	
	
	function merge(target, source, overwrite) {
	  // We should escapse that source is string
	  // and enter for ... in ...
	  if (!isObject(source) || !isObject(target)) {
	    return overwrite ? clone(source) : target;
	  }
	
	  for (var key in source) {
	    if (source.hasOwnProperty(key)) {
	      var targetProp = target[key];
	      var sourceProp = source[key];
	
	      if (isObject(sourceProp) && isObject(targetProp) && !isArray(sourceProp) && !isArray(targetProp) && !isDom(sourceProp) && !isDom(targetProp) && !isBuiltInObject(sourceProp) && !isBuiltInObject(targetProp) && !isPrimitive(sourceProp) && !isPrimitive(targetProp)) {
	        // 如果需要递归覆盖，就递归调用merge
	        merge(targetProp, sourceProp, overwrite);
	      } else if (overwrite || !(key in target)) {
	        // 否则只处理overwrite为true，或者在目标对象中没有此属性的情况
	        // NOTE，在 target[key] 不存在的时候也是直接覆盖
	        target[key] = clone(source[key], true);
	      }
	    }
	  }
	
	  return target;
	}
	/**
	 * @param {Array} targetAndSources The first item is target, and the rests are source.
	 * @param {boolean} [overwrite=false]
	 * @return {*} target
	 */
	
	
	function mergeAll(targetAndSources, overwrite) {
	  var result = targetAndSources[0];
	
	  for (var i = 1, len = targetAndSources.length; i < len; i++) {
	    result = merge(result, targetAndSources[i], overwrite);
	  }
	
	  return result;
	}
	/**
	 * @param {*} target
	 * @param {*} source
	 * @memberOf module:zrender/core/util
	 */
	
	
	function extend(target, source) {
	  for (var key in source) {
	    if (source.hasOwnProperty(key)) {
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	/**
	 * @param {*} target
	 * @param {*} source
	 * @param {boolean} [overlay=false]
	 * @memberOf module:zrender/core/util
	 */
	
	
	function defaults(target, source, overlay) {
	  for (var key in source) {
	    if (source.hasOwnProperty(key) && (overlay ? source[key] != null : target[key] == null)) {
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	var createCanvas = function () {
	  return methods.createCanvas();
	};
	
	methods.createCanvas = function () {
	  return document.createElement('canvas');
	}; // FIXME
	
	
	var _ctx;
	
	function getContext() {
	  if (!_ctx) {
	    // Use util.createCanvas instead of createCanvas
	    // because createCanvas may be overwritten in different environment
	    _ctx = createCanvas().getContext('2d');
	  }
	
	  return _ctx;
	}
	/**
	 * 查询数组中元素的index
	 * @memberOf module:zrender/core/util
	 */
	
	
	function indexOf(array, value) {
	  if (array) {
	    if (array.indexOf) {
	      return array.indexOf(value);
	    }
	
	    for (var i = 0, len = array.length; i < len; i++) {
	      if (array[i] === value) {
	        return i;
	      }
	    }
	  }
	
	  return -1;
	}
	/**
	 * 构造类继承关系
	 *
	 * @memberOf module:zrender/core/util
	 * @param {Function} clazz 源类
	 * @param {Function} baseClazz 基类
	 */
	
	
	function inherits(clazz, baseClazz) {
	  var clazzPrototype = clazz.prototype;
	
	  function F() {}
	
	  F.prototype = baseClazz.prototype;
	  clazz.prototype = new F();
	
	  for (var prop in clazzPrototype) {
	    if (clazzPrototype.hasOwnProperty(prop)) {
	      clazz.prototype[prop] = clazzPrototype[prop];
	    }
	  }
	
	  clazz.prototype.constructor = clazz;
	  clazz.superClass = baseClazz;
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {Object|Function} target
	 * @param {Object|Function} sorce
	 * @param {boolean} overlay
	 */
	
	
	function mixin(target, source, overlay) {
	  target = 'prototype' in target ? target.prototype : target;
	  source = 'prototype' in source ? source.prototype : source;
	  defaults(target, source, overlay);
	}
	/**
	 * Consider typed array.
	 * @param {Array|TypedArray} data
	 */
	
	
	function isArrayLike(data) {
	  if (!data) {
	    return;
	  }
	
	  if (typeof data === 'string') {
	    return false;
	  }
	
	  return typeof data.length === 'number';
	}
	/**
	 * 数组或对象遍历
	 * @memberOf module:zrender/core/util
	 * @param {Object|Array} obj
	 * @param {Function} cb
	 * @param {*} [context]
	 */
	
	
	function each(obj, cb, context) {
	  if (!(obj && cb)) {
	    return;
	  }
	
	  if (obj.forEach && obj.forEach === nativeForEach) {
	    obj.forEach(cb, context);
	  } else if (obj.length === +obj.length) {
	    for (var i = 0, len = obj.length; i < len; i++) {
	      cb.call(context, obj[i], i, obj);
	    }
	  } else {
	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) {
	        cb.call(context, obj[key], key, obj);
	      }
	    }
	  }
	}
	/**
	 * 数组映射
	 * @memberOf module:zrender/core/util
	 * @param {Array} obj
	 * @param {Function} cb
	 * @param {*} [context]
	 * @return {Array}
	 */
	
	
	function map(obj, cb, context) {
	  if (!(obj && cb)) {
	    return;
	  }
	
	  if (obj.map && obj.map === nativeMap) {
	    return obj.map(cb, context);
	  } else {
	    var result = [];
	
	    for (var i = 0, len = obj.length; i < len; i++) {
	      result.push(cb.call(context, obj[i], i, obj));
	    }
	
	    return result;
	  }
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {Array} obj
	 * @param {Function} cb
	 * @param {Object} [memo]
	 * @param {*} [context]
	 * @return {Array}
	 */
	
	
	function reduce(obj, cb, memo, context) {
	  if (!(obj && cb)) {
	    return;
	  }
	
	  if (obj.reduce && obj.reduce === nativeReduce) {
	    return obj.reduce(cb, memo, context);
	  } else {
	    for (var i = 0, len = obj.length; i < len; i++) {
	      memo = cb.call(context, memo, obj[i], i, obj);
	    }
	
	    return memo;
	  }
	}
	/**
	 * 数组过滤
	 * @memberOf module:zrender/core/util
	 * @param {Array} obj
	 * @param {Function} cb
	 * @param {*} [context]
	 * @return {Array}
	 */
	
	
	function filter(obj, cb, context) {
	  if (!(obj && cb)) {
	    return;
	  }
	
	  if (obj.filter && obj.filter === nativeFilter) {
	    return obj.filter(cb, context);
	  } else {
	    var result = [];
	
	    for (var i = 0, len = obj.length; i < len; i++) {
	      if (cb.call(context, obj[i], i, obj)) {
	        result.push(obj[i]);
	      }
	    }
	
	    return result;
	  }
	}
	/**
	 * 数组项查找
	 * @memberOf module:zrender/core/util
	 * @param {Array} obj
	 * @param {Function} cb
	 * @param {*} [context]
	 * @return {*}
	 */
	
	
	function find(obj, cb, context) {
	  if (!(obj && cb)) {
	    return;
	  }
	
	  for (var i = 0, len = obj.length; i < len; i++) {
	    if (cb.call(context, obj[i], i, obj)) {
	      return obj[i];
	    }
	  }
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {Function} func
	 * @param {*} context
	 * @return {Function}
	 */
	
	
	function bind(func, context) {
	  var args = nativeSlice.call(arguments, 2);
	  return function () {
	    return func.apply(context, args.concat(nativeSlice.call(arguments)));
	  };
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {Function} func
	 * @return {Function}
	 */
	
	
	function curry(func) {
	  var args = nativeSlice.call(arguments, 1);
	  return function () {
	    return func.apply(this, args.concat(nativeSlice.call(arguments)));
	  };
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isArray(value) {
	  return objToString.call(value) === '[object Array]';
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isFunction(value) {
	  return typeof value === 'function';
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isString(value) {
	  return objToString.call(value) === '[object String]';
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return type === 'function' || !!value && type === 'object';
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isBuiltInObject(value) {
	  return !!BUILTIN_OBJECT[objToString.call(value)];
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isTypedArray(value) {
	  return !!TYPED_ARRAY[objToString.call(value)];
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isDom(value) {
	  return typeof value === 'object' && typeof value.nodeType === 'number' && typeof value.ownerDocument === 'object';
	}
	/**
	 * Whether is exactly NaN. Notice isNaN('a') returns true.
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function eqNaN(value) {
	  /* eslint-disable-next-line no-self-compare */
	  return value !== value;
	}
	/**
	 * If value1 is not null, then return value1, otherwise judget rest of values.
	 * Low performance.
	 * @memberOf module:zrender/core/util
	 * @return {*} Final value
	 */
	
	
	function retrieve(values) {
	  for (var i = 0, len = arguments.length; i < len; i++) {
	    if (arguments[i] != null) {
	      return arguments[i];
	    }
	  }
	}
	
	function retrieve2(value0, value1) {
	  return value0 != null ? value0 : value1;
	}
	
	function retrieve3(value0, value1, value2) {
	  return value0 != null ? value0 : value1 != null ? value1 : value2;
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {Array} arr
	 * @param {number} startIndex
	 * @param {number} endIndex
	 * @return {Array}
	 */
	
	
	function slice() {
	  return Function.call.apply(nativeSlice, arguments);
	}
	/**
	 * Normalize css liked array configuration
	 * e.g.
	 *  3 => [3, 3, 3, 3]
	 *  [4, 2] => [4, 2, 4, 2]
	 *  [4, 3, 2] => [4, 3, 2, 3]
	 * @param {number|Array.<number>} val
	 * @return {Array.<number>}
	 */
	
	
	function normalizeCssArray(val) {
	  if (typeof val === 'number') {
	    return [val, val, val, val];
	  }
	
	  var len = val.length;
	
	  if (len === 2) {
	    // vertical | horizontal
	    return [val[0], val[1], val[0], val[1]];
	  } else if (len === 3) {
	    // top | horizontal | bottom
	    return [val[0], val[1], val[2], val[1]];
	  }
	
	  return val;
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {boolean} condition
	 * @param {string} message
	 */
	
	
	function assert(condition, message) {
	  if (!condition) {
	    throw new Error(message);
	  }
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {string} str string to be trimed
	 * @return {string} trimed string
	 */
	
	
	function trim(str) {
	  if (str == null) {
	    return null;
	  } else if (typeof str.trim === 'function') {
	    return str.trim();
	  } else {
	    return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
	  }
	}
	
	var primitiveKey = '__ec_primitive__';
	/**
	 * Set an object as primitive to be ignored traversing children in clone or merge
	 */
	
	function setAsPrimitive(obj) {
	  obj[primitiveKey] = true;
	}
	
	function isPrimitive(obj) {
	  return obj[primitiveKey];
	}
	/**
	 * @constructor
	 * @param {Object} obj Only apply `ownProperty`.
	 */
	
	
	function HashMap(obj) {
	  var isArr = isArray(obj); // Key should not be set on this, otherwise
	  // methods get/set/... may be overrided.
	
	  this.data = {};
	  var thisMap = this;
	  obj instanceof HashMap ? obj.each(visit) : obj && each(obj, visit);
	
	  function visit(value, key) {
	    isArr ? thisMap.set(value, key) : thisMap.set(key, value);
	  }
	}
	
	HashMap.prototype = {
	  constructor: HashMap,
	  // Do not provide `has` method to avoid defining what is `has`.
	  // (We usually treat `null` and `undefined` as the same, different
	  // from ES6 Map).
	  get: function (key) {
	    return this.data.hasOwnProperty(key) ? this.data[key] : null;
	  },
	  set: function (key, value) {
	    // Comparing with invocation chaining, `return value` is more commonly
	    // used in this case: `var someVal = map.set('a', genVal());`
	    return this.data[key] = value;
	  },
	  // Although util.each can be performed on this hashMap directly, user
	  // should not use the exposed keys, who are prefixed.
	  each: function (cb, context) {
	    context !== void 0 && (cb = bind(cb, context));
	    /* eslint-disable guard-for-in */
	
	    for (var key in this.data) {
	      this.data.hasOwnProperty(key) && cb(this.data[key], key);
	    }
	    /* eslint-enable guard-for-in */
	
	  },
	  // Do not use this method if performance sensitive.
	  removeKey: function (key) {
	    delete this.data[key];
	  }
	};
	
	function createHashMap(obj) {
	  return new HashMap(obj);
	}
	
	function concatArray(a, b) {
	  var newArray = new a.constructor(a.length + b.length);
	
	  for (var i = 0; i < a.length; i++) {
	    newArray[i] = a[i];
	  }
	
	  var offset = a.length;
	
	  for (i = 0; i < b.length; i++) {
	    newArray[i + offset] = b[i];
	  }
	
	  return newArray;
	}
	
	function noop() {}
	
	exports.$override = $override;
	exports.clone = clone;
	exports.merge = merge;
	exports.mergeAll = mergeAll;
	exports.extend = extend;
	exports.defaults = defaults;
	exports.createCanvas = createCanvas;
	exports.getContext = getContext;
	exports.indexOf = indexOf;
	exports.inherits = inherits;
	exports.mixin = mixin;
	exports.isArrayLike = isArrayLike;
	exports.each = each;
	exports.map = map;
	exports.reduce = reduce;
	exports.filter = filter;
	exports.find = find;
	exports.bind = bind;
	exports.curry = curry;
	exports.isArray = isArray;
	exports.isFunction = isFunction;
	exports.isString = isString;
	exports.isObject = isObject;
	exports.isBuiltInObject = isBuiltInObject;
	exports.isTypedArray = isTypedArray;
	exports.isDom = isDom;
	exports.eqNaN = eqNaN;
	exports.retrieve = retrieve;
	exports.retrieve2 = retrieve2;
	exports.retrieve3 = retrieve3;
	exports.slice = slice;
	exports.normalizeCssArray = normalizeCssArray;
	exports.assert = assert;
	exports.trim = trim;
	exports.setAsPrimitive = setAsPrimitive;
	exports.isPrimitive = isPrimitive;
	exports.createHashMap = createHashMap;
	exports.concatArray = concatArray;
	exports.noop = noop;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1927)();
	}


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(153);
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;
	  var cache = new WeakMap();
	
	  _getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };
	
	  return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }
	
	  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return {
	      "default": obj
	    };
	  }
	
	  var cache = _getRequireWildcardCache();
	
	  if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }
	
	  var newObj = {};
	  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
	
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
	
	      if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }
	
	  newObj["default"] = obj;
	
	  if (cache) {
	    cache.set(obj, newObj);
	  }
	
	  return newObj;
	}
	
	module.exports = _interopRequireWildcard;

/***/ },
/* 6 */
/***/ function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.29.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m),
	                parsedParts = some.call(flags.parsedDateParts, function (i) {
	                    return i != null;
	                }),
	                isNowValid =
	                    !isNaN(m._d.getTime()) &&
	                    flags.overflow < 0 &&
	                    !flags.empty &&
	                    !flags.invalidEra &&
	                    !flags.invalidMonth &&
	                    !flags.invalidWeekday &&
	                    !flags.weekdayMismatch &&
	                    !flags.nullInput &&
	                    !flags.invalidFormat &&
	                    !flags.userInvalidated &&
	                    (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            } else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key;
	                for (i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias(unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        return mom.isValid()
	            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
	            : NaN;
	    }
	
	    function set$1(mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (
	                unit === 'FullYear' &&
	                isLeapYear(mom.year()) &&
	                mom.month() === 1 &&
	                mom.date() === 29
	            ) {
	                value = toInt(value);
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
	                    value,
	                    mom.month(),
	                    daysInMonth(value, mom.month())
	                );
	            } else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i;
	            for (i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
	                    matched,
	                    p1,
	                    p2,
	                    p3,
	                    p4
	                ) {
	                    return p1 || p2 || p3 || p4;
	                })
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M', match1to2);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
	            '_'
	        ),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w', match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
	        input,
	        week,
	        config,
	        token
	    ) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	            ? weekdays[m.day()]
	            : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	            ? this._weekdaysShort[m.day()]
	            : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	            ? this._weekdaysMin[m.day()]
	            : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2);
	    addRegexToken('h', match1to2);
	    addRegexToken('k', match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(1917)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                    ? DATE
	                    : a[HOUR] < 0 ||
	                      a[HOUR] > 24 ||
	                      (a[HOUR] === 24 &&
	                          (a[MINUTE] !== 0 ||
	                              a[SECOND] !== 0 ||
	                              a[MILLISECOND] !== 0))
	                    ? HOUR
	                    : a[MINUTE] < 0 || a[MINUTE] > 59
	                    ? MINUTE
	                    : a[SECOND] < 0 || a[SECOND] > 59
	                    ? SECOND
	                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                    ? MILLISECOND
	                    : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^)]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	            ? 'lastWeek'
	            : diff < 0
	            ? 'lastDay'
	            : diff < 1
	            ? 'sameDay'
	            : diff < 2
	            ? 'nextDay'
	            : diff < 7
	            ? 'nextWeek'
	            : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
	        input,
	        array,
	        config,
	        token
	    ) {
	        var era = config._locale.erasParse(input, token, config._strict);
	        if (era) {
	            getParsingFlags(config).era = era;
	        } else {
	            getParsingFlags(config).invalidEra = input;
	        }
	    });
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            namePieces.push(regexEscape(eras[i].name));
	            abbrPieces.push(regexEscape(eras[i].abbr));
	            narrowPieces.push(regexEscape(eras[i].narrow));
	
	            mixedPieces.push(regexEscape(eras[i].name));
	            mixedPieces.push(regexEscape(eras[i].abbr));
	            mixedPieces.push(regexEscape(eras[i].narrow));
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
	        input,
	        week,
	        config,
	        token
	    ) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D', match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m', match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s', match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1() {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y');
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.29.1';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(291)(module)))

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(10);
	var Context = /** @class */ (function () {
	    function Context(params, logger) {
	        this.beanWrappers = {};
	        this.registeredModules = [];
	        this.componentsMappedByName = {};
	        this.destroyed = false;
	        if (!params || !params.beans) {
	            return;
	        }
	        this.contextParams = params;
	        this.registeredModules = params.registeredModules;
	        this.logger = logger;
	        this.logger.log(">> creating ag-Application Context");
	        this.setupComponents();
	        this.createBeans();
	        var beanInstances = this.getBeanInstances();
	        this.wireBeans(beanInstances);
	        this.logger.log(">> ag-Application Context ready - component is alive");
	    }
	    Context.prototype.getBeanInstances = function () {
	        return utils_1._.mapObject(this.beanWrappers, function (beanEntry) { return beanEntry.beanInstance; });
	    };
	    Context.prototype.setupComponents = function () {
	        var _this = this;
	        if (this.contextParams.components) {
	            this.contextParams.components.forEach(function (componentMeta) { return _this.addComponent(componentMeta); });
	        }
	    };
	    Context.prototype.addComponent = function (componentMeta) {
	        // get name of the class as a string
	        // let className = _.getNameOfClass(ComponentClass);
	        // insert a dash after every capital letter
	        // let classEscaped = className.replace(/([A-Z])/g, "-$1").toLowerCase();
	        var classEscaped = componentMeta.componentName.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
	        // put all to upper case
	        var classUpperCase = classEscaped.toUpperCase();
	        // finally store
	        this.componentsMappedByName[classUpperCase] = componentMeta.theClass;
	    };
	    Context.prototype.createComponentFromElement = function (element, afterPreCreateCallback) {
	        var key = element.nodeName;
	        if (this.componentsMappedByName && this.componentsMappedByName[key]) {
	            var newComponent = new this.componentsMappedByName[key]();
	            this.wireBean(newComponent, afterPreCreateCallback);
	            return newComponent;
	        }
	        return null;
	    };
	    Context.prototype.wireBean = function (bean, afterPreCreateCallback) {
	        if (!bean) {
	            throw Error("Can't wire to bean since it is null");
	        }
	        this.wireBeans([bean], afterPreCreateCallback);
	    };
	    Context.prototype.wireBeans = function (beanInstances, afterPreCreateCallback) {
	        this.autoWireBeans(beanInstances);
	        this.methodWireBeans(beanInstances);
	        this.callLifeCycleMethods(beanInstances, 'preConstructMethods');
	        // the callback sets the attributes, so the component has access to attributes
	        // before postConstruct methods in the component are executed
	        if (utils_1._.exists(afterPreCreateCallback)) {
	            beanInstances.forEach(afterPreCreateCallback);
	        }
	        this.callLifeCycleMethods(beanInstances, 'postConstructMethods');
	    };
	    Context.prototype.createBeans = function () {
	        var _this = this;
	        // register all normal beans
	        this.contextParams.beans.forEach(this.createBeanWrapper.bind(this));
	        // register override beans, these will overwrite beans above of same name
	        if (this.contextParams.overrideBeans) {
	            this.contextParams.overrideBeans.forEach(this.createBeanWrapper.bind(this));
	        }
	        // instantiate all beans - overridden beans will be left out
	        utils_1._.iterateObject(this.beanWrappers, function (key, beanEntry) {
	            var constructorParamsMeta;
	            if (beanEntry.bean.__agBeanMetaData && beanEntry.bean.__agBeanMetaData.autowireMethods && beanEntry.bean.__agBeanMetaData.autowireMethods.agConstructor) {
	                constructorParamsMeta = beanEntry.bean.__agBeanMetaData.autowireMethods.agConstructor;
	            }
	            var constructorParams = _this.getBeansForParameters(constructorParamsMeta, beanEntry.bean.name);
	            var newInstance = applyToConstructor(beanEntry.bean, constructorParams);
	            beanEntry.beanInstance = newInstance;
	            _this.logger.log("bean " + _this.getBeanName(newInstance) + " created");
	        });
	    };
	    // tslint:disable-next-line
	    Context.prototype.createBeanWrapper = function (Bean) {
	        var metaData = Bean.__agBeanMetaData;
	        if (!metaData) {
	            var beanName = void 0;
	            if (Bean.prototype.constructor) {
	                beanName = Bean.prototype.constructor.name;
	            }
	            else {
	                beanName = "" + Bean;
	            }
	            console.error("context item " + beanName + " is not a bean");
	            return;
	        }
	        var beanEntry = {
	            bean: Bean,
	            beanInstance: null,
	            beanName: metaData.beanName
	        };
	        this.beanWrappers[metaData.beanName] = beanEntry;
	    };
	    Context.prototype.autoWireBeans = function (beanInstances) {
	        var _this = this;
	        beanInstances.forEach(function (beanInstance) {
	            _this.forEachMetaDataInHierarchy(beanInstance, function (metaData, beanName) {
	                var attributes = metaData.agClassAttributes;
	                if (!attributes) {
	                    return;
	                }
	                attributes.forEach(function (attribute) {
	                    var otherBean = _this.lookupBeanInstance(beanName, attribute.beanName, attribute.optional);
	                    beanInstance[attribute.attributeName] = otherBean;
	                });
	            });
	        });
	    };
	    Context.prototype.methodWireBeans = function (beanInstances) {
	        var _this = this;
	        beanInstances.forEach(function (beanInstance) {
	            _this.forEachMetaDataInHierarchy(beanInstance, function (metaData, beanName) {
	                utils_1._.iterateObject(metaData.autowireMethods, function (methodName, wireParams) {
	                    // skip constructor, as this is dealt with elsewhere
	                    if (methodName === "agConstructor") {
	                        return;
	                    }
	                    var initParams = _this.getBeansForParameters(wireParams, beanName);
	                    beanInstance[methodName].apply(beanInstance, initParams);
	                });
	            });
	        });
	    };
	    Context.prototype.forEachMetaDataInHierarchy = function (beanInstance, callback) {
	        var prototype = Object.getPrototypeOf(beanInstance);
	        while (prototype != null) {
	            var constructor = prototype.constructor;
	            if (constructor.hasOwnProperty('__agBeanMetaData')) {
	                var metaData = constructor.__agBeanMetaData;
	                var beanName = this.getBeanName(constructor);
	                callback(metaData, beanName);
	            }
	            prototype = Object.getPrototypeOf(prototype);
	        }
	    };
	    Context.prototype.getBeanName = function (constructor) {
	        if (constructor.__agBeanMetaData && constructor.__agBeanMetaData.beanName) {
	            return constructor.__agBeanMetaData.beanName;
	        }
	        var constructorString = constructor.toString();
	        var beanName = constructorString.substring(9, constructorString.indexOf("("));
	        return beanName;
	    };
	    Context.prototype.getBeansForParameters = function (parameters, beanName) {
	        var _this = this;
	        var beansList = [];
	        if (parameters) {
	            utils_1._.iterateObject(parameters, function (paramIndex, otherBeanName) {
	                var otherBean = _this.lookupBeanInstance(beanName, otherBeanName);
	                beansList[Number(paramIndex)] = otherBean;
	            });
	        }
	        return beansList;
	    };
	    Context.prototype.lookupBeanInstance = function (wiringBean, beanName, optional) {
	        if (optional === void 0) { optional = false; }
	        if (beanName === "context") {
	            return this;
	        }
	        else if (this.contextParams.seed && this.contextParams.seed.hasOwnProperty(beanName)) {
	            return this.contextParams.seed[beanName];
	        }
	        else {
	            var beanEntry = this.beanWrappers[beanName];
	            if (beanEntry) {
	                return beanEntry.beanInstance;
	            }
	            if (!optional) {
	                console.error("ag-Grid: unable to find bean reference " + beanName + " while initialising " + wiringBean);
	            }
	            return null;
	        }
	    };
	    Context.prototype.callLifeCycleMethods = function (beanInstances, lifeCycleMethod) {
	        var _this = this;
	        beanInstances.forEach(function (beanInstance) {
	            _this.forEachMetaDataInHierarchy(beanInstance, function (metaData) {
	                var methods = metaData[lifeCycleMethod];
	                if (!methods) {
	                    return;
	                }
	                methods.forEach(function (methodName) { return beanInstance[methodName](); });
	            });
	        });
	    };
	    Context.prototype.getBean = function (name) {
	        return this.lookupBeanInstance("getBean", name, true);
	    };
	    Context.prototype.getEnterpriseDefaultComponents = function () {
	        return this.contextParams.enterpriseDefaultComponents;
	    };
	    Context.prototype.destroy = function () {
	        // should only be able to destroy once
	        if (this.destroyed) {
	            return;
	        }
	        this.logger.log(">> Shutting down ag-Application Context");
	        var beanInstances = this.getBeanInstances();
	        this.callLifeCycleMethods(beanInstances, 'preDestroyMethods');
	        this.contextParams.seed = null;
	        this.destroyed = true;
	        this.logger.log(">> ag-Application Context shut down - component is dead");
	    };
	    Context.prototype.isModuleRegistered = function (moduleName) {
	        return this.registeredModules.indexOf(moduleName) !== -1;
	    };
	    return Context;
	}());
	exports.Context = Context;
	// taken from: http://stackoverflow.com/questions/3362471/how-can-i-call-a-javascript-constructor-using-call-or-apply
	// allows calling 'apply' on a constructor
	function applyToConstructor(constructor, argArray) {
	    var args = [null].concat(argArray);
	    var factoryFunction = constructor.bind.apply(constructor, args);
	    return new factoryFunction();
	}
	function PreConstruct(target, methodName, descriptor) {
	    var props = getOrCreateProps(target.constructor);
	    if (!props.postConstructMethods) {
	        props.preConstructMethods = [];
	    }
	    props.preConstructMethods.push(methodName);
	}
	exports.PreConstruct = PreConstruct;
	function PostConstruct(target, methodName, descriptor) {
	    var props = getOrCreateProps(target.constructor);
	    if (!props.postConstructMethods) {
	        props.postConstructMethods = [];
	    }
	    props.postConstructMethods.push(methodName);
	}
	exports.PostConstruct = PostConstruct;
	function PreDestroy(target, methodName, descriptor) {
	    var props = getOrCreateProps(target.constructor);
	    if (!props.preDestroyMethods) {
	        props.preDestroyMethods = [];
	    }
	    props.preDestroyMethods.push(methodName);
	}
	exports.PreDestroy = PreDestroy;
	function Bean(beanName) {
	    return function (classConstructor) {
	        var props = getOrCreateProps(classConstructor);
	        props.beanName = beanName;
	    };
	}
	exports.Bean = Bean;
	function Autowired(name) {
	    return function (target, propertyKey, descriptor) {
	        autowiredFunc(target, name, false, target, propertyKey, null);
	    };
	}
	exports.Autowired = Autowired;
	function Optional(name) {
	    return function (target, propertyKey, descriptor) {
	        autowiredFunc(target, name, true, target, propertyKey, null);
	    };
	}
	exports.Optional = Optional;
	function autowiredFunc(target, name, optional, classPrototype, methodOrAttributeName, index) {
	    if (name === null) {
	        console.error("ag-Grid: Autowired name should not be null");
	        return;
	    }
	    if (typeof index === "number") {
	        console.error("ag-Grid: Autowired should be on an attribute");
	        return;
	    }
	    // it's an attribute on the class
	    var props = getOrCreateProps(target.constructor);
	    if (!props.agClassAttributes) {
	        props.agClassAttributes = [];
	    }
	    props.agClassAttributes.push({
	        attributeName: methodOrAttributeName,
	        beanName: name,
	        optional: optional
	    });
	}
	function Qualifier(name) {
	    return function (classPrototype, methodOrAttributeName, index) {
	        var constructor = typeof classPrototype == "function" ? classPrototype : classPrototype.constructor;
	        var props;
	        if (typeof index === "number") {
	            // it's a parameter on a method
	            var methodName = void 0;
	            if (methodOrAttributeName) {
	                props = getOrCreateProps(constructor);
	                methodName = methodOrAttributeName;
	            }
	            else {
	                props = getOrCreateProps(constructor);
	                methodName = "agConstructor";
	            }
	            if (!props.autowireMethods) {
	                props.autowireMethods = {};
	            }
	            if (!props.autowireMethods[methodName]) {
	                props.autowireMethods[methodName] = {};
	            }
	            props.autowireMethods[methodName][index] = name;
	        }
	    };
	}
	exports.Qualifier = Qualifier;
	function getOrCreateProps(target) {
	    if (!target.hasOwnProperty("__agBeanMetaData")) {
	        target.__agBeanMetaData = {};
	    }
	    return target.__agBeanMetaData;
	}


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var objectWithoutPropertiesLoose = __webpack_require__(570);
	
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = objectWithoutPropertiesLoose(source, excluded);
	  var key, i;
	
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutProperties;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1410));
	__export(__webpack_require__(1411));
	__export(__webpack_require__(1412));
	__export(__webpack_require__(1413));


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _styles = __webpack_require__(76);
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(241));
	
	function withStyles(stylesOrCreator, options) {
	  return (0, _styles.withStyles)(stylesOrCreator, (0, _extends2.default)({
	    defaultTheme: _defaultTheme.default
	  }, options));
	}
	
	var _default = withStyles;
	exports.default = _default;

/***/ },
/* 12 */
/***/ function(module, exports) {

	function toVal(mix) {
		var k, y, str='';
	
		if (typeof mix === 'string' || typeof mix === 'number') {
			str += mix;
		} else if (typeof mix === 'object') {
			if (Array.isArray(mix)) {
				for (k=0; k < mix.length; k++) {
					if (mix[k]) {
						if (y = toVal(mix[k])) {
							str && (str += ' ');
							str += y;
						}
					}
				}
			} else {
				for (k in mix) {
					if (mix[k]) {
						str && (str += ' ');
						str += k;
					}
				}
			}
		}
	
		return str;
	}
	
	module.exports = function () {
		var i=0, tmp, x, str='';
		while (i < arguments.length) {
			if (tmp = arguments[i++]) {
				if (x = toVal(tmp)) {
					str && (str += ' ');
					str += x
				}
			}
		}
		return str;
	}


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	var zrender = __webpack_require__(390);
	
	var zrUtil = __webpack_require__(3);
	
	var colorTool = __webpack_require__(114);
	
	var env = __webpack_require__(55);
	
	var timsort = __webpack_require__(555);
	
	var Eventful = __webpack_require__(189);
	
	var GlobalModel = __webpack_require__(749);
	
	var ExtensionAPI = __webpack_require__(693);
	
	var CoordinateSystemManager = __webpack_require__(92);
	
	var OptionManager = __webpack_require__(1692);
	
	var backwardCompat = __webpack_require__(1700);
	
	var dataStack = __webpack_require__(1703);
	
	var ComponentModel = __webpack_require__(57);
	
	var SeriesModel = __webpack_require__(58);
	
	var ComponentView = __webpack_require__(340);
	
	var ChartView = __webpack_require__(106);
	
	var graphic = __webpack_require__(16);
	
	var modelUtil = __webpack_require__(24);
	
	var _throttle = __webpack_require__(142);
	
	var throttle = _throttle.throttle;
	
	var seriesColor = __webpack_require__(1712);
	
	var aria = __webpack_require__(1711);
	
	var loadingDefault = __webpack_require__(1691);
	
	var Scheduler = __webpack_require__(1706);
	
	var lightTheme = __webpack_require__(1708);
	
	var darkTheme = __webpack_require__(1707);
	
	__webpack_require__(717);
	
	var mapDataStorage = __webpack_require__(472);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var assert = zrUtil.assert;
	var each = zrUtil.each;
	var isFunction = zrUtil.isFunction;
	var isObject = zrUtil.isObject;
	var parseClassType = ComponentModel.parseClassType;
	var version = '4.9.0';
	var dependencies = {
	  zrender: '4.3.2'
	};
	var TEST_FRAME_REMAIN_TIME = 1;
	var PRIORITY_PROCESSOR_FILTER = 1000;
	var PRIORITY_PROCESSOR_SERIES_FILTER = 800;
	var PRIORITY_PROCESSOR_DATASTACK = 900;
	var PRIORITY_PROCESSOR_STATISTIC = 5000;
	var PRIORITY_VISUAL_LAYOUT = 1000;
	var PRIORITY_VISUAL_PROGRESSIVE_LAYOUT = 1100;
	var PRIORITY_VISUAL_GLOBAL = 2000;
	var PRIORITY_VISUAL_CHART = 3000;
	var PRIORITY_VISUAL_POST_CHART_LAYOUT = 3500;
	var PRIORITY_VISUAL_COMPONENT = 4000; // FIXME
	// necessary?
	
	var PRIORITY_VISUAL_BRUSH = 5000;
	var PRIORITY = {
	  PROCESSOR: {
	    FILTER: PRIORITY_PROCESSOR_FILTER,
	    SERIES_FILTER: PRIORITY_PROCESSOR_SERIES_FILTER,
	    STATISTIC: PRIORITY_PROCESSOR_STATISTIC
	  },
	  VISUAL: {
	    LAYOUT: PRIORITY_VISUAL_LAYOUT,
	    PROGRESSIVE_LAYOUT: PRIORITY_VISUAL_PROGRESSIVE_LAYOUT,
	    GLOBAL: PRIORITY_VISUAL_GLOBAL,
	    CHART: PRIORITY_VISUAL_CHART,
	    POST_CHART_LAYOUT: PRIORITY_VISUAL_POST_CHART_LAYOUT,
	    COMPONENT: PRIORITY_VISUAL_COMPONENT,
	    BRUSH: PRIORITY_VISUAL_BRUSH
	  }
	}; // Main process have three entries: `setOption`, `dispatchAction` and `resize`,
	// where they must not be invoked nestedly, except the only case: invoke
	// dispatchAction with updateMethod "none" in main process.
	// This flag is used to carry out this rule.
	// All events will be triggered out side main process (i.e. when !this[IN_MAIN_PROCESS]).
	
	var IN_MAIN_PROCESS = '__flagInMainProcess';
	var OPTION_UPDATED = '__optionUpdated';
	var ACTION_REG = /^[a-zA-Z0-9_]+$/;
	
	function createRegisterEventWithLowercaseName(method, ignoreDisposed) {
	  return function (eventName, handler, context) {
	    if (!ignoreDisposed && this._disposed) {
	      disposedWarning(this.id);
	      return;
	    } // Event name is all lowercase
	
	
	    eventName = eventName && eventName.toLowerCase();
	    Eventful.prototype[method].call(this, eventName, handler, context);
	  };
	}
	/**
	 * @module echarts~MessageCenter
	 */
	
	
	function MessageCenter() {
	  Eventful.call(this);
	}
	
	MessageCenter.prototype.on = createRegisterEventWithLowercaseName('on', true);
	MessageCenter.prototype.off = createRegisterEventWithLowercaseName('off', true);
	MessageCenter.prototype.one = createRegisterEventWithLowercaseName('one', true);
	zrUtil.mixin(MessageCenter, Eventful);
	/**
	 * @module echarts~ECharts
	 */
	
	function ECharts(dom, theme, opts) {
	  opts = opts || {}; // Get theme by name
	
	  if (typeof theme === 'string') {
	    theme = themeStorage[theme];
	  }
	  /**
	   * @type {string}
	   */
	
	
	  this.id;
	  /**
	   * Group id
	   * @type {string}
	   */
	
	  this.group;
	  /**
	   * @type {HTMLElement}
	   * @private
	   */
	
	  this._dom = dom;
	  var defaultRenderer = 'canvas';
	
	  /**
	   * @type {module:zrender/ZRender}
	   * @private
	   */
	  var zr = this._zr = zrender.init(dom, {
	    renderer: opts.renderer || defaultRenderer,
	    devicePixelRatio: opts.devicePixelRatio,
	    width: opts.width,
	    height: opts.height
	  });
	  /**
	   * Expect 60 fps.
	   * @type {Function}
	   * @private
	   */
	
	  this._throttledZrFlush = throttle(zrUtil.bind(zr.flush, zr), 17);
	  var theme = zrUtil.clone(theme);
	  theme && backwardCompat(theme, true);
	  /**
	   * @type {Object}
	   * @private
	   */
	
	  this._theme = theme;
	  /**
	   * @type {Array.<module:echarts/view/Chart>}
	   * @private
	   */
	
	  this._chartsViews = [];
	  /**
	   * @type {Object.<string, module:echarts/view/Chart>}
	   * @private
	   */
	
	  this._chartsMap = {};
	  /**
	   * @type {Array.<module:echarts/view/Component>}
	   * @private
	   */
	
	  this._componentsViews = [];
	  /**
	   * @type {Object.<string, module:echarts/view/Component>}
	   * @private
	   */
	
	  this._componentsMap = {};
	  /**
	   * @type {module:echarts/CoordinateSystem}
	   * @private
	   */
	
	  this._coordSysMgr = new CoordinateSystemManager();
	  /**
	   * @type {module:echarts/ExtensionAPI}
	   * @private
	   */
	
	  var api = this._api = createExtensionAPI(this); // Sort on demand
	
	  function prioritySortFunc(a, b) {
	    return a.__prio - b.__prio;
	  }
	
	  timsort(visualFuncs, prioritySortFunc);
	  timsort(dataProcessorFuncs, prioritySortFunc);
	  /**
	   * @type {module:echarts/stream/Scheduler}
	   */
	
	  this._scheduler = new Scheduler(this, api, dataProcessorFuncs, visualFuncs);
	  Eventful.call(this, this._ecEventProcessor = new EventProcessor());
	  /**
	   * @type {module:echarts~MessageCenter}
	   * @private
	   */
	
	  this._messageCenter = new MessageCenter(); // Init mouse events
	
	  this._initEvents(); // In case some people write `window.onresize = chart.resize`
	
	
	  this.resize = zrUtil.bind(this.resize, this); // Can't dispatch action during rendering procedure
	
	  this._pendingActions = [];
	  zr.animation.on('frame', this._onframe, this);
	  bindRenderedEvent(zr, this); // ECharts instance can be used as value.
	
	  zrUtil.setAsPrimitive(this);
	}
	
	var echartsProto = ECharts.prototype;
	
	echartsProto._onframe = function () {
	  if (this._disposed) {
	    return;
	  }
	
	  var scheduler = this._scheduler; // Lazy update
	
	  if (this[OPTION_UPDATED]) {
	    var silent = this[OPTION_UPDATED].silent;
	    this[IN_MAIN_PROCESS] = true;
	    prepare(this);
	    updateMethods.update.call(this);
	    this[IN_MAIN_PROCESS] = false;
	    this[OPTION_UPDATED] = false;
	    flushPendingActions.call(this, silent);
	    triggerUpdatedEvent.call(this, silent);
	  } // Avoid do both lazy update and progress in one frame.
	  else if (scheduler.unfinished) {
	      // Stream progress.
	      var remainTime = TEST_FRAME_REMAIN_TIME;
	      var ecModel = this._model;
	      var api = this._api;
	      scheduler.unfinished = false;
	
	      do {
	        var startTime = +new Date();
	        scheduler.performSeriesTasks(ecModel); // Currently dataProcessorFuncs do not check threshold.
	
	        scheduler.performDataProcessorTasks(ecModel);
	        updateStreamModes(this, ecModel); // Do not update coordinate system here. Because that coord system update in
	        // each frame is not a good user experience. So we follow the rule that
	        // the extent of the coordinate system is determin in the first frame (the
	        // frame is executed immedietely after task reset.
	        // this._coordSysMgr.update(ecModel, api);
	        // console.log('--- ec frame visual ---', remainTime);
	
	        scheduler.performVisualTasks(ecModel);
	        renderSeries(this, this._model, api, 'remain');
	        remainTime -= +new Date() - startTime;
	      } while (remainTime > 0 && scheduler.unfinished); // Call flush explicitly for trigger finished event.
	
	
	      if (!scheduler.unfinished) {
	        this._zr.flush();
	      } // Else, zr flushing be ensue within the same frame,
	      // because zr flushing is after onframe event.
	
	    }
	};
	/**
	 * @return {HTMLElement}
	 */
	
	
	echartsProto.getDom = function () {
	  return this._dom;
	};
	/**
	 * @return {module:zrender~ZRender}
	 */
	
	
	echartsProto.getZr = function () {
	  return this._zr;
	};
	/**
	 * Usage:
	 * chart.setOption(option, notMerge, lazyUpdate);
	 * chart.setOption(option, {
	 *     notMerge: ...,
	 *     lazyUpdate: ...,
	 *     silent: ...
	 * });
	 *
	 * @param {Object} option
	 * @param {Object|boolean} [opts] opts or notMerge.
	 * @param {boolean} [opts.notMerge=false]
	 * @param {boolean} [opts.lazyUpdate=false] Useful when setOption frequently.
	 */
	
	
	echartsProto.setOption = function (option, notMerge, lazyUpdate) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  var silent;
	
	  if (isObject(notMerge)) {
	    lazyUpdate = notMerge.lazyUpdate;
	    silent = notMerge.silent;
	    notMerge = notMerge.notMerge;
	  }
	
	  this[IN_MAIN_PROCESS] = true;
	
	  if (!this._model || notMerge) {
	    var optionManager = new OptionManager(this._api);
	    var theme = this._theme;
	    var ecModel = this._model = new GlobalModel();
	    ecModel.scheduler = this._scheduler;
	    ecModel.init(null, null, theme, optionManager);
	  }
	
	  this._model.setOption(option, optionPreprocessorFuncs);
	
	  if (lazyUpdate) {
	    this[OPTION_UPDATED] = {
	      silent: silent
	    };
	    this[IN_MAIN_PROCESS] = false;
	  } else {
	    prepare(this);
	    updateMethods.update.call(this); // Ensure zr refresh sychronously, and then pixel in canvas can be
	    // fetched after `setOption`.
	
	    this._zr.flush();
	
	    this[OPTION_UPDATED] = false;
	    this[IN_MAIN_PROCESS] = false;
	    flushPendingActions.call(this, silent);
	    triggerUpdatedEvent.call(this, silent);
	  }
	};
	/**
	 * @DEPRECATED
	 */
	
	
	echartsProto.setTheme = function () {
	  console.error('ECharts#setTheme() is DEPRECATED in ECharts 3.0');
	};
	/**
	 * @return {module:echarts/model/Global}
	 */
	
	
	echartsProto.getModel = function () {
	  return this._model;
	};
	/**
	 * @return {Object}
	 */
	
	
	echartsProto.getOption = function () {
	  return this._model && this._model.getOption();
	};
	/**
	 * @return {number}
	 */
	
	
	echartsProto.getWidth = function () {
	  return this._zr.getWidth();
	};
	/**
	 * @return {number}
	 */
	
	
	echartsProto.getHeight = function () {
	  return this._zr.getHeight();
	};
	/**
	 * @return {number}
	 */
	
	
	echartsProto.getDevicePixelRatio = function () {
	  return this._zr.painter.dpr || window.devicePixelRatio || 1;
	};
	/**
	 * Get canvas which has all thing rendered
	 * @param {Object} opts
	 * @param {string} [opts.backgroundColor]
	 * @return {string}
	 */
	
	
	echartsProto.getRenderedCanvas = function (opts) {
	  if (!env.canvasSupported) {
	    return;
	  }
	
	  opts = opts || {};
	  opts.pixelRatio = opts.pixelRatio || 1;
	  opts.backgroundColor = opts.backgroundColor || this._model.get('backgroundColor');
	  var zr = this._zr; // var list = zr.storage.getDisplayList();
	  // Stop animations
	  // Never works before in init animation, so remove it.
	  // zrUtil.each(list, function (el) {
	  //     el.stopAnimation(true);
	  // });
	
	  return zr.painter.getRenderedCanvas(opts);
	};
	/**
	 * Get svg data url
	 * @return {string}
	 */
	
	
	echartsProto.getSvgDataURL = function () {
	  if (!env.svgSupported) {
	    return;
	  }
	
	  var zr = this._zr;
	  var list = zr.storage.getDisplayList(); // Stop animations
	
	  zrUtil.each(list, function (el) {
	    el.stopAnimation(true);
	  });
	  return zr.painter.toDataURL();
	};
	/**
	 * @return {string}
	 * @param {Object} opts
	 * @param {string} [opts.type='png']
	 * @param {string} [opts.pixelRatio=1]
	 * @param {string} [opts.backgroundColor]
	 * @param {string} [opts.excludeComponents]
	 */
	
	
	echartsProto.getDataURL = function (opts) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  opts = opts || {};
	  var excludeComponents = opts.excludeComponents;
	  var ecModel = this._model;
	  var excludesComponentViews = [];
	  var self = this;
	  each(excludeComponents, function (componentType) {
	    ecModel.eachComponent({
	      mainType: componentType
	    }, function (component) {
	      var view = self._componentsMap[component.__viewId];
	
	      if (!view.group.ignore) {
	        excludesComponentViews.push(view);
	        view.group.ignore = true;
	      }
	    });
	  });
	  var url = this._zr.painter.getType() === 'svg' ? this.getSvgDataURL() : this.getRenderedCanvas(opts).toDataURL('image/' + (opts && opts.type || 'png'));
	  each(excludesComponentViews, function (view) {
	    view.group.ignore = false;
	  });
	  return url;
	};
	/**
	 * @return {string}
	 * @param {Object} opts
	 * @param {string} [opts.type='png']
	 * @param {string} [opts.pixelRatio=1]
	 * @param {string} [opts.backgroundColor]
	 */
	
	
	echartsProto.getConnectedDataURL = function (opts) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  if (!env.canvasSupported) {
	    return;
	  }
	
	  var isSvg = opts.type === 'svg';
	  var groupId = this.group;
	  var mathMin = Math.min;
	  var mathMax = Math.max;
	  var MAX_NUMBER = Infinity;
	
	  if (connectedGroups[groupId]) {
	    var left = MAX_NUMBER;
	    var top = MAX_NUMBER;
	    var right = -MAX_NUMBER;
	    var bottom = -MAX_NUMBER;
	    var canvasList = [];
	    var dpr = opts && opts.pixelRatio || 1;
	    zrUtil.each(instances, function (chart, id) {
	      if (chart.group === groupId) {
	        var canvas = isSvg ? chart.getZr().painter.getSvgDom().innerHTML : chart.getRenderedCanvas(zrUtil.clone(opts));
	        var boundingRect = chart.getDom().getBoundingClientRect();
	        left = mathMin(boundingRect.left, left);
	        top = mathMin(boundingRect.top, top);
	        right = mathMax(boundingRect.right, right);
	        bottom = mathMax(boundingRect.bottom, bottom);
	        canvasList.push({
	          dom: canvas,
	          left: boundingRect.left,
	          top: boundingRect.top
	        });
	      }
	    });
	    left *= dpr;
	    top *= dpr;
	    right *= dpr;
	    bottom *= dpr;
	    var width = right - left;
	    var height = bottom - top;
	    var targetCanvas = zrUtil.createCanvas();
	    var zr = zrender.init(targetCanvas, {
	      renderer: isSvg ? 'svg' : 'canvas'
	    });
	    zr.resize({
	      width: width,
	      height: height
	    });
	
	    if (isSvg) {
	      var content = '';
	      each(canvasList, function (item) {
	        var x = item.left - left;
	        var y = item.top - top;
	        content += '<g transform="translate(' + x + ',' + y + ')">' + item.dom + '</g>';
	      });
	      zr.painter.getSvgRoot().innerHTML = content;
	
	      if (opts.connectedBackgroundColor) {
	        zr.painter.setBackgroundColor(opts.connectedBackgroundColor);
	      }
	
	      zr.refreshImmediately();
	      return zr.painter.toDataURL();
	    } else {
	      // Background between the charts
	      if (opts.connectedBackgroundColor) {
	        zr.add(new graphic.Rect({
	          shape: {
	            x: 0,
	            y: 0,
	            width: width,
	            height: height
	          },
	          style: {
	            fill: opts.connectedBackgroundColor
	          }
	        }));
	      }
	
	      each(canvasList, function (item) {
	        var img = new graphic.Image({
	          style: {
	            x: item.left * dpr - left,
	            y: item.top * dpr - top,
	            image: item.dom
	          }
	        });
	        zr.add(img);
	      });
	      zr.refreshImmediately();
	      return targetCanvas.toDataURL('image/' + (opts && opts.type || 'png'));
	    }
	  } else {
	    return this.getDataURL(opts);
	  }
	};
	/**
	 * Convert from logical coordinate system to pixel coordinate system.
	 * See CoordinateSystem#convertToPixel.
	 * @param {string|Object} finder
	 *        If string, e.g., 'geo', means {geoIndex: 0}.
	 *        If Object, could contain some of these properties below:
	 *        {
	 *            seriesIndex / seriesId / seriesName,
	 *            geoIndex / geoId, geoName,
	 *            bmapIndex / bmapId / bmapName,
	 *            xAxisIndex / xAxisId / xAxisName,
	 *            yAxisIndex / yAxisId / yAxisName,
	 *            gridIndex / gridId / gridName,
	 *            ... (can be extended)
	 *        }
	 * @param {Array|number} value
	 * @return {Array|number} result
	 */
	
	
	echartsProto.convertToPixel = zrUtil.curry(doConvertPixel, 'convertToPixel');
	/**
	 * Convert from pixel coordinate system to logical coordinate system.
	 * See CoordinateSystem#convertFromPixel.
	 * @param {string|Object} finder
	 *        If string, e.g., 'geo', means {geoIndex: 0}.
	 *        If Object, could contain some of these properties below:
	 *        {
	 *            seriesIndex / seriesId / seriesName,
	 *            geoIndex / geoId / geoName,
	 *            bmapIndex / bmapId / bmapName,
	 *            xAxisIndex / xAxisId / xAxisName,
	 *            yAxisIndex / yAxisId / yAxisName
	 *            gridIndex / gridId / gridName,
	 *            ... (can be extended)
	 *        }
	 * @param {Array|number} value
	 * @return {Array|number} result
	 */
	
	echartsProto.convertFromPixel = zrUtil.curry(doConvertPixel, 'convertFromPixel');
	
	function doConvertPixel(methodName, finder, value) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  var ecModel = this._model;
	
	  var coordSysList = this._coordSysMgr.getCoordinateSystems();
	
	  var result;
	  finder = modelUtil.parseFinder(ecModel, finder);
	
	  for (var i = 0; i < coordSysList.length; i++) {
	    var coordSys = coordSysList[i];
	
	    if (coordSys[methodName] && (result = coordSys[methodName](ecModel, finder, value)) != null) {
	      return result;
	    }
	  }
	}
	/**
	 * Is the specified coordinate systems or components contain the given pixel point.
	 * @param {string|Object} finder
	 *        If string, e.g., 'geo', means {geoIndex: 0}.
	 *        If Object, could contain some of these properties below:
	 *        {
	 *            seriesIndex / seriesId / seriesName,
	 *            geoIndex / geoId / geoName,
	 *            bmapIndex / bmapId / bmapName,
	 *            xAxisIndex / xAxisId / xAxisName,
	 *            yAxisIndex / yAxisId / yAxisName,
	 *            gridIndex / gridId / gridName,
	 *            ... (can be extended)
	 *        }
	 * @param {Array|number} value
	 * @return {boolean} result
	 */
	
	
	echartsProto.containPixel = function (finder, value) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  var ecModel = this._model;
	  var result;
	  finder = modelUtil.parseFinder(ecModel, finder);
	  zrUtil.each(finder, function (models, key) {
	    key.indexOf('Models') >= 0 && zrUtil.each(models, function (model) {
	      var coordSys = model.coordinateSystem;
	
	      if (coordSys && coordSys.containPoint) {
	        result |= !!coordSys.containPoint(value);
	      } else if (key === 'seriesModels') {
	        var view = this._chartsMap[model.__viewId];
	
	        if (view && view.containPoint) {
	          result |= view.containPoint(value, model);
	        } else {}
	      } else {}
	    }, this);
	  }, this);
	  return !!result;
	};
	/**
	 * Get visual from series or data.
	 * @param {string|Object} finder
	 *        If string, e.g., 'series', means {seriesIndex: 0}.
	 *        If Object, could contain some of these properties below:
	 *        {
	 *            seriesIndex / seriesId / seriesName,
	 *            dataIndex / dataIndexInside
	 *        }
	 *        If dataIndex is not specified, series visual will be fetched,
	 *        but not data item visual.
	 *        If all of seriesIndex, seriesId, seriesName are not specified,
	 *        visual will be fetched from first series.
	 * @param {string} visualType 'color', 'symbol', 'symbolSize'
	 */
	
	
	echartsProto.getVisual = function (finder, visualType) {
	  var ecModel = this._model;
	  finder = modelUtil.parseFinder(ecModel, finder, {
	    defaultMainType: 'series'
	  });
	  var seriesModel = finder.seriesModel;
	  var data = seriesModel.getData();
	  var dataIndexInside = finder.hasOwnProperty('dataIndexInside') ? finder.dataIndexInside : finder.hasOwnProperty('dataIndex') ? data.indexOfRawIndex(finder.dataIndex) : null;
	  return dataIndexInside != null ? data.getItemVisual(dataIndexInside, visualType) : data.getVisual(visualType);
	};
	/**
	 * Get view of corresponding component model
	 * @param  {module:echarts/model/Component} componentModel
	 * @return {module:echarts/view/Component}
	 */
	
	
	echartsProto.getViewOfComponentModel = function (componentModel) {
	  return this._componentsMap[componentModel.__viewId];
	};
	/**
	 * Get view of corresponding series model
	 * @param  {module:echarts/model/Series} seriesModel
	 * @return {module:echarts/view/Chart}
	 */
	
	
	echartsProto.getViewOfSeriesModel = function (seriesModel) {
	  return this._chartsMap[seriesModel.__viewId];
	};
	
	var updateMethods = {
	  prepareAndUpdate: function (payload) {
	    prepare(this);
	    updateMethods.update.call(this, payload);
	  },
	
	  /**
	   * @param {Object} payload
	   * @private
	   */
	  update: function (payload) {
	    // console.profile && console.profile('update');
	    var ecModel = this._model;
	    var api = this._api;
	    var zr = this._zr;
	    var coordSysMgr = this._coordSysMgr;
	    var scheduler = this._scheduler; // update before setOption
	
	    if (!ecModel) {
	      return;
	    }
	
	    scheduler.restoreData(ecModel, payload);
	    scheduler.performSeriesTasks(ecModel); // TODO
	    // Save total ecModel here for undo/redo (after restoring data and before processing data).
	    // Undo (restoration of total ecModel) can be carried out in 'action' or outside API call.
	    // Create new coordinate system each update
	    // In LineView may save the old coordinate system and use it to get the orignal point
	
	    coordSysMgr.create(ecModel, api);
	    scheduler.performDataProcessorTasks(ecModel, payload); // Current stream render is not supported in data process. So we can update
	    // stream modes after data processing, where the filtered data is used to
	    // deteming whether use progressive rendering.
	
	    updateStreamModes(this, ecModel); // We update stream modes before coordinate system updated, then the modes info
	    // can be fetched when coord sys updating (consider the barGrid extent fix). But
	    // the drawback is the full coord info can not be fetched. Fortunately this full
	    // coord is not requied in stream mode updater currently.
	
	    coordSysMgr.update(ecModel, api);
	    clearColorPalette(ecModel);
	    scheduler.performVisualTasks(ecModel, payload);
	    render(this, ecModel, api, payload); // Set background
	
	    var backgroundColor = ecModel.get('backgroundColor') || 'transparent'; // In IE8
	
	    if (!env.canvasSupported) {
	      var colorArr = colorTool.parse(backgroundColor);
	      backgroundColor = colorTool.stringify(colorArr, 'rgb');
	
	      if (colorArr[3] === 0) {
	        backgroundColor = 'transparent';
	      }
	    } else {
	      zr.setBackgroundColor(backgroundColor);
	    }
	
	    performPostUpdateFuncs(ecModel, api); // console.profile && console.profileEnd('update');
	  },
	
	  /**
	   * @param {Object} payload
	   * @private
	   */
	  updateTransform: function (payload) {
	    var ecModel = this._model;
	    var ecIns = this;
	    var api = this._api; // update before setOption
	
	    if (!ecModel) {
	      return;
	    } // ChartView.markUpdateMethod(payload, 'updateTransform');
	
	
	    var componentDirtyList = [];
	    ecModel.eachComponent(function (componentType, componentModel) {
	      var componentView = ecIns.getViewOfComponentModel(componentModel);
	
	      if (componentView && componentView.__alive) {
	        if (componentView.updateTransform) {
	          var result = componentView.updateTransform(componentModel, ecModel, api, payload);
	          result && result.update && componentDirtyList.push(componentView);
	        } else {
	          componentDirtyList.push(componentView);
	        }
	      }
	    });
	    var seriesDirtyMap = zrUtil.createHashMap();
	    ecModel.eachSeries(function (seriesModel) {
	      var chartView = ecIns._chartsMap[seriesModel.__viewId];
	
	      if (chartView.updateTransform) {
	        var result = chartView.updateTransform(seriesModel, ecModel, api, payload);
	        result && result.update && seriesDirtyMap.set(seriesModel.uid, 1);
	      } else {
	        seriesDirtyMap.set(seriesModel.uid, 1);
	      }
	    });
	    clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
	    // this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);
	
	    this._scheduler.performVisualTasks(ecModel, payload, {
	      setDirty: true,
	      dirtyMap: seriesDirtyMap
	    }); // Currently, not call render of components. Geo render cost a lot.
	    // renderComponents(ecIns, ecModel, api, payload, componentDirtyList);
	
	
	    renderSeries(ecIns, ecModel, api, payload, seriesDirtyMap);
	    performPostUpdateFuncs(ecModel, this._api);
	  },
	
	  /**
	   * @param {Object} payload
	   * @private
	   */
	  updateView: function (payload) {
	    var ecModel = this._model; // update before setOption
	
	    if (!ecModel) {
	      return;
	    }
	
	    ChartView.markUpdateMethod(payload, 'updateView');
	    clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
	
	    this._scheduler.performVisualTasks(ecModel, payload, {
	      setDirty: true
	    });
	
	    render(this, this._model, this._api, payload);
	    performPostUpdateFuncs(ecModel, this._api);
	  },
	
	  /**
	   * @param {Object} payload
	   * @private
	   */
	  updateVisual: function (payload) {
	    updateMethods.update.call(this, payload); // var ecModel = this._model;
	    // // update before setOption
	    // if (!ecModel) {
	    //     return;
	    // }
	    // ChartView.markUpdateMethod(payload, 'updateVisual');
	    // clearColorPalette(ecModel);
	    // // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
	    // this._scheduler.performVisualTasks(ecModel, payload, {visualType: 'visual', setDirty: true});
	    // render(this, this._model, this._api, payload);
	    // performPostUpdateFuncs(ecModel, this._api);
	  },
	
	  /**
	   * @param {Object} payload
	   * @private
	   */
	  updateLayout: function (payload) {
	    updateMethods.update.call(this, payload); // var ecModel = this._model;
	    // // update before setOption
	    // if (!ecModel) {
	    //     return;
	    // }
	    // ChartView.markUpdateMethod(payload, 'updateLayout');
	    // // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
	    // // this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);
	    // this._scheduler.performVisualTasks(ecModel, payload, {setDirty: true});
	    // render(this, this._model, this._api, payload);
	    // performPostUpdateFuncs(ecModel, this._api);
	  }
	};
	
	function prepare(ecIns) {
	  var ecModel = ecIns._model;
	  var scheduler = ecIns._scheduler;
	  scheduler.restorePipelines(ecModel);
	  scheduler.prepareStageTasks();
	  prepareView(ecIns, 'component', ecModel, scheduler);
	  prepareView(ecIns, 'chart', ecModel, scheduler);
	  scheduler.plan();
	}
	/**
	 * @private
	 */
	
	
	function updateDirectly(ecIns, method, payload, mainType, subType) {
	  var ecModel = ecIns._model; // broadcast
	
	  if (!mainType) {
	    // FIXME
	    // Chart will not be update directly here, except set dirty.
	    // But there is no such scenario now.
	    each(ecIns._componentsViews.concat(ecIns._chartsViews), callView);
	    return;
	  }
	
	  var query = {};
	  query[mainType + 'Id'] = payload[mainType + 'Id'];
	  query[mainType + 'Index'] = payload[mainType + 'Index'];
	  query[mainType + 'Name'] = payload[mainType + 'Name'];
	  var condition = {
	    mainType: mainType,
	    query: query
	  };
	  subType && (condition.subType = subType); // subType may be '' by parseClassType;
	
	  var excludeSeriesId = payload.excludeSeriesId;
	
	  if (excludeSeriesId != null) {
	    excludeSeriesId = zrUtil.createHashMap(modelUtil.normalizeToArray(excludeSeriesId));
	  } // If dispatchAction before setOption, do nothing.
	
	
	  ecModel && ecModel.eachComponent(condition, function (model) {
	    if (!excludeSeriesId || excludeSeriesId.get(model.id) == null) {
	      callView(ecIns[mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId]);
	    }
	  }, ecIns);
	
	  function callView(view) {
	    view && view.__alive && view[method] && view[method](view.__model, ecModel, ecIns._api, payload);
	  }
	}
	/**
	 * Resize the chart
	 * @param {Object} opts
	 * @param {number} [opts.width] Can be 'auto' (the same as null/undefined)
	 * @param {number} [opts.height] Can be 'auto' (the same as null/undefined)
	 * @param {boolean} [opts.silent=false]
	 */
	
	
	echartsProto.resize = function (opts) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  this._zr.resize(opts);
	
	  var ecModel = this._model; // Resize loading effect
	
	  this._loadingFX && this._loadingFX.resize();
	
	  if (!ecModel) {
	    return;
	  }
	
	  var optionChanged = ecModel.resetOption('media');
	  var silent = opts && opts.silent;
	  this[IN_MAIN_PROCESS] = true;
	  optionChanged && prepare(this);
	  updateMethods.update.call(this);
	  this[IN_MAIN_PROCESS] = false;
	  flushPendingActions.call(this, silent);
	  triggerUpdatedEvent.call(this, silent);
	};
	
	function updateStreamModes(ecIns, ecModel) {
	  var chartsMap = ecIns._chartsMap;
	  var scheduler = ecIns._scheduler;
	  ecModel.eachSeries(function (seriesModel) {
	    scheduler.updateStreamModes(seriesModel, chartsMap[seriesModel.__viewId]);
	  });
	}
	/**
	 * Show loading effect
	 * @param  {string} [name='default']
	 * @param  {Object} [cfg]
	 */
	
	
	echartsProto.showLoading = function (name, cfg) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  if (isObject(name)) {
	    cfg = name;
	    name = '';
	  }
	
	  name = name || 'default';
	  this.hideLoading();
	
	  if (!loadingEffects[name]) {
	    return;
	  }
	
	  var el = loadingEffects[name](this._api, cfg);
	  var zr = this._zr;
	  this._loadingFX = el;
	  zr.add(el);
	};
	/**
	 * Hide loading effect
	 */
	
	
	echartsProto.hideLoading = function () {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  this._loadingFX && this._zr.remove(this._loadingFX);
	  this._loadingFX = null;
	};
	/**
	 * @param {Object} eventObj
	 * @return {Object}
	 */
	
	
	echartsProto.makeActionFromEvent = function (eventObj) {
	  var payload = zrUtil.extend({}, eventObj);
	  payload.type = eventActionMap[eventObj.type];
	  return payload;
	};
	/**
	 * @pubilc
	 * @param {Object} payload
	 * @param {string} [payload.type] Action type
	 * @param {Object|boolean} [opt] If pass boolean, means opt.silent
	 * @param {boolean} [opt.silent=false] Whether trigger events.
	 * @param {boolean} [opt.flush=undefined]
	 *                  true: Flush immediately, and then pixel in canvas can be fetched
	 *                      immediately. Caution: it might affect performance.
	 *                  false: Not flush.
	 *                  undefined: Auto decide whether perform flush.
	 */
	
	
	echartsProto.dispatchAction = function (payload, opt) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  if (!isObject(opt)) {
	    opt = {
	      silent: !!opt
	    };
	  }
	
	  if (!actions[payload.type]) {
	    return;
	  } // Avoid dispatch action before setOption. Especially in `connect`.
	
	
	  if (!this._model) {
	    return;
	  } // May dispatchAction in rendering procedure
	
	
	  if (this[IN_MAIN_PROCESS]) {
	    this._pendingActions.push(payload);
	
	    return;
	  }
	
	  doDispatchAction.call(this, payload, opt.silent);
	
	  if (opt.flush) {
	    this._zr.flush(true);
	  } else if (opt.flush !== false && env.browser.weChat) {
	    // In WeChat embeded browser, `requestAnimationFrame` and `setInterval`
	    // hang when sliding page (on touch event), which cause that zr does not
	    // refresh util user interaction finished, which is not expected.
	    // But `dispatchAction` may be called too frequently when pan on touch
	    // screen, which impacts performance if do not throttle them.
	    this._throttledZrFlush();
	  }
	
	  flushPendingActions.call(this, opt.silent);
	  triggerUpdatedEvent.call(this, opt.silent);
	};
	
	function doDispatchAction(payload, silent) {
	  var payloadType = payload.type;
	  var escapeConnect = payload.escapeConnect;
	  var actionWrap = actions[payloadType];
	  var actionInfo = actionWrap.actionInfo;
	  var cptType = (actionInfo.update || 'update').split(':');
	  var updateMethod = cptType.pop();
	  cptType = cptType[0] != null && parseClassType(cptType[0]);
	  this[IN_MAIN_PROCESS] = true;
	  var payloads = [payload];
	  var batched = false; // Batch action
	
	  if (payload.batch) {
	    batched = true;
	    payloads = zrUtil.map(payload.batch, function (item) {
	      item = zrUtil.defaults(zrUtil.extend({}, item), payload);
	      item.batch = null;
	      return item;
	    });
	  }
	
	  var eventObjBatch = [];
	  var eventObj;
	  var isHighDown = payloadType === 'highlight' || payloadType === 'downplay';
	  each(payloads, function (batchItem) {
	    // Action can specify the event by return it.
	    eventObj = actionWrap.action(batchItem, this._model, this._api); // Emit event outside
	
	    eventObj = eventObj || zrUtil.extend({}, batchItem); // Convert type to eventType
	
	    eventObj.type = actionInfo.event || eventObj.type;
	    eventObjBatch.push(eventObj); // light update does not perform data process, layout and visual.
	
	    if (isHighDown) {
	      // method, payload, mainType, subType
	      updateDirectly(this, updateMethod, batchItem, 'series');
	    } else if (cptType) {
	      updateDirectly(this, updateMethod, batchItem, cptType.main, cptType.sub);
	    }
	  }, this);
	
	  if (updateMethod !== 'none' && !isHighDown && !cptType) {
	    // Still dirty
	    if (this[OPTION_UPDATED]) {
	      // FIXME Pass payload ?
	      prepare(this);
	      updateMethods.update.call(this, payload);
	      this[OPTION_UPDATED] = false;
	    } else {
	      updateMethods[updateMethod].call(this, payload);
	    }
	  } // Follow the rule of action batch
	
	
	  if (batched) {
	    eventObj = {
	      type: actionInfo.event || payloadType,
	      escapeConnect: escapeConnect,
	      batch: eventObjBatch
	    };
	  } else {
	    eventObj = eventObjBatch[0];
	  }
	
	  this[IN_MAIN_PROCESS] = false;
	  !silent && this._messageCenter.trigger(eventObj.type, eventObj);
	}
	
	function flushPendingActions(silent) {
	  var pendingActions = this._pendingActions;
	
	  while (pendingActions.length) {
	    var payload = pendingActions.shift();
	    doDispatchAction.call(this, payload, silent);
	  }
	}
	
	function triggerUpdatedEvent(silent) {
	  !silent && this.trigger('updated');
	}
	/**
	 * Event `rendered` is triggered when zr
	 * rendered. It is useful for realtime
	 * snapshot (reflect animation).
	 *
	 * Event `finished` is triggered when:
	 * (1) zrender rendering finished.
	 * (2) initial animation finished.
	 * (3) progressive rendering finished.
	 * (4) no pending action.
	 * (5) no delayed setOption needs to be processed.
	 */
	
	
	function bindRenderedEvent(zr, ecIns) {
	  zr.on('rendered', function () {
	    ecIns.trigger('rendered'); // The `finished` event should not be triggered repeatly,
	    // so it should only be triggered when rendering indeed happend
	    // in zrender. (Consider the case that dipatchAction is keep
	    // triggering when mouse move).
	
	    if ( // Although zr is dirty if initial animation is not finished
	    // and this checking is called on frame, we also check
	    // animation finished for robustness.
	    zr.animation.isFinished() && !ecIns[OPTION_UPDATED] && !ecIns._scheduler.unfinished && !ecIns._pendingActions.length) {
	      ecIns.trigger('finished');
	    }
	  });
	}
	/**
	 * @param {Object} params
	 * @param {number} params.seriesIndex
	 * @param {Array|TypedArray} params.data
	 */
	
	
	echartsProto.appendData = function (params) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  var seriesIndex = params.seriesIndex;
	  var ecModel = this.getModel();
	  var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
	  seriesModel.appendData(params); // Note: `appendData` does not support that update extent of coordinate
	  // system, util some scenario require that. In the expected usage of
	  // `appendData`, the initial extent of coordinate system should better
	  // be fixed by axis `min`/`max` setting or initial data, otherwise if
	  // the extent changed while `appendData`, the location of the painted
	  // graphic elements have to be changed, which make the usage of
	  // `appendData` meaningless.
	
	  this._scheduler.unfinished = true;
	};
	/**
	 * Register event
	 * @method
	 */
	
	
	echartsProto.on = createRegisterEventWithLowercaseName('on', false);
	echartsProto.off = createRegisterEventWithLowercaseName('off', false);
	echartsProto.one = createRegisterEventWithLowercaseName('one', false);
	/**
	 * Prepare view instances of charts and components
	 * @param  {module:echarts/model/Global} ecModel
	 * @private
	 */
	
	function prepareView(ecIns, type, ecModel, scheduler) {
	  var isComponent = type === 'component';
	  var viewList = isComponent ? ecIns._componentsViews : ecIns._chartsViews;
	  var viewMap = isComponent ? ecIns._componentsMap : ecIns._chartsMap;
	  var zr = ecIns._zr;
	  var api = ecIns._api;
	
	  for (var i = 0; i < viewList.length; i++) {
	    viewList[i].__alive = false;
	  }
	
	  isComponent ? ecModel.eachComponent(function (componentType, model) {
	    componentType !== 'series' && doPrepare(model);
	  }) : ecModel.eachSeries(doPrepare);
	
	  function doPrepare(model) {
	    // Consider: id same and type changed.
	    var viewId = '_ec_' + model.id + '_' + model.type;
	    var view = viewMap[viewId];
	
	    if (!view) {
	      var classType = parseClassType(model.type);
	      var Clazz = isComponent ? ComponentView.getClass(classType.main, classType.sub) : ChartView.getClass(classType.sub);
	      view = new Clazz();
	      view.init(ecModel, api);
	      viewMap[viewId] = view;
	      viewList.push(view);
	      zr.add(view.group);
	    }
	
	    model.__viewId = view.__id = viewId;
	    view.__alive = true;
	    view.__model = model;
	    view.group.__ecComponentInfo = {
	      mainType: model.mainType,
	      index: model.componentIndex
	    };
	    !isComponent && scheduler.prepareView(view, model, ecModel, api);
	  }
	
	  for (var i = 0; i < viewList.length;) {
	    var view = viewList[i];
	
	    if (!view.__alive) {
	      !isComponent && view.renderTask.dispose();
	      zr.remove(view.group);
	      view.dispose(ecModel, api);
	      viewList.splice(i, 1);
	      delete viewMap[view.__id];
	      view.__id = view.group.__ecComponentInfo = null;
	    } else {
	      i++;
	    }
	  }
	} // /**
	//  * Encode visual infomation from data after data processing
	//  *
	//  * @param {module:echarts/model/Global} ecModel
	//  * @param {object} layout
	//  * @param {boolean} [layoutFilter] `true`: only layout,
	//  *                                 `false`: only not layout,
	//  *                                 `null`/`undefined`: all.
	//  * @param {string} taskBaseTag
	//  * @private
	//  */
	// function startVisualEncoding(ecIns, ecModel, api, payload, layoutFilter) {
	//     each(visualFuncs, function (visual, index) {
	//         var isLayout = visual.isLayout;
	//         if (layoutFilter == null
	//             || (layoutFilter === false && !isLayout)
	//             || (layoutFilter === true && isLayout)
	//         ) {
	//             visual.func(ecModel, api, payload);
	//         }
	//     });
	// }
	
	
	function clearColorPalette(ecModel) {
	  ecModel.clearColorPalette();
	  ecModel.eachSeries(function (seriesModel) {
	    seriesModel.clearColorPalette();
	  });
	}
	
	function render(ecIns, ecModel, api, payload) {
	  renderComponents(ecIns, ecModel, api, payload);
	  each(ecIns._chartsViews, function (chart) {
	    chart.__alive = false;
	  });
	  renderSeries(ecIns, ecModel, api, payload); // Remove groups of unrendered charts
	
	  each(ecIns._chartsViews, function (chart) {
	    if (!chart.__alive) {
	      chart.remove(ecModel, api);
	    }
	  });
	}
	
	function renderComponents(ecIns, ecModel, api, payload, dirtyList) {
	  each(dirtyList || ecIns._componentsViews, function (componentView) {
	    var componentModel = componentView.__model;
	    componentView.render(componentModel, ecModel, api, payload);
	    updateZ(componentModel, componentView);
	  });
	}
	/**
	 * Render each chart and component
	 * @private
	 */
	
	
	function renderSeries(ecIns, ecModel, api, payload, dirtyMap) {
	  // Render all charts
	  var scheduler = ecIns._scheduler;
	  var unfinished;
	  ecModel.eachSeries(function (seriesModel) {
	    var chartView = ecIns._chartsMap[seriesModel.__viewId];
	    chartView.__alive = true;
	    var renderTask = chartView.renderTask;
	    scheduler.updatePayload(renderTask, payload);
	
	    if (dirtyMap && dirtyMap.get(seriesModel.uid)) {
	      renderTask.dirty();
	    }
	
	    unfinished |= renderTask.perform(scheduler.getPerformArgs(renderTask));
	    chartView.group.silent = !!seriesModel.get('silent');
	    updateZ(seriesModel, chartView);
	    updateBlend(seriesModel, chartView);
	  });
	  scheduler.unfinished |= unfinished; // If use hover layer
	
	  updateHoverLayerStatus(ecIns, ecModel); // Add aria
	
	  aria(ecIns._zr.dom, ecModel);
	}
	
	function performPostUpdateFuncs(ecModel, api) {
	  each(postUpdateFuncs, function (func) {
	    func(ecModel, api);
	  });
	}
	
	var MOUSE_EVENT_NAMES = ['click', 'dblclick', 'mouseover', 'mouseout', 'mousemove', 'mousedown', 'mouseup', 'globalout', 'contextmenu'];
	/**
	 * @private
	 */
	
	echartsProto._initEvents = function () {
	  each(MOUSE_EVENT_NAMES, function (eveName) {
	    var handler = function (e) {
	      var ecModel = this.getModel();
	      var el = e.target;
	      var params;
	      var isGlobalOut = eveName === 'globalout'; // no e.target when 'globalout'.
	
	      if (isGlobalOut) {
	        params = {};
	      } else if (el && el.dataIndex != null) {
	        var dataModel = el.dataModel || ecModel.getSeriesByIndex(el.seriesIndex);
	        params = dataModel && dataModel.getDataParams(el.dataIndex, el.dataType, el) || {};
	      } // If element has custom eventData of components
	      else if (el && el.eventData) {
	          params = zrUtil.extend({}, el.eventData);
	        } // Contract: if params prepared in mouse event,
	      // these properties must be specified:
	      // {
	      //    componentType: string (component main type)
	      //    componentIndex: number
	      // }
	      // Otherwise event query can not work.
	
	
	      if (params) {
	        var componentType = params.componentType;
	        var componentIndex = params.componentIndex; // Special handling for historic reason: when trigger by
	        // markLine/markPoint/markArea, the componentType is
	        // 'markLine'/'markPoint'/'markArea', but we should better
	        // enable them to be queried by seriesIndex, since their
	        // option is set in each series.
	
	        if (componentType === 'markLine' || componentType === 'markPoint' || componentType === 'markArea') {
	          componentType = 'series';
	          componentIndex = params.seriesIndex;
	        }
	
	        var model = componentType && componentIndex != null && ecModel.getComponent(componentType, componentIndex);
	        var view = model && this[model.mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId];
	        params.event = e;
	        params.type = eveName;
	        this._ecEventProcessor.eventInfo = {
	          targetEl: el,
	          packedEvent: params,
	          model: model,
	          view: view
	        };
	        this.trigger(eveName, params);
	      }
	    }; // Consider that some component (like tooltip, brush, ...)
	    // register zr event handler, but user event handler might
	    // do anything, such as call `setOption` or `dispatchAction`,
	    // which probably update any of the content and probably
	    // cause problem if it is called previous other inner handlers.
	
	
	    handler.zrEventfulCallAtLast = true;
	
	    this._zr.on(eveName, handler, this);
	  }, this);
	  each(eventActionMap, function (actionType, eventType) {
	    this._messageCenter.on(eventType, function (event) {
	      this.trigger(eventType, event);
	    }, this);
	  }, this);
	};
	/**
	 * @return {boolean}
	 */
	
	
	echartsProto.isDisposed = function () {
	  return this._disposed;
	};
	/**
	 * Clear
	 */
	
	
	echartsProto.clear = function () {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  this.setOption({
	    series: []
	  }, true);
	};
	/**
	 * Dispose instance
	 */
	
	
	echartsProto.dispose = function () {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  this._disposed = true;
	  modelUtil.setAttribute(this.getDom(), DOM_ATTRIBUTE_KEY, '');
	  var api = this._api;
	  var ecModel = this._model;
	  each(this._componentsViews, function (component) {
	    component.dispose(ecModel, api);
	  });
	  each(this._chartsViews, function (chart) {
	    chart.dispose(ecModel, api);
	  }); // Dispose after all views disposed
	
	  this._zr.dispose();
	
	  delete instances[this.id];
	};
	
	zrUtil.mixin(ECharts, Eventful);
	
	function disposedWarning(id) {}
	
	function updateHoverLayerStatus(ecIns, ecModel) {
	  var zr = ecIns._zr;
	  var storage = zr.storage;
	  var elCount = 0;
	  storage.traverse(function (el) {
	    elCount++;
	  });
	
	  if (elCount > ecModel.get('hoverLayerThreshold') && !env.node) {
	    ecModel.eachSeries(function (seriesModel) {
	      if (seriesModel.preventUsingHoverLayer) {
	        return;
	      }
	
	      var chartView = ecIns._chartsMap[seriesModel.__viewId];
	
	      if (chartView.__alive) {
	        chartView.group.traverse(function (el) {
	          // Don't switch back.
	          el.useHoverLayer = true;
	        });
	      }
	    });
	  }
	}
	/**
	 * Update chart progressive and blend.
	 * @param {module:echarts/model/Series|module:echarts/model/Component} model
	 * @param {module:echarts/view/Component|module:echarts/view/Chart} view
	 */
	
	
	function updateBlend(seriesModel, chartView) {
	  var blendMode = seriesModel.get('blendMode') || null;
	  chartView.group.traverse(function (el) {
	    // FIXME marker and other components
	    if (!el.isGroup) {
	      // Only set if blendMode is changed. In case element is incremental and don't wan't to rerender.
	      if (el.style.blend !== blendMode) {
	        el.setStyle('blend', blendMode);
	      }
	    }
	
	    if (el.eachPendingDisplayable) {
	      el.eachPendingDisplayable(function (displayable) {
	        displayable.setStyle('blend', blendMode);
	      });
	    }
	  });
	}
	/**
	 * @param {module:echarts/model/Series|module:echarts/model/Component} model
	 * @param {module:echarts/view/Component|module:echarts/view/Chart} view
	 */
	
	
	function updateZ(model, view) {
	  var z = model.get('z');
	  var zlevel = model.get('zlevel'); // Set z and zlevel
	
	  view.group.traverse(function (el) {
	    if (el.type !== 'group') {
	      z != null && (el.z = z);
	      zlevel != null && (el.zlevel = zlevel);
	    }
	  });
	}
	
	function createExtensionAPI(ecInstance) {
	  var coordSysMgr = ecInstance._coordSysMgr;
	  return zrUtil.extend(new ExtensionAPI(ecInstance), {
	    // Inject methods
	    getCoordinateSystems: zrUtil.bind(coordSysMgr.getCoordinateSystems, coordSysMgr),
	    getComponentByElement: function (el) {
	      while (el) {
	        var modelInfo = el.__ecComponentInfo;
	
	        if (modelInfo != null) {
	          return ecInstance._model.getComponent(modelInfo.mainType, modelInfo.index);
	        }
	
	        el = el.parent;
	      }
	    }
	  });
	}
	/**
	 * @class
	 * Usage of query:
	 * `chart.on('click', query, handler);`
	 * The `query` can be:
	 * + The component type query string, only `mainType` or `mainType.subType`,
	 *   like: 'xAxis', 'series', 'xAxis.category' or 'series.line'.
	 * + The component query object, like:
	 *   `{seriesIndex: 2}`, `{seriesName: 'xx'}`, `{seriesId: 'some'}`,
	 *   `{xAxisIndex: 2}`, `{xAxisName: 'xx'}`, `{xAxisId: 'some'}`.
	 * + The data query object, like:
	 *   `{dataIndex: 123}`, `{dataType: 'link'}`, `{name: 'some'}`.
	 * + The other query object (cmponent customized query), like:
	 *   `{element: 'some'}` (only available in custom series).
	 *
	 * Caveat: If a prop in the `query` object is `null/undefined`, it is the
	 * same as there is no such prop in the `query` object.
	 */
	
	
	function EventProcessor() {
	  // These info required: targetEl, packedEvent, model, view
	  this.eventInfo;
	}
	
	EventProcessor.prototype = {
	  constructor: EventProcessor,
	  normalizeQuery: function (query) {
	    var cptQuery = {};
	    var dataQuery = {};
	    var otherQuery = {}; // `query` is `mainType` or `mainType.subType` of component.
	
	    if (zrUtil.isString(query)) {
	      var condCptType = parseClassType(query); // `.main` and `.sub` may be ''.
	
	      cptQuery.mainType = condCptType.main || null;
	      cptQuery.subType = condCptType.sub || null;
	    } // `query` is an object, convert to {mainType, index, name, id}.
	    else {
	        // `xxxIndex`, `xxxName`, `xxxId`, `name`, `dataIndex`, `dataType` is reserved,
	        // can not be used in `compomentModel.filterForExposedEvent`.
	        var suffixes = ['Index', 'Name', 'Id'];
	        var dataKeys = {
	          name: 1,
	          dataIndex: 1,
	          dataType: 1
	        };
	        zrUtil.each(query, function (val, key) {
	          var reserved = false;
	
	          for (var i = 0; i < suffixes.length; i++) {
	            var propSuffix = suffixes[i];
	            var suffixPos = key.lastIndexOf(propSuffix);
	
	            if (suffixPos > 0 && suffixPos === key.length - propSuffix.length) {
	              var mainType = key.slice(0, suffixPos); // Consider `dataIndex`.
	
	              if (mainType !== 'data') {
	                cptQuery.mainType = mainType;
	                cptQuery[propSuffix.toLowerCase()] = val;
	                reserved = true;
	              }
	            }
	          }
	
	          if (dataKeys.hasOwnProperty(key)) {
	            dataQuery[key] = val;
	            reserved = true;
	          }
	
	          if (!reserved) {
	            otherQuery[key] = val;
	          }
	        });
	      }
	
	    return {
	      cptQuery: cptQuery,
	      dataQuery: dataQuery,
	      otherQuery: otherQuery
	    };
	  },
	  filter: function (eventType, query, args) {
	    // They should be assigned before each trigger call.
	    var eventInfo = this.eventInfo;
	
	    if (!eventInfo) {
	      return true;
	    }
	
	    var targetEl = eventInfo.targetEl;
	    var packedEvent = eventInfo.packedEvent;
	    var model = eventInfo.model;
	    var view = eventInfo.view; // For event like 'globalout'.
	
	    if (!model || !view) {
	      return true;
	    }
	
	    var cptQuery = query.cptQuery;
	    var dataQuery = query.dataQuery;
	    return check(cptQuery, model, 'mainType') && check(cptQuery, model, 'subType') && check(cptQuery, model, 'index', 'componentIndex') && check(cptQuery, model, 'name') && check(cptQuery, model, 'id') && check(dataQuery, packedEvent, 'name') && check(dataQuery, packedEvent, 'dataIndex') && check(dataQuery, packedEvent, 'dataType') && (!view.filterForExposedEvent || view.filterForExposedEvent(eventType, query.otherQuery, targetEl, packedEvent));
	
	    function check(query, host, prop, propOnHost) {
	      return query[prop] == null || host[propOnHost || prop] === query[prop];
	    }
	  },
	  afterTrigger: function () {
	    // Make sure the eventInfo wont be used in next trigger.
	    this.eventInfo = null;
	  }
	};
	/**
	 * @type {Object} key: actionType.
	 * @inner
	 */
	
	var actions = {};
	/**
	 * Map eventType to actionType
	 * @type {Object}
	 */
	
	var eventActionMap = {};
	/**
	 * Data processor functions of each stage
	 * @type {Array.<Object.<string, Function>>}
	 * @inner
	 */
	
	var dataProcessorFuncs = [];
	/**
	 * @type {Array.<Function>}
	 * @inner
	 */
	
	var optionPreprocessorFuncs = [];
	/**
	 * @type {Array.<Function>}
	 * @inner
	 */
	
	var postUpdateFuncs = [];
	/**
	 * Visual encoding functions of each stage
	 * @type {Array.<Object.<string, Function>>}
	 */
	
	var visualFuncs = [];
	/**
	 * Theme storage
	 * @type {Object.<key, Object>}
	 */
	
	var themeStorage = {};
	/**
	 * Loading effects
	 */
	
	var loadingEffects = {};
	var instances = {};
	var connectedGroups = {};
	var idBase = new Date() - 0;
	var groupIdBase = new Date() - 0;
	var DOM_ATTRIBUTE_KEY = '_echarts_instance_';
	
	function enableConnect(chart) {
	  var STATUS_PENDING = 0;
	  var STATUS_UPDATING = 1;
	  var STATUS_UPDATED = 2;
	  var STATUS_KEY = '__connectUpdateStatus';
	
	  function updateConnectedChartsStatus(charts, status) {
	    for (var i = 0; i < charts.length; i++) {
	      var otherChart = charts[i];
	      otherChart[STATUS_KEY] = status;
	    }
	  }
	
	  each(eventActionMap, function (actionType, eventType) {
	    chart._messageCenter.on(eventType, function (event) {
	      if (connectedGroups[chart.group] && chart[STATUS_KEY] !== STATUS_PENDING) {
	        if (event && event.escapeConnect) {
	          return;
	        }
	
	        var action = chart.makeActionFromEvent(event);
	        var otherCharts = [];
	        each(instances, function (otherChart) {
	          if (otherChart !== chart && otherChart.group === chart.group) {
	            otherCharts.push(otherChart);
	          }
	        });
	        updateConnectedChartsStatus(otherCharts, STATUS_PENDING);
	        each(otherCharts, function (otherChart) {
	          if (otherChart[STATUS_KEY] !== STATUS_UPDATING) {
	            otherChart.dispatchAction(action);
	          }
	        });
	        updateConnectedChartsStatus(otherCharts, STATUS_UPDATED);
	      }
	    });
	  });
	}
	/**
	 * @param {HTMLElement} dom
	 * @param {Object} [theme]
	 * @param {Object} opts
	 * @param {number} [opts.devicePixelRatio] Use window.devicePixelRatio by default
	 * @param {string} [opts.renderer] Can choose 'canvas' or 'svg' to render the chart.
	 * @param {number} [opts.width] Use clientWidth of the input `dom` by default.
	 *                              Can be 'auto' (the same as null/undefined)
	 * @param {number} [opts.height] Use clientHeight of the input `dom` by default.
	 *                               Can be 'auto' (the same as null/undefined)
	 */
	
	
	function init(dom, theme, opts) {
	  var existInstance = getInstanceByDom(dom);
	
	  if (existInstance) {
	    return existInstance;
	  }
	
	  var chart = new ECharts(dom, theme, opts);
	  chart.id = 'ec_' + idBase++;
	  instances[chart.id] = chart;
	  modelUtil.setAttribute(dom, DOM_ATTRIBUTE_KEY, chart.id);
	  enableConnect(chart);
	  return chart;
	}
	/**
	 * @return {string|Array.<module:echarts~ECharts>} groupId
	 */
	
	
	function connect(groupId) {
	  // Is array of charts
	  if (zrUtil.isArray(groupId)) {
	    var charts = groupId;
	    groupId = null; // If any chart has group
	
	    each(charts, function (chart) {
	      if (chart.group != null) {
	        groupId = chart.group;
	      }
	    });
	    groupId = groupId || 'g_' + groupIdBase++;
	    each(charts, function (chart) {
	      chart.group = groupId;
	    });
	  }
	
	  connectedGroups[groupId] = true;
	  return groupId;
	}
	/**
	 * @DEPRECATED
	 * @return {string} groupId
	 */
	
	
	function disConnect(groupId) {
	  connectedGroups[groupId] = false;
	}
	/**
	 * @return {string} groupId
	 */
	
	
	var disconnect = disConnect;
	/**
	 * Dispose a chart instance
	 * @param  {module:echarts~ECharts|HTMLDomElement|string} chart
	 */
	
	function dispose(chart) {
	  if (typeof chart === 'string') {
	    chart = instances[chart];
	  } else if (!(chart instanceof ECharts)) {
	    // Try to treat as dom
	    chart = getInstanceByDom(chart);
	  }
	
	  if (chart instanceof ECharts && !chart.isDisposed()) {
	    chart.dispose();
	  }
	}
	/**
	 * @param  {HTMLElement} dom
	 * @return {echarts~ECharts}
	 */
	
	
	function getInstanceByDom(dom) {
	  return instances[modelUtil.getAttribute(dom, DOM_ATTRIBUTE_KEY)];
	}
	/**
	 * @param {string} key
	 * @return {echarts~ECharts}
	 */
	
	
	function getInstanceById(key) {
	  return instances[key];
	}
	/**
	 * Register theme
	 */
	
	
	function registerTheme(name, theme) {
	  themeStorage[name] = theme;
	}
	/**
	 * Register option preprocessor
	 * @param {Function} preprocessorFunc
	 */
	
	
	function registerPreprocessor(preprocessorFunc) {
	  optionPreprocessorFuncs.push(preprocessorFunc);
	}
	/**
	 * @param {number} [priority=1000]
	 * @param {Object|Function} processor
	 */
	
	
	function registerProcessor(priority, processor) {
	  normalizeRegister(dataProcessorFuncs, priority, processor, PRIORITY_PROCESSOR_FILTER);
	}
	/**
	 * Register postUpdater
	 * @param {Function} postUpdateFunc
	 */
	
	
	function registerPostUpdate(postUpdateFunc) {
	  postUpdateFuncs.push(postUpdateFunc);
	}
	/**
	 * Usage:
	 * registerAction('someAction', 'someEvent', function () { ... });
	 * registerAction('someAction', function () { ... });
	 * registerAction(
	 *     {type: 'someAction', event: 'someEvent', update: 'updateView'},
	 *     function () { ... }
	 * );
	 *
	 * @param {(string|Object)} actionInfo
	 * @param {string} actionInfo.type
	 * @param {string} [actionInfo.event]
	 * @param {string} [actionInfo.update]
	 * @param {string} [eventName]
	 * @param {Function} action
	 */
	
	
	function registerAction(actionInfo, eventName, action) {
	  if (typeof eventName === 'function') {
	    action = eventName;
	    eventName = '';
	  }
	
	  var actionType = isObject(actionInfo) ? actionInfo.type : [actionInfo, actionInfo = {
	    event: eventName
	  }][0]; // Event name is all lowercase
	
	  actionInfo.event = (actionInfo.event || actionType).toLowerCase();
	  eventName = actionInfo.event; // Validate action type and event name.
	
	  assert(ACTION_REG.test(actionType) && ACTION_REG.test(eventName));
	
	  if (!actions[actionType]) {
	    actions[actionType] = {
	      action: action,
	      actionInfo: actionInfo
	    };
	  }
	
	  eventActionMap[eventName] = actionType;
	}
	/**
	 * @param {string} type
	 * @param {*} CoordinateSystem
	 */
	
	
	function registerCoordinateSystem(type, CoordinateSystem) {
	  CoordinateSystemManager.register(type, CoordinateSystem);
	}
	/**
	 * Get dimensions of specified coordinate system.
	 * @param {string} type
	 * @return {Array.<string|Object>}
	 */
	
	
	function getCoordinateSystemDimensions(type) {
	  var coordSysCreator = CoordinateSystemManager.get(type);
	
	  if (coordSysCreator) {
	    return coordSysCreator.getDimensionsInfo ? coordSysCreator.getDimensionsInfo() : coordSysCreator.dimensions.slice();
	  }
	}
	/**
	 * Layout is a special stage of visual encoding
	 * Most visual encoding like color are common for different chart
	 * But each chart has it's own layout algorithm
	 *
	 * @param {number} [priority=1000]
	 * @param {Function} layoutTask
	 */
	
	
	function registerLayout(priority, layoutTask) {
	  normalizeRegister(visualFuncs, priority, layoutTask, PRIORITY_VISUAL_LAYOUT, 'layout');
	}
	/**
	 * @param {number} [priority=3000]
	 * @param {module:echarts/stream/Task} visualTask
	 */
	
	
	function registerVisual(priority, visualTask) {
	  normalizeRegister(visualFuncs, priority, visualTask, PRIORITY_VISUAL_CHART, 'visual');
	}
	/**
	 * @param {Object|Function} fn: {seriesType, createOnAllSeries, performRawSeries, reset}
	 */
	
	
	function normalizeRegister(targetList, priority, fn, defaultPriority, visualType) {
	  if (isFunction(priority) || isObject(priority)) {
	    fn = priority;
	    priority = defaultPriority;
	  }
	
	  var stageHandler = Scheduler.wrapStageHandler(fn, visualType);
	  stageHandler.__prio = priority;
	  stageHandler.__raw = fn;
	  targetList.push(stageHandler);
	  return stageHandler;
	}
	/**
	 * @param {string} name
	 */
	
	
	function registerLoading(name, loadingFx) {
	  loadingEffects[name] = loadingFx;
	}
	/**
	 * @param {Object} opts
	 * @param {string} [superClass]
	 */
	
	
	function extendComponentModel(opts
	/*, superClass*/
	) {
	  // var Clazz = ComponentModel;
	  // if (superClass) {
	  //     var classType = parseClassType(superClass);
	  //     Clazz = ComponentModel.getClass(classType.main, classType.sub, true);
	  // }
	  return ComponentModel.extend(opts);
	}
	/**
	 * @param {Object} opts
	 * @param {string} [superClass]
	 */
	
	
	function extendComponentView(opts
	/*, superClass*/
	) {
	  // var Clazz = ComponentView;
	  // if (superClass) {
	  //     var classType = parseClassType(superClass);
	  //     Clazz = ComponentView.getClass(classType.main, classType.sub, true);
	  // }
	  return ComponentView.extend(opts);
	}
	/**
	 * @param {Object} opts
	 * @param {string} [superClass]
	 */
	
	
	function extendSeriesModel(opts
	/*, superClass*/
	) {
	  // var Clazz = SeriesModel;
	  // if (superClass) {
	  //     superClass = 'series.' + superClass.replace('series.', '');
	  //     var classType = parseClassType(superClass);
	  //     Clazz = ComponentModel.getClass(classType.main, classType.sub, true);
	  // }
	  return SeriesModel.extend(opts);
	}
	/**
	 * @param {Object} opts
	 * @param {string} [superClass]
	 */
	
	
	function extendChartView(opts
	/*, superClass*/
	) {
	  // var Clazz = ChartView;
	  // if (superClass) {
	  //     superClass = superClass.replace('series.', '');
	  //     var classType = parseClassType(superClass);
	  //     Clazz = ChartView.getClass(classType.main, true);
	  // }
	  return ChartView.extend(opts);
	}
	/**
	 * ZRender need a canvas context to do measureText.
	 * But in node environment canvas may be created by node-canvas.
	 * So we need to specify how to create a canvas instead of using document.createElement('canvas')
	 *
	 * Be careful of using it in the browser.
	 *
	 * @param {Function} creator
	 * @example
	 *     var Canvas = require('canvas');
	 *     var echarts = require('echarts');
	 *     echarts.setCanvasCreator(function () {
	 *         // Small size is enough.
	 *         return new Canvas(32, 32);
	 *     });
	 */
	
	
	function setCanvasCreator(creator) {
	  zrUtil.$override('createCanvas', creator);
	}
	/**
	 * @param {string} mapName
	 * @param {Array.<Object>|Object|string} geoJson
	 * @param {Object} [specialAreas]
	 *
	 * @example GeoJSON
	 *     $.get('USA.json', function (geoJson) {
	 *         echarts.registerMap('USA', geoJson);
	 *         // Or
	 *         echarts.registerMap('USA', {
	 *             geoJson: geoJson,
	 *             specialAreas: {}
	 *         })
	 *     });
	 *
	 *     $.get('airport.svg', function (svg) {
	 *         echarts.registerMap('airport', {
	 *             svg: svg
	 *         }
	 *     });
	 *
	 *     echarts.registerMap('eu', [
	 *         {svg: eu-topographic.svg},
	 *         {geoJSON: eu.json}
	 *     ])
	 */
	
	
	function registerMap(mapName, geoJson, specialAreas) {
	  mapDataStorage.registerMap(mapName, geoJson, specialAreas);
	}
	/**
	 * @param {string} mapName
	 * @return {Object}
	 */
	
	
	function getMap(mapName) {
	  // For backward compatibility, only return the first one.
	  var records = mapDataStorage.retrieveMap(mapName);
	  return records && records[0] && {
	    geoJson: records[0].geoJSON,
	    specialAreas: records[0].specialAreas
	  };
	}
	
	registerVisual(PRIORITY_VISUAL_GLOBAL, seriesColor);
	registerPreprocessor(backwardCompat);
	registerProcessor(PRIORITY_PROCESSOR_DATASTACK, dataStack);
	registerLoading('default', loadingDefault); // Default actions
	
	registerAction({
	  type: 'highlight',
	  event: 'highlight',
	  update: 'highlight'
	}, zrUtil.noop);
	registerAction({
	  type: 'downplay',
	  event: 'downplay',
	  update: 'downplay'
	}, zrUtil.noop); // Default theme
	
	registerTheme('light', lightTheme);
	registerTheme('dark', darkTheme); // For backward compatibility, where the namespace `dataTool` will
	// be mounted on `echarts` is the extension `dataTool` is imported.
	
	var dataTool = {};
	exports.version = version;
	exports.dependencies = dependencies;
	exports.PRIORITY = PRIORITY;
	exports.init = init;
	exports.connect = connect;
	exports.disConnect = disConnect;
	exports.disconnect = disconnect;
	exports.dispose = dispose;
	exports.getInstanceByDom = getInstanceByDom;
	exports.getInstanceById = getInstanceById;
	exports.registerTheme = registerTheme;
	exports.registerPreprocessor = registerPreprocessor;
	exports.registerProcessor = registerProcessor;
	exports.registerPostUpdate = registerPostUpdate;
	exports.registerAction = registerAction;
	exports.registerCoordinateSystem = registerCoordinateSystem;
	exports.getCoordinateSystemDimensions = getCoordinateSystemDimensions;
	exports.registerLayout = registerLayout;
	exports.registerVisual = registerVisual;
	exports.registerLoading = registerLoading;
	exports.extendComponentModel = extendComponentModel;
	exports.extendComponentView = extendComponentView;
	exports.extendSeriesModel = extendSeriesModel;
	exports.extendChartView = extendChartView;
	exports.setCanvasCreator = setCanvasCreator;
	exports.registerMap = registerMap;
	exports.getMap = getMap;
	exports.dataTool = dataTool;
	var ___ec_export = __webpack_require__(748);
	(function () {
	    for (var key in ___ec_export) {
	        if (___ec_export.hasOwnProperty(key)) {
	            exports[key] = ___ec_export[key];
	        }
	    }
	})();

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(10);
	var eventService_1 = __webpack_require__(22);
	var constants_1 = __webpack_require__(30);
	var componentUtil_1 = __webpack_require__(417);
	var gridApi_1 = __webpack_require__(33);
	var context_1 = __webpack_require__(8);
	var columnApi_1 = __webpack_require__(38);
	var columnController_1 = __webpack_require__(26);
	var environment_1 = __webpack_require__(247);
	var propertyKeys_1 = __webpack_require__(659);
	var colDefUtil_1 = __webpack_require__(641);
	var eventKeys_1 = __webpack_require__(160);
	var autoHeightCalculator_1 = __webpack_require__(433);
	var sideBar_1 = __webpack_require__(642);
	var DEFAULT_ROW_HEIGHT = 25;
	var DEFAULT_DETAIL_ROW_HEIGHT = 300;
	var DEFAULT_VIEWPORT_ROW_MODEL_PAGE_SIZE = 5;
	var DEFAULT_VIEWPORT_ROW_MODEL_BUFFER_SIZE = 5;
	var DEFAULT_KEEP_DETAIL_ROW_COUNT = 10;
	function isTrue(value) {
	    return value === true || value === 'true';
	}
	function zeroOrGreater(value, defaultValue) {
	    if (value >= 0) {
	        return value;
	    }
	    // zero gets returned if number is missing or the wrong type
	    return defaultValue;
	}
	function oneOrGreater(value, defaultValue) {
	    if (value > 0) {
	        return value;
	    }
	    // zero gets returned if number is missing or the wrong type
	    return defaultValue;
	}
	var GridOptionsWrapper = /** @class */ (function () {
	    function GridOptionsWrapper() {
	        this.propertyEventService = new eventService_1.EventService();
	        this.domDataKey = '__AG_' + Math.random().toString();
	        this.layoutElements = [];
	    }
	    GridOptionsWrapper_1 = GridOptionsWrapper;
	    GridOptionsWrapper.prototype.agWire = function (gridApi, columnApi) {
	        this.gridOptions.api = gridApi;
	        this.gridOptions.columnApi = columnApi;
	        this.checkForDeprecated();
	        this.checkForViolations();
	    };
	    GridOptionsWrapper.prototype.destroy = function () {
	        // need to remove these, as we don't own the lifecycle of the gridOptions, we need to
	        // remove the references in case the user keeps the grid options, we want the rest
	        // of the grid to be picked up by the garbage collector
	        this.gridOptions.api = null;
	        this.gridOptions.columnApi = null;
	    };
	    GridOptionsWrapper.prototype.init = function () {
	        if (!(this.gridOptions.suppressPropertyNamesCheck === true)) {
	            this.checkGridOptionsProperties();
	            this.checkColumnDefProperties();
	        }
	        var async = this.useAsyncEvents();
	        this.eventService.addGlobalListener(this.globalEventHandler.bind(this), async);
	        if (this.isGroupSelectsChildren() && this.isSuppressParentsInRowNodes()) {
	            console.warn('ag-Grid: groupSelectsChildren does not work wth suppressParentsInRowNodes, this selection method needs the part in rowNode to work');
	        }
	        if (this.isGroupSelectsChildren()) {
	            if (!this.isRowSelectionMulti()) {
	                console.warn("ag-Grid: rowSelection must be 'multiple' for groupSelectsChildren to make sense");
	            }
	            if (this.isRowModelServerSide()) {
	                console.warn('ag-Grid: group selects children is NOT support for Server Side Row Model. ' +
	                    'This is because the rows are lazy loaded, so selecting a group is not possible as' +
	                    'the grid has no way of knowing what the children are.');
	            }
	        }
	        if (this.isGroupRemoveSingleChildren() && this.isGroupHideOpenParents()) {
	            console.warn('ag-Grid: groupRemoveSingleChildren and groupHideOpenParents do not work with each other, you need to pick one. And don\'t ask us how to us these together on our support forum either you will get the same answer!');
	        }
	        this.addEventListener(GridOptionsWrapper_1.PROP_DOM_LAYOUT, this.updateLayoutClasses.bind(this));
	    };
	    GridOptionsWrapper.prototype.checkColumnDefProperties = function () {
	        var _this = this;
	        if (this.gridOptions.columnDefs == null) {
	            return;
	        }
	        this.gridOptions.columnDefs.forEach(function (colDef) {
	            var userProperties = Object.getOwnPropertyNames(colDef);
	            var validProperties = colDefUtil_1.ColDefUtil.ALL_PROPERTIES.concat(colDefUtil_1.ColDefUtil.FRAMEWORK_PROPERTIES);
	            _this.checkProperties(userProperties, validProperties, validProperties, 'colDef', 'https://www.ag-grid.com/javascript-grid-column-properties/');
	        });
	    };
	    GridOptionsWrapper.prototype.checkGridOptionsProperties = function () {
	        var userProperties = Object.getOwnPropertyNames(this.gridOptions);
	        var validProperties = propertyKeys_1.PropertyKeys.ALL_PROPERTIES.concat(propertyKeys_1.PropertyKeys.FRAMEWORK_PROPERTIES);
	        Object.keys(eventKeys_1.Events).forEach(function (it) { return validProperties.push(componentUtil_1.ComponentUtil.getCallbackForEvent(eventKeys_1.Events[it])); });
	        var validPropertiesAndExceptions = validProperties.concat('api', 'columnApi');
	        this.checkProperties(userProperties, validPropertiesAndExceptions, validProperties, 'gridOptions', 'https://www.ag-grid.com/javascript-grid-properties/');
	    };
	    GridOptionsWrapper.prototype.checkProperties = function (userProperties, validPropertiesAndExceptions, validProperties, containerName, docsUrl) {
	        var invalidProperties = utils_1._.fuzzyCheckStrings(userProperties, validPropertiesAndExceptions, validProperties);
	        var invalidPropertyKeys = Object.keys(invalidProperties);
	        invalidPropertyKeys.forEach(function (invalidPropertyKey) {
	            var fuzzySuggestions = invalidProperties[invalidPropertyKey];
	            console.warn("ag-grid: invalid " + containerName + " property '" + invalidPropertyKey + "' did you mean any of these: " + fuzzySuggestions.slice(0, 8).join(","));
	        });
	        if (invalidPropertyKeys.length > 0) {
	            console.warn("ag-grid: to see all the valid " + containerName + " properties please check: " + docsUrl);
	        }
	    };
	    // returns the dom data, or undefined if not found
	    GridOptionsWrapper.prototype.getDomData = function (element, key) {
	        var domData = element[this.domDataKey];
	        if (domData) {
	            return domData[key];
	        }
	        return;
	    };
	    GridOptionsWrapper.prototype.setDomData = function (element, key, value) {
	        var domData = element[this.domDataKey];
	        if (utils_1._.missing(domData)) {
	            domData = {};
	            element[this.domDataKey] = domData;
	        }
	        domData[key] = value;
	    };
	    GridOptionsWrapper.prototype.isEnterprise = function () {
	        return this.enterprise;
	    };
	    GridOptionsWrapper.prototype.isRowSelection = function () {
	        return this.gridOptions.rowSelection === "single" || this.gridOptions.rowSelection === "multiple";
	    };
	    GridOptionsWrapper.prototype.isRowDeselection = function () {
	        return isTrue(this.gridOptions.rowDeselection);
	    };
	    GridOptionsWrapper.prototype.isRowSelectionMulti = function () {
	        return this.gridOptions.rowSelection === 'multiple';
	    };
	    GridOptionsWrapper.prototype.isRowMultiSelectWithClick = function () {
	        return isTrue(this.gridOptions.rowMultiSelectWithClick);
	    };
	    GridOptionsWrapper.prototype.getContext = function () {
	        return this.gridOptions.context;
	    };
	    GridOptionsWrapper.prototype.isPivotMode = function () {
	        return isTrue(this.gridOptions.pivotMode);
	    };
	    GridOptionsWrapper.prototype.isPivotTotals = function () {
	        return isTrue(this.gridOptions.pivotTotals);
	    };
	    GridOptionsWrapper.prototype.getPivotColumnGroupTotals = function () {
	        return this.gridOptions.pivotColumnGroupTotals;
	    };
	    GridOptionsWrapper.prototype.getPivotRowTotals = function () {
	        return this.gridOptions.pivotRowTotals;
	    };
	    GridOptionsWrapper.prototype.isRowModelInfinite = function () {
	        return this.gridOptions.rowModelType === constants_1.Constants.ROW_MODEL_TYPE_INFINITE;
	    };
	    GridOptionsWrapper.prototype.isRowModelViewport = function () {
	        return this.gridOptions.rowModelType === constants_1.Constants.ROW_MODEL_TYPE_VIEWPORT;
	    };
	    GridOptionsWrapper.prototype.isRowModelServerSide = function () {
	        return this.gridOptions.rowModelType === constants_1.Constants.ROW_MODEL_TYPE_SERVER_SIDE;
	    };
	    GridOptionsWrapper.prototype.isRowModelDefault = function () {
	        return utils_1._.missing(this.gridOptions.rowModelType) ||
	            this.gridOptions.rowModelType === constants_1.Constants.ROW_MODEL_TYPE_CLIENT_SIDE ||
	            this.gridOptions.rowModelType === constants_1.Constants.DEPRECATED_ROW_MODEL_TYPE_NORMAL;
	    };
	    GridOptionsWrapper.prototype.isFullRowEdit = function () {
	        return this.gridOptions.editType === 'fullRow';
	    };
	    GridOptionsWrapper.prototype.isSuppressFocusAfterRefresh = function () {
	        return isTrue(this.gridOptions.suppressFocusAfterRefresh);
	    };
	    GridOptionsWrapper.prototype.isSuppressBrowserResizeObserver = function () {
	        return isTrue(this.gridOptions.suppressBrowserResizeObserver);
	    };
	    GridOptionsWrapper.prototype.isSuppressMaintainUnsortedOrder = function () {
	        return isTrue(this.gridOptions.suppressMaintainUnsortedOrder);
	    };
	    GridOptionsWrapper.prototype.isShowToolPanel = function () {
	        return isTrue(this.gridOptions.sideBar && Array.isArray(this.getSideBar().toolPanels));
	    };
	    GridOptionsWrapper.prototype.getSideBar = function () {
	        return this.gridOptions.sideBar;
	    };
	    GridOptionsWrapper.prototype.isSuppressTouch = function () {
	        return isTrue(this.gridOptions.suppressTouch);
	    };
	    GridOptionsWrapper.prototype.isSuppressRowTransform = function () {
	        return isTrue(this.gridOptions.suppressRowTransform);
	    };
	    GridOptionsWrapper.prototype.isSuppressSetColumnStateEvents = function () {
	        return isTrue(this.gridOptions.suppressSetColumnStateEvents);
	    };
	    GridOptionsWrapper.prototype.useAsyncEvents = function () {
	        return !isTrue(this.gridOptions.suppressAsyncEvents);
	    };
	    GridOptionsWrapper.prototype.isEnableCellChangeFlash = function () {
	        return isTrue(this.gridOptions.enableCellChangeFlash);
	    };
	    GridOptionsWrapper.prototype.isGroupSelectsChildren = function () {
	        var result = isTrue(this.gridOptions.groupSelectsChildren);
	        if (result && this.isTreeData()) {
	            console.warn('ag-Grid: groupSelectsChildren does not work with tree data');
	            return false;
	        }
	        return result;
	    };
	    GridOptionsWrapper.prototype.isSuppressRowHoverHighlight = function () {
	        return isTrue(this.gridOptions.suppressRowHoverHighlight);
	    };
	    GridOptionsWrapper.prototype.isGroupSelectsFiltered = function () {
	        return isTrue(this.gridOptions.groupSelectsFiltered);
	    };
	    GridOptionsWrapper.prototype.isGroupHideOpenParents = function () {
	        return isTrue(this.gridOptions.groupHideOpenParents);
	    };
	    // if we are doing hideOpenParents, then we always have groupMultiAutoColumn, otherwise hideOpenParents would not work
	    GridOptionsWrapper.prototype.isGroupMultiAutoColumn = function () {
	        return isTrue(this.gridOptions.groupMultiAutoColumn) || isTrue(this.gridOptions.groupHideOpenParents);
	    };
	    GridOptionsWrapper.prototype.isGroupRemoveSingleChildren = function () {
	        return isTrue(this.gridOptions.groupRemoveSingleChildren);
	    };
	    GridOptionsWrapper.prototype.isGroupRemoveLowestSingleChildren = function () {
	        return isTrue(this.gridOptions.groupRemoveLowestSingleChildren);
	    };
	    GridOptionsWrapper.prototype.isGroupIncludeFooter = function () {
	        return isTrue(this.gridOptions.groupIncludeFooter);
	    };
	    GridOptionsWrapper.prototype.isGroupIncludeTotalFooter = function () {
	        return isTrue(this.gridOptions.groupIncludeTotalFooter);
	    };
	    GridOptionsWrapper.prototype.isGroupSuppressBlankHeader = function () {
	        return isTrue(this.gridOptions.groupSuppressBlankHeader);
	    };
	    GridOptionsWrapper.prototype.isSuppressRowClickSelection = function () {
	        return isTrue(this.gridOptions.suppressRowClickSelection);
	    };
	    GridOptionsWrapper.prototype.isSuppressCellSelection = function () {
	        return isTrue(this.gridOptions.suppressCellSelection);
	    };
	    GridOptionsWrapper.prototype.isSuppressMultiSort = function () {
	        return isTrue(this.gridOptions.suppressMultiSort);
	    };
	    GridOptionsWrapper.prototype.isMultiSortKeyCtrl = function () {
	        return this.gridOptions.multiSortKey === 'ctrl';
	    };
	    GridOptionsWrapper.prototype.isGroupSuppressAutoColumn = function () {
	        return isTrue(this.gridOptions.groupSuppressAutoColumn);
	    };
	    GridOptionsWrapper.prototype.isSuppressDragLeaveHidesColumns = function () {
	        return isTrue(this.gridOptions.suppressDragLeaveHidesColumns);
	    };
	    GridOptionsWrapper.prototype.isSuppressScrollOnNewData = function () {
	        return isTrue(this.gridOptions.suppressScrollOnNewData);
	    };
	    GridOptionsWrapper.prototype.isRowDragManaged = function () {
	        return isTrue(this.gridOptions.rowDragManaged);
	    };
	    GridOptionsWrapper.prototype.isSuppressRowDrag = function () {
	        return isTrue(this.gridOptions.suppressRowDrag);
	    };
	    // returns either 'print', 'autoHeight' or 'normal' (normal is the default)
	    GridOptionsWrapper.prototype.getDomLayout = function () {
	        var _this = this;
	        var domLayout = this.gridOptions.domLayout;
	        if (domLayout === constants_1.Constants.DOM_LAYOUT_PRINT
	            || domLayout === constants_1.Constants.DOM_LAYOUT_AUTO_HEIGHT
	            || domLayout === constants_1.Constants.DOM_LAYOUT_NORMAL) {
	            return domLayout;
	        }
	        else if (domLayout === null || domLayout === undefined) {
	            return constants_1.Constants.DOM_LAYOUT_NORMAL;
	        }
	        else {
	            utils_1._.doOnce(function () { return console.warn("ag-Grid: " + _this.gridOptions.domLayout + " is not valid for DOM Layout, valid values are " + constants_1.Constants.DOM_LAYOUT_NORMAL + ", " + constants_1.Constants.DOM_LAYOUT_AUTO_HEIGHT + " and " + constants_1.Constants.DOM_LAYOUT_PRINT); }, 'warn about dom layout values');
	            return constants_1.Constants.DOM_LAYOUT_NORMAL;
	        }
	    };
	    GridOptionsWrapper.prototype.isSuppressHorizontalScroll = function () {
	        return isTrue(this.gridOptions.suppressHorizontalScroll);
	    };
	    GridOptionsWrapper.prototype.isSuppressMaxRenderedRowRestriction = function () {
	        return isTrue(this.gridOptions.suppressMaxRenderedRowRestriction);
	    };
	    GridOptionsWrapper.prototype.isExcludeChildrenWhenTreeDataFiltering = function () {
	        return isTrue(this.gridOptions.excludeChildrenWhenTreeDataFiltering);
	    };
	    GridOptionsWrapper.prototype.isAlwaysShowVerticalScroll = function () {
	        return isTrue(this.gridOptions.alwaysShowVerticalScroll);
	    };
	    GridOptionsWrapper.prototype.isSuppressLoadingOverlay = function () {
	        return isTrue(this.gridOptions.suppressLoadingOverlay);
	    };
	    GridOptionsWrapper.prototype.isSuppressNoRowsOverlay = function () {
	        return isTrue(this.gridOptions.suppressNoRowsOverlay);
	    };
	    GridOptionsWrapper.prototype.isSuppressFieldDotNotation = function () {
	        return isTrue(this.gridOptions.suppressFieldDotNotation);
	    };
	    GridOptionsWrapper.prototype.getPinnedTopRowData = function () {
	        return this.gridOptions.pinnedTopRowData;
	    };
	    GridOptionsWrapper.prototype.getPinnedBottomRowData = function () {
	        return this.gridOptions.pinnedBottomRowData;
	    };
	    GridOptionsWrapper.prototype.isFunctionsPassive = function () {
	        return isTrue(this.gridOptions.functionsPassive);
	    };
	    GridOptionsWrapper.prototype.isSuppressTabbing = function () {
	        return isTrue(this.gridOptions.suppressTabbing);
	    };
	    GridOptionsWrapper.prototype.isSuppressChangeDetection = function () {
	        return isTrue(this.gridOptions.suppressChangeDetection);
	    };
	    GridOptionsWrapper.prototype.isSuppressAnimationFrame = function () {
	        return isTrue(this.gridOptions.suppressAnimationFrame);
	    };
	    GridOptionsWrapper.prototype.getQuickFilterText = function () {
	        return this.gridOptions.quickFilterText;
	    };
	    GridOptionsWrapper.prototype.isCacheQuickFilter = function () {
	        return isTrue(this.gridOptions.cacheQuickFilter);
	    };
	    GridOptionsWrapper.prototype.isUnSortIcon = function () {
	        return isTrue(this.gridOptions.unSortIcon);
	    };
	    GridOptionsWrapper.prototype.isSuppressMenuHide = function () {
	        return isTrue(this.gridOptions.suppressMenuHide);
	    };
	    GridOptionsWrapper.prototype.isEnterMovesDownAfterEdit = function () {
	        return isTrue(this.gridOptions.enterMovesDownAfterEdit);
	    };
	    GridOptionsWrapper.prototype.isEnterMovesDown = function () {
	        return isTrue(this.gridOptions.enterMovesDown);
	    };
	    GridOptionsWrapper.prototype.getRowStyle = function () {
	        return this.gridOptions.rowStyle;
	    };
	    GridOptionsWrapper.prototype.getRowClass = function () {
	        return this.gridOptions.rowClass;
	    };
	    GridOptionsWrapper.prototype.getRowStyleFunc = function () {
	        return this.gridOptions.getRowStyle;
	    };
	    GridOptionsWrapper.prototype.getRowClassFunc = function () {
	        return this.gridOptions.getRowClass;
	    };
	    GridOptionsWrapper.prototype.rowClassRules = function () {
	        return this.gridOptions.rowClassRules;
	    };
	    GridOptionsWrapper.prototype.getCreateChartContainerFunc = function () {
	        return this.gridOptions.createChartContainer;
	    };
	    GridOptionsWrapper.prototype.getPopupParent = function () {
	        return this.gridOptions.popupParent;
	    };
	    GridOptionsWrapper.prototype.getBlockLoadDebounceMillis = function () {
	        return this.gridOptions.blockLoadDebounceMillis;
	    };
	    GridOptionsWrapper.prototype.getPostProcessPopupFunc = function () {
	        return this.gridOptions.postProcessPopup;
	    };
	    GridOptionsWrapper.prototype.getDoesDataFlowerFunc = function () {
	        return this.gridOptions.doesDataFlower;
	    };
	    GridOptionsWrapper.prototype.getPaginationNumberFormatterFunc = function () {
	        return this.gridOptions.paginationNumberFormatter;
	    };
	    GridOptionsWrapper.prototype.getChildCountFunc = function () {
	        return this.gridOptions.getChildCount;
	    };
	    GridOptionsWrapper.prototype.getDefaultGroupSortComparator = function () {
	        return this.gridOptions.defaultGroupSortComparator;
	    };
	    GridOptionsWrapper.prototype.getIsFullWidthCellFunc = function () {
	        return this.gridOptions.isFullWidthCell;
	    };
	    GridOptionsWrapper.prototype.getFullWidthCellRendererParams = function () {
	        return this.gridOptions.fullWidthCellRendererParams;
	    };
	    GridOptionsWrapper.prototype.isEmbedFullWidthRows = function () {
	        return isTrue(this.gridOptions.embedFullWidthRows) || isTrue(this.gridOptions.deprecatedEmbedFullWidthRows);
	    };
	    GridOptionsWrapper.prototype.getSuppressKeyboardEventFunc = function () {
	        return this.gridOptions.suppressKeyboardEvent;
	    };
	    GridOptionsWrapper.prototype.getBusinessKeyForNodeFunc = function () {
	        return this.gridOptions.getBusinessKeyForNode;
	    };
	    GridOptionsWrapper.prototype.getApi = function () {
	        return this.gridOptions.api;
	    };
	    GridOptionsWrapper.prototype.getColumnApi = function () {
	        return this.gridOptions.columnApi;
	    };
	    GridOptionsWrapper.prototype.isDeltaRowDataMode = function () {
	        return isTrue(this.gridOptions.deltaRowDataMode);
	    };
	    GridOptionsWrapper.prototype.isDeltaColumnMode = function () {
	        return isTrue(this.gridOptions.deltaColumnMode);
	    };
	    GridOptionsWrapper.prototype.isEnsureDomOrder = function () {
	        return isTrue(this.gridOptions.ensureDomOrder);
	    };
	    GridOptionsWrapper.prototype.isEnableCharts = function () {
	        if (isTrue((this.gridOptions.enableCharts))) {
	            if (!this.context.isModuleRegistered("chartsModule" /* ChartsModule */)) {
	                utils_1._.doOnce(function () {
	                    console.warn('ag-grid: Charts is enabled but the Charts Module has not been included.');
	                }, 'ChartsModuleCheck');
	                return false;
	            }
	            return true;
	        }
	        return false;
	    };
	    GridOptionsWrapper.prototype.getColResizeDefault = function () {
	        return this.gridOptions.colResizeDefault;
	    };
	    GridOptionsWrapper.prototype.isSingleClickEdit = function () {
	        return isTrue(this.gridOptions.singleClickEdit);
	    };
	    GridOptionsWrapper.prototype.isSuppressClickEdit = function () {
	        return isTrue(this.gridOptions.suppressClickEdit);
	    };
	    GridOptionsWrapper.prototype.isStopEditingWhenGridLosesFocus = function () {
	        return isTrue(this.gridOptions.stopEditingWhenGridLosesFocus);
	    };
	    GridOptionsWrapper.prototype.getGroupDefaultExpanded = function () {
	        return this.gridOptions.groupDefaultExpanded;
	    };
	    GridOptionsWrapper.prototype.getMaxConcurrentDatasourceRequests = function () {
	        return this.gridOptions.maxConcurrentDatasourceRequests;
	    };
	    GridOptionsWrapper.prototype.getMaxBlocksInCache = function () {
	        return this.gridOptions.maxBlocksInCache;
	    };
	    GridOptionsWrapper.prototype.getCacheOverflowSize = function () {
	        return this.gridOptions.cacheOverflowSize;
	    };
	    GridOptionsWrapper.prototype.getPaginationPageSize = function () {
	        return this.gridOptions.paginationPageSize;
	    };
	    GridOptionsWrapper.prototype.isPaginateChildRows = function () {
	        // if using groupSuppressRow, means we are not showing parent rows,
	        // so we always paginate on the child rows here as there are no parent rows
	        if (this.isGroupSuppressRow() || this.isGroupRemoveSingleChildren()
	            || this.isGroupRemoveLowestSingleChildren()) {
	            return true;
	        }
	        return isTrue(this.gridOptions.paginateChildRows);
	    };
	    GridOptionsWrapper.prototype.getCacheBlockSize = function () {
	        return this.gridOptions.cacheBlockSize;
	    };
	    GridOptionsWrapper.prototype.getInfiniteInitialRowCount = function () {
	        return this.gridOptions.infiniteInitialRowCount;
	    };
	    GridOptionsWrapper.prototype.isPurgeClosedRowNodes = function () {
	        return isTrue(this.gridOptions.purgeClosedRowNodes);
	    };
	    GridOptionsWrapper.prototype.isSuppressPaginationPanel = function () {
	        return isTrue(this.gridOptions.suppressPaginationPanel);
	    };
	    GridOptionsWrapper.prototype.getRowData = function () {
	        return this.gridOptions.rowData;
	    };
	    // this property is different - we never allow groupUseEntireRow if in pivot mode,
	    // as otherwise we don't see the pivot values.
	    GridOptionsWrapper.prototype.isGroupUseEntireRow = function (pivotMode) {
	        return pivotMode ? false : isTrue(this.gridOptions.groupUseEntireRow);
	    };
	    GridOptionsWrapper.prototype.isEnableRtl = function () {
	        return isTrue(this.gridOptions.enableRtl);
	    };
	    GridOptionsWrapper.prototype.getAutoGroupColumnDef = function () {
	        return this.gridOptions.autoGroupColumnDef;
	    };
	    GridOptionsWrapper.prototype.isGroupSuppressRow = function () {
	        return isTrue(this.gridOptions.groupSuppressRow);
	    };
	    GridOptionsWrapper.prototype.getRowGroupPanelShow = function () {
	        return this.gridOptions.rowGroupPanelShow;
	    };
	    GridOptionsWrapper.prototype.getPivotPanelShow = function () {
	        return this.gridOptions.pivotPanelShow;
	    };
	    GridOptionsWrapper.prototype.isAngularCompileRows = function () {
	        return isTrue(this.gridOptions.angularCompileRows);
	    };
	    GridOptionsWrapper.prototype.isAngularCompileFilters = function () {
	        return isTrue(this.gridOptions.angularCompileFilters);
	    };
	    GridOptionsWrapper.prototype.isAngularCompileHeaders = function () {
	        return isTrue(this.gridOptions.angularCompileHeaders);
	    };
	    GridOptionsWrapper.prototype.isDebug = function () {
	        return isTrue(this.gridOptions.debug);
	    };
	    GridOptionsWrapper.prototype.getColumnDefs = function () {
	        return this.gridOptions.columnDefs;
	    };
	    GridOptionsWrapper.prototype.getColumnTypes = function () {
	        return this.gridOptions.columnTypes;
	    };
	    GridOptionsWrapper.prototype.getDatasource = function () {
	        return this.gridOptions.datasource;
	    };
	    GridOptionsWrapper.prototype.getViewportDatasource = function () {
	        return this.gridOptions.viewportDatasource;
	    };
	    GridOptionsWrapper.prototype.getServerSideDatasource = function () {
	        return this.gridOptions.serverSideDatasource;
	    };
	    GridOptionsWrapper.prototype.isAccentedSort = function () {
	        return isTrue(this.gridOptions.accentedSort);
	    };
	    GridOptionsWrapper.prototype.isEnableBrowserTooltips = function () {
	        return isTrue(this.gridOptions.enableBrowserTooltips);
	    };
	    GridOptionsWrapper.prototype.isEnableCellExpressions = function () {
	        return isTrue(this.gridOptions.enableCellExpressions);
	    };
	    GridOptionsWrapper.prototype.isEnableGroupEdit = function () {
	        return isTrue(this.gridOptions.enableGroupEdit);
	    };
	    GridOptionsWrapper.prototype.isSuppressMiddleClickScrolls = function () {
	        return isTrue(this.gridOptions.suppressMiddleClickScrolls);
	    };
	    GridOptionsWrapper.prototype.isPreventDefaultOnContextMenu = function () {
	        return isTrue(this.gridOptions.preventDefaultOnContextMenu);
	    };
	    GridOptionsWrapper.prototype.isSuppressPreventDefaultOnMouseWheel = function () {
	        return isTrue(this.gridOptions.suppressPreventDefaultOnMouseWheel);
	    };
	    GridOptionsWrapper.prototype.isSuppressColumnVirtualisation = function () {
	        return isTrue(this.gridOptions.suppressColumnVirtualisation);
	    };
	    GridOptionsWrapper.prototype.isSuppressContextMenu = function () {
	        return isTrue(this.gridOptions.suppressContextMenu);
	    };
	    GridOptionsWrapper.prototype.isAllowContextMenuWithControlKey = function () {
	        return isTrue(this.gridOptions.allowContextMenuWithControlKey);
	    };
	    GridOptionsWrapper.prototype.isSuppressCopyRowsToClipboard = function () {
	        return isTrue(this.gridOptions.suppressCopyRowsToClipboard);
	    };
	    GridOptionsWrapper.prototype.isCopyHeadersToClipboard = function () {
	        return isTrue(this.gridOptions.copyHeadersToClipboard);
	    };
	    GridOptionsWrapper.prototype.isSuppressClipboardPaste = function () {
	        return isTrue(this.gridOptions.suppressClipboardPaste);
	    };
	    GridOptionsWrapper.prototype.isPagination = function () {
	        return isTrue(this.gridOptions.pagination);
	    };
	    GridOptionsWrapper.prototype.isSuppressEnterpriseResetOnNewColumns = function () {
	        return isTrue(this.gridOptions.suppressEnterpriseResetOnNewColumns);
	    };
	    GridOptionsWrapper.prototype.getProcessDataFromClipboardFunc = function () {
	        return this.gridOptions.processDataFromClipboard;
	    };
	    GridOptionsWrapper.prototype.getBatchUpdateWaitMillis = function () {
	        return utils_1._.exists(this.gridOptions.batchUpdateWaitMillis) ? this.gridOptions.batchUpdateWaitMillis : constants_1.Constants.BATCH_WAIT_MILLIS;
	    };
	    GridOptionsWrapper.prototype.isSuppressMovableColumns = function () {
	        return isTrue(this.gridOptions.suppressMovableColumns);
	    };
	    GridOptionsWrapper.prototype.isAnimateRows = function () {
	        // never allow animating if enforcing the row order
	        if (this.isEnsureDomOrder()) {
	            return false;
	        }
	        return isTrue(this.gridOptions.animateRows);
	    };
	    GridOptionsWrapper.prototype.isSuppressColumnMoveAnimation = function () {
	        return isTrue(this.gridOptions.suppressColumnMoveAnimation);
	    };
	    GridOptionsWrapper.prototype.isSuppressAggFuncInHeader = function () {
	        return isTrue(this.gridOptions.suppressAggFuncInHeader);
	    };
	    GridOptionsWrapper.prototype.isSuppressAggAtRootLevel = function () {
	        return isTrue(this.gridOptions.suppressAggAtRootLevel);
	    };
	    GridOptionsWrapper.prototype.isEnableRangeSelection = function () {
	        return this.enterprise && isTrue(this.gridOptions.enableRangeSelection);
	    };
	    GridOptionsWrapper.prototype.isEnableRangeHandle = function () {
	        return isTrue(this.gridOptions.enableRangeHandle);
	    };
	    GridOptionsWrapper.prototype.isEnableFillHandle = function () {
	        return isTrue(this.gridOptions.enableFillHandle);
	    };
	    GridOptionsWrapper.prototype.isSuppressMultiRangeSelection = function () {
	        return isTrue(this.gridOptions.suppressMultiRangeSelection);
	    };
	    GridOptionsWrapper.prototype.isPaginationAutoPageSize = function () {
	        return isTrue(this.gridOptions.paginationAutoPageSize);
	    };
	    GridOptionsWrapper.prototype.isRememberGroupStateWhenNewData = function () {
	        return isTrue(this.gridOptions.rememberGroupStateWhenNewData);
	    };
	    GridOptionsWrapper.prototype.getIcons = function () {
	        return this.gridOptions.icons;
	    };
	    GridOptionsWrapper.prototype.getAggFuncs = function () {
	        return this.gridOptions.aggFuncs;
	    };
	    GridOptionsWrapper.prototype.getSortingOrder = function () {
	        return this.gridOptions.sortingOrder;
	    };
	    GridOptionsWrapper.prototype.getAlignedGrids = function () {
	        return this.gridOptions.alignedGrids;
	    };
	    GridOptionsWrapper.prototype.isMasterDetail = function () {
	        var _this = this;
	        var usingMasterDetail = isTrue(this.gridOptions.masterDetail);
	        utils_1._.doOnce(function () {
	            if (usingMasterDetail && !_this.enterprise) {
	                console.warn('ag-grid: Master Detail is an Enterprise feature of ag-Grid.');
	            }
	        }, 'MasterDetailEnterpriseCheck');
	        return usingMasterDetail && this.enterprise;
	    };
	    GridOptionsWrapper.prototype.isKeepDetailRows = function () {
	        return isTrue(this.gridOptions.keepDetailRows);
	    };
	    GridOptionsWrapper.prototype.getKeepDetailRowsCount = function () {
	        if (this.gridOptions.keepDetailRowsCount > 0) {
	            return this.gridOptions.keepDetailRowsCount;
	        }
	        else {
	            return DEFAULT_KEEP_DETAIL_ROW_COUNT;
	        }
	    };
	    GridOptionsWrapper.prototype.getIsRowMasterFunc = function () {
	        return this.gridOptions.isRowMaster;
	    };
	    GridOptionsWrapper.prototype.getIsRowSelectableFunc = function () {
	        return this.gridOptions.isRowSelectable;
	    };
	    GridOptionsWrapper.prototype.getGroupRowRendererParams = function () {
	        return this.gridOptions.groupRowRendererParams;
	    };
	    GridOptionsWrapper.prototype.getOverlayLoadingTemplate = function () {
	        return this.gridOptions.overlayLoadingTemplate;
	    };
	    GridOptionsWrapper.prototype.getOverlayNoRowsTemplate = function () {
	        return this.gridOptions.overlayNoRowsTemplate;
	    };
	    GridOptionsWrapper.prototype.isSuppressAutoSize = function () {
	        return isTrue(this.gridOptions.suppressAutoSize);
	    };
	    GridOptionsWrapper.prototype.isEnableCellTextSelection = function () {
	        return isTrue(this.gridOptions.enableCellTextSelection);
	    };
	    GridOptionsWrapper.prototype.isSuppressParentsInRowNodes = function () {
	        return isTrue(this.gridOptions.suppressParentsInRowNodes);
	    };
	    GridOptionsWrapper.prototype.isFunctionsReadOnly = function () {
	        return isTrue(this.gridOptions.functionsReadOnly);
	    };
	    GridOptionsWrapper.prototype.isFloatingFilter = function () {
	        return this.gridOptions.floatingFilter;
	    };
	    GridOptionsWrapper.prototype.isEnableCellTextSelect = function () {
	        return isTrue(this.gridOptions.enableCellTextSelection);
	    };
	    GridOptionsWrapper.prototype.isEnableOldSetFilterModel = function () {
	        return isTrue(this.gridOptions.enableOldSetFilterModel);
	    };
	    GridOptionsWrapper.prototype.getDefaultColDef = function () {
	        return this.gridOptions.defaultColDef;
	    };
	    GridOptionsWrapper.prototype.getDefaultColGroupDef = function () {
	        return this.gridOptions.defaultColGroupDef;
	    };
	    GridOptionsWrapper.prototype.getDefaultExportParams = function () {
	        return this.gridOptions.defaultExportParams;
	    };
	    GridOptionsWrapper.prototype.isSuppressCsvExport = function () {
	        return isTrue(this.gridOptions.suppressCsvExport);
	    };
	    GridOptionsWrapper.prototype.isAllowShowChangeAfterFilter = function () {
	        return isTrue(this.gridOptions.allowShowChangeAfterFilter);
	    };
	    GridOptionsWrapper.prototype.isSuppressExcelExport = function () {
	        return isTrue(this.gridOptions.suppressExcelExport);
	    };
	    GridOptionsWrapper.prototype.isSuppressMakeColumnVisibleAfterUnGroup = function () {
	        return isTrue(this.gridOptions.suppressMakeColumnVisibleAfterUnGroup);
	    };
	    GridOptionsWrapper.prototype.getNodeChildDetailsFunc = function () {
	        return this.gridOptions.getNodeChildDetails;
	    };
	    GridOptionsWrapper.prototype.getDataPathFunc = function () {
	        return this.gridOptions.getDataPath;
	    };
	    GridOptionsWrapper.prototype.getIsServerSideGroupFunc = function () {
	        return this.gridOptions.isServerSideGroup;
	    };
	    GridOptionsWrapper.prototype.getServerSideGroupKeyFunc = function () {
	        return this.gridOptions.getServerSideGroupKey;
	    };
	    GridOptionsWrapper.prototype.getGroupRowAggNodesFunc = function () {
	        return this.gridOptions.groupRowAggNodes;
	    };
	    GridOptionsWrapper.prototype.getContextMenuItemsFunc = function () {
	        return this.gridOptions.getContextMenuItems;
	    };
	    GridOptionsWrapper.prototype.getMainMenuItemsFunc = function () {
	        return this.gridOptions.getMainMenuItems;
	    };
	    GridOptionsWrapper.prototype.getChartToolbarItemsFunc = function () {
	        return this.gridOptions.getChartToolbarItems;
	    };
	    GridOptionsWrapper.prototype.getRowNodeIdFunc = function () {
	        return this.gridOptions.getRowNodeId;
	    };
	    GridOptionsWrapper.prototype.getNavigateToNextCellFunc = function () {
	        return this.gridOptions.navigateToNextCell;
	    };
	    GridOptionsWrapper.prototype.getTabToNextCellFunc = function () {
	        return this.gridOptions.tabToNextCell;
	    };
	    GridOptionsWrapper.prototype.isTreeData = function () {
	        var _this = this;
	        var usingTreeData = isTrue(this.gridOptions.treeData);
	        utils_1._.doOnce(function () {
	            if (usingTreeData && !_this.enterprise) {
	                console.warn('ag-grid: TreeData is an Enterprise feature of ag-Grid.');
	            }
	        }, 'TreeDataEnterpriseCheck');
	        return usingTreeData;
	    };
	    GridOptionsWrapper.prototype.isValueCache = function () {
	        return isTrue(this.gridOptions.valueCache);
	    };
	    GridOptionsWrapper.prototype.isValueCacheNeverExpires = function () {
	        return isTrue(this.gridOptions.valueCacheNeverExpires);
	    };
	    GridOptionsWrapper.prototype.isDeltaSort = function () {
	        return isTrue(this.gridOptions.deltaSort);
	    };
	    GridOptionsWrapper.prototype.isAggregateOnlyChangedColumns = function () {
	        return isTrue(this.gridOptions.aggregateOnlyChangedColumns);
	    };
	    GridOptionsWrapper.prototype.getProcessSecondaryColDefFunc = function () {
	        return this.gridOptions.processSecondaryColDef;
	    };
	    GridOptionsWrapper.prototype.getProcessSecondaryColGroupDefFunc = function () {
	        return this.gridOptions.processSecondaryColGroupDef;
	    };
	    GridOptionsWrapper.prototype.getSendToClipboardFunc = function () {
	        return this.gridOptions.sendToClipboard;
	    };
	    GridOptionsWrapper.prototype.getProcessRowPostCreateFunc = function () {
	        return this.gridOptions.processRowPostCreate;
	    };
	    GridOptionsWrapper.prototype.getProcessCellForClipboardFunc = function () {
	        return this.gridOptions.processCellForClipboard;
	    };
	    GridOptionsWrapper.prototype.getProcessHeaderForClipboardFunc = function () {
	        return this.gridOptions.processHeaderForClipboard;
	    };
	    GridOptionsWrapper.prototype.getProcessCellFromClipboardFunc = function () {
	        return this.gridOptions.processCellFromClipboard;
	    };
	    GridOptionsWrapper.prototype.getViewportRowModelPageSize = function () {
	        return oneOrGreater(this.gridOptions.viewportRowModelPageSize, DEFAULT_VIEWPORT_ROW_MODEL_PAGE_SIZE);
	    };
	    GridOptionsWrapper.prototype.getViewportRowModelBufferSize = function () {
	        return zeroOrGreater(this.gridOptions.viewportRowModelBufferSize, DEFAULT_VIEWPORT_ROW_MODEL_BUFFER_SIZE);
	    };
	    // public getCellRenderers(): {[key: string]: {new(): ICellRenderer} | ICellRendererFunc} { return this.gridOptions.cellRenderers; }
	    // public getCellEditors(): {[key: string]: {new(): ICellEditor}} { return this.gridOptions.cellEditors; }
	    GridOptionsWrapper.prototype.isServerSideSortingAlwaysResets = function () {
	        return isTrue(this.gridOptions.serverSideSortingAlwaysResets);
	    };
	    GridOptionsWrapper.prototype.getPostSortFunc = function () {
	        return this.gridOptions.postSort;
	    };
	    GridOptionsWrapper.prototype.getProcessChartOptionsFunc = function () {
	        return this.gridOptions.processChartOptions;
	    };
	    GridOptionsWrapper.prototype.getClipboardDeliminator = function () {
	        return utils_1._.exists(this.gridOptions.clipboardDeliminator) ? this.gridOptions.clipboardDeliminator : '\t';
	    };
	    GridOptionsWrapper.prototype.setProperty = function (key, value) {
	        var gridOptionsNoType = this.gridOptions;
	        var previousValue = gridOptionsNoType[key];
	        if (previousValue !== value) {
	            gridOptionsNoType[key] = value;
	            var event_1 = {
	                type: key,
	                currentValue: value,
	                previousValue: previousValue
	            };
	            this.propertyEventService.dispatchEvent(event_1);
	        }
	    };
	    // this logic is repeated in lots of places. any element that had different CSS
	    // dependent on the layout needs to have the layout class added ot it.
	    GridOptionsWrapper.prototype.addLayoutElement = function (element) {
	        this.layoutElements.push(element);
	        this.updateLayoutClasses();
	    };
	    GridOptionsWrapper.prototype.updateLayoutClasses = function () {
	        var domLayout = this.getDomLayout();
	        var domLayoutAutoHeight = domLayout === constants_1.Constants.DOM_LAYOUT_AUTO_HEIGHT;
	        var domLayoutPrint = domLayout === constants_1.Constants.DOM_LAYOUT_PRINT;
	        var domLayoutNormal = domLayout === constants_1.Constants.DOM_LAYOUT_NORMAL;
	        this.layoutElements.forEach(function (e) {
	            utils_1._.addOrRemoveCssClass(e, 'ag-layout-auto-height', domLayoutAutoHeight);
	            utils_1._.addOrRemoveCssClass(e, 'ag-layout-normal', domLayoutNormal);
	            utils_1._.addOrRemoveCssClass(e, 'ag-layout-print', domLayoutPrint);
	        });
	    };
	    GridOptionsWrapper.prototype.addEventListener = function (key, listener) {
	        GridOptionsWrapper_1.checkEventDeprecation(key);
	        this.propertyEventService.addEventListener(key, listener);
	    };
	    GridOptionsWrapper.checkEventDeprecation = function (eventName) {
	        if (eventName === 'floatingRowDataChanged') {
	            console.warn('ag-Grid: floatingRowDataChanged is now called pinnedRowDataChanged');
	        }
	    };
	    GridOptionsWrapper.prototype.removeEventListener = function (key, listener) {
	        this.propertyEventService.removeEventListener(key, listener);
	    };
	    GridOptionsWrapper.prototype.getAutoSizePadding = function () {
	        return this.gridOptions.autoSizePadding && this.gridOptions.autoSizePadding > 0 ? this.gridOptions.autoSizePadding : 20;
	    };
	    // properties
	    GridOptionsWrapper.prototype.getHeaderHeight = function () {
	        if (typeof this.gridOptions.headerHeight === 'number') {
	            return this.gridOptions.headerHeight;
	        }
	        return this.specialForNewMaterial(25, 'headerHeight');
	    };
	    GridOptionsWrapper.prototype.getFloatingFiltersHeight = function () {
	        if (typeof this.gridOptions.floatingFiltersHeight === 'number') {
	            return this.gridOptions.floatingFiltersHeight;
	        }
	        return this.specialForNewMaterial(25, 'headerHeight');
	    };
	    GridOptionsWrapper.prototype.getGroupHeaderHeight = function () {
	        if (typeof this.gridOptions.groupHeaderHeight === 'number') {
	            return this.gridOptions.groupHeaderHeight;
	        }
	        return this.getHeaderHeight();
	    };
	    GridOptionsWrapper.prototype.getPivotHeaderHeight = function () {
	        if (typeof this.gridOptions.pivotHeaderHeight === 'number') {
	            return this.gridOptions.pivotHeaderHeight;
	        }
	        return this.getHeaderHeight();
	    };
	    GridOptionsWrapper.prototype.getPivotGroupHeaderHeight = function () {
	        if (typeof this.gridOptions.pivotGroupHeaderHeight === 'number') {
	            return this.gridOptions.pivotGroupHeaderHeight;
	        }
	        return this.getGroupHeaderHeight();
	    };
	    GridOptionsWrapper.prototype.isExternalFilterPresent = function () {
	        if (typeof this.gridOptions.isExternalFilterPresent === 'function') {
	            return this.gridOptions.isExternalFilterPresent();
	        }
	        return false;
	    };
	    GridOptionsWrapper.prototype.doesExternalFilterPass = function (node) {
	        if (typeof this.gridOptions.doesExternalFilterPass === 'function') {
	            return this.gridOptions.doesExternalFilterPass(node);
	        }
	        return false;
	    };
	    GridOptionsWrapper.prototype.getDocument = function () {
	        // if user is providing document, we use the users one,
	        // otherwise we use the document on the global namespace.
	        var result = null;
	        if (this.gridOptions.getDocument && utils_1._.exists(this.gridOptions.getDocument)) {
	            result = this.gridOptions.getDocument();
	        }
	        if (result && utils_1._.exists(result)) {
	            return result;
	        }
	        return document;
	    };
	    GridOptionsWrapper.prototype.getMinColWidth = function () {
	        if (this.gridOptions.minColWidth && (this.gridOptions.minColWidth > GridOptionsWrapper_1.MIN_COL_WIDTH)) {
	            return this.gridOptions.minColWidth;
	        }
	        return GridOptionsWrapper_1.MIN_COL_WIDTH;
	    };
	    GridOptionsWrapper.prototype.getMaxColWidth = function () {
	        if (this.gridOptions.maxColWidth && (this.gridOptions.maxColWidth > GridOptionsWrapper_1.MIN_COL_WIDTH)) {
	            return this.gridOptions.maxColWidth;
	        }
	        return null;
	    };
	    GridOptionsWrapper.prototype.getColWidth = function () {
	        if (typeof this.gridOptions.colWidth !== 'number' || this.gridOptions.colWidth < GridOptionsWrapper_1.MIN_COL_WIDTH) {
	            return 200;
	        }
	        return this.gridOptions.colWidth;
	    };
	    GridOptionsWrapper.prototype.getRowBuffer = function () {
	        var rowBuffer = this.gridOptions.rowBuffer;
	        if (typeof rowBuffer === 'number') {
	            if (rowBuffer < 0) {
	                utils_1._.doOnce(function () { return console.warn("ag-Grid: rowBuffer should not be negative"); }, 'warn rowBuffer negative');
	                this.gridOptions.rowBuffer = rowBuffer = 0;
	            }
	        }
	        else {
	            rowBuffer = constants_1.Constants.ROW_BUFFER_SIZE;
	        }
	        return rowBuffer;
	    };
	    GridOptionsWrapper.prototype.getRowBufferInPixels = function () {
	        var rowsToBuffer = this.getRowBuffer();
	        var defaultRowHeight = this.getRowHeightAsNumber();
	        return rowsToBuffer * defaultRowHeight;
	    };
	    // the user might be using some non-standard scrollbar, eg a scrollbar that has zero
	    // width and overlays (like the Safari scrollbar, but presented in Chrome). so we
	    // allow the user to provide the scroll width before we work it out.
	    GridOptionsWrapper.prototype.getScrollbarWidth = function () {
	        if (this.scrollWidth == null) {
	            var useGridOptions = typeof this.gridOptions.scrollbarWidth === 'number' &&
	                this.gridOptions.scrollbarWidth >= 0;
	            this.scrollWidth = useGridOptions ? this.gridOptions.scrollbarWidth : utils_1._.getScrollbarWidth();
	        }
	        return this.scrollWidth;
	    };
	    GridOptionsWrapper.prototype.checkForDeprecated = function () {
	        var _this = this;
	        // casting to generic object, so typescript compiles even though
	        // we are looking for attributes that don't exist
	        var options = this.gridOptions;
	        if (options.suppressUnSort) {
	            console.warn('ag-grid: as of v1.12.4 suppressUnSort is not used. Please use sortingOrder instead.');
	        }
	        if (options.suppressDescSort) {
	            console.warn('ag-grid: as of v1.12.4 suppressDescSort is not used. Please use sortingOrder instead.');
	        }
	        if (options.groupAggFields) {
	            console.warn('ag-grid: as of v3 groupAggFields is not used. Please add appropriate agg fields to your columns.');
	        }
	        if (options.groupHidePivotColumns) {
	            console.warn('ag-grid: as of v3 groupHidePivotColumns is not used as pivot columns are now called rowGroup columns. Please refer to the documentation');
	        }
	        if (options.groupKeys) {
	            console.warn('ag-grid: as of v3 groupKeys is not used. You need to set rowGroupIndex on the columns to group. Please refer to the documentation');
	        }
	        if (typeof options.groupDefaultExpanded === 'boolean') {
	            console.warn('ag-grid: groupDefaultExpanded can no longer be boolean. for groupDefaultExpanded=true, use groupDefaultExpanded=9999 instead, to expand all the groups');
	        }
	        if (options.onRowDeselected || options.rowDeselected) {
	            console.warn('ag-grid: since version 3.4 event rowDeselected no longer exists, please check the docs');
	        }
	        if (options.rowsAlreadyGrouped) {
	            console.warn('ag-grid: since version 3.4 rowsAlreadyGrouped no longer exists, please use getNodeChildDetails() instead');
	        }
	        if (options.groupAggFunction) {
	            console.warn('ag-grid: since version 4.3.x groupAggFunction is now called groupRowAggNodes');
	        }
	        if (options.checkboxSelection) {
	            console.warn('ag-grid: since version 8.0.x checkboxSelection is not supported as a grid option. ' +
	                'If you want this on all columns, use defaultColDef instead and set it there');
	        }
	        if (options.paginationInitialRowCount) {
	            console.warn('ag-grid: since version 9.0.x paginationInitialRowCount is now called infiniteInitialRowCount');
	        }
	        if (options.infinitePageSize) {
	            console.warn('ag-grid: since version 9.0.x infinitePageSize is now called cacheBlockSize');
	        }
	        if (options.infiniteBlockSize) {
	            console.warn('ag-grid: since version 10.0.x infiniteBlockSize is now called cacheBlockSize');
	        }
	        if (options.maxPagesInCache) {
	            console.warn('ag-grid: since version 10.0.x maxPagesInCache is now called maxBlocksInCache');
	        }
	        if (options.paginationOverflowSize) {
	            console.warn('ag-grid: since version 10.0.x paginationOverflowSize is now called cacheOverflowSize');
	        }
	        // if (options.forPrint) {
	        //     console.warn('ag-grid: since version 10.1.x, use property domLayout="forPrint" instead of forPrint=true');
	        // }
	        if (options.suppressMenuFilterPanel) {
	            console.warn("ag-grid: since version 11.0.x, use property colDef.menuTabs=['generalMenuTab','columnsMenuTab'] instead of suppressMenuFilterPanel=true");
	        }
	        if (options.suppressMenuMainPanel) {
	            console.warn("ag-grid: since version 11.0.x, use property colDef.menuTabs=['filterMenuTab','columnsMenuTab'] instead of suppressMenuMainPanel=true");
	        }
	        if (options.suppressMenuColumnPanel) {
	            console.warn("ag-grid: since version 11.0.x, use property colDef.menuTabs=['generalMenuTab','filterMenuTab'] instead of suppressMenuColumnPanel=true");
	        }
	        if (options.suppressUseColIdForGroups) {
	            console.warn("ag-grid: since version 11.0.x, this is not in use anymore. You should be able to remove it from your definition");
	        }
	        if (options.groupSuppressRow) {
	            console.warn("ag-grid: since version 18.2.x, 'groupSuppressRow' should not be used anymore. Instead remove row groups and perform custom sorting.");
	        }
	        if (options.groupColumnDef) {
	            console.warn("ag-grid: since version 11.0.x, groupColumnDef has been renamed, this property is now called autoGroupColumnDef. Please change your configuration accordingly");
	        }
	        if (options.slaveGrids) {
	            console.warn("ag-grid: since version 12.x, slaveGrids has been renamed, this property is now called alignedGrids. Please change your configuration accordingly");
	        }
	        if (options.floatingTopRowData) {
	            console.warn("ag-grid: since version 12.x, floatingTopRowData is now called pinnedTopRowData");
	        }
	        if (options.floatingBottomRowData) {
	            console.warn("ag-grid: since version 12.x, floatingBottomRowData is now called pinnedBottomRowData");
	        }
	        if (options.paginationStartPage) {
	            console.warn("ag-grid: since version 12.x, paginationStartPage is gone, please call api.paginationGoToPage(" + options.paginationStartPage + ") instead.");
	        }
	        if (options.getHeaderCellTemplate) {
	            console.warn("ag-grid: since version 15.x, getHeaderCellTemplate is gone, please check the header documentation on how to set header templates.");
	        }
	        if (options.headerCellTemplate) {
	            console.warn("ag-grid: since version 15.x, headerCellTemplate is gone, please check the header documentation on how to set header templates.");
	        }
	        if (options.headerCellRenderer) {
	            console.warn("ag-grid: since version 15.x, headerCellRenderer is gone, please check the header documentation on how to set header templates.");
	        }
	        if (options.angularCompileHeaders) {
	            console.warn("ag-grid: since version 15.x, angularCompileHeaders is gone, please see the getting started for Angular 1 docs to see how to do headers in Angular 1.x.");
	        }
	        if (options.pivotTotals) {
	            console.warn("ag-grid: since version 18.x, pivotTotals has been removed, instead if using pivotTotals, set pivotColumnGroupTotals='before'|'after'.");
	            options.pivotColumnGroupTotals = 'before';
	        }
	        if (options.rowModelType === 'inMemory') {
	            console.warn("ag-grid: since version 18.x, The In Memory Row Model has been renamed to the Client Side Row Model, set rowModelType='clientSide' instead.");
	            options.rowModelType = 'clientSide';
	        }
	        if (options.rowModelType === 'enterprise') {
	            console.warn("ag-grid: since version 18.x, The Enterprise Row Model has been renamed to the Server Side Row Model, set rowModelType='serverSide' instead.");
	            options.rowModelType = 'serverSide';
	        }
	        if (options.layoutInterval) {
	            console.warn("ag-grid: since version 18.x, layoutInterval is no longer a property. This is because the grid now uses CSS Flex for layout.");
	        }
	        if (options.gridAutoHeight) {
	            console.warn("ag-grid: since version 19.x, gridAutoHeight is gone, please use domLayout=autoHeight instead");
	            options.domLayout = 'autoHeight';
	        }
	        if (options.showToolPanel === true) {
	            console.warn("ag-grid: since version 19.x, showToolPanel is gone, please specify toolPanel components. See https://www.ag-grid.com/javascript-grid-tool-panel/");
	            options.showToolPanel = undefined;
	            options.sideBar = options.sideBar || true;
	        }
	        if (options.showToolPanel === false) {
	            console.warn("ag-grid: since version 19.x, showToolPanel is gone, please specify toolPanel components. See https://www.ag-grid.com/javascript-grid-tool-panel/");
	            options.showToolPanel = undefined;
	            options.sideBar = options.sideBar || false;
	        }
	        var oldToolPanelProperties = {
	            toolPanelSuppressRowGroups: 'suppressRowGroups',
	            toolPanelSuppressValues: 'suppressValues',
	            toolPanelSuppressPivots: 'suppressPivots',
	            toolPanelSuppressPivotMode: 'suppressPivotMode',
	            toolPanelSuppressColumnFilter: 'suppressColumnFilter',
	            toolPanelSuppressColumnSelectAll: 'suppressColumnSelectAll',
	            toolPanelSuppressSideButtons: 'suppressSideButtons',
	            toolPanelSuppressColumnExpandAll: 'suppressColumnExpandAll',
	            contractColumnSelection: 'contractColumnSelection'
	        };
	        var toolPanelColumnsCompProps = {};
	        Object.keys(oldToolPanelProperties).forEach(function (key) {
	            var translation = oldToolPanelProperties[key];
	            var value = _this.gridOptions[key];
	            if (value !== undefined) {
	                if (key === 'toolPanelSuppressSideButtons') {
	                    console.warn('ag-grid: since v19.0 toolPanelSuppressSideButtons has been completely removed. See https://www.ag-grid.com/javascript-grid-tool-panel/');
	                    return;
	                }
	                console.warn("ag-grid: since v19.0 gridOptions." + key + " is deprecated, please use gridOptions.sideBar.toolPanel[columnsIndex].componentParams." + translation);
	                toolPanelColumnsCompProps[translation] = value;
	            }
	        });
	        if (Object.keys(toolPanelColumnsCompProps).length > 0 && !utils_1._.exists(options.sideBar)) {
	            console.warn("ag-grid: since version 19.x, sideBar is mandatory if using toolPanel related properties. See https://www.ag-grid.com/javascript-grid-tool-panel/");
	            options.sideBar = true;
	        }
	        if (options.sideBar != null) {
	            options.sideBar = sideBar_1.SideBarDefParser.parse(options.sideBar);
	        }
	        var sideBarDef = this.gridOptions.sideBar;
	        if (Object.keys(toolPanelColumnsCompProps).length > 0 && sideBarDef && sideBarDef.toolPanels) {
	            var columnsDef = (sideBarDef.toolPanels.filter(function (it) { return it.id === 'columns'; }));
	            if (columnsDef.length === 1) {
	                utils_1._.mergeDeep(columnsDef[0], {
	                    componentParams: toolPanelColumnsCompProps
	                });
	            }
	        }
	        if (options.enableStatusBar) {
	            console.warn("ag-grid: since version 19.x, enableStatusBar is gone, please specify statusBar components");
	            options.statusBar = options.statusBar ||
	                {
	                    components: [{ component: 'agAggregationComponent' }]
	                };
	        }
	        if (options.alwaysShowStatusBar) {
	            console.warn("ag-grid: since version 19.x, alwaysShowStatusBar is gone. Please specify a min-height on the ag-status-bar css class, eg .ag-status-bar {min-height: 35px; }");
	        }
	        if (options.enableServerSideSorting || options.enableSorting) {
	            console.warn("ag-Grid: since v20, grid options enableSorting and enableServerSideSorting are gone. Instead set sortable=true on the column definition for the columns sorting are allowed on. To migrate from gridOption.enableSorting=true, set gridOptions.defaultColDef.sortable=true");
	            if (!options.defaultColDef) {
	                options.defaultColDef = {};
	            }
	            if (!options.defaultColDef.sortable) {
	                options.defaultColDef.sortable = true;
	            }
	        }
	        if (options.enableFilter || options.enableServerSideFilter) {
	            console.warn("ag-Grid: since v20, grid options enableFilter and enableServerSideFilter are gone. Instead set filter=true (if not already specifying a specific filter) on the column definition for the columns filtering is allowed on. To migrate from gridOptions.enableFilter=true, set gridOptions.defaultColDef.filter=true. If you are explicitly setting specific filters for each column (ie colDef.filter is already set) the you don't need to do anything.");
	            if (!options.defaultColDef) {
	                options.defaultColDef = {};
	            }
	            if (!options.defaultColDef.filter) {
	                options.defaultColDef.filter = true;
	            }
	        }
	        if (options.enableColResize) {
	            console.warn("ag-Grid: since v20, grid options enableColResize is gone. Instead set resizable=true on the column definition for the columns resizing are allowed on. To migrate from gridOption.enableColResize=true, set gridOptions.defaultColDef.resizable=true");
	            if (!options.defaultColDef) {
	                options.defaultColDef = {};
	            }
	            if (!options.defaultColDef.resizable) {
	                options.defaultColDef.resizable = true;
	            }
	        }
	        if (options.deprecatedEmbedFullWidthRows) {
	            console.warn("ag-Grid: since v21.2, deprecatedEmbedFullWidthRows has been replaced with embedFullWidthRows.");
	        }
	        if (options.suppressTabbing) {
	            console.warn("ag-Grid: since v20.1, suppressTabbing is replaced with the more powerful grid callback suppressKeyboardEvent(params) which can suppress any keyboard event including tabbing.");
	        }
	        if (options.doesDataFlower) {
	            console.warn('ag-Grid: since v21.1, doesDataFlower is deprecated. Master/Detail is the new way for showing child data for a row and was introduced over a year ago. Please migrate your code to use master/detail instead.');
	        }
	    };
	    GridOptionsWrapper.prototype.checkForViolations = function () {
	        if (this.isTreeData()) {
	            this.treeDataViolations();
	        }
	    };
	    GridOptionsWrapper.prototype.treeDataViolations = function () {
	        if (this.isRowModelDefault()) {
	            if (utils_1._.missing(this.getDataPathFunc())) {
	                console.warn('ag-Grid: property usingTreeData=true with rowModel=clientSide, but you did not ' +
	                    'provide getDataPath function, please provide getDataPath function if using tree data.');
	            }
	        }
	        if (this.isRowModelServerSide()) {
	            if (utils_1._.missing(this.getIsServerSideGroupFunc())) {
	                console.warn('ag-Grid: property usingTreeData=true with rowModel=serverSide, but you did not ' +
	                    'provide isServerSideGroup function, please provide isServerSideGroup function if using tree data.');
	            }
	            if (utils_1._.missing(this.getServerSideGroupKeyFunc())) {
	                console.warn('ag-Grid: property usingTreeData=true with rowModel=serverSide, but you did not ' +
	                    'provide getServerSideGroupKey function, please provide getServerSideGroupKey function if using tree data.');
	            }
	        }
	    };
	    GridOptionsWrapper.prototype.getLocaleTextFunc = function () {
	        if (this.gridOptions.localeTextFunc) {
	            return this.gridOptions.localeTextFunc;
	        }
	        var that = this;
	        return function (key, defaultValue) {
	            var localeText = that.gridOptions.localeText;
	            if (localeText && localeText[key]) {
	                return localeText[key];
	            }
	            return defaultValue;
	        };
	    };
	    // responsible for calling the onXXX functions on gridOptions
	    GridOptionsWrapper.prototype.globalEventHandler = function (eventName, event) {
	        var callbackMethodName = componentUtil_1.ComponentUtil.getCallbackForEvent(eventName);
	        if (typeof this.gridOptions[callbackMethodName] === 'function') {
	            this.gridOptions[callbackMethodName](event);
	        }
	    };
	    // we don't allow dynamic row height for virtual paging
	    GridOptionsWrapper.prototype.getRowHeightAsNumber = function () {
	        if (!this.gridOptions.rowHeight || utils_1._.missing(this.gridOptions.rowHeight)) {
	            return this.getDefaultRowHeight();
	        }
	        else if (this.gridOptions.rowHeight && this.isNumeric(this.gridOptions.rowHeight)) {
	            return this.gridOptions.rowHeight;
	        }
	        console.warn('ag-Grid row height must be a number if not using standard row model');
	        return this.getDefaultRowHeight();
	    };
	    GridOptionsWrapper.prototype.getRowHeightForNode = function (rowNode, allowEstimate) {
	        // check the function first, in case use set both function and
	        // number, when using virtual pagination then function can be
	        // used for pinned rows and the number for the body rows.
	        if (allowEstimate === void 0) { allowEstimate = false; }
	        if (typeof this.gridOptions.getRowHeight === 'function') {
	            if (allowEstimate) {
	                return { height: this.getDefaultRowHeight(), estimated: true };
	            }
	            var params = {
	                node: rowNode,
	                data: rowNode.data,
	                api: this.gridOptions.api,
	                context: this.gridOptions.context
	            };
	            return { height: this.gridOptions.getRowHeight(params), estimated: false };
	        }
	        else if (rowNode.detail && this.isMasterDetail()) {
	            if (this.isNumeric(this.gridOptions.detailRowHeight)) {
	                return { height: this.gridOptions.detailRowHeight, estimated: false };
	            }
	            else {
	                return { height: DEFAULT_DETAIL_ROW_HEIGHT, estimated: false };
	            }
	        }
	        var defaultRowHeight = this.getDefaultRowHeight();
	        var rowHeight = this.gridOptions.rowHeight && this.isNumeric(this.gridOptions.rowHeight) ?
	            this.gridOptions.rowHeight : defaultRowHeight;
	        var minRowHeight = Math.min(defaultRowHeight, rowHeight);
	        if (this.columnController.isAutoRowHeightActive()) {
	            if (allowEstimate) {
	                return { height: rowHeight, estimated: true };
	            }
	            var autoHeight = this.autoHeightCalculator.getPreferredHeightForRow(rowNode);
	            // never return less than the default row height - covers when auto height
	            // cells are blank.
	            return { height: Math.max(autoHeight, minRowHeight), estimated: false };
	        }
	        return { height: rowHeight, estimated: false };
	    };
	    GridOptionsWrapper.prototype.isDynamicRowHeight = function () {
	        return typeof this.gridOptions.getRowHeight === 'function';
	    };
	    GridOptionsWrapper.prototype.getVirtualItemHeight = function () {
	        return this.specialForNewMaterial(20, 'virtualItemHeight');
	    };
	    GridOptionsWrapper.prototype.isNumeric = function (value) {
	        return !isNaN(value) && typeof value === 'number';
	    };
	    // Material data table has strict guidelines about whitespace, and these values are different than the ones
	    // ag-grid uses by default. We override the default ones for the sake of making it better out of the box
	    GridOptionsWrapper.prototype.specialForNewMaterial = function (defaultValue, sassVariableName) {
	        var theme = this.environment.getTheme().theme;
	        if (theme && theme.indexOf('ag-theme') === 0) {
	            return this.environment.getSassVariable(theme, sassVariableName);
	        }
	        return defaultValue;
	    };
	    GridOptionsWrapper.prototype.getDefaultRowHeight = function () {
	        return this.specialForNewMaterial(DEFAULT_ROW_HEIGHT, 'rowHeight');
	    };
	    var GridOptionsWrapper_1;
	    GridOptionsWrapper.MIN_COL_WIDTH = 10;
	    GridOptionsWrapper.PROP_HEADER_HEIGHT = 'headerHeight';
	    GridOptionsWrapper.PROP_GROUP_REMOVE_SINGLE_CHILDREN = 'groupRemoveSingleChildren';
	    GridOptionsWrapper.PROP_GROUP_REMOVE_LOWEST_SINGLE_CHILDREN = 'groupRemoveLowestSingleChildren';
	    GridOptionsWrapper.PROP_PIVOT_HEADER_HEIGHT = 'pivotHeaderHeight';
	    GridOptionsWrapper.PROP_SUPPRESS_CLIPBOARD_PASTE = 'suppressClipboardPaste';
	    GridOptionsWrapper.PROP_GROUP_HEADER_HEIGHT = 'groupHeaderHeight';
	    GridOptionsWrapper.PROP_PIVOT_GROUP_HEADER_HEIGHT = 'pivotGroupHeaderHeight';
	    GridOptionsWrapper.PROP_FLOATING_FILTERS_HEIGHT = 'floatingFiltersHeight';
	    GridOptionsWrapper.PROP_SUPPRESS_ROW_DRAG = 'suppressRowDrag';
	    GridOptionsWrapper.PROP_POPUP_PARENT = 'popupParent';
	    GridOptionsWrapper.PROP_DOM_LAYOUT = 'domLayout';
	    __decorate([
	        context_1.Autowired('gridOptions'),
	        __metadata("design:type", Object)
	    ], GridOptionsWrapper.prototype, "gridOptions", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], GridOptionsWrapper.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], GridOptionsWrapper.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('enterprise'),
	        __metadata("design:type", Boolean)
	    ], GridOptionsWrapper.prototype, "enterprise", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], GridOptionsWrapper.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], GridOptionsWrapper.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('environment'),
	        __metadata("design:type", environment_1.Environment)
	    ], GridOptionsWrapper.prototype, "environment", void 0);
	    __decorate([
	        context_1.Autowired('autoHeightCalculator'),
	        __metadata("design:type", autoHeightCalculator_1.AutoHeightCalculator)
	    ], GridOptionsWrapper.prototype, "autoHeightCalculator", void 0);
	    __decorate([
	        context_1.Autowired('context'),
	        __metadata("design:type", context_1.Context)
	    ], GridOptionsWrapper.prototype, "context", void 0);
	    __decorate([
	        __param(0, context_1.Qualifier('gridApi')), __param(1, context_1.Qualifier('columnApi')),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [gridApi_1.GridApi, columnApi_1.ColumnApi]),
	        __metadata("design:returntype", void 0)
	    ], GridOptionsWrapper.prototype, "agWire", null);
	    __decorate([
	        context_1.PreDestroy,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], GridOptionsWrapper.prototype, "destroy", null);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], GridOptionsWrapper.prototype, "init", null);
	    GridOptionsWrapper = GridOptionsWrapper_1 = __decorate([
	        context_1.Bean('gridOptionsWrapper')
	    ], GridOptionsWrapper);
	    return GridOptionsWrapper;
	}());
	exports.GridOptionsWrapper = GridOptionsWrapper;


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.20';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      if (iteratees.length) {
	        iteratees = arrayMap(iteratees, function(iteratee) {
	          if (isArray(iteratee)) {
	            return function(value) {
	              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	            }
	          }
	          return iteratee;
	        });
	      } else {
	        iteratees = [identity];
	      }
	
	      var index = -1;
	      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	          return object;
	        }
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      var low = 0,
	          high = array == null ? 0 : array.length;
	      if (high === 0) {
	        return 0;
	      }
	
	      value = iteratee(value);
	      var valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Check that cyclic values are equal.
	      var arrStacked = stack.get(array);
	      var othStacked = stack.get(other);
	      if (arrStacked && othStacked) {
	        return arrStacked == other && othStacked == array;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Check that cyclic values are equal.
	      var objStacked = stack.get(object);
	      var othStacked = stack.get(other);
	      if (objStacked && othStacked) {
	        return objStacked == other && othStacked == object;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }
	
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     *
	     * // Combining several predicates using `_.overEvery` or `_.overSome`.
	     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	     * // => objects for ['fred', 'barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 30 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
	      // and escape the comment, thus injecting code that gets evaled.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/\s/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     *
	     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
	     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(291)(module)))

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var pathTool = __webpack_require__(1098);
	
	var colorTool = __webpack_require__(114);
	
	var matrix = __webpack_require__(73);
	
	var vector = __webpack_require__(41);
	
	var Path = __webpack_require__(46);
	
	var Transformable = __webpack_require__(389);
	
	var ZImage = __webpack_require__(232);
	
	exports.Image = ZImage;
	
	var Group = __webpack_require__(187);
	
	exports.Group = Group;
	
	var Text = __webpack_require__(188);
	
	exports.Text = Text;
	
	var Circle = __webpack_require__(1093);
	
	exports.Circle = Circle;
	
	var Sector = __webpack_require__(2293);
	
	exports.Sector = Sector;
	
	var Ring = __webpack_require__(2292);
	
	exports.Ring = Ring;
	
	var Polygon = __webpack_require__(1095);
	
	exports.Polygon = Polygon;
	
	var Polyline = __webpack_require__(1096);
	
	exports.Polyline = Polyline;
	
	var Rect = __webpack_require__(561);
	
	exports.Rect = Rect;
	
	var Line = __webpack_require__(1094);
	
	exports.Line = Line;
	
	var BezierCurve = __webpack_require__(2290);
	
	exports.BezierCurve = BezierCurve;
	
	var Arc = __webpack_require__(2289);
	
	exports.Arc = Arc;
	
	var CompoundPath = __webpack_require__(2285);
	
	exports.CompoundPath = CompoundPath;
	
	var LinearGradient = __webpack_require__(557);
	
	exports.LinearGradient = LinearGradient;
	
	var RadialGradient = __webpack_require__(2286);
	
	exports.RadialGradient = RadialGradient;
	
	var BoundingRect = __webpack_require__(42);
	
	exports.BoundingRect = BoundingRect;
	
	var IncrementalDisplayable = __webpack_require__(556);
	
	exports.IncrementalDisplayable = IncrementalDisplayable;
	
	var subPixelOptimizeUtil = __webpack_require__(560);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var mathMax = Math.max;
	var mathMin = Math.min;
	var EMPTY_OBJ = {};
	var Z2_EMPHASIS_LIFT = 1; // key: label model property nane, value: style property name.
	
	var CACHED_LABEL_STYLE_PROPERTIES = {
	  color: 'textFill',
	  textBorderColor: 'textStroke',
	  textBorderWidth: 'textStrokeWidth'
	};
	var EMPHASIS = 'emphasis';
	var NORMAL = 'normal'; // Reserve 0 as default.
	
	var _highlightNextDigit = 1;
	var _highlightKeyMap = {};
	var _customShapeMap = {};
	/**
	 * Extend shape with parameters
	 */
	
	function extendShape(opts) {
	  return Path.extend(opts);
	}
	/**
	 * Extend path
	 */
	
	
	function extendPath(pathData, opts) {
	  return pathTool.extendFromString(pathData, opts);
	}
	/**
	 * Register a user defined shape.
	 * The shape class can be fetched by `getShapeClass`
	 * This method will overwrite the registered shapes, including
	 * the registered built-in shapes, if using the same `name`.
	 * The shape can be used in `custom series` and
	 * `graphic component` by declaring `{type: name}`.
	 *
	 * @param {string} name
	 * @param {Object} ShapeClass Can be generated by `extendShape`.
	 */
	
	
	function registerShape(name, ShapeClass) {
	  _customShapeMap[name] = ShapeClass;
	}
	/**
	 * Find shape class registered by `registerShape`. Usually used in
	 * fetching user defined shape.
	 *
	 * [Caution]:
	 * (1) This method **MUST NOT be used inside echarts !!!**, unless it is prepared
	 * to use user registered shapes.
	 * Because the built-in shape (see `getBuiltInShape`) will be registered by
	 * `registerShape` by default. That enables users to get both built-in
	 * shapes as well as the shapes belonging to themsleves. But users can overwrite
	 * the built-in shapes by using names like 'circle', 'rect' via calling
	 * `registerShape`. So the echarts inner featrues should not fetch shapes from here
	 * in case that it is overwritten by users, except that some features, like
	 * `custom series`, `graphic component`, do it deliberately.
	 *
	 * (2) In the features like `custom series`, `graphic component`, the user input
	 * `{tpye: 'xxx'}` does not only specify shapes but also specify other graphic
	 * elements like `'group'`, `'text'`, `'image'` or event `'path'`. Those names
	 * are reserved names, that is, if some user register a shape named `'image'`,
	 * the shape will not be used. If we intending to add some more reserved names
	 * in feature, that might bring break changes (disable some existing user shape
	 * names). But that case probably rearly happen. So we dont make more mechanism
	 * to resolve this issue here.
	 *
	 * @param {string} name
	 * @return {Object} The shape class. If not found, return nothing.
	 */
	
	
	function getShapeClass(name) {
	  if (_customShapeMap.hasOwnProperty(name)) {
	    return _customShapeMap[name];
	  }
	}
	/**
	 * Create a path element from path data string
	 * @param {string} pathData
	 * @param {Object} opts
	 * @param {module:zrender/core/BoundingRect} rect
	 * @param {string} [layout=cover] 'center' or 'cover'
	 */
	
	
	function makePath(pathData, opts, rect, layout) {
	  var path = pathTool.createFromString(pathData, opts);
	
	  if (rect) {
	    if (layout === 'center') {
	      rect = centerGraphic(rect, path.getBoundingRect());
	    }
	
	    resizePath(path, rect);
	  }
	
	  return path;
	}
	/**
	 * Create a image element from image url
	 * @param {string} imageUrl image url
	 * @param {Object} opts options
	 * @param {module:zrender/core/BoundingRect} rect constrain rect
	 * @param {string} [layout=cover] 'center' or 'cover'
	 */
	
	
	function makeImage(imageUrl, rect, layout) {
	  var path = new ZImage({
	    style: {
	      image: imageUrl,
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height
	    },
	    onload: function (img) {
	      if (layout === 'center') {
	        var boundingRect = {
	          width: img.width,
	          height: img.height
	        };
	        path.setStyle(centerGraphic(rect, boundingRect));
	      }
	    }
	  });
	  return path;
	}
	/**
	 * Get position of centered element in bounding box.
	 *
	 * @param  {Object} rect         element local bounding box
	 * @param  {Object} boundingRect constraint bounding box
	 * @return {Object} element position containing x, y, width, and height
	 */
	
	
	function centerGraphic(rect, boundingRect) {
	  // Set rect to center, keep width / height ratio.
	  var aspect = boundingRect.width / boundingRect.height;
	  var width = rect.height * aspect;
	  var height;
	
	  if (width <= rect.width) {
	    height = rect.height;
	  } else {
	    width = rect.width;
	    height = width / aspect;
	  }
	
	  var cx = rect.x + rect.width / 2;
	  var cy = rect.y + rect.height / 2;
	  return {
	    x: cx - width / 2,
	    y: cy - height / 2,
	    width: width,
	    height: height
	  };
	}
	
	var mergePath = pathTool.mergePath;
	/**
	 * Resize a path to fit the rect
	 * @param {module:zrender/graphic/Path} path
	 * @param {Object} rect
	 */
	
	function resizePath(path, rect) {
	  if (!path.applyTransform) {
	    return;
	  }
	
	  var pathRect = path.getBoundingRect();
	  var m = pathRect.calculateTransform(rect);
	  path.applyTransform(m);
	}
	/**
	 * Sub pixel optimize line for canvas
	 *
	 * @param {Object} param
	 * @param {Object} [param.shape]
	 * @param {number} [param.shape.x1]
	 * @param {number} [param.shape.y1]
	 * @param {number} [param.shape.x2]
	 * @param {number} [param.shape.y2]
	 * @param {Object} [param.style]
	 * @param {number} [param.style.lineWidth]
	 * @return {Object} Modified param
	 */
	
	
	function subPixelOptimizeLine(param) {
	  subPixelOptimizeUtil.subPixelOptimizeLine(param.shape, param.shape, param.style);
	  return param;
	}
	/**
	 * Sub pixel optimize rect for canvas
	 *
	 * @param {Object} param
	 * @param {Object} [param.shape]
	 * @param {number} [param.shape.x]
	 * @param {number} [param.shape.y]
	 * @param {number} [param.shape.width]
	 * @param {number} [param.shape.height]
	 * @param {Object} [param.style]
	 * @param {number} [param.style.lineWidth]
	 * @return {Object} Modified param
	 */
	
	
	function subPixelOptimizeRect(param) {
	  subPixelOptimizeUtil.subPixelOptimizeRect(param.shape, param.shape, param.style);
	  return param;
	}
	/**
	 * Sub pixel optimize for canvas
	 *
	 * @param {number} position Coordinate, such as x, y
	 * @param {number} lineWidth Should be nonnegative integer.
	 * @param {boolean=} positiveOrNegative Default false (negative).
	 * @return {number} Optimized position.
	 */
	
	
	var subPixelOptimize = subPixelOptimizeUtil.subPixelOptimize;
	
	function hasFillOrStroke(fillOrStroke) {
	  return fillOrStroke != null && fillOrStroke !== 'none';
	} // Most lifted color are duplicated.
	
	
	var liftedColorMap = zrUtil.createHashMap();
	var liftedColorCount = 0;
	
	function liftColor(color) {
	  if (typeof color !== 'string') {
	    return color;
	  }
	
	  var liftedColor = liftedColorMap.get(color);
	
	  if (!liftedColor) {
	    liftedColor = colorTool.lift(color, -0.1);
	
	    if (liftedColorCount < 10000) {
	      liftedColorMap.set(color, liftedColor);
	      liftedColorCount++;
	    }
	  }
	
	  return liftedColor;
	}
	
	function cacheElementStl(el) {
	  if (!el.__hoverStlDirty) {
	    return;
	  }
	
	  el.__hoverStlDirty = false;
	  var hoverStyle = el.__hoverStl;
	
	  if (!hoverStyle) {
	    el.__cachedNormalStl = el.__cachedNormalZ2 = null;
	    return;
	  }
	
	  var normalStyle = el.__cachedNormalStl = {};
	  el.__cachedNormalZ2 = el.z2;
	  var elStyle = el.style;
	
	  for (var name in hoverStyle) {
	    // See comment in `singleEnterEmphasis`.
	    if (hoverStyle[name] != null) {
	      normalStyle[name] = elStyle[name];
	    }
	  } // Always cache fill and stroke to normalStyle for lifting color.
	
	
	  normalStyle.fill = elStyle.fill;
	  normalStyle.stroke = elStyle.stroke;
	}
	
	function singleEnterEmphasis(el) {
	  var hoverStl = el.__hoverStl;
	
	  if (!hoverStl || el.__highlighted) {
	    return;
	  }
	
	  var zr = el.__zr;
	  var useHoverLayer = el.useHoverLayer && zr && zr.painter.type === 'canvas';
	  el.__highlighted = useHoverLayer ? 'layer' : 'plain';
	
	  if (el.isGroup || !zr && el.useHoverLayer) {
	    return;
	  }
	
	  var elTarget = el;
	  var targetStyle = el.style;
	
	  if (useHoverLayer) {
	    elTarget = zr.addHover(el);
	    targetStyle = elTarget.style;
	  }
	
	  rollbackDefaultTextStyle(targetStyle);
	
	  if (!useHoverLayer) {
	    cacheElementStl(elTarget);
	  } // styles can be:
	  // {
	  //    label: {
	  //        show: false,
	  //        position: 'outside',
	  //        fontSize: 18
	  //    },
	  //    emphasis: {
	  //        label: {
	  //            show: true
	  //        }
	  //    }
	  // },
	  // where properties of `emphasis` may not appear in `normal`. We previously use
	  // module:echarts/util/model#defaultEmphasis to merge `normal` to `emphasis`.
	  // But consider rich text and setOption in merge mode, it is impossible to cover
	  // all properties in merge. So we use merge mode when setting style here.
	  // But we choose the merge strategy that only properties that is not `null/undefined`.
	  // Because when making a textStyle (espacially rich text), it is not easy to distinguish
	  // `hasOwnProperty` and `null/undefined` in code, so we trade them as the same for simplicity.
	  // But this strategy brings a trouble that `null/undefined` can not be used to remove
	  // style any more in `emphasis`. Users can both set properties directly on normal and
	  // emphasis to avoid this issue, or we might support `'none'` for this case if required.
	
	
	  targetStyle.extendFrom(hoverStl);
	  setDefaultHoverFillStroke(targetStyle, hoverStl, 'fill');
	  setDefaultHoverFillStroke(targetStyle, hoverStl, 'stroke');
	  applyDefaultTextStyle(targetStyle);
	
	  if (!useHoverLayer) {
	    el.dirty(false);
	    el.z2 += Z2_EMPHASIS_LIFT;
	  }
	}
	
	function setDefaultHoverFillStroke(targetStyle, hoverStyle, prop) {
	  if (!hasFillOrStroke(hoverStyle[prop]) && hasFillOrStroke(targetStyle[prop])) {
	    targetStyle[prop] = liftColor(targetStyle[prop]);
	  }
	}
	
	function singleEnterNormal(el) {
	  var highlighted = el.__highlighted;
	
	  if (!highlighted) {
	    return;
	  }
	
	  el.__highlighted = false;
	
	  if (el.isGroup) {
	    return;
	  }
	
	  if (highlighted === 'layer') {
	    el.__zr && el.__zr.removeHover(el);
	  } else {
	    var style = el.style;
	    var normalStl = el.__cachedNormalStl;
	
	    if (normalStl) {
	      rollbackDefaultTextStyle(style);
	      el.setStyle(normalStl);
	      applyDefaultTextStyle(style);
	    } // `__cachedNormalZ2` will not be reset if calling `setElementHoverStyle`
	    // when `el` is on emphasis state. So here by comparing with 1, we try
	    // hard to make the bug case rare.
	
	
	    var normalZ2 = el.__cachedNormalZ2;
	
	    if (normalZ2 != null && el.z2 - normalZ2 === Z2_EMPHASIS_LIFT) {
	      el.z2 = normalZ2;
	    }
	  }
	}
	
	function traverseUpdate(el, updater, commonParam) {
	  // If root is group, also enter updater for `highDownOnUpdate`.
	  var fromState = NORMAL;
	  var toState = NORMAL;
	  var trigger; // See the rule of `highDownOnUpdate` on `graphic.setAsHighDownDispatcher`.
	
	  el.__highlighted && (fromState = EMPHASIS, trigger = true);
	  updater(el, commonParam);
	  el.__highlighted && (toState = EMPHASIS, trigger = true);
	  el.isGroup && el.traverse(function (child) {
	    !child.isGroup && updater(child, commonParam);
	  });
	  trigger && el.__highDownOnUpdate && el.__highDownOnUpdate(fromState, toState);
	}
	/**
	 * Set hover style (namely "emphasis style") of element, based on the current
	 * style of the given `el`.
	 * This method should be called after all of the normal styles have been adopted
	 * to the `el`. See the reason on `setHoverStyle`.
	 *
	 * @param {module:zrender/Element} el Should not be `zrender/container/Group`.
	 * @param {Object} [el.hoverStyle] Can be set on el or its descendants,
	 *        e.g., `el.hoverStyle = ...; graphic.setHoverStyle(el); `.
	 *        Often used when item group has a label element and it's hoverStyle is different.
	 * @param {Object|boolean} [hoverStl] The specified hover style.
	 *        If set as `false`, disable the hover style.
	 *        Similarly, The `el.hoverStyle` can alse be set
	 *        as `false` to disable the hover style.
	 *        Otherwise, use the default hover style if not provided.
	 */
	
	
	function setElementHoverStyle(el, hoverStl) {
	  // For performance consideration, it might be better to make the "hover style" only the
	  // difference properties from the "normal style", but not a entire copy of all styles.
	  hoverStl = el.__hoverStl = hoverStl !== false && (el.hoverStyle || hoverStl || {});
	  el.__hoverStlDirty = true; // FIXME
	  // It is not completely right to save "normal"/"emphasis" flag on elements.
	  // It probably should be saved on `data` of series. Consider the cases:
	  // (1) A highlighted elements are moved out of the view port and re-enter
	  // again by dataZoom.
	  // (2) call `setOption` and replace elements totally when they are highlighted.
	
	  if (el.__highlighted) {
	    // Consider the case:
	    // The styles of a highlighted `el` is being updated. The new "emphasis style"
	    // should be adapted to the `el`. Notice here new "normal styles" should have
	    // been set outside and the cached "normal style" is out of date.
	    el.__cachedNormalStl = null; // Do not clear `__cachedNormalZ2` here, because setting `z2` is not a constraint
	    // of this method. In most cases, `z2` is not set and hover style should be able
	    // to rollback. Of course, that would bring bug, but only in a rare case, see
	    // `doSingleLeaveHover` for details.
	
	    singleEnterNormal(el);
	    singleEnterEmphasis(el);
	  }
	}
	
	function onElementMouseOver(e) {
	  !shouldSilent(this, e) // "emphasis" event highlight has higher priority than mouse highlight.
	  && !this.__highByOuter && traverseUpdate(this, singleEnterEmphasis);
	}
	
	function onElementMouseOut(e) {
	  !shouldSilent(this, e) // "emphasis" event highlight has higher priority than mouse highlight.
	  && !this.__highByOuter && traverseUpdate(this, singleEnterNormal);
	}
	
	function onElementEmphasisEvent(highlightDigit) {
	  this.__highByOuter |= 1 << (highlightDigit || 0);
	  traverseUpdate(this, singleEnterEmphasis);
	}
	
	function onElementNormalEvent(highlightDigit) {
	  !(this.__highByOuter &= ~(1 << (highlightDigit || 0))) && traverseUpdate(this, singleEnterNormal);
	}
	
	function shouldSilent(el, e) {
	  return el.__highDownSilentOnTouch && e.zrByTouch;
	}
	/**
	 * Set hover style (namely "emphasis style") of element,
	 * based on the current style of the given `el`.
	 *
	 * (1)
	 * **CONSTRAINTS** for this method:
	 * <A> This method MUST be called after all of the normal styles having been adopted
	 * to the `el`.
	 * <B> The input `hoverStyle` (that is, "emphasis style") MUST be the subset of the
	 * "normal style" having been set to the el.
	 * <C> `color` MUST be one of the "normal styles" (because color might be lifted as
	 * a default hover style).
	 *
	 * The reason: this method treat the current style of the `el` as the "normal style"
	 * and cache them when enter/update the "emphasis style". Consider the case: the `el`
	 * is in "emphasis" state and `setOption`/`dispatchAction` trigger the style updating
	 * logic, where the el should shift from the original emphasis style to the new
	 * "emphasis style" and should be able to "downplay" back to the new "normal style".
	 *
	 * Indeed, it is error-prone to make a interface has so many constraints, but I have
	 * not found a better solution yet to fit the backward compatibility, performance and
	 * the current programming style.
	 *
	 * (2)
	 * Call the method for a "root" element once. Do not call it for each descendants.
	 * If the descendants elemenets of a group has itself hover style different from the
	 * root group, we can simply mount the style on `el.hoverStyle` for them, but should
	 * not call this method for them.
	 *
	 * (3) These input parameters can be set directly on `el`:
	 *
	 * @param {module:zrender/Element} el
	 * @param {Object} [el.hoverStyle] See `graphic.setElementHoverStyle`.
	 * @param {boolean} [el.highDownSilentOnTouch=false] See `graphic.setAsHighDownDispatcher`.
	 * @param {Function} [el.highDownOnUpdate] See `graphic.setAsHighDownDispatcher`.
	 * @param {Object|boolean} [hoverStyle] See `graphic.setElementHoverStyle`.
	 */
	
	
	function setHoverStyle(el, hoverStyle) {
	  setAsHighDownDispatcher(el, true);
	  traverseUpdate(el, setElementHoverStyle, hoverStyle);
	}
	/**
	 * @param {module:zrender/Element} el
	 * @param {Function} [el.highDownOnUpdate] Called when state updated.
	 *        Since `setHoverStyle` has the constraint that it must be called after
	 *        all of the normal style updated, `highDownOnUpdate` is not needed to
	 *        trigger if both `fromState` and `toState` is 'normal', and needed to
	 *        trigger if both `fromState` and `toState` is 'emphasis', which enables
	 *        to sync outside style settings to "emphasis" state.
	 *        @this {string} This dispatcher `el`.
	 *        @param {string} fromState Can be "normal" or "emphasis".
	 *               `fromState` might equal to `toState`,
	 *               for example, when this method is called when `el` is
	 *               on "emphasis" state.
	 *        @param {string} toState Can be "normal" or "emphasis".
	 *
	 *        FIXME
	 *        CAUTION: Do not expose `highDownOnUpdate` outside echarts.
	 *        Because it is not a complete solution. The update
	 *        listener should not have been mount in element,
	 *        and the normal/emphasis state should not have
	 *        mantained on elements.
	 *
	 * @param {boolean} [el.highDownSilentOnTouch=false]
	 *        In touch device, mouseover event will be trigger on touchstart event
	 *        (see module:zrender/dom/HandlerProxy). By this mechanism, we can
	 *        conveniently use hoverStyle when tap on touch screen without additional
	 *        code for compatibility.
	 *        But if the chart/component has select feature, which usually also use
	 *        hoverStyle, there might be conflict between 'select-highlight' and
	 *        'hover-highlight' especially when roam is enabled (see geo for example).
	 *        In this case, `highDownSilentOnTouch` should be used to disable
	 *        hover-highlight on touch device.
	 * @param {boolean} [asDispatcher=true] If `false`, do not set as "highDownDispatcher".
	 */
	
	
	function setAsHighDownDispatcher(el, asDispatcher) {
	  var disable = asDispatcher === false; // Make `highDownSilentOnTouch` and `highDownOnUpdate` only work after
	  // `setAsHighDownDispatcher` called. Avoid it is modified by user unexpectedly.
	
	  el.__highDownSilentOnTouch = el.highDownSilentOnTouch;
	  el.__highDownOnUpdate = el.highDownOnUpdate; // Simple optimize, since this method might be
	  // called for each elements of a group in some cases.
	
	  if (!disable || el.__highDownDispatcher) {
	    var method = disable ? 'off' : 'on'; // Duplicated function will be auto-ignored, see Eventful.js.
	
	    el[method]('mouseover', onElementMouseOver)[method]('mouseout', onElementMouseOut); // Emphasis, normal can be triggered manually by API or other components like hover link.
	
	    el[method]('emphasis', onElementEmphasisEvent)[method]('normal', onElementNormalEvent); // Also keep previous record.
	
	    el.__highByOuter = el.__highByOuter || 0;
	    el.__highDownDispatcher = !disable;
	  }
	}
	/**
	 * @param {module:zrender/src/Element} el
	 * @return {boolean}
	 */
	
	
	function isHighDownDispatcher(el) {
	  return !!(el && el.__highDownDispatcher);
	}
	/**
	 * Support hightlight/downplay record on each elements.
	 * For the case: hover highlight/downplay (legend, visualMap, ...) and
	 * user triggerred hightlight/downplay should not conflict.
	 * Only all of the highlightDigit cleared, return to normal.
	 * @param {string} highlightKey
	 * @return {number} highlightDigit
	 */
	
	
	function getHighlightDigit(highlightKey) {
	  var highlightDigit = _highlightKeyMap[highlightKey];
	
	  if (highlightDigit == null && _highlightNextDigit <= 32) {
	    highlightDigit = _highlightKeyMap[highlightKey] = _highlightNextDigit++;
	  }
	
	  return highlightDigit;
	}
	/**
	 * See more info in `setTextStyleCommon`.
	 * @param {Object|module:zrender/graphic/Style} normalStyle
	 * @param {Object} emphasisStyle
	 * @param {module:echarts/model/Model} normalModel
	 * @param {module:echarts/model/Model} emphasisModel
	 * @param {Object} opt Check `opt` of `setTextStyleCommon` to find other props.
	 * @param {string|Function} [opt.defaultText]
	 * @param {module:echarts/model/Model} [opt.labelFetcher] Fetch text by
	 *      `opt.labelFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex, opt.labelProp)`
	 * @param {number} [opt.labelDataIndex] Fetch text by
	 *      `opt.textFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex, opt.labelProp)`
	 * @param {number} [opt.labelDimIndex] Fetch text by
	 *      `opt.textFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex, opt.labelProp)`
	 * @param {string} [opt.labelProp] Fetch text by
	 *      `opt.textFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex, opt.labelProp)`
	 * @param {Object} [normalSpecified]
	 * @param {Object} [emphasisSpecified]
	 */
	
	
	function setLabelStyle(normalStyle, emphasisStyle, normalModel, emphasisModel, opt, normalSpecified, emphasisSpecified) {
	  opt = opt || EMPTY_OBJ;
	  var labelFetcher = opt.labelFetcher;
	  var labelDataIndex = opt.labelDataIndex;
	  var labelDimIndex = opt.labelDimIndex;
	  var labelProp = opt.labelProp; // This scenario, `label.normal.show = true; label.emphasis.show = false`,
	  // is not supported util someone requests.
	
	  var showNormal = normalModel.getShallow('show');
	  var showEmphasis = emphasisModel.getShallow('show'); // Consider performance, only fetch label when necessary.
	  // If `normal.show` is `false` and `emphasis.show` is `true` and `emphasis.formatter` is not set,
	  // label should be displayed, where text is fetched by `normal.formatter` or `opt.defaultText`.
	
	  var baseText;
	
	  if (showNormal || showEmphasis) {
	    if (labelFetcher) {
	      baseText = labelFetcher.getFormattedLabel(labelDataIndex, 'normal', null, labelDimIndex, labelProp);
	    }
	
	    if (baseText == null) {
	      baseText = zrUtil.isFunction(opt.defaultText) ? opt.defaultText(labelDataIndex, opt) : opt.defaultText;
	    }
	  }
	
	  var normalStyleText = showNormal ? baseText : null;
	  var emphasisStyleText = showEmphasis ? zrUtil.retrieve2(labelFetcher ? labelFetcher.getFormattedLabel(labelDataIndex, 'emphasis', null, labelDimIndex, labelProp) : null, baseText) : null; // Optimize: If style.text is null, text will not be drawn.
	
	  if (normalStyleText != null || emphasisStyleText != null) {
	    // Always set `textStyle` even if `normalStyle.text` is null, because default
	    // values have to be set on `normalStyle`.
	    // If we set default values on `emphasisStyle`, consider case:
	    // Firstly, `setOption(... label: {normal: {text: null}, emphasis: {show: true}} ...);`
	    // Secondly, `setOption(... label: {noraml: {show: true, text: 'abc', color: 'red'} ...);`
	    // Then the 'red' will not work on emphasis.
	    setTextStyle(normalStyle, normalModel, normalSpecified, opt);
	    setTextStyle(emphasisStyle, emphasisModel, emphasisSpecified, opt, true);
	  }
	
	  normalStyle.text = normalStyleText;
	  emphasisStyle.text = emphasisStyleText;
	}
	/**
	 * Modify label style manually.
	 * Only works after `setLabelStyle` and `setElementHoverStyle` called.
	 *
	 * @param {module:zrender/src/Element} el
	 * @param {Object} [normalStyleProps] optional
	 * @param {Object} [emphasisStyleProps] optional
	 */
	
	
	function modifyLabelStyle(el, normalStyleProps, emphasisStyleProps) {
	  var elStyle = el.style;
	
	  if (normalStyleProps) {
	    rollbackDefaultTextStyle(elStyle);
	    el.setStyle(normalStyleProps);
	    applyDefaultTextStyle(elStyle);
	  }
	
	  elStyle = el.__hoverStl;
	
	  if (emphasisStyleProps && elStyle) {
	    rollbackDefaultTextStyle(elStyle);
	    zrUtil.extend(elStyle, emphasisStyleProps);
	    applyDefaultTextStyle(elStyle);
	  }
	}
	/**
	 * Set basic textStyle properties.
	 * See more info in `setTextStyleCommon`.
	 * @param {Object|module:zrender/graphic/Style} textStyle
	 * @param {module:echarts/model/Model} model
	 * @param {Object} [specifiedTextStyle] Can be overrided by settings in model.
	 * @param {Object} [opt] See `opt` of `setTextStyleCommon`.
	 * @param {boolean} [isEmphasis]
	 */
	
	
	function setTextStyle(textStyle, textStyleModel, specifiedTextStyle, opt, isEmphasis) {
	  setTextStyleCommon(textStyle, textStyleModel, opt, isEmphasis);
	  specifiedTextStyle && zrUtil.extend(textStyle, specifiedTextStyle); // textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
	
	  return textStyle;
	}
	/**
	 * Set text option in the style.
	 * See more info in `setTextStyleCommon`.
	 * @deprecated
	 * @param {Object} textStyle
	 * @param {module:echarts/model/Model} labelModel
	 * @param {string|boolean} defaultColor Default text color.
	 *        If set as false, it will be processed as a emphasis style.
	 */
	
	
	function setText(textStyle, labelModel, defaultColor) {
	  var opt = {
	    isRectText: true
	  };
	  var isEmphasis;
	
	  if (defaultColor === false) {
	    isEmphasis = true;
	  } else {
	    // Support setting color as 'auto' to get visual color.
	    opt.autoColor = defaultColor;
	  }
	
	  setTextStyleCommon(textStyle, labelModel, opt, isEmphasis); // textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
	}
	/**
	 * The uniform entry of set text style, that is, retrieve style definitions
	 * from `model` and set to `textStyle` object.
	 *
	 * Never in merge mode, but in overwrite mode, that is, all of the text style
	 * properties will be set. (Consider the states of normal and emphasis and
	 * default value can be adopted, merge would make the logic too complicated
	 * to manage.)
	 *
	 * The `textStyle` object can either be a plain object or an instance of
	 * `zrender/src/graphic/Style`, and either be the style of normal or emphasis.
	 * After this mothod called, the `textStyle` object can then be used in
	 * `el.setStyle(textStyle)` or `el.hoverStyle = textStyle`.
	 *
	 * Default value will be adopted and `insideRollbackOpt` will be created.
	 * See `applyDefaultTextStyle` `rollbackDefaultTextStyle` for more details.
	 *
	 * opt: {
	 *      disableBox: boolean, Whether diable drawing box of block (outer most).
	 *      isRectText: boolean,
	 *      autoColor: string, specify a color when color is 'auto',
	 *              for textFill, textStroke, textBackgroundColor, and textBorderColor.
	 *              If autoColor specified, it is used as default textFill.
	 *      useInsideStyle:
	 *              `true`: Use inside style (textFill, textStroke, textStrokeWidth)
	 *                  if `textFill` is not specified.
	 *              `false`: Do not use inside style.
	 *              `null/undefined`: use inside style if `isRectText` is true and
	 *                  `textFill` is not specified and textPosition contains `'inside'`.
	 *      forceRich: boolean
	 * }
	 */
	
	
	function setTextStyleCommon(textStyle, textStyleModel, opt, isEmphasis) {
	  // Consider there will be abnormal when merge hover style to normal style if given default value.
	  opt = opt || EMPTY_OBJ;
	
	  if (opt.isRectText) {
	    var textPosition;
	
	    if (opt.getTextPosition) {
	      textPosition = opt.getTextPosition(textStyleModel, isEmphasis);
	    } else {
	      textPosition = textStyleModel.getShallow('position') || (isEmphasis ? null : 'inside'); // 'outside' is not a valid zr textPostion value, but used
	      // in bar series, and magric type should be considered.
	
	      textPosition === 'outside' && (textPosition = 'top');
	    }
	
	    textStyle.textPosition = textPosition;
	    textStyle.textOffset = textStyleModel.getShallow('offset');
	    var labelRotate = textStyleModel.getShallow('rotate');
	    labelRotate != null && (labelRotate *= Math.PI / 180);
	    textStyle.textRotation = labelRotate;
	    textStyle.textDistance = zrUtil.retrieve2(textStyleModel.getShallow('distance'), isEmphasis ? null : 5);
	  }
	
	  var ecModel = textStyleModel.ecModel;
	  var globalTextStyle = ecModel && ecModel.option.textStyle; // Consider case:
	  // {
	  //     data: [{
	  //         value: 12,
	  //         label: {
	  //             rich: {
	  //                 // no 'a' here but using parent 'a'.
	  //             }
	  //         }
	  //     }],
	  //     rich: {
	  //         a: { ... }
	  //     }
	  // }
	
	  var richItemNames = getRichItemNames(textStyleModel);
	  var richResult;
	
	  if (richItemNames) {
	    richResult = {};
	
	    for (var name in richItemNames) {
	      if (richItemNames.hasOwnProperty(name)) {
	        // Cascade is supported in rich.
	        var richTextStyle = textStyleModel.getModel(['rich', name]); // In rich, never `disableBox`.
	        // FIXME: consider `label: {formatter: '{a|xx}', color: 'blue', rich: {a: {}}}`,
	        // the default color `'blue'` will not be adopted if no color declared in `rich`.
	        // That might confuses users. So probably we should put `textStyleModel` as the
	        // root ancestor of the `richTextStyle`. But that would be a break change.
	
	        setTokenTextStyle(richResult[name] = {}, richTextStyle, globalTextStyle, opt, isEmphasis);
	      }
	    }
	  }
	
	  textStyle.rich = richResult;
	  setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isEmphasis, true);
	
	  if (opt.forceRich && !opt.textStyle) {
	    opt.textStyle = {};
	  }
	
	  return textStyle;
	} // Consider case:
	// {
	//     data: [{
	//         value: 12,
	//         label: {
	//             rich: {
	//                 // no 'a' here but using parent 'a'.
	//             }
	//         }
	//     }],
	//     rich: {
	//         a: { ... }
	//     }
	// }
	
	
	function getRichItemNames(textStyleModel) {
	  // Use object to remove duplicated names.
	  var richItemNameMap;
	
	  while (textStyleModel && textStyleModel !== textStyleModel.ecModel) {
	    var rich = (textStyleModel.option || EMPTY_OBJ).rich;
	
	    if (rich) {
	      richItemNameMap = richItemNameMap || {};
	
	      for (var name in rich) {
	        if (rich.hasOwnProperty(name)) {
	          richItemNameMap[name] = 1;
	        }
	      }
	    }
	
	    textStyleModel = textStyleModel.parentModel;
	  }
	
	  return richItemNameMap;
	}
	
	function setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isEmphasis, isBlock) {
	  // In merge mode, default value should not be given.
	  globalTextStyle = !isEmphasis && globalTextStyle || EMPTY_OBJ;
	  textStyle.textFill = getAutoColor(textStyleModel.getShallow('color'), opt) || globalTextStyle.color;
	  textStyle.textStroke = getAutoColor(textStyleModel.getShallow('textBorderColor'), opt) || globalTextStyle.textBorderColor;
	  textStyle.textStrokeWidth = zrUtil.retrieve2(textStyleModel.getShallow('textBorderWidth'), globalTextStyle.textBorderWidth);
	
	  if (!isEmphasis) {
	    if (isBlock) {
	      textStyle.insideRollbackOpt = opt;
	      applyDefaultTextStyle(textStyle);
	    } // Set default finally.
	
	
	    if (textStyle.textFill == null) {
	      textStyle.textFill = opt.autoColor;
	    }
	  } // Do not use `getFont` here, because merge should be supported, where
	  // part of these properties may be changed in emphasis style, and the
	  // others should remain their original value got from normal style.
	
	
	  textStyle.fontStyle = textStyleModel.getShallow('fontStyle') || globalTextStyle.fontStyle;
	  textStyle.fontWeight = textStyleModel.getShallow('fontWeight') || globalTextStyle.fontWeight;
	  textStyle.fontSize = textStyleModel.getShallow('fontSize') || globalTextStyle.fontSize;
	  textStyle.fontFamily = textStyleModel.getShallow('fontFamily') || globalTextStyle.fontFamily;
	  textStyle.textAlign = textStyleModel.getShallow('align');
	  textStyle.textVerticalAlign = textStyleModel.getShallow('verticalAlign') || textStyleModel.getShallow('baseline');
	  textStyle.textLineHeight = textStyleModel.getShallow('lineHeight');
	  textStyle.textWidth = textStyleModel.getShallow('width');
	  textStyle.textHeight = textStyleModel.getShallow('height');
	  textStyle.textTag = textStyleModel.getShallow('tag');
	
	  if (!isBlock || !opt.disableBox) {
	    textStyle.textBackgroundColor = getAutoColor(textStyleModel.getShallow('backgroundColor'), opt);
	    textStyle.textPadding = textStyleModel.getShallow('padding');
	    textStyle.textBorderColor = getAutoColor(textStyleModel.getShallow('borderColor'), opt);
	    textStyle.textBorderWidth = textStyleModel.getShallow('borderWidth');
	    textStyle.textBorderRadius = textStyleModel.getShallow('borderRadius');
	    textStyle.textBoxShadowColor = textStyleModel.getShallow('shadowColor');
	    textStyle.textBoxShadowBlur = textStyleModel.getShallow('shadowBlur');
	    textStyle.textBoxShadowOffsetX = textStyleModel.getShallow('shadowOffsetX');
	    textStyle.textBoxShadowOffsetY = textStyleModel.getShallow('shadowOffsetY');
	  }
	
	  textStyle.textShadowColor = textStyleModel.getShallow('textShadowColor') || globalTextStyle.textShadowColor;
	  textStyle.textShadowBlur = textStyleModel.getShallow('textShadowBlur') || globalTextStyle.textShadowBlur;
	  textStyle.textShadowOffsetX = textStyleModel.getShallow('textShadowOffsetX') || globalTextStyle.textShadowOffsetX;
	  textStyle.textShadowOffsetY = textStyleModel.getShallow('textShadowOffsetY') || globalTextStyle.textShadowOffsetY;
	}
	
	function getAutoColor(color, opt) {
	  return color !== 'auto' ? color : opt && opt.autoColor ? opt.autoColor : null;
	}
	/**
	 * Give some default value to the input `textStyle` object, based on the current settings
	 * in this `textStyle` object.
	 *
	 * The Scenario:
	 * when text position is `inside` and `textFill` is not specified, we show
	 * text border by default for better view. But it should be considered that text position
	 * might be changed when hovering or being emphasis, where the `insideRollback` is used to
	 * restore the style.
	 *
	 * Usage (& NOTICE):
	 * When a style object (eithor plain object or instance of `zrender/src/graphic/Style`) is
	 * about to be modified on its text related properties, `rollbackDefaultTextStyle` should
	 * be called before the modification and `applyDefaultTextStyle` should be called after that.
	 * (For the case that all of the text related properties is reset, like `setTextStyleCommon`
	 * does, `rollbackDefaultTextStyle` is not needed to be called).
	 */
	
	
	function applyDefaultTextStyle(textStyle) {
	  var textPosition = textStyle.textPosition;
	  var opt = textStyle.insideRollbackOpt;
	  var insideRollback;
	
	  if (opt && textStyle.textFill == null) {
	    var autoColor = opt.autoColor;
	    var isRectText = opt.isRectText;
	    var useInsideStyle = opt.useInsideStyle;
	    var useInsideStyleCache = useInsideStyle !== false && (useInsideStyle === true || isRectText && textPosition // textPosition can be [10, 30]
	    && typeof textPosition === 'string' && textPosition.indexOf('inside') >= 0);
	    var useAutoColorCache = !useInsideStyleCache && autoColor != null; // All of the props declared in `CACHED_LABEL_STYLE_PROPERTIES` are to be cached.
	
	    if (useInsideStyleCache || useAutoColorCache) {
	      insideRollback = {
	        textFill: textStyle.textFill,
	        textStroke: textStyle.textStroke,
	        textStrokeWidth: textStyle.textStrokeWidth
	      };
	    }
	
	    if (useInsideStyleCache) {
	      textStyle.textFill = '#fff'; // Consider text with #fff overflow its container.
	
	      if (textStyle.textStroke == null) {
	        textStyle.textStroke = autoColor;
	        textStyle.textStrokeWidth == null && (textStyle.textStrokeWidth = 2);
	      }
	    }
	
	    if (useAutoColorCache) {
	      textStyle.textFill = autoColor;
	    }
	  } // Always set `insideRollback`, so that the previous one can be cleared.
	
	
	  textStyle.insideRollback = insideRollback;
	}
	/**
	 * Consider the case: in a scatter,
	 * label: {
	 *     normal: {position: 'inside'},
	 *     emphasis: {position: 'top'}
	 * }
	 * In the normal state, the `textFill` will be set as '#fff' for pretty view (see
	 * `applyDefaultTextStyle`), but when switching to emphasis state, the `textFill`
	 * should be retured to 'autoColor', but not keep '#fff'.
	 */
	
	
	function rollbackDefaultTextStyle(style) {
	  var insideRollback = style.insideRollback;
	
	  if (insideRollback) {
	    // Reset all of the props in `CACHED_LABEL_STYLE_PROPERTIES`.
	    style.textFill = insideRollback.textFill;
	    style.textStroke = insideRollback.textStroke;
	    style.textStrokeWidth = insideRollback.textStrokeWidth;
	    style.insideRollback = null;
	  }
	}
	
	function getFont(opt, ecModel) {
	  var gTextStyleModel = ecModel && ecModel.getModel('textStyle');
	  return zrUtil.trim([// FIXME in node-canvas fontWeight is before fontStyle
	  opt.fontStyle || gTextStyleModel && gTextStyleModel.getShallow('fontStyle') || '', opt.fontWeight || gTextStyleModel && gTextStyleModel.getShallow('fontWeight') || '', (opt.fontSize || gTextStyleModel && gTextStyleModel.getShallow('fontSize') || 12) + 'px', opt.fontFamily || gTextStyleModel && gTextStyleModel.getShallow('fontFamily') || 'sans-serif'].join(' '));
	}
	
	function animateOrSetProps(isUpdate, el, props, animatableModel, dataIndex, cb) {
	  if (typeof dataIndex === 'function') {
	    cb = dataIndex;
	    dataIndex = null;
	  } // Do not check 'animation' property directly here. Consider this case:
	  // animation model is an `itemModel`, whose does not have `isAnimationEnabled`
	  // but its parent model (`seriesModel`) does.
	
	
	  var animationEnabled = animatableModel && animatableModel.isAnimationEnabled();
	
	  if (animationEnabled) {
	    var postfix = isUpdate ? 'Update' : '';
	    var duration = animatableModel.getShallow('animationDuration' + postfix);
	    var animationEasing = animatableModel.getShallow('animationEasing' + postfix);
	    var animationDelay = animatableModel.getShallow('animationDelay' + postfix);
	
	    if (typeof animationDelay === 'function') {
	      animationDelay = animationDelay(dataIndex, animatableModel.getAnimationDelayParams ? animatableModel.getAnimationDelayParams(el, dataIndex) : null);
	    }
	
	    if (typeof duration === 'function') {
	      duration = duration(dataIndex);
	    }
	
	    duration > 0 ? el.animateTo(props, duration, animationDelay || 0, animationEasing, cb, !!cb) : (el.stopAnimation(), el.attr(props), cb && cb());
	  } else {
	    el.stopAnimation();
	    el.attr(props);
	    cb && cb();
	  }
	}
	/**
	 * Update graphic element properties with or without animation according to the
	 * configuration in series.
	 *
	 * Caution: this method will stop previous animation.
	 * So do not use this method to one element twice before
	 * animation starts, unless you know what you are doing.
	 *
	 * @param {module:zrender/Element} el
	 * @param {Object} props
	 * @param {module:echarts/model/Model} [animatableModel]
	 * @param {number} [dataIndex]
	 * @param {Function} [cb]
	 * @example
	 *     graphic.updateProps(el, {
	 *         position: [100, 100]
	 *     }, seriesModel, dataIndex, function () { console.log('Animation done!'); });
	 *     // Or
	 *     graphic.updateProps(el, {
	 *         position: [100, 100]
	 *     }, seriesModel, function () { console.log('Animation done!'); });
	 */
	
	
	function updateProps(el, props, animatableModel, dataIndex, cb) {
	  animateOrSetProps(true, el, props, animatableModel, dataIndex, cb);
	}
	/**
	 * Init graphic element properties with or without animation according to the
	 * configuration in series.
	 *
	 * Caution: this method will stop previous animation.
	 * So do not use this method to one element twice before
	 * animation starts, unless you know what you are doing.
	 *
	 * @param {module:zrender/Element} el
	 * @param {Object} props
	 * @param {module:echarts/model/Model} [animatableModel]
	 * @param {number} [dataIndex]
	 * @param {Function} cb
	 */
	
	
	function initProps(el, props, animatableModel, dataIndex, cb) {
	  animateOrSetProps(false, el, props, animatableModel, dataIndex, cb);
	}
	/**
	 * Get transform matrix of target (param target),
	 * in coordinate of its ancestor (param ancestor)
	 *
	 * @param {module:zrender/mixin/Transformable} target
	 * @param {module:zrender/mixin/Transformable} [ancestor]
	 */
	
	
	function getTransform(target, ancestor) {
	  var mat = matrix.identity([]);
	
	  while (target && target !== ancestor) {
	    matrix.mul(mat, target.getLocalTransform(), mat);
	    target = target.parent;
	  }
	
	  return mat;
	}
	/**
	 * Apply transform to an vertex.
	 * @param {Array.<number>} target [x, y]
	 * @param {Array.<number>|TypedArray.<number>|Object} transform Can be:
	 *      + Transform matrix: like [1, 0, 0, 1, 0, 0]
	 *      + {position, rotation, scale}, the same as `zrender/Transformable`.
	 * @param {boolean=} invert Whether use invert matrix.
	 * @return {Array.<number>} [x, y]
	 */
	
	
	function applyTransform(target, transform, invert) {
	  if (transform && !zrUtil.isArrayLike(transform)) {
	    transform = Transformable.getLocalTransform(transform);
	  }
	
	  if (invert) {
	    transform = matrix.invert([], transform);
	  }
	
	  return vector.applyTransform([], target, transform);
	}
	/**
	 * @param {string} direction 'left' 'right' 'top' 'bottom'
	 * @param {Array.<number>} transform Transform matrix: like [1, 0, 0, 1, 0, 0]
	 * @param {boolean=} invert Whether use invert matrix.
	 * @return {string} Transformed direction. 'left' 'right' 'top' 'bottom'
	 */
	
	
	function transformDirection(direction, transform, invert) {
	  // Pick a base, ensure that transform result will not be (0, 0).
	  var hBase = transform[4] === 0 || transform[5] === 0 || transform[0] === 0 ? 1 : Math.abs(2 * transform[4] / transform[0]);
	  var vBase = transform[4] === 0 || transform[5] === 0 || transform[2] === 0 ? 1 : Math.abs(2 * transform[4] / transform[2]);
	  var vertex = [direction === 'left' ? -hBase : direction === 'right' ? hBase : 0, direction === 'top' ? -vBase : direction === 'bottom' ? vBase : 0];
	  vertex = applyTransform(vertex, transform, invert);
	  return Math.abs(vertex[0]) > Math.abs(vertex[1]) ? vertex[0] > 0 ? 'right' : 'left' : vertex[1] > 0 ? 'bottom' : 'top';
	}
	/**
	 * Apply group transition animation from g1 to g2.
	 * If no animatableModel, no animation.
	 */
	
	
	function groupTransition(g1, g2, animatableModel, cb) {
	  if (!g1 || !g2) {
	    return;
	  }
	
	  function getElMap(g) {
	    var elMap = {};
	    g.traverse(function (el) {
	      if (!el.isGroup && el.anid) {
	        elMap[el.anid] = el;
	      }
	    });
	    return elMap;
	  }
	
	  function getAnimatableProps(el) {
	    var obj = {
	      position: vector.clone(el.position),
	      rotation: el.rotation
	    };
	
	    if (el.shape) {
	      obj.shape = zrUtil.extend({}, el.shape);
	    }
	
	    return obj;
	  }
	
	  var elMap1 = getElMap(g1);
	  g2.traverse(function (el) {
	    if (!el.isGroup && el.anid) {
	      var oldEl = elMap1[el.anid];
	
	      if (oldEl) {
	        var newProp = getAnimatableProps(el);
	        el.attr(getAnimatableProps(oldEl));
	        updateProps(el, newProp, animatableModel, el.dataIndex);
	      } // else {
	      //     if (el.previousProps) {
	      //         graphic.updateProps
	      //     }
	      // }
	
	    }
	  });
	}
	/**
	 * @param {Array.<Array.<number>>} points Like: [[23, 44], [53, 66], ...]
	 * @param {Object} rect {x, y, width, height}
	 * @return {Array.<Array.<number>>} A new clipped points.
	 */
	
	
	function clipPointsByRect(points, rect) {
	  // FIXME: this way migth be incorrect when grpahic clipped by a corner.
	  // and when element have border.
	  return zrUtil.map(points, function (point) {
	    var x = point[0];
	    x = mathMax(x, rect.x);
	    x = mathMin(x, rect.x + rect.width);
	    var y = point[1];
	    y = mathMax(y, rect.y);
	    y = mathMin(y, rect.y + rect.height);
	    return [x, y];
	  });
	}
	/**
	 * @param {Object} targetRect {x, y, width, height}
	 * @param {Object} rect {x, y, width, height}
	 * @return {Object} A new clipped rect. If rect size are negative, return undefined.
	 */
	
	
	function clipRectByRect(targetRect, rect) {
	  var x = mathMax(targetRect.x, rect.x);
	  var x2 = mathMin(targetRect.x + targetRect.width, rect.x + rect.width);
	  var y = mathMax(targetRect.y, rect.y);
	  var y2 = mathMin(targetRect.y + targetRect.height, rect.y + rect.height); // If the total rect is cliped, nothing, including the border,
	  // should be painted. So return undefined.
	
	  if (x2 >= x && y2 >= y) {
	    return {
	      x: x,
	      y: y,
	      width: x2 - x,
	      height: y2 - y
	    };
	  }
	}
	/**
	 * @param {string} iconStr Support 'image://' or 'path://' or direct svg path.
	 * @param {Object} [opt] Properties of `module:zrender/Element`, except `style`.
	 * @param {Object} [rect] {x, y, width, height}
	 * @return {module:zrender/Element} Icon path or image element.
	 */
	
	
	function createIcon(iconStr, opt, rect) {
	  opt = zrUtil.extend({
	    rectHover: true
	  }, opt);
	  var style = opt.style = {
	    strokeNoScale: true
	  };
	  rect = rect || {
	    x: -1,
	    y: -1,
	    width: 2,
	    height: 2
	  };
	
	  if (iconStr) {
	    return iconStr.indexOf('image://') === 0 ? (style.image = iconStr.slice(8), zrUtil.defaults(style, rect), new ZImage(opt)) : makePath(iconStr.replace('path://', ''), opt, rect, 'center');
	  }
	}
	/**
	 * Return `true` if the given line (line `a`) and the given polygon
	 * are intersect.
	 * Note that we do not count colinear as intersect here because no
	 * requirement for that. We could do that if required in future.
	 *
	 * @param {number} a1x
	 * @param {number} a1y
	 * @param {number} a2x
	 * @param {number} a2y
	 * @param {Array.<Array.<number>>} points Points of the polygon.
	 * @return {boolean}
	 */
	
	
	function linePolygonIntersect(a1x, a1y, a2x, a2y, points) {
	  for (var i = 0, p2 = points[points.length - 1]; i < points.length; i++) {
	    var p = points[i];
	
	    if (lineLineIntersect(a1x, a1y, a2x, a2y, p[0], p[1], p2[0], p2[1])) {
	      return true;
	    }
	
	    p2 = p;
	  }
	}
	/**
	 * Return `true` if the given two lines (line `a` and line `b`)
	 * are intersect.
	 * Note that we do not count colinear as intersect here because no
	 * requirement for that. We could do that if required in future.
	 *
	 * @param {number} a1x
	 * @param {number} a1y
	 * @param {number} a2x
	 * @param {number} a2y
	 * @param {number} b1x
	 * @param {number} b1y
	 * @param {number} b2x
	 * @param {number} b2y
	 * @return {boolean}
	 */
	
	
	function lineLineIntersect(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
	  // let `vec_m` to be `vec_a2 - vec_a1` and `vec_n` to be `vec_b2 - vec_b1`.
	  var mx = a2x - a1x;
	  var my = a2y - a1y;
	  var nx = b2x - b1x;
	  var ny = b2y - b1y; // `vec_m` and `vec_n` are parallel iff
	  //     exising `k` such that `vec_m = k · vec_n`, equivalent to `vec_m X vec_n = 0`.
	
	  var nmCrossProduct = crossProduct2d(nx, ny, mx, my);
	
	  if (nearZero(nmCrossProduct)) {
	    return false;
	  } // `vec_m` and `vec_n` are intersect iff
	  //     existing `p` and `q` in [0, 1] such that `vec_a1 + p * vec_m = vec_b1 + q * vec_n`,
	  //     such that `q = ((vec_a1 - vec_b1) X vec_m) / (vec_n X vec_m)`
	  //           and `p = ((vec_a1 - vec_b1) X vec_n) / (vec_n X vec_m)`.
	
	
	  var b1a1x = a1x - b1x;
	  var b1a1y = a1y - b1y;
	  var q = crossProduct2d(b1a1x, b1a1y, mx, my) / nmCrossProduct;
	
	  if (q < 0 || q > 1) {
	    return false;
	  }
	
	  var p = crossProduct2d(b1a1x, b1a1y, nx, ny) / nmCrossProduct;
	
	  if (p < 0 || p > 1) {
	    return false;
	  }
	
	  return true;
	}
	/**
	 * Cross product of 2-dimension vector.
	 */
	
	
	function crossProduct2d(x1, y1, x2, y2) {
	  return x1 * y2 - x2 * y1;
	}
	
	function nearZero(val) {
	  return val <= 1e-6 && val >= -1e-6;
	} // Register built-in shapes. These shapes might be overwirtten
	// by users, although we do not recommend that.
	
	
	registerShape('circle', Circle);
	registerShape('sector', Sector);
	registerShape('ring', Ring);
	registerShape('polygon', Polygon);
	registerShape('polyline', Polyline);
	registerShape('rect', Rect);
	registerShape('line', Line);
	registerShape('bezierCurve', BezierCurve);
	registerShape('arc', Arc);
	exports.Z2_EMPHASIS_LIFT = Z2_EMPHASIS_LIFT;
	exports.CACHED_LABEL_STYLE_PROPERTIES = CACHED_LABEL_STYLE_PROPERTIES;
	exports.extendShape = extendShape;
	exports.extendPath = extendPath;
	exports.registerShape = registerShape;
	exports.getShapeClass = getShapeClass;
	exports.makePath = makePath;
	exports.makeImage = makeImage;
	exports.mergePath = mergePath;
	exports.resizePath = resizePath;
	exports.subPixelOptimizeLine = subPixelOptimizeLine;
	exports.subPixelOptimizeRect = subPixelOptimizeRect;
	exports.subPixelOptimize = subPixelOptimize;
	exports.setElementHoverStyle = setElementHoverStyle;
	exports.setHoverStyle = setHoverStyle;
	exports.setAsHighDownDispatcher = setAsHighDownDispatcher;
	exports.isHighDownDispatcher = isHighDownDispatcher;
	exports.getHighlightDigit = getHighlightDigit;
	exports.setLabelStyle = setLabelStyle;
	exports.modifyLabelStyle = modifyLabelStyle;
	exports.setTextStyle = setTextStyle;
	exports.setText = setText;
	exports.getFont = getFont;
	exports.updateProps = updateProps;
	exports.initProps = initProps;
	exports.getTransform = getTransform;
	exports.applyTransform = applyTransform;
	exports.transformDirection = transformDirection;
	exports.groupTransition = groupTransition;
	exports.clipPointsByRect = clipPointsByRect;
	exports.clipRectByRect = clipRectByRect;
	exports.createIcon = createIcon;
	exports.linePolygonIntersect = linePolygonIntersect;
	exports.lineLineIntersect = lineLineIntersect;

/***/ },
/* 17 */
/***/ function(module, exports) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	__webpack_require__(1);
	
	var jsonObj = {};
	var jsonArr = [];
	
	var foundLang = function foundLang(jsonObj, lang) {
		var t = jsonObj.find(function (el) {
			return el.lang[0] === lang[0] && el.lang[1] === lang[1];
		});
		if (t) return t;else return jsonObj.find(function (el) {
			return el.lang[0] === lang[0];
		});
	};
	
	var register = function register(json, lang) {
		jsonArr.push({
			"lang": lang,
			"json": json
		});
	};
	
	var init = function init() {
		var userLg = (navigator.language || navigator.userLanguage).match(/([A-z]){2}/g);
		jsonObj = function () {
			var jsonlg = foundLang(jsonArr, userLg);
			var defaut = jsonArr.find(function (element) {
				return element.lang == "default";
			});
			if (!!jsonlg) {
				return jsonlg.json;
			} else if (!!defaut) {
				return defaut.json;
			} else {
				throw new Error("Cannot found lang");
			}
		}();
	};
	
	var clear = function clear() {
		jsonArr = [];
		jsonObj = {};
	};
	module.exports = new Proxy({}, {
		get: function get(cible, nom) {
			if (nom === 'import' || nom === 'addLang') return register;else if (nom === 'init') return init;else if (nom === '__esModule') return false;else if (nom === "clear") return clear;else if (nom in jsonObj) return jsonObj[nom];else throw new Error("[i18n] Cannot found " + nom + " property");
		}
	});
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process, global) {/*
	 * Copyright 2016 Google Inc. All rights reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not
	 * use this file except in compliance with the License. You may obtain a copy of
	 * the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
	 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
	 * License for the specific language governing permissions and limitations under
	 * the License.
	 */
	
	
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	(function (scope) {
	  if (scope['Proxy']) {
	    return;
	  }
	  var lastRevokeFn = null;
	
	  /**
	   * @param {*} o
	   * @return {boolean} whether this is probably a (non-null) Object
	   */
	  function isObject(o) {
	    return o ? (typeof o === 'undefined' ? 'undefined' : _typeof(o)) == 'object' || typeof o == 'function' : false;
	  }
	
	  /**
	   * @constructor
	   * @param {!Object} target
	   * @param {{apply, construct, get, set}} handler
	   */
	  scope.Proxy = function (target, handler) {
	    if (!isObject(target) || !isObject(handler)) {
	      throw new TypeError('Cannot create proxy with a non-object as target or handler');
	    }
	
	    // Construct revoke function, and set lastRevokeFn so that Proxy.revocable can steal it.
	    // The caller might get the wrong revoke function if a user replaces or wraps scope.Proxy
	    // to call itself, but that seems unlikely especially when using the polyfill.
	    var throwRevoked = function throwRevoked() {};
	    lastRevokeFn = function lastRevokeFn() {
	      throwRevoked = function throwRevoked(trap) {
	        throw new TypeError('Cannot perform \'' + trap + '\' on a proxy that has been revoked');
	      };
	    };
	
	    // Fail on unsupported traps: Chrome doesn't do this, but ensure that users of the polyfill
	    // are a bit more careful. Copy the internal parts of handler to prevent user changes.
	    var unsafeHandler = handler;
	    handler = { 'get': null, 'set': null, 'apply': null, 'construct': null };
	    for (var k in unsafeHandler) {
	      if (!(k in handler)) {
	        throw new TypeError('Proxy polyfill does not support trap \'' + k + '\'');
	      }
	      handler[k] = unsafeHandler[k];
	    }
	    if (typeof unsafeHandler == 'function') {
	      // Allow handler to be a function (which has an 'apply' method). This matches what is
	      // probably a bug in native versions. It treats the apply call as a trap to be configured.
	      handler.apply = unsafeHandler.apply.bind(unsafeHandler);
	    }
	
	    // Define proxy as this, or a Function (if either it's callable, or apply is set).
	    // TODO(samthor): Closure compiler doesn't know about 'construct', attempts to rename it.
	    var proxy = this;
	    var isMethod = false;
	    var targetIsFunction = typeof target == 'function';
	    if (handler.apply || handler['construct'] || targetIsFunction) {
	      proxy = function Proxy() {
	        var usingNew = this && this.constructor === proxy;
	        var args = Array.prototype.slice.call(arguments);
	        throwRevoked(usingNew ? 'construct' : 'apply');
	
	        if (usingNew && handler['construct']) {
	          return handler['construct'].call(this, target, args);
	        } else if (!usingNew && handler.apply) {
	          return handler.apply(target, this, args);
	        } else if (targetIsFunction) {
	          // since the target was a function, fallback to calling it directly.
	          if (usingNew) {
	            // inspired by answers to https://stackoverflow.com/q/1606797
	            args.unshift(target); // pass class as first arg to constructor, although irrelevant
	            // nb. cast to convince Closure compiler that this is a constructor
	            var f = /** @type {!Function} */target.bind.apply(target, args);
	            return new f();
	          }
	          return target.apply(this, args);
	        }
	        throw new TypeError(usingNew ? 'not a constructor' : 'not a function');
	      };
	      isMethod = true;
	    }
	
	    // Create default getters/setters. Create different code paths as handler.get/handler.set can't
	    // change after creation.
	    var getter = handler.get ? function (prop) {
	      throwRevoked('get');
	      return handler.get(this, prop, proxy);
	    } : function (prop) {
	      throwRevoked('get');
	      return this[prop];
	    };
	    var setter = handler.set ? function (prop, value) {
	      throwRevoked('set');
	      var status = handler.set(this, prop, value, proxy);
	      if (!status) {
	        // TODO(samthor): If the calling code is in strict mode, throw TypeError.
	        // It's (sometimes) possible to work this out, if this code isn't strict- try to load the
	        // callee, and if it's available, that code is non-strict. However, this isn't exhaustive.
	      }
	    } : function (prop, value) {
	      throwRevoked('set');
	      this[prop] = value;
	    };
	
	    // Clone direct properties (i.e., not part of a prototype).
	    var propertyNames = Object.getOwnPropertyNames(target);
	    var propertyMap = {};
	    propertyNames.forEach(function (prop) {
	      if (isMethod && prop in proxy) {
	        return; // ignore properties already here, e.g. 'bind', 'prototype' etc
	      }
	      var real = Object.getOwnPropertyDescriptor(target, prop);
	      var desc = {
	        enumerable: !!real.enumerable,
	        get: getter.bind(target, prop),
	        set: setter.bind(target, prop)
	      };
	      Object.defineProperty(proxy, prop, desc);
	      propertyMap[prop] = true;
	    });
	
	    // Set the prototype, or clone all prototype methods (always required if a getter is provided).
	    // TODO(samthor): We don't allow prototype methods to be set. It's (even more) awkward.
	    // An alternative here would be to _just_ clone methods to keep behavior consistent.
	    var prototypeOk = true;
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(proxy, Object.getPrototypeOf(target));
	    } else if (proxy.__proto__) {
	      proxy.__proto__ = target.__proto__;
	    } else {
	      prototypeOk = false;
	    }
	    if (handler.get || !prototypeOk) {
	      for (var _k in target) {
	        if (propertyMap[_k]) {
	          continue;
	        }
	        Object.defineProperty(proxy, _k, { get: getter.bind(target, _k) });
	      }
	    }
	
	    // The Proxy polyfill cannot handle adding new properties. Seal the target and proxy.
	    Object.seal(target);
	    Object.seal(proxy);
	
	    return proxy; // nb. if isMethod is true, proxy != this
	  };
	
	  scope.Proxy.revocable = function (target, handler) {
	    var p = new scope.Proxy(target, handler);
	    return { 'proxy': p, 'revoke': lastRevokeFn };
	  };
	
	  scope.Proxy['revocable'] = scope.Proxy.revocable;
	  scope['Proxy'] = scope.Proxy;
	})(typeof process !== 'undefined' && {}.toString.call(process) == '[object process]' ? global : self);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(3)))
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };
	
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
	var g;
	
	// This works in non-strict mode
	g = (function() {
		return this;
	})();
	
	try {
		// This works if eval is allowed (see CSP)
		g = g || Function("return this")() || (1,eval)("this");
	} catch(e) {
		// This works if the window reference is available
		if(typeof window === "object")
			g = window;
	}
	
	// g can still be undefined, but nothing to do about it...
	// We return undefined, instead of nothing here, so it's
	// easier to handle this case. if(!global) { ...}
	
	module.exports = g;
	
	
	/***/ })
	/******/ ]);
	//# sourceMappingURL=index.js.map

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(2054);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(2055);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	/** @license Material-UI v4.10.2
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "chainPropTypes", {
	  enumerable: true,
	  get: function get() {
	    return _chainPropTypes.default;
	  }
	});
	Object.defineProperty(exports, "deepmerge", {
	  enumerable: true,
	  get: function get() {
	    return _deepmerge.default;
	  }
	});
	Object.defineProperty(exports, "elementAcceptingRef", {
	  enumerable: true,
	  get: function get() {
	    return _elementAcceptingRef.default;
	  }
	});
	Object.defineProperty(exports, "elementTypeAcceptingRef", {
	  enumerable: true,
	  get: function get() {
	    return _elementTypeAcceptingRef.default;
	  }
	});
	Object.defineProperty(exports, "exactProp", {
	  enumerable: true,
	  get: function get() {
	    return _exactProp.default;
	  }
	});
	Object.defineProperty(exports, "formatMuiErrorMessage", {
	  enumerable: true,
	  get: function get() {
	    return _formatMuiErrorMessage.default;
	  }
	});
	Object.defineProperty(exports, "getDisplayName", {
	  enumerable: true,
	  get: function get() {
	    return _getDisplayName.default;
	  }
	});
	Object.defineProperty(exports, "HTMLElementType", {
	  enumerable: true,
	  get: function get() {
	    return _HTMLElementType.default;
	  }
	});
	Object.defineProperty(exports, "ponyfillGlobal", {
	  enumerable: true,
	  get: function get() {
	    return _ponyfillGlobal.default;
	  }
	});
	Object.defineProperty(exports, "refType", {
	  enumerable: true,
	  get: function get() {
	    return _refType.default;
	  }
	});
	
	var _chainPropTypes = _interopRequireDefault(__webpack_require__(414));
	
	var _deepmerge = _interopRequireDefault(__webpack_require__(1372));
	
	var _elementAcceptingRef = _interopRequireDefault(__webpack_require__(1373));
	
	var _elementTypeAcceptingRef = _interopRequireDefault(__webpack_require__(1374));
	
	var _exactProp = _interopRequireDefault(__webpack_require__(1375));
	
	var _formatMuiErrorMessage = _interopRequireDefault(__webpack_require__(1376));
	
	var _getDisplayName = _interopRequireDefault(__webpack_require__(1377));
	
	var _HTMLElementType = _interopRequireDefault(__webpack_require__(1371));
	
	var _ponyfillGlobal = _interopRequireDefault(__webpack_require__(1378));
	
	var _refType = _interopRequireDefault(__webpack_require__(1379));

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* A third-party license is embeded for some of the code in this file:
	* The method "quantile" was copied from "d3.js".
	* (See more details in the comment of the method below.)
	* The use of the source code of this file is also subject to the terms
	* and consitions of the license of "d3.js" (BSD-3Clause, see
	* </licenses/LICENSE-d3>).
	*/
	var RADIAN_EPSILON = 1e-4;
	
	function _trim(str) {
	  return str.replace(/^\s+|\s+$/g, '');
	}
	/**
	 * Linear mapping a value from domain to range
	 * @memberOf module:echarts/util/number
	 * @param  {(number|Array.<number>)} val
	 * @param  {Array.<number>} domain Domain extent domain[0] can be bigger than domain[1]
	 * @param  {Array.<number>} range  Range extent range[0] can be bigger than range[1]
	 * @param  {boolean} clamp
	 * @return {(number|Array.<number>}
	 */
	
	
	function linearMap(val, domain, range, clamp) {
	  var subDomain = domain[1] - domain[0];
	  var subRange = range[1] - range[0];
	
	  if (subDomain === 0) {
	    return subRange === 0 ? range[0] : (range[0] + range[1]) / 2;
	  } // Avoid accuracy problem in edge, such as
	  // 146.39 - 62.83 === 83.55999999999999.
	  // See echarts/test/ut/spec/util/number.js#linearMap#accuracyError
	  // It is a little verbose for efficiency considering this method
	  // is a hotspot.
	
	
	  if (clamp) {
	    if (subDomain > 0) {
	      if (val <= domain[0]) {
	        return range[0];
	      } else if (val >= domain[1]) {
	        return range[1];
	      }
	    } else {
	      if (val >= domain[0]) {
	        return range[0];
	      } else if (val <= domain[1]) {
	        return range[1];
	      }
	    }
	  } else {
	    if (val === domain[0]) {
	      return range[0];
	    }
	
	    if (val === domain[1]) {
	      return range[1];
	    }
	  }
	
	  return (val - domain[0]) / subDomain * subRange + range[0];
	}
	/**
	 * Convert a percent string to absolute number.
	 * Returns NaN if percent is not a valid string or number
	 * @memberOf module:echarts/util/number
	 * @param {string|number} percent
	 * @param {number} all
	 * @return {number}
	 */
	
	
	function parsePercent(percent, all) {
	  switch (percent) {
	    case 'center':
	    case 'middle':
	      percent = '50%';
	      break;
	
	    case 'left':
	    case 'top':
	      percent = '0%';
	      break;
	
	    case 'right':
	    case 'bottom':
	      percent = '100%';
	      break;
	  }
	
	  if (typeof percent === 'string') {
	    if (_trim(percent).match(/%$/)) {
	      return parseFloat(percent) / 100 * all;
	    }
	
	    return parseFloat(percent);
	  }
	
	  return percent == null ? NaN : +percent;
	}
	/**
	 * (1) Fix rounding error of float numbers.
	 * (2) Support return string to avoid scientific notation like '3.5e-7'.
	 *
	 * @param {number} x
	 * @param {number} [precision]
	 * @param {boolean} [returnStr]
	 * @return {number|string}
	 */
	
	
	function round(x, precision, returnStr) {
	  if (precision == null) {
	    precision = 10;
	  } // Avoid range error
	
	
	  precision = Math.min(Math.max(0, precision), 20);
	  x = (+x).toFixed(precision);
	  return returnStr ? x : +x;
	}
	/**
	 * asc sort arr.
	 * The input arr will be modified.
	 *
	 * @param {Array} arr
	 * @return {Array} The input arr.
	 */
	
	
	function asc(arr) {
	  arr.sort(function (a, b) {
	    return a - b;
	  });
	  return arr;
	}
	/**
	 * Get precision
	 * @param {number} val
	 */
	
	
	function getPrecision(val) {
	  val = +val;
	
	  if (isNaN(val)) {
	    return 0;
	  } // It is much faster than methods converting number to string as follows
	  //      var tmp = val.toString();
	  //      return tmp.length - 1 - tmp.indexOf('.');
	  // especially when precision is low
	
	
	  var e = 1;
	  var count = 0;
	
	  while (Math.round(val * e) / e !== val) {
	    e *= 10;
	    count++;
	  }
	
	  return count;
	}
	/**
	 * @param {string|number} val
	 * @return {number}
	 */
	
	
	function getPrecisionSafe(val) {
	  var str = val.toString(); // Consider scientific notation: '3.4e-12' '3.4e+12'
	
	  var eIndex = str.indexOf('e');
	
	  if (eIndex > 0) {
	    var precision = +str.slice(eIndex + 1);
	    return precision < 0 ? -precision : 0;
	  } else {
	    var dotIndex = str.indexOf('.');
	    return dotIndex < 0 ? 0 : str.length - 1 - dotIndex;
	  }
	}
	/**
	 * Minimal dicernible data precisioin according to a single pixel.
	 *
	 * @param {Array.<number>} dataExtent
	 * @param {Array.<number>} pixelExtent
	 * @return {number} precision
	 */
	
	
	function getPixelPrecision(dataExtent, pixelExtent) {
	  var log = Math.log;
	  var LN10 = Math.LN10;
	  var dataQuantity = Math.floor(log(dataExtent[1] - dataExtent[0]) / LN10);
	  var sizeQuantity = Math.round(log(Math.abs(pixelExtent[1] - pixelExtent[0])) / LN10); // toFixed() digits argument must be between 0 and 20.
	
	  var precision = Math.min(Math.max(-dataQuantity + sizeQuantity, 0), 20);
	  return !isFinite(precision) ? 20 : precision;
	}
	/**
	 * Get a data of given precision, assuring the sum of percentages
	 * in valueList is 1.
	 * The largest remainer method is used.
	 * https://en.wikipedia.org/wiki/Largest_remainder_method
	 *
	 * @param {Array.<number>} valueList a list of all data
	 * @param {number} idx index of the data to be processed in valueList
	 * @param {number} precision integer number showing digits of precision
	 * @return {number} percent ranging from 0 to 100
	 */
	
	
	function getPercentWithPrecision(valueList, idx, precision) {
	  if (!valueList[idx]) {
	    return 0;
	  }
	
	  var sum = zrUtil.reduce(valueList, function (acc, val) {
	    return acc + (isNaN(val) ? 0 : val);
	  }, 0);
	
	  if (sum === 0) {
	    return 0;
	  }
	
	  var digits = Math.pow(10, precision);
	  var votesPerQuota = zrUtil.map(valueList, function (val) {
	    return (isNaN(val) ? 0 : val) / sum * digits * 100;
	  });
	  var targetSeats = digits * 100;
	  var seats = zrUtil.map(votesPerQuota, function (votes) {
	    // Assign automatic seats.
	    return Math.floor(votes);
	  });
	  var currentSum = zrUtil.reduce(seats, function (acc, val) {
	    return acc + val;
	  }, 0);
	  var remainder = zrUtil.map(votesPerQuota, function (votes, idx) {
	    return votes - seats[idx];
	  }); // Has remainding votes.
	
	  while (currentSum < targetSeats) {
	    // Find next largest remainder.
	    var max = Number.NEGATIVE_INFINITY;
	    var maxId = null;
	
	    for (var i = 0, len = remainder.length; i < len; ++i) {
	      if (remainder[i] > max) {
	        max = remainder[i];
	        maxId = i;
	      }
	    } // Add a vote to max remainder.
	
	
	    ++seats[maxId];
	    remainder[maxId] = 0;
	    ++currentSum;
	  }
	
	  return seats[idx] / digits;
	} // Number.MAX_SAFE_INTEGER, ie do not support.
	
	
	var MAX_SAFE_INTEGER = 9007199254740991;
	/**
	 * To 0 - 2 * PI, considering negative radian.
	 * @param {number} radian
	 * @return {number}
	 */
	
	function remRadian(radian) {
	  var pi2 = Math.PI * 2;
	  return (radian % pi2 + pi2) % pi2;
	}
	/**
	 * @param {type} radian
	 * @return {boolean}
	 */
	
	
	function isRadianAroundZero(val) {
	  return val > -RADIAN_EPSILON && val < RADIAN_EPSILON;
	}
	/* eslint-disable */
	
	
	var TIME_REG = /^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d\d)(?::(\d\d)(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/; // jshint ignore:line
	
	/* eslint-enable */
	
	/**
	 * @param {string|Date|number} value These values can be accepted:
	 *   + An instance of Date, represent a time in its own time zone.
	 *   + Or string in a subset of ISO 8601, only including:
	 *     + only year, month, date: '2012-03', '2012-03-01', '2012-03-01 05', '2012-03-01 05:06',
	 *     + separated with T or space: '2012-03-01T12:22:33.123', '2012-03-01 12:22:33.123',
	 *     + time zone: '2012-03-01T12:22:33Z', '2012-03-01T12:22:33+8000', '2012-03-01T12:22:33-05:00',
	 *     all of which will be treated as local time if time zone is not specified
	 *     (see <https://momentjs.com/>).
	 *   + Or other string format, including (all of which will be treated as loacal time):
	 *     '2012', '2012-3-1', '2012/3/1', '2012/03/01',
	 *     '2009/6/12 2:00', '2009/6/12 2:05:08', '2009/6/12 2:05:08.123'
	 *   + a timestamp, which represent a time in UTC.
	 * @return {Date} date
	 */
	
	function parseDate(value) {
	  if (value instanceof Date) {
	    return value;
	  } else if (typeof value === 'string') {
	    // Different browsers parse date in different way, so we parse it manually.
	    // Some other issues:
	    // new Date('1970-01-01') is UTC,
	    // new Date('1970/01/01') and new Date('1970-1-01') is local.
	    // See issue #3623
	    var match = TIME_REG.exec(value);
	
	    if (!match) {
	      // return Invalid Date.
	      return new Date(NaN);
	    } // Use local time when no timezone offset specifed.
	
	
	    if (!match[8]) {
	      // match[n] can only be string or undefined.
	      // But take care of '12' + 1 => '121'.
	      return new Date(+match[1], +(match[2] || 1) - 1, +match[3] || 1, +match[4] || 0, +(match[5] || 0), +match[6] || 0, +match[7] || 0);
	    } // Timezoneoffset of Javascript Date has considered DST (Daylight Saving Time,
	    // https://tc39.github.io/ecma262/#sec-daylight-saving-time-adjustment).
	    // For example, system timezone is set as "Time Zone: America/Toronto",
	    // then these code will get different result:
	    // `new Date(1478411999999).getTimezoneOffset();  // get 240`
	    // `new Date(1478412000000).getTimezoneOffset();  // get 300`
	    // So we should not use `new Date`, but use `Date.UTC`.
	    else {
	        var hour = +match[4] || 0;
	
	        if (match[8].toUpperCase() !== 'Z') {
	          hour -= match[8].slice(0, 3);
	        }
	
	        return new Date(Date.UTC(+match[1], +(match[2] || 1) - 1, +match[3] || 1, hour, +(match[5] || 0), +match[6] || 0, +match[7] || 0));
	      }
	  } else if (value == null) {
	    return new Date(NaN);
	  }
	
	  return new Date(Math.round(value));
	}
	/**
	 * Quantity of a number. e.g. 0.1, 1, 10, 100
	 *
	 * @param  {number} val
	 * @return {number}
	 */
	
	
	function quantity(val) {
	  return Math.pow(10, quantityExponent(val));
	}
	/**
	 * Exponent of the quantity of a number
	 * e.g., 1234 equals to 1.234*10^3, so quantityExponent(1234) is 3
	 *
	 * @param  {number} val non-negative value
	 * @return {number}
	 */
	
	
	function quantityExponent(val) {
	  if (val === 0) {
	    return 0;
	  }
	
	  var exp = Math.floor(Math.log(val) / Math.LN10);
	  /**
	   * exp is expected to be the rounded-down result of the base-10 log of val.
	   * But due to the precision loss with Math.log(val), we need to restore it
	   * using 10^exp to make sure we can get val back from exp. #11249
	   */
	
	  if (val / Math.pow(10, exp) >= 10) {
	    exp++;
	  }
	
	  return exp;
	}
	/**
	 * find a “nice” number approximately equal to x. Round the number if round = true,
	 * take ceiling if round = false. The primary observation is that the “nicest”
	 * numbers in decimal are 1, 2, and 5, and all power-of-ten multiples of these numbers.
	 *
	 * See "Nice Numbers for Graph Labels" of Graphic Gems.
	 *
	 * @param  {number} val Non-negative value.
	 * @param  {boolean} round
	 * @return {number}
	 */
	
	
	function nice(val, round) {
	  var exponent = quantityExponent(val);
	  var exp10 = Math.pow(10, exponent);
	  var f = val / exp10; // 1 <= f < 10
	
	  var nf;
	
	  if (round) {
	    if (f < 1.5) {
	      nf = 1;
	    } else if (f < 2.5) {
	      nf = 2;
	    } else if (f < 4) {
	      nf = 3;
	    } else if (f < 7) {
	      nf = 5;
	    } else {
	      nf = 10;
	    }
	  } else {
	    if (f < 1) {
	      nf = 1;
	    } else if (f < 2) {
	      nf = 2;
	    } else if (f < 3) {
	      nf = 3;
	    } else if (f < 5) {
	      nf = 5;
	    } else {
	      nf = 10;
	    }
	  }
	
	  val = nf * exp10; // Fix 3 * 0.1 === 0.30000000000000004 issue (see IEEE 754).
	  // 20 is the uppper bound of toFixed.
	
	  return exponent >= -20 ? +val.toFixed(exponent < 0 ? -exponent : 0) : val;
	}
	/**
	 * This code was copied from "d3.js"
	 * <https://github.com/d3/d3/blob/9cc9a875e636a1dcf36cc1e07bdf77e1ad6e2c74/src/arrays/quantile.js>.
	 * See the license statement at the head of this file.
	 * @param {Array.<number>} ascArr
	 */
	
	
	function quantile(ascArr, p) {
	  var H = (ascArr.length - 1) * p + 1;
	  var h = Math.floor(H);
	  var v = +ascArr[h - 1];
	  var e = H - h;
	  return e ? v + e * (ascArr[h] - v) : v;
	}
	/**
	 * Order intervals asc, and split them when overlap.
	 * expect(numberUtil.reformIntervals([
	 *     {interval: [18, 62], close: [1, 1]},
	 *     {interval: [-Infinity, -70], close: [0, 0]},
	 *     {interval: [-70, -26], close: [1, 1]},
	 *     {interval: [-26, 18], close: [1, 1]},
	 *     {interval: [62, 150], close: [1, 1]},
	 *     {interval: [106, 150], close: [1, 1]},
	 *     {interval: [150, Infinity], close: [0, 0]}
	 * ])).toEqual([
	 *     {interval: [-Infinity, -70], close: [0, 0]},
	 *     {interval: [-70, -26], close: [1, 1]},
	 *     {interval: [-26, 18], close: [0, 1]},
	 *     {interval: [18, 62], close: [0, 1]},
	 *     {interval: [62, 150], close: [0, 1]},
	 *     {interval: [150, Infinity], close: [0, 0]}
	 * ]);
	 * @param {Array.<Object>} list, where `close` mean open or close
	 *        of the interval, and Infinity can be used.
	 * @return {Array.<Object>} The origin list, which has been reformed.
	 */
	
	
	function reformIntervals(list) {
	  list.sort(function (a, b) {
	    return littleThan(a, b, 0) ? -1 : 1;
	  });
	  var curr = -Infinity;
	  var currClose = 1;
	
	  for (var i = 0; i < list.length;) {
	    var interval = list[i].interval;
	    var close = list[i].close;
	
	    for (var lg = 0; lg < 2; lg++) {
	      if (interval[lg] <= curr) {
	        interval[lg] = curr;
	        close[lg] = !lg ? 1 - currClose : 1;
	      }
	
	      curr = interval[lg];
	      currClose = close[lg];
	    }
	
	    if (interval[0] === interval[1] && close[0] * close[1] !== 1) {
	      list.splice(i, 1);
	    } else {
	      i++;
	    }
	  }
	
	  return list;
	
	  function littleThan(a, b, lg) {
	    return a.interval[lg] < b.interval[lg] || a.interval[lg] === b.interval[lg] && (a.close[lg] - b.close[lg] === (!lg ? 1 : -1) || !lg && littleThan(a, b, 1));
	  }
	}
	/**
	 * parseFloat NaNs numeric-cast false positives (null|true|false|"")
	 * ...but misinterprets leading-number strings, particularly hex literals ("0x...")
	 * subtraction forces infinities to NaN
	 *
	 * @param {*} v
	 * @return {boolean}
	 */
	
	
	function isNumeric(v) {
	  return v - parseFloat(v) >= 0;
	}
	
	exports.linearMap = linearMap;
	exports.parsePercent = parsePercent;
	exports.round = round;
	exports.asc = asc;
	exports.getPrecision = getPrecision;
	exports.getPrecisionSafe = getPrecisionSafe;
	exports.getPixelPrecision = getPixelPrecision;
	exports.getPercentWithPrecision = getPercentWithPrecision;
	exports.MAX_SAFE_INTEGER = MAX_SAFE_INTEGER;
	exports.remRadian = remRadian;
	exports.isRadianAroundZero = isRadianAroundZero;
	exports.parseDate = parseDate;
	exports.quantity = quantity;
	exports.quantityExponent = quantityExponent;
	exports.nice = nice;
	exports.quantile = quantile;
	exports.reformIntervals = reformIntervals;
	exports.isNumeric = isNumeric;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _reduxThunk = __webpack_require__(1066);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _redux = __webpack_require__(553);
	
	var _reactRouterRedux = __webpack_require__(43);
	
	var _reactRouter = __webpack_require__(1009);
	
	var _AdministrationReducer = __webpack_require__(2094);
	
	var _reactAquasys = __webpack_require__(49);
	
	var _reduxLogger = __webpack_require__(1065);
	
	var _reduxLogger2 = _interopRequireDefault(_reduxLogger);
	
	var _SitesReducer = __webpack_require__(2182);
	
	var _HomeReducer = __webpack_require__(2142);
	
	var _SignUpValidationReducer = __webpack_require__(2173);
	
	var _SignUpValidationReducer2 = _interopRequireDefault(_SignUpValidationReducer);
	
	var _LoginReducer = __webpack_require__(2152);
	
	var _LoginReducer2 = _interopRequireDefault(_LoginReducer);
	
	var _DetailStationReducer = __webpack_require__(2205);
	
	var _ReferentialReducer = __webpack_require__(2167);
	
	var _DashboardReducer = __webpack_require__(2129);
	
	var _SelectionReducer = __webpack_require__(2130);
	
	var _CreditReducer = __webpack_require__(2141);
	
	var _PointReducer = __webpack_require__(2166);
	
	var _InitPasswordReducer = __webpack_require__(2148);
	
	var _ToastrReducer = __webpack_require__(2144);
	
	var _InformationReducer = __webpack_require__(2143);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var router = (0, _reactRouterRedux.routerMiddleware)(_reactRouter.hashHistory);
	
	var middlewares = [_reduxThunk2.default, router];
	
	if (false) {
		middlewares.push(_reduxLogger2.default);
	}
	var enhancer = _redux.applyMiddleware.apply(undefined, middlewares);
	
	var AppStore = (0, _redux.createStore)((0, _redux.combineReducers)({
		HomeReducer: _HomeReducer.HomeReducer,
		DashboardReducer: _DashboardReducer.DashboardReducer,
		SelectionReducer: _SelectionReducer.SelectionReducer,
		SignUpValidationReducer: _SignUpValidationReducer2.default,
		LoginReducer: _LoginReducer2.default,
		AdministrationReducer: _AdministrationReducer.AdministrationReducer,
		DetailStationReducer: _DetailStationReducer.DetailStationReducer,
		ToastrReducer: _ToastrReducer.ToastrReducer,
		InformationReducer: _InformationReducer.InformationReducer,
		WaitReducer: _reactAquasys.WaitReducer,
		SitesReducer: _SitesReducer.SitesReducer,
		ReferentialReducer: _ReferentialReducer.ReferentialReducer,
		CreditReducer: _CreditReducer.CreditReducer,
		PointReducer: _PointReducer.PointReducer,
		InitPasswordReducer: _InitPasswordReducer.InitPasswordReducer,
		routing: _reactRouterRedux.routerReducer
	}), {
		ReferentialReducer: _ReferentialReducer.store,
		LoginReducer: {
			error: '',
			success: ''
		},
		AdministrationReducer: _AdministrationReducer.store,
		SignUpValidationReducer: {
			error: '',
			success: ''
		},
		DashboardReducer: _DashboardReducer.store,
		SelectionReducer: _SelectionReducer.store,
		HomeReducer: _HomeReducer.store,
		DetailStationReducer: _DetailStationReducer.store,
		SitesReducer: _SitesReducer.store,
		CreditReducer: _CreditReducer.store,
		PointReducer: _PointReducer.store,
		InitPasswordReducer: _InitPasswordReducer.store,
		ToastrReducer: _ToastrReducer.store,
		InformationReducer: _InformationReducer.store,
		WaitReducer: {
			isWait: false,
			name: 'ball-grid-pulse',
			color: 'blue',
			fadeIn: 'none'
		}
	}, enhancer);
	
	exports.default = AppStore;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var logger_1 = __webpack_require__(68);
	var context_1 = __webpack_require__(8);
	var context_2 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var utils_1 = __webpack_require__(10);
	var EventService = /** @class */ (function () {
	    function EventService() {
	        this.allSyncListeners = {};
	        this.allAsyncListeners = {};
	        this.globalSyncListeners = [];
	        this.globalAsyncListeners = [];
	        this.asyncFunctionsQueue = [];
	        this.scheduled = false;
	        this.firedEvents = {};
	    }
	    EventService_1 = EventService;
	    // because this class is used both inside the context and outside the context, we do not
	    // use autowired attributes, as that would be confusing, as sometimes the attributes
	    // would be wired, and sometimes not.
	    //
	    // the global event servers used by ag-Grid is autowired by the context once, and this
	    // setBeans method gets called once.
	    //
	    // the times when this class is used outside of the context (eg RowNode has an instance of this
	    // class) then it is not a bean, and this setBeans method is not called.
	    EventService.prototype.setBeans = function (loggerFactory, gridOptionsWrapper, globalEventListener) {
	        if (globalEventListener === void 0) { globalEventListener = null; }
	        this.logger = loggerFactory.create('EventService');
	        if (globalEventListener) {
	            var async = gridOptionsWrapper.useAsyncEvents();
	            this.addGlobalListener(globalEventListener, async);
	        }
	    };
	    EventService.prototype.getListenerList = function (eventType, async) {
	        var listenerMap = async ? this.allAsyncListeners : this.allSyncListeners;
	        var listenerList = listenerMap[eventType];
	        if (!listenerList) {
	            listenerList = [];
	            listenerMap[eventType] = listenerList;
	        }
	        return listenerList;
	    };
	    EventService.prototype.addEventListener = function (eventType, listener, async) {
	        if (async === void 0) { async = false; }
	        var listenerList = this.getListenerList(eventType, async);
	        if (listenerList.indexOf(listener) < 0) {
	            listenerList.push(listener);
	        }
	    };
	    // for some events, it's important that the model gets to hear about them before the view,
	    // as the model may need to update before the view works on the info. if you register
	    // via this method, you get notified before the view parts
	    EventService.prototype.addModalPriorityEventListener = function (eventType, listener, async) {
	        if (async === void 0) { async = false; }
	        this.addEventListener(eventType + EventService_1.PRIORITY, listener, async);
	    };
	    EventService.prototype.addGlobalListener = function (listener, async) {
	        if (async === void 0) { async = false; }
	        if (async) {
	            this.globalAsyncListeners.push(listener);
	        }
	        else {
	            this.globalSyncListeners.push(listener);
	        }
	    };
	    EventService.prototype.removeEventListener = function (eventType, listener, async) {
	        if (async === void 0) { async = false; }
	        var listenerList = this.getListenerList(eventType, async);
	        utils_1._.removeFromArray(listenerList, listener);
	    };
	    EventService.prototype.removeGlobalListener = function (listener, async) {
	        if (async === void 0) { async = false; }
	        if (async) {
	            utils_1._.removeFromArray(this.globalAsyncListeners, listener);
	        }
	        else {
	            utils_1._.removeFromArray(this.globalSyncListeners, listener);
	        }
	    };
	    // why do we pass the type here? the type is in ColumnChangeEvent, so unless the
	    // type is not in other types of events???
	    EventService.prototype.dispatchEvent = function (event) {
	        // console.log(`dispatching ${eventType}: ${event}`);
	        this.dispatchToListeners(event, true);
	        this.dispatchToListeners(event, false);
	        this.firedEvents[event.type] = true;
	    };
	    EventService.prototype.dispatchEventOnce = function (event) {
	        if (!this.firedEvents[event.type]) {
	            this.dispatchEvent(event);
	        }
	    };
	    EventService.prototype.dispatchToListeners = function (event, async) {
	        var _this = this;
	        var globalListeners = async ? this.globalAsyncListeners : this.globalSyncListeners;
	        var eventType = event.type;
	        // this allows the columnController to get events before anyone else
	        var p1ListenerList = this.getListenerList(eventType + EventService_1.PRIORITY, async);
	        utils_1._.forEachSnapshotFirst(p1ListenerList, function (listener) {
	            if (async) {
	                _this.dispatchAsync(function () { return listener(event); });
	            }
	            else {
	                listener(event);
	            }
	        });
	        var listenerList = this.getListenerList(eventType, async);
	        utils_1._.forEachSnapshotFirst(listenerList, function (listener) {
	            if (async) {
	                _this.dispatchAsync(function () { return listener(event); });
	            }
	            else {
	                listener(event);
	            }
	        });
	        utils_1._.forEachSnapshotFirst(globalListeners, function (listener) {
	            if (async) {
	                _this.dispatchAsync(function () { return listener(eventType, event); });
	            }
	            else {
	                listener(eventType, event);
	            }
	        });
	    };
	    // this gets called inside the grid's thread, for each event that it
	    // wants to set async. the grid then batches the events into one setTimeout()
	    // because setTimeout() is an expensive operation. ideally we would have
	    // each event in it's own setTimeout(), but we batch for performance.
	    EventService.prototype.dispatchAsync = function (func) {
	        // add to the queue for executing later in the next VM turn
	        this.asyncFunctionsQueue.push(func);
	        // check if timeout is already scheduled. the first time the grid calls
	        // this within it's thread turn, this should be false, so it will schedule
	        // the 'flush queue' method the first time it comes here. then the flag is
	        // set to 'true' so it will know it's already scheduled for subsequent calls.
	        if (!this.scheduled) {
	            // if not scheduled, schedule one
	            window.setTimeout(this.flushAsyncQueue.bind(this), 0);
	            // mark that it is scheduled
	            this.scheduled = true;
	        }
	    };
	    // this happens in the next VM turn only, and empties the queue of events
	    EventService.prototype.flushAsyncQueue = function () {
	        this.scheduled = false;
	        // we take a copy, because the event listener could be using
	        // the grid, which would cause more events, which would be potentially
	        // added to the queue, so safe to take a copy, the new events will
	        // get executed in a later VM turn rather than risk updating the
	        // queue as we are flushing it.
	        var queueCopy = this.asyncFunctionsQueue.slice();
	        this.asyncFunctionsQueue = [];
	        // execute the queue
	        queueCopy.forEach(function (func) { return func(); });
	    };
	    var EventService_1;
	    // this is an old idea niall had, should really take it out, was to do with ordering who gets to process
	    // events first, to give model and service objects preference over the view
	    EventService.PRIORITY = '-P1';
	    __decorate([
	        __param(0, context_2.Qualifier('loggerFactory')),
	        __param(1, context_2.Qualifier('gridOptionsWrapper')),
	        __param(2, context_2.Qualifier('globalEventListener')),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [logger_1.LoggerFactory,
	            gridOptionsWrapper_1.GridOptionsWrapper,
	            Function]),
	        __metadata("design:returntype", void 0)
	    ], EventService.prototype, "setBeans", null);
	    EventService = EventService_1 = __decorate([
	        context_1.Bean('eventService')
	    ], EventService);
	    return EventService;
	}());
	exports.EventService = EventService;


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var env = __webpack_require__(55);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var isObject = zrUtil.isObject;
	var isArray = zrUtil.isArray;
	/**
	 * Make the name displayable. But we should
	 * make sure it is not duplicated with user
	 * specified name, so use '\0';
	 */
	
	var DUMMY_COMPONENT_NAME_PREFIX = 'series\0';
	/**
	 * If value is not array, then translate it to array.
	 * @param  {*} value
	 * @return {Array} [value] or value
	 */
	
	function normalizeToArray(value) {
	  return value instanceof Array ? value : value == null ? [] : [value];
	}
	/**
	 * Sync default option between normal and emphasis like `position` and `show`
	 * In case some one will write code like
	 *     label: {
	 *          show: false,
	 *          position: 'outside',
	 *          fontSize: 18
	 *     },
	 *     emphasis: {
	 *          label: { show: true }
	 *     }
	 * @param {Object} opt
	 * @param {string} key
	 * @param {Array.<string>} subOpts
	 */
	
	
	function defaultEmphasis(opt, key, subOpts) {
	  // Caution: performance sensitive.
	  if (opt) {
	    opt[key] = opt[key] || {};
	    opt.emphasis = opt.emphasis || {};
	    opt.emphasis[key] = opt.emphasis[key] || {}; // Default emphasis option from normal
	
	    for (var i = 0, len = subOpts.length; i < len; i++) {
	      var subOptName = subOpts[i];
	
	      if (!opt.emphasis[key].hasOwnProperty(subOptName) && opt[key].hasOwnProperty(subOptName)) {
	        opt.emphasis[key][subOptName] = opt[key][subOptName];
	      }
	    }
	  }
	}
	
	var TEXT_STYLE_OPTIONS = ['fontStyle', 'fontWeight', 'fontSize', 'fontFamily', 'rich', 'tag', 'color', 'textBorderColor', 'textBorderWidth', 'width', 'height', 'lineHeight', 'align', 'verticalAlign', 'baseline', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY', 'textShadowColor', 'textShadowBlur', 'textShadowOffsetX', 'textShadowOffsetY', 'backgroundColor', 'borderColor', 'borderWidth', 'borderRadius', 'padding']; // modelUtil.LABEL_OPTIONS = modelUtil.TEXT_STYLE_OPTIONS.concat([
	//     'position', 'offset', 'rotate', 'origin', 'show', 'distance', 'formatter',
	//     'fontStyle', 'fontWeight', 'fontSize', 'fontFamily',
	//     // FIXME: deprecated, check and remove it.
	//     'textStyle'
	// ]);
	
	/**
	 * The method do not ensure performance.
	 * data could be [12, 2323, {value: 223}, [1221, 23], {value: [2, 23]}]
	 * This helper method retieves value from data.
	 * @param {string|number|Date|Array|Object} dataItem
	 * @return {number|string|Date|Array.<number|string|Date>}
	 */
	
	function getDataItemValue(dataItem) {
	  return isObject(dataItem) && !isArray(dataItem) && !(dataItem instanceof Date) ? dataItem.value : dataItem;
	}
	/**
	 * data could be [12, 2323, {value: 223}, [1221, 23], {value: [2, 23]}]
	 * This helper method determine if dataItem has extra option besides value
	 * @param {string|number|Date|Array|Object} dataItem
	 */
	
	
	function isDataItemOption(dataItem) {
	  return isObject(dataItem) && !(dataItem instanceof Array); // // markLine data can be array
	  // && !(dataItem[0] && isObject(dataItem[0]) && !(dataItem[0] instanceof Array));
	}
	/**
	 * Mapping to exists for merge.
	 *
	 * @public
	 * @param {Array.<Object>|Array.<module:echarts/model/Component>} exists
	 * @param {Object|Array.<Object>} newCptOptions
	 * @return {Array.<Object>} Result, like [{exist: ..., option: ...}, {}],
	 *                          index of which is the same as exists.
	 */
	
	
	function mappingToExists(exists, newCptOptions) {
	  // Mapping by the order by original option (but not order of
	  // new option) in merge mode. Because we should ensure
	  // some specified index (like xAxisIndex) is consistent with
	  // original option, which is easy to understand, espatially in
	  // media query. And in most case, merge option is used to
	  // update partial option but not be expected to change order.
	  newCptOptions = (newCptOptions || []).slice();
	  var result = zrUtil.map(exists || [], function (obj, index) {
	    return {
	      exist: obj
	    };
	  }); // Mapping by id or name if specified.
	
	  each(newCptOptions, function (cptOption, index) {
	    if (!isObject(cptOption)) {
	      return;
	    } // id has highest priority.
	
	
	    for (var i = 0; i < result.length; i++) {
	      if (!result[i].option // Consider name: two map to one.
	      && cptOption.id != null && result[i].exist.id === cptOption.id + '') {
	        result[i].option = cptOption;
	        newCptOptions[index] = null;
	        return;
	      }
	    }
	
	    for (var i = 0; i < result.length; i++) {
	      var exist = result[i].exist;
	
	      if (!result[i].option // Consider name: two map to one.
	      // Can not match when both ids exist but different.
	      && (exist.id == null || cptOption.id == null) && cptOption.name != null && !isIdInner(cptOption) && !isIdInner(exist) && exist.name === cptOption.name + '') {
	        result[i].option = cptOption;
	        newCptOptions[index] = null;
	        return;
	      }
	    }
	  }); // Otherwise mapping by index.
	
	  each(newCptOptions, function (cptOption, index) {
	    if (!isObject(cptOption)) {
	      return;
	    }
	
	    var i = 0;
	
	    for (; i < result.length; i++) {
	      var exist = result[i].exist;
	
	      if (!result[i].option // Existing model that already has id should be able to
	      // mapped to (because after mapping performed model may
	      // be assigned with a id, whish should not affect next
	      // mapping), except those has inner id.
	      && !isIdInner(exist) // Caution:
	      // Do not overwrite id. But name can be overwritten,
	      // because axis use name as 'show label text'.
	      // 'exist' always has id and name and we dont
	      // need to check it.
	      && cptOption.id == null) {
	        result[i].option = cptOption;
	        break;
	      }
	    }
	
	    if (i >= result.length) {
	      result.push({
	        option: cptOption
	      });
	    }
	  });
	  return result;
	}
	/**
	 * Make id and name for mapping result (result of mappingToExists)
	 * into `keyInfo` field.
	 *
	 * @public
	 * @param {Array.<Object>} Result, like [{exist: ..., option: ...}, {}],
	 *                          which order is the same as exists.
	 * @return {Array.<Object>} The input.
	 */
	
	
	function makeIdAndName(mapResult) {
	  // We use this id to hash component models and view instances
	  // in echarts. id can be specified by user, or auto generated.
	  // The id generation rule ensures new view instance are able
	  // to mapped to old instance when setOption are called in
	  // no-merge mode. So we generate model id by name and plus
	  // type in view id.
	  // name can be duplicated among components, which is convenient
	  // to specify multi components (like series) by one name.
	  // Ensure that each id is distinct.
	  var idMap = zrUtil.createHashMap();
	  each(mapResult, function (item, index) {
	    var existCpt = item.exist;
	    existCpt && idMap.set(existCpt.id, item);
	  });
	  each(mapResult, function (item, index) {
	    var opt = item.option;
	    zrUtil.assert(!opt || opt.id == null || !idMap.get(opt.id) || idMap.get(opt.id) === item, 'id duplicates: ' + (opt && opt.id));
	    opt && opt.id != null && idMap.set(opt.id, item);
	    !item.keyInfo && (item.keyInfo = {});
	  }); // Make name and id.
	
	  each(mapResult, function (item, index) {
	    var existCpt = item.exist;
	    var opt = item.option;
	    var keyInfo = item.keyInfo;
	
	    if (!isObject(opt)) {
	      return;
	    } // name can be overwitten. Consider case: axis.name = '20km'.
	    // But id generated by name will not be changed, which affect
	    // only in that case: setOption with 'not merge mode' and view
	    // instance will be recreated, which can be accepted.
	
	
	    keyInfo.name = opt.name != null ? opt.name + '' : existCpt ? existCpt.name // Avoid diffferent series has the same name,
	    // because name may be used like in color pallet.
	    : DUMMY_COMPONENT_NAME_PREFIX + index;
	
	    if (existCpt) {
	      keyInfo.id = existCpt.id;
	    } else if (opt.id != null) {
	      keyInfo.id = opt.id + '';
	    } else {
	      // Consider this situatoin:
	      //  optionA: [{name: 'a'}, {name: 'a'}, {..}]
	      //  optionB [{..}, {name: 'a'}, {name: 'a'}]
	      // Series with the same name between optionA and optionB
	      // should be mapped.
	      var idNum = 0;
	
	      do {
	        keyInfo.id = '\0' + keyInfo.name + '\0' + idNum++;
	      } while (idMap.get(keyInfo.id));
	    }
	
	    idMap.set(keyInfo.id, item);
	  });
	}
	
	function isNameSpecified(componentModel) {
	  var name = componentModel.name; // Is specified when `indexOf` get -1 or > 0.
	
	  return !!(name && name.indexOf(DUMMY_COMPONENT_NAME_PREFIX));
	}
	/**
	 * @public
	 * @param {Object} cptOption
	 * @return {boolean}
	 */
	
	
	function isIdInner(cptOption) {
	  return isObject(cptOption) && cptOption.id && (cptOption.id + '').indexOf('\0_ec_\0') === 0;
	}
	/**
	 * A helper for removing duplicate items between batchA and batchB,
	 * and in themselves, and categorize by series.
	 *
	 * @param {Array.<Object>} batchA Like: [{seriesId: 2, dataIndex: [32, 4, 5]}, ...]
	 * @param {Array.<Object>} batchB Like: [{seriesId: 2, dataIndex: [32, 4, 5]}, ...]
	 * @return {Array.<Array.<Object>, Array.<Object>>} result: [resultBatchA, resultBatchB]
	 */
	
	
	function compressBatches(batchA, batchB) {
	  var mapA = {};
	  var mapB = {};
	  makeMap(batchA || [], mapA);
	  makeMap(batchB || [], mapB, mapA);
	  return [mapToArray(mapA), mapToArray(mapB)];
	
	  function makeMap(sourceBatch, map, otherMap) {
	    for (var i = 0, len = sourceBatch.length; i < len; i++) {
	      var seriesId = sourceBatch[i].seriesId;
	      var dataIndices = normalizeToArray(sourceBatch[i].dataIndex);
	      var otherDataIndices = otherMap && otherMap[seriesId];
	
	      for (var j = 0, lenj = dataIndices.length; j < lenj; j++) {
	        var dataIndex = dataIndices[j];
	
	        if (otherDataIndices && otherDataIndices[dataIndex]) {
	          otherDataIndices[dataIndex] = null;
	        } else {
	          (map[seriesId] || (map[seriesId] = {}))[dataIndex] = 1;
	        }
	      }
	    }
	  }
	
	  function mapToArray(map, isData) {
	    var result = [];
	
	    for (var i in map) {
	      if (map.hasOwnProperty(i) && map[i] != null) {
	        if (isData) {
	          result.push(+i);
	        } else {
	          var dataIndices = mapToArray(map[i], true);
	          dataIndices.length && result.push({
	            seriesId: i,
	            dataIndex: dataIndices
	          });
	        }
	      }
	    }
	
	    return result;
	  }
	}
	/**
	 * @param {module:echarts/data/List} data
	 * @param {Object} payload Contains dataIndex (means rawIndex) / dataIndexInside / name
	 *                         each of which can be Array or primary type.
	 * @return {number|Array.<number>} dataIndex If not found, return undefined/null.
	 */
	
	
	function queryDataIndex(data, payload) {
	  if (payload.dataIndexInside != null) {
	    return payload.dataIndexInside;
	  } else if (payload.dataIndex != null) {
	    return zrUtil.isArray(payload.dataIndex) ? zrUtil.map(payload.dataIndex, function (value) {
	      return data.indexOfRawIndex(value);
	    }) : data.indexOfRawIndex(payload.dataIndex);
	  } else if (payload.name != null) {
	    return zrUtil.isArray(payload.name) ? zrUtil.map(payload.name, function (value) {
	      return data.indexOfName(value);
	    }) : data.indexOfName(payload.name);
	  }
	}
	/**
	 * Enable property storage to any host object.
	 * Notice: Serialization is not supported.
	 *
	 * For example:
	 * var inner = zrUitl.makeInner();
	 *
	 * function some1(hostObj) {
	 *      inner(hostObj).someProperty = 1212;
	 *      ...
	 * }
	 * function some2() {
	 *      var fields = inner(this);
	 *      fields.someProperty1 = 1212;
	 *      fields.someProperty2 = 'xx';
	 *      ...
	 * }
	 *
	 * @return {Function}
	 */
	
	
	function makeInner() {
	  // Consider different scope by es module import.
	  var key = '__\0ec_inner_' + innerUniqueIndex++ + '_' + Math.random().toFixed(5);
	  return function (hostObj) {
	    return hostObj[key] || (hostObj[key] = {});
	  };
	}
	
	var innerUniqueIndex = 0;
	/**
	 * @param {module:echarts/model/Global} ecModel
	 * @param {string|Object} finder
	 *        If string, e.g., 'geo', means {geoIndex: 0}.
	 *        If Object, could contain some of these properties below:
	 *        {
	 *            seriesIndex, seriesId, seriesName,
	 *            geoIndex, geoId, geoName,
	 *            bmapIndex, bmapId, bmapName,
	 *            xAxisIndex, xAxisId, xAxisName,
	 *            yAxisIndex, yAxisId, yAxisName,
	 *            gridIndex, gridId, gridName,
	 *            ... (can be extended)
	 *        }
	 *        Each properties can be number|string|Array.<number>|Array.<string>
	 *        For example, a finder could be
	 *        {
	 *            seriesIndex: 3,
	 *            geoId: ['aa', 'cc'],
	 *            gridName: ['xx', 'rr']
	 *        }
	 *        xxxIndex can be set as 'all' (means all xxx) or 'none' (means not specify)
	 *        If nothing or null/undefined specified, return nothing.
	 * @param {Object} [opt]
	 * @param {string} [opt.defaultMainType]
	 * @param {Array.<string>} [opt.includeMainTypes]
	 * @return {Object} result like:
	 *        {
	 *            seriesModels: [seriesModel1, seriesModel2],
	 *            seriesModel: seriesModel1, // The first model
	 *            geoModels: [geoModel1, geoModel2],
	 *            geoModel: geoModel1, // The first model
	 *            ...
	 *        }
	 */
	
	function parseFinder(ecModel, finder, opt) {
	  if (zrUtil.isString(finder)) {
	    var obj = {};
	    obj[finder + 'Index'] = 0;
	    finder = obj;
	  }
	
	  var defaultMainType = opt && opt.defaultMainType;
	
	  if (defaultMainType && !has(finder, defaultMainType + 'Index') && !has(finder, defaultMainType + 'Id') && !has(finder, defaultMainType + 'Name')) {
	    finder[defaultMainType + 'Index'] = 0;
	  }
	
	  var result = {};
	  each(finder, function (value, key) {
	    var value = finder[key]; // Exclude 'dataIndex' and other illgal keys.
	
	    if (key === 'dataIndex' || key === 'dataIndexInside') {
	      result[key] = value;
	      return;
	    }
	
	    var parsedKey = key.match(/^(\w+)(Index|Id|Name)$/) || [];
	    var mainType = parsedKey[1];
	    var queryType = (parsedKey[2] || '').toLowerCase();
	
	    if (!mainType || !queryType || value == null || queryType === 'index' && value === 'none' || opt && opt.includeMainTypes && zrUtil.indexOf(opt.includeMainTypes, mainType) < 0) {
	      return;
	    }
	
	    var queryParam = {
	      mainType: mainType
	    };
	
	    if (queryType !== 'index' || value !== 'all') {
	      queryParam[queryType] = value;
	    }
	
	    var models = ecModel.queryComponents(queryParam);
	    result[mainType + 'Models'] = models;
	    result[mainType + 'Model'] = models[0];
	  });
	  return result;
	}
	
	function has(obj, prop) {
	  return obj && obj.hasOwnProperty(prop);
	}
	
	function setAttribute(dom, key, value) {
	  dom.setAttribute ? dom.setAttribute(key, value) : dom[key] = value;
	}
	
	function getAttribute(dom, key) {
	  return dom.getAttribute ? dom.getAttribute(key) : dom[key];
	}
	
	function getTooltipRenderMode(renderModeOption) {
	  if (renderModeOption === 'auto') {
	    // Using html when `document` exists, use richText otherwise
	    return env.domSupported ? 'html' : 'richText';
	  } else {
	    return renderModeOption || 'html';
	  }
	}
	/**
	 * Group a list by key.
	 *
	 * @param {Array} array
	 * @param {Function} getKey
	 *        param {*} Array item
	 *        return {string} key
	 * @return {Object} Result
	 *        {Array}: keys,
	 *        {module:zrender/core/util/HashMap} buckets: {key -> Array}
	 */
	
	
	function groupData(array, getKey) {
	  var buckets = zrUtil.createHashMap();
	  var keys = [];
	  zrUtil.each(array, function (item) {
	    var key = getKey(item);
	    (buckets.get(key) || (keys.push(key), buckets.set(key, []))).push(item);
	  });
	  return {
	    keys: keys,
	    buckets: buckets
	  };
	}
	
	exports.normalizeToArray = normalizeToArray;
	exports.defaultEmphasis = defaultEmphasis;
	exports.TEXT_STYLE_OPTIONS = TEXT_STYLE_OPTIONS;
	exports.getDataItemValue = getDataItemValue;
	exports.isDataItemOption = isDataItemOption;
	exports.mappingToExists = mappingToExists;
	exports.makeIdAndName = makeIdAndName;
	exports.isNameSpecified = isNameSpecified;
	exports.isIdInner = isIdInner;
	exports.compressBatches = compressBatches;
	exports.queryDataIndex = queryDataIndex;
	exports.makeInner = makeInner;
	exports.parseFinder = parseFinder;
	exports.setAttribute = setAttribute;
	exports.getAttribute = getAttribute;
	exports.getTooltipRenderMode = getTooltipRenderMode;
	exports.groupData = groupData;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = capitalize;
	
	var _utils = __webpack_require__(19);
	
	// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
	//
	// A strict capitalization should uppercase the first letter of each word a the sentence.
	// We only handle the first word.
	function capitalize(string) {
	  if (typeof string !== 'string') {
	    throw new Error( false ? "Material-UI: capitalize(string) expects a string argument." : (0, _utils.formatMuiErrorMessage)(7));
	  }
	
	  return string.charAt(0).toUpperCase() + string.slice(1);
	}

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var columnGroup_1 = __webpack_require__(159);
	var column_1 = __webpack_require__(45);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var expressionService_1 = __webpack_require__(121);
	var columnFactory_1 = __webpack_require__(246);
	var displayedGroupCreator_1 = __webpack_require__(314);
	var autoWidthCalculator_1 = __webpack_require__(250);
	var eventService_1 = __webpack_require__(22);
	var columnUtils_1 = __webpack_require__(195);
	var logger_1 = __webpack_require__(68);
	var events_1 = __webpack_require__(29);
	var originalColumnGroup_1 = __webpack_require__(196);
	var groupInstanceIdCreator_1 = __webpack_require__(416);
	var context_1 = __webpack_require__(8);
	var columnAnimationService_1 = __webpack_require__(321);
	var autoGroupColService_1 = __webpack_require__(639);
	var valueCache_1 = __webpack_require__(198);
	var gridApi_1 = __webpack_require__(33);
	var columnApi_1 = __webpack_require__(38);
	var utils_1 = __webpack_require__(10);
	var ColumnController = /** @class */ (function () {
	    function ColumnController() {
	        // header row count, based on user provided columns
	        this.primaryHeaderRowCount = 0;
	        this.secondaryHeaderRowCount = 0;
	        this.secondaryColumnsPresent = false;
	        // header row count, either above, or based on pivoting if we are pivoting
	        this.gridHeaderRowCount = 0;
	        // these are the lists used by the rowRenderer to render nodes. almost the leaf nodes of the above
	        // displayed trees, however it also takes into account if the groups are open or not.
	        this.displayedLeftColumns = [];
	        this.displayedRightColumns = [];
	        this.displayedCenterColumns = [];
	        // all three lists above combined
	        this.allDisplayedColumns = [];
	        // same as above, except trimmed down to only columns within the viewport
	        this.allDisplayedVirtualColumns = [];
	        this.allDisplayedCenterVirtualColumns = [];
	        this.rowGroupColumns = [];
	        this.valueColumns = [];
	        this.pivotColumns = [];
	        this.ready = false;
	        this.autoGroupsNeedBuilding = false;
	        this.pivotMode = false;
	        this.bodyWidth = 0;
	        this.leftWidth = 0;
	        this.rightWidth = 0;
	        this.bodyWidthDirty = true;
	    }
	    ColumnController.prototype.init = function () {
	        var pivotMode = this.gridOptionsWrapper.isPivotMode();
	        this.suppressColumnVirtualisation = this.gridOptionsWrapper.isSuppressColumnVirtualisation();
	        if (this.isPivotSettingAllowed(pivotMode)) {
	            this.pivotMode = pivotMode;
	        }
	        this.usingTreeData = this.gridOptionsWrapper.isTreeData();
	    };
	    ColumnController.prototype.setColumnDefs = function (columnDefs, source) {
	        if (source === void 0) { source = "api"; }
	        var colsPreviouslyExisted = !!this.columnDefs;
	        this.columnDefs = columnDefs;
	        // always invalidate cache on changing columns, as the column id's for the new columns
	        // could overlap with the old id's, so the cache would return old values for new columns.
	        this.valueCache.expire();
	        // NOTE ==================
	        // we should be destroying the existing columns and groups if they exist, for example, the original column
	        // group adds a listener to the columns, it should be also removing the listeners
	        this.autoGroupsNeedBuilding = true;
	        var oldPrimaryColumns = this.primaryColumns;
	        var balancedTreeResult = this.columnFactory.createColumnTree(columnDefs, true, oldPrimaryColumns);
	        this.primaryColumnTree = balancedTreeResult.columnTree;
	        this.primaryHeaderRowCount = balancedTreeResult.treeDept + 1;
	        this.primaryColumns = this.getColumnsFromTree(this.primaryColumnTree);
	        this.extractRowGroupColumns(source, oldPrimaryColumns);
	        this.extractPivotColumns(source, oldPrimaryColumns);
	        this.createValueColumns(source, oldPrimaryColumns);
	        this.ready = true;
	        this.updateGridColumns();
	        this.updateDisplayedColumns(source);
	        this.checkDisplayedVirtualColumns();
	        if (this.gridOptionsWrapper.isDeltaColumnMode() && colsPreviouslyExisted) {
	            this.resetColumnState(true, source);
	        }
	        var eventEverythingChanged = {
	            type: events_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            source: source
	        };
	        this.eventService.dispatchEvent(eventEverythingChanged);
	        var newColumnsLoadedEvent = {
	            type: events_1.Events.EVENT_NEW_COLUMNS_LOADED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(newColumnsLoadedEvent);
	    };
	    ColumnController.prototype.isAutoRowHeightActive = function () {
	        return this.autoRowHeightColumns && this.autoRowHeightColumns.length > 0;
	    };
	    ColumnController.prototype.getAllAutoRowHeightCols = function () {
	        return this.autoRowHeightColumns;
	    };
	    ColumnController.prototype.setVirtualViewportLeftAndRight = function () {
	        if (this.gridOptionsWrapper.isEnableRtl()) {
	            this.viewportLeft = this.bodyWidth - this.scrollPosition - this.scrollWidth;
	            this.viewportRight = this.bodyWidth - this.scrollPosition;
	        }
	        else {
	            this.viewportLeft = this.scrollPosition;
	            this.viewportRight = this.scrollWidth + this.scrollPosition;
	        }
	    };
	    // used by clipboard service, to know what columns to paste into
	    ColumnController.prototype.getDisplayedColumnsStartingAt = function (column) {
	        var currentColumn = column;
	        var result = [];
	        while (currentColumn && utils_1._.exists(currentColumn)) {
	            result.push(currentColumn);
	            currentColumn = this.getDisplayedColAfter(currentColumn);
	        }
	        return result;
	    };
	    // checks what columns are currently displayed due to column virtualisation. fires an event
	    // if the list of columns has changed.
	    // + setColumnWidth(), setVirtualViewportPosition(), setColumnDefs(), sizeColumnsToFit()
	    ColumnController.prototype.checkDisplayedVirtualColumns = function () {
	        // check displayCenterColumnTree exists first, as it won't exist when grid is initialising
	        if (utils_1._.exists(this.displayedCenterColumns)) {
	            var hashBefore = this.allDisplayedVirtualColumns.map(function (column) { return column.getId(); }).join('#');
	            this.updateVirtualSets();
	            var hashAfter = this.allDisplayedVirtualColumns.map(function (column) { return column.getId(); }).join('#');
	            if (hashBefore !== hashAfter) {
	                var event_1 = {
	                    type: events_1.Events.EVENT_VIRTUAL_COLUMNS_CHANGED,
	                    api: this.gridApi,
	                    columnApi: this.columnApi
	                };
	                this.eventService.dispatchEvent(event_1);
	            }
	        }
	    };
	    ColumnController.prototype.setVirtualViewportPosition = function (scrollWidth, scrollPosition) {
	        if (scrollWidth !== this.scrollWidth || scrollPosition !== this.scrollPosition || this.bodyWidthDirty) {
	            this.scrollWidth = scrollWidth;
	            this.scrollPosition = scrollPosition;
	            // we need to call setVirtualViewportLeftAndRight() at least once after the body width changes,
	            // as the viewport can stay the same, but in RTL, if body width changes, we need to work out the
	            // virtual columns again
	            this.bodyWidthDirty = true;
	            this.setVirtualViewportLeftAndRight();
	            if (this.ready) {
	                this.checkDisplayedVirtualColumns();
	            }
	        }
	    };
	    ColumnController.prototype.isPivotMode = function () {
	        return this.pivotMode;
	    };
	    ColumnController.prototype.isPivotSettingAllowed = function (pivot) {
	        if (pivot) {
	            if (this.gridOptionsWrapper.isTreeData()) {
	                console.warn("ag-Grid: Pivot mode not available in conjunction Tree Data i.e. 'gridOptions.treeData: true'");
	                return false;
	            }
	            else {
	                return true;
	            }
	        }
	        else {
	            return true;
	        }
	    };
	    ColumnController.prototype.setPivotMode = function (pivotMode, source) {
	        if (source === void 0) { source = "api"; }
	        if (pivotMode === this.pivotMode) {
	            return;
	        }
	        if (!this.isPivotSettingAllowed(this.pivotMode)) {
	            return;
	        }
	        this.pivotMode = pivotMode;
	        // we need to update grid columns to cover the scenario where user has groupSuppressAutoColumn=true, as
	        // this means we don't use auto group column UNLESS we are in pivot mode (it's mandatory in pivot mode),
	        // so need to updateGridColumn() to check it autoGroupCol needs to be added / removed
	        this.autoGroupsNeedBuilding = true;
	        this.updateGridColumns();
	        this.updateDisplayedColumns(source);
	        var event = {
	            type: events_1.Events.EVENT_COLUMN_PIVOT_MODE_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ColumnController.prototype.getSecondaryPivotColumn = function (pivotKeys, valueColKey) {
	        if (!this.secondaryColumnsPresent) {
	            return null;
	        }
	        var valueColumnToFind = this.getPrimaryColumn(valueColKey);
	        var foundColumn = null;
	        if (this.secondaryColumns) {
	            this.secondaryColumns.forEach(function (column) {
	                var thisPivotKeys = column.getColDef().pivotKeys;
	                var pivotValueColumn = column.getColDef().pivotValueColumn;
	                var pivotKeyMatches = utils_1._.compareArrays(thisPivotKeys, pivotKeys);
	                var pivotValueMatches = pivotValueColumn === valueColumnToFind;
	                if (pivotKeyMatches && pivotValueMatches) {
	                    foundColumn = column;
	                }
	            });
	        }
	        return foundColumn;
	    };
	    ColumnController.prototype.setBeans = function (loggerFactory) {
	        this.logger = loggerFactory.create('ColumnController');
	    };
	    ColumnController.prototype.setFirstRightAndLastLeftPinned = function (source) {
	        var lastLeft;
	        var firstRight;
	        if (this.gridOptionsWrapper.isEnableRtl()) {
	            lastLeft = this.displayedLeftColumns ? this.displayedLeftColumns[0] : null;
	            firstRight = this.displayedRightColumns ? utils_1._.last(this.displayedRightColumns) : null;
	        }
	        else {
	            lastLeft = this.displayedLeftColumns ? utils_1._.last(this.displayedLeftColumns) : null;
	            firstRight = this.displayedRightColumns ? this.displayedRightColumns[0] : null;
	        }
	        this.gridColumns.forEach(function (column) {
	            column.setLastLeftPinned(column === lastLeft, source);
	            column.setFirstRightPinned(column === firstRight, source);
	        });
	    };
	    ColumnController.prototype.autoSizeColumns = function (keys, source) {
	        // because of column virtualisation, we can only do this function on columns that are
	        // actually rendered, as non-rendered columns (outside the viewport and not rendered
	        // due to column virtualisation) are not present. this can result in all rendered columns
	        // getting narrowed, which in turn introduces more rendered columns on the RHS which
	        // did not get autosized in the original run, leaving the visible grid with columns on
	        // the LHS sized, but RHS no. so we keep looping through teh visible columns until
	        // no more cols are available (rendered) to be resized
	        var _this = this;
	        if (source === void 0) { source = "api"; }
	        // keep track of which cols we have resized in here
	        var columnsAutosized = [];
	        // initialise with anything except 0 so that while loop executes at least once
	        var changesThisTimeAround = -1;
	        while (changesThisTimeAround !== 0) {
	            changesThisTimeAround = 0;
	            this.actionOnGridColumns(keys, function (column) {
	                // if already autosized, skip it
	                if (columnsAutosized.indexOf(column) >= 0) {
	                    return false;
	                }
	                // get how wide this col should be
	                var preferredWidth = _this.autoWidthCalculator.getPreferredWidthForColumn(column);
	                // preferredWidth = -1 if this col is not on the screen
	                if (preferredWidth > 0) {
	                    var newWidth = _this.normaliseColumnWidth(column, preferredWidth);
	                    column.setActualWidth(newWidth, source);
	                    columnsAutosized.push(column);
	                    changesThisTimeAround++;
	                }
	                return true;
	            }, source);
	        }
	        if (columnsAutosized.length > 0) {
	            var event_2 = {
	                type: events_1.Events.EVENT_COLUMN_RESIZED,
	                columns: columnsAutosized,
	                column: columnsAutosized.length === 1 ? columnsAutosized[0] : null,
	                finished: true,
	                api: this.gridApi,
	                columnApi: this.columnApi,
	                source: "autosizeColumns"
	            };
	            this.eventService.dispatchEvent(event_2);
	        }
	    };
	    ColumnController.prototype.autoSizeColumn = function (key, source) {
	        if (source === void 0) { source = "api"; }
	        if (key) {
	            this.autoSizeColumns([key], source);
	        }
	    };
	    ColumnController.prototype.autoSizeAllColumns = function (source) {
	        if (source === void 0) { source = "api"; }
	        var allDisplayedColumns = this.getAllDisplayedColumns();
	        this.autoSizeColumns(allDisplayedColumns, source);
	    };
	    ColumnController.prototype.getColumnsFromTree = function (rootColumns) {
	        var result = [];
	        recursiveFindColumns(rootColumns);
	        return result;
	        function recursiveFindColumns(childColumns) {
	            for (var i = 0; i < childColumns.length; i++) {
	                var child = childColumns[i];
	                if (child instanceof column_1.Column) {
	                    result.push(child);
	                }
	                else if (child instanceof originalColumnGroup_1.OriginalColumnGroup) {
	                    recursiveFindColumns(child.getChildren());
	                }
	            }
	        }
	    };
	    ColumnController.prototype.getAllDisplayedColumnGroups = function () {
	        if (this.displayedLeftColumnTree && this.displayedRightColumnTree && this.displayedCentreColumnTree) {
	            return this.displayedLeftColumnTree
	                .concat(this.displayedCentreColumnTree)
	                .concat(this.displayedRightColumnTree);
	        }
	        else {
	            return null;
	        }
	    };
	    // + columnSelectPanel
	    ColumnController.prototype.getPrimaryColumnTree = function () {
	        return this.primaryColumnTree;
	    };
	    // + gridPanel -> for resizing the body and setting top margin
	    ColumnController.prototype.getHeaderRowCount = function () {
	        return this.gridHeaderRowCount;
	    };
	    // + headerRenderer -> setting pinned body width
	    ColumnController.prototype.getLeftDisplayedColumnGroups = function () {
	        return this.displayedLeftColumnTree;
	    };
	    // + headerRenderer -> setting pinned body width
	    ColumnController.prototype.getRightDisplayedColumnGroups = function () {
	        return this.displayedRightColumnTree;
	    };
	    // + headerRenderer -> setting pinned body width
	    ColumnController.prototype.getCenterDisplayedColumnGroups = function () {
	        return this.displayedCentreColumnTree;
	    };
	    ColumnController.prototype.getDisplayedColumnGroups = function (type) {
	        switch (type) {
	            case column_1.Column.PINNED_LEFT:
	                return this.getLeftDisplayedColumnGroups();
	            case column_1.Column.PINNED_RIGHT:
	                return this.getRightDisplayedColumnGroups();
	            default:
	                return this.getCenterDisplayedColumnGroups();
	        }
	    };
	    // gridPanel -> ensureColumnVisible
	    ColumnController.prototype.isColumnDisplayed = function (column) {
	        return this.getAllDisplayedColumns().indexOf(column) >= 0;
	    };
	    // + csvCreator
	    ColumnController.prototype.getAllDisplayedColumns = function () {
	        return this.allDisplayedColumns;
	    };
	    ColumnController.prototype.getAllDisplayedVirtualColumns = function () {
	        return this.allDisplayedVirtualColumns;
	    };
	    ColumnController.prototype.getDisplayedLeftColumnsForRow = function (rowNode) {
	        if (!this.colSpanActive) {
	            return this.displayedLeftColumns;
	        }
	        else {
	            return this.getDisplayedColumnsForRow(rowNode, this.displayedLeftColumns);
	        }
	    };
	    ColumnController.prototype.getDisplayedRightColumnsForRow = function (rowNode) {
	        if (!this.colSpanActive) {
	            return this.displayedRightColumns;
	        }
	        else {
	            return this.getDisplayedColumnsForRow(rowNode, this.displayedRightColumns);
	        }
	    };
	    ColumnController.prototype.getDisplayedColumnsForRow = function (rowNode, displayedColumns, filterCallback, emptySpaceBeforeColumn) {
	        var result = [];
	        var lastConsideredCol = null;
	        var _loop_1 = function (i) {
	            var col = displayedColumns[i];
	            var maxAllowedColSpan = displayedColumns.length - i;
	            var colSpan = Math.min(col.getColSpan(rowNode), maxAllowedColSpan);
	            var columnsToCheckFilter = [col];
	            if (colSpan > 1) {
	                var colsToRemove = colSpan - 1;
	                for (var j = 1; j <= colsToRemove; j++) {
	                    columnsToCheckFilter.push(displayedColumns[i + j]);
	                }
	                i += colsToRemove;
	            }
	            // see which cols we should take out for column virtualisation
	            var filterPasses;
	            if (filterCallback) {
	                // if user provided a callback, means some columns may not be in the viewport.
	                // the user will NOT provide a callback if we are talking about pinned areas,
	                // as pinned areas have no horizontal scroll and do not virtualise the columns.
	                // if lots of columns, that means column spanning, and we set filterPasses = true
	                // if one or more of the columns spanned pass the filter.
	                filterPasses = false;
	                columnsToCheckFilter.forEach(function (colForFilter) {
	                    if (filterCallback(colForFilter)) {
	                        filterPasses = true;
	                    }
	                });
	            }
	            else {
	                filterPasses = true;
	            }
	            if (filterPasses) {
	                if (result.length === 0 && lastConsideredCol) {
	                    var gapBeforeColumn = emptySpaceBeforeColumn ? emptySpaceBeforeColumn(col) : false;
	                    if (gapBeforeColumn) {
	                        result.push(lastConsideredCol);
	                    }
	                }
	                result.push(col);
	            }
	            lastConsideredCol = col;
	            out_i_1 = i;
	        };
	        var out_i_1;
	        for (var i = 0; i < displayedColumns.length; i++) {
	            _loop_1(i);
	            i = out_i_1;
	        }
	        return result;
	    };
	    // + rowRenderer
	    // if we are not column spanning, this just returns back the virtual centre columns,
	    // however if we are column spanning, then different rows can have different virtual
	    // columns, so we have to work out the list for each individual row.
	    ColumnController.prototype.getAllDisplayedCenterVirtualColumnsForRow = function (rowNode) {
	        var _this = this;
	        if (!this.colSpanActive) {
	            return this.allDisplayedCenterVirtualColumns;
	        }
	        var emptySpaceBeforeColumn = function (col) { return col.getLeft() > _this.viewportLeft; };
	        // if doing column virtualisation, then we filter based on the viewport.
	        var filterCallback = this.suppressColumnVirtualisation ? null : this.isColumnInViewport.bind(this);
	        return this.getDisplayedColumnsForRow(rowNode, this.displayedCenterColumns, filterCallback, emptySpaceBeforeColumn);
	    };
	    ColumnController.prototype.isColumnInViewport = function (col) {
	        var columnLeft = col.getLeft();
	        var columnRight = col.getLeft() + col.getActualWidth();
	        // adding 200 for buffer size, so some cols off viewport are rendered.
	        // this helps horizontal scrolling so user rarely sees white space (unless
	        // they scroll horizontally fast). however we are conservative, as the more
	        // buffer the slower the vertical redraw speed
	        var leftBounds = this.viewportLeft - 200;
	        var rightBounds = this.viewportRight + 200;
	        var columnToMuchLeft = columnLeft < leftBounds && columnRight < leftBounds;
	        var columnToMuchRight = columnLeft > rightBounds && columnRight > rightBounds;
	        return !columnToMuchLeft && !columnToMuchRight;
	    };
	    // used by:
	    // + angularGrid -> setting pinned body width
	    // note: this should be cached
	    ColumnController.prototype.getPinnedLeftContainerWidth = function () {
	        return this.getWidthOfColsInList(this.displayedLeftColumns);
	    };
	    // note: this should be cached
	    ColumnController.prototype.getPinnedRightContainerWidth = function () {
	        return this.getWidthOfColsInList(this.displayedRightColumns);
	    };
	    ColumnController.prototype.updatePrimaryColumnList = function (keys, masterList, actionIsAdd, columnCallback, eventType, source) {
	        var _this = this;
	        if (source === void 0) { source = "api"; }
	        if (!keys || utils_1._.missingOrEmpty(keys)) {
	            return;
	        }
	        var atLeastOne = false;
	        keys.forEach(function (key) {
	            var columnToAdd = _this.getPrimaryColumn(key);
	            if (!columnToAdd) {
	                return;
	            }
	            if (actionIsAdd) {
	                if (masterList.indexOf(columnToAdd) >= 0) {
	                    return;
	                }
	                masterList.push(columnToAdd);
	            }
	            else {
	                if (masterList.indexOf(columnToAdd) < 0) {
	                    return;
	                }
	                utils_1._.removeFromArray(masterList, columnToAdd);
	            }
	            columnCallback(columnToAdd);
	            atLeastOne = true;
	        });
	        if (!atLeastOne) {
	            return;
	        }
	        if (this.autoGroupsNeedBuilding) {
	            this.updateGridColumns();
	        }
	        this.updateDisplayedColumns(source);
	        var event = {
	            type: eventType,
	            columns: masterList,
	            column: masterList.length === 1 ? masterList[0] : null,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            source: source
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ColumnController.prototype.setRowGroupColumns = function (colKeys, source) {
	        if (source === void 0) { source = "api"; }
	        this.autoGroupsNeedBuilding = true;
	        this.setPrimaryColumnList(colKeys, this.rowGroupColumns, events_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.setRowGroupActive.bind(this), source);
	    };
	    ColumnController.prototype.setRowGroupActive = function (active, column, source) {
	        if (active === column.isRowGroupActive()) {
	            return;
	        }
	        column.setRowGroupActive(active, source);
	        if (!active && !this.gridOptionsWrapper.isSuppressMakeColumnVisibleAfterUnGroup()) {
	            column.setVisible(true, source);
	        }
	    };
	    ColumnController.prototype.addRowGroupColumn = function (key, source) {
	        if (source === void 0) { source = "api"; }
	        if (key) {
	            this.addRowGroupColumns([key], source);
	        }
	    };
	    ColumnController.prototype.addRowGroupColumns = function (keys, source) {
	        if (source === void 0) { source = "api"; }
	        this.autoGroupsNeedBuilding = true;
	        this.updatePrimaryColumnList(keys, this.rowGroupColumns, true, this.setRowGroupActive.bind(this, true), events_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, source);
	    };
	    ColumnController.prototype.removeRowGroupColumns = function (keys, source) {
	        if (source === void 0) { source = "api"; }
	        this.autoGroupsNeedBuilding = true;
	        this.updatePrimaryColumnList(keys, this.rowGroupColumns, false, this.setRowGroupActive.bind(this, false), events_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, source);
	    };
	    ColumnController.prototype.removeRowGroupColumn = function (key, source) {
	        if (source === void 0) { source = "api"; }
	        if (key) {
	            this.removeRowGroupColumns([key], source);
	        }
	    };
	    ColumnController.prototype.addPivotColumns = function (keys, source) {
	        if (source === void 0) { source = "api"; }
	        this.updatePrimaryColumnList(keys, this.pivotColumns, true, function (column) { return column.setPivotActive(true, source); }, events_1.Events.EVENT_COLUMN_PIVOT_CHANGED, source);
	    };
	    ColumnController.prototype.setPivotColumns = function (colKeys, source) {
	        if (source === void 0) { source = "api"; }
	        this.setPrimaryColumnList(colKeys, this.pivotColumns, events_1.Events.EVENT_COLUMN_PIVOT_CHANGED, function (added, column) {
	            column.setPivotActive(added, source);
	        }, source);
	    };
	    ColumnController.prototype.addPivotColumn = function (key, source) {
	        if (source === void 0) { source = "api"; }
	        this.addPivotColumns([key], source);
	    };
	    ColumnController.prototype.removePivotColumns = function (keys, source) {
	        if (source === void 0) { source = "api"; }
	        this.updatePrimaryColumnList(keys, this.pivotColumns, false, function (column) { return column.setPivotActive(false, source); }, events_1.Events.EVENT_COLUMN_PIVOT_CHANGED, source);
	    };
	    ColumnController.prototype.removePivotColumn = function (key, source) {
	        if (source === void 0) { source = "api"; }
	        this.removePivotColumns([key], source);
	    };
	    ColumnController.prototype.setPrimaryColumnList = function (colKeys, masterList, eventName, columnCallback, source) {
	        var _this = this;
	        masterList.length = 0;
	        if (utils_1._.exists(colKeys)) {
	            colKeys.forEach(function (key) {
	                var column = _this.getPrimaryColumn(key);
	                if (column) {
	                    masterList.push(column);
	                }
	            });
	        }
	        this.primaryColumns.forEach(function (column) {
	            var added = masterList.indexOf(column) >= 0;
	            columnCallback(added, column);
	        });
	        if (this.autoGroupsNeedBuilding) {
	            this.updateGridColumns();
	        }
	        this.updateDisplayedColumns(source);
	        var event = {
	            type: eventName,
	            columns: masterList,
	            column: masterList.length === 1 ? masterList[0] : null,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            source: source
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ColumnController.prototype.setValueColumns = function (colKeys, source) {
	        if (source === void 0) { source = "api"; }
	        this.setPrimaryColumnList(colKeys, this.valueColumns, events_1.Events.EVENT_COLUMN_VALUE_CHANGED, this.setValueActive.bind(this), source);
	    };
	    ColumnController.prototype.setValueActive = function (active, column, source) {
	        if (active === column.isValueActive()) {
	            return;
	        }
	        column.setValueActive(active, source);
	        if (active && !column.getAggFunc()) {
	            var defaultAggFunc = this.aggFuncService.getDefaultAggFunc(column);
	            column.setAggFunc(defaultAggFunc);
	        }
	    };
	    ColumnController.prototype.addValueColumns = function (keys, source) {
	        if (source === void 0) { source = "api"; }
	        this.updatePrimaryColumnList(keys, this.valueColumns, true, this.setValueActive.bind(this, true), events_1.Events.EVENT_COLUMN_VALUE_CHANGED, source);
	    };
	    ColumnController.prototype.addValueColumn = function (colKey, source) {
	        if (source === void 0) { source = "api"; }
	        if (colKey) {
	            this.addValueColumns([colKey], source);
	        }
	    };
	    ColumnController.prototype.removeValueColumn = function (colKey, source) {
	        if (source === void 0) { source = "api"; }
	        this.removeValueColumns([colKey], source);
	    };
	    ColumnController.prototype.removeValueColumns = function (keys, source) {
	        if (source === void 0) { source = "api"; }
	        this.updatePrimaryColumnList(keys, this.valueColumns, false, this.setValueActive.bind(this, false), events_1.Events.EVENT_COLUMN_VALUE_CHANGED, source);
	    };
	    // returns the width we can set to this col, taking into consideration min and max widths
	    ColumnController.prototype.normaliseColumnWidth = function (column, newWidth) {
	        if (newWidth < column.getMinWidth()) {
	            newWidth = column.getMinWidth();
	        }
	        if (column.isGreaterThanMax(newWidth)) {
	            newWidth = column.getMaxWidth();
	        }
	        return newWidth;
	    };
	    ColumnController.prototype.getPrimaryOrGridColumn = function (key) {
	        var column = this.getPrimaryColumn(key);
	        if (column) {
	            return column;
	        }
	        else {
	            return this.getGridColumn(key);
	        }
	    };
	    ColumnController.prototype.setColumnWidth = function (key, // @key - the column who's size we want to change
	    newWidth, // @newWidth - width in pixels
	    shiftKey, // @takeFromAdjacent - if user has 'shift' pressed, then pixels are taken from adjacent column
	    finished, // @finished - ends up in the event, tells the user if more events are to come
	    source) {
	        if (source === void 0) { source = "api"; }
	        var col = this.getPrimaryOrGridColumn(key);
	        if (!col) {
	            return;
	        }
	        var sets = [];
	        sets.push({
	            width: newWidth,
	            ratios: [1],
	            columns: [col]
	        });
	        // if user wants to do shift resize by default, then we invert the shift operation
	        var defaultIsShift = this.gridOptionsWrapper.getColResizeDefault() === 'shift';
	        if (defaultIsShift) {
	            shiftKey = !shiftKey;
	        }
	        if (shiftKey) {
	            var otherCol = this.getDisplayedColAfter(col);
	            if (!otherCol) {
	                return;
	            }
	            var widthDiff = col.getActualWidth() - newWidth;
	            var otherColWidth = otherCol.getActualWidth() + widthDiff;
	            sets.push({
	                width: otherColWidth,
	                ratios: [1],
	                columns: [otherCol]
	            });
	        }
	        this.resizeColumnSets(sets, finished, source);
	    };
	    ColumnController.prototype.checkMinAndMaxWidthsForSet = function (columnResizeSet) {
	        var columns = columnResizeSet.columns, width = columnResizeSet.width;
	        // every col has a min width, so sum them all up and see if we have enough room
	        // for all the min widths
	        var minWidthAccumulated = 0;
	        var maxWidthAccumulated = 0;
	        var maxWidthActive = true;
	        columns.forEach(function (col) {
	            minWidthAccumulated += col.getMinWidth();
	            if (col.getMaxWidth() > 0) {
	                maxWidthAccumulated += col.getMaxWidth();
	            }
	            else {
	                // if at least one columns has no max width, it means the group of columns
	                // then has no max width, as at least one column can take as much width as possible
	                maxWidthActive = false;
	            }
	        });
	        var minWidthPasses = width >= minWidthAccumulated;
	        var maxWidthPasses = !maxWidthActive || (width <= maxWidthAccumulated);
	        return minWidthPasses && maxWidthPasses;
	    };
	    // method takes sets of columns and resizes them. either all sets will be resized, or nothing
	    // be resized. this is used for example when user tries to resize a group and holds shift key,
	    // then both the current group (grows), and the adjacent group (shrinks), will get resized,
	    // so that's two sets for this method.
	    ColumnController.prototype.resizeColumnSets = function (resizeSets, finished, source) {
	        var passMinMaxCheck = utils_1._.every(resizeSets, this.checkMinAndMaxWidthsForSet.bind(this));
	        if (!passMinMaxCheck) {
	            // even though we are not going to resize beyond min/max size, we still need to raise event when finished
	            if (finished) {
	                var columns = resizeSets && resizeSets.length > 0 ? resizeSets[0].columns : null;
	                var event_3 = {
	                    type: events_1.Events.EVENT_COLUMN_RESIZED,
	                    columns: columns,
	                    column: columns && columns.length === 1 ? columns[0] : null,
	                    finished: finished,
	                    api: this.gridApi,
	                    columnApi: this.columnApi,
	                    source: source
	                };
	                this.eventService.dispatchEvent(event_3);
	            }
	            return; // don't resize!
	        }
	        var changedCols = [];
	        var allCols = [];
	        resizeSets.forEach(function (set) {
	            var width = set.width, columns = set.columns, ratios = set.ratios;
	            // keep track of pixels used, and last column gets the remaining,
	            // to cater for rounding errors, and min width adjustments
	            var newWidths = {};
	            var finishedCols = {};
	            columns.forEach(function (col) { return allCols.push(col); });
	            // the loop below goes through each col. if a col exceeds it's min/max width,
	            // it then gets set to its min/max width and the column is removed marked as 'finished'
	            // and the calculation is done again leaving this column out. take for example columns
	            // {A, width: 50, maxWidth: 100}
	            // {B, width: 50}
	            // {C, width: 50}
	            // and then the set is set to width 600 - on the first pass the grid tries to set each column
	            // to 200. it checks A and sees 200 > 100 and so sets the width to 100. col A is then marked
	            // as 'finished' and the calculation is done again with the remaining cols B and C, which end up
	            // splitting the remaining 500 pixels.
	            var finishedColsGrew = true;
	            var loopCount = 0;
	            var _loop_2 = function () {
	                loopCount++;
	                if (loopCount > 1000) {
	                    // this should never happen, but in the future, someone might introduce a bug here,
	                    // so we stop the browser from hanging and report bug properly
	                    console.error('ag-Grid: infinite loop in resizeColumnSets');
	                    return "break";
	                }
	                finishedColsGrew = false;
	                var subsetCols = [];
	                var subsetRatios = [];
	                var subsetRatioTotal = 0;
	                var pixelsToDistribute = width;
	                columns.forEach(function (col, index) {
	                    var thisColFinished = finishedCols[col.getId()];
	                    if (thisColFinished) {
	                        pixelsToDistribute -= newWidths[col.getId()];
	                    }
	                    else {
	                        subsetCols.push(col);
	                        var ratioThisCol = ratios[index];
	                        subsetRatioTotal += ratioThisCol;
	                        subsetRatios.push(ratioThisCol);
	                    }
	                });
	                // because we are not using all of the ratios (cols can be missing),
	                // we scale the ratio. if all columns are included, then subsetRatioTotal=1,
	                // and so the ratioScale will be 1.
	                var ratioScale = 1 / subsetRatioTotal;
	                subsetCols.forEach(function (col, index) {
	                    var lastCol = index === (subsetCols.length - 1);
	                    var colNewWidth;
	                    if (lastCol) {
	                        colNewWidth = pixelsToDistribute;
	                    }
	                    else {
	                        colNewWidth = Math.round(ratios[index] * width * ratioScale);
	                        pixelsToDistribute -= colNewWidth;
	                    }
	                    if (colNewWidth < col.getMinWidth()) {
	                        colNewWidth = col.getMinWidth();
	                        finishedCols[col.getId()] = true;
	                        finishedColsGrew = true;
	                    }
	                    else if (col.getMaxWidth() > 0 && colNewWidth > col.getMaxWidth()) {
	                        colNewWidth = col.getMaxWidth();
	                        finishedCols[col.getId()] = true;
	                        finishedColsGrew = true;
	                    }
	                    newWidths[col.getId()] = colNewWidth;
	                });
	            };
	            while (finishedColsGrew) {
	                var state_1 = _loop_2();
	                if (state_1 === "break")
	                    break;
	            }
	            columns.forEach(function (col) {
	                var newWidth = newWidths[col.getId()];
	                if (col.getActualWidth() !== newWidth) {
	                    col.setActualWidth(newWidth);
	                    changedCols.push(col);
	                }
	            });
	        });
	        // if no cols changed, then no need to update more or send event.
	        var atLeastOneColChanged = changedCols.length > 0;
	        if (atLeastOneColChanged) {
	            this.setLeftValues(source);
	            this.updateBodyWidths();
	            this.checkDisplayedVirtualColumns();
	        }
	        // check for change first, to avoid unnecessary firing of events
	        // however we always fire 'finished' events. this is important
	        // when groups are resized, as if the group is changing slowly,
	        // eg 1 pixel at a time, then each change will fire change events
	        // in all the columns in the group, but only one with get the pixel.
	        if (atLeastOneColChanged || finished) {
	            var event_4 = {
	                type: events_1.Events.EVENT_COLUMN_RESIZED,
	                columns: allCols,
	                column: allCols.length === 1 ? allCols[0] : null,
	                finished: finished,
	                api: this.gridApi,
	                columnApi: this.columnApi,
	                source: source
	            };
	            this.eventService.dispatchEvent(event_4);
	        }
	    };
	    ColumnController.prototype.setColumnAggFunc = function (column, aggFunc, source) {
	        if (source === void 0) { source = "api"; }
	        if (column) {
	            column.setAggFunc(aggFunc);
	            var event_5 = {
	                type: events_1.Events.EVENT_COLUMN_VALUE_CHANGED,
	                columns: [column],
	                column: column,
	                api: this.gridApi,
	                columnApi: this.columnApi,
	                source: source
	            };
	            this.eventService.dispatchEvent(event_5);
	        }
	    };
	    ColumnController.prototype.moveRowGroupColumn = function (fromIndex, toIndex, source) {
	        if (source === void 0) { source = "api"; }
	        var column = this.rowGroupColumns[fromIndex];
	        this.rowGroupColumns.splice(fromIndex, 1);
	        this.rowGroupColumns.splice(toIndex, 0, column);
	        var event = {
	            type: events_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED,
	            columns: this.rowGroupColumns,
	            column: this.rowGroupColumns.length === 1 ? this.rowGroupColumns[0] : null,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            source: source
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ColumnController.prototype.moveColumns = function (columnsToMoveKeys, toIndex, source) {
	        if (source === void 0) { source = "api"; }
	        this.columnAnimationService.start();
	        if (toIndex > this.gridColumns.length - columnsToMoveKeys.length) {
	            console.warn('ag-Grid: tried to insert columns in invalid location, toIndex = ' + toIndex);
	            console.warn('ag-Grid: remember that you should not count the moving columns when calculating the new index');
	            return;
	        }
	        // we want to pull all the columns out first and put them into an ordered list
	        var columnsToMove = this.getGridColumns(columnsToMoveKeys);
	        var failedRules = !this.doesMovePassRules(columnsToMove, toIndex);
	        if (failedRules) {
	            return;
	        }
	        utils_1._.moveInArray(this.gridColumns, columnsToMove, toIndex);
	        this.updateDisplayedColumns(source);
	        var event = {
	            type: events_1.Events.EVENT_COLUMN_MOVED,
	            columns: columnsToMove,
	            column: columnsToMove.length === 1 ? columnsToMove[0] : null,
	            toIndex: toIndex,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            source: source
	        };
	        this.eventService.dispatchEvent(event);
	        this.columnAnimationService.finish();
	    };
	    ColumnController.prototype.doesMovePassRules = function (columnsToMove, toIndex) {
	        // make a copy of what the grid columns would look like after the move
	        var proposedColumnOrder = this.gridColumns.slice();
	        utils_1._.moveInArray(proposedColumnOrder, columnsToMove, toIndex);
	        // then check that the new proposed order of the columns passes all rules
	        if (!this.doesMovePassMarryChildren(proposedColumnOrder)) {
	            return false;
	        }
	        if (!this.doesMovePassLockedPositions(proposedColumnOrder)) {
	            return false;
	        }
	        return true;
	    };
	    ColumnController.prototype.doesMovePassLockedPositions = function (proposedColumnOrder) {
	        var foundNonLocked = false;
	        var rulePassed = true;
	        // go though the cols, see if any non-locked appear before any locked
	        proposedColumnOrder.forEach(function (col) {
	            if (col.getColDef().lockPosition) {
	                if (foundNonLocked) {
	                    rulePassed = false;
	                }
	            }
	            else {
	                foundNonLocked = true;
	            }
	        });
	        return rulePassed;
	    };
	    ColumnController.prototype.doesMovePassMarryChildren = function (allColumnsCopy) {
	        var rulePassed = true;
	        this.columnUtils.depthFirstOriginalTreeSearch(null, this.gridBalancedTree, function (child) {
	            if (!(child instanceof originalColumnGroup_1.OriginalColumnGroup)) {
	                return;
	            }
	            var columnGroup = child;
	            var marryChildren = columnGroup.getColGroupDef() && columnGroup.getColGroupDef().marryChildren;
	            if (!marryChildren) {
	                return;
	            }
	            var newIndexes = [];
	            columnGroup.getLeafColumns().forEach(function (col) {
	                var newColIndex = allColumnsCopy.indexOf(col);
	                newIndexes.push(newColIndex);
	            });
	            var maxIndex = Math.max.apply(Math, newIndexes);
	            var minIndex = Math.min.apply(Math, newIndexes);
	            // spread is how far the first column in this group is away from the last column
	            var spread = maxIndex - minIndex;
	            var maxSpread = columnGroup.getLeafColumns().length - 1;
	            // if the columns
	            if (spread > maxSpread) {
	                rulePassed = false;
	            }
	            // console.log(`maxIndex = ${maxIndex}, minIndex = ${minIndex}, spread = ${spread}, maxSpread = ${maxSpread}, fail = ${spread > (count-1)}`)
	            // console.log(allColumnsCopy.map( col => col.getColDef().field).join(','));
	        });
	        return rulePassed;
	    };
	    ColumnController.prototype.moveColumn = function (key, toIndex, source) {
	        if (source === void 0) { source = "api"; }
	        this.moveColumns([key], toIndex, source);
	    };
	    ColumnController.prototype.moveColumnByIndex = function (fromIndex, toIndex, source) {
	        if (source === void 0) { source = "api"; }
	        var column = this.gridColumns[fromIndex];
	        this.moveColumn(column, toIndex, source);
	    };
	    // used by:
	    // + angularGrid -> for setting body width
	    // + rowController -> setting main row widths (when inserting and resizing)
	    // need to cache this
	    ColumnController.prototype.getBodyContainerWidth = function () {
	        return this.bodyWidth;
	    };
	    ColumnController.prototype.getContainerWidth = function (pinned) {
	        switch (pinned) {
	            case column_1.Column.PINNED_LEFT:
	                return this.leftWidth;
	            case column_1.Column.PINNED_RIGHT:
	                return this.rightWidth;
	            default:
	                return this.bodyWidth;
	        }
	    };
	    // after setColumnWidth or updateGroupsAndDisplayedColumns
	    ColumnController.prototype.updateBodyWidths = function () {
	        var newBodyWidth = this.getWidthOfColsInList(this.displayedCenterColumns);
	        var newLeftWidth = this.getWidthOfColsInList(this.displayedLeftColumns);
	        var newRightWidth = this.getWidthOfColsInList(this.displayedRightColumns);
	        // this is used by virtual col calculation, for RTL only, as a change to body width can impact displayed
	        // columns, due to RTL inverting the y coordinates
	        this.bodyWidthDirty = this.bodyWidth !== newBodyWidth;
	        var atLeastOneChanged = this.bodyWidth !== newBodyWidth || this.leftWidth !== newLeftWidth || this.rightWidth !== newRightWidth;
	        if (atLeastOneChanged) {
	            this.bodyWidth = newBodyWidth;
	            this.leftWidth = newLeftWidth;
	            this.rightWidth = newRightWidth;
	            // when this fires, it is picked up by the gridPanel, which ends up in
	            // gridPanel calling setWidthAndScrollPosition(), which in turn calls setVirtualViewportPosition()
	            var event_6 = {
	                type: events_1.Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED,
	                api: this.gridApi,
	                columnApi: this.columnApi
	            };
	            this.eventService.dispatchEvent(event_6);
	        }
	    };
	    // + rowController
	    ColumnController.prototype.getValueColumns = function () {
	        return this.valueColumns ? this.valueColumns : [];
	    };
	    // + rowController
	    ColumnController.prototype.getPivotColumns = function () {
	        return this.pivotColumns ? this.pivotColumns : [];
	    };
	    // + clientSideRowModel
	    ColumnController.prototype.isPivotActive = function () {
	        return this.pivotColumns && this.pivotColumns.length > 0 && this.pivotMode;
	    };
	    // + toolPanel
	    ColumnController.prototype.getRowGroupColumns = function () {
	        return this.rowGroupColumns ? this.rowGroupColumns : [];
	    };
	    // + rowController -> while inserting rows
	    ColumnController.prototype.getDisplayedCenterColumns = function () {
	        return this.displayedCenterColumns;
	    };
	    // + rowController -> while inserting rows
	    ColumnController.prototype.getDisplayedLeftColumns = function () {
	        return this.displayedLeftColumns;
	    };
	    ColumnController.prototype.getDisplayedRightColumns = function () {
	        return this.displayedRightColumns;
	    };
	    ColumnController.prototype.getDisplayedColumns = function (type) {
	        switch (type) {
	            case column_1.Column.PINNED_LEFT:
	                return this.getDisplayedLeftColumns();
	            case column_1.Column.PINNED_RIGHT:
	                return this.getDisplayedRightColumns();
	            default:
	                return this.getDisplayedCenterColumns();
	        }
	    };
	    // used by:
	    // + clientSideRowController -> sorting, building quick filter text
	    // + headerRenderer -> sorting (clearing icon)
	    ColumnController.prototype.getAllPrimaryColumns = function () {
	        return this.primaryColumns ? this.primaryColumns.slice() : null;
	    };
	    ColumnController.prototype.getSecondaryColumns = function () {
	        return this.secondaryColumns ? this.secondaryColumns.slice() : null;
	    };
	    ColumnController.prototype.getAllColumnsForQuickFilter = function () {
	        return this.columnsForQuickFilter;
	    };
	    // + moveColumnController
	    ColumnController.prototype.getAllGridColumns = function () {
	        return this.gridColumns;
	    };
	    ColumnController.prototype.isEmpty = function () {
	        return utils_1._.missingOrEmpty(this.gridColumns);
	    };
	    ColumnController.prototype.isRowGroupEmpty = function () {
	        return utils_1._.missingOrEmpty(this.rowGroupColumns);
	    };
	    ColumnController.prototype.setColumnVisible = function (key, visible, source) {
	        if (source === void 0) { source = "api"; }
	        this.setColumnsVisible([key], visible, source);
	    };
	    ColumnController.prototype.setColumnsVisible = function (keys, visible, source) {
	        var _this = this;
	        if (source === void 0) { source = "api"; }
	        this.columnAnimationService.start();
	        this.actionOnGridColumns(keys, function (column) {
	            if (column.isVisible() !== visible) {
	                column.setVisible(visible, source);
	                return true;
	            }
	            else {
	                return false;
	            }
	        }, source, function () {
	            var event = {
	                type: events_1.Events.EVENT_COLUMN_VISIBLE,
	                visible: visible,
	                column: null,
	                columns: null,
	                api: _this.gridApi,
	                columnApi: _this.columnApi,
	                source: source
	            };
	            return event;
	        });
	        this.columnAnimationService.finish();
	    };
	    ColumnController.prototype.setColumnPinned = function (key, pinned, source) {
	        if (source === void 0) { source = "api"; }
	        if (key) {
	            this.setColumnsPinned([key], pinned, source);
	        }
	    };
	    ColumnController.prototype.setColumnsPinned = function (keys, pinned, source) {
	        var _this = this;
	        if (source === void 0) { source = "api"; }
	        if (this.gridOptionsWrapper.getDomLayout() === 'print') {
	            console.warn("Changing the column pinning status is not allowed with domLayout='print'");
	            return;
	        }
	        this.columnAnimationService.start();
	        var actualPinned;
	        if (pinned === true || pinned === column_1.Column.PINNED_LEFT) {
	            actualPinned = column_1.Column.PINNED_LEFT;
	        }
	        else if (pinned === column_1.Column.PINNED_RIGHT) {
	            actualPinned = column_1.Column.PINNED_RIGHT;
	        }
	        else {
	            actualPinned = null;
	        }
	        this.actionOnGridColumns(keys, function (col) {
	            if (col.getPinned() !== actualPinned) {
	                col.setPinned(actualPinned);
	                return true;
	            }
	            else {
	                return false;
	            }
	        }, source, function () {
	            var event = {
	                type: events_1.Events.EVENT_COLUMN_PINNED,
	                pinned: actualPinned,
	                column: null,
	                columns: null,
	                api: _this.gridApi,
	                columnApi: _this.columnApi,
	                source: source
	            };
	            return event;
	        });
	        this.columnAnimationService.finish();
	    };
	    // does an action on a set of columns. provides common functionality for looking up the
	    // columns based on key, getting a list of effected columns, and then updated the event
	    // with either one column (if it was just one col) or a list of columns
	    // used by: autoResize, setVisible, setPinned
	    ColumnController.prototype.actionOnGridColumns = function (// the column keys this action will be on
	    keys, 
	    // the action to do - if this returns false, the column was skipped
	    // and won't be included in the event
	    action, 
	    // should return back a column event of the right type
	    source, createEvent) {
	        var _this = this;
	        if (utils_1._.missingOrEmpty(keys)) {
	            return;
	        }
	        var updatedColumns = [];
	        keys.forEach(function (key) {
	            var column = _this.getGridColumn(key);
	            if (!column) {
	                return;
	            }
	            // need to check for false with type (ie !== instead of !=)
	            // as not returning anything (undefined) would also be false
	            var resultOfAction = action(column);
	            if (resultOfAction !== false) {
	                updatedColumns.push(column);
	            }
	        });
	        if (updatedColumns.length === 0) {
	            return;
	        }
	        this.updateDisplayedColumns(source);
	        if (utils_1._.exists(createEvent) && createEvent) {
	            var event_7 = createEvent();
	            event_7.columns = updatedColumns;
	            event_7.column = updatedColumns.length === 1 ? updatedColumns[0] : null;
	            this.eventService.dispatchEvent(event_7);
	        }
	    };
	    ColumnController.prototype.getDisplayedColBefore = function (col) {
	        var allDisplayedColumns = this.getAllDisplayedColumns();
	        var oldIndex = allDisplayedColumns.indexOf(col);
	        if (oldIndex > 0) {
	            return allDisplayedColumns[oldIndex - 1];
	        }
	        else {
	            return null;
	        }
	    };
	    // used by:
	    // + rowRenderer -> for navigation
	    ColumnController.prototype.getDisplayedColAfter = function (col) {
	        var allDisplayedColumns = this.getAllDisplayedColumns();
	        var oldIndex = allDisplayedColumns.indexOf(col);
	        if (oldIndex < (allDisplayedColumns.length - 1)) {
	            return allDisplayedColumns[oldIndex + 1];
	        }
	        else {
	            return null;
	        }
	    };
	    ColumnController.prototype.getDisplayedGroupAfter = function (columnGroup) {
	        // pick one col in this group at random
	        var col = columnGroup.getDisplayedLeafColumns()[0];
	        var requiredLevel = columnGroup.getOriginalColumnGroup().getLevel();
	        while (true) {
	            // keep moving to the next col, until we get to another group
	            col = this.getDisplayedColAfter(col);
	            // if no col after, means no group after
	            if (!col) {
	                return null;
	            }
	            // get group at same level as the one we are looking for
	            var groupPointer = col.getParent();
	            while (groupPointer.getOriginalColumnGroup().getLevel() !== requiredLevel) {
	                groupPointer = groupPointer.getParent();
	            }
	            if (groupPointer !== columnGroup) {
	                return groupPointer;
	            }
	        }
	    };
	    ColumnController.prototype.isPinningLeft = function () {
	        return this.displayedLeftColumns.length > 0;
	    };
	    ColumnController.prototype.isPinningRight = function () {
	        return this.displayedRightColumns.length > 0;
	    };
	    ColumnController.prototype.getPrimaryAndSecondaryAndAutoColumns = function () {
	        var result = this.primaryColumns ? this.primaryColumns.slice(0) : [];
	        if (this.groupAutoColumns && utils_1._.exists(this.groupAutoColumns)) {
	            this.groupAutoColumns.forEach(function (col) { return result.push(col); });
	        }
	        if (this.secondaryColumnsPresent && this.secondaryColumns) {
	            this.secondaryColumns.forEach(function (column) { return result.push(column); });
	        }
	        return result;
	    };
	    ColumnController.prototype.createStateItemFromColumn = function (column) {
	        var rowGroupIndex = column.isRowGroupActive() ? this.rowGroupColumns.indexOf(column) : null;
	        var pivotIndex = column.isPivotActive() ? this.pivotColumns.indexOf(column) : null;
	        var aggFunc = column.isValueActive() ? column.getAggFunc() : null;
	        return {
	            colId: column.getColId(),
	            hide: !column.isVisible(),
	            aggFunc: aggFunc,
	            width: column.getActualWidth(),
	            pivotIndex: pivotIndex,
	            pinned: column.getPinned(),
	            rowGroupIndex: rowGroupIndex
	        };
	    };
	    ColumnController.prototype.getColumnState = function () {
	        if (utils_1._.missing(this.primaryColumns)) {
	            return [];
	        }
	        var primaryColumnState = this.primaryColumns.map(this.createStateItemFromColumn.bind(this));
	        var groupAutoColumnState = this.groupAutoColumns
	            // if groupAutoCols, then include them
	            ? this.groupAutoColumns.map(this.createStateItemFromColumn.bind(this))
	            // otherwise no
	            : [];
	        var columnStateList = groupAutoColumnState.concat(primaryColumnState);
	        if (!this.pivotMode) {
	            this.orderColumnStateList(columnStateList);
	        }
	        return columnStateList;
	    };
	    ColumnController.prototype.orderColumnStateList = function (columnStateList) {
	        var gridColumnIds = this.gridColumns.map(function (column) { return column.getColId(); });
	        columnStateList.sort(function (itemA, itemB) {
	            var posA = gridColumnIds.indexOf(itemA.colId);
	            var posB = gridColumnIds.indexOf(itemB.colId);
	            return posA - posB;
	        });
	    };
	    ColumnController.prototype.resetColumnState = function (suppressEverythingEvent, source) {
	        // NOTE = there is one bug here that no customer has noticed - if a column has colDef.lockPosition,
	        // this is ignored  below when ordering the cols. to work, we should always put lockPosition cols first.
	        // As a work around, developers should just put lockPosition columns first in their colDef list.
	        if (suppressEverythingEvent === void 0) { suppressEverythingEvent = false; }
	        if (source === void 0) { source = "api"; }
	        // we can't use 'allColumns' as the order might of messed up, so get the primary ordered list
	        var primaryColumns = this.getColumnsFromTree(this.primaryColumnTree);
	        var columnStates = [];
	        // we start at 1000, so if user has mix of rowGroup and group specified, it will work with both.
	        // eg IF user has ColA.rowGroupIndex=0, ColB.rowGroupIndex=1, ColC.rowGroup=true,
	        // THEN result will be ColA.rowGroupIndex=0, ColB.rowGroupIndex=1, ColC.rowGroup=1000
	        var letRowGroupIndex = 1000;
	        var letPivotIndex = 1000;
	        if (primaryColumns) {
	            primaryColumns.forEach(function (column) {
	                var rowGroupIndex = column.getColDef().rowGroupIndex;
	                var rowGroup = column.getColDef().rowGroup;
	                var pivotIndex = column.getColDef().pivotIndex;
	                var pivot = column.getColDef().pivot;
	                var stateItem = {
	                    colId: column.getColId(),
	                    aggFunc: column.getColDef().aggFunc,
	                    hide: column.getColDef().hide,
	                    pinned: column.getColDef().pinned,
	                    rowGroupIndex: rowGroupIndex,
	                    pivotIndex: column.getColDef().pivotIndex,
	                    width: column.getColDef().width
	                };
	                if (utils_1._.missing(rowGroupIndex) && rowGroup) {
	                    stateItem.rowGroupIndex = letRowGroupIndex++;
	                }
	                if (utils_1._.missing(pivotIndex) && pivot) {
	                    stateItem.pivotIndex = letPivotIndex++;
	                }
	                columnStates.push(stateItem);
	            });
	        }
	        this.setColumnState(columnStates, suppressEverythingEvent, source);
	    };
	    ColumnController.prototype.setColumnState = function (columnStates, suppressEverythingEvent, source) {
	        var _this = this;
	        if (suppressEverythingEvent === void 0) { suppressEverythingEvent = false; }
	        if (source === void 0) { source = "api"; }
	        if (utils_1._.missingOrEmpty(this.primaryColumns)) {
	            return false;
	        }
	        var columnStateBefore = this.getColumnState();
	        this.autoGroupsNeedBuilding = true;
	        // at the end below, this list will have all columns we got no state for
	        var columnsWithNoState = this.primaryColumns.slice();
	        this.rowGroupColumns = [];
	        this.valueColumns = [];
	        this.pivotColumns = [];
	        var success = true;
	        var rowGroupIndexes = {};
	        var pivotIndexes = {};
	        var autoGroupColumnStates = [];
	        if (columnStates) {
	            columnStates.forEach(function (state) {
	                // auto group columns are re-created so deferring syncing with ColumnState
	                if (utils_1._.exists(_this.getAutoColumn(state.colId))) {
	                    autoGroupColumnStates.push(state);
	                    return;
	                }
	                var column = _this.getPrimaryColumn(state.colId);
	                if (!column) {
	                    console.warn('ag-grid: column ' + state.colId + ' not found');
	                    success = false;
	                }
	                else {
	                    _this.syncColumnWithStateItem(column, state, rowGroupIndexes, pivotIndexes, source);
	                    utils_1._.removeFromArray(columnsWithNoState, column);
	                }
	            });
	        }
	        // anything left over, we got no data for, so add in the column as non-value, non-rowGroup and hidden
	        columnsWithNoState.forEach(this.syncColumnWithNoState.bind(this));
	        // sort the lists according to the indexes that were provided
	        this.rowGroupColumns.sort(this.sortColumnListUsingIndexes.bind(this, rowGroupIndexes));
	        this.pivotColumns.sort(this.sortColumnListUsingIndexes.bind(this, pivotIndexes));
	        this.updateGridColumns();
	        // sync newly created auto group columns with ColumnState
	        autoGroupColumnStates.forEach(function (stateItem) {
	            var autoCol = _this.getAutoColumn(stateItem.colId);
	            _this.syncColumnWithStateItem(autoCol, stateItem, rowGroupIndexes, pivotIndexes, source);
	        });
	        if (columnStates) {
	            var orderOfColIds_1 = columnStates.map(function (stateItem) { return stateItem.colId; });
	            this.gridColumns.sort(function (colA, colB) {
	                var indexA = orderOfColIds_1.indexOf(colA.getId());
	                var indexB = orderOfColIds_1.indexOf(colB.getId());
	                return indexA - indexB;
	            });
	        }
	        // this is already done in updateGridColumns, however we changed the order above (to match the order of the state
	        // columns) so we need to do it again. we could of put logic into the order above to take into account fixed
	        // columns, however if we did then we would have logic for updating fixed columns twice. reusing the logic here
	        // is less sexy for the code here, but it keeps consistency.
	        this.putFixedColumnsFirst();
	        this.updateDisplayedColumns(source);
	        if (!suppressEverythingEvent) {
	            var event_8 = {
	                type: events_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED,
	                api: this.gridApi,
	                columnApi: this.columnApi,
	                source: source
	            };
	            this.eventService.dispatchEvent(event_8);
	        }
	        this.raiseColumnEvents(columnStateBefore, source);
	        return success;
	    };
	    ColumnController.prototype.raiseColumnEvents = function (columnStateBefore, source) {
	        var _this = this;
	        if (this.gridOptionsWrapper.isSuppressSetColumnStateEvents()) {
	            return;
	        }
	        var columnStateAfter = this.getColumnState();
	        // raises generic ColumnEvents where all columns are returned rather than what has changed
	        var raiseEventWithAllColumns = function (eventType, idMapper, columns) {
	            var unchanged = utils_1._.compareArrays(columnStateBefore.map(idMapper).sort(), columnStateAfter.map(idMapper).sort());
	            if (unchanged) {
	                return;
	            }
	            // returning all columns rather than what has changed!
	            var event = {
	                type: eventType,
	                columns: columns,
	                column: columns.length === 1 ? columns[0] : null,
	                api: _this.gridApi,
	                columnApi: _this.columnApi,
	                source: source
	            };
	            _this.eventService.dispatchEvent(event);
	        };
	        // determines which columns have changed according to supplied predicate
	        var getChangedColumns = function (changedPredicate) {
	            var changedColumns = [];
	            var columnStateBeforeMap = {};
	            columnStateBefore.forEach(function (col) {
	                columnStateBeforeMap[col.colId] = col;
	            });
	            _this.gridColumns.forEach(function (column) {
	                var colStateBefore = columnStateBeforeMap[column.getColId()];
	                if (!colStateBefore || changedPredicate(colStateBefore, column)) {
	                    changedColumns.push(column);
	                }
	            });
	            return changedColumns;
	        };
	        // generic ColumnEvents which return current column list
	        var valueColumnIdMapper = function (cs) { return cs.colId + '-' + cs.aggFunc; };
	        raiseEventWithAllColumns(events_1.Events.EVENT_COLUMN_VALUE_CHANGED, valueColumnIdMapper, this.valueColumns);
	        var pivotColumnIdMapper = function (cs) { return cs.colId + '-' + cs.pivotIndex; };
	        raiseEventWithAllColumns(events_1.Events.EVENT_COLUMN_PIVOT_CHANGED, pivotColumnIdMapper, this.pivotColumns);
	        var rowGroupColumnIdMapper = function (cs) { return cs.colId + '-' + cs.rowGroupIndex; };
	        raiseEventWithAllColumns(events_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, rowGroupColumnIdMapper, this.rowGroupColumns);
	        // specific ColumnEvents which return what's changed
	        var pinnedChangePredicate = function (cs, c) { return cs.pinned !== c.getPinned(); };
	        this.raiseColumnPinnedEvent(getChangedColumns(pinnedChangePredicate), source);
	        var visibilityChangePredicate = function (cs, c) { return cs.hide === c.isVisible(); };
	        var cols = getChangedColumns(visibilityChangePredicate);
	        this.raiseColumnVisibleEvent(cols, source);
	        var resizeChangePredicate = function (cs, c) { return cs.width !== c.getActualWidth(); };
	        this.raiseColumnResizeEvent(getChangedColumns(resizeChangePredicate), source);
	        // special handling for moved column events
	        this.raiseColumnMovedEvent(columnStateBefore, source);
	    };
	    ColumnController.prototype.raiseColumnPinnedEvent = function (changedColumns, source) {
	        if (changedColumns.length > 0) {
	            var event_9 = {
	                type: events_1.Events.EVENT_COLUMN_PINNED,
	                pinned: null,
	                columns: changedColumns,
	                column: null,
	                api: this.gridApi,
	                columnApi: this.columnApi,
	                source: source
	            };
	            this.eventService.dispatchEvent(event_9);
	        }
	    };
	    ColumnController.prototype.raiseColumnVisibleEvent = function (changedColumns, source) {
	        if (changedColumns.length > 0) {
	            var event_10 = {
	                type: events_1.Events.EVENT_COLUMN_VISIBLE,
	                visible: undefined,
	                columns: changedColumns,
	                column: null,
	                api: this.gridApi,
	                columnApi: this.columnApi,
	                source: source
	            };
	            this.eventService.dispatchEvent(event_10);
	        }
	    };
	    ColumnController.prototype.raiseColumnResizeEvent = function (changedColumns, source) {
	        if (changedColumns.length > 0) {
	            var event_11 = {
	                type: events_1.Events.EVENT_COLUMN_RESIZED,
	                columns: changedColumns,
	                column: null,
	                finished: true,
	                api: this.gridApi,
	                columnApi: this.columnApi,
	                source: source
	            };
	            this.eventService.dispatchEvent(event_11);
	        }
	    };
	    ColumnController.prototype.raiseColumnMovedEvent = function (columnStateBefore, source) {
	        var movedColumns = [];
	        var columnStateAfter = this.getColumnState();
	        var _loop_3 = function (i) {
	            var before = columnStateBefore[i];
	            var after = columnStateAfter[i];
	            // don't consider column if reintroduced or hidden
	            if (!before || after.hide) {
	                return "continue";
	            }
	            if (before.colId !== after.colId) {
	                var predicate = function (column) { return column.getColId() === after.colId; };
	                var movedColumn = utils_1._.find(this_1.allDisplayedColumns, predicate);
	                movedColumns.push(movedColumn);
	            }
	        };
	        var this_1 = this;
	        for (var i = 0; i < columnStateAfter.length; i++) {
	            _loop_3(i);
	        }
	        if (movedColumns.length > 0) {
	            var event_12 = {
	                type: events_1.Events.EVENT_COLUMN_MOVED,
	                columns: movedColumns,
	                column: null,
	                toIndex: undefined,
	                api: this.gridApi,
	                columnApi: this.columnApi,
	                source: source
	            };
	            this.eventService.dispatchEvent(event_12);
	        }
	    };
	    ColumnController.prototype.sortColumnListUsingIndexes = function (indexes, colA, colB) {
	        var indexA = indexes[colA.getId()];
	        var indexB = indexes[colB.getId()];
	        return indexA - indexB;
	    };
	    ColumnController.prototype.syncColumnWithNoState = function (column, source) {
	        column.setVisible(false, source);
	        column.setAggFunc(null);
	        column.setPinned(null);
	        column.setRowGroupActive(false, source);
	        column.setPivotActive(false, source);
	        column.setValueActive(false, source);
	    };
	    ColumnController.prototype.syncColumnWithStateItem = function (column, stateItem, rowGroupIndexes, pivotIndexes, source) {
	        if (!column) {
	            return;
	        }
	        // following ensures we are left with boolean true or false, eg converts (null, undefined, 0) all to true
	        column.setVisible(!stateItem.hide, source);
	        // sets pinned to 'left' or 'right'
	        column.setPinned(stateItem.pinned);
	        // if width provided and valid, use it, otherwise stick with the old width
	        var minColWidth = this.gridOptionsWrapper.getMinColWidth();
	        if (stateItem.width && minColWidth &&
	            (stateItem.width >= minColWidth)) {
	            column.setActualWidth(stateItem.width, source);
	        }
	        if (typeof stateItem.aggFunc === 'string') {
	            column.setAggFunc(stateItem.aggFunc);
	            column.setValueActive(true, source);
	            this.valueColumns.push(column);
	        }
	        else {
	            if (utils_1._.exists(stateItem.aggFunc)) {
	                console.warn('ag-Grid: stateItem.aggFunc must be a string. if using your own aggregation ' +
	                    'functions, register the functions first before using them in get/set state. This is because it is' +
	                    'intended for the column state to be stored and retrieved as simple JSON.');
	            }
	            column.setAggFunc(null);
	            column.setValueActive(false, source);
	        }
	        if (typeof stateItem.rowGroupIndex === 'number') {
	            this.rowGroupColumns.push(column);
	            column.setRowGroupActive(true, source);
	            rowGroupIndexes[column.getId()] = stateItem.rowGroupIndex;
	        }
	        else {
	            column.setRowGroupActive(false, source);
	        }
	        if (typeof stateItem.pivotIndex === 'number') {
	            this.pivotColumns.push(column);
	            column.setPivotActive(true, source);
	            pivotIndexes[column.getId()] = stateItem.pivotIndex;
	        }
	        else {
	            column.setPivotActive(false, source);
	        }
	    };
	    ColumnController.prototype.getGridColumns = function (keys) {
	        return this.getColumns(keys, this.getGridColumn.bind(this));
	    };
	    ColumnController.prototype.getColumns = function (keys, columnLookupCallback) {
	        var foundColumns = [];
	        if (keys) {
	            keys.forEach(function (key) {
	                var column = columnLookupCallback(key);
	                if (column) {
	                    foundColumns.push(column);
	                }
	            });
	        }
	        return foundColumns;
	    };
	    // used by growGroupPanel
	    ColumnController.prototype.getColumnWithValidation = function (key) {
	        if (key == null) {
	            return null;
	        }
	        var column = this.getGridColumn(key);
	        if (!column) {
	            console.warn('ag-Grid: could not find column ' + key);
	        }
	        return column;
	    };
	    ColumnController.prototype.getPrimaryColumn = function (key) {
	        return this.getColumn(key, this.primaryColumns);
	    };
	    ColumnController.prototype.getGridColumn = function (key) {
	        return this.getColumn(key, this.gridColumns);
	    };
	    ColumnController.prototype.getColumn = function (key, columnList) {
	        if (!key) {
	            return null;
	        }
	        for (var i = 0; i < columnList.length; i++) {
	            if (this.columnsMatch(columnList[i], key)) {
	                return columnList[i];
	            }
	        }
	        return this.getAutoColumn(key);
	    };
	    ColumnController.prototype.getAutoColumn = function (key) {
	        var _this = this;
	        if (!this.groupAutoColumns || !utils_1._.exists(this.groupAutoColumns) || utils_1._.missing(this.groupAutoColumns)) {
	            return null;
	        }
	        return utils_1._.find(this.groupAutoColumns, function (groupCol) {
	            return _this.columnsMatch(groupCol, key);
	        });
	    };
	    ColumnController.prototype.columnsMatch = function (column, key) {
	        var columnMatches = column === key;
	        var colDefMatches = column.getColDef() === key;
	        var idMatches = column.getColId() == key;
	        return columnMatches || colDefMatches || idMatches;
	    };
	    ColumnController.prototype.getDisplayNameForColumn = function (column, location, includeAggFunc) {
	        if (includeAggFunc === void 0) { includeAggFunc = false; }
	        if (!column) {
	            return null;
	        }
	        var headerName = this.getHeaderName(column.getColDef(), column, null, null, location);
	        if (includeAggFunc) {
	            return this.wrapHeaderNameWithAggFunc(column, headerName);
	        }
	        else {
	            return headerName;
	        }
	    };
	    ColumnController.prototype.getDisplayNameForOriginalColumnGroup = function (columnGroup, originalColumnGroup, location) {
	        var colGroupDef = originalColumnGroup ? originalColumnGroup.getColGroupDef() : null;
	        if (colGroupDef) {
	            return this.getHeaderName(colGroupDef, null, columnGroup, originalColumnGroup, location);
	        }
	        else {
	            return null;
	        }
	    };
	    ColumnController.prototype.getDisplayNameForColumnGroup = function (columnGroup, location) {
	        return this.getDisplayNameForOriginalColumnGroup(columnGroup, columnGroup.getOriginalColumnGroup(), location);
	    };
	    // location is where the column is going to appear, ie who is calling us
	    ColumnController.prototype.getHeaderName = function (colDef, column, columnGroup, originalColumnGroup, location) {
	        var headerValueGetter = colDef.headerValueGetter;
	        if (headerValueGetter) {
	            var params = {
	                colDef: colDef,
	                column: column,
	                columnGroup: columnGroup,
	                originalColumnGroup: originalColumnGroup,
	                location: location,
	                api: this.gridOptionsWrapper.getApi(),
	                context: this.gridOptionsWrapper.getContext()
	            };
	            if (typeof headerValueGetter === 'function') {
	                // valueGetter is a function, so just call it
	                return headerValueGetter(params);
	            }
	            else if (typeof headerValueGetter === 'string') {
	                // valueGetter is an expression, so execute the expression
	                return this.expressionService.evaluate(headerValueGetter, params);
	            }
	            else {
	                console.warn('ag-grid: headerValueGetter must be a function or a string');
	                return '';
	            }
	        }
	        else if (colDef.headerName != null) {
	            return colDef.headerName;
	        }
	        else if (colDef.field) {
	            return utils_1._.camelCaseToHumanText(colDef.field);
	        }
	        else {
	            return '';
	        }
	    };
	    /*
	        private getHeaderGroupName(columnGroup: ColumnGroup): string {
	            let colGroupDef = columnGroup.getOriginalColumnGroup().getColGroupDef();
	            let headerValueGetter = colGroupDef.headerValueGetter;
	
	            if (headerValueGetter) {
	                let params = {
	                    columnGroup: columnGroup,
	                    colDef: colGroupDef,
	                    api: this.gridOptionsWrapper.getApi(),
	                    context: this.gridOptionsWrapper.getContext()
	                };
	
	                if (typeof headerValueGetter === 'function') {
	                    // valueGetter is a function, so just call it
	                    return headerValueGetter(params);
	                } else if (typeof headerValueGetter === 'string') {
	                    // valueGetter is an expression, so execute the expression
	                    return this.expressionService.evaluate(headerValueGetter, params);
	                } else {
	                    console.warn('ag-grid: headerValueGetter must be a function or a string');
	                    return '';
	                }
	            } else {
	                return colGroupDef.headerName;
	            }
	        }
	    */
	    ColumnController.prototype.wrapHeaderNameWithAggFunc = function (column, headerName) {
	        if (this.gridOptionsWrapper.isSuppressAggFuncInHeader()) {
	            return headerName;
	        }
	        // only columns with aggregation active can have aggregations
	        var pivotValueColumn = column.getColDef().pivotValueColumn;
	        var pivotActiveOnThisColumn = utils_1._.exists(pivotValueColumn);
	        var aggFunc = null;
	        var aggFuncFound;
	        // otherwise we have a measure that is active, and we are doing aggregation on it
	        if (pivotActiveOnThisColumn) {
	            aggFunc = pivotValueColumn ? pivotValueColumn.getAggFunc() : null;
	            aggFuncFound = true;
	        }
	        else {
	            var measureActive = column.isValueActive();
	            var aggregationPresent = this.pivotMode || !this.isRowGroupEmpty();
	            if (measureActive && aggregationPresent) {
	                aggFunc = column.getAggFunc();
	                aggFuncFound = true;
	            }
	            else {
	                aggFuncFound = false;
	            }
	        }
	        if (aggFuncFound) {
	            var aggFuncString = (typeof aggFunc === 'string') ? aggFunc : 'func';
	            var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
	            var aggFuncStringTranslated = localeTextFunc(aggFuncString, aggFuncString);
	            return aggFuncStringTranslated + "(" + headerName + ")";
	        }
	        else {
	            return headerName;
	        }
	    };
	    // returns the group with matching colId and instanceId. If instanceId is missing,
	    // matches only on the colId.
	    ColumnController.prototype.getColumnGroup = function (colId, instanceId) {
	        if (!colId) {
	            return null;
	        }
	        if (colId instanceof columnGroup_1.ColumnGroup) {
	            return colId;
	        }
	        var allColumnGroups = this.getAllDisplayedColumnGroups();
	        var checkInstanceId = typeof instanceId === 'number';
	        var result = null;
	        this.columnUtils.depthFirstAllColumnTreeSearch(allColumnGroups, function (child) {
	            if (child instanceof columnGroup_1.ColumnGroup) {
	                var columnGroup = child;
	                var matched = void 0;
	                if (checkInstanceId) {
	                    matched = colId === columnGroup.getGroupId() && instanceId === columnGroup.getInstanceId();
	                }
	                else {
	                    matched = colId === columnGroup.getGroupId();
	                }
	                if (matched) {
	                    result = columnGroup;
	                }
	            }
	        });
	        return result;
	    };
	    ColumnController.prototype.isReady = function () {
	        return this.ready;
	    };
	    ColumnController.prototype.createValueColumns = function (source, oldPrimaryColumns) {
	        this.valueColumns = this.extractColumns(oldPrimaryColumns, this.valueColumns, function (col, flag) { return col.setValueActive(flag, source); }, 
	        // aggFunc doesn't have index variant, cos order of value cols doesn't matter, so always return null
	        function () { return null; }, 
	        // aggFunc is a string, so return it's existence
	        function (colDef) { return !!colDef.aggFunc; });
	        // all new columns added will have aggFunc missing, so set it to what is in the colDef
	        this.valueColumns.forEach(function (col) {
	            if (!col.getAggFunc()) {
	                col.setAggFunc(col.getColDef().aggFunc);
	            }
	        });
	    };
	    ColumnController.prototype.extractRowGroupColumns = function (source, oldPrimaryColumns) {
	        this.rowGroupColumns = this.extractColumns(oldPrimaryColumns, this.rowGroupColumns, function (col, flag) { return col.setRowGroupActive(flag, source); }, function (colDef) { return colDef.rowGroupIndex; }, function (colDef) { return colDef.rowGroup; });
	    };
	    ColumnController.prototype.extractColumns = function (oldPrimaryColumns, previousCols, setFlagFunc, getIndexFunc, getValueFunc) {
	        var _this = this;
	        if (!previousCols) {
	            previousCols = [];
	        }
	        // remove cols that no longer exist
	        var colPresentInPrimaryFunc = function (col) { return _this.primaryColumns.indexOf(col) >= 0; };
	        var colMissingFromPrimaryFunc = function (col) { return _this.primaryColumns.indexOf(col) < 0; };
	        var colNewFunc = function (col) { return !oldPrimaryColumns || oldPrimaryColumns.indexOf(col) < 0; };
	        var removedCols = previousCols.filter(colMissingFromPrimaryFunc);
	        var existingCols = previousCols.filter(colPresentInPrimaryFunc);
	        var newPrimaryCols = this.primaryColumns.filter(colNewFunc);
	        removedCols.forEach(function (col) { return setFlagFunc(col, false); });
	        var newCols = [];
	        // we only want to work on new columns, as old columns already got processed first time around
	        // pull out items with xxxIndex
	        newPrimaryCols.forEach(function (col) {
	            var index = getIndexFunc(col.getColDef());
	            if (typeof index === 'number') {
	                newCols.push(col);
	            }
	        });
	        // then sort them
	        newCols.sort(function (colA, colB) {
	            var indexA = getIndexFunc(colA.getColDef());
	            var indexB = getIndexFunc(colB.getColDef());
	            if (indexA === indexB) {
	                return 0;
	            }
	            else if (indexA < indexB) {
	                return -1;
	            }
	            else {
	                return 1;
	            }
	        });
	        // now just pull out items xxx (boolean value), they will be added at the end
	        // after the indexed ones, but in the order the columns appear
	        newPrimaryCols.forEach(function (col) {
	            var booleanValue = getValueFunc(col.getColDef());
	            if (booleanValue) {
	                // if user already specified xxxIndex then we skip it as this col already included
	                if (newCols.indexOf(col) >= 0) {
	                    return;
	                }
	                newCols.push(col);
	            }
	        });
	        newCols.forEach(function (col) { return setFlagFunc(col, true); });
	        var res = existingCols.concat(newCols);
	        return res;
	    };
	    ColumnController.prototype.extractPivotColumns = function (source, oldPrimaryColumns) {
	        this.pivotColumns = this.extractColumns(oldPrimaryColumns, this.pivotColumns, function (col, flag) { return col.setPivotActive(flag, source); }, function (colDef) { return colDef.pivotIndex; }, function (colDef) { return colDef.pivot; });
	    };
	    ColumnController.prototype.resetColumnGroupState = function (source) {
	        if (source === void 0) { source = "api"; }
	        var stateItems = [];
	        this.columnUtils.depthFirstOriginalTreeSearch(null, this.primaryColumnTree, function (child) {
	            if (child instanceof originalColumnGroup_1.OriginalColumnGroup) {
	                var groupState = {
	                    groupId: child.getGroupId(),
	                    open: child.getColGroupDef().openByDefault
	                };
	                stateItems.push(groupState);
	            }
	        });
	        this.setColumnGroupState(stateItems, source);
	    };
	    ColumnController.prototype.getColumnGroupState = function () {
	        var columnGroupState = [];
	        this.columnUtils.depthFirstOriginalTreeSearch(null, this.gridBalancedTree, function (node) {
	            if (node instanceof originalColumnGroup_1.OriginalColumnGroup) {
	                var originalColumnGroup = node;
	                columnGroupState.push({
	                    groupId: originalColumnGroup.getGroupId(),
	                    open: originalColumnGroup.isExpanded()
	                });
	            }
	        });
	        return columnGroupState;
	    };
	    ColumnController.prototype.setColumnGroupState = function (stateItems, source) {
	        var _this = this;
	        if (source === void 0) { source = "api"; }
	        this.columnAnimationService.start();
	        var impactedGroups = [];
	        stateItems.forEach(function (stateItem) {
	            var groupKey = stateItem.groupId;
	            var newValue = stateItem.open;
	            var originalColumnGroup = _this.getOriginalColumnGroup(groupKey);
	            if (!originalColumnGroup) {
	                return;
	            }
	            if (originalColumnGroup.isExpanded() === newValue) {
	                return;
	            }
	            _this.logger.log('columnGroupOpened(' + originalColumnGroup.getGroupId() + ',' + newValue + ')');
	            originalColumnGroup.setExpanded(newValue);
	            impactedGroups.push(originalColumnGroup);
	        });
	        this.updateGroupsAndDisplayedColumns(source);
	        this.setFirstRightAndLastLeftPinned(source);
	        impactedGroups.forEach(function (originalColumnGroup) {
	            var event = {
	                type: events_1.Events.EVENT_COLUMN_GROUP_OPENED,
	                columnGroup: originalColumnGroup,
	                api: _this.gridApi,
	                columnApi: _this.columnApi
	            };
	            _this.eventService.dispatchEvent(event);
	        });
	        this.columnAnimationService.finish();
	    };
	    // called by headerRenderer - when a header is opened or closed
	    ColumnController.prototype.setColumnGroupOpened = function (key, newValue, source) {
	        if (source === void 0) { source = "api"; }
	        var keyAsString;
	        if (key instanceof originalColumnGroup_1.OriginalColumnGroup) {
	            keyAsString = key.getId();
	        }
	        else {
	            keyAsString = key;
	        }
	        this.setColumnGroupState([{ groupId: keyAsString, open: newValue }], source);
	    };
	    ColumnController.prototype.getOriginalColumnGroup = function (key) {
	        if (key instanceof originalColumnGroup_1.OriginalColumnGroup) {
	            return key;
	        }
	        if (typeof key !== 'string') {
	            console.error('ag-Grid: group key must be a string');
	        }
	        // otherwise, search for the column group by id
	        var res = null;
	        this.columnUtils.depthFirstOriginalTreeSearch(null, this.gridBalancedTree, function (node) {
	            if (node instanceof originalColumnGroup_1.OriginalColumnGroup) {
	                var originalColumnGroup = node;
	                if (originalColumnGroup.getId() === key) {
	                    res = originalColumnGroup;
	                }
	            }
	        });
	        return res;
	    };
	    ColumnController.prototype.calculateColumnsForDisplay = function () {
	        var _this = this;
	        var columnsForDisplay;
	        if (this.pivotMode && !this.secondaryColumnsPresent) {
	            // pivot mode is on, but we are not pivoting, so we only
	            // show columns we are aggregating on
	            columnsForDisplay = utils_1._.filter(this.gridColumns, function (column) {
	                var isAutoGroupCol = _this.groupAutoColumns && _this.groupAutoColumns.indexOf(column) >= 0;
	                var isValueCol = _this.valueColumns && _this.valueColumns.indexOf(column) >= 0;
	                return isAutoGroupCol || isValueCol;
	            });
	        }
	        else {
	            // otherwise continue as normal. this can be working on the primary
	            // or secondary columns, whatever the gridColumns are set to
	            columnsForDisplay = utils_1._.filter(this.gridColumns, function (column) {
	                // keep col if a) it's auto-group or b) it's visible
	                var isAutoGroupCol = _this.groupAutoColumns && _this.groupAutoColumns.indexOf(column) >= 0;
	                return isAutoGroupCol || column.isVisible();
	            });
	        }
	        return columnsForDisplay;
	    };
	    ColumnController.prototype.checkColSpanActiveInCols = function (columns) {
	        var result = false;
	        columns.forEach(function (col) {
	            if (utils_1._.exists(col.getColDef().colSpan)) {
	                result = true;
	            }
	        });
	        return result;
	    };
	    ColumnController.prototype.calculateColumnsForGroupDisplay = function () {
	        var _this = this;
	        this.groupDisplayColumns = [];
	        var checkFunc = function (col) {
	            var colDef = col.getColDef();
	            if (colDef && utils_1._.exists(colDef.showRowGroup)) {
	                _this.groupDisplayColumns.push(col);
	            }
	        };
	        this.gridColumns.forEach(checkFunc);
	        if (this.groupAutoColumns) {
	            this.groupAutoColumns.forEach(checkFunc);
	        }
	    };
	    ColumnController.prototype.getGroupDisplayColumns = function () {
	        return this.groupDisplayColumns;
	    };
	    ColumnController.prototype.updateDisplayedColumns = function (source) {
	        var columnsForDisplay = this.calculateColumnsForDisplay();
	        this.buildDisplayedTrees(columnsForDisplay);
	        this.calculateColumnsForGroupDisplay();
	        // also called when group opened/closed
	        this.updateGroupsAndDisplayedColumns(source);
	        // also called when group opened/closed
	        this.setFirstRightAndLastLeftPinned(source);
	    };
	    ColumnController.prototype.isSecondaryColumnsPresent = function () {
	        return this.secondaryColumnsPresent;
	    };
	    ColumnController.prototype.setSecondaryColumns = function (colDefs, source) {
	        if (source === void 0) { source = "api"; }
	        var newColsPresent = colDefs && colDefs.length > 0;
	        // if not cols passed, and we had to cols anyway, then do nothing
	        if (!newColsPresent && !this.secondaryColumnsPresent) {
	            return;
	        }
	        if (newColsPresent) {
	            this.processSecondaryColumnDefinitions(colDefs);
	            var balancedTreeResult = this.columnFactory.createColumnTree(colDefs, false);
	            this.secondaryBalancedTree = balancedTreeResult.columnTree;
	            this.secondaryHeaderRowCount = balancedTreeResult.treeDept + 1;
	            this.secondaryColumns = this.getColumnsFromTree(this.secondaryBalancedTree);
	            this.secondaryColumnsPresent = true;
	        }
	        else {
	            this.secondaryBalancedTree = null;
	            this.secondaryHeaderRowCount = -1;
	            this.secondaryColumns = null;
	            this.secondaryColumnsPresent = false;
	        }
	        this.updateGridColumns();
	        this.updateDisplayedColumns(source);
	    };
	    ColumnController.prototype.processSecondaryColumnDefinitions = function (colDefs) {
	        var columnCallback = this.gridOptionsWrapper.getProcessSecondaryColDefFunc();
	        var groupCallback = this.gridOptionsWrapper.getProcessSecondaryColGroupDefFunc();
	        if (!columnCallback && !groupCallback) {
	            return undefined;
	        }
	        if (colDefs) {
	            searchForColDefs(colDefs);
	        }
	        function searchForColDefs(colDefs2) {
	            colDefs2.forEach(function (abstractColDef) {
	                var isGroup = utils_1._.exists(abstractColDef.children);
	                if (isGroup) {
	                    var colGroupDef = abstractColDef;
	                    if (groupCallback) {
	                        groupCallback(colGroupDef);
	                    }
	                    searchForColDefs(colGroupDef.children);
	                }
	                else {
	                    var colDef = abstractColDef;
	                    if (columnCallback) {
	                        columnCallback(colDef);
	                    }
	                }
	            });
	        }
	    };
	    // called from: setColumnState, setColumnDefs, setSecondaryColumns
	    ColumnController.prototype.updateGridColumns = function () {
	        if (this.gridColsArePrimary) {
	            this.lastPrimaryOrder = this.gridColumns;
	        }
	        if (this.secondaryColumns && this.secondaryBalancedTree) {
	            this.gridBalancedTree = this.secondaryBalancedTree.slice();
	            this.gridHeaderRowCount = this.secondaryHeaderRowCount;
	            this.gridColumns = this.secondaryColumns.slice();
	            this.gridColsArePrimary = false;
	        }
	        else {
	            this.gridBalancedTree = this.primaryColumnTree.slice();
	            this.gridHeaderRowCount = this.primaryHeaderRowCount;
	            this.gridColumns = this.primaryColumns.slice();
	            this.gridColsArePrimary = true;
	            // updateGridColumns gets called after user adds a row group. we want to maintain the order of the columns
	            // when this happens (eg if user moved a column) rather than revert back to the original column order.
	            // likewise if changing in/out of pivot mode, we want to maintain the order of the primary cols
	            this.orderGridColsLikeLastPrimary();
	        }
	        this.addAutoGroupToGridColumns();
	        this.autoRowHeightColumns = this.gridColumns.filter(function (col) { return col.getColDef().autoHeight; });
	        this.putFixedColumnsFirst();
	        this.setupQuickFilterColumns();
	        this.clearDisplayedColumns();
	        this.colSpanActive = this.checkColSpanActiveInCols(this.gridColumns);
	        var event = {
	            type: events_1.Events.EVENT_GRID_COLUMNS_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ColumnController.prototype.orderGridColsLikeLastPrimary = function () {
	        var _this = this;
	        if (utils_1._.missing(this.lastPrimaryOrder)) {
	            return;
	        }
	        // only do the sort if at least one column is accounted for. columns will be not accounted for
	        // if changing from secondary to primary columns
	        var noColsFound = true;
	        this.gridColumns.forEach(function (col) {
	            if (_this.lastPrimaryOrder.indexOf(col) >= 0) {
	                noColsFound = false;
	            }
	        });
	        if (noColsFound) {
	            return;
	        }
	        // order cols in the same order as before. we need to make sure that all
	        // cols still exists, so filter out any that no longer exist.
	        var oldColsOrdered = this.lastPrimaryOrder.filter(function (col) { return _this.gridColumns.indexOf(col) >= 0; });
	        var newColsOrdered = this.gridColumns.filter(function (col) { return oldColsOrdered.indexOf(col) < 0; });
	        // add in the new columns, at the end (if no group), or at the end of the group (if a group)
	        var newGridColumns = oldColsOrdered.slice();
	        newColsOrdered.forEach(function (newCol) {
	            var parent = newCol.getOriginalParent();
	            // if no parent, means we are not grouping, so just add the column to the end
	            if (!parent) {
	                newGridColumns.push(newCol);
	                return;
	            }
	            // find the group the column belongs to. if no siblings at the current level (eg col in group on it's
	            // own) then go up one level and look for siblings there.
	            var siblings = [];
	            while (!siblings.length && parent) {
	                var leafCols = parent.getLeafColumns();
	                leafCols.forEach(function (leafCol) {
	                    var presentInNewGriColumns = newGridColumns.indexOf(leafCol) >= 0;
	                    var noYetInSiblings = siblings.indexOf(leafCol) < 0;
	                    if (presentInNewGriColumns && noYetInSiblings) {
	                        siblings.push(leafCol);
	                    }
	                });
	                parent = parent.getOriginalParent();
	            }
	            // if no siblings exist at any level, this means the col is in a group (or parent groups) on it's own
	            if (!siblings.length) {
	                newGridColumns.push(newCol);
	                return;
	            }
	            // find index of last column in the group
	            var indexes = siblings.map(function (col) { return newGridColumns.indexOf(col); });
	            var lastIndex = Math.max.apply(Math, indexes);
	            utils_1._.insertIntoArray(newGridColumns, newCol, lastIndex + 1);
	        });
	        this.gridColumns = newGridColumns;
	    };
	    ColumnController.prototype.isPrimaryColumnGroupsPresent = function () {
	        return this.primaryHeaderRowCount > 1;
	    };
	    // if we are using autoGroupCols, then they should be included for quick filter. this covers the
	    // following scenarios:
	    // a) user provides 'field' into autoGroupCol of normal grid, so now because a valid col to filter leafs on
	    // b) using tree data and user depends on autoGroupCol for first col, and we also want to filter on this
	    //    (tree data is a bit different, as parent rows can be filtered on, unlike row grouping)
	    ColumnController.prototype.setupQuickFilterColumns = function () {
	        if (this.groupAutoColumns) {
	            this.columnsForQuickFilter = this.primaryColumns.concat(this.groupAutoColumns);
	        }
	        else {
	            this.columnsForQuickFilter = this.primaryColumns;
	        }
	    };
	    ColumnController.prototype.putFixedColumnsFirst = function () {
	        var locked = this.gridColumns.filter(function (c) { return c.getColDef().lockPosition; });
	        var unlocked = this.gridColumns.filter(function (c) { return !c.getColDef().lockPosition; });
	        this.gridColumns = locked.concat(unlocked);
	    };
	    ColumnController.prototype.addAutoGroupToGridColumns = function () {
	        // add in auto-group here
	        this.createGroupAutoColumnsIfNeeded();
	        if (utils_1._.missing(this.groupAutoColumns)) {
	            return;
	        }
	        this.gridColumns = this.groupAutoColumns ? this.groupAutoColumns.concat(this.gridColumns) : this.gridColumns;
	        var autoColBalancedTree = this.columnFactory.createForAutoGroups(this.groupAutoColumns, this.gridBalancedTree);
	        this.gridBalancedTree = autoColBalancedTree.concat(this.gridBalancedTree);
	    };
	    // gets called after we copy down grid columns, to make sure any part of the gui
	    // that tries to draw, eg the header, it will get empty lists of columns rather
	    // than stale columns. for example, the header will received gridColumnsChanged
	    // event, so will try and draw, but it will draw successfully when it acts on the
	    // virtualColumnsChanged event
	    ColumnController.prototype.clearDisplayedColumns = function () {
	        this.displayedLeftColumnTree = [];
	        this.displayedRightColumnTree = [];
	        this.displayedCentreColumnTree = [];
	        this.displayedLeftHeaderRows = {};
	        this.displayedRightHeaderRows = {};
	        this.displayedCentreHeaderRows = {};
	        this.displayedLeftColumns = [];
	        this.displayedRightColumns = [];
	        this.displayedCenterColumns = [];
	        this.allDisplayedColumns = [];
	        this.allDisplayedVirtualColumns = [];
	    };
	    ColumnController.prototype.updateGroupsAndDisplayedColumns = function (source) {
	        this.updateOpenClosedVisibilityInColumnGroups();
	        this.updateDisplayedColumnsFromTrees(source);
	        this.updateVirtualSets();
	        this.updateBodyWidths();
	        // this event is picked up by the gui, headerRenderer and rowRenderer, to recalculate what columns to display
	        var event = {
	            type: events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ColumnController.prototype.updateDisplayedColumnsFromTrees = function (source) {
	        this.addToDisplayedColumns(this.displayedLeftColumnTree, this.displayedLeftColumns);
	        this.addToDisplayedColumns(this.displayedCentreColumnTree, this.displayedCenterColumns);
	        this.addToDisplayedColumns(this.displayedRightColumnTree, this.displayedRightColumns);
	        this.setupAllDisplayedColumns();
	        this.setLeftValues(source);
	    };
	    ColumnController.prototype.setupAllDisplayedColumns = function () {
	        if (this.gridOptionsWrapper.isEnableRtl()) {
	            this.allDisplayedColumns = this.displayedRightColumns
	                .concat(this.displayedCenterColumns)
	                .concat(this.displayedLeftColumns);
	        }
	        else {
	            this.allDisplayedColumns = this.displayedLeftColumns
	                .concat(this.displayedCenterColumns)
	                .concat(this.displayedRightColumns);
	        }
	    };
	    // sets the left pixel position of each column
	    ColumnController.prototype.setLeftValues = function (source) {
	        this.setLeftValuesOfColumns(source);
	        this.setLeftValuesOfGroups();
	    };
	    ColumnController.prototype.setLeftValuesOfColumns = function (source) {
	        var _this = this;
	        // go through each list of displayed columns
	        var allColumns = this.primaryColumns.slice(0);
	        // let totalColumnWidth = this.getWidthOfColsInList()
	        var doingRtl = this.gridOptionsWrapper.isEnableRtl();
	        [this.displayedLeftColumns, this.displayedRightColumns, this.displayedCenterColumns].forEach(function (columns) {
	            if (doingRtl) {
	                // when doing RTL, we start at the top most pixel (ie RHS) and work backwards
	                var left_1 = _this.getWidthOfColsInList(columns);
	                columns.forEach(function (column) {
	                    left_1 -= column.getActualWidth();
	                    column.setLeft(left_1, source);
	                });
	            }
	            else {
	                // otherwise normal LTR, we start at zero
	                var left_2 = 0;
	                columns.forEach(function (column) {
	                    column.setLeft(left_2, source);
	                    left_2 += column.getActualWidth();
	                });
	            }
	            utils_1._.removeAllFromArray(allColumns, columns);
	        });
	        // items left in allColumns are columns not displayed, so remove the left position. this is
	        // important for the rows, as if a col is made visible, then taken out, then made visible again,
	        // we don't want the animation of the cell floating in from the old position, whatever that was.
	        allColumns.forEach(function (column) {
	            column.setLeft(null, source);
	        });
	    };
	    ColumnController.prototype.setLeftValuesOfGroups = function () {
	        // a groups left value is the lest left value of it's children
	        [this.displayedLeftColumnTree, this.displayedRightColumnTree, this.displayedCentreColumnTree].forEach(function (columns) {
	            columns.forEach(function (column) {
	                if (column instanceof columnGroup_1.ColumnGroup) {
	                    var columnGroup = column;
	                    columnGroup.checkLeft();
	                }
	            });
	        });
	    };
	    ColumnController.prototype.addToDisplayedColumns = function (displayedColumnTree, displayedColumns) {
	        displayedColumns.length = 0;
	        this.columnUtils.depthFirstDisplayedColumnTreeSearch(displayedColumnTree, function (child) {
	            if (child instanceof column_1.Column) {
	                displayedColumns.push(child);
	            }
	        });
	    };
	    ColumnController.prototype.updateDisplayedCenterVirtualColumns = function () {
	        if (this.suppressColumnVirtualisation) {
	            // no virtualisation, so don't filter
	            this.allDisplayedCenterVirtualColumns = this.displayedCenterColumns;
	        }
	        else {
	            // filter out what should be visible
	            this.allDisplayedCenterVirtualColumns = this.filterOutColumnsWithinViewport();
	        }
	        this.allDisplayedVirtualColumns = this.allDisplayedCenterVirtualColumns
	            .concat(this.displayedLeftColumns)
	            .concat(this.displayedRightColumns);
	        // return map of virtual col id's, for easy lookup when building the groups.
	        // the map will be colId=>true, ie col id's mapping to 'true'.
	        var result = {};
	        this.allDisplayedVirtualColumns.forEach(function (col) {
	            result[col.getId()] = true;
	        });
	        return result;
	    };
	    ColumnController.prototype.getVirtualHeaderGroupRow = function (type, dept) {
	        var result;
	        switch (type) {
	            case column_1.Column.PINNED_LEFT:
	                result = this.displayedLeftHeaderRows[dept];
	                break;
	            case column_1.Column.PINNED_RIGHT:
	                result = this.displayedRightHeaderRows[dept];
	                break;
	            default:
	                result = this.displayedCentreHeaderRows[dept];
	                break;
	        }
	        if (utils_1._.missing(result)) {
	            result = [];
	        }
	        return result;
	    };
	    ColumnController.prototype.updateDisplayedVirtualGroups = function (virtualColIds) {
	        // go through each group, see if any of it's cols are displayed, and if yes,
	        // then this group is included
	        this.displayedLeftHeaderRows = {};
	        this.displayedRightHeaderRows = {};
	        this.displayedCentreHeaderRows = {};
	        testGroup(this.displayedLeftColumnTree, this.displayedLeftHeaderRows, 0);
	        testGroup(this.displayedRightColumnTree, this.displayedRightHeaderRows, 0);
	        testGroup(this.displayedCentreColumnTree, this.displayedCentreHeaderRows, 0);
	        function testGroup(children, result, dept) {
	            var returnValue = false;
	            for (var i = 0; i < children.length; i++) {
	                // see if this item is within viewport
	                var child = children[i];
	                var addThisItem = void 0;
	                if (child instanceof column_1.Column) {
	                    // for column, test if column is included
	                    addThisItem = virtualColIds[child.getId()] === true;
	                }
	                else {
	                    // if group, base decision on children
	                    var columnGroup = child;
	                    addThisItem = testGroup(columnGroup.getDisplayedChildren(), result, dept + 1);
	                }
	                if (addThisItem) {
	                    returnValue = true;
	                    if (!result[dept]) {
	                        result[dept] = [];
	                    }
	                    result[dept].push(child);
	                }
	            }
	            return returnValue;
	        }
	    };
	    ColumnController.prototype.updateVirtualSets = function () {
	        var virtualColIds = this.updateDisplayedCenterVirtualColumns();
	        this.updateDisplayedVirtualGroups(virtualColIds);
	    };
	    ColumnController.prototype.filterOutColumnsWithinViewport = function () {
	        return utils_1._.filter(this.displayedCenterColumns, this.isColumnInViewport.bind(this));
	    };
	    // called from api
	    ColumnController.prototype.sizeColumnsToFit = function (gridWidth, source) {
	        var _this = this;
	        if (source === void 0) { source = "api"; }
	        // avoid divide by zero
	        var allDisplayedColumns = this.getAllDisplayedColumns();
	        if (gridWidth <= 0 || allDisplayedColumns.length === 0) {
	            return;
	        }
	        var colsToNotSpread = utils_1._.filter(allDisplayedColumns, function (column) {
	            return column.getColDef().suppressSizeToFit === true;
	        });
	        var colsToSpread = utils_1._.filter(allDisplayedColumns, function (column) {
	            return column.getColDef().suppressSizeToFit !== true;
	        });
	        // make a copy of the cols that are going to be resized
	        var colsToFireEventFor = colsToSpread.slice(0);
	        var finishedResizing = false;
	        while (!finishedResizing) {
	            finishedResizing = true;
	            var availablePixels = gridWidth - this.getWidthOfColsInList(colsToNotSpread);
	            if (availablePixels <= 0) {
	                // no width, set everything to minimum
	                colsToSpread.forEach(function (column) {
	                    column.setMinimum(source);
	                });
	            }
	            else {
	                var scale = availablePixels / this.getWidthOfColsInList(colsToSpread);
	                // we set the pixels for the last col based on what's left, as otherwise
	                // we could be a pixel or two short or extra because of rounding errors.
	                var pixelsForLastCol = availablePixels;
	                // backwards through loop, as we are removing items as we go
	                for (var i = colsToSpread.length - 1; i >= 0; i--) {
	                    var column = colsToSpread[i];
	                    var newWidth = Math.round(column.getActualWidth() * scale);
	                    if (newWidth < column.getMinWidth()) {
	                        column.setMinimum(source);
	                        moveToNotSpread(column);
	                        finishedResizing = false;
	                    }
	                    else if (column.isGreaterThanMax(newWidth)) {
	                        column.setActualWidth(column.getMaxWidth(), source);
	                        moveToNotSpread(column);
	                        finishedResizing = false;
	                    }
	                    else {
	                        var onLastCol = i === 0;
	                        if (onLastCol) {
	                            column.setActualWidth(pixelsForLastCol, source);
	                        }
	                        else {
	                            column.setActualWidth(newWidth, source);
	                        }
	                    }
	                    pixelsForLastCol -= newWidth;
	                }
	            }
	        }
	        this.setLeftValues(source);
	        this.updateBodyWidths();
	        colsToFireEventFor.forEach(function (column) {
	            var event = {
	                type: events_1.Events.EVENT_COLUMN_RESIZED,
	                column: column,
	                columns: [column],
	                finished: true,
	                api: _this.gridApi,
	                columnApi: _this.columnApi,
	                source: "sizeColumnsToFit"
	            };
	            _this.eventService.dispatchEvent(event);
	        });
	        function moveToNotSpread(column) {
	            utils_1._.removeFromArray(colsToSpread, column);
	            colsToNotSpread.push(column);
	        }
	    };
	    ColumnController.prototype.buildDisplayedTrees = function (visibleColumns) {
	        var leftVisibleColumns = utils_1._.filter(visibleColumns, function (column) {
	            return column.getPinned() === 'left';
	        });
	        var rightVisibleColumns = utils_1._.filter(visibleColumns, function (column) {
	            return column.getPinned() === 'right';
	        });
	        var centerVisibleColumns = utils_1._.filter(visibleColumns, function (column) {
	            return column.getPinned() !== 'left' && column.getPinned() !== 'right';
	        });
	        var groupInstanceIdCreator = new groupInstanceIdCreator_1.GroupInstanceIdCreator();
	        this.displayedLeftColumnTree = this.displayedGroupCreator.createDisplayedGroups(leftVisibleColumns, this.gridBalancedTree, groupInstanceIdCreator, column_1.Column.PINNED_LEFT, this.displayedLeftColumnTree);
	        this.displayedRightColumnTree = this.displayedGroupCreator.createDisplayedGroups(rightVisibleColumns, this.gridBalancedTree, groupInstanceIdCreator, column_1.Column.PINNED_RIGHT, this.displayedRightColumnTree);
	        this.displayedCentreColumnTree = this.displayedGroupCreator.createDisplayedGroups(centerVisibleColumns, this.gridBalancedTree, groupInstanceIdCreator, null, this.displayedCentreColumnTree);
	    };
	    ColumnController.prototype.updateOpenClosedVisibilityInColumnGroups = function () {
	        var allColumnGroups = this.getAllDisplayedColumnGroups();
	        this.columnUtils.depthFirstAllColumnTreeSearch(allColumnGroups, function (child) {
	            if (child instanceof columnGroup_1.ColumnGroup) {
	                var columnGroup = child;
	                columnGroup.calculateDisplayedColumns();
	            }
	        });
	    };
	    ColumnController.prototype.getGroupAutoColumns = function () {
	        return this.groupAutoColumns;
	    };
	    ColumnController.prototype.createGroupAutoColumnsIfNeeded = function () {
	        if (!this.autoGroupsNeedBuilding) {
	            return;
	        }
	        this.autoGroupsNeedBuilding = false;
	        var groupFullWidthRow = this.gridOptionsWrapper.isGroupUseEntireRow(this.pivotMode);
	        // we never suppress auto col for pivot mode, as there is no way for user to provide group columns
	        // in pivot mode. pivot mode has auto group column (provide by grid) and value columns (provided by
	        // pivot feature in the grid).
	        var groupSuppressAutoColumn = this.gridOptionsWrapper.isGroupSuppressAutoColumn() && !this.pivotMode;
	        var groupSuppressRow = this.gridOptionsWrapper.isGroupSuppressRow();
	        var groupingActive = this.rowGroupColumns.length > 0 || this.usingTreeData;
	        var needAutoColumns = groupingActive && !groupSuppressAutoColumn && !groupFullWidthRow && !groupSuppressRow;
	        if (needAutoColumns) {
	            var newAutoGroupCols = this.autoGroupColService.createAutoGroupColumns(this.rowGroupColumns);
	            var autoColsDifferent = !this.autoColsEqual(newAutoGroupCols, this.groupAutoColumns);
	            if (autoColsDifferent) {
	                this.groupAutoColumns = newAutoGroupCols;
	            }
	        }
	        else {
	            this.groupAutoColumns = null;
	        }
	    };
	    ColumnController.prototype.autoColsEqual = function (colsA, colsB) {
	        var bothMissing = !colsA && !colsB;
	        if (bothMissing) {
	            return true;
	        }
	        var atLeastOneListMissing = !colsA || !colsB;
	        if (atLeastOneListMissing) {
	            return false;
	        }
	        if (colsA.length !== colsB.length) {
	            return false;
	        }
	        for (var i = 0; i < colsA.length; i++) {
	            var colA = colsA[i];
	            var colB = colsB[i];
	            if (colA.getColId() !== colB.getColId()) {
	                return false;
	            }
	        }
	        return true;
	    };
	    ColumnController.prototype.getWidthOfColsInList = function (columnList) {
	        var result = 0;
	        for (var i = 0; i < columnList.length; i++) {
	            result += columnList[i].getActualWidth();
	        }
	        return result;
	    };
	    ColumnController.prototype.getGridBalancedTree = function () {
	        return this.gridBalancedTree;
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], ColumnController.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('expressionService'),
	        __metadata("design:type", expressionService_1.ExpressionService)
	    ], ColumnController.prototype, "expressionService", void 0);
	    __decorate([
	        context_1.Autowired('columnFactory'),
	        __metadata("design:type", columnFactory_1.ColumnFactory)
	    ], ColumnController.prototype, "columnFactory", void 0);
	    __decorate([
	        context_1.Autowired('displayedGroupCreator'),
	        __metadata("design:type", displayedGroupCreator_1.DisplayedGroupCreator)
	    ], ColumnController.prototype, "displayedGroupCreator", void 0);
	    __decorate([
	        context_1.Autowired('autoWidthCalculator'),
	        __metadata("design:type", autoWidthCalculator_1.AutoWidthCalculator)
	    ], ColumnController.prototype, "autoWidthCalculator", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], ColumnController.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('columnUtils'),
	        __metadata("design:type", columnUtils_1.ColumnUtils)
	    ], ColumnController.prototype, "columnUtils", void 0);
	    __decorate([
	        context_1.Autowired('context'),
	        __metadata("design:type", context_1.Context)
	    ], ColumnController.prototype, "context", void 0);
	    __decorate([
	        context_1.Autowired('columnAnimationService'),
	        __metadata("design:type", columnAnimationService_1.ColumnAnimationService)
	    ], ColumnController.prototype, "columnAnimationService", void 0);
	    __decorate([
	        context_1.Autowired('autoGroupColService'),
	        __metadata("design:type", autoGroupColService_1.AutoGroupColService)
	    ], ColumnController.prototype, "autoGroupColService", void 0);
	    __decorate([
	        context_1.Optional('aggFuncService'),
	        __metadata("design:type", Object)
	    ], ColumnController.prototype, "aggFuncService", void 0);
	    __decorate([
	        context_1.Optional('valueCache'),
	        __metadata("design:type", valueCache_1.ValueCache)
	    ], ColumnController.prototype, "valueCache", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], ColumnController.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], ColumnController.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ColumnController.prototype, "init", null);
	    __decorate([
	        __param(0, context_1.Qualifier('loggerFactory')),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [logger_1.LoggerFactory]),
	        __metadata("design:returntype", void 0)
	    ], ColumnController.prototype, "setBeans", null);
	    ColumnController = __decorate([
	        context_1.Bean('columnController')
	    ], ColumnController);
	    return ColumnController;
	}());
	exports.ColumnController = ColumnController;


/***/ },
/* 27 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// (1) The code `if (__DEV__) ...` can be removed by build tool.
	// (2) If intend to use `__DEV__`, this module should be imported. Use a global
	// variable `__DEV__` may cause that miss the declaration (see #6535), or the
	// declaration is behind of the using position (for example in `Model.extent`,
	// And tools like rollup can not analysis the dependency if not import).
	var dev; // In browser
	
	if (typeof window !== 'undefined') {
	  dev = window.__DEV__;
	} // In node
	else if (typeof global !== 'undefined') {
	    dev = global.__DEV__;
	  }
	
	if (typeof dev === 'undefined') {
	  dev = true;
	}
	
	var __DEV__ = dev;
	exports.__DEV__ = __DEV__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var eventKeys_1 = __webpack_require__(160);
	exports.Events = eventKeys_1.Events;


/***/ },
/* 30 */
/***/ function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Constants = /** @class */ (function () {
	    function Constants() {
	    }
	    Constants.STEP_EVERYTHING = 0;
	    Constants.STEP_FILTER = 1;
	    Constants.STEP_SORT = 2;
	    Constants.STEP_MAP = 3;
	    Constants.STEP_AGGREGATE = 4;
	    Constants.STEP_PIVOT = 5;
	    Constants.ROW_BUFFER_SIZE = 10;
	    Constants.LAYOUT_INTERVAL = 500;
	    Constants.BATCH_WAIT_MILLIS = 50;
	    Constants.EXPORT_TYPE_DRAG_COPY = 'dragCopy';
	    Constants.EXPORT_TYPE_CLIPBOARD = 'clipboard';
	    Constants.EXPORT_TYPE_EXCEL = 'excel';
	    Constants.EXPORT_TYPE_CSV = 'csv';
	    Constants.KEY_BACKSPACE = 8;
	    Constants.KEY_TAB = 9;
	    Constants.KEY_NEW_LINE = 10;
	    Constants.KEY_ENTER = 13;
	    Constants.KEY_SHIFT = 16;
	    Constants.KEY_ESCAPE = 27;
	    Constants.KEY_SPACE = 32;
	    Constants.KEY_LEFT = 37;
	    Constants.KEY_UP = 38;
	    Constants.KEY_RIGHT = 39;
	    Constants.KEY_DOWN = 40;
	    Constants.KEY_DELETE = 46;
	    Constants.KEY_A = 65;
	    Constants.KEY_C = 67;
	    Constants.KEY_V = 86;
	    Constants.KEY_D = 68;
	    Constants.KEY_F2 = 113;
	    Constants.KEY_PAGE_UP = 33;
	    Constants.KEY_PAGE_DOWN = 34;
	    Constants.KEY_PAGE_HOME = 36;
	    Constants.KEY_PAGE_END = 35;
	    Constants.ROW_MODEL_TYPE_INFINITE = 'infinite';
	    Constants.ROW_MODEL_TYPE_VIEWPORT = 'viewport';
	    Constants.ROW_MODEL_TYPE_CLIENT_SIDE = 'clientSide';
	    Constants.ROW_MODEL_TYPE_SERVER_SIDE = 'serverSide';
	    Constants.DEPRECATED_ROW_MODEL_TYPE_NORMAL = 'normal';
	    Constants.ALWAYS = 'always';
	    Constants.ONLY_WHEN_GROUPING = 'onlyWhenGrouping';
	    Constants.PINNED_TOP = 'top';
	    Constants.PINNED_BOTTOM = 'bottom';
	    Constants.DOM_LAYOUT_NORMAL = 'normal';
	    Constants.DOM_LAYOUT_PRINT = 'print';
	    Constants.DOM_LAYOUT_AUTO_HEIGHT = 'autoHeight';
	    Constants.GROUP_AUTO_COLUMN_ID = 'ag-Grid-AutoColumn';
	    return Constants;
	}());
	exports.Constants = Constants;


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var beanStub_1 = __webpack_require__(71);
	var utils_1 = __webpack_require__(10);
	var compIdSequence = new utils_1.NumberSequence();
	var Component = /** @class */ (function (_super) {
	    __extends(Component, _super);
	    function Component(template) {
	        var _this = _super.call(this) || this;
	        _this.childComponents = [];
	        _this.annotatedEventListeners = [];
	        // if false, then CSS class "ag-hidden" is applied, which sets "display: none"
	        _this.displayed = true;
	        // if false, then CSS class "ag-invisible" is applied, which sets "visibility: hidden"
	        _this.visible = true;
	        // unique id for this row component. this is used for getting a reference to the HTML dom.
	        // we cannot use the RowNode id as this is not unique (due to animation, old rows can be lying
	        // around as we create a new rowComp instance for the same row node).
	        _this.compId = compIdSequence.next();
	        if (template) {
	            _this.setTemplate(template);
	        }
	        return _this;
	    }
	    Component.prototype.getCompId = function () {
	        return this.compId;
	    };
	    // for registered components only, eg creates AgCheckbox instance from ag-checkbox HTML tag
	    Component.prototype.createChildComponentsFromTags = function (parentNode) {
	        var _this = this;
	        // we MUST take a copy of the list first, as the 'swapComponentForNode' adds comments into the DOM
	        // which messes up the traversal order of the children.
	        var childNodeList = utils_1._.copyNodeList(parentNode.childNodes);
	        childNodeList.forEach(function (childNode) {
	            var childComp = _this.getContext().createComponentFromElement(childNode, function (childComp) {
	                // copy over all attributes, including css classes, so any attributes user put on the tag
	                // wll be carried across
	                _this.copyAttributesFromNode(childNode, childComp.getGui());
	            });
	            if (childComp) {
	                if (childComp.addItems && childNode.children.length) {
	                    _this.createChildComponentsFromTags(childNode);
	                    // converting from HTMLCollection to Array
	                    var items = Array.prototype.slice.call(childNode.children);
	                    childComp.addItems(items);
	                }
	                // replace the tag (eg ag-checkbox) with the proper HTMLElement (eg 'div') in the dom
	                _this.swapComponentForNode(childComp, parentNode, childNode);
	            }
	            else if (childNode.childNodes) {
	                _this.createChildComponentsFromTags(childNode);
	            }
	        });
	    };
	    Component.prototype.copyAttributesFromNode = function (source, dest) {
	        utils_1._.iterateNamedNodeMap(source.attributes, function (name, value) {
	            dest.setAttribute(name, value);
	        });
	    };
	    Component.prototype.swapComponentForNode = function (newComponent, parentNode, childNode) {
	        var eComponent = newComponent.getGui();
	        parentNode.replaceChild(eComponent, childNode);
	        parentNode.insertBefore(document.createComment(childNode.nodeName), eComponent);
	        this.childComponents.push(newComponent);
	        this.swapInComponentForQuerySelectors(newComponent, childNode);
	    };
	    Component.prototype.swapInComponentForQuerySelectors = function (newComponent, childNode) {
	        var thisProto = Object.getPrototypeOf(this);
	        var thisNoType = this;
	        while (thisProto != null) {
	            var metaData = thisProto.__agComponentMetaData;
	            var currentProtoName = (thisProto.constructor).name;
	            if (metaData && metaData[currentProtoName] && metaData[currentProtoName].querySelectors) {
	                metaData[currentProtoName].querySelectors.forEach(function (querySelector) {
	                    if (thisNoType[querySelector.attributeName] === childNode) {
	                        thisNoType[querySelector.attributeName] = newComponent;
	                    }
	                });
	            }
	            thisProto = Object.getPrototypeOf(thisProto);
	        }
	    };
	    Component.prototype.setTemplate = function (template) {
	        var eGui = utils_1._.loadTemplate(template);
	        this.setTemplateFromElement(eGui);
	    };
	    Component.prototype.setTemplateFromElement = function (element) {
	        this.eGui = element;
	        this.eGui.__agComponent = this;
	        this.addAnnotatedEventListeners();
	        this.wireQuerySelectors();
	        // context will not be available when user sets template in constructor
	        var contextIsAvailable = !!this.getContext();
	        if (contextIsAvailable) {
	            this.createChildComponentsFromTags(this.getGui());
	        }
	    };
	    Component.prototype.createChildComponentsPreConstruct = function () {
	        // ui exists if user sets template in constructor. when this happens, we have to wait for the context
	        // to be autoWired first before we can create child components.
	        var uiExists = !!this.getGui();
	        if (uiExists) {
	            this.createChildComponentsFromTags(this.getGui());
	        }
	    };
	    Component.prototype.wireQuerySelectors = function () {
	        var _this = this;
	        if (!this.eGui) {
	            return;
	        }
	        var thisProto = Object.getPrototypeOf(this);
	        var _loop_1 = function () {
	            var metaData = thisProto.__agComponentMetaData;
	            var currentProtoName = (thisProto.constructor).name;
	            if (metaData && metaData[currentProtoName] && metaData[currentProtoName].querySelectors) {
	                var thisNoType_1 = this_1;
	                metaData[currentProtoName].querySelectors.forEach(function (querySelector) {
	                    var resultOfQuery = _this.eGui.querySelector(querySelector.querySelector);
	                    if (resultOfQuery) {
	                        var backingComponent = resultOfQuery.__agComponent;
	                        if (backingComponent) {
	                            thisNoType_1[querySelector.attributeName] = backingComponent;
	                        }
	                        else {
	                            thisNoType_1[querySelector.attributeName] = resultOfQuery;
	                        }
	                    }
	                    else {
	                        // put debug msg in here if query selector fails???
	                    }
	                });
	            }
	            thisProto = Object.getPrototypeOf(thisProto);
	        };
	        var this_1 = this;
	        while (thisProto != null) {
	            _loop_1();
	        }
	    };
	    Component.prototype.addAnnotatedEventListeners = function () {
	        var _this = this;
	        this.removeAnnotatedEventListeners();
	        if (!this.eGui) {
	            return;
	        }
	        var listenerMethods = this.getAgComponentMetaData('listenerMethods');
	        if (utils_1._.missingOrEmpty(listenerMethods)) {
	            return;
	        }
	        if (!this.annotatedEventListeners) {
	            this.annotatedEventListeners = [];
	        }
	        listenerMethods.forEach(function (eventListener) {
	            var listener = _this[eventListener.methodName].bind(_this);
	            _this.eGui.addEventListener(eventListener.eventName, listener);
	            _this.annotatedEventListeners.push({ eventName: eventListener.eventName, listener: listener });
	        });
	    };
	    Component.prototype.getAgComponentMetaData = function (key) {
	        var res = [];
	        var thisProto = Object.getPrototypeOf(this);
	        while (thisProto != null) {
	            var metaData = thisProto.__agComponentMetaData;
	            var currentProtoName = (thisProto.constructor).name;
	            // IE does not support Function.prototype.name, so we need to extract
	            // the name using a RegEx
	            // from: https://matt.scharley.me/2012/03/monkey-patch-name-ie.html
	            if (currentProtoName === undefined) {
	                var funcNameRegex = /function\s([^(]{1,})\(/;
	                var results = funcNameRegex.exec(thisProto.constructor.toString());
	                if (results && results.length > 1) {
	                    currentProtoName = results[1].trim();
	                }
	            }
	            if (metaData && metaData[currentProtoName] && metaData[currentProtoName][key]) {
	                res = res.concat(metaData[currentProtoName][key]);
	            }
	            thisProto = Object.getPrototypeOf(thisProto);
	        }
	        return res;
	    };
	    Component.prototype.removeAnnotatedEventListeners = function () {
	        var _this = this;
	        if (!this.annotatedEventListeners || !this.eGui) {
	            return;
	        }
	        this.annotatedEventListeners.forEach(function (eventListener) {
	            _this.eGui.removeEventListener(eventListener.eventName, eventListener.listener);
	        });
	        this.annotatedEventListeners = [];
	    };
	    Component.prototype.getGui = function () {
	        return this.eGui;
	    };
	    Component.prototype.setParentComponent = function (component) {
	        this.parentComponent = component;
	    };
	    Component.prototype.getParentComponent = function () {
	        return this.parentComponent;
	    };
	    // this method is for older code, that wants to provide the gui element,
	    // it is not intended for this to be in ag-Stack
	    Component.prototype.setGui = function (eGui) {
	        this.eGui = eGui;
	    };
	    Component.prototype.queryForHtmlElement = function (cssSelector) {
	        return this.eGui.querySelector(cssSelector);
	    };
	    Component.prototype.queryForHtmlInputElement = function (cssSelector) {
	        return this.eGui.querySelector(cssSelector);
	    };
	    Component.prototype.appendChild = function (newChild) {
	        if (utils_1._.isNodeOrElement(newChild)) {
	            this.eGui.appendChild(newChild);
	        }
	        else {
	            var childComponent = newChild;
	            this.eGui.appendChild(childComponent.getGui());
	            this.childComponents.push(childComponent);
	        }
	    };
	    Component.prototype.addFeature = function (context, feature) {
	        context.wireBean(feature);
	        if (feature.destroy) {
	            this.addDestroyFunc(feature.destroy.bind(feature));
	        }
	    };
	    Component.prototype.isDisplayed = function () {
	        return this.displayed;
	    };
	    Component.prototype.setVisible = function (visible) {
	        if (visible !== this.visible) {
	            this.visible = visible;
	            utils_1._.setVisible(this.eGui, visible);
	        }
	    };
	    Component.prototype.setDisplayed = function (displayed) {
	        if (displayed !== this.displayed) {
	            this.displayed = displayed;
	            utils_1._.setDisplayed(this.eGui, displayed);
	            var event_1 = {
	                type: Component.EVENT_DISPLAYED_CHANGED,
	                visible: this.displayed
	            };
	            this.dispatchEvent(event_1);
	        }
	    };
	    /*    public setVisible(visible: boolean, visibilityMode?: 'display' | 'visibility'): void {
	            const isDisplay = visibilityMode !== 'visibility';
	            if (visible !== this.visible) {
	                this.visible = visible;
	    
	                // ag-hidden: display: none     -> setDisplayed();
	                // ag-invisible: visibility: hidden     => setVisible();
	    
	                _.addOrRemoveCssClass(this.eGui, isDisplay ? 'ag-hidden' : 'ag-invisible', !visible);
	                const event: VisibleChangedEvent = {
	                    type: Component.EVENT_VISIBLE_CHANGED,
	                    visible: this.visible
	                };
	                this.dispatchEvent(event);
	            }
	        }*/
	    Component.prototype.addOrRemoveCssClass = function (className, addOrRemove) {
	        utils_1._.addOrRemoveCssClass(this.eGui, className, addOrRemove);
	    };
	    Component.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        this.childComponents.forEach(function (childComponent) {
	            if (childComponent && childComponent.destroy) {
	                childComponent.destroy();
	            }
	        });
	        this.childComponents.length = 0;
	        this.removeAnnotatedEventListeners();
	    };
	    Component.prototype.addGuiEventListener = function (event, listener) {
	        var _this = this;
	        this.getGui().addEventListener(event, listener);
	        this.addDestroyFunc(function () { return _this.getGui().removeEventListener(event, listener); });
	    };
	    Component.prototype.addCssClass = function (className) {
	        utils_1._.addCssClass(this.getGui(), className);
	    };
	    Component.prototype.removeCssClass = function (className) {
	        utils_1._.removeCssClass(this.getGui(), className);
	    };
	    Component.prototype.getAttribute = function (key) {
	        var eGui = this.getGui();
	        return eGui ? eGui.getAttribute(key) : null;
	    };
	    Component.prototype.getRefElement = function (refName) {
	        return this.queryForHtmlElement('[ref="' + refName + '"]');
	    };
	    Component.EVENT_DISPLAYED_CHANGED = 'displayedChanged';
	    __decorate([
	        context_1.PreConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], Component.prototype, "createChildComponentsPreConstruct", null);
	    return Component;
	}(beanStub_1.BeanStub));
	exports.Component = Component;


/***/ },
/* 32 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var csvCreator_1 = __webpack_require__(422);
	var rowRenderer_1 = __webpack_require__(91);
	var filterManager_1 = __webpack_require__(77);
	var columnController_1 = __webpack_require__(26);
	var selectionController_1 = __webpack_require__(102);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var valueService_1 = __webpack_require__(103);
	var eventService_1 = __webpack_require__(22);
	var constants_1 = __webpack_require__(30);
	var context_1 = __webpack_require__(8);
	var sortController_1 = __webpack_require__(120);
	var focusedCellController_1 = __webpack_require__(119);
	var cellRendererFactory_1 = __webpack_require__(320);
	var paginationProxy_1 = __webpack_require__(135);
	var immutableService_1 = __webpack_require__(670);
	var valueCache_1 = __webpack_require__(198);
	var alignedGridsService_1 = __webpack_require__(313);
	var pinnedRowModel_1 = __webpack_require__(136);
	var animationFrameService_1 = __webpack_require__(197);
	var utils_1 = __webpack_require__(10);
	var GridApi = /** @class */ (function () {
	    function GridApi() {
	        this.detailGridInfoMap = {};
	    }
	    GridApi.prototype.registerGridComp = function (gridPanel) {
	        this.gridPanel = gridPanel;
	    };
	    GridApi.prototype.registerGridCore = function (gridCore) {
	        this.gridCore = gridCore;
	    };
	    GridApi.prototype.registerHeaderRootComp = function (headerRootComp) {
	        this.headerRootComp = headerRootComp;
	    };
	    GridApi.prototype.init = function () {
	        switch (this.rowModel.getType()) {
	            case constants_1.Constants.ROW_MODEL_TYPE_CLIENT_SIDE:
	                this.clientSideRowModel = this.rowModel;
	                break;
	            case constants_1.Constants.ROW_MODEL_TYPE_INFINITE:
	                this.infinitePageRowModel = this.rowModel;
	                break;
	            case constants_1.Constants.ROW_MODEL_TYPE_SERVER_SIDE:
	                this.serverSideRowModel = this.rowModel;
	                break;
	        }
	    };
	    /** Used internally by grid. Not intended to be used by the client. Interface may change between releases. */
	    GridApi.prototype.__getAlignedGridService = function () {
	        return this.alignedGridsService;
	    };
	    GridApi.prototype.addDetailGridInfo = function (id, gridInfo) {
	        this.detailGridInfoMap[id] = gridInfo;
	    };
	    GridApi.prototype.removeDetailGridInfo = function (id) {
	        this.detailGridInfoMap[id] = undefined;
	    };
	    GridApi.prototype.getDetailGridInfo = function (id) {
	        return this.detailGridInfoMap[id];
	    };
	    GridApi.prototype.forEachDetailGridInfo = function (callback) {
	        var index = 0;
	        utils_1._.iterateObject(this.detailGridInfoMap, function (id, gridInfo) {
	            // check for undefined, as old references will still be lying around
	            if (utils_1._.exists(gridInfo)) {
	                callback(gridInfo, index);
	                index++;
	            }
	        });
	    };
	    GridApi.prototype.getDataAsCsv = function (params) {
	        return this.csvCreator.getDataAsCsv(params);
	    };
	    GridApi.prototype.exportDataAsCsv = function (params) {
	        this.csvCreator.exportDataAsCsv(params);
	    };
	    GridApi.prototype.getDataAsExcel = function (params) {
	        if (!this.excelCreator) {
	            console.warn('ag-Grid: Excel export is only available in ag-Grid Enterprise');
	        }
	        return this.excelCreator.getDataAsExcelXml(params);
	    };
	    GridApi.prototype.exportDataAsExcel = function (params) {
	        if (!this.excelCreator) {
	            console.warn('ag-Grid: Excel export is only available in ag-Grid Enterprise');
	        }
	        this.excelCreator.exportDataAsExcel(params);
	    };
	    /** @deprecated */
	    GridApi.prototype.setEnterpriseDatasource = function (datasource) {
	        console.warn("ag-grid: since version 18.x, api.setEnterpriseDatasource() should be replaced with api.setServerSideDatasource()");
	        this.setServerSideDatasource(datasource);
	    };
	    GridApi.prototype.setServerSideDatasource = function (datasource) {
	        if (this.gridOptionsWrapper.isRowModelServerSide()) {
	            // should really have an IEnterpriseRowModel interface, so we are not casting to any
	            this.rowModel.setDatasource(datasource);
	        }
	        else {
	            console.warn("ag-Grid: you can only use an enterprise datasource when gridOptions.rowModelType is '" + constants_1.Constants.ROW_MODEL_TYPE_SERVER_SIDE + "'");
	        }
	    };
	    GridApi.prototype.setDatasource = function (datasource) {
	        if (this.gridOptionsWrapper.isRowModelInfinite()) {
	            this.rowModel.setDatasource(datasource);
	        }
	        else {
	            console.warn("ag-Grid: you can only use a datasource when gridOptions.rowModelType is '" + constants_1.Constants.ROW_MODEL_TYPE_INFINITE + "'");
	        }
	    };
	    GridApi.prototype.setViewportDatasource = function (viewportDatasource) {
	        if (this.gridOptionsWrapper.isRowModelViewport()) {
	            // this is bad coding, because it's using an interface that's exposed in the enterprise.
	            // really we should create an interface in the core for viewportDatasource and let
	            // the enterprise implement it, rather than casting to 'any' here
	            this.rowModel.setViewportDatasource(viewportDatasource);
	        }
	        else {
	            console.warn("ag-Grid: you can only use a viewport datasource when gridOptions.rowModelType is '" + constants_1.Constants.ROW_MODEL_TYPE_VIEWPORT + "'");
	        }
	    };
	    GridApi.prototype.setRowData = function (rowData) {
	        if (this.gridOptionsWrapper.isRowModelDefault()) {
	            if (this.gridOptionsWrapper.isDeltaRowDataMode()) {
	                var _a = this.immutableService.createTransactionForRowData(rowData), transaction = _a[0], orderIdMap = _a[1];
	                this.clientSideRowModel.updateRowData(transaction, orderIdMap);
	                // need to force updating of full width rows - note this wouldn't be necessary the full width cell comp listened
	                // to the data change event on the row node and refreshed itself.
	                this.rowRenderer.refreshFullWidthRows();
	            }
	            else {
	                this.selectionController.reset();
	                this.clientSideRowModel.setRowData(rowData);
	            }
	        }
	        else {
	            console.warn('cannot call setRowData unless using normal row model');
	        }
	    };
	    /** @deprecated */
	    GridApi.prototype.setFloatingTopRowData = function (rows) {
	        console.warn('ag-Grid: since v12, api.setFloatingTopRowData() is now api.setPinnedTopRowData()');
	        this.setPinnedTopRowData(rows);
	    };
	    /** @deprecated */
	    GridApi.prototype.setFloatingBottomRowData = function (rows) {
	        console.warn('ag-Grid: since v12, api.setFloatingBottomRowData() is now api.setPinnedBottomRowData()');
	        this.setPinnedBottomRowData(rows);
	    };
	    /** @deprecated */
	    GridApi.prototype.getFloatingTopRowCount = function () {
	        console.warn('ag-Grid: since v12, api.getFloatingTopRowCount() is now api.getPinnedTopRowCount()');
	        return this.getPinnedTopRowCount();
	    };
	    /** @deprecated */
	    GridApi.prototype.getFloatingBottomRowCount = function () {
	        console.warn('ag-Grid: since v12, api.getFloatingBottomRowCount() is now api.getPinnedBottomRowCount()');
	        return this.getPinnedBottomRowCount();
	    };
	    /** @deprecated */
	    GridApi.prototype.getFloatingTopRow = function (index) {
	        console.warn('ag-Grid: since v12, api.getFloatingTopRow() is now api.getPinnedTopRow()');
	        return this.getPinnedTopRow(index);
	    };
	    /** @deprecated */
	    GridApi.prototype.getFloatingBottomRow = function (index) {
	        console.warn('ag-Grid: since v12, api.getFloatingBottomRow() is now api.getPinnedBottomRow()');
	        return this.getPinnedBottomRow(index);
	    };
	    GridApi.prototype.setPinnedTopRowData = function (rows) {
	        this.pinnedRowModel.setPinnedTopRowData(rows);
	    };
	    GridApi.prototype.setPinnedBottomRowData = function (rows) {
	        this.pinnedRowModel.setPinnedBottomRowData(rows);
	    };
	    GridApi.prototype.getPinnedTopRowCount = function () {
	        return this.pinnedRowModel.getPinnedTopRowCount();
	    };
	    GridApi.prototype.getPinnedBottomRowCount = function () {
	        return this.pinnedRowModel.getPinnedBottomRowCount();
	    };
	    GridApi.prototype.getPinnedTopRow = function (index) {
	        return this.pinnedRowModel.getPinnedTopRow(index);
	    };
	    GridApi.prototype.getPinnedBottomRow = function (index) {
	        return this.pinnedRowModel.getPinnedBottomRow(index);
	    };
	    GridApi.prototype.setColumnDefs = function (colDefs, source) {
	        if (source === void 0) { source = "api"; }
	        this.columnController.setColumnDefs(colDefs, source);
	    };
	    GridApi.prototype.expireValueCache = function () {
	        this.valueCache.expire();
	    };
	    GridApi.prototype.getVerticalPixelRange = function () {
	        return this.gridPanel.getVScrollPosition();
	    };
	    GridApi.prototype.getHorizontalPixelRange = function () {
	        return this.gridPanel.getHScrollPosition();
	    };
	    GridApi.prototype.setAlwaysShowVerticalScroll = function (show) {
	        this.gridOptionsWrapper.setProperty('alwaysShowVerticalScroll', show);
	    };
	    GridApi.prototype.refreshToolPanel = function () {
	        this.gridCore.refreshSideBar();
	    };
	    GridApi.prototype.refreshCells = function (params) {
	        if (params === void 0) { params = {}; }
	        if (Array.isArray(params)) {
	            // the old version of refreshCells() took an array of rowNodes for the first argument
	            console.warn('since ag-Grid v11.1, refreshCells() now takes parameters, please see the documentation.');
	            return;
	        }
	        this.rowRenderer.refreshCells(params);
	    };
	    GridApi.prototype.flashCells = function (params) {
	        if (params === void 0) { params = {}; }
	        this.rowRenderer.flashCells(params);
	    };
	    GridApi.prototype.redrawRows = function (params) {
	        if (params === void 0) { params = {}; }
	        if (params && params.rowNodes) {
	            this.rowRenderer.redrawRows(params.rowNodes);
	        }
	        else {
	            this.rowRenderer.redrawAfterModelUpdate();
	        }
	    };
	    GridApi.prototype.timeFullRedraw = function (count) {
	        if (count === void 0) { count = 1; }
	        var iterationCount = 0;
	        var totalProcessing = 0;
	        var totalReflow = 0;
	        var that = this;
	        doOneIteration();
	        function doOneIteration() {
	            var start = (new Date()).getTime();
	            that.rowRenderer.redrawAfterModelUpdate();
	            var endProcessing = (new Date()).getTime();
	            window.setTimeout(function () {
	                var endReflow = (new Date()).getTime();
	                var durationProcessing = endProcessing - start;
	                var durationReflow = endReflow - endProcessing;
	                // tslint:disable-next-line
	                console.log('duration:  processing = ' + durationProcessing + 'ms, reflow = ' + durationReflow + 'ms');
	                iterationCount++;
	                totalProcessing += durationProcessing;
	                totalReflow += durationReflow;
	                if (iterationCount < count) {
	                    // wait for 1s between tests
	                    window.setTimeout(doOneIteration, 1000);
	                }
	                else {
	                    finish();
	                }
	            }, 0);
	        }
	        function finish() {
	            // tslint:disable-next-line
	            console.log('tests complete. iteration count = ' + iterationCount);
	            // tslint:disable-next-line
	            console.log('average processing = ' + (totalProcessing / iterationCount) + 'ms');
	            // tslint:disable-next-line
	            console.log('average reflow = ' + (totalReflow / iterationCount) + 'ms');
	        }
	    };
	    /** @deprecated */
	    GridApi.prototype.refreshView = function () {
	        console.warn('ag-Grid: since v11.1, refreshView() is deprecated, please call refreshCells() or redrawRows() instead');
	        this.redrawRows();
	    };
	    //** @deprecated */
	    GridApi.prototype.refreshRows = function (rowNodes) {
	        console.warn('since ag-Grid v11.1, refreshRows() is deprecated, please use refreshCells({rowNodes: rows}) or redrawRows({rowNodes: rows}) instead');
	        this.refreshCells({ rowNodes: rowNodes });
	    };
	    /** @deprecated */
	    GridApi.prototype.rowDataChanged = function (rows) {
	        console.warn('ag-Grid: rowDataChanged is deprecated, either call refreshView() to refresh everything, or call rowNode.setRowData(newData) to set value on a particular node');
	        this.redrawRows();
	    };
	    /** @deprecated */
	    GridApi.prototype.softRefreshView = function () {
	        console.error('ag-Grid: since v16, softRefreshView() is no longer supported. Please check the documentation on how to refresh.');
	    };
	    /** @deprecated */
	    GridApi.prototype.refreshGroupRows = function () {
	        console.warn('ag-Grid: since v11.1, refreshGroupRows() is no longer supported, call refreshCells() instead. ' +
	            'Because refreshCells() now does dirty checking, it will only refresh cells that have changed, so it should ' +
	            'not be necessary to only refresh the group rows.');
	        this.refreshCells();
	    };
	    GridApi.prototype.setFunctionsReadOnly = function (readOnly) {
	        this.gridOptionsWrapper.setProperty('functionsReadOnly', readOnly);
	    };
	    GridApi.prototype.refreshHeader = function () {
	        this.headerRootComp.refreshHeader();
	        this.gridPanel.setHeaderAndFloatingHeights();
	    };
	    GridApi.prototype.isAnyFilterPresent = function () {
	        return this.filterManager.isAnyFilterPresent();
	    };
	    GridApi.prototype.isAdvancedFilterPresent = function () {
	        console.warn('ag-Grid: isAdvancedFilterPresent() is deprecated, please use isColumnFilterPresent()');
	        return this.isColumnFilterPresent();
	    };
	    GridApi.prototype.isColumnFilterPresent = function () {
	        return this.filterManager.isAdvancedFilterPresent();
	    };
	    GridApi.prototype.isQuickFilterPresent = function () {
	        return this.filterManager.isQuickFilterPresent();
	    };
	    GridApi.prototype.getModel = function () {
	        return this.rowModel;
	    };
	    GridApi.prototype.setRowNodeExpanded = function (rowNode, expanded) {
	        if (rowNode) {
	            rowNode.setExpanded(expanded);
	        }
	    };
	    GridApi.prototype.onGroupExpandedOrCollapsed = function (deprecated_refreshFromIndex) {
	        if (utils_1._.missing(this.clientSideRowModel)) {
	            console.warn('ag-Grid: cannot call onGroupExpandedOrCollapsed unless using normal row model');
	        }
	        if (utils_1._.exists(deprecated_refreshFromIndex)) {
	            console.warn('ag-Grid: api.onGroupExpandedOrCollapsed - refreshFromIndex parameter is no longer used, the grid will refresh all rows');
	        }
	        // we don't really want the user calling this if only one rowNode was expanded, instead they should be
	        // calling rowNode.setExpanded(boolean) - this way we do a 'keepRenderedRows=false' so that the whole
	        // grid gets refreshed again - otherwise the row with the rowNodes that were changed won't get updated,
	        // and thus the expand icon in the group cell won't get 'opened' or 'closed'.
	        this.clientSideRowModel.refreshModel({ step: constants_1.Constants.STEP_MAP });
	    };
	    GridApi.prototype.refreshInMemoryRowModel = function (step) {
	        console.warn("ag-grid: since version 18.x, api.refreshInMemoryRowModel() should be replaced with api.refreshClientSideRowModel()");
	        this.refreshClientSideRowModel(step);
	    };
	    GridApi.prototype.refreshClientSideRowModel = function (step) {
	        if (utils_1._.missing(this.clientSideRowModel)) {
	            console.warn('cannot call refreshClientSideRowModel unless using normal row model');
	        }
	        var paramsStep = constants_1.Constants.STEP_EVERYTHING;
	        var stepsMapped = {
	            group: constants_1.Constants.STEP_EVERYTHING,
	            filter: constants_1.Constants.STEP_FILTER,
	            map: constants_1.Constants.STEP_MAP,
	            aggregate: constants_1.Constants.STEP_AGGREGATE,
	            sort: constants_1.Constants.STEP_SORT,
	            pivot: constants_1.Constants.STEP_PIVOT
	        };
	        if (utils_1._.exists(step)) {
	            paramsStep = stepsMapped[step];
	        }
	        if (utils_1._.missing(paramsStep)) {
	            console.error("ag-Grid: invalid step " + step + ", available steps are " + Object.keys(stepsMapped).join(', '));
	            return;
	        }
	        var modelParams = {
	            step: paramsStep,
	            keepRenderedRows: true,
	            animate: true,
	            keepEditingRows: true
	        };
	        this.clientSideRowModel.refreshModel(modelParams);
	    };
	    GridApi.prototype.isAnimationFrameQueueEmpty = function () {
	        return this.animationFrameService.isQueueEmpty();
	    };
	    GridApi.prototype.getRowNode = function (id) {
	        return this.rowModel.getRowNode(id);
	    };
	    GridApi.prototype.expandAll = function () {
	        if (utils_1._.missing(this.clientSideRowModel)) {
	            console.warn('ag-Grid: cannot call expandAll unless using normal row model');
	            return;
	        }
	        this.clientSideRowModel.expandOrCollapseAll(true);
	    };
	    GridApi.prototype.collapseAll = function () {
	        if (utils_1._.missing(this.clientSideRowModel)) {
	            console.warn('ag-Grid: cannot call collapseAll unless using normal row model');
	            return;
	        }
	        this.clientSideRowModel.expandOrCollapseAll(false);
	    };
	    GridApi.prototype.addVirtualRowListener = function (eventName, rowIndex, callback) {
	        if (typeof eventName !== 'string') {
	            console.warn('ag-Grid: addVirtualRowListener is deprecated, please use addRenderedRowListener.');
	        }
	        this.addRenderedRowListener(eventName, rowIndex, callback);
	    };
	    GridApi.prototype.addRenderedRowListener = function (eventName, rowIndex, callback) {
	        if (eventName === 'virtualRowSelected') {
	            console.warn("ag-Grid: event virtualRowSelected is deprecated, to register for individual row\n                selection events, add a listener directly to the row node.");
	        }
	        this.rowRenderer.addRenderedRowListener(eventName, rowIndex, callback);
	    };
	    GridApi.prototype.setQuickFilter = function (newFilter) {
	        this.filterManager.setQuickFilter(newFilter);
	    };
	    GridApi.prototype.selectIndex = function (index, tryMulti, suppressEvents) {
	        console.warn('ag-Grid: do not use api for selection, call node.setSelected(value) instead');
	        if (suppressEvents) {
	            console.warn('ag-Grid: suppressEvents is no longer supported, stop listening for the event if you no longer want it');
	        }
	        this.selectionController.selectIndex(index, tryMulti);
	    };
	    GridApi.prototype.deselectIndex = function (index, suppressEvents) {
	        if (suppressEvents === void 0) { suppressEvents = false; }
	        console.warn('ag-Grid: do not use api for selection, call node.setSelected(value) instead');
	        if (suppressEvents) {
	            console.warn('ag-Grid: suppressEvents is no longer supported, stop listening for the event if you no longer want it');
	        }
	        this.selectionController.deselectIndex(index);
	    };
	    GridApi.prototype.selectNode = function (node, tryMulti, suppressEvents) {
	        if (tryMulti === void 0) { tryMulti = false; }
	        if (suppressEvents === void 0) { suppressEvents = false; }
	        console.warn('ag-Grid: API for selection is deprecated, call node.setSelected(value) instead');
	        if (suppressEvents) {
	            console.warn('ag-Grid: suppressEvents is no longer supported, stop listening for the event if you no longer want it');
	        }
	        node.setSelectedParams({ newValue: true, clearSelection: !tryMulti });
	    };
	    GridApi.prototype.deselectNode = function (node, suppressEvents) {
	        if (suppressEvents === void 0) { suppressEvents = false; }
	        console.warn('ag-Grid: API for selection is deprecated, call node.setSelected(value) instead');
	        if (suppressEvents) {
	            console.warn('ag-Grid: suppressEvents is no longer supported, stop listening for the event if you no longer want it');
	        }
	        node.setSelectedParams({ newValue: false });
	    };
	    GridApi.prototype.selectAll = function () {
	        this.selectionController.selectAllRowNodes();
	    };
	    GridApi.prototype.deselectAll = function () {
	        this.selectionController.deselectAllRowNodes();
	    };
	    GridApi.prototype.selectAllFiltered = function () {
	        this.selectionController.selectAllRowNodes(true);
	    };
	    GridApi.prototype.deselectAllFiltered = function () {
	        this.selectionController.deselectAllRowNodes(true);
	    };
	    GridApi.prototype.recomputeAggregates = function () {
	        if (utils_1._.missing(this.clientSideRowModel)) {
	            console.warn('cannot call recomputeAggregates unless using normal row model');
	        }
	        console.warn("recomputeAggregates is deprecated, please call api.refreshClientSideRowModel('aggregate') instead");
	        this.clientSideRowModel.refreshModel({ step: constants_1.Constants.STEP_AGGREGATE });
	    };
	    GridApi.prototype.sizeColumnsToFit = function () {
	        this.gridPanel.sizeColumnsToFit();
	    };
	    GridApi.prototype.showLoadingOverlay = function () {
	        this.gridPanel.showLoadingOverlay();
	    };
	    GridApi.prototype.showNoRowsOverlay = function () {
	        this.gridPanel.showNoRowsOverlay();
	    };
	    GridApi.prototype.hideOverlay = function () {
	        this.gridPanel.hideOverlay();
	    };
	    GridApi.prototype.isNodeSelected = function (node) {
	        console.warn('ag-Grid: no need to call api.isNodeSelected(), just call node.isSelected() instead');
	        return node.isSelected();
	    };
	    GridApi.prototype.getSelectedNodesById = function () {
	        console.error('ag-Grid: since version 3.4, getSelectedNodesById no longer exists, use getSelectedNodes() instead');
	        return null;
	    };
	    GridApi.prototype.getSelectedNodes = function () {
	        return this.selectionController.getSelectedNodes();
	    };
	    GridApi.prototype.getSelectedRows = function () {
	        return this.selectionController.getSelectedRows();
	    };
	    GridApi.prototype.getBestCostNodeSelection = function () {
	        return this.selectionController.getBestCostNodeSelection();
	    };
	    GridApi.prototype.getRenderedNodes = function () {
	        return this.rowRenderer.getRenderedNodes();
	    };
	    GridApi.prototype.ensureColIndexVisible = function (index) {
	        console.warn('ag-Grid: ensureColIndexVisible(index) no longer supported, use ensureColumnVisible(colKey) instead.');
	    };
	    GridApi.prototype.ensureColumnVisible = function (key) {
	        this.gridPanel.ensureColumnVisible(key);
	    };
	    // Valid values for position are bottom, middle and top
	    GridApi.prototype.ensureIndexVisible = function (index, position) {
	        this.gridPanel.ensureIndexVisible(index, position);
	    };
	    // Valid values for position are bottom, middle and top
	    GridApi.prototype.ensureNodeVisible = function (comparator, position) {
	        this.gridCore.ensureNodeVisible(comparator, position);
	    };
	    GridApi.prototype.forEachLeafNode = function (callback) {
	        if (utils_1._.missing(this.clientSideRowModel)) {
	            console.warn('cannot call forEachNode unless using normal row model');
	        }
	        this.clientSideRowModel.forEachLeafNode(callback);
	    };
	    GridApi.prototype.forEachNode = function (callback) {
	        this.rowModel.forEachNode(callback);
	    };
	    GridApi.prototype.forEachNodeAfterFilter = function (callback) {
	        if (utils_1._.missing(this.clientSideRowModel)) {
	            console.warn('cannot call forEachNodeAfterFilter unless using normal row model');
	        }
	        this.clientSideRowModel.forEachNodeAfterFilter(callback);
	    };
	    GridApi.prototype.forEachNodeAfterFilterAndSort = function (callback) {
	        if (utils_1._.missing(this.clientSideRowModel)) {
	            console.warn('cannot call forEachNodeAfterFilterAndSort unless using normal row model');
	        }
	        this.clientSideRowModel.forEachNodeAfterFilterAndSort(callback);
	    };
	    GridApi.prototype.getFilterApiForColDef = function (colDef) {
	        console.warn('ag-grid API method getFilterApiForColDef deprecated, use getFilterApi instead');
	        return this.getFilterInstance(colDef);
	    };
	    GridApi.prototype.getFilterInstance = function (key) {
	        var column = this.columnController.getPrimaryColumn(key);
	        if (column) {
	            return this.filterManager.getFilterComponent(column, 'NO_UI').resolveNow(null, function (filterComp) { return filterComp; });
	        }
	    };
	    GridApi.prototype.getFilterApi = function (key) {
	        console.warn('ag-Grid: getFilterApi is deprecated, use getFilterInstance instead');
	        return this.getFilterInstance(key);
	    };
	    GridApi.prototype.destroyFilter = function (key) {
	        var column = this.columnController.getPrimaryColumn(key);
	        if (column) {
	            return this.filterManager.destroyFilter(column, "filterDestroyed");
	        }
	    };
	    GridApi.prototype.getStatusPanel = function (key) {
	        if (this.statusBarService) {
	            return this.statusBarService.getStatusPanel(key);
	        }
	    };
	    GridApi.prototype.getColumnDef = function (key) {
	        var column = this.columnController.getPrimaryColumn(key);
	        if (column) {
	            return column.getColDef();
	        }
	        else {
	            return null;
	        }
	    };
	    GridApi.prototype.onFilterChanged = function () {
	        this.filterManager.onFilterChanged();
	    };
	    GridApi.prototype.onSortChanged = function () {
	        this.sortController.onSortChanged();
	    };
	    GridApi.prototype.setSortModel = function (sortModel, source) {
	        if (source === void 0) { source = "api"; }
	        this.sortController.setSortModel(sortModel, source);
	    };
	    GridApi.prototype.getSortModel = function () {
	        return this.sortController.getSortModel();
	    };
	    GridApi.prototype.setFilterModel = function (model) {
	        this.filterManager.setFilterModel(model);
	    };
	    GridApi.prototype.getFilterModel = function () {
	        return this.filterManager.getFilterModel();
	    };
	    GridApi.prototype.getFocusedCell = function () {
	        return this.focusedCellController.getFocusedCell();
	    };
	    GridApi.prototype.clearFocusedCell = function () {
	        return this.focusedCellController.clearFocusedCell();
	    };
	    GridApi.prototype.setFocusedCell = function (rowIndex, colKey, floating) {
	        this.focusedCellController.setFocusedCell(rowIndex, colKey, floating, true);
	    };
	    GridApi.prototype.setSuppressRowDrag = function (value) {
	        this.gridOptionsWrapper.setProperty(gridOptionsWrapper_1.GridOptionsWrapper.PROP_SUPPRESS_ROW_DRAG, value);
	    };
	    GridApi.prototype.setHeaderHeight = function (headerHeight) {
	        this.gridOptionsWrapper.setProperty(gridOptionsWrapper_1.GridOptionsWrapper.PROP_HEADER_HEIGHT, headerHeight);
	        this.doLayout();
	    };
	    GridApi.prototype.setGridAutoHeight = function (gridAutoHeight) {
	        console.warn('api.setGridAutoHeight(boolean) is deprecated, please use api.setDomLayout() instead');
	        this.setDomLayout(gridAutoHeight ? 'autoHeight' : 'normal');
	    };
	    GridApi.prototype.setDomLayout = function (domLayout) {
	        this.gridOptionsWrapper.setProperty(gridOptionsWrapper_1.GridOptionsWrapper.PROP_DOM_LAYOUT, domLayout);
	    };
	    GridApi.prototype.setEnableCellTextSelection = function (selectable) {
	        this.gridPanel.setCellTextSelection(selectable);
	    };
	    GridApi.prototype.setGroupHeaderHeight = function (headerHeight) {
	        this.gridOptionsWrapper.setProperty(gridOptionsWrapper_1.GridOptionsWrapper.PROP_GROUP_HEADER_HEIGHT, headerHeight);
	        this.doLayout();
	    };
	    GridApi.prototype.setFloatingFiltersHeight = function (headerHeight) {
	        this.gridOptionsWrapper.setProperty(gridOptionsWrapper_1.GridOptionsWrapper.PROP_FLOATING_FILTERS_HEIGHT, headerHeight);
	        this.doLayout();
	    };
	    GridApi.prototype.setPivotGroupHeaderHeight = function (headerHeight) {
	        this.gridOptionsWrapper.setProperty(gridOptionsWrapper_1.GridOptionsWrapper.PROP_PIVOT_GROUP_HEADER_HEIGHT, headerHeight);
	        this.doLayout();
	    };
	    GridApi.prototype.setPivotHeaderHeight = function (headerHeight) {
	        this.gridOptionsWrapper.setProperty(gridOptionsWrapper_1.GridOptionsWrapper.PROP_PIVOT_HEADER_HEIGHT, headerHeight);
	        this.doLayout();
	    };
	    GridApi.prototype.isSideBarVisible = function () {
	        return this.gridCore.isSideBarVisible();
	    };
	    GridApi.prototype.setSideBarVisible = function (show) {
	        this.gridCore.setSideBarVisible(show);
	    };
	    GridApi.prototype.showToolPanel = function (show) {
	        console.warn("ag-grid: from v19 api.showToolPanel has been deprecated in favour of api.setSideBarVisible");
	        this.setSideBarVisible(show);
	    };
	    GridApi.prototype.openToolPanel = function (key) {
	        this.gridCore.openToolPanel(key);
	    };
	    GridApi.prototype.closeToolPanel = function () {
	        this.gridCore.closeToolPanel();
	    };
	    GridApi.prototype.getOpenedToolPanel = function () {
	        return this.gridCore.getOpenedToolPanel();
	    };
	    GridApi.prototype.getSideBar = function () {
	        return this.gridCore.getSideBar();
	    };
	    GridApi.prototype.setSideBar = function (def) {
	        return this.gridCore.setSideBar(def);
	    };
	    GridApi.prototype.setSuppressClipboardPaste = function (value) {
	        this.gridOptionsWrapper.setProperty(gridOptionsWrapper_1.GridOptionsWrapper.PROP_SUPPRESS_CLIPBOARD_PASTE, value);
	    };
	    GridApi.prototype.isToolPanelShowing = function () {
	        return this.gridCore.isToolPanelShowing();
	    };
	    GridApi.prototype.doLayout = function () {
	        this.gridPanel.checkViewportAndScrolls();
	    };
	    GridApi.prototype.resetRowHeights = function () {
	        if (utils_1._.exists(this.clientSideRowModel)) {
	            this.clientSideRowModel.resetRowHeights();
	        }
	    };
	    GridApi.prototype.setGroupRemoveSingleChildren = function (value) {
	        this.gridOptionsWrapper.setProperty(gridOptionsWrapper_1.GridOptionsWrapper.PROP_GROUP_REMOVE_SINGLE_CHILDREN, value);
	    };
	    GridApi.prototype.setGroupRemoveLowestSingleChildren = function (value) {
	        this.gridOptionsWrapper.setProperty(gridOptionsWrapper_1.GridOptionsWrapper.PROP_GROUP_REMOVE_LOWEST_SINGLE_CHILDREN, value);
	    };
	    GridApi.prototype.onRowHeightChanged = function () {
	        if (utils_1._.exists(this.clientSideRowModel)) {
	            this.clientSideRowModel.onRowHeightChanged();
	        }
	    };
	    GridApi.prototype.getValue = function (colKey, rowNode) {
	        var column = this.columnController.getPrimaryColumn(colKey);
	        if (utils_1._.missing(column)) {
	            column = this.columnController.getGridColumn(colKey);
	        }
	        if (utils_1._.missing(column)) {
	            return null;
	        }
	        else {
	            return this.valueService.getValue(column, rowNode);
	        }
	    };
	    GridApi.prototype.addEventListener = function (eventType, listener) {
	        var async = this.gridOptionsWrapper.useAsyncEvents();
	        this.eventService.addEventListener(eventType, listener, async);
	    };
	    GridApi.prototype.addGlobalListener = function (listener) {
	        var async = this.gridOptionsWrapper.useAsyncEvents();
	        this.eventService.addGlobalListener(listener, async);
	    };
	    GridApi.prototype.removeEventListener = function (eventType, listener) {
	        var async = this.gridOptionsWrapper.useAsyncEvents();
	        this.eventService.removeEventListener(eventType, listener, async);
	    };
	    GridApi.prototype.removeGlobalListener = function (listener) {
	        var async = this.gridOptionsWrapper.useAsyncEvents();
	        this.eventService.removeGlobalListener(listener, async);
	    };
	    GridApi.prototype.dispatchEvent = function (event) {
	        this.eventService.dispatchEvent(event);
	    };
	    GridApi.prototype.destroy = function () {
	        // destroy the UI first (as they use the services)
	        this.gridCore.destroy();
	        // destroy the services
	        this.context.destroy();
	    };
	    GridApi.prototype.resetQuickFilter = function () {
	        this.rowModel.forEachNode(function (node) { return node.quickFilterAggregateText = null; });
	    };
	    GridApi.prototype.getRangeSelections = function () {
	        console.warn("ag-Grid: in v20.1.x, api.getRangeSelections() is gone, please use getCellRanges() instead.\n        We had to change how cell selections works a small bit to allow charting to integrate. The return type of\n        getCellRanges() is a bit different, please check the ag-Grid documentation.");
	        return null;
	    };
	    GridApi.prototype.getCellRanges = function () {
	        if (this.rangeController) {
	            return this.rangeController.getCellRanges();
	        }
	        else {
	            console.warn('ag-Grid: cell range selection is only available in ag-Grid Enterprise');
	            return null;
	        }
	    };
	    GridApi.prototype.camelCaseToHumanReadable = function (camelCase) {
	        return utils_1._.camelCaseToHumanText(camelCase);
	    };
	    GridApi.prototype.addRangeSelection = function (deprecatedNoLongerUsed) {
	        console.warn('ag-Grid: As of version 21.x, range selection changed slightly to allow charting integration. Please call api.addCellRange() instead of api.addRangeSelection()');
	    };
	    GridApi.prototype.addCellRange = function (params) {
	        if (!this.rangeController) {
	            console.warn('ag-Grid: cell range selection is only available in ag-Grid Enterprise');
	        }
	        this.rangeController.addCellRange(params);
	    };
	    GridApi.prototype.clearRangeSelection = function () {
	        if (!this.rangeController) {
	            console.warn('ag-Grid: cell range selection is only available in ag-Grid Enterprise');
	        }
	        this.rangeController.removeAllCellRanges();
	    };
	    GridApi.prototype.chartRange = function (params) {
	        if (!this.context.isModuleRegistered("chartsModule" /* ChartsModule */)) {
	            utils_1._.doOnce(function () {
	                console.warn('ag-grid: Cannot chart range - the Charts Module has not been included.');
	            }, 'ChartsModuleCheck');
	            return;
	        }
	        return this.chartService.chartCellRange(params);
	    };
	    GridApi.prototype.copySelectedRowsToClipboard = function (includeHeader, columnKeys) {
	        if (!this.clipboardService) {
	            console.warn('ag-Grid: clipboard is only available in ag-Grid Enterprise');
	        }
	        this.clipboardService.copySelectedRowsToClipboard(includeHeader, columnKeys);
	    };
	    GridApi.prototype.copySelectedRangeToClipboard = function (includeHeader) {
	        if (!this.clipboardService) {
	            console.warn('ag-Grid: clipboard is only available in ag-Grid Enterprise');
	        }
	        this.clipboardService.copySelectedRangeToClipboard(includeHeader);
	    };
	    GridApi.prototype.copySelectedRangeDown = function () {
	        if (!this.clipboardService) {
	            console.warn('ag-Grid: clipboard is only available in ag-Grid Enterprise');
	        }
	        this.clipboardService.copyRangeDown();
	    };
	    GridApi.prototype.showColumnMenuAfterButtonClick = function (colKey, buttonElement) {
	        // use grid column so works with pivot mode
	        var column = this.columnController.getGridColumn(colKey);
	        this.menuFactory.showMenuAfterButtonClick(column, buttonElement);
	    };
	    GridApi.prototype.showColumnMenuAfterMouseClick = function (colKey, mouseEvent) {
	        // use grid column so works with pivot mode
	        var column = this.columnController.getGridColumn(colKey);
	        this.menuFactory.showMenuAfterMouseEvent(column, mouseEvent);
	    };
	    GridApi.prototype.hidePopupMenu = function () {
	        // hide the context menu if in enterprise
	        if (this.contextMenuFactory) {
	            this.contextMenuFactory.hideActiveMenu();
	        }
	        // and hide the column menu always
	        this.menuFactory.hideActiveMenu();
	    };
	    GridApi.prototype.setPopupParent = function (ePopupParent) {
	        this.gridOptionsWrapper.setProperty(gridOptionsWrapper_1.GridOptionsWrapper.PROP_POPUP_PARENT, ePopupParent);
	    };
	    GridApi.prototype.tabToNextCell = function () {
	        return this.rowRenderer.tabToNextCell(false);
	    };
	    GridApi.prototype.tabToPreviousCell = function () {
	        return this.rowRenderer.tabToNextCell(true);
	    };
	    GridApi.prototype.getCellRendererInstances = function (params) {
	        if (params === void 0) { params = {}; }
	        return this.rowRenderer.getCellRendererInstances(params);
	    };
	    GridApi.prototype.getCellEditorInstances = function (params) {
	        if (params === void 0) { params = {}; }
	        return this.rowRenderer.getCellEditorInstances(params);
	    };
	    GridApi.prototype.getEditingCells = function () {
	        return this.rowRenderer.getEditingCells();
	    };
	    GridApi.prototype.stopEditing = function (cancel) {
	        if (cancel === void 0) { cancel = false; }
	        this.rowRenderer.stopEditing(cancel);
	    };
	    GridApi.prototype.startEditingCell = function (params) {
	        var column = this.columnController.getGridColumn(params.colKey);
	        if (!column) {
	            console.warn("ag-Grid: no column found for " + params.colKey);
	            return;
	        }
	        var cellPosition = {
	            rowIndex: params.rowIndex,
	            rowPinned: params.rowPinned,
	            column: column
	        };
	        var notPinned = utils_1._.missing(params.rowPinned);
	        if (notPinned) {
	            this.gridPanel.ensureIndexVisible(params.rowIndex);
	        }
	        this.rowRenderer.startEditingCell(cellPosition, params.keyPress, params.charPress);
	    };
	    GridApi.prototype.addAggFunc = function (key, aggFunc) {
	        if (this.aggFuncService) {
	            this.aggFuncService.addAggFunc(key, aggFunc);
	        }
	    };
	    GridApi.prototype.addAggFuncs = function (aggFuncs) {
	        if (this.aggFuncService) {
	            this.aggFuncService.addAggFuncs(aggFuncs);
	        }
	    };
	    GridApi.prototype.clearAggFuncs = function () {
	        if (this.aggFuncService) {
	            this.aggFuncService.clear();
	        }
	    };
	    GridApi.prototype.updateRowData = function (rowDataTransaction) {
	        var res = null;
	        if (this.clientSideRowModel) {
	            res = this.clientSideRowModel.updateRowData(rowDataTransaction);
	        }
	        else if (this.infinitePageRowModel) {
	            this.infinitePageRowModel.updateRowData(rowDataTransaction);
	        }
	        else {
	            console.error('ag-Grid: updateRowData() only works with ClientSideRowModel and InfiniteRowModel.');
	        }
	        // refresh all the full width rows
	        this.rowRenderer.refreshFullWidthRows();
	        // do change detection for all present cells
	        if (!this.gridOptionsWrapper.isSuppressChangeDetection()) {
	            this.rowRenderer.refreshCells();
	        }
	        return res;
	    };
	    GridApi.prototype.batchUpdateRowData = function (rowDataTransaction, callback) {
	        if (!this.clientSideRowModel) {
	            console.error('ag-Grid: api.batchUpdateRowData() only works with ClientSideRowModel.');
	            return;
	        }
	        this.clientSideRowModel.batchUpdateRowData(rowDataTransaction, callback);
	    };
	    GridApi.prototype.insertItemsAtIndex = function (index, items, skipRefresh) {
	        if (skipRefresh === void 0) { skipRefresh = false; }
	        console.warn('ag-Grid: insertItemsAtIndex() is deprecated, use updateRowData(transaction) instead.');
	        this.updateRowData({ add: items, addIndex: index, update: null, remove: null });
	    };
	    GridApi.prototype.removeItems = function (rowNodes, skipRefresh) {
	        if (skipRefresh === void 0) { skipRefresh = false; }
	        console.warn('ag-Grid: removeItems() is deprecated, use updateRowData(transaction) instead.');
	        var dataToRemove = rowNodes.map(function (rowNode) { return rowNode.data; });
	        this.updateRowData({ add: null, addIndex: null, update: null, remove: dataToRemove });
	    };
	    GridApi.prototype.addItems = function (items, skipRefresh) {
	        if (skipRefresh === void 0) { skipRefresh = false; }
	        console.warn('ag-Grid: addItems() is deprecated, use updateRowData(transaction) instead.');
	        this.updateRowData({ add: items, addIndex: null, update: null, remove: null });
	    };
	    GridApi.prototype.refreshVirtualPageCache = function () {
	        console.warn('ag-Grid: refreshVirtualPageCache() is now called refreshInfiniteCache(), please call refreshInfiniteCache() instead');
	        this.refreshInfiniteCache();
	    };
	    GridApi.prototype.refreshInfinitePageCache = function () {
	        console.warn('ag-Grid: refreshInfinitePageCache() is now called refreshInfiniteCache(), please call refreshInfiniteCache() instead');
	        this.refreshInfiniteCache();
	    };
	    GridApi.prototype.refreshInfiniteCache = function () {
	        if (this.infinitePageRowModel) {
	            this.infinitePageRowModel.refreshCache();
	        }
	        else {
	            console.warn("ag-Grid: api.refreshInfiniteCache is only available when rowModelType='infinite'.");
	        }
	    };
	    GridApi.prototype.purgeVirtualPageCache = function () {
	        console.warn('ag-Grid: purgeVirtualPageCache() is now called purgeInfiniteCache(), please call purgeInfiniteCache() instead');
	        this.purgeInfinitePageCache();
	    };
	    GridApi.prototype.purgeInfinitePageCache = function () {
	        console.warn('ag-Grid: purgeInfinitePageCache() is now called purgeInfiniteCache(), please call purgeInfiniteCache() instead');
	        this.purgeInfiniteCache();
	    };
	    GridApi.prototype.purgeInfiniteCache = function () {
	        if (this.infinitePageRowModel) {
	            this.infinitePageRowModel.purgeCache();
	        }
	        else {
	            console.warn("ag-Grid: api.purgeInfiniteCache is only available when rowModelType='infinite'.");
	        }
	    };
	    /** @deprecated */
	    GridApi.prototype.purgeEnterpriseCache = function (route) {
	        console.warn("ag-grid: since version 18.x, api.purgeEnterpriseCache() should be replaced with api.purgeServerSideCache()");
	        this.purgeServerSideCache(route);
	    };
	    GridApi.prototype.purgeServerSideCache = function (route) {
	        if (this.serverSideRowModel) {
	            this.serverSideRowModel.purgeCache(route);
	        }
	        else {
	            console.warn("ag-Grid: api.purgeServerSideCache is only available when rowModelType='enterprise'.");
	        }
	    };
	    GridApi.prototype.getVirtualRowCount = function () {
	        console.warn('ag-Grid: getVirtualRowCount() is now called getInfiniteRowCount(), please call getInfiniteRowCount() instead');
	        return this.getInfiniteRowCount();
	    };
	    GridApi.prototype.getInfiniteRowCount = function () {
	        if (this.infinitePageRowModel) {
	            return this.infinitePageRowModel.getVirtualRowCount();
	        }
	        else {
	            console.warn("ag-Grid: api.getVirtualRowCount is only available when rowModelType='virtual'.");
	        }
	    };
	    GridApi.prototype.isMaxRowFound = function () {
	        if (this.infinitePageRowModel) {
	            return this.infinitePageRowModel.isMaxRowFound();
	        }
	        else {
	            console.warn("ag-Grid: api.isMaxRowFound is only available when rowModelType='virtual'.");
	        }
	    };
	    GridApi.prototype.setVirtualRowCount = function (rowCount, maxRowFound) {
	        console.warn('ag-Grid: setVirtualRowCount() is now called setInfiniteRowCount(), please call setInfiniteRowCount() instead');
	        this.setInfiniteRowCount(rowCount, maxRowFound);
	    };
	    GridApi.prototype.setInfiniteRowCount = function (rowCount, maxRowFound) {
	        if (this.infinitePageRowModel) {
	            this.infinitePageRowModel.setVirtualRowCount(rowCount, maxRowFound);
	        }
	        else {
	            console.warn("ag-Grid: api.setVirtualRowCount is only available when rowModelType='virtual'.");
	        }
	    };
	    GridApi.prototype.getVirtualPageState = function () {
	        console.warn('ag-Grid: getVirtualPageState() is now called getCacheBlockState(), please call getCacheBlockState() instead');
	        return this.getCacheBlockState();
	    };
	    GridApi.prototype.getInfinitePageState = function () {
	        console.warn('ag-Grid: getInfinitePageState() is now called getCacheBlockState(), please call getCacheBlockState() instead');
	        return this.getCacheBlockState();
	    };
	    GridApi.prototype.getCacheBlockState = function () {
	        if (this.infinitePageRowModel) {
	            return this.infinitePageRowModel.getBlockState();
	        }
	        else if (this.serverSideRowModel) {
	            return this.serverSideRowModel.getBlockState();
	        }
	        else {
	            console.warn("ag-Grid: api.getCacheBlockState() is only available when rowModelType='infinite' or rowModelType='serverSide'.");
	        }
	    };
	    GridApi.prototype.checkGridSize = function () {
	        this.gridPanel.setHeaderAndFloatingHeights();
	    };
	    GridApi.prototype.getFirstRenderedRow = function () {
	        console.warn('in ag-Grid v12, getFirstRenderedRow() was renamed to getFirstDisplayedRow()');
	        return this.getFirstDisplayedRow();
	    };
	    GridApi.prototype.getFirstDisplayedRow = function () {
	        return this.rowRenderer.getFirstVirtualRenderedRow();
	    };
	    GridApi.prototype.getLastRenderedRow = function () {
	        console.warn('in ag-Grid v12, getLastRenderedRow() was renamed to getLastDisplayedRow()');
	        return this.getLastDisplayedRow();
	    };
	    GridApi.prototype.getLastDisplayedRow = function () {
	        return this.rowRenderer.getLastVirtualRenderedRow();
	    };
	    GridApi.prototype.getDisplayedRowAtIndex = function (index) {
	        return this.rowModel.getRow(index);
	    };
	    GridApi.prototype.getDisplayedRowCount = function () {
	        return this.rowModel.getRowCount();
	    };
	    GridApi.prototype.paginationIsLastPageFound = function () {
	        return this.paginationProxy.isLastPageFound();
	    };
	    GridApi.prototype.paginationGetPageSize = function () {
	        return this.paginationProxy.getPageSize();
	    };
	    GridApi.prototype.paginationSetPageSize = function (size) {
	        this.gridOptionsWrapper.setProperty('paginationPageSize', size);
	    };
	    GridApi.prototype.paginationGetCurrentPage = function () {
	        return this.paginationProxy.getCurrentPage();
	    };
	    GridApi.prototype.paginationGetTotalPages = function () {
	        return this.paginationProxy.getTotalPages();
	    };
	    GridApi.prototype.paginationGetRowCount = function () {
	        return this.paginationProxy.getMasterRowCount();
	    };
	    GridApi.prototype.paginationGoToNextPage = function () {
	        this.paginationProxy.goToNextPage();
	    };
	    GridApi.prototype.paginationGoToPreviousPage = function () {
	        this.paginationProxy.goToPreviousPage();
	    };
	    GridApi.prototype.paginationGoToFirstPage = function () {
	        this.paginationProxy.goToFirstPage();
	    };
	    GridApi.prototype.paginationGoToLastPage = function () {
	        this.paginationProxy.goToLastPage();
	    };
	    GridApi.prototype.paginationGoToPage = function (page) {
	        this.paginationProxy.goToPage(page);
	    };
	    __decorate([
	        context_1.Autowired('immutableService'),
	        __metadata("design:type", immutableService_1.ImmutableService)
	    ], GridApi.prototype, "immutableService", void 0);
	    __decorate([
	        context_1.Autowired('csvCreator'),
	        __metadata("design:type", csvCreator_1.CsvCreator)
	    ], GridApi.prototype, "csvCreator", void 0);
	    __decorate([
	        context_1.Optional('excelCreator'),
	        __metadata("design:type", Object)
	    ], GridApi.prototype, "excelCreator", void 0);
	    __decorate([
	        context_1.Autowired('rowRenderer'),
	        __metadata("design:type", rowRenderer_1.RowRenderer)
	    ], GridApi.prototype, "rowRenderer", void 0);
	    __decorate([
	        context_1.Autowired('filterManager'),
	        __metadata("design:type", filterManager_1.FilterManager)
	    ], GridApi.prototype, "filterManager", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], GridApi.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('selectionController'),
	        __metadata("design:type", selectionController_1.SelectionController)
	    ], GridApi.prototype, "selectionController", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], GridApi.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('valueService'),
	        __metadata("design:type", valueService_1.ValueService)
	    ], GridApi.prototype, "valueService", void 0);
	    __decorate([
	        context_1.Autowired('alignedGridsService'),
	        __metadata("design:type", alignedGridsService_1.AlignedGridsService)
	    ], GridApi.prototype, "alignedGridsService", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], GridApi.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('pinnedRowModel'),
	        __metadata("design:type", pinnedRowModel_1.PinnedRowModel)
	    ], GridApi.prototype, "pinnedRowModel", void 0);
	    __decorate([
	        context_1.Autowired('context'),
	        __metadata("design:type", context_1.Context)
	    ], GridApi.prototype, "context", void 0);
	    __decorate([
	        context_1.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], GridApi.prototype, "rowModel", void 0);
	    __decorate([
	        context_1.Autowired('sortController'),
	        __metadata("design:type", sortController_1.SortController)
	    ], GridApi.prototype, "sortController", void 0);
	    __decorate([
	        context_1.Autowired('paginationProxy'),
	        __metadata("design:type", paginationProxy_1.PaginationProxy)
	    ], GridApi.prototype, "paginationProxy", void 0);
	    __decorate([
	        context_1.Autowired('focusedCellController'),
	        __metadata("design:type", focusedCellController_1.FocusedCellController)
	    ], GridApi.prototype, "focusedCellController", void 0);
	    __decorate([
	        context_1.Optional('rangeController'),
	        __metadata("design:type", Object)
	    ], GridApi.prototype, "rangeController", void 0);
	    __decorate([
	        context_1.Optional('clipboardService'),
	        __metadata("design:type", Object)
	    ], GridApi.prototype, "clipboardService", void 0);
	    __decorate([
	        context_1.Optional('aggFuncService'),
	        __metadata("design:type", Object)
	    ], GridApi.prototype, "aggFuncService", void 0);
	    __decorate([
	        context_1.Autowired('menuFactory'),
	        __metadata("design:type", Object)
	    ], GridApi.prototype, "menuFactory", void 0);
	    __decorate([
	        context_1.Optional('contextMenuFactory'),
	        __metadata("design:type", Object)
	    ], GridApi.prototype, "contextMenuFactory", void 0);
	    __decorate([
	        context_1.Autowired('cellRendererFactory'),
	        __metadata("design:type", cellRendererFactory_1.CellRendererFactory)
	    ], GridApi.prototype, "cellRendererFactory", void 0);
	    __decorate([
	        context_1.Autowired('valueCache'),
	        __metadata("design:type", valueCache_1.ValueCache)
	    ], GridApi.prototype, "valueCache", void 0);
	    __decorate([
	        context_1.Optional('sideBarComp'),
	        __metadata("design:type", Object)
	    ], GridApi.prototype, "sideBarComp", void 0);
	    __decorate([
	        context_1.Autowired('animationFrameService'),
	        __metadata("design:type", animationFrameService_1.AnimationFrameService)
	    ], GridApi.prototype, "animationFrameService", void 0);
	    __decorate([
	        context_1.Optional('statusBarService'),
	        __metadata("design:type", Object)
	    ], GridApi.prototype, "statusBarService", void 0);
	    __decorate([
	        context_1.Optional('chartService'),
	        __metadata("design:type", Object)
	    ], GridApi.prototype, "chartService", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], GridApi.prototype, "init", null);
	    GridApi = __decorate([
	        context_1.Bean('gridApi')
	    ], GridApi);
	    return GridApi;
	}());
	exports.GridApi = GridApi;


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(107);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 35 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var BoundingRect = __webpack_require__(42);
	
	var _number = __webpack_require__(20);
	
	var parsePercent = _number.parsePercent;
	
	var formatUtil = __webpack_require__(40);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Layout helpers for each component positioning
	var each = zrUtil.each;
	/**
	 * @public
	 */
	
	var LOCATION_PARAMS = ['left', 'right', 'top', 'bottom', 'width', 'height'];
	/**
	 * @public
	 */
	
	var HV_NAMES = [['width', 'left', 'right'], ['height', 'top', 'bottom']];
	
	function boxLayout(orient, group, gap, maxWidth, maxHeight) {
	  var x = 0;
	  var y = 0;
	
	  if (maxWidth == null) {
	    maxWidth = Infinity;
	  }
	
	  if (maxHeight == null) {
	    maxHeight = Infinity;
	  }
	
	  var currentLineMaxSize = 0;
	  group.eachChild(function (child, idx) {
	    var position = child.position;
	    var rect = child.getBoundingRect();
	    var nextChild = group.childAt(idx + 1);
	    var nextChildRect = nextChild && nextChild.getBoundingRect();
	    var nextX;
	    var nextY;
	
	    if (orient === 'horizontal') {
	      var moveX = rect.width + (nextChildRect ? -nextChildRect.x + rect.x : 0);
	      nextX = x + moveX; // Wrap when width exceeds maxWidth or meet a `newline` group
	      // FIXME compare before adding gap?
	
	      if (nextX > maxWidth || child.newline) {
	        x = 0;
	        nextX = moveX;
	        y += currentLineMaxSize + gap;
	        currentLineMaxSize = rect.height;
	      } else {
	        // FIXME: consider rect.y is not `0`?
	        currentLineMaxSize = Math.max(currentLineMaxSize, rect.height);
	      }
	    } else {
	      var moveY = rect.height + (nextChildRect ? -nextChildRect.y + rect.y : 0);
	      nextY = y + moveY; // Wrap when width exceeds maxHeight or meet a `newline` group
	
	      if (nextY > maxHeight || child.newline) {
	        x += currentLineMaxSize + gap;
	        y = 0;
	        nextY = moveY;
	        currentLineMaxSize = rect.width;
	      } else {
	        currentLineMaxSize = Math.max(currentLineMaxSize, rect.width);
	      }
	    }
	
	    if (child.newline) {
	      return;
	    }
	
	    position[0] = x;
	    position[1] = y;
	    orient === 'horizontal' ? x = nextX + gap : y = nextY + gap;
	  });
	}
	/**
	 * VBox or HBox layouting
	 * @param {string} orient
	 * @param {module:zrender/container/Group} group
	 * @param {number} gap
	 * @param {number} [width=Infinity]
	 * @param {number} [height=Infinity]
	 */
	
	
	var box = boxLayout;
	/**
	 * VBox layouting
	 * @param {module:zrender/container/Group} group
	 * @param {number} gap
	 * @param {number} [width=Infinity]
	 * @param {number} [height=Infinity]
	 */
	
	var vbox = zrUtil.curry(boxLayout, 'vertical');
	/**
	 * HBox layouting
	 * @param {module:zrender/container/Group} group
	 * @param {number} gap
	 * @param {number} [width=Infinity]
	 * @param {number} [height=Infinity]
	 */
	
	var hbox = zrUtil.curry(boxLayout, 'horizontal');
	/**
	 * If x or x2 is not specified or 'center' 'left' 'right',
	 * the width would be as long as possible.
	 * If y or y2 is not specified or 'middle' 'top' 'bottom',
	 * the height would be as long as possible.
	 *
	 * @param {Object} positionInfo
	 * @param {number|string} [positionInfo.x]
	 * @param {number|string} [positionInfo.y]
	 * @param {number|string} [positionInfo.x2]
	 * @param {number|string} [positionInfo.y2]
	 * @param {Object} containerRect {width, height}
	 * @param {string|number} margin
	 * @return {Object} {width, height}
	 */
	
	function getAvailableSize(positionInfo, containerRect, margin) {
	  var containerWidth = containerRect.width;
	  var containerHeight = containerRect.height;
	  var x = parsePercent(positionInfo.x, containerWidth);
	  var y = parsePercent(positionInfo.y, containerHeight);
	  var x2 = parsePercent(positionInfo.x2, containerWidth);
	  var y2 = parsePercent(positionInfo.y2, containerHeight);
	  (isNaN(x) || isNaN(parseFloat(positionInfo.x))) && (x = 0);
	  (isNaN(x2) || isNaN(parseFloat(positionInfo.x2))) && (x2 = containerWidth);
	  (isNaN(y) || isNaN(parseFloat(positionInfo.y))) && (y = 0);
	  (isNaN(y2) || isNaN(parseFloat(positionInfo.y2))) && (y2 = containerHeight);
	  margin = formatUtil.normalizeCssArray(margin || 0);
	  return {
	    width: Math.max(x2 - x - margin[1] - margin[3], 0),
	    height: Math.max(y2 - y - margin[0] - margin[2], 0)
	  };
	}
	/**
	 * Parse position info.
	 *
	 * @param {Object} positionInfo
	 * @param {number|string} [positionInfo.left]
	 * @param {number|string} [positionInfo.top]
	 * @param {number|string} [positionInfo.right]
	 * @param {number|string} [positionInfo.bottom]
	 * @param {number|string} [positionInfo.width]
	 * @param {number|string} [positionInfo.height]
	 * @param {number|string} [positionInfo.aspect] Aspect is width / height
	 * @param {Object} containerRect
	 * @param {string|number} [margin]
	 *
	 * @return {module:zrender/core/BoundingRect}
	 */
	
	
	function getLayoutRect(positionInfo, containerRect, margin) {
	  margin = formatUtil.normalizeCssArray(margin || 0);
	  var containerWidth = containerRect.width;
	  var containerHeight = containerRect.height;
	  var left = parsePercent(positionInfo.left, containerWidth);
	  var top = parsePercent(positionInfo.top, containerHeight);
	  var right = parsePercent(positionInfo.right, containerWidth);
	  var bottom = parsePercent(positionInfo.bottom, containerHeight);
	  var width = parsePercent(positionInfo.width, containerWidth);
	  var height = parsePercent(positionInfo.height, containerHeight);
	  var verticalMargin = margin[2] + margin[0];
	  var horizontalMargin = margin[1] + margin[3];
	  var aspect = positionInfo.aspect; // If width is not specified, calculate width from left and right
	
	  if (isNaN(width)) {
	    width = containerWidth - right - horizontalMargin - left;
	  }
	
	  if (isNaN(height)) {
	    height = containerHeight - bottom - verticalMargin - top;
	  }
	
	  if (aspect != null) {
	    // If width and height are not given
	    // 1. Graph should not exceeds the container
	    // 2. Aspect must be keeped
	    // 3. Graph should take the space as more as possible
	    // FIXME
	    // Margin is not considered, because there is no case that both
	    // using margin and aspect so far.
	    if (isNaN(width) && isNaN(height)) {
	      if (aspect > containerWidth / containerHeight) {
	        width = containerWidth * 0.8;
	      } else {
	        height = containerHeight * 0.8;
	      }
	    } // Calculate width or height with given aspect
	
	
	    if (isNaN(width)) {
	      width = aspect * height;
	    }
	
	    if (isNaN(height)) {
	      height = width / aspect;
	    }
	  } // If left is not specified, calculate left from right and width
	
	
	  if (isNaN(left)) {
	    left = containerWidth - right - width - horizontalMargin;
	  }
	
	  if (isNaN(top)) {
	    top = containerHeight - bottom - height - verticalMargin;
	  } // Align left and top
	
	
	  switch (positionInfo.left || positionInfo.right) {
	    case 'center':
	      left = containerWidth / 2 - width / 2 - margin[3];
	      break;
	
	    case 'right':
	      left = containerWidth - width - horizontalMargin;
	      break;
	  }
	
	  switch (positionInfo.top || positionInfo.bottom) {
	    case 'middle':
	    case 'center':
	      top = containerHeight / 2 - height / 2 - margin[0];
	      break;
	
	    case 'bottom':
	      top = containerHeight - height - verticalMargin;
	      break;
	  } // If something is wrong and left, top, width, height are calculated as NaN
	
	
	  left = left || 0;
	  top = top || 0;
	
	  if (isNaN(width)) {
	    // Width may be NaN if only one value is given except width
	    width = containerWidth - horizontalMargin - left - (right || 0);
	  }
	
	  if (isNaN(height)) {
	    // Height may be NaN if only one value is given except height
	    height = containerHeight - verticalMargin - top - (bottom || 0);
	  }
	
	  var rect = new BoundingRect(left + margin[3], top + margin[0], width, height);
	  rect.margin = margin;
	  return rect;
	}
	/**
	 * Position a zr element in viewport
	 *  Group position is specified by either
	 *  {left, top}, {right, bottom}
	 *  If all properties exists, right and bottom will be igonred.
	 *
	 * Logic:
	 *     1. Scale (against origin point in parent coord)
	 *     2. Rotate (against origin point in parent coord)
	 *     3. Traslate (with el.position by this method)
	 * So this method only fixes the last step 'Traslate', which does not affect
	 * scaling and rotating.
	 *
	 * If be called repeatly with the same input el, the same result will be gotten.
	 *
	 * @param {module:zrender/Element} el Should have `getBoundingRect` method.
	 * @param {Object} positionInfo
	 * @param {number|string} [positionInfo.left]
	 * @param {number|string} [positionInfo.top]
	 * @param {number|string} [positionInfo.right]
	 * @param {number|string} [positionInfo.bottom]
	 * @param {number|string} [positionInfo.width] Only for opt.boundingModel: 'raw'
	 * @param {number|string} [positionInfo.height] Only for opt.boundingModel: 'raw'
	 * @param {Object} containerRect
	 * @param {string|number} margin
	 * @param {Object} [opt]
	 * @param {Array.<number>} [opt.hv=[1,1]] Only horizontal or only vertical.
	 * @param {Array.<number>} [opt.boundingMode='all']
	 *        Specify how to calculate boundingRect when locating.
	 *        'all': Position the boundingRect that is transformed and uioned
	 *               both itself and its descendants.
	 *               This mode simplies confine the elements in the bounding
	 *               of their container (e.g., using 'right: 0').
	 *        'raw': Position the boundingRect that is not transformed and only itself.
	 *               This mode is useful when you want a element can overflow its
	 *               container. (Consider a rotated circle needs to be located in a corner.)
	 *               In this mode positionInfo.width/height can only be number.
	 */
	
	
	function positionElement(el, positionInfo, containerRect, margin, opt) {
	  var h = !opt || !opt.hv || opt.hv[0];
	  var v = !opt || !opt.hv || opt.hv[1];
	  var boundingMode = opt && opt.boundingMode || 'all';
	
	  if (!h && !v) {
	    return;
	  }
	
	  var rect;
	
	  if (boundingMode === 'raw') {
	    rect = el.type === 'group' ? new BoundingRect(0, 0, +positionInfo.width || 0, +positionInfo.height || 0) : el.getBoundingRect();
	  } else {
	    rect = el.getBoundingRect();
	
	    if (el.needLocalTransform()) {
	      var transform = el.getLocalTransform(); // Notice: raw rect may be inner object of el,
	      // which should not be modified.
	
	      rect = rect.clone();
	      rect.applyTransform(transform);
	    }
	  } // The real width and height can not be specified but calculated by the given el.
	
	
	  positionInfo = getLayoutRect(zrUtil.defaults({
	    width: rect.width,
	    height: rect.height
	  }, positionInfo), containerRect, margin); // Because 'tranlate' is the last step in transform
	  // (see zrender/core/Transformable#getLocalTransform),
	  // we can just only modify el.position to get final result.
	
	  var elPos = el.position;
	  var dx = h ? positionInfo.x - rect.x : 0;
	  var dy = v ? positionInfo.y - rect.y : 0;
	  el.attr('position', boundingMode === 'raw' ? [dx, dy] : [elPos[0] + dx, elPos[1] + dy]);
	}
	/**
	 * @param {Object} option Contains some of the properties in HV_NAMES.
	 * @param {number} hvIdx 0: horizontal; 1: vertical.
	 */
	
	
	function sizeCalculable(option, hvIdx) {
	  return option[HV_NAMES[hvIdx][0]] != null || option[HV_NAMES[hvIdx][1]] != null && option[HV_NAMES[hvIdx][2]] != null;
	}
	/**
	 * Consider Case:
	 * When defulat option has {left: 0, width: 100}, and we set {right: 0}
	 * through setOption or media query, using normal zrUtil.merge will cause
	 * {right: 0} does not take effect.
	 *
	 * @example
	 * ComponentModel.extend({
	 *     init: function () {
	 *         ...
	 *         var inputPositionParams = layout.getLayoutParams(option);
	 *         this.mergeOption(inputPositionParams);
	 *     },
	 *     mergeOption: function (newOption) {
	 *         newOption && zrUtil.merge(thisOption, newOption, true);
	 *         layout.mergeLayoutParam(thisOption, newOption);
	 *     }
	 * });
	 *
	 * @param {Object} targetOption
	 * @param {Object} newOption
	 * @param {Object|string} [opt]
	 * @param {boolean|Array.<boolean>} [opt.ignoreSize=false] Used for the components
	 *  that width (or height) should not be calculated by left and right (or top and bottom).
	 */
	
	
	function mergeLayoutParam(targetOption, newOption, opt) {
	  !zrUtil.isObject(opt) && (opt = {});
	  var ignoreSize = opt.ignoreSize;
	  !zrUtil.isArray(ignoreSize) && (ignoreSize = [ignoreSize, ignoreSize]);
	  var hResult = merge(HV_NAMES[0], 0);
	  var vResult = merge(HV_NAMES[1], 1);
	  copy(HV_NAMES[0], targetOption, hResult);
	  copy(HV_NAMES[1], targetOption, vResult);
	
	  function merge(names, hvIdx) {
	    var newParams = {};
	    var newValueCount = 0;
	    var merged = {};
	    var mergedValueCount = 0;
	    var enoughParamNumber = 2;
	    each(names, function (name) {
	      merged[name] = targetOption[name];
	    });
	    each(names, function (name) {
	      // Consider case: newOption.width is null, which is
	      // set by user for removing width setting.
	      hasProp(newOption, name) && (newParams[name] = merged[name] = newOption[name]);
	      hasValue(newParams, name) && newValueCount++;
	      hasValue(merged, name) && mergedValueCount++;
	    });
	
	    if (ignoreSize[hvIdx]) {
	      // Only one of left/right is premitted to exist.
	      if (hasValue(newOption, names[1])) {
	        merged[names[2]] = null;
	      } else if (hasValue(newOption, names[2])) {
	        merged[names[1]] = null;
	      }
	
	      return merged;
	    } // Case: newOption: {width: ..., right: ...},
	    // or targetOption: {right: ...} and newOption: {width: ...},
	    // There is no conflict when merged only has params count
	    // little than enoughParamNumber.
	
	
	    if (mergedValueCount === enoughParamNumber || !newValueCount) {
	      return merged;
	    } // Case: newOption: {width: ..., right: ...},
	    // Than we can make sure user only want those two, and ignore
	    // all origin params in targetOption.
	    else if (newValueCount >= enoughParamNumber) {
	        return newParams;
	      } else {
	        // Chose another param from targetOption by priority.
	        for (var i = 0; i < names.length; i++) {
	          var name = names[i];
	
	          if (!hasProp(newParams, name) && hasProp(targetOption, name)) {
	            newParams[name] = targetOption[name];
	            break;
	          }
	        }
	
	        return newParams;
	      }
	  }
	
	  function hasProp(obj, name) {
	    return obj.hasOwnProperty(name);
	  }
	
	  function hasValue(obj, name) {
	    return obj[name] != null && obj[name] !== 'auto';
	  }
	
	  function copy(names, target, source) {
	    each(names, function (name) {
	      target[name] = source[name];
	    });
	  }
	}
	/**
	 * Retrieve 'left', 'right', 'top', 'bottom', 'width', 'height' from object.
	 * @param {Object} source
	 * @return {Object} Result contains those props.
	 */
	
	
	function getLayoutParams(source) {
	  return copyLayoutParams({}, source);
	}
	/**
	 * Retrieve 'left', 'right', 'top', 'bottom', 'width', 'height' from object.
	 * @param {Object} source
	 * @return {Object} Result contains those props.
	 */
	
	
	function copyLayoutParams(target, source) {
	  source && target && each(LOCATION_PARAMS, function (name) {
	    source.hasOwnProperty(name) && (target[name] = source[name]);
	  });
	  return target;
	}
	
	exports.LOCATION_PARAMS = LOCATION_PARAMS;
	exports.HV_NAMES = HV_NAMES;
	exports.box = box;
	exports.vbox = vbox;
	exports.hbox = hbox;
	exports.getAvailableSize = getAvailableSize;
	exports.getLayoutRect = getLayoutRect;
	exports.positionElement = positionElement;
	exports.sizeCalculable = sizeCalculable;
	exports.mergeLayoutParam = mergeLayoutParam;
	exports.getLayoutParams = getLayoutParams;
	exports.copyLayoutParams = copyLayoutParams;

/***/ },
/* 37 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var columnController_1 = __webpack_require__(26);
	var context_1 = __webpack_require__(8);
	var ColumnApi = /** @class */ (function () {
	    function ColumnApi() {
	    }
	    ColumnApi.prototype.sizeColumnsToFit = function (gridWidth) { this.columnController.sizeColumnsToFit(gridWidth, 'api'); };
	    ColumnApi.prototype.setColumnGroupOpened = function (group, newValue) { this.columnController.setColumnGroupOpened(group, newValue, 'api'); };
	    ColumnApi.prototype.getColumnGroup = function (name, instanceId) { return this.columnController.getColumnGroup(name, instanceId); };
	    ColumnApi.prototype.getOriginalColumnGroup = function (name) { return this.columnController.getOriginalColumnGroup(name); };
	    ColumnApi.prototype.getDisplayNameForColumn = function (column, location) { return this.columnController.getDisplayNameForColumn(column, location); };
	    ColumnApi.prototype.getDisplayNameForColumnGroup = function (columnGroup, location) { return this.columnController.getDisplayNameForColumnGroup(columnGroup, location); };
	    ColumnApi.prototype.getColumn = function (key) { return this.columnController.getPrimaryColumn(key); };
	    ColumnApi.prototype.setColumnState = function (columnState) { return this.columnController.setColumnState(columnState, false, 'api'); };
	    ColumnApi.prototype.getColumnState = function () { return this.columnController.getColumnState(); };
	    ColumnApi.prototype.resetColumnState = function () { this.columnController.resetColumnState(false, 'api'); };
	    ColumnApi.prototype.getColumnGroupState = function () { return this.columnController.getColumnGroupState(); };
	    ColumnApi.prototype.setColumnGroupState = function (stateItems) { this.columnController.setColumnGroupState(stateItems, 'api'); };
	    ColumnApi.prototype.resetColumnGroupState = function () { this.columnController.resetColumnGroupState('api'); };
	    ColumnApi.prototype.isPinning = function () { return this.columnController.isPinningLeft() || this.columnController.isPinningRight(); };
	    ColumnApi.prototype.isPinningLeft = function () { return this.columnController.isPinningLeft(); };
	    ColumnApi.prototype.isPinningRight = function () { return this.columnController.isPinningRight(); };
	    ColumnApi.prototype.getDisplayedColAfter = function (col) { return this.columnController.getDisplayedColAfter(col); };
	    ColumnApi.prototype.getDisplayedColBefore = function (col) { return this.columnController.getDisplayedColBefore(col); };
	    ColumnApi.prototype.setColumnVisible = function (key, visible) { this.columnController.setColumnVisible(key, visible, 'api'); };
	    ColumnApi.prototype.setColumnsVisible = function (keys, visible) { this.columnController.setColumnsVisible(keys, visible, 'api'); };
	    ColumnApi.prototype.setColumnPinned = function (key, pinned) { this.columnController.setColumnPinned(key, pinned, 'api'); };
	    ColumnApi.prototype.setColumnsPinned = function (keys, pinned) { this.columnController.setColumnsPinned(keys, pinned, 'api'); };
	    ColumnApi.prototype.getAllColumns = function () { return this.columnController.getAllPrimaryColumns(); };
	    ColumnApi.prototype.getAllGridColumns = function () { return this.columnController.getAllGridColumns(); };
	    ColumnApi.prototype.getDisplayedLeftColumns = function () { return this.columnController.getDisplayedLeftColumns(); };
	    ColumnApi.prototype.getDisplayedCenterColumns = function () { return this.columnController.getDisplayedCenterColumns(); };
	    ColumnApi.prototype.getDisplayedRightColumns = function () { return this.columnController.getDisplayedRightColumns(); };
	    ColumnApi.prototype.getAllDisplayedColumns = function () { return this.columnController.getAllDisplayedColumns(); };
	    ColumnApi.prototype.getAllDisplayedVirtualColumns = function () { return this.columnController.getAllDisplayedVirtualColumns(); };
	    ColumnApi.prototype.moveColumn = function (key, toIndex) {
	        if (typeof key === 'number') {
	            // moveColumn used to take indexes, so this is advising user who hasn't moved to new method name
	            console.warn('ag-Grid: you are using moveColumn(fromIndex, toIndex) - moveColumn takes a column key and a destination index, not two indexes, to move with indexes use moveColumnByIndex(from,to) instead');
	            this.columnController.moveColumnByIndex(key, toIndex, 'api');
	        }
	        else {
	            this.columnController.moveColumn(key, toIndex, 'api');
	        }
	    };
	    ColumnApi.prototype.moveColumnByIndex = function (fromIndex, toIndex) { this.columnController.moveColumnByIndex(fromIndex, toIndex, 'api'); };
	    ColumnApi.prototype.moveColumns = function (columnsToMoveKeys, toIndex) { this.columnController.moveColumns(columnsToMoveKeys, toIndex, 'api'); };
	    ColumnApi.prototype.moveRowGroupColumn = function (fromIndex, toIndex) { this.columnController.moveRowGroupColumn(fromIndex, toIndex); };
	    ColumnApi.prototype.setColumnAggFunc = function (column, aggFunc) { this.columnController.setColumnAggFunc(column, aggFunc); };
	    ColumnApi.prototype.setColumnWidth = function (key, newWidth, finished) {
	        if (finished === void 0) { finished = true; }
	        this.columnController.setColumnWidth(key, newWidth, false, finished);
	    };
	    ColumnApi.prototype.setPivotMode = function (pivotMode) { this.columnController.setPivotMode(pivotMode); };
	    ColumnApi.prototype.isPivotMode = function () { return this.columnController.isPivotMode(); };
	    ColumnApi.prototype.getSecondaryPivotColumn = function (pivotKeys, valueColKey) { return this.columnController.getSecondaryPivotColumn(pivotKeys, valueColKey); };
	    ColumnApi.prototype.setValueColumns = function (colKeys) { this.columnController.setValueColumns(colKeys, 'api'); };
	    ColumnApi.prototype.getValueColumns = function () { return this.columnController.getValueColumns(); };
	    ColumnApi.prototype.removeValueColumn = function (colKey) { this.columnController.removeValueColumn(colKey, 'api'); };
	    ColumnApi.prototype.removeValueColumns = function (colKeys) { this.columnController.removeValueColumns(colKeys, 'api'); };
	    ColumnApi.prototype.addValueColumn = function (colKey) { this.columnController.addValueColumn(colKey, 'api'); };
	    ColumnApi.prototype.addValueColumns = function (colKeys) { this.columnController.addValueColumns(colKeys, 'api'); };
	    ColumnApi.prototype.setRowGroupColumns = function (colKeys) { this.columnController.setRowGroupColumns(colKeys, 'api'); };
	    ColumnApi.prototype.removeRowGroupColumn = function (colKey) { this.columnController.removeRowGroupColumn(colKey, 'api'); };
	    ColumnApi.prototype.removeRowGroupColumns = function (colKeys) { this.columnController.removeRowGroupColumns(colKeys, 'api'); };
	    ColumnApi.prototype.addRowGroupColumn = function (colKey) { this.columnController.addRowGroupColumn(colKey, 'api'); };
	    ColumnApi.prototype.addRowGroupColumns = function (colKeys) { this.columnController.addRowGroupColumns(colKeys, 'api'); };
	    ColumnApi.prototype.getRowGroupColumns = function () { return this.columnController.getRowGroupColumns(); };
	    ColumnApi.prototype.setPivotColumns = function (colKeys) { this.columnController.setPivotColumns(colKeys, 'api'); };
	    ColumnApi.prototype.removePivotColumn = function (colKey) { this.columnController.removePivotColumn(colKey, 'api'); };
	    ColumnApi.prototype.removePivotColumns = function (colKeys) { this.columnController.removePivotColumns(colKeys, 'api'); };
	    ColumnApi.prototype.addPivotColumn = function (colKey) { this.columnController.addPivotColumn(colKey, 'api'); };
	    ColumnApi.prototype.addPivotColumns = function (colKeys) { this.columnController.addPivotColumns(colKeys, 'api'); };
	    ColumnApi.prototype.getPivotColumns = function () { return this.columnController.getPivotColumns(); };
	    ColumnApi.prototype.getLeftDisplayedColumnGroups = function () { return this.columnController.getLeftDisplayedColumnGroups(); };
	    ColumnApi.prototype.getCenterDisplayedColumnGroups = function () { return this.columnController.getCenterDisplayedColumnGroups(); };
	    ColumnApi.prototype.getRightDisplayedColumnGroups = function () { return this.columnController.getRightDisplayedColumnGroups(); };
	    ColumnApi.prototype.getAllDisplayedColumnGroups = function () { return this.columnController.getAllDisplayedColumnGroups(); };
	    ColumnApi.prototype.autoSizeColumn = function (key) { return this.columnController.autoSizeColumn(key, 'api'); };
	    ColumnApi.prototype.autoSizeColumns = function (keys) { return this.columnController.autoSizeColumns(keys, 'api'); };
	    ColumnApi.prototype.autoSizeAllColumns = function () { this.columnController.autoSizeAllColumns('api'); };
	    ColumnApi.prototype.setSecondaryColumns = function (colDefs) { this.columnController.setSecondaryColumns(colDefs, 'api'); };
	    ColumnApi.prototype.getSecondaryColumns = function () { return this.columnController.getSecondaryColumns(); };
	    ColumnApi.prototype.getPrimaryColumns = function () { return this.columnController.getAllPrimaryColumns(); };
	    // below goes through deprecated items, prints message to user, then calls the new version of the same method
	    ColumnApi.prototype.columnGroupOpened = function (group, newValue) {
	        console.error('ag-Grid: columnGroupOpened no longer exists, use setColumnGroupOpened');
	        this.setColumnGroupOpened(group, newValue);
	    };
	    ColumnApi.prototype.hideColumns = function (colIds, hide) {
	        console.error('ag-Grid: hideColumns is deprecated, use setColumnsVisible');
	        this.columnController.setColumnsVisible(colIds, !hide, 'api');
	    };
	    ColumnApi.prototype.hideColumn = function (colId, hide) {
	        console.error('ag-Grid: hideColumn is deprecated, use setColumnVisible');
	        this.columnController.setColumnVisible(colId, !hide, 'api');
	    };
	    ColumnApi.prototype.setState = function (columnState) {
	        console.error('ag-Grid: setState is deprecated, use setColumnState');
	        return this.setColumnState(columnState);
	    };
	    ColumnApi.prototype.getState = function () {
	        console.error('ag-Grid: getState is deprecated, use getColumnState');
	        return this.getColumnState();
	    };
	    ColumnApi.prototype.resetState = function () {
	        console.error('ag-Grid: resetState is deprecated, use resetColumnState');
	        this.resetColumnState();
	    };
	    ColumnApi.prototype.getAggregationColumns = function () {
	        console.error('ag-Grid: getAggregationColumns is deprecated, use getValueColumns');
	        return this.columnController.getValueColumns();
	    };
	    ColumnApi.prototype.removeAggregationColumn = function (colKey) {
	        console.error('ag-Grid: removeAggregationColumn is deprecated, use removeValueColumn');
	        this.columnController.removeValueColumn(colKey, 'api');
	    };
	    ColumnApi.prototype.removeAggregationColumns = function (colKeys) {
	        console.error('ag-Grid: removeAggregationColumns is deprecated, use removeValueColumns');
	        this.columnController.removeValueColumns(colKeys, 'api');
	    };
	    ColumnApi.prototype.addAggregationColumn = function (colKey) {
	        console.error('ag-Grid: addAggregationColumn is deprecated, use addValueColumn');
	        this.columnController.addValueColumn(colKey, 'api');
	    };
	    ColumnApi.prototype.addAggregationColumns = function (colKeys) {
	        console.error('ag-Grid: addAggregationColumns is deprecated, use addValueColumns');
	        this.columnController.addValueColumns(colKeys, 'api');
	    };
	    ColumnApi.prototype.setColumnAggFunction = function (column, aggFunc) {
	        console.error('ag-Grid: setColumnAggFunction is deprecated, use setColumnAggFunc');
	        this.columnController.setColumnAggFunc(column, aggFunc, 'api');
	    };
	    ColumnApi.prototype.getDisplayNameForCol = function (column) {
	        console.error('ag-Grid: getDisplayNameForCol is deprecated, use getDisplayNameForColumn');
	        return this.getDisplayNameForColumn(column, null);
	    };
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], ColumnApi.prototype, "columnController", void 0);
	    ColumnApi = __decorate([
	        context_1.Bean('columnApi')
	    ], ColumnApi);
	    return ColumnApi;
	}());
	exports.ColumnApi = ColumnApi;


/***/ },
/* 39 */
/***/ function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function QuerySelector(selector) {
	    return querySelectorFunc.bind(this, selector);
	}
	exports.QuerySelector = QuerySelector;
	function RefSelector(ref) {
	    return querySelectorFunc.bind(this, "[ref=" + ref + "]");
	}
	exports.RefSelector = RefSelector;
	function querySelectorFunc(selector, classPrototype, methodOrAttributeName, index) {
	    if (selector === null) {
	        console.error("ag-Grid: QuerySelector selector should not be null");
	        return;
	    }
	    if (typeof index === "number") {
	        console.error("ag-Grid: QuerySelector should be on an attribute");
	        return;
	    }
	    addToObjectProps(classPrototype, 'querySelectors', {
	        attributeName: methodOrAttributeName,
	        querySelector: selector
	    });
	}
	// think we should take this out, put property bindings on the
	function Listener(eventName) {
	    return listenerFunc.bind(this, eventName);
	}
	exports.Listener = Listener;
	function listenerFunc(eventName, target, methodName) {
	    if (eventName === null) {
	        console.error("ag-Grid: EventListener eventName should not be null");
	        return;
	    }
	    addToObjectProps(target, 'listenerMethods', {
	        methodName: methodName,
	        eventName: eventName
	    });
	}
	// think we should take this out, put property bindings on the
	function Method(eventName) {
	    return methodFunc.bind(this, eventName);
	}
	exports.Method = Method;
	function methodFunc(alias, target, methodName) {
	    if (alias === null) {
	        console.error("ag-Grid: EventListener eventName should not be null");
	        return;
	    }
	    addToObjectProps(target, 'methods', {
	        methodName: methodName,
	        alias: alias
	    });
	}
	function addToObjectProps(target, key, value) {
	    // it's an attribute on the class
	    var props = getOrCreateProps(target, target.constructor.name);
	    if (!props[key]) {
	        props[key] = [];
	    }
	    props[key].push(value);
	}
	function getOrCreateProps(target, instanceName) {
	    if (!target.__agComponentMetaData) {
	        target.__agComponentMetaData = {};
	    }
	    if (!target.__agComponentMetaData[instanceName]) {
	        target.__agComponentMetaData[instanceName] = {};
	    }
	    return target.__agComponentMetaData[instanceName];
	}


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var textContain = __webpack_require__(79);
	
	var numberUtil = __webpack_require__(20);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// import Text from 'zrender/src/graphic/Text';
	
	/**
	 * add commas after every three numbers
	 * @param {string|number} x
	 * @return {string}
	 */
	function addCommas(x) {
	  if (isNaN(x)) {
	    return '-';
	  }
	
	  x = (x + '').split('.');
	  return x[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,') + (x.length > 1 ? '.' + x[1] : '');
	}
	/**
	 * @param {string} str
	 * @param {boolean} [upperCaseFirst=false]
	 * @return {string} str
	 */
	
	
	function toCamelCase(str, upperCaseFirst) {
	  str = (str || '').toLowerCase().replace(/-(.)/g, function (match, group1) {
	    return group1.toUpperCase();
	  });
	
	  if (upperCaseFirst && str) {
	    str = str.charAt(0).toUpperCase() + str.slice(1);
	  }
	
	  return str;
	}
	
	var normalizeCssArray = zrUtil.normalizeCssArray;
	var replaceReg = /([&<>"'])/g;
	var replaceMap = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;',
	  '\'': '&#39;'
	};
	
	function encodeHTML(source) {
	  return source == null ? '' : (source + '').replace(replaceReg, function (str, c) {
	    return replaceMap[c];
	  });
	}
	
	var TPL_VAR_ALIAS = ['a', 'b', 'c', 'd', 'e', 'f', 'g'];
	
	var wrapVar = function (varName, seriesIdx) {
	  return '{' + varName + (seriesIdx == null ? '' : seriesIdx) + '}';
	};
	/**
	 * Template formatter
	 * @param {string} tpl
	 * @param {Array.<Object>|Object} paramsList
	 * @param {boolean} [encode=false]
	 * @return {string}
	 */
	
	
	function formatTpl(tpl, paramsList, encode) {
	  if (!zrUtil.isArray(paramsList)) {
	    paramsList = [paramsList];
	  }
	
	  var seriesLen = paramsList.length;
	
	  if (!seriesLen) {
	    return '';
	  }
	
	  var $vars = paramsList[0].$vars || [];
	
	  for (var i = 0; i < $vars.length; i++) {
	    var alias = TPL_VAR_ALIAS[i];
	    tpl = tpl.replace(wrapVar(alias), wrapVar(alias, 0));
	  }
	
	  for (var seriesIdx = 0; seriesIdx < seriesLen; seriesIdx++) {
	    for (var k = 0; k < $vars.length; k++) {
	      var val = paramsList[seriesIdx][$vars[k]];
	      tpl = tpl.replace(wrapVar(TPL_VAR_ALIAS[k], seriesIdx), encode ? encodeHTML(val) : val);
	    }
	  }
	
	  return tpl;
	}
	/**
	 * simple Template formatter
	 *
	 * @param {string} tpl
	 * @param {Object} param
	 * @param {boolean} [encode=false]
	 * @return {string}
	 */
	
	
	function formatTplSimple(tpl, param, encode) {
	  zrUtil.each(param, function (value, key) {
	    tpl = tpl.replace('{' + key + '}', encode ? encodeHTML(value) : value);
	  });
	  return tpl;
	}
	/**
	 * @param {Object|string} [opt] If string, means color.
	 * @param {string} [opt.color]
	 * @param {string} [opt.extraCssText]
	 * @param {string} [opt.type='item'] 'item' or 'subItem'
	 * @param {string} [opt.renderMode='html'] render mode of tooltip, 'html' or 'richText'
	 * @param {string} [opt.markerId='X'] id name for marker. If only one marker is in a rich text, this can be omitted.
	 * @return {string}
	 */
	
	
	function getTooltipMarker(opt, extraCssText) {
	  opt = zrUtil.isString(opt) ? {
	    color: opt,
	    extraCssText: extraCssText
	  } : opt || {};
	  var color = opt.color;
	  var type = opt.type;
	  var extraCssText = opt.extraCssText;
	  var renderMode = opt.renderMode || 'html';
	  var markerId = opt.markerId || 'X';
	
	  if (!color) {
	    return '';
	  }
	
	  if (renderMode === 'html') {
	    return type === 'subItem' ? '<span style="display:inline-block;vertical-align:middle;margin-right:8px;margin-left:3px;' + 'border-radius:4px;width:4px;height:4px;background-color:' + encodeHTML(color) + ';' + (extraCssText || '') + '"></span>' : '<span style="display:inline-block;margin-right:5px;' + 'border-radius:10px;width:10px;height:10px;background-color:' + encodeHTML(color) + ';' + (extraCssText || '') + '"></span>';
	  } else {
	    // Space for rich element marker
	    return {
	      renderMode: renderMode,
	      content: '{marker' + markerId + '|}  ',
	      style: {
	        color: color
	      }
	    };
	  }
	}
	
	function pad(str, len) {
	  str += '';
	  return '0000'.substr(0, len - str.length) + str;
	}
	/**
	 * ISO Date format
	 * @param {string} tpl
	 * @param {number} value
	 * @param {boolean} [isUTC=false] Default in local time.
	 *           see `module:echarts/scale/Time`
	 *           and `module:echarts/util/number#parseDate`.
	 * @inner
	 */
	
	
	function formatTime(tpl, value, isUTC) {
	  if (tpl === 'week' || tpl === 'month' || tpl === 'quarter' || tpl === 'half-year' || tpl === 'year') {
	    tpl = 'MM-dd\nyyyy';
	  }
	
	  var date = numberUtil.parseDate(value);
	  var utc = isUTC ? 'UTC' : '';
	  var y = date['get' + utc + 'FullYear']();
	  var M = date['get' + utc + 'Month']() + 1;
	  var d = date['get' + utc + 'Date']();
	  var h = date['get' + utc + 'Hours']();
	  var m = date['get' + utc + 'Minutes']();
	  var s = date['get' + utc + 'Seconds']();
	  var S = date['get' + utc + 'Milliseconds']();
	  tpl = tpl.replace('MM', pad(M, 2)).replace('M', M).replace('yyyy', y).replace('yy', y % 100).replace('dd', pad(d, 2)).replace('d', d).replace('hh', pad(h, 2)).replace('h', h).replace('mm', pad(m, 2)).replace('m', m).replace('ss', pad(s, 2)).replace('s', s).replace('SSS', pad(S, 3));
	  return tpl;
	}
	/**
	 * Capital first
	 * @param {string} str
	 * @return {string}
	 */
	
	
	function capitalFirst(str) {
	  return str ? str.charAt(0).toUpperCase() + str.substr(1) : str;
	}
	
	var truncateText = textContain.truncateText;
	/**
	 * @public
	 * @param {Object} opt
	 * @param {string} opt.text
	 * @param {string} opt.font
	 * @param {string} [opt.textAlign='left']
	 * @param {string} [opt.textVerticalAlign='top']
	 * @param {Array.<number>} [opt.textPadding]
	 * @param {number} [opt.textLineHeight]
	 * @param {Object} [opt.rich]
	 * @param {Object} [opt.truncate]
	 * @return {Object} {x, y, width, height, lineHeight}
	 */
	
	function getTextBoundingRect(opt) {
	  return textContain.getBoundingRect(opt.text, opt.font, opt.textAlign, opt.textVerticalAlign, opt.textPadding, opt.textLineHeight, opt.rich, opt.truncate);
	}
	/**
	 * @deprecated
	 * the `textLineHeight` was added later.
	 * For backward compatiblility, put it as the last parameter.
	 * But deprecated this interface. Please use `getTextBoundingRect` instead.
	 */
	
	
	function getTextRect(text, font, textAlign, textVerticalAlign, textPadding, rich, truncate, textLineHeight) {
	  return textContain.getBoundingRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, rich, truncate);
	}
	/**
	 * open new tab
	 * @param {string} link url
	 * @param {string} target blank or self
	 */
	
	
	function windowOpen(link, target) {
	  if (target === '_blank' || target === 'blank') {
	    var blank = window.open();
	    blank.opener = null;
	    blank.location = link;
	  } else {
	    window.open(link, target);
	  }
	}
	
	exports.addCommas = addCommas;
	exports.toCamelCase = toCamelCase;
	exports.normalizeCssArray = normalizeCssArray;
	exports.encodeHTML = encodeHTML;
	exports.formatTpl = formatTpl;
	exports.formatTplSimple = formatTplSimple;
	exports.getTooltipMarker = getTooltipMarker;
	exports.formatTime = formatTime;
	exports.capitalFirst = capitalFirst;
	exports.truncateText = truncateText;
	exports.getTextBoundingRect = getTextBoundingRect;
	exports.getTextRect = getTextRect;
	exports.windowOpen = windowOpen;

/***/ },
/* 41 */
/***/ function(module, exports) {

	/* global Float32Array */
	var ArrayCtor = typeof Float32Array === 'undefined' ? Array : Float32Array;
	/**
	 * 创建一个向量
	 * @param {number} [x=0]
	 * @param {number} [y=0]
	 * @return {Vector2}
	 */
	
	function create(x, y) {
	  var out = new ArrayCtor(2);
	
	  if (x == null) {
	    x = 0;
	  }
	
	  if (y == null) {
	    y = 0;
	  }
	
	  out[0] = x;
	  out[1] = y;
	  return out;
	}
	/**
	 * 复制向量数据
	 * @param {Vector2} out
	 * @param {Vector2} v
	 * @return {Vector2}
	 */
	
	
	function copy(out, v) {
	  out[0] = v[0];
	  out[1] = v[1];
	  return out;
	}
	/**
	 * 克隆一个向量
	 * @param {Vector2} v
	 * @return {Vector2}
	 */
	
	
	function clone(v) {
	  var out = new ArrayCtor(2);
	  out[0] = v[0];
	  out[1] = v[1];
	  return out;
	}
	/**
	 * 设置向量的两个项
	 * @param {Vector2} out
	 * @param {number} a
	 * @param {number} b
	 * @return {Vector2} 结果
	 */
	
	
	function set(out, a, b) {
	  out[0] = a;
	  out[1] = b;
	  return out;
	}
	/**
	 * 向量相加
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 */
	
	
	function add(out, v1, v2) {
	  out[0] = v1[0] + v2[0];
	  out[1] = v1[1] + v2[1];
	  return out;
	}
	/**
	 * 向量缩放后相加
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 * @param {number} a
	 */
	
	
	function scaleAndAdd(out, v1, v2, a) {
	  out[0] = v1[0] + v2[0] * a;
	  out[1] = v1[1] + v2[1] * a;
	  return out;
	}
	/**
	 * 向量相减
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 */
	
	
	function sub(out, v1, v2) {
	  out[0] = v1[0] - v2[0];
	  out[1] = v1[1] - v2[1];
	  return out;
	}
	/**
	 * 向量长度
	 * @param {Vector2} v
	 * @return {number}
	 */
	
	
	function len(v) {
	  return Math.sqrt(lenSquare(v));
	}
	
	var length = len; // jshint ignore:line
	
	/**
	 * 向量长度平方
	 * @param {Vector2} v
	 * @return {number}
	 */
	
	function lenSquare(v) {
	  return v[0] * v[0] + v[1] * v[1];
	}
	
	var lengthSquare = lenSquare;
	/**
	 * 向量乘法
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 */
	
	function mul(out, v1, v2) {
	  out[0] = v1[0] * v2[0];
	  out[1] = v1[1] * v2[1];
	  return out;
	}
	/**
	 * 向量除法
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 */
	
	
	function div(out, v1, v2) {
	  out[0] = v1[0] / v2[0];
	  out[1] = v1[1] / v2[1];
	  return out;
	}
	/**
	 * 向量点乘
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 * @return {number}
	 */
	
	
	function dot(v1, v2) {
	  return v1[0] * v2[0] + v1[1] * v2[1];
	}
	/**
	 * 向量缩放
	 * @param {Vector2} out
	 * @param {Vector2} v
	 * @param {number} s
	 */
	
	
	function scale(out, v, s) {
	  out[0] = v[0] * s;
	  out[1] = v[1] * s;
	  return out;
	}
	/**
	 * 向量归一化
	 * @param {Vector2} out
	 * @param {Vector2} v
	 */
	
	
	function normalize(out, v) {
	  var d = len(v);
	
	  if (d === 0) {
	    out[0] = 0;
	    out[1] = 0;
	  } else {
	    out[0] = v[0] / d;
	    out[1] = v[1] / d;
	  }
	
	  return out;
	}
	/**
	 * 计算向量间距离
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 * @return {number}
	 */
	
	
	function distance(v1, v2) {
	  return Math.sqrt((v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]));
	}
	
	var dist = distance;
	/**
	 * 向量距离平方
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 * @return {number}
	 */
	
	function distanceSquare(v1, v2) {
	  return (v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]);
	}
	
	var distSquare = distanceSquare;
	/**
	 * 求负向量
	 * @param {Vector2} out
	 * @param {Vector2} v
	 */
	
	function negate(out, v) {
	  out[0] = -v[0];
	  out[1] = -v[1];
	  return out;
	}
	/**
	 * 插值两个点
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 * @param {number} t
	 */
	
	
	function lerp(out, v1, v2, t) {
	  out[0] = v1[0] + t * (v2[0] - v1[0]);
	  out[1] = v1[1] + t * (v2[1] - v1[1]);
	  return out;
	}
	/**
	 * 矩阵左乘向量
	 * @param {Vector2} out
	 * @param {Vector2} v
	 * @param {Vector2} m
	 */
	
	
	function applyTransform(out, v, m) {
	  var x = v[0];
	  var y = v[1];
	  out[0] = m[0] * x + m[2] * y + m[4];
	  out[1] = m[1] * x + m[3] * y + m[5];
	  return out;
	}
	/**
	 * 求两个向量最小值
	 * @param  {Vector2} out
	 * @param  {Vector2} v1
	 * @param  {Vector2} v2
	 */
	
	
	function min(out, v1, v2) {
	  out[0] = Math.min(v1[0], v2[0]);
	  out[1] = Math.min(v1[1], v2[1]);
	  return out;
	}
	/**
	 * 求两个向量最大值
	 * @param  {Vector2} out
	 * @param  {Vector2} v1
	 * @param  {Vector2} v2
	 */
	
	
	function max(out, v1, v2) {
	  out[0] = Math.max(v1[0], v2[0]);
	  out[1] = Math.max(v1[1], v2[1]);
	  return out;
	}
	
	exports.create = create;
	exports.copy = copy;
	exports.clone = clone;
	exports.set = set;
	exports.add = add;
	exports.scaleAndAdd = scaleAndAdd;
	exports.sub = sub;
	exports.len = len;
	exports.length = length;
	exports.lenSquare = lenSquare;
	exports.lengthSquare = lengthSquare;
	exports.mul = mul;
	exports.div = div;
	exports.dot = dot;
	exports.scale = scale;
	exports.normalize = normalize;
	exports.distance = distance;
	exports.dist = dist;
	exports.distanceSquare = distanceSquare;
	exports.distSquare = distSquare;
	exports.negate = negate;
	exports.lerp = lerp;
	exports.applyTransform = applyTransform;
	exports.min = min;
	exports.max = max;

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	var vec2 = __webpack_require__(41);
	
	var matrix = __webpack_require__(73);
	
	/**
	 * @module echarts/core/BoundingRect
	 */
	var v2ApplyTransform = vec2.applyTransform;
	var mathMin = Math.min;
	var mathMax = Math.max;
	/**
	 * @alias module:echarts/core/BoundingRect
	 */
	
	function BoundingRect(x, y, width, height) {
	  if (width < 0) {
	    x = x + width;
	    width = -width;
	  }
	
	  if (height < 0) {
	    y = y + height;
	    height = -height;
	  }
	  /**
	   * @type {number}
	   */
	
	
	  this.x = x;
	  /**
	   * @type {number}
	   */
	
	  this.y = y;
	  /**
	   * @type {number}
	   */
	
	  this.width = width;
	  /**
	   * @type {number}
	   */
	
	  this.height = height;
	}
	
	BoundingRect.prototype = {
	  constructor: BoundingRect,
	
	  /**
	   * @param {module:echarts/core/BoundingRect} other
	   */
	  union: function (other) {
	    var x = mathMin(other.x, this.x);
	    var y = mathMin(other.y, this.y);
	    this.width = mathMax(other.x + other.width, this.x + this.width) - x;
	    this.height = mathMax(other.y + other.height, this.y + this.height) - y;
	    this.x = x;
	    this.y = y;
	  },
	
	  /**
	   * @param {Array.<number>} m
	   * @methods
	   */
	  applyTransform: function () {
	    var lt = [];
	    var rb = [];
	    var lb = [];
	    var rt = [];
	    return function (m) {
	      // In case usage like this
	      // el.getBoundingRect().applyTransform(el.transform)
	      // And element has no transform
	      if (!m) {
	        return;
	      }
	
	      lt[0] = lb[0] = this.x;
	      lt[1] = rt[1] = this.y;
	      rb[0] = rt[0] = this.x + this.width;
	      rb[1] = lb[1] = this.y + this.height;
	      v2ApplyTransform(lt, lt, m);
	      v2ApplyTransform(rb, rb, m);
	      v2ApplyTransform(lb, lb, m);
	      v2ApplyTransform(rt, rt, m);
	      this.x = mathMin(lt[0], rb[0], lb[0], rt[0]);
	      this.y = mathMin(lt[1], rb[1], lb[1], rt[1]);
	      var maxX = mathMax(lt[0], rb[0], lb[0], rt[0]);
	      var maxY = mathMax(lt[1], rb[1], lb[1], rt[1]);
	      this.width = maxX - this.x;
	      this.height = maxY - this.y;
	    };
	  }(),
	
	  /**
	   * Calculate matrix of transforming from self to target rect
	   * @param  {module:zrender/core/BoundingRect} b
	   * @return {Array.<number>}
	   */
	  calculateTransform: function (b) {
	    var a = this;
	    var sx = b.width / a.width;
	    var sy = b.height / a.height;
	    var m = matrix.create(); // 矩阵右乘
	
	    matrix.translate(m, m, [-a.x, -a.y]);
	    matrix.scale(m, m, [sx, sy]);
	    matrix.translate(m, m, [b.x, b.y]);
	    return m;
	  },
	
	  /**
	   * @param {(module:echarts/core/BoundingRect|Object)} b
	   * @return {boolean}
	   */
	  intersect: function (b) {
	    if (!b) {
	      return false;
	    }
	
	    if (!(b instanceof BoundingRect)) {
	      // Normalize negative width/height.
	      b = BoundingRect.create(b);
	    }
	
	    var a = this;
	    var ax0 = a.x;
	    var ax1 = a.x + a.width;
	    var ay0 = a.y;
	    var ay1 = a.y + a.height;
	    var bx0 = b.x;
	    var bx1 = b.x + b.width;
	    var by0 = b.y;
	    var by1 = b.y + b.height;
	    return !(ax1 < bx0 || bx1 < ax0 || ay1 < by0 || by1 < ay0);
	  },
	  contain: function (x, y) {
	    var rect = this;
	    return x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height;
	  },
	
	  /**
	   * @return {module:echarts/core/BoundingRect}
	   */
	  clone: function () {
	    return new BoundingRect(this.x, this.y, this.width, this.height);
	  },
	
	  /**
	   * Copy from another rect
	   */
	  copy: function (other) {
	    this.x = other.x;
	    this.y = other.y;
	    this.width = other.width;
	    this.height = other.height;
	  },
	  plain: function () {
	    return {
	      x: this.x,
	      y: this.y,
	      width: this.width,
	      height: this.height
	    };
	  }
	};
	/**
	 * @param {Object|module:zrender/core/BoundingRect} rect
	 * @param {number} rect.x
	 * @param {number} rect.y
	 * @param {number} rect.width
	 * @param {number} rect.height
	 * @return {module:zrender/core/BoundingRect}
	 */
	
	BoundingRect.create = function (rect) {
	  return new BoundingRect(rect.x, rect.y, rect.width, rect.height);
	};
	
	var _default = BoundingRect;
	module.exports = _default;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;
	
	var _reducer = __webpack_require__(1001);
	
	Object.defineProperty(exports, 'LOCATION_CHANGE', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.LOCATION_CHANGE;
	  }
	});
	Object.defineProperty(exports, 'routerReducer', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.routerReducer;
	  }
	});
	
	var _actions = __webpack_require__(1000);
	
	Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
	  enumerable: true,
	  get: function get() {
	    return _actions.CALL_HISTORY_METHOD;
	  }
	});
	Object.defineProperty(exports, 'push', {
	  enumerable: true,
	  get: function get() {
	    return _actions.push;
	  }
	});
	Object.defineProperty(exports, 'replace', {
	  enumerable: true,
	  get: function get() {
	    return _actions.replace;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _actions.go;
	  }
	});
	Object.defineProperty(exports, 'goBack', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goBack;
	  }
	});
	Object.defineProperty(exports, 'goForward', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goForward;
	  }
	});
	Object.defineProperty(exports, 'routerActions', {
	  enumerable: true,
	  get: function get() {
	    return _actions.routerActions;
	  }
	});
	
	var _sync = __webpack_require__(2059);
	
	var _sync2 = _interopRequireDefault(_sync);
	
	var _middleware = __webpack_require__(2058);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.syncHistoryWithStore = _sync2['default'];
	exports.routerMiddleware = _middleware2['default'];

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var v1 = __webpack_require__(2268);
	var v4 = __webpack_require__(2269);
	
	var uuid = v4;
	uuid.v1 = v1;
	uuid.v4 = v4;
	
	module.exports = uuid;


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var eventService_1 = __webpack_require__(22);
	var utils_1 = __webpack_require__(10);
	var context_1 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var columnUtils_1 = __webpack_require__(195);
	var columnApi_1 = __webpack_require__(38);
	var gridApi_1 = __webpack_require__(33);
	// Wrapper around a user provide column definition. The grid treats the column definition as ready only.
	// This class contains all the runtime information about a column, plus some logic (the definition has no logic).
	// This class implements both interfaces ColumnGroupChild and OriginalColumnGroupChild as the class can
	// appear as a child of either the original tree or the displayed tree. However the relevant group classes
	// for each type only implements one, as each group can only appear in it's associated tree (eg OriginalColumnGroup
	// can only appear in OriginalColumn tree).
	var Column = /** @class */ (function () {
	    function Column(colDef, userProvidedColDef, colId, primary) {
	        this.moving = false;
	        this.menuVisible = false;
	        this.filterActive = false;
	        this.eventService = new eventService_1.EventService();
	        this.rowGroupActive = false;
	        this.pivotActive = false;
	        this.aggregationActive = false;
	        this.colDef = colDef;
	        this.userProvidedColDef = userProvidedColDef;
	        this.visible = !colDef.hide;
	        this.sort = colDef.sort;
	        this.sortedAt = colDef.sortedAt;
	        this.colId = colId;
	        this.primary = primary;
	    }
	    // gets called when user provides an alternative colDef, eg
	    Column.prototype.setColDef = function (colDef, userProvidedColDef) {
	        this.colDef = colDef;
	        this.userProvidedColDef = userProvidedColDef;
	    };
	    Column.prototype.getUserProvidedColDef = function () {
	        return this.userProvidedColDef;
	    };
	    Column.prototype.setParent = function (parent) {
	        this.parent = parent;
	    };
	    Column.prototype.getParent = function () {
	        return this.parent;
	    };
	    Column.prototype.setOriginalParent = function (originalParent) {
	        this.originalParent = originalParent;
	    };
	    Column.prototype.getOriginalParent = function () {
	        return this.originalParent;
	    };
	    // this is done after constructor as it uses gridOptionsWrapper
	    Column.prototype.initialise = function () {
	        this.setPinned(this.colDef.pinned);
	        var minColWidth = this.gridOptionsWrapper.getMinColWidth();
	        var maxColWidth = this.gridOptionsWrapper.getMaxColWidth();
	        if (this.colDef.minWidth) {
	            this.minWidth = this.colDef.minWidth;
	        }
	        else {
	            this.minWidth = minColWidth;
	        }
	        if (this.colDef.maxWidth) {
	            this.maxWidth = this.colDef.maxWidth;
	        }
	        else {
	            this.maxWidth = maxColWidth;
	        }
	        this.actualWidth = this.columnUtils.calculateColInitialWidth(this.colDef);
	        var suppressDotNotation = this.gridOptionsWrapper.isSuppressFieldDotNotation();
	        this.fieldContainsDots = utils_1._.exists(this.colDef.field) && this.colDef.field.indexOf('.') >= 0 && !suppressDotNotation;
	        this.tooltipFieldContainsDots = utils_1._.exists(this.colDef.tooltipField) && this.colDef.tooltipField.indexOf('.') >= 0 && !suppressDotNotation;
	        this.validate();
	    };
	    Column.prototype.isEmptyGroup = function () {
	        return false;
	    };
	    Column.prototype.isRowGroupDisplayed = function (colId) {
	        if (utils_1._.missing(this.colDef) || utils_1._.missing(this.colDef.showRowGroup)) {
	            return false;
	        }
	        var showingAllGroups = this.colDef.showRowGroup === true;
	        var showingThisGroup = this.colDef.showRowGroup === colId;
	        return showingAllGroups || showingThisGroup;
	    };
	    Column.prototype.getUniqueId = function () {
	        return this.getId();
	    };
	    Column.prototype.isPrimary = function () {
	        return this.primary;
	    };
	    Column.prototype.isFilterAllowed = function () {
	        // filter defined means it's a string, class or true.
	        // if its false, null or undefined then it's false.
	        var filterDefined = !!this.colDef.filter || !!this.colDef.filterFramework;
	        return this.primary && filterDefined;
	    };
	    Column.prototype.isFieldContainsDots = function () {
	        return this.fieldContainsDots;
	    };
	    Column.prototype.isTooltipFieldContainsDots = function () {
	        return this.tooltipFieldContainsDots;
	    };
	    Column.prototype.validate = function () {
	        var colDefAny = this.colDef;
	        if (!this.gridOptionsWrapper.isEnterprise()) {
	            var itemsNotAllowedWithoutEnterprise = ['enableRowGroup', 'rowGroup', 'rowGroupIndex', 'enablePivot', 'enableValue', 'pivot', 'pivotIndex', 'aggFunc', 'chartDataType'];
	            itemsNotAllowedWithoutEnterprise.forEach(function (item) {
	                if (utils_1._.exists(colDefAny[item])) {
	                    console.warn("ag-Grid: " + item + " is only valid in ag-Grid-Enterprise, your column definition should not have " + item);
	                }
	            });
	        }
	        if (this.gridOptionsWrapper.isTreeData()) {
	            var itemsNotAllowedWithTreeData = ['rowGroup', 'rowGroupIndex', 'pivot', 'pivotIndex'];
	            itemsNotAllowedWithTreeData.forEach(function (item) {
	                if (utils_1._.exists(colDefAny[item])) {
	                    console.warn("ag-Grid: " + item + " is not possible when doing tree data, your column definition should not have " + item);
	                }
	            });
	        }
	        if (utils_1._.exists(this.colDef.width) && typeof this.colDef.width !== 'number') {
	            console.warn('ag-Grid: colDef.width should be a number, not ' + typeof this.colDef.width);
	        }
	        if (utils_1._.get(this, 'colDef.cellRendererParams.restrictToOneGroup', null)) {
	            console.warn('ag-Grid: Since ag-grid 11.0.0 cellRendererParams.restrictToOneGroup is deprecated. You should use showRowGroup');
	        }
	        if (utils_1._.get(this, 'colDef.cellRendererParams.keyMap', null)) {
	            console.warn('ag-Grid: Since ag-grid 11.0.0 cellRendererParams.keyMap is deprecated. You should use colDef.keyCreator');
	        }
	        if (utils_1._.get(this, 'colDef.cellRendererParams.keyMap', null)) {
	            console.warn('ag-Grid: Since ag-grid 11.0.0 cellRendererParams.keyMap is deprecated. You should use colDef.keyCreator');
	        }
	        if (colDefAny.floatingCellRenderer) {
	            console.warn('ag-Grid: since v11, floatingCellRenderer is now pinnedRowCellRenderer');
	            this.colDef.pinnedRowCellRenderer = colDefAny.floatingCellRenderer;
	        }
	        if (colDefAny.floatingRendererFramework) {
	            console.warn('ag-Grid: since v11, floatingRendererFramework is now pinnedRowCellRendererFramework');
	            this.colDef.pinnedRowCellRendererFramework = colDefAny.floatingRendererFramework;
	        }
	        if (colDefAny.floatingRendererParams) {
	            console.warn('ag-Grid: since v11, floatingRendererParams is now pinnedRowCellRendererParams');
	            this.colDef.pinnedRowCellRendererParams = colDefAny.floatingRendererParams;
	        }
	        if (colDefAny.floatingValueFormatter) {
	            console.warn('ag-Grid: since v11, floatingValueFormatter is now pinnedRowValueFormatter');
	            this.colDef.pinnedRowValueFormatter = colDefAny.floatingValueFormatter;
	        }
	        if (colDefAny.cellFormatter) {
	            console.warn('ag-Grid: since v12, cellFormatter is now valueFormatter');
	            if (utils_1._.missing(this.colDef.valueFormatter)) {
	                this.colDef.valueFormatter = colDefAny.cellFormatter;
	            }
	        }
	        if (colDefAny.headerCellTemplate) {
	            console.warn('ag-Grid: since v15, headerCellTemplate is gone, use header component instead.');
	        }
	        if (colDefAny.headerCellRenderer) {
	            console.warn('ag-Grid: since v15, headerCellRenderer is gone, use header component instead.');
	        }
	        if (colDefAny.volatile) {
	            console.warn('ag-Grid: since v16, colDef.volatile is gone, please check refresh docs on how to refresh specific cells.');
	        }
	        if (colDefAny.suppressSorting) {
	            console.warn("ag-Grid: since v20, colDef.suppressSorting is gone, instead use colDef.sortable=false.", this.colDef);
	            this.colDef.sortable = false;
	        }
	        if (colDefAny.suppressFilter) {
	            console.warn("ag-Grid: since v20, colDef.suppressFilter is gone, instead use colDef.filter=false.", this.colDef);
	            this.colDef.filter = false;
	        }
	        if (colDefAny.suppressResize) {
	            console.warn("ag-Grid: since v20, colDef.suppressResize is gone, instead use colDef.resizable=false.", this.colDef);
	            this.colDef.resizable = false;
	        }
	        if (colDefAny.tooltip) {
	            console.warn("ag-Grid: since v20.1, colDef.tooltip is gone, instead use colDef.tooltipValueGetter.", this.colDef);
	            this.colDef.tooltipValueGetter = colDefAny.tooltip;
	        }
	    };
	    Column.prototype.addEventListener = function (eventType, listener) {
	        this.eventService.addEventListener(eventType, listener);
	    };
	    Column.prototype.removeEventListener = function (eventType, listener) {
	        this.eventService.removeEventListener(eventType, listener);
	    };
	    Column.prototype.createIsColumnFuncParams = function (rowNode) {
	        return {
	            node: rowNode,
	            data: rowNode.data,
	            column: this,
	            colDef: this.colDef,
	            context: this.gridOptionsWrapper.getContext(),
	            api: this.gridOptionsWrapper.getApi(),
	            columnApi: this.gridOptionsWrapper.getColumnApi()
	        };
	    };
	    Column.prototype.isSuppressNavigable = function (rowNode) {
	        // if boolean set, then just use it
	        if (typeof this.colDef.suppressNavigable === 'boolean') {
	            return this.colDef.suppressNavigable;
	        }
	        // if function, then call the function to find out
	        if (typeof this.colDef.suppressNavigable === 'function') {
	            var params = this.createIsColumnFuncParams(rowNode);
	            var userFunc = this.colDef.suppressNavigable;
	            return userFunc(params);
	        }
	        return false;
	    };
	    Column.prototype.isCellEditable = function (rowNode) {
	        // only allow editing of groups if the user has this option enabled
	        if (rowNode.group && !this.gridOptionsWrapper.isEnableGroupEdit()) {
	            return false;
	        }
	        return this.isColumnFunc(rowNode, this.colDef.editable);
	    };
	    Column.prototype.isRowDrag = function (rowNode) {
	        return this.isColumnFunc(rowNode, this.colDef.rowDrag);
	    };
	    Column.prototype.isDndSource = function (rowNode) {
	        return this.isColumnFunc(rowNode, this.colDef.dndSource);
	    };
	    Column.prototype.isCellCheckboxSelection = function (rowNode) {
	        return this.isColumnFunc(rowNode, this.colDef.checkboxSelection);
	    };
	    Column.prototype.isSuppressPaste = function (rowNode) {
	        return this.isColumnFunc(rowNode, this.colDef ? this.colDef.suppressPaste : null);
	    };
	    Column.prototype.isResizable = function () {
	        return this.colDef.resizable === true;
	    };
	    Column.prototype.isColumnFunc = function (rowNode, value) {
	        // if boolean set, then just use it
	        if (typeof value === 'boolean') {
	            return value;
	        }
	        // if function, then call the function to find out
	        if (typeof value === 'function') {
	            var params = this.createIsColumnFuncParams(rowNode);
	            var editableFunc = value;
	            return editableFunc(params);
	        }
	        return false;
	    };
	    Column.prototype.setMoving = function (moving, source) {
	        if (source === void 0) { source = "api"; }
	        this.moving = moving;
	        this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_MOVING_CHANGED, source));
	    };
	    Column.prototype.createColumnEvent = function (type, source) {
	        return {
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            type: type,
	            column: this,
	            columns: [this],
	            source: source
	        };
	    };
	    Column.prototype.isMoving = function () {
	        return this.moving;
	    };
	    Column.prototype.getSort = function () {
	        return this.sort;
	    };
	    Column.prototype.setSort = function (sort, source) {
	        if (source === void 0) { source = "api"; }
	        if (this.sort !== sort) {
	            this.sort = sort;
	            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_SORT_CHANGED, source));
	        }
	    };
	    Column.prototype.setMenuVisible = function (visible, source) {
	        if (source === void 0) { source = "api"; }
	        if (this.menuVisible !== visible) {
	            this.menuVisible = visible;
	            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_MENU_VISIBLE_CHANGED, source));
	        }
	    };
	    Column.prototype.isMenuVisible = function () {
	        return this.menuVisible;
	    };
	    Column.prototype.isSortAscending = function () {
	        return this.sort === Column.SORT_ASC;
	    };
	    Column.prototype.isSortDescending = function () {
	        return this.sort === Column.SORT_DESC;
	    };
	    Column.prototype.isSortNone = function () {
	        return utils_1._.missing(this.sort);
	    };
	    Column.prototype.isSorting = function () {
	        return utils_1._.exists(this.sort);
	    };
	    Column.prototype.getSortedAt = function () {
	        return this.sortedAt;
	    };
	    Column.prototype.setSortedAt = function (sortedAt) {
	        this.sortedAt = sortedAt;
	    };
	    Column.prototype.setAggFunc = function (aggFunc) {
	        this.aggFunc = aggFunc;
	    };
	    Column.prototype.getAggFunc = function () {
	        return this.aggFunc;
	    };
	    Column.prototype.getLeft = function () {
	        return this.left;
	    };
	    Column.prototype.getOldLeft = function () {
	        return this.oldLeft;
	    };
	    Column.prototype.getRight = function () {
	        return this.left + this.actualWidth;
	    };
	    Column.prototype.setLeft = function (left, source) {
	        if (source === void 0) { source = "api"; }
	        this.oldLeft = this.left;
	        if (this.left !== left) {
	            this.left = left;
	            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_LEFT_CHANGED, source));
	        }
	    };
	    Column.prototype.isFilterActive = function () {
	        return this.filterActive;
	    };
	    // additionalEventAttributes is used by provided simple floating filter, so it can add 'floatingFilter=true' to the event
	    Column.prototype.setFilterActive = function (active, source, additionalEventAttributes) {
	        if (source === void 0) { source = "api"; }
	        if (this.filterActive !== active) {
	            this.filterActive = active;
	            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_FILTER_ACTIVE_CHANGED, source));
	        }
	        var filterChangedEvent = this.createColumnEvent(Column.EVENT_FILTER_CHANGED, source);
	        if (additionalEventAttributes) {
	            utils_1._.mergeDeep(filterChangedEvent, additionalEventAttributes);
	        }
	        this.eventService.dispatchEvent(filterChangedEvent);
	    };
	    Column.prototype.setPinned = function (pinned) {
	        if (pinned === true || pinned === Column.PINNED_LEFT) {
	            this.pinned = Column.PINNED_LEFT;
	        }
	        else if (pinned === Column.PINNED_RIGHT) {
	            this.pinned = Column.PINNED_RIGHT;
	        }
	        else {
	            this.pinned = null;
	        }
	    };
	    Column.prototype.setFirstRightPinned = function (firstRightPinned, source) {
	        if (source === void 0) { source = "api"; }
	        if (this.firstRightPinned !== firstRightPinned) {
	            this.firstRightPinned = firstRightPinned;
	            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_FIRST_RIGHT_PINNED_CHANGED, source));
	        }
	    };
	    Column.prototype.setLastLeftPinned = function (lastLeftPinned, source) {
	        if (source === void 0) { source = "api"; }
	        if (this.lastLeftPinned !== lastLeftPinned) {
	            this.lastLeftPinned = lastLeftPinned;
	            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_LAST_LEFT_PINNED_CHANGED, source));
	        }
	    };
	    Column.prototype.isFirstRightPinned = function () {
	        return this.firstRightPinned;
	    };
	    Column.prototype.isLastLeftPinned = function () {
	        return this.lastLeftPinned;
	    };
	    Column.prototype.isPinned = function () {
	        return this.pinned === Column.PINNED_LEFT || this.pinned === Column.PINNED_RIGHT;
	    };
	    Column.prototype.isPinnedLeft = function () {
	        return this.pinned === Column.PINNED_LEFT;
	    };
	    Column.prototype.isPinnedRight = function () {
	        return this.pinned === Column.PINNED_RIGHT;
	    };
	    Column.prototype.getPinned = function () {
	        return this.pinned;
	    };
	    Column.prototype.setVisible = function (visible, source) {
	        if (source === void 0) { source = "api"; }
	        var newValue = visible === true;
	        if (this.visible !== newValue) {
	            this.visible = newValue;
	            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_VISIBLE_CHANGED, source));
	        }
	    };
	    Column.prototype.isVisible = function () {
	        return this.visible;
	    };
	    Column.prototype.getColDef = function () {
	        return this.colDef;
	    };
	    Column.prototype.getColumnGroupShow = function () {
	        return this.colDef.columnGroupShow;
	    };
	    Column.prototype.getColId = function () {
	        return this.colId;
	    };
	    Column.prototype.getId = function () {
	        return this.getColId();
	    };
	    Column.prototype.getDefinition = function () {
	        return this.colDef;
	    };
	    Column.prototype.getActualWidth = function () {
	        return this.actualWidth;
	    };
	    Column.prototype.createBaseColDefParams = function (rowNode) {
	        var params = {
	            node: rowNode,
	            data: rowNode.data,
	            colDef: this.colDef,
	            column: this,
	            api: this.gridOptionsWrapper.getApi(),
	            columnApi: this.gridOptionsWrapper.getColumnApi(),
	            context: this.gridOptionsWrapper.getContext()
	        };
	        return params;
	    };
	    Column.prototype.getColSpan = function (rowNode) {
	        if (utils_1._.missing(this.colDef.colSpan)) {
	            return 1;
	        }
	        var params = this.createBaseColDefParams(rowNode);
	        var colSpan = this.colDef.colSpan(params);
	        // colSpan must be number equal to or greater than 1
	        return Math.max(colSpan, 1);
	    };
	    Column.prototype.getRowSpan = function (rowNode) {
	        if (utils_1._.missing(this.colDef.rowSpan)) {
	            return 1;
	        }
	        var params = this.createBaseColDefParams(rowNode);
	        var rowSpan = this.colDef.rowSpan(params);
	        // rowSpan must be number equal to or greater than 1
	        return Math.max(rowSpan, 1);
	    };
	    Column.prototype.setActualWidth = function (actualWidth, source) {
	        if (source === void 0) { source = "api"; }
	        if (this.actualWidth !== actualWidth) {
	            this.actualWidth = actualWidth;
	            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_WIDTH_CHANGED, source));
	        }
	    };
	    Column.prototype.isGreaterThanMax = function (width) {
	        if (this.maxWidth) {
	            return width > this.maxWidth;
	        }
	        return false;
	    };
	    Column.prototype.getMinWidth = function () {
	        return this.minWidth;
	    };
	    Column.prototype.getMaxWidth = function () {
	        return this.maxWidth;
	    };
	    Column.prototype.setMinimum = function (source) {
	        if (source === void 0) { source = "api"; }
	        this.setActualWidth(this.minWidth, source);
	    };
	    Column.prototype.setRowGroupActive = function (rowGroup, source) {
	        if (source === void 0) { source = "api"; }
	        if (this.rowGroupActive !== rowGroup) {
	            this.rowGroupActive = rowGroup;
	            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_ROW_GROUP_CHANGED, source));
	        }
	    };
	    Column.prototype.isRowGroupActive = function () {
	        return this.rowGroupActive;
	    };
	    Column.prototype.setPivotActive = function (pivot, source) {
	        if (source === void 0) { source = "api"; }
	        if (this.pivotActive !== pivot) {
	            this.pivotActive = pivot;
	            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_PIVOT_CHANGED, source));
	        }
	    };
	    Column.prototype.isPivotActive = function () {
	        return this.pivotActive;
	    };
	    Column.prototype.isAnyFunctionActive = function () {
	        return this.isPivotActive() || this.isRowGroupActive() || this.isValueActive();
	    };
	    Column.prototype.isAnyFunctionAllowed = function () {
	        return this.isAllowPivot() || this.isAllowRowGroup() || this.isAllowValue();
	    };
	    Column.prototype.setValueActive = function (value, source) {
	        if (source === void 0) { source = "api"; }
	        if (this.aggregationActive !== value) {
	            this.aggregationActive = value;
	            this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_VALUE_CHANGED, source));
	        }
	    };
	    Column.prototype.isValueActive = function () {
	        return this.aggregationActive;
	    };
	    Column.prototype.isAllowPivot = function () {
	        return this.colDef.enablePivot === true;
	    };
	    Column.prototype.isAllowValue = function () {
	        return this.colDef.enableValue === true;
	    };
	    Column.prototype.isAllowRowGroup = function () {
	        return this.colDef.enableRowGroup === true;
	    };
	    Column.prototype.getMenuTabs = function (defaultValues) {
	        var menuTabs = this.getColDef().menuTabs;
	        if (menuTabs == null) {
	            menuTabs = defaultValues;
	        }
	        return menuTabs;
	    };
	    // this used to be needed, as previous version of ag-grid had lockPosition as column state,
	    // so couldn't depend on colDef version.
	    Column.prototype.isLockPosition = function () {
	        console.warn('ag-Grid: since v21, col.isLockPosition() should not be used, please use col.getColDef().lockPosition instead.');
	        return this.colDef ? !!this.colDef.lockPosition : false;
	    };
	    // this used to be needed, as previous version of ag-grid had lockVisible as column state,
	    // so couldn't depend on colDef version.
	    Column.prototype.isLockVisible = function () {
	        console.warn('ag-Grid: since v21, col.isLockVisible() should not be used, please use col.getColDef().lockVisible instead.');
	        return this.colDef ? !!this.colDef.lockVisible : false;
	    };
	    // this used to be needed, as previous version of ag-grid had lockPinned as column state,
	    // so couldn't depend on colDef version.
	    Column.prototype.isLockPinned = function () {
	        console.warn('ag-Grid: since v21, col.isLockPinned() should not be used, please use col.getColDef().lockPinned instead.');
	        return this.colDef ? !!this.colDef.lockPinned : false;
	    };
	    // + renderedHeaderCell - for making header cell transparent when moving
	    Column.EVENT_MOVING_CHANGED = 'movingChanged';
	    // + renderedCell - changing left position
	    Column.EVENT_LEFT_CHANGED = 'leftChanged';
	    // + renderedCell - changing width
	    Column.EVENT_WIDTH_CHANGED = 'widthChanged';
	    // + renderedCell - for changing pinned classes
	    Column.EVENT_LAST_LEFT_PINNED_CHANGED = 'lastLeftPinnedChanged';
	    Column.EVENT_FIRST_RIGHT_PINNED_CHANGED = 'firstRightPinnedChanged';
	    // + renderedColumn - for changing visibility icon
	    Column.EVENT_VISIBLE_CHANGED = 'visibleChanged';
	    // + every time the filter changes, used in the floating filters
	    Column.EVENT_FILTER_CHANGED = 'filterChanged';
	    // + renderedHeaderCell - marks the header with filter icon
	    Column.EVENT_FILTER_ACTIVE_CHANGED = 'filterActiveChanged';
	    // + renderedHeaderCell - marks the header with sort icon
	    Column.EVENT_SORT_CHANGED = 'sortChanged';
	    Column.EVENT_MENU_VISIBLE_CHANGED = 'menuVisibleChanged';
	    // + toolpanel, for gui updates
	    Column.EVENT_ROW_GROUP_CHANGED = 'columnRowGroupChanged';
	    // + toolpanel, for gui updates
	    Column.EVENT_PIVOT_CHANGED = 'columnPivotChanged';
	    // + toolpanel, for gui updates
	    Column.EVENT_VALUE_CHANGED = 'columnValueChanged';
	    Column.PINNED_RIGHT = 'right';
	    Column.PINNED_LEFT = 'left';
	    Column.SORT_ASC = 'asc';
	    Column.SORT_DESC = 'desc';
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], Column.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('columnUtils'),
	        __metadata("design:type", columnUtils_1.ColumnUtils)
	    ], Column.prototype, "columnUtils", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], Column.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], Column.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], Column.prototype, "initialise", null);
	    return Column;
	}());
	exports.Column = Column;


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	var Displayable = __webpack_require__(294);
	
	var zrUtil = __webpack_require__(3);
	
	var PathProxy = __webpack_require__(231);
	
	var pathContain = __webpack_require__(2280);
	
	var Pattern = __webpack_require__(1087);
	
	var getCanvasPattern = Pattern.prototype.getCanvasPattern;
	var abs = Math.abs;
	var pathProxyForDraw = new PathProxy(true);
	/**
	 * @alias module:zrender/graphic/Path
	 * @extends module:zrender/graphic/Displayable
	 * @constructor
	 * @param {Object} opts
	 */
	
	function Path(opts) {
	  Displayable.call(this, opts);
	  /**
	   * @type {module:zrender/core/PathProxy}
	   * @readOnly
	   */
	
	  this.path = null;
	}
	
	Path.prototype = {
	  constructor: Path,
	  type: 'path',
	  __dirtyPath: true,
	  strokeContainThreshold: 5,
	  // This item default to be false. But in map series in echarts,
	  // in order to improve performance, it should be set to true,
	  // so the shorty segment won't draw.
	  segmentIgnoreThreshold: 0,
	
	  /**
	   * See `module:zrender/src/graphic/helper/subPixelOptimize`.
	   * @type {boolean}
	   */
	  subPixelOptimize: false,
	  brush: function (ctx, prevEl) {
	    var style = this.style;
	    var path = this.path || pathProxyForDraw;
	    var hasStroke = style.hasStroke();
	    var hasFill = style.hasFill();
	    var fill = style.fill;
	    var stroke = style.stroke;
	    var hasFillGradient = hasFill && !!fill.colorStops;
	    var hasStrokeGradient = hasStroke && !!stroke.colorStops;
	    var hasFillPattern = hasFill && !!fill.image;
	    var hasStrokePattern = hasStroke && !!stroke.image;
	    style.bind(ctx, this, prevEl);
	    this.setTransform(ctx);
	
	    if (this.__dirty) {
	      var rect; // Update gradient because bounding rect may changed
	
	      if (hasFillGradient) {
	        rect = rect || this.getBoundingRect();
	        this._fillGradient = style.getGradient(ctx, fill, rect);
	      }
	
	      if (hasStrokeGradient) {
	        rect = rect || this.getBoundingRect();
	        this._strokeGradient = style.getGradient(ctx, stroke, rect);
	      }
	    } // Use the gradient or pattern
	
	
	    if (hasFillGradient) {
	      // PENDING If may have affect the state
	      ctx.fillStyle = this._fillGradient;
	    } else if (hasFillPattern) {
	      ctx.fillStyle = getCanvasPattern.call(fill, ctx);
	    }
	
	    if (hasStrokeGradient) {
	      ctx.strokeStyle = this._strokeGradient;
	    } else if (hasStrokePattern) {
	      ctx.strokeStyle = getCanvasPattern.call(stroke, ctx);
	    }
	
	    var lineDash = style.lineDash;
	    var lineDashOffset = style.lineDashOffset;
	    var ctxLineDash = !!ctx.setLineDash; // Update path sx, sy
	
	    var scale = this.getGlobalScale();
	    path.setScale(scale[0], scale[1], this.segmentIgnoreThreshold); // Proxy context
	    // Rebuild path in following 2 cases
	    // 1. Path is dirty
	    // 2. Path needs javascript implemented lineDash stroking.
	    //    In this case, lineDash information will not be saved in PathProxy
	
	    if (this.__dirtyPath || lineDash && !ctxLineDash && hasStroke) {
	      path.beginPath(ctx); // Setting line dash before build path
	
	      if (lineDash && !ctxLineDash) {
	        path.setLineDash(lineDash);
	        path.setLineDashOffset(lineDashOffset);
	      }
	
	      this.buildPath(path, this.shape, false); // Clear path dirty flag
	
	      if (this.path) {
	        this.__dirtyPath = false;
	      }
	    } else {
	      // Replay path building
	      ctx.beginPath();
	      this.path.rebuildPath(ctx);
	    }
	
	    if (hasFill) {
	      if (style.fillOpacity != null) {
	        var originalGlobalAlpha = ctx.globalAlpha;
	        ctx.globalAlpha = style.fillOpacity * style.opacity;
	        path.fill(ctx);
	        ctx.globalAlpha = originalGlobalAlpha;
	      } else {
	        path.fill(ctx);
	      }
	    }
	
	    if (lineDash && ctxLineDash) {
	      ctx.setLineDash(lineDash);
	      ctx.lineDashOffset = lineDashOffset;
	    }
	
	    if (hasStroke) {
	      if (style.strokeOpacity != null) {
	        var originalGlobalAlpha = ctx.globalAlpha;
	        ctx.globalAlpha = style.strokeOpacity * style.opacity;
	        path.stroke(ctx);
	        ctx.globalAlpha = originalGlobalAlpha;
	      } else {
	        path.stroke(ctx);
	      }
	    }
	
	    if (lineDash && ctxLineDash) {
	      // PENDING
	      // Remove lineDash
	      ctx.setLineDash([]);
	    } // Draw rect text
	
	
	    if (style.text != null) {
	      // Only restore transform when needs draw text.
	      this.restoreTransform(ctx);
	      this.drawRectText(ctx, this.getBoundingRect());
	    }
	  },
	  // When bundling path, some shape may decide if use moveTo to begin a new subpath or closePath
	  // Like in circle
	  buildPath: function (ctx, shapeCfg, inBundle) {},
	  createPathProxy: function () {
	    this.path = new PathProxy();
	  },
	  getBoundingRect: function () {
	    var rect = this._rect;
	    var style = this.style;
	    var needsUpdateRect = !rect;
	
	    if (needsUpdateRect) {
	      var path = this.path;
	
	      if (!path) {
	        // Create path on demand.
	        path = this.path = new PathProxy();
	      }
	
	      if (this.__dirtyPath) {
	        path.beginPath();
	        this.buildPath(path, this.shape, false);
	      }
	
	      rect = path.getBoundingRect();
	    }
	
	    this._rect = rect;
	
	    if (style.hasStroke()) {
	      // Needs update rect with stroke lineWidth when
	      // 1. Element changes scale or lineWidth
	      // 2. Shape is changed
	      var rectWithStroke = this._rectWithStroke || (this._rectWithStroke = rect.clone());
	
	      if (this.__dirty || needsUpdateRect) {
	        rectWithStroke.copy(rect); // FIXME Must after updateTransform
	
	        var w = style.lineWidth; // PENDING, Min line width is needed when line is horizontal or vertical
	
	        var lineScale = style.strokeNoScale ? this.getLineScale() : 1; // Only add extra hover lineWidth when there are no fill
	
	        if (!style.hasFill()) {
	          w = Math.max(w, this.strokeContainThreshold || 4);
	        } // Consider line width
	        // Line scale can't be 0;
	
	
	        if (lineScale > 1e-10) {
	          rectWithStroke.width += w / lineScale;
	          rectWithStroke.height += w / lineScale;
	          rectWithStroke.x -= w / lineScale / 2;
	          rectWithStroke.y -= w / lineScale / 2;
	        }
	      } // Return rect with stroke
	
	
	      return rectWithStroke;
	    }
	
	    return rect;
	  },
	  contain: function (x, y) {
	    var localPos = this.transformCoordToLocal(x, y);
	    var rect = this.getBoundingRect();
	    var style = this.style;
	    x = localPos[0];
	    y = localPos[1];
	
	    if (rect.contain(x, y)) {
	      var pathData = this.path.data;
	
	      if (style.hasStroke()) {
	        var lineWidth = style.lineWidth;
	        var lineScale = style.strokeNoScale ? this.getLineScale() : 1; // Line scale can't be 0;
	
	        if (lineScale > 1e-10) {
	          // Only add extra hover lineWidth when there are no fill
	          if (!style.hasFill()) {
	            lineWidth = Math.max(lineWidth, this.strokeContainThreshold);
	          }
	
	          if (pathContain.containStroke(pathData, lineWidth / lineScale, x, y)) {
	            return true;
	          }
	        }
	      }
	
	      if (style.hasFill()) {
	        return pathContain.contain(pathData, x, y);
	      }
	    }
	
	    return false;
	  },
	
	  /**
	   * @param  {boolean} dirtyPath
	   */
	  dirty: function (dirtyPath) {
	    if (dirtyPath == null) {
	      dirtyPath = true;
	    } // Only mark dirty, not mark clean
	
	
	    if (dirtyPath) {
	      this.__dirtyPath = dirtyPath;
	      this._rect = null;
	    }
	
	    this.__dirty = this.__dirtyText = true;
	    this.__zr && this.__zr.refresh(); // Used as a clipping path
	
	    if (this.__clipTarget) {
	      this.__clipTarget.dirty();
	    }
	  },
	
	  /**
	   * Alias for animate('shape')
	   * @param {boolean} loop
	   */
	  animateShape: function (loop) {
	    return this.animate('shape', loop);
	  },
	  // Overwrite attrKV
	  attrKV: function (key, value) {
	    // FIXME
	    if (key === 'shape') {
	      this.setShape(value);
	      this.__dirtyPath = true;
	      this._rect = null;
	    } else {
	      Displayable.prototype.attrKV.call(this, key, value);
	    }
	  },
	
	  /**
	   * @param {Object|string} key
	   * @param {*} value
	   */
	  setShape: function (key, value) {
	    var shape = this.shape; // Path from string may not have shape
	
	    if (shape) {
	      if (zrUtil.isObject(key)) {
	        for (var name in key) {
	          if (key.hasOwnProperty(name)) {
	            shape[name] = key[name];
	          }
	        }
	      } else {
	        shape[key] = value;
	      }
	
	      this.dirty(true);
	    }
	
	    return this;
	  },
	  getLineScale: function () {
	    var m = this.transform; // Get the line scale.
	    // Determinant of `m` means how much the area is enlarged by the
	    // transformation. So its square root can be used as a scale factor
	    // for width.
	
	    return m && abs(m[0] - 1) > 1e-10 && abs(m[3] - 1) > 1e-10 ? Math.sqrt(abs(m[0] * m[3] - m[2] * m[1])) : 1;
	  }
	};
	/**
	 * 扩展一个 Path element, 比如星形，圆等。
	 * Extend a path element
	 * @param {Object} props
	 * @param {string} props.type Path type
	 * @param {Function} props.init Initialize
	 * @param {Function} props.buildPath Overwrite buildPath method
	 * @param {Object} [props.style] Extended default style config
	 * @param {Object} [props.shape] Extended default shape config
	 */
	
	Path.extend = function (defaults) {
	  var Sub = function (opts) {
	    Path.call(this, opts);
	
	    if (defaults.style) {
	      // Extend default style
	      this.style.extendFrom(defaults.style, false);
	    } // Extend default shape
	
	
	    var defaultShape = defaults.shape;
	
	    if (defaultShape) {
	      this.shape = this.shape || {};
	      var thisShape = this.shape;
	
	      for (var name in defaultShape) {
	        if (!thisShape.hasOwnProperty(name) && defaultShape.hasOwnProperty(name)) {
	          thisShape[name] = defaultShape[name];
	        }
	      }
	    }
	
	    defaults.init && defaults.init.call(this, opts);
	  };
	
	  zrUtil.inherits(Sub, Path); // FIXME 不能 extend position, rotation 等引用对象
	
	  for (var name in defaults) {
	    // Extending prototype values and methods
	    if (name !== 'style' && name !== 'shape') {
	      Sub.prototype[name] = defaults[name];
	    }
	  }
	
	  return Sub;
	};
	
	zrUtil.inherits(Path, Displayable);
	var _default = Path;
	module.exports = _default;

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useForkRef;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _setRef = _interopRequireDefault(__webpack_require__(157));
	
	function useForkRef(refA, refB) {
	  /**
	   * This will create a new function if the ref props change and are defined.
	   * This means react will call the old forkRef with `null` and the new forkRef
	   * with the ref. Cleanup naturally emerges from this behavior
	   */
	  return React.useMemo(function () {
	    if (refA == null && refB == null) {
	      return null;
	    }
	
	    return function (refValue) {
	      (0, _setRef.default)(refA, refValue);
	      (0, _setRef.default)(refB, refValue);
	    };
	  }, [refA, refB]);
	}

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var env = __webpack_require__(55);
	
	var _model = __webpack_require__(24);
	
	var makeInner = _model.makeInner;
	
	var _clazz = __webpack_require__(124);
	
	var enableClassExtend = _clazz.enableClassExtend;
	var enableClassCheck = _clazz.enableClassCheck;
	
	var lineStyleMixin = __webpack_require__(1697);
	
	var areaStyleMixin = __webpack_require__(1694);
	
	var textStyleMixin = __webpack_require__(1698);
	
	var itemStyleMixin = __webpack_require__(1696);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/model/Model
	 */
	var mixin = zrUtil.mixin;
	var inner = makeInner();
	/**
	 * @alias module:echarts/model/Model
	 * @constructor
	 * @param {Object} [option]
	 * @param {module:echarts/model/Model} [parentModel]
	 * @param {module:echarts/model/Global} [ecModel]
	 */
	
	function Model(option, parentModel, ecModel) {
	  /**
	   * @type {module:echarts/model/Model}
	   * @readOnly
	   */
	  this.parentModel = parentModel;
	  /**
	   * @type {module:echarts/model/Global}
	   * @readOnly
	   */
	
	  this.ecModel = ecModel;
	  /**
	   * @type {Object}
	   * @protected
	   */
	
	  this.option = option; // Simple optimization
	  // if (this.init) {
	  //     if (arguments.length <= 4) {
	  //         this.init(option, parentModel, ecModel, extraOpt);
	  //     }
	  //     else {
	  //         this.init.apply(this, arguments);
	  //     }
	  // }
	}
	
	Model.prototype = {
	  constructor: Model,
	
	  /**
	   * Model 的初始化函数
	   * @param {Object} option
	   */
	  init: null,
	
	  /**
	   * 从新的 Option merge
	   */
	  mergeOption: function (option) {
	    zrUtil.merge(this.option, option, true);
	  },
	
	  /**
	   * @param {string|Array.<string>} path
	   * @param {boolean} [ignoreParent=false]
	   * @return {*}
	   */
	  get: function (path, ignoreParent) {
	    if (path == null) {
	      return this.option;
	    }
	
	    return doGet(this.option, this.parsePath(path), !ignoreParent && getParent(this, path));
	  },
	
	  /**
	   * @param {string} key
	   * @param {boolean} [ignoreParent=false]
	   * @return {*}
	   */
	  getShallow: function (key, ignoreParent) {
	    var option = this.option;
	    var val = option == null ? option : option[key];
	    var parentModel = !ignoreParent && getParent(this, key);
	
	    if (val == null && parentModel) {
	      val = parentModel.getShallow(key);
	    }
	
	    return val;
	  },
	
	  /**
	   * @param {string|Array.<string>} [path]
	   * @param {module:echarts/model/Model} [parentModel]
	   * @return {module:echarts/model/Model}
	   */
	  getModel: function (path, parentModel) {
	    var obj = path == null ? this.option : doGet(this.option, path = this.parsePath(path));
	    var thisParentModel;
	    parentModel = parentModel || (thisParentModel = getParent(this, path)) && thisParentModel.getModel(path);
	    return new Model(obj, parentModel, this.ecModel);
	  },
	
	  /**
	   * If model has option
	   */
	  isEmpty: function () {
	    return this.option == null;
	  },
	  restoreData: function () {},
	  // Pending
	  clone: function () {
	    var Ctor = this.constructor;
	    return new Ctor(zrUtil.clone(this.option));
	  },
	  setReadOnly: function (properties) {// clazzUtil.setReadOnly(this, properties);
	  },
	  // If path is null/undefined, return null/undefined.
	  parsePath: function (path) {
	    if (typeof path === 'string') {
	      path = path.split('.');
	    }
	
	    return path;
	  },
	
	  /**
	   * @param {Function} getParentMethod
	   *        param {Array.<string>|string} path
	   *        return {module:echarts/model/Model}
	   */
	  customizeGetParent: function (getParentMethod) {
	    inner(this).getParent = getParentMethod;
	  },
	  isAnimationEnabled: function () {
	    if (!env.node) {
	      if (this.option.animation != null) {
	        return !!this.option.animation;
	      } else if (this.parentModel) {
	        return this.parentModel.isAnimationEnabled();
	      }
	    }
	  }
	};
	
	function doGet(obj, pathArr, parentModel) {
	  for (var i = 0; i < pathArr.length; i++) {
	    // Ignore empty
	    if (!pathArr[i]) {
	      continue;
	    } // obj could be number/string/... (like 0)
	
	
	    obj = obj && typeof obj === 'object' ? obj[pathArr[i]] : null;
	
	    if (obj == null) {
	      break;
	    }
	  }
	
	  if (obj == null && parentModel) {
	    obj = parentModel.get(pathArr);
	  }
	
	  return obj;
	} // `path` can be null/undefined
	
	
	function getParent(model, path) {
	  var getParentMethod = inner(model).getParent;
	  return getParentMethod ? getParentMethod.call(model, path) : model.parentModel;
	} // Enable Model.extend.
	
	
	enableClassExtend(Model);
	enableClassCheck(Model);
	mixin(Model, lineStyleMixin);
	mixin(Model, areaStyleMixin);
	mixin(Model, textStyleMixin);
	mixin(Model, itemStyleMixin);
	var _default = Model;
	module.exports = _default;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.WMS = exports.StationPoint = exports.SitesPoint = exports.SingleStationPoint = exports.OSM = exports.KML = exports.Custom = exports.MapStyles = exports.PopupFactory = exports.Map = exports.Textarea = exports.Autocomplete = exports.DatePicker = exports.IChart = exports.TimeStackedBar = exports.Timeserie = exports.TimeBar = exports.StackedBar = exports.Plot = exports.Pie = exports.Line = exports.HorizontalStackedBar = exports.HorizontalBar = exports.BoxPlot = exports.Bar = exports.Area = exports.Input = exports.Table = exports.ToastrReducer = exports.ToastrAction = exports.Toastr = exports.WaitReducer = exports.WaitAction = exports.Wait = exports.Checkbox = exports.Select = undefined;
	
		var _Select = __webpack_require__(1);
	
		var _Select2 = _interopRequireDefault(_Select);
	
		var _Input = __webpack_require__(4);
	
		var _Input2 = _interopRequireDefault(_Input);
	
		var _Checkbox = __webpack_require__(6);
	
		var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
		var _Wait = __webpack_require__(7);
	
		var _Wait2 = _interopRequireDefault(_Wait);
	
		var _WaitAction = __webpack_require__(10);
	
		var _WaitAction2 = _interopRequireDefault(_WaitAction);
	
		var _WaitReducer = __webpack_require__(12);
	
		var _WaitReducer2 = _interopRequireDefault(_WaitReducer);
	
		var _Toastr = __webpack_require__(13);
	
		var _Toastr2 = _interopRequireDefault(_Toastr);
	
		var _ToastrAction = __webpack_require__(14);
	
		var _ToastrAction2 = _interopRequireDefault(_ToastrAction);
	
		var _ToastrReducer = __webpack_require__(17);
	
		var _ToastrReducer2 = _interopRequireDefault(_ToastrReducer);
	
		var _Table = __webpack_require__(18);
	
		var _Table2 = _interopRequireDefault(_Table);
	
		var _Area = __webpack_require__(35);
	
		var _Area2 = _interopRequireDefault(_Area);
	
		var _Bar = __webpack_require__(45);
	
		var _Bar2 = _interopRequireDefault(_Bar);
	
		var _HorizontalBar = __webpack_require__(49);
	
		var _HorizontalBar2 = _interopRequireDefault(_HorizontalBar);
	
		var _Pie = __webpack_require__(51);
	
		var _Pie2 = _interopRequireDefault(_Pie);
	
		var _TimeBar = __webpack_require__(53);
	
		var _TimeBar2 = _interopRequireDefault(_TimeBar);
	
		var _Timeserie = __webpack_require__(42);
	
		var _Timeserie2 = _interopRequireDefault(_Timeserie);
	
		var _Line = __webpack_require__(55);
	
		var _Line2 = _interopRequireDefault(_Line);
	
		var _Plot = __webpack_require__(57);
	
		var _Plot2 = _interopRequireDefault(_Plot);
	
		var _StackedBar = __webpack_require__(59);
	
		var _StackedBar2 = _interopRequireDefault(_StackedBar);
	
		var _HorizontalStackedBar = __webpack_require__(61);
	
		var _HorizontalStackedBar2 = _interopRequireDefault(_HorizontalStackedBar);
	
		var _TimeStackedBar = __webpack_require__(63);
	
		var _TimeStackedBar2 = _interopRequireDefault(_TimeStackedBar);
	
		var _BoxPlot = __webpack_require__(65);
	
		var _BoxPlot2 = _interopRequireDefault(_BoxPlot);
	
		var _IChart = __webpack_require__(68);
	
		var _IChart2 = _interopRequireDefault(_IChart);
	
		var _DatePicker = __webpack_require__(74);
	
		var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
		var _Autocomplete = __webpack_require__(77);
	
		var _Autocomplete2 = _interopRequireDefault(_Autocomplete);
	
		var _Textarea = __webpack_require__(78);
	
		var _Textarea2 = _interopRequireDefault(_Textarea);
	
		var _Map = __webpack_require__(79);
	
		var _Map2 = _interopRequireDefault(_Map);
	
		var _PopupFactory = __webpack_require__(83);
	
		var _PopupFactory2 = _interopRequireDefault(_PopupFactory);
	
		var _MapStyles = __webpack_require__(84);
	
		var _MapStyles2 = _interopRequireDefault(_MapStyles);
	
		var _Custom = __webpack_require__(85);
	
		var _Custom2 = _interopRequireDefault(_Custom);
	
		var _KML = __webpack_require__(88);
	
		var _KML2 = _interopRequireDefault(_KML);
	
		var _OSM = __webpack_require__(90);
	
		var _OSM2 = _interopRequireDefault(_OSM);
	
		var _SingleStationPoint = __webpack_require__(91);
	
		var _SingleStationPoint2 = _interopRequireDefault(_SingleStationPoint);
	
		var _SitesPoint = __webpack_require__(92);
	
		var _SitesPoint2 = _interopRequireDefault(_SitesPoint);
	
		var _StationPoint = __webpack_require__(95);
	
		var _StationPoint2 = _interopRequireDefault(_StationPoint);
	
		var _WMS = __webpack_require__(96);
	
		var _WMS2 = _interopRequireDefault(_WMS);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.Select = _Select2.default;
		exports.Checkbox = _Checkbox2.default;
		exports.Wait = _Wait2.default;
		exports.WaitAction = _WaitAction2.default;
		exports.WaitReducer = _WaitReducer2.default;
		exports.Toastr = _Toastr2.default;
		exports.ToastrAction = _ToastrAction2.default;
		exports.ToastrReducer = _ToastrReducer2.default;
		exports.Table = _Table2.default;
		exports.Input = _Input2.default;
		exports.Area = _Area2.default;
		exports.Bar = _Bar2.default;
		exports.BoxPlot = _BoxPlot2.default;
		exports.HorizontalBar = _HorizontalBar2.default;
		exports.HorizontalStackedBar = _HorizontalStackedBar2.default;
		exports.Line = _Line2.default;
		exports.Pie = _Pie2.default;
		exports.Plot = _Plot2.default;
		exports.StackedBar = _StackedBar2.default;
		exports.TimeBar = _TimeBar2.default;
		exports.Timeserie = _Timeserie2.default;
		exports.TimeStackedBar = _TimeStackedBar2.default;
		exports.IChart = _IChart2.default;
		exports.DatePicker = _DatePicker2.default;
		exports.Autocomplete = _Autocomplete2.default;
		exports.Textarea = _Textarea2.default;
		exports.Map = _Map2.default;
		exports.PopupFactory = _PopupFactory2.default;
		exports.MapStyles = _MapStyles2.default;
		exports.Custom = _Custom2.default;
		exports.KML = _KML2.default;
		exports.OSM = _OSM2.default;
		exports.SingleStationPoint = _SingleStationPoint2.default;
		exports.SitesPoint = _SitesPoint2.default;
		exports.StationPoint = _StationPoint2.default;
		exports.WMS = _WMS2.default;
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _propTypes = __webpack_require__(3);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var Select = function (_Component) {
		    _inherits(Select, _Component);
	
		    function Select(props) {
		        _classCallCheck(this, Select);
	
		        var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));
	
		        _this.init = function () {
		            $('select').material_select();
		        };
	
		        _this.getDefaultValue = function () {
		            var defaultValue = _this.props.elements.find(function (el) {
		                return el.selected;
		            });
		            if (defaultValue) {
		                return defaultValue.value;
		            }
		            return null;
		        };
	
		        return _this;
		    }
	
		    _createClass(Select, [{
		        key: 'componentDidMount',
		        value: function componentDidMount() {
		            var _this2 = this;
	
		            this.init();
		            $(this.selectRef).on('change', function () {
		                return _this2.props.onChange(_this2.selectRef.value);
		            });
		        }
		    }, {
		        key: 'componentDidUpdate',
		        value: function componentDidUpdate() {
		            this.init();
		        }
		    }, {
		        key: 'render',
		        value: function render() {
		            var _this3 = this;
	
		            var options = this.props.elements.map(function (el) {
		                var optionProps = {};
		                if (el.value == _this3.props.selected) {
		                    optionProps.selected = true;
		                }
		                if (el.disabled) {
		                    optionProps.disabled = 'disabled';
		                }
		                return _react2.default.createElement(
		                    'option',
		                    _extends({ value: el.value }, optionProps),
		                    el.label
		                );
		            });
	
		            var className = 'input-field no-margin-top ' + (this.props.className || '');
	
		            return _react2.default.createElement(
		                'div',
		                { className: className },
		                _react2.default.createElement(
		                    'select',
		                    { ref: function ref(_ref) {
		                            return _this3.selectRef = _ref;
		                        } },
		                    options
		                ),
		                _react2.default.createElement(
		                    'label',
		                    null,
		                    this.props.label
		                )
		            );
		        }
		    }]);
	
		    return Select;
		}(_react.Component);
	
		Select.propTypes = {
		    elements: _propTypes2.default.arrayOf(_propTypes2.default.shape({
		        value: _propTypes2.default.string,
		        label: _propTypes2.default.string
		    })).isRequired,
		    className: _propTypes2.default.string,
		    onChange: _propTypes2.default.func.isRequired,
		    selected: _propTypes2.default.any,
		    label: _propTypes2.default.string
		};
	
		Select.defaultProps = {
		    label: ''
		};
	
		exports.default = Select;
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(60);
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(4);
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _propTypes = __webpack_require__(3);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		var _uuid = __webpack_require__(5);
	
		var _uuid2 = _interopRequireDefault(_uuid);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var Materialize = window.Materialize;
	
		var Input = function (_Component) {
		    _inherits(Input, _Component);
	
		    function Input(props) {
		        _classCallCheck(this, Input);
	
		        var _this = _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));
	
		        _this.updateTextFields = function () {
		            if (Materialize.updateTextFields) {
		                Materialize.updateTextFields();
		            }
		        };
	
		        _this.changeValue = function (e) {
		            _this.setState({ value: e.target.value });
		        };
	
		        _this.getLabel = function () {
		            return _react2.default.createElement(
		                'label',
		                { htmlFor: _this.state.selectId },
		                _this.props.label
		            );
		        };
	
		        _this.getValue = function () {
		            return _this.inputRef.value;
		        };
	
		        _this.state = {
		            selectId: _uuid2.default.v4(),
		            value: ''
		        };
		        return _this;
		    }
	
		    _createClass(Input, [{
		        key: 'componentWillMount',
		        value: function componentWillMount() {
		            this.setState({ value: this.props.value });
		        }
		    }, {
		        key: 'componentDidMount',
		        value: function componentDidMount() {
		            this.updateTextFields();
		        }
		    }, {
		        key: 'componentWillReceiveProps',
		        value: function componentWillReceiveProps(nextProps) {
		            this.setState({ value: nextProps.value });
		        }
		    }, {
		        key: 'componentDidUpdate',
		        value: function componentDidUpdate() {
		            this.updateTextFields();
		        }
		    }, {
		        key: 'render',
		        value: function render() {
		            var _this2 = this;
	
		            var className = 'input-field ' + (this.props.className || '');
	
		            return _react2.default.createElement(
		                'div',
		                { className: className },
		                _react2.default.createElement('input', { placeholder: this.props.placeholder, ref: function ref(_ref) {
		                        return _this2.inputRef = _ref;
		                    }, id: this.state.selectId, value: this.state.value, onChange: this.changeValue,
		                    type: this.props.type,
		                    className: 'validate' }),
		                this.getLabel()
		            );
		        }
		    }]);
	
		    return Input;
		}(_react.Component);
	
		Input.propTypes = {
		    type: _propTypes2.default.string.isRequired,
		    className: _propTypes2.default.string,
		    selectId: _propTypes2.default.string,
		    placeholder: _propTypes2.default.string,
		    label: _propTypes2.default.string,
		    value: _propTypes2.default.string
		};
	
		Input.defaultProps = {
		    reference: '',
		    value: ''
		};
	
		exports.default = Input;
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(44);
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _propTypes = __webpack_require__(3);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		var _uuid = __webpack_require__(5);
	
		var _uuid2 = _interopRequireDefault(_uuid);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var Checkbox = function (_Component) {
		    _inherits(Checkbox, _Component);
	
		    function Checkbox(props) {
		        _classCallCheck(this, Checkbox);
	
		        var _this = _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call(this, props));
	
		        _this.getLabel = function () {
		            return _react2.default.createElement(
		                'label',
		                { htmlFor: _this.state.selectId },
		                _this.props.label
		            );
		        };
	
		        _this.getValue = function () {
		            return _this.state.checked;
		        };
	
		        _this.check = function () {
		            var checked = !_this.state.checked;
		            _this.setState({ checked: checked });
		            if (_this.props.onChange) {
		                _this.props.onChange(checked);
		            }
		        };
	
		        _this.getClassName = function () {
		            if (_this.props.condensed) {
		                return _this.props.condensed ? 'no-margin validate ' + (_this.props.className || '') : 'validate ' + (_this.props.className || '');
		            }
		            return 'validate';
		        };
	
		        _this.getInput = function () {
		            var inputClassName = _this.getClassName();
		            if (_this.props.disabled) {
		                return _react2.default.createElement('input', { placeholder: _this.props.placeholder, id: _this.state.selectId,
		                    type: 'checkbox', checked: _this.state.checked,
		                    className: inputClassName, onClick: _this.check, disabled: true });
		            }
		            return _react2.default.createElement('input', { placeholder: _this.props.placeholder, id: _this.state.selectId,
		                type: 'checkbox', checked: _this.state.checked,
		                className: inputClassName, onClick: _this.check });
		        };
	
		        _this.state = {
		            selectId: _uuid2.default.v4(),
		            checked: false
		        };
		        return _this;
		    }
	
		    _createClass(Checkbox, [{
		        key: 'componentWillMount',
		        value: function componentWillMount() {
		            this.setState({ checked: this.props.checked });
		        }
		    }, {
		        key: 'componentWillReceiveProps',
		        value: function componentWillReceiveProps(nextProps) {
		            this.setState({ checked: nextProps.checked });
		        }
		    }, {
		        key: 'render',
		        value: function render() {
		            var condensedClass = this.props.condensed ? 'no-margin ' + (this.props.className || '') : this.props.className || '';
		            return _react2.default.createElement(
		                'div',
		                { className: condensedClass ? condensedClass : this.props.className || '' },
		                this.getInput(),
		                this.getLabel()
		            );
		        }
		    }]);
	
		    return Checkbox;
		}(_react.Component);
	
		Checkbox.propTypes = {
		    className: _propTypes2.default.string,
		    onChange: _propTypes2.default.func,
		    placeholder: _propTypes2.default.string,
		    label: _propTypes2.default.string,
		    checked: _propTypes2.default.bool.isRequired,
		    condensed: _propTypes2.default.bool,
		    disabled: _propTypes2.default.bool
		};
	
		Checkbox.defaultProps = {
		    checked: false,
		    className: '',
		    label: '',
		    placeholder: '',
		    onChange: function onChange() {},
		    condensed: false,
		    disabled: false
		};
	
		exports.default = Checkbox;
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _propTypes = __webpack_require__(3);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		var _reactRedux = __webpack_require__(8);
	
		var _reactSpinkit = __webpack_require__(9);
	
		var _reactSpinkit2 = _interopRequireDefault(_reactSpinkit);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var Wait = function (_React$Component) {
		    _inherits(Wait, _React$Component);
	
		    function Wait(props) {
		        _classCallCheck(this, Wait);
	
		        return _possibleConstructorReturn(this, (Wait.__proto__ || Object.getPrototypeOf(Wait)).call(this, props));
		    }
	
		    _createClass(Wait, [{
		        key: 'render',
		        value: function render() {
		            if (this.props.isWait) {
		                return _react2.default.createElement(
		                    'div',
		                    { className: 'bg-overlay' },
		                    _react2.default.createElement(
		                        'div',
		                        { className: 'wait' },
		                        _react2.default.createElement(_reactSpinkit2.default, { name: this.props.name, color: this.props.color, fadeIn: this.props.fadeIn })
		                    )
		                );
		            }
		            return null;
		        }
		    }]);
	
		    return Wait;
		}(_react2.default.Component);
	
		Wait.defaultProps = {
		    name: 'ball-spin-fade-loader',
		    color: 'black',
		    fadeIn: 'none',
		    isWait: false
		};
	
		Wait.propTypes = {
		    name: _propTypes2.default.string,
		    color: _propTypes2.default.string,
		    fadeIn: _propTypes2.default.string,
		    isWait: _propTypes2.default.bool
		};
	
		var mapStateToProps = function mapStateToProps(store) {
		    return {
		        isWait: store.WaitReducer.isWait,
		        name: store.WaitReducer.name,
		        color: store.WaitReducer.color,
		        fadeIn: store.WaitReducer.fadeIn
		    };
		};
	
		exports.default = (0, _reactRedux.connect)(mapStateToProps)(Wait);
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(18);
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(2017);
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _WaitConstants = __webpack_require__(11);
	
		var AppAction = {
		    wait: function wait(display) {
		        return {
		            type: _WaitConstants.WAIT,
		            wait: display
		        };
		    },
		    waitStart: function waitStart() {
		        return AppAction.wait(true);
		    },
		    waitStop: function waitStop() {
		        return AppAction.wait(false);
		    }
		};
	
		exports.default = AppAction;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		module.exports = {
		  WAIT: 'WAIT'
		};
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = WaitReducer;
	
		var _WaitConstants = __webpack_require__(11);
	
		function WaitReducer() {
		    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		    var action = arguments[1];
	
		    switch (action.type) {
		        case _WaitConstants.WAIT:
		            {
		                return Object.assign({}, state, {
		                    isWait: action.wait
		                });
		            }
		        default:
		            return state;
		    }
		}
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _propTypes = __webpack_require__(3);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		var _reactRedux = __webpack_require__(8);
	
		var _ToastrAction = __webpack_require__(14);
	
		var _ToastrAction2 = _interopRequireDefault(_ToastrAction);
	
		__webpack_require__(16);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var toastr = window.toastr;
	
		var Toastr = function (_Component) {
		    _inherits(Toastr, _Component);
	
		    function Toastr(props) {
		        _classCallCheck(this, Toastr);
	
		        return _possibleConstructorReturn(this, (Toastr.__proto__ || Object.getPrototypeOf(Toastr)).call(this, props));
		    }
	
		    _createClass(Toastr, [{
		        key: 'componentDidUpdate',
		        value: function componentDidUpdate(prevProps) {
		            if (this.props.error && this.props.error != prevProps.error) {
		                toastr.error(this.props.error);
		                this.props.store.dispatch(_ToastrAction2.default.error(''));
		            }
		            if (this.props.success && this.props.success != prevProps.success) {
		                toastr.success(this.props.success);
		                this.props.store.dispatch(_ToastrAction2.default.success(''));
		            }
		            if (this.props.warning && this.props.warning != prevProps.warning) {
		                toastr.warning(this.props.warning);
		                this.props.store.dispatch(_ToastrAction2.default.success(''));
		            }
		            if (this.props.info && this.props.info != prevProps.info) {
		                toastr.info(this.props.info);
		                this.props.store.dispatch(_ToastrAction2.default.info(''));
		            }
		        }
		    }, {
		        key: 'render',
		        value: function render() {
		            return null;
		        }
		    }]);
	
		    return Toastr;
		}(_react.Component);
	
		Toastr.propTypes = {
		    error: _propTypes2.default.string,
		    success: _propTypes2.default.string,
		    warning: _propTypes2.default.string,
		    info: _propTypes2.default.string,
		    store: _propTypes2.default.object.isRequired
		};
	
		var mapStateToProps = function mapStateToProps(store) {
		    return {
		        error: store.ToastrReducer.error,
		        success: store.ToastrReducer.success,
		        warning: store.ToastrReducer.warning,
		        info: store.ToastrReducer.info
		    };
		};
	
		exports.default = (0, _reactRedux.connect)(mapStateToProps)(Toastr);
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _ToastrConstants = __webpack_require__(15);
	
		var ToastrAction = {
		    error: function error(message) {
		        return {
		            type: _ToastrConstants.TOASTR_ERROR,
		            message: message
		        };
		    },
		    success: function success(message) {
		        return {
		            type: _ToastrConstants.TOASTR_SUCCESS,
		            message: message
		        };
		    },
		    warning: function warning(message) {
		        return {
		            type: _ToastrConstants.TOASTR_WARNING,
		            message: message
		        };
		    },
		    info: function info(message) {
		        return {
		            type: _ToastrConstants.TOASTR_INFO,
		            message: message
		        };
		    }
		};
	
		exports.default = ToastrAction;
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		module.exports = {
		    TOASTR_ERROR: 'TOASTR_ERROR',
		    TOASTR_SUCCESS: 'TOASTR_SUCCESS',
		    TOASTR_WARNING: 'TOASTR_WARNING',
		    TOASTR_INFO: 'TOASTR_INFO'
		};
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		$(document).ready(function () {
		    toastr.options = {
		        "closeButton": false,
		        "debug": false,
		        "newestOnTop": false,
		        "progressBar": false,
		        "positionClass": "toast-bottom-left",
		        "preventDuplicates": false,
		        "onclick": null,
		        "showDuration": "300",
		        "hideDuration": "1000",
		        "timeOut": "5000",
		        "extendedTimeOut": "1000",
		        "showEasing": "swing",
		        "hideEasing": "linear",
		        "showMethod": "slideDown",
		        "hideMethod": "slideUp"
		    };
		});
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = ToastrReducer;
	
		var _ToastrConstants = __webpack_require__(15);
	
		function ToastrReducer() {
		    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		    var action = arguments[1];
	
		    switch (action.type) {
		        case _ToastrConstants.TOASTR_ERROR:
		            {
		                return Object.assign({}, state, {
		                    error: action.message
		                });
		            }
		        case _ToastrConstants.TOASTR_SUCCESS:
		            {
		                return Object.assign({}, state, {
		                    success: action.message
		                });
		            }
		        case _ToastrConstants.TOASTR_WARNING:
		            {
		                return Object.assign({}, state, {
		                    warning: action.message
		                });
		            }
		        case _ToastrConstants.TOASTR_INFO:
		            {
		                return Object.assign({}, state, {
		                    info: action.message
		                });
		            }
		        default:
		            return state;
		    }
		}
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _TableBody = __webpack_require__(19);
	
		var _TableBody2 = _interopRequireDefault(_TableBody);
	
		var _TableBodyColor = __webpack_require__(22);
	
		var _TableBodyColor2 = _interopRequireDefault(_TableBodyColor);
	
		var _propTypes = __webpack_require__(3);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		var _TableHeader = __webpack_require__(28);
	
		var _TableHeader2 = _interopRequireDefault(_TableHeader);
	
		var _TableFilter = __webpack_require__(30);
	
		var _TableFilter2 = _interopRequireDefault(_TableFilter);
	
		var _TablePagination = __webpack_require__(31);
	
		var _TablePagination2 = _interopRequireDefault(_TablePagination);
	
		var _lodash = __webpack_require__(20);
	
		var _MoreVert = __webpack_require__(32);
	
		var _MoreVert2 = _interopRequireDefault(_MoreVert);
	
		var _simpleReactI18n = __webpack_require__(29);
	
		var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
		var _Select = __webpack_require__(1);
	
		var _Select2 = _interopRequireDefault(_Select);
	
		var _table_fr = __webpack_require__(33);
	
		var _table_fr2 = _interopRequireDefault(_table_fr);
	
		var _table = __webpack_require__(34);
	
		var _table2 = _interopRequireDefault(_table);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		_simpleReactI18n2.default.addLang(_table_fr2.default, ['fr', 'FR']);
		_simpleReactI18n2.default.addLang(_table2.default, 'default');
		_simpleReactI18n2.default.init();
	
		var $ = window.$;
	
		var Table = function (_Component) {
		    _inherits(Table, _Component);
	
		    function Table(props) {
		        _classCallCheck(this, Table);
	
		        var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));
	
		        _this.onSort = function (value) {
		            var sort = 'asc';
		            if (_this.state.sortColumn.sort === sort && _this.state.sortColumn.column === value) {
		                sort = 'desc';
		            }
		            _this.setState({ sortColumn: { column: value, sort: sort } });
		        };
	
		        _this.onFilter = function (e) {
		            _this.setState({ filter: e.target.value });
		        };
	
		        _this.changePage = function (page) {
		            _this.setState({ page: page });
		        };
	
		        _this.onChange = function (value) {
		            _this.setState({
		                checked: value
		            });
		        };
	
		        _this.changeNbPerPage = function (nbPerPage) {
		            _this.setState({ nbPerPage: nbPerPage });
		        };
	
		        _this.updateArrowIcon = function () {
		            if (_this.state.arrowIcon === 'keyboard_arrow_down') {
		                $('.collapsible').collapsible('open', 0);
		                _this.setState({ arrowIcon: 'keyboard_arrow_up' });
		            } else {
		                $('.collapsible').collapsible('close', 0);
		                _this.setState({ arrowIcon: 'keyboard_arrow_down' });
		            }
		        };
	
		        _this.getTableFilter = function () {
		            if (_this.props.searchable) {
		                return _react2.default.createElement(_TableFilter2.default, { onFilter: _this.onFilter });
		            }
		            return null;
		        };
	
		        _this.getTablePagination = function (data) {
		            if (_this.props.paging && _this.state.nbPerPage != -1) {
		                return _react2.default.createElement(_TablePagination2.default, { nbElement: data.length, index: _this.state.page,
		                    nbElementPerPage: _this.state.nbPerPage,
		                    onChangePage: _this.changePage });
		            }
		            return null;
		        };
	
		        _this.searchable = function () {
		            return function () {
		                if (_this.state.filter) {
		                    return (0, _lodash.filter)(_this.props.data, function (value) {
		                        return (0, _lodash.some)(_this.getValues(value), function (item) {
		                            var newItem = item + '';
		                            if (typeof item === 'string') {
		                                newItem = item.toLowerCase();
		                            } else if (item === undefined || item === null) {
		                                newItem = '';
		                            }
		                            return newItem.startsWith(_this.state.filter);
		                        });
		                    });
		                }
		                return _this.props.data;
		            }();
		        };
	
		        _this.onSubmit = function () {
		            var exportData = [];
		            for (var idx = 0; idx < _this.dataCheck.length; idx++) {
		                var dataLine = _this.dataCheck[idx];
		                if (_this.refs[idx].getValue()) {
		                    exportData.push(dataLine);
		                }
		            }
		            return exportData;
		        };
	
		        _this.getHeaders = function () {
		            if (_this.props.type.headers) {
		                return _this.props.type.headers;
		            }
		            return Object.keys(_this.props.type);
		        };
	
		        _this.state = {
		            sortColumn: { column: '', sort: '' },
		            filter: '',
		            page: 1,
		            nbPerPage: -1,
		            checked: false,
		            arrowIcon: 'keyboard_arrow_down'
		        };
		        return _this;
		    }
	
		    _createClass(Table, [{
		        key: 'componentWillMount',
		        value: function componentWillMount() {
		            var newState = {
		                datatable: this.props.data,
		                checked: this.props.checked
		            };
		            if (this.props.nbPerPageLabel && this.props.nbPerPageLabel.length > 0) {
		                newState.nbPerPage = this.props.nbPerPageLabel[0].value;
		            }
		            this.setState(newState);
		        }
		    }, {
		        key: 'componentDidMount',
		        value: function componentDidMount() {
		            $('.collapsible').collapsible();
		        }
		    }, {
		        key: 'getValues',
		        value: function getValues(object) {
		            return Object.values(object);
		        }
		    }, {
		        key: 'render',
		        value: function render() {
		            var _this2 = this;
	
		            // Searchable
		            var data = this.searchable();
		            this.dataCheck = [];
	
		            var nbElement = function () {
		                var label = data.length + ' ' + _simpleReactI18n2.default.element;
		                if (data.length > 1) {
		                    label = label + 's';
		                }
		                return label;
		            }();
	
		            // Paging
		            var tablePagination = function () {
		                if (_this2.props.paging && data.length > _this2.props.nbPerPageLabel[0].value) {
		                    return _react2.default.createElement(_Select2.default, { elements: _this2.props.nbPerPageLabel, onChange: _this2.changeNbPerPage });
		                }
		                return null;
		            }();
	
		            var pagination = this.getTablePagination(data);
	
		            if (this.state.nbPerPage !== -1) {
		                data = (0, _lodash.slice)(data, (this.state.page - 1) * this.state.nbPerPage, this.state.page * this.state.nbPerPage);
		            }
	
		            // Sortable
		            if (this.state.sortColumn.column) {
		                data = (0, _lodash.sortBy)(data, this.state.sortColumn.column);
		                if (this.state.sortColumn.sort === 'desc') {
		                    (0, _lodash.reverse)(data);
		                }
		            }
		            var head = function (sortable) {
		                if (sortable) {
		                    var headers = _this2.getHeaders();
		                    var className = _this2.props.headerClass ? _this2.props.headerClass : '';
		                    return _react2.default.createElement(
		                        'thead',
		                        { className: className },
		                        _react2.default.createElement(_TableHeader2.default, { checked: _this2.state.checked, onChange: _this2.onChange, headers: headers,
		                            checkable: _this2.props.checkable, sortColumn: _this2.state.sortColumn,
		                            onSort: _this2.onSort, condensed: _this2.props.condensed })
		                    );
		                }
		                return '';
		            }(this.props.sortable);
	
		            // Body
		            var body = data.map(function (d, id) {
		                if (_this2.props.color) {
		                    return _react2.default.createElement(_TableBodyColor2.default, { data: d, key: id, editable: _this2.props.editable,
		                        link: _this2.props.link, subLink: _this2.props.subLink,
		                        condensed: _this2.props.condensed, store: _this2.props.store,
		                        headers: _this2.getHeaders() });
		                }
		                return _react2.default.createElement(_TableBody2.default, { data: d, key: id, ref: id, editable: _this2.props.editable, link: _this2.props.link,
		                    subLink: _this2.props.subLink, condensed: _this2.props.condensed,
		                    checked: _this2.state.checked, checkable: _this2.props.checkable,
		                    store: _this2.props.store, headers: _this2.getHeaders() });
		            });
	
		            this.dataCheck = data;
	
		            var moreVert = function () {
		                if (_this2.props.actions.length > 0) {
		                    return _react2.default.createElement(_MoreVert2.default, { links: _this2.props.actions, store: _this2.props.store });
		                }
		                return '';
		            }();
	
		            var titleShow = function () {
		                if (_this2.props.showTitle) {
		                    return _react2.default.createElement(
		                        'div',
		                        { className: 'activator col s6' },
		                        _this2.props.title,
		                        ' (',
		                        nbElement,
		                        ')',
		                        moreVert
		                    );
		                }
		                return null;
		            }();
		            return _react2.default.createElement(
		                'div',
		                { className: 'card ' },
		                _react2.default.createElement(
		                    'div',
		                    { className: 'card-title activator' },
		                    _react2.default.createElement(
		                        'div',
		                        { className: 'row no-margin' },
		                        titleShow,
		                        _react2.default.createElement(
		                            'div',
		                            { className: 'col s5 right' },
		                            this.getTableFilter()
		                        )
		                    )
		                ),
		                _react2.default.createElement(
		                    'div',
		                    { className: 'card-content no-padding-top', style: { overflowX: 'auto' } },
		                    _react2.default.createElement(
		                        'div',
		                        { className: 'dataTables_wrapper dt-material no-footer' },
		                        _react2.default.createElement(
		                            'div',
		                            { className: 'row' },
		                            _react2.default.createElement(
		                                'table',
		                                {
		                                    className: 'col l12 highlight table row-border order-column dataTable no-footer responsive-table' },
		                                head,
		                                _react2.default.createElement(
		                                    'tbody',
		                                    null,
		                                    body
		                                )
		                            )
		                        )
		                    ),
		                    _react2.default.createElement(
		                        'div',
		                        { className: 'row' },
		                        _react2.default.createElement(
		                            'div',
		                            { className: 'col' },
		                            tablePagination
		                        ),
		                        _react2.default.createElement(
		                            'div',
		                            { className: 'col' },
		                            pagination
		                        )
		                    )
		                )
		            );
		        }
		    }]);
	
		    return Table;
		}(_react.Component);
	
		Table.propTypes = {
		    icon: _react2.default.PropTypes.string,
		    data: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
		    type: _react2.default.PropTypes.instanceOf(_react2.default.PropTypes.object),
		    title: _react2.default.PropTypes.string,
		    sortable: _react2.default.PropTypes.bool,
		    searchable: _react2.default.PropTypes.bool,
		    editable: _react2.default.PropTypes.bool,
		    paging: _react2.default.PropTypes.bool,
		    nbPerPageLabel: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.element),
		    link: _react2.default.PropTypes.string,
		    checkable: _react2.default.PropTypes.bool,
		    subLink: _react2.default.PropTypes.string,
		    condensed: _react2.default.PropTypes.bool,
		    actions: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.shape({
		        href: _react2.default.PropTypes.string.isRequired,
		        color: _react2.default.PropTypes.string,
		        iconName: _react2.default.PropTypes.string.isRequired
		    })),
		    checked: _react2.default.PropTypes.bool,
		    color: _react2.default.PropTypes.bool,
		    showTitle: _react2.default.PropTypes.bool,
		    store: _react2.default.PropTypes.object.isRequired,
		    headerClass: _react2.default.PropTypes.string
		};
	
		Table.defaultProps = {
		    data: [],
		    sortable: false,
		    searchable: false,
		    editable: false,
		    paging: false,
		    nbPerPageLabel: [],
		    actions: [],
		    color: false,
		    condensed: false,
		    checkable: false,
		    showTitle: true,
		    checked: false
		};
	
		exports.default = Table;
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _lodash = __webpack_require__(20);
	
		var _reactRouterRedux = __webpack_require__(21);
	
		var _Checkbox = __webpack_require__(6);
	
		var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var TableBody = function (_Component) {
		    _inherits(TableBody, _Component);
	
		    function TableBody(props) {
		        _classCallCheck(this, TableBody);
	
		        var _this = _possibleConstructorReturn(this, (TableBody.__proto__ || Object.getPrototypeOf(TableBody)).call(this, props));
	
		        _this.onClick = function (idx) {
		            _this.setState({ editableColumn: idx, width: _this.refs['col-' + idx].offsetWidth });
		        };
	
		        _this.onLink = function (id) {
		            if (_this.props.subLink) {
		                _this.props.store.dispatch((0, _reactRouterRedux.push)('/' + _this.props.link + '/' + id + '/' + _this.props.subLink));
		            } else {
		                _this.props.store.dispatch((0, _reactRouterRedux.push)('/' + _this.props.link + '/' + id));
		            }
		        };
	
		        _this.getValue = function () {
		            return _this.refs.checkbox.getValue();
		        };
	
		        _this.onBlur = function () {
		            _this.props.data[(0, _lodash.keys)(_this.props.data)[_this.state.editableColumn]] = _this.refs.inputRef.value;
		            _this.setState({ editableColumn: -1 });
		        };
	
		        _this.getCheck = function (properties) {
		            if (_this.props.checkable) {
		                return [].concat(['check'], properties);
		            }
		            return properties;
		        };
	
		        _this.getClassNameOnClick = function (editable) {
		            var classNameOnClick = editable ? 'clickable' : '';
		            if (_this.props.condensed) {
		                return 'table-body-condensed ' + classNameOnClick;
		            }
		            return classNameOnClick;
		        };
	
		        _this.getData = function (val) {
		            var type = _typeof(_this.props.data[val]);
		            switch (type) {
		                case 'boolean':
		                    return _react2.default.createElement(_Checkbox2.default, { checked: _this.props.data[val], condensed: _this.props.condensed, disabled: true });
		                default:
		                    return _this.props.data[val];
		            }
		        };
	
		        _this.getCell = function (editable, val, idx) {
	
		            return _react2.default.createElement(
		                'td',
		                { key: idx, ref: 'col-' + idx, onClick: editable,
		                    className: _this.getClassNameOnClick(editable) },
		                ' ',
		                _this.getData(val)
		            );
		        };
	
		        _this.state = {
		            editableColumn: -1,
		            width: 0
		        };
		        return _this;
		    }
	
		    _createClass(TableBody, [{
		        key: 'render',
		        value: function render() {
		            var _this2 = this;
	
		            var properties = this.props.headers;
	
		            var check = this.getCheck(properties);
	
		            // Linkable
		            var link = function () {
		                if (_this2.props.link) {
		                    return function () {
		                        return _this2.onLink(_this2.props.data.id);
		                    };
		                }
		                return '';
		            }();
	
		            var rows = check.map(function (val) {
		                if (val === 'check') {
		                    if (_this2.props.condensed) {
		                        return _react2.default.createElement(
		                            'td',
		                            { className: 'table-body-condensed column-checkbox' },
		                            _react2.default.createElement(_Checkbox2.default, { checked: _this2.props.checked, condensed: _this2.props.condensed, ref: 'checkbox' })
		                        );
		                    }
		                    return _react2.default.createElement(
		                        'td',
		                        { className: 'column-checkbox' },
		                        _react2.default.createElement(_Checkbox2.default, { checked: _this2.props.checked, ref: 'checkbox' })
		                    );
		                }
	
		                var idx = Object.keys(_this2.props.data).indexOf(val);
		                if (idx === _this2.state.editableColumn) {
		                    return _react2.default.createElement(
		                        'td',
		                        { key: idx, className: 'card col clickable',
		                            style: { position: 'absolute', width: _this2.state.width },
		                            onClick: link },
		                        _react2.default.createElement('input', { autoFocus: true, type: 'text', ref: 'inputRef', onBlur: _this2.onBlur,
		                            defaultValue: _this2.props.data[val] })
		                    );
		                }
	
		                // Editable
		                var editable = function () {
		                    if (_this2.props.editable) {
		                        return function () {
		                            return _this2.onClick(idx);
		                        };
		                    }
		                    return link;
		                }();
		                return _this2.getCell(editable, val, idx);
		            });
	
		            var className = function () {
		                if (link) {
		                    return 'bottomMargin10 clickable';
		                }
		                return 'bottomMargin10';
		            }();
	
		            return _react2.default.createElement(
		                'tr',
		                { className: className },
		                rows
		            );
		        }
		    }]);
	
		    return TableBody;
		}(_react.Component);
	
		TableBody.propTypes = {
		    data: _react.PropTypes.object.isRequired,
		    editable: _react2.default.PropTypes.bool,
		    link: _react.PropTypes.string,
		    subLink: _react.PropTypes.string,
		    condensed: _react.PropTypes.bool,
		    checkable: _react.PropTypes.bool,
		    store: _react.PropTypes.object.isRequired,
		    headers: _react2.default.PropTypes.arrayOf(_react.PropTypes.string)
		};
	
		TableBody.defaultProps = {
		    data: {},
		    editable: false,
		    condensed: false,
		    checkable: false,
		    link: '',
		    sublink: ''
		};
	
		exports.default = TableBody;
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(15);
	
	/***/ }),
	/* 21 */
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(43);
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _lodash = __webpack_require__(20);
	
		var _reactRouterRedux = __webpack_require__(21);
	
		var _AppStore = __webpack_require__(23);
	
		var _AppStore2 = _interopRequireDefault(_AppStore);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var TableBodyColor = function (_Component) {
		    _inherits(TableBodyColor, _Component);
	
		    function TableBodyColor(props) {
		        _classCallCheck(this, TableBodyColor);
	
		        var _this = _possibleConstructorReturn(this, (TableBodyColor.__proto__ || Object.getPrototypeOf(TableBodyColor)).call(this, props));
	
		        _this.onClick = function (idx) {
		            _this.setState({ editableColumn: idx, width: _this.refs['col-' + idx].offsetWidth });
		        };
	
		        _this.onLink = function (id) {
		            if (_this.props.subLink) {
		                _this.props.store.dispatch((0, _reactRouterRedux.push)('/' + _this.props.link + '/' + id + '/' + _this.props.subLink));
		            } else {
		                _this.props.store.dispatch((0, _reactRouterRedux.push)('/' + _this.props.link + '/' + id));
		            }
		        };
	
		        _this.onBlur = function () {
		            _this.props.data[(0, _lodash.keys)(_this.props.data)[_this.state.editableColumn]] = _this.refs.inputRef.value;
		            _this.setState({ editableColumn: -1 });
		        };
	
		        _this.state = {
		            editableColumn: -1,
		            width: 0
		        };
		        return _this;
		    }
	
		    _createClass(TableBodyColor, [{
		        key: 'render',
		        value: function render() {
		            var _this2 = this;
	
		            var properties = this.props.headers;
		            var rows = properties.map(function (val, idx) {
		                if (idx === _this2.state.editableColumn) {
		                    return _react2.default.createElement(
		                        'td',
		                        { key: idx, className: 'card col', style: { position: 'absolute', width: _this2.state.width } },
		                        _react2.default.createElement('input', { autoFocus: true, type: 'text', ref: 'inputRef', onBlur: _this2.onBlur,
		                            defaultValue: _this2.props.data[val] })
		                    );
		                }
	
		                // Editable
		                var editable = function () {
		                    if (_this2.props.editable) {
		                        return function () {
		                            return _this2.onClick(idx);
		                        };
		                    }
		                    return '';
		                }();
		                var className = [];
		                className.push(_this2.props.data.color || _this2.props.data[val].color);
		                className.push((_this2.props.data.textColor || _this2.props.data[val].textColor) + '-text');
		                className.push(_this2.props.condensed ? 'table-body-condensed' : '');
		                var value = _this2.props.data[val].value || _this2.props.data[val];
		                return _react2.default.createElement(
		                    'td',
		                    { key: idx, ref: 'col-' + idx, onClick: editable, className: className.join(' '), style: { borderRadius: '0px' } },
		                    _react2.default.createElement(
		                        'span',
		                        {
		                            className: 'truncate' },
		                        value
		                    )
		                );
		            });
	
		            // Linkable
		            var link = function () {
		                if (_this2.props.link) {
		                    return function () {
		                        return _this2.onLink(_this2.props.data.id);
		                    };
		                }
		                return '';
		            }();
	
		            var className = function () {
		                if (link) {
		                    return 'bottomMargin10 clickable';
		                }
		                return 'bottomMargin10';
		            }();
	
		            return _react2.default.createElement(
		                'tr',
		                { className: className, onClick: link },
		                rows
		            );
		        }
		    }]);
	
		    return TableBodyColor;
		}(_react.Component);
	
		TableBodyColor.propTypes = {
		    data: _react.PropTypes.object.isRequired,
		    editable: _react2.default.PropTypes.bool,
		    link: _react.PropTypes.string,
		    subLink: _react.PropTypes.string,
		    condensed: _react2.default.PropTypes.bool,
		    store: _react2.default.PropTypes.object.isRequired,
		    headers: _react2.default.PropTypes.arrayOf(_react.PropTypes.string)
		};
	
		TableBodyColor.defaultProps = {
		    data: {},
		    editable: false,
		    condensed: false
		};
	
		exports.default = TableBodyColor;
	
	/***/ }),
	/* 23 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _reduxThunk = __webpack_require__(24);
	
		var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
		var _redux = __webpack_require__(25);
	
		var _reactRouterRedux = __webpack_require__(21);
	
		var _reactRouter = __webpack_require__(26);
	
		var _reduxLogger = __webpack_require__(27);
	
		var _reduxLogger2 = _interopRequireDefault(_reduxLogger);
	
		var _WaitReducer = __webpack_require__(12);
	
		var _WaitReducer2 = _interopRequireDefault(_WaitReducer);
	
		var _ToastrReducer = __webpack_require__(17);
	
		var _ToastrReducer2 = _interopRequireDefault(_ToastrReducer);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var router = (0, _reactRouterRedux.routerMiddleware)(_reactRouter.browserHistory);
		var enhancer = (0, _redux.applyMiddleware)(_reduxThunk2.default, router, _reduxLogger2.default);
	
		var AppStore = (0, _redux.createStore)((0, _redux.combineReducers)({ WaitReducer: _WaitReducer2.default, ToastrReducer: _ToastrReducer2.default, routing: _reactRouterRedux.routerReducer }), {
		    WaitReducer: {
		        isWait: false,
		        name: 'ball-spin-fade-loader',
		        color: 'red',
		        fadeIn: 'none'
		    },
		    ToastrReducer: {
		        success: '',
		        error: '',
		        warning: '',
		        info: ''
		    }
		}, enhancer);
	
		exports.default = AppStore;
	
	/***/ }),
	/* 24 */
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(1066);
	
	/***/ }),
	/* 25 */
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(553);
	
	/***/ }),
	/* 26 */
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(2011);
	
	/***/ }),
	/* 27 */
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(1065);
	
	/***/ }),
	/* 28 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _simpleReactI18n = __webpack_require__(29);
	
		var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
		var _Checkbox = __webpack_require__(6);
	
		var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var TableHeader = function (_Component) {
		    _inherits(TableHeader, _Component);
	
		    function TableHeader() {
		        _classCallCheck(this, TableHeader);
	
		        return _possibleConstructorReturn(this, (TableHeader.__proto__ || Object.getPrototypeOf(TableHeader)).apply(this, arguments));
		    }
	
		    _createClass(TableHeader, [{
		        key: 'render',
		        value: function render() {
		            var _this2 = this;
	
		            var check = this.props.headers;
		            if (this.props.checkable) {
		                check = [].concat(['check'], this.props.headers);
		            }
		            var rows = check.map(function (header) {
		                if (header === 'check') {
		                    if (_this2.props.condensed) {
		                        return _react2.default.createElement(
		                            'th',
		                            { className: 'table-body-condensed column-checkbox' },
		                            _react2.default.createElement(_Checkbox2.default, { checked: _this2.props.checked, condensed: _this2.props.condensed,
		                                onChange: _this2.props.onChange })
		                        );
		                    }
		                    return _react2.default.createElement(
		                        'th',
		                        { className: 'column-checkbox' },
		                        _react2.default.createElement(_Checkbox2.default, { checked: _this2.props.checked, onChange: _this2.props.onChange })
		                    );
		                }
		                var iconClass = function () {
		                    var icon = 'fa';
		                    if (header === _this2.props.sortColumn.column) {
		                        icon = icon + ' fa-sort-' + _this2.props.sortColumn.sort;
		                    } else {
		                        icon = icon + ' fa-sort';
		                    }
		                    icon = icon + ' color-grey';
		                    return icon;
		                }();
	
		                var name = /^[0-9A-Za-z]+$/.test(header) && _simpleReactI18n2.default[header] ? _simpleReactI18n2.default[header] : header;
		                if (_this2.props.condensed) {
		                    return _react2.default.createElement(
		                        'th',
		                        { key: header, onClick: function onClick() {
		                                return _this2.props.onSort(header);
		                            },
		                            className: 'clickable no-padding' },
		                        name,
		                        '\xA0',
		                        _react2.default.createElement('i', { className: iconClass, 'aria-hidden': 'true' })
		                    );
		                }
		                return _react2.default.createElement(
		                    'th',
		                    { key: header, onClick: function onClick() {
		                            return _this2.props.onSort(header);
		                        }, className: 'clickable' },
		                    name,
		                    '\xA0',
		                    _react2.default.createElement('i', { className: iconClass, 'aria-hidden': 'true' })
		                );
		            });
		            return _react2.default.createElement(
		                'tr',
		                null,
		                rows
		            );
		        }
		    }]);
	
		    return TableHeader;
		}(_react.Component);
	
		TableHeader.propTypes = {
		    headers: _react.PropTypes.arrayOf(_react2.default.PropTypes.string).isRequired,
		    onSort: _react.PropTypes.func,
		    checkable: _react.PropTypes.bool,
		    sortColumn: _react.PropTypes.shape({
		        column: _react2.default.PropTypes.string.isRequired,
		        sort: _react2.default.PropTypes.string.isRequired
		    }),
		    condensed: _react.PropTypes.bool
		};
	
		TableHeader.defaultProps = {
		    checkable: false,
		    condensed: false
		};
	
		exports.default = TableHeader;
	
	/***/ }),
	/* 29 */
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(2031);
	
	/***/ }),
	/* 30 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var TableFilter = function (_Component) {
		    _inherits(TableFilter, _Component);
	
		    function TableFilter() {
		        _classCallCheck(this, TableFilter);
	
		        return _possibleConstructorReturn(this, (TableFilter.__proto__ || Object.getPrototypeOf(TableFilter)).apply(this, arguments));
		    }
	
		    _createClass(TableFilter, [{
		        key: 'render',
		        value: function render() {
		            return _react2.default.createElement(
		                'div',
		                { className: 'dataTables_filter' },
		                _react2.default.createElement(
		                    'div',
		                    { className: 'well' },
		                    _react2.default.createElement(
		                        'div',
		                        { className: 'row no-padding no-margin' },
		                        _react2.default.createElement(
		                            'div',
		                            { className: 'input-field col s12 no-margin-top' },
		                            _react2.default.createElement('input', { type: 'text', className: 'validate form-control input-sm no-margin-bottom', placeholder: 'Rechercher', 'aria-controls': 'tableStationQualito',
		                                onChange: this.props.onFilter })
		                        )
		                    )
		                )
		            );
		        }
		    }]);
	
		    return TableFilter;
		}(_react.Component);
	
		TableFilter.propTypes = {
		    onFilter: _react.PropTypes.func
		};
	
		exports.default = TableFilter;
	
	/***/ }),
	/* 31 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _lodash = __webpack_require__(20);
	
		var _Select = __webpack_require__(1);
	
		var _Select2 = _interopRequireDefault(_Select);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var TablePagination = function (_Component) {
		    _inherits(TablePagination, _Component);
	
		    function TablePagination() {
		        var _ref;
	
		        var _temp, _this, _ret;
	
		        _classCallCheck(this, TablePagination);
	
		        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		            args[_key] = arguments[_key];
		        }
	
		        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TablePagination.__proto__ || Object.getPrototypeOf(TablePagination)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (value) {
		            _this.props.onChangePage(value);
		        }, _this.getRange = function (nbPages) {
		            if (nbPages < 5) {
		                return (0, _lodash.range)(1, nbPages + 1);
		            } else if (_this.props.index + (_this.props.displayPage - 1) >= nbPages) {
		                return (0, _lodash.range)(nbPages - (_this.props.displayPage - 1), nbPages + 1);
		            } else if (_this.props.index > _this.props.displayPage) {
		                return (0, _lodash.range)(_this.props.index - (_this.props.displayPage - 3), _this.props.index + 1);
		            }
		            return (0, _lodash.range)(1, _this.props.displayPage + 1);
		        }, _temp), _possibleConstructorReturn(_this, _ret);
		    }
	
		    _createClass(TablePagination, [{
		        key: 'render',
		        value: function render() {
		            var _this2 = this;
	
		            var style = { marginRight: '0.5rem' };
		            var nbPages = Math.ceil(this.props.nbElement / this.props.nbElementPerPage);
		            if (nbPages != 1) {
		                var pagination = function () {
		                    if (_this2.props.nbElementPerPage !== -1) {
		                        return _this2.getRange(nbPages).map(function (idx) {
		                            if (_this2.props.index === idx) {
		                                return _react2.default.createElement(
		                                    'a',
		                                    { className: 'btn waves-effect waves-light disabled', style: style, 'aria-controls': 'tableStationQualito', disabled: 'disabled', key: idx },
		                                    idx
		                                );
		                            }
		                            return _react2.default.createElement(
		                                'a',
		                                { className: 'btn waves-effect waves-light', style: style, 'aria-controls': 'tableStationQualito', onClick: function onClick() {
		                                        return _this2.onClick(idx);
		                                    }, key: idx },
		                                idx
		                            );
		                        });
		                    }
		                    return [_react2.default.createElement(
		                        'a',
		                        { className: 'btn waves-effect waves-light disabled', style: style, 'aria-controls': 'tableStationQualito', disabled: 'disabled', key: 1 },
		                        '1'
		                    )];
		                }();
	
		                var previous = function () {
		                    if (nbPages < _this2.props.displayPage + 1) {
		                        return null;
		                    }
		                    if (_this2.props.index === 1) {
		                        return _react2.default.createElement(
		                            'a',
		                            { className: 'btn previous disabled', style: style, id: 'tableStationQualito_previous', 'aria-controls': 'tableStationQualito', disabled: true },
		                            '<'
		                        );
		                    }
		                    return _react2.default.createElement(
		                        'a',
		                        { className: 'btn previous', style: style, id: 'tableStationQualito_previous', 'aria-controls': 'tableStationQualito', onClick: function onClick() {
		                                return _this2.onClick(_this2.props.index - 1);
		                            } },
		                        '<'
		                    );
		                }();
		                var next = function () {
		                    if (nbPages < _this2.props.displayPage + 1) {
		                        return null;
		                    }
		                    if (_this2.props.index === nbPages) {
		                        return _react2.default.createElement(
		                            'a',
		                            { className: 'btn next disabled', style: style, id: 'tableStationQualito_next', 'aria-controls': 'tableStationQualito', disabled: true },
		                            '>'
		                        );
		                    }
		                    return _react2.default.createElement(
		                        'a',
		                        { className: 'btn next', style: style, id: 'tableStationQualito_next', 'aria-controls': 'tableStationQualito', onClick: function onClick() {
		                                return _this2.onClick(_this2.props.index + 1);
		                            } },
		                        '>'
		                    );
		                }();
		                var threeDotsNext = function () {
		                    if (nbPages != 1 && nbPages > _this2.props.displayPage && _this2.props.index !== nbPages && _this2.props.index + _this2.props.displayPage - 1 < nbPages) {
		                        return [_react2.default.createElement(
		                            'a',
		                            { className: 'btn btn-flat no-hover', style: style },
		                            '...'
		                        ), _react2.default.createElement(
		                            'a',
		                            { className: 'btn waves-effect waves-light', style: style, 'aria-controls': 'tableStationQualito', onClick: function onClick() {
		                                    return _this2.onClick(nbPages);
		                                } },
		                            nbPages
		                        )];
		                    }
		                    return null;
		                }();
		                var threeDotsPrevious = function () {
		                    if (nbPages != 1 && _this2.props.index > _this2.props.displayPage) {
		                        return [_react2.default.createElement(
		                            'a',
		                            { className: 'btn waves-effect waves-light', style: style, 'aria-controls': 'tableStationQualito', onClick: function onClick() {
		                                    return _this2.onClick(1);
		                                } },
		                            1
		                        ), _react2.default.createElement(
		                            'a',
		                            { className: 'btn btn-flat no-hover', style: style },
		                            '...'
		                        )];
		                    }
		                    return null;
		                }();
	
		                return _react2.default.createElement(
		                    'div',
		                    { className: 'dataTables_paginate paging_simple_numbers' },
		                    _react2.default.createElement(
		                        'div',
		                        { className: 'pagination' },
		                        previous,
		                        threeDotsPrevious,
		                        pagination,
		                        threeDotsNext,
		                        next
		                    )
		                );
		            } else {
		                return null;
		            }
		        }
		    }]);
	
		    return TablePagination;
		}(_react.Component);
	
		TablePagination.propTypes = {
		    index: _react.PropTypes.number.isRequired,
		    nbElement: _react.PropTypes.number.isRequired,
		    nbElementPerPage: _react.PropTypes.number.isRequired,
		    onChangePage: _react.PropTypes.func.isRequired
		};
	
		TablePagination.defaultProps = {
		    displayPage: 5
		};
	
		exports.default = TablePagination;
	
	/***/ }),
	/* 32 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactRouterRedux = __webpack_require__(21);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var MoreVert = function (_Component) {
		    _inherits(MoreVert, _Component);
	
		    function MoreVert(props) {
		        _classCallCheck(this, MoreVert);
	
		        var _this = _possibleConstructorReturn(this, (MoreVert.__proto__ || Object.getPrototypeOf(MoreVert)).call(this, props));
	
		        _this.onClick = function (href) {
		            _this.props.store.dispatch((0, _reactRouterRedux.push)('/' + href));
		        };
	
		        return _this;
		    }
	
		    _createClass(MoreVert, [{
		        key: 'render',
		        value: function render() {
		            var _this2 = this;
	
		            var links = this.props.links.map(function (link) {
		                return _react2.default.createElement(
		                    'li',
		                    null,
		                    _react2.default.createElement(
		                        'a',
		                        { onClick: function onClick() {
		                                return _this2.onClick(link.href);
		                            }, className: 'btn-floating ' + link.color },
		                        _react2.default.createElement(
		                            'i',
		                            { className: 'material-icons' },
		                            link.iconName
		                        )
		                    )
		                );
		            });
		            return _react2.default.createElement(
		                'div',
		                { className: 'right fixed-action-btn horizontal btn-tab-action click-to-toggle' },
		                _react2.default.createElement(
		                    'a',
		                    null,
		                    _react2.default.createElement(
		                        'i',
		                        { className: 'material-icons ' },
		                        'more_vert'
		                    )
		                ),
		                _react2.default.createElement(
		                    'ul',
		                    null,
		                    links
		                )
		            );
		        }
		    }]);
	
		    return MoreVert;
		}(_react.Component);
	
		MoreVert.propTypes = {
		    links: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.shape({
		        href: _react2.default.PropTypes.string.isRequired,
		        color: _react2.default.PropTypes.string,
		        iconName: _react2.default.PropTypes.string.isRequired
		    })).isRequired,
		    store: _react2.default.PropTypes.object.isRequired
		};
	
		MoreVert.defaultProps = {
		    links: []
		};
	
		exports.default = MoreVert;
	
	/***/ }),
	/* 33 */
	/***/ (function(module, exports) {
	
		module.exports = {"element":"Elément"}
	
	/***/ }),
	/* 34 */
	/***/ (function(module, exports) {
	
		module.exports = {"element":"Elément"}
	
	/***/ }),
	/* 35 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _AreaChart = __webpack_require__(36);
	
		var _AreaChart2 = _interopRequireDefault(_AreaChart);
	
		var _Timeserie2 = __webpack_require__(42);
	
		var _Timeserie3 = _interopRequireDefault(_Timeserie2);
	
		var _lodash = __webpack_require__(20);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var Area = function (_Timeserie) {
		    _inherits(Area, _Timeserie);
	
		    function Area() {
		        _classCallCheck(this, Area);
	
		        return _possibleConstructorReturn(this, (Area.__proto__ || Object.getPrototypeOf(Area)).apply(this, arguments));
		    }
	
		    _createClass(Area, [{
		        key: 'initYScale',
		        value: function initYScale(yData) {
		            return _get(Area.prototype.__proto__ || Object.getPrototypeOf(Area.prototype), 'initYScale', this).call(this, (0, _lodash.flatten)(yData));
		        }
		    }, {
		        key: 'focus',
		        value: function focus() {
		            if (this.data[0].y.length > 1) {
		                return 'arearange';
		            }
		            return _get(Area.prototype.__proto__ || Object.getPrototypeOf(Area.prototype), 'focus', this).call(this);
		        }
		    }, {
		        key: 'svg',
		        value: function svg(data) {
		            return _react2.default.createElement(_AreaChart2.default, { data: data, xScale: this.xScale, yScale: this.yScale, color: this.color, isDashStyle: this.isDashStyle(), plot: this.plot });
		        }
		    }]);
	
		    return Area;
		}(_Timeserie3.default);
	
		exports.default = Area;
	
	/***/ }),
	/* 36 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _TimeserieChart2 = __webpack_require__(37);
	
		var _TimeserieChart3 = _interopRequireDefault(_TimeserieChart2);
	
		var _moment = __webpack_require__(39);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var Area = function (_TimeserieChart) {
		    _inherits(Area, _TimeserieChart);
	
		    function Area() {
		        _classCallCheck(this, Area);
	
		        return _possibleConstructorReturn(this, (Area.__proto__ || Object.getPrototypeOf(Area)).apply(this, arguments));
		    }
	
		    _createClass(Area, [{
		        key: 'getSvg',
		        value: function getSvg() {
		            var _this2 = this;
	
		            var area = d3.area().x(function (d) {
		                return _this2.props.xScale(d.x);
		            }).y1(function (d) {
		                if (d.y.length > 1) {
		                    return _this2.props.yScale(d.y[1]);
		                }
		                return _this2.props.yScale(d.y);
		            }).y0(function (d) {
		                if (d.y.length > 1) {
		                    return _this2.props.yScale(d.y[0]);
		                }
		                return _this2.props.yScale(_this2.props.yScale.domain()[0]);
		            });
		            var dash = function () {
		                if (_this2.props.isDashStyle) {
		                    return '5';
		                }
		                return '0';
		            }();
	
		            return _react2.default.createElement('path', { d: area(this.props.data), stroke: this.props.color, fill: this.props.color, strokeDasharray: dash,
		                opacity: '0.3' });
		        }
		    }]);
	
		    return Area;
		}(_TimeserieChart3.default);
	
		exports.default = Area;
	
	/***/ }),
	/* 37 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _ISerie2 = __webpack_require__(38);
	
		var _ISerie3 = _interopRequireDefault(_ISerie2);
	
		var _moment = __webpack_require__(39);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		var _UtilChart = __webpack_require__(40);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var d3 = window.d3;
	
		var Timeserie = function (_ISerie) {
		    _inherits(Timeserie, _ISerie);
	
		    function Timeserie() {
		        _classCallCheck(this, Timeserie);
	
		        return _possibleConstructorReturn(this, (Timeserie.__proto__ || Object.getPrototypeOf(Timeserie)).apply(this, arguments));
		    }
	
		    _createClass(Timeserie, [{
		        key: 'render',
		        value: function render() {
		            var _this2 = this;
	
		            var plots = function () {
		                if (_this2.props.plot) {
		                    return _this2.props.data.map(function (d) {
		                        return (0, _UtilChart.getPlot)(_this2.props.plot, _this2.props.xScale(d.x), _this2.props.yScale(d.y), _this2.props.color);
		                    });
		                }
		                return null;
		            }();
		            return _react2.default.createElement(
		                'g',
		                null,
		                this.getSvg(),
		                plots
		            );
		        }
		    }, {
		        key: 'getSvg',
		        value: function getSvg() {
		            var _this3 = this;
	
		            var line = d3.line().x(function (d) {
		                return _this3.props.xScale(d.x);
		            }).y(function (d) {
		                return _this3.props.yScale(d.y);
		            });
	
		            var dash = function () {
		                if (_this3.props.isDashStyle) {
		                    return '5';
		                }
		                return '0';
		            }();
	
		            return _react2.default.createElement('path', { d: line(this.props.data), stroke: this.props.color, fill: 'none', strokeDasharray: dash });
		        }
		    }]);
	
		    return Timeserie;
		}(_ISerie3.default);
	
		exports.default = Timeserie;
	
	/***/ }),
	/* 38 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var ISerie = function (_Component) {
		    _inherits(ISerie, _Component);
	
		    function ISerie(props) {
		        _classCallCheck(this, ISerie);
	
		        return _possibleConstructorReturn(this, (ISerie.__proto__ || Object.getPrototypeOf(ISerie)).call(this, props));
		    }
	
		    return ISerie;
		}(_react.Component);
	
		ISerie.propTypes = {
		    data: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.shape({
		        x: _react2.default.PropTypes.any.isRequired,
		        y: _react2.default.PropTypes.number.isRequired,
		        color: _react2.default.PropTypes.string
		    })).isRequired,
		    color: _react2.default.PropTypes.string,
		    style: _react2.default.PropTypes.string,
		    name: _react2.default.PropTypes.string
		};
	
		exports.default = ISerie;
	
	/***/ }),
	/* 39 */
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(7);
	
	/***/ }),
	/* 40 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.scalePointPosition = exports.getInvert = exports.getYAxis = exports.closest = exports.getPlot = exports.getMouse = exports.getDataPoint = undefined;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _moment = __webpack_require__(39);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		var _lodash = __webpack_require__(20);
	
		var _Axis = __webpack_require__(41);
	
		var _Axis2 = _interopRequireDefault(_Axis);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var d3 = window.d3;
	
		var getDataPoint = function getDataPoint(point, scale, data, method) {
		    var m = method || 'x';
	
		    var i = function () {
		        if (scale.invert) {
		            var x0 = getInvert(scale, point, m);
		            var close = closest(data.map(function (d) {
		                return d[m];
		            }), x0);
		            return (0, _lodash.findIndex)(data, function (d) {
		                return d[m] == close;
		            });
		        }
		        return scalePointPosition(point, scale);
		    }();
		    var d0 = data[i];
	
		    var dataPoint = { point: point };
		    dataPoint.data = d0;
		    return dataPoint;
		};
	
		var scalePointPosition = function scalePointPosition(point, xScale) {
		    var xPos = point.x;
		    var domain = xScale.domain();
		    var range = xScale.range();
		    var rangePoints = d3.range(range[0], range[1], xScale.step());
		    return d3.bisect(rangePoints, xPos) - 1;
		};
	
		var getInvert = function getInvert(scale, point, method) {
		    var invertScale = scale.invert(point[method]);
		    if (_moment2.default.isDate(invertScale)) {
		        return (0, _moment2.default)(invertScale).valueOf();
		    }
		    return invertScale;
		};
	
		var closest = function closest(arr, closestTo) {
		    return arr.reduce(function (prev, curr) {
		        return Math.abs(curr - closestTo) < Math.abs(prev - closestTo) ? curr : prev;
		    });
		};
	
		var getMouse = function getMouse(e, chartId) {
		    var svg = document.getElementById(chartId);
		    var pt = svg.createSVGPoint();
		    pt.x = e.clientX;
		    pt.y = e.clientY;
		    return pt.matrixTransform(svg.getScreenCTM().inverse());
		};
	
		var getPlot = function getPlot(plot, x, y, color) {
		    var r = 4;
		    switch (plot) {
		        case 'round':
		            return _react2.default.createElement('circle', { r: r, cx: x, cy: y, fill: color });
		        case 'square':
		            return _react2.default.createElement('rect', { x: x - r, y: y - r, width: r * 2,
		                height: r * 2, fill: color });
		        case 'diamond':
		            return _react2.default.createElement('rect', { x: x - r, y: y - r, width: r * 2,
		                height: r * 2, fill: color, transform: 'rotate(45,' + x + ',' + y + ')' });
		        case 'triangle':
		            var size = r * 3;
		            var newX = x - r * 1.5;
		            var newY = y + r * 1.5;
		            return _react2.default.createElement('polygon', { points: newX + ' ' + newY + ', ' + (newX + size / 2) + ' ' + (newY - size) + ', ' + (newX + size) + ' ' + newY, fill: color });
		        default:
		            return _react2.default.createElement('circle', { r: r, cx: x, cy: y, fill: color });
		    }
		};
	
		var getYAxis = function getYAxis(yScale, width, widthPadding, position) {
		    switch (position) {
		        case 'right':
		            return _react2.default.createElement(_Axis2.default, { orient: d3.axisRight, scale: yScale, tickSizeInner: -width + widthPadding * 2,
		                translate: 'translate(' + (width - widthPadding) + ',' + 0 + ')', width: widthPadding, truncate: true });
		        case 'left':
		        default:
		            return _react2.default.createElement(_Axis2.default, { orient: d3.axisLeft, scale: yScale, tickSizeInner: -width + widthPadding * 2,
		                translate: 'translate(' + widthPadding + ',' + 0 + ')', width: widthPadding, truncate: true });
		    }
		};
	
		exports.getDataPoint = getDataPoint;
		exports.getMouse = getMouse;
		exports.getPlot = getPlot;
		exports.closest = closest;
		exports.getYAxis = getYAxis;
		exports.getInvert = getInvert;
		exports.scalePointPosition = scalePointPosition;
	
	/***/ }),
	/* 41 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var d3 = window.d3;
	
		var Axis = function (_Component) {
		    _inherits(Axis, _Component);
	
		    function Axis() {
		        var _ref;
	
		        var _temp, _this, _ret;
	
		        _classCallCheck(this, Axis);
	
		        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		            args[_key] = arguments[_key];
		        }
	
		        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Axis.__proto__ || Object.getPrototypeOf(Axis)).call.apply(_ref, [this].concat(args))), _this), _this.truncate = function (text, width) {
		            var paddingWidth = width * 0.70;
		            text.each(function () {
		                var t = d3.select(this);
		                var word = t.text();
		                var size = t.node().getComputedTextLength();
	
		                while (size > paddingWidth) {
		                    t.text(t.text().slice(0, -1));
		                    size = t.node().getComputedTextLength();
		                }
		                if (word.length != t.text().length) {
		                    t.text(t.text() + '...');
		                }
		                d3.select(t.node().parentNode).append("title").text(word);
		            });
		        }, _this.renderAxis = function () {
		            var node = _this.refs.axis;
		            var axis = _this.props.orient().ticks(6).scale(_this.props.scale).tickSizeOuter(0);
		            if (_this.props.tickSizeInner) {
		                axis.tickSizeInner(_this.props.tickSizeInner);
		            }
		            d3.select(node).call(axis);
		            if (_this.props.truncate) {
		                d3.select(node).selectAll('.tick text').call(_this.truncate, _this.props.width);
		            }
		        }, _temp), _possibleConstructorReturn(_this, _ret);
		    }
	
		    _createClass(Axis, [{
		        key: 'componentDidMount',
		        value: function componentDidMount() {
		            this.renderAxis();
		        }
		    }, {
		        key: 'componentDidUpdate',
		        value: function componentDidUpdate() {
		            this.renderAxis();
		        }
		    }, {
		        key: 'render',
		        value: function render() {
		            return _react2.default.createElement('g', { className: 'axis', ref: 'axis', transform: this.props.translate });
		        }
		    }]);
	
		    return Axis;
		}(_react.Component);
	
		Axis.propTypes = {
		    orient: _react2.default.PropTypes.func,
		    translate: _react2.default.PropTypes.string,
		    scale: _react2.default.PropTypes.func,
		    tickSizeInner: _react2.default.PropTypes.number
		};
	
		exports.default = Axis;
	
	/***/ }),
	/* 42 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _Serie2 = __webpack_require__(43);
	
		var _Serie3 = _interopRequireDefault(_Serie2);
	
		var _moment = __webpack_require__(39);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		var _UtilChart = __webpack_require__(40);
	
		var _TimeserieChart = __webpack_require__(37);
	
		var _TimeserieChart2 = _interopRequireDefault(_TimeserieChart);
	
		var _lodash = __webpack_require__(20);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var d3 = window.d3;
	
		var Timeserie = function (_Serie) {
		    _inherits(Timeserie, _Serie);
	
		    function Timeserie(obj) {
		        _classCallCheck(this, Timeserie);
	
		        var _this = _possibleConstructorReturn(this, (Timeserie.__proto__ || Object.getPrototypeOf(Timeserie)).call(this, obj));
	
		        _this.plot = obj.plot;
		        _this.nice = obj.nice;
		        return _this;
		    }
	
		    _createClass(Timeserie, [{
		        key: 'initXDomain',
		        value: function initXDomain(rangeMin, rangeMax) {
		            this.xDomain = d3.scaleTime().range([rangeMin, rangeMax]);
		            return this;
		        }
		    }, {
		        key: 'initXScale',
		        value: function initXScale(xData) {
		            this.xScale = this.xDomain.domain(d3.extent(xData));
		            if (this.nice) {
		                this.xScale.nice();
		            }
		            return this;
		        }
		    }, {
		        key: 'chunck',
		        value: function chunck() {
		            var data = [];
		            var copyData = (0, _lodash.sortBy)(this.data.slice(), ['x']);
		            while (copyData.length > 0) {
		                var array = function () {
		                    if (copyData[0].y !== null) {
		                        return (0, _lodash.takeWhile)(copyData, function (d) {
		                            return d.y !== null;
		                        });
		                    }
		                    return (0, _lodash.takeWhile)(copyData, function (d) {
		                        return d.y === null;
		                    });
		                }();
		                copyData.splice(0, array.length);
		                data.push(array);
		            }
		            return data.filter(function (d) {
		                return d[0].y !== null;
		            });
		        }
		    }, {
		        key: 'render',
		        value: function render(width, height, widthPadding, heightPadding) {
		            var _this2 = this;
	
		            var chunck = this.chunck();
		            return chunck.map(function (d) {
		                return _this2.svg(d);
		            });
		        }
		    }, {
		        key: 'svg',
		        value: function svg(data) {
		            return _react2.default.createElement(_TimeserieChart2.default, { data: data, xScale: this.xScale, yScale: this.yScale, color: this.color, isDashStyle: this.isDashStyle(), plot: this.plot });
		        }
		    }]);
	
		    return Timeserie;
		}(_Serie3.default);
	
		exports.default = Timeserie;
	
	/***/ }),
	/* 43 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _Focus = __webpack_require__(44);
	
		var _Focus2 = _interopRequireDefault(_Focus);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var Serie = function () {
	
		    /*
		        Serie {
		            data[{
		                x:0,
		                y:1,
		            },
		            {
		                x:0,
		                y:1,
		            }],
		            color: 'black',
		            style: 'solid',
		            name:'test2'
		        }
		          Serie {
		            data[{
		                x:0,
		                y:1,
		            },
		            {
		                x:0,
		                y:1,
		                color:'white'
		            }],
		            color: 'black',
		            style: 'dash'
		        }
		    */
		    function Serie(obj) {
		        _classCallCheck(this, Serie);
	
		        if (!this.initXDomain) {
		            throw new Error('initXDomain is not defined');
		        }
		        if (!this.initXScale) {
		            throw new Error('initXScale is not defined');
		        }
		        this.data = obj.data;
		        this.color = obj.color || 'steelblue';
		        this.style = obj.style || 'solid';
		        this.name = obj.name;
		        this.yMin = obj.yMin;
		        this.yMax = obj.yMax;
		        this.yAxis = obj.yAxis;
		    }
	
		    _createClass(Serie, [{
		        key: 'isSolidStyle',
		        value: function isSolidStyle() {
		            return this.style === 'solid';
		        }
		    }, {
		        key: 'isDashStyle',
		        value: function isDashStyle() {
		            return this.style === 'dash';
		        }
		    }, {
		        key: 'initXScale',
		        value: function initXScale(xData) {
		            this.xScale = this.xDomain.domain(xData);
		            return this;
		        }
		    }, {
		        key: 'initYDomain',
		        value: function initYDomain(rangeMin, rangeMax) {
		            this.yDomain = d3.scaleLinear().range([rangeMin, rangeMax]);
		            return this;
		        }
		    }, {
		        key: 'initYScale',
		        value: function initYScale(yData) {
		            var domain = d3.extent(yData);
		            var dMin = domain[0];
		            var dMax = domain[1];
		            dMin = function () {
		                if (dMin < 0) {
		                    return dMin * 1.1;
		                }
		                return dMin * 0.9;
		            }();
	
		            dMax = function () {
		                if (dMax < 0) {
		                    return dMax * 0.9;
		                }
		                return dMax * 1.1;
		            }();
		            this.yScale = this.yDomain.domain([dMin, dMax]);
		            return this;
		        }
		    }, {
		        key: 'focus',
		        value: function focus() {
		            return 'focus';
		        }
		    }]);
	
		    return Serie;
		}();
	
		exports.default = Serie;
	
	/***/ }),
	/* 44 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _UtilChart = __webpack_require__(40);
	
		var _moment = __webpack_require__(39);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		var _lodash = __webpack_require__(20);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var Focus = function (_Component) {
		    _inherits(Focus, _Component);
	
		    function Focus(props) {
		        _classCallCheck(this, Focus);
	
		        var _this = _possibleConstructorReturn(this, (Focus.__proto__ || Object.getPrototypeOf(Focus)).call(this, props));
	
		        _this.findSerie = function (d) {
		            return _this.props.series.find(function (s) {
		                return s.data.find(function (data) {
		                    return data.x == d.x && data.y == d.y;
		                }) !== undefined;
		            });
		        };
	
		        _this.getDataPoint = function (points, mouse) {
		            if (points.length > 1) {
		                return (0, _lodash.minBy)(points.map(function (point) {
		                    var serie = _this.findSerie(point.data);
		                    var invert = (0, _UtilChart.getInvert)(serie.yScale, mouse, 'y');
		                    return {
		                        data: point.data,
		                        abs: Math.abs(point.data.y - invert)
		                    };
		                }), 'abs');
		            }
		            return points[0];
		        };
	
		        _this.setRectWidth = function (state) {
		            var text = d3.select(_this.refs.text);
		            text.text('x : ' + state.xValue);
		            var xWidth = text.node().getComputedTextLength();
		            text.text('y : ' + state.yValue);
		            var yWidth = text.node().getComputedTextLength();
		            state.rectWidth = d3.max([xWidth, yWidth]) + 15;
		        };
	
		        _this.setTransform = function (dataPoint, state) {
		            var xScale = dataPoint.xScale(dataPoint.data.x);
		            state.transform = 'translate(' + dataPoint.xScale(dataPoint.data.x) + ',' + dataPoint.yScale(state.yValue) + ')';
		            if (xScale + state.rectWidth > _this.props.width) {
		                state.transformRect = 'translate(' + (dataPoint.xScale(dataPoint.data.x) - state.rectWidth - 20) + ',' + dataPoint.yScale(state.yValue) + ')';
		            } else {
		                state.transformRect = state.transform;
		            }
		        };
	
		        _this.state = {
		            rectWidth: 150,
		            transformRect: '',
		            display: 'none',
		            transform: null,
		            colorFocus: '',
		            yValue: 'Y',
		            xValue: 'X'
		        };
		        return _this;
		    }
	
		    _createClass(Focus, [{
		        key: 'mouseOver',
		        value: function mouseOver(e) {
		            this.setState({ display: 'inline' });
		        }
		    }, {
		        key: 'mouseOut',
		        value: function mouseOut(e) {
		            this.setState({ display: 'none' });
		        }
		    }, {
		        key: 'mouseMove',
		        value: function mouseMove(e) {
		            var _this2 = this;
	
		            var mouse = (0, _UtilChart.getMouse)(e, this.props.chartId);
	
		            var seriesData = this.props.series.map(function (serie) {
		                return serie.data;
		            });
	
		            var points = seriesData.map(function (data) {
		                return (0, _UtilChart.getDataPoint)(mouse, _this2.props.series[0].xScale, data, 'x');
		            }).filter(function (p) {
		                return p.data !== undefined;
		            });
	
		            var dataPoint = this.getDataPoint(points, mouse);
	
		            var state = {};
	
		            if (dataPoint && dataPoint.data) {
		                var serie = this.findSerie(dataPoint.data);
		                dataPoint.xScale = serie.xScale;
		                dataPoint.yScale = serie.yScale;
		                this.getValues(dataPoint, state);
		                this.setRectWidth(state);
		                this.setTransform(dataPoint, state);
		                state.colorFocus = serie.color || 'steelblue';
		            }
		            this.setState(state);
		        }
		    }, {
		        key: 'getValues',
		        value: function getValues(dataPoint, state) {
		            var d = dataPoint.data;
		            var xValue = function () {
		                var date = (0, _moment2.default)(d.x);
		                if (date.isValid()) {
		                    return date.toDate().toLocaleDateString() + ' ' + date.toDate().toLocaleTimeString();
		                }
		                return d.x;
		            }();
		            state.xValue = xValue;
		            state.yValue = d.y;
		        }
		    }, {
		        key: 'getFocus',
		        value: function getFocus() {
		            return _react2.default.createElement(
		                'g',
		                { style: { display: this.state.display } },
		                _react2.default.createElement('circle', { r: 4.5, fill: this.state.colorFocus, transform: this.state.transform }),
		                _react2.default.createElement(
		                    'g',
		                    { transform: this.state.transformRect, className: 'focus' },
		                    _react2.default.createElement('rect', { x: 9, rx: 5, height: 50, width: this.state.rectWidth }),
		                    _react2.default.createElement(
		                        'text',
		                        null,
		                        _react2.default.createElement(
		                            'tspan',
		                            { ref: 'text', x: 15, y: 10, dy: '.35em' },
		                            'y : ' + this.state.yValue
		                        ),
		                        _react2.default.createElement(
		                            'tspan',
		                            { x: 15, y: 30, dy: '.35em' },
		                            'x : ' + this.state.xValue
		                        )
		                    )
		                )
		            );
		        }
		    }, {
		        key: 'render',
		        value: function render() {
		            var focus = this.getFocus();
	
		            return _react2.default.createElement(
		                'g',
		                null,
		                focus
		            );
		        }
		    }]);
	
		    return Focus;
		}(_react.Component);
	
		exports.default = Focus;
	
	/***/ }),
	/* 45 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _Serie2 = __webpack_require__(43);
	
		var _Serie3 = _interopRequireDefault(_Serie2);
	
		var _moment = __webpack_require__(39);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		var _BarChart = __webpack_require__(46);
	
		var _BarChart2 = _interopRequireDefault(_BarChart);
	
		var _ReverseBarChart = __webpack_require__(47);
	
		var _ReverseBarChart2 = _interopRequireDefault(_ReverseBarChart);
	
		var _PositiveNegativeBarChart = __webpack_require__(48);
	
		var _PositiveNegativeBarChart2 = _interopRequireDefault(_PositiveNegativeBarChart);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var d3 = window.d3;
	
		var Bar = function (_Serie) {
		    _inherits(Bar, _Serie);
	
		    function Bar() {
		        _classCallCheck(this, Bar);
	
		        return _possibleConstructorReturn(this, (Bar.__proto__ || Object.getPrototypeOf(Bar)).apply(this, arguments));
		    }
	
		    _createClass(Bar, [{
		        key: 'initXDomain',
		        value: function initXDomain(rangeMin, rangeMax) {
		            this.xDomain = d3.scaleBand().rangeRound([rangeMin, rangeMax]).padding(0.1);
		            return this;
		        }
		    }, {
		        key: 'initYScale',
		        value: function initYScale(yData, xData) {
		            var ydomainMax = d3.max(yData);
		            var ydomainMin = d3.min(yData);
		            return _get(Bar.prototype.__proto__ || Object.getPrototypeOf(Bar.prototype), 'initYScale', this).call(this, [this.yMin || ydomainMin, this.yMax || ydomainMax]);
		        }
		    }, {
		        key: 'render',
		        value: function render(width, height, widthPadding, heightPadding) {
		            var minMax = d3.extent(this.data.map(function (d) {
		                return d.y;
		            }));
		            if (minMax[0] < 0 && minMax[1] <= 0) {
		                return _react2.default.createElement(_ReverseBarChart2.default, { data: this.data, xdomain: this.xDomain, yScale: this.yScale, color: this.color, height: height, heightPadding: heightPadding });
		            } else if (minMax[0] < 0 && minMax[1] > 0) {
		                return _react2.default.createElement(_PositiveNegativeBarChart2.default, { data: this.data, xdomain: this.xDomain, yScale: this.yScale, color: this.color, height: height, heightPadding: heightPadding });
		            }
		            return _react2.default.createElement(_BarChart2.default, { data: this.data, xdomain: this.xDomain, yScale: this.yScale, color: this.color, height: height, heightPadding: heightPadding });
		        }
		    }]);
	
		    return Bar;
		}(_Serie3.default);
	
		exports.default = Bar;
	
	/***/ }),
	/* 46 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _ISerie2 = __webpack_require__(38);
	
		var _ISerie3 = _interopRequireDefault(_ISerie2);
	
		var _moment = __webpack_require__(39);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var BarChart = function (_ISerie) {
		    _inherits(BarChart, _ISerie);
	
		    function BarChart() {
		        _classCallCheck(this, BarChart);
	
		        return _possibleConstructorReturn(this, (BarChart.__proto__ || Object.getPrototypeOf(BarChart)).apply(this, arguments));
		    }
	
		    _createClass(BarChart, [{
		        key: 'render',
		        value: function render() {
		            var _this2 = this;
	
		            var bars = this.props.data.map(function (d, i) {
		                return _react2.default.createElement('rect', { x: _this2.props.xdomain(d.x), y: _this2.props.yScale(d.y), width: _this2.props.xdomain.bandwidth(),
		                    height: _this2.props.height - _this2.props.yScale(d.y) - _this2.props.heightPadding, fill: d.color || _this2.props.color });
		            });
	
		            return _react2.default.createElement(
		                'g',
		                null,
		                bars
		            );
		        }
		    }]);
	
		    return BarChart;
		}(_ISerie3.default);
	
		exports.default = BarChart;
	
	/***/ }),
	/* 47 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _ISerie2 = __webpack_require__(38);
	
		var _ISerie3 = _interopRequireDefault(_ISerie2);
	
		var _moment = __webpack_require__(39);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var ReverseBarChart = function (_ISerie) {
		    _inherits(ReverseBarChart, _ISerie);
	
		    function ReverseBarChart() {
		        _classCallCheck(this, ReverseBarChart);
	
		        return _possibleConstructorReturn(this, (ReverseBarChart.__proto__ || Object.getPrototypeOf(ReverseBarChart)).apply(this, arguments));
		    }
	
		    _createClass(ReverseBarChart, [{
		        key: 'render',
		        value: function render() {
		            var _this2 = this;
	
		            var bars = this.props.data.map(function (d, i) {
		                return _react2.default.createElement('rect', { x: _this2.props.xdomain(d.x), y: _this2.props.heightPadding, width: _this2.props.xdomain.bandwidth(),
		                    height: _this2.props.yScale(d.y) - _this2.props.heightPadding, fill: d.color || _this2.props.color });
		            });
	
		            return _react2.default.createElement(
		                'g',
		                null,
		                bars
		            );
		        }
		    }]);
	
		    return ReverseBarChart;
		}(_ISerie3.default);
	
		exports.default = ReverseBarChart;
	
	/***/ }),
	/* 48 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _ISerie2 = __webpack_require__(38);
	
		var _ISerie3 = _interopRequireDefault(_ISerie2);
	
		var _moment = __webpack_require__(39);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var PositiveNegativeBarChart = function (_ISerie) {
		    _inherits(PositiveNegativeBarChart, _ISerie);
	
		    function PositiveNegativeBarChart() {
		        var _ref;
	
		        var _temp, _this, _ret;
	
		        _classCallCheck(this, PositiveNegativeBarChart);
	
		        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		            args[_key] = arguments[_key];
		        }
	
		        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PositiveNegativeBarChart.__proto__ || Object.getPrototypeOf(PositiveNegativeBarChart)).call.apply(_ref, [this].concat(args))), _this), _this.getChartMeasures = function (y) {
		            if (y < 0) {
		                return {
		                    height: _this.props.yScale(y) - _this.props.yScale(0),
		                    y: _this.props.yScale(0)
		                };
		            }
		            return {
		                height: _this.props.yScale(0) - _this.props.yScale(y),
		                y: _this.props.yScale(y)
		            };
		        }, _temp), _possibleConstructorReturn(_this, _ret);
		    }
	
		    _createClass(PositiveNegativeBarChart, [{
		        key: 'render',
		        value: function render() {
		            var _this2 = this;
	
		            var bars = this.props.data.map(function (d, i) {
		                var chartMeasures = _this2.getChartMeasures(d.y);
		                return _react2.default.createElement('rect', { x: _this2.props.xdomain(d.x), y: chartMeasures.y, width: _this2.props.xdomain.bandwidth(),
		                    height: chartMeasures.height, fill: d.color || _this2.props.color });
		            });
		            return _react2.default.createElement(
		                'g',
		                null,
		                bars
		            );
		        }
		    }]);
	
		    return PositiveNegativeBarChart;
		}(_ISerie3.default);
	
		exports.default = PositiveNegativeBarChart;
	
	/***/ }),
	/* 49 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _Serie2 = __webpack_require__(43);
	
		var _Serie3 = _interopRequireDefault(_Serie2);
	
		var _HorizontalBarChart = __webpack_require__(50);
	
		var _HorizontalBarChart2 = _interopRequireDefault(_HorizontalBarChart);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var d3 = window.d3;
	
		var HorizontalBar = function (_Serie) {
		    _inherits(HorizontalBar, _Serie);
	
		    function HorizontalBar() {
		        _classCallCheck(this, HorizontalBar);
	
		        return _possibleConstructorReturn(this, (HorizontalBar.__proto__ || Object.getPrototypeOf(HorizontalBar)).apply(this, arguments));
		    }
	
		    _createClass(HorizontalBar, [{
		        key: 'initXDomain',
		        value: function initXDomain(rangeMin, rangeMax) {
		            this.xDomain = d3.scaleLinear().range([rangeMin, rangeMax]);
		            return this;
		        }
		    }, {
		        key: 'initXScale',
		        value: function initXScale(xData, yData) {
		            var xdomainMax = d3.max(yData);
		            var xdomainMin = d3.min(yData);
		            if (xdomainMin && xdomainMin < 0) {
		                xdomainMax = xdomainMin;
		            }
		            var dMax = function () {
		                if (xdomainMax < 0) {
		                    return xdomainMax * 0.9;
		                }
		                return xdomainMax * 1.1;
		            }();
		            this.xScale = this.xDomain.domain([0, dMax]).nice();
		            return this;
		        }
		    }, {
		        key: 'initYDomain',
		        value: function initYDomain(rangeMin, rangeMax) {
		            this.yDomain = d3.scaleBand().range([rangeMin, rangeMax]);
		            return this;
		        }
		    }, {
		        key: 'initYScale',
		        value: function initYScale(yData, xData) {
		            this.yScale = this.yDomain.domain(xData);
		            return this;
		        }
		    }, {
		        key: 'focus',
		        value: function focus() {
		            return null;
		        }
		    }, {
		        key: 'render',
		        value: function render(width, height, widthPadding, heightPadding) {
		            return _react2.default.createElement(_HorizontalBarChart2.default, { data: this.data, ydomain: this.yDomain, yScale: this.yScale, xScale: this.xScale, color: this.color, height: height, widthPadding: widthPadding });
		        }
		    }]);
	
		    return HorizontalBar;
		}(_Serie3.default);
	
		exports.default = HorizontalBar;
	
	/***/ }),
	/* 50 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _ISerie2 = __webpack_require__(38);
	
		var _ISerie3 = _interopRequireDefault(_ISerie2);
	
		var _moment = __webpack_require__(39);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var HorizontalBarChart = function (_ISerie) {
		    _inherits(HorizontalBarChart, _ISerie);
	
		    function HorizontalBarChart() {
		        _classCallCheck(this, HorizontalBarChart);
	
		        return _possibleConstructorReturn(this, (HorizontalBarChart.__proto__ || Object.getPrototypeOf(HorizontalBarChart)).apply(this, arguments));
		    }
	
		    _createClass(HorizontalBarChart, [{
		        key: 'render',
		        value: function render() {
		            var _this2 = this;
	
		            var bars = this.props.data.map(function (d, i) {
		                return _react2.default.createElement('rect', { x: _this2.props.widthPadding, y: _this2.props.yScale(d.x) + 10, width: _this2.props.xScale(d.y) - _this2.props.widthPadding,
		                    height: _this2.props.ydomain.bandwidth() - 15, fill: _this2.props.color });
		            });
	
		            return _react2.default.createElement(
		                'g',
		                null,
		                bars
		            );
		        }
		    }]);
	
		    return HorizontalBarChart;
		}(_ISerie3.default);
	
		exports.default = HorizontalBarChart;
	
	/***/ }),
	/* 51 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _Serie2 = __webpack_require__(43);
	
		var _Serie3 = _interopRequireDefault(_Serie2);
	
		var _moment = __webpack_require__(39);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		var _PieChart = __webpack_require__(52);
	
		var _PieChart2 = _interopRequireDefault(_PieChart);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var d3 = window.d3;
	
		var Pie = function (_Serie) {
		    _inherits(Pie, _Serie);
	
		    function Pie() {
		        _classCallCheck(this, Pie);
	
		        return _possibleConstructorReturn(this, (Pie.__proto__ || Object.getPrototypeOf(Pie)).apply(this, arguments));
		    }
	
		    _createClass(Pie, [{
		        key: 'initXDomain',
		        value: function initXDomain() {
		            return this;
		        }
		    }, {
		        key: 'initXScale',
		        value: function initXScale() {
		            return this;
		        }
		    }, {
		        key: 'initYScale',
		        value: function initYScale() {
		            return this;
		        }
		    }, {
		        key: 'focus',
		        value: function focus() {
		            return null;
		        }
		    }, {
		        key: 'render',
		        value: function render(width, height, widthPadding, heightPadding) {
		            return _react2.default.createElement(_PieChart2.default, { data: this.data, width: width, height: height });
		        }
		    }]);
	
		    return Pie;
		}(_Serie3.default);
	
		exports.default = Pie;
	
	/***/ }),
	/* 52 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _ISerie2 = __webpack_require__(38);
	
		var _ISerie3 = _interopRequireDefault(_ISerie2);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var PieChart = function (_ISerie) {
		    _inherits(PieChart, _ISerie);
	
		    function PieChart(props) {
		        _classCallCheck(this, PieChart);
	
		        var _this = _possibleConstructorReturn(this, (PieChart.__proto__ || Object.getPrototypeOf(PieChart)).call(this, props));
	
		        _this.state = {
		            selected: ''
		        };
		        return _this;
		    }
	
		    _createClass(PieChart, [{
		        key: 'getElementData',
		        value: function getElementData(element) {
		            return element._groups[0][0].data;
		        }
		    }, {
		        key: 'mouseOver',
		        value: function mouseOver(el) {
		            this.setState({ selected: this.getElementData(el).x });
		        }
		    }, {
		        key: 'mouseOut',
		        value: function mouseOut() {
		            this.setState({ selected: '' });
		        }
		    }, {
		        key: 'getPath',
		        value: function getPath(data, radius) {
		            var _this2 = this;
	
		            return function () {
		                if (data.x == _this2.state.selected) {
		                    return d3.arc().outerRadius(radius).innerRadius(radius * 0.5);
		                }
		                return d3.arc().outerRadius(radius - 10).innerRadius(radius * 0.5);
		            }();
		        }
		    }, {
		        key: 'render',
		        value: function render() {
		            var _this3 = this;
	
		            var radius = Math.min(this.props.width, this.props.height) / 2;
	
		            var arcs = d3.pie().value(function (d) {
		                return d.y;
		            })(this.props.data);
		            var arc = function () {
		                return arcs.map(function (d, i) {
		                    var path = _this3.getPath(d.data, radius);
	
		                    return _react2.default.createElement(
		                        'g',
		                        { onMouseOver: function onMouseOver() {
		                                return _this3.mouseOver(d3.select(d));
		                            },
		                            onMouseOut: function onMouseOut() {
		                                return _this3.mouseOut();
		                            } },
		                        _react2.default.createElement('path', { d: path(d), fill: d.data.color }),
		                        _react2.default.createElement(
		                            'text',
		                            { transform: 'translate(' + path.centroid(d) + ')', textAnchor: 'middle' },
		                            d.value
		                        )
		                    );
		                });
		                return '';
		            }();
	
		            return _react2.default.createElement(
		                'g',
		                { transform: 'translate(' + this.props.width / 2 + ',' + this.props.height / 2 + ')' },
		                arc
		            );
		        }
		    }]);
	
		    return PieChart;
		}(_ISerie3.default);
	
		exports.default = PieChart;
	
	/***/ }),
	/* 53 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _Bar = __webpack_require__(45);
	
		var _Bar2 = _interopRequireDefault(_Bar);
	
		var _TimeBarChart = __webpack_require__(54);
	
		var _TimeBarChart2 = _interopRequireDefault(_TimeBarChart);
	
		var _Timeserie2 = __webpack_require__(42);
	
		var _Timeserie3 = _interopRequireDefault(_Timeserie2);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var d3 = window.d3;
	
		var TimeBar = function (_Timeserie) {
		    _inherits(TimeBar, _Timeserie);
	
		    function TimeBar() {
		        _classCallCheck(this, TimeBar);
	
		        return _possibleConstructorReturn(this, (TimeBar.__proto__ || Object.getPrototypeOf(TimeBar)).apply(this, arguments));
		    }
	
		    _createClass(TimeBar, [{
		        key: 'render',
		        value: function render(width, height, widthPadding, heightPadding) {
		            return _react2.default.createElement(_TimeBarChart2.default, { data: this.data, xdomain: this.xDomain, yScale: this.yScale, color: this.color, height: height, heightPadding: heightPadding });
		        }
		    }]);
	
		    return TimeBar;
		}(_Timeserie3.default);
	
		exports.default = TimeBar;
	
	/***/ }),
	/* 54 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _ISerie2 = __webpack_require__(38);
	
		var _ISerie3 = _interopRequireDefault(_ISerie2);
	
		var _moment = __webpack_require__(39);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var TimeBarChart = function (_ISerie) {
		    _inherits(TimeBarChart, _ISerie);
	
		    function TimeBarChart() {
		        _classCallCheck(this, TimeBarChart);
	
		        return _possibleConstructorReturn(this, (TimeBarChart.__proto__ || Object.getPrototypeOf(TimeBarChart)).apply(this, arguments));
		    }
	
		    _createClass(TimeBarChart, [{
		        key: 'render',
		        value: function render() {
		            var _this2 = this;
	
		            var bars = this.props.data.map(function (d, i) {
		                return _react2.default.createElement('rect', { x: _this2.props.xdomain(d.x), y: _this2.props.yScale(d.y), width: 2,
		                    height: _this2.props.height - _this2.props.yScale(d.y) - _this2.props.heightPadding, fill: _this2.props.color });
		            });
	
		            return _react2.default.createElement(
		                'g',
		                null,
		                bars
		            );
		        }
		    }]);
	
		    return TimeBarChart;
		}(_ISerie3.default);
	
		exports.default = TimeBarChart;
	
	/***/ }),
	/* 55 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _Timeserie2 = __webpack_require__(42);
	
		var _Timeserie3 = _interopRequireDefault(_Timeserie2);
	
		var _moment = __webpack_require__(39);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		var _LineChart = __webpack_require__(56);
	
		var _LineChart2 = _interopRequireDefault(_LineChart);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var d3 = window.d3;
	
		var Line = function (_Timeserie) {
		    _inherits(Line, _Timeserie);
	
		    function Line() {
		        _classCallCheck(this, Line);
	
		        return _possibleConstructorReturn(this, (Line.__proto__ || Object.getPrototypeOf(Line)).apply(this, arguments));
		    }
	
		    _createClass(Line, [{
		        key: 'render',
		        value: function render(width, height, widthPadding, heightPadding) {
		            return _react2.default.createElement(_LineChart2.default, { data: this.data, yScale: this.yScale, color: this.color, width: width, widthPadding: widthPadding });
		        }
		    }]);
	
		    return Line;
		}(_Timeserie3.default);
	
		exports.default = Line;
	
	/***/ }),
	/* 56 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _ISerie2 = __webpack_require__(38);
	
		var _ISerie3 = _interopRequireDefault(_ISerie2);
	
		var _moment = __webpack_require__(39);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		var _UtilChart = __webpack_require__(40);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var d3 = window.d3;
	
		var LineChart = function (_ISerie) {
		    _inherits(LineChart, _ISerie);
	
		    function LineChart() {
		        _classCallCheck(this, LineChart);
	
		        return _possibleConstructorReturn(this, (LineChart.__proto__ || Object.getPrototypeOf(LineChart)).apply(this, arguments));
		    }
	
		    _createClass(LineChart, [{
		        key: 'render',
		        value: function render() {
		            var y = this.props.yScale(this.props.data[0].y);
		            return _react2.default.createElement('line', { x1: this.props.widthPadding, y1: y, x2: this.props.width - this.props.widthPadding, y2: y, stroke: this.props.color, 'stroke-width': '5' });
		        }
		    }]);
	
		    return LineChart;
		}(_ISerie3.default);
	
		exports.default = LineChart;
	
	/***/ }),
	/* 57 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _PlotChart = __webpack_require__(58);
	
		var _PlotChart2 = _interopRequireDefault(_PlotChart);
	
		var _Timeserie2 = __webpack_require__(42);
	
		var _Timeserie3 = _interopRequireDefault(_Timeserie2);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var Plot = function (_Timeserie) {
		    _inherits(Plot, _Timeserie);
	
		    function Plot() {
		        _classCallCheck(this, Plot);
	
		        return _possibleConstructorReturn(this, (Plot.__proto__ || Object.getPrototypeOf(Plot)).apply(this, arguments));
		    }
	
		    _createClass(Plot, [{
		        key: 'svg',
		        value: function svg(data) {
		            return _react2.default.createElement(_PlotChart2.default, { data: data, xScale: this.xScale, yScale: this.yScale, color: this.color, plot: this.plot });
		        }
		    }]);
	
		    return Plot;
		}(_Timeserie3.default);
	
		exports.default = Plot;
	
	/***/ }),
	/* 58 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _TimeserieChart2 = __webpack_require__(37);
	
		var _TimeserieChart3 = _interopRequireDefault(_TimeserieChart2);
	
		var _UtilChart = __webpack_require__(40);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var PlotChart = function (_TimeserieChart) {
		    _inherits(PlotChart, _TimeserieChart);
	
		    function PlotChart() {
		        _classCallCheck(this, PlotChart);
	
		        return _possibleConstructorReturn(this, (PlotChart.__proto__ || Object.getPrototypeOf(PlotChart)).apply(this, arguments));
		    }
	
		    _createClass(PlotChart, [{
		        key: 'render',
		        value: function render() {
		            var _this2 = this;
	
		            var plots = function () {
		                return _this2.props.data.map(function (d) {
		                    return (0, _UtilChart.getPlot)(_this2.props.plot, _this2.props.xScale(d.x), _this2.props.yScale(d.y), _this2.props.color);
		                });
		            }();
	
		            return _react2.default.createElement(
		                'g',
		                null,
		                plots
		            );
		        }
		    }]);
	
		    return PlotChart;
		}(_TimeserieChart3.default);
	
		exports.default = PlotChart;
	
	/***/ }),
	/* 59 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _Serie = __webpack_require__(43);
	
		var _Serie2 = _interopRequireDefault(_Serie);
	
		var _moment = __webpack_require__(39);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		var _StackedBarChart = __webpack_require__(60);
	
		var _StackedBarChart2 = _interopRequireDefault(_StackedBarChart);
	
		var _Bar2 = __webpack_require__(45);
	
		var _Bar3 = _interopRequireDefault(_Bar2);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var d3 = window.d3;
	
		var StackedBar = function (_Bar) {
		    _inherits(StackedBar, _Bar);
	
		    function StackedBar() {
		        _classCallCheck(this, StackedBar);
	
		        return _possibleConstructorReturn(this, (StackedBar.__proto__ || Object.getPrototypeOf(StackedBar)).apply(this, arguments));
		    }
	
		    _createClass(StackedBar, [{
		        key: 'initXScale',
		        value: function initXScale(xData, layers) {
		            return _get(StackedBar.prototype.__proto__ || Object.getPrototypeOf(StackedBar.prototype), 'initXScale', this).call(this, xData);
		        }
		    }, {
		        key: 'initYDomain',
		        value: function initYDomain(rangeMin, rangeMax) {
		            this.yDomain = d3.scaleLinear().range([rangeMin, rangeMax]);
		            return this;
		        }
		    }, {
		        key: 'initYScale',
		        value: function initYScale(xData, layers) {
		            var domain = d3.extent(layers[layers.length - 1], function (d) {
		                return d[0] + d[1];
		            });
		            this.yScale = this.yDomain.domain([this.yMin || domain[0], this.yMax || domain[1]]).nice();
		            return this;
		        }
		    }, {
		        key: 'render',
		        value: function render(width, height, widthPadding, heightPadding, layer, color) {
		            return _react2.default.createElement(_StackedBarChart2.default, { data: layer, xdomain: this.xDomain, yScale: this.yScale, height: height, heightPadding: heightPadding, color: color });
		        }
		    }]);
	
		    return StackedBar;
		}(_Bar3.default);
	
		exports.default = StackedBar;
	
	/***/ }),
	/* 60 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _BarChart2 = __webpack_require__(46);
	
		var _BarChart3 = _interopRequireDefault(_BarChart2);
	
		var _moment = __webpack_require__(39);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var StackedBarChart = function (_BarChart) {
		    _inherits(StackedBarChart, _BarChart);
	
		    function StackedBarChart() {
		        _classCallCheck(this, StackedBarChart);
	
		        return _possibleConstructorReturn(this, (StackedBarChart.__proto__ || Object.getPrototypeOf(StackedBarChart)).apply(this, arguments));
		    }
	
		    _createClass(StackedBarChart, [{
		        key: 'render',
		        value: function render() {
		            var _this2 = this;
	
		            var bars = this.props.data.map(function (d, i) {
		                return _react2.default.createElement('rect', { x: _this2.props.xdomain(d.data.x), y: _this2.props.yScale(d[1]), width: _this2.props.xdomain.bandwidth(),
		                    height: _this2.props.yScale(d[0]) - _this2.props.yScale(d[1]), fill: _this2.props.color });
		            });
	
		            return _react2.default.createElement(
		                'g',
		                null,
		                bars
		            );
		        }
		    }]);
	
		    return StackedBarChart;
		}(_BarChart3.default);
	
		exports.default = StackedBarChart;
	
	/***/ }),
	/* 61 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _Serie = __webpack_require__(43);
	
		var _Serie2 = _interopRequireDefault(_Serie);
	
		var _moment = __webpack_require__(39);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		var _HorizontalStackedBarChart = __webpack_require__(62);
	
		var _HorizontalStackedBarChart2 = _interopRequireDefault(_HorizontalStackedBarChart);
	
		var _HorizontalBar2 = __webpack_require__(49);
	
		var _HorizontalBar3 = _interopRequireDefault(_HorizontalBar2);
	
		var _lodash = __webpack_require__(20);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var d3 = window.d3;
	
		var HorizontalStackedBar = function (_HorizontalBar) {
		    _inherits(HorizontalStackedBar, _HorizontalBar);
	
		    function HorizontalStackedBar() {
		        _classCallCheck(this, HorizontalStackedBar);
	
		        return _possibleConstructorReturn(this, (HorizontalStackedBar.__proto__ || Object.getPrototypeOf(HorizontalStackedBar)).apply(this, arguments));
		    }
	
		    _createClass(HorizontalStackedBar, [{
		        key: 'initXScale',
		        value: function initXScale(xData, layers) {
		            var xdomainMax = d3.extent(layers[layers.length - 1], function (d) {
		                return d[0] + d[1];
		            })[1];
		            var dMax = function () {
		                if (xdomainMax < 0) {
		                    return xdomainMax * 0.9;
		                }
		                return xdomainMax * 1.1;
		            }();
		            this.xScale = this.xDomain.domain([0, dMax]).nice();
		            return this;
		        }
		    }, {
		        key: 'initYScale',
		        value: function initYScale(xData, layers) {
		            this.yScale = this.yDomain.domain((0, _lodash.uniq)(xData));
		            return this;
		        }
		    }, {
		        key: 'render',
		        value: function render(width, height, widthPadding, heightPadding, layer, color) {
		            return _react2.default.createElement(_HorizontalStackedBarChart2.default, { data: layer, ydomain: this.yDomain, yScale: this.yScale, xScale: this.xScale, height: height, widthPadding: widthPadding, color: color });
		        }
		    }]);
	
		    return HorizontalStackedBar;
		}(_HorizontalBar3.default);
	
		exports.default = HorizontalStackedBar;
	
	/***/ }),
	/* 62 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _ISerie2 = __webpack_require__(38);
	
		var _ISerie3 = _interopRequireDefault(_ISerie2);
	
		var _moment = __webpack_require__(39);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var HorizontalStackedBarChart = function (_ISerie) {
		    _inherits(HorizontalStackedBarChart, _ISerie);
	
		    function HorizontalStackedBarChart() {
		        _classCallCheck(this, HorizontalStackedBarChart);
	
		        return _possibleConstructorReturn(this, (HorizontalStackedBarChart.__proto__ || Object.getPrototypeOf(HorizontalStackedBarChart)).apply(this, arguments));
		    }
	
		    _createClass(HorizontalStackedBarChart, [{
		        key: 'render',
		        value: function render() {
		            var _this2 = this;
	
		            var bars = this.props.data.map(function (d, i) {
		                return _react2.default.createElement('rect', { x: _this2.props.xScale(d[0]), y: _this2.props.yScale(d.data.x), width: _this2.props.xScale(d[1]) - _this2.props.xScale(d[0]),
		                    height: _this2.props.ydomain.bandwidth() - 15, fill: _this2.props.color });
		            });
	
		            return _react2.default.createElement(
		                'g',
		                null,
		                bars
		            );
		        }
		    }]);
	
		    return HorizontalStackedBarChart;
		}(_ISerie3.default);
	
		exports.default = HorizontalStackedBarChart;
	
	/***/ }),
	/* 63 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _Serie = __webpack_require__(43);
	
		var _Serie2 = _interopRequireDefault(_Serie);
	
		var _moment = __webpack_require__(39);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		var _TimeStackedBarChart = __webpack_require__(64);
	
		var _TimeStackedBarChart2 = _interopRequireDefault(_TimeStackedBarChart);
	
		var _Timeserie2 = __webpack_require__(42);
	
		var _Timeserie3 = _interopRequireDefault(_Timeserie2);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var d3 = window.d3;
	
		var TimeStackedBar = function (_Timeserie) {
		    _inherits(TimeStackedBar, _Timeserie);
	
		    function TimeStackedBar() {
		        _classCallCheck(this, TimeStackedBar);
	
		        return _possibleConstructorReturn(this, (TimeStackedBar.__proto__ || Object.getPrototypeOf(TimeStackedBar)).apply(this, arguments));
		    }
	
		    _createClass(TimeStackedBar, [{
		        key: 'initYScale',
		        value: function initYScale(xData, layers) {
		            var domain = d3.extent(layers[layers.length - 1], function (d) {
		                return d[0] + d[1];
		            });
		            this.yScale = this.yDomain.domain([this.yMin || domain[0], this.yMax || domain[1]]).nice();
		            return this;
		        }
		    }, {
		        key: 'render',
		        value: function render(width, height, widthPadding, heightPadding, layer, color) {
		            return _react2.default.createElement(_TimeStackedBarChart2.default, { data: layer, xdomain: this.xDomain, yScale: this.yScale, height: height, heightPadding: heightPadding, color: color });
		        }
		    }]);
	
		    return TimeStackedBar;
		}(_Timeserie3.default);
	
		exports.default = TimeStackedBar;
	
	/***/ }),
	/* 64 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _BarChart2 = __webpack_require__(46);
	
		var _BarChart3 = _interopRequireDefault(_BarChart2);
	
		var _moment = __webpack_require__(39);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var TimeStackedBarChart = function (_BarChart) {
		    _inherits(TimeStackedBarChart, _BarChart);
	
		    function TimeStackedBarChart() {
		        _classCallCheck(this, TimeStackedBarChart);
	
		        return _possibleConstructorReturn(this, (TimeStackedBarChart.__proto__ || Object.getPrototypeOf(TimeStackedBarChart)).apply(this, arguments));
		    }
	
		    _createClass(TimeStackedBarChart, [{
		        key: 'render',
		        value: function render() {
		            var _this2 = this;
	
		            var bars = this.props.data.map(function (d, i) {
		                return _react2.default.createElement('rect', { x: _this2.props.xdomain(d.data.x), y: _this2.props.yScale(d[1]), width: 2,
		                    height: _this2.props.yScale(d[0]) - _this2.props.yScale(d[1]), fill: _this2.props.color });
		            });
	
		            return _react2.default.createElement(
		                'g',
		                null,
		                bars
		            );
		        }
		    }]);
	
		    return TimeStackedBarChart;
		}(_BarChart3.default);
	
		exports.default = TimeStackedBarChart;
	
	/***/ }),
	/* 65 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _lodash = __webpack_require__(20);
	
		var _Serie2 = __webpack_require__(43);
	
		var _Serie3 = _interopRequireDefault(_Serie2);
	
		var _BoxPlotChart = __webpack_require__(66);
	
		var _BoxPlotChart2 = _interopRequireDefault(_BoxPlotChart);
	
		var _BoxPlotFocus = __webpack_require__(67);
	
		var _BoxPlotFocus2 = _interopRequireDefault(_BoxPlotFocus);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var BoxPlot = function (_Serie) {
		    _inherits(BoxPlot, _Serie);
	
		    function BoxPlot() {
		        _classCallCheck(this, BoxPlot);
	
		        return _possibleConstructorReturn(this, (BoxPlot.__proto__ || Object.getPrototypeOf(BoxPlot)).apply(this, arguments));
		    }
	
		    _createClass(BoxPlot, [{
		        key: 'initXDomain',
		        value: function initXDomain(min, max) {
		            this.xDomain = d3.scalePoint().rangeRound([min, max]).padding([0.5]);
		            return this;
		        }
		    }, {
		        key: 'initYScale',
		        value: function initYScale(yData) {
		            return _get(BoxPlot.prototype.__proto__ || Object.getPrototypeOf(BoxPlot.prototype), 'initYScale', this).call(this, (0, _lodash.flatten)(yData));
		        }
		    }, {
		        key: 'focus',
		        value: function focus(width, height, widthPadding, heightPadding, xScale, yScale, series) {
		            return 'boxplot';
		        }
		    }, {
		        key: 'render',
		        value: function render(width, height, widthPadding, heightPadding) {
		            return _react2.default.createElement(_BoxPlotChart2.default, { data: this.data, xScale: this.xScale, yScale: this.yScale, widthPadding: widthPadding, heightPadding: heightPadding, height: height });
		        }
		    }]);
	
		    return BoxPlot;
		}(_Serie3.default);
	
		exports.default = BoxPlot;
	
	/***/ }),
	/* 66 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _ISerie2 = __webpack_require__(38);
	
		var _ISerie3 = _interopRequireDefault(_ISerie2);
	
		var _moment = __webpack_require__(39);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		var _UtilChart = __webpack_require__(40);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var d3 = window.d3;
	
		var BoxPlotChart = function (_ISerie) {
		    _inherits(BoxPlotChart, _ISerie);
	
		    function BoxPlotChart() {
		        var _ref;
	
		        var _temp, _this, _ret;
	
		        _classCallCheck(this, BoxPlotChart);
	
		        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		            args[_key] = arguments[_key];
		        }
	
		        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BoxPlotChart.__proto__ || Object.getPrototypeOf(BoxPlotChart)).call.apply(_ref, [this].concat(args))), _this), _this.boxQuartiles = function (d) {
		            d.sort(d3.ascending);
		            return [d3.quantile(d, .25), d3.quantile(d, .5), d3.quantile(d, .75)];
		        }, _this.line = function (x1, x2, y1, y2) {
		            return _react2.default.createElement('line', {
		                x1: x1,
		                x2: x2,
		                y1: _this.props.yScale(y1),
		                y2: _this.props.yScale(y2),
		                stroke: 'black',
		                'stroke-width': '5'
		            });
		        }, _this.verticalLine = function (x, yMin, yMax) {
		            return _react2.default.createElement('line', {
		                x1: x,
		                x2: x,
		                y1: _this.props.yScale(yMin),
		                y2: _this.props.yScale(yMax),
		                stroke: 'black',
		                'stroke-width': '5'
		            });
		        }, _temp), _possibleConstructorReturn(_this, _ret);
		    }
	
		    _createClass(BoxPlotChart, [{
		        key: 'render',
		        value: function render() {
		            var _this2 = this;
	
		            var boxes = this.props.data.map(function (data) {
		                var minMax = d3.extent(data.y);
		                var quartiles = _this2.boxQuartiles(data.y);
		                var yQ2 = _this2.props.yScale(quartiles[2]);
		                var x = _this2.props.xScale(data.x);
		                return _react2.default.createElement(
		                    'g',
		                    null,
		                    _react2.default.createElement('rect', {
		                        width: '30',
		                        height: _this2.props.yScale(quartiles[0]) - _this2.props.yScale(quartiles[2]),
		                        x: x - 15,
		                        y: yQ2,
		                        fill: 'steelblue' }),
		                    _this2.line(x - 15, x + 15, quartiles[1], quartiles[1]),
		                    _this2.line(x - 15, x + 15, minMax[0], minMax[0]),
		                    _this2.line(x - 15, x + 15, minMax[1], minMax[1]),
		                    _this2.line(x, x, minMax[0], quartiles[0]),
		                    _this2.line(x, x, quartiles[2], minMax[1])
		                );
		            });
	
		            return _react2.default.createElement(
		                'g',
		                null,
		                boxes
		            );
		        }
		    }]);
	
		    return BoxPlotChart;
		}(_ISerie3.default);
	
		exports.default = BoxPlotChart;
	
	/***/ }),
	/* 67 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _Focus2 = __webpack_require__(44);
	
		var _Focus3 = _interopRequireDefault(_Focus2);
	
		var _UtilChart = __webpack_require__(40);
	
		var _moment = __webpack_require__(39);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		var _lodash = __webpack_require__(20);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var d3 = window.d3;
	
		var BoxPlotFocus = function (_Focus) {
		    _inherits(BoxPlotFocus, _Focus);
	
		    function BoxPlotFocus() {
		        var _ref;
	
		        var _temp, _this, _ret;
	
		        _classCallCheck(this, BoxPlotFocus);
	
		        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		            args[_key] = arguments[_key];
		        }
	
		        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BoxPlotFocus.__proto__ || Object.getPrototypeOf(BoxPlotFocus)).call.apply(_ref, [this].concat(args))), _this), _this.getYData = function (yData) {
		            var minMax = d3.extent(yData);
		            var quartiles = [d3.quantile(yData, .25), d3.quantile(yData, .5), d3.quantile(yData, .75)];
		            return [].concat(minMax, quartiles).map(function (data) {
		                return { y: data };
		            });
		        }, _temp), _possibleConstructorReturn(_this, _ret);
		    }
	
		    _createClass(BoxPlotFocus, [{
		        key: 'getValues',
		        value: function getValues(dataPoint, state) {
		            dataPoint.data.y.sort(d3.ascending);
		            var yData = this.getYData(dataPoint.data.y);
		            var yPoint = (0, _UtilChart.getDataPoint)(dataPoint.point, dataPoint.yScale, yData, 'y');
		            var d = dataPoint.data;
		            var xValue = function () {
		                var date = (0, _moment2.default)(d.x);
		                if (date.isValid()) {
		                    return date.toDate().toLocaleDateString() + ' ' + date.toDate().toLocaleTimeString();
		                }
		                return d.x;
		            }();
		            state.xValue = xValue;
		            state.yValue = yPoint.data.y;
		            state.transform = 'translate(' + dataPoint.xScale(xValue) + ',' + dataPoint.yScale(yPoint.data.y) + ')';
		        }
		    }]);
	
		    return BoxPlotFocus;
		}(_Focus3.default);
	
		exports.default = BoxPlotFocus;
	
	/***/ }),
	/* 68 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDom = __webpack_require__(69);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		var _lodash = __webpack_require__(20);
	
		var _Legend = __webpack_require__(70);
	
		var _Legend2 = _interopRequireDefault(_Legend);
	
		var _Serie = __webpack_require__(43);
	
		var _Serie2 = _interopRequireDefault(_Serie);
	
		var _Pie = __webpack_require__(51);
	
		var _Pie2 = _interopRequireDefault(_Pie);
	
		var _Axis = __webpack_require__(41);
	
		var _Axis2 = _interopRequireDefault(_Axis);
	
		var _Zoom = __webpack_require__(71);
	
		var _Zoom2 = _interopRequireDefault(_Zoom);
	
		var _Overlay = __webpack_require__(72);
	
		var _Overlay2 = _interopRequireDefault(_Overlay);
	
		var _UtilChart = __webpack_require__(40);
	
		var _uuid = __webpack_require__(5);
	
		var _uuid2 = _interopRequireDefault(_uuid);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var IChart = function (_React$Component) {
		    _inherits(IChart, _React$Component);
	
		    function IChart(state, props) {
		        _classCallCheck(this, IChart);
	
		        var _this = _possibleConstructorReturn(this, (IChart.__proto__ || Object.getPrototypeOf(IChart)).call(this, props));
	
		        _this.getXAxis = function (xScale, height, heightPadding) {
		            if (xScale) {
		                return _react2.default.createElement(_Axis2.default, { orient: d3.axisBottom, scale: xScale, tickSizeInner: -height + heightPadding * 2,
		                    translate: 'translate(' + 0 + ',' + (height - heightPadding) + ')' });
		            }
		            return null;
		        };
	
		        _this.xData = function () {
		            return (0, _lodash.flatten)(_this.state.series.map(function (serie) {
		                return serie.data.map(function (d) {
		                    return d.x;
		                });
		            }));
		        };
	
		        _this.renderSeriesWithoutYAxis = function (width, widthPadding, height, heightPadding) {
		            var seriesWithoutYAxis = _this.state.series.filter(function (serie) {
		                return !serie.yAxis;
		            });
	
		            var xData = _this.xData();
		            var yData = (0, _lodash.flattenDeep)(seriesWithoutYAxis.map(function (serie) {
		                return serie.data.map(function (d) {
		                    return d.y;
		                });
		            }));
	
		            return seriesWithoutYAxis.map(function (serie) {
		                return {
		                    render: serie.initXDomain(widthPadding, width - widthPadding).initXScale(xData, yData).initYDomain(height - heightPadding, heightPadding).initYScale(yData, xData).render(width, height, widthPadding, heightPadding),
		                    xScale: serie.xScale,
		                    yScale: serie.yScale
		                };
		            });
		        };
	
		        _this.renderSeriesWithYAxis = function (width, widthPadding, height, heightPadding) {
		            var seriesWithYAxis = _this.state.series.filter(function (serie) {
		                return serie.yAxis;
		            });
	
		            var xData = _this.xData();
	
		            return seriesWithYAxis.map(function (serie) {
		                var yData = serie.data.map(function (d) {
		                    return d.y;
		                });
		                serie.initXDomain(widthPadding, width - widthPadding).initXScale(xData, yData).initYDomain(height - heightPadding, heightPadding).initYScale(yData, xData);
		                var yAxis = (0, _UtilChart.getYAxis)(serie.yScale, width, widthPadding, serie.yAxis);
		                var render = _react2.default.createElement(
		                    'g',
		                    null,
		                    serie.render(width, height, widthPadding, heightPadding),
		                    yAxis
		                );
		                return {
		                    render: render,
		                    xScale: serie.xScale,
		                    yScale: serie.yScale
		                };
		            });
		        };
	
		        _this.clickSerie = function (serie) {
		            var clicked = _this.props.series.find(function (s) {
		                return s.name == serie;
		            });
		            var foundSerie = (0, _lodash.findIndex)(_this.state.series, { name: serie });
		            var series = _this.state.series.slice();
	
		            if (foundSerie !== -1) {
		                series.splice(foundSerie, 1);
		            } else {
		                series.push(clicked);
		            }
		            _this.setState({ series: series });
		        };
	
		        _this.reset = function () {
		            _this.setState({ series: _this.props.series });
		        };
	
		        _this.updateData = function (screenClient) {
		            var newSeries = _this.state.series.map(function (serie) {
		                var first = _this.findDataPoint(serie.data, (0, _UtilChart.getDataPoint)({
		                    x: screenClient.xStart,
		                    y: screenClient.yStart
		                }, screenClient.scale, serie.data));
		                var last = _this.findDataPoint(serie.data, (0, _UtilChart.getDataPoint)({
		                    x: screenClient.xEnd,
		                    y: screenClient.yEnd
		                }, screenClient.scale, serie.data));
		                var cloneSerie = (0, _lodash.clone)(serie);
		                cloneSerie.data = serie.data.slice(first, last);
		                return cloneSerie;
		            });
		            _this.setState({ series: newSeries });
		        };
	
		        _this.findDataPoint = function (data, dataPoint) {
		            if (dataPoint.data) {
		                return (0, _lodash.findIndex)(data, function (d) {
		                    return d.x === dataPoint.data.x;
		                });
		            }
		            return data.length - 1;
		        };
	
		        _this.zoom = function () {
		            if (_this.props.zoomable) {
		                return {
		                    reset: _this.reset,
		                    updateData: _this.updateData
		                };
		            }
		            return null;
		        };
	
		        _this.state = Object.assign({}, {
		            series: [],
		            width: 300,
		            chartId: _uuid2.default.v4()
		        }, state);
		        return _this;
		    }
	
		    _createClass(IChart, [{
		        key: 'componentWillMount',
		        value: function componentWillMount() {
		            this.setState({ series: this.props.series });
		        }
		    }, {
		        key: 'componentDidMount',
		        value: function componentDidMount() {
		            this.setState({ width: _reactDom2.default.findDOMNode(this).getBoundingClientRect().width });
		        }
		    }, {
		        key: 'componentWillReceiveProps',
		        value: function componentWillReceiveProps(nextProps) {
		            this.setState({ series: nextProps.series });
		        }
		    }, {
		        key: 'getYAxis',
		        value: function getYAxis(yScale, width, widthPadding) {
		            if (yScale) {
		                return (0, _UtilChart.getYAxis)(yScale, width, widthPadding);
		            }
		            return null;
		        }
		    }, {
		        key: 'legend',
		        value: function legend(width, widthPadding, height, heightPadding) {
		            if (this.props.legend) {
		                if (this.props.series[0] instanceof _Pie2.default) {
		                    return _react2.default.createElement(_Legend2.default, { series: this.props.series[0].data, widthPadding: widthPadding,
		                        heightPadding: this.props.height * 0.97, clickSerie: this.clickSerie });
		                }
		                return _react2.default.createElement(_Legend2.default, { series: this.props.series, widthPadding: widthPadding,
		                    heightPadding: this.props.height * 0.98, clickSerie: this.clickSerie });
		            }
		            return null;
		        }
		    }, {
		        key: 'render',
		        value: function render() {
		            var _this2 = this;
	
		            var widthPadding = this.state.width * this.props.widthPadding;
		            var heightPadding = this.props.height * 0.05;
	
		            var width = this.state.width;
		            var height = this.props.height - heightPadding;
	
		            var render = this.renderSeriesWithoutYAxis(width, widthPadding, height, heightPadding);
		            var seriesWithYAxis = this.renderSeriesWithYAxis(width, widthPadding, height, heightPadding);
	
		            var scale = function () {
		                if (render.length > 0) {
		                    return {
		                        xScale: render[0].xScale,
		                        yScale: render[0].yScale
		                    };
		                }
		                return {
		                    xScale: seriesWithYAxis[0].xScale,
		                    yScale: seriesWithYAxis[0].yScale
		                };
		            }();
	
		            var focus = function () {
		                if (_this2.props.series[0].focus) {
		                    return _this2.props.series[0].focus();
		                }
		                return undefined;
		            }();
	
		            var legend = this.legend(width, widthPadding, height, heightPadding);
	
		            return _react2.default.createElement(
		                'svg',
		                { width: '100%', height: '100%', viewBox: '0 0 ' + this.state.width + ' ' + this.props.height,
		                    xmlns: 'http://www.w3.org/2000/svg', version: '1.1', id: this.state.chartId },
		                render.map(function (serie) {
		                    return serie.render;
		                }),
		                seriesWithYAxis.map(function (serie) {
		                    return serie.render;
		                }),
		                this.getXAxis(scale.xScale, height, heightPadding),
		                this.getYAxis(scale.yScale, width, widthPadding),
		                _react2.default.createElement(_Overlay2.default, {
		                    zoom: this.zoom(),
		                    focus: focus,
		                    width: width,
		                    height: height,
		                    widthPadding: widthPadding,
		                    heightPadding: heightPadding,
		                    chartId: this.state.chartId,
		                    series: this.state.series }),
		                legend
		            );
		        }
		    }]);
	
		    return IChart;
		}(_react2.default.Component);
	
		IChart.propTypes = {
		    series: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.instanceOf(_Serie2.default)),
		    legend: _react2.default.PropTypes.bool,
		    height: _react2.default.PropTypes.number,
		    width: _react2.default.PropTypes.number,
		    widthPadding: _react2.default.PropTypes.number
		};
	
		IChart.defaultProps = {
		    widthPadding: 0.05
		};
	
		exports.default = IChart;
	
	/***/ }),
	/* 69 */
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(1931);
	
	/***/ }),
	/* 70 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
			value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _Serie = __webpack_require__(43);
	
		var _Serie2 = _interopRequireDefault(_Serie);
	
		var _UtilChart = __webpack_require__(40);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var Legend = function (_Component) {
			_inherits(Legend, _Component);
	
			function Legend(props) {
				_classCallCheck(this, Legend);
	
				var _this = _possibleConstructorReturn(this, (Legend.__proto__ || Object.getPrototypeOf(Legend)).call(this, props));
	
				_this.calculatePadding = function () {
					var size = _this.refs.legend.children.length;
					var padding = [];
					for (var i = 0; i < size; ++i) {
						if (i > 0) {
							padding.push(padding[i - 1] + _this.refs.legend.children[i].getBBox().width + 20);
						} else {
							padding.push(_this.refs.legend.children[i].getBBox().width);
						}
					}
					_this.setState({ padding: padding });
				};
	
				_this.state = { padding: [] };
				return _this;
			}
	
			_createClass(Legend, [{
				key: 'componentDidMount',
				value: function componentDidMount() {
					this.calculatePadding();
				}
			}, {
				key: 'componentDidUpdate',
				value: function componentDidUpdate(prevProps) {
					if (prevProps.series.length !== this.props.series.length) {
						this.calculatePadding();
					}
				}
			}, {
				key: 'render',
				value: function render() {
					var _this2 = this;
	
					var legend = this.props.series.map(function (serie, i) {
						var widthPadding = function () {
							if (_this2.state.padding.length > 0 && i !== 0) {
								return _this2.props.widthPadding + _this2.state.padding[i - 1] + 20;
							}
							return _this2.props.widthPadding;
						}();
						var plot = (0, _UtilChart.getPlot)(serie.plot, 0, 0, serie.color);
						return _react2.default.createElement(
							'g',
							{ transform: 'translate(' + widthPadding + ',' + _this2.props.heightPadding + ')', className: 'clickable', onClick: function onClick() {
									return _this2.props.clickSerie(serie.name);
								} },
							plot,
							_react2.default.createElement(
								'text',
								{ transform: 'translate(10,5)' },
								serie.name
							)
						);
					});
	
					return _react2.default.createElement(
						'g',
						{ ref: 'legend' },
						legend
					);
				}
			}]);
	
			return Legend;
		}(_react.Component);
	
		Legend.propTypes = {
			series: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.instanceOf(_Serie2.default)),
			widthPadding: _react2.default.PropTypes.number,
			heightPadding: _react2.default.PropTypes.number
		};
	
		exports.default = Legend;
	
	/***/ }),
	/* 71 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
			value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _UtilChart = __webpack_require__(40);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var Zoom = function (_React$Component) {
			_inherits(Zoom, _React$Component);
	
			function Zoom() {
				_classCallCheck(this, Zoom);
	
				var _this = _possibleConstructorReturn(this, (Zoom.__proto__ || Object.getPrototypeOf(Zoom)).call(this));
	
				_this.state = {
					drag: false,
					dragX: 0,
					dragY: 0,
					dragXStart: 0,
					dragYStart: 0,
					resetVisibility: 'hidden'
				};
				return _this;
			}
	
			_createClass(Zoom, [{
				key: 'mouseMove',
				value: function mouseMove(e) {
					e.preventDefault();
					var mousePoint = (0, _UtilChart.getMouse)(e, this.props.chartId);
					var state = {};
					if (this.state.drag) {
						state.dragX = mousePoint.x;
						state.dragY = mousePoint.y;
					}
					this.setState(state);
				}
			}, {
				key: 'mouseDown',
				value: function mouseDown(e) {
					e.preventDefault();
					var mousePoint = (0, _UtilChart.getMouse)(e, this.props.chartId);
					this.setState({
						drag: true,
						dragXStart: mousePoint.x,
						dragYStart: mousePoint.y,
						dragX: mousePoint.x,
						dragY: mousePoint.y
					});
				}
			}, {
				key: 'mouseUp',
				value: function mouseUp(e) {
					e.preventDefault();
					this.setState({ drag: false, dragXStart: 0, dragYStart: 0, dragX: 0, dragY: 0, resetVisibility: 'visible' });
	
					var mouse = (0, _UtilChart.getMouse)(e, this.props.chartId);
	
					this.props.updateData({
						xStart: this.state.dragXStart,
						yStart: this.state.dragYStart,
						xEnd: mouse.x,
						yEnd: mouse.y,
						scale: this.props.xScale
					});
				}
			}, {
				key: 'reset',
				value: function reset() {
					this.setState({ resetVisibility: 'hidden' });
					this.props.reset();
				}
			}, {
				key: 'render',
				value: function render() {
					var _this2 = this;
	
					var drag = _react2.default.createElement('rect', { className: 'drag', width: Math.abs(this.state.dragXStart - this.state.dragX),
						height: Math.abs(this.state.dragYStart - this.state.dragY), x: this.state.dragXStart,
						y: this.state.dragYStart });
	
					var translate = this.props.width - 10;
	
					var reset = _react2.default.createElement(
						'g',
						{ className: 'reset', title: 'Zoom d\'origine', transform: 'translate(' + translate + ',20)',
							visibility: this.state.resetVisibility, onClick: function onClick() {
								return _this2.reset();
							} },
						_react2.default.createElement(
							'title',
							null,
							'Zoom d\'origine'
						),
						_react2.default.createElement('rect', { rx: '3', ry: '3', fill: 'url(#highcharts-10)', x: '-2.5', y: '0.5', width: '105', height: '18', strokeWidth: '1',
							stroke: '#999' }),
						_react2.default.createElement(
							'text',
							{ x: '0', y: '16' },
							_react2.default.createElement(
								'tspan',
								{ x: '0' },
								'Zoom d\'origine'
							)
						)
					);
	
					return _react2.default.createElement(
						'g',
						null,
						drag,
						reset
					);
				}
			}]);
	
			return Zoom;
		}(_react2.default.Component);
	
		Zoom.propTypes = {
			updateData: _react2.default.PropTypes.func,
			reset: _react2.default.PropTypes.func,
			width: _react2.default.PropTypes.number
		};
	
		exports.default = Zoom;
	
	/***/ }),
	/* 72 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _Focus = __webpack_require__(44);
	
		var _Focus2 = _interopRequireDefault(_Focus);
	
		var _BoxPlotFocus = __webpack_require__(67);
	
		var _BoxPlotFocus2 = _interopRequireDefault(_BoxPlotFocus);
	
		var _AreaRangeFocus = __webpack_require__(73);
	
		var _AreaRangeFocus2 = _interopRequireDefault(_AreaRangeFocus);
	
		var _Zoom = __webpack_require__(71);
	
		var _Zoom2 = _interopRequireDefault(_Zoom);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var Overlay = function (_Component) {
		    _inherits(Overlay, _Component);
	
		    function Overlay() {
		        var _ref;
	
		        var _temp, _this, _ret;
	
		        _classCallCheck(this, Overlay);
	
		        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		            args[_key] = arguments[_key];
		        }
	
		        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call.apply(_ref, [this].concat(args))), _this), _this.focus = function () {
		            switch (_this.props.focus) {
		                case 'focus':
		                    return _react2.default.createElement(_Focus2.default, {
		                        ref: 'focus',
		                        width: _this.props.width,
		                        height: _this.props.height,
		                        widthPadding: _this.props.widthPadding,
		                        heightPadding: _this.props.heightPadding,
		                        series: _this.props.series,
		                        chartId: _this.props.chartId });
		                case 'boxplot':
		                    return _react2.default.createElement(_BoxPlotFocus2.default, {
		                        ref: 'focus',
		                        width: _this.props.width,
		                        height: _this.props.height,
		                        widthPadding: _this.props.widthPadding,
		                        heightPadding: _this.props.heightPadding,
		                        series: _this.props.series,
		                        chartId: _this.props.chartId });
		                case 'arearange':
		                    return _react2.default.createElement(_AreaRangeFocus2.default, {
		                        ref: 'focus',
		                        width: _this.props.width,
		                        height: _this.props.height,
		                        widthPadding: _this.props.widthPadding,
		                        heightPadding: _this.props.heightPadding,
		                        series: _this.props.series,
		                        chartId: _this.props.chartId });
		                default:
		                    return null;
		            }
		        }, _this.zoom = function () {
		            if (_this.props.zoom) {
		                return _react2.default.createElement(_Zoom2.default, {
		                    xScale: _this.props.series[0].xScale,
		                    width: _this.props.width,
		                    height: _this.props.height,
		                    widthPadding: _this.props.widthPadding,
		                    heightPadding: _this.props.heightPadding,
		                    reset: _this.props.zoom.reset,
		                    updateData: _this.props.zoom.updateData,
		                    ref: 'zoom',
		                    chartId: _this.props.chartId });
		            }
		            return null;
		        }, _temp), _possibleConstructorReturn(_this, _ret);
		    }
	
		    _createClass(Overlay, [{
		        key: 'mouseOver',
		        value: function mouseOver(e) {
		            e.preventDefault();
		            if (this.refs.focus) {
		                this.refs.focus.mouseOver(e);
		            }
		        }
		    }, {
		        key: 'mouseOut',
		        value: function mouseOut(e) {
		            e.preventDefault();
		            if (this.refs.focus) {
		                this.refs.focus.mouseOut(e);
		            }
		        }
		    }, {
		        key: 'mouseMove',
		        value: function mouseMove(e) {
		            e.preventDefault();
		            if (this.refs.focus) {
		                this.refs.focus.mouseMove(e);
		            }
		            if (this.refs.zoom) {
		                this.refs.zoom.mouseMove(e);
		            }
		        }
		    }, {
		        key: 'mouseDown',
		        value: function mouseDown(e) {
		            e.preventDefault();
		            if (this.refs.zoom) {
		                this.refs.zoom.mouseDown(e);
		            }
		        }
		    }, {
		        key: 'mouseUp',
		        value: function mouseUp(e) {
		            e.preventDefault();
		            if (this.refs.zoom) {
		                this.refs.zoom.mouseUp(e);
		            }
		        }
		    }, {
		        key: 'render',
		        value: function render() {
		            var _this2 = this;
	
		            return _react2.default.createElement(
		                'g',
		                null,
		                _react2.default.createElement('rect', { className: 'overlay', width: this.props.width, height: this.props.height, x: this.props.widthPadding, y: this.props.heightPadding,
		                    onMouseOver: function onMouseOver(e) {
		                        return _this2.mouseOver(e);
		                    },
		                    onMouseOut: function onMouseOut(e) {
		                        return _this2.mouseOut(e);
		                    },
		                    onMouseMove: function onMouseMove(e) {
		                        return _this2.mouseMove(e);
		                    },
		                    onMouseDown: function onMouseDown(e) {
		                        return _this2.mouseDown(e);
		                    },
		                    onMouseUp: function onMouseUp(e) {
		                        return _this2.mouseUp(e);
		                    } }),
		                this.focus(),
		                this.zoom()
		            );
		        }
		    }]);
	
		    return Overlay;
		}(_react.Component);
	
		exports.default = Overlay;
	
	/***/ }),
	/* 73 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _Focus2 = __webpack_require__(44);
	
		var _Focus3 = _interopRequireDefault(_Focus2);
	
		var _UtilChart = __webpack_require__(40);
	
		var _moment = __webpack_require__(39);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		var _lodash = __webpack_require__(20);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var AreaRangeFocus = function (_Focus) {
		    _inherits(AreaRangeFocus, _Focus);
	
		    function AreaRangeFocus() {
		        var _ref;
	
		        var _temp, _this, _ret;
	
		        _classCallCheck(this, AreaRangeFocus);
	
		        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		            args[_key] = arguments[_key];
		        }
	
		        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AreaRangeFocus.__proto__ || Object.getPrototypeOf(AreaRangeFocus)).call.apply(_ref, [this].concat(args))), _this), _this.getDataPoint = function (points, mouse) {
		            var newPoints = (0, _lodash.flatten)(points.map(function (point) {
		                if (point.data.y.length > 1) {
		                    return point.data.y.map(function (y) {
		                        var clonePoint = (0, _lodash.cloneDeep)(point);
		                        clonePoint.data.y = y;
		                        return clonePoint;
		                    });
		                }
		                return point;
		            }));
	
		            if (newPoints.length > 1) {
		                return (0, _lodash.minBy)(newPoints.map(function (point) {
		                    var serie = _this.findSerie(point.data);
		                    var invert = (0, _UtilChart.getInvert)(serie.yScale, mouse, 'y');
		                    return {
		                        data: point.data,
		                        abs: Math.abs(point.data.y - invert)
		                    };
		                }), 'abs');
		            }
		            return newPoints[0];
		        }, _this.findSerie = function (d) {
		            return _this.props.series.find(function (s) {
		                return s.data.find(function (data) {
		                    if (data.y.length > 1) {
		                        return data.x == d.x && data.y.indexOf(d.y) != -1;
		                    }
		                    return data.x == d.x && data.y == d.y;
		                }) !== undefined;
		            });
		        }, _temp), _possibleConstructorReturn(_this, _ret);
		    }
	
		    return AreaRangeFocus;
		}(_Focus3.default);
	
		exports.default = AreaRangeFocus;
	
	/***/ }),
	/* 74 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _uuid = __webpack_require__(5);
	
		var _uuid2 = _interopRequireDefault(_uuid);
	
		var _moment = __webpack_require__(39);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		var _simpleReactI18n = __webpack_require__(29);
	
		var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
		var _datepicker_fr = __webpack_require__(75);
	
		var _datepicker_fr2 = _interopRequireDefault(_datepicker_fr);
	
		var _datepicker = __webpack_require__(76);
	
		var _datepicker2 = _interopRequireDefault(_datepicker);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		_simpleReactI18n2.default.addLang(_datepicker_fr2.default, ['fr', 'FR']);
		_simpleReactI18n2.default.addLang(_datepicker2.default, 'default');
		_simpleReactI18n2.default.init();
	
		var Materialize = window.Materialize;
	
		var DatePicker = function (_Component) {
		    _inherits(DatePicker, _Component);
	
		    function DatePicker(props) {
		        _classCallCheck(this, DatePicker);
	
		        var _this = _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call(this, props));
	
		        _this.onChange = function () {
		            var value = _this.refs[_this.state.datepickerId].value;
		            _this.props.onChange({
		                text: value,
		                timestamp: (0, _moment2.default)(value, _this.props.format.toUpperCase()).valueOf()
		            });
		            _this.setState({ value: value });
		        };
	
		        _this.state = {
		            datepickerId: _uuid2.default.v4(),
		            value: ''
		        };
		        return _this;
		    }
	
		    _createClass(DatePicker, [{
		        key: 'componentWillMount',
		        value: function componentWillMount() {
		            this.setState({ value: this.props.value });
		        }
		    }, {
		        key: 'componentWillReceiveProps',
		        value: function componentWillReceiveProps(nextProps) {
		            this.setState({ value: nextProps.value });
		        }
		    }, {
		        key: 'componentDidMount',
		        value: function componentDidMount() {
		            $('.datepicker').pickadate({
		                labelMonthNext: 'Mois suivant',
		                labelMonthPrev: 'Mois précédent',
		                labelMonthSelect: 'Selectionner le mois',
		                labelYearSelect: 'Selectionner une année',
		                monthsFull: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
		                monthsShort: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'],
		                weekdaysFull: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
		                weekdaysShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
		                weekdaysLetter: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
		                selectMonths: true,
		                selectYears: 15,
		                today: _simpleReactI18n2.default.today,
		                clear: _simpleReactI18n2.default.clean,
		                close: _simpleReactI18n2.default.close,
		                closeOnSelect: false,
		                format: this.props.format,
		                firstDay: '1',
		                onClose: this.onChange
		            });
		        }
		    }, {
		        key: 'render',
		        value: function render() {
		            var _this2 = this;
	
		            var className = function () {
		                if (_this2.props.value) {
		                    return 'active';
		                }
		                return '';
		            }();
		            return _react2.default.createElement(
		                'div',
		                { className: 'input-field' },
		                _react2.default.createElement('input', { type: 'text', className: 'datepicker', id: this.state.datepickerId, ref: this.state.datepickerId, value: this.state.value }),
		                _react2.default.createElement(
		                    'label',
		                    { className: className, htmlFor: this.state.datepickerId },
		                    this.props.title
		                )
		            );
		        }
		    }]);
	
		    return DatePicker;
		}(_react.Component);
	
		DatePicker.propTypes = {
		    format: _react2.default.PropTypes.string,
		    title: _react2.default.PropTypes.string,
		    value: _react2.default.PropTypes.string,
		    onChange: _react2.default.PropTypes.func.isRequired
		};
	
		DatePicker.defaultProps = {
		    format: 'dd/mm/yyyy'
		};
	
		exports.default = DatePicker;
	
	/***/ }),
	/* 75 */
	/***/ (function(module, exports) {
	
		module.exports = {"today":"Aujourd'hui","clean":"Effacer","close":"Valider"}
	
	/***/ }),
	/* 76 */
	/***/ (function(module, exports) {
	
		module.exports = {"today":"Aujourd'hui","clean":"Effacer","close":"Valider"}
	
	/***/ }),
	/* 77 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _uuid = __webpack_require__(5);
	
		var _uuid2 = _interopRequireDefault(_uuid);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var $ = window.$;
		var Materialize = window.Materialize;
	
		var AutoComplete = function (_Component) {
		    _inherits(AutoComplete, _Component);
	
		    function AutoComplete(props) {
		        _classCallCheck(this, AutoComplete);
	
		        var _this = _possibleConstructorReturn(this, (AutoComplete.__proto__ || Object.getPrototypeOf(AutoComplete)).call(this, props));
	
		        _this.initialiseWidgets = function () {
		            var newValues = _this.props.values.reduce(function (acc, value) {
		                acc[value.label] = value.href ? value.href : null;
		                return acc;
		            }, {});
	
		            if ($('#' + _this.state.autocompleteId).autocomplete) {
		                $('#' + _this.state.autocompleteId).autocomplete({
		                    data: newValues,
		                    limit: _this.props.limit, // The max amount of results that can be shown at once. Default: Infinity.
		                    minLength: _this.props.minLength, // The minimum length of the input for the autocomplete to start. Default: 1.
		                    onAutocomplete: function onAutocomplete(val) {
		                        _this.props.onChange(_this.props.values.find(function (v) {
		                            return v.label == val;
		                        }));
		                    }
		                });
		            }
	
		            if (Materialize.updateTextFields) {
		                Materialize.updateTextFields();
		            }
		        };
	
		        _this.changeValue = function (e) {
		            _this.setState({ value: e.target.value });
		        };
	
		        _this.state = {
		            autocompleteId: _uuid2.default.v4(),
		            value: ''
		        };
		        return _this;
		    }
	
		    _createClass(AutoComplete, [{
		        key: 'componentWillMount',
		        value: function componentWillMount() {
		            this.setState({ value: this.props.selected });
		        }
		    }, {
		        key: 'componentDidMount',
		        value: function componentDidMount() {
		            this.initialiseWidgets();
		        }
		    }, {
		        key: 'componentWillReceiveProps',
		        value: function componentWillReceiveProps(nextProps) {
		            this.setState({ value: nextProps.selected });
		        }
		    }, {
		        key: 'componentDidUpdate',
		        value: function componentDidUpdate() {
		            this.initialiseWidgets();
		        }
		    }, {
		        key: 'render',
		        value: function render() {
		            var _this2 = this;
	
		            var defaultValue = this.props.values.find(function (v) {
		                return v.value === _this2.state.value;
		            });
		            return _react2.default.createElement(
		                'div',
		                { className: 'input-field' },
		                _react2.default.createElement('input', { type: 'text', id: this.state.autocompleteId, className: 'autocomplete', value: defaultValue ? defaultValue.label : this.state.value, onChange: this.changeValue }),
		                _react2.default.createElement(
		                    'label',
		                    { htmlFor: this.state.autocompleteId },
		                    this.props.title
		                )
		            );
		        }
		    }]);
	
		    return AutoComplete;
		}(_react.Component);
	
		AutoComplete.propTypes = {
		    values: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
		    title: _react2.default.PropTypes.string,
		    onChange: _react2.default.PropTypes.function,
		    limit: _react2.default.PropTypes.number,
		    minLength: _react2.default.PropTypes.number,
		    selected: _react2.default.PropTypes.string
		};
	
		AutoComplete.defaultProps = {
		    values: [{
		        label: '',
		        href: null
		    }],
		    title: 'Autocomplete',
		    onChange: '',
		    limit: 10,
		    minLength: 1,
		    selected: ''
		};
	
		exports.default = AutoComplete;
	
	/***/ }),
	/* 78 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _Input2 = __webpack_require__(4);
	
		var _Input3 = _interopRequireDefault(_Input2);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var Texarea = function (_Input) {
		    _inherits(Texarea, _Input);
	
		    function Texarea() {
		        _classCallCheck(this, Texarea);
	
		        return _possibleConstructorReturn(this, (Texarea.__proto__ || Object.getPrototypeOf(Texarea)).apply(this, arguments));
		    }
	
		    _createClass(Texarea, [{
		        key: 'render',
		        value: function render() {
		            var _this2 = this;
	
		            var className = 'input-field ' + (this.props.className || '');
	
		            return _react2.default.createElement(
		                'div',
		                { className: className },
		                _react2.default.createElement('textarea', { className: 'materialize-textarea', ref: function ref(_ref) {
		                        return _this2.inputRef = _ref;
		                    },
		                    id: this.state.selectId, value: this.state.value, onChange: this.changeValue }),
		                this.getLabel()
		            );
		        }
		    }]);
	
		    return Texarea;
		}(_Input3.default);
	
		exports.default = Texarea;
	
	/***/ }),
	/* 79 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _openlayers = __webpack_require__(80);
	
		var _openlayers2 = _interopRequireDefault(_openlayers);
	
		var _reactDom = __webpack_require__(69);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		var _Popup = __webpack_require__(81);
	
		var _Popup2 = _interopRequireDefault(_Popup);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var Map = function (_Component) {
		    _inherits(Map, _Component);
	
		    function Map(props) {
		        _classCallCheck(this, Map);
	
		        var _this = _possibleConstructorReturn(this, (Map.__proto__ || Object.getPrototypeOf(Map)).call(this, props));
	
		        _this.createMeasureTooltip = function () {
		            if (_this.measureTooltipElement) {
		                _this.measureTooltipElement.parentNode.removeChild(_this.measureTooltipElement);
		            }
		            _this.measureTooltipElement = document.createElement('div');
		            _this.measureTooltipElement.className = 'tooltip tooltip-measure';
		            _this.measureTooltip = new _openlayers2.default.Overlay({
		                element: _this.measureTooltipElement,
		                offset: [0, -15],
		                positioning: 'bottom-center'
		            });
		            _this.olMap.addOverlay(_this.measureTooltip);
		        };
	
		        _this.clickMap = function (e) {
		            e.preventDefault();
		            if (!_this.props.drawFunction) {
		                _this.setState({ event: { clientX: e.clientX, clientY: e.clientY } });
		                if (_this.props.event) {
		                    var coordinate = _this.olMap.getCoordinateFromPixel(_this.olMap.getEventPixel({
		                        clientX: e.clientX,
		                        clientY: e.clientY
		                    }));
		                    var pointTransform = _openlayers2.default.proj.transform(coordinate, 'EPSG:3857', 'EPSG:4326');
		                    _this.props.event(pointTransform, _this.state.zoom);
		                }
		            }
		        };
	
		        _this.state = {
		            event: {},
		            popup: []
		        };
		        return _this;
		    }
	
		    _createClass(Map, [{
		        key: 'componentWillMount',
		        value: function componentWillMount() {
		            var _this2 = this;
	
		            var layersTab = this.props.layers.map(function (el) {
		                return el.getLayer();
		            });
		            if (this.props.drawFunction) {
		                var source = new _openlayers2.default.source.Vector({ wrapX: false });
	
		                var vector = new _openlayers2.default.layer.Vector({
		                    source: source
		                });
		                layersTab = [].concat(layersTab, vector);
		                this.source = source;
		            }
		            var map = new _openlayers2.default.Map({
		                layers: layersTab,
		                view: new _openlayers2.default.View({
		                    center: _openlayers2.default.proj.fromLonLat(this.props.mapConf.center),
		                    zoom: this.props.mapConf.zoom
		                })
		            });
		            var ghostZoom = map.getView().getZoom();
		            map.on('moveend', function () {
		                if (ghostZoom != map.getView().getZoom()) {
		                    _this2.setState({ zoom: map.getView().getZoom() });
		                }
		            });
	
		            this.olMap = map;
		            if (this.props.drawFunction) {
		                var draw = new _openlayers2.default.interaction.Draw({
		                    source: this.source,
		                    type: 'Circle'
		                });
		                map.addInteraction(draw);
		                this.listener = '';
		                this.coord = '';
		                this.radius = '';
		                this.measureTooltipElement = '';
		                this.measureTooltip = '';
		                this.createMeasureTooltip();
		                draw.on('drawstart', function (evt) {
		                    evt.feature.getGeometry().on('change', function (event) {
		                        var units = map.getView().getProjection().getUnits();
		                        _this2.listener = event.target;
		                        _this2.measureTooltipElement.innerHTML = (_this2.listener.getRadius() * _openlayers2.default.proj.METERS_PER_UNIT[units] / 1000).toFixed(2);
		                        _this2.measureTooltip.setPosition(_this2.listener.getLastCoordinate());
		                    });
		                }, this);
		                draw.on('drawend', function (evt) {
		                    this.coord = _openlayers2.default.proj.transform(evt.feature.getGeometry().getFirstCoordinate(), 'EPSG:3857', 'EPSG:4326');
		                    this.radius = this.listener.getRadius() / 1000;
		                    this.props.radius(this.coord, this.radius);
		                }, this);
		            }
		        }
		    }, {
		        key: 'componentDidMount',
		        value: function componentDidMount() {
		            var map = _reactDom2.default.findDOMNode(this.refs.map);
		            this.olMap.setTarget(map);
		        }
		    }, {
		        key: 'componentWillReceiveProps',
		        value: function componentWillReceiveProps(nextProps) {
		            var _this3 = this;
	
		            var added = nextProps.layers.filter(function (next) {
		                return !_this3.props.layers.find(function (prec) {
		                    return prec === next;
		                });
		            });
	
		            added.forEach(function (element) {
		                _this3.olMap.addLayer(element.getLayer());
		            }, this);
	
		            var removed = this.props.layers.filter(function (prec) {
		                return !nextProps.layers.find(function (next) {
		                    return prec === next;
		                });
		            });
	
		            removed.forEach(function (element) {
		                _this3.olMap.removeLayer(element.getLayer());
		            }, this);
		            this.olMap.getView().setCenter(_openlayers2.default.proj.fromLonLat(nextProps.mapConf.center));
		            this.olMap.getView().setZoom(nextProps.mapConf.zoom);
		            this.olMap.updateSize();
		        }
		    }, {
		        key: 'render',
		        value: function render() {
		            return _react2.default.createElement(
		                'div',
		                { id: 'map', style: { height: this.props.mapConf.size + 'px' }, ref: 'map', onClick: this.clickMap },
		                _react2.default.createElement(_Popup2.default, { olMap: this.olMap, layers: this.props.layers, event: this.state.event,
		                    popupProps: this.props.popupProps })
		            );
		        }
		    }]);
	
		    return Map;
		}(_react.Component);
	
		Map.propTypes = {
		    layers: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
		    popupProps: _react2.default.PropTypes.shape({ filters: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.string) }),
		    mapConf: _react2.default.PropTypes.shape({
		        size: _react2.default.PropTypes.number,
		        center: _react2.default.PropTypes.array,
		        zoom: _react2.default.PropTypes.number
		    }),
		    event: _react2.default.PropTypes.func,
		    drawFunction: _react2.default.PropTypes.bool,
		    radius: _react2.default.PropTypes.func
		};
	
		Map.defaultProps = {
		    mapConf: {
		        size: 300,
		        center: [47.123010186224576, -1.820669934399723],
		        zoom: 10
		    },
		    layers: [],
		    popupProps: { filters: [] },
		    drawFunction: false,
		    event: function event() {},
		    radius: function radius() {},
		    zoom: 10
		};
	
		exports.default = Map;
	
	/***/ }),
	/* 80 */
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(110);
	
	/***/ }),
	/* 81 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _openlayers = __webpack_require__(80);
	
		var _openlayers2 = _interopRequireDefault(_openlayers);
	
		var _reactDom = __webpack_require__(69);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		var _PopupContent = __webpack_require__(82);
	
		var _PopupContent2 = _interopRequireDefault(_PopupContent);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = _react2.default.createClass({
		    displayName: 'Popup',
	
	
		    propTypes: {
		        olMap: _react2.default.PropTypes.instanceOf(_openlayers2.default.Map),
		        event: _react2.default.PropTypes.shape({ clientX: _react2.default.PropTypes.number, clientY: _react2.default.PropTypes.number }),
		        layers: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
		        popupProps: _react2.default.PropTypes.shape({ filters: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.string) })
		    },
		    getDefaultProps: function getDefaultProps() {
		        return {
		            olMap: {},
		            event: {},
		            layers: [],
		            popupProps: { filters: [] }
		        };
		    },
		    getInitialState: function getInitialState() {
		        return {
		            feature: []
		        };
		    },
		    componentDidMount: function componentDidMount() {
		        var container = _reactDom2.default.findDOMNode(this.refs.popup);
		        this.popup = new _openlayers2.default.Overlay({
		            positioning: 'bottom-center',
		            autoPan: true,
		            autoPanAnimation: {
		                duration: 250
		            },
		            offset: [0, 0]
		        });
		        this.props.olMap.addOverlay(this.popup);
		        this.popup.setElement(container);
		    },
		    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		        var _this = this;
	
		        var arr = [];
		        var popup = this.popup;
		        nextProps.olMap.forEachFeatureAtPixel(this.props.olMap.getEventPixel(nextProps.event), function (feature) {
		            var havePopup = _this.props.layers.find(function (la) {
		                return la.checkUuid(feature.getId());
		            }).getPopup();
		            var isOnFilter = _this.props.popupProps.filters.includes(feature.getGeometry().getType());
		            if (havePopup && isOnFilter) {
		                arr.push(feature);
		            }
		        });
		        if (arr.length > 0) {
		            this.setState({ feature: arr });
		            popup.setPosition(this.props.olMap.getCoordinateFromPixel(this.props.olMap.getEventPixel(nextProps.event)));
		        } else {
		            popup.setPosition(undefined);
		        }
		    },
		    getContent: function getContent() {
		        var _this2 = this;
	
		        if (this.state.feature.length > 0) {
		            var filterLayers = this.state.feature.map(function (ft) {
		                return _this2.props.layers.find(function (la) {
		                    return la.checkUuid(ft.getId());
		                });
		            });
		            return _react2.default.createElement(_PopupContent2.default, { features: this.state.feature, layers: filterLayers });
		        }
		        return [];
		    },
	
	
		    render: function render() {
		        var popupContent = this.getContent();
		        return _react2.default.createElement(
		            'div',
		            { ref: 'popup', className: 'ol-popup' },
		            popupContent
		        );
		    }
		});
	
	/***/ }),
	/* 82 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = _react2.default.createClass({
		    displayName: 'PopupContent',
	
	
		    propTypes: {
		        layers: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
		        features: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object)
		    },
	
		    getInitialState: function getInitialState() {
		        return {
		            selected: ''
		        };
		    },
		    getDefaultProps: function getDefaultProps() {
		        return {
		            layers: [],
		            features: []
		        };
		    },
		    getFeatureProxy: function getFeatureProxy(feature) {
		        var handler = {
		            get: function get(target, name) {
		                // You must use .get to access to props of feature.
		                if (name === 'id') {
		                    return target.getId();
		                }
		                return target.get(name);
		            }
		        };
		        return new Proxy(feature, handler);
		    },
		    componentWillMount: function componentWillMount() {
		        var _this = this;
	
		        var feature = this.getFeatureProxy(this.props.features[0]);
		        var lay = this.props.layers.find(function (la) {
		            return la.checkUuid(_this.props.features[0].getId());
		        });
		        this.setState({ selected: lay.getPopup().content(lay, feature) });
		    },
		    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		        var _this2 = this;
	
		        if (nextProps.features) {
		            if (this.props.features.length > 1) {
		                this.props.features.forEach(function (element) {
		                    _this2['couche' + element.getId()].removeEventListener('click', _this2.handlerListener(element));
		                });
		            }
	
		            var lay = nextProps.layers.find(function (la) {
		                return la.checkUuid(nextProps.features[0].getId());
		            });
		            var feature = this.getFeatureProxy(nextProps.features[0]);
		            this.setState({ selected: lay.getPopup().content(lay, feature) });
		        }
		    },
		    componentDidMount: function componentDidMount() {
		        this.createListener();
		    },
		    componentDidUpdate: function componentDidUpdate(prevProps) {
		        // no props check create too much listener
		        if (prevProps.features !== this.props.features) {
		            this.createListener();
		        }
		    },
		    createListener: function createListener() {
		        var _this3 = this;
	
		        if (this.props.features.length > 1) {
		            this.props.features.forEach(function (element) {
		                // React can't trigger click on the map. You must use EventListener, after the DOM render.
		                _this3['couche' + element.getId()].removeEventListener('click', _this3.handlerListener(element));
		                _this3['couche' + element.getId()].addEventListener('click', _this3.handlerListener(element));
		            });
		        }
		    },
		    handlerListener: function handlerListener(element) {
		        var _this4 = this;
	
		        return function () {
		            var feature = _this4.getFeatureProxy(element);
		            var lay = _this4.props.layers.find(function (la) {
		                return la.checkUuid(element.getId());
		            });
		            return _this4.setState({ selected: lay.getPopup().content(lay, feature) });
		        };
		    },
		    getContent: function getContent() {
		        var _this5 = this;
	
		        // creation of childs components is too hard because you must use eventlistener over 2 components..
		        var list = this.props.features.map(function (element) {
		            var lay = _this5.props.layers.find(function (la) {
		                return la.checkUuid(element.getId());
		            });
		            return _react2.default.createElement(
		                'li',
		                { key: element.getId() },
		                _react2.default.createElement(
		                    'a',
		                    { className: 'truncate', ref: function ref(el) {
		                            _this5['couche' + element.getId()] = el;
		                        } },
		                    lay.type.title
		                )
		            );
		        });
		        if (list.length > 1) {
		            return _react2.default.createElement(
		                'div',
		                { className: 'row no-margin' },
		                _react2.default.createElement(
		                    'div',
		                    { className: 'col s4 border-right' },
		                    _react2.default.createElement(
		                        'ul',
		                        { id: 'menu' },
		                        list
		                    )
		                ),
		                _react2.default.createElement(
		                    'div',
		                    { className: 'col s8' },
		                    this.state.selected
		                )
		            );
		        }
		        return _react2.default.createElement(
		            'div',
		            { className: 'row no-margin' },
		            _react2.default.createElement(
		                'div',
		                { className: 'col s12' },
		                this.state.selected
		            )
		        );
		    },
	
	
		    render: function render() {
		        var content = this.getContent();
		        return _react2.default.createElement(
		            'div',
		            { id: 'popover-content' },
		            content
		        );
		    }
		});
	
	/***/ }),
	/* 83 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
			value: true
		});
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
			popupStationPoint: {
				name: function name(layer) {
					return layer.type.name;
				},
				content: function content(layer, feature) {
					var station = layer.getUuid().find(function (el) {
						return el.uuid === feature.id;
					}).obj;
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'b',
							null,
							station.code,
							' '
						),
						':',
						_react2.default.createElement('br', null),
						feature.name
					);
				}
			},
			popupSitePoint: {
				name: function name(layer) {
					return layer.type.name;
				},
				content: function content(layer, feature) {
					var station = layer.getUuid().find(function (el) {
						return el.uuid === feature.id;
					}).obj;
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'b',
							null,
							station.code,
							' '
						),
						':',
						_react2.default.createElement('br', null),
						feature.name
					);
				}
			},
			popupKmlCity: {
				name: function name(layer, feature) {
					return feature.NAME;
				},
				content: function content(layer, feature) {
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'b',
							null,
							feature.NAME
						),
						_react2.default.createElement('br', null),
						'Code postal : ',
						feature.CODE_POSTAL,
						_react2.default.createElement('br', null),
						'Population : ',
						feature.POPULATION,
						_react2.default.createElement('br', null),
						'D\xE9partement : ',
						feature.CODE_DEPARTMENT,
						_react2.default.createElement('br', null)
					);
				}
			},
			popupKmlWaterSheed: {
				name: function name(layer, feature) {
					return feature.CODE;
				}, content: function content(layer, feature) {
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'b',
							null,
							feature.CODE
						),
						_react2.default.createElement('br', null),
						'Nom : ',
						feature.NAME,
						_react2.default.createElement('br', null)
					);
				}
			}
		};
	
	/***/ }),
	/* 84 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
			value: true
		});
	
		var _openlayers = __webpack_require__(80);
	
		var _openlayers2 = _interopRequireDefault(_openlayers);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var fillBlack = function fillBlack() {
			var fill = new _openlayers2.default.style.Fill({
				color: _openlayers2.default.color.asString('rgba(255,255,255,0.5)')
			});
			var stroke = new _openlayers2.default.style.Stroke({
				color: _openlayers2.default.color.asString('#000000'),
				width: 2
			});
			return [new _openlayers2.default.style.Style({
				fill: fill,
				stroke: stroke
			})];
		};
	
		var fillRed = function fillRed() {
			var fill = new _openlayers2.default.style.Fill({
				color: _openlayers2.default.color.asString('rgba(255,255,255,0.3)')
			});
			var stroke = new _openlayers2.default.style.Stroke({
				color: _openlayers2.default.color.asString('#ff0000'),
				width: 2
			});
			return [new _openlayers2.default.style.Style({
				fill: fill,
				stroke: stroke
			})];
		};
	
		exports.default = {
			FILL_RED: fillRed(),
			FILL_BLACK: fillBlack()
		};
	
	/***/ }),
	/* 85 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
			value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		exports.default = Custom;
	
		var _ILayers = __webpack_require__(86);
	
		var _ILayers2 = _interopRequireDefault(_ILayers);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var _Custom = function (_Layers) {
			_inherits(_Custom, _Layers);
	
			function _Custom(vector) {
				_classCallCheck(this, _Custom);
	
				var _this = _possibleConstructorReturn(this, (_Custom.__proto__ || Object.getPrototypeOf(_Custom)).call(this));
	
				_this.vector = vector;
				return _this;
			}
	
			_createClass(_Custom, [{
				key: 'getLayer',
				value: function getLayer() {
					return this.vector;
				}
			}]);
	
			return _Custom;
		}(_ILayers2.default);
	
		function Custom() {
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return new (Function.prototype.bind.apply(_Custom, [null].concat(args)))();
		}
	
	/***/ }),
	/* 86 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
			value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _MapException = __webpack_require__(87);
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var ILayers = function () {
			function ILayers() {
				_classCallCheck(this, ILayers);
	
				this.uuid = [];
				if (!this.getLayer) {
					throw new _MapException.MapException('getLayer is not defined');
				}
			}
	
			_createClass(ILayers, [{
				key: 'generateUUID',
				value: function generateUUID() {
					var d = new Date().getTime();
					var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
						var r = (d + Math.random() * 16) % 16 | 0;
						d = Math.floor(d / 16);
						return function () {
							if (c === 'x') {
								return r;
							}
							return r & 0x3 | 0x8;
						}().toString(16);
					});
					return uuid;
				}
			}, {
				key: 'getUuid',
				value: function getUuid() {
					return this.uuid;
				}
			}, {
				key: 'getPopup',
				value: function getPopup() {
					return '';
				}
			}, {
				key: 'checkUuid',
				value: function checkUuid(u) {
					return !!this.uuid.find(function (el) {
						return u === el.uuid;
					});
				}
			}, {
				key: 'registerFeature',
				value: function registerFeature() {
					var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
					var uuid = this.generateUUID();
					this.uuid.push({ uuid: uuid, obj: obj });
					return uuid;
				}
			}]);
	
			return ILayers;
		}();
	
		exports.default = ILayers;
	
	/***/ }),
	/* 87 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
			value: true
		});
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var MapException = function (_Error) {
			_inherits(MapException, _Error);
	
			function MapException(message) {
				_classCallCheck(this, MapException);
	
				var name = 'MapException';
	
				var _this = _possibleConstructorReturn(this, (MapException.__proto__ || Object.getPrototypeOf(MapException)).call(this, name + ' : ' + message));
	
				_this.name = name;
				return _this;
			}
	
			return MapException;
		}(Error);
	
		exports.MapException = MapException;
	
	/***/ }),
	/* 88 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		exports.default = KML;
	
		var _ILayers = __webpack_require__(86);
	
		var _ILayers2 = _interopRequireDefault(_ILayers);
	
		var _ActionUtils = __webpack_require__(89);
	
		var _openlayers = __webpack_require__(80);
	
		var _openlayers2 = _interopRequireDefault(_openlayers);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var _KML = function (_Layers) {
		    _inherits(_KML, _Layers);
	
		    function _KML(obj) {
		        _classCallCheck(this, _KML);
	
		        var _this = _possibleConstructorReturn(this, (_KML.__proto__ || Object.getPrototypeOf(_KML)).call(this));
	
		        _this.obj = obj;
		        _this.kmlFormatWater = new _openlayers2.default.format.KML({
		            extractStyles: obj.extractStyles || false
		        });
		        _this.type = obj.type || {};
		        _this.popup = obj.popup;
		        _this.layer = _this.createLayer();
		        return _this;
		    }
	
		    _createClass(_KML, [{
		        key: 'getHeaders',
		        value: function getHeaders() {
		            if (this.obj.headers) {
		                return { Accept: 'application/vnd.google-earth.kml+xml' };
		            }
		            return {};
		        }
		    }, {
		        key: 'createLayer',
		        value: function createLayer() {
		            var that = this;
		            var vct = new _openlayers2.default.source.Vector({
		                loader: function loader() {
		                    fetch(that.obj.url, {
		                        headers: that.getHeaders(),
		                        method: 'GET'
		                    }).then(function (response) {
		                        return (0, _ActionUtils.checkStatus)({
		                            200: function _(rep) {
		                                return rep.text();
		                            },
		                            204: function _() {
		                                return [];
		                            }
		                        }, response);
		                    }).then(function () {
		                        var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
		                        var feature = that.kmlFormatWater.readFeatures(response, { featureProjection: 'EPSG:3857' });
		                        feature.map(function (f) {
		                            return f.setId(that.registerFeature());
		                        });
		                        vct.addFeatures(feature);
		                    });
		                },
		                format: this.kmlFormatWater
		            });
	
		            return new _openlayers2.default.layer.Vector({
		                source: vct,
		                style: this.obj.style
		            });
		        }
		    }, {
		        key: 'getLayer',
		        value: function getLayer() {
		            return this.layer;
		        }
		    }, {
		        key: 'getPopup',
		        value: function getPopup() {
		            return this.popup;
		        }
		    }]);
	
		    return _KML;
		}(_ILayers2.default);
	
		function KML(args) {
		    return new _KML(args);
		}
	
	/***/ }),
	/* 89 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
			value: true
		});
		var checkAuth = function checkAuth(response) {
			switch (response.status) {
				case 200:
					return response;
				case 403:
					throw new Error('Not Authorized');
				case 500:
					throw new Error('Unable to contact service');
				default:
					throw new Error('Not Authorized');
			}
		};
	
		var getJson = function getJson(response) {
			return response.json();
		};
	
		var checkStatus = function checkStatus(obj, response) {
			var code = Object.keys(obj).find(function (element) {
				return response.status + '' === element + '';
			});
			if (!code) {
				throw new Error('Unhandled Error during fetch' + response.status);
			}
			return obj[code](response);
		};
	
		exports.checkAuth = checkAuth;
		exports.getJson = getJson;
		exports.checkStatus = checkStatus;
	
	/***/ }),
	/* 90 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
			value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		exports.default = OSM;
	
		var _ILayers = __webpack_require__(86);
	
		var _ILayers2 = _interopRequireDefault(_ILayers);
	
		var _openlayers = __webpack_require__(80);
	
		var _openlayers2 = _interopRequireDefault(_openlayers);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var _OSM = function (_Layers) {
			_inherits(_OSM, _Layers);
	
			function _OSM() {
				_classCallCheck(this, _OSM);
	
				var _this = _possibleConstructorReturn(this, (_OSM.__proto__ || Object.getPrototypeOf(_OSM)).call(this));
	
				_this.layer = _this.createLayer();
				return _this;
			}
	
			_createClass(_OSM, [{
				key: 'createLayer',
				value: function createLayer() {
					return new _openlayers2.default.layer.Tile({
						source: new _openlayers2.default.source.OSM()
					});
				}
			}, {
				key: 'getLayer',
				value: function getLayer() {
					return this.layer;
				}
			}]);
	
			return _OSM;
		}(_ILayers2.default);
	
		function OSM() {
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return new (Function.prototype.bind.apply(_OSM, [null].concat(args)))();
		}
	
	/***/ }),
	/* 91 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
			value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		exports.default = SingleStationPoint;
	
		var _ILayers = __webpack_require__(86);
	
		var _ILayers2 = _interopRequireDefault(_ILayers);
	
		var _openlayers = __webpack_require__(80);
	
		var _openlayers2 = _interopRequireDefault(_openlayers);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var _SingleStationPoint = function (_Layers) {
			_inherits(_SingleStationPoint, _Layers);
	
			function _SingleStationPoint(obj) {
				_classCallCheck(this, _SingleStationPoint);
	
				var _this = _possibleConstructorReturn(this, (_SingleStationPoint.__proto__ || Object.getPrototypeOf(_SingleStationPoint)).call(this));
	
				_this.type = obj.type;
				_this.objPoints = obj;
				_this.layer = _this.createLayer();
				return _this;
			}
	
			_createClass(_SingleStationPoint, [{
				key: 'createLayer',
				value: function createLayer() {
					var feature = this.createFeature(this.objPoints.site.site.localization.xCoordinate, this.objPoints.site.site.localization.yCoordinate, this.objPoints.type.img, this.objPoints.site.site.name, this.objPoints.site.site);
					var vectorSource = new _openlayers2.default.source.Vector({
						features: [feature]
					});
	
					return new _openlayers2.default.layer.Vector({
						source: vectorSource
					});
				}
			}, {
				key: 'getLayer',
				value: function getLayer() {
					return this.layer;
				}
			}, {
				key: 'createFeature',
				value: function createFeature(x, y, style, name, site) {
					var f = new _openlayers2.default.Feature({
						geometry: new _openlayers2.default.geom.Point(_openlayers2.default.proj.transform([+x, +y], 'EPSG:4326', 'EPSG:3857')),
						name: name
					});
					f.setId(this.registerFeature(site));
					f.setStyle(style);
					return f;
				}
			}]);
	
			return _SingleStationPoint;
		}(_ILayers2.default);
	
		function SingleStationPoint() {
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return new (Function.prototype.bind.apply(_SingleStationPoint, [null].concat(args)))();
		}
	
	/***/ }),
	/* 92 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		exports.default = SitesPoint;
	
		var _ILayers = __webpack_require__(86);
	
		var _ILayers2 = _interopRequireDefault(_ILayers);
	
		var _openlayers = __webpack_require__(80);
	
		var _openlayers2 = _interopRequireDefault(_openlayers);
	
		var _CoordinateUtils = __webpack_require__(93);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var _SitesPoint = function (_Layers) {
		    _inherits(_SitesPoint, _Layers);
	
		    function _SitesPoint(obj) {
		        _classCallCheck(this, _SitesPoint);
	
		        var _this = _possibleConstructorReturn(this, (_SitesPoint.__proto__ || Object.getPrototypeOf(_SitesPoint)).call(this));
	
		        _this.type = obj.type;
		        _this.objPoints = obj;
		        _this.popup = obj.popup;
		        _this.layer = _this.createLayer();
		        return _this;
		    }
	
		    _createClass(_SitesPoint, [{
		        key: 'createLayer',
		        value: function createLayer() {
		            var _this2 = this;
	
		            var features = this.objPoints.site.map(function (point) {
		                return _this2.createFeature(point.xCoordinate, point.yCoordinate, point.projection, _this2.objPoints.type.img, point.name, point);
		            });
	
		            var vectorSource = new _openlayers2.default.source.Vector({
		                features: features
		            });
	
		            return new _openlayers2.default.layer.Vector({
		                source: vectorSource
		            });
		        }
		    }, {
		        key: 'getLayer',
		        value: function getLayer() {
		            return this.layer;
		        }
		    }, {
		        key: 'createFeature',
		        value: function createFeature(x, y, projection, style, name, site) {
		            var center = (0, _CoordinateUtils.getWGS84Coordinate)(x, y, projection);
		            var f = new _openlayers2.default.Feature({
		                geometry: new _openlayers2.default.geom.Point(_openlayers2.default.proj.transform(center, 'EPSG:4326', 'EPSG:3857')),
		                name: name
		            });
		            f.setId(this.registerFeature(site));
		            f.setStyle(style);
		            return f;
		        }
		    }, {
		        key: 'getPopup',
		        value: function getPopup() {
		            return this.popup;
		        }
		    }]);
	
		    return _SitesPoint;
		}(_ILayers2.default);
	
		function SitesPoint() {
		    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		        args[_key] = arguments[_key];
		    }
	
		    return new (Function.prototype.bind.apply(_SitesPoint, [null].concat(args)))();
		}
	
	/***/ }),
	/* 93 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.getWGS84Coordinate = undefined;
	
		var _proj = __webpack_require__(94);
	
		var _proj2 = _interopRequireDefault(_proj);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var getWGS84Coordinate = function getWGS84Coordinate(x, y, projection) {
		    if (projection) {
		        switch (projection) {
		            case 2:
		                return (0, _proj2.default)('+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs', 'WGS84', [+x, +y]);
		            case 5:
		                return (0, _proj2.default)('+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs', 'WGS84', [+x, +y]);
		            case 26:
		                return (0, _proj2.default)('+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs', 'WGS84', [+x, +y]);
		            case 16:
		                return [+x, +y];
		            case 0:
		                return [2.4983333333333335, 46.6058333];
		            default:
		                return (0, _proj2.default)('+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs', 'WGS84', [+x, +y]);
		        }
		    }
		    // return proj4('+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs', 'WGS84', [+x, +y])
		    return (0, _proj2.default)('+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs ', 'WGS84', [+x, +y]);
		};
	
		exports.getWGS84Coordinate = getWGS84Coordinate;
	
	/***/ }),
	/* 94 */
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(1925);
	
	/***/ }),
	/* 95 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
			value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		exports.default = StationPoint;
	
		var _ILayers = __webpack_require__(86);
	
		var _ILayers2 = _interopRequireDefault(_ILayers);
	
		var _openlayers = __webpack_require__(80);
	
		var _openlayers2 = _interopRequireDefault(_openlayers);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var _StationPoint = function (_Layers) {
			_inherits(_StationPoint, _Layers);
	
			function _StationPoint(obj) {
				_classCallCheck(this, _StationPoint);
	
				var _this = _possibleConstructorReturn(this, (_StationPoint.__proto__ || Object.getPrototypeOf(_StationPoint)).call(this));
	
				_this.type = obj.type;
				_this.objPoints = obj;
				_this.popup = obj.popup;
				_this.layer = _this.createLayer();
				return _this;
			}
	
			_createClass(_StationPoint, [{
				key: 'createLayer',
				value: function createLayer() {
					var _this2 = this;
	
					console.log(this.objPoints.site);
					var features = this.objPoints.site.map(function (point) {
						return _this2.createFeature(point.latitude, point.longitude, _this2.objPoints.type.img, point.name, point);
					});
	
					var vectorSource = new _openlayers2.default.source.Vector({
						features: features
					});
	
					return new _openlayers2.default.layer.Vector({
						source: vectorSource
					});
				}
			}, {
				key: 'getLayer',
				value: function getLayer() {
					return this.layer;
				}
			}, {
				key: 'createFeature',
				value: function createFeature(x, y, style, name, site) {
					var f = new _openlayers2.default.Feature({
						geometry: new _openlayers2.default.geom.Point(_openlayers2.default.proj.transform([+x, +y], 'EPSG:4326', 'EPSG:3857')),
						name: name
					});
					f.setId(this.registerFeature(site));
					f.setStyle(style);
					return f;
				}
			}, {
				key: 'getPopup',
				value: function getPopup() {
					return this.popup;
				}
			}]);
	
			return _StationPoint;
		}(_ILayers2.default);
	
		function StationPoint() {
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return new (Function.prototype.bind.apply(_StationPoint, [null].concat(args)))();
		}
	
	/***/ }),
	/* 96 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
			value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		exports.default = WMS;
	
		var _ILayers = __webpack_require__(86);
	
		var _ILayers2 = _interopRequireDefault(_ILayers);
	
		var _openlayers = __webpack_require__(80);
	
		var _openlayers2 = _interopRequireDefault(_openlayers);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var _WMS = function (_Layers) {
			_inherits(_WMS, _Layers);
	
			function _WMS(obj) {
				_classCallCheck(this, _WMS);
	
				var _this = _possibleConstructorReturn(this, (_WMS.__proto__ || Object.getPrototypeOf(_WMS)).call(this));
	
				_this.url = obj.url;
				_this.params = obj.params;
				_this.layer = _this.createLayer();
				return _this;
			}
	
			_createClass(_WMS, [{
				key: 'createLayer',
				value: function createLayer() {
					return new _openlayers2.default.layer.Tile({
						source: new _openlayers2.default.source.TileWMS({
							url: this.url,
							params: this.params
						})
					});
				}
			}, {
				key: 'getLayer',
				value: function getLayer() {
					return this.layer;
				}
			}]);
	
			return _WMS;
		}(_ILayers2.default);
	
		function WMS() {
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return new (Function.prototype.bind.apply(_WMS, [null].concat(args)))();
		}
	
	/***/ })
	/******/ ]);

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var DOMProperty = __webpack_require__(213);
	var ReactDOMComponentFlags = __webpack_require__(959);
	
	var invariant = __webpack_require__(28);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(2052);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _reactRouterRedux = __webpack_require__(43);
	
	var _HomeConstants = __webpack_require__(53);
	
	var _isomorphicFetch = __webpack_require__(78);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _ActionUtils = __webpack_require__(112);
	
	var _AdministrationAction = __webpack_require__(61);
	
	var _AdministrationAction2 = _interopRequireDefault(_AdministrationAction);
	
	var _SelectionAction = __webpack_require__(95);
	
	var _SelectionAction2 = _interopRequireDefault(_SelectionAction);
	
	var _SitesAction = __webpack_require__(97);
	
	var _SitesAction2 = _interopRequireDefault(_SitesAction);
	
	var _DetailStationAction = __webpack_require__(540);
	
	var _DetailStationAction2 = _interopRequireDefault(_DetailStationAction);
	
	var _ApplicationConf = __webpack_require__(65);
	
	var _ApplicationConf2 = _interopRequireDefault(_ApplicationConf);
	
	var _CreditAction = __webpack_require__(376);
	
	var _CreditAction2 = _interopRequireDefault(_CreditAction);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _ToastrAction = __webpack_require__(66);
	
	var _ToastrAction2 = _interopRequireDefault(_ToastrAction);
	
	var _ToastrConstants = __webpack_require__(377);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeAction = {
		resetToastr: function resetToastr() {
			return {
				type: _HomeConstants.TOASTR_RESET
			};
		},
		setTitle: function setTitle(title) {
			return { type: _HomeConstants.TITLE, title: title };
		},
	
		errorOnFetch: function errorOnFetch(content) {
			return {
				type: _ToastrConstants.ERROR,
				message: content
			};
		},
		doneOnFetch: function doneOnFetch(content) {
			return {
				type: _ToastrConstants.SUCCESS,
				message: content
			};
		},
		receiveUser: function receiveUser(content, type) {
			return {
				type: type,
				user: content
			};
		},
		setBackPath: function setBackPath(backPath) {
			return {
				type: _HomeConstants.SET_BACKPATH,
				backPath: backPath
			};
		},
		updateFirstConnection: function updateFirstConnection(login) {
			return function (dispatch) {
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.user.updateFirstConnection(), {
					method: 'POST',
					headers: { Authorization: btoa('Basic ' + login) }
				}).then(_ActionUtils.checkAuth).then(function () {
					dispatch(HomeAction.fetchUser(login));
				}).catch(function (err) {
					dispatch(HomeAction.errorOnFetch(_simpleReactI18n2.default.error.cannotSaveInformation + err));
				});
			};
		},
	
		fetchUser: function fetchUser(login) {
			return function (dispatch) {
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.login.login(), {
					method: 'GET',
					headers: { Authorization: 'Basic ' + btoa(login) }
				}).then(_ActionUtils.checkAuth).then(_ActionUtils.getJson).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(HomeAction.receiveUser(json, _HomeConstants.RECEIVE_USER_INFORMATIONS));
					return json;
				}).then(function (jsonResult) {
					if (jsonResult) {
						dispatch(HomeAction.fetchRoles(jsonResult.login));
					}
				}).catch(function (err) {
					dispatch(HomeAction.errorOnFetch('fetchUser' + err));
				});
			};
		},
		receiveRoles: function receiveRoles(roles) {
			return {
				roles: roles,
				type: _HomeConstants.RECEIVE_USER_ROLES
			};
		},
	
		fetchRoles: function fetchRoles(login) {
			return function (dispatch) {
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.user.getRoles(login), {
					method: 'GET',
					headers: { Authorization: 'AQUADB_BE' + btoa(login) }
				}).then(_ActionUtils.checkAuth).then(_ActionUtils.getJson).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(HomeAction.receiveRoles(json));
				});
			};
		},
	
		logout: function logout() {
			return function (dispatch) {
				sessionStorage.removeItem('TOKEN');
				dispatch(_AdministrationAction2.default.resetAdministrationStore());
				dispatch(_SelectionAction2.default.resetSelection());
				dispatch(_SitesAction2.default.reset());
				dispatch(_DetailStationAction2.default.reset());
				dispatch(_CreditAction2.default.reset());
				dispatch((0, _reactRouterRedux.push)(_HomeConstants.PATH_HOME));
				dispatch(HomeAction.setTitle(undefined));
				dispatch(_ToastrAction2.default.success(_simpleReactI18n2.default.loginOutSuccess));
			};
		},
	
		updateLoginModalState: function updateLoginModalState(loginModalState) {
			return {
				loginModalState: loginModalState,
				type: _HomeConstants.RECEIVE_MODAL_LOGIN_STATE
			};
		},
		updateLoginModalActions: function updateLoginModalActions(modalActions) {
			return {
				modalActions: modalActions,
				type: _HomeConstants.RECEIVE_MODAL_ACTIONS
			};
		},
		setAction: function setAction(actions) {
			return { type: _HomeConstants.ACTIONS, actions: actions };
		}
	};
	
	exports.default = HomeAction;

/***/ },
/* 53 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
		TOASTR_ERROR: 'TOASTR_ERROR',
		TOASTR_SUCCESS: 'TOASTR_SUCCESS',
		TOASTR_RESET: 'TOASTR_RESET',
		SET_BACKPATH: 'SET_BACKPATH',
		WAIT: 'WAIT',
		RECEIVE_USER_INFORMATIONS: 'RECEIVE_USER_INFORMATIONS',
		RECEIVE_USER_ROLES: 'RECEIVE_USER_ROLES',
		RECEIVE_MODAL_LOGIN_STATE: 'RECEIVE_MODAL_LOGIN_STATE',
		RECEIVE_MODAL_ACTIONS: 'RECEIVE_MODAL_ACTIONS',
		TITLE: 'TITLE',
		ACTIONS: 'ACTIONS',
		SET_EXTERNAL_LINK: 'SET_EXTERNAL_LINK',
		PATH_HOME: '/',
		PATH_MAIN: '/main',
		PATH_SELECTION: '/myResearch',
		PATH_LOGIN: '/login',
		PATH_SIGNUP: '/signup',
		PATH_INIT_ACCOUNT: '/initAccount',
		PATH_FIND_EMAIL: '/findEmail',
		PATH_RESET_PWD: '/resetPassword',
		PATH_STATION: '/station/:id',
		PATH_POINT: 'point/',
		PATH_POINT_ID: 'point/:id/:typeId',
		PATH_ADMINISTRATION: '/administration',
		PATH_ADMINISTRATION_RESEARCH: '/administration/research',
		PATH_ADMINISTRATION_ACCOUNT: '/administration/account',
		PATH_ADMINISTRATION_MAP: '/administration/map',
		PATH_ADMINISTRATION_THEME: '/administration/theme',
		PATH_ADMINISTRATION_SOURCE: '/administration/source',
		PATH_ADMINISTRATION_CREDIT: '/administration/credit',
		PATH_RESEARCH: '/research'
	};

/***/ },
/* 54 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DtoUser = function DtoUser(obj) {
		_classCallCheck(this, DtoUser);
	
		this.login = obj.login;
		this.firstName = obj.firstName;
		this.lastName = obj.lastName;
		this.email = obj.email;
		this.mobileNumber = obj.mobileNumber;
		this.fixNumber = obj.fixNumber;
		this.address = obj.address;
		this.city = obj.city;
		this.administrator = obj.administrator;
		this.administratorUser = obj.administratorUser;
		this.firstConnection = obj.firstConnection === null ? true : obj.firstConnection;
		this.latitude = obj.latitude ? obj.latitude.toString() : undefined;
		this.longitude = obj.longitude ? obj.longitude.toString() : undefined;
		this.zoom = obj.zoom ? obj.zoom.toString() : undefined;
	};
	
	exports.default = DtoUser;

/***/ },
/* 55 */
/***/ function(module, exports) {

	/**
	 * echarts设备环境识别
	 *
	 * @desc echarts基于Canvas，纯Javascript图表库，提供直观，生动，可交互，可个性化定制的数据统计图表。
	 * @author firede[firede@firede.us]
	 * @desc thanks zepto.
	 */
	
	/* global wx */
	var env = {};
	
	if (typeof wx === 'object' && typeof wx.getSystemInfoSync === 'function') {
	  // In Weixin Application
	  env = {
	    browser: {},
	    os: {},
	    node: false,
	    wxa: true,
	    // Weixin Application
	    canvasSupported: true,
	    svgSupported: false,
	    touchEventsSupported: true,
	    domSupported: false
	  };
	} else if (typeof document === 'undefined' && typeof self !== 'undefined') {
	  // In worker
	  env = {
	    browser: {},
	    os: {},
	    node: false,
	    worker: true,
	    canvasSupported: true,
	    domSupported: false
	  };
	} else if (typeof navigator === 'undefined') {
	  // In node
	  env = {
	    browser: {},
	    os: {},
	    node: true,
	    worker: false,
	    // Assume canvas is supported
	    canvasSupported: true,
	    svgSupported: true,
	    domSupported: false
	  };
	} else {
	  env = detect(navigator.userAgent);
	}
	
	var _default = env; // Zepto.js
	// (c) 2010-2013 Thomas Fuchs
	// Zepto.js may be freely distributed under the MIT license.
	
	function detect(ua) {
	  var os = {};
	  var browser = {}; // var webkit = ua.match(/Web[kK]it[\/]{0,1}([\d.]+)/);
	  // var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
	  // var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
	  // var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
	  // var iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
	  // var webos = ua.match(/(webOS|hpwOS)[\s\/]([\d.]+)/);
	  // var touchpad = webos && ua.match(/TouchPad/);
	  // var kindle = ua.match(/Kindle\/([\d.]+)/);
	  // var silk = ua.match(/Silk\/([\d._]+)/);
	  // var blackberry = ua.match(/(BlackBerry).*Version\/([\d.]+)/);
	  // var bb10 = ua.match(/(BB10).*Version\/([\d.]+)/);
	  // var rimtabletos = ua.match(/(RIM\sTablet\sOS)\s([\d.]+)/);
	  // var playbook = ua.match(/PlayBook/);
	  // var chrome = ua.match(/Chrome\/([\d.]+)/) || ua.match(/CriOS\/([\d.]+)/);
	
	  var firefox = ua.match(/Firefox\/([\d.]+)/); // var safari = webkit && ua.match(/Mobile\//) && !chrome;
	  // var webview = ua.match(/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/) && !chrome;
	
	  var ie = ua.match(/MSIE\s([\d.]+)/) // IE 11 Trident/7.0; rv:11.0
	  || ua.match(/Trident\/.+?rv:(([\d.]+))/);
	  var edge = ua.match(/Edge\/([\d.]+)/); // IE 12 and 12+
	
	  var weChat = /micromessenger/i.test(ua); // Todo: clean this up with a better OS/browser seperation:
	  // - discern (more) between multiple browsers on android
	  // - decide if kindle fire in silk mode is android or not
	  // - Firefox on Android doesn't specify the Android version
	  // - possibly devide in os, device and browser hashes
	  // if (browser.webkit = !!webkit) browser.version = webkit[1];
	  // if (android) os.android = true, os.version = android[2];
	  // if (iphone && !ipod) os.ios = os.iphone = true, os.version = iphone[2].replace(/_/g, '.');
	  // if (ipad) os.ios = os.ipad = true, os.version = ipad[2].replace(/_/g, '.');
	  // if (ipod) os.ios = os.ipod = true, os.version = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
	  // if (webos) os.webos = true, os.version = webos[2];
	  // if (touchpad) os.touchpad = true;
	  // if (blackberry) os.blackberry = true, os.version = blackberry[2];
	  // if (bb10) os.bb10 = true, os.version = bb10[2];
	  // if (rimtabletos) os.rimtabletos = true, os.version = rimtabletos[2];
	  // if (playbook) browser.playbook = true;
	  // if (kindle) os.kindle = true, os.version = kindle[1];
	  // if (silk) browser.silk = true, browser.version = silk[1];
	  // if (!silk && os.android && ua.match(/Kindle Fire/)) browser.silk = true;
	  // if (chrome) browser.chrome = true, browser.version = chrome[1];
	
	  if (firefox) {
	    browser.firefox = true;
	    browser.version = firefox[1];
	  } // if (safari && (ua.match(/Safari/) || !!os.ios)) browser.safari = true;
	  // if (webview) browser.webview = true;
	
	
	  if (ie) {
	    browser.ie = true;
	    browser.version = ie[1];
	  }
	
	  if (edge) {
	    browser.edge = true;
	    browser.version = edge[1];
	  } // It is difficult to detect WeChat in Win Phone precisely, because ua can
	  // not be set on win phone. So we do not consider Win Phone.
	
	
	  if (weChat) {
	    browser.weChat = true;
	  } // os.tablet = !!(ipad || playbook || (android && !ua.match(/Mobile/)) ||
	  //     (firefox && ua.match(/Tablet/)) || (ie && !ua.match(/Phone/) && ua.match(/Touch/)));
	  // os.phone  = !!(!os.tablet && !os.ipod && (android || iphone || webos ||
	  //     (chrome && ua.match(/Android/)) || (chrome && ua.match(/CriOS\/([\d.]+)/)) ||
	  //     (firefox && ua.match(/Mobile/)) || (ie && ua.match(/Touch/))));
	
	
	  return {
	    browser: browser,
	    os: os,
	    node: false,
	    // 原生canvas支持，改极端点了
	    // canvasSupported : !(browser.ie && parseFloat(browser.version) < 9)
	    canvasSupported: !!document.createElement('canvas').getContext,
	    svgSupported: typeof SVGRect !== 'undefined',
	    // works on most browsers
	    // IE10/11 does not support touch event, and MS Edge supports them but not by
	    // default, so we dont check navigator.maxTouchPoints for them here.
	    touchEventsSupported: 'ontouchstart' in window && !browser.ie && !browser.edge,
	    // <http://caniuse.com/#search=pointer%20event>.
	    pointerEventsSupported: // (1) Firefox supports pointer but not by default, only MS browsers are reliable on pointer
	    // events currently. So we dont use that on other browsers unless tested sufficiently.
	    // For example, in iOS 13 Mobile Chromium 78, if the touching behavior starts page
	    // scroll, the `pointermove` event can not be fired any more. That will break some
	    // features like "pan horizontally to move something and pan vertically to page scroll".
	    // The horizontal pan probably be interrupted by the casually triggered page scroll.
	    // (2) Although IE 10 supports pointer event, it use old style and is different from the
	    // standard. So we exclude that. (IE 10 is hardly used on touch device)
	    'onpointerdown' in window && (browser.edge || browser.ie && browser.version >= 11),
	    // passiveSupported: detectPassiveSupport()
	    domSupported: typeof document !== 'undefined'
	  };
	} // See https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
	// function detectPassiveSupport() {
	//     // Test via a getter in the options object to see if the passive property is accessed
	//     var supportsPassive = false;
	//     try {
	//         var opts = Object.defineProperty({}, 'passive', {
	//             get: function() {
	//                 supportsPassive = true;
	//             }
	//         });
	//         window.addEventListener('testPassive', function() {}, opts);
	//     } catch (e) {
	//     }
	//     return supportsPassive;
	// }
	
	
	module.exports = _default;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _openlayers = __webpack_require__(110);
	
	var _openlayers2 = _interopRequireDefault(_openlayers);
	
	var _map_quality = __webpack_require__(2233);
	
	var _map_quality2 = _interopRequireDefault(_map_quality);
	
	var _map_pluvio = __webpack_require__(2231);
	
	var _map_pluvio2 = _interopRequireDefault(_map_pluvio);
	
	var _map_piezo = __webpack_require__(2230);
	
	var _map_piezo2 = _interopRequireDefault(_map_piezo);
	
	var _map_hydro = __webpack_require__(2226);
	
	var _map_hydro2 = _interopRequireDefault(_map_hydro);
	
	var _map_maregraphe = __webpack_require__(2229);
	
	var _map_maregraphe2 = _interopRequireDefault(_map_maregraphe);
	
	var _map_industrial_site = __webpack_require__(2227);
	
	var _map_industrial_site2 = _interopRequireDefault(_map_industrial_site);
	
	var _map_Assainissement = __webpack_require__(2223);
	
	var _map_Assainissement2 = _interopRequireDefault(_map_Assainissement);
	
	var _map_polluted_soil = __webpack_require__(2232);
	
	var _map_polluted_soil2 = _interopRequireDefault(_map_polluted_soil);
	
	var _mapmarker_blue_default = __webpack_require__(2234);
	
	var _mapmarker_blue_default2 = _interopRequireDefault(_mapmarker_blue_default);
	
	var _map_sampling_point = __webpack_require__(1061);
	
	var _map_sampling_point2 = _interopRequireDefault(_map_sampling_point);
	
	var _map_mairie = __webpack_require__(2228);
	
	var _map_mairie2 = _interopRequireDefault(_map_mairie);
	
	var _map_fishing_place = __webpack_require__(2225);
	
	var _map_fishing_place2 = _interopRequireDefault(_map_fishing_place);
	
	var _map_cavity = __webpack_require__(2224);
	
	var _map_cavity2 = _interopRequireDefault(_map_cavity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var singularPlural = function singularPlural(number) {
		var value = arguments.length > 1 && arguments[1] !== _mapmarker_blue_default2.default ? arguments[1] : 's';
	
		if (number > 1) {
			return value;
		}
		return '';
	};
	//import agricoleExploitation from '../../../public/pictures/markers/map_agricultureExploitation.svg'
	
	//import pluviometer from '../../../public/pictures/markers/map_pluvio.png'
	
	
	var createIconStyle = function createIconStyle(imgsrc) {
		return new _openlayers2.default.style.Style({
			image: new _openlayers2.default.style.Icon({
				scale: 0.15,
				anchor: [0.5, 0.5],
				src: imgsrc
			}),
			zIndex: 1
		});
	};
	
	var createIconStyleHover = function createIconStyleHover(imgsrc) {
		var result = new _openlayers2.default.style.Style({
			image: new _openlayers2.default.style.Icon({
				scale: 0.35,
				anchor: [0.5, 0.75],
				src: imgsrc
			}),
			zIndex: 99
		});
		result.setZIndex(99);
		return result;
	};
	
	exports.default = {
		getType: function getType(typeId, types) {
			var dataFilter = types.find(function (type) {
				return type.id == typeId;
			});
			if (dataFilter && dataFilter.parameter && this[dataFilter.parameter]) {
				return this[dataFilter.parameter];
			}
			return this.UNDEFINED;
		},
		getTypeByParameter: function getTypeByParameter(parameter, types) {
			var dataFilter = types.find(function (type) {
				return type.parameter == parameter;
			});
			return dataFilter ? dataFilter : _mapmarker_blue_default2.default;
		},
		QUALITOMETER: {
			img: createIconStyle(_map_quality2.default),
			name: function name(nb) {
				return 'Qualitomètre' + singularPlural(nb) + ' souterrain' + singularPlural(nb);
			},
			title: 'Qualitomètre souterrain',
			type: 'QUALITOMETER',
			icon: _map_quality2.default,
			dataType: ['QUALITOMETER_ANALYSIS']
		},
		QUALITOMETER_SURFACE: {
			img: createIconStyle(_map_quality2.default),
			name: function name(nb) {
				return 'Qualitomètre' + singularPlural(nb) + ' de surface';
			},
			title: 'Qualitomètre surface',
			type: 'QUALITOMETER_SURFACE',
			icon: _map_quality2.default,
			dataType: ['QUALITOMETER_ANALYSIS', 'QUALITOMETER_ANALYSIS_HYDROMORPHO', 'QUALITOMETER_ANALYSIS_HYDROBIO']
	
		},
		PLUVIOMETER: {
			img: createIconStyle(_map_pluvio2.default),
			name: function name(nb) {
				return 'Station' + singularPlural(nb) + ' météo';
			},
			title: 'Station météo',
			type: 'PLUVIOMETER',
			icon: _map_pluvio2.default,
			dataType: ['PLUVIOMETER_RAIN', 'PLUVIOMETER_NEBULOSITE', 'PLUVIOMETER_PRESSION', 'PLUVIOMETER_WIND_FORCE', 'PLUVIOMETER_WIND_DIRECTION', 'PLUVIOMETER_SNOW', 'PLUVIOMETER_SNOW_TOTAL']
		},
		PIEZOMETER: {
			img: createIconStyle(_map_piezo2.default),
			name: function name(nb) {
				return 'Piézomètre' + singularPlural(nb);
			},
			title: 'Piézomètre',
			type: 'PIEZOMETER',
			icon: _map_piezo2.default,
			dataType: ['PIEZOMETER_MEASURE']
		},
		PIEZOMETER_REFERENCE: {
			img: createIconStyle(_map_piezo2.default),
			name: function name(nb) {
				return 'Indicateur' + singularPlural(nb) + ' sécheresse';
			},
			title: 'Piézomètre de référence (SDAGE)',
			type: 'PIEZOMETER_REFERENCE',
			icon: _map_piezo2.default,
			dataType: ['PIEZOMETER_REFERENCE_MEASURE']
		},
		HYDROLOGICAL_STATION: {
			img: createIconStyle(_map_hydro2.default),
			name: function name(nb) {
				return 'Station' + singularPlural(nb) + ' hydrométrique' + singularPlural(nb);
			},
			title: 'Station hydrométrique',
			type: 'HYDROLOGICAL_STATION',
			icon: _map_hydro2.default,
			dataType: ['HYDROLOGICAL_DEBIT', 'HYDROLOGICAL_HEIGHT']
		},
		HYDROLOGICAL_SITE: {
			img: createIconStyle(_map_hydro2.default),
			name: function name(nb) {
				return 'Site ' + singularPlural(nb) + ' hydrométrique' + singularPlural(nb);
			},
			title: 'Site hydrométrique',
			type: 'HYDROLOGICAL_SITE',
			icon: _map_hydro2.default,
			dataType: []
		},
		HYDROLOGICAL_INDICATOR: {
			img: createIconStyle(_map_hydro2.default),
			name: function name(nb) {
				return 'Station' + singularPlural(nb) + ' hydrométrique' + singularPlural(nb) + ' de référence';
			},
			title: 'Station hydrométrique de référence (SDAGE)',
			type: 'HYDROLOGICAL_INDICATOR',
			icon: _map_hydro2.default,
			dataType: []
		},
		SEAPORT: {
			img: createIconStyle(_map_maregraphe2.default),
			name: function name(nb) {
				return 'Marégraphe' + singularPlural(nb);
			},
			title: 'Marégraphe',
			type: 'SEAPORT',
			icon: _map_maregraphe2.default,
			dataType: ['SEAPORT_MEASURE']
		},
		INDUSTRIAL_SITE: {
			img: createIconStyle(_map_industrial_site2.default),
			name: function name(nb) {
				return 'Site' + singularPlural(nb) + ' industriel' + singularPlural(nb);
			},
			title: 'Site industriel',
			type: 'INDUSTRIAL_SITE',
			icon: _map_industrial_site2.default,
			dataType: ['INDUSTRIAL_SITE_NUMBER']
		},
		OBSTACLE_FLOW: {
			img: createIconStyle(_map_maregraphe2.default),
			name: function name(nb) {
				return 'Obstacle' + singularPlural(nb) + ' à l\'écoulement';
			},
			title: 'Obstacle à l\'écoulement',
			type: 'OBSTACLE_FLOW',
			icon: _map_maregraphe2.default,
			dataType: ['OBSTACLE_FLOW_STATION_NUMBER']
		},
		TREATMENT_STATION: {
			img: createIconStyle(_map_Assainissement2.default),
			name: function name(nb) {
				return 'Station' + singularPlural(nb) + ' d\'épuration';
			},
			title: 'Station  d\'épuration',
			type: 'TREATMENT_STATION',
			icon: _map_Assainissement2.default,
			dataType: ['TREATMENT_STATION_NUMBER']
		},
	
		POLLUTED_SOIL: {
			img: createIconStyle(_map_polluted_soil2.default),
			name: function name(nb) {
				return 'Sol' + singularPlural(nb) + ' pollué' + singularPlural(nb);
			},
			title: 'Sol pollué',
			type: 'POLLUTED_SOIL',
			icon: _map_polluted_soil2.default,
			dataType: ['POLLUTED_SOIL_NUMBER']
		},
		DEPOSIT: {
			img: createIconStyle(_mapmarker_blue_default2.default),
			name: function name(nb) {
				return 'Gisement' + singularPlural(nb);
			},
			title: 'Gisement',
			type: 'DEPOSIT',
			icon: _mapmarker_blue_default2.default,
			dataType: []
		},
		SAMPLING_SURFACE_POINT: {
			img: createIconStyle(_map_sampling_point2.default),
			name: function name(nb) {
				return 'Point' + singularPlural(nb) + 'de prélèvement';
			},
			title: 'Point de prélèvement',
			type: 'SAMPLING_SURFACE_POINT',
			icon: _map_sampling_point2.default,
			dataType: []
	
		},
		CITY: {
			img: createIconStyle(_map_mairie2.default),
			name: function name(nb) {
				return 'Donnée' + singularPlural(nb) + ' communale' + singularPlural(nb);
			},
			title: 'Donnée communale',
			type: 'CITY',
			icon: _map_mairie2.default,
			dataType: ['CITY_NUMBER']
	
		},
		FISHING_PLACE: {
			img: createIconStyle(_map_fishing_place2.default),
			name: function name(nb) {
				return 'Lieu' + singularPlural(nb, 'x') + ' de pêche';
			},
			title: 'Lieu de pêche',
			type: 'FISHING_PLACE',
			icon: _map_fishing_place2.default,
			dataType: ['FISHING_PLACE']
	
		},
		CAVITY: {
			img: createIconStyle(_map_cavity2.default),
			name: function name(nb) {
				return 'Cavité' + singularPlural(nb, 's') + ' souterraine' + singularPlural(nb, 's');
			},
			title: 'Cavité souterraine',
			type: 'CAVITY',
			icon: _map_cavity2.default,
			dataType: ['CAVITY']
	
		},
		UNDEFINED: {
			img: createIconStyle(_mapmarker_blue_default2.default),
			name: function name() {
				return 'Pas de type défini';
			},
			title: 'Inconnu',
			type: 'UNDEFINED',
			icon: _mapmarker_blue_default2.default,
			dataType: []
		},
		createIconStyleHover: createIconStyleHover
	};

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var Model = __webpack_require__(48);
	
	var componentUtil = __webpack_require__(268);
	
	var _clazz = __webpack_require__(124);
	
	var enableClassManagement = _clazz.enableClassManagement;
	var parseClassType = _clazz.parseClassType;
	
	var _model = __webpack_require__(24);
	
	var makeInner = _model.makeInner;
	
	var layout = __webpack_require__(36);
	
	var boxLayoutMixin = __webpack_require__(1695);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Component model
	 *
	 * @module echarts/model/Component
	 */
	var inner = makeInner();
	/**
	 * @alias module:echarts/model/Component
	 * @constructor
	 * @param {Object} option
	 * @param {module:echarts/model/Model} parentModel
	 * @param {module:echarts/model/Model} ecModel
	 */
	
	var ComponentModel = Model.extend({
	  type: 'component',
	
	  /**
	   * @readOnly
	   * @type {string}
	   */
	  id: '',
	
	  /**
	   * Because simplified concept is probably better, series.name (or component.name)
	   * has been having too many resposibilities:
	   * (1) Generating id (which requires name in option should not be modified).
	   * (2) As an index to mapping series when merging option or calling API (a name
	   * can refer to more then one components, which is convinient is some case).
	   * (3) Display.
	   * @readOnly
	   */
	  name: '',
	
	  /**
	   * @readOnly
	   * @type {string}
	   */
	  mainType: '',
	
	  /**
	   * @readOnly
	   * @type {string}
	   */
	  subType: '',
	
	  /**
	   * @readOnly
	   * @type {number}
	   */
	  componentIndex: 0,
	
	  /**
	   * @type {Object}
	   * @protected
	   */
	  defaultOption: null,
	
	  /**
	   * @type {module:echarts/model/Global}
	   * @readOnly
	   */
	  ecModel: null,
	
	  /**
	   * key: componentType
	   * value:  Component model list, can not be null.
	   * @type {Object.<string, Array.<module:echarts/model/Model>>}
	   * @readOnly
	   */
	  dependentModels: [],
	
	  /**
	   * @type {string}
	   * @readOnly
	   */
	  uid: null,
	
	  /**
	   * Support merge layout params.
	   * Only support 'box' now (left/right/top/bottom/width/height).
	   * @type {string|Object} Object can be {ignoreSize: true}
	   * @readOnly
	   */
	  layoutMode: null,
	  $constructor: function (option, parentModel, ecModel, extraOpt) {
	    Model.call(this, option, parentModel, ecModel, extraOpt);
	    this.uid = componentUtil.getUID('ec_cpt_model');
	  },
	  init: function (option, parentModel, ecModel, extraOpt) {
	    this.mergeDefaultAndTheme(option, ecModel);
	  },
	  mergeDefaultAndTheme: function (option, ecModel) {
	    var layoutMode = this.layoutMode;
	    var inputPositionParams = layoutMode ? layout.getLayoutParams(option) : {};
	    var themeModel = ecModel.getTheme();
	    zrUtil.merge(option, themeModel.get(this.mainType));
	    zrUtil.merge(option, this.getDefaultOption());
	
	    if (layoutMode) {
	      layout.mergeLayoutParam(option, inputPositionParams, layoutMode);
	    }
	  },
	  mergeOption: function (option, extraOpt) {
	    zrUtil.merge(this.option, option, true);
	    var layoutMode = this.layoutMode;
	
	    if (layoutMode) {
	      layout.mergeLayoutParam(this.option, option, layoutMode);
	    }
	  },
	  // Hooker after init or mergeOption
	  optionUpdated: function (newCptOption, isInit) {},
	  getDefaultOption: function () {
	    var fields = inner(this);
	
	    if (!fields.defaultOption) {
	      var optList = [];
	      var Class = this.constructor;
	
	      while (Class) {
	        var opt = Class.prototype.defaultOption;
	        opt && optList.push(opt);
	        Class = Class.superClass;
	      }
	
	      var defaultOption = {};
	
	      for (var i = optList.length - 1; i >= 0; i--) {
	        defaultOption = zrUtil.merge(defaultOption, optList[i], true);
	      }
	
	      fields.defaultOption = defaultOption;
	    }
	
	    return fields.defaultOption;
	  },
	  getReferringComponents: function (mainType) {
	    return this.ecModel.queryComponents({
	      mainType: mainType,
	      index: this.get(mainType + 'Index', true),
	      id: this.get(mainType + 'Id', true)
	    });
	  }
	}); // Reset ComponentModel.extend, add preConstruct.
	// clazzUtil.enableClassExtend(
	//     ComponentModel,
	//     function (option, parentModel, ecModel, extraOpt) {
	//         // Set dependentModels, componentIndex, name, id, mainType, subType.
	//         zrUtil.extend(this, extraOpt);
	//         this.uid = componentUtil.getUID('componentModel');
	//         // this.setReadOnly([
	//         //     'type', 'id', 'uid', 'name', 'mainType', 'subType',
	//         //     'dependentModels', 'componentIndex'
	//         // ]);
	//     }
	// );
	// Add capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.
	
	enableClassManagement(ComponentModel, {
	  registerWhenExtend: true
	});
	componentUtil.enableSubTypeDefaulter(ComponentModel); // Add capability of ComponentModel.topologicalTravel.
	
	componentUtil.enableTopologicalTravel(ComponentModel, getDependencies);
	
	function getDependencies(componentType) {
	  var deps = [];
	  zrUtil.each(ComponentModel.getClassesByMainType(componentType), function (Clazz) {
	    deps = deps.concat(Clazz.prototype.dependencies || []);
	  }); // Ensure main type.
	
	  deps = zrUtil.map(deps, function (type) {
	    return parseClassType(type).main;
	  }); // Hack dataset for convenience.
	
	  if (componentType !== 'dataset' && zrUtil.indexOf(deps, 'dataset') <= 0) {
	    deps.unshift('dataset');
	  }
	
	  return deps;
	}
	
	zrUtil.mixin(ComponentModel, boxLayoutMixin);
	var _default = ComponentModel;
	module.exports = _default;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(3);
	
	var env = __webpack_require__(55);
	
	var _format = __webpack_require__(40);
	
	var formatTime = _format.formatTime;
	var encodeHTML = _format.encodeHTML;
	var addCommas = _format.addCommas;
	var getTooltipMarker = _format.getTooltipMarker;
	
	var modelUtil = __webpack_require__(24);
	
	var ComponentModel = __webpack_require__(57);
	
	var colorPaletteMixin = __webpack_require__(750);
	
	var dataFormatMixin = __webpack_require__(475);
	
	var _layout = __webpack_require__(36);
	
	var getLayoutParams = _layout.getLayoutParams;
	var mergeLayoutParam = _layout.mergeLayoutParam;
	
	var _task = __webpack_require__(476);
	
	var createTask = _task.createTask;
	
	var _sourceHelper = __webpack_require__(123);
	
	var prepareSource = _sourceHelper.prepareSource;
	var getSource = _sourceHelper.getSource;
	
	var _dataProvider = __webpack_require__(167);
	
	var retrieveRawValue = _dataProvider.retrieveRawValue;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = modelUtil.makeInner();
	var SeriesModel = ComponentModel.extend({
	  type: 'series.__base__',
	
	  /**
	   * @readOnly
	   */
	  seriesIndex: 0,
	  // coodinateSystem will be injected in the echarts/CoordinateSystem
	  coordinateSystem: null,
	
	  /**
	   * @type {Object}
	   * @protected
	   */
	  defaultOption: null,
	
	  /**
	   * legend visual provider to the legend component
	   * @type {Object}
	   */
	  // PENDING
	  legendVisualProvider: null,
	
	  /**
	   * Access path of color for visual
	   */
	  visualColorAccessPath: 'itemStyle.color',
	
	  /**
	   * Access path of borderColor for visual
	   */
	  visualBorderColorAccessPath: 'itemStyle.borderColor',
	
	  /**
	   * Support merge layout params.
	   * Only support 'box' now (left/right/top/bottom/width/height).
	   * @type {string|Object} Object can be {ignoreSize: true}
	   * @readOnly
	   */
	  layoutMode: null,
	  init: function (option, parentModel, ecModel, extraOpt) {
	    /**
	     * @type {number}
	     * @readOnly
	     */
	    this.seriesIndex = this.componentIndex;
	    this.dataTask = createTask({
	      count: dataTaskCount,
	      reset: dataTaskReset
	    });
	    this.dataTask.context = {
	      model: this
	    };
	    this.mergeDefaultAndTheme(option, ecModel);
	    prepareSource(this);
	    var data = this.getInitialData(option, ecModel);
	    wrapData(data, this);
	    this.dataTask.context.data = data;
	
	    /**
	     * @type {module:echarts/data/List|module:echarts/data/Tree|module:echarts/data/Graph}
	     * @private
	     */
	    inner(this).dataBeforeProcessed = data; // If we reverse the order (make data firstly, and then make
	    // dataBeforeProcessed by cloneShallow), cloneShallow will
	    // cause data.graph.data !== data when using
	    // module:echarts/data/Graph or module:echarts/data/Tree.
	    // See module:echarts/data/helper/linkList
	    // Theoretically, it is unreasonable to call `seriesModel.getData()` in the model
	    // init or merge stage, because the data can be restored. So we do not `restoreData`
	    // and `setData` here, which forbids calling `seriesModel.getData()` in this stage.
	    // Call `seriesModel.getRawData()` instead.
	    // this.restoreData();
	
	    autoSeriesName(this);
	  },
	
	  /**
	   * Util for merge default and theme to option
	   * @param  {Object} option
	   * @param  {module:echarts/model/Global} ecModel
	   */
	  mergeDefaultAndTheme: function (option, ecModel) {
	    var layoutMode = this.layoutMode;
	    var inputPositionParams = layoutMode ? getLayoutParams(option) : {}; // Backward compat: using subType on theme.
	    // But if name duplicate between series subType
	    // (for example: parallel) add component mainType,
	    // add suffix 'Series'.
	
	    var themeSubType = this.subType;
	
	    if (ComponentModel.hasClass(themeSubType)) {
	      themeSubType += 'Series';
	    }
	
	    zrUtil.merge(option, ecModel.getTheme().get(this.subType));
	    zrUtil.merge(option, this.getDefaultOption()); // Default label emphasis `show`
	
	    modelUtil.defaultEmphasis(option, 'label', ['show']);
	    this.fillDataTextStyle(option.data);
	
	    if (layoutMode) {
	      mergeLayoutParam(option, inputPositionParams, layoutMode);
	    }
	  },
	  mergeOption: function (newSeriesOption, ecModel) {
	    // this.settingTask.dirty();
	    newSeriesOption = zrUtil.merge(this.option, newSeriesOption, true);
	    this.fillDataTextStyle(newSeriesOption.data);
	    var layoutMode = this.layoutMode;
	
	    if (layoutMode) {
	      mergeLayoutParam(this.option, newSeriesOption, layoutMode);
	    }
	
	    prepareSource(this);
	    var data = this.getInitialData(newSeriesOption, ecModel);
	    wrapData(data, this);
	    this.dataTask.dirty();
	    this.dataTask.context.data = data;
	    inner(this).dataBeforeProcessed = data;
	    autoSeriesName(this);
	  },
	  fillDataTextStyle: function (data) {
	    // Default data label emphasis `show`
	    // FIXME Tree structure data ?
	    // FIXME Performance ?
	    if (data && !zrUtil.isTypedArray(data)) {
	      var props = ['show'];
	
	      for (var i = 0; i < data.length; i++) {
	        if (data[i] && data[i].label) {
	          modelUtil.defaultEmphasis(data[i], 'label', props);
	        }
	      }
	    }
	  },
	
	  /**
	   * Init a data structure from data related option in series
	   * Must be overwritten
	   */
	  getInitialData: function () {},
	
	  /**
	   * Append data to list
	   * @param {Object} params
	   * @param {Array|TypedArray} params.data
	   */
	  appendData: function (params) {
	    // FIXME ???
	    // (1) If data from dataset, forbidden append.
	    // (2) support append data of dataset.
	    var data = this.getRawData();
	    data.appendData(params.data);
	  },
	
	  /**
	   * Consider some method like `filter`, `map` need make new data,
	   * We should make sure that `seriesModel.getData()` get correct
	   * data in the stream procedure. So we fetch data from upstream
	   * each time `task.perform` called.
	   * @param {string} [dataType]
	   * @return {module:echarts/data/List}
	   */
	  getData: function (dataType) {
	    var task = getCurrentTask(this);
	
	    if (task) {
	      var data = task.context.data;
	      return dataType == null ? data : data.getLinkedData(dataType);
	    } else {
	      // When series is not alive (that may happen when click toolbox
	      // restore or setOption with not merge mode), series data may
	      // be still need to judge animation or something when graphic
	      // elements want to know whether fade out.
	      return inner(this).data;
	    }
	  },
	
	  /**
	   * @param {module:echarts/data/List} data
	   */
	  setData: function (data) {
	    var task = getCurrentTask(this);
	
	    if (task) {
	      var context = task.context; // Consider case: filter, data sample.
	
	      if (context.data !== data && task.modifyOutputEnd) {
	        task.setOutputEnd(data.count());
	      }
	
	      context.outputData = data; // Caution: setData should update context.data,
	      // Because getData may be called multiply in a
	      // single stage and expect to get the data just
	      // set. (For example, AxisProxy, x y both call
	      // getData and setDate sequentially).
	      // So the context.data should be fetched from
	      // upstream each time when a stage starts to be
	      // performed.
	
	      if (task !== this.dataTask) {
	        context.data = data;
	      }
	    }
	
	    inner(this).data = data;
	  },
	
	  /**
	   * @see {module:echarts/data/helper/sourceHelper#getSource}
	   * @return {module:echarts/data/Source} source
	   */
	  getSource: function () {
	    return getSource(this);
	  },
	
	  /**
	   * Get data before processed
	   * @return {module:echarts/data/List}
	   */
	  getRawData: function () {
	    return inner(this).dataBeforeProcessed;
	  },
	
	  /**
	   * Get base axis if has coordinate system and has axis.
	   * By default use coordSys.getBaseAxis();
	   * Can be overrided for some chart.
	   * @return {type} description
	   */
	  getBaseAxis: function () {
	    var coordSys = this.coordinateSystem;
	    return coordSys && coordSys.getBaseAxis && coordSys.getBaseAxis();
	  },
	  // FIXME
	
	  /**
	   * Default tooltip formatter
	   *
	   * @param {number} dataIndex
	   * @param {boolean} [multipleSeries=false]
	   * @param {number} [dataType]
	   * @param {string} [renderMode='html'] valid values: 'html' and 'richText'.
	   *                                     'html' is used for rendering tooltip in extra DOM form, and the result
	   *                                     string is used as DOM HTML content.
	   *                                     'richText' is used for rendering tooltip in rich text form, for those where
	   *                                     DOM operation is not supported.
	   * @return {Object} formatted tooltip with `html` and `markers`
	   */
	  formatTooltip: function (dataIndex, multipleSeries, dataType, renderMode) {
	    var series = this;
	    renderMode = renderMode || 'html';
	    var newLine = renderMode === 'html' ? '<br/>' : '\n';
	    var isRichText = renderMode === 'richText';
	    var markers = {};
	    var markerId = 0;
	
	    function formatArrayValue(value) {
	      // ??? TODO refactor these logic.
	      // check: category-no-encode-has-axis-data in dataset.html
	      var vertially = zrUtil.reduce(value, function (vertially, val, idx) {
	        var dimItem = data.getDimensionInfo(idx);
	        return vertially |= dimItem && dimItem.tooltip !== false && dimItem.displayName != null;
	      }, 0);
	      var result = [];
	      tooltipDims.length ? zrUtil.each(tooltipDims, function (dim) {
	        setEachItem(retrieveRawValue(data, dataIndex, dim), dim);
	      }) // By default, all dims is used on tooltip.
	      : zrUtil.each(value, setEachItem);
	
	      function setEachItem(val, dim) {
	        var dimInfo = data.getDimensionInfo(dim); // If `dimInfo.tooltip` is not set, show tooltip.
	
	        if (!dimInfo || dimInfo.otherDims.tooltip === false) {
	          return;
	        }
	
	        var dimType = dimInfo.type;
	        var markName = 'sub' + series.seriesIndex + 'at' + markerId;
	        var dimHead = getTooltipMarker({
	          color: color,
	          type: 'subItem',
	          renderMode: renderMode,
	          markerId: markName
	        });
	        var dimHeadStr = typeof dimHead === 'string' ? dimHead : dimHead.content;
	        var valStr = (vertially ? dimHeadStr + encodeHTML(dimInfo.displayName || '-') + ': ' : '') + // FIXME should not format time for raw data?
	        encodeHTML(dimType === 'ordinal' ? val + '' : dimType === 'time' ? multipleSeries ? '' : formatTime('yyyy/MM/dd hh:mm:ss', val) : addCommas(val));
	        valStr && result.push(valStr);
	
	        if (isRichText) {
	          markers[markName] = color;
	          ++markerId;
	        }
	      }
	
	      var newLine = vertially ? isRichText ? '\n' : '<br/>' : '';
	      var content = newLine + result.join(newLine || ', ');
	      return {
	        renderMode: renderMode,
	        content: content,
	        style: markers
	      };
	    }
	
	    function formatSingleValue(val) {
	      // return encodeHTML(addCommas(val));
	      return {
	        renderMode: renderMode,
	        content: encodeHTML(addCommas(val)),
	        style: markers
	      };
	    }
	
	    var data = this.getData();
	    var tooltipDims = data.mapDimension('defaultedTooltip', true);
	    var tooltipDimLen = tooltipDims.length;
	    var value = this.getRawValue(dataIndex);
	    var isValueArr = zrUtil.isArray(value);
	    var color = data.getItemVisual(dataIndex, 'color');
	
	    if (zrUtil.isObject(color) && color.colorStops) {
	      color = (color.colorStops[0] || {}).color;
	    }
	
	    color = color || 'transparent'; // Complicated rule for pretty tooltip.
	
	    var formattedValue = tooltipDimLen > 1 || isValueArr && !tooltipDimLen ? formatArrayValue(value) : tooltipDimLen ? formatSingleValue(retrieveRawValue(data, dataIndex, tooltipDims[0])) : formatSingleValue(isValueArr ? value[0] : value);
	    var content = formattedValue.content;
	    var markName = series.seriesIndex + 'at' + markerId;
	    var colorEl = getTooltipMarker({
	      color: color,
	      type: 'item',
	      renderMode: renderMode,
	      markerId: markName
	    });
	    markers[markName] = color;
	    ++markerId;
	    var name = data.getName(dataIndex);
	    var seriesName = this.name;
	
	    if (!modelUtil.isNameSpecified(this)) {
	      seriesName = '';
	    }
	
	    seriesName = seriesName ? encodeHTML(seriesName) + (!multipleSeries ? newLine : ': ') : '';
	    var colorStr = typeof colorEl === 'string' ? colorEl : colorEl.content;
	    var html = !multipleSeries ? seriesName + colorStr + (name ? encodeHTML(name) + ': ' + content : content) : colorStr + seriesName + content;
	    return {
	      html: html,
	      markers: markers
	    };
	  },
	
	  /**
	   * @return {boolean}
	   */
	  isAnimationEnabled: function () {
	    if (env.node) {
	      return false;
	    }
	
	    var animationEnabled = this.getShallow('animation');
	
	    if (animationEnabled) {
	      if (this.getData().count() > this.getShallow('animationThreshold')) {
	        animationEnabled = false;
	      }
	    }
	
	    return animationEnabled;
	  },
	  restoreData: function () {
	    this.dataTask.dirty();
	  },
	  getColorFromPalette: function (name, scope, requestColorNum) {
	    var ecModel = this.ecModel; // PENDING
	
	    var color = colorPaletteMixin.getColorFromPalette.call(this, name, scope, requestColorNum);
	
	    if (!color) {
	      color = ecModel.getColorFromPalette(name, scope, requestColorNum);
	    }
	
	    return color;
	  },
	
	  /**
	   * Use `data.mapDimension(coordDim, true)` instead.
	   * @deprecated
	   */
	  coordDimToDataDim: function (coordDim) {
	    return this.getRawData().mapDimension(coordDim, true);
	  },
	
	  /**
	   * Get progressive rendering count each step
	   * @return {number}
	   */
	  getProgressive: function () {
	    return this.get('progressive');
	  },
	
	  /**
	   * Get progressive rendering count each step
	   * @return {number}
	   */
	  getProgressiveThreshold: function () {
	    return this.get('progressiveThreshold');
	  },
	
	  /**
	   * Get data indices for show tooltip content. See tooltip.
	   * @abstract
	   * @param {Array.<string>|string} dim
	   * @param {Array.<number>} value
	   * @param {module:echarts/coord/single/SingleAxis} baseAxis
	   * @return {Object} {dataIndices, nestestValue}.
	   */
	  getAxisTooltipData: null,
	
	  /**
	   * See tooltip.
	   * @abstract
	   * @param {number} dataIndex
	   * @return {Array.<number>} Point of tooltip. null/undefined can be returned.
	   */
	  getTooltipPosition: null,
	
	  /**
	   * @see {module:echarts/stream/Scheduler}
	   */
	  pipeTask: null,
	
	  /**
	   * Convinient for override in extended class.
	   * @protected
	   * @type {Function}
	   */
	  preventIncremental: null,
	
	  /**
	   * @public
	   * @readOnly
	   * @type {Object}
	   */
	  pipelineContext: null
	});
	zrUtil.mixin(SeriesModel, dataFormatMixin);
	zrUtil.mixin(SeriesModel, colorPaletteMixin);
	/**
	 * MUST be called after `prepareSource` called
	 * Here we need to make auto series, especially for auto legend. But we
	 * do not modify series.name in option to avoid side effects.
	 */
	
	function autoSeriesName(seriesModel) {
	  // User specified name has higher priority, otherwise it may cause
	  // series can not be queried unexpectedly.
	  var name = seriesModel.name;
	
	  if (!modelUtil.isNameSpecified(seriesModel)) {
	    seriesModel.name = getSeriesAutoName(seriesModel) || name;
	  }
	}
	
	function getSeriesAutoName(seriesModel) {
	  var data = seriesModel.getRawData();
	  var dataDims = data.mapDimension('seriesName', true);
	  var nameArr = [];
	  zrUtil.each(dataDims, function (dataDim) {
	    var dimInfo = data.getDimensionInfo(dataDim);
	    dimInfo.displayName && nameArr.push(dimInfo.displayName);
	  });
	  return nameArr.join(' ');
	}
	
	function dataTaskCount(context) {
	  return context.model.getRawData().count();
	}
	
	function dataTaskReset(context) {
	  var seriesModel = context.model;
	  seriesModel.setData(seriesModel.getRawData().cloneShallow());
	  return dataTaskProgress;
	}
	
	function dataTaskProgress(param, context) {
	  // Avoid repead cloneShallow when data just created in reset.
	  if (context.outputData && param.end > context.outputData.count()) {
	    context.model.getRawData().cloneShallow(context.outputData);
	  }
	} // TODO refactor
	
	
	function wrapData(data, seriesModel) {
	  zrUtil.each(data.CHANGABLE_METHODS, function (methodName) {
	    data.wrapMethod(methodName, zrUtil.curry(onDataSelfChange, seriesModel));
	  });
	}
	
	function onDataSelfChange(seriesModel) {
	  var task = getCurrentTask(seriesModel);
	
	  if (task) {
	    // Consider case: filter, selectRange
	    task.setOutputEnd(this.count());
	  }
	}
	
	function getCurrentTask(seriesModel) {
	  var scheduler = (seriesModel.ecModel || {}).scheduler;
	  var pipeline = scheduler && scheduler.getPipeline(seriesModel.uid);
	
	  if (pipeline) {
	    // When pipline finished, the currrentTask keep the last
	    // task (renderTask).
	    var task = pipeline.currentTask;
	
	    if (task) {
	      var agentStubMap = task.agentStubMap;
	
	      if (agentStubMap) {
	        task = agentStubMap.get(seriesModel.uid);
	      }
	    }
	
	    return task;
	  }
	}
	
	var _default = SeriesModel;
	module.exports = _default;

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useTheme;
	
	var _styles = __webpack_require__(76);
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(241));
	
	function useTheme() {
	  var theme = (0, _styles.useTheme)() || _defaultTheme.default;
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    _react.default.useDebugValue(theme);
	  }
	
	  return theme;
	}

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(216);


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _isomorphicFetch = __webpack_require__(78);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _HomeAction = __webpack_require__(52);
	
	var _HomeAction2 = _interopRequireDefault(_HomeAction);
	
	var _lodash = __webpack_require__(15);
	
	var _AdministrationConstants = __webpack_require__(1014);
	
	var _MOCKConstants = __webpack_require__(2093);
	
	var _ApplicationConf = __webpack_require__(65);
	
	var _ApplicationConf2 = _interopRequireDefault(_ApplicationConf);
	
	var _ActionUtils = __webpack_require__(112);
	
	var _reactAquasys = __webpack_require__(49);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdministrationAction = {
		updateUser: function updateUser(login, userInformations) {
			return function (dispatch) {
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.user.saveUser(), {
					method: 'PUT',
					headers: { authorization: btoa('Basic ' + login) },
					body: JSON.stringify(userInformations)
				}).then(function () {
					dispatch(_HomeAction2.default.doneOnFetch('Vos informations ont bien été enregistrées'));
					dispatch(_HomeAction2.default.fetchUser(login));
				}).catch(function (err) {
					dispatch(_HomeAction2.default.errorOnFetch('Impossible d\'enregistrer vos informations' + err));
				});
			};
		},
		receiveDataTypeStatistics: function receiveDataTypeStatistics(dataTypeStatistics) {
			return { type: _AdministrationConstants.RECEIVE_DATA_TYPE_STATISTICS, dataTypeStatistics: dataTypeStatistics };
		},
		fetchDataTypeStatistics: function fetchDataTypeStatistics() {
			return function (dispatch) {
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.dataType.getDataTypeKeyFigures(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					}
				}).then(_ActionUtils.checkAuth).then(_ActionUtils.getJson).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(AdministrationAction.receiveDataTypeStatistics(json));
				});
			};
		},
		receiveThemes: function receiveThemes(themes) {
			return { type: _AdministrationConstants.RECEIVE_THEMES, themes: themes };
		},
		fetchThemes: function fetchThemes() {
			return function (dispatch) {
				var fullThemes = _MOCKConstants.MASTER_THEMES.map(function (o) {
					o.themes = [];
					_MOCKConstants.THEMES.forEach(function (t) {
						if (t.masterTheme === o.id) {
							t.layers = [];
							_MOCKConstants.LAYERS.forEach(function (l) {
								if ((0, _lodash.find)(l.themes, function (tId) {
									return tId === t.id;
								})) {
									t.layers.push(l);
								}
							});
							t.siteTypes = [];
							_MOCKConstants.SITE_TYPES.map(function (sT) {
								if ((0, _lodash.find)(sT.themes, function (tId) {
									return tId === t.id;
								})) {
									t.siteTypes.push(sT);
								}
							});
							o.themes.push(t);
						}
					});
					return o;
				});
				dispatch(AdministrationAction.receiveThemes(fullThemes));
			};
		},
		receiveSources: function receiveSources(sources) {
			return { type: _AdministrationConstants.RECEIVE_ALL_SOURCES, sources: sources };
		},
		fetchSources: function fetchSources() {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.referencial.getSources(), {
					method: 'GET',
					headers: {
						'Content-Type': 'application/json'
					}
				}).then(_ActionUtils.getJson).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					return dispatch(AdministrationAction.receiveSources(json));
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
		resetSelectedThemes: function resetSelectedThemes() {
			return { type: _AdministrationConstants.RESET_SELECTED_THEMES };
		},
		receiveSelectedThemes: function receiveSelectedThemes(selectedThemes) {
			return { type: _AdministrationConstants.SELECTED_THEMES, selectedThemes: selectedThemes };
		},
		selectedThemes: function selectedThemes(_selectedThemes) {
			return function (dispatch) {
				dispatch(AdministrationAction.receiveSelectedThemes(_selectedThemes));
			};
		},
		resetSelectedFilters: function resetSelectedFilters() {
			return { type: _AdministrationConstants.RESET_SELECTED_FILTERS };
		},
		selectedFilters: function selectedFilters(_selectedFilters) {
			AdministrationAction.resetSelectedFilters();
			return { type: _AdministrationConstants.SELECTED_FILTERS, selectedFilters: _selectedFilters };
		},
		resetEntry: function resetEntry() {
			return { type: _AdministrationConstants.RESET_ENTRY_FILTER };
		},
		resetAdministrationStore: function resetAdministrationStore() {
			return { type: _AdministrationConstants.RESET_ADMINISTRATION_STORE };
		},
		updateEntry: function updateEntry(filterEntry) {
			return { type: _AdministrationConstants.ENTRY_FILTER, filterEntry: filterEntry };
		},
		setLegends: function setLegends(legends) {
			return { type: _AdministrationConstants.RECEIVE_LEGENDS, legends: legends };
		},
		addLegend: function addLegend(legend) {
			return { type: _AdministrationConstants.ADD_LEGEND, legend: legend };
		},
		removeLegend: function removeLegend(legendId) {
			return { type: _AdministrationConstants.REMOVE_LEGEND, legendId: legendId };
		},
	
	
		fetchNews: function fetchNews() {
			return function (dispatch) {
				dispatch(AdministrationAction.receiveNews(_MOCKConstants.NEWS));
			};
		},
	
		updateNews: function updateNews(news) {
			return function (dispatch) {
				dispatch(AdministrationAction.readNews(news));
			};
		},
	
		readNews: function readNews(news) {
			return { type: _AdministrationConstants.READ_NEWS, news: news };
		},
		receiveNews: function receiveNews(news) {
			return { type: _AdministrationConstants.RECEIVE_NEWS, news: news };
		}
	};
	
	exports.default = AdministrationAction;

/***/ },
/* 62 */
/***/ function(module, exports) {

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	module.exports = _defineProperty;

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hexToRgb = hexToRgb;
	exports.rgbToHex = rgbToHex;
	exports.hslToRgb = hslToRgb;
	exports.decomposeColor = decomposeColor;
	exports.recomposeColor = recomposeColor;
	exports.getContrastRatio = getContrastRatio;
	exports.getLuminance = getLuminance;
	exports.emphasize = emphasize;
	exports.fade = fade;
	exports.darken = darken;
	exports.lighten = lighten;
	
	var _utils = __webpack_require__(19);
	
	/* eslint-disable no-use-before-define */
	
	/**
	 * Returns a number whose value is limited to the given range.
	 *
	 * @param {number} value The value to be clamped
	 * @param {number} min The lower boundary of the output range
	 * @param {number} max The upper boundary of the output range
	 * @returns {number} A number in the range [min, max]
	 */
	function clamp(value) {
	  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	
	  if (false) {
	    if (value < min || value > max) {
	      console.error("Material-UI: The value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "]."));
	    }
	  }
	
	  return Math.min(Math.max(min, value), max);
	}
	/**
	 * Converts a color from CSS hex format to CSS rgb format.
	 *
	 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
	 * @returns {string} A CSS rgb color string
	 */
	
	
	function hexToRgb(color) {
	  color = color.substr(1);
	  var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
	  var colors = color.match(re);
	
	  if (colors && colors[0].length === 1) {
	    colors = colors.map(function (n) {
	      return n + n;
	    });
	  }
	
	  return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function (n, index) {
	    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
	  }).join(', '), ")") : '';
	}
	
	function intToHex(int) {
	  var hex = int.toString(16);
	  return hex.length === 1 ? "0".concat(hex) : hex;
	}
	/**
	 * Converts a color from CSS rgb format to CSS hex format.
	 *
	 * @param {string} color - RGB color, i.e. rgb(n, n, n)
	 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
	 */
	
	
	function rgbToHex(color) {
	  // Idempotent
	  if (color.indexOf('#') === 0) {
	    return color;
	  }
	
	  var _decomposeColor = decomposeColor(color),
	      values = _decomposeColor.values;
	
	  return "#".concat(values.map(function (n) {
	    return intToHex(n);
	  }).join(''));
	}
	/**
	 * Converts a color from hsl format to rgb format.
	 *
	 * @param {string} color - HSL color values
	 * @returns {string} rgb color values
	 */
	
	
	function hslToRgb(color) {
	  color = decomposeColor(color);
	  var _color = color,
	      values = _color.values;
	  var h = values[0];
	  var s = values[1] / 100;
	  var l = values[2] / 100;
	  var a = s * Math.min(l, 1 - l);
	
	  var f = function f(n) {
	    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
	    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
	  };
	
	  var type = 'rgb';
	  var rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];
	
	  if (color.type === 'hsla') {
	    type += 'a';
	    rgb.push(values[3]);
	  }
	
	  return recomposeColor({
	    type: type,
	    values: rgb
	  });
	}
	/**
	 * Returns an object with the type and values of a color.
	 *
	 * Note: Does not support rgb % values.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {object} - A MUI color object: {type: string, values: number[]}
	 */
	
	
	function decomposeColor(color) {
	  // Idempotent
	  if (color.type) {
	    return color;
	  }
	
	  if (color.charAt(0) === '#') {
	    return decomposeColor(hexToRgb(color));
	  }
	
	  var marker = color.indexOf('(');
	  var type = color.substring(0, marker);
	
	  if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
	    throw new Error( false ? "Material-UI: Unsupported `".concat(color, "` color.\nWe support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().") : (0, _utils.formatMuiErrorMessage)(3, color));
	  }
	
	  var values = color.substring(marker + 1, color.length - 1).split(',');
	  values = values.map(function (value) {
	    return parseFloat(value);
	  });
	  return {
	    type: type,
	    values: values
	  };
	}
	/**
	 * Converts a color object with type and values to a string.
	 *
	 * @param {object} color - Decomposed color
	 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
	 * @param {array} color.values - [n,n,n] or [n,n,n,n]
	 * @returns {string} A CSS color string
	 */
	
	
	function recomposeColor(color) {
	  var type = color.type;
	  var values = color.values;
	
	  if (type.indexOf('rgb') !== -1) {
	    // Only convert the first 3 values to int (i.e. not alpha)
	    values = values.map(function (n, i) {
	      return i < 3 ? parseInt(n, 10) : n;
	    });
	  } else if (type.indexOf('hsl') !== -1) {
	    values[1] = "".concat(values[1], "%");
	    values[2] = "".concat(values[2], "%");
	  }
	
	  return "".concat(type, "(").concat(values.join(', '), ")");
	}
	/**
	 * Calculates the contrast ratio between two colors.
	 *
	 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
	 *
	 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} A contrast ratio value in the range 0 - 21.
	 */
	
	
	function getContrastRatio(foreground, background) {
	  var lumA = getLuminance(foreground);
	  var lumB = getLuminance(background);
	  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
	}
	/**
	 * The relative brightness of any point in a color space,
	 * normalized to 0 for darkest black and 1 for lightest white.
	 *
	 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} The relative brightness of the color in the range 0 - 1
	 */
	
	
	function getLuminance(color) {
	  color = decomposeColor(color);
	  var rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
	  rgb = rgb.map(function (val) {
	    val /= 255; // normalized
	
	    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
	  }); // Truncate at 3 digits
	
	  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
	}
	/**
	 * Darken or lighten a color, depending on its luminance.
	 * Light colors are darkened, dark colors are lightened.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	
	
	function emphasize(color) {
	  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
	  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
	}
	/**
	 * Set the absolute transparency of a color.
	 * Any existing alpha values are overwritten.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} value - value to set the alpha channel to in the range 0 -1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	
	
	function fade(color, value) {
	  color = decomposeColor(color);
	  value = clamp(value);
	
	  if (color.type === 'rgb' || color.type === 'hsl') {
	    color.type += 'a';
	  }
	
	  color.values[3] = value;
	  return recomposeColor(color);
	}
	/**
	 * Darkens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	
	
	function darken(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient);
	
	  if (color.type.indexOf('hsl') !== -1) {
	    color.values[2] *= 1 - coefficient;
	  } else if (color.type.indexOf('rgb') !== -1) {
	    for (var i = 0; i < 3; i += 1) {
	      color.values[i] *= 1 - coefficient;
	    }
	  }
	
	  return recomposeColor(color);
	}
	/**
	 * Lightens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	
	
	function lighten(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient);
	
	  if (color.type.indexOf('hsl') !== -1) {
	    color.values[2] += (100 - color.values[2]) * coefficient;
	  } else if (color.type.indexOf('rgb') !== -1) {
	    for (var i = 0; i < 3; i += 1) {
	      color.values[i] += (255 - color.values[i]) * coefficient;
	    }
	  }
	
	  return recomposeColor(color);
	}

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(132);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _basepath = __webpack_require__(180);
	
	exports.default = {
		site: {
			getSiteOfType: function getSiteOfType() {
				return _basepath.postgrestPath + 'rpc/getsiteoftype';
			}
		},
		webService: {
			ades: function ades() {
				return _basepath.adminPath + 'synchroniseAdes';
			}
		},
		referencial: {
			getUnits: function getUnits() {
				return _basepath.postgrestPath + 'sieau_chimical_units?select=code,name,symbol';
			},
			getRemarks: function getRemarks() {
				return _basepath.postgrestPath + 'sieau_remark_code?select=id,code,mnemonique';
			},
			getSupports: function getSupports() {
				return _basepath.postgrestPath + 'sieau_supports?select=code,name';
			},
			getStandardCodification: function getStandardCodification() {
				return _basepath.postgrestPath + 'gns_standard_codifications?select=dtype,code,definition';
			},
			getParameters: function getParameters() {
				return _basepath.postgrestPath + 'sieau_chimical_parameters?select=code,name';
			},
			getCities: function getCities() {
				return _basepath.postgrestPath + 'rpc/getcities';
			},
			getDepartments: function getDepartments() {
				return _basepath.postgrestPath + 'rpc/getdepartments';
			},
			getFilterTypes: function getFilterTypes() {
				return _basepath.postgrestPath + 'sieau_filter_type';
			},
			getSiteTypes: function getSiteTypes() {
				return _basepath.postgrestPath + 'gns_sites_types?select=id,parameter,definition';
			},
			getWatershed: function getWatershed() {
				return _basepath.postgrestPath + 'rpc/getsimplewatershed';
			},
			getSimpleStations: function getSimpleStations() {
				return _basepath.postgrestPath + 'rpc/getsimplestations';
			},
			getManagementWaters: function getManagementWaters() {
				return _basepath.postgrestPath + 'rpc/getmanagementwaters';
			},
			getSources: function getSources() {
				return _basepath.postgrestPath + 'sieau_source';
			},
			getIndicatorTypes: function getIndicatorTypes() {
				return _basepath.postgrestPath + 'sieau_indicator_type';
			},
			getIndicators: function getIndicators() {
				return _basepath.postgrestPath + 'sieau_drinking_sanitation_indicator';
			}
		},
		qualito: {
			getStation: function getStation(id) {
				return _basepath.adminPath + 'qualitometer/' + id;
			},
			getPickupOperation: function getPickupOperation() {
				return _basepath.postgrestPath + 'rpc/getpickupoperation';
			},
			getAnalysis: function getAnalysis() {
				return _basepath.postgrestPath + 'rpc/getanalysis';
			},
			getQualitometerKeyFigure: function getQualitometerKeyFigure() {
				return _basepath.postgrestPath + 'rpc/getqualitometerkeyfigure';
			}
		},
		station: {
			getStation: function getStation(id) {
				return _basepath.adminPath + 'station/' + id;
			},
			getNetworks: function getNetworks() {
				return _basepath.postgrestPath + 'rpc/getnetworks';
			},
			getSamplingSurfacePoints: function getSamplingSurfacePoints() {
				return _basepath.postgrestPath + 'rpc/getsamplingsurfacepoint';
			},
			export: function _export() {
				return _basepath.adminPath + 'station/export';
			},
			exportStation: function exportStation(id) {
				return _basepath.adminPath + 'station/export?station=' + id;
			}
		},
		piezo: {
			getAll: function getAll() {
				return _basepath.adminPath + 'piezometer';
			},
			getMeasure: function getMeasure() {
				return this.getAll() + '/measure';
			},
			getPiezometer: function getPiezometer() {
				return _basepath.postgrestPath + 'rpc/get';
			},
			getPiezometerMeasure: function getPiezometerMeasure() {
				return _basepath.postgrestPath + 'rpc/getpiezometermeasure';
			},
			getPiezometerMeasureMax: function getPiezometerMeasureMax(id) {
				return _basepath.adminPath + 'piezometer/' + id + '/measure?statistic=MAX';
			},
			getPiezometerMeasureMin: function getPiezometerMeasureMin(id) {
				return _basepath.adminPath + 'piezometer/' + id + '/measure?statistic=MIN';
			},
			getPiezometerMeasureMoyenne: function getPiezometerMeasureMoyenne(id) {
				return _basepath.adminPath + 'piezometer/' + id + '/measure?statistic=MOYENNE';
			},
			getPiezometerKeyFigure: function getPiezometerKeyFigure() {
				return _basepath.postgrestPath + 'rpc/getpiezometerkeyfigure';
			}
		},
		hydrometric: {
			getAll: function getAll() {
				return _basepath.adminPath + 'hydrologicalstation';
			},
			getMeasure: function getMeasure() {
				return this.getAll() + '/height';
			}
		},
		pluvio: {
			getAll: function getAll() {
				return _basepath.adminPath + 'pluviometer';
			},
			getMeasure: function getMeasure() {
				return this.getAll() + '/measure';
			}
		},
		contact: {
			post: function post() {
				return _basepath.adminPath + 'contact';
			}
		},
		applicationDescription: {
			getMetaInfomations: function getMetaInfomations() {
				return _basepath.adminPath + 'applicationDescription/metainformations';
			}
		},
		login: {
			login: function login() {
				return _basepath.aqua6boAuthPath + 'aquadb/login';
			},
			getLogin: function getLogin() {
				return _basepath.adminPath + 'login';
			}
		},
		user: {
			saveUser: function saveUser() {
				return _basepath.adminPath + 'user';
			},
			updateFirstConnection: function updateFirstConnection() {
				return _basepath.adminPath + 'user/firstConnection';
			},
			checkUserExist: function checkUserExist() {
				return _basepath.aqua6boAuthPath + 'aquadb/userAccountActivation';
			},
			checkEmailExist: function checkEmailExist() {
				return _basepath.aqua6boAuthPath + 'aquadb/updateToken';
			},
			updatePassword: function updatePassword() {
				return _basepath.aqua6boAuthPath + 'aquadb/userAccountNewPassword';
			},
			getRoles: function getRoles(login) {
				return _basepath.aqua6boAuthPath + 'aquadb/roles?login=' + login;
			}
		},
		sites: {
			getChildWatershed: function getChildWatershed() {
				return _basepath.postgrestPath + 'rpc/getwatershedchild';
			},
			getByWatershed: function getByWatershed() {
				return _basepath.postgrestPath + 'rpc/searchbywatershed';
			},
			getWatershed: function getWatershed() {
				return _basepath.postgrestPath + 'rpc/getwatershed';
			},
			getCityWatershed: function getCityWatershed() {
				return _basepath.postgrestPath + 'rpc/getcitywatershedlevel4';
			},
			getDepartmentWatershed: function getDepartmentWatershed() {
				return _basepath.postgrestPath + 'rpc/getdepartmentwatershedlevel4';
			},
			getSageWatershed: function getSageWatershed() {
				return _basepath.postgrestPath + 'rpc/getsagewatershedlevel4';
			},
			getRadiusWatershed: function getRadiusWatershed() {
				return _basepath.postgrestPath + 'rpc/getradiuswatershedlevel4';
			},
			getSimpleStationResearch: function getSimpleStationResearch() {
				return _basepath.postgrestPath + 'rpc/getsimplestation';
			},
			getSimpleStationWatershed: function getSimpleStationWatershed() {
				return _basepath.postgrestPath + 'rpc/getsimplepointwatershedlevel4';
			},
			addOrRemoveSites: function addOrRemoveSites() {
				return _basepath.adminPath + 'user/site';
			},
			getKeyFigures: function getKeyFigures() {
				return _basepath.postgrestPath + 'rpc/getkeyfigures';
			},
			getSamplingPoints: function getSamplingPoints(ids) {
				return _basepath.postgrestPath + 'sieau_sampling_surface_point?select=code,id&id=in.' + ids;
			}
		},
		city: {
			getCity: function getCity(code) {
				return _basepath.adminPath + 'city/?city=' + code;
			},
			getCitiesWithId: function getCitiesWithId(ids) {
				return _basepath.postgrestPath + 'gns_cities?select=id,name,postal_code,code&id=in.' + ids;
			},
			getIndicators: function getIndicators() {
				return _basepath.postgrestPath + 'rpc/getcityindicators';
			},
			getInformations: function getInformations() {
				return _basepath.postgrestPath + 'rpc/getcityinformations';
			}
		},
		industrialSite: {
			get: function get(id) {
				return _basepath.postgrestPath + 'sieau_industrial_site?id=eq.' + id;
			}
		},
		pollutedSoil: {
			get: function get(id) {
				return _basepath.postgrestPath + 'sieau_polluted_soil?id=eq.' + id;
			}
		},
		selection: {
			get: function get(login) {
				return _basepath.postgrestPath + 'sieau_selection?role=eq.ROLE_ADMIN_' + login;
			},
			getSelection: function getSelection(id, login) {
				return _basepath.postgrestPath + 'sieau_selection?id=eq.' + id + '&=eq.ROLE_ADMIN_' + login;
			},
			getSelectionByName: function getSelectionByName() {
				return _basepath.postgrestPath + 'rpc/getselection';
			},
			getSelectionSites: function getSelectionSites() {
				return _basepath.postgrestPath + 'rpc/getselectionsites';
			},
			getSelectionFilters: function getSelectionFilters() {
				return _basepath.postgrestPath + 'rpc/getselectionfilter';
			},
			getFilters: function getFilters() {
				return _basepath.postgrestPath + 'rpc/getselectionfiltervalue';
			},
			getExportHistory: function getExportHistory() {
				return _basepath.postgrestPath + 'rpc/getexporthistory';
			},
			getSelectionWatershed: function getSelectionWatershed() {
				return _basepath.postgrestPath + 'rpc/getselectionwatershed';
			},
			selectionsPath: function selectionsPath() {
				return _basepath.adminPath + 'selections';
			},
			selectionPath: function selectionPath(id) {
				return _basepath.adminPath + 'selection/' + id;
			},
			getSites: function getSites() {
				return _basepath.postgrestPath + 'rpc/getsimplesites';
			},
			updateExecution: function updateExecution(id) {
				return _basepath.adminPath + 'selection/' + id + '/execution';
			},
			status: function status() {
				return _basepath.postgrestPath + 'sieau_selection_status';
			},
			export: function _export(id) {
				return _basepath.adminPath + 'export/selection/' + id;
			},
			addFavorite: function addFavorite(id) {
				return _basepath.adminPath + 'selection/favorite/' + id;
			},
			removeFavorite: function removeFavorite(id) {
				return _basepath.adminPath + 'selection/removeFavorite/' + id;
			}
		},
		signup: function signup() {
			return _basepath.adminPath + 'signup';
		},
		activatePath: function activatePath() {
			return _basepath.adminPath + 'activate';
		},
		signupUrl: function signupUrl() {
			return _basepath.appPath + 'signup';
		},
		layer: {
			cityLayer: function cityLayer(code) {
				return _basepath.layerPath + 'communes/' + code + '.kml';
			},
			departmentLayer: function departmentLayer(code) {
				return _basepath.layerPath + 'departments/' + code + '.kml';
			},
			whatershedLayer: function whatershedLayer(watershedCode) {
				return _basepath.layerPath + 'masseEau/' + watershedCode + '.kml';
			},
			managementWaterLayer: function managementWaterLayer(managementWaterCode) {
				return _basepath.adminPath + 'map/managementWater/' + managementWaterCode;
			}
		},
		credit: {
			initCredit: function initCredit() {
				return _basepath.adminPath + 'credit/init';
			},
			userCredit: function userCredit() {
				return _basepath.postgrestPath + 'rpc/getusercredit';
			},
			userCreditHystory: function userCreditHystory() {
				return _basepath.postgrestPath + 'rpc/getusercredithistory';
			},
			creditType: function creditType() {
				return _basepath.postgrestPath + 'aquadb_credit_type';
			},
			creditRequest: function creditRequest() {
				return _basepath.adminPath + 'credit/request';
			}
		},
		dataType: {
			getDataTypeKeyFigures: function getDataTypeKeyFigures() {
				return _basepath.postgrestPath + 'rpc/getkeyfiguresdatatype';
			}
		},
		point: {
			getDetailPoint: function getDetailPoint() {
				return _basepath.postgrestPath + 'rpc/getdetailpoint';
			}
		},
		distance: {
			getDistance: function getDistance(xRef, yRef, xDest, yDest) {
				return 'http://maps.googleapis.com/maps/api/distancematrix/json?origins=' + yRef + ',' + xRef + '?destinations=' + yDest + ',' + xDest;
			}
		}
	};

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _ToastrConstants = __webpack_require__(377);
	
	var ToastrAction = {
		error: function error(message) {
			return {
				type: _ToastrConstants.ERROR,
				message: message
			};
		},
		info: function info(message) {
			return {
				type: _ToastrConstants.INFO,
				message: message
			};
		},
		warning: function warning(message) {
			return {
				type: _ToastrConstants.WARNING,
				message: message
			};
		},
		success: function success(message) {
			return {
				type: _ToastrConstants.SUCCESS,
				message: message
			};
		},
		reset: function reset() {
			return {
				type: _ToastrConstants.RESET_MODAL
			};
		}
	};
	
	exports.default = ToastrAction;

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getYear = exports.getDate = undefined;
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getDate = function getDate(d) {
		var date = (0, _moment2.default)(d, 'DD/MM/YYYY').isValid() ? (0, _moment2.default)(d, 'DD/MM/YYYY') : (0, _moment2.default)(d);
		if (d && date.isValid()) {
			return date.format('DD/MM/YYYY');
		}
		return '';
	};
	
	var getYear = function getYear(date) {
		if (date) {
			return (0, _moment2.default)(date).format('YYYY');
		}
		return '';
	};
	
	exports.getDate = getDate;
	exports.getYear = getYear;

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var context_1 = __webpack_require__(8);
	var context_2 = __webpack_require__(8);
	var LoggerFactory = /** @class */ (function () {
	    function LoggerFactory() {
	    }
	    LoggerFactory.prototype.setBeans = function (gridOptionsWrapper) {
	        this.logging = gridOptionsWrapper.isDebug();
	    };
	    LoggerFactory.prototype.create = function (name) {
	        return new Logger(name, this.isLogging.bind(this));
	    };
	    LoggerFactory.prototype.isLogging = function () {
	        return this.logging;
	    };
	    __decorate([
	        __param(0, context_2.Qualifier('gridOptionsWrapper')),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [gridOptionsWrapper_1.GridOptionsWrapper]),
	        __metadata("design:returntype", void 0)
	    ], LoggerFactory.prototype, "setBeans", null);
	    LoggerFactory = __decorate([
	        context_1.Bean('loggerFactory')
	    ], LoggerFactory);
	    return LoggerFactory;
	}());
	exports.LoggerFactory = LoggerFactory;
	var Logger = /** @class */ (function () {
	    function Logger(name, isLoggingFunc) {
	        this.name = name;
	        this.isLoggingFunc = isLoggingFunc;
	    }
	    Logger.prototype.isLogging = function () {
	        return this.isLoggingFunc();
	    };
	    Logger.prototype.log = function (message) {
	        if (this.isLoggingFunc()) {
	            // tslint:disable-next-line
	            console.log('ag-Grid.' + this.name + ': ' + message);
	        }
	    };
	    return Logger;
	}());
	exports.Logger = Logger;


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ButtonBase.default;
	  }
	});
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(1132));

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createSvgIcon;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(308));
	
	/**
	 * Private module reserved for @material-ui/x packages.
	 */
	function createSvgIcon(path, displayName) {
	  var Component = function Component(props, ref) {
	    return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, (0, _extends2.default)({
	      ref: ref
	    }, props), path);
	  };
	
	  if (false) {
	    // Need to set `displayName` on the inner component for React.memo.
	    // React prior to 16.14 ignores `displayName` on the wrapper.
	    Component.displayName = "".concat(displayName, "Icon");
	  }
	
	  Component.muiName = _SvgIcon.default.muiName;
	  return /*#__PURE__*/_react.default.memo( /*#__PURE__*/_react.default.forwardRef(Component));
	}

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var eventService_1 = __webpack_require__(22);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var context_1 = __webpack_require__(8);
	var utils_1 = __webpack_require__(10);
	var BeanStub = /** @class */ (function () {
	    function BeanStub() {
	        this.destroyFunctions = [];
	        this.destroyed = false;
	    }
	    // this was a test constructor niall built, when active, it prints after 5 seconds all beans/components that are
	    // not destroyed. to use, create a new grid, then api.destroy() before 5 seconds. then anything that gets printed
	    // points to a bean or component that was not properly disposed of.
	    // constructor() {
	    //     setTimeout(()=> {
	    //         if (this.isAlive()) {
	    //             let prototype: any = Object.getPrototypeOf(this);
	    //             const constructor: any = prototype.constructor;
	    //             const constructorString = constructor.toString();
	    //             const beanName = constructorString.substring(9, constructorString.indexOf("("));
	    //             console.log('is alive ' + beanName);
	    //         }
	    //     }, 5000);
	    // }
	    // CellComp and GridComp and override this because they get the FrameworkOverrides from the Beans bean
	    BeanStub.prototype.getFrameworkOverrides = function () {
	        return this.frameworkOverrides;
	    };
	    BeanStub.prototype.getContext = function () {
	        return this.context;
	    };
	    BeanStub.prototype.destroy = function () {
	        // let prototype: any = Object.getPrototypeOf(this);
	        // const constructor: any = prototype.constructor;
	        // const constructorString = constructor.toString();
	        // const beanName = constructorString.substring(9, constructorString.indexOf("("));
	        this.destroyFunctions.forEach(function (func) { return func(); });
	        this.destroyFunctions.length = 0;
	        this.destroyed = true;
	        this.dispatchEvent({ type: BeanStub.EVENT_DESTROYED });
	    };
	    BeanStub.prototype.addEventListener = function (eventType, listener) {
	        if (!this.localEventService) {
	            this.localEventService = new eventService_1.EventService();
	        }
	        this.localEventService.addEventListener(eventType, listener);
	    };
	    BeanStub.prototype.removeEventListener = function (eventType, listener) {
	        if (this.localEventService) {
	            this.localEventService.removeEventListener(eventType, listener);
	        }
	    };
	    BeanStub.prototype.dispatchEventAsync = function (event) {
	        var _this = this;
	        window.setTimeout(function () { return _this.dispatchEvent(event); }, 0);
	    };
	    BeanStub.prototype.dispatchEvent = function (event) {
	        if (this.localEventService) {
	            this.localEventService.dispatchEvent(event);
	        }
	    };
	    BeanStub.prototype.addDestroyableEventListener = function (eElement, event, listener) {
	        var _this = this;
	        if (this.destroyed) {
	            return;
	        }
	        if (eElement instanceof HTMLElement) {
	            utils_1._.addSafePassiveEventListener(this.getFrameworkOverrides(), eElement, event, listener);
	        }
	        else if (eElement instanceof Window) {
	            eElement.addEventListener(event, listener);
	        }
	        else if (eElement instanceof gridOptionsWrapper_1.GridOptionsWrapper) {
	            eElement.addEventListener(event, listener);
	        }
	        else {
	            eElement.addEventListener(event, listener);
	        }
	        var destroyFunc = function () {
	            if (eElement instanceof HTMLElement) {
	                eElement.removeEventListener(event, listener);
	            }
	            else if (eElement instanceof Window) {
	                eElement.removeEventListener(event, listener);
	            }
	            else if (eElement instanceof gridOptionsWrapper_1.GridOptionsWrapper) {
	                eElement.removeEventListener(event, listener);
	            }
	            else {
	                eElement.removeEventListener(event, listener);
	            }
	            _this.destroyFunctions = _this.destroyFunctions.filter(function (fn) { return fn !== destroyFunc; });
	        };
	        this.destroyFunctions.push(destroyFunc);
	        return destroyFunc;
	    };
	    BeanStub.prototype.isAlive = function () {
	        return !this.destroyed;
	    };
	    BeanStub.prototype.addDestroyFunc = function (func) {
	        // if we are already destroyed, we execute the func now
	        if (this.isAlive()) {
	            this.destroyFunctions.push(func);
	        }
	        else {
	            func();
	        }
	    };
	    BeanStub.EVENT_DESTROYED = 'destroyed';
	    __decorate([
	        context_1.Autowired('context'),
	        __metadata("design:type", context_1.Context)
	    ], BeanStub.prototype, "context", void 0);
	    __decorate([
	        context_1.Autowired('frameworkOverrides'),
	        __metadata("design:type", Object)
	    ], BeanStub.prototype, "frameworkOverrides", void 0);
	    __decorate([
	        context_1.PreDestroy,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], BeanStub.prototype, "destroy", null);
	    return BeanStub;
	}());
	exports.BeanStub = BeanStub;


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(2053);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 73 */
/***/ function(module, exports) {

	/**
	 * 3x2矩阵操作类
	 * @exports zrender/tool/matrix
	 */
	
	/* global Float32Array */
	var ArrayCtor = typeof Float32Array === 'undefined' ? Array : Float32Array;
	/**
	 * Create a identity matrix.
	 * @return {Float32Array|Array.<number>}
	 */
	
	function create() {
	  var out = new ArrayCtor(6);
	  identity(out);
	  return out;
	}
	/**
	 * 设置矩阵为单位矩阵
	 * @param {Float32Array|Array.<number>} out
	 */
	
	
	function identity(out) {
	  out[0] = 1;
	  out[1] = 0;
	  out[2] = 0;
	  out[3] = 1;
	  out[4] = 0;
	  out[5] = 0;
	  return out;
	}
	/**
	 * 复制矩阵
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} m
	 */
	
	
	function copy(out, m) {
	  out[0] = m[0];
	  out[1] = m[1];
	  out[2] = m[2];
	  out[3] = m[3];
	  out[4] = m[4];
	  out[5] = m[5];
	  return out;
	}
	/**
	 * 矩阵相乘
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} m1
	 * @param {Float32Array|Array.<number>} m2
	 */
	
	
	function mul(out, m1, m2) {
	  // Consider matrix.mul(m, m2, m);
	  // where out is the same as m2.
	  // So use temp variable to escape error.
	  var out0 = m1[0] * m2[0] + m1[2] * m2[1];
	  var out1 = m1[1] * m2[0] + m1[3] * m2[1];
	  var out2 = m1[0] * m2[2] + m1[2] * m2[3];
	  var out3 = m1[1] * m2[2] + m1[3] * m2[3];
	  var out4 = m1[0] * m2[4] + m1[2] * m2[5] + m1[4];
	  var out5 = m1[1] * m2[4] + m1[3] * m2[5] + m1[5];
	  out[0] = out0;
	  out[1] = out1;
	  out[2] = out2;
	  out[3] = out3;
	  out[4] = out4;
	  out[5] = out5;
	  return out;
	}
	/**
	 * 平移变换
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} a
	 * @param {Float32Array|Array.<number>} v
	 */
	
	
	function translate(out, a, v) {
	  out[0] = a[0];
	  out[1] = a[1];
	  out[2] = a[2];
	  out[3] = a[3];
	  out[4] = a[4] + v[0];
	  out[5] = a[5] + v[1];
	  return out;
	}
	/**
	 * 旋转变换
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} a
	 * @param {number} rad
	 */
	
	
	function rotate(out, a, rad) {
	  var aa = a[0];
	  var ac = a[2];
	  var atx = a[4];
	  var ab = a[1];
	  var ad = a[3];
	  var aty = a[5];
	  var st = Math.sin(rad);
	  var ct = Math.cos(rad);
	  out[0] = aa * ct + ab * st;
	  out[1] = -aa * st + ab * ct;
	  out[2] = ac * ct + ad * st;
	  out[3] = -ac * st + ct * ad;
	  out[4] = ct * atx + st * aty;
	  out[5] = ct * aty - st * atx;
	  return out;
	}
	/**
	 * 缩放变换
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} a
	 * @param {Float32Array|Array.<number>} v
	 */
	
	
	function scale(out, a, v) {
	  var vx = v[0];
	  var vy = v[1];
	  out[0] = a[0] * vx;
	  out[1] = a[1] * vy;
	  out[2] = a[2] * vx;
	  out[3] = a[3] * vy;
	  out[4] = a[4] * vx;
	  out[5] = a[5] * vy;
	  return out;
	}
	/**
	 * 求逆矩阵
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} a
	 */
	
	
	function invert(out, a) {
	  var aa = a[0];
	  var ac = a[2];
	  var atx = a[4];
	  var ab = a[1];
	  var ad = a[3];
	  var aty = a[5];
	  var det = aa * ad - ab * ac;
	
	  if (!det) {
	    return null;
	  }
	
	  det = 1.0 / det;
	  out[0] = ad * det;
	  out[1] = -ab * det;
	  out[2] = -ac * det;
	  out[3] = aa * det;
	  out[4] = (ac * aty - ad * atx) * det;
	  out[5] = (ab * atx - aa * aty) * det;
	  return out;
	}
	/**
	 * Clone a new matrix.
	 * @param {Float32Array|Array.<number>} a
	 */
	
	
	function clone(a) {
	  var b = create();
	  copy(b, a);
	  return b;
	}
	
	exports.create = create;
	exports.identity = identity;
	exports.copy = copy;
	exports.mul = mul;
	exports.translate = translate;
	exports.rotate = rotate;
	exports.scale = scale;
	exports.invert = invert;
	exports.clone = clone;

/***/ },
/* 74 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Typography.default;
	  }
	});
	
	var _Typography = _interopRequireDefault(__webpack_require__(1283));

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	/** @license Material-UI v4.10.0
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  createGenerateClassName: true,
	  createStyles: true,
	  getThemeProps: true,
	  jssPreset: true,
	  makeStyles: true,
	  mergeClasses: true,
	  ServerStyleSheets: true,
	  styled: true,
	  StylesProvider: true,
	  ThemeProvider: true,
	  useTheme: true,
	  withStyles: true,
	  withTheme: true
	};
	Object.defineProperty(exports, "createGenerateClassName", {
	  enumerable: true,
	  get: function get() {
	    return _createGenerateClassName.default;
	  }
	});
	Object.defineProperty(exports, "createStyles", {
	  enumerable: true,
	  get: function get() {
	    return _createStyles.default;
	  }
	});
	Object.defineProperty(exports, "getThemeProps", {
	  enumerable: true,
	  get: function get() {
	    return _getThemeProps.default;
	  }
	});
	Object.defineProperty(exports, "jssPreset", {
	  enumerable: true,
	  get: function get() {
	    return _jssPreset.default;
	  }
	});
	Object.defineProperty(exports, "makeStyles", {
	  enumerable: true,
	  get: function get() {
	    return _makeStyles.default;
	  }
	});
	Object.defineProperty(exports, "mergeClasses", {
	  enumerable: true,
	  get: function get() {
	    return _mergeClasses.default;
	  }
	});
	Object.defineProperty(exports, "ServerStyleSheets", {
	  enumerable: true,
	  get: function get() {
	    return _ServerStyleSheets.default;
	  }
	});
	Object.defineProperty(exports, "styled", {
	  enumerable: true,
	  get: function get() {
	    return _styled.default;
	  }
	});
	Object.defineProperty(exports, "StylesProvider", {
	  enumerable: true,
	  get: function get() {
	    return _StylesProvider.default;
	  }
	});
	Object.defineProperty(exports, "ThemeProvider", {
	  enumerable: true,
	  get: function get() {
	    return _ThemeProvider.default;
	  }
	});
	Object.defineProperty(exports, "useTheme", {
	  enumerable: true,
	  get: function get() {
	    return _useTheme.default;
	  }
	});
	Object.defineProperty(exports, "withStyles", {
	  enumerable: true,
	  get: function get() {
	    return _withStyles.default;
	  }
	});
	Object.defineProperty(exports, "withTheme", {
	  enumerable: true,
	  get: function get() {
	    return _withTheme.default;
	  }
	});
	
	var _utils = __webpack_require__(19);
	
	var _createGenerateClassName = _interopRequireWildcard(__webpack_require__(411));
	
	Object.keys(_createGenerateClassName).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _createGenerateClassName[key];
	    }
	  });
	});
	
	var _createStyles = _interopRequireWildcard(__webpack_require__(1343));
	
	Object.keys(_createStyles).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _createStyles[key];
	    }
	  });
	});
	
	var _getThemeProps = _interopRequireWildcard(__webpack_require__(633));
	
	Object.keys(_getThemeProps).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _getThemeProps[key];
	    }
	  });
	});
	
	var _jssPreset = _interopRequireWildcard(__webpack_require__(634));
	
	Object.keys(_jssPreset).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _jssPreset[key];
	    }
	  });
	});
	
	var _makeStyles = _interopRequireWildcard(__webpack_require__(412));
	
	Object.keys(_makeStyles).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _makeStyles[key];
	    }
	  });
	});
	
	var _mergeClasses = _interopRequireWildcard(__webpack_require__(635));
	
	Object.keys(_mergeClasses).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _mergeClasses[key];
	    }
	  });
	});
	
	var _ServerStyleSheets = _interopRequireWildcard(__webpack_require__(1337));
	
	Object.keys(_ServerStyleSheets).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ServerStyleSheets[key];
	    }
	  });
	});
	
	var _styled = _interopRequireWildcard(__webpack_require__(1352));
	
	Object.keys(_styled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _styled[key];
	    }
	  });
	});
	
	var _StylesProvider = _interopRequireWildcard(__webpack_require__(410));
	
	Object.keys(_StylesProvider).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _StylesProvider[key];
	    }
	  });
	});
	
	var _ThemeProvider = _interopRequireWildcard(__webpack_require__(1340));
	
	Object.keys(_ThemeProvider).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ThemeProvider[key];
	    }
	  });
	});
	
	var _useTheme = _interopRequireWildcard(__webpack_require__(245));
	
	Object.keys(_useTheme).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _useTheme[key];
	    }
	  });
	});
	
	var _withStyles = _interopRequireWildcard(__webpack_require__(1355));
	
	Object.keys(_withStyles).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withStyles[key];
	    }
	  });
	});
	
	var _withTheme = _interopRequireWildcard(__webpack_require__(1357));
	
	Object.keys(_withTheme).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withTheme[key];
	    }
	  });
	});
	
	/* eslint-disable import/export */
	
	/* Warning if there are several instances of @material-ui/styles */
	if (false) {
	  _utils.ponyfillGlobal['__@material-ui/styles-init__'] = _utils.ponyfillGlobal['__@material-ui/styles-init__'] || 0;
	
	  if (_utils.ponyfillGlobal['__@material-ui/styles-init__'] === 1) {
	    console.warn(['It looks like there are several instances of `@material-ui/styles` initialized in this application.', 'This may cause theme propagation issues, broken class names, ' + 'specificity issues, and makes your application bigger without a good reason.', '', 'See https://material-ui.com/r/styles-instance-warning for more info.'].join('\n'));
	  }
	
	  _utils.ponyfillGlobal['__@material-ui/styles-init__'] += 1;
	}

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(10);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var popupService_1 = __webpack_require__(137);
	var valueService_1 = __webpack_require__(103);
	var columnController_1 = __webpack_require__(26);
	var columnApi_1 = __webpack_require__(38);
	var context_1 = __webpack_require__(8);
	var eventService_1 = __webpack_require__(22);
	var events_1 = __webpack_require__(29);
	var gridApi_1 = __webpack_require__(33);
	var userComponentFactory_1 = __webpack_require__(81);
	var FilterManager = /** @class */ (function () {
	    function FilterManager() {
	        this.allFilters = {};
	        this.quickFilter = null;
	        this.quickFilterParts = null;
	        // this is true when the grid is processing the filter change. this is used by the cell comps, so that they
	        // don't flash when data changes due to filter changes. there is no need to flash when filter changes as the
	        // user is in control, so doesn't make sense to show flashing changes. for example, go to main demo where
	        // this feature is turned off (hack code to always return false for isSuppressFlashingCellsBecauseFiltering(), put in)
	        // 100,000 rows and group by country. then do some filtering. all the cells flash, which is silly.
	        this.processingFilterChange = false;
	    }
	    FilterManager_1 = FilterManager;
	    FilterManager.prototype.registerGridCore = function (gridCore) {
	        this.gridCore = gridCore;
	    };
	    FilterManager.prototype.init = function () {
	        this.eventService.addEventListener(events_1.Events.EVENT_ROW_DATA_CHANGED, this.onNewRowsLoaded.bind(this));
	        this.eventService.addEventListener(events_1.Events.EVENT_NEW_COLUMNS_LOADED, this.onNewColumnsLoaded.bind(this));
	        this.quickFilter = this.parseQuickFilter(this.gridOptionsWrapper.getQuickFilterText());
	        this.setQuickFilterParts();
	        this.allowShowChangeAfterFilter = this.gridOptionsWrapper.isAllowShowChangeAfterFilter();
	        // check this here, in case there is a filter from the start
	        this.checkExternalFilter();
	    };
	    FilterManager.prototype.setQuickFilterParts = function () {
	        if (this.quickFilter) {
	            this.quickFilterParts = this.quickFilter.split(' ');
	        }
	        else {
	            this.quickFilterParts = null;
	        }
	    };
	    FilterManager.prototype.setFilterModel = function (model) {
	        var _this = this;
	        var allPromises = [];
	        if (model) {
	            // mark the filters as we set them, so any active filters left over we stop
	            var modelKeys_1 = Object.keys(model);
	            utils_1._.iterateObject(this.allFilters, function (colId, filterWrapper) {
	                utils_1._.removeFromArray(modelKeys_1, colId);
	                var newModel = model[colId];
	                _this.setModelOnFilterWrapper(filterWrapper.filterPromise, newModel);
	                allPromises.push(filterWrapper.filterPromise);
	            });
	            // at this point, processedFields contains data for which we don't have a filter working yet
	            utils_1._.iterateArray(modelKeys_1, function (colId) {
	                var column = _this.columnController.getPrimaryColumn(colId);
	                if (!column) {
	                    console.warn('Warning ag-grid setFilterModel - no column found for colId ' + colId);
	                    return;
	                }
	                var filterWrapper = _this.getOrCreateFilterWrapper(column, 'NO_UI');
	                _this.setModelOnFilterWrapper(filterWrapper.filterPromise, model[colId]);
	                allPromises.push(filterWrapper.filterPromise);
	            });
	        }
	        else {
	            utils_1._.iterateObject(this.allFilters, function (key, filterWrapper) {
	                _this.setModelOnFilterWrapper(filterWrapper.filterPromise, null);
	                allPromises.push(filterWrapper.filterPromise);
	            });
	        }
	        utils_1.Promise.all(allPromises).then(function (whatever) {
	            _this.onFilterChanged();
	        });
	    };
	    FilterManager.prototype.setModelOnFilterWrapper = function (filterPromise, newModel) {
	        filterPromise.then(function (filter) {
	            if (typeof filter.setModel !== 'function') {
	                console.warn('Warning ag-grid - filter missing setModel method, which is needed for setFilterModel');
	                return;
	            }
	            filter.setModel(newModel);
	        });
	    };
	    FilterManager.prototype.getFilterModel = function () {
	        var result = {};
	        utils_1._.iterateObject(this.allFilters, function (key, filterWrapper) {
	            // because user can provide filters, we provide useful error checking and messages
	            var filterPromise = filterWrapper.filterPromise;
	            var filter = filterPromise.resolveNow(null, function (filter) { return filter; });
	            if (filter == null) {
	                return null;
	            }
	            if (typeof filter.getModel !== 'function') {
	                console.warn('Warning ag-grid - filter API missing getModel method, which is needed for getFilterModel');
	                return;
	            }
	            var model = filter.getModel();
	            if (utils_1._.exists(model)) {
	                result[key] = model;
	            }
	        });
	        return result;
	    };
	    // returns true if any advanced filter (ie not quick filter) active
	    FilterManager.prototype.isAdvancedFilterPresent = function () {
	        return this.advancedFilterPresent;
	    };
	    // called by:
	    // 1) onFilterChanged()
	    // 2) onNewRowsLoaded()
	    FilterManager.prototype.setAdvancedFilterPresent = function () {
	        var atLeastOneActive = false;
	        utils_1._.iterateObject(this.allFilters, function (key, filterWrapper) {
	            if (filterWrapper.filterPromise.resolveNow(false, function (filter) { return filter.isFilterActive(); })) {
	                atLeastOneActive = true;
	            }
	        });
	        this.advancedFilterPresent = atLeastOneActive;
	    };
	    FilterManager.prototype.updateFilterFlagInColumns = function (source, additionalEventAttributes) {
	        utils_1._.iterateObject(this.allFilters, function (key, filterWrapper) {
	            var filterActive = filterWrapper.filterPromise.resolveNow(false, function (filter) { return filter.isFilterActive(); });
	            filterWrapper.column.setFilterActive(filterActive, source, additionalEventAttributes);
	        });
	    };
	    // returns true if quickFilter or advancedFilter
	    FilterManager.prototype.isAnyFilterPresent = function () {
	        return this.isQuickFilterPresent() || this.advancedFilterPresent || this.externalFilterPresent;
	    };
	    FilterManager.prototype.doesFilterPass = function (node, filterToSkip) {
	        var data = node.data;
	        var colKeys = Object.keys(this.allFilters);
	        for (var i = 0, l = colKeys.length; i < l; i++) { // critical code, don't use functional programming
	            var colId = colKeys[i];
	            var filterWrapper = this.allFilters[colId];
	            // if no filter, always pass
	            if (filterWrapper === undefined) {
	                continue;
	            }
	            var filter = filterWrapper.filterPromise.resolveNow(undefined, function (filter) { return filter; });
	            // if filter not yet there, continue
	            if (filter === undefined) {
	                continue;
	            }
	            if (filter === filterToSkip) {
	                continue;
	            }
	            // don't bother with filters that are not active
	            if (!filter.isFilterActive()) {
	                continue;
	            }
	            if (!filter.doesFilterPass) { // because users can do custom filters, give nice error message
	                console.error('Filter is missing method doesFilterPass');
	            }
	            var params = {
	                node: node,
	                data: data
	            };
	            if (!filter.doesFilterPass(params)) {
	                return false;
	            }
	        }
	        // all filters passed
	        return true;
	    };
	    FilterManager.prototype.parseQuickFilter = function (newFilter) {
	        if (utils_1._.missing(newFilter) || newFilter === "") {
	            return null;
	        }
	        if (!this.gridOptionsWrapper.isRowModelDefault()) {
	            console.warn('ag-grid: quick filtering only works with the Client-side Row Model');
	            return null;
	        }
	        return newFilter.toUpperCase();
	    };
	    // returns true if it has changed (not just same value again)
	    FilterManager.prototype.setQuickFilter = function (newFilter) {
	        var parsedFilter = this.parseQuickFilter(newFilter);
	        if (this.quickFilter !== parsedFilter) {
	            this.quickFilter = parsedFilter;
	            this.setQuickFilterParts();
	            this.onFilterChanged();
	        }
	    };
	    FilterManager.prototype.checkExternalFilter = function () {
	        this.externalFilterPresent = this.gridOptionsWrapper.isExternalFilterPresent();
	    };
	    FilterManager.prototype.onFilterChanged = function (additionalEventAttributes) {
	        this.setAdvancedFilterPresent();
	        this.updateFilterFlagInColumns("filterChanged", additionalEventAttributes);
	        this.checkExternalFilter();
	        utils_1._.iterateObject(this.allFilters, function (key, filterWrapper) {
	            filterWrapper.filterPromise.then(function (filter) {
	                if (filter.onAnyFilterChanged) {
	                    filter.onAnyFilterChanged();
	                }
	            });
	        });
	        var filterChangedEvent = {
	            type: events_1.Events.EVENT_FILTER_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        if (additionalEventAttributes) {
	            utils_1._.mergeDeep(filterChangedEvent, additionalEventAttributes);
	        }
	        // because internal events are not async in ag-grid, when the dispatchEvent
	        // method comes back, we know all listeners have finished executing.
	        this.processingFilterChange = true;
	        this.eventService.dispatchEvent(filterChangedEvent);
	        this.processingFilterChange = false;
	    };
	    FilterManager.prototype.isSuppressFlashingCellsBecauseFiltering = function () {
	        if (this.allowShowChangeAfterFilter) {
	            // if user has elected to always flash cell changes, then return false always
	            return false;
	        }
	        else {
	            // otherwise we suppress flashing changes when filtering
	            return this.processingFilterChange;
	        }
	    };
	    FilterManager.prototype.isQuickFilterPresent = function () {
	        return this.quickFilter !== null;
	    };
	    FilterManager.prototype.doesRowPassOtherFilters = function (filterToSkip, node) {
	        return this.doesRowPassFilter(node, filterToSkip);
	    };
	    FilterManager.prototype.doesRowPassQuickFilterNoCache = function (node, filterPart) {
	        var _this = this;
	        var columns = this.columnController.getAllColumnsForQuickFilter();
	        var filterPasses = false;
	        columns.forEach(function (column) {
	            if (filterPasses) {
	                return;
	            }
	            var part = _this.getQuickFilterTextForColumn(column, node);
	            if (utils_1._.exists(part)) {
	                if (part.indexOf(filterPart) >= 0) {
	                    filterPasses = true;
	                }
	            }
	        });
	        return filterPasses;
	    };
	    FilterManager.prototype.doesRowPassQuickFilterCache = function (node, filterPart) {
	        if (!node.quickFilterAggregateText) {
	            this.aggregateRowForQuickFilter(node);
	        }
	        var filterPasses = node.quickFilterAggregateText.indexOf(filterPart) >= 0;
	        return filterPasses;
	    };
	    FilterManager.prototype.doesRowPassQuickFilter = function (node) {
	        var _this = this;
	        var filterPasses = true;
	        var usingCache = this.gridOptionsWrapper.isCacheQuickFilter();
	        this.quickFilterParts.forEach(function (filterPart) {
	            var partPasses = usingCache ?
	                _this.doesRowPassQuickFilterCache(node, filterPart) : _this.doesRowPassQuickFilterNoCache(node, filterPart);
	            // each part must pass, if any fails, then the whole filter fails
	            if (!partPasses) {
	                filterPasses = false;
	            }
	        });
	        return filterPasses;
	    };
	    FilterManager.prototype.doesRowPassFilter = function (node, filterToSkip) {
	        // the row must pass ALL of the filters, so if any of them fail,
	        // we return true. that means if a row passes the quick filter,
	        // but fails the column filter, it fails overall
	        // first up, check quick filter
	        if (this.isQuickFilterPresent()) {
	            if (!this.doesRowPassQuickFilter(node)) {
	                return false;
	            }
	        }
	        // secondly, give the client a chance to reject this row
	        if (this.externalFilterPresent) {
	            if (!this.gridOptionsWrapper.doesExternalFilterPass(node)) {
	                return false;
	            }
	        }
	        // lastly, check our internal advanced filter
	        if (this.advancedFilterPresent) {
	            if (!this.doesFilterPass(node, filterToSkip)) {
	                return false;
	            }
	        }
	        // got this far, all filters pass
	        return true;
	    };
	    FilterManager.prototype.getQuickFilterTextForColumn = function (column, rowNode) {
	        var value = this.valueService.getValue(column, rowNode, true);
	        var valueAfterCallback;
	        var colDef = column.getColDef();
	        if (column.getColDef().getQuickFilterText) {
	            var params = {
	                value: value,
	                node: rowNode,
	                data: rowNode.data,
	                column: column,
	                colDef: colDef,
	                context: this.gridOptionsWrapper.getContext()
	            };
	            valueAfterCallback = column.getColDef().getQuickFilterText(params);
	        }
	        else {
	            valueAfterCallback = value;
	        }
	        if (utils_1._.exists(valueAfterCallback)) {
	            return valueAfterCallback.toString().toUpperCase();
	        }
	        else {
	            return null;
	        }
	    };
	    FilterManager.prototype.aggregateRowForQuickFilter = function (node) {
	        var _this = this;
	        var stringParts = [];
	        var columns = this.columnController.getAllColumnsForQuickFilter();
	        columns.forEach(function (column) {
	            var part = _this.getQuickFilterTextForColumn(column, node);
	            if (utils_1._.exists(part)) {
	                stringParts.push(part);
	            }
	        });
	        node.quickFilterAggregateText = stringParts.join(FilterManager_1.QUICK_FILTER_SEPARATOR);
	    };
	    FilterManager.prototype.onNewRowsLoaded = function (source) {
	        utils_1._.iterateObject(this.allFilters, function (key, filterWrapper) {
	            filterWrapper.filterPromise.then(function (filter) {
	                if (filter.onNewRowsLoaded) {
	                    filter.onNewRowsLoaded();
	                }
	            });
	        });
	        this.updateFilterFlagInColumns(source);
	        this.setAdvancedFilterPresent();
	    };
	    FilterManager.prototype.createValueGetter = function (column) {
	        var _this = this;
	        return function (node) {
	            return _this.valueService.getValue(column, node, true);
	        };
	    };
	    FilterManager.prototype.getFilterComponent = function (column, source) {
	        var filterWrapper = this.getOrCreateFilterWrapper(column, source);
	        return filterWrapper.filterPromise;
	    };
	    FilterManager.prototype.isFilterActive = function (column) {
	        var filterWrapper = this.cachedFilter(column);
	        if (filterWrapper) {
	            return filterWrapper.filterPromise.resolveNow(false, function (filter) { return filter.isFilterActive(); });
	        }
	        else {
	            return false;
	        }
	    };
	    FilterManager.prototype.getOrCreateFilterWrapper = function (column, source) {
	        var filterWrapper = this.cachedFilter(column);
	        if (!filterWrapper) {
	            filterWrapper = this.createFilterWrapper(column, source);
	            this.allFilters[column.getColId()] = filterWrapper;
	        }
	        else {
	            if (source !== 'NO_UI') {
	                this.putIntoGui(filterWrapper, source);
	            }
	        }
	        return filterWrapper;
	    };
	    FilterManager.prototype.cachedFilter = function (column) {
	        return this.allFilters[column.getColId()];
	    };
	    FilterManager.prototype.createFilterInstance = function (column, $scope) {
	        var _this = this;
	        var defaultFilter = 'agTextColumnFilter';
	        if (this.gridOptionsWrapper.isEnterprise()) {
	            defaultFilter = 'agSetColumnFilter';
	        }
	        var sanitisedColDef = utils_1._.cloneObject(column.getColDef());
	        var filterInstance;
	        var params = this.createFilterParams(column, sanitisedColDef, $scope);
	        params.filterChangedCallback = this.onFilterChanged.bind(this);
	        params.filterModifiedCallback = function () {
	            var event = {
	                type: events_1.Events.EVENT_FILTER_MODIFIED,
	                api: _this.gridApi,
	                columnApi: _this.columnApi,
	                column: column,
	                filterInstance: filterInstance
	            };
	            _this.eventService.dispatchEvent(event);
	        };
	        // we modify params in a callback as we need the filter instance, and this isn't available
	        // when creating the params above
	        var modifyParamsCallback = function (params, filter) { return utils_1._.assign(params, {
	            doesRowPassOtherFilter: _this.doesRowPassOtherFilters.bind(_this, filter),
	        }); };
	        var res = this.userComponentFactory.newFilterComponent(sanitisedColDef, params, defaultFilter, modifyParamsCallback);
	        res.then(function (r) { return filterInstance = r; });
	        return res;
	    };
	    FilterManager.prototype.createFilterParams = function (column, colDef, $scope) {
	        if ($scope === void 0) { $scope = null; }
	        var params = {
	            api: this.gridOptionsWrapper.getApi(),
	            column: column,
	            colDef: colDef,
	            rowModel: this.rowModel,
	            filterChangedCallback: null,
	            filterModifiedCallback: null,
	            valueGetter: this.createValueGetter(column),
	            context: this.gridOptionsWrapper.getContext(),
	            doesRowPassOtherFilter: null
	        };
	        // hack in scope if using AngularJS
	        if ($scope) {
	            params.$scope = $scope;
	        }
	        return params;
	    };
	    FilterManager.prototype.createFilterWrapper = function (column, source) {
	        var filterWrapper = {
	            column: column,
	            filterPromise: null,
	            scope: null,
	            compiledElement: null,
	            guiPromise: utils_1.Promise.external()
	        };
	        filterWrapper.scope = this.gridOptionsWrapper.isAngularCompileFilters() ? this.$scope.$new() : null;
	        filterWrapper.filterPromise = this.createFilterInstance(column, filterWrapper.scope);
	        this.putIntoGui(filterWrapper, source);
	        return filterWrapper;
	    };
	    FilterManager.prototype.putIntoGui = function (filterWrapper, source) {
	        var _this = this;
	        var eFilterGui = document.createElement('div');
	        eFilterGui.className = 'ag-filter';
	        filterWrapper.filterPromise.then(function (filter) {
	            var guiFromFilter = filter.getGui();
	            if (utils_1._.missing(guiFromFilter)) {
	                console.warn("getGui method from filter returned " + guiFromFilter + ", it should be a DOM element or an HTML template string.");
	            }
	            // for backwards compatibility with Angular 1 - we
	            // used to allow providing back HTML from getGui().
	            // once we move away from supporting Angular 1
	            // directly, we can change this.
	            if (typeof guiFromFilter === 'string') {
	                guiFromFilter = utils_1._.loadTemplate(guiFromFilter);
	            }
	            eFilterGui.appendChild(guiFromFilter);
	            if (filterWrapper.scope) {
	                var compiledElement = _this.$compile(eFilterGui)(filterWrapper.scope);
	                filterWrapper.compiledElement = compiledElement;
	                window.setTimeout(function () { return filterWrapper.scope.$apply(); }, 0);
	            }
	            filterWrapper.guiPromise.resolve(eFilterGui);
	            _this.eventService.dispatchEvent({
	                type: events_1.Events.EVENT_FILTER_OPENED,
	                column: filterWrapper.column,
	                source: source,
	                eGui: eFilterGui,
	                api: _this.gridApi,
	                columnApi: _this.columnApi
	            });
	        });
	    };
	    FilterManager.prototype.onNewColumnsLoaded = function () {
	        var _this = this;
	        var atLeastOneFilterGone = false;
	        utils_1._.iterateObject(this.allFilters, function (key, filterWrapper) {
	            var oldColumn = !_this.columnController.getPrimaryColumn(filterWrapper.column);
	            if (oldColumn) {
	                atLeastOneFilterGone = true;
	                _this.disposeFilterWrapper(filterWrapper, "filterDestroyed");
	            }
	        });
	        if (atLeastOneFilterGone) {
	            this.onFilterChanged();
	        }
	    };
	    // destroys the filter, so it not longer takes part
	    FilterManager.prototype.destroyFilter = function (column, source) {
	        if (source === void 0) { source = "api"; }
	        var filterWrapper = this.allFilters[column.getColId()];
	        if (filterWrapper) {
	            this.disposeFilterWrapper(filterWrapper, source);
	            this.onFilterChanged();
	        }
	    };
	    FilterManager.prototype.disposeFilterWrapper = function (filterWrapper, source) {
	        var _this = this;
	        filterWrapper.filterPromise.then(function (filter) {
	            filter.setModel(null);
	            if (filter.destroy) {
	                filter.destroy();
	            }
	            filterWrapper.column.setFilterActive(false, source);
	            if (filterWrapper.scope) {
	                if (filterWrapper.compiledElement) {
	                    filterWrapper.compiledElement.remove();
	                }
	                filterWrapper.scope.$destroy();
	            }
	            delete _this.allFilters[filterWrapper.column.getColId()];
	        });
	    };
	    FilterManager.prototype.destroy = function () {
	        var _this = this;
	        utils_1._.iterateObject(this.allFilters, function (key, filterWrapper) {
	            _this.disposeFilterWrapper(filterWrapper, "filterDestroyed");
	        });
	    };
	    var FilterManager_1;
	    FilterManager.QUICK_FILTER_SEPARATOR = '\n';
	    __decorate([
	        context_1.Autowired('$compile'),
	        __metadata("design:type", Object)
	    ], FilterManager.prototype, "$compile", void 0);
	    __decorate([
	        context_1.Autowired('$scope'),
	        __metadata("design:type", Object)
	    ], FilterManager.prototype, "$scope", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], FilterManager.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('popupService'),
	        __metadata("design:type", popupService_1.PopupService)
	    ], FilterManager.prototype, "popupService", void 0);
	    __decorate([
	        context_1.Autowired('valueService'),
	        __metadata("design:type", valueService_1.ValueService)
	    ], FilterManager.prototype, "valueService", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], FilterManager.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], FilterManager.prototype, "rowModel", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], FilterManager.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('enterprise'),
	        __metadata("design:type", Boolean)
	    ], FilterManager.prototype, "enterprise", void 0);
	    __decorate([
	        context_1.Autowired('context'),
	        __metadata("design:type", context_1.Context)
	    ], FilterManager.prototype, "context", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], FilterManager.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], FilterManager.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.Autowired('userComponentFactory'),
	        __metadata("design:type", userComponentFactory_1.UserComponentFactory)
	    ], FilterManager.prototype, "userComponentFactory", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], FilterManager.prototype, "init", null);
	    __decorate([
	        context_1.PreDestroy,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], FilterManager.prototype, "destroy", null);
	    FilterManager = FilterManager_1 = __decorate([
	        context_1.Bean('filterManager')
	    ], FilterManager);
	    return FilterManager;
	}());
	exports.FilterManager = FilterManager;


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	// the whatwg-fetch polyfill installs the fetch() function
	// on the global object (window or self)
	//
	// Return that as the export for use in Webpack, Browserify etc.
	__webpack_require__(2270);
	module.exports = self.fetch.bind(self);


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	var BoundingRect = __webpack_require__(42);
	
	var imageHelper = __webpack_require__(559);
	
	var _util = __webpack_require__(3);
	
	var getContext = _util.getContext;
	var extend = _util.extend;
	var retrieve2 = _util.retrieve2;
	var retrieve3 = _util.retrieve3;
	var trim = _util.trim;
	var textWidthCache = {};
	var textWidthCacheCounter = 0;
	var TEXT_CACHE_MAX = 5000;
	var STYLE_REG = /\{([a-zA-Z0-9_]+)\|([^}]*)\}/g;
	var DEFAULT_FONT = '12px sans-serif'; // Avoid assign to an exported variable, for transforming to cjs.
	
	var methods = {};
	
	function $override(name, fn) {
	  methods[name] = fn;
	}
	/**
	 * @public
	 * @param {string} text
	 * @param {string} font
	 * @return {number} width
	 */
	
	
	function getWidth(text, font) {
	  font = font || DEFAULT_FONT;
	  var key = text + ':' + font;
	
	  if (textWidthCache[key]) {
	    return textWidthCache[key];
	  }
	
	  var textLines = (text + '').split('\n');
	  var width = 0;
	
	  for (var i = 0, l = textLines.length; i < l; i++) {
	    // textContain.measureText may be overrided in SVG or VML
	    width = Math.max(measureText(textLines[i], font).width, width);
	  }
	
	  if (textWidthCacheCounter > TEXT_CACHE_MAX) {
	    textWidthCacheCounter = 0;
	    textWidthCache = {};
	  }
	
	  textWidthCacheCounter++;
	  textWidthCache[key] = width;
	  return width;
	}
	/**
	 * @public
	 * @param {string} text
	 * @param {string} font
	 * @param {string} [textAlign='left']
	 * @param {string} [textVerticalAlign='top']
	 * @param {Array.<number>} [textPadding]
	 * @param {Object} [rich]
	 * @param {Object} [truncate]
	 * @return {Object} {x, y, width, height, lineHeight}
	 */
	
	
	function getBoundingRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, rich, truncate) {
	  return rich ? getRichTextRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, rich, truncate) : getPlainTextRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, truncate);
	}
	
	function getPlainTextRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, truncate) {
	  var contentBlock = parsePlainText(text, font, textPadding, textLineHeight, truncate);
	  var outerWidth = getWidth(text, font);
	
	  if (textPadding) {
	    outerWidth += textPadding[1] + textPadding[3];
	  }
	
	  var outerHeight = contentBlock.outerHeight;
	  var x = adjustTextX(0, outerWidth, textAlign);
	  var y = adjustTextY(0, outerHeight, textVerticalAlign);
	  var rect = new BoundingRect(x, y, outerWidth, outerHeight);
	  rect.lineHeight = contentBlock.lineHeight;
	  return rect;
	}
	
	function getRichTextRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, rich, truncate) {
	  var contentBlock = parseRichText(text, {
	    rich: rich,
	    truncate: truncate,
	    font: font,
	    textAlign: textAlign,
	    textPadding: textPadding,
	    textLineHeight: textLineHeight
	  });
	  var outerWidth = contentBlock.outerWidth;
	  var outerHeight = contentBlock.outerHeight;
	  var x = adjustTextX(0, outerWidth, textAlign);
	  var y = adjustTextY(0, outerHeight, textVerticalAlign);
	  return new BoundingRect(x, y, outerWidth, outerHeight);
	}
	/**
	 * @public
	 * @param {number} x
	 * @param {number} width
	 * @param {string} [textAlign='left']
	 * @return {number} Adjusted x.
	 */
	
	
	function adjustTextX(x, width, textAlign) {
	  // FIXME Right to left language
	  if (textAlign === 'right') {
	    x -= width;
	  } else if (textAlign === 'center') {
	    x -= width / 2;
	  }
	
	  return x;
	}
	/**
	 * @public
	 * @param {number} y
	 * @param {number} height
	 * @param {string} [textVerticalAlign='top']
	 * @return {number} Adjusted y.
	 */
	
	
	function adjustTextY(y, height, textVerticalAlign) {
	  if (textVerticalAlign === 'middle') {
	    y -= height / 2;
	  } else if (textVerticalAlign === 'bottom') {
	    y -= height;
	  }
	
	  return y;
	}
	/**
	 * Follow same interface to `Displayable.prototype.calculateTextPosition`.
	 * @public
	 * @param {Obejct} [out] Prepared out object. If not input, auto created in the method.
	 * @param {module:zrender/graphic/Style} style where `textPosition` and `textDistance` are visited.
	 * @param {Object} rect {x, y, width, height} Rect of the host elment, according to which the text positioned.
	 * @return {Object} The input `out`. Set: {x, y, textAlign, textVerticalAlign}
	 */
	
	
	function calculateTextPosition(out, style, rect) {
	  var textPosition = style.textPosition;
	  var distance = style.textDistance;
	  var x = rect.x;
	  var y = rect.y;
	  distance = distance || 0;
	  var height = rect.height;
	  var width = rect.width;
	  var halfHeight = height / 2;
	  var textAlign = 'left';
	  var textVerticalAlign = 'top';
	
	  switch (textPosition) {
	    case 'left':
	      x -= distance;
	      y += halfHeight;
	      textAlign = 'right';
	      textVerticalAlign = 'middle';
	      break;
	
	    case 'right':
	      x += distance + width;
	      y += halfHeight;
	      textVerticalAlign = 'middle';
	      break;
	
	    case 'top':
	      x += width / 2;
	      y -= distance;
	      textAlign = 'center';
	      textVerticalAlign = 'bottom';
	      break;
	
	    case 'bottom':
	      x += width / 2;
	      y += height + distance;
	      textAlign = 'center';
	      break;
	
	    case 'inside':
	      x += width / 2;
	      y += halfHeight;
	      textAlign = 'center';
	      textVerticalAlign = 'middle';
	      break;
	
	    case 'insideLeft':
	      x += distance;
	      y += halfHeight;
	      textVerticalAlign = 'middle';
	      break;
	
	    case 'insideRight':
	      x += width - distance;
	      y += halfHeight;
	      textAlign = 'right';
	      textVerticalAlign = 'middle';
	      break;
	
	    case 'insideTop':
	      x += width / 2;
	      y += distance;
	      textAlign = 'center';
	      break;
	
	    case 'insideBottom':
	      x += width / 2;
	      y += height - distance;
	      textAlign = 'center';
	      textVerticalAlign = 'bottom';
	      break;
	
	    case 'insideTopLeft':
	      x += distance;
	      y += distance;
	      break;
	
	    case 'insideTopRight':
	      x += width - distance;
	      y += distance;
	      textAlign = 'right';
	      break;
	
	    case 'insideBottomLeft':
	      x += distance;
	      y += height - distance;
	      textVerticalAlign = 'bottom';
	      break;
	
	    case 'insideBottomRight':
	      x += width - distance;
	      y += height - distance;
	      textAlign = 'right';
	      textVerticalAlign = 'bottom';
	      break;
	  }
	
	  out = out || {};
	  out.x = x;
	  out.y = y;
	  out.textAlign = textAlign;
	  out.textVerticalAlign = textVerticalAlign;
	  return out;
	}
	/**
	 * To be removed. But still do not remove in case that some one has imported it.
	 * @deprecated
	 * @public
	 * @param {stirng} textPosition
	 * @param {Object} rect {x, y, width, height}
	 * @param {number} distance
	 * @return {Object} {x, y, textAlign, textVerticalAlign}
	 */
	
	
	function adjustTextPositionOnRect(textPosition, rect, distance) {
	  var dummyStyle = {
	    textPosition: textPosition,
	    textDistance: distance
	  };
	  return calculateTextPosition({}, dummyStyle, rect);
	}
	/**
	 * Show ellipsis if overflow.
	 *
	 * @public
	 * @param  {string} text
	 * @param  {string} containerWidth
	 * @param  {string} font
	 * @param  {number} [ellipsis='...']
	 * @param  {Object} [options]
	 * @param  {number} [options.maxIterations=3]
	 * @param  {number} [options.minChar=0] If truncate result are less
	 *                  then minChar, ellipsis will not show, which is
	 *                  better for user hint in some cases.
	 * @param  {number} [options.placeholder=''] When all truncated, use the placeholder.
	 * @return {string}
	 */
	
	
	function truncateText(text, containerWidth, font, ellipsis, options) {
	  if (!containerWidth) {
	    return '';
	  }
	
	  var textLines = (text + '').split('\n');
	  options = prepareTruncateOptions(containerWidth, font, ellipsis, options); // FIXME
	  // It is not appropriate that every line has '...' when truncate multiple lines.
	
	  for (var i = 0, len = textLines.length; i < len; i++) {
	    textLines[i] = truncateSingleLine(textLines[i], options);
	  }
	
	  return textLines.join('\n');
	}
	
	function prepareTruncateOptions(containerWidth, font, ellipsis, options) {
	  options = extend({}, options);
	  options.font = font;
	  var ellipsis = retrieve2(ellipsis, '...');
	  options.maxIterations = retrieve2(options.maxIterations, 2);
	  var minChar = options.minChar = retrieve2(options.minChar, 0); // FIXME
	  // Other languages?
	
	  options.cnCharWidth = getWidth('国', font); // FIXME
	  // Consider proportional font?
	
	  var ascCharWidth = options.ascCharWidth = getWidth('a', font);
	  options.placeholder = retrieve2(options.placeholder, ''); // Example 1: minChar: 3, text: 'asdfzxcv', truncate result: 'asdf', but not: 'a...'.
	  // Example 2: minChar: 3, text: '维度', truncate result: '维', but not: '...'.
	
	  var contentWidth = containerWidth = Math.max(0, containerWidth - 1); // Reserve some gap.
	
	  for (var i = 0; i < minChar && contentWidth >= ascCharWidth; i++) {
	    contentWidth -= ascCharWidth;
	  }
	
	  var ellipsisWidth = getWidth(ellipsis, font);
	
	  if (ellipsisWidth > contentWidth) {
	    ellipsis = '';
	    ellipsisWidth = 0;
	  }
	
	  contentWidth = containerWidth - ellipsisWidth;
	  options.ellipsis = ellipsis;
	  options.ellipsisWidth = ellipsisWidth;
	  options.contentWidth = contentWidth;
	  options.containerWidth = containerWidth;
	  return options;
	}
	
	function truncateSingleLine(textLine, options) {
	  var containerWidth = options.containerWidth;
	  var font = options.font;
	  var contentWidth = options.contentWidth;
	
	  if (!containerWidth) {
	    return '';
	  }
	
	  var lineWidth = getWidth(textLine, font);
	
	  if (lineWidth <= containerWidth) {
	    return textLine;
	  }
	
	  for (var j = 0;; j++) {
	    if (lineWidth <= contentWidth || j >= options.maxIterations) {
	      textLine += options.ellipsis;
	      break;
	    }
	
	    var subLength = j === 0 ? estimateLength(textLine, contentWidth, options.ascCharWidth, options.cnCharWidth) : lineWidth > 0 ? Math.floor(textLine.length * contentWidth / lineWidth) : 0;
	    textLine = textLine.substr(0, subLength);
	    lineWidth = getWidth(textLine, font);
	  }
	
	  if (textLine === '') {
	    textLine = options.placeholder;
	  }
	
	  return textLine;
	}
	
	function estimateLength(text, contentWidth, ascCharWidth, cnCharWidth) {
	  var width = 0;
	  var i = 0;
	
	  for (var len = text.length; i < len && width < contentWidth; i++) {
	    var charCode = text.charCodeAt(i);
	    width += 0 <= charCode && charCode <= 127 ? ascCharWidth : cnCharWidth;
	  }
	
	  return i;
	}
	/**
	 * @public
	 * @param {string} font
	 * @return {number} line height
	 */
	
	
	function getLineHeight(font) {
	  // FIXME A rough approach.
	  return getWidth('国', font);
	}
	/**
	 * @public
	 * @param {string} text
	 * @param {string} font
	 * @return {Object} width
	 */
	
	
	function measureText(text, font) {
	  return methods.measureText(text, font);
	} // Avoid assign to an exported variable, for transforming to cjs.
	
	
	methods.measureText = function (text, font) {
	  var ctx = getContext();
	  ctx.font = font || DEFAULT_FONT;
	  return ctx.measureText(text);
	};
	/**
	 * @public
	 * @param {string} text
	 * @param {string} font
	 * @param {Object} [truncate]
	 * @return {Object} block: {lineHeight, lines, height, outerHeight, canCacheByTextString}
	 *  Notice: for performance, do not calculate outerWidth util needed.
	 *  `canCacheByTextString` means the result `lines` is only determined by the input `text`.
	 *  Thus we can simply comparing the `input` text to determin whether the result changed,
	 *  without travel the result `lines`.
	 */
	
	
	function parsePlainText(text, font, padding, textLineHeight, truncate) {
	  text != null && (text += '');
	  var lineHeight = retrieve2(textLineHeight, getLineHeight(font));
	  var lines = text ? text.split('\n') : [];
	  var height = lines.length * lineHeight;
	  var outerHeight = height;
	  var canCacheByTextString = true;
	
	  if (padding) {
	    outerHeight += padding[0] + padding[2];
	  }
	
	  if (text && truncate) {
	    canCacheByTextString = false;
	    var truncOuterHeight = truncate.outerHeight;
	    var truncOuterWidth = truncate.outerWidth;
	
	    if (truncOuterHeight != null && outerHeight > truncOuterHeight) {
	      text = '';
	      lines = [];
	    } else if (truncOuterWidth != null) {
	      var options = prepareTruncateOptions(truncOuterWidth - (padding ? padding[1] + padding[3] : 0), font, truncate.ellipsis, {
	        minChar: truncate.minChar,
	        placeholder: truncate.placeholder
	      }); // FIXME
	      // It is not appropriate that every line has '...' when truncate multiple lines.
	
	      for (var i = 0, len = lines.length; i < len; i++) {
	        lines[i] = truncateSingleLine(lines[i], options);
	      }
	    }
	  }
	
	  return {
	    lines: lines,
	    height: height,
	    outerHeight: outerHeight,
	    lineHeight: lineHeight,
	    canCacheByTextString: canCacheByTextString
	  };
	}
	/**
	 * For example: 'some text {a|some text}other text{b|some text}xxx{c|}xxx'
	 * Also consider 'bbbb{a|xxx\nzzz}xxxx\naaaa'.
	 *
	 * @public
	 * @param {string} text
	 * @param {Object} style
	 * @return {Object} block
	 * {
	 *      width,
	 *      height,
	 *      lines: [{
	 *          lineHeight,
	 *          width,
	 *          tokens: [[{
	 *              styleName,
	 *              text,
	 *              width,      // include textPadding
	 *              height,     // include textPadding
	 *              textWidth, // pure text width
	 *              textHeight, // pure text height
	 *              lineHeihgt,
	 *              font,
	 *              textAlign,
	 *              textVerticalAlign
	 *          }], [...], ...]
	 *      }, ...]
	 * }
	 * If styleName is undefined, it is plain text.
	 */
	
	
	function parseRichText(text, style) {
	  var contentBlock = {
	    lines: [],
	    width: 0,
	    height: 0
	  };
	  text != null && (text += '');
	
	  if (!text) {
	    return contentBlock;
	  }
	
	  var lastIndex = STYLE_REG.lastIndex = 0;
	  var result;
	
	  while ((result = STYLE_REG.exec(text)) != null) {
	    var matchedIndex = result.index;
	
	    if (matchedIndex > lastIndex) {
	      pushTokens(contentBlock, text.substring(lastIndex, matchedIndex));
	    }
	
	    pushTokens(contentBlock, result[2], result[1]);
	    lastIndex = STYLE_REG.lastIndex;
	  }
	
	  if (lastIndex < text.length) {
	    pushTokens(contentBlock, text.substring(lastIndex, text.length));
	  }
	
	  var lines = contentBlock.lines;
	  var contentHeight = 0;
	  var contentWidth = 0; // For `textWidth: 100%`
	
	  var pendingList = [];
	  var stlPadding = style.textPadding;
	  var truncate = style.truncate;
	  var truncateWidth = truncate && truncate.outerWidth;
	  var truncateHeight = truncate && truncate.outerHeight;
	
	  if (stlPadding) {
	    truncateWidth != null && (truncateWidth -= stlPadding[1] + stlPadding[3]);
	    truncateHeight != null && (truncateHeight -= stlPadding[0] + stlPadding[2]);
	  } // Calculate layout info of tokens.
	
	
	  for (var i = 0; i < lines.length; i++) {
	    var line = lines[i];
	    var lineHeight = 0;
	    var lineWidth = 0;
	
	    for (var j = 0; j < line.tokens.length; j++) {
	      var token = line.tokens[j];
	      var tokenStyle = token.styleName && style.rich[token.styleName] || {}; // textPadding should not inherit from style.
	
	      var textPadding = token.textPadding = tokenStyle.textPadding; // textFont has been asigned to font by `normalizeStyle`.
	
	      var font = token.font = tokenStyle.font || style.font; // textHeight can be used when textVerticalAlign is specified in token.
	
	      var tokenHeight = token.textHeight = retrieve2( // textHeight should not be inherited, consider it can be specified
	      // as box height of the block.
	      tokenStyle.textHeight, getLineHeight(font));
	      textPadding && (tokenHeight += textPadding[0] + textPadding[2]);
	      token.height = tokenHeight;
	      token.lineHeight = retrieve3(tokenStyle.textLineHeight, style.textLineHeight, tokenHeight);
	      token.textAlign = tokenStyle && tokenStyle.textAlign || style.textAlign;
	      token.textVerticalAlign = tokenStyle && tokenStyle.textVerticalAlign || 'middle';
	
	      if (truncateHeight != null && contentHeight + token.lineHeight > truncateHeight) {
	        return {
	          lines: [],
	          width: 0,
	          height: 0
	        };
	      }
	
	      token.textWidth = getWidth(token.text, font);
	      var tokenWidth = tokenStyle.textWidth;
	      var tokenWidthNotSpecified = tokenWidth == null || tokenWidth === 'auto'; // Percent width, can be `100%`, can be used in drawing separate
	      // line when box width is needed to be auto.
	
	      if (typeof tokenWidth === 'string' && tokenWidth.charAt(tokenWidth.length - 1) === '%') {
	        token.percentWidth = tokenWidth;
	        pendingList.push(token);
	        tokenWidth = 0; // Do not truncate in this case, because there is no user case
	        // and it is too complicated.
	      } else {
	        if (tokenWidthNotSpecified) {
	          tokenWidth = token.textWidth; // FIXME: If image is not loaded and textWidth is not specified, calling
	          // `getBoundingRect()` will not get correct result.
	
	          var textBackgroundColor = tokenStyle.textBackgroundColor;
	          var bgImg = textBackgroundColor && textBackgroundColor.image; // Use cases:
	          // (1) If image is not loaded, it will be loaded at render phase and call
	          // `dirty()` and `textBackgroundColor.image` will be replaced with the loaded
	          // image, and then the right size will be calculated here at the next tick.
	          // See `graphic/helper/text.js`.
	          // (2) If image loaded, and `textBackgroundColor.image` is image src string,
	          // use `imageHelper.findExistImage` to find cached image.
	          // `imageHelper.findExistImage` will always be called here before
	          // `imageHelper.createOrUpdateImage` in `graphic/helper/text.js#renderRichText`
	          // which ensures that image will not be rendered before correct size calcualted.
	
	          if (bgImg) {
	            bgImg = imageHelper.findExistImage(bgImg);
	
	            if (imageHelper.isImageReady(bgImg)) {
	              tokenWidth = Math.max(tokenWidth, bgImg.width * tokenHeight / bgImg.height);
	            }
	          }
	        }
	
	        var paddingW = textPadding ? textPadding[1] + textPadding[3] : 0;
	        tokenWidth += paddingW;
	        var remianTruncWidth = truncateWidth != null ? truncateWidth - lineWidth : null;
	
	        if (remianTruncWidth != null && remianTruncWidth < tokenWidth) {
	          if (!tokenWidthNotSpecified || remianTruncWidth < paddingW) {
	            token.text = '';
	            token.textWidth = tokenWidth = 0;
	          } else {
	            token.text = truncateText(token.text, remianTruncWidth - paddingW, font, truncate.ellipsis, {
	              minChar: truncate.minChar
	            });
	            token.textWidth = getWidth(token.text, font);
	            tokenWidth = token.textWidth + paddingW;
	          }
	        }
	      }
	
	      lineWidth += token.width = tokenWidth;
	      tokenStyle && (lineHeight = Math.max(lineHeight, token.lineHeight));
	    }
	
	    line.width = lineWidth;
	    line.lineHeight = lineHeight;
	    contentHeight += lineHeight;
	    contentWidth = Math.max(contentWidth, lineWidth);
	  }
	
	  contentBlock.outerWidth = contentBlock.width = retrieve2(style.textWidth, contentWidth);
	  contentBlock.outerHeight = contentBlock.height = retrieve2(style.textHeight, contentHeight);
	
	  if (stlPadding) {
	    contentBlock.outerWidth += stlPadding[1] + stlPadding[3];
	    contentBlock.outerHeight += stlPadding[0] + stlPadding[2];
	  }
	
	  for (var i = 0; i < pendingList.length; i++) {
	    var token = pendingList[i];
	    var percentWidth = token.percentWidth; // Should not base on outerWidth, because token can not be placed out of padding.
	
	    token.width = parseInt(percentWidth, 10) / 100 * contentWidth;
	  }
	
	  return contentBlock;
	}
	
	function pushTokens(block, str, styleName) {
	  var isEmptyStr = str === '';
	  var strs = str.split('\n');
	  var lines = block.lines;
	
	  for (var i = 0; i < strs.length; i++) {
	    var text = strs[i];
	    var token = {
	      styleName: styleName,
	      text: text,
	      isLineHolder: !text && !isEmptyStr
	    }; // The first token should be appended to the last line.
	
	    if (!i) {
	      var tokens = (lines[lines.length - 1] || (lines[0] = {
	        tokens: []
	      })).tokens; // Consider cases:
	      // (1) ''.split('\n') => ['', '\n', ''], the '' at the first item
	      // (which is a placeholder) should be replaced by new token.
	      // (2) A image backage, where token likes {a|}.
	      // (3) A redundant '' will affect textAlign in line.
	      // (4) tokens with the same tplName should not be merged, because
	      // they should be displayed in different box (with border and padding).
	
	      var tokensLen = tokens.length;
	      tokensLen === 1 && tokens[0].isLineHolder ? tokens[0] = token : // Consider text is '', only insert when it is the "lineHolder" or
	      // "emptyStr". Otherwise a redundant '' will affect textAlign in line.
	      (text || !tokensLen || isEmptyStr) && tokens.push(token);
	    } // Other tokens always start a new line.
	    else {
	        // If there is '', insert it as a placeholder.
	        lines.push({
	          tokens: [token]
	        });
	      }
	  }
	}
	
	function makeFont(style) {
	  // FIXME in node-canvas fontWeight is before fontStyle
	  // Use `fontSize` `fontFamily` to check whether font properties are defined.
	  var font = (style.fontSize || style.fontFamily) && [style.fontStyle, style.fontWeight, (style.fontSize || 12) + 'px', // If font properties are defined, `fontFamily` should not be ignored.
	  style.fontFamily || 'sans-serif'].join(' ');
	  return font && trim(font) || style.textFont || style.font;
	}
	
	exports.DEFAULT_FONT = DEFAULT_FONT;
	exports.$override = $override;
	exports.getWidth = getWidth;
	exports.getBoundingRect = getBoundingRect;
	exports.adjustTextX = adjustTextX;
	exports.adjustTextY = adjustTextY;
	exports.calculateTextPosition = calculateTextPosition;
	exports.adjustTextPositionOnRect = adjustTextPositionOnRect;
	exports.truncateText = truncateText;
	exports.getLineHeight = getLineHeight;
	exports.measureText = measureText;
	exports.parsePlainText = parsePlainText;
	exports.parseRichText = parseRichText;
	exports.makeFont = makeFont;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	var arrayWithHoles = __webpack_require__(566);
	
	var iterableToArrayLimit = __webpack_require__(1104);
	
	var unsupportedIterableToArray = __webpack_require__(392);
	
	var nonIterableRest = __webpack_require__(569);
	
	function _slicedToArray(arr, i) {
	  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
	}
	
	module.exports = _slicedToArray;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var userComponentRegistry_1 = __webpack_require__(420);
	var agComponentUtils_1 = __webpack_require__(418);
	var componentMetadataProvider_1 = __webpack_require__(419);
	var utils_1 = __webpack_require__(10);
	var ComponentSource;
	(function (ComponentSource) {
	    ComponentSource[ComponentSource["DEFAULT"] = 0] = "DEFAULT";
	    ComponentSource[ComponentSource["REGISTERED_BY_NAME"] = 1] = "REGISTERED_BY_NAME";
	    ComponentSource[ComponentSource["HARDCODED"] = 2] = "HARDCODED";
	})(ComponentSource = exports.ComponentSource || (exports.ComponentSource = {}));
	var UserComponentFactory = /** @class */ (function () {
	    function UserComponentFactory() {
	    }
	    UserComponentFactory.prototype.newDateComponent = function (params) {
	        return this.createAndInitUserComponent(this.gridOptions, params, "dateComponent", "agDateInput");
	    };
	    UserComponentFactory.prototype.newHeaderComponent = function (params) {
	        return this.createAndInitUserComponent(params.column.getColDef(), params, "headerComponent", "agColumnHeader");
	    };
	    UserComponentFactory.prototype.newHeaderGroupComponent = function (params) {
	        return this.createAndInitUserComponent(params.columnGroup.getColGroupDef(), params, "headerGroupComponent", "agColumnGroupHeader");
	    };
	    UserComponentFactory.prototype.newFullWidthGroupRowInnerCellRenderer = function (params) {
	        return this.createAndInitUserComponent(this.gridOptions, params, "groupRowInnerRenderer", null, true);
	    };
	    // this one is unusual, as it can be LoadingCellRenderer, DetailCellRenderer, FullWidthCellRenderer or GroupRowRenderer.
	    // so we have to pass the type in.
	    UserComponentFactory.prototype.newFullWidthCellRenderer = function (params, cellRendererType, cellRendererName) {
	        return this.createAndInitUserComponent(null, params, cellRendererType, cellRendererName);
	    };
	    UserComponentFactory.prototype.newCellRenderer = function (target, params) {
	        return this.createAndInitUserComponent(target, params, "cellRenderer", null, true);
	    };
	    UserComponentFactory.prototype.newPinnedRowCellRenderer = function (target, params) {
	        return this.createAndInitUserComponent(target, params, "pinnedRowCellRenderer", null, true);
	    };
	    UserComponentFactory.prototype.newCellEditor = function (colDef, params) {
	        return this.createAndInitUserComponent(colDef, params, 'cellEditor', 'agCellEditor');
	    };
	    UserComponentFactory.prototype.newInnerCellRenderer = function (target, params) {
	        return this.createAndInitUserComponent(target, params, "innerRenderer", null);
	    };
	    UserComponentFactory.prototype.newLoadingOverlayComponent = function (params) {
	        return this.createAndInitUserComponent(this.gridOptions, params, "loadingOverlayComponent", "agLoadingOverlay");
	    };
	    UserComponentFactory.prototype.newNoRowsOverlayComponent = function (params) {
	        return this.createAndInitUserComponent(this.gridOptions, params, "noRowsOverlayComponent", "agNoRowsOverlay");
	    };
	    UserComponentFactory.prototype.newTooltipComponent = function (params) {
	        var colDef = params.colDef;
	        return this.createAndInitUserComponent(colDef, params, "tooltipComponent", 'agTooltipComponent');
	    };
	    UserComponentFactory.prototype.newFilterComponent = function (colDef, params, defaultFilter, modifyParamsCallback) {
	        return this.createAndInitUserComponent(colDef, params, 'filter', defaultFilter, false, modifyParamsCallback);
	    };
	    UserComponentFactory.prototype.newFloatingFilterComponent = function (colDef, params, defaultFloatingFilter) {
	        return this.createAndInitUserComponent(colDef, params, "floatingFilterComponent", defaultFloatingFilter, true);
	    };
	    UserComponentFactory.prototype.newToolPanelComponent = function (toolPanelDef, params) {
	        return this.createAndInitUserComponent(toolPanelDef, params, 'toolPanel');
	    };
	    UserComponentFactory.prototype.newStatusPanelComponent = function (def, params) {
	        return this.createAndInitUserComponent(def, params, 'statusPanel');
	    };
	    /**
	     * This method creates a component given everything needed to guess what sort of component needs to be instantiated
	     * It takes
	     *  @param definitionObject: This is the context for which this component needs to be created, it can be gridOptions
	     *      (global) or columnDef mostly.
	     *  @param paramsFromGrid: Params to be passed to the component and passed by ag-Grid. This will get merged with any params
	     *      specified by the user in the configuration
	     *  @param propertyName: The name of the property used in ag-grid as a convention to refer to the component, it can be:
	     *      'floatingFilter', 'cellRenderer', is used to find if the user is specifying a custom component
	     *  @param defaultComponentName: The actual name of the component to instantiate, this is usually the same as propertyName, but in
	     *      some cases is not, like floatingFilter, if it is the same is not necessary to specify
	     *  @param optional: Handy method to tell if this should return a component ALWAYS. if that is the case, but there is no
	     *      component found, it throws an error, by default all components are MANDATORY
	     *  @param modifyParamsCallback: A chance to customise the params passed to the init method. It receives what the current
	     *  params are and the component that init is about to get called for
	     */
	    UserComponentFactory.prototype.createAndInitUserComponent = function (definitionObject, paramsFromGrid, propertyName, defaultComponentName, 
	    // optional items are: FloatingFilter, CellComp (for cellRenderer)
	    optional, 
	    // used by FilterManager only
	    modifyParamsCallback) {
	        if (optional === void 0) { optional = false; }
	        if (!definitionObject) {
	            definitionObject = this.gridOptions;
	        }
	        // Create the component instance
	        var componentAndParams = this.createComponentInstance(definitionObject, propertyName, paramsFromGrid, defaultComponentName, optional);
	        if (!componentAndParams) {
	            return null;
	        }
	        var componentInstance = componentAndParams.componentInstance;
	        // Wire the component and call the init method with the correct params
	        var params = this.createFinalParams(definitionObject, propertyName, paramsFromGrid, componentAndParams.paramsFromSelector);
	        this.addReactHacks(params);
	        // give caller chance to set any params that depend on the componentInstance (need here as the
	        // componentInstance was not available when createUserComponent was called)
	        var paramsAfterCallback = modifyParamsCallback ? modifyParamsCallback(params, componentInstance) : params;
	        var deferredInit = this.initComponent(componentInstance, paramsAfterCallback);
	        if (deferredInit == null) {
	            // const p = new Promise<A>(resolve => {
	            //     setTimeout( ()=> {
	            //         resolve(componentInstance);
	            //     }, 1000);
	            // });
	            // return p;
	            return utils_1.Promise.resolve(componentInstance);
	        }
	        else {
	            var asPromise = deferredInit;
	            return asPromise.map(function (notRelevant) { return componentInstance; });
	        }
	    };
	    UserComponentFactory.prototype.addReactHacks = function (params) {
	        // a temporary fix for AG-1574
	        // AG-1715 raised to do a wider ranging refactor to improve this
	        var agGridReact = this.context.getBean('agGridReact');
	        if (agGridReact) {
	            params.agGridReact = utils_1._.cloneObject(agGridReact);
	        }
	        // AG-1716 - directly related to AG-1574 and AG-1715
	        var frameworkComponentWrapper = this.context.getBean('frameworkComponentWrapper');
	        if (frameworkComponentWrapper) {
	            params.frameworkComponentWrapper = frameworkComponentWrapper;
	        }
	    };
	    /**
	     * This method creates a component given everything needed to guess what sort of component needs to be instantiated
	     * It takes
	     *  @param clazz: The class to instantiate,
	     *  @param agGridParams: Params to be passed to the component and passed by ag-Grid. This will get merged with any params
	     *      specified by the user in the configuration
	     *  @param modifyParamsCallback: A chance to customise the params passed to the init method. It receives what the current
	     *  params are and the component that init is about to get called for
	     */
	    UserComponentFactory.prototype.createUserComponentFromConcreteClass = function (clazz, agGridParams) {
	        var internalComponent = new clazz();
	        this.initComponent(internalComponent, agGridParams);
	        return internalComponent;
	    };
	    /**
	     * This method returns the underlying representation of the component to be created. ie for Javascript the
	     * underlying function where we should be calling new into. In case of the frameworks, the framework class
	     * object that represents the component to be created.
	     *
	     * This method is handy for different reasons, for example if you want to check if a component has a particular
	     * method implemented without having to create the component, just by inspecting the source component
	     *
	     * It takes
	     *  @param definitionObject: This is the context for which this component needs to be created, it can be gridOptions
	     *      (global) or columnDef mostly.
	     *  @param propertyName: The name of the property used in ag-grid as a convention to refer to the component, it can be:
	     *      'floatingFilter', 'cellRenderer', is used to find if the user is specifying a custom component
	     *  @param params: Params to be passed to the dynamic component function in case it needs to be
	     *      invoked
	     *  @param defaultComponentName: The name of the component to load if there is no component specified
	     */
	    UserComponentFactory.prototype.lookupComponentClassDef = function (definitionObject, propertyName, params, defaultComponentName) {
	        if (params === void 0) { params = null; }
	        /**
	         * There are five things that can happen when resolving a component.
	         *  a) HardcodedFwComponent: That holder[propertyName]Framework has associated a Framework native component
	         *  b) HardcodedJsComponent: That holder[propertyName] has associate a JS component
	         *  c) hardcodedJsFunction: That holder[propertyName] has associate a JS function
	         *  d) hardcodedNameComponent: That holder[propertyName] has associate a string that represents a component to load
	         *  e) That none of the three previous are specified, then we need to use the DefaultRegisteredComponent
	         */
	        var hardcodedNameComponent = null;
	        var HardcodedJsComponent = null;
	        var hardcodedJsFunction = null;
	        var HardcodedFwComponent = null;
	        var componentSelectorFunc;
	        if (definitionObject != null) {
	            var componentPropertyValue = definitionObject[propertyName];
	            // for filters only, we allow 'true' for the component, which means default filter to be used
	            var usingDefaultComponent = componentPropertyValue === true;
	            if (componentPropertyValue != null && !usingDefaultComponent) {
	                if (typeof componentPropertyValue === 'string') {
	                    hardcodedNameComponent = componentPropertyValue;
	                }
	                else if (typeof componentPropertyValue === 'boolean') {
	                    // never happens, as we test for usingDefaultComponent above,
	                    // however it's needed for the next block to compile
	                }
	                else if (this.agComponentUtils.doesImplementIComponent(componentPropertyValue)) {
	                    HardcodedJsComponent = componentPropertyValue;
	                }
	                else {
	                    hardcodedJsFunction = componentPropertyValue;
	                }
	            }
	            HardcodedFwComponent = definitionObject[propertyName + "Framework"];
	            componentSelectorFunc = definitionObject[propertyName + "Selector"];
	        }
	        /**
	         * Since we allow many types of flavors for specifying the components, let's make sure this is not an illegal
	         * combination
	         */
	        if ((HardcodedJsComponent && HardcodedFwComponent) ||
	            (hardcodedNameComponent && HardcodedFwComponent) ||
	            (hardcodedJsFunction && HardcodedFwComponent)) {
	            throw Error("ag-grid: you are trying to specify: " + propertyName + " twice as a component.");
	        }
	        if (HardcodedFwComponent && !this.frameworkComponentWrapper) {
	            throw Error("ag-grid: you are specifying a framework component but you are not using a framework version of ag-grid for : " + propertyName);
	        }
	        if (componentSelectorFunc && (hardcodedNameComponent || HardcodedJsComponent || hardcodedJsFunction || HardcodedFwComponent)) {
	            throw Error("ag-grid: you can't specify both, the selector and the component of ag-grid for : " + propertyName);
	        }
	        /**
	         * At this stage we are guaranteed to either have,
	         * DEPRECATED
	         * - A unique HardcodedFwComponent
	         * - A unique HardcodedJsComponent
	         * - A unique hardcodedJsFunction
	         * BY NAME- FAVOURED APPROACH
	         * - A unique hardcodedNameComponent
	         * - None of the previous, hence we revert to: RegisteredComponent
	         */
	        if (HardcodedFwComponent) {
	            // console.warn(`ag-grid: Since version 12.1.0 specifying a component directly is deprecated, you should register the component by name`);
	            // console.warn(`${HardcodedFwComponent}`);
	            return {
	                componentFromFramework: true,
	                component: HardcodedFwComponent,
	                source: ComponentSource.HARDCODED,
	                paramsFromSelector: null
	            };
	        }
	        if (HardcodedJsComponent) {
	            // console.warn(`ag-grid: Since version 12.1.0 specifying a component directly is deprecated, you should register the component by name`);
	            // console.warn(`${HardcodedJsComponent}`);
	            return {
	                componentFromFramework: false,
	                component: HardcodedJsComponent,
	                source: ComponentSource.HARDCODED,
	                paramsFromSelector: null
	            };
	        }
	        if (hardcodedJsFunction) {
	            // console.warn(`ag-grid: Since version 12.1.0 specifying a function directly is deprecated, you should register the component by name`);
	            // console.warn(`${hardcodedJsFunction}`);
	            return this.agComponentUtils.adaptFunction(propertyName, hardcodedJsFunction, false, ComponentSource.HARDCODED);
	        }
	        var selectorResult = componentSelectorFunc ? componentSelectorFunc(params) : null;
	        var componentNameToUse;
	        if (selectorResult && selectorResult.component) {
	            componentNameToUse = selectorResult.component;
	        }
	        else if (hardcodedNameComponent) {
	            componentNameToUse = hardcodedNameComponent;
	        }
	        else {
	            componentNameToUse = defaultComponentName;
	        }
	        if (!componentNameToUse) {
	            return null;
	        }
	        var registeredCompClassDef = this.lookupFromRegisteredComponents(propertyName, componentNameToUse);
	        return {
	            componentFromFramework: registeredCompClassDef.componentFromFramework,
	            component: registeredCompClassDef.component,
	            source: registeredCompClassDef.source,
	            paramsFromSelector: selectorResult ? selectorResult.params : null
	        };
	    };
	    UserComponentFactory.prototype.lookupFromRegisteredComponents = function (propertyName, componentNameOpt) {
	        var componentName = componentNameOpt != null ? componentNameOpt : propertyName;
	        var registeredComponent = this.userComponentRegistry.retrieve(componentName);
	        if (registeredComponent == null) {
	            return null;
	        }
	        //If it is a FW it has to be registered as a component
	        if (registeredComponent.componentFromFramework) {
	            return {
	                component: registeredComponent.component,
	                componentFromFramework: true,
	                source: ComponentSource.REGISTERED_BY_NAME,
	                paramsFromSelector: null
	            };
	        }
	        //If it is JS it may be a function or a component
	        if (this.agComponentUtils.doesImplementIComponent(registeredComponent.component)) {
	            return {
	                component: registeredComponent.component,
	                componentFromFramework: false,
	                source: (registeredComponent.source == userComponentRegistry_1.RegisteredComponentSource.REGISTERED) ? ComponentSource.REGISTERED_BY_NAME : ComponentSource.DEFAULT,
	                paramsFromSelector: null
	            };
	        }
	        // This is a function
	        return this.agComponentUtils.adaptFunction(propertyName, registeredComponent.component, registeredComponent.componentFromFramework, (registeredComponent.source == userComponentRegistry_1.RegisteredComponentSource.REGISTERED) ? ComponentSource.REGISTERED_BY_NAME : ComponentSource.DEFAULT);
	    };
	    /**
	     * Useful to check what would be the resultant params for a given object
	     *  @param definitionObject: This is the context for which this component needs to be created, it can be gridOptions
	     *      (global) or columnDef mostly.
	     *  @param propertyName: The name of the property used in ag-grid as a convention to refer to the component, it can be:
	     *      'floatingFilter', 'cellRenderer', is used to find if the user is specifying a custom component
	     *  @param paramsFromGrid: Params to be passed to the component and passed by ag-Grid. This will get merged with any params
	     *      specified by the user in the configuration
	     * @returns {any} It merges the user agGridParams with the actual params specified by the user.
	     */
	    UserComponentFactory.prototype.createFinalParams = function (definitionObject, propertyName, paramsFromGrid, paramsFromSelector) {
	        if (paramsFromSelector === void 0) { paramsFromSelector = null; }
	        var res = {};
	        utils_1._.mergeDeep(res, paramsFromGrid);
	        var userParams = definitionObject ? definitionObject[propertyName + "Params"] : null;
	        if (userParams != null) {
	            if (typeof userParams === 'function') {
	                utils_1._.mergeDeep(res, userParams(paramsFromGrid));
	            }
	            else if (typeof userParams === 'object') {
	                utils_1._.mergeDeep(res, userParams);
	            }
	        }
	        utils_1._.mergeDeep(res, paramsFromSelector);
	        return res;
	    };
	    UserComponentFactory.prototype.createComponentInstance = function (holder, propertyName, paramsForSelector, defaultComponentName, optional) {
	        var componentToUse = this.lookupComponentClassDef(holder, propertyName, paramsForSelector, defaultComponentName);
	        var missing = !componentToUse || !componentToUse.component;
	        if (missing) {
	            if (!optional) {
	                console.error("Error creating component " + propertyName + "=>" + defaultComponentName);
	            }
	            return null;
	        }
	        var componentInstance;
	        if (componentToUse.componentFromFramework) {
	            // Using framework component
	            var FrameworkComponentRaw = componentToUse.component;
	            var thisComponentConfig = this.componentMetadataProvider.retrieve(propertyName);
	            componentInstance = this.frameworkComponentWrapper.wrap(FrameworkComponentRaw, thisComponentConfig.mandatoryMethodList, thisComponentConfig.optionalMethodList, defaultComponentName);
	        }
	        else {
	            // Using plain JavaScript component
	            componentInstance = new componentToUse.component();
	        }
	        return { componentInstance: componentInstance, paramsFromSelector: componentToUse.paramsFromSelector };
	    };
	    UserComponentFactory.prototype.initComponent = function (component, finalParams) {
	        this.context.wireBean(component);
	        if (component.init == null) {
	            return;
	        }
	        else {
	            return component.init(finalParams);
	        }
	    };
	    __decorate([
	        context_1.Autowired("gridOptions"),
	        __metadata("design:type", Object)
	    ], UserComponentFactory.prototype, "gridOptions", void 0);
	    __decorate([
	        context_1.Autowired("gridOptionsWrapper"),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], UserComponentFactory.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired("context"),
	        __metadata("design:type", context_1.Context)
	    ], UserComponentFactory.prototype, "context", void 0);
	    __decorate([
	        context_1.Autowired("agComponentUtils"),
	        __metadata("design:type", agComponentUtils_1.AgComponentUtils)
	    ], UserComponentFactory.prototype, "agComponentUtils", void 0);
	    __decorate([
	        context_1.Autowired("componentMetadataProvider"),
	        __metadata("design:type", componentMetadataProvider_1.ComponentMetadataProvider)
	    ], UserComponentFactory.prototype, "componentMetadataProvider", void 0);
	    __decorate([
	        context_1.Autowired("userComponentRegistry"),
	        __metadata("design:type", userComponentRegistry_1.UserComponentRegistry)
	    ], UserComponentFactory.prototype, "userComponentRegistry", void 0);
	    __decorate([
	        context_1.Optional("frameworkComponentWrapper"),
	        __metadata("design:type", Object)
	    ], UserComponentFactory.prototype, "frameworkComponentWrapper", void 0);
	    UserComponentFactory = __decorate([
	        context_1.Bean('userComponentFactory')
	    ], UserComponentFactory);
	    return UserComponentFactory;
	}());
	exports.UserComponentFactory = UserComponentFactory;


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var logger_1 = __webpack_require__(68);
	var context_1 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var dragService_1 = __webpack_require__(158);
	var columnController_1 = __webpack_require__(26);
	var environment_1 = __webpack_require__(247);
	var utils_1 = __webpack_require__(10);
	var DragSourceType;
	(function (DragSourceType) {
	    DragSourceType[DragSourceType["ToolPanel"] = 0] = "ToolPanel";
	    DragSourceType[DragSourceType["HeaderCell"] = 1] = "HeaderCell";
	    DragSourceType[DragSourceType["RowDrag"] = 2] = "RowDrag";
	})(DragSourceType = exports.DragSourceType || (exports.DragSourceType = {}));
	var VDirection;
	(function (VDirection) {
	    VDirection[VDirection["Up"] = 0] = "Up";
	    VDirection[VDirection["Down"] = 1] = "Down";
	})(VDirection = exports.VDirection || (exports.VDirection = {}));
	var HDirection;
	(function (HDirection) {
	    HDirection[HDirection["Left"] = 0] = "Left";
	    HDirection[HDirection["Right"] = 1] = "Right";
	})(HDirection = exports.HDirection || (exports.HDirection = {}));
	var DragAndDropService = /** @class */ (function () {
	    function DragAndDropService() {
	        this.dragSourceAndParamsList = [];
	        this.dropTargets = [];
	    }
	    DragAndDropService_1 = DragAndDropService;
	    DragAndDropService.prototype.init = function () {
	        this.ePinnedIcon = utils_1._.createIcon('columnMovePin', this.gridOptionsWrapper, null);
	        this.ePlusIcon = utils_1._.createIcon('columnMoveAdd', this.gridOptionsWrapper, null);
	        this.eHiddenIcon = utils_1._.createIcon('columnMoveHide', this.gridOptionsWrapper, null);
	        this.eMoveIcon = utils_1._.createIcon('columnMoveMove', this.gridOptionsWrapper, null);
	        this.eLeftIcon = utils_1._.createIcon('columnMoveLeft', this.gridOptionsWrapper, null);
	        this.eRightIcon = utils_1._.createIcon('columnMoveRight', this.gridOptionsWrapper, null);
	        this.eGroupIcon = utils_1._.createIcon('columnMoveGroup', this.gridOptionsWrapper, null);
	        this.eAggregateIcon = utils_1._.createIcon('columnMoveValue', this.gridOptionsWrapper, null);
	        this.ePivotIcon = utils_1._.createIcon('columnMovePivot', this.gridOptionsWrapper, null);
	        this.eDropNotAllowedIcon = utils_1._.createIcon('dropNotAllowed', this.gridOptionsWrapper, null);
	    };
	    DragAndDropService.prototype.setBeans = function (loggerFactory) {
	        this.logger = loggerFactory.create('OldToolPanelDragAndDropService');
	    };
	    DragAndDropService.prototype.getStringType = function (type) {
	        switch (type) {
	            case DragSourceType.RowDrag: return 'row';
	            case DragSourceType.HeaderCell: return 'headerCell';
	            case DragSourceType.ToolPanel: return 'toolPanel';
	            default:
	                console.warn("ag-Grid: bug - unknown drag type " + type);
	                return null;
	        }
	    };
	    DragAndDropService.prototype.addDragSource = function (dragSource, allowTouch) {
	        if (allowTouch === void 0) { allowTouch = false; }
	        var params = {
	            eElement: dragSource.eElement,
	            dragStartPixels: dragSource.dragStartPixels,
	            onDragStart: this.onDragStart.bind(this, dragSource),
	            onDragStop: this.onDragStop.bind(this),
	            onDragging: this.onDragging.bind(this)
	        };
	        this.dragSourceAndParamsList.push({ params: params, dragSource: dragSource });
	        this.dragService.addDragSource(params, allowTouch);
	    };
	    DragAndDropService.prototype.removeDragSource = function (dragSource) {
	        var sourceAndParams = utils_1._.find(this.dragSourceAndParamsList, function (item) { return item.dragSource === dragSource; });
	        if (sourceAndParams) {
	            this.dragService.removeDragSource(sourceAndParams.params);
	            utils_1._.removeFromArray(this.dragSourceAndParamsList, sourceAndParams);
	        }
	    };
	    DragAndDropService.prototype.destroy = function () {
	        var _this = this;
	        this.dragSourceAndParamsList.forEach(function (sourceAndParams) {
	            _this.dragService.removeDragSource(sourceAndParams.params);
	        });
	        this.dragSourceAndParamsList.length = 0;
	    };
	    DragAndDropService.prototype.nudge = function () {
	        if (this.dragging) {
	            this.onDragging(this.eventLastTime, true);
	        }
	    };
	    DragAndDropService.prototype.onDragStart = function (dragSource, mouseEvent) {
	        this.dragging = true;
	        this.dragSource = dragSource;
	        this.eventLastTime = mouseEvent;
	        this.dragItem = this.dragSource.dragItemCallback();
	        this.lastDropTarget = this.dragSource.dragSourceDropTarget;
	        if (this.dragSource.dragStarted) {
	            this.dragSource.dragStarted();
	        }
	        this.createGhost();
	    };
	    DragAndDropService.prototype.onDragStop = function (mouseEvent) {
	        this.eventLastTime = null;
	        this.dragging = false;
	        if (this.dragSource.dragStopped) {
	            this.dragSource.dragStopped();
	        }
	        if (this.lastDropTarget && this.lastDropTarget.onDragStop) {
	            var draggingEvent = this.createDropTargetEvent(this.lastDropTarget, mouseEvent, null, null, false);
	            this.lastDropTarget.onDragStop(draggingEvent);
	        }
	        this.lastDropTarget = null;
	        this.dragItem = null;
	        this.removeGhost();
	    };
	    DragAndDropService.prototype.onDragging = function (mouseEvent, fromNudge) {
	        var hDirection = this.workOutHDirection(mouseEvent);
	        var vDirection = this.workOutVDirection(mouseEvent);
	        this.eventLastTime = mouseEvent;
	        this.positionGhost(mouseEvent);
	        // check if mouseEvent intersects with any of the drop targets
	        var dropTarget = utils_1._.find(this.dropTargets, this.isMouseOnDropTarget.bind(this, mouseEvent));
	        if (dropTarget !== this.lastDropTarget) {
	            this.leaveLastTargetIfExists(mouseEvent, hDirection, vDirection, fromNudge);
	            this.enterDragTargetIfExists(dropTarget, mouseEvent, hDirection, vDirection, fromNudge);
	            this.lastDropTarget = dropTarget;
	        }
	        else if (dropTarget) {
	            var draggingEvent = this.createDropTargetEvent(dropTarget, mouseEvent, hDirection, vDirection, fromNudge);
	            dropTarget.onDragging(draggingEvent);
	        }
	    };
	    DragAndDropService.prototype.enterDragTargetIfExists = function (dropTarget, mouseEvent, hDirection, vDirection, fromNudge) {
	        if (!dropTarget) {
	            return;
	        }
	        var dragEnterEvent = this.createDropTargetEvent(dropTarget, mouseEvent, hDirection, vDirection, fromNudge);
	        dropTarget.onDragEnter(dragEnterEvent);
	        this.setGhostIcon(dropTarget.getIconName ? dropTarget.getIconName() : null);
	    };
	    DragAndDropService.prototype.leaveLastTargetIfExists = function (mouseEvent, hDirection, vDirection, fromNudge) {
	        if (!this.lastDropTarget) {
	            return;
	        }
	        var dragLeaveEvent = this.createDropTargetEvent(this.lastDropTarget, mouseEvent, hDirection, vDirection, fromNudge);
	        this.lastDropTarget.onDragLeave(dragLeaveEvent);
	        this.setGhostIcon(null);
	    };
	    DragAndDropService.prototype.getAllContainersFromDropTarget = function (dropTarget) {
	        var containers = [dropTarget.getContainer()];
	        var secondaryContainers = dropTarget.getSecondaryContainers ? dropTarget.getSecondaryContainers() : null;
	        if (secondaryContainers) {
	            containers = containers.concat(secondaryContainers);
	        }
	        return containers;
	    };
	    // checks if the mouse is on the drop target. it checks eContainer and eSecondaryContainers
	    DragAndDropService.prototype.isMouseOnDropTarget = function (mouseEvent, dropTarget) {
	        var allContainers = this.getAllContainersFromDropTarget(dropTarget);
	        var mouseOverTarget = false;
	        allContainers.forEach(function (eContainer) {
	            if (!eContainer) {
	                return;
	            } // secondary can be missing
	            var rect = eContainer.getBoundingClientRect();
	            // if element is not visible, then width and height are zero
	            if (rect.width === 0 || rect.height === 0) {
	                return;
	            }
	            var horizontalFit = mouseEvent.clientX >= rect.left && mouseEvent.clientX <= rect.right;
	            var verticalFit = mouseEvent.clientY >= rect.top && mouseEvent.clientY <= rect.bottom;
	            //console.log(`rect.width = ${rect.width} || rect.height = ${rect.height} ## verticalFit = ${verticalFit}, horizontalFit = ${horizontalFit}, `);
	            if (horizontalFit && verticalFit) {
	                mouseOverTarget = true;
	            }
	        });
	        if (mouseOverTarget) {
	            var mouseOverTargetAndInterested = dropTarget.isInterestedIn(this.dragSource.type);
	            return mouseOverTargetAndInterested;
	        }
	        else {
	            return false;
	        }
	    };
	    DragAndDropService.prototype.addDropTarget = function (dropTarget) {
	        this.dropTargets.push(dropTarget);
	    };
	    DragAndDropService.prototype.workOutHDirection = function (event) {
	        if (this.eventLastTime.clientX > event.clientX) {
	            return HDirection.Left;
	        }
	        else if (this.eventLastTime.clientX < event.clientX) {
	            return HDirection.Right;
	        }
	        else {
	            return null;
	        }
	    };
	    DragAndDropService.prototype.workOutVDirection = function (event) {
	        if (this.eventLastTime.clientY > event.clientY) {
	            return VDirection.Up;
	        }
	        else if (this.eventLastTime.clientY < event.clientY) {
	            return VDirection.Down;
	        }
	        else {
	            return null;
	        }
	    };
	    DragAndDropService.prototype.createDropTargetEvent = function (dropTarget, event, hDirection, vDirection, fromNudge) {
	        // localise x and y to the target component
	        var rect = dropTarget.getContainer().getBoundingClientRect();
	        var x = event.clientX - rect.left;
	        var y = event.clientY - rect.top;
	        var dropTargetEvent = {
	            event: event,
	            x: x,
	            y: y,
	            vDirection: vDirection,
	            hDirection: hDirection,
	            dragSource: this.dragSource,
	            fromNudge: fromNudge,
	            dragItem: this.dragItem
	        };
	        return dropTargetEvent;
	    };
	    DragAndDropService.prototype.positionGhost = function (event) {
	        var ghostRect = this.eGhost.getBoundingClientRect();
	        var ghostHeight = ghostRect.height;
	        // for some reason, without the '-2', it still overlapped by 1 or 2 pixels, which
	        // then brought in scrollbars to the browser. no idea why, but putting in -2 here
	        // works around it which is good enough for me.
	        var browserWidth = utils_1._.getBodyWidth() - 2;
	        var browserHeight = utils_1._.getBodyHeight() - 2;
	        // put ghost vertically in middle of cursor
	        var top = event.pageY - (ghostHeight / 2);
	        // horizontally, place cursor just right of icon
	        var left = event.pageX - 30;
	        var usrDocument = this.gridOptionsWrapper.getDocument();
	        var windowScrollY = window.pageYOffset || usrDocument.documentElement.scrollTop;
	        var windowScrollX = window.pageXOffset || usrDocument.documentElement.scrollLeft;
	        // check ghost is not positioned outside of the browser
	        if (browserWidth > 0) {
	            if ((left + this.eGhost.clientWidth) > (browserWidth + windowScrollX)) {
	                left = browserWidth + windowScrollX - this.eGhost.clientWidth;
	            }
	        }
	        if (left < 0) {
	            left = 0;
	        }
	        if (browserHeight > 0) {
	            if ((top + this.eGhost.clientHeight) > (browserHeight + windowScrollY)) {
	                top = browserHeight + windowScrollY - this.eGhost.clientHeight;
	            }
	        }
	        if (top < 0) {
	            top = 0;
	        }
	        this.eGhost.style.left = left + 'px';
	        this.eGhost.style.top = top + 'px';
	    };
	    DragAndDropService.prototype.removeGhost = function () {
	        if (this.eGhost && this.eGhostParent) {
	            this.eGhostParent.removeChild(this.eGhost);
	        }
	        this.eGhost = null;
	    };
	    DragAndDropService.prototype.createGhost = function () {
	        this.eGhost = utils_1._.loadTemplate(DragAndDropService_1.GHOST_TEMPLATE);
	        var theme = this.environment.getTheme().theme;
	        if (theme) {
	            utils_1._.addCssClass(this.eGhost, theme);
	        }
	        this.eGhostIcon = this.eGhost.querySelector('.ag-dnd-ghost-icon');
	        this.setGhostIcon(null);
	        var eText = this.eGhost.querySelector('.ag-dnd-ghost-label');
	        eText.innerHTML = utils_1._.escape(this.dragSource.dragItemName);
	        this.eGhost.style.height = '25px';
	        this.eGhost.style.top = '20px';
	        this.eGhost.style.left = '20px';
	        var usrDocument = this.gridOptionsWrapper.getDocument();
	        this.eGhostParent = usrDocument.querySelector('body');
	        if (!this.eGhostParent) {
	            console.warn('ag-Grid: could not find document body, it is needed for dragging columns');
	        }
	        else {
	            this.eGhostParent.appendChild(this.eGhost);
	        }
	    };
	    DragAndDropService.prototype.setGhostIcon = function (iconName, shake) {
	        if (shake === void 0) { shake = false; }
	        utils_1._.clearElement(this.eGhostIcon);
	        var eIcon;
	        switch (iconName) {
	            case DragAndDropService_1.ICON_ADD:
	                eIcon = this.ePlusIcon;
	                break;
	            case DragAndDropService_1.ICON_PINNED:
	                eIcon = this.ePinnedIcon;
	                break;
	            case DragAndDropService_1.ICON_MOVE:
	                eIcon = this.eMoveIcon;
	                break;
	            case DragAndDropService_1.ICON_LEFT:
	                eIcon = this.eLeftIcon;
	                break;
	            case DragAndDropService_1.ICON_RIGHT:
	                eIcon = this.eRightIcon;
	                break;
	            case DragAndDropService_1.ICON_GROUP:
	                eIcon = this.eGroupIcon;
	                break;
	            case DragAndDropService_1.ICON_AGGREGATE:
	                eIcon = this.eAggregateIcon;
	                break;
	            case DragAndDropService_1.ICON_PIVOT:
	                eIcon = this.ePivotIcon;
	                break;
	            case DragAndDropService_1.ICON_NOT_ALLOWED:
	                eIcon = this.eDropNotAllowedIcon;
	                break;
	            default:
	                eIcon = this.eHiddenIcon;
	                break;
	        }
	        this.eGhostIcon.appendChild(eIcon);
	        utils_1._.addOrRemoveCssClass(this.eGhostIcon, 'ag-shake-left-to-right', shake);
	    };
	    var DragAndDropService_1;
	    DragAndDropService.ICON_PINNED = 'pinned';
	    DragAndDropService.ICON_ADD = 'add';
	    DragAndDropService.ICON_MOVE = 'move';
	    DragAndDropService.ICON_LEFT = 'left';
	    DragAndDropService.ICON_RIGHT = 'right';
	    DragAndDropService.ICON_GROUP = 'group';
	    DragAndDropService.ICON_AGGREGATE = 'aggregate';
	    DragAndDropService.ICON_PIVOT = 'pivot';
	    DragAndDropService.ICON_NOT_ALLOWED = 'notAllowed';
	    DragAndDropService.GHOST_TEMPLATE = '<div class="ag-dnd-ghost">' +
	        '  <span class="ag-dnd-ghost-icon ag-shake-left-to-right"></span>' +
	        '  <div class="ag-dnd-ghost-label">' +
	        '  </div>' +
	        '</div>';
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], DragAndDropService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('dragService'),
	        __metadata("design:type", dragService_1.DragService)
	    ], DragAndDropService.prototype, "dragService", void 0);
	    __decorate([
	        context_1.Autowired('environment'),
	        __metadata("design:type", environment_1.Environment)
	    ], DragAndDropService.prototype, "environment", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], DragAndDropService.prototype, "columnController", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], DragAndDropService.prototype, "init", null);
	    __decorate([
	        __param(0, context_1.Qualifier('loggerFactory')),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [logger_1.LoggerFactory]),
	        __metadata("design:returntype", void 0)
	    ], DragAndDropService.prototype, "setBeans", null);
	    __decorate([
	        context_1.PreDestroy,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], DragAndDropService.prototype, "destroy", null);
	    DragAndDropService = DragAndDropService_1 = __decorate([
	        context_1.Bean('dragAndDropService')
	    ], DragAndDropService);
	    return DragAndDropService;
	}());
	exports.DragAndDropService = DragAndDropService;


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(3);
	
	var Model = __webpack_require__(48);
	
	var DataDiffer = __webpack_require__(166);
	
	var Source = __webpack_require__(263);
	
	var _dataProvider = __webpack_require__(167);
	
	var defaultDimValueGetters = _dataProvider.defaultDimValueGetters;
	var DefaultDataProvider = _dataProvider.DefaultDataProvider;
	
	var _dimensionHelper = __webpack_require__(264);
	
	var summarizeDimensions = _dimensionHelper.summarizeDimensions;
	
	var DataDimensionInfo = __webpack_require__(744);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Float64Array, Int32Array, Uint32Array, Uint16Array */
	
	/**
	 * List for data storage
	 * @module echarts/data/List
	 */
	var isObject = zrUtil.isObject;
	var UNDEFINED = 'undefined';
	var INDEX_NOT_FOUND = -1; // Use prefix to avoid index to be the same as otherIdList[idx],
	// which will cause weird udpate animation.
	
	var ID_PREFIX = 'e\0\0';
	var dataCtors = {
	  'float': typeof Float64Array === UNDEFINED ? Array : Float64Array,
	  'int': typeof Int32Array === UNDEFINED ? Array : Int32Array,
	  // Ordinal data type can be string or int
	  'ordinal': Array,
	  'number': Array,
	  'time': Array
	}; // Caution: MUST not use `new CtorUint32Array(arr, 0, len)`, because the Ctor of array is
	// different from the Ctor of typed array.
	
	var CtorUint32Array = typeof Uint32Array === UNDEFINED ? Array : Uint32Array;
	var CtorInt32Array = typeof Int32Array === UNDEFINED ? Array : Int32Array;
	var CtorUint16Array = typeof Uint16Array === UNDEFINED ? Array : Uint16Array;
	
	function getIndicesCtor(list) {
	  // The possible max value in this._indicies is always this._rawCount despite of filtering.
	  return list._rawCount > 65535 ? CtorUint32Array : CtorUint16Array;
	}
	
	function cloneChunk(originalChunk) {
	  var Ctor = originalChunk.constructor; // Only shallow clone is enough when Array.
	
	  return Ctor === Array ? originalChunk.slice() : new Ctor(originalChunk);
	}
	
	var TRANSFERABLE_PROPERTIES = ['hasItemOption', '_nameList', '_idList', '_invertedIndicesMap', '_rawData', '_chunkSize', '_chunkCount', '_dimValueGetter', '_count', '_rawCount', '_nameDimIdx', '_idDimIdx'];
	var CLONE_PROPERTIES = ['_extent', '_approximateExtent', '_rawExtent'];
	
	function transferProperties(target, source) {
	  zrUtil.each(TRANSFERABLE_PROPERTIES.concat(source.__wrappedMethods || []), function (propName) {
	    if (source.hasOwnProperty(propName)) {
	      target[propName] = source[propName];
	    }
	  });
	  target.__wrappedMethods = source.__wrappedMethods;
	  zrUtil.each(CLONE_PROPERTIES, function (propName) {
	    target[propName] = zrUtil.clone(source[propName]);
	  });
	  target._calculationInfo = zrUtil.extend(source._calculationInfo);
	}
	/**
	 * @constructor
	 * @alias module:echarts/data/List
	 *
	 * @param {Array.<string|Object|module:data/DataDimensionInfo>} dimensions
	 *      For example, ['someDimName', {name: 'someDimName', type: 'someDimType'}, ...].
	 *      Dimensions should be concrete names like x, y, z, lng, lat, angle, radius
	 * @param {module:echarts/model/Model} hostModel
	 */
	
	
	var List = function (dimensions, hostModel) {
	  dimensions = dimensions || ['x', 'y'];
	  var dimensionInfos = {};
	  var dimensionNames = [];
	  var invertedIndicesMap = {};
	
	  for (var i = 0; i < dimensions.length; i++) {
	    // Use the original dimensions[i], where other flag props may exists.
	    var dimensionInfo = dimensions[i];
	
	    if (zrUtil.isString(dimensionInfo)) {
	      dimensionInfo = new DataDimensionInfo({
	        name: dimensionInfo
	      });
	    } else if (!(dimensionInfo instanceof DataDimensionInfo)) {
	      dimensionInfo = new DataDimensionInfo(dimensionInfo);
	    }
	
	    var dimensionName = dimensionInfo.name;
	    dimensionInfo.type = dimensionInfo.type || 'float';
	
	    if (!dimensionInfo.coordDim) {
	      dimensionInfo.coordDim = dimensionName;
	      dimensionInfo.coordDimIndex = 0;
	    }
	
	    dimensionInfo.otherDims = dimensionInfo.otherDims || {};
	    dimensionNames.push(dimensionName);
	    dimensionInfos[dimensionName] = dimensionInfo;
	    dimensionInfo.index = i;
	
	    if (dimensionInfo.createInvertedIndices) {
	      invertedIndicesMap[dimensionName] = [];
	    }
	  }
	  /**
	   * @readOnly
	   * @type {Array.<string>}
	   */
	
	
	  this.dimensions = dimensionNames;
	  /**
	   * Infomation of each data dimension, like data type.
	   * @type {Object}
	   */
	
	  this._dimensionInfos = dimensionInfos;
	  /**
	   * @type {module:echarts/model/Model}
	   */
	
	  this.hostModel = hostModel;
	  /**
	   * @type {module:echarts/model/Model}
	   */
	
	  this.dataType;
	  /**
	   * Indices stores the indices of data subset after filtered.
	   * This data subset will be used in chart.
	   * @type {Array.<number>}
	   * @readOnly
	   */
	
	  this._indices = null;
	  this._count = 0;
	  this._rawCount = 0;
	  /**
	   * Data storage
	   * @type {Object.<key, Array.<TypedArray|Array>>}
	   * @private
	   */
	
	  this._storage = {};
	  /**
	   * @type {Array.<string>}
	   */
	
	  this._nameList = [];
	  /**
	   * @type {Array.<string>}
	   */
	
	  this._idList = [];
	  /**
	   * Models of data option is stored sparse for optimizing memory cost
	   * @type {Array.<module:echarts/model/Model>}
	   * @private
	   */
	
	  this._optionModels = [];
	  /**
	   * Global visual properties after visual coding
	   * @type {Object}
	   * @private
	   */
	
	  this._visual = {};
	  /**
	   * Globel layout properties.
	   * @type {Object}
	   * @private
	   */
	
	  this._layout = {};
	  /**
	   * Item visual properties after visual coding
	   * @type {Array.<Object>}
	   * @private
	   */
	
	  this._itemVisuals = [];
	  /**
	   * Key: visual type, Value: boolean
	   * @type {Object}
	   * @readOnly
	   */
	
	  this.hasItemVisual = {};
	  /**
	   * Item layout properties after layout
	   * @type {Array.<Object>}
	   * @private
	   */
	
	  this._itemLayouts = [];
	  /**
	   * Graphic elemnents
	   * @type {Array.<module:zrender/Element>}
	   * @private
	   */
	
	  this._graphicEls = [];
	  /**
	   * Max size of each chunk.
	   * @type {number}
	   * @private
	   */
	
	  this._chunkSize = 1e5;
	  /**
	   * @type {number}
	   * @private
	   */
	
	  this._chunkCount = 0;
	  /**
	   * @type {Array.<Array|Object>}
	   * @private
	   */
	
	  this._rawData;
	  /**
	   * Raw extent will not be cloned, but only transfered.
	   * It will not be calculated util needed.
	   * key: dim,
	   * value: {end: number, extent: Array.<number>}
	   * @type {Object}
	   * @private
	   */
	
	  this._rawExtent = {};
	  /**
	   * @type {Object}
	   * @private
	   */
	
	  this._extent = {};
	  /**
	   * key: dim
	   * value: extent
	   * @type {Object}
	   * @private
	   */
	
	  this._approximateExtent = {};
	  /**
	   * Cache summary info for fast visit. See "dimensionHelper".
	   * @type {Object}
	   * @private
	   */
	
	  this._dimensionsSummary = summarizeDimensions(this);
	  /**
	   * @type {Object.<Array|TypedArray>}
	   * @private
	   */
	
	  this._invertedIndicesMap = invertedIndicesMap;
	  /**
	   * @type {Object}
	   * @private
	   */
	
	  this._calculationInfo = {};
	  /**
	   * User output info of this data.
	   * DO NOT use it in other places!
	   *
	   * When preparing user params for user callbacks, we have
	   * to clone these inner data structures to prevent users
	   * from modifying them to effect built-in logic. And for
	   * performance consideration we make this `userOutput` to
	   * avoid clone them too many times.
	   *
	   * @type {Object}
	   * @readOnly
	   */
	
	  this.userOutput = this._dimensionsSummary.userOutput;
	};
	
	var listProto = List.prototype;
	listProto.type = 'list';
	/**
	 * If each data item has it's own option
	 * @type {boolean}
	 */
	
	listProto.hasItemOption = true;
	/**
	 * The meanings of the input parameter `dim`:
	 *
	 * + If dim is a number (e.g., `1`), it means the index of the dimension.
	 *   For example, `getDimension(0)` will return 'x' or 'lng' or 'radius'.
	 * + If dim is a number-like string (e.g., `"1"`):
	 *     + If there is the same concrete dim name defined in `this.dimensions`, it means that concrete name.
	 *     + If not, it will be converted to a number, which means the index of the dimension.
	 *        (why? because of the backward compatbility. We have been tolerating number-like string in
	 *        dimension setting, although now it seems that it is not a good idea.)
	 *     For example, `visualMap[i].dimension: "1"` is the same meaning as `visualMap[i].dimension: 1`,
	 *     if no dimension name is defined as `"1"`.
	 * + If dim is a not-number-like string, it means the concrete dim name.
	 *   For example, it can be be default name `"x"`, `"y"`, `"z"`, `"lng"`, `"lat"`, `"angle"`, `"radius"`,
	 *   or customized in `dimensions` property of option like `"age"`.
	 *
	 * Get dimension name
	 * @param {string|number} dim See above.
	 * @return {string} Concrete dim name.
	 */
	
	listProto.getDimension = function (dim) {
	  if (typeof dim === 'number' // If being a number-like string but not being defined a dimension name.
	  || !isNaN(dim) && !this._dimensionInfos.hasOwnProperty(dim)) {
	    dim = this.dimensions[dim];
	  }
	
	  return dim;
	};
	/**
	 * Get type and calculation info of particular dimension
	 * @param {string|number} dim
	 *        Dimension can be concrete names like x, y, z, lng, lat, angle, radius
	 *        Or a ordinal number. For example getDimensionInfo(0) will return 'x' or 'lng' or 'radius'
	 */
	
	
	listProto.getDimensionInfo = function (dim) {
	  // Do not clone, because there may be categories in dimInfo.
	  return this._dimensionInfos[this.getDimension(dim)];
	};
	/**
	 * @return {Array.<string>} concrete dimension name list on coord.
	 */
	
	
	listProto.getDimensionsOnCoord = function () {
	  return this._dimensionsSummary.dataDimsOnCoord.slice();
	};
	/**
	 * @param {string} coordDim
	 * @param {number} [idx] A coordDim may map to more than one data dim.
	 *        If idx is `true`, return a array of all mapped dims.
	 *        If idx is not specified, return the first dim not extra.
	 * @return {string|Array.<string>} concrete data dim.
	 *        If idx is number, and not found, return null/undefined.
	 *        If idx is `true`, and not found, return empty array (always return array).
	 */
	
	
	listProto.mapDimension = function (coordDim, idx) {
	  var dimensionsSummary = this._dimensionsSummary;
	
	  if (idx == null) {
	    return dimensionsSummary.encodeFirstDimNotExtra[coordDim];
	  }
	
	  var dims = dimensionsSummary.encode[coordDim];
	  return idx === true // always return array if idx is `true`
	  ? (dims || []).slice() : dims && dims[idx];
	};
	/**
	 * Initialize from data
	 * @param {Array.<Object|number|Array>} data source or data or data provider.
	 * @param {Array.<string>} [nameLIst] The name of a datum is used on data diff and
	 *        default label/tooltip.
	 *        A name can be specified in encode.itemName,
	 *        or dataItem.name (only for series option data),
	 *        or provided in nameList from outside.
	 * @param {Function} [dimValueGetter] (dataItem, dimName, dataIndex, dimIndex) => number
	 */
	
	
	listProto.initData = function (data, nameList, dimValueGetter) {
	  var notProvider = Source.isInstance(data) || zrUtil.isArrayLike(data);
	
	  if (notProvider) {
	    data = new DefaultDataProvider(data, this.dimensions.length);
	  }
	
	  this._rawData = data; // Clear
	
	  this._storage = {};
	  this._indices = null;
	  this._nameList = nameList || [];
	  this._idList = [];
	  this._nameRepeatCount = {};
	
	  if (!dimValueGetter) {
	    this.hasItemOption = false;
	  }
	  /**
	   * @readOnly
	   */
	
	
	  this.defaultDimValueGetter = defaultDimValueGetters[this._rawData.getSource().sourceFormat]; // Default dim value getter
	
	  this._dimValueGetter = dimValueGetter = dimValueGetter || this.defaultDimValueGetter;
	  this._dimValueGetterArrayRows = defaultDimValueGetters.arrayRows; // Reset raw extent.
	
	  this._rawExtent = {};
	
	  this._initDataFromProvider(0, data.count()); // If data has no item option.
	
	
	  if (data.pure) {
	    this.hasItemOption = false;
	  }
	};
	
	listProto.getProvider = function () {
	  return this._rawData;
	};
	/**
	 * Caution: Can be only called on raw data (before `this._indices` created).
	 */
	
	
	listProto.appendData = function (data) {
	  var rawData = this._rawData;
	  var start = this.count();
	  rawData.appendData(data);
	  var end = rawData.count();
	
	  if (!rawData.persistent) {
	    end += start;
	  }
	
	  this._initDataFromProvider(start, end);
	};
	/**
	 * Caution: Can be only called on raw data (before `this._indices` created).
	 * This method does not modify `rawData` (`dataProvider`), but only
	 * add values to storage.
	 *
	 * The final count will be increased by `Math.max(values.length, names.length)`.
	 *
	 * @param {Array.<Array.<*>>} values That is the SourceType: 'arrayRows', like
	 *        [
	 *            [12, 33, 44],
	 *            [NaN, 43, 1],
	 *            ['-', 'asdf', 0]
	 *        ]
	 *        Each item is exaclty cooresponding to a dimension.
	 * @param {Array.<string>} [names]
	 */
	
	
	listProto.appendValues = function (values, names) {
	  var chunkSize = this._chunkSize;
	  var storage = this._storage;
	  var dimensions = this.dimensions;
	  var dimLen = dimensions.length;
	  var rawExtent = this._rawExtent;
	  var start = this.count();
	  var end = start + Math.max(values.length, names ? names.length : 0);
	  var originalChunkCount = this._chunkCount;
	
	  for (var i = 0; i < dimLen; i++) {
	    var dim = dimensions[i];
	
	    if (!rawExtent[dim]) {
	      rawExtent[dim] = getInitialExtent();
	    }
	
	    if (!storage[dim]) {
	      storage[dim] = [];
	    }
	
	    prepareChunks(storage, this._dimensionInfos[dim], chunkSize, originalChunkCount, end);
	    this._chunkCount = storage[dim].length;
	  }
	
	  var emptyDataItem = new Array(dimLen);
	
	  for (var idx = start; idx < end; idx++) {
	    var sourceIdx = idx - start;
	    var chunkIndex = Math.floor(idx / chunkSize);
	    var chunkOffset = idx % chunkSize; // Store the data by dimensions
	
	    for (var k = 0; k < dimLen; k++) {
	      var dim = dimensions[k];
	
	      var val = this._dimValueGetterArrayRows(values[sourceIdx] || emptyDataItem, dim, sourceIdx, k);
	
	      storage[dim][chunkIndex][chunkOffset] = val;
	      var dimRawExtent = rawExtent[dim];
	      val < dimRawExtent[0] && (dimRawExtent[0] = val);
	      val > dimRawExtent[1] && (dimRawExtent[1] = val);
	    }
	
	    if (names) {
	      this._nameList[idx] = names[sourceIdx];
	    }
	  }
	
	  this._rawCount = this._count = end; // Reset data extent
	
	  this._extent = {};
	  prepareInvertedIndex(this);
	};
	
	listProto._initDataFromProvider = function (start, end) {
	  // Optimize.
	  if (start >= end) {
	    return;
	  }
	
	  var chunkSize = this._chunkSize;
	  var rawData = this._rawData;
	  var storage = this._storage;
	  var dimensions = this.dimensions;
	  var dimLen = dimensions.length;
	  var dimensionInfoMap = this._dimensionInfos;
	  var nameList = this._nameList;
	  var idList = this._idList;
	  var rawExtent = this._rawExtent;
	  var nameRepeatCount = this._nameRepeatCount = {};
	  var nameDimIdx;
	  var originalChunkCount = this._chunkCount;
	
	  for (var i = 0; i < dimLen; i++) {
	    var dim = dimensions[i];
	
	    if (!rawExtent[dim]) {
	      rawExtent[dim] = getInitialExtent();
	    }
	
	    var dimInfo = dimensionInfoMap[dim];
	
	    if (dimInfo.otherDims.itemName === 0) {
	      nameDimIdx = this._nameDimIdx = i;
	    }
	
	    if (dimInfo.otherDims.itemId === 0) {
	      this._idDimIdx = i;
	    }
	
	    if (!storage[dim]) {
	      storage[dim] = [];
	    }
	
	    prepareChunks(storage, dimInfo, chunkSize, originalChunkCount, end);
	    this._chunkCount = storage[dim].length;
	  }
	
	  var dataItem = new Array(dimLen);
	
	  for (var idx = start; idx < end; idx++) {
	    // NOTICE: Try not to write things into dataItem
	    dataItem = rawData.getItem(idx, dataItem); // Each data item is value
	    // [1, 2]
	    // 2
	    // Bar chart, line chart which uses category axis
	    // only gives the 'y' value. 'x' value is the indices of category
	    // Use a tempValue to normalize the value to be a (x, y) value
	
	    var chunkIndex = Math.floor(idx / chunkSize);
	    var chunkOffset = idx % chunkSize; // Store the data by dimensions
	
	    for (var k = 0; k < dimLen; k++) {
	      var dim = dimensions[k];
	      var dimStorage = storage[dim][chunkIndex]; // PENDING NULL is empty or zero
	
	      var val = this._dimValueGetter(dataItem, dim, idx, k);
	
	      dimStorage[chunkOffset] = val;
	      var dimRawExtent = rawExtent[dim];
	      val < dimRawExtent[0] && (dimRawExtent[0] = val);
	      val > dimRawExtent[1] && (dimRawExtent[1] = val);
	    } // ??? FIXME not check by pure but sourceFormat?
	    // TODO refactor these logic.
	
	
	    if (!rawData.pure) {
	      var name = nameList[idx];
	
	      if (dataItem && name == null) {
	        // If dataItem is {name: ...}, it has highest priority.
	        // That is appropriate for many common cases.
	        if (dataItem.name != null) {
	          // There is no other place to persistent dataItem.name,
	          // so save it to nameList.
	          nameList[idx] = name = dataItem.name;
	        } else if (nameDimIdx != null) {
	          var nameDim = dimensions[nameDimIdx];
	          var nameDimChunk = storage[nameDim][chunkIndex];
	
	          if (nameDimChunk) {
	            name = nameDimChunk[chunkOffset];
	            var ordinalMeta = dimensionInfoMap[nameDim].ordinalMeta;
	
	            if (ordinalMeta && ordinalMeta.categories.length) {
	              name = ordinalMeta.categories[name];
	            }
	          }
	        }
	      } // Try using the id in option
	      // id or name is used on dynamical data, mapping old and new items.
	
	
	      var id = dataItem == null ? null : dataItem.id;
	
	      if (id == null && name != null) {
	        // Use name as id and add counter to avoid same name
	        nameRepeatCount[name] = nameRepeatCount[name] || 0;
	        id = name;
	
	        if (nameRepeatCount[name] > 0) {
	          id += '__ec__' + nameRepeatCount[name];
	        }
	
	        nameRepeatCount[name]++;
	      }
	
	      id != null && (idList[idx] = id);
	    }
	  }
	
	  if (!rawData.persistent && rawData.clean) {
	    // Clean unused data if data source is typed array.
	    rawData.clean();
	  }
	
	  this._rawCount = this._count = end; // Reset data extent
	
	  this._extent = {};
	  prepareInvertedIndex(this);
	};
	
	function prepareChunks(storage, dimInfo, chunkSize, chunkCount, end) {
	  var DataCtor = dataCtors[dimInfo.type];
	  var lastChunkIndex = chunkCount - 1;
	  var dim = dimInfo.name;
	  var resizeChunkArray = storage[dim][lastChunkIndex];
	
	  if (resizeChunkArray && resizeChunkArray.length < chunkSize) {
	    var newStore = new DataCtor(Math.min(end - lastChunkIndex * chunkSize, chunkSize)); // The cost of the copy is probably inconsiderable
	    // within the initial chunkSize.
	
	    for (var j = 0; j < resizeChunkArray.length; j++) {
	      newStore[j] = resizeChunkArray[j];
	    }
	
	    storage[dim][lastChunkIndex] = newStore;
	  } // Create new chunks.
	
	
	  for (var k = chunkCount * chunkSize; k < end; k += chunkSize) {
	    storage[dim].push(new DataCtor(Math.min(end - k, chunkSize)));
	  }
	}
	
	function prepareInvertedIndex(list) {
	  var invertedIndicesMap = list._invertedIndicesMap;
	  zrUtil.each(invertedIndicesMap, function (invertedIndices, dim) {
	    var dimInfo = list._dimensionInfos[dim]; // Currently, only dimensions that has ordinalMeta can create inverted indices.
	
	    var ordinalMeta = dimInfo.ordinalMeta;
	
	    if (ordinalMeta) {
	      invertedIndices = invertedIndicesMap[dim] = new CtorInt32Array(ordinalMeta.categories.length); // The default value of TypedArray is 0. To avoid miss
	      // mapping to 0, we should set it as INDEX_NOT_FOUND.
	
	      for (var i = 0; i < invertedIndices.length; i++) {
	        invertedIndices[i] = INDEX_NOT_FOUND;
	      }
	
	      for (var i = 0; i < list._count; i++) {
	        // Only support the case that all values are distinct.
	        invertedIndices[list.get(dim, i)] = i;
	      }
	    }
	  });
	}
	
	function getRawValueFromStore(list, dimIndex, rawIndex) {
	  var val;
	
	  if (dimIndex != null) {
	    var chunkSize = list._chunkSize;
	    var chunkIndex = Math.floor(rawIndex / chunkSize);
	    var chunkOffset = rawIndex % chunkSize;
	    var dim = list.dimensions[dimIndex];
	    var chunk = list._storage[dim][chunkIndex];
	
	    if (chunk) {
	      val = chunk[chunkOffset];
	      var ordinalMeta = list._dimensionInfos[dim].ordinalMeta;
	
	      if (ordinalMeta && ordinalMeta.categories.length) {
	        val = ordinalMeta.categories[val];
	      }
	    }
	  }
	
	  return val;
	}
	/**
	 * @return {number}
	 */
	
	
	listProto.count = function () {
	  return this._count;
	};
	
	listProto.getIndices = function () {
	  var newIndices;
	  var indices = this._indices;
	
	  if (indices) {
	    var Ctor = indices.constructor;
	    var thisCount = this._count; // `new Array(a, b, c)` is different from `new Uint32Array(a, b, c)`.
	
	    if (Ctor === Array) {
	      newIndices = new Ctor(thisCount);
	
	      for (var i = 0; i < thisCount; i++) {
	        newIndices[i] = indices[i];
	      }
	    } else {
	      newIndices = new Ctor(indices.buffer, 0, thisCount);
	    }
	  } else {
	    var Ctor = getIndicesCtor(this);
	    var newIndices = new Ctor(this.count());
	
	    for (var i = 0; i < newIndices.length; i++) {
	      newIndices[i] = i;
	    }
	  }
	
	  return newIndices;
	};
	/**
	 * Get value. Return NaN if idx is out of range.
	 * @param {string} dim Dim must be concrete name.
	 * @param {number} idx
	 * @param {boolean} stack
	 * @return {number}
	 */
	
	
	listProto.get = function (dim, idx
	/*, stack */
	) {
	  if (!(idx >= 0 && idx < this._count)) {
	    return NaN;
	  }
	
	  var storage = this._storage;
	
	  if (!storage[dim]) {
	    // TODO Warn ?
	    return NaN;
	  }
	
	  idx = this.getRawIndex(idx);
	  var chunkIndex = Math.floor(idx / this._chunkSize);
	  var chunkOffset = idx % this._chunkSize;
	  var chunkStore = storage[dim][chunkIndex];
	  var value = chunkStore[chunkOffset]; // FIXME ordinal data type is not stackable
	  // if (stack) {
	  //     var dimensionInfo = this._dimensionInfos[dim];
	  //     if (dimensionInfo && dimensionInfo.stackable) {
	  //         var stackedOn = this.stackedOn;
	  //         while (stackedOn) {
	  //             // Get no stacked data of stacked on
	  //             var stackedValue = stackedOn.get(dim, idx);
	  //             // Considering positive stack, negative stack and empty data
	  //             if ((value >= 0 && stackedValue > 0)  // Positive stack
	  //                 || (value <= 0 && stackedValue < 0) // Negative stack
	  //             ) {
	  //                 value += stackedValue;
	  //             }
	  //             stackedOn = stackedOn.stackedOn;
	  //         }
	  //     }
	  // }
	
	  return value;
	};
	/**
	 * @param {string} dim concrete dim
	 * @param {number} rawIndex
	 * @return {number|string}
	 */
	
	
	listProto.getByRawIndex = function (dim, rawIdx) {
	  if (!(rawIdx >= 0 && rawIdx < this._rawCount)) {
	    return NaN;
	  }
	
	  var dimStore = this._storage[dim];
	
	  if (!dimStore) {
	    // TODO Warn ?
	    return NaN;
	  }
	
	  var chunkIndex = Math.floor(rawIdx / this._chunkSize);
	  var chunkOffset = rawIdx % this._chunkSize;
	  var chunkStore = dimStore[chunkIndex];
	  return chunkStore[chunkOffset];
	};
	/**
	 * FIXME Use `get` on chrome maybe slow(in filterSelf and selectRange).
	 * Hack a much simpler _getFast
	 * @private
	 */
	
	
	listProto._getFast = function (dim, rawIdx) {
	  var chunkIndex = Math.floor(rawIdx / this._chunkSize);
	  var chunkOffset = rawIdx % this._chunkSize;
	  var chunkStore = this._storage[dim][chunkIndex];
	  return chunkStore[chunkOffset];
	};
	/**
	 * Get value for multi dimensions.
	 * @param {Array.<string>} [dimensions] If ignored, using all dimensions.
	 * @param {number} idx
	 * @return {number}
	 */
	
	
	listProto.getValues = function (dimensions, idx
	/*, stack */
	) {
	  var values = [];
	
	  if (!zrUtil.isArray(dimensions)) {
	    // stack = idx;
	    idx = dimensions;
	    dimensions = this.dimensions;
	  }
	
	  for (var i = 0, len = dimensions.length; i < len; i++) {
	    values.push(this.get(dimensions[i], idx
	    /*, stack */
	    ));
	  }
	
	  return values;
	};
	/**
	 * If value is NaN. Inlcuding '-'
	 * Only check the coord dimensions.
	 * @param {string} dim
	 * @param {number} idx
	 * @return {number}
	 */
	
	
	listProto.hasValue = function (idx) {
	  var dataDimsOnCoord = this._dimensionsSummary.dataDimsOnCoord;
	
	  for (var i = 0, len = dataDimsOnCoord.length; i < len; i++) {
	    // Ordinal type originally can be string or number.
	    // But when an ordinal type is used on coord, it can
	    // not be string but only number. So we can also use isNaN.
	    if (isNaN(this.get(dataDimsOnCoord[i], idx))) {
	      return false;
	    }
	  }
	
	  return true;
	};
	/**
	 * Get extent of data in one dimension
	 * @param {string} dim
	 * @param {boolean} stack
	 */
	
	
	listProto.getDataExtent = function (dim
	/*, stack */
	) {
	  // Make sure use concrete dim as cache name.
	  dim = this.getDimension(dim);
	  var dimData = this._storage[dim];
	  var initialExtent = getInitialExtent(); // stack = !!((stack || false) && this.getCalculationInfo(dim));
	
	  if (!dimData) {
	    return initialExtent;
	  } // Make more strict checkings to ensure hitting cache.
	
	
	  var currEnd = this.count(); // var cacheName = [dim, !!stack].join('_');
	  // var cacheName = dim;
	  // Consider the most cases when using data zoom, `getDataExtent`
	  // happened before filtering. We cache raw extent, which is not
	  // necessary to be cleared and recalculated when restore data.
	
	  var useRaw = !this._indices; // && !stack;
	
	  var dimExtent;
	
	  if (useRaw) {
	    return this._rawExtent[dim].slice();
	  }
	
	  dimExtent = this._extent[dim];
	
	  if (dimExtent) {
	    return dimExtent.slice();
	  }
	
	  dimExtent = initialExtent;
	  var min = dimExtent[0];
	  var max = dimExtent[1];
	
	  for (var i = 0; i < currEnd; i++) {
	    // var value = stack ? this.get(dim, i, true) : this._getFast(dim, this.getRawIndex(i));
	    var value = this._getFast(dim, this.getRawIndex(i));
	
	    value < min && (min = value);
	    value > max && (max = value);
	  }
	
	  dimExtent = [min, max];
	  this._extent[dim] = dimExtent;
	  return dimExtent;
	};
	/**
	 * Optimize for the scenario that data is filtered by a given extent.
	 * Consider that if data amount is more than hundreds of thousand,
	 * extent calculation will cost more than 10ms and the cache will
	 * be erased because of the filtering.
	 */
	
	
	listProto.getApproximateExtent = function (dim
	/*, stack */
	) {
	  dim = this.getDimension(dim);
	  return this._approximateExtent[dim] || this.getDataExtent(dim
	  /*, stack */
	  );
	};
	
	listProto.setApproximateExtent = function (extent, dim
	/*, stack */
	) {
	  dim = this.getDimension(dim);
	  this._approximateExtent[dim] = extent.slice();
	};
	/**
	 * @param {string} key
	 * @return {*}
	 */
	
	
	listProto.getCalculationInfo = function (key) {
	  return this._calculationInfo[key];
	};
	/**
	 * @param {string|Object} key or k-v object
	 * @param {*} [value]
	 */
	
	
	listProto.setCalculationInfo = function (key, value) {
	  isObject(key) ? zrUtil.extend(this._calculationInfo, key) : this._calculationInfo[key] = value;
	};
	/**
	 * Get sum of data in one dimension
	 * @param {string} dim
	 */
	
	
	listProto.getSum = function (dim
	/*, stack */
	) {
	  var dimData = this._storage[dim];
	  var sum = 0;
	
	  if (dimData) {
	    for (var i = 0, len = this.count(); i < len; i++) {
	      var value = this.get(dim, i
	      /*, stack */
	      );
	
	      if (!isNaN(value)) {
	        sum += value;
	      }
	    }
	  }
	
	  return sum;
	};
	/**
	 * Get median of data in one dimension
	 * @param {string} dim
	 */
	
	
	listProto.getMedian = function (dim
	/*, stack */
	) {
	  var dimDataArray = []; // map all data of one dimension
	
	  this.each(dim, function (val, idx) {
	    if (!isNaN(val)) {
	      dimDataArray.push(val);
	    }
	  }); // TODO
	  // Use quick select?
	  // immutability & sort
	
	  var sortedDimDataArray = [].concat(dimDataArray).sort(function (a, b) {
	    return a - b;
	  });
	  var len = this.count(); // calculate median
	
	  return len === 0 ? 0 : len % 2 === 1 ? sortedDimDataArray[(len - 1) / 2] : (sortedDimDataArray[len / 2] + sortedDimDataArray[len / 2 - 1]) / 2;
	}; // /**
	//  * Retreive the index with given value
	//  * @param {string} dim Concrete dimension.
	//  * @param {number} value
	//  * @return {number}
	//  */
	// Currently incorrect: should return dataIndex but not rawIndex.
	// Do not fix it until this method is to be used somewhere.
	// FIXME Precision of float value
	// listProto.indexOf = function (dim, value) {
	//     var storage = this._storage;
	//     var dimData = storage[dim];
	//     var chunkSize = this._chunkSize;
	//     if (dimData) {
	//         for (var i = 0, len = this.count(); i < len; i++) {
	//             var chunkIndex = Math.floor(i / chunkSize);
	//             var chunkOffset = i % chunkSize;
	//             if (dimData[chunkIndex][chunkOffset] === value) {
	//                 return i;
	//             }
	//         }
	//     }
	//     return -1;
	// };
	
	/**
	 * Only support the dimension which inverted index created.
	 * Do not support other cases until required.
	 * @param {string} concrete dim
	 * @param {number|string} value
	 * @return {number} rawIndex
	 */
	
	
	listProto.rawIndexOf = function (dim, value) {
	  var invertedIndices = dim && this._invertedIndicesMap[dim];
	  var rawIndex = invertedIndices[value];
	
	  if (rawIndex == null || isNaN(rawIndex)) {
	    return INDEX_NOT_FOUND;
	  }
	
	  return rawIndex;
	};
	/**
	 * Retreive the index with given name
	 * @param {number} idx
	 * @param {number} name
	 * @return {number}
	 */
	
	
	listProto.indexOfName = function (name) {
	  for (var i = 0, len = this.count(); i < len; i++) {
	    if (this.getName(i) === name) {
	      return i;
	    }
	  }
	
	  return -1;
	};
	/**
	 * Retreive the index with given raw data index
	 * @param {number} idx
	 * @param {number} name
	 * @return {number}
	 */
	
	
	listProto.indexOfRawIndex = function (rawIndex) {
	  if (rawIndex >= this._rawCount || rawIndex < 0) {
	    return -1;
	  }
	
	  if (!this._indices) {
	    return rawIndex;
	  } // Indices are ascending
	
	
	  var indices = this._indices; // If rawIndex === dataIndex
	
	  var rawDataIndex = indices[rawIndex];
	
	  if (rawDataIndex != null && rawDataIndex < this._count && rawDataIndex === rawIndex) {
	    return rawIndex;
	  }
	
	  var left = 0;
	  var right = this._count - 1;
	
	  while (left <= right) {
	    var mid = (left + right) / 2 | 0;
	
	    if (indices[mid] < rawIndex) {
	      left = mid + 1;
	    } else if (indices[mid] > rawIndex) {
	      right = mid - 1;
	    } else {
	      return mid;
	    }
	  }
	
	  return -1;
	};
	/**
	 * Retreive the index of nearest value
	 * @param {string} dim
	 * @param {number} value
	 * @param {number} [maxDistance=Infinity]
	 * @return {Array.<number>} If and only if multiple indices has
	 *        the same value, they are put to the result.
	 */
	
	
	listProto.indicesOfNearest = function (dim, value, maxDistance) {
	  var storage = this._storage;
	  var dimData = storage[dim];
	  var nearestIndices = [];
	
	  if (!dimData) {
	    return nearestIndices;
	  }
	
	  if (maxDistance == null) {
	    maxDistance = Infinity;
	  }
	
	  var minDist = Infinity;
	  var minDiff = -1;
	  var nearestIndicesLen = 0; // Check the test case of `test/ut/spec/data/List.js`.
	
	  for (var i = 0, len = this.count(); i < len; i++) {
	    var diff = value - this.get(dim, i);
	    var dist = Math.abs(diff);
	
	    if (dist <= maxDistance) {
	      // When the `value` is at the middle of `this.get(dim, i)` and `this.get(dim, i+1)`,
	      // we'd better not push both of them to `nearestIndices`, otherwise it is easy to
	      // get more than one item in `nearestIndices` (more specifically, in `tooltip`).
	      // So we chose the one that `diff >= 0` in this csae.
	      // But if `this.get(dim, i)` and `this.get(dim, j)` get the same value, both of them
	      // should be push to `nearestIndices`.
	      if (dist < minDist || dist === minDist && diff >= 0 && minDiff < 0) {
	        minDist = dist;
	        minDiff = diff;
	        nearestIndicesLen = 0;
	      }
	
	      if (diff === minDiff) {
	        nearestIndices[nearestIndicesLen++] = i;
	      }
	    }
	  }
	
	  nearestIndices.length = nearestIndicesLen;
	  return nearestIndices;
	};
	/**
	 * Get raw data index
	 * @param {number} idx
	 * @return {number}
	 */
	
	
	listProto.getRawIndex = getRawIndexWithoutIndices;
	
	function getRawIndexWithoutIndices(idx) {
	  return idx;
	}
	
	function getRawIndexWithIndices(idx) {
	  if (idx < this._count && idx >= 0) {
	    return this._indices[idx];
	  }
	
	  return -1;
	}
	/**
	 * Get raw data item
	 * @param {number} idx
	 * @return {number}
	 */
	
	
	listProto.getRawDataItem = function (idx) {
	  if (!this._rawData.persistent) {
	    var val = [];
	
	    for (var i = 0; i < this.dimensions.length; i++) {
	      var dim = this.dimensions[i];
	      val.push(this.get(dim, idx));
	    }
	
	    return val;
	  } else {
	    return this._rawData.getItem(this.getRawIndex(idx));
	  }
	};
	/**
	 * @param {number} idx
	 * @param {boolean} [notDefaultIdx=false]
	 * @return {string}
	 */
	
	
	listProto.getName = function (idx) {
	  var rawIndex = this.getRawIndex(idx);
	  return this._nameList[rawIndex] || getRawValueFromStore(this, this._nameDimIdx, rawIndex) || '';
	};
	/**
	 * @param {number} idx
	 * @param {boolean} [notDefaultIdx=false]
	 * @return {string}
	 */
	
	
	listProto.getId = function (idx) {
	  return getId(this, this.getRawIndex(idx));
	};
	
	function getId(list, rawIndex) {
	  var id = list._idList[rawIndex];
	
	  if (id == null) {
	    id = getRawValueFromStore(list, list._idDimIdx, rawIndex);
	  }
	
	  if (id == null) {
	    // FIXME Check the usage in graph, should not use prefix.
	    id = ID_PREFIX + rawIndex;
	  }
	
	  return id;
	}
	
	function normalizeDimensions(dimensions) {
	  if (!zrUtil.isArray(dimensions)) {
	    dimensions = [dimensions];
	  }
	
	  return dimensions;
	}
	
	function validateDimensions(list, dims) {
	  for (var i = 0; i < dims.length; i++) {
	    // stroage may be empty when no data, so use
	    // dimensionInfos to check.
	    if (!list._dimensionInfos[dims[i]]) {
	      console.error('Unkown dimension ' + dims[i]);
	    }
	  }
	}
	/**
	 * Data iteration
	 * @param {string|Array.<string>}
	 * @param {Function} cb
	 * @param {*} [context=this]
	 *
	 * @example
	 *  list.each('x', function (x, idx) {});
	 *  list.each(['x', 'y'], function (x, y, idx) {});
	 *  list.each(function (idx) {})
	 */
	
	
	listProto.each = function (dims, cb, context, contextCompat) {
	  'use strict';
	
	  if (!this._count) {
	    return;
	  }
	
	  if (typeof dims === 'function') {
	    contextCompat = context;
	    context = cb;
	    cb = dims;
	    dims = [];
	  } // contextCompat just for compat echarts3
	
	
	  context = context || contextCompat || this;
	  dims = zrUtil.map(normalizeDimensions(dims), this.getDimension, this);
	  var dimSize = dims.length;
	
	  for (var i = 0; i < this.count(); i++) {
	    // Simple optimization
	    switch (dimSize) {
	      case 0:
	        cb.call(context, i);
	        break;
	
	      case 1:
	        cb.call(context, this.get(dims[0], i), i);
	        break;
	
	      case 2:
	        cb.call(context, this.get(dims[0], i), this.get(dims[1], i), i);
	        break;
	
	      default:
	        var k = 0;
	        var value = [];
	
	        for (; k < dimSize; k++) {
	          value[k] = this.get(dims[k], i);
	        } // Index
	
	
	        value[k] = i;
	        cb.apply(context, value);
	    }
	  }
	};
	/**
	 * Data filter
	 * @param {string|Array.<string>}
	 * @param {Function} cb
	 * @param {*} [context=this]
	 */
	
	
	listProto.filterSelf = function (dimensions, cb, context, contextCompat) {
	  'use strict';
	
	  if (!this._count) {
	    return;
	  }
	
	  if (typeof dimensions === 'function') {
	    contextCompat = context;
	    context = cb;
	    cb = dimensions;
	    dimensions = [];
	  } // contextCompat just for compat echarts3
	
	
	  context = context || contextCompat || this;
	  dimensions = zrUtil.map(normalizeDimensions(dimensions), this.getDimension, this);
	  var count = this.count();
	  var Ctor = getIndicesCtor(this);
	  var newIndices = new Ctor(count);
	  var value = [];
	  var dimSize = dimensions.length;
	  var offset = 0;
	  var dim0 = dimensions[0];
	
	  for (var i = 0; i < count; i++) {
	    var keep;
	    var rawIdx = this.getRawIndex(i); // Simple optimization
	
	    if (dimSize === 0) {
	      keep = cb.call(context, i);
	    } else if (dimSize === 1) {
	      var val = this._getFast(dim0, rawIdx);
	
	      keep = cb.call(context, val, i);
	    } else {
	      for (var k = 0; k < dimSize; k++) {
	        value[k] = this._getFast(dim0, rawIdx);
	      }
	
	      value[k] = i;
	      keep = cb.apply(context, value);
	    }
	
	    if (keep) {
	      newIndices[offset++] = rawIdx;
	    }
	  } // Set indices after filtered.
	
	
	  if (offset < count) {
	    this._indices = newIndices;
	  }
	
	  this._count = offset; // Reset data extent
	
	  this._extent = {};
	  this.getRawIndex = this._indices ? getRawIndexWithIndices : getRawIndexWithoutIndices;
	  return this;
	};
	/**
	 * Select data in range. (For optimization of filter)
	 * (Manually inline code, support 5 million data filtering in data zoom.)
	 */
	
	
	listProto.selectRange = function (range) {
	  'use strict';
	
	  if (!this._count) {
	    return;
	  }
	
	  var dimensions = [];
	
	  for (var dim in range) {
	    if (range.hasOwnProperty(dim)) {
	      dimensions.push(dim);
	    }
	  }
	
	  var dimSize = dimensions.length;
	
	  if (!dimSize) {
	    return;
	  }
	
	  var originalCount = this.count();
	  var Ctor = getIndicesCtor(this);
	  var newIndices = new Ctor(originalCount);
	  var offset = 0;
	  var dim0 = dimensions[0];
	  var min = range[dim0][0];
	  var max = range[dim0][1];
	  var quickFinished = false;
	
	  if (!this._indices) {
	    // Extreme optimization for common case. About 2x faster in chrome.
	    var idx = 0;
	
	    if (dimSize === 1) {
	      var dimStorage = this._storage[dimensions[0]];
	
	      for (var k = 0; k < this._chunkCount; k++) {
	        var chunkStorage = dimStorage[k];
	        var len = Math.min(this._count - k * this._chunkSize, this._chunkSize);
	
	        for (var i = 0; i < len; i++) {
	          var val = chunkStorage[i]; // NaN will not be filtered. Consider the case, in line chart, empty
	          // value indicates the line should be broken. But for the case like
	          // scatter plot, a data item with empty value will not be rendered,
	          // but the axis extent may be effected if some other dim of the data
	          // item has value. Fortunately it is not a significant negative effect.
	
	          if (val >= min && val <= max || isNaN(val)) {
	            newIndices[offset++] = idx;
	          }
	
	          idx++;
	        }
	      }
	
	      quickFinished = true;
	    } else if (dimSize === 2) {
	      var dimStorage = this._storage[dim0];
	      var dimStorage2 = this._storage[dimensions[1]];
	      var min2 = range[dimensions[1]][0];
	      var max2 = range[dimensions[1]][1];
	
	      for (var k = 0; k < this._chunkCount; k++) {
	        var chunkStorage = dimStorage[k];
	        var chunkStorage2 = dimStorage2[k];
	        var len = Math.min(this._count - k * this._chunkSize, this._chunkSize);
	
	        for (var i = 0; i < len; i++) {
	          var val = chunkStorage[i];
	          var val2 = chunkStorage2[i]; // Do not filter NaN, see comment above.
	
	          if ((val >= min && val <= max || isNaN(val)) && (val2 >= min2 && val2 <= max2 || isNaN(val2))) {
	            newIndices[offset++] = idx;
	          }
	
	          idx++;
	        }
	      }
	
	      quickFinished = true;
	    }
	  }
	
	  if (!quickFinished) {
	    if (dimSize === 1) {
	      for (var i = 0; i < originalCount; i++) {
	        var rawIndex = this.getRawIndex(i);
	
	        var val = this._getFast(dim0, rawIndex); // Do not filter NaN, see comment above.
	
	
	        if (val >= min && val <= max || isNaN(val)) {
	          newIndices[offset++] = rawIndex;
	        }
	      }
	    } else {
	      for (var i = 0; i < originalCount; i++) {
	        var keep = true;
	        var rawIndex = this.getRawIndex(i);
	
	        for (var k = 0; k < dimSize; k++) {
	          var dimk = dimensions[k];
	
	          var val = this._getFast(dim, rawIndex); // Do not filter NaN, see comment above.
	
	
	          if (val < range[dimk][0] || val > range[dimk][1]) {
	            keep = false;
	          }
	        }
	
	        if (keep) {
	          newIndices[offset++] = this.getRawIndex(i);
	        }
	      }
	    }
	  } // Set indices after filtered.
	
	
	  if (offset < originalCount) {
	    this._indices = newIndices;
	  }
	
	  this._count = offset; // Reset data extent
	
	  this._extent = {};
	  this.getRawIndex = this._indices ? getRawIndexWithIndices : getRawIndexWithoutIndices;
	  return this;
	};
	/**
	 * Data mapping to a plain array
	 * @param {string|Array.<string>} [dimensions]
	 * @param {Function} cb
	 * @param {*} [context=this]
	 * @return {Array}
	 */
	
	
	listProto.mapArray = function (dimensions, cb, context, contextCompat) {
	  'use strict';
	
	  if (typeof dimensions === 'function') {
	    contextCompat = context;
	    context = cb;
	    cb = dimensions;
	    dimensions = [];
	  } // contextCompat just for compat echarts3
	
	
	  context = context || contextCompat || this;
	  var result = [];
	  this.each(dimensions, function () {
	    result.push(cb && cb.apply(this, arguments));
	  }, context);
	  return result;
	}; // Data in excludeDimensions is copied, otherwise transfered.
	
	
	function cloneListForMapAndSample(original, excludeDimensions) {
	  var allDimensions = original.dimensions;
	  var list = new List(zrUtil.map(allDimensions, original.getDimensionInfo, original), original.hostModel); // FIXME If needs stackedOn, value may already been stacked
	
	  transferProperties(list, original);
	  var storage = list._storage = {};
	  var originalStorage = original._storage; // Init storage
	
	  for (var i = 0; i < allDimensions.length; i++) {
	    var dim = allDimensions[i];
	
	    if (originalStorage[dim]) {
	      // Notice that we do not reset invertedIndicesMap here, becuase
	      // there is no scenario of mapping or sampling ordinal dimension.
	      if (zrUtil.indexOf(excludeDimensions, dim) >= 0) {
	        storage[dim] = cloneDimStore(originalStorage[dim]);
	        list._rawExtent[dim] = getInitialExtent();
	        list._extent[dim] = null;
	      } else {
	        // Direct reference for other dimensions
	        storage[dim] = originalStorage[dim];
	      }
	    }
	  }
	
	  return list;
	}
	
	function cloneDimStore(originalDimStore) {
	  var newDimStore = new Array(originalDimStore.length);
	
	  for (var j = 0; j < originalDimStore.length; j++) {
	    newDimStore[j] = cloneChunk(originalDimStore[j]);
	  }
	
	  return newDimStore;
	}
	
	function getInitialExtent() {
	  return [Infinity, -Infinity];
	}
	/**
	 * Data mapping to a new List with given dimensions
	 * @param {string|Array.<string>} dimensions
	 * @param {Function} cb
	 * @param {*} [context=this]
	 * @return {Array}
	 */
	
	
	listProto.map = function (dimensions, cb, context, contextCompat) {
	  'use strict'; // contextCompat just for compat echarts3
	
	  context = context || contextCompat || this;
	  dimensions = zrUtil.map(normalizeDimensions(dimensions), this.getDimension, this);
	  var list = cloneListForMapAndSample(this, dimensions); // Following properties are all immutable.
	  // So we can reference to the same value
	
	  list._indices = this._indices;
	  list.getRawIndex = list._indices ? getRawIndexWithIndices : getRawIndexWithoutIndices;
	  var storage = list._storage;
	  var tmpRetValue = [];
	  var chunkSize = this._chunkSize;
	  var dimSize = dimensions.length;
	  var dataCount = this.count();
	  var values = [];
	  var rawExtent = list._rawExtent;
	
	  for (var dataIndex = 0; dataIndex < dataCount; dataIndex++) {
	    for (var dimIndex = 0; dimIndex < dimSize; dimIndex++) {
	      values[dimIndex] = this.get(dimensions[dimIndex], dataIndex
	      /*, stack */
	      );
	    }
	
	    values[dimSize] = dataIndex;
	    var retValue = cb && cb.apply(context, values);
	
	    if (retValue != null) {
	      // a number or string (in oridinal dimension)?
	      if (typeof retValue !== 'object') {
	        tmpRetValue[0] = retValue;
	        retValue = tmpRetValue;
	      }
	
	      var rawIndex = this.getRawIndex(dataIndex);
	      var chunkIndex = Math.floor(rawIndex / chunkSize);
	      var chunkOffset = rawIndex % chunkSize;
	
	      for (var i = 0; i < retValue.length; i++) {
	        var dim = dimensions[i];
	        var val = retValue[i];
	        var rawExtentOnDim = rawExtent[dim];
	        var dimStore = storage[dim];
	
	        if (dimStore) {
	          dimStore[chunkIndex][chunkOffset] = val;
	        }
	
	        if (val < rawExtentOnDim[0]) {
	          rawExtentOnDim[0] = val;
	        }
	
	        if (val > rawExtentOnDim[1]) {
	          rawExtentOnDim[1] = val;
	        }
	      }
	    }
	  }
	
	  return list;
	};
	/**
	 * Large data down sampling on given dimension
	 * @param {string} dimension
	 * @param {number} rate
	 * @param {Function} sampleValue
	 * @param {Function} sampleIndex Sample index for name and id
	 */
	
	
	listProto.downSample = function (dimension, rate, sampleValue, sampleIndex) {
	  var list = cloneListForMapAndSample(this, [dimension]);
	  var targetStorage = list._storage;
	  var frameValues = [];
	  var frameSize = Math.floor(1 / rate);
	  var dimStore = targetStorage[dimension];
	  var len = this.count();
	  var chunkSize = this._chunkSize;
	  var rawExtentOnDim = list._rawExtent[dimension];
	  var newIndices = new (getIndicesCtor(this))(len);
	  var offset = 0;
	
	  for (var i = 0; i < len; i += frameSize) {
	    // Last frame
	    if (frameSize > len - i) {
	      frameSize = len - i;
	      frameValues.length = frameSize;
	    }
	
	    for (var k = 0; k < frameSize; k++) {
	      var dataIdx = this.getRawIndex(i + k);
	      var originalChunkIndex = Math.floor(dataIdx / chunkSize);
	      var originalChunkOffset = dataIdx % chunkSize;
	      frameValues[k] = dimStore[originalChunkIndex][originalChunkOffset];
	    }
	
	    var value = sampleValue(frameValues);
	    var sampleFrameIdx = this.getRawIndex(Math.min(i + sampleIndex(frameValues, value) || 0, len - 1));
	    var sampleChunkIndex = Math.floor(sampleFrameIdx / chunkSize);
	    var sampleChunkOffset = sampleFrameIdx % chunkSize; // Only write value on the filtered data
	
	    dimStore[sampleChunkIndex][sampleChunkOffset] = value;
	
	    if (value < rawExtentOnDim[0]) {
	      rawExtentOnDim[0] = value;
	    }
	
	    if (value > rawExtentOnDim[1]) {
	      rawExtentOnDim[1] = value;
	    }
	
	    newIndices[offset++] = sampleFrameIdx;
	  }
	
	  list._count = offset;
	  list._indices = newIndices;
	  list.getRawIndex = getRawIndexWithIndices;
	  return list;
	};
	/**
	 * Get model of one data item.
	 *
	 * @param {number} idx
	 */
	// FIXME Model proxy ?
	
	
	listProto.getItemModel = function (idx) {
	  var hostModel = this.hostModel;
	  return new Model(this.getRawDataItem(idx), hostModel, hostModel && hostModel.ecModel);
	};
	/**
	 * Create a data differ
	 * @param {module:echarts/data/List} otherList
	 * @return {module:echarts/data/DataDiffer}
	 */
	
	
	listProto.diff = function (otherList) {
	  var thisList = this;
	  return new DataDiffer(otherList ? otherList.getIndices() : [], this.getIndices(), function (idx) {
	    return getId(otherList, idx);
	  }, function (idx) {
	    return getId(thisList, idx);
	  });
	};
	/**
	 * Get visual property.
	 * @param {string} key
	 */
	
	
	listProto.getVisual = function (key) {
	  var visual = this._visual;
	  return visual && visual[key];
	};
	/**
	 * Set visual property
	 * @param {string|Object} key
	 * @param {*} [value]
	 *
	 * @example
	 *  setVisual('color', color);
	 *  setVisual({
	 *      'color': color
	 *  });
	 */
	
	
	listProto.setVisual = function (key, val) {
	  if (isObject(key)) {
	    for (var name in key) {
	      if (key.hasOwnProperty(name)) {
	        this.setVisual(name, key[name]);
	      }
	    }
	
	    return;
	  }
	
	  this._visual = this._visual || {};
	  this._visual[key] = val;
	};
	/**
	 * Set layout property.
	 * @param {string|Object} key
	 * @param {*} [val]
	 */
	
	
	listProto.setLayout = function (key, val) {
	  if (isObject(key)) {
	    for (var name in key) {
	      if (key.hasOwnProperty(name)) {
	        this.setLayout(name, key[name]);
	      }
	    }
	
	    return;
	  }
	
	  this._layout[key] = val;
	};
	/**
	 * Get layout property.
	 * @param  {string} key.
	 * @return {*}
	 */
	
	
	listProto.getLayout = function (key) {
	  return this._layout[key];
	};
	/**
	 * Get layout of single data item
	 * @param {number} idx
	 */
	
	
	listProto.getItemLayout = function (idx) {
	  return this._itemLayouts[idx];
	};
	/**
	 * Set layout of single data item
	 * @param {number} idx
	 * @param {Object} layout
	 * @param {boolean=} [merge=false]
	 */
	
	
	listProto.setItemLayout = function (idx, layout, merge) {
	  this._itemLayouts[idx] = merge ? zrUtil.extend(this._itemLayouts[idx] || {}, layout) : layout;
	};
	/**
	 * Clear all layout of single data item
	 */
	
	
	listProto.clearItemLayouts = function () {
	  this._itemLayouts.length = 0;
	};
	/**
	 * Get visual property of single data item
	 * @param {number} idx
	 * @param {string} key
	 * @param {boolean} [ignoreParent=false]
	 */
	
	
	listProto.getItemVisual = function (idx, key, ignoreParent) {
	  var itemVisual = this._itemVisuals[idx];
	  var val = itemVisual && itemVisual[key];
	
	  if (val == null && !ignoreParent) {
	    // Use global visual property
	    return this.getVisual(key);
	  }
	
	  return val;
	};
	/**
	 * Set visual property of single data item
	 *
	 * @param {number} idx
	 * @param {string|Object} key
	 * @param {*} [value]
	 *
	 * @example
	 *  setItemVisual(0, 'color', color);
	 *  setItemVisual(0, {
	 *      'color': color
	 *  });
	 */
	
	
	listProto.setItemVisual = function (idx, key, value) {
	  var itemVisual = this._itemVisuals[idx] || {};
	  var hasItemVisual = this.hasItemVisual;
	  this._itemVisuals[idx] = itemVisual;
	
	  if (isObject(key)) {
	    for (var name in key) {
	      if (key.hasOwnProperty(name)) {
	        itemVisual[name] = key[name];
	        hasItemVisual[name] = true;
	      }
	    }
	
	    return;
	  }
	
	  itemVisual[key] = value;
	  hasItemVisual[key] = true;
	};
	/**
	 * Clear itemVisuals and list visual.
	 */
	
	
	listProto.clearAllVisual = function () {
	  this._visual = {};
	  this._itemVisuals = [];
	  this.hasItemVisual = {};
	};
	
	var setItemDataAndSeriesIndex = function (child) {
	  child.seriesIndex = this.seriesIndex;
	  child.dataIndex = this.dataIndex;
	  child.dataType = this.dataType;
	};
	/**
	 * Set graphic element relative to data. It can be set as null
	 * @param {number} idx
	 * @param {module:zrender/Element} [el]
	 */
	
	
	listProto.setItemGraphicEl = function (idx, el) {
	  var hostModel = this.hostModel;
	
	  if (el) {
	    // Add data index and series index for indexing the data by element
	    // Useful in tooltip
	    el.dataIndex = idx;
	    el.dataType = this.dataType;
	    el.seriesIndex = hostModel && hostModel.seriesIndex;
	
	    if (el.type === 'group') {
	      el.traverse(setItemDataAndSeriesIndex, el);
	    }
	  }
	
	  this._graphicEls[idx] = el;
	};
	/**
	 * @param {number} idx
	 * @return {module:zrender/Element}
	 */
	
	
	listProto.getItemGraphicEl = function (idx) {
	  return this._graphicEls[idx];
	};
	/**
	 * @param {Function} cb
	 * @param {*} context
	 */
	
	
	listProto.eachItemGraphicEl = function (cb, context) {
	  zrUtil.each(this._graphicEls, function (el, idx) {
	    if (el) {
	      cb && cb.call(context, el, idx);
	    }
	  });
	};
	/**
	 * Shallow clone a new list except visual and layout properties, and graph elements.
	 * New list only change the indices.
	 */
	
	
	listProto.cloneShallow = function (list) {
	  if (!list) {
	    var dimensionInfoList = zrUtil.map(this.dimensions, this.getDimensionInfo, this);
	    list = new List(dimensionInfoList, this.hostModel);
	  } // FIXME
	
	
	  list._storage = this._storage;
	  transferProperties(list, this); // Clone will not change the data extent and indices
	
	  if (this._indices) {
	    var Ctor = this._indices.constructor;
	    list._indices = new Ctor(this._indices);
	  } else {
	    list._indices = null;
	  }
	
	  list.getRawIndex = list._indices ? getRawIndexWithIndices : getRawIndexWithoutIndices;
	  return list;
	};
	/**
	 * Wrap some method to add more feature
	 * @param {string} methodName
	 * @param {Function} injectFunction
	 */
	
	
	listProto.wrapMethod = function (methodName, injectFunction) {
	  var originalMethod = this[methodName];
	
	  if (typeof originalMethod !== 'function') {
	    return;
	  }
	
	  this.__wrappedMethods = this.__wrappedMethods || [];
	
	  this.__wrappedMethods.push(methodName);
	
	  this[methodName] = function () {
	    var res = originalMethod.apply(this, arguments);
	    return injectFunction.apply(this, [res].concat(zrUtil.slice(arguments)));
	  };
	}; // Methods that create a new list based on this list should be listed here.
	// Notice that those method should `RETURN` the new list.
	
	
	listProto.TRANSFERABLE_METHODS = ['cloneShallow', 'downSample', 'map']; // Methods that change indices of this list should be listed here.
	
	listProto.CHANGABLE_METHODS = ['filterSelf', 'selectRange'];
	var _default = List;
	module.exports = _default;

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var graphic = __webpack_require__(16);
	
	var BoundingRect = __webpack_require__(42);
	
	var _text = __webpack_require__(79);
	
	var calculateTextPosition = _text.calculateTextPosition;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Symbol factory
	
	/**
	 * Triangle shape
	 * @inner
	 */
	var Triangle = graphic.extendShape({
	  type: 'triangle',
	  shape: {
	    cx: 0,
	    cy: 0,
	    width: 0,
	    height: 0
	  },
	  buildPath: function (path, shape) {
	    var cx = shape.cx;
	    var cy = shape.cy;
	    var width = shape.width / 2;
	    var height = shape.height / 2;
	    path.moveTo(cx, cy - height);
	    path.lineTo(cx + width, cy + height);
	    path.lineTo(cx - width, cy + height);
	    path.closePath();
	  }
	});
	/**
	 * Diamond shape
	 * @inner
	 */
	
	var Diamond = graphic.extendShape({
	  type: 'diamond',
	  shape: {
	    cx: 0,
	    cy: 0,
	    width: 0,
	    height: 0
	  },
	  buildPath: function (path, shape) {
	    var cx = shape.cx;
	    var cy = shape.cy;
	    var width = shape.width / 2;
	    var height = shape.height / 2;
	    path.moveTo(cx, cy - height);
	    path.lineTo(cx + width, cy);
	    path.lineTo(cx, cy + height);
	    path.lineTo(cx - width, cy);
	    path.closePath();
	  }
	});
	/**
	 * Pin shape
	 * @inner
	 */
	
	var Pin = graphic.extendShape({
	  type: 'pin',
	  shape: {
	    // x, y on the cusp
	    x: 0,
	    y: 0,
	    width: 0,
	    height: 0
	  },
	  buildPath: function (path, shape) {
	    var x = shape.x;
	    var y = shape.y;
	    var w = shape.width / 5 * 3; // Height must be larger than width
	
	    var h = Math.max(w, shape.height);
	    var r = w / 2; // Dist on y with tangent point and circle center
	
	    var dy = r * r / (h - r);
	    var cy = y - h + r + dy;
	    var angle = Math.asin(dy / r); // Dist on x with tangent point and circle center
	
	    var dx = Math.cos(angle) * r;
	    var tanX = Math.sin(angle);
	    var tanY = Math.cos(angle);
	    var cpLen = r * 0.6;
	    var cpLen2 = r * 0.7;
	    path.moveTo(x - dx, cy + dy);
	    path.arc(x, cy, r, Math.PI - angle, Math.PI * 2 + angle);
	    path.bezierCurveTo(x + dx - tanX * cpLen, cy + dy + tanY * cpLen, x, y - cpLen2, x, y);
	    path.bezierCurveTo(x, y - cpLen2, x - dx + tanX * cpLen, cy + dy + tanY * cpLen, x - dx, cy + dy);
	    path.closePath();
	  }
	});
	/**
	 * Arrow shape
	 * @inner
	 */
	
	var Arrow = graphic.extendShape({
	  type: 'arrow',
	  shape: {
	    x: 0,
	    y: 0,
	    width: 0,
	    height: 0
	  },
	  buildPath: function (ctx, shape) {
	    var height = shape.height;
	    var width = shape.width;
	    var x = shape.x;
	    var y = shape.y;
	    var dx = width / 3 * 2;
	    ctx.moveTo(x, y);
	    ctx.lineTo(x + dx, y + height);
	    ctx.lineTo(x, y + height / 4 * 3);
	    ctx.lineTo(x - dx, y + height);
	    ctx.lineTo(x, y);
	    ctx.closePath();
	  }
	});
	/**
	 * Map of path contructors
	 * @type {Object.<string, module:zrender/graphic/Path>}
	 */
	
	var symbolCtors = {
	  line: graphic.Line,
	  rect: graphic.Rect,
	  roundRect: graphic.Rect,
	  square: graphic.Rect,
	  circle: graphic.Circle,
	  diamond: Diamond,
	  pin: Pin,
	  arrow: Arrow,
	  triangle: Triangle
	};
	var symbolShapeMakers = {
	  line: function (x, y, w, h, shape) {
	    // FIXME
	    shape.x1 = x;
	    shape.y1 = y + h / 2;
	    shape.x2 = x + w;
	    shape.y2 = y + h / 2;
	  },
	  rect: function (x, y, w, h, shape) {
	    shape.x = x;
	    shape.y = y;
	    shape.width = w;
	    shape.height = h;
	  },
	  roundRect: function (x, y, w, h, shape) {
	    shape.x = x;
	    shape.y = y;
	    shape.width = w;
	    shape.height = h;
	    shape.r = Math.min(w, h) / 4;
	  },
	  square: function (x, y, w, h, shape) {
	    var size = Math.min(w, h);
	    shape.x = x;
	    shape.y = y;
	    shape.width = size;
	    shape.height = size;
	  },
	  circle: function (x, y, w, h, shape) {
	    // Put circle in the center of square
	    shape.cx = x + w / 2;
	    shape.cy = y + h / 2;
	    shape.r = Math.min(w, h) / 2;
	  },
	  diamond: function (x, y, w, h, shape) {
	    shape.cx = x + w / 2;
	    shape.cy = y + h / 2;
	    shape.width = w;
	    shape.height = h;
	  },
	  pin: function (x, y, w, h, shape) {
	    shape.x = x + w / 2;
	    shape.y = y + h / 2;
	    shape.width = w;
	    shape.height = h;
	  },
	  arrow: function (x, y, w, h, shape) {
	    shape.x = x + w / 2;
	    shape.y = y + h / 2;
	    shape.width = w;
	    shape.height = h;
	  },
	  triangle: function (x, y, w, h, shape) {
	    shape.cx = x + w / 2;
	    shape.cy = y + h / 2;
	    shape.width = w;
	    shape.height = h;
	  }
	};
	var symbolBuildProxies = {};
	zrUtil.each(symbolCtors, function (Ctor, name) {
	  symbolBuildProxies[name] = new Ctor();
	});
	var SymbolClz = graphic.extendShape({
	  type: 'symbol',
	  shape: {
	    symbolType: '',
	    x: 0,
	    y: 0,
	    width: 0,
	    height: 0
	  },
	  calculateTextPosition: function (out, style, rect) {
	    var res = calculateTextPosition(out, style, rect);
	    var shape = this.shape;
	
	    if (shape && shape.symbolType === 'pin' && style.textPosition === 'inside') {
	      res.y = rect.y + rect.height * 0.4;
	    }
	
	    return res;
	  },
	  buildPath: function (ctx, shape, inBundle) {
	    var symbolType = shape.symbolType;
	
	    if (symbolType !== 'none') {
	      var proxySymbol = symbolBuildProxies[symbolType];
	
	      if (!proxySymbol) {
	        // Default rect
	        symbolType = 'rect';
	        proxySymbol = symbolBuildProxies[symbolType];
	      }
	
	      symbolShapeMakers[symbolType](shape.x, shape.y, shape.width, shape.height, proxySymbol.shape);
	      proxySymbol.buildPath(ctx, proxySymbol.shape, inBundle);
	    }
	  }
	}); // Provide setColor helper method to avoid determine if set the fill or stroke outside
	
	function symbolPathSetColor(color, innerColor) {
	  if (this.type !== 'image') {
	    var symbolStyle = this.style;
	    var symbolShape = this.shape;
	
	    if (symbolShape && symbolShape.symbolType === 'line') {
	      symbolStyle.stroke = color;
	    } else if (this.__isEmptyBrush) {
	      symbolStyle.stroke = color;
	      symbolStyle.fill = innerColor || '#fff';
	    } else {
	      // FIXME 判断图形默认是填充还是描边，使用 onlyStroke ?
	      symbolStyle.fill && (symbolStyle.fill = color);
	      symbolStyle.stroke && (symbolStyle.stroke = color);
	    }
	
	    this.dirty(false);
	  }
	}
	/**
	 * Create a symbol element with given symbol configuration: shape, x, y, width, height, color
	 * @param {string} symbolType
	 * @param {number} x
	 * @param {number} y
	 * @param {number} w
	 * @param {number} h
	 * @param {string} color
	 * @param {boolean} [keepAspect=false] whether to keep the ratio of w/h,
	 *                            for path and image only.
	 */
	
	
	function createSymbol(symbolType, x, y, w, h, color, keepAspect) {
	  // TODO Support image object, DynamicImage.
	  var isEmpty = symbolType.indexOf('empty') === 0;
	
	  if (isEmpty) {
	    symbolType = symbolType.substr(5, 1).toLowerCase() + symbolType.substr(6);
	  }
	
	  var symbolPath;
	
	  if (symbolType.indexOf('image://') === 0) {
	    symbolPath = graphic.makeImage(symbolType.slice(8), new BoundingRect(x, y, w, h), keepAspect ? 'center' : 'cover');
	  } else if (symbolType.indexOf('path://') === 0) {
	    symbolPath = graphic.makePath(symbolType.slice(7), {}, new BoundingRect(x, y, w, h), keepAspect ? 'center' : 'cover');
	  } else {
	    symbolPath = new SymbolClz({
	      shape: {
	        symbolType: symbolType,
	        x: x,
	        y: y,
	        width: w,
	        height: h
	      }
	    });
	  }
	
	  symbolPath.__isEmptyBrush = isEmpty;
	  symbolPath.setColor = symbolPathSetColor;
	  symbolPath.setColor(color);
	  return symbolPath;
	}
	
	exports.createSymbol = createSymbol;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(1807),
	    baseMatchesProperty = __webpack_require__(1808),
	    identity = __webpack_require__(273),
	    isArray = __webpack_require__(35),
	    property = __webpack_require__(1899);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 86 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.name = obj.name;
		this.localisation = obj.localisation;
		this.link = obj.link;
		this.typeParameter = obj.typeparameter;
		this.typeId = obj.type_id;
		this.xCoordinate = obj.xcoordinate;
		this.yCoordinate = obj.ycoordinate;
		this.code = obj.code;
		this.cityId = obj.city_id;
		this.creationDate = obj.creationdate;
		this.updateDate = obj.updatedate;
		this.lastUpdate = obj.lastUpdate;
		this.watershedId = obj.watershed_id;
		this.bssId = obj.bss_id;
		this.sourceId = obj.source_id;
		this.codeDce = obj.code_dce;
		this.profondeur = obj.profondeur;
		this.isPiezometer = obj.ispiezometer === '1';
		this.isQualitometer = obj.isqualitometer === '1';
		this.isHydrologicalStation = obj.ishydrologicalstation === '1';
		this.isPluviometer = obj.ispluviometer === '1';
		this.isTreatmentStation = obj.istreatmentstation === '1';
		this.isIndustrialSite = obj.isindustrialsite === '1';
		this.isSeaport = obj.isseaport === '1';
		this.isPollutedSoil = obj.ispollutedsoil === '1';
	};
	
	exports.default = _class;

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _lodash = __webpack_require__(15);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.name = (0, _lodash.capitalize)(obj.name);
		this.code = obj.code;
		this.postalCode = obj.postal_code;
		this.nameResearch = obj.nameresearch;
		this.codeResearch = obj.coderesearch;
		this.codeResearch = obj.postalcoderesearch;
	};
	
	exports.default = _class;

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _lodash = __webpack_require__(15);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.code = obj.code;
		this.name = (0, _lodash.capitalize)(obj.name) || (0, _lodash.capitalize)(obj.code);
		this.xCoordinate = obj.xcoordinate;
		this.yCoordinate = obj.ycoordinate;
		this.typeId = obj.type_id;
		this.typeParameter = obj.typeparameter;
		this.isPiezometer = obj.ispiezometer;
		this.isQualitometer = obj.isqualitometer;
		this.idWatershed = obj.watershedid;
		this.headers = ['code', 'name'];
	};
	
	exports.default = _class;

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Paper.default;
	  }
	});
	
	var _Paper = _interopRequireDefault(__webpack_require__(1221));

/***/ },
/* 90 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var eventService_1 = __webpack_require__(22);
	var rowComp_1 = __webpack_require__(441);
	var column_1 = __webpack_require__(45);
	var events_1 = __webpack_require__(29);
	var constants_1 = __webpack_require__(30);
	var cellComp_1 = __webpack_require__(251);
	var context_1 = __webpack_require__(8);
	var columnApi_1 = __webpack_require__(38);
	var columnController_1 = __webpack_require__(26);
	var logger_1 = __webpack_require__(68);
	var focusedCellController_1 = __webpack_require__(119);
	var cellNavigationService_1 = __webpack_require__(415);
	var beanStub_1 = __webpack_require__(71);
	var paginationProxy_1 = __webpack_require__(135);
	var gridApi_1 = __webpack_require__(33);
	var pinnedRowModel_1 = __webpack_require__(136);
	var beans_1 = __webpack_require__(161);
	var animationFrameService_1 = __webpack_require__(197);
	var maxDivHeightScaler_1 = __webpack_require__(323);
	var utils_1 = __webpack_require__(10);
	var rowPosition_1 = __webpack_require__(315);
	var RowRenderer = /** @class */ (function (_super) {
	    __extends(RowRenderer, _super);
	    function RowRenderer() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.destroyFuncsForColumnListeners = [];
	        // map of row ids to row objects. keeps track of which elements
	        // are rendered for which rows in the dom.
	        _this.rowCompsByIndex = {};
	        _this.floatingTopRowComps = [];
	        _this.floatingBottomRowComps = [];
	        // we only allow one refresh at a time, otherwise the internal memory structure here
	        // will get messed up. this can happen if the user has a cellRenderer, and inside the
	        // renderer they call an API method that results in another pass of the refresh,
	        // then it will be trying to draw rows in the middle of a refresh.
	        _this.refreshInProgress = false;
	        return _this;
	    }
	    RowRenderer.prototype.registerGridCore = function (gridCore) {
	        this.gridCore = gridCore;
	    };
	    RowRenderer.prototype.getGridCore = function () {
	        return this.gridCore;
	    };
	    RowRenderer.prototype.agWire = function (loggerFactory) {
	        this.logger = loggerFactory.create("RowRenderer");
	    };
	    RowRenderer.prototype.registerGridComp = function (gridPanel) {
	        this.gridPanel = gridPanel;
	        this.rowContainers = this.gridPanel.getRowContainers();
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_PAGINATION_CHANGED, this.onPageLoaded.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_PINNED_ROW_DATA_CHANGED, this.onPinnedRowDataChanged.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_BODY_SCROLL, this.redrawAfterScroll.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_BODY_HEIGHT_CHANGED, this.redrawAfterScroll.bind(this));
	        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_DOM_LAYOUT, this.onDomLayoutChanged.bind(this));
	        this.registerCellEventListeners();
	        this.printLayout = this.gridOptionsWrapper.getDomLayout() === constants_1.Constants.DOM_LAYOUT_PRINT;
	        this.embedFullWidthRows = this.printLayout || this.gridOptionsWrapper.isEmbedFullWidthRows();
	        this.redrawAfterModelUpdate();
	    };
	    // in a clean design, each cell would register for each of these events. however when scrolling, all the cells
	    // registering and de-registering for events is a performance bottleneck. so we register here once and inform
	    // all active cells.
	    RowRenderer.prototype.registerCellEventListeners = function () {
	        var _this = this;
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_CELL_FOCUSED, function (event) {
	            _this.forEachCellComp(function (cellComp) { return cellComp.onCellFocused(event); });
	        });
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_FLASH_CELLS, function (event) {
	            _this.forEachCellComp(function (cellComp) { return cellComp.onFlashCells(event); });
	        });
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_COLUMN_HOVER_CHANGED, function () {
	            _this.forEachCellComp(function (cellComp) { return cellComp.onColumnHover(); });
	        });
	        // only for printLayout - because we are rendering all the cells in the same row, regardless of pinned state,
	        // then changing the width of the containers will impact left position. eg the center cols all have their
	        // left position adjusted by the width of the left pinned column, so if the pinned left column width changes,
	        // all the center cols need to be shifted to accommodate this. when in normal layout, the pinned cols are
	        // in different containers so doesn't impact.
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, function () {
	            if (_this.printLayout) {
	                _this.forEachCellComp(function (cellComp) { return cellComp.onLeftChanged(); });
	            }
	        });
	        var rangeSelectionEnabled = this.gridOptionsWrapper.isEnableRangeSelection();
	        if (rangeSelectionEnabled) {
	            this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_RANGE_SELECTION_CHANGED, function () {
	                _this.forEachCellComp(function (cellComp) { return cellComp.onRangeSelectionChanged(); });
	            });
	            this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_COLUMN_MOVED, function () {
	                _this.forEachCellComp(function (cellComp) { return cellComp.updateRangeBordersIfRangeCount(); });
	            });
	            this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_COLUMN_PINNED, function () {
	                _this.forEachCellComp(function (cellComp) { return cellComp.updateRangeBordersIfRangeCount(); });
	            });
	            this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_COLUMN_VISIBLE, function () {
	                _this.forEachCellComp(function (cellComp) { return cellComp.updateRangeBordersIfRangeCount(); });
	            });
	        }
	        // add listeners to the grid columns
	        this.refreshListenersToColumnsForCellComps();
	        // if the grid columns change, then refresh the listeners again
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_GRID_COLUMNS_CHANGED, this.refreshListenersToColumnsForCellComps.bind(this));
	        this.addDestroyFunc(this.removeGridColumnListeners.bind(this));
	    };
	    // executes all functions in destroyFuncsForColumnListeners and then clears the list
	    RowRenderer.prototype.removeGridColumnListeners = function () {
	        this.destroyFuncsForColumnListeners.forEach(function (func) { return func(); });
	        this.destroyFuncsForColumnListeners.length = 0;
	    };
	    // this function adds listeners onto all the grid columns, which are the column that we could have cellComps for.
	    // when the grid columns change, we add listeners again. in an ideal design, each CellComp would just register to
	    // the column it belongs to on creation, however this was a bottleneck with the number of cells, so do it here
	    // once instead.
	    RowRenderer.prototype.refreshListenersToColumnsForCellComps = function () {
	        var _this = this;
	        this.removeGridColumnListeners();
	        var cols = this.columnController.getAllGridColumns();
	        if (!cols) {
	            return;
	        }
	        cols.forEach(function (col) {
	            var forEachCellWithThisCol = function (callback) {
	                _this.forEachCellComp(function (cellComp) {
	                    if (cellComp.getColumn() === col) {
	                        callback(cellComp);
	                    }
	                });
	            };
	            var leftChangedListener = function () {
	                forEachCellWithThisCol(function (cellComp) { return cellComp.onLeftChanged(); });
	            };
	            var widthChangedListener = function () {
	                forEachCellWithThisCol(function (cellComp) { return cellComp.onWidthChanged(); });
	            };
	            var firstRightPinnedChangedListener = function () {
	                forEachCellWithThisCol(function (cellComp) { return cellComp.onFirstRightPinnedChanged(); });
	            };
	            var lastLeftPinnedChangedListener = function () {
	                forEachCellWithThisCol(function (cellComp) { return cellComp.onLastLeftPinnedChanged(); });
	            };
	            col.addEventListener(column_1.Column.EVENT_LEFT_CHANGED, leftChangedListener);
	            col.addEventListener(column_1.Column.EVENT_WIDTH_CHANGED, widthChangedListener);
	            col.addEventListener(column_1.Column.EVENT_FIRST_RIGHT_PINNED_CHANGED, firstRightPinnedChangedListener);
	            col.addEventListener(column_1.Column.EVENT_LAST_LEFT_PINNED_CHANGED, lastLeftPinnedChangedListener);
	            _this.destroyFuncsForColumnListeners.push(function () {
	                col.removeEventListener(column_1.Column.EVENT_LEFT_CHANGED, leftChangedListener);
	                col.removeEventListener(column_1.Column.EVENT_WIDTH_CHANGED, widthChangedListener);
	                col.removeEventListener(column_1.Column.EVENT_FIRST_RIGHT_PINNED_CHANGED, firstRightPinnedChangedListener);
	                col.removeEventListener(column_1.Column.EVENT_LAST_LEFT_PINNED_CHANGED, lastLeftPinnedChangedListener);
	            });
	        });
	    };
	    RowRenderer.prototype.onDomLayoutChanged = function () {
	        var printLayout = this.gridOptionsWrapper.getDomLayout() === constants_1.Constants.DOM_LAYOUT_PRINT;
	        var embedFullWidthRows = printLayout || this.gridOptionsWrapper.isEmbedFullWidthRows();
	        // if moving towards or away from print layout, means we need to destroy all rows, as rows are not laid
	        // out using absolute positioning when doing print layout
	        var destroyRows = embedFullWidthRows !== this.embedFullWidthRows || this.printLayout !== printLayout;
	        this.printLayout = printLayout;
	        this.embedFullWidthRows = embedFullWidthRows;
	        if (destroyRows) {
	            this.redrawAfterModelUpdate();
	        }
	    };
	    // for row models that have datasources, when we update the datasource, we need to force the rowRenderer
	    // to redraw all rows. otherwise the old rows from the old datasource will stay displayed.
	    RowRenderer.prototype.datasourceChanged = function () {
	        this.firstRenderedRow = 0;
	        this.lastRenderedRow = -1;
	        var rowIndexesToRemove = Object.keys(this.rowCompsByIndex);
	        this.removeRowComps(rowIndexesToRemove);
	    };
	    RowRenderer.prototype.onPageLoaded = function (refreshEvent) {
	        if (utils_1._.missing(refreshEvent)) {
	            refreshEvent = {
	                type: events_1.Events.EVENT_MODEL_UPDATED,
	                api: this.gridApi,
	                columnApi: this.columnApi,
	                animate: false,
	                keepRenderedRows: false,
	                newData: false,
	                newPage: false
	            };
	        }
	        this.onModelUpdated(refreshEvent);
	    };
	    RowRenderer.prototype.getAllCellsForColumn = function (column) {
	        var eCells = [];
	        utils_1._.iterateObject(this.rowCompsByIndex, callback);
	        utils_1._.iterateObject(this.floatingBottomRowComps, callback);
	        utils_1._.iterateObject(this.floatingTopRowComps, callback);
	        function callback(key, rowComp) {
	            var eCell = rowComp.getCellForCol(column);
	            if (eCell) {
	                eCells.push(eCell);
	            }
	        }
	        return eCells;
	    };
	    RowRenderer.prototype.refreshFloatingRowComps = function () {
	        this.refreshFloatingRows(this.floatingTopRowComps, this.pinnedRowModel.getPinnedTopRowData(), this.rowContainers.floatingTopPinnedLeft, this.rowContainers.floatingTopPinnedRight, this.rowContainers.floatingTop, this.rowContainers.floatingTopFullWidth);
	        this.refreshFloatingRows(this.floatingBottomRowComps, this.pinnedRowModel.getPinnedBottomRowData(), this.rowContainers.floatingBottomPinnedLeft, this.rowContainers.floatingBottomPinnedRight, this.rowContainers.floatingBottom, this.rowContainers.floatingBottomFullWith);
	    };
	    RowRenderer.prototype.refreshFloatingRows = function (rowComps, rowNodes, pinnedLeftContainerComp, pinnedRightContainerComp, bodyContainerComp, fullWidthContainerComp) {
	        var _this = this;
	        rowComps.forEach(function (row) {
	            row.destroy();
	        });
	        rowComps.length = 0;
	        if (rowNodes) {
	            rowNodes.forEach(function (node) {
	                var rowComp = new rowComp_1.RowComp(_this.$scope, bodyContainerComp, pinnedLeftContainerComp, pinnedRightContainerComp, fullWidthContainerComp, node, _this.beans, false, false, _this.printLayout, _this.embedFullWidthRows);
	                rowComp.init();
	                rowComps.push(rowComp);
	            });
	        }
	        this.flushContainers(rowComps);
	    };
	    RowRenderer.prototype.onPinnedRowDataChanged = function () {
	        // recycling rows in order to ensure cell editing is not cancelled
	        var params = {
	            recycleRows: true
	        };
	        this.redrawAfterModelUpdate(params);
	    };
	    RowRenderer.prototype.onModelUpdated = function (refreshEvent) {
	        var params = {
	            recycleRows: refreshEvent.keepRenderedRows,
	            animate: refreshEvent.animate,
	            newData: refreshEvent.newData,
	            newPage: refreshEvent.newPage,
	            // because this is a model updated event (not pinned rows), we
	            // can skip updating the pinned rows. this is needed so that if user
	            // is doing transaction updates, the pinned rows are not getting constantly
	            // trashed - or editing cells in pinned rows are not refreshed and put into read mode
	            onlyBody: true
	        };
	        this.redrawAfterModelUpdate(params);
	    };
	    // if the row nodes are not rendered, no index is returned
	    RowRenderer.prototype.getRenderedIndexesForRowNodes = function (rowNodes) {
	        var result = [];
	        if (utils_1._.missing(rowNodes)) {
	            return result;
	        }
	        utils_1._.iterateObject(this.rowCompsByIndex, function (index, renderedRow) {
	            var rowNode = renderedRow.getRowNode();
	            if (rowNodes.indexOf(rowNode) >= 0) {
	                result.push(index);
	            }
	        });
	        return result;
	    };
	    RowRenderer.prototype.redrawRows = function (rowNodes) {
	        if (!rowNodes || rowNodes.length == 0) {
	            return;
	        }
	        // we only need to be worried about rendered rows, as this method is
	        // called to what's rendered. if the row isn't rendered, we don't care
	        var indexesToRemove = this.getRenderedIndexesForRowNodes(rowNodes);
	        // remove the rows
	        this.removeRowComps(indexesToRemove);
	        // add draw them again
	        this.redrawAfterModelUpdate({
	            recycleRows: true
	        });
	    };
	    RowRenderer.prototype.getCellToRestoreFocusToAfterRefresh = function (params) {
	        var focusedCell = params.suppressKeepFocus ? null : this.focusedCellController.getFocusCellToUseAfterRefresh();
	        if (utils_1._.missing(focusedCell)) {
	            return null;
	        }
	        // if the dom is not actually focused on a cell, then we don't try to refocus. the problem this
	        // solves is with editing - if the user is editing, eg focus is on a text field, and not on the
	        // cell itself, then the cell can be registered as having focus, however it's the text field that
	        // has the focus and not the cell div. therefore, when the refresh is finished, the grid will focus
	        // the cell, and not the textfield. that means if the user is in a text field, and the grid refreshes,
	        // the focus is lost from the text field. we do not want this.
	        var activeElement = document.activeElement;
	        var domData = this.gridOptionsWrapper.getDomData(activeElement, cellComp_1.CellComp.DOM_DATA_KEY_CELL_COMP);
	        var elementIsNotACellDev = utils_1._.missing(domData);
	        if (elementIsNotACellDev) {
	            return null;
	        }
	        return focusedCell;
	    };
	    // gets called after changes to the model.
	    RowRenderer.prototype.redrawAfterModelUpdate = function (params) {
	        if (params === void 0) { params = {}; }
	        this.getLockOnRefresh();
	        var focusedCell = this.getCellToRestoreFocusToAfterRefresh(params);
	        this.sizeContainerToPageHeight();
	        this.scrollToTopIfNewData(params);
	        // never recycle rows when print layout, we draw each row again from scratch. this is because print layout
	        // uses normal dom layout to put cells into dom - it doesn't allow reordering rows.
	        var recycleRows = !this.printLayout && params.recycleRows;
	        var animate = params.animate && this.gridOptionsWrapper.isAnimateRows();
	        var rowsToRecycle = this.binRowComps(recycleRows);
	        this.redraw(rowsToRecycle, animate);
	        if (!params.onlyBody) {
	            this.refreshFloatingRowComps();
	        }
	        this.restoreFocusedCell(focusedCell);
	        this.releaseLockOnRefresh();
	    };
	    RowRenderer.prototype.scrollToTopIfNewData = function (params) {
	        var scrollToTop = params.newData || params.newPage;
	        var suppressScrollToTop = this.gridOptionsWrapper.isSuppressScrollOnNewData();
	        if (scrollToTop && !suppressScrollToTop) {
	            this.gridPanel.scrollToTop();
	        }
	    };
	    RowRenderer.prototype.sizeContainerToPageHeight = function () {
	        var containers = [
	            this.rowContainers.body,
	            this.rowContainers.fullWidth,
	            this.rowContainers.pinnedLeft,
	            this.rowContainers.pinnedRight
	        ];
	        if (this.printLayout) {
	            containers.forEach(function (container) { return container.setHeight(null); });
	            return;
	        }
	        var containerHeight = this.paginationProxy.getCurrentPageHeight();
	        // we need at least 1 pixel for the horizontal scroll to work. so if there are now rows,
	        // we still want the scroll to be present, otherwise there would be no way to scroll the header
	        // which might be needed us user wants to access columns
	        // on the RHS - and if that was where the filter was that cause no rows to be presented, there
	        // is no way to remove the filter.
	        if (containerHeight === 0) {
	            containerHeight = 1;
	        }
	        this.maxDivHeightScaler.setModelHeight(containerHeight);
	        var realHeight = this.maxDivHeightScaler.getUiContainerHeight();
	        containers.forEach(function (container) { return container.setHeight(realHeight); });
	    };
	    RowRenderer.prototype.getLockOnRefresh = function () {
	        if (this.refreshInProgress) {
	            throw new Error("ag-Grid: cannot get grid to draw rows when it is in the middle of drawing rows. " +
	                "Your code probably called a grid API method while the grid was in the render stage. To overcome " +
	                "this, put the API call into a timeout, eg instead of api.refreshView(), " +
	                "call setTimeout(function(){api.refreshView(),0}). To see what part of your code " +
	                "that caused the refresh check this stacktrace.");
	        }
	        this.refreshInProgress = true;
	    };
	    RowRenderer.prototype.releaseLockOnRefresh = function () {
	        this.refreshInProgress = false;
	    };
	    // sets the focus to the provided cell, if the cell is provided. this way, the user can call refresh without
	    // worry about the focus been lost. this is important when the user is using keyboard navigation to do edits
	    // and the cellEditor is calling 'refresh' to get other cells to update (as other cells might depend on the
	    // edited cell).
	    RowRenderer.prototype.restoreFocusedCell = function (cellPosition) {
	        if (cellPosition) {
	            this.focusedCellController.setFocusedCell(cellPosition.rowIndex, cellPosition.column, cellPosition.rowPinned, true);
	        }
	    };
	    RowRenderer.prototype.stopEditing = function (cancel) {
	        if (cancel === void 0) { cancel = false; }
	        this.forEachRowComp(function (key, rowComp) {
	            rowComp.stopEditing(cancel);
	        });
	    };
	    RowRenderer.prototype.forEachCellComp = function (callback) {
	        this.forEachRowComp(function (key, rowComp) { return rowComp.forEachCellComp(callback); });
	    };
	    RowRenderer.prototype.forEachRowComp = function (callback) {
	        utils_1._.iterateObject(this.rowCompsByIndex, callback);
	        utils_1._.iterateObject(this.floatingTopRowComps, callback);
	        utils_1._.iterateObject(this.floatingBottomRowComps, callback);
	    };
	    RowRenderer.prototype.addRenderedRowListener = function (eventName, rowIndex, callback) {
	        var rowComp = this.rowCompsByIndex[rowIndex];
	        if (rowComp) {
	            rowComp.addEventListener(eventName, callback);
	        }
	    };
	    RowRenderer.prototype.flashCells = function (params) {
	        if (params === void 0) { params = {}; }
	        this.forEachCellCompFiltered(params.rowNodes, params.columns, function (cellComp) { return cellComp.flashCell(); });
	    };
	    RowRenderer.prototype.refreshCells = function (params) {
	        if (params === void 0) { params = {}; }
	        var refreshCellParams = {
	            forceRefresh: params.force,
	            newData: false
	        };
	        this.forEachCellCompFiltered(params.rowNodes, params.columns, function (cellComp) { return cellComp.refreshCell(refreshCellParams); });
	    };
	    RowRenderer.prototype.getCellRendererInstances = function (params) {
	        var res = [];
	        this.forEachCellCompFiltered(params.rowNodes, params.columns, function (cellComp) {
	            var cellRenderer = cellComp.getCellRenderer();
	            if (cellRenderer) {
	                res.push(cellRenderer);
	            }
	        });
	        return res;
	    };
	    RowRenderer.prototype.getCellEditorInstances = function (params) {
	        var res = [];
	        this.forEachCellCompFiltered(params.rowNodes, params.columns, function (cellComp) {
	            var cellEditor = cellComp.getCellEditor();
	            if (cellEditor) {
	                res.push(cellEditor);
	            }
	        });
	        return res;
	    };
	    RowRenderer.prototype.getEditingCells = function () {
	        var res = [];
	        this.forEachCellComp(function (cellComp) {
	            if (cellComp.isEditing()) {
	                var cellPosition = cellComp.getCellPosition();
	                res.push(cellPosition);
	            }
	        });
	        return res;
	    };
	    // calls the callback for each cellComp that match the provided rowNodes and columns. eg if one row node
	    // and two columns provided, that identifies 4 cells, so callback gets called 4 times, once for each cell.
	    RowRenderer.prototype.forEachCellCompFiltered = function (rowNodes, columns, callback) {
	        var _this = this;
	        var rowIdsMap;
	        if (utils_1._.exists(rowNodes)) {
	            rowIdsMap = {
	                top: {},
	                bottom: {},
	                normal: {}
	            };
	            rowNodes.forEach(function (rowNode) {
	                if (rowNode.rowPinned === constants_1.Constants.PINNED_TOP) {
	                    rowIdsMap.top[rowNode.id] = true;
	                }
	                else if (rowNode.rowPinned === constants_1.Constants.PINNED_BOTTOM) {
	                    rowIdsMap.bottom[rowNode.id] = true;
	                }
	                else {
	                    rowIdsMap.normal[rowNode.id] = true;
	                }
	            });
	        }
	        var colIdsMap;
	        if (utils_1._.exists(columns)) {
	            colIdsMap = {};
	            columns.forEach(function (colKey) {
	                var column = _this.columnController.getGridColumn(colKey);
	                if (utils_1._.exists(column)) {
	                    colIdsMap[column.getId()] = true;
	                }
	            });
	        }
	        var processRow = function (rowComp) {
	            var rowNode = rowComp.getRowNode();
	            var id = rowNode.id;
	            var floating = rowNode.rowPinned;
	            // skip this row if it is missing from the provided list
	            if (utils_1._.exists(rowIdsMap)) {
	                if (floating === constants_1.Constants.PINNED_BOTTOM) {
	                    if (!rowIdsMap.bottom[id]) {
	                        return;
	                    }
	                }
	                else if (floating === constants_1.Constants.PINNED_TOP) {
	                    if (!rowIdsMap.top[id]) {
	                        return;
	                    }
	                }
	                else {
	                    if (!rowIdsMap.normal[id]) {
	                        return;
	                    }
	                }
	            }
	            rowComp.forEachCellComp(function (cellComp) {
	                var colId = cellComp.getColumn().getId();
	                var excludeColFromRefresh = colIdsMap && !colIdsMap[colId];
	                if (excludeColFromRefresh) {
	                    return;
	                }
	                callback(cellComp);
	            });
	        };
	        utils_1._.iterateObject(this.rowCompsByIndex, function (index, rowComp) {
	            processRow(rowComp);
	        });
	        if (this.floatingTopRowComps) {
	            this.floatingTopRowComps.forEach(processRow);
	        }
	        if (this.floatingBottomRowComps) {
	            this.floatingBottomRowComps.forEach(processRow);
	        }
	    };
	    RowRenderer.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        var rowIndexesToRemove = Object.keys(this.rowCompsByIndex);
	        this.removeRowComps(rowIndexesToRemove);
	    };
	    RowRenderer.prototype.binRowComps = function (recycleRows) {
	        var _this = this;
	        var indexesToRemove;
	        var rowsToRecycle = {};
	        if (recycleRows) {
	            indexesToRemove = [];
	            utils_1._.iterateObject(this.rowCompsByIndex, function (index, rowComp) {
	                var rowNode = rowComp.getRowNode();
	                if (utils_1._.exists(rowNode.id)) {
	                    rowsToRecycle[rowNode.id] = rowComp;
	                    delete _this.rowCompsByIndex[index];
	                }
	                else {
	                    indexesToRemove.push(index);
	                }
	            });
	        }
	        else {
	            indexesToRemove = Object.keys(this.rowCompsByIndex);
	        }
	        this.removeRowComps(indexesToRemove);
	        return rowsToRecycle;
	    };
	    // takes array of row indexes
	    RowRenderer.prototype.removeRowComps = function (rowsToRemove) {
	        var _this = this;
	        // if no fromIndex then set to -1, which will refresh everything
	        // let realFromIndex = -1;
	        rowsToRemove.forEach(function (indexToRemove) {
	            var renderedRow = _this.rowCompsByIndex[indexToRemove];
	            renderedRow.destroy();
	            delete _this.rowCompsByIndex[indexToRemove];
	        });
	    };
	    // gets called when rows don't change, but viewport does, so after:
	    // 1) height of grid body changes, ie number of displayed rows has changed
	    // 2) grid scrolled to new position
	    // 3) ensure index visible (which is a scroll)
	    RowRenderer.prototype.redrawAfterScroll = function () {
	        this.getLockOnRefresh();
	        this.redraw(null, false, true);
	        this.releaseLockOnRefresh();
	    };
	    RowRenderer.prototype.removeRowCompsNotToDraw = function (indexesToDraw) {
	        // for speedy lookup, dump into map
	        var indexesToDrawMap = {};
	        indexesToDraw.forEach(function (index) { return (indexesToDrawMap[index] = true); });
	        var existingIndexes = Object.keys(this.rowCompsByIndex);
	        var indexesNotToDraw = utils_1._.filter(existingIndexes, function (index) { return !indexesToDrawMap[index]; });
	        this.removeRowComps(indexesNotToDraw);
	    };
	    RowRenderer.prototype.calculateIndexesToDraw = function () {
	        var _this = this;
	        // all in all indexes in the viewport
	        var indexesToDraw = utils_1._.createArrayOfNumbers(this.firstRenderedRow, this.lastRenderedRow);
	        // add in indexes of rows we want to keep, because they are currently editing
	        utils_1._.iterateObject(this.rowCompsByIndex, function (indexStr, rowComp) {
	            var index = Number(indexStr);
	            if (index < _this.firstRenderedRow || index > _this.lastRenderedRow) {
	                if (_this.doNotUnVirtualiseRow(rowComp)) {
	                    indexesToDraw.push(index);
	                }
	            }
	        });
	        indexesToDraw.sort(function (a, b) { return a - b; });
	        return indexesToDraw;
	    };
	    RowRenderer.prototype.redraw = function (rowsToRecycle, animate, afterScroll) {
	        var _this = this;
	        if (animate === void 0) { animate = false; }
	        if (afterScroll === void 0) { afterScroll = false; }
	        this.maxDivHeightScaler.updateOffset();
	        this.workOutFirstAndLastRowsToRender();
	        // the row can already exist and be in the following:
	        // rowsToRecycle -> if model change, then the index may be different, however row may
	        //                         exist here from previous time (mapped by id).
	        // this.rowCompsByIndex -> if just a scroll, then this will contain what is currently in the viewport
	        // this is all the indexes we want, including those that already exist, so this method
	        // will end up going through each index and drawing only if the row doesn't already exist
	        var indexesToDraw = this.calculateIndexesToDraw();
	        this.removeRowCompsNotToDraw(indexesToDraw);
	        // never animate when doing print layout - as we want to get things ready to print as quickly as possible,
	        // otherwise we risk the printer printing a row that's half faded (half way through fading in)
	        if (this.printLayout) {
	            animate = false;
	        }
	        // add in new rows
	        var nextVmTurnFunctions = [];
	        var rowComps = [];
	        indexesToDraw.forEach(function (rowIndex) {
	            var rowComp = _this.createOrUpdateRowComp(rowIndex, rowsToRecycle, animate, afterScroll);
	            if (utils_1._.exists(rowComp)) {
	                rowComps.push(rowComp);
	                utils_1._.pushAll(nextVmTurnFunctions, rowComp.getAndClearNextVMTurnFunctions());
	            }
	        });
	        this.flushContainers(rowComps);
	        utils_1._.executeNextVMTurn(nextVmTurnFunctions);
	        var useAnimationFrame = afterScroll && !this.gridOptionsWrapper.isSuppressAnimationFrame() && !this.printLayout;
	        if (useAnimationFrame) {
	            this.beans.taskQueue.addP2Task(this.destroyRowComps.bind(this, rowsToRecycle, animate));
	        }
	        else {
	            this.destroyRowComps(rowsToRecycle, animate);
	        }
	        this.checkAngularCompile();
	        this.gridPanel.updateRowCount();
	    };
	    RowRenderer.prototype.flushContainers = function (rowComps) {
	        utils_1._.iterateObject(this.rowContainers, function (key, rowContainerComp) {
	            if (rowContainerComp) {
	                rowContainerComp.flushRowTemplates();
	            }
	        });
	        rowComps.forEach(function (rowComp) { return rowComp.afterFlush(); });
	    };
	    RowRenderer.prototype.onDisplayedColumnsChanged = function () {
	        var pinningLeft = this.columnController.isPinningLeft();
	        var pinningRight = this.columnController.isPinningRight();
	        var atLeastOneChanged = this.pinningLeft !== pinningLeft || pinningRight !== this.pinningRight;
	        if (atLeastOneChanged) {
	            this.pinningLeft = pinningLeft;
	            this.pinningRight = pinningRight;
	            if (this.embedFullWidthRows) {
	                this.redrawFullWidthEmbeddedRows();
	            }
	        }
	    };
	    // when embedding, what gets showed in each section depends on what is pinned. eg if embedding group expand / collapse,
	    // then it should go into the pinned left area if pinning left, or the center area if not pinning.
	    RowRenderer.prototype.redrawFullWidthEmbeddedRows = function () {
	        // if either of the pinned panels has shown / hidden, then need to redraw the fullWidth bits when
	        // embedded, as what appears in each section depends on whether we are pinned or not
	        var rowsToRemove = [];
	        utils_1._.iterateObject(this.rowCompsByIndex, function (id, rowComp) {
	            if (rowComp.isFullWidth()) {
	                var rowIndex = rowComp.getRowNode().rowIndex;
	                rowsToRemove.push(rowIndex.toString());
	            }
	        });
	        this.refreshFloatingRowComps();
	        this.removeRowComps(rowsToRemove);
	        this.redrawAfterScroll();
	    };
	    RowRenderer.prototype.refreshFullWidthRows = function () {
	        var rowsToRemove = [];
	        utils_1._.iterateObject(this.rowCompsByIndex, function (id, rowComp) {
	            if (rowComp.isFullWidth()) {
	                var fullWidthRowsRefreshed = rowComp.refreshFullWidth();
	                if (!fullWidthRowsRefreshed) {
	                    var rowIndex = rowComp.getRowNode().rowIndex;
	                    rowsToRemove.push(rowIndex.toString());
	                }
	            }
	        });
	        this.removeRowComps(rowsToRemove);
	        this.redrawAfterScroll();
	    };
	    RowRenderer.prototype.createOrUpdateRowComp = function (rowIndex, rowsToRecycle, animate, afterScroll) {
	        var rowNode;
	        var rowComp = this.rowCompsByIndex[rowIndex];
	        // if no row comp, see if we can get it from the previous rowComps
	        if (!rowComp) {
	            rowNode = this.paginationProxy.getRow(rowIndex);
	            if (utils_1._.exists(rowNode) && utils_1._.exists(rowsToRecycle) && rowsToRecycle[rowNode.id] && rowNode.alreadyRendered) {
	                rowComp = rowsToRecycle[rowNode.id];
	                rowsToRecycle[rowNode.id] = null;
	            }
	        }
	        var creatingNewRowComp = !rowComp;
	        if (creatingNewRowComp) {
	            // create a new one
	            if (!rowNode) {
	                rowNode = this.paginationProxy.getRow(rowIndex);
	            }
	            if (utils_1._.exists(rowNode)) {
	                rowComp = this.createRowComp(rowNode, animate, afterScroll);
	            }
	            else {
	                // this should never happen - if somehow we are trying to create
	                // a row for a rowNode that does not exist.
	                return;
	            }
	        }
	        else {
	            // ensure row comp is in right position in DOM
	            rowComp.ensureDomOrder();
	        }
	        if (rowNode) {
	            // set node as 'alreadyRendered' to ensure we only recycle rowComps that have been rendered, this ensures
	            // we don't reuse rowComps that have been removed and then re-added in the same batch transaction.
	            rowNode.alreadyRendered = true;
	        }
	        this.rowCompsByIndex[rowIndex] = rowComp;
	        return rowComp;
	    };
	    RowRenderer.prototype.destroyRowComps = function (rowCompsMap, animate) {
	        var delayedFuncs = [];
	        utils_1._.iterateObject(rowCompsMap, function (nodeId, rowComp) {
	            // if row was used, then it's null
	            if (!rowComp) {
	                return;
	            }
	            rowComp.destroy(animate);
	            utils_1._.pushAll(delayedFuncs, rowComp.getAndClearDelayedDestroyFunctions());
	        });
	        utils_1._.executeInAWhile(delayedFuncs);
	    };
	    RowRenderer.prototype.checkAngularCompile = function () {
	        var _this = this;
	        // if we are doing angular compiling, then do digest the scope here
	        if (this.gridOptionsWrapper.isAngularCompileRows()) {
	            // we do it in a timeout, in case we are already in an apply
	            window.setTimeout(function () {
	                _this.$scope.$apply();
	            }, 0);
	        }
	    };
	    RowRenderer.prototype.workOutFirstAndLastRowsToRender = function () {
	        var newFirst;
	        var newLast;
	        if (!this.paginationProxy.isRowsToRender()) {
	            newFirst = 0;
	            newLast = -1; // setting to -1 means nothing in range
	        }
	        else if (this.printLayout) {
	            newFirst = this.paginationProxy.getPageFirstRow();
	            newLast = this.paginationProxy.getPageLastRow();
	        }
	        else {
	            var paginationOffset = this.paginationProxy.getPixelOffset();
	            var maxDivHeightScaler = this.maxDivHeightScaler.getOffset();
	            var bodyVRange = this.gridPanel.getVScrollPosition();
	            var bodyTopPixel = bodyVRange.top;
	            var bodyBottomPixel = bodyVRange.bottom;
	            var bufferPixels = this.gridOptionsWrapper.getRowBufferInPixels();
	            var firstPixel = bodyTopPixel + paginationOffset + maxDivHeightScaler - bufferPixels;
	            var lastPixel = bodyBottomPixel + paginationOffset + maxDivHeightScaler + bufferPixels;
	            this.ensureAllRowsInRangeHaveHeightsCalculated(firstPixel, lastPixel);
	            var firstRowIndex = this.paginationProxy.getRowIndexAtPixel(firstPixel);
	            var lastRowIndex = this.paginationProxy.getRowIndexAtPixel(lastPixel);
	            var pageFirstRow = this.paginationProxy.getPageFirstRow();
	            var pageLastRow = this.paginationProxy.getPageLastRow();
	            // adjust, in case buffer extended actual size
	            if (firstRowIndex < pageFirstRow) {
	                firstRowIndex = pageFirstRow;
	            }
	            if (lastRowIndex > pageLastRow) {
	                lastRowIndex = pageLastRow;
	            }
	            newFirst = firstRowIndex;
	            newLast = lastRowIndex;
	        }
	        // sometimes user doesn't set CSS right and ends up with grid with no height and grid ends up
	        // trying to render all the rows, eg 10,000+ rows. this will kill the browser. so instead of
	        // killing the browser, we limit the number of rows. just in case some use case we didn't think
	        // of, we also have a property to not do this operation.
	        var rowLayoutNormal = this.gridOptionsWrapper.getDomLayout() === constants_1.Constants.DOM_LAYOUT_NORMAL;
	        var suppressRowCountRestriction = this.gridOptionsWrapper.isSuppressMaxRenderedRowRestriction();
	        var rowBufferMaxSize = Math.max(this.gridOptionsWrapper.getRowBuffer(), 500);
	        if (rowLayoutNormal && !suppressRowCountRestriction) {
	            if (newLast - newFirst > rowBufferMaxSize) {
	                newLast = newFirst + rowBufferMaxSize;
	            }
	        }
	        var firstDiffers = newFirst !== this.firstRenderedRow;
	        var lastDiffers = newLast !== this.lastRenderedRow;
	        if (firstDiffers || lastDiffers) {
	            this.firstRenderedRow = newFirst;
	            this.lastRenderedRow = newLast;
	            var event_1 = {
	                type: events_1.Events.EVENT_VIEWPORT_CHANGED,
	                firstRow: newFirst,
	                lastRow: newLast,
	                api: this.gridApi,
	                columnApi: this.columnApi
	            };
	            this.eventService.dispatchEvent(event_1);
	        }
	        if (this.paginationProxy.isRowsToRender()) {
	            var event_2 = {
	                type: events_1.Events.EVENT_FIRST_DATA_RENDERED,
	                firstRow: newFirst,
	                lastRow: newLast,
	                api: this.gridApi,
	                columnApi: this.columnApi
	            };
	            this.eventService.dispatchEventOnce(event_2);
	        }
	    };
	    RowRenderer.prototype.ensureAllRowsInRangeHaveHeightsCalculated = function (topPixel, bottomPixel) {
	        // ensureRowHeightsVisible only works with CSRM, as it's the only row model that allows lazy row height calcs.
	        // all the other row models just hard code so the method just returns back false
	        var rowHeightsChanged = this.paginationProxy.ensureRowHeightsValid(topPixel, bottomPixel, -1, -1);
	        if (rowHeightsChanged) {
	            // if row heights have changed, we need to resize the containers the rows sit it
	            this.sizeContainerToPageHeight();
	            // we also need to update heightScaler as this has dependency of row container height
	            this.maxDivHeightScaler.updateOffset();
	        }
	    };
	    RowRenderer.prototype.getFirstVirtualRenderedRow = function () {
	        return this.firstRenderedRow;
	    };
	    RowRenderer.prototype.getLastVirtualRenderedRow = function () {
	        return this.lastRenderedRow;
	    };
	    // check that none of the rows to remove are editing or focused as:
	    // a) if editing, we want to keep them, otherwise the user will loose the context of the edit,
	    //    eg user starts editing, enters some text, then scrolls down and then up, next time row rendered
	    //    the edit is reset - so we want to keep it rendered.
	    // b) if focused, we want ot keep keyboard focus, so if user ctrl+c, it goes to clipboard,
	    //    otherwise the user can range select and drag (with focus cell going out of the viewport)
	    //    and then ctrl+c, nothing will happen if cell is removed from dom.
	    // c) if detail record of master detail, as users complained that the context of detail rows
	    //    was getting lost when detail row out of view. eg user expands to show detail row,
	    //    then manipulates the detail panel (eg sorts the detail grid), then context is lost
	    //    after detail panel is scrolled out of / into view.
	    RowRenderer.prototype.doNotUnVirtualiseRow = function (rowComp) {
	        var REMOVE_ROW = false;
	        var KEEP_ROW = true;
	        var rowNode = rowComp.getRowNode();
	        var rowHasFocus = this.focusedCellController.isRowNodeFocused(rowNode);
	        var rowIsEditing = rowComp.isEditing();
	        var rowIsDetail = rowNode.detail;
	        var mightWantToKeepRow = rowHasFocus || rowIsEditing || rowIsDetail;
	        // if we deffo don't want to keep it,
	        if (!mightWantToKeepRow) {
	            return REMOVE_ROW;
	        }
	        // editing row, only remove if it is no longer rendered, eg filtered out or new data set.
	        // the reason we want to keep is if user is scrolling up and down, we don't want to loose
	        // the context of the editing in process.
	        var rowNodePresent = this.paginationProxy.isRowPresent(rowNode);
	        return rowNodePresent ? KEEP_ROW : REMOVE_ROW;
	    };
	    RowRenderer.prototype.createRowComp = function (rowNode, animate, afterScroll) {
	        var suppressAnimationFrame = this.gridOptionsWrapper.isSuppressAnimationFrame();
	        // we don't use animations frames for printing, so the user can put the grid into print mode
	        // and immediately print - otherwise the user would have to wait for the rows to draw in the background
	        // (via the animation frames) which is awkward to do from code.
	        // we only do the animation frames after scrolling, as this is where we want the smooth user experience.
	        // having animation frames for other times makes the grid look 'jumpy'.
	        var useAnimationFrameForCreate = afterScroll && !suppressAnimationFrame && !this.printLayout;
	        var rowComp = new rowComp_1.RowComp(this.$scope, this.rowContainers.body, this.rowContainers.pinnedLeft, this.rowContainers.pinnedRight, this.rowContainers.fullWidth, rowNode, this.beans, animate, useAnimationFrameForCreate, this.printLayout, this.embedFullWidthRows);
	        rowComp.init();
	        return rowComp;
	    };
	    RowRenderer.prototype.getRenderedNodes = function () {
	        var renderedRows = this.rowCompsByIndex;
	        return Object.keys(renderedRows).map(function (key) {
	            return renderedRows[key].getRowNode();
	        });
	    };
	    // we use index for rows, but column object for columns, as the next column (by index) might not
	    // be visible (header grouping) so it's not reliable, so using the column object instead.
	    RowRenderer.prototype.navigateToNextCell = function (event, key, currentCell, allowUserOverride) {
	        // we keep searching for a next cell until we find one. this is how the group rows get skipped
	        var nextCell = currentCell;
	        var finished = false;
	        while (!finished) {
	            // if the current cell is spanning across multiple columns, we need to move
	            // our current position to be the last cell on the right before finding the
	            // the next target.
	            if (this.gridOptionsWrapper.isEnableRtl()) {
	                if (key === constants_1.Constants.KEY_LEFT) {
	                    nextCell = this.getLastCellOfColSpan(nextCell);
	                }
	            }
	            else if (key === constants_1.Constants.KEY_RIGHT) {
	                nextCell = this.getLastCellOfColSpan(nextCell);
	            }
	            nextCell = this.cellNavigationService.getNextCellToFocus(key, nextCell);
	            // eg if going down, and nextCell=undefined, means we are gone past the last row
	            var hitEdgeOfGrid = utils_1._.missing(nextCell);
	            if (hitEdgeOfGrid) {
	                finished = true;
	                continue;
	            }
	            var rowNode = this.rowPositionUtils.getRowNode(nextCell);
	            // we do not allow focusing on full width rows, this includes details rows
	            if (rowNode.detail) {
	                continue;
	            }
	            // if not a group, then we have a valid row, so quit the search
	            if (!rowNode.group) {
	                finished = true;
	                continue;
	            }
	            // full width rows cannot be focused, so if it's a group and using full width rows,
	            // we need to skip over the row
	            var pivotMode = this.columnController.isPivotMode();
	            var usingFullWidthRows = this.gridOptionsWrapper.isGroupUseEntireRow(pivotMode);
	            if (!usingFullWidthRows) {
	                finished = true;
	            }
	        }
	        // allow user to override what cell to go to next. when doing normal cell navigation (with keys)
	        // we allow this, however if processing 'enter after edit' we don't allow override
	        if (allowUserOverride) {
	            var userFunc = this.gridOptionsWrapper.getNavigateToNextCellFunc();
	            if (utils_1._.exists(userFunc)) {
	                var params = {
	                    key: key,
	                    previousCellPosition: currentCell,
	                    nextCellPosition: nextCell ? nextCell : null,
	                    event: event
	                };
	                var userCell = userFunc(params);
	                if (utils_1._.exists(userCell)) {
	                    if (userCell.floating) {
	                        utils_1._.doOnce(function () { console.warn("ag-Grid: tabToNextCellFunc return type should have attributes: rowIndex, rowPinned, column. However you had 'floating', maybe you meant 'rowPinned'?"); }, 'no floating in userCell');
	                        userCell.rowPinned = userCell.floating;
	                    }
	                    nextCell = {
	                        rowPinned: userCell.rowPinned,
	                        rowIndex: userCell.rowIndex,
	                        column: userCell.column
	                    };
	                }
	                else {
	                    nextCell = null;
	                }
	            }
	        }
	        // no next cell means we have reached a grid boundary, eg left, right, top or bottom of grid
	        if (!nextCell) {
	            return;
	        }
	        // in case we have col spanning we get the cellComp and use it to
	        // get the position. This was we always focus the first cell inside
	        // the spanning.
	        this.ensureCellVisible(nextCell); // ensureCellVisible first, to make sure nextCell is rendered
	        var cellComp = this.getComponentForCell(nextCell);
	        nextCell = cellComp.getCellPosition();
	        // we call this again, as nextCell can be different to it's previous value due to Column Spanning
	        // (ie if cursor moving from right to left, and cell is spanning columns, then nextCell was the
	        // last column in the group, however now it's the first column in the group). if we didn't do
	        // ensureCellVisible again, then we could only be showing the last portion (last column) of the
	        // merged cells.
	        this.ensureCellVisible(nextCell);
	        this.focusedCellController.setFocusedCell(nextCell.rowIndex, nextCell.column, nextCell.rowPinned, true);
	        if (this.rangeController) {
	            this.rangeController.setRangeToCell(nextCell);
	        }
	    };
	    RowRenderer.prototype.getLastCellOfColSpan = function (cell) {
	        var cellComp = this.getComponentForCell(cell);
	        if (!cellComp) {
	            return cell;
	        }
	        var colSpanningList = cellComp.getColSpanningList();
	        if (colSpanningList.length === 1) {
	            return cell;
	        }
	        return {
	            rowIndex: cell.rowIndex,
	            column: utils_1._.last(colSpanningList),
	            rowPinned: cell.rowPinned
	        };
	    };
	    RowRenderer.prototype.ensureCellVisible = function (gridCell) {
	        // this scrolls the row into view
	        if (utils_1._.missing(gridCell.rowPinned)) {
	            this.gridPanel.ensureIndexVisible(gridCell.rowIndex);
	        }
	        if (!gridCell.column.isPinned()) {
	            this.gridPanel.ensureColumnVisible(gridCell.column);
	        }
	        // need to nudge the scrolls for the floating items. otherwise when we set focus on a non-visible
	        // floating cell, the scrolls get out of sync
	        this.gridPanel.horizontallyScrollHeaderCenterAndFloatingCenter();
	        // need to flush frames, to make sure the correct cells are rendered
	        this.animationFrameService.flushAllFrames();
	    };
	    RowRenderer.prototype.startEditingCell = function (gridCell, keyPress, charPress) {
	        var cell = this.getComponentForCell(gridCell);
	        if (cell) {
	            cell.startRowOrCellEdit(keyPress, charPress);
	        }
	    };
	    RowRenderer.prototype.getComponentForCell = function (cellPosition) {
	        var rowComponent;
	        switch (cellPosition.rowPinned) {
	            case constants_1.Constants.PINNED_TOP:
	                rowComponent = this.floatingTopRowComps[cellPosition.rowIndex];
	                break;
	            case constants_1.Constants.PINNED_BOTTOM:
	                rowComponent = this.floatingBottomRowComps[cellPosition.rowIndex];
	                break;
	            default:
	                rowComponent = this.rowCompsByIndex[cellPosition.rowIndex];
	                break;
	        }
	        if (!rowComponent) {
	            return null;
	        }
	        var cellComponent = rowComponent.getRenderedCellForColumn(cellPosition.column);
	        return cellComponent;
	    };
	    RowRenderer.prototype.getRowNode = function (gridRow) {
	        switch (gridRow.rowPinned) {
	            case constants_1.Constants.PINNED_TOP:
	                return this.pinnedRowModel.getPinnedTopRowData()[gridRow.rowIndex];
	            case constants_1.Constants.PINNED_BOTTOM:
	                return this.pinnedRowModel.getPinnedBottomRowData()[gridRow.rowIndex];
	            default:
	                return this.rowModel.getRow(gridRow.rowIndex);
	        }
	    };
	    RowRenderer.prototype.onTabKeyDown = function (previousRenderedCell, keyboardEvent) {
	        var backwards = keyboardEvent.shiftKey;
	        var success = this.moveToCellAfter(previousRenderedCell, backwards);
	        if (success) {
	            keyboardEvent.preventDefault();
	        }
	    };
	    RowRenderer.prototype.tabToNextCell = function (backwards) {
	        var focusedCell = this.focusedCellController.getFocusedCell();
	        // if no focus, then cannot navigate
	        if (utils_1._.missing(focusedCell)) {
	            return false;
	        }
	        var renderedCell = this.getComponentForCell(focusedCell);
	        // if cell is not rendered, means user has scrolled away from the cell
	        if (utils_1._.missing(renderedCell)) {
	            return false;
	        }
	        var result = this.moveToCellAfter(renderedCell, backwards);
	        return result;
	    };
	    RowRenderer.prototype.moveToCellAfter = function (previousRenderedCell, backwards) {
	        var editing = previousRenderedCell.isEditing();
	        var res;
	        if (editing) {
	            if (this.gridOptionsWrapper.isFullRowEdit()) {
	                res = this.moveToNextEditingRow(previousRenderedCell, backwards);
	            }
	            else {
	                res = this.moveToNextEditingCell(previousRenderedCell, backwards);
	            }
	        }
	        else {
	            res = this.moveToNextCellNotEditing(previousRenderedCell, backwards);
	        }
	        return res;
	    };
	    RowRenderer.prototype.moveToNextEditingCell = function (previousRenderedCell, backwards) {
	        var gridCell = previousRenderedCell.getCellPosition();
	        // need to do this before getting next cell to edit, in case the next cell
	        // has editable function (eg colDef.editable=func() ) and it depends on the
	        // result of this cell, so need to save updates from the first edit, in case
	        // the value is referenced in the function.
	        previousRenderedCell.stopEditing();
	        // find the next cell to start editing
	        var nextRenderedCell = this.findNextCellToFocusOn(gridCell, backwards, true);
	        var foundCell = utils_1._.exists(nextRenderedCell);
	        // only prevent default if we found a cell. so if user is on last cell and hits tab, then we default
	        // to the normal tabbing so user can exit the grid.
	        if (foundCell) {
	            nextRenderedCell.startEditingIfEnabled(null, null, true);
	            nextRenderedCell.focusCell(false);
	        }
	        return foundCell;
	    };
	    RowRenderer.prototype.moveToNextEditingRow = function (previousRenderedCell, backwards) {
	        var gridCell = previousRenderedCell.getCellPosition();
	        // find the next cell to start editing
	        var nextRenderedCell = this.findNextCellToFocusOn(gridCell, backwards, true);
	        var foundCell = utils_1._.exists(nextRenderedCell);
	        // only prevent default if we found a cell. so if user is on last cell and hits tab, then we default
	        // to the normal tabbing so user can exit the grid.
	        if (foundCell) {
	            this.moveEditToNextCellOrRow(previousRenderedCell, nextRenderedCell);
	        }
	        return foundCell;
	    };
	    RowRenderer.prototype.moveToNextCellNotEditing = function (previousRenderedCell, backwards) {
	        var gridCell = previousRenderedCell.getCellPosition();
	        // find the next cell to start editing
	        var nextRenderedCell = this.findNextCellToFocusOn(gridCell, backwards, false);
	        var foundCell = utils_1._.exists(nextRenderedCell);
	        // only prevent default if we found a cell. so if user is on last cell and hits tab, then we default
	        // to the normal tabbing so user can exit the grid.
	        if (foundCell) {
	            nextRenderedCell.focusCell(true);
	        }
	        return foundCell;
	    };
	    RowRenderer.prototype.moveEditToNextCellOrRow = function (previousRenderedCell, nextRenderedCell) {
	        var pGridCell = previousRenderedCell.getCellPosition();
	        var nGridCell = nextRenderedCell.getCellPosition();
	        var rowsMatch = pGridCell.rowIndex === nGridCell.rowIndex && pGridCell.rowPinned === nGridCell.rowPinned;
	        if (rowsMatch) {
	            // same row, so we don't start / stop editing, we just move the focus along
	            previousRenderedCell.setFocusOutOnEditor();
	            nextRenderedCell.setFocusInOnEditor();
	        }
	        else {
	            var pRow = previousRenderedCell.getRenderedRow();
	            var nRow = nextRenderedCell.getRenderedRow();
	            previousRenderedCell.setFocusOutOnEditor();
	            pRow.stopEditing();
	            nRow.startRowEditing();
	            nextRenderedCell.setFocusInOnEditor();
	        }
	        nextRenderedCell.focusCell();
	    };
	    // called by the cell, when tab is pressed while editing.
	    // @return: RenderedCell when navigation successful, otherwise null
	    RowRenderer.prototype.findNextCellToFocusOn = function (gridCell, backwards, startEditing) {
	        var nextCell = gridCell;
	        while (true) {
	            if (!backwards) {
	                nextCell = this.getLastCellOfColSpan(nextCell);
	            }
	            nextCell = this.cellNavigationService.getNextTabbedCell(nextCell, backwards);
	            // allow user to override what cell to go to next
	            var userFunc = this.gridOptionsWrapper.getTabToNextCellFunc();
	            if (utils_1._.exists(userFunc)) {
	                var params = {
	                    backwards: backwards,
	                    editing: startEditing,
	                    previousCellPosition: gridCell,
	                    nextCellPosition: nextCell ? nextCell : null
	                };
	                var userCell = userFunc(params);
	                if (utils_1._.exists(userCell)) {
	                    if (userCell.floating) {
	                        utils_1._.doOnce(function () { console.warn("ag-Grid: tabToNextCellFunc return type should have attributes: rowIndex, rowPinned, column. However you had 'floating', maybe you meant 'rowPinned'?"); }, 'no floating in userCell');
	                        userCell.rowPinned = userCell.floating;
	                    }
	                    nextCell = {
	                        rowIndex: userCell.rowIndex,
	                        column: userCell.column,
	                        rowPinned: userCell.rowPinned
	                    };
	                }
	                else {
	                    nextCell = null;
	                }
	            }
	            // if no 'next cell', means we have got to last cell of grid, so nothing to move to,
	            // so bottom right cell going forwards, or top left going backwards
	            if (!nextCell) {
	                return null;
	            }
	            // if editing, but cell not editable, skip cell. we do this before we do all of
	            // the 'ensure index visible' and 'flush all frames', otherwise if we are skipping
	            // a bunch of cells (eg 10 rows) then all the work on ensuring cell visible is useless
	            // (except for the last one) which causes grid to stall for a while.
	            if (startEditing) {
	                var rowNode = this.lookupRowNodeForCell(nextCell);
	                var cellIsEditable = nextCell.column.isCellEditable(rowNode);
	                if (!cellIsEditable) {
	                    continue;
	                }
	            }
	            // this scrolls the row into view
	            var cellIsNotFloating = utils_1._.missing(nextCell.rowPinned);
	            if (cellIsNotFloating) {
	                this.gridPanel.ensureIndexVisible(nextCell.rowIndex);
	            }
	            // pinned columns don't scroll, so no need to ensure index visible
	            if (!nextCell.column.isPinned()) {
	                this.gridPanel.ensureColumnVisible(nextCell.column);
	            }
	            // need to nudge the scrolls for the floating items. otherwise when we set focus on a non-visible
	            // floating cell, the scrolls get out of sync
	            this.gridPanel.horizontallyScrollHeaderCenterAndFloatingCenter();
	            // get the grid panel to flush all animation frames - otherwise the call below to get the cellComp
	            // could fail, if we just scrolled the grid (to make a cell visible) and the rendering hasn't finished.
	            this.animationFrameService.flushAllFrames();
	            // we have to call this after ensureColumnVisible - otherwise it could be a virtual column
	            // or row that is not currently in view, hence the renderedCell would not exist
	            var nextCellComp = this.getComponentForCell(nextCell);
	            // if next cell is fullWidth row, then no rendered cell,
	            // as fullWidth rows have no cells, so we skip it
	            if (utils_1._.missing(nextCellComp)) {
	                continue;
	            }
	            if (nextCellComp.isSuppressNavigable()) {
	                continue;
	            }
	            // by default, when we click a cell, it gets selected into a range, so to keep keyboard navigation
	            // consistent, we set into range here also.
	            if (this.rangeController) {
	                this.rangeController.setRangeToCell(nextCell);
	            }
	            // we successfully tabbed onto a grid cell, so return true
	            return nextCellComp;
	        }
	    };
	    RowRenderer.prototype.lookupRowNodeForCell = function (cell) {
	        if (cell.rowPinned === constants_1.Constants.PINNED_TOP) {
	            return this.pinnedRowModel.getPinnedTopRow(cell.rowIndex);
	        }
	        if (cell.rowPinned === constants_1.Constants.PINNED_BOTTOM) {
	            return this.pinnedRowModel.getPinnedBottomRow(cell.rowIndex);
	        }
	        return this.paginationProxy.getRow(cell.rowIndex);
	    };
	    __decorate([
	        context_1.Autowired("paginationProxy"),
	        __metadata("design:type", paginationProxy_1.PaginationProxy)
	    ], RowRenderer.prototype, "paginationProxy", void 0);
	    __decorate([
	        context_1.Autowired("columnController"),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], RowRenderer.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired("gridOptionsWrapper"),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], RowRenderer.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired("$scope"),
	        __metadata("design:type", Object)
	    ], RowRenderer.prototype, "$scope", void 0);
	    __decorate([
	        context_1.Autowired("eventService"),
	        __metadata("design:type", eventService_1.EventService)
	    ], RowRenderer.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired("pinnedRowModel"),
	        __metadata("design:type", pinnedRowModel_1.PinnedRowModel)
	    ], RowRenderer.prototype, "pinnedRowModel", void 0);
	    __decorate([
	        context_1.Autowired("rowModel"),
	        __metadata("design:type", Object)
	    ], RowRenderer.prototype, "rowModel", void 0);
	    __decorate([
	        context_1.Autowired("loggerFactory"),
	        __metadata("design:type", logger_1.LoggerFactory)
	    ], RowRenderer.prototype, "loggerFactory", void 0);
	    __decorate([
	        context_1.Autowired("focusedCellController"),
	        __metadata("design:type", focusedCellController_1.FocusedCellController)
	    ], RowRenderer.prototype, "focusedCellController", void 0);
	    __decorate([
	        context_1.Autowired("cellNavigationService"),
	        __metadata("design:type", cellNavigationService_1.CellNavigationService)
	    ], RowRenderer.prototype, "cellNavigationService", void 0);
	    __decorate([
	        context_1.Autowired("columnApi"),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], RowRenderer.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired("gridApi"),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], RowRenderer.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.Autowired("beans"),
	        __metadata("design:type", beans_1.Beans)
	    ], RowRenderer.prototype, "beans", void 0);
	    __decorate([
	        context_1.Autowired("maxDivHeightScaler"),
	        __metadata("design:type", maxDivHeightScaler_1.MaxDivHeightScaler)
	    ], RowRenderer.prototype, "maxDivHeightScaler", void 0);
	    __decorate([
	        context_1.Autowired("animationFrameService"),
	        __metadata("design:type", animationFrameService_1.AnimationFrameService)
	    ], RowRenderer.prototype, "animationFrameService", void 0);
	    __decorate([
	        context_1.Autowired("rowPositionUtils"),
	        __metadata("design:type", rowPosition_1.RowPositionUtils)
	    ], RowRenderer.prototype, "rowPositionUtils", void 0);
	    __decorate([
	        context_1.Optional("rangeController"),
	        __metadata("design:type", Object)
	    ], RowRenderer.prototype, "rangeController", void 0);
	    __decorate([
	        __param(0, context_1.Qualifier("loggerFactory")),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [logger_1.LoggerFactory]),
	        __metadata("design:returntype", void 0)
	    ], RowRenderer.prototype, "agWire", null);
	    RowRenderer = __decorate([
	        context_1.Bean("rowRenderer")
	    ], RowRenderer);
	    return RowRenderer;
	}(beanStub_1.BeanStub));
	exports.RowRenderer = RowRenderer;


/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var coordinateSystemCreators = {};
	
	function CoordinateSystemManager() {
	  this._coordinateSystems = [];
	}
	
	CoordinateSystemManager.prototype = {
	  constructor: CoordinateSystemManager,
	  create: function (ecModel, api) {
	    var coordinateSystems = [];
	    zrUtil.each(coordinateSystemCreators, function (creater, type) {
	      var list = creater.create(ecModel, api);
	      coordinateSystems = coordinateSystems.concat(list || []);
	    });
	    this._coordinateSystems = coordinateSystems;
	  },
	  update: function (ecModel, api) {
	    zrUtil.each(this._coordinateSystems, function (coordSys) {
	      coordSys.update && coordSys.update(ecModel, api);
	    });
	  },
	  getCoordinateSystems: function () {
	    return this._coordinateSystems.slice();
	  }
	};
	
	CoordinateSystemManager.register = function (type, coordinateSystemCreator) {
	  coordinateSystemCreators[type] = coordinateSystemCreator;
	};
	
	CoordinateSystemManager.get = function (type) {
	  return coordinateSystemCreators[type];
	};
	
	var _default = CoordinateSystemManager;
	module.exports = _default;

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(3);
	
	var OrdinalScale = __webpack_require__(1704);
	
	var IntervalScale = __webpack_require__(338);
	
	var Scale = __webpack_require__(339);
	
	var numberUtil = __webpack_require__(20);
	
	var _barGrid = __webpack_require__(337);
	
	var prepareLayoutBarSeries = _barGrid.prepareLayoutBarSeries;
	var makeColumnLayout = _barGrid.makeColumnLayout;
	var retrieveColumnLayout = _barGrid.retrieveColumnLayout;
	
	var BoundingRect = __webpack_require__(42);
	
	__webpack_require__(1705);
	
	__webpack_require__(751);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Get axis scale extent before niced.
	 * Item of returned array can only be number (including Infinity and NaN).
	 */
	function getScaleExtent(scale, model) {
	  var scaleType = scale.type;
	  var min = model.getMin();
	  var max = model.getMax();
	  var originalExtent = scale.getExtent();
	  var axisDataLen;
	  var boundaryGap;
	  var span;
	
	  if (scaleType === 'ordinal') {
	    axisDataLen = model.getCategories().length;
	  } else {
	    boundaryGap = model.get('boundaryGap');
	
	    if (!zrUtil.isArray(boundaryGap)) {
	      boundaryGap = [boundaryGap || 0, boundaryGap || 0];
	    }
	
	    if (typeof boundaryGap[0] === 'boolean') {
	      boundaryGap = [0, 0];
	    }
	
	    boundaryGap[0] = numberUtil.parsePercent(boundaryGap[0], 1);
	    boundaryGap[1] = numberUtil.parsePercent(boundaryGap[1], 1);
	    span = originalExtent[1] - originalExtent[0] || Math.abs(originalExtent[0]);
	  } // Notice: When min/max is not set (that is, when there are null/undefined,
	  // which is the most common case), these cases should be ensured:
	  // (1) For 'ordinal', show all axis.data.
	  // (2) For others:
	  //      + `boundaryGap` is applied (if min/max set, boundaryGap is
	  //      disabled).
	  //      + If `needCrossZero`, min/max should be zero, otherwise, min/max should
	  //      be the result that originalExtent enlarged by boundaryGap.
	  // (3) If no data, it should be ensured that `scale.setBlank` is set.
	  // FIXME
	  // (1) When min/max is 'dataMin' or 'dataMax', should boundaryGap be able to used?
	  // (2) When `needCrossZero` and all data is positive/negative, should it be ensured
	  // that the results processed by boundaryGap are positive/negative?
	
	
	  if (min === 'dataMin') {
	    min = originalExtent[0];
	  } else if (typeof min === 'function') {
	    min = min({
	      min: originalExtent[0],
	      max: originalExtent[1]
	    });
	  }
	
	  if (max === 'dataMax') {
	    max = originalExtent[1];
	  } else if (typeof max === 'function') {
	    max = max({
	      min: originalExtent[0],
	      max: originalExtent[1]
	    });
	  }
	
	  var fixMin = min != null;
	  var fixMax = max != null;
	
	  if (min == null) {
	    min = scaleType === 'ordinal' ? axisDataLen ? 0 : NaN : originalExtent[0] - boundaryGap[0] * span;
	  }
	
	  if (max == null) {
	    max = scaleType === 'ordinal' ? axisDataLen ? axisDataLen - 1 : NaN : originalExtent[1] + boundaryGap[1] * span;
	  }
	
	  (min == null || !isFinite(min)) && (min = NaN);
	  (max == null || !isFinite(max)) && (max = NaN);
	  scale.setBlank(zrUtil.eqNaN(min) || zrUtil.eqNaN(max) || scaleType === 'ordinal' && !scale.getOrdinalMeta().categories.length); // Evaluate if axis needs cross zero
	
	  if (model.getNeedCrossZero()) {
	    // Axis is over zero and min is not set
	    if (min > 0 && max > 0 && !fixMin) {
	      min = 0;
	    } // Axis is under zero and max is not set
	
	
	    if (min < 0 && max < 0 && !fixMax) {
	      max = 0;
	    }
	  } // If bars are placed on a base axis of type time or interval account for axis boundary overflow and current axis
	  // is base axis
	  // FIXME
	  // (1) Consider support value axis, where below zero and axis `onZero` should be handled properly.
	  // (2) Refactor the logic with `barGrid`. Is it not need to `makeBarWidthAndOffsetInfo` twice with different extent?
	  //     Should not depend on series type `bar`?
	  // (3) Fix that might overlap when using dataZoom.
	  // (4) Consider other chart types using `barGrid`?
	  // See #6728, #4862, `test/bar-overflow-time-plot.html`
	
	
	  var ecModel = model.ecModel;
	
	  if (ecModel && scaleType === 'time'
	  /*|| scaleType === 'interval' */
	  ) {
	    var barSeriesModels = prepareLayoutBarSeries('bar', ecModel);
	    var isBaseAxisAndHasBarSeries;
	    zrUtil.each(barSeriesModels, function (seriesModel) {
	      isBaseAxisAndHasBarSeries |= seriesModel.getBaseAxis() === model.axis;
	    });
	
	    if (isBaseAxisAndHasBarSeries) {
	      // Calculate placement of bars on axis
	      var barWidthAndOffset = makeColumnLayout(barSeriesModels); // Adjust axis min and max to account for overflow
	
	      var adjustedScale = adjustScaleForOverflow(min, max, model, barWidthAndOffset);
	      min = adjustedScale.min;
	      max = adjustedScale.max;
	    }
	  }
	
	  return {
	    extent: [min, max],
	    // "fix" means "fixed", the value should not be
	    // changed in the subsequent steps.
	    fixMin: fixMin,
	    fixMax: fixMax
	  };
	}
	
	function adjustScaleForOverflow(min, max, model, barWidthAndOffset) {
	  // Get Axis Length
	  var axisExtent = model.axis.getExtent();
	  var axisLength = axisExtent[1] - axisExtent[0]; // Get bars on current base axis and calculate min and max overflow
	
	  var barsOnCurrentAxis = retrieveColumnLayout(barWidthAndOffset, model.axis);
	
	  if (barsOnCurrentAxis === undefined) {
	    return {
	      min: min,
	      max: max
	    };
	  }
	
	  var minOverflow = Infinity;
	  zrUtil.each(barsOnCurrentAxis, function (item) {
	    minOverflow = Math.min(item.offset, minOverflow);
	  });
	  var maxOverflow = -Infinity;
	  zrUtil.each(barsOnCurrentAxis, function (item) {
	    maxOverflow = Math.max(item.offset + item.width, maxOverflow);
	  });
	  minOverflow = Math.abs(minOverflow);
	  maxOverflow = Math.abs(maxOverflow);
	  var totalOverFlow = minOverflow + maxOverflow; // Calulate required buffer based on old range and overflow
	
	  var oldRange = max - min;
	  var oldRangePercentOfNew = 1 - (minOverflow + maxOverflow) / axisLength;
	  var overflowBuffer = oldRange / oldRangePercentOfNew - oldRange;
	  max += overflowBuffer * (maxOverflow / totalOverFlow);
	  min -= overflowBuffer * (minOverflow / totalOverFlow);
	  return {
	    min: min,
	    max: max
	  };
	}
	
	function niceScaleExtent(scale, model) {
	  var extentInfo = getScaleExtent(scale, model);
	  var extent = extentInfo.extent;
	  var splitNumber = model.get('splitNumber');
	
	  if (scale.type === 'log') {
	    scale.base = model.get('logBase');
	  }
	
	  var scaleType = scale.type;
	  scale.setExtent(extent[0], extent[1]);
	  scale.niceExtent({
	    splitNumber: splitNumber,
	    fixMin: extentInfo.fixMin,
	    fixMax: extentInfo.fixMax,
	    minInterval: scaleType === 'interval' || scaleType === 'time' ? model.get('minInterval') : null,
	    maxInterval: scaleType === 'interval' || scaleType === 'time' ? model.get('maxInterval') : null
	  }); // If some one specified the min, max. And the default calculated interval
	  // is not good enough. He can specify the interval. It is often appeared
	  // in angle axis with angle 0 - 360. Interval calculated in interval scale is hard
	  // to be 60.
	  // FIXME
	
	  var interval = model.get('interval');
	
	  if (interval != null) {
	    scale.setInterval && scale.setInterval(interval);
	  }
	}
	/**
	 * @param {module:echarts/model/Model} model
	 * @param {string} [axisType] Default retrieve from model.type
	 * @return {module:echarts/scale/*}
	 */
	
	
	function createScaleByModel(model, axisType) {
	  axisType = axisType || model.get('type');
	
	  if (axisType) {
	    switch (axisType) {
	      // Buildin scale
	      case 'category':
	        return new OrdinalScale(model.getOrdinalMeta ? model.getOrdinalMeta() : model.getCategories(), [Infinity, -Infinity]);
	
	      case 'value':
	        return new IntervalScale();
	      // Extended scale, like time and log
	
	      default:
	        return (Scale.getClass(axisType) || IntervalScale).create(model);
	    }
	  }
	}
	/**
	 * Check if the axis corss 0
	 */
	
	
	function ifAxisCrossZero(axis) {
	  var dataExtent = axis.scale.getExtent();
	  var min = dataExtent[0];
	  var max = dataExtent[1];
	  return !(min > 0 && max > 0 || min < 0 && max < 0);
	}
	/**
	 * @param {module:echarts/coord/Axis} axis
	 * @return {Function} Label formatter function.
	 *         param: {number} tickValue,
	 *         param: {number} idx, the index in all ticks.
	 *                         If category axis, this param is not requied.
	 *         return: {string} label string.
	 */
	
	
	function makeLabelFormatter(axis) {
	  var labelFormatter = axis.getLabelModel().get('formatter');
	  var categoryTickStart = axis.type === 'category' ? axis.scale.getExtent()[0] : null;
	
	  if (typeof labelFormatter === 'string') {
	    labelFormatter = function (tpl) {
	      return function (val) {
	        // For category axis, get raw value; for numeric axis,
	        // get foramtted label like '1,333,444'.
	        val = axis.scale.getLabel(val);
	        return tpl.replace('{value}', val != null ? val : '');
	      };
	    }(labelFormatter); // Consider empty array
	
	
	    return labelFormatter;
	  } else if (typeof labelFormatter === 'function') {
	    return function (tickValue, idx) {
	      // The original intention of `idx` is "the index of the tick in all ticks".
	      // But the previous implementation of category axis do not consider the
	      // `axisLabel.interval`, which cause that, for example, the `interval` is
	      // `1`, then the ticks "name5", "name7", "name9" are displayed, where the
	      // corresponding `idx` are `0`, `2`, `4`, but not `0`, `1`, `2`. So we keep
	      // the definition here for back compatibility.
	      if (categoryTickStart != null) {
	        idx = tickValue - categoryTickStart;
	      }
	
	      return labelFormatter(getAxisRawValue(axis, tickValue), idx);
	    };
	  } else {
	    return function (tick) {
	      return axis.scale.getLabel(tick);
	    };
	  }
	}
	
	function getAxisRawValue(axis, value) {
	  // In category axis with data zoom, tick is not the original
	  // index of axis.data. So tick should not be exposed to user
	  // in category axis.
	  return axis.type === 'category' ? axis.scale.getLabel(value) : value;
	}
	/**
	 * @param {module:echarts/coord/Axis} axis
	 * @return {module:zrender/core/BoundingRect} Be null/undefined if no labels.
	 */
	
	
	function estimateLabelUnionRect(axis) {
	  var axisModel = axis.model;
	  var scale = axis.scale;
	
	  if (!axisModel.get('axisLabel.show') || scale.isBlank()) {
	    return;
	  }
	
	  var isCategory = axis.type === 'category';
	  var realNumberScaleTicks;
	  var tickCount;
	  var categoryScaleExtent = scale.getExtent(); // Optimize for large category data, avoid call `getTicks()`.
	
	  if (isCategory) {
	    tickCount = scale.count();
	  } else {
	    realNumberScaleTicks = scale.getTicks();
	    tickCount = realNumberScaleTicks.length;
	  }
	
	  var axisLabelModel = axis.getLabelModel();
	  var labelFormatter = makeLabelFormatter(axis);
	  var rect;
	  var step = 1; // Simple optimization for large amount of labels
	
	  if (tickCount > 40) {
	    step = Math.ceil(tickCount / 40);
	  }
	
	  for (var i = 0; i < tickCount; i += step) {
	    var tickValue = realNumberScaleTicks ? realNumberScaleTicks[i] : categoryScaleExtent[0] + i;
	    var label = labelFormatter(tickValue);
	    var unrotatedSingleRect = axisLabelModel.getTextRect(label);
	    var singleRect = rotateTextRect(unrotatedSingleRect, axisLabelModel.get('rotate') || 0);
	    rect ? rect.union(singleRect) : rect = singleRect;
	  }
	
	  return rect;
	}
	
	function rotateTextRect(textRect, rotate) {
	  var rotateRadians = rotate * Math.PI / 180;
	  var boundingBox = textRect.plain();
	  var beforeWidth = boundingBox.width;
	  var beforeHeight = boundingBox.height;
	  var afterWidth = beforeWidth * Math.abs(Math.cos(rotateRadians)) + Math.abs(beforeHeight * Math.sin(rotateRadians));
	  var afterHeight = beforeWidth * Math.abs(Math.sin(rotateRadians)) + Math.abs(beforeHeight * Math.cos(rotateRadians));
	  var rotatedRect = new BoundingRect(boundingBox.x, boundingBox.y, afterWidth, afterHeight);
	  return rotatedRect;
	}
	/**
	 * @param {module:echarts/src/model/Model} model axisLabelModel or axisTickModel
	 * @return {number|String} Can be null|'auto'|number|function
	 */
	
	
	function getOptionCategoryInterval(model) {
	  var interval = model.get('interval');
	  return interval == null ? 'auto' : interval;
	}
	/**
	 * Set `categoryInterval` as 0 implicitly indicates that
	 * show all labels reguardless of overlap.
	 * @param {Object} axis axisModel.axis
	 * @return {boolean}
	 */
	
	
	function shouldShowAllLabels(axis) {
	  return axis.type === 'category' && getOptionCategoryInterval(axis.getLabelModel()) === 0;
	}
	
	exports.getScaleExtent = getScaleExtent;
	exports.niceScaleExtent = niceScaleExtent;
	exports.createScaleByModel = createScaleByModel;
	exports.ifAxisCrossZero = ifAxisCrossZero;
	exports.makeLabelFormatter = makeLabelFormatter;
	exports.getAxisRawValue = getAxisRawValue;
	exports.estimateLabelUnionRect = estimateLabelUnionRect;
	exports.getOptionCategoryInterval = getOptionCategoryInterval;
	exports.shouldShowAllLabels = shouldShowAllLabels;

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _isomorphicFetch = __webpack_require__(78);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _lodash = __webpack_require__(15);
	
	var _reactAquasys = __webpack_require__(49);
	
	var _ActionUtils = __webpack_require__(112);
	
	var _ApplicationConf = __webpack_require__(65);
	
	var _ApplicationConf2 = _interopRequireDefault(_ApplicationConf);
	
	var _SelectionConstants = __webpack_require__(529);
	
	var _ApplicationUtils = __webpack_require__(186);
	
	var _DtoSelection = __webpack_require__(181);
	
	var _DtoSelection2 = _interopRequireDefault(_DtoSelection);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _ToastrAction = __webpack_require__(66);
	
	var _ToastrAction2 = _interopRequireDefault(_ToastrAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SelectionAction = {
	
		receiveSelections: function receiveSelections(selections) {
			return {
				type: _SelectionConstants.RECEIVE_ALL_SELECTIONS,
				selections: selections
			};
		},
	
		fetchSelection: function fetchSelection(selectionname, login) {
			return function (dispatch) {
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.selection.getSelectionByName(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'Accept': 'application/vnd.pgrst.object+json'
					},
					body: JSON.stringify({ selectionname: selectionname, login: login })
				}).then(_ActionUtils.getJson).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
					if (json.id) {
						dispatch(SelectionAction.updateSelections(json));
						dispatch(SelectionAction.setSelectedSelection(new _DtoSelection2.default(json)));
					}
					return json;
				}).then(function (json) {
					if (json.id) {
						Promise.all([SelectionAction.fetchSelectionSites([json.id])]).then(function (v) {
							var idSelections = (0, _lodash.flatten)(v);
							dispatch(SelectionAction.receiveSelectionSites(idSelections));
							var idSites = idSelections.map(function (o) {
								return o.site_id;
							});
							Promise.all([SelectionAction.fetchSelectionDetailSites(idSites)]).then(function (c) {
								var siteIds = (0, _lodash.flatten)(c);
								dispatch(SelectionAction.receiveSelectionDetailSites(siteIds));
							});
							Promise.all([SelectionAction.fetchSelectionKeyFigures(idSites)]).then(function (c) {
								var selectionKeyfigures = (0, _lodash.flatten)(c);
								dispatch(SelectionAction.receiveSelectionKeyFigures(selectionKeyfigures));
							});
						});
						dispatch(SelectionAction.fetchSelectionFilters([json.id]));
						return json.id;
					}
					return null;
				}).then(function (id) {
					if (id) {
						dispatch(SelectionAction.fetchSelectionExportHistory([id]));
						dispatch(SelectionAction.fetchSelectionWatershed([id]));
					}
				}).catch(function () {
					dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.error.cannotGetSelection));
				});
			};
		},
	
		updateSelections: function updateSelections(selection) {
			return { type: _SelectionConstants.RECEIVE_AND_SELECT_SELECTION, selection: selection };
		},
	
		fetchSelections: function fetchSelections(login) {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.selection.get(login), {
					method: 'GET',
					headers: {
						'Content-Type': 'application/json'
					}
				}).then(_ActionUtils.getJson).then(function () {
					var jsonResult = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					if (jsonResult.length) {
						var filterSelectionClose = (0, _lodash.filter)(jsonResult, function (o) {
							return !o.closedate && !o.close;
						});
						var ids = filterSelectionClose.map(function (o) {
							return o.id;
						});
						Promise.all([SelectionAction.fetchSelectionSites(ids)]).then(function (values) {
							var idSelections = (0, _lodash.uniqBy)((0, _lodash.flatten)(values));
							var idSites = idSelections.map(function (o) {
								return o.site_id;
							});
							Promise.all([SelectionAction.fetchSelectionDetailSites(idSites)]).then(function (c) {
								var siteIds = (0, _lodash.flatten)(c);
								dispatch(SelectionAction.receiveSelectionDetailSites(siteIds));
							});
							Promise.all([SelectionAction.fetchSelectionKeyFigures(idSites)]).then(function (c) {
								var selectionKeyfigures = (0, _lodash.flatten)(c);
								dispatch(SelectionAction.receiveSelectionKeyFigures(selectionKeyfigures));
							});
							dispatch(SelectionAction.receiveSelectionSites(idSelections));
						});
						dispatch(SelectionAction.fetchSelectionFilters(ids));
						dispatch(SelectionAction.receiveSelections(filterSelectionClose));
						return ids;
					}
					return null;
				}).then(function (idsSelection) {
					if (idsSelection) {
						dispatch(SelectionAction.fetchSelectionExportHistory(idsSelection));
						dispatch(SelectionAction.fetchSelectionWatershed(idsSelection));
					}
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				}).catch(function () {
					dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.error.cannotGetSelection));
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
	
		updateExecution: function updateExecution(id, login) {
			return function (dispatch) {
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.selection.updateExecution(id), {
					method: 'PUT',
					headers: { authorization: btoa('Basic ' + login) }
				}).then(function () {}).catch(function (error) {
					dispatch(_ToastrAction2.default.error(error));
				});
			};
		},
	
	
		receiveSelectionSites: function receiveSelectionSites(selectionSites) {
			return {
				type: _SelectionConstants.RECEIVE_SELECTIONS_SITES,
				selectionSites: selectionSites
			};
		},
		fetchSelectionSites: function fetchSelectionSites(idSelections) {
			return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.selection.getSelectionSites(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({ selectionids: (0, _ApplicationUtils.getFetchSiteIds)(idSelections) })
			}).then(_ActionUtils.getJson).then(function () {
				var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
				if (!json.error) {
					return json;
				}
				return [];
			});
		},
		receiveSelectionFilters: function receiveSelectionFilters(selectionFilters) {
			return {
				type: _SelectionConstants.RECEIVE_SELECTIONS_FILTERS,
				selectionFilters: selectionFilters
			};
		},
		fetchSelectionFilters: function fetchSelectionFilters(idSelections) {
			return function (dispatch) {
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.selection.getSelectionFilters(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({ selectionids: (0, _ApplicationUtils.getFetchSiteIds)(idSelections) })
				}).then(_ActionUtils.getJson).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(SelectionAction.receiveSelectionFilters(json));
					return json;
				}).then(function (json) {
					var filterIds = json.map(function (o) {
						return o.id;
					});
					dispatch(SelectionAction.fetchFilterValues(filterIds));
				});
			};
		},
	
		receiveFilterValues: function receiveFilterValues(filterValues) {
			return {
				type: _SelectionConstants.RECEIVE_FILTERS_VALUES,
				filterValues: filterValues
			};
		},
		fetchFilterValues: function fetchFilterValues(filterIds) {
			return function (dispatch) {
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.selection.getFilters(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({ filterids: (0, _ApplicationUtils.getFetchSiteIds)(filterIds) })
				}).then(_ActionUtils.getJson).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(SelectionAction.receiveFilterValues(json));
					return json;
				});
			};
		},
		receiveSelectionDetailSites: function receiveSelectionDetailSites(selectionDetailsSites) {
			return {
				type: _SelectionConstants.RECEIVE_SELECTIONS_DETAIL_SITES,
				selectionDetailsSites: selectionDetailsSites
			};
		},
		fetchSelectionDetailSites: function fetchSelectionDetailSites(siteIds) {
			return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.selection.getSites(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					sitesid: (0, _ApplicationUtils.getFetchSiteIds)(siteIds)
				})
			}).then(_ActionUtils.getJson).then(function () {
				var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
				if (!json.error) {
					return json;
				}
				return [];
			});
		},
	
		resetSelection: function resetSelection() {
			return {
				type: _SelectionConstants.RESET_USER_SELECTION
			};
		},
	
		setSelectedSelection: function setSelectedSelection(selectedSelection) {
			return {
				type: _SelectionConstants.SELECTED_SELECTION,
				selectedSelection: selectedSelection
			};
		},
	
		resetSelectedSelection: function resetSelectedSelection() {
			return {
				type: _SelectionConstants.RESET_SELECTED_SELECTION
			};
		},
	
		saveSelection: function saveSelection(login, name, filters, stations, watersheds) {
			var result = SelectionAction.formatJson(name, filters, stations, watersheds);
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.selection.selectionsPath(), {
					method: 'POST',
					headers: { authorization: btoa('Basic ' + login) },
					body: JSON.stringify(result)
				}).then(function () {
					dispatch(_ToastrAction2.default.success(_simpleReactI18n2.default.addNewSelectionSuccess));
				}).then(function () {
					dispatch(SelectionAction.fetchSelection(name, login));
					dispatch(SelectionAction.fetchSelections(login));
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				}).catch(function (error) {
					dispatch(_ToastrAction2.default.error(error));
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
	
		updateSelection: function updateSelection(selectionId, login, name, filters, stations, watersheds) {
			var result = SelectionAction.formatJson(name, filters, stations, watersheds);
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				//dispatch(SelectionAction.resetSelectionInformations(selectionId))
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.selection.selectionPath(selectionId), {
					method: 'PUT',
					headers: { authorization: btoa('Basic ' + login) },
					body: JSON.stringify(result)
				}).then(function () {
					dispatch(_ToastrAction2.default.success(_simpleReactI18n2.default.savedSelection));
				}).then(function () {
					dispatch(SelectionAction.fetchSelections(login));
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				}).catch(function (error) {
					dispatch(_ToastrAction2.default.error(error));
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
		resetSelectionInformations: function resetSelectionInformations(selectionId) {
			return {
				type: _SelectionConstants.RESET_SELECTION_INFORMATIONS,
				selectionId: selectionId
			};
		},
		receiveDeleteSelection: function receiveDeleteSelection(selectionId) {
			return {
				type: _SelectionConstants.RECEIVE_DELETE_SELECTION,
				selectionId: selectionId
			};
		},
	
		deleteSelection: function deleteSelection(login, id) {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				dispatch(SelectionAction.closeModalSelectionDelete());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.selection.selectionPath(id), {
					method: 'DELETE',
					headers: { authorization: btoa('Basic ' + login) }
				}).then(function () {
					dispatch(_ToastrAction2.default.success(_simpleReactI18n2.default.deletedSelection));
				}).then(function () {
					dispatch(SelectionAction.receiveDeleteSelection(id));
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				}).catch(function (error) {
					dispatch(_ToastrAction2.default.error(error));
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
	
		receiveSelectionKeyFigures: function receiveSelectionKeyFigures(selectionKeyFigures) {
			return {
				type: _SelectionConstants.RECEIVE_SELECTIONS_KEY_FIGURES,
				selectionKeyFigures: selectionKeyFigures
			};
		},
		fetchSelectionKeyFigures: function fetchSelectionKeyFigures(stationIds) {
			return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.sites.getKeyFigures(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					stationids: (0, _ApplicationUtils.getFetchSiteIds)(stationIds)
				})
			}).then(_ActionUtils.getJson).then(function () {
				var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
				if (!json.error) {
					return json;
				}
				return [];
			});
		},
	
		receiveSelectionExportHistory: function receiveSelectionExportHistory(selectionExportsHistory) {
			return {
				type: _SelectionConstants.RECEIVE_SELECTIONS_EXPORT_HISTORY,
				selectionExportsHistory: selectionExportsHistory
			};
		},
		fetchSelectionExportHistory: function fetchSelectionExportHistory(selectionIds) {
			return function (dispatch) {
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.selection.getExportHistory(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						selectionids: (0, _ApplicationUtils.getFetchSiteIds)(selectionIds)
					})
				}).then(_ActionUtils.getJson).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(SelectionAction.receiveSelectionExportHistory(json));
				});
			};
		},
		receiveSelectionWatershed: function receiveSelectionWatershed(selectionWatershed) {
			return {
				type: _SelectionConstants.RECEIVE_SELECTIONS_WATERSHED,
				selectionWatershed: selectionWatershed
			};
		},
		fetchSelectionWatershed: function fetchSelectionWatershed(selectionIds) {
			return function (dispatch) {
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.selection.getSelectionWatershed(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						selectionids: (0, _ApplicationUtils.getFetchSiteIds)(selectionIds)
					})
				}).then(_ActionUtils.getJson).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(SelectionAction.receiveSelectionWatershed(json));
				});
			};
		},
		receiveSelectionStatus: function receiveSelectionStatus(selectionStatus) {
			return {
				type: _SelectionConstants.RECEIVE_SELECTIONS_STATUS,
				selectionStatus: selectionStatus
			};
		},
		fetchSelectionStatus: function fetchSelectionStatus() {
			return function (dispatch) {
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.selection.status(), {
					method: 'GET',
					headers: {
						'Content-Type': 'application/json'
					}
				}).then(_ActionUtils.getJson).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(SelectionAction.receiveSelectionStatus(json));
				});
			};
		},
		receiveFavoriteSelection: function receiveFavoriteSelection(selectionId) {
			return {
				type: _SelectionConstants.RECEIVE_FAVORITE_SELECTION,
				selectionId: selectionId
			};
		},
		setFavoriteSelection: function setFavoriteSelection(selection) {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.selection.addFavorite(selection.id), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						authorization: btoa('Basic ' + atob(sessionStorage.getItem('TOKEN')))
					}
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
					dispatch(SelectionAction.receiveFavoriteSelection(selection.id));
				}).catch(function () {
					dispatch(_ToastrAction2.default.error('Error save favorite'));
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
	
		receiveRemoveFavoriteSelection: function receiveRemoveFavoriteSelection(selectionId) {
			return {
				type: _SelectionConstants.RECEIVE_REMOVE_FAVORITE_SELECTION,
				selectionId: selectionId
			};
		},
		removeFavoriteSelection: function removeFavoriteSelection(selection) {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.selection.removeFavorite(selection.id), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						authorization: btoa('Basic ' + atob(sessionStorage.getItem('TOKEN')))
					}
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
					dispatch(SelectionAction.receiveRemoveFavoriteSelection(selection.id));
				}).catch(function () {
					dispatch(_ToastrAction2.default.error('Error remove favorite'));
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
	
		receiveSelectedExportSelection: function receiveSelectedExportSelection(selectedExportSelections) {
			return {
				type: _SelectionConstants.RECEIVE_SELECTED_EXPORT_SELECTIONS,
				selectedExportSelections: selectedExportSelections
			};
		},
		resetSelectedExportSelection: function resetSelectedExportSelection() {
			return {
				type: _SelectionConstants.RESET_SELECTED_EXPORT_SELECTIONS
			};
		},
		openModalSelectionInformation: function openModalSelectionInformation(selectedSelectionInformation) {
			return {
				type: _SelectionConstants.OPEN_MODAL_SELECTED_SELECTION_INFORMATION,
				selectedSelectionInformation: selectedSelectionInformation
			};
		},
		openModalSelectionDelete: function openModalSelectionDelete(selectedSelectionInformation) {
			return {
				type: _SelectionConstants.OPEN_MODAL_SELECTED_SELECTION_DELETE,
				selectedSelectionInformation: selectedSelectionInformation
			};
		},
		openModalSelectionExport: function openModalSelectionExport(selectedSelectionInformation) {
			return {
				type: _SelectionConstants.OPEN_MODAL_SELECTED_SELECTION_EXPORT,
				selectedSelectionInformation: selectedSelectionInformation
			};
		},
		openModalSelectionSave: function openModalSelectionSave() {
			return {
				type: _SelectionConstants.OPEN_MODAL_SELECTED_SELECTION_SAVE
			};
		},
		closeModalSelectionInformation: function closeModalSelectionInformation() {
			return {
				type: _SelectionConstants.CLOSE_MODAL_SELECTED_SELECTION_INFORMATION
			};
		},
		closeModalSelectionDelete: function closeModalSelectionDelete() {
			return {
				type: _SelectionConstants.CLOSE_MODAL_SELECTED_SELECTION_DELETE
			};
		},
		closeModalSelectionExport: function closeModalSelectionExport() {
			return {
				type: _SelectionConstants.CLOSE_MODAL_SELECTED_SELECTION_EXPORT
			};
		},
		closeModalSelectionSave: function closeModalSelectionSave() {
			return {
				type: _SelectionConstants.CLOSE_MODAL_SELECTED_SELECTION_SAVE
			};
		},
	
		exportSelection: function exportSelection(login, selectionId) {
			var selectedOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.selection.export(selectionId), {
					method: 'POST',
					headers: { authorization: btoa('Basic ' + login) },
					body: JSON.stringify({
						exportType: selectedOptions
					})
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
					dispatch(_ToastrAction2.default.success(_simpleReactI18n2.default.receiveEmailDownloadLink));
				}).then(function () {
					dispatch(SelectionAction.closeModalSelectionExport());
				}).catch(function () {
					dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.error.errorOccurredExportingSelection));
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
		exportSelections: function exportSelections(login, listOfSelections) {
			return function (dispatch) {
				if (listOfSelections.length > 1) {
					dispatch(_ToastrAction2.default.info('L\'export de plusieurs sélections est en développement'));
				} else {
					dispatch(SelectionAction.exportSelection(login, listOfSelections[0].id));
				}
				dispatch(SelectionAction.resetSelectedExportSelection());
			};
		},
		formatJson: function formatJson(name, filterValue, stations, watersheds) {
			var ids = stations.map(function (o) {
				return o.id;
			});
			var watershedIds = watersheds.map(function (o) {
				return o.id;
			});
			var filters = filterValue.map(function (o) {
				return {
					type: o.filterTypeId,
					value: o.value
				};
			});
			return {
				name: name,
				selectedSites: ids,
				filters: filters,
				watershed: watershedIds
			};
		}
	};
	
	exports.default = SelectionAction;

/***/ },
/* 96 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.parameter = obj.parameter;
		this.label = obj.definition;
	};
	
	exports.default = _class;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _SitesConstants = __webpack_require__(226);
	
	var _ApplicationConf = __webpack_require__(65);
	
	var _ApplicationConf2 = _interopRequireDefault(_ApplicationConf);
	
	var _isomorphicFetch = __webpack_require__(78);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _ActionUtils = __webpack_require__(112);
	
	var _HomeAction = __webpack_require__(52);
	
	var _HomeAction2 = _interopRequireDefault(_HomeAction);
	
	var _reactAquasys = __webpack_require__(49);
	
	var _ApplicationUtils = __webpack_require__(186);
	
	var _HomeConstants = __webpack_require__(53);
	
	var _reactRouterRedux = __webpack_require__(43);
	
	var _SiteTypes = __webpack_require__(56);
	
	var _SiteTypes2 = _interopRequireDefault(_SiteTypes);
	
	var _reduce = __webpack_require__(813);
	
	var _reduce2 = _interopRequireDefault(_reduce);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _flatMap = __webpack_require__(803);
	
	var _flatMap2 = _interopRequireDefault(_flatMap);
	
	var _lodash = __webpack_require__(15);
	
	var _ResearchTypesUtils = __webpack_require__(228);
	
	var _ThemesUtils = __webpack_require__(384);
	
	var _AdministrationAction = __webpack_require__(61);
	
	var _AdministrationAction2 = _interopRequireDefault(_AdministrationAction);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _SelectionAction = __webpack_require__(95);
	
	var _SelectionAction2 = _interopRequireDefault(_SelectionAction);
	
	var _ToastrAction = __webpack_require__(66);
	
	var _ToastrAction2 = _interopRequireDefault(_ToastrAction);
	
	var _InformationAction = __webpack_require__(1030);
	
	var _InformationAction2 = _interopRequireDefault(_InformationAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectedTypes = [{
		type: _SiteTypes2.default.QUALITOMETER.type,
		checked: true
	}, {
		type: _SiteTypes2.default.QUALITOMETER_SURFACE.type,
		checked: true
	}, {
		type: _SiteTypes2.default.PIEZOMETER.type,
		checked: true
	}, {
		type: _SiteTypes2.default.POLLUTED_SOIL.type,
		checked: true
	}, {
		type: _SiteTypes2.default.INDUSTRIAL_SITE.type,
		checked: true
	}];
	
	var RESEARCH_TYPES = [{
		type: _SitesConstants.PANEL_CITY,
		title: 'Recherche par critère géographique',
		icon: 'location_city',
		comment: 'Recherche par critères géographiques. Rechercher en saisant le code ou le nom.',
		inDevelop: false
	}, {
		type: _SitesConstants.PANEL_RADIUS,
		title: 'Recherche par périmètre',
		icon: 'filter_tilt_shift',
		inDevelop: false,
		comment: 'Recherche par périmètre. Cliquez sur la carte et tracez un cercle à partir de ce point. La zone de recherche est limitée à 20km.'
	}, {
		type: _SitesConstants.PANEL_DRAW,
		title: 'Recherche par polygone',
		icon: 'mode_edit',
		inDevelop: true,
		comment: 'Désiner la forme que vous souhaitez et la recherche se fera dans la zone que vous avez déssinez'
	}, {
		type: _SitesConstants.PANEL_LAYER,
		title: 'Recherche par KML',
		icon: 'insert_photo',
		inDevelop: true,
		comment: 'Uploder un KML et la recherche se fera sur ce KML'
	}];
	
	var SitesAction = {
	
		receiveStations: function receiveStations(content, idWatershed, selection) {
			return {
				type: _SitesConstants.ADD_STATIONS,
				stations: content,
				selection: selection
			};
		},
		putStations: function putStations(content) {
			return {
				type: _SitesConstants.PUT_STATIONS,
				stations: content
			};
		},
	
		setSelectedStations: function setSelectedStations(content) {
			return {
				type: _SitesConstants.SELECTED_STATIONS,
				selectedStations: content
			};
		},
	
		toggleSelectedStations: function toggleSelectedStations(station) {
			return function (dispatch) {
				var selectedStations = Object.assign([], _AppStore2.default.getState().SitesReducer.selectedStations);
				var res = (0, _lodash.find)(selectedStations, (0, _lodash.matchesProperty)('id', station.id));
				if (res) {
					(0, _lodash.remove)(selectedStations, function (s) {
						return s.id === station.id;
					});
					dispatch(SitesAction.setSelectedStations(selectedStations));
				} else {
					selectedStations.push(station);
					dispatch(SitesAction.setSelectedStations(selectedStations));
				}
			};
		},
		receiveSelectedTypes: function receiveSelectedTypes(selected) {
			return {
				type: _SitesConstants.SELECTED_TYPES,
				selectedTypes: selected
			};
		},
	
		fetchSelectedTypes: function fetchSelectedTypes() {
			return function (dispatch) {
				dispatch(SitesAction.receiveSelectedTypes(selectedTypes));
			};
		},
	
		launchResearch: function launchResearch(selectedFilters, selectedThemes, filterTypes) {
			var selection = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
	
			_AppStore2.default.dispatch(_AdministrationAction2.default.selectedThemes(selectedThemes));
			_AppStore2.default.dispatch(_AdministrationAction2.default.selectedFilters(selectedFilters));
			_AppStore2.default.dispatch(SitesAction.resetStations());
			if (selection) {
				_AppStore2.default.dispatch(_SelectionAction2.default.setSelectedSelection(selection));
				_AppStore2.default.dispatch(_SelectionAction2.default.updateExecution(selection.id));
			}
			if (selectedFilters.length && selectedThemes.length) {
				var filterTypeDto = selectedFilters.map(function (o) {
					return (0, _ResearchTypesUtils.createDtoFilter)(filterTypes, o);
				});
				_AppStore2.default.dispatch(SitesAction.prepareFetchTypeResearch(filterTypeDto, (0, _ThemesUtils.getSiteTypesSelected)(selectedThemes), selection));
			} else {
				if (!selectedFilters.length) {
					_AppStore2.default.dispatch(_ToastrAction2.default.warning(_simpleReactI18n2.default.warning.pleaseFillLeastFilter));
				} else if (!selectedThemes.length) {
					_AppStore2.default.dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.error.pleaseFillLeastTheme));
				}
			}
		},
	
	
		prepareFetchTypeResearch: function prepareFetchTypeResearch(filters, siteTypesSelected, selection) {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				dispatch(_InformationAction2.default.message(_simpleReactI18n2.default.dataRecuperation));
				var reducerFilterType = (0, _reduce2.default)(filters, function (a, b) {
					(a[b.filterTypeId] || (a[b.filterTypeId] = [])).push(b);
					return a;
				}, {});
				var fetchTab = (0, _flatMap2.default)(Object.keys(reducerFilterType), function (o) {
					switch (o.toString()) {
						case '1':
							return SitesAction.prepareCityFilter(reducerFilterType[o], siteTypesSelected, selection);
						case '2':
							return SitesAction.prepareRadiusFilter(reducerFilterType[o], siteTypesSelected, selection);
						case '65537':
							return SitesAction.prepareStationFilter(reducerFilterType[o], selection);
						case '65536':
							return SitesAction.prepareWatershedFilter(reducerFilterType[o], siteTypesSelected, selection);
						case '98304':
							return SitesAction.prepareManagementWaterFilter(reducerFilterType[o], siteTypesSelected, selection);
						case '131072':
							return SitesAction.prepareDepartmentFilter(reducerFilterType[o], siteTypesSelected, selection);
						default:
							return [];
					}
				});
				fetchTab.push(_AdministrationAction2.default.updateEntry(''));
				var allfetch = fetchTab.map(function (o) {
					return _AppStore2.default.dispatch(o);
				});
				Promise.all(allfetch);
				_AppStore2.default.dispatch((0, _reactRouterRedux.push)(_HomeConstants.PATH_RESEARCH));
			};
		},
	
		prepareCityFilter: function prepareCityFilter(tabFilter, siteType, selection) {
			return tabFilter.map(function (o) {
				return SitesAction.fetchStationsByCity(o.value, siteType, selection);
			});
		},
		prepareDepartmentFilter: function prepareDepartmentFilter(tabFilter, siteType, selection) {
			return tabFilter.map(function (o) {
				return SitesAction.fetchStationsByDepartment(o.value, siteType, selection);
			});
		},
		prepareManagementWaterFilter: function prepareManagementWaterFilter(tabFilter, siteType, selection) {
			return tabFilter.map(function (o) {
				return SitesAction.fetchStationsBySage(o.value, siteType, selection);
			});
		},
		prepareRadiusFilter: function prepareRadiusFilter(tabFilter, siteType, selection) {
			return tabFilter.map(function (o) {
				return SitesAction.fetchStationsByRadius(o.value, siteType, selection);
			});
		},
		prepareStationFilter: function prepareStationFilter(tabFilter, selection) {
			return tabFilter.map(function (o) {
				return SitesAction.fetchSimpleStationWaterShed(o.value, selection);
			});
		},
		prepareWatershedFilter: function prepareWatershedFilter(tabFilter, siteType, selection) {
			return tabFilter.map(function (o) {
				return SitesAction.fetchDispatchStationsByWatershedSimple(o.value, siteType, selection);
			});
		},
		fetchStationsByCity: function fetchStationsByCity(code, selectedType, selection) {
			return function (dispatch) {
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.sites.getCityWatershed(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						inseecode: code
					})
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(SitesAction.getStations(json, selectedType, selection));
				});
			};
		},
		fetchStationsByDepartment: function fetchStationsByDepartment(code, selectedType, selection) {
			return function (dispatch) {
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.sites.getDepartmentWatershed(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						departmentcode: code
					})
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(SitesAction.getStations(json, selectedType, selection));
				});
			};
		},
		fetchStationsBySage: function fetchStationsBySage(code, selectedType, selection) {
			return function (dispatch) {
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.sites.getSageWatershed(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						sagecode: code
					})
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(SitesAction.getStations(json, selectedType, selection));
				});
			};
		},
		fetchStationsByRadius: function fetchStationsByRadius(coordinatesWithRadius, selectedType, selection) {
			return function (dispatch) {
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.sites.getRadiusWatershed(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify(coordinatesWithRadius)
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(SitesAction.getStations(json, selectedType, selection));
				});
			};
		},
	
		fetchOnDemandKeyfigures: function fetchOnDemandKeyfigures(stations) {
			return function (dispatch) {
				_AppStore2.default.dispatch(_reactAquasys.WaitAction.waitStart());
				var stationIds = stations.map(function (o) {
					return o.id;
				});
				var cities = stations.filter(function (o) {
					return o.typeId == 335715375;
				});
				var citiesId = cities.map(function (o) {
					return o.id;
				});
				var citiesCode = cities.map(function (o) {
					return o.code;
				});
				dispatch(SitesAction.fetchCityIndicators(citiesId));
				dispatch(SitesAction.fetchCityInformations(citiesCode));
				dispatch(SitesAction.fetchKeyFigures(stationIds));
				_AppStore2.default.dispatch(_reactAquasys.WaitAction.waitStop());
			};
		},
	
		getStations: function getStations(jsonIdWatershed, selectedType, selection) {
			return function (dispatch) {
				var listOfWatershedIds = jsonIdWatershed.map(function (waterShed) {
					return waterShed.id;
				});
				var finalListOfWatershed = (0, _lodash.flatten)(listOfWatershedIds.map(function (id) {
					return SitesAction.fetchDispatchGetWatershedChild(id);
				}));
				Promise.all(finalListOfWatershed).then(function (resultOfChild) {
					var listOfWatershed = (0, _lodash.flatten)(resultOfChild);
					dispatch(SitesAction.receiveWatershedSelected(listOfWatershed));
					return (0, _lodash.flatten)(listOfWatershed.map(function (watershed) {
						return SitesAction.fetchStationsByWatershed(watershed.id, selectedType);
					}));
				}).then(function (values) {
					dispatch(_InformationAction2.default.message(_simpleReactI18n2.default.mapGenerate));
					Promise.all(values).then(function (resultOfChild) {
						dispatch(SitesAction.receiveStations((0, _lodash.flattenDeep)(resultOfChild), selection));
					}).then(function () {
						_AppStore2.default.dispatch(_reactAquasys.WaitAction.waitStop());
					}).catch(function () {
						_AppStore2.default.dispatch(_reactAquasys.WaitAction.waitStop());
					});
				});
			};
		},
	
		fetchSimpleStationWaterShed: function fetchSimpleStationWaterShed(id, selection) {
			return function (dispatch) {
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.sites.getSimpleStationWatershed(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						idpoint: id
					})
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					var watershedId = json && json.length ? json[0].id : undefined;
					dispatch(SitesAction.receiveWatershedSelected(json));
					dispatch(SitesAction.fetchSimpleStation(id, watershedId, selection));
				});
			};
		},
	
		fetchSimpleStation: function fetchSimpleStation(id, idWatershed, selection) {
			return function (dispatch) {
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.sites.getSimpleStationResearch(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						idstation: id
					})
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(SitesAction.receiveStations(json, idWatershed, selection));
					return json;
				}).then(function (json) {
					dispatch(SitesAction.fetchKeyFigures([json.id]));
				}).catch(function (err) {
					dispatch(_HomeAction2.default.errorOnFetch('fetchSimpleStation' + err));
				});
			};
		},
	
		receiveWatershedSelected: function receiveWatershedSelected(watershedSelected) {
			return {
				type: _SitesConstants.RECEIVE_WATERSHED_SELECTED,
				watershedSelected: watershedSelected
			};
		},
	
		fetchStationsByWatershed: function fetchStationsByWatershed(idwatershed, selectedType) {
			return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.sites.getByWatershed(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					idwatershed: idwatershed,
					parametertype: (0, _ApplicationUtils.getFetchSiteTypeAllowWithTypes)(selectedType)
				})
			}).then(function (response) {
				return (0, _ActionUtils.checkStatus)({
					200: function _(rep) {
						return rep.json();
					},
					204: function _() {
						return [];
					},
					404: function _() {
						return [];
					}
				}, response);
			}).then(function () {
				var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
				if (!json.error) {
					return json;
				}
				return [];
			});
		},
	
		fetchDispatchGetWatershedChild: function fetchDispatchGetWatershedChild(idwatershed) {
			return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.sites.getChildWatershed(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					idwatershed: idwatershed
				})
			}).then(function (response) {
				return (0, _ActionUtils.checkStatus)({
					200: function _(rep) {
						return rep.json();
					},
					204: function _() {
						return [];
					},
					404: function _() {
						return [];
					}
				}, response);
			}).then(function () {
				var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
				return json;
			});
		},
		fetchDispatchStationsByWatershedSimple: function fetchDispatchStationsByWatershedSimple(idwatershed, selectedType, selection) {
			return function (dispatch) {
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.sites.getWatershed(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						idwatershed: idwatershed
					})
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							return [];
						},
						404: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(SitesAction.getStations(json, selectedType, selection));
				});
			};
		},
		fetchDispatchStationsByWatershed: function fetchDispatchStationsByWatershed(idwatershed, selectedType, selection) {
			return function (dispatch) {
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.sites.getByWatershed(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						idwatershed: idwatershed,
						parametertype: (0, _ApplicationUtils.getFetchSiteTypeAllowWithTypes)(selectedType)
					})
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							return [];
						},
						404: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(SitesAction.receiveStations(json, idwatershed, selection));
					return json;
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					var stationId = json.map(function (o) {
						return o.id;
					});
					dispatch(SitesAction.fetchKeyFigures(stationId));
				});
			};
		},
	
		receiveKeyFigures: function receiveKeyFigures(keyFigures) {
			return {
				type: _SitesConstants.RECEIVE_KEY_FIGURES,
				keyFigures: keyFigures
			};
		},
		fetchKeyFigures: function fetchKeyFigures(stationIds) {
			return function (dispatch) {
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.sites.getKeyFigures(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						stationids: (0, _ApplicationUtils.getFetchSiteIds)(stationIds)
					})
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							return [];
						},
						404: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(SitesAction.receiveKeyFigures(json));
					return json;
				}).then(function (json) {
					var samplingIds = json.filter(function (o) {
						return o.samplingid;
					}).map(function (o) {
						return o.samplingid;
					});
					if (samplingIds.length) {
						dispatch(SitesAction.fetchSamplingPoints(samplingIds));
					}
				}).then(function () {
					_AppStore2.default.dispatch(_reactAquasys.WaitAction.waitStop());
				}).catch(function (err) {
					dispatch(_HomeAction2.default.errorOnFetch('fetchKeyFigures' + err));
				});
			};
		},
		receiveCityIndicators: function receiveCityIndicators(cityIndicators) {
			return {
				type: _SitesConstants.RECEIVE_CITY_INDICATORS,
				cityIndicators: cityIndicators
			};
		},
		fetchCityIndicators: function fetchCityIndicators(stationIds) {
			return function (dispatch) {
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.city.getIndicators(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						citypointid: (0, _ApplicationUtils.getFetchSiteIds)(stationIds)
					})
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							return [];
						},
						404: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					if (json.length) {
						dispatch(SitesAction.receiveCityIndicators(json));
					}
				}).catch(function (err) {
					dispatch(_HomeAction2.default.errorOnFetch('fetchCityIndicators' + err));
				});
			};
		},
		receiveCityInformations: function receiveCityInformations(cityInformations) {
			return {
				type: _SitesConstants.RECEIVE_CITY_INFORMATIONS,
				cityInformations: cityInformations
			};
		},
		fetchCityInformations: function fetchCityInformations(stationCode) {
			return function (dispatch) {
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.city.getInformations(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						citypointcode: (0, _ApplicationUtils.getFetchSiteTypeAllowWithTypes)(stationCode)
					})
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							return [];
						},
						404: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					if (json.length) {
						dispatch(SitesAction.receiveCityInformations(json));
					} else {
						dispatch(_ToastrAction2.default.warning(_simpleReactI18n2.default.warning.noInformationAvailableMunicipalities));
					}
				}).catch(function (err) {
					dispatch(_HomeAction2.default.errorOnFetch('fetchCityIndicators' + err));
				});
			};
		},
	
		fetchSamplingPoints: function fetchSamplingPoints() {
			var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
			return function (dispatch) {
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.sites.getSamplingPoints(ids.join(','))).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							return [];
						},
						404: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(SitesAction.receiveSamplingPoints(json));
				});
			};
		},
	
		receiveSamplingPoints: function receiveSamplingPoints(samplingPoints) {
			return { type: _SitesConstants.RECEIVE_KEY_FIGURES_SAMPLING_POINTS, samplingPoints: samplingPoints };
		},
		receiveResearchTypes: function receiveResearchTypes(researchTypes) {
			return { type: _SitesConstants.RECEIVE_RESEARCH_TYPE, researchTypes: researchTypes };
		},
		fetchResearchTypes: function fetchResearchTypes() {
			return function (dispatch) {
				dispatch(SitesAction.receiveResearchTypes(RESEARCH_TYPES));
			};
		},
	
		setOldValue: function setOldValue(oldValue) {
			return {
				type: _SitesConstants.SET_OLD_VALUE,
				oldValue: oldValue
			};
		},
		setSelectedValue: function setSelectedValue(selectedValue) {
			return {
				type: _SitesConstants.SET_SELECTED_VALUE,
				selectedValue: selectedValue
			};
		},
		setVisualisation: function setVisualisation(visualisation) {
			return {
				type: _SitesConstants.SET_VISUALISATION,
				visualisation: visualisation
			};
		},
		setRadius: function setRadius(radius) {
			return {
				type: _SitesConstants.SET_RADIUS,
				radius: radius
			};
		},
		setCoordinatesHover: function setCoordinatesHover(hover) {
			return {
				type: _SitesConstants.SET_HOVER,
				hover: hover
			};
		},
		addWatershedLayers: function addWatershedLayers(watershedLayers) {
			return {
				type: _SitesConstants.WATERSHED_LAYERS,
				watershedLayers: watershedLayers
			};
		},
		updateWatershedLayers: function updateWatershedLayers(watershedLayers) {
			return {
				type: _SitesConstants.UPDATE_WATERSHED_LAYERS,
				watershedLayers: watershedLayers
			};
		},
		addManagementWaterLayers: function addManagementWaterLayers(managementWaterLayers) {
			return {
				type: _SitesConstants.MANAGEMENT_WATER_LAYERS,
				managementWaterLayers: managementWaterLayers
			};
		},
		updateManagementWaterLayers: function updateManagementWaterLayers(managementWaterLayers) {
			return {
				type: _SitesConstants.UPDATE_MANAGEMENT_WATER_LAYERS,
				managementWaterLayers: managementWaterLayers
			};
		},
		addCitiesLayers: function addCitiesLayers(citiesLayers) {
			return {
				type: _SitesConstants.CITIES_LAYERS,
				citiesLayers: citiesLayers
			};
		},
		addDepartmentsLayers: function addDepartmentsLayers(departmentsLayers) {
			return {
				type: _SitesConstants.DEPARTMENTS_LAYERS,
				departmentsLayers: departmentsLayers
			};
		},
		updateCitiesLayers: function updateCitiesLayers(citiesLayers) {
			return {
				type: _SitesConstants.UPDATE_CITIES_LAYERS,
				citiesLayers: citiesLayers
			};
		},
		reset: function reset() {
			return {
				type: _SitesConstants.RESET_RESEARCH
			};
		},
		resetStations: function resetStations() {
			return {
				type: _SitesConstants.RESET_STATIONS
			};
		}
	};
	
	exports.default = SitesAction;

/***/ },
/* 98 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.beginDate = obj.begindate;
		this.endDate = obj.enddate;
		this.nbMeasure = obj.nbmeasure;
		this.nbDebits = obj.nbdebits;
		this.nbHeight = obj.nbheight;
		this.nbAnalysis = obj.nbanalysis;
		this.typeId = obj.idtype;
		this.stationId = obj.stationid;
		this.samplingId = obj.samplingid;
	};
	
	exports.default = _class;

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.duration = exports.easing = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
	// to learn the context in which each easing should be used.
	var easing = {
	  // This is the most common easing curve.
	  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
	  // Objects enter the screen at full velocity from off-screen and
	  // slowly decelerate to a resting point.
	  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
	  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
	  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
	  // The sharp curve is used by objects that may return to the screen at any time.
	  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
	}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
	// to learn when use what timing
	
	exports.easing = easing;
	var duration = {
	  shortest: 150,
	  shorter: 200,
	  short: 250,
	  // most basic recommended timing
	  standard: 300,
	  // this is to be used in complex animations
	  complex: 375,
	  // recommended when something is entering screen
	  enteringScreen: 225,
	  // recommended when something is leaving screen
	  leavingScreen: 195
	};
	exports.duration = duration;
	
	function formatMs(milliseconds) {
	  return "".concat(Math.round(milliseconds), "ms");
	}
	/**
	 * @param {string|Array} props
	 * @param {object} param
	 * @param {string} param.prop
	 * @param {number} param.duration
	 * @param {string} param.easing
	 * @param {number} param.delay
	 */
	
	
	var _default = {
	  easing: easing,
	  duration: duration,
	  create: function create() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _options$duration = options.duration,
	        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
	        _options$easing = options.easing,
	        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
	        _options$delay = options.delay,
	        delay = _options$delay === void 0 ? 0 : _options$delay,
	        other = (0, _objectWithoutProperties2.default)(options, ["duration", "easing", "delay"]);
	
	    if (false) {
	      var isString = function isString(value) {
	        return typeof value === 'string';
	      };
	
	      var isNumber = function isNumber(value) {
	        return !isNaN(parseFloat(value));
	      };
	
	      if (!isString(props) && !Array.isArray(props)) {
	        console.error('Material-UI: Argument "props" must be a string or Array.');
	      }
	
	      if (!isNumber(durationOption) && !isString(durationOption)) {
	        console.error("Material-UI: Argument \"duration\" must be a number or a string but found ".concat(durationOption, "."));
	      }
	
	      if (!isString(easingOption)) {
	        console.error('Material-UI: Argument "easing" must be a string.');
	      }
	
	      if (!isNumber(delay) && !isString(delay)) {
	        console.error('Material-UI: Argument "delay" must be a number or a string.');
	      }
	
	      if (Object.keys(other).length !== 0) {
	        console.error("Material-UI: Unrecognized argument(s) [".concat(Object.keys(other).join(','), "]."));
	      }
	    }
	
	    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
	      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
	    }).join(',');
	  },
	  getAutoHeightDuration: function getAutoHeightDuration(height) {
	    if (!height) {
	      return 0;
	    }
	
	    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
	
	    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
	  }
	};
	exports.default = _default;

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(62));
	
	var _responsivePropType = _interopRequireDefault(__webpack_require__(638));
	
	var _breakpoints = __webpack_require__(413);
	
	function getPath(obj, path) {
	  if (!path || typeof path !== 'string') {
	    return null;
	  }
	
	  return path.split('.').reduce(function (acc, item) {
	    return acc && acc[item] ? acc[item] : null;
	  }, obj);
	}
	
	function style(options) {
	  var prop = options.prop,
	      _options$cssProperty = options.cssProperty,
	      cssProperty = _options$cssProperty === void 0 ? options.prop : _options$cssProperty,
	      themeKey = options.themeKey,
	      transform = options.transform;
	
	  var fn = function fn(props) {
	    if (props[prop] == null) {
	      return null;
	    }
	
	    var propValue = props[prop];
	    var theme = props.theme;
	    var themeMapping = getPath(theme, themeKey) || {};
	
	    var styleFromPropValue = function styleFromPropValue(propValueFinal) {
	      var value;
	
	      if (typeof themeMapping === 'function') {
	        value = themeMapping(propValueFinal);
	      } else if (Array.isArray(themeMapping)) {
	        value = themeMapping[propValueFinal] || propValueFinal;
	      } else {
	        value = getPath(themeMapping, propValueFinal) || propValueFinal;
	
	        if (transform) {
	          value = transform(value);
	        }
	      }
	
	      if (cssProperty === false) {
	        return value;
	      }
	
	      return (0, _defineProperty2.default)({}, cssProperty, value);
	    };
	
	    return (0, _breakpoints.handleBreakpoints)(props, propValue, styleFromPropValue);
	  };
	
	  fn.propTypes =  false ? (0, _defineProperty2.default)({}, prop, _responsivePropType.default) : {};
	  fn.filterProps = [prop];
	  return fn;
	}
	
	var _default = style;
	exports.default = _default;

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var eventService_1 = __webpack_require__(22);
	var events_1 = __webpack_require__(29);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var selectionController_1 = __webpack_require__(102);
	var valueService_1 = __webpack_require__(103);
	var columnController_1 = __webpack_require__(26);
	var columnApi_1 = __webpack_require__(38);
	var context_1 = __webpack_require__(8);
	var constants_1 = __webpack_require__(30);
	var valueCache_1 = __webpack_require__(198);
	var gridApi_1 = __webpack_require__(33);
	var utils_1 = __webpack_require__(10);
	var RowNode = /** @class */ (function () {
	    function RowNode() {
	        /** Children mapped by the pivot columns */
	        this.childrenMapped = {};
	        /** True by default - can be overridden via gridOptions.isRowSelectable(rowNode) */
	        this.selectable = true;
	        /** Used by sorting service - to give deterministic sort to groups. Previously we
	         * just id for this, however id is a string and had slower sorting compared to numbers. */
	        this.__objectId = RowNode.OBJECT_ID_SEQUENCE++;
	        /** True when nodes with the same id are being removed and added as part of the same batch transaction */
	        this.alreadyRendered = false;
	        this.selected = false;
	    }
	    RowNode.prototype.setData = function (data) {
	        var oldData = this.data;
	        this.data = data;
	        this.valueCache.onDataChanged();
	        this.updateDataOnDetailNode();
	        this.checkRowSelectable();
	        var event = this.createDataChangedEvent(data, oldData, false);
	        this.dispatchLocalEvent(event);
	    };
	    // when we are doing master / detail, the detail node is lazy created, but then kept around.
	    // so if we show / hide the detail, the same detail rowNode is used. so we need to keep the data
	    // in sync, otherwise expand/collapse of the detail would still show the old values.
	    RowNode.prototype.updateDataOnDetailNode = function () {
	        if (this.detailNode) {
	            this.detailNode.data = this.data;
	        }
	    };
	    RowNode.prototype.createDataChangedEvent = function (newData, oldData, update) {
	        return {
	            type: RowNode.EVENT_DATA_CHANGED,
	            node: this,
	            oldData: oldData,
	            newData: newData,
	            update: update
	        };
	    };
	    RowNode.prototype.createLocalRowEvent = function (type) {
	        return {
	            type: type,
	            node: this
	        };
	    };
	    // similar to setRowData, however it is expected that the data is the same data item. this
	    // is intended to be used with Redux type stores, where the whole data can be changed. we are
	    // guaranteed that the data is the same entity (so grid doesn't need to worry about the id of the
	    // underlying data changing, hence doesn't need to worry about selection). the grid, upon receiving
	    // dataChanged event, will refresh the cells rather than rip them all out (so user can show transitions).
	    RowNode.prototype.updateData = function (data) {
	        var oldData = this.data;
	        this.data = data;
	        this.updateDataOnDetailNode();
	        this.checkRowSelectable();
	        this.updateDataOnDetailNode();
	        var event = this.createDataChangedEvent(data, oldData, true);
	        this.dispatchLocalEvent(event);
	    };
	    RowNode.prototype.getRowIndexString = function () {
	        if (this.rowPinned === constants_1.Constants.PINNED_TOP) {
	            return 't-' + this.rowIndex;
	        }
	        else if (this.rowPinned === constants_1.Constants.PINNED_BOTTOM) {
	            return 'b-' + this.rowIndex;
	        }
	        else {
	            return this.rowIndex.toString();
	        }
	    };
	    RowNode.prototype.createDaemonNode = function () {
	        var oldNode = new RowNode();
	        this.context.wireBean(oldNode);
	        // just copy the id and data, this is enough for the node to be used
	        // in the selection controller (the selection controller is the only
	        // place where daemon nodes can live).
	        oldNode.id = this.id;
	        oldNode.data = this.data;
	        oldNode.daemon = true;
	        oldNode.selected = this.selected;
	        oldNode.level = this.level;
	        return oldNode;
	    };
	    RowNode.prototype.setDataAndId = function (data, id) {
	        var oldNode = utils_1._.exists(this.id) ? this.createDaemonNode() : null;
	        var oldData = this.data;
	        this.data = data;
	        this.updateDataOnDetailNode();
	        this.setId(id);
	        this.selectionController.syncInRowNode(this, oldNode);
	        this.checkRowSelectable();
	        var event = this.createDataChangedEvent(data, oldData, false);
	        this.dispatchLocalEvent(event);
	    };
	    RowNode.prototype.checkRowSelectable = function () {
	        var isRowSelectableFunc = this.gridOptionsWrapper.getIsRowSelectableFunc();
	        var shouldInvokeIsRowSelectable = isRowSelectableFunc && utils_1._.exists(this);
	        this.setRowSelectable(shouldInvokeIsRowSelectable ? isRowSelectableFunc(this) : true);
	    };
	    RowNode.prototype.setRowSelectable = function (newVal) {
	        if (this.selectable !== newVal) {
	            this.selectable = newVal;
	            if (this.eventService) {
	                this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_SELECTABLE_CHANGED));
	            }
	        }
	    };
	    RowNode.prototype.setId = function (id) {
	        // see if user is providing the id's
	        var getRowNodeId = this.gridOptionsWrapper.getRowNodeIdFunc();
	        if (getRowNodeId) {
	            // if user is providing the id's, then we set the id only after the data has been set.
	            // this is important for virtual pagination and viewport, where empty rows exist.
	            if (this.data) {
	                this.id = getRowNodeId(this.data);
	            }
	            else {
	                // this can happen if user has set blank into the rowNode after the row previously
	                // having data. this happens in virtual page row model, when data is delete and
	                // the page is refreshed.
	                this.id = undefined;
	            }
	        }
	        else {
	            this.id = id;
	        }
	    };
	    RowNode.prototype.isPixelInRange = function (pixel) {
	        return pixel >= this.rowTop && pixel < (this.rowTop + this.rowHeight);
	    };
	    RowNode.prototype.clearRowTop = function () {
	        this.oldRowTop = this.rowTop;
	        this.setRowTop(null);
	    };
	    RowNode.prototype.setFirstChild = function (firstChild) {
	        if (this.firstChild === firstChild) {
	            return;
	        }
	        this.firstChild = firstChild;
	        if (this.eventService) {
	            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_FIRST_CHILD_CHANGED));
	        }
	    };
	    RowNode.prototype.setLastChild = function (lastChild) {
	        if (this.lastChild === lastChild) {
	            return;
	        }
	        this.lastChild = lastChild;
	        if (this.eventService) {
	            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_LAST_CHILD_CHANGED));
	        }
	    };
	    RowNode.prototype.setChildIndex = function (childIndex) {
	        if (this.childIndex === childIndex) {
	            return;
	        }
	        this.childIndex = childIndex;
	        if (this.eventService) {
	            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_CHILD_INDEX_CHANGED));
	        }
	    };
	    RowNode.prototype.setRowTop = function (rowTop) {
	        if (this.rowTop === rowTop) {
	            return;
	        }
	        this.rowTop = rowTop;
	        if (this.eventService) {
	            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_TOP_CHANGED));
	        }
	    };
	    RowNode.prototype.setDragging = function (dragging) {
	        if (this.dragging === dragging) {
	            return;
	        }
	        this.dragging = dragging;
	        if (this.eventService) {
	            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_DRAGGING_CHANGED));
	        }
	    };
	    RowNode.prototype.setAllChildrenCount = function (allChildrenCount) {
	        if (this.allChildrenCount === allChildrenCount) {
	            return;
	        }
	        this.allChildrenCount = allChildrenCount;
	        if (this.eventService) {
	            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_ALL_CHILDREN_COUNT_CHANGED));
	        }
	    };
	    RowNode.prototype.setRowHeight = function (rowHeight, estimated) {
	        if (estimated === void 0) { estimated = false; }
	        this.rowHeight = rowHeight;
	        this.rowHeightEstimated = estimated;
	        if (this.eventService) {
	            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_HEIGHT_CHANGED));
	        }
	    };
	    RowNode.prototype.setRowIndex = function (rowIndex) {
	        this.rowIndex = rowIndex;
	        if (this.eventService) {
	            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_ROW_INDEX_CHANGED));
	        }
	    };
	    RowNode.prototype.setUiLevel = function (uiLevel) {
	        if (this.uiLevel === uiLevel) {
	            return;
	        }
	        this.uiLevel = uiLevel;
	        if (this.eventService) {
	            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_UI_LEVEL_CHANGED));
	        }
	    };
	    RowNode.prototype.setExpanded = function (expanded) {
	        if (this.expanded === expanded) {
	            return;
	        }
	        this.expanded = expanded;
	        if (this.eventService) {
	            this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_EXPANDED_CHANGED));
	        }
	        var event = this.createGlobalRowEvent(events_1.Events.EVENT_ROW_GROUP_OPENED);
	        this.mainEventService.dispatchEvent(event);
	        if (this.gridOptionsWrapper.isGroupIncludeFooter()) {
	            this.gridApi.redrawRows({ rowNodes: [this] });
	        }
	    };
	    RowNode.prototype.createGlobalRowEvent = function (type) {
	        var event = {
	            type: type,
	            node: this,
	            data: this.data,
	            rowIndex: this.rowIndex,
	            rowPinned: this.rowPinned,
	            context: this.gridOptionsWrapper.getContext(),
	            api: this.gridOptionsWrapper.getApi(),
	            columnApi: this.gridOptionsWrapper.getColumnApi()
	        };
	        return event;
	    };
	    RowNode.prototype.dispatchLocalEvent = function (event) {
	        if (this.eventService) {
	            this.eventService.dispatchEvent(event);
	        }
	    };
	    // we also allow editing the value via the editors. when it is done via
	    // the editors, no 'cell changed' event gets fired, as it's assumed that
	    // the cell knows about the change given it's in charge of the editing.
	    // this method is for the client to call, so the cell listens for the change
	    // event, and also flashes the cell when the change occurs.
	    RowNode.prototype.setDataValue = function (colKey, newValue) {
	        var column = this.columnController.getPrimaryColumn(colKey);
	        this.valueService.setValue(this, column, newValue);
	        this.dispatchCellChangedEvent(column, newValue);
	    };
	    RowNode.prototype.setGroupValue = function (colKey, newValue) {
	        var column = this.columnController.getGridColumn(colKey);
	        if (utils_1._.missing(this.groupData)) {
	            this.groupData = {};
	        }
	        this.groupData[column.getColId()] = newValue;
	        this.dispatchCellChangedEvent(column, newValue);
	    };
	    // sets the data for an aggregation
	    RowNode.prototype.setAggData = function (newAggData) {
	        var _this = this;
	        // find out all keys that could potentially change
	        var colIds = utils_1._.getAllKeysInObjects([this.aggData, newAggData]);
	        this.aggData = newAggData;
	        // if no event service, nobody has registered for events, so no need fire event
	        if (this.eventService) {
	            colIds.forEach(function (colId) {
	                var column = _this.columnController.getGridColumn(colId);
	                var value = _this.aggData ? _this.aggData[colId] : undefined;
	                _this.dispatchCellChangedEvent(column, value);
	            });
	        }
	    };
	    RowNode.prototype.hasChildren = function () {
	        // we need to return true when this.group=true, as this is used by server side row model
	        // (as children are lazy loaded and stored in a cache anyway). otherwise we return true
	        // if children exist.
	        return this.group || (this.childrenAfterGroup && this.childrenAfterGroup.length > 0);
	    };
	    RowNode.prototype.isEmptyRowGroupNode = function () {
	        return this.group && utils_1._.missingOrEmpty(this.childrenAfterGroup);
	    };
	    RowNode.prototype.dispatchCellChangedEvent = function (column, newValue) {
	        var cellChangedEvent = {
	            type: RowNode.EVENT_CELL_CHANGED,
	            node: this,
	            column: column,
	            newValue: newValue
	        };
	        this.dispatchLocalEvent(cellChangedEvent);
	    };
	    RowNode.prototype.resetQuickFilterAggregateText = function () {
	        this.quickFilterAggregateText = null;
	    };
	    RowNode.prototype.isExpandable = function () {
	        return this.hasChildren() || this.master;
	    };
	    RowNode.prototype.isSelected = function () {
	        // for footers, we just return what our sibling selected state is, as cannot select a footer
	        if (this.footer) {
	            return this.sibling.isSelected();
	        }
	        return this.selected;
	    };
	    RowNode.prototype.depthFirstSearch = function (callback) {
	        if (this.childrenAfterGroup) {
	            this.childrenAfterGroup.forEach(function (child) { return child.depthFirstSearch(callback); });
	        }
	        callback(this);
	    };
	    // + rowController.updateGroupsInSelection()
	    // + selectionController.calculatedSelectedForAllGroupNodes()
	    RowNode.prototype.calculateSelectedFromChildren = function () {
	        var atLeastOneSelected = false;
	        var atLeastOneDeSelected = false;
	        var atLeastOneMixed = false;
	        var newSelectedValue;
	        if (this.childrenAfterGroup) {
	            for (var i = 0; i < this.childrenAfterGroup.length; i++) {
	                var child = this.childrenAfterGroup[i];
	                // skip non-selectable nodes to prevent inconsistent selection values
	                if (!child.selectable) {
	                    continue;
	                }
	                var childState = child.isSelected();
	                switch (childState) {
	                    case true:
	                        atLeastOneSelected = true;
	                        break;
	                    case false:
	                        atLeastOneDeSelected = true;
	                        break;
	                    default:
	                        atLeastOneMixed = true;
	                        break;
	                }
	            }
	        }
	        if (atLeastOneMixed) {
	            newSelectedValue = undefined;
	        }
	        else if (atLeastOneSelected && !atLeastOneDeSelected) {
	            newSelectedValue = true;
	        }
	        else if (!atLeastOneSelected && atLeastOneDeSelected) {
	            newSelectedValue = false;
	        }
	        else {
	            newSelectedValue = undefined;
	        }
	        this.selectThisNode(newSelectedValue);
	    };
	    RowNode.prototype.setSelectedInitialValue = function (selected) {
	        this.selected = selected;
	    };
	    RowNode.prototype.setSelected = function (newValue, clearSelection, suppressFinishActions) {
	        if (clearSelection === void 0) { clearSelection = false; }
	        if (suppressFinishActions === void 0) { suppressFinishActions = false; }
	        this.setSelectedParams({
	            newValue: newValue,
	            clearSelection: clearSelection,
	            suppressFinishActions: suppressFinishActions,
	            rangeSelect: false
	        });
	    };
	    RowNode.prototype.isRowPinned = function () {
	        return this.rowPinned === constants_1.Constants.PINNED_TOP || this.rowPinned === constants_1.Constants.PINNED_BOTTOM;
	    };
	    // to make calling code more readable, this is the same method as setSelected except it takes names parameters
	    RowNode.prototype.setSelectedParams = function (params) {
	        var groupSelectsChildren = this.gridOptionsWrapper.isGroupSelectsChildren();
	        var newValue = params.newValue === true;
	        var clearSelection = params.clearSelection === true;
	        var suppressFinishActions = params.suppressFinishActions === true;
	        var rangeSelect = params.rangeSelect === true;
	        // groupSelectsFiltered only makes sense when group selects children
	        var groupSelectsFiltered = groupSelectsChildren && (params.groupSelectsFiltered === true);
	        if (this.id === undefined) {
	            console.warn('ag-Grid: cannot select node until id for node is known');
	            return 0;
	        }
	        if (this.rowPinned) {
	            console.warn('ag-Grid: cannot select pinned rows');
	            return 0;
	        }
	        // if we are a footer, we don't do selection, just pass the info
	        // to the sibling (the parent of the group)
	        if (this.footer) {
	            var count = this.sibling.setSelectedParams(params);
	            return count;
	        }
	        if (rangeSelect) {
	            var newRowClicked = this.selectionController.getLastSelectedNode() !== this;
	            var allowMultiSelect = this.gridOptionsWrapper.isRowSelectionMulti();
	            if (newRowClicked && allowMultiSelect) {
	                return this.doRowRangeSelection();
	            }
	        }
	        var updatedCount = 0;
	        // when groupSelectsFiltered, then this node may end up intermediate despite
	        // trying to set it to true / false. this group will be calculated further on
	        // down when we call calculatedSelectedForAllGroupNodes(). we need to skip it
	        // here, otherwise the updatedCount would include it.
	        var skipThisNode = groupSelectsFiltered && this.group;
	        if (!skipThisNode) {
	            var thisNodeWasSelected = this.selectThisNode(newValue);
	            if (thisNodeWasSelected) {
	                updatedCount++;
	            }
	        }
	        if (groupSelectsChildren && this.group) {
	            updatedCount += this.selectChildNodes(newValue, groupSelectsFiltered);
	        }
	        // clear other nodes if not doing multi select
	        if (!suppressFinishActions) {
	            var clearOtherNodes = newValue && (clearSelection || !this.gridOptionsWrapper.isRowSelectionMulti());
	            if (clearOtherNodes) {
	                updatedCount += this.selectionController.clearOtherNodes(this);
	            }
	            // only if we selected something, then update groups and fire events
	            if (updatedCount > 0) {
	                this.selectionController.updateGroupsFromChildrenSelections();
	                // this is the very end of the 'action node', so we are finished all the updates,
	                // include any parent / child changes that this method caused
	                var event_1 = {
	                    type: events_1.Events.EVENT_SELECTION_CHANGED,
	                    api: this.gridApi,
	                    columnApi: this.columnApi
	                };
	                this.mainEventService.dispatchEvent(event_1);
	            }
	            // so if user next does shift-select, we know where to start the selection from
	            if (newValue) {
	                this.selectionController.setLastSelectedNode(this);
	            }
	        }
	        return updatedCount;
	    };
	    // selects all rows between this node and the last selected node (or the top if this is the first selection).
	    // not to be mixed up with 'cell range selection' where you drag the mouse, this is row range selection, by
	    // holding down 'shift'.
	    RowNode.prototype.doRowRangeSelection = function () {
	        var updatedCount = 0;
	        var groupsSelectChildren = this.gridOptionsWrapper.isGroupSelectsChildren();
	        var lastSelectedNode = this.selectionController.getLastSelectedNode();
	        var nodesToSelect = this.rowModel.getNodesInRangeForSelection(this, lastSelectedNode);
	        nodesToSelect.forEach(function (rowNode) {
	            if (rowNode.group && groupsSelectChildren) {
	                return;
	            }
	            var nodeWasSelected = rowNode.selectThisNode(true);
	            if (nodeWasSelected) {
	                updatedCount++;
	            }
	        });
	        this.selectionController.updateGroupsFromChildrenSelections();
	        var event = {
	            type: events_1.Events.EVENT_SELECTION_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.mainEventService.dispatchEvent(event);
	        return updatedCount;
	    };
	    RowNode.prototype.isParentOfNode = function (potentialParent) {
	        var parentNode = this.parent;
	        while (parentNode) {
	            if (parentNode === potentialParent) {
	                return true;
	            }
	            parentNode = parentNode.parent;
	        }
	        return false;
	    };
	    RowNode.prototype.selectThisNode = function (newValue) {
	        if (!this.selectable || this.selected === newValue) {
	            return false;
	        }
	        this.selected = newValue;
	        if (this.eventService) {
	            this.dispatchLocalEvent(this.createLocalRowEvent(RowNode.EVENT_ROW_SELECTED));
	        }
	        var event = this.createGlobalRowEvent(events_1.Events.EVENT_ROW_SELECTED);
	        this.mainEventService.dispatchEvent(event);
	        return true;
	    };
	    RowNode.prototype.selectChildNodes = function (newValue, groupSelectsFiltered) {
	        var children = groupSelectsFiltered ? this.childrenAfterFilter : this.childrenAfterGroup;
	        var updatedCount = 0;
	        if (utils_1._.missing(children)) {
	            return;
	        }
	        for (var i = 0; i < children.length; i++) {
	            updatedCount += children[i].setSelectedParams({
	                newValue: newValue,
	                clearSelection: false,
	                suppressFinishActions: true,
	                groupSelectsFiltered: groupSelectsFiltered
	            });
	        }
	        return updatedCount;
	    };
	    RowNode.prototype.addEventListener = function (eventType, listener) {
	        if (!this.eventService) {
	            this.eventService = new eventService_1.EventService();
	        }
	        this.eventService.addEventListener(eventType, listener);
	    };
	    RowNode.prototype.removeEventListener = function (eventType, listener) {
	        this.eventService.removeEventListener(eventType, listener);
	    };
	    RowNode.prototype.onMouseEnter = function () {
	        this.dispatchLocalEvent(this.createLocalRowEvent(RowNode.EVENT_MOUSE_ENTER));
	    };
	    RowNode.prototype.onMouseLeave = function () {
	        this.dispatchLocalEvent(this.createLocalRowEvent(RowNode.EVENT_MOUSE_LEAVE));
	    };
	    RowNode.prototype.getFirstChildOfFirstChild = function (rowGroupColumn) {
	        var currentRowNode = this;
	        // if we are hiding groups, then if we are the first child, of the first child,
	        // all the way up to the column we are interested in, then we show the group cell.
	        var isCandidate = true;
	        var foundFirstChildPath = false;
	        var nodeToSwapIn;
	        while (isCandidate && !foundFirstChildPath) {
	            var parentRowNode = currentRowNode.parent;
	            var firstChild = utils_1._.exists(parentRowNode) && currentRowNode.firstChild;
	            if (firstChild) {
	                if (parentRowNode.rowGroupColumn === rowGroupColumn) {
	                    foundFirstChildPath = true;
	                    nodeToSwapIn = parentRowNode;
	                }
	            }
	            else {
	                isCandidate = false;
	            }
	            currentRowNode = parentRowNode;
	        }
	        return foundFirstChildPath ? nodeToSwapIn : null;
	    };
	    RowNode.OBJECT_ID_SEQUENCE = 0;
	    RowNode.EVENT_ROW_SELECTED = 'rowSelected';
	    RowNode.EVENT_DATA_CHANGED = 'dataChanged';
	    RowNode.EVENT_CELL_CHANGED = 'cellChanged';
	    RowNode.EVENT_ALL_CHILDREN_COUNT_CHANGED = 'allChildrenCountChanged';
	    RowNode.EVENT_MOUSE_ENTER = 'mouseEnter';
	    RowNode.EVENT_MOUSE_LEAVE = 'mouseLeave';
	    RowNode.EVENT_HEIGHT_CHANGED = 'heightChanged';
	    RowNode.EVENT_TOP_CHANGED = 'topChanged';
	    RowNode.EVENT_FIRST_CHILD_CHANGED = 'firstChildChanged';
	    RowNode.EVENT_LAST_CHILD_CHANGED = 'lastChildChanged';
	    RowNode.EVENT_CHILD_INDEX_CHANGED = 'childIndexChanged';
	    RowNode.EVENT_ROW_INDEX_CHANGED = 'rowIndexChanged';
	    RowNode.EVENT_EXPANDED_CHANGED = 'expandedChanged';
	    RowNode.EVENT_SELECTABLE_CHANGED = 'selectableChanged';
	    RowNode.EVENT_UI_LEVEL_CHANGED = 'uiLevelChanged';
	    RowNode.EVENT_DRAGGING_CHANGED = 'draggingChanged';
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], RowNode.prototype, "mainEventService", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], RowNode.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('selectionController'),
	        __metadata("design:type", selectionController_1.SelectionController)
	    ], RowNode.prototype, "selectionController", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], RowNode.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('valueService'),
	        __metadata("design:type", valueService_1.ValueService)
	    ], RowNode.prototype, "valueService", void 0);
	    __decorate([
	        context_1.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], RowNode.prototype, "rowModel", void 0);
	    __decorate([
	        context_1.Autowired('context'),
	        __metadata("design:type", context_1.Context)
	    ], RowNode.prototype, "context", void 0);
	    __decorate([
	        context_1.Autowired('valueCache'),
	        __metadata("design:type", valueCache_1.ValueCache)
	    ], RowNode.prototype, "valueCache", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], RowNode.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], RowNode.prototype, "gridApi", void 0);
	    return RowNode;
	}());
	exports.RowNode = RowNode;


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var context_2 = __webpack_require__(8);
	var logger_1 = __webpack_require__(68);
	var eventService_1 = __webpack_require__(22);
	var events_1 = __webpack_require__(29);
	var context_3 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var context_4 = __webpack_require__(8);
	var constants_1 = __webpack_require__(30);
	var columnApi_1 = __webpack_require__(38);
	var gridApi_1 = __webpack_require__(33);
	var utils_1 = __webpack_require__(10);
	var changedPath_1 = __webpack_require__(325);
	var SelectionController = /** @class */ (function () {
	    function SelectionController() {
	    }
	    SelectionController.prototype.setBeans = function (loggerFactory) {
	        this.logger = loggerFactory.create('SelectionController');
	        this.reset();
	        if (this.gridOptionsWrapper.isRowModelDefault()) {
	            this.eventService.addEventListener(events_1.Events.EVENT_ROW_DATA_CHANGED, this.reset.bind(this));
	        }
	        else {
	            this.logger.log('dont know what to do here');
	        }
	    };
	    SelectionController.prototype.init = function () {
	        this.groupSelectsChildren = this.gridOptionsWrapper.isGroupSelectsChildren();
	        this.eventService.addEventListener(events_1.Events.EVENT_ROW_SELECTED, this.onRowSelected.bind(this));
	    };
	    SelectionController.prototype.setLastSelectedNode = function (rowNode) {
	        this.lastSelectedNode = rowNode;
	    };
	    SelectionController.prototype.getLastSelectedNode = function () {
	        return this.lastSelectedNode;
	    };
	    SelectionController.prototype.getSelectedNodes = function () {
	        var selectedNodes = [];
	        utils_1._.iterateObject(this.selectedNodes, function (key, rowNode) {
	            if (rowNode) {
	                selectedNodes.push(rowNode);
	            }
	        });
	        return selectedNodes;
	    };
	    SelectionController.prototype.getSelectedRows = function () {
	        var selectedRows = [];
	        utils_1._.iterateObject(this.selectedNodes, function (key, rowNode) {
	            if (rowNode && rowNode.data) {
	                selectedRows.push(rowNode.data);
	            }
	        });
	        return selectedRows;
	    };
	    SelectionController.prototype.removeGroupsFromSelection = function () {
	        var _this = this;
	        utils_1._.iterateObject(this.selectedNodes, function (key, rowNode) {
	            if (rowNode && rowNode.group) {
	                _this.selectedNodes[rowNode.id] = undefined;
	            }
	        });
	    };
	    // should only be called if groupSelectsChildren=true
	    SelectionController.prototype.updateGroupsFromChildrenSelections = function (changedPath) {
	        // we only do this when group selection state depends on selected children
	        if (!this.gridOptionsWrapper.isGroupSelectsChildren()) {
	            return;
	        }
	        // also only do it if CSRM (code should never allow this anyway)
	        if (this.rowModel.getType() !== constants_1.Constants.ROW_MODEL_TYPE_CLIENT_SIDE) {
	            return;
	        }
	        var clientSideRowModel = this.rowModel;
	        var rootNode = clientSideRowModel.getRootNode();
	        if (!changedPath) {
	            changedPath = new changedPath_1.ChangedPath(true, rootNode);
	            changedPath.setInactive();
	        }
	        changedPath.forEachChangedNodeDepthFirst(function (rowNode) {
	            if (rowNode !== rootNode) {
	                rowNode.calculateSelectedFromChildren();
	            }
	        });
	        // clientSideRowModel.getTopLevelNodes()!.forEach((rowNode: RowNode) => {
	        //     rowNode.depthFirstSearch((node) => {
	        //         if (node.group) {
	        //         }
	        //     });
	        // });
	    };
	    SelectionController.prototype.getNodeForIdIfSelected = function (id) {
	        return this.selectedNodes[id];
	    };
	    SelectionController.prototype.clearOtherNodes = function (rowNodeToKeepSelected) {
	        var _this = this;
	        var groupsToRefresh = {};
	        var updatedCount = 0;
	        utils_1._.iterateObject(this.selectedNodes, function (key, otherRowNode) {
	            if (otherRowNode && otherRowNode.id !== rowNodeToKeepSelected.id) {
	                var rowNode = _this.selectedNodes[otherRowNode.id];
	                updatedCount += rowNode.setSelectedParams({
	                    newValue: false,
	                    clearSelection: false,
	                    suppressFinishActions: true
	                });
	                if (_this.groupSelectsChildren && otherRowNode.parent) {
	                    groupsToRefresh[otherRowNode.parent.id] = otherRowNode.parent;
	                }
	            }
	        });
	        utils_1._.iterateObject(groupsToRefresh, function (key, group) {
	            group.calculateSelectedFromChildren();
	        });
	        return updatedCount;
	    };
	    SelectionController.prototype.onRowSelected = function (event) {
	        var rowNode = event.node;
	        // we do not store the group rows when the groups select children
	        if (this.groupSelectsChildren && rowNode.group) {
	            return;
	        }
	        if (rowNode.isSelected()) {
	            this.selectedNodes[rowNode.id] = rowNode;
	        }
	        else {
	            this.selectedNodes[rowNode.id] = undefined;
	        }
	    };
	    SelectionController.prototype.syncInRowNode = function (rowNode, oldNode) {
	        this.syncInOldRowNode(rowNode, oldNode);
	        this.syncInNewRowNode(rowNode);
	    };
	    // if the id has changed for the node, then this means the rowNode
	    // is getting used for a different data item, which breaks
	    // our selectedNodes, as the node now is mapped by the old id
	    // which is inconsistent. so to keep the old node as selected,
	    // we swap in the clone (with the old id and old data). this means
	    // the oldNode is effectively a daemon we keep a reference to,
	    // so if client calls api.getSelectedNodes(), it gets the daemon
	    // in the result. when the client un-selects, the reference to the
	    // daemon is removed. the daemon, because it's an oldNode, is not
	    // used by the grid for rendering, it's a copy of what the node used
	    // to be like before the id was changed.
	    SelectionController.prototype.syncInOldRowNode = function (rowNode, oldNode) {
	        var oldNodeHasDifferentId = utils_1._.exists(oldNode) && (rowNode.id !== oldNode.id);
	        if (oldNodeHasDifferentId) {
	            var oldNodeSelected = utils_1._.exists(this.selectedNodes[oldNode.id]);
	            if (oldNodeSelected) {
	                this.selectedNodes[oldNode.id] = oldNode;
	            }
	        }
	    };
	    SelectionController.prototype.syncInNewRowNode = function (rowNode) {
	        if (utils_1._.exists(this.selectedNodes[rowNode.id])) {
	            rowNode.setSelectedInitialValue(true);
	            this.selectedNodes[rowNode.id] = rowNode;
	        }
	        else {
	            rowNode.setSelectedInitialValue(false);
	        }
	    };
	    SelectionController.prototype.reset = function () {
	        this.logger.log('reset');
	        this.selectedNodes = {};
	        this.lastSelectedNode = null;
	    };
	    // returns a list of all nodes at 'best cost' - a feature to be used
	    // with groups / trees. if a group has all it's children selected,
	    // then the group appears in the result, but not the children.
	    // Designed for use with 'children' as the group selection type,
	    // where groups don't actually appear in the selection normally.
	    SelectionController.prototype.getBestCostNodeSelection = function () {
	        if (this.rowModel.getType() !== constants_1.Constants.ROW_MODEL_TYPE_CLIENT_SIDE) {
	            console.warn('getBestCostNodeSelection is only available when using normal row model');
	        }
	        var clientSideRowModel = this.rowModel;
	        var topLevelNodes = clientSideRowModel.getTopLevelNodes();
	        if (topLevelNodes === null) {
	            console.warn('selectAll not available doing rowModel=virtual');
	            return;
	        }
	        var result = [];
	        // recursive function, to find the selected nodes
	        function traverse(nodes) {
	            for (var i = 0, l = nodes.length; i < l; i++) {
	                var node = nodes[i];
	                if (node.isSelected()) {
	                    result.push(node);
	                }
	                else {
	                    // if not selected, then if it's a group, and the group
	                    // has children, continue to search for selections
	                    if (node.group && node.children) {
	                        traverse(node.children);
	                    }
	                }
	            }
	        }
	        traverse(topLevelNodes);
	        return result;
	    };
	    SelectionController.prototype.setRowModel = function (rowModel) {
	        this.rowModel = rowModel;
	    };
	    SelectionController.prototype.isEmpty = function () {
	        var count = 0;
	        utils_1._.iterateObject(this.selectedNodes, function (nodeId, rowNode) {
	            if (rowNode) {
	                count++;
	            }
	        });
	        return count === 0;
	    };
	    SelectionController.prototype.deselectAllRowNodes = function (justFiltered) {
	        if (justFiltered === void 0) { justFiltered = false; }
	        var callback = function (rowNode) { return rowNode.selectThisNode(false); };
	        var rowModelClientSide = this.rowModel.getType() === constants_1.Constants.ROW_MODEL_TYPE_CLIENT_SIDE;
	        if (justFiltered) {
	            if (!rowModelClientSide) {
	                console.error('ag-Grid: selecting just filtered only works with In Memory Row Model');
	                return;
	            }
	            var clientSideRowModel = this.rowModel;
	            clientSideRowModel.forEachNodeAfterFilter(callback);
	        }
	        else {
	            utils_1._.iterateObject(this.selectedNodes, function (id, rowNode) {
	                // remember the reference can be to null, as we never 'delete' from the map
	                if (rowNode) {
	                    callback(rowNode);
	                }
	            });
	            // this clears down the map (whereas above only sets the items in map to 'undefined')
	            this.reset();
	        }
	        // the above does not clean up the parent rows if they are selected
	        if (rowModelClientSide && this.groupSelectsChildren) {
	            this.updateGroupsFromChildrenSelections();
	        }
	        var event = {
	            type: events_1.Events.EVENT_SELECTION_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    SelectionController.prototype.selectAllRowNodes = function (justFiltered) {
	        if (justFiltered === void 0) { justFiltered = false; }
	        if (this.rowModel.getType() !== constants_1.Constants.ROW_MODEL_TYPE_CLIENT_SIDE) {
	            throw new Error("selectAll only available with normal row model, ie not " + this.rowModel.getType());
	        }
	        var clientSideRowModel = this.rowModel;
	        var callback = function (rowNode) { return rowNode.selectThisNode(true); };
	        if (justFiltered) {
	            clientSideRowModel.forEachNodeAfterFilter(callback);
	        }
	        else {
	            clientSideRowModel.forEachNode(callback);
	        }
	        // the above does not clean up the parent rows if they are selected
	        if (this.rowModel.getType() === constants_1.Constants.ROW_MODEL_TYPE_CLIENT_SIDE && this.groupSelectsChildren) {
	            this.updateGroupsFromChildrenSelections();
	        }
	        var event = {
	            type: events_1.Events.EVENT_SELECTION_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    /**
	     * @method
	     * @deprecated
	     */
	    SelectionController.prototype.selectNode = function (rowNode, tryMulti) {
	        if (rowNode) {
	            rowNode.setSelectedParams({ newValue: true, clearSelection: !tryMulti });
	        }
	    };
	    /**
	     * @method
	     * @deprecated
	     */
	    SelectionController.prototype.deselectIndex = function (rowIndex) {
	        var node = this.rowModel.getRow(rowIndex);
	        this.deselectNode(node);
	    };
	    /**
	     * @method
	     * @deprecated
	     */
	    SelectionController.prototype.deselectNode = function (rowNode) {
	        if (rowNode) {
	            rowNode.setSelectedParams({ newValue: false, clearSelection: false });
	        }
	    };
	    /**
	     * @method
	     * @deprecated
	     */
	    SelectionController.prototype.selectIndex = function (index, tryMulti) {
	        var node = this.rowModel.getRow(index);
	        this.selectNode(node, tryMulti);
	    };
	    __decorate([
	        context_3.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], SelectionController.prototype, "eventService", void 0);
	    __decorate([
	        context_3.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], SelectionController.prototype, "rowModel", void 0);
	    __decorate([
	        context_3.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], SelectionController.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_3.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], SelectionController.prototype, "columnApi", void 0);
	    __decorate([
	        context_3.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], SelectionController.prototype, "gridApi", void 0);
	    __decorate([
	        __param(0, context_2.Qualifier('loggerFactory')),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [logger_1.LoggerFactory]),
	        __metadata("design:returntype", void 0)
	    ], SelectionController.prototype, "setBeans", null);
	    __decorate([
	        context_4.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], SelectionController.prototype, "init", null);
	    SelectionController = __decorate([
	        context_1.Bean('selectionController')
	    ], SelectionController);
	    return SelectionController;
	}());
	exports.SelectionController = SelectionController;


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var expressionService_1 = __webpack_require__(121);
	var columnController_1 = __webpack_require__(26);
	var context_1 = __webpack_require__(8);
	var events_1 = __webpack_require__(29);
	var eventService_1 = __webpack_require__(22);
	var valueCache_1 = __webpack_require__(198);
	var utils_1 = __webpack_require__(10);
	var ValueService = /** @class */ (function () {
	    function ValueService() {
	        this.initialised = false;
	    }
	    ValueService.prototype.init = function () {
	        this.cellExpressions = this.gridOptionsWrapper.isEnableCellExpressions();
	        this.initialised = true;
	    };
	    ValueService.prototype.getValue = function (column, rowNode, forFilter, ignoreAggData) {
	        // console.log(`turnActive = ${this.turnActive}`);
	        if (forFilter === void 0) { forFilter = false; }
	        if (ignoreAggData === void 0) { ignoreAggData = false; }
	        // hack - the grid is getting refreshed before this bean gets initialised, race condition.
	        // really should have a way so they get initialised in the right order???
	        if (!this.initialised) {
	            this.init();
	        }
	        if (!rowNode) {
	            return;
	        }
	        // pull these out to make code below easier to read
	        var colDef = column.getColDef();
	        var field = colDef.field;
	        var colId = column.getId();
	        var data = rowNode.data;
	        var result;
	        // if there is a value getter, this gets precedence over a field
	        var groupDataExists = rowNode.groupData && rowNode.groupData[colId] !== undefined;
	        var aggDataExists = !ignoreAggData && rowNode.aggData && rowNode.aggData[colId] !== undefined;
	        if (forFilter && colDef.filterValueGetter) {
	            result = this.executeFilterValueGetter(colDef.filterValueGetter, data, column, rowNode);
	        }
	        else if (this.gridOptionsWrapper.isTreeData() && aggDataExists) {
	            result = rowNode.aggData[colId];
	        }
	        else if (this.gridOptionsWrapper.isTreeData() && colDef.valueGetter) {
	            result = this.executeValueGetter(colDef.valueGetter, data, column, rowNode);
	        }
	        else if (this.gridOptionsWrapper.isTreeData() && (field && data)) {
	            result = utils_1._.getValueUsingField(data, field, column.isFieldContainsDots());
	        }
	        else if (groupDataExists) {
	            result = rowNode.groupData[colId];
	        }
	        else if (aggDataExists) {
	            result = rowNode.aggData[colId];
	        }
	        else if (colDef.valueGetter) {
	            result = this.executeValueGetter(colDef.valueGetter, data, column, rowNode);
	        }
	        else if (field && data) {
	            result = utils_1._.getValueUsingField(data, field, column.isFieldContainsDots());
	        }
	        // the result could be an expression itself, if we are allowing cell values to be expressions
	        if (this.cellExpressions && (typeof result === 'string') && result.indexOf('=') === 0) {
	            var cellValueGetter = result.substring(1);
	            result = this.executeValueGetter(cellValueGetter, data, column, rowNode);
	        }
	        return result;
	    };
	    ValueService.prototype.setValue = function (rowNode, colKey, newValue) {
	        var column = this.columnController.getPrimaryColumn(colKey);
	        if (!rowNode || !column) {
	            return;
	        }
	        // this will only happen if user is trying to paste into a group row, which doesn't make sense
	        // the user should not be trying to paste into group rows
	        var data = rowNode.data;
	        if (utils_1._.missing(data)) {
	            rowNode.data = {};
	        }
	        // for backwards compatibility we are also retrieving the newValueHandler as well as the valueSetter
	        var _a = column.getColDef(), field = _a.field, newValueHandler = _a.newValueHandler, valueSetter = _a.valueSetter;
	        // need either a field or a newValueHandler for this to work
	        if (utils_1._.missing(field) && utils_1._.missing(newValueHandler) && utils_1._.missing(valueSetter)) {
	            // we don't tell user about newValueHandler, as that is deprecated
	            console.warn("ag-Grid: you need either field or valueSetter set on colDef for editing to work");
	            return;
	        }
	        var params = {
	            node: rowNode,
	            data: rowNode.data,
	            oldValue: this.getValue(column, rowNode),
	            newValue: newValue,
	            colDef: column.getColDef(),
	            column: column,
	            api: this.gridOptionsWrapper.getApi(),
	            columnApi: this.gridOptionsWrapper.getColumnApi(),
	            context: this.gridOptionsWrapper.getContext()
	        };
	        params.newValue = newValue;
	        var valueWasDifferent;
	        if (newValueHandler && utils_1._.exists(newValueHandler)) {
	            valueWasDifferent = newValueHandler(params);
	        }
	        else if (utils_1._.exists(valueSetter)) {
	            valueWasDifferent = this.expressionService.evaluate(valueSetter, params);
	        }
	        else {
	            valueWasDifferent = this.setValueUsingField(data, field, newValue, column.isFieldContainsDots());
	        }
	        // in case user forgot to return something (possible if they are not using TypeScript
	        // and just forgot, or using an old newValueHandler we didn't always expect a return
	        // value here), we default the return value to true, so we always refresh.
	        if (valueWasDifferent === undefined) {
	            valueWasDifferent = true;
	        }
	        // if no change to the value, then no need to do the updating, or notifying via events.
	        // otherwise the user could be tabbing around the grid, and cellValueChange would get called
	        // all the time.
	        if (!valueWasDifferent) {
	            return;
	        }
	        // reset quick filter on this row
	        rowNode.resetQuickFilterAggregateText();
	        this.valueCache.onDataChanged();
	        params.newValue = this.getValue(column, rowNode);
	        var onCellValueChanged = column.getColDef().onCellValueChanged;
	        if (typeof onCellValueChanged === 'function') {
	            // to make callback async, do in a timeout
	            setTimeout(function () { return onCellValueChanged(params); }, 0);
	        }
	        var event = {
	            type: events_1.Events.EVENT_CELL_VALUE_CHANGED,
	            event: null,
	            rowIndex: rowNode.rowIndex,
	            rowPinned: rowNode.rowPinned,
	            column: params.column,
	            api: params.api,
	            colDef: params.colDef,
	            columnApi: params.columnApi,
	            context: params.context,
	            data: rowNode.data,
	            node: rowNode,
	            oldValue: params.oldValue,
	            newValue: params.newValue,
	            value: params.newValue
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ValueService.prototype.setValueUsingField = function (data, field, newValue, isFieldContainsDots) {
	        if (!field) {
	            return false;
	        }
	        // if no '.', then it's not a deep value
	        var valuesAreSame = false;
	        if (!isFieldContainsDots) {
	            data[field] = newValue;
	        }
	        else {
	            // otherwise it is a deep value, so need to dig for it
	            var fieldPieces = field.split('.');
	            var currentObject = data;
	            while (fieldPieces.length > 0 && currentObject) {
	                var fieldPiece = fieldPieces.shift();
	                if (fieldPieces.length === 0) {
	                    currentObject[fieldPiece] = newValue;
	                }
	                else {
	                    currentObject = currentObject[fieldPiece];
	                }
	            }
	        }
	        return !valuesAreSame;
	    };
	    ValueService.prototype.executeFilterValueGetter = function (valueGetter, data, column, rowNode) {
	        var params = {
	            data: data,
	            node: rowNode,
	            column: column,
	            colDef: column.getColDef(),
	            api: this.gridOptionsWrapper.getApi(),
	            columnApi: this.gridOptionsWrapper.getColumnApi(),
	            context: this.gridOptionsWrapper.getContext(),
	            getValue: this.getValueCallback.bind(this, rowNode)
	        };
	        return this.expressionService.evaluate(valueGetter, params);
	    };
	    ValueService.prototype.executeValueGetter = function (valueGetter, data, column, rowNode) {
	        var colId = column.getId();
	        // if inside the same turn, just return back the value we got last time
	        var valueFromCache = this.valueCache.getValue(rowNode, colId);
	        if (valueFromCache !== undefined) {
	            return valueFromCache;
	        }
	        var params = {
	            data: data,
	            node: rowNode,
	            column: column,
	            colDef: column.getColDef(),
	            api: this.gridOptionsWrapper.getApi(),
	            columnApi: this.gridOptionsWrapper.getColumnApi(),
	            context: this.gridOptionsWrapper.getContext(),
	            getValue: this.getValueCallback.bind(this, rowNode)
	        };
	        var result = this.expressionService.evaluate(valueGetter, params);
	        // if a turn is active, store the value in case the grid asks for it again
	        this.valueCache.setValue(rowNode, colId, result);
	        return result;
	    };
	    ValueService.prototype.getValueCallback = function (node, field) {
	        var otherColumn = this.columnController.getPrimaryColumn(field);
	        if (otherColumn) {
	            return this.getValue(otherColumn, node);
	        }
	        return null;
	    };
	    // used by row grouping and pivot, to get key for a row. col can be a pivot col or a row grouping col
	    ValueService.prototype.getKeyForNode = function (col, rowNode) {
	        var value = this.getValue(col, rowNode);
	        var keyCreator = col.getColDef().keyCreator;
	        var result = keyCreator ? keyCreator({ value: value }) : value;
	        // if already a string, or missing, just return it
	        if (typeof result === 'string' || result == null) {
	            return result;
	        }
	        result = String(result);
	        if (result === '[object Object]') {
	            utils_1._.doOnce(function () {
	                console.warn('ag-Grid: a column you are grouping or pivoting by has objects as values. If you want to group by complex objects then either a) use a colDef.keyCreator (se ag-Grid docs) or b) to toString() on the object to return a key');
	            }, 'getKeyForNode - warn about [object,object]');
	        }
	        return result;
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], ValueService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('expressionService'),
	        __metadata("design:type", expressionService_1.ExpressionService)
	    ], ValueService.prototype, "expressionService", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], ValueService.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], ValueService.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('valueCache'),
	        __metadata("design:type", valueCache_1.ValueCache)
	    ], ValueService.prototype, "valueCache", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ValueService.prototype, "init", null);
	    ValueService = __decorate([
	        context_1.Bean('valueService')
	    ], ValueService);
	    return ValueService;
	}());
	exports.ValueService = ValueService;


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(2);
	var factory = __webpack_require__(688);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(3);
	
	var each = _util.each;
	var isString = _util.isString;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Note that it is too complicated to support 3d stack by value
	 * (have to create two-dimension inverted index), so in 3d case
	 * we just support that stacked by index.
	 *
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {Array.<string|Object>} dimensionInfoList The same as the input of <module:echarts/data/List>.
	 *        The input dimensionInfoList will be modified.
	 * @param {Object} [opt]
	 * @param {boolean} [opt.stackedCoordDimension=''] Specify a coord dimension if needed.
	 * @param {boolean} [opt.byIndex=false]
	 * @return {Object} calculationInfo
	 * {
	 *     stackedDimension: string
	 *     stackedByDimension: string
	 *     isStackedByIndex: boolean
	 *     stackedOverDimension: string
	 *     stackResultDimension: string
	 * }
	 */
	function enableDataStack(seriesModel, dimensionInfoList, opt) {
	  opt = opt || {};
	  var byIndex = opt.byIndex;
	  var stackedCoordDimension = opt.stackedCoordDimension; // Compatibal: when `stack` is set as '', do not stack.
	
	  var mayStack = !!(seriesModel && seriesModel.get('stack'));
	  var stackedByDimInfo;
	  var stackedDimInfo;
	  var stackResultDimension;
	  var stackedOverDimension;
	  each(dimensionInfoList, function (dimensionInfo, index) {
	    if (isString(dimensionInfo)) {
	      dimensionInfoList[index] = dimensionInfo = {
	        name: dimensionInfo
	      };
	    }
	
	    if (mayStack && !dimensionInfo.isExtraCoord) {
	      // Find the first ordinal dimension as the stackedByDimInfo.
	      if (!byIndex && !stackedByDimInfo && dimensionInfo.ordinalMeta) {
	        stackedByDimInfo = dimensionInfo;
	      } // Find the first stackable dimension as the stackedDimInfo.
	
	
	      if (!stackedDimInfo && dimensionInfo.type !== 'ordinal' && dimensionInfo.type !== 'time' && (!stackedCoordDimension || stackedCoordDimension === dimensionInfo.coordDim)) {
	        stackedDimInfo = dimensionInfo;
	      }
	    }
	  });
	
	  if (stackedDimInfo && !byIndex && !stackedByDimInfo) {
	    // Compatible with previous design, value axis (time axis) only stack by index.
	    // It may make sense if the user provides elaborately constructed data.
	    byIndex = true;
	  } // Add stack dimension, they can be both calculated by coordinate system in `unionExtent`.
	  // That put stack logic in List is for using conveniently in echarts extensions, but it
	  // might not be a good way.
	
	
	  if (stackedDimInfo) {
	    // Use a weird name that not duplicated with other names.
	    stackResultDimension = '__\0ecstackresult';
	    stackedOverDimension = '__\0ecstackedover'; // Create inverted index to fast query index by value.
	
	    if (stackedByDimInfo) {
	      stackedByDimInfo.createInvertedIndices = true;
	    }
	
	    var stackedDimCoordDim = stackedDimInfo.coordDim;
	    var stackedDimType = stackedDimInfo.type;
	    var stackedDimCoordIndex = 0;
	    each(dimensionInfoList, function (dimensionInfo) {
	      if (dimensionInfo.coordDim === stackedDimCoordDim) {
	        stackedDimCoordIndex++;
	      }
	    });
	    dimensionInfoList.push({
	      name: stackResultDimension,
	      coordDim: stackedDimCoordDim,
	      coordDimIndex: stackedDimCoordIndex,
	      type: stackedDimType,
	      isExtraCoord: true,
	      isCalculationCoord: true
	    });
	    stackedDimCoordIndex++;
	    dimensionInfoList.push({
	      name: stackedOverDimension,
	      // This dimension contains stack base (generally, 0), so do not set it as
	      // `stackedDimCoordDim` to avoid extent calculation, consider log scale.
	      coordDim: stackedOverDimension,
	      coordDimIndex: stackedDimCoordIndex,
	      type: stackedDimType,
	      isExtraCoord: true,
	      isCalculationCoord: true
	    });
	  }
	
	  return {
	    stackedDimension: stackedDimInfo && stackedDimInfo.name,
	    stackedByDimension: stackedByDimInfo && stackedByDimInfo.name,
	    isStackedByIndex: byIndex,
	    stackedOverDimension: stackedOverDimension,
	    stackResultDimension: stackResultDimension
	  };
	}
	/**
	 * @param {module:echarts/data/List} data
	 * @param {string} stackedDim
	 */
	
	
	function isDimensionStacked(data, stackedDim
	/*, stackedByDim*/
	) {
	  // Each single series only maps to one pair of axis. So we do not need to
	  // check stackByDim, whatever stacked by a dimension or stacked by index.
	  return !!stackedDim && stackedDim === data.getCalculationInfo('stackedDimension'); // && (
	  //     stackedByDim != null
	  //         ? stackedByDim === data.getCalculationInfo('stackedByDimension')
	  //         : data.getCalculationInfo('isStackedByIndex')
	  // );
	}
	/**
	 * @param {module:echarts/data/List} data
	 * @param {string} targetDim
	 * @param {string} [stackedByDim] If not input this parameter, check whether
	 *                                stacked by index.
	 * @return {string} dimension
	 */
	
	
	function getStackedDimension(data, targetDim) {
	  return isDimensionStacked(data, targetDim) ? data.getCalculationInfo('stackResultDimension') : targetDim;
	}
	
	exports.enableDataStack = enableDataStack;
	exports.isDimensionStacked = isDimensionStacked;
	exports.getStackedDimension = getStackedDimension;

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(3);
	
	var each = _util.each;
	
	var Group = __webpack_require__(187);
	
	var componentUtil = __webpack_require__(268);
	
	var clazzUtil = __webpack_require__(124);
	
	var modelUtil = __webpack_require__(24);
	
	var graphicUtil = __webpack_require__(16);
	
	var _task = __webpack_require__(476);
	
	var createTask = _task.createTask;
	
	var createRenderPlanner = __webpack_require__(202);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = modelUtil.makeInner();
	var renderPlanner = createRenderPlanner();
	
	function Chart() {
	  /**
	   * @type {module:zrender/container/Group}
	   * @readOnly
	   */
	  this.group = new Group();
	  /**
	   * @type {string}
	   * @readOnly
	   */
	
	  this.uid = componentUtil.getUID('viewChart');
	  this.renderTask = createTask({
	    plan: renderTaskPlan,
	    reset: renderTaskReset
	  });
	  this.renderTask.context = {
	    view: this
	  };
	}
	
	Chart.prototype = {
	  type: 'chart',
	
	  /**
	   * Init the chart.
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  init: function (ecModel, api) {},
	
	  /**
	   * Render the chart.
	   * @param  {module:echarts/model/Series} seriesModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @param  {Object} payload
	   */
	  render: function (seriesModel, ecModel, api, payload) {},
	
	  /**
	   * Highlight series or specified data item.
	   * @param  {module:echarts/model/Series} seriesModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @param  {Object} payload
	   */
	  highlight: function (seriesModel, ecModel, api, payload) {
	    toggleHighlight(seriesModel.getData(), payload, 'emphasis');
	  },
	
	  /**
	   * Downplay series or specified data item.
	   * @param  {module:echarts/model/Series} seriesModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @param  {Object} payload
	   */
	  downplay: function (seriesModel, ecModel, api, payload) {
	    toggleHighlight(seriesModel.getData(), payload, 'normal');
	  },
	
	  /**
	   * Remove self.
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  remove: function (ecModel, api) {
	    this.group.removeAll();
	  },
	
	  /**
	   * Dispose self.
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  dispose: function () {},
	
	  /**
	   * Rendering preparation in progressive mode.
	   * @param  {module:echarts/model/Series} seriesModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @param  {Object} payload
	   */
	  incrementalPrepareRender: null,
	
	  /**
	   * Render in progressive mode.
	   * @param  {Object} params See taskParams in `stream/task.js`
	   * @param  {module:echarts/model/Series} seriesModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @param  {Object} payload
	   */
	  incrementalRender: null,
	
	  /**
	   * Update transform directly.
	   * @param  {module:echarts/model/Series} seriesModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @param  {Object} payload
	   * @return {Object} {update: true}
	   */
	  updateTransform: null,
	
	  /**
	   * The view contains the given point.
	   * @interface
	   * @param {Array.<number>} point
	   * @return {boolean}
	   */
	  // containPoint: function () {}
	
	  /**
	   * @param {string} eventType
	   * @param {Object} query
	   * @param {module:zrender/Element} targetEl
	   * @param {Object} packedEvent
	   * @return {boolen} Pass only when return `true`.
	   */
	  filterForExposedEvent: null
	};
	var chartProto = Chart.prototype;
	
	chartProto.updateView = chartProto.updateLayout = chartProto.updateVisual = function (seriesModel, ecModel, api, payload) {
	  this.render(seriesModel, ecModel, api, payload);
	};
	/**
	 * Set state of single element
	 * @param {module:zrender/Element} el
	 * @param {string} state 'normal'|'emphasis'
	 * @param {number} highlightDigit
	 */
	
	
	function elSetState(el, state, highlightDigit) {
	  if (el) {
	    el.trigger(state, highlightDigit);
	
	    if (el.isGroup // Simple optimize.
	    && !graphicUtil.isHighDownDispatcher(el)) {
	      for (var i = 0, len = el.childCount(); i < len; i++) {
	        elSetState(el.childAt(i), state, highlightDigit);
	      }
	    }
	  }
	}
	/**
	 * @param {module:echarts/data/List} data
	 * @param {Object} payload
	 * @param {string} state 'normal'|'emphasis'
	 */
	
	
	function toggleHighlight(data, payload, state) {
	  var dataIndex = modelUtil.queryDataIndex(data, payload);
	  var highlightDigit = payload && payload.highlightKey != null ? graphicUtil.getHighlightDigit(payload.highlightKey) : null;
	
	  if (dataIndex != null) {
	    each(modelUtil.normalizeToArray(dataIndex), function (dataIdx) {
	      elSetState(data.getItemGraphicEl(dataIdx), state, highlightDigit);
	    });
	  } else {
	    data.eachItemGraphicEl(function (el) {
	      elSetState(el, state, highlightDigit);
	    });
	  }
	} // Enable Chart.extend.
	
	
	clazzUtil.enableClassExtend(Chart, ['dispose']); // Add capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.
	
	clazzUtil.enableClassManagement(Chart, {
	  registerWhenExtend: true
	});
	
	Chart.markUpdateMethod = function (payload, methodName) {
	  inner(payload).updateMethod = methodName;
	};
	
	function renderTaskPlan(context) {
	  return renderPlanner(context.model);
	}
	
	function renderTaskReset(context) {
	  var seriesModel = context.model;
	  var ecModel = context.ecModel;
	  var api = context.api;
	  var payload = context.payload; // ???! remove updateView updateVisual
	
	  var progressiveRender = seriesModel.pipelineContext.progressiveRender;
	  var view = context.view;
	  var updateMethod = payload && inner(payload).updateMethod;
	  var methodName = progressiveRender ? 'incrementalPrepareRender' : updateMethod && view[updateMethod] ? updateMethod // `appendData` is also supported when data amount
	  // is less than progressive threshold.
	  : 'render';
	
	  if (methodName !== 'render') {
	    view[methodName](seriesModel, ecModel, api, payload);
	  }
	
	  return progressMethodMap[methodName];
	}
	
	var progressMethodMap = {
	  incrementalPrepareRender: {
	    progress: function (params, context) {
	      context.view.incrementalRender(params, context.model, context.ecModel, context.api, context.payload);
	    }
	  },
	  render: {
	    // Put view.render in `progress` to support appendData. But in this case
	    // view.render should not be called in reset, otherwise it will be called
	    // twise. Use `forceFirstProgress` to make sure that view.render is called
	    // in any cases.
	    forceFirstProgress: true,
	    progress: function (params, context) {
	      context.view.render(context.model, context.ecModel, context.api, context.payload);
	    }
	  }
	};
	var _default = Chart;
	module.exports = _default;

/***/ },
/* 107 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(807),
	    isLength = __webpack_require__(496);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	var require;var require;var require;var require;var require;var require;var require;var require;/* WEBPACK VAR INJECTION */(function(global) {// OpenLayers. See https://openlayers.org/
	// License: https://raw.githubusercontent.com/openlayers/openlayers/master/LICENSE.md
	// Version: v4.0.1
	;(function (root, factory) {
	  if (true) {
	    module.exports = factory();
	  } else if (typeof define === "function" && define.amd) {
	    define([], factory);
	  } else {
	    root.ol = factory();
	  }
	}(this, function () {
	  var OPENLAYERS = {};
	  var k,aa=this;function t(a,b){var c=OPENLAYERS,d=a.split("."),c=c||aa;d[0]in c||!c.execScript||c.execScript("var "+d[0]);for(var e;d.length&&(e=d.shift());)d.length||void 0===b?c[e]?c=c[e]:c=c[e]={}:c[e]=b};var ba,ca;function da(a,b){return a>b?1:a<b?-1:0}function ea(a,b){return 0<=a.indexOf(b)}function fa(a,b,c){var d=a.length;if(a[0]<=b)return 0;if(!(b<=a[d-1]))if(0<c)for(c=1;c<d;++c){if(a[c]<b)return c-1}else if(0>c)for(c=1;c<d;++c){if(a[c]<=b)return c}else for(c=1;c<d;++c){if(a[c]==b)return c;if(a[c]<b)return a[c-1]-b<b-a[c]?c-1:c}return d-1}function ga(a,b){var c,d=Array.isArray(b)?b:[b],e=d.length;for(c=0;c<e;c++)a[a.length]=d[c]}
	function ha(a,b){for(var c=a.length>>>0,d,e=0;e<c;e++)if(d=a[e],b(d,e,a))return d;return null}function ia(a,b){var c=a.length;if(c!==b.length)return!1;for(var d=0;d<c;d++)if(a[d]!==b[d])return!1;return!0}function ja(a){var b=ka,c=a.length,d=Array(a.length),e;for(e=0;e<c;e++)d[e]={index:e,value:a[e]};d.sort(function(a,c){return b(a.value,c.value)||a.index-c.index});for(e=0;e<a.length;e++)a[e]=d[e].value}function la(a,b){var c;return a.every(function(d,e){c=e;return!b(d,e,a)})?-1:c}
	function ma(a,b){var c=b||da;return a.every(function(b,e){if(!e)return!0;var d=c(a[e-1],b);return!(0<d||0===d)})};function u(a,b){a.prototype=Object.create(b.prototype);a.prototype.constructor=a}function na(){}function w(a){return a.ko||(a.ko=++oa)}var oa=0;function pa(a){this.message="Assertion failed. See https://openlayers.org/en/v4.0.1/doc/errors/#"+a+" for details.";this.code=a;this.name="AssertionError"}u(pa,Error);function qa(a,b){if(!a)throw new pa(b);};function sa(a,b,c,d){this.da=a;this.ba=b;this.fa=c;this.ja=d}function ta(a,b,c){return a.da<=b&&b<=a.ba&&a.fa<=c&&c<=a.ja}function ua(a,b){return a.da==b.da&&a.fa==b.fa&&a.ba==b.ba&&a.ja==b.ja}function va(a,b){return a.da<=b.ba&&a.ba>=b.da&&a.fa<=b.ja&&a.ja>=b.fa};function wa(a,b,c){return Math.min(Math.max(a,b),c)}var xa=function(){var a;"cosh"in Math?a=Math.cosh:a=function(a){a=Math.exp(a);return(a+1/a)/2};return a}();function ya(a){qa(0<a,29);return Math.pow(2,Math.ceil(Math.log(a)/Math.LN2))}function za(a,b,c,d,e,f){var g=e-c,h=f-d;if(g||h){var l=((a-c)*g+(b-d)*h)/(g*g+h*h);1<l?(c=e,d=f):0<l&&(c+=g*l,d+=h*l)}return Aa(a,b,c,d)}function Aa(a,b,c,d){a=c-a;b=d-b;return a*a+b*b}function Ba(a){return a*Math.PI/180}
	function Ca(a,b){var c=a%b;return 0>c*b?c+b:c}function Da(a,b,c){return a+c*(b-a)};function Ea(a,b,c){void 0===c&&(c=[0,0]);c[0]=a[0]+2*b;c[1]=a[1]+2*b;return c}function Fa(a,b,c){void 0===c&&(c=[0,0]);c[0]=a[0]*b+.5|0;c[1]=a[1]*b+.5|0;return c}function Ga(a,b){if(Array.isArray(a))return a;void 0===b?b=[a,a]:b[0]=b[1]=a;return b};function Ha(a){for(var b=Ia(),c=0,d=a.length;c<d;++c)Ja(b,a[c]);return b}function Ka(a,b,c){return c?(c[0]=a[0]-b,c[1]=a[1]-b,c[2]=a[2]+b,c[3]=a[3]+b,c):[a[0]-b,a[1]-b,a[2]+b,a[3]+b]}function Na(a,b){return b?(b[0]=a[0],b[1]=a[1],b[2]=a[2],b[3]=a[3],b):a.slice()}function Oa(a,b,c){b=b<a[0]?a[0]-b:a[2]<b?b-a[2]:0;a=c<a[1]?a[1]-c:a[3]<c?c-a[3]:0;return b*b+a*a}function Qa(a,b){return Sa(a,b[0],b[1])}function Ta(a,b){return a[0]<=b[0]&&b[2]<=a[2]&&a[1]<=b[1]&&b[3]<=a[3]}
	function Sa(a,b,c){return a[0]<=b&&b<=a[2]&&a[1]<=c&&c<=a[3]}function Ua(a,b){var c=a[1],d=a[2],e=a[3],f=b[0],g=b[1],h=0;f<a[0]?h|=16:f>d&&(h|=4);g<c?h|=8:g>e&&(h|=2);h||(h=1);return h}function Ia(){return[Infinity,Infinity,-Infinity,-Infinity]}function Va(a,b,c,d,e){return e?(e[0]=a,e[1]=b,e[2]=c,e[3]=d,e):[a,b,c,d]}function Wa(a,b){var c=a[0],d=a[1];return Va(c,d,c,d,b)}function Xa(a,b,c,d,e){e=Va(Infinity,Infinity,-Infinity,-Infinity,e);return Ya(e,a,b,c,d)}
	function Za(a,b){return a[0]==b[0]&&a[2]==b[2]&&a[1]==b[1]&&a[3]==b[3]}function $a(a,b){b[0]<a[0]&&(a[0]=b[0]);b[2]>a[2]&&(a[2]=b[2]);b[1]<a[1]&&(a[1]=b[1]);b[3]>a[3]&&(a[3]=b[3]);return a}function Ja(a,b){b[0]<a[0]&&(a[0]=b[0]);b[0]>a[2]&&(a[2]=b[0]);b[1]<a[1]&&(a[1]=b[1]);b[1]>a[3]&&(a[3]=b[1])}function Ya(a,b,c,d,e){for(;c<d;c+=e){var f=a,g=b[c],h=b[c+1];f[0]=Math.min(f[0],g);f[1]=Math.min(f[1],h);f[2]=Math.max(f[2],g);f[3]=Math.max(f[3],h)}return a}
	function ab(a,b,c){var d;return(d=b.call(c,bb(a)))||(d=b.call(c,cb(a)))||(d=b.call(c,db(a)))?d:(d=b.call(c,eb(a)))?d:!1}function fb(a){var b=0;gb(a)||(b=hb(a)*ib(a));return b}function bb(a){return[a[0],a[1]]}function cb(a){return[a[2],a[1]]}function jb(a){return[(a[0]+a[2])/2,(a[1]+a[3])/2]}
	function kb(a,b,c,d,e){var f=b*d[0]/2;d=b*d[1]/2;b=Math.cos(c);var g=Math.sin(c);c=f*b;f*=g;b*=d;var h=d*g,l=a[0],m=a[1];a=l-c+h;d=l-c-h;g=l+c-h;c=l+c+h;var h=m-f-b,l=m-f+b,p=m+f+b,f=m+f-b;return Va(Math.min(a,d,g,c),Math.min(h,l,p,f),Math.max(a,d,g,c),Math.max(h,l,p,f),e)}function ib(a){return a[3]-a[1]}function lb(a,b,c){c=c?c:Ia();mb(a,b)&&(c[0]=a[0]>b[0]?a[0]:b[0],c[1]=a[1]>b[1]?a[1]:b[1],c[2]=a[2]<b[2]?a[2]:b[2],c[3]=a[3]<b[3]?a[3]:b[3]);return c}function eb(a){return[a[0],a[3]]}
	function db(a){return[a[2],a[3]]}function hb(a){return a[2]-a[0]}function mb(a,b){return a[0]<=b[2]&&a[2]>=b[0]&&a[1]<=b[3]&&a[3]>=b[1]}function gb(a){return a[2]<a[0]||a[3]<a[1]}function nb(a,b){var c=(a[2]-a[0])/2*(b-1),d=(a[3]-a[1])/2*(b-1);a[0]-=c;a[2]+=c;a[1]-=d;a[3]+=d}
	function ob(a,b,c){a=[a[0],a[1],a[0],a[3],a[2],a[1],a[2],a[3]];b(a,a,2);var d=[a[0],a[2],a[4],a[6]],e=[a[1],a[3],a[5],a[7]];b=Math.min.apply(null,d);a=Math.min.apply(null,e);d=Math.max.apply(null,d);e=Math.max.apply(null,e);return Va(b,a,d,e,c)};var pb="function"===typeof Object.assign?Object.assign:function(a,b){if(!a||null===a)throw new TypeError("Cannot convert undefined or null to object");for(var c=Object(a),d=1,e=arguments.length;d<e;++d){var f=arguments[d];if(void 0!==f&&null!==f)for(var g in f)f.hasOwnProperty(g)&&(c[g]=f[g])}return c};function qb(a){for(var b in a)delete a[b]}function rb(a){var b=[],c;for(c in a)b.push(a[c]);return b}function sb(a){for(var b in a)return!1;return!b};/*
	
	 Latitude/longitude spherical geodesy formulae taken from
	 http://www.movable-type.co.uk/scripts/latlong.html
	 Licensed under CC-BY-3.0.
	*/
	function tb(a){this.radius=a}tb.prototype.a=function(a){for(var b=0,c=a.length,d=a[c-1][0],e=a[c-1][1],f=0;f<c;f++)var g=a[f][0],h=a[f][1],b=b+Ba(g-d)*(2+Math.sin(Ba(e))+Math.sin(Ba(h))),d=g,e=h;return b*this.radius*this.radius/2};tb.prototype.b=function(a,b){var c=Ba(a[1]),d=Ba(b[1]),e=(d-c)/2,f=Ba(b[0]-a[0])/2,c=Math.sin(e)*Math.sin(e)+Math.sin(f)*Math.sin(f)*Math.cos(c)*Math.cos(d);return 2*this.radius*Math.atan2(Math.sqrt(c),Math.sqrt(1-c))};
	tb.prototype.offset=function(a,b,c){var d=Ba(a[1]);b/=this.radius;var e=Math.asin(Math.sin(d)*Math.cos(b)+Math.cos(d)*Math.sin(b)*Math.cos(c));return[180*(Ba(a[0])+Math.atan2(Math.sin(c)*Math.sin(b)*Math.cos(d),Math.cos(b)-Math.sin(d)*Math.sin(e)))/Math.PI,180*e/Math.PI]};var ub=new tb(6370997);var vb={};vb.degrees=2*Math.PI*ub.radius/360;vb.ft=.3048;vb.m=1;vb["us-ft"]=1200/3937;var wb=null;function yb(a){this.nb=a.code;this.i=a.units;this.c=void 0!==a.extent?a.extent:null;this.g=void 0!==a.worldExtent?a.worldExtent:null;this.b=void 0!==a.axisOrientation?a.axisOrientation:"enu";this.f=void 0!==a.global?a.global:!1;this.a=!(!this.f||!this.c);this.j=a.getPointResolution;this.l=null;this.o=a.metersPerUnit;var b=a.code,c=wb||window.proj4;"function"==typeof c&&(b=c.defs(b),void 0!==b&&(void 0!==b.axis&&void 0===a.axisOrientation&&(this.b=b.axis),void 0===a.metersPerUnit&&(this.o=b.to_meter),
	void 0===a.units&&(this.i=b.units)))}k=yb.prototype;k.nk=function(){return this.nb};k.D=function(){return this.c};k.Jb=function(){return this.i};k.sc=function(){return this.o||vb[this.i]};k.Zk=function(){return this.g};k.Kl=function(){return this.f};k.pp=function(a){this.f=a;this.a=!(!a||!this.c)};k.ln=function(a){this.c=a;this.a=!(!this.f||!a)};k.xp=function(a){this.g=a};k.op=function(a){this.j=a};var zb={};var Ab={};function Bb(a,b,c){a=a.nb;b=b.nb;a in Ab||(Ab[a]={});Ab[a][b]=c}function Db(a,b){var c;a in Ab&&b in Ab[a]&&(c=Ab[a][b]);return c};function Eb(a,b,c){var d=a.j;d?b=d(b,c):"degrees"!=a.Jb()&&(d=Fb(a,Gb("EPSG:4326")),b=[c[0]-b/2,c[1],c[0]+b/2,c[1],c[0],c[1]-b/2,c[0],c[1]+b/2],b=d(b,b,2),b=(ub.b(b.slice(0,2),b.slice(2,4))+ub.b(b.slice(4,6),b.slice(6,8)))/2,a=a.sc(),void 0!==a&&(b/=a));return b}function Hb(a){Ib(a);a.forEach(function(b){a.forEach(function(a){b!==a&&Bb(b,a,Jb)})})}function Kb(){var a=Lb,b=Mb,c=Nb;Ob.forEach(function(d){a.forEach(function(a){Bb(d,a,b);Bb(a,d,c)})})}function Pb(a){zb[a.nb]=a;Bb(a,a,Jb)}
	function Ib(a){var b=[];a.forEach(function(a){b.push(Pb(a))})}function Qb(a){return a?"string"===typeof a?Gb(a):a:Gb("EPSG:3857")}function Rb(a,b,c,d){a=Gb(a);b=Gb(b);Bb(a,b,Sb(c));Bb(b,a,Sb(d))}function Sb(a){return function(b,c,d){var e=b.length;d=void 0!==d?d:2;c=void 0!==c?c:Array(e);var f,g;for(g=0;g<e;g+=d)for(f=a([b[g],b[g+1]]),c[g]=f[0],c[g+1]=f[1],f=d-1;2<=f;--f)c[g+f]=b[g+f];return c}}
	function Gb(a){var b=null;if(a instanceof yb)b=a;else if("string"===typeof a){var b=zb[a]||null,c=wb||window.proj4;b||"function"!=typeof c||void 0===c.defs(a)||(b=new yb({code:a}),Pb(b))}return b}function Tb(a,b){if(a===b)return!0;var c=a.Jb()===b.Jb();return a.nb===b.nb?c:Fb(a,b)===Jb&&c}function Ub(a,b){var c=Gb(a),d=Gb(b);return Fb(c,d)}
	function Fb(a,b){var c=a.nb,d=b.nb,e=Db(c,d);if(!e){var f=wb||window.proj4;if("function"==typeof f){var g=f.defs(c),h=f.defs(d);void 0!==g&&void 0!==h&&(g===h?Hb([b,a]):(e=f(d,c),Rb(b,a,e.forward,e.inverse)),e=Db(c,d))}}e||(e=Vb);return e}function Vb(a,b){if(void 0!==b&&a!==b){for(var c=0,d=a.length;c<d;++c)b[c]=a[c];a=b}return a}function Jb(a,b){var c;if(void 0!==b){c=0;for(var d=a.length;c<d;++c)b[c]=a[c];c=b}else c=a.slice();return c}function Wb(a,b,c){return Ub(b,c)(a,void 0,a.length)}
	function Xb(a,b,c){b=Ub(b,c);return ob(a,b)};function Yb(a,b,c,d){return void 0!==d?(d[0]=a,d[1]=b,d[2]=c,d):[a,b,c]}function Zb(a){var b=a[0],c=Array(b),d=1<<b-1,e,f;for(e=0;e<b;++e)f=48,a[1]&d&&(f+=1),a[2]&d&&(f+=2),c[e]=String.fromCharCode(f),d>>=1;return c.join("")};function $b(a){this.minZoom=void 0!==a.minZoom?a.minZoom:0;this.b=a.resolutions;qa(ma(this.b,function(a,b){return b-a}),17);this.maxZoom=this.b.length-1;this.f=void 0!==a.origin?a.origin:null;this.c=null;void 0!==a.origins&&(this.c=a.origins,qa(this.c.length==this.b.length,20));var b=a.extent;void 0===b||this.f||this.c||(this.f=eb(b));qa(!this.f&&this.c||this.f&&!this.c,18);this.i=null;void 0!==a.tileSizes&&(this.i=a.tileSizes,qa(this.i.length==this.b.length,19));this.g=void 0!==a.tileSize?a.tileSize:
	this.i?null:256;qa(!this.g&&this.i||this.g&&!this.i,22);this.v=void 0!==b?b:null;this.a=null;this.l=[0,0];void 0!==a.sizes?this.a=a.sizes.map(function(a){return new sa(Math.min(0,a[0]),Math.max(a[0]-1,-1),Math.min(0,a[1]),Math.max(a[1]-1,-1))},this):b&&ac(this,b)}var bc=[0,0,0];k=$b.prototype;k.eh=function(a,b,c){a=cc(this,a,b);for(var d=a.da,e=a.ba;d<=e;++d)for(var f=a.fa,g=a.ja;f<=g;++f)c([b,d,f])};
	function ec(a,b,c,d,e){e=a.Ta(b,e);for(b=b[0]-1;b>=a.minZoom;){if(c.call(null,b,cc(a,e,b,d)))return!0;--b}return!1}k.D=function(){return this.v};k.oh=function(){return this.maxZoom};k.ph=function(){return this.minZoom};k.Qc=function(a){return this.f?this.f:this.c[a]};k.La=function(a){return this.b[a]};k.oi=function(){return this.b};function fc(a,b,c,d){return b[0]<a.maxZoom?(d=a.Ta(b,d),cc(a,d,b[0]+1,c)):null}
	function gc(a,b,c,d){hc(a,b[0],b[1],c,!1,bc);var e=bc[1],f=bc[2];hc(a,b[2],b[3],c,!0,bc);a=bc[1];b=bc[2];void 0!==d?(d.da=e,d.ba=a,d.fa=f,d.ja=b):d=new sa(e,a,f,b);return d}function cc(a,b,c,d){return gc(a,b,a.La(c),d)}function ic(a,b){var c=a.Qc(b[0]),d=a.La(b[0]),e=Ga(a.fb(b[0]),a.l);return[c[0]+(b[1]+.5)*e[0]*d,c[1]+(b[2]+.5)*e[1]*d]}k.Ta=function(a,b){var c=this.Qc(a[0]),d=this.La(a[0]),e=Ga(this.fb(a[0]),this.l),f=c[0]+a[1]*e[0]*d,c=c[1]+a[2]*e[1]*d;return Va(f,c,f+e[0]*d,c+e[1]*d,b)};
	k.we=function(a,b,c){return hc(this,a[0],a[1],b,!1,c)};function hc(a,b,c,d,e,f){var g=a.Mc(d),h=d/a.La(g),l=a.Qc(g);a=Ga(a.fb(g),a.l);b=h*Math.floor((b-l[0])/d+(e?.5:0))/a[0];c=h*Math.floor((c-l[1])/d+(e?0:.5))/a[1];e?(b=Math.ceil(b)-1,c=Math.ceil(c)-1):(b=Math.floor(b),c=Math.floor(c));return Yb(g,b,c,f)}k.Pf=function(a,b,c){return hc(this,a[0],a[1],this.La(b),!1,c)};k.fb=function(a){return this.g?this.g:this.i[a]};k.Mc=function(a,b){return wa(fa(this.b,a,b||0),this.minZoom,this.maxZoom)};
	function ac(a,b){for(var c=a.b.length,d=Array(c),e=a.minZoom;e<c;++e)d[e]=cc(a,b,e);a.a=d};function jc(a){var b=a.l;if(!b){var b=kc(a),c=lc(b,void 0,void 0),b=new $b({extent:b,origin:eb(b),resolutions:c,tileSize:void 0});a.l=b}return b}function mc(a){var b={};pb(b,a?a:{});void 0===b.extent&&(b.extent=Gb("EPSG:3857").D());b.resolutions=lc(b.extent,b.maxZoom,b.tileSize);delete b.maxZoom;return new $b(b)}function lc(a,b,c){b=void 0!==b?b:42;var d=ib(a);a=hb(a);c=Ga(void 0!==c?c:256);c=Math.max(a/c[0],d/c[1]);b+=1;d=Array(b);for(a=0;a<b;++a)d[a]=c/Math.pow(2,a);return d}
	function kc(a){a=Gb(a);var b=a.D();b||(a=180*vb.degrees/a.sc(),b=Va(-a,-a,a,a));return b};function nc(a){this.b=a.html;this.a=a.tileRanges?a.tileRanges:null}nc.prototype.f=function(){return this.b};function oc(a){return function(b){if(b)return[wa(b[0],a[0],a[2]),wa(b[1],a[1],a[3])]}}function pc(a){return a};function qc(a){function b(b){var c=a.listener,e=a.Vg||a.target;a.Xg&&rc(a);return c.call(e,b)}return a.Wg=b}function sc(a,b,c,d){for(var e,f=0,g=a.length;f<g;++f)if(e=a[f],e.listener===b&&e.Vg===c)return d&&(e.deleteIndex=f),e}function tc(a,b){var c=a.eb;return c?c[b]:void 0}function uc(a){var b=a.eb;b||(b=a.eb={});return b}
	function vc(a,b){var c=tc(a,b);if(c){for(var d=0,e=c.length;d<e;++d)a.removeEventListener(b,c[d].Wg),qb(c[d]);c.length=0;if(c=a.eb)delete c[b],Object.keys(c).length||delete a.eb}}function B(a,b,c,d,e){var f=uc(a),g=f[b];g||(g=f[b]=[]);(f=sc(g,c,d,!1))?e||(f.Xg=!1):(f={Vg:d,Xg:!!e,listener:c,target:a,type:b},a.addEventListener(b,qc(f)),g.push(f));return f}function wc(a,b,c,d){return B(a,b,c,d,!0)}function xc(a,b,c,d){(a=tc(a,b))&&(c=sc(a,c,d,!0))&&rc(c)}
	function rc(a){if(a&&a.target){a.target.removeEventListener(a.type,a.Wg);var b=tc(a.target,a.type);if(b){var c="deleteIndex"in a?a.deleteIndex:b.indexOf(a);-1!==c&&b.splice(c,1);b.length||vc(a.target,a.type)}qb(a)}}function yc(a){var b=uc(a),c;for(c in b)vc(a,c)};function zc(){}zc.prototype.Zb=!1;function Ac(a){a.Zb||(a.Zb=!0,a.ra())}zc.prototype.ra=na;function Bc(a){this.type=a;this.target=null}Bc.prototype.preventDefault=Bc.prototype.stopPropagation=function(){this.Fo=!0};function Cc(a){a.stopPropagation()};function Dc(){this.$a={};this.ta={};this.qa={}}u(Dc,zc);Dc.prototype.addEventListener=function(a,b){var c=this.qa[a];c||(c=this.qa[a]=[]);-1===c.indexOf(b)&&c.push(b)};
	Dc.prototype.b=function(a){var b="string"===typeof a?new Bc(a):a;a=b.type;b.target=this;var c=this.qa[a],d;if(c){a in this.ta||(this.ta[a]=0,this.$a[a]=0);++this.ta[a];for(var e=0,f=c.length;e<f;++e)if(!1===c[e].call(this,b)||b.Fo){d=!1;break}--this.ta[a];if(!this.ta[a]){b=this.$a[a];for(delete this.$a[a];b--;)this.removeEventListener(a,na);delete this.ta[a]}return d}};Dc.prototype.ra=function(){yc(this)};function Ec(a,b){return b?b in a.qa:0<Object.keys(a.qa).length}
	Dc.prototype.removeEventListener=function(a,b){var c=this.qa[a];if(c){var d=c.indexOf(b);a in this.$a?(c[d]=na,++this.$a[a]):(c.splice(d,1),c.length||delete this.qa[a])}};function Fc(){Dc.call(this);this.f=0}u(Fc,Dc);k=Fc.prototype;k.s=function(){++this.f;this.b("change")};k.L=function(){return this.f};k.J=function(a,b,c){if(Array.isArray(a)){for(var d=a.length,e=Array(d),f=0;f<d;++f)e[f]=B(this,a[f],b,c);return e}return B(this,a,b,c)};k.once=function(a,b,c){if(Array.isArray(a)){for(var d=a.length,e=Array(d),f=0;f<d;++f)e[f]=wc(this,a[f],b,c);return e}return wc(this,a,b,c)};
	k.K=function(a,b,c){if(Array.isArray(a))for(var d=0,e=a.length;d<e;++d)xc(this,a[d],b,c);else xc(this,a,b,c)};function Gc(a){Fc.call(this);w(this);this.I={};void 0!==a&&this.H(a)}u(Gc,Fc);var Hc={};function Ic(a){return Hc.hasOwnProperty(a)?Hc[a]:Hc[a]="change:"+a}k=Gc.prototype;k.get=function(a){var b;this.I.hasOwnProperty(a)&&(b=this.I[a]);return b};k.O=function(){return Object.keys(this.I)};k.N=function(){return pb({},this.I)};function Jc(a,b,c){var d;d=Ic(b);a.b(new Kc(d,b,c));a.b(new Kc("propertychange",b,c))}k.set=function(a,b,c){c?this.I[a]=b:(c=this.I[a],this.I[a]=b,c!==b&&Jc(this,a,c))};
	k.H=function(a,b){for(var c in a)this.set(c,a[c],b)};k.P=function(a,b){if(a in this.I){var c=this.I[a];delete this.I[a];b||Jc(this,a,c)}};function Kc(a,b,c){Bc.call(this,a);this.key=b;this.oldValue=c}u(Kc,Bc);function D(a){Gc.call(this);this.a=a?a:[];Lc(this)}u(D,Gc);k=D.prototype;k.clear=function(){for(;0<this.ec();)this.pop()};k.Tf=function(a){var b,c;b=0;for(c=a.length;b<c;++b)this.push(a[b]);return this};k.forEach=function(a,b){this.a.forEach(a,b)};k.am=function(){return this.a};k.item=function(a){return this.a[a]};k.ec=function(){return this.get(Mc)};k.Be=function(a,b){this.a.splice(a,0,b);Lc(this);this.b(new Nc("add",b))};k.pop=function(){return this.tg(this.ec()-1)};
	k.push=function(a){var b=this.ec();this.Be(b,a);return this.ec()};k.remove=function(a){var b=this.a,c,d;c=0;for(d=b.length;c<d;++c)if(b[c]===a)return this.tg(c)};k.tg=function(a){var b=this.a[a];this.a.splice(a,1);Lc(this);this.b(new Nc("remove",b));return b};k.mp=function(a,b){var c=this.ec();if(a<c)c=this.a[a],this.a[a]=b,this.b(new Nc("remove",c)),this.b(new Nc("add",b));else{for(;c<a;++c)this.Be(c,void 0);this.Be(a,b)}};function Lc(a){a.set(Mc,a.a.length)}var Mc="length";
	function Nc(a,b){Bc.call(this,a);this.element=b}u(Nc,Bc);var Oc=/^#(?:[0-9a-f]{3}){1,2}$/i,Pc=/^([a-z]*)$/i;function Qc(a){return Array.isArray(a)?a:Rc(a)}function Sc(a){if("string"!==typeof a){var b=a[0];b!=(b|0)&&(b=b+.5|0);var c=a[1];c!=(c|0)&&(c=c+.5|0);var d=a[2];d!=(d|0)&&(d=d+.5|0);a="rgba("+b+","+c+","+d+","+(void 0===a[3]?1:a[3])+")"}return a}
	var Rc=function(){var a={},b=0;return function(c){var d;if(a.hasOwnProperty(c))d=a[c];else{if(1024<=b){d=0;for(var e in a)d++&3||(delete a[e],--b)}d=c;var f;Pc.exec(d)&&(e=document.createElement("div"),e.style.color=d,document.body.appendChild(e),d=getComputedStyle(e).color,document.body.removeChild(e));if(Oc.exec(d)){f=d.length-1;qa(3==f||6==f,54);var g=3==f?1:2;f=parseInt(d.substr(1+0*g,g),16);e=parseInt(d.substr(1+1*g,g),16);d=parseInt(d.substr(1+2*g,g),16);1==g&&(f=(f<<4)+f,e=(e<<4)+e,d=(d<<4)+
	d);f=[f,e,d,1]}else d.indexOf("rgba(")?d.indexOf("rgb(")?qa(!1,14):(d=d.slice(4,-1).split(",").map(Number),d.push(1),f=Uc(d)):(d=d.slice(5,-1).split(",").map(Number),f=Uc(d));d=f;a[c]=d;++b}return d}}();function Uc(a){var b=[];b[0]=wa(a[0]+.5|0,0,255);b[1]=wa(a[1]+.5|0,0,255);b[2]=wa(a[2]+.5|0,0,255);b[3]=wa(a[3],0,1);return b};function Vc(a){return"string"===typeof a||a instanceof CanvasPattern||a instanceof CanvasGradient?a:Sc(a)};function Wc(a,b,c){this.center=a;this.resolution=b;this.rotation=c};function Xc(a,b){var c=document.createElement("CANVAS");a&&(c.width=a);b&&(c.height=b);return c.getContext("2d")}function Yc(a,b){var c=b.parentNode;c&&c.replaceChild(a,b)}function Zc(a){a&&a.parentNode&&a.parentNode.removeChild(a)};function ad(a){Gc.call(this);this.element=a.element?a.element:null;this.a=this.S=null;this.v=[];this.render=a.render?a.render:na;a.target&&this.i(a.target)}u(ad,Gc);ad.prototype.ra=function(){Zc(this.element);Gc.prototype.ra.call(this)};ad.prototype.g=function(){return this.a};
	ad.prototype.setMap=function(a){this.a&&Zc(this.element);for(var b=0,c=this.v.length;b<c;++b)rc(this.v[b]);this.v.length=0;if(this.a=a)(this.S?this.S:a.u).appendChild(this.element),this.render!==na&&this.v.push(B(a,"postrender",this.render,this)),a.render()};ad.prototype.i=function(a){this.S="string"===typeof a?document.getElementById(a):a};function bd(a){a=a?a:{};this.R=document.createElement("UL");this.u=document.createElement("LI");this.R.appendChild(this.u);this.u.style.display="none";this.c=void 0!==a.collapsed?a.collapsed:!0;this.j=void 0!==a.collapsible?a.collapsible:!0;this.j||(this.c=!1);var b=void 0!==a.className?a.className:"ol-attribution",c=void 0!==a.tipLabel?a.tipLabel:"Attributions",d=void 0!==a.collapseLabel?a.collapseLabel:"\u00bb";"string"===typeof d?(this.A=document.createElement("span"),this.A.textContent=d):this.A=
	d;d=void 0!==a.label?a.label:"i";"string"===typeof d?(this.C=document.createElement("span"),this.C.textContent=d):this.C=d;var e=this.j&&!this.c?this.A:this.C,d=document.createElement("button");d.setAttribute("type","button");d.title=c;d.appendChild(e);B(d,"click",this.ym,this);c=document.createElement("div");c.className=b+" ol-unselectable ol-control"+(this.c&&this.j?" ol-collapsed":"")+(this.j?"":" ol-uncollapsible");c.appendChild(this.R);c.appendChild(d);ad.call(this,{element:c,render:a.render?
	a.render:cd,target:a.target});this.G=!0;this.o={};this.l={};this.Y={}}u(bd,ad);
	function cd(a){if(a=a.frameState){var b,c,d,e,f,g,h,l,m,p,n,q=a.layerStatesArray,r=pb({},a.attributions),v={},x={},y=a.viewState.projection;c=0;for(b=q.length;c<b;c++)if(g=q[c].layer.la())if(p=w(g).toString(),m=g.l)for(d=0,e=m.length;d<e;d++)if(h=m[d],l=w(h).toString(),!(l in r)){if(f=a.usedTiles[p]){var z=g.Ib(y);a:{n=void 0;var A,V,Pa=h,ra=z,La=y;if(Pa.a){for(n in f)if(n in Pa.a){var z=f[n],C;V=0;for(A=Pa.a[n].length;V<A;++V){C=Pa.a[n][V];if(va(C,z)){n=!0;break a}var Ma=cc(ra,kc(La),parseInt(n,
	10)),xb=Ma.ba-Ma.da+1;if(z.da<Ma.da||z.ba>Ma.ba)if(va(C,new sa(Ca(z.da,xb),Ca(z.ba,xb),z.fa,z.ja))||z.ba-z.da+1>xb&&va(C,Ma)){n=!0;break a}}}n=!1}else n=!0}}else n=!1;n?(l in v&&delete v[l],n=h.b,n in x||(x[n]=!0,r[l]=h)):v[l]=h}b=[r,v];c=b[0];b=b[1];for(var Z in this.o)Z in c?(this.l[Z]||(this.o[Z].style.display="",this.l[Z]=!0),delete c[Z]):Z in b?(this.l[Z]&&(this.o[Z].style.display="none",delete this.l[Z]),delete b[Z]):(Zc(this.o[Z]),delete this.o[Z],delete this.l[Z]);for(Z in c)d=document.createElement("LI"),
	d.innerHTML=c[Z].b,this.R.appendChild(d),this.o[Z]=d,this.l[Z]=!0;for(Z in b)d=document.createElement("LI"),d.innerHTML=b[Z].b,d.style.display="none",this.R.appendChild(d),this.o[Z]=d;Z=!sb(this.l)||!sb(a.logos);this.G!=Z&&(this.element.style.display=Z?"":"none",this.G=Z);Z&&sb(this.l)?this.element.classList.add("ol-logo-only"):this.element.classList.remove("ol-logo-only");var Ra;a=a.logos;Z=this.Y;for(Ra in Z)Ra in a||(Zc(Z[Ra]),delete Z[Ra]);for(var Cb in a)b=a[Cb],b instanceof HTMLElement&&(this.u.appendChild(b),
	Z[Cb]=b),Cb in Z||(Ra=new Image,Ra.src=Cb,""===b?c=Ra:(c=document.createElement("a"),c.href=b,c.appendChild(Ra)),this.u.appendChild(c),Z[Cb]=c);this.u.style.display=sb(a)?"none":""}else this.G&&(this.element.style.display="none",this.G=!1)}k=bd.prototype;k.ym=function(a){a.preventDefault();dd(this)};function dd(a){a.element.classList.toggle("ol-collapsed");a.c?Yc(a.A,a.C):Yc(a.C,a.A);a.c=!a.c}k.xm=function(){return this.j};
	k.Am=function(a){this.j!==a&&(this.j=a,this.element.classList.toggle("ol-uncollapsible"),!a&&this.c&&dd(this))};k.zm=function(a){this.j&&this.c!==a&&dd(this)};k.wm=function(){return this.c};function ed(a){return Math.pow(a,3)}function fd(a){return 1-ed(1-a)}function gd(a){return 3*a*a-2*a*a*a}function hd(a){return a};function id(a){a=a?a:{};var b=void 0!==a.className?a.className:"ol-rotate",c=void 0!==a.label?a.label:"\u21e7";this.c=null;"string"===typeof c?(this.c=document.createElement("span"),this.c.className="ol-compass",this.c.textContent=c):(this.c=c,this.c.classList.add("ol-compass"));var d=a.tipLabel?a.tipLabel:"Reset rotation",c=document.createElement("button");c.className=b+"-reset";c.setAttribute("type","button");c.title=d;c.appendChild(this.c);B(c,"click",id.prototype.A,this);d=document.createElement("div");
	d.className=b+" ol-unselectable ol-control";d.appendChild(c);b=a.render?a.render:jd;this.j=a.resetNorth?a.resetNorth:void 0;ad.call(this,{element:d,render:b,target:a.target});this.o=void 0!==a.duration?a.duration:250;this.l=void 0!==a.autoHide?a.autoHide:!0;this.u=void 0;this.l&&this.element.classList.add("ol-hidden")}u(id,ad);
	id.prototype.A=function(a){a.preventDefault();if(this.j)this.j();else if(a=this.a.$()){var b=a.Va();void 0!==b&&(0<this.o?(b%=2*Math.PI,a.animate({rotation:0,duration:this.o,easing:fd})):a.He(0))}};
	function jd(a){if(a=a.frameState){a=a.viewState.rotation;if(a!=this.u){var b="rotate("+a+"rad)";if(this.l){var c=this.element.classList.contains("ol-hidden");c||a?c&&a&&this.element.classList.remove("ol-hidden"):this.element.classList.add("ol-hidden")}this.c.style.msTransform=b;this.c.style.webkitTransform=b;this.c.style.transform=b}this.u=a}};function kd(a){a=a?a:{};var b=void 0!==a.className?a.className:"ol-zoom",c=void 0!==a.delta?a.delta:1,d=void 0!==a.zoomInLabel?a.zoomInLabel:"+",e=void 0!==a.zoomOutLabel?a.zoomOutLabel:"\u2212",f=void 0!==a.zoomInTipLabel?a.zoomInTipLabel:"Zoom in",g=void 0!==a.zoomOutTipLabel?a.zoomOutTipLabel:"Zoom out",h=document.createElement("button");h.className=b+"-in";h.setAttribute("type","button");h.title=f;h.appendChild("string"===typeof d?document.createTextNode(d):d);B(h,"click",kd.prototype.l.bind(this,
	c));d=document.createElement("button");d.className=b+"-out";d.setAttribute("type","button");d.title=g;d.appendChild("string"===typeof e?document.createTextNode(e):e);B(d,"click",kd.prototype.l.bind(this,-c));c=document.createElement("div");c.className=b+" ol-unselectable ol-control";c.appendChild(h);c.appendChild(d);ad.call(this,{element:c,target:a.target});this.c=void 0!==a.duration?a.duration:250}u(kd,ad);
	kd.prototype.l=function(a,b){b.preventDefault();var c=this.a.$();if(c){var d=c.Ua();d&&(d=c.constrainResolution(d,a),0<this.c?(0<ld(c)[0]&&md(c),c.animate({resolution:d,duration:this.c,easing:fd})):c.Xc(d))}};function nd(a){a=a?a:{};var b=new D;(void 0!==a.zoom?a.zoom:1)&&b.push(new kd(a.zoomOptions));(void 0!==a.rotate?a.rotate:1)&&b.push(new id(a.rotateOptions));(void 0!==a.attribution?a.attribution:1)&&b.push(new bd(a.attributionOptions));return b};function od(a){a=a?a:{};this.c=void 0!==a.className?a.className:"ol-full-screen";var b=void 0!==a.label?a.label:"\u2922";this.j="string"===typeof b?document.createTextNode(b):b;b=void 0!==a.labelActive?a.labelActive:"\u00d7";this.o="string"===typeof b?document.createTextNode(b):b;var c=a.tipLabel?a.tipLabel:"Toggle full-screen",b=document.createElement("button");b.className=this.c+"-"+pd();b.setAttribute("type","button");b.title=c;b.appendChild(this.j);B(b,"click",this.C,this);c=document.createElement("div");
	c.className=this.c+" ol-unselectable ol-control "+(qd()?"":"ol-unsupported");c.appendChild(b);ad.call(this,{element:c,target:a.target});this.A=void 0!==a.keys?a.keys:!1;this.l=a.source}u(od,ad);
	od.prototype.C=function(a){a.preventDefault();qd()&&(a=this.a)&&(pd()?document.exitFullscreen?document.exitFullscreen():document.msExitFullscreen?document.msExitFullscreen():document.mozCancelFullScreen?document.mozCancelFullScreen():document.webkitExitFullscreen&&document.webkitExitFullscreen():(a=this.l?"string"===typeof this.l?document.getElementById(this.l):this.l:a.Kc(),this.A?a.mozRequestFullScreenWithKeys?a.mozRequestFullScreenWithKeys():a.webkitRequestFullscreen?a.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT):
	rd(a):rd(a)))};od.prototype.u=function(){var a=this.element.firstElementChild,b=this.a;pd()?(a.className=this.c+"-true",Yc(this.o,this.j)):(a.className=this.c+"-false",Yc(this.j,this.o));b&&b.xd()};od.prototype.setMap=function(a){ad.prototype.setMap.call(this,a);a&&this.v.push(B(document,sd(),this.u,this))};
	function qd(){var a=document.body;return!!(a.webkitRequestFullscreen||a.mozRequestFullScreen&&document.mozFullScreenEnabled||a.msRequestFullscreen&&document.msFullscreenEnabled||a.requestFullscreen&&document.fullscreenEnabled)}function pd(){return!!(document.webkitIsFullScreen||document.mozFullScreen||document.msFullscreenElement||document.fullscreenElement)}
	function rd(a){a.requestFullscreen?a.requestFullscreen():a.msRequestFullscreen?a.msRequestFullscreen():a.mozRequestFullScreen?a.mozRequestFullScreen():a.webkitRequestFullscreen&&a.webkitRequestFullscreen()}var sd=function(){var a;return function(){if(!a){var b=document.body;b.webkitRequestFullscreen?a="webkitfullscreenchange":b.mozRequestFullScreen?a="mozfullscreenchange":b.msRequestFullscreen?a="MSFullscreenChange":b.requestFullscreen&&(a="fullscreenchange")}return a}}();function td(a){a=a?a:{};var b=document.createElement("DIV");b.className=void 0!==a.className?a.className:"ol-mouse-position";ad.call(this,{element:b,render:a.render?a.render:ud,target:a.target});B(this,Ic(vd),this.Bm,this);a.coordinateFormat&&this.Fi(a.coordinateFormat);a.projection&&this.Mh(Gb(a.projection));this.u=void 0!==a.undefinedHTML?a.undefinedHTML:"";this.o=b.innerHTML;this.j=this.l=this.c=null}u(td,ad);
	function ud(a){a=a.frameState;a?this.c!=a.viewState.projection&&(this.c=a.viewState.projection,this.l=null):this.c=null;wd(this,this.j)}k=td.prototype;k.Bm=function(){this.l=null};k.ih=function(){return this.get(xd)};k.Lh=function(){return this.get(vd)};k.rl=function(a){this.j=this.a.te(a);wd(this,this.j)};k.sl=function(){wd(this,null);this.j=null};k.setMap=function(a){ad.prototype.setMap.call(this,a);a&&(a=a.c,this.v.push(B(a,"mousemove",this.rl,this),B(a,"mouseout",this.sl,this)))};
	k.Fi=function(a){this.set(xd,a)};k.Mh=function(a){this.set(vd,a)};function wd(a,b){var c=a.u;if(b&&a.c){if(!a.l){var d=a.Lh();a.l=d?Fb(a.c,d):Vb}if(d=a.a.Za(b))a.l(d,d),c=(c=a.ih())?c(d):d.toString()}a.o&&c==a.o||(a.element.innerHTML=c,a.o=c)}var vd="projection",xd="coordinateFormat";function yd(a,b,c){Bc.call(this,a);this.map=b;this.frameState=void 0!==c?c:null}u(yd,Bc);function zd(a,b,c,d,e){yd.call(this,a,b,e);this.originalEvent=c;this.pixel=b.te(c);this.coordinate=b.Za(this.pixel);this.dragging=void 0!==d?d:!1}u(zd,yd);zd.prototype.preventDefault=function(){yd.prototype.preventDefault.call(this);this.originalEvent.preventDefault()};zd.prototype.stopPropagation=function(){yd.prototype.stopPropagation.call(this);this.originalEvent.stopPropagation()};var Ad={Xp:"singleclick",Mp:"click",Np:"dblclick",Qp:"pointerdrag",Tp:"pointermove",Pp:"pointerdown",Wp:"pointerup",Vp:"pointerover",Up:"pointerout",Rp:"pointerenter",Sp:"pointerleave",Op:"pointercancel"};function Bd(a,b,c,d,e){zd.call(this,a,b,c.b,d,e);this.b=c}u(Bd,zd);var Cd=["experimental-webgl","webgl","webkit-3d","moz-webgl"];function Dd(a,b){var c,d,e=Cd.length;for(d=0;d<e;++d)try{if(c=a.getContext(Cd[d],b))return c}catch(f){}return null};var Ed,Fd="undefined"!==typeof navigator?navigator.userAgent.toLowerCase():"",Gd=-1!==Fd.indexOf("firefox"),Hd=-1!==Fd.indexOf("safari")&&-1==Fd.indexOf("chrom"),Id=-1!==Fd.indexOf("webkit")&&-1==Fd.indexOf("edge"),Jd=-1!==Fd.indexOf("macintosh"),Kd=window.devicePixelRatio||1,Ld=!1,Md=function(){if(!("HTMLCanvasElement"in window))return!1;try{var a=document.createElement("CANVAS").getContext("2d");return a?(void 0!==a.setLineDash&&(Ld=!0),!0):!1}catch(b){return!1}}(),Nd="DeviceOrientationEvent"in
	window,Od="geolocation"in navigator,Pd="ontouchstart"in window,Qd="PointerEvent"in window,Rd=!!navigator.msPointerEnabled,Sd=!1,Td,Ud=[];if("WebGLRenderingContext"in window)try{var Vd=Dd(document.createElement("CANVAS"),{failIfMajorPerformanceCaveat:!0});Vd&&(Sd=!0,Td=Vd.getParameter(Vd.MAX_TEXTURE_SIZE),Ud=Vd.getSupportedExtensions())}catch(a){}Ed=Sd;ca=Ud;ba=Td;function Wd(a,b){this.b=a;this.i=b};function Xd(a){Wd.call(this,a,{mousedown:this.Ml,mousemove:this.Nl,mouseup:this.Ql,mouseover:this.Pl,mouseout:this.Ol});this.a=a.f;this.f=[]}u(Xd,Wd);function Yd(a,b){for(var c=a.f,d=b.clientX,e=b.clientY,f=0,g=c.length,h;f<g&&(h=c[f]);f++){var l=Math.abs(e-h[1]);if(25>=Math.abs(d-h[0])&&25>=l)return!0}return!1}function Zd(a){var b=ae(a,a),c=b.preventDefault;b.preventDefault=function(){a.preventDefault();c()};b.pointerId=1;b.isPrimary=!0;b.pointerType="mouse";return b}k=Xd.prototype;
	k.Ml=function(a){if(!Yd(this,a)){(1).toString()in this.a&&this.cancel(a);var b=Zd(a);this.a[(1).toString()]=a;be(this.b,"pointerdown",b,a)}};k.Nl=function(a){if(!Yd(this,a)){var b=Zd(a);be(this.b,"pointermove",b,a)}};k.Ql=function(a){if(!Yd(this,a)){var b=this.a[(1).toString()];b&&b.button===a.button&&(b=Zd(a),be(this.b,"pointerup",b,a),delete this.a[(1).toString()])}};k.Pl=function(a){if(!Yd(this,a)){var b=Zd(a);ce(this.b,b,a)}};k.Ol=function(a){if(!Yd(this,a)){var b=Zd(a);de(this.b,b,a)}};
	k.cancel=function(a){var b=Zd(a);this.b.cancel(b,a);delete this.a[(1).toString()]};function ee(a){Wd.call(this,a,{MSPointerDown:this.Vl,MSPointerMove:this.Wl,MSPointerUp:this.Zl,MSPointerOut:this.Xl,MSPointerOver:this.Yl,MSPointerCancel:this.Ul,MSGotPointerCapture:this.Sl,MSLostPointerCapture:this.Tl});this.a=a.f;this.f=["","unavailable","touch","pen","mouse"]}u(ee,Wd);function fe(a,b){var c=b;"number"===typeof b.pointerType&&(c=ae(b,b),c.pointerType=a.f[b.pointerType]);return c}k=ee.prototype;
	k.Vl=function(a){this.a[a.pointerId.toString()]=a;var b=fe(this,a);be(this.b,"pointerdown",b,a)};k.Wl=function(a){var b=fe(this,a);be(this.b,"pointermove",b,a)};k.Zl=function(a){var b=fe(this,a);be(this.b,"pointerup",b,a);delete this.a[a.pointerId.toString()]};k.Xl=function(a){var b=fe(this,a);de(this.b,b,a)};k.Yl=function(a){var b=fe(this,a);ce(this.b,b,a)};k.Ul=function(a){var b=fe(this,a);this.b.cancel(b,a);delete this.a[a.pointerId.toString()]};
	k.Tl=function(a){this.b.b(new ge("lostpointercapture",a,a))};k.Sl=function(a){this.b.b(new ge("gotpointercapture",a,a))};function he(a){Wd.call(this,a,{pointerdown:this.xo,pointermove:this.yo,pointerup:this.Bo,pointerout:this.zo,pointerover:this.Ao,pointercancel:this.wo,gotpointercapture:this.al,lostpointercapture:this.Ll})}u(he,Wd);k=he.prototype;k.xo=function(a){ie(this.b,a)};k.yo=function(a){ie(this.b,a)};k.Bo=function(a){ie(this.b,a)};k.zo=function(a){ie(this.b,a)};k.Ao=function(a){ie(this.b,a)};k.wo=function(a){ie(this.b,a)};k.Ll=function(a){ie(this.b,a)};k.al=function(a){ie(this.b,a)};function ge(a,b,c){Bc.call(this,a);this.b=b;a=c?c:{};this.buttons=je(a);this.pressure=ke(a,this.buttons);this.bubbles="bubbles"in a?a.bubbles:!1;this.cancelable="cancelable"in a?a.cancelable:!1;this.view="view"in a?a.view:null;this.detail="detail"in a?a.detail:null;this.screenX="screenX"in a?a.screenX:0;this.screenY="screenY"in a?a.screenY:0;this.clientX="clientX"in a?a.clientX:0;this.clientY="clientY"in a?a.clientY:0;this.button="button"in a?a.button:0;this.relatedTarget="relatedTarget"in a?a.relatedTarget:
	null;this.pointerId="pointerId"in a?a.pointerId:0;this.width="width"in a?a.width:0;this.height="height"in a?a.height:0;this.pointerType="pointerType"in a?a.pointerType:"";this.isPrimary="isPrimary"in a?a.isPrimary:!1;b.preventDefault&&(this.preventDefault=function(){b.preventDefault()})}u(ge,Bc);function je(a){if(a.buttons||le)a=a.buttons;else switch(a.which){case 1:a=1;break;case 2:a=4;break;case 3:a=2;break;default:a=0}return a}
	function ke(a,b){var c=0;a.pressure?c=a.pressure:c=b?.5:0;return c}var le=!1;try{le=1===(new MouseEvent("click",{buttons:1})).buttons}catch(a){};function me(a,b){Wd.call(this,a,{touchstart:this.Dp,touchmove:this.Cp,touchend:this.Bp,touchcancel:this.Ap});this.a=a.f;this.l=b;this.f=void 0;this.g=0;this.c=void 0}u(me,Wd);k=me.prototype;k.Di=function(){this.g=0;this.c=void 0};
	function ne(a,b,c){b=ae(b,c);b.pointerId=c.identifier+2;b.bubbles=!0;b.cancelable=!0;b.detail=a.g;b.button=0;b.buttons=1;b.width=c.webkitRadiusX||c.radiusX||0;b.height=c.webkitRadiusY||c.radiusY||0;b.pressure=c.webkitForce||c.force||.5;b.isPrimary=a.f===c.identifier;b.pointerType="touch";b.clientX=c.clientX;b.clientY=c.clientY;b.screenX=c.screenX;b.screenY=c.screenY;return b}
	function oe(a,b,c){function d(){b.preventDefault()}var e=Array.prototype.slice.call(b.changedTouches),f=e.length,g,h;for(g=0;g<f;++g)h=ne(a,b,e[g]),h.preventDefault=d,c.call(a,b,h)}
	k.Dp=function(a){var b=a.touches,c=Object.keys(this.a),d=c.length;if(d>=b.length){var e=[],f,g,h;for(f=0;f<d;++f){g=c[f];h=this.a[g];var l;if(!(l=1==g))a:{for(var m=b.length,p=0;p<m;p++)if(l=b[p],l.identifier===g-2){l=!0;break a}l=!1}l||e.push(h.out)}for(f=0;f<e.length;++f)this.zf(a,e[f])}b=a.changedTouches[0];c=Object.keys(this.a).length;if(!c||1===c&&(1).toString()in this.a)this.f=b.identifier,void 0!==this.c&&clearTimeout(this.c);pe(this,a);this.g++;oe(this,a,this.so)};
	k.so=function(a,b){this.a[b.pointerId]={target:b.target,out:b,pi:b.target};var c=this.b;b.bubbles=!0;be(c,"pointerover",b,a);c=this.b;b.bubbles=!1;be(c,"pointerenter",b,a);be(this.b,"pointerdown",b,a)};k.Cp=function(a){a.preventDefault();oe(this,a,this.Rl)};
	k.Rl=function(a,b){var c=this.a[b.pointerId];if(c){var d=c.out,e=c.pi;be(this.b,"pointermove",b,a);d&&e!==b.target&&(d.relatedTarget=b.target,b.relatedTarget=e,d.target=e,b.target?(de(this.b,d,a),ce(this.b,b,a)):(b.target=e,b.relatedTarget=null,this.zf(a,b)));c.out=b;c.pi=b.target}};k.Bp=function(a){pe(this,a);oe(this,a,this.Ep)};
	k.Ep=function(a,b){be(this.b,"pointerup",b,a);this.b.out(b,a);qe(this.b,b,a);delete this.a[b.pointerId];b.isPrimary&&(this.f=void 0,this.c=setTimeout(this.Di.bind(this),200))};k.Ap=function(a){oe(this,a,this.zf)};k.zf=function(a,b){this.b.cancel(b,a);this.b.out(b,a);qe(this.b,b,a);delete this.a[b.pointerId];b.isPrimary&&(this.f=void 0,this.c=setTimeout(this.Di.bind(this),200))};
	function pe(a,b){var c=a.l.f,d=b.changedTouches[0];if(a.f===d.identifier){var e=[d.clientX,d.clientY];c.push(e);setTimeout(function(){var a=c.indexOf(e);-1<a&&c.splice(a,1)},2500)}};function re(a){Dc.call(this);this.g=a;this.f={};this.i={};this.a=[];Qd?se(this,new he(this)):Rd?se(this,new ee(this)):(a=new Xd(this),se(this,a),Pd&&se(this,new me(this,a)));a=this.a.length;for(var b,c=0;c<a;c++)b=this.a[c],te(this,Object.keys(b.i))}u(re,Dc);function se(a,b){var c=Object.keys(b.i);c&&(c.forEach(function(a){var c=b.i[a];c&&(this.i[a]=c.bind(b))},a),a.a.push(b))}re.prototype.c=function(a){var b=this.i[a.type];b&&b(a)};
	function te(a,b){b.forEach(function(a){B(this.g,a,this.c,this)},a)}function ve(a,b){b.forEach(function(a){xc(this.g,a,this.c,this)},a)}function ae(a,b){for(var c={},d,e=0,f=we.length;e<f;e++)d=we[e][0],c[d]=a[d]||b[d]||we[e][1];return c}function qe(a,b,c){b.bubbles=!1;be(a,"pointerleave",b,c)}re.prototype.out=function(a,b){a.bubbles=!0;be(this,"pointerout",a,b)};re.prototype.cancel=function(a,b){be(this,"pointercancel",a,b)};
	function de(a,b,c){a.out(b,c);var d=b.target,e=b.relatedTarget;d&&e&&d.contains(e)||qe(a,b,c)}function ce(a,b,c){b.bubbles=!0;be(a,"pointerover",b,c);var d=b.target,e=b.relatedTarget;d&&e&&d.contains(e)||(b.bubbles=!1,be(a,"pointerenter",b,c))}function be(a,b,c,d){a.b(new ge(b,d,c))}function ie(a,b){a.b(new ge(b.type,b,b))}re.prototype.ra=function(){for(var a=this.a.length,b,c=0;c<a;c++)b=this.a[c],ve(this,Object.keys(b.i));Dc.prototype.ra.call(this)};
	var we=[["bubbles",!1],["cancelable",!1],["view",null],["detail",null],["screenX",0],["screenY",0],["clientX",0],["clientY",0],["ctrlKey",!1],["altKey",!1],["shiftKey",!1],["metaKey",!1],["button",0],["relatedTarget",null],["buttons",0],["pointerId",0],["width",0],["height",0],["pressure",0],["tiltX",0],["tiltY",0],["pointerType",""],["hwTimestamp",0],["isPrimary",!1],["type",""],["target",null],["currentTarget",null],["which",0]];function xe(a){Dc.call(this);this.c=a;this.l=0;this.j=!1;this.i=[];this.f=null;a=this.c.c;this.u=0;this.I={};this.g=new re(a);this.a=null;this.o=B(this.g,"pointerdown",this.ul,this);this.v=B(this.g,"pointermove",this.$o,this)}u(xe,Dc);function ye(a,b){var c=new Bd("click",a.c,b);a.b(c);a.l?(clearTimeout(a.l),a.l=0,c=new Bd("dblclick",a.c,b),a.b(c)):a.l=setTimeout(function(){this.l=0;var a=new Bd("singleclick",this.c,b);this.b(a)}.bind(a),250)}
	function ze(a,b){"pointerup"==b.type||"pointercancel"==b.type?delete a.I[b.pointerId]:"pointerdown"==b.type&&(a.I[b.pointerId]=!0);a.u=Object.keys(a.I).length}k=xe.prototype;k.vh=function(a){ze(this,a);var b=new Bd("pointerup",this.c,a);this.b(b);this.j||a.button||ye(this,this.f);this.u||(this.i.forEach(rc),this.i.length=0,this.j=!1,this.f=null,Ac(this.a),this.a=null)};
	k.ul=function(a){ze(this,a);var b=new Bd("pointerdown",this.c,a);this.b(b);this.f=a;this.i.length||(this.a=new re(document),this.i.push(B(this.a,"pointermove",this.om,this),B(this.a,"pointerup",this.vh,this),B(this.g,"pointercancel",this.vh,this)))};k.om=function(a){if(a.clientX!=this.f.clientX||a.clientY!=this.f.clientY){this.j=!0;var b=new Bd("pointerdrag",this.c,a,this.j);this.b(b)}a.preventDefault()};
	k.$o=function(a){this.b(new Bd(a.type,this.c,a,!(!this.f||a.clientX==this.f.clientX&&a.clientY==this.f.clientY)))};k.ra=function(){this.v&&(rc(this.v),this.v=null);this.o&&(rc(this.o),this.o=null);this.i.forEach(rc);this.i.length=0;this.a&&(Ac(this.a),this.a=null);this.g&&(Ac(this.g),this.g=null);Dc.prototype.ra.call(this)};function Ae(a,b){this.o=a;this.c=b;this.b=[];this.f=[];this.a={}}Ae.prototype.clear=function(){this.b.length=0;this.f.length=0;qb(this.a)};function Be(a){var b=a.b,c=a.f,d=b[0];1==b.length?(b.length=0,c.length=0):(b[0]=b.pop(),c[0]=c.pop(),Ce(a,0));b=a.c(d);delete a.a[b];return d}Ae.prototype.i=function(a){qa(!(this.c(a)in this.a),31);var b=this.o(a);return Infinity!=b?(this.b.push(a),this.f.push(b),this.a[this.c(a)]=!0,De(this,0,this.b.length-1),!0):!1};
	function Ce(a,b){for(var c=a.b,d=a.f,e=c.length,f=c[b],g=d[b],h=b;b<e>>1;){var l=2*b+1,m=2*b+2,l=m<e&&d[m]<d[l]?m:l;c[b]=c[l];d[b]=d[l];b=l}c[b]=f;d[b]=g;De(a,h,b)}function De(a,b,c){var d=a.b;a=a.f;for(var e=d[c],f=a[c];c>b;){var g=c-1>>1;if(a[g]>f)d[c]=d[g],a[c]=a[g],c=g;else break}d[c]=e;a[c]=f}function Ee(a){var b=a.o,c=a.b,d=a.f,e=0,f=c.length,g,h,l;for(h=0;h<f;++h)g=c[h],l=b(g),Infinity==l?delete a.a[a.c(g)]:(d[e]=l,c[e++]=g);c.length=e;d.length=e;for(b=(a.b.length>>1)-1;0<=b;b--)Ce(a,b)};function Fe(a,b){Ae.call(this,function(b){return a.apply(null,b)},function(a){return a[0].ib()});this.v=b;this.l=0;this.g={}}u(Fe,Ae);Fe.prototype.i=function(a){var b=Ae.prototype.i.call(this,a);b&&B(a[0],"change",this.j,this);return b};Fe.prototype.j=function(a){a=a.target;var b=a.V();if(2===b||3===b||4===b||5===b)xc(a,"change",this.j,this),a=a.ib(),a in this.g&&(delete this.g[a],--this.l),this.v()};
	function Ge(a,b,c){for(var d=0,e,f;a.l<b&&d<c&&0<a.b.length;)e=Be(a)[0],f=e.ib(),0!==e.V()||f in a.g||(a.g[f]=!0,++a.l,++d,e.load())};function He(a){return function(b,c,d){if(void 0!==b)return b=fa(a,b,d),b=wa(b+c,0,a.length-1),c=Math.floor(b),b!=c&&c<a.length-1?a[c]/Math.pow(a[c]/a[c+1],b-c):a[c]}}function Ie(a,b,c){return function(d,e,f){if(void 0!==d)return d=Math.max(Math.floor(Math.log(b/d)/Math.log(a)+(-f/2+.5))+e,0),void 0!==c&&(d=Math.min(d,c)),b/Math.pow(a,d)}};function Ke(a){if(void 0!==a)return 0}function Le(a,b){if(void 0!==a)return a+b}function Me(a){var b=2*Math.PI/a;return function(a,d){if(void 0!==a)return a=Math.floor((a+d)/b+.5)*b}}function Ne(){var a=Ba(5);return function(b,c){if(void 0!==b)return Math.abs(b+c)<=a?0:b+c}};function Oe(a,b){var c=void 0!==b?a.toFixed(b):""+a,d=c.indexOf("."),d=-1===d?c.length:d;return 2<d?c:Array(3-d).join("0")+c}function Pe(a){a=(""+a).split(".");for(var b=["1","3"],c=0;c<Math.max(a.length,b.length);c++){var d=parseInt(a[c]||"0",10),e=parseInt(b[c]||"0",10);if(d>e)return 1;if(e>d)return-1}return 0};function Qe(a,b){a[0]+=b[0];a[1]+=b[1];return a}function Re(a,b){var c=a[0],d=a[1],e=b[0],f=b[1],g=e[0],e=e[1],h=f[0],f=f[1],l=h-g,m=f-e,c=l||m?(l*(c-g)+m*(d-e))/(l*l+m*m||0):0;0>=c||(1<=c?(g=h,e=f):(g+=c*l,e+=c*m));return[g,e]}
	function Se(a,b,c){a=Ca(a+180,360)-180;var d=Math.abs(3600*a);c=c||0;var e=Math.pow(10,c),f=Math.floor(d/3600),g=Math.floor((d-3600*f)/60),d=Math.ceil((d-3600*f-60*g)*e)/e;60<=d&&(d=0,g+=1);60<=g&&(g=0,f+=1);return f+"\u00b0 "+Oe(g)+"\u2032 "+Oe(d,c)+"\u2033 "+b.charAt(0>a?1:0)}function Te(a,b,c){return a?b.replace("{x}",a[0].toFixed(c)).replace("{y}",a[1].toFixed(c)):""}function Ue(a,b){for(var c=!0,d=a.length-1;0<=d;--d)if(a[d]!=b[d]){c=!1;break}return c}
	function Ve(a,b){var c=Math.cos(b),d=Math.sin(b),e=a[1]*c+a[0]*d;a[0]=a[0]*c-a[1]*d;a[1]=e;return a}function We(a,b){a[0]*=b;a[1]*=b}function Xe(a,b){var c=a[0]-b[0],d=a[1]-b[1];return c*c+d*d}function Ye(a,b){return Math.sqrt(Xe(a,b))}function Ze(a,b){return Xe(a,Re(a,b))}function $e(a,b){return Te(a,"{x}, {y}",b)};function af(){return!0}function bf(){return!1};function cf(){Gc.call(this);this.o=Ia();this.v=-1;this.i={};this.j=this.g=0}u(cf,Gc);k=cf.prototype;k.Ab=function(a,b){var c=b?b:[NaN,NaN];this.Gb(a[0],a[1],c,Infinity);return c};k.sb=function(a){return this.Oc(a[0],a[1])};k.Oc=bf;k.D=function(a){this.v!=this.f&&(this.o=this.ne(this.o),this.v=this.f);var b=this.o;a?(a[0]=b[0],a[1]=b[1],a[2]=b[2],a[3]=b[3]):a=b;return a};k.Pb=function(a){return this.Qd(a*a)};k.tb=function(a,b){this.Dc(Ub(a,b));return this};function df(a,b,c,d,e,f){for(var g=f?f:[],h=0;b<c;b+=d){var l=a[b],m=a[b+1];g[h++]=e[0]*l+e[2]*m+e[4];g[h++]=e[1]*l+e[3]*m+e[5]}f&&g.length!=h&&(g.length=h);return g}function ef(a,b,c,d,e,f){var g=f?f:[],h=0,l,m;for(l=0;l<b;l+=c)for(g[h++]=a[l]+d,g[h++]=a[l+1]+e,m=l+2;m<l+c;++m)g[h++]=a[m];f&&g.length!=h&&(g.length=h);return g};function ff(){cf.call(this);this.ka="XY";this.a=2;this.B=null}u(ff,cf);function gf(a){var b;"XY"==a?b=2:"XYZ"==a||"XYM"==a?b=3:"XYZM"==a&&(b=4);return b}k=ff.prototype;k.Oc=bf;k.ne=function(a){return Xa(this.B,0,this.B.length,this.a,a)};k.bc=function(){return this.B.slice(0,this.a)};k.ha=function(){return this.B};k.cc=function(){return this.B.slice(this.B.length-this.a)};k.dc=function(){return this.ka};
	k.Qd=function(a){this.j!=this.f&&(qb(this.i),this.g=0,this.j=this.f);if(0>a||this.g&&a<=this.g)return this;var b=a.toString();if(this.i.hasOwnProperty(b))return this.i[b];var c=this.kd(a);if(c.ha().length<this.B.length)return this.i[b]=c;this.g=a;return this};k.kd=function(){return this};k.sa=function(){return this.a};function hf(a,b,c){a.a=gf(b);a.ka=b;a.B=c}
	function jf(a,b,c,d){if(b)c=gf(b);else{for(b=0;b<d;++b)if(c.length)c=c[0];else{a.ka="XY";a.a=2;return}c=c.length;var e;2==c?e="XY":3==c?e="XYZ":4==c&&(e="XYZM");b=e}a.ka=b;a.a=c}k.Dc=function(a){this.B&&(a(this.B,this.B,this.a),this.s())};
	k.rotate=function(a,b){var c=this.ha();if(c){for(var d=c.length,e=this.sa(),f=c?c:[],g=Math.cos(a),h=Math.sin(a),l=b[0],m=b[1],p=0,n=0;n<d;n+=e){var q=c[n]-l,r=c[n+1]-m;f[p++]=l+q*g-r*h;f[p++]=m+q*h+r*g;for(q=n+2;q<n+e;++q)f[p++]=c[q]}c&&f.length!=p&&(f.length=p);this.s()}};
	k.scale=function(a,b,c){var d=b;void 0===d&&(d=a);var e=c;e||(e=jb(this.D()));if(c=this.ha()){b=c.length;for(var f=this.sa(),g=c?c:[],h=e[0],e=e[1],l=0,m=0;m<b;m+=f){var p=c[m]-h,n=c[m+1]-e;g[l++]=h+a*p;g[l++]=e+d*n;for(p=m+2;p<m+f;++p)g[l++]=c[p]}c&&g.length!=l&&(g.length=l);this.s()}};k.translate=function(a,b){var c=this.ha();c&&(ef(c,c.length,this.sa(),a,b,c),this.s())};function kf(a,b,c,d){for(var e=0,f=a[c-d],g=a[c-d+1];b<c;b+=d)var h=a[b],l=a[b+1],e=e+(g*h-f*l),f=h,g=l;return e/2}function lf(a,b,c,d){var e=0,f,g;f=0;for(g=c.length;f<g;++f){var h=c[f],e=e+kf(a,b,h,d);b=h}return e};function mf(a,b,c,d,e,f,g){var h=a[b],l=a[b+1],m=a[c]-h,p=a[c+1]-l;if(m||p)if(f=((e-h)*m+(f-l)*p)/(m*m+p*p),1<f)b=c;else if(0<f){for(e=0;e<d;++e)g[e]=Da(a[b+e],a[c+e],f);g.length=d;return}for(e=0;e<d;++e)g[e]=a[b+e];g.length=d}function nf(a,b,c,d,e){var f=a[b],g=a[b+1];for(b+=d;b<c;b+=d){var h=a[b],l=a[b+1],f=Aa(f,g,h,l);f>e&&(e=f);f=h;g=l}return e}function of(a,b,c,d,e){var f,g;f=0;for(g=c.length;f<g;++f){var h=c[f];e=nf(a,b,h,d,e);b=h}return e}
	function pf(a,b,c,d,e,f,g,h,l,m,p){if(b==c)return m;var n;if(!e){n=Aa(g,h,a[b],a[b+1]);if(n<m){for(p=0;p<d;++p)l[p]=a[b+p];l.length=d;return n}return m}for(var q=p?p:[NaN,NaN],r=b+d;r<c;)if(mf(a,r-d,r,d,g,h,q),n=Aa(g,h,q[0],q[1]),n<m){m=n;for(p=0;p<d;++p)l[p]=q[p];l.length=d;r+=d}else r+=d*Math.max((Math.sqrt(n)-Math.sqrt(m))/e|0,1);if(f&&(mf(a,c-d,b,d,g,h,q),n=Aa(g,h,q[0],q[1]),n<m)){m=n;for(p=0;p<d;++p)l[p]=q[p];l.length=d}return m}
	function qf(a,b,c,d,e,f,g,h,l,m,p){p=p?p:[NaN,NaN];var n,q;n=0;for(q=c.length;n<q;++n){var r=c[n];m=pf(a,b,r,d,e,f,g,h,l,m,p);b=r}return m};function rf(a,b){var c=0,d,e;d=0;for(e=b.length;d<e;++d)a[c++]=b[d];return c}function sf(a,b,c,d){var e,f;e=0;for(f=c.length;e<f;++e){var g=c[e],h;for(h=0;h<d;++h)a[b++]=g[h]}return b}function tf(a,b,c,d,e){e=e?e:[];var f=0,g,h;g=0;for(h=c.length;g<h;++g)b=sf(a,b,c[g],d),e[f++]=b;e.length=f;return e};function uf(a,b,c,d,e){e=void 0!==e?e:[];for(var f=0;b<c;b+=d)e[f++]=a.slice(b,b+d);e.length=f;return e}function vf(a,b,c,d,e){e=void 0!==e?e:[];var f=0,g,h;g=0;for(h=c.length;g<h;++g){var l=c[g];e[f++]=uf(a,b,l,d,e[f]);b=l}e.length=f;return e};function wf(a,b,c,d,e,f,g){var h=(c-b)/d;if(3>h){for(;b<c;b+=d)f[g++]=a[b],f[g++]=a[b+1];return g}var l=Array(h);l[0]=1;l[h-1]=1;c=[b,c-d];for(var m=0,p;0<c.length;){var n=c.pop(),q=c.pop(),r=0,v=a[q],x=a[q+1],y=a[n],z=a[n+1];for(p=q+d;p<n;p+=d){var A=za(a[p],a[p+1],v,x,y,z);A>r&&(m=p,r=A)}r>e&&(l[(m-b)/d]=1,q+d<m&&c.push(q,m),m+d<n&&c.push(m,n))}for(p=0;p<h;++p)l[p]&&(f[g++]=a[b+p*d],f[g++]=a[b+p*d+1]);return g}
	function xf(a,b,c,d,e,f,g,h){var l,m;l=0;for(m=c.length;l<m;++l){var p=c[l];a:{var n,q=a,r=p,v=d,x=e,y=f,z=g;if(b!=r){var A=x*Math.round(q[b]/x),V=x*Math.round(q[b+1]/x);b+=v;y[z++]=A;y[z++]=V;do if(n=x*Math.round(q[b]/x),g=x*Math.round(q[b+1]/x),b+=v,b==r){y[z++]=n;y[z++]=g;g=z;break a}while(n==A&&g==V);for(;b<r;){var Pa,ra;Pa=x*Math.round(q[b]/x);ra=x*Math.round(q[b+1]/x);b+=v;if(Pa!=n||ra!=g){var La=n-A,C=g-V,Ma=Pa-A,xb=ra-V;La*xb==C*Ma&&(0>La&&Ma<La||La==Ma||0<La&&Ma>La)&&(0>C&&xb<C||C==xb||0<
	C&&xb>C)||(y[z++]=n,y[z++]=g,A=n,V=g);n=Pa;g=ra}}y[z++]=n;y[z++]=g}g=z}h.push(g);b=p}return g};function yf(a,b){ff.call(this);this.c=this.l=-1;this.pa(a,b)}u(yf,ff);k=yf.prototype;k.clone=function(){var a=new yf(null);zf(a,this.ka,this.B.slice());return a};k.Gb=function(a,b,c,d){if(d<Oa(this.D(),a,b))return d;this.c!=this.f&&(this.l=Math.sqrt(nf(this.B,0,this.B.length,this.a,0)),this.c=this.f);return pf(this.B,0,this.B.length,this.a,this.l,!0,a,b,c,d)};k.Km=function(){return kf(this.B,0,this.B.length,this.a)};k.X=function(){return uf(this.B,0,this.B.length,this.a)};
	k.kd=function(a){var b=[];b.length=wf(this.B,0,this.B.length,this.a,a,b,0);a=new yf(null);zf(a,"XY",b);return a};k.T=function(){return"LinearRing"};k.Xa=function(){};k.pa=function(a,b){a?(jf(this,b,a,1),this.B||(this.B=[]),this.B.length=sf(this.B,0,a,this.a),this.s()):zf(this,"XY",null)};function zf(a,b,c){hf(a,b,c);a.s()};function E(a,b){ff.call(this);this.pa(a,b)}u(E,ff);k=E.prototype;k.clone=function(){var a=new E(null);a.ca(this.ka,this.B.slice());return a};k.Gb=function(a,b,c,d){var e=this.B;a=Aa(a,b,e[0],e[1]);if(a<d){d=this.a;for(b=0;b<d;++b)c[b]=e[b];c.length=d;return a}return d};k.X=function(){return this.B?this.B.slice():[]};k.ne=function(a){return Wa(this.B,a)};k.T=function(){return"Point"};k.Xa=function(a){return Sa(a,this.B[0],this.B[1])};
	k.pa=function(a,b){a?(jf(this,b,a,0),this.B||(this.B=[]),this.B.length=rf(this.B,a),this.s()):this.ca("XY",null)};k.ca=function(a,b){hf(this,a,b);this.s()};function Af(a,b,c,d,e){return!ab(e,function(e){return!Bf(a,b,c,d,e[0],e[1])})}function Bf(a,b,c,d,e,f){for(var g=0,h=a[c-d],l=a[c-d+1];b<c;b+=d){var m=a[b],p=a[b+1];l<=f?p>f&&0<(m-h)*(f-l)-(e-h)*(p-l)&&g++:p<=f&&0>(m-h)*(f-l)-(e-h)*(p-l)&&g--;h=m;l=p}return!!g}function Cf(a,b,c,d,e,f){if(!c.length||!Bf(a,b,c[0],d,e,f))return!1;var g;b=1;for(g=c.length;b<g;++b)if(Bf(a,c[b-1],c[b],d,e,f))return!1;return!0};function Df(a,b,c,d,e,f,g){var h,l,m,p,n,q=e[f+1],r=[],v=c[0];m=a[v-d];n=a[v-d+1];for(h=b;h<v;h+=d){p=a[h];l=a[h+1];if(q<=n&&l<=q||n<=q&&q<=l)m=(q-n)/(l-n)*(p-m)+m,r.push(m);m=p;n=l}v=NaN;n=-Infinity;r.sort(da);m=r[0];h=1;for(l=r.length;h<l;++h){p=r[h];var x=Math.abs(p-m);x>n&&(m=(m+p)/2,Cf(a,b,c,d,m,q)&&(v=m,n=x));m=p}isNaN(v)&&(v=e[f]);return g?(g.push(v,q),g):[v,q]};function Ef(a,b,c,d,e,f){for(var g=[a[b],a[b+1]],h=[],l;b+d<c;b+=d){h[0]=a[b+d];h[1]=a[b+d+1];if(l=e.call(f,g,h))return l;g[0]=h[0];g[1]=h[1]}return!1};function Ff(a,b,c,d,e){var f=Ya(Ia(),a,b,c,d);return mb(e,f)?Ta(e,f)||f[0]>=e[0]&&f[2]<=e[2]||f[1]>=e[1]&&f[3]<=e[3]?!0:Ef(a,b,c,d,function(a,b){var c=!1,d=Ua(e,a),f=Ua(e,b);if(1===d||1===f)c=!0;else{var g=e[0],h=e[1],r=e[2],v=e[3],x=b[0],y=b[1],z=(y-a[1])/(x-a[0]);f&2&&!(d&2)&&(c=x-(y-v)/z,c=c>=g&&c<=r);c||!(f&4)||d&4||(c=y-(x-r)*z,c=c>=h&&c<=v);c||!(f&8)||d&8||(c=x-(y-h)/z,c=c>=g&&c<=r);c||!(f&16)||d&16||(c=y-(x-g)*z,c=c>=h&&c<=v)}return c}):!1}
	function Gf(a,b,c,d,e){var f=c[0];if(!(Ff(a,b,f,d,e)||Bf(a,b,f,d,e[0],e[1])||Bf(a,b,f,d,e[0],e[3])||Bf(a,b,f,d,e[2],e[1])||Bf(a,b,f,d,e[2],e[3])))return!1;if(1===c.length)return!0;b=1;for(f=c.length;b<f;++b)if(Af(a,c[b-1],c[b],d,e))return!1;return!0};function Hf(a,b,c,d){for(var e=0,f=a[c-d],g=a[c-d+1];b<c;b+=d)var h=a[b],l=a[b+1],e=e+(h-f)*(l+g),f=h,g=l;return 0<e}function If(a,b,c,d){var e=0;d=void 0!==d?d:!1;var f,g;f=0;for(g=b.length;f<g;++f){var h=b[f],e=Hf(a,e,h,c);if(!f){if(d&&e||!d&&!e)return!1}else if(d&&!e||!d&&e)return!1;e=h}return!0}
	function Jf(a,b,c,d,e){e=void 0!==e?e:!1;var f,g;f=0;for(g=c.length;f<g;++f){var h=c[f],l=Hf(a,b,h,d);if(f?e&&!l||!e&&l:e&&l||!e&&!l)for(var l=a,m=h,p=d;b<m-p;){var n;for(n=0;n<p;++n){var q=l[b+n];l[b+n]=l[m-p+n];l[m-p+n]=q}b+=p;m-=p}b=h}return b}function Kf(a,b,c,d){var e=0,f,g;f=0;for(g=b.length;f<g;++f)e=Jf(a,e,b[f],c,d);return e};function F(a,b){ff.call(this);this.c=[];this.u=-1;this.A=null;this.R=this.C=this.G=-1;this.l=null;this.pa(a,b)}u(F,ff);k=F.prototype;k.Vj=function(a){this.B?ga(this.B,a.ha()):this.B=a.ha().slice();this.c.push(this.B.length);this.s()};k.clone=function(){var a=new F(null);a.ca(this.ka,this.B.slice(),this.c.slice());return a};
	k.Gb=function(a,b,c,d){if(d<Oa(this.D(),a,b))return d;this.C!=this.f&&(this.G=Math.sqrt(of(this.B,0,this.c,this.a,0)),this.C=this.f);return qf(this.B,0,this.c,this.a,this.G,!0,a,b,c,d)};k.Oc=function(a,b){return Cf(this.fc(),0,this.c,this.a,a,b)};k.Nm=function(){return lf(this.fc(),0,this.c,this.a)};k.X=function(a){var b;void 0!==a?(b=this.fc().slice(),Jf(b,0,this.c,this.a,a)):b=this.B;return vf(b,0,this.c,this.a)};k.Rb=function(){return this.c};
	function Lf(a){if(a.u!=a.f){var b=jb(a.D());a.A=Df(a.fc(),0,a.c,a.a,b,0);a.u=a.f}return a.A}k.yk=function(){return new E(Lf(this))};k.Ek=function(){return this.c.length};k.nh=function(a){if(0>a||this.c.length<=a)return null;var b=new yf(null);zf(b,this.ka,this.B.slice(a?this.c[a-1]:0,this.c[a]));return b};k.jd=function(){var a=this.ka,b=this.B,c=this.c,d=[],e=0,f,g;f=0;for(g=c.length;f<g;++f){var h=c[f],l=new yf(null);zf(l,a,b.slice(e,h));d.push(l);e=h}return d};
	k.fc=function(){if(this.R!=this.f){var a=this.B;If(a,this.c,this.a)?this.l=a:(this.l=a.slice(),this.l.length=Jf(this.l,0,this.c,this.a));this.R=this.f}return this.l};k.kd=function(a){var b=[],c=[];b.length=xf(this.B,0,this.c,this.a,Math.sqrt(a),b,0,c);a=new F(null);a.ca("XY",b,c);return a};k.T=function(){return"Polygon"};k.Xa=function(a){return Gf(this.fc(),0,this.c,this.a,a)};
	k.pa=function(a,b){if(a){jf(this,b,a,2);this.B||(this.B=[]);var c=tf(this.B,0,a,this.a,this.c);this.B.length=c.length?c[c.length-1]:0;this.s()}else this.ca("XY",null,this.c)};k.ca=function(a,b,c){hf(this,a,b);this.c=c;this.s()};function Mf(a,b,c,d){var e=d?d:32;d=[];var f;for(f=0;f<e;++f)ga(d,a.offset(b,c,2*Math.PI*f/e));d.push(d[0],d[1]);a=new F(null);a.ca("XY",d,[d.length]);return a}
	function Nf(a){var b=a[0],c=a[1],d=a[2];a=a[3];b=[b,c,b,a,d,a,d,c,b,c];c=new F(null);c.ca("XY",b,[b.length]);return c}function Of(a,b,c){var d=b?b:32,e=a.sa();b=a.ka;for(var f=new F(null,b),d=e*(d+1),e=Array(d),g=0;g<d;g++)e[g]=0;f.ca(b,e,[e.length]);Pf(f,a.Ba(),a.Vd(),c);return f}function Pf(a,b,c,d){var e=a.ha(),f=a.ka,g=a.sa(),h=a.Rb(),l=e.length/g-1;d=d?d:0;for(var m,p,n=0;n<=l;++n)p=n*g,m=d+2*Ca(n,l)*Math.PI/l,e[p]=b[0]+c*Math.cos(m),e[p+1]=b[1]+c*Math.sin(m);a.ca(f,e,h)};function Qf(a){Gc.call(this);a=a||{};this.l=[0,0];this.c=[];this.lf=this.lf.bind(this);var b={};b.center=void 0!==a.center?a.center:null;this.o=Qb(a.projection);var c,d,e,f=void 0!==a.minZoom?a.minZoom:0;c=void 0!==a.maxZoom?a.maxZoom:28;var g=void 0!==a.zoomFactor?a.zoomFactor:2;if(void 0!==a.resolutions)c=a.resolutions,d=c[0],e=c[c.length-1],c=He(c);else{d=Qb(a.projection);e=d.D();var h=(e?Math.max(hb(e),ib(e)):360*vb.degrees/d.sc())/256/Math.pow(2,0),l=h/Math.pow(2,28);d=a.maxResolution;void 0!==
	d?f=0:d=h/Math.pow(g,f);e=a.minResolution;void 0===e&&(e=void 0!==a.maxZoom?void 0!==a.maxResolution?d/Math.pow(g,c):h/Math.pow(g,c):l);c=f+Math.floor(Math.log(d/e)/Math.log(g));e=d/Math.pow(g,c-f);c=Ie(g,d,c-f)}this.a=d;this.i=e;this.A=g;this.g=a.resolutions;this.j=f;(void 0!==a.enableRotation?a.enableRotation:1)?(f=a.constrainRotation,f=void 0===f||!0===f?Ne():!1===f?Le:"number"===typeof f?Me(f):Le):f=Ke;this.u=new Wc(void 0!==a.extent?oc(a.extent):pc,c,f);void 0!==a.resolution?b.resolution=a.resolution:
	void 0!==a.zoom&&(b.resolution=this.constrainResolution(this.a,a.zoom-this.j));b.rotation=void 0!==a.rotation?a.rotation:0;this.H(b)}u(Qf,Gc);k=Qf.prototype;
	k.animate=function(a){var b=Date.now(),c=this.Ba().slice(),d=this.Ua(),e=this.Va(),f=arguments.length,g;1<f&&"function"===typeof arguments[f-1]&&(g=arguments[f-1],--f);for(var h=[],l=0;l<f;++l){var m=arguments[l],p={start:b,complete:!1,anchor:m.anchor,duration:void 0!==m.duration?m.duration:1E3,easing:m.easing||gd};m.center&&(p.Bg=c,p.Dg=m.center,c=p.Dg);void 0!==m.zoom?(p.hf=d,p.jf=this.constrainResolution(this.a,m.zoom-this.j,0),d=p.jf):m.resolution&&(p.hf=d,p.jf=m.resolution,d=p.jf);void 0!==m.rotation&&
	(p.Cg=e,p.Xi=m.rotation,e=p.Xi);p.fd=g;b+=p.duration;h.push(p)}this.c.push(h);Rf(this,0,1);this.lf()};function md(a){Rf(a,0,-ld(a)[0]);for(var b=0,c=a.c.length;b<c;++b){var d=a.c[b];d[0].fd&&d[0].fd(!1)}a.c.length=0}
	k.lf=function(){void 0!==this.v&&(cancelAnimationFrame(this.v),this.v=void 0);if(0<ld(this)[0]){for(var a=Date.now(),b=!1,c=this.c.length-1;0<=c;--c){for(var d=this.c[c],e=!0,f=0,g=d.length;f<g;++f){var h=d[f];if(!h.complete){b=a-h.start;b=0<h.duration?b/h.duration:1;1<=b?(h.complete=!0,b=1):e=!1;b=h.easing(b);if(h.Bg){var l=h.Bg[0],m=h.Bg[1];this.set("center",[l+b*(h.Dg[0]-l),m+b*(h.Dg[1]-m)])}h.hf&&(l=h.hf+b*(h.jf-h.hf),h.anchor&&this.set("center",Sf(this,l,h.anchor)),this.set("resolution",l));
	void 0!==h.Cg&&(b=h.Cg+b*(h.Xi-h.Cg),h.anchor&&this.set("center",Tf(this,b,h.anchor)),this.set("rotation",b));b=!0;if(!h.complete)break}}e&&(this.c[c]=null,Rf(this,0,-1),(d=d[0].fd)&&d(!0))}this.c=this.c.filter(Boolean);b&&void 0===this.v&&(this.v=requestAnimationFrame(this.lf))}};function Tf(a,b,c){var d,e=a.Ba();void 0!==e&&(d=[e[0]-c[0],e[1]-c[1]],Ve(d,b-a.Va()),Qe(d,c));return d}
	function Sf(a,b,c){var d,e=a.Ba();a=a.Ua();void 0!==e&&void 0!==a&&(d=[c[0]-b*(c[0]-e[0])/a,c[1]-b*(c[1]-e[1])/a]);return d}function Uf(a){var b=[100,100];a='.ol-viewport[data-view="'+w(a)+'"]';if(a=document.querySelector(a))a=getComputedStyle(a),b[0]=parseInt(a.width,10),b[1]=parseInt(a.height,10);return b}k.Ec=function(a){return this.u.center(a)};k.constrainResolution=function(a,b,c){return this.u.resolution(a,b||0,c||0)};k.constrainRotation=function(a,b){return this.u.rotation(a,b||0)};k.Ba=function(){return this.get("center")};
	function ld(a,b){return void 0!==b?(b[0]=a.l[0],b[1]=a.l[1],b):a.l.slice()}k.ed=function(a){a=a||Uf(this);var b=this.Ba();qa(b,1);var c=this.Ua();qa(void 0!==c,2);var d=this.Va();qa(void 0!==d,3);return kb(b,c,d,a)};k.sm=function(){return this.a};k.tm=function(){return this.i};k.um=function(){return this.o};k.Ua=function(){return this.get("resolution")};k.vm=function(){return this.g};function Vf(a,b){return Math.max(hb(a)/b[0],ib(a)/b[1])}
	function Wf(a){var b=a.a,c=Math.log(b/a.i)/Math.log(2);return function(a){return b/Math.pow(2,a*c)}}k.Va=function(){return this.get("rotation")};function Xf(a){var b=a.a,c=Math.log(b/a.i)/Math.log(2);return function(a){return Math.log(b/a)/Math.log(2)/c}}k.V=function(){var a=this.Ba(),b=this.o,c=this.Ua(),d=this.Va();return{center:a.slice(),projection:void 0!==b?b:null,resolution:c,rotation:d}};
	k.$k=function(){var a,b=this.Ua();if(void 0!==b&&b>=this.i&&b<=this.a){a=this.j||0;var c,d;if(this.g){d=fa(this.g,b,1);a+=d;if(d==this.g.length-1)return a;c=this.g[d];d=c/this.g[d+1]}else c=this.a,d=this.A;a+=Math.log(c/b)/Math.log(d)}return a};
	k.Ff=function(a,b){var c=b||{},d=c.size;d||(d=Uf(this));var e;a instanceof ff?"Circle"===a.T()?(a=a.D(),e=Nf(a),e.rotate(this.Va(),jb(a))):e=a:(qa(Array.isArray(a),24),qa(!gb(a),25),e=Nf(a));var f=c.padding?c.padding:[0,0,0,0],g=void 0!==c.constrainResolution?c.constrainResolution:!0,h=void 0!==c.nearest?c.nearest:!1,l;void 0!==c.minResolution?l=c.minResolution:void 0!==c.maxZoom?l=this.constrainResolution(this.a,c.maxZoom-this.j,0):l=0;var m=e.ha(),p=this.Va(),n=Math.cos(-p),p=Math.sin(-p),q=Infinity,
	r=Infinity,v=-Infinity,x=-Infinity;e=e.sa();for(var y=0,z=m.length;y<z;y+=e)var A=m[y]*n-m[y+1]*p,V=m[y]*p+m[y+1]*n,q=Math.min(q,A),r=Math.min(r,V),v=Math.max(v,A),x=Math.max(x,V);d=Vf([q,r,v,x],[d[0]-f[1]-f[3],d[1]-f[0]-f[2]]);d=isNaN(d)?l:Math.max(d,l);g&&(g=this.constrainResolution(d,0,0),!h&&g<d&&(g=this.constrainResolution(g,-1,0)),d=g);p=-p;h=(q+v)/2+(f[1]-f[3])/2*d;f=(r+x)/2+(f[0]-f[2])/2*d;n=[h*n-f*p,f*n+h*p];void 0!==c.duration?this.animate({resolution:d,center:n,duration:c.duration,easing:c.easing}):
	(this.Xc(d),this.wb(n))};k.$j=function(a,b,c){var d=this.Va(),e=Math.cos(-d),d=Math.sin(-d),f=a[0]*e-a[1]*d;a=a[1]*e+a[0]*d;var g=this.Ua(),f=f+(b[0]/2-c[0])*g;a+=(c[1]-b[1]/2)*g;d=-d;this.wb([f*e-a*d,a*e+f*d])};function Yf(a){return!!a.Ba()&&void 0!==a.Ua()}k.rotate=function(a,b){if(void 0!==b){var c=Tf(this,a,b);this.wb(c)}this.He(a)};k.wb=function(a){this.set("center",a);0<ld(this)[0]&&md(this)};function Rf(a,b,c){a.l[b]+=c;a.s()}k.Xc=function(a){this.set("resolution",a);0<ld(this)[0]&&md(this)};
	k.He=function(a){this.set("rotation",a);0<ld(this)[0]&&md(this)};k.yp=function(a){a=this.constrainResolution(this.a,a-this.j,0);this.Xc(a)};function Zf(a,b,c){this.i=a;this.c=b;this.g=c;this.b=[];this.a=this.f=0}function $f(a){a.b.length=0;a.f=0;a.a=0};function ag(a){Gc.call(this);this.v=null;this.Ia(!0);this.handleEvent=a.handleEvent}u(ag,Gc);ag.prototype.c=function(){return this.get("active")};ag.prototype.i=function(){return this.v};ag.prototype.Ia=function(a){this.set("active",a)};ag.prototype.setMap=function(a){this.v=a};function bg(a,b,c,d){if(void 0!==b){var e=a.Va(),f=a.Ba();void 0!==e&&f&&0<d?a.animate({rotation:b,anchor:c,duration:d,easing:fd}):a.rotate(b,c)}}
	function cg(a,b,c,d){var e=a.Ua();b=a.constrainResolution(e,b,0);if(c&&void 0!==b&&b!==e){var f=a.Ba();c=Sf(a,b,c);c=a.Ec(c);c=[(b*f[0]-e*c[0])/(b-e),(b*f[1]-e*c[1])/(b-e)]}dg(a,b,c,d)}function dg(a,b,c,d){if(b){var e=a.Ua(),f=a.Ba();void 0!==e&&f&&b!==e&&d?a.animate({resolution:b,anchor:c,duration:d,easing:fd}):(c&&(c=Sf(a,b,c),a.wb(c)),a.Xc(b))}};function eg(a){a=a?a:{};this.a=a.delta?a.delta:1;ag.call(this,{handleEvent:fg});this.g=void 0!==a.duration?a.duration:250}u(eg,ag);function fg(a){var b=!1,c=a.originalEvent;if("dblclick"==a.type){var b=a.coordinate,c=c.shiftKey?-this.a:this.a,d=a.map.$();cg(d,c,b,this.g);a.preventDefault();b=!0}return!b};function gg(a){a=a.originalEvent;return a.altKey&&!(a.metaKey||a.ctrlKey)&&a.shiftKey}function hg(a){a=a.originalEvent;return!a.button&&!(Id&&Jd&&a.ctrlKey)}function ig(a){return"pointermove"==a.type}function jg(a){return"singleclick"==a.type}function kg(a){a=a.originalEvent;return!a.altKey&&!(a.metaKey||a.ctrlKey)&&!a.shiftKey}function lg(a){a=a.originalEvent;return!a.altKey&&!(a.metaKey||a.ctrlKey)&&a.shiftKey}
	function mg(a){a=a.originalEvent.target.tagName;return"INPUT"!==a&&"SELECT"!==a&&"TEXTAREA"!==a}function ng(a){qa(a.b,56);return"mouse"==a.b.pointerType}function og(a){a=a.b;return a.isPrimary&&0===a.button};function pg(a){a=a?a:{};ag.call(this,{handleEvent:a.handleEvent?a.handleEvent:qg});this.sf=a.handleDownEvent?a.handleDownEvent:bf;this.pf=a.handleDragEvent?a.handleDragEvent:na;this.xf=a.handleMoveEvent?a.handleMoveEvent:na;this.yf=a.handleUpEvent?a.handleUpEvent:bf;this.A=!1;this.Y={};this.l=[]}u(pg,ag);function rg(a){for(var b=a.length,c=0,d=0,e=0;e<b;e++)c+=a[e].clientX,d+=a[e].clientY;return[c/b,d/b]}
	function qg(a){if(!(a instanceof Bd))return!0;var b=!1,c=a.type;if("pointerdown"===c||"pointerdrag"===c||"pointerup"===c)c=a.b,"pointerup"==a.type?delete this.Y[c.pointerId]:"pointerdown"==a.type?this.Y[c.pointerId]=c:c.pointerId in this.Y&&(this.Y[c.pointerId]=c),this.l=rb(this.Y);this.A?"pointerdrag"==a.type?this.pf(a):"pointerup"==a.type&&(this.A=this.yf(a)&&0<this.l.length):"pointerdown"==a.type?(this.A=a=this.sf(a),b=this.Zc(a)):"pointermove"==a.type&&this.xf(a);return!b}pg.prototype.Zc=function(a){return a};function sg(a){pg.call(this,{handleDownEvent:tg,handleDragEvent:ug,handleUpEvent:vg});a=a?a:{};this.a=a.kinetic;this.g=null;this.u=a.condition?a.condition:kg;this.j=!1}u(sg,pg);function ug(a){var b=this.l,c=rg(b);if(b.length==this.o){if(this.a&&this.a.b.push(c[0],c[1],Date.now()),this.g){var d=this.g[0]-c[0],e=c[1]-this.g[1];a=a.map.$();var f=a.V(),d=[d,e];We(d,f.resolution);Ve(d,f.rotation);Qe(d,f.center);d=a.Ec(d);a.wb(d)}}else this.a&&$f(this.a);this.g=c;this.o=b.length}
	function vg(a){var b=a.map;a=b.$();if(this.l.length)return this.a&&$f(this.a),this.g=null,!0;var c;if(c=!this.j&&this.a)if(c=this.a,6>c.b.length)c=!1;else{var d=Date.now()-c.g,e=c.b.length-3;if(c.b[e+2]<d)c=!1;else{for(var f=e-3;0<f&&c.b[f+2]>d;)f-=3;var d=c.b[e+2]-c.b[f+2],g=c.b[e]-c.b[f],e=c.b[e+1]-c.b[f+1];c.f=Math.atan2(e,g);c.a=Math.sqrt(g*g+e*e)/d;c=c.a>c.c}}c&&(c=this.a,c=(c.c-c.a)/c.i,e=this.a.f,f=a.Ba(),f=b.Ka(f),b=b.Za([f[0]-c*Math.cos(e),f[1]-c*Math.sin(e)]),a.animate({center:a.Ec(b),duration:500,
	easing:fd}));Rf(a,1,-1);return!1}function tg(a){if(0<this.l.length&&this.u(a)){var b=a.map.$();this.g=null;this.A||Rf(b,1,1);ld(b)[0]&&b.wb(a.frameState.viewState.center);this.a&&$f(this.a);this.j=1<this.l.length;return!0}return!1}sg.prototype.Zc=bf;function wg(a){a=a?a:{};pg.call(this,{handleDownEvent:xg,handleDragEvent:yg,handleUpEvent:zg});this.g=a.condition?a.condition:gg;this.a=void 0;this.j=void 0!==a.duration?a.duration:250}u(wg,pg);function yg(a){if(ng(a)){var b=a.map,c=b.Mb();a=a.pixel;c=Math.atan2(c[1]/2-a[1],a[0]-c[0]/2);if(void 0!==this.a){a=c-this.a;var b=b.$(),d=b.Va();bg(b,d-a)}this.a=c}}function zg(a){if(!ng(a))return!0;a=a.map.$();Rf(a,1,-1);var b=a.Va(),c=this.j,b=a.constrainRotation(b,0);bg(a,b,void 0,c);return!1}
	function xg(a){return ng(a)&&hg(a)&&this.g(a)?(Rf(a.map.$(),1,1),this.a=void 0,!0):!1}wg.prototype.Zc=bf;function Ag(a){this.Gc=null;this.a=document.createElement("div");this.a.style.position="absolute";this.a.className="ol-box "+a;this.f=this.c=this.b=null}u(Ag,zc);Ag.prototype.ra=function(){this.setMap(null)};function Bg(a){var b=a.c,c=a.f;a=a.a.style;a.left=Math.min(b[0],c[0])+"px";a.top=Math.min(b[1],c[1])+"px";a.width=Math.abs(c[0]-b[0])+"px";a.height=Math.abs(c[1]-b[1])+"px"}
	Ag.prototype.setMap=function(a){if(this.b){this.b.A.removeChild(this.a);var b=this.a.style;b.left=b.top=b.width=b.height="inherit"}(this.b=a)&&this.b.A.appendChild(this.a)};function Cg(a){var b=a.c,c=a.f,b=[b,[b[0],c[1]],c,[c[0],b[1]]].map(a.b.Za,a.b);b[4]=b[0].slice();a.Gc?a.Gc.pa([b]):a.Gc=new F([b])}Ag.prototype.U=function(){return this.Gc};function Dg(a){pg.call(this,{handleDownEvent:Eg,handleDragEvent:Fg,handleUpEvent:Gg});a=a?a:{};this.a=new Ag(a.className||"ol-dragbox");this.g=null;this.u=a.condition?a.condition:af;this.o=a.boxEndCondition?a.boxEndCondition:Hg}u(Dg,pg);function Hg(a,b,c){a=c[0]-b[0];b=c[1]-b[1];return 64<=a*a+b*b}function Fg(a){if(ng(a)){var b=this.a,c=a.pixel;b.c=this.g;b.f=c;Cg(b);Bg(b);this.b(new Ig(Jg,a.coordinate,a))}}Dg.prototype.U=function(){return this.a.U()};Dg.prototype.j=na;
	function Gg(a){if(!ng(a))return!0;this.a.setMap(null);this.o(a,this.g,a.pixel)&&(this.j(a),this.b(new Ig(Kg,a.coordinate,a)));return!1}function Eg(a){if(ng(a)&&hg(a)&&this.u(a)){this.g=a.pixel;this.a.setMap(a.map);var b=this.a,c=this.g;b.c=this.g;b.f=c;Cg(b);Bg(b);this.b(new Ig(Lg,a.coordinate,a));return!0}return!1}var Lg="boxstart",Jg="boxdrag",Kg="boxend";function Ig(a,b,c){Bc.call(this,a);this.coordinate=b;this.mapBrowserEvent=c}u(Ig,Bc);function Mg(a){a=a?a:{};var b=a.condition?a.condition:lg;this.C=void 0!==a.duration?a.duration:200;this.G=void 0!==a.out?a.out:!1;Dg.call(this,{condition:b,className:a.className||"ol-dragzoom"})}u(Mg,Dg);
	Mg.prototype.j=function(){var a=this.v,b=a.$(),c=a.Mb(),d=this.U().D();if(this.G){var e=b.ed(c),d=[a.Ka(bb(d)),a.Ka(db(d))],a=Va(Infinity,Infinity,-Infinity,-Infinity,void 0),f,g;f=0;for(g=d.length;f<g;++f)Ja(a,d[f]);nb(e,1/Vf(a,c));d=e}c=b.constrainResolution(Vf(d,c));e=jb(d);e=b.Ec(e);b.animate({resolution:c,center:e,duration:this.C,easing:fd})};function Ng(a){ag.call(this,{handleEvent:Og});a=a||{};this.a=function(a){return kg(a)&&mg(a)};this.g=a.condition?a.condition:this.a;this.l=void 0!==a.duration?a.duration:100;this.j=void 0!==a.pixelDelta?a.pixelDelta:128}u(Ng,ag);
	function Og(a){var b=!1;if("keydown"==a.type){var c=a.originalEvent.keyCode;if(this.g(a)&&(40==c||37==c||39==c||38==c)){var b=a.map.$(),d=b.Ua()*this.j,e=0,f=0;40==c?f=-d:37==c?e=-d:39==c?e=d:f=d;d=[e,f];Ve(d,b.Va());c=this.l;if(e=b.Ba())d=b.Ec([e[0]+d[0],e[1]+d[1]]),c?b.animate({duration:c,easing:hd,center:d}):b.wb(d);a.preventDefault();b=!0}}return!b};function Pg(a){ag.call(this,{handleEvent:Qg});a=a?a:{};this.g=a.condition?a.condition:mg;this.a=a.delta?a.delta:1;this.l=void 0!==a.duration?a.duration:100}u(Pg,ag);function Qg(a){var b=!1;if("keydown"==a.type||"keypress"==a.type){var c=a.originalEvent.charCode;!this.g(a)||43!=c&&45!=c||(b=43==c?this.a:-this.a,c=a.map.$(),cg(c,b,void 0,this.l),a.preventDefault(),b=!0)}return!b};function Rg(a){ag.call(this,{handleEvent:Sg});a=a||{};this.l=0;this.R=void 0!==a.duration?a.duration:250;this.Y=void 0!==a.timeout?a.timeout:80;this.A=void 0!==a.useAnchor?a.useAnchor:!0;this.a=null;this.o=this.j=this.u=this.g=void 0}u(Rg,ag);
	function Sg(a){var b=a.type;if("wheel"!==b&&"mousewheel"!==b)return!0;a.preventDefault();var b=a.map,c=a.originalEvent;this.A&&(this.a=a.coordinate);var d;"wheel"==a.type?(d=c.deltaY,Gd&&c.deltaMode===WheelEvent.DOM_DELTA_PIXEL&&(d/=Kd),c.deltaMode===WheelEvent.DOM_DELTA_LINE&&(d*=40)):"mousewheel"==a.type&&(d=-c.wheelDeltaY,Hd&&(d/=3));if(0===d)return!1;a=Date.now();void 0===this.g&&(this.g=a);if(!this.j||400<a-this.g)this.j=4>Math.abs(d)?Tg:Ug;if(this.j===Tg){b=b.$();this.o?clearTimeout(this.o):
	Rf(b,1,1);this.o=setTimeout(this.C.bind(this),400);d=b.Ua()*Math.pow(2,d/300);var c=b.i,e=b.a,f=0;d<c?(d=Math.max(d,c/1.5),f=1):d>e&&(d=Math.min(d,1.5*e),f=-1);if(this.a){var g=Sf(b,d,this.a);b.wb(b.Ec(g))}b.Xc(d);0<f?b.animate({resolution:c,easing:fd,anchor:this.a,duration:500}):0>f&&b.animate({resolution:e,easing:fd,anchor:this.a,duration:500});this.g=a;return!1}this.l+=d;a=Math.max(this.Y-(a-this.g),0);clearTimeout(this.u);this.u=setTimeout(this.G.bind(this,b),a);return!1}
	Rg.prototype.C=function(){this.o=void 0;Rf(this.v.$(),1,-1)};Rg.prototype.G=function(a){a=a.$();0<ld(a)[0]&&md(a);cg(a,-wa(this.l,-1,1),this.a,this.R);this.j=void 0;this.l=0;this.a=null;this.u=this.g=void 0};Rg.prototype.S=function(a){this.A=a;a||(this.a=null)};var Tg="trackpad",Ug="wheel";function Vg(a){pg.call(this,{handleDownEvent:Wg,handleDragEvent:Xg,handleUpEvent:Yg});a=a||{};this.g=null;this.j=void 0;this.a=!1;this.o=0;this.C=void 0!==a.threshold?a.threshold:.3;this.u=void 0!==a.duration?a.duration:250}u(Vg,pg);
	function Xg(a){var b=0,c=this.l[0],d=this.l[1],c=Math.atan2(d.clientY-c.clientY,d.clientX-c.clientX);void 0!==this.j&&(b=c-this.j,this.o+=b,!this.a&&Math.abs(this.o)>this.C&&(this.a=!0));this.j=c;a=a.map;c=a.c.getBoundingClientRect();d=rg(this.l);d[0]-=c.left;d[1]-=c.top;this.g=a.Za(d);this.a&&(c=a.$(),d=c.Va(),a.render(),bg(c,d+b,this.g))}function Yg(a){if(2>this.l.length){a=a.map.$();Rf(a,1,-1);if(this.a){var b=a.Va(),c=this.g,d=this.u,b=a.constrainRotation(b,0);bg(a,b,c,d)}return!1}return!0}
	function Wg(a){return 2<=this.l.length?(a=a.map,this.g=null,this.j=void 0,this.a=!1,this.o=0,this.A||Rf(a.$(),1,1),!0):!1}Vg.prototype.Zc=bf;function Zg(a){pg.call(this,{handleDownEvent:$g,handleDragEvent:ah,handleUpEvent:bh});a=a?a:{};this.o=a.constrainResolution||!1;this.g=null;this.u=void 0!==a.duration?a.duration:400;this.a=void 0;this.j=1}u(Zg,pg);
	function ah(a){var b=1,c=this.l[0],d=this.l[1],e=c.clientX-d.clientX,c=c.clientY-d.clientY,e=Math.sqrt(e*e+c*c);void 0!==this.a&&(b=this.a/e);this.a=e;a=a.map;var e=a.$(),d=e.Ua(),f=e.a,g=e.i,c=d*b;c>f?(b=f/d,c=f):c<g&&(b=g/d,c=g);1!=b&&(this.j=b);b=a.c.getBoundingClientRect();d=rg(this.l);d[0]-=b.left;d[1]-=b.top;this.g=a.Za(d);a.render();dg(e,c,this.g)}
	function bh(a){if(2>this.l.length){a=a.map.$();Rf(a,1,-1);var b=a.Ua();if(this.o||b<a.i||b>a.a){var c=this.g,d=this.u,b=a.constrainResolution(b,0,this.j-1);dg(a,b,c,d)}return!1}return!0}function $g(a){return 2<=this.l.length?(a=a.map,this.g=null,this.a=void 0,this.j=1,this.A||Rf(a.$(),1,1),!0):!1}Zg.prototype.Zc=bf;function ch(a){a=a?a:{};var b=new D,c=new Zf(-.005,.05,100);(void 0!==a.altShiftDragRotate?a.altShiftDragRotate:1)&&b.push(new wg);(void 0!==a.doubleClickZoom?a.doubleClickZoom:1)&&b.push(new eg({delta:a.zoomDelta,duration:a.zoomDuration}));(void 0!==a.dragPan?a.dragPan:1)&&b.push(new sg({kinetic:c}));(void 0!==a.pinchRotate?a.pinchRotate:1)&&b.push(new Vg);(void 0!==a.pinchZoom?a.pinchZoom:1)&&b.push(new Zg({duration:a.zoomDuration}));if(void 0!==a.keyboard?a.keyboard:1)b.push(new Ng),b.push(new Pg({delta:a.zoomDelta,
	duration:a.zoomDuration}));(void 0!==a.mouseWheelZoom?a.mouseWheelZoom:1)&&b.push(new Rg({duration:a.zoomDuration}));(void 0!==a.shiftDragZoom?a.shiftDragZoom:1)&&b.push(new Mg({duration:a.zoomDuration}));return b};function dh(a){Gc.call(this);var b=pb({},a);b.opacity=void 0!==a.opacity?a.opacity:1;b.visible=void 0!==a.visible?a.visible:!0;b.zIndex=void 0!==a.zIndex?a.zIndex:0;b.maxResolution=void 0!==a.maxResolution?a.maxResolution:Infinity;b.minResolution=void 0!==a.minResolution?a.minResolution:0;this.H(b);this.a={layer:this,De:!0}}u(dh,Gc);
	function eh(a){a.a.opacity=wa(a.ic(),0,1);a.a.Ui=a.Nf();a.a.visible=a.Kb();a.a.extent=a.D();a.a.zIndex=a.za();a.a.maxResolution=a.gc();a.a.minResolution=Math.max(a.hc(),0);return a.a}k=dh.prototype;k.D=function(){return this.get("extent")};k.gc=function(){return this.get("maxResolution")};k.hc=function(){return this.get("minResolution")};k.ic=function(){return this.get("opacity")};k.Kb=function(){return this.get("visible")};k.za=function(){return this.get("zIndex")};
	k.uc=function(a){this.set("extent",a)};k.zc=function(a){this.set("maxResolution",a)};k.Ac=function(a){this.set("minResolution",a)};k.vc=function(a){this.set("opacity",a)};k.wc=function(a){this.set("visible",a)};k.Wb=function(a){this.set("zIndex",a)};function fh(a){var b=a||{};a=pb({},b);delete a.layers;b=b.layers;dh.call(this,a);this.i=[];this.c={};B(this,Ic(gh),this.nl,this);b?Array.isArray(b)?b=new D(b.slice()):qa(b instanceof D,43):b=new D;this.Sh(b)}u(fh,dh);k=fh.prototype;k.Dd=function(){};k.ze=function(){this.Kb()&&this.s()};
	k.nl=function(){this.i.forEach(rc);this.i.length=0;var a=this.od();this.i.push(B(a,"add",this.ml,this),B(a,"remove",this.ol,this));for(var b in this.c)this.c[b].forEach(rc);qb(this.c);var a=a.a,c,d;b=0;for(c=a.length;b<c;b++)d=a[b],this.c[w(d).toString()]=[B(d,"propertychange",this.ze,this),B(d,"change",this.ze,this)];this.s()};k.ml=function(a){a=a.element;var b=w(a).toString();this.c[b]=[B(a,"propertychange",this.ze,this),B(a,"change",this.ze,this)];this.s()};
	k.ol=function(a){a=w(a.element).toString();this.c[a].forEach(rc);delete this.c[a];this.s()};k.od=function(){return this.get(gh)};k.Sh=function(a){this.set(gh,a)};
	k.Lf=function(a){var b=void 0!==a?a:[],c=b.length;this.od().forEach(function(a){a.Lf(b)});a=eh(this);var d,e;for(d=b.length;c<d;c++)e=b[c],e.opacity*=a.opacity,e.visible=e.visible&&a.visible,e.maxResolution=Math.min(e.maxResolution,a.maxResolution),e.minResolution=Math.max(e.minResolution,a.minResolution),void 0!==a.extent&&(e.extent=void 0!==e.extent?lb(e.extent,a.extent):a.extent);return b};k.Nf=function(){return"ready"};var gh="layers";function hh(a){yb.call(this,{code:a,units:"m",extent:ih,global:!0,worldExtent:jh,getPointResolution:function(a,c){return a/xa(c[1]/6378137)}})}u(hh,yb);var kh=6378137*Math.PI,ih=[-kh,-kh,kh,kh],jh=[-180,-85,180,85],Lb="EPSG:3857 EPSG:102100 EPSG:102113 EPSG:900913 urn:ogc:def:crs:EPSG:6.18:3:3857 urn:ogc:def:crs:EPSG::3857 http://www.opengis.net/gml/srs/epsg.xml#3857".split(" ").map(function(a){return new hh(a)});
	function Mb(a,b,c){var d=a.length;c=1<c?c:2;void 0===b&&(2<c?b=a.slice():b=Array(d));for(var e=0;e<d;e+=c){b[e]=kh*a[e]/180;var f=6378137*Math.log(Math.tan(Math.PI*(a[e+1]+90)/360));f>kh?f=kh:f<-kh&&(f=-kh);b[e+1]=f}return b}function Nb(a,b,c){var d=a.length;c=1<c?c:2;void 0===b&&(2<c?b=a.slice():b=Array(d));for(var e=0;e<d;e+=c)b[e]=180*a[e]/kh,b[e+1]=360*Math.atan(Math.exp(a[e+1]/6378137))/Math.PI-90;return b};var mh=new tb(6378137);function nh(a,b){yb.call(this,{code:a,units:"degrees",extent:oh,axisOrientation:b,global:!0,metersPerUnit:ph,worldExtent:oh})}u(nh,yb);var oh=[-180,-90,180,90],ph=Math.PI*mh.radius/180,Ob=[new nh("CRS:84"),new nh("EPSG:4326","neu"),new nh("urn:ogc:def:crs:EPSG::4326","neu"),new nh("urn:ogc:def:crs:EPSG:6.6:4326","neu"),new nh("urn:ogc:def:crs:OGC:1.3:CRS84"),new nh("urn:ogc:def:crs:OGC:2:84"),new nh("http://www.opengis.net/gml/srs/epsg.xml#4326","neu"),new nh("urn:x-ogc:def:crs:EPSG:4326","neu")];function qh(){Hb(Lb);Hb(Ob);Kb()};function rh(a){var b=pb({},a);delete b.source;dh.call(this,b);this.u=this.o=this.j=null;a.map&&this.setMap(a.map);B(this,Ic("source"),this.Al,this);this.Yc(a.source?a.source:null)}u(rh,dh);function sh(a,b){return a.visible&&b>=a.minResolution&&b<a.maxResolution}k=rh.prototype;k.Lf=function(a){a=a?a:[];a.push(eh(this));return a};k.la=function(){return this.get("source")||null};k.Nf=function(){var a=this.la();return a?a.V():"undefined"};k.kn=function(){this.s()};
	k.Al=function(){this.u&&(rc(this.u),this.u=null);var a=this.la();a&&(this.u=B(a,"change",this.kn,this));this.s()};k.setMap=function(a){this.j&&(rc(this.j),this.j=null);a||this.s();this.o&&(rc(this.o),this.o=null);a&&(this.j=B(a,"precompose",function(a){var b=eh(this);b.De=!1;b.zIndex=Infinity;a.frameState.layerStatesArray.push(b);a.frameState.layerStates[w(this)]=b},this),this.o=B(this,"change",a.render,a),this.s())};k.Yc=function(a){this.set("source",a)};function th(){this.b={};this.a=0}th.prototype.clear=function(){this.b={};this.a=0};th.prototype.get=function(a,b,c){a=b+":"+a+":"+(c?Sc(c):"null");return a in this.b?this.b[a]:null};th.prototype.set=function(a,b,c,d){this.b[b+":"+a+":"+(c?Sc(c):"null")]=d;++this.a};var uh=new th;var vh=Array(6);function wh(){return[1,0,0,1,0,0]}function xh(a){return yh(a,1,0,0,1,0,0)}function zh(a,b){var c=a[0],d=a[1],e=a[2],f=a[3],g=a[4],h=a[5],l=b[0],m=b[1],p=b[2],n=b[3],q=b[4],r=b[5];a[0]=c*l+e*m;a[1]=d*l+f*m;a[2]=c*p+e*n;a[3]=d*p+f*n;a[4]=c*q+e*r+g;a[5]=d*q+f*r+h;return a}function yh(a,b,c,d,e,f,g){a[0]=b;a[1]=c;a[2]=d;a[3]=e;a[4]=f;a[5]=g;return a}function Ah(a,b){a[0]=b[0];a[1]=b[1];a[2]=b[2];a[3]=b[3];a[4]=b[4];a[5]=b[5];return a}
	function Bh(a,b){var c=b[0],d=b[1];b[0]=a[0]*c+a[2]*d+a[4];b[1]=a[1]*c+a[3]*d+a[5];return b}function Ch(a,b){var c=Math.cos(b),d=Math.sin(b);zh(a,yh(vh,c,d,-d,c,0,0))}function Dh(a,b,c){return zh(a,yh(vh,b,0,0,c,0,0))}function Eh(a,b,c){zh(a,yh(vh,1,0,0,1,b,c))}function Fh(a,b,c,d,e,f,g,h){var l=Math.sin(f);f=Math.cos(f);a[0]=d*f;a[1]=e*l;a[2]=-d*l;a[3]=e*f;a[4]=g*d*f-h*d*l+b;a[5]=g*e*l+h*e*f+c;return a}
	function Gh(a){var b=a[0]*a[3]-a[1]*a[2];qa(!!b,32);var c=a[0],d=a[1],e=a[2],f=a[3],g=a[4],h=a[5];a[0]=f/b;a[1]=-d/b;a[2]=-e/b;a[3]=c/b;a[4]=(e*h-f*g)/b;a[5]=-(c*h-d*g)/b;return a};function Hh(a,b){this.j=b;this.c={};this.v={}}u(Hh,zc);function Ih(a){var b=a.viewState,c=a.coordinateToPixelTransform,d=a.pixelToCoordinateTransform;Fh(c,a.size[0]/2,a.size[1]/2,1/b.resolution,-1/b.resolution,-b.rotation,-b.center[0],-b.center[1]);Gh(Ah(d,c))}k=Hh.prototype;k.ra=function(){for(var a in this.c)Ac(this.c[a])};function Jh(){if(32<uh.a){var a=0,b,c;for(b in uh.b)c=uh.b[b],a++&3||Ec(c)||(delete uh.b[b],--uh.a)}}
	k.Aa=function(a,b,c,d,e,f,g){function h(a,c){var f=w(a).toString(),g=b.layerStates[w(c)].De;if(!(f in b.skippedFeatureUids)||g)return d.call(e,a,g?c:null)}var l,m=b.viewState,p=m.resolution,n=m.projection,m=a;if(n.a){var n=n.D(),q=hb(n),r=a[0];if(r<n[0]||r>n[2])m=[r+q*Math.ceil((n[0]-r)/q),a[1]]}n=b.layerStatesArray;for(q=n.length-1;0<=q;--q){var v=n[q],r=v.layer;if(sh(v,p)&&f.call(g,r)&&(v=Kh(this,r),r.la()&&(l=v.Aa(r.la().G?m:a,b,c,h,e)),l))return l}};
	k.Zh=function(a,b,c,d,e){return void 0!==this.Aa(a,b,c,af,this,d,e)};function Kh(a,b){var c=w(b).toString();if(c in a.c)return a.c[c];var d=b.Dd(a);a.c[c]=d;a.v[c]=B(d,"change",a.ll,a);return d}k.ll=function(){this.j.render()};k.vg=na;k.gp=function(a,b){for(var c in this.c)if(!(b&&c in b.layerStates)){var d=c,e=this.c[d];delete this.c[d];rc(this.v[d]);delete this.v[d];Ac(e)}};function Lh(a,b){for(var c in a.c)if(!(c in b.layerStates)){b.postRenderFunctions.push(a.gp.bind(a));break}}
	function ka(a,b){return a.zIndex-b.zIndex};function Mh(a,b,c,d,e){Bc.call(this,a);this.vectorContext=b;this.frameState=c;this.context=d;this.glContext=e}u(Mh,Bc);var Nh=[0,0,0,1],Oh=[],Ph=[0,0,0,1];function Qh(a,b,c,d){b&&(a.translate(c,d),a.rotate(b),a.translate(-c,-d))};function Rh(){}k=Rh.prototype;k.mc=function(){};k.pd=function(){};k.$b=function(){};k.oe=function(){};k.pe=function(){};k.Qb=function(){};k.nc=function(){};k.oc=function(){};k.pc=function(){};k.qc=function(){};k.rc=function(){};k.xc=function(){};k.Na=function(){};k.Vb=function(){};k.Tb=function(){};function Sh(a,b,c,d,e){this.f=a;this.I=b;this.c=c;this.u=d;this.mb=e;this.M=this.b=this.a=this.$a=this.S=this.R=null;this.eb=this.Y=this.o=this.G=this.C=this.A=0;this.ea=!1;this.i=this.ia=0;this.oa=!1;this.qa=0;this.Fa="";this.Ja=this.Zb=0;this.Ha=!1;this.l=this.Oa=0;this.ta=this.j=this.g=null;this.v=[];this.lb=wh()}u(Sh,Rh);
	function Th(a,b,c){if(a.M){b=df(b,0,c,2,a.u,a.v);c=a.f;var d=a.lb,e=c.globalAlpha;1!=a.o&&(c.globalAlpha=e*a.o);var f=a.ia;a.ea&&(f+=a.mb);var g,h;g=0;for(h=b.length;g<h;g+=2){var l=b[g]-a.A,m=b[g+1]-a.C;a.oa&&(l=Math.round(l),m=Math.round(m));if(f||1!=a.i){var p=l+a.A,n=m+a.C;Fh(d,p,n,a.i,a.i,f,-p,-n);c.setTransform.apply(c,d)}c.drawImage(a.M,a.Y,a.eb,a.qa,a.G,l,m,a.qa,a.G)}(f||1!=a.i)&&c.setTransform(1,0,0,1,0,0);1!=a.o&&(c.globalAlpha=e)}}
	function Uh(a,b,c,d){var e=0;if(a.ta&&""!==a.Fa){a.g&&Vh(a,a.g);a.j&&Wh(a,a.j);var f=a.ta,g=a.f,h=a.$a;h?(h.font!=f.font&&(h.font=g.font=f.font),h.textAlign!=f.textAlign&&(h.textAlign=g.textAlign=f.textAlign),h.textBaseline!=f.textBaseline&&(h.textBaseline=g.textBaseline=f.textBaseline)):(g.font=f.font,g.textAlign=f.textAlign,g.textBaseline=f.textBaseline,a.$a={font:f.font,textAlign:f.textAlign,textBaseline:f.textBaseline});b=df(b,e,c,d,a.u,a.v);f=a.f;g=a.Oa;for(a.Ha&&(g+=a.mb);e<c;e+=d){var h=b[e]+
	a.Zb,l=b[e+1]+a.Ja;if(g||1!=a.l){var m=Fh(a.lb,h,l,a.l,a.l,g,-h,-l);f.setTransform.apply(f,m)}a.j&&f.strokeText(a.Fa,h,l);a.g&&f.fillText(a.Fa,h,l)}(g||1!=a.l)&&f.setTransform(1,0,0,1,0,0)}}function Xh(a,b,c,d,e,f){var g=a.f;a=df(b,c,d,e,a.u,a.v);g.moveTo(a[0],a[1]);b=a.length;f&&(b-=2);for(c=2;c<b;c+=2)g.lineTo(a[c],a[c+1]);f&&g.closePath();return d}function Yh(a,b,c,d,e){var f,g;f=0;for(g=d.length;f<g;++f)c=Xh(a,b,c,d[f],e,!0);return c}k=Sh.prototype;
	k.$b=function(a){if(mb(this.c,a.D())){if(this.a||this.b){this.a&&Vh(this,this.a);this.b&&Wh(this,this.b);var b;b=this.u;var c=this.v,d=a.ha();b=d?df(d,0,d.length,a.sa(),b,c):null;c=b[2]-b[0];d=b[3]-b[1];c=Math.sqrt(c*c+d*d);d=this.f;d.beginPath();d.arc(b[0],b[1],c,0,2*Math.PI);this.a&&d.fill();this.b&&d.stroke()}""!==this.Fa&&Uh(this,a.Ba(),2,2)}};k.pd=function(a){this.Na(a.Ca(),a.Da());this.Vb(a.Z());this.Tb(a.Pa())};
	k.mc=function(a){switch(a.T()){case "Point":this.qc(a);break;case "LineString":this.Qb(a);break;case "Polygon":this.rc(a);break;case "MultiPoint":this.oc(a);break;case "MultiLineString":this.nc(a);break;case "MultiPolygon":this.pc(a);break;case "GeometryCollection":this.pe(a);break;case "Circle":this.$b(a)}};k.oe=function(a,b){var c=(0,b.Ra)(a);c&&mb(this.c,c.D())&&(this.pd(b),this.mc(c))};k.pe=function(a){a=a.a;var b,c;b=0;for(c=a.length;b<c;++b)this.mc(a[b])};
	k.qc=function(a){var b=a.ha();a=a.sa();this.M&&Th(this,b,b.length);""!==this.Fa&&Uh(this,b,b.length,a)};k.oc=function(a){var b=a.ha();a=a.sa();this.M&&Th(this,b,b.length);""!==this.Fa&&Uh(this,b,b.length,a)};k.Qb=function(a){if(mb(this.c,a.D())){if(this.b){Wh(this,this.b);var b=this.f,c=a.ha();b.beginPath();Xh(this,c,0,c.length,a.sa(),!1);b.stroke()}""!==this.Fa&&(a=Zh(a),Uh(this,a,2,2))}};
	k.nc=function(a){var b=a.D();if(mb(this.c,b)){if(this.b){Wh(this,this.b);var b=this.f,c=a.ha(),d=0,e=a.Rb(),f=a.sa();b.beginPath();var g,h;g=0;for(h=e.length;g<h;++g)d=Xh(this,c,d,e[g],f,!1);b.stroke()}""!==this.Fa&&(a=$h(a),Uh(this,a,a.length,2))}};k.rc=function(a){if(mb(this.c,a.D())){if(this.b||this.a){this.a&&Vh(this,this.a);this.b&&Wh(this,this.b);var b=this.f;b.beginPath();Yh(this,a.fc(),0,a.Rb(),a.sa());this.a&&b.fill();this.b&&b.stroke()}""!==this.Fa&&(a=Lf(a),Uh(this,a,2,2))}};
	k.pc=function(a){if(mb(this.c,a.D())){if(this.b||this.a){this.a&&Vh(this,this.a);this.b&&Wh(this,this.b);var b=this.f,c=ai(a),d=0,e=a.c,f=a.sa(),g,h;b.beginPath();g=0;for(h=e.length;g<h;++g)d=Yh(this,c,d,e[g],f);this.a&&b.fill();this.b&&b.stroke()}""!==this.Fa&&(a=bi(a),Uh(this,a,a.length,2))}};function Vh(a,b){var c=a.f,d=a.R;d?d.fillStyle!=b.fillStyle&&(d.fillStyle=c.fillStyle=b.fillStyle):(c.fillStyle=b.fillStyle,a.R={fillStyle:b.fillStyle})}
	function Wh(a,b){var c=a.f,d=a.S;d?(d.lineCap!=b.lineCap&&(d.lineCap=c.lineCap=b.lineCap),Ld&&!ia(d.lineDash,b.lineDash)&&c.setLineDash(d.lineDash=b.lineDash),d.lineJoin!=b.lineJoin&&(d.lineJoin=c.lineJoin=b.lineJoin),d.lineWidth!=b.lineWidth&&(d.lineWidth=c.lineWidth=b.lineWidth),d.miterLimit!=b.miterLimit&&(d.miterLimit=c.miterLimit=b.miterLimit),d.strokeStyle!=b.strokeStyle&&(d.strokeStyle=c.strokeStyle=b.strokeStyle)):(c.lineCap=b.lineCap,Ld&&c.setLineDash(b.lineDash),c.lineJoin=b.lineJoin,c.lineWidth=
	b.lineWidth,c.miterLimit=b.miterLimit,c.strokeStyle=b.strokeStyle,a.S={lineCap:b.lineCap,lineDash:b.lineDash,lineJoin:b.lineJoin,lineWidth:b.lineWidth,miterLimit:b.miterLimit,strokeStyle:b.strokeStyle})}
	k.Na=function(a,b){if(a){var c=a.b;this.a={fillStyle:Vc(c?c:Nh)}}else this.a=null;if(b){var c=b.a,d=b.i,e=b.f,f=b.g,g=b.l,h=b.c,l=b.j;this.b={lineCap:void 0!==d?d:"round",lineDash:e?e:Oh,lineDashOffset:f?f:0,lineJoin:void 0!==g?g:"round",lineWidth:this.I*(void 0!==h?h:1),miterLimit:void 0!==l?l:10,strokeStyle:Vc(c?c:Ph)}}else this.b=null};
	k.Vb=function(a){if(a){var b=a.Hc(),c=a.Z(1),d=a.Pc(),e=a.jc();this.A=b[0];this.C=b[1];this.G=e[1];this.M=c;this.o=a.g;this.Y=d[0];this.eb=d[1];this.ea=a.o;this.ia=a.l;this.i=a.c;this.oa=a.v;this.qa=e[0]}else this.M=null};
	k.Tb=function(a){if(a){var b=a.Ca();b?(b=b.b,this.g={fillStyle:Vc(b?b:Nh)}):this.g=null;var c=a.Da();if(c){var b=c.a,d=c.i,e=c.f,f=c.g,g=c.l,h=c.c,c=c.j;this.j={lineCap:void 0!==d?d:"round",lineDash:e?e:Oh,lineDashOffset:f?f:0,lineJoin:void 0!==g?g:"round",lineWidth:void 0!==h?h:1,miterLimit:void 0!==c?c:10,strokeStyle:Vc(b?b:Ph)}}else this.j=null;var b=a.a,d=a.f,e=a.c,f=a.j,g=a.i,h=a.b,c=a.Pa(),l=a.g;a=a.l;this.ta={font:void 0!==b?b:"10px sans-serif",textAlign:void 0!==l?l:"center",textBaseline:void 0!==
	a?a:"middle"};this.Fa=void 0!==c?c:"";this.Zb=void 0!==d?this.I*d:0;this.Ja=void 0!==e?this.I*e:0;this.Ha=void 0!==f?f:!1;this.Oa=void 0!==g?g:0;this.l=this.I*(void 0!==h?h:1)}else this.Fa=""};function ci(a,b){Hh.call(this,0,b);this.f=Xc();this.b=this.f.canvas;this.b.style.width="100%";this.b.style.height="100%";this.b.style.display="block";this.b.className="ol-unselectable";a.insertBefore(this.b,a.childNodes[0]||null);this.a=!0;this.i=wh()}u(ci,Hh);
	function di(a,b,c){var d=a.j,e=a.f;if(Ec(d,b)){var f=c.extent,g=c.pixelRatio,h=c.viewState.rotation,l=c.viewState,m=c.pixelRatio/l.resolution;a=Fh(a.i,a.b.width/2,a.b.height/2,m,-m,-l.rotation,-l.center[0],-l.center[1]);d.b(new Mh(b,new Sh(e,g,f,a,h),c,e,null))}}ci.prototype.T=function(){return"canvas"};
	ci.prototype.vg=function(a){if(a){var b=this.f,c=a.pixelRatio,d=Math.round(a.size[0]*c),e=Math.round(a.size[1]*c);this.b.width!=d||this.b.height!=e?(this.b.width=d,this.b.height=e):b.clearRect(0,0,d,e);c=a.viewState.rotation;Ih(a);di(this,"precompose",a);var f=a.layerStatesArray;ja(f);c&&(b.save(),Qh(b,c,d/2,e/2));var d=a.viewState.resolution,g,h,l,e=0;for(g=f.length;e<g;++e)l=f[e],h=l.layer,h=Kh(this,h),sh(l,d)&&"ready"==l.Ui&&h.qd(a,l)&&h.I(a,l,b);c&&b.restore();di(this,"postcompose",a);this.a||
	(this.b.style.display="",this.a=!0);Lh(this,a);a.postRenderFunctions.push(Jh)}else this.a&&(this.b.style.display="none",this.a=!1)};ci.prototype.Yh=function(a,b,c,d,e,f){var g,h=b.viewState.resolution,l=b.layerStatesArray,m=l.length;a=Bh(b.pixelToCoordinateTransform,a.slice());for(--m;0<=m;--m){g=l[m];var p=g.layer;if(sh(g,h)&&e.call(f,p)&&(g=Kh(this,p).v(a,b,c,d)))return g}};var ei=["Polygon","Circle","LineString","Image","Text"];function fi(){};function gi(a){this.b=a};function hi(a){this.b=a}u(hi,gi);hi.prototype.T=function(){return 35632};function ii(a){this.b=a}u(ii,gi);ii.prototype.T=function(){return 35633};function ji(){this.b="precision mediump float;varying vec2 a;varying vec2 b;varying float c;varying float d;uniform float m;uniform vec4 n;uniform vec4 o;uniform vec2 p;void main(void){vec2 windowCenter=vec2((a.x+1.0)/2.0*p.x*d,(a.y+1.0)/2.0*p.y*d);vec2 windowOffset=vec2((b.x+1.0)/2.0*p.x*d,(b.y+1.0)/2.0*p.y*d);float radius=length(windowCenter-windowOffset);float dist=length(windowCenter-gl_FragCoord.xy);if(dist>radius+c){if(o.a==0.0){gl_FragColor=n;}else{gl_FragColor=o;}gl_FragColor.a=gl_FragColor.a-(dist-(radius+c));}else if(n.a==0.0){gl_FragColor=o;if(dist<radius-c){gl_FragColor.a=gl_FragColor.a-(radius-c-dist);}} else{gl_FragColor=n;float strokeDist=radius-c;float antialias=2.0*d;if(dist>strokeDist){gl_FragColor=o;}else if(dist>=strokeDist-antialias){float step=smoothstep(strokeDist-antialias,strokeDist,dist);gl_FragColor=mix(n,o,step);}} gl_FragColor.a=gl_FragColor.a*m;if(gl_FragColor.a<=0.0){discard;}}"}
	u(ji,hi);var ki=new ji;
	function li(){this.b="varying vec2 a;varying vec2 b;varying float c;varying float d;attribute vec2 e;attribute float f;attribute float g;uniform mat4 h;uniform mat4 i;uniform mat4 j;uniform float k;uniform float l;void main(void){mat4 offsetMatrix=i*j;a=vec4(h*vec4(e,0.0,1.0)).xy;d=l;float lineWidth=k*l;c=lineWidth/2.0;if(lineWidth==0.0){lineWidth=2.0*l;}vec2 offset;float radius=g+3.0*l;if(f==0.0){offset=vec2(-1.0,1.0);}else if(f==1.0){offset=vec2(-1.0,-1.0);}else if(f==2.0){offset=vec2(1.0,-1.0);}else{offset=vec2(1.0,1.0);}gl_Position=h*vec4(e+offset*radius,0.0,1.0)+offsetMatrix*vec4(offset*lineWidth,0.0,0.0);b=vec4(h*vec4(e.x+g,e.y,0.0,1.0)).xy;if(distance(a,b)>20000.0){gl_Position=vec4(a,0.0,1.0);}}"}
	u(li,ii);var mi=new li;function ni(a,b){this.G=a.getUniformLocation(b,"n");this.qa=a.getUniformLocation(b,"k");this.c=a.getUniformLocation(b,"j");this.i=a.getUniformLocation(b,"i");this.a=a.getUniformLocation(b,"m");this.ta=a.getUniformLocation(b,"l");this.f=a.getUniformLocation(b,"h");this.R=a.getUniformLocation(b,"p");this.S=a.getUniformLocation(b,"o");this.l=a.getAttribLocation(b,"f");this.b=a.getAttribLocation(b,"e");this.u=a.getAttribLocation(b,"g")};function oi(){return[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1]}function pi(a,b){a[0]=b[0];a[1]=b[1];a[4]=b[2];a[5]=b[3];a[12]=b[4];a[13]=b[5];return a};function qi(a,b){this.origin=jb(b);this.mb=wh();this.Oa=wh();this.lb=wh();this.Ja=oi();this.b=[];this.o=null;this.f=[];this.g=[];this.a=[];this.v=null;this.l=void 0}u(qi,Rh);
	qi.prototype.i=function(a,b,c,d,e,f,g,h,l,m,p){var n=a.b,q,r,v,x,y,z,A,V;this.l&&(q=n.isEnabled(n.STENCIL_TEST),r=n.getParameter(n.STENCIL_FUNC),v=n.getParameter(n.STENCIL_VALUE_MASK),x=n.getParameter(n.STENCIL_REF),y=n.getParameter(n.STENCIL_WRITEMASK),z=n.getParameter(n.STENCIL_FAIL),A=n.getParameter(n.STENCIL_PASS_DEPTH_PASS),V=n.getParameter(n.STENCIL_PASS_DEPTH_FAIL),n.enable(n.STENCIL_TEST),n.clear(n.STENCIL_BUFFER_BIT),n.stencilMask(255),n.stencilFunc(n.ALWAYS,1,255),n.stencilOp(n.KEEP,n.KEEP,
	n.REPLACE),this.l.i(a,b,c,d,e,f,g,h,l,m,p),n.stencilMask(0),n.stencilFunc(n.NOTEQUAL,1,255));ri(a,34962,this.v);ri(a,34963,this.o);f=this.ff(n,a,e,f);var Pa=xh(this.mb);Dh(Pa,2/(c*e[0]),2/(c*e[1]));Ch(Pa,-d);Eh(Pa,-(b[0]-this.origin[0]),-(b[1]-this.origin[1]));b=xh(this.lb);Dh(b,2/e[0],2/e[1]);e=xh(this.Oa);d&&Ch(e,-d);n.uniformMatrix4fv(f.f,!1,pi(this.Ja,Pa));n.uniformMatrix4fv(f.i,!1,pi(this.Ja,b));n.uniformMatrix4fv(f.c,!1,pi(this.Ja,e));n.uniform1f(f.a,g);var ra;l?(m?a=this.qe(n,a,h,l,p):(n.clear(n.COLOR_BUFFER_BIT|
	n.DEPTH_BUFFER_BIT),this.Md(n,a,h,!0),a=(a=l(null))?a:void 0),ra=a):this.Md(n,a,h,!1);this.gf(n,f);this.l&&(q||n.disable(n.STENCIL_TEST),n.clear(n.STENCIL_BUFFER_BIT),n.stencilFunc(r,x,v),n.stencilMask(y),n.stencilOp(z,V,A));return ra};function si(a,b,c,d){a.drawElements(4,d-c,b.g?5125:5123,c*(b.g?4:2))};var ti=[0,0,0,1],ui=[],vi=[0,0,0,1];function wi(a,b,c,d,e,f){a=(c-a)*(f-b)-(e-a)*(d-b);return a<=xi&&a>=-xi?void 0:0<a}var xi=Number.EPSILON||2.220446049250313E-16;function yi(a){this.b=void 0!==a?a:[];this.a=zi}var zi=35044;function Ai(a,b){qi.call(this,0,b);this.I=null;this.j=[];this.u=[];this.A=0;this.c={fillColor:null,strokeColor:null,lineDash:null,lineDashOffset:void 0,lineWidth:void 0,s:!1}}u(Ai,qi);k=Ai.prototype;
	k.$b=function(a,b){var c=a.Vd(),d=a.sa();if(c){this.f.push(this.b.length);this.g.push(b);this.c.s&&(this.u.push(this.b.length),this.c.s=!1);this.A=c;var c=a.ha(),c=ef(c,2,d,-this.origin[0],-this.origin[1]),e=this.a.length,f=this.b.length,g=e/4,h;for(h=0;2>h;h+=d)this.a[e++]=c[h],this.a[e++]=c[h+1],this.a[e++]=0,this.a[e++]=this.A,this.a[e++]=c[h],this.a[e++]=c[h+1],this.a[e++]=1,this.a[e++]=this.A,this.a[e++]=c[h],this.a[e++]=c[h+1],this.a[e++]=2,this.a[e++]=this.A,this.a[e++]=c[h],this.a[e++]=c[h+
	1],this.a[e++]=3,this.a[e++]=this.A,this.b[f++]=g,this.b[f++]=g+1,this.b[f++]=g+2,this.b[f++]=g+2,this.b[f++]=g+3,this.b[f++]=g,g+=4}else this.c.s&&(this.j.pop(),this.j.length&&(d=this.j[this.j.length-1],this.c.fillColor=d[0],this.c.strokeColor=d[1],this.c.lineWidth=d[2],this.c.s=!1))};k.Bb=function(){this.v=new yi(this.a);this.o=new yi(this.b);this.f.push(this.b.length);!this.u.length&&0<this.j.length&&(this.j=[]);this.b=this.a=null};
	k.Cb=function(a){var b=this.v,c=this.o;return function(){Bi(a,b);Bi(a,c)}};k.ff=function(a,b,c,d){var e=Ci(b,ki,mi),f;this.I?f=this.I:this.I=f=new ni(a,e);b.Rc(e);a.enableVertexAttribArray(f.b);a.vertexAttribPointer(f.b,2,5126,!1,16,0);a.enableVertexAttribArray(f.l);a.vertexAttribPointer(f.l,1,5126,!1,16,8);a.enableVertexAttribArray(f.u);a.vertexAttribPointer(f.u,1,5126,!1,16,12);a.uniform2fv(f.R,c);a.uniform1f(f.ta,d);return f};
	k.gf=function(a,b){a.disableVertexAttribArray(b.b);a.disableVertexAttribArray(b.l);a.disableVertexAttribArray(b.u)};
	k.Md=function(a,b,c){if(sb(c)){var d,e,f;e=this.f[this.f.length-1];for(c=this.u.length-1;0<=c;--c)d=this.u[c],f=this.j[c],a.uniform4fv(this.I.G,f[0]),Di(this,a,f[1],f[2]),si(a,b,d,e),e=d}else{var g,h,l,m;l=this.f.length-2;f=e=this.f[l+1];for(d=this.u.length-1;0<=d;--d){g=this.j[d];a.uniform4fv(this.I.G,g[0]);Di(this,a,g[1],g[2]);for(g=this.u[d];0<=l&&this.f[l]>=g;)m=this.f[l],h=this.g[l],h=w(h).toString(),c[h]&&(e!==f&&si(a,b,e,f),f=m),l--,e=m;e!==f&&si(a,b,e,f);e=f=g}}};
	k.qe=function(a,b,c,d,e){var f,g,h,l,m,p,n;n=this.f.length-2;h=this.f[n+1];for(f=this.u.length-1;0<=f;--f)for(g=this.j[f],a.uniform4fv(this.I.G,g[0]),Di(this,a,g[1],g[2]),l=this.u[f];0<=n&&this.f[n]>=l;){g=this.f[n];m=this.g[n];p=w(m).toString();if(void 0===c[p]&&m.U()&&(void 0===e||mb(e,m.U().D()))&&(a.clear(a.COLOR_BUFFER_BIT|a.DEPTH_BUFFER_BIT),si(a,b,g,h),h=d(m)))return h;n--;h=g}};function Di(a,b,c,d){b.uniform4fv(a.I.S,c);b.uniform1f(a.I.qa,d)}
	k.Na=function(a,b){var c,d;b?(c=b.f,this.c.lineDash=c?c:ui,c=b.g,this.c.lineDashOffset=c?c:0,c=b.a,c instanceof CanvasGradient||c instanceof CanvasPattern?c=vi:c=Qc(c).map(function(a,b){return 3!=b?a/255:a})||vi,d=b.c,d=void 0!==d?d:1):(c=[0,0,0,0],d=0);var e=a?a.b:[0,0,0,0];e instanceof CanvasGradient||e instanceof CanvasPattern?e=ti:e=Qc(e).map(function(a,b){return 3!=b?a/255:a})||ti;this.c.strokeColor&&ia(this.c.strokeColor,c)&&this.c.fillColor&&ia(this.c.fillColor,e)&&this.c.lineWidth===d||(this.c.s=
	!0,this.c.fillColor=e,this.c.strokeColor=c,this.c.lineWidth=d,this.j.push([e,c,d]))};function Ei(){this.b="precision mediump float;varying vec2 a;varying float b;uniform float k;uniform sampler2D l;void main(void){vec4 texColor=texture2D(l,a);gl_FragColor.rgb=texColor.rgb;float alpha=texColor.a*b*k;if(alpha==0.0){discard;}gl_FragColor.a=alpha;}"}u(Ei,hi);var Fi=new Ei;
	function Gi(){this.b="varying vec2 a;varying float b;attribute vec2 c;attribute vec2 d;attribute vec2 e;attribute float f;attribute float g;uniform mat4 h;uniform mat4 i;uniform mat4 j;void main(void){mat4 offsetMatrix=i;if(g==1.0){offsetMatrix=i*j;}vec4 offsets=offsetMatrix*vec4(e,0.0,0.0);gl_Position=h*vec4(c,0.0,1.0)+offsets;a=d;b=f;}"}u(Gi,ii);var Hi=new Gi;
	function Ii(a,b){this.c=a.getUniformLocation(b,"j");this.i=a.getUniformLocation(b,"i");this.a=a.getUniformLocation(b,"k");this.f=a.getUniformLocation(b,"h");this.v=a.getAttribLocation(b,"e");this.I=a.getAttribLocation(b,"f");this.b=a.getAttribLocation(b,"c");this.A=a.getAttribLocation(b,"g");this.C=a.getAttribLocation(b,"d")};function Ji(a,b){this.l=a;this.b=b;this.a={};this.c={};this.f={};this.o=this.v=this.i=this.j=null;(this.g=ea(ca,"OES_element_index_uint"))&&b.getExtension("OES_element_index_uint");B(this.l,"webglcontextlost",this.mo,this);B(this.l,"webglcontextrestored",this.no,this)}u(Ji,zc);
	function ri(a,b,c){var d=a.b,e=c.b,f=String(w(c));if(f in a.a)d.bindBuffer(b,a.a[f].buffer);else{var g=d.createBuffer();d.bindBuffer(b,g);var h;34962==b?h=new Float32Array(e):34963==b&&(h=a.g?new Uint32Array(e):new Uint16Array(e));d.bufferData(b,h,c.a);a.a[f]={lc:c,buffer:g}}}function Bi(a,b){var c=a.b,d=String(w(b)),e=a.a[d];c.isContextLost()||c.deleteBuffer(e.buffer);delete a.a[d]}k=Ji.prototype;
	k.ra=function(){yc(this.l);var a=this.b;if(!a.isContextLost()){for(var b in this.a)a.deleteBuffer(this.a[b].buffer);for(b in this.f)a.deleteProgram(this.f[b]);for(b in this.c)a.deleteShader(this.c[b]);a.deleteFramebuffer(this.i);a.deleteRenderbuffer(this.o);a.deleteTexture(this.v)}};k.lo=function(){return this.b};
	function Ki(a){if(!a.i){var b=a.b,c=b.createFramebuffer();b.bindFramebuffer(b.FRAMEBUFFER,c);var d=Li(b,1,1),e=b.createRenderbuffer();b.bindRenderbuffer(b.RENDERBUFFER,e);b.renderbufferStorage(b.RENDERBUFFER,b.DEPTH_COMPONENT16,1,1);b.framebufferTexture2D(b.FRAMEBUFFER,b.COLOR_ATTACHMENT0,b.TEXTURE_2D,d,0);b.framebufferRenderbuffer(b.FRAMEBUFFER,b.DEPTH_ATTACHMENT,b.RENDERBUFFER,e);b.bindTexture(b.TEXTURE_2D,null);b.bindRenderbuffer(b.RENDERBUFFER,null);b.bindFramebuffer(b.FRAMEBUFFER,null);a.i=c;
	a.v=d;a.o=e}return a.i}function Mi(a,b){var c=String(w(b));if(c in a.c)return a.c[c];var d=a.b,e=d.createShader(b.T());d.shaderSource(e,b.b);d.compileShader(e);return a.c[c]=e}function Ci(a,b,c){var d=w(b)+"/"+w(c);if(d in a.f)return a.f[d];var e=a.b,f=e.createProgram();e.attachShader(f,Mi(a,b));e.attachShader(f,Mi(a,c));e.linkProgram(f);return a.f[d]=f}k.mo=function(){qb(this.a);qb(this.c);qb(this.f);this.o=this.v=this.i=this.j=null};k.no=function(){};
	k.Rc=function(a){if(a==this.j)return!1;this.b.useProgram(a);this.j=a;return!0};function Ni(a,b,c){var d=a.createTexture();a.bindTexture(a.TEXTURE_2D,d);a.texParameteri(a.TEXTURE_2D,a.TEXTURE_MAG_FILTER,a.LINEAR);a.texParameteri(a.TEXTURE_2D,a.TEXTURE_MIN_FILTER,a.LINEAR);void 0!==b&&a.texParameteri(3553,10242,b);void 0!==c&&a.texParameteri(3553,10243,c);return d}function Li(a,b,c){var d=Ni(a,void 0,void 0);a.texImage2D(a.TEXTURE_2D,0,a.RGBA,b,c,0,a.RGBA,a.UNSIGNED_BYTE,null);return d}
	function Oi(a,b){var c=Ni(a,33071,33071);a.texImage2D(a.TEXTURE_2D,0,a.RGBA,a.RGBA,a.UNSIGNED_BYTE,b);return c};function Pi(a,b){qi.call(this,0,b);this.G=this.C=void 0;this.A=[];this.I=[];this.ta=void 0;this.j=[];this.c=[];this.S=this.R=void 0;this.qa=null;this.oa=this.ia=this.ea=this.eb=this.Y=this.$a=void 0;this.Ha=[];this.u=[];this.Zb=void 0}u(Pi,qi);k=Pi.prototype;k.Cb=function(a){var b=this.v,c=this.o,d=this.Ha,e=this.u,f=a.b;return function(){if(!f.isContextLost()){var g,h;g=0;for(h=d.length;g<h;++g)f.deleteTexture(d[g]);g=0;for(h=e.length;g<h;++g)f.deleteTexture(e[g])}Bi(a,b);Bi(a,c)}};
	function Qi(a,b,c,d){var e=a.C,f=a.G,g=a.ta,h=a.R,l=a.S,m=a.$a,p=a.Y,n=a.eb,q=a.ea?1:0,r=-a.ia,v=a.oa,x=a.Zb,y=Math.cos(r),r=Math.sin(r),z=a.b.length,A=a.a.length,V,Pa,ra,La,C,Ma;for(V=0;V<c;V+=d)C=b[V]-a.origin[0],Ma=b[V+1]-a.origin[1],Pa=A/8,ra=-v*e,La=-v*(g-f),a.a[A++]=C,a.a[A++]=Ma,a.a[A++]=ra*y-La*r,a.a[A++]=ra*r+La*y,a.a[A++]=p/l,a.a[A++]=(n+g)/h,a.a[A++]=m,a.a[A++]=q,ra=v*(x-e),La=-v*(g-f),a.a[A++]=C,a.a[A++]=Ma,a.a[A++]=ra*y-La*r,a.a[A++]=ra*r+La*y,a.a[A++]=(p+x)/l,a.a[A++]=(n+g)/h,a.a[A++]=
	m,a.a[A++]=q,ra=v*(x-e),La=v*f,a.a[A++]=C,a.a[A++]=Ma,a.a[A++]=ra*y-La*r,a.a[A++]=ra*r+La*y,a.a[A++]=(p+x)/l,a.a[A++]=n/h,a.a[A++]=m,a.a[A++]=q,ra=-v*e,La=v*f,a.a[A++]=C,a.a[A++]=Ma,a.a[A++]=ra*y-La*r,a.a[A++]=ra*r+La*y,a.a[A++]=p/l,a.a[A++]=n/h,a.a[A++]=m,a.a[A++]=q,a.b[z++]=Pa,a.b[z++]=Pa+1,a.b[z++]=Pa+2,a.b[z++]=Pa,a.b[z++]=Pa+2,a.b[z++]=Pa+3}k.oc=function(a,b){this.f.push(this.b.length);this.g.push(b);var c=a.ha();Qi(this,c,c.length,a.sa())};
	k.qc=function(a,b){this.f.push(this.b.length);this.g.push(b);var c=a.ha();Qi(this,c,c.length,a.sa())};k.Bb=function(a){a=a.b;this.A.push(this.b.length);this.I.push(this.b.length);this.v=new yi(this.a);this.o=new yi(this.b);var b={};Ri(this.Ha,this.j,b,a);Ri(this.u,this.c,b,a);this.ta=this.G=this.C=void 0;this.c=this.j=null;this.S=this.R=void 0;this.b=null;this.oa=this.ia=this.ea=this.eb=this.Y=this.$a=void 0;this.a=null;this.Zb=void 0};
	function Ri(a,b,c,d){var e,f,g,h=b.length;for(g=0;g<h;++g)e=b[g],f=w(e).toString(),f in c?e=c[f]:(e=Oi(d,e),c[f]=e),a[g]=e}
	k.ff=function(a,b){var c=Ci(b,Fi,Hi),d;this.qa?d=this.qa:this.qa=d=new Ii(a,c);b.Rc(c);a.enableVertexAttribArray(d.b);a.vertexAttribPointer(d.b,2,5126,!1,32,0);a.enableVertexAttribArray(d.v);a.vertexAttribPointer(d.v,2,5126,!1,32,8);a.enableVertexAttribArray(d.C);a.vertexAttribPointer(d.C,2,5126,!1,32,16);a.enableVertexAttribArray(d.I);a.vertexAttribPointer(d.I,1,5126,!1,32,24);a.enableVertexAttribArray(d.A);a.vertexAttribPointer(d.A,1,5126,!1,32,28);return d};
	k.gf=function(a,b){a.disableVertexAttribArray(b.b);a.disableVertexAttribArray(b.v);a.disableVertexAttribArray(b.C);a.disableVertexAttribArray(b.I);a.disableVertexAttribArray(b.A)};
	k.Md=function(a,b,c,d){var e=d?this.u:this.Ha;d=d?this.I:this.A;if(sb(c)){var f,g;c=0;f=e.length;for(g=0;c<f;++c){a.bindTexture(3553,e[c]);var h=d[c];si(a,b,g,h);g=h}}else for(g=f=0,h=e.length;g<h;++g){a.bindTexture(3553,e[g]);for(var l=0<g?d[g-1]:0,m=d[g],p=l;f<this.f.length&&this.f[f]<=m;){var n=w(this.g[f]).toString();void 0!==c[n]?(p!==l&&si(a,b,p,l),l=p=f===this.f.length-1?m:this.f[f+1]):l=f===this.f.length-1?m:this.f[f+1];f++}p!==l&&si(a,b,p,l)}};
	k.qe=function(a,b,c,d,e){var f,g,h,l,m,p,n=this.f.length-1;for(f=this.u.length-1;0<=f;--f)for(a.bindTexture(3553,this.u[f]),g=0<f?this.I[f-1]:0,l=this.I[f];0<=n&&this.f[n]>=g;){h=this.f[n];m=this.g[n];p=w(m).toString();if(void 0===c[p]&&m.U()&&(void 0===e||mb(e,m.U().D()))&&(a.clear(a.COLOR_BUFFER_BIT|a.DEPTH_BUFFER_BIT),si(a,b,h,l),l=d(m)))return l;l=h;n--}};
	k.Vb=function(a){var b=a.Hc(),c=a.Z(1),d=a.ue(),e=a.cg(1),f=a.g,g=a.Pc(),h=a.o,l=a.l,m=a.jc();a=a.c;var p;this.j.length?(p=this.j[this.j.length-1],w(p)!=w(c)&&(this.A.push(this.b.length),this.j.push(c))):this.j.push(c);this.c.length?(p=this.c[this.c.length-1],w(p)!=w(e)&&(this.I.push(this.b.length),this.c.push(e))):this.c.push(e);this.C=b[0];this.G=b[1];this.ta=m[1];this.R=d[1];this.S=d[0];this.$a=f;this.Y=g[0];this.eb=g[1];this.ia=l;this.ea=h;this.oa=a;this.Zb=m[0]};function Si(a,b,c){var d=b-c;return a[0]===a[d]&&a[1]===a[d+1]&&3<(b-0)/c?!!kf(a,0,b,c):!1};function Ti(){this.b="precision mediump float;varying float a;varying vec2 b;varying float c;uniform float m;uniform vec4 n;uniform vec2 o;uniform float p;void main(void){if(a>0.0){vec2 windowCoords=vec2((b.x+1.0)/2.0*o.x*p,(b.y+1.0)/2.0*o.y*p);if(length(windowCoords-gl_FragCoord.xy)>c*p){discard;}} gl_FragColor=n;float alpha=n.a*m;if(alpha==0.0){discard;}gl_FragColor.a=alpha;}"}u(Ti,hi);var Ui=new Ti;
	function Vi(){this.b="varying float a;varying vec2 b;varying float c;attribute vec2 d;attribute vec2 e;attribute vec2 f;attribute float g;uniform mat4 h;uniform mat4 i;uniform mat4 j;uniform float k;uniform float l;bool nearlyEquals(in float value,in float ref){float epsilon=0.000000000001;return value>=ref-epsilon&&value<=ref+epsilon;}void alongNormal(out vec2 offset,in vec2 nextP,in float turnDir,in float direction){vec2 dirVect=nextP-e;vec2 normal=normalize(vec2(-turnDir*dirVect.y,turnDir*dirVect.x));offset=k/2.0*normal*direction;}void miterUp(out vec2 offset,out float round,in bool isRound,in float direction){float halfWidth=k/2.0;vec2 tangent=normalize(normalize(f-e)+normalize(e-d));vec2 normal=vec2(-tangent.y,tangent.x);vec2 dirVect=f-e;vec2 tmpNormal=normalize(vec2(-dirVect.y,dirVect.x));float miterLength=abs(halfWidth/dot(normal,tmpNormal));offset=normal*direction*miterLength;round=0.0;if(isRound){round=1.0;}else if(miterLength>l+k){offset=halfWidth*tmpNormal*direction;}} bool miterDown(out vec2 offset,in vec4 projPos,in mat4 offsetMatrix,in float direction){bool degenerate=false;vec2 tangent=normalize(normalize(f-e)+normalize(e-d));vec2 normal=vec2(-tangent.y,tangent.x);vec2 dirVect=d-e;vec2 tmpNormal=normalize(vec2(-dirVect.y,dirVect.x));vec2 longOffset,shortOffset,longVertex;vec4 shortProjVertex;float halfWidth=k/2.0;if(length(f-e)>length(d-e)){longOffset=tmpNormal*direction*halfWidth;shortOffset=normalize(vec2(dirVect.y,-dirVect.x))*direction*halfWidth;longVertex=f;shortProjVertex=h*vec4(d,0.0,1.0);}else{shortOffset=tmpNormal*direction*halfWidth;longOffset=normalize(vec2(dirVect.y,-dirVect.x))*direction*halfWidth;longVertex=d;shortProjVertex=h*vec4(f,0.0,1.0);}vec4 p1=h*vec4(longVertex,0.0,1.0)+offsetMatrix*vec4(longOffset,0.0,0.0);vec4 p2=projPos+offsetMatrix*vec4(longOffset,0.0,0.0);vec4 p3=shortProjVertex+offsetMatrix*vec4(-shortOffset,0.0,0.0);vec4 p4=shortProjVertex+offsetMatrix*vec4(shortOffset,0.0,0.0);float denom=(p4.y-p3.y)*(p2.x-p1.x)-(p4.x-p3.x)*(p2.y-p1.y);float firstU=((p4.x-p3.x)*(p1.y-p3.y)-(p4.y-p3.y)*(p1.x-p3.x))/denom;float secondU=((p2.x-p1.x)*(p1.y-p3.y)-(p2.y-p1.y)*(p1.x-p3.x))/denom;float epsilon=0.000000000001;if(firstU>epsilon&&firstU<1.0-epsilon&&secondU>epsilon&&secondU<1.0-epsilon){shortProjVertex.x=p1.x+firstU*(p2.x-p1.x);shortProjVertex.y=p1.y+firstU*(p2.y-p1.y);offset=shortProjVertex.xy;degenerate=true;}else{float miterLength=abs(halfWidth/dot(normal,tmpNormal));offset=normal*direction*miterLength;}return degenerate;}void squareCap(out vec2 offset,out float round,in bool isRound,in vec2 nextP,in float turnDir,in float direction){round=0.0;vec2 dirVect=e-nextP;vec2 firstNormal=normalize(dirVect);vec2 secondNormal=vec2(turnDir*firstNormal.y*direction,-turnDir*firstNormal.x*direction);vec2 hypotenuse=normalize(firstNormal-secondNormal);vec2 normal=vec2(turnDir*hypotenuse.y*direction,-turnDir*hypotenuse.x*direction);float length=sqrt(c*c*2.0);offset=normal*length;if(isRound){round=1.0;}} void main(void){bool degenerate=false;float direction=float(sign(g));mat4 offsetMatrix=i*j;vec2 offset;vec4 projPos=h*vec4(e,0.0,1.0);bool round=nearlyEquals(mod(g,2.0),0.0);a=0.0;c=k/2.0;b=projPos.xy;if(nearlyEquals(mod(g,3.0),0.0)||nearlyEquals(mod(g,17.0),0.0)){alongNormal(offset,f,1.0,direction);}else if(nearlyEquals(mod(g,5.0),0.0)||nearlyEquals(mod(g,13.0),0.0)){alongNormal(offset,d,-1.0,direction);}else if(nearlyEquals(mod(g,23.0),0.0)){miterUp(offset,a,round,direction);}else if(nearlyEquals(mod(g,19.0),0.0)){degenerate=miterDown(offset,projPos,offsetMatrix,direction);}else if(nearlyEquals(mod(g,7.0),0.0)){squareCap(offset,a,round,f,1.0,direction);}else if(nearlyEquals(mod(g,11.0),0.0)){squareCap(offset,a,round,d,-1.0,direction);}if(!degenerate){vec4 offsets=offsetMatrix*vec4(offset,0.0,0.0);gl_Position=projPos+offsets;}else{gl_Position=vec4(offset,0.0,1.0);}}"}
	u(Vi,ii);var Wi=new Vi;function Xi(a,b){this.G=a.getUniformLocation(b,"n");this.qa=a.getUniformLocation(b,"k");this.S=a.getUniformLocation(b,"l");this.c=a.getUniformLocation(b,"j");this.i=a.getUniformLocation(b,"i");this.a=a.getUniformLocation(b,"m");this.ta=a.getUniformLocation(b,"p");this.f=a.getUniformLocation(b,"h");this.R=a.getUniformLocation(b,"o");this.g=a.getAttribLocation(b,"g");this.j=a.getAttribLocation(b,"d");this.o=a.getAttribLocation(b,"f");this.b=a.getAttribLocation(b,"e")};function Yi(a,b){qi.call(this,0,b);this.I=null;this.u=[];this.j=[];this.c={strokeColor:null,lineCap:void 0,lineDash:null,lineDashOffset:void 0,lineJoin:void 0,lineWidth:void 0,miterLimit:void 0,s:!1}}u(Yi,qi);
	function Zi(a,b,c,d){var e,f=a.a.length,g=a.b.length,h="bevel"===a.c.lineJoin?0:"miter"===a.c.lineJoin?1:2,l="butt"===a.c.lineCap?0:"square"===a.c.lineCap?1:2,m=Si(b,c,d),p,n,q,r=g,v=1,x,y,z;for(e=0;e<c;e+=d){q=f/7;x=y;y=z||[b[e],b[e+1]];if(e)if(e===c-d){m?z=p:(x=x||[0,0],f=$i(a,x,y,[0,0],v*aj*(l||1),f),f=$i(a,x,y,[0,0],-v*aj*(l||1),f),a.b[g++]=q,a.b[g++]=r-1,a.b[g++]=r,a.b[g++]=r,a.b[g++]=q+1,a.b[g++]=q,l&&(f=$i(a,x,y,[0,0],v*bj*l,f),f=$i(a,x,y,[0,0],-v*bj*l,f),a.b[g++]=q+2,a.b[g++]=q,a.b[g++]=q+
	1,a.b[g++]=q+1,a.b[g++]=q+3,a.b[g++]=q+2));break}else z=[b[e+d],b[e+d+1]];else{z=[b[e+d],b[e+d+1]];if(c-0===2*d&&ia(y,z))break;if(m)x=[b[c-2*d],b[c-2*d+1]],p=z;else{l&&(f=$i(a,[0,0],y,z,v*cj*l,f),f=$i(a,[0,0],y,z,-v*cj*l,f),a.b[g++]=q+2,a.b[g++]=q,a.b[g++]=q+1,a.b[g++]=q+1,a.b[g++]=q+3,a.b[g++]=q+2);f=$i(a,[0,0],y,z,v*dj*(l||1),f);f=$i(a,[0,0],y,z,-v*dj*(l||1),f);r=f/7-1;continue}}n=wi(x[0],x[1],y[0],y[1],z[0],z[1])?-1:1;f=$i(a,x,y,z,n*ej*(h||1),f);f=$i(a,x,y,z,n*fj*(h||1),f);f=$i(a,x,y,z,-n*gj*(h||
	1),f);0<e&&(a.b[g++]=q,a.b[g++]=r-1,a.b[g++]=r,a.b[g++]=q+2,a.b[g++]=q,a.b[g++]=0<v*n?r:r-1);a.b[g++]=q;a.b[g++]=q+2;a.b[g++]=q+1;r=q+2;v=n;h&&(f=$i(a,x,y,z,n*hj*h,f),a.b[g++]=q+1,a.b[g++]=q+3,a.b[g++]=q)}m&&(q=q||f/7,n=Hf([x[0],x[1],y[0],y[1],z[0],z[1]],0,6,2)?1:-1,f=$i(a,x,y,z,n*ej*(h||1),f),$i(a,x,y,z,-n*gj*(h||1),f),a.b[g++]=q,a.b[g++]=r-1,a.b[g++]=r,a.b[g++]=q+1,a.b[g++]=q,a.b[g++]=0<v*n?r:r-1)}
	function $i(a,b,c,d,e,f){a.a[f++]=b[0];a.a[f++]=b[1];a.a[f++]=c[0];a.a[f++]=c[1];a.a[f++]=d[0];a.a[f++]=d[1];a.a[f++]=e;return f}function ij(a,b,c){b-=0;return b<2*c?!1:b===2*c?!ia([a[0],a[1]],[a[0+c],a[c+1]]):!0}k=Yi.prototype;k.Qb=function(a,b){var c=a.ha(),d=a.sa();ij(c,c.length,d)&&(c=ef(c,c.length,d,-this.origin[0],-this.origin[1]),this.c.s&&(this.j.push(this.b.length),this.c.s=!1),this.f.push(this.b.length),this.g.push(b),Zi(this,c,c.length,d))};
	k.nc=function(a,b){var c=this.b.length,d=a.hd(),e,f;e=0;for(f=d.length;e<f;++e){var g=d[e].ha(),h=d[e].sa();ij(g,g.length,h)&&(g=ef(g,g.length,h,-this.origin[0],-this.origin[1]),Zi(this,g,g.length,h))}this.b.length>c&&(this.f.push(c),this.g.push(b),this.c.s&&(this.j.push(c),this.c.s=!1))};
	function jj(a,b,c,d){Si(b,b.length,d)||(b.push(b[0]),b.push(b[1]));Zi(a,b,b.length,d);if(c.length){var e;b=0;for(e=c.length;b<e;++b)Si(c[b],c[b].length,d)||(c[b].push(c[b][0]),c[b].push(c[b][1])),Zi(a,c[b],c[b].length,d)}}function kj(a,b,c){c=void 0===c?a.b.length:c;a.f.push(c);a.g.push(b);a.c.s&&(a.j.push(c),a.c.s=!1)}k.Bb=function(){this.v=new yi(this.a);this.o=new yi(this.b);this.f.push(this.b.length);!this.j.length&&0<this.u.length&&(this.u=[]);this.b=this.a=null};
	k.Cb=function(a){var b=this.v,c=this.o;return function(){Bi(a,b);Bi(a,c)}};k.ff=function(a,b,c,d){var e=Ci(b,Ui,Wi),f;this.I?f=this.I:this.I=f=new Xi(a,e);b.Rc(e);a.enableVertexAttribArray(f.j);a.vertexAttribPointer(f.j,2,5126,!1,28,0);a.enableVertexAttribArray(f.b);a.vertexAttribPointer(f.b,2,5126,!1,28,8);a.enableVertexAttribArray(f.o);a.vertexAttribPointer(f.o,2,5126,!1,28,16);a.enableVertexAttribArray(f.g);a.vertexAttribPointer(f.g,1,5126,!1,28,24);a.uniform2fv(f.R,c);a.uniform1f(f.ta,d);return f};
	k.gf=function(a,b){a.disableVertexAttribArray(b.j);a.disableVertexAttribArray(b.b);a.disableVertexAttribArray(b.o);a.disableVertexAttribArray(b.g)};
	k.Md=function(a,b,c,d){var e=a.getParameter(a.DEPTH_FUNC),f=a.getParameter(a.DEPTH_WRITEMASK);d||(a.enable(a.DEPTH_TEST),a.depthMask(!0),a.depthFunc(a.NOTEQUAL));if(sb(c)){var g,h,l;h=this.f[this.f.length-1];for(c=this.j.length-1;0<=c;--c)g=this.j[c],l=this.u[c],lj(this,a,l[0],l[1],l[2]),si(a,b,g,h),a.clear(a.DEPTH_BUFFER_BIT),h=g}else{var m,p,n,q;n=this.f.length-2;l=h=this.f[n+1];for(g=this.j.length-1;0<=g;--g){m=this.u[g];lj(this,a,m[0],m[1],m[2]);for(m=this.j[g];0<=n&&this.f[n]>=m;)q=this.f[n],
	p=this.g[n],p=w(p).toString(),c[p]&&(h!==l&&(si(a,b,h,l),a.clear(a.DEPTH_BUFFER_BIT)),l=q),n--,h=q;h!==l&&(si(a,b,h,l),a.clear(a.DEPTH_BUFFER_BIT));h=l=m}}d||(a.disable(a.DEPTH_TEST),a.clear(a.DEPTH_BUFFER_BIT),a.depthMask(f),a.depthFunc(e))};
	k.qe=function(a,b,c,d,e){var f,g,h,l,m,p,n;n=this.f.length-2;h=this.f[n+1];for(f=this.j.length-1;0<=f;--f)for(g=this.u[f],lj(this,a,g[0],g[1],g[2]),l=this.j[f];0<=n&&this.f[n]>=l;){g=this.f[n];m=this.g[n];p=w(m).toString();if(void 0===c[p]&&m.U()&&(void 0===e||mb(e,m.U().D()))&&(a.clear(a.COLOR_BUFFER_BIT|a.DEPTH_BUFFER_BIT),si(a,b,g,h),h=d(m)))return h;n--;h=g}};function lj(a,b,c,d,e){b.uniform4fv(a.I.G,c);b.uniform1f(a.I.qa,d);b.uniform1f(a.I.S,e)}
	k.Na=function(a,b){var c=b.i;this.c.lineCap=void 0!==c?c:"round";c=b.f;this.c.lineDash=c?c:ui;c=b.g;this.c.lineDashOffset=c?c:0;c=b.l;this.c.lineJoin=void 0!==c?c:"round";c=b.a;c instanceof CanvasGradient||c instanceof CanvasPattern?c=vi:c=Qc(c).map(function(a,b){return 3!=b?a/255:a})||vi;var d=b.c,d=void 0!==d?d:1,e=b.j,e=void 0!==e?e:10;this.c.strokeColor&&ia(this.c.strokeColor,c)&&this.c.lineWidth===d&&this.c.miterLimit===e||(this.c.s=!0,this.c.strokeColor=c,this.c.lineWidth=d,this.c.miterLimit=
	e,this.u.push([c,d,e]))};var dj=3,aj=5,cj=7,bj=11,ej=13,fj=17,gj=19,hj=23;function mj(){this.b="precision mediump float;uniform vec4 e;uniform float f;void main(void){gl_FragColor=e;float alpha=e.a*f;if(alpha==0.0){discard;}gl_FragColor.a=alpha;}"}u(mj,hi);var nj=new mj;function oj(){this.b="attribute vec2 a;uniform mat4 b;uniform mat4 c;uniform mat4 d;void main(void){gl_Position=b*vec4(a,0.0,1.0);}"}u(oj,ii);var pj=new oj;
	function qj(a,b){this.G=a.getUniformLocation(b,"e");this.c=a.getUniformLocation(b,"d");this.i=a.getUniformLocation(b,"c");this.a=a.getUniformLocation(b,"f");this.f=a.getUniformLocation(b,"b");this.b=a.getAttribLocation(b,"a")};function rj(a){a=a||{};this.a=void 0!==a.color?a.color:null;this.i=a.lineCap;this.f=void 0!==a.lineDash?a.lineDash:null;this.g=a.lineDashOffset;this.l=a.lineJoin;this.j=a.miterLimit;this.c=a.width;this.b=void 0}k=rj.prototype;k.clone=function(){var a=this.a;return new rj({color:a&&a.slice?a.slice():a||void 0,lineCap:this.i,lineDash:this.f?this.f.slice():void 0,lineDashOffset:this.g,lineJoin:this.l,miterLimit:this.j,width:this.c})};k.ao=function(){return this.a};k.Ak=function(){return this.i};
	k.bo=function(){return this.f};k.Bk=function(){return this.g};k.Ck=function(){return this.l};k.Hk=function(){return this.j};k.co=function(){return this.c};k.eo=function(a){this.a=a;this.b=void 0};k.qp=function(a){this.i=a;this.b=void 0};k.setLineDash=function(a){this.f=a;this.b=void 0};k.rp=function(a){this.g=a;this.b=void 0};k.sp=function(a){this.l=a;this.b=void 0};k.tp=function(a){this.j=a;this.b=void 0};k.wp=function(a){this.c=a;this.b=void 0};function sj(a){this.b=this.a=this.f=void 0;this.i=void 0===a?!0:a;this.c=0}function tj(a){var b=a.b;if(b){var c=b.next,d=b.ub;c&&(c.ub=d);d&&(d.next=c);a.b=c||d;a.f===a.a?(a.b=void 0,a.f=void 0,a.a=void 0):a.f===b?a.f=a.b:a.a===b&&(a.a=d?a.b.ub:a.b);a.c--}}function uj(a){a.b=a.f;if(a.b)return a.b.data}function vj(a){if(a.b&&a.b.next)return a.b=a.b.next,a.b.data}function wj(a){if(a.b&&a.b.next)return a.b.next.data}function xj(a){if(a.b&&a.b.ub)return a.b=a.b.ub,a.b.data}
	function yj(a){if(a.b&&a.b.ub)return a.b.ub.data}function zj(a){if(a.b)return a.b.data}sj.prototype.concat=function(a){if(a.b){if(this.b){var b=this.b.next;this.b.next=a.f;a.f.ub=this.b;b.ub=a.a;a.a.next=b;this.c+=a.c}else this.b=a.b,this.f=a.f,this.a=a.a,this.c=a.c;a.b=void 0;a.f=void 0;a.a=void 0;a.c=0}};var Aj,Bj,Cj,Dj;
	(function(){var a={},b={ma:a};(function(c){if("object"===typeof a&&"undefined"!==typeof b)b.ma=c();else{var d;"undefined"!==typeof window?d=window:"undefined"!==typeof global?d=global:"undefined"!==typeof self?d=self:d=this;d.cq=c()}})(function(){return function d(a,b,g){function e(h,l){if(!b[h]){if(!a[h]){var m="function"==typeof require&&require;if(!l&&m)return require(h,!0);if(f)return f(h,!0);m=Error("Cannot find module '"+h+"'");throw m.code="MODULE_NOT_FOUND",m;}m=b[h]={ma:{}};a[h][0].call(m.ma,function(b){var d=
	a[h][1][b];return e(d?d:b)},m,m.ma,d,a,b,g)}return b[h].ma}for(var f="function"==typeof require&&require,m=0;m<g.length;m++)e(g[m]);return e}({1:[function(a,b){function d(a,b,f,g,q){f=f||0;g=g||a.length-1;for(q=q||h;g>f;){if(600<g-f){var l=g-f+1,m=b-f+1,p=Math.log(l),n=.5*Math.exp(2*p/3),p=.5*Math.sqrt(p*n*(l-n)/l)*(0>m-l/2?-1:1);d(a,b,Math.max(f,Math.floor(b-m*n/l+p)),Math.min(g,Math.floor(b+(l-m)*n/l+p)),q)}l=a[b];m=f;n=g;e(a,f,b);for(0<q(a[g],l)&&e(a,f,g);m<n;){e(a,m,n);m++;for(n--;0>q(a[m],l);)m++;
	for(;0<q(a[n],l);)n--}0===q(a[f],l)?e(a,f,n):(n++,e(a,n,g));n<=b&&(f=n+1);b<=n&&(g=n-1)}}function e(a,b,d){var e=a[b];a[b]=a[d];a[d]=e}function h(a,b){return a<b?-1:a>b?1:0}b.ma=d},{}],2:[function(a,b){function d(a,b){if(!(this instanceof d))return new d(a,b);this.wf=Math.max(4,a||9);this.Pg=Math.max(2,Math.ceil(.4*this.wf));b&&this.Lj(b);this.clear()}function e(a,b){h(a,0,a.children.length,b,a)}function h(a,b,d,e,f){f||(f=x(null));f.da=Infinity;f.fa=Infinity;f.ba=-Infinity;f.ja=-Infinity;for(var g;b<
	d;b++)g=a.children[b],l(f,a.hb?e(g):g);return f}function l(a,b){a.da=Math.min(a.da,b.da);a.fa=Math.min(a.fa,b.fa);a.ba=Math.max(a.ba,b.ba);a.ja=Math.max(a.ja,b.ja)}function m(a,b){return a.da-b.da}function p(a,b){return a.fa-b.fa}function n(a){return(a.ba-a.da)*(a.ja-a.fa)}function q(a){return a.ba-a.da+(a.ja-a.fa)}function r(a,b){return a.da<=b.da&&a.fa<=b.fa&&b.ba<=a.ba&&b.ja<=a.ja}function v(a,b){return b.da<=a.ba&&b.fa<=a.ja&&b.ba>=a.da&&b.ja>=a.fa}function x(a){return{children:a,height:1,hb:!0,
	da:Infinity,fa:Infinity,ba:-Infinity,ja:-Infinity}}function y(a,b,d,e,f){for(var g=[b,d],h;g.length;)d=g.pop(),b=g.pop(),d-b<=e||(h=b+Math.ceil((d-b)/e/2)*e,z(a,h,b,d,f),g.push(b,h,h,d))}b.ma=d;var z=a("quickselect");d.prototype={all:function(){return this.Kg(this.data,[])},search:function(a){var b=this.data,d=[],e=this.yb;if(!v(a,b))return d;for(var f=[],g,h,l,m;b;){g=0;for(h=b.children.length;g<h;g++)l=b.children[g],m=b.hb?e(l):l,v(a,m)&&(b.hb?d.push(l):r(a,m)?this.Kg(l,d):f.push(l));b=f.pop()}return d},
	load:function(a){if(!a||!a.length)return this;if(a.length<this.Pg){for(var b=0,d=a.length;b<d;b++)this.Ea(a[b]);return this}a=this.Mg(a.slice(),0,a.length-1,0);this.data.children.length?this.data.height===a.height?this.Rg(this.data,a):(this.data.height<a.height&&(b=this.data,this.data=a,a=b),this.Og(a,this.data.height-a.height-1,!0)):this.data=a;return this},Ea:function(a){a&&this.Og(a,this.data.height-1);return this},clear:function(){this.data=x([]);return this},remove:function(a,b){if(!a)return this;
	for(var d=this.data,e=this.yb(a),f=[],g=[],h,l,m,n;d||f.length;){d||(d=f.pop(),l=f[f.length-1],h=g.pop(),n=!0);if(d.hb){a:{m=a;var p=d.children,q=b;if(q){for(var v=0;v<p.length;v++)if(q(m,p[v])){m=v;break a}m=-1}else m=p.indexOf(m)}if(-1!==m){d.children.splice(m,1);f.push(d);this.Jj(f);break}}n||d.hb||!r(d,e)?l?(h++,d=l.children[h],n=!1):d=null:(f.push(d),g.push(h),h=0,l=d,d=d.children[0])}return this},yb:function(a){return a},Af:m,Bf:p,toJSON:function(){return this.data},Kg:function(a,b){for(var d=
	[];a;)a.hb?b.push.apply(b,a.children):d.push.apply(d,a.children),a=d.pop();return b},Mg:function(a,b,d,f){var g=d-b+1,h=this.wf,l;if(g<=h)return l=x(a.slice(b,d+1)),e(l,this.yb),l;f||(f=Math.ceil(Math.log(g)/Math.log(h)),h=Math.ceil(g/Math.pow(h,f-1)));l=x([]);l.hb=!1;l.height=f;var g=Math.ceil(g/h),h=g*Math.ceil(Math.sqrt(h)),m,n,p;for(y(a,b,d,h,this.Af);b<=d;b+=h)for(n=Math.min(b+h-1,d),y(a,b,n,g,this.Bf),m=b;m<=n;m+=g)p=Math.min(m+g-1,n),l.children.push(this.Mg(a,m,p,f-1));e(l,this.yb);return l},
	Ij:function(a,b,d,e){for(var f,g,h,l,m,p,q,r;;){e.push(b);if(b.hb||e.length-1===d)break;q=r=Infinity;f=0;for(g=b.children.length;f<g;f++)h=b.children[f],m=n(h),p=(Math.max(h.ba,a.ba)-Math.min(h.da,a.da))*(Math.max(h.ja,a.ja)-Math.min(h.fa,a.fa))-m,p<r?(r=p,q=m<q?m:q,l=h):p===r&&m<q&&(q=m,l=h);b=l||b.children[0]}return b},Og:function(a,b,d){var e=this.yb;d=d?a:e(a);var e=[],f=this.Ij(d,this.data,b,e);f.children.push(a);for(l(f,d);0<=b;)if(e[b].children.length>this.wf)this.Qj(e,b),b--;else break;this.Fj(d,
	e,b)},Qj:function(a,b){var d=a[b],f=d.children.length,g=this.Pg;this.Gj(d,g,f);f=this.Hj(d,g,f);f=x(d.children.splice(f,d.children.length-f));f.height=d.height;f.hb=d.hb;e(d,this.yb);e(f,this.yb);b?a[b-1].children.push(f):this.Rg(d,f)},Rg:function(a,b){this.data=x([a,b]);this.data.height=a.height+1;this.data.hb=!1;e(this.data,this.yb)},Hj:function(a,b,d){var e,f,g,l,m,p,q;m=p=Infinity;for(e=b;e<=d-b;e++)f=h(a,0,e,this.yb),g=h(a,e,d,this.yb),l=Math.max(0,Math.min(f.ba,g.ba)-Math.max(f.da,g.da))*Math.max(0,
	Math.min(f.ja,g.ja)-Math.max(f.fa,g.fa)),f=n(f)+n(g),l<m?(m=l,q=e,p=f<p?f:p):l===m&&f<p&&(p=f,q=e);return q},Gj:function(a,b,d){var e=a.hb?this.Af:m,f=a.hb?this.Bf:p,g=this.Lg(a,b,d,e);b=this.Lg(a,b,d,f);g<b&&a.children.sort(e)},Lg:function(a,b,d,e){a.children.sort(e);e=this.yb;var f=h(a,0,b,e),g=h(a,d-b,d,e),m=q(f)+q(g),p,n;for(p=b;p<d-b;p++)n=a.children[p],l(f,a.hb?e(n):n),m+=q(f);for(p=d-b-1;p>=b;p--)n=a.children[p],l(g,a.hb?e(n):n),m+=q(g);return m},Fj:function(a,b,d){for(;0<=d;d--)l(b[d],a)},
	Jj:function(a){for(var b=a.length-1,d;0<=b;b--)0===a[b].children.length?0<b?(d=a[b-1].children,d.splice(d.indexOf(a[b]),1)):this.clear():e(a[b],this.yb)},Lj:function(a){var b=["return a"," - b",";"];this.Af=new Function("a","b",b.join(a[0]));this.Bf=new Function("a","b",b.join(a[1]));this.yb=new Function("a","return {minX: a"+a[0]+", minY: a"+a[1]+", maxX: a"+a[2]+", maxY: a"+a[3]+"};")}}},{quickselect:1}]},{},[2])(2)});Aj=b.ma})();function Ej(a){this.b=Aj(a);this.a={}}k=Ej.prototype;k.Ea=function(a,b){var c={da:a[0],fa:a[1],ba:a[2],ja:a[3],value:b};this.b.Ea(c);this.a[w(b)]=c};k.load=function(a,b){for(var c=Array(b.length),d=0,e=b.length;d<e;d++){var f=a[d],g=b[d],f={da:f[0],fa:f[1],ba:f[2],ja:f[3],value:g};c[d]=f;this.a[w(g)]=f}this.b.load(c)};k.remove=function(a){a=w(a);var b=this.a[a];delete this.a[a];return null!==this.b.remove(b)};
	function Fj(a,b,c){var d=a.a[w(c)];Za([d.da,d.fa,d.ba,d.ja],b)||(a.remove(c),a.Ea(b,c))}function Gj(a){return a.b.all().map(function(a){return a.value})}function Hj(a,b){return a.b.search({da:b[0],fa:b[1],ba:b[2],ja:b[3]}).map(function(a){return a.value})}k.forEach=function(a,b){return Ij(Gj(this),a,b)};function Jj(a,b,c,d){return Ij(Hj(a,b),c,d)}function Ij(a,b,c){for(var d,e=0,f=a.length;e<f&&!(d=b.call(c,a[e]));e++);return d}k.clear=function(){this.b.clear();this.a={}};
	k.D=function(){var a=this.b.data;return[a.da,a.fa,a.ba,a.ja]};function Kj(a,b){qi.call(this,0,b);this.l=new Yi(0,b);this.I=null;this.u=[];this.c=[];this.j={fillColor:null,s:!1}}u(Kj,qi);function Lj(a,b,c,d){var e=new sj,f=new Ej;b=Mj(a,b,d,e,f,!0);if(c.length){var g,h,l=[];g=0;for(h=c.length;g<h;++g){var m={list:new sj,ba:void 0};l.push(m);m.ba=Mj(a,c[g],d,m.list,f,!1)}l.sort(function(a,b){return b.ba-a.ba});for(g=0;g<l.length;++g)Nj(l[g].list,l[g].ba,e,b,f)}Oj(e,f,!1);Pj(a,e,f)}
	function Mj(a,b,c,d,e,f){var g,h,l=a.a.length/2,m,p,n,q=[],r=[];if(f===Hf(b,0,b.length,c))for(p=m=Qj(a,b[0],b[1],l++),f=b[0],g=c,h=b.length;g<h;g+=c)n=Qj(a,b[g],b[g+1],l++),r.push(Rj(p,n,d)),q.push([Math.min(p.x,n.x),Math.min(p.y,n.y),Math.max(p.x,n.x),Math.max(p.y,n.y)]),f=b[g]>f?b[g]:f,p=n;else for(g=b.length-c,p=m=Qj(a,b[g],b[g+1],l++),f=b[g],g-=c,h=0;g>=h;g-=c)n=Qj(a,b[g],b[g+1],l++),r.push(Rj(p,n,d)),q.push([Math.min(p.x,n.x),Math.min(p.y,n.y),Math.max(p.x,n.x),Math.max(p.y,n.y)]),f=b[g]>f?b[g]:
	f,p=n;r.push(Rj(n,m,d));q.push([Math.min(p.x,n.x),Math.min(p.y,n.y),Math.max(p.x,n.x),Math.max(p.y,n.y)]);e.load(q,r);return f}function Oj(a,b,c){var d=uj(a),e=d,f=vj(a),g=!1;do{var h=c?wi(f.W.x,f.W.y,e.W.x,e.W.y,e.aa.x,e.aa.y):wi(e.aa.x,e.aa.y,e.W.x,e.W.y,f.W.x,f.W.y);void 0===h?(Sj(e,f,a,b),g=!0,f===d&&(d=wj(a)),f=e,xj(a)):e.W.vb!==h&&(e.W.vb=h,g=!0);e=f;f=vj(a)}while(e!==d);return g}
	function Nj(a,b,c,d,e){Oj(a,e,!0);for(var f=uj(a);f.W.x!==b;)f=vj(a);b=f.W;d={x:d,y:b.y,gb:-1};var g=Infinity,h,l,m,p;m=Tj({aa:b,W:d},e,!0);h=0;for(l=m.length;h<l;++h){var n=m[h];if(void 0===n.aa.vb){var q=Uj(b,d,n.aa,n.W,!0),r=Math.abs(b.x-q[0]);r<g&&(g=r,p={x:q[0],y:q[1],gb:-1},f=n)}}if(Infinity!==g){m=f.W;if(0<g&&(f=Vj(b,p,f.W,e),f.length))for(p=Infinity,h=0,l=f.length;h<l;++h)if(g=f[h],n=Math.atan2(b.y-g.y,d.x-g.x),n<p||n===p&&g.x<m.x)p=n,m=g;for(f=uj(c);f.W!==m;)f=vj(c);d={x:b.x,y:b.y,gb:b.gb,
	vb:void 0};h={x:f.W.x,y:f.W.y,gb:f.W.gb,vb:void 0};wj(a).aa=d;Rj(b,f.W,a,e);Rj(h,d,a,e);f.W=h;a.i&&a.b&&(a.f=a.b,a.a=a.b.ub);c.concat(a)}}
	function Pj(a,b,c){for(var d=!1,e=Wj(b,c);3<b.c;)if(e){if(!Xj(a,b,c,e,d)&&!Oj(b,c,d)&&!Yj(a,b,c,!0))break}else if(!Xj(a,b,c,e,d)&&!Oj(b,c,d)&&!Yj(a,b,c))if(e=Wj(b,c)){var d=b,f=2*d.c,g=Array(f),h=uj(d),l=h,m=0;do g[m++]=l.aa.x,g[m++]=l.aa.y,l=vj(d);while(l!==h);d=!Hf(g,0,f,2);Oj(b,c,d)}else{e=a;d=b;f=g=uj(d);do{h=Tj(f,c);if(h.length){g=h[0];h=Uj(f.aa,f.W,g.aa,g.W);h=Qj(e,h[0],h[1],e.a.length/2);l=new sj;m=new Ej;Rj(h,f.W,l,m);f.W=h;Fj(c,[Math.min(f.aa.x,h.x),Math.min(f.aa.y,h.y),Math.max(f.aa.x,h.x),
	Math.max(f.aa.y,h.y)],f);for(f=vj(d);f!==g;)Rj(f.aa,f.W,l,m),c.remove(f),tj(d),f=zj(d);Rj(g.aa,h,l,m);g.aa=h;Fj(c,[Math.min(g.W.x,h.x),Math.min(g.W.y,h.y),Math.max(g.W.x,h.x),Math.max(g.W.y,h.y)],g);Oj(d,c,!1);Pj(e,d,c);Oj(l,m,!1);Pj(e,l,m);break}f=vj(d)}while(f!==g);break}3===b.c&&(e=a.b.length,a.b[e++]=yj(b).aa.gb,a.b[e++]=zj(b).aa.gb,a.b[e++]=wj(b).aa.gb)}
	function Xj(a,b,c,d,e){var f=a.b.length,g=uj(b),h=yj(b),l=g,m=vj(b),p=wj(b),n,q,r,v=!1;do{n=l.aa;q=l.W;r=m.W;if(!1===q.vb){var x=e?Zj(p.W,r,q,n,h.aa):Zj(h.aa,n,q,r,p.W);!d&&Tj({aa:n,W:r},c).length||!x||Vj(n,q,r,c,!0).length||!d&&!1!==n.vb&&!1!==r.vb&&Hf([h.aa.x,h.aa.y,n.x,n.y,q.x,q.y,r.x,r.y,p.W.x,p.W.y],0,10,2)!==!e||(a.b[f++]=n.gb,a.b[f++]=q.gb,a.b[f++]=r.gb,Sj(l,m,b,c),m===g&&(g=p),v=!0)}h=yj(b);l=zj(b);m=vj(b);p=wj(b)}while(l!==g&&3<b.c);return v}
	function Yj(a,b,c,d){var e=uj(b);vj(b);var f=e,g=vj(b),h=!1;do{var l=Uj(f.aa,f.W,g.aa,g.W,d);if(l){var m,h=a.b.length,p=a.a.length/2,n=xj(b);tj(b);c.remove(n);m=n===e;d?(l[0]===f.aa.x&&l[1]===f.aa.y?(xj(b),l=f.aa,g.aa=l,c.remove(f),m=m||f===e):(l=g.W,f.W=l,c.remove(g),m=m||g===e),tj(b)):(l=Qj(a,l[0],l[1],p),f.W=l,g.aa=l,Fj(c,[Math.min(f.aa.x,f.W.x),Math.min(f.aa.y,f.W.y),Math.max(f.aa.x,f.W.x),Math.max(f.aa.y,f.W.y)],f),Fj(c,[Math.min(g.aa.x,g.W.x),Math.min(g.aa.y,g.W.y),Math.max(g.aa.x,g.W.x),Math.max(g.aa.y,
	g.W.y)],g));a.b[h++]=n.aa.gb;a.b[h++]=n.W.gb;a.b[h++]=l.gb;h=!0;if(m)break}f=yj(b);g=vj(b)}while(f!==e);return h}function Wj(a,b){var c=uj(a),d=c;do{if(Tj(d,b).length)return!1;d=vj(a)}while(d!==c);return!0}function Qj(a,b,c,d){var e=a.a.length;a.a[e++]=b;a.a[e++]=c;return{x:b,y:c,gb:d,vb:void 0}}
	function Rj(a,b,c,d){var e={aa:a,W:b},f={ub:void 0,next:void 0,data:e},g=c.b;if(g){var h=g.next;f.ub=g;f.next=h;g.next=f;h&&(h.ub=f);g===c.a&&(c.a=f)}else c.f=f,c.a=f,c.i&&(f.next=f,f.ub=f);c.b=f;c.c++;d&&d.Ea([Math.min(a.x,b.x),Math.min(a.y,b.y),Math.max(a.x,b.x),Math.max(a.y,b.y)],e);return e}function Sj(a,b,c,d){zj(c)===b&&(tj(c),a.W=b.W,d.remove(b),Fj(d,[Math.min(a.aa.x,a.W.x),Math.min(a.aa.y,a.W.y),Math.max(a.aa.x,a.W.x),Math.max(a.aa.y,a.W.y)],a))}
	function Vj(a,b,c,d,e){var f,g,h,l=[],m=Hj(d,[Math.min(a.x,b.x,c.x),Math.min(a.y,b.y,c.y),Math.max(a.x,b.x,c.x),Math.max(a.y,b.y,c.y)]);d=0;for(f=m.length;d<f;++d)for(g in m[d])h=m[d][g],"object"!==typeof h||e&&!h.vb||h.x===a.x&&h.y===a.y||h.x===b.x&&h.y===b.y||h.x===c.x&&h.y===c.y||-1!==l.indexOf(h)||!Bf([a.x,a.y,b.x,b.y,c.x,c.y],0,6,2,h.x,h.y)||l.push(h);return l}
	function Tj(a,b,c){var d=a.aa,e=a.W;b=Hj(b,[Math.min(d.x,e.x),Math.min(d.y,e.y),Math.max(d.x,e.x),Math.max(d.y,e.y)]);var f=[],g,h;g=0;for(h=b.length;g<h;++g){var l=b[g];a!==l&&(c||l.aa!==e||l.W!==d)&&Uj(d,e,l.aa,l.W,c)&&f.push(l)}return f}
	function Uj(a,b,c,d,e){var f=(d.y-c.y)*(b.x-a.x)-(d.x-c.x)*(b.y-a.y);if(f&&(d=((d.x-c.x)*(a.y-c.y)-(d.y-c.y)*(a.x-c.x))/f,c=((b.x-a.x)*(a.y-c.y)-(b.y-a.y)*(a.x-c.x))/f,!e&&d>xi&&d<1-xi&&c>xi&&c<1-xi||e&&0<=d&&1>=d&&0<=c&&1>=c))return[a.x+d*(b.x-a.x),a.y+d*(b.y-a.y)]}
	function Zj(a,b,c,d,e){if(void 0===b.vb||void 0===d.vb)return!1;var f=(c.x-d.x)*(b.y-d.y)>(c.y-d.y)*(b.x-d.x);e=(e.x-d.x)*(b.y-d.y)<(e.y-d.y)*(b.x-d.x);a=(a.x-b.x)*(d.y-b.y)>(a.y-b.y)*(d.x-b.x);c=(c.x-b.x)*(d.y-b.y)<(c.y-b.y)*(d.x-b.x);b=b.vb?c||a:c&&a;return(d.vb?e||f:e&&f)&&b}k=Kj.prototype;
	k.pc=function(a,b){var c=a.Od(),d=a.sa(),e=this.b.length,f=this.l.b.length,g,h,l,m;g=0;for(h=c.length;g<h;++g){var p=c[g].jd();if(0<p.length){var n=p[0].ha(),n=ef(n,n.length,d,-this.origin[0],-this.origin[1]),q=[],r;l=1;for(m=p.length;l<m;++l)r=p[l].ha(),r=ef(r,r.length,d,-this.origin[0],-this.origin[1]),q.push(r);jj(this.l,n,q,d);Lj(this,n,q,d)}}this.b.length>e&&(this.f.push(e),this.g.push(b),this.j.s&&(this.c.push(e),this.j.s=!1));this.l.b.length>f&&kj(this.l,b,f)};
	k.rc=function(a,b){var c=a.jd(),d=a.sa();if(0<c.length){this.f.push(this.b.length);this.g.push(b);this.j.s&&(this.c.push(this.b.length),this.j.s=!1);kj(this.l,b);var e=c[0].ha(),e=ef(e,e.length,d,-this.origin[0],-this.origin[1]),f=[],g,h,l;g=1;for(h=c.length;g<h;++g)l=c[g].ha(),l=ef(l,l.length,d,-this.origin[0],-this.origin[1]),f.push(l);jj(this.l,e,f,d);Lj(this,e,f,d)}};
	k.Bb=function(a){this.v=new yi(this.a);this.o=new yi(this.b);this.f.push(this.b.length);this.l.Bb(a);!this.c.length&&0<this.u.length&&(this.u=[]);this.b=this.a=null};k.Cb=function(a){var b=this.v,c=this.o,d=this.l.Cb(a);return function(){Bi(a,b);Bi(a,c);d()}};k.ff=function(a,b){var c=Ci(b,nj,pj),d;this.I?d=this.I:this.I=d=new qj(a,c);b.Rc(c);a.enableVertexAttribArray(d.b);a.vertexAttribPointer(d.b,2,5126,!1,8,0);return d};k.gf=function(a,b){a.disableVertexAttribArray(b.b)};
	k.Md=function(a,b,c,d){var e=a.getParameter(a.DEPTH_FUNC),f=a.getParameter(a.DEPTH_WRITEMASK);d||(a.enable(a.DEPTH_TEST),a.depthMask(!0),a.depthFunc(a.NOTEQUAL));if(sb(c)){var g,h,l;h=this.f[this.f.length-1];for(c=this.c.length-1;0<=c;--c)g=this.c[c],l=this.u[c],a.uniform4fv(this.I.G,l),si(a,b,g,h),h=g}else{var m,p,n,q;n=this.f.length-2;l=h=this.f[n+1];for(g=this.c.length-1;0<=g;--g){m=this.u[g];a.uniform4fv(this.I.G,m);for(m=this.c[g];0<=n&&this.f[n]>=m;)q=this.f[n],p=this.g[n],p=w(p).toString(),
	c[p]&&(h!==l&&(si(a,b,h,l),a.clear(a.DEPTH_BUFFER_BIT)),l=q),n--,h=q;h!==l&&(si(a,b,h,l),a.clear(a.DEPTH_BUFFER_BIT));h=l=m}}d||(a.disable(a.DEPTH_TEST),a.clear(a.DEPTH_BUFFER_BIT),a.depthMask(f),a.depthFunc(e))};
	k.qe=function(a,b,c,d,e){var f,g,h,l,m,p,n;n=this.f.length-2;h=this.f[n+1];for(f=this.c.length-1;0<=f;--f)for(g=this.u[f],a.uniform4fv(this.I.G,g),l=this.c[f];0<=n&&this.f[n]>=l;){g=this.f[n];m=this.g[n];p=w(m).toString();if(void 0===c[p]&&m.U()&&(void 0===e||mb(e,m.U().D()))&&(a.clear(a.COLOR_BUFFER_BIT|a.DEPTH_BUFFER_BIT),si(a,b,g,h),h=d(m)))return h;n--;h=g}};
	k.Na=function(a,b){var c=a?a.b:[0,0,0,0];c instanceof CanvasGradient||c instanceof CanvasPattern?c=ti:c=Qc(c).map(function(a,b){return 3!=b?a/255:a})||ti;this.j.fillColor&&ia(c,this.j.fillColor)||(this.j.fillColor=c,this.j.s=!0,this.u.push(c));b?this.l.Na(null,b):this.l.Na(null,new rj({color:[0,0,0,0],lineWidth:0}))};function ak(){}ak.prototype.i=function(){};function bk(a,b,c){this.g=b;this.l=a;this.c=c;this.a={}}u(bk,fi);function ck(a,b){var c=[],d;for(d in a.a){var e=a.a[d],f;for(f in e)c.push(e[f].Cb(b))}return function(){for(var a=c.length,b,d=0;d<a;d++)b=c[d].apply(this,arguments);return b}}function dk(a,b){for(var c in a.a){var d=a.a[c],e;for(e in d)d[e].Bb(b)}}bk.prototype.b=function(a,b){var c=void 0!==a?a.toString():"0",d=this.a[c];void 0===d&&(d={},this.a[c]=d);c=d[b];void 0===c&&(c=new ek[b](this.l,this.g),d[b]=c);return c};
	bk.prototype.f=function(){return sb(this.a)};bk.prototype.i=function(a,b,c,d,e,f,g,h){var l=Object.keys(this.a).map(Number);l.sort(da);var m,p,n,q,r,v;m=0;for(p=l.length;m<p;++m)for(r=this.a[l[m].toString()],n=0,q=ei.length;n<q;++n)v=r[ei[n]],void 0!==v&&v.i(a,b,c,d,e,f,g,h,void 0,!1)};
	function fk(a,b,c,d,e,f,g,h,l,m,p){var n=gk,q=Object.keys(a.a).map(Number);q.sort(function(a,b){return b-a});var r,v,x,y,z;r=0;for(v=q.length;r<v;++r)for(y=a.a[q[r].toString()],x=ei.length-1;0<=x;--x)if(z=y[ei[x]],void 0!==z&&(z=z.i(b,c,d,e,n,f,g,h,l,m,p)))return z}
	bk.prototype.Aa=function(a,b,c,d,e,f,g,h,l,m){var p=b.b;p.bindFramebuffer(p.FRAMEBUFFER,Ki(b));var n;void 0!==this.c&&(n=Ka(Wa(a),d*this.c));return fk(this,b,a,d,e,g,h,l,function(a){var b=new Uint8Array(4);p.readPixels(0,0,1,1,p.RGBA,p.UNSIGNED_BYTE,b);if(0<b[3]&&(a=m(a)))return a},!0,n)};
	function hk(a,b,c,d,e,f,g,h){var l=c.b;l.bindFramebuffer(l.FRAMEBUFFER,Ki(c));return void 0!==fk(a,c,b,d,e,f,g,h,function(){var a=new Uint8Array(4);l.readPixels(0,0,1,1,l.RGBA,l.UNSIGNED_BYTE,a);return 0<a[3]},!1)}var gk=[1,1],ek={Circle:Ai,Image:Pi,LineString:Yi,Polygon:Kj,Text:ak};function ik(a,b,c,d,e,f,g){this.b=a;this.f=b;this.a=f;this.c=g;this.l=e;this.g=d;this.i=c;this.j=this.o=this.v=null}u(ik,Rh);k=ik.prototype;k.pd=function(a){this.Na(a.Ca(),a.Da());this.Vb(a.Z())};
	k.mc=function(a){switch(a.T()){case "Point":this.qc(a,null);break;case "LineString":this.Qb(a,null);break;case "Polygon":this.rc(a,null);break;case "MultiPoint":this.oc(a,null);break;case "MultiLineString":this.nc(a,null);break;case "MultiPolygon":this.pc(a,null);break;case "GeometryCollection":this.pe(a,null);break;case "Circle":this.$b(a,null)}};k.oe=function(a,b){var c=(0,b.Ra)(a);c&&mb(this.a,c.D())&&(this.pd(b),this.mc(c))};k.pe=function(a){a=a.a;var b,c;b=0;for(c=a.length;b<c;++b)this.mc(a[b])};
	k.qc=function(a,b){var c=this.b,d=(new bk(1,this.a)).b(0,"Image");d.Vb(this.v);d.qc(a,b);d.Bb(c);d.i(this.b,this.f,this.i,this.g,this.l,this.c,1,{},void 0,!1);d.Cb(c)()};k.oc=function(a,b){var c=this.b,d=(new bk(1,this.a)).b(0,"Image");d.Vb(this.v);d.oc(a,b);d.Bb(c);d.i(this.b,this.f,this.i,this.g,this.l,this.c,1,{},void 0,!1);d.Cb(c)()};
	k.Qb=function(a,b){var c=this.b,d=(new bk(1,this.a)).b(0,"LineString");d.Na(null,this.j);d.Qb(a,b);d.Bb(c);d.i(this.b,this.f,this.i,this.g,this.l,this.c,1,{},void 0,!1);d.Cb(c)()};k.nc=function(a,b){var c=this.b,d=(new bk(1,this.a)).b(0,"LineString");d.Na(null,this.j);d.nc(a,b);d.Bb(c);d.i(this.b,this.f,this.i,this.g,this.l,this.c,1,{},void 0,!1);d.Cb(c)()};
	k.rc=function(a,b){var c=this.b,d=(new bk(1,this.a)).b(0,"Polygon");d.Na(this.o,this.j);d.rc(a,b);d.Bb(c);d.i(this.b,this.f,this.i,this.g,this.l,this.c,1,{},void 0,!1);d.Cb(c)()};k.pc=function(a,b){var c=this.b,d=(new bk(1,this.a)).b(0,"Polygon");d.Na(this.o,this.j);d.pc(a,b);d.Bb(c);d.i(this.b,this.f,this.i,this.g,this.l,this.c,1,{},void 0,!1);d.Cb(c)()};
	k.$b=function(a,b){var c=this.b,d=(new bk(1,this.a)).b(0,"Circle");d.Na(this.o,this.j);d.$b(a,b);d.Bb(c);d.i(this.b,this.f,this.i,this.g,this.l,this.c,1,{},void 0,!1);d.Cb(c)()};k.Vb=function(a){this.v=a};k.Na=function(a,b){this.o=a;this.j=b};function jk(){this.c=0;this.b={};this.f=this.a=null}k=jk.prototype;k.clear=function(){this.c=0;this.b={};this.f=this.a=null};k.forEach=function(a,b){for(var c=this.a;c;)a.call(b,c.$c,c.tc,this),c=c.Lb};k.get=function(a){a=this.b[a];qa(!!a,15);if(a===this.f)return a.$c;a===this.a?(this.a=this.a.Lb,this.a.td=null):(a.Lb.td=a.td,a.td.Lb=a.Lb);a.Lb=null;a.td=this.f;this.f=this.f.Lb=a;return a.$c};
	k.pop=function(){var a=this.a;delete this.b[a.tc];a.Lb&&(a.Lb.td=null);this.a=a.Lb;this.a||(this.f=null);--this.c;return a.$c};k.replace=function(a,b){this.get(a);this.b[a].$c=b};k.set=function(a,b){qa(!(a in this.b),16);var c={tc:a,Lb:null,td:this.f,$c:b};this.f?this.f.Lb=c:this.a=c;this.f=c;this.b[a]=c;++this.c};function kk(a,b){Hh.call(this,0,b);this.b=document.createElement("CANVAS");this.b.style.width="100%";this.b.style.height="100%";this.b.style.display="block";this.b.className="ol-unselectable";a.insertBefore(this.b,a.childNodes[0]||null);this.u=this.A=0;this.C=Xc();this.o=!0;this.f=Dd(this.b,{antialias:!0,depth:!0,failIfMajorPerformanceCaveat:!0,preserveDrawingBuffer:!1,stencil:!0});this.i=new Ji(this.b,this.f);B(this.b,"webglcontextlost",this.nn,this);B(this.b,"webglcontextrestored",this.pn,this);
	this.a=new jk;this.I=null;this.l=new Ae(function(a){var b=a[1];a=a[2];var c=b[0]-this.I[0],b=b[1]-this.I[1];return 65536*Math.log(a)+Math.sqrt(c*c+b*b)/a}.bind(this),function(a){return a[0].ib()});this.G=function(){if(this.l.b.length){Ee(this.l);var a=Be(this.l);lk(this,a[0],a[3],a[4])}return!1}.bind(this);this.g=0;mk(this)}u(kk,Hh);
	function lk(a,b,c,d){var e=a.f,f=b.ib();if(a.a.b.hasOwnProperty(f))a=a.a.get(f),e.bindTexture(3553,a.Fb),9729!=a.Bh&&(e.texParameteri(3553,10240,9729),a.Bh=9729),9729!=a.Dh&&(e.texParameteri(3553,10241,9729),a.Dh=9729);else{var g=e.createTexture();e.bindTexture(3553,g);if(0<d){var h=a.C.canvas,l=a.C;a.A!==c[0]||a.u!==c[1]?(h.width=c[0],h.height=c[1],a.A=c[0],a.u=c[1]):l.clearRect(0,0,c[0],c[1]);l.drawImage(b.Z(),d,d,c[0],c[1],0,0,c[0],c[1]);e.texImage2D(3553,0,6408,6408,5121,h)}else e.texImage2D(3553,
	0,6408,6408,5121,b.Z());e.texParameteri(3553,10240,9729);e.texParameteri(3553,10241,9729);e.texParameteri(3553,10242,33071);e.texParameteri(3553,10243,33071);a.a.set(f,{Fb:g,Bh:9729,Dh:9729})}}function nk(a,b,c){var d=a.j;if(Ec(d,b)){a=a.i;var e=c.viewState;d.b(new Mh(b,new ik(a,e.center,e.resolution,e.rotation,c.size,c.extent,c.pixelRatio),c,null,a))}}k=kk.prototype;k.ra=function(){var a=this.f;a.isContextLost()||this.a.forEach(function(b){b&&a.deleteTexture(b.Fb)});Ac(this.i);Hh.prototype.ra.call(this)};
	k.bk=function(a,b){for(var c=this.f,d;1024<this.a.c-this.g;){if(d=this.a.a.$c)c.deleteTexture(d.Fb);else if(+this.a.a.tc==b.index)break;else--this.g;this.a.pop()}};k.T=function(){return"webgl"};k.nn=function(a){a.preventDefault();this.a.clear();this.g=0;a=this.c;for(var b in a)a[b].$f()};k.pn=function(){mk(this);this.j.render()};function mk(a){a=a.f;a.activeTexture(33984);a.blendFuncSeparate(770,771,1,771);a.disable(2884);a.disable(2929);a.disable(3089);a.disable(2960)}
	k.vg=function(a){var b=this.i,c=this.f;if(c.isContextLost())return!1;if(!a)return this.o&&(this.b.style.display="none",this.o=!1),!1;this.I=a.focus;this.a.set((-a.index).toString(),null);++this.g;nk(this,"precompose",a);var d=[],e=a.layerStatesArray;ja(e);var f=a.viewState.resolution,g,h,l,m;g=0;for(h=e.length;g<h;++g)m=e[g],sh(m,f)&&"ready"==m.Ui&&(l=Kh(this,m.layer),l.ag(a,m,b)&&d.push(m));e=a.size[0]*a.pixelRatio;f=a.size[1]*a.pixelRatio;if(this.b.width!=e||this.b.height!=f)this.b.width=e,this.b.height=
	f;c.bindFramebuffer(36160,null);c.clearColor(0,0,0,0);c.clear(16384);c.enable(3042);c.viewport(0,0,this.b.width,this.b.height);g=0;for(h=d.length;g<h;++g)m=d[g],l=Kh(this,m.layer),l.ai(a,m,b);this.o||(this.b.style.display="",this.o=!0);Ih(a);1024<this.a.c-this.g&&a.postRenderFunctions.push(this.bk.bind(this));this.l.b.length&&(a.postRenderFunctions.push(this.G),a.animate=!0);nk(this,"postcompose",a);Lh(this,a);a.postRenderFunctions.push(Jh)};
	k.Aa=function(a,b,c,d,e,f,g){var h;if(this.f.isContextLost())return!1;var l=b.viewState,m=b.layerStatesArray,p;for(p=m.length-1;0<=p;--p){h=m[p];var n=h.layer;if(sh(h,l.resolution)&&f.call(g,n)&&(h=Kh(this,n).Aa(a,b,c,d,e)))return h}};k.Zh=function(a,b,c,d,e){c=!1;if(this.f.isContextLost())return!1;var f=b.viewState,g=b.layerStatesArray,h;for(h=g.length-1;0<=h;--h){var l=g[h],m=l.layer;if(sh(l,f.resolution)&&d.call(e,m)&&(c=Kh(this,m).Ke(a,b)))return!0}return c};
	k.Yh=function(a,b,c,d,e){if(this.f.isContextLost())return!1;var f=b.viewState,g,h=b.layerStatesArray,l;for(l=h.length-1;0<=l;--l){g=h[l];var m=g.layer;if(sh(g,f.resolution)&&e.call(d,m)&&(g=Kh(this,m).Zf(a,b,c,d)))return g}};var ok=["canvas","webgl"];
	function G(a){Gc.call(this);var b=pk(a);this.rf=void 0!==a.loadTilesWhileAnimating?a.loadTilesWhileAnimating:!1;this.sf=void 0!==a.loadTilesWhileInteracting?a.loadTilesWhileInteracting:!1;this.xf=void 0!==a.pixelRatio?a.pixelRatio:Kd;this.pf=b.logos;this.ia=function(){this.g=void 0;this.hp.call(this,Date.now())}.bind(this);this.mb=wh();this.yf=wh();this.Bd=0;this.a=null;this.lb=Ia();this.G=this.R=this.S=null;this.c=document.createElement("DIV");this.c.className="ol-viewport"+(Pd?" ol-touch":"");this.c.style.position=
	"relative";this.c.style.overflow="hidden";this.c.style.width="100%";this.c.style.height="100%";this.c.style.msTouchAction="none";this.c.style.touchAction="none";this.A=document.createElement("DIV");this.A.className="ol-overlaycontainer";this.c.appendChild(this.A);this.u=document.createElement("DIV");this.u.className="ol-overlaycontainer-stopevent";a="click dblclick mousedown touchstart mspointerdown pointerdown mousewheel wheel".split(" ");for(var c=0,d=a.length;c<d;++c)B(this.u,a[c],Cc);this.c.appendChild(this.u);
	this.Ja=new xe(this);for(var e in Ad)B(this.Ja,Ad[e],this.uh,this);this.oa=b.keyboardEventTarget;this.v=null;B(this.c,"wheel",this.ld,this);B(this.c,"mousewheel",this.ld,this);this.j=b.controls;this.l=b.interactions;this.o=b.overlays;this.dg={};this.C=new b.jp(this.c,this);this.Y=null;this.Oa=[];this.Ha=new Fe(this.Wk.bind(this),this.Cl.bind(this));this.ea={};B(this,Ic("layergroup"),this.kl,this);B(this,Ic("view"),this.Dl,this);B(this,Ic("size"),this.zl,this);B(this,Ic("target"),this.Bl,this);this.H(b.values);
	this.j.forEach(function(a){a.setMap(this)},this);B(this.j,"add",function(a){a.element.setMap(this)},this);B(this.j,"remove",function(a){a.element.setMap(null)},this);this.l.forEach(function(a){a.setMap(this)},this);B(this.l,"add",function(a){a.element.setMap(this)},this);B(this.l,"remove",function(a){a.element.setMap(null)},this);this.o.forEach(this.Ug,this);B(this.o,"add",function(a){this.Ug(a.element)},this);B(this.o,"remove",function(a){var b=a.element.g;void 0!==b&&delete this.dg[b.toString()];
	a.element.setMap(null)},this)}u(G,Gc);k=G.prototype;k.Rj=function(a){this.j.push(a)};k.Sj=function(a){this.l.push(a)};k.Sg=function(a){this.Jc().od().push(a)};k.Tg=function(a){this.o.push(a)};k.Ug=function(a){var b=a.g;void 0!==b&&(this.dg[b.toString()]=a);a.setMap(this)};
	k.ra=function(){Ac(this.Ja);Ac(this.C);xc(this.c,"wheel",this.ld,this);xc(this.c,"mousewheel",this.ld,this);this.i&&(window.removeEventListener("resize",this.i,!1),this.i=void 0);this.g&&(cancelAnimationFrame(this.g),this.g=void 0);this.Fe(null);Gc.prototype.ra.call(this)};k.re=function(a,b,c){if(this.a)return a=this.Za(a),c=c?c:{},this.C.Aa(a,this.a,void 0!==c.hitTolerance?c.hitTolerance*this.a.pixelRatio:0,b,null,c.layerFilter?c.layerFilter:af,null)};
	k.pm=function(a,b,c,d,e){if(this.a)return this.C.Yh(a,this.a,b,void 0!==c?c:null,d?d:af,void 0!==e?e:null)};k.El=function(a,b){if(!this.a)return!1;var c=this.Za(a);b=b?b:{};return this.C.Zh(c,this.a,void 0!==b.hitTolerance?b.hitTolerance*this.a.pixelRatio:0,b.layerFilter?b.layerFilter:af,null)};k.sk=function(a){return this.Za(this.te(a))};k.te=function(a){var b=this.c.getBoundingClientRect();a=a.changedTouches?a.changedTouches[0]:a;return[a.clientX-b.left,a.clientY-b.top]};k.Of=function(){return this.get("target")};
	k.Kc=function(){var a=this.Of();return void 0!==a?"string"===typeof a?document.getElementById(a):a:null};k.Za=function(a){var b=this.a;return b?Bh(b.pixelToCoordinateTransform,a.slice()):null};k.qk=function(){return this.j};k.Lk=function(){return this.o};k.Kk=function(a){a=this.dg[a.toString()];return void 0!==a?a:null};k.xk=function(){return this.l};k.Jc=function(){return this.get("layergroup")};k.Jh=function(){return this.Jc().od()};
	k.Ka=function(a){var b=this.a;return b?Bh(b.coordinateToPixelTransform,a.slice(0,2)):null};k.Mb=function(){return this.get("size")};k.$=function(){return this.get("view")};k.Yk=function(){return this.c};k.Wk=function(a,b,c,d){var e=this.a;if(!(e&&b in e.wantedTiles&&e.wantedTiles[b][a.ib()]))return Infinity;a=c[0]-e.focus[0];c=c[1]-e.focus[1];return 65536*Math.log(d)+Math.sqrt(a*a+c*c)/d};k.ld=function(a,b){var c=new zd(b||a.type,this,a);this.uh(c)};
	k.uh=function(a){if(this.a){this.Y=a.coordinate;a.frameState=this.a;var b=this.l.a,c;if(!1!==this.b(a))for(c=b.length-1;0<=c;c--){var d=b[c];if(d.c()&&!d.handleEvent(a))break}}};k.xl=function(){var a=this.a,b=this.Ha;if(b.b.length){var c=16,d=c;if(a){var e=a.viewHints;e[0]&&(c=this.rf?8:0,d=2);e[1]&&(c=this.sf?8:0,d=2)}b.l<c&&(Ee(b),Ge(b,c,d))}b=this.Oa;c=0;for(d=b.length;c<d;++c)b[c](this,a);b.length=0};k.zl=function(){this.render()};
	k.Bl=function(){var a;this.Of()&&(a=this.Kc());if(this.v){for(var b=0,c=this.v.length;b<c;++b)rc(this.v[b]);this.v=null}a?(a.appendChild(this.c),a=this.oa?this.oa:a,this.v=[B(a,"keydown",this.ld,this),B(a,"keypress",this.ld,this)],this.i||(this.i=this.xd.bind(this),window.addEventListener("resize",this.i,!1))):(Zc(this.c),this.i&&(window.removeEventListener("resize",this.i,!1),this.i=void 0));this.xd()};k.Cl=function(){this.render()};k.xh=function(){this.render()};
	k.Dl=function(){this.S&&(rc(this.S),this.S=null);this.R&&(rc(this.R),this.R=null);var a=this.$();a&&(this.c.setAttribute("data-view",w(a)),this.S=B(a,"propertychange",this.xh,this),this.R=B(a,"change",this.xh,this));this.render()};k.kl=function(){this.G&&(this.G.forEach(rc),this.G=null);var a=this.Jc();a&&(this.G=[B(a,"propertychange",this.render,this),B(a,"change",this.render,this)]);this.render()};k.ip=function(){this.g&&cancelAnimationFrame(this.g);this.ia()};
	k.render=function(){void 0===this.g&&(this.g=requestAnimationFrame(this.ia))};k.ap=function(a){return this.j.remove(a)};k.bp=function(a){return this.l.remove(a)};k.ep=function(a){return this.Jc().od().remove(a)};k.fp=function(a){return this.o.remove(a)};
	k.hp=function(a){var b,c,d=this.Mb(),e=this.$(),f=Ia(),g=null;if(void 0!==d&&0<d[0]&&0<d[1]&&e&&Yf(e)){var g=ld(e,this.a?this.a.viewHints:void 0),h=this.Jc().Lf(),l={};b=0;for(c=h.length;b<c;++b)l[w(h[b].layer)]=h[b];b=e.V();g={animate:!1,attributions:{},coordinateToPixelTransform:this.mb,extent:f,focus:this.Y?this.Y:b.center,index:this.Bd++,layerStates:l,layerStatesArray:h,logos:pb({},this.pf),pixelRatio:this.xf,pixelToCoordinateTransform:this.yf,postRenderFunctions:[],size:d,skippedFeatureUids:this.ea,
	tileQueue:this.Ha,time:a,usedTiles:{},viewState:b,viewHints:g,wantedTiles:{}}}g&&(g.extent=kb(b.center,b.resolution,b.rotation,g.size,f));this.a=g;this.C.vg(g);g&&(g.animate&&this.render(),Array.prototype.push.apply(this.Oa,g.postRenderFunctions),g.viewHints[0]||g.viewHints[1]||Za(g.extent,this.lb)||(this.b(new yd("moveend",this,g)),Na(g.extent,this.lb)));this.b(new yd("postrender",this,g));setTimeout(this.xl.bind(this),0)};k.Li=function(a){this.set("layergroup",a)};
	k.Ag=function(a){this.set("size",a)};k.Fe=function(a){this.set("target",a)};k.vp=function(a){this.set("view",a)};k.Ti=function(a){a=w(a).toString();this.ea[a]=!0;this.render()};k.xd=function(){var a=this.Kc();if(a){var b=getComputedStyle(a);this.Ag([a.offsetWidth-parseFloat(b.borderLeftWidth)-parseFloat(b.paddingLeft)-parseFloat(b.paddingRight)-parseFloat(b.borderRightWidth),a.offsetHeight-parseFloat(b.borderTopWidth)-parseFloat(b.paddingTop)-parseFloat(b.paddingBottom)-parseFloat(b.borderBottomWidth)])}else this.Ag(void 0)};
	k.Zi=function(a){a=w(a).toString();delete this.ea[a];this.render()};
	function pk(a){var b=null;void 0!==a.keyboardEventTarget&&(b="string"===typeof a.keyboardEventTarget?document.getElementById(a.keyboardEventTarget):a.keyboardEventTarget);var c={},d={};if(void 0===a.logo||"boolean"===typeof a.logo&&a.logo)d["data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAAHGAAABxgEXwfpGAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAhNQTFRF////AP//AICAgP//AFVVQECA////K1VVSbbbYL/fJ05idsTYJFtbbcjbJllmZszWWMTOIFhoHlNiZszTa9DdUcHNHlNlV8XRIVdiasrUHlZjIVZjaMnVH1RlIFRkH1RkH1ZlasvYasvXVsPQH1VkacnVa8vWIVZjIFRjVMPQa8rXIVVkXsXRsNveIFVkIFZlIVVj3eDeh6GmbMvXH1ZkIFRka8rWbMvXIFVkIFVjIFVkbMvWH1VjbMvWIFVlbcvWIFVla8vVIFVkbMvWbMvVH1VkbMvWIFVlbcvWIFVkbcvVbMvWjNPbIFVkU8LPwMzNIFVkbczWIFVkbsvWbMvXIFVkRnB8bcvW2+TkW8XRIFVkIlZlJVloJlpoKlxrLl9tMmJwOWd0Omh1RXF8TneCT3iDUHiDU8LPVMLPVcLPVcPQVsPPVsPQV8PQWMTQWsTQW8TQXMXSXsXRX4SNX8bSYMfTYcfTYsfTY8jUZcfSZsnUaIqTacrVasrVa8jTa8rWbI2VbMvWbcvWdJObdcvUdszUd8vVeJaee87Yfc3WgJyjhqGnitDYjaarldPZnrK2oNbborW5o9bbo9fbpLa6q9ndrL3ArtndscDDutzfu8fJwN7gwt7gxc/QyuHhy+HizeHi0NfX0+Pj19zb1+Tj2uXk29/e3uLg3+Lh3+bl4uXj4ufl4+fl5Ofl5ufl5ujm5+jmySDnBAAAAFp0Uk5TAAECAgMEBAYHCA0NDg4UGRogIiMmKSssLzU7PkJJT1JTVFliY2hrdHZ3foSFhYeJjY2QkpugqbG1tre5w8zQ09XY3uXn6+zx8vT09vf4+Pj5+fr6/P39/f3+gz7SsAAAAVVJREFUOMtjYKA7EBDnwCPLrObS1BRiLoJLnte6CQy8FLHLCzs2QUG4FjZ5GbcmBDDjxJBXDWxCBrb8aM4zbkIDzpLYnAcE9VXlJSWlZRU13koIeW57mGx5XjoMZEUqwxWYQaQbSzLSkYGfKFSe0QMsX5WbjgY0YS4MBplemI4BdGBW+DQ11eZiymfqQuXZIjqwyadPNoSZ4L+0FVM6e+oGI6g8a9iKNT3o8kVzNkzRg5lgl7p4wyRUL9Yt2jAxVh6mQCogae6GmflI8p0r13VFWTHBQ0rWPW7ahgWVcPm+9cuLoyy4kCJDzCm6d8PSFoh0zvQNC5OjDJhQopPPJqph1doJBUD5tnkbZiUEqaCnB3bTqLTFG1bPn71kw4b+GFdpLElKIzRxxgYgWNYc5SCENVHKeUaltHdXx0dZ8uBI1hJ2UUDgq82CM2MwKeibqAvSO7MCABq0wXEPiqWEAAAAAElFTkSuQmCC"]="https://openlayers.org/";
	else{var e=a.logo;"string"===typeof e?d[e]="":e instanceof HTMLElement?d[w(e).toString()]=e:e&&(qa("string"==typeof e.href,44),qa("string"==typeof e.src,45),d[e.src]=e.href)}e=a.layers instanceof fh?a.layers:new fh({layers:a.layers});c.layergroup=e;c.target=a.target;c.view=void 0!==a.view?a.view:new Qf;var e=Hh,f;void 0!==a.renderer?(Array.isArray(a.renderer)?f=a.renderer:"string"===typeof a.renderer?f=[a.renderer]:qa(!1,46),0<=f.indexOf("dom")&&(f=f.concat(ok))):f=ok;var g,h;g=0;for(h=f.length;g<
	h;++g){var l=f[g];if("canvas"==l){if(Md){e=ci;break}}else if("webgl"==l&&Ed){e=kk;break}}void 0!==a.controls?Array.isArray(a.controls)?f=new D(a.controls.slice()):(qa(a.controls instanceof D,47),f=a.controls):f=nd();void 0!==a.interactions?Array.isArray(a.interactions)?g=new D(a.interactions.slice()):(qa(a.interactions instanceof D,48),g=a.interactions):g=ch();void 0!==a.overlays?Array.isArray(a.overlays)?a=new D(a.overlays.slice()):(qa(a.overlays instanceof D,49),a=a.overlays):a=new D;return{controls:f,
	interactions:g,keyboardEventTarget:b,logos:d,overlays:a,jp:e,values:c}}qh();function qk(a){Gc.call(this);this.g=a.id;this.o=void 0!==a.insertFirst?a.insertFirst:!0;this.v=void 0!==a.stopEvent?a.stopEvent:!0;this.c=document.createElement("DIV");this.c.className="ol-overlay-container";this.c.style.position="absolute";this.autoPan=void 0!==a.autoPan?a.autoPan:!1;this.l=a.autoPanAnimation||{};this.j=void 0!==a.autoPanMargin?a.autoPanMargin:20;this.a={me:"",Ce:"",bf:"",kf:"",visible:!0};this.i=null;B(this,Ic(rk),this.fl,this);B(this,Ic(sk),this.pl,this);B(this,Ic(tk),this.tl,
	this);B(this,Ic(uk),this.vl,this);B(this,Ic(vk),this.wl,this);void 0!==a.element&&this.Gi(a.element);this.Ni(void 0!==a.offset?a.offset:[0,0]);this.Qi(void 0!==a.positioning?a.positioning:"top-left");void 0!==a.position&&this.Wf(a.position)}u(qk,Gc);k=qk.prototype;k.se=function(){return this.get(rk)};k.qm=function(){return this.g};k.Ge=function(){return this.get(sk)};k.qh=function(){return this.get(tk)};k.Kh=function(){return this.get(uk)};k.rh=function(){return this.get(vk)};
	k.fl=function(){for(var a=this.c;a.lastChild;)a.removeChild(a.lastChild);(a=this.se())&&this.c.appendChild(a)};k.pl=function(){this.i&&(Zc(this.c),rc(this.i),this.i=null);var a=this.Ge();a&&(this.i=B(a,"postrender",this.render,this),wk(this),a=this.v?a.u:a.A,this.o?a.insertBefore(this.c,a.childNodes[0]||null):a.appendChild(this.c))};k.render=function(){wk(this)};k.tl=function(){wk(this)};
	k.vl=function(){wk(this);if(this.get(uk)&&this.autoPan){var a=this.Ge();if(a&&a.Kc()){var b=xk(a.Kc(),a.Mb()),c=this.se(),d=c.offsetWidth,e=c.currentStyle||getComputedStyle(c),d=d+(parseInt(e.marginLeft,10)+parseInt(e.marginRight,10)),e=c.offsetHeight,f=c.currentStyle||getComputedStyle(c),e=e+(parseInt(f.marginTop,10)+parseInt(f.marginBottom,10)),g=xk(c,[d,e]),c=this.j;Ta(b,g)||(d=g[0]-b[0],e=b[2]-g[2],f=g[1]-b[1],g=b[3]-g[3],b=[0,0],0>d?b[0]=d-c:0>e&&(b[0]=Math.abs(e)+c),0>f?b[1]=f-c:0>g&&(b[1]=
	Math.abs(g)+c),0===b[0]&&0===b[1])||(c=a.$().Ba(),c=a.Ka(c),b=[c[0]+b[0],c[1]+b[1]],a.$().animate({center:a.Za(b),duration:this.l.duration,easing:this.l.easing}))}}};k.wl=function(){wk(this)};k.Gi=function(a){this.set(rk,a)};k.setMap=function(a){this.set(sk,a)};k.Ni=function(a){this.set(tk,a)};k.Wf=function(a){this.set(uk,a)};function xk(a,b){var c=a.getBoundingClientRect(),d=c.left+window.pageXOffset,c=c.top+window.pageYOffset;return[d,c,d+b[0],c+b[1]]}k.Qi=function(a){this.set(vk,a)};
	function yk(a,b){a.a.visible!==b&&(a.c.style.display=b?"":"none",a.a.visible=b)}
	function wk(a){var b=a.Ge(),c=a.Kh();if(b&&b.a&&c){var c=b.Ka(c),d=b.Mb(),b=a.c.style,e=a.qh(),f=a.rh(),g=e[0],e=e[1];if("bottom-right"==f||"center-right"==f||"top-right"==f)""!==a.a.Ce&&(a.a.Ce=b.left=""),g=Math.round(d[0]-c[0]-g)+"px",a.a.bf!=g&&(a.a.bf=b.right=g);else{""!==a.a.bf&&(a.a.bf=b.right="");if("bottom-center"==f||"center-center"==f||"top-center"==f)g-=a.c.offsetWidth/2;g=Math.round(c[0]+g)+"px";a.a.Ce!=g&&(a.a.Ce=b.left=g)}if("bottom-left"==f||"bottom-center"==f||"bottom-right"==f)""!==
	a.a.kf&&(a.a.kf=b.top=""),c=Math.round(d[1]-c[1]-e)+"px",a.a.me!=c&&(a.a.me=b.bottom=c);else{""!==a.a.me&&(a.a.me=b.bottom="");if("center-left"==f||"center-center"==f||"center-right"==f)e-=a.c.offsetHeight/2;c=Math.round(c[1]+e)+"px";a.a.kf!=c&&(a.a.kf=b.top=c)}yk(a,!0)}else yk(a,!1)}var rk="element",sk="map",tk="offset",uk="position",vk="positioning";function zk(a){a=a?a:{};this.l=void 0!==a.collapsed?a.collapsed:!0;this.j=void 0!==a.collapsible?a.collapsible:!0;this.j||(this.l=!1);var b=void 0!==a.className?a.className:"ol-overviewmap",c=void 0!==a.tipLabel?a.tipLabel:"Overview map",d=void 0!==a.collapseLabel?a.collapseLabel:"\u00ab";"string"===typeof d?(this.o=document.createElement("span"),this.o.textContent=d):this.o=d;d=void 0!==a.label?a.label:"\u00bb";"string"===typeof d?(this.u=document.createElement("span"),this.u.textContent=d):this.u=
	d;var e=this.j&&!this.l?this.o:this.u,d=document.createElement("button");d.setAttribute("type","button");d.title=c;d.appendChild(e);B(d,"click",this.Em,this);this.C=document.createElement("DIV");this.C.className="ol-overviewmap-map";var f=this.c=new G({controls:new D,interactions:new D,view:a.view});a.layers&&a.layers.forEach(function(a){f.Sg(a)},this);c=document.createElement("DIV");c.className="ol-overviewmap-box";c.style.boxSizing="border-box";this.A=new qk({position:[0,0],positioning:"bottom-left",
	element:c});this.c.Tg(this.A);c=document.createElement("div");c.className=b+" ol-unselectable ol-control"+(this.l&&this.j?" ol-collapsed":"")+(this.j?"":" ol-uncollapsible");c.appendChild(this.C);c.appendChild(d);ad.call(this,{element:c,render:a.render?a.render:Ak,target:a.target})}u(zk,ad);k=zk.prototype;
	k.setMap=function(a){var b=this.a;a!==b&&(b&&((b=b.$())&&xc(b,Ic("rotation"),this.Ae,this),this.c.Fe(null)),ad.prototype.setMap.call(this,a),a&&(this.c.Fe(this.C),this.v.push(B(a,"propertychange",this.ql,this)),this.c.Jh().ec()||this.c.Li(a.Jc()),a=a.$()))&&(B(a,Ic("rotation"),this.Ae,this),Yf(a)&&(this.c.xd(),Bk(this)))};k.ql=function(a){"view"===a.key&&((a=a.oldValue)&&xc(a,Ic("rotation"),this.Ae,this),a=this.a.$(),B(a,Ic("rotation"),this.Ae,this))};k.Ae=function(){this.c.$().He(this.a.$().Va())};
	function Ak(){var a=this.a,b=this.c;if(a.a&&b.a){var c=a.Mb(),a=a.$().ed(c),d=b.Mb(),c=b.$().ed(d),e=b.Ka(eb(a)),f=b.Ka(cb(a)),b=Math.abs(e[0]-f[0]),e=Math.abs(e[1]-f[1]),f=d[0],d=d[1];b<.1*f||e<.1*d||b>.75*f||e>.75*d?Bk(this):Ta(c,a)||(a=this.c,c=this.a.$(),a.$().wb(c.Ba()))}Ck(this)}function Bk(a){var b=a.a;a=a.c;var c=b.Mb(),b=b.$().ed(c);a=a.$();nb(b,1/(.1*Math.pow(2,Math.log(7.5)/Math.LN2/2)));a.Ff(b)}
	function Ck(a){var b=a.a,c=a.c;if(b.a&&c.a){var d=b.Mb(),e=b.$(),f=c.$(),c=e.Va(),b=a.A,g=a.A.se(),h=e.ed(d),d=f.Ua(),e=bb(h),f=db(h),l;if(a=a.a.$().Ba())l=[e[0]-a[0],e[1]-a[1]],Ve(l,c),Qe(l,a);b.Wf(l);g&&(g.style.width=Math.abs((e[0]-f[0])/d)+"px",g.style.height=Math.abs((f[1]-e[1])/d)+"px")}}k.Em=function(a){a.preventDefault();Dk(this)};
	function Dk(a){a.element.classList.toggle("ol-collapsed");a.l?Yc(a.o,a.u):Yc(a.u,a.o);a.l=!a.l;var b=a.c;a.l||b.a||(b.xd(),Bk(a),wc(b,"postrender",function(){Ck(this)},a))}k.Dm=function(){return this.j};k.Gm=function(a){this.j!==a&&(this.j=a,this.element.classList.toggle("ol-uncollapsible"),!a&&this.l&&Dk(this))};k.Fm=function(a){this.j&&this.l!==a&&Dk(this)};k.Cm=function(){return this.l};k.Mk=function(){return this.c};function Ek(a){a=a?a:{};var b=void 0!==a.className?a.className:"ol-scale-line";this.j=document.createElement("DIV");this.j.className=b+"-inner";this.c=document.createElement("DIV");this.c.className=b+" ol-unselectable";this.c.appendChild(this.j);this.u=null;this.o=void 0!==a.minWidth?a.minWidth:64;this.l=!1;this.C=void 0;this.A="";ad.call(this,{element:this.c,render:a.render?a.render:Fk,target:a.target});B(this,Ic(Gk),this.R,this);this.G(a.units||"metric")}u(Ek,ad);var Hk=[1,2,5];
	Ek.prototype.Jb=function(){return this.get(Gk)};function Fk(a){(a=a.frameState)?this.u=a.viewState:this.u=null;Ik(this)}Ek.prototype.R=function(){Ik(this)};Ek.prototype.G=function(a){this.set(Gk,a)};
	function Ik(a){var b=a.u;if(b){var c=b.projection,d=c.sc(),b=Eb(c,b.resolution,b.center)*d,d=a.o*b,c="",e=a.Jb();"degrees"==e?(c=vb.degrees,b/=c,d<c/60?(c="\u2033",b*=3600):d<c?(c="\u2032",b*=60):c="\u00b0"):"imperial"==e?.9144>d?(c="in",b/=.0254):1609.344>d?(c="ft",b/=.3048):(c="mi",b/=1609.344):"nautical"==e?(b/=1852,c="nm"):"metric"==e?1>d?(c="mm",b*=1E3):1E3>d?c="m":(c="km",b/=1E3):"us"==e?.9144>d?(c="in",b*=39.37):1609.344>d?(c="ft",b/=.30480061):(c="mi",b/=1609.3472):qa(!1,33);for(var e=3*Math.floor(Math.log(a.o*
	b)/Math.log(10)),f;;){f=Hk[(e%3+3)%3]*Math.pow(10,Math.floor(e/3));d=Math.round(f/b);if(isNaN(d)){a.c.style.display="none";a.l=!1;return}if(d>=a.o)break;++e}b=f+" "+c;a.A!=b&&(a.j.innerHTML=b,a.A=b);a.C!=d&&(a.j.style.width=d+"px",a.C=d);a.l||(a.c.style.display="",a.l=!0)}else a.l&&(a.c.style.display="none",a.l=!1)}var Gk="units";function Jk(a){a=a?a:{};this.c=void 0;this.l=Kk;this.A=this.o=0;this.R=null;this.ea=!1;this.Y=void 0!==a.duration?a.duration:200;var b=void 0!==a.className?a.className:"ol-zoomslider",c=document.createElement("button");c.setAttribute("type","button");c.className=b+"-thumb ol-unselectable";var d=document.createElement("div");d.className=b+" ol-unselectable ol-control";d.appendChild(c);this.j=new re(d);B(this.j,"pointerdown",this.el,this);B(this.j,"pointermove",this.cl,this);B(this.j,"pointerup",this.dl,
	this);B(d,"click",this.bl,this);B(c,"click",Cc);ad.call(this,{element:d,render:a.render?a.render:Lk})}u(Jk,ad);Jk.prototype.ra=function(){Ac(this.j);ad.prototype.ra.call(this)};var Kk=0;k=Jk.prototype;k.setMap=function(a){ad.prototype.setMap.call(this,a);a&&a.render()};
	function Lk(a){if(a.frameState){if(!this.ea){var b=this.element,c=b.offsetWidth,d=b.offsetHeight,e=b.firstElementChild,f=getComputedStyle(e),b=e.offsetWidth+parseFloat(f.marginRight)+parseFloat(f.marginLeft),e=e.offsetHeight+parseFloat(f.marginTop)+parseFloat(f.marginBottom);this.R=[b,e];c>d?(this.l=1,this.A=c-b):(this.l=Kk,this.o=d-e);this.ea=!0}a=a.frameState.viewState.resolution;a!==this.c&&(this.c=a,Mk(this,a))}}
	k.bl=function(a){var b=this.a.$();a=Nk(this,wa(1===this.l?(a.offsetX-this.R[0]/2)/this.A:(a.offsetY-this.R[1]/2)/this.o,0,1));b.animate({resolution:b.constrainResolution(a),duration:this.Y,easing:fd})};k.el=function(a){this.u||a.b.target!==this.element.firstElementChild||(Rf(this.a.$(),1,1),this.C=a.clientX,this.G=a.clientY,this.u=!0)};
	k.cl=function(a){if(this.u){var b=this.element.firstElementChild;this.c=Nk(this,wa(1===this.l?(a.clientX-this.C+parseInt(b.style.left,10))/this.A:(a.clientY-this.G+parseInt(b.style.top,10))/this.o,0,1));this.a.$().Xc(this.c);Mk(this,this.c);this.C=a.clientX;this.G=a.clientY}};k.dl=function(){if(this.u){var a=this.a.$();Rf(a,1,-1);a.animate({resolution:a.constrainResolution(this.c),duration:this.Y,easing:fd});this.u=!1;this.G=this.C=void 0}};
	function Mk(a,b){var c;c=1-Xf(a.a.$())(b);var d=a.element.firstElementChild;1==a.l?d.style.left=a.A*c+"px":d.style.top=a.o*c+"px"}function Nk(a,b){return Wf(a.a.$())(1-b)};function Ok(a){a=a?a:{};this.c=a.extent?a.extent:null;var b=void 0!==a.className?a.className:"ol-zoom-extent",c=void 0!==a.label?a.label:"E",d=void 0!==a.tipLabel?a.tipLabel:"Fit to extent",e=document.createElement("button");e.setAttribute("type","button");e.title=d;e.appendChild("string"===typeof c?document.createTextNode(c):c);B(e,"click",this.l,this);c=document.createElement("div");c.className=b+" ol-unselectable ol-control";c.appendChild(e);ad.call(this,{element:c,target:a.target})}u(Ok,ad);
	Ok.prototype.l=function(a){a.preventDefault();a=this.a.$();var b=this.c?this.c:a.o.D();a.Ff(b)};function Pk(a){Gc.call(this);a=a?a:{};this.a=null;B(this,Ic(Qk),this.cm,this);this.Uf(void 0!==a.tracking?a.tracking:!1)}u(Pk,Gc);k=Pk.prototype;k.ra=function(){this.Uf(!1);Gc.prototype.ra.call(this)};
	k.qo=function(a){if(null!==a.alpha){var b=Ba(a.alpha);this.set(Rk,b);"boolean"===typeof a.absolute&&a.absolute?this.set(Sk,b):"number"===typeof a.webkitCompassHeading&&-1!=a.webkitCompassAccuracy&&this.set(Sk,Ba(a.webkitCompassHeading))}null!==a.beta&&this.set(Tk,Ba(a.beta));null!==a.gamma&&this.set(Uk,Ba(a.gamma));this.s()};k.jk=function(){return this.get(Rk)};k.mk=function(){return this.get(Tk)};k.uk=function(){return this.get(Uk)};k.bm=function(){return this.get(Sk)};k.Fh=function(){return this.get(Qk)};
	k.cm=function(){if(Nd){var a=this.Fh();a&&!this.a?this.a=B(window,"deviceorientation",this.qo,this):a||null===this.a||(rc(this.a),this.a=null)}};k.Uf=function(a){this.set(Qk,a)};var Rk="alpha",Tk="beta",Uk="gamma",Sk="heading",Qk="tracking";function Vk(a){this.g=a.opacity;this.o=a.rotateWithView;this.l=a.rotation;this.c=a.scale;this.v=a.snapToPixel}k=Vk.prototype;k.Pe=function(){return this.g};k.Qe=function(){return this.o};k.Re=function(){return this.l};k.Se=function(){return this.c};k.ve=function(){return this.v};k.rd=function(a){this.g=a};k.Te=function(a){this.l=a};k.sd=function(a){this.c=a};function Wk(a){this.A=this.I=this.i=null;this.Wa=void 0!==a.fill?a.fill:null;this.qa=[0,0];this.b=a.points;this.a=void 0!==a.radius?a.radius:a.radius1;this.f=void 0!==a.radius2?a.radius2:this.a;this.j=void 0!==a.angle?a.angle:0;this.Ya=void 0!==a.stroke?a.stroke:null;this.G=this.ta=this.C=null;this.u=a.atlasManager;Xk(this,this.u);Vk.call(this,{opacity:1,rotateWithView:void 0!==a.rotateWithView?a.rotateWithView:!1,rotation:void 0!==a.rotation?a.rotation:0,scale:1,snapToPixel:void 0!==a.snapToPixel?
	a.snapToPixel:!0})}u(Wk,Vk);k=Wk.prototype;k.clone=function(){var a=new Wk({fill:this.Ca()?this.Ca().clone():void 0,points:this.f!==this.a?this.b/2:this.b,radius:this.a,radius2:this.f,angle:this.j,snapToPixel:this.v,stroke:this.Da()?this.Da().clone():void 0,rotation:this.l,rotateWithView:this.o,atlasManager:this.u});a.rd(this.g);a.sd(this.c);return a};k.Hc=function(){return this.C};k.ki=function(){return this.j};k.Ca=function(){return this.Wa};k.cg=function(){return this.A};k.Z=function(){return this.I};
	k.ue=function(){return this.G};k.Oe=function(){return 2};k.Pc=function(){return this.qa};k.li=function(){return this.b};k.mi=function(){return this.a};k.sh=function(){return this.f};k.jc=function(){return this.ta};k.Da=function(){return this.Ya};k.zh=function(){};k.load=function(){};k.Yi=function(){};
	function Xk(a,b){var c,d="",e="",f=0,g=null,h,l=0;a.Ya&&(h=Vc(a.Ya.a),l=a.Ya.c,void 0===l&&(l=1),g=a.Ya.f,Ld||(g=null),e=a.Ya.l,void 0===e&&(e="round"),d=a.Ya.i,void 0===d&&(d="round"),f=a.Ya.j,void 0===f&&(f=10));var m=2*(a.a+l)+1,d={strokeStyle:h,Vi:l,size:m,lineCap:d,lineDash:g,lineJoin:e,miterLimit:f};void 0===b?(e=Xc(m,m),a.I=e.canvas,c=m=a.I.width,a.ah(d,e,0,0),a.Wa?a.A=a.I:(e=Xc(d.size,d.size),a.A=e.canvas,a.$g(d,e,0,0))):(m=Math.round(m),(e=!a.Wa)&&(c=a.$g.bind(a,d)),a.Ya?(f=a.Ya,void 0===
	f.b&&(f.b="s",f.b=f.a?"string"===typeof f.a?f.b+f.a:f.b+w(f.a).toString():f.b+"-",f.b+=","+(void 0!==f.i?f.i.toString():"-")+","+(f.f?f.f.toString():"-")+","+(void 0!==f.g?f.g:"-")+","+(void 0!==f.l?f.l:"-")+","+(void 0!==f.j?f.j.toString():"-")+","+(void 0!==f.c?f.c.toString():"-")),f=f.b):f="-",a.Wa?(g=a.Wa,void 0===g.a&&(g.a=g.b instanceof CanvasPattern||g.b instanceof CanvasGradient?w(g.b).toString():"f"+(g.b?Sc(g.b):"-")),g=g.a):g="-",a.i&&f==a.i[1]&&g==a.i[2]&&a.a==a.i[3]&&a.f==a.i[4]&&a.j==
	a.i[5]&&a.b==a.i[6]||(a.i=["r"+f+g+(void 0!==a.a?a.a.toString():"-")+(void 0!==a.f?a.f.toString():"-")+(void 0!==a.j?a.j.toString():"-")+(void 0!==a.b?a.b.toString():"-"),f,g,a.a,a.f,a.j,a.b]),d=b.add(a.i[0],m,m,a.ah.bind(a,d),c),a.I=d.image,a.qa=[d.offsetX,d.offsetY],c=d.image.width,a.A=e?d.Fl:a.I);a.C=[m/2,m/2];a.ta=[m,m];a.G=[c,c]}
	k.ah=function(a,b,c,d){var e;b.setTransform(1,0,0,1,0,0);b.translate(c,d);b.beginPath();if(Infinity===this.b)b.arc(a.size/2,a.size/2,this.a,0,2*Math.PI,!0);else for(this.f!==this.a&&(this.b*=2),c=0;c<=this.b;c++)d=2*c*Math.PI/this.b-Math.PI/2+this.j,e=c%2?this.f:this.a,b.lineTo(a.size/2+e*Math.cos(d),a.size/2+e*Math.sin(d));this.Wa&&(b.fillStyle=Vc(this.Wa.b),b.fill());this.Ya&&(b.strokeStyle=a.strokeStyle,b.lineWidth=a.Vi,a.lineDash&&b.setLineDash(a.lineDash),b.lineCap=a.lineCap,b.lineJoin=a.lineJoin,
	b.miterLimit=a.miterLimit,b.stroke());b.closePath()};
	k.$g=function(a,b,c,d){b.setTransform(1,0,0,1,0,0);b.translate(c,d);b.beginPath();if(Infinity===this.b)b.arc(a.size/2,a.size/2,this.a,0,2*Math.PI,!0);else{this.f!==this.a&&(this.b*=2);var e;for(c=0;c<=this.b;c++)e=2*c*Math.PI/this.b-Math.PI/2+this.j,d=c%2?this.f:this.a,b.lineTo(a.size/2+d*Math.cos(e),a.size/2+d*Math.sin(e))}b.fillStyle=Nh;b.fill();this.Ya&&(b.strokeStyle=a.strokeStyle,b.lineWidth=a.Vi,a.lineDash&&b.setLineDash(a.lineDash),b.stroke());b.closePath()};function Yk(a){a=a||{};Wk.call(this,{points:Infinity,fill:a.fill,radius:a.radius,snapToPixel:a.snapToPixel,stroke:a.stroke,atlasManager:a.atlasManager})}u(Yk,Wk);Yk.prototype.clone=function(){var a=new Yk({fill:this.Ca()?this.Ca().clone():void 0,stroke:this.Da()?this.Da().clone():void 0,radius:this.a,snapToPixel:this.v,atlasManager:this.u});a.rd(this.g);a.sd(this.c);return a};Yk.prototype.Wc=function(a){this.a=a;Xk(this,this.u)};function Zk(a){a=a||{};this.b=void 0!==a.color?a.color:null;this.a=void 0}Zk.prototype.clone=function(){var a=this.b;return new Zk({color:a&&a.slice?a.slice():a||void 0})};Zk.prototype.f=function(){return this.b};Zk.prototype.c=function(a){this.b=a;this.a=void 0};function $k(a){a=a||{};this.Gc=null;this.Ra=al;void 0!==a.geometry&&this.Sa(a.geometry);this.Wa=void 0!==a.fill?a.fill:null;this.M=void 0!==a.image?a.image:null;this.Ya=void 0!==a.stroke?a.stroke:null;this.Fa=void 0!==a.text?a.text:null;this.kj=a.zIndex}k=$k.prototype;
	k.clone=function(){var a=this.U();a&&a.clone&&(a=a.clone());return new $k({geometry:a,fill:this.Ca()?this.Ca().clone():void 0,image:this.Z()?this.Z().clone():void 0,stroke:this.Da()?this.Da().clone():void 0,text:this.Pa()?this.Pa().clone():void 0,zIndex:this.za()})};k.U=function(){return this.Gc};k.vk=function(){return this.Ra};k.Ca=function(){return this.Wa};k.cf=function(a){this.Wa=a};k.Z=function(){return this.M};k.zg=function(a){this.M=a};k.Da=function(){return this.Ya};
	k.df=function(a){this.Ya=a};k.Pa=function(){return this.Fa};k.ef=function(a){this.Fa=a};k.za=function(){return this.kj};k.Sa=function(a){"function"===typeof a?this.Ra=a:"string"===typeof a?this.Ra=function(b){return b.get(a)}:a?a&&(this.Ra=function(){return a}):this.Ra=al;this.Gc=a};k.Wb=function(a){this.kj=a};function bl(a){if("function"!==typeof a){var b;Array.isArray(a)?b=a:(qa(a instanceof $k,41),b=[a]);a=function(){return b}}return a}var cl=null;
	function dl(){if(!cl){var a=new Zk({color:"rgba(255,255,255,0.4)"}),b=new rj({color:"#3399CC",width:1.25});cl=[new $k({image:new Yk({fill:a,stroke:b,radius:5}),fill:a,stroke:b})]}return cl}
	function el(){var a={},b=[255,255,255,1],c=[0,153,255,1];a.Polygon=[new $k({fill:new Zk({color:[255,255,255,.5]})})];a.MultiPolygon=a.Polygon;a.LineString=[new $k({stroke:new rj({color:b,width:5})}),new $k({stroke:new rj({color:c,width:3})})];a.MultiLineString=a.LineString;a.Circle=a.Polygon.concat(a.LineString);a.Point=[new $k({image:new Yk({radius:6,fill:new Zk({color:c}),stroke:new rj({color:b,width:1.5})}),zIndex:Infinity})];a.MultiPoint=a.Point;a.GeometryCollection=a.Polygon.concat(a.LineString,
	a.Point);return a}function al(a){return a.U()};function H(a){Gc.call(this);this.a=void 0;this.c="geometry";this.g=null;this.l=void 0;this.i=null;B(this,Ic(this.c),this.ye,this);void 0!==a&&(a instanceof cf||!a?this.Sa(a):this.H(a))}u(H,Gc);k=H.prototype;k.clone=function(){var a=new H(this.N());a.Vc(this.c);var b=this.U();b&&a.Sa(b.clone());(b=this.g)&&a.Vf(b);return a};k.U=function(){return this.get(this.c)};k.dm=function(){return this.a};k.wk=function(){return this.c};k.em=function(){return this.g};k.Nc=function(){return this.l};k.gl=function(){this.s()};
	k.ye=function(){this.i&&(rc(this.i),this.i=null);var a=this.U();a&&(this.i=B(a,"change",this.gl,this));this.s()};k.Sa=function(a){this.set(this.c,a)};k.Vf=function(a){this.l=(this.g=a)?fl(a):void 0;this.s()};k.kc=function(a){this.a=a;this.s()};k.Vc=function(a){xc(this,Ic(this.c),this.ye,this);this.c=a;B(this,Ic(this.c),this.ye,this);this.ye()};
	function fl(a){var b;if("function"===typeof a)2==a.length?b=function(b){return a(this,b)}:b=a;else{var c;Array.isArray(a)?c=a:(qa(a instanceof $k,41),c=[a]);b=function(){return c}}return b};var gl=document.implementation.createDocument("","",null);function il(a,b){return gl.createElementNS(a,b)}function jl(a,b){return kl(a,b,[]).join("")}function kl(a,b,c){if(a.nodeType==Node.CDATA_SECTION_NODE||a.nodeType==Node.TEXT_NODE)b?c.push(String(a.nodeValue).replace(/(\r\n|\r|\n)/g,"")):c.push(a.nodeValue);else for(a=a.firstChild;a;a=a.nextSibling)kl(a,b,c);return c}function ll(a){return a instanceof Document}function ml(a){return a instanceof Node}
	function nl(a){return(new DOMParser).parseFromString(a,"application/xml")}function pl(a,b){return function(c,d){var e=a.call(b,c,d);void 0!==e&&ga(d[d.length-1],e)}}function ql(a,b){return function(c,d){var e=a.call(void 0!==b?b:this,c,d);void 0!==e&&d[d.length-1].push(e)}}function rl(a,b){return function(c,d){var e=a.call(void 0!==b?b:this,c,d);void 0!==e&&(d[d.length-1]=e)}}
	function sl(a){return function(b,c){var d=a.call(this,b,c);if(void 0!==d){var e=c[c.length-1],f=b.localName,g;f in e?g=e[f]:g=e[f]=[];g.push(d)}}}function I(a,b){return function(c,d){var e=a.call(this,c,d);void 0!==e&&(d[d.length-1][void 0!==b?b:c.localName]=e)}}function J(a,b){return function(c,d,e){a.call(void 0!==b?b:this,c,d,e);e[e.length-1].node.appendChild(c)}}
	function tl(a){var b,c;return function(d,e,f){if(!b){b={};var g={};g[d.localName]=a;b[d.namespaceURI]=g;c=ul(d.localName)}vl(b,c,e,f)}}function ul(a,b){return function(c,d,e){c=d[d.length-1].node;d=a;void 0===d&&(d=e);e=b;void 0===b&&(e=c.namespaceURI);return il(e,d)}}var wl=ul();function xl(a,b){for(var c=b.length,d=Array(c),e=0;e<c;++e)d[e]=a[b[e]];return d}function K(a,b,c){c=void 0!==c?c:{};var d,e;d=0;for(e=a.length;d<e;++d)c[a[d]]=b;return c}
	function yl(a,b,c,d){for(b=b.firstElementChild;b;b=b.nextElementSibling){var e=a[b.namespaceURI];void 0!==e&&(e=e[b.localName])&&e.call(d,b,c)}}function L(a,b,c,d,e){d.push(a);yl(b,c,d,e);return d.pop()}function vl(a,b,c,d,e,f){for(var g=(void 0!==e?e:c).length,h,l,m=0;m<g;++m)h=c[m],void 0!==h&&(l=b.call(f,h,d,void 0!==e?e[m]:void 0),void 0!==l&&a[l.namespaceURI][l.localName].call(f,l,h,d))}function zl(a,b,c,d,e,f,g){e.push(a);vl(b,c,d,e,f,g);e.pop()};function Al(a,b,c,d){return function(e,f,g){var h=new XMLHttpRequest;h.open("GET","function"===typeof a?a(e,f,g):a,!0);"arraybuffer"==b.T()&&(h.responseType="arraybuffer");h.onload=function(){if(!h.status||200<=h.status&&300>h.status){var a=b.T(),e;"json"==a||"text"==a?e=h.responseText:"xml"==a?(e=h.responseXML)||(e=nl(h.responseText)):"arraybuffer"==a&&(e=h.response);e?c.call(this,b.Qa(e,{featureProjection:g}),b.kb(e)):d.call(this)}else d.call(this)}.bind(this);h.send()}}
	function Bl(a,b){return Al(a,b,function(a){this.dd(a)},na)};function Cl(){this.g=this.defaultDataProjection=null}function Dl(a,b,c){var d;c&&(d={dataProjection:c.dataProjection?c.dataProjection:a.kb(b),featureProjection:c.featureProjection});return El(a,d)}function El(a,b){return pb({dataProjection:a.defaultDataProjection,featureProjection:a.g},b)}
	function Fl(a,b,c){var d=c?Gb(c.featureProjection):null,e=c?Gb(c.dataProjection):null,f;d&&e&&!Tb(d,e)?a instanceof cf?f=(b?a.clone():a).tb(b?d:e,b?e:d):f=Xb(b?a.slice():a,b?d:e,b?e:d):f=a;if(b&&c&&c.decimals){var g=Math.pow(10,c.decimals);a=function(a){for(var b=0,c=a.length;b<c;++b)a[b]=Math.round(a[b]*g)/g;return a};Array.isArray(f)?a(f):f.Dc(a)}return f};function Gl(){Cl.call(this)}u(Gl,Cl);function Hl(a){return"string"===typeof a?(a=JSON.parse(a))?a:null:null!==a?a:null}k=Gl.prototype;k.T=function(){return"json"};k.Ub=function(a,b){return this.Sc(Hl(a),Dl(this,a,b))};k.Qa=function(a,b){return this.kg(Hl(a),Dl(this,a,b))};k.Tc=function(a,b){return this.og(Hl(a),Dl(this,a,b))};k.kb=function(a){return this.rg(Hl(a))};k.yd=function(a,b){return JSON.stringify(this.ad(a,b))};k.Xb=function(a,b){return JSON.stringify(this.ce(a,b))};
	k.bd=function(a,b){return JSON.stringify(this.ee(a,b))};function Il(a,b,c,d,e,f){var g=NaN,h=NaN,l=(c-b)/d;if(1===l)g=a[b],h=a[b+1];else if(2==l)g=(1-e)*a[b]+e*a[b+d],h=(1-e)*a[b+1]+e*a[b+d+1];else if(l){var h=a[b],l=a[b+1],m=0,g=[0],p;for(p=b+d;p<c;p+=d){var n=a[p],q=a[p+1],m=m+Math.sqrt((n-h)*(n-h)+(q-l)*(q-l));g.push(m);h=n;l=q}c=e*m;l=0;m=g.length;for(p=!1;l<m;)e=l+(m-l>>1),h=+da(g[e],c),0>h?l=e+1:(m=e,p=!h);e=p?l:~l;0>e?(c=(c-g[-e-2])/(g[-e-1]-g[-e-2]),b+=(-e-2)*d,g=Da(a[b],a[b+d],c),h=Da(a[b+1],a[b+d+1],c)):(g=a[b+e*d],h=a[b+e*d+1])}return f?(f[0]=
	g,f[1]=h,f):[g,h]}function Jl(a,b,c,d,e,f){if(c==b)return null;if(e<a[b+d-1])return f?(c=a.slice(b,b+d),c[d-1]=e,c):null;if(a[c-1]<e)return f?(c=a.slice(c-d,c),c[d-1]=e,c):null;if(e==a[b+d-1])return a.slice(b,b+d);b/=d;for(c/=d;b<c;)f=b+c>>1,e<a[(f+1)*d-1]?c=f:b=f+1;c=a[b*d-1];if(e==c)return a.slice((b-1)*d,(b-1)*d+d);f=(e-c)/(a[(b+1)*d-1]-c);c=[];var g;for(g=0;g<d-1;++g)c.push(Da(a[(b-1)*d+g],a[b*d+g],f));c.push(e);return c}
	function Kl(a,b,c,d,e,f){var g=0;if(f)return Jl(a,g,b[b.length-1],c,d,e);if(d<a[c-1])return e?(a=a.slice(0,c),a[c-1]=d,a):null;if(a[a.length-1]<d)return e?(a=a.slice(a.length-c),a[c-1]=d,a):null;e=0;for(f=b.length;e<f;++e){var h=b[e];if(g!=h){if(d<a[g+c-1])break;else if(d<=a[h-1])return Jl(a,g,h,c,d,!1);g=h}}return null};function M(a,b){ff.call(this);this.c=null;this.u=this.A=this.l=-1;this.pa(a,b)}u(M,ff);k=M.prototype;k.Tj=function(a){this.B?ga(this.B,a):this.B=a.slice();this.s()};k.clone=function(){var a=new M(null);a.ca(this.ka,this.B.slice());return a};k.Gb=function(a,b,c,d){if(d<Oa(this.D(),a,b))return d;this.u!=this.f&&(this.A=Math.sqrt(nf(this.B,0,this.B.length,this.a,0)),this.u=this.f);return pf(this.B,0,this.B.length,this.a,this.A,!1,a,b,c,d)};
	k.gk=function(a,b){return Ef(this.B,0,this.B.length,this.a,a,b)};k.Im=function(a,b){return"XYM"!=this.ka&&"XYZM"!=this.ka?null:Jl(this.B,0,this.B.length,this.a,a,void 0!==b?b:!1)};k.X=function(){return uf(this.B,0,this.B.length,this.a)};k.hh=function(a,b){return Il(this.B,0,this.B.length,this.a,a,b)};k.Jm=function(){var a=this.B,b=this.a,c=a[0],d=a[1],e=0,f;for(f=0+b;f<this.B.length;f+=b)var g=a[f],h=a[f+1],e=e+Math.sqrt((g-c)*(g-c)+(h-d)*(h-d)),c=g,d=h;return e};
	function Zh(a){a.l!=a.f&&(a.c=a.hh(.5,a.c),a.l=a.f);return a.c}k.kd=function(a){var b=[];b.length=wf(this.B,0,this.B.length,this.a,a,b,0);a=new M(null);a.ca("XY",b);return a};k.T=function(){return"LineString"};k.Xa=function(a){return Ff(this.B,0,this.B.length,this.a,a)};k.pa=function(a,b){a?(jf(this,b,a,1),this.B||(this.B=[]),this.B.length=sf(this.B,0,a,this.a),this.s()):this.ca("XY",null)};k.ca=function(a,b){hf(this,a,b);this.s()};function N(a,b){ff.call(this);this.c=[];this.l=this.u=-1;this.pa(a,b)}u(N,ff);k=N.prototype;k.Uj=function(a){this.B?ga(this.B,a.ha().slice()):this.B=a.ha().slice();this.c.push(this.B.length);this.s()};k.clone=function(){var a=new N(null);a.ca(this.ka,this.B.slice(),this.c.slice());return a};k.Gb=function(a,b,c,d){if(d<Oa(this.D(),a,b))return d;this.l!=this.f&&(this.u=Math.sqrt(of(this.B,0,this.c,this.a,0)),this.l=this.f);return qf(this.B,0,this.c,this.a,this.u,!1,a,b,c,d)};
	k.Lm=function(a,b,c){return"XYM"!=this.ka&&"XYZM"!=this.ka||!this.B.length?null:Kl(this.B,this.c,this.a,a,void 0!==b?b:!1,void 0!==c?c:!1)};k.X=function(){return vf(this.B,0,this.c,this.a)};k.Rb=function(){return this.c};k.Dk=function(a){if(0>a||this.c.length<=a)return null;var b=new M(null);b.ca(this.ka,this.B.slice(a?this.c[a-1]:0,this.c[a]));return b};
	k.hd=function(){var a=this.B,b=this.c,c=this.ka,d=[],e=0,f,g;f=0;for(g=b.length;f<g;++f){var h=b[f],l=new M(null);l.ca(c,a.slice(e,h));d.push(l);e=h}return d};function $h(a){var b=[],c=a.B,d=0,e=a.c;a=a.a;var f,g;f=0;for(g=e.length;f<g;++f){var h=e[f],d=Il(c,d,h,a,.5);ga(b,d);d=h}return b}k.kd=function(a){var b=[],c=[],d=this.B,e=this.c,f=this.a,g=0,h=0,l,m;l=0;for(m=e.length;l<m;++l){var p=e[l],h=wf(d,g,p,f,a,b,h);c.push(h);g=p}b.length=h;a=new N(null);a.ca("XY",b,c);return a};k.T=function(){return"MultiLineString"};
	k.Xa=function(a){a:{var b=this.B,c=this.c,d=this.a,e=0,f,g;f=0;for(g=c.length;f<g;++f){if(Ff(b,e,c[f],d,a)){a=!0;break a}e=c[f]}a=!1}return a};k.pa=function(a,b){if(a){jf(this,b,a,2);this.B||(this.B=[]);var c=tf(this.B,0,a,this.a,this.c);this.B.length=c.length?c[c.length-1]:0;this.s()}else this.ca("XY",null,this.c)};k.ca=function(a,b,c){hf(this,a,b);this.c=c;this.s()};
	function Ll(a,b){var c=a.ka,d=[],e=[],f,g;f=0;for(g=b.length;f<g;++f){var h=b[f];f||(c=h.ka);ga(d,h.ha());e.push(d.length)}a.ca(c,d,e)};function O(a,b){ff.call(this);this.pa(a,b)}u(O,ff);k=O.prototype;k.Wj=function(a){this.B?ga(this.B,a.ha()):this.B=a.ha().slice();this.s()};k.clone=function(){var a=new O(null);a.ca(this.ka,this.B.slice());return a};k.Gb=function(a,b,c,d){if(d<Oa(this.D(),a,b))return d;var e=this.B,f=this.a,g,h,l;g=0;for(h=e.length;g<h;g+=f)if(l=Aa(a,b,e[g],e[g+1]),l<d){d=l;for(l=0;l<f;++l)c[l]=e[g+l];c.length=f}return d};k.X=function(){return uf(this.B,0,this.B.length,this.a)};
	k.Ok=function(a){var b=this.B?this.B.length/this.a:0;if(0>a||b<=a)return null;b=new E(null);b.ca(this.ka,this.B.slice(a*this.a,(a+1)*this.a));return b};k.Ie=function(){var a=this.B,b=this.ka,c=this.a,d=[],e,f;e=0;for(f=a.length;e<f;e+=c){var g=new E(null);g.ca(b,a.slice(e,e+c));d.push(g)}return d};k.T=function(){return"MultiPoint"};k.Xa=function(a){var b=this.B,c=this.a,d,e,f,g;d=0;for(e=b.length;d<e;d+=c)if(f=b[d],g=b[d+1],Sa(a,f,g))return!0;return!1};
	k.pa=function(a,b){a?(jf(this,b,a,1),this.B||(this.B=[]),this.B.length=sf(this.B,0,a,this.a),this.s()):this.ca("XY",null)};k.ca=function(a,b){hf(this,a,b);this.s()};function P(a,b){ff.call(this);this.c=[];this.u=-1;this.A=null;this.R=this.C=this.G=-1;this.l=null;this.pa(a,b)}u(P,ff);k=P.prototype;k.Xj=function(a){if(this.B){var b=this.B.length;ga(this.B,a.ha());a=a.Rb().slice();var c,d;c=0;for(d=a.length;c<d;++c)a[c]+=b}else this.B=a.ha().slice(),a=a.Rb().slice(),this.c.push();this.c.push(a);this.s()};k.clone=function(){for(var a=new P(null),b=this.c.length,c=Array(b),d=0;d<b;++d)c[d]=this.c[d].slice();Ml(a,this.ka,this.B.slice(),c);return a};
	k.Gb=function(a,b,c,d){if(d<Oa(this.D(),a,b))return d;if(this.C!=this.f){var e=this.c,f=0,g=0,h,l;h=0;for(l=e.length;h<l;++h)var m=e[h],g=of(this.B,f,m,this.a,g),f=m[m.length-1];this.G=Math.sqrt(g);this.C=this.f}e=ai(this);f=this.c;g=this.a;h=this.G;l=0;var m=[NaN,NaN],p,n;p=0;for(n=f.length;p<n;++p){var q=f[p];d=qf(e,l,q,g,h,!0,a,b,c,d,m);l=q[q.length-1]}return d};
	k.Oc=function(a,b){var c;a:{c=ai(this);var d=this.c,e=0;if(d.length){var f,g;f=0;for(g=d.length;f<g;++f){var h=d[f];if(Cf(c,e,h,this.a,a,b)){c=!0;break a}e=h[h.length-1]}}c=!1}return c};k.Mm=function(){var a=ai(this),b=this.c,c=0,d=0,e,f;e=0;for(f=b.length;e<f;++e)var g=b[e],d=d+lf(a,c,g,this.a),c=g[g.length-1];return d};
	k.X=function(a){var b;void 0!==a?(b=ai(this).slice(),Kf(b,this.c,this.a,a)):b=this.B;a=b;b=this.c;var c=this.a,d=0,e=[],f=0,g,h;g=0;for(h=b.length;g<h;++g){var l=b[g];e[f++]=vf(a,d,l,c,e[f]);d=l[l.length-1]}e.length=f;return e};
	function bi(a){if(a.u!=a.f){var b=a.B,c=a.c,d=a.a,e=0,f=[],g,h;g=0;for(h=c.length;g<h;++g){var l=c[g],e=Xa(b,e,l[0],d);f.push((e[0]+e[2])/2,(e[1]+e[3])/2);e=l[l.length-1]}b=ai(a);c=a.c;d=a.a;g=0;h=[];l=0;for(e=c.length;l<e;++l){var m=c[l];h=Df(b,g,m,d,f,2*l,h);g=m[m.length-1]}a.A=h;a.u=a.f}return a.A}k.zk=function(){var a=new O(null);a.ca("XY",bi(this).slice());return a};
	function ai(a){if(a.R!=a.f){var b=a.B,c;a:{c=a.c;var d,e;d=0;for(e=c.length;d<e;++d)if(!If(b,c[d],a.a,void 0)){c=!1;break a}c=!0}c?a.l=b:(a.l=b.slice(),a.l.length=Kf(a.l,a.c,a.a));a.R=a.f}return a.l}k.kd=function(a){var b=[],c=[],d=this.B,e=this.c,f=this.a;a=Math.sqrt(a);var g=0,h=0,l,m;l=0;for(m=e.length;l<m;++l){var p=e[l],n=[],h=xf(d,g,p,f,a,b,h,n);c.push(n);g=p[p.length-1]}b.length=h;d=new P(null);Ml(d,"XY",b,c);return d};
	k.Pk=function(a){if(0>a||this.c.length<=a)return null;var b;a?(b=this.c[a-1],b=b[b.length-1]):b=0;a=this.c[a].slice();var c=a[a.length-1];if(b){var d,e;d=0;for(e=a.length;d<e;++d)a[d]-=b}d=new F(null);d.ca(this.ka,this.B.slice(b,c),a);return d};k.Od=function(){var a=this.ka,b=this.B,c=this.c,d=[],e=0,f,g,h,l;f=0;for(g=c.length;f<g;++f){var m=c[f].slice(),p=m[m.length-1];if(e)for(h=0,l=m.length;h<l;++h)m[h]-=e;h=new F(null);h.ca(a,b.slice(e,p),m);d.push(h);e=p}return d};k.T=function(){return"MultiPolygon"};
	k.Xa=function(a){a:{var b=ai(this),c=this.c,d=this.a,e=0,f,g;f=0;for(g=c.length;f<g;++f){var h=c[f];if(Gf(b,e,h,d,a)){a=!0;break a}e=h[h.length-1]}a=!1}return a};k.pa=function(a,b){if(a){jf(this,b,a,3);this.B||(this.B=[]);var c=this.B,d=this.a,e=this.c,f=0,e=e?e:[],g=0,h,l;h=0;for(l=a.length;h<l;++h)f=tf(c,f,a[h],d,e[g]),e[g++]=f,f=f[f.length-1];e.length=g;e.length?(c=e[e.length-1],this.B.length=c.length?c[c.length-1]:0):this.B.length=0;this.s()}else Ml(this,"XY",null,this.c)};
	function Ml(a,b,c,d){hf(a,b,c);a.c=d;a.s()}function Nl(a,b){var c=a.ka,d=[],e=[],f,g,h;f=0;for(g=b.length;f<g;++f){var l=b[f];f||(c=l.ka);var m=d.length;h=l.Rb();var p,n;p=0;for(n=h.length;p<n;++p)h[p]+=m;ga(d,l.ha());e.push(h)}Ml(a,c,d,e)};function Ol(a){a=a?a:{};Cl.call(this);this.b=a.geometryName}u(Ol,Gl);
	function Pl(a,b){if(!a)return null;var c;if("number"===typeof a.x&&"number"===typeof a.y)c="Point";else if(a.points)c="MultiPoint";else if(a.paths)c=1===a.paths.length?"LineString":"MultiLineString";else if(a.rings){var d=a.rings,e=Ql(a),f=[],g=[];c=[];var h,l;h=0;for(l=d.length;h<l;++h)f.length=0,sf(f,0,d[h],e.length),Hf(f,0,f.length,e.length)?g.push([d[h]]):c.push(d[h]);for(;c.length;){d=c.shift();e=!1;for(h=g.length-1;0<=h;h--)if(Ta((new yf(g[h][0])).D(),(new yf(d)).D())){g[h].push(d);e=!0;break}e||
	g.push([d.reverse()])}a=pb({},a);1===g.length?(c="Polygon",a.rings=g[0]):(c="MultiPolygon",a.rings=g)}return Fl((0,Rl[c])(a),!1,b)}function Ql(a){var b="XY";!0===a.hasZ&&!0===a.hasM?b="XYZM":!0===a.hasZ?b="XYZ":!0===a.hasM&&(b="XYM");return b}function Sl(a){a=a.ka;return{hasZ:"XYZ"===a||"XYZM"===a,hasM:"XYM"===a||"XYZM"===a}}
	var Rl={Point:function(a){return void 0!==a.m&&void 0!==a.z?new E([a.x,a.y,a.z,a.m],"XYZM"):void 0!==a.z?new E([a.x,a.y,a.z],"XYZ"):void 0!==a.m?new E([a.x,a.y,a.m],"XYM"):new E([a.x,a.y])},LineString:function(a){return new M(a.paths[0],Ql(a))},Polygon:function(a){return new F(a.rings,Ql(a))},MultiPoint:function(a){return new O(a.points,Ql(a))},MultiLineString:function(a){return new N(a.paths,Ql(a))},MultiPolygon:function(a){return new P(a.rings,Ql(a))}},Tl={Point:function(a){var b=a.X(),c;a=a.ka;
	"XYZ"===a?c={x:b[0],y:b[1],z:b[2]}:"XYM"===a?c={x:b[0],y:b[1],m:b[2]}:"XYZM"===a?c={x:b[0],y:b[1],z:b[2],m:b[3]}:"XY"===a?c={x:b[0],y:b[1]}:qa(!1,34);return c},LineString:function(a){var b=Sl(a);return{hasZ:b.hasZ,hasM:b.hasM,paths:[a.X()]}},Polygon:function(a){var b=Sl(a);return{hasZ:b.hasZ,hasM:b.hasM,rings:a.X(!1)}},MultiPoint:function(a){var b=Sl(a);return{hasZ:b.hasZ,hasM:b.hasM,points:a.X()}},MultiLineString:function(a){var b=Sl(a);return{hasZ:b.hasZ,hasM:b.hasM,paths:a.X()}},MultiPolygon:function(a){var b=
	Sl(a);a=a.X(!1);for(var c=[],d=0;d<a.length;d++)for(var e=a[d].length-1;0<=e;e--)c.push(a[d][e]);return{hasZ:b.hasZ,hasM:b.hasM,rings:c}}};k=Ol.prototype;k.Sc=function(a,b){var c=Pl(a.geometry,b),d=new H;this.b&&d.Vc(this.b);d.Sa(c);b&&b.Rf&&a.attributes[b.Rf]&&d.kc(a.attributes[b.Rf]);a.attributes&&d.H(a.attributes);return d};
	k.kg=function(a,b){var c=b?b:{};if(a.features){var d=[],e=a.features,f,g;c.Rf=a.objectIdFieldName;f=0;for(g=e.length;f<g;++f)d.push(this.Sc(e[f],c));return d}return[this.Sc(a,c)]};k.og=function(a,b){return Pl(a,b)};k.rg=function(a){return a.spatialReference&&a.spatialReference.wkid?Gb("EPSG:"+a.spatialReference.wkid):null};function Ul(a,b){return(0,Tl[a.T()])(Fl(a,!0,b),b)}k.ee=function(a,b){return Ul(a,El(this,b))};
	k.ad=function(a,b){b=El(this,b);var c={},d=a.U();d&&(c.geometry=Ul(d,b));d=a.N();delete d[a.c];c.attributes=sb(d)?{}:d;b&&b.featureProjection&&(c.spatialReference={wkid:Gb(b.featureProjection).nb.split(":").pop()});return c};k.ce=function(a,b){b=El(this,b);var c=[],d,e;d=0;for(e=a.length;d<e;++d)c.push(this.ad(a[d],b));return{features:c}};function Vl(a){this.Bc=a};function Wl(a,b){this.Bc=a;this.b=Array.prototype.slice.call(arguments,1);qa(2<=this.b.length,57)}u(Wl,Vl);function Xl(a){var b=["And"].concat(Array.prototype.slice.call(arguments));Wl.apply(this,b)}u(Xl,Wl);function Yl(a,b,c){this.Bc="BBOX";this.geometryName=a;this.extent=b;this.srsName=c}u(Yl,Vl);function Zl(a,b){this.Bc=a;this.b=b}u(Zl,Vl);function $l(a,b,c,d){Zl.call(this,a,b);this.f=c;this.a=d}u($l,Zl);function am(a,b,c){$l.call(this,"PropertyIsEqualTo",a,b,c)}u(am,$l);function bm(a,b){$l.call(this,"PropertyIsGreaterThan",a,b)}u(bm,$l);function cm(a,b){$l.call(this,"PropertyIsGreaterThanOrEqualTo",a,b)}u(cm,$l);function dm(a,b,c,d){this.Bc=a;this.geometryName=b||"the_geom";this.geometry=c;this.srsName=d}u(dm,Vl);function em(a,b,c){dm.call(this,"Intersects",a,b,c)}u(em,dm);function fm(a,b,c){Zl.call(this,"PropertyIsBetween",a);this.a=b;this.f=c}u(fm,Zl);function gm(a,b,c,d,e,f){Zl.call(this,"PropertyIsLike",a);this.c=b;this.g=void 0!==c?c:"*";this.i=void 0!==d?d:".";this.f=void 0!==e?e:"!";this.a=f}u(gm,Zl);function hm(a){Zl.call(this,"PropertyIsNull",a)}u(hm,Zl);function im(a,b){$l.call(this,"PropertyIsLessThan",a,b)}u(im,$l);function jm(a,b){$l.call(this,"PropertyIsLessThanOrEqualTo",a,b)}u(jm,$l);function km(a){this.Bc="Not";this.condition=a}u(km,Vl);function lm(a,b,c){$l.call(this,"PropertyIsNotEqualTo",a,b,c)}u(lm,$l);function mm(a){var b=["Or"].concat(Array.prototype.slice.call(arguments));Wl.apply(this,b)}u(mm,Wl);function nm(a,b,c){dm.call(this,"Within",a,b,c)}u(nm,dm);function om(a){var b=[null].concat(Array.prototype.slice.call(arguments));return new (Function.prototype.bind.apply(Xl,b))}function pm(a,b,c){return new Yl(a,b,c)};function qm(a){cf.call(this);this.a=a?a:null;rm(this)}u(qm,cf);function sm(a){var b=[],c,d;c=0;for(d=a.length;c<d;++c)b.push(a[c].clone());return b}function tm(a){var b,c;if(a.a)for(b=0,c=a.a.length;b<c;++b)xc(a.a[b],"change",a.s,a)}function rm(a){var b,c;if(a.a)for(b=0,c=a.a.length;b<c;++b)B(a.a[b],"change",a.s,a)}k=qm.prototype;k.clone=function(){var a=new qm(null);a.Ji(this.a);return a};
	k.Gb=function(a,b,c,d){if(d<Oa(this.D(),a,b))return d;var e=this.a,f,g;f=0;for(g=e.length;f<g;++f)d=e[f].Gb(a,b,c,d);return d};k.Oc=function(a,b){var c=this.a,d,e;d=0;for(e=c.length;d<e;++d)if(c[d].Oc(a,b))return!0;return!1};k.ne=function(a){Va(Infinity,Infinity,-Infinity,-Infinity,a);for(var b=this.a,c=0,d=b.length;c<d;++c)$a(a,b[c].D());return a};k.If=function(){return sm(this.a)};
	k.Qd=function(a){this.j!=this.f&&(qb(this.i),this.g=0,this.j=this.f);if(0>a||this.g&&a<this.g)return this;var b=a.toString();if(this.i.hasOwnProperty(b))return this.i[b];var c=[],d=this.a,e=!1,f,g;f=0;for(g=d.length;f<g;++f){var h=d[f],l=h.Qd(a);c.push(l);l!==h&&(e=!0)}if(e)return a=new qm(null),tm(a),a.a=c,rm(a),a.s(),this.i[b]=a;this.g=a;return this};k.T=function(){return"GeometryCollection"};k.Xa=function(a){var b=this.a,c,d;c=0;for(d=b.length;c<d;++c)if(b[c].Xa(a))return!0;return!1};
	k.rotate=function(a,b){for(var c=this.a,d=0,e=c.length;d<e;++d)c[d].rotate(a,b);this.s()};k.scale=function(a,b,c){c||(c=jb(this.D()));for(var d=this.a,e=0,f=d.length;e<f;++e)d[e].scale(a,b,c);this.s()};k.Ji=function(a){a=sm(a);tm(this);this.a=a;rm(this);this.s()};k.Dc=function(a){var b=this.a,c,d;c=0;for(d=b.length;c<d;++c)b[c].Dc(a);this.s()};k.translate=function(a,b){var c=this.a,d,e;d=0;for(e=c.length;d<e;++d)c[d].translate(a,b);this.s()};k.ra=function(){tm(this);cf.prototype.ra.call(this)};function um(a){a=a?a:{};Cl.call(this);this.defaultDataProjection=Gb(a.defaultDataProjection?a.defaultDataProjection:"EPSG:4326");a.featureProjection&&(this.g=Gb(a.featureProjection));this.b=a.geometryName}u(um,Gl);function vm(a,b){return a?Fl((0,wm[a.type])(a),!1,b):null}function xm(a,b){return(0,ym[a.T()])(Fl(a,!0,b),b)}
	var wm={Point:function(a){return new E(a.coordinates)},LineString:function(a){return new M(a.coordinates)},Polygon:function(a){return new F(a.coordinates)},MultiPoint:function(a){return new O(a.coordinates)},MultiLineString:function(a){return new N(a.coordinates)},MultiPolygon:function(a){return new P(a.coordinates)},GeometryCollection:function(a,b){var c=a.geometries.map(function(a){return vm(a,b)});return new qm(c)}},ym={Point:function(a){return{type:"Point",coordinates:a.X()}},LineString:function(a){return{type:"LineString",
	coordinates:a.X()}},Polygon:function(a,b){var c;b&&(c=b.rightHanded);return{type:"Polygon",coordinates:a.X(c)}},MultiPoint:function(a){return{type:"MultiPoint",coordinates:a.X()}},MultiLineString:function(a){return{type:"MultiLineString",coordinates:a.X()}},MultiPolygon:function(a,b){var c;b&&(c=b.rightHanded);return{type:"MultiPolygon",coordinates:a.X(c)}},GeometryCollection:function(a,b){return{type:"GeometryCollection",geometries:a.a.map(function(a){var c=pb({},b);delete c.featureProjection;return xm(a,
	c)})}},Circle:function(){return{type:"GeometryCollection",geometries:[]}}};k=um.prototype;k.Sc=function(a,b){var c;c="Feature"===a.type?a:{type:"Feature",geometry:a};var d=vm(c.geometry,b),e=new H;this.b&&e.Vc(this.b);e.Sa(d);void 0!==c.id&&e.kc(c.id);c.properties&&e.H(c.properties);return e};k.kg=function(a,b){var c;if("FeatureCollection"===a.type){c=[];var d=a.features,e,f;e=0;for(f=d.length;e<f;++e)c.push(this.Sc(d[e],b))}else c=[this.Sc(a,b)];return c};k.og=function(a,b){return vm(a,b)};
	k.rg=function(a){a=a.crs;var b;a?"name"==a.type?b=Gb(a.properties.name):"EPSG"==a.type?b=Gb("EPSG:"+a.properties.code):qa(!1,36):b=this.defaultDataProjection;return b};k.ad=function(a,b){b=El(this,b);var c={type:"Feature"},d=a.a;void 0!==d&&(c.id=d);(d=a.U())?c.geometry=xm(d,b):c.geometry=null;d=a.N();delete d[a.c];sb(d)?c.properties=null:c.properties=d;return c};k.ce=function(a,b){b=El(this,b);var c=[],d,e;d=0;for(e=a.length;d<e;++d)c.push(this.ad(a[d],b));return{type:"FeatureCollection",features:c}};
	k.ee=function(a,b){return xm(a,El(this,b))};function zm(){this.f=new XMLSerializer;Cl.call(this)}u(zm,Cl);k=zm.prototype;k.T=function(){return"xml"};k.Ub=function(a,b){if(ll(a))return Am(this,a,b);if(ml(a))return this.jg(a,b);if("string"===typeof a){var c=nl(a);return Am(this,c,b)}return null};function Am(a,b,c){a=Bm(a,b,c);return 0<a.length?a[0]:null}k.jg=function(){return null};k.Qa=function(a,b){if(ll(a))return Bm(this,a,b);if(ml(a))return this.yc(a,b);if("string"===typeof a){var c=nl(a);return Bm(this,c,b)}return[]};
	function Bm(a,b,c){var d=[];for(b=b.firstChild;b;b=b.nextSibling)b.nodeType==Node.ELEMENT_NODE&&ga(d,a.yc(b,c));return d}k.Tc=function(a,b){if(ll(a))return null;if(ml(a))return this.vi(a,b);"string"===typeof a&&nl(a);return null};k.vi=function(){return null};k.kb=function(a){return ll(a)?this.qg(a):ml(a)?this.Ze(a):"string"===typeof a?(a=nl(a),this.qg(a)):null};k.qg=function(){return this.defaultDataProjection};k.Ze=function(){return this.defaultDataProjection};
	k.yd=function(a,b){return this.f.serializeToString(this.Fg(a,b))};k.Fg=function(){return null};k.Xb=function(a,b){var c=this.Yb(a,b);return this.f.serializeToString(c)};k.Yb=function(){return null};k.bd=function(a,b){var c=this.de(a,b);return this.f.serializeToString(c)};k.de=function(){return null};function Cm(a){a=a?a:{};this.featureType=a.featureType;this.featureNS=a.featureNS;this.srsName=a.srsName;this.schemaLocation="";this.b={};this.b["http://www.opengis.net/gml"]={featureMember:rl(Cm.prototype.Xd),featureMembers:rl(Cm.prototype.Xd)};zm.call(this)}u(Cm,zm);var Dm=/^[\s\xa0]*$/;k=Cm.prototype;
	k.Xd=function(a,b){var c=a.localName,d=null;if("FeatureCollection"==c)"http://www.opengis.net/wfs"===a.namespaceURI?d=L([],this.b,a,b,this):d=L(null,this.b,a,b,this);else if("featureMembers"==c||"featureMember"==c){var e=b[0],f=e.featureType,g=e.featureNS,h,l;if(!f&&a.childNodes){f=[];g={};h=0;for(l=a.childNodes.length;h<l;++h){var m=a.childNodes[h];if(1===m.nodeType){var p=m.nodeName.split(":").pop();if(-1===f.indexOf(p)){var n="",q=0,m=m.namespaceURI,r;for(r in g){if(g[r]===m){n=r;break}++q}n||
	(n="p"+q,g[n]=m);f.push(n+":"+p)}}}"featureMember"!=c&&(e.featureType=f,e.featureNS=g)}"string"===typeof g&&(h=g,g={},g.p0=h);var e={},f=Array.isArray(f)?f:[f],v;for(v in g){p={};h=0;for(l=f.length;h<l;++h)(-1===f[h].indexOf(":")?"p0":f[h].split(":")[0])===v&&(p[f[h].split(":").pop()]="featureMembers"==c?ql(this.ig,this):rl(this.ig,this));e[g[v]]=p}"featureMember"==c?d=L(void 0,e,a,b):d=L([],e,a,b)}null===d&&(d=[]);return d};
	k.We=function(a,b){var c=b[0];c.srsName=a.firstElementChild.getAttribute("srsName");var d=L(null,this.Jg,a,b,this);if(d)return Fl(d,!1,c)};
	k.ig=function(a,b){var c,d;(d=a.getAttribute("fid"))||(d=a.getAttributeNS("http://www.opengis.net/gml","id")||"");var e={},f;for(c=a.firstElementChild;c;c=c.nextElementSibling){var g=c.localName;if(0===c.childNodes.length||1===c.childNodes.length&&(3===c.firstChild.nodeType||4===c.firstChild.nodeType)){var h=jl(c,!1);Dm.test(h)&&(h=void 0);e[g]=h}else"boundedBy"!==g&&(f=g),e[g]=this.We(c,b)}c=new H(e);f&&c.Vc(f);d&&c.kc(d);return c};
	k.Ai=function(a,b){var c=this.Ve(a,b);if(c){var d=new E(null);d.ca("XYZ",c);return d}};k.yi=function(a,b){var c=L([],this.sj,a,b,this);if(c)return new O(c)};k.xi=function(a,b){var c=L([],this.rj,a,b,this);if(c){var d=new N(null);Ll(d,c);return d}};k.zi=function(a,b){var c=L([],this.tj,a,b,this);if(c){var d=new P(null);Nl(d,c);return d}};k.ri=function(a,b){yl(this.wj,a,b,this)};k.yh=function(a,b){yl(this.pj,a,b,this)};k.si=function(a,b){yl(this.xj,a,b,this)};
	k.Xe=function(a,b){var c=this.Ve(a,b);if(c){var d=new M(null);d.ca("XYZ",c);return d}};k.Lo=function(a,b){var c=L(null,this.fe,a,b,this);if(c)return c};k.wi=function(a,b){var c=this.Ve(a,b);if(c){var d=new yf(null);zf(d,"XYZ",c);return d}};k.Ye=function(a,b){var c=L([null],this.qf,a,b,this);if(c&&c[0]){var d=new F(null),e=c[0],f=[e.length],g,h;g=1;for(h=c.length;g<h;++g)ga(e,c[g]),f.push(e.length);d.ca("XYZ",e,f);return d}};k.Ve=function(a,b){return L(null,this.fe,a,b,this)};
	k.sj={"http://www.opengis.net/gml":{pointMember:ql(Cm.prototype.ri),pointMembers:ql(Cm.prototype.ri)}};k.rj={"http://www.opengis.net/gml":{lineStringMember:ql(Cm.prototype.yh),lineStringMembers:ql(Cm.prototype.yh)}};k.tj={"http://www.opengis.net/gml":{polygonMember:ql(Cm.prototype.si),polygonMembers:ql(Cm.prototype.si)}};k.wj={"http://www.opengis.net/gml":{Point:ql(Cm.prototype.Ve)}};k.pj={"http://www.opengis.net/gml":{LineString:ql(Cm.prototype.Xe)}};k.xj={"http://www.opengis.net/gml":{Polygon:ql(Cm.prototype.Ye)}};
	k.ge={"http://www.opengis.net/gml":{LinearRing:rl(Cm.prototype.Lo)}};k.vi=function(a,b){var c=this.We(a,[Dl(this,a,b?b:{})]);return c?c:null};k.yc=function(a,b){var c={featureType:this.featureType,featureNS:this.featureNS};b&&pb(c,Dl(this,a,b));return this.Xd(a,[c])||[]};k.Ze=function(a){return Gb(this.srsName?this.srsName:a.firstElementChild.getAttribute("srsName"))};function Em(a){a=jl(a,!1);return Fm(a)}function Fm(a){if(a=/^\s*(true|1)|(false|0)\s*$/.exec(a))return void 0!==a[1]||!1}function Gm(a){a=jl(a,!1);a=Date.parse(a);return isNaN(a)?void 0:a/1E3}function Hm(a){a=jl(a,!1);return Im(a)}function Im(a){if(a=/^\s*([+\-]?\d*\.?\d+(?:e[+\-]?\d+)?)\s*$/i.exec(a))return parseFloat(a[1])}function Jm(a){a=jl(a,!1);return Km(a)}function Km(a){if(a=/^\s*(\d+)\s*$/.exec(a))return parseInt(a[1],10)}function Q(a){return jl(a,!1).trim()}
	function Lm(a,b){Mm(a,b?"1":"0")}function Nm(a,b){a.appendChild(gl.createTextNode(b.toPrecision()))}function Om(a,b){a.appendChild(gl.createTextNode(b.toString()))}function Mm(a,b){a.appendChild(gl.createTextNode(b))};function Pm(a){a=a?a:{};Cm.call(this,a);this.o=void 0!==a.surface?a.surface:!1;this.i=void 0!==a.curve?a.curve:!1;this.l=void 0!==a.multiCurve?a.multiCurve:!0;this.j=void 0!==a.multiSurface?a.multiSurface:!0;this.schemaLocation=a.schemaLocation?a.schemaLocation:"http://www.opengis.net/gml http://schemas.opengis.net/gml/3.1.1/profiles/gmlsfProfile/1.0.0/gmlsf.xsd"}u(Pm,Cm);k=Pm.prototype;k.Po=function(a,b){var c=L([],this.qj,a,b,this);if(c){var d=new N(null);Ll(d,c);return d}};
	k.Qo=function(a,b){var c=L([],this.uj,a,b,this);if(c){var d=new P(null);Nl(d,c);return d}};k.Zg=function(a,b){yl(this.mj,a,b,this)};k.Wi=function(a,b){yl(this.Bj,a,b,this)};k.To=function(a,b){return L([null],this.vj,a,b,this)};k.Wo=function(a,b){return L([null],this.Aj,a,b,this)};k.Uo=function(a,b){return L([null],this.qf,a,b,this)};k.Oo=function(a,b){return L([null],this.fe,a,b,this)};k.Jl=function(a,b){var c=L(void 0,this.ge,a,b,this);c&&b[b.length-1].push(c)};
	k.ck=function(a,b){var c=L(void 0,this.ge,a,b,this);c&&(b[b.length-1][0]=c)};k.Bi=function(a,b){var c=L([null],this.Cj,a,b,this);if(c&&c[0]){var d=new F(null),e=c[0],f=[e.length],g,h;g=1;for(h=c.length;g<h;++g)ga(e,c[g]),f.push(e.length);d.ca("XYZ",e,f);return d}};k.ti=function(a,b){var c=L([null],this.nj,a,b,this);if(c){var d=new M(null);d.ca("XYZ",c);return d}};k.Ko=function(a,b){var c=L([null],this.oj,a,b,this);return Va(c[1][0],c[1][1],c[2][0],c[2][1])};
	k.Mo=function(a,b){for(var c=jl(a,!1),d=/^\s*([+\-]?\d*\.?\d+(?:[eE][+\-]?\d+)?)\s*/,e=[],f;f=d.exec(c);)e.push(parseFloat(f[1])),c=c.substr(f[0].length);if(""===c){c=b[0].srsName;d="enu";c&&(d=Gb(c).b);if("neu"===d)for(c=0,d=e.length;c<d;c+=3)f=e[c],e[c]=e[c+1],e[c+1]=f;c=e.length;2==c&&e.push(0);if(c)return e}};
	k.ng=function(a,b){var c=jl(a,!1).replace(/^\s*|\s*$/g,""),d=b[0].srsName,e=a.parentNode.getAttribute("srsDimension"),f="enu";d&&(f=Gb(d).b);c=c.split(/\s+/);d=2;a.getAttribute("srsDimension")?d=Km(a.getAttribute("srsDimension")):a.getAttribute("dimension")?d=Km(a.getAttribute("dimension")):e&&(d=Km(e));for(var g,h,l=[],m=0,p=c.length;m<p;m+=d)e=parseFloat(c[m]),g=parseFloat(c[m+1]),h=3===d?parseFloat(c[m+2]):0,"en"===f.substr(0,2)?l.push(e,g,h):l.push(g,e,h);return l};
	k.fe={"http://www.opengis.net/gml":{pos:rl(Pm.prototype.Mo),posList:rl(Pm.prototype.ng)}};k.qf={"http://www.opengis.net/gml":{interior:Pm.prototype.Jl,exterior:Pm.prototype.ck}};
	k.Jg={"http://www.opengis.net/gml":{Point:rl(Cm.prototype.Ai),MultiPoint:rl(Cm.prototype.yi),LineString:rl(Cm.prototype.Xe),MultiLineString:rl(Cm.prototype.xi),LinearRing:rl(Cm.prototype.wi),Polygon:rl(Cm.prototype.Ye),MultiPolygon:rl(Cm.prototype.zi),Surface:rl(Pm.prototype.Bi),MultiSurface:rl(Pm.prototype.Qo),Curve:rl(Pm.prototype.ti),MultiCurve:rl(Pm.prototype.Po),Envelope:rl(Pm.prototype.Ko)}};k.qj={"http://www.opengis.net/gml":{curveMember:ql(Pm.prototype.Zg),curveMembers:ql(Pm.prototype.Zg)}};
	k.uj={"http://www.opengis.net/gml":{surfaceMember:ql(Pm.prototype.Wi),surfaceMembers:ql(Pm.prototype.Wi)}};k.mj={"http://www.opengis.net/gml":{LineString:ql(Cm.prototype.Xe),Curve:ql(Pm.prototype.ti)}};k.Bj={"http://www.opengis.net/gml":{Polygon:ql(Cm.prototype.Ye),Surface:ql(Pm.prototype.Bi)}};k.Cj={"http://www.opengis.net/gml":{patches:rl(Pm.prototype.To)}};k.nj={"http://www.opengis.net/gml":{segments:rl(Pm.prototype.Wo)}};k.oj={"http://www.opengis.net/gml":{lowerCorner:ql(Pm.prototype.ng),upperCorner:ql(Pm.prototype.ng)}};
	k.vj={"http://www.opengis.net/gml":{PolygonPatch:rl(Pm.prototype.Uo)}};k.Aj={"http://www.opengis.net/gml":{LineStringSegment:rl(Pm.prototype.Oo)}};function Qm(a,b,c){c=c[c.length-1].srsName;b=b.X();for(var d=b.length,e=Array(d),f,g=0;g<d;++g){f=b[g];var h=g,l="enu";c&&(l=Gb(c).b);e[h]="en"===l.substr(0,2)?f[0]+" "+f[1]:f[1]+" "+f[0]}Mm(a,e.join(" "))}
	k.hj=function(a,b,c){var d=c[c.length-1].srsName;d&&a.setAttribute("srsName",d);d=il(a.namespaceURI,"pos");a.appendChild(d);c=c[c.length-1].srsName;a="enu";c&&(a=Gb(c).b);b=b.X();Mm(d,"en"===a.substr(0,2)?b[0]+" "+b[1]:b[1]+" "+b[0])};var Rm={"http://www.opengis.net/gml":{lowerCorner:J(Mm),upperCorner:J(Mm)}};k=Pm.prototype;k.Jp=function(a,b,c){var d=c[c.length-1].srsName;d&&a.setAttribute("srsName",d);zl({node:a},Rm,wl,[b[0]+" "+b[1],b[2]+" "+b[3]],c,["lowerCorner","upperCorner"],this)};
	k.ej=function(a,b,c){var d=c[c.length-1].srsName;d&&a.setAttribute("srsName",d);d=il(a.namespaceURI,"posList");a.appendChild(d);Qm(d,b,c)};k.zj=function(a,b){var c=b[b.length-1],d=c.node,e=c.exteriorWritten;void 0===e&&(c.exteriorWritten=!0);return il(d.namespaceURI,void 0!==e?"interior":"exterior")};
	k.nf=function(a,b,c){var d=c[c.length-1].srsName;"PolygonPatch"!==a.nodeName&&d&&a.setAttribute("srsName",d);"Polygon"===a.nodeName||"PolygonPatch"===a.nodeName?(b=b.jd(),zl({node:a,srsName:d},Sm,this.zj,b,c,void 0,this)):"Surface"===a.nodeName&&(d=il(a.namespaceURI,"patches"),a.appendChild(d),a=il(d.namespaceURI,"PolygonPatch"),d.appendChild(a),this.nf(a,b,c))};
	k.mf=function(a,b,c){var d=c[c.length-1].srsName;"LineStringSegment"!==a.nodeName&&d&&a.setAttribute("srsName",d);"LineString"===a.nodeName||"LineStringSegment"===a.nodeName?(d=il(a.namespaceURI,"posList"),a.appendChild(d),Qm(d,b,c)):"Curve"===a.nodeName&&(d=il(a.namespaceURI,"segments"),a.appendChild(d),a=il(d.namespaceURI,"LineStringSegment"),d.appendChild(a),this.mf(a,b,c))};
	k.gj=function(a,b,c){var d=c[c.length-1],e=d.srsName,d=d.surface;e&&a.setAttribute("srsName",e);b=b.Od();zl({node:a,srsName:e,surface:d},Tm,this.c,b,c,void 0,this)};k.Kp=function(a,b,c){var d=c[c.length-1].srsName;d&&a.setAttribute("srsName",d);b=b.Ie();zl({node:a,srsName:d},Um,ul("pointMember"),b,c,void 0,this)};k.fj=function(a,b,c){var d=c[c.length-1],e=d.srsName,d=d.curve;e&&a.setAttribute("srsName",e);b=b.hd();zl({node:a,srsName:e,curve:d},Vm,this.c,b,c,void 0,this)};
	k.ij=function(a,b,c){var d=il(a.namespaceURI,"LinearRing");a.appendChild(d);this.ej(d,b,c)};k.jj=function(a,b,c){var d=this.a(b,c);d&&(a.appendChild(d),this.nf(d,b,c))};k.Lp=function(a,b,c){var d=il(a.namespaceURI,"Point");a.appendChild(d);this.hj(d,b,c)};k.dj=function(a,b,c){var d=this.a(b,c);d&&(a.appendChild(d),this.mf(d,b,c))};
	k.zd=function(a,b,c){var d=c[c.length-1],e=pb({},d);e.node=a;var f;Array.isArray(b)?d.dataProjection?f=Xb(b,d.featureProjection,d.dataProjection):f=b:f=Fl(b,!0,d);zl(e,Wm,this.a,[f],c,void 0,this)};
	k.cj=function(a,b,c){var d=b.a;d&&a.setAttribute("fid",d);var d=c[c.length-1],e=d.featureNS,f=b.c;d.Uc||(d.Uc={},d.Uc[e]={});var g=b.N();b=[];var h=[],l;for(l in g){var m=g[l];null!==m&&(b.push(l),h.push(m),l==f||m instanceof cf?l in d.Uc[e]||(d.Uc[e][l]=J(this.zd,this)):l in d.Uc[e]||(d.Uc[e][l]=J(Mm)))}l=pb({},d);l.node=a;zl(l,d.Uc,ul(void 0,e),h,c,b)};
	var Tm={"http://www.opengis.net/gml":{surfaceMember:J(Pm.prototype.jj),polygonMember:J(Pm.prototype.jj)}},Um={"http://www.opengis.net/gml":{pointMember:J(Pm.prototype.Lp)}},Vm={"http://www.opengis.net/gml":{lineStringMember:J(Pm.prototype.dj),curveMember:J(Pm.prototype.dj)}},Sm={"http://www.opengis.net/gml":{exterior:J(Pm.prototype.ij),interior:J(Pm.prototype.ij)}},Wm={"http://www.opengis.net/gml":{Curve:J(Pm.prototype.mf),MultiCurve:J(Pm.prototype.fj),Point:J(Pm.prototype.hj),MultiPoint:J(Pm.prototype.Kp),
	LineString:J(Pm.prototype.mf),MultiLineString:J(Pm.prototype.fj),LinearRing:J(Pm.prototype.ej),Polygon:J(Pm.prototype.nf),MultiPolygon:J(Pm.prototype.gj),Surface:J(Pm.prototype.nf),MultiSurface:J(Pm.prototype.gj),Envelope:J(Pm.prototype.Jp)}},Xm={MultiLineString:"lineStringMember",MultiCurve:"curveMember",MultiPolygon:"polygonMember",MultiSurface:"surfaceMember"};Pm.prototype.c=function(a,b){return il("http://www.opengis.net/gml",Xm[b[b.length-1].node.nodeName])};
	Pm.prototype.a=function(a,b){var c=b[b.length-1],d=c.multiSurface,e=c.surface,f=c.curve,c=c.multiCurve,g;Array.isArray(a)?g="Envelope":(g=a.T(),"MultiPolygon"===g&&!0===d?g="MultiSurface":"Polygon"===g&&!0===e?g="Surface":"LineString"===g&&!0===f?g="Curve":"MultiLineString"===g&&!0===c&&(g="MultiCurve"));return il("http://www.opengis.net/gml",g)};
	Pm.prototype.de=function(a,b){b=El(this,b);var c=il("http://www.opengis.net/gml","geom"),d={node:c,srsName:this.srsName,curve:this.i,surface:this.o,multiSurface:this.j,multiCurve:this.l};b&&pb(d,b);this.zd(c,a,[d]);return c};
	Pm.prototype.Yb=function(a,b){b=El(this,b);var c=il("http://www.opengis.net/gml","featureMembers");c.setAttributeNS("http://www.w3.org/2001/XMLSchema-instance","xsi:schemaLocation",this.schemaLocation);var d={srsName:this.srsName,curve:this.i,surface:this.o,multiSurface:this.j,multiCurve:this.l,featureNS:this.featureNS,featureType:this.featureType};b&&pb(d,b);var d=[d],e=d[d.length-1],f=e.featureType,g=e.featureNS,h={};h[g]={};h[g][f]=J(this.cj,this);e=pb({},e);e.node=c;zl(e,h,ul(f,g),a,d);return c};function Ym(a){a=a?a:{};Cm.call(this,a);this.b["http://www.opengis.net/gml"].featureMember=ql(Cm.prototype.Xd);this.schemaLocation=a.schemaLocation?a.schemaLocation:"http://www.opengis.net/gml http://schemas.opengis.net/gml/2.1.2/feature.xsd"}u(Ym,Cm);k=Ym.prototype;
	k.ui=function(a,b){var c=jl(a,!1).replace(/^\s*|\s*$/g,""),d=b[0].srsName,e=a.parentNode.getAttribute("srsDimension"),f="enu";d&&(d=Gb(d))&&(f=d.b);c=c.split(/[\s,]+/);d=2;a.getAttribute("srsDimension")?d=Km(a.getAttribute("srsDimension")):a.getAttribute("dimension")?d=Km(a.getAttribute("dimension")):e&&(d=Km(e));for(var g,h,l=[],m=0,p=c.length;m<p;m+=d)e=parseFloat(c[m]),g=parseFloat(c[m+1]),h=3===d?parseFloat(c[m+2]):0,"en"===f.substr(0,2)?l.push(e,g,h):l.push(g,e,h);return l};
	k.Io=function(a,b){var c=L([null],this.lj,a,b,this);return Va(c[1][0],c[1][1],c[1][3],c[1][4])};k.Hl=function(a,b){var c=L(void 0,this.ge,a,b,this);c&&b[b.length-1].push(c)};k.ro=function(a,b){var c=L(void 0,this.ge,a,b,this);c&&(b[b.length-1][0]=c)};k.fe={"http://www.opengis.net/gml":{coordinates:rl(Ym.prototype.ui)}};k.qf={"http://www.opengis.net/gml":{innerBoundaryIs:Ym.prototype.Hl,outerBoundaryIs:Ym.prototype.ro}};k.lj={"http://www.opengis.net/gml":{coordinates:ql(Ym.prototype.ui)}};
	k.Jg={"http://www.opengis.net/gml":{Point:rl(Cm.prototype.Ai),MultiPoint:rl(Cm.prototype.yi),LineString:rl(Cm.prototype.Xe),MultiLineString:rl(Cm.prototype.xi),LinearRing:rl(Cm.prototype.wi),Polygon:rl(Cm.prototype.Ye),MultiPolygon:rl(Cm.prototype.zi),Box:rl(Ym.prototype.Io)}};function Zm(a){a=a?a:{};zm.call(this);this.defaultDataProjection=Gb("EPSG:4326");this.b=a.readExtensions}u(Zm,zm);var $m=[null,"http://www.topografix.com/GPX/1/0","http://www.topografix.com/GPX/1/1"];function an(a,b,c,d){a.push(parseFloat(c.getAttribute("lon")),parseFloat(c.getAttribute("lat")));"ele"in d?(a.push(d.ele),delete d.ele,b.hasZ=!0):a.push(0);"time"in d?(a.push(d.time),delete d.time,b.hasM=!0):a.push(0);return a}
	function bn(a,b,c){var d="XY",e=2;a.hasZ&&a.hasM?(d="XYZM",e=4):a.hasZ?(d="XYZ",e=3):a.hasM&&(d="XYM",e=3);if(4!==e){var f,g;f=0;for(g=b.length/4;f<g;f++)b[f*e]=b[4*f],b[f*e+1]=b[4*f+1],a.hasZ&&(b[f*e+2]=b[4*f+2]),a.hasM&&(b[f*e+2]=b[4*f+3]);b.length=b.length/4*e;if(c)for(f=0,g=c.length;f<g;f++)c[f]=c[f]/4*e}return d}function cn(a,b){var c=b[b.length-1],d=a.getAttribute("href");null!==d&&(c.link=d);yl(dn,a,b)}function en(a,b){b[b.length-1].extensionsNode_=a}
	function fn(a,b){var c=b[0],d=L({flatCoordinates:[],layoutOptions:{}},gn,a,b);if(d){var e=d.flatCoordinates;delete d.flatCoordinates;var f=d.layoutOptions;delete d.layoutOptions;var f=bn(f,e),g=new M(null);g.ca(f,e);Fl(g,!1,c);c=new H(g);c.H(d);return c}}
	function hn(a,b){var c=b[0],d=L({flatCoordinates:[],ends:[],layoutOptions:{}},jn,a,b);if(d){var e=d.flatCoordinates;delete d.flatCoordinates;var f=d.ends;delete d.ends;var g=d.layoutOptions;delete d.layoutOptions;var g=bn(g,e,f),h=new N(null);h.ca(g,e,f);Fl(h,!1,c);c=new H(h);c.H(d);return c}}function kn(a,b){var c=b[0],d=L({},ln,a,b);if(d){var e={},f=an([],e,a,d),e=bn(e,f),f=new E(f,e);Fl(f,!1,c);c=new H(f);c.H(d);return c}}
	var mn={rte:fn,trk:hn,wpt:kn},nn=K($m,{rte:ql(fn),trk:ql(hn),wpt:ql(kn)}),dn=K($m,{text:I(Q,"linkText"),type:I(Q,"linkType")}),gn=K($m,{name:I(Q),cmt:I(Q),desc:I(Q),src:I(Q),link:cn,number:I(Jm),extensions:en,type:I(Q),rtept:function(a,b){var c=L({},on,a,b);if(c){var d=b[b.length-1];an(d.flatCoordinates,d.layoutOptions,a,c)}}}),on=K($m,{ele:I(Hm),time:I(Gm)}),jn=K($m,{name:I(Q),cmt:I(Q),desc:I(Q),src:I(Q),link:cn,number:I(Jm),type:I(Q),extensions:en,trkseg:function(a,b){var c=b[b.length-1];yl(pn,
	a,b);c.ends.push(c.flatCoordinates.length)}}),pn=K($m,{trkpt:function(a,b){var c=L({},qn,a,b);if(c){var d=b[b.length-1];an(d.flatCoordinates,d.layoutOptions,a,c)}}}),qn=K($m,{ele:I(Hm),time:I(Gm)}),ln=K($m,{ele:I(Hm),time:I(Gm),magvar:I(Hm),geoidheight:I(Hm),name:I(Q),cmt:I(Q),desc:I(Q),src:I(Q),link:cn,sym:I(Q),type:I(Q),fix:I(Q),sat:I(Jm),hdop:I(Hm),vdop:I(Hm),pdop:I(Hm),ageofdgpsdata:I(Hm),dgpsid:I(Jm),extensions:en});
	function rn(a,b){b||(b=[]);for(var c=0,d=b.length;c<d;++c){var e=b[c];if(a.b){var f=e.get("extensionsNode_")||null;a.b(e,f)}e.set("extensionsNode_",void 0)}}Zm.prototype.jg=function(a,b){if(!ea($m,a.namespaceURI))return null;var c=mn[a.localName];if(!c)return null;c=c(a,[Dl(this,a,b)]);if(!c)return null;rn(this,[c]);return c};Zm.prototype.yc=function(a,b){if(!ea($m,a.namespaceURI))return[];if("gpx"==a.localName){var c=L([],nn,a,[Dl(this,a,b)]);if(c)return rn(this,c),c}return[]};
	function sn(a,b,c){a.setAttribute("href",b);b=c[c.length-1].properties;zl({node:a},tn,wl,[b.linkText,b.linkType],c,un)}function vn(a,b,c){var d=c[c.length-1],e=d.node.namespaceURI,f=d.properties;a.setAttributeNS(null,"lat",b[1]);a.setAttributeNS(null,"lon",b[0]);switch(d.geometryLayout){case "XYZM":b[3]&&(f.time=b[3]);case "XYZ":b[2]&&(f.ele=b[2]);break;case "XYM":b[2]&&(f.time=b[2])}b="rtept"==a.nodeName?wn[e]:xn[e];d=xl(f,b);zl({node:a,properties:f},yn,wl,d,c,b)}
	var un=["text","type"],tn=K($m,{text:J(Mm),type:J(Mm)}),zn=K($m,"name cmt desc src link number type rtept".split(" ")),An=K($m,{name:J(Mm),cmt:J(Mm),desc:J(Mm),src:J(Mm),link:J(sn),number:J(Om),type:J(Mm),rtept:tl(J(vn))}),wn=K($m,["ele","time"]),Bn=K($m,"name cmt desc src link number type trkseg".split(" ")),En=K($m,{name:J(Mm),cmt:J(Mm),desc:J(Mm),src:J(Mm),link:J(sn),number:J(Om),type:J(Mm),trkseg:tl(J(function(a,b,c){zl({node:a,geometryLayout:b.ka,properties:{}},Cn,Dn,b.X(),c)}))}),Dn=ul("trkpt"),
	Cn=K($m,{trkpt:J(vn)}),xn=K($m,"ele time magvar geoidheight name cmt desc src link sym type fix sat hdop vdop pdop ageofdgpsdata dgpsid".split(" ")),yn=K($m,{ele:J(Nm),time:J(function(a,b){var c=new Date(1E3*b);a.appendChild(gl.createTextNode(c.getUTCFullYear()+"-"+Oe(c.getUTCMonth()+1)+"-"+Oe(c.getUTCDate())+"T"+Oe(c.getUTCHours())+":"+Oe(c.getUTCMinutes())+":"+Oe(c.getUTCSeconds())+"Z"))}),magvar:J(Nm),geoidheight:J(Nm),name:J(Mm),cmt:J(Mm),desc:J(Mm),src:J(Mm),link:J(sn),sym:J(Mm),type:J(Mm),fix:J(Mm),
	sat:J(Om),hdop:J(Nm),vdop:J(Nm),pdop:J(Nm),ageofdgpsdata:J(Nm),dgpsid:J(Om)}),Fn={Point:"wpt",LineString:"rte",MultiLineString:"trk"};function Gn(a,b){var c=a.U();if(c&&(c=Fn[c.T()]))return il(b[b.length-1].node.namespaceURI,c)}
	var Hn=K($m,{rte:J(function(a,b,c){var d=c[0],e=b.N();a={node:a,properties:e};if(b=b.U())b=Fl(b,!0,d),a.geometryLayout=b.ka,e.rtept=b.X();d=zn[c[c.length-1].node.namespaceURI];e=xl(e,d);zl(a,An,wl,e,c,d)}),trk:J(function(a,b,c){var d=c[0],e=b.N();a={node:a,properties:e};if(b=b.U())b=Fl(b,!0,d),e.trkseg=b.hd();d=Bn[c[c.length-1].node.namespaceURI];e=xl(e,d);zl(a,En,wl,e,c,d)}),wpt:J(function(a,b,c){var d=c[0],e=c[c.length-1];e.properties=b.N();if(b=b.U())b=Fl(b,!0,d),e.geometryLayout=b.ka,vn(a,b.X(),
	c)})});Zm.prototype.Yb=function(a,b){b=El(this,b);var c=il("http://www.topografix.com/GPX/1/1","gpx");c.setAttributeNS("http://www.w3.org/2000/xmlns/","xmlns:xsi","http://www.w3.org/2001/XMLSchema-instance");c.setAttributeNS("http://www.w3.org/2001/XMLSchema-instance","xsi:schemaLocation","http://www.topografix.com/GPX/1/1 http://www.topografix.com/GPX/1/1/gpx.xsd");c.setAttribute("version","1.1");c.setAttribute("creator","OpenLayers");zl({node:c},Hn,Gn,a,[b]);return c};function In(){Cl.call(this)}u(In,Cl);function Jn(a){return"string"===typeof a?a:""}k=In.prototype;k.T=function(){return"text"};k.Ub=function(a,b){return this.Wd(Jn(a),El(this,b))};k.Qa=function(a,b){return this.lg(Jn(a),El(this,b))};k.Tc=function(a,b){return this.ud(Jn(a),El(this,b))};k.kb=function(){return this.defaultDataProjection};k.yd=function(a,b){return this.be(a,El(this,b))};k.Xb=function(a,b){return this.Gg(a,El(this,b))};k.bd=function(a,b){return this.Ad(a,El(this,b))};function Kn(a){a=a?a:{};Cl.call(this);this.defaultDataProjection=Gb("EPSG:4326");this.b=a.altitudeMode?a.altitudeMode:"none"}u(Kn,In);var Ln=/^B(\d{2})(\d{2})(\d{2})(\d{2})(\d{5})([NS])(\d{3})(\d{5})([EW])([AV])(\d{5})(\d{5})/,Mn=/^H.([A-Z]{3}).*?:(.*)/,Nn=/^HFDTE(\d{2})(\d{2})(\d{2})/,On=/\r\n|\r|\n/;k=Kn.prototype;
	k.Wd=function(a,b){var c=this.b,d=a.split(On),e={},f=[],g=2E3,h=0,l=1,m=-1,p,n;p=0;for(n=d.length;p<n;++p){var q=d[p],r;if("B"==q.charAt(0)){if(r=Ln.exec(q)){var q=parseInt(r[1],10),v=parseInt(r[2],10),x=parseInt(r[3],10),y=parseInt(r[4],10)+parseInt(r[5],10)/6E4;"S"==r[6]&&(y=-y);var z=parseInt(r[7],10)+parseInt(r[8],10)/6E4;"W"==r[9]&&(z=-z);f.push(z,y);"none"!=c&&f.push("gps"==c?parseInt(r[11],10):"barometric"==c?parseInt(r[12],10):0);r=Date.UTC(g,h,l,q,v,x);r<m&&(r=Date.UTC(g,h,l+1,q,v,x));f.push(r/
	1E3);m=r}}else"H"==q.charAt(0)&&((r=Nn.exec(q))?(l=parseInt(r[1],10),h=parseInt(r[2],10)-1,g=2E3+parseInt(r[3],10)):(r=Mn.exec(q))&&(e[r[1]]=r[2].trim()))}if(!f.length)return null;d=new M(null);d.ca("none"==c?"XYM":"XYZM",f);c=new H(Fl(d,!1,b));c.H(e);return c};k.lg=function(a,b){var c=this.Wd(a,b);return c?[c]:[]};k.be=function(){};k.Gg=function(){};k.Ad=function(){};k.ud=function(){};function Pn(a,b,c,d,e,f){Dc.call(this);this.l=null;this.M=a?a:new Image;null!==d&&(this.M.crossOrigin=d);this.c=f?document.createElement("CANVAS"):null;this.g=f;this.i=null;this.f=e;this.a=c;this.j=b;this.o=!1;2==this.f&&Qn(this)}u(Pn,Dc);function Qn(a){var b=Xc(1,1);try{b.drawImage(a.M,0,0),b.getImageData(0,0,1,1)}catch(c){a.o=!0}}Pn.prototype.v=function(){this.f=3;this.i.forEach(rc);this.i=null;this.b("change")};
	Pn.prototype.I=function(){this.f=2;this.a&&(this.M.width=this.a[0],this.M.height=this.a[1]);this.a=[this.M.width,this.M.height];this.i.forEach(rc);this.i=null;Qn(this);if(!this.o&&null!==this.g){this.c.width=this.M.width;this.c.height=this.M.height;var a=this.c.getContext("2d");a.drawImage(this.M,0,0);for(var b=a.getImageData(0,0,this.M.width,this.M.height),c=b.data,d=this.g[0]/255,e=this.g[1]/255,f=this.g[2]/255,g=0,h=c.length;g<h;g+=4)c[g]*=d,c[g+1]*=e,c[g+2]*=f;a.putImageData(b,0,0)}this.b("change")};
	Pn.prototype.Z=function(){return this.c?this.c:this.M};Pn.prototype.load=function(){if(0==this.f){this.f=1;this.i=[wc(this.M,"error",this.v,this),wc(this.M,"load",this.I,this)];try{this.M.src=this.j}catch(a){this.v()}}};function Rn(a){a=a||{};this.j=void 0!==a.anchor?a.anchor:[.5,.5];this.I=null;this.a=void 0!==a.anchorOrigin?a.anchorOrigin:"top-left";this.C=void 0!==a.anchorXUnits?a.anchorXUnits:"fraction";this.G=void 0!==a.anchorYUnits?a.anchorYUnits:"fraction";this.ta=void 0!==a.crossOrigin?a.crossOrigin:null;var b=void 0!==a.img?a.img:null,c=void 0!==a.imgSize?a.imgSize:null,d=a.src;qa(!(void 0!==d&&b),4);qa(!b||b&&c,5);void 0!==d&&d.length||!b||(d=b.src||w(b).toString());qa(void 0!==d&&0<d.length,6);var e=void 0!==
	a.src?0:2;this.i=void 0!==a.color?Qc(a.color):null;var f=this.ta,g=this.i,h=uh.get(d,f,g);h||(h=new Pn(b,d,c,f,e,g),uh.set(d,f,g,h));this.b=h;this.qa=void 0!==a.offset?a.offset:[0,0];this.f=void 0!==a.offsetOrigin?a.offsetOrigin:"top-left";this.u=null;this.A=void 0!==a.size?a.size:null;Vk.call(this,{opacity:void 0!==a.opacity?a.opacity:1,rotation:void 0!==a.rotation?a.rotation:0,scale:void 0!==a.scale?a.scale:1,snapToPixel:void 0!==a.snapToPixel?a.snapToPixel:!0,rotateWithView:void 0!==a.rotateWithView?
	a.rotateWithView:!1})}u(Rn,Vk);k=Rn.prototype;
	k.clone=function(){var a=this.Z(1),b;if(2===this.b.f)if("IMG"===a.tagName.toUpperCase())b=a.cloneNode(!0);else{b=document.createElement("canvas");var c=b.getContext("2d");b.width=a.width;b.height=a.height;c.drawImage(a,0,0)}return new Rn({anchor:this.j.slice(),anchorOrigin:this.a,anchorXUnits:this.C,anchorYUnits:this.G,crossOrigin:this.ta,color:this.i&&this.i.slice?this.i.slice():this.i||void 0,img:b?b:void 0,imgSize:b?this.b.a.slice():void 0,src:b?void 0:this.b.j,offset:this.qa.slice(),offsetOrigin:this.f,
	size:null!==this.A?this.A.slice():void 0,opacity:this.g,scale:this.c,snapToPixel:this.v,rotation:this.l,rotateWithView:this.o})};
	k.Hc=function(){if(this.I)return this.I;var a=this.j,b=this.jc();if("fraction"==this.C||"fraction"==this.G){if(!b)return null;a=this.j.slice();"fraction"==this.C&&(a[0]*=b[0]);"fraction"==this.G&&(a[1]*=b[1])}if("top-left"!=this.a){if(!b)return null;a===this.j&&(a=this.j.slice());if("top-right"==this.a||"bottom-right"==this.a)a[0]=-a[0]+b[0];if("bottom-left"==this.a||"bottom-right"==this.a)a[1]=-a[1]+b[1]}return this.I=a};k.Zn=function(){return this.i};k.Z=function(a){return this.b.Z(a)};k.ue=function(){return this.b.a};
	k.Oe=function(){return this.b.f};k.cg=function(){var a=this.b;if(!a.l)if(a.o){var b=a.a[0],c=a.a[1],d=Xc(b,c);d.fillRect(0,0,b,c);a.l=d.canvas}else a.l=a.M;return a.l};k.Pc=function(){if(this.u)return this.u;var a=this.qa;if("top-left"!=this.f){var b=this.jc(),c=this.b.a;if(!b||!c)return null;a=a.slice();if("top-right"==this.f||"bottom-right"==this.f)a[0]=c[0]-b[0]-a[0];if("bottom-left"==this.f||"bottom-right"==this.f)a[1]=c[1]-b[1]-a[1]}return this.u=a};k.$n=function(){return this.b.j};
	k.jc=function(){return this.A?this.A:this.b.a};k.zh=function(a,b){return B(this.b,"change",a,b)};k.load=function(){this.b.load()};k.Yi=function(a,b){xc(this.b,"change",a,b)};function Sn(a){a=a||{};this.a=a.font;this.i=a.rotation;this.j=a.rotateWithView;this.b=a.scale;this.Fa=a.text;this.g=a.textAlign;this.l=a.textBaseline;this.Wa=void 0!==a.fill?a.fill:new Zk({color:"#333"});this.Ya=void 0!==a.stroke?a.stroke:null;this.f=void 0!==a.offsetX?a.offsetX:0;this.c=void 0!==a.offsetY?a.offsetY:0}k=Sn.prototype;
	k.clone=function(){return new Sn({font:this.a,rotation:this.i,rotateWithView:this.j,scale:this.b,text:this.Pa(),textAlign:this.g,textBaseline:this.l,fill:this.Ca()?this.Ca().clone():void 0,stroke:this.Da()?this.Da().clone():void 0,offsetX:this.f,offsetY:this.c})};k.tk=function(){return this.a};k.Ik=function(){return this.f};k.Jk=function(){return this.c};k.Ca=function(){return this.Wa};k.fo=function(){return this.j};k.ho=function(){return this.i};k.io=function(){return this.b};k.Da=function(){return this.Ya};
	k.Pa=function(){return this.Fa};k.Tk=function(){return this.g};k.Uk=function(){return this.l};k.Ii=function(a){this.a=a};k.Oi=function(a){this.f=a};k.Pi=function(a){this.c=a};k.cf=function(a){this.Wa=a};k.jo=function(a){this.i=a};k.ni=function(a){this.b=a};k.df=function(a){this.Ya=a};k.ef=function(a){this.Fa=a};k.Ri=function(a){this.g=a};k.up=function(a){this.l=a};function Tn(a){a=a?a:{};zm.call(this);Un||(Vn=[255,255,255,1],Wn=new Zk({color:Vn}),Xn=[20,2],Yn=Zn="pixels",$n=[64,64],ao="https://maps.google.com/mapfiles/kml/pushpin/ylw-pushpin.png",bo=.5,co=new Rn({anchor:Xn,anchorOrigin:"bottom-left",anchorXUnits:Zn,anchorYUnits:Yn,crossOrigin:"anonymous",rotation:0,scale:bo,size:$n,src:ao}),eo="NO_IMAGE",fo=new rj({color:Vn,width:1}),go=new rj({color:[51,51,51,1],width:2}),ho=new Sn({font:"bold 16px Helvetica",fill:Wn,stroke:go,scale:.8}),io=new $k({fill:Wn,
	image:co,text:ho,stroke:fo,zIndex:0}),Un=[io]);this.defaultDataProjection=Gb("EPSG:4326");this.a=a.defaultStyle?a.defaultStyle:Un;this.c=void 0!==a.extractStyles?a.extractStyles:!0;this.l=void 0!==a.writeStyles?a.writeStyles:!0;this.b={};this.i=void 0!==a.showPointNames?a.showPointNames:!0}var Un,Vn,Wn,Xn,Zn,Yn,$n,ao,bo,co,eo,fo,go,ho,io;u(Tn,zm);
	var jo=["http://www.google.com/kml/ext/2.2"],ko=[null,"http://earth.google.com/kml/2.0","http://earth.google.com/kml/2.1","http://earth.google.com/kml/2.2","http://www.opengis.net/kml/2.2"],lo={fraction:"fraction",pixels:"pixels"};
	function mo(a,b){var c,d=[0,0],e="start";a.Z()&&(c=a.Z().ue(),null===c&&(c=$n),2==c.length&&(e=a.Z().c,d[0]=e*c[0]/2,d[1]=-e*c[1]/2,e="left"));if(null!==a.Pa()){var f=a.Pa();c=f.clone();c.Ii(f.a||ho.a);c.ni(f.b||ho.b);c.cf(f.Ca()||ho.Ca());c.df(f.Da()||go)}else c=ho.clone();c.ef(b);c.Oi(d[0]);c.Pi(d[1]);c.Ri(e);return new $k({text:c})}
	function no(a,b,c,d,e){return function(){var f=e,g="";f&&this.U()&&(f="Point"===this.U().T());f&&(g=this.get("name"),f=f&&g);if(a)return f?(f=mo(a[0],g),a.concat(f)):a;if(b){var h=oo(b,c,d);return f?(f=mo(h[0],g),h.concat(f)):h}return f?(f=mo(c[0],g),c.concat(f)):c}}function oo(a,b,c){return Array.isArray(a)?a:"string"===typeof a?(!(a in c)&&"#"+a in c&&(a="#"+a),oo(c[a],b,c)):b}
	function po(a){a=jl(a,!1);if(a=/^\s*#?\s*([0-9A-Fa-f]{8})\s*$/.exec(a))return a=a[1],[parseInt(a.substr(6,2),16),parseInt(a.substr(4,2),16),parseInt(a.substr(2,2),16),parseInt(a.substr(0,2),16)/255]}function qo(a){a=jl(a,!1);for(var b=[],c=/^\s*([+\-]?\d*\.?\d+(?:e[+\-]?\d+)?)\s*,\s*([+\-]?\d*\.?\d+(?:e[+\-]?\d+)?)(?:\s*,\s*([+\-]?\d*\.?\d+(?:e[+\-]?\d+)?))?\s*/i,d;d=c.exec(a);)b.push(parseFloat(d[1]),parseFloat(d[2]),d[3]?parseFloat(d[3]):0),a=a.substr(d[0].length);if(""===a)return b}
	function ro(a){var b=jl(a,!1).trim();return a.baseURI?(new URL(b,a.baseURI)).href:b}function so(a){return Hm(a)}function to(a,b){return L(null,uo,a,b)}function vo(a,b){var c=L({B:[],bj:[]},wo,a,b);if(c){var d=c.B,c=c.bj,e,f;e=0;for(f=Math.min(d.length,c.length);e<f;++e)d[4*e+3]=c[e];c=new M(null);c.ca("XYZM",d);return c}}function xo(a,b){var c=L({},yo,a,b),d=L(null,zo,a,b);if(d){var e=new M(null);e.ca("XYZ",d);e.H(c);return e}}
	function Ao(a,b){var c=L({},yo,a,b),d=L(null,zo,a,b);if(d){var e=new F(null);e.ca("XYZ",d,[d.length]);e.H(c);return e}}
	function Bo(a,b){var c=L([],Co,a,b);if(!c)return null;if(!c.length)return new qm(c);var d,e=!0,f=c[0].T(),g,h,l;h=1;for(l=c.length;h<l;++h)if(g=c[h],g.T()!=f){e=!1;break}if(e)if("Point"==f){d=c[0];e=d.ka;f=d.ha();h=1;for(l=c.length;h<l;++h)g=c[h],ga(f,g.ha());d=new O(null);d.ca(e,f);Do(d,c)}else"LineString"==f?(d=new N(null),Ll(d,c),Do(d,c)):"Polygon"==f?(d=new P(null),Nl(d,c),Do(d,c)):"GeometryCollection"==f?d=new qm(c):qa(!1,37);else d=new qm(c);return d}
	function Eo(a,b){var c=L({},yo,a,b),d=L(null,zo,a,b);if(d){var e=new E(null);e.ca("XYZ",d);e.H(c);return e}}function Fo(a,b){var c=L({},yo,a,b),d=L([null],Go,a,b);if(d&&d[0]){var e=new F(null),f=d[0],g=[f.length],h,l;h=1;for(l=d.length;h<l;++h)ga(f,d[h]),g.push(f.length);e.ca("XYZ",f,g);e.H(c);return e}}
	function Ho(a,b){var c=L({},Io,a,b);if(!c)return null;var d="fillStyle"in c?c.fillStyle:Wn,e=c.fill;void 0===e||e||(d=null);e="imageStyle"in c?c.imageStyle:co;e==eo&&(e=void 0);var f="textStyle"in c?c.textStyle:ho,g="strokeStyle"in c?c.strokeStyle:fo,c=c.outline;void 0===c||c||(g=null);return[new $k({fill:d,image:e,stroke:g,text:f,zIndex:void 0})]}
	function Do(a,b){var c=b.length,d=Array(b.length),e=Array(b.length),f,g,h,l;h=l=!1;for(g=0;g<c;++g)f=b[g],d[g]=f.get("extrude"),e[g]=f.get("altitudeMode"),h=h||void 0!==d[g],l=l||e[g];h&&a.set("extrude",d);l&&a.set("altitudeMode",e)}function Jo(a,b){yl(Ko,a,b)}function Lo(a,b){yl(Mo,a,b)}
	var No=K(ko,{displayName:I(Q),value:I(Q)}),Ko=K(ko,{Data:function(a,b){var c=a.getAttribute("name");yl(No,a,b);var d=b[b.length-1];null!==c?d[c]=d.value:null!==d.displayName&&(d[d.displayName]=d.value)},SchemaData:function(a,b){yl(Oo,a,b)}}),Mo=K(ko,{LatLonAltBox:function(a,b){var c=L({},Po,a,b);if(c){var d=b[b.length-1];d.extent=[parseFloat(c.west),parseFloat(c.south),parseFloat(c.east),parseFloat(c.north)];d.altitudeMode=c.altitudeMode;d.minAltitude=parseFloat(c.minAltitude);d.maxAltitude=parseFloat(c.maxAltitude)}},
	Lod:function(a,b){var c=L({},Qo,a,b);if(c){var d=b[b.length-1];d.minLodPixels=parseFloat(c.minLodPixels);d.maxLodPixels=parseFloat(c.maxLodPixels);d.minFadeExtent=parseFloat(c.minFadeExtent);d.maxFadeExtent=parseFloat(c.maxFadeExtent)}}}),Po=K(ko,{altitudeMode:I(Q),minAltitude:I(Hm),maxAltitude:I(Hm),north:I(Hm),south:I(Hm),east:I(Hm),west:I(Hm)}),Qo=K(ko,{minLodPixels:I(Hm),maxLodPixels:I(Hm),minFadeExtent:I(Hm),maxFadeExtent:I(Hm)}),yo=K(ko,{extrude:I(Em),altitudeMode:I(Q)}),uo=K(ko,{coordinates:rl(qo)}),
	Go=K(ko,{innerBoundaryIs:function(a,b){var c=L(void 0,Ro,a,b);c&&b[b.length-1].push(c)},outerBoundaryIs:function(a,b){var c=L(void 0,So,a,b);c&&(b[b.length-1][0]=c)}}),wo=K(ko,{when:function(a,b){var c=b[b.length-1].bj,d=jl(a,!1),d=Date.parse(d);c.push(isNaN(d)?0:d)}},K(jo,{coord:function(a,b){var c=b[b.length-1].B,d=jl(a,!1);(d=/^\s*([+\-]?\d+(?:\.\d*)?(?:e[+\-]?\d*)?)\s+([+\-]?\d+(?:\.\d*)?(?:e[+\-]?\d*)?)\s+([+\-]?\d+(?:\.\d*)?(?:e[+\-]?\d*)?)\s*$/i.exec(d))?c.push(parseFloat(d[1]),parseFloat(d[2]),
	parseFloat(d[3]),0):c.push(0,0,0,0)}})),zo=K(ko,{coordinates:rl(qo)}),To=K(ko,{href:I(ro)},K(jo,{x:I(Hm),y:I(Hm),w:I(Hm),h:I(Hm)})),Uo=K(ko,{Icon:I(function(a,b){var c=L({},To,a,b);return c?c:null}),heading:I(Hm),hotSpot:I(function(a){var b=a.getAttribute("xunits"),c=a.getAttribute("yunits");return{x:parseFloat(a.getAttribute("x")),Hg:lo[b],y:parseFloat(a.getAttribute("y")),Ig:lo[c]}}),scale:I(so)}),Ro=K(ko,{LinearRing:rl(to)}),Vo=K(ko,{color:I(po),scale:I(so)}),Wo=K(ko,{color:I(po),width:I(Hm)}),
	Co=K(ko,{LineString:ql(xo),LinearRing:ql(Ao),MultiGeometry:ql(Bo),Point:ql(Eo),Polygon:ql(Fo)}),Xo=K(jo,{Track:ql(vo)}),Zo=K(ko,{ExtendedData:Jo,Region:Lo,Link:function(a,b){yl(Yo,a,b)},address:I(Q),description:I(Q),name:I(Q),open:I(Em),phoneNumber:I(Q),visibility:I(Em)}),Yo=K(ko,{href:I(ro)}),So=K(ko,{LinearRing:rl(to)}),$o=K(ko,{Style:I(Ho),key:I(Q),styleUrl:I(ro)}),bp=K(ko,{ExtendedData:Jo,Region:Lo,MultiGeometry:I(Bo,"geometry"),LineString:I(xo,"geometry"),LinearRing:I(Ao,"geometry"),Point:I(Eo,
	"geometry"),Polygon:I(Fo,"geometry"),Style:I(Ho),StyleMap:function(a,b){var c=L(void 0,ap,a,b);if(c){var d=b[b.length-1];Array.isArray(c)?d.Style=c:"string"===typeof c?d.styleUrl=c:qa(!1,38)}},address:I(Q),description:I(Q),name:I(Q),open:I(Em),phoneNumber:I(Q),styleUrl:I(ro),visibility:I(Em)},K(jo,{MultiTrack:I(function(a,b){var c=L([],Xo,a,b);if(c){var d=new N(null);Ll(d,c);return d}},"geometry"),Track:I(vo,"geometry")})),cp=K(ko,{color:I(po),fill:I(Em),outline:I(Em)}),Oo=K(ko,{SimpleData:function(a,
	b){var c=a.getAttribute("name");if(null!==c){var d=Q(a);b[b.length-1][c]=d}}}),Io=K(ko,{IconStyle:function(a,b){var c=L({},Uo,a,b);if(c){var d=b[b.length-1],e="Icon"in c?c.Icon:{},f=!("Icon"in c)||0<Object.keys(e).length,g,h=e.href;h?g=h:f&&(g=ao);var l,m,p;(h=c.hotSpot)?(l=[h.x,h.y],m=h.Hg,p=h.Ig):g===ao?(l=Xn,m=Zn,p=Yn):/^http:\/\/maps\.(?:google|gstatic)\.com\//.test(g)&&(l=[.5,0],p=m="fraction");var n,h=e.x,q=e.y;void 0!==h&&void 0!==q&&(n=[h,q]);var r,h=e.w,e=e.h;void 0!==h&&void 0!==e&&(r=[h,
	e]);var v,e=c.heading;void 0!==e&&(v=Ba(e));c=c.scale;f?(g==ao&&(r=$n,void 0===c&&(c=bo)),f=new Rn({anchor:l,anchorOrigin:"bottom-left",anchorXUnits:m,anchorYUnits:p,crossOrigin:"anonymous",offset:n,offsetOrigin:"bottom-left",rotation:v,scale:c,size:r,src:g}),d.imageStyle=f):d.imageStyle=eo}},LabelStyle:function(a,b){var c=L({},Vo,a,b);c&&(b[b.length-1].textStyle=new Sn({fill:new Zk({color:"color"in c?c.color:Vn}),scale:c.scale}))},LineStyle:function(a,b){var c=L({},Wo,a,b);c&&(b[b.length-1].strokeStyle=
	new rj({color:"color"in c?c.color:Vn,width:"width"in c?c.width:1}))},PolyStyle:function(a,b){var c=L({},cp,a,b);if(c){var d=b[b.length-1];d.fillStyle=new Zk({color:"color"in c?c.color:Vn});var e=c.fill;void 0!==e&&(d.fill=e);c=c.outline;void 0!==c&&(d.outline=c)}}}),ap=K(ko,{Pair:function(a,b){var c=L({},$o,a,b);if(c){var d=c.key;d&&"normal"==d&&((d=c.styleUrl)&&(b[b.length-1]=d),(c=c.Style)&&(b[b.length-1]=c))}}});k=Tn.prototype;
	k.hg=function(a,b){var c=K(ko,{Document:pl(this.hg,this),Folder:pl(this.hg,this),Placemark:ql(this.pg,this),Style:this.Yo.bind(this),StyleMap:this.Xo.bind(this)});if(c=L([],c,a,b,this))return c};k.pg=function(a,b){var c=L({geometry:null},bp,a,b);if(c){var d=new H,e=a.getAttribute("id");null!==e&&d.kc(e);var e=b[0],f=c.geometry;f&&Fl(f,!1,e);d.Sa(f);delete c.geometry;this.c&&d.Vf(no(c.Style,c.styleUrl,this.a,this.b,this.i));delete c.Style;d.H(c);return d}};
	k.Yo=function(a,b){var c=a.getAttribute("id");if(null!==c){var d=Ho(a,b);d&&(c=a.baseURI?(new URL("#"+c,a.baseURI)).href:"#"+c,this.b[c]=d)}};k.Xo=function(a,b){var c=a.getAttribute("id");if(null!==c){var d=L(void 0,ap,a,b);d&&(c=a.baseURI?(new URL("#"+c,a.baseURI)).href:"#"+c,this.b[c]=d)}};k.jg=function(a,b){if(!ea(ko,a.namespaceURI))return null;var c=this.pg(a,[Dl(this,a,b)]);return c?c:null};
	k.yc=function(a,b){if(!ea(ko,a.namespaceURI))return[];var c;c=a.localName;if("Document"==c||"Folder"==c)return(c=this.hg(a,[Dl(this,a,b)]))?c:[];if("Placemark"==c)return(c=this.pg(a,[Dl(this,a,b)]))?[c]:[];if("kml"==c){c=[];var d;for(d=a.firstElementChild;d;d=d.nextElementSibling){var e=this.yc(d,b);e&&ga(c,e)}return c}return[]};k.Ro=function(a){if(ll(a))return dp(this,a);if(ml(a))return ep(this,a);if("string"===typeof a)return a=nl(a),dp(this,a)};
	function dp(a,b){var c;for(c=b.firstChild;c;c=c.nextSibling)if(c.nodeType==Node.ELEMENT_NODE){var d=ep(a,c);if(d)return d}}function ep(a,b){var c;for(c=b.firstElementChild;c;c=c.nextElementSibling)if(ea(ko,c.namespaceURI)&&"name"==c.localName)return Q(c);for(c=b.firstElementChild;c;c=c.nextElementSibling){var d=c.localName;if(ea(ko,c.namespaceURI)&&("Document"==d||"Folder"==d||"Placemark"==d||"kml"==d)&&(d=ep(a,c)))return d}}
	k.So=function(a){var b=[];ll(a)?ga(b,fp(this,a)):ml(a)?ga(b,gp(this,a)):"string"===typeof a&&(a=nl(a),ga(b,fp(this,a)));return b};function fp(a,b){var c,d=[];for(c=b.firstChild;c;c=c.nextSibling)c.nodeType==Node.ELEMENT_NODE&&ga(d,gp(a,c));return d}
	function gp(a,b){var c,d=[];for(c=b.firstElementChild;c;c=c.nextElementSibling)if(ea(ko,c.namespaceURI)&&"NetworkLink"==c.localName){var e=L({},Zo,c,[]);d.push(e)}for(c=b.firstElementChild;c;c=c.nextElementSibling)e=c.localName,!ea(ko,c.namespaceURI)||"Document"!=e&&"Folder"!=e&&"kml"!=e||ga(d,gp(a,c));return d}k.Vo=function(a){var b=[];ll(a)?ga(b,hp(this,a)):ml(a)?ga(b,this.$e(a)):"string"===typeof a&&(a=nl(a),ga(b,hp(this,a)));return b};
	function hp(a,b){var c,d=[];for(c=b.firstChild;c;c=c.nextSibling)c.nodeType==Node.ELEMENT_NODE&&ga(d,a.$e(c));return d}k.$e=function(a){var b,c=[];for(b=a.firstElementChild;b;b=b.nextElementSibling)if(ea(ko,b.namespaceURI)&&"Region"==b.localName){var d=L({},Mo,b,[]);c.push(d)}for(b=a.firstElementChild;b;b=b.nextElementSibling)a=b.localName,!ea(ko,b.namespaceURI)||"Document"!=a&&"Folder"!=a&&"kml"!=a||ga(c,this.$e(b));return c};
	function ip(a,b){var c=Qc(b),c=[255*(4==c.length?c[3]:1),c[2],c[1],c[0]],d;for(d=0;4>d;++d){var e=parseInt(c[d],10).toString(16);c[d]=1==e.length?"0"+e:e}Mm(a,c.join(""))}function jp(a,b,c){a={node:a};var d=b.T(),e,f;"GeometryCollection"==d?(e=b.If(),f=kp):"MultiPoint"==d?(e=b.Ie(),f=lp):"MultiLineString"==d?(e=b.hd(),f=mp):"MultiPolygon"==d?(e=b.Od(),f=np):qa(!1,39);zl(a,op,f,e,c)}function pp(a,b,c){zl({node:a},qp,rp,[b],c)}
	function sp(a,b,c){var d={node:a};b.a&&a.setAttribute("id",b.a);a=b.N();var e={address:1,description:1,name:1,open:1,phoneNumber:1,styleUrl:1,visibility:1};e[b.c]=1;var f=Object.keys(a||{}).sort().filter(function(a){return!e[a]});if(0<f.length){var g=xl(a,f);zl(d,tp,up,[{names:f,values:g}],c)}if(f=b.Nc())if(f=f.call(b,0))f=Array.isArray(f)?f[0]:f,this.l&&(a.Style=f),(f=f.Pa())&&(a.name=f.Pa());f=vp[c[c.length-1].node.namespaceURI];a=xl(a,f);zl(d,tp,wl,a,c,f);a=c[0];(b=b.U())&&(b=Fl(b,!0,a));zl(d,
	tp,kp,[b],c)}function wp(a,b,c){var d=b.ha();a={node:a};a.layout=b.ka;a.stride=b.sa();zl(a,xp,yp,[d],c)}function zp(a,b,c){b=b.jd();var d=b.shift();a={node:a};zl(a,Ap,Bp,b,c);zl(a,Ap,Cp,[d],c)}function Dp(a,b){Nm(a,Math.round(1E6*b)/1E6)}
	var Ep=K(ko,["Document","Placemark"]),Hp=K(ko,{Document:J(function(a,b,c){zl({node:a},Fp,Gp,b,c,void 0,this)}),Placemark:J(sp)}),Fp=K(ko,{Placemark:J(sp)}),Ip=K(ko,{Data:J(function(a,b,c){a.setAttribute("name",b.name);a={node:a};b=b.value;"object"==typeof b?(null!==b&&b.displayName&&zl(a,Ip,wl,[b.displayName],c,["displayName"]),null!==b&&b.value&&zl(a,Ip,wl,[b.value],c,["value"])):zl(a,Ip,wl,[b],c,["value"])}),value:J(function(a,b){Mm(a,b)}),displayName:J(function(a,b){a.appendChild(gl.createCDATASection(b))})}),
	Jp={Point:"Point",LineString:"LineString",LinearRing:"LinearRing",Polygon:"Polygon",MultiPoint:"MultiGeometry",MultiLineString:"MultiGeometry",MultiPolygon:"MultiGeometry",GeometryCollection:"MultiGeometry"},Kp=K(ko,["href"],K(jo,["x","y","w","h"])),Lp=K(ko,{href:J(Mm)},K(jo,{x:J(Nm),y:J(Nm),w:J(Nm),h:J(Nm)})),Mp=K(ko,["scale","heading","Icon","hotSpot"]),Op=K(ko,{Icon:J(function(a,b,c){a={node:a};var d=Kp[c[c.length-1].node.namespaceURI],e=xl(b,d);zl(a,Lp,wl,e,c,d);d=Kp[jo[0]];e=xl(b,d);zl(a,Lp,
	Np,e,c,d)}),heading:J(Nm),hotSpot:J(function(a,b){a.setAttribute("x",b.x);a.setAttribute("y",b.y);a.setAttribute("xunits",b.Hg);a.setAttribute("yunits",b.Ig)}),scale:J(Dp)}),Pp=K(ko,["color","scale"]),Qp=K(ko,{color:J(ip),scale:J(Dp)}),Rp=K(ko,["color","width"]),Sp=K(ko,{color:J(ip),width:J(Nm)}),qp=K(ko,{LinearRing:J(wp)}),op=K(ko,{LineString:J(wp),Point:J(wp),Polygon:J(zp),GeometryCollection:J(jp)}),vp=K(ko,"name open visibility address phoneNumber description styleUrl Style".split(" ")),tp=K(ko,
	{ExtendedData:J(function(a,b,c){a={node:a};var d=b.names;b=b.values;for(var e=d.length,f=0;f<e;f++)zl(a,Ip,Tp,[{name:d[f],value:b[f]}],c)}),MultiGeometry:J(jp),LineString:J(wp),LinearRing:J(wp),Point:J(wp),Polygon:J(zp),Style:J(function(a,b,c){a={node:a};var d={},e=b.Ca(),f=b.Da(),g=b.Z();b=b.Pa();g instanceof Rn&&(d.IconStyle=g);b&&(d.LabelStyle=b);f&&(d.LineStyle=f);e&&(d.PolyStyle=e);b=Up[c[c.length-1].node.namespaceURI];d=xl(d,b);zl(a,Vp,wl,d,c,b)}),address:J(Mm),description:J(Mm),name:J(Mm),
	open:J(Lm),phoneNumber:J(Mm),styleUrl:J(Mm),visibility:J(Lm)}),xp=K(ko,{coordinates:J(function(a,b,c){c=c[c.length-1];var d=c.layout;c=c.stride;var e;"XY"==d||"XYM"==d?e=2:"XYZ"==d||"XYZM"==d?e=3:qa(!1,34);var f,g=b.length,h="";if(0<g){h+=b[0];for(d=1;d<e;++d)h+=","+b[d];for(f=c;f<g;f+=c)for(h+=" "+b[f],d=1;d<e;++d)h+=","+b[f+d]}Mm(a,h)})}),Ap=K(ko,{outerBoundaryIs:J(pp),innerBoundaryIs:J(pp)}),Wp=K(ko,{color:J(ip)}),Up=K(ko,["IconStyle","LabelStyle","LineStyle","PolyStyle"]),Vp=K(ko,{IconStyle:J(function(a,
	b,c){a={node:a};var d={},e=b.jc(),f=b.ue(),g={href:b.b.j};if(e){g.w=e[0];g.h=e[1];var h=b.Hc(),l=b.Pc();l&&f&&l[0]&&l[1]!==e[1]&&(g.x=l[0],g.y=f[1]-(l[1]+e[1]));h&&h[0]&&h[1]!==e[1]&&(d.hotSpot={x:h[0],Hg:"pixels",y:e[1]-h[1],Ig:"pixels"})}d.Icon=g;e=b.c;1!==e&&(d.scale=e);(b=b.l)&&(d.heading=b);b=Mp[c[c.length-1].node.namespaceURI];d=xl(d,b);zl(a,Op,wl,d,c,b)}),LabelStyle:J(function(a,b,c){a={node:a};var d={},e=b.Ca();e&&(d.color=e.b);(b=b.b)&&1!==b&&(d.scale=b);b=Pp[c[c.length-1].node.namespaceURI];
	d=xl(d,b);zl(a,Qp,wl,d,c,b)}),LineStyle:J(function(a,b,c){a={node:a};var d=Rp[c[c.length-1].node.namespaceURI];b=xl({color:b.a,width:b.c},d);zl(a,Sp,wl,b,c,d)}),PolyStyle:J(function(a,b,c){zl({node:a},Wp,Xp,[b.b],c)})});function Np(a,b,c){return il(jo[0],"gx:"+c)}function Gp(a,b){return il(b[b.length-1].node.namespaceURI,"Placemark")}function kp(a,b){if(a)return il(b[b.length-1].node.namespaceURI,Jp[a.T()])}
	var Xp=ul("color"),yp=ul("coordinates"),Tp=ul("Data"),up=ul("ExtendedData"),Bp=ul("innerBoundaryIs"),lp=ul("Point"),mp=ul("LineString"),rp=ul("LinearRing"),np=ul("Polygon"),Cp=ul("outerBoundaryIs");
	Tn.prototype.Yb=function(a,b){b=El(this,b);var c=il(ko[4],"kml");c.setAttributeNS("http://www.w3.org/2000/xmlns/","xmlns:gx",jo[0]);c.setAttributeNS("http://www.w3.org/2000/xmlns/","xmlns:xsi","http://www.w3.org/2001/XMLSchema-instance");c.setAttributeNS("http://www.w3.org/2001/XMLSchema-instance","xsi:schemaLocation","http://www.opengis.net/kml/2.2 https://developers.google.com/kml/schema/kml22gx.xsd");var d={node:c},e={};1<a.length?e.Document=a:1==a.length&&(e.Placemark=a[0]);var f=Ep[c.namespaceURI],
	e=xl(e,f);zl(d,Hp,wl,e,[b],f,this);return c};(function(){var a={},b={ma:a};(function(c){if("object"===typeof a&&"undefined"!==typeof b)b.ma=c();else{var d;"undefined"!==typeof window?d=window:"undefined"!==typeof global?d=global:"undefined"!==typeof self?d=self:d=this;d.aq=c()}})(function(){return function d(a,b,g){function e(h,l){if(!b[h]){if(!a[h]){var m="function"==typeof require&&require;if(!l&&m)return require(h,!0);if(f)return f(h,!0);m=Error("Cannot find module '"+h+"'");throw m.code="MODULE_NOT_FOUND",m;}m=b[h]={ma:{}};a[h][0].call(m.ma,function(b){var d=
	a[h][1][b];return e(d?d:b)},m,m.ma,d,a,b,g)}return b[h].ma}for(var f="function"==typeof require&&require,m=0;m<g.length;m++)e(g[m]);return e}({1:[function(a,b,f){f.read=function(a,b,d,e,f){var g;g=8*f-e-1;var h=(1<<g)-1,l=h>>1,m=-7;f=d?f-1:0;var p=d?-1:1,y=a[b+f];f+=p;d=y&(1<<-m)-1;y>>=-m;for(m+=g;0<m;d=256*d+a[b+f],f+=p,m-=8);g=d&(1<<-m)-1;d>>=-m;for(m+=e;0<m;g=256*g+a[b+f],f+=p,m-=8);if(0===d)d=1-l;else{if(d===h)return g?NaN:Infinity*(y?-1:1);g+=Math.pow(2,e);d-=l}return(y?-1:1)*g*Math.pow(2,d-
	e)};f.write=function(a,b,d,e,f,n){var g,h=8*n-f-1,l=(1<<h)-1,m=l>>1,p=23===f?Math.pow(2,-24)-Math.pow(2,-77):0;n=e?0:n-1;var z=e?1:-1,A=0>b||0===b&&0>1/b?1:0;b=Math.abs(b);isNaN(b)||Infinity===b?(b=isNaN(b)?1:0,e=l):(e=Math.floor(Math.log(b)/Math.LN2),1>b*(g=Math.pow(2,-e))&&(e--,g*=2),b=1<=e+m?b+p/g:b+p*Math.pow(2,1-m),2<=b*g&&(e++,g/=2),e+m>=l?(b=0,e=l):1<=e+m?(b=(b*g-1)*Math.pow(2,f),e+=m):(b=b*Math.pow(2,m-1)*Math.pow(2,f),e=0));for(;8<=f;a[d+n]=b&255,n+=z,b/=256,f-=8);e=e<<f|b;for(h+=f;0<h;a[d+
	n]=e&255,n+=z,e/=256,h-=8);a[d+n-z]|=128*A}},{}],2:[function(a,b){function d(a){this.lc=ArrayBuffer.isView&&ArrayBuffer.isView(a)?a:new Uint8Array(a||0);this.type=this.ga=0;this.length=this.lc.length}function e(a,b,d){var e=d.lc,f,g;g=e[d.ga++];f=(g&112)>>4;if(128>g)return h(a,f,b);g=e[d.ga++];f|=(g&127)<<3;if(128>g)return h(a,f,b);g=e[d.ga++];f|=(g&127)<<10;if(128>g)return h(a,f,b);g=e[d.ga++];f|=(g&127)<<17;if(128>g)return h(a,f,b);g=e[d.ga++];f|=(g&127)<<24;if(128>g)return h(a,f,b);g=e[d.ga++];
	if(128>g)return h(a,f|(g&1)<<31,b);throw Error("Expected varint not more than 10 bytes");}function h(a,b,d){return d?4294967296*b+(a>>>0):4294967296*(b>>>0)+(a>>>0)}b.ma=d;var l=a("ieee754");d.c=0;d.f=1;d.b=2;d.a=5;d.prototype={mg:function(a,b,d){for(d=d||this.length;this.ga<d;){var e=this.Ma(),f=e>>3,g=this.ga;this.type=e&7;a(f,b,this);this.ga===g&&this.zp(e)}return b},No:function(){var a=l.read(this.lc,this.ga,!0,23,4);this.ga+=4;return a},Jo:function(){var a=l.read(this.lc,this.ga,!0,52,8);this.ga+=
	8;return a},Ma:function(a){var b=this.lc,d,f;f=b[this.ga++];d=f&127;if(128>f)return d;f=b[this.ga++];d|=(f&127)<<7;if(128>f)return d;f=b[this.ga++];d|=(f&127)<<14;if(128>f)return d;f=b[this.ga++];d|=(f&127)<<21;if(128>f)return d;f=b[this.ga];return e(d|(f&15)<<28,a,this)},Zo:function(){return this.Ma(!0)},Yd:function(){var a=this.Ma();return 1===a%2?(a+1)/-2:a/2},Ho:function(){return!!this.Ma()},sg:function(){for(var a=this.Ma()+this.ga,b=this.lc,d="",e=this.ga;e<a;){var f=b[e],g=null,h=239<f?4:223<
	f?3:191<f?2:1;if(e+h>a)break;var l,z,A;if(1===h)128>f&&(g=f);else if(2===h)l=b[e+1],128===(l&192)&&(g=(f&31)<<6|l&63,127>=g&&(g=null));else if(3===h){if(l=b[e+1],z=b[e+2],128===(l&192)&&128===(z&192)&&(g=(f&15)<<12|(l&63)<<6|z&63,2047>=g||55296<=g&&57343>=g))g=null}else 4===h&&(l=b[e+1],z=b[e+2],A=b[e+3],128===(l&192)&&128===(z&192)&&128===(A&192)&&(g=(f&15)<<18|(l&63)<<12|(z&63)<<6|A&63,65535>=g||1114112<=g))&&(g=null);null===g?(g=65533,h=1):65535<g&&(g-=65536,d+=String.fromCharCode(g>>>10&1023|
	55296),g=56320|g&1023);d+=String.fromCharCode(g);e+=h}this.ga=a;return d},zp:function(a){a&=7;if(a===d.c)for(;127<this.lc[this.ga++];);else if(a===d.b)this.ga=this.Ma()+this.ga;else if(a===d.a)this.ga+=4;else if(a===d.f)this.ga+=8;else throw Error("Unimplemented type: "+a);}}},{ieee754:1}]},{},[2])(2)});Bj=b.ma})();(function(){var a={},b={ma:a};(function(c){if("object"===typeof a&&"undefined"!==typeof b)b.ma=c();else{var d;"undefined"!==typeof window?d=window:"undefined"!==typeof global?d=global:"undefined"!==typeof self?d=self:d=this;d.eq=c()}})(function(){return function d(a,b,g){function e(h,l){if(!b[h]){if(!a[h]){var m="function"==typeof require&&require;if(!l&&m)return require(h,!0);if(f)return f(h,!0);m=Error("Cannot find module '"+h+"'");throw m.code="MODULE_NOT_FOUND",m;}m=b[h]={ma:{}};a[h][0].call(m.ma,function(b){var d=
	a[h][1][b];return e(d?d:b)},m,m.ma,d,a,b,g)}return b[h].ma}for(var f="function"==typeof require&&require,m=0;m<g.length;m++)e(g[m]);return e}({1:[function(a,b){function d(a,b){this.x=a;this.y=b}b.ma=d;d.prototype={clone:function(){return new d(this.x,this.y)},add:function(a){return this.clone().Ej(a)},rotate:function(a){return this.clone().Oj(a)},round:function(){return this.clone().Pj()},angle:function(){return Math.atan2(this.y,this.x)},Ej:function(a){this.x+=a.x;this.y+=a.y;return this},Oj:function(a){var b=
	Math.cos(a);a=Math.sin(a);var d=a*this.x+b*this.y;this.x=b*this.x-a*this.y;this.y=d;return this},Pj:function(){this.x=Math.round(this.x);this.y=Math.round(this.y);return this}};d.b=function(a){return a instanceof d?a:Array.isArray(a)?new d(a[0],a[1]):a}},{}],2:[function(a,b){b.ma.Dj=a("./lib/vectortile.js");b.ma.Yp=a("./lib/vectortilefeature.js");b.ma.Zp=a("./lib/vectortilelayer.js")},{"./lib/vectortile.js":3,"./lib/vectortilefeature.js":4,"./lib/vectortilelayer.js":5}],3:[function(a,b){function d(a,
	b,d){3===a&&(a=new e(d,d.Ma()+d.ga),a.length&&(b[a.name]=a))}var e=a("./vectortilelayer");b.ma=function(a,b){this.layers=a.mg(d,{},b)}},{"./vectortilelayer":5}],4:[function(a,b){function d(a,b,d,f,g){this.properties={};this.extent=d;this.type=0;this.Cc=a;this.tf=-1;this.ie=f;this.ke=g;a.mg(e,this,b)}function e(a,b,d){if(1==a)b.id=d.Ma();else if(2==a)for(a=d.Ma()+d.ga;d.ga<a;){var e=b.ie[d.Ma()],f=b.ke[d.Ma()];b.properties[e]=f}else 3==a?b.type=d.Ma():4==a&&(b.tf=d.ga)}var h=a("point-geometry");b.ma=
	d;d.b=["Unknown","Point","LineString","Polygon"];d.prototype.Ah=function(){var a=this.Cc;a.ga=this.tf;for(var b=a.Ma()+a.ga,d=1,e=0,f=0,g=0,v=[],x;a.ga<b;)if(e||(e=a.Ma(),d=e&7,e>>=3),e--,1===d||2===d)f+=a.Yd(),g+=a.Yd(),1===d&&(x&&v.push(x),x=[]),x.push(new h(f,g));else if(7===d)x&&x.push(x[0].clone());else throw Error("unknown command "+d);x&&v.push(x);return v};d.prototype.bbox=function(){var a=this.Cc;a.ga=this.tf;for(var b=a.Ma()+a.ga,d=1,e=0,f=0,g=0,h=Infinity,x=-Infinity,y=Infinity,z=-Infinity;a.ga<
	b;)if(e||(e=a.Ma(),d=e&7,e>>=3),e--,1===d||2===d)f+=a.Yd(),g+=a.Yd(),f<h&&(h=f),f>x&&(x=f),g<y&&(y=g),g>z&&(z=g);else if(7!==d)throw Error("unknown command "+d);return[h,y,x,z]}},{"point-geometry":1}],5:[function(a,b){function d(a,b){this.version=1;this.name=null;this.extent=4096;this.length=0;this.Cc=a;this.ie=[];this.ke=[];this.he=[];a.mg(e,this,b);this.length=this.he.length}function e(a,b,d){15===a?b.version=d.Ma():1===a?b.name=d.sg():5===a?b.extent=d.Ma():2===a?b.he.push(d.ga):3===a?b.ie.push(d.sg()):
	4===a&&b.ke.push(h(d))}function h(a){for(var b=null,d=a.Ma()+a.ga;a.ga<d;)b=a.Ma()>>3,b=1===b?a.sg():2===b?a.No():3===b?a.Jo():4===b?a.Zo():5===b?a.Ma():6===b?a.Yd():7===b?a.Ho():null;return b}var l=a("./vectortilefeature.js");b.ma=d;d.prototype.feature=function(a){if(0>a||a>=this.he.length)throw Error("feature index out of bounds");this.Cc.ga=this.he[a];a=this.Cc.Ma()+this.Cc.ga;return new l(this.Cc,a,this.extent,this.ie,this.ke)}},{"./vectortilefeature.js":4}]},{},[2])(2)});Cj=b.ma})();function Yp(a,b,c,d){this.f=a;this.b=b;this.i=c;this.c=d}k=Yp.prototype;k.get=function(a){return this.c[a]};k.Rb=function(){return this.i};k.D=function(){this.a||(this.a="Point"===this.f?Wa(this.b):Xa(this.b,0,this.b.length,2));return this.a};k.fc=function(){return this.b};k.ha=Yp.prototype.fc;k.U=function(){return this};k.mn=function(){return this.c};k.Qd=Yp.prototype.U;k.sa=function(){return 2};k.Nc=na;k.T=function(){return this.f};function Zp(a){Cl.call(this);a=a?a:{};this.defaultDataProjection=new yb({code:"",units:"tile-pixels"});this.b=a.featureClass?a.featureClass:Yp;this.f=a.geometryName;this.a=a.layerName?a.layerName:"layer";this.c=a.layers?a.layers:null}u(Zp,Cl);k=Zp.prototype;k.T=function(){return"arraybuffer"};
	k.Qa=function(a,b){var c=this.c,d=new Bj(a),d=new Cj.Dj(d),e=[],f=this.b,g,h,l;for(l in d.layers)if(!c||-1!=c.indexOf(l)){g=d.layers[l];for(var m=0,p=g.length;m<p;++m){if(f===Yp){h=void 0;var n=g.feature(m),q=l,r=n.Ah(),v=[],x=[];$p(r,x,v);var y=n.type;1===y?h=1===r.length?"Point":"MultiPoint":2===y?h=1===r.length?"LineString":"MultiLineString":3===y&&(h="Polygon");n=n.properties;n[this.a]=q;h=new this.b(h,x,v,n)}else{y=g.feature(m);n=l;x=b;h=new this.b;q=y.id;v=y.properties;v[this.a]=n;this.f&&h.Vc(this.f);
	n=void 0;r=y.type;if(0===r)n=null;else{var y=y.Ah(),z=[],A=[];$p(y,A,z);1===r?n=1===y.length?new E(null):new O(null):2===r?1===y.length?n=new M(null):n=new N(null):3===r&&(n=new F(null));n.ca("XY",A,z)}x=Fl(n,!1,El(this,x));h.Sa(x);h.kc(q);h.H(v)}e.push(h)}}return e};k.kb=function(){return this.defaultDataProjection};k.Hm=function(a){this.c=a};function $p(a,b,c){for(var d=0,e=0,f=a.length;e<f;++e){var g=a[e],h,l;h=0;for(l=g.length;h<l;++h){var m=g[h];b.push(m.x,m.y)}d+=2*h;c.push(d)}}k.Ub=function(){};
	k.Tc=function(){};k.yd=function(){};k.bd=function(){};k.Xb=function(){};function aq(){zm.call(this);this.defaultDataProjection=Gb("EPSG:4326")}u(aq,zm);function bq(a,b){b[b.length-1].ae[a.getAttribute("k")]=a.getAttribute("v")}
	var cq=[null],dq=K(cq,{nd:function(a,b){b[b.length-1].md.push(a.getAttribute("ref"))},tag:bq}),fq=K(cq,{node:function(a,b){var c=b[0],d=b[b.length-1],e=a.getAttribute("id"),f=[parseFloat(a.getAttribute("lon")),parseFloat(a.getAttribute("lat"))];d.Eh[e]=f;var g=L({ae:{}},eq,a,b);sb(g.ae)||(f=new E(f),Fl(f,!1,c),c=new H(f),c.kc(e),c.H(g.ae),d.features.push(c))},way:function(a,b){for(var c=b[0],d=a.getAttribute("id"),e=L({md:[],ae:{}},dq,a,b),f=b[b.length-1],g=[],h=0,l=e.md.length;h<l;h++)ga(g,f.Eh[e.md[h]]);
	e.md[0]==e.md[e.md.length-1]?(h=new F(null),h.ca("XY",g,[g.length])):(h=new M(null),h.ca("XY",g));Fl(h,!1,c);c=new H(h);c.kc(d);c.H(e.ae);f.features.push(c)}}),eq=K(cq,{tag:bq});aq.prototype.yc=function(a,b){var c=Dl(this,a,b);return"osm"==a.localName&&(c=L({Eh:{},features:[]},fq,a,[c]),c.features)?c.features:[]};aq.prototype.Fg=function(){};aq.prototype.Yb=function(){};aq.prototype.de=function(){};function gq(a){return a.getAttributeNS("http://www.w3.org/1999/xlink","href")};function hq(){}hq.prototype.read=function(a){return ll(a)?this.a(a):ml(a)?this.b(a):"string"===typeof a?(a=nl(a),this.a(a)):null};function iq(){}u(iq,hq);iq.prototype.a=function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType==Node.ELEMENT_NODE)return this.b(a);return null};iq.prototype.b=function(a){return(a=L({},jq,a,[]))?a:null};
	var kq=[null,"http://www.opengis.net/ows/1.1"],jq=K(kq,{ServiceIdentification:I(function(a,b){return L({},mq,a,b)}),ServiceProvider:I(function(a,b){return L({},nq,a,b)}),OperationsMetadata:I(function(a,b){return L({},oq,a,b)})}),pq=K(kq,{DeliveryPoint:I(Q),City:I(Q),AdministrativeArea:I(Q),PostalCode:I(Q),Country:I(Q),ElectronicMailAddress:I(Q)}),qq=K(kq,{Value:sl(function(a){return Q(a)})}),rq=K(kq,{AllowedValues:I(function(a,b){return L({},qq,a,b)})}),tq=K(kq,{Phone:I(function(a,b){return L({},
	sq,a,b)}),Address:I(function(a,b){return L({},pq,a,b)})}),vq=K(kq,{HTTP:I(function(a,b){return L({},uq,a,b)})}),uq=K(kq,{Get:sl(function(a,b){var c=gq(a);if(c)return L({href:c},wq,a,b)}),Post:void 0}),xq=K(kq,{DCP:I(function(a,b){return L({},vq,a,b)})}),oq=K(kq,{Operation:function(a,b){var c=a.getAttribute("name"),d=L({},xq,a,b);d&&(b[b.length-1][c]=d)}}),sq=K(kq,{Voice:I(Q),Facsimile:I(Q)}),wq=K(kq,{Constraint:sl(function(a,b){var c=a.getAttribute("name");if(c)return L({name:c},rq,a,b)})}),yq=K(kq,
	{IndividualName:I(Q),PositionName:I(Q),ContactInfo:I(function(a,b){return L({},tq,a,b)})}),mq=K(kq,{Title:I(Q),ServiceTypeVersion:I(Q),ServiceType:I(Q)}),nq=K(kq,{ProviderName:I(Q),ProviderSite:I(gq),ServiceContact:I(function(a,b){return L({},yq,a,b)})});function zq(a,b,c,d){var e;void 0!==d?e=d:e=[];for(var f=d=0;f<b;){var g=a[f++];e[d++]=a[f++];e[d++]=g;for(g=2;g<c;++g)e[d++]=a[f++]}e.length=d};function Aq(a){a=a?a:{};Cl.call(this);this.defaultDataProjection=Gb("EPSG:4326");this.b=a.factor?a.factor:1E5;this.a=a.geometryLayout?a.geometryLayout:"XY"}u(Aq,In);function Bq(a,b,c){var d,e=Array(b);for(d=0;d<b;++d)e[d]=0;var f,g;f=0;for(g=a.length;f<g;)for(d=0;d<b;++d,++f){var h=a[f],l=h-e[d];e[d]=h;a[f]=l}return Cq(a,c?c:1E5)}function Dq(a,b,c){var d,e=Array(b);for(d=0;d<b;++d)e[d]=0;a=Eq(a,c?c:1E5);var f;c=0;for(f=a.length;c<f;)for(d=0;d<b;++d,++c)e[d]+=a[c],a[c]=e[d];return a}
	function Cq(a,b){var c=b?b:1E5,d,e;d=0;for(e=a.length;d<e;++d)a[d]=Math.round(a[d]*c);c=0;for(d=a.length;c<d;++c)e=a[c],a[c]=0>e?~(e<<1):e<<1;c="";d=0;for(e=a.length;d<e;++d){for(var f,g=a[d],h="";32<=g;)f=(32|g&31)+63,h+=String.fromCharCode(f),g>>=5;h+=String.fromCharCode(g+63);c+=h}return c}
	function Eq(a,b){var c=b?b:1E5,d=[],e=0,f=0,g,h;g=0;for(h=a.length;g<h;++g){var l=a.charCodeAt(g)-63,e=e|(l&31)<<f;32>l?(d.push(e),f=e=0):f+=5}e=0;for(f=d.length;e<f;++e)g=d[e],d[e]=g&1?~(g>>1):g>>1;e=0;for(f=d.length;e<f;++e)d[e]/=c;return d}k=Aq.prototype;k.Wd=function(a,b){var c=this.ud(a,b);return new H(c)};k.lg=function(a,b){return[this.Wd(a,b)]};k.ud=function(a,b){var c=gf(this.a),d=Dq(a,c,this.b);zq(d,d.length,c,d);c=uf(d,0,d.length,c);return Fl(new M(c,this.a),!1,El(this,b))};
	k.be=function(a,b){var c=a.U();if(c)return this.Ad(c,b);qa(!1,40);return""};k.Gg=function(a,b){return this.be(a[0],b)};k.Ad=function(a,b){a=Fl(a,!0,El(this,b));var c=a.ha(),d=a.sa();zq(c,c.length,d,c);return Bq(c,d,this.b)};function Fq(a){a=a?a:{};Cl.call(this);this.defaultDataProjection=Gb(a.defaultDataProjection?a.defaultDataProjection:"EPSG:4326")}u(Fq,Gl);function Gq(a,b){var c=[],d,e,f,g;f=0;for(g=a.length;f<g;++f)d=a[f],0<f&&c.pop(),0<=d?e=b[d]:e=b[~d].slice().reverse(),c.push.apply(c,e);d=0;for(e=c.length;d<e;++d)c[d]=c[d].slice();return c}function Hq(a,b,c,d,e){a=a.geometries;var f=[],g,h;g=0;for(h=a.length;g<h;++g)f[g]=Iq(a[g],b,c,d,e);return f}
	function Iq(a,b,c,d,e){var f=a.type,g=Jq[f];b="Point"===f||"MultiPoint"===f?g(a,c,d):g(a,b);c=new H;c.Sa(Fl(b,!1,e));void 0!==a.id&&c.kc(a.id);a.properties&&c.H(a.properties);return c}
	Fq.prototype.kg=function(a,b){if("Topology"==a.type){var c,d=null,e=null;a.transform&&(c=a.transform,d=c.scale,e=c.translate);var f=a.arcs;if(c){c=d;var g=e,h,l;h=0;for(l=f.length;h<l;++h){var m,p,n,q=f[h],r=c,v=g,x=0,y=0;p=0;for(m=q.length;p<m;++p)n=q[p],x+=n[0],y+=n[1],n[0]=x,n[1]=y,Kq(n,r,v)}}c=[];g=rb(a.objects);h=0;for(l=g.length;h<l;++h)"GeometryCollection"===g[h].type?(m=g[h],c.push.apply(c,Hq(m,f,d,e,b))):(m=g[h],c.push(Iq(m,f,d,e,b)));return c}return[]};
	function Kq(a,b,c){a[0]=a[0]*b[0]+c[0];a[1]=a[1]*b[1]+c[1]}Fq.prototype.rg=function(){return this.defaultDataProjection};
	var Jq={Point:function(a,b,c){a=a.coordinates;b&&c&&Kq(a,b,c);return new E(a)},LineString:function(a,b){var c=Gq(a.arcs,b);return new M(c)},Polygon:function(a,b){var c=[],d,e;d=0;for(e=a.arcs.length;d<e;++d)c[d]=Gq(a.arcs[d],b);return new F(c)},MultiPoint:function(a,b,c){a=a.coordinates;var d,e;if(b&&c)for(d=0,e=a.length;d<e;++d)Kq(a[d],b,c);return new O(a)},MultiLineString:function(a,b){var c=[],d,e;d=0;for(e=a.arcs.length;d<e;++d)c[d]=Gq(a.arcs[d],b);return new N(c)},MultiPolygon:function(a,b){var c=
	[],d,e,f,g,h,l;h=0;for(l=a.arcs.length;h<l;++h){d=a.arcs[h];e=[];f=0;for(g=d.length;f<g;++f)e[f]=Gq(d[f],b);c[h]=e}return new P(c)}};k=Fq.prototype;k.ad=function(){};k.ce=function(){};k.ee=function(){};k.og=function(){};k.Sc=function(){};function Lq(a){a=a?a:{};this.i=a.featureType;this.a=a.featureNS;this.b=a.gmlFormat?a.gmlFormat:new Pm;this.c=a.schemaLocation?a.schemaLocation:"http://www.opengis.net/wfs http://schemas.opengis.net/wfs/1.1.0/wfs.xsd";zm.call(this)}u(Lq,zm);Lq.prototype.yc=function(a,b){var c={featureType:this.i,featureNS:this.a};pb(c,Dl(this,a,b?b:{}));c=[c];this.b.b["http://www.opengis.net/gml"].featureMember=ql(Cm.prototype.Xd);(c=L([],this.b.b,a,c,this.b))||(c=[]);return c};
	Lq.prototype.j=function(a){if(ll(a))return Mq(a);if(ml(a))return L({},Nq,a,[]);if("string"===typeof a)return a=nl(a),Mq(a)};Lq.prototype.l=function(a){if(ll(a))return Oq(this,a);if(ml(a))return Pq(this,a);if("string"===typeof a)return a=nl(a),Oq(this,a)};function Oq(a,b){for(var c=b.firstChild;c;c=c.nextSibling)if(c.nodeType==Node.ELEMENT_NODE)return Pq(a,c)}var Qq={"http://www.opengis.net/gml":{boundedBy:I(Cm.prototype.We,"bounds")}};
	function Pq(a,b){var c={},d=Km(b.getAttribute("numberOfFeatures"));c.numberOfFeatures=d;return L(c,Qq,b,[],a.b)}
	var Rq={"http://www.opengis.net/wfs":{totalInserted:I(Jm),totalUpdated:I(Jm),totalDeleted:I(Jm)}},Sq={"http://www.opengis.net/ogc":{FeatureId:ql(function(a){return a.getAttribute("fid")})}},Tq={"http://www.opengis.net/wfs":{Feature:function(a,b){yl(Sq,a,b)}}},Nq={"http://www.opengis.net/wfs":{TransactionSummary:I(function(a,b){return L({},Rq,a,b)},"transactionSummary"),InsertResults:I(function(a,b){return L([],Tq,a,b)},"insertIds")}};
	function Mq(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType==Node.ELEMENT_NODE)return L({},Nq,a,[])}var Uq={"http://www.opengis.net/wfs":{PropertyName:J(Mm)}};function Vq(a,b){var c=il("http://www.opengis.net/ogc","Filter"),d=il("http://www.opengis.net/ogc","FeatureId");c.appendChild(d);d.setAttribute("fid",b);a.appendChild(c)}
	var Wq={"http://www.opengis.net/wfs":{Insert:J(function(a,b,c){var d=c[c.length-1],d=il(d.featureNS,d.featureType);a.appendChild(d);Pm.prototype.cj(d,b,c)}),Update:J(function(a,b,c){var d=c[c.length-1];qa(void 0!==b.a,27);var e=d.featureType,f=d.featurePrefix,f=f?f:"feature",g=d.featureNS;a.setAttribute("typeName",f+":"+e);a.setAttributeNS("http://www.w3.org/2000/xmlns/","xmlns:"+f,g);e=b.a;if(void 0!==e){for(var f=b.O(),g=[],h=0,l=f.length;h<l;h++){var m=b.get(f[h]);void 0!==m&&g.push({name:f[h],
	value:m})}zl({node:a,srsName:d.srsName},Wq,ul("Property"),g,c);Vq(a,e)}}),Delete:J(function(a,b,c){var d=c[c.length-1];qa(void 0!==b.a,26);c=d.featureType;var e=d.featurePrefix,e=e?e:"feature",d=d.featureNS;a.setAttribute("typeName",e+":"+c);a.setAttributeNS("http://www.w3.org/2000/xmlns/","xmlns:"+e,d);b=b.a;void 0!==b&&Vq(a,b)}),Property:J(function(a,b,c){var d=il("http://www.opengis.net/wfs","Name");a.appendChild(d);Mm(d,b.name);void 0!==b.value&&null!==b.value&&(d=il("http://www.opengis.net/wfs",
	"Value"),a.appendChild(d),b.value instanceof cf?Pm.prototype.zd(d,b.value,c):Mm(d,b.value))}),Native:J(function(a,b){b.Hp&&a.setAttribute("vendorId",b.Hp);void 0!==b.lp&&a.setAttribute("safeToIgnore",b.lp);void 0!==b.value&&Mm(a,b.value)})}};function Xq(a,b,c){var d={node:a};b.b.forEach(function(a){zl(d,Yq,ul(a.Bc),[a],c)})}function Zq(a,b){void 0!==b.a&&a.setAttribute("matchCase",b.a.toString());$q(a,b.b);ar(a,""+b.f)}
	function br(a,b,c){a=il("http://www.opengis.net/ogc",a);Mm(a,c);b.appendChild(a)}function $q(a,b){br("PropertyName",a,b)}function ar(a,b){br("Literal",a,b)}
	var Yq={"http://www.opengis.net/wfs":{Query:J(function(a,b,c){var d=c[c.length-1],e=d.featurePrefix,f=d.featureNS,g=d.propertyNames,h=d.srsName;a.setAttribute("typeName",(e?e+":":"")+b);h&&a.setAttribute("srsName",h);f&&a.setAttributeNS("http://www.w3.org/2000/xmlns/","xmlns:"+e,f);b=pb({},d);b.node=a;zl(b,Uq,ul("PropertyName"),g,c);if(d=d.filter)g=il("http://www.opengis.net/ogc","Filter"),a.appendChild(g),zl({node:g},Yq,ul(d.Bc),[d],c)})},"http://www.opengis.net/ogc":{And:J(Xq),Or:J(Xq),Not:J(function(a,
	b,c){b=b.condition;zl({node:a},Yq,ul(b.Bc),[b],c)}),BBOX:J(function(a,b,c){c[c.length-1].srsName=b.srsName;$q(a,b.geometryName);Pm.prototype.zd(a,b.extent,c)}),Intersects:J(function(a,b,c){c[c.length-1].srsName=b.srsName;$q(a,b.geometryName);Pm.prototype.zd(a,b.geometry,c)}),Within:J(function(a,b,c){c[c.length-1].srsName=b.srsName;$q(a,b.geometryName);Pm.prototype.zd(a,b.geometry,c)}),PropertyIsEqualTo:J(Zq),PropertyIsNotEqualTo:J(Zq),PropertyIsLessThan:J(Zq),PropertyIsLessThanOrEqualTo:J(Zq),PropertyIsGreaterThan:J(Zq),
	PropertyIsGreaterThanOrEqualTo:J(Zq),PropertyIsNull:J(function(a,b){$q(a,b.b)}),PropertyIsBetween:J(function(a,b){$q(a,b.b);var c=il("http://www.opengis.net/ogc","LowerBoundary");a.appendChild(c);ar(c,""+b.a);c=il("http://www.opengis.net/ogc","UpperBoundary");a.appendChild(c);ar(c,""+b.f)}),PropertyIsLike:J(function(a,b){a.setAttribute("wildCard",b.g);a.setAttribute("singleChar",b.i);a.setAttribute("escapeChar",b.f);void 0!==b.a&&a.setAttribute("matchCase",b.a.toString());$q(a,b.b);ar(a,""+b.c)})}};
	Lq.prototype.o=function(a){var b=il("http://www.opengis.net/wfs","GetFeature");b.setAttribute("service","WFS");b.setAttribute("version","1.1.0");var c;if(a&&(a.handle&&b.setAttribute("handle",a.handle),a.outputFormat&&b.setAttribute("outputFormat",a.outputFormat),void 0!==a.maxFeatures&&b.setAttribute("maxFeatures",a.maxFeatures),a.resultType&&b.setAttribute("resultType",a.resultType),void 0!==a.startIndex&&b.setAttribute("startIndex",a.startIndex),void 0!==a.count&&b.setAttribute("count",a.count),
	c=a.filter,a.bbox)){qa(a.geometryName,12);var d=pm(a.geometryName,a.bbox,a.srsName);c?c=om(c,d):c=d}b.setAttributeNS("http://www.w3.org/2001/XMLSchema-instance","xsi:schemaLocation",this.c);c={node:b,srsName:a.srsName,featureNS:a.featureNS?a.featureNS:this.a,featurePrefix:a.featurePrefix,geometryName:a.geometryName,filter:c,propertyNames:a.propertyNames?a.propertyNames:[]};qa(Array.isArray(a.featureTypes),11);a=a.featureTypes;c=[c];d=pb({},c[c.length-1]);d.node=b;zl(d,Yq,ul("Query"),a,c);return b};
	Lq.prototype.v=function(a,b,c,d){var e=[],f=il("http://www.opengis.net/wfs","Transaction");f.setAttribute("service","WFS");f.setAttribute("version","1.1.0");var g,h;d&&(g=d.gmlOptions?d.gmlOptions:{},d.handle&&f.setAttribute("handle",d.handle));f.setAttributeNS("http://www.w3.org/2001/XMLSchema-instance","xsi:schemaLocation",this.c);a&&(h={node:f,featureNS:d.featureNS,featureType:d.featureType,featurePrefix:d.featurePrefix,srsName:d.srsName},pb(h,g),zl(h,Wq,ul("Insert"),a,e));b&&(h={node:f,featureNS:d.featureNS,
	featureType:d.featureType,featurePrefix:d.featurePrefix,srsName:d.srsName},pb(h,g),zl(h,Wq,ul("Update"),b,e));c&&zl({node:f,featureNS:d.featureNS,featureType:d.featureType,featurePrefix:d.featurePrefix,srsName:d.srsName},Wq,ul("Delete"),c,e);d.nativeElements&&zl({node:f,featureNS:d.featureNS,featureType:d.featureType,featurePrefix:d.featurePrefix,srsName:d.srsName},Wq,ul("Native"),d.nativeElements,e);return f};
	Lq.prototype.qg=function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType==Node.ELEMENT_NODE)return this.Ze(a);return null};Lq.prototype.Ze=function(a){if(a.firstElementChild&&a.firstElementChild.firstElementChild)for(a=a.firstElementChild.firstElementChild,a=a.firstElementChild;a;a=a.nextElementSibling)if(0!==a.childNodes.length&&(1!==a.childNodes.length||3!==a.firstChild.nodeType)){var b=[{}];this.b.We(a,b);return Gb(b.pop().srsName)}return null};function cr(a){a=a?a:{};Cl.call(this);this.b=void 0!==a.splitCollection?a.splitCollection:!1}u(cr,In);function dr(a){a=a.X();return a.length?a.join(" "):""}function er(a){a=a.X();for(var b=[],c=0,d=a.length;c<d;++c)b.push(a[c].join(" "));return b.join(",")}function fr(a){var b=[];a=a.jd();for(var c=0,d=a.length;c<d;++c)b.push("("+er(a[c])+")");return b.join(",")}
	function gr(a){var b=a.T(),c=(0,hr[b])(a),b=b.toUpperCase();if(a instanceof ff){a=a.ka;var d="";if("XYZ"===a||"XYZM"===a)d+="Z";if("XYM"===a||"XYZM"===a)d+="M";a=d;0<a.length&&(b+=" "+a)}return c.length?b+"("+c+")":b+" EMPTY"}
	var hr={Point:dr,LineString:er,Polygon:fr,MultiPoint:function(a){var b=[];a=a.Ie();for(var c=0,d=a.length;c<d;++c)b.push("("+dr(a[c])+")");return b.join(",")},MultiLineString:function(a){var b=[];a=a.hd();for(var c=0,d=a.length;c<d;++c)b.push("("+er(a[c])+")");return b.join(",")},MultiPolygon:function(a){var b=[];a=a.Od();for(var c=0,d=a.length;c<d;++c)b.push("("+fr(a[c])+")");return b.join(",")},GeometryCollection:function(a){var b=[];a=a.If();for(var c=0,d=a.length;c<d;++c)b.push(gr(a[c]));return b.join(",")}};
	k=cr.prototype;k.Wd=function(a,b){var c=this.ud(a,b);if(c){var d=new H;d.Sa(c);return d}return null};k.lg=function(a,b){var c=[],d=this.ud(a,b);this.b&&"GeometryCollection"==d.T()?c=d.a:c=[d];for(var e=[],f=0,g=c.length;f<g;++f)d=new H,d.Sa(c[f]),e.push(d);return e};k.ud=function(a,b){var c;c=new ir(new jr(a));kr(c);return(c=lr(c))?Fl(c,!1,b):null};k.be=function(a,b){var c=a.U();return c?this.Ad(c,b):""};
	k.Gg=function(a,b){if(1==a.length)return this.be(a[0],b);for(var c=[],d=0,e=a.length;d<e;++d)c.push(a[d].U());c=new qm(c);return this.Ad(c,b)};k.Ad=function(a,b){return gr(Fl(a,!0,b))};function jr(a){this.a=a;this.b=-1}
	function mr(a){var b=a.a.charAt(++a.b),c={position:a.b,value:b};if("("==b)c.type=2;else if(","==b)c.type=5;else if(")"==b)c.type=3;else if("0"<=b&&"9">=b||"."==b||"-"==b){c.type=4;var d,b=a.b,e=!1,f=!1;do{if("."==d)e=!0;else if("e"==d||"E"==d)f=!0;d=a.a.charAt(++a.b)}while("0"<=d&&"9">=d||"."==d&&(void 0===e||!e)||!f&&("e"==d||"E"==d)||f&&("-"==d||"+"==d));a=parseFloat(a.a.substring(b,a.b--));c.value=a}else if("a"<=b&&"z">=b||"A"<=b&&"Z">=b){c.type=1;b=a.b;do d=a.a.charAt(++a.b);while("a"<=d&&"z">=
	d||"A"<=d&&"Z">=d);a=a.a.substring(b,a.b--).toUpperCase();c.value=a}else{if(" "==b||"\t"==b||"\r"==b||"\n"==b)return mr(a);if(""===b)c.type=6;else throw Error("Unexpected character: "+b);}return c}function ir(a){this.f=a;this.a="XY"}function kr(a){a.b=mr(a.f)}function nr(a,b){var c=a.b.type==b;c&&kr(a);return c}
	function lr(a){var b=a.b;if(nr(a,1)){var b=b.value,c="XY",d=a.b;1==a.b.type&&(d=d.value,"Z"===d?c="XYZ":"M"===d?c="XYM":"ZM"===d&&(c="XYZM"),"XY"!==c&&kr(a));a.a=c;if("GEOMETRYCOLLECTION"==b){a:{if(nr(a,2)){b=[];do b.push(lr(a));while(nr(a,5));if(nr(a,3)){a=b;break a}}else if(or(a)){a=[];break a}throw Error(pr(a));}return new qm(a)}d=qr[b];c=rr[b];if(!d||!c)throw Error("Invalid geometry type: "+b);b=d.call(a);return new c(b,a.a)}throw Error(pr(a));}k=ir.prototype;
	k.fg=function(){if(nr(this,2)){var a=sr(this);if(nr(this,3))return a}else if(or(this))return null;throw Error(pr(this));};k.eg=function(){if(nr(this,2)){var a=tr(this);if(nr(this,3))return a}else if(or(this))return[];throw Error(pr(this));};k.gg=function(){if(nr(this,2)){var a=ur(this);if(nr(this,3))return a}else if(or(this))return[];throw Error(pr(this));};
	k.uo=function(){if(nr(this,2)){var a;if(2==this.b.type)for(a=[this.fg()];nr(this,5);)a.push(this.fg());else a=tr(this);if(nr(this,3))return a}else if(or(this))return[];throw Error(pr(this));};k.to=function(){if(nr(this,2)){var a=ur(this);if(nr(this,3))return a}else if(or(this))return[];throw Error(pr(this));};k.vo=function(){if(nr(this,2)){for(var a=[this.gg()];nr(this,5);)a.push(this.gg());if(nr(this,3))return a}else if(or(this))return[];throw Error(pr(this));};
	function sr(a){for(var b=[],c=a.a.length,d=0;d<c;++d){var e=a.b;if(nr(a,4))b.push(e.value);else break}if(b.length==c)return b;throw Error(pr(a));}function tr(a){for(var b=[sr(a)];nr(a,5);)b.push(sr(a));return b}function ur(a){for(var b=[a.eg()];nr(a,5);)b.push(a.eg());return b}function or(a){var b=1==a.b.type&&"EMPTY"==a.b.value;b&&kr(a);return b}function pr(a){return"Unexpected `"+a.b.value+"` at position "+a.b.position+" in `"+a.f.a+"`"}
	var rr={POINT:E,LINESTRING:M,POLYGON:F,MULTIPOINT:O,MULTILINESTRING:N,MULTIPOLYGON:P},qr={POINT:ir.prototype.fg,LINESTRING:ir.prototype.eg,POLYGON:ir.prototype.gg,MULTIPOINT:ir.prototype.uo,MULTILINESTRING:ir.prototype.to,MULTIPOLYGON:ir.prototype.vo};function vr(){this.version=void 0}u(vr,hq);vr.prototype.a=function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType==Node.ELEMENT_NODE)return this.b(a);return null};vr.prototype.b=function(a){this.version=a.getAttribute("version").trim();return(a=L({version:this.version},wr,a,[]))?a:null};function xr(a,b){return L({},yr,a,b)}function zr(a,b){return L({},Ar,a,b)}function Br(a,b){var c=xr(a,b);if(c){var d=[Km(a.getAttribute("width")),Km(a.getAttribute("height"))];c.size=d;return c}}
	function Cr(a,b){return L([],Dr,a,b)}
	var Er=[null,"http://www.opengis.net/wms"],wr=K(Er,{Service:I(function(a,b){return L({},Fr,a,b)}),Capability:I(function(a,b){return L({},Gr,a,b)})}),Gr=K(Er,{Request:I(function(a,b){return L({},Hr,a,b)}),Exception:I(function(a,b){return L([],Ir,a,b)}),Layer:I(function(a,b){return L({},Jr,a,b)})}),Fr=K(Er,{Name:I(Q),Title:I(Q),Abstract:I(Q),KeywordList:I(Cr),OnlineResource:I(gq),ContactInformation:I(function(a,b){return L({},Kr,a,b)}),Fees:I(Q),AccessConstraints:I(Q),LayerLimit:I(Jm),MaxWidth:I(Jm),
	MaxHeight:I(Jm)}),Kr=K(Er,{ContactPersonPrimary:I(function(a,b){return L({},Lr,a,b)}),ContactPosition:I(Q),ContactAddress:I(function(a,b){return L({},Mr,a,b)}),ContactVoiceTelephone:I(Q),ContactFacsimileTelephone:I(Q),ContactElectronicMailAddress:I(Q)}),Lr=K(Er,{ContactPerson:I(Q),ContactOrganization:I(Q)}),Mr=K(Er,{AddressType:I(Q),Address:I(Q),City:I(Q),StateOrProvince:I(Q),PostCode:I(Q),Country:I(Q)}),Ir=K(Er,{Format:ql(Q)}),Jr=K(Er,{Name:I(Q),Title:I(Q),Abstract:I(Q),KeywordList:I(Cr),CRS:sl(Q),
	EX_GeographicBoundingBox:I(function(a,b){var c=L({},Nr,a,b);if(c){var d=c.westBoundLongitude,e=c.southBoundLatitude,f=c.eastBoundLongitude,c=c.northBoundLatitude;if(void 0!==d&&void 0!==e&&void 0!==f&&void 0!==c)return[d,e,f,c]}}),BoundingBox:sl(function(a){var b=[Im(a.getAttribute("minx")),Im(a.getAttribute("miny")),Im(a.getAttribute("maxx")),Im(a.getAttribute("maxy"))],c=[Im(a.getAttribute("resx")),Im(a.getAttribute("resy"))];return{crs:a.getAttribute("CRS"),extent:b,res:c}}),Dimension:sl(function(a){return{name:a.getAttribute("name"),
	units:a.getAttribute("units"),unitSymbol:a.getAttribute("unitSymbol"),"default":a.getAttribute("default"),multipleValues:Fm(a.getAttribute("multipleValues")),nearestValue:Fm(a.getAttribute("nearestValue")),current:Fm(a.getAttribute("current")),values:Q(a)}}),Attribution:I(function(a,b){return L({},Or,a,b)}),AuthorityURL:sl(function(a,b){var c=xr(a,b);if(c)return c.name=a.getAttribute("name"),c}),Identifier:sl(Q),MetadataURL:sl(function(a,b){var c=xr(a,b);if(c)return c.type=a.getAttribute("type"),
	c}),DataURL:sl(xr),FeatureListURL:sl(xr),Style:sl(function(a,b){return L({},Pr,a,b)}),MinScaleDenominator:I(Hm),MaxScaleDenominator:I(Hm),Layer:sl(function(a,b){var c=b[b.length-1],d=L({},Jr,a,b);if(d){var e=Fm(a.getAttribute("queryable"));void 0===e&&(e=c.queryable);d.queryable=void 0!==e?e:!1;e=Km(a.getAttribute("cascaded"));void 0===e&&(e=c.cascaded);d.cascaded=e;e=Fm(a.getAttribute("opaque"));void 0===e&&(e=c.opaque);d.opaque=void 0!==e?e:!1;e=Fm(a.getAttribute("noSubsets"));void 0===e&&(e=c.noSubsets);
	d.noSubsets=void 0!==e?e:!1;(e=Im(a.getAttribute("fixedWidth")))||(e=c.fixedWidth);d.fixedWidth=e;(e=Im(a.getAttribute("fixedHeight")))||(e=c.fixedHeight);d.fixedHeight=e;["Style","CRS","AuthorityURL"].forEach(function(a){a in c&&(d[a]=(d[a]||[]).concat(c[a]))});"EX_GeographicBoundingBox BoundingBox Dimension Attribution MinScaleDenominator MaxScaleDenominator".split(" ").forEach(function(a){a in d||(d[a]=c[a])});return d}})}),Or=K(Er,{Title:I(Q),OnlineResource:I(gq),LogoURL:I(Br)}),Nr=K(Er,{westBoundLongitude:I(Hm),
	eastBoundLongitude:I(Hm),southBoundLatitude:I(Hm),northBoundLatitude:I(Hm)}),Hr=K(Er,{GetCapabilities:I(zr),GetMap:I(zr),GetFeatureInfo:I(zr)}),Ar=K(Er,{Format:sl(Q),DCPType:sl(function(a,b){return L({},Qr,a,b)})}),Qr=K(Er,{HTTP:I(function(a,b){return L({},Rr,a,b)})}),Rr=K(Er,{Get:I(xr),Post:I(xr)}),Pr=K(Er,{Name:I(Q),Title:I(Q),Abstract:I(Q),LegendURL:sl(Br),StyleSheetURL:I(xr),StyleURL:I(xr)}),yr=K(Er,{Format:I(Q),OnlineResource:I(gq)}),Dr=K(Er,{Keyword:ql(Q)});function Sr(a){a=a?a:{};this.a="http://mapserver.gis.umn.edu/mapserver";this.b=new Ym;this.c=a.layers?a.layers:null;zm.call(this)}u(Sr,zm);
	Sr.prototype.yc=function(a,b){var c={};b&&pb(c,Dl(this,a,b));var d=[c];a.setAttribute("namespaceURI",this.a);var e=a.localName,c=[];if(a.childNodes.length){if("msGMLOutput"==e)for(var f=0,g=a.childNodes.length;f<g;f++){var h=a.childNodes[f];if(h.nodeType===Node.ELEMENT_NODE){var l=d[0],m=h.localName.replace("_layer","");if(!this.c||ea(this.c,m)){m+="_feature";l.featureType=m;l.featureNS=this.a;var p={};p[m]=ql(this.b.ig,this.b);l=K([l.featureNS,null],p);h.setAttribute("namespaceURI",this.a);(h=L([],
	l,h,d,this.b))&&ga(c,h)}}}"FeatureCollection"==e&&(d=L([],this.b.b,a,[{}],this.b))&&(c=d)}return c};Sr.prototype.Fg=function(){};Sr.prototype.Yb=function(){};Sr.prototype.de=function(){};function Tr(){this.f=new iq}u(Tr,hq);Tr.prototype.a=function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType==Node.ELEMENT_NODE)return this.b(a);return null};Tr.prototype.b=function(a){var b=a.getAttribute("version").trim(),c=this.f.b(a);if(!c)return null;c.version=b;return(c=L(c,Ur,a,[]))?c:null};function Vr(a){var b=Q(a).split(" ");if(b&&2==b.length&&(a=+b[0],b=+b[1],!isNaN(a)&&!isNaN(b)))return[a,b]}
	var Wr=[null,"http://www.opengis.net/wmts/1.0"],Xr=[null,"http://www.opengis.net/ows/1.1"],Ur=K(Wr,{Contents:I(function(a,b){return L({},Yr,a,b)})}),Yr=K(Wr,{Layer:sl(function(a,b){return L({},Zr,a,b)}),TileMatrixSet:sl(function(a,b){return L({},$r,a,b)})}),Zr=K(Wr,{Style:sl(function(a,b){var c=L({},as,a,b);if(c){var d="true"===a.getAttribute("isDefault");c.isDefault=d;return c}}),Format:sl(Q),TileMatrixSetLink:sl(function(a,b){return L({},bs,a,b)}),Dimension:sl(function(a,b){return L({},cs,a,b)}),
	ResourceURL:sl(function(a){var b=a.getAttribute("format"),c=a.getAttribute("template");a=a.getAttribute("resourceType");var d={};b&&(d.format=b);c&&(d.template=c);a&&(d.resourceType=a);return d})},K(Xr,{Title:I(Q),Abstract:I(Q),WGS84BoundingBox:I(function(a,b){var c=L([],ds,a,b);if(2==c.length)return Ha(c)}),Identifier:I(Q)})),as=K(Wr,{LegendURL:sl(function(a){var b={};b.format=a.getAttribute("format");b.href=gq(a);return b})},K(Xr,{Title:I(Q),Identifier:I(Q)})),bs=K(Wr,{TileMatrixSet:I(Q),TileMatrixSetLimits:I(function(a,
	b){return L([],es,a,b)})}),es=K(Wr,{TileMatrixLimits:ql(function(a,b){return L({},fs,a,b)})}),fs=K(Wr,{TileMatrix:I(Q),MinTileRow:I(Jm),MaxTileRow:I(Jm),MinTileCol:I(Jm),MaxTileCol:I(Jm)}),cs=K(Wr,{Default:I(Q),Value:sl(Q)},K(Xr,{Identifier:I(Q)})),ds=K(Xr,{LowerCorner:ql(Vr),UpperCorner:ql(Vr)}),$r=K(Wr,{WellKnownScaleSet:I(Q),TileMatrix:sl(function(a,b){return L({},gs,a,b)})},K(Xr,{SupportedCRS:I(Q),Identifier:I(Q)})),gs=K(Wr,{TopLeftCorner:I(Vr),ScaleDenominator:I(Hm),TileWidth:I(Jm),TileHeight:I(Jm),
	MatrixWidth:I(Jm),MatrixHeight:I(Jm)},K(Xr,{Identifier:I(Q)}));function hs(a){Gc.call(this);a=a||{};this.a=null;this.i=Vb;this.c=void 0;B(this,Ic("projection"),this.hm,this);B(this,Ic("tracking"),this.im,this);void 0!==a.projection&&this.Ih(Gb(a.projection));void 0!==a.trackingOptions&&this.Si(a.trackingOptions);this.Ee(void 0!==a.tracking?a.tracking:!1)}u(hs,Gc);k=hs.prototype;k.ra=function(){this.Ee(!1);Gc.prototype.ra.call(this)};k.hm=function(){var a=this.Gh();a&&(this.i=Fb(Gb("EPSG:4326"),a),this.a&&this.set("position",this.i(this.a)))};
	k.im=function(){if(Od){var a=this.Hh();a&&void 0===this.c?this.c=navigator.geolocation.watchPosition(this.Co.bind(this),this.Do.bind(this),this.th()):a||void 0===this.c||(navigator.geolocation.clearWatch(this.c),this.c=void 0)}};
	k.Co=function(a){a=a.coords;this.set("accuracy",a.accuracy);this.set("altitude",null===a.altitude?void 0:a.altitude);this.set("altitudeAccuracy",null===a.altitudeAccuracy?void 0:a.altitudeAccuracy);this.set("heading",null===a.heading?void 0:Ba(a.heading));this.a?(this.a[0]=a.longitude,this.a[1]=a.latitude):this.a=[a.longitude,a.latitude];var b=this.i(this.a);this.set("position",b);this.set("speed",null===a.speed?void 0:a.speed);a=Mf(mh,this.a,a.accuracy);a.Dc(this.i);this.set("accuracyGeometry",a);
	this.s()};k.Do=function(a){a.type="error";this.Ee(!1);this.b(a)};k.hk=function(){return this.get("accuracy")};k.ik=function(){return this.get("accuracyGeometry")||null};k.kk=function(){return this.get("altitude")};k.lk=function(){return this.get("altitudeAccuracy")};k.fm=function(){return this.get("heading")};k.gm=function(){return this.get("position")};k.Gh=function(){return this.get("projection")};k.Rk=function(){return this.get("speed")};k.Hh=function(){return this.get("tracking")};k.th=function(){return this.get("trackingOptions")};
	k.Ih=function(a){this.set("projection",a)};k.Ee=function(a){this.set("tracking",a)};k.Si=function(a){this.set("trackingOptions",a)};function is(a,b,c){ff.call(this);this.yg(a,b?b:0,c)}u(is,ff);k=is.prototype;k.clone=function(){var a=new is(null);hf(a,this.ka,this.B.slice());a.s();return a};k.Gb=function(a,b,c,d){var e=this.B;a-=e[0];var f=b-e[1];b=a*a+f*f;if(b<d){if(b)for(d=this.Vd()/Math.sqrt(b),c[0]=e[0]+d*a,c[1]=e[1]+d*f,d=2;d<this.a;++d)c[d]=e[d];else for(d=0;d<this.a;++d)c[d]=e[d];c.length=this.a;return b}return d};k.Oc=function(a,b){var c=this.B,d=a-c[0],c=b-c[1];return d*d+c*c<=js(this)};
	k.Ba=function(){return this.B.slice(0,this.a)};k.ne=function(a){var b=this.B,c=b[this.a]-b[0];return Va(b[0]-c,b[1]-c,b[0]+c,b[1]+c,a)};k.Vd=function(){return Math.sqrt(js(this))};function js(a){var b=a.B[a.a]-a.B[0];a=a.B[a.a+1]-a.B[1];return b*b+a*a}k.T=function(){return"Circle"};k.Xa=function(a){var b=this.D();return mb(a,b)?(b=this.Ba(),a[0]<=b[0]&&a[2]>=b[0]||a[1]<=b[1]&&a[3]>=b[1]?!0:ab(a,this.sb,this)):!1};
	k.wb=function(a){var b=this.a,c=a.slice();c[b]=c[0]+(this.B[b]-this.B[0]);var d;for(d=1;d<b;++d)c[b+d]=a[d];hf(this,this.ka,c);this.s()};k.yg=function(a,b,c){if(a){jf(this,c,a,0);this.B||(this.B=[]);c=this.B;a=rf(c,a);c[a++]=c[0]+b;var d;b=1;for(d=this.a;b<d;++b)c[a++]=c[b];c.length=a}else hf(this,"XY",null);this.s()};k.X=function(){};k.pa=function(){};k.Wc=function(a){this.B[this.a]=this.B[0]+a;this.s()};function ks(a,b,c){for(var d=[],e=a(0),f=a(1),g=b(e),h=b(f),l=[f,e],m=[h,g],p=[1,0],n={},q=1E5,r,v,x,y,z;0<--q&&0<p.length;)x=p.pop(),e=l.pop(),g=m.pop(),f=x.toString(),f in n||(d.push(g[0],g[1]),n[f]=!0),y=p.pop(),f=l.pop(),h=m.pop(),z=(x+y)/2,r=a(z),v=b(r),za(v[0],v[1],g[0],g[1],h[0],h[1])<c?(d.push(h[0],h[1]),f=y.toString(),n[f]=!0):(p.push(y,z,z,x),m.push(h,v,v,g),l.push(f,r,r,e));return d}function ls(a,b,c,d,e){var f=Gb("EPSG:4326");return ks(function(d){return[a,b+(c-b)*d]},Ub(f,d),e)}
	function ms(a,b,c,d,e){var f=Gb("EPSG:4326");return ks(function(d){return[b+(c-b)*d,a]},Ub(f,d),e)};function ns(a){a=a||{};this.i=this.j=null;this.f=this.g=Infinity;this.c=this.l=-Infinity;this.A=this.u=Infinity;this.G=this.C=-Infinity;this.R=void 0!==a.targetSize?a.targetSize:100;this.qa=void 0!==a.maxLines?a.maxLines:100;this.b=[];this.a=[];this.ta=void 0!==a.strokeStyle?a.strokeStyle:os;this.I=this.o=void 0;this.v=null;this.setMap(void 0!==a.map?a.map:null)}var os=new rj({color:"rgba(0,0,0,0.2)"}),ps=[90,45,30,20,10,5,2,1,.5,.2,.1,.05,.01,.005,.002,.001];
	function qs(a,b,c,d,e,f,g){var h=g;b=ls(b,c,d,a.i,e);h=void 0!==a.b[h]?a.b[h]:new M(null);h.ca("XY",b);mb(h.D(),f)&&(a.b[g++]=h);return g}function rs(a,b,c,d,e){var f=e;b=ms(b,a.c,a.f,a.i,c);f=void 0!==a.a[f]?a.a[f]:new M(null);f.ca("XY",b);mb(f.D(),d)&&(a.a[e++]=f);return e}k=ns.prototype;k.jm=function(){return this.j};k.Gk=function(){return this.b};k.Nk=function(){return this.a};
	k.wh=function(a){var b=a.vectorContext,c=a.frameState,d=c.extent;a=c.viewState;var e=a.center,f=a.projection,g=a.resolution;a=c.pixelRatio;a=g*g/(4*a*a);if(!this.i||!Tb(this.i,f)){var h=Gb("EPSG:4326"),l=f.D(),m=f.g,p=Xb(m,h,f),n=m[2],q=m[1],r=m[0],v=p[3],x=p[2],y=p[1],p=p[0];this.g=m[3];this.f=n;this.l=q;this.c=r;this.u=v;this.A=x;this.C=y;this.G=p;this.o=Ub(h,f);this.I=Ub(f,h);this.v=this.I(jb(l));this.i=f}f.a&&(f=f.D(),h=hb(f),c=c.focus[0],c<f[0]||c>f[2])&&(c=h*Math.ceil((f[0]-c)/h),d=[d[0]+c,
	d[1],d[2]+c,d[3]]);c=this.v[0];f=this.v[1];h=-1;m=Math.pow(this.R*g,2);n=[];q=[];g=0;for(l=ps.length;g<l;++g){r=ps[g]/2;n[0]=c-r;n[1]=f-r;q[0]=c+r;q[1]=f+r;this.o(n,n);this.o(q,q);r=Math.pow(q[0]-n[0],2)+Math.pow(q[1]-n[1],2);if(r<=m)break;h=ps[g]}g=h;if(-1==g)this.b.length=this.a.length=0;else{c=this.I(e);e=c[0];c=c[1];f=this.qa;h=[Math.max(d[0],this.G),Math.max(d[1],this.C),Math.min(d[2],this.A),Math.min(d[3],this.u)];h=Xb(h,this.i,"EPSG:4326");m=h[3];q=h[1];e=Math.floor(e/g)*g;n=wa(e,this.c,this.f);
	l=qs(this,n,q,m,a,d,0);for(h=0;n!=this.c&&h++<f;)n=Math.max(n-g,this.c),l=qs(this,n,q,m,a,d,l);n=wa(e,this.c,this.f);for(h=0;n!=this.f&&h++<f;)n=Math.min(n+g,this.f),l=qs(this,n,q,m,a,d,l);this.b.length=l;c=Math.floor(c/g)*g;e=wa(c,this.l,this.g);l=rs(this,e,a,d,0);for(h=0;e!=this.l&&h++<f;)e=Math.max(e-g,this.l),l=rs(this,e,a,d,l);e=wa(c,this.l,this.g);for(h=0;e!=this.g&&h++<f;)e=Math.min(e+g,this.g),l=rs(this,e,a,d,l);this.a.length=l}b.Na(null,this.ta);a=0;for(e=this.b.length;a<e;++a)g=this.b[a],
	b.Qb(g,null);a=0;for(e=this.a.length;a<e;++a)g=this.a[a],b.Qb(g,null)};k.setMap=function(a){this.j&&(this.j.K("postcompose",this.wh,this),this.j.render());a&&(a.J("postcompose",this.wh,this),a.render());this.j=a};function ss(a,b,c,d,e){Dc.call(this);this.i=e;this.extent=a;this.a=c;this.resolution=b;this.state=d}u(ss,Dc);ss.prototype.s=function(){this.b("change")};ss.prototype.D=function(){return this.extent};ss.prototype.V=function(){return this.state};function ts(a,b,c,d,e,f,g){ss.call(this,a,b,c,0,d);this.l=e;this.M=new Image;null!==f&&(this.M.crossOrigin=f);this.c={};this.f=null;this.state=0;this.g=g}u(ts,ss);k=ts.prototype;k.Z=function(a){if(void 0!==a){var b;a=w(a);if(a in this.c)return this.c[a];sb(this.c)?b=this.M:b=this.M.cloneNode(!1);return this.c[a]=b}return this.M};k.mm=function(){this.state=3;this.f.forEach(rc);this.f=null;this.s()};
	k.nm=function(){void 0===this.resolution&&(this.resolution=ib(this.extent)/this.M.height);this.state=2;this.f.forEach(rc);this.f=null;this.s()};k.load=function(){if(0==this.state||3==this.state)this.state=1,this.s(),this.f=[wc(this.M,"error",this.mm,this),wc(this.M,"load",this.nm,this)],this.g(this,this.l)};k.zg=function(a){this.M=a};function us(a,b,c,d,e,f){this.c=f?f:null;ss.call(this,a,b,c,f?0:2,d);this.f=e}u(us,ss);us.prototype.g=function(a){this.state=a?3:2;this.s()};us.prototype.load=function(){0==this.state&&(this.state=1,this.s(),this.c(this.g.bind(this)))};us.prototype.Z=function(){return this.f};function vs(a,b){Dc.call(this);this.Ga=a;this.state=b;this.a=null;this.key=""}u(vs,Dc);vs.prototype.s=function(){this.b("change")};vs.prototype.ib=function(){return this.key+"/"+this.Ga};function ws(a){if(!a.a)return a;var b=a.a;do{if(2==b.V())return b;b=b.a}while(b);return a}vs.prototype.i=function(){return this.Ga};vs.prototype.V=function(){return this.state};function xs(a,b,c,d,e){vs.call(this,a,b);this.g=c;this.M=new Image;null!==d&&(this.M.crossOrigin=d);this.c=null;this.j=e}u(xs,vs);k=xs.prototype;k.ra=function(){1==this.state&&ys(this);this.a&&Ac(this.a);this.state=5;this.s();vs.prototype.ra.call(this)};k.Z=function(){return this.M};k.ib=function(){return this.g};k.km=function(){this.state=3;ys(this);this.s()};k.lm=function(){this.state=this.M.naturalWidth&&this.M.naturalHeight?2:4;ys(this);this.s()};
	k.load=function(){if(0==this.state||3==this.state)this.state=1,this.s(),this.c=[wc(this.M,"error",this.km,this),wc(this.M,"load",this.lm,this)],this.j(this,this.g)};function ys(a){a.c.forEach(rc);a.c=null};function zs(a){a=a?a:{};ag.call(this,{handleEvent:af});this.g=a.formatConstructors?a.formatConstructors:[];this.j=a.projection?Gb(a.projection):null;this.a=null;this.target=a.target?a.target:null}u(zs,ag);function As(a){a=a.dataTransfer.files;var b,c,d;b=0;for(c=a.length;b<c;++b){d=a.item(b);var e=new FileReader;e.addEventListener("load",this.l.bind(this,d));e.readAsText(d)}}function Bs(a){a.stopPropagation();a.preventDefault();a.dataTransfer.dropEffect="copy"}
	zs.prototype.l=function(a,b){var c=b.target.result,d=this.v,e=this.j;e||(e=d.$().o);var d=this.g,f=[],g,h;g=0;for(h=d.length;g<h;++g){var l=new d[g];var m={featureProjection:e};try{f=l.Qa(c,m)}catch(p){f=null}if(f&&0<f.length)break}this.b(new Cs(Ds,a,f,e))};zs.prototype.setMap=function(a){this.a&&(this.a.forEach(rc),this.a=null);ag.prototype.setMap.call(this,a);a&&(a=this.target?this.target:a.c,this.a=[B(a,"drop",As,this),B(a,"dragenter",Bs,this),B(a,"dragover",Bs,this),B(a,"drop",Bs,this)])};
	var Ds="addfeatures";function Cs(a,b,c,d){Bc.call(this,a);this.features=c;this.file=b;this.projection=d}u(Cs,Bc);function Es(a){a=a?a:{};pg.call(this,{handleDownEvent:Fs,handleDragEvent:Gs,handleUpEvent:Hs});this.o=a.condition?a.condition:lg;this.a=this.g=void 0;this.j=0;this.u=void 0!==a.duration?a.duration:400}u(Es,pg);function Gs(a){if(ng(a)){var b=a.map,c=b.Mb(),d=a.pixel;a=d[0]-c[0]/2;d=c[1]/2-d[1];c=Math.atan2(d,a);a=Math.sqrt(a*a+d*d);b=b.$();void 0!==this.g&&(d=c-this.g,bg(b,b.Va()-d));this.g=c;void 0!==this.a&&(c=this.a*(b.Ua()/a),dg(b,c));void 0!==this.a&&(this.j=this.a/a);this.a=a}}
	function Hs(a){if(!ng(a))return!0;a=a.map.$();Rf(a,1,-1);var b=this.j-1,c=a.Va(),c=a.constrainRotation(c,0);bg(a,c,void 0,void 0);var c=a.Ua(),d=this.u,c=a.constrainResolution(c,0,b);dg(a,c,void 0,d);this.j=0;return!1}function Fs(a){return ng(a)&&this.o(a)?(Rf(a.map.$(),1,1),this.a=this.g=void 0,!0):!1};function Is(a,b,c,d){this.oa=a;this.Y=b;this.overlaps=d;this.c=0;this.resolution=c;this.R=this.ta=null;this.a=[];this.coordinates=[];this.eb=wh();this.b=[];this.qa=null;this.ia=wh();this.ea=wh()}u(Is,Rh);
	function Js(a,b,c,d,e,f,g){var h=a.coordinates.length,l=a.Gf();g&&(c+=e);g=[b[c],b[c+1]];var m=[NaN,NaN],p=!0,n,q,r;for(n=c+e;n<d;n+=e)m[0]=b[n],m[1]=b[n+1],r=Ua(l,m),r!==q?(p&&(a.coordinates[h++]=g[0],a.coordinates[h++]=g[1]),a.coordinates[h++]=m[0],a.coordinates[h++]=m[1],p=!1):1===r?(a.coordinates[h++]=m[0],a.coordinates[h++]=m[1],p=!1):p=!0,g[0]=m[0],g[1]=m[1],q=r;if(f&&p||n===c+e)a.coordinates[h++]=g[0],a.coordinates[h++]=g[1];return h}
	function Ks(a,b){a.ta=[0,b,0];a.a.push(a.ta);a.R=[0,b,0];a.b.push(a.R)}Is.prototype.Wa=function(a,b){if(this.$a){var c=Bh(this.eb,this.$a.slice());a.translate(c[0],c[1]);a.rotate(b)}a.fill();this.$a&&a.setTransform.apply(a,this.ea)};
	function Ls(a,b,c,d,e,f,g,h,l){var m;a.qa&&ia(d,a.eb)?m=a.qa:(a.qa||(a.qa=[]),m=df(a.coordinates,0,a.coordinates.length,2,d,a.qa),Ah(a.eb,d));d=!sb(f);for(var p=0,n=g.length,q=0,r,v=a.ia,x=a.ea,y,z,A,V,Pa=0,ra=0,La=a.a!=g||a.overlaps?0:200;p<n;){var C=g[p],Ma,xb,Z,Ra;switch(C[0]){case 0:q=C[1];d&&f[w(q).toString()]||!q.U()?p=C[2]:void 0===l||mb(l,q.U().D())?++p:p=C[2]+1;break;case 1:Pa>La&&(a.Wa(b,e),Pa=0);ra>La&&(b.stroke(),ra=0);Pa||ra||(b.beginPath(),y=z=NaN);++p;break;case 2:q=C[1];r=m[q];C=m[q+
	1];A=m[q+2]-r;q=m[q+3]-C;q=Math.sqrt(A*A+q*q);b.moveTo(r+q,C);b.arc(r,C,q,0,2*Math.PI,!0);++p;break;case 3:b.closePath();++p;break;case 4:q=C[1];r=C[2];Ma=C[3];xb=C[4]*c;Z=C[5]*c;var Cb=C[6],dc=C[7],$c=C[8],$d=C[9];Ra=C[10];A=C[11];V=C[12];var Je=C[13],ue=C[14];for(Ra&&(A+=e);q<r;q+=2){C=m[q]-xb;Ra=m[q+1]-Z;Je&&(C=Math.round(C),Ra=Math.round(Ra));if(1!=V||A){var Tc=C+xb,lh=Ra+Z;Fh(v,Tc,lh,V,V,A,-Tc,-lh);b.setTransform.apply(b,v)}Tc=b.globalAlpha;1!=dc&&(b.globalAlpha=Tc*dc);var lh=ue+$c>Ma.width?
	Ma.width-$c:ue,lq=Cb+$d>Ma.height?Ma.height-$d:Cb;b.drawImage(Ma,$c,$d,lh,lq,C,Ra,lh*c,lq*c);1!=dc&&(b.globalAlpha=Tc);(1!=V||A)&&b.setTransform.apply(b,x)}++p;break;case 5:q=C[1];r=C[2];Z=C[3];Cb=C[4]*c;dc=C[5]*c;A=C[6];V=C[7]*c;Ma=C[8];xb=C[9];for((Ra=C[10])&&(A+=e);q<r;q+=2){C=m[q]+Cb;Ra=m[q+1]+dc;if(1!=V||A)Fh(v,C,Ra,V,V,A,-C,-Ra),b.setTransform.apply(b,v);$c=Z.split("\n");$d=$c.length;1<$d?(Je=Math.round(1.5*b.measureText("M").width),Ra-=($d-1)/2*Je):Je=0;for(ue=0;ue<$d;ue++)Tc=$c[ue],xb&&b.strokeText(Tc,
	C,Ra),Ma&&b.fillText(Tc,C,Ra),Ra+=Je;(1!=V||A)&&b.setTransform.apply(b,x)}++p;break;case 6:if(h&&(q=C[1],q=h(q)))return q;++p;break;case 7:La?Pa++:a.Wa(b,e);++p;break;case 8:q=C[1];r=C[2];C=m[q];Ra=m[q+1];A=C+.5|0;V=Ra+.5|0;if(A!==y||V!==z)b.moveTo(C,Ra),y=A,z=V;for(q+=2;q<r;q+=2)if(C=m[q],Ra=m[q+1],A=C+.5|0,V=Ra+.5|0,q==r-2||A!==y||V!==z)b.lineTo(C,Ra),y=A,z=V;++p;break;case 9:a.$a=C[2];Pa&&(a.Wa(b,e),Pa=0,ra&&(b.stroke(),ra=0));b.fillStyle=C[1];++p;break;case 10:var q=void 0!==C[8]?C[8]:!0,hl=C[9];
	r=C[2];ra&&(b.stroke(),ra=0);b.strokeStyle=C[1];b.lineWidth=q?r*c:r;b.lineCap=C[3];b.lineJoin=C[4];b.miterLimit=C[5];Ld&&(r=C[6],A=C[7],q&&c!==hl&&(r=r.map(function(a){return a*c/hl}),A*=c/hl,C[6]=r,C[7]=A,C[9]=c),b.lineDashOffset=A,b.setLineDash(r));++p;break;case 11:b.font=C[1];b.textAlign=C[2];b.textBaseline=C[3];++p;break;case 12:La?ra++:b.stroke();++p;break;default:++p}}Pa&&a.Wa(b,e);ra&&b.stroke()}Is.prototype.i=function(a,b,c,d,e){Ls(this,a,b,c,d,e,this.a,void 0,void 0)};
	function Ms(a){var b=a.b;b.reverse();var c,d=b.length,e,f,g=-1;for(c=0;c<d;++c)if(e=b[c],f=e[0],6==f)g=c;else if(0==f){e[2]=c;e=a.b;for(f=c;g<f;){var h=e[g];e[g]=e[f];e[f]=h;++g;--f}g=-1}}function Ns(a,b){a.ta[2]=a.a.length;a.ta=null;a.R[2]=a.b.length;a.R=null;var c=[6,b];a.a.push(c);a.b.push(c)}Is.prototype.Je=na;Is.prototype.Gf=function(){return this.Y};function Os(a,b,c,d){Is.call(this,a,b,c,d);this.M=this.S=null;this.G=this.C=this.A=this.u=this.I=this.v=this.o=this.j=this.l=this.g=this.f=void 0}u(Os,Is);
	Os.prototype.qc=function(a,b){if(this.M){Ks(this,b);var c=a.ha(),d=this.coordinates.length,c=Js(this,c,0,c.length,a.sa(),!1,!1);this.a.push([4,d,c,this.M,this.f,this.g,this.l,this.j,this.o,this.v,this.I,this.u,this.A,this.C,this.G]);this.b.push([4,d,c,this.S,this.f,this.g,this.l,this.j,this.o,this.v,this.I,this.u,this.A,this.C,this.G]);Ns(this,b)}};
	Os.prototype.oc=function(a,b){if(this.M){Ks(this,b);var c=a.ha(),d=this.coordinates.length,c=Js(this,c,0,c.length,a.sa(),!1,!1);this.a.push([4,d,c,this.M,this.f,this.g,this.l,this.j,this.o,this.v,this.I,this.u,this.A,this.C,this.G]);this.b.push([4,d,c,this.S,this.f,this.g,this.l,this.j,this.o,this.v,this.I,this.u,this.A,this.C,this.G]);Ns(this,b)}};Os.prototype.Je=function(){Ms(this);this.g=this.f=void 0;this.M=this.S=null;this.G=this.C=this.u=this.I=this.v=this.o=this.j=this.A=this.l=void 0};
	Os.prototype.Vb=function(a){var b=a.Hc(),c=a.jc(),d=a.cg(1),e=a.Z(1),f=a.Pc();this.f=b[0];this.g=b[1];this.S=d;this.M=e;this.l=c[1];this.j=a.g;this.o=f[0];this.v=f[1];this.I=a.o;this.u=a.l;this.A=a.c;this.C=a.v;this.G=c[0]};function Ps(a,b,c,d){Is.call(this,a,b,c,d);this.g=null;this.f={Kd:void 0,Ed:void 0,Fd:null,Gd:void 0,Hd:void 0,Id:void 0,Jd:void 0,Sf:0,strokeStyle:void 0,lineCap:void 0,lineDash:null,lineDashOffset:void 0,lineJoin:void 0,lineWidth:void 0,miterLimit:void 0}}u(Ps,Is);function Qs(a,b,c,d,e){var f=a.coordinates.length;b=Js(a,b,c,d,e,!1,!1);f=[8,f,b];a.a.push(f);a.b.push(f);return d}k=Ps.prototype;k.Gf=function(){this.g||(this.g=Na(this.Y),0<this.c&&Ka(this.g,this.resolution*(this.c+1)/2,this.g));return this.g};
	function Rs(a){var b=a.f,c=b.strokeStyle,d=b.lineCap,e=b.lineDash,f=b.lineDashOffset,g=b.lineJoin,h=b.lineWidth,l=b.miterLimit;b.Kd==c&&b.Ed==d&&ia(b.Fd,e)&&b.Gd==f&&b.Hd==g&&b.Id==h&&b.Jd==l||(b.Sf!=a.coordinates.length&&(a.a.push([12]),b.Sf=a.coordinates.length),a.a.push([10,c,h,d,g,l,e,f,!0,1],[1]),b.Kd=c,b.Ed=d,b.Fd=e,b.Gd=f,b.Hd=g,b.Id=h,b.Jd=l)}
	k.Qb=function(a,b){var c=this.f,d=c.lineWidth;void 0!==c.strokeStyle&&void 0!==d&&(Rs(this),Ks(this,b),this.b.push([10,c.strokeStyle,c.lineWidth,c.lineCap,c.lineJoin,c.miterLimit,c.lineDash,c.lineDashOffset,!0,1],[1]),c=a.ha(),Qs(this,c,0,c.length,a.sa()),this.b.push([12]),Ns(this,b))};
	k.nc=function(a,b){var c=this.f,d=c.lineWidth;if(void 0!==c.strokeStyle&&void 0!==d){Rs(this);Ks(this,b);this.b.push([10,c.strokeStyle,c.lineWidth,c.lineCap,c.lineJoin,c.miterLimit,c.lineDash,c.lineDashOffset,!0,1],[1]);var c=a.Rb(),d=a.ha(),e=a.sa(),f=0,g,h;g=0;for(h=c.length;g<h;++g)f=Qs(this,d,f,c[g],e);this.b.push([12]);Ns(this,b)}};k.Je=function(){this.f.Sf!=this.coordinates.length&&this.a.push([12]);Ms(this);this.f=null};
	k.Na=function(a,b){var c=b.a;this.f.strokeStyle=Vc(c?c:Ph);c=b.i;this.f.lineCap=void 0!==c?c:"round";c=b.f;this.f.lineDash=c?c:Oh;c=b.g;this.f.lineDashOffset=c?c:0;c=b.l;this.f.lineJoin=void 0!==c?c:"round";c=b.c;this.f.lineWidth=void 0!==c?c:1;c=b.j;this.f.miterLimit=void 0!==c?c:10;this.f.lineWidth>this.c&&(this.c=this.f.lineWidth,this.g=null)};function Ss(a,b,c,d){Is.call(this,a,b,c,d);this.g=null;this.f={Yg:void 0,Kd:void 0,Ed:void 0,Fd:null,Gd:void 0,Hd:void 0,Id:void 0,Jd:void 0,fillStyle:void 0,strokeStyle:void 0,lineCap:void 0,lineDash:null,lineDashOffset:void 0,lineJoin:void 0,lineWidth:void 0,miterLimit:void 0}}u(Ss,Is);
	function Ts(a,b,c,d,e){var f=a.f,g=void 0!==f.fillStyle,f=void 0!=f.strokeStyle,h=d.length,l=[1];a.a.push(l);a.b.push(l);for(l=0;l<h;++l){var m=d[l],p=a.coordinates.length;c=Js(a,b,c,m,e,!0,!f);c=[8,p,c];a.a.push(c);a.b.push(c);f&&(c=[3],a.a.push(c),a.b.push(c));c=m}b=[7];a.b.push(b);g&&a.a.push(b);f&&(g=[12],a.a.push(g),a.b.push(g));return c}k=Ss.prototype;
	k.$b=function(a,b){var c=this.f,d=c.strokeStyle;if(void 0!==c.fillStyle||void 0!==d){Us(this,a);Ks(this,b);this.b.push([9,Sc(Nh)]);void 0!==c.strokeStyle&&this.b.push([10,c.strokeStyle,c.lineWidth,c.lineCap,c.lineJoin,c.miterLimit,c.lineDash,c.lineDashOffset,!0,1]);var e=a.ha(),d=this.coordinates.length;Js(this,e,0,e.length,a.sa(),!1,!1);e=[1];d=[2,d];this.a.push(e,d);this.b.push(e,d);d=[7];this.b.push(d);void 0!==c.fillStyle&&this.a.push(d);void 0!==c.strokeStyle&&(c=[12],this.a.push(c),this.b.push(c));
	Ns(this,b)}};k.rc=function(a,b){var c=this.f;Us(this,a);Ks(this,b);this.b.push([9,Sc(Nh)]);void 0!==c.strokeStyle&&this.b.push([10,c.strokeStyle,c.lineWidth,c.lineCap,c.lineJoin,c.miterLimit,c.lineDash,c.lineDashOffset,!0,1]);var c=a.Rb(),d=a.fc();Ts(this,d,0,c,a.sa());Ns(this,b)};
	k.pc=function(a,b){var c=this.f,d=c.strokeStyle;if(void 0!==c.fillStyle||void 0!==d){Us(this,a);Ks(this,b);this.b.push([9,Sc(Nh)]);void 0!==c.strokeStyle&&this.b.push([10,c.strokeStyle,c.lineWidth,c.lineCap,c.lineJoin,c.miterLimit,c.lineDash,c.lineDashOffset,!0,1]);var c=a.c,d=ai(a),e=a.sa(),f=0,g,h;g=0;for(h=c.length;g<h;++g)f=Ts(this,d,f,c[g],e);Ns(this,b)}};k.Je=function(){Ms(this);this.f=null;var a=this.oa;if(a){var b=this.coordinates,c,d;c=0;for(d=b.length;c<d;++c)b[c]=a*Math.round(b[c]/a)}};
	k.Gf=function(){this.g||(this.g=Na(this.Y),0<this.c&&Ka(this.g,this.resolution*(this.c+1)/2,this.g));return this.g};
	k.Na=function(a,b){var c=this.f;if(a){var d=a.b;c.fillStyle=Vc(d?d:Nh)}else c.fillStyle=void 0;b?(d=b.a,c.strokeStyle=Vc(d?d:Ph),d=b.i,c.lineCap=void 0!==d?d:"round",d=b.f,c.lineDash=d?d.slice():Oh,d=b.g,c.lineDashOffset=d?d:0,d=b.l,c.lineJoin=void 0!==d?d:"round",d=b.c,c.lineWidth=void 0!==d?d:1,d=b.j,c.miterLimit=void 0!==d?d:10,c.lineWidth>this.c&&(this.c=c.lineWidth,this.g=null)):(c.strokeStyle=void 0,c.lineCap=void 0,c.lineDash=null,c.lineDashOffset=void 0,c.lineJoin=void 0,c.lineWidth=void 0,
	c.miterLimit=void 0)};function Us(a,b){var c=a.f,d=c.fillStyle,e=c.strokeStyle,f=c.lineCap,g=c.lineDash,h=c.lineDashOffset,l=c.lineJoin,m=c.lineWidth,p=c.miterLimit;if(void 0!==d&&("string"!==typeof d||c.Yg!=d)){var n=[9,d];"string"!==typeof d&&(d=b.D(),n.push([d[0],d[3]]));a.a.push(n);c.Yg=c.fillStyle}void 0===e||c.Kd==e&&c.Ed==f&&ia(c.Fd,g)&&c.Gd==h&&c.Hd==l&&c.Id==m&&c.Jd==p||(a.a.push([10,e,m,f,l,p,g,h,!0,1]),c.Kd=e,c.Ed=f,c.Fd=g,c.Gd=h,c.Hd=l,c.Id=m,c.Jd=p)};function Vs(a,b,c,d){Is.call(this,a,b,c,d);this.G=this.C=this.A=null;this.Fa="";this.o=this.j=0;this.v=void 0;this.u=this.I=0;this.l=this.g=this.f=null}u(Vs,Is);
	Vs.prototype.xc=function(a,b,c,d,e,f){if(""!==this.Fa&&this.l&&(this.f||this.g)){if(this.f){e=this.f;var g=this.A;if(!g||g.fillStyle!=e.fillStyle){var h=[9,e.fillStyle];this.a.push(h);this.b.push(h);g?g.fillStyle=e.fillStyle:this.A={fillStyle:e.fillStyle}}}this.g&&(e=this.g,g=this.C,g&&g.lineCap==e.lineCap&&g.lineDash==e.lineDash&&g.lineDashOffset==e.lineDashOffset&&g.lineJoin==e.lineJoin&&g.lineWidth==e.lineWidth&&g.miterLimit==e.miterLimit&&g.strokeStyle==e.strokeStyle||(h=[10,e.strokeStyle,e.lineWidth,
	e.lineCap,e.lineJoin,e.miterLimit,e.lineDash,e.lineDashOffset,!1,1],this.a.push(h),this.b.push(h),g?(g.lineCap=e.lineCap,g.lineDash=e.lineDash,g.lineDashOffset=e.lineDashOffset,g.lineJoin=e.lineJoin,g.lineWidth=e.lineWidth,g.miterLimit=e.miterLimit,g.strokeStyle=e.strokeStyle):this.C={lineCap:e.lineCap,lineDash:e.lineDash,lineDashOffset:e.lineDashOffset,lineJoin:e.lineJoin,lineWidth:e.lineWidth,miterLimit:e.miterLimit,strokeStyle:e.strokeStyle}));e=this.l;g=this.G;g&&g.font==e.font&&g.textAlign==
	e.textAlign&&g.textBaseline==e.textBaseline||(h=[11,e.font,e.textAlign,e.textBaseline],this.a.push(h),this.b.push(h),g?(g.font=e.font,g.textAlign=e.textAlign,g.textBaseline=e.textBaseline):this.G={font:e.font,textAlign:e.textAlign,textBaseline:e.textBaseline});Ks(this,f);e=this.coordinates.length;a=Js(this,a,b,c,d,!1,!1);a=[5,e,a,this.Fa,this.j,this.o,this.I,this.u,!!this.f,!!this.g,this.v];this.a.push(a);this.b.push(a);Ns(this,f)}};
	Vs.prototype.Tb=function(a){if(a){var b=a.Ca();b?(b=b.b,b=Vc(b?b:Nh),this.f?this.f.fillStyle=b:this.f={fillStyle:b}):this.f=null;var c=a.Da();if(c){var b=c.a,d=c.i,e=c.f,f=c.g,g=c.l,h=c.c,c=c.j,d=void 0!==d?d:"round",e=e?e.slice():Oh,f=void 0!==f?f:0,g=void 0!==g?g:"round",h=void 0!==h?h:1,c=void 0!==c?c:10,b=Vc(b?b:Ph);if(this.g){var l=this.g;l.lineCap=d;l.lineDash=e;l.lineDashOffset=f;l.lineJoin=g;l.lineWidth=h;l.miterLimit=c;l.strokeStyle=b}else this.g={lineCap:d,lineDash:e,lineDashOffset:f,lineJoin:g,
	lineWidth:h,miterLimit:c,strokeStyle:b}}else this.g=null;var m=a.a,b=a.f,d=a.c,e=a.j,h=a.i,c=a.b,f=a.Pa(),g=a.g,l=a.l;a=void 0!==m?m:"10px sans-serif";g=void 0!==g?g:"center";l=void 0!==l?l:"middle";this.l?(m=this.l,m.font=a,m.textAlign=g,m.textBaseline=l):this.l={font:a,textAlign:g,textBaseline:l};this.Fa=void 0!==f?f:"";this.j=void 0!==b?b:0;this.o=void 0!==d?d:0;this.v=void 0!==e?e:!1;this.I=void 0!==h?h:0;this.u=void 0!==c?c:1}else this.Fa=""};function Ws(a,b,c,d,e){this.I=a;this.c=b;this.o=d;this.v=c;this.g=e;this.a={};this.l=Xc(1,1);this.j=wh()}u(Ws,fi);var Xs={0:[[!0]]};function Ys(a,b,c){var d,e=Math.floor(a.length/2);if(b>=e)for(d=e;d<b;d++)a[d][c]=!0;else if(b<e)for(d=b+1;d<e;d++)a[d][c]=!0}
	function Zs(a){if(void 0!==Xs[a])return Xs[a];for(var b=2*a+1,c=Array(b),d=0;d<b;d++)c[d]=Array(b);for(var b=a,e=d=0;b>=d;)Ys(c,a+b,a+d),Ys(c,a+d,a+b),Ys(c,a-d,a+b),Ys(c,a-b,a+d),Ys(c,a-b,a-d),Ys(c,a-d,a-b),Ys(c,a+d,a-b),Ys(c,a+b,a-d),d++,e+=1+2*d,0<2*(e-b)+1&&(--b,e+=1-2*b);return Xs[a]=c}function $s(a){for(var b in a.a){var c=a.a[b],d;for(d in c)c[d].Je()}}
	Ws.prototype.Aa=function(a,b,c,d,e,f){d=Math.round(d);var g=2*d+1,h=Fh(this.j,d+.5,d+.5,1/b,-1/b,-c,-a[0],-a[1]),l=this.l;l.canvas.width!==g||l.canvas.height!==g?(l.canvas.width=g,l.canvas.height=g):l.clearRect(0,0,g,g);var m;void 0!==this.g&&(m=Ia(),Ja(m,a),Ka(m,b*(this.g+d),m));var p=Zs(d);return at(this,l,h,c,e,function(a){for(var b=l.getImageData(0,0,g,g).data,c=0;c<g;c++)for(var d=0;d<g;d++)if(p[c][d]&&0<b[4*(d*g+c)+3]){if(a=f(a))return a;l.clearRect(0,0,g,g);return}},m)};
	function bt(a,b){var c=a.c,d=c[0],e=c[1],f=c[2],c=c[3],d=[d,e,d,c,f,c,f,e];df(d,0,8,2,b,d);return d}Ws.prototype.b=function(a,b){var c=void 0!==a?a.toString():"0",d=this.a[c];void 0===d&&(d={},this.a[c]=d);c=d[b];void 0===c&&(c=new ct[b](this.I,this.c,this.v,this.o),d[b]=c);return c};Ws.prototype.f=function(){return sb(this.a)};
	Ws.prototype.i=function(a,b,c,d,e,f){var g=Object.keys(this.a).map(Number);g.sort(da);var h=bt(this,c);a.save();a.beginPath();a.moveTo(h[0],h[1]);a.lineTo(h[2],h[3]);a.lineTo(h[4],h[5]);a.lineTo(h[6],h[7]);a.clip();f=f?f:ei;var l,m,p,n,q,h=0;for(l=g.length;h<l;++h)for(n=this.a[g[h].toString()],m=0,p=f.length;m<p;++m)q=n[f[m]],void 0!==q&&q.i(a,b,c,d,e);a.restore()};
	function at(a,b,c,d,e,f,g){var h=Object.keys(a.a).map(Number);h.sort(function(a,b){return b-a});var l,m,p,n,q;l=0;for(m=h.length;l<m;++l)for(n=a.a[h[l].toString()],p=ei.length-1;0<=p;--p)if(q=n[ei[p]],void 0!==q&&(q=Ls(q,b,1,c,d,e,q.b,f,g)))return q}var ct={Circle:Ss,Image:Os,LineString:Ps,Polygon:Ss,Text:Vs};function dt(a){Fc.call(this);this.a=a}u(dt,Fc);dt.prototype.Aa=na;dt.prototype.Ke=bf;dt.prototype.Cf=function(a,b,c){return function(d,e){return et(a,b,d,e,function(a){c[d]||(c[d]={});c[d][a.Ga.toString()]=a})}};dt.prototype.ea=function(a){2===a.target.V()&&ft(this)};function gt(a,b){var c=b.V();2!=c&&3!=c&&B(b,"change",a.ea,a);0==c&&(b.load(),c=b.V());return 2==c}function ft(a){var b=a.a;b.Kb()&&"ready"==b.Nf()&&a.s()}
	function ht(a,b){b.fi()&&a.postRenderFunctions.push(function(a,b,e){b=w(a).toString();a.gd(e.viewState.projection,e.usedTiles[b])}.bind(null,b))}function it(a,b){if(b){var c,d,e;d=0;for(e=b.length;d<e;++d)c=b[d],a[w(c).toString()]=c}}function jt(a,b){var c=b.R;void 0!==c&&("string"===typeof c?a.logos[c]="":c&&(qa("string"==typeof c.href,44),qa("string"==typeof c.src,45),a.logos[c.src]=c.href))}
	function kt(a,b,c,d){b=w(b).toString();c=c.toString();b in a?c in a[b]?(a=a[b][c],d.da<a.da&&(a.da=d.da),d.ba>a.ba&&(a.ba=d.ba),d.fa<a.fa&&(a.fa=d.fa),d.ja>a.ja&&(a.ja=d.ja)):a[b][c]=d:(a[b]={},a[b][c]=d)}
	function lt(a,b,c,d,e,f,g,h,l,m){var p=w(b).toString();p in a.wantedTiles||(a.wantedTiles[p]={});var n=a.wantedTiles[p];a=a.tileQueue;var q=c.minZoom,r,v,x,y,z,A;for(A=g;A>=q;--A)for(v=cc(c,f,A,v),x=c.La(A),y=v.da;y<=v.ba;++y)for(z=v.fa;z<=v.ja;++z)g-A<=h?(r=b.Lc(A,y,z,d,e),0==r.V()&&(n[r.ib()]=!0,r.ib()in a.a||a.i([r,p,ic(c,r.Ga),x])),l&&l.call(m,r)):b.Eg(A,y,z,e)};function mt(a){dt.call(this,a);this.ia=wh()}u(mt,dt);function nt(a,b,c){var d=b.pixelRatio,e=b.size[0]*d,f=b.size[1]*d,g=b.viewState.rotation,h=eb(c),l=db(c),m=cb(c);c=bb(c);Bh(b.coordinateToPixelTransform,h);Bh(b.coordinateToPixelTransform,l);Bh(b.coordinateToPixelTransform,m);Bh(b.coordinateToPixelTransform,c);a.save();Qh(a,-g,e/2,f/2);a.beginPath();a.moveTo(h[0]*d,h[1]*d);a.lineTo(l[0]*d,l[1]*d);a.lineTo(m[0]*d,m[1]*d);a.lineTo(c[0]*d,c[1]*d);a.clip();Qh(a,g,e/2,f/2)}
	function ot(a,b,c,d,e){var f=a.a;if(Ec(f,b)){var g=d.size[0]*d.pixelRatio,h=d.size[1]*d.pixelRatio,l=d.viewState.rotation;Qh(c,-l,g/2,h/2);a=e?e:pt(a,d,0);f.b(new Mh(b,new Sh(c,d.pixelRatio,d.extent,a,d.viewState.rotation),d,c,null));Qh(c,l,g/2,h/2)}}mt.prototype.v=function(a,b,c,d){if(this.Aa(a,b,0,af,this))return c.call(d,this.a,null)};mt.prototype.Ue=function(a,b,c,d){ot(this,"postcompose",a,b,d)};
	function pt(a,b,c){var d=b.viewState,e=b.pixelRatio,f=e/d.resolution;return Fh(a.ia,e*b.size[0]/2,e*b.size[1]/2,f,-f,-d.rotation,-d.center[0]+c,-d.center[1])};function qt(a,b){return w(a)-w(b)}function rt(a,b){var c=.5*a/b;return c*c}function st(a,b,c,d,e,f){var g=!1,h,l;if(h=c.Z())l=h.Oe(),2==l||3==l?h.Yi(e,f):(0==l&&h.load(),h.zh(e,f),g=!0);if(e=(0,c.Ra)(b))d=e.Qd(d),(0,tt[d.T()])(a,d,c,b);return g}
	var tt={Point:function(a,b,c,d){var e=c.Z();if(e){if(2!=e.Oe())return;var f=a.b(c.za(),"Image");f.Vb(e);f.qc(b,d)}if(e=c.Pa())a=a.b(c.za(),"Text"),a.Tb(e),a.xc(b.ha(),0,2,2,b,d)},LineString:function(a,b,c,d){var e=c.Da();if(e){var f=a.b(c.za(),"LineString");f.Na(null,e);f.Qb(b,d)}if(e=c.Pa())a=a.b(c.za(),"Text"),a.Tb(e),a.xc(Zh(b),0,2,2,b,d)},Polygon:function(a,b,c,d){var e=c.Ca(),f=c.Da();if(e||f){var g=a.b(c.za(),"Polygon");g.Na(e,f);g.rc(b,d)}if(e=c.Pa())a=a.b(c.za(),"Text"),a.Tb(e),a.xc(Lf(b),
	0,2,2,b,d)},MultiPoint:function(a,b,c,d){var e=c.Z();if(e){if(2!=e.Oe())return;var f=a.b(c.za(),"Image");f.Vb(e);f.oc(b,d)}if(e=c.Pa())a=a.b(c.za(),"Text"),a.Tb(e),c=b.ha(),a.xc(c,0,c.length,b.sa(),b,d)},MultiLineString:function(a,b,c,d){var e=c.Da();if(e){var f=a.b(c.za(),"LineString");f.Na(null,e);f.nc(b,d)}if(e=c.Pa())a=a.b(c.za(),"Text"),a.Tb(e),c=$h(b),a.xc(c,0,c.length,2,b,d)},MultiPolygon:function(a,b,c,d){var e=c.Ca(),f=c.Da();if(f||e){var g=a.b(c.za(),"Polygon");g.Na(e,f);g.pc(b,d)}if(e=
	c.Pa())a=a.b(c.za(),"Text"),a.Tb(e),c=bi(b),a.xc(c,0,c.length,2,b,d)},GeometryCollection:function(a,b,c,d){b=b.a;var e,f;e=0;for(f=b.length;e<f;++e)(0,tt[b[e].T()])(a,b[e],c,d)},Circle:function(a,b,c,d){var e=c.Ca(),f=c.Da();if(e||f){var g=a.b(c.za(),"Circle");g.Na(e,f);g.$b(b,d)}if(e=c.Pa())a=a.b(c.za(),"Text"),a.Tb(e),a.xc(b.Ba(),0,2,2,b,d)}};function ut(a){mt.call(this,a);this.c=!1;this.u=-1;this.o=NaN;this.l=Ia();this.i=this.j=null;this.g=Xc()}u(ut,mt);
	ut.prototype.I=function(a,b,c){var d=a.extent,e=a.pixelRatio,f=b.De?a.skippedFeatureUids:{},g=a.viewState,h=g.projection,g=g.rotation,l=h.D(),m=this.a.la(),p=pt(this,a,0);ot(this,"precompose",c,a,p);var n=b.extent,q=void 0!==n;q&&nt(c,a,n);if((n=this.i)&&!n.f()){var r=0,v=0,x;if(Ec(this.a,"render")){x=c.canvas.width;var y=c.canvas.height;if(g){var z=Math.round(Math.sqrt(x*x+y*y)),r=(z-x)/2,v=(z-y)/2;x=y=z}this.g.canvas.width=x;this.g.canvas.height=y;x=this.g}else x=c;y=x.globalAlpha;x.globalAlpha=
	b.opacity;x!=c&&x.translate(r,v);var z=a.size[0]*e,A=a.size[1]*e;Qh(x,-g,z/2,A/2);n.i(x,e,p,g,f);if(m.G&&h.a&&!Ta(l,d)){for(var h=d[0],m=hb(l),V=0;h<l[0];)--V,p=m*V,p=pt(this,a,p),n.i(x,e,p,g,f),h+=m;V=0;for(h=d[2];h>l[2];)++V,p=m*V,p=pt(this,a,p),n.i(x,e,p,g,f),h-=m;p=pt(this,a,0)}Qh(x,g,z/2,A/2);x!=c&&(ot(this,"render",x,a,p),c.drawImage(x.canvas,-r,-v),x.translate(-r,-v));x.globalAlpha=y}q&&c.restore();this.Ue(c,a,b,p)};
	ut.prototype.Aa=function(a,b,c,d,e){if(this.i){var f=this.a,g={};return this.i.Aa(a,b.viewState.resolution,b.viewState.rotation,c,{},function(a){var b=w(a).toString();if(!(b in g))return g[b]=!0,d.call(e,a,f)})}};ut.prototype.A=function(){ft(this)};
	ut.prototype.qd=function(a){function b(a){var b,d=a.Nc();d?b=d.call(a,m):(d=c.i)&&(b=d(a,m));if(b){if(b){d=!1;if(Array.isArray(b))for(var e=0,f=b.length;e<f;++e)d=st(q,a,b[e],rt(m,p),this.A,this)||d;else d=st(q,a,b,rt(m,p),this.A,this)||d;a=d}else a=!1;this.c=this.c||a}}var c=this.a,d=c.la();it(a.attributions,d.l);jt(a,d);var e=a.viewHints[0],f=a.viewHints[1],g=c.ea,h=c.ia;if(!this.c&&!g&&e||!h&&f)return!0;var l=a.extent,h=a.viewState,e=h.projection,m=h.resolution,p=a.pixelRatio,f=c.f,n=c.c,g=c.get(vt);
	void 0===g&&(g=qt);l=Ka(l,n*m);n=h.projection.D();d.G&&h.projection.a&&!Ta(n,a.extent)&&(a=Math.max(hb(l)/2,hb(n)),l[0]=n[0]-a,l[2]=n[2]+a);if(!this.c&&this.o==m&&this.u==f&&this.j==g&&Ta(this.l,l))return!0;this.i=null;this.c=!1;var q=new Ws(.5*m/p,l,m,d.Ha,c.c);d.Ud(l,m,e);if(g){var r=[];d.ac(l,function(a){r.push(a)},this);r.sort(g);r.forEach(b,this)}else d.ac(l,b,this);$s(q);this.o=m;this.u=f;this.j=g;this.l=l;this.i=q;return!0};function wt(){this.b="precision mediump float;varying vec2 a;uniform float f;uniform sampler2D g;void main(void){vec4 texColor=texture2D(g,a);gl_FragColor.rgb=texColor.rgb;gl_FragColor.a=texColor.a*f;}"}u(wt,hi);var xt=new wt;function yt(){this.b="varying vec2 a;attribute vec2 b;attribute vec2 c;uniform mat4 d;uniform mat4 e;void main(void){gl_Position=e*vec4(b,0.,1.);a=(d*vec4(c,0.,1.)).st;}"}u(yt,ii);var zt=new yt;
	function At(a,b){this.f=a.getUniformLocation(b,"f");this.c=a.getUniformLocation(b,"e");this.g=a.getUniformLocation(b,"d");this.i=a.getUniformLocation(b,"g");this.b=a.getAttribLocation(b,"b");this.a=a.getAttribLocation(b,"c")};function Bt(a,b){dt.call(this,b);this.c=a;this.Y=new yi([-1,-1,0,0,1,-1,1,0,-1,1,0,1,1,1,1,1]);this.g=this.Fb=null;this.l=void 0;this.v=wh();this.u=wh();this.C=oi();this.I=null}u(Bt,dt);
	function Ct(a,b,c){var d=a.c.f;if(void 0===a.l||a.l!=c){b.postRenderFunctions.push(function(a,b,c){a.isContextLost()||(a.deleteFramebuffer(b),a.deleteTexture(c))}.bind(null,d,a.g,a.Fb));b=Li(d,c,c);var e=d.createFramebuffer();d.bindFramebuffer(36160,e);d.framebufferTexture2D(36160,36064,3553,b,0);a.Fb=b;a.g=e;a.l=c}else d.bindFramebuffer(36160,a.g)}
	Bt.prototype.ai=function(a,b,c){Dt(this,"precompose",c,a);ri(c,34962,this.Y);var d=c.b,e=Ci(c,xt,zt),f;this.I?f=this.I:this.I=f=new At(d,e);c.Rc(e)&&(d.enableVertexAttribArray(f.b),d.vertexAttribPointer(f.b,2,5126,!1,16,0),d.enableVertexAttribArray(f.a),d.vertexAttribPointer(f.a,2,5126,!1,16,8),d.uniform1i(f.i,0));d.uniformMatrix4fv(f.g,!1,pi(this.C,this.v));d.uniformMatrix4fv(f.c,!1,pi(this.C,this.u));d.uniform1f(f.f,b.opacity);d.bindTexture(3553,this.Fb);d.drawArrays(5,0,4);Dt(this,"postcompose",
	c,a)};function Dt(a,b,c,d){a=a.a;if(Ec(a,b)){var e=d.viewState;a.b(new Mh(b,new ik(c,e.center,e.resolution,e.rotation,d.size,d.extent,d.pixelRatio),d,null,c))}}Bt.prototype.$f=function(){this.g=this.Fb=null;this.l=void 0};function Et(a,b){Bt.call(this,a,b);this.o=!1;this.S=-1;this.R=NaN;this.A=Ia();this.j=this.i=this.G=null}u(Et,Bt);k=Et.prototype;k.ai=function(a,b,c){this.j=b;var d=a.viewState,e=this.i,f=a.size,g=a.pixelRatio,h=this.c.f;e&&!e.f()&&(h.enable(h.SCISSOR_TEST),h.scissor(0,0,f[0]*g,f[1]*g),e.i(c,d.center,d.resolution,d.rotation,f,g,b.opacity,b.De?a.skippedFeatureUids:{}),h.disable(h.SCISSOR_TEST))};k.ra=function(){var a=this.i;a&&(ck(a,this.c.i)(),this.i=null);Bt.prototype.ra.call(this)};
	k.Aa=function(a,b,c,d,e){if(this.i&&this.j){c=b.viewState;var f=this.a,g={};return this.i.Aa(a,this.c.i,c.center,c.resolution,c.rotation,b.size,b.pixelRatio,this.j.opacity,{},function(a){var b=w(a).toString();if(!(b in g))return g[b]=!0,d.call(e,a,f)})}};k.Ke=function(a,b){if(this.i&&this.j){var c=b.viewState;return hk(this.i,a,this.c.i,c.resolution,c.rotation,b.pixelRatio,this.j.opacity,b.skippedFeatureUids)}return!1};
	k.Zf=function(a,b,c,d){a=Bh(b.pixelToCoordinateTransform,a.slice());if(this.Ke(a,b))return c.call(d,this.a,null)};k.bi=function(){ft(this)};
	k.ag=function(a,b,c){function d(a){var b,c=a.Nc();c?b=c.call(a,m):(c=e.i)&&(b=c(a,m));if(b){if(b){c=!1;if(Array.isArray(b))for(var d=b.length-1;0<=d;--d)c=st(q,a,b[d],rt(m,p),this.bi,this)||c;else c=st(q,a,b,rt(m,p),this.bi,this)||c;a=c}else a=!1;this.o=this.o||a}}var e=this.a;b=e.la();it(a.attributions,b.l);jt(a,b);var f=a.viewHints[0],g=a.viewHints[1],h=e.ea,l=e.ia;if(!this.o&&!h&&f||!l&&g)return!0;var g=a.extent,h=a.viewState,f=h.projection,m=h.resolution,p=a.pixelRatio,h=e.f,n=e.c,l=e.get(vt);
	void 0===l&&(l=qt);g=Ka(g,n*m);if(!this.o&&this.R==m&&this.S==h&&this.G==l&&Ta(this.A,g))return!0;this.i&&a.postRenderFunctions.push(ck(this.i,c));this.o=!1;var q=new bk(.5*m/p,g,e.c);b.Ud(g,m,f);if(l){var r=[];b.ac(g,function(a){r.push(a)},this);r.sort(l);r.forEach(d,this)}else b.ac(g,d,this);dk(q,c);this.R=m;this.S=h;this.G=l;this.A=g;this.i=q;return!0};function R(a){a=a?a:{};var b=pb({},a);delete b.style;delete b.renderBuffer;delete b.updateWhileAnimating;delete b.updateWhileInteracting;rh.call(this,b);this.c=void 0!==a.renderBuffer?a.renderBuffer:100;this.A=null;this.i=void 0;this.g(a.style);this.ea=void 0!==a.updateWhileAnimating?a.updateWhileAnimating:!1;this.ia=void 0!==a.updateWhileInteracting?a.updateWhileInteracting:!1}u(R,rh);R.prototype.Dd=function(a){var b=null,c=a.T();"canvas"===c?b=new ut(this):"webgl"===c&&(b=new Et(a,this));return b};
	R.prototype.C=function(){return this.A};R.prototype.G=function(){return this.i};R.prototype.g=function(a){this.A=void 0!==a?a:dl;this.i=null===a?void 0:bl(this.A);this.s()};var vt="renderOrder";function Ft(){return[[-Infinity,-Infinity,Infinity,Infinity]]};function Gt(a){Gc.call(this);this.c=Gb(a.projection);this.l=Ht(a.attributions);this.R=a.logo;this.Ja=void 0!==a.state?a.state:"ready";this.G=void 0!==a.wrapX?a.wrapX:!1}u(Gt,Gc);function Ht(a){if("string"===typeof a)return[new nc({html:a})];if(a instanceof nc)return[a];if(Array.isArray(a)){for(var b=a.length,c=Array(b),d=0;d<b;d++){var e=a[d];c[d]="string"===typeof e?new nc({html:e}):e}return c}return null}k=Gt.prototype;k.Aa=na;k.xa=function(){return this.l};k.wa=function(){return this.R};k.ya=function(){return this.c};
	k.V=function(){return this.Ja};k.va=function(){this.s()};k.ua=function(a){this.l=Ht(a);this.s()};function It(a,b){a.Ja=b;a.s()};function S(a){a=a||{};Gt.call(this,{attributions:a.attributions,logo:a.logo,projection:void 0,state:"ready",wrapX:void 0!==a.wrapX?a.wrapX:!0});this.Y=na;this.S=a.format;this.Ha=void 0==a.overlaps?!0:a.overlaps;this.ea=a.url;a.loader?this.Y=a.loader:void 0!==this.ea&&(qa(this.S,7),this.Y=Bl(this.ea,this.S));this.Bd=a.strategy?a.strategy:Ft;var b=void 0!==a.useSpatialIndex?a.useSpatialIndex:!0;this.a=b?new Ej:null;this.oa=new Ej;this.g={};this.j={};this.o={};this.v={};this.i=null;var c,d;a.features instanceof
	D?(c=a.features,d=c.a):Array.isArray(a.features)&&(d=a.features);b||c||(c=new D(d));d&&Jt(this,d);c&&Kt(this,c)}u(S,Gt);k=S.prototype;k.zb=function(a){var b=w(a).toString();if(Lt(this,b,a)){Mt(this,b,a);var c=a.U();c?(b=c.D(),this.a&&this.a.Ea(b,a)):this.g[b]=a;this.b(new Nt("addfeature",a))}this.s()};function Mt(a,b,c){a.v[b]=[B(c,"change",a.ji,a),B(c,"propertychange",a.ji,a)]}
	function Lt(a,b,c){var d=!0,e=c.a;void 0!==e?e.toString()in a.j?d=!1:a.j[e.toString()]=c:(qa(!(b in a.o),30),a.o[b]=c);return d}k.dd=function(a){Jt(this,a);this.s()};function Jt(a,b){var c,d,e,f,g=[],h=[],l=[];d=0;for(e=b.length;d<e;d++)f=b[d],c=w(f).toString(),Lt(a,c,f)&&h.push(f);d=0;for(e=h.length;d<e;d++){f=h[d];c=w(f).toString();Mt(a,c,f);var m=f.U();m?(c=m.D(),g.push(c),l.push(f)):a.g[c]=f}a.a&&a.a.load(g,l);d=0;for(e=h.length;d<e;d++)a.b(new Nt("addfeature",h[d]))}
	function Kt(a,b){var c=!1;B(a,"addfeature",function(a){c||(c=!0,b.push(a.feature),c=!1)});B(a,"removefeature",function(a){c||(c=!0,b.remove(a.feature),c=!1)});B(b,"add",function(a){c||(c=!0,this.zb(a.element),c=!1)},a);B(b,"remove",function(a){c||(c=!0,this.Db(a.element),c=!1)},a);a.i=b}
	k.clear=function(a){if(a){for(var b in this.v)this.v[b].forEach(rc);this.i||(this.v={},this.j={},this.o={})}else if(this.a){this.a.forEach(this.ug,this);for(var c in this.g)this.ug(this.g[c])}this.i&&this.i.clear();this.a&&this.a.clear();this.oa.clear();this.g={};this.b(new Nt("clear"));this.s()};k.bh=function(a,b){if(this.a)return this.a.forEach(a,b);if(this.i)return this.i.forEach(a,b)};function Ot(a,b,c){a.ac([b[0],b[1],b[0],b[1]],function(a){if(a.U().sb(b))return c.call(void 0,a)})}
	k.ac=function(a,b,c){if(this.a)return Jj(this.a,a,b,c);if(this.i)return this.i.forEach(b,c)};k.dh=function(a,b,c){return this.ac(a,function(d){if(d.U().Xa(a)&&(d=b.call(c,d)))return d})};k.lh=function(){return this.i};k.Ne=function(){var a;this.i?a=this.i.a:this.a&&(a=Gj(this.a),sb(this.g)||ga(a,rb(this.g)));return a};k.kh=function(a){var b=[];Ot(this,a,function(a){b.push(a)});return b};k.Hf=function(a){return Hj(this.a,a)};
	k.gh=function(a,b){var c=a[0],d=a[1],e=null,f=[NaN,NaN],g=Infinity,h=[-Infinity,-Infinity,Infinity,Infinity],l=b?b:af;Jj(this.a,h,function(a){if(l(a)){var b=a.U(),m=g;g=b.Gb(c,d,f,g);g<m&&(e=a,a=Math.sqrt(g),h[0]=c-a,h[1]=d-a,h[2]=c+a,h[3]=d+a)}});return e};k.D=function(){return this.a.D()};k.jh=function(a){a=this.j[a.toString()];return void 0!==a?a:null};k.hi=function(){return this.S};k.ii=function(){return this.ea};
	k.ji=function(a){a=a.target;var b=w(a).toString(),c=a.U();c?(c=c.D(),b in this.g?(delete this.g[b],this.a&&this.a.Ea(c,a)):this.a&&Fj(this.a,c,a)):b in this.g||(this.a&&this.a.remove(a),this.g[b]=a);c=a.a;void 0!==c?(c=c.toString(),b in this.o?(delete this.o[b],this.j[c]=a):this.j[c]!==a&&(Pt(this,a),this.j[c]=a)):b in this.o||(Pt(this,a),this.o[b]=a);this.s();this.b(new Nt("changefeature",a))};
	k.Ud=function(a,b,c){var d=this.oa;a=this.Bd(a,b);var e,f;e=0;for(f=a.length;e<f;++e){var g=a[e];Jj(d,g,function(a){return Ta(a.extent,g)})||(this.Y.call(this,g,b,c),d.Ea(g,{extent:g.slice()}))}};k.Db=function(a){var b=w(a).toString();b in this.g?delete this.g[b]:this.a&&this.a.remove(a);this.ug(a);this.s()};k.ug=function(a){var b=w(a).toString();this.v[b].forEach(rc);delete this.v[b];var c=a.a;void 0!==c?delete this.j[c.toString()]:delete this.o[b];this.b(new Nt("removefeature",a))};
	function Pt(a,b){for(var c in a.j)if(a.j[c]===b){delete a.j[c];break}}function Nt(a,b){Bc.call(this,a);this.feature=b}u(Nt,Bc);function Qt(a){pg.call(this,{handleDownEvent:Rt,handleEvent:St,handleUpEvent:Tt});this.ea=null;this.u=!1;this.lb=a.source?a.source:null;this.Ha=a.features?a.features:null;this.ak=a.snapTolerance?a.snapTolerance:12;this.S=a.type;this.g=Ut(this.S);this.Ja=a.minPoints?a.minPoints:this.g===Vt?3:2;this.oa=a.maxPoints?a.maxPoints:Infinity;this.Bd=a.finishCondition?a.finishCondition:af;var b=a.geometryFunction;if(!b)if("Circle"===this.S)b=function(a,b){var c=b?b:new is([NaN,NaN]);c.yg(a[0],Math.sqrt(Xe(a[0],
	a[1])));return c};else{var c,d=this.g;d===Wt?c=E:d===Xt?c=M:d===Vt&&(c=F);b=function(a,b){var e=b;e?d===Vt?e.pa([a[0].concat([a[0][0]])]):e.pa(a):e=new c(a);return e}}this.Ra=b;this.R=this.C=this.a=this.G=this.j=this.o=null;this.mb=a.clickTolerance?a.clickTolerance*a.clickTolerance:36;this.ia=new R({source:new S({useSpatialIndex:!1,wrapX:a.wrapX?a.wrapX:!1}),style:a.style?a.style:Yt()});this.Oa=a.geometryName;this.Yj=a.condition?a.condition:kg;this.rf=a.freehand?af:a.freehandCondition?a.freehandCondition:
	lg;B(this,Ic("active"),this.aj,this)}u(Qt,pg);function Yt(){var a=el();return function(b){return a[b.U().T()]}}k=Qt.prototype;k.setMap=function(a){pg.prototype.setMap.call(this,a);this.aj()};function St(a){this.u=this.g!==Wt&&this.rf(a);var b=!this.u;this.u&&"pointerdrag"===a.type&&null!==this.j?(Zt(this,a),b=!1):"pointermove"===a.type?b=$t(this,a):"dblclick"===a.type&&(b=!1);return qg.call(this,a)&&b}
	function Rt(a){return this.u?(this.ea=a.pixel,this.o||au(this,a),!0):this.Yj(a)?(this.ea=a.pixel,!0):!1}function Tt(a){var b=this.ea,c=a.pixel,d=b[0]-c[0],b=b[1]-c[1],d=d*d+b*b,b=!0,c=this.g===bu;(this.u?d>this.mb:d<=this.mb)?($t(this,a),this.o?this.u||c?this.Nd():cu(this,a)?this.Bd(a)&&this.Nd():Zt(this,a):(au(this,a),this.g===Wt&&this.Nd()),b=!1):c&&(this.o=null);return b}
	function $t(a,b){if(a.o){var c=b.coordinate,d=a.j.U(),e;a.g===Wt?e=a.a:a.g===Vt?(e=a.a[0],e=e[e.length-1],cu(a,b)&&(c=a.o.slice())):(e=a.a,e=e[e.length-1]);e[0]=c[0];e[1]=c[1];a.Ra(a.a,d);a.G&&a.G.U().pa(c);d instanceof F&&a.g!==Vt?(a.C||(a.C=new H(new M(null))),d=d.nh(0),c=a.C.U(),c.ca(d.ka,d.ha())):a.R&&(c=a.C.U(),c.pa(a.R));du(a)}else c=b.coordinate.slice(),a.G?a.G.U().pa(c):(a.G=new H(new E(c)),du(a));return!0}
	function cu(a,b){var c=!1;if(a.j){var d=!1,e=[a.o];a.g===Xt?d=a.a.length>a.Ja:a.g===Vt&&(d=a.a[0].length>a.Ja,e=[a.a[0][0],a.a[0][a.a[0].length-2]]);if(d)for(var d=b.map,f=0,g=e.length;f<g;f++){var h=e[f],l=d.Ka(h),m=b.pixel,c=m[0]-l[0],l=m[1]-l[1];if(c=Math.sqrt(c*c+l*l)<=(a.u?1:a.ak)){a.o=h;break}}}return c}
	function au(a,b){var c=b.coordinate;a.o=c;a.g===Wt?a.a=c.slice():a.g===Vt?(a.a=[[c.slice(),c.slice()]],a.R=a.a[0]):(a.a=[c.slice(),c.slice()],a.g===bu&&(a.R=a.a));a.R&&(a.C=new H(new M(a.R)));c=a.Ra(a.a);a.j=new H;a.Oa&&a.j.Vc(a.Oa);a.j.Sa(c);du(a);a.b(new eu("drawstart",a.j))}
	function Zt(a,b){var c=b.coordinate,d=a.j.U(),e,f;a.g===Xt?(a.o=c.slice(),f=a.a,f.length>=a.oa&&(a.u?f.pop():e=!0),f.push(c.slice()),a.Ra(f,d)):a.g===Vt&&(f=a.a[0],f.length>=a.oa&&(a.u?f.pop():e=!0),f.push(c.slice()),e&&(a.o=f[0]),a.Ra(a.a,d));du(a);e&&a.Nd()}k.cp=function(){var a=this.j.U(),b,c;this.g===Xt?(b=this.a,b.splice(-2,1),this.Ra(b,a)):this.g===Vt&&(b=this.a[0],b.splice(-2,1),c=this.C.U(),c.pa(b),this.Ra(this.a,a));0===b.length&&(this.o=null);du(this)};
	k.Nd=function(){var a=fu(this),b=this.a,c=a.U();this.g===Xt?(b.pop(),this.Ra(b,c)):this.g===Vt&&(b[0].pop(),this.Ra(b,c),b=c.X());"MultiPoint"===this.S?a.Sa(new O([b])):"MultiLineString"===this.S?a.Sa(new N([b])):"MultiPolygon"===this.S&&a.Sa(new P([b]));this.b(new eu("drawend",a));this.Ha&&this.Ha.push(a);this.lb&&this.lb.zb(a)};function fu(a){a.o=null;var b=a.j;b&&(a.j=null,a.G=null,a.C=null,a.ia.la().clear(!0));return b}
	k.Om=function(a){var b=a.U();this.j=a;this.a=b.X();a=this.a[this.a.length-1];this.o=a.slice();this.a.push(a.slice());du(this);this.b(new eu("drawstart",this.j))};k.Zc=bf;function du(a){var b=[];a.j&&b.push(a.j);a.C&&b.push(a.C);a.G&&b.push(a.G);a=a.ia.la();a.clear(!0);a.dd(b)}k.aj=function(){var a=this.v,b=this.c();a&&b||fu(this);this.ia.setMap(b?a:null)};
	function Ut(a){var b;"Point"===a||"MultiPoint"===a?b=Wt:"LineString"===a||"MultiLineString"===a?b=Xt:"Polygon"===a||"MultiPolygon"===a?b=Vt:"Circle"===a&&(b=bu);return b}var Wt="Point",Xt="LineString",Vt="Polygon",bu="Circle";function eu(a,b){Bc.call(this,a);this.feature=b}u(eu,Bc);function gu(a){this.a=this.j=null;this.C=!1;this.G=this.o=null;a||(a={});a.extent&&this.g(a.extent);pg.call(this,{handleDownEvent:hu,handleDragEvent:iu,handleEvent:ju,handleUpEvent:ku});this.u=new R({source:new S({useSpatialIndex:!1,wrapX:!!a.wrapX}),style:a.boxStyle?a.boxStyle:lu(),updateWhileAnimating:!0,updateWhileInteracting:!0});this.R=new R({source:new S({useSpatialIndex:!1,wrapX:!!a.wrapX}),style:a.pointerStyle?a.pointerStyle:mu(),updateWhileAnimating:!0,updateWhileInteracting:!0})}u(gu,pg);
	function ju(a){if(!(a instanceof Bd))return!0;if("pointermove"==a.type&&!this.A){var b=a.pixel,c=a.map,d=nu(this,b,c);d||(d=c.Za(b));ou(this,d)}qg.call(this,a);return!1}
	function hu(a){function b(a){var b=null,c=null;a[0]==e[0]?b=e[2]:a[0]==e[2]&&(b=e[0]);a[1]==e[1]?c=e[3]:a[1]==e[3]&&(c=e[1]);return null!==b&&null!==c?[b,c]:null}var c=a.pixel,d=a.map,e=this.D();(a=nu(this,c,d))&&e?(c=a[0]==e[0]||a[0]==e[2]?a[0]:null,d=a[1]==e[1]||a[1]==e[3]?a[1]:null,null!==c&&null!==d?this.a=pu(b(a)):null!==c?this.a=qu(b([c,e[1]]),b([c,e[3]])):null!==d&&(this.a=qu(b([e[0],d]),b([e[2],d])))):(a=d.Za(c),this.g([a[0],a[1],a[0],a[1]]),this.a=pu(a));return!0}
	function iu(a){this.a&&(a=a.coordinate,this.g(this.a(a)),ou(this,a));return!0}function ku(){this.a=null;var a=this.D();a&&fb(a)||this.g(null);return!1}function lu(){var a=el();return function(){return a.Polygon}}function mu(){var a=el();return function(){return a.Point}}function pu(a){return function(b){return Ha([a,b])}}function qu(a,b){return a[0]==b[0]?function(c){return Ha([a,[c[0],b[1]]])}:a[1]==b[1]?function(c){return Ha([a,[b[0],c[1]]])}:null}
	function nu(a,b,c){function d(a,b){return Ze(e,a)-Ze(e,b)}var e=c.Za(b),f=a.D();if(f){f=[[[f[0],f[1]],[f[0],f[3]]],[[f[0],f[3]],[f[2],f[3]]],[[f[2],f[3]],[f[2],f[1]]],[[f[2],f[1]],[f[0],f[1]]]];f.sort(d);var f=f[0],g=Re(e,f),h=c.Ka(g);if(10>=Ye(b,h))return b=c.Ka(f[0]),c=c.Ka(f[1]),b=Xe(h,b),c=Xe(h,c),a.C=10>=Math.sqrt(Math.min(b,c)),a.C&&(g=b>c?f[1]:f[0]),g}return null}function ou(a,b){var c=a.G;c?c.U().pa(b):(c=new H(new E(b)),a.G=c,a.R.la().zb(c))}
	gu.prototype.setMap=function(a){this.u.setMap(a);this.R.setMap(a);pg.prototype.setMap.call(this,a)};gu.prototype.D=function(){return this.j};gu.prototype.g=function(a){this.j=a?a:null;var b=this.o;b?a?b.Sa(Nf(a)):b.Sa(void 0):(this.o=b=a?new H(Nf(a)):new H({}),this.u.la().zb(b));this.b(new ru(this.j))};function ru(a){Bc.call(this,su);this.b=a}u(ru,Bc);var su="extentchanged";function tu(a){pg.call(this,{handleDownEvent:uu,handleDragEvent:vu,handleEvent:wu,handleUpEvent:xu});this.mb=a.condition?a.condition:og;this.Oa=function(a){return kg(a)&&jg(a)};this.lb=a.deleteCondition?a.deleteCondition:this.Oa;this.Ha=this.g=null;this.Ja=[0,0];this.C=this.R=!1;this.a=new Ej;this.ia=void 0!==a.pixelTolerance?a.pixelTolerance:10;this.o=this.oa=!1;this.j=[];this.G=new R({source:new S({useSpatialIndex:!1,wrapX:!!a.wrapX}),style:a.style?a.style:yu(),updateWhileAnimating:!0,updateWhileInteracting:!0});
	this.ea={Point:this.Vm,LineString:this.Oh,LinearRing:this.Oh,Polygon:this.Wm,MultiPoint:this.Tm,MultiLineString:this.Sm,MultiPolygon:this.Um,Circle:this.Ip,GeometryCollection:this.Rm};this.u=a.features;this.u.forEach(this.Yf,this);B(this.u,"add",this.Pm,this);B(this.u,"remove",this.Qm,this);this.S=null}u(tu,pg);k=tu.prototype;k.Yf=function(a){var b=a.U();b&&b.T()in this.ea&&this.ea[b.T()].call(this,a,b);(b=this.v)&&b.a&&this.c()&&zu(this,this.Ja,b);B(a,"change",this.Nh,this)};
	function Au(a,b){a.C||(a.C=!0,a.b(new Bu("modifystart",a.u,b)))}function Cu(a,b){Du(a,b);a.g&&!a.u.ec()&&(a.G.la().Db(a.g),a.g=null);xc(b,"change",a.Nh,a)}function Du(a,b){var c=a.a,d=[];c.forEach(function(a){b===a.feature&&d.push(a)});for(var e=d.length-1;0<=e;--e)c.remove(d[e])}k.Ia=function(a){this.g&&!a&&(this.G.la().Db(this.g),this.g=null);pg.prototype.Ia.call(this,a)};k.setMap=function(a){this.G.setMap(a);pg.prototype.setMap.call(this,a)};k.Pm=function(a){this.Yf(a.element)};
	k.Nh=function(a){this.o||(a=a.target,Cu(this,a),this.Yf(a))};k.Qm=function(a){Cu(this,a.element)};k.Vm=function(a,b){var c=b.X(),c={feature:a,geometry:b,na:[c,c]};this.a.Ea(b.D(),c)};k.Tm=function(a,b){var c=b.X(),d,e,f;e=0;for(f=c.length;e<f;++e)d=c[e],d={feature:a,geometry:b,depth:[e],index:e,na:[d,d]},this.a.Ea(b.D(),d)};k.Oh=function(a,b){var c=b.X(),d,e,f,g;d=0;for(e=c.length-1;d<e;++d)f=c.slice(d,d+2),g={feature:a,geometry:b,index:d,na:f},this.a.Ea(Ha(f),g)};
	k.Sm=function(a,b){var c=b.X(),d,e,f,g,h,l,m;g=0;for(h=c.length;g<h;++g)for(d=c[g],e=0,f=d.length-1;e<f;++e)l=d.slice(e,e+2),m={feature:a,geometry:b,depth:[g],index:e,na:l},this.a.Ea(Ha(l),m)};k.Wm=function(a,b){var c=b.X(),d,e,f,g,h,l,m;g=0;for(h=c.length;g<h;++g)for(d=c[g],e=0,f=d.length-1;e<f;++e)l=d.slice(e,e+2),m={feature:a,geometry:b,depth:[g],index:e,na:l},this.a.Ea(Ha(l),m)};
	k.Um=function(a,b){var c=b.X(),d,e,f,g,h,l,m,p,n,q;l=0;for(m=c.length;l<m;++l)for(p=c[l],g=0,h=p.length;g<h;++g)for(d=p[g],e=0,f=d.length-1;e<f;++e)n=d.slice(e,e+2),q={feature:a,geometry:b,depth:[g,l],index:e,na:n},this.a.Ea(Ha(n),q)};k.Ip=function(a,b){var c=b.Ba(),d={feature:a,geometry:b,index:0,na:[c,c]},e={feature:a,geometry:b,index:1,na:[c,c]};d.Ef=e.Ef=[d,e];this.a.Ea(Wa(c),d);this.a.Ea(b.D(),e)};k.Rm=function(a,b){var c,d=b.a;for(c=0;c<d.length;++c)this.ea[d[c].T()].call(this,a,d[c])};
	function Eu(a,b){var c=a.g;c?c.U().pa(b):(c=new H(new E(b)),a.g=c,a.G.la().zb(c))}function Fu(a,b){return a.index-b.index}
	function uu(a){if(!this.mb(a))return!1;zu(this,a.pixel,a.map);this.j.length=0;this.C=!1;var b=this.g;if(b){var c=[],b=b.U().X(),d=Ha([b]),d=Hj(this.a,d),e={};d.sort(Fu);for(var f=0,g=d.length;f<g;++f){var h=d[f],l=h.na,m=w(h.feature),p=h.depth;p&&(m+="-"+p.join("-"));e[m]||(e[m]=Array(2));if("Circle"===h.geometry.T()&&1===h.index)l=Gu(b,h),Ue(l,b)&&!e[m][0]&&(this.j.push([h,0]),e[m][0]=h);else if(Ue(l[0],b)&&!e[m][0])this.j.push([h,0]),e[m][0]=h;else if(Ue(l[1],b)&&!e[m][1]){if("LineString"!==h.geometry.T()&&
	"MultiLineString"!==h.geometry.T()||!e[m][0]||0!==e[m][0].index)this.j.push([h,1]),e[m][1]=h}else w(l)in this.Ha&&!e[m][0]&&!e[m][1]&&c.push([h,b])}c.length&&Au(this,a);for(a=c.length-1;0<=a;--a)this.Il.apply(this,c[a])}return!!this.g}
	function vu(a){this.R=!1;Au(this,a);a=a.coordinate;for(var b=0,c=this.j.length;b<c;++b){for(var d=this.j[b],e=d[0],f=e.depth,g=e.geometry,h,l=e.na,d=d[1];a.length<g.sa();)a.push(l[d][a.length]);switch(g.T()){case "Point":h=a;l[0]=l[1]=a;break;case "MultiPoint":h=g.X();h[e.index]=a;l[0]=l[1]=a;break;case "LineString":h=g.X();h[e.index+d]=a;l[d]=a;break;case "MultiLineString":h=g.X();h[f[0]][e.index+d]=a;l[d]=a;break;case "Polygon":h=g.X();h[f[0]][e.index+d]=a;l[d]=a;break;case "MultiPolygon":h=g.X();
	h[f[1]][f[0]][e.index+d]=a;l[d]=a;break;case "Circle":l[0]=l[1]=a,0===e.index?(this.o=!0,g.wb(a)):(this.o=!0,g.Wc(Ye(g.Ba(),a))),this.o=!1}h&&(e=g,f=h,this.o=!0,e.pa(f),this.o=!1)}Eu(this,a)}function xu(a){for(var b,c,d=this.j.length-1;0<=d;--d)if(b=this.j[d][0],c=b.geometry,"Circle"===c.T()){var e=c.Ba(),f=b.Ef[0];b=b.Ef[1];f.na[0]=f.na[1]=e;b.na[0]=b.na[1]=e;Fj(this.a,Wa(e),f);Fj(this.a,c.D(),b)}else Fj(this.a,Ha(b.na),b);this.C&&(this.b(new Bu("modifyend",this.u,a)),this.C=!1);return!1}
	function wu(a){if(!(a instanceof Bd))return!0;this.S=a;var b;ld(a.map.$())[1]||"pointermove"!=a.type||this.A||(this.Ja=a.pixel,zu(this,a.pixel,a.map));this.g&&this.lb(a)&&(b="singleclick"==a.type&&this.R?!0:this.Ci());"singleclick"==a.type&&(this.R=!1);return qg.call(this,a)&&!b}
	function zu(a,b,c){function d(a,b){return Hu(e,a)-Hu(e,b)}var e=c.Za(b),f=Ka(Wa(e),c.$().Ua()*a.ia),f=Hj(a.a,f);if(0<f.length){f.sort(d);var g=f[0],h=g.na,l=Gu(e,g),m=c.Ka(l),p=Ye(b,m);if(p<=a.ia){b={};if("Circle"===g.geometry.T()&&1===g.index)a.oa=!0,Eu(a,l);else for(p=c.Ka(h[0]),g=c.Ka(h[1]),c=Xe(m,p),m=Xe(m,g),p=Math.sqrt(Math.min(c,m)),a.oa=p<=a.ia,a.oa&&(l=c>m?h[1]:h[0]),Eu(a,l),m=1,c=f.length;m<c;++m)if(l=f[m].na,Ue(h[0],l[0])&&Ue(h[1],l[1])||Ue(h[0],l[1])&&Ue(h[1],l[0]))b[w(l)]=!0;else break;
	b[w(h)]=!0;a.Ha=b;return}}a.g&&(a.G.la().Db(a.g),a.g=null)}function Hu(a,b){var c=b.geometry;if("Circle"===c.T()&&1===b.index){var d=Xe(c.Ba(),a),c=Math.sqrt(d)-c.Vd();return c*c}return Ze(a,b.na)}function Gu(a,b){var c=b.geometry;return"Circle"===c.T()&&1===b.index?c.Ab(a):Re(a,b.na)}
	k.Il=function(a,b){for(var c=a.na,d=a.feature,e=a.geometry,f=a.depth,g=a.index,h;b.length<e.sa();)b.push(0);switch(e.T()){case "MultiLineString":h=e.X();h[f[0]].splice(g+1,0,b);break;case "Polygon":h=e.X();h[f[0]].splice(g+1,0,b);break;case "MultiPolygon":h=e.X();h[f[1]][f[0]].splice(g+1,0,b);break;case "LineString":h=e.X();h.splice(g+1,0,b);break;default:return}this.o=!0;e.pa(h);this.o=!1;h=this.a;h.remove(a);Iu(this,e,g,f,1);var l={na:[c[0],b],feature:d,geometry:e,depth:f,index:g};h.Ea(Ha(l.na),
	l);this.j.push([l,1]);c={na:[b,c[1]],feature:d,geometry:e,depth:f,index:g+1};h.Ea(Ha(c.na),c);this.j.push([c,0]);this.R=!0};
	k.Ci=function(){if(this.S&&"pointerdrag"!=this.S.type){var a=this.S;Au(this,a);var b=this.j,c={},d,e,f,g,h,l,m,p,n;for(h=b.length-1;0<=h;--h)g=b[h],p=g[0],n=w(p.feature),p.depth&&(n+="-"+p.depth.join("-")),n in c||(c[n]={}),0===g[1]?(c[n].right=p,c[n].index=p.index):1==g[1]&&(c[n].left=p,c[n].index=p.index+1);for(n in c){m=c[n].right;h=c[n].left;g=c[n].index;l=g-1;p=void 0!==h?h:m;0>l&&(l=0);b=p.geometry;e=f=b.X();d=!1;switch(b.T()){case "MultiLineString":2<f[p.depth[0]].length&&(f[p.depth[0]].splice(g,
	1),d=!0);break;case "LineString":2<f.length&&(f.splice(g,1),d=!0);break;case "MultiPolygon":e=e[p.depth[1]];case "Polygon":e=e[p.depth[0]],4<e.length&&(g==e.length-1&&(g=0),e.splice(g,1),d=!0,0===g&&(e.pop(),e.push(e[0]),l=e.length-1))}d&&(d=b,this.o=!0,d.pa(f),this.o=!1,f=[],void 0!==h&&(this.a.remove(h),f.push(h.na[0])),void 0!==m&&(this.a.remove(m),f.push(m.na[1])),void 0!==h&&void 0!==m&&(h={depth:p.depth,feature:p.feature,geometry:p.geometry,index:l,na:f},this.a.Ea(Ha(h.na),h)),Iu(this,b,g,p.depth,
	-1),this.g&&(this.G.la().Db(this.g),this.g=null))}this.b(new Bu("modifyend",this.u,a));this.C=!1;return!0}return!1};function Iu(a,b,c,d,e){Jj(a.a,b.D(),function(a){a.geometry===b&&(void 0===d||void 0===a.depth||ia(a.depth,d))&&a.index>c&&(a.index+=e)})}function yu(){var a=el();return function(){return a.Point}}function Bu(a,b,c){Bc.call(this,a);this.features=b;this.mapBrowserEvent=c}u(Bu,Bc);function Ju(a){ag.call(this,{handleEvent:Ku});a=a?a:{};this.C=a.condition?a.condition:jg;this.A=a.addCondition?a.addCondition:bf;this.G=a.removeCondition?a.removeCondition:bf;this.R=a.toggleCondition?a.toggleCondition:lg;this.o=a.multi?a.multi:!1;this.j=a.filter?a.filter:af;this.l=a.hitTolerance?a.hitTolerance:0;this.g=new R({source:new S({useSpatialIndex:!1,features:a.features,wrapX:a.wrapX}),style:a.style?a.style:Lu(),updateWhileAnimating:!0,updateWhileInteracting:!0});if(a.layers)if("function"===
	typeof a.layers)a=a.layers;else{var b=a.layers;a=function(a){return ea(b,a)}}else a=af;this.u=a;this.a={};a=this.g.la().i;B(a,"add",this.Xm,this);B(a,"remove",this.an,this)}u(Ju,ag);k=Ju.prototype;k.Ym=function(){return this.g.la().i};k.Zm=function(){return this.l};k.$m=function(a){a=w(a);return this.a[a]};
	function Ku(a){if(!this.C(a))return!0;var b=this.A(a),c=this.G(a),d=this.R(a),e=!b&&!c&&!d,f=a.map,g=this.g.la().i,h=[],l=[];if(e){qb(this.a);f.re(a.pixel,function(a,b){if(this.j(a,b)){l.push(a);var c=w(a);this.a[c]=b;return!this.o}}.bind(this),{layerFilter:this.u,hitTolerance:this.l});for(e=g.ec()-1;0<=e;--e){var f=g.item(e),m=l.indexOf(f);-1<m?l.splice(m,1):(g.remove(f),h.push(f))}l.length&&g.Tf(l)}else{f.re(a.pixel,function(a,e){if(this.j(a,e)){if(!b&&!d||ea(g.a,a))(c||d)&&ea(g.a,a)&&(h.push(a),
	f=w(a),delete this.a[f]);else{l.push(a);var f=w(a);this.a[f]=e}return!this.o}}.bind(this),{layerFilter:this.u,hitTolerance:this.l});for(e=h.length-1;0<=e;--e)g.remove(h[e]);g.Tf(l)}(0<l.length||0<h.length)&&this.b(new Mu(Nu,l,h,a));return ig(a)}k.bn=function(a){this.l=a};k.setMap=function(a){var b=this.v,c=this.g.la().i;b&&c.forEach(b.Zi,b);ag.prototype.setMap.call(this,a);this.g.setMap(a);a&&c.forEach(a.Ti,a)};
	function Lu(){var a=el();ga(a.Polygon,a.LineString);ga(a.GeometryCollection,a.LineString);return function(b){return b.U()?a[b.U().T()]:null}}k.Xm=function(a){var b=this.v;b&&b.Ti(a.element)};k.an=function(a){var b=this.v;b&&b.Zi(a.element)};function Mu(a,b,c,d){Bc.call(this,a);this.selected=b;this.deselected=c;this.mapBrowserEvent=d}u(Mu,Bc);var Nu="select";function Ou(a){pg.call(this,{handleEvent:Pu,handleDownEvent:af,handleUpEvent:Qu});a=a?a:{};this.o=a.source?a.source:null;this.ia=void 0!==a.vertex?a.vertex:!0;this.R=void 0!==a.edge?a.edge:!0;this.j=a.features?a.features:null;this.oa=[];this.C={};this.S={};this.u={};this.G=null;this.g=void 0!==a.pixelTolerance?a.pixelTolerance:10;this.Ja=Ru.bind(this);this.a=new Ej;this.ea={Point:this.hn,LineString:this.Rh,LinearRing:this.Rh,Polygon:this.jn,MultiPoint:this.fn,MultiLineString:this.en,MultiPolygon:this.gn,
	GeometryCollection:this.dn}}u(Ou,pg);k=Ou.prototype;k.zb=function(a,b){var c=void 0!==b?b:!0,d=w(a),e=a.U();if(e){var f=this.ea[e.T()];f&&(this.S[d]=e.D(Ia()),f.call(this,a,e))}c&&(this.C[d]=B(a,"change",this.cn,this))};k.ek=function(a){this.zb(a)};k.fk=function(a){this.Db(a)};k.Ph=function(a){var b;a instanceof Nt?b=a.feature:a instanceof Nc&&(b=a.element);this.zb(b)};k.Qh=function(a){var b;a instanceof Nt?b=a.feature:a instanceof Nc&&(b=a.element);this.Db(b)};
	k.cn=function(a){a=a.target;if(this.A){var b=w(a);b in this.u||(this.u[b]=a)}else this.$i(a)};k.Db=function(a,b){var c=void 0!==b?b:!0,d=w(a),e=this.S[d];if(e){var f=this.a,g=[];Jj(f,e,function(b){a===b.feature&&g.push(b)});for(e=g.length-1;0<=e;--e)f.remove(g[e])}c&&(rc(this.C[d]),delete this.C[d])};
	k.setMap=function(a){var b=this.v,c=this.oa,d;this.j?d=this.j:this.o&&(d=this.o.Ne());b&&(c.forEach(rc),c.length=0,d.forEach(this.fk,this));pg.prototype.setMap.call(this,a);a&&(this.j?c.push(B(this.j,"add",this.Ph,this),B(this.j,"remove",this.Qh,this)):this.o&&c.push(B(this.o,"addfeature",this.Ph,this),B(this.o,"removefeature",this.Qh,this)),d.forEach(this.ek,this))};k.Zc=bf;k.$i=function(a){this.Db(a,!1);this.zb(a,!1)};
	k.dn=function(a,b){var c,d=b.a;for(c=0;c<d.length;++c)this.ea[d[c].T()].call(this,a,d[c])};k.Rh=function(a,b){var c=b.X(),d,e,f,g;d=0;for(e=c.length-1;d<e;++d)f=c.slice(d,d+2),g={feature:a,na:f},this.a.Ea(Ha(f),g)};k.en=function(a,b){var c=b.X(),d,e,f,g,h,l,m;g=0;for(h=c.length;g<h;++g)for(d=c[g],e=0,f=d.length-1;e<f;++e)l=d.slice(e,e+2),m={feature:a,na:l},this.a.Ea(Ha(l),m)};k.fn=function(a,b){var c=b.X(),d,e,f;e=0;for(f=c.length;e<f;++e)d=c[e],d={feature:a,na:[d,d]},this.a.Ea(b.D(),d)};
	k.gn=function(a,b){var c=b.X(),d,e,f,g,h,l,m,p,n,q;l=0;for(m=c.length;l<m;++l)for(p=c[l],g=0,h=p.length;g<h;++g)for(d=p[g],e=0,f=d.length-1;e<f;++e)n=d.slice(e,e+2),q={feature:a,na:n},this.a.Ea(Ha(n),q)};k.hn=function(a,b){var c=b.X(),c={feature:a,na:[c,c]};this.a.Ea(b.D(),c)};k.jn=function(a,b){var c=b.X(),d,e,f,g,h,l,m;g=0;for(h=c.length;g<h;++g)for(d=c[g],e=0,f=d.length-1;e<f;++e)l=d.slice(e,e+2),m={feature:a,na:l},this.a.Ea(Ha(l),m)};
	function Pu(a){var b,c,d=a.pixel,e=a.coordinate;b=a.map;var f=b.Za([d[0]-this.g,d[1]+this.g]);c=b.Za([d[0]+this.g,d[1]-this.g]);var f=Ha([f,c]),g=Hj(this.a,f),h,f=!1,l=null;c=null;if(0<g.length){this.G=e;g.sort(this.Ja);g=g[0].na;if(this.ia&&!this.R){if(e=b.Ka(g[0]),h=b.Ka(g[1]),e=Xe(d,e),d=Xe(d,h),h=Math.sqrt(Math.min(e,d)),h=h<=this.g)f=!0,l=e>d?g[1]:g[0],c=b.Ka(l)}else this.R&&(l=Re(e,g),c=b.Ka(l),Ye(d,c)<=this.g&&(f=!0,this.ia&&(e=b.Ka(g[0]),h=b.Ka(g[1]),e=Xe(c,e),d=Xe(c,h),h=Math.sqrt(Math.min(e,
	d)),h=h<=this.g)))&&(l=e>d?g[1]:g[0],c=b.Ka(l));f&&(c=[Math.round(c[0]),Math.round(c[1])])}b=l;f&&(a.coordinate=b.slice(0,2),a.pixel=c);return qg.call(this,a)}function Qu(){var a=rb(this.u);a.length&&(a.forEach(this.$i,this),this.u={});return!1}function Ru(a,b){return Ze(this.G,a.na)-Ze(this.G,b.na)};function Su(a){pg.call(this,{handleDownEvent:Tu,handleDragEvent:Uu,handleMoveEvent:Vu,handleUpEvent:Wu});a=a?a:{};this.g=void 0;this.a=null;this.o=void 0!==a.features?a.features:null;var b;if(a.layers)if("function"===typeof a.layers)b=a.layers;else{var c=a.layers;b=function(a){return ea(c,a)}}else b=af;this.C=b;this.u=a.hitTolerance?a.hitTolerance:0;this.j=null}u(Su,pg);
	function Tu(a){this.j=Xu(this,a.pixel,a.map);if(!this.a&&this.j){this.a=a.coordinate;Vu.call(this,a);var b=this.o||new D([this.j]);this.b(new Yu("translatestart",b,a.coordinate));return!0}return!1}function Wu(a){if(this.a){this.a=null;Vu.call(this,a);var b=this.o||new D([this.j]);this.b(new Yu("translateend",b,a.coordinate));return!0}return!1}
	function Uu(a){if(this.a){a=a.coordinate;var b=a[0]-this.a[0],c=a[1]-this.a[1],d=this.o||new D([this.j]);d.forEach(function(a){var d=a.U();d.translate(b,c);a.Sa(d)});this.a=a;this.b(new Yu("translating",d,a))}}function Vu(a){var b=a.map.Kc();Xu(this,a.pixel,a.map)?(this.g=void 0!==this.g?this.g:b.style.cursor,b.style.cursor=this.a?"-webkit-grabbing":"-webkit-grab",b.style.cursor=this.a?"grabbing":"grab"):void 0!==this.g&&(b.style.cursor=this.g,this.g=void 0)}
	function Xu(a,b,c){return c.re(b,function(a){if(!this.o||ea(this.o.a,a))return a}.bind(a),{layerFilter:a.C,hitTolerance:a.u})}Su.prototype.G=function(){return this.u};Su.prototype.R=function(a){this.u=a};function Yu(a,b,c){Bc.call(this,a);this.features=b;this.coordinate=c}u(Yu,Bc);function T(a){a=a?a:{};var b=pb({},a);delete b.gradient;delete b.radius;delete b.blur;delete b.shadow;delete b.weight;R.call(this,b);this.l=null;this.Y=void 0!==a.shadow?a.shadow:250;this.S=void 0;this.R=null;B(this,Ic(Zu),this.hl,this);this.Ki(a.gradient?a.gradient:$u);this.Ei(void 0!==a.blur?a.blur:15);this.Wc(void 0!==a.radius?a.radius:8);B(this,Ic(av),this.Qf,this);B(this,Ic(bv),this.Qf,this);this.Qf();var c=a.weight?a.weight:"weight",d;"string"===typeof c?d=function(a){return a.get(c)}:d=c;this.g(function(a){a=
	d(a);a=void 0!==a?wa(a,0,1):1;var b=255*a|0,c=this.R[b];c||(c=[new $k({image:new Rn({opacity:a,src:this.S})})],this.R[b]=c);return c}.bind(this));this.set(vt,null);B(this,"render",this.yl,this)}u(T,R);var $u=["#00f","#0ff","#0f0","#ff0","#f00"];k=T.prototype;k.fh=function(){return this.get(av)};k.mh=function(){return this.get(Zu)};k.Th=function(){return this.get(bv)};
	k.hl=function(){for(var a=this.mh(),b=Xc(1,256),c=b.createLinearGradient(0,0,1,256),d=1/(a.length-1),e=0,f=a.length;e<f;++e)c.addColorStop(e*d,a[e]);b.fillStyle=c;b.fillRect(0,0,1,256);this.l=b.getImageData(0,0,1,256).data};k.Qf=function(){var a=this.Th(),b=this.fh(),c=a+b+1,d=2*c,d=Xc(d,d);d.shadowOffsetX=d.shadowOffsetY=this.Y;d.shadowBlur=b;d.shadowColor="#000";d.beginPath();b=c-this.Y;d.arc(b,b,a,0,2*Math.PI,!0);d.fill();this.S=d.canvas.toDataURL();this.R=Array(256);this.s()};
	k.yl=function(a){a=a.context;var b=a.canvas,b=a.getImageData(0,0,b.width,b.height),c=b.data,d,e,f;d=0;for(e=c.length;d<e;d+=4)if(f=4*c[d+3])c[d]=this.l[f],c[d+1]=this.l[f+1],c[d+2]=this.l[f+2];a.putImageData(b,0,0)};k.Ei=function(a){this.set(av,a)};k.Ki=function(a){this.set(Zu,a)};k.Wc=function(a){this.set(bv,a)};var av="blur",Zu="gradient",bv="radius";function cv(a){mt.call(this,a);this.o=wh();this.g=null}u(cv,mt);cv.prototype.I=function(a,b,c){ot(this,"precompose",c,a,void 0);var d=this.Z();if(d){var e=b.extent,f=void 0!==e;f&&nt(c,a,e);var e=this.A(),g=c.globalAlpha;c.globalAlpha=b.opacity;c.drawImage(d,0,0,+d.width,+d.height,Math.round(e[4]),Math.round(e[5]),Math.round(d.width*e[0]),Math.round(d.height*e[3]));c.globalAlpha=g;f&&c.restore()}this.Ue(c,a,b)};
	cv.prototype.Aa=function(a,b,c,d,e){var f=this.a;return f.la().Aa(a,b.viewState.resolution,b.viewState.rotation,c,b.skippedFeatureUids,function(a){return d.call(e,a,f)})};
	cv.prototype.v=function(a,b,c,d){if(this.Z()){if(this.a.la().Aa!==na)return mt.prototype.v.apply(this,arguments);var e=Bh(this.o,a.slice());We(e,b.viewState.resolution/this.i);this.g||(this.g=Xc(1,1));this.g.clearRect(0,0,1,1);this.g.drawImage(this.Z(),e[0],e[1],1,1,0,0,1,1);e=this.g.getImageData(0,0,1,1).data;if(0<e[3])return c.call(d,this.a,e)}};function dv(a){cv.call(this,a);this.M=null;this.c=wh()}u(dv,cv);dv.prototype.Z=function(){return this.M?this.M.Z():null};dv.prototype.A=function(){return this.c};
	dv.prototype.qd=function(a,b){var c=a.pixelRatio,d=a.size,e=a.viewState,f=e.center,g=e.resolution,h=this.a.la(),l=a.viewHints,m=a.extent;void 0!==b.extent&&(m=lb(m,b.extent));l[0]||l[1]||gb(m)||(e=h.Z(m,g,c,e.projection))&&gt(this,e)&&(this.M=e);if(this.M){var e=this.M,m=e.D(),p=e.resolution,l=e.a,n=c*p/(g*l),m=Fh(this.c,c*d[0]/2,c*d[1]/2,n,n,0,l*(m[0]-f[0])/p,l*(f[1]-m[3])/p);Fh(this.o,c*d[0]/2-m[4],c*d[1]/2-m[5],c/g,-c/g,0,-f[0],-f[1]);it(a.attributions,e.i);jt(a,h);this.i=g*c/l}return!!this.M};function ev(a,b,c,d){var e=Wb(c,b,a);c=Eb(b,d,c);b=b.sc();void 0!==b&&(c*=b);b=a.sc();void 0!==b&&(c/=b);a=Eb(a,c,e)/c;isFinite(a)&&0<a&&(c/=a);return c}function fv(a,b,c,d){a=c-a;b=d-b;var e=Math.sqrt(a*a+b*b);return[Math.round(c+a/e),Math.round(d+b/e)]}
	function gv(a,b,c,d,e,f,g,h,l,m,p){var n=Xc(Math.round(c*a),Math.round(c*b));if(!l.length)return n.canvas;n.scale(c,c);var q=Ia();l.forEach(function(a){$a(q,a.extent)});var r=Xc(Math.round(c*hb(q)/d),Math.round(c*ib(q)/d)),v=c/d;l.forEach(function(a){r.drawImage(a.image,m,m,a.image.width-2*m,a.image.height-2*m,(a.extent[0]-q[0])*v,-(a.extent[3]-q[3])*v,hb(a.extent)*v,ib(a.extent)*v)});var x=eb(g);h.c.forEach(function(a){var b=a.source,e=a.target,g=b[1][0],h=b[1][1],l=b[2][0],m=b[2][1];a=(e[0][0]-
	x[0])/f;var p=-(e[0][1]-x[1])/f,v=(e[1][0]-x[0])/f,y=-(e[1][1]-x[1])/f,Z=(e[2][0]-x[0])/f,Ra=-(e[2][1]-x[1])/f,e=b[0][0],b=b[0][1],g=g-e,h=h-b,l=l-e,m=m-b;a:{g=[[g,h,0,0,v-a],[l,m,0,0,Z-a],[0,0,g,h,y-p],[0,0,l,m,Ra-p]];h=g.length;for(l=0;l<h;l++){for(var m=l,Cb=Math.abs(g[l][l]),dc=l+1;dc<h;dc++){var $c=Math.abs(g[dc][l]);$c>Cb&&(Cb=$c,m=dc)}if(!Cb){g=null;break a}Cb=g[m];g[m]=g[l];g[l]=Cb;for(m=l+1;m<h;m++)for(Cb=-g[m][l]/g[l][l],dc=l;dc<h+1;dc++)g[m][dc]=l==dc?0:g[m][dc]+Cb*g[l][dc]}l=Array(h);
	for(m=h-1;0<=m;m--)for(l[m]=g[m][h]/g[m][m],Cb=m-1;0<=Cb;Cb--)g[Cb][h]-=g[Cb][m]*l[m];g=l}g&&(n.save(),n.beginPath(),l=(a+v+Z)/3,m=(p+y+Ra)/3,h=fv(l,m,a,p),v=fv(l,m,v,y),Z=fv(l,m,Z,Ra),n.moveTo(v[0],v[1]),n.lineTo(h[0],h[1]),n.lineTo(Z[0],Z[1]),n.clip(),n.transform(g[0],g[2],g[1],g[3],a,p),n.translate(q[0]-e,q[3]-b),n.scale(d/c,-d/c),n.drawImage(r.canvas,0,0),n.restore())});p&&(n.save(),n.strokeStyle="black",n.lineWidth=1,h.c.forEach(function(a){var b=a.target;a=(b[0][0]-x[0])/f;var c=-(b[0][1]-x[1])/
	f,d=(b[1][0]-x[0])/f,e=-(b[1][1]-x[1])/f,g=(b[2][0]-x[0])/f,b=-(b[2][1]-x[1])/f;n.beginPath();n.moveTo(d,e);n.lineTo(a,c);n.lineTo(g,b);n.closePath();n.stroke()}),n.restore());return n.canvas};function hv(a,b,c,d,e){this.f=a;this.i=b;var f={},g=Ub(this.i,this.f);this.a=function(a){var b=a[0]+"/"+a[1];f[b]||(f[b]=g(a));return f[b]};this.g=d;this.v=e*e;this.c=[];this.j=!1;this.o=this.f.a&&!!d&&!!this.f.D()&&hb(d)==hb(this.f.D());this.b=this.f.D()?hb(this.f.D()):null;this.l=this.i.D()?hb(this.i.D()):null;a=eb(c);b=db(c);d=cb(c);c=bb(c);e=this.a(a);var h=this.a(b),l=this.a(d),m=this.a(c);iv(this,a,b,d,c,e,h,l,m,10);if(this.j){var p=Infinity;this.c.forEach(function(a){p=Math.min(p,a.source[0][0],
	a.source[1][0],a.source[2][0])});this.c.forEach(function(a){if(Math.max(a.source[0][0],a.source[1][0],a.source[2][0])-p>this.b/2){var b=[[a.source[0][0],a.source[0][1]],[a.source[1][0],a.source[1][1]],[a.source[2][0],a.source[2][1]]];b[0][0]-p>this.b/2&&(b[0][0]-=this.b);b[1][0]-p>this.b/2&&(b[1][0]-=this.b);b[2][0]-p>this.b/2&&(b[2][0]-=this.b);Math.max(b[0][0],b[1][0],b[2][0])-Math.min(b[0][0],b[1][0],b[2][0])<this.b/2&&(a.source=b)}},this)}f={}}
	function iv(a,b,c,d,e,f,g,h,l,m){var p=Ha([f,g,h,l]),n=a.b?hb(p)/a.b:null,q=a.b,r=a.f.a&&.5<n&&1>n,v=!1;if(0<m){if(a.i.f&&a.l)var x=Ha([b,c,d,e]),v=v|.25<hb(x)/a.l;!r&&a.f.f&&n&&(v|=.25<n)}if(v||!a.g||mb(p,a.g)){if(!(v||isFinite(f[0])&&isFinite(f[1])&&isFinite(g[0])&&isFinite(g[1])&&isFinite(h[0])&&isFinite(h[1])&&isFinite(l[0])&&isFinite(l[1])))if(0<m)v=!0;else return;if(0<m&&(v||(p=a.a([(b[0]+d[0])/2,(b[1]+d[1])/2]),q=r?(Ca(f[0],q)+Ca(h[0],q))/2-Ca(p[0],q):(f[0]+h[0])/2-p[0],p=(f[1]+h[1])/2-p[1],
	v=q*q+p*p>a.v),v)){Math.abs(b[0]-d[0])<=Math.abs(b[1]-d[1])?(r=[(c[0]+d[0])/2,(c[1]+d[1])/2],q=a.a(r),p=[(e[0]+b[0])/2,(e[1]+b[1])/2],n=a.a(p),iv(a,b,c,r,p,f,g,q,n,m-1),iv(a,p,r,d,e,n,q,h,l,m-1)):(r=[(b[0]+c[0])/2,(b[1]+c[1])/2],q=a.a(r),p=[(d[0]+e[0])/2,(d[1]+e[1])/2],n=a.a(p),iv(a,b,r,p,e,f,q,n,l,m-1),iv(a,r,c,d,p,q,g,h,n,m-1));return}if(r){if(!a.o)return;a.j=!0}a.c.push({source:[f,h,l],target:[b,d,e]});a.c.push({source:[f,g,h],target:[b,c,d]})}}
	function jv(a){var b=Ia();a.c.forEach(function(a){a=a.source;Ja(b,a[0]);Ja(b,a[1]);Ja(b,a[2])});return b};function kv(a,b,c,d,e,f){this.v=b;this.o=a.D();var g=b.D(),h=g?lb(c,g):c,g=ev(a,b,jb(h),d);this.l=new hv(a,b,h,this.o,.5*g);this.c=d;this.f=c;a=jv(this.l);this.j=(this.Eb=f(a,g,e))?this.Eb.a:1;this.$d=this.g=null;e=2;f=[];this.Eb&&(e=0,f=this.Eb.i);ss.call(this,c,d,this.j,e,f)}u(kv,ss);kv.prototype.ra=function(){1==this.state&&(rc(this.$d),this.$d=null);ss.prototype.ra.call(this)};kv.prototype.Z=function(){return this.g};
	kv.prototype.Zd=function(){var a=this.Eb.V();2==a&&(this.g=gv(hb(this.f)/this.c,ib(this.f)/this.c,this.j,this.Eb.resolution,0,this.c,this.f,this.l,[{extent:this.Eb.D(),image:this.Eb.Z()}],0));this.state=a;this.s()};kv.prototype.load=function(){if(0==this.state){this.state=1;this.s();var a=this.Eb.V();2==a||3==a?this.Zd():(this.$d=B(this.Eb,"change",function(){var a=this.Eb.V();if(2==a||3==a)rc(this.$d),this.$d=null,this.Zd()},this),this.Eb.load())}};function lv(a){Gt.call(this,{attributions:a.attributions,extent:a.extent,logo:a.logo,projection:a.projection,state:a.state});this.u=void 0!==a.resolutions?a.resolutions:null;this.a=null;this.ea=0}u(lv,Gt);function mv(a,b){a.u&&(b=a.u[fa(a.u,b,0)]);return b}
	lv.prototype.Z=function(a,b,c,d){var e=this.c;if(e&&d&&!Tb(e,d)){if(this.a){if(this.ea==this.f&&Tb(this.a.v,d)&&this.a.resolution==b&&this.a.a==c&&Za(this.a.D(),a))return this.a;Ac(this.a);this.a=null}this.a=new kv(e,d,a,b,c,function(a,b,c){return this.Ic(a,b,c,e)}.bind(this));this.ea=this.f;return this.a}e&&(d=e);return this.Ic(a,b,c,d)};lv.prototype.j=function(a){a=a.target;switch(a.V()){case 1:this.b(new nv(ov,a));break;case 2:this.b(new nv(pv,a));break;case 3:this.b(new nv(qv,a))}};
	function rv(a,b){a.Z().src=b}function nv(a,b){Bc.call(this,a);this.image=b}u(nv,Bc);var ov="imageloadstart",pv="imageloadend",qv="imageloaderror";function sv(a){lv.call(this,{attributions:a.attributions,logo:a.logo,projection:a.projection,resolutions:a.resolutions,state:a.state});this.ia=a.canvasFunction;this.S=null;this.Y=0;this.oa=void 0!==a.ratio?a.ratio:1.5}u(sv,lv);sv.prototype.Ic=function(a,b,c,d){b=mv(this,b);var e=this.S;if(e&&this.Y==this.f&&e.resolution==b&&e.a==c&&Ta(e.D(),a))return e;a=a.slice();nb(a,this.oa);(d=this.ia(a,b,c,[hb(a)/b*c,ib(a)/b*c],d))&&(e=new us(a,b,c,this.l,d));this.S=e;this.Y=this.f;return e};function tv(a){this.i=a.source;this.Oa=wh();this.g=Xc();this.o=[0,0];this.Ha=void 0==a.renderBuffer?100:a.renderBuffer;this.A=null;sv.call(this,{attributions:a.attributions,canvasFunction:this.Zj.bind(this),logo:a.logo,projection:a.projection,ratio:a.ratio,resolutions:a.resolutions,state:this.i.V()});this.C=null;this.v=void 0;this.ci(a.style);B(this.i,"change",this.Fn,this)}u(tv,sv);k=tv.prototype;
	k.Zj=function(a,b,c,d,e){var f=new Ws(.5*b/c,a,b,this.i.Ha,this.Ha);this.i.Ud(a,b,e);var g=!1;this.i.ac(a,function(a){var d;if(!(d=g)){var e;(d=a.Nc())?e=d.call(a,b):this.v&&(e=this.v(a,b));if(e){var h,n=!1;Array.isArray(e)||(e=[e]);d=0;for(h=e.length;d<h;++d)n=st(f,a,e[d],rt(b,c),this.En,this)||n;d=n}else d=!1}g=d},this);$s(f);if(g)return null;this.o[0]!=d[0]||this.o[1]!=d[1]?(this.g.canvas.width=d[0],this.g.canvas.height=d[1],this.o[0]=d[0],this.o[1]=d[1]):this.g.clearRect(0,0,d[0],d[1]);a=uv(this,
	jb(a),b,c,d);f.i(this.g,c,a,0,{});this.A=f;return this.g.canvas};k.Aa=function(a,b,c,d,e,f){if(this.A){var g={};return this.A.Aa(a,b,0,d,e,function(a){var b=w(a).toString();if(!(b in g))return g[b]=!0,f(a)})}};k.Bn=function(){return this.i};k.Cn=function(){return this.C};k.Dn=function(){return this.v};function uv(a,b,c,d,e){c=d/c;return Fh(a.Oa,e[0]/2,e[1]/2,c,-c,0,-b[0],-b[1])}k.En=function(){this.s()};k.Fn=function(){It(this,this.i.V())};
	k.ci=function(a){this.C=void 0!==a?a:dl;this.v=a?bl(this.C):void 0;this.s()};function vv(a,b){Bt.call(this,a,b);this.j=this.i=this.M=null}u(vv,Bt);function wv(a,b){var c=b.Z();return Oi(a.c.f,c)}vv.prototype.Aa=function(a,b,c,d,e){var f=this.a;return f.la().Aa(a,b.viewState.resolution,b.viewState.rotation,c,b.skippedFeatureUids,function(a){return d.call(e,a,f)})};
	vv.prototype.ag=function(a,b){var c=this.c.f,d=a.pixelRatio,e=a.viewState,f=e.center,g=e.resolution,h=e.rotation,l=this.M,m=this.Fb,p=this.a.la(),n=a.viewHints,q=a.extent;void 0!==b.extent&&(q=lb(q,b.extent));n[0]||n[1]||gb(q)||(e=p.Z(q,g,d,e.projection))&&gt(this,e)&&(l=e,m=wv(this,e),this.Fb&&a.postRenderFunctions.push(function(a,b){a.isContextLost()||a.deleteTexture(b)}.bind(null,c,this.Fb)));l&&(c=this.c.i.l,xv(this,c.width,c.height,d,f,g,h,l.D()),this.j=null,d=this.v,xh(d),Dh(d,1,-1),Eh(d,0,
	-1),this.M=l,this.Fb=m,it(a.attributions,l.i),jt(a,p));return!!l};function xv(a,b,c,d,e,f,g,h){b*=f;c*=f;a=a.u;xh(a);Dh(a,2*d/b,2*d/c);Ch(a,-g);Eh(a,h[0]-e[0],h[1]-e[1]);Dh(a,(h[2]-h[0])/2,(h[3]-h[1])/2);Eh(a,1,1)}vv.prototype.Ke=function(a,b){return void 0!==this.Aa(a,b,0,af,this)};
	vv.prototype.Zf=function(a,b,c,d){if(this.M&&this.M.Z())if(this.a.la()instanceof tv){var e=Bh(b.pixelToCoordinateTransform,a.slice());if(this.Aa(e,b,0,af,this))return c.call(d,this.a,null)}else{e=[this.M.Z().width,this.M.Z().height];if(!this.j){var f=b.size;b=wh();Eh(b,-1,-1);Dh(b,2/f[0],2/f[1]);Eh(b,0,f[1]);Dh(b,1,-1);var f=Gh(this.u.slice()),g=wh();Eh(g,0,e[1]);Dh(g,1,-1);Dh(g,e[0]/2,e[1]/2);Eh(g,1,1);zh(g,f);zh(g,b);this.j=g}a=Bh(this.j,a.slice());if(!(0>a[0]||a[0]>e[0]||0>a[1]||a[1]>e[1])&&(this.i||
	(this.i=Xc(1,1)),this.i.clearRect(0,0,1,1),this.i.drawImage(this.M.Z(),a[0],a[1],1,1,0,0,1,1),e=this.i.getImageData(0,0,1,1).data,0<e[3]))return c.call(d,this.a,e)}};function yv(a){rh.call(this,a?a:{})}u(yv,rh);yv.prototype.Dd=function(a){var b=null,c=a.T();"canvas"===c?b=new dv(this):"webgl"===c&&(b=new vv(a,this));return b};function zv(a){cv.call(this,a);this.u=Xc();this.l=null;this.c=[];this.j=Ia();this.Ja=new sa(0,0,0,0);this.C=wh();this.Y=0}u(zv,cv);function Av(a,b){var c=b.V(),d=a.a.Td();return 2==c||4==c||3==c&&!d}
	zv.prototype.qd=function(a,b){var c=a.pixelRatio,d=a.size,e=a.viewState,f=e.projection,g=e.resolution,e=e.center,h=this.a,l=h.la(),m=l.f,p=l.Ib(f),n=p.Mc(g,this.Y),q=p.La(n),r=Math.round(g/q)||1,v=a.extent;void 0!==b.extent&&(v=lb(v,b.extent));if(gb(v))return!1;var x=gc(p,v,q),y;y=p.Qc(n);var z=p.La(n),A=Ga(p.fb(n),p.l);y=Va(y[0]+x.da*A[0]*z,y[1]+x.fa*A[1]*z,y[0]+(x.ba+1)*A[0]*z,y[1]+(x.ja+1)*A[1]*z,void 0);z=l.pb(c);A={};A[n]={};var V=this.Cf(l,f,A),Pa=this.j,ra=this.Ja,La=!1,C,Ma,xb;for(Ma=x.da;Ma<=
	x.ba;++Ma)for(xb=x.fa;xb<=x.ja;++xb)C=l.Lc(n,Ma,xb,c,f),Av(this,C)||(C=ws(C)),Av(this,C)?2==C.V()&&(A[n][C.Ga.toString()]=C,La||-1!=this.c.indexOf(C)||(La=!0)):ec(p,C.Ga,V,ra,Pa)||(C=fc(p,C.Ga,ra,Pa))&&V(n+1,C);V=a.viewHints;if(!(this.i&&16<Date.now()-a.time&&(V[0]||V[1])||!La&&this.l&&Ta(this.l,v)&&this.af==m)||r!=this.R){La=l.Sd(n,c,f);Ma=Math.round((x.ba-x.da+1)*La[0]/r);C=Math.round((x.ja-x.fa+1)*La[0]/r);La=this.u;xb=La.canvas;V=l.Mf(f);xb.width!=Ma||xb.height!=C?(this.R=r,xb.width=Ma,xb.height=
	C):(La.clearRect(0,0,Ma,C),r=this.R);this.c.length=0;ra=Object.keys(A).map(Number);ra.sort(da);var Z,Ra,Cb,dc,$c,$d,Je,ue;Cb=0;for(dc=ra.length;Cb<dc;++Cb){Ma=ra[Cb];Ra=l.Sd(Ma,c,f);C=p.La(Ma);Z=C/q;$c=z*l.Jf(f);$d=A[Ma];for(var Tc in $d)C=$d[Tc],xb=p.Ta(C.Ga,Pa),Ma=(xb[0]-y[0])/q*z/r,xb=(y[3]-xb[3])/q*z/r,Je=Ra[0]*Z/r,ue=Ra[1]*Z/r,V||La.clearRect(Ma,xb,Je,ue),this.Df(C,a,b,Ma,xb,Je,ue,$c),this.c.push(C)}this.af=m;this.i=q*c/z*r;this.l=y}Tc=this.i/g;Tc=Fh(this.C,c*d[0]/2,c*d[1]/2,Tc,Tc,0,(this.l[0]-
	e[0])/this.i*c,(e[1]-this.l[3])/this.i*c);Fh(this.o,c*d[0]/2-Tc[4],c*d[1]/2-Tc[5],c/g,-c/g,0,-e[0],-e[1]);kt(a.usedTiles,l,n,x);lt(a,l,p,c,f,v,n,h.Pd());ht(a,l);jt(a,l);return 0<this.c.length};zv.prototype.Df=function(a,b,c,d,e,f,g,h){(a=a.Z())&&this.u.drawImage(a,h,h,a.width-2*h,a.height-2*h,d,e,f,g)};zv.prototype.Z=function(){return this.u.canvas};zv.prototype.A=function(){return this.C};function Bv(){this.b="precision mediump float;varying vec2 a;uniform sampler2D e;void main(void){gl_FragColor=texture2D(e,a);}"}u(Bv,hi);var Cv=new Bv;function Dv(){this.b="varying vec2 a;attribute vec2 b;attribute vec2 c;uniform vec4 d;void main(void){gl_Position=vec4(b*d.xy+d.zw,0.,1.);a=c;}"}u(Dv,ii);var Ev=new Dv;function Fv(a,b){this.f=a.getUniformLocation(b,"e");this.c=a.getUniformLocation(b,"d");this.b=a.getAttribLocation(b,"b");this.a=a.getAttribLocation(b,"c")};function Gv(a,b){Bt.call(this,a,b);this.R=Cv;this.ia=Ev;this.i=null;this.G=new yi([0,0,0,1,1,0,1,1,0,1,0,0,1,1,1,0]);this.A=this.j=null;this.o=-1;this.S=[0,0]}u(Gv,Bt);k=Gv.prototype;k.ra=function(){Bi(this.c.i,this.G);Bt.prototype.ra.call(this)};k.Cf=function(a,b,c){var d=this.c;return function(e,f){return et(a,b,e,f,function(a){var b=d.a.b.hasOwnProperty(a.ib());b&&(c[e]||(c[e]={}),c[e][a.Ga.toString()]=a);return b})}};k.$f=function(){Bt.prototype.$f.call(this);this.i=null};
	k.ag=function(a,b,c){var d=this.c,e=c.b,f=a.viewState,g=f.projection,h=this.a,l=h.la(),m=l.Ib(g),p=m.Mc(f.resolution),n=m.La(p),q=l.Sd(p,a.pixelRatio,g),r=q[0]/Ga(m.fb(p),this.S)[0],v=n/r,x=l.pb(r)*l.Jf(g),y=f.center,z=a.extent,A=gc(m,z,n);if(this.j&&ua(this.j,A)&&this.o==l.f)v=this.A;else{var V=[A.ba-A.da+1,A.ja-A.fa+1],Pa=ya(Math.max(V[0]*q[0],V[1]*q[1])),V=v*Pa,ra=m.Qc(p),La=ra[0]+A.da*q[0]*v,v=ra[1]+A.fa*q[1]*v,v=[La,v,La+V,v+V];Ct(this,a,Pa);e.viewport(0,0,Pa,Pa);e.clearColor(0,0,0,0);e.clear(16384);
	e.disable(3042);Pa=Ci(c,this.R,this.ia);c.Rc(Pa);this.i||(this.i=new Fv(e,Pa));ri(c,34962,this.G);e.enableVertexAttribArray(this.i.b);e.vertexAttribPointer(this.i.b,2,5126,!1,16,0);e.enableVertexAttribArray(this.i.a);e.vertexAttribPointer(this.i.a,2,5126,!1,16,8);e.uniform1i(this.i.f,0);c={};c[p]={};var C=this.Cf(l,g,c),Ma=h.Td(),Pa=!0,La=Ia(),xb=new sa(0,0,0,0),Z,Ra,Cb;for(Ra=A.da;Ra<=A.ba;++Ra)for(Cb=A.fa;Cb<=A.ja;++Cb){ra=l.Lc(p,Ra,Cb,r,g);if(void 0!==b.extent&&(Z=m.Ta(ra.Ga,La),!mb(Z,b.extent)))continue;
	Z=ra.V();(Z=2==Z||4==Z||3==Z&&!Ma)||(ra=ws(ra));Z=ra.V();if(2==Z){if(d.a.b.hasOwnProperty(ra.ib())){c[p][ra.Ga.toString()]=ra;continue}}else if(4==Z||3==Z&&!Ma)continue;Pa=!1;Z=ec(m,ra.Ga,C,xb,La);Z||(ra=fc(m,ra.Ga,xb,La))&&C(p+1,ra)}b=Object.keys(c).map(Number);b.sort(da);for(var C=new Float32Array(4),dc,Ma=0,xb=b.length;Ma<xb;++Ma)for(dc in Ra=c[b[Ma]],Ra)ra=Ra[dc],Z=m.Ta(ra.Ga,La),C[0]=2*(Z[2]-Z[0])/V,C[1]=2*(Z[3]-Z[1])/V,C[2]=2*(Z[0]-v[0])/V-1,C[3]=2*(Z[1]-v[1])/V-1,e.uniform4fv(this.i.c,C),lk(d,
	ra,q,x*r),e.drawArrays(5,0,4);Pa?(this.j=A,this.A=v,this.o=l.f):(this.A=this.j=null,this.o=-1,a.animate=!0)}kt(a.usedTiles,l,p,A);var $c=d.l;lt(a,l,m,r,g,z,p,h.Pd(),function(a){2!=a.V()||d.a.b.hasOwnProperty(a.ib())||a.ib()in $c.a||$c.i([a,ic(m,a.Ga),m.La(a.Ga[0]),q,x*r])},this);ht(a,l);jt(a,l);e=this.v;xh(e);Eh(e,(Math.round(y[0]/n)*n-v[0])/(v[2]-v[0]),(Math.round(y[1]/n)*n-v[1])/(v[3]-v[1]));f.rotation&&Ch(e,f.rotation);Dh(e,a.size[0]*f.resolution/(v[2]-v[0]),a.size[1]*f.resolution/(v[3]-v[1]));
	Eh(e,-.5,-.5);return!0};k.Zf=function(a,b,c,d){if(this.g){a=Bh(this.v,[a[0]/b.size[0],(b.size[1]-a[1])/b.size[1]].slice());a=[a[0]*this.l,a[1]*this.l];b=this.c.i.b;b.bindFramebuffer(b.FRAMEBUFFER,this.g);var e=new Uint8Array(4);b.readPixels(a[0],a[1],1,1,b.RGBA,b.UNSIGNED_BYTE,e);if(0<e[3])return c.call(d,this.a,e)}};function Hv(a){a=a?a:{};var b=pb({},a);delete b.preload;delete b.useInterimTilesOnError;rh.call(this,b);this.Uh(void 0!==a.preload?a.preload:0);this.Vh(void 0!==a.useInterimTilesOnError?a.useInterimTilesOnError:!0)}u(Hv,rh);k=Hv.prototype;k.Dd=function(a){var b=null,c=a.T();"canvas"===c?b=new zv(this):"webgl"===c&&(b=new Gv(a,this));return b};k.Pd=function(){return this.get("preload")};k.Uh=function(a){this.set("preload",a)};k.Td=function(){return this.get("useInterimTilesOnError")};
	k.Vh=function(a){this.set("useInterimTilesOnError",a)};function Iv(a){zv.call(this,a);this.G=!1;this.S=wh();this.Y="vector"==a.v?1:0}u(Iv,zv);var Jv={image:ei,hybrid:["Polygon","LineString"]},Kv={hybrid:["Image","Text"],vector:ei};k=Iv.prototype;k.qd=function(a,b){var c=this.a.f;this.oa!=c&&(this.c.length=0);this.oa=c;return zv.prototype.qd.apply(this,arguments)};
	function Lv(a,b,c){function d(a){var b,c=a.Nc();c?b=c.call(a,r):(c=e.i)&&(b=c(a,r));if(b){Array.isArray(b)||(b=[b]);var c=A,d=z;if(b){var f=!1;if(Array.isArray(b))for(var g=0,h=b.length;g<h;++g)f=st(d,a,b[g],c,this.$h,this)||f;else f=st(d,a,b,c,this.$h,this)||f;a=f}else a=!1;this.G=this.G||a;l.Ld=l.Ld||a}}var e=a.a,f=c.pixelRatio;c=c.viewState.projection;var g=e.f,h=e.get(vt)||null,l=b.f;if(l.Ld||l.af!=g||l.wg!=h){l.vd=null;l.Ld=!1;var m=e.la(),p=m.tileGrid,n=b.Ga,q=b.l,r=p.La(n[0]),v,x,y;"tile-pixels"==
	q.Jb()?(v=y=m.pb(),p=Ga(p.fb(n[0])),v=[0,0,p[0]*v,p[1]*v]):(y=r,v=p.Ta(n),Tb(c,q)||(x=!0,b.Xf(c)));l.Ld=!1;var z=new Ws(0,v,y,m.g,e.c),A=rt(y,f);b=b.g;h&&h!==l.wg&&b.sort(h);m=0;for(y=b.length;m<y;++m)f=b[m],x&&f.U().tb(q,c),d.call(a,f);$s(z);l.af=g;l.wg=h;l.vd=z;l.resolution=NaN}}
	k.Df=function(a,b,c,d,e,f,g,h){var l=a;Lv(this,l,b);if("vector"!=this.a.v){var m=l,p=b,n=this.a,l=m.f,q=n.f,r=Jv[n.v];if(r&&l.xg!==q){l.xg=q;var v=m.Ga,x=m.Ga[0],q=p.pixelRatio,y=n.la(),z=y.tileGrid,A=y.pb(),n=xh(this.S);"tile-pixels"==m.l.Jb()?(v=q/A,Dh(n,v,v)):(A=q/z.La(x),v=z.Ta(v,this.j),Dh(n,A,-A),Eh(n,-v[0],-v[3]));m=m.c;p=y.Sd(x,q,p.viewState.projection);m.canvas.width=p[0];m.canvas.height=p[1];l.vd.i(m,q,n,0,{},r)}}zv.prototype.Df.apply(this,arguments)};
	k.Aa=function(a,b,c,d,e){var f=b.viewState.resolution;b=b.viewState.rotation;c=void 0==c?0:c;var g=this.a,h={},l=this.c,m=g.la(),p=m.tileGrid,n,q,r,v,x,y;r=0;for(v=l.length;r<v;++r)y=l[r],q=y.Ga,x=m.tileGrid.Ta(q,this.j),Qa(Ka(x,c*f),a)&&("tile-pixels"===y.l.Jb()?(x=eb(x),f=m.pb(),q=p.La(q[0])/f,q=[(a[0]-x[0])/q,(x[1]-a[1])/q]):q=a,y=y.f.vd,n=n||y.Aa(q,f,b,c,{},function(a){var b=w(a).toString();if(!(b in h))return h[b]=!0,d.call(e,a,g)}));return n};k.$h=function(){ft(this)};
	k.Ue=function(a,b,c){var d=Kv[this.a.v];if(d)for(var e=b.pixelRatio,f=b.viewState.rotation,g=b.size,h=Math.round(e*g[0]/2),g=Math.round(e*g[1]/2),l=this.c,m=[],p=[],n=l.length-1;0<=n;--n){var q=l[n],r;var v=q;r=b;if("tile-pixels"==v.l.Jb()){var x=this.a.la(),y=x.tileGrid,z=v.Ga,x=y.La(z[0])/x.pb(),v=r.viewState,A=r.pixelRatio,V=v.resolution/A,z=y.Ta(z,this.j),y=v.center,z=eb(z);r=r.size;r=Fh(this.S,Math.round(A*r[0]/2),Math.round(A*r[1]/2),x/V,x/V,v.rotation,(z[0]-y[0])/x,(y[1]-z[1])/x)}else r=pt(this,
	r,0);x=bt(q.f.vd,r);v=q.Ga[0];a.save();a.globalAlpha=c.opacity;Qh(a,-f,h,g);A=0;for(V=m.length;A<V;++A)y=m[A],v<p[A]&&(a.beginPath(),a.moveTo(x[0],x[1]),a.lineTo(x[2],x[3]),a.lineTo(x[4],x[5]),a.lineTo(x[6],x[7]),a.moveTo(y[6],y[7]),a.lineTo(y[4],y[5]),a.lineTo(y[2],y[3]),a.lineTo(y[0],y[1]),a.clip());q.f.vd.i(a,e,r,f,{},d);a.restore();m.push(x);p.push(v)}zv.prototype.Ue.apply(this,arguments)};function U(a){a=a?a:{};var b=pb({},a);delete b.preload;delete b.useInterimTilesOnError;R.call(this,b);this.Wh(a.preload?a.preload:0);this.Xh(a.useInterimTilesOnError?a.useInterimTilesOnError:!0);qa(void 0==a.renderMode||"image"==a.renderMode||"hybrid"==a.renderMode||"vector"==a.renderMode,28);this.v=a.renderMode||"hybrid"}u(U,R);k=U.prototype;k.Dd=function(a){var b=null;"canvas"===a.T()&&(b=new Iv(this));return b};k.Pd=function(){return this.get(Mv)};k.Td=function(){return this.get(Nv)};
	k.Wh=function(a){this.set("preload",a)};k.Xh=function(a){this.set("useInterimTilesOnError",a)};var Mv="preload",Nv="useInterimTilesOnError";function Ov(a,b,c,d){function e(){delete window[g];f.parentNode.removeChild(f)}var f=document.createElement("script"),g="olc_"+w(b);f.async=!0;f.src=a+(-1==a.indexOf("?")?"?":"&")+(d||"callback")+"="+g;var h=setTimeout(function(){e();c&&c()},1E4);window[g]=function(a){clearTimeout(h);e();b(a)};document.getElementsByTagName("head")[0].appendChild(f)};function Pv(a,b,c,d,e,f,g,h,l,m,p){vs.call(this,e,0);this.C=void 0!==p?p:!1;this.A=g;this.u=h;this.I=null;this.c=b;this.j=d;this.o=f?f:e;this.f=[];this.wd=null;this.g=0;f=d.Ta(this.o);h=this.j.D();e=this.c.D();f=h?lb(f,h):f;if(fb(f))if((h=a.D())&&(e?e=lb(e,h):e=h),d=ev(a,c,jb(f),d.La(this.o[0])),!isFinite(d)||0>=d)this.state=4;else if(this.v=new hv(a,c,f,e,d*(void 0!==m?m:.5)),this.v.c.length)if(this.g=b.Mc(d),c=jv(this.v),e&&(a.a?(c[1]=wa(c[1],e[1],e[3]),c[3]=wa(c[3],e[1],e[3])):c=lb(c,e)),fb(c)){a=
	cc(b,c,this.g);for(b=a.da;b<=a.ba;b++)for(c=a.fa;c<=a.ja;c++)(m=l(this.g,b,c,g))&&this.f.push(m);this.f.length||(this.state=4)}else this.state=4;else this.state=4;else this.state=4}u(Pv,vs);Pv.prototype.ra=function(){1==this.state&&(this.wd.forEach(rc),this.wd=null);vs.prototype.ra.call(this)};Pv.prototype.Z=function(){return this.I};
	Pv.prototype.Zd=function(){var a=[];this.f.forEach(function(b){b&&2==b.V()&&a.push({extent:this.c.Ta(b.Ga),image:b.Z()})},this);this.f.length=0;if(a.length){var b=this.o[0],c=this.j.fb(b),d="number"===typeof c?c:c[0],c="number"===typeof c?c:c[1],b=this.j.La(b),e=this.c.La(this.g),f=this.j.Ta(this.o);this.I=gv(d,c,this.A,e,this.c.D(),b,f,this.v,a,this.u,this.C);this.state=2}else this.state=3;this.s()};
	Pv.prototype.load=function(){if(0==this.state){this.state=1;this.s();var a=0;this.wd=[];this.f.forEach(function(b){var c=b.V();if(0==c||1==c){a++;var d;d=B(b,"change",function(){var c=b.V();if(2==c||3==c||4==c)rc(d),a--,a||(this.wd.forEach(rc),this.wd=null,this.Zd())},this);this.wd.push(d)}},this);this.f.forEach(function(a){0==a.V()&&a.load()});a||setTimeout(this.Zd.bind(this),0)}};function Qv(a,b){var c=/\{z\}/g,d=/\{x\}/g,e=/\{y\}/g,f=/\{-y\}/g;return function(g){if(g)return a.replace(c,g[0].toString()).replace(d,g[1].toString()).replace(e,function(){return(-g[2]-1).toString()}).replace(f,function(){var a=b.a?b.a[g[0]]:null;qa(a,55);return(a.ja-a.fa+1+g[2]).toString()})}}function Rv(a,b){for(var c=a.length,d=Array(c),e=0;e<c;++e)d[e]=Qv(a[e],b);return Sv(d)}function Sv(a){return 1===a.length?a[0]:function(b,c,d){if(b)return a[Ca((b[1]<<b[0])+b[2],a.length)](b,c,d)}}
	function Tv(){}function Uv(a){var b=[],c=/\{([a-z])-([a-z])\}/.exec(a);if(c){var d=c[2].charCodeAt(0),e;for(e=c[1].charCodeAt(0);e<=d;++e)b.push(a.replace(c[0],String.fromCharCode(e)));return b}if(c=c=/\{(\d+)-(\d+)\}/.exec(a)){d=parseInt(c[2],10);for(e=parseInt(c[1],10);e<=d;e++)b.push(a.replace(c[0],e.toString()));return b}b.push(a);return b};function Vv(a){jk.call(this);this.i=void 0!==a?a:2048}u(Vv,jk);function Wv(a){return a.c>a.i}Vv.prototype.gd=function(a){for(var b,c;Wv(this);){b=this.a.$c;c=b.Ga[0].toString();var d;if(d=c in a)b=b.Ga,d=ta(a[c],b[1],b[2]);if(d)break;else Ac(this.pop())}};function Xv(a){Gt.call(this,{attributions:a.attributions,extent:a.extent,logo:a.logo,projection:a.projection,state:a.state,wrapX:a.wrapX});this.oa=void 0!==a.opaque?a.opaque:!1;this.Oa=void 0!==a.tilePixelRatio?a.tilePixelRatio:1;this.tileGrid=void 0!==a.tileGrid?a.tileGrid:null;this.a=new Vv(a.cacheSize);this.j=[0,0];this.tc=""}u(Xv,Gt);k=Xv.prototype;k.fi=function(){return Wv(this.a)};k.gd=function(a,b){var c=this.Rd(a);c&&c.gd(b)};
	function et(a,b,c,d,e){b=a.Rd(b);if(!b)return!1;for(var f=!0,g,h,l=d.da;l<=d.ba;++l)for(var m=d.fa;m<=d.ja;++m)g=a.Sb(c,l,m),h=!1,b.b.hasOwnProperty(g)&&(g=b.get(g),(h=2===g.V())&&(h=!1!==e(g))),h||(f=!1);return f}k.Jf=function(){return 0};function Yv(a,b){a.tc!==b&&(a.tc=b,a.s())}k.Sb=function(a,b,c){return a+"/"+b+"/"+c};k.Mf=function(){return this.oa};k.ab=function(){return this.tileGrid};k.Ib=function(a){return this.tileGrid?this.tileGrid:jc(a)};
	k.Rd=function(a){var b=this.c;return b&&!Tb(b,a)?null:this.a};k.pb=function(){return this.Oa};k.Sd=function(a,b,c){c=this.Ib(c);b=this.pb(b);a=Ga(c.fb(a),this.j);return 1==b?a:Fa(a,b,this.j)};function Zv(a,b,c){var d=void 0!==c?c:a.c;c=a.Ib(d);if(a.G&&d.f){var e=b;b=e[0];a=ic(c,e);d=kc(d);Qa(d,a)?b=e:(e=hb(d),a[0]+=e*Math.ceil((d[0]-a[0])/e),b=c.Pf(a,b))}e=b[0];d=b[1];a=b[2];if(c.minZoom>e||e>c.maxZoom)c=!1;else{var f=c.D();c=(c=f?cc(c,f,e):c.a?c.a[e]:null)?ta(c,d,a):!0}return c?b:null}
	k.va=function(){this.a.clear();this.s()};k.Eg=na;function $v(a,b){Bc.call(this,a);this.tile=b}u($v,Bc);function aw(a){Xv.call(this,{attributions:a.attributions,cacheSize:a.cacheSize,extent:a.extent,logo:a.logo,opaque:a.opaque,projection:a.projection,state:a.state,tileGrid:a.tileGrid,tilePixelRatio:a.tilePixelRatio,wrapX:a.wrapX});this.tileLoadFunction=a.tileLoadFunction;this.tileUrlFunction=this.Fc?this.Fc.bind(this):Tv;this.urls=null;a.urls?this.cb(a.urls):a.url&&this.jb(a.url);a.tileUrlFunction&&this.bb(a.tileUrlFunction)}u(aw,Xv);k=aw.prototype;k.ob=function(){return this.tileLoadFunction};
	k.qb=function(){return this.tileUrlFunction};k.rb=function(){return this.urls};k.gi=function(a){a=a.target;switch(a.V()){case 1:this.b(new $v("tileloadstart",a));break;case 2:this.b(new $v("tileloadend",a));break;case 3:this.b(new $v("tileloaderror",a))}};k.xb=function(a){this.a.clear();this.tileLoadFunction=a;this.s()};k.bb=function(a,b){this.tileUrlFunction=a;"undefined"!==typeof b?Yv(this,b):this.s()};
	k.jb=function(a){var b=this.urls=Uv(a);this.bb(this.Fc?this.Fc.bind(this):Rv(b,this.tileGrid),a)};k.cb=function(a){this.urls=a;var b=a.join("\n");this.bb(this.Fc?this.Fc.bind(this):Rv(a,this.tileGrid),b)};k.Eg=function(a,b,c){a=this.Sb(a,b,c);this.a.b.hasOwnProperty(a)&&this.a.get(a)};function W(a){aw.call(this,{attributions:a.attributions,cacheSize:a.cacheSize,extent:a.extent,logo:a.logo,opaque:a.opaque,projection:a.projection,state:a.state,tileGrid:a.tileGrid,tileLoadFunction:a.tileLoadFunction?a.tileLoadFunction:bw,tilePixelRatio:a.tilePixelRatio,tileUrlFunction:a.tileUrlFunction,url:a.url,urls:a.urls,wrapX:a.wrapX});this.crossOrigin=void 0!==a.crossOrigin?a.crossOrigin:null;this.tileClass=a.tileClass?a.tileClass:xs;this.g={};this.v={};this.Ha=a.reprojectionErrorThreshold;this.C=
	!1}u(W,aw);k=W.prototype;k.fi=function(){if(Wv(this.a))return!0;for(var a in this.g)if(Wv(this.g[a]))return!0;return!1};k.gd=function(a,b){var c=this.Rd(a);this.a.gd(this.a==c?b:{});for(var d in this.g){var e=this.g[d];e.gd(e==c?b:{})}};k.Jf=function(a){return this.c&&a&&!Tb(this.c,a)?0:this.Kf()};k.Kf=function(){return 0};k.Mf=function(a){return this.c&&a&&!Tb(this.c,a)?!1:aw.prototype.Mf.call(this,a)};
	k.Ib=function(a){var b=this.c;return!this.tileGrid||b&&!Tb(b,a)?(b=w(a).toString(),b in this.v||(this.v[b]=jc(a)),this.v[b]):this.tileGrid};k.Rd=function(a){var b=this.c;if(!b||Tb(b,a))return this.a;a=w(a).toString();a in this.g||(this.g[a]=new Vv);return this.g[a]};function cw(a,b,c,d,e,f,g){b=[b,c,d];e=(c=Zv(a,b,f))?a.tileUrlFunction(c,e,f):void 0;e=new a.tileClass(b,void 0!==e?0:4,void 0!==e?e:"",a.crossOrigin,a.tileLoadFunction);e.key=g;B(e,"change",a.gi,a);return e}
	k.Lc=function(a,b,c,d,e){if(this.c&&e&&!Tb(this.c,e)){var f=this.Rd(e);c=[a,b,c];var g;a=this.Sb.apply(this,c);f.b.hasOwnProperty(a)&&(g=f.get(a));b=this.tc;if(g&&g.key==b)return g;var h=this.c,l=this.Ib(h),m=this.Ib(e),p=Zv(this,c,e);d=new Pv(h,l,e,m,c,p,this.pb(d),this.Kf(),function(a,b,c,d){return dw(this,a,b,c,d,h)}.bind(this),this.Ha,this.C);d.key=b;g?(d.a=g,f.replace(a,d)):f.set(a,d);return d}return dw(this,a,b,c,d,e)};
	function dw(a,b,c,d,e,f){var g,h=a.Sb(b,c,d),l=a.tc;if(a.a.b.hasOwnProperty(h)){if(g=a.a.get(h),g.key!=l){var m=g;g=cw(a,b,c,d,e,f,l);0==m.V()?g.a=m.a:g.a=m;if(g.a){b=g.a;c=g;do{if(2==b.V()){b.a=null;break}else 1==b.V()?c=b:0==b.V()?c.a=b.a:c=b;b=c.a}while(b)}a.a.replace(h,g)}}else g=cw(a,b,c,d,e,f,l),a.a.set(h,g);return g}k.Nb=function(a){if(this.C!=a){this.C=a;for(var b in this.g)this.g[b].clear();this.s()}};k.Ob=function(a,b){var c=Gb(a);c&&(c=w(c).toString(),c in this.v||(this.v[c]=b))};
	function bw(a,b){a.Z().src=b};function ew(a){this.A=void 0!==a.hidpi?a.hidpi:!1;W.call(this,{cacheSize:a.cacheSize,crossOrigin:"anonymous",opaque:!0,projection:Gb("EPSG:3857"),reprojectionErrorThreshold:a.reprojectionErrorThreshold,state:"loading",tileLoadFunction:a.tileLoadFunction,tilePixelRatio:this.A?2:1,wrapX:void 0!==a.wrapX?a.wrapX:!0});this.S=void 0!==a.culture?a.culture:"en-us";this.u=void 0!==a.maxZoom?a.maxZoom:-1;this.i=a.key;this.o=a.imagerySet;Ov("https://dev.virtualearth.net/REST/v1/Imagery/Metadata/"+this.o+"?uriScheme=https&include=ImageryProviders&key="+
	this.i,this.ia.bind(this),void 0,"jsonp")}u(ew,W);var fw=new nc({html:'<a class="ol-attribution-bing-tos" href="http://www.microsoft.com/maps/product/terms.html">Terms of Use</a>'});ew.prototype.Y=function(){return this.i};ew.prototype.ea=function(){return this.o};
	ew.prototype.ia=function(a){if(200!=a.statusCode||"OK"!=a.statusDescription||"ValidCredentials"!=a.authenticationResultCode||1!=a.resourceSets.length||1!=a.resourceSets[0].resources.length)It(this,"error");else{var b=a.brandLogoUri;-1==b.indexOf("https")&&(b=b.replace("http","https"));var c=a.resourceSets[0].resources[0],d=-1==this.u?c.zoomMax:this.u;a=kc(this.c);var e=mc({extent:a,minZoom:c.zoomMin,maxZoom:d,tileSize:(c.imageWidth==c.imageHeight?c.imageWidth:[c.imageWidth,c.imageHeight])/this.pb()});
	this.tileGrid=e;var f=this.S,g=this.A;this.tileUrlFunction=Sv(c.imageUrlSubdomains.map(function(a){var b=[0,0,0],d=c.imageUrl.replace("{subdomain}",a).replace("{culture}",f);return function(a){if(a)return Yb(a[0],a[1],-a[2]-1,b),a=d,g&&(a+="&dpi=d1&device=mobile"),a.replace("{quadkey}",Zb(b))}}));if(c.imageryProviders){var h=Fb(Gb("EPSG:4326"),this.c);a=c.imageryProviders.map(function(a){var b=a.attribution,c={};a.coverageAreas.forEach(function(a){var b=a.zoomMin,f=Math.min(a.zoomMax,d);a=a.bbox;
	a=ob([a[1],a[0],a[3],a[2]],h);var g,l;for(g=b;g<=f;++g)l=g.toString(),b=cc(e,a,g),l in c?c[l].push(b):c[l]=[b]});return new nc({html:b,tileRanges:c})});a.push(fw);this.ua(a)}this.R=b;It(this,"ready")}};function gw(a){a=a||{};var b=void 0!==a.projection?a.projection:"EPSG:3857",c=void 0!==a.tileGrid?a.tileGrid:mc({extent:kc(b),maxZoom:a.maxZoom,minZoom:a.minZoom,tileSize:a.tileSize});W.call(this,{attributions:a.attributions,cacheSize:a.cacheSize,crossOrigin:a.crossOrigin,logo:a.logo,opaque:a.opaque,projection:b,reprojectionErrorThreshold:a.reprojectionErrorThreshold,tileGrid:c,tileLoadFunction:a.tileLoadFunction,tilePixelRatio:a.tilePixelRatio,tileUrlFunction:a.tileUrlFunction,url:a.url,urls:a.urls,
	wrapX:void 0!==a.wrapX?a.wrapX:!0})}u(gw,W);function hw(a){this.u=a.account;this.A=a.map||"";this.i=a.config||{};this.o={};gw.call(this,{attributions:a.attributions,cacheSize:a.cacheSize,crossOrigin:a.crossOrigin,logo:a.logo,maxZoom:void 0!==a.maxZoom?a.maxZoom:18,minZoom:a.minZoom,projection:a.projection,state:"loading",wrapX:a.wrapX});iw(this)}u(hw,gw);k=hw.prototype;k.pk=function(){return this.i};k.Fp=function(a){pb(this.i,a);iw(this)};k.np=function(a){this.i=a||{};iw(this)};
	function iw(a){var b=JSON.stringify(a.i);if(a.o[b])jw(a,a.o[b]);else{var c="https://"+a.u+".cartodb.com/api/v1/map";a.A&&(c+="/named/"+a.A);var d=new XMLHttpRequest;d.addEventListener("load",a.jl.bind(a,b));d.addEventListener("error",a.il.bind(a));d.open("POST",c);d.setRequestHeader("Content-type","application/json");d.send(JSON.stringify(a.i))}}
	k.jl=function(a,b){var c=b.target;if(!c.status||200<=c.status&&300>c.status){var d;try{d=JSON.parse(c.responseText)}catch(e){It(this,"error");return}jw(this,d);this.o[a]=d;It(this,"ready")}else It(this,"error")};k.il=function(){It(this,"error")};function jw(a,b){a.jb("https://"+b.cdn_url.https+"/"+a.u+"/api/v1/map/"+b.layergroupid+"/{z}/{x}/{y}.png")};function X(a){S.call(this,{attributions:a.attributions,extent:a.extent,logo:a.logo,projection:a.projection,wrapX:a.wrapX});this.C=void 0;this.ia=void 0!==a.distance?a.distance:20;this.A=[];this.Ra=a.geometryFunction||function(a){a=a.U();qa(a instanceof E,10);return a};this.u=a.source;this.u.J("change",X.prototype.Oa,this)}u(X,S);X.prototype.lb=function(){return this.u};X.prototype.Ud=function(a,b,c){this.u.Ud(a,b,c);b!==this.C&&(this.clear(),this.C=b,kw(this),this.dd(this.A))};
	X.prototype.mb=function(a){this.ia=a;this.Oa()};X.prototype.Oa=function(){this.clear();kw(this);this.dd(this.A);this.s()};function kw(a){if(void 0!==a.C){a.A.length=0;for(var b=Ia(),c=a.ia*a.C,d=a.u.Ne(),e={},f=0,g=d.length;f<g;f++){var h=d[f];w(h).toString()in e||!(h=a.Ra(h))||(h=h.X(),Wa(h,b),Ka(b,c,b),h=a.u.Hf(b),h=h.filter(function(a){a=w(a).toString();return a in e?!1:e[a]=!0}),a.A.push(lw(a,h)))}}}
	function lw(a,b){for(var c=[0,0],d=b.length-1;0<=d;--d){var e=a.Ra(b[d]);e?Qe(c,e.X()):b.splice(d,1)}We(c,1/b.length);c=new H(new E(c));c.set("features",b);return c};function mw(a,b){var c=[];Object.keys(b).forEach(function(a){null!==b[a]&&void 0!==b[a]&&c.push(a+"="+encodeURIComponent(b[a]))});var d=c.join("&");a=a.replace(/[?&]$/,"");a=-1===a.indexOf("?")?a+"?":a+"&";return a+d};function nw(a){a=a||{};lv.call(this,{attributions:a.attributions,logo:a.logo,projection:a.projection,resolutions:a.resolutions});this.S=void 0!==a.crossOrigin?a.crossOrigin:null;this.Y=void 0!==a.hidpi?a.hidpi:!0;this.i=a.url;this.g=a.imageLoadFunction?a.imageLoadFunction:rv;this.v=a.params||{};this.M=null;this.o=[0,0];this.C=0;this.A=void 0!==a.ratio?a.ratio:1.5}u(nw,lv);k=nw.prototype;k.rn=function(){return this.v};
	k.Ic=function(a,b,c,d){if(void 0===this.i)return null;b=mv(this,b);c=this.Y?c:1;var e=this.M;if(e&&this.C==this.f&&e.resolution==b&&e.a==c&&Ta(e.D(),a))return e;e={F:"image",FORMAT:"PNG32",TRANSPARENT:!0};pb(e,this.v);a=a.slice();var f=(a[0]+a[2])/2,g=(a[1]+a[3])/2;if(1!=this.A){var h=this.A*hb(a)/2,l=this.A*ib(a)/2;a[0]=f-h;a[1]=g-l;a[2]=f+h;a[3]=g+l}var h=b/c,l=Math.ceil(hb(a)/h),m=Math.ceil(ib(a)/h);a[0]=f-h*l/2;a[2]=f+h*l/2;a[1]=g-h*m/2;a[3]=g+h*m/2;this.o[0]=l;this.o[1]=m;f=a;g=this.o;h=c;d=
	d.nb.split(":").pop();e.SIZE=g[0]+","+g[1];e.BBOX=f.join(",");e.BBOXSR=d;e.IMAGESR=d;e.DPI=Math.round(90*h);d=this.i;f=d.replace(/MapServer\/?$/,"MapServer/export").replace(/ImageServer\/?$/,"ImageServer/exportImage");f==d&&qa(!1,50);e=mw(f,e);this.M=new ts(a,b,c,this.l,e,this.S,this.g);this.C=this.f;B(this.M,"change",this.j,this);return this.M};k.qn=function(){return this.g};k.sn=function(){return this.i};k.tn=function(a){this.M=null;this.g=a;this.s()};
	k.vn=function(a){a!=this.i&&(this.i=a,this.M=null,this.s())};k.wn=function(a){pb(this.v,a);this.M=null;this.s()};function ow(a){lv.call(this,{projection:a.projection,resolutions:a.resolutions});this.S=void 0!==a.crossOrigin?a.crossOrigin:null;this.o=void 0!==a.displayDpi?a.displayDpi:96;this.g=a.params||{};this.C=a.url;this.i=a.imageLoadFunction?a.imageLoadFunction:rv;this.Y=void 0!==a.hidpi?a.hidpi:!0;this.ia=void 0!==a.metersPerUnit?a.metersPerUnit:1;this.v=void 0!==a.ratio?a.ratio:1;this.oa=void 0!==a.useOverlay?a.useOverlay:!1;this.M=null;this.A=0}u(ow,lv);k=ow.prototype;k.yn=function(){return this.g};
	k.Ic=function(a,b,c){b=mv(this,b);c=this.Y?c:1;var d=this.M;if(d&&this.A==this.f&&d.resolution==b&&d.a==c&&Ta(d.D(),a))return d;1!=this.v&&(a=a.slice(),nb(a,this.v));var e=[hb(a)/b*c,ib(a)/b*c];if(void 0!==this.C){var d=this.C,f=jb(a),g=this.ia,h=hb(a),l=ib(a),m=e[0],p=e[1],n=.0254/this.o,e={OPERATION:this.oa?"GETDYNAMICMAPOVERLAYIMAGE":"GETMAPIMAGE",VERSION:"2.0.0",LOCALE:"en",CLIENTAGENT:"ol.source.ImageMapGuide source",CLIP:"1",SETDISPLAYDPI:this.o,SETDISPLAYWIDTH:Math.round(e[0]),SETDISPLAYHEIGHT:Math.round(e[1]),
	SETVIEWSCALE:p*h>m*l?h*g/(m*n):l*g/(p*n),SETVIEWCENTERX:f[0],SETVIEWCENTERY:f[1]};pb(e,this.g);d=mw(d,e);d=new ts(a,b,c,this.l,d,this.S,this.i);B(d,"change",this.j,this)}else d=null;this.M=d;this.A=this.f;return d};k.xn=function(){return this.i};k.An=function(a){pb(this.g,a);this.s()};k.zn=function(a){this.M=null;this.i=a;this.s()};function pw(a){var b=a.imageExtent,c=void 0!==a.crossOrigin?a.crossOrigin:null,d=a.imageLoadFunction?a.imageLoadFunction:rv;lv.call(this,{attributions:a.attributions,logo:a.logo,projection:Gb(a.projection)});this.M=new ts(b,void 0,1,this.l,a.url,c,d);this.i=a.imageSize?a.imageSize:null;B(this.M,"change",this.j,this)}u(pw,lv);pw.prototype.Ic=function(a){return mb(a,this.M.D())?this.M:null};
	pw.prototype.j=function(a){if(2==this.M.V()){var b=this.M.D(),c=this.M.Z(),d,e;this.i?(d=this.i[0],e=this.i[1]):(d=c.width,e=c.height);b=Math.ceil(hb(b)/(ib(b)/e));if(b!=d){var b=Xc(b,e),f=b.canvas;b.drawImage(c,0,0,d,e,0,0,f.width,f.height);this.M.zg(f)}}lv.prototype.j.call(this,a)};function qw(a){a=a||{};lv.call(this,{attributions:a.attributions,logo:a.logo,projection:a.projection,resolutions:a.resolutions});this.ia=void 0!==a.crossOrigin?a.crossOrigin:null;this.g=a.url;this.v=a.imageLoadFunction?a.imageLoadFunction:rv;this.i=a.params||{};this.o=!0;rw(this);this.Y=a.serverType;this.oa=void 0!==a.hidpi?a.hidpi:!0;this.M=null;this.A=[0,0];this.S=0;this.C=void 0!==a.ratio?a.ratio:1.5}u(qw,lv);var sw=[101,101];k=qw.prototype;
	k.Gn=function(a,b,c,d){if(void 0!==this.g){var e=kb(a,b,0,sw),f={SERVICE:"WMS",VERSION:"1.3.0",REQUEST:"GetFeatureInfo",FORMAT:"image/png",TRANSPARENT:!0,QUERY_LAYERS:this.i.LAYERS};pb(f,this.i,d);d=Math.floor((e[3]-a[1])/b);f[this.o?"I":"X"]=Math.floor((a[0]-e[0])/b);f[this.o?"J":"Y"]=d;return tw(this,e,sw,1,Gb(c),f)}};k.In=function(){return this.i};
	k.Ic=function(a,b,c,d){if(void 0===this.g)return null;b=mv(this,b);1==c||this.oa&&void 0!==this.Y||(c=1);var e=b/c,f=jb(a),g=kb(f,b,0,[Math.ceil(hb(a)/e),Math.ceil(ib(a)/e)]);a=kb(f,b,0,[Math.ceil(this.C*hb(a)/e),Math.ceil(this.C*ib(a)/e)]);if((f=this.M)&&this.S==this.f&&f.resolution==b&&f.a==c&&Ta(f.D(),g))return f;g={SERVICE:"WMS",VERSION:"1.3.0",REQUEST:"GetMap",FORMAT:"image/png",TRANSPARENT:!0};pb(g,this.i);this.A[0]=Math.round(hb(a)/e);this.A[1]=Math.round(ib(a)/e);d=tw(this,a,this.A,c,d,g);
	this.M=new ts(a,b,c,this.l,d,this.ia,this.v);this.S=this.f;B(this.M,"change",this.j,this);return this.M};k.Hn=function(){return this.v};
	function tw(a,b,c,d,e,f){qa(void 0!==a.g,9);f[a.o?"CRS":"SRS"]=e.nb;"STYLES"in a.i||(f.STYLES="");if(1!=d)switch(a.Y){case "geoserver":d=90*d+.5|0;f.FORMAT_OPTIONS="FORMAT_OPTIONS"in f?f.FORMAT_OPTIONS+(";dpi:"+d):"dpi:"+d;break;case "mapserver":f.MAP_RESOLUTION=90*d;break;case "carmentaserver":case "qgis":f.DPI=90*d;break;default:qa(!1,8)}f.WIDTH=c[0];f.HEIGHT=c[1];c=e.b;var g;a.o&&"ne"==c.substr(0,2)?g=[b[1],b[0],b[3],b[2]]:g=b;f.BBOX=g.join(",");return mw(a.g,f)}k.Jn=function(){return this.g};
	k.Kn=function(a){this.M=null;this.v=a;this.s()};k.Ln=function(a){a!=this.g&&(this.g=a,this.M=null,this.s())};k.Mn=function(a){pb(this.i,a);rw(this);this.M=null;this.s()};function rw(a){a.o=0<=Pe(a.i.VERSION||"1.3.0")};function uw(a){a=a||{};var b;void 0!==a.attributions?b=a.attributions:b=[vw];gw.call(this,{attributions:b,cacheSize:a.cacheSize,crossOrigin:void 0!==a.crossOrigin?a.crossOrigin:"anonymous",opaque:void 0!==a.opaque?a.opaque:!0,maxZoom:void 0!==a.maxZoom?a.maxZoom:19,reprojectionErrorThreshold:a.reprojectionErrorThreshold,tileLoadFunction:a.tileLoadFunction,url:void 0!==a.url?a.url:"https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png",wrapX:a.wrapX})}u(uw,gw);var vw=new nc({html:'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors.'});(function(){var a={},b={ma:a};(function(c){if("object"===typeof a&&"undefined"!==typeof b)b.ma=c();else{var d;"undefined"!==typeof window?d=window:"undefined"!==typeof global?d=global:"undefined"!==typeof self?d=self:d=this;d.bq=c()}})(function(){return function d(a,b,g){function e(h,l){if(!b[h]){if(!a[h]){var m="function"==typeof require&&require;if(!l&&m)return require(h,!0);if(f)return f(h,!0);m=Error("Cannot find module '"+h+"'");throw m.code="MODULE_NOT_FOUND",m;}m=b[h]={ma:{}};a[h][0].call(m.ma,function(b){var d=
	a[h][1][b];return e(d?d:b)},m,m.ma,d,a,b,g)}return b[h].ma}for(var f="function"==typeof require&&require,m=0;m<g.length;m++)e(g[m]);return e}({1:[function(a,b,f){a=a("./processor");f.yj=a},{"./processor":2}],2:[function(a,b){function d(a){var b=!0;try{new ImageData(10,10)}catch(q){b=!1}return function(d){var e=d.buffers,f=d.meta,g=d.width,h=d.height,l=e.length,m=e[0].byteLength;if(d.imageOps){m=Array(l);for(d=0;d<l;++d){var n=m,p=d,q;q=new Uint8ClampedArray(e[d]);var La=g,C=h;q=b?new ImageData(q,
	La,C):{data:q,width:La,height:C};n[p]=q}g=a(m,f).data}else{g=new Uint8ClampedArray(m);h=Array(l);n=Array(l);for(d=0;d<l;++d)h[d]=new Uint8ClampedArray(e[d]),n[d]=[0,0,0,0];for(e=0;e<m;e+=4){for(d=0;d<l;++d)p=h[d],n[d][0]=p[e],n[d][1]=p[e+1],n[d][2]=p[e+2],n[d][3]=p[e+3];d=a(n,f);g[e]=d[0];g[e+1]=d[1];g[e+2]=d[2];g[e+3]=d[3]}}return g.buffer}}function e(a,b){var e=Object.keys(a.lib||{}).map(function(b){return"var "+b+" = "+a.lib[b].toString()+";"}).concat(["var __minion__ = ("+d.toString()+")(",a.operation.toString(),
	");",'self.addEventListener("message", function(event) {',"  var buffer = __minion__(event.data);","  self.postMessage({buffer: buffer, meta: event.data.meta}, [buffer]);","});"]),e=URL.createObjectURL(new Blob(e,{type:"text/javascript"})),e=new Worker(e);e.addEventListener("message",b);return e}function h(a,b){var e=d(a.operation);return{postMessage:function(a){setTimeout(function(){b({data:{buffer:e(a),meta:a.meta}})},0)}}}function l(a){this.uf=!!a.Gl;var b;0===a.threads?b=0:this.uf?b=1:b=a.threads||
	1;var d=[];if(b)for(var f=0;f<b;++f)d[f]=e(a,this.Qg.bind(this,f));else d[0]=h(a,this.Qg.bind(this,0));this.le=d;this.Cd=[];this.Mj=a.Go||Infinity;this.je=0;this.cd={};this.vf=null}var m=a("./util").$l;l.prototype.Eo=function(a,b,d){this.Kj({inputs:a,Ch:b,fd:d});this.Ng()};l.prototype.Kj=function(a){for(this.Cd.push(a);this.Cd.length>this.Mj;)this.Cd.shift().fd(null,null)};l.prototype.Ng=function(){if(0===this.je&&0<this.Cd.length){var a=this.vf=this.Cd.shift(),b=a.inputs[0].width,d=a.inputs[0].height,
	e=a.inputs.map(function(a){return a.data.buffer}),f=this.le.length;this.je=f;if(1===f)this.le[0].postMessage({buffers:e,meta:a.Ch,imageOps:this.uf,width:b,height:d},e);else for(var g=4*Math.ceil(a.inputs[0].data.length/4/f),h=0;h<f;++h){for(var l=h*g,m=[],V=0,Pa=e.length;V<Pa;++V)m.push(e[h].slice(l,l+g));this.le[h].postMessage({buffers:m,meta:a.Ch,imageOps:this.uf,width:b,height:d},m)}}};l.prototype.Qg=function(a,b){this.$p||(this.cd[a]=b.data,--this.je,0===this.je&&this.Nj())};l.prototype.Nj=function(){var a=
	this.vf,b=this.le.length,d,e;if(1===b)d=new Uint8ClampedArray(this.cd[0].buffer),e=this.cd[0].meta;else{var f=a.inputs[0].data.length;d=new Uint8ClampedArray(f);e=Array(f);for(var f=4*Math.ceil(f/4/b),g=0;g<b;++g){var h=g*f;d.set(new Uint8ClampedArray(this.cd[g].buffer),h);e[g]=this.cd[g].meta}}this.vf=null;this.cd={};a.fd(null,m(d,a.inputs[0].width,a.inputs[0].height),e);this.Ng()};b.ma=l},{"./util":3}],3:[function(a,b,f){var d=!0;try{new ImageData(10,10)}catch(l){d=!1}var e=document.createElement("canvas").getContext("2d");
	f.$l=function(a,b,f){if(d)return new ImageData(a,b,f);b=e.createImageData(b,f);b.data.set(a);return b}},{}]},{},[1])(1)});Dj=b.ma})();function ww(a){this.C=null;this.Ha=void 0!==a.operationType?a.operationType:"pixel";this.Oa=void 0!==a.threads?a.threads:1;this.i=xw(a.sources);for(var b=0,c=this.i.length;b<c;++b)B(this.i[b],"change",this.s,this);this.g=Xc();this.ia=new Fe(function(){return 1},this.s.bind(this));for(var b=yw(this.i),c={},d=0,e=b.length;d<e;++d)c[w(b[d].layer)]=b[d];this.o=this.v=null;this.Y={animate:!1,attributions:{},coordinateToPixelTransform:wh(),extent:null,focus:null,index:0,layerStates:c,layerStatesArray:b,
	logos:{},pixelRatio:1,pixelToCoordinateTransform:wh(),postRenderFunctions:[],size:[0,0],skippedFeatureUids:{},tileQueue:this.ia,time:Date.now(),usedTiles:{},viewState:{rotation:0},viewHints:[],wantedTiles:{}};lv.call(this,{});a.operation&&this.A(a.operation,a.lib)}u(ww,lv);ww.prototype.A=function(a,b){this.C=new Dj.yj({operation:a,Gl:"image"===this.Ha,Go:1,lib:b,threads:this.Oa});this.s()};function zw(a,b,c){var d=a.v;return!d||a.f!==d.kp||c!==d.resolution||!Za(b,d.extent)}
	ww.prototype.Z=function(a,b,c,d){c=!0;for(var e,f=0,g=this.i.length;f<g;++f)if(e=this.i[f].a.la(),"ready"!==e.V()){c=!1;break}if(!c)return null;a=a.slice();if(!zw(this,a,b))return this.o;c=this.g.canvas;e=Math.round(hb(a)/b);f=Math.round(ib(a)/b);if(e!==c.width||f!==c.height)c.width=e,c.height=f;e=pb({},this.Y);e.viewState=pb({},e.viewState);var f=jb(a),g=Math.round(hb(a)/b),h=Math.round(ib(a)/b);e.extent=a;e.focus=jb(a);e.size[0]=g;e.size[1]=h;g=e.viewState;g.center=f;g.projection=d;g.resolution=
	b;this.o=d=new us(a,b,1,this.l,c,this.S.bind(this,e));this.v={extent:a,resolution:b,kp:this.f};return d};
	ww.prototype.S=function(a,b){for(var c=this.i.length,d=Array(c),e=0;e<c;++e){var f;f=this.i[e];var g=a,h=a.layerStatesArray[e];if(f.qd(g,h)){var l=g.size[0],m=g.size[1];if(Aw){var p=Aw.canvas;p.width!==l||p.height!==m?Aw=Xc(l,m):Aw.clearRect(0,0,l,m)}else Aw=Xc(l,m);f.I(g,h,Aw);f=Aw.getImageData(0,0,l,m)}else f=null;if(f)d[e]=f;else{d=null;break}}d&&(c={},this.b(new Bw(Cw,a,c)),this.C.Eo(d,c,this.oa.bind(this,a,b)));Ge(a.tileQueue,16,16)};
	ww.prototype.oa=function(a,b,c,d,e){c?b(c):d&&(this.b(new Bw(Dw,a,e)),zw(this,a.extent,a.viewState.resolution/a.pixelRatio)||this.g.putImageData(d,0,0),b(null))};var Aw=null;function yw(a){return a.map(function(a){return eh(a.a)})}function xw(a){for(var b=a.length,c=Array(b),d=0;d<b;++d){var e=d,f=a[d],g=null;f instanceof Xv?(f=new Hv({source:f}),g=new zv(f)):f instanceof lv&&(f=new yv({source:f}),g=new dv(f));c[e]=g}return c}
	function Bw(a,b,c){Bc.call(this,a);this.extent=b.extent;this.resolution=b.viewState.resolution/b.pixelRatio;this.data=c}u(Bw,Bc);ww.prototype.Ic=function(){return null};var Cw="beforeoperations",Dw="afteroperations";function Ew(a){var b=a.layer.indexOf("-"),b=Fw[-1==b?a.layer:a.layer.slice(0,b)],c=Gw[a.layer];gw.call(this,{attributions:Hw,cacheSize:a.cacheSize,crossOrigin:"anonymous",maxZoom:void 0!=a.maxZoom?a.maxZoom:b.maxZoom,minZoom:void 0!=a.minZoom?a.minZoom:b.minZoom,opaque:c.opaque,reprojectionErrorThreshold:a.reprojectionErrorThreshold,tileLoadFunction:a.tileLoadFunction,url:void 0!==a.url?a.url:"https://stamen-tiles-{a-d}.a.ssl.fastly.net/"+a.layer+"/{z}/{x}/{y}."+c.Hb})}u(Ew,gw);
	var Hw=[new nc({html:'Map tiles by <a href="http://stamen.com/">Stamen Design</a>, under <a href="http://creativecommons.org/licenses/by/3.0/">CC BY 3.0</a>.'}),vw],Gw={terrain:{Hb:"jpg",opaque:!0},"terrain-background":{Hb:"jpg",opaque:!0},"terrain-labels":{Hb:"png",opaque:!1},"terrain-lines":{Hb:"png",opaque:!1},"toner-background":{Hb:"png",opaque:!0},toner:{Hb:"png",opaque:!0},"toner-hybrid":{Hb:"png",opaque:!1},"toner-labels":{Hb:"png",opaque:!1},"toner-lines":{Hb:"png",opaque:!1},"toner-lite":{Hb:"png",
	opaque:!0},watercolor:{Hb:"jpg",opaque:!0}},Fw={terrain:{minZoom:4,maxZoom:18},toner:{minZoom:0,maxZoom:20},watercolor:{minZoom:1,maxZoom:16}};function Iw(a){a=a||{};W.call(this,{attributions:a.attributions,cacheSize:a.cacheSize,crossOrigin:a.crossOrigin,logo:a.logo,projection:a.projection,reprojectionErrorThreshold:a.reprojectionErrorThreshold,tileGrid:a.tileGrid,tileLoadFunction:a.tileLoadFunction,url:a.url,urls:a.urls,wrapX:void 0!==a.wrapX?a.wrapX:!0});this.i=a.params||{};this.o=Ia();Yv(this,Jw(this))}u(Iw,W);function Jw(a){var b=0,c=[],d;for(d in a.i)c[b++]=d+"-"+a.i[d];return c.join("/")}Iw.prototype.u=function(){return this.i};
	Iw.prototype.pb=function(a){return a};
	Iw.prototype.Fc=function(a,b,c){var d=this.tileGrid;d||(d=this.Ib(c));if(!(d.b.length<=a[0])){var e=d.Ta(a,this.o),f=Ga(d.fb(a[0]),this.j);1!=b&&(f=Fa(f,b,this.j));d={F:"image",FORMAT:"PNG32",TRANSPARENT:!0};pb(d,this.i);var g=this.urls;g?(c=c.nb.split(":").pop(),d.SIZE=f[0]+","+f[1],d.BBOX=e.join(","),d.BBOXSR=c,d.IMAGESR=c,d.DPI=Math.round(d.DPI?d.DPI*b:90*b),a=(1==g.length?g[0]:g[Ca((a[1]<<a[0])+a[2],g.length)]).replace(/MapServer\/?$/,"MapServer/export").replace(/ImageServer\/?$/,"ImageServer/exportImage"),
	a=mw(a,d)):a=void 0;return a}};Iw.prototype.A=function(a){pb(this.i,a);Yv(this,Jw(this))};function Kw(a){Xv.call(this,{opaque:!1,projection:a.projection,tileGrid:a.tileGrid,wrapX:void 0!==a.wrapX?a.wrapX:!0})}u(Kw,Xv);Kw.prototype.Lc=function(a,b,c){var d=this.Sb(a,b,c);if(this.a.b.hasOwnProperty(d))return this.a.get(d);var e=Ga(this.tileGrid.fb(a));a=[a,b,c];b=(b=Zv(this,a))?Zv(this,b).toString():"";e=new Lw(a,e,b);this.a.set(d,e);return e};function Lw(a,b,c){vs.call(this,a,2);this.c=b;this.Fa=c;this.f=null}u(Lw,vs);
	Lw.prototype.Z=function(){if(this.f)return this.f;var a=this.c,b=Xc(a[0],a[1]);b.strokeStyle="black";b.strokeRect(.5,.5,a[0]+.5,a[1]+.5);b.fillStyle="black";b.textAlign="center";b.textBaseline="middle";b.font="24px sans-serif";b.fillText(this.Fa,a[0]/2,a[1]/2);return this.f=b.canvas};Lw.prototype.load=function(){};function Mw(a){this.i=null;W.call(this,{attributions:a.attributions,cacheSize:a.cacheSize,crossOrigin:a.crossOrigin,projection:Gb("EPSG:3857"),reprojectionErrorThreshold:a.reprojectionErrorThreshold,state:"loading",tileLoadFunction:a.tileLoadFunction,wrapX:void 0!==a.wrapX?a.wrapX:!0});if(a.jsonp)Ov(a.url,this.di.bind(this),this.Le.bind(this));else{var b=new XMLHttpRequest;b.addEventListener("load",this.On.bind(this));b.addEventListener("error",this.Nn.bind(this));b.open("GET",a.url);b.send()}}
	u(Mw,W);k=Mw.prototype;k.On=function(a){a=a.target;if(!a.status||200<=a.status&&300>a.status){var b;try{b=JSON.parse(a.responseText)}catch(c){this.Le();return}this.di(b)}else this.Le()};k.Nn=function(){this.Le()};k.Vk=function(){return this.i};
	k.di=function(a){var b=Gb("EPSG:4326"),c=this.c,d;if(a.bounds){var e=Fb(b,c);d=ob(a.bounds,e)}var f=a.minzoom||0,e=a.maxzoom||22;this.tileGrid=c=mc({extent:kc(c),maxZoom:e,minZoom:f});this.tileUrlFunction=Rv(a.tiles,c);if(void 0!==a.attribution&&!this.l){b=void 0!==d?d:b.D();d={};for(var g;f<=e;++f)g=f.toString(),d[g]=[cc(c,b,f)];this.ua([new nc({html:a.attribution,tileRanges:d})])}this.i=a;It(this,"ready")};k.Le=function(){It(this,"error")};function Nw(a){Xv.call(this,{projection:Gb("EPSG:3857"),state:"loading"});this.v=void 0!==a.preemptive?a.preemptive:!0;this.o=Tv;this.g=void 0;this.i=a.jsonp||!1;if(a.url)if(this.i)Ov(a.url,this.bg.bind(this),this.Me.bind(this));else{var b=new XMLHttpRequest;b.addEventListener("load",this.Sn.bind(this));b.addEventListener("error",this.Rn.bind(this));b.open("GET",a.url);b.send()}else a.tileJSON?this.bg(a.tileJSON):qa(!1,51)}u(Nw,Xv);k=Nw.prototype;
	k.Sn=function(a){a=a.target;if(!a.status||200<=a.status&&300>a.status){var b;try{b=JSON.parse(a.responseText)}catch(c){this.Me();return}this.bg(b)}else this.Me()};k.Rn=function(){this.Me()};k.Sk=function(){return this.g};k.dk=function(a,b,c,d,e){this.tileGrid?(b=this.tileGrid.we(a,b),Ow(this.Lc(b[0],b[1],b[2],1,this.c),a,c,d,e)):!0===e?setTimeout(function(){c.call(d,null)},0):c.call(d,null)};k.Me=function(){It(this,"error")};
	k.bg=function(a){var b=Gb("EPSG:4326"),c=this.c,d;if(a.bounds){var e=Fb(b,c);d=ob(a.bounds,e)}var f=a.minzoom||0,e=a.maxzoom||22;this.tileGrid=c=mc({extent:kc(c),maxZoom:e,minZoom:f});this.g=a.template;var g=a.grids;if(g){this.o=Rv(g,c);if(void 0!==a.attribution){b=void 0!==d?d:b.D();for(d={};f<=e;++f)g=f.toString(),d[g]=[cc(c,b,f)];this.ua([new nc({html:a.attribution,tileRanges:d})])}It(this,"ready")}else It(this,"error")};
	k.Lc=function(a,b,c,d,e){var f=this.Sb(a,b,c);if(this.a.b.hasOwnProperty(f))return this.a.get(f);a=[a,b,c];b=Zv(this,a,e);d=this.o(b,d,e);d=new Pw(a,void 0!==d?0:4,void 0!==d?d:"",this.tileGrid.Ta(a),this.v,this.i);this.a.set(f,d);return d};k.Eg=function(a,b,c){a=this.Sb(a,b,c);this.a.b.hasOwnProperty(a)&&this.a.get(a)};function Pw(a,b,c,d,e,f){vs.call(this,a,b);this.o=c;this.f=d;this.I=e;this.c=this.j=this.g=null;this.v=f}u(Pw,vs);k=Pw.prototype;k.Z=function(){return null};
	k.getData=function(a){if(!this.g||!this.j)return null;var b=this.g[Math.floor((1-(a[1]-this.f[1])/(this.f[3]-this.f[1]))*this.g.length)];if("string"!==typeof b)return null;b=b.charCodeAt(Math.floor((a[0]-this.f[0])/(this.f[2]-this.f[0])*b.length));93<=b&&b--;35<=b&&b--;b-=32;a=null;b in this.j&&(b=this.j[b],this.c&&b in this.c?a=this.c[b]:a=b);return a};
	function Ow(a,b,c,d,e){0==a.state&&!0===e?(wc(a,"change",function(){c.call(d,this.getData(b))},a),Qw(a)):!0===e?setTimeout(function(){c.call(d,this.getData(b))}.bind(a),0):c.call(d,a.getData(b))}k.ib=function(){return this.o};k.xe=function(){this.state=3;this.s()};k.ei=function(a){this.g=a.grid;this.j=a.keys;this.c=a.data;this.state=4;this.s()};
	function Qw(a){if(0==a.state)if(a.state=1,a.v)Ov(a.o,a.ei.bind(a),a.xe.bind(a));else{var b=new XMLHttpRequest;b.addEventListener("load",a.Qn.bind(a));b.addEventListener("error",a.Pn.bind(a));b.open("GET",a.o);b.send()}}k.Qn=function(a){a=a.target;if(!a.status||200<=a.status&&300>a.status){var b;try{b=JSON.parse(a.responseText)}catch(c){this.xe();return}this.ei(b)}else this.xe()};k.Pn=function(){this.xe()};k.load=function(){this.I&&Qw(this)};function Rw(a){a=a||{};var b=a.params||{};W.call(this,{attributions:a.attributions,cacheSize:a.cacheSize,crossOrigin:a.crossOrigin,logo:a.logo,opaque:!("TRANSPARENT"in b?b.TRANSPARENT:1),projection:a.projection,reprojectionErrorThreshold:a.reprojectionErrorThreshold,tileGrid:a.tileGrid,tileLoadFunction:a.tileLoadFunction,url:a.url,urls:a.urls,wrapX:void 0!==a.wrapX?a.wrapX:!0});this.u=void 0!==a.gutter?a.gutter:0;this.i=b;this.o=!0;this.A=a.serverType;this.Y=void 0!==a.hidpi?a.hidpi:!0;this.S="";
	Sw(this);this.ea=Ia();Tw(this);Yv(this,Uw(this))}u(Rw,W);k=Rw.prototype;
	k.Tn=function(a,b,c,d){c=Gb(c);var e=this.tileGrid;e||(e=this.Ib(c));b=e.we(a,b);if(!(e.b.length<=b[0])){var f=e.La(b[0]),g=e.Ta(b,this.ea),e=Ga(e.fb(b[0]),this.j),h=this.u;h&&(e=Ea(e,h,this.j),g=Ka(g,f*h,g));h={SERVICE:"WMS",VERSION:"1.3.0",REQUEST:"GetFeatureInfo",FORMAT:"image/png",TRANSPARENT:!0,QUERY_LAYERS:this.i.LAYERS};pb(h,this.i,d);d=Math.floor((g[3]-a[1])/f);h[this.o?"I":"X"]=Math.floor((a[0]-g[0])/f);h[this.o?"J":"Y"]=d;return Vw(this,b,e,g,1,c,h)}};k.Kf=function(){return this.u};
	k.Sb=function(a,b,c){return this.S+W.prototype.Sb.call(this,a,b,c)};k.Un=function(){return this.i};
	function Vw(a,b,c,d,e,f,g){var h=a.urls;if(h){g.WIDTH=c[0];g.HEIGHT=c[1];g[a.o?"CRS":"SRS"]=f.nb;"STYLES"in a.i||(g.STYLES="");if(1!=e)switch(a.A){case "geoserver":c=90*e+.5|0;g.FORMAT_OPTIONS="FORMAT_OPTIONS"in g?g.FORMAT_OPTIONS+(";dpi:"+c):"dpi:"+c;break;case "mapserver":g.MAP_RESOLUTION=90*e;break;case "carmentaserver":case "qgis":g.DPI=90*e;break;default:qa(!1,52)}f=f.b;a.o&&"ne"==f.substr(0,2)&&(a=d[0],d[0]=d[1],d[1]=a,a=d[2],d[2]=d[3],d[3]=a);g.BBOX=d.join(",");return mw(1==h.length?h[0]:h[Ca((b[1]<<
	b[0])+b[2],h.length)],g)}}k.pb=function(a){return this.Y&&void 0!==this.A?a:1};function Sw(a){var b=0,c=[];if(a.urls){var d,e;d=0;for(e=a.urls.length;d<e;++d)c[b++]=a.urls[d]}a.S=c.join("#")}function Uw(a){var b=0,c=[],d;for(d in a.i)c[b++]=d+"-"+a.i[d];return c.join("/")}
	k.Fc=function(a,b,c){var d=this.tileGrid;d||(d=this.Ib(c));if(!(d.b.length<=a[0])){1==b||this.Y&&void 0!==this.A||(b=1);var e=d.La(a[0]),f=d.Ta(a,this.ea),d=Ga(d.fb(a[0]),this.j),g=this.u;g&&(d=Ea(d,g,this.j),f=Ka(f,e*g,f));1!=b&&(d=Fa(d,b,this.j));e={SERVICE:"WMS",VERSION:"1.3.0",REQUEST:"GetMap",FORMAT:"image/png",TRANSPARENT:!0};pb(e,this.i);return Vw(this,a,d,f,b,c,e)}};k.cb=function(a){W.prototype.cb.call(this,a);Sw(this)};k.Vn=function(a){pb(this.i,a);Sw(this);Tw(this);Yv(this,Uw(this))};
	function Tw(a){a.o=0<=Pe(a.i.VERSION||"1.3.0")};function Ww(a,b,c,d,e){vs.call(this,a,b);this.c=Xc();this.j=d;this.g=null;this.f={Ld:!1,wg:null,af:-1,xg:-1,vd:null};this.I=e;this.o=c}u(Ww,vs);k=Ww.prototype;k.Z=function(){return-1==this.f.xg?null:this.c.canvas};k.rm=function(){return this.j};k.ib=function(){return this.o};k.load=function(){0==this.state&&(this.state=1,this.s(),this.I(this,this.o),this.v(null,NaN,null))};k.po=function(a,b){this.Xf(b);this.Hi(a)};k.oo=function(){this.state=3;this.s()};k.Hi=function(a){this.g=a;this.state=2;this.s()};
	k.Xf=function(a){this.l=a};k.Mi=function(a){this.v=a};function Xw(a,b){a.Mi(Al(b,a.j,a.po.bind(a),a.oo.bind(a)))};function Yw(a){aw.call(this,{attributions:a.attributions,cacheSize:void 0!==a.cacheSize?a.cacheSize:128,extent:a.extent,logo:a.logo,opaque:!1,projection:a.projection,state:a.state,tileGrid:a.tileGrid,tileLoadFunction:a.tileLoadFunction?a.tileLoadFunction:Xw,tileUrlFunction:a.tileUrlFunction,tilePixelRatio:a.tilePixelRatio,url:a.url,urls:a.urls,wrapX:void 0===a.wrapX?!0:a.wrapX});this.i=a.format?a.format:null;this.g=void 0==a.overlaps?!0:a.overlaps;this.tileClass=a.tileClass?a.tileClass:Ww}u(Yw,aw);
	Yw.prototype.Lc=function(a,b,c,d,e){var f=this.Sb(a,b,c);if(this.a.b.hasOwnProperty(f))return this.a.get(f);a=[a,b,c];d=(b=Zv(this,a,e))?this.tileUrlFunction(b,d,e):void 0;d=new this.tileClass(a,void 0!==d?0:4,void 0!==d?d:"",this.i,this.tileLoadFunction);B(d,"change",this.gi,this);this.a.set(f,d);return d};Yw.prototype.pb=function(a){return void 0==a?aw.prototype.pb.call(this,a):a};Yw.prototype.Sd=function(a,b){var c=Ga(this.tileGrid.fb(a));return[Math.round(c[0]*b),Math.round(c[1]*b)]};function Zw(a){this.j=a.matrixIds;$b.call(this,{extent:a.extent,origin:a.origin,origins:a.origins,resolutions:a.resolutions,tileSize:a.tileSize,tileSizes:a.tileSizes,sizes:a.sizes})}u(Zw,$b);Zw.prototype.o=function(){return this.j};
	function $w(a,b,c){var d=[],e=[],f=[],g=[],h=[],l=void 0!==c?c:[];c=Gb(a.SupportedCRS.replace(/urn:ogc:def:crs:(\w+):(.*:)?(\w+)$/,"$1:$3"));var m=c.sc(),p="ne"==c.b.substr(0,2);a.TileMatrix.sort(function(a,b){return b.ScaleDenominator-a.ScaleDenominator});a.TileMatrix.forEach(function(a){var b;0<l.length?b=ha(l,function(b){return a.Identifier==b.TileMatrix}):b=!0;if(b){e.push(a.Identifier);b=2.8E-4*a.ScaleDenominator/m;var c=a.TileWidth,n=a.TileHeight;p?f.push([a.TopLeftCorner[1],a.TopLeftCorner[0]]):
	f.push(a.TopLeftCorner);d.push(b);g.push(c==n?c:[c,n]);h.push([a.MatrixWidth,-a.MatrixHeight])}});return new Zw({extent:b,origins:f,resolutions:d,matrixIds:e,tileSizes:g,sizes:h})};function Y(a){function b(a){a="KVP"==d?mw(a,f):a.replace(/\{(\w+?)\}/g,function(a,b){return b.toLowerCase()in f?f[b.toLowerCase()]:a});return function(b){if(b){var c={TileMatrix:e.j[b[0]],TileCol:b[1],TileRow:-b[2]-1};pb(c,g);b=a;return b="KVP"==d?mw(b,c):b.replace(/\{(\w+?)\}/g,function(a,b){return c[b]})}}}this.ea=void 0!==a.version?a.version:"1.0.0";this.u=void 0!==a.format?a.format:"image/jpeg";this.i=a.dimensions?a.dimensions:{};this.A=a.layer;this.o=a.matrixSet;this.S=a.style;var c=a.urls;void 0===
	c&&void 0!==a.url&&(c=Uv(a.url));var d=this.Y=void 0!==a.requestEncoding?a.requestEncoding:"KVP",e=a.tileGrid,f={layer:this.A,style:this.S,tilematrixset:this.o};"KVP"==d&&pb(f,{Service:"WMTS",Request:"GetTile",Version:this.ea,Format:this.u});var g=this.i,h=c&&0<c.length?Sv(c.map(b)):Tv;W.call(this,{attributions:a.attributions,cacheSize:a.cacheSize,crossOrigin:a.crossOrigin,logo:a.logo,projection:a.projection,reprojectionErrorThreshold:a.reprojectionErrorThreshold,tileClass:a.tileClass,tileGrid:e,
	tileLoadFunction:a.tileLoadFunction,tilePixelRatio:a.tilePixelRatio,tileUrlFunction:h,urls:c,wrapX:void 0!==a.wrapX?a.wrapX:!1});Yv(this,ax(this))}u(Y,W);k=Y.prototype;k.rk=function(){return this.i};k.Wn=function(){return this.u};k.Xn=function(){return this.A};k.Fk=function(){return this.o};k.Qk=function(){return this.Y};k.Yn=function(){return this.S};k.Xk=function(){return this.ea};function ax(a){var b=0,c=[],d;for(d in a.i)c[b++]=d+"-"+a.i[d];return c.join("/")}
	k.Gp=function(a){pb(this.i,a);Yv(this,ax(this))};function bx(a){a=a||{};var b=a.size,c=b[0],d=b[1],e=[],f=256;switch(void 0!==a.tierSizeCalculation?a.tierSizeCalculation:cx){case cx:for(;c>f||d>f;)e.push([Math.ceil(c/f),Math.ceil(d/f)]),f+=f;break;case dx:for(;c>f||d>f;)e.push([Math.ceil(c/f),Math.ceil(d/f)]),c>>=1,d>>=1;break;default:qa(!1,53)}e.push([1,1]);e.reverse();for(var f=[1],g=[0],d=1,c=e.length;d<c;d++)f.push(1<<d),g.push(e[d-1][0]*e[d-1][1]+g[d-1]);f.reverse();b=[0,-b[1],b[0],0];b=new $b({extent:b,origin:eb(b),resolutions:f});(f=a.url)&&
	-1==f.indexOf("{TileGroup}")&&(f+="{TileGroup}/{z}-{x}-{y}.jpg");f=Uv(f);f=Sv(f.map(function(a){return function(b){if(b){var c=b[0],d=b[1];b=-b[2]-1;var f={z:c,x:d,y:b,TileGroup:"TileGroup"+((d+b*e[c][0]+g[c])/256|0)};return a.replace(/\{(\w+?)\}/g,function(a,b){return f[b]})}}}));W.call(this,{attributions:a.attributions,cacheSize:a.cacheSize,crossOrigin:a.crossOrigin,logo:a.logo,projection:a.projection,reprojectionErrorThreshold:a.reprojectionErrorThreshold,tileClass:ex,tileGrid:b,tileUrlFunction:f})}
	u(bx,W);function ex(a,b,c,d,e){xs.call(this,a,b,c,d,e);this.f=null}u(ex,xs);ex.prototype.Z=function(){if(this.f)return this.f;var a=xs.prototype.Z.call(this);if(2==this.state){if(256==a.width&&256==a.height)return this.f=a;var b=Xc(256,256);b.drawImage(a,0,0);return this.f=b.canvas}return a};var cx="default",dx="truncated";function fx(a,b){this.b=b;this.a=[{x:0,y:0,width:a,height:a}];this.c={};this.f=Xc(a,a);this.i=this.f.canvas}fx.prototype.get=function(a){return this.c[a]||null};
	fx.prototype.add=function(a,b,c,d,e){var f,g,h;g=0;for(h=this.a.length;g<h;++g)if(f=this.a[g],f.width>=b+this.b&&f.height>=c+this.b)return h={offsetX:f.x+this.b,offsetY:f.y+this.b,image:this.i},this.c[a]=h,d.call(e,this.f,f.x+this.b,f.y+this.b),a=g,b+=this.b,d=c+this.b,f.width-b>f.height-d?(c={x:f.x+b,y:f.y,width:f.width-b,height:f.height},b={x:f.x,y:f.y+d,width:b,height:f.height-d},gx(this,a,c,b)):(c={x:f.x+b,y:f.y,width:f.width-b,height:d},b={x:f.x,y:f.y+d,width:f.width,height:f.height-d},gx(this,
	a,c,b)),h;return null};function gx(a,b,c,d){b=[b,1];0<c.width&&0<c.height&&b.push(c);0<d.width&&0<d.height&&b.push(d);a.a.splice.apply(a.a,b)};function hx(a){a=a||{};this.a=void 0!==a.initialSize?a.initialSize:256;this.f=void 0!==a.maxSize?a.maxSize:void 0!==ba?ba:2048;this.b=void 0!==a.space?a.space:1;this.i=[new fx(this.a,this.b)];this.c=this.a;this.g=[new fx(this.c,this.b)]}hx.prototype.add=function(a,b,c,d,e,f){if(b+this.b>this.f||c+this.b>this.f)return null;d=ix(this,!1,a,b,c,d,f);if(!d)return null;a=ix(this,!0,a,b,c,e?e:na,f);return{offsetX:d.offsetX,offsetY:d.offsetY,image:d.image,Fl:a.image}};
	function ix(a,b,c,d,e,f,g){var h=b?a.g:a.i,l,m,p;m=0;for(p=h.length;m<p;++m){l=h[m];if(l=l.add(c,d,e,f,g))return l;l||m!==p-1||(b?(l=Math.min(2*a.c,a.f),a.c=l):(l=Math.min(2*a.a,a.f),a.a=l),l=new fx(l,a.b),h.push(l),++p)}return null};pa.prototype.code=pa.prototype.code;t("ol.Attribution",nc);nc.prototype.getHTML=nc.prototype.f;t("ol.Collection",D);D.prototype.clear=D.prototype.clear;D.prototype.extend=D.prototype.Tf;D.prototype.forEach=D.prototype.forEach;D.prototype.getArray=D.prototype.am;D.prototype.item=D.prototype.item;D.prototype.getLength=D.prototype.ec;D.prototype.insertAt=D.prototype.Be;D.prototype.pop=D.prototype.pop;D.prototype.push=D.prototype.push;D.prototype.remove=D.prototype.remove;D.prototype.removeAt=D.prototype.tg;
	D.prototype.setAt=D.prototype.mp;Nc.prototype.element=Nc.prototype.element;t("ol.color.asArray",Qc);t("ol.color.asString",Sc);t("ol.colorlike.asColorLike",Vc);t("ol.control.defaults",nd);t("ol.coordinate.add",Qe);t("ol.coordinate.createStringXY",function(a){return function(b){return $e(b,a)}});t("ol.coordinate.format",Te);t("ol.coordinate.rotate",Ve);t("ol.coordinate.toStringHDMS",function(a,b){return a?Se(a[1],"NS",b)+" "+Se(a[0],"EW",b):""});t("ol.coordinate.toStringXY",$e);
	t("ol.DeviceOrientation",Pk);Pk.prototype.getAlpha=Pk.prototype.jk;Pk.prototype.getBeta=Pk.prototype.mk;Pk.prototype.getGamma=Pk.prototype.uk;Pk.prototype.getHeading=Pk.prototype.bm;Pk.prototype.getTracking=Pk.prototype.Fh;Pk.prototype.setTracking=Pk.prototype.Uf;t("ol.easing.easeIn",ed);t("ol.easing.easeOut",fd);t("ol.easing.inAndOut",gd);t("ol.easing.linear",hd);t("ol.easing.upAndDown",function(a){return.5>a?gd(2*a):1-gd(2*(a-.5))});t("ol.extent.boundingExtent",Ha);t("ol.extent.buffer",Ka);
	t("ol.extent.containsCoordinate",Qa);t("ol.extent.containsExtent",Ta);t("ol.extent.containsXY",Sa);t("ol.extent.createEmpty",Ia);t("ol.extent.equals",Za);t("ol.extent.extend",$a);t("ol.extent.getBottomLeft",bb);t("ol.extent.getBottomRight",cb);t("ol.extent.getCenter",jb);t("ol.extent.getHeight",ib);t("ol.extent.getIntersection",lb);t("ol.extent.getSize",function(a){return[a[2]-a[0],a[3]-a[1]]});t("ol.extent.getTopLeft",eb);t("ol.extent.getTopRight",db);t("ol.extent.getWidth",hb);
	t("ol.extent.intersects",mb);t("ol.extent.isEmpty",gb);t("ol.extent.applyTransform",ob);t("ol.Feature",H);H.prototype.clone=H.prototype.clone;H.prototype.getGeometry=H.prototype.U;H.prototype.getId=H.prototype.dm;H.prototype.getGeometryName=H.prototype.wk;H.prototype.getStyle=H.prototype.em;H.prototype.getStyleFunction=H.prototype.Nc;H.prototype.setGeometry=H.prototype.Sa;H.prototype.setStyle=H.prototype.Vf;H.prototype.setId=H.prototype.kc;H.prototype.setGeometryName=H.prototype.Vc;
	t("ol.featureloader.xhr",Bl);t("ol.Geolocation",hs);hs.prototype.getAccuracy=hs.prototype.hk;hs.prototype.getAccuracyGeometry=hs.prototype.ik;hs.prototype.getAltitude=hs.prototype.kk;hs.prototype.getAltitudeAccuracy=hs.prototype.lk;hs.prototype.getHeading=hs.prototype.fm;hs.prototype.getPosition=hs.prototype.gm;hs.prototype.getProjection=hs.prototype.Gh;hs.prototype.getSpeed=hs.prototype.Rk;hs.prototype.getTracking=hs.prototype.Hh;hs.prototype.getTrackingOptions=hs.prototype.th;
	hs.prototype.setProjection=hs.prototype.Ih;hs.prototype.setTracking=hs.prototype.Ee;hs.prototype.setTrackingOptions=hs.prototype.Si;t("ol.Graticule",ns);ns.prototype.getMap=ns.prototype.jm;ns.prototype.getMeridians=ns.prototype.Gk;ns.prototype.getParallels=ns.prototype.Nk;ns.prototype.setMap=ns.prototype.setMap;t("ol.has.DEVICE_PIXEL_RATIO",Kd);t("ol.has.CANVAS",Md);t("ol.has.DEVICE_ORIENTATION",Nd);t("ol.has.GEOLOCATION",Od);t("ol.has.TOUCH",Pd);t("ol.has.WEBGL",Ed);ts.prototype.getImage=ts.prototype.Z;
	ts.prototype.load=ts.prototype.load;xs.prototype.getImage=xs.prototype.Z;t("ol.inherits",u);t("ol.interaction.defaults",ch);t("ol.Kinetic",Zf);t("ol.loadingstrategy.all",Ft);t("ol.loadingstrategy.bbox",function(a){return[a]});t("ol.loadingstrategy.tile",function(a){return function(b,c){var d=a.Mc(c),e=cc(a,b,d),f=[],d=[d,0,0];for(d[1]=e.da;d[1]<=e.ba;++d[1])for(d[2]=e.fa;d[2]<=e.ja;++d[2])f.push(a.Ta(d));return f}});t("ol.Map",G);G.prototype.addControl=G.prototype.Rj;G.prototype.addInteraction=G.prototype.Sj;
	G.prototype.addLayer=G.prototype.Sg;G.prototype.addOverlay=G.prototype.Tg;G.prototype.forEachFeatureAtPixel=G.prototype.re;G.prototype.forEachLayerAtPixel=G.prototype.pm;G.prototype.hasFeatureAtPixel=G.prototype.El;G.prototype.getEventCoordinate=G.prototype.sk;G.prototype.getEventPixel=G.prototype.te;G.prototype.getTarget=G.prototype.Of;G.prototype.getTargetElement=G.prototype.Kc;G.prototype.getCoordinateFromPixel=G.prototype.Za;G.prototype.getControls=G.prototype.qk;G.prototype.getOverlays=G.prototype.Lk;
	G.prototype.getOverlayById=G.prototype.Kk;G.prototype.getInteractions=G.prototype.xk;G.prototype.getLayerGroup=G.prototype.Jc;G.prototype.getLayers=G.prototype.Jh;G.prototype.getPixelFromCoordinate=G.prototype.Ka;G.prototype.getSize=G.prototype.Mb;G.prototype.getView=G.prototype.$;G.prototype.getViewport=G.prototype.Yk;G.prototype.renderSync=G.prototype.ip;G.prototype.render=G.prototype.render;G.prototype.removeControl=G.prototype.ap;G.prototype.removeInteraction=G.prototype.bp;
	G.prototype.removeLayer=G.prototype.ep;G.prototype.removeOverlay=G.prototype.fp;G.prototype.setLayerGroup=G.prototype.Li;G.prototype.setSize=G.prototype.Ag;G.prototype.setTarget=G.prototype.Fe;G.prototype.setView=G.prototype.vp;G.prototype.updateSize=G.prototype.xd;zd.prototype.originalEvent=zd.prototype.originalEvent;zd.prototype.pixel=zd.prototype.pixel;zd.prototype.coordinate=zd.prototype.coordinate;zd.prototype.dragging=zd.prototype.dragging;yd.prototype.map=yd.prototype.map;
	yd.prototype.frameState=yd.prototype.frameState;t("ol.Object",Gc);Gc.prototype.get=Gc.prototype.get;Gc.prototype.getKeys=Gc.prototype.O;Gc.prototype.getProperties=Gc.prototype.N;Gc.prototype.set=Gc.prototype.set;Gc.prototype.setProperties=Gc.prototype.H;Gc.prototype.unset=Gc.prototype.P;Kc.prototype.key=Kc.prototype.key;Kc.prototype.oldValue=Kc.prototype.oldValue;t("ol.Observable",Fc);t("ol.Observable.unByKey",function(a){if(Array.isArray(a))for(var b=0,c=a.length;b<c;++b)rc(a[b]);else rc(a)});
	Fc.prototype.changed=Fc.prototype.s;Fc.prototype.dispatchEvent=Fc.prototype.b;Fc.prototype.getRevision=Fc.prototype.L;Fc.prototype.on=Fc.prototype.J;Fc.prototype.once=Fc.prototype.once;Fc.prototype.un=Fc.prototype.K;t("ol.Overlay",qk);qk.prototype.getElement=qk.prototype.se;qk.prototype.getId=qk.prototype.qm;qk.prototype.getMap=qk.prototype.Ge;qk.prototype.getOffset=qk.prototype.qh;qk.prototype.getPosition=qk.prototype.Kh;qk.prototype.getPositioning=qk.prototype.rh;qk.prototype.setElement=qk.prototype.Gi;
	qk.prototype.setMap=qk.prototype.setMap;qk.prototype.setOffset=qk.prototype.Ni;qk.prototype.setPosition=qk.prototype.Wf;qk.prototype.setPositioning=qk.prototype.Qi;t("ol.proj.METERS_PER_UNIT",vb);t("ol.proj.setProj4",function(a){wb=a});t("ol.proj.getPointResolution",Eb);t("ol.proj.addEquivalentProjections",Hb);t("ol.proj.addProjection",Pb);t("ol.proj.addCoordinateTransforms",Rb);t("ol.proj.fromLonLat",function(a,b){return Wb(a,"EPSG:4326",void 0!==b?b:"EPSG:3857")});
	t("ol.proj.toLonLat",function(a,b){return Wb(a,void 0!==b?b:"EPSG:3857","EPSG:4326")});t("ol.proj.get",Gb);t("ol.proj.equivalent",Tb);t("ol.proj.getTransform",Ub);t("ol.proj.transform",Wb);t("ol.proj.transformExtent",Xb);t("ol.render.toContext",function(a,b){var c=a.canvas,d=b?b:{},e=d.pixelRatio||Kd;if(d=d.size)c.width=d[0]*e,c.height=d[1]*e,c.style.width=d[0]+"px",c.style.height=d[1]+"px";c=[0,0,c.width,c.height];d=Dh(wh(),e,e);return new Sh(a,e,c,d,0)});t("ol.size.toSize",Ga);t("ol.Sphere",tb);
	tb.prototype.geodesicArea=tb.prototype.a;tb.prototype.haversineDistance=tb.prototype.b;vs.prototype.getTileCoord=vs.prototype.i;vs.prototype.load=vs.prototype.load;t("ol.tilegrid.createXYZ",mc);Ww.prototype.getFormat=Ww.prototype.rm;Ww.prototype.setFeatures=Ww.prototype.Hi;Ww.prototype.setProjection=Ww.prototype.Xf;Ww.prototype.setLoader=Ww.prototype.Mi;t("ol.View",Qf);Qf.prototype.animate=Qf.prototype.animate;Qf.prototype.constrainCenter=Qf.prototype.Ec;Qf.prototype.constrainResolution=Qf.prototype.constrainResolution;
	Qf.prototype.constrainRotation=Qf.prototype.constrainRotation;Qf.prototype.getCenter=Qf.prototype.Ba;Qf.prototype.calculateExtent=Qf.prototype.ed;Qf.prototype.getMaxResolution=Qf.prototype.sm;Qf.prototype.getMinResolution=Qf.prototype.tm;Qf.prototype.getProjection=Qf.prototype.um;Qf.prototype.getResolution=Qf.prototype.Ua;Qf.prototype.getResolutions=Qf.prototype.vm;Qf.prototype.getRotation=Qf.prototype.Va;Qf.prototype.getZoom=Qf.prototype.$k;Qf.prototype.fit=Qf.prototype.Ff;
	Qf.prototype.centerOn=Qf.prototype.$j;Qf.prototype.rotate=Qf.prototype.rotate;Qf.prototype.setCenter=Qf.prototype.wb;Qf.prototype.setResolution=Qf.prototype.Xc;Qf.prototype.setRotation=Qf.prototype.He;Qf.prototype.setZoom=Qf.prototype.yp;t("ol.xml.getAllTextContent",jl);t("ol.xml.parse",nl);Ji.prototype.getGL=Ji.prototype.lo;Ji.prototype.useProgram=Ji.prototype.Rc;t("ol.tilegrid.TileGrid",$b);$b.prototype.forEachTileCoord=$b.prototype.eh;$b.prototype.getMaxZoom=$b.prototype.oh;
	$b.prototype.getMinZoom=$b.prototype.ph;$b.prototype.getOrigin=$b.prototype.Qc;$b.prototype.getResolution=$b.prototype.La;$b.prototype.getResolutions=$b.prototype.oi;$b.prototype.getTileCoordExtent=$b.prototype.Ta;$b.prototype.getTileCoordForCoordAndResolution=$b.prototype.we;$b.prototype.getTileCoordForCoordAndZ=$b.prototype.Pf;$b.prototype.getTileSize=$b.prototype.fb;$b.prototype.getZForResolution=$b.prototype.Mc;t("ol.tilegrid.WMTS",Zw);Zw.prototype.getMatrixIds=Zw.prototype.o;
	t("ol.tilegrid.WMTS.createFromCapabilitiesMatrixSet",$w);t("ol.style.AtlasManager",hx);t("ol.style.Circle",Yk);Yk.prototype.setRadius=Yk.prototype.Wc;t("ol.style.Fill",Zk);Zk.prototype.clone=Zk.prototype.clone;Zk.prototype.getColor=Zk.prototype.f;Zk.prototype.setColor=Zk.prototype.c;t("ol.style.Icon",Rn);Rn.prototype.clone=Rn.prototype.clone;Rn.prototype.getAnchor=Rn.prototype.Hc;Rn.prototype.getColor=Rn.prototype.Zn;Rn.prototype.getImage=Rn.prototype.Z;Rn.prototype.getOrigin=Rn.prototype.Pc;
	Rn.prototype.getSrc=Rn.prototype.$n;Rn.prototype.getSize=Rn.prototype.jc;Rn.prototype.load=Rn.prototype.load;t("ol.style.Image",Vk);Vk.prototype.getOpacity=Vk.prototype.Pe;Vk.prototype.getRotateWithView=Vk.prototype.Qe;Vk.prototype.getRotation=Vk.prototype.Re;Vk.prototype.getScale=Vk.prototype.Se;Vk.prototype.getSnapToPixel=Vk.prototype.ve;Vk.prototype.setOpacity=Vk.prototype.rd;Vk.prototype.setRotation=Vk.prototype.Te;Vk.prototype.setScale=Vk.prototype.sd;t("ol.style.RegularShape",Wk);
	Wk.prototype.clone=Wk.prototype.clone;Wk.prototype.getAnchor=Wk.prototype.Hc;Wk.prototype.getAngle=Wk.prototype.ki;Wk.prototype.getFill=Wk.prototype.Ca;Wk.prototype.getImage=Wk.prototype.Z;Wk.prototype.getOrigin=Wk.prototype.Pc;Wk.prototype.getPoints=Wk.prototype.li;Wk.prototype.getRadius=Wk.prototype.mi;Wk.prototype.getRadius2=Wk.prototype.sh;Wk.prototype.getSize=Wk.prototype.jc;Wk.prototype.getStroke=Wk.prototype.Da;t("ol.style.Stroke",rj);rj.prototype.clone=rj.prototype.clone;
	rj.prototype.getColor=rj.prototype.ao;rj.prototype.getLineCap=rj.prototype.Ak;rj.prototype.getLineDash=rj.prototype.bo;rj.prototype.getLineDashOffset=rj.prototype.Bk;rj.prototype.getLineJoin=rj.prototype.Ck;rj.prototype.getMiterLimit=rj.prototype.Hk;rj.prototype.getWidth=rj.prototype.co;rj.prototype.setColor=rj.prototype.eo;rj.prototype.setLineCap=rj.prototype.qp;rj.prototype.setLineDash=rj.prototype.setLineDash;rj.prototype.setLineDashOffset=rj.prototype.rp;rj.prototype.setLineJoin=rj.prototype.sp;
	rj.prototype.setMiterLimit=rj.prototype.tp;rj.prototype.setWidth=rj.prototype.wp;t("ol.style.Style",$k);$k.prototype.clone=$k.prototype.clone;$k.prototype.getGeometry=$k.prototype.U;$k.prototype.getGeometryFunction=$k.prototype.vk;$k.prototype.getFill=$k.prototype.Ca;$k.prototype.setFill=$k.prototype.cf;$k.prototype.getImage=$k.prototype.Z;$k.prototype.setImage=$k.prototype.zg;$k.prototype.getStroke=$k.prototype.Da;$k.prototype.setStroke=$k.prototype.df;$k.prototype.getText=$k.prototype.Pa;
	$k.prototype.setText=$k.prototype.ef;$k.prototype.getZIndex=$k.prototype.za;$k.prototype.setGeometry=$k.prototype.Sa;$k.prototype.setZIndex=$k.prototype.Wb;t("ol.style.Text",Sn);Sn.prototype.clone=Sn.prototype.clone;Sn.prototype.getFont=Sn.prototype.tk;Sn.prototype.getOffsetX=Sn.prototype.Ik;Sn.prototype.getOffsetY=Sn.prototype.Jk;Sn.prototype.getFill=Sn.prototype.Ca;Sn.prototype.getRotateWithView=Sn.prototype.fo;Sn.prototype.getRotation=Sn.prototype.ho;Sn.prototype.getScale=Sn.prototype.io;
	Sn.prototype.getStroke=Sn.prototype.Da;Sn.prototype.getText=Sn.prototype.Pa;Sn.prototype.getTextAlign=Sn.prototype.Tk;Sn.prototype.getTextBaseline=Sn.prototype.Uk;Sn.prototype.setFont=Sn.prototype.Ii;Sn.prototype.setOffsetX=Sn.prototype.Oi;Sn.prototype.setOffsetY=Sn.prototype.Pi;Sn.prototype.setFill=Sn.prototype.cf;Sn.prototype.setRotation=Sn.prototype.jo;Sn.prototype.setScale=Sn.prototype.ni;Sn.prototype.setStroke=Sn.prototype.df;Sn.prototype.setText=Sn.prototype.ef;Sn.prototype.setTextAlign=Sn.prototype.Ri;
	Sn.prototype.setTextBaseline=Sn.prototype.up;t("ol.source.BingMaps",ew);t("ol.source.BingMaps.TOS_ATTRIBUTION",fw);ew.prototype.getApiKey=ew.prototype.Y;ew.prototype.getImagerySet=ew.prototype.ea;t("ol.source.CartoDB",hw);hw.prototype.getConfig=hw.prototype.pk;hw.prototype.updateConfig=hw.prototype.Fp;hw.prototype.setConfig=hw.prototype.np;t("ol.source.Cluster",X);X.prototype.getSource=X.prototype.lb;X.prototype.setDistance=X.prototype.mb;t("ol.source.Image",lv);nv.prototype.image=nv.prototype.image;
	t("ol.source.ImageArcGISRest",nw);nw.prototype.getParams=nw.prototype.rn;nw.prototype.getImageLoadFunction=nw.prototype.qn;nw.prototype.getUrl=nw.prototype.sn;nw.prototype.setImageLoadFunction=nw.prototype.tn;nw.prototype.setUrl=nw.prototype.vn;nw.prototype.updateParams=nw.prototype.wn;t("ol.source.ImageCanvas",sv);t("ol.source.ImageMapGuide",ow);ow.prototype.getParams=ow.prototype.yn;ow.prototype.getImageLoadFunction=ow.prototype.xn;ow.prototype.updateParams=ow.prototype.An;
	ow.prototype.setImageLoadFunction=ow.prototype.zn;t("ol.source.ImageStatic",pw);t("ol.source.ImageVector",tv);tv.prototype.getSource=tv.prototype.Bn;tv.prototype.getStyle=tv.prototype.Cn;tv.prototype.getStyleFunction=tv.prototype.Dn;tv.prototype.setStyle=tv.prototype.ci;t("ol.source.ImageWMS",qw);qw.prototype.getGetFeatureInfoUrl=qw.prototype.Gn;qw.prototype.getParams=qw.prototype.In;qw.prototype.getImageLoadFunction=qw.prototype.Hn;qw.prototype.getUrl=qw.prototype.Jn;
	qw.prototype.setImageLoadFunction=qw.prototype.Kn;qw.prototype.setUrl=qw.prototype.Ln;qw.prototype.updateParams=qw.prototype.Mn;t("ol.source.OSM",uw);t("ol.source.OSM.ATTRIBUTION",vw);t("ol.source.Raster",ww);ww.prototype.setOperation=ww.prototype.A;Bw.prototype.extent=Bw.prototype.extent;Bw.prototype.resolution=Bw.prototype.resolution;Bw.prototype.data=Bw.prototype.data;t("ol.source.Source",Gt);Gt.prototype.getAttributions=Gt.prototype.xa;Gt.prototype.getLogo=Gt.prototype.wa;
	Gt.prototype.getProjection=Gt.prototype.ya;Gt.prototype.getState=Gt.prototype.V;Gt.prototype.refresh=Gt.prototype.va;Gt.prototype.setAttributions=Gt.prototype.ua;t("ol.source.Stamen",Ew);t("ol.source.Tile",Xv);Xv.prototype.getTileGrid=Xv.prototype.ab;$v.prototype.tile=$v.prototype.tile;t("ol.source.TileArcGISRest",Iw);Iw.prototype.getParams=Iw.prototype.u;Iw.prototype.updateParams=Iw.prototype.A;t("ol.source.TileDebug",Kw);t("ol.source.TileImage",W);W.prototype.setRenderReprojectionEdges=W.prototype.Nb;
	W.prototype.setTileGridForProjection=W.prototype.Ob;t("ol.source.TileJSON",Mw);Mw.prototype.getTileJSON=Mw.prototype.Vk;t("ol.source.TileUTFGrid",Nw);Nw.prototype.getTemplate=Nw.prototype.Sk;Nw.prototype.forDataAtCoordinateAndResolution=Nw.prototype.dk;t("ol.source.TileWMS",Rw);Rw.prototype.getGetFeatureInfoUrl=Rw.prototype.Tn;Rw.prototype.getParams=Rw.prototype.Un;Rw.prototype.updateParams=Rw.prototype.Vn;aw.prototype.getTileLoadFunction=aw.prototype.ob;aw.prototype.getTileUrlFunction=aw.prototype.qb;
	aw.prototype.getUrls=aw.prototype.rb;aw.prototype.setTileLoadFunction=aw.prototype.xb;aw.prototype.setTileUrlFunction=aw.prototype.bb;aw.prototype.setUrl=aw.prototype.jb;aw.prototype.setUrls=aw.prototype.cb;t("ol.source.Vector",S);S.prototype.addFeature=S.prototype.zb;S.prototype.addFeatures=S.prototype.dd;S.prototype.clear=S.prototype.clear;S.prototype.forEachFeature=S.prototype.bh;S.prototype.forEachFeatureInExtent=S.prototype.ac;S.prototype.forEachFeatureIntersectingExtent=S.prototype.dh;
	S.prototype.getFeaturesCollection=S.prototype.lh;S.prototype.getFeatures=S.prototype.Ne;S.prototype.getFeaturesAtCoordinate=S.prototype.kh;S.prototype.getFeaturesInExtent=S.prototype.Hf;S.prototype.getClosestFeatureToCoordinate=S.prototype.gh;S.prototype.getExtent=S.prototype.D;S.prototype.getFeatureById=S.prototype.jh;S.prototype.getFormat=S.prototype.hi;S.prototype.getUrl=S.prototype.ii;S.prototype.removeFeature=S.prototype.Db;Nt.prototype.feature=Nt.prototype.feature;t("ol.source.VectorTile",Yw);
	t("ol.source.WMTS",Y);Y.prototype.getDimensions=Y.prototype.rk;Y.prototype.getFormat=Y.prototype.Wn;Y.prototype.getLayer=Y.prototype.Xn;Y.prototype.getMatrixSet=Y.prototype.Fk;Y.prototype.getRequestEncoding=Y.prototype.Qk;Y.prototype.getStyle=Y.prototype.Yn;Y.prototype.getVersion=Y.prototype.Xk;Y.prototype.updateDimensions=Y.prototype.Gp;
	t("ol.source.WMTS.optionsFromCapabilities",function(a,b){var c=ha(a.Contents.Layer,function(a){return a.Identifier==b.layer}),d=a.Contents.TileMatrixSet,e,f,g;e=1<c.TileMatrixSetLink.length?"projection"in b?la(c.TileMatrixSetLink,function(a){var c=ha(d,function(b){return b.Identifier==a.TileMatrixSet}).SupportedCRS.replace(/urn:ogc:def:crs:(\w+):(.*:)?(\w+)$/,"$1:$3"),e=Gb(c),f=Gb(b.projection);return e&&f?Tb(e,f):c==b.projection}):la(c.TileMatrixSetLink,function(a){return a.TileMatrixSet==b.matrixSet}):
	0;0>e&&(e=0);f=c.TileMatrixSetLink[e].TileMatrixSet;g=c.TileMatrixSetLink[e].TileMatrixSetLimits;var h=c.Format[0];"format"in b&&(h=b.format);e=la(c.Style,function(a){return"style"in b?a.Title==b.style:a.isDefault});0>e&&(e=0);e=c.Style[e].Identifier;var l={};"Dimension"in c&&c.Dimension.forEach(function(a){var b=a.Identifier,c=a.Default;void 0===c&&(c=a.Value[0]);l[b]=c});var m=ha(a.Contents.TileMatrixSet,function(a){return a.Identifier==f}),p;p="projection"in b?Gb(b.projection):Gb(m.SupportedCRS.replace(/urn:ogc:def:crs:(\w+):(.*:)?(\w+)$/,
	"$1:$3"));var n=c.WGS84BoundingBox,q,r;void 0!==n&&(r=Gb("EPSG:4326").D(),r=n[0]==r[0]&&n[2]==r[2],q=Xb(n,"EPSG:4326",p),(n=p.D())&&(Ta(n,q)||(q=void 0)));g=$w(m,q,g);var v=[],m=b.requestEncoding,m=void 0!==m?m:"";if("OperationsMetadata"in a&&"GetTile"in a.OperationsMetadata){q=a.OperationsMetadata.GetTile.DCP.HTTP.Get;for(var n=0,x=q.length;n<x;++n){var y=ha(q[n].Constraint,function(a){return"GetEncoding"==a.name}).AllowedValues.Value;""===m&&(m=y[0]);if("KVP"===m)ea(y,"KVP")&&v.push(q[n].href);
	else break}}v.length||(m="REST",c.ResourceURL.forEach(function(a){"tile"===a.resourceType&&(h=a.format,v.push(a.template))}));return{urls:v,layer:b.layer,matrixSet:f,format:h,projection:p,requestEncoding:m,tileGrid:g,style:e,dimensions:l,wrapX:r}});t("ol.source.XYZ",gw);t("ol.source.Zoomify",bx);Mh.prototype.vectorContext=Mh.prototype.vectorContext;Mh.prototype.frameState=Mh.prototype.frameState;Mh.prototype.context=Mh.prototype.context;Mh.prototype.glContext=Mh.prototype.glContext;
	Yp.prototype.get=Yp.prototype.get;Yp.prototype.getExtent=Yp.prototype.D;Yp.prototype.getGeometry=Yp.prototype.U;Yp.prototype.getProperties=Yp.prototype.mn;Yp.prototype.getType=Yp.prototype.T;t("ol.render.VectorContext",Rh);ik.prototype.setStyle=ik.prototype.pd;ik.prototype.drawGeometry=ik.prototype.mc;ik.prototype.drawFeature=ik.prototype.oe;Sh.prototype.drawCircle=Sh.prototype.$b;Sh.prototype.setStyle=Sh.prototype.pd;Sh.prototype.drawGeometry=Sh.prototype.mc;Sh.prototype.drawFeature=Sh.prototype.oe;
	t("ol.proj.common.add",qh);t("ol.proj.Projection",yb);yb.prototype.getCode=yb.prototype.nk;yb.prototype.getExtent=yb.prototype.D;yb.prototype.getUnits=yb.prototype.Jb;yb.prototype.getMetersPerUnit=yb.prototype.sc;yb.prototype.getWorldExtent=yb.prototype.Zk;yb.prototype.isGlobal=yb.prototype.Kl;yb.prototype.setGlobal=yb.prototype.pp;yb.prototype.setExtent=yb.prototype.ln;yb.prototype.setWorldExtent=yb.prototype.xp;yb.prototype.setGetPointResolution=yb.prototype.op;
	t("ol.proj.Units.METERS_PER_UNIT",vb);t("ol.layer.Base",dh);dh.prototype.getExtent=dh.prototype.D;dh.prototype.getMaxResolution=dh.prototype.gc;dh.prototype.getMinResolution=dh.prototype.hc;dh.prototype.getOpacity=dh.prototype.ic;dh.prototype.getVisible=dh.prototype.Kb;dh.prototype.getZIndex=dh.prototype.za;dh.prototype.setExtent=dh.prototype.uc;dh.prototype.setMaxResolution=dh.prototype.zc;dh.prototype.setMinResolution=dh.prototype.Ac;dh.prototype.setOpacity=dh.prototype.vc;
	dh.prototype.setVisible=dh.prototype.wc;dh.prototype.setZIndex=dh.prototype.Wb;t("ol.layer.Group",fh);fh.prototype.getLayers=fh.prototype.od;fh.prototype.setLayers=fh.prototype.Sh;t("ol.layer.Heatmap",T);T.prototype.getBlur=T.prototype.fh;T.prototype.getGradient=T.prototype.mh;T.prototype.getRadius=T.prototype.Th;T.prototype.setBlur=T.prototype.Ei;T.prototype.setGradient=T.prototype.Ki;T.prototype.setRadius=T.prototype.Wc;t("ol.layer.Image",yv);yv.prototype.getSource=yv.prototype.la;
	t("ol.layer.Layer",rh);rh.prototype.getSource=rh.prototype.la;rh.prototype.setMap=rh.prototype.setMap;rh.prototype.setSource=rh.prototype.Yc;t("ol.layer.Tile",Hv);Hv.prototype.getPreload=Hv.prototype.Pd;Hv.prototype.getSource=Hv.prototype.la;Hv.prototype.setPreload=Hv.prototype.Uh;Hv.prototype.getUseInterimTilesOnError=Hv.prototype.Td;Hv.prototype.setUseInterimTilesOnError=Hv.prototype.Vh;t("ol.layer.Vector",R);R.prototype.getSource=R.prototype.la;R.prototype.getStyle=R.prototype.C;
	R.prototype.getStyleFunction=R.prototype.G;R.prototype.setStyle=R.prototype.g;t("ol.layer.VectorTile",U);U.prototype.getPreload=U.prototype.Pd;U.prototype.getUseInterimTilesOnError=U.prototype.Td;U.prototype.setPreload=U.prototype.Wh;U.prototype.setUseInterimTilesOnError=U.prototype.Xh;t("ol.interaction.DoubleClickZoom",eg);t("ol.interaction.DoubleClickZoom.handleEvent",fg);t("ol.interaction.DragAndDrop",zs);t("ol.interaction.DragAndDrop.handleEvent",af);Cs.prototype.features=Cs.prototype.features;
	Cs.prototype.file=Cs.prototype.file;Cs.prototype.projection=Cs.prototype.projection;t("ol.interaction.DragBox",Dg);Dg.prototype.getGeometry=Dg.prototype.U;Ig.prototype.coordinate=Ig.prototype.coordinate;Ig.prototype.mapBrowserEvent=Ig.prototype.mapBrowserEvent;t("ol.interaction.DragPan",sg);t("ol.interaction.DragRotate",wg);t("ol.interaction.DragRotateAndZoom",Es);t("ol.interaction.DragZoom",Mg);t("ol.interaction.Draw",Qt);t("ol.interaction.Draw.handleEvent",St);Qt.prototype.removeLastPoint=Qt.prototype.cp;
	Qt.prototype.finishDrawing=Qt.prototype.Nd;Qt.prototype.extend=Qt.prototype.Om;t("ol.interaction.Draw.createRegularPolygon",function(a,b){return function(c,d){var e=c[0],f=c[1],g=Math.sqrt(Xe(e,f)),h=d?d:Of(new is(e),a);Pf(h,e,g,b?b:Math.atan((f[1]-e[1])/(f[0]-e[0])));return h}});t("ol.interaction.Draw.createBox",function(){return function(a,b){var c=Ha(a),d=b||new F(null);d.pa([[bb(c),cb(c),db(c),eb(c),bb(c)]]);return d}});eu.prototype.feature=eu.prototype.feature;t("ol.interaction.Extent",gu);
	gu.prototype.getExtent=gu.prototype.D;gu.prototype.setExtent=gu.prototype.g;ru.prototype.extent_=ru.prototype.b;t("ol.interaction.Interaction",ag);ag.prototype.getActive=ag.prototype.c;ag.prototype.getMap=ag.prototype.i;ag.prototype.setActive=ag.prototype.Ia;t("ol.interaction.KeyboardPan",Ng);t("ol.interaction.KeyboardPan.handleEvent",Og);t("ol.interaction.KeyboardZoom",Pg);t("ol.interaction.KeyboardZoom.handleEvent",Qg);t("ol.interaction.Modify",tu);t("ol.interaction.Modify.handleEvent",wu);
	tu.prototype.removePoint=tu.prototype.Ci;Bu.prototype.features=Bu.prototype.features;Bu.prototype.mapBrowserEvent=Bu.prototype.mapBrowserEvent;t("ol.interaction.MouseWheelZoom",Rg);t("ol.interaction.MouseWheelZoom.handleEvent",Sg);Rg.prototype.setMouseAnchor=Rg.prototype.S;t("ol.interaction.PinchRotate",Vg);t("ol.interaction.PinchZoom",Zg);t("ol.interaction.Pointer",pg);t("ol.interaction.Pointer.handleEvent",qg);t("ol.interaction.Select",Ju);Ju.prototype.getFeatures=Ju.prototype.Ym;
	Ju.prototype.getHitTolerance=Ju.prototype.Zm;Ju.prototype.getLayer=Ju.prototype.$m;t("ol.interaction.Select.handleEvent",Ku);Ju.prototype.setHitTolerance=Ju.prototype.bn;Ju.prototype.setMap=Ju.prototype.setMap;Mu.prototype.selected=Mu.prototype.selected;Mu.prototype.deselected=Mu.prototype.deselected;Mu.prototype.mapBrowserEvent=Mu.prototype.mapBrowserEvent;t("ol.interaction.Snap",Ou);Ou.prototype.addFeature=Ou.prototype.zb;Ou.prototype.removeFeature=Ou.prototype.Db;t("ol.interaction.Translate",Su);
	Su.prototype.getHitTolerance=Su.prototype.G;Su.prototype.setHitTolerance=Su.prototype.R;Yu.prototype.features=Yu.prototype.features;Yu.prototype.coordinate=Yu.prototype.coordinate;t("ol.geom.Circle",is);is.prototype.clone=is.prototype.clone;is.prototype.getCenter=is.prototype.Ba;is.prototype.getRadius=is.prototype.Vd;is.prototype.getType=is.prototype.T;is.prototype.intersectsExtent=is.prototype.Xa;is.prototype.setCenter=is.prototype.wb;is.prototype.setCenterAndRadius=is.prototype.yg;
	is.prototype.setRadius=is.prototype.Wc;is.prototype.transform=is.prototype.tb;t("ol.geom.Geometry",cf);cf.prototype.getClosestPoint=cf.prototype.Ab;cf.prototype.intersectsCoordinate=cf.prototype.sb;cf.prototype.getExtent=cf.prototype.D;cf.prototype.rotate=cf.prototype.rotate;cf.prototype.scale=cf.prototype.scale;cf.prototype.simplify=cf.prototype.Pb;cf.prototype.transform=cf.prototype.tb;t("ol.geom.GeometryCollection",qm);qm.prototype.clone=qm.prototype.clone;qm.prototype.getGeometries=qm.prototype.If;
	qm.prototype.getType=qm.prototype.T;qm.prototype.intersectsExtent=qm.prototype.Xa;qm.prototype.setGeometries=qm.prototype.Ji;qm.prototype.applyTransform=qm.prototype.Dc;qm.prototype.translate=qm.prototype.translate;t("ol.geom.LinearRing",yf);yf.prototype.clone=yf.prototype.clone;yf.prototype.getArea=yf.prototype.Km;yf.prototype.getCoordinates=yf.prototype.X;yf.prototype.getType=yf.prototype.T;yf.prototype.setCoordinates=yf.prototype.pa;t("ol.geom.LineString",M);M.prototype.appendCoordinate=M.prototype.Tj;
	M.prototype.clone=M.prototype.clone;M.prototype.forEachSegment=M.prototype.gk;M.prototype.getCoordinateAtM=M.prototype.Im;M.prototype.getCoordinates=M.prototype.X;M.prototype.getCoordinateAt=M.prototype.hh;M.prototype.getLength=M.prototype.Jm;M.prototype.getType=M.prototype.T;M.prototype.intersectsExtent=M.prototype.Xa;M.prototype.setCoordinates=M.prototype.pa;t("ol.geom.MultiLineString",N);N.prototype.appendLineString=N.prototype.Uj;N.prototype.clone=N.prototype.clone;
	N.prototype.getCoordinateAtM=N.prototype.Lm;N.prototype.getCoordinates=N.prototype.X;N.prototype.getLineString=N.prototype.Dk;N.prototype.getLineStrings=N.prototype.hd;N.prototype.getType=N.prototype.T;N.prototype.intersectsExtent=N.prototype.Xa;N.prototype.setCoordinates=N.prototype.pa;t("ol.geom.MultiPoint",O);O.prototype.appendPoint=O.prototype.Wj;O.prototype.clone=O.prototype.clone;O.prototype.getCoordinates=O.prototype.X;O.prototype.getPoint=O.prototype.Ok;O.prototype.getPoints=O.prototype.Ie;
	O.prototype.getType=O.prototype.T;O.prototype.intersectsExtent=O.prototype.Xa;O.prototype.setCoordinates=O.prototype.pa;t("ol.geom.MultiPolygon",P);P.prototype.appendPolygon=P.prototype.Xj;P.prototype.clone=P.prototype.clone;P.prototype.getArea=P.prototype.Mm;P.prototype.getCoordinates=P.prototype.X;P.prototype.getInteriorPoints=P.prototype.zk;P.prototype.getPolygon=P.prototype.Pk;P.prototype.getPolygons=P.prototype.Od;P.prototype.getType=P.prototype.T;P.prototype.intersectsExtent=P.prototype.Xa;
	P.prototype.setCoordinates=P.prototype.pa;t("ol.geom.Point",E);E.prototype.clone=E.prototype.clone;E.prototype.getCoordinates=E.prototype.X;E.prototype.getType=E.prototype.T;E.prototype.intersectsExtent=E.prototype.Xa;E.prototype.setCoordinates=E.prototype.pa;t("ol.geom.Polygon",F);F.prototype.appendLinearRing=F.prototype.Vj;F.prototype.clone=F.prototype.clone;F.prototype.getArea=F.prototype.Nm;F.prototype.getCoordinates=F.prototype.X;F.prototype.getInteriorPoint=F.prototype.yk;
	F.prototype.getLinearRingCount=F.prototype.Ek;F.prototype.getLinearRing=F.prototype.nh;F.prototype.getLinearRings=F.prototype.jd;F.prototype.getType=F.prototype.T;F.prototype.intersectsExtent=F.prototype.Xa;F.prototype.setCoordinates=F.prototype.pa;t("ol.geom.Polygon.circular",Mf);t("ol.geom.Polygon.fromExtent",Nf);t("ol.geom.Polygon.fromCircle",Of);t("ol.geom.SimpleGeometry",ff);ff.prototype.getFirstCoordinate=ff.prototype.bc;ff.prototype.getLastCoordinate=ff.prototype.cc;
	ff.prototype.getLayout=ff.prototype.dc;ff.prototype.applyTransform=ff.prototype.Dc;ff.prototype.translate=ff.prototype.translate;t("ol.format.EsriJSON",Ol);Ol.prototype.readFeature=Ol.prototype.Ub;Ol.prototype.readFeatures=Ol.prototype.Qa;Ol.prototype.readGeometry=Ol.prototype.Tc;Ol.prototype.readProjection=Ol.prototype.kb;Ol.prototype.writeGeometry=Ol.prototype.bd;Ol.prototype.writeGeometryObject=Ol.prototype.ee;Ol.prototype.writeFeature=Ol.prototype.yd;Ol.prototype.writeFeatureObject=Ol.prototype.ad;
	Ol.prototype.writeFeatures=Ol.prototype.Xb;Ol.prototype.writeFeaturesObject=Ol.prototype.ce;t("ol.format.Feature",Cl);t("ol.format.filter.and",om);t("ol.format.filter.or",function(a){var b=[null].concat(Array.prototype.slice.call(arguments));return new (Function.prototype.bind.apply(mm,b))});t("ol.format.filter.not",function(a){return new km(a)});t("ol.format.filter.bbox",pm);t("ol.format.filter.intersects",function(a,b,c){return new em(a,b,c)});
	t("ol.format.filter.within",function(a,b,c){return new nm(a,b,c)});t("ol.format.filter.equalTo",function(a,b,c){return new am(a,b,c)});t("ol.format.filter.notEqualTo",function(a,b,c){return new lm(a,b,c)});t("ol.format.filter.lessThan",function(a,b){return new im(a,b)});t("ol.format.filter.lessThanOrEqualTo",function(a,b){return new jm(a,b)});t("ol.format.filter.greaterThan",function(a,b){return new bm(a,b)});t("ol.format.filter.greaterThanOrEqualTo",function(a,b){return new cm(a,b)});
	t("ol.format.filter.isNull",function(a){return new hm(a)});t("ol.format.filter.between",function(a,b,c){return new fm(a,b,c)});t("ol.format.filter.like",function(a,b,c,d,e,f){return new gm(a,b,c,d,e,f)});t("ol.format.GeoJSON",um);um.prototype.readFeature=um.prototype.Ub;um.prototype.readFeatures=um.prototype.Qa;um.prototype.readGeometry=um.prototype.Tc;um.prototype.readProjection=um.prototype.kb;um.prototype.writeFeature=um.prototype.yd;um.prototype.writeFeatureObject=um.prototype.ad;
	um.prototype.writeFeatures=um.prototype.Xb;um.prototype.writeFeaturesObject=um.prototype.ce;um.prototype.writeGeometry=um.prototype.bd;um.prototype.writeGeometryObject=um.prototype.ee;t("ol.format.GML",Pm);Pm.prototype.writeFeatures=Pm.prototype.Xb;Pm.prototype.writeFeaturesNode=Pm.prototype.Yb;t("ol.format.GML2",Ym);t("ol.format.GML3",Pm);Pm.prototype.writeGeometryNode=Pm.prototype.de;Pm.prototype.writeFeatures=Pm.prototype.Xb;Pm.prototype.writeFeaturesNode=Pm.prototype.Yb;
	Cm.prototype.readFeatures=Cm.prototype.Qa;t("ol.format.GPX",Zm);Zm.prototype.readFeature=Zm.prototype.Ub;Zm.prototype.readFeatures=Zm.prototype.Qa;Zm.prototype.readProjection=Zm.prototype.kb;Zm.prototype.writeFeatures=Zm.prototype.Xb;Zm.prototype.writeFeaturesNode=Zm.prototype.Yb;t("ol.format.IGC",Kn);Kn.prototype.readFeature=Kn.prototype.Ub;Kn.prototype.readFeatures=Kn.prototype.Qa;Kn.prototype.readProjection=Kn.prototype.kb;t("ol.format.KML",Tn);Tn.prototype.readFeature=Tn.prototype.Ub;
	Tn.prototype.readFeatures=Tn.prototype.Qa;Tn.prototype.readName=Tn.prototype.Ro;Tn.prototype.readNetworkLinks=Tn.prototype.So;Tn.prototype.readRegion=Tn.prototype.Vo;Tn.prototype.readRegionFromNode=Tn.prototype.$e;Tn.prototype.readProjection=Tn.prototype.kb;Tn.prototype.writeFeatures=Tn.prototype.Xb;Tn.prototype.writeFeaturesNode=Tn.prototype.Yb;t("ol.format.MVT",Zp);Zp.prototype.readFeatures=Zp.prototype.Qa;Zp.prototype.readProjection=Zp.prototype.kb;Zp.prototype.setLayers=Zp.prototype.Hm;
	t("ol.format.OSMXML",aq);aq.prototype.readFeatures=aq.prototype.Qa;aq.prototype.readProjection=aq.prototype.kb;t("ol.format.Polyline",Aq);t("ol.format.Polyline.encodeDeltas",Bq);t("ol.format.Polyline.decodeDeltas",Dq);t("ol.format.Polyline.encodeFloats",Cq);t("ol.format.Polyline.decodeFloats",Eq);Aq.prototype.readFeature=Aq.prototype.Ub;Aq.prototype.readFeatures=Aq.prototype.Qa;Aq.prototype.readGeometry=Aq.prototype.Tc;Aq.prototype.readProjection=Aq.prototype.kb;Aq.prototype.writeGeometry=Aq.prototype.bd;
	t("ol.format.TopoJSON",Fq);Fq.prototype.readFeatures=Fq.prototype.Qa;Fq.prototype.readProjection=Fq.prototype.kb;t("ol.format.WFS",Lq);Lq.prototype.readFeatures=Lq.prototype.Qa;Lq.prototype.readTransactionResponse=Lq.prototype.j;Lq.prototype.readFeatureCollectionMetadata=Lq.prototype.l;Lq.prototype.writeGetFeature=Lq.prototype.o;Lq.prototype.writeTransaction=Lq.prototype.v;Lq.prototype.readProjection=Lq.prototype.kb;t("ol.format.WKT",cr);cr.prototype.readFeature=cr.prototype.Ub;
	cr.prototype.readFeatures=cr.prototype.Qa;cr.prototype.readGeometry=cr.prototype.Tc;cr.prototype.writeFeature=cr.prototype.yd;cr.prototype.writeFeatures=cr.prototype.Xb;cr.prototype.writeGeometry=cr.prototype.bd;t("ol.format.WMSCapabilities",vr);vr.prototype.read=vr.prototype.read;t("ol.format.WMSGetFeatureInfo",Sr);Sr.prototype.readFeatures=Sr.prototype.Qa;t("ol.format.WMTSCapabilities",Tr);Tr.prototype.read=Tr.prototype.read;t("ol.format.filter.And",Xl);t("ol.format.filter.Bbox",Yl);
	t("ol.format.filter.Comparison",Zl);t("ol.format.filter.ComparisonBinary",$l);t("ol.format.filter.EqualTo",am);t("ol.format.filter.Filter",Vl);t("ol.format.filter.GreaterThan",bm);t("ol.format.filter.GreaterThanOrEqualTo",cm);t("ol.format.filter.Intersects",em);t("ol.format.filter.IsBetween",fm);t("ol.format.filter.IsLike",gm);t("ol.format.filter.IsNull",hm);t("ol.format.filter.LessThan",im);t("ol.format.filter.LessThanOrEqualTo",jm);t("ol.format.filter.Not",km);t("ol.format.filter.NotEqualTo",lm);
	t("ol.format.filter.Or",mm);t("ol.format.filter.Spatial",dm);t("ol.format.filter.Within",nm);t("ol.events.condition.altKeyOnly",function(a){a=a.originalEvent;return a.altKey&&!(a.metaKey||a.ctrlKey)&&!a.shiftKey});t("ol.events.condition.altShiftKeysOnly",gg);t("ol.events.condition.always",af);t("ol.events.condition.click",function(a){return"click"==a.type});t("ol.events.condition.never",bf);t("ol.events.condition.pointerMove",ig);t("ol.events.condition.singleClick",jg);
	t("ol.events.condition.doubleClick",function(a){return"dblclick"==a.type});t("ol.events.condition.noModifierKeys",kg);t("ol.events.condition.platformModifierKeyOnly",function(a){a=a.originalEvent;return!a.altKey&&(Jd?a.metaKey:a.ctrlKey)&&!a.shiftKey});t("ol.events.condition.shiftKeyOnly",lg);t("ol.events.condition.targetNotEditable",mg);t("ol.events.condition.mouseOnly",ng);t("ol.events.condition.primaryAction",og);Bc.prototype.type=Bc.prototype.type;Bc.prototype.target=Bc.prototype.target;
	Bc.prototype.preventDefault=Bc.prototype.preventDefault;Bc.prototype.stopPropagation=Bc.prototype.stopPropagation;t("ol.control.Attribution",bd);t("ol.control.Attribution.render",cd);bd.prototype.getCollapsible=bd.prototype.xm;bd.prototype.setCollapsible=bd.prototype.Am;bd.prototype.setCollapsed=bd.prototype.zm;bd.prototype.getCollapsed=bd.prototype.wm;t("ol.control.Control",ad);ad.prototype.getMap=ad.prototype.g;ad.prototype.setMap=ad.prototype.setMap;ad.prototype.setTarget=ad.prototype.i;
	t("ol.control.FullScreen",od);t("ol.control.MousePosition",td);t("ol.control.MousePosition.render",ud);td.prototype.getCoordinateFormat=td.prototype.ih;td.prototype.getProjection=td.prototype.Lh;td.prototype.setCoordinateFormat=td.prototype.Fi;td.prototype.setProjection=td.prototype.Mh;t("ol.control.OverviewMap",zk);t("ol.control.OverviewMap.render",Ak);zk.prototype.getCollapsible=zk.prototype.Dm;zk.prototype.setCollapsible=zk.prototype.Gm;zk.prototype.setCollapsed=zk.prototype.Fm;
	zk.prototype.getCollapsed=zk.prototype.Cm;zk.prototype.getOverviewMap=zk.prototype.Mk;t("ol.control.Rotate",id);t("ol.control.Rotate.render",jd);t("ol.control.ScaleLine",Ek);Ek.prototype.getUnits=Ek.prototype.Jb;t("ol.control.ScaleLine.render",Fk);Ek.prototype.setUnits=Ek.prototype.G;t("ol.control.Zoom",kd);t("ol.control.ZoomSlider",Jk);t("ol.control.ZoomSlider.render",Lk);t("ol.control.ZoomToExtent",Ok);Gc.prototype.changed=Gc.prototype.s;Gc.prototype.dispatchEvent=Gc.prototype.b;
	Gc.prototype.getRevision=Gc.prototype.L;Gc.prototype.on=Gc.prototype.J;Gc.prototype.once=Gc.prototype.once;Gc.prototype.un=Gc.prototype.K;D.prototype.get=D.prototype.get;D.prototype.getKeys=D.prototype.O;D.prototype.getProperties=D.prototype.N;D.prototype.set=D.prototype.set;D.prototype.setProperties=D.prototype.H;D.prototype.unset=D.prototype.P;D.prototype.changed=D.prototype.s;D.prototype.dispatchEvent=D.prototype.b;D.prototype.getRevision=D.prototype.L;D.prototype.on=D.prototype.J;
	D.prototype.once=D.prototype.once;D.prototype.un=D.prototype.K;Nc.prototype.type=Nc.prototype.type;Nc.prototype.target=Nc.prototype.target;Nc.prototype.preventDefault=Nc.prototype.preventDefault;Nc.prototype.stopPropagation=Nc.prototype.stopPropagation;Pk.prototype.get=Pk.prototype.get;Pk.prototype.getKeys=Pk.prototype.O;Pk.prototype.getProperties=Pk.prototype.N;Pk.prototype.set=Pk.prototype.set;Pk.prototype.setProperties=Pk.prototype.H;Pk.prototype.unset=Pk.prototype.P;Pk.prototype.changed=Pk.prototype.s;
	Pk.prototype.dispatchEvent=Pk.prototype.b;Pk.prototype.getRevision=Pk.prototype.L;Pk.prototype.on=Pk.prototype.J;Pk.prototype.once=Pk.prototype.once;Pk.prototype.un=Pk.prototype.K;H.prototype.get=H.prototype.get;H.prototype.getKeys=H.prototype.O;H.prototype.getProperties=H.prototype.N;H.prototype.set=H.prototype.set;H.prototype.setProperties=H.prototype.H;H.prototype.unset=H.prototype.P;H.prototype.changed=H.prototype.s;H.prototype.dispatchEvent=H.prototype.b;H.prototype.getRevision=H.prototype.L;
	H.prototype.on=H.prototype.J;H.prototype.once=H.prototype.once;H.prototype.un=H.prototype.K;hs.prototype.get=hs.prototype.get;hs.prototype.getKeys=hs.prototype.O;hs.prototype.getProperties=hs.prototype.N;hs.prototype.set=hs.prototype.set;hs.prototype.setProperties=hs.prototype.H;hs.prototype.unset=hs.prototype.P;hs.prototype.changed=hs.prototype.s;hs.prototype.dispatchEvent=hs.prototype.b;hs.prototype.getRevision=hs.prototype.L;hs.prototype.on=hs.prototype.J;hs.prototype.once=hs.prototype.once;
	hs.prototype.un=hs.prototype.K;xs.prototype.getTileCoord=xs.prototype.i;xs.prototype.load=xs.prototype.load;G.prototype.get=G.prototype.get;G.prototype.getKeys=G.prototype.O;G.prototype.getProperties=G.prototype.N;G.prototype.set=G.prototype.set;G.prototype.setProperties=G.prototype.H;G.prototype.unset=G.prototype.P;G.prototype.changed=G.prototype.s;G.prototype.dispatchEvent=G.prototype.b;G.prototype.getRevision=G.prototype.L;G.prototype.on=G.prototype.J;G.prototype.once=G.prototype.once;
	G.prototype.un=G.prototype.K;yd.prototype.type=yd.prototype.type;yd.prototype.target=yd.prototype.target;yd.prototype.preventDefault=yd.prototype.preventDefault;yd.prototype.stopPropagation=yd.prototype.stopPropagation;zd.prototype.map=zd.prototype.map;zd.prototype.frameState=zd.prototype.frameState;zd.prototype.type=zd.prototype.type;zd.prototype.target=zd.prototype.target;zd.prototype.preventDefault=zd.prototype.preventDefault;zd.prototype.stopPropagation=zd.prototype.stopPropagation;
	Bd.prototype.originalEvent=Bd.prototype.originalEvent;Bd.prototype.pixel=Bd.prototype.pixel;Bd.prototype.coordinate=Bd.prototype.coordinate;Bd.prototype.dragging=Bd.prototype.dragging;Bd.prototype.preventDefault=Bd.prototype.preventDefault;Bd.prototype.stopPropagation=Bd.prototype.stopPropagation;Bd.prototype.map=Bd.prototype.map;Bd.prototype.frameState=Bd.prototype.frameState;Bd.prototype.type=Bd.prototype.type;Bd.prototype.target=Bd.prototype.target;Kc.prototype.type=Kc.prototype.type;
	Kc.prototype.target=Kc.prototype.target;Kc.prototype.preventDefault=Kc.prototype.preventDefault;Kc.prototype.stopPropagation=Kc.prototype.stopPropagation;qk.prototype.get=qk.prototype.get;qk.prototype.getKeys=qk.prototype.O;qk.prototype.getProperties=qk.prototype.N;qk.prototype.set=qk.prototype.set;qk.prototype.setProperties=qk.prototype.H;qk.prototype.unset=qk.prototype.P;qk.prototype.changed=qk.prototype.s;qk.prototype.dispatchEvent=qk.prototype.b;qk.prototype.getRevision=qk.prototype.L;
	qk.prototype.on=qk.prototype.J;qk.prototype.once=qk.prototype.once;qk.prototype.un=qk.prototype.K;Ww.prototype.getTileCoord=Ww.prototype.i;Ww.prototype.load=Ww.prototype.load;Qf.prototype.get=Qf.prototype.get;Qf.prototype.getKeys=Qf.prototype.O;Qf.prototype.getProperties=Qf.prototype.N;Qf.prototype.set=Qf.prototype.set;Qf.prototype.setProperties=Qf.prototype.H;Qf.prototype.unset=Qf.prototype.P;Qf.prototype.changed=Qf.prototype.s;Qf.prototype.dispatchEvent=Qf.prototype.b;Qf.prototype.getRevision=Qf.prototype.L;
	Qf.prototype.on=Qf.prototype.J;Qf.prototype.once=Qf.prototype.once;Qf.prototype.un=Qf.prototype.K;Zw.prototype.forEachTileCoord=Zw.prototype.eh;Zw.prototype.getMaxZoom=Zw.prototype.oh;Zw.prototype.getMinZoom=Zw.prototype.ph;Zw.prototype.getOrigin=Zw.prototype.Qc;Zw.prototype.getResolution=Zw.prototype.La;Zw.prototype.getResolutions=Zw.prototype.oi;Zw.prototype.getTileCoordExtent=Zw.prototype.Ta;Zw.prototype.getTileCoordForCoordAndResolution=Zw.prototype.we;Zw.prototype.getTileCoordForCoordAndZ=Zw.prototype.Pf;
	Zw.prototype.getTileSize=Zw.prototype.fb;Zw.prototype.getZForResolution=Zw.prototype.Mc;Wk.prototype.getOpacity=Wk.prototype.Pe;Wk.prototype.getRotateWithView=Wk.prototype.Qe;Wk.prototype.getRotation=Wk.prototype.Re;Wk.prototype.getScale=Wk.prototype.Se;Wk.prototype.getSnapToPixel=Wk.prototype.ve;Wk.prototype.setOpacity=Wk.prototype.rd;Wk.prototype.setRotation=Wk.prototype.Te;Wk.prototype.setScale=Wk.prototype.sd;Yk.prototype.clone=Yk.prototype.clone;Yk.prototype.getAngle=Yk.prototype.ki;
	Yk.prototype.getFill=Yk.prototype.Ca;Yk.prototype.getPoints=Yk.prototype.li;Yk.prototype.getRadius=Yk.prototype.mi;Yk.prototype.getRadius2=Yk.prototype.sh;Yk.prototype.getStroke=Yk.prototype.Da;Yk.prototype.getOpacity=Yk.prototype.Pe;Yk.prototype.getRotateWithView=Yk.prototype.Qe;Yk.prototype.getRotation=Yk.prototype.Re;Yk.prototype.getScale=Yk.prototype.Se;Yk.prototype.getSnapToPixel=Yk.prototype.ve;Yk.prototype.setOpacity=Yk.prototype.rd;Yk.prototype.setRotation=Yk.prototype.Te;
	Yk.prototype.setScale=Yk.prototype.sd;Rn.prototype.getOpacity=Rn.prototype.Pe;Rn.prototype.getRotateWithView=Rn.prototype.Qe;Rn.prototype.getRotation=Rn.prototype.Re;Rn.prototype.getScale=Rn.prototype.Se;Rn.prototype.getSnapToPixel=Rn.prototype.ve;Rn.prototype.setOpacity=Rn.prototype.rd;Rn.prototype.setRotation=Rn.prototype.Te;Rn.prototype.setScale=Rn.prototype.sd;Gt.prototype.get=Gt.prototype.get;Gt.prototype.getKeys=Gt.prototype.O;Gt.prototype.getProperties=Gt.prototype.N;Gt.prototype.set=Gt.prototype.set;
	Gt.prototype.setProperties=Gt.prototype.H;Gt.prototype.unset=Gt.prototype.P;Gt.prototype.changed=Gt.prototype.s;Gt.prototype.dispatchEvent=Gt.prototype.b;Gt.prototype.getRevision=Gt.prototype.L;Gt.prototype.on=Gt.prototype.J;Gt.prototype.once=Gt.prototype.once;Gt.prototype.un=Gt.prototype.K;Xv.prototype.getAttributions=Xv.prototype.xa;Xv.prototype.getLogo=Xv.prototype.wa;Xv.prototype.getProjection=Xv.prototype.ya;Xv.prototype.getState=Xv.prototype.V;Xv.prototype.refresh=Xv.prototype.va;
	Xv.prototype.setAttributions=Xv.prototype.ua;Xv.prototype.get=Xv.prototype.get;Xv.prototype.getKeys=Xv.prototype.O;Xv.prototype.getProperties=Xv.prototype.N;Xv.prototype.set=Xv.prototype.set;Xv.prototype.setProperties=Xv.prototype.H;Xv.prototype.unset=Xv.prototype.P;Xv.prototype.changed=Xv.prototype.s;Xv.prototype.dispatchEvent=Xv.prototype.b;Xv.prototype.getRevision=Xv.prototype.L;Xv.prototype.on=Xv.prototype.J;Xv.prototype.once=Xv.prototype.once;Xv.prototype.un=Xv.prototype.K;
	aw.prototype.getTileGrid=aw.prototype.ab;aw.prototype.refresh=aw.prototype.va;aw.prototype.getAttributions=aw.prototype.xa;aw.prototype.getLogo=aw.prototype.wa;aw.prototype.getProjection=aw.prototype.ya;aw.prototype.getState=aw.prototype.V;aw.prototype.setAttributions=aw.prototype.ua;aw.prototype.get=aw.prototype.get;aw.prototype.getKeys=aw.prototype.O;aw.prototype.getProperties=aw.prototype.N;aw.prototype.set=aw.prototype.set;aw.prototype.setProperties=aw.prototype.H;aw.prototype.unset=aw.prototype.P;
	aw.prototype.changed=aw.prototype.s;aw.prototype.dispatchEvent=aw.prototype.b;aw.prototype.getRevision=aw.prototype.L;aw.prototype.on=aw.prototype.J;aw.prototype.once=aw.prototype.once;aw.prototype.un=aw.prototype.K;W.prototype.getTileLoadFunction=W.prototype.ob;W.prototype.getTileUrlFunction=W.prototype.qb;W.prototype.getUrls=W.prototype.rb;W.prototype.setTileLoadFunction=W.prototype.xb;W.prototype.setTileUrlFunction=W.prototype.bb;W.prototype.setUrl=W.prototype.jb;W.prototype.setUrls=W.prototype.cb;
	W.prototype.getTileGrid=W.prototype.ab;W.prototype.refresh=W.prototype.va;W.prototype.getAttributions=W.prototype.xa;W.prototype.getLogo=W.prototype.wa;W.prototype.getProjection=W.prototype.ya;W.prototype.getState=W.prototype.V;W.prototype.setAttributions=W.prototype.ua;W.prototype.get=W.prototype.get;W.prototype.getKeys=W.prototype.O;W.prototype.getProperties=W.prototype.N;W.prototype.set=W.prototype.set;W.prototype.setProperties=W.prototype.H;W.prototype.unset=W.prototype.P;
	W.prototype.changed=W.prototype.s;W.prototype.dispatchEvent=W.prototype.b;W.prototype.getRevision=W.prototype.L;W.prototype.on=W.prototype.J;W.prototype.once=W.prototype.once;W.prototype.un=W.prototype.K;ew.prototype.setRenderReprojectionEdges=ew.prototype.Nb;ew.prototype.setTileGridForProjection=ew.prototype.Ob;ew.prototype.getTileLoadFunction=ew.prototype.ob;ew.prototype.getTileUrlFunction=ew.prototype.qb;ew.prototype.getUrls=ew.prototype.rb;ew.prototype.setTileLoadFunction=ew.prototype.xb;
	ew.prototype.setTileUrlFunction=ew.prototype.bb;ew.prototype.setUrl=ew.prototype.jb;ew.prototype.setUrls=ew.prototype.cb;ew.prototype.getTileGrid=ew.prototype.ab;ew.prototype.refresh=ew.prototype.va;ew.prototype.getAttributions=ew.prototype.xa;ew.prototype.getLogo=ew.prototype.wa;ew.prototype.getProjection=ew.prototype.ya;ew.prototype.getState=ew.prototype.V;ew.prototype.setAttributions=ew.prototype.ua;ew.prototype.get=ew.prototype.get;ew.prototype.getKeys=ew.prototype.O;
	ew.prototype.getProperties=ew.prototype.N;ew.prototype.set=ew.prototype.set;ew.prototype.setProperties=ew.prototype.H;ew.prototype.unset=ew.prototype.P;ew.prototype.changed=ew.prototype.s;ew.prototype.dispatchEvent=ew.prototype.b;ew.prototype.getRevision=ew.prototype.L;ew.prototype.on=ew.prototype.J;ew.prototype.once=ew.prototype.once;ew.prototype.un=ew.prototype.K;gw.prototype.setRenderReprojectionEdges=gw.prototype.Nb;gw.prototype.setTileGridForProjection=gw.prototype.Ob;
	gw.prototype.getTileLoadFunction=gw.prototype.ob;gw.prototype.getTileUrlFunction=gw.prototype.qb;gw.prototype.getUrls=gw.prototype.rb;gw.prototype.setTileLoadFunction=gw.prototype.xb;gw.prototype.setTileUrlFunction=gw.prototype.bb;gw.prototype.setUrl=gw.prototype.jb;gw.prototype.setUrls=gw.prototype.cb;gw.prototype.getTileGrid=gw.prototype.ab;gw.prototype.refresh=gw.prototype.va;gw.prototype.getAttributions=gw.prototype.xa;gw.prototype.getLogo=gw.prototype.wa;gw.prototype.getProjection=gw.prototype.ya;
	gw.prototype.getState=gw.prototype.V;gw.prototype.setAttributions=gw.prototype.ua;gw.prototype.get=gw.prototype.get;gw.prototype.getKeys=gw.prototype.O;gw.prototype.getProperties=gw.prototype.N;gw.prototype.set=gw.prototype.set;gw.prototype.setProperties=gw.prototype.H;gw.prototype.unset=gw.prototype.P;gw.prototype.changed=gw.prototype.s;gw.prototype.dispatchEvent=gw.prototype.b;gw.prototype.getRevision=gw.prototype.L;gw.prototype.on=gw.prototype.J;gw.prototype.once=gw.prototype.once;
	gw.prototype.un=gw.prototype.K;hw.prototype.setRenderReprojectionEdges=hw.prototype.Nb;hw.prototype.setTileGridForProjection=hw.prototype.Ob;hw.prototype.getTileLoadFunction=hw.prototype.ob;hw.prototype.getTileUrlFunction=hw.prototype.qb;hw.prototype.getUrls=hw.prototype.rb;hw.prototype.setTileLoadFunction=hw.prototype.xb;hw.prototype.setTileUrlFunction=hw.prototype.bb;hw.prototype.setUrl=hw.prototype.jb;hw.prototype.setUrls=hw.prototype.cb;hw.prototype.getTileGrid=hw.prototype.ab;
	hw.prototype.refresh=hw.prototype.va;hw.prototype.getAttributions=hw.prototype.xa;hw.prototype.getLogo=hw.prototype.wa;hw.prototype.getProjection=hw.prototype.ya;hw.prototype.getState=hw.prototype.V;hw.prototype.setAttributions=hw.prototype.ua;hw.prototype.get=hw.prototype.get;hw.prototype.getKeys=hw.prototype.O;hw.prototype.getProperties=hw.prototype.N;hw.prototype.set=hw.prototype.set;hw.prototype.setProperties=hw.prototype.H;hw.prototype.unset=hw.prototype.P;hw.prototype.changed=hw.prototype.s;
	hw.prototype.dispatchEvent=hw.prototype.b;hw.prototype.getRevision=hw.prototype.L;hw.prototype.on=hw.prototype.J;hw.prototype.once=hw.prototype.once;hw.prototype.un=hw.prototype.K;S.prototype.getAttributions=S.prototype.xa;S.prototype.getLogo=S.prototype.wa;S.prototype.getProjection=S.prototype.ya;S.prototype.getState=S.prototype.V;S.prototype.refresh=S.prototype.va;S.prototype.setAttributions=S.prototype.ua;S.prototype.get=S.prototype.get;S.prototype.getKeys=S.prototype.O;
	S.prototype.getProperties=S.prototype.N;S.prototype.set=S.prototype.set;S.prototype.setProperties=S.prototype.H;S.prototype.unset=S.prototype.P;S.prototype.changed=S.prototype.s;S.prototype.dispatchEvent=S.prototype.b;S.prototype.getRevision=S.prototype.L;S.prototype.on=S.prototype.J;S.prototype.once=S.prototype.once;S.prototype.un=S.prototype.K;X.prototype.addFeature=X.prototype.zb;X.prototype.addFeatures=X.prototype.dd;X.prototype.clear=X.prototype.clear;X.prototype.forEachFeature=X.prototype.bh;
	X.prototype.forEachFeatureInExtent=X.prototype.ac;X.prototype.forEachFeatureIntersectingExtent=X.prototype.dh;X.prototype.getFeaturesCollection=X.prototype.lh;X.prototype.getFeatures=X.prototype.Ne;X.prototype.getFeaturesAtCoordinate=X.prototype.kh;X.prototype.getFeaturesInExtent=X.prototype.Hf;X.prototype.getClosestFeatureToCoordinate=X.prototype.gh;X.prototype.getExtent=X.prototype.D;X.prototype.getFeatureById=X.prototype.jh;X.prototype.getFormat=X.prototype.hi;X.prototype.getUrl=X.prototype.ii;
	X.prototype.removeFeature=X.prototype.Db;X.prototype.getAttributions=X.prototype.xa;X.prototype.getLogo=X.prototype.wa;X.prototype.getProjection=X.prototype.ya;X.prototype.getState=X.prototype.V;X.prototype.refresh=X.prototype.va;X.prototype.setAttributions=X.prototype.ua;X.prototype.get=X.prototype.get;X.prototype.getKeys=X.prototype.O;X.prototype.getProperties=X.prototype.N;X.prototype.set=X.prototype.set;X.prototype.setProperties=X.prototype.H;X.prototype.unset=X.prototype.P;
	X.prototype.changed=X.prototype.s;X.prototype.dispatchEvent=X.prototype.b;X.prototype.getRevision=X.prototype.L;X.prototype.on=X.prototype.J;X.prototype.once=X.prototype.once;X.prototype.un=X.prototype.K;lv.prototype.getAttributions=lv.prototype.xa;lv.prototype.getLogo=lv.prototype.wa;lv.prototype.getProjection=lv.prototype.ya;lv.prototype.getState=lv.prototype.V;lv.prototype.refresh=lv.prototype.va;lv.prototype.setAttributions=lv.prototype.ua;lv.prototype.get=lv.prototype.get;
	lv.prototype.getKeys=lv.prototype.O;lv.prototype.getProperties=lv.prototype.N;lv.prototype.set=lv.prototype.set;lv.prototype.setProperties=lv.prototype.H;lv.prototype.unset=lv.prototype.P;lv.prototype.changed=lv.prototype.s;lv.prototype.dispatchEvent=lv.prototype.b;lv.prototype.getRevision=lv.prototype.L;lv.prototype.on=lv.prototype.J;lv.prototype.once=lv.prototype.once;lv.prototype.un=lv.prototype.K;nv.prototype.type=nv.prototype.type;nv.prototype.target=nv.prototype.target;
	nv.prototype.preventDefault=nv.prototype.preventDefault;nv.prototype.stopPropagation=nv.prototype.stopPropagation;nw.prototype.getAttributions=nw.prototype.xa;nw.prototype.getLogo=nw.prototype.wa;nw.prototype.getProjection=nw.prototype.ya;nw.prototype.getState=nw.prototype.V;nw.prototype.refresh=nw.prototype.va;nw.prototype.setAttributions=nw.prototype.ua;nw.prototype.get=nw.prototype.get;nw.prototype.getKeys=nw.prototype.O;nw.prototype.getProperties=nw.prototype.N;nw.prototype.set=nw.prototype.set;
	nw.prototype.setProperties=nw.prototype.H;nw.prototype.unset=nw.prototype.P;nw.prototype.changed=nw.prototype.s;nw.prototype.dispatchEvent=nw.prototype.b;nw.prototype.getRevision=nw.prototype.L;nw.prototype.on=nw.prototype.J;nw.prototype.once=nw.prototype.once;nw.prototype.un=nw.prototype.K;sv.prototype.getAttributions=sv.prototype.xa;sv.prototype.getLogo=sv.prototype.wa;sv.prototype.getProjection=sv.prototype.ya;sv.prototype.getState=sv.prototype.V;sv.prototype.refresh=sv.prototype.va;
	sv.prototype.setAttributions=sv.prototype.ua;sv.prototype.get=sv.prototype.get;sv.prototype.getKeys=sv.prototype.O;sv.prototype.getProperties=sv.prototype.N;sv.prototype.set=sv.prototype.set;sv.prototype.setProperties=sv.prototype.H;sv.prototype.unset=sv.prototype.P;sv.prototype.changed=sv.prototype.s;sv.prototype.dispatchEvent=sv.prototype.b;sv.prototype.getRevision=sv.prototype.L;sv.prototype.on=sv.prototype.J;sv.prototype.once=sv.prototype.once;sv.prototype.un=sv.prototype.K;
	ow.prototype.getAttributions=ow.prototype.xa;ow.prototype.getLogo=ow.prototype.wa;ow.prototype.getProjection=ow.prototype.ya;ow.prototype.getState=ow.prototype.V;ow.prototype.refresh=ow.prototype.va;ow.prototype.setAttributions=ow.prototype.ua;ow.prototype.get=ow.prototype.get;ow.prototype.getKeys=ow.prototype.O;ow.prototype.getProperties=ow.prototype.N;ow.prototype.set=ow.prototype.set;ow.prototype.setProperties=ow.prototype.H;ow.prototype.unset=ow.prototype.P;ow.prototype.changed=ow.prototype.s;
	ow.prototype.dispatchEvent=ow.prototype.b;ow.prototype.getRevision=ow.prototype.L;ow.prototype.on=ow.prototype.J;ow.prototype.once=ow.prototype.once;ow.prototype.un=ow.prototype.K;pw.prototype.getAttributions=pw.prototype.xa;pw.prototype.getLogo=pw.prototype.wa;pw.prototype.getProjection=pw.prototype.ya;pw.prototype.getState=pw.prototype.V;pw.prototype.refresh=pw.prototype.va;pw.prototype.setAttributions=pw.prototype.ua;pw.prototype.get=pw.prototype.get;pw.prototype.getKeys=pw.prototype.O;
	pw.prototype.getProperties=pw.prototype.N;pw.prototype.set=pw.prototype.set;pw.prototype.setProperties=pw.prototype.H;pw.prototype.unset=pw.prototype.P;pw.prototype.changed=pw.prototype.s;pw.prototype.dispatchEvent=pw.prototype.b;pw.prototype.getRevision=pw.prototype.L;pw.prototype.on=pw.prototype.J;pw.prototype.once=pw.prototype.once;pw.prototype.un=pw.prototype.K;tv.prototype.getAttributions=tv.prototype.xa;tv.prototype.getLogo=tv.prototype.wa;tv.prototype.getProjection=tv.prototype.ya;
	tv.prototype.getState=tv.prototype.V;tv.prototype.refresh=tv.prototype.va;tv.prototype.setAttributions=tv.prototype.ua;tv.prototype.get=tv.prototype.get;tv.prototype.getKeys=tv.prototype.O;tv.prototype.getProperties=tv.prototype.N;tv.prototype.set=tv.prototype.set;tv.prototype.setProperties=tv.prototype.H;tv.prototype.unset=tv.prototype.P;tv.prototype.changed=tv.prototype.s;tv.prototype.dispatchEvent=tv.prototype.b;tv.prototype.getRevision=tv.prototype.L;tv.prototype.on=tv.prototype.J;
	tv.prototype.once=tv.prototype.once;tv.prototype.un=tv.prototype.K;qw.prototype.getAttributions=qw.prototype.xa;qw.prototype.getLogo=qw.prototype.wa;qw.prototype.getProjection=qw.prototype.ya;qw.prototype.getState=qw.prototype.V;qw.prototype.refresh=qw.prototype.va;qw.prototype.setAttributions=qw.prototype.ua;qw.prototype.get=qw.prototype.get;qw.prototype.getKeys=qw.prototype.O;qw.prototype.getProperties=qw.prototype.N;qw.prototype.set=qw.prototype.set;qw.prototype.setProperties=qw.prototype.H;
	qw.prototype.unset=qw.prototype.P;qw.prototype.changed=qw.prototype.s;qw.prototype.dispatchEvent=qw.prototype.b;qw.prototype.getRevision=qw.prototype.L;qw.prototype.on=qw.prototype.J;qw.prototype.once=qw.prototype.once;qw.prototype.un=qw.prototype.K;uw.prototype.setRenderReprojectionEdges=uw.prototype.Nb;uw.prototype.setTileGridForProjection=uw.prototype.Ob;uw.prototype.getTileLoadFunction=uw.prototype.ob;uw.prototype.getTileUrlFunction=uw.prototype.qb;uw.prototype.getUrls=uw.prototype.rb;
	uw.prototype.setTileLoadFunction=uw.prototype.xb;uw.prototype.setTileUrlFunction=uw.prototype.bb;uw.prototype.setUrl=uw.prototype.jb;uw.prototype.setUrls=uw.prototype.cb;uw.prototype.getTileGrid=uw.prototype.ab;uw.prototype.refresh=uw.prototype.va;uw.prototype.getAttributions=uw.prototype.xa;uw.prototype.getLogo=uw.prototype.wa;uw.prototype.getProjection=uw.prototype.ya;uw.prototype.getState=uw.prototype.V;uw.prototype.setAttributions=uw.prototype.ua;uw.prototype.get=uw.prototype.get;
	uw.prototype.getKeys=uw.prototype.O;uw.prototype.getProperties=uw.prototype.N;uw.prototype.set=uw.prototype.set;uw.prototype.setProperties=uw.prototype.H;uw.prototype.unset=uw.prototype.P;uw.prototype.changed=uw.prototype.s;uw.prototype.dispatchEvent=uw.prototype.b;uw.prototype.getRevision=uw.prototype.L;uw.prototype.on=uw.prototype.J;uw.prototype.once=uw.prototype.once;uw.prototype.un=uw.prototype.K;ww.prototype.getAttributions=ww.prototype.xa;ww.prototype.getLogo=ww.prototype.wa;
	ww.prototype.getProjection=ww.prototype.ya;ww.prototype.getState=ww.prototype.V;ww.prototype.refresh=ww.prototype.va;ww.prototype.setAttributions=ww.prototype.ua;ww.prototype.get=ww.prototype.get;ww.prototype.getKeys=ww.prototype.O;ww.prototype.getProperties=ww.prototype.N;ww.prototype.set=ww.prototype.set;ww.prototype.setProperties=ww.prototype.H;ww.prototype.unset=ww.prototype.P;ww.prototype.changed=ww.prototype.s;ww.prototype.dispatchEvent=ww.prototype.b;ww.prototype.getRevision=ww.prototype.L;
	ww.prototype.on=ww.prototype.J;ww.prototype.once=ww.prototype.once;ww.prototype.un=ww.prototype.K;Bw.prototype.type=Bw.prototype.type;Bw.prototype.target=Bw.prototype.target;Bw.prototype.preventDefault=Bw.prototype.preventDefault;Bw.prototype.stopPropagation=Bw.prototype.stopPropagation;Ew.prototype.setRenderReprojectionEdges=Ew.prototype.Nb;Ew.prototype.setTileGridForProjection=Ew.prototype.Ob;Ew.prototype.getTileLoadFunction=Ew.prototype.ob;Ew.prototype.getTileUrlFunction=Ew.prototype.qb;
	Ew.prototype.getUrls=Ew.prototype.rb;Ew.prototype.setTileLoadFunction=Ew.prototype.xb;Ew.prototype.setTileUrlFunction=Ew.prototype.bb;Ew.prototype.setUrl=Ew.prototype.jb;Ew.prototype.setUrls=Ew.prototype.cb;Ew.prototype.getTileGrid=Ew.prototype.ab;Ew.prototype.refresh=Ew.prototype.va;Ew.prototype.getAttributions=Ew.prototype.xa;Ew.prototype.getLogo=Ew.prototype.wa;Ew.prototype.getProjection=Ew.prototype.ya;Ew.prototype.getState=Ew.prototype.V;Ew.prototype.setAttributions=Ew.prototype.ua;
	Ew.prototype.get=Ew.prototype.get;Ew.prototype.getKeys=Ew.prototype.O;Ew.prototype.getProperties=Ew.prototype.N;Ew.prototype.set=Ew.prototype.set;Ew.prototype.setProperties=Ew.prototype.H;Ew.prototype.unset=Ew.prototype.P;Ew.prototype.changed=Ew.prototype.s;Ew.prototype.dispatchEvent=Ew.prototype.b;Ew.prototype.getRevision=Ew.prototype.L;Ew.prototype.on=Ew.prototype.J;Ew.prototype.once=Ew.prototype.once;Ew.prototype.un=Ew.prototype.K;$v.prototype.type=$v.prototype.type;$v.prototype.target=$v.prototype.target;
	$v.prototype.preventDefault=$v.prototype.preventDefault;$v.prototype.stopPropagation=$v.prototype.stopPropagation;Iw.prototype.setRenderReprojectionEdges=Iw.prototype.Nb;Iw.prototype.setTileGridForProjection=Iw.prototype.Ob;Iw.prototype.getTileLoadFunction=Iw.prototype.ob;Iw.prototype.getTileUrlFunction=Iw.prototype.qb;Iw.prototype.getUrls=Iw.prototype.rb;Iw.prototype.setTileLoadFunction=Iw.prototype.xb;Iw.prototype.setTileUrlFunction=Iw.prototype.bb;Iw.prototype.setUrl=Iw.prototype.jb;
	Iw.prototype.setUrls=Iw.prototype.cb;Iw.prototype.getTileGrid=Iw.prototype.ab;Iw.prototype.refresh=Iw.prototype.va;Iw.prototype.getAttributions=Iw.prototype.xa;Iw.prototype.getLogo=Iw.prototype.wa;Iw.prototype.getProjection=Iw.prototype.ya;Iw.prototype.getState=Iw.prototype.V;Iw.prototype.setAttributions=Iw.prototype.ua;Iw.prototype.get=Iw.prototype.get;Iw.prototype.getKeys=Iw.prototype.O;Iw.prototype.getProperties=Iw.prototype.N;Iw.prototype.set=Iw.prototype.set;Iw.prototype.setProperties=Iw.prototype.H;
	Iw.prototype.unset=Iw.prototype.P;Iw.prototype.changed=Iw.prototype.s;Iw.prototype.dispatchEvent=Iw.prototype.b;Iw.prototype.getRevision=Iw.prototype.L;Iw.prototype.on=Iw.prototype.J;Iw.prototype.once=Iw.prototype.once;Iw.prototype.un=Iw.prototype.K;Kw.prototype.getTileGrid=Kw.prototype.ab;Kw.prototype.refresh=Kw.prototype.va;Kw.prototype.getAttributions=Kw.prototype.xa;Kw.prototype.getLogo=Kw.prototype.wa;Kw.prototype.getProjection=Kw.prototype.ya;Kw.prototype.getState=Kw.prototype.V;
	Kw.prototype.setAttributions=Kw.prototype.ua;Kw.prototype.get=Kw.prototype.get;Kw.prototype.getKeys=Kw.prototype.O;Kw.prototype.getProperties=Kw.prototype.N;Kw.prototype.set=Kw.prototype.set;Kw.prototype.setProperties=Kw.prototype.H;Kw.prototype.unset=Kw.prototype.P;Kw.prototype.changed=Kw.prototype.s;Kw.prototype.dispatchEvent=Kw.prototype.b;Kw.prototype.getRevision=Kw.prototype.L;Kw.prototype.on=Kw.prototype.J;Kw.prototype.once=Kw.prototype.once;Kw.prototype.un=Kw.prototype.K;
	Mw.prototype.setRenderReprojectionEdges=Mw.prototype.Nb;Mw.prototype.setTileGridForProjection=Mw.prototype.Ob;Mw.prototype.getTileLoadFunction=Mw.prototype.ob;Mw.prototype.getTileUrlFunction=Mw.prototype.qb;Mw.prototype.getUrls=Mw.prototype.rb;Mw.prototype.setTileLoadFunction=Mw.prototype.xb;Mw.prototype.setTileUrlFunction=Mw.prototype.bb;Mw.prototype.setUrl=Mw.prototype.jb;Mw.prototype.setUrls=Mw.prototype.cb;Mw.prototype.getTileGrid=Mw.prototype.ab;Mw.prototype.refresh=Mw.prototype.va;
	Mw.prototype.getAttributions=Mw.prototype.xa;Mw.prototype.getLogo=Mw.prototype.wa;Mw.prototype.getProjection=Mw.prototype.ya;Mw.prototype.getState=Mw.prototype.V;Mw.prototype.setAttributions=Mw.prototype.ua;Mw.prototype.get=Mw.prototype.get;Mw.prototype.getKeys=Mw.prototype.O;Mw.prototype.getProperties=Mw.prototype.N;Mw.prototype.set=Mw.prototype.set;Mw.prototype.setProperties=Mw.prototype.H;Mw.prototype.unset=Mw.prototype.P;Mw.prototype.changed=Mw.prototype.s;Mw.prototype.dispatchEvent=Mw.prototype.b;
	Mw.prototype.getRevision=Mw.prototype.L;Mw.prototype.on=Mw.prototype.J;Mw.prototype.once=Mw.prototype.once;Mw.prototype.un=Mw.prototype.K;Nw.prototype.getTileGrid=Nw.prototype.ab;Nw.prototype.refresh=Nw.prototype.va;Nw.prototype.getAttributions=Nw.prototype.xa;Nw.prototype.getLogo=Nw.prototype.wa;Nw.prototype.getProjection=Nw.prototype.ya;Nw.prototype.getState=Nw.prototype.V;Nw.prototype.setAttributions=Nw.prototype.ua;Nw.prototype.get=Nw.prototype.get;Nw.prototype.getKeys=Nw.prototype.O;
	Nw.prototype.getProperties=Nw.prototype.N;Nw.prototype.set=Nw.prototype.set;Nw.prototype.setProperties=Nw.prototype.H;Nw.prototype.unset=Nw.prototype.P;Nw.prototype.changed=Nw.prototype.s;Nw.prototype.dispatchEvent=Nw.prototype.b;Nw.prototype.getRevision=Nw.prototype.L;Nw.prototype.on=Nw.prototype.J;Nw.prototype.once=Nw.prototype.once;Nw.prototype.un=Nw.prototype.K;Rw.prototype.setRenderReprojectionEdges=Rw.prototype.Nb;Rw.prototype.setTileGridForProjection=Rw.prototype.Ob;
	Rw.prototype.getTileLoadFunction=Rw.prototype.ob;Rw.prototype.getTileUrlFunction=Rw.prototype.qb;Rw.prototype.getUrls=Rw.prototype.rb;Rw.prototype.setTileLoadFunction=Rw.prototype.xb;Rw.prototype.setTileUrlFunction=Rw.prototype.bb;Rw.prototype.setUrl=Rw.prototype.jb;Rw.prototype.setUrls=Rw.prototype.cb;Rw.prototype.getTileGrid=Rw.prototype.ab;Rw.prototype.refresh=Rw.prototype.va;Rw.prototype.getAttributions=Rw.prototype.xa;Rw.prototype.getLogo=Rw.prototype.wa;Rw.prototype.getProjection=Rw.prototype.ya;
	Rw.prototype.getState=Rw.prototype.V;Rw.prototype.setAttributions=Rw.prototype.ua;Rw.prototype.get=Rw.prototype.get;Rw.prototype.getKeys=Rw.prototype.O;Rw.prototype.getProperties=Rw.prototype.N;Rw.prototype.set=Rw.prototype.set;Rw.prototype.setProperties=Rw.prototype.H;Rw.prototype.unset=Rw.prototype.P;Rw.prototype.changed=Rw.prototype.s;Rw.prototype.dispatchEvent=Rw.prototype.b;Rw.prototype.getRevision=Rw.prototype.L;Rw.prototype.on=Rw.prototype.J;Rw.prototype.once=Rw.prototype.once;
	Rw.prototype.un=Rw.prototype.K;Nt.prototype.type=Nt.prototype.type;Nt.prototype.target=Nt.prototype.target;Nt.prototype.preventDefault=Nt.prototype.preventDefault;Nt.prototype.stopPropagation=Nt.prototype.stopPropagation;Yw.prototype.getTileLoadFunction=Yw.prototype.ob;Yw.prototype.getTileUrlFunction=Yw.prototype.qb;Yw.prototype.getUrls=Yw.prototype.rb;Yw.prototype.setTileLoadFunction=Yw.prototype.xb;Yw.prototype.setTileUrlFunction=Yw.prototype.bb;Yw.prototype.setUrl=Yw.prototype.jb;
	Yw.prototype.setUrls=Yw.prototype.cb;Yw.prototype.getTileGrid=Yw.prototype.ab;Yw.prototype.refresh=Yw.prototype.va;Yw.prototype.getAttributions=Yw.prototype.xa;Yw.prototype.getLogo=Yw.prototype.wa;Yw.prototype.getProjection=Yw.prototype.ya;Yw.prototype.getState=Yw.prototype.V;Yw.prototype.setAttributions=Yw.prototype.ua;Yw.prototype.get=Yw.prototype.get;Yw.prototype.getKeys=Yw.prototype.O;Yw.prototype.getProperties=Yw.prototype.N;Yw.prototype.set=Yw.prototype.set;Yw.prototype.setProperties=Yw.prototype.H;
	Yw.prototype.unset=Yw.prototype.P;Yw.prototype.changed=Yw.prototype.s;Yw.prototype.dispatchEvent=Yw.prototype.b;Yw.prototype.getRevision=Yw.prototype.L;Yw.prototype.on=Yw.prototype.J;Yw.prototype.once=Yw.prototype.once;Yw.prototype.un=Yw.prototype.K;Y.prototype.setRenderReprojectionEdges=Y.prototype.Nb;Y.prototype.setTileGridForProjection=Y.prototype.Ob;Y.prototype.getTileLoadFunction=Y.prototype.ob;Y.prototype.getTileUrlFunction=Y.prototype.qb;Y.prototype.getUrls=Y.prototype.rb;
	Y.prototype.setTileLoadFunction=Y.prototype.xb;Y.prototype.setTileUrlFunction=Y.prototype.bb;Y.prototype.setUrl=Y.prototype.jb;Y.prototype.setUrls=Y.prototype.cb;Y.prototype.getTileGrid=Y.prototype.ab;Y.prototype.refresh=Y.prototype.va;Y.prototype.getAttributions=Y.prototype.xa;Y.prototype.getLogo=Y.prototype.wa;Y.prototype.getProjection=Y.prototype.ya;Y.prototype.getState=Y.prototype.V;Y.prototype.setAttributions=Y.prototype.ua;Y.prototype.get=Y.prototype.get;Y.prototype.getKeys=Y.prototype.O;
	Y.prototype.getProperties=Y.prototype.N;Y.prototype.set=Y.prototype.set;Y.prototype.setProperties=Y.prototype.H;Y.prototype.unset=Y.prototype.P;Y.prototype.changed=Y.prototype.s;Y.prototype.dispatchEvent=Y.prototype.b;Y.prototype.getRevision=Y.prototype.L;Y.prototype.on=Y.prototype.J;Y.prototype.once=Y.prototype.once;Y.prototype.un=Y.prototype.K;bx.prototype.setRenderReprojectionEdges=bx.prototype.Nb;bx.prototype.setTileGridForProjection=bx.prototype.Ob;bx.prototype.getTileLoadFunction=bx.prototype.ob;
	bx.prototype.getTileUrlFunction=bx.prototype.qb;bx.prototype.getUrls=bx.prototype.rb;bx.prototype.setTileLoadFunction=bx.prototype.xb;bx.prototype.setTileUrlFunction=bx.prototype.bb;bx.prototype.setUrl=bx.prototype.jb;bx.prototype.setUrls=bx.prototype.cb;bx.prototype.getTileGrid=bx.prototype.ab;bx.prototype.refresh=bx.prototype.va;bx.prototype.getAttributions=bx.prototype.xa;bx.prototype.getLogo=bx.prototype.wa;bx.prototype.getProjection=bx.prototype.ya;bx.prototype.getState=bx.prototype.V;
	bx.prototype.setAttributions=bx.prototype.ua;bx.prototype.get=bx.prototype.get;bx.prototype.getKeys=bx.prototype.O;bx.prototype.getProperties=bx.prototype.N;bx.prototype.set=bx.prototype.set;bx.prototype.setProperties=bx.prototype.H;bx.prototype.unset=bx.prototype.P;bx.prototype.changed=bx.prototype.s;bx.prototype.dispatchEvent=bx.prototype.b;bx.prototype.getRevision=bx.prototype.L;bx.prototype.on=bx.prototype.J;bx.prototype.once=bx.prototype.once;bx.prototype.un=bx.prototype.K;
	Pv.prototype.getTileCoord=Pv.prototype.i;Pv.prototype.load=Pv.prototype.load;dt.prototype.changed=dt.prototype.s;dt.prototype.dispatchEvent=dt.prototype.b;dt.prototype.getRevision=dt.prototype.L;dt.prototype.on=dt.prototype.J;dt.prototype.once=dt.prototype.once;dt.prototype.un=dt.prototype.K;Bt.prototype.changed=Bt.prototype.s;Bt.prototype.dispatchEvent=Bt.prototype.b;Bt.prototype.getRevision=Bt.prototype.L;Bt.prototype.on=Bt.prototype.J;Bt.prototype.once=Bt.prototype.once;Bt.prototype.un=Bt.prototype.K;
	vv.prototype.changed=vv.prototype.s;vv.prototype.dispatchEvent=vv.prototype.b;vv.prototype.getRevision=vv.prototype.L;vv.prototype.on=vv.prototype.J;vv.prototype.once=vv.prototype.once;vv.prototype.un=vv.prototype.K;Gv.prototype.changed=Gv.prototype.s;Gv.prototype.dispatchEvent=Gv.prototype.b;Gv.prototype.getRevision=Gv.prototype.L;Gv.prototype.on=Gv.prototype.J;Gv.prototype.once=Gv.prototype.once;Gv.prototype.un=Gv.prototype.K;Et.prototype.changed=Et.prototype.s;Et.prototype.dispatchEvent=Et.prototype.b;
	Et.prototype.getRevision=Et.prototype.L;Et.prototype.on=Et.prototype.J;Et.prototype.once=Et.prototype.once;Et.prototype.un=Et.prototype.K;mt.prototype.changed=mt.prototype.s;mt.prototype.dispatchEvent=mt.prototype.b;mt.prototype.getRevision=mt.prototype.L;mt.prototype.on=mt.prototype.J;mt.prototype.once=mt.prototype.once;mt.prototype.un=mt.prototype.K;cv.prototype.changed=cv.prototype.s;cv.prototype.dispatchEvent=cv.prototype.b;cv.prototype.getRevision=cv.prototype.L;cv.prototype.on=cv.prototype.J;
	cv.prototype.once=cv.prototype.once;cv.prototype.un=cv.prototype.K;dv.prototype.changed=dv.prototype.s;dv.prototype.dispatchEvent=dv.prototype.b;dv.prototype.getRevision=dv.prototype.L;dv.prototype.on=dv.prototype.J;dv.prototype.once=dv.prototype.once;dv.prototype.un=dv.prototype.K;zv.prototype.changed=zv.prototype.s;zv.prototype.dispatchEvent=zv.prototype.b;zv.prototype.getRevision=zv.prototype.L;zv.prototype.on=zv.prototype.J;zv.prototype.once=zv.prototype.once;zv.prototype.un=zv.prototype.K;
	ut.prototype.changed=ut.prototype.s;ut.prototype.dispatchEvent=ut.prototype.b;ut.prototype.getRevision=ut.prototype.L;ut.prototype.on=ut.prototype.J;ut.prototype.once=ut.prototype.once;ut.prototype.un=ut.prototype.K;Iv.prototype.changed=Iv.prototype.s;Iv.prototype.dispatchEvent=Iv.prototype.b;Iv.prototype.getRevision=Iv.prototype.L;Iv.prototype.on=Iv.prototype.J;Iv.prototype.once=Iv.prototype.once;Iv.prototype.un=Iv.prototype.K;Mh.prototype.type=Mh.prototype.type;Mh.prototype.target=Mh.prototype.target;
	Mh.prototype.preventDefault=Mh.prototype.preventDefault;Mh.prototype.stopPropagation=Mh.prototype.stopPropagation;ge.prototype.type=ge.prototype.type;ge.prototype.target=ge.prototype.target;ge.prototype.preventDefault=ge.prototype.preventDefault;ge.prototype.stopPropagation=ge.prototype.stopPropagation;dh.prototype.get=dh.prototype.get;dh.prototype.getKeys=dh.prototype.O;dh.prototype.getProperties=dh.prototype.N;dh.prototype.set=dh.prototype.set;dh.prototype.setProperties=dh.prototype.H;
	dh.prototype.unset=dh.prototype.P;dh.prototype.changed=dh.prototype.s;dh.prototype.dispatchEvent=dh.prototype.b;dh.prototype.getRevision=dh.prototype.L;dh.prototype.on=dh.prototype.J;dh.prototype.once=dh.prototype.once;dh.prototype.un=dh.prototype.K;fh.prototype.getExtent=fh.prototype.D;fh.prototype.getMaxResolution=fh.prototype.gc;fh.prototype.getMinResolution=fh.prototype.hc;fh.prototype.getOpacity=fh.prototype.ic;fh.prototype.getVisible=fh.prototype.Kb;fh.prototype.getZIndex=fh.prototype.za;
	fh.prototype.setExtent=fh.prototype.uc;fh.prototype.setMaxResolution=fh.prototype.zc;fh.prototype.setMinResolution=fh.prototype.Ac;fh.prototype.setOpacity=fh.prototype.vc;fh.prototype.setVisible=fh.prototype.wc;fh.prototype.setZIndex=fh.prototype.Wb;fh.prototype.get=fh.prototype.get;fh.prototype.getKeys=fh.prototype.O;fh.prototype.getProperties=fh.prototype.N;fh.prototype.set=fh.prototype.set;fh.prototype.setProperties=fh.prototype.H;fh.prototype.unset=fh.prototype.P;fh.prototype.changed=fh.prototype.s;
	fh.prototype.dispatchEvent=fh.prototype.b;fh.prototype.getRevision=fh.prototype.L;fh.prototype.on=fh.prototype.J;fh.prototype.once=fh.prototype.once;fh.prototype.un=fh.prototype.K;rh.prototype.getExtent=rh.prototype.D;rh.prototype.getMaxResolution=rh.prototype.gc;rh.prototype.getMinResolution=rh.prototype.hc;rh.prototype.getOpacity=rh.prototype.ic;rh.prototype.getVisible=rh.prototype.Kb;rh.prototype.getZIndex=rh.prototype.za;rh.prototype.setExtent=rh.prototype.uc;rh.prototype.setMaxResolution=rh.prototype.zc;
	rh.prototype.setMinResolution=rh.prototype.Ac;rh.prototype.setOpacity=rh.prototype.vc;rh.prototype.setVisible=rh.prototype.wc;rh.prototype.setZIndex=rh.prototype.Wb;rh.prototype.get=rh.prototype.get;rh.prototype.getKeys=rh.prototype.O;rh.prototype.getProperties=rh.prototype.N;rh.prototype.set=rh.prototype.set;rh.prototype.setProperties=rh.prototype.H;rh.prototype.unset=rh.prototype.P;rh.prototype.changed=rh.prototype.s;rh.prototype.dispatchEvent=rh.prototype.b;rh.prototype.getRevision=rh.prototype.L;
	rh.prototype.on=rh.prototype.J;rh.prototype.once=rh.prototype.once;rh.prototype.un=rh.prototype.K;R.prototype.setMap=R.prototype.setMap;R.prototype.setSource=R.prototype.Yc;R.prototype.getExtent=R.prototype.D;R.prototype.getMaxResolution=R.prototype.gc;R.prototype.getMinResolution=R.prototype.hc;R.prototype.getOpacity=R.prototype.ic;R.prototype.getVisible=R.prototype.Kb;R.prototype.getZIndex=R.prototype.za;R.prototype.setExtent=R.prototype.uc;R.prototype.setMaxResolution=R.prototype.zc;
	R.prototype.setMinResolution=R.prototype.Ac;R.prototype.setOpacity=R.prototype.vc;R.prototype.setVisible=R.prototype.wc;R.prototype.setZIndex=R.prototype.Wb;R.prototype.get=R.prototype.get;R.prototype.getKeys=R.prototype.O;R.prototype.getProperties=R.prototype.N;R.prototype.set=R.prototype.set;R.prototype.setProperties=R.prototype.H;R.prototype.unset=R.prototype.P;R.prototype.changed=R.prototype.s;R.prototype.dispatchEvent=R.prototype.b;R.prototype.getRevision=R.prototype.L;R.prototype.on=R.prototype.J;
	R.prototype.once=R.prototype.once;R.prototype.un=R.prototype.K;T.prototype.getSource=T.prototype.la;T.prototype.getStyle=T.prototype.C;T.prototype.getStyleFunction=T.prototype.G;T.prototype.setStyle=T.prototype.g;T.prototype.setMap=T.prototype.setMap;T.prototype.setSource=T.prototype.Yc;T.prototype.getExtent=T.prototype.D;T.prototype.getMaxResolution=T.prototype.gc;T.prototype.getMinResolution=T.prototype.hc;T.prototype.getOpacity=T.prototype.ic;T.prototype.getVisible=T.prototype.Kb;
	T.prototype.getZIndex=T.prototype.za;T.prototype.setExtent=T.prototype.uc;T.prototype.setMaxResolution=T.prototype.zc;T.prototype.setMinResolution=T.prototype.Ac;T.prototype.setOpacity=T.prototype.vc;T.prototype.setVisible=T.prototype.wc;T.prototype.setZIndex=T.prototype.Wb;T.prototype.get=T.prototype.get;T.prototype.getKeys=T.prototype.O;T.prototype.getProperties=T.prototype.N;T.prototype.set=T.prototype.set;T.prototype.setProperties=T.prototype.H;T.prototype.unset=T.prototype.P;
	T.prototype.changed=T.prototype.s;T.prototype.dispatchEvent=T.prototype.b;T.prototype.getRevision=T.prototype.L;T.prototype.on=T.prototype.J;T.prototype.once=T.prototype.once;T.prototype.un=T.prototype.K;yv.prototype.setMap=yv.prototype.setMap;yv.prototype.setSource=yv.prototype.Yc;yv.prototype.getExtent=yv.prototype.D;yv.prototype.getMaxResolution=yv.prototype.gc;yv.prototype.getMinResolution=yv.prototype.hc;yv.prototype.getOpacity=yv.prototype.ic;yv.prototype.getVisible=yv.prototype.Kb;
	yv.prototype.getZIndex=yv.prototype.za;yv.prototype.setExtent=yv.prototype.uc;yv.prototype.setMaxResolution=yv.prototype.zc;yv.prototype.setMinResolution=yv.prototype.Ac;yv.prototype.setOpacity=yv.prototype.vc;yv.prototype.setVisible=yv.prototype.wc;yv.prototype.setZIndex=yv.prototype.Wb;yv.prototype.get=yv.prototype.get;yv.prototype.getKeys=yv.prototype.O;yv.prototype.getProperties=yv.prototype.N;yv.prototype.set=yv.prototype.set;yv.prototype.setProperties=yv.prototype.H;yv.prototype.unset=yv.prototype.P;
	yv.prototype.changed=yv.prototype.s;yv.prototype.dispatchEvent=yv.prototype.b;yv.prototype.getRevision=yv.prototype.L;yv.prototype.on=yv.prototype.J;yv.prototype.once=yv.prototype.once;yv.prototype.un=yv.prototype.K;Hv.prototype.setMap=Hv.prototype.setMap;Hv.prototype.setSource=Hv.prototype.Yc;Hv.prototype.getExtent=Hv.prototype.D;Hv.prototype.getMaxResolution=Hv.prototype.gc;Hv.prototype.getMinResolution=Hv.prototype.hc;Hv.prototype.getOpacity=Hv.prototype.ic;Hv.prototype.getVisible=Hv.prototype.Kb;
	Hv.prototype.getZIndex=Hv.prototype.za;Hv.prototype.setExtent=Hv.prototype.uc;Hv.prototype.setMaxResolution=Hv.prototype.zc;Hv.prototype.setMinResolution=Hv.prototype.Ac;Hv.prototype.setOpacity=Hv.prototype.vc;Hv.prototype.setVisible=Hv.prototype.wc;Hv.prototype.setZIndex=Hv.prototype.Wb;Hv.prototype.get=Hv.prototype.get;Hv.prototype.getKeys=Hv.prototype.O;Hv.prototype.getProperties=Hv.prototype.N;Hv.prototype.set=Hv.prototype.set;Hv.prototype.setProperties=Hv.prototype.H;Hv.prototype.unset=Hv.prototype.P;
	Hv.prototype.changed=Hv.prototype.s;Hv.prototype.dispatchEvent=Hv.prototype.b;Hv.prototype.getRevision=Hv.prototype.L;Hv.prototype.on=Hv.prototype.J;Hv.prototype.once=Hv.prototype.once;Hv.prototype.un=Hv.prototype.K;U.prototype.getSource=U.prototype.la;U.prototype.getStyle=U.prototype.C;U.prototype.getStyleFunction=U.prototype.G;U.prototype.setStyle=U.prototype.g;U.prototype.setMap=U.prototype.setMap;U.prototype.setSource=U.prototype.Yc;U.prototype.getExtent=U.prototype.D;
	U.prototype.getMaxResolution=U.prototype.gc;U.prototype.getMinResolution=U.prototype.hc;U.prototype.getOpacity=U.prototype.ic;U.prototype.getVisible=U.prototype.Kb;U.prototype.getZIndex=U.prototype.za;U.prototype.setExtent=U.prototype.uc;U.prototype.setMaxResolution=U.prototype.zc;U.prototype.setMinResolution=U.prototype.Ac;U.prototype.setOpacity=U.prototype.vc;U.prototype.setVisible=U.prototype.wc;U.prototype.setZIndex=U.prototype.Wb;U.prototype.get=U.prototype.get;U.prototype.getKeys=U.prototype.O;
	U.prototype.getProperties=U.prototype.N;U.prototype.set=U.prototype.set;U.prototype.setProperties=U.prototype.H;U.prototype.unset=U.prototype.P;U.prototype.changed=U.prototype.s;U.prototype.dispatchEvent=U.prototype.b;U.prototype.getRevision=U.prototype.L;U.prototype.on=U.prototype.J;U.prototype.once=U.prototype.once;U.prototype.un=U.prototype.K;ag.prototype.get=ag.prototype.get;ag.prototype.getKeys=ag.prototype.O;ag.prototype.getProperties=ag.prototype.N;ag.prototype.set=ag.prototype.set;
	ag.prototype.setProperties=ag.prototype.H;ag.prototype.unset=ag.prototype.P;ag.prototype.changed=ag.prototype.s;ag.prototype.dispatchEvent=ag.prototype.b;ag.prototype.getRevision=ag.prototype.L;ag.prototype.on=ag.prototype.J;ag.prototype.once=ag.prototype.once;ag.prototype.un=ag.prototype.K;eg.prototype.getActive=eg.prototype.c;eg.prototype.getMap=eg.prototype.i;eg.prototype.setActive=eg.prototype.Ia;eg.prototype.get=eg.prototype.get;eg.prototype.getKeys=eg.prototype.O;
	eg.prototype.getProperties=eg.prototype.N;eg.prototype.set=eg.prototype.set;eg.prototype.setProperties=eg.prototype.H;eg.prototype.unset=eg.prototype.P;eg.prototype.changed=eg.prototype.s;eg.prototype.dispatchEvent=eg.prototype.b;eg.prototype.getRevision=eg.prototype.L;eg.prototype.on=eg.prototype.J;eg.prototype.once=eg.prototype.once;eg.prototype.un=eg.prototype.K;zs.prototype.getActive=zs.prototype.c;zs.prototype.getMap=zs.prototype.i;zs.prototype.setActive=zs.prototype.Ia;zs.prototype.get=zs.prototype.get;
	zs.prototype.getKeys=zs.prototype.O;zs.prototype.getProperties=zs.prototype.N;zs.prototype.set=zs.prototype.set;zs.prototype.setProperties=zs.prototype.H;zs.prototype.unset=zs.prototype.P;zs.prototype.changed=zs.prototype.s;zs.prototype.dispatchEvent=zs.prototype.b;zs.prototype.getRevision=zs.prototype.L;zs.prototype.on=zs.prototype.J;zs.prototype.once=zs.prototype.once;zs.prototype.un=zs.prototype.K;Cs.prototype.type=Cs.prototype.type;Cs.prototype.target=Cs.prototype.target;
	Cs.prototype.preventDefault=Cs.prototype.preventDefault;Cs.prototype.stopPropagation=Cs.prototype.stopPropagation;pg.prototype.getActive=pg.prototype.c;pg.prototype.getMap=pg.prototype.i;pg.prototype.setActive=pg.prototype.Ia;pg.prototype.get=pg.prototype.get;pg.prototype.getKeys=pg.prototype.O;pg.prototype.getProperties=pg.prototype.N;pg.prototype.set=pg.prototype.set;pg.prototype.setProperties=pg.prototype.H;pg.prototype.unset=pg.prototype.P;pg.prototype.changed=pg.prototype.s;
	pg.prototype.dispatchEvent=pg.prototype.b;pg.prototype.getRevision=pg.prototype.L;pg.prototype.on=pg.prototype.J;pg.prototype.once=pg.prototype.once;pg.prototype.un=pg.prototype.K;Dg.prototype.getActive=Dg.prototype.c;Dg.prototype.getMap=Dg.prototype.i;Dg.prototype.setActive=Dg.prototype.Ia;Dg.prototype.get=Dg.prototype.get;Dg.prototype.getKeys=Dg.prototype.O;Dg.prototype.getProperties=Dg.prototype.N;Dg.prototype.set=Dg.prototype.set;Dg.prototype.setProperties=Dg.prototype.H;Dg.prototype.unset=Dg.prototype.P;
	Dg.prototype.changed=Dg.prototype.s;Dg.prototype.dispatchEvent=Dg.prototype.b;Dg.prototype.getRevision=Dg.prototype.L;Dg.prototype.on=Dg.prototype.J;Dg.prototype.once=Dg.prototype.once;Dg.prototype.un=Dg.prototype.K;Ig.prototype.type=Ig.prototype.type;Ig.prototype.target=Ig.prototype.target;Ig.prototype.preventDefault=Ig.prototype.preventDefault;Ig.prototype.stopPropagation=Ig.prototype.stopPropagation;sg.prototype.getActive=sg.prototype.c;sg.prototype.getMap=sg.prototype.i;
	sg.prototype.setActive=sg.prototype.Ia;sg.prototype.get=sg.prototype.get;sg.prototype.getKeys=sg.prototype.O;sg.prototype.getProperties=sg.prototype.N;sg.prototype.set=sg.prototype.set;sg.prototype.setProperties=sg.prototype.H;sg.prototype.unset=sg.prototype.P;sg.prototype.changed=sg.prototype.s;sg.prototype.dispatchEvent=sg.prototype.b;sg.prototype.getRevision=sg.prototype.L;sg.prototype.on=sg.prototype.J;sg.prototype.once=sg.prototype.once;sg.prototype.un=sg.prototype.K;wg.prototype.getActive=wg.prototype.c;
	wg.prototype.getMap=wg.prototype.i;wg.prototype.setActive=wg.prototype.Ia;wg.prototype.get=wg.prototype.get;wg.prototype.getKeys=wg.prototype.O;wg.prototype.getProperties=wg.prototype.N;wg.prototype.set=wg.prototype.set;wg.prototype.setProperties=wg.prototype.H;wg.prototype.unset=wg.prototype.P;wg.prototype.changed=wg.prototype.s;wg.prototype.dispatchEvent=wg.prototype.b;wg.prototype.getRevision=wg.prototype.L;wg.prototype.on=wg.prototype.J;wg.prototype.once=wg.prototype.once;wg.prototype.un=wg.prototype.K;
	Es.prototype.getActive=Es.prototype.c;Es.prototype.getMap=Es.prototype.i;Es.prototype.setActive=Es.prototype.Ia;Es.prototype.get=Es.prototype.get;Es.prototype.getKeys=Es.prototype.O;Es.prototype.getProperties=Es.prototype.N;Es.prototype.set=Es.prototype.set;Es.prototype.setProperties=Es.prototype.H;Es.prototype.unset=Es.prototype.P;Es.prototype.changed=Es.prototype.s;Es.prototype.dispatchEvent=Es.prototype.b;Es.prototype.getRevision=Es.prototype.L;Es.prototype.on=Es.prototype.J;
	Es.prototype.once=Es.prototype.once;Es.prototype.un=Es.prototype.K;Mg.prototype.getGeometry=Mg.prototype.U;Mg.prototype.getActive=Mg.prototype.c;Mg.prototype.getMap=Mg.prototype.i;Mg.prototype.setActive=Mg.prototype.Ia;Mg.prototype.get=Mg.prototype.get;Mg.prototype.getKeys=Mg.prototype.O;Mg.prototype.getProperties=Mg.prototype.N;Mg.prototype.set=Mg.prototype.set;Mg.prototype.setProperties=Mg.prototype.H;Mg.prototype.unset=Mg.prototype.P;Mg.prototype.changed=Mg.prototype.s;
	Mg.prototype.dispatchEvent=Mg.prototype.b;Mg.prototype.getRevision=Mg.prototype.L;Mg.prototype.on=Mg.prototype.J;Mg.prototype.once=Mg.prototype.once;Mg.prototype.un=Mg.prototype.K;Qt.prototype.getActive=Qt.prototype.c;Qt.prototype.getMap=Qt.prototype.i;Qt.prototype.setActive=Qt.prototype.Ia;Qt.prototype.get=Qt.prototype.get;Qt.prototype.getKeys=Qt.prototype.O;Qt.prototype.getProperties=Qt.prototype.N;Qt.prototype.set=Qt.prototype.set;Qt.prototype.setProperties=Qt.prototype.H;Qt.prototype.unset=Qt.prototype.P;
	Qt.prototype.changed=Qt.prototype.s;Qt.prototype.dispatchEvent=Qt.prototype.b;Qt.prototype.getRevision=Qt.prototype.L;Qt.prototype.on=Qt.prototype.J;Qt.prototype.once=Qt.prototype.once;Qt.prototype.un=Qt.prototype.K;eu.prototype.type=eu.prototype.type;eu.prototype.target=eu.prototype.target;eu.prototype.preventDefault=eu.prototype.preventDefault;eu.prototype.stopPropagation=eu.prototype.stopPropagation;gu.prototype.getActive=gu.prototype.c;gu.prototype.getMap=gu.prototype.i;
	gu.prototype.setActive=gu.prototype.Ia;gu.prototype.get=gu.prototype.get;gu.prototype.getKeys=gu.prototype.O;gu.prototype.getProperties=gu.prototype.N;gu.prototype.set=gu.prototype.set;gu.prototype.setProperties=gu.prototype.H;gu.prototype.unset=gu.prototype.P;gu.prototype.changed=gu.prototype.s;gu.prototype.dispatchEvent=gu.prototype.b;gu.prototype.getRevision=gu.prototype.L;gu.prototype.on=gu.prototype.J;gu.prototype.once=gu.prototype.once;gu.prototype.un=gu.prototype.K;ru.prototype.type=ru.prototype.type;
	ru.prototype.target=ru.prototype.target;ru.prototype.preventDefault=ru.prototype.preventDefault;ru.prototype.stopPropagation=ru.prototype.stopPropagation;Ng.prototype.getActive=Ng.prototype.c;Ng.prototype.getMap=Ng.prototype.i;Ng.prototype.setActive=Ng.prototype.Ia;Ng.prototype.get=Ng.prototype.get;Ng.prototype.getKeys=Ng.prototype.O;Ng.prototype.getProperties=Ng.prototype.N;Ng.prototype.set=Ng.prototype.set;Ng.prototype.setProperties=Ng.prototype.H;Ng.prototype.unset=Ng.prototype.P;
	Ng.prototype.changed=Ng.prototype.s;Ng.prototype.dispatchEvent=Ng.prototype.b;Ng.prototype.getRevision=Ng.prototype.L;Ng.prototype.on=Ng.prototype.J;Ng.prototype.once=Ng.prototype.once;Ng.prototype.un=Ng.prototype.K;Pg.prototype.getActive=Pg.prototype.c;Pg.prototype.getMap=Pg.prototype.i;Pg.prototype.setActive=Pg.prototype.Ia;Pg.prototype.get=Pg.prototype.get;Pg.prototype.getKeys=Pg.prototype.O;Pg.prototype.getProperties=Pg.prototype.N;Pg.prototype.set=Pg.prototype.set;
	Pg.prototype.setProperties=Pg.prototype.H;Pg.prototype.unset=Pg.prototype.P;Pg.prototype.changed=Pg.prototype.s;Pg.prototype.dispatchEvent=Pg.prototype.b;Pg.prototype.getRevision=Pg.prototype.L;Pg.prototype.on=Pg.prototype.J;Pg.prototype.once=Pg.prototype.once;Pg.prototype.un=Pg.prototype.K;tu.prototype.getActive=tu.prototype.c;tu.prototype.getMap=tu.prototype.i;tu.prototype.setActive=tu.prototype.Ia;tu.prototype.get=tu.prototype.get;tu.prototype.getKeys=tu.prototype.O;
	tu.prototype.getProperties=tu.prototype.N;tu.prototype.set=tu.prototype.set;tu.prototype.setProperties=tu.prototype.H;tu.prototype.unset=tu.prototype.P;tu.prototype.changed=tu.prototype.s;tu.prototype.dispatchEvent=tu.prototype.b;tu.prototype.getRevision=tu.prototype.L;tu.prototype.on=tu.prototype.J;tu.prototype.once=tu.prototype.once;tu.prototype.un=tu.prototype.K;Bu.prototype.type=Bu.prototype.type;Bu.prototype.target=Bu.prototype.target;Bu.prototype.preventDefault=Bu.prototype.preventDefault;
	Bu.prototype.stopPropagation=Bu.prototype.stopPropagation;Rg.prototype.getActive=Rg.prototype.c;Rg.prototype.getMap=Rg.prototype.i;Rg.prototype.setActive=Rg.prototype.Ia;Rg.prototype.get=Rg.prototype.get;Rg.prototype.getKeys=Rg.prototype.O;Rg.prototype.getProperties=Rg.prototype.N;Rg.prototype.set=Rg.prototype.set;Rg.prototype.setProperties=Rg.prototype.H;Rg.prototype.unset=Rg.prototype.P;Rg.prototype.changed=Rg.prototype.s;Rg.prototype.dispatchEvent=Rg.prototype.b;Rg.prototype.getRevision=Rg.prototype.L;
	Rg.prototype.on=Rg.prototype.J;Rg.prototype.once=Rg.prototype.once;Rg.prototype.un=Rg.prototype.K;Vg.prototype.getActive=Vg.prototype.c;Vg.prototype.getMap=Vg.prototype.i;Vg.prototype.setActive=Vg.prototype.Ia;Vg.prototype.get=Vg.prototype.get;Vg.prototype.getKeys=Vg.prototype.O;Vg.prototype.getProperties=Vg.prototype.N;Vg.prototype.set=Vg.prototype.set;Vg.prototype.setProperties=Vg.prototype.H;Vg.prototype.unset=Vg.prototype.P;Vg.prototype.changed=Vg.prototype.s;Vg.prototype.dispatchEvent=Vg.prototype.b;
	Vg.prototype.getRevision=Vg.prototype.L;Vg.prototype.on=Vg.prototype.J;Vg.prototype.once=Vg.prototype.once;Vg.prototype.un=Vg.prototype.K;Zg.prototype.getActive=Zg.prototype.c;Zg.prototype.getMap=Zg.prototype.i;Zg.prototype.setActive=Zg.prototype.Ia;Zg.prototype.get=Zg.prototype.get;Zg.prototype.getKeys=Zg.prototype.O;Zg.prototype.getProperties=Zg.prototype.N;Zg.prototype.set=Zg.prototype.set;Zg.prototype.setProperties=Zg.prototype.H;Zg.prototype.unset=Zg.prototype.P;Zg.prototype.changed=Zg.prototype.s;
	Zg.prototype.dispatchEvent=Zg.prototype.b;Zg.prototype.getRevision=Zg.prototype.L;Zg.prototype.on=Zg.prototype.J;Zg.prototype.once=Zg.prototype.once;Zg.prototype.un=Zg.prototype.K;Ju.prototype.getActive=Ju.prototype.c;Ju.prototype.getMap=Ju.prototype.i;Ju.prototype.setActive=Ju.prototype.Ia;Ju.prototype.get=Ju.prototype.get;Ju.prototype.getKeys=Ju.prototype.O;Ju.prototype.getProperties=Ju.prototype.N;Ju.prototype.set=Ju.prototype.set;Ju.prototype.setProperties=Ju.prototype.H;Ju.prototype.unset=Ju.prototype.P;
	Ju.prototype.changed=Ju.prototype.s;Ju.prototype.dispatchEvent=Ju.prototype.b;Ju.prototype.getRevision=Ju.prototype.L;Ju.prototype.on=Ju.prototype.J;Ju.prototype.once=Ju.prototype.once;Ju.prototype.un=Ju.prototype.K;Mu.prototype.type=Mu.prototype.type;Mu.prototype.target=Mu.prototype.target;Mu.prototype.preventDefault=Mu.prototype.preventDefault;Mu.prototype.stopPropagation=Mu.prototype.stopPropagation;Ou.prototype.getActive=Ou.prototype.c;Ou.prototype.getMap=Ou.prototype.i;
	Ou.prototype.setActive=Ou.prototype.Ia;Ou.prototype.get=Ou.prototype.get;Ou.prototype.getKeys=Ou.prototype.O;Ou.prototype.getProperties=Ou.prototype.N;Ou.prototype.set=Ou.prototype.set;Ou.prototype.setProperties=Ou.prototype.H;Ou.prototype.unset=Ou.prototype.P;Ou.prototype.changed=Ou.prototype.s;Ou.prototype.dispatchEvent=Ou.prototype.b;Ou.prototype.getRevision=Ou.prototype.L;Ou.prototype.on=Ou.prototype.J;Ou.prototype.once=Ou.prototype.once;Ou.prototype.un=Ou.prototype.K;Su.prototype.getActive=Su.prototype.c;
	Su.prototype.getMap=Su.prototype.i;Su.prototype.setActive=Su.prototype.Ia;Su.prototype.get=Su.prototype.get;Su.prototype.getKeys=Su.prototype.O;Su.prototype.getProperties=Su.prototype.N;Su.prototype.set=Su.prototype.set;Su.prototype.setProperties=Su.prototype.H;Su.prototype.unset=Su.prototype.P;Su.prototype.changed=Su.prototype.s;Su.prototype.dispatchEvent=Su.prototype.b;Su.prototype.getRevision=Su.prototype.L;Su.prototype.on=Su.prototype.J;Su.prototype.once=Su.prototype.once;Su.prototype.un=Su.prototype.K;
	Yu.prototype.type=Yu.prototype.type;Yu.prototype.target=Yu.prototype.target;Yu.prototype.preventDefault=Yu.prototype.preventDefault;Yu.prototype.stopPropagation=Yu.prototype.stopPropagation;cf.prototype.get=cf.prototype.get;cf.prototype.getKeys=cf.prototype.O;cf.prototype.getProperties=cf.prototype.N;cf.prototype.set=cf.prototype.set;cf.prototype.setProperties=cf.prototype.H;cf.prototype.unset=cf.prototype.P;cf.prototype.changed=cf.prototype.s;cf.prototype.dispatchEvent=cf.prototype.b;
	cf.prototype.getRevision=cf.prototype.L;cf.prototype.on=cf.prototype.J;cf.prototype.once=cf.prototype.once;cf.prototype.un=cf.prototype.K;ff.prototype.getClosestPoint=ff.prototype.Ab;ff.prototype.intersectsCoordinate=ff.prototype.sb;ff.prototype.getExtent=ff.prototype.D;ff.prototype.rotate=ff.prototype.rotate;ff.prototype.scale=ff.prototype.scale;ff.prototype.simplify=ff.prototype.Pb;ff.prototype.transform=ff.prototype.tb;ff.prototype.get=ff.prototype.get;ff.prototype.getKeys=ff.prototype.O;
	ff.prototype.getProperties=ff.prototype.N;ff.prototype.set=ff.prototype.set;ff.prototype.setProperties=ff.prototype.H;ff.prototype.unset=ff.prototype.P;ff.prototype.changed=ff.prototype.s;ff.prototype.dispatchEvent=ff.prototype.b;ff.prototype.getRevision=ff.prototype.L;ff.prototype.on=ff.prototype.J;ff.prototype.once=ff.prototype.once;ff.prototype.un=ff.prototype.K;is.prototype.getFirstCoordinate=is.prototype.bc;is.prototype.getLastCoordinate=is.prototype.cc;is.prototype.getLayout=is.prototype.dc;
	is.prototype.rotate=is.prototype.rotate;is.prototype.scale=is.prototype.scale;is.prototype.getClosestPoint=is.prototype.Ab;is.prototype.intersectsCoordinate=is.prototype.sb;is.prototype.getExtent=is.prototype.D;is.prototype.simplify=is.prototype.Pb;is.prototype.get=is.prototype.get;is.prototype.getKeys=is.prototype.O;is.prototype.getProperties=is.prototype.N;is.prototype.set=is.prototype.set;is.prototype.setProperties=is.prototype.H;is.prototype.unset=is.prototype.P;is.prototype.changed=is.prototype.s;
	is.prototype.dispatchEvent=is.prototype.b;is.prototype.getRevision=is.prototype.L;is.prototype.on=is.prototype.J;is.prototype.once=is.prototype.once;is.prototype.un=is.prototype.K;qm.prototype.getClosestPoint=qm.prototype.Ab;qm.prototype.intersectsCoordinate=qm.prototype.sb;qm.prototype.getExtent=qm.prototype.D;qm.prototype.rotate=qm.prototype.rotate;qm.prototype.scale=qm.prototype.scale;qm.prototype.simplify=qm.prototype.Pb;qm.prototype.transform=qm.prototype.tb;qm.prototype.get=qm.prototype.get;
	qm.prototype.getKeys=qm.prototype.O;qm.prototype.getProperties=qm.prototype.N;qm.prototype.set=qm.prototype.set;qm.prototype.setProperties=qm.prototype.H;qm.prototype.unset=qm.prototype.P;qm.prototype.changed=qm.prototype.s;qm.prototype.dispatchEvent=qm.prototype.b;qm.prototype.getRevision=qm.prototype.L;qm.prototype.on=qm.prototype.J;qm.prototype.once=qm.prototype.once;qm.prototype.un=qm.prototype.K;yf.prototype.getFirstCoordinate=yf.prototype.bc;yf.prototype.getLastCoordinate=yf.prototype.cc;
	yf.prototype.getLayout=yf.prototype.dc;yf.prototype.rotate=yf.prototype.rotate;yf.prototype.scale=yf.prototype.scale;yf.prototype.getClosestPoint=yf.prototype.Ab;yf.prototype.intersectsCoordinate=yf.prototype.sb;yf.prototype.getExtent=yf.prototype.D;yf.prototype.simplify=yf.prototype.Pb;yf.prototype.transform=yf.prototype.tb;yf.prototype.get=yf.prototype.get;yf.prototype.getKeys=yf.prototype.O;yf.prototype.getProperties=yf.prototype.N;yf.prototype.set=yf.prototype.set;yf.prototype.setProperties=yf.prototype.H;
	yf.prototype.unset=yf.prototype.P;yf.prototype.changed=yf.prototype.s;yf.prototype.dispatchEvent=yf.prototype.b;yf.prototype.getRevision=yf.prototype.L;yf.prototype.on=yf.prototype.J;yf.prototype.once=yf.prototype.once;yf.prototype.un=yf.prototype.K;M.prototype.getFirstCoordinate=M.prototype.bc;M.prototype.getLastCoordinate=M.prototype.cc;M.prototype.getLayout=M.prototype.dc;M.prototype.rotate=M.prototype.rotate;M.prototype.scale=M.prototype.scale;M.prototype.getClosestPoint=M.prototype.Ab;
	M.prototype.intersectsCoordinate=M.prototype.sb;M.prototype.getExtent=M.prototype.D;M.prototype.simplify=M.prototype.Pb;M.prototype.transform=M.prototype.tb;M.prototype.get=M.prototype.get;M.prototype.getKeys=M.prototype.O;M.prototype.getProperties=M.prototype.N;M.prototype.set=M.prototype.set;M.prototype.setProperties=M.prototype.H;M.prototype.unset=M.prototype.P;M.prototype.changed=M.prototype.s;M.prototype.dispatchEvent=M.prototype.b;M.prototype.getRevision=M.prototype.L;M.prototype.on=M.prototype.J;
	M.prototype.once=M.prototype.once;M.prototype.un=M.prototype.K;N.prototype.getFirstCoordinate=N.prototype.bc;N.prototype.getLastCoordinate=N.prototype.cc;N.prototype.getLayout=N.prototype.dc;N.prototype.rotate=N.prototype.rotate;N.prototype.scale=N.prototype.scale;N.prototype.getClosestPoint=N.prototype.Ab;N.prototype.intersectsCoordinate=N.prototype.sb;N.prototype.getExtent=N.prototype.D;N.prototype.simplify=N.prototype.Pb;N.prototype.transform=N.prototype.tb;N.prototype.get=N.prototype.get;
	N.prototype.getKeys=N.prototype.O;N.prototype.getProperties=N.prototype.N;N.prototype.set=N.prototype.set;N.prototype.setProperties=N.prototype.H;N.prototype.unset=N.prototype.P;N.prototype.changed=N.prototype.s;N.prototype.dispatchEvent=N.prototype.b;N.prototype.getRevision=N.prototype.L;N.prototype.on=N.prototype.J;N.prototype.once=N.prototype.once;N.prototype.un=N.prototype.K;O.prototype.getFirstCoordinate=O.prototype.bc;O.prototype.getLastCoordinate=O.prototype.cc;O.prototype.getLayout=O.prototype.dc;
	O.prototype.rotate=O.prototype.rotate;O.prototype.scale=O.prototype.scale;O.prototype.getClosestPoint=O.prototype.Ab;O.prototype.intersectsCoordinate=O.prototype.sb;O.prototype.getExtent=O.prototype.D;O.prototype.simplify=O.prototype.Pb;O.prototype.transform=O.prototype.tb;O.prototype.get=O.prototype.get;O.prototype.getKeys=O.prototype.O;O.prototype.getProperties=O.prototype.N;O.prototype.set=O.prototype.set;O.prototype.setProperties=O.prototype.H;O.prototype.unset=O.prototype.P;
	O.prototype.changed=O.prototype.s;O.prototype.dispatchEvent=O.prototype.b;O.prototype.getRevision=O.prototype.L;O.prototype.on=O.prototype.J;O.prototype.once=O.prototype.once;O.prototype.un=O.prototype.K;P.prototype.getFirstCoordinate=P.prototype.bc;P.prototype.getLastCoordinate=P.prototype.cc;P.prototype.getLayout=P.prototype.dc;P.prototype.rotate=P.prototype.rotate;P.prototype.scale=P.prototype.scale;P.prototype.getClosestPoint=P.prototype.Ab;P.prototype.intersectsCoordinate=P.prototype.sb;
	P.prototype.getExtent=P.prototype.D;P.prototype.simplify=P.prototype.Pb;P.prototype.transform=P.prototype.tb;P.prototype.get=P.prototype.get;P.prototype.getKeys=P.prototype.O;P.prototype.getProperties=P.prototype.N;P.prototype.set=P.prototype.set;P.prototype.setProperties=P.prototype.H;P.prototype.unset=P.prototype.P;P.prototype.changed=P.prototype.s;P.prototype.dispatchEvent=P.prototype.b;P.prototype.getRevision=P.prototype.L;P.prototype.on=P.prototype.J;P.prototype.once=P.prototype.once;
	P.prototype.un=P.prototype.K;E.prototype.getFirstCoordinate=E.prototype.bc;E.prototype.getLastCoordinate=E.prototype.cc;E.prototype.getLayout=E.prototype.dc;E.prototype.rotate=E.prototype.rotate;E.prototype.scale=E.prototype.scale;E.prototype.getClosestPoint=E.prototype.Ab;E.prototype.intersectsCoordinate=E.prototype.sb;E.prototype.getExtent=E.prototype.D;E.prototype.simplify=E.prototype.Pb;E.prototype.transform=E.prototype.tb;E.prototype.get=E.prototype.get;E.prototype.getKeys=E.prototype.O;
	E.prototype.getProperties=E.prototype.N;E.prototype.set=E.prototype.set;E.prototype.setProperties=E.prototype.H;E.prototype.unset=E.prototype.P;E.prototype.changed=E.prototype.s;E.prototype.dispatchEvent=E.prototype.b;E.prototype.getRevision=E.prototype.L;E.prototype.on=E.prototype.J;E.prototype.once=E.prototype.once;E.prototype.un=E.prototype.K;F.prototype.getFirstCoordinate=F.prototype.bc;F.prototype.getLastCoordinate=F.prototype.cc;F.prototype.getLayout=F.prototype.dc;F.prototype.rotate=F.prototype.rotate;
	F.prototype.scale=F.prototype.scale;F.prototype.getClosestPoint=F.prototype.Ab;F.prototype.intersectsCoordinate=F.prototype.sb;F.prototype.getExtent=F.prototype.D;F.prototype.simplify=F.prototype.Pb;F.prototype.transform=F.prototype.tb;F.prototype.get=F.prototype.get;F.prototype.getKeys=F.prototype.O;F.prototype.getProperties=F.prototype.N;F.prototype.set=F.prototype.set;F.prototype.setProperties=F.prototype.H;F.prototype.unset=F.prototype.P;F.prototype.changed=F.prototype.s;
	F.prototype.dispatchEvent=F.prototype.b;F.prototype.getRevision=F.prototype.L;F.prototype.on=F.prototype.J;F.prototype.once=F.prototype.once;F.prototype.un=F.prototype.K;Pm.prototype.readFeatures=Pm.prototype.Qa;Ym.prototype.readFeatures=Ym.prototype.Qa;Pm.prototype.readFeatures=Pm.prototype.Qa;ad.prototype.get=ad.prototype.get;ad.prototype.getKeys=ad.prototype.O;ad.prototype.getProperties=ad.prototype.N;ad.prototype.set=ad.prototype.set;ad.prototype.setProperties=ad.prototype.H;
	ad.prototype.unset=ad.prototype.P;ad.prototype.changed=ad.prototype.s;ad.prototype.dispatchEvent=ad.prototype.b;ad.prototype.getRevision=ad.prototype.L;ad.prototype.on=ad.prototype.J;ad.prototype.once=ad.prototype.once;ad.prototype.un=ad.prototype.K;bd.prototype.getMap=bd.prototype.g;bd.prototype.setMap=bd.prototype.setMap;bd.prototype.setTarget=bd.prototype.i;bd.prototype.get=bd.prototype.get;bd.prototype.getKeys=bd.prototype.O;bd.prototype.getProperties=bd.prototype.N;bd.prototype.set=bd.prototype.set;
	bd.prototype.setProperties=bd.prototype.H;bd.prototype.unset=bd.prototype.P;bd.prototype.changed=bd.prototype.s;bd.prototype.dispatchEvent=bd.prototype.b;bd.prototype.getRevision=bd.prototype.L;bd.prototype.on=bd.prototype.J;bd.prototype.once=bd.prototype.once;bd.prototype.un=bd.prototype.K;od.prototype.getMap=od.prototype.g;od.prototype.setMap=od.prototype.setMap;od.prototype.setTarget=od.prototype.i;od.prototype.get=od.prototype.get;od.prototype.getKeys=od.prototype.O;
	od.prototype.getProperties=od.prototype.N;od.prototype.set=od.prototype.set;od.prototype.setProperties=od.prototype.H;od.prototype.unset=od.prototype.P;od.prototype.changed=od.prototype.s;od.prototype.dispatchEvent=od.prototype.b;od.prototype.getRevision=od.prototype.L;od.prototype.on=od.prototype.J;od.prototype.once=od.prototype.once;od.prototype.un=od.prototype.K;td.prototype.getMap=td.prototype.g;td.prototype.setMap=td.prototype.setMap;td.prototype.setTarget=td.prototype.i;td.prototype.get=td.prototype.get;
	td.prototype.getKeys=td.prototype.O;td.prototype.getProperties=td.prototype.N;td.prototype.set=td.prototype.set;td.prototype.setProperties=td.prototype.H;td.prototype.unset=td.prototype.P;td.prototype.changed=td.prototype.s;td.prototype.dispatchEvent=td.prototype.b;td.prototype.getRevision=td.prototype.L;td.prototype.on=td.prototype.J;td.prototype.once=td.prototype.once;td.prototype.un=td.prototype.K;zk.prototype.getMap=zk.prototype.g;zk.prototype.setMap=zk.prototype.setMap;
	zk.prototype.setTarget=zk.prototype.i;zk.prototype.get=zk.prototype.get;zk.prototype.getKeys=zk.prototype.O;zk.prototype.getProperties=zk.prototype.N;zk.prototype.set=zk.prototype.set;zk.prototype.setProperties=zk.prototype.H;zk.prototype.unset=zk.prototype.P;zk.prototype.changed=zk.prototype.s;zk.prototype.dispatchEvent=zk.prototype.b;zk.prototype.getRevision=zk.prototype.L;zk.prototype.on=zk.prototype.J;zk.prototype.once=zk.prototype.once;zk.prototype.un=zk.prototype.K;id.prototype.getMap=id.prototype.g;
	id.prototype.setMap=id.prototype.setMap;id.prototype.setTarget=id.prototype.i;id.prototype.get=id.prototype.get;id.prototype.getKeys=id.prototype.O;id.prototype.getProperties=id.prototype.N;id.prototype.set=id.prototype.set;id.prototype.setProperties=id.prototype.H;id.prototype.unset=id.prototype.P;id.prototype.changed=id.prototype.s;id.prototype.dispatchEvent=id.prototype.b;id.prototype.getRevision=id.prototype.L;id.prototype.on=id.prototype.J;id.prototype.once=id.prototype.once;
	id.prototype.un=id.prototype.K;Ek.prototype.getMap=Ek.prototype.g;Ek.prototype.setMap=Ek.prototype.setMap;Ek.prototype.setTarget=Ek.prototype.i;Ek.prototype.get=Ek.prototype.get;Ek.prototype.getKeys=Ek.prototype.O;Ek.prototype.getProperties=Ek.prototype.N;Ek.prototype.set=Ek.prototype.set;Ek.prototype.setProperties=Ek.prototype.H;Ek.prototype.unset=Ek.prototype.P;Ek.prototype.changed=Ek.prototype.s;Ek.prototype.dispatchEvent=Ek.prototype.b;Ek.prototype.getRevision=Ek.prototype.L;Ek.prototype.on=Ek.prototype.J;
	Ek.prototype.once=Ek.prototype.once;Ek.prototype.un=Ek.prototype.K;kd.prototype.getMap=kd.prototype.g;kd.prototype.setMap=kd.prototype.setMap;kd.prototype.setTarget=kd.prototype.i;kd.prototype.get=kd.prototype.get;kd.prototype.getKeys=kd.prototype.O;kd.prototype.getProperties=kd.prototype.N;kd.prototype.set=kd.prototype.set;kd.prototype.setProperties=kd.prototype.H;kd.prototype.unset=kd.prototype.P;kd.prototype.changed=kd.prototype.s;kd.prototype.dispatchEvent=kd.prototype.b;
	kd.prototype.getRevision=kd.prototype.L;kd.prototype.on=kd.prototype.J;kd.prototype.once=kd.prototype.once;kd.prototype.un=kd.prototype.K;Jk.prototype.getMap=Jk.prototype.g;Jk.prototype.setMap=Jk.prototype.setMap;Jk.prototype.setTarget=Jk.prototype.i;Jk.prototype.get=Jk.prototype.get;Jk.prototype.getKeys=Jk.prototype.O;Jk.prototype.getProperties=Jk.prototype.N;Jk.prototype.set=Jk.prototype.set;Jk.prototype.setProperties=Jk.prototype.H;Jk.prototype.unset=Jk.prototype.P;Jk.prototype.changed=Jk.prototype.s;
	Jk.prototype.dispatchEvent=Jk.prototype.b;Jk.prototype.getRevision=Jk.prototype.L;Jk.prototype.on=Jk.prototype.J;Jk.prototype.once=Jk.prototype.once;Jk.prototype.un=Jk.prototype.K;Ok.prototype.getMap=Ok.prototype.g;Ok.prototype.setMap=Ok.prototype.setMap;Ok.prototype.setTarget=Ok.prototype.i;Ok.prototype.get=Ok.prototype.get;Ok.prototype.getKeys=Ok.prototype.O;Ok.prototype.getProperties=Ok.prototype.N;Ok.prototype.set=Ok.prototype.set;Ok.prototype.setProperties=Ok.prototype.H;Ok.prototype.unset=Ok.prototype.P;
	Ok.prototype.changed=Ok.prototype.s;Ok.prototype.dispatchEvent=Ok.prototype.b;Ok.prototype.getRevision=Ok.prototype.L;Ok.prototype.on=Ok.prototype.J;Ok.prototype.once=Ok.prototype.once;Ok.prototype.un=Ok.prototype.K;
	  return OPENLAYERS.ol;
	}));
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37),
	    _assign = __webpack_require__(32);
	
	var CallbackQueue = __webpack_require__(957);
	var PooledClass = __webpack_require__(178);
	var ReactFeatureFlags = __webpack_require__(962);
	var ReactReconciler = __webpack_require__(214);
	var Transaction = __webpack_require__(363);
	
	var invariant = __webpack_require__(28);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 112 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var checkAuth = function checkAuth(response) {
		switch (response.status) {
			case 200:
				return response;
			case 403:
				throw new Error('Not Authorized');
			case 500:
				throw new Error('Unable to contact service');
			default:
				throw new Error('Not Authorized');
		}
	};
	
	var getJson = function getJson(response) {
		return response.json();
	};
	
	var checkStatus = function checkStatus(obj, response) {
		var code = Object.keys(obj).find(function (element) {
			return response.status + '' === element + '';
		});
		if (!code) {
			throw new Error('Unhandled Error during fetch' + response.status);
		}
		return obj[code](response);
	};
	
	var getBody = function getBody(login, parameter) {
		return JSON.stringify({
			role: 'ROLE_ADMIN_' + login,
			typeparameter: parameter
		});
	};
	
	exports.checkAuth = checkAuth;
	exports.getJson = getJson;
	exports.checkStatus = checkStatus;
	exports.getBody = getBody;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	var Eventful = __webpack_require__(189);
	
	exports.Dispatcher = Eventful;
	
	var env = __webpack_require__(55);
	
	var _dom = __webpack_require__(1085);
	
	var isCanvasEl = _dom.isCanvasEl;
	var transformCoordWithViewport = _dom.transformCoordWithViewport;
	
	/**
	 * Utilities for mouse or touch events.
	 */
	var isDomLevel2 = typeof window !== 'undefined' && !!window.addEventListener;
	var MOUSE_EVENT_REG = /^(?:mouse|pointer|contextmenu|drag|drop)|click/;
	var _calcOut = [];
	/**
	 * Get the `zrX` and `zrY`, which are relative to the top-left of
	 * the input `el`.
	 * CSS transform (2D & 3D) is supported.
	 *
	 * The strategy to fetch the coords:
	 * + If `calculate` is not set as `true`, users of this method should
	 * ensure that `el` is the same or the same size & location as `e.target`.
	 * Otherwise the result coords are probably not expected. Because we
	 * firstly try to get coords from e.offsetX/e.offsetY.
	 * + If `calculate` is set as `true`, the input `el` can be any element
	 * and we force to calculate the coords based on `el`.
	 * + The input `el` should be positionable (not position:static).
	 *
	 * The force `calculate` can be used in case like:
	 * When mousemove event triggered on ec tooltip, `e.target` is not `el`(zr painter.dom).
	 *
	 * @param {HTMLElement} el DOM element.
	 * @param {Event} e Mouse event or touch event.
	 * @param {Object} out Get `out.zrX` and `out.zrY` as the result.
	 * @param {boolean} [calculate=false] Whether to force calculate
	 *        the coordinates but not use ones provided by browser.
	 */
	
	function clientToLocal(el, e, out, calculate) {
	  out = out || {}; // According to the W3C Working Draft, offsetX and offsetY should be relative
	  // to the padding edge of the target element. The only browser using this convention
	  // is IE. Webkit uses the border edge, Opera uses the content edge, and FireFox does
	  // not support the properties.
	  // (see http://www.jacklmoore.com/notes/mouse-position/)
	  // In zr painter.dom, padding edge equals to border edge.
	
	  if (calculate || !env.canvasSupported) {
	    calculateZrXY(el, e, out);
	  } // Caution: In FireFox, layerX/layerY Mouse position relative to the closest positioned
	  // ancestor element, so we should make sure el is positioned (e.g., not position:static).
	  // BTW1, Webkit don't return the same results as FF in non-simple cases (like add
	  // zoom-factor, overflow / opacity layers, transforms ...)
	  // BTW2, (ev.offsetY || ev.pageY - $(ev.target).offset().top) is not correct in preserve-3d.
	  // <https://bugs.jquery.com/ticket/8523#comment:14>
	  // BTW3, In ff, offsetX/offsetY is always 0.
	  else if (env.browser.firefox && e.layerX != null && e.layerX !== e.offsetX) {
	      out.zrX = e.layerX;
	      out.zrY = e.layerY;
	    } // For IE6+, chrome, safari, opera. (When will ff support offsetX?)
	    else if (e.offsetX != null) {
	        out.zrX = e.offsetX;
	        out.zrY = e.offsetY;
	      } // For some other device, e.g., IOS safari.
	      else {
	          calculateZrXY(el, e, out);
	        }
	
	  return out;
	}
	
	function calculateZrXY(el, e, out) {
	  // BlackBerry 5, iOS 3 (original iPhone) don't have getBoundingRect.
	  if (env.domSupported && el.getBoundingClientRect) {
	    var ex = e.clientX;
	    var ey = e.clientY;
	
	    if (isCanvasEl(el)) {
	      // Original approach, which do not support CSS transform.
	      // marker can not be locationed in a canvas container
	      // (getBoundingClientRect is always 0). We do not support
	      // that input a pre-created canvas to zr while using css
	      // transform in iOS.
	      var box = el.getBoundingClientRect();
	      out.zrX = ex - box.left;
	      out.zrY = ey - box.top;
	      return;
	    } else {
	      if (transformCoordWithViewport(_calcOut, el, ex, ey)) {
	        out.zrX = _calcOut[0];
	        out.zrY = _calcOut[1];
	        return;
	      }
	    }
	  }
	
	  out.zrX = out.zrY = 0;
	}
	/**
	 * Find native event compat for legency IE.
	 * Should be called at the begining of a native event listener.
	 *
	 * @param {Event} [e] Mouse event or touch event or pointer event.
	 *        For lagency IE, we use `window.event` is used.
	 * @return {Event} The native event.
	 */
	
	
	function getNativeEvent(e) {
	  return e || window.event;
	}
	/**
	 * Normalize the coordinates of the input event.
	 *
	 * Get the `e.zrX` and `e.zrY`, which are relative to the top-left of
	 * the input `el`.
	 * Get `e.zrDelta` if using mouse wheel.
	 * Get `e.which`, see the comment inside this function.
	 *
	 * Do not calculate repeatly if `zrX` and `zrY` already exist.
	 *
	 * Notice: see comments in `clientToLocal`. check the relationship
	 * between the result coords and the parameters `el` and `calculate`.
	 *
	 * @param {HTMLElement} el DOM element.
	 * @param {Event} [e] See `getNativeEvent`.
	 * @param {boolean} [calculate=false] Whether to force calculate
	 *        the coordinates but not use ones provided by browser.
	 * @return {UIEvent} The normalized native UIEvent.
	 */
	
	
	function normalizeEvent(el, e, calculate) {
	  e = getNativeEvent(e);
	
	  if (e.zrX != null) {
	    return e;
	  }
	
	  var eventType = e.type;
	  var isTouch = eventType && eventType.indexOf('touch') >= 0;
	
	  if (!isTouch) {
	    clientToLocal(el, e, e, calculate);
	    e.zrDelta = e.wheelDelta ? e.wheelDelta / 120 : -(e.detail || 0) / 3;
	  } else {
	    var touch = eventType !== 'touchend' ? e.targetTouches[0] : e.changedTouches[0];
	    touch && clientToLocal(el, touch, e, calculate);
	  } // Add which for click: 1 === left; 2 === middle; 3 === right; otherwise: 0;
	  // See jQuery: https://github.com/jquery/jquery/blob/master/src/event.js
	  // If e.which has been defined, it may be readonly,
	  // see: https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/which
	
	
	  var button = e.button;
	
	  if (e.which == null && button !== undefined && MOUSE_EVENT_REG.test(e.type)) {
	    e.which = button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
	  } // [Caution]: `e.which` from browser is not always reliable. For example,
	  // when press left button and `mousemove (pointermove)` in Edge, the `e.which`
	  // is 65536 and the `e.button` is -1. But the `mouseup (pointerup)` and
	  // `mousedown (pointerdown)` is the same as Chrome does.
	
	
	  return e;
	}
	/**
	 * @param {HTMLElement} el
	 * @param {string} name
	 * @param {Function} handler
	 * @param {Object|boolean} opt If boolean, means `opt.capture`
	 * @param {boolean} [opt.capture=false]
	 * @param {boolean} [opt.passive=false]
	 */
	
	
	function addEventListener(el, name, handler, opt) {
	  if (isDomLevel2) {
	    // Reproduct the console warning:
	    // [Violation] Added non-passive event listener to a scroll-blocking <some> event.
	    // Consider marking event handler as 'passive' to make the page more responsive.
	    // Just set console log level: verbose in chrome dev tool.
	    // then the warning log will be printed when addEventListener called.
	    // See https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
	    // We have not yet found a neat way to using passive. Because in zrender the dom event
	    // listener delegate all of the upper events of element. Some of those events need
	    // to prevent default. For example, the feature `preventDefaultMouseMove` of echarts.
	    // Before passive can be adopted, these issues should be considered:
	    // (1) Whether and how a zrender user specifies an event listener passive. And by default,
	    // passive or not.
	    // (2) How to tread that some zrender event listener is passive, and some is not. If
	    // we use other way but not preventDefault of mousewheel and touchmove, browser
	    // compatibility should be handled.
	    // var opts = (env.passiveSupported && name === 'mousewheel')
	    //     ? {passive: true}
	    //     // By default, the third param of el.addEventListener is `capture: false`.
	    //     : void 0;
	    // el.addEventListener(name, handler /* , opts */);
	    el.addEventListener(name, handler, opt);
	  } else {
	    // For simplicity, do not implement `setCapture` for IE9-.
	    el.attachEvent('on' + name, handler);
	  }
	}
	/**
	 * Parameter are the same as `addEventListener`.
	 *
	 * Notice that if a listener is registered twice, one with capture and one without,
	 * remove each one separately. Removal of a capturing listener does not affect a
	 * non-capturing version of the same listener, and vice versa.
	 */
	
	
	function removeEventListener(el, name, handler, opt) {
	  if (isDomLevel2) {
	    el.removeEventListener(name, handler, opt);
	  } else {
	    el.detachEvent('on' + name, handler);
	  }
	}
	/**
	 * preventDefault and stopPropagation.
	 * Notice: do not use this method in zrender. It can only be
	 * used by upper applications if necessary.
	 *
	 * @param {Event} e A mouse or touch event.
	 */
	
	
	var stop = isDomLevel2 ? function (e) {
	  e.preventDefault();
	  e.stopPropagation();
	  e.cancelBubble = true;
	} : function (e) {
	  e.returnValue = false;
	  e.cancelBubble = true;
	};
	/**
	 * This method only works for mouseup and mousedown. The functionality is restricted
	 * for fault tolerance, See the `e.which` compatibility above.
	 *
	 * @param {MouseEvent} e
	 * @return {boolean}
	 */
	
	function isMiddleOrRightButtonOnMouseUpDown(e) {
	  return e.which === 2 || e.which === 3;
	}
	/**
	 * To be removed.
	 * @deprecated
	 */
	
	
	function notLeftMouse(e) {
	  // If e.which is undefined, considered as left mouse event.
	  return e.which > 1;
	} // For backward compatibility
	
	
	exports.clientToLocal = clientToLocal;
	exports.getNativeEvent = getNativeEvent;
	exports.normalizeEvent = normalizeEvent;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.stop = stop;
	exports.isMiddleOrRightButtonOnMouseUpDown = isMiddleOrRightButtonOnMouseUpDown;
	exports.notLeftMouse = notLeftMouse;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	var LRU = __webpack_require__(1084);
	
	var kCSSColorTable = {
	  'transparent': [0, 0, 0, 0],
	  'aliceblue': [240, 248, 255, 1],
	  'antiquewhite': [250, 235, 215, 1],
	  'aqua': [0, 255, 255, 1],
	  'aquamarine': [127, 255, 212, 1],
	  'azure': [240, 255, 255, 1],
	  'beige': [245, 245, 220, 1],
	  'bisque': [255, 228, 196, 1],
	  'black': [0, 0, 0, 1],
	  'blanchedalmond': [255, 235, 205, 1],
	  'blue': [0, 0, 255, 1],
	  'blueviolet': [138, 43, 226, 1],
	  'brown': [165, 42, 42, 1],
	  'burlywood': [222, 184, 135, 1],
	  'cadetblue': [95, 158, 160, 1],
	  'chartreuse': [127, 255, 0, 1],
	  'chocolate': [210, 105, 30, 1],
	  'coral': [255, 127, 80, 1],
	  'cornflowerblue': [100, 149, 237, 1],
	  'cornsilk': [255, 248, 220, 1],
	  'crimson': [220, 20, 60, 1],
	  'cyan': [0, 255, 255, 1],
	  'darkblue': [0, 0, 139, 1],
	  'darkcyan': [0, 139, 139, 1],
	  'darkgoldenrod': [184, 134, 11, 1],
	  'darkgray': [169, 169, 169, 1],
	  'darkgreen': [0, 100, 0, 1],
	  'darkgrey': [169, 169, 169, 1],
	  'darkkhaki': [189, 183, 107, 1],
	  'darkmagenta': [139, 0, 139, 1],
	  'darkolivegreen': [85, 107, 47, 1],
	  'darkorange': [255, 140, 0, 1],
	  'darkorchid': [153, 50, 204, 1],
	  'darkred': [139, 0, 0, 1],
	  'darksalmon': [233, 150, 122, 1],
	  'darkseagreen': [143, 188, 143, 1],
	  'darkslateblue': [72, 61, 139, 1],
	  'darkslategray': [47, 79, 79, 1],
	  'darkslategrey': [47, 79, 79, 1],
	  'darkturquoise': [0, 206, 209, 1],
	  'darkviolet': [148, 0, 211, 1],
	  'deeppink': [255, 20, 147, 1],
	  'deepskyblue': [0, 191, 255, 1],
	  'dimgray': [105, 105, 105, 1],
	  'dimgrey': [105, 105, 105, 1],
	  'dodgerblue': [30, 144, 255, 1],
	  'firebrick': [178, 34, 34, 1],
	  'floralwhite': [255, 250, 240, 1],
	  'forestgreen': [34, 139, 34, 1],
	  'fuchsia': [255, 0, 255, 1],
	  'gainsboro': [220, 220, 220, 1],
	  'ghostwhite': [248, 248, 255, 1],
	  'gold': [255, 215, 0, 1],
	  'goldenrod': [218, 165, 32, 1],
	  'gray': [128, 128, 128, 1],
	  'green': [0, 128, 0, 1],
	  'greenyellow': [173, 255, 47, 1],
	  'grey': [128, 128, 128, 1],
	  'honeydew': [240, 255, 240, 1],
	  'hotpink': [255, 105, 180, 1],
	  'indianred': [205, 92, 92, 1],
	  'indigo': [75, 0, 130, 1],
	  'ivory': [255, 255, 240, 1],
	  'khaki': [240, 230, 140, 1],
	  'lavender': [230, 230, 250, 1],
	  'lavenderblush': [255, 240, 245, 1],
	  'lawngreen': [124, 252, 0, 1],
	  'lemonchiffon': [255, 250, 205, 1],
	  'lightblue': [173, 216, 230, 1],
	  'lightcoral': [240, 128, 128, 1],
	  'lightcyan': [224, 255, 255, 1],
	  'lightgoldenrodyellow': [250, 250, 210, 1],
	  'lightgray': [211, 211, 211, 1],
	  'lightgreen': [144, 238, 144, 1],
	  'lightgrey': [211, 211, 211, 1],
	  'lightpink': [255, 182, 193, 1],
	  'lightsalmon': [255, 160, 122, 1],
	  'lightseagreen': [32, 178, 170, 1],
	  'lightskyblue': [135, 206, 250, 1],
	  'lightslategray': [119, 136, 153, 1],
	  'lightslategrey': [119, 136, 153, 1],
	  'lightsteelblue': [176, 196, 222, 1],
	  'lightyellow': [255, 255, 224, 1],
	  'lime': [0, 255, 0, 1],
	  'limegreen': [50, 205, 50, 1],
	  'linen': [250, 240, 230, 1],
	  'magenta': [255, 0, 255, 1],
	  'maroon': [128, 0, 0, 1],
	  'mediumaquamarine': [102, 205, 170, 1],
	  'mediumblue': [0, 0, 205, 1],
	  'mediumorchid': [186, 85, 211, 1],
	  'mediumpurple': [147, 112, 219, 1],
	  'mediumseagreen': [60, 179, 113, 1],
	  'mediumslateblue': [123, 104, 238, 1],
	  'mediumspringgreen': [0, 250, 154, 1],
	  'mediumturquoise': [72, 209, 204, 1],
	  'mediumvioletred': [199, 21, 133, 1],
	  'midnightblue': [25, 25, 112, 1],
	  'mintcream': [245, 255, 250, 1],
	  'mistyrose': [255, 228, 225, 1],
	  'moccasin': [255, 228, 181, 1],
	  'navajowhite': [255, 222, 173, 1],
	  'navy': [0, 0, 128, 1],
	  'oldlace': [253, 245, 230, 1],
	  'olive': [128, 128, 0, 1],
	  'olivedrab': [107, 142, 35, 1],
	  'orange': [255, 165, 0, 1],
	  'orangered': [255, 69, 0, 1],
	  'orchid': [218, 112, 214, 1],
	  'palegoldenrod': [238, 232, 170, 1],
	  'palegreen': [152, 251, 152, 1],
	  'paleturquoise': [175, 238, 238, 1],
	  'palevioletred': [219, 112, 147, 1],
	  'papayawhip': [255, 239, 213, 1],
	  'peachpuff': [255, 218, 185, 1],
	  'peru': [205, 133, 63, 1],
	  'pink': [255, 192, 203, 1],
	  'plum': [221, 160, 221, 1],
	  'powderblue': [176, 224, 230, 1],
	  'purple': [128, 0, 128, 1],
	  'red': [255, 0, 0, 1],
	  'rosybrown': [188, 143, 143, 1],
	  'royalblue': [65, 105, 225, 1],
	  'saddlebrown': [139, 69, 19, 1],
	  'salmon': [250, 128, 114, 1],
	  'sandybrown': [244, 164, 96, 1],
	  'seagreen': [46, 139, 87, 1],
	  'seashell': [255, 245, 238, 1],
	  'sienna': [160, 82, 45, 1],
	  'silver': [192, 192, 192, 1],
	  'skyblue': [135, 206, 235, 1],
	  'slateblue': [106, 90, 205, 1],
	  'slategray': [112, 128, 144, 1],
	  'slategrey': [112, 128, 144, 1],
	  'snow': [255, 250, 250, 1],
	  'springgreen': [0, 255, 127, 1],
	  'steelblue': [70, 130, 180, 1],
	  'tan': [210, 180, 140, 1],
	  'teal': [0, 128, 128, 1],
	  'thistle': [216, 191, 216, 1],
	  'tomato': [255, 99, 71, 1],
	  'turquoise': [64, 224, 208, 1],
	  'violet': [238, 130, 238, 1],
	  'wheat': [245, 222, 179, 1],
	  'white': [255, 255, 255, 1],
	  'whitesmoke': [245, 245, 245, 1],
	  'yellow': [255, 255, 0, 1],
	  'yellowgreen': [154, 205, 50, 1]
	};
	
	function clampCssByte(i) {
	  // Clamp to integer 0 .. 255.
	  i = Math.round(i); // Seems to be what Chrome does (vs truncation).
	
	  return i < 0 ? 0 : i > 255 ? 255 : i;
	}
	
	function clampCssAngle(i) {
	  // Clamp to integer 0 .. 360.
	  i = Math.round(i); // Seems to be what Chrome does (vs truncation).
	
	  return i < 0 ? 0 : i > 360 ? 360 : i;
	}
	
	function clampCssFloat(f) {
	  // Clamp to float 0.0 .. 1.0.
	  return f < 0 ? 0 : f > 1 ? 1 : f;
	}
	
	function parseCssInt(str) {
	  // int or percentage.
	  if (str.length && str.charAt(str.length - 1) === '%') {
	    return clampCssByte(parseFloat(str) / 100 * 255);
	  }
	
	  return clampCssByte(parseInt(str, 10));
	}
	
	function parseCssFloat(str) {
	  // float or percentage.
	  if (str.length && str.charAt(str.length - 1) === '%') {
	    return clampCssFloat(parseFloat(str) / 100);
	  }
	
	  return clampCssFloat(parseFloat(str));
	}
	
	function cssHueToRgb(m1, m2, h) {
	  if (h < 0) {
	    h += 1;
	  } else if (h > 1) {
	    h -= 1;
	  }
	
	  if (h * 6 < 1) {
	    return m1 + (m2 - m1) * h * 6;
	  }
	
	  if (h * 2 < 1) {
	    return m2;
	  }
	
	  if (h * 3 < 2) {
	    return m1 + (m2 - m1) * (2 / 3 - h) * 6;
	  }
	
	  return m1;
	}
	
	function lerpNumber(a, b, p) {
	  return a + (b - a) * p;
	}
	
	function setRgba(out, r, g, b, a) {
	  out[0] = r;
	  out[1] = g;
	  out[2] = b;
	  out[3] = a;
	  return out;
	}
	
	function copyRgba(out, a) {
	  out[0] = a[0];
	  out[1] = a[1];
	  out[2] = a[2];
	  out[3] = a[3];
	  return out;
	}
	
	var colorCache = new LRU(20);
	var lastRemovedArr = null;
	
	function putToCache(colorStr, rgbaArr) {
	  // Reuse removed array
	  if (lastRemovedArr) {
	    copyRgba(lastRemovedArr, rgbaArr);
	  }
	
	  lastRemovedArr = colorCache.put(colorStr, lastRemovedArr || rgbaArr.slice());
	}
	/**
	 * @param {string} colorStr
	 * @param {Array.<number>} out
	 * @return {Array.<number>}
	 * @memberOf module:zrender/util/color
	 */
	
	
	function parse(colorStr, rgbaArr) {
	  if (!colorStr) {
	    return;
	  }
	
	  rgbaArr = rgbaArr || [];
	  var cached = colorCache.get(colorStr);
	
	  if (cached) {
	    return copyRgba(rgbaArr, cached);
	  } // colorStr may be not string
	
	
	  colorStr = colorStr + ''; // Remove all whitespace, not compliant, but should just be more accepting.
	
	  var str = colorStr.replace(/ /g, '').toLowerCase(); // Color keywords (and transparent) lookup.
	
	  if (str in kCSSColorTable) {
	    copyRgba(rgbaArr, kCSSColorTable[str]);
	    putToCache(colorStr, rgbaArr);
	    return rgbaArr;
	  } // #abc and #abc123 syntax.
	
	
	  if (str.charAt(0) === '#') {
	    if (str.length === 4) {
	      var iv = parseInt(str.substr(1), 16); // TODO(deanm): Stricter parsing.
	
	      if (!(iv >= 0 && iv <= 0xfff)) {
	        setRgba(rgbaArr, 0, 0, 0, 1);
	        return; // Covers NaN.
	      }
	
	      setRgba(rgbaArr, (iv & 0xf00) >> 4 | (iv & 0xf00) >> 8, iv & 0xf0 | (iv & 0xf0) >> 4, iv & 0xf | (iv & 0xf) << 4, 1);
	      putToCache(colorStr, rgbaArr);
	      return rgbaArr;
	    } else if (str.length === 7) {
	      var iv = parseInt(str.substr(1), 16); // TODO(deanm): Stricter parsing.
	
	      if (!(iv >= 0 && iv <= 0xffffff)) {
	        setRgba(rgbaArr, 0, 0, 0, 1);
	        return; // Covers NaN.
	      }
	
	      setRgba(rgbaArr, (iv & 0xff0000) >> 16, (iv & 0xff00) >> 8, iv & 0xff, 1);
	      putToCache(colorStr, rgbaArr);
	      return rgbaArr;
	    }
	
	    return;
	  }
	
	  var op = str.indexOf('(');
	  var ep = str.indexOf(')');
	
	  if (op !== -1 && ep + 1 === str.length) {
	    var fname = str.substr(0, op);
	    var params = str.substr(op + 1, ep - (op + 1)).split(',');
	    var alpha = 1; // To allow case fallthrough.
	
	    switch (fname) {
	      case 'rgba':
	        if (params.length !== 4) {
	          setRgba(rgbaArr, 0, 0, 0, 1);
	          return;
	        }
	
	        alpha = parseCssFloat(params.pop());
	      // jshint ignore:line
	      // Fall through.
	
	      case 'rgb':
	        if (params.length !== 3) {
	          setRgba(rgbaArr, 0, 0, 0, 1);
	          return;
	        }
	
	        setRgba(rgbaArr, parseCssInt(params[0]), parseCssInt(params[1]), parseCssInt(params[2]), alpha);
	        putToCache(colorStr, rgbaArr);
	        return rgbaArr;
	
	      case 'hsla':
	        if (params.length !== 4) {
	          setRgba(rgbaArr, 0, 0, 0, 1);
	          return;
	        }
	
	        params[3] = parseCssFloat(params[3]);
	        hsla2rgba(params, rgbaArr);
	        putToCache(colorStr, rgbaArr);
	        return rgbaArr;
	
	      case 'hsl':
	        if (params.length !== 3) {
	          setRgba(rgbaArr, 0, 0, 0, 1);
	          return;
	        }
	
	        hsla2rgba(params, rgbaArr);
	        putToCache(colorStr, rgbaArr);
	        return rgbaArr;
	
	      default:
	        return;
	    }
	  }
	
	  setRgba(rgbaArr, 0, 0, 0, 1);
	  return;
	}
	/**
	 * @param {Array.<number>} hsla
	 * @param {Array.<number>} rgba
	 * @return {Array.<number>} rgba
	 */
	
	
	function hsla2rgba(hsla, rgba) {
	  var h = (parseFloat(hsla[0]) % 360 + 360) % 360 / 360; // 0 .. 1
	  // NOTE(deanm): According to the CSS spec s/l should only be
	  // percentages, but we don't bother and let float or percentage.
	
	  var s = parseCssFloat(hsla[1]);
	  var l = parseCssFloat(hsla[2]);
	  var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
	  var m1 = l * 2 - m2;
	  rgba = rgba || [];
	  setRgba(rgba, clampCssByte(cssHueToRgb(m1, m2, h + 1 / 3) * 255), clampCssByte(cssHueToRgb(m1, m2, h) * 255), clampCssByte(cssHueToRgb(m1, m2, h - 1 / 3) * 255), 1);
	
	  if (hsla.length === 4) {
	    rgba[3] = hsla[3];
	  }
	
	  return rgba;
	}
	/**
	 * @param {Array.<number>} rgba
	 * @return {Array.<number>} hsla
	 */
	
	
	function rgba2hsla(rgba) {
	  if (!rgba) {
	    return;
	  } // RGB from 0 to 255
	
	
	  var R = rgba[0] / 255;
	  var G = rgba[1] / 255;
	  var B = rgba[2] / 255;
	  var vMin = Math.min(R, G, B); // Min. value of RGB
	
	  var vMax = Math.max(R, G, B); // Max. value of RGB
	
	  var delta = vMax - vMin; // Delta RGB value
	
	  var L = (vMax + vMin) / 2;
	  var H;
	  var S; // HSL results from 0 to 1
	
	  if (delta === 0) {
	    H = 0;
	    S = 0;
	  } else {
	    if (L < 0.5) {
	      S = delta / (vMax + vMin);
	    } else {
	      S = delta / (2 - vMax - vMin);
	    }
	
	    var deltaR = ((vMax - R) / 6 + delta / 2) / delta;
	    var deltaG = ((vMax - G) / 6 + delta / 2) / delta;
	    var deltaB = ((vMax - B) / 6 + delta / 2) / delta;
	
	    if (R === vMax) {
	      H = deltaB - deltaG;
	    } else if (G === vMax) {
	      H = 1 / 3 + deltaR - deltaB;
	    } else if (B === vMax) {
	      H = 2 / 3 + deltaG - deltaR;
	    }
	
	    if (H < 0) {
	      H += 1;
	    }
	
	    if (H > 1) {
	      H -= 1;
	    }
	  }
	
	  var hsla = [H * 360, S, L];
	
	  if (rgba[3] != null) {
	    hsla.push(rgba[3]);
	  }
	
	  return hsla;
	}
	/**
	 * @param {string} color
	 * @param {number} level
	 * @return {string}
	 * @memberOf module:zrender/util/color
	 */
	
	
	function lift(color, level) {
	  var colorArr = parse(color);
	
	  if (colorArr) {
	    for (var i = 0; i < 3; i++) {
	      if (level < 0) {
	        colorArr[i] = colorArr[i] * (1 - level) | 0;
	      } else {
	        colorArr[i] = (255 - colorArr[i]) * level + colorArr[i] | 0;
	      }
	
	      if (colorArr[i] > 255) {
	        colorArr[i] = 255;
	      } else if (color[i] < 0) {
	        colorArr[i] = 0;
	      }
	    }
	
	    return stringify(colorArr, colorArr.length === 4 ? 'rgba' : 'rgb');
	  }
	}
	/**
	 * @param {string} color
	 * @return {string}
	 * @memberOf module:zrender/util/color
	 */
	
	
	function toHex(color) {
	  var colorArr = parse(color);
	
	  if (colorArr) {
	    return ((1 << 24) + (colorArr[0] << 16) + (colorArr[1] << 8) + +colorArr[2]).toString(16).slice(1);
	  }
	}
	/**
	 * Map value to color. Faster than lerp methods because color is represented by rgba array.
	 * @param {number} normalizedValue A float between 0 and 1.
	 * @param {Array.<Array.<number>>} colors List of rgba color array
	 * @param {Array.<number>} [out] Mapped gba color array
	 * @return {Array.<number>} will be null/undefined if input illegal.
	 */
	
	
	function fastLerp(normalizedValue, colors, out) {
	  if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) {
	    return;
	  }
	
	  out = out || [];
	  var value = normalizedValue * (colors.length - 1);
	  var leftIndex = Math.floor(value);
	  var rightIndex = Math.ceil(value);
	  var leftColor = colors[leftIndex];
	  var rightColor = colors[rightIndex];
	  var dv = value - leftIndex;
	  out[0] = clampCssByte(lerpNumber(leftColor[0], rightColor[0], dv));
	  out[1] = clampCssByte(lerpNumber(leftColor[1], rightColor[1], dv));
	  out[2] = clampCssByte(lerpNumber(leftColor[2], rightColor[2], dv));
	  out[3] = clampCssFloat(lerpNumber(leftColor[3], rightColor[3], dv));
	  return out;
	}
	/**
	 * @deprecated
	 */
	
	
	var fastMapToColor = fastLerp;
	/**
	 * @param {number} normalizedValue A float between 0 and 1.
	 * @param {Array.<string>} colors Color list.
	 * @param {boolean=} fullOutput Default false.
	 * @return {(string|Object)} Result color. If fullOutput,
	 *                           return {color: ..., leftIndex: ..., rightIndex: ..., value: ...},
	 * @memberOf module:zrender/util/color
	 */
	
	function lerp(normalizedValue, colors, fullOutput) {
	  if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) {
	    return;
	  }
	
	  var value = normalizedValue * (colors.length - 1);
	  var leftIndex = Math.floor(value);
	  var rightIndex = Math.ceil(value);
	  var leftColor = parse(colors[leftIndex]);
	  var rightColor = parse(colors[rightIndex]);
	  var dv = value - leftIndex;
	  var color = stringify([clampCssByte(lerpNumber(leftColor[0], rightColor[0], dv)), clampCssByte(lerpNumber(leftColor[1], rightColor[1], dv)), clampCssByte(lerpNumber(leftColor[2], rightColor[2], dv)), clampCssFloat(lerpNumber(leftColor[3], rightColor[3], dv))], 'rgba');
	  return fullOutput ? {
	    color: color,
	    leftIndex: leftIndex,
	    rightIndex: rightIndex,
	    value: value
	  } : color;
	}
	/**
	 * @deprecated
	 */
	
	
	var mapToColor = lerp;
	/**
	 * @param {string} color
	 * @param {number=} h 0 ~ 360, ignore when null.
	 * @param {number=} s 0 ~ 1, ignore when null.
	 * @param {number=} l 0 ~ 1, ignore when null.
	 * @return {string} Color string in rgba format.
	 * @memberOf module:zrender/util/color
	 */
	
	function modifyHSL(color, h, s, l) {
	  color = parse(color);
	
	  if (color) {
	    color = rgba2hsla(color);
	    h != null && (color[0] = clampCssAngle(h));
	    s != null && (color[1] = parseCssFloat(s));
	    l != null && (color[2] = parseCssFloat(l));
	    return stringify(hsla2rgba(color), 'rgba');
	  }
	}
	/**
	 * @param {string} color
	 * @param {number=} alpha 0 ~ 1
	 * @return {string} Color string in rgba format.
	 * @memberOf module:zrender/util/color
	 */
	
	
	function modifyAlpha(color, alpha) {
	  color = parse(color);
	
	  if (color && alpha != null) {
	    color[3] = clampCssFloat(alpha);
	    return stringify(color, 'rgba');
	  }
	}
	/**
	 * @param {Array.<number>} arrColor like [12,33,44,0.4]
	 * @param {string} type 'rgba', 'hsva', ...
	 * @return {string} Result color. (If input illegal, return undefined).
	 */
	
	
	function stringify(arrColor, type) {
	  if (!arrColor || !arrColor.length) {
	    return;
	  }
	
	  var colorStr = arrColor[0] + ',' + arrColor[1] + ',' + arrColor[2];
	
	  if (type === 'rgba' || type === 'hsva' || type === 'hsla') {
	    colorStr += ',' + arrColor[3];
	  }
	
	  return type + '(' + colorStr + ')';
	}
	
	exports.parse = parse;
	exports.lift = lift;
	exports.toHex = toHex;
	exports.fastLerp = fastLerp;
	exports.fastMapToColor = fastMapToColor;
	exports.lerp = lerp;
	exports.mapToColor = mapToColor;
	exports.modifyHSL = modifyHSL;
	exports.modifyAlpha = modifyAlpha;
	exports.stringify = stringify;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	var arrayWithoutHoles = __webpack_require__(1100);
	
	var iterableToArray = __webpack_require__(568);
	
	var unsupportedIterableToArray = __webpack_require__(392);
	
	var nonIterableSpread = __webpack_require__(1105);
	
	function _toConsumableArray(arr) {
	  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
	}
	
	module.exports = _toConsumableArray;

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	/** @license Material-UI v4.11.0
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  colors: true,
	  Accordion: true,
	  AccordionActions: true,
	  AccordionDetails: true,
	  AccordionSummary: true,
	  AppBar: true,
	  Avatar: true,
	  Backdrop: true,
	  Badge: true,
	  BottomNavigation: true,
	  BottomNavigationAction: true,
	  Box: true,
	  Breadcrumbs: true,
	  Button: true,
	  ButtonBase: true,
	  ButtonGroup: true,
	  Card: true,
	  CardActionArea: true,
	  CardActions: true,
	  CardContent: true,
	  CardHeader: true,
	  CardMedia: true,
	  Checkbox: true,
	  Chip: true,
	  CircularProgress: true,
	  ClickAwayListener: true,
	  Collapse: true,
	  Container: true,
	  CssBaseline: true,
	  Dialog: true,
	  DialogActions: true,
	  DialogContent: true,
	  DialogContentText: true,
	  DialogTitle: true,
	  Divider: true,
	  Drawer: true,
	  ExpansionPanel: true,
	  ExpansionPanelActions: true,
	  ExpansionPanelDetails: true,
	  ExpansionPanelSummary: true,
	  Fab: true,
	  Fade: true,
	  FilledInput: true,
	  FormControl: true,
	  FormControlLabel: true,
	  FormGroup: true,
	  FormHelperText: true,
	  FormLabel: true,
	  Grid: true,
	  GridList: true,
	  GridListTile: true,
	  GridListTileBar: true,
	  Grow: true,
	  Hidden: true,
	  Icon: true,
	  IconButton: true,
	  Input: true,
	  InputAdornment: true,
	  InputBase: true,
	  InputLabel: true,
	  LinearProgress: true,
	  Link: true,
	  List: true,
	  ListItem: true,
	  ListItemAvatar: true,
	  ListItemIcon: true,
	  ListItemSecondaryAction: true,
	  ListItemText: true,
	  ListSubheader: true,
	  Menu: true,
	  MenuItem: true,
	  MenuList: true,
	  MobileStepper: true,
	  Modal: true,
	  NativeSelect: true,
	  NoSsr: true,
	  OutlinedInput: true,
	  Paper: true,
	  Popover: true,
	  Popper: true,
	  Portal: true,
	  Radio: true,
	  RadioGroup: true,
	  RootRef: true,
	  Select: true,
	  Slide: true,
	  Slider: true,
	  Snackbar: true,
	  SnackbarContent: true,
	  Step: true,
	  StepButton: true,
	  StepConnector: true,
	  StepContent: true,
	  StepIcon: true,
	  StepLabel: true,
	  Stepper: true,
	  SvgIcon: true,
	  SwipeableDrawer: true,
	  Switch: true,
	  Tab: true,
	  Table: true,
	  TableBody: true,
	  TableCell: true,
	  TableContainer: true,
	  TableFooter: true,
	  TableHead: true,
	  TablePagination: true,
	  TableRow: true,
	  TableSortLabel: true,
	  Tabs: true,
	  TabScrollButton: true,
	  TextField: true,
	  TextareaAutosize: true,
	  Toolbar: true,
	  Tooltip: true,
	  Typography: true,
	  Unstable_TrapFocus: true,
	  useMediaQuery: true,
	  useScrollTrigger: true,
	  withMobileDialog: true,
	  withWidth: true,
	  Zoom: true
	};
	Object.defineProperty(exports, "Accordion", {
	  enumerable: true,
	  get: function get() {
	    return _Accordion.default;
	  }
	});
	Object.defineProperty(exports, "AccordionActions", {
	  enumerable: true,
	  get: function get() {
	    return _AccordionActions.default;
	  }
	});
	Object.defineProperty(exports, "AccordionDetails", {
	  enumerable: true,
	  get: function get() {
	    return _AccordionDetails.default;
	  }
	});
	Object.defineProperty(exports, "AccordionSummary", {
	  enumerable: true,
	  get: function get() {
	    return _AccordionSummary.default;
	  }
	});
	Object.defineProperty(exports, "AppBar", {
	  enumerable: true,
	  get: function get() {
	    return _AppBar.default;
	  }
	});
	Object.defineProperty(exports, "Avatar", {
	  enumerable: true,
	  get: function get() {
	    return _Avatar.default;
	  }
	});
	Object.defineProperty(exports, "Backdrop", {
	  enumerable: true,
	  get: function get() {
	    return _Backdrop.default;
	  }
	});
	Object.defineProperty(exports, "Badge", {
	  enumerable: true,
	  get: function get() {
	    return _Badge.default;
	  }
	});
	Object.defineProperty(exports, "BottomNavigation", {
	  enumerable: true,
	  get: function get() {
	    return _BottomNavigation.default;
	  }
	});
	Object.defineProperty(exports, "BottomNavigationAction", {
	  enumerable: true,
	  get: function get() {
	    return _BottomNavigationAction.default;
	  }
	});
	Object.defineProperty(exports, "Box", {
	  enumerable: true,
	  get: function get() {
	    return _Box.default;
	  }
	});
	Object.defineProperty(exports, "Breadcrumbs", {
	  enumerable: true,
	  get: function get() {
	    return _Breadcrumbs.default;
	  }
	});
	Object.defineProperty(exports, "Button", {
	  enumerable: true,
	  get: function get() {
	    return _Button.default;
	  }
	});
	Object.defineProperty(exports, "ButtonBase", {
	  enumerable: true,
	  get: function get() {
	    return _ButtonBase.default;
	  }
	});
	Object.defineProperty(exports, "ButtonGroup", {
	  enumerable: true,
	  get: function get() {
	    return _ButtonGroup.default;
	  }
	});
	Object.defineProperty(exports, "Card", {
	  enumerable: true,
	  get: function get() {
	    return _Card.default;
	  }
	});
	Object.defineProperty(exports, "CardActionArea", {
	  enumerable: true,
	  get: function get() {
	    return _CardActionArea.default;
	  }
	});
	Object.defineProperty(exports, "CardActions", {
	  enumerable: true,
	  get: function get() {
	    return _CardActions.default;
	  }
	});
	Object.defineProperty(exports, "CardContent", {
	  enumerable: true,
	  get: function get() {
	    return _CardContent.default;
	  }
	});
	Object.defineProperty(exports, "CardHeader", {
	  enumerable: true,
	  get: function get() {
	    return _CardHeader.default;
	  }
	});
	Object.defineProperty(exports, "CardMedia", {
	  enumerable: true,
	  get: function get() {
	    return _CardMedia.default;
	  }
	});
	Object.defineProperty(exports, "Checkbox", {
	  enumerable: true,
	  get: function get() {
	    return _Checkbox.default;
	  }
	});
	Object.defineProperty(exports, "Chip", {
	  enumerable: true,
	  get: function get() {
	    return _Chip.default;
	  }
	});
	Object.defineProperty(exports, "CircularProgress", {
	  enumerable: true,
	  get: function get() {
	    return _CircularProgress.default;
	  }
	});
	Object.defineProperty(exports, "ClickAwayListener", {
	  enumerable: true,
	  get: function get() {
	    return _ClickAwayListener.default;
	  }
	});
	Object.defineProperty(exports, "Collapse", {
	  enumerable: true,
	  get: function get() {
	    return _Collapse.default;
	  }
	});
	Object.defineProperty(exports, "Container", {
	  enumerable: true,
	  get: function get() {
	    return _Container.default;
	  }
	});
	Object.defineProperty(exports, "CssBaseline", {
	  enumerable: true,
	  get: function get() {
	    return _CssBaseline.default;
	  }
	});
	Object.defineProperty(exports, "Dialog", {
	  enumerable: true,
	  get: function get() {
	    return _Dialog.default;
	  }
	});
	Object.defineProperty(exports, "DialogActions", {
	  enumerable: true,
	  get: function get() {
	    return _DialogActions.default;
	  }
	});
	Object.defineProperty(exports, "DialogContent", {
	  enumerable: true,
	  get: function get() {
	    return _DialogContent.default;
	  }
	});
	Object.defineProperty(exports, "DialogContentText", {
	  enumerable: true,
	  get: function get() {
	    return _DialogContentText.default;
	  }
	});
	Object.defineProperty(exports, "DialogTitle", {
	  enumerable: true,
	  get: function get() {
	    return _DialogTitle.default;
	  }
	});
	Object.defineProperty(exports, "Divider", {
	  enumerable: true,
	  get: function get() {
	    return _Divider.default;
	  }
	});
	Object.defineProperty(exports, "Drawer", {
	  enumerable: true,
	  get: function get() {
	    return _Drawer.default;
	  }
	});
	Object.defineProperty(exports, "ExpansionPanel", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanel.default;
	  }
	});
	Object.defineProperty(exports, "ExpansionPanelActions", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelActions.default;
	  }
	});
	Object.defineProperty(exports, "ExpansionPanelDetails", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelDetails.default;
	  }
	});
	Object.defineProperty(exports, "ExpansionPanelSummary", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelSummary.default;
	  }
	});
	Object.defineProperty(exports, "Fab", {
	  enumerable: true,
	  get: function get() {
	    return _Fab.default;
	  }
	});
	Object.defineProperty(exports, "Fade", {
	  enumerable: true,
	  get: function get() {
	    return _Fade.default;
	  }
	});
	Object.defineProperty(exports, "FilledInput", {
	  enumerable: true,
	  get: function get() {
	    return _FilledInput.default;
	  }
	});
	Object.defineProperty(exports, "FormControl", {
	  enumerable: true,
	  get: function get() {
	    return _FormControl.default;
	  }
	});
	Object.defineProperty(exports, "FormControlLabel", {
	  enumerable: true,
	  get: function get() {
	    return _FormControlLabel.default;
	  }
	});
	Object.defineProperty(exports, "FormGroup", {
	  enumerable: true,
	  get: function get() {
	    return _FormGroup.default;
	  }
	});
	Object.defineProperty(exports, "FormHelperText", {
	  enumerable: true,
	  get: function get() {
	    return _FormHelperText.default;
	  }
	});
	Object.defineProperty(exports, "FormLabel", {
	  enumerable: true,
	  get: function get() {
	    return _FormLabel.default;
	  }
	});
	Object.defineProperty(exports, "Grid", {
	  enumerable: true,
	  get: function get() {
	    return _Grid.default;
	  }
	});
	Object.defineProperty(exports, "GridList", {
	  enumerable: true,
	  get: function get() {
	    return _GridList.default;
	  }
	});
	Object.defineProperty(exports, "GridListTile", {
	  enumerable: true,
	  get: function get() {
	    return _GridListTile.default;
	  }
	});
	Object.defineProperty(exports, "GridListTileBar", {
	  enumerable: true,
	  get: function get() {
	    return _GridListTileBar.default;
	  }
	});
	Object.defineProperty(exports, "Grow", {
	  enumerable: true,
	  get: function get() {
	    return _Grow.default;
	  }
	});
	Object.defineProperty(exports, "Hidden", {
	  enumerable: true,
	  get: function get() {
	    return _Hidden.default;
	  }
	});
	Object.defineProperty(exports, "Icon", {
	  enumerable: true,
	  get: function get() {
	    return _Icon.default;
	  }
	});
	Object.defineProperty(exports, "IconButton", {
	  enumerable: true,
	  get: function get() {
	    return _IconButton.default;
	  }
	});
	Object.defineProperty(exports, "Input", {
	  enumerable: true,
	  get: function get() {
	    return _Input.default;
	  }
	});
	Object.defineProperty(exports, "InputAdornment", {
	  enumerable: true,
	  get: function get() {
	    return _InputAdornment.default;
	  }
	});
	Object.defineProperty(exports, "InputBase", {
	  enumerable: true,
	  get: function get() {
	    return _InputBase.default;
	  }
	});
	Object.defineProperty(exports, "InputLabel", {
	  enumerable: true,
	  get: function get() {
	    return _InputLabel.default;
	  }
	});
	Object.defineProperty(exports, "LinearProgress", {
	  enumerable: true,
	  get: function get() {
	    return _LinearProgress.default;
	  }
	});
	Object.defineProperty(exports, "Link", {
	  enumerable: true,
	  get: function get() {
	    return _Link.default;
	  }
	});
	Object.defineProperty(exports, "List", {
	  enumerable: true,
	  get: function get() {
	    return _List.default;
	  }
	});
	Object.defineProperty(exports, "ListItem", {
	  enumerable: true,
	  get: function get() {
	    return _ListItem.default;
	  }
	});
	Object.defineProperty(exports, "ListItemAvatar", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemAvatar.default;
	  }
	});
	Object.defineProperty(exports, "ListItemIcon", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemIcon.default;
	  }
	});
	Object.defineProperty(exports, "ListItemSecondaryAction", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemSecondaryAction.default;
	  }
	});
	Object.defineProperty(exports, "ListItemText", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemText.default;
	  }
	});
	Object.defineProperty(exports, "ListSubheader", {
	  enumerable: true,
	  get: function get() {
	    return _ListSubheader.default;
	  }
	});
	Object.defineProperty(exports, "Menu", {
	  enumerable: true,
	  get: function get() {
	    return _Menu.default;
	  }
	});
	Object.defineProperty(exports, "MenuItem", {
	  enumerable: true,
	  get: function get() {
	    return _MenuItem.default;
	  }
	});
	Object.defineProperty(exports, "MenuList", {
	  enumerable: true,
	  get: function get() {
	    return _MenuList.default;
	  }
	});
	Object.defineProperty(exports, "MobileStepper", {
	  enumerable: true,
	  get: function get() {
	    return _MobileStepper.default;
	  }
	});
	Object.defineProperty(exports, "Modal", {
	  enumerable: true,
	  get: function get() {
	    return _Modal.default;
	  }
	});
	Object.defineProperty(exports, "NativeSelect", {
	  enumerable: true,
	  get: function get() {
	    return _NativeSelect.default;
	  }
	});
	Object.defineProperty(exports, "NoSsr", {
	  enumerable: true,
	  get: function get() {
	    return _NoSsr.default;
	  }
	});
	Object.defineProperty(exports, "OutlinedInput", {
	  enumerable: true,
	  get: function get() {
	    return _OutlinedInput.default;
	  }
	});
	Object.defineProperty(exports, "Paper", {
	  enumerable: true,
	  get: function get() {
	    return _Paper.default;
	  }
	});
	Object.defineProperty(exports, "Popover", {
	  enumerable: true,
	  get: function get() {
	    return _Popover.default;
	  }
	});
	Object.defineProperty(exports, "Popper", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.default;
	  }
	});
	Object.defineProperty(exports, "Portal", {
	  enumerable: true,
	  get: function get() {
	    return _Portal.default;
	  }
	});
	Object.defineProperty(exports, "Radio", {
	  enumerable: true,
	  get: function get() {
	    return _Radio.default;
	  }
	});
	Object.defineProperty(exports, "RadioGroup", {
	  enumerable: true,
	  get: function get() {
	    return _RadioGroup.default;
	  }
	});
	Object.defineProperty(exports, "RootRef", {
	  enumerable: true,
	  get: function get() {
	    return _RootRef.default;
	  }
	});
	Object.defineProperty(exports, "Select", {
	  enumerable: true,
	  get: function get() {
	    return _Select.default;
	  }
	});
	Object.defineProperty(exports, "Slide", {
	  enumerable: true,
	  get: function get() {
	    return _Slide.default;
	  }
	});
	Object.defineProperty(exports, "Slider", {
	  enumerable: true,
	  get: function get() {
	    return _Slider.default;
	  }
	});
	Object.defineProperty(exports, "Snackbar", {
	  enumerable: true,
	  get: function get() {
	    return _Snackbar.default;
	  }
	});
	Object.defineProperty(exports, "SnackbarContent", {
	  enumerable: true,
	  get: function get() {
	    return _SnackbarContent.default;
	  }
	});
	Object.defineProperty(exports, "Step", {
	  enumerable: true,
	  get: function get() {
	    return _Step.default;
	  }
	});
	Object.defineProperty(exports, "StepButton", {
	  enumerable: true,
	  get: function get() {
	    return _StepButton.default;
	  }
	});
	Object.defineProperty(exports, "StepConnector", {
	  enumerable: true,
	  get: function get() {
	    return _StepConnector.default;
	  }
	});
	Object.defineProperty(exports, "StepContent", {
	  enumerable: true,
	  get: function get() {
	    return _StepContent.default;
	  }
	});
	Object.defineProperty(exports, "StepIcon", {
	  enumerable: true,
	  get: function get() {
	    return _StepIcon.default;
	  }
	});
	Object.defineProperty(exports, "StepLabel", {
	  enumerable: true,
	  get: function get() {
	    return _StepLabel.default;
	  }
	});
	Object.defineProperty(exports, "Stepper", {
	  enumerable: true,
	  get: function get() {
	    return _Stepper.default;
	  }
	});
	Object.defineProperty(exports, "SvgIcon", {
	  enumerable: true,
	  get: function get() {
	    return _SvgIcon.default;
	  }
	});
	Object.defineProperty(exports, "SwipeableDrawer", {
	  enumerable: true,
	  get: function get() {
	    return _SwipeableDrawer.default;
	  }
	});
	Object.defineProperty(exports, "Switch", {
	  enumerable: true,
	  get: function get() {
	    return _Switch.default;
	  }
	});
	Object.defineProperty(exports, "Tab", {
	  enumerable: true,
	  get: function get() {
	    return _Tab.default;
	  }
	});
	Object.defineProperty(exports, "Table", {
	  enumerable: true,
	  get: function get() {
	    return _Table.default;
	  }
	});
	Object.defineProperty(exports, "TableBody", {
	  enumerable: true,
	  get: function get() {
	    return _TableBody.default;
	  }
	});
	Object.defineProperty(exports, "TableCell", {
	  enumerable: true,
	  get: function get() {
	    return _TableCell.default;
	  }
	});
	Object.defineProperty(exports, "TableContainer", {
	  enumerable: true,
	  get: function get() {
	    return _TableContainer.default;
	  }
	});
	Object.defineProperty(exports, "TableFooter", {
	  enumerable: true,
	  get: function get() {
	    return _TableFooter.default;
	  }
	});
	Object.defineProperty(exports, "TableHead", {
	  enumerable: true,
	  get: function get() {
	    return _TableHead.default;
	  }
	});
	Object.defineProperty(exports, "TablePagination", {
	  enumerable: true,
	  get: function get() {
	    return _TablePagination.default;
	  }
	});
	Object.defineProperty(exports, "TableRow", {
	  enumerable: true,
	  get: function get() {
	    return _TableRow.default;
	  }
	});
	Object.defineProperty(exports, "TableSortLabel", {
	  enumerable: true,
	  get: function get() {
	    return _TableSortLabel.default;
	  }
	});
	Object.defineProperty(exports, "Tabs", {
	  enumerable: true,
	  get: function get() {
	    return _Tabs.default;
	  }
	});
	Object.defineProperty(exports, "TabScrollButton", {
	  enumerable: true,
	  get: function get() {
	    return _TabScrollButton.default;
	  }
	});
	Object.defineProperty(exports, "TextField", {
	  enumerable: true,
	  get: function get() {
	    return _TextField.default;
	  }
	});
	Object.defineProperty(exports, "TextareaAutosize", {
	  enumerable: true,
	  get: function get() {
	    return _TextareaAutosize.default;
	  }
	});
	Object.defineProperty(exports, "Toolbar", {
	  enumerable: true,
	  get: function get() {
	    return _Toolbar.default;
	  }
	});
	Object.defineProperty(exports, "Tooltip", {
	  enumerable: true,
	  get: function get() {
	    return _Tooltip.default;
	  }
	});
	Object.defineProperty(exports, "Typography", {
	  enumerable: true,
	  get: function get() {
	    return _Typography.default;
	  }
	});
	Object.defineProperty(exports, "Unstable_TrapFocus", {
	  enumerable: true,
	  get: function get() {
	    return _Unstable_TrapFocus.default;
	  }
	});
	Object.defineProperty(exports, "useMediaQuery", {
	  enumerable: true,
	  get: function get() {
	    return _useMediaQuery.default;
	  }
	});
	Object.defineProperty(exports, "useScrollTrigger", {
	  enumerable: true,
	  get: function get() {
	    return _useScrollTrigger.default;
	  }
	});
	Object.defineProperty(exports, "withMobileDialog", {
	  enumerable: true,
	  get: function get() {
	    return _withMobileDialog.default;
	  }
	});
	Object.defineProperty(exports, "withWidth", {
	  enumerable: true,
	  get: function get() {
	    return _withWidth.default;
	  }
	});
	Object.defineProperty(exports, "Zoom", {
	  enumerable: true,
	  get: function get() {
	    return _Zoom.default;
	  }
	});
	exports.colors = void 0;
	
	var colors = _interopRequireWildcard(__webpack_require__(1293));
	
	exports.colors = colors;
	
	var _styles = __webpack_require__(1319);
	
	Object.keys(_styles).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _styles[key];
	    }
	  });
	});
	
	var _utils = __webpack_require__(627);
	
	Object.keys(_utils).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _utils[key];
	    }
	  });
	});
	
	var _Accordion = _interopRequireWildcard(__webpack_require__(1109));
	
	Object.keys(_Accordion).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Accordion[key];
	    }
	  });
	});
	
	var _AccordionActions = _interopRequireWildcard(__webpack_require__(1111));
	
	Object.keys(_AccordionActions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _AccordionActions[key];
	    }
	  });
	});
	
	var _AccordionDetails = _interopRequireWildcard(__webpack_require__(1113));
	
	Object.keys(_AccordionDetails).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _AccordionDetails[key];
	    }
	  });
	});
	
	var _AccordionSummary = _interopRequireWildcard(__webpack_require__(1115));
	
	Object.keys(_AccordionSummary).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _AccordionSummary[key];
	    }
	  });
	});
	
	var _AppBar = _interopRequireWildcard(__webpack_require__(1117));
	
	Object.keys(_AppBar).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _AppBar[key];
	    }
	  });
	});
	
	var _Avatar = _interopRequireWildcard(__webpack_require__(573));
	
	Object.keys(_Avatar).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Avatar[key];
	    }
	  });
	});
	
	var _Backdrop = _interopRequireWildcard(__webpack_require__(393));
	
	Object.keys(_Backdrop).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Backdrop[key];
	    }
	  });
	});
	
	var _Badge = _interopRequireWildcard(__webpack_require__(1121));
	
	Object.keys(_Badge).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Badge[key];
	    }
	  });
	});
	
	var _BottomNavigation = _interopRequireWildcard(__webpack_require__(1123));
	
	Object.keys(_BottomNavigation).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _BottomNavigation[key];
	    }
	  });
	});
	
	var _BottomNavigationAction = _interopRequireWildcard(__webpack_require__(1125));
	
	Object.keys(_BottomNavigationAction).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _BottomNavigationAction[key];
	    }
	  });
	});
	
	var _Box = _interopRequireWildcard(__webpack_require__(1127));
	
	Object.keys(_Box).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Box[key];
	    }
	  });
	});
	
	var _Breadcrumbs = _interopRequireWildcard(__webpack_require__(1130));
	
	Object.keys(_Breadcrumbs).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Breadcrumbs[key];
	    }
	  });
	});
	
	var _Button = _interopRequireWildcard(__webpack_require__(233));
	
	Object.keys(_Button).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Button[key];
	    }
	  });
	});
	
	var _ButtonBase = _interopRequireWildcard(__webpack_require__(69));
	
	Object.keys(_ButtonBase).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ButtonBase[key];
	    }
	  });
	});
	
	var _ButtonGroup = _interopRequireWildcard(__webpack_require__(1136));
	
	Object.keys(_ButtonGroup).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ButtonGroup[key];
	    }
	  });
	});
	
	var _Card = _interopRequireWildcard(__webpack_require__(574));
	
	Object.keys(_Card).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Card[key];
	    }
	  });
	});
	
	var _CardActionArea = _interopRequireWildcard(__webpack_require__(1139));
	
	Object.keys(_CardActionArea).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CardActionArea[key];
	    }
	  });
	});
	
	var _CardActions = _interopRequireWildcard(__webpack_require__(1141));
	
	Object.keys(_CardActions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CardActions[key];
	    }
	  });
	});
	
	var _CardContent = _interopRequireWildcard(__webpack_require__(1143));
	
	Object.keys(_CardContent).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CardContent[key];
	    }
	  });
	});
	
	var _CardHeader = _interopRequireWildcard(__webpack_require__(575));
	
	Object.keys(_CardHeader).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CardHeader[key];
	    }
	  });
	});
	
	var _CardMedia = _interopRequireWildcard(__webpack_require__(1146));
	
	Object.keys(_CardMedia).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CardMedia[key];
	    }
	  });
	});
	
	var _Checkbox = _interopRequireWildcard(__webpack_require__(394));
	
	Object.keys(_Checkbox).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Checkbox[key];
	    }
	  });
	});
	
	var _Chip = _interopRequireWildcard(__webpack_require__(234));
	
	Object.keys(_Chip).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Chip[key];
	    }
	  });
	});
	
	var _CircularProgress = _interopRequireWildcard(__webpack_require__(1150));
	
	Object.keys(_CircularProgress).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CircularProgress[key];
	    }
	  });
	});
	
	var _ClickAwayListener = _interopRequireWildcard(__webpack_require__(576));
	
	Object.keys(_ClickAwayListener).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ClickAwayListener[key];
	    }
	  });
	});
	
	var _Collapse = _interopRequireWildcard(__webpack_require__(296));
	
	Object.keys(_Collapse).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Collapse[key];
	    }
	  });
	});
	
	var _Container = _interopRequireWildcard(__webpack_require__(1154));
	
	Object.keys(_Container).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Container[key];
	    }
	  });
	});
	
	var _CssBaseline = _interopRequireWildcard(__webpack_require__(1156));
	
	Object.keys(_CssBaseline).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CssBaseline[key];
	    }
	  });
	});
	
	var _Dialog = _interopRequireWildcard(__webpack_require__(190));
	
	Object.keys(_Dialog).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Dialog[key];
	    }
	  });
	});
	
	var _DialogActions = _interopRequireWildcard(__webpack_require__(297));
	
	Object.keys(_DialogActions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _DialogActions[key];
	    }
	  });
	});
	
	var _DialogContent = _interopRequireWildcard(__webpack_require__(577));
	
	Object.keys(_DialogContent).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _DialogContent[key];
	    }
	  });
	});
	
	var _DialogContentText = _interopRequireWildcard(__webpack_require__(1161));
	
	Object.keys(_DialogContentText).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _DialogContentText[key];
	    }
	  });
	});
	
	var _DialogTitle = _interopRequireWildcard(__webpack_require__(235));
	
	Object.keys(_DialogTitle).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _DialogTitle[key];
	    }
	  });
	});
	
	var _Divider = _interopRequireWildcard(__webpack_require__(578));
	
	Object.keys(_Divider).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Divider[key];
	    }
	  });
	});
	
	var _Drawer = _interopRequireWildcard(__webpack_require__(1164));
	
	Object.keys(_Drawer).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Drawer[key];
	    }
	  });
	});
	
	var _ExpansionPanel = _interopRequireWildcard(__webpack_require__(580));
	
	Object.keys(_ExpansionPanel).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ExpansionPanel[key];
	    }
	  });
	});
	
	var _ExpansionPanelActions = _interopRequireWildcard(__webpack_require__(1167));
	
	Object.keys(_ExpansionPanelActions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ExpansionPanelActions[key];
	    }
	  });
	});
	
	var _ExpansionPanelDetails = _interopRequireWildcard(__webpack_require__(581));
	
	Object.keys(_ExpansionPanelDetails).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ExpansionPanelDetails[key];
	    }
	  });
	});
	
	var _ExpansionPanelSummary = _interopRequireWildcard(__webpack_require__(582));
	
	Object.keys(_ExpansionPanelSummary).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ExpansionPanelSummary[key];
	    }
	  });
	});
	
	var _Fab = _interopRequireWildcard(__webpack_require__(396));
	
	Object.keys(_Fab).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Fab[key];
	    }
	  });
	});
	
	var _Fade = _interopRequireWildcard(__webpack_require__(397));
	
	Object.keys(_Fade).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Fade[key];
	    }
	  });
	});
	
	var _FilledInput = _interopRequireWildcard(__webpack_require__(398));
	
	Object.keys(_FilledInput).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _FilledInput[key];
	    }
	  });
	});
	
	var _FormControl = _interopRequireWildcard(__webpack_require__(399));
	
	Object.keys(_FormControl).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _FormControl[key];
	    }
	  });
	});
	
	var _FormControlLabel = _interopRequireWildcard(__webpack_require__(583));
	
	Object.keys(_FormControlLabel).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _FormControlLabel[key];
	    }
	  });
	});
	
	var _FormGroup = _interopRequireWildcard(__webpack_require__(584));
	
	Object.keys(_FormGroup).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _FormGroup[key];
	    }
	  });
	});
	
	var _FormHelperText = _interopRequireWildcard(__webpack_require__(585));
	
	Object.keys(_FormHelperText).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _FormHelperText[key];
	    }
	  });
	});
	
	var _FormLabel = _interopRequireWildcard(__webpack_require__(586));
	
	Object.keys(_FormLabel).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _FormLabel[key];
	    }
	  });
	});
	
	var _Grid = _interopRequireWildcard(__webpack_require__(1179));
	
	Object.keys(_Grid).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Grid[key];
	    }
	  });
	});
	
	var _GridList = _interopRequireWildcard(__webpack_require__(1181));
	
	Object.keys(_GridList).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _GridList[key];
	    }
	  });
	});
	
	var _GridListTile = _interopRequireWildcard(__webpack_require__(1183));
	
	Object.keys(_GridListTile).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _GridListTile[key];
	    }
	  });
	});
	
	var _GridListTileBar = _interopRequireWildcard(__webpack_require__(1185));
	
	Object.keys(_GridListTileBar).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _GridListTileBar[key];
	    }
	  });
	});
	
	var _Grow = _interopRequireWildcard(__webpack_require__(299));
	
	Object.keys(_Grow).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Grow[key];
	    }
	  });
	});
	
	var _Hidden = _interopRequireWildcard(__webpack_require__(1190));
	
	Object.keys(_Hidden).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Hidden[key];
	    }
	  });
	});
	
	var _Icon = _interopRequireWildcard(__webpack_require__(300));
	
	Object.keys(_Icon).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Icon[key];
	    }
	  });
	});
	
	var _IconButton = _interopRequireWildcard(__webpack_require__(236));
	
	Object.keys(_IconButton).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _IconButton[key];
	    }
	  });
	});
	
	var _Input = _interopRequireWildcard(__webpack_require__(301));
	
	Object.keys(_Input).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Input[key];
	    }
	  });
	});
	
	var _InputAdornment = _interopRequireWildcard(__webpack_require__(1195));
	
	Object.keys(_InputAdornment).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _InputAdornment[key];
	    }
	  });
	});
	
	var _InputBase = _interopRequireWildcard(__webpack_require__(237));
	
	Object.keys(_InputBase).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _InputBase[key];
	    }
	  });
	});
	
	var _InputLabel = _interopRequireWildcard(__webpack_require__(587));
	
	Object.keys(_InputLabel).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _InputLabel[key];
	    }
	  });
	});
	
	var _LinearProgress = _interopRequireWildcard(__webpack_require__(302));
	
	Object.keys(_LinearProgress).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _LinearProgress[key];
	    }
	  });
	});
	
	var _Link = _interopRequireWildcard(__webpack_require__(1200));
	
	Object.keys(_Link).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Link[key];
	    }
	  });
	});
	
	var _List = _interopRequireWildcard(__webpack_require__(303));
	
	Object.keys(_List).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _List[key];
	    }
	  });
	});
	
	var _ListItem = _interopRequireWildcard(__webpack_require__(304));
	
	Object.keys(_ListItem).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ListItem[key];
	    }
	  });
	});
	
	var _ListItemAvatar = _interopRequireWildcard(__webpack_require__(305));
	
	Object.keys(_ListItemAvatar).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ListItemAvatar[key];
	    }
	  });
	});
	
	var _ListItemIcon = _interopRequireWildcard(__webpack_require__(1205));
	
	Object.keys(_ListItemIcon).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ListItemIcon[key];
	    }
	  });
	});
	
	var _ListItemSecondaryAction = _interopRequireWildcard(__webpack_require__(1207));
	
	Object.keys(_ListItemSecondaryAction).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ListItemSecondaryAction[key];
	    }
	  });
	});
	
	var _ListItemText = _interopRequireWildcard(__webpack_require__(306));
	
	Object.keys(_ListItemText).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ListItemText[key];
	    }
	  });
	});
	
	var _ListSubheader = _interopRequireWildcard(__webpack_require__(588));
	
	Object.keys(_ListSubheader).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ListSubheader[key];
	    }
	  });
	});
	
	var _Menu = _interopRequireWildcard(__webpack_require__(1210));
	
	Object.keys(_Menu).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Menu[key];
	    }
	  });
	});
	
	var _MenuItem = _interopRequireWildcard(__webpack_require__(590));
	
	Object.keys(_MenuItem).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _MenuItem[key];
	    }
	  });
	});
	
	var _MenuList = _interopRequireWildcard(__webpack_require__(591));
	
	Object.keys(_MenuList).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _MenuList[key];
	    }
	  });
	});
	
	var _MobileStepper = _interopRequireWildcard(__webpack_require__(1214));
	
	Object.keys(_MobileStepper).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _MobileStepper[key];
	    }
	  });
	});
	
	var _Modal = _interopRequireWildcard(__webpack_require__(307));
	
	Object.keys(_Modal).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Modal[key];
	    }
	  });
	});
	
	var _NativeSelect = _interopRequireWildcard(__webpack_require__(1217));
	
	Object.keys(_NativeSelect).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _NativeSelect[key];
	    }
	  });
	});
	
	var _NoSsr = _interopRequireWildcard(__webpack_require__(595));
	
	Object.keys(_NoSsr).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _NoSsr[key];
	    }
	  });
	});
	
	var _OutlinedInput = _interopRequireWildcard(__webpack_require__(401));
	
	Object.keys(_OutlinedInput).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _OutlinedInput[key];
	    }
	  });
	});
	
	var _Paper = _interopRequireWildcard(__webpack_require__(89));
	
	Object.keys(_Paper).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Paper[key];
	    }
	  });
	});
	
	var _Popover = _interopRequireWildcard(__webpack_require__(596));
	
	Object.keys(_Popover).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Popover[key];
	    }
	  });
	});
	
	var _Popper = _interopRequireWildcard(__webpack_require__(597));
	
	Object.keys(_Popper).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Popper[key];
	    }
	  });
	});
	
	var _Portal = _interopRequireWildcard(__webpack_require__(402));
	
	Object.keys(_Portal).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Portal[key];
	    }
	  });
	});
	
	var _Radio = _interopRequireWildcard(__webpack_require__(1227));
	
	Object.keys(_Radio).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Radio[key];
	    }
	  });
	});
	
	var _RadioGroup = _interopRequireWildcard(__webpack_require__(1229));
	
	Object.keys(_RadioGroup).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _RadioGroup[key];
	    }
	  });
	});
	
	var _RootRef = _interopRequireWildcard(__webpack_require__(1231));
	
	Object.keys(_RootRef).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _RootRef[key];
	    }
	  });
	});
	
	var _Select = _interopRequireWildcard(__webpack_require__(403));
	
	Object.keys(_Select).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Select[key];
	    }
	  });
	});
	
	var _Slide = _interopRequireWildcard(__webpack_require__(155));
	
	Object.keys(_Slide).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Slide[key];
	    }
	  });
	});
	
	var _Slider = _interopRequireWildcard(__webpack_require__(1237));
	
	Object.keys(_Slider).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Slider[key];
	    }
	  });
	});
	
	var _Snackbar = _interopRequireWildcard(__webpack_require__(192));
	
	Object.keys(_Snackbar).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Snackbar[key];
	    }
	  });
	});
	
	var _SnackbarContent = _interopRequireWildcard(__webpack_require__(404));
	
	Object.keys(_SnackbarContent).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _SnackbarContent[key];
	    }
	  });
	});
	
	var _Step = _interopRequireWildcard(__webpack_require__(600));
	
	Object.keys(_Step).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Step[key];
	    }
	  });
	});
	
	var _StepButton = _interopRequireWildcard(__webpack_require__(1242));
	
	Object.keys(_StepButton).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _StepButton[key];
	    }
	  });
	});
	
	var _StepConnector = _interopRequireWildcard(__webpack_require__(601));
	
	Object.keys(_StepConnector).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _StepConnector[key];
	    }
	  });
	});
	
	var _StepContent = _interopRequireWildcard(__webpack_require__(1245));
	
	Object.keys(_StepContent).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _StepContent[key];
	    }
	  });
	});
	
	var _StepIcon = _interopRequireWildcard(__webpack_require__(602));
	
	Object.keys(_StepIcon).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _StepIcon[key];
	    }
	  });
	});
	
	var _StepLabel = _interopRequireWildcard(__webpack_require__(405));
	
	Object.keys(_StepLabel).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _StepLabel[key];
	    }
	  });
	});
	
	var _Stepper = _interopRequireWildcard(__webpack_require__(603));
	
	Object.keys(_Stepper).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Stepper[key];
	    }
	  });
	});
	
	var _SvgIcon = _interopRequireWildcard(__webpack_require__(308));
	
	Object.keys(_SvgIcon).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _SvgIcon[key];
	    }
	  });
	});
	
	var _SwipeableDrawer = _interopRequireWildcard(__webpack_require__(1252));
	
	Object.keys(_SwipeableDrawer).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _SwipeableDrawer[key];
	    }
	  });
	});
	
	var _Switch = _interopRequireWildcard(__webpack_require__(1254));
	
	Object.keys(_Switch).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Switch[key];
	    }
	  });
	});
	
	var _Tab = _interopRequireWildcard(__webpack_require__(1256));
	
	Object.keys(_Tab).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Tab[key];
	    }
	  });
	});
	
	var _Table = _interopRequireWildcard(__webpack_require__(1259));
	
	Object.keys(_Table).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Table[key];
	    }
	  });
	});
	
	var _TableBody = _interopRequireWildcard(__webpack_require__(1261));
	
	Object.keys(_TableBody).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TableBody[key];
	    }
	  });
	});
	
	var _TableCell = _interopRequireWildcard(__webpack_require__(606));
	
	Object.keys(_TableCell).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TableCell[key];
	    }
	  });
	});
	
	var _TableContainer = _interopRequireWildcard(__webpack_require__(1264));
	
	Object.keys(_TableContainer).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TableContainer[key];
	    }
	  });
	});
	
	var _TableFooter = _interopRequireWildcard(__webpack_require__(1266));
	
	Object.keys(_TableFooter).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TableFooter[key];
	    }
	  });
	});
	
	var _TableHead = _interopRequireWildcard(__webpack_require__(1268));
	
	Object.keys(_TableHead).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TableHead[key];
	    }
	  });
	});
	
	var _TablePagination = _interopRequireWildcard(__webpack_require__(1271));
	
	Object.keys(_TablePagination).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TablePagination[key];
	    }
	  });
	});
	
	var _TableRow = _interopRequireWildcard(__webpack_require__(1273));
	
	Object.keys(_TableRow).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TableRow[key];
	    }
	  });
	});
	
	var _TableSortLabel = _interopRequireWildcard(__webpack_require__(1275));
	
	Object.keys(_TableSortLabel).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TableSortLabel[key];
	    }
	  });
	});
	
	var _Tabs = _interopRequireWildcard(__webpack_require__(607));
	
	Object.keys(_Tabs).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Tabs[key];
	    }
	  });
	});
	
	var _TabScrollButton = _interopRequireWildcard(__webpack_require__(604));
	
	Object.keys(_TabScrollButton).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TabScrollButton[key];
	    }
	  });
	});
	
	var _TextField = _interopRequireWildcard(__webpack_require__(406));
	
	Object.keys(_TextField).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TextField[key];
	    }
	  });
	});
	
	var _TextareaAutosize = _interopRequireWildcard(__webpack_require__(608));
	
	Object.keys(_TextareaAutosize).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TextareaAutosize[key];
	    }
	  });
	});
	
	var _Toolbar = _interopRequireWildcard(__webpack_require__(609));
	
	Object.keys(_Toolbar).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Toolbar[key];
	    }
	  });
	});
	
	var _Tooltip = _interopRequireWildcard(__webpack_require__(240));
	
	Object.keys(_Tooltip).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Tooltip[key];
	    }
	  });
	});
	
	var _Typography = _interopRequireWildcard(__webpack_require__(75));
	
	Object.keys(_Typography).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Typography[key];
	    }
	  });
	});
	
	var _Unstable_TrapFocus = _interopRequireWildcard(__webpack_require__(610));
	
	Object.keys(_Unstable_TrapFocus).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Unstable_TrapFocus[key];
	    }
	  });
	});
	
	var _useMediaQuery = _interopRequireWildcard(__webpack_require__(625));
	
	Object.keys(_useMediaQuery).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _useMediaQuery[key];
	    }
	  });
	});
	
	var _useScrollTrigger = _interopRequireWildcard(__webpack_require__(1326));
	
	Object.keys(_useScrollTrigger).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _useScrollTrigger[key];
	    }
	  });
	});
	
	var _withMobileDialog = _interopRequireWildcard(__webpack_require__(1330));
	
	Object.keys(_withMobileDialog).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withMobileDialog[key];
	    }
	  });
	});
	
	var _withWidth = _interopRequireWildcard(__webpack_require__(409));
	
	Object.keys(_withWidth).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withWidth[key];
	    }
	  });
	});
	
	var _Zoom = _interopRequireWildcard(__webpack_require__(1286));
	
	Object.keys(_Zoom).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Zoom[key];
	    }
	  });
	});

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useEventCallback;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var useEnhancedEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
	/**
	 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
	 *
	 * @param {function} fn
	 */
	
	function useEventCallback(fn) {
	  var ref = React.useRef(fn);
	  useEnhancedEffect(function () {
	    ref.current = fn;
	  });
	  return React.useCallback(function () {
	    return (0, ref.current).apply(void 0, arguments);
	  }, []);
	}

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _merge = _interopRequireDefault(__webpack_require__(312));
	
	function compose() {
	  for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
	    styles[_key] = arguments[_key];
	  }
	
	  var fn = function fn(props) {
	    return styles.reduce(function (acc, style) {
	      var output = style(props);
	
	      if (output) {
	        return (0, _merge.default)(acc, output);
	      }
	
	      return acc;
	    }, {});
	  }; // Alternative approach that doesn't yield any performance gain.
	  // const handlers = styles.reduce((acc, style) => {
	  //   style.filterProps.forEach(prop => {
	  //     acc[prop] = style;
	  //   });
	  //   return acc;
	  // }, {});
	  // const fn = props => {
	  //   return Object.keys(props).reduce((acc, prop) => {
	  //     if (handlers[prop]) {
	  //       return merge(acc, handlers[prop](props));
	  //     }
	  //     return acc;
	  //   }, {});
	  // };
	
	
	  fn.propTypes =  false ? styles.reduce(function (acc, style) {
	    return (0, _extends2.default)(acc, style.propTypes);
	  }, {}) : {};
	  fn.filterProps = styles.reduce(function (acc, style) {
	    return acc.concat(style.filterProps);
	  }, []);
	  return fn;
	}
	
	var _default = compose;
	exports.default = _default;

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var eventService_1 = __webpack_require__(22);
	var events_1 = __webpack_require__(29);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var columnApi_1 = __webpack_require__(38);
	var columnController_1 = __webpack_require__(26);
	var gridApi_1 = __webpack_require__(33);
	var cellComp_1 = __webpack_require__(251);
	var utils_1 = __webpack_require__(10);
	var FocusedCellController = /** @class */ (function () {
	    function FocusedCellController() {
	    }
	    FocusedCellController.prototype.init = function () {
	        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.clearFocusedCell.bind(this));
	        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED, this.clearFocusedCell.bind(this));
	        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_GROUP_OPENED, this.clearFocusedCell.bind(this));
	        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.clearFocusedCell.bind(this));
	        // we used to remove focus when moving column, am not sure why. so taking this out and see who complains.
	        // we can delete these three lines of code soon.
	        // this.eventService.addEventListener(Events.EVENT_COLUMN_MOVED, this.clearFocusedCell.bind(this));
	        // this.eventService.addEventListener(Events.EVENT_COLUMN_PINNED, this.clearFocusedCell.bind(this));
	        // this.eventService.addEventListener(Events.EVENT_COLUMN_VISIBLE, this.clearFocusedCell.bind(this));
	    };
	    FocusedCellController.prototype.clearFocusedCell = function () {
	        this.focusedCellPosition = null;
	        this.onCellFocused(false);
	    };
	    FocusedCellController.prototype.getFocusedCell = function () {
	        return this.focusedCellPosition;
	    };
	    // we check if the browser is focusing something, and if it is, and
	    // it's the cell we think is focused, then return the cell. so this
	    // methods returns the cell if a) we think it has focus and b) the
	    // browser thinks it has focus. this then returns nothing if we
	    // first focus a cell, then second click outside the grid, as then the
	    // grid cell will still be focused as far as the grid is concerned,
	    // however the browser focus will have moved somewhere else.
	    FocusedCellController.prototype.getFocusCellToUseAfterRefresh = function () {
	        if (this.gridOptionsWrapper.isSuppressFocusAfterRefresh()) {
	            return null;
	        }
	        if (!this.focusedCellPosition) {
	            return null;
	        }
	        // we check that the browser is actually focusing on the grid, if it is not, then
	        // we have nothing to worry about
	        var browserFocusedCell = this.getGridCellForDomElement(document.activeElement);
	        if (!browserFocusedCell) {
	            return null;
	        }
	        return this.focusedCellPosition;
	    };
	    FocusedCellController.prototype.getGridCellForDomElement = function (eBrowserCell) {
	        var ePointer = eBrowserCell;
	        while (ePointer) {
	            var cellComp = this.gridOptionsWrapper.getDomData(ePointer, cellComp_1.CellComp.DOM_DATA_KEY_CELL_COMP);
	            if (cellComp) {
	                return cellComp.getCellPosition();
	            }
	            ePointer = ePointer.parentNode;
	        }
	        return null;
	    };
	    FocusedCellController.prototype.setFocusedCell = function (rowIndex, colKey, floating, forceBrowserFocus) {
	        if (forceBrowserFocus === void 0) { forceBrowserFocus = false; }
	        var column = utils_1._.makeNull(this.columnController.getGridColumn(colKey));
	        this.focusedCellPosition = { rowIndex: rowIndex, rowPinned: utils_1._.makeNull(floating), column: column };
	        this.onCellFocused(forceBrowserFocus);
	    };
	    FocusedCellController.prototype.isCellFocused = function (cellPosition) {
	        if (utils_1._.missing(this.focusedCellPosition)) {
	            return false;
	        }
	        return this.focusedCellPosition.column === cellPosition.column && this.isRowFocused(cellPosition.rowIndex, cellPosition.rowPinned);
	    };
	    FocusedCellController.prototype.isRowNodeFocused = function (rowNode) {
	        return this.isRowFocused(rowNode.rowIndex, rowNode.rowPinned);
	    };
	    FocusedCellController.prototype.isAnyCellFocused = function () {
	        return !!this.focusedCellPosition;
	    };
	    FocusedCellController.prototype.isRowFocused = function (rowIndex, floating) {
	        if (utils_1._.missing(this.focusedCellPosition)) {
	            return false;
	        }
	        var floatingOrNull = utils_1._.makeNull(floating);
	        return this.focusedCellPosition.rowIndex === rowIndex && this.focusedCellPosition.rowPinned === floatingOrNull;
	    };
	    FocusedCellController.prototype.onCellFocused = function (forceBrowserFocus) {
	        var event = {
	            type: events_1.Events.EVENT_CELL_FOCUSED,
	            forceBrowserFocus: forceBrowserFocus,
	            rowIndex: null,
	            column: null,
	            floating: null,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            rowPinned: null
	        };
	        if (this.focusedCellPosition) {
	            event.rowIndex = this.focusedCellPosition.rowIndex;
	            event.column = this.focusedCellPosition.column;
	            event.rowPinned = this.focusedCellPosition.rowPinned;
	        }
	        this.eventService.dispatchEvent(event);
	    };
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], FocusedCellController.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], FocusedCellController.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], FocusedCellController.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], FocusedCellController.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], FocusedCellController.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], FocusedCellController.prototype, "init", null);
	    FocusedCellController = __decorate([
	        context_1.Bean('focusedCellController')
	    ], FocusedCellController);
	    return FocusedCellController;
	}());
	exports.FocusedCellController = FocusedCellController;


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var column_1 = __webpack_require__(45);
	var context_1 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var columnApi_1 = __webpack_require__(38);
	var columnController_1 = __webpack_require__(26);
	var eventService_1 = __webpack_require__(22);
	var events_1 = __webpack_require__(29);
	var gridApi_1 = __webpack_require__(33);
	var utils_1 = __webpack_require__(10);
	var SortController = /** @class */ (function () {
	    function SortController() {
	    }
	    SortController_1 = SortController;
	    SortController.prototype.progressSort = function (column, multiSort, source) {
	        if (source === void 0) { source = "api"; }
	        var nextDirection = this.getNextSortDirection(column);
	        this.setSortForColumn(column, nextDirection, multiSort, source);
	    };
	    SortController.prototype.setSortForColumn = function (column, sort, multiSort, source) {
	        if (source === void 0) { source = "api"; }
	        // auto correct - if sort not legal value, then set it to 'no sort' (which is null)
	        if (sort !== column_1.Column.SORT_ASC && sort !== column_1.Column.SORT_DESC) {
	            sort = null;
	        }
	        // update sort on current col
	        column.setSort(sort, source);
	        // sortedAt used for knowing order of cols when multi-col sort
	        if (column.getSort()) {
	            var sortedAt = Number(new Date().valueOf());
	            column.setSortedAt(sortedAt);
	        }
	        else {
	            column.setSortedAt(null);
	        }
	        var doingMultiSort = multiSort && !this.gridOptionsWrapper.isSuppressMultiSort();
	        // clear sort on all columns except this one, and update the icons
	        if (!doingMultiSort) {
	            this.clearSortBarThisColumn(column, source);
	        }
	        this.dispatchSortChangedEvents();
	    };
	    // gets called by API, so if data changes, use can call this, which will end up
	    // working out the sort order again of the rows.
	    SortController.prototype.onSortChanged = function () {
	        this.dispatchSortChangedEvents();
	    };
	    SortController.prototype.dispatchSortChangedEvents = function () {
	        var event = {
	            type: events_1.Events.EVENT_SORT_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    SortController.prototype.clearSortBarThisColumn = function (columnToSkip, source) {
	        this.columnController.getPrimaryAndSecondaryAndAutoColumns().forEach(function (columnToClear) {
	            // Do not clear if either holding shift, or if column in question was clicked
	            if (!(columnToClear === columnToSkip)) {
	                // setting to 'undefined' as null means 'none' rather than cleared, otherwise issue will arise
	                // if sort order is: ['desc', null , 'asc'], as it will start at null rather than 'desc'.
	                columnToClear.setSort(undefined, source);
	            }
	        });
	    };
	    SortController.prototype.getNextSortDirection = function (column) {
	        var sortingOrder;
	        if (column.getColDef().sortingOrder) {
	            sortingOrder = column.getColDef().sortingOrder;
	        }
	        else if (this.gridOptionsWrapper.getSortingOrder()) {
	            sortingOrder = this.gridOptionsWrapper.getSortingOrder();
	        }
	        else {
	            sortingOrder = SortController_1.DEFAULT_SORTING_ORDER;
	        }
	        if (!Array.isArray(sortingOrder) || sortingOrder.length <= 0) {
	            console.warn("ag-grid: sortingOrder must be an array with at least one element, currently it's " + sortingOrder);
	            return null;
	        }
	        var currentIndex = sortingOrder.indexOf(column.getSort());
	        var notInArray = currentIndex < 0;
	        var lastItemInArray = currentIndex == sortingOrder.length - 1;
	        var result;
	        if (notInArray || lastItemInArray) {
	            result = sortingOrder[0];
	        }
	        else {
	            result = sortingOrder[currentIndex + 1];
	        }
	        // verify the sort type exists, as the user could provide the sortingOrder, need to make sure it's valid
	        if (SortController_1.DEFAULT_SORTING_ORDER.indexOf(result) < 0) {
	            console.warn('ag-grid: invalid sort type ' + result);
	            return null;
	        }
	        return result;
	    };
	    // used by the public api, for saving the sort model
	    SortController.prototype.getSortModel = function () {
	        var columnsWithSorting = this.getColumnsWithSortingOrdered();
	        return utils_1._.map(columnsWithSorting, function (column) {
	            return {
	                colId: column.getColId(),
	                sort: column.getSort()
	            };
	        });
	    };
	    SortController.prototype.setSortModel = function (sortModel, source) {
	        var _this = this;
	        if (source === void 0) { source = "api"; }
	        // first up, clear any previous sort
	        var sortModelProvided = sortModel && sortModel.length > 0;
	        var allColumnsIncludingAuto = this.columnController.getPrimaryAndSecondaryAndAutoColumns();
	        allColumnsIncludingAuto.forEach(function (column) {
	            var sortForCol = null;
	            var sortedAt = -1;
	            if (sortModelProvided && column.getColDef().sortable) {
	                for (var j = 0; j < sortModel.length; j++) {
	                    var sortModelEntry = sortModel[j];
	                    if (typeof sortModelEntry.colId === 'string'
	                        && typeof column.getColId() === 'string'
	                        && _this.compareColIds(sortModelEntry, column)) {
	                        sortForCol = sortModelEntry.sort;
	                        sortedAt = j;
	                    }
	                }
	            }
	            if (sortForCol) {
	                column.setSort(sortForCol, source);
	                column.setSortedAt(sortedAt);
	            }
	            else {
	                column.setSort(null, source);
	                column.setSortedAt(null);
	            }
	        });
	        this.dispatchSortChangedEvents();
	    };
	    SortController.prototype.compareColIds = function (sortModelEntry, column) {
	        return sortModelEntry.colId === column.getColId();
	    };
	    SortController.prototype.getColumnsWithSortingOrdered = function () {
	        // pull out all the columns that have sorting set
	        var allColumnsIncludingAuto = this.columnController.getPrimaryAndSecondaryAndAutoColumns();
	        var columnsWithSorting = utils_1._.filter(allColumnsIncludingAuto, function (column) { return !!column.getSort(); });
	        // put the columns in order of which one got sorted first
	        columnsWithSorting.sort(function (a, b) { return a.sortedAt - b.sortedAt; });
	        return columnsWithSorting;
	    };
	    // used by row controller, when doing the sorting
	    SortController.prototype.getSortForRowController = function () {
	        var columnsWithSorting = this.getColumnsWithSortingOrdered();
	        return utils_1._.map(columnsWithSorting, function (column) {
	            var ascending = column.getSort() === column_1.Column.SORT_ASC;
	            return {
	                inverter: ascending ? 1 : -1,
	                column: column
	            };
	        });
	    };
	    var SortController_1;
	    SortController.DEFAULT_SORTING_ORDER = [column_1.Column.SORT_ASC, column_1.Column.SORT_DESC, null];
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], SortController.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], SortController.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], SortController.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], SortController.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], SortController.prototype, "gridApi", void 0);
	    SortController = SortController_1 = __decorate([
	        context_1.Bean('sortController')
	    ], SortController);
	    return SortController;
	}());
	exports.SortController = SortController;


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var logger_1 = __webpack_require__(68);
	var context_1 = __webpack_require__(8);
	var context_2 = __webpack_require__(8);
	var ExpressionService = /** @class */ (function () {
	    function ExpressionService() {
	        this.expressionToFunctionCache = {};
	    }
	    ExpressionService.prototype.setBeans = function (loggerFactory) {
	        this.logger = loggerFactory.create('ExpressionService');
	    };
	    ExpressionService.prototype.evaluate = function (expressionOrFunc, params) {
	        if (typeof expressionOrFunc === 'function') {
	            // valueGetter is a function, so just call it
	            var func = expressionOrFunc;
	            return func(params);
	        }
	        else if (typeof expressionOrFunc === 'string') {
	            // valueGetter is an expression, so execute the expression
	            var expression = expressionOrFunc;
	            return this.evaluateExpression(expression, params);
	        }
	        else {
	            console.error('ag-Grid: value should be either a string or a function', expressionOrFunc);
	        }
	    };
	    ExpressionService.prototype.evaluateExpression = function (expression, params) {
	        try {
	            var javaScriptFunction = this.createExpressionFunction(expression);
	            // the params don't have all these values, rather we add every possible
	            // value a params can have, which makes whatever is in the params available.
	            var result = javaScriptFunction(params.value, params.context, params.oldValue, params.newValue, params.value, params.node, params.data, params.colDef, params.rowIndex, params.api, params.columnApi, params.getValue, params.column, params.columnGroup);
	            return result;
	        }
	        catch (e) {
	            // the expression failed, which can happen, as it's the client that
	            // provides the expression. so print a nice message
	            // tslint:disable-next-line
	            console.log('Processing of the expression failed');
	            // tslint:disable-next-line
	            console.log('Expression = ' + expression);
	            // tslint:disable-next-line
	            console.log('Exception = ' + e);
	            return null;
	        }
	    };
	    ExpressionService.prototype.createExpressionFunction = function (expression) {
	        // check cache first
	        if (this.expressionToFunctionCache[expression]) {
	            return this.expressionToFunctionCache[expression];
	        }
	        // if not found in cache, return the function
	        var functionBody = this.createFunctionBody(expression);
	        var theFunction = new Function('x, ctx, oldValue, newValue, value, node, data, colDef, rowIndex, api, columnApi, getValue, column, columnGroup', functionBody);
	        // store in cache
	        this.expressionToFunctionCache[expression] = theFunction;
	        return theFunction;
	    };
	    ExpressionService.prototype.createFunctionBody = function (expression) {
	        // if the expression has the 'return' word in it, then use as is,
	        // if not, then wrap it with return and ';' to make a function
	        if (expression.indexOf('return') >= 0) {
	            return expression;
	        }
	        else {
	            return 'return ' + expression + ';';
	        }
	    };
	    __decorate([
	        __param(0, context_2.Qualifier('loggerFactory')),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [logger_1.LoggerFactory]),
	        __metadata("design:returntype", void 0)
	    ], ExpressionService.prototype, "setBeans", null);
	    ExpressionService = __decorate([
	        context_1.Bean('expressionService')
	    ], ExpressionService);
	    return ExpressionService;
	}());
	exports.ExpressionService = ExpressionService;


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var List = __webpack_require__(83);
	
	var createDimensions = __webpack_require__(207);
	
	var _sourceType = __webpack_require__(265);
	
	var SOURCE_FORMAT_ORIGINAL = _sourceType.SOURCE_FORMAT_ORIGINAL;
	
	var _dimensionHelper = __webpack_require__(264);
	
	var getDimensionTypeByAxis = _dimensionHelper.getDimensionTypeByAxis;
	
	var _model = __webpack_require__(24);
	
	var getDataItemValue = _model.getDataItemValue;
	
	var CoordinateSystem = __webpack_require__(92);
	
	var _referHelper = __webpack_require__(1699);
	
	var getCoordSysInfoBySeries = _referHelper.getCoordSysInfoBySeries;
	
	var Source = __webpack_require__(263);
	
	var _dataStackHelper = __webpack_require__(105);
	
	var enableDataStack = _dataStackHelper.enableDataStack;
	
	var _sourceHelper = __webpack_require__(123);
	
	var makeSeriesEncodeForAxisCoordSys = _sourceHelper.makeSeriesEncodeForAxisCoordSys;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {module:echarts/data/Source|Array} source Or raw data.
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {Object} [opt]
	 * @param {string} [opt.generateCoord]
	 * @param {boolean} [opt.useEncodeDefaulter]
	 */
	function createListFromArray(source, seriesModel, opt) {
	  opt = opt || {};
	
	  if (!Source.isInstance(source)) {
	    source = Source.seriesDataToSource(source);
	  }
	
	  var coordSysName = seriesModel.get('coordinateSystem');
	  var registeredCoordSys = CoordinateSystem.get(coordSysName);
	  var coordSysInfo = getCoordSysInfoBySeries(seriesModel);
	  var coordSysDimDefs;
	
	  if (coordSysInfo) {
	    coordSysDimDefs = zrUtil.map(coordSysInfo.coordSysDims, function (dim) {
	      var dimInfo = {
	        name: dim
	      };
	      var axisModel = coordSysInfo.axisMap.get(dim);
	
	      if (axisModel) {
	        var axisType = axisModel.get('type');
	        dimInfo.type = getDimensionTypeByAxis(axisType); // dimInfo.stackable = isStackable(axisType);
	      }
	
	      return dimInfo;
	    });
	  }
	
	  if (!coordSysDimDefs) {
	    // Get dimensions from registered coordinate system
	    coordSysDimDefs = registeredCoordSys && (registeredCoordSys.getDimensionsInfo ? registeredCoordSys.getDimensionsInfo() : registeredCoordSys.dimensions.slice()) || ['x', 'y'];
	  }
	
	  var dimInfoList = createDimensions(source, {
	    coordDimensions: coordSysDimDefs,
	    generateCoord: opt.generateCoord,
	    encodeDefaulter: opt.useEncodeDefaulter ? zrUtil.curry(makeSeriesEncodeForAxisCoordSys, coordSysDimDefs, seriesModel) : null
	  });
	  var firstCategoryDimIndex;
	  var hasNameEncode;
	  coordSysInfo && zrUtil.each(dimInfoList, function (dimInfo, dimIndex) {
	    var coordDim = dimInfo.coordDim;
	    var categoryAxisModel = coordSysInfo.categoryAxisMap.get(coordDim);
	
	    if (categoryAxisModel) {
	      if (firstCategoryDimIndex == null) {
	        firstCategoryDimIndex = dimIndex;
	      }
	
	      dimInfo.ordinalMeta = categoryAxisModel.getOrdinalMeta();
	    }
	
	    if (dimInfo.otherDims.itemName != null) {
	      hasNameEncode = true;
	    }
	  });
	
	  if (!hasNameEncode && firstCategoryDimIndex != null) {
	    dimInfoList[firstCategoryDimIndex].otherDims.itemName = 0;
	  }
	
	  var stackCalculationInfo = enableDataStack(seriesModel, dimInfoList);
	  var list = new List(dimInfoList, seriesModel);
	  list.setCalculationInfo(stackCalculationInfo);
	  var dimValueGetter = firstCategoryDimIndex != null && isNeedCompleteOrdinalData(source) ? function (itemOpt, dimName, dataIndex, dimIndex) {
	    // Use dataIndex as ordinal value in categoryAxis
	    return dimIndex === firstCategoryDimIndex ? dataIndex : this.defaultDimValueGetter(itemOpt, dimName, dataIndex, dimIndex);
	  } : null;
	  list.hasItemOption = false;
	  list.initData(source, null, dimValueGetter);
	  return list;
	}
	
	function isNeedCompleteOrdinalData(source) {
	  if (source.sourceFormat === SOURCE_FORMAT_ORIGINAL) {
	    var sampleItem = firstDataNotNull(source.data || []);
	    return sampleItem != null && !zrUtil.isArray(getDataItemValue(sampleItem));
	  }
	}
	
	function firstDataNotNull(data) {
	  var i = 0;
	
	  while (i < data.length && data[i] == null) {
	    i++;
	  }
	
	  return data[i];
	}
	
	var _default = createListFromArray;
	module.exports = _default;

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	var _model = __webpack_require__(24);
	
	var makeInner = _model.makeInner;
	var getDataItemValue = _model.getDataItemValue;
	
	var _util = __webpack_require__(3);
	
	var createHashMap = _util.createHashMap;
	var each = _util.each;
	var map = _util.map;
	var isArray = _util.isArray;
	var isString = _util.isString;
	var isObject = _util.isObject;
	var isTypedArray = _util.isTypedArray;
	var isArrayLike = _util.isArrayLike;
	var extend = _util.extend;
	var assert = _util.assert;
	
	var Source = __webpack_require__(263);
	
	var _sourceType = __webpack_require__(265);
	
	var SOURCE_FORMAT_ORIGINAL = _sourceType.SOURCE_FORMAT_ORIGINAL;
	var SOURCE_FORMAT_ARRAY_ROWS = _sourceType.SOURCE_FORMAT_ARRAY_ROWS;
	var SOURCE_FORMAT_OBJECT_ROWS = _sourceType.SOURCE_FORMAT_OBJECT_ROWS;
	var SOURCE_FORMAT_KEYED_COLUMNS = _sourceType.SOURCE_FORMAT_KEYED_COLUMNS;
	var SOURCE_FORMAT_UNKNOWN = _sourceType.SOURCE_FORMAT_UNKNOWN;
	var SOURCE_FORMAT_TYPED_ARRAY = _sourceType.SOURCE_FORMAT_TYPED_ARRAY;
	var SERIES_LAYOUT_BY_ROW = _sourceType.SERIES_LAYOUT_BY_ROW;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// The result of `guessOrdinal`.
	var BE_ORDINAL = {
	  Must: 1,
	  // Encounter string but not '-' and not number-like.
	  Might: 2,
	  // Encounter string but number-like.
	  Not: 3 // Other cases
	
	};
	var inner = makeInner();
	/**
	 * @see {module:echarts/data/Source}
	 * @param {module:echarts/component/dataset/DatasetModel} datasetModel
	 * @return {string} sourceFormat
	 */
	
	function detectSourceFormat(datasetModel) {
	  var data = datasetModel.option.source;
	  var sourceFormat = SOURCE_FORMAT_UNKNOWN;
	
	  if (isTypedArray(data)) {
	    sourceFormat = SOURCE_FORMAT_TYPED_ARRAY;
	  } else if (isArray(data)) {
	    // FIXME Whether tolerate null in top level array?
	    if (data.length === 0) {
	      sourceFormat = SOURCE_FORMAT_ARRAY_ROWS;
	    }
	
	    for (var i = 0, len = data.length; i < len; i++) {
	      var item = data[i];
	
	      if (item == null) {
	        continue;
	      } else if (isArray(item)) {
	        sourceFormat = SOURCE_FORMAT_ARRAY_ROWS;
	        break;
	      } else if (isObject(item)) {
	        sourceFormat = SOURCE_FORMAT_OBJECT_ROWS;
	        break;
	      }
	    }
	  } else if (isObject(data)) {
	    for (var key in data) {
	      if (data.hasOwnProperty(key) && isArrayLike(data[key])) {
	        sourceFormat = SOURCE_FORMAT_KEYED_COLUMNS;
	        break;
	      }
	    }
	  } else if (data != null) {
	    throw new Error('Invalid data');
	  }
	
	  inner(datasetModel).sourceFormat = sourceFormat;
	}
	/**
	 * [Scenarios]:
	 * (1) Provide source data directly:
	 *     series: {
	 *         encode: {...},
	 *         dimensions: [...]
	 *         seriesLayoutBy: 'row',
	 *         data: [[...]]
	 *     }
	 * (2) Refer to datasetModel.
	 *     series: [{
	 *         encode: {...}
	 *         // Ignore datasetIndex means `datasetIndex: 0`
	 *         // and the dimensions defination in dataset is used
	 *     }, {
	 *         encode: {...},
	 *         seriesLayoutBy: 'column',
	 *         datasetIndex: 1
	 *     }]
	 *
	 * Get data from series itself or datset.
	 * @return {module:echarts/data/Source} source
	 */
	
	
	function getSource(seriesModel) {
	  return inner(seriesModel).source;
	}
	/**
	 * MUST be called before mergeOption of all series.
	 * @param {module:echarts/model/Global} ecModel
	 */
	
	
	function resetSourceDefaulter(ecModel) {
	  // `datasetMap` is used to make default encode.
	  inner(ecModel).datasetMap = createHashMap();
	}
	/**
	 * [Caution]:
	 * MUST be called after series option merged and
	 * before "series.getInitailData()" called.
	 *
	 * [The rule of making default encode]:
	 * Category axis (if exists) alway map to the first dimension.
	 * Each other axis occupies a subsequent dimension.
	 *
	 * [Why make default encode]:
	 * Simplify the typing of encode in option, avoiding the case like that:
	 * series: [{encode: {x: 0, y: 1}}, {encode: {x: 0, y: 2}}, {encode: {x: 0, y: 3}}],
	 * where the "y" have to be manually typed as "1, 2, 3, ...".
	 *
	 * @param {module:echarts/model/Series} seriesModel
	 */
	
	
	function prepareSource(seriesModel) {
	  var seriesOption = seriesModel.option;
	  var data = seriesOption.data;
	  var sourceFormat = isTypedArray(data) ? SOURCE_FORMAT_TYPED_ARRAY : SOURCE_FORMAT_ORIGINAL;
	  var fromDataset = false;
	  var seriesLayoutBy = seriesOption.seriesLayoutBy;
	  var sourceHeader = seriesOption.sourceHeader;
	  var dimensionsDefine = seriesOption.dimensions;
	  var datasetModel = getDatasetModel(seriesModel);
	
	  if (datasetModel) {
	    var datasetOption = datasetModel.option;
	    data = datasetOption.source;
	    sourceFormat = inner(datasetModel).sourceFormat;
	    fromDataset = true; // These settings from series has higher priority.
	
	    seriesLayoutBy = seriesLayoutBy || datasetOption.seriesLayoutBy;
	    sourceHeader == null && (sourceHeader = datasetOption.sourceHeader);
	    dimensionsDefine = dimensionsDefine || datasetOption.dimensions;
	  }
	
	  var completeResult = completeBySourceData(data, sourceFormat, seriesLayoutBy, sourceHeader, dimensionsDefine);
	  inner(seriesModel).source = new Source({
	    data: data,
	    fromDataset: fromDataset,
	    seriesLayoutBy: seriesLayoutBy,
	    sourceFormat: sourceFormat,
	    dimensionsDefine: completeResult.dimensionsDefine,
	    startIndex: completeResult.startIndex,
	    dimensionsDetectCount: completeResult.dimensionsDetectCount,
	    // Note: dataset option does not have `encode`.
	    encodeDefine: seriesOption.encode
	  });
	} // return {startIndex, dimensionsDefine, dimensionsCount}
	
	
	function completeBySourceData(data, sourceFormat, seriesLayoutBy, sourceHeader, dimensionsDefine) {
	  if (!data) {
	    return {
	      dimensionsDefine: normalizeDimensionsDefine(dimensionsDefine)
	    };
	  }
	
	  var dimensionsDetectCount;
	  var startIndex;
	
	  if (sourceFormat === SOURCE_FORMAT_ARRAY_ROWS) {
	    // Rule: Most of the first line are string: it is header.
	    // Caution: consider a line with 5 string and 1 number,
	    // it still can not be sure it is a head, because the
	    // 5 string may be 5 values of category columns.
	    if (sourceHeader === 'auto' || sourceHeader == null) {
	      arrayRowsTravelFirst(function (val) {
	        // '-' is regarded as null/undefined.
	        if (val != null && val !== '-') {
	          if (isString(val)) {
	            startIndex == null && (startIndex = 1);
	          } else {
	            startIndex = 0;
	          }
	        } // 10 is an experience number, avoid long loop.
	
	      }, seriesLayoutBy, data, 10);
	    } else {
	      startIndex = sourceHeader ? 1 : 0;
	    }
	
	    if (!dimensionsDefine && startIndex === 1) {
	      dimensionsDefine = [];
	      arrayRowsTravelFirst(function (val, index) {
	        dimensionsDefine[index] = val != null ? val : '';
	      }, seriesLayoutBy, data);
	    }
	
	    dimensionsDetectCount = dimensionsDefine ? dimensionsDefine.length : seriesLayoutBy === SERIES_LAYOUT_BY_ROW ? data.length : data[0] ? data[0].length : null;
	  } else if (sourceFormat === SOURCE_FORMAT_OBJECT_ROWS) {
	    if (!dimensionsDefine) {
	      dimensionsDefine = objectRowsCollectDimensions(data);
	    }
	  } else if (sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS) {
	    if (!dimensionsDefine) {
	      dimensionsDefine = [];
	      each(data, function (colArr, key) {
	        dimensionsDefine.push(key);
	      });
	    }
	  } else if (sourceFormat === SOURCE_FORMAT_ORIGINAL) {
	    var value0 = getDataItemValue(data[0]);
	    dimensionsDetectCount = isArray(value0) && value0.length || 1;
	  } else if (sourceFormat === SOURCE_FORMAT_TYPED_ARRAY) {}
	
	  return {
	    startIndex: startIndex,
	    dimensionsDefine: normalizeDimensionsDefine(dimensionsDefine),
	    dimensionsDetectCount: dimensionsDetectCount
	  };
	} // Consider dimensions defined like ['A', 'price', 'B', 'price', 'C', 'price'],
	// which is reasonable. But dimension name is duplicated.
	// Returns undefined or an array contains only object without null/undefiend or string.
	
	
	function normalizeDimensionsDefine(dimensionsDefine) {
	  if (!dimensionsDefine) {
	    // The meaning of null/undefined is different from empty array.
	    return;
	  }
	
	  var nameMap = createHashMap();
	  return map(dimensionsDefine, function (item, index) {
	    item = extend({}, isObject(item) ? item : {
	      name: item
	    }); // User can set null in dimensions.
	    // We dont auto specify name, othewise a given name may
	    // cause it be refered unexpectedly.
	
	    if (item.name == null) {
	      return item;
	    } // Also consider number form like 2012.
	
	
	    item.name += ''; // User may also specify displayName.
	    // displayName will always exists except user not
	    // specified or dim name is not specified or detected.
	    // (A auto generated dim name will not be used as
	    // displayName).
	
	    if (item.displayName == null) {
	      item.displayName = item.name;
	    }
	
	    var exist = nameMap.get(item.name);
	
	    if (!exist) {
	      nameMap.set(item.name, {
	        count: 1
	      });
	    } else {
	      item.name += '-' + exist.count++;
	    }
	
	    return item;
	  });
	}
	
	function arrayRowsTravelFirst(cb, seriesLayoutBy, data, maxLoop) {
	  maxLoop == null && (maxLoop = Infinity);
	
	  if (seriesLayoutBy === SERIES_LAYOUT_BY_ROW) {
	    for (var i = 0; i < data.length && i < maxLoop; i++) {
	      cb(data[i] ? data[i][0] : null, i);
	    }
	  } else {
	    var value0 = data[0] || [];
	
	    for (var i = 0; i < value0.length && i < maxLoop; i++) {
	      cb(value0[i], i);
	    }
	  }
	}
	
	function objectRowsCollectDimensions(data) {
	  var firstIndex = 0;
	  var obj;
	
	  while (firstIndex < data.length && !(obj = data[firstIndex++])) {} // jshint ignore: line
	
	
	  if (obj) {
	    var dimensions = [];
	    each(obj, function (value, key) {
	      dimensions.push(key);
	    });
	    return dimensions;
	  }
	}
	/**
	 * [The strategy of the arrengment of data dimensions for dataset]:
	 * "value way": all axes are non-category axes. So series one by one take
	 *     several (the number is coordSysDims.length) dimensions from dataset.
	 *     The result of data arrengment of data dimensions like:
	 *     | ser0_x | ser0_y | ser1_x | ser1_y | ser2_x | ser2_y |
	 * "category way": at least one axis is category axis. So the the first data
	 *     dimension is always mapped to the first category axis and shared by
	 *     all of the series. The other data dimensions are taken by series like
	 *     "value way" does.
	 *     The result of data arrengment of data dimensions like:
	 *     | ser_shared_x | ser0_y | ser1_y | ser2_y |
	 *
	 * @param {Array.<Object|string>} coordDimensions [{name: <string>, type: <string>, dimsDef: <Array>}, ...]
	 * @param {module:model/Series} seriesModel
	 * @param {module:data/Source} source
	 * @return {Object} encode Never be `null/undefined`.
	 */
	
	
	function makeSeriesEncodeForAxisCoordSys(coordDimensions, seriesModel, source) {
	  var encode = {};
	  var datasetModel = getDatasetModel(seriesModel); // Currently only make default when using dataset, util more reqirements occur.
	
	  if (!datasetModel || !coordDimensions) {
	    return encode;
	  }
	
	  var encodeItemName = [];
	  var encodeSeriesName = [];
	  var ecModel = seriesModel.ecModel;
	  var datasetMap = inner(ecModel).datasetMap;
	  var key = datasetModel.uid + '_' + source.seriesLayoutBy;
	  var baseCategoryDimIndex;
	  var categoryWayValueDimStart;
	  coordDimensions = coordDimensions.slice();
	  each(coordDimensions, function (coordDimInfo, coordDimIdx) {
	    !isObject(coordDimInfo) && (coordDimensions[coordDimIdx] = {
	      name: coordDimInfo
	    });
	
	    if (coordDimInfo.type === 'ordinal' && baseCategoryDimIndex == null) {
	      baseCategoryDimIndex = coordDimIdx;
	      categoryWayValueDimStart = getDataDimCountOnCoordDim(coordDimensions[coordDimIdx]);
	    }
	
	    encode[coordDimInfo.name] = [];
	  });
	  var datasetRecord = datasetMap.get(key) || datasetMap.set(key, {
	    categoryWayDim: categoryWayValueDimStart,
	    valueWayDim: 0
	  }); // TODO
	  // Auto detect first time axis and do arrangement.
	
	  each(coordDimensions, function (coordDimInfo, coordDimIdx) {
	    var coordDimName = coordDimInfo.name;
	    var count = getDataDimCountOnCoordDim(coordDimInfo); // In value way.
	
	    if (baseCategoryDimIndex == null) {
	      var start = datasetRecord.valueWayDim;
	      pushDim(encode[coordDimName], start, count);
	      pushDim(encodeSeriesName, start, count);
	      datasetRecord.valueWayDim += count; // ??? TODO give a better default series name rule?
	      // especially when encode x y specified.
	      // consider: when mutiple series share one dimension
	      // category axis, series name should better use
	      // the other dimsion name. On the other hand, use
	      // both dimensions name.
	    } // In category way, the first category axis.
	    else if (baseCategoryDimIndex === coordDimIdx) {
	        pushDim(encode[coordDimName], 0, count);
	        pushDim(encodeItemName, 0, count);
	      } // In category way, the other axis.
	      else {
	          var start = datasetRecord.categoryWayDim;
	          pushDim(encode[coordDimName], start, count);
	          pushDim(encodeSeriesName, start, count);
	          datasetRecord.categoryWayDim += count;
	        }
	  });
	
	  function pushDim(dimIdxArr, idxFrom, idxCount) {
	    for (var i = 0; i < idxCount; i++) {
	      dimIdxArr.push(idxFrom + i);
	    }
	  }
	
	  function getDataDimCountOnCoordDim(coordDimInfo) {
	    var dimsDef = coordDimInfo.dimsDef;
	    return dimsDef ? dimsDef.length : 1;
	  }
	
	  encodeItemName.length && (encode.itemName = encodeItemName);
	  encodeSeriesName.length && (encode.seriesName = encodeSeriesName);
	  return encode;
	}
	/**
	 * Work for data like [{name: ..., value: ...}, ...].
	 *
	 * @param {module:model/Series} seriesModel
	 * @param {module:data/Source} source
	 * @return {Object} encode Never be `null/undefined`.
	 */
	
	
	function makeSeriesEncodeForNameBased(seriesModel, source, dimCount) {
	  var encode = {};
	  var datasetModel = getDatasetModel(seriesModel); // Currently only make default when using dataset, util more reqirements occur.
	
	  if (!datasetModel) {
	    return encode;
	  }
	
	  var sourceFormat = source.sourceFormat;
	  var dimensionsDefine = source.dimensionsDefine;
	  var potentialNameDimIndex;
	
	  if (sourceFormat === SOURCE_FORMAT_OBJECT_ROWS || sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS) {
	    each(dimensionsDefine, function (dim, idx) {
	      if ((isObject(dim) ? dim.name : dim) === 'name') {
	        potentialNameDimIndex = idx;
	      }
	    });
	  } // idxResult: {v, n}.
	
	
	  var idxResult = function () {
	    var idxRes0 = {};
	    var idxRes1 = {};
	    var guessRecords = []; // 5 is an experience value.
	
	    for (var i = 0, len = Math.min(5, dimCount); i < len; i++) {
	      var guessResult = doGuessOrdinal(source.data, sourceFormat, source.seriesLayoutBy, dimensionsDefine, source.startIndex, i);
	      guessRecords.push(guessResult);
	      var isPureNumber = guessResult === BE_ORDINAL.Not; // [Strategy of idxRes0]: find the first BE_ORDINAL.Not as the value dim,
	      // and then find a name dim with the priority:
	      // "BE_ORDINAL.Might|BE_ORDINAL.Must" > "other dim" > "the value dim itself".
	
	      if (isPureNumber && idxRes0.v == null && i !== potentialNameDimIndex) {
	        idxRes0.v = i;
	      }
	
	      if (idxRes0.n == null || idxRes0.n === idxRes0.v || !isPureNumber && guessRecords[idxRes0.n] === BE_ORDINAL.Not) {
	        idxRes0.n = i;
	      }
	
	      if (fulfilled(idxRes0) && guessRecords[idxRes0.n] !== BE_ORDINAL.Not) {
	        return idxRes0;
	      } // [Strategy of idxRes1]: if idxRes0 not satisfied (that is, no BE_ORDINAL.Not),
	      // find the first BE_ORDINAL.Might as the value dim,
	      // and then find a name dim with the priority:
	      // "other dim" > "the value dim itself".
	      // That is for backward compat: number-like (e.g., `'3'`, `'55'`) can be
	      // treated as number.
	
	
	      if (!isPureNumber) {
	        if (guessResult === BE_ORDINAL.Might && idxRes1.v == null && i !== potentialNameDimIndex) {
	          idxRes1.v = i;
	        }
	
	        if (idxRes1.n == null || idxRes1.n === idxRes1.v) {
	          idxRes1.n = i;
	        }
	      }
	    }
	
	    function fulfilled(idxResult) {
	      return idxResult.v != null && idxResult.n != null;
	    }
	
	    return fulfilled(idxRes0) ? idxRes0 : fulfilled(idxRes1) ? idxRes1 : null;
	  }();
	
	  if (idxResult) {
	    encode.value = idxResult.v; // `potentialNameDimIndex` has highest priority.
	
	    var nameDimIndex = potentialNameDimIndex != null ? potentialNameDimIndex : idxResult.n; // By default, label use itemName in charts.
	    // So we dont set encodeLabel here.
	
	    encode.itemName = [nameDimIndex];
	    encode.seriesName = [nameDimIndex];
	  }
	
	  return encode;
	}
	/**
	 * If return null/undefined, indicate that should not use datasetModel.
	 */
	
	
	function getDatasetModel(seriesModel) {
	  var option = seriesModel.option; // Caution: consider the scenario:
	  // A dataset is declared and a series is not expected to use the dataset,
	  // and at the beginning `setOption({series: { noData })` (just prepare other
	  // option but no data), then `setOption({series: {data: [...]}); In this case,
	  // the user should set an empty array to avoid that dataset is used by default.
	
	  var thisData = option.data;
	
	  if (!thisData) {
	    return seriesModel.ecModel.getComponent('dataset', option.datasetIndex || 0);
	  }
	}
	/**
	 * The rule should not be complex, otherwise user might not
	 * be able to known where the data is wrong.
	 * The code is ugly, but how to make it neat?
	 *
	 * @param {module:echars/data/Source} source
	 * @param {number} dimIndex
	 * @return {BE_ORDINAL} guess result.
	 */
	
	
	function guessOrdinal(source, dimIndex) {
	  return doGuessOrdinal(source.data, source.sourceFormat, source.seriesLayoutBy, source.dimensionsDefine, source.startIndex, dimIndex);
	} // dimIndex may be overflow source data.
	// return {BE_ORDINAL}
	
	
	function doGuessOrdinal(data, sourceFormat, seriesLayoutBy, dimensionsDefine, startIndex, dimIndex) {
	  var result; // Experience value.
	
	  var maxLoop = 5;
	
	  if (isTypedArray(data)) {
	    return BE_ORDINAL.Not;
	  } // When sourceType is 'objectRows' or 'keyedColumns', dimensionsDefine
	  // always exists in source.
	
	
	  var dimName;
	  var dimType;
	
	  if (dimensionsDefine) {
	    var dimDefItem = dimensionsDefine[dimIndex];
	
	    if (isObject(dimDefItem)) {
	      dimName = dimDefItem.name;
	      dimType = dimDefItem.type;
	    } else if (isString(dimDefItem)) {
	      dimName = dimDefItem;
	    }
	  }
	
	  if (dimType != null) {
	    return dimType === 'ordinal' ? BE_ORDINAL.Must : BE_ORDINAL.Not;
	  }
	
	  if (sourceFormat === SOURCE_FORMAT_ARRAY_ROWS) {
	    if (seriesLayoutBy === SERIES_LAYOUT_BY_ROW) {
	      var sample = data[dimIndex];
	
	      for (var i = 0; i < (sample || []).length && i < maxLoop; i++) {
	        if ((result = detectValue(sample[startIndex + i])) != null) {
	          return result;
	        }
	      }
	    } else {
	      for (var i = 0; i < data.length && i < maxLoop; i++) {
	        var row = data[startIndex + i];
	
	        if (row && (result = detectValue(row[dimIndex])) != null) {
	          return result;
	        }
	      }
	    }
	  } else if (sourceFormat === SOURCE_FORMAT_OBJECT_ROWS) {
	    if (!dimName) {
	      return BE_ORDINAL.Not;
	    }
	
	    for (var i = 0; i < data.length && i < maxLoop; i++) {
	      var item = data[i];
	
	      if (item && (result = detectValue(item[dimName])) != null) {
	        return result;
	      }
	    }
	  } else if (sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS) {
	    if (!dimName) {
	      return BE_ORDINAL.Not;
	    }
	
	    var sample = data[dimName];
	
	    if (!sample || isTypedArray(sample)) {
	      return BE_ORDINAL.Not;
	    }
	
	    for (var i = 0; i < sample.length && i < maxLoop; i++) {
	      if ((result = detectValue(sample[i])) != null) {
	        return result;
	      }
	    }
	  } else if (sourceFormat === SOURCE_FORMAT_ORIGINAL) {
	    for (var i = 0; i < data.length && i < maxLoop; i++) {
	      var item = data[i];
	      var val = getDataItemValue(item);
	
	      if (!isArray(val)) {
	        return BE_ORDINAL.Not;
	      }
	
	      if ((result = detectValue(val[dimIndex])) != null) {
	        return result;
	      }
	    }
	  }
	
	  function detectValue(val) {
	    var beStr = isString(val); // Consider usage convenience, '1', '2' will be treated as "number".
	    // `isFinit('')` get `true`.
	
	    if (val != null && isFinite(val) && val !== '') {
	      return beStr ? BE_ORDINAL.Might : BE_ORDINAL.Not;
	    } else if (beStr && val !== '-') {
	      return BE_ORDINAL.Must;
	    }
	  }
	
	  return BE_ORDINAL.Not;
	}
	
	exports.BE_ORDINAL = BE_ORDINAL;
	exports.detectSourceFormat = detectSourceFormat;
	exports.getSource = getSource;
	exports.resetSourceDefaulter = resetSourceDefaulter;
	exports.prepareSource = prepareSource;
	exports.makeSeriesEncodeForAxisCoordSys = makeSeriesEncodeForAxisCoordSys;
	exports.makeSeriesEncodeForNameBased = makeSeriesEncodeForNameBased;
	exports.guessOrdinal = guessOrdinal;

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var TYPE_DELIMITER = '.';
	var IS_CONTAINER = '___EC__COMPONENT__CONTAINER___';
	/**
	 * Notice, parseClassType('') should returns {main: '', sub: ''}
	 * @public
	 */
	
	function parseClassType(componentType) {
	  var ret = {
	    main: '',
	    sub: ''
	  };
	
	  if (componentType) {
	    componentType = componentType.split(TYPE_DELIMITER);
	    ret.main = componentType[0] || '';
	    ret.sub = componentType[1] || '';
	  }
	
	  return ret;
	}
	/**
	 * @public
	 */
	
	
	function checkClassType(componentType) {
	  zrUtil.assert(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(componentType), 'componentType "' + componentType + '" illegal');
	}
	/**
	 * @public
	 */
	
	
	function enableClassExtend(RootClass, mandatoryMethods) {
	  RootClass.$constructor = RootClass;
	
	  RootClass.extend = function (proto) {
	    var superClass = this;
	
	    var ExtendedClass = function () {
	      if (!proto.$constructor) {
	        superClass.apply(this, arguments);
	      } else {
	        proto.$constructor.apply(this, arguments);
	      }
	    };
	
	    zrUtil.extend(ExtendedClass.prototype, proto);
	    ExtendedClass.extend = this.extend;
	    ExtendedClass.superCall = superCall;
	    ExtendedClass.superApply = superApply;
	    zrUtil.inherits(ExtendedClass, this);
	    ExtendedClass.superClass = superClass;
	    return ExtendedClass;
	  };
	}
	
	var classBase = 0;
	/**
	 * Can not use instanceof, consider different scope by
	 * cross domain or es module import in ec extensions.
	 * Mount a method "isInstance()" to Clz.
	 */
	
	function enableClassCheck(Clz) {
	  var classAttr = ['__\0is_clz', classBase++, Math.random().toFixed(3)].join('_');
	  Clz.prototype[classAttr] = true;
	
	  Clz.isInstance = function (obj) {
	    return !!(obj && obj[classAttr]);
	  };
	} // superCall should have class info, which can not be fetch from 'this'.
	// Consider this case:
	// class A has method f,
	// class B inherits class A, overrides method f, f call superApply('f'),
	// class C inherits class B, do not overrides method f,
	// then when method of class C is called, dead loop occured.
	
	
	function superCall(context, methodName) {
	  var args = zrUtil.slice(arguments, 2);
	  return this.superClass.prototype[methodName].apply(context, args);
	}
	
	function superApply(context, methodName, args) {
	  return this.superClass.prototype[methodName].apply(context, args);
	}
	/**
	 * @param {Object} entity
	 * @param {Object} options
	 * @param {boolean} [options.registerWhenExtend]
	 * @public
	 */
	
	
	function enableClassManagement(entity, options) {
	  options = options || {};
	  /**
	   * Component model classes
	   * key: componentType,
	   * value:
	   *     componentClass, when componentType is 'xxx'
	   *     or Object.<subKey, componentClass>, when componentType is 'xxx.yy'
	   * @type {Object}
	   */
	
	  var storage = {};
	
	  entity.registerClass = function (Clazz, componentType) {
	    if (componentType) {
	      checkClassType(componentType);
	      componentType = parseClassType(componentType);
	
	      if (!componentType.sub) {
	        storage[componentType.main] = Clazz;
	      } else if (componentType.sub !== IS_CONTAINER) {
	        var container = makeContainer(componentType);
	        container[componentType.sub] = Clazz;
	      }
	    }
	
	    return Clazz;
	  };
	
	  entity.getClass = function (componentMainType, subType, throwWhenNotFound) {
	    var Clazz = storage[componentMainType];
	
	    if (Clazz && Clazz[IS_CONTAINER]) {
	      Clazz = subType ? Clazz[subType] : null;
	    }
	
	    if (throwWhenNotFound && !Clazz) {
	      throw new Error(!subType ? componentMainType + '.' + 'type should be specified.' : 'Component ' + componentMainType + '.' + (subType || '') + ' not exists. Load it first.');
	    }
	
	    return Clazz;
	  };
	
	  entity.getClassesByMainType = function (componentType) {
	    componentType = parseClassType(componentType);
	    var result = [];
	    var obj = storage[componentType.main];
	
	    if (obj && obj[IS_CONTAINER]) {
	      zrUtil.each(obj, function (o, type) {
	        type !== IS_CONTAINER && result.push(o);
	      });
	    } else {
	      result.push(obj);
	    }
	
	    return result;
	  };
	
	  entity.hasClass = function (componentType) {
	    // Just consider componentType.main.
	    componentType = parseClassType(componentType);
	    return !!storage[componentType.main];
	  };
	  /**
	   * @return {Array.<string>} Like ['aa', 'bb'], but can not be ['aa.xx']
	   */
	
	
	  entity.getAllClassMainTypes = function () {
	    var types = [];
	    zrUtil.each(storage, function (obj, type) {
	      types.push(type);
	    });
	    return types;
	  };
	  /**
	   * If a main type is container and has sub types
	   * @param  {string}  mainType
	   * @return {boolean}
	   */
	
	
	  entity.hasSubTypes = function (componentType) {
	    componentType = parseClassType(componentType);
	    var obj = storage[componentType.main];
	    return obj && obj[IS_CONTAINER];
	  };
	
	  entity.parseClassType = parseClassType;
	
	  function makeContainer(componentType) {
	    var container = storage[componentType.main];
	
	    if (!container || !container[IS_CONTAINER]) {
	      container = storage[componentType.main] = {};
	      container[IS_CONTAINER] = true;
	    }
	
	    return container;
	  }
	
	  if (options.registerWhenExtend) {
	    var originalExtend = entity.extend;
	
	    if (originalExtend) {
	      entity.extend = function (proto) {
	        var ExtendedClass = originalExtend.call(this, proto);
	        return entity.registerClass(ExtendedClass, proto.type);
	      };
	    }
	  }
	
	  return entity;
	}
	/**
	 * @param {string|Array.<string>} properties
	 */
	
	
	function setReadOnly(obj, properties) {// FIXME It seems broken in IE8 simulation of IE11
	  // if (!zrUtil.isArray(properties)) {
	  //     properties = properties != null ? [properties] : [];
	  // }
	  // zrUtil.each(properties, function (prop) {
	  //     var value = obj[prop];
	  //     Object.defineProperty
	  //         && Object.defineProperty(obj, prop, {
	  //             value: value, writable: false
	  //         });
	  //     zrUtil.isArray(obj[prop])
	  //         && Object.freeze
	  //         && Object.freeze(obj[prop]);
	  // });
	}
	
	exports.parseClassType = parseClassType;
	exports.enableClassExtend = enableClassExtend;
	exports.enableClassCheck = enableClassCheck;
	exports.enableClassManagement = enableClassManagement;
	exports.setReadOnly = setReadOnly;

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(795);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(175),
	    getPrototype = __webpack_require__(1830),
	    isObjectLike = __webpack_require__(146);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(32);
	
	var PooledClass = __webpack_require__(178);
	
	var emptyFunction = __webpack_require__(107);
	var warning = __webpack_require__(34);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 128 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 129 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.title = obj.title;
		this.pic = obj.pic;
		this.layers = obj.layers;
		this.siteTypes = obj.siteTypes;
		this.masterTheme = obj.masterTheme;
		this.color = obj.color;
		this.disable = obj.disable;
	};
	
	exports.default = _class;

/***/ },
/* 130 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.filter = obj.filter;
	};
	
	exports.default = _class;

/***/ },
/* 131 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var getPlurial = function getPlurial(i18nSingular, i18nPlurial, data) {
		if (data && (data.length > 1 || data > 1)) {
			return i18nPlurial;
		}
		return i18nSingular;
	};
	var getPlurialWithNumber = function getPlurialWithNumber(i18nSingular, i18nPlurial, number) {
		return number > 1 ? i18nPlurial : i18nSingular;
	};
	
	var substringText = function substringText(text) {
		var shortNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
	
		if (text) {
			if (text.length > shortNumber) {
				return text.substring(text, shortNumber) + '...';
			}
			return text;
		}
		return '';
	};
	
	var substringNumber = function substringNumber(number) {
		var fixed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
	
		if (number) {
			if (Number(number).toString().length > fixed) {
				return number.toFixed(fixed);
			}
			return number;
		}
		return '';
	};
	
	exports.getPlurial = getPlurial;
	exports.getPlurialWithNumber = getPlurialWithNumber;
	exports.substringText = substringText;
	exports.substringNumber = substringNumber;

/***/ },
/* 132 */
108,
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useControlled;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */
	function useControlled(_ref) {
	  var controlled = _ref.controlled,
	      defaultProp = _ref.default,
	      name = _ref.name,
	      _ref$state = _ref.state,
	      state = _ref$state === void 0 ? 'value' : _ref$state;
	
	  var _React$useRef = React.useRef(controlled !== undefined),
	      isControlled = _React$useRef.current;
	
	  var _React$useState = React.useState(defaultProp),
	      valueState = _React$useState[0],
	      setValue = _React$useState[1];
	
	  var value = isControlled ? controlled : valueState;
	
	  if (false) {
	    React.useEffect(function () {
	      if (isControlled !== (controlled !== undefined)) {
	        console.error(["Material-UI: A component is changing the ".concat(isControlled ? '' : 'un', "controlled ").concat(state, " state of ").concat(name, " to be ").concat(isControlled ? 'un' : '', "controlled."), 'Elements should not switch from uncontrolled to controlled (or vice versa).', "Decide between using a controlled or uncontrolled ".concat(name, " ") + 'element for the lifetime of the component.', "The nature of the state is determined during the first render, it's considered controlled if the value is not `undefined`.", 'More info: https://fb.me/react-controlled-components'].join('\n'));
	      }
	    }, [controlled]);
	
	    var _React$useRef2 = React.useRef(defaultProp),
	        defaultValue = _React$useRef2.current;
	
	    React.useEffect(function () {
	      if (!isControlled && defaultValue !== defaultProp) {
	        console.error(["Material-UI: A component is changing the default ".concat(state, " state of an uncontrolled ").concat(name, " after being initialized. ") + "To suppress this warning opt to use a controlled ".concat(name, ".")].join('\n'));
	      }
	    }, [JSON.stringify(defaultProp)]);
	  }
	
	  var setValueIfUncontrolled = React.useCallback(function (newValue) {
	    if (!isControlled) {
	      setValue(newValue);
	    }
	  }, []);
	  return [value, setValueIfUncontrolled];
	}

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var componentAnnotations_1 = __webpack_require__(39);
	var optionsFactory_1 = __webpack_require__(648);
	var providedFilter_1 = __webpack_require__(317);
	var utils_1 = __webpack_require__(10);
	var ConditionPosition;
	(function (ConditionPosition) {
	    ConditionPosition[ConditionPosition["One"] = 0] = "One";
	    ConditionPosition[ConditionPosition["Two"] = 1] = "Two";
	})(ConditionPosition = exports.ConditionPosition || (exports.ConditionPosition = {}));
	var DEFAULT_TRANSLATIONS = {
	    loadingOoo: 'Loading...',
	    empty: 'Choose One',
	    equals: 'Equals',
	    notEqual: 'Not equal',
	    lessThan: 'Less than',
	    greaterThan: 'Greater than',
	    inRange: 'In range',
	    lessThanOrEqual: 'Less than or equals',
	    greaterThanOrEqual: 'Greater than or equals',
	    filterOoo: 'Filter...',
	    contains: 'Contains',
	    notContains: 'Not contains',
	    startsWith: 'Starts with',
	    endsWith: 'Ends with',
	    searchOoo: 'Search...',
	    selectAll: 'Select All',
	    applyFilter: 'Apply Filter',
	    clearFilter: 'Clear Filter',
	    andCondition: 'AND',
	    orCondition: 'OR'
	};
	/**
	 * Every filter with a dropdown where the user can specify a comparing type against the filter values
	 */
	var SimpleFilter = /** @class */ (function (_super) {
	    __extends(SimpleFilter, _super);
	    function SimpleFilter() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    // returns true if this type requires a 'from' field, eg any filter that requires at least one text value
	    SimpleFilter.prototype.showValueFrom = function (type) {
	        return !this.doesFilterHaveHiddenInput(type) && type !== SimpleFilter.EMPTY;
	    };
	    // returns true if this type requires a 'to' field, currently only 'range' returns true
	    SimpleFilter.prototype.showValueTo = function (type) {
	        return type === SimpleFilter.IN_RANGE;
	    };
	    // floating filter calls this when user applies filter from floating filter
	    SimpleFilter.prototype.onFloatingFilterChanged = function (type, value) {
	        this.setValueFromFloatingFilter(value);
	        this.setTypeFromFloatingFilter(type);
	        this.onUiChanged(true);
	    };
	    SimpleFilter.prototype.setTypeFromFloatingFilter = function (type) {
	        this.eType1.value = type;
	        this.eType2.value = null;
	        this.eJoinOperatorAnd.checked = true;
	    };
	    SimpleFilter.prototype.getModelFromUi = function () {
	        if (!this.isConditionUiComplete(ConditionPosition.One)) {
	            return null;
	        }
	        if (this.isAllowTwoConditions() && this.isConditionUiComplete(ConditionPosition.Two)) {
	            var res = {
	                filterType: this.getFilterType(),
	                operator: this.getJoinOperator(),
	                condition1: this.createCondition(ConditionPosition.One),
	                condition2: this.createCondition(ConditionPosition.Two)
	            };
	            return res;
	        }
	        else {
	            var res = this.createCondition(ConditionPosition.One);
	            return res;
	        }
	    };
	    SimpleFilter.prototype.getCondition1Type = function () {
	        return this.eType1.value;
	    };
	    SimpleFilter.prototype.getCondition2Type = function () {
	        return this.eType2.value;
	    };
	    SimpleFilter.prototype.getJoinOperator = function () {
	        return this.eJoinOperatorOr.checked ? 'OR' : 'AND';
	    };
	    SimpleFilter.prototype.areModelsEqual = function (a, b) {
	        // both are missing
	        if (!a && !b) {
	            return true;
	        }
	        // one is missing, other present
	        if ((!a && b) || (a && !b)) {
	            return false;
	        }
	        // one is combined, the other is not
	        var aIsSimple = !a.operator;
	        var bIsSimple = !b.operator;
	        var oneSimpleOneCombined = (!aIsSimple && bIsSimple) || (aIsSimple && !bIsSimple);
	        if (oneSimpleOneCombined) {
	            return false;
	        }
	        var res;
	        // otherwise both present, so compare
	        if (aIsSimple) {
	            var aSimple = a;
	            var bSimple = b;
	            res = this.areSimpleModelsEqual(aSimple, bSimple);
	        }
	        else {
	            var aCombined = a;
	            var bCombined = b;
	            res = aCombined.operator === bCombined.operator
	                && this.areSimpleModelsEqual(aCombined.condition1, bCombined.condition1)
	                && this.areSimpleModelsEqual(aCombined.condition2, bCombined.condition2);
	        }
	        return res;
	    };
	    SimpleFilter.prototype.setModelIntoUi = function (model) {
	        var isCombined = model.operator;
	        if (isCombined) {
	            var combinedModel = model;
	            var orChecked = combinedModel.operator === 'OR';
	            this.eJoinOperatorAnd.checked = !orChecked;
	            this.eJoinOperatorOr.checked = orChecked;
	            this.eType1.value = combinedModel.condition1.type;
	            this.eType2.value = combinedModel.condition2.type;
	            this.setConditionIntoUi(combinedModel.condition1, ConditionPosition.One);
	            this.setConditionIntoUi(combinedModel.condition2, ConditionPosition.Two);
	        }
	        else {
	            var simpleModel = model;
	            this.eJoinOperatorAnd.checked = true;
	            this.eJoinOperatorOr.checked = false;
	            this.eType1.value = simpleModel.type;
	            this.eType2.value = this.optionsFactory.getDefaultOption();
	            this.setConditionIntoUi(simpleModel, ConditionPosition.One);
	            this.setConditionIntoUi(null, ConditionPosition.Two);
	        }
	    };
	    SimpleFilter.prototype.doesFilterPass = function (params) {
	        var model = this.getModel();
	        var isCombined = model.operator;
	        if (isCombined) {
	            var combinedModel = model;
	            var firstResult = this.individualConditionPasses(params, combinedModel.condition1);
	            var secondResult = this.individualConditionPasses(params, combinedModel.condition2);
	            if (combinedModel.operator === 'AND') {
	                return firstResult && secondResult;
	            }
	            else {
	                return firstResult || secondResult;
	            }
	        }
	        else {
	            var simpleModel = model;
	            var result = this.individualConditionPasses(params, simpleModel);
	            return result;
	        }
	    };
	    SimpleFilter.prototype.setParams = function (params) {
	        _super.prototype.setParams.call(this, params);
	        this.simpleFilterParams = params;
	        this.optionsFactory = new optionsFactory_1.OptionsFactory();
	        this.optionsFactory.init(params, this.getDefaultFilterOptions());
	        this.allowTwoConditions = !params.suppressAndOrCondition;
	        this.putOptionsIntoDropdown();
	        this.addChangedListeners();
	    };
	    SimpleFilter.prototype.putOptionsIntoDropdown = function () {
	        var _this = this;
	        var filterOptions = this.optionsFactory.getFilterOptions();
	        filterOptions.forEach(function (option) {
	            var createOption = function () {
	                var key = (typeof option === 'string') ? option : option.displayKey;
	                var localName = _this.translate(key);
	                var eOption = document.createElement("option");
	                eOption.text = localName;
	                eOption.value = key;
	                return eOption;
	            };
	            _this.eType1.add(createOption());
	            _this.eType2.add(createOption());
	        });
	        var readOnly = filterOptions.length <= 1;
	        this.eType1.disabled = readOnly;
	        this.eType2.disabled = readOnly;
	    };
	    SimpleFilter.prototype.isAllowTwoConditions = function () {
	        return this.allowTwoConditions;
	    };
	    SimpleFilter.prototype.createBodyTemplate = function () {
	        var optionsTemplate1 = "<select class=\"ag-filter-select\" ref=\"eOptions1\"></select>";
	        var valueTemplate1 = this.createValueTemplate(ConditionPosition.One);
	        var optionsTemplate2 = "<select class=\"ag-filter-select\" ref=\"eOptions2\"></select>";
	        var valueTemplate2 = this.createValueTemplate(ConditionPosition.Two);
	        var uniqueGroupId = 'ag-simple-filter-and-or-' + this.getCompId();
	        var translate = this.gridOptionsWrapper.getLocaleTextFunc();
	        var andOrTemplate = "<div class=\"ag-filter-condition\" ref=\"eJoinOperatorPanel\">\n                    <label>\n                        <input ref=\"eJoinOperatorAnd\" type=\"radio\" class=\"and\" name=\"" + uniqueGroupId + "\" value=\"AND\")} checked=\"checked\" />\n                        " + translate('andCondition', 'AND') + "\n                    </label>\n                    <label>\n                        <input ref=\"eJoinOperatorOr\" type=\"radio\" class=\"or\" name=\"" + uniqueGroupId + "\" value=\"OR\" />\n                        " + translate('orCondition', 'OR') + "\n                    </label>\n                </div>";
	        var template = optionsTemplate1 + "\n                " + valueTemplate1 + "\n                " + andOrTemplate + "\n                " + optionsTemplate2 + "\n                " + valueTemplate2;
	        return template;
	    };
	    SimpleFilter.prototype.updateUiVisibility = function () {
	        var firstConditionComplete = this.isConditionUiComplete(ConditionPosition.One);
	        var showSecondFilter = this.allowTwoConditions && firstConditionComplete;
	        utils_1._.setDisplayed(this.eCondition2Body, showSecondFilter);
	        utils_1._.setDisplayed(this.eType2, showSecondFilter);
	        utils_1._.setDisplayed(this.eJoinOperatorPanel, showSecondFilter);
	    };
	    SimpleFilter.prototype.resetUiToDefaults = function () {
	        this.eJoinOperatorAnd.checked = true;
	        var defaultOption = this.optionsFactory.getDefaultOption();
	        this.eType1.value = defaultOption;
	        this.eType2.value = defaultOption;
	    };
	    SimpleFilter.prototype.translate = function (toTranslate) {
	        var translate = this.gridOptionsWrapper.getLocaleTextFunc();
	        var defaultTranslation = DEFAULT_TRANSLATIONS[toTranslate];
	        if (!defaultTranslation && this.optionsFactory.getCustomOption(toTranslate)) {
	            defaultTranslation = this.optionsFactory.getCustomOption(toTranslate).displayName;
	        }
	        return translate(toTranslate, defaultTranslation);
	    };
	    SimpleFilter.prototype.addChangedListeners = function () {
	        var _this = this;
	        var listener = function () { return _this.onUiChanged(); };
	        this.addDestroyableEventListener(this.eType1, "change", listener);
	        this.addDestroyableEventListener(this.eType2, "change", listener);
	        this.addDestroyableEventListener(this.eJoinOperatorOr, "change", listener);
	        this.addDestroyableEventListener(this.eJoinOperatorAnd, "change", listener);
	    };
	    SimpleFilter.prototype.doesFilterHaveHiddenInput = function (filterType) {
	        var customFilterOption = this.optionsFactory.getCustomOption(filterType);
	        return customFilterOption && customFilterOption.hideFilterInput;
	    };
	    SimpleFilter.EMPTY = 'empty';
	    SimpleFilter.EQUALS = 'equals';
	    SimpleFilter.NOT_EQUAL = 'notEqual';
	    SimpleFilter.LESS_THAN = 'lessThan';
	    SimpleFilter.LESS_THAN_OR_EQUAL = 'lessThanOrEqual';
	    SimpleFilter.GREATER_THAN = 'greaterThan';
	    SimpleFilter.GREATER_THAN_OR_EQUAL = 'greaterThanOrEqual';
	    SimpleFilter.IN_RANGE = 'inRange';
	    SimpleFilter.CONTAINS = 'contains';
	    SimpleFilter.NOT_CONTAINS = 'notContains';
	    SimpleFilter.STARTS_WITH = 'startsWith';
	    SimpleFilter.ENDS_WITH = 'endsWith';
	    __decorate([
	        componentAnnotations_1.RefSelector('eOptions1'),
	        __metadata("design:type", HTMLSelectElement)
	    ], SimpleFilter.prototype, "eType1", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eOptions2'),
	        __metadata("design:type", HTMLSelectElement)
	    ], SimpleFilter.prototype, "eType2", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eJoinOperatorAnd'),
	        __metadata("design:type", HTMLInputElement)
	    ], SimpleFilter.prototype, "eJoinOperatorAnd", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eJoinOperatorOr'),
	        __metadata("design:type", HTMLInputElement)
	    ], SimpleFilter.prototype, "eJoinOperatorOr", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eCondition2Body'),
	        __metadata("design:type", HTMLElement)
	    ], SimpleFilter.prototype, "eCondition2Body", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eJoinOperatorPanel'),
	        __metadata("design:type", HTMLElement)
	    ], SimpleFilter.prototype, "eJoinOperatorPanel", void 0);
	    return SimpleFilter;
	}(providedFilter_1.ProvidedFilter));
	exports.SimpleFilter = SimpleFilter;


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var beanStub_1 = __webpack_require__(71);
	var eventService_1 = __webpack_require__(22);
	var events_1 = __webpack_require__(29);
	var context_1 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var selectionController_1 = __webpack_require__(102);
	var columnApi_1 = __webpack_require__(38);
	var gridApi_1 = __webpack_require__(33);
	var utils_1 = __webpack_require__(10);
	var PaginationProxy = /** @class */ (function (_super) {
	    __extends(PaginationProxy, _super);
	    function PaginationProxy() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.currentPage = 0;
	        _this.topDisplayedRowIndex = 0;
	        _this.bottomDisplayedRowIndex = 0;
	        _this.pixelOffset = 0;
	        _this.masterRowCount = 0;
	        return _this;
	    }
	    PaginationProxy.prototype.postConstruct = function () {
	        this.active = this.gridOptionsWrapper.isPagination();
	        this.paginateChildRows = this.gridOptionsWrapper.isPaginateChildRows();
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_MODEL_UPDATED, this.onModelUpdated.bind(this));
	        this.addDestroyableEventListener(this.gridOptionsWrapper, 'paginationPageSize', this.onModelUpdated.bind(this));
	        this.onModelUpdated();
	    };
	    PaginationProxy.prototype.ensureRowHeightsValid = function (startPixel, endPixel, startLimitIndex, endLimitIndex) {
	        var res = this.rowModel.ensureRowHeightsValid(startPixel, endPixel, this.getPageFirstRow(), this.getPageLastRow());
	        if (res) {
	            this.calculatePages();
	        }
	        return res;
	    };
	    PaginationProxy.prototype.onModelUpdated = function (modelUpdatedEvent) {
	        this.calculatePages();
	        var paginationChangedEvent = {
	            type: events_1.Events.EVENT_PAGINATION_CHANGED,
	            animate: modelUpdatedEvent ? modelUpdatedEvent.animate : false,
	            newData: modelUpdatedEvent ? modelUpdatedEvent.newData : false,
	            newPage: modelUpdatedEvent ? modelUpdatedEvent.newPage : false,
	            keepRenderedRows: modelUpdatedEvent ? modelUpdatedEvent.keepRenderedRows : false,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(paginationChangedEvent);
	    };
	    PaginationProxy.prototype.goToPage = function (page) {
	        if (!this.active) {
	            return;
	        }
	        if (this.currentPage === page) {
	            return;
	        }
	        this.currentPage = page;
	        var event = {
	            type: events_1.Events.EVENT_MODEL_UPDATED,
	            animate: false,
	            keepRenderedRows: false,
	            newData: false,
	            newPage: true,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.onModelUpdated(event);
	    };
	    PaginationProxy.prototype.getPixelOffset = function () {
	        return this.pixelOffset;
	    };
	    PaginationProxy.prototype.getRow = function (index) {
	        return this.rowModel.getRow(index);
	    };
	    PaginationProxy.prototype.getRowNode = function (id) {
	        return this.rowModel.getRowNode(id);
	    };
	    PaginationProxy.prototype.getRowIndexAtPixel = function (pixel) {
	        return this.rowModel.getRowIndexAtPixel(pixel);
	    };
	    PaginationProxy.prototype.getCurrentPageHeight = function () {
	        if (utils_1._.missing(this.topRowBounds) || utils_1._.missing(this.bottomRowBounds)) {
	            return 0;
	        }
	        return Math.max(this.bottomRowBounds.rowTop + this.bottomRowBounds.rowHeight - this.topRowBounds.rowTop, 0);
	    };
	    PaginationProxy.prototype.isRowPresent = function (rowNode) {
	        if (!this.rowModel.isRowPresent(rowNode)) {
	            return false;
	        }
	        var nodeIsInPage = rowNode.rowIndex >= this.topDisplayedRowIndex && rowNode.rowIndex <= this.bottomDisplayedRowIndex;
	        return nodeIsInPage;
	    };
	    PaginationProxy.prototype.isEmpty = function () {
	        return this.rowModel.isEmpty();
	    };
	    PaginationProxy.prototype.isRowsToRender = function () {
	        return this.rowModel.isRowsToRender();
	    };
	    PaginationProxy.prototype.getNodesInRangeForSelection = function (firstInRange, lastInRange) {
	        return this.rowModel.getNodesInRangeForSelection(firstInRange, lastInRange);
	    };
	    PaginationProxy.prototype.forEachNode = function (callback) {
	        return this.rowModel.forEachNode(callback);
	    };
	    PaginationProxy.prototype.getType = function () {
	        return this.rowModel.getType();
	    };
	    PaginationProxy.prototype.getRowBounds = function (index) {
	        var res = this.rowModel.getRowBounds(index);
	        res.rowIndex = index;
	        return res;
	    };
	    PaginationProxy.prototype.getPageFirstRow = function () {
	        return this.topRowBounds ? this.topRowBounds.rowIndex : -1;
	    };
	    PaginationProxy.prototype.getPageLastRow = function () {
	        return this.bottomRowBounds ? this.bottomRowBounds.rowIndex : -1;
	    };
	    PaginationProxy.prototype.getRowCount = function () {
	        return this.rowModel.getRowCount();
	    };
	    PaginationProxy.prototype.goToPageWithIndex = function (index) {
	        if (!this.active) {
	            return;
	        }
	        var pageNumber = Math.floor(index / this.pageSize);
	        this.goToPage(pageNumber);
	    };
	    PaginationProxy.prototype.isLastPageFound = function () {
	        return this.rowModel.isLastRowFound();
	    };
	    PaginationProxy.prototype.getCurrentPage = function () {
	        return this.currentPage;
	    };
	    PaginationProxy.prototype.goToNextPage = function () {
	        this.goToPage(this.currentPage + 1);
	    };
	    PaginationProxy.prototype.goToPreviousPage = function () {
	        this.goToPage(this.currentPage - 1);
	    };
	    PaginationProxy.prototype.goToFirstPage = function () {
	        this.goToPage(0);
	    };
	    PaginationProxy.prototype.goToLastPage = function () {
	        var rowCount = this.rowModel.getRowCount();
	        var lastPage = Math.floor(rowCount / this.pageSize);
	        this.goToPage(lastPage);
	    };
	    PaginationProxy.prototype.getPageSize = function () {
	        return this.pageSize;
	    };
	    PaginationProxy.prototype.getTotalPages = function () {
	        return this.totalPages;
	    };
	    PaginationProxy.prototype.setPageSize = function () {
	        // show put this into super class
	        this.pageSize = this.gridOptionsWrapper.getPaginationPageSize();
	        if (!(this.pageSize >= 1)) {
	            this.pageSize = 100;
	        }
	    };
	    PaginationProxy.prototype.calculatePages = function () {
	        if (this.active) {
	            this.setPageSize();
	            if (this.paginateChildRows) {
	                this.calculatePagesAllRows();
	            }
	            else {
	                this.calculatePagesMasterRowsOnly();
	            }
	        }
	        else {
	            this.calculatedPagesNotActive();
	        }
	        this.topRowBounds = this.rowModel.getRowBounds(this.topDisplayedRowIndex);
	        if (this.topRowBounds) {
	            this.topRowBounds.rowIndex = this.topDisplayedRowIndex;
	        }
	        this.bottomRowBounds = this.rowModel.getRowBounds(this.bottomDisplayedRowIndex);
	        if (this.bottomRowBounds) {
	            this.bottomRowBounds.rowIndex = this.bottomDisplayedRowIndex;
	        }
	        this.pixelOffset = utils_1._.exists(this.topRowBounds) ? this.topRowBounds.rowTop : 0;
	    };
	    PaginationProxy.prototype.setZeroRows = function () {
	        this.topDisplayedRowIndex = 0;
	        this.bottomDisplayedRowIndex = -1;
	        this.currentPage = 0;
	        this.totalPages = 0;
	    };
	    PaginationProxy.prototype.calculatePagesMasterRowsOnly = function () {
	        // const csrm = <ClientSideRowModel> this.rowModel;
	        // const rootNode = csrm.getRootNode();
	        // const masterRows = rootNode.childrenAfterSort;
	        this.masterRowCount = this.rowModel.getTopLevelRowCount();
	        if (this.masterRowCount === 0) {
	            this.setZeroRows();
	            return;
	        }
	        var masterLastRowIndex = this.masterRowCount - 1;
	        this.totalPages = Math.floor((masterLastRowIndex) / this.pageSize) + 1;
	        if (this.currentPage >= this.totalPages) {
	            this.currentPage = this.totalPages - 1;
	        }
	        if (!utils_1._.isNumeric(this.currentPage) || this.currentPage < 0) {
	            this.currentPage = 0;
	        }
	        var masterPageStartIndex = this.pageSize * this.currentPage;
	        var masterPageEndIndex = (this.pageSize * (this.currentPage + 1)) - 1;
	        if (masterPageEndIndex > masterLastRowIndex) {
	            masterPageEndIndex = masterLastRowIndex;
	        }
	        this.topDisplayedRowIndex = this.rowModel.getTopLevelRowDisplayedIndex(masterPageStartIndex);
	        // masterRows[masterPageStartIndex].rowIndex;
	        if (masterPageEndIndex === masterLastRowIndex) {
	            // if showing the last master row, then we want to show the very last row of the model
	            this.bottomDisplayedRowIndex = this.rowModel.getRowCount() - 1;
	        }
	        else {
	            var firstIndexNotToShow = this.rowModel.getTopLevelRowDisplayedIndex(masterPageEndIndex + 1);
	            //masterRows[masterPageEndIndex + 1].rowIndex;
	            // this gets the index of the last child - eg current row is open, we want to display all children,
	            // the index of the last child is one less than the index of the next parent row.
	            this.bottomDisplayedRowIndex = firstIndexNotToShow - 1;
	        }
	    };
	    PaginationProxy.prototype.getMasterRowCount = function () {
	        return this.masterRowCount;
	    };
	    PaginationProxy.prototype.calculatePagesAllRows = function () {
	        this.masterRowCount = this.rowModel.getRowCount();
	        if (this.masterRowCount === 0) {
	            this.setZeroRows();
	            return;
	        }
	        var maxRowIndex = this.masterRowCount - 1;
	        this.totalPages = Math.floor((maxRowIndex) / this.pageSize) + 1;
	        if (this.currentPage >= this.totalPages) {
	            this.currentPage = this.totalPages - 1;
	        }
	        if (!utils_1._.isNumeric(this.currentPage) || this.currentPage < 0) {
	            this.currentPage = 0;
	        }
	        this.topDisplayedRowIndex = this.pageSize * this.currentPage;
	        this.bottomDisplayedRowIndex = (this.pageSize * (this.currentPage + 1)) - 1;
	        if (this.bottomDisplayedRowIndex > maxRowIndex) {
	            this.bottomDisplayedRowIndex = maxRowIndex;
	        }
	    };
	    PaginationProxy.prototype.calculatedPagesNotActive = function () {
	        this.pageSize = this.rowModel.getRowCount();
	        this.totalPages = 1;
	        this.currentPage = 0;
	        this.topDisplayedRowIndex = 0;
	        this.bottomDisplayedRowIndex = this.rowModel.getRowCount() - 1;
	    };
	    __decorate([
	        context_1.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], PaginationProxy.prototype, "rowModel", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], PaginationProxy.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], PaginationProxy.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('selectionController'),
	        __metadata("design:type", selectionController_1.SelectionController)
	    ], PaginationProxy.prototype, "selectionController", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], PaginationProxy.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], PaginationProxy.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], PaginationProxy.prototype, "postConstruct", null);
	    PaginationProxy = __decorate([
	        context_1.Bean('paginationProxy')
	    ], PaginationProxy);
	    return PaginationProxy;
	}(beanStub_1.BeanStub));
	exports.PaginationProxy = PaginationProxy;


/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var rowNode_1 = __webpack_require__(101);
	var context_1 = __webpack_require__(8);
	var eventService_1 = __webpack_require__(22);
	var events_1 = __webpack_require__(29);
	var constants_1 = __webpack_require__(30);
	var columnApi_1 = __webpack_require__(38);
	var gridApi_1 = __webpack_require__(33);
	var utils_1 = __webpack_require__(10);
	var PinnedRowModel = /** @class */ (function () {
	    function PinnedRowModel() {
	    }
	    PinnedRowModel.prototype.init = function () {
	        this.setPinnedTopRowData(this.gridOptionsWrapper.getPinnedTopRowData());
	        this.setPinnedBottomRowData(this.gridOptionsWrapper.getPinnedBottomRowData());
	    };
	    PinnedRowModel.prototype.isEmpty = function (floating) {
	        var rows = floating === constants_1.Constants.PINNED_TOP ? this.pinnedTopRows : this.pinnedBottomRows;
	        return utils_1._.missingOrEmpty(rows);
	    };
	    PinnedRowModel.prototype.isRowsToRender = function (floating) {
	        return !this.isEmpty(floating);
	    };
	    PinnedRowModel.prototype.getRowAtPixel = function (pixel, floating) {
	        var rows = floating === constants_1.Constants.PINNED_TOP ? this.pinnedTopRows : this.pinnedBottomRows;
	        if (utils_1._.missingOrEmpty(rows)) {
	            return 0; // this should never happen, just in case, 0 is graceful failure
	        }
	        for (var i = 0; i < rows.length; i++) {
	            var rowNode = rows[i];
	            var rowTopPixel = rowNode.rowTop + rowNode.rowHeight - 1;
	            // only need to range check against the top pixel, as we are going through the list
	            // in order, first row to hit the pixel wins
	            if (rowTopPixel >= pixel) {
	                return i;
	            }
	        }
	        return rows.length - 1;
	    };
	    PinnedRowModel.prototype.setPinnedTopRowData = function (rowData) {
	        this.pinnedTopRows = this.createNodesFromData(rowData, true);
	        var event = {
	            type: events_1.Events.EVENT_PINNED_ROW_DATA_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    PinnedRowModel.prototype.setPinnedBottomRowData = function (rowData) {
	        this.pinnedBottomRows = this.createNodesFromData(rowData, false);
	        var event = {
	            type: events_1.Events.EVENT_PINNED_ROW_DATA_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    PinnedRowModel.prototype.createNodesFromData = function (allData, isTop) {
	        var _this = this;
	        var rowNodes = [];
	        if (allData) {
	            var nextRowTop_1 = 0;
	            allData.forEach(function (dataItem, index) {
	                var rowNode = new rowNode_1.RowNode();
	                _this.context.wireBean(rowNode);
	                rowNode.data = dataItem;
	                rowNode.id = (isTop ? 't' : 'b') + "-" + index;
	                rowNode.rowPinned = isTop ? constants_1.Constants.PINNED_TOP : constants_1.Constants.PINNED_BOTTOM;
	                rowNode.setRowTop(nextRowTop_1);
	                rowNode.setRowHeight(_this.gridOptionsWrapper.getRowHeightForNode(rowNode).height);
	                rowNode.setRowIndex(index);
	                nextRowTop_1 += rowNode.rowHeight;
	                rowNodes.push(rowNode);
	            });
	        }
	        return rowNodes;
	    };
	    PinnedRowModel.prototype.getPinnedTopRowData = function () {
	        return this.pinnedTopRows;
	    };
	    PinnedRowModel.prototype.getPinnedBottomRowData = function () {
	        return this.pinnedBottomRows;
	    };
	    PinnedRowModel.prototype.getPinnedTopTotalHeight = function () {
	        return this.getTotalHeight(this.pinnedTopRows);
	    };
	    PinnedRowModel.prototype.getPinnedTopRowCount = function () {
	        return this.pinnedTopRows ? this.pinnedTopRows.length : 0;
	    };
	    PinnedRowModel.prototype.getPinnedBottomRowCount = function () {
	        return this.pinnedBottomRows ? this.pinnedBottomRows.length : 0;
	    };
	    PinnedRowModel.prototype.getPinnedTopRow = function (index) {
	        return this.pinnedTopRows[index];
	    };
	    PinnedRowModel.prototype.getPinnedBottomRow = function (index) {
	        return this.pinnedBottomRows[index];
	    };
	    PinnedRowModel.prototype.forEachPinnedTopRow = function (callback) {
	        if (utils_1._.missingOrEmpty(this.pinnedTopRows)) {
	            return;
	        }
	        this.pinnedTopRows.forEach(callback);
	    };
	    PinnedRowModel.prototype.forEachPinnedBottomRow = function (callback) {
	        if (utils_1._.missingOrEmpty(this.pinnedBottomRows)) {
	            return;
	        }
	        this.pinnedBottomRows.forEach(callback);
	    };
	    PinnedRowModel.prototype.getPinnedBottomTotalHeight = function () {
	        return this.getTotalHeight(this.pinnedBottomRows);
	    };
	    PinnedRowModel.prototype.getTotalHeight = function (rowNodes) {
	        if (!rowNodes || rowNodes.length === 0) {
	            return 0;
	        }
	        else {
	            var lastNode = utils_1._.last(rowNodes);
	            return lastNode.rowTop + lastNode.rowHeight;
	        }
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], PinnedRowModel.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], PinnedRowModel.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('context'),
	        __metadata("design:type", context_1.Context)
	    ], PinnedRowModel.prototype, "context", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], PinnedRowModel.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], PinnedRowModel.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], PinnedRowModel.prototype, "init", null);
	    PinnedRowModel = __decorate([
	        context_1.Bean('pinnedRowModel')
	    ], PinnedRowModel);
	    return PinnedRowModel;
	}());
	exports.PinnedRowModel = PinnedRowModel;


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var constants_1 = __webpack_require__(30);
	var context_1 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var environment_1 = __webpack_require__(247);
	var eventService_1 = __webpack_require__(22);
	var events_1 = __webpack_require__(29);
	var utils_1 = __webpack_require__(10);
	var PopupService = /** @class */ (function () {
	    function PopupService() {
	        this.popupList = [];
	    }
	    PopupService.prototype.registerGridCore = function (gridCore) {
	        this.gridCore = gridCore;
	    };
	    PopupService.prototype.getDocument = function () {
	        return this.gridOptionsWrapper.getDocument();
	    };
	    PopupService.prototype.getPopupParent = function () {
	        var ePopupParent = this.gridOptionsWrapper.getPopupParent();
	        if (ePopupParent) {
	            return ePopupParent;
	        }
	        return this.gridCore.getRootGui();
	    };
	    PopupService.prototype.positionPopupForMenu = function (params) {
	        var sourceRect = params.eventSource.getBoundingClientRect();
	        var eDocument = this.getDocument();
	        var popupParent = this.getPopupParent();
	        var parentRect;
	        if (popupParent === eDocument.body) {
	            parentRect = eDocument.documentElement.getBoundingClientRect();
	        }
	        else {
	            parentRect = popupParent.getBoundingClientRect();
	        }
	        var y = sourceRect.top - parentRect.top;
	        y = this.keepYWithinBounds(params, y);
	        var minWidth = (params.ePopup.clientWidth > 0) ? params.ePopup.clientWidth : 200;
	        params.ePopup.style.minWidth = minWidth + "px";
	        var widthOfParent = parentRect.right - parentRect.left;
	        var maxX = widthOfParent - minWidth;
	        // the x position of the popup depends on RTL or LTR. for normal cases, LTR, we put the child popup
	        // to the right, unless it doesn't fit and we then put it to the left. for RTL it's the other way around,
	        // we try place it first to the left, and then if not to the right.
	        var x;
	        if (this.gridOptionsWrapper.isEnableRtl()) {
	            // for RTL, try left first
	            x = xLeftPosition();
	            if (x < 0) {
	                x = xRightPosition();
	            }
	            if (x > maxX) {
	                x = 0;
	            }
	        }
	        else {
	            // for LTR, try right first
	            x = xRightPosition();
	            if (x > maxX) {
	                x = xLeftPosition();
	            }
	            if (x < 0) {
	                x = 0;
	            }
	        }
	        params.ePopup.style.left = x + "px";
	        params.ePopup.style.top = y + "px";
	        function xRightPosition() {
	            return sourceRect.right - parentRect.left - 2;
	        }
	        function xLeftPosition() {
	            return sourceRect.left - parentRect.left - minWidth;
	        }
	    };
	    PopupService.prototype.positionPopupUnderMouseEvent = function (params) {
	        var _a = this.calculatePointerAlign(params.mouseEvent), x = _a.x, y = _a.y;
	        var ePopup = params.ePopup, nudgeX = params.nudgeX, nudgeY = params.nudgeY;
	        this.positionPopup({
	            ePopup: ePopup,
	            x: x,
	            y: y,
	            nudgeX: nudgeX,
	            nudgeY: nudgeY,
	            keepWithinBounds: true
	        });
	        this.callPostProcessPopup(params.ePopup, null, params.mouseEvent, params.type, params.column, params.rowNode);
	    };
	    PopupService.prototype.calculatePointerAlign = function (e) {
	        var eDocument = this.getDocument();
	        var popupParent = this.getPopupParent();
	        var parentRect = popupParent.getBoundingClientRect();
	        var documentRect = eDocument.documentElement.getBoundingClientRect();
	        return {
	            x: e.clientX - (popupParent === eDocument.body ? documentRect.left : parentRect.left),
	            y: e.clientY - (popupParent === eDocument.body ? documentRect.top : parentRect.top)
	        };
	    };
	    PopupService.prototype.positionPopupUnderComponent = function (params) {
	        var sourceRect = params.eventSource.getBoundingClientRect();
	        var eDocument = this.getDocument();
	        var popupParent = this.getPopupParent();
	        var alignSide = params.alignSide || 'left';
	        var parentRect;
	        if (popupParent === eDocument.body) {
	            parentRect = eDocument.documentElement.getBoundingClientRect();
	        }
	        else {
	            parentRect = popupParent.getBoundingClientRect();
	        }
	        var x = sourceRect.left - parentRect.left;
	        if (alignSide === 'right') {
	            x -= (params.ePopup.offsetWidth - sourceRect.width);
	        }
	        this.positionPopup({
	            ePopup: params.ePopup,
	            minWidth: params.minWidth,
	            minHeight: params.minHeight,
	            nudgeX: params.nudgeX,
	            nudgeY: params.nudgeY,
	            x: x,
	            y: sourceRect.top - parentRect.top + sourceRect.height,
	            keepWithinBounds: params.keepWithinBounds
	        });
	        this.callPostProcessPopup(params.ePopup, params.eventSource, null, params.type, params.column, params.rowNode);
	    };
	    PopupService.prototype.positionPopupOverComponent = function (params) {
	        var sourceRect = params.eventSource.getBoundingClientRect();
	        var eDocument = this.getDocument();
	        var popupParent = this.getPopupParent();
	        var parentRect;
	        if (popupParent === eDocument.body) {
	            parentRect = eDocument.documentElement.getBoundingClientRect();
	        }
	        else {
	            parentRect = popupParent.getBoundingClientRect();
	        }
	        this.positionPopup({
	            ePopup: params.ePopup,
	            minWidth: params.minWidth,
	            nudgeX: params.nudgeX,
	            nudgeY: params.nudgeY,
	            x: sourceRect.left - parentRect.left,
	            y: sourceRect.top - parentRect.top,
	            keepWithinBounds: params.keepWithinBounds
	        });
	        this.callPostProcessPopup(params.ePopup, params.eventSource, null, params.type, params.column, params.rowNode);
	    };
	    PopupService.prototype.callPostProcessPopup = function (ePopup, eventSource, mouseEvent, type, column, rowNode) {
	        var callback = this.gridOptionsWrapper.getPostProcessPopupFunc();
	        if (callback) {
	            var params = {
	                column: column,
	                rowNode: rowNode,
	                ePopup: ePopup,
	                type: type,
	                eventSource: eventSource,
	                mouseEvent: mouseEvent
	            };
	            callback(params);
	        }
	    };
	    PopupService.prototype.positionPopup = function (params) {
	        var x = params.x;
	        var y = params.y;
	        if (params.nudgeX) {
	            x += params.nudgeX;
	        }
	        if (params.nudgeY) {
	            y += params.nudgeY;
	        }
	        // if popup is overflowing to the bottom, move it up
	        if (params.keepWithinBounds) {
	            x = this.keepXWithinBounds(params, x);
	            y = this.keepYWithinBounds(params, y);
	        }
	        params.ePopup.style.left = x + "px";
	        params.ePopup.style.top = y + "px";
	    };
	    PopupService.prototype.keepYWithinBounds = function (params, y) {
	        var eDocument = this.gridOptionsWrapper.getDocument();
	        var docElement = eDocument.documentElement;
	        var popupParent = this.getPopupParent();
	        var parentRect = popupParent.getBoundingClientRect();
	        var documentRect = eDocument.documentElement.getBoundingClientRect();
	        var isBody = popupParent === eDocument.body;
	        var defaultPadding = 3;
	        var minHeight = Math.min(200, parentRect.height);
	        var diff = 0;
	        if (params.minHeight && params.minHeight < minHeight) {
	            minHeight = params.minHeight;
	        }
	        else if (params.ePopup.offsetHeight > 0) {
	            minHeight = params.ePopup.clientHeight;
	            diff = utils_1._.getAbsoluteHeight(params.ePopup) - minHeight;
	        }
	        var heightOfParent = isBody ? (utils_1._.getAbsoluteHeight(docElement) + docElement.scrollTop) : parentRect.height;
	        if (isBody) {
	            heightOfParent -= Math.abs(documentRect.top - parentRect.top);
	        }
	        var maxY = heightOfParent - minHeight - diff - defaultPadding;
	        return Math.min(Math.max(y, 0), Math.abs(maxY));
	    };
	    PopupService.prototype.keepXWithinBounds = function (params, x) {
	        var eDocument = this.gridOptionsWrapper.getDocument();
	        var docElement = eDocument.documentElement;
	        var popupParent = this.getPopupParent();
	        var parentRect = popupParent.getBoundingClientRect();
	        var documentRect = eDocument.documentElement.getBoundingClientRect();
	        var isBody = popupParent === eDocument.body;
	        var defaultPadding = 3;
	        var ePopup = params.ePopup;
	        var minWidth = Math.min(200, parentRect.width);
	        var diff = 0;
	        if (params.minWidth && params.minWidth < minWidth) {
	            minWidth = params.minWidth;
	        }
	        else if (ePopup.offsetWidth > 0) {
	            minWidth = ePopup.offsetWidth;
	            ePopup.style.minWidth = minWidth + "px";
	            diff = utils_1._.getAbsoluteWidth(ePopup) - minWidth;
	        }
	        var widthOfParent = isBody ? (utils_1._.getAbsoluteWidth(docElement) + docElement.scrollLeft) : parentRect.width;
	        if (isBody) {
	            widthOfParent -= Math.abs(documentRect.left - parentRect.left);
	        }
	        var maxX = widthOfParent - minWidth - diff - defaultPadding;
	        return Math.min(Math.max(x, 0), Math.abs(maxX));
	    };
	    // adds an element to a div, but also listens to background checking for clicks,
	    // so that when the background is clicked, the child is removed again, giving
	    // a model look to popups.
	    PopupService.prototype.addAsModalPopup = function (eChild, closeOnEsc, closedCallback, click) {
	        return this.addPopup(true, eChild, closeOnEsc, closedCallback, click);
	    };
	    PopupService.prototype.addPopup = function (modal, eChild, closeOnEsc, closedCallback, click, alwaysOnTop) {
	        var _this = this;
	        var eDocument = this.gridOptionsWrapper.getDocument();
	        if (!eDocument) {
	            console.warn('ag-grid: could not find the document, document is empty');
	            return function () { };
	        }
	        var pos = utils_1._.findIndex(this.popupList, function (popup) { return popup.element === eChild; });
	        if (pos !== -1) {
	            var popup = this.popupList[pos];
	            return popup.hideFunc;
	        }
	        var ePopupParent = this.getPopupParent();
	        // for angular specifically, but shouldn't cause an issue with js or other fw's
	        // https://github.com/angular/angular/issues/8563
	        ePopupParent.appendChild(eChild);
	        eChild.style.top = '0px';
	        eChild.style.left = '0px';
	        // add env CSS class to child, in case user provided a popup parent, which means
	        // theme class may be missing
	        var eWrapper = document.createElement('div');
	        var theme = this.environment.getTheme().theme;
	        if (theme) {
	            utils_1._.addCssClass(eWrapper, theme);
	        }
	        utils_1._.addCssClass(eWrapper, 'ag-popup');
	        utils_1._.addCssClass(eChild, this.gridOptionsWrapper.isEnableRtl() ? 'ag-rtl' : 'ag-ltr');
	        eWrapper.appendChild(eChild);
	        ePopupParent.appendChild(eWrapper);
	        if (alwaysOnTop) {
	            this.setAlwaysOnTop(eWrapper, true);
	        }
	        else {
	            this.bringPopupToFront(eWrapper);
	        }
	        var popupHidden = false;
	        var hidePopupOnKeyboardEvent = function (event) {
	            var key = event.which || event.keyCode;
	            if (key === constants_1.Constants.KEY_ESCAPE && eWrapper.contains(document.activeElement)) {
	                hidePopup(null);
	            }
	        };
	        var hidePopupOnMouseEvent = function (event) {
	            hidePopup(event);
	        };
	        var hidePopupOnTouchEvent = function (event) {
	            hidePopup(null, event);
	        };
	        var hidePopup = function (mouseEvent, touchEvent) {
	            if (
	            // we don't hide popup if the event was on the child, or any
	            // children of this child
	            _this.isEventFromCurrentPopup(mouseEvent, touchEvent, eChild) ||
	                // if the event to close is actually the open event, then ignore it
	                _this.isEventSameChainAsOriginalEvent(click, mouseEvent, touchEvent) ||
	                // this method should only be called once. the client can have different
	                // paths, each one wanting to close, so this method may be called multiple times.
	                popupHidden) {
	                return;
	            }
	            popupHidden = true;
	            ePopupParent.removeChild(eWrapper);
	            eDocument.removeEventListener('keydown', hidePopupOnKeyboardEvent);
	            eDocument.removeEventListener('mousedown', hidePopupOnMouseEvent);
	            eDocument.removeEventListener('touchstart', hidePopupOnTouchEvent);
	            eDocument.removeEventListener('contextmenu', hidePopupOnMouseEvent);
	            _this.eventService.removeEventListener(events_1.Events.EVENT_DRAG_STARTED, hidePopupOnMouseEvent);
	            if (closedCallback) {
	                closedCallback();
	            }
	            _this.popupList = _this.popupList.filter(function (popup) { return popup.element !== eChild; });
	        };
	        // if we add these listeners now, then the current mouse
	        // click will be included, which we don't want
	        window.setTimeout(function () {
	            if (closeOnEsc) {
	                eDocument.addEventListener('keydown', hidePopupOnKeyboardEvent);
	            }
	            if (modal) {
	                eDocument.addEventListener('mousedown', hidePopupOnMouseEvent);
	                _this.eventService.addEventListener(events_1.Events.EVENT_DRAG_STARTED, hidePopupOnMouseEvent);
	                eDocument.addEventListener('touchstart', hidePopupOnTouchEvent);
	                eDocument.addEventListener('contextmenu', hidePopupOnMouseEvent);
	            }
	        }, 0);
	        this.popupList.push({
	            element: eChild,
	            hideFunc: hidePopup
	        });
	        return hidePopup;
	    };
	    PopupService.prototype.isEventFromCurrentPopup = function (mouseEvent, touchEvent, eChild) {
	        var event = mouseEvent ? mouseEvent : touchEvent;
	        if (!event) {
	            return false;
	        }
	        var indexOfThisChild = utils_1._.findIndex(this.popupList, function (popup) { return popup.element === eChild; });
	        if (indexOfThisChild === -1) {
	            return false;
	        }
	        for (var i = indexOfThisChild; i < this.popupList.length; i++) {
	            var popup = this.popupList[i];
	            if (utils_1._.isElementInEventPath(popup.element, event)) {
	                return true;
	            }
	        }
	        // if the user did not write their own Custom Element to be rendered as popup
	        // and this component has additional popup element, they should have the
	        // `ag-custom-component-popup` class to be detected as part of the Custom Component
	        var el = event.target;
	        while (el && el != document.body) {
	            if (el.classList.contains('ag-custom-component-popup') || el.parentElement === null) {
	                return true;
	            }
	            el = el.parentElement;
	        }
	    };
	    // in some browsers, the context menu event can be fired before the click event, which means
	    // the context menu event could open the popup, but then the click event closes it straight away.
	    PopupService.prototype.isEventSameChainAsOriginalEvent = function (originalClick, mouseEvent, touchEvent) {
	        // we check the coordinates of the event, to see if it's the same event. there is a 1 / 1000 chance that
	        // the event is a different event, however that is an edge case that is not very relevant (the user clicking
	        // twice on the same location isn't a normal path).
	        // event could be mouse event or touch event.
	        var mouseEventOrTouch = null;
	        if (mouseEvent) {
	            // mouse event can be used direction, it has coordinates
	            mouseEventOrTouch = mouseEvent;
	        }
	        else if (touchEvent) {
	            // touch event doesn't have coordinates, need it's touch object
	            mouseEventOrTouch = touchEvent.touches[0];
	        }
	        if (mouseEventOrTouch && originalClick) {
	            // for x, allow 4px margin, to cover iPads, where touch (which opens menu) is followed
	            // by browser click (when you life finger up, touch is interrupted as click in browser)
	            var screenX_1 = mouseEvent ? mouseEvent.screenX : 0;
	            var screenY_1 = mouseEvent ? mouseEvent.screenY : 0;
	            var xMatch = Math.abs(originalClick.screenX - screenX_1) < 5;
	            var yMatch = Math.abs(originalClick.screenY - screenY_1) < 5;
	            if (xMatch && yMatch) {
	                return true;
	            }
	        }
	        return false;
	    };
	    PopupService.prototype.getWrapper = function (ePopup) {
	        while (!utils_1._.containsClass(ePopup, 'ag-popup') && ePopup.parentElement) {
	            ePopup = ePopup.parentElement;
	        }
	        return utils_1._.containsClass(ePopup, 'ag-popup') ? ePopup : null;
	    };
	    PopupService.prototype.setAlwaysOnTop = function (ePopup, alwaysOnTop) {
	        var eWrapper = this.getWrapper(ePopup);
	        if (!eWrapper) {
	            return;
	        }
	        utils_1._.addOrRemoveCssClass(eWrapper, 'ag-always-on-top', !!alwaysOnTop);
	        if (alwaysOnTop) {
	            this.bringPopupToFront(eWrapper);
	        }
	    };
	    PopupService.prototype.bringPopupToFront = function (ePopup) {
	        var parent = this.getPopupParent();
	        var popupList = Array.prototype.slice.call(parent.querySelectorAll('.ag-popup'));
	        var popupLen = popupList.length;
	        var alwaysOnTopList = Array.prototype.slice.call(parent.querySelectorAll('.ag-popup.ag-always-on-top'));
	        var onTopLength = alwaysOnTopList.length;
	        var eWrapper = this.getWrapper(ePopup);
	        if (!eWrapper || popupLen <= 1 || !parent.contains(ePopup)) {
	            return;
	        }
	        var pos = popupList.indexOf(eWrapper);
	        if (onTopLength) {
	            var isPopupAlwaysOnTop = utils_1._.containsClass(eWrapper, 'ag-always-on-top');
	            if (isPopupAlwaysOnTop) {
	                if (pos !== popupLen - 1) {
	                    utils_1._.last(alwaysOnTopList).insertAdjacentElement('afterend', eWrapper);
	                }
	            }
	            else if (pos !== popupLen - onTopLength - 1) {
	                alwaysOnTopList[0].insertAdjacentElement('beforebegin', eWrapper);
	            }
	        }
	        else if (pos !== popupLen - 1) {
	            utils_1._.last(popupList).insertAdjacentElement('afterend', eWrapper);
	        }
	        var params = {
	            type: 'popupToFront',
	            api: this.gridOptionsWrapper.getApi(),
	            columnApi: this.gridOptionsWrapper.getColumnApi(),
	            eWrapper: eWrapper
	        };
	        this.eventService.dispatchEvent(params);
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], PopupService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('environment'),
	        __metadata("design:type", environment_1.Environment)
	    ], PopupService.prototype, "environment", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], PopupService.prototype, "eventService", void 0);
	    PopupService = __decorate([
	        context_1.Bean('popupService')
	    ], PopupService);
	    return PopupService;
	}());
	exports.PopupService = PopupService;


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(3);
	
	var retrieve = _util.retrieve;
	var defaults = _util.defaults;
	var extend = _util.extend;
	var each = _util.each;
	
	var formatUtil = __webpack_require__(40);
	
	var graphic = __webpack_require__(16);
	
	var Model = __webpack_require__(48);
	
	var _number = __webpack_require__(20);
	
	var isRadianAroundZero = _number.isRadianAroundZero;
	var remRadian = _number.remRadian;
	
	var _symbol = __webpack_require__(84);
	
	var createSymbol = _symbol.createSymbol;
	
	var matrixUtil = __webpack_require__(73);
	
	var _vector = __webpack_require__(41);
	
	var v2ApplyTransform = _vector.applyTransform;
	
	var _axisHelper = __webpack_require__(93);
	
	var shouldShowAllLabels = _axisHelper.shouldShowAllLabels;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PI = Math.PI;
	/**
	 * A final axis is translated and rotated from a "standard axis".
	 * So opt.position and opt.rotation is required.
	 *
	 * A standard axis is and axis from [0, 0] to [0, axisExtent[1]],
	 * for example: (0, 0) ------------> (0, 50)
	 *
	 * nameDirection or tickDirection or labelDirection is 1 means tick
	 * or label is below the standard axis, whereas is -1 means above
	 * the standard axis. labelOffset means offset between label and axis,
	 * which is useful when 'onZero', where axisLabel is in the grid and
	 * label in outside grid.
	 *
	 * Tips: like always,
	 * positive rotation represents anticlockwise, and negative rotation
	 * represents clockwise.
	 * The direction of position coordinate is the same as the direction
	 * of screen coordinate.
	 *
	 * Do not need to consider axis 'inverse', which is auto processed by
	 * axis extent.
	 *
	 * @param {module:zrender/container/Group} group
	 * @param {Object} axisModel
	 * @param {Object} opt Standard axis parameters.
	 * @param {Array.<number>} opt.position [x, y]
	 * @param {number} opt.rotation by radian
	 * @param {number} [opt.nameDirection=1] 1 or -1 Used when nameLocation is 'middle' or 'center'.
	 * @param {number} [opt.tickDirection=1] 1 or -1
	 * @param {number} [opt.labelDirection=1] 1 or -1
	 * @param {number} [opt.labelOffset=0] Usefull when onZero.
	 * @param {string} [opt.axisLabelShow] default get from axisModel.
	 * @param {string} [opt.axisName] default get from axisModel.
	 * @param {number} [opt.axisNameAvailableWidth]
	 * @param {number} [opt.labelRotate] by degree, default get from axisModel.
	 * @param {number} [opt.strokeContainThreshold] Default label interval when label
	 * @param {number} [opt.nameTruncateMaxWidth]
	 */
	
	var AxisBuilder = function (axisModel, opt) {
	  /**
	   * @readOnly
	   */
	  this.opt = opt;
	  /**
	   * @readOnly
	   */
	
	  this.axisModel = axisModel; // Default value
	
	  defaults(opt, {
	    labelOffset: 0,
	    nameDirection: 1,
	    tickDirection: 1,
	    labelDirection: 1,
	    silent: true
	  });
	  /**
	   * @readOnly
	   */
	
	  this.group = new graphic.Group(); // FIXME Not use a seperate text group?
	
	  var dumbGroup = new graphic.Group({
	    position: opt.position.slice(),
	    rotation: opt.rotation
	  }); // this.group.add(dumbGroup);
	  // this._dumbGroup = dumbGroup;
	
	  dumbGroup.updateTransform();
	  this._transform = dumbGroup.transform;
	  this._dumbGroup = dumbGroup;
	};
	
	AxisBuilder.prototype = {
	  constructor: AxisBuilder,
	  hasBuilder: function (name) {
	    return !!builders[name];
	  },
	  add: function (name) {
	    builders[name].call(this);
	  },
	  getGroup: function () {
	    return this.group;
	  }
	};
	var builders = {
	  /**
	   * @private
	   */
	  axisLine: function () {
	    var opt = this.opt;
	    var axisModel = this.axisModel;
	
	    if (!axisModel.get('axisLine.show')) {
	      return;
	    }
	
	    var extent = this.axisModel.axis.getExtent();
	    var matrix = this._transform;
	    var pt1 = [extent[0], 0];
	    var pt2 = [extent[1], 0];
	
	    if (matrix) {
	      v2ApplyTransform(pt1, pt1, matrix);
	      v2ApplyTransform(pt2, pt2, matrix);
	    }
	
	    var lineStyle = extend({
	      lineCap: 'round'
	    }, axisModel.getModel('axisLine.lineStyle').getLineStyle());
	    this.group.add(new graphic.Line({
	      // Id for animation
	      anid: 'line',
	      subPixelOptimize: true,
	      shape: {
	        x1: pt1[0],
	        y1: pt1[1],
	        x2: pt2[0],
	        y2: pt2[1]
	      },
	      style: lineStyle,
	      strokeContainThreshold: opt.strokeContainThreshold || 5,
	      silent: true,
	      z2: 1
	    }));
	    var arrows = axisModel.get('axisLine.symbol');
	    var arrowSize = axisModel.get('axisLine.symbolSize');
	    var arrowOffset = axisModel.get('axisLine.symbolOffset') || 0;
	
	    if (typeof arrowOffset === 'number') {
	      arrowOffset = [arrowOffset, arrowOffset];
	    }
	
	    if (arrows != null) {
	      if (typeof arrows === 'string') {
	        // Use the same arrow for start and end point
	        arrows = [arrows, arrows];
	      }
	
	      if (typeof arrowSize === 'string' || typeof arrowSize === 'number') {
	        // Use the same size for width and height
	        arrowSize = [arrowSize, arrowSize];
	      }
	
	      var symbolWidth = arrowSize[0];
	      var symbolHeight = arrowSize[1];
	      each([{
	        rotate: opt.rotation + Math.PI / 2,
	        offset: arrowOffset[0],
	        r: 0
	      }, {
	        rotate: opt.rotation - Math.PI / 2,
	        offset: arrowOffset[1],
	        r: Math.sqrt((pt1[0] - pt2[0]) * (pt1[0] - pt2[0]) + (pt1[1] - pt2[1]) * (pt1[1] - pt2[1]))
	      }], function (point, index) {
	        if (arrows[index] !== 'none' && arrows[index] != null) {
	          var symbol = createSymbol(arrows[index], -symbolWidth / 2, -symbolHeight / 2, symbolWidth, symbolHeight, lineStyle.stroke, true); // Calculate arrow position with offset
	
	          var r = point.r + point.offset;
	          var pos = [pt1[0] + r * Math.cos(opt.rotation), pt1[1] - r * Math.sin(opt.rotation)];
	          symbol.attr({
	            rotation: point.rotate,
	            position: pos,
	            silent: true,
	            z2: 11
	          });
	          this.group.add(symbol);
	        }
	      }, this);
	    }
	  },
	
	  /**
	   * @private
	   */
	  axisTickLabel: function () {
	    var axisModel = this.axisModel;
	    var opt = this.opt;
	    var ticksEls = buildAxisMajorTicks(this, axisModel, opt);
	    var labelEls = buildAxisLabel(this, axisModel, opt);
	    fixMinMaxLabelShow(axisModel, labelEls, ticksEls);
	    buildAxisMinorTicks(this, axisModel, opt);
	  },
	
	  /**
	   * @private
	   */
	  axisName: function () {
	    var opt = this.opt;
	    var axisModel = this.axisModel;
	    var name = retrieve(opt.axisName, axisModel.get('name'));
	
	    if (!name) {
	      return;
	    }
	
	    var nameLocation = axisModel.get('nameLocation');
	    var nameDirection = opt.nameDirection;
	    var textStyleModel = axisModel.getModel('nameTextStyle');
	    var gap = axisModel.get('nameGap') || 0;
	    var extent = this.axisModel.axis.getExtent();
	    var gapSignal = extent[0] > extent[1] ? -1 : 1;
	    var pos = [nameLocation === 'start' ? extent[0] - gapSignal * gap : nameLocation === 'end' ? extent[1] + gapSignal * gap : (extent[0] + extent[1]) / 2, // 'middle'
	    // Reuse labelOffset.
	    isNameLocationCenter(nameLocation) ? opt.labelOffset + nameDirection * gap : 0];
	    var labelLayout;
	    var nameRotation = axisModel.get('nameRotate');
	
	    if (nameRotation != null) {
	      nameRotation = nameRotation * PI / 180; // To radian.
	    }
	
	    var axisNameAvailableWidth;
	
	    if (isNameLocationCenter(nameLocation)) {
	      labelLayout = innerTextLayout(opt.rotation, nameRotation != null ? nameRotation : opt.rotation, // Adapt to axis.
	      nameDirection);
	    } else {
	      labelLayout = endTextLayout(opt, nameLocation, nameRotation || 0, extent);
	      axisNameAvailableWidth = opt.axisNameAvailableWidth;
	
	      if (axisNameAvailableWidth != null) {
	        axisNameAvailableWidth = Math.abs(axisNameAvailableWidth / Math.sin(labelLayout.rotation));
	        !isFinite(axisNameAvailableWidth) && (axisNameAvailableWidth = null);
	      }
	    }
	
	    var textFont = textStyleModel.getFont();
	    var truncateOpt = axisModel.get('nameTruncate', true) || {};
	    var ellipsis = truncateOpt.ellipsis;
	    var maxWidth = retrieve(opt.nameTruncateMaxWidth, truncateOpt.maxWidth, axisNameAvailableWidth); // FIXME
	    // truncate rich text? (consider performance)
	
	    var truncatedText = ellipsis != null && maxWidth != null ? formatUtil.truncateText(name, maxWidth, textFont, ellipsis, {
	      minChar: 2,
	      placeholder: truncateOpt.placeholder
	    }) : name;
	    var tooltipOpt = axisModel.get('tooltip', true);
	    var mainType = axisModel.mainType;
	    var formatterParams = {
	      componentType: mainType,
	      name: name,
	      $vars: ['name']
	    };
	    formatterParams[mainType + 'Index'] = axisModel.componentIndex;
	    var textEl = new graphic.Text({
	      // Id for animation
	      anid: 'name',
	      __fullText: name,
	      __truncatedText: truncatedText,
	      position: pos,
	      rotation: labelLayout.rotation,
	      silent: isLabelSilent(axisModel),
	      z2: 1,
	      tooltip: tooltipOpt && tooltipOpt.show ? extend({
	        content: name,
	        formatter: function () {
	          return name;
	        },
	        formatterParams: formatterParams
	      }, tooltipOpt) : null
	    });
	    graphic.setTextStyle(textEl.style, textStyleModel, {
	      text: truncatedText,
	      textFont: textFont,
	      textFill: textStyleModel.getTextColor() || axisModel.get('axisLine.lineStyle.color'),
	      textAlign: textStyleModel.get('align') || labelLayout.textAlign,
	      textVerticalAlign: textStyleModel.get('verticalAlign') || labelLayout.textVerticalAlign
	    });
	
	    if (axisModel.get('triggerEvent')) {
	      textEl.eventData = makeAxisEventDataBase(axisModel);
	      textEl.eventData.targetType = 'axisName';
	      textEl.eventData.name = name;
	    } // FIXME
	
	
	    this._dumbGroup.add(textEl);
	
	    textEl.updateTransform();
	    this.group.add(textEl);
	    textEl.decomposeTransform();
	  }
	};
	
	var makeAxisEventDataBase = AxisBuilder.makeAxisEventDataBase = function (axisModel) {
	  var eventData = {
	    componentType: axisModel.mainType,
	    componentIndex: axisModel.componentIndex
	  };
	  eventData[axisModel.mainType + 'Index'] = axisModel.componentIndex;
	  return eventData;
	};
	/**
	 * @public
	 * @static
	 * @param {Object} opt
	 * @param {number} axisRotation in radian
	 * @param {number} textRotation in radian
	 * @param {number} direction
	 * @return {Object} {
	 *  rotation, // according to axis
	 *  textAlign,
	 *  textVerticalAlign
	 * }
	 */
	
	
	var innerTextLayout = AxisBuilder.innerTextLayout = function (axisRotation, textRotation, direction) {
	  var rotationDiff = remRadian(textRotation - axisRotation);
	  var textAlign;
	  var textVerticalAlign;
	
	  if (isRadianAroundZero(rotationDiff)) {
	    // Label is parallel with axis line.
	    textVerticalAlign = direction > 0 ? 'top' : 'bottom';
	    textAlign = 'center';
	  } else if (isRadianAroundZero(rotationDiff - PI)) {
	    // Label is inverse parallel with axis line.
	    textVerticalAlign = direction > 0 ? 'bottom' : 'top';
	    textAlign = 'center';
	  } else {
	    textVerticalAlign = 'middle';
	
	    if (rotationDiff > 0 && rotationDiff < PI) {
	      textAlign = direction > 0 ? 'right' : 'left';
	    } else {
	      textAlign = direction > 0 ? 'left' : 'right';
	    }
	  }
	
	  return {
	    rotation: rotationDiff,
	    textAlign: textAlign,
	    textVerticalAlign: textVerticalAlign
	  };
	};
	
	function endTextLayout(opt, textPosition, textRotate, extent) {
	  var rotationDiff = remRadian(textRotate - opt.rotation);
	  var textAlign;
	  var textVerticalAlign;
	  var inverse = extent[0] > extent[1];
	  var onLeft = textPosition === 'start' && !inverse || textPosition !== 'start' && inverse;
	
	  if (isRadianAroundZero(rotationDiff - PI / 2)) {
	    textVerticalAlign = onLeft ? 'bottom' : 'top';
	    textAlign = 'center';
	  } else if (isRadianAroundZero(rotationDiff - PI * 1.5)) {
	    textVerticalAlign = onLeft ? 'top' : 'bottom';
	    textAlign = 'center';
	  } else {
	    textVerticalAlign = 'middle';
	
	    if (rotationDiff < PI * 1.5 && rotationDiff > PI / 2) {
	      textAlign = onLeft ? 'left' : 'right';
	    } else {
	      textAlign = onLeft ? 'right' : 'left';
	    }
	  }
	
	  return {
	    rotation: rotationDiff,
	    textAlign: textAlign,
	    textVerticalAlign: textVerticalAlign
	  };
	}
	
	var isLabelSilent = AxisBuilder.isLabelSilent = function (axisModel) {
	  var tooltipOpt = axisModel.get('tooltip');
	  return axisModel.get('silent') // Consider mouse cursor, add these restrictions.
	  || !(axisModel.get('triggerEvent') || tooltipOpt && tooltipOpt.show);
	};
	
	function fixMinMaxLabelShow(axisModel, labelEls, tickEls) {
	  if (shouldShowAllLabels(axisModel.axis)) {
	    return;
	  } // If min or max are user set, we need to check
	  // If the tick on min(max) are overlap on their neighbour tick
	  // If they are overlapped, we need to hide the min(max) tick label
	
	
	  var showMinLabel = axisModel.get('axisLabel.showMinLabel');
	  var showMaxLabel = axisModel.get('axisLabel.showMaxLabel'); // FIXME
	  // Have not consider onBand yet, where tick els is more than label els.
	
	  labelEls = labelEls || [];
	  tickEls = tickEls || [];
	  var firstLabel = labelEls[0];
	  var nextLabel = labelEls[1];
	  var lastLabel = labelEls[labelEls.length - 1];
	  var prevLabel = labelEls[labelEls.length - 2];
	  var firstTick = tickEls[0];
	  var nextTick = tickEls[1];
	  var lastTick = tickEls[tickEls.length - 1];
	  var prevTick = tickEls[tickEls.length - 2];
	
	  if (showMinLabel === false) {
	    ignoreEl(firstLabel);
	    ignoreEl(firstTick);
	  } else if (isTwoLabelOverlapped(firstLabel, nextLabel)) {
	    if (showMinLabel) {
	      ignoreEl(nextLabel);
	      ignoreEl(nextTick);
	    } else {
	      ignoreEl(firstLabel);
	      ignoreEl(firstTick);
	    }
	  }
	
	  if (showMaxLabel === false) {
	    ignoreEl(lastLabel);
	    ignoreEl(lastTick);
	  } else if (isTwoLabelOverlapped(prevLabel, lastLabel)) {
	    if (showMaxLabel) {
	      ignoreEl(prevLabel);
	      ignoreEl(prevTick);
	    } else {
	      ignoreEl(lastLabel);
	      ignoreEl(lastTick);
	    }
	  }
	}
	
	function ignoreEl(el) {
	  el && (el.ignore = true);
	}
	
	function isTwoLabelOverlapped(current, next, labelLayout) {
	  // current and next has the same rotation.
	  var firstRect = current && current.getBoundingRect().clone();
	  var nextRect = next && next.getBoundingRect().clone();
	
	  if (!firstRect || !nextRect) {
	    return;
	  } // When checking intersect of two rotated labels, we use mRotationBack
	  // to avoid that boundingRect is enlarge when using `boundingRect.applyTransform`.
	
	
	  var mRotationBack = matrixUtil.identity([]);
	  matrixUtil.rotate(mRotationBack, mRotationBack, -current.rotation);
	  firstRect.applyTransform(matrixUtil.mul([], mRotationBack, current.getLocalTransform()));
	  nextRect.applyTransform(matrixUtil.mul([], mRotationBack, next.getLocalTransform()));
	  return firstRect.intersect(nextRect);
	}
	
	function isNameLocationCenter(nameLocation) {
	  return nameLocation === 'middle' || nameLocation === 'center';
	}
	
	function createTicks(ticksCoords, tickTransform, tickEndCoord, tickLineStyle, aniid) {
	  var tickEls = [];
	  var pt1 = [];
	  var pt2 = [];
	
	  for (var i = 0; i < ticksCoords.length; i++) {
	    var tickCoord = ticksCoords[i].coord;
	    pt1[0] = tickCoord;
	    pt1[1] = 0;
	    pt2[0] = tickCoord;
	    pt2[1] = tickEndCoord;
	
	    if (tickTransform) {
	      v2ApplyTransform(pt1, pt1, tickTransform);
	      v2ApplyTransform(pt2, pt2, tickTransform);
	    } // Tick line, Not use group transform to have better line draw
	
	
	    var tickEl = new graphic.Line({
	      // Id for animation
	      anid: aniid + '_' + ticksCoords[i].tickValue,
	      subPixelOptimize: true,
	      shape: {
	        x1: pt1[0],
	        y1: pt1[1],
	        x2: pt2[0],
	        y2: pt2[1]
	      },
	      style: tickLineStyle,
	      z2: 2,
	      silent: true
	    });
	    tickEls.push(tickEl);
	  }
	
	  return tickEls;
	}
	
	function buildAxisMajorTicks(axisBuilder, axisModel, opt) {
	  var axis = axisModel.axis;
	  var tickModel = axisModel.getModel('axisTick');
	
	  if (!tickModel.get('show') || axis.scale.isBlank()) {
	    return;
	  }
	
	  var lineStyleModel = tickModel.getModel('lineStyle');
	  var tickEndCoord = opt.tickDirection * tickModel.get('length');
	  var ticksCoords = axis.getTicksCoords();
	  var ticksEls = createTicks(ticksCoords, axisBuilder._transform, tickEndCoord, defaults(lineStyleModel.getLineStyle(), {
	    stroke: axisModel.get('axisLine.lineStyle.color')
	  }), 'ticks');
	
	  for (var i = 0; i < ticksEls.length; i++) {
	    axisBuilder.group.add(ticksEls[i]);
	  }
	
	  return ticksEls;
	}
	
	function buildAxisMinorTicks(axisBuilder, axisModel, opt) {
	  var axis = axisModel.axis;
	  var minorTickModel = axisModel.getModel('minorTick');
	
	  if (!minorTickModel.get('show') || axis.scale.isBlank()) {
	    return;
	  }
	
	  var minorTicksCoords = axis.getMinorTicksCoords();
	
	  if (!minorTicksCoords.length) {
	    return;
	  }
	
	  var lineStyleModel = minorTickModel.getModel('lineStyle');
	  var tickEndCoord = opt.tickDirection * minorTickModel.get('length');
	  var minorTickLineStyle = defaults(lineStyleModel.getLineStyle(), defaults(axisModel.getModel('axisTick').getLineStyle(), {
	    stroke: axisModel.get('axisLine.lineStyle.color')
	  }));
	
	  for (var i = 0; i < minorTicksCoords.length; i++) {
	    var minorTicksEls = createTicks(minorTicksCoords[i], axisBuilder._transform, tickEndCoord, minorTickLineStyle, 'minorticks_' + i);
	
	    for (var k = 0; k < minorTicksEls.length; k++) {
	      axisBuilder.group.add(minorTicksEls[k]);
	    }
	  }
	}
	
	function buildAxisLabel(axisBuilder, axisModel, opt) {
	  var axis = axisModel.axis;
	  var show = retrieve(opt.axisLabelShow, axisModel.get('axisLabel.show'));
	
	  if (!show || axis.scale.isBlank()) {
	    return;
	  }
	
	  var labelModel = axisModel.getModel('axisLabel');
	  var labelMargin = labelModel.get('margin');
	  var labels = axis.getViewLabels(); // Special label rotate.
	
	  var labelRotation = (retrieve(opt.labelRotate, labelModel.get('rotate')) || 0) * PI / 180;
	  var labelLayout = innerTextLayout(opt.rotation, labelRotation, opt.labelDirection);
	  var rawCategoryData = axisModel.getCategories && axisModel.getCategories(true);
	  var labelEls = [];
	  var silent = isLabelSilent(axisModel);
	  var triggerEvent = axisModel.get('triggerEvent');
	  each(labels, function (labelItem, index) {
	    var tickValue = labelItem.tickValue;
	    var formattedLabel = labelItem.formattedLabel;
	    var rawLabel = labelItem.rawLabel;
	    var itemLabelModel = labelModel;
	
	    if (rawCategoryData && rawCategoryData[tickValue] && rawCategoryData[tickValue].textStyle) {
	      itemLabelModel = new Model(rawCategoryData[tickValue].textStyle, labelModel, axisModel.ecModel);
	    }
	
	    var textColor = itemLabelModel.getTextColor() || axisModel.get('axisLine.lineStyle.color');
	    var tickCoord = axis.dataToCoord(tickValue);
	    var pos = [tickCoord, opt.labelOffset + opt.labelDirection * labelMargin];
	    var textEl = new graphic.Text({
	      // Id for animation
	      anid: 'label_' + tickValue,
	      position: pos,
	      rotation: labelLayout.rotation,
	      silent: silent,
	      z2: 10
	    });
	    graphic.setTextStyle(textEl.style, itemLabelModel, {
	      text: formattedLabel,
	      textAlign: itemLabelModel.getShallow('align', true) || labelLayout.textAlign,
	      textVerticalAlign: itemLabelModel.getShallow('verticalAlign', true) || itemLabelModel.getShallow('baseline', true) || labelLayout.textVerticalAlign,
	      textFill: typeof textColor === 'function' ? textColor( // (1) In category axis with data zoom, tick is not the original
	      // index of axis.data. So tick should not be exposed to user
	      // in category axis.
	      // (2) Compatible with previous version, which always use formatted label as
	      // input. But in interval scale the formatted label is like '223,445', which
	      // maked user repalce ','. So we modify it to return original val but remain
	      // it as 'string' to avoid error in replacing.
	      axis.type === 'category' ? rawLabel : axis.type === 'value' ? tickValue + '' : tickValue, index) : textColor
	    }); // Pack data for mouse event
	
	    if (triggerEvent) {
	      textEl.eventData = makeAxisEventDataBase(axisModel);
	      textEl.eventData.targetType = 'axisLabel';
	      textEl.eventData.value = rawLabel;
	    } // FIXME
	
	
	    axisBuilder._dumbGroup.add(textEl);
	
	    textEl.updateTransform();
	    labelEls.push(textEl);
	    axisBuilder.group.add(textEl);
	    textEl.decomposeTransform();
	  });
	  return labelEls;
	}
	
	var _default = AxisBuilder;
	module.exports = _default;

/***/ },
/* 139 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var features = {};
	
	function register(name, ctor) {
	  features[name] = ctor;
	}
	
	function get(name) {
	  return features[name];
	}
	
	exports.register = register;
	exports.get = get;

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(3);
	
	var each = _util.each;
	var map = _util.map;
	
	var _number = __webpack_require__(20);
	
	var linearMap = _number.linearMap;
	var getPixelPrecision = _number.getPixelPrecision;
	var round = _number.round;
	
	var _axisTickLabelBuilder = __webpack_require__(1651);
	
	var createAxisTicks = _axisTickLabelBuilder.createAxisTicks;
	var createAxisLabels = _axisTickLabelBuilder.createAxisLabels;
	var calculateCategoryInterval = _axisTickLabelBuilder.calculateCategoryInterval;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var NORMALIZED_EXTENT = [0, 1];
	/**
	 * Base class of Axis.
	 * @constructor
	 */
	
	var Axis = function (dim, scale, extent) {
	  /**
	   * Axis dimension. Such as 'x', 'y', 'z', 'angle', 'radius'.
	   * @type {string}
	   */
	  this.dim = dim;
	  /**
	   * Axis scale
	   * @type {module:echarts/coord/scale/*}
	   */
	
	  this.scale = scale;
	  /**
	   * @type {Array.<number>}
	   * @private
	   */
	
	  this._extent = extent || [0, 0];
	  /**
	   * @type {boolean}
	   */
	
	  this.inverse = false;
	  /**
	   * Usually true when axis has a ordinal scale
	   * @type {boolean}
	   */
	
	  this.onBand = false;
	};
	
	Axis.prototype = {
	  constructor: Axis,
	
	  /**
	   * If axis extent contain given coord
	   * @param {number} coord
	   * @return {boolean}
	   */
	  contain: function (coord) {
	    var extent = this._extent;
	    var min = Math.min(extent[0], extent[1]);
	    var max = Math.max(extent[0], extent[1]);
	    return coord >= min && coord <= max;
	  },
	
	  /**
	   * If axis extent contain given data
	   * @param {number} data
	   * @return {boolean}
	   */
	  containData: function (data) {
	    return this.scale.contain(data);
	  },
	
	  /**
	   * Get coord extent.
	   * @return {Array.<number>}
	   */
	  getExtent: function () {
	    return this._extent.slice();
	  },
	
	  /**
	   * Get precision used for formatting
	   * @param {Array.<number>} [dataExtent]
	   * @return {number}
	   */
	  getPixelPrecision: function (dataExtent) {
	    return getPixelPrecision(dataExtent || this.scale.getExtent(), this._extent);
	  },
	
	  /**
	   * Set coord extent
	   * @param {number} start
	   * @param {number} end
	   */
	  setExtent: function (start, end) {
	    var extent = this._extent;
	    extent[0] = start;
	    extent[1] = end;
	  },
	
	  /**
	   * Convert data to coord. Data is the rank if it has an ordinal scale
	   * @param {number} data
	   * @param  {boolean} clamp
	   * @return {number}
	   */
	  dataToCoord: function (data, clamp) {
	    var extent = this._extent;
	    var scale = this.scale;
	    data = scale.normalize(data);
	
	    if (this.onBand && scale.type === 'ordinal') {
	      extent = extent.slice();
	      fixExtentWithBands(extent, scale.count());
	    }
	
	    return linearMap(data, NORMALIZED_EXTENT, extent, clamp);
	  },
	
	  /**
	   * Convert coord to data. Data is the rank if it has an ordinal scale
	   * @param {number} coord
	   * @param  {boolean} clamp
	   * @return {number}
	   */
	  coordToData: function (coord, clamp) {
	    var extent = this._extent;
	    var scale = this.scale;
	
	    if (this.onBand && scale.type === 'ordinal') {
	      extent = extent.slice();
	      fixExtentWithBands(extent, scale.count());
	    }
	
	    var t = linearMap(coord, extent, NORMALIZED_EXTENT, clamp);
	    return this.scale.scale(t);
	  },
	
	  /**
	   * Convert pixel point to data in axis
	   * @param {Array.<number>} point
	   * @param  {boolean} clamp
	   * @return {number} data
	   */
	  pointToData: function (point, clamp) {// Should be implemented in derived class if necessary.
	  },
	
	  /**
	   * Different from `zrUtil.map(axis.getTicks(), axis.dataToCoord, axis)`,
	   * `axis.getTicksCoords` considers `onBand`, which is used by
	   * `boundaryGap:true` of category axis and splitLine and splitArea.
	   * @param {Object} [opt]
	   * @param {Model} [opt.tickModel=axis.model.getModel('axisTick')]
	   * @param {boolean} [opt.clamp] If `true`, the first and the last
	   *        tick must be at the axis end points. Otherwise, clip ticks
	   *        that outside the axis extent.
	   * @return {Array.<Object>} [{
	   *     coord: ...,
	   *     tickValue: ...
	   * }, ...]
	   */
	  getTicksCoords: function (opt) {
	    opt = opt || {};
	    var tickModel = opt.tickModel || this.getTickModel();
	    var result = createAxisTicks(this, tickModel);
	    var ticks = result.ticks;
	    var ticksCoords = map(ticks, function (tickValue) {
	      return {
	        coord: this.dataToCoord(tickValue),
	        tickValue: tickValue
	      };
	    }, this);
	    var alignWithLabel = tickModel.get('alignWithLabel');
	    fixOnBandTicksCoords(this, ticksCoords, alignWithLabel, opt.clamp);
	    return ticksCoords;
	  },
	
	  /**
	   * @return {Array.<Array.<Object>>} [{ coord: ..., tickValue: ...}]
	   */
	  getMinorTicksCoords: function () {
	    if (this.scale.type === 'ordinal') {
	      // Category axis doesn't support minor ticks
	      return [];
	    }
	
	    var minorTickModel = this.model.getModel('minorTick');
	    var splitNumber = minorTickModel.get('splitNumber'); // Protection.
	
	    if (!(splitNumber > 0 && splitNumber < 100)) {
	      splitNumber = 5;
	    }
	
	    var minorTicks = this.scale.getMinorTicks(splitNumber);
	    var minorTicksCoords = map(minorTicks, function (minorTicksGroup) {
	      return map(minorTicksGroup, function (minorTick) {
	        return {
	          coord: this.dataToCoord(minorTick),
	          tickValue: minorTick
	        };
	      }, this);
	    }, this);
	    return minorTicksCoords;
	  },
	
	  /**
	   * @return {Array.<Object>} [{
	   *     formattedLabel: string,
	   *     rawLabel: axis.scale.getLabel(tickValue)
	   *     tickValue: number
	   * }, ...]
	   */
	  getViewLabels: function () {
	    return createAxisLabels(this).labels;
	  },
	
	  /**
	   * @return {module:echarts/coord/model/Model}
	   */
	  getLabelModel: function () {
	    return this.model.getModel('axisLabel');
	  },
	
	  /**
	   * Notice here we only get the default tick model. For splitLine
	   * or splitArea, we should pass the splitLineModel or splitAreaModel
	   * manually when calling `getTicksCoords`.
	   * In GL, this method may be overrided to:
	   * `axisModel.getModel('axisTick', grid3DModel.getModel('axisTick'));`
	   * @return {module:echarts/coord/model/Model}
	   */
	  getTickModel: function () {
	    return this.model.getModel('axisTick');
	  },
	
	  /**
	   * Get width of band
	   * @return {number}
	   */
	  getBandWidth: function () {
	    var axisExtent = this._extent;
	    var dataExtent = this.scale.getExtent();
	    var len = dataExtent[1] - dataExtent[0] + (this.onBand ? 1 : 0); // Fix #2728, avoid NaN when only one data.
	
	    len === 0 && (len = 1);
	    var size = Math.abs(axisExtent[1] - axisExtent[0]);
	    return Math.abs(size) / len;
	  },
	
	  /**
	   * @abstract
	   * @return {boolean} Is horizontal
	   */
	  isHorizontal: null,
	
	  /**
	   * @abstract
	   * @return {number} Get axis rotate, by degree.
	   */
	  getRotate: null,
	
	  /**
	   * Only be called in category axis.
	   * Can be overrided, consider other axes like in 3D.
	   * @return {number} Auto interval for cateogry axis tick and label
	   */
	  calculateCategoryInterval: function () {
	    return calculateCategoryInterval(this);
	  }
	};
	
	function fixExtentWithBands(extent, nTick) {
	  var size = extent[1] - extent[0];
	  var len = nTick;
	  var margin = size / len / 2;
	  extent[0] += margin;
	  extent[1] -= margin;
	} // If axis has labels [1, 2, 3, 4]. Bands on the axis are
	// |---1---|---2---|---3---|---4---|.
	// So the displayed ticks and splitLine/splitArea should between
	// each data item, otherwise cause misleading (e.g., split tow bars
	// of a single data item when there are two bar series).
	// Also consider if tickCategoryInterval > 0 and onBand, ticks and
	// splitLine/spliteArea should layout appropriately corresponding
	// to displayed labels. (So we should not use `getBandWidth` in this
	// case).
	
	
	function fixOnBandTicksCoords(axis, ticksCoords, alignWithLabel, clamp) {
	  var ticksLen = ticksCoords.length;
	
	  if (!axis.onBand || alignWithLabel || !ticksLen) {
	    return;
	  }
	
	  var axisExtent = axis.getExtent();
	  var last;
	  var diffSize;
	
	  if (ticksLen === 1) {
	    ticksCoords[0].coord = axisExtent[0];
	    last = ticksCoords[1] = {
	      coord: axisExtent[0]
	    };
	  } else {
	    var crossLen = ticksCoords[ticksLen - 1].tickValue - ticksCoords[0].tickValue;
	    var shift = (ticksCoords[ticksLen - 1].coord - ticksCoords[0].coord) / crossLen;
	    each(ticksCoords, function (ticksItem) {
	      ticksItem.coord -= shift / 2;
	    });
	    var dataExtent = axis.scale.getExtent();
	    diffSize = 1 + dataExtent[1] - ticksCoords[ticksLen - 1].tickValue;
	    last = {
	      coord: ticksCoords[ticksLen - 1].coord + shift * diffSize
	    };
	    ticksCoords.push(last);
	  }
	
	  var inverse = axisExtent[0] > axisExtent[1]; // Handling clamp.
	
	  if (littleThan(ticksCoords[0].coord, axisExtent[0])) {
	    clamp ? ticksCoords[0].coord = axisExtent[0] : ticksCoords.shift();
	  }
	
	  if (clamp && littleThan(axisExtent[0], ticksCoords[0].coord)) {
	    ticksCoords.unshift({
	      coord: axisExtent[0]
	    });
	  }
	
	  if (littleThan(axisExtent[1], last.coord)) {
	    clamp ? last.coord = axisExtent[1] : ticksCoords.pop();
	  }
	
	  if (clamp && littleThan(last.coord, axisExtent[1])) {
	    ticksCoords.push({
	      coord: axisExtent[1]
	    });
	  }
	
	  function littleThan(a, b) {
	    // Avoid rounding error cause calculated tick coord different with extent.
	    // It may cause an extra unecessary tick added.
	    a = round(a);
	    b = round(b);
	    return inverse ? a > b : a < b;
	  }
	}
	
	var _default = Axis;
	module.exports = _default;

/***/ },
/* 141 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Language: (Simplified) Chinese.
	 */
	var _default = {
	  legend: {
	    selector: {
	      all: '全选',
	      inverse: '反选'
	    }
	  },
	  toolbox: {
	    brush: {
	      title: {
	        rect: '矩形选择',
	        polygon: '圈选',
	        lineX: '横向选择',
	        lineY: '纵向选择',
	        keep: '保持选择',
	        clear: '清除选择'
	      }
	    },
	    dataView: {
	      title: '数据视图',
	      lang: ['数据视图', '关闭', '刷新']
	    },
	    dataZoom: {
	      title: {
	        zoom: '区域缩放',
	        back: '区域缩放还原'
	      }
	    },
	    magicType: {
	      title: {
	        line: '切换为折线图',
	        bar: '切换为柱状图',
	        stack: '切换为堆叠',
	        tiled: '切换为平铺'
	      }
	    },
	    restore: {
	      title: '还原'
	    },
	    saveAsImage: {
	      title: '保存为图片',
	      lang: ['右键另存为图片']
	    }
	  },
	  series: {
	    typeNames: {
	      pie: '饼图',
	      bar: '柱状图',
	      line: '折线图',
	      scatter: '散点图',
	      effectScatter: '涟漪散点图',
	      radar: '雷达图',
	      tree: '树图',
	      treemap: '矩形树图',
	      boxplot: '箱型图',
	      candlestick: 'K线图',
	      k: 'K线图',
	      heatmap: '热力图',
	      map: '地图',
	      parallel: '平行坐标图',
	      lines: '线图',
	      graph: '关系图',
	      sankey: '桑基图',
	      funnel: '漏斗图',
	      gauge: '仪表盘图',
	      pictorialBar: '象形柱图',
	      themeRiver: '主题河流图',
	      sunburst: '旭日图'
	    }
	  },
	  aria: {
	    general: {
	      withTitle: '这是一个关于“{title}”的图表。',
	      withoutTitle: '这是一个图表，'
	    },
	    series: {
	      single: {
	        prefix: '',
	        withName: '图表类型是{seriesType}，表示{seriesName}。',
	        withoutName: '图表类型是{seriesType}。'
	      },
	      multiple: {
	        prefix: '它由{seriesCount}个图表系列组成。',
	        withName: '第{seriesId}个系列是一个表示{seriesName}的{seriesType}，',
	        withoutName: '第{seriesId}个系列是一个{seriesType}，',
	        separator: {
	          middle: '；',
	          end: '。'
	        }
	      }
	    },
	    data: {
	      allData: '其数据是——',
	      partialData: '其中，前{displayCnt}项是——',
	      withName: '{name}的数据是{value}',
	      withoutName: '{value}',
	      separator: {
	        middle: '，',
	        end: ''
	      }
	    }
	  }
	};
	module.exports = _default;

/***/ },
/* 142 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var ORIGIN_METHOD = '\0__throttleOriginMethod';
	var RATE = '\0__throttleRate';
	var THROTTLE_TYPE = '\0__throttleType';
	/**
	 * @public
	 * @param {(Function)} fn
	 * @param {number} [delay=0] Unit: ms.
	 * @param {boolean} [debounce=false]
	 *        true: If call interval less than `delay`, only the last call works.
	 *        false: If call interval less than `delay, call works on fixed rate.
	 * @return {(Function)} throttled fn.
	 */
	
	function throttle(fn, delay, debounce) {
	  var currCall;
	  var lastCall = 0;
	  var lastExec = 0;
	  var timer = null;
	  var diff;
	  var scope;
	  var args;
	  var debounceNextCall;
	  delay = delay || 0;
	
	  function exec() {
	    lastExec = new Date().getTime();
	    timer = null;
	    fn.apply(scope, args || []);
	  }
	
	  var cb = function () {
	    currCall = new Date().getTime();
	    scope = this;
	    args = arguments;
	    var thisDelay = debounceNextCall || delay;
	    var thisDebounce = debounceNextCall || debounce;
	    debounceNextCall = null;
	    diff = currCall - (thisDebounce ? lastCall : lastExec) - thisDelay;
	    clearTimeout(timer); // Here we should make sure that: the `exec` SHOULD NOT be called later
	    // than a new call of `cb`, that is, preserving the command order. Consider
	    // calculating "scale rate" when roaming as an example. When a call of `cb`
	    // happens, either the `exec` is called dierectly, or the call is delayed.
	    // But the delayed call should never be later than next call of `cb`. Under
	    // this assurance, we can simply update view state each time `dispatchAction`
	    // triggered by user roaming, but not need to add extra code to avoid the
	    // state being "rolled-back".
	
	    if (thisDebounce) {
	      timer = setTimeout(exec, thisDelay);
	    } else {
	      if (diff >= 0) {
	        exec();
	      } else {
	        timer = setTimeout(exec, -diff);
	      }
	    }
	
	    lastCall = currCall;
	  };
	  /**
	   * Clear throttle.
	   * @public
	   */
	
	
	  cb.clear = function () {
	    if (timer) {
	      clearTimeout(timer);
	      timer = null;
	    }
	  };
	  /**
	   * Enable debounce once.
	   */
	
	
	  cb.debounceNextCall = function (debounceDelay) {
	    debounceNextCall = debounceDelay;
	  };
	
	  return cb;
	}
	/**
	 * Create throttle method or update throttle rate.
	 *
	 * @example
	 * ComponentView.prototype.render = function () {
	 *     ...
	 *     throttle.createOrUpdate(
	 *         this,
	 *         '_dispatchAction',
	 *         this.model.get('throttle'),
	 *         'fixRate'
	 *     );
	 * };
	 * ComponentView.prototype.remove = function () {
	 *     throttle.clear(this, '_dispatchAction');
	 * };
	 * ComponentView.prototype.dispose = function () {
	 *     throttle.clear(this, '_dispatchAction');
	 * };
	 *
	 * @public
	 * @param {Object} obj
	 * @param {string} fnAttr
	 * @param {number} [rate]
	 * @param {string} [throttleType='fixRate'] 'fixRate' or 'debounce'
	 * @return {Function} throttled function.
	 */
	
	
	function createOrUpdate(obj, fnAttr, rate, throttleType) {
	  var fn = obj[fnAttr];
	
	  if (!fn) {
	    return;
	  }
	
	  var originFn = fn[ORIGIN_METHOD] || fn;
	  var lastThrottleType = fn[THROTTLE_TYPE];
	  var lastRate = fn[RATE];
	
	  if (lastRate !== rate || lastThrottleType !== throttleType) {
	    if (rate == null || !throttleType) {
	      return obj[fnAttr] = originFn;
	    }
	
	    fn = obj[fnAttr] = throttle(originFn, rate, throttleType === 'debounce');
	    fn[ORIGIN_METHOD] = originFn;
	    fn[THROTTLE_TYPE] = throttleType;
	    fn[RATE] = rate;
	  }
	
	  return fn;
	}
	/**
	 * Clear throttle. Example see throttle.createOrUpdate.
	 *
	 * @public
	 * @param {Object} obj
	 * @param {string} fnAttr
	 */
	
	
	function clear(obj, fnAttr) {
	  var fn = obj[fnAttr];
	
	  if (fn && fn[ORIGIN_METHOD]) {
	    obj[fnAttr] = fn[ORIGIN_METHOD];
	  }
	}
	
	exports.throttle = throttle;
	exports.createOrUpdate = createOrUpdate;
	exports.clear = clear;

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.compose = exports.merge = exports.$ = exports.style = exports.presets = exports.keyframes = exports.fontFace = exports.insertGlobal = exports.insertRule = exports.plugins = exports.styleSheet = undefined;
	exports.speedy = speedy;
	exports.simulations = simulations;
	exports.simulate = simulate;
	exports.cssLabels = cssLabels;
	exports.isLikeRule = isLikeRule;
	exports.idFor = idFor;
	exports.css = css;
	exports.rehydrate = rehydrate;
	exports.flush = flush;
	exports.select = select;
	exports.parent = parent;
	exports.media = media;
	exports.pseudo = pseudo;
	exports.active = active;
	exports.any = any;
	exports.checked = checked;
	exports.disabled = disabled;
	exports.empty = empty;
	exports.enabled = enabled;
	exports._default = _default;
	exports.first = first;
	exports.firstChild = firstChild;
	exports.firstOfType = firstOfType;
	exports.fullscreen = fullscreen;
	exports.focus = focus;
	exports.hover = hover;
	exports.indeterminate = indeterminate;
	exports.inRange = inRange;
	exports.invalid = invalid;
	exports.lastChild = lastChild;
	exports.lastOfType = lastOfType;
	exports.left = left;
	exports.link = link;
	exports.onlyChild = onlyChild;
	exports.onlyOfType = onlyOfType;
	exports.optional = optional;
	exports.outOfRange = outOfRange;
	exports.readOnly = readOnly;
	exports.readWrite = readWrite;
	exports.required = required;
	exports.right = right;
	exports.root = root;
	exports.scope = scope;
	exports.target = target;
	exports.valid = valid;
	exports.visited = visited;
	exports.dir = dir;
	exports.lang = lang;
	exports.not = not;
	exports.nthChild = nthChild;
	exports.nthLastChild = nthLastChild;
	exports.nthLastOfType = nthLastOfType;
	exports.nthOfType = nthOfType;
	exports.after = after;
	exports.before = before;
	exports.firstLetter = firstLetter;
	exports.firstLine = firstLine;
	exports.selection = selection;
	exports.backdrop = backdrop;
	exports.placeholder = placeholder;
	exports.cssFor = cssFor;
	exports.attribsFor = attribsFor;
	
	var _objectAssign = __webpack_require__(32);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _sheet = __webpack_require__(1746);
	
	var _CSSPropertyOperations = __webpack_require__(761);
	
	var _clean = __webpack_require__(1742);
	
	var _clean2 = _interopRequireDefault(_clean);
	
	var _plugins = __webpack_require__(1744);
	
	var _hash = __webpack_require__(1743);
	
	var _hash2 = _interopRequireDefault(_hash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	/* stylesheet */
	
	
	var styleSheet = exports.styleSheet = new _sheet.StyleSheet();
	// an isomorphic StyleSheet shim. hides all the nitty gritty.
	
	// /**************** LIFTOFF IN 3... 2... 1... ****************/
	styleSheet.inject(); //eslint-disable-line indent
	// /****************      TO THE MOOOOOOON     ****************/
	
	// convenience function to toggle speedy
	function speedy(bool) {
	  return styleSheet.speedy(bool);
	}
	
	// plugins
	// we include these by default
	var plugins = exports.plugins = styleSheet.plugins = new _plugins.PluginSet([_plugins.prefixes, _plugins.contentWrap, _plugins.fallbacks]);
	plugins.media = new _plugins.PluginSet(); // neat! media, font-face, keyframes
	plugins.fontFace = new _plugins.PluginSet();
	plugins.keyframes = new _plugins.PluginSet([_plugins.prefixes, _plugins.fallbacks]);
	
	// define some constants
	
	var isDev = ("production") === 'development' || !("production");
	var isTest = ("production") === 'test';
	var isBrowser = typeof window !== 'undefined';
	
	/**** simulations  ****/
	
	// a flag to enable simulation meta tags on dom nodes
	// defaults to true in dev mode. recommend *not* to
	// toggle often.
	var canSimulate = isDev;
	
	// we use these flags for issuing warnings when simulate is called
	// in prod / in incorrect order
	var warned1 = false,
	    warned2 = false;
	
	// toggles simulation activity. shouldn't be needed in most cases
	function simulations() {
	  var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	  canSimulate = !!bool;
	}
	
	// use this on dom nodes to 'simulate' pseudoclasses
	// <div {...hover({ color: 'red' })} {...simulate('hover', 'visited')}>...</div>
	// you can even send in some weird ones, as long as it's in simple format
	// and matches an existing rule on the element
	// eg simulate('nthChild2', ':hover:active') etc
	function simulate() {
	  for (var _len = arguments.length, pseudos = Array(_len), _key = 0; _key < _len; _key++) {
	    pseudos[_key] = arguments[_key];
	  }
	
	  pseudos = (0, _clean2.default)(pseudos);
	  if (!pseudos) return {};
	  if (!canSimulate) {
	    if (!warned1) {
	      console.warn('can\'t simulate without once calling simulations(true)'); //eslint-disable-line no-console
	      warned1 = true;
	    }
	    if (!isDev && !isTest && !warned2) {
	      console.warn('don\'t use simulation outside dev'); //eslint-disable-line no-console
	      warned2 = true;
	    }
	    return {};
	  }
	  return pseudos.reduce(function (o, p) {
	    return o['data-simulate-' + simple(p)] = '', o;
	  }, {});
	}
	
	/**** labels ****/
	// toggle for debug labels.
	// *shouldn't* have to mess with this manually
	var hasLabels = isDev;
	
	function cssLabels(bool) {
	  hasLabels = !!bool;
	}
	
	// takes a string, converts to lowercase, strips out nonalphanumeric.
	function simple(str) {
	  var char = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  return str.toLowerCase().replace(/[^a-z0-9]/g, char);
	}
	
	// hashes a string to something 'unique'
	// we use this to generate ids for styles
	
	
	function hashify(obj) {
	  var str = JSON.stringify(obj);
	  var toRet = (0, _hash2.default)(str).toString(36);
	  if (obj.label && obj.label.length > 0 && isDev) {
	    return simple(obj.label.join('.'), '-') + '-' + toRet;
	  }
	  return toRet;
	}
	
	// of shape { 'data-css-<id>': '' }
	function isLikeRule(rule) {
	  var keys = Object.keys(rule).filter(function (x) {
	    return x !== 'toString';
	  });
	  if (keys.length !== 1) {
	    return false;
	  }
	  return !!/data\-css\-([a-zA-Z0-9\-_]+)/.exec(keys[0]);
	}
	
	// extracts id from a { 'data-css-<id>': ''} like object
	function idFor(rule) {
	  var keys = Object.keys(rule).filter(function (x) {
	    return x !== 'toString';
	  });
	  if (keys.length !== 1) throw new Error('not a rule');
	  var regex = /data\-css\-([a-zA-Z0-9\-_]+)/;
	  var match = regex.exec(keys[0]);
	  if (!match) throw new Error('not a rule');
	  return match[1];
	}
	
	// from https://github.com/j2css/j2c/blob/5d381c2d721d04b54fabe6a165d587247c3087cb/src/helpers.js#L28-L61
	
	// "Tokenizes" the selectors into parts relevant for the next function.
	// Strings and comments are matched, but ignored afterwards.
	// This is not a full tokenizers. It only recognizes comas, parentheses,
	// strings and comments.
	// regexp generated by scripts/regexps.js then trimmed by hand
	var selectorTokenizer = /[(),]|"(?:\\.|[^"\n])*"|'(?:\\.|[^'\n])*'|\/\*[\s\S]*?\*\//g;
	
	/**
	 * This will split a coma-separated selector list into individual selectors,
	 * ignoring comas in strings, comments and in :pseudo-selectors(parameter, lists).
	 *
	 * @param {string} selector
	 * @return {string[]}
	 */
	
	function splitSelector(selector) {
	  if (selector.indexOf(',') === -1) {
	    return [selector];
	  }
	
	  var indices = [],
	      res = [],
	      inParen = 0,
	      o;
	  /*eslint-disable no-cond-assign*/
	  while (o = selectorTokenizer.exec(selector)) {
	    /*eslint-enable no-cond-assign*/
	    switch (o[0]) {
	      case '(':
	        inParen++;break;
	      case ')':
	        inParen--;break;
	      case ',':
	        if (inParen) break;indices.push(o.index);
	    }
	  }
	  for (o = indices.length; o--;) {
	    res.unshift(selector.slice(indices[o] + 1));
	    selector = selector.slice(0, indices[o]);
	  }
	  res.unshift(selector);
	  return res;
	}
	
	function selector(id, path) {
	  if (!id) {
	    return path.replace(/\&/g, '');
	  }
	  if (!path) return '.css-' + id + ',[data-css-' + id + ']';
	
	  var x = splitSelector(path).map(function (x) {
	    return x.indexOf('&') >= 0 ? [x.replace(/\&/mg, '.css-' + id), x.replace(/\&/mg, '[data-css-' + id + ']')].join(',') // todo - make sure each sub selector has an &
	    : '.css-' + id + x + ',[data-css-' + id + ']' + x;
	  }).join(',');
	
	  if (canSimulate && /^\&\:/.exec(path) && !/\s/.exec(path)) {
	    x += ',.css-' + id + '[data-simulate-' + simple(path) + '],[data-css-' + id + '][data-simulate-' + simple(path) + ']';
	  }
	  return x;
	}
	
	// end https://github.com/j2css/j2c/blob/5d381c2d721d04b54fabe6a165d587247c3087cb/src/helpers.js#L28-L61
	
	
	function toCSS(_ref) {
	  var selector = _ref.selector,
	      style = _ref.style;
	
	  var result = plugins.transform({ selector: selector, style: style });
	  return result.selector + '{' + (0, _CSSPropertyOperations.createMarkupForStyles)(result.style) + '}';
	}
	
	function deconstruct(style) {
	  // we can be sure it's not infinitely nested here
	  var plain = void 0,
	      selects = void 0,
	      medias = void 0,
	      supports = void 0;
	  Object.keys(style).forEach(function (key) {
	    if (key.indexOf('&') >= 0) {
	      selects = selects || {};
	      selects[key] = style[key];
	    } else if (key.indexOf('@media') === 0) {
	      medias = medias || {};
	      medias[key] = deconstruct(style[key]);
	    } else if (key.indexOf('@supports') === 0) {
	      supports = supports || {};
	      supports[key] = deconstruct(style[key]);
	    } else if (key === 'label') {
	      if (style.label.length > 0) {
	        plain = plain || {};
	        plain.label = hasLabels ? style.label.join('.') : '';
	      }
	    } else {
	      plain = plain || {};
	      plain[key] = style[key];
	    }
	  });
	  return { plain: plain, selects: selects, medias: medias, supports: supports };
	}
	
	function deconstructedStyleToCSS(id, style) {
	  var css = [];
	
	  // plugins here
	  var plain = style.plain,
	      selects = style.selects,
	      medias = style.medias,
	      supports = style.supports;
	
	  if (plain) {
	    css.push(toCSS({ style: plain, selector: selector(id) }));
	  }
	  if (selects) {
	    Object.keys(selects).forEach(function (key) {
	      return css.push(toCSS({ style: selects[key], selector: selector(id, key) }));
	    });
	  }
	  if (medias) {
	    Object.keys(medias).forEach(function (key) {
	      return css.push(key + '{' + deconstructedStyleToCSS(id, medias[key]).join('') + '}');
	    });
	  }
	  if (supports) {
	    Object.keys(supports).forEach(function (key) {
	      return css.push(key + '{' + deconstructedStyleToCSS(id, supports[key]).join('') + '}');
	    });
	  }
	  return css;
	}
	
	// this cache to track which rules have
	// been inserted into the stylesheet
	var inserted = styleSheet.inserted = {};
	
	// and helpers to insert rules into said styleSheet
	function insert(spec) {
	  if (!inserted[spec.id]) {
	    inserted[spec.id] = true;
	    var deconstructed = deconstruct(spec.style);
	    var rules = deconstructedStyleToCSS(spec.id, deconstructed);
	    inserted[spec.id] = isBrowser ? true : rules;
	    rules.forEach(function (cssRule) {
	      return styleSheet.insert(cssRule);
	    });
	  }
	}
	
	// a simple cache to store generated rules
	var registered = styleSheet.registered = {};
	function register(spec) {
	  if (!registered[spec.id]) {
	    registered[spec.id] = spec;
	  }
	}
	
	function _getRegistered(rule) {
	  if (isLikeRule(rule)) {
	    var ret = registered[idFor(rule)];
	    if (ret == null) {
	      throw new Error('[glamor] an unexpected rule cache miss occurred. This is probably a sign of multiple glamor instances in your app. See https://github.com/threepointone/glamor/issues/79');
	    }
	    return ret;
	  }
	  return rule;
	}
	
	// todo - perf
	var ruleCache = {};
	function toRule(spec) {
	  register(spec);
	  insert(spec);
	
	  if (ruleCache[spec.id]) {
	    return ruleCache[spec.id];
	  }
	
	  var ret = _defineProperty({}, 'data-css-' + spec.id, hasLabels ? spec.label || '' : '');
	  Object.defineProperty(ret, 'toString', {
	    enumerable: false, value: function value() {
	      return 'css-' + spec.id;
	    }
	  });
	  ruleCache[spec.id] = ret;
	  return ret;
	}
	
	function log() {
	  //eslint-disable-line no-unused-vars
	  console.log(this); //eslint-disable-line no-console
	  return this;
	}
	
	function isSelector(key) {
	  var possibles = [':', '.', '[', '>', ' '],
	      found = false,
	      ch = key.charAt(0);
	  for (var i = 0; i < possibles.length; i++) {
	    if (ch === possibles[i]) {
	      found = true;
	      break;
	    }
	  }
	  return found || key.indexOf('&') >= 0;
	}
	
	function joinSelectors(a, b) {
	  var as = splitSelector(a).map(function (a) {
	    return !(a.indexOf('&') >= 0) ? '&' + a : a;
	  });
	  var bs = splitSelector(b).map(function (b) {
	    return !(b.indexOf('&') >= 0) ? '&' + b : b;
	  });
	
	  return bs.reduce(function (arr, b) {
	    return arr.concat(as.map(function (a) {
	      return b.replace(/\&/g, a);
	    }));
	  }, []).join(',');
	}
	
	function joinMediaQueries(a, b) {
	  return a ? '@media ' + a.substring(6) + ' and ' + b.substring(6) : b;
	}
	
	function isMediaQuery(key) {
	  return key.indexOf('@media') === 0;
	}
	
	function isSupports(key) {
	  return key.indexOf('@supports') === 0;
	}
	
	function joinSupports(a, b) {
	  return a ? '@supports ' + a.substring(9) + ' and ' + b.substring(9) : b;
	}
	
	// flatten a nested array
	function flatten(inArr) {
	  var arr = [];
	  for (var i = 0; i < inArr.length; i++) {
	    if (Array.isArray(inArr[i])) arr = arr.concat(flatten(inArr[i]));else arr = arr.concat(inArr[i]);
	  }
	  return arr;
	}
	
	var prefixedPseudoSelectors = {
	  '::placeholder': ['::-webkit-input-placeholder', '::-moz-placeholder', '::-ms-input-placeholder'],
	  ':fullscreen': [':-webkit-full-screen', ':-moz-full-screen', ':-ms-fullscreen']
	
	  // mutable! modifies dest.
	};function build(dest, _ref2) {
	  var _ref2$selector = _ref2.selector,
	      selector = _ref2$selector === undefined ? '' : _ref2$selector,
	      _ref2$mq = _ref2.mq,
	      mq = _ref2$mq === undefined ? '' : _ref2$mq,
	      _ref2$supp = _ref2.supp,
	      supp = _ref2$supp === undefined ? '' : _ref2$supp,
	      _ref2$src = _ref2.src,
	      src = _ref2$src === undefined ? {} : _ref2$src;
	
	
	  if (!Array.isArray(src)) {
	    src = [src];
	  }
	  src = flatten(src);
	
	  src.forEach(function (_src) {
	    if (isLikeRule(_src)) {
	      var reg = _getRegistered(_src);
	      if (reg.type !== 'css') {
	        throw new Error('cannot merge this rule');
	      }
	      _src = reg.style;
	    }
	    _src = (0, _clean2.default)(_src);
	    if (_src && _src.composes) {
	      build(dest, { selector: selector, mq: mq, supp: supp, src: _src.composes });
	    }
	    Object.keys(_src || {}).forEach(function (key) {
	      if (isSelector(key)) {
	
	        if (prefixedPseudoSelectors[key]) {
	          prefixedPseudoSelectors[key].forEach(function (p) {
	            return build(dest, { selector: joinSelectors(selector, p), mq: mq, supp: supp, src: _src[key] });
	          });
	        }
	
	        build(dest, { selector: joinSelectors(selector, key), mq: mq, supp: supp, src: _src[key] });
	      } else if (isMediaQuery(key)) {
	        build(dest, { selector: selector, mq: joinMediaQueries(mq, key), supp: supp, src: _src[key] });
	      } else if (isSupports(key)) {
	        build(dest, { selector: selector, mq: mq, supp: joinSupports(supp, key), src: _src[key] });
	      } else if (key === 'composes') {
	        // ignore, we already dealth with it
	      } else {
	        var _dest = dest;
	        if (supp) {
	          _dest[supp] = _dest[supp] || {};
	          _dest = _dest[supp];
	        }
	        if (mq) {
	          _dest[mq] = _dest[mq] || {};
	          _dest = _dest[mq];
	        }
	        if (selector) {
	          _dest[selector] = _dest[selector] || {};
	          _dest = _dest[selector];
	        }
	
	        if (key === 'label') {
	          if (hasLabels) {
	            dest.label = dest.label.concat(_src.label);
	          }
	        } else {
	          _dest[key] = _src[key];
	        }
	      }
	    });
	  });
	}
	
	function _css(rules) {
	  var style = { label: [] };
	  build(style, { src: rules }); // mutative! but worth it.
	
	  var spec = {
	    id: hashify(style),
	    style: style, label: hasLabels ? style.label.join('.') : '',
	    type: 'css'
	  };
	  return toRule(spec);
	}
	
	var nullrule = {
	  // 'data-css-nil': ''
	};
	Object.defineProperty(nullrule, 'toString', {
	  enumerable: false, value: function value() {
	    return 'css-nil';
	  }
	});
	
	var inputCaches = typeof WeakMap !== 'undefined' ? [nullrule, new WeakMap(), new WeakMap(), new WeakMap()] : [nullrule];
	
	var warnedWeakMapError = false;
	function multiIndexCache(fn) {
	  return function (args) {
	    if (inputCaches[args.length]) {
	      var coi = inputCaches[args.length];
	      var ctr = 0;
	      while (ctr < args.length - 1) {
	        if (!coi.has(args[ctr])) {
	          coi.set(args[ctr], new WeakMap());
	        }
	        coi = coi.get(args[ctr]);
	        ctr++;
	      }
	      if (coi.has(args[args.length - 1])) {
	        var ret = coi.get(args[ctr]);
	
	        if (registered[ret.toString().substring(4)]) {
	          // make sure it hasn't been flushed
	          return ret;
	        }
	      }
	    }
	    var value = fn(args);
	    if (inputCaches[args.length]) {
	      var _ctr = 0,
	          _coi = inputCaches[args.length];
	      while (_ctr < args.length - 1) {
	        _coi = _coi.get(args[_ctr]);
	        _ctr++;
	      }
	      try {
	        _coi.set(args[_ctr], value);
	      } catch (err) {
	        if (isDev && !warnedWeakMapError) {
	          var _console;
	
	          warnedWeakMapError = true;
	          (_console = console).warn.apply(_console, ['failed setting the WeakMap cache for args:'].concat(_toConsumableArray(args))); // eslint-disable-line no-console
	          console.warn('this should NOT happen, please file a bug on the github repo.'); // eslint-disable-line no-console
	        }
	      }
	    }
	    return value;
	  };
	}
	
	var cachedCss = typeof WeakMap !== 'undefined' ? multiIndexCache(_css) : _css;
	
	function css() {
	  for (var _len2 = arguments.length, rules = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    rules[_key2] = arguments[_key2];
	  }
	
	  if (rules[0] && rules[0].length && rules[0].raw) {
	    throw new Error('you forgot to include glamor/babel in your babel plugins.');
	  }
	
	  rules = (0, _clean2.default)(rules);
	  if (!rules) {
	    return nullrule;
	  }
	
	  return cachedCss(rules);
	}
	
	css.insert = function (css) {
	  var spec = {
	    id: hashify(css),
	    css: css,
	    type: 'raw'
	  };
	  register(spec);
	  if (!inserted[spec.id]) {
	    styleSheet.insert(spec.css);
	    inserted[spec.id] = isBrowser ? true : [spec.css];
	  }
	};
	
	var insertRule = exports.insertRule = css.insert;
	
	css.global = function (selector, style) {
	  style = (0, _clean2.default)(style);
	  if (style) {
	    return css.insert(toCSS({ selector: selector, style: style }));
	  }
	};
	
	var insertGlobal = exports.insertGlobal = css.global;
	
	function insertKeyframe(spec) {
	  if (!inserted[spec.id]) {
	    var inner = Object.keys(spec.keyframes).map(function (kf) {
	      var result = plugins.keyframes.transform({ id: spec.id, name: kf, style: spec.keyframes[kf] });
	      return result.name + '{' + (0, _CSSPropertyOperations.createMarkupForStyles)(result.style) + '}';
	    }).join('');
	
	    var rules = ['-webkit-', '-moz-', '-o-', ''].map(function (prefix) {
	      return '@' + prefix + 'keyframes ' + (spec.name + '_' + spec.id) + '{' + inner + '}';
	    });
	    rules.forEach(function (rule) {
	      return styleSheet.insert(rule);
	    });
	
	    inserted[spec.id] = isBrowser ? true : rules;
	  }
	}
	css.keyframes = function (name, kfs) {
	  if (!kfs) {
	    kfs = name, name = 'animation';
	  }
	
	  // do not ignore empty keyframe definitions for now.
	  kfs = (0, _clean2.default)(kfs) || {};
	  var spec = {
	    id: hashify({ name: name, kfs: kfs }),
	    type: 'keyframes',
	    name: name,
	    keyframes: kfs
	  };
	  register(spec);
	  insertKeyframe(spec);
	  return name + '_' + spec.id;
	};
	
	// we don't go all out for fonts as much, giving a simple font loading strategy
	// use a fancier lib if you need moar power
	css.fontFace = function (font) {
	  font = (0, _clean2.default)(font);
	  var spec = {
	    id: hashify(font),
	    type: 'font-face',
	    font: font
	  };
	  register(spec);
	  insertFontFace(spec);
	
	  return font.fontFamily;
	};
	
	var fontFace = exports.fontFace = css.fontFace;
	var keyframes = exports.keyframes = css.keyframes;
	
	function insertFontFace(spec) {
	  if (!inserted[spec.id]) {
	    var rule = '@font-face{' + (0, _CSSPropertyOperations.createMarkupForStyles)(spec.font) + '}';
	    styleSheet.insert(rule);
	    inserted[spec.id] = isBrowser ? true : [rule];
	  }
	}
	
	// rehydrate the insertion cache with ids sent from
	// renderStatic / renderStaticOptimized
	function rehydrate(ids) {
	  // load up ids
	  (0, _objectAssign2.default)(inserted, ids.reduce(function (o, i) {
	    return o[i] = true, o;
	  }, {}));
	  // assume css loaded separately
	}
	
	// clears out the cache and empties the stylesheet
	// best for tests, though there might be some value for SSR.
	
	function flush() {
	  inserted = styleSheet.inserted = {};
	  registered = styleSheet.registered = {};
	  ruleCache = {};
	  styleSheet.flush();
	  styleSheet.inject();
	}
	
	var presets = exports.presets = {
	  mobile: '(min-width: 400px)',
	  Mobile: '@media (min-width: 400px)',
	  phablet: '(min-width: 550px)',
	  Phablet: '@media (min-width: 550px)',
	  tablet: '(min-width: 750px)',
	  Tablet: '@media (min-width: 750px)',
	  desktop: '(min-width: 1000px)',
	  Desktop: '@media (min-width: 1000px)',
	  hd: '(min-width: 1200px)',
	  Hd: '@media (min-width: 1200px)'
	};
	
	var style = exports.style = css;
	
	function select(selector) {
	  for (var _len3 = arguments.length, styles = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    styles[_key3 - 1] = arguments[_key3];
	  }
	
	  if (!selector) {
	    return style(styles);
	  }
	  return css(_defineProperty({}, selector, styles));
	}
	var $ = exports.$ = select;
	
	function parent(selector) {
	  for (var _len4 = arguments.length, styles = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	    styles[_key4 - 1] = arguments[_key4];
	  }
	
	  return css(_defineProperty({}, selector + ' &', styles));
	}
	
	var merge = exports.merge = css;
	var compose = exports.compose = css;
	
	function media(query) {
	  for (var _len5 = arguments.length, rules = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	    rules[_key5 - 1] = arguments[_key5];
	  }
	
	  return css(_defineProperty({}, '@media ' + query, rules));
	}
	
	function pseudo(selector) {
	  for (var _len6 = arguments.length, styles = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
	    styles[_key6 - 1] = arguments[_key6];
	  }
	
	  return css(_defineProperty({}, selector, styles));
	}
	
	// allllll the pseudoclasses
	
	function active(x) {
	  return pseudo(':active', x);
	}
	
	function any(x) {
	  return pseudo(':any', x);
	}
	
	function checked(x) {
	  return pseudo(':checked', x);
	}
	
	function disabled(x) {
	  return pseudo(':disabled', x);
	}
	
	function empty(x) {
	  return pseudo(':empty', x);
	}
	
	function enabled(x) {
	  return pseudo(':enabled', x);
	}
	
	function _default(x) {
	  return pseudo(':default', x); // note '_default' name
	}
	
	function first(x) {
	  return pseudo(':first', x);
	}
	
	function firstChild(x) {
	  return pseudo(':first-child', x);
	}
	
	function firstOfType(x) {
	  return pseudo(':first-of-type', x);
	}
	
	function fullscreen(x) {
	  return pseudo(':fullscreen', x);
	}
	
	function focus(x) {
	  return pseudo(':focus', x);
	}
	
	function hover(x) {
	  return pseudo(':hover', x);
	}
	
	function indeterminate(x) {
	  return pseudo(':indeterminate', x);
	}
	
	function inRange(x) {
	  return pseudo(':in-range', x);
	}
	
	function invalid(x) {
	  return pseudo(':invalid', x);
	}
	
	function lastChild(x) {
	  return pseudo(':last-child', x);
	}
	
	function lastOfType(x) {
	  return pseudo(':last-of-type', x);
	}
	
	function left(x) {
	  return pseudo(':left', x);
	}
	
	function link(x) {
	  return pseudo(':link', x);
	}
	
	function onlyChild(x) {
	  return pseudo(':only-child', x);
	}
	
	function onlyOfType(x) {
	  return pseudo(':only-of-type', x);
	}
	
	function optional(x) {
	  return pseudo(':optional', x);
	}
	
	function outOfRange(x) {
	  return pseudo(':out-of-range', x);
	}
	
	function readOnly(x) {
	  return pseudo(':read-only', x);
	}
	
	function readWrite(x) {
	  return pseudo(':read-write', x);
	}
	
	function required(x) {
	  return pseudo(':required', x);
	}
	
	function right(x) {
	  return pseudo(':right', x);
	}
	
	function root(x) {
	  return pseudo(':root', x);
	}
	
	function scope(x) {
	  return pseudo(':scope', x);
	}
	
	function target(x) {
	  return pseudo(':target', x);
	}
	
	function valid(x) {
	  return pseudo(':valid', x);
	}
	
	function visited(x) {
	  return pseudo(':visited', x);
	}
	
	// parameterized pseudoclasses
	function dir(p, x) {
	  return pseudo(':dir(' + p + ')', x);
	}
	function lang(p, x) {
	  return pseudo(':lang(' + p + ')', x);
	}
	function not(p, x) {
	  // should this be a plugin?
	  var selector = p.split(',').map(function (x) {
	    return x.trim();
	  }).map(function (x) {
	    return ':not(' + x + ')';
	  });
	  if (selector.length === 1) {
	    return pseudo(':not(' + p + ')', x);
	  }
	  return select(selector.join(''), x);
	}
	function nthChild(p, x) {
	  return pseudo(':nth-child(' + p + ')', x);
	}
	function nthLastChild(p, x) {
	  return pseudo(':nth-last-child(' + p + ')', x);
	}
	function nthLastOfType(p, x) {
	  return pseudo(':nth-last-of-type(' + p + ')', x);
	}
	function nthOfType(p, x) {
	  return pseudo(':nth-of-type(' + p + ')', x);
	}
	
	// pseudoelements
	function after(x) {
	  return pseudo('::after', x);
	}
	function before(x) {
	  return pseudo('::before', x);
	}
	function firstLetter(x) {
	  return pseudo('::first-letter', x);
	}
	function firstLine(x) {
	  return pseudo('::first-line', x);
	}
	function selection(x) {
	  return pseudo('::selection', x);
	}
	function backdrop(x) {
	  return pseudo('::backdrop', x);
	}
	function placeholder(x) {
	  // https://github.com/threepointone/glamor/issues/14
	  return css({ '::placeholder': x });
	}
	
	/*** helpers for web components ***/
	// https://github.com/threepointone/glamor/issues/16
	
	function cssFor() {
	  for (var _len7 = arguments.length, rules = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	    rules[_key7] = arguments[_key7];
	  }
	
	  rules = (0, _clean2.default)(rules);
	  return rules ? rules.map(function (r) {
	    var style = { label: [] };
	    build(style, { src: r }); // mutative! but worth it.
	    return deconstructedStyleToCSS(hashify(style), deconstruct(style)).join('');
	  }).join('') : '';
	}
	
	function attribsFor() {
	  for (var _len8 = arguments.length, rules = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
	    rules[_key8] = arguments[_key8];
	  }
	
	  rules = (0, _clean2.default)(rules);
	  var htmlAttributes = rules ? rules.map(function (rule) {
	    idFor(rule); // throwaway check for rule
	    var key = Object.keys(rule)[0],
	        value = rule[key];
	    return key + '="' + (value || '') + '"';
	  }).join(' ') : '';
	
	  return htmlAttributes;
	}

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(1793),
	    createBaseEach = __webpack_require__(790);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(273),
	    overRest = __webpack_require__(1860),
	    setToString = __webpack_require__(1864);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ },
/* 146 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 147 */
[2307, 60],
/* 148 */
[2307, 2],
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;
	
	var _warning = __webpack_require__(132);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
	  var _parsePath = parsePath(path),
	      pathname = _parsePath.pathname,
	      search = _parsePath.search,
	      hash = _parsePath.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
	    hash: hash
	  });
	};
	
	var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
	  var _parsePath2 = parsePath(path),
	      pathname = _parsePath2.pathname,
	      search = _parsePath2.search,
	      hash = _parsePath2.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
	      return prefix === '?' ? prefix : suffix;
	    }),
	    hash: hash
	  });
	};
	
	var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
	  var _parsePath3 = parsePath(path),
	      search = _parsePath3.search;
	
	  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
	  return match && match[1];
	};
	
	var extractPath = function extractPath(string) {
	  var match = string.match(/^(https?:)?\/\/[^\/]*/);
	  return match == null ? string : string.substring(match[0].length);
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  if (location == null || typeof location === 'string') return location;
	
	  var basename = location.basename,
	      pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	  var path = (basename || '') + pathname;
	
	  if (search && search !== '?') path += search;
	
	  if (hash) path += hash;
	
	  return path;
	};

/***/ },
/* 150 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.code;
		this.name = obj.name;
	};
	
	exports.default = _class;

/***/ },
/* 151 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var formatNumber = function formatNumber(number) {
		if (number) {
			return number.toLocaleString();
		}
		return 0;
	};
	
	var nFormatter = function nFormatter(num) {
		if (num >= 1000000000) {
			return (num / 1000000000).toFixed(0).replace(/\.0$/, '') + 'G';
		}
		if (num >= 1000000) {
			return (num / 1000000).toFixed(0).replace(/\.0$/, '') + 'M';
		}
		if (num >= 1000) {
			return (num / 1000).toFixed(0).replace(/\.0$/, '') + 'K';
		}
		return num;
	};
	
	exports.formatNumber = formatNumber;
	exports.nFormatter = nFormatter;

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	var _vector = __webpack_require__(41);
	
	var v2Create = _vector.create;
	var v2DistSquare = _vector.distSquare;
	
	/**
	 * 曲线辅助模块
	 * @module zrender/core/curve
	 * @author pissang(https://www.github.com/pissang)
	 */
	var mathPow = Math.pow;
	var mathSqrt = Math.sqrt;
	var EPSILON = 1e-8;
	var EPSILON_NUMERIC = 1e-4;
	var THREE_SQRT = mathSqrt(3);
	var ONE_THIRD = 1 / 3; // 临时变量
	
	var _v0 = v2Create();
	
	var _v1 = v2Create();
	
	var _v2 = v2Create();
	
	function isAroundZero(val) {
	  return val > -EPSILON && val < EPSILON;
	}
	
	function isNotAroundZero(val) {
	  return val > EPSILON || val < -EPSILON;
	}
	/**
	 * 计算三次贝塞尔值
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {number} t
	 * @return {number}
	 */
	
	
	function cubicAt(p0, p1, p2, p3, t) {
	  var onet = 1 - t;
	  return onet * onet * (onet * p0 + 3 * t * p1) + t * t * (t * p3 + 3 * onet * p2);
	}
	/**
	 * 计算三次贝塞尔导数值
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {number} t
	 * @return {number}
	 */
	
	
	function cubicDerivativeAt(p0, p1, p2, p3, t) {
	  var onet = 1 - t;
	  return 3 * (((p1 - p0) * onet + 2 * (p2 - p1) * t) * onet + (p3 - p2) * t * t);
	}
	/**
	 * 计算三次贝塞尔方程根，使用盛金公式
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {number} val
	 * @param  {Array.<number>} roots
	 * @return {number} 有效根数目
	 */
	
	
	function cubicRootAt(p0, p1, p2, p3, val, roots) {
	  // Evaluate roots of cubic functions
	  var a = p3 + 3 * (p1 - p2) - p0;
	  var b = 3 * (p2 - p1 * 2 + p0);
	  var c = 3 * (p1 - p0);
	  var d = p0 - val;
	  var A = b * b - 3 * a * c;
	  var B = b * c - 9 * a * d;
	  var C = c * c - 3 * b * d;
	  var n = 0;
	
	  if (isAroundZero(A) && isAroundZero(B)) {
	    if (isAroundZero(b)) {
	      roots[0] = 0;
	    } else {
	      var t1 = -c / b; //t1, t2, t3, b is not zero
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	    }
	  } else {
	    var disc = B * B - 4 * A * C;
	
	    if (isAroundZero(disc)) {
	      var K = B / A;
	      var t1 = -b / a + K; // t1, a is not zero
	
	      var t2 = -K / 2; // t2, t3
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	
	      if (t2 >= 0 && t2 <= 1) {
	        roots[n++] = t2;
	      }
	    } else if (disc > 0) {
	      var discSqrt = mathSqrt(disc);
	      var Y1 = A * b + 1.5 * a * (-B + discSqrt);
	      var Y2 = A * b + 1.5 * a * (-B - discSqrt);
	
	      if (Y1 < 0) {
	        Y1 = -mathPow(-Y1, ONE_THIRD);
	      } else {
	        Y1 = mathPow(Y1, ONE_THIRD);
	      }
	
	      if (Y2 < 0) {
	        Y2 = -mathPow(-Y2, ONE_THIRD);
	      } else {
	        Y2 = mathPow(Y2, ONE_THIRD);
	      }
	
	      var t1 = (-b - (Y1 + Y2)) / (3 * a);
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	    } else {
	      var T = (2 * A * b - 3 * a * B) / (2 * mathSqrt(A * A * A));
	      var theta = Math.acos(T) / 3;
	      var ASqrt = mathSqrt(A);
	      var tmp = Math.cos(theta);
	      var t1 = (-b - 2 * ASqrt * tmp) / (3 * a);
	      var t2 = (-b + ASqrt * (tmp + THREE_SQRT * Math.sin(theta))) / (3 * a);
	      var t3 = (-b + ASqrt * (tmp - THREE_SQRT * Math.sin(theta))) / (3 * a);
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	
	      if (t2 >= 0 && t2 <= 1) {
	        roots[n++] = t2;
	      }
	
	      if (t3 >= 0 && t3 <= 1) {
	        roots[n++] = t3;
	      }
	    }
	  }
	
	  return n;
	}
	/**
	 * 计算三次贝塞尔方程极限值的位置
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {Array.<number>} extrema
	 * @return {number} 有效数目
	 */
	
	
	function cubicExtrema(p0, p1, p2, p3, extrema) {
	  var b = 6 * p2 - 12 * p1 + 6 * p0;
	  var a = 9 * p1 + 3 * p3 - 3 * p0 - 9 * p2;
	  var c = 3 * p1 - 3 * p0;
	  var n = 0;
	
	  if (isAroundZero(a)) {
	    if (isNotAroundZero(b)) {
	      var t1 = -c / b;
	
	      if (t1 >= 0 && t1 <= 1) {
	        extrema[n++] = t1;
	      }
	    }
	  } else {
	    var disc = b * b - 4 * a * c;
	
	    if (isAroundZero(disc)) {
	      extrema[0] = -b / (2 * a);
	    } else if (disc > 0) {
	      var discSqrt = mathSqrt(disc);
	      var t1 = (-b + discSqrt) / (2 * a);
	      var t2 = (-b - discSqrt) / (2 * a);
	
	      if (t1 >= 0 && t1 <= 1) {
	        extrema[n++] = t1;
	      }
	
	      if (t2 >= 0 && t2 <= 1) {
	        extrema[n++] = t2;
	      }
	    }
	  }
	
	  return n;
	}
	/**
	 * 细分三次贝塞尔曲线
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {number} t
	 * @param  {Array.<number>} out
	 */
	
	
	function cubicSubdivide(p0, p1, p2, p3, t, out) {
	  var p01 = (p1 - p0) * t + p0;
	  var p12 = (p2 - p1) * t + p1;
	  var p23 = (p3 - p2) * t + p2;
	  var p012 = (p12 - p01) * t + p01;
	  var p123 = (p23 - p12) * t + p12;
	  var p0123 = (p123 - p012) * t + p012; // Seg0
	
	  out[0] = p0;
	  out[1] = p01;
	  out[2] = p012;
	  out[3] = p0123; // Seg1
	
	  out[4] = p0123;
	  out[5] = p123;
	  out[6] = p23;
	  out[7] = p3;
	}
	/**
	 * 投射点到三次贝塞尔曲线上，返回投射距离。
	 * 投射点有可能会有一个或者多个，这里只返回其中距离最短的一个。
	 * @param {number} x0
	 * @param {number} y0
	 * @param {number} x1
	 * @param {number} y1
	 * @param {number} x2
	 * @param {number} y2
	 * @param {number} x3
	 * @param {number} y3
	 * @param {number} x
	 * @param {number} y
	 * @param {Array.<number>} [out] 投射点
	 * @return {number}
	 */
	
	
	function cubicProjectPoint(x0, y0, x1, y1, x2, y2, x3, y3, x, y, out) {
	  // http://pomax.github.io/bezierinfo/#projections
	  var t;
	  var interval = 0.005;
	  var d = Infinity;
	  var prev;
	  var next;
	  var d1;
	  var d2;
	  _v0[0] = x;
	  _v0[1] = y; // 先粗略估计一下可能的最小距离的 t 值
	  // PENDING
	
	  for (var _t = 0; _t < 1; _t += 0.05) {
	    _v1[0] = cubicAt(x0, x1, x2, x3, _t);
	    _v1[1] = cubicAt(y0, y1, y2, y3, _t);
	    d1 = v2DistSquare(_v0, _v1);
	
	    if (d1 < d) {
	      t = _t;
	      d = d1;
	    }
	  }
	
	  d = Infinity; // At most 32 iteration
	
	  for (var i = 0; i < 32; i++) {
	    if (interval < EPSILON_NUMERIC) {
	      break;
	    }
	
	    prev = t - interval;
	    next = t + interval; // t - interval
	
	    _v1[0] = cubicAt(x0, x1, x2, x3, prev);
	    _v1[1] = cubicAt(y0, y1, y2, y3, prev);
	    d1 = v2DistSquare(_v1, _v0);
	
	    if (prev >= 0 && d1 < d) {
	      t = prev;
	      d = d1;
	    } else {
	      // t + interval
	      _v2[0] = cubicAt(x0, x1, x2, x3, next);
	      _v2[1] = cubicAt(y0, y1, y2, y3, next);
	      d2 = v2DistSquare(_v2, _v0);
	
	      if (next <= 1 && d2 < d) {
	        t = next;
	        d = d2;
	      } else {
	        interval *= 0.5;
	      }
	    }
	  } // t
	
	
	  if (out) {
	    out[0] = cubicAt(x0, x1, x2, x3, t);
	    out[1] = cubicAt(y0, y1, y2, y3, t);
	  } // console.log(interval, i);
	
	
	  return mathSqrt(d);
	}
	/**
	 * 计算二次方贝塞尔值
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} t
	 * @return {number}
	 */
	
	
	function quadraticAt(p0, p1, p2, t) {
	  var onet = 1 - t;
	  return onet * (onet * p0 + 2 * t * p1) + t * t * p2;
	}
	/**
	 * 计算二次方贝塞尔导数值
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} t
	 * @return {number}
	 */
	
	
	function quadraticDerivativeAt(p0, p1, p2, t) {
	  return 2 * ((1 - t) * (p1 - p0) + t * (p2 - p1));
	}
	/**
	 * 计算二次方贝塞尔方程根
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} t
	 * @param  {Array.<number>} roots
	 * @return {number} 有效根数目
	 */
	
	
	function quadraticRootAt(p0, p1, p2, val, roots) {
	  var a = p0 - 2 * p1 + p2;
	  var b = 2 * (p1 - p0);
	  var c = p0 - val;
	  var n = 0;
	
	  if (isAroundZero(a)) {
	    if (isNotAroundZero(b)) {
	      var t1 = -c / b;
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	    }
	  } else {
	    var disc = b * b - 4 * a * c;
	
	    if (isAroundZero(disc)) {
	      var t1 = -b / (2 * a);
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	    } else if (disc > 0) {
	      var discSqrt = mathSqrt(disc);
	      var t1 = (-b + discSqrt) / (2 * a);
	      var t2 = (-b - discSqrt) / (2 * a);
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	
	      if (t2 >= 0 && t2 <= 1) {
	        roots[n++] = t2;
	      }
	    }
	  }
	
	  return n;
	}
	/**
	 * 计算二次贝塞尔方程极限值
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @return {number}
	 */
	
	
	function quadraticExtremum(p0, p1, p2) {
	  var divider = p0 + p2 - 2 * p1;
	
	  if (divider === 0) {
	    // p1 is center of p0 and p2
	    return 0.5;
	  } else {
	    return (p0 - p1) / divider;
	  }
	}
	/**
	 * 细分二次贝塞尔曲线
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} t
	 * @param  {Array.<number>} out
	 */
	
	
	function quadraticSubdivide(p0, p1, p2, t, out) {
	  var p01 = (p1 - p0) * t + p0;
	  var p12 = (p2 - p1) * t + p1;
	  var p012 = (p12 - p01) * t + p01; // Seg0
	
	  out[0] = p0;
	  out[1] = p01;
	  out[2] = p012; // Seg1
	
	  out[3] = p012;
	  out[4] = p12;
	  out[5] = p2;
	}
	/**
	 * 投射点到二次贝塞尔曲线上，返回投射距离。
	 * 投射点有可能会有一个或者多个，这里只返回其中距离最短的一个。
	 * @param {number} x0
	 * @param {number} y0
	 * @param {number} x1
	 * @param {number} y1
	 * @param {number} x2
	 * @param {number} y2
	 * @param {number} x
	 * @param {number} y
	 * @param {Array.<number>} out 投射点
	 * @return {number}
	 */
	
	
	function quadraticProjectPoint(x0, y0, x1, y1, x2, y2, x, y, out) {
	  // http://pomax.github.io/bezierinfo/#projections
	  var t;
	  var interval = 0.005;
	  var d = Infinity;
	  _v0[0] = x;
	  _v0[1] = y; // 先粗略估计一下可能的最小距离的 t 值
	  // PENDING
	
	  for (var _t = 0; _t < 1; _t += 0.05) {
	    _v1[0] = quadraticAt(x0, x1, x2, _t);
	    _v1[1] = quadraticAt(y0, y1, y2, _t);
	    var d1 = v2DistSquare(_v0, _v1);
	
	    if (d1 < d) {
	      t = _t;
	      d = d1;
	    }
	  }
	
	  d = Infinity; // At most 32 iteration
	
	  for (var i = 0; i < 32; i++) {
	    if (interval < EPSILON_NUMERIC) {
	      break;
	    }
	
	    var prev = t - interval;
	    var next = t + interval; // t - interval
	
	    _v1[0] = quadraticAt(x0, x1, x2, prev);
	    _v1[1] = quadraticAt(y0, y1, y2, prev);
	    var d1 = v2DistSquare(_v1, _v0);
	
	    if (prev >= 0 && d1 < d) {
	      t = prev;
	      d = d1;
	    } else {
	      // t + interval
	      _v2[0] = quadraticAt(x0, x1, x2, next);
	      _v2[1] = quadraticAt(y0, y1, y2, next);
	      var d2 = v2DistSquare(_v2, _v0);
	
	      if (next <= 1 && d2 < d) {
	        t = next;
	        d = d2;
	      } else {
	        interval *= 0.5;
	      }
	    }
	  } // t
	
	
	  if (out) {
	    out[0] = quadraticAt(x0, x1, x2, t);
	    out[1] = quadraticAt(y0, y1, y2, t);
	  } // console.log(interval, i);
	
	
	  return mathSqrt(d);
	}
	
	exports.cubicAt = cubicAt;
	exports.cubicDerivativeAt = cubicDerivativeAt;
	exports.cubicRootAt = cubicRootAt;
	exports.cubicExtrema = cubicExtrema;
	exports.cubicSubdivide = cubicSubdivide;
	exports.cubicProjectPoint = cubicProjectPoint;
	exports.quadraticAt = quadraticAt;
	exports.quadraticDerivativeAt = quadraticDerivativeAt;
	exports.quadraticRootAt = quadraticRootAt;
	exports.quadraticExtremum = quadraticExtremum;
	exports.quadraticSubdivide = quadraticSubdivide;
	exports.quadraticProjectPoint = quadraticProjectPoint;

/***/ },
/* 153 */
/***/ function(module, exports) {

	function _typeof(obj) {
	  "@babel/helpers - typeof";
	
	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    module.exports = _typeof = function _typeof(obj) {
	      return typeof obj;
	    };
	  } else {
	    module.exports = _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }
	
	  return _typeof(obj);
	}
	
	module.exports = _typeof;

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useFormControl;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _FormControlContext = _interopRequireDefault(__webpack_require__(298));
	
	function useFormControl() {
	  return React.useContext(_FormControlContext.default);
	}

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Slide.default;
	  }
	});
	
	var _Slide = _interopRequireDefault(__webpack_require__(1234));

/***/ },
/* 156 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = debounce;
	
	// Corresponds to 10 frames at 60 Hz.
	// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
	function debounce(func) {
	  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
	  var timeout;
	
	  function debounced() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    // eslint-disable-next-line consistent-this
	    var that = this;
	
	    var later = function later() {
	      func.apply(that, args);
	    };
	
	    clearTimeout(timeout);
	    timeout = setTimeout(later, wait);
	  }
	
	  debounced.clear = function () {
	    clearTimeout(timeout);
	  };
	
	  return debounced;
	}

/***/ },
/* 157 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setRef;
	
	// TODO v5: consider to make it private
	function setRef(ref, value) {
	  if (typeof ref === 'function') {
	    ref(value);
	  } else if (ref) {
	    ref.current = value;
	  }
	}

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var logger_1 = __webpack_require__(68);
	var eventService_1 = __webpack_require__(22);
	var events_1 = __webpack_require__(29);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var columnApi_1 = __webpack_require__(38);
	var gridApi_1 = __webpack_require__(33);
	var utils_1 = __webpack_require__(10);
	/** Adds drag listening onto an element. In ag-Grid this is used twice, first is resizing columns,
	 * second is moving the columns and column groups around (ie the 'drag' part of Drag and Drop. */
	var DragService = /** @class */ (function () {
	    function DragService() {
	        this.onMouseUpListener = this.onMouseUp.bind(this);
	        this.onMouseMoveListener = this.onMouseMove.bind(this);
	        this.onTouchEndListener = this.onTouchUp.bind(this);
	        this.onTouchMoveListener = this.onTouchMove.bind(this);
	        this.dragEndFunctions = [];
	        this.dragSources = [];
	    }
	    DragService.prototype.init = function () {
	        this.logger = this.loggerFactory.create('DragService');
	    };
	    DragService.prototype.destroy = function () {
	        this.dragSources.forEach(this.removeListener.bind(this));
	        this.dragSources.length = 0;
	    };
	    DragService.prototype.removeListener = function (dragSourceAndListener) {
	        var element = dragSourceAndListener.dragSource.eElement;
	        var mouseDownListener = dragSourceAndListener.mouseDownListener;
	        element.removeEventListener('mousedown', mouseDownListener);
	        // remove touch listener only if it exists
	        if (dragSourceAndListener.touchEnabled) {
	            var touchStartListener = dragSourceAndListener.touchStartListener;
	            element.removeEventListener('touchstart', touchStartListener, { passive: true });
	        }
	    };
	    DragService.prototype.removeDragSource = function (params) {
	        var dragSourceAndListener = utils_1._.find(this.dragSources, function (item) { return item.dragSource === params; });
	        if (!dragSourceAndListener) {
	            return;
	        }
	        this.removeListener(dragSourceAndListener);
	        utils_1._.removeFromArray(this.dragSources, dragSourceAndListener);
	    };
	    DragService.prototype.setNoSelectToBody = function (noSelect) {
	        var eDocument = this.gridOptionsWrapper.getDocument();
	        var eBody = eDocument.querySelector('body');
	        if (utils_1._.exists(eBody)) {
	            // when we drag the mouse in ag-Grid, this class gets added / removed from the body, so that
	            // the mouse isn't selecting text when dragging.
	            utils_1._.addOrRemoveCssClass(eBody, 'ag-unselectable', noSelect);
	        }
	    };
	    DragService.prototype.addDragSource = function (params, includeTouch) {
	        if (includeTouch === void 0) { includeTouch = false; }
	        var mouseListener = this.onMouseDown.bind(this, params);
	        params.eElement.addEventListener('mousedown', mouseListener);
	        var touchListener = null;
	        var suppressTouch = this.gridOptionsWrapper.isSuppressTouch();
	        if (includeTouch && !suppressTouch) {
	            touchListener = this.onTouchStart.bind(this, params);
	            params.eElement.addEventListener('touchstart', touchListener, { passive: false });
	        }
	        this.dragSources.push({
	            dragSource: params,
	            mouseDownListener: mouseListener,
	            touchStartListener: touchListener,
	            touchEnabled: includeTouch
	        });
	    };
	    // gets called whenever mouse down on any drag source
	    DragService.prototype.onTouchStart = function (params, touchEvent) {
	        var _this = this;
	        this.currentDragParams = params;
	        this.dragging = false;
	        var touch = touchEvent.touches[0];
	        this.touchLastTime = touch;
	        this.touchStart = touch;
	        touchEvent.preventDefault();
	        // we temporally add these listeners, for the duration of the drag, they
	        // are removed in touch end handling.
	        params.eElement.addEventListener('touchmove', this.onTouchMoveListener, { passive: true });
	        params.eElement.addEventListener('touchend', this.onTouchEndListener, { passive: true });
	        params.eElement.addEventListener('touchcancel', this.onTouchEndListener, { passive: true });
	        this.dragEndFunctions.push(function () {
	            params.eElement.removeEventListener('touchmove', _this.onTouchMoveListener, { passive: true });
	            params.eElement.removeEventListener('touchend', _this.onTouchEndListener, { passive: true });
	            params.eElement.removeEventListener('touchcancel', _this.onTouchEndListener, { passive: true });
	        });
	        // see if we want to start dragging straight away
	        if (params.dragStartPixels === 0) {
	            this.onCommonMove(touch, this.touchStart);
	        }
	    };
	    // gets called whenever mouse down on any drag source
	    DragService.prototype.onMouseDown = function (params, mouseEvent) {
	        var _this = this;
	        // we ignore when shift key is pressed. this is for the range selection, as when
	        // user shift-clicks a cell, this should not be interpreted as the start of a drag.
	        // if (mouseEvent.shiftKey) { return; }
	        if (params.skipMouseEvent) {
	            if (params.skipMouseEvent(mouseEvent)) {
	                return;
	            }
	        }
	        // if there are two elements with parent / child relationship, and both are draggable,
	        // when we drag the child, we should NOT drag the parent. an example of this is row moving
	        // and range selection - row moving should get preference when use drags the rowDrag component.
	        if (mouseEvent._alreadyProcessedByDragService) {
	            return;
	        }
	        mouseEvent._alreadyProcessedByDragService = true;
	        // only interested in left button clicks
	        if (mouseEvent.button !== 0) {
	            return;
	        }
	        this.currentDragParams = params;
	        this.dragging = false;
	        this.mouseStartEvent = mouseEvent;
	        var eDocument = this.gridOptionsWrapper.getDocument();
	        this.setNoSelectToBody(true);
	        // we temporally add these listeners, for the duration of the drag, they
	        // are removed in mouseup handling.
	        eDocument.addEventListener('mousemove', this.onMouseMoveListener);
	        eDocument.addEventListener('mouseup', this.onMouseUpListener);
	        this.dragEndFunctions.push(function () {
	            eDocument.removeEventListener('mousemove', _this.onMouseMoveListener);
	            eDocument.removeEventListener('mouseup', _this.onMouseUpListener);
	        });
	        //see if we want to start dragging straight away
	        if (params.dragStartPixels === 0) {
	            this.onMouseMove(mouseEvent);
	        }
	    };
	    // returns true if the event is close to the original event by X pixels either vertically or horizontally.
	    // we only start dragging after X pixels so this allows us to know if we should start dragging yet.
	    DragService.prototype.isEventNearStartEvent = function (currentEvent, startEvent) {
	        // by default, we wait 4 pixels before starting the drag
	        var dragStartPixels = this.currentDragParams.dragStartPixels;
	        var requiredPixelDiff = utils_1._.exists(dragStartPixels) ? dragStartPixels : 4;
	        return utils_1._.areEventsNear(currentEvent, startEvent, requiredPixelDiff);
	    };
	    DragService.prototype.getFirstActiveTouch = function (touchList) {
	        for (var i = 0; i < touchList.length; i++) {
	            if (touchList[i].identifier === this.touchStart.identifier) {
	                return touchList[i];
	            }
	        }
	        return null;
	    };
	    DragService.prototype.onCommonMove = function (currentEvent, startEvent) {
	        if (!this.dragging) {
	            // if mouse hasn't travelled from the start position enough, do nothing
	            if (!this.dragging && this.isEventNearStartEvent(currentEvent, startEvent)) {
	                return;
	            }
	            this.dragging = true;
	            var event_1 = {
	                type: events_1.Events.EVENT_DRAG_STARTED,
	                api: this.gridApi,
	                columnApi: this.columnApi
	            };
	            this.eventService.dispatchEvent(event_1);
	            this.currentDragParams.onDragStart(startEvent);
	        }
	        this.currentDragParams.onDragging(currentEvent);
	    };
	    DragService.prototype.onTouchMove = function (touchEvent) {
	        var touch = this.getFirstActiveTouch(touchEvent.touches);
	        if (!touch) {
	            return;
	        }
	        // this.___statusPanel.setInfoText(Math.random() + ' onTouchMove preventDefault stopPropagation');
	        // if we don't preview default, then the browser will try and do it's own touch stuff,
	        // like do 'back button' (chrome does this) or scroll the page (eg drag column could  be confused
	        // with scroll page in the app)
	        // touchEvent.preventDefault();
	        this.onCommonMove(touch, this.touchStart);
	    };
	    // only gets called after a mouse down - as this is only added after mouseDown
	    // and is removed when mouseUp happens
	    DragService.prototype.onMouseMove = function (mouseEvent) {
	        this.onCommonMove(mouseEvent, this.mouseStartEvent);
	    };
	    DragService.prototype.onTouchUp = function (touchEvent) {
	        var touch = this.getFirstActiveTouch(touchEvent.changedTouches);
	        // i haven't worked this out yet, but there is no matching touch
	        // when we get the touch up event. to get around this, we swap in
	        // the last touch. this is a hack to 'get it working' while we
	        // figure out what's going on, why we are not getting a touch in
	        // current event.
	        if (!touch) {
	            touch = this.touchLastTime;
	        }
	        // if mouse was left up before we started to move, then this is a tap.
	        // we check this before onUpCommon as onUpCommon resets the dragging
	        // let tap = !this.dragging;
	        // let tapTarget = this.currentDragParams.eElement;
	        this.onUpCommon(touch);
	        // if tap, tell user
	        // console.log(`${Math.random()} tap = ${tap}`);
	        // if (tap) {
	        //     tapTarget.click();
	        // }
	    };
	    DragService.prototype.onMouseUp = function (mouseEvent) {
	        this.onUpCommon(mouseEvent);
	    };
	    DragService.prototype.onUpCommon = function (eventOrTouch) {
	        if (this.dragging) {
	            this.dragging = false;
	            this.currentDragParams.onDragStop(eventOrTouch);
	            var event_2 = {
	                type: events_1.Events.EVENT_DRAG_STOPPED,
	                api: this.gridApi,
	                columnApi: this.columnApi
	            };
	            this.eventService.dispatchEvent(event_2);
	        }
	        this.setNoSelectToBody(false);
	        this.mouseStartEvent = null;
	        this.touchStart = null;
	        this.touchLastTime = null;
	        this.currentDragParams = null;
	        this.dragEndFunctions.forEach(function (func) { return func(); });
	        this.dragEndFunctions.length = 0;
	    };
	    __decorate([
	        context_1.Autowired('loggerFactory'),
	        __metadata("design:type", logger_1.LoggerFactory)
	    ], DragService.prototype, "loggerFactory", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], DragService.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], DragService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], DragService.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], DragService.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], DragService.prototype, "init", null);
	    __decorate([
	        context_1.PreDestroy,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], DragService.prototype, "destroy", null);
	    DragService = __decorate([
	        context_1.Bean('dragService')
	    ], DragService);
	    return DragService;
	}());
	exports.DragService = DragService;


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var column_1 = __webpack_require__(45);
	var eventService_1 = __webpack_require__(22);
	var context_1 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var utils_1 = __webpack_require__(10);
	var ColumnGroup = /** @class */ (function () {
	    function ColumnGroup(originalColumnGroup, groupId, instanceId, pinned) {
	        // depends on the open/closed state of the group, only displaying columns are stored here
	        this.displayedChildren = [];
	        this.localEventService = new eventService_1.EventService();
	        this.groupId = groupId;
	        this.instanceId = instanceId;
	        this.originalColumnGroup = originalColumnGroup;
	        this.pinned = pinned;
	    }
	    // this is static, a it is used outside of this class
	    ColumnGroup.createUniqueId = function (groupId, instanceId) {
	        return groupId + '_' + instanceId;
	    };
	    // as the user is adding and removing columns, the groups are recalculated.
	    // this reset clears out all children, ready for children to be added again
	    ColumnGroup.prototype.reset = function () {
	        this.parent = null;
	        this.children = null;
	        this.displayedChildren = null;
	    };
	    ColumnGroup.prototype.getParent = function () {
	        return this.parent;
	    };
	    ColumnGroup.prototype.setParent = function (parent) {
	        this.parent = parent;
	    };
	    ColumnGroup.prototype.getUniqueId = function () {
	        return ColumnGroup.createUniqueId(this.groupId, this.instanceId);
	    };
	    ColumnGroup.prototype.isEmptyGroup = function () {
	        return this.displayedChildren.length === 0;
	    };
	    ColumnGroup.prototype.isMoving = function () {
	        var allLeafColumns = this.getOriginalColumnGroup().getLeafColumns();
	        if (!allLeafColumns || allLeafColumns.length === 0) {
	            return false;
	        }
	        var allMoving = true;
	        allLeafColumns.forEach(function (col) {
	            if (!col.isMoving()) {
	                allMoving = false;
	            }
	        });
	        return allMoving;
	    };
	    ColumnGroup.prototype.checkLeft = function () {
	        // first get all children to setLeft, as it impacts our decision below
	        this.displayedChildren.forEach(function (child) {
	            if (child instanceof ColumnGroup) {
	                child.checkLeft();
	            }
	        });
	        // set our left based on first displayed column
	        if (this.displayedChildren.length > 0) {
	            if (this.gridOptionsWrapper.isEnableRtl()) {
	                var lastChild = utils_1._.last(this.displayedChildren);
	                var lastChildLeft = lastChild.getLeft();
	                this.setLeft(lastChildLeft);
	            }
	            else {
	                var firstChildLeft = this.displayedChildren[0].getLeft();
	                this.setLeft(firstChildLeft);
	            }
	        }
	        else {
	            // this should never happen, as if we have no displayed columns, then
	            // this groups should not even exist.
	            this.setLeft(null);
	        }
	    };
	    ColumnGroup.prototype.getLeft = function () {
	        return this.left;
	    };
	    ColumnGroup.prototype.getOldLeft = function () {
	        return this.oldLeft;
	    };
	    ColumnGroup.prototype.setLeft = function (left) {
	        this.oldLeft = left;
	        if (this.left !== left) {
	            this.left = left;
	            this.localEventService.dispatchEvent(this.createAgEvent(ColumnGroup.EVENT_LEFT_CHANGED));
	        }
	    };
	    ColumnGroup.prototype.getPinned = function () {
	        return this.pinned;
	    };
	    ColumnGroup.prototype.createAgEvent = function (type) {
	        return {
	            type: type,
	        };
	    };
	    ColumnGroup.prototype.addEventListener = function (eventType, listener) {
	        this.localEventService.addEventListener(eventType, listener);
	    };
	    ColumnGroup.prototype.removeEventListener = function (eventType, listener) {
	        this.localEventService.removeEventListener(eventType, listener);
	    };
	    ColumnGroup.prototype.getGroupId = function () {
	        return this.groupId;
	    };
	    ColumnGroup.prototype.getInstanceId = function () {
	        return this.instanceId;
	    };
	    ColumnGroup.prototype.isChildInThisGroupDeepSearch = function (wantedChild) {
	        var result = false;
	        this.children.forEach(function (foundChild) {
	            if (wantedChild === foundChild) {
	                result = true;
	            }
	            if (foundChild instanceof ColumnGroup) {
	                if (foundChild.isChildInThisGroupDeepSearch(wantedChild)) {
	                    result = true;
	                }
	            }
	        });
	        return result;
	    };
	    ColumnGroup.prototype.getActualWidth = function () {
	        var groupActualWidth = 0;
	        if (this.displayedChildren) {
	            this.displayedChildren.forEach(function (child) {
	                groupActualWidth += child.getActualWidth();
	            });
	        }
	        return groupActualWidth;
	    };
	    ColumnGroup.prototype.isResizable = function () {
	        if (!this.displayedChildren) {
	            return false;
	        }
	        // if at least one child is resizable, then the group is resizable
	        var result = false;
	        this.displayedChildren.forEach(function (child) {
	            if (child.isResizable()) {
	                result = true;
	            }
	        });
	        return result;
	    };
	    ColumnGroup.prototype.getMinWidth = function () {
	        var result = 0;
	        this.displayedChildren.forEach(function (groupChild) {
	            result += groupChild.getMinWidth();
	        });
	        return result;
	    };
	    ColumnGroup.prototype.addChild = function (child) {
	        if (!this.children) {
	            this.children = [];
	        }
	        this.children.push(child);
	    };
	    ColumnGroup.prototype.getDisplayedChildren = function () {
	        return this.displayedChildren;
	    };
	    ColumnGroup.prototype.getLeafColumns = function () {
	        var result = [];
	        this.addLeafColumns(result);
	        return result;
	    };
	    ColumnGroup.prototype.getDisplayedLeafColumns = function () {
	        var result = [];
	        this.addDisplayedLeafColumns(result);
	        return result;
	    };
	    // why two methods here doing the same thing?
	    ColumnGroup.prototype.getDefinition = function () {
	        return this.originalColumnGroup.getColGroupDef();
	    };
	    ColumnGroup.prototype.getColGroupDef = function () {
	        return this.originalColumnGroup.getColGroupDef();
	    };
	    ColumnGroup.prototype.isPadding = function () {
	        return this.originalColumnGroup.isPadding();
	    };
	    ColumnGroup.prototype.isExpandable = function () {
	        return this.originalColumnGroup.isExpandable();
	    };
	    ColumnGroup.prototype.isExpanded = function () {
	        return this.originalColumnGroup.isExpanded();
	    };
	    ColumnGroup.prototype.setExpanded = function (expanded) {
	        this.originalColumnGroup.setExpanded(expanded);
	    };
	    ColumnGroup.prototype.addDisplayedLeafColumns = function (leafColumns) {
	        this.displayedChildren.forEach(function (child) {
	            if (child instanceof column_1.Column) {
	                leafColumns.push(child);
	            }
	            else if (child instanceof ColumnGroup) {
	                child.addDisplayedLeafColumns(leafColumns);
	            }
	        });
	    };
	    ColumnGroup.prototype.addLeafColumns = function (leafColumns) {
	        this.children.forEach(function (child) {
	            if (child instanceof column_1.Column) {
	                leafColumns.push(child);
	            }
	            else if (child instanceof ColumnGroup) {
	                child.addLeafColumns(leafColumns);
	            }
	        });
	    };
	    ColumnGroup.prototype.getChildren = function () {
	        return this.children;
	    };
	    ColumnGroup.prototype.getColumnGroupShow = function () {
	        return this.originalColumnGroup.getColumnGroupShow();
	    };
	    ColumnGroup.prototype.getOriginalColumnGroup = function () {
	        return this.originalColumnGroup;
	    };
	    ColumnGroup.prototype.calculateDisplayedColumns = function () {
	        var _this = this;
	        // clear out last time we calculated
	        this.displayedChildren = [];
	        var topLevelGroup = this;
	        // find the column group that is controlling expandable. this is relevant when we have padding (empty)
	        // groups, where the expandable is actually the first parent that is not a padding group.
	        if (this.isPadding()) {
	            while (topLevelGroup.getParent() && topLevelGroup.isPadding()) {
	                topLevelGroup = topLevelGroup.getParent();
	            }
	        }
	        var isExpandable = topLevelGroup.originalColumnGroup.isExpandable();
	        // it not expandable, everything is visible
	        if (!isExpandable) {
	            this.displayedChildren = this.children;
	        }
	        else {
	            // Add cols based on columnGroupShow
	            // Note - the below also adds padding groups, these are always added because they never have
	            // colDef.columnGroupShow set.
	            this.children.forEach(function (abstractColumn) {
	                var headerGroupShow = abstractColumn.getColumnGroupShow();
	                switch (headerGroupShow) {
	                    case ColumnGroup.HEADER_GROUP_SHOW_OPEN:
	                        // when set to open, only show col if group is open
	                        if (topLevelGroup.originalColumnGroup.isExpanded()) {
	                            _this.displayedChildren.push(abstractColumn);
	                        }
	                        break;
	                    case ColumnGroup.HEADER_GROUP_SHOW_CLOSED:
	                        // when set to open, only show col if group is open
	                        if (!topLevelGroup.originalColumnGroup.isExpanded()) {
	                            _this.displayedChildren.push(abstractColumn);
	                        }
	                        break;
	                    default:
	                        // default is always show the column
	                        _this.displayedChildren.push(abstractColumn);
	                        break;
	                }
	            });
	        }
	        this.localEventService.dispatchEvent(this.createAgEvent(ColumnGroup.EVENT_DISPLAYED_CHILDREN_CHANGED));
	    };
	    ColumnGroup.HEADER_GROUP_SHOW_OPEN = 'open';
	    ColumnGroup.HEADER_GROUP_SHOW_CLOSED = 'closed';
	    ColumnGroup.HEADER_GROUP_PADDING = 'padding';
	    ColumnGroup.EVENT_LEFT_CHANGED = 'leftChanged';
	    ColumnGroup.EVENT_DISPLAYED_CHILDREN_CHANGED = 'displayedChildrenChanged';
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], ColumnGroup.prototype, "gridOptionsWrapper", void 0);
	    return ColumnGroup;
	}());
	exports.ColumnGroup = ColumnGroup;


/***/ },
/* 160 */
/***/ function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Events = /** @class */ (function () {
	    function Events() {
	    }
	    /** Everything has changed with the columns. Either complete new set of columns set, or user called setState()*/
	    Events.EVENT_COLUMN_EVERYTHING_CHANGED = 'columnEverythingChanged';
	    /** User has set in new columns. */
	    Events.EVENT_NEW_COLUMNS_LOADED = 'newColumnsLoaded';
	    /** The pivot mode flag was changed */
	    Events.EVENT_COLUMN_PIVOT_MODE_CHANGED = 'columnPivotModeChanged';
	    /** A row group column was added, removed or order changed. */
	    Events.EVENT_COLUMN_ROW_GROUP_CHANGED = 'columnRowGroupChanged';
	    /** expandAll / collapseAll was called from the api. */
	    Events.EVENT_EXPAND_COLLAPSE_ALL = 'expandOrCollapseAll';
	    /** A pivot column was added, removed or order changed. */
	    Events.EVENT_COLUMN_PIVOT_CHANGED = 'columnPivotChanged';
	    /** The list of grid columns has changed. */
	    Events.EVENT_GRID_COLUMNS_CHANGED = 'gridColumnsChanged';
	    /** A value column was added, removed or agg function was changed. */
	    Events.EVENT_COLUMN_VALUE_CHANGED = 'columnValueChanged';
	    /** A column was moved */
	    Events.EVENT_COLUMN_MOVED = 'columnMoved';
	    /** One or more columns was shown / hidden */
	    Events.EVENT_COLUMN_VISIBLE = 'columnVisible';
	    /** One or more columns was pinned / unpinned*/
	    Events.EVENT_COLUMN_PINNED = 'columnPinned';
	    /** A column group was opened / closed */
	    Events.EVENT_COLUMN_GROUP_OPENED = 'columnGroupOpened';
	    /** One or more columns was resized. If just one, the column in the event is set. */
	    Events.EVENT_COLUMN_RESIZED = 'columnResized';
	    /** The list of displayed columns has changed, can result from columns open / close, column move, pivot, group, etc */
	    Events.EVENT_DISPLAYED_COLUMNS_CHANGED = 'displayedColumnsChanged';
	    /** The list of virtual columns has changed, results from viewport changing */
	    Events.EVENT_VIRTUAL_COLUMNS_CHANGED = 'virtualColumnsChanged';
	    /** A row group was opened / closed */
	    Events.EVENT_ROW_GROUP_OPENED = 'rowGroupOpened';
	    /** The client has set new data into the grid */
	    Events.EVENT_ROW_DATA_CHANGED = 'rowDataChanged';
	    /** The client has updated data for the grid */
	    Events.EVENT_ROW_DATA_UPDATED = 'rowDataUpdated';
	    /** The client has set new floating data into the grid */
	    Events.EVENT_PINNED_ROW_DATA_CHANGED = 'pinnedRowDataChanged';
	    /** Range selection has changed */
	    Events.EVENT_RANGE_SELECTION_CHANGED = 'rangeSelectionChanged';
	    /** Chart Range selection has changed */
	    Events.EVENT_CHART_RANGE_SELECTION_CHANGED = 'chartRangeSelectionChanged';
	    /** Chart Options have changed */
	    Events.EVENT_CHART_OPTIONS_CHANGED = 'chartOptionsChanged';
	    /** For when the tool panel is shown / hidden */
	    Events.EVENT_TOOL_PANEL_VISIBLE_CHANGED = 'toolPanelVisibleChanged';
	    /** Model was updated - grid updates the drawn rows when this happens */
	    Events.EVENT_MODEL_UPDATED = 'modelUpdated';
	    Events.EVENT_PASTE_START = 'pasteStart';
	    Events.EVENT_PASTE_END = 'pasteEnd';
	    Events.EVENT_CELL_CLICKED = 'cellClicked';
	    Events.EVENT_CELL_DOUBLE_CLICKED = 'cellDoubleClicked';
	    Events.EVENT_CELL_MOUSE_DOWN = 'cellMouseDown';
	    Events.EVENT_CELL_CONTEXT_MENU = 'cellContextMenu';
	    Events.EVENT_CELL_VALUE_CHANGED = 'cellValueChanged';
	    Events.EVENT_ROW_VALUE_CHANGED = 'rowValueChanged';
	    Events.EVENT_CELL_FOCUSED = 'cellFocused';
	    Events.EVENT_ROW_SELECTED = 'rowSelected';
	    Events.EVENT_SELECTION_CHANGED = 'selectionChanged';
	    Events.EVENT_CELL_KEY_DOWN = 'cellKeyDown';
	    Events.EVENT_CELL_KEY_PRESS = 'cellKeyPress';
	    Events.EVENT_CELL_MOUSE_OVER = 'cellMouseOver';
	    Events.EVENT_CELL_MOUSE_OUT = 'cellMouseOut';
	    /** 2 events for filtering. The grid LISTENS for filterChanged and afterFilterChanged */
	    Events.EVENT_FILTER_CHANGED = 'filterChanged';
	    /** Filter was change but not applied. Only useful if apply buttons are used in filters. */
	    Events.EVENT_FILTER_MODIFIED = 'filterModified';
	    Events.EVENT_FILTER_OPENED = 'filterOpened';
	    Events.EVENT_SORT_CHANGED = 'sortChanged';
	    /** A row was removed from the dom, for any reason. Use to clean up resources (if any) used by the row. */
	    Events.EVENT_VIRTUAL_ROW_REMOVED = 'virtualRowRemoved';
	    Events.EVENT_ROW_CLICKED = 'rowClicked';
	    Events.EVENT_ROW_DOUBLE_CLICKED = 'rowDoubleClicked';
	    /** Gets called once after the grid has finished initialising. */
	    Events.EVENT_GRID_READY = 'gridReady';
	    /** Width of height of the main grid div has changed. Grid listens for this and does layout of grid if it's
	     * changed, so always filling the space it was given. */
	    Events.EVENT_GRID_SIZE_CHANGED = 'gridSizeChanged';
	    /** The indexes of the rows rendered has changed, eg user has scrolled to a new vertical position. */
	    Events.EVENT_VIEWPORT_CHANGED = 'viewportChanged';
	    /** Rows were rendered for the first time (ie on async data load). */
	    Events.EVENT_FIRST_DATA_RENDERED = 'firstDataRendered';
	    /** A column drag has started, either resizing a column or moving a column. */
	    Events.EVENT_DRAG_STARTED = 'dragStarted';
	    /** A column drag has stopped */
	    Events.EVENT_DRAG_STOPPED = 'dragStopped';
	    Events.EVENT_ROW_EDITING_STARTED = 'rowEditingStarted';
	    Events.EVENT_ROW_EDITING_STOPPED = 'rowEditingStopped';
	    Events.EVENT_CELL_EDITING_STARTED = 'cellEditingStarted';
	    Events.EVENT_CELL_EDITING_STOPPED = 'cellEditingStopped';
	    /** Main body of grid has scrolled, either horizontally or vertically */
	    Events.EVENT_BODY_SCROLL = 'bodyScroll';
	    Events.EVENT_ANIMATION_QUEUE_EMPTY = 'animationQueueEmpty';
	    Events.EVENT_HEIGHT_SCALE_CHANGED = 'heightScaleChanged';
	    /** The displayed page for pagination has changed. For example the data was filtered or sorted,
	     * or the user has moved to a different page. */
	    Events.EVENT_PAGINATION_CHANGED = 'paginationChanged';
	    /** Only used by React, Angular 2+, Web Components and VueJS ag-Grid components
	     * (not used if doing plain JavaScript or Angular 1.x). If the grid receives changes due
	     * to bound properties, this event fires after the grid has finished processing the change. */
	    Events.EVENT_COMPONENT_STATE_CHANGED = 'componentStateChanged';
	    /** All items from here down are used internally by the grid, not intended for external use. */
	    // not documented, either experimental, or we just don't want users using an depending on them
	    Events.EVENT_BODY_HEIGHT_CHANGED = 'bodyHeightChanged';
	    Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED = 'displayedColumnsWidthChanged';
	    Events.EVENT_SCROLL_VISIBILITY_CHANGED = 'scrollVisibilityChanged';
	    Events.EVENT_COLUMN_HOVER_CHANGED = 'columnHoverChanged';
	    Events.EVENT_FLASH_CELLS = 'flashCells';
	    Events.EVENT_ROW_DRAG_ENTER = 'rowDragEnter';
	    Events.EVENT_ROW_DRAG_MOVE = 'rowDragMove';
	    Events.EVENT_ROW_DRAG_LEAVE = 'rowDragLeave';
	    Events.EVENT_ROW_DRAG_END = 'rowDragEnd';
	    // these are used for server side group and agg - only used by CS with Viewport Row Model - intention is
	    // to design these better around server side functions and then release to general public when fully working with
	    // all the row models.
	    Events.EVENT_COLUMN_ROW_GROUP_CHANGE_REQUEST = 'columnRowGroupChangeRequest';
	    Events.EVENT_COLUMN_PIVOT_CHANGE_REQUEST = 'columnPivotChangeRequest';
	    Events.EVENT_COLUMN_VALUE_CHANGE_REQUEST = 'columnValueChangeRequest';
	    Events.EVENT_COLUMN_AGG_FUNC_CHANGE_REQUEST = 'columnAggFuncChangeRequest';
	    return Events;
	}());
	exports.Events = Events;


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var columnApi_1 = __webpack_require__(38);
	var columnController_1 = __webpack_require__(26);
	var gridApi_1 = __webpack_require__(33);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var expressionService_1 = __webpack_require__(121);
	var rowRenderer_1 = __webpack_require__(91);
	var templateService_1 = __webpack_require__(445);
	var valueService_1 = __webpack_require__(103);
	var eventService_1 = __webpack_require__(22);
	var columnAnimationService_1 = __webpack_require__(321);
	var focusedCellController_1 = __webpack_require__(119);
	var cellRendererFactory_1 = __webpack_require__(320);
	var popupService_1 = __webpack_require__(137);
	var valueFormatterService_1 = __webpack_require__(253);
	var stylingService_1 = __webpack_require__(444);
	var columnHoverService_1 = __webpack_require__(252);
	var paginationProxy_1 = __webpack_require__(135);
	var animationFrameService_1 = __webpack_require__(197);
	var userComponentFactory_1 = __webpack_require__(81);
	var dragAndDropService_1 = __webpack_require__(82);
	var sortController_1 = __webpack_require__(120);
	var filterManager_1 = __webpack_require__(77);
	var maxDivHeightScaler_1 = __webpack_require__(323);
	var tooltipManager_1 = __webpack_require__(451);
	var detailRowCompCache_1 = __webpack_require__(663);
	var cellPosition_1 = __webpack_require__(421);
	var rowPosition_1 = __webpack_require__(315);
	/** Using the IoC has a slight performance consideration, which is no problem most of the
	 * time, unless we are trashing objects - which is the case when scrolling and rowComp
	 * and cellComp. So for performance reasons, RowComp and CellComp do not get autowired
	 * with the IoC. Instead they get passed this object which is all the beans the RowComp
	 * and CellComp need. Not autowiring all the cells gives performance improvement. */
	var Beans = /** @class */ (function () {
	    function Beans() {
	    }
	    Beans.prototype.registerGridComp = function (gridPanel) {
	        this.gridPanel = gridPanel;
	    };
	    Beans.prototype.postConstruct = function () {
	        this.doingMasterDetail = this.gridOptionsWrapper.isMasterDetail();
	    };
	    __decorate([
	        context_1.Autowired('paginationProxy'),
	        __metadata("design:type", paginationProxy_1.PaginationProxy)
	    ], Beans.prototype, "paginationProxy", void 0);
	    __decorate([
	        context_1.Autowired('context'),
	        __metadata("design:type", context_1.Context)
	    ], Beans.prototype, "context", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], Beans.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], Beans.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], Beans.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('expressionService'),
	        __metadata("design:type", expressionService_1.ExpressionService)
	    ], Beans.prototype, "expressionService", void 0);
	    __decorate([
	        context_1.Autowired('rowRenderer'),
	        __metadata("design:type", rowRenderer_1.RowRenderer)
	    ], Beans.prototype, "rowRenderer", void 0);
	    __decorate([
	        context_1.Autowired('$compile'),
	        __metadata("design:type", Object)
	    ], Beans.prototype, "$compile", void 0);
	    __decorate([
	        context_1.Autowired('templateService'),
	        __metadata("design:type", templateService_1.TemplateService)
	    ], Beans.prototype, "templateService", void 0);
	    __decorate([
	        context_1.Autowired('valueService'),
	        __metadata("design:type", valueService_1.ValueService)
	    ], Beans.prototype, "valueService", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], Beans.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], Beans.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('columnAnimationService'),
	        __metadata("design:type", columnAnimationService_1.ColumnAnimationService)
	    ], Beans.prototype, "columnAnimationService", void 0);
	    __decorate([
	        context_1.Optional('rangeController'),
	        __metadata("design:type", Object)
	    ], Beans.prototype, "rangeController", void 0);
	    __decorate([
	        context_1.Autowired('focusedCellController'),
	        __metadata("design:type", focusedCellController_1.FocusedCellController)
	    ], Beans.prototype, "focusedCellController", void 0);
	    __decorate([
	        context_1.Optional('contextMenuFactory'),
	        __metadata("design:type", Object)
	    ], Beans.prototype, "contextMenuFactory", void 0);
	    __decorate([
	        context_1.Autowired('cellRendererFactory'),
	        __metadata("design:type", cellRendererFactory_1.CellRendererFactory)
	    ], Beans.prototype, "cellRendererFactory", void 0);
	    __decorate([
	        context_1.Autowired('popupService'),
	        __metadata("design:type", popupService_1.PopupService)
	    ], Beans.prototype, "popupService", void 0);
	    __decorate([
	        context_1.Autowired('valueFormatterService'),
	        __metadata("design:type", valueFormatterService_1.ValueFormatterService)
	    ], Beans.prototype, "valueFormatterService", void 0);
	    __decorate([
	        context_1.Autowired('stylingService'),
	        __metadata("design:type", stylingService_1.StylingService)
	    ], Beans.prototype, "stylingService", void 0);
	    __decorate([
	        context_1.Autowired('columnHoverService'),
	        __metadata("design:type", columnHoverService_1.ColumnHoverService)
	    ], Beans.prototype, "columnHoverService", void 0);
	    __decorate([
	        context_1.Autowired('enterprise'),
	        __metadata("design:type", Boolean)
	    ], Beans.prototype, "enterprise", void 0);
	    __decorate([
	        context_1.Autowired('userComponentFactory'),
	        __metadata("design:type", userComponentFactory_1.UserComponentFactory)
	    ], Beans.prototype, "userComponentFactory", void 0);
	    __decorate([
	        context_1.Autowired('animationFrameService'),
	        __metadata("design:type", animationFrameService_1.AnimationFrameService)
	    ], Beans.prototype, "taskQueue", void 0);
	    __decorate([
	        context_1.Autowired('dragAndDropService'),
	        __metadata("design:type", dragAndDropService_1.DragAndDropService)
	    ], Beans.prototype, "dragAndDropService", void 0);
	    __decorate([
	        context_1.Autowired('sortController'),
	        __metadata("design:type", sortController_1.SortController)
	    ], Beans.prototype, "sortController", void 0);
	    __decorate([
	        context_1.Autowired('filterManager'),
	        __metadata("design:type", filterManager_1.FilterManager)
	    ], Beans.prototype, "filterManager", void 0);
	    __decorate([
	        context_1.Autowired('maxDivHeightScaler'),
	        __metadata("design:type", maxDivHeightScaler_1.MaxDivHeightScaler)
	    ], Beans.prototype, "maxDivHeightScaler", void 0);
	    __decorate([
	        context_1.Autowired('tooltipManager'),
	        __metadata("design:type", tooltipManager_1.TooltipManager)
	    ], Beans.prototype, "tooltipManager", void 0);
	    __decorate([
	        context_1.Autowired('frameworkOverrides'),
	        __metadata("design:type", Object)
	    ], Beans.prototype, "frameworkOverrides", void 0);
	    __decorate([
	        context_1.Autowired('detailRowCompCache'),
	        __metadata("design:type", detailRowCompCache_1.DetailRowCompCache)
	    ], Beans.prototype, "detailRowCompCache", void 0);
	    __decorate([
	        context_1.Autowired('cellPositionUtils'),
	        __metadata("design:type", cellPosition_1.CellPositionUtils)
	    ], Beans.prototype, "cellPositionUtils", void 0);
	    __decorate([
	        context_1.Autowired('rowPositionUtils'),
	        __metadata("design:type", rowPosition_1.RowPositionUtils)
	    ], Beans.prototype, "rowPositionUtils", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], Beans.prototype, "postConstruct", null);
	    Beans = __decorate([
	        context_1.Bean('beans')
	    ], Beans);
	    return Beans;
	}());
	exports.Beans = Beans;


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var agAbstractLabel_1 = __webpack_require__(446);
	var utils_1 = __webpack_require__(10);
	var AgAbstractField = /** @class */ (function (_super) {
	    __extends(AgAbstractField, _super);
	    function AgAbstractField() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    AgAbstractField.prototype.onValueChange = function (callbackFn) {
	        var _this = this;
	        this.addDestroyableEventListener(this, AgAbstractField.EVENT_CHANGED, function () {
	            callbackFn(_this.getValue());
	        });
	        return this;
	    };
	    AgAbstractField.prototype.getWidth = function () {
	        return this.getGui().clientWidth;
	    };
	    AgAbstractField.prototype.setWidth = function (width) {
	        utils_1._.setFixedWidth(this.getGui(), width);
	        return this;
	    };
	    AgAbstractField.prototype.getValue = function () {
	        return this.value;
	    };
	    AgAbstractField.prototype.setValue = function (value, silent) {
	        if (this.value === value) {
	            return this;
	        }
	        this.value = value;
	        if (!silent) {
	            this.dispatchEvent({ type: AgAbstractField.EVENT_CHANGED });
	        }
	        return this;
	    };
	    AgAbstractField.EVENT_CHANGED = 'valueChange';
	    return AgAbstractField;
	}(agAbstractLabel_1.AgAbstractLabel));
	exports.AgAbstractField = AgAbstractField;


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var globalObj = typeof global === 'undefined' ? {} : global;
	globalObj.HTMLElement = typeof HTMLElement === 'undefined' ? {} : HTMLElement;
	globalObj.HTMLButtonElement = typeof HTMLButtonElement === 'undefined' ? {} : HTMLButtonElement;
	globalObj.HTMLSelectElement = typeof HTMLSelectElement === 'undefined' ? {} : HTMLSelectElement;
	globalObj.HTMLInputElement = typeof HTMLInputElement === 'undefined' ? {} : HTMLInputElement;
	globalObj.Node = typeof Node === 'undefined' ? {} : Node;
	globalObj.MouseEvent = typeof MouseEvent === 'undefined' ? {} : MouseEvent;
	// columnController
	var columnFactory_1 = __webpack_require__(246);
	exports.ColumnFactory = columnFactory_1.ColumnFactory;
	var columnController_1 = __webpack_require__(26);
	exports.ColumnController = columnController_1.ColumnController;
	var columnKeyCreator_1 = __webpack_require__(640);
	exports.ColumnKeyCreator = columnKeyCreator_1.ColumnKeyCreator;
	var columnUtils_1 = __webpack_require__(195);
	exports.ColumnUtils = columnUtils_1.ColumnUtils;
	var displayedGroupCreator_1 = __webpack_require__(314);
	exports.DisplayedGroupCreator = displayedGroupCreator_1.DisplayedGroupCreator;
	var groupInstanceIdCreator_1 = __webpack_require__(416);
	exports.GroupInstanceIdCreator = groupInstanceIdCreator_1.GroupInstanceIdCreator;
	// components
	var componentUtil_1 = __webpack_require__(417);
	exports.ComponentUtil = componentUtil_1.ComponentUtil;
	var colDefUtil_1 = __webpack_require__(641);
	exports.ColDefUtil = colDefUtil_1.ColDefUtil;
	var userComponentRegistry_1 = __webpack_require__(420);
	exports.UserComponentRegistry = userComponentRegistry_1.UserComponentRegistry;
	var userComponentFactory_1 = __webpack_require__(81);
	exports.UserComponentFactory = userComponentFactory_1.UserComponentFactory;
	var agGridNg1_1 = __webpack_require__(1380);
	exports.initialiseAgGridWithAngular1 = agGridNg1_1.initialiseAgGridWithAngular1;
	var agGridWebComponent_1 = __webpack_require__(1381);
	exports.initialiseAgGridWithWebComponents = agGridWebComponent_1.initialiseAgGridWithWebComponents;
	// context
	var beanStub_1 = __webpack_require__(71);
	exports.BeanStub = beanStub_1.BeanStub;
	var context_1 = __webpack_require__(8);
	exports.Context = context_1.Context;
	exports.Autowired = context_1.Autowired;
	exports.PostConstruct = context_1.PostConstruct;
	exports.PreConstruct = context_1.PreConstruct;
	exports.Optional = context_1.Optional;
	exports.Bean = context_1.Bean;
	exports.Qualifier = context_1.Qualifier;
	exports.PreDestroy = context_1.PreDestroy;
	var componentAnnotations_1 = __webpack_require__(39);
	exports.QuerySelector = componentAnnotations_1.QuerySelector;
	exports.Listener = componentAnnotations_1.Listener;
	exports.RefSelector = componentAnnotations_1.RefSelector;
	// dragAndDrop
	var dragAndDropService_1 = __webpack_require__(82);
	exports.DragAndDropService = dragAndDropService_1.DragAndDropService;
	exports.DragSourceType = dragAndDropService_1.DragSourceType;
	exports.HDirection = dragAndDropService_1.HDirection;
	exports.VDirection = dragAndDropService_1.VDirection;
	var dragService_1 = __webpack_require__(158);
	exports.DragService = dragService_1.DragService;
	// entities
	var column_1 = __webpack_require__(45);
	exports.Column = column_1.Column;
	var columnGroup_1 = __webpack_require__(159);
	exports.ColumnGroup = columnGroup_1.ColumnGroup;
	var originalColumnGroup_1 = __webpack_require__(196);
	exports.OriginalColumnGroup = originalColumnGroup_1.OriginalColumnGroup;
	var rowNode_1 = __webpack_require__(101);
	exports.RowNode = rowNode_1.RowNode;
	// filter
	var filterManager_1 = __webpack_require__(77);
	exports.FilterManager = filterManager_1.FilterManager;
	var providedFilter_1 = __webpack_require__(317);
	exports.ProvidedFilter = providedFilter_1.ProvidedFilter;
	var simpleFilter_1 = __webpack_require__(134);
	exports.SimpleFilter = simpleFilter_1.SimpleFilter;
	var scalerFilter_1 = __webpack_require__(426);
	exports.ScalerFilter = scalerFilter_1.ScalerFilter;
	var numberFilter_1 = __webpack_require__(425);
	exports.NumberFilter = numberFilter_1.NumberFilter;
	var textFilter_1 = __webpack_require__(427);
	exports.TextFilter = textFilter_1.TextFilter;
	var dateFilter_1 = __webpack_require__(424);
	exports.DateFilter = dateFilter_1.DateFilter;
	// gridPanel
	var gridPanel_1 = __webpack_require__(429);
	exports.GridPanel = gridPanel_1.GridPanel;
	var scrollVisibleService_1 = __webpack_require__(249);
	exports.ScrollVisibleService = scrollVisibleService_1.ScrollVisibleService;
	var mouseEventService_1 = __webpack_require__(248);
	exports.MouseEventService = mouseEventService_1.MouseEventService;
	// headerRendering
	var bodyDropPivotTarget_1 = __webpack_require__(651);
	exports.BodyDropPivotTarget = bodyDropPivotTarget_1.BodyDropPivotTarget;
	var bodyDropTarget_1 = __webpack_require__(652);
	exports.BodyDropTarget = bodyDropTarget_1.BodyDropTarget;
	var cssClassApplier_1 = __webpack_require__(430);
	exports.CssClassApplier = cssClassApplier_1.CssClassApplier;
	var headerContainer_1 = __webpack_require__(654);
	exports.HeaderContainer = headerContainer_1.HeaderContainer;
	var headerRootComp_1 = __webpack_require__(431);
	exports.HeaderRootComp = headerRootComp_1.HeaderRootComp;
	var headerRowComp_1 = __webpack_require__(655);
	exports.HeaderRowComp = headerRowComp_1.HeaderRowComp;
	var horizontalResizeService_1 = __webpack_require__(318);
	exports.HorizontalResizeService = horizontalResizeService_1.HorizontalResizeService;
	var moveColumnController_1 = __webpack_require__(656);
	exports.MoveColumnController = moveColumnController_1.MoveColumnController;
	var standardMenu_1 = __webpack_require__(657);
	exports.StandardMenuFactory = standardMenu_1.StandardMenuFactory;
	// layout
	var tabbedLayout_1 = __webpack_require__(1397);
	exports.TabbedLayout = tabbedLayout_1.TabbedLayout;
	var verticalStack_1 = __webpack_require__(1398);
	exports.VerticalStack = verticalStack_1.VerticalStack;
	// misc
	var simpleHttpRequest_1 = __webpack_require__(1399);
	exports.simpleHttpRequest = simpleHttpRequest_1.simpleHttpRequest;
	var resizeObserverService_1 = __webpack_require__(319);
	exports.ResizeObserverService = resizeObserverService_1.ResizeObserverService;
	var largeTextCellEditor_1 = __webpack_require__(660);
	exports.LargeTextCellEditor = largeTextCellEditor_1.LargeTextCellEditor;
	var popupEditorWrapper_1 = __webpack_require__(434);
	exports.PopupEditorWrapper = popupEditorWrapper_1.PopupEditorWrapper;
	var popupSelectCellEditor_1 = __webpack_require__(661);
	exports.PopupSelectCellEditor = popupSelectCellEditor_1.PopupSelectCellEditor;
	var popupTextCellEditor_1 = __webpack_require__(662);
	exports.PopupTextCellEditor = popupTextCellEditor_1.PopupTextCellEditor;
	var selectCellEditor_1 = __webpack_require__(435);
	exports.SelectCellEditor = selectCellEditor_1.SelectCellEditor;
	var textCellEditor_1 = __webpack_require__(436);
	exports.TextCellEditor = textCellEditor_1.TextCellEditor;
	var animateShowChangeCellRenderer_1 = __webpack_require__(437);
	exports.AnimateShowChangeCellRenderer = animateShowChangeCellRenderer_1.AnimateShowChangeCellRenderer;
	var animateSlideCellRenderer_1 = __webpack_require__(438);
	exports.AnimateSlideCellRenderer = animateSlideCellRenderer_1.AnimateSlideCellRenderer;
	var groupCellRenderer_1 = __webpack_require__(439);
	exports.GroupCellRenderer = groupCellRenderer_1.GroupCellRenderer;
	// features
	var setLeftFeature_1 = __webpack_require__(322);
	exports.SetLeftFeature = setLeftFeature_1.SetLeftFeature;
	// rendering
	var autoWidthCalculator_1 = __webpack_require__(250);
	exports.AutoWidthCalculator = autoWidthCalculator_1.AutoWidthCalculator;
	var cellRendererFactory_1 = __webpack_require__(320);
	exports.CellRendererFactory = cellRendererFactory_1.CellRendererFactory;
	var checkboxSelectionComponent_1 = __webpack_require__(440);
	exports.CheckboxSelectionComponent = checkboxSelectionComponent_1.CheckboxSelectionComponent;
	var cellComp_1 = __webpack_require__(251);
	exports.CellComp = cellComp_1.CellComp;
	var rowComp_1 = __webpack_require__(441);
	exports.RowComp = rowComp_1.RowComp;
	var rowRenderer_1 = __webpack_require__(91);
	exports.RowRenderer = rowRenderer_1.RowRenderer;
	var valueFormatterService_1 = __webpack_require__(253);
	exports.ValueFormatterService = valueFormatterService_1.ValueFormatterService;
	// rowControllers/inMemory
	var filterStage_1 = __webpack_require__(668);
	exports.FilterStage = filterStage_1.FilterStage;
	var flattenStage_1 = __webpack_require__(669);
	exports.FlattenStage = flattenStage_1.FlattenStage;
	var sortStage_1 = __webpack_require__(671);
	exports.SortStage = sortStage_1.SortStage;
	// row models
	var pinnedRowModel_1 = __webpack_require__(136);
	exports.PinnedRowModel = pinnedRowModel_1.PinnedRowModel;
	var clientSideRowModel_1 = __webpack_require__(667);
	exports.ClientSideRowModel = clientSideRowModel_1.ClientSideRowModel;
	var changedPath_1 = __webpack_require__(325);
	exports.ChangedPath = changedPath_1.ChangedPath;
	var clientSideNodeManager_1 = __webpack_require__(666);
	exports.ClientSideNodeManager = clientSideNodeManager_1.ClientSideNodeManager;
	var infiniteRowModel_1 = __webpack_require__(672);
	exports.InfiniteRowModel = infiniteRowModel_1.InfiniteRowModel;
	var rowNodeBlock_1 = __webpack_require__(324);
	exports.RowNodeBlock = rowNodeBlock_1.RowNodeBlock;
	var rowNodeBlockLoader_1 = __webpack_require__(665);
	exports.RowNodeBlockLoader = rowNodeBlockLoader_1.RowNodeBlockLoader;
	var paginationProxy_1 = __webpack_require__(135);
	exports.PaginationProxy = paginationProxy_1.PaginationProxy;
	var rowNodeCache_1 = __webpack_require__(442);
	exports.RowNodeCache = rowNodeCache_1.RowNodeCache;
	//styling
	var stylingService_1 = __webpack_require__(444);
	exports.StylingService = stylingService_1.StylingService;
	// widgets
	var agAbstractField_1 = __webpack_require__(162);
	exports.AgAbstractField = agAbstractField_1.AgAbstractField;
	var agCheckbox_1 = __webpack_require__(199);
	exports.AgCheckbox = agCheckbox_1.AgCheckbox;
	var agRadioButton_1 = __webpack_require__(450);
	exports.AgRadioButton = agRadioButton_1.AgRadioButton;
	var agToggleButton_1 = __webpack_require__(683);
	exports.AgToggleButton = agToggleButton_1.AgToggleButton;
	var agInputTextField_1 = __webpack_require__(448);
	exports.AgInputTextField = agInputTextField_1.AgInputTextField;
	var agInputTextArea_1 = __webpack_require__(680);
	exports.AgInputTextArea = agInputTextArea_1.AgInputTextArea;
	var agInputNumberField_1 = __webpack_require__(327);
	exports.AgInputNumberField = agInputNumberField_1.AgInputNumberField;
	var agInputRange_1 = __webpack_require__(447);
	exports.AgInputRange = agInputRange_1.AgInputRange;
	var agSelect_1 = __webpack_require__(681);
	exports.AgSelect = agSelect_1.AgSelect;
	var agSlider_1 = __webpack_require__(682);
	exports.AgSlider = agSlider_1.AgSlider;
	var agAngleSelect_1 = __webpack_require__(677);
	exports.AgAngleSelect = agAngleSelect_1.AgAngleSelect;
	var agColorPicker_1 = __webpack_require__(678);
	exports.AgColorPicker = agColorPicker_1.AgColorPicker;
	var agGroupComponent_1 = __webpack_require__(679);
	exports.AgGroupComponent = agGroupComponent_1.AgGroupComponent;
	var agDialog_1 = __webpack_require__(326);
	exports.AgDialog = agDialog_1.AgDialog;
	var agPanel_1 = __webpack_require__(449);
	exports.AgPanel = agPanel_1.AgPanel;
	var messageBox_1 = __webpack_require__(1417);
	exports.MessageBox = messageBox_1.MessageBox;
	var component_1 = __webpack_require__(31);
	exports.Component = component_1.Component;
	var popupComponent_1 = __webpack_require__(200);
	exports.PopupComponent = popupComponent_1.PopupComponent;
	var popupService_1 = __webpack_require__(137);
	exports.PopupService = popupService_1.PopupService;
	var touchListener_1 = __webpack_require__(255);
	exports.TouchListener = touchListener_1.TouchListener;
	// range
	var iRangeController_1 = __webpack_require__(658);
	exports.CellRangeType = iRangeController_1.CellRangeType;
	// exporter
	var csvCreator_1 = __webpack_require__(422);
	exports.CsvCreator = csvCreator_1.CsvCreator;
	exports.BaseCreator = csvCreator_1.BaseCreator;
	var downloader_1 = __webpack_require__(423);
	exports.Downloader = downloader_1.Downloader;
	var xmlFactory_1 = __webpack_require__(644);
	exports.XmlFactory = xmlFactory_1.XmlFactory;
	var gridSerializer_1 = __webpack_require__(316);
	exports.BaseGridSerializingSession = gridSerializer_1.BaseGridSerializingSession;
	exports.GridSerializer = gridSerializer_1.GridSerializer;
	var gridSerializer_2 = __webpack_require__(316);
	exports.RowType = gridSerializer_2.RowType;
	var zipContainer_1 = __webpack_require__(643);
	exports.ZipContainer = zipContainer_1.ZipContainer;
	// root
	var vanillaFrameworkOverrides_1 = __webpack_require__(676);
	exports.VanillaFrameworkOverrides = vanillaFrameworkOverrides_1.VanillaFrameworkOverrides;
	var cellNavigationService_1 = __webpack_require__(415);
	exports.CellNavigationService = cellNavigationService_1.CellNavigationService;
	var alignedGridsService_1 = __webpack_require__(313);
	exports.AlignedGridsService = alignedGridsService_1.AlignedGridsService;
	var constants_1 = __webpack_require__(30);
	exports.Constants = constants_1.Constants;
	var grid_1 = __webpack_require__(428);
	exports.Grid = grid_1.Grid;
	var gridApi_1 = __webpack_require__(33);
	exports.GridApi = gridApi_1.GridApi;
	var eventKeys_1 = __webpack_require__(160);
	exports.Events = eventKeys_1.Events;
	var focusedCellController_1 = __webpack_require__(119);
	exports.FocusedCellController = focusedCellController_1.FocusedCellController;
	var functions_1 = __webpack_require__(1390);
	exports.defaultGroupComparator = functions_1.defaultGroupComparator;
	var gridOptionsWrapper_1 = __webpack_require__(14);
	exports.GridOptionsWrapper = gridOptionsWrapper_1.GridOptionsWrapper;
	var eventService_1 = __webpack_require__(22);
	exports.EventService = eventService_1.EventService;
	var selectableService_1 = __webpack_require__(443);
	exports.SelectableService = selectableService_1.SelectableService;
	var gridCore_1 = __webpack_require__(649);
	exports.GridCore = gridCore_1.GridCore;
	var logger_1 = __webpack_require__(68);
	exports.Logger = logger_1.Logger;
	var selectionController_1 = __webpack_require__(102);
	exports.SelectionController = selectionController_1.SelectionController;
	var sortController_1 = __webpack_require__(120);
	exports.SortController = sortController_1.SortController;
	var templateService_1 = __webpack_require__(445);
	exports.TemplateService = templateService_1.TemplateService;
	var utils_1 = __webpack_require__(10);
	exports.Color = utils_1.Color;
	exports.Utils = utils_1.Utils;
	exports.NumberSequence = utils_1.NumberSequence;
	exports._ = utils_1._;
	exports.Promise = utils_1.Promise;
	var valueService_1 = __webpack_require__(103);
	exports.ValueService = valueService_1.ValueService;
	var expressionService_1 = __webpack_require__(121);
	exports.ExpressionService = expressionService_1.ExpressionService;
	var logger_2 = __webpack_require__(68);
	exports.LoggerFactory = logger_2.LoggerFactory;
	var cellPosition_1 = __webpack_require__(421);
	exports.CellPositionUtils = cellPosition_1.CellPositionUtils;
	var rowPosition_1 = __webpack_require__(315);
	exports.RowPositionUtils = rowPosition_1.RowPositionUtils;
	var columnApi_1 = __webpack_require__(38);
	exports.ColumnApi = columnApi_1.ColumnApi;
	var frameworkComponentWrapper_1 = __webpack_require__(1382);
	exports.BaseComponentWrapper = frameworkComponentWrapper_1.BaseComponentWrapper;
	var environment_1 = __webpack_require__(247);
	exports.Environment = environment_1.Environment;
	var tooltipManager_1 = __webpack_require__(451);
	exports.TooltipManager = tooltipManager_1.TooltipManager;
	// charts
	var iChartOptions_1 = __webpack_require__(1396);
	exports.ChartType = iChartOptions_1.ChartType;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function retrieveTargetInfo(payload, validPayloadTypes, seriesModel) {
	  if (payload && zrUtil.indexOf(validPayloadTypes, payload.type) >= 0) {
	    var root = seriesModel.getData().tree.root;
	    var targetNode = payload.targetNode;
	
	    if (typeof targetNode === 'string') {
	      targetNode = root.getNodeById(targetNode);
	    }
	
	    if (targetNode && root.contains(targetNode)) {
	      return {
	        node: targetNode
	      };
	    }
	
	    var targetNodeId = payload.targetNodeId;
	
	    if (targetNodeId != null && (targetNode = root.getNodeById(targetNodeId))) {
	      return {
	        node: targetNode
	      };
	    }
	  }
	} // Not includes the given node at the last item.
	
	
	function getPathToRoot(node) {
	  var path = [];
	
	  while (node) {
	    node = node.parentNode;
	    node && path.push(node);
	  }
	
	  return path.reverse();
	}
	
	function aboveViewRoot(viewRoot, node) {
	  var viewPath = getPathToRoot(viewRoot);
	  return zrUtil.indexOf(viewPath, node) >= 0;
	} // From root to the input node (the input node will be included).
	
	
	function wrapTreePathInfo(node, seriesModel) {
	  var treePathInfo = [];
	
	  while (node) {
	    var nodeDataIndex = node.dataIndex;
	    treePathInfo.push({
	      name: node.name,
	      dataIndex: nodeDataIndex,
	      value: seriesModel.getRawValue(nodeDataIndex)
	    });
	    node = node.parentNode;
	  }
	
	  treePathInfo.reverse();
	  return treePathInfo;
	}
	
	exports.retrieveTargetInfo = retrieveTargetInfo;
	exports.getPathToRoot = getPathToRoot;
	exports.aboveViewRoot = aboveViewRoot;
	exports.wrapTreePathInfo = wrapTreePathInfo;

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(13);
	
	var axisPointerModelHelper = __webpack_require__(332);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Base class of AxisView.
	 */
	var AxisView = echarts.extendComponentView({
	  type: 'axis',
	
	  /**
	   * @private
	   */
	  _axisPointer: null,
	
	  /**
	   * @protected
	   * @type {string}
	   */
	  axisPointerClass: null,
	
	  /**
	   * @override
	   */
	  render: function (axisModel, ecModel, api, payload) {
	    // FIXME
	    // This process should proformed after coordinate systems updated
	    // (axis scale updated), and should be performed each time update.
	    // So put it here temporarily, although it is not appropriate to
	    // put a model-writing procedure in `view`.
	    this.axisPointerClass && axisPointerModelHelper.fixValue(axisModel);
	    AxisView.superApply(this, 'render', arguments);
	    updateAxisPointer(this, axisModel, ecModel, api, payload, true);
	  },
	
	  /**
	   * Action handler.
	   * @public
	   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
	   * @param {module:echarts/model/Global} ecModel
	   * @param {module:echarts/ExtensionAPI} api
	   * @param {Object} payload
	   */
	  updateAxisPointer: function (axisModel, ecModel, api, payload, force) {
	    updateAxisPointer(this, axisModel, ecModel, api, payload, false);
	  },
	
	  /**
	   * @override
	   */
	  remove: function (ecModel, api) {
	    var axisPointer = this._axisPointer;
	    axisPointer && axisPointer.remove(api);
	    AxisView.superApply(this, 'remove', arguments);
	  },
	
	  /**
	   * @override
	   */
	  dispose: function (ecModel, api) {
	    disposeAxisPointer(this, api);
	    AxisView.superApply(this, 'dispose', arguments);
	  }
	});
	
	function updateAxisPointer(axisView, axisModel, ecModel, api, payload, forceRender) {
	  var Clazz = AxisView.getAxisPointerClass(axisView.axisPointerClass);
	
	  if (!Clazz) {
	    return;
	  }
	
	  var axisPointerModel = axisPointerModelHelper.getAxisPointerModel(axisModel);
	  axisPointerModel ? (axisView._axisPointer || (axisView._axisPointer = new Clazz())).render(axisModel, axisPointerModel, api, forceRender) : disposeAxisPointer(axisView, api);
	}
	
	function disposeAxisPointer(axisView, ecModel, api) {
	  var axisPointer = axisView._axisPointer;
	  axisPointer && axisPointer.dispose(ecModel, api);
	  axisView._axisPointer = null;
	}
	
	var axisPointerClazz = [];
	
	AxisView.registerAxisPointerClass = function (type, clazz) {
	  axisPointerClazz[type] = clazz;
	};
	
	AxisView.getAxisPointerClass = function (type) {
	  return type && axisPointerClazz[type];
	};
	
	var _default = AxisView;
	module.exports = _default;

/***/ },
/* 166 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function defaultKeyGetter(item) {
	  return item;
	}
	/**
	 * @param {Array} oldArr
	 * @param {Array} newArr
	 * @param {Function} oldKeyGetter
	 * @param {Function} newKeyGetter
	 * @param {Object} [context] Can be visited by this.context in callback.
	 */
	
	
	function DataDiffer(oldArr, newArr, oldKeyGetter, newKeyGetter, context) {
	  this._old = oldArr;
	  this._new = newArr;
	  this._oldKeyGetter = oldKeyGetter || defaultKeyGetter;
	  this._newKeyGetter = newKeyGetter || defaultKeyGetter;
	  this.context = context;
	}
	
	DataDiffer.prototype = {
	  constructor: DataDiffer,
	
	  /**
	   * Callback function when add a data
	   */
	  add: function (func) {
	    this._add = func;
	    return this;
	  },
	
	  /**
	   * Callback function when update a data
	   */
	  update: function (func) {
	    this._update = func;
	    return this;
	  },
	
	  /**
	   * Callback function when remove a data
	   */
	  remove: function (func) {
	    this._remove = func;
	    return this;
	  },
	  execute: function () {
	    var oldArr = this._old;
	    var newArr = this._new;
	    var oldDataIndexMap = {};
	    var newDataIndexMap = {};
	    var oldDataKeyArr = [];
	    var newDataKeyArr = [];
	    var i;
	    initIndexMap(oldArr, oldDataIndexMap, oldDataKeyArr, '_oldKeyGetter', this);
	    initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter', this);
	
	    for (i = 0; i < oldArr.length; i++) {
	      var key = oldDataKeyArr[i];
	      var idx = newDataIndexMap[key]; // idx can never be empty array here. see 'set null' logic below.
	
	      if (idx != null) {
	        // Consider there is duplicate key (for example, use dataItem.name as key).
	        // We should make sure every item in newArr and oldArr can be visited.
	        var len = idx.length;
	
	        if (len) {
	          len === 1 && (newDataIndexMap[key] = null);
	          idx = idx.shift();
	        } else {
	          newDataIndexMap[key] = null;
	        }
	
	        this._update && this._update(idx, i);
	      } else {
	        this._remove && this._remove(i);
	      }
	    }
	
	    for (var i = 0; i < newDataKeyArr.length; i++) {
	      var key = newDataKeyArr[i];
	
	      if (newDataIndexMap.hasOwnProperty(key)) {
	        var idx = newDataIndexMap[key];
	
	        if (idx == null) {
	          continue;
	        } // idx can never be empty array here. see 'set null' logic above.
	
	
	        if (!idx.length) {
	          this._add && this._add(idx);
	        } else {
	          for (var j = 0, len = idx.length; j < len; j++) {
	            this._add && this._add(idx[j]);
	          }
	        }
	      }
	    }
	  }
	};
	
	function initIndexMap(arr, map, keyArr, keyGetterName, dataDiffer) {
	  for (var i = 0; i < arr.length; i++) {
	    // Add prefix to avoid conflict with Object.prototype.
	    var key = '_ec_' + dataDiffer[keyGetterName](arr[i], i);
	    var existence = map[key];
	
	    if (existence == null) {
	      keyArr.push(key);
	      map[key] = i;
	    } else {
	      if (!existence.length) {
	        map[key] = existence = [existence];
	      }
	
	      existence.push(i);
	    }
	  }
	}
	
	var _default = DataDiffer;
	module.exports = _default;

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	var _util = __webpack_require__(3);
	
	var isTypedArray = _util.isTypedArray;
	var extend = _util.extend;
	var assert = _util.assert;
	var each = _util.each;
	var isObject = _util.isObject;
	
	var _model = __webpack_require__(24);
	
	var getDataItemValue = _model.getDataItemValue;
	var isDataItemOption = _model.isDataItemOption;
	
	var _number = __webpack_require__(20);
	
	var parseDate = _number.parseDate;
	
	var Source = __webpack_require__(263);
	
	var _sourceType = __webpack_require__(265);
	
	var SOURCE_FORMAT_TYPED_ARRAY = _sourceType.SOURCE_FORMAT_TYPED_ARRAY;
	var SOURCE_FORMAT_ARRAY_ROWS = _sourceType.SOURCE_FORMAT_ARRAY_ROWS;
	var SOURCE_FORMAT_ORIGINAL = _sourceType.SOURCE_FORMAT_ORIGINAL;
	var SOURCE_FORMAT_OBJECT_ROWS = _sourceType.SOURCE_FORMAT_OBJECT_ROWS;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// TODO
	// ??? refactor? check the outer usage of data provider.
	// merge with defaultDimValueGetter?
	
	/**
	 * If normal array used, mutable chunk size is supported.
	 * If typed array used, chunk size must be fixed.
	 */
	function DefaultDataProvider(source, dimSize) {
	  if (!Source.isInstance(source)) {
	    source = Source.seriesDataToSource(source);
	  }
	
	  this._source = source;
	  var data = this._data = source.data;
	  var sourceFormat = source.sourceFormat; // Typed array. TODO IE10+?
	
	  if (sourceFormat === SOURCE_FORMAT_TYPED_ARRAY) {
	    this._offset = 0;
	    this._dimSize = dimSize;
	    this._data = data;
	  }
	
	  var methods = providerMethods[sourceFormat === SOURCE_FORMAT_ARRAY_ROWS ? sourceFormat + '_' + source.seriesLayoutBy : sourceFormat];
	  extend(this, methods);
	}
	
	var providerProto = DefaultDataProvider.prototype; // If data is pure without style configuration
	
	providerProto.pure = false; // If data is persistent and will not be released after use.
	
	providerProto.persistent = true; // ???! FIXME legacy data provider do not has method getSource
	
	providerProto.getSource = function () {
	  return this._source;
	};
	
	var providerMethods = {
	  'arrayRows_column': {
	    pure: true,
	    count: function () {
	      return Math.max(0, this._data.length - this._source.startIndex);
	    },
	    getItem: function (idx) {
	      return this._data[idx + this._source.startIndex];
	    },
	    appendData: appendDataSimply
	  },
	  'arrayRows_row': {
	    pure: true,
	    count: function () {
	      var row = this._data[0];
	      return row ? Math.max(0, row.length - this._source.startIndex) : 0;
	    },
	    getItem: function (idx) {
	      idx += this._source.startIndex;
	      var item = [];
	      var data = this._data;
	
	      for (var i = 0; i < data.length; i++) {
	        var row = data[i];
	        item.push(row ? row[idx] : null);
	      }
	
	      return item;
	    },
	    appendData: function () {
	      throw new Error('Do not support appendData when set seriesLayoutBy: "row".');
	    }
	  },
	  'objectRows': {
	    pure: true,
	    count: countSimply,
	    getItem: getItemSimply,
	    appendData: appendDataSimply
	  },
	  'keyedColumns': {
	    pure: true,
	    count: function () {
	      var dimName = this._source.dimensionsDefine[0].name;
	      var col = this._data[dimName];
	      return col ? col.length : 0;
	    },
	    getItem: function (idx) {
	      var item = [];
	      var dims = this._source.dimensionsDefine;
	
	      for (var i = 0; i < dims.length; i++) {
	        var col = this._data[dims[i].name];
	        item.push(col ? col[idx] : null);
	      }
	
	      return item;
	    },
	    appendData: function (newData) {
	      var data = this._data;
	      each(newData, function (newCol, key) {
	        var oldCol = data[key] || (data[key] = []);
	
	        for (var i = 0; i < (newCol || []).length; i++) {
	          oldCol.push(newCol[i]);
	        }
	      });
	    }
	  },
	  'original': {
	    count: countSimply,
	    getItem: getItemSimply,
	    appendData: appendDataSimply
	  },
	  'typedArray': {
	    persistent: false,
	    pure: true,
	    count: function () {
	      return this._data ? this._data.length / this._dimSize : 0;
	    },
	    getItem: function (idx, out) {
	      idx = idx - this._offset;
	      out = out || [];
	      var offset = this._dimSize * idx;
	
	      for (var i = 0; i < this._dimSize; i++) {
	        out[i] = this._data[offset + i];
	      }
	
	      return out;
	    },
	    appendData: function (newData) {
	      this._data = newData;
	    },
	    // Clean self if data is already used.
	    clean: function () {
	      // PENDING
	      this._offset += this.count();
	      this._data = null;
	    }
	  }
	};
	
	function countSimply() {
	  return this._data.length;
	}
	
	function getItemSimply(idx) {
	  return this._data[idx];
	}
	
	function appendDataSimply(newData) {
	  for (var i = 0; i < newData.length; i++) {
	    this._data.push(newData[i]);
	  }
	}
	
	var rawValueGetters = {
	  arrayRows: getRawValueSimply,
	  objectRows: function (dataItem, dataIndex, dimIndex, dimName) {
	    return dimIndex != null ? dataItem[dimName] : dataItem;
	  },
	  keyedColumns: getRawValueSimply,
	  original: function (dataItem, dataIndex, dimIndex, dimName) {
	    // FIXME
	    // In some case (markpoint in geo (geo-map.html)), dataItem
	    // is {coord: [...]}
	    var value = getDataItemValue(dataItem);
	    return dimIndex == null || !(value instanceof Array) ? value : value[dimIndex];
	  },
	  typedArray: getRawValueSimply
	};
	
	function getRawValueSimply(dataItem, dataIndex, dimIndex, dimName) {
	  return dimIndex != null ? dataItem[dimIndex] : dataItem;
	}
	
	var defaultDimValueGetters = {
	  arrayRows: getDimValueSimply,
	  objectRows: function (dataItem, dimName, dataIndex, dimIndex) {
	    return converDataValue(dataItem[dimName], this._dimensionInfos[dimName]);
	  },
	  keyedColumns: getDimValueSimply,
	  original: function (dataItem, dimName, dataIndex, dimIndex) {
	    // Performance sensitive, do not use modelUtil.getDataItemValue.
	    // If dataItem is an plain object with no value field, the var `value`
	    // will be assigned with the object, but it will be tread correctly
	    // in the `convertDataValue`.
	    var value = dataItem && (dataItem.value == null ? dataItem : dataItem.value); // If any dataItem is like { value: 10 }
	
	    if (!this._rawData.pure && isDataItemOption(dataItem)) {
	      this.hasItemOption = true;
	    }
	
	    return converDataValue(value instanceof Array ? value[dimIndex] // If value is a single number or something else not array.
	    : value, this._dimensionInfos[dimName]);
	  },
	  typedArray: function (dataItem, dimName, dataIndex, dimIndex) {
	    return dataItem[dimIndex];
	  }
	};
	
	function getDimValueSimply(dataItem, dimName, dataIndex, dimIndex) {
	  return converDataValue(dataItem[dimIndex], this._dimensionInfos[dimName]);
	}
	/**
	 * This helper method convert value in data.
	 * @param {string|number|Date} value
	 * @param {Object|string} [dimInfo] If string (like 'x'), dimType defaults 'number'.
	 *        If "dimInfo.ordinalParseAndSave", ordinal value can be parsed.
	 */
	
	
	function converDataValue(value, dimInfo) {
	  // Performance sensitive.
	  var dimType = dimInfo && dimInfo.type;
	
	  if (dimType === 'ordinal') {
	    // If given value is a category string
	    var ordinalMeta = dimInfo && dimInfo.ordinalMeta;
	    return ordinalMeta ? ordinalMeta.parseAndCollect(value) : value;
	  }
	
	  if (dimType === 'time' // spead up when using timestamp
	  && typeof value !== 'number' && value != null && value !== '-') {
	    value = +parseDate(value);
	  } // dimType defaults 'number'.
	  // If dimType is not ordinal and value is null or undefined or NaN or '-',
	  // parse to NaN.
	
	
	  return value == null || value === '' ? NaN // If string (like '-'), using '+' parse to NaN
	  // If object, also parse to NaN
	  : +value;
	} // ??? FIXME can these logic be more neat: getRawValue, getRawDataItem,
	// Consider persistent.
	// Caution: why use raw value to display on label or tooltip?
	// A reason is to avoid format. For example time value we do not know
	// how to format is expected. More over, if stack is used, calculated
	// value may be 0.91000000001, which have brings trouble to display.
	// TODO: consider how to treat null/undefined/NaN when display?
	
	/**
	 * @param {module:echarts/data/List} data
	 * @param {number} dataIndex
	 * @param {string|number} [dim] dimName or dimIndex
	 * @return {Array.<number>|string|number} can be null/undefined.
	 */
	
	
	function retrieveRawValue(data, dataIndex, dim) {
	  if (!data) {
	    return;
	  } // Consider data may be not persistent.
	
	
	  var dataItem = data.getRawDataItem(dataIndex);
	
	  if (dataItem == null) {
	    return;
	  }
	
	  var sourceFormat = data.getProvider().getSource().sourceFormat;
	  var dimName;
	  var dimIndex;
	  var dimInfo = data.getDimensionInfo(dim);
	
	  if (dimInfo) {
	    dimName = dimInfo.name;
	    dimIndex = dimInfo.index;
	  }
	
	  return rawValueGetters[sourceFormat](dataItem, dataIndex, dimIndex, dimName);
	}
	/**
	 * Compatible with some cases (in pie, map) like:
	 * data: [{name: 'xx', value: 5, selected: true}, ...]
	 * where only sourceFormat is 'original' and 'objectRows' supported.
	 *
	 * ??? TODO
	 * Supported detail options in data item when using 'arrayRows'.
	 *
	 * @param {module:echarts/data/List} data
	 * @param {number} dataIndex
	 * @param {string} attr like 'selected'
	 */
	
	
	function retrieveRawAttr(data, dataIndex, attr) {
	  if (!data) {
	    return;
	  }
	
	  var sourceFormat = data.getProvider().getSource().sourceFormat;
	
	  if (sourceFormat !== SOURCE_FORMAT_ORIGINAL && sourceFormat !== SOURCE_FORMAT_OBJECT_ROWS) {
	    return;
	  }
	
	  var dataItem = data.getRawDataItem(dataIndex);
	
	  if (sourceFormat === SOURCE_FORMAT_ORIGINAL && !isObject(dataItem)) {
	    dataItem = null;
	  }
	
	  if (dataItem) {
	    return dataItem[attr];
	  }
	}
	
	exports.DefaultDataProvider = DefaultDataProvider;
	exports.defaultDimValueGetters = defaultDimValueGetters;
	exports.retrieveRawValue = retrieveRawValue;
	exports.retrieveRawAttr = retrieveRawAttr;

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var zrColor = __webpack_require__(114);
	
	var _number = __webpack_require__(20);
	
	var linearMap = _number.linearMap;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var isObject = zrUtil.isObject;
	var CATEGORY_DEFAULT_VISUAL_INDEX = -1;
	/**
	 * @param {Object} option
	 * @param {string} [option.type] See visualHandlers.
	 * @param {string} [option.mappingMethod] 'linear' or 'piecewise' or 'category' or 'fixed'
	 * @param {Array.<number>=} [option.dataExtent] [minExtent, maxExtent],
	 *                                              required when mappingMethod is 'linear'
	 * @param {Array.<Object>=} [option.pieceList] [
	 *                                             {value: someValue},
	 *                                             {interval: [min1, max1], visual: {...}},
	 *                                             {interval: [min2, max2]}
	 *                                             ],
	 *                                            required when mappingMethod is 'piecewise'.
	 *                                            Visual for only each piece can be specified.
	 * @param {Array.<string|Object>=} [option.categories] ['cate1', 'cate2']
	 *                                            required when mappingMethod is 'category'.
	 *                                            If no option.categories, categories is set
	 *                                            as [0, 1, 2, ...].
	 * @param {boolean} [option.loop=false] Whether loop mapping when mappingMethod is 'category'.
	 * @param {(Array|Object|*)} [option.visual]  Visual data.
	 *                                            when mappingMethod is 'category',
	 *                                            visual data can be array or object
	 *                                            (like: {cate1: '#222', none: '#fff'})
	 *                                            or primary types (which represents
	 *                                            default category visual), otherwise visual
	 *                                            can be array or primary (which will be
	 *                                            normalized to array).
	 *
	 */
	
	var VisualMapping = function (option) {
	  var mappingMethod = option.mappingMethod;
	  var visualType = option.type;
	  /**
	   * @readOnly
	   * @type {Object}
	   */
	
	  var thisOption = this.option = zrUtil.clone(option);
	  /**
	   * @readOnly
	   * @type {string}
	   */
	
	  this.type = visualType;
	  /**
	   * @readOnly
	   * @type {string}
	   */
	
	  this.mappingMethod = mappingMethod;
	  /**
	   * @private
	   * @type {Function}
	   */
	
	  this._normalizeData = normalizers[mappingMethod];
	  var visualHandler = visualHandlers[visualType];
	  /**
	   * @public
	   * @type {Function}
	   */
	
	  this.applyVisual = visualHandler.applyVisual;
	  /**
	   * @public
	   * @type {Function}
	   */
	
	  this.getColorMapper = visualHandler.getColorMapper;
	  /**
	   * @private
	   * @type {Function}
	   */
	
	  this._doMap = visualHandler._doMap[mappingMethod];
	
	  if (mappingMethod === 'piecewise') {
	    normalizeVisualRange(thisOption);
	    preprocessForPiecewise(thisOption);
	  } else if (mappingMethod === 'category') {
	    thisOption.categories ? preprocessForSpecifiedCategory(thisOption) // categories is ordinal when thisOption.categories not specified,
	    // which need no more preprocess except normalize visual.
	    : normalizeVisualRange(thisOption, true);
	  } else {
	    // mappingMethod === 'linear' or 'fixed'
	    zrUtil.assert(mappingMethod !== 'linear' || thisOption.dataExtent);
	    normalizeVisualRange(thisOption);
	  }
	};
	
	VisualMapping.prototype = {
	  constructor: VisualMapping,
	  mapValueToVisual: function (value) {
	    var normalized = this._normalizeData(value);
	
	    return this._doMap(normalized, value);
	  },
	  getNormalizer: function () {
	    return zrUtil.bind(this._normalizeData, this);
	  }
	};
	var visualHandlers = VisualMapping.visualHandlers = {
	  color: {
	    applyVisual: makeApplyVisual('color'),
	
	    /**
	     * Create a mapper function
	     * @return {Function}
	     */
	    getColorMapper: function () {
	      var thisOption = this.option;
	      return zrUtil.bind(thisOption.mappingMethod === 'category' ? function (value, isNormalized) {
	        !isNormalized && (value = this._normalizeData(value));
	        return doMapCategory.call(this, value);
	      } : function (value, isNormalized, out) {
	        // If output rgb array
	        // which will be much faster and useful in pixel manipulation
	        var returnRGBArray = !!out;
	        !isNormalized && (value = this._normalizeData(value));
	        out = zrColor.fastLerp(value, thisOption.parsedVisual, out);
	        return returnRGBArray ? out : zrColor.stringify(out, 'rgba');
	      }, this);
	    },
	    _doMap: {
	      linear: function (normalized) {
	        return zrColor.stringify(zrColor.fastLerp(normalized, this.option.parsedVisual), 'rgba');
	      },
	      category: doMapCategory,
	      piecewise: function (normalized, value) {
	        var result = getSpecifiedVisual.call(this, value);
	
	        if (result == null) {
	          result = zrColor.stringify(zrColor.fastLerp(normalized, this.option.parsedVisual), 'rgba');
	        }
	
	        return result;
	      },
	      fixed: doMapFixed
	    }
	  },
	  colorHue: makePartialColorVisualHandler(function (color, value) {
	    return zrColor.modifyHSL(color, value);
	  }),
	  colorSaturation: makePartialColorVisualHandler(function (color, value) {
	    return zrColor.modifyHSL(color, null, value);
	  }),
	  colorLightness: makePartialColorVisualHandler(function (color, value) {
	    return zrColor.modifyHSL(color, null, null, value);
	  }),
	  colorAlpha: makePartialColorVisualHandler(function (color, value) {
	    return zrColor.modifyAlpha(color, value);
	  }),
	  opacity: {
	    applyVisual: makeApplyVisual('opacity'),
	    _doMap: makeDoMap([0, 1])
	  },
	  liftZ: {
	    applyVisual: makeApplyVisual('liftZ'),
	    _doMap: {
	      linear: doMapFixed,
	      category: doMapFixed,
	      piecewise: doMapFixed,
	      fixed: doMapFixed
	    }
	  },
	  symbol: {
	    applyVisual: function (value, getter, setter) {
	      var symbolCfg = this.mapValueToVisual(value);
	
	      if (zrUtil.isString(symbolCfg)) {
	        setter('symbol', symbolCfg);
	      } else if (isObject(symbolCfg)) {
	        for (var name in symbolCfg) {
	          if (symbolCfg.hasOwnProperty(name)) {
	            setter(name, symbolCfg[name]);
	          }
	        }
	      }
	    },
	    _doMap: {
	      linear: doMapToArray,
	      category: doMapCategory,
	      piecewise: function (normalized, value) {
	        var result = getSpecifiedVisual.call(this, value);
	
	        if (result == null) {
	          result = doMapToArray.call(this, normalized);
	        }
	
	        return result;
	      },
	      fixed: doMapFixed
	    }
	  },
	  symbolSize: {
	    applyVisual: makeApplyVisual('symbolSize'),
	    _doMap: makeDoMap([0, 1])
	  }
	};
	
	function preprocessForPiecewise(thisOption) {
	  var pieceList = thisOption.pieceList;
	  thisOption.hasSpecialVisual = false;
	  zrUtil.each(pieceList, function (piece, index) {
	    piece.originIndex = index; // piece.visual is "result visual value" but not
	    // a visual range, so it does not need to be normalized.
	
	    if (piece.visual != null) {
	      thisOption.hasSpecialVisual = true;
	    }
	  });
	}
	
	function preprocessForSpecifiedCategory(thisOption) {
	  // Hash categories.
	  var categories = thisOption.categories;
	  var visual = thisOption.visual;
	  var categoryMap = thisOption.categoryMap = {};
	  each(categories, function (cate, index) {
	    categoryMap[cate] = index;
	  }); // Process visual map input.
	
	  if (!zrUtil.isArray(visual)) {
	    var visualArr = [];
	
	    if (zrUtil.isObject(visual)) {
	      each(visual, function (v, cate) {
	        var index = categoryMap[cate];
	        visualArr[index != null ? index : CATEGORY_DEFAULT_VISUAL_INDEX] = v;
	      });
	    } else {
	      // Is primary type, represents default visual.
	      visualArr[CATEGORY_DEFAULT_VISUAL_INDEX] = visual;
	    }
	
	    visual = setVisualToOption(thisOption, visualArr);
	  } // Remove categories that has no visual,
	  // then we can mapping them to CATEGORY_DEFAULT_VISUAL_INDEX.
	
	
	  for (var i = categories.length - 1; i >= 0; i--) {
	    if (visual[i] == null) {
	      delete categoryMap[categories[i]];
	      categories.pop();
	    }
	  }
	}
	
	function normalizeVisualRange(thisOption, isCategory) {
	  var visual = thisOption.visual;
	  var visualArr = [];
	
	  if (zrUtil.isObject(visual)) {
	    each(visual, function (v) {
	      visualArr.push(v);
	    });
	  } else if (visual != null) {
	    visualArr.push(visual);
	  }
	
	  var doNotNeedPair = {
	    color: 1,
	    symbol: 1
	  };
	
	  if (!isCategory && visualArr.length === 1 && !doNotNeedPair.hasOwnProperty(thisOption.type)) {
	    // Do not care visualArr.length === 0, which is illegal.
	    visualArr[1] = visualArr[0];
	  }
	
	  setVisualToOption(thisOption, visualArr);
	}
	
	function makePartialColorVisualHandler(applyValue) {
	  return {
	    applyVisual: function (value, getter, setter) {
	      value = this.mapValueToVisual(value); // Must not be array value
	
	      setter('color', applyValue(getter('color'), value));
	    },
	    _doMap: makeDoMap([0, 1])
	  };
	}
	
	function doMapToArray(normalized) {
	  var visual = this.option.visual;
	  return visual[Math.round(linearMap(normalized, [0, 1], [0, visual.length - 1], true))] || {};
	}
	
	function makeApplyVisual(visualType) {
	  return function (value, getter, setter) {
	    setter(visualType, this.mapValueToVisual(value));
	  };
	}
	
	function doMapCategory(normalized) {
	  var visual = this.option.visual;
	  return visual[this.option.loop && normalized !== CATEGORY_DEFAULT_VISUAL_INDEX ? normalized % visual.length : normalized];
	}
	
	function doMapFixed() {
	  return this.option.visual[0];
	}
	
	function makeDoMap(sourceExtent) {
	  return {
	    linear: function (normalized) {
	      return linearMap(normalized, sourceExtent, this.option.visual, true);
	    },
	    category: doMapCategory,
	    piecewise: function (normalized, value) {
	      var result = getSpecifiedVisual.call(this, value);
	
	      if (result == null) {
	        result = linearMap(normalized, sourceExtent, this.option.visual, true);
	      }
	
	      return result;
	    },
	    fixed: doMapFixed
	  };
	}
	
	function getSpecifiedVisual(value) {
	  var thisOption = this.option;
	  var pieceList = thisOption.pieceList;
	
	  if (thisOption.hasSpecialVisual) {
	    var pieceIndex = VisualMapping.findPieceIndex(value, pieceList);
	    var piece = pieceList[pieceIndex];
	
	    if (piece && piece.visual) {
	      return piece.visual[this.type];
	    }
	  }
	}
	
	function setVisualToOption(thisOption, visualArr) {
	  thisOption.visual = visualArr;
	
	  if (thisOption.type === 'color') {
	    thisOption.parsedVisual = zrUtil.map(visualArr, function (item) {
	      return zrColor.parse(item);
	    });
	  }
	
	  return visualArr;
	}
	/**
	 * Normalizers by mapping methods.
	 */
	
	
	var normalizers = {
	  linear: function (value) {
	    return linearMap(value, this.option.dataExtent, [0, 1], true);
	  },
	  piecewise: function (value) {
	    var pieceList = this.option.pieceList;
	    var pieceIndex = VisualMapping.findPieceIndex(value, pieceList, true);
	
	    if (pieceIndex != null) {
	      return linearMap(pieceIndex, [0, pieceList.length - 1], [0, 1], true);
	    }
	  },
	  category: function (value) {
	    var index = this.option.categories ? this.option.categoryMap[value] : value; // ordinal
	
	    return index == null ? CATEGORY_DEFAULT_VISUAL_INDEX : index;
	  },
	  fixed: zrUtil.noop
	};
	/**
	 * List available visual types.
	 *
	 * @public
	 * @return {Array.<string>}
	 */
	
	VisualMapping.listVisualTypes = function () {
	  var visualTypes = [];
	  zrUtil.each(visualHandlers, function (handler, key) {
	    visualTypes.push(key);
	  });
	  return visualTypes;
	};
	/**
	 * @public
	 */
	
	
	VisualMapping.addVisualHandler = function (name, handler) {
	  visualHandlers[name] = handler;
	};
	/**
	 * @public
	 */
	
	
	VisualMapping.isValidType = function (visualType) {
	  return visualHandlers.hasOwnProperty(visualType);
	};
	/**
	 * Convinent method.
	 * Visual can be Object or Array or primary type.
	 *
	 * @public
	 */
	
	
	VisualMapping.eachVisual = function (visual, callback, context) {
	  if (zrUtil.isObject(visual)) {
	    zrUtil.each(visual, callback, context);
	  } else {
	    callback.call(context, visual);
	  }
	};
	
	VisualMapping.mapVisual = function (visual, callback, context) {
	  var isPrimary;
	  var newVisual = zrUtil.isArray(visual) ? [] : zrUtil.isObject(visual) ? {} : (isPrimary = true, null);
	  VisualMapping.eachVisual(visual, function (v, key) {
	    var newVal = callback.call(context, v, key);
	    isPrimary ? newVisual = newVal : newVisual[key] = newVal;
	  });
	  return newVisual;
	};
	/**
	 * @public
	 * @param {Object} obj
	 * @return {Object} new object containers visual values.
	 *                 If no visuals, return null.
	 */
	
	
	VisualMapping.retrieveVisuals = function (obj) {
	  var ret = {};
	  var hasVisual;
	  obj && each(visualHandlers, function (h, visualType) {
	    if (obj.hasOwnProperty(visualType)) {
	      ret[visualType] = obj[visualType];
	      hasVisual = true;
	    }
	  });
	  return hasVisual ? ret : null;
	};
	/**
	 * Give order to visual types, considering colorSaturation, colorAlpha depends on color.
	 *
	 * @public
	 * @param {(Object|Array)} visualTypes If Object, like: {color: ..., colorSaturation: ...}
	 *                                     IF Array, like: ['color', 'symbol', 'colorSaturation']
	 * @return {Array.<string>} Sorted visual types.
	 */
	
	
	VisualMapping.prepareVisualTypes = function (visualTypes) {
	  if (isObject(visualTypes)) {
	    var types = [];
	    each(visualTypes, function (item, type) {
	      types.push(type);
	    });
	    visualTypes = types;
	  } else if (zrUtil.isArray(visualTypes)) {
	    visualTypes = visualTypes.slice();
	  } else {
	    return [];
	  }
	
	  visualTypes.sort(function (type1, type2) {
	    // color should be front of colorSaturation, colorAlpha, ...
	    // symbol and symbolSize do not matter.
	    return type2 === 'color' && type1 !== 'color' && type1.indexOf('color') === 0 ? 1 : -1;
	  });
	  return visualTypes;
	};
	/**
	 * 'color', 'colorSaturation', 'colorAlpha', ... are depends on 'color'.
	 * Other visuals are only depends on themself.
	 *
	 * @public
	 * @param {string} visualType1
	 * @param {string} visualType2
	 * @return {boolean}
	 */
	
	
	VisualMapping.dependsOn = function (visualType1, visualType2) {
	  return visualType2 === 'color' ? !!(visualType1 && visualType1.indexOf(visualType2) === 0) : visualType1 === visualType2;
	};
	/**
	 * @param {number} value
	 * @param {Array.<Object>} pieceList [{value: ..., interval: [min, max]}, ...]
	 *                         Always from small to big.
	 * @param {boolean} [findClosestWhenOutside=false]
	 * @return {number} index
	 */
	
	
	VisualMapping.findPieceIndex = function (value, pieceList, findClosestWhenOutside) {
	  var possibleI;
	  var abs = Infinity; // value has the higher priority.
	
	  for (var i = 0, len = pieceList.length; i < len; i++) {
	    var pieceValue = pieceList[i].value;
	
	    if (pieceValue != null) {
	      if (pieceValue === value // FIXME
	      // It is supposed to compare value according to value type of dimension,
	      // but currently value type can exactly be string or number.
	      // Compromise for numeric-like string (like '12'), especially
	      // in the case that visualMap.categories is ['22', '33'].
	      || typeof pieceValue === 'string' && pieceValue === value + '') {
	        return i;
	      }
	
	      findClosestWhenOutside && updatePossible(pieceValue, i);
	    }
	  }
	
	  for (var i = 0, len = pieceList.length; i < len; i++) {
	    var piece = pieceList[i];
	    var interval = piece.interval;
	    var close = piece.close;
	
	    if (interval) {
	      if (interval[0] === -Infinity) {
	        if (littleThan(close[1], value, interval[1])) {
	          return i;
	        }
	      } else if (interval[1] === Infinity) {
	        if (littleThan(close[0], interval[0], value)) {
	          return i;
	        }
	      } else if (littleThan(close[0], interval[0], value) && littleThan(close[1], value, interval[1])) {
	        return i;
	      }
	
	      findClosestWhenOutside && updatePossible(interval[0], i);
	      findClosestWhenOutside && updatePossible(interval[1], i);
	    }
	  }
	
	  if (findClosestWhenOutside) {
	    return value === Infinity ? pieceList.length - 1 : value === -Infinity ? 0 : possibleI;
	  }
	
	  function updatePossible(val, index) {
	    var newAbs = Math.abs(val - value);
	
	    if (newAbs < abs) {
	      abs = newAbs;
	      possibleI = index;
	    }
	  }
	};
	
	function littleThan(close, a, b) {
	  return close ? a <= b : a < b;
	}
	
	var _default = VisualMapping;
	module.exports = _default;

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(3);
	
	var isFunction = _util.isFunction;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(seriesType, defaultSymbolType, legendSymbol) {
	  // Encoding visual for all series include which is filtered for legend drawing
	  return {
	    seriesType: seriesType,
	    // For legend.
	    performRawSeries: true,
	    reset: function (seriesModel, ecModel, api) {
	      var data = seriesModel.getData();
	      var symbolType = seriesModel.get('symbol');
	      var symbolSize = seriesModel.get('symbolSize');
	      var keepAspect = seriesModel.get('symbolKeepAspect');
	      var symbolRotate = seriesModel.get('symbolRotate');
	      var hasSymbolTypeCallback = isFunction(symbolType);
	      var hasSymbolSizeCallback = isFunction(symbolSize);
	      var hasSymbolRotateCallback = isFunction(symbolRotate);
	      var hasCallback = hasSymbolTypeCallback || hasSymbolSizeCallback || hasSymbolRotateCallback;
	      var seriesSymbol = !hasSymbolTypeCallback && symbolType ? symbolType : defaultSymbolType;
	      var seriesSymbolSize = !hasSymbolSizeCallback ? symbolSize : null;
	      var seriesSymbolRotate = !hasSymbolRotateCallback ? seriesSymbolRotate : null;
	      data.setVisual({
	        legendSymbol: legendSymbol || seriesSymbol,
	        // If seting callback functions on `symbol` or `symbolSize`, for simplicity and avoiding
	        // to bring trouble, we do not pick a reuslt from one of its calling on data item here,
	        // but just use the default value. Callback on `symbol` or `symbolSize` is convenient in
	        // some cases but generally it is not recommanded.
	        symbol: seriesSymbol,
	        symbolSize: seriesSymbolSize,
	        symbolKeepAspect: keepAspect,
	        symbolRotate: symbolRotate
	      }); // Only visible series has each data be visual encoded
	
	      if (ecModel.isSeriesFiltered(seriesModel)) {
	        return;
	      }
	
	      function dataEach(data, idx) {
	        if (hasCallback) {
	          var rawValue = seriesModel.getRawValue(idx);
	          var params = seriesModel.getDataParams(idx);
	          hasSymbolTypeCallback && data.setItemVisual(idx, 'symbol', symbolType(rawValue, params));
	          hasSymbolSizeCallback && data.setItemVisual(idx, 'symbolSize', symbolSize(rawValue, params));
	          hasSymbolRotateCallback && data.setItemVisual(idx, 'symbolRotate', symbolRotate(rawValue, params));
	        }
	
	        if (data.hasItemOption) {
	          var itemModel = data.getItemModel(idx);
	          var itemSymbolType = itemModel.getShallow('symbol', true);
	          var itemSymbolSize = itemModel.getShallow('symbolSize', true);
	          var itemSymbolRotate = itemModel.getShallow('symbolRotate', true);
	          var itemSymbolKeepAspect = itemModel.getShallow('symbolKeepAspect', true); // If has item symbol
	
	          if (itemSymbolType != null) {
	            data.setItemVisual(idx, 'symbol', itemSymbolType);
	          }
	
	          if (itemSymbolSize != null) {
	            // PENDING Transform symbolSize ?
	            data.setItemVisual(idx, 'symbolSize', itemSymbolSize);
	          }
	
	          if (itemSymbolRotate != null) {
	            data.setItemVisual(idx, 'symbolRotate', itemSymbolRotate);
	          }
	
	          if (itemSymbolKeepAspect != null) {
	            data.setItemVisual(idx, 'symbolKeepAspect', itemSymbolKeepAspect);
	          }
	        }
	      }
	
	      return {
	        dataEach: data.hasItemOption || hasCallback ? dataEach : null
	      };
	    }
	  };
	}
	
	module.exports = _default;

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(1739);
	
	module.exports = Function.prototype.bind || implementation;


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.extractPath = extractPath;
	exports.parsePath = parsePath;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(108);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function extractPath(string) {
	  var match = string.match(/^https?:\/\/[^\/]*/);
	
	  if (match == null) return string;
	
	  return string.substring(match[0].length);
	}
	
	function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	}

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var _extends = __webpack_require__(6);
	var isInBrowser = __webpack_require__(769);
	var warning = __webpack_require__(554);
	var _createClass = __webpack_require__(295);
	var _inheritsLoose = __webpack_require__(1103);
	var _assertThisInitialized = __webpack_require__(567);
	var _objectWithoutPropertiesLoose = __webpack_require__(570);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
	var isInBrowser__default = /*#__PURE__*/_interopDefaultLegacy(isInBrowser);
	var warning__default = /*#__PURE__*/_interopDefaultLegacy(warning);
	var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
	var _inheritsLoose__default = /*#__PURE__*/_interopDefaultLegacy(_inheritsLoose);
	var _assertThisInitialized__default = /*#__PURE__*/_interopDefaultLegacy(_assertThisInitialized);
	var _objectWithoutPropertiesLoose__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutPropertiesLoose);
	
	var plainObjectConstrurctor = {}.constructor;
	function cloneStyle(style) {
	  if (style == null || typeof style !== 'object') return style;
	  if (Array.isArray(style)) return style.map(cloneStyle);
	  if (style.constructor !== plainObjectConstrurctor) return style;
	  var newStyle = {};
	
	  for (var name in style) {
	    newStyle[name] = cloneStyle(style[name]);
	  }
	
	  return newStyle;
	}
	
	/**
	 * Create a rule instance.
	 */
	
	function createRule(name, decl, options) {
	  if (name === void 0) {
	    name = 'unnamed';
	  }
	
	  var jss = options.jss;
	  var declCopy = cloneStyle(decl);
	  var rule = jss.plugins.onCreateRule(name, declCopy, options);
	  if (rule) return rule; // It is an at-rule and it has no instance.
	
	  if (name[0] === '@') {
	     false ? warning__default['default'](false, "[JSS] Unknown rule " + name) : void 0;
	  }
	
	  return null;
	}
	
	var join = function join(value, by) {
	  var result = '';
	
	  for (var i = 0; i < value.length; i++) {
	    // Remove !important from the value, it will be readded later.
	    if (value[i] === '!important') break;
	    if (result) result += by;
	    result += value[i];
	  }
	
	  return result;
	};
	
	/**
	 * Converts array values to string.
	 *
	 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
	 * `border: ['1px', '2px']` > `border: 1px, 2px;`
	 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
	 * `color: ['red', !important]` > `color: red !important;`
	 */
	var toCssValue = function toCssValue(value, ignoreImportant) {
	  if (ignoreImportant === void 0) {
	    ignoreImportant = false;
	  }
	
	  if (!Array.isArray(value)) return value;
	  var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.
	
	  if (Array.isArray(value[0])) {
	    for (var i = 0; i < value.length; i++) {
	      if (value[i] === '!important') break;
	      if (cssValue) cssValue += ', ';
	      cssValue += join(value[i], ' ');
	    }
	  } else cssValue = join(value, ', '); // Add !important, because it was ignored.
	
	
	  if (!ignoreImportant && value[value.length - 1] === '!important') {
	    cssValue += ' !important';
	  }
	
	  return cssValue;
	};
	
	/**
	 * Indent a string.
	 * http://jsperf.com/array-join-vs-for
	 */
	function indentStr(str, indent) {
	  var result = '';
	
	  for (var index = 0; index < indent; index++) {
	    result += '  ';
	  }
	
	  return result + str;
	}
	/**
	 * Converts a Rule to CSS string.
	 */
	
	
	function toCss(selector, style, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var result = '';
	  if (!style) return result;
	  var _options = options,
	      _options$indent = _options.indent,
	      indent = _options$indent === void 0 ? 0 : _options$indent;
	  var fallbacks = style.fallbacks;
	  if (selector) indent++; // Apply fallbacks first.
	
	  if (fallbacks) {
	    // Array syntax {fallbacks: [{prop: value}]}
	    if (Array.isArray(fallbacks)) {
	      for (var index = 0; index < fallbacks.length; index++) {
	        var fallback = fallbacks[index];
	
	        for (var prop in fallback) {
	          var value = fallback[prop];
	
	          if (value != null) {
	            if (result) result += '\n';
	            result += "" + indentStr(prop + ": " + toCssValue(value) + ";", indent);
	          }
	        }
	      }
	    } else {
	      // Object syntax {fallbacks: {prop: value}}
	      for (var _prop in fallbacks) {
	        var _value = fallbacks[_prop];
	
	        if (_value != null) {
	          if (result) result += '\n';
	          result += "" + indentStr(_prop + ": " + toCssValue(_value) + ";", indent);
	        }
	      }
	    }
	  }
	
	  for (var _prop2 in style) {
	    var _value2 = style[_prop2];
	
	    if (_value2 != null && _prop2 !== 'fallbacks') {
	      if (result) result += '\n';
	      result += "" + indentStr(_prop2 + ": " + toCssValue(_value2) + ";", indent);
	    }
	  } // Allow empty style in this case, because properties will be added dynamically.
	
	
	  if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
	
	  if (!selector) return result;
	  indent--;
	  if (result) result = "\n" + result + "\n";
	  return indentStr(selector + " {" + result, indent) + indentStr('}', indent);
	}
	
	var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
	var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
	var escape = (function (str) {
	  return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
	});
	
	var BaseStyleRule =
	/*#__PURE__*/
	function () {
	  function BaseStyleRule(key, style, options) {
	    this.type = 'style';
	    this.key = void 0;
	    this.isProcessed = false;
	    this.style = void 0;
	    this.renderer = void 0;
	    this.renderable = void 0;
	    this.options = void 0;
	    var sheet = options.sheet,
	        Renderer = options.Renderer;
	    this.key = key;
	    this.options = options;
	    this.style = style;
	    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
	  }
	  /**
	   * Get or set a style property.
	   */
	
	
	  var _proto = BaseStyleRule.prototype;
	
	  _proto.prop = function prop(name, value, options) {
	    // It's a getter.
	    if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
	
	    var force = options ? options.force : false;
	    if (!force && this.style[name] === value) return this;
	    var newValue = value;
	
	    if (!options || options.process !== false) {
	      newValue = this.options.jss.plugins.onChangeValue(value, name, this);
	    }
	
	    var isEmpty = newValue == null || newValue === false;
	    var isDefined = name in this.style; // Value is empty and wasn't defined before.
	
	    if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
	
	    var remove = isEmpty && isDefined;
	    if (remove) delete this.style[name];else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
	
	    if (this.renderable && this.renderer) {
	      if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, newValue);
	      return this;
	    }
	
	    var sheet = this.options.sheet;
	
	    if (sheet && sheet.attached) {
	       false ? warning__default['default'](false, '[JSS] Rule is not linked. Missing sheet option "link: true".') : void 0;
	    }
	
	    return this;
	  };
	
	  return BaseStyleRule;
	}();
	var StyleRule =
	/*#__PURE__*/
	function (_BaseStyleRule) {
	  _inheritsLoose__default['default'](StyleRule, _BaseStyleRule);
	
	  function StyleRule(key, style, options) {
	    var _this;
	
	    _this = _BaseStyleRule.call(this, key, style, options) || this;
	    _this.selectorText = void 0;
	    _this.id = void 0;
	    _this.renderable = void 0;
	    var selector = options.selector,
	        scoped = options.scoped,
	        sheet = options.sheet,
	        generateId = options.generateId;
	
	    if (selector) {
	      _this.selectorText = selector;
	    } else if (scoped !== false) {
	      _this.id = generateId(_assertThisInitialized__default['default'](_assertThisInitialized__default['default'](_this)), sheet);
	      _this.selectorText = "." + escape(_this.id);
	    }
	
	    return _this;
	  }
	  /**
	   * Set selector string.
	   * Attention: use this with caution. Most browsers didn't implement
	   * selectorText setter, so this may result in rerendering of entire Style Sheet.
	   */
	
	
	  var _proto2 = StyleRule.prototype;
	
	  /**
	   * Apply rule to an element inline.
	   */
	  _proto2.applyTo = function applyTo(renderable) {
	    var renderer = this.renderer;
	
	    if (renderer) {
	      var json = this.toJSON();
	
	      for (var prop in json) {
	        renderer.setProperty(renderable, prop, json[prop]);
	      }
	    }
	
	    return this;
	  }
	  /**
	   * Returns JSON representation of the rule.
	   * Fallbacks are not supported.
	   * Useful for inline styles.
	   */
	  ;
	
	  _proto2.toJSON = function toJSON() {
	    var json = {};
	
	    for (var prop in this.style) {
	      var value = this.style[prop];
	      if (typeof value !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = toCssValue(value);
	    }
	
	    return json;
	  }
	  /**
	   * Generates a CSS string.
	   */
	  ;
	
	  _proto2.toString = function toString(options) {
	    var sheet = this.options.sheet;
	    var link = sheet ? sheet.options.link : false;
	    var opts = link ? _extends__default['default']({}, options, {
	      allowEmpty: true
	    }) : options;
	    return toCss(this.selectorText, this.style, opts);
	  };
	
	  _createClass__default['default'](StyleRule, [{
	    key: "selector",
	    set: function set(selector) {
	      if (selector === this.selectorText) return;
	      this.selectorText = selector;
	      var renderer = this.renderer,
	          renderable = this.renderable;
	      if (!renderable || !renderer) return;
	      var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
	
	      if (!hasChanged) {
	        renderer.replaceRule(renderable, this);
	      }
	    }
	    /**
	     * Get selector string.
	     */
	    ,
	    get: function get() {
	      return this.selectorText;
	    }
	  }]);
	
	  return StyleRule;
	}(BaseStyleRule);
	var pluginStyleRule = {
	  onCreateRule: function onCreateRule(name, style, options) {
	    if (name[0] === '@' || options.parent && options.parent.type === 'keyframes') {
	      return null;
	    }
	
	    return new StyleRule(name, style, options);
	  }
	};
	
	var defaultToStringOptions = {
	  indent: 1,
	  children: true
	};
	var atRegExp = /@([\w-]+)/;
	/**
	 * Conditional rule for @media, @supports
	 */
	
	var ConditionalRule =
	/*#__PURE__*/
	function () {
	  function ConditionalRule(key, styles, options) {
	    this.type = 'conditional';
	    this.at = void 0;
	    this.key = void 0;
	    this.query = void 0;
	    this.rules = void 0;
	    this.options = void 0;
	    this.isProcessed = false;
	    this.renderable = void 0;
	    this.key = key;
	    var atMatch = key.match(atRegExp);
	    this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
	
	    this.query = options.name || "@" + this.at;
	    this.options = options;
	    this.rules = new RuleList(_extends__default['default']({}, options, {
	      parent: this
	    }));
	
	    for (var name in styles) {
	      this.rules.add(name, styles[name]);
	    }
	
	    this.rules.process();
	  }
	  /**
	   * Get a rule.
	   */
	
	
	  var _proto = ConditionalRule.prototype;
	
	  _proto.getRule = function getRule(name) {
	    return this.rules.get(name);
	  }
	  /**
	   * Get index of a rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(rule) {
	    return this.rules.indexOf(rule);
	  }
	  /**
	   * Create and register rule, run plugins.
	   */
	  ;
	
	  _proto.addRule = function addRule(name, style, options) {
	    var rule = this.rules.add(name, style, options);
	    if (!rule) return null;
	    this.options.jss.plugins.onProcessRule(rule);
	    return rule;
	  }
	  /**
	   * Generates a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString(options) {
	    if (options === void 0) {
	      options = defaultToStringOptions;
	    }
	
	    if (options.indent == null) options.indent = defaultToStringOptions.indent;
	    if (options.children == null) options.children = defaultToStringOptions.children;
	
	    if (options.children === false) {
	      return this.query + " {}";
	    }
	
	    var children = this.rules.toString(options);
	    return children ? this.query + " {\n" + children + "\n}" : '';
	  };
	
	  return ConditionalRule;
	}();
	var keyRegExp = /@media|@supports\s+/;
	var pluginConditionalRule = {
	  onCreateRule: function onCreateRule(key, styles, options) {
	    return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
	  }
	};
	
	var defaultToStringOptions$1 = {
	  indent: 1,
	  children: true
	};
	var nameRegExp = /@keyframes\s+([\w-]+)/;
	/**
	 * Rule for @keyframes
	 */
	
	var KeyframesRule =
	/*#__PURE__*/
	function () {
	  function KeyframesRule(key, frames, options) {
	    this.type = 'keyframes';
	    this.at = '@keyframes';
	    this.key = void 0;
	    this.name = void 0;
	    this.id = void 0;
	    this.rules = void 0;
	    this.options = void 0;
	    this.isProcessed = false;
	    this.renderable = void 0;
	    var nameMatch = key.match(nameRegExp);
	
	    if (nameMatch && nameMatch[1]) {
	      this.name = nameMatch[1];
	    } else {
	      this.name = 'noname';
	       false ? warning__default['default'](false, "[JSS] Bad keyframes name " + key) : void 0;
	    }
	
	    this.key = this.type + "-" + this.name;
	    this.options = options;
	    var scoped = options.scoped,
	        sheet = options.sheet,
	        generateId = options.generateId;
	    this.id = scoped === false ? this.name : escape(generateId(this, sheet));
	    this.rules = new RuleList(_extends__default['default']({}, options, {
	      parent: this
	    }));
	
	    for (var name in frames) {
	      this.rules.add(name, frames[name], _extends__default['default']({}, options, {
	        parent: this
	      }));
	    }
	
	    this.rules.process();
	  }
	  /**
	   * Generates a CSS string.
	   */
	
	
	  var _proto = KeyframesRule.prototype;
	
	  _proto.toString = function toString(options) {
	    if (options === void 0) {
	      options = defaultToStringOptions$1;
	    }
	
	    if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
	    if (options.children == null) options.children = defaultToStringOptions$1.children;
	
	    if (options.children === false) {
	      return this.at + " " + this.id + " {}";
	    }
	
	    var children = this.rules.toString(options);
	    if (children) children = "\n" + children + "\n";
	    return this.at + " " + this.id + " {" + children + "}";
	  };
	
	  return KeyframesRule;
	}();
	var keyRegExp$1 = /@keyframes\s+/;
	var refRegExp = /\$([\w-]+)/g;
	
	var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
	  if (typeof val === 'string') {
	    return val.replace(refRegExp, function (match, name) {
	      if (name in keyframes) {
	        return keyframes[name];
	      }
	
	       false ? warning__default['default'](false, "[JSS] Referenced keyframes rule \"" + name + "\" is not defined.") : void 0;
	      return match;
	    });
	  }
	
	  return val;
	};
	/**
	 * Replace the reference for a animation name.
	 */
	
	
	var replaceRef = function replaceRef(style, prop, keyframes) {
	  var value = style[prop];
	  var refKeyframe = findReferencedKeyframe(value, keyframes);
	
	  if (refKeyframe !== value) {
	    style[prop] = refKeyframe;
	  }
	};
	
	var plugin = {
	  onCreateRule: function onCreateRule(key, frames, options) {
	    return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
	  },
	  // Animation name ref replacer.
	  onProcessStyle: function onProcessStyle(style, rule, sheet) {
	    if (rule.type !== 'style' || !sheet) return style;
	    if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
	    if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
	    return style;
	  },
	  onChangeValue: function onChangeValue(val, prop, rule) {
	    var sheet = rule.options.sheet;
	
	    if (!sheet) {
	      return val;
	    }
	
	    switch (prop) {
	      case 'animation':
	        return findReferencedKeyframe(val, sheet.keyframes);
	
	      case 'animation-name':
	        return findReferencedKeyframe(val, sheet.keyframes);
	
	      default:
	        return val;
	    }
	  }
	};
	
	var KeyframeRule =
	/*#__PURE__*/
	function (_BaseStyleRule) {
	  _inheritsLoose__default['default'](KeyframeRule, _BaseStyleRule);
	
	  function KeyframeRule() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _BaseStyleRule.call.apply(_BaseStyleRule, [this].concat(args)) || this;
	    _this.renderable = void 0;
	    return _this;
	  }
	
	  var _proto = KeyframeRule.prototype;
	
	  /**
	   * Generates a CSS string.
	   */
	  _proto.toString = function toString(options) {
	    var sheet = this.options.sheet;
	    var link = sheet ? sheet.options.link : false;
	    var opts = link ? _extends__default['default']({}, options, {
	      allowEmpty: true
	    }) : options;
	    return toCss(this.key, this.style, opts);
	  };
	
	  return KeyframeRule;
	}(BaseStyleRule);
	var pluginKeyframeRule = {
	  onCreateRule: function onCreateRule(key, style, options) {
	    if (options.parent && options.parent.type === 'keyframes') {
	      return new KeyframeRule(key, style, options);
	    }
	
	    return null;
	  }
	};
	
	var FontFaceRule =
	/*#__PURE__*/
	function () {
	  function FontFaceRule(key, style, options) {
	    this.type = 'font-face';
	    this.at = '@font-face';
	    this.key = void 0;
	    this.style = void 0;
	    this.options = void 0;
	    this.isProcessed = false;
	    this.renderable = void 0;
	    this.key = key;
	    this.style = style;
	    this.options = options;
	  }
	  /**
	   * Generates a CSS string.
	   */
	
	
	  var _proto = FontFaceRule.prototype;
	
	  _proto.toString = function toString(options) {
	    if (Array.isArray(this.style)) {
	      var str = '';
	
	      for (var index = 0; index < this.style.length; index++) {
	        str += toCss(this.at, this.style[index]);
	        if (this.style[index + 1]) str += '\n';
	      }
	
	      return str;
	    }
	
	    return toCss(this.at, this.style, options);
	  };
	
	  return FontFaceRule;
	}();
	var keyRegExp$2 = /@font-face/;
	var pluginFontFaceRule = {
	  onCreateRule: function onCreateRule(key, style, options) {
	    return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
	  }
	};
	
	var ViewportRule =
	/*#__PURE__*/
	function () {
	  function ViewportRule(key, style, options) {
	    this.type = 'viewport';
	    this.at = '@viewport';
	    this.key = void 0;
	    this.style = void 0;
	    this.options = void 0;
	    this.isProcessed = false;
	    this.renderable = void 0;
	    this.key = key;
	    this.style = style;
	    this.options = options;
	  }
	  /**
	   * Generates a CSS string.
	   */
	
	
	  var _proto = ViewportRule.prototype;
	
	  _proto.toString = function toString(options) {
	    return toCss(this.key, this.style, options);
	  };
	
	  return ViewportRule;
	}();
	var pluginViewportRule = {
	  onCreateRule: function onCreateRule(key, style, options) {
	    return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
	  }
	};
	
	var SimpleRule =
	/*#__PURE__*/
	function () {
	  function SimpleRule(key, value, options) {
	    this.type = 'simple';
	    this.key = void 0;
	    this.value = void 0;
	    this.options = void 0;
	    this.isProcessed = false;
	    this.renderable = void 0;
	    this.key = key;
	    this.value = value;
	    this.options = options;
	  }
	  /**
	   * Generates a CSS string.
	   */
	  // eslint-disable-next-line no-unused-vars
	
	
	  var _proto = SimpleRule.prototype;
	
	  _proto.toString = function toString(options) {
	    if (Array.isArray(this.value)) {
	      var str = '';
	
	      for (var index = 0; index < this.value.length; index++) {
	        str += this.key + " " + this.value[index] + ";";
	        if (this.value[index + 1]) str += '\n';
	      }
	
	      return str;
	    }
	
	    return this.key + " " + this.value + ";";
	  };
	
	  return SimpleRule;
	}();
	var keysMap = {
	  '@charset': true,
	  '@import': true,
	  '@namespace': true
	};
	var pluginSimpleRule = {
	  onCreateRule: function onCreateRule(key, value, options) {
	    return key in keysMap ? new SimpleRule(key, value, options) : null;
	  }
	};
	
	var plugins = [pluginStyleRule, pluginConditionalRule, plugin, pluginKeyframeRule, pluginFontFaceRule, pluginViewportRule, pluginSimpleRule];
	
	var defaultUpdateOptions = {
	  process: true
	};
	var forceUpdateOptions = {
	  force: true,
	  process: true
	  /**
	   * Contains rules objects and allows adding/removing etc.
	   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
	   */
	
	};
	
	var RuleList =
	/*#__PURE__*/
	function () {
	  // Rules registry for access by .get() method.
	  // It contains the same rule registered by name and by selector.
	  // Original styles object.
	  // Used to ensure correct rules order.
	  function RuleList(options) {
	    this.map = {};
	    this.raw = {};
	    this.index = [];
	    this.counter = 0;
	    this.options = void 0;
	    this.classes = void 0;
	    this.keyframes = void 0;
	    this.options = options;
	    this.classes = options.classes;
	    this.keyframes = options.keyframes;
	  }
	  /**
	   * Create and register rule.
	   *
	   * Will not render after Style Sheet was rendered the first time.
	   */
	
	
	  var _proto = RuleList.prototype;
	
	  _proto.add = function add(name, decl, ruleOptions) {
	    var _this$options = this.options,
	        parent = _this$options.parent,
	        sheet = _this$options.sheet,
	        jss = _this$options.jss,
	        Renderer = _this$options.Renderer,
	        generateId = _this$options.generateId,
	        scoped = _this$options.scoped;
	
	    var options = _extends__default['default']({
	      classes: this.classes,
	      parent: parent,
	      sheet: sheet,
	      jss: jss,
	      Renderer: Renderer,
	      generateId: generateId,
	      scoped: scoped,
	      name: name,
	      keyframes: this.keyframes,
	      selector: undefined
	    }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
	    // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
	    // we need to make the key unique within this RuleList instance scope.
	
	
	    var key = name;
	
	    if (name in this.raw) {
	      key = name + "-d" + this.counter++;
	    } // We need to save the original decl before creating the rule
	    // because cache plugin needs to use it as a key to return a cached rule.
	
	
	    this.raw[key] = decl;
	
	    if (key in this.classes) {
	      // E.g. rules inside of @media container
	      options.selector = "." + escape(this.classes[key]);
	    }
	
	    var rule = createRule(key, decl, options);
	    if (!rule) return null;
	    this.register(rule);
	    var index = options.index === undefined ? this.index.length : options.index;
	    this.index.splice(index, 0, rule);
	    return rule;
	  }
	  /**
	   * Get a rule.
	   */
	  ;
	
	  _proto.get = function get(name) {
	    return this.map[name];
	  }
	  /**
	   * Delete a rule.
	   */
	  ;
	
	  _proto.remove = function remove(rule) {
	    this.unregister(rule);
	    delete this.raw[rule.key];
	    this.index.splice(this.index.indexOf(rule), 1);
	  }
	  /**
	   * Get index of a rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(rule) {
	    return this.index.indexOf(rule);
	  }
	  /**
	   * Run `onProcessRule()` plugins on every rule.
	   */
	  ;
	
	  _proto.process = function process() {
	    var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
	    // we end up with very hard-to-track-down side effects.
	
	    this.index.slice(0).forEach(plugins.onProcessRule, plugins);
	  }
	  /**
	   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
	   */
	  ;
	
	  _proto.register = function register(rule) {
	    this.map[rule.key] = rule;
	
	    if (rule instanceof StyleRule) {
	      this.map[rule.selector] = rule;
	      if (rule.id) this.classes[rule.key] = rule.id;
	    } else if (rule instanceof KeyframesRule && this.keyframes) {
	      this.keyframes[rule.name] = rule.id;
	    }
	  }
	  /**
	   * Unregister a rule.
	   */
	  ;
	
	  _proto.unregister = function unregister(rule) {
	    delete this.map[rule.key];
	
	    if (rule instanceof StyleRule) {
	      delete this.map[rule.selector];
	      delete this.classes[rule.key];
	    } else if (rule instanceof KeyframesRule) {
	      delete this.keyframes[rule.name];
	    }
	  }
	  /**
	   * Update the function values with a new data.
	   */
	  ;
	
	  _proto.update = function update() {
	    var name;
	    var data;
	    var options;
	
	    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
	      name = arguments.length <= 0 ? undefined : arguments[0]; // $FlowFixMe[invalid-tuple-index]
	
	      data = arguments.length <= 1 ? undefined : arguments[1]; // $FlowFixMe[invalid-tuple-index]
	
	      options = arguments.length <= 2 ? undefined : arguments[2];
	    } else {
	      data = arguments.length <= 0 ? undefined : arguments[0]; // $FlowFixMe[invalid-tuple-index]
	
	      options = arguments.length <= 1 ? undefined : arguments[1];
	      name = null;
	    }
	
	    if (name) {
	      this.updateOne(this.map[name], data, options);
	    } else {
	      for (var index = 0; index < this.index.length; index++) {
	        this.updateOne(this.index[index], data, options);
	      }
	    }
	  }
	  /**
	   * Execute plugins, update rule props.
	   */
	  ;
	
	  _proto.updateOne = function updateOne(rule, data, options) {
	    if (options === void 0) {
	      options = defaultUpdateOptions;
	    }
	
	    var _this$options2 = this.options,
	        plugins = _this$options2.jss.plugins,
	        sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
	
	    if (rule.rules instanceof RuleList) {
	      rule.rules.update(data, options);
	      return;
	    }
	
	    var styleRule = rule;
	    var style = styleRule.style;
	    plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
	
	    if (options.process && style && style !== styleRule.style) {
	      // We need to run the plugins in case new `style` relies on syntax plugins.
	      plugins.onProcessStyle(styleRule.style, styleRule, sheet); // Update and add props.
	
	      for (var prop in styleRule.style) {
	        var nextValue = styleRule.style[prop];
	        var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
	        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
	
	        if (nextValue !== prevValue) {
	          styleRule.prop(prop, nextValue, forceUpdateOptions);
	        }
	      } // Remove props.
	
	
	      for (var _prop in style) {
	        var _nextValue = styleRule.style[_prop];
	        var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
	        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
	
	        if (_nextValue == null && _nextValue !== _prevValue) {
	          styleRule.prop(_prop, null, forceUpdateOptions);
	        }
	      }
	    }
	  }
	  /**
	   * Convert rules to a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString(options) {
	    var str = '';
	    var sheet = this.options.sheet;
	    var link = sheet ? sheet.options.link : false;
	
	    for (var index = 0; index < this.index.length; index++) {
	      var rule = this.index[index];
	      var css = rule.toString(options); // No need to render an empty rule.
	
	      if (!css && !link) continue;
	      if (str) str += '\n';
	      str += css;
	    }
	
	    return str;
	  };
	
	  return RuleList;
	}();
	
	var StyleSheet =
	/*#__PURE__*/
	function () {
	  function StyleSheet(styles, options) {
	    this.options = void 0;
	    this.deployed = void 0;
	    this.attached = void 0;
	    this.rules = void 0;
	    this.renderer = void 0;
	    this.classes = void 0;
	    this.keyframes = void 0;
	    this.queue = void 0;
	    this.attached = false;
	    this.deployed = false;
	    this.classes = {};
	    this.keyframes = {};
	    this.options = _extends__default['default']({}, options, {
	      sheet: this,
	      parent: this,
	      classes: this.classes,
	      keyframes: this.keyframes
	    });
	
	    if (options.Renderer) {
	      this.renderer = new options.Renderer(this);
	    }
	
	    this.rules = new RuleList(this.options);
	
	    for (var name in styles) {
	      this.rules.add(name, styles[name]);
	    }
	
	    this.rules.process();
	  }
	  /**
	   * Attach renderable to the render tree.
	   */
	
	
	  var _proto = StyleSheet.prototype;
	
	  _proto.attach = function attach() {
	    if (this.attached) return this;
	    if (this.renderer) this.renderer.attach();
	    this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
	
	    if (!this.deployed) this.deploy();
	    return this;
	  }
	  /**
	   * Remove renderable from render tree.
	   */
	  ;
	
	  _proto.detach = function detach() {
	    if (!this.attached) return this;
	    if (this.renderer) this.renderer.detach();
	    this.attached = false;
	    return this;
	  }
	  /**
	   * Add a rule to the current stylesheet.
	   * Will insert a rule also after the stylesheet has been rendered first time.
	   */
	  ;
	
	  _proto.addRule = function addRule(name, decl, options) {
	    var queue = this.queue; // Plugins can create rules.
	    // In order to preserve the right order, we need to queue all `.addRule` calls,
	    // which happen after the first `rules.add()` call.
	
	    if (this.attached && !queue) this.queue = [];
	    var rule = this.rules.add(name, decl, options);
	    if (!rule) return null;
	    this.options.jss.plugins.onProcessRule(rule);
	
	    if (this.attached) {
	      if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
	      // It will be inserted all together when .attach is called.
	
	      if (queue) queue.push(rule);else {
	        this.insertRule(rule);
	
	        if (this.queue) {
	          this.queue.forEach(this.insertRule, this);
	          this.queue = undefined;
	        }
	      }
	      return rule;
	    } // We can't add rules to a detached style node.
	    // We will redeploy the sheet once user will attach it.
	
	
	    this.deployed = false;
	    return rule;
	  }
	  /**
	   * Insert rule into the StyleSheet
	   */
	  ;
	
	  _proto.insertRule = function insertRule(rule) {
	    if (this.renderer) {
	      this.renderer.insertRule(rule);
	    }
	  }
	  /**
	   * Create and add rules.
	   * Will render also after Style Sheet was rendered the first time.
	   */
	  ;
	
	  _proto.addRules = function addRules(styles, options) {
	    var added = [];
	
	    for (var name in styles) {
	      var rule = this.addRule(name, styles[name], options);
	      if (rule) added.push(rule);
	    }
	
	    return added;
	  }
	  /**
	   * Get a rule by name.
	   */
	  ;
	
	  _proto.getRule = function getRule(name) {
	    return this.rules.get(name);
	  }
	  /**
	   * Delete a rule by name.
	   * Returns `true`: if rule has been deleted from the DOM.
	   */
	  ;
	
	  _proto.deleteRule = function deleteRule(name) {
	    var rule = typeof name === 'object' ? name : this.rules.get(name);
	
	    if (!rule || // Style sheet was created without link: true and attached, in this case we
	    // won't be able to remove the CSS rule from the DOM.
	    this.attached && !rule.renderable) {
	      return false;
	    }
	
	    this.rules.remove(rule);
	
	    if (this.attached && rule.renderable && this.renderer) {
	      return this.renderer.deleteRule(rule.renderable);
	    }
	
	    return true;
	  }
	  /**
	   * Get index of a rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(rule) {
	    return this.rules.indexOf(rule);
	  }
	  /**
	   * Deploy pure CSS string to a renderable.
	   */
	  ;
	
	  _proto.deploy = function deploy() {
	    if (this.renderer) this.renderer.deploy();
	    this.deployed = true;
	    return this;
	  }
	  /**
	   * Update the function values with a new data.
	   */
	  ;
	
	  _proto.update = function update() {
	    var _this$rules;
	
	    (_this$rules = this.rules).update.apply(_this$rules, arguments);
	
	    return this;
	  }
	  /**
	   * Updates a single rule.
	   */
	  ;
	
	  _proto.updateOne = function updateOne(rule, data, options) {
	    this.rules.updateOne(rule, data, options);
	    return this;
	  }
	  /**
	   * Convert rules to a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString(options) {
	    return this.rules.toString(options);
	  };
	
	  return StyleSheet;
	}();
	
	var PluginsRegistry =
	/*#__PURE__*/
	function () {
	  function PluginsRegistry() {
	    this.plugins = {
	      internal: [],
	      external: []
	    };
	    this.registry = void 0;
	  }
	
	  var _proto = PluginsRegistry.prototype;
	
	  /**
	   * Call `onCreateRule` hooks and return an object if returned by a hook.
	   */
	  _proto.onCreateRule = function onCreateRule(name, decl, options) {
	    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
	      var rule = this.registry.onCreateRule[i](name, decl, options);
	      if (rule) return rule;
	    }
	
	    return null;
	  }
	  /**
	   * Call `onProcessRule` hooks.
	   */
	  ;
	
	  _proto.onProcessRule = function onProcessRule(rule) {
	    if (rule.isProcessed) return;
	    var sheet = rule.options.sheet;
	
	    for (var i = 0; i < this.registry.onProcessRule.length; i++) {
	      this.registry.onProcessRule[i](rule, sheet);
	    }
	
	    if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
	    rule.isProcessed = true;
	  }
	  /**
	   * Call `onProcessStyle` hooks.
	   */
	  ;
	
	  _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
	    for (var i = 0; i < this.registry.onProcessStyle.length; i++) {
	      // $FlowFixMe[prop-missing]
	      rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
	    }
	  }
	  /**
	   * Call `onProcessSheet` hooks.
	   */
	  ;
	
	  _proto.onProcessSheet = function onProcessSheet(sheet) {
	    for (var i = 0; i < this.registry.onProcessSheet.length; i++) {
	      this.registry.onProcessSheet[i](sheet);
	    }
	  }
	  /**
	   * Call `onUpdate` hooks.
	   */
	  ;
	
	  _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
	    for (var i = 0; i < this.registry.onUpdate.length; i++) {
	      this.registry.onUpdate[i](data, rule, sheet, options);
	    }
	  }
	  /**
	   * Call `onChangeValue` hooks.
	   */
	  ;
	
	  _proto.onChangeValue = function onChangeValue(value, prop, rule) {
	    var processedValue = value;
	
	    for (var i = 0; i < this.registry.onChangeValue.length; i++) {
	      processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
	    }
	
	    return processedValue;
	  }
	  /**
	   * Register a plugin.
	   */
	  ;
	
	  _proto.use = function use(newPlugin, options) {
	    if (options === void 0) {
	      options = {
	        queue: 'external'
	      };
	    }
	
	    var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
	
	    if (plugins.indexOf(newPlugin) !== -1) {
	      return;
	    }
	
	    plugins.push(newPlugin);
	    this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function (registry, plugin) {
	      for (var name in plugin) {
	        if (name in registry) {
	          registry[name].push(plugin[name]);
	        } else {
	           false ? warning__default['default'](false, "[JSS] Unknown hook \"" + name + "\".") : void 0;
	        }
	      }
	
	      return registry;
	    }, {
	      onCreateRule: [],
	      onProcessRule: [],
	      onProcessStyle: [],
	      onProcessSheet: [],
	      onChangeValue: [],
	      onUpdate: []
	    });
	  };
	
	  return PluginsRegistry;
	}();
	
	/**
	 * Sheets registry to access them all at one place.
	 */
	var SheetsRegistry =
	/*#__PURE__*/
	function () {
	  function SheetsRegistry() {
	    this.registry = [];
	  }
	
	  var _proto = SheetsRegistry.prototype;
	
	  /**
	   * Register a Style Sheet.
	   */
	  _proto.add = function add(sheet) {
	    var registry = this.registry;
	    var index = sheet.options.index;
	    if (registry.indexOf(sheet) !== -1) return;
	
	    if (registry.length === 0 || index >= this.index) {
	      registry.push(sheet);
	      return;
	    } // Find a position.
	
	
	    for (var i = 0; i < registry.length; i++) {
	      if (registry[i].options.index > index) {
	        registry.splice(i, 0, sheet);
	        return;
	      }
	    }
	  }
	  /**
	   * Reset the registry.
	   */
	  ;
	
	  _proto.reset = function reset() {
	    this.registry = [];
	  }
	  /**
	   * Remove a Style Sheet.
	   */
	  ;
	
	  _proto.remove = function remove(sheet) {
	    var index = this.registry.indexOf(sheet);
	    this.registry.splice(index, 1);
	  }
	  /**
	   * Convert all attached sheets to a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString(_temp) {
	    var _ref = _temp === void 0 ? {} : _temp,
	        attached = _ref.attached,
	        options = _objectWithoutPropertiesLoose__default['default'](_ref, ["attached"]);
	
	    var css = '';
	
	    for (var i = 0; i < this.registry.length; i++) {
	      var sheet = this.registry[i];
	
	      if (attached != null && sheet.attached !== attached) {
	        continue;
	      }
	
	      if (css) css += '\n';
	      css += sheet.toString(options);
	    }
	
	    return css;
	  };
	
	  _createClass__default['default'](SheetsRegistry, [{
	    key: "index",
	
	    /**
	     * Current highest index number.
	     */
	    get: function get() {
	      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
	    }
	  }]);
	
	  return SheetsRegistry;
	}();
	
	/**
	 * This is a global sheets registry. Only DomRenderer will add sheets to it.
	 * On the server one should use an own SheetsRegistry instance and add the
	 * sheets to it, because you need to make sure to create a new registry for
	 * each request in order to not leak sheets across requests.
	 */
	
	var registry = new SheetsRegistry();
	
	/* eslint-disable */
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var globalThis = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	
	var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
	if (globalThis[ns] == null) globalThis[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
	// the current version with just one short number and use it for classes generation
	// we use a counter. Also it is more accurate, because user can manually reevaluate
	// the module.
	
	var moduleId = globalThis[ns]++;
	
	var maxRules = 1e10;
	
	/**
	 * Returns a function which generates unique class names based on counters.
	 * When new generator function is created, rule counter is reseted.
	 * We need to reset the rule counter for SSR for each request.
	 */
	var createGenerateId = function createGenerateId(options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var ruleCounter = 0;
	  return function (rule, sheet) {
	    ruleCounter += 1;
	
	    if (ruleCounter > maxRules) {
	       false ? warning__default['default'](false, "[JSS] You might have a memory leak. Rule counter is at " + ruleCounter + ".") : void 0;
	    }
	
	    var jssId = '';
	    var prefix = '';
	
	    if (sheet) {
	      if (sheet.options.classNamePrefix) {
	        prefix = sheet.options.classNamePrefix;
	      }
	
	      if (sheet.options.jss.id != null) {
	        jssId = String(sheet.options.jss.id);
	      }
	    }
	
	    if (options.minify) {
	      // Using "c" because a number can't be the first char in a class name.
	      return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
	    }
	
	    return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
	  };
	};
	
	/**
	 * Cache the value from the first time a function is called.
	 */
	var memoize = function memoize(fn) {
	  var value;
	  return function () {
	    if (!value) value = fn();
	    return value;
	  };
	};
	
	/**
	 * Get a style property value.
	 */
	var getPropertyValue = function getPropertyValue(cssRule, prop) {
	  try {
	    // Support CSSTOM.
	    if (cssRule.attributeStyleMap) {
	      return cssRule.attributeStyleMap.get(prop);
	    }
	
	    return cssRule.style.getPropertyValue(prop);
	  } catch (err) {
	    // IE may throw if property is unknown.
	    return '';
	  }
	};
	
	/**
	 * Set a style property.
	 */
	var setProperty = function setProperty(cssRule, prop, value) {
	  try {
	    var cssValue = value;
	
	    if (Array.isArray(value)) {
	      cssValue = toCssValue(value, true);
	
	      if (value[value.length - 1] === '!important') {
	        cssRule.style.setProperty(prop, cssValue, 'important');
	        return true;
	      }
	    } // Support CSSTOM.
	
	
	    if (cssRule.attributeStyleMap) {
	      cssRule.attributeStyleMap.set(prop, cssValue);
	    } else {
	      cssRule.style.setProperty(prop, cssValue);
	    }
	  } catch (err) {
	    // IE may throw if property is unknown.
	    return false;
	  }
	
	  return true;
	};
	
	/**
	 * Remove a style property.
	 */
	var removeProperty = function removeProperty(cssRule, prop) {
	  try {
	    // Support CSSTOM.
	    if (cssRule.attributeStyleMap) {
	      cssRule.attributeStyleMap.delete(prop);
	    } else {
	      cssRule.style.removeProperty(prop);
	    }
	  } catch (err) {
	     false ? warning__default['default'](false, "[JSS] DOMException \"" + err.message + "\" was thrown. Tried to remove property \"" + prop + "\".") : void 0;
	  }
	};
	
	/**
	 * Set the selector.
	 */
	var setSelector = function setSelector(cssRule, selectorText) {
	  cssRule.selectorText = selectorText; // Return false if setter was not successful.
	  // Currently works in chrome only.
	
	  return cssRule.selectorText === selectorText;
	};
	/**
	 * Gets the `head` element upon the first call and caches it.
	 * We assume it can't be null.
	 */
	
	
	var getHead = memoize(function () {
	  return document.querySelector('head');
	});
	/**
	 * Find attached sheet with an index higher than the passed one.
	 */
	
	function findHigherSheet(registry, options) {
	  for (var i = 0; i < registry.length; i++) {
	    var sheet = registry[i];
	
	    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
	      return sheet;
	    }
	  }
	
	  return null;
	}
	/**
	 * Find attached sheet with the highest index.
	 */
	
	
	function findHighestSheet(registry, options) {
	  for (var i = registry.length - 1; i >= 0; i--) {
	    var sheet = registry[i];
	
	    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
	      return sheet;
	    }
	  }
	
	  return null;
	}
	/**
	 * Find a comment with "jss" inside.
	 */
	
	
	function findCommentNode(text) {
	  var head = getHead();
	
	  for (var i = 0; i < head.childNodes.length; i++) {
	    var node = head.childNodes[i];
	
	    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
	      return node;
	    }
	  }
	
	  return null;
	}
	
	/**
	 * Find a node before which we can insert the sheet.
	 */
	function findPrevNode(options) {
	  var registry$1 = registry.registry;
	
	  if (registry$1.length > 0) {
	    // Try to insert before the next higher sheet.
	    var sheet = findHigherSheet(registry$1, options);
	
	    if (sheet && sheet.renderer) {
	      return {
	        parent: sheet.renderer.element.parentNode,
	        node: sheet.renderer.element
	      };
	    } // Otherwise insert after the last attached.
	
	
	    sheet = findHighestSheet(registry$1, options);
	
	    if (sheet && sheet.renderer) {
	      return {
	        parent: sheet.renderer.element.parentNode,
	        node: sheet.renderer.element.nextSibling
	      };
	    }
	  } // Try to find a comment placeholder if registry is empty.
	
	
	  var insertionPoint = options.insertionPoint;
	
	  if (insertionPoint && typeof insertionPoint === 'string') {
	    var comment = findCommentNode(insertionPoint);
	
	    if (comment) {
	      return {
	        parent: comment.parentNode,
	        node: comment.nextSibling
	      };
	    } // If user specifies an insertion point and it can't be found in the document -
	    // bad specificity issues may appear.
	
	
	     false ? warning__default['default'](false, "[JSS] Insertion point \"" + insertionPoint + "\" not found.") : void 0;
	  }
	
	  return false;
	}
	/**
	 * Insert style element into the DOM.
	 */
	
	
	function insertStyle(style, options) {
	  var insertionPoint = options.insertionPoint;
	  var nextNode = findPrevNode(options);
	
	  if (nextNode !== false && nextNode.parent) {
	    nextNode.parent.insertBefore(style, nextNode.node);
	    return;
	  } // Works with iframes and any node types.
	
	
	  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
	    // https://stackoverflow.com/questions/41328728/force-casting-in-flow
	    var insertionPointElement = insertionPoint;
	    var parentNode = insertionPointElement.parentNode;
	    if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);else  false ? warning__default['default'](false, '[JSS] Insertion point is not in the DOM.') : void 0;
	    return;
	  }
	
	  getHead().appendChild(style);
	}
	/**
	 * Read jss nonce setting from the page if the user has set it.
	 */
	
	
	var getNonce = memoize(function () {
	  var node = document.querySelector('meta[property="csp-nonce"]');
	  return node ? node.getAttribute('content') : null;
	});
	
	var _insertRule = function insertRule(container, rule, index) {
	  try {
	    if ('insertRule' in container) {
	      var c = container;
	      c.insertRule(rule, index);
	    } // Keyframes rule.
	    else if ('appendRule' in container) {
	        var _c = container;
	
	        _c.appendRule(rule);
	      }
	  } catch (err) {
	     false ? warning__default['default'](false, "[JSS] " + err.message) : void 0;
	    return false;
	  }
	
	  return container.cssRules[index];
	};
	
	var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
	  var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
	
	  if (index === undefined || index > maxIndex) {
	    // eslint-disable-next-line no-param-reassign
	    return maxIndex;
	  }
	
	  return index;
	};
	
	var createStyle = function createStyle() {
	  var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
	  // insert rules after we insert the style tag.
	  // It seems to kick-off the source order specificity algorithm.
	
	  el.textContent = '\n';
	  return el;
	};
	
	var DomRenderer =
	/*#__PURE__*/
	function () {
	  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696
	  // Will be empty if link: true option is not set, because
	  // it is only for use together with insertRule API.
	  function DomRenderer(sheet) {
	    this.getPropertyValue = getPropertyValue;
	    this.setProperty = setProperty;
	    this.removeProperty = removeProperty;
	    this.setSelector = setSelector;
	    this.element = void 0;
	    this.sheet = void 0;
	    this.hasInsertedRules = false;
	    this.cssRules = [];
	    // There is no sheet when the renderer is used from a standalone StyleRule.
	    if (sheet) registry.add(sheet);
	    this.sheet = sheet;
	
	    var _ref = this.sheet ? this.sheet.options : {},
	        media = _ref.media,
	        meta = _ref.meta,
	        element = _ref.element;
	
	    this.element = element || createStyle();
	    this.element.setAttribute('data-jss', '');
	    if (media) this.element.setAttribute('media', media);
	    if (meta) this.element.setAttribute('data-meta', meta);
	    var nonce = getNonce();
	    if (nonce) this.element.setAttribute('nonce', nonce);
	  }
	  /**
	   * Insert style element into render tree.
	   */
	
	
	  var _proto = DomRenderer.prototype;
	
	  _proto.attach = function attach() {
	    // In the case the element node is external and it is already in the DOM.
	    if (this.element.parentNode || !this.sheet) return;
	    insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
	    // most browsers create a new CSSStyleSheet, except of all IEs.
	
	    var deployed = Boolean(this.sheet && this.sheet.deployed);
	
	    if (this.hasInsertedRules && deployed) {
	      this.hasInsertedRules = false;
	      this.deploy();
	    }
	  }
	  /**
	   * Remove style element from render tree.
	   */
	  ;
	
	  _proto.detach = function detach() {
	    if (!this.sheet) return;
	    var parentNode = this.element.parentNode;
	    if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
	    // Though IE will keep them and we need a consistent behavior.
	
	    if (this.sheet.options.link) {
	      this.cssRules = [];
	      this.element.textContent = '\n';
	    }
	  }
	  /**
	   * Inject CSS string into element.
	   */
	  ;
	
	  _proto.deploy = function deploy() {
	    var sheet = this.sheet;
	    if (!sheet) return;
	
	    if (sheet.options.link) {
	      this.insertRules(sheet.rules);
	      return;
	    }
	
	    this.element.textContent = "\n" + sheet.toString() + "\n";
	  }
	  /**
	   * Insert RuleList into an element.
	   */
	  ;
	
	  _proto.insertRules = function insertRules(rules, nativeParent) {
	    for (var i = 0; i < rules.index.length; i++) {
	      this.insertRule(rules.index[i], i, nativeParent);
	    }
	  }
	  /**
	   * Insert a rule into element.
	   */
	  ;
	
	  _proto.insertRule = function insertRule(rule, index, nativeParent) {
	    if (nativeParent === void 0) {
	      nativeParent = this.element.sheet;
	    }
	
	    if (rule.rules) {
	      var parent = rule;
	      var latestNativeParent = nativeParent;
	
	      if (rule.type === 'conditional' || rule.type === 'keyframes') {
	        var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.
	
	
	        latestNativeParent = _insertRule(nativeParent, parent.toString({
	          children: false
	        }), _insertionIndex);
	
	        if (latestNativeParent === false) {
	          return false;
	        }
	
	        this.refCssRule(rule, _insertionIndex, latestNativeParent);
	      }
	
	      this.insertRules(parent.rules, latestNativeParent);
	      return latestNativeParent;
	    }
	
	    var ruleStr = rule.toString();
	    if (!ruleStr) return false;
	    var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);
	
	    var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);
	
	    if (nativeRule === false) {
	      return false;
	    }
	
	    this.hasInsertedRules = true;
	    this.refCssRule(rule, insertionIndex, nativeRule);
	    return nativeRule;
	  };
	
	  _proto.refCssRule = function refCssRule(rule, index, cssRule) {
	    rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
	    // like rules inside media queries or keyframes
	
	    if (rule.options.parent instanceof StyleSheet) {
	      this.cssRules[index] = cssRule;
	    }
	  }
	  /**
	   * Delete a rule.
	   */
	  ;
	
	  _proto.deleteRule = function deleteRule(cssRule) {
	    var sheet = this.element.sheet;
	    var index = this.indexOf(cssRule);
	    if (index === -1) return false;
	    sheet.deleteRule(index);
	    this.cssRules.splice(index, 1);
	    return true;
	  }
	  /**
	   * Get index of a CSS Rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(cssRule) {
	    return this.cssRules.indexOf(cssRule);
	  }
	  /**
	   * Generate a new CSS rule and replace the existing one.
	   *
	   * Only used for some old browsers because they can't set a selector.
	   */
	  ;
	
	  _proto.replaceRule = function replaceRule(cssRule, rule) {
	    var index = this.indexOf(cssRule);
	    if (index === -1) return false;
	    this.element.sheet.deleteRule(index);
	    this.cssRules.splice(index, 1);
	    return this.insertRule(rule, index);
	  }
	  /**
	   * Get all rules elements.
	   */
	  ;
	
	  _proto.getRules = function getRules() {
	    return this.element.sheet.cssRules;
	  };
	
	  return DomRenderer;
	}();
	
	var instanceCounter = 0;
	
	var Jss =
	/*#__PURE__*/
	function () {
	  function Jss(options) {
	    this.id = instanceCounter++;
	    this.version = "10.5.0";
	    this.plugins = new PluginsRegistry();
	    this.options = {
	      id: {
	        minify: false
	      },
	      createGenerateId: createGenerateId,
	      Renderer: isInBrowser__default['default'] ? DomRenderer : null,
	      plugins: []
	    };
	    this.generateId = createGenerateId({
	      minify: false
	    });
	
	    for (var i = 0; i < plugins.length; i++) {
	      this.plugins.use(plugins[i], {
	        queue: 'internal'
	      });
	    }
	
	    this.setup(options);
	  }
	  /**
	   * Prepares various options, applies plugins.
	   * Should not be used twice on the same instance, because there is no plugins
	   * deduplication logic.
	   */
	
	
	  var _proto = Jss.prototype;
	
	  _proto.setup = function setup(options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (options.createGenerateId) {
	      this.options.createGenerateId = options.createGenerateId;
	    }
	
	    if (options.id) {
	      this.options.id = _extends__default['default']({}, this.options.id, options.id);
	    }
	
	    if (options.createGenerateId || options.id) {
	      this.generateId = this.options.createGenerateId(this.options.id);
	    }
	
	    if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
	
	    if ('Renderer' in options) {
	      this.options.Renderer = options.Renderer;
	    } // eslint-disable-next-line prefer-spread
	
	
	    if (options.plugins) this.use.apply(this, options.plugins);
	    return this;
	  }
	  /**
	   * Create a Style Sheet.
	   */
	  ;
	
	  _proto.createStyleSheet = function createStyleSheet(styles, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    var _options = options,
	        index = _options.index;
	
	    if (typeof index !== 'number') {
	      index = registry.index === 0 ? 0 : registry.index + 1;
	    }
	
	    var sheet = new StyleSheet(styles, _extends__default['default']({}, options, {
	      jss: this,
	      generateId: options.generateId || this.generateId,
	      insertionPoint: this.options.insertionPoint,
	      Renderer: this.options.Renderer,
	      index: index
	    }));
	    this.plugins.onProcessSheet(sheet);
	    return sheet;
	  }
	  /**
	   * Detach the Style Sheet and remove it from the registry.
	   */
	  ;
	
	  _proto.removeStyleSheet = function removeStyleSheet(sheet) {
	    sheet.detach();
	    registry.remove(sheet);
	    return this;
	  }
	  /**
	   * Create a rule without a Style Sheet.
	   * [Deprecated] will be removed in the next major version.
	   */
	  ;
	
	  _proto.createRule = function createRule$1(name, style, options) {
	    if (style === void 0) {
	      style = {};
	    }
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    // Enable rule without name for inline styles.
	    if (typeof name === 'object') {
	      // $FlowFixMe[incompatible-call]
	      return this.createRule(undefined, name, style);
	    } // $FlowFixMe[incompatible-type]
	
	
	    var ruleOptions = _extends__default['default']({}, options, {
	      name: name,
	      jss: this,
	      Renderer: this.options.Renderer
	    });
	
	    if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
	    if (!ruleOptions.classes) ruleOptions.classes = {};
	    if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
	
	    var rule = createRule(name, style, ruleOptions);
	
	    if (rule) this.plugins.onProcessRule(rule);
	    return rule;
	  }
	  /**
	   * Register plugin. Passed function will be invoked with a rule instance.
	   */
	  ;
	
	  _proto.use = function use() {
	    var _this = this;
	
	    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
	      plugins[_key] = arguments[_key];
	    }
	
	    plugins.forEach(function (plugin) {
	      _this.plugins.use(plugin);
	    });
	    return this;
	  };
	
	  return Jss;
	}();
	
	/**
	 * Extracts a styles object with only props that contain function values.
	 */
	function getDynamicStyles(styles) {
	  var to = null;
	
	  for (var key in styles) {
	    var value = styles[key];
	    var type = typeof value;
	
	    if (type === 'function') {
	      if (!to) to = {};
	      to[key] = value;
	    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
	      var extracted = getDynamicStyles(value);
	
	      if (extracted) {
	        if (!to) to = {};
	        to[key] = extracted;
	      }
	    }
	  }
	
	  return to;
	}
	
	/**
	 * SheetsManager is like a WeakMap which is designed to count StyleSheet
	 * instances and attach/detach automatically.
	 */
	var SheetsManager =
	/*#__PURE__*/
	function () {
	  function SheetsManager() {
	    this.length = 0;
	    this.sheets = new WeakMap();
	  }
	
	  var _proto = SheetsManager.prototype;
	
	  _proto.get = function get(key) {
	    var entry = this.sheets.get(key);
	    return entry && entry.sheet;
	  };
	
	  _proto.add = function add(key, sheet) {
	    if (this.sheets.has(key)) return;
	    this.length++;
	    this.sheets.set(key, {
	      sheet: sheet,
	      refs: 0
	    });
	  };
	
	  _proto.manage = function manage(key) {
	    var entry = this.sheets.get(key);
	
	    if (entry) {
	      if (entry.refs === 0) {
	        entry.sheet.attach();
	      }
	
	      entry.refs++;
	      return entry.sheet;
	    }
	
	    warning__default['default'](false, "[JSS] SheetsManager: can't find sheet to manage");
	    return undefined;
	  };
	
	  _proto.unmanage = function unmanage(key) {
	    var entry = this.sheets.get(key);
	
	    if (entry) {
	      if (entry.refs > 0) {
	        entry.refs--;
	        if (entry.refs === 0) entry.sheet.detach();
	      }
	    } else {
	      warning__default['default'](false, "SheetsManager: can't find sheet to unmanage");
	    }
	  };
	
	  _createClass__default['default'](SheetsManager, [{
	    key: "size",
	    get: function get() {
	      return this.length;
	    }
	  }]);
	
	  return SheetsManager;
	}();
	
	/**
	 * A better abstraction over CSS.
	 *
	 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
	 * @website https://github.com/cssinjs/jss
	 * @license MIT
	 */
	
	/**
	 * Export a constant indicating if this browser has CSSTOM support.
	 * https://developers.google.com/web/updates/2018/03/cssom
	 */
	var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;
	/**
	 * Creates a new instance of Jss.
	 */
	
	var create = function create(options) {
	  return new Jss(options);
	};
	/**
	 * A global Jss instance.
	 */
	
	var jss = create();
	
	exports.RuleList = RuleList;
	exports.SheetsManager = SheetsManager;
	exports.SheetsRegistry = SheetsRegistry;
	exports.create = create;
	exports.createGenerateId = createGenerateId;
	exports.createRule = createRule;
	exports.default = jss;
	exports.getDynamicStyles = getDynamicStyles;
	exports.hasCSSTOMSupport = hasCSSTOMSupport;
	exports.sheets = registry;
	exports.toCssValue = toCssValue;


/***/ },
/* 173 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(773),
	    isFlattenable = __webpack_require__(1841);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(270),
	    getRawTag = __webpack_require__(1831),
	    objectToString = __webpack_require__(1859);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(1804),
	    getValue = __webpack_require__(1833);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 177 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 178 */
[2306, 37],
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _react = __webpack_require__(60);
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var arrayOf = _react.PropTypes.arrayOf;
	var oneOfType = _react.PropTypes.oneOfType;
	var element = _react.PropTypes.element;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = shape({
	  listen: func.isRequired,
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired
	});
	
	var component = exports.component = oneOfType([func, string]);
	var components = exports.components = oneOfType([component, object]);
	var route = exports.route = oneOfType([object, element]);
	var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ },
/* 180 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = { adminPath: 'https://aquadb.fr/administration/web/', appPath: 'https://aquadb.fr/', postgrestPath: 'https://aquadb.fr/postgrest/', aquasysPath: 'https://www.aquasys.fr', layerPath: 'https://aquadb.fr/layers/', aqua6boAuthPath: 'https://aqua6bo.aquadb.fr/auth/', recaptchaKey: '6LdD4ZgUAAAAAMf3IRb1qM6CO3IRQNfVWm804N7X', aquadbSupport: 'https://www.aquasys.fr/aquadb/contact/' };

/***/ },
/* 181 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.title = obj.name;
		this.creationDate = obj.creation_date;
		this.updateDate = obj.update_date;
		this.lastExecution = obj.last_execution;
		this.state = obj.selectionstatus_id;
		this.close = obj.close;
		this.closeDate = obj.closedate;
		this.favorite = obj.favorite;
		this.role = obj.role;
	};
	
	exports.default = _class;

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _lodash = __webpack_require__(15);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj, stations, filters, themes, picture) {
		var favoriteFunction = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
		var executionFunction = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';
		var deleteFunction = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
		var informationFunction = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : '';
		var exportFunction = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : '';
		var isUpdateData = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : false;
		var exportHistory = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : [];
		var selectionWatershed = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : [];
		var keyFigures = arguments.length > 13 && arguments[13] !== undefined ? arguments[13] : [];
	
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.title = obj.title;
		this.creationDate = obj.creationDate;
		this.updateDate = obj.updateDate;
		this.lastExecutionDate = obj.lastExecution;
		this.state = obj.state;
		this.stations = stations;
		this.filters = filters;
		this.themes = themes;
		this.nbStation = stations ? (0, _lodash.uniqBy)(stations, 'id').length : 0;
		this.nbFilter = filters ? filters.length : 0;
		this.nbTheme = themes ? themes.length : 0;
		this.favoriteFunction = favoriteFunction;
		this.executionFunction = executionFunction;
		this.deleteFunction = deleteFunction;
		this.informationFunction = informationFunction;
		this.exportFunction = exportFunction;
		this.picture = picture;
		this.isUpdateData = isUpdateData;
		this.exportHistory = exportHistory;
		this.nbExport = exportHistory.length;
		this.selectionWatershed = selectionWatershed;
		this.nbWatershed = selectionWatershed.length;
		this.keyFigures = keyFigures;
		this.favorite = obj.favorite;
		this.headers = ['isUpdateData', 'title', 'nbTheme', 'nbWatershed', 'nbStation', 'creationDate', 'updateDate', 'lastExecutionDate', 'favoriteFunction', 'informationFunction', 'executionFunction', 'exportFunction', 'deleteFunction'];
	};
	
	exports.default = _class;

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _lodash = __webpack_require__(15);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.name = (0, _lodash.capitalize)(obj.name);
		this.code = obj.code;
		this.nameResearch = obj.nameresearch;
		this.codeResearch = obj.coderesearch;
	};
	
	exports.default = _class;

/***/ },
/* 184 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.analysisid;
		this.analysisDate = obj.analysisDate;
		this.result = obj.result;
		this.parameters = obj.parameters;
		this.pickupOperationId = obj.pickupid;
		this.remarkCode = obj.remarkcode;
		this.unit = obj.unit;
		this.support = obj.support;
		this.contact = obj.contact;
	};
	
	exports.default = _class;

/***/ },
/* 185 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.date = obj.date;
		this.measure = obj.measure;
		this.continuity = obj.continuity;
		this.status = obj.status;
		this.qualification = obj.qualification;
		this.piezometerId = obj.piezometer_id;
	};
	
	exports.default = _class;

/***/ },
/* 186 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var getSiteTypeAllowWithTypes = function getSiteTypeAllowWithTypes(types) {
		return types.join(',');
	};
	
	var getFetchSiteTypeAllowWithTypes = function getFetchSiteTypeAllowWithTypes(types) {
		var tmp = getSiteTypeAllowWithTypes(types);
		return '{' + tmp + '}';
	};
	var getFetchSiteIds = function getFetchSiteIds(siteIds) {
		return '{' + siteIds.join(',') + '}';
	};
	
	var getDefaultMapCenter = function getDefaultMapCenter() {
		var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
	
		var defaultX = 2.5048828125;
		var defaultY = 46.649436163350245;
		var defaultReturn = [defaultX, defaultY];
		if (user) {
			if (user.latitude && user.longitude) {
				return [Number(user.latitude), Number(user.longitude)];
			}
			return defaultReturn;
		}
		return defaultReturn;
	};
	var getDefaultZoom = function getDefaultZoom() {
		var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
	
		return user.zoom ? Number(user.zoom) : 7;
	};
	
	exports.getFetchSiteTypeAllowWithTypes = getFetchSiteTypeAllowWithTypes;
	exports.getSiteTypeAllowWithTypes = getSiteTypeAllowWithTypes;
	exports.getFetchSiteIds = getFetchSiteIds;
	exports.getDefaultMapCenter = getDefaultMapCenter;
	exports.getDefaultZoom = getDefaultZoom;

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(3);
	
	var Element = __webpack_require__(1076);
	
	var BoundingRect = __webpack_require__(42);
	
	/**
	 * Group是一个容器，可以插入子节点，Group的变换也会被应用到子节点上
	 * @module zrender/graphic/Group
	 * @example
	 *     var Group = require('zrender/container/Group');
	 *     var Circle = require('zrender/graphic/shape/Circle');
	 *     var g = new Group();
	 *     g.position[0] = 100;
	 *     g.position[1] = 100;
	 *     g.add(new Circle({
	 *         style: {
	 *             x: 100,
	 *             y: 100,
	 *             r: 20,
	 *         }
	 *     }));
	 *     zr.add(g);
	 */
	
	/**
	 * @alias module:zrender/graphic/Group
	 * @constructor
	 * @extends module:zrender/mixin/Transformable
	 * @extends module:zrender/mixin/Eventful
	 */
	var Group = function (opts) {
	  opts = opts || {};
	  Element.call(this, opts);
	
	  for (var key in opts) {
	    if (opts.hasOwnProperty(key)) {
	      this[key] = opts[key];
	    }
	  }
	
	  this._children = [];
	  this.__storage = null;
	  this.__dirty = true;
	};
	
	Group.prototype = {
	  constructor: Group,
	  isGroup: true,
	
	  /**
	   * @type {string}
	   */
	  type: 'group',
	
	  /**
	   * 所有子孙元素是否响应鼠标事件
	   * @name module:/zrender/container/Group#silent
	   * @type {boolean}
	   * @default false
	   */
	  silent: false,
	
	  /**
	   * @return {Array.<module:zrender/Element>}
	   */
	  children: function () {
	    return this._children.slice();
	  },
	
	  /**
	   * 获取指定 index 的儿子节点
	   * @param  {number} idx
	   * @return {module:zrender/Element}
	   */
	  childAt: function (idx) {
	    return this._children[idx];
	  },
	
	  /**
	   * 获取指定名字的儿子节点
	   * @param  {string} name
	   * @return {module:zrender/Element}
	   */
	  childOfName: function (name) {
	    var children = this._children;
	
	    for (var i = 0; i < children.length; i++) {
	      if (children[i].name === name) {
	        return children[i];
	      }
	    }
	  },
	
	  /**
	   * @return {number}
	   */
	  childCount: function () {
	    return this._children.length;
	  },
	
	  /**
	   * 添加子节点到最后
	   * @param {module:zrender/Element} child
	   */
	  add: function (child) {
	    if (child && child !== this && child.parent !== this) {
	      this._children.push(child);
	
	      this._doAdd(child);
	    }
	
	    return this;
	  },
	
	  /**
	   * 添加子节点在 nextSibling 之前
	   * @param {module:zrender/Element} child
	   * @param {module:zrender/Element} nextSibling
	   */
	  addBefore: function (child, nextSibling) {
	    if (child && child !== this && child.parent !== this && nextSibling && nextSibling.parent === this) {
	      var children = this._children;
	      var idx = children.indexOf(nextSibling);
	
	      if (idx >= 0) {
	        children.splice(idx, 0, child);
	
	        this._doAdd(child);
	      }
	    }
	
	    return this;
	  },
	  _doAdd: function (child) {
	    if (child.parent) {
	      child.parent.remove(child);
	    }
	
	    child.parent = this;
	    var storage = this.__storage;
	    var zr = this.__zr;
	
	    if (storage && storage !== child.__storage) {
	      storage.addToStorage(child);
	
	      if (child instanceof Group) {
	        child.addChildrenToStorage(storage);
	      }
	    }
	
	    zr && zr.refresh();
	  },
	
	  /**
	   * 移除子节点
	   * @param {module:zrender/Element} child
	   */
	  remove: function (child) {
	    var zr = this.__zr;
	    var storage = this.__storage;
	    var children = this._children;
	    var idx = zrUtil.indexOf(children, child);
	
	    if (idx < 0) {
	      return this;
	    }
	
	    children.splice(idx, 1);
	    child.parent = null;
	
	    if (storage) {
	      storage.delFromStorage(child);
	
	      if (child instanceof Group) {
	        child.delChildrenFromStorage(storage);
	      }
	    }
	
	    zr && zr.refresh();
	    return this;
	  },
	
	  /**
	   * 移除所有子节点
	   */
	  removeAll: function () {
	    var children = this._children;
	    var storage = this.__storage;
	    var child;
	    var i;
	
	    for (i = 0; i < children.length; i++) {
	      child = children[i];
	
	      if (storage) {
	        storage.delFromStorage(child);
	
	        if (child instanceof Group) {
	          child.delChildrenFromStorage(storage);
	        }
	      }
	
	      child.parent = null;
	    }
	
	    children.length = 0;
	    return this;
	  },
	
	  /**
	   * 遍历所有子节点
	   * @param  {Function} cb
	   * @param  {}   context
	   */
	  eachChild: function (cb, context) {
	    var children = this._children;
	
	    for (var i = 0; i < children.length; i++) {
	      var child = children[i];
	      cb.call(context, child, i);
	    }
	
	    return this;
	  },
	
	  /**
	   * 深度优先遍历所有子孙节点
	   * @param  {Function} cb
	   * @param  {}   context
	   */
	  traverse: function (cb, context) {
	    for (var i = 0; i < this._children.length; i++) {
	      var child = this._children[i];
	      cb.call(context, child);
	
	      if (child.type === 'group') {
	        child.traverse(cb, context);
	      }
	    }
	
	    return this;
	  },
	  addChildrenToStorage: function (storage) {
	    for (var i = 0; i < this._children.length; i++) {
	      var child = this._children[i];
	      storage.addToStorage(child);
	
	      if (child instanceof Group) {
	        child.addChildrenToStorage(storage);
	      }
	    }
	  },
	  delChildrenFromStorage: function (storage) {
	    for (var i = 0; i < this._children.length; i++) {
	      var child = this._children[i];
	      storage.delFromStorage(child);
	
	      if (child instanceof Group) {
	        child.delChildrenFromStorage(storage);
	      }
	    }
	  },
	  dirty: function () {
	    this.__dirty = true;
	    this.__zr && this.__zr.refresh();
	    return this;
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getBoundingRect: function (includeChildren) {
	    // TODO Caching
	    var rect = null;
	    var tmpRect = new BoundingRect(0, 0, 0, 0);
	    var children = includeChildren || this._children;
	    var tmpMat = [];
	
	    for (var i = 0; i < children.length; i++) {
	      var child = children[i];
	
	      if (child.ignore || child.invisible) {
	        continue;
	      }
	
	      var childRect = child.getBoundingRect();
	      var transform = child.getLocalTransform(tmpMat); // TODO
	      // The boundingRect cacluated by transforming original
	      // rect may be bigger than the actual bundingRect when rotation
	      // is used. (Consider a circle rotated aginst its center, where
	      // the actual boundingRect should be the same as that not be
	      // rotated.) But we can not find better approach to calculate
	      // actual boundingRect yet, considering performance.
	
	      if (transform) {
	        tmpRect.copy(childRect);
	        tmpRect.applyTransform(transform);
	        rect = rect || tmpRect.clone();
	        rect.union(tmpRect);
	      } else {
	        rect = rect || childRect.clone();
	        rect.union(childRect);
	      }
	    }
	
	    return rect || tmpRect;
	  }
	};
	zrUtil.inherits(Group, Element);
	var _default = Group;
	module.exports = _default;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	var Displayable = __webpack_require__(294);
	
	var zrUtil = __webpack_require__(3);
	
	var textContain = __webpack_require__(79);
	
	var textHelper = __webpack_require__(388);
	
	var _constant = __webpack_require__(387);
	
	var ContextCachedBy = _constant.ContextCachedBy;
	
	/**
	 * @alias zrender/graphic/Text
	 * @extends module:zrender/graphic/Displayable
	 * @constructor
	 * @param {Object} opts
	 */
	var Text = function (opts) {
	  // jshint ignore:line
	  Displayable.call(this, opts);
	};
	
	Text.prototype = {
	  constructor: Text,
	  type: 'text',
	  brush: function (ctx, prevEl) {
	    var style = this.style; // Optimize, avoid normalize every time.
	
	    this.__dirty && textHelper.normalizeTextStyle(style, true); // Use props with prefix 'text'.
	
	    style.fill = style.stroke = style.shadowBlur = style.shadowColor = style.shadowOffsetX = style.shadowOffsetY = null;
	    var text = style.text; // Convert to string
	
	    text != null && (text += ''); // Do not apply style.bind in Text node. Because the real bind job
	    // is in textHelper.renderText, and performance of text render should
	    // be considered.
	    // style.bind(ctx, this, prevEl);
	
	    if (!textHelper.needDrawText(text, style)) {
	      // The current el.style is not applied
	      // and should not be used as cache.
	      ctx.__attrCachedBy = ContextCachedBy.NONE;
	      return;
	    }
	
	    this.setTransform(ctx);
	    textHelper.renderText(this, ctx, text, style, null, prevEl);
	    this.restoreTransform(ctx);
	  },
	  getBoundingRect: function () {
	    var style = this.style; // Optimize, avoid normalize every time.
	
	    this.__dirty && textHelper.normalizeTextStyle(style, true);
	
	    if (!this._rect) {
	      var text = style.text;
	      text != null ? text += '' : text = '';
	      var rect = textContain.getBoundingRect(style.text + '', style.font, style.textAlign, style.textVerticalAlign, style.textPadding, style.textLineHeight, style.rich);
	      rect.x += style.x || 0;
	      rect.y += style.y || 0;
	
	      if (textHelper.getStroke(style.textStroke, style.textStrokeWidth)) {
	        var w = style.textStrokeWidth;
	        rect.x -= w / 2;
	        rect.y -= w / 2;
	        rect.width += w;
	        rect.height += w;
	      }
	
	      this._rect = rect;
	    }
	
	    return this._rect;
	  }
	};
	zrUtil.inherits(Text, Displayable);
	var _default = Text;
	module.exports = _default;

/***/ },
/* 189 */
/***/ function(module, exports) {

	/**
	 * Event Mixin
	 * @module zrender/mixin/Eventful
	 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
	 *         pissang (https://www.github.com/pissang)
	 */
	var arrySlice = Array.prototype.slice;
	/**
	 * Event dispatcher.
	 *
	 * @alias module:zrender/mixin/Eventful
	 * @constructor
	 * @param {Object} [eventProcessor] The object eventProcessor is the scope when
	 *        `eventProcessor.xxx` called.
	 * @param {Function} [eventProcessor.normalizeQuery]
	 *        param: {string|Object} Raw query.
	 *        return: {string|Object} Normalized query.
	 * @param {Function} [eventProcessor.filter] Event will be dispatched only
	 *        if it returns `true`.
	 *        param: {string} eventType
	 *        param: {string|Object} query
	 *        return: {boolean}
	 * @param {Function} [eventProcessor.afterTrigger] Called after all handlers called.
	 *        param: {string} eventType
	 */
	
	var Eventful = function (eventProcessor) {
	  this._$handlers = {};
	  this._$eventProcessor = eventProcessor;
	};
	
	Eventful.prototype = {
	  constructor: Eventful,
	
	  /**
	   * The handler can only be triggered once, then removed.
	   *
	   * @param {string} event The event name.
	   * @param {string|Object} [query] Condition used on event filter.
	   * @param {Function} handler The event handler.
	   * @param {Object} context
	   */
	  one: function (event, query, handler, context) {
	    return on(this, event, query, handler, context, true);
	  },
	
	  /**
	   * Bind a handler.
	   *
	   * @param {string} event The event name.
	   * @param {string|Object} [query] Condition used on event filter.
	   * @param {Function} handler The event handler.
	   * @param {Object} [context]
	   */
	  on: function (event, query, handler, context) {
	    return on(this, event, query, handler, context, false);
	  },
	
	  /**
	   * Whether any handler has bound.
	   *
	   * @param  {string}  event
	   * @return {boolean}
	   */
	  isSilent: function (event) {
	    var _h = this._$handlers;
	    return !_h[event] || !_h[event].length;
	  },
	
	  /**
	   * Unbind a event.
	   *
	   * @param {string} [event] The event name.
	   *        If no `event` input, "off" all listeners.
	   * @param {Function} [handler] The event handler.
	   *        If no `handler` input, "off" all listeners of the `event`.
	   */
	  off: function (event, handler) {
	    var _h = this._$handlers;
	
	    if (!event) {
	      this._$handlers = {};
	      return this;
	    }
	
	    if (handler) {
	      if (_h[event]) {
	        var newList = [];
	
	        for (var i = 0, l = _h[event].length; i < l; i++) {
	          if (_h[event][i].h !== handler) {
	            newList.push(_h[event][i]);
	          }
	        }
	
	        _h[event] = newList;
	      }
	
	      if (_h[event] && _h[event].length === 0) {
	        delete _h[event];
	      }
	    } else {
	      delete _h[event];
	    }
	
	    return this;
	  },
	
	  /**
	   * Dispatch a event.
	   *
	   * @param {string} type The event name.
	   */
	  trigger: function (type) {
	    var _h = this._$handlers[type];
	    var eventProcessor = this._$eventProcessor;
	
	    if (_h) {
	      var args = arguments;
	      var argLen = args.length;
	
	      if (argLen > 3) {
	        args = arrySlice.call(args, 1);
	      }
	
	      var len = _h.length;
	
	      for (var i = 0; i < len;) {
	        var hItem = _h[i];
	
	        if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(type, hItem.query)) {
	          i++;
	          continue;
	        } // Optimize advise from backbone
	
	
	        switch (argLen) {
	          case 1:
	            hItem.h.call(hItem.ctx);
	            break;
	
	          case 2:
	            hItem.h.call(hItem.ctx, args[1]);
	            break;
	
	          case 3:
	            hItem.h.call(hItem.ctx, args[1], args[2]);
	            break;
	
	          default:
	            // have more than 2 given arguments
	            hItem.h.apply(hItem.ctx, args);
	            break;
	        }
	
	        if (hItem.one) {
	          _h.splice(i, 1);
	
	          len--;
	        } else {
	          i++;
	        }
	      }
	    }
	
	    eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(type);
	    return this;
	  },
	
	  /**
	   * Dispatch a event with context, which is specified at the last parameter.
	   *
	   * @param {string} type The event name.
	   */
	  triggerWithContext: function (type) {
	    var _h = this._$handlers[type];
	    var eventProcessor = this._$eventProcessor;
	
	    if (_h) {
	      var args = arguments;
	      var argLen = args.length;
	
	      if (argLen > 4) {
	        args = arrySlice.call(args, 1, args.length - 1);
	      }
	
	      var ctx = args[args.length - 1];
	      var len = _h.length;
	
	      for (var i = 0; i < len;) {
	        var hItem = _h[i];
	
	        if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(type, hItem.query)) {
	          i++;
	          continue;
	        } // Optimize advise from backbone
	
	
	        switch (argLen) {
	          case 1:
	            hItem.h.call(ctx);
	            break;
	
	          case 2:
	            hItem.h.call(ctx, args[1]);
	            break;
	
	          case 3:
	            hItem.h.call(ctx, args[1], args[2]);
	            break;
	
	          default:
	            // have more than 2 given arguments
	            hItem.h.apply(ctx, args);
	            break;
	        }
	
	        if (hItem.one) {
	          _h.splice(i, 1);
	
	          len--;
	        } else {
	          i++;
	        }
	      }
	    }
	
	    eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(type);
	    return this;
	  }
	};
	
	function normalizeQuery(host, query) {
	  var eventProcessor = host._$eventProcessor;
	
	  if (query != null && eventProcessor && eventProcessor.normalizeQuery) {
	    query = eventProcessor.normalizeQuery(query);
	  }
	
	  return query;
	}
	
	function on(eventful, event, query, handler, context, isOnce) {
	  var _h = eventful._$handlers;
	
	  if (typeof query === 'function') {
	    context = handler;
	    handler = query;
	    query = null;
	  }
	
	  if (!handler || !event) {
	    return eventful;
	  }
	
	  query = normalizeQuery(eventful, query);
	
	  if (!_h[event]) {
	    _h[event] = [];
	  }
	
	  for (var i = 0; i < _h[event].length; i++) {
	    if (_h[event][i].h === handler) {
	      return eventful;
	    }
	  }
	
	  var wrap = {
	    h: handler,
	    one: isOnce,
	    query: query,
	    ctx: context || eventful,
	    // FIXME
	    // Do not publish this feature util it is proved that it makes sense.
	    callAtLast: handler.zrEventfulCallAtLast
	  };
	  var lastIndex = _h[event].length - 1;
	  var lastWrap = _h[event][lastIndex];
	  lastWrap && lastWrap.callAtLast ? _h[event].splice(lastIndex, 0, wrap) : _h[event].push(wrap);
	  return eventful;
	} // ----------------------
	// The events in zrender
	// ----------------------
	
	/**
	 * @event module:zrender/mixin/Eventful#onclick
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmouseover
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmouseout
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmousemove
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmousewheel
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmousedown
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmouseup
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondrag
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondragstart
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondragend
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondragenter
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondragleave
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondragover
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondrop
	 * @type {Function}
	 * @default null
	 */
	
	
	var _default = Eventful;
	module.exports = _default;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Dialog.default;
	  }
	});
	
	var _Dialog = _interopRequireDefault(__webpack_require__(1157));

/***/ },
/* 191 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formControlState;
	
	function formControlState(_ref) {
	  var props = _ref.props,
	      states = _ref.states,
	      muiFormControl = _ref.muiFormControl;
	  return states.reduce(function (acc, state) {
	    acc[state] = props[state];
	
	    if (muiFormControl) {
	      if (typeof props[state] === 'undefined') {
	        acc[state] = muiFormControl[state];
	      }
	    }
	
	    return acc;
	  }, {});
	}

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Snackbar.default;
	  }
	});
	
	var _Snackbar = _interopRequireDefault(__webpack_require__(1238));

/***/ },
/* 193 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTransitionProps = getTransitionProps;
	exports.reflow = void 0;
	
	var reflow = function reflow(node) {
	  return node.scrollTop;
	};
	
	exports.reflow = reflow;
	
	function getTransitionProps(props, options) {
	  var timeout = props.timeout,
	      _props$style = props.style,
	      style = _props$style === void 0 ? {} : _props$style;
	  return {
	    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
	    delay: style.transitionDelay
	  };
	}

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createChainedFunction;
	
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.reduce(function (acc, func) {
	    if (func == null) {
	      return acc;
	    }
	
	    if (false) {
	      if (typeof func !== 'function') {
	        console.error('Material-UI: Invalid Argument Type, must only provide functions, undefined, or null.');
	      }
	    }
	
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      func.apply(this, args);
	    };
	  }, function () {});
	}

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var columnGroup_1 = __webpack_require__(159);
	var originalColumnGroup_1 = __webpack_require__(196);
	var context_1 = __webpack_require__(8);
	var context_2 = __webpack_require__(8);
	// takes in a list of columns, as specified by the column definitions, and returns column groups
	var ColumnUtils = /** @class */ (function () {
	    function ColumnUtils() {
	    }
	    ColumnUtils.prototype.calculateColInitialWidth = function (colDef) {
	        if (!colDef.width) {
	            // if no width defined in colDef, use default
	            return this.gridOptionsWrapper.getColWidth();
	        }
	        else if (colDef.width < this.gridOptionsWrapper.getMinColWidth()) {
	            // if width in col def to small, set to min width
	            return this.gridOptionsWrapper.getMinColWidth();
	        }
	        else {
	            // otherwise use the provided width
	            return colDef.width;
	        }
	    };
	    ColumnUtils.prototype.getOriginalPathForColumn = function (column, originalBalancedTree) {
	        var result = [];
	        var found = false;
	        recursePath(originalBalancedTree, 0);
	        // we should always find the path, but in case there is a bug somewhere, returning null
	        // will make it fail rather than provide a 'hard to track down' bug
	        if (found) {
	            return result;
	        }
	        else {
	            return null;
	        }
	        function recursePath(balancedColumnTree, dept) {
	            for (var i = 0; i < balancedColumnTree.length; i++) {
	                if (found) {
	                    // quit the search, so 'result' is kept with the found result
	                    return;
	                }
	                var node = balancedColumnTree[i];
	                if (node instanceof originalColumnGroup_1.OriginalColumnGroup) {
	                    var nextNode = node;
	                    recursePath(nextNode.getChildren(), dept + 1);
	                    result[dept] = node;
	                }
	                else {
	                    if (node === column) {
	                        found = true;
	                    }
	                }
	            }
	        }
	    };
	    /*    public getPathForColumn(column: Column, allDisplayedColumnGroups: ColumnGroupChild[]): ColumnGroup[] {
	            let result: ColumnGroup[] = [];
	            let found = false;
	    
	            recursePath(allDisplayedColumnGroups, 0);
	    
	            // we should always find the path, but in case there is a bug somewhere, returning null
	            // will make it fail rather than provide a 'hard to track down' bug
	            if (found) {
	                return result;
	            } else {
	                return null;
	            }
	    
	            function recursePath(balancedColumnTree: ColumnGroupChild[], dept: number): void {
	    
	                for (let i = 0; i<balancedColumnTree.length; i++) {
	                    if (found) {
	                        // quit the search, so 'result' is kept with the found result
	                        return;
	                    }
	                    let node = balancedColumnTree[i];
	                    if (node instanceof ColumnGroup) {
	                        let nextNode = <ColumnGroup> node;
	                        recursePath(nextNode.getChildren(), dept+1);
	                        result[dept] = node;
	                    } else {
	                        if (node === column) {
	                            found = true;
	                        }
	                    }
	                }
	            }
	        }*/
	    ColumnUtils.prototype.depthFirstOriginalTreeSearch = function (parent, tree, callback) {
	        var _this = this;
	        if (!tree) {
	            return;
	        }
	        tree.forEach(function (child) {
	            if (child instanceof originalColumnGroup_1.OriginalColumnGroup) {
	                _this.depthFirstOriginalTreeSearch(child, child.getChildren(), callback);
	            }
	            callback(child, parent);
	        });
	    };
	    ColumnUtils.prototype.depthFirstAllColumnTreeSearch = function (tree, callback) {
	        var _this = this;
	        if (!tree) {
	            return;
	        }
	        tree.forEach(function (child) {
	            if (child instanceof columnGroup_1.ColumnGroup) {
	                _this.depthFirstAllColumnTreeSearch(child.getChildren(), callback);
	            }
	            callback(child);
	        });
	    };
	    ColumnUtils.prototype.depthFirstDisplayedColumnTreeSearch = function (tree, callback) {
	        var _this = this;
	        if (!tree) {
	            return;
	        }
	        tree.forEach(function (child) {
	            if (child instanceof columnGroup_1.ColumnGroup) {
	                _this.depthFirstDisplayedColumnTreeSearch(child.getDisplayedChildren(), callback);
	            }
	            callback(child);
	        });
	    };
	    __decorate([
	        context_2.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], ColumnUtils.prototype, "gridOptionsWrapper", void 0);
	    ColumnUtils = __decorate([
	        context_1.Bean('columnUtils')
	    ], ColumnUtils);
	    return ColumnUtils;
	}());
	exports.ColumnUtils = ColumnUtils;


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var columnGroup_1 = __webpack_require__(159);
	var column_1 = __webpack_require__(45);
	var eventService_1 = __webpack_require__(22);
	var OriginalColumnGroup = /** @class */ (function () {
	    function OriginalColumnGroup(colGroupDef, groupId, padding, level) {
	        this.localEventService = new eventService_1.EventService();
	        this.expandable = false;
	        this.colGroupDef = colGroupDef;
	        this.groupId = groupId;
	        this.expanded = colGroupDef && !!colGroupDef.openByDefault;
	        this.padding = padding;
	        this.level = level;
	    }
	    OriginalColumnGroup.prototype.setOriginalParent = function (originalParent) {
	        this.originalParent = this.originalParent;
	    };
	    OriginalColumnGroup.prototype.getOriginalParent = function () {
	        return this.originalParent;
	    };
	    OriginalColumnGroup.prototype.getLevel = function () {
	        return this.level;
	    };
	    OriginalColumnGroup.prototype.isVisible = function () {
	        // return true if at least one child is visible
	        if (this.children) {
	            return this.children.some(function (child) { return child.isVisible(); });
	        }
	        return false;
	    };
	    OriginalColumnGroup.prototype.isPadding = function () {
	        return this.padding;
	    };
	    OriginalColumnGroup.prototype.setExpanded = function (expanded) {
	        this.expanded = expanded === undefined ? false : expanded;
	        var event = {
	            type: OriginalColumnGroup.EVENT_EXPANDED_CHANGED
	        };
	        this.localEventService.dispatchEvent(event);
	    };
	    OriginalColumnGroup.prototype.isExpandable = function () {
	        return this.expandable;
	    };
	    OriginalColumnGroup.prototype.isExpanded = function () {
	        return this.expanded;
	    };
	    OriginalColumnGroup.prototype.getGroupId = function () {
	        return this.groupId;
	    };
	    OriginalColumnGroup.prototype.getId = function () {
	        return this.getGroupId();
	    };
	    OriginalColumnGroup.prototype.setChildren = function (children) {
	        this.children = children;
	    };
	    OriginalColumnGroup.prototype.getChildren = function () {
	        return this.children;
	    };
	    OriginalColumnGroup.prototype.getColGroupDef = function () {
	        return this.colGroupDef;
	    };
	    OriginalColumnGroup.prototype.getLeafColumns = function () {
	        var result = [];
	        this.addLeafColumns(result);
	        return result;
	    };
	    OriginalColumnGroup.prototype.addLeafColumns = function (leafColumns) {
	        if (!this.children) {
	            return;
	        }
	        this.children.forEach(function (child) {
	            if (child instanceof column_1.Column) {
	                leafColumns.push(child);
	            }
	            else if (child instanceof OriginalColumnGroup) {
	                child.addLeafColumns(leafColumns);
	            }
	        });
	    };
	    OriginalColumnGroup.prototype.getColumnGroupShow = function () {
	        return this.padding ? columnGroup_1.ColumnGroup.HEADER_GROUP_PADDING : this.colGroupDef.columnGroupShow;
	    };
	    // need to check that this group has at least one col showing when both expanded and contracted.
	    // if not, then we don't allow expanding and contracting on this group
	    OriginalColumnGroup.prototype.setupExpandable = function () {
	        var _this = this;
	        this.setExpandable();
	        // note - we should be removing this event listener
	        this.getLeafColumns().forEach(function (col) { return col.addEventListener(column_1.Column.EVENT_VISIBLE_CHANGED, _this.onColumnVisibilityChanged.bind(_this)); });
	    };
	    OriginalColumnGroup.prototype.setExpandable = function () {
	        if (this.isPadding()) {
	            return;
	        }
	        // want to make sure the group doesn't disappear when it's open
	        var atLeastOneShowingWhenOpen = false;
	        // want to make sure the group doesn't disappear when it's closed
	        var atLeastOneShowingWhenClosed = false;
	        // want to make sure the group has something to show / hide
	        var atLeastOneChangeable = false;
	        var children = this.findChildren();
	        for (var i = 0, j = children.length; i < j; i++) {
	            var abstractColumn = children[i];
	            if (!abstractColumn.isVisible()) {
	                continue;
	            }
	            // if the abstractColumn is a grid generated group, there will be no colDef
	            var headerGroupShow = abstractColumn.getColumnGroupShow();
	            if (headerGroupShow === columnGroup_1.ColumnGroup.HEADER_GROUP_SHOW_OPEN) {
	                atLeastOneShowingWhenOpen = true;
	                atLeastOneChangeable = true;
	            }
	            else if (headerGroupShow === columnGroup_1.ColumnGroup.HEADER_GROUP_SHOW_CLOSED) {
	                atLeastOneShowingWhenClosed = true;
	                atLeastOneChangeable = true;
	            }
	            else {
	                atLeastOneShowingWhenOpen = true;
	                atLeastOneShowingWhenClosed = true;
	                if (headerGroupShow === columnGroup_1.ColumnGroup.HEADER_GROUP_PADDING) {
	                    var column = abstractColumn;
	                    atLeastOneChangeable = column.children.some(function (child) { return child.getColumnGroupShow() !== undefined; });
	                }
	            }
	        }
	        var expandable = atLeastOneShowingWhenOpen && atLeastOneShowingWhenClosed && atLeastOneChangeable;
	        if (this.expandable !== expandable) {
	            this.expandable = expandable;
	            var event_1 = {
	                type: OriginalColumnGroup.EVENT_EXPANDABLE_CHANGED
	            };
	            this.localEventService.dispatchEvent(event_1);
	        }
	    };
	    OriginalColumnGroup.prototype.findChildren = function () {
	        var children = this.children;
	        var firstChild = children[0];
	        if (firstChild && (!firstChild.isPadding || !firstChild.isPadding())) {
	            return children;
	        }
	        while (children.length === 1 && children[0] instanceof OriginalColumnGroup) {
	            children = children[0].children;
	        }
	        return children;
	    };
	    OriginalColumnGroup.prototype.onColumnVisibilityChanged = function () {
	        this.setExpandable();
	    };
	    OriginalColumnGroup.prototype.addEventListener = function (eventType, listener) {
	        this.localEventService.addEventListener(eventType, listener);
	    };
	    OriginalColumnGroup.prototype.removeEventListener = function (eventType, listener) {
	        this.localEventService.removeEventListener(eventType, listener);
	    };
	    OriginalColumnGroup.EVENT_EXPANDED_CHANGED = 'expandedChanged';
	    OriginalColumnGroup.EVENT_EXPANDABLE_CHANGED = 'expandableChanged';
	    return OriginalColumnGroup;
	}());
	exports.OriginalColumnGroup = OriginalColumnGroup;


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var eventKeys_1 = __webpack_require__(160);
	var eventService_1 = __webpack_require__(22);
	var AnimationFrameService = /** @class */ (function () {
	    function AnimationFrameService() {
	        // create tasks are to do with row creation. for them we want to execute according to row order, so we use
	        // TaskItem so we know what index the item is for.
	        this.p1Tasks = [];
	        // destroy tasks are to do with row removal. they are done after row creation as the user will need to see new
	        // rows first (as blank is scrolled into view), when we remove the old rows (no longer in view) is not as
	        // important.
	        this.p2Tasks = [];
	        this.ticking = false;
	        // we need to know direction of scroll, to build up rows in the direction of
	        // the scroll. eg if user scrolls down, we extend the rows by building down.
	        this.scrollGoingDown = true;
	        this.lastScrollTop = 0;
	    }
	    AnimationFrameService.prototype.setScrollTop = function (scrollTop) {
	        this.scrollGoingDown = scrollTop > this.lastScrollTop;
	        this.lastScrollTop = scrollTop;
	    };
	    AnimationFrameService.prototype.registerGridComp = function (gridPanel) {
	        this.gridPanel = gridPanel;
	    };
	    AnimationFrameService.prototype.init = function () {
	        this.useAnimationFrame = !this.gridOptionsWrapper.isSuppressAnimationFrame();
	    };
	    // this method is for our ag-Grid sanity only - if animation frames are turned off,
	    // then no place in the code should be looking to add any work to be done in animation
	    // frames. this stops bugs - where some code is asking for a frame to be executed
	    // when it should not.
	    AnimationFrameService.prototype.verifyAnimationFrameOn = function (methodName) {
	        if (this.useAnimationFrame === false) {
	            console.warn("ag-Grid: AnimationFrameService." + methodName + " called but animation frames are off");
	        }
	    };
	    AnimationFrameService.prototype.addP1Task = function (task, index) {
	        this.verifyAnimationFrameOn('addP1Task');
	        var taskItem = { task: task, index: index };
	        this.p1Tasks.push(taskItem);
	        this.schedule();
	    };
	    AnimationFrameService.prototype.addP2Task = function (task) {
	        this.verifyAnimationFrameOn('addP2Task');
	        this.p2Tasks.push(task);
	        this.schedule();
	    };
	    AnimationFrameService.prototype.executeFrame = function (millis) {
	        this.verifyAnimationFrameOn('executeFrame');
	        if (this.scrollGoingDown) {
	            this.p1Tasks.sort(function (a, b) { return b.index - a.index; });
	        }
	        else {
	            this.p1Tasks.sort(function (a, b) { return a.index - b.index; });
	        }
	        var frameStart = new Date().getTime();
	        var duration = (new Date().getTime()) - frameStart;
	        // 16ms is 60 fps
	        var noMaxMillis = millis <= 0;
	        while (noMaxMillis || duration < millis) {
	            var gridPanelUpdated = this.gridPanel.executeFrame();
	            if (!gridPanelUpdated) {
	                if (this.p1Tasks.length > 0) {
	                    var taskItem = this.p1Tasks.pop();
	                    taskItem.task();
	                }
	                else if (this.p2Tasks.length > 0) {
	                    var task = this.p2Tasks.pop();
	                    task();
	                }
	                else {
	                    break;
	                }
	            }
	            duration = (new Date().getTime()) - frameStart;
	        }
	        if (this.p1Tasks.length > 0 || this.p2Tasks.length > 0) {
	            this.requestFrame();
	        }
	        else {
	            this.stopTicking();
	        }
	    };
	    AnimationFrameService.prototype.stopTicking = function () {
	        this.ticking = false;
	        var event = {
	            type: eventKeys_1.Events.EVENT_ANIMATION_QUEUE_EMPTY,
	            columnApi: this.gridOptionsWrapper.getColumnApi(),
	            api: this.gridOptionsWrapper.getApi()
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    AnimationFrameService.prototype.flushAllFrames = function () {
	        if (!this.useAnimationFrame) {
	            return;
	        }
	        this.executeFrame(-1);
	    };
	    AnimationFrameService.prototype.schedule = function () {
	        if (!this.useAnimationFrame) {
	            return;
	        }
	        if (!this.ticking) {
	            this.ticking = true;
	            this.requestFrame();
	        }
	    };
	    AnimationFrameService.prototype.requestFrame = function () {
	        // check for the existence of requestAnimationFrame, and if
	        // it's missing, then we polyfill it with setTimeout()
	        var callback = this.executeFrame.bind(this, 60);
	        if (window.requestAnimationFrame) {
	            window.requestAnimationFrame(callback);
	        }
	        else if (window.webkitRequestAnimationFrame) {
	            window.webkitRequestAnimationFrame(callback);
	        }
	        else {
	            window.setTimeout(callback, 0);
	        }
	    };
	    AnimationFrameService.prototype.isQueueEmpty = function () {
	        return this.ticking;
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], AnimationFrameService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], AnimationFrameService.prototype, "eventService", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], AnimationFrameService.prototype, "init", null);
	    AnimationFrameService = __decorate([
	        context_1.Bean('animationFrameService')
	    ], AnimationFrameService);
	    return AnimationFrameService;
	}());
	exports.AnimationFrameService = AnimationFrameService;


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var ValueCache = /** @class */ (function () {
	    function ValueCache() {
	        this.cacheVersion = 0;
	    }
	    ValueCache.prototype.init = function () {
	        this.active = this.gridOptionsWrapper.isValueCache();
	        this.neverExpires = this.gridOptionsWrapper.isValueCacheNeverExpires();
	    };
	    ValueCache.prototype.onDataChanged = function () {
	        if (this.neverExpires) {
	            return;
	        }
	        this.expire();
	    };
	    ValueCache.prototype.expire = function () {
	        this.cacheVersion++;
	    };
	    ValueCache.prototype.setValue = function (rowNode, colId, value) {
	        if (this.active) {
	            if (rowNode.__cacheVersion !== this.cacheVersion) {
	                rowNode.__cacheVersion = this.cacheVersion;
	                rowNode.__cacheData = {};
	            }
	            rowNode.__cacheData[colId] = value;
	        }
	    };
	    ValueCache.prototype.getValue = function (rowNode, colId) {
	        var valueInCache = this.active
	            && rowNode.__cacheVersion === this.cacheVersion
	            && rowNode.__cacheData[colId] !== undefined;
	        if (valueInCache) {
	            return rowNode.__cacheData[colId];
	        }
	        else {
	            return undefined;
	        }
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], ValueCache.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ValueCache.prototype, "init", null);
	    ValueCache = __decorate([
	        context_1.Bean('valueCache')
	    ], ValueCache);
	    return ValueCache;
	}());
	exports.ValueCache = ValueCache;


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var agAbstractInputField_1 = __webpack_require__(254);
	var agAbstractField_1 = __webpack_require__(162);
	var utils_1 = __webpack_require__(10);
	var AgCheckbox = /** @class */ (function (_super) {
	    __extends(AgCheckbox, _super);
	    function AgCheckbox() {
	        var _this = _super.call(this) || this;
	        _this.className = 'ag-checkbox';
	        _this.displayTag = 'input';
	        _this.inputType = 'checkbox';
	        _this.labelAlignment = 'right';
	        _this.iconMap = {
	            selected: 'checkboxChecked',
	            unselected: 'checkboxUnchecked',
	            indeterminate: 'checkboxIndeterminate'
	        };
	        _this.selected = false;
	        _this.readOnly = false;
	        _this.passive = false;
	        _this.setTemplate(_this.TEMPLATE.replace(/%displayField%/g, _this.displayTag));
	        return _this;
	    }
	    AgCheckbox.prototype.postConstruct = function () {
	        _super.prototype.postConstruct.call(this);
	        utils_1._.addCssClass(this.eInput, 'ag-hidden');
	        this.addIconsPlaceholder();
	        this.updateIcons();
	    };
	    AgCheckbox.prototype.addInputListeners = function () {
	        var _this = this;
	        this.addDestroyableEventListener(this.getGui(), 'click', function (e) { return _this.onClick(e); });
	        this.addDestroyableEventListener(this.eInput, 'change', function (e) { return _this.setValue(e.target.checked, true); });
	    };
	    AgCheckbox.prototype.addIconsPlaceholder = function () {
	        var iconDiv = document.createElement('div');
	        this.eWrapper.appendChild(iconDiv);
	        this.eIconEl = iconDiv;
	    };
	    AgCheckbox.prototype.onClick = function (event) {
	        // if we don't set the path, then won't work in Edge, as once the <span> is removed from the dom,
	        // it's not possible to calculate the path by following the parent's chain. in other browser (eg
	        // chrome) there is event.path for this purpose, but missing in Edge.
	        utils_1._.addAgGridEventPath(event);
	        if (!this.readOnly) {
	            this.toggle();
	        }
	    };
	    AgCheckbox.prototype.getNextValue = function () {
	        return this.selected === undefined ? true : !this.selected;
	    };
	    AgCheckbox.prototype.setPassive = function (passive) {
	        this.passive = passive;
	    };
	    AgCheckbox.prototype.setReadOnly = function (readOnly) {
	        this.readOnly = readOnly;
	        this.updateIcons();
	    };
	    AgCheckbox.prototype.isReadOnly = function () {
	        return this.readOnly;
	    };
	    AgCheckbox.prototype.isSelected = function () {
	        return this.selected;
	    };
	    AgCheckbox.prototype.toggle = function () {
	        var nextValue = this.getNextValue();
	        if (this.passive) {
	            var event_1 = {
	                type: AgCheckbox.EVENT_CHANGED,
	                selected: nextValue
	            };
	            this.dispatchEvent(event_1);
	        }
	        else {
	            this.setValue(nextValue);
	        }
	    };
	    AgCheckbox.prototype.setSelected = function (selected, silent) {
	        if (this.selected === selected) {
	            return;
	        }
	        this.selected = typeof selected === 'boolean' ? selected : undefined;
	        this.eInput.checked = this.selected;
	        this.updateIcons();
	        if (!silent) {
	            var event_2 = {
	                type: agAbstractField_1.AgAbstractField.EVENT_CHANGED,
	                selected: this.selected
	            };
	            this.dispatchEvent(event_2);
	        }
	    };
	    AgCheckbox.prototype.getIconName = function () {
	        var value = this.getValue();
	        var prop = value === undefined ? 'indeterminate' : (value ? 'selected' : 'unselected');
	        var readOnlyStr = this.isReadOnly() ? 'ReadOnly' : '';
	        return "" + this.iconMap[prop] + readOnlyStr;
	    };
	    AgCheckbox.prototype.updateIcons = function () {
	        utils_1._.clearElement(this.eIconEl);
	        this.eIconEl.appendChild(utils_1._.createIconNoSpan(this.getIconName(), this.gridOptionsWrapper, null));
	    };
	    AgCheckbox.prototype.getValue = function () {
	        return this.isSelected();
	    };
	    AgCheckbox.prototype.setValue = function (value, silent) {
	        this.setSelected(value, silent);
	        return this;
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], AgCheckbox.prototype, "gridOptionsWrapper", void 0);
	    return AgCheckbox;
	}(agAbstractInputField_1.AgAbstractInputField));
	exports.AgCheckbox = AgCheckbox;


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(31);
	var utils_1 = __webpack_require__(10);
	var PopupComponent = /** @class */ (function (_super) {
	    __extends(PopupComponent, _super);
	    function PopupComponent() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PopupComponent.prototype.isPopup = function () {
	        return true;
	    };
	    PopupComponent.prototype.setParentComponent = function (container) {
	        utils_1._.addCssClass(container.getGui(), 'ag-has-popup');
	        _super.prototype.setParentComponent.call(this, container);
	    };
	    PopupComponent.prototype.destroy = function () {
	        var parentComp = this.parentComponent;
	        var hasParent = parentComp && parentComp.isAlive();
	        if (hasParent) {
	            utils_1._.removeCssClass(parentComp.getGui(), 'ag-has-popup');
	        }
	        _super.prototype.destroy.call(this);
	    };
	    return PopupComponent;
	}(component_1.Component));
	exports.PopupComponent = PopupComponent;


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createDimensions = __webpack_require__(207);
	
	var List = __webpack_require__(83);
	
	var _util = __webpack_require__(3);
	
	var extend = _util.extend;
	var isArray = _util.isArray;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * [Usage]:
	 * (1)
	 * createListSimply(seriesModel, ['value']);
	 * (2)
	 * createListSimply(seriesModel, {
	 *     coordDimensions: ['value'],
	 *     dimensionsCount: 5
	 * });
	 *
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {Object|Array.<string|Object>} opt opt or coordDimensions
	 *        The options in opt, see `echarts/data/helper/createDimensions`
	 * @param {Array.<string>} [nameList]
	 * @return {module:echarts/data/List}
	 */
	function _default(seriesModel, opt, nameList) {
	  opt = isArray(opt) && {
	    coordDimensions: opt
	  } || extend({}, opt);
	  var source = seriesModel.getSource();
	  var dimensionsInfo = createDimensions(source, opt);
	  var list = new List(dimensionsInfo, seriesModel);
	  list.initData(source, nameList);
	  return list;
	}
	
	module.exports = _default;

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _model = __webpack_require__(24);
	
	var makeInner = _model.makeInner;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @return {string} If large mode changed, return string 'reset';
	 */
	function _default() {
	  var inner = makeInner();
	  return function (seriesModel) {
	    var fields = inner(seriesModel);
	    var pipelineContext = seriesModel.pipelineContext;
	    var originalLarge = fields.large;
	    var originalProgressive = fields.progressiveRender; // FIXME: if the planner works on a filtered series, `pipelineContext` does not
	    // exists. See #11611 . Probably we need to modify this structure, see the comment
	    // on `performRawSeries` in `Schedular.js`.
	
	    var large = fields.large = pipelineContext && pipelineContext.large;
	    var progressive = fields.progressiveRender = pipelineContext && pipelineContext.progressiveRender;
	    return !!(originalLarge ^ large || originalProgressive ^ progressive) && 'reset';
	  };
	}
	
	module.exports = _default;

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var env = __webpack_require__(55);
	
	var modelUtil = __webpack_require__(24);
	
	var helper = __webpack_require__(461);
	
	var AxisProxy = __webpack_require__(1589);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var eachAxisDim = helper.eachAxisDim;
	var DataZoomModel = echarts.extendComponentModel({
	  type: 'dataZoom',
	  dependencies: ['xAxis', 'yAxis', 'zAxis', 'radiusAxis', 'angleAxis', 'singleAxis', 'series'],
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    zlevel: 0,
	    z: 4,
	    // Higher than normal component (z: 2).
	    orient: null,
	    // Default auto by axisIndex. Possible value: 'horizontal', 'vertical'.
	    xAxisIndex: null,
	    // Default the first horizontal category axis.
	    yAxisIndex: null,
	    // Default the first vertical category axis.
	    filterMode: 'filter',
	    // Possible values: 'filter' or 'empty' or 'weakFilter'.
	    // 'filter': data items which are out of window will be removed. This option is
	    //          applicable when filtering outliers. For each data item, it will be
	    //          filtered if one of the relevant dimensions is out of the window.
	    // 'weakFilter': data items which are out of window will be removed. This option
	    //          is applicable when filtering outliers. For each data item, it will be
	    //          filtered only if all  of the relevant dimensions are out of the same
	    //          side of the window.
	    // 'empty': data items which are out of window will be set to empty.
	    //          This option is applicable when user should not neglect
	    //          that there are some data items out of window.
	    // 'none': Do not filter.
	    // Taking line chart as an example, line will be broken in
	    // the filtered points when filterModel is set to 'empty', but
	    // be connected when set to 'filter'.
	    throttle: null,
	    // Dispatch action by the fixed rate, avoid frequency.
	    // default 100. Do not throttle when use null/undefined.
	    // If animation === true and animationDurationUpdate > 0,
	    // default value is 100, otherwise 20.
	    start: 0,
	    // Start percent. 0 ~ 100
	    end: 100,
	    // End percent. 0 ~ 100
	    startValue: null,
	    // Start value. If startValue specified, start is ignored.
	    endValue: null,
	    // End value. If endValue specified, end is ignored.
	    minSpan: null,
	    // 0 ~ 100
	    maxSpan: null,
	    // 0 ~ 100
	    minValueSpan: null,
	    // The range of dataZoom can not be smaller than that.
	    maxValueSpan: null,
	    // The range of dataZoom can not be larger than that.
	    rangeMode: null // Array, can be 'value' or 'percent'.
	
	  },
	
	  /**
	   * @override
	   */
	  init: function (option, parentModel, ecModel) {
	    /**
	     * key like x_0, y_1
	     * @private
	     * @type {Object}
	     */
	    this._dataIntervalByAxis = {};
	    /**
	     * @private
	     */
	
	    this._dataInfo = {};
	    /**
	     * key like x_0, y_1
	     * @private
	     */
	
	    this._axisProxies = {};
	    /**
	     * @readOnly
	     */
	
	    this.textStyleModel;
	    /**
	     * @private
	     */
	
	    this._autoThrottle = true;
	    /**
	     * It is `[rangeModeForMin, rangeModeForMax]`.
	     * The optional values for `rangeMode`:
	     * + `'value'` mode: the axis extent will always be determined by
	     *     `dataZoom.startValue` and `dataZoom.endValue`, despite
	     *     how data like and how `axis.min` and `axis.max` are.
	     * + `'percent'` mode: `100` represents 100% of the `[dMin, dMax]`,
	     *     where `dMin` is `axis.min` if `axis.min` specified, otherwise `data.extent[0]`,
	     *     and `dMax` is `axis.max` if `axis.max` specified, otherwise `data.extent[1]`.
	     *     Axis extent will be determined by the result of the percent of `[dMin, dMax]`.
	     *
	     * For example, when users are using dynamic data (update data periodically via `setOption`),
	     * if in `'value`' mode, the window will be kept in a fixed value range despite how
	     * data are appended, while if in `'percent'` mode, whe window range will be changed alone with
	     * the appended data (suppose `axis.min` and `axis.max` are not specified).
	     *
	     * @private
	     */
	
	    this._rangePropMode = ['percent', 'percent'];
	    var inputRawOption = retrieveRawOption(option);
	    /**
	     * Suppose a "main process" start at the point that model prepared (that is,
	     * model initialized or merged or method called in `action`).
	     * We should keep the `main process` idempotent, that is, given a set of values
	     * on `option`, we get the same result.
	     *
	     * But sometimes, values on `option` will be updated for providing users
	     * a "final calculated value" (`dataZoomProcessor` will do that). Those value
	     * should not be the base/input of the `main process`.
	     *
	     * So in that case we should save and keep the input of the `main process`
	     * separately, called `settledOption`.
	     *
	     * For example, consider the case:
	     * (Step_1) brush zoom the grid by `toolbox.dataZoom`,
	     *     where the original input `option.startValue`, `option.endValue` are earsed by
	     *     calculated value.
	     * (Step)2) click the legend to hide and show a series,
	     *     where the new range is calculated by the earsed `startValue` and `endValue`,
	     *     which brings incorrect result.
	     *
	     * @readOnly
	     */
	
	    this.settledOption = inputRawOption;
	    this.mergeDefaultAndTheme(option, ecModel);
	    this.doInit(inputRawOption);
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function (newOption) {
	    var inputRawOption = retrieveRawOption(newOption); //FIX #2591
	
	    zrUtil.merge(this.option, newOption, true);
	    zrUtil.merge(this.settledOption, inputRawOption, true);
	    this.doInit(inputRawOption);
	  },
	
	  /**
	   * @protected
	   */
	  doInit: function (inputRawOption) {
	    var thisOption = this.option; // Disable realtime view update if canvas is not supported.
	
	    if (!env.canvasSupported) {
	      thisOption.realtime = false;
	    }
	
	    this._setDefaultThrottle(inputRawOption);
	
	    updateRangeUse(this, inputRawOption);
	    var settledOption = this.settledOption;
	    each([['start', 'startValue'], ['end', 'endValue']], function (names, index) {
	      // start/end has higher priority over startValue/endValue if they
	      // both set, but we should make chart.setOption({endValue: 1000})
	      // effective, rather than chart.setOption({endValue: 1000, end: null}).
	      if (this._rangePropMode[index] === 'value') {
	        thisOption[names[0]] = settledOption[names[0]] = null;
	      } // Otherwise do nothing and use the merge result.
	
	    }, this);
	    this.textStyleModel = this.getModel('textStyle');
	
	    this._resetTarget();
	
	    this._giveAxisProxies();
	  },
	
	  /**
	   * @private
	   */
	  _giveAxisProxies: function () {
	    var axisProxies = this._axisProxies;
	    this.eachTargetAxis(function (dimNames, axisIndex, dataZoomModel, ecModel) {
	      var axisModel = this.dependentModels[dimNames.axis][axisIndex]; // If exists, share axisProxy with other dataZoomModels.
	
	      var axisProxy = axisModel.__dzAxisProxy || ( // Use the first dataZoomModel as the main model of axisProxy.
	      axisModel.__dzAxisProxy = new AxisProxy(dimNames.name, axisIndex, this, ecModel)); // FIXME
	      // dispose __dzAxisProxy
	
	      axisProxies[dimNames.name + '_' + axisIndex] = axisProxy;
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _resetTarget: function () {
	    var thisOption = this.option;
	
	    var autoMode = this._judgeAutoMode();
	
	    eachAxisDim(function (dimNames) {
	      var axisIndexName = dimNames.axisIndex;
	      thisOption[axisIndexName] = modelUtil.normalizeToArray(thisOption[axisIndexName]);
	    }, this);
	
	    if (autoMode === 'axisIndex') {
	      this._autoSetAxisIndex();
	    } else if (autoMode === 'orient') {
	      this._autoSetOrient();
	    }
	  },
	
	  /**
	   * @private
	   */
	  _judgeAutoMode: function () {
	    // Auto set only works for setOption at the first time.
	    // The following is user's reponsibility. So using merged
	    // option is OK.
	    var thisOption = this.option;
	    var hasIndexSpecified = false;
	    eachAxisDim(function (dimNames) {
	      // When user set axisIndex as a empty array, we think that user specify axisIndex
	      // but do not want use auto mode. Because empty array may be encountered when
	      // some error occured.
	      if (thisOption[dimNames.axisIndex] != null) {
	        hasIndexSpecified = true;
	      }
	    }, this);
	    var orient = thisOption.orient;
	
	    if (orient == null && hasIndexSpecified) {
	      return 'orient';
	    } else if (!hasIndexSpecified) {
	      if (orient == null) {
	        thisOption.orient = 'horizontal';
	      }
	
	      return 'axisIndex';
	    }
	  },
	
	  /**
	   * @private
	   */
	  _autoSetAxisIndex: function () {
	    var autoAxisIndex = true;
	    var orient = this.get('orient', true);
	    var thisOption = this.option;
	    var dependentModels = this.dependentModels;
	
	    if (autoAxisIndex) {
	      // Find axis that parallel to dataZoom as default.
	      var dimName = orient === 'vertical' ? 'y' : 'x';
	
	      if (dependentModels[dimName + 'Axis'].length) {
	        thisOption[dimName + 'AxisIndex'] = [0];
	        autoAxisIndex = false;
	      } else {
	        each(dependentModels.singleAxis, function (singleAxisModel) {
	          if (autoAxisIndex && singleAxisModel.get('orient', true) === orient) {
	            thisOption.singleAxisIndex = [singleAxisModel.componentIndex];
	            autoAxisIndex = false;
	          }
	        });
	      }
	    }
	
	    if (autoAxisIndex) {
	      // Find the first category axis as default. (consider polar)
	      eachAxisDim(function (dimNames) {
	        if (!autoAxisIndex) {
	          return;
	        }
	
	        var axisIndices = [];
	        var axisModels = this.dependentModels[dimNames.axis];
	
	        if (axisModels.length && !axisIndices.length) {
	          for (var i = 0, len = axisModels.length; i < len; i++) {
	            if (axisModels[i].get('type') === 'category') {
	              axisIndices.push(i);
	            }
	          }
	        }
	
	        thisOption[dimNames.axisIndex] = axisIndices;
	
	        if (axisIndices.length) {
	          autoAxisIndex = false;
	        }
	      }, this);
	    }
	
	    if (autoAxisIndex) {
	      // FIXME
	      // 这里是兼容ec2的写法（没指定xAxisIndex和yAxisIndex时把scatter和双数值轴折柱纳入dataZoom控制），
	      // 但是实际是否需要Grid.js#getScaleByOption来判断（考虑time，log等axis type）？
	      // If both dataZoom.xAxisIndex and dataZoom.yAxisIndex is not specified,
	      // dataZoom component auto adopts series that reference to
	      // both xAxis and yAxis which type is 'value'.
	      this.ecModel.eachSeries(function (seriesModel) {
	        if (this._isSeriesHasAllAxesTypeOf(seriesModel, 'value')) {
	          eachAxisDim(function (dimNames) {
	            var axisIndices = thisOption[dimNames.axisIndex];
	            var axisIndex = seriesModel.get(dimNames.axisIndex);
	            var axisId = seriesModel.get(dimNames.axisId);
	            var axisModel = seriesModel.ecModel.queryComponents({
	              mainType: dimNames.axis,
	              index: axisIndex,
	              id: axisId
	            })[0];
	            axisIndex = axisModel.componentIndex;
	
	            if (zrUtil.indexOf(axisIndices, axisIndex) < 0) {
	              axisIndices.push(axisIndex);
	            }
	          });
	        }
	      }, this);
	    }
	  },
	
	  /**
	   * @private
	   */
	  _autoSetOrient: function () {
	    var dim; // Find the first axis
	
	    this.eachTargetAxis(function (dimNames) {
	      !dim && (dim = dimNames.name);
	    }, this);
	    this.option.orient = dim === 'y' ? 'vertical' : 'horizontal';
	  },
	
	  /**
	   * @private
	   */
	  _isSeriesHasAllAxesTypeOf: function (seriesModel, axisType) {
	    // FIXME
	    // 需要series的xAxisIndex和yAxisIndex都首先自动设置上。
	    // 例如series.type === scatter时。
	    var is = true;
	    eachAxisDim(function (dimNames) {
	      var seriesAxisIndex = seriesModel.get(dimNames.axisIndex);
	      var axisModel = this.dependentModels[dimNames.axis][seriesAxisIndex];
	
	      if (!axisModel || axisModel.get('type') !== axisType) {
	        is = false;
	      }
	    }, this);
	    return is;
	  },
	
	  /**
	   * @private
	   */
	  _setDefaultThrottle: function (inputRawOption) {
	    // When first time user set throttle, auto throttle ends.
	    if (inputRawOption.hasOwnProperty('throttle')) {
	      this._autoThrottle = false;
	    }
	
	    if (this._autoThrottle) {
	      var globalOption = this.ecModel.option;
	      this.option.throttle = globalOption.animation && globalOption.animationDurationUpdate > 0 ? 100 : 20;
	    }
	  },
	
	  /**
	   * @public
	   */
	  getFirstTargetAxisModel: function () {
	    var firstAxisModel;
	    eachAxisDim(function (dimNames) {
	      if (firstAxisModel == null) {
	        var indices = this.get(dimNames.axisIndex);
	
	        if (indices.length) {
	          firstAxisModel = this.dependentModels[dimNames.axis][indices[0]];
	        }
	      }
	    }, this);
	    return firstAxisModel;
	  },
	
	  /**
	   * @public
	   * @param {Function} callback param: axisModel, dimNames, axisIndex, dataZoomModel, ecModel
	   */
	  eachTargetAxis: function (callback, context) {
	    var ecModel = this.ecModel;
	    eachAxisDim(function (dimNames) {
	      each(this.get(dimNames.axisIndex), function (axisIndex) {
	        callback.call(context, dimNames, axisIndex, this, ecModel);
	      }, this);
	    }, this);
	  },
	
	  /**
	   * @param {string} dimName
	   * @param {number} axisIndex
	   * @return {module:echarts/component/dataZoom/AxisProxy} If not found, return null/undefined.
	   */
	  getAxisProxy: function (dimName, axisIndex) {
	    return this._axisProxies[dimName + '_' + axisIndex];
	  },
	
	  /**
	   * @param {string} dimName
	   * @param {number} axisIndex
	   * @return {module:echarts/model/Model} If not found, return null/undefined.
	   */
	  getAxisModel: function (dimName, axisIndex) {
	    var axisProxy = this.getAxisProxy(dimName, axisIndex);
	    return axisProxy && axisProxy.getAxisModel();
	  },
	
	  /**
	   * If not specified, set to undefined.
	   *
	   * @public
	   * @param {Object} opt
	   * @param {number} [opt.start]
	   * @param {number} [opt.end]
	   * @param {number} [opt.startValue]
	   * @param {number} [opt.endValue]
	   */
	  setRawRange: function (opt) {
	    var thisOption = this.option;
	    var settledOption = this.settledOption;
	    each([['start', 'startValue'], ['end', 'endValue']], function (names) {
	      // Consider the pair <start, startValue>:
	      // If one has value and the other one is `null/undefined`, we both set them
	      // to `settledOption`. This strategy enables the feature to clear the original
	      // value in `settledOption` to `null/undefined`.
	      // But if both of them are `null/undefined`, we do not set them to `settledOption`
	      // and keep `settledOption` with the original value. This strategy enables users to
	      // only set <end or endValue> but not set <start or startValue> when calling
	      // `dispatchAction`.
	      // The pair <end, endValue> is treated in the same way.
	      if (opt[names[0]] != null || opt[names[1]] != null) {
	        thisOption[names[0]] = settledOption[names[0]] = opt[names[0]];
	        thisOption[names[1]] = settledOption[names[1]] = opt[names[1]];
	      }
	    }, this);
	    updateRangeUse(this, opt);
	  },
	
	  /**
	   * @public
	   * @param {Object} opt
	   * @param {number} [opt.start]
	   * @param {number} [opt.end]
	   * @param {number} [opt.startValue]
	   * @param {number} [opt.endValue]
	   */
	  setCalculatedRange: function (opt) {
	    var option = this.option;
	    each(['start', 'startValue', 'end', 'endValue'], function (name) {
	      option[name] = opt[name];
	    });
	  },
	
	  /**
	   * @public
	   * @return {Array.<number>} [startPercent, endPercent]
	   */
	  getPercentRange: function () {
	    var axisProxy = this.findRepresentativeAxisProxy();
	
	    if (axisProxy) {
	      return axisProxy.getDataPercentWindow();
	    }
	  },
	
	  /**
	   * @public
	   * For example, chart.getModel().getComponent('dataZoom').getValueRange('y', 0);
	   *
	   * @param {string} [axisDimName]
	   * @param {number} [axisIndex]
	   * @return {Array.<number>} [startValue, endValue] value can only be '-' or finite number.
	   */
	  getValueRange: function (axisDimName, axisIndex) {
	    if (axisDimName == null && axisIndex == null) {
	      var axisProxy = this.findRepresentativeAxisProxy();
	
	      if (axisProxy) {
	        return axisProxy.getDataValueWindow();
	      }
	    } else {
	      return this.getAxisProxy(axisDimName, axisIndex).getDataValueWindow();
	    }
	  },
	
	  /**
	   * @public
	   * @param {module:echarts/model/Model} [axisModel] If axisModel given, find axisProxy
	   *      corresponding to the axisModel
	   * @return {module:echarts/component/dataZoom/AxisProxy}
	   */
	  findRepresentativeAxisProxy: function (axisModel) {
	    if (axisModel) {
	      return axisModel.__dzAxisProxy;
	    } // Find the first hosted axisProxy
	
	
	    var axisProxies = this._axisProxies;
	
	    for (var key in axisProxies) {
	      if (axisProxies.hasOwnProperty(key) && axisProxies[key].hostedBy(this)) {
	        return axisProxies[key];
	      }
	    } // If no hosted axis find not hosted axisProxy.
	    // Consider this case: dataZoomModel1 and dataZoomModel2 control the same axis,
	    // and the option.start or option.end settings are different. The percentRange
	    // should follow axisProxy.
	    // (We encounter this problem in toolbox data zoom.)
	
	
	    for (var key in axisProxies) {
	      if (axisProxies.hasOwnProperty(key) && !axisProxies[key].hostedBy(this)) {
	        return axisProxies[key];
	      }
	    }
	  },
	
	  /**
	   * @return {Array.<string>}
	   */
	  getRangePropMode: function () {
	    return this._rangePropMode.slice();
	  }
	});
	/**
	 * Retrieve the those raw params from option, which will be cached separately.
	 * becasue they will be overwritten by normalized/calculated values in the main
	 * process.
	 */
	
	function retrieveRawOption(option) {
	  var ret = {};
	  each(['start', 'end', 'startValue', 'endValue', 'throttle'], function (name) {
	    option.hasOwnProperty(name) && (ret[name] = option[name]);
	  });
	  return ret;
	}
	
	function updateRangeUse(dataZoomModel, inputRawOption) {
	  var rangePropMode = dataZoomModel._rangePropMode;
	  var rangeModeInOption = dataZoomModel.get('rangeMode');
	  each([['start', 'startValue'], ['end', 'endValue']], function (names, index) {
	    var percentSpecified = inputRawOption[names[0]] != null;
	    var valueSpecified = inputRawOption[names[1]] != null;
	
	    if (percentSpecified && !valueSpecified) {
	      rangePropMode[index] = 'percent';
	    } else if (!percentSpecified && valueSpecified) {
	      rangePropMode[index] = 'value';
	    } else if (rangeModeInOption) {
	      rangePropMode[index] = rangeModeInOption[index];
	    } else if (percentSpecified) {
	      // percentSpecified && valueSpecified
	      rangePropMode[index] = 'percent';
	    } // else remain its original setting.
	
	  });
	}
	
	var _default = DataZoomModel;
	module.exports = _default;

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var ComponentView = __webpack_require__(340);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = ComponentView.extend({
	  type: 'dataZoom',
	  render: function (dataZoomModel, ecModel, api, payload) {
	    this.dataZoomModel = dataZoomModel;
	    this.ecModel = ecModel;
	    this.api = api;
	  },
	
	  /**
	   * Find the first target coordinate system.
	   *
	   * @protected
	   * @return {Object} {
	   *                   grid: [
	   *                       {model: coord0, axisModels: [axis1, axis3], coordIndex: 1},
	   *                       {model: coord1, axisModels: [axis0, axis2], coordIndex: 0},
	   *                       ...
	   *                   ],  // cartesians must not be null/undefined.
	   *                   polar: [
	   *                       {model: coord0, axisModels: [axis4], coordIndex: 0},
	   *                       ...
	   *                   ],  // polars must not be null/undefined.
	   *                   singleAxis: [
	   *                       {model: coord0, axisModels: [], coordIndex: 0}
	   *                   ]
	   */
	  getTargetCoordInfo: function () {
	    var dataZoomModel = this.dataZoomModel;
	    var ecModel = this.ecModel;
	    var coordSysLists = {};
	    dataZoomModel.eachTargetAxis(function (dimNames, axisIndex) {
	      var axisModel = ecModel.getComponent(dimNames.axis, axisIndex);
	
	      if (axisModel) {
	        var coordModel = axisModel.getCoordSysModel();
	        coordModel && save(coordModel, axisModel, coordSysLists[coordModel.mainType] || (coordSysLists[coordModel.mainType] = []), coordModel.componentIndex);
	      }
	    }, this);
	
	    function save(coordModel, axisModel, store, coordIndex) {
	      var item;
	
	      for (var i = 0; i < store.length; i++) {
	        if (store[i].model === coordModel) {
	          item = store[i];
	          break;
	        }
	      }
	
	      if (!item) {
	        store.push(item = {
	          model: coordModel,
	          axisModels: [],
	          coordIndex: coordIndex
	        });
	      }
	
	      item.axisModels.push(axisModel);
	    }
	
	    return coordSysLists;
	  }
	});
	
	module.exports = _default;

/***/ },
/* 205 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Calculate slider move result.
	 * Usage:
	 * (1) If both handle0 and handle1 are needed to be moved, set minSpan the same as
	 * maxSpan and the same as `Math.abs(handleEnd[1] - handleEnds[0])`.
	 * (2) If handle0 is forbidden to cross handle1, set minSpan as `0`.
	 *
	 * @param {number} delta Move length.
	 * @param {Array.<number>} handleEnds handleEnds[0] can be bigger then handleEnds[1].
	 *              handleEnds will be modified in this method.
	 * @param {Array.<number>} extent handleEnds is restricted by extent.
	 *              extent[0] should less or equals than extent[1].
	 * @param {number|string} handleIndex Can be 'all', means that both move the two handleEnds.
	 * @param {number} [minSpan] The range of dataZoom can not be smaller than that.
	 *              If not set, handle0 and cross handle1. If set as a non-negative
	 *              number (including `0`), handles will push each other when reaching
	 *              the minSpan.
	 * @param {number} [maxSpan] The range of dataZoom can not be larger than that.
	 * @return {Array.<number>} The input handleEnds.
	 */
	function _default(delta, handleEnds, extent, handleIndex, minSpan, maxSpan) {
	  delta = delta || 0;
	  var extentSpan = extent[1] - extent[0]; // Notice maxSpan and minSpan can be null/undefined.
	
	  if (minSpan != null) {
	    minSpan = restrict(minSpan, [0, extentSpan]);
	  }
	
	  if (maxSpan != null) {
	    maxSpan = Math.max(maxSpan, minSpan != null ? minSpan : 0);
	  }
	
	  if (handleIndex === 'all') {
	    var handleSpan = Math.abs(handleEnds[1] - handleEnds[0]);
	    handleSpan = restrict(handleSpan, [0, extentSpan]);
	    minSpan = maxSpan = restrict(handleSpan, [minSpan, maxSpan]);
	    handleIndex = 0;
	  }
	
	  handleEnds[0] = restrict(handleEnds[0], extent);
	  handleEnds[1] = restrict(handleEnds[1], extent);
	  var originalDistSign = getSpanSign(handleEnds, handleIndex);
	  handleEnds[handleIndex] += delta; // Restrict in extent.
	
	  var extentMinSpan = minSpan || 0;
	  var realExtent = extent.slice();
	  originalDistSign.sign < 0 ? realExtent[0] += extentMinSpan : realExtent[1] -= extentMinSpan;
	  handleEnds[handleIndex] = restrict(handleEnds[handleIndex], realExtent); // Expand span.
	
	  var currDistSign = getSpanSign(handleEnds, handleIndex);
	
	  if (minSpan != null && (currDistSign.sign !== originalDistSign.sign || currDistSign.span < minSpan)) {
	    // If minSpan exists, 'cross' is forbidden.
	    handleEnds[1 - handleIndex] = handleEnds[handleIndex] + originalDistSign.sign * minSpan;
	  } // Shrink span.
	
	
	  var currDistSign = getSpanSign(handleEnds, handleIndex);
	
	  if (maxSpan != null && currDistSign.span > maxSpan) {
	    handleEnds[1 - handleIndex] = handleEnds[handleIndex] + currDistSign.sign * maxSpan;
	  }
	
	  return handleEnds;
	}
	
	function getSpanSign(handleEnds, handleIndex) {
	  var dist = handleEnds[handleIndex] - handleEnds[1 - handleIndex]; // If `handleEnds[0] === handleEnds[1]`, always believe that handleEnd[0]
	  // is at left of handleEnds[1] for non-cross case.
	
	  return {
	    span: Math.abs(dist),
	    sign: dist > 0 ? -1 : dist < 0 ? 1 : handleIndex ? -1 : 1
	  };
	}
	
	function restrict(value, extend) {
	  return Math.min(extend[1] != null ? extend[1] : Infinity, Math.max(extend[0] != null ? extend[0] : -Infinity, value));
	}
	
	module.exports = _default;

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// import * as axisHelper from './axisHelper';
	var _default = {
	  /**
	   * @param {boolean} origin
	   * @return {number|string} min value or 'dataMin' or null/undefined (means auto) or NaN
	   */
	  getMin: function (origin) {
	    var option = this.option;
	    var min = !origin && option.rangeStart != null ? option.rangeStart : option.min;
	
	    if (this.axis && min != null && min !== 'dataMin' && typeof min !== 'function' && !zrUtil.eqNaN(min)) {
	      min = this.axis.scale.parse(min);
	    }
	
	    return min;
	  },
	
	  /**
	   * @param {boolean} origin
	   * @return {number|string} max value or 'dataMax' or null/undefined (means auto) or NaN
	   */
	  getMax: function (origin) {
	    var option = this.option;
	    var max = !origin && option.rangeEnd != null ? option.rangeEnd : option.max;
	
	    if (this.axis && max != null && max !== 'dataMax' && typeof max !== 'function' && !zrUtil.eqNaN(max)) {
	      max = this.axis.scale.parse(max);
	    }
	
	    return max;
	  },
	
	  /**
	   * @return {boolean}
	   */
	  getNeedCrossZero: function () {
	    var option = this.option;
	    return option.rangeStart != null || option.rangeEnd != null ? false : !option.scale;
	  },
	
	  /**
	   * Should be implemented by each axis model if necessary.
	   * @return {module:echarts/model/Component} coordinate system model
	   */
	  getCoordSysModel: zrUtil.noop,
	
	  /**
	   * @param {number} rangeStart Can only be finite number or null/undefined or NaN.
	   * @param {number} rangeEnd Can only be finite number or null/undefined or NaN.
	   */
	  setRange: function (rangeStart, rangeEnd) {
	    this.option.rangeStart = rangeStart;
	    this.option.rangeEnd = rangeEnd;
	  },
	
	  /**
	   * Reset range
	   */
	  resetRange: function () {
	    // rangeStart and rangeEnd is readonly.
	    this.option.rangeStart = this.option.rangeEnd = null;
	  }
	};
	module.exports = _default;

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var completeDimensions = __webpack_require__(746);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Substitute `completeDimensions`.
	 * `completeDimensions` is to be deprecated.
	 */
	
	/**
	 * @param {module:echarts/data/Source|module:echarts/data/List} source or data.
	 * @param {Object|Array} [opt]
	 * @param {Array.<string|Object>} [opt.coordDimensions=[]]
	 * @param {number} [opt.dimensionsCount]
	 * @param {string} [opt.generateCoord]
	 * @param {string} [opt.generateCoordCount]
	 * @param {Array.<string|Object>} [opt.dimensionsDefine=source.dimensionsDefine] Overwrite source define.
	 * @param {Object|HashMap} [opt.encodeDefine=source.encodeDefine] Overwrite source define.
	 * @param {Function} [opt.encodeDefaulter] Make default encode if user not specified.
	 * @return {Array.<Object>} dimensionsInfo
	 */
	function _default(source, opt) {
	  opt = opt || {};
	  return completeDimensions(opt.coordDimensions || [], source, {
	    dimsDef: opt.dimensionsDefine || source.dimensionsDefine,
	    encodeDef: opt.encodeDefine || source.encodeDefine,
	    dimCount: opt.dimensionsCount,
	    encodeDefaulter: opt.encodeDefaulter,
	    generateCoord: opt.generateCoord,
	    generateCoordCount: opt.generateCoordCount
	  });
	}
	
	module.exports = _default;

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// TODO Parse shadow style
	// TODO Only shallow path support
	function _default(properties) {
	  // Normalize
	  for (var i = 0; i < properties.length; i++) {
	    if (!properties[i][1]) {
	      properties[i][1] = properties[i][0];
	    }
	  }
	
	  return function (model, excludes, includes) {
	    var style = {};
	
	    for (var i = 0; i < properties.length; i++) {
	      var propName = properties[i][1];
	
	      if (excludes && zrUtil.indexOf(excludes, propName) >= 0 || includes && zrUtil.indexOf(includes, propName) < 0) {
	        continue;
	      }
	
	      var val = model.getShallow(propName);
	
	      if (val != null) {
	        style[properties[i][0]] = val;
	      }
	    }
	
	    return style;
	  };
	}
	
	module.exports = _default;

/***/ },
/* 209 */
/***/ function(module, exports) {

	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	'use strict';
	
	exports.__esModule = true;
	var PUSH = 'PUSH';
	
	exports.PUSH = PUSH;
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = 'REPLACE';
	
	exports.REPLACE = REPLACE;
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = 'POP';
	
	exports.POP = POP;
	exports['default'] = {
	  PUSH: PUSH,
	  REPLACE: REPLACE,
	  POP: POP
	};

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(72);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(772),
	    baseKeys = __webpack_require__(782),
	    isArrayLike = __webpack_require__(109);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(498);
	var setInnerHTML = __webpack_require__(365);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(506);
	var setTextContent = __webpack_require__(975);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var invariant = __webpack_require__(28);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(1968);
	var ReactInstrumentation = __webpack_require__(94);
	
	var warning = __webpack_require__(34);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern);
	
	  var regexpSource = _compilePattern2.regexpSource;
	  var paramNames = _compilePattern2.paramNames;
	  var tokens = _compilePattern2.tokens;
	
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames;
	  var paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern);
	
	  var tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0;
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenCount += 1;
	    } else if (token === ')') {
	      parenCount -= 1;
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURIComponent(paramValue);
	    } else {
	      pathname += token;
	    }
	  }
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(32);
	
	var ReactBaseClasses = __webpack_require__(984);
	var ReactChildren = __webpack_require__(2021);
	var ReactDOMFactories = __webpack_require__(2022);
	var ReactElement = __webpack_require__(217);
	var ReactPropTypes = __webpack_require__(2023);
	var ReactVersion = __webpack_require__(2024);
	
	var createReactClass = __webpack_require__(2025);
	var onlyChild = __webpack_require__(2029);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(32);
	
	var ReactCurrentOwner = __webpack_require__(128);
	
	var warning = __webpack_require__(34);
	var canDefineProperty = __webpack_require__(988);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(986);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DragDropContext = __webpack_require__(992);
	
	Object.defineProperty(exports, 'DragDropContext', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DragDropContext).default;
	  }
	});
	
	var _DragDropContextProvider = __webpack_require__(2039);
	
	Object.defineProperty(exports, 'DragDropContextProvider', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DragDropContextProvider).default;
	  }
	});
	
	var _DragLayer = __webpack_require__(2040);
	
	Object.defineProperty(exports, 'DragLayer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DragLayer).default;
	  }
	});
	
	var _DragSource = __webpack_require__(2041);
	
	Object.defineProperty(exports, 'DragSource', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DragSource).default;
	  }
	});
	
	var _DropTarget = __webpack_require__(2042);
	
	Object.defineProperty(exports, 'DropTarget', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DropTarget).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    } else if (match[0] === '\\(') {
	      regexpSource += '\\(';
	    } else if (match[0] === '\\)') {
	      regexpSource += '\\)';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern),
	      regexpSource = _compilePattern2.regexpSource,
	      paramNames = _compilePattern2.paramNames,
	      tokens = _compilePattern2.tokens;
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames,
	      paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern),
	      tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0,
	      parenHistory = [];
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenHistory[parenCount] = '';
	      parenCount += 1;
	    } else if (token === ')') {
	      var parenText = parenHistory.pop();
	      parenCount -= 1;
	
	      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
	    } else if (token === '\\(') {
	      pathname += '(';
	    } else if (token === '\\)') {
	      pathname += ')';
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue == null) {
	        if (parenCount) {
	          parenHistory[parenCount - 1] = '';
	
	          var curTokenIdx = tokens.indexOf(token);
	          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
	          var nextParenIdx = -1;
	
	          for (var _i = 0; _i < tokensSubset.length; _i++) {
	            if (tokensSubset[_i] == ')') {
	              nextParenIdx = _i;
	              break;
	            }
	          }
	
	          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;
	
	          // jump to ending paren
	          i = curTokenIdx + nextParenIdx - 1;
	        }
	      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
	    } else {
	      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
	    }
	  }
	
	  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 220 */
64,
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(132);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(149);
	
	var _Actions = __webpack_require__(370);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createQuery = exports.createQuery = function createQuery(props) {
	  return _extends(Object.create(null), props);
	};
	
	var createLocation = exports.createLocation = function createLocation() {
	  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
	  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;
	
	   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;
	
	  var pathname = object.pathname || '/';
	  var search = object.search || '';
	  var hash = object.hash || '';
	  var state = object.state;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	};
	
	var isDate = function isDate(object) {
	  return Object.prototype.toString.call(object) === '[object Date]';
	};
	
	var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
	  if (a === b) return true;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;
	
	  // Not the same object, but same type.
	  if (typeofA === 'object') {
	    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;
	
	    if (!Array.isArray(a)) {
	      var keysofA = Object.keys(a);
	      var keysofB = Object.keys(b);
	      return keysofA.length === keysofB.length && keysofA.every(function (key) {
	        return statesAreEqual(a[key], b[key]);
	      });
	    }
	
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return statesAreEqual(item, b[index]);
	    });
	  }
	
	  // All other serializable types (string, number, boolean)
	  // should be strict equal.
	  return false;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.key === b.key &&
	  // a.action === b.action && // Different action !== location change.
	  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
	};

/***/ },
/* 222 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.name = obj.name;
		this.comment = obj.comment;
		this.logo = obj.logo;
		this.url = obj.url;
	};
	
	exports.default = _class;

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _lodash = __webpack_require__(15);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.code;
		this.name = (0, _lodash.capitalize)(obj.name);
		this.code = obj.code;
		this.nameResearch = obj.nameresearch;
		this.codeResearch = obj.coderesearch;
	};
	
	exports.default = _class;

/***/ },
/* 224 */
150,
/* 225 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DtoStandardCodification = function DtoStandardCodification(obj) {
		_classCallCheck(this, DtoStandardCodification);
	
		this.type = obj.dtype;
		this.code = obj.code;
		this.definition = obj.definition;
	};
	
	exports.default = DtoStandardCodification;

/***/ },
/* 226 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
		ADD_STATIONS: 'ADD_STATIONS',
		SET_OLD_VALUE: 'SET_OLD_VALUE',
		SET_SELECTED_VALUE: 'SET_SELECTED_VALUE',
		SET_VISUALISATION: 'SET_VISUALISATION',
		SET_RADIUS: 'SET_RADIUS',
		PANEL_CITY: 'PANEL_CITY',
		PANEL_RADIUS: 'PANEL_RADIUS',
		PANEL_DRAW: 'PANEL_DRAW',
		PANEL_WATERMASS: 'PANEL_WATERMASS',
		PANEL_LAYER: 'PANEL_LAYER',
		SELECTED_TYPES: 'SELECTED_TYPES',
		SET_HOVER: 'SET_HOVER',
		RESET_RESEARCH: 'RESET_RESEARCH',
		RESET_STATIONS: 'RESET_STATIONS',
		SELECTED_STATIONS: 'SELECTED_STATIONS',
		RECEIVE_KEY_FIGURES: 'RECEIVE_KEY_FIGURES',
		RECEIVE_CITY_INDICATORS: 'RECEIVE_CITY_INDICATORS',
		RECEIVE_CITY_INFORMATIONS: 'RECEIVE_CITY_INFORMATIONS',
		RECEIVE_WATERSHED_SELECTED: 'RECEIVE_WATERSHED_SELECTED',
		PUT_STATIONS: 'PUT_STATIONS',
		WATERSHED_LAYERS: 'WATERSHED_LAYERS',
		UPDATE_WATERSHED_LAYERS: 'UPDATE_WATERSHED_LAYERS',
		MANAGEMENT_WATER_LAYERS: 'MANAGEMENT_WATER_LAYERS',
		UPDATE_MANAGEMENT_WATER_LAYERS: 'UPDATE_MANAGEMENT_WATER_LAYERS',
		CITIES_LAYERS: 'CITIES_LAYERS',
		DEPARTMENTS_LAYERS: 'DEPARTMENTS_LAYERS',
		UPDATE_CITIES_LAYERS: 'UPDATE_CITIES_LAYERS',
		RECEIVE_KEY_FIGURES_SAMPLING_POINTS: 'RECEIVE_KEY_FIGURES_SAMPLING_POINTS',
		RECEIVE_RESEARCH_TYPE: 'RECEIVE_RESEARCH_TYPE',
		MAP_RESEARCH: 'MAP_RESEARCH',
		HOME_PAGE_RESEARCH: 'HOME_PAGE_RESEARCH'
	};

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _DtoDetailSite = __webpack_require__(2201);
	
	var _DtoDetailSite2 = _interopRequireDefault(_DtoDetailSite);
	
	var _DtoWaterMass = __webpack_require__(2204);
	
	var _DtoWaterMass2 = _interopRequireDefault(_DtoWaterMass);
	
	var _DtoHydrologicalArea = __webpack_require__(2202);
	
	var _DtoHydrologicalArea2 = _interopRequireDefault(_DtoHydrologicalArea);
	
	var _StationNatureConstants = __webpack_require__(2199);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(obj) {
			_classCallCheck(this, _class);
	
			this.code = obj.code;
			this.altitude = obj.altitude;
			this.beginningDate = obj.beginningDate;
			this.endingDate = obj.endingDate;
			this.natureStation = obj.natureStation;
			if (obj.hydrologicArea) {
				this.hydrologicArea = new _DtoHydrologicalArea2.default(obj.hydrologicArea);
			}
			if (obj.waterMass) {
				this.waterMass = new _DtoWaterMass2.default(obj.waterMass);
			}
			this.site = new _DtoDetailSite2.default(obj.site);
		}
	
		_createClass(_class, [{
			key: 'isPiezometer',
			value: function isPiezometer() {
				return this.natureStation.indexOf(_StationNatureConstants.STATION_NATURE_PIEZOMETER) !== -1;
			}
		}, {
			key: 'isQualitometer',
			value: function isQualitometer() {
				return this.natureStation.indexOf(_StationNatureConstants.STATION_NATURE_QUALITOMETER) !== -1;
			}
		}, {
			key: 'isSeaport',
			value: function isSeaport() {
				return this.natureStation.indexOf(_StationNatureConstants.STATION_NATURE_SEAPORT) !== -1;
			}
		}, {
			key: 'isPluviometer',
			value: function isPluviometer() {
				return this.natureStation.indexOf(_StationNatureConstants.STATION_NATURE_PLUVIOMETER) !== -1;
			}
		}, {
			key: 'isPollutedSoil',
			value: function isPollutedSoil() {
				return this.natureStation.indexOf(_StationNatureConstants.STATION_NATURE_POLLUTED_SOIL) !== -1;
			}
		}, {
			key: 'isIndustrialSite',
			value: function isIndustrialSite() {
				return this.natureStation.indexOf(_StationNatureConstants.STATION_NATURE_INDUSTRIAL_SITE) !== -1;
			}
		}, {
			key: 'isHydrologicalStation',
			value: function isHydrologicalStation() {
				return this.natureStation.indexOf(_StationNatureConstants.STATION_NATURE_HYDROLOGICAL_STATION) !== -1;
			}
		}, {
			key: 'isTreatmentStation',
			value: function isTreatmentStation() {
				return this.natureStation.indexOf(_StationNatureConstants.STATION_NATURE_TREATMENT_STATION) !== -1;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getRgba = exports.getRgb = exports.getColorRgb = exports.getFilterTypeConstant = exports.createDtoFilterTheme = exports.createDtoFilter = exports.getFilterTypeReference = exports.createDto = undefined;
	
	var _DtoFilter = __webpack_require__(530);
	
	var _DtoFilter2 = _interopRequireDefault(_DtoFilter);
	
	var _lodash = __webpack_require__(15);
	
	var _ResearchTypes = __webpack_require__(288);
	
	var _ResearchTypes2 = _interopRequireDefault(_ResearchTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createDto = function createDto(value, tipeId, filterParameter) {
		return new _DtoFilter2.default({ value: value, filtertype_id: tipeId, filterParameter: filterParameter.type });
	};
	
	var getFilterTypeReference = function getFilterTypeReference(listOfFilterTypeReference, type) {
		return (0, _lodash.find)(listOfFilterTypeReference, function (o) {
			return o.filter == type;
		});
	};
	var createDtoFilter = function createDtoFilter(listOfFilterTypeReference, filterResearch) {
		if (filterResearch.type && filterResearch.type.type) {
			var filterReference = getFilterTypeReference(listOfFilterTypeReference, filterResearch.type.type);
			switch (filterReference.filter) {
				case _ResearchTypes2.default.CITY.type:
					return createDto(filterResearch.value.code, filterReference.id, _ResearchTypes2.default.CITY);
				case _ResearchTypes2.default.RADIUS.type:
					return createDto(filterResearch.value, filterReference.id, _ResearchTypes2.default.RADIUS);
				case _ResearchTypes2.default.STATION.type:
					return createDto(filterResearch.value.id, filterReference.id, _ResearchTypes2.default.STATION);
				case _ResearchTypes2.default.WATERSHED.type:
					return createDto(filterResearch.value.id || filterResearch.value.code, filterReference.id, _ResearchTypes2.default.WATERSHED);
				case _ResearchTypes2.default.MANAGEMENT_WATER.type:
					return createDto(filterResearch.value.id, filterReference.id, _ResearchTypes2.default.MANAGEMENT_WATER);
				case _ResearchTypes2.default.DEPARTMENT.type:
					return createDto(filterResearch.value.code, filterReference.id, _ResearchTypes2.default.DEPARTMENT);
				default:
					return null;
			}
		}
		return null;
	};
	var createDtoFilterTheme = function createDtoFilterTheme(listOfFilterTypeReference, filterResearch) {
		var filterReference = getFilterTypeReference(listOfFilterTypeReference, _ResearchTypes2.default.THEME.type);
		return createDto(filterResearch.value.id, filterReference.id, _ResearchTypes2.default.THEME);
	};
	
	var getFilterTypeConstant = function getFilterTypeConstant(parameter) {
		switch (parameter) {
			case _ResearchTypes2.default.RADIUS.type:
				return _ResearchTypes2.default.RADIUS;
			case _ResearchTypes2.default.CITY.type:
				return _ResearchTypes2.default.CITY;
			case _ResearchTypes2.default.WATERSHED.type:
				return _ResearchTypes2.default.WATERSHED;
			case _ResearchTypes2.default.STATION.type:
				return _ResearchTypes2.default.STATION;
			case _ResearchTypes2.default.MANAGEMENT_WATER.type:
				return _ResearchTypes2.default.MANAGEMENT_WATER;
			case _ResearchTypes2.default.DEPARTMENT.type:
				return _ResearchTypes2.default.DEPARTMENT;
			default:
				return null;
		}
	};
	
	var getRgb = function getRgb(rgb) {
		return 'rgb(' + rgb + ')';
	};
	var getRgba = function getRgba(rgb) {
		var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.7;
	
		return 'rgba(' + rgb + ',' + opacity + ')';
	};
	
	var getColorRgb = function getColorRgb(type) {
		var rgba = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
		var opacity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0.15';
	
		return rgba ? getRgba(type.color, opacity) : getRgb(type.color);
	};
	exports.createDto = createDto;
	exports.getFilterTypeReference = getFilterTypeReference;
	exports.createDtoFilter = createDtoFilter;
	exports.createDtoFilterTheme = createDtoFilterTheme;
	exports.getFilterTypeConstant = getFilterTypeConstant;
	exports.getColorRgb = getColorRgb;
	exports.getRgb = getRgb;
	exports.getRgba = getRgba;

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _MapException = __webpack_require__(2214);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ILayers = function () {
		function ILayers() {
			_classCallCheck(this, ILayers);
	
			this.uuid = [];
			if (!this.getLayer) {
				throw new _MapException.MapException('getLayer is not defined');
			}
		}
	
		_createClass(ILayers, [{
			key: 'generateUUID',
			value: function generateUUID() {
				var d = new Date().getTime();
				var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
					var r = (d + Math.random() * 16) % 16 | 0;
					d = Math.floor(d / 16);
					return function () {
						if (c === 'x') {
							return r;
						}
						return r & 0x3 | 0x8;
					}().toString(16);
				});
				return uuid;
			}
		}, {
			key: 'getUuid',
			value: function getUuid() {
				return this.uuid;
			}
		}, {
			key: 'getPopup',
			value: function getPopup() {
				return '';
			}
		}, {
			key: 'checkUuid',
			value: function checkUuid(u) {
				return !!this.uuid.find(function (el) {
					return u === el.uuid;
				});
			}
		}, {
			key: 'registerFeature',
			value: function registerFeature() {
				var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
				var uuid = this.generateUUID();
				this.uuid.push({ uuid: uuid, obj: obj });
				return uuid;
			}
		}]);
	
		return ILayers;
	}();
	
	exports.default = ILayers;

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.config = exports.Transition = exports.TransitionGroup = exports.SwitchTransition = exports.ReplaceTransition = exports.CSSTransition = void 0;
	
	var _CSSTransition = _interopRequireDefault(__webpack_require__(2246));
	
	exports.CSSTransition = _CSSTransition.default;
	
	var _ReplaceTransition = _interopRequireDefault(__webpack_require__(2247));
	
	exports.ReplaceTransition = _ReplaceTransition.default;
	
	var _SwitchTransition = _interopRequireDefault(__webpack_require__(2248));
	
	exports.SwitchTransition = _SwitchTransition.default;
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(1062));
	
	exports.TransitionGroup = _TransitionGroup.default;
	
	var _Transition = _interopRequireDefault(__webpack_require__(550));
	
	exports.Transition = _Transition.default;
	
	var _config = _interopRequireDefault(__webpack_require__(1063));
	
	exports.config = _config.default;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	var curve = __webpack_require__(152);
	
	var vec2 = __webpack_require__(41);
	
	var bbox = __webpack_require__(292);
	
	var BoundingRect = __webpack_require__(42);
	
	var _config = __webpack_require__(385);
	
	var dpr = _config.devicePixelRatio;
	
	/**
	 * Path 代理，可以在`buildPath`中用于替代`ctx`, 会保存每个path操作的命令到pathCommands属性中
	 * 可以用于 isInsidePath 判断以及获取boundingRect
	 *
	 * @module zrender/core/PathProxy
	 * @author Yi Shen (http://www.github.com/pissang)
	 */
	// TODO getTotalLength, getPointAtLength
	
	/* global Float32Array */
	var CMD = {
	  M: 1,
	  L: 2,
	  C: 3,
	  Q: 4,
	  A: 5,
	  Z: 6,
	  // Rect
	  R: 7
	}; // var CMD_MEM_SIZE = {
	//     M: 3,
	//     L: 3,
	//     C: 7,
	//     Q: 5,
	//     A: 9,
	//     R: 5,
	//     Z: 1
	// };
	
	var min = [];
	var max = [];
	var min2 = [];
	var max2 = [];
	var mathMin = Math.min;
	var mathMax = Math.max;
	var mathCos = Math.cos;
	var mathSin = Math.sin;
	var mathSqrt = Math.sqrt;
	var mathAbs = Math.abs;
	var hasTypedArray = typeof Float32Array !== 'undefined';
	/**
	 * @alias module:zrender/core/PathProxy
	 * @constructor
	 */
	
	var PathProxy = function (notSaveData) {
	  this._saveData = !(notSaveData || false);
	
	  if (this._saveData) {
	    /**
	     * Path data. Stored as flat array
	     * @type {Array.<Object>}
	     */
	    this.data = [];
	  }
	
	  this._ctx = null;
	};
	/**
	 * 快速计算Path包围盒（并不是最小包围盒）
	 * @return {Object}
	 */
	
	
	PathProxy.prototype = {
	  constructor: PathProxy,
	  _xi: 0,
	  _yi: 0,
	  _x0: 0,
	  _y0: 0,
	  // Unit x, Unit y. Provide for avoiding drawing that too short line segment
	  _ux: 0,
	  _uy: 0,
	  _len: 0,
	  _lineDash: null,
	  _dashOffset: 0,
	  _dashIdx: 0,
	  _dashSum: 0,
	
	  /**
	   * @readOnly
	   */
	  setScale: function (sx, sy, segmentIgnoreThreshold) {
	    // Compat. Previously there is no segmentIgnoreThreshold.
	    segmentIgnoreThreshold = segmentIgnoreThreshold || 0;
	    this._ux = mathAbs(segmentIgnoreThreshold / dpr / sx) || 0;
	    this._uy = mathAbs(segmentIgnoreThreshold / dpr / sy) || 0;
	  },
	  getContext: function () {
	    return this._ctx;
	  },
	
	  /**
	   * @param  {CanvasRenderingContext2D} ctx
	   * @return {module:zrender/core/PathProxy}
	   */
	  beginPath: function (ctx) {
	    this._ctx = ctx;
	    ctx && ctx.beginPath();
	    ctx && (this.dpr = ctx.dpr); // Reset
	
	    if (this._saveData) {
	      this._len = 0;
	    }
	
	    if (this._lineDash) {
	      this._lineDash = null;
	      this._dashOffset = 0;
	    }
	
	    return this;
	  },
	
	  /**
	   * @param  {number} x
	   * @param  {number} y
	   * @return {module:zrender/core/PathProxy}
	   */
	  moveTo: function (x, y) {
	    this.addData(CMD.M, x, y);
	    this._ctx && this._ctx.moveTo(x, y); // x0, y0, xi, yi 是记录在 _dashedXXXXTo 方法中使用
	    // xi, yi 记录当前点, x0, y0 在 closePath 的时候回到起始点。
	    // 有可能在 beginPath 之后直接调用 lineTo，这时候 x0, y0 需要
	    // 在 lineTo 方法中记录，这里先不考虑这种情况，dashed line 也只在 IE10- 中不支持
	
	    this._x0 = x;
	    this._y0 = y;
	    this._xi = x;
	    this._yi = y;
	    return this;
	  },
	
	  /**
	   * @param  {number} x
	   * @param  {number} y
	   * @return {module:zrender/core/PathProxy}
	   */
	  lineTo: function (x, y) {
	    var exceedUnit = mathAbs(x - this._xi) > this._ux || mathAbs(y - this._yi) > this._uy // Force draw the first segment
	    || this._len < 5;
	    this.addData(CMD.L, x, y);
	
	    if (this._ctx && exceedUnit) {
	      this._needsDash() ? this._dashedLineTo(x, y) : this._ctx.lineTo(x, y);
	    }
	
	    if (exceedUnit) {
	      this._xi = x;
	      this._yi = y;
	    }
	
	    return this;
	  },
	
	  /**
	   * @param  {number} x1
	   * @param  {number} y1
	   * @param  {number} x2
	   * @param  {number} y2
	   * @param  {number} x3
	   * @param  {number} y3
	   * @return {module:zrender/core/PathProxy}
	   */
	  bezierCurveTo: function (x1, y1, x2, y2, x3, y3) {
	    this.addData(CMD.C, x1, y1, x2, y2, x3, y3);
	
	    if (this._ctx) {
	      this._needsDash() ? this._dashedBezierTo(x1, y1, x2, y2, x3, y3) : this._ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
	    }
	
	    this._xi = x3;
	    this._yi = y3;
	    return this;
	  },
	
	  /**
	   * @param  {number} x1
	   * @param  {number} y1
	   * @param  {number} x2
	   * @param  {number} y2
	   * @return {module:zrender/core/PathProxy}
	   */
	  quadraticCurveTo: function (x1, y1, x2, y2) {
	    this.addData(CMD.Q, x1, y1, x2, y2);
	
	    if (this._ctx) {
	      this._needsDash() ? this._dashedQuadraticTo(x1, y1, x2, y2) : this._ctx.quadraticCurveTo(x1, y1, x2, y2);
	    }
	
	    this._xi = x2;
	    this._yi = y2;
	    return this;
	  },
	
	  /**
	   * @param  {number} cx
	   * @param  {number} cy
	   * @param  {number} r
	   * @param  {number} startAngle
	   * @param  {number} endAngle
	   * @param  {boolean} anticlockwise
	   * @return {module:zrender/core/PathProxy}
	   */
	  arc: function (cx, cy, r, startAngle, endAngle, anticlockwise) {
	    this.addData(CMD.A, cx, cy, r, r, startAngle, endAngle - startAngle, 0, anticlockwise ? 0 : 1);
	    this._ctx && this._ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
	    this._xi = mathCos(endAngle) * r + cx;
	    this._yi = mathSin(endAngle) * r + cy;
	    return this;
	  },
	  // TODO
	  arcTo: function (x1, y1, x2, y2, radius) {
	    if (this._ctx) {
	      this._ctx.arcTo(x1, y1, x2, y2, radius);
	    }
	
	    return this;
	  },
	  // TODO
	  rect: function (x, y, w, h) {
	    this._ctx && this._ctx.rect(x, y, w, h);
	    this.addData(CMD.R, x, y, w, h);
	    return this;
	  },
	
	  /**
	   * @return {module:zrender/core/PathProxy}
	   */
	  closePath: function () {
	    this.addData(CMD.Z);
	    var ctx = this._ctx;
	    var x0 = this._x0;
	    var y0 = this._y0;
	
	    if (ctx) {
	      this._needsDash() && this._dashedLineTo(x0, y0);
	      ctx.closePath();
	    }
	
	    this._xi = x0;
	    this._yi = y0;
	    return this;
	  },
	
	  /**
	   * Context 从外部传入，因为有可能是 rebuildPath 完之后再 fill。
	   * stroke 同样
	   * @param {CanvasRenderingContext2D} ctx
	   * @return {module:zrender/core/PathProxy}
	   */
	  fill: function (ctx) {
	    ctx && ctx.fill();
	    this.toStatic();
	  },
	
	  /**
	   * @param {CanvasRenderingContext2D} ctx
	   * @return {module:zrender/core/PathProxy}
	   */
	  stroke: function (ctx) {
	    ctx && ctx.stroke();
	    this.toStatic();
	  },
	
	  /**
	   * 必须在其它绘制命令前调用
	   * Must be invoked before all other path drawing methods
	   * @return {module:zrender/core/PathProxy}
	   */
	  setLineDash: function (lineDash) {
	    if (lineDash instanceof Array) {
	      this._lineDash = lineDash;
	      this._dashIdx = 0;
	      var lineDashSum = 0;
	
	      for (var i = 0; i < lineDash.length; i++) {
	        lineDashSum += lineDash[i];
	      }
	
	      this._dashSum = lineDashSum;
	    }
	
	    return this;
	  },
	
	  /**
	   * 必须在其它绘制命令前调用
	   * Must be invoked before all other path drawing methods
	   * @return {module:zrender/core/PathProxy}
	   */
	  setLineDashOffset: function (offset) {
	    this._dashOffset = offset;
	    return this;
	  },
	
	  /**
	   *
	   * @return {boolean}
	   */
	  len: function () {
	    return this._len;
	  },
	
	  /**
	   * 直接设置 Path 数据
	   */
	  setData: function (data) {
	    var len = data.length;
	
	    if (!(this.data && this.data.length === len) && hasTypedArray) {
	      this.data = new Float32Array(len);
	    }
	
	    for (var i = 0; i < len; i++) {
	      this.data[i] = data[i];
	    }
	
	    this._len = len;
	  },
	
	  /**
	   * 添加子路径
	   * @param {module:zrender/core/PathProxy|Array.<module:zrender/core/PathProxy>} path
	   */
	  appendPath: function (path) {
	    if (!(path instanceof Array)) {
	      path = [path];
	    }
	
	    var len = path.length;
	    var appendSize = 0;
	    var offset = this._len;
	
	    for (var i = 0; i < len; i++) {
	      appendSize += path[i].len();
	    }
	
	    if (hasTypedArray && this.data instanceof Float32Array) {
	      this.data = new Float32Array(offset + appendSize);
	    }
	
	    for (var i = 0; i < len; i++) {
	      var appendPathData = path[i].data;
	
	      for (var k = 0; k < appendPathData.length; k++) {
	        this.data[offset++] = appendPathData[k];
	      }
	    }
	
	    this._len = offset;
	  },
	
	  /**
	   * 填充 Path 数据。
	   * 尽量复用而不申明新的数组。大部分图形重绘的指令数据长度都是不变的。
	   */
	  addData: function (cmd) {
	    if (!this._saveData) {
	      return;
	    }
	
	    var data = this.data;
	
	    if (this._len + arguments.length > data.length) {
	      // 因为之前的数组已经转换成静态的 Float32Array
	      // 所以不够用时需要扩展一个新的动态数组
	      this._expandData();
	
	      data = this.data;
	    }
	
	    for (var i = 0; i < arguments.length; i++) {
	      data[this._len++] = arguments[i];
	    }
	
	    this._prevCmd = cmd;
	  },
	  _expandData: function () {
	    // Only if data is Float32Array
	    if (!(this.data instanceof Array)) {
	      var newData = [];
	
	      for (var i = 0; i < this._len; i++) {
	        newData[i] = this.data[i];
	      }
	
	      this.data = newData;
	    }
	  },
	
	  /**
	   * If needs js implemented dashed line
	   * @return {boolean}
	   * @private
	   */
	  _needsDash: function () {
	    return this._lineDash;
	  },
	  _dashedLineTo: function (x1, y1) {
	    var dashSum = this._dashSum;
	    var offset = this._dashOffset;
	    var lineDash = this._lineDash;
	    var ctx = this._ctx;
	    var x0 = this._xi;
	    var y0 = this._yi;
	    var dx = x1 - x0;
	    var dy = y1 - y0;
	    var dist = mathSqrt(dx * dx + dy * dy);
	    var x = x0;
	    var y = y0;
	    var dash;
	    var nDash = lineDash.length;
	    var idx;
	    dx /= dist;
	    dy /= dist;
	
	    if (offset < 0) {
	      // Convert to positive offset
	      offset = dashSum + offset;
	    }
	
	    offset %= dashSum;
	    x -= offset * dx;
	    y -= offset * dy;
	
	    while (dx > 0 && x <= x1 || dx < 0 && x >= x1 || dx === 0 && (dy > 0 && y <= y1 || dy < 0 && y >= y1)) {
	      idx = this._dashIdx;
	      dash = lineDash[idx];
	      x += dx * dash;
	      y += dy * dash;
	      this._dashIdx = (idx + 1) % nDash; // Skip positive offset
	
	      if (dx > 0 && x < x0 || dx < 0 && x > x0 || dy > 0 && y < y0 || dy < 0 && y > y0) {
	        continue;
	      }
	
	      ctx[idx % 2 ? 'moveTo' : 'lineTo'](dx >= 0 ? mathMin(x, x1) : mathMax(x, x1), dy >= 0 ? mathMin(y, y1) : mathMax(y, y1));
	    } // Offset for next lineTo
	
	
	    dx = x - x1;
	    dy = y - y1;
	    this._dashOffset = -mathSqrt(dx * dx + dy * dy);
	  },
	  // Not accurate dashed line to
	  _dashedBezierTo: function (x1, y1, x2, y2, x3, y3) {
	    var dashSum = this._dashSum;
	    var offset = this._dashOffset;
	    var lineDash = this._lineDash;
	    var ctx = this._ctx;
	    var x0 = this._xi;
	    var y0 = this._yi;
	    var t;
	    var dx;
	    var dy;
	    var cubicAt = curve.cubicAt;
	    var bezierLen = 0;
	    var idx = this._dashIdx;
	    var nDash = lineDash.length;
	    var x;
	    var y;
	    var tmpLen = 0;
	
	    if (offset < 0) {
	      // Convert to positive offset
	      offset = dashSum + offset;
	    }
	
	    offset %= dashSum; // Bezier approx length
	
	    for (t = 0; t < 1; t += 0.1) {
	      dx = cubicAt(x0, x1, x2, x3, t + 0.1) - cubicAt(x0, x1, x2, x3, t);
	      dy = cubicAt(y0, y1, y2, y3, t + 0.1) - cubicAt(y0, y1, y2, y3, t);
	      bezierLen += mathSqrt(dx * dx + dy * dy);
	    } // Find idx after add offset
	
	
	    for (; idx < nDash; idx++) {
	      tmpLen += lineDash[idx];
	
	      if (tmpLen > offset) {
	        break;
	      }
	    }
	
	    t = (tmpLen - offset) / bezierLen;
	
	    while (t <= 1) {
	      x = cubicAt(x0, x1, x2, x3, t);
	      y = cubicAt(y0, y1, y2, y3, t); // Use line to approximate dashed bezier
	      // Bad result if dash is long
	
	      idx % 2 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
	      t += lineDash[idx] / bezierLen;
	      idx = (idx + 1) % nDash;
	    } // Finish the last segment and calculate the new offset
	
	
	    idx % 2 !== 0 && ctx.lineTo(x3, y3);
	    dx = x3 - x;
	    dy = y3 - y;
	    this._dashOffset = -mathSqrt(dx * dx + dy * dy);
	  },
	  _dashedQuadraticTo: function (x1, y1, x2, y2) {
	    // Convert quadratic to cubic using degree elevation
	    var x3 = x2;
	    var y3 = y2;
	    x2 = (x2 + 2 * x1) / 3;
	    y2 = (y2 + 2 * y1) / 3;
	    x1 = (this._xi + 2 * x1) / 3;
	    y1 = (this._yi + 2 * y1) / 3;
	
	    this._dashedBezierTo(x1, y1, x2, y2, x3, y3);
	  },
	
	  /**
	   * 转成静态的 Float32Array 减少堆内存占用
	   * Convert dynamic array to static Float32Array
	   */
	  toStatic: function () {
	    var data = this.data;
	
	    if (data instanceof Array) {
	      data.length = this._len;
	
	      if (hasTypedArray) {
	        this.data = new Float32Array(data);
	      }
	    }
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getBoundingRect: function () {
	    min[0] = min[1] = min2[0] = min2[1] = Number.MAX_VALUE;
	    max[0] = max[1] = max2[0] = max2[1] = -Number.MAX_VALUE;
	    var data = this.data;
	    var xi = 0;
	    var yi = 0;
	    var x0 = 0;
	    var y0 = 0;
	
	    for (var i = 0; i < data.length;) {
	      var cmd = data[i++];
	
	      if (i === 1) {
	        // 如果第一个命令是 L, C, Q
	        // 则 previous point 同绘制命令的第一个 point
	        //
	        // 第一个命令为 Arc 的情况下会在后面特殊处理
	        xi = data[i];
	        yi = data[i + 1];
	        x0 = xi;
	        y0 = yi;
	      }
	
	      switch (cmd) {
	        case CMD.M:
	          // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
	          // 在 closePath 的时候使用
	          x0 = data[i++];
	          y0 = data[i++];
	          xi = x0;
	          yi = y0;
	          min2[0] = x0;
	          min2[1] = y0;
	          max2[0] = x0;
	          max2[1] = y0;
	          break;
	
	        case CMD.L:
	          bbox.fromLine(xi, yi, data[i], data[i + 1], min2, max2);
	          xi = data[i++];
	          yi = data[i++];
	          break;
	
	        case CMD.C:
	          bbox.fromCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], min2, max2);
	          xi = data[i++];
	          yi = data[i++];
	          break;
	
	        case CMD.Q:
	          bbox.fromQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], min2, max2);
	          xi = data[i++];
	          yi = data[i++];
	          break;
	
	        case CMD.A:
	          // TODO Arc 判断的开销比较大
	          var cx = data[i++];
	          var cy = data[i++];
	          var rx = data[i++];
	          var ry = data[i++];
	          var startAngle = data[i++];
	          var endAngle = data[i++] + startAngle; // TODO Arc 旋转
	
	          i += 1;
	          var anticlockwise = 1 - data[i++];
	
	          if (i === 1) {
	            // 直接使用 arc 命令
	            // 第一个命令起点还未定义
	            x0 = mathCos(startAngle) * rx + cx;
	            y0 = mathSin(startAngle) * ry + cy;
	          }
	
	          bbox.fromArc(cx, cy, rx, ry, startAngle, endAngle, anticlockwise, min2, max2);
	          xi = mathCos(endAngle) * rx + cx;
	          yi = mathSin(endAngle) * ry + cy;
	          break;
	
	        case CMD.R:
	          x0 = xi = data[i++];
	          y0 = yi = data[i++];
	          var width = data[i++];
	          var height = data[i++]; // Use fromLine
	
	          bbox.fromLine(x0, y0, x0 + width, y0 + height, min2, max2);
	          break;
	
	        case CMD.Z:
	          xi = x0;
	          yi = y0;
	          break;
	      } // Union
	
	
	      vec2.min(min, min, min2);
	      vec2.max(max, max, max2);
	    } // No data
	
	
	    if (i === 0) {
	      min[0] = min[1] = max[0] = max[1] = 0;
	    }
	
	    return new BoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
	  },
	
	  /**
	   * Rebuild path from current data
	   * Rebuild path will not consider javascript implemented line dash.
	   * @param {CanvasRenderingContext2D} ctx
	   */
	  rebuildPath: function (ctx) {
	    var d = this.data;
	    var x0;
	    var y0;
	    var xi;
	    var yi;
	    var x;
	    var y;
	    var ux = this._ux;
	    var uy = this._uy;
	    var len = this._len;
	
	    for (var i = 0; i < len;) {
	      var cmd = d[i++];
	
	      if (i === 1) {
	        // 如果第一个命令是 L, C, Q
	        // 则 previous point 同绘制命令的第一个 point
	        //
	        // 第一个命令为 Arc 的情况下会在后面特殊处理
	        xi = d[i];
	        yi = d[i + 1];
	        x0 = xi;
	        y0 = yi;
	      }
	
	      switch (cmd) {
	        case CMD.M:
	          x0 = xi = d[i++];
	          y0 = yi = d[i++];
	          ctx.moveTo(xi, yi);
	          break;
	
	        case CMD.L:
	          x = d[i++];
	          y = d[i++]; // Not draw too small seg between
	
	          if (mathAbs(x - xi) > ux || mathAbs(y - yi) > uy || i === len - 1) {
	            ctx.lineTo(x, y);
	            xi = x;
	            yi = y;
	          }
	
	          break;
	
	        case CMD.C:
	          ctx.bezierCurveTo(d[i++], d[i++], d[i++], d[i++], d[i++], d[i++]);
	          xi = d[i - 2];
	          yi = d[i - 1];
	          break;
	
	        case CMD.Q:
	          ctx.quadraticCurveTo(d[i++], d[i++], d[i++], d[i++]);
	          xi = d[i - 2];
	          yi = d[i - 1];
	          break;
	
	        case CMD.A:
	          var cx = d[i++];
	          var cy = d[i++];
	          var rx = d[i++];
	          var ry = d[i++];
	          var theta = d[i++];
	          var dTheta = d[i++];
	          var psi = d[i++];
	          var fs = d[i++];
	          var r = rx > ry ? rx : ry;
	          var scaleX = rx > ry ? 1 : rx / ry;
	          var scaleY = rx > ry ? ry / rx : 1;
	          var isEllipse = Math.abs(rx - ry) > 1e-3;
	          var endAngle = theta + dTheta;
	
	          if (isEllipse) {
	            ctx.translate(cx, cy);
	            ctx.rotate(psi);
	            ctx.scale(scaleX, scaleY);
	            ctx.arc(0, 0, r, theta, endAngle, 1 - fs);
	            ctx.scale(1 / scaleX, 1 / scaleY);
	            ctx.rotate(-psi);
	            ctx.translate(-cx, -cy);
	          } else {
	            ctx.arc(cx, cy, r, theta, endAngle, 1 - fs);
	          }
	
	          if (i === 1) {
	            // 直接使用 arc 命令
	            // 第一个命令起点还未定义
	            x0 = mathCos(theta) * rx + cx;
	            y0 = mathSin(theta) * ry + cy;
	          }
	
	          xi = mathCos(endAngle) * rx + cx;
	          yi = mathSin(endAngle) * ry + cy;
	          break;
	
	        case CMD.R:
	          x0 = xi = d[i];
	          y0 = yi = d[i + 1];
	          ctx.rect(d[i++], d[i++], d[i++], d[i++]);
	          break;
	
	        case CMD.Z:
	          ctx.closePath();
	          xi = x0;
	          yi = y0;
	      }
	    }
	  }
	};
	PathProxy.CMD = CMD;
	var _default = PathProxy;
	module.exports = _default;

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	var Displayable = __webpack_require__(294);
	
	var BoundingRect = __webpack_require__(42);
	
	var zrUtil = __webpack_require__(3);
	
	var imageHelper = __webpack_require__(559);
	
	/**
	 * @alias zrender/graphic/Image
	 * @extends module:zrender/graphic/Displayable
	 * @constructor
	 * @param {Object} opts
	 */
	function ZImage(opts) {
	  Displayable.call(this, opts);
	}
	
	ZImage.prototype = {
	  constructor: ZImage,
	  type: 'image',
	  brush: function (ctx, prevEl) {
	    var style = this.style;
	    var src = style.image; // Must bind each time
	
	    style.bind(ctx, this, prevEl);
	    var image = this._image = imageHelper.createOrUpdateImage(src, this._image, this, this.onload);
	
	    if (!image || !imageHelper.isImageReady(image)) {
	      return;
	    } // 图片已经加载完成
	    // if (image.nodeName.toUpperCase() == 'IMG') {
	    //     if (!image.complete) {
	    //         return;
	    //     }
	    // }
	    // Else is canvas
	
	
	    var x = style.x || 0;
	    var y = style.y || 0;
	    var width = style.width;
	    var height = style.height;
	    var aspect = image.width / image.height;
	
	    if (width == null && height != null) {
	      // Keep image/height ratio
	      width = height * aspect;
	    } else if (height == null && width != null) {
	      height = width / aspect;
	    } else if (width == null && height == null) {
	      width = image.width;
	      height = image.height;
	    } // 设置transform
	
	
	    this.setTransform(ctx);
	
	    if (style.sWidth && style.sHeight) {
	      var sx = style.sx || 0;
	      var sy = style.sy || 0;
	      ctx.drawImage(image, sx, sy, style.sWidth, style.sHeight, x, y, width, height);
	    } else if (style.sx && style.sy) {
	      var sx = style.sx;
	      var sy = style.sy;
	      var sWidth = width - sx;
	      var sHeight = height - sy;
	      ctx.drawImage(image, sx, sy, sWidth, sHeight, x, y, width, height);
	    } else {
	      ctx.drawImage(image, x, y, width, height);
	    } // Draw rect text
	
	
	    if (style.text != null) {
	      // Only restore transform when needs draw text.
	      this.restoreTransform(ctx);
	      this.drawRectText(ctx, this.getBoundingRect());
	    }
	  },
	  getBoundingRect: function () {
	    var style = this.style;
	
	    if (!this._rect) {
	      this._rect = new BoundingRect(style.x || 0, style.y || 0, style.width || 0, style.height || 0);
	    }
	
	    return this._rect;
	  }
	};
	zrUtil.inherits(ZImage, Displayable);
	var _default = ZImage;
	module.exports = _default;

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Button.default;
	  }
	});
	
	var _Button = _interopRequireDefault(__webpack_require__(1131));

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Chip.default;
	  }
	});
	
	var _Chip = _interopRequireDefault(__webpack_require__(1148));

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _DialogTitle.default;
	  }
	});
	
	var _DialogTitle = _interopRequireDefault(__webpack_require__(1162));

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _IconButton.default;
	  }
	});
	
	var _IconButton = _interopRequireDefault(__webpack_require__(1192));

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _InputBase.default;
	  }
	});
	
	var _InputBase = _interopRequireDefault(__webpack_require__(1196));

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	/**
	 * @ignore - internal component.
	 */
	var ListContext = /*#__PURE__*/React.createContext({});
	
	if (false) {
	  ListContext.displayName = 'ListContext';
	}
	
	var _default = ListContext;
	exports.default = _default;

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	/**
	 * @ignore - internal component.
	 */
	var Tablelvl2Context = /*#__PURE__*/React.createContext();
	
	if (false) {
	  Tablelvl2Context.displayName = 'Tablelvl2Context';
	}
	
	var _default = Tablelvl2Context;
	exports.default = _default;

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Tooltip.default;
	  }
	});
	
	var _Tooltip = _interopRequireDefault(__webpack_require__(1282));

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _createMuiTheme = _interopRequireDefault(__webpack_require__(408));
	
	var defaultTheme = (0, _createMuiTheme.default)();
	var _default = defaultTheme;
	exports.default = _default;

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMuiElement;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	function isMuiElement(element, muiNames) {
	  return /*#__PURE__*/React.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
	}

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.teardown = teardown;
	exports.default = useIsFocusVisible;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(51));
	
	// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js
	var hadKeyboardEvent = true;
	var hadFocusVisibleRecently = false;
	var hadFocusVisibleRecentlyTimeout = null;
	var inputTypesWhitelist = {
	  text: true,
	  search: true,
	  url: true,
	  tel: true,
	  email: true,
	  password: true,
	  number: true,
	  date: true,
	  month: true,
	  week: true,
	  time: true,
	  datetime: true,
	  'datetime-local': true
	};
	/**
	 * Computes whether the given element should automatically trigger the
	 * `focus-visible` class being added, i.e. whether it should always match
	 * `:focus-visible` when focused.
	 * @param {Element} node
	 * @return {boolean}
	 */
	
	function focusTriggersKeyboardModality(node) {
	  var type = node.type,
	      tagName = node.tagName;
	
	  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
	    return true;
	  }
	
	  if (tagName === 'TEXTAREA' && !node.readOnly) {
	    return true;
	  }
	
	  if (node.isContentEditable) {
	    return true;
	  }
	
	  return false;
	}
	/**
	 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
	 * If the most recent user interaction was via the keyboard;
	 * and the key press did not include a meta, alt/option, or control key;
	 * then the modality is keyboard. Otherwise, the modality is not keyboard.
	 * @param {KeyboardEvent} event
	 */
	
	
	function handleKeyDown(event) {
	  if (event.metaKey || event.altKey || event.ctrlKey) {
	    return;
	  }
	
	  hadKeyboardEvent = true;
	}
	/**
	 * If at any point a user clicks with a pointing device, ensure that we change
	 * the modality away from keyboard.
	 * This avoids the situation where a user presses a key on an already focused
	 * element, and then clicks on a different element, focusing it with a
	 * pointing device, while we still think we're in keyboard modality.
	 */
	
	
	function handlePointerDown() {
	  hadKeyboardEvent = false;
	}
	
	function handleVisibilityChange() {
	  if (this.visibilityState === 'hidden') {
	    // If the tab becomes active again, the browser will handle calling focus
	    // on the element (Safari actually calls it twice).
	    // If this tab change caused a blur on an element with focus-visible,
	    // re-apply the class when the user switches back to the tab.
	    if (hadFocusVisibleRecently) {
	      hadKeyboardEvent = true;
	    }
	  }
	}
	
	function prepare(doc) {
	  doc.addEventListener('keydown', handleKeyDown, true);
	  doc.addEventListener('mousedown', handlePointerDown, true);
	  doc.addEventListener('pointerdown', handlePointerDown, true);
	  doc.addEventListener('touchstart', handlePointerDown, true);
	  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
	}
	
	function teardown(doc) {
	  doc.removeEventListener('keydown', handleKeyDown, true);
	  doc.removeEventListener('mousedown', handlePointerDown, true);
	  doc.removeEventListener('pointerdown', handlePointerDown, true);
	  doc.removeEventListener('touchstart', handlePointerDown, true);
	  doc.removeEventListener('visibilitychange', handleVisibilityChange, true);
	}
	
	function isFocusVisible(event) {
	  var target = event.target;
	
	  try {
	    return target.matches(':focus-visible');
	  } catch (error) {// browsers not implementing :focus-visible will throw a SyntaxError
	    // we use our own heuristic for those browsers
	    // rethrow might be better if it's not the expected error but do we really
	    // want to crash if focus-visible malfunctioned?
	  } // no need for validFocusTarget check. the user does that by attaching it to
	  // focusable events only
	
	
	  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
	}
	/**
	 * Should be called if a blur event is fired on a focus-visible element
	 */
	
	
	function handleBlurVisible() {
	  // To detect a tab/window switch, we look for a blur event followed
	  // rapidly by a visibility change.
	  // If we don't see a visibility change within 100ms, it's probably a
	  // regular focus change.
	  hadFocusVisibleRecently = true;
	  window.clearTimeout(hadFocusVisibleRecentlyTimeout);
	  hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
	    hadFocusVisibleRecently = false;
	  }, 100);
	}
	
	function useIsFocusVisible() {
	  var ref = React.useCallback(function (instance) {
	    var node = ReactDOM.findDOMNode(instance);
	
	    if (node != null) {
	      prepare(node.ownerDocument);
	    }
	  }, []);
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    React.useDebugValue(isFocusVisible);
	  }
	
	  return {
	    isFocusVisible: isFocusVisible,
	    onBlurVisible: handleBlurVisible,
	    ref: ref
	  };
	}

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createSvgIcon;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(308));
	
	function createSvgIcon(path, displayName) {
	  var Component = _react.default.memo(_react.default.forwardRef(function (props, ref) {
	    return _react.default.createElement(_SvgIcon.default, (0, _extends2.default)({
	      ref: ref
	    }, props), path);
	  }));
	
	  if (false) {
	    Component.displayName = "".concat(displayName, "Icon");
	  }
	
	  Component.muiName = _SvgIcon.default.muiName;
	  return Component;
	}

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _useTheme.default;
	  }
	});
	
	var _useTheme = _interopRequireDefault(__webpack_require__(1354));

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var logger_1 = __webpack_require__(68);
	var columnUtils_1 = __webpack_require__(195);
	var columnKeyCreator_1 = __webpack_require__(640);
	var originalColumnGroup_1 = __webpack_require__(196);
	var column_1 = __webpack_require__(45);
	var context_1 = __webpack_require__(8);
	var defaultColumnTypes_1 = __webpack_require__(1383);
	var utils_1 = __webpack_require__(10);
	// takes ColDefs and ColGroupDefs and turns them into Columns and OriginalGroups
	var ColumnFactory = /** @class */ (function () {
	    function ColumnFactory() {
	    }
	    ColumnFactory.prototype.setBeans = function (loggerFactory) {
	        this.logger = loggerFactory.create('ColumnFactory');
	    };
	    ColumnFactory.prototype.createColumnTree = function (defs, primaryColumns, existingColumns) {
	        // column key creator dishes out unique column id's in a deterministic way,
	        // so if we have two grids (that could be master/slave) with same column definitions,
	        // then this ensures the two grids use identical id's.
	        var columnKeyCreator = new columnKeyCreator_1.ColumnKeyCreator();
	        if (existingColumns) {
	            var existingKeys = existingColumns.map(function (col) { return col.getId(); });
	            columnKeyCreator.addExistingKeys(existingKeys);
	        }
	        // we take a copy of the columns as we are going to be removing from them
	        var existingColsCopy = existingColumns ? existingColumns.slice() : null;
	        // create am unbalanced tree that maps the provided definitions
	        var unbalancedTree = this.recursivelyCreateColumns(defs, 0, primaryColumns, existingColsCopy, columnKeyCreator, null);
	        var treeDept = this.findMaxDept(unbalancedTree, 0);
	        this.logger.log('Number of levels for grouped columns is ' + treeDept);
	        var res = this.balanceColumnTree(unbalancedTree, 0, treeDept, columnKeyCreator);
	        var deptFirstCallback = function (child, parent) {
	            if (child instanceof originalColumnGroup_1.OriginalColumnGroup) {
	                child.setupExpandable();
	            }
	            // we set the original parents at the end, rather than when we go along, as balancing the tree
	            // adds extra levels into the tree. so we can only set parents when balancing is done.
	            child.setOriginalParent(parent);
	        };
	        this.columnUtils.depthFirstOriginalTreeSearch(null, res, deptFirstCallback);
	        return {
	            columnTree: res,
	            treeDept: treeDept
	        };
	    };
	    ColumnFactory.prototype.createForAutoGroups = function (autoGroupCols, gridBalancedTree) {
	        var _this = this;
	        var autoColBalancedTree = [];
	        autoGroupCols.forEach(function (col) {
	            var fakeTreeItem = _this.createAutoGroupTreeItem(gridBalancedTree, col);
	            autoColBalancedTree.push(fakeTreeItem);
	        });
	        return autoColBalancedTree;
	    };
	    ColumnFactory.prototype.createAutoGroupTreeItem = function (balancedColumnTree, column) {
	        var dept = this.findDepth(balancedColumnTree);
	        // at the end, this will be the top of the tree item.
	        var nextChild = column;
	        for (var i = dept - 1; i >= 0; i--) {
	            var autoGroup = new originalColumnGroup_1.OriginalColumnGroup(null, "FAKE_PATH_" + column.getId() + "}_" + i, true, i);
	            this.context.wireBean(autoGroup);
	            autoGroup.setChildren([nextChild]);
	            nextChild.setOriginalParent(autoGroup);
	            nextChild = autoGroup;
	        }
	        // at this point, the nextChild is the top most item in the tree
	        return nextChild;
	    };
	    ColumnFactory.prototype.findDepth = function (balancedColumnTree) {
	        var dept = 0;
	        var pointer = balancedColumnTree;
	        while (pointer && pointer[0] && pointer[0] instanceof originalColumnGroup_1.OriginalColumnGroup) {
	            dept++;
	            pointer = pointer[0].getChildren();
	        }
	        return dept;
	    };
	    ColumnFactory.prototype.balanceColumnTree = function (unbalancedTree, currentDept, columnDept, columnKeyCreator) {
	        var result = [];
	        // go through each child, for groups, recurse a level deeper,
	        // for columns we need to pad
	        for (var i = 0; i < unbalancedTree.length; i++) {
	            var child = unbalancedTree[i];
	            if (child instanceof originalColumnGroup_1.OriginalColumnGroup) {
	                // child is a group, all we do is go to the next level of recursion
	                var originalGroup = child;
	                var newChildren = this.balanceColumnTree(originalGroup.getChildren(), currentDept + 1, columnDept, columnKeyCreator);
	                originalGroup.setChildren(newChildren);
	                result.push(originalGroup);
	            }
	            else {
	                // child is a column - so here we add in the padded column groups if needed
	                var firstPaddedGroup = void 0;
	                var currentPaddedGroup = void 0;
	                // this for loop will NOT run any loops if no padded column groups are needed
	                for (var j = columnDept - 1; j >= currentDept; j--) {
	                    var newColId = columnKeyCreator.getUniqueKey(null, null);
	                    var colGroupDefMerged = this.createMergedColGroupDef(null);
	                    var paddedGroup = new originalColumnGroup_1.OriginalColumnGroup(colGroupDefMerged, newColId, true, currentDept);
	                    this.context.wireBean(paddedGroup);
	                    if (currentPaddedGroup) {
	                        currentPaddedGroup.setChildren([paddedGroup]);
	                    }
	                    currentPaddedGroup = paddedGroup;
	                    if (!firstPaddedGroup) {
	                        firstPaddedGroup = currentPaddedGroup;
	                    }
	                }
	                // likewise this if statement will not run if no padded groups
	                if (firstPaddedGroup) {
	                    result.push(firstPaddedGroup);
	                    var hasGroups = unbalancedTree.some(function (child) { return child instanceof originalColumnGroup_1.OriginalColumnGroup; });
	                    if (hasGroups) {
	                        currentPaddedGroup.setChildren([child]);
	                        continue;
	                    }
	                    else {
	                        currentPaddedGroup.setChildren(unbalancedTree);
	                        break;
	                    }
	                }
	                result.push(child);
	            }
	        }
	        return result;
	    };
	    ColumnFactory.prototype.findMaxDept = function (treeChildren, dept) {
	        var maxDeptThisLevel = dept;
	        for (var i = 0; i < treeChildren.length; i++) {
	            var abstractColumn = treeChildren[i];
	            if (abstractColumn instanceof originalColumnGroup_1.OriginalColumnGroup) {
	                var originalGroup = abstractColumn;
	                var newDept = this.findMaxDept(originalGroup.getChildren(), dept + 1);
	                if (maxDeptThisLevel < newDept) {
	                    maxDeptThisLevel = newDept;
	                }
	            }
	        }
	        return maxDeptThisLevel;
	    };
	    ColumnFactory.prototype.recursivelyCreateColumns = function (defs, level, primaryColumns, existingColsCopy, columnKeyCreator, parent) {
	        var _this = this;
	        var result = [];
	        if (!defs) {
	            return result;
	        }
	        defs.forEach(function (def) {
	            var newGroupOrColumn;
	            if (_this.isColumnGroup(def)) {
	                newGroupOrColumn = _this.createColumnGroup(primaryColumns, def, level, existingColsCopy, columnKeyCreator, parent);
	            }
	            else {
	                newGroupOrColumn = _this.createColumn(primaryColumns, def, existingColsCopy, columnKeyCreator, parent);
	            }
	            result.push(newGroupOrColumn);
	        });
	        return result;
	    };
	    ColumnFactory.prototype.createColumnGroup = function (primaryColumns, colGroupDef, level, existingColumns, columnKeyCreator, parent) {
	        var colGroupDefMerged = this.createMergedColGroupDef(colGroupDef);
	        var groupId = columnKeyCreator.getUniqueKey(colGroupDefMerged.groupId, null);
	        var originalGroup = new originalColumnGroup_1.OriginalColumnGroup(colGroupDefMerged, groupId, false, level);
	        this.context.wireBean(originalGroup);
	        var children = this.recursivelyCreateColumns(colGroupDefMerged.children, level + 1, primaryColumns, existingColumns, columnKeyCreator, originalGroup);
	        originalGroup.setChildren(children);
	        return originalGroup;
	    };
	    ColumnFactory.prototype.createMergedColGroupDef = function (colGroupDef) {
	        var colGroupDefMerged = {};
	        utils_1._.assign(colGroupDefMerged, this.gridOptionsWrapper.getDefaultColGroupDef());
	        utils_1._.assign(colGroupDefMerged, colGroupDef);
	        this.checkForDeprecatedItems(colGroupDefMerged);
	        return colGroupDefMerged;
	    };
	    ColumnFactory.prototype.createColumn = function (primaryColumns, colDef, existingColsCopy, columnKeyCreator, parent) {
	        var colDefMerged = this.mergeColDefs(colDef);
	        this.checkForDeprecatedItems(colDefMerged);
	        // see if column already exists
	        var column = this.findExistingColumn(colDef, existingColsCopy);
	        if (!column) {
	            // no existing column, need to create one
	            var colId = columnKeyCreator.getUniqueKey(colDefMerged.colId, colDefMerged.field);
	            column = new column_1.Column(colDefMerged, colDef, colId, primaryColumns);
	            this.context.wireBean(column);
	        }
	        else {
	            column.setColDef(colDefMerged, colDef);
	        }
	        return column;
	    };
	    ColumnFactory.prototype.findExistingColumn = function (colDef, existingColsCopy) {
	        var res = utils_1._.find(existingColsCopy, function (col) {
	            var oldColDef = col.getUserProvidedColDef();
	            if (!oldColDef) {
	                return false;
	            }
	            // first check object references
	            if (oldColDef === colDef) {
	                return true;
	            }
	            // second check id's
	            var oldColHadId = oldColDef.colId !== null && oldColDef.colId !== undefined;
	            if (oldColHadId) {
	                return oldColDef.colId === colDef.colId;
	            }
	            else {
	                return false;
	            }
	        });
	        // make sure we remove, so if user provided duplicate id, then we don't have more than
	        // one column instance for colDef with common id
	        if (res) {
	            utils_1._.removeFromArray(existingColsCopy, res);
	        }
	        return res;
	    };
	    ColumnFactory.prototype.mergeColDefs = function (colDef) {
	        // start with empty merged definition
	        var colDefMerged = {};
	        // merge properties from default column definitions
	        utils_1._.assign(colDefMerged, this.gridOptionsWrapper.getDefaultColDef());
	        // merge properties from column type properties
	        if (colDef.type) {
	            this.assignColumnTypes(colDef, colDefMerged);
	        }
	        // merge properties from column definitions
	        utils_1._.assign(colDefMerged, colDef);
	        return colDefMerged;
	    };
	    ColumnFactory.prototype.assignColumnTypes = function (colDef, colDefMerged) {
	        var typeKeys;
	        if (colDef.type instanceof Array) {
	            var invalidArray = colDef.type.some(function (a) { return typeof a !== 'string'; });
	            if (invalidArray) {
	                console.warn("ag-grid: if colDef.type is supplied an array it should be of type 'string[]'");
	            }
	            else {
	                typeKeys = colDef.type;
	            }
	        }
	        else if (typeof colDef.type === 'string') {
	            typeKeys = colDef.type.split(',');
	        }
	        else {
	            console.warn("ag-grid: colDef.type should be of type 'string' | 'string[]'");
	            return;
	        }
	        // merge user defined with default column types
	        var allColumnTypes = utils_1._.assign({}, this.gridOptionsWrapper.getColumnTypes(), defaultColumnTypes_1.DefaultColumnTypes);
	        typeKeys.forEach(function (t) {
	            var typeColDef = allColumnTypes[t.trim()];
	            if (typeColDef) {
	                utils_1._.assign(colDefMerged, typeColDef);
	            }
	            else {
	                console.warn("ag-grid: colDef.type '" + t + "' does not correspond to defined gridOptions.columnTypes");
	            }
	        });
	    };
	    ColumnFactory.prototype.checkForDeprecatedItems = function (colDef) {
	        if (colDef) {
	            var colDefNoType = colDef; // take out the type, so we can access attributes not defined in the type
	            if (colDefNoType.group !== undefined) {
	                console.warn('ag-grid: colDef.group is invalid, please check documentation on how to do grouping as it changed in version 3');
	            }
	            if (colDefNoType.headerGroup !== undefined) {
	                console.warn('ag-grid: colDef.headerGroup is invalid, please check documentation on how to do grouping as it changed in version 3');
	            }
	            if (colDefNoType.headerGroupShow !== undefined) {
	                console.warn('ag-grid: colDef.headerGroupShow is invalid, should be columnGroupShow, please check documentation on how to do grouping as it changed in version 3');
	            }
	            if (colDefNoType.suppressRowGroup !== undefined) {
	                console.warn('ag-grid: colDef.suppressRowGroup is deprecated, please use colDef.type instead');
	            }
	            if (colDefNoType.suppressAggregation !== undefined) {
	                console.warn('ag-grid: colDef.suppressAggregation is deprecated, please use colDef.type instead');
	            }
	            if (colDefNoType.suppressRowGroup || colDefNoType.suppressAggregation) {
	                console.warn('ag-grid: colDef.suppressAggregation and colDef.suppressRowGroup are deprecated, use allowRowGroup, allowPivot and allowValue instead');
	            }
	            if (colDefNoType.displayName) {
	                console.warn("ag-grid: Found displayName " + colDefNoType.displayName + ", please use headerName instead, displayName is deprecated.");
	                colDefNoType.headerName = colDefNoType.displayName;
	            }
	        }
	    };
	    // if object has children, we assume it's a group
	    ColumnFactory.prototype.isColumnGroup = function (abstractColDef) {
	        return abstractColDef.children !== undefined;
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], ColumnFactory.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('columnUtils'),
	        __metadata("design:type", columnUtils_1.ColumnUtils)
	    ], ColumnFactory.prototype, "columnUtils", void 0);
	    __decorate([
	        context_1.Autowired('context'),
	        __metadata("design:type", context_1.Context)
	    ], ColumnFactory.prototype, "context", void 0);
	    __decorate([
	        __param(0, context_1.Qualifier('loggerFactory')),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [logger_1.LoggerFactory]),
	        __metadata("design:returntype", void 0)
	    ], ColumnFactory.prototype, "setBeans", null);
	    ColumnFactory = __decorate([
	        context_1.Bean('columnFactory')
	    ], ColumnFactory);
	    return ColumnFactory;
	}());
	exports.ColumnFactory = ColumnFactory;


/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var utils_1 = __webpack_require__(10);
	var MAT_GRID_SIZE = 8;
	var FRESH_GRID_SIZE = 4;
	var BALHAM_GRID_SIZE = 4;
	var HARD_CODED_SIZES = {
	    'ag-theme-material': {
	        headerHeight: MAT_GRID_SIZE * 7,
	        virtualItemHeight: MAT_GRID_SIZE * 5,
	        rowHeight: MAT_GRID_SIZE * 6
	    },
	    'ag-theme-classic': {
	        headerHeight: 25,
	        virtualItemHeight: FRESH_GRID_SIZE * 5,
	        rowHeight: 25
	    },
	    'ag-theme-balham': {
	        headerHeight: BALHAM_GRID_SIZE * 8,
	        virtualItemHeight: BALHAM_GRID_SIZE * 7,
	        rowHeight: BALHAM_GRID_SIZE * 7
	    }
	};
	/**
	 * this object contains a list of Sass variables and an array
	 * of CSS styles required to get the correct value.
	 * eg. $virtual-item-height requires a structure, so we can get it's height.
	 * <div class="ag-theme-balham">
	 *     <div class="ag-virtual-list-container">
	 *         <div class="ag-virtual-list-item"></div>
	 *     </div>
	 */
	var SASS_PROPERTY_BUILDER = {
	    headerHeight: ['ag-header-row'],
	    virtualItemHeight: ['ag-virtual-list-container', 'ag-virtual-list-item'],
	    rowHeight: ['ag-row']
	};
	var CALCULATED_SIZES = {};
	var Environment = /** @class */ (function () {
	    function Environment() {
	    }
	    Environment.prototype.getSassVariable = function (theme, key) {
	        var useTheme = 'ag-theme-' + (theme.match('material') ? 'material' : (theme.match('balham') ? 'balham' : 'classic'));
	        var defaultValue = HARD_CODED_SIZES[useTheme][key];
	        var calculatedValue = 0;
	        if (!CALCULATED_SIZES[theme]) {
	            CALCULATED_SIZES[theme] = {};
	        }
	        if (CALCULATED_SIZES[theme][key]) {
	            return CALCULATED_SIZES[theme][key];
	        }
	        if (SASS_PROPERTY_BUILDER[key]) {
	            var classList = SASS_PROPERTY_BUILDER[key];
	            var div = document.createElement('div');
	            var el = classList.reduce(function (el, currentClass, idx) {
	                if (idx === 0) {
	                    utils_1._.addCssClass(el, theme);
	                }
	                var div = document.createElement('div');
	                utils_1._.addCssClass(div, currentClass);
	                el.appendChild(div);
	                return div;
	            }, div);
	            if (document.body) {
	                document.body.appendChild(div);
	                calculatedValue = parseInt(window.getComputedStyle(el).height, 10);
	                document.body.removeChild(div);
	            }
	        }
	        CALCULATED_SIZES[theme][key] = calculatedValue || defaultValue;
	        return CALCULATED_SIZES[theme][key];
	    };
	    Environment.prototype.isThemeDark = function () {
	        var theme = this.getTheme().theme;
	        return !!theme && theme.indexOf('dark') >= 0;
	    };
	    Environment.prototype.getTheme = function () {
	        var reg = /\bag-(fresh|dark|blue|material|bootstrap|(?:theme-([\w\-]*)))\b/;
	        var el = this.eGridDiv;
	        var themeMatch;
	        while (el) {
	            themeMatch = reg.exec(el.className);
	            if (!themeMatch) {
	                el = el.parentElement;
	            }
	            else {
	                break;
	            }
	        }
	        if (!themeMatch) {
	            return {};
	        }
	        var theme = themeMatch[0];
	        var usingOldTheme = themeMatch[2] === undefined;
	        if (usingOldTheme) {
	            var newTheme_1 = theme.replace('ag-', 'ag-theme-');
	            utils_1._.doOnce(function () { return console.warn("ag-Grid: As of v19 old theme are no longer provided. Please replace " + theme + " with " + newTheme_1 + "."); }, 'using-old-theme');
	        }
	        return { theme: theme, el: el };
	    };
	    __decorate([
	        context_1.Autowired('eGridDiv'),
	        __metadata("design:type", HTMLElement)
	    ], Environment.prototype, "eGridDiv", void 0);
	    Environment = __decorate([
	        context_1.Bean('environment')
	    ], Environment);
	    return Environment;
	}());
	exports.Environment = Environment;


/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var context_2 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var utils_1 = __webpack_require__(10);
	var MouseEventService = /** @class */ (function () {
	    function MouseEventService() {
	        this.gridInstanceId = MouseEventService_1.gridInstanceSequence.next();
	    }
	    MouseEventService_1 = MouseEventService;
	    MouseEventService.prototype.init = function () {
	        this.stampDomElementWithGridInstance();
	    };
	    // we put the instance id onto the main DOM element. this is used for events, when grids are inside grids,
	    // so the grid can work out if the even came from this grid or a grid inside this one. see the ctrl+v logic
	    // for where this is used.
	    MouseEventService.prototype.stampDomElementWithGridInstance = function () {
	        this.eGridDiv[MouseEventService_1.GRID_DOM_KEY] = this.gridInstanceId;
	    };
	    MouseEventService.prototype.getRenderedCellForEvent = function (event) {
	        return utils_1._.getCellCompForEvent(this.gridOptionsWrapper, event);
	    };
	    // walks the path of the event, and returns true if this grid is the first one that it finds. if doing
	    // master / detail grids, and a child grid is found, then it returns false. this stops things like copy/paste
	    // getting executed on many grids at the same time.
	    MouseEventService.prototype.isEventFromThisGrid = function (event) {
	        var path = utils_1._.getEventPath(event);
	        for (var i = 0; i < path.length; i++) {
	            var element = path[i];
	            var instanceId = element[MouseEventService_1.GRID_DOM_KEY];
	            if (utils_1._.exists(instanceId)) {
	                var eventFromThisGrid = instanceId === this.gridInstanceId;
	                return eventFromThisGrid;
	            }
	        }
	        return false;
	    };
	    MouseEventService.prototype.getCellPositionForEvent = function (event) {
	        var cellComp = this.getRenderedCellForEvent(event);
	        return cellComp ? cellComp.getCellPosition() : null;
	    };
	    var MouseEventService_1;
	    MouseEventService.gridInstanceSequence = new utils_1.NumberSequence();
	    MouseEventService.GRID_DOM_KEY = '__ag_grid_instance';
	    __decorate([
	        context_2.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], MouseEventService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_2.Autowired('eGridDiv'),
	        __metadata("design:type", HTMLElement)
	    ], MouseEventService.prototype, "eGridDiv", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], MouseEventService.prototype, "init", null);
	    MouseEventService = MouseEventService_1 = __decorate([
	        context_1.Bean('mouseEventService')
	    ], MouseEventService);
	    return MouseEventService;
	}());
	exports.MouseEventService = MouseEventService;


/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var eventService_1 = __webpack_require__(22);
	var events_1 = __webpack_require__(29);
	var columnController_1 = __webpack_require__(26);
	var columnApi_1 = __webpack_require__(38);
	var gridApi_1 = __webpack_require__(33);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var ScrollVisibleService = /** @class */ (function () {
	    function ScrollVisibleService() {
	    }
	    ScrollVisibleService.prototype.setScrollsVisible = function (params) {
	        var atLeastOneDifferent = this.horizontalScrollShowing !== params.horizontalScrollShowing ||
	            this.verticalScrollShowing !== params.verticalScrollShowing;
	        if (atLeastOneDifferent) {
	            this.horizontalScrollShowing = params.horizontalScrollShowing;
	            this.verticalScrollShowing = params.verticalScrollShowing;
	            var event_1 = {
	                type: events_1.Events.EVENT_SCROLL_VISIBILITY_CHANGED,
	                api: this.gridApi,
	                columnApi: this.columnApi
	            };
	            this.eventService.dispatchEvent(event_1);
	        }
	    };
	    // used by pagination service - to know page height
	    ScrollVisibleService.prototype.isHorizontalScrollShowing = function () {
	        return this.horizontalScrollShowing;
	    };
	    // used by header container
	    ScrollVisibleService.prototype.isVerticalScrollShowing = function () {
	        return this.verticalScrollShowing;
	    };
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], ScrollVisibleService.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], ScrollVisibleService.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], ScrollVisibleService.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], ScrollVisibleService.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], ScrollVisibleService.prototype, "gridOptionsWrapper", void 0);
	    ScrollVisibleService = __decorate([
	        context_1.Bean('scrollVisibleService')
	    ], ScrollVisibleService);
	    return ScrollVisibleService;
	}());
	exports.ScrollVisibleService = ScrollVisibleService;


/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var rowRenderer_1 = __webpack_require__(91);
	var context_1 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var headerWrapperComp_1 = __webpack_require__(653);
	var AutoWidthCalculator = /** @class */ (function () {
	    function AutoWidthCalculator() {
	    }
	    AutoWidthCalculator.prototype.registerGridComp = function (gridPanel) {
	        this.gridPanel = gridPanel;
	    };
	    AutoWidthCalculator.prototype.registerHeaderRootComp = function (headerRootComp) {
	        this.headerRootComp = headerRootComp;
	    };
	    // this is the trick: we create a dummy container and clone all the cells
	    // into the dummy, then check the dummy's width. then destroy the dummy
	    // as we don't need it any more.
	    // drawback: only the cells visible on the screen are considered
	    AutoWidthCalculator.prototype.getPreferredWidthForColumn = function (column) {
	        var eHeaderCell = this.getHeaderCellForColumn(column);
	        // cell isn't visible
	        if (!eHeaderCell) {
	            return -1;
	        }
	        var eDummyContainer = document.createElement('span');
	        // position fixed, so it isn't restricted to the boundaries of the parent
	        eDummyContainer.style.position = 'fixed';
	        // we put the dummy into the body container, so it will inherit all the
	        // css styles that the real cells are inheriting
	        var eBodyContainer = this.gridPanel.getCenterContainer();
	        eBodyContainer.appendChild(eDummyContainer);
	        // get all the cells that are currently displayed (this only brings back
	        // rendered cells, rows not rendered due to row visualisation will not be here)
	        this.putRowCellsIntoDummyContainer(column, eDummyContainer);
	        // also put header cell in
	        // we only consider the lowest level cell, not the group cell. in 99% of the time, this
	        // will be enough. if we consider groups, then it gets to complicated for what it's worth,
	        // as the groups can span columns and this class only considers one column at a time.
	        this.cloneItemIntoDummy(eHeaderCell, eDummyContainer);
	        // at this point, all the clones are lined up vertically with natural widths. the dummy
	        // container will have a width wide enough just to fit the largest.
	        var dummyContainerWidth = eDummyContainer.offsetWidth;
	        // we are finished with the dummy container, so get rid of it
	        eBodyContainer.removeChild(eDummyContainer);
	        // we add padding as I found sometimes the gui still put '...' after some of the texts. so the
	        // user can configure the grid to add a few more pixels after the calculated width
	        var autoSizePadding = this.gridOptionsWrapper.getAutoSizePadding();
	        return dummyContainerWidth + autoSizePadding;
	    };
	    AutoWidthCalculator.prototype.getHeaderCellForColumn = function (column) {
	        var comp = null;
	        // find the rendered header cell
	        this.headerRootComp.forEachHeaderElement(function (headerElement) {
	            if (headerElement instanceof headerWrapperComp_1.HeaderWrapperComp) {
	                var headerWrapperComp = headerElement;
	                if (headerWrapperComp.getColumn() === column) {
	                    comp = headerWrapperComp;
	                }
	            }
	        });
	        return comp ? comp.getGui() : null;
	    };
	    AutoWidthCalculator.prototype.putRowCellsIntoDummyContainer = function (column, eDummyContainer) {
	        var _this = this;
	        var eCells = this.rowRenderer.getAllCellsForColumn(column);
	        eCells.forEach(function (eCell) { return _this.cloneItemIntoDummy(eCell, eDummyContainer); });
	    };
	    AutoWidthCalculator.prototype.cloneItemIntoDummy = function (eCell, eDummyContainer) {
	        // make a deep clone of the cell
	        var eCellClone = eCell.cloneNode(true);
	        // the original has a fixed width, we remove this to allow the natural width based on content
	        eCellClone.style.width = '';
	        // the original has position = absolute, we need to remove this so it's positioned normally
	        eCellClone.style.position = 'static';
	        eCellClone.style.left = '';
	        // we put the cell into a containing div, as otherwise the cells would just line up
	        // on the same line, standard flow layout, by putting them into divs, they are laid
	        // out one per line
	        var eCloneParent = document.createElement('div');
	        // table-row, so that each cell is on a row. i also tried display='block', but this
	        // didn't work in IE
	        eCloneParent.style.display = 'table-row';
	        // the twig on the branch, the branch on the tree, the tree in the hole,
	        // the hole in the bog, the bog in the clone, the clone in the parent,
	        // the parent in the dummy, and the dummy down in the vall-e-ooo, OOOOOOOOO! Oh row the rattling bog....
	        eCloneParent.appendChild(eCellClone);
	        eDummyContainer.appendChild(eCloneParent);
	    };
	    __decorate([
	        context_1.Autowired('rowRenderer'),
	        __metadata("design:type", rowRenderer_1.RowRenderer)
	    ], AutoWidthCalculator.prototype, "rowRenderer", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], AutoWidthCalculator.prototype, "gridOptionsWrapper", void 0);
	    AutoWidthCalculator = __decorate([
	        context_1.Bean('autoWidthCalculator')
	    ], AutoWidthCalculator);
	    return AutoWidthCalculator;
	}());
	exports.AutoWidthCalculator = AutoWidthCalculator;


/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var column_1 = __webpack_require__(45);
	var constants_1 = __webpack_require__(30);
	var events_1 = __webpack_require__(29);
	var component_1 = __webpack_require__(31);
	var checkboxSelectionComponent_1 = __webpack_require__(440);
	var iRangeController_1 = __webpack_require__(658);
	var rowDragComp_1 = __webpack_require__(1405);
	var popupEditorWrapper_1 = __webpack_require__(434);
	var utils_1 = __webpack_require__(10);
	var dndSourceComp_1 = __webpack_require__(1401);
	var CellComp = /** @class */ (function (_super) {
	    __extends(CellComp, _super);
	    function CellComp(scope, beans, column, rowNode, rowComp, autoHeightCell, printLayout) {
	        var _this = _super.call(this) || this;
	        _this.editingCell = false;
	        _this.suppressRefreshCell = false;
	        _this.scope = null;
	        // every time we go into edit mode, or back again, this gets incremented.
	        // it's the components way of dealing with the async nature of framework components,
	        // so if a framework component takes a while to be created, we know if the object
	        // is still relevant when creating is finished. eg we could click edit / un-edit 20
	        // times before the first React edit component comes back - we should discard
	        // the first 19.
	        _this.cellEditorVersion = 0;
	        _this.cellRendererVersion = 0;
	        _this.scope = scope;
	        _this.beans = beans;
	        _this.column = column;
	        _this.rowNode = rowNode;
	        _this.rowComp = rowComp;
	        _this.autoHeightCell = autoHeightCell;
	        _this.printLayout = printLayout;
	        _this.createGridCellVo();
	        _this.rangeSelectionEnabled = beans.gridOptionsWrapper.isEnableRangeSelection();
	        _this.cellFocused = _this.beans.focusedCellController.isCellFocused(_this.cellPosition);
	        _this.firstRightPinned = _this.column.isFirstRightPinned();
	        _this.lastLeftPinned = _this.column.isLastLeftPinned();
	        if (_this.rangeSelectionEnabled) {
	            var rangeController = _this.beans.rangeController;
	            _this.rangeCount = rangeController.getCellRangeCount(_this.cellPosition);
	            if (_this.rangeCount) {
	                _this.hasChartRange = rangeController.getCellRanges().every(function (range) { return utils_1._.exists(range.type); });
	            }
	        }
	        _this.getValueAndFormat();
	        _this.setUsingWrapper();
	        _this.chooseCellRenderer();
	        _this.setupColSpan();
	        _this.rowSpan = _this.column.getRowSpan(_this.rowNode);
	        return _this;
	    }
	    CellComp.prototype.getCreateTemplate = function () {
	        var unselectable = !this.beans.gridOptionsWrapper.isEnableCellTextSelection() ? 'unselectable="on"' : '';
	        var templateParts = [];
	        var col = this.column;
	        var width = this.getCellWidth();
	        var left = this.modifyLeftForPrintLayout(this.getCellLeft());
	        var valueToRender = this.getInitialValueToRender();
	        var valueSanitised = utils_1._.get(this.column, 'colDef.template', null) ? valueToRender : utils_1._.escape(valueToRender);
	        this.tooltip = this.getToolTip();
	        var tooltipSanitised = utils_1._.escape(this.tooltip);
	        var colIdSanitised = utils_1._.escape(col.getId());
	        var wrapperStartTemplate = '';
	        var wrapperEndTemplate = '';
	        var stylesFromColDef = this.preProcessStylesFromColDef();
	        var cssClasses = this.getInitialCssClasses();
	        var stylesForRowSpanning = this.getStylesForRowSpanning();
	        if (this.usingWrapper) {
	            wrapperStartTemplate = "<div ref=\"eCellWrapper\" class=\"ag-cell-wrapper\"><span ref=\"eCellValue\" class=\"ag-cell-value\" " + unselectable + ">";
	            wrapperEndTemplate = '</span></div>';
	        }
	        templateParts.push("<div");
	        templateParts.push(" tabindex=\"-1\"");
	        templateParts.push(" " + unselectable); // THIS IS FOR IE ONLY so text selection doesn't bubble outside of the grid
	        templateParts.push(" role=\"gridcell\"");
	        templateParts.push(" comp-id=\"" + this.getCompId() + "\" ");
	        templateParts.push(" col-id=\"" + colIdSanitised + "\"");
	        templateParts.push(" class=\"" + cssClasses.join(' ') + "\"");
	        if (this.beans.gridOptionsWrapper.isEnableBrowserTooltips() && utils_1._.exists(tooltipSanitised)) {
	            templateParts.push("title=\"" + tooltipSanitised + "\"");
	        }
	        templateParts.push(" style=\"width: " + width + "px; left: " + left + "px; " + stylesFromColDef + " " + stylesForRowSpanning + "\" >");
	        templateParts.push(wrapperStartTemplate);
	        if (utils_1._.exists(valueSanitised, true)) {
	            templateParts.push(valueSanitised);
	        }
	        templateParts.push(wrapperEndTemplate);
	        templateParts.push("</div>");
	        return templateParts.join('');
	    };
	    CellComp.prototype.getStylesForRowSpanning = function () {
	        if (this.rowSpan === 1) {
	            return '';
	        }
	        var singleRowHeight = this.beans.gridOptionsWrapper.getRowHeightAsNumber();
	        var totalRowHeight = singleRowHeight * this.rowSpan;
	        return "height: " + totalRowHeight + "px; z-index: 1;";
	    };
	    CellComp.prototype.afterAttached = function () {
	        var querySelector = "[comp-id=\"" + this.getCompId() + "\"]";
	        var eGui = this.eParentRow.querySelector(querySelector);
	        this.setGui(eGui);
	        // all of these have dependencies on the eGui, so only do them after eGui is set
	        this.addDomData();
	        this.populateTemplate();
	        this.createCellRendererInstance(true);
	        this.angular1Compile();
	        // if not doing enterprise, then range selection service would be missing
	        // so need to check before trying to use it
	        if (this.rangeSelectionEnabled) {
	            if (this.shouldHaveSelectionHandle()) {
	                this.addSelectionHandle();
	            }
	        }
	        if (utils_1._.exists(this.tooltip) && !this.beans.gridOptionsWrapper.isEnableBrowserTooltips()) {
	            this.beans.tooltipManager.registerTooltip(this);
	        }
	    };
	    CellComp.prototype.onColumnHover = function () {
	        var isHovered = this.beans.columnHoverService.isHovered(this.column);
	        utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-column-hover', isHovered);
	    };
	    CellComp.prototype.onCellChanged = function (event) {
	        var eventImpactsThisCell = event.column === this.column;
	        if (eventImpactsThisCell) {
	            this.refreshCell({});
	        }
	    };
	    CellComp.prototype.getCellLeft = function () {
	        var mostLeftCol;
	        if (this.beans.gridOptionsWrapper.isEnableRtl() && this.colsSpanning) {
	            mostLeftCol = utils_1._.last(this.colsSpanning);
	        }
	        else {
	            mostLeftCol = this.column;
	        }
	        return mostLeftCol.getLeft();
	    };
	    CellComp.prototype.getCellWidth = function () {
	        if (!this.colsSpanning) {
	            return this.column.getActualWidth();
	        }
	        var result = 0;
	        this.colsSpanning.forEach(function (col) { return result += col.getActualWidth(); });
	        return result;
	    };
	    CellComp.prototype.onFlashCells = function (event) {
	        var cellId = this.beans.cellPositionUtils.createId(this.cellPosition);
	        var shouldFlash = event.cells[cellId];
	        if (shouldFlash) {
	            this.animateCell('highlight');
	        }
	    };
	    CellComp.prototype.setupColSpan = function () {
	        // if no col span is active, then we don't set it up, as it would be wasteful of CPU
	        if (utils_1._.missing(this.getComponentHolder().colSpan)) {
	            return;
	        }
	        // because we are col spanning, a reorder of the cols can change what cols we are spanning over
	        this.addDestroyableEventListener(this.beans.eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayColumnsChanged.bind(this));
	        // because we are spanning over multiple cols, we check for width any time any cols width changes.
	        // this is expensive - really we should be explicitly checking only the cols we are spanning over
	        // instead of every col, however it would be tricky code to track the cols we are spanning over, so
	        // because hardly anyone will be using colSpan, am favouring this easier way for more maintainable code.
	        this.addDestroyableEventListener(this.beans.eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onWidthChanged.bind(this));
	        this.colsSpanning = this.getColSpanningList();
	    };
	    CellComp.prototype.getColSpanningList = function () {
	        var colSpan = this.column.getColSpan(this.rowNode);
	        var colsSpanning = [];
	        // if just one col, the col span is just the column we are in
	        if (colSpan === 1) {
	            colsSpanning.push(this.column);
	        }
	        else {
	            var pointer = this.column;
	            var pinned = this.column.getPinned();
	            for (var i = 0; pointer && i < colSpan; i++) {
	                colsSpanning.push(pointer);
	                pointer = this.beans.columnController.getDisplayedColAfter(pointer);
	                if (!pointer || utils_1._.missing(pointer)) {
	                    break;
	                }
	                // we do not allow col spanning to span outside of pinned areas
	                if (pinned !== pointer.getPinned()) {
	                    break;
	                }
	            }
	        }
	        return colsSpanning;
	    };
	    CellComp.prototype.onDisplayColumnsChanged = function () {
	        var colsSpanning = this.getColSpanningList();
	        if (!utils_1._.compareArrays(this.colsSpanning, colsSpanning)) {
	            this.colsSpanning = colsSpanning;
	            this.onWidthChanged();
	            this.onLeftChanged(); // left changes when doing RTL
	        }
	    };
	    CellComp.prototype.getInitialCssClasses = function () {
	        var cssClasses = ["ag-cell", "ag-cell-not-inline-editing"];
	        // if we are putting the cell into a dummy container, to work out it's height,
	        // then we don't put the height css in, as we want cell to fit height in that case.
	        if (!this.autoHeightCell) {
	            cssClasses.push('ag-cell-with-height');
	        }
	        var doingFocusCss = !this.beans.gridOptionsWrapper.isSuppressCellSelection();
	        if (doingFocusCss && this.cellFocused) {
	            // otherwise the class depends on the focus state
	            cssClasses.push('ag-cell-focus');
	        }
	        if (this.firstRightPinned) {
	            cssClasses.push('ag-cell-first-right-pinned');
	        }
	        if (this.lastLeftPinned) {
	            cssClasses.push('ag-cell-last-left-pinned');
	        }
	        if (this.beans.columnHoverService.isHovered(this.column)) {
	            cssClasses.push('ag-column-hover');
	        }
	        utils_1._.pushAll(cssClasses, this.preProcessClassesFromColDef());
	        utils_1._.pushAll(cssClasses, this.preProcessCellClassRules());
	        utils_1._.pushAll(cssClasses, this.getInitialRangeClasses());
	        // if using the wrapper, this class goes on the wrapper instead
	        if (!this.usingWrapper) {
	            cssClasses.push('ag-cell-value');
	        }
	        return cssClasses;
	    };
	    CellComp.prototype.getInitialValueToRender = function () {
	        // if using a cellRenderer, then render the html from the cell renderer if it exists
	        if (this.usingCellRenderer) {
	            if (typeof this.cellRendererGui === 'string') {
	                return this.cellRendererGui;
	            }
	            else {
	                return '';
	            }
	        }
	        var colDef = this.getComponentHolder();
	        if (colDef.template) {
	            // template is really only used for angular 1 - as people using ng1 are used to providing templates with
	            // bindings in it. in ng2, people will hopefully want to provide components, not templates.
	            return colDef.template;
	        }
	        else if (colDef.templateUrl) {
	            // likewise for templateUrl - it's for ng1 really - when we move away from ng1, we can take these out.
	            // niall was pro angular 1 when writing template and templateUrl, if writing from scratch now, would
	            // not do these, but would follow a pattern that was friendly towards components, not templates.
	            var template = this.beans.templateService.getTemplate(colDef.templateUrl, this.refreshCell.bind(this, true));
	            if (template) {
	                return template;
	            }
	            else {
	                return '';
	            }
	        }
	        else {
	            return this.getValueToUse();
	        }
	    };
	    CellComp.prototype.getRenderedRow = function () {
	        return this.rowComp;
	    };
	    CellComp.prototype.isSuppressNavigable = function () {
	        return this.column.isSuppressNavigable(this.rowNode);
	    };
	    CellComp.prototype.getCellRenderer = function () {
	        return this.cellRenderer;
	    };
	    CellComp.prototype.getCellEditor = function () {
	        return this.cellEditor;
	    };
	    // + stop editing {forceRefresh: true, suppressFlash: true}
	    // + event cellChanged {}
	    // + cellRenderer.params.refresh() {} -> method passes 'as is' to the cellRenderer, so params could be anything
	    // + rowComp: event dataChanged {animate: update, newData: !update}
	    // + rowComp: api refreshCells() {animate: true/false}
	    // + rowRenderer: api softRefreshView() {}
	    CellComp.prototype.refreshCell = function (params) {
	        // if we are in the middle of 'stopEditing', then we don't refresh here, as refresh gets called explicitly
	        if (this.suppressRefreshCell || this.editingCell) {
	            return;
	        }
	        var colDef = this.getComponentHolder();
	        var newData = params && params.newData;
	        var suppressFlash = (params && params.suppressFlash) || colDef.suppressCellFlash;
	        var forceRefresh = params && params.forceRefresh;
	        var oldValue = this.value;
	        this.getValueAndFormat();
	        // for simple values only (not pojo's), see if the value is the same, and if it is, skip the refresh.
	        // when never allow skipping after an edit, as after editing, we need to put the GUI back to the way
	        // if was before the edit.
	        var valuesDifferent = !this.valuesAreEqual(oldValue, this.value);
	        var dataNeedsUpdating = forceRefresh || valuesDifferent;
	        if (dataNeedsUpdating) {
	            // if it's 'new data', then we don't refresh the cellRenderer, even if refresh method is available.
	            // this is because if the whole data is new (ie we are showing stock price 'BBA' now and not 'SSD')
	            // then we are not showing a movement in the stock price, rather we are showing different stock.
	            var cellRendererRefreshed = newData ? false : this.attemptCellRendererRefresh();
	            // we do the replace if not doing refresh, or if refresh was unsuccessful.
	            // the refresh can be unsuccessful if we are using a framework (eg ng2 or react) and the framework
	            // wrapper has the refresh method, but the underlying component doesn't
	            if (!cellRendererRefreshed) {
	                this.replaceContentsAfterRefresh();
	            }
	            // we don't want to flash the cells when processing a filter change, as otherwise the UI would
	            // be to busy. see comment in FilterManager with regards processingFilterChange
	            var processingFilterChange = this.beans.filterManager.isSuppressFlashingCellsBecauseFiltering();
	            var flashCell = !suppressFlash && !processingFilterChange &&
	                (this.beans.gridOptionsWrapper.isEnableCellChangeFlash() || colDef.enableCellChangeFlash);
	            if (flashCell) {
	                this.flashCell();
	            }
	            // need to check rules. note, we ignore colDef classes and styles, these are assumed to be static
	            this.postProcessStylesFromColDef();
	            this.postProcessClassesFromColDef();
	        }
	        // we can't readily determine if the data in an angularjs template has changed, so here we just update
	        // and recompile (if applicable)
	        this.updateAngular1ScopeAndCompile();
	        this.refreshToolTip();
	        // we do cellClassRules even if the value has not changed, so that users who have rules that
	        // look at other parts of the row (where the other part of the row might of changed) will work.
	        this.postProcessCellClassRules();
	    };
	    // user can also call this via API
	    CellComp.prototype.flashCell = function () {
	        this.animateCell('data-changed');
	    };
	    CellComp.prototype.animateCell = function (cssName) {
	        var fullName = 'ag-cell-' + cssName;
	        var animationFullName = 'ag-cell-' + cssName + '-animation';
	        var element = this.getGui();
	        // we want to highlight the cells, without any animation
	        utils_1._.addCssClass(element, fullName);
	        utils_1._.removeCssClass(element, animationFullName);
	        // then once that is applied, we remove the highlight with animation
	        window.setTimeout(function () {
	            utils_1._.removeCssClass(element, fullName);
	            utils_1._.addCssClass(element, animationFullName);
	            window.setTimeout(function () {
	                // and then to leave things as we got them, we remove the animation
	                utils_1._.removeCssClass(element, animationFullName);
	            }, 1000);
	        }, 500);
	    };
	    CellComp.prototype.replaceContentsAfterRefresh = function () {
	        // otherwise we rip out the cell and replace it
	        utils_1._.clearElement(this.eParentOfValue);
	        // remove old renderer component if it exists
	        if (this.cellRenderer && this.cellRenderer.destroy) {
	            this.cellRenderer.destroy();
	        }
	        this.cellRenderer = null;
	        this.cellRendererGui = null;
	        // populate
	        this.putDataIntoCellAfterRefresh();
	        this.updateAngular1ScopeAndCompile();
	    };
	    CellComp.prototype.updateAngular1ScopeAndCompile = function () {
	        if (this.beans.gridOptionsWrapper.isAngularCompileRows() && this.scope) {
	            this.scope.data = __assign({}, this.rowNode.data);
	            this.angular1Compile();
	        }
	    };
	    CellComp.prototype.angular1Compile = function () {
	        // if angular compiling, then need to also compile the cell again (angular compiling sucks, please wait...)
	        if (this.beans.gridOptionsWrapper.isAngularCompileRows()) {
	            var eGui = this.getGui();
	            // only compile the node if it hasn't already been done
	            // this prevents "orphaned" node leaks
	            if (!eGui.classList.contains('ng-scope') || eGui.childElementCount === 0) {
	                var compiledElement_1 = this.beans.$compile(eGui)(this.scope);
	                this.addDestroyFunc(function () {
	                    compiledElement_1.remove();
	                });
	            }
	        }
	    };
	    CellComp.prototype.postProcessStylesFromColDef = function () {
	        var stylesToUse = this.processStylesFromColDef();
	        if (stylesToUse) {
	            utils_1._.addStylesToElement(this.getGui(), stylesToUse);
	        }
	    };
	    CellComp.prototype.preProcessStylesFromColDef = function () {
	        var stylesToUse = this.processStylesFromColDef();
	        return utils_1._.cssStyleObjectToMarkup(stylesToUse);
	    };
	    CellComp.prototype.processStylesFromColDef = function () {
	        var colDef = this.getComponentHolder();
	        if (colDef.cellStyle) {
	            var cssToUse = void 0;
	            if (typeof colDef.cellStyle === 'function') {
	                var cellStyleParams = {
	                    value: this.value,
	                    data: this.rowNode.data,
	                    node: this.rowNode,
	                    colDef: colDef,
	                    column: this.column,
	                    $scope: this.scope,
	                    context: this.beans.gridOptionsWrapper.getContext(),
	                    api: this.beans.gridOptionsWrapper.getApi()
	                };
	                var cellStyleFunc = colDef.cellStyle;
	                cssToUse = cellStyleFunc(cellStyleParams);
	            }
	            else {
	                cssToUse = colDef.cellStyle;
	            }
	            return cssToUse;
	        }
	    };
	    CellComp.prototype.postProcessClassesFromColDef = function () {
	        var _this = this;
	        this.processClassesFromColDef(function (className) { return utils_1._.addCssClass(_this.getGui(), className); });
	    };
	    CellComp.prototype.preProcessClassesFromColDef = function () {
	        var res = [];
	        this.processClassesFromColDef(function (className) { return res.push(className); });
	        return res;
	    };
	    CellComp.prototype.processClassesFromColDef = function (onApplicableClass) {
	        var colDef = this.getComponentHolder();
	        this.beans.stylingService.processStaticCellClasses(colDef, {
	            value: this.value,
	            data: this.rowNode.data,
	            node: this.rowNode,
	            colDef: colDef,
	            rowIndex: this.rowNode.rowIndex,
	            $scope: this.scope,
	            api: this.beans.gridOptionsWrapper.getApi(),
	            columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
	            context: this.beans.gridOptionsWrapper.getContext()
	        }, onApplicableClass);
	    };
	    CellComp.prototype.putDataIntoCellAfterRefresh = function () {
	        // template gets preference, then cellRenderer, then do it ourselves
	        var colDef = this.getComponentHolder();
	        if (colDef.template) {
	            // template is really only used for angular 1 - as people using ng1 are used to providing templates with
	            // bindings in it. in ng2, people will hopefully want to provide components, not templates.
	            this.eParentOfValue.innerHTML = colDef.template;
	        }
	        else if (colDef.templateUrl) {
	            // likewise for templateUrl - it's for ng1 really - when we move away from ng1, we can take these out.
	            // niall was pro angular 1 when writing template and templateUrl, if writing from scratch now, would
	            // not do these, but would follow a pattern that was friendly towards components, not templates.
	            var template = this.beans.templateService.getTemplate(colDef.templateUrl, this.refreshCell.bind(this, true));
	            if (template) {
	                this.eParentOfValue.innerHTML = template;
	            }
	        }
	        else {
	            // we can switch from using a cell renderer back to the default if a user
	            // is using cellRendererSelect
	            this.chooseCellRenderer();
	            if (this.usingCellRenderer) {
	                this.createCellRendererInstance();
	            }
	            else {
	                var valueToUse = this.getValueToUse();
	                if (valueToUse !== null && valueToUse !== undefined) {
	                    this.eParentOfValue.innerHTML = utils_1._.escape(valueToUse);
	                }
	            }
	        }
	    };
	    CellComp.prototype.attemptCellRendererRefresh = function () {
	        if (utils_1._.missing(this.cellRenderer) || !this.cellRenderer || utils_1._.missing(this.cellRenderer.refresh)) {
	            return false;
	        }
	        // if the cell renderer has a refresh method, we call this instead of doing a refresh
	        var params = this.createCellRendererParams();
	        // take any custom params off of the user
	        var finalParams = this.beans.userComponentFactory.createFinalParams(this.getComponentHolder(), this.cellRendererType, params);
	        var result = this.cellRenderer.refresh(finalParams);
	        // NOTE on undefined: previous version of the cellRenderer.refresh() interface
	        // returned nothing, if the method existed, we assumed it refreshed. so for
	        // backwards compatibility, we assume if method exists and returns nothing,
	        // that it was successful.
	        return result === true || result === undefined;
	    };
	    CellComp.prototype.refreshToolTip = function () {
	        var newTooltip = this.getToolTip();
	        if (this.tooltip === newTooltip) {
	            return;
	        }
	        var hasNewTooltip = utils_1._.exists(newTooltip);
	        var hadTooltip = utils_1._.exists(this.tooltip);
	        if (hasNewTooltip && this.tooltip === newTooltip.toString()) {
	            return;
	        }
	        this.tooltip = newTooltip;
	        if (this.beans.gridOptionsWrapper.isEnableBrowserTooltips()) {
	            if (hasNewTooltip) {
	                var tooltipSanitised = utils_1._.escape(this.tooltip);
	                this.eParentOfValue.setAttribute('title', tooltipSanitised);
	            }
	            else {
	                this.eParentOfValue.removeAttribute('title');
	            }
	        }
	        else {
	            if (hadTooltip) {
	                if (!hasNewTooltip) {
	                    this.beans.tooltipManager.unregisterTooltip(this);
	                }
	            }
	            else if (hasNewTooltip) {
	                this.beans.tooltipManager.registerTooltip(this);
	            }
	        }
	    };
	    CellComp.prototype.valuesAreEqual = function (val1, val2) {
	        // if the user provided an equals method, use that, otherwise do simple comparison
	        var colDef = this.getComponentHolder();
	        var equalsMethod = colDef ? colDef.equals : null;
	        if (equalsMethod) {
	            return equalsMethod(val1, val2);
	        }
	        return val1 === val2;
	    };
	    CellComp.prototype.getToolTip = function () {
	        var colDef = this.getComponentHolder();
	        var data = this.rowNode.data;
	        if (colDef.tooltipField && utils_1._.exists(data)) {
	            return utils_1._.getValueUsingField(data, colDef.tooltipField, this.column.isTooltipFieldContainsDots());
	        }
	        var valueGetter = colDef.tooltipValueGetter || colDef.tooltip;
	        if (valueGetter) {
	            return valueGetter({
	                api: this.beans.gridOptionsWrapper.getApi(),
	                columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
	                colDef: colDef,
	                column: this.getColumn(),
	                context: this.beans.gridOptionsWrapper.getContext(),
	                value: this.value,
	                valueFormatted: this.valueFormatted,
	                rowIndex: this.cellPosition.rowIndex,
	                node: this.rowNode,
	                data: this.rowNode.data,
	                $scope: this.scope,
	            });
	        }
	        return null;
	    };
	    CellComp.prototype.getTooltipText = function (escape) {
	        if (escape === void 0) { escape = true; }
	        return escape ? utils_1._.escape(this.tooltip) : this.tooltip;
	    };
	    CellComp.prototype.processCellClassRules = function (onApplicableClass, onNotApplicableClass) {
	        var colDef = this.getComponentHolder();
	        this.beans.stylingService.processClassRules(colDef.cellClassRules, {
	            value: this.value,
	            data: this.rowNode.data,
	            node: this.rowNode,
	            colDef: colDef,
	            rowIndex: this.cellPosition.rowIndex,
	            api: this.beans.gridOptionsWrapper.getApi(),
	            columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
	            $scope: this.scope,
	            context: this.beans.gridOptionsWrapper.getContext()
	        }, onApplicableClass, onNotApplicableClass);
	    };
	    CellComp.prototype.postProcessCellClassRules = function () {
	        var _this = this;
	        this.processCellClassRules(function (className) {
	            utils_1._.addCssClass(_this.getGui(), className);
	        }, function (className) {
	            utils_1._.removeCssClass(_this.getGui(), className);
	        });
	    };
	    CellComp.prototype.preProcessCellClassRules = function () {
	        var res = [];
	        this.processCellClassRules(function (className) {
	            res.push(className);
	        }, function (className) {
	            // not catered for, if creating, no need
	            // to remove class as it was never there
	        });
	        return res;
	    };
	    // a wrapper is used when we are putting a selection checkbox in the cell with the value
	    CellComp.prototype.setUsingWrapper = function () {
	        var colDef = this.getComponentHolder();
	        // never allow selection or dragging on pinned rows
	        if (this.rowNode.rowPinned) {
	            this.usingWrapper = false;
	            this.includeSelectionComponent = false;
	            this.includeRowDraggingComponent = false;
	            this.includeDndSourceComponent = false;
	            return;
	        }
	        var cbSelectionIsFunc = typeof colDef.checkboxSelection === 'function';
	        var rowDraggableIsFunc = typeof colDef.rowDrag === 'function';
	        var dndSourceIsFunc = typeof colDef.dndSource === 'function';
	        this.includeSelectionComponent = cbSelectionIsFunc || colDef.checkboxSelection === true;
	        this.includeRowDraggingComponent = rowDraggableIsFunc || colDef.rowDrag === true;
	        this.includeDndSourceComponent = dndSourceIsFunc || colDef.dndSource === true;
	        this.usingWrapper = this.includeRowDraggingComponent || this.includeSelectionComponent || this.includeDndSourceComponent;
	    };
	    CellComp.prototype.chooseCellRenderer = function () {
	        // template gets preference, then cellRenderer, then do it ourselves
	        var colDef = this.getComponentHolder();
	        // templates are for ng1, ideally we wouldn't have these, they are ng1 support
	        // inside the core which is bad
	        if (colDef.template || colDef.templateUrl) {
	            this.usingCellRenderer = false;
	            return;
	        }
	        var params = this.createCellRendererParams();
	        var cellRenderer = this.beans.userComponentFactory.lookupComponentClassDef(colDef, 'cellRenderer', params);
	        var pinnedRowCellRenderer = this.beans.userComponentFactory.lookupComponentClassDef(colDef, 'pinnedRowCellRenderer', params);
	        if (pinnedRowCellRenderer && this.rowNode.rowPinned) {
	            this.cellRendererType = CellComp.CELL_RENDERER_TYPE_PINNED;
	            this.usingCellRenderer = true;
	        }
	        else if (cellRenderer) {
	            this.cellRendererType = CellComp.CELL_RENDERER_TYPE_NORMAL;
	            this.usingCellRenderer = true;
	        }
	        else {
	            this.usingCellRenderer = false;
	        }
	    };
	    CellComp.prototype.createCellRendererInstance = function (useTaskService) {
	        var _this = this;
	        if (useTaskService === void 0) { useTaskService = false; }
	        if (!this.usingCellRenderer) {
	            return;
	        }
	        // never use task service if angularCompileRows=true, as that assume the cell renderers
	        // are finished when the row is created. also we never use it if animation frame service
	        // is turned off.
	        // and lastly we never use it if doing auto-height, as the auto-height service checks the
	        // row height directly after the cell is created, it doesn't wait around for the tasks to complete
	        var angularCompileRows = this.beans.gridOptionsWrapper.isAngularCompileRows();
	        var suppressAnimationFrame = this.beans.gridOptionsWrapper.isSuppressAnimationFrame();
	        if (angularCompileRows || suppressAnimationFrame || this.autoHeightCell) {
	            useTaskService = false;
	        }
	        var params = this.createCellRendererParams();
	        this.cellRendererVersion++;
	        var callback = this.afterCellRendererCreated.bind(this, this.cellRendererVersion);
	        var cellRendererTypeNormal = this.cellRendererType === CellComp.CELL_RENDERER_TYPE_NORMAL;
	        var task = function () {
	            // this can return null in the event that the user has switched from a renderer component to nothing, for example
	            // when using a cellRendererSelect to return a component or null depending on row data etc
	            var componentPromise;
	            if (cellRendererTypeNormal) {
	                componentPromise = _this.beans.userComponentFactory.newCellRenderer(_this.getComponentHolder(), params);
	            }
	            else {
	                componentPromise = _this.beans.userComponentFactory.newPinnedRowCellRenderer(_this.getComponentHolder(), params);
	            }
	            if (componentPromise) {
	                componentPromise.then(callback);
	            }
	        };
	        if (useTaskService) {
	            this.beans.taskQueue.addP2Task(task);
	        }
	        else {
	            task();
	        }
	    };
	    CellComp.prototype.afterCellRendererCreated = function (cellRendererVersion, cellRenderer) {
	        // see if daemon
	        if (!this.isAlive() || (cellRendererVersion !== this.cellRendererVersion)) {
	            if (cellRenderer.destroy) {
	                cellRenderer.destroy();
	            }
	            return;
	        }
	        this.cellRenderer = cellRenderer;
	        this.cellRendererGui = this.cellRenderer.getGui();
	        if (utils_1._.missing(this.cellRendererGui)) {
	            return;
	        }
	        // if async components, then it's possible the user started editing since
	        // this call was made
	        if (!this.editingCell) {
	            this.eParentOfValue.appendChild(this.cellRendererGui);
	        }
	    };
	    CellComp.prototype.createCellRendererParams = function () {
	        var _this = this;
	        var params = {
	            value: this.value,
	            valueFormatted: this.valueFormatted,
	            getValue: this.getValue.bind(this),
	            setValue: function (value) {
	                _this.beans.valueService.setValue(_this.rowNode, _this.column, value);
	            },
	            formatValue: this.formatValue.bind(this),
	            data: this.rowNode.data,
	            node: this.rowNode,
	            colDef: this.getComponentHolder(),
	            column: this.column,
	            $scope: this.scope,
	            rowIndex: this.cellPosition.rowIndex,
	            api: this.beans.gridOptionsWrapper.getApi(),
	            columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
	            context: this.beans.gridOptionsWrapper.getContext(),
	            refreshCell: this.refreshCell.bind(this),
	            eGridCell: this.getGui(),
	            eParentOfValue: this.eParentOfValue,
	            // these bits are not documented anywhere, so we could drop them?
	            // it was in the olden days to allow user to register for when rendered
	            // row was removed (the row comp was removed), however now that the user
	            // can provide components for cells, the destroy method gets call when this
	            // happens so no longer need to fire event.
	            addRowCompListener: this.rowComp ? this.rowComp.addEventListener.bind(this.rowComp) : null,
	            addRenderedRowListener: function (eventType, listener) {
	                console.warn('ag-Grid: since ag-Grid .v11, params.addRenderedRowListener() is now params.addRowCompListener()');
	                if (_this.rowComp) {
	                    _this.rowComp.addEventListener(eventType, listener);
	                }
	            }
	        };
	        return params;
	    };
	    CellComp.prototype.formatValue = function (value) {
	        var valueFormatted = this.beans.valueFormatterService.formatValue(this.column, this.rowNode, this.scope, value);
	        var valueFormattedExists = valueFormatted !== null && valueFormatted !== undefined;
	        return valueFormattedExists ? valueFormatted : value;
	    };
	    CellComp.prototype.getValueToUse = function () {
	        var valueFormattedExists = this.valueFormatted !== null && this.valueFormatted !== undefined;
	        return valueFormattedExists ? this.valueFormatted : this.value;
	    };
	    CellComp.prototype.getValueAndFormat = function () {
	        this.value = this.getValue();
	        this.valueFormatted = this.beans.valueFormatterService.formatValue(this.column, this.rowNode, this.scope, this.value);
	    };
	    CellComp.prototype.getValue = function () {
	        // if we don't check this, then the grid will render leaf groups as open even if we are not
	        // allowing the user to open leaf groups. confused? remember for pivot mode we don't allow
	        // opening leaf groups, so we have to force leafGroups to be closed in case the user expanded
	        // them via the API, or user user expanded them in the UI before turning on pivot mode
	        var lockedClosedGroup = this.rowNode.leafGroup && this.beans.columnController.isPivotMode();
	        var isOpenGroup = this.rowNode.group && this.rowNode.expanded && !this.rowNode.footer && !lockedClosedGroup;
	        // are we showing group footers
	        var groupFootersEnabled = this.beans.gridOptionsWrapper.isGroupIncludeFooter();
	        // if doing footers, we normally don't show agg data at group level when group is open
	        var groupAlwaysShowAggData = this.beans.gridOptionsWrapper.isGroupSuppressBlankHeader();
	        // if doing grouping and footers, we don't want to include the agg value
	        // in the header when the group is open
	        var ignoreAggData = (isOpenGroup && groupFootersEnabled) && !groupAlwaysShowAggData;
	        return this.beans.valueService.getValue(this.column, this.rowNode, false, ignoreAggData);
	    };
	    CellComp.prototype.onMouseEvent = function (eventName, mouseEvent) {
	        if (utils_1._.isStopPropagationForAgGrid(mouseEvent)) {
	            return;
	        }
	        switch (eventName) {
	            case 'click':
	                this.onCellClicked(mouseEvent);
	                break;
	            case 'mousedown':
	                this.onMouseDown(mouseEvent);
	                break;
	            case 'dblclick':
	                this.onCellDoubleClicked(mouseEvent);
	                break;
	            case 'mouseout':
	                this.onMouseOut(mouseEvent);
	                break;
	            case 'mouseover':
	                this.onMouseOver(mouseEvent);
	                break;
	        }
	    };
	    CellComp.prototype.dispatchCellContextMenuEvent = function (event) {
	        var colDef = this.getComponentHolder();
	        var cellContextMenuEvent = this.createEvent(event, events_1.Events.EVENT_CELL_CONTEXT_MENU);
	        this.beans.eventService.dispatchEvent(cellContextMenuEvent);
	        if (colDef.onCellContextMenu) {
	            // to make the callback async, do in a timeout
	            window.setTimeout(function () { return colDef.onCellContextMenu(cellContextMenuEvent); }, 0);
	        }
	    };
	    CellComp.prototype.createEvent = function (domEvent, eventType) {
	        var event = {
	            node: this.rowNode,
	            data: this.rowNode.data,
	            value: this.value,
	            column: this.column,
	            colDef: this.getComponentHolder(),
	            context: this.beans.gridOptionsWrapper.getContext(),
	            api: this.beans.gridApi,
	            columnApi: this.beans.columnApi,
	            rowPinned: this.rowNode.rowPinned,
	            event: domEvent,
	            type: eventType,
	            rowIndex: this.rowNode.rowIndex
	        };
	        // because we are hacking in $scope for angular 1, we have to de-reference
	        if (this.scope) {
	            event.$scope = this.scope;
	        }
	        return event;
	    };
	    CellComp.prototype.onMouseOut = function (mouseEvent) {
	        var cellMouseOutEvent = this.createEvent(mouseEvent, events_1.Events.EVENT_CELL_MOUSE_OUT);
	        this.beans.eventService.dispatchEvent(cellMouseOutEvent);
	        this.beans.columnHoverService.clearMouseOver();
	    };
	    CellComp.prototype.onMouseOver = function (mouseEvent) {
	        var cellMouseOverEvent = this.createEvent(mouseEvent, events_1.Events.EVENT_CELL_MOUSE_OVER);
	        this.beans.eventService.dispatchEvent(cellMouseOverEvent);
	        this.beans.columnHoverService.setMouseOver([this.column]);
	    };
	    CellComp.prototype.onCellDoubleClicked = function (mouseEvent) {
	        var colDef = this.getComponentHolder();
	        // always dispatch event to eventService
	        var cellDoubleClickedEvent = this.createEvent(mouseEvent, events_1.Events.EVENT_CELL_DOUBLE_CLICKED);
	        this.beans.eventService.dispatchEvent(cellDoubleClickedEvent);
	        // check if colDef also wants to handle event
	        if (typeof colDef.onCellDoubleClicked === 'function') {
	            // to make the callback async, do in a timeout
	            window.setTimeout(function () { return colDef.onCellDoubleClicked(cellDoubleClickedEvent); }, 0);
	        }
	        var editOnDoubleClick = !this.beans.gridOptionsWrapper.isSingleClickEdit()
	            && !this.beans.gridOptionsWrapper.isSuppressClickEdit();
	        if (editOnDoubleClick) {
	            this.startRowOrCellEdit();
	        }
	    };
	    // called by rowRenderer when user navigates via tab key
	    CellComp.prototype.startRowOrCellEdit = function (keyPress, charPress) {
	        if (this.beans.gridOptionsWrapper.isFullRowEdit()) {
	            this.rowComp.startRowEditing(keyPress, charPress, this);
	        }
	        else {
	            this.startEditingIfEnabled(keyPress, charPress, true);
	        }
	    };
	    CellComp.prototype.isCellEditable = function () {
	        return this.column.isCellEditable(this.rowNode);
	    };
	    // either called internally if single cell editing, or called by rowRenderer if row editing
	    CellComp.prototype.startEditingIfEnabled = function (keyPress, charPress, cellStartedEdit) {
	        if (keyPress === void 0) { keyPress = null; }
	        if (charPress === void 0) { charPress = null; }
	        if (cellStartedEdit === void 0) { cellStartedEdit = false; }
	        // don't do it if not editable
	        if (!this.isCellEditable()) {
	            return;
	        }
	        // don't do it if already editing
	        if (this.editingCell) {
	            return;
	        }
	        this.editingCell = true;
	        this.cellEditorVersion++;
	        var callback = this.afterCellEditorCreated.bind(this, this.cellEditorVersion);
	        var params = this.createCellEditorParams(keyPress, charPress, cellStartedEdit);
	        this.createCellEditor(params).then(callback);
	        // if we don't do this, and editor component is async, then there will be a period
	        // when the component isn't present and keyboard navigation won't work - so example
	        // of user hitting tab quickly (more quickly than renderers getting created) won't work
	        var cellEditorAsync = utils_1._.missing(this.cellEditor);
	        if (cellEditorAsync && cellStartedEdit) {
	            this.focusCell(true);
	        }
	    };
	    CellComp.prototype.createCellEditor = function (params) {
	        var _this = this;
	        var cellEditorPromise = this.beans.userComponentFactory.newCellEditor(this.column.getColDef(), params);
	        return cellEditorPromise.map(function (cellEditor) {
	            var isPopup = cellEditor.isPopup && cellEditor.isPopup();
	            if (!isPopup) {
	                return cellEditor;
	            }
	            if (_this.beans.gridOptionsWrapper.isFullRowEdit()) {
	                console.warn('ag-Grid: popup cellEditor does not work with fullRowEdit - you cannot use them both ' +
	                    '- either turn off fullRowEdit, or stop using popup editors.');
	            }
	            // if a popup, then we wrap in a popup editor and return the popup
	            var popupEditorWrapper = new popupEditorWrapper_1.PopupEditorWrapper(cellEditor);
	            _this.beans.context.wireBean(popupEditorWrapper);
	            popupEditorWrapper.init(params);
	            return popupEditorWrapper;
	        });
	    };
	    CellComp.prototype.afterCellEditorCreated = function (cellEditorVersion, cellEditor) {
	        // if editingCell=false, means user cancelled the editor before component was ready.
	        // if versionMismatch, then user cancelled the edit, then started the edit again, and this
	        //   is the first editor which is now stale.
	        var versionMismatch = cellEditorVersion !== this.cellEditorVersion;
	        if (versionMismatch || !this.editingCell) {
	            if (cellEditor.destroy) {
	                cellEditor.destroy();
	            }
	            return;
	        }
	        if (cellEditor.isCancelBeforeStart && cellEditor.isCancelBeforeStart()) {
	            if (cellEditor.destroy) {
	                cellEditor.destroy();
	            }
	            this.editingCell = false;
	            return;
	        }
	        if (!cellEditor.getGui) {
	            console.warn("ag-Grid: cellEditor for column " + this.column.getId() + " is missing getGui() method");
	            // no getGui, for React guys, see if they attached a react component directly
	            if (cellEditor.render) {
	                console.warn("ag-Grid: we found 'render' on the component, are you trying to set a React renderer but added it as colDef.cellEditor instead of colDef.cellEditorFmk?");
	            }
	            if (cellEditor.destroy) {
	                cellEditor.destroy();
	            }
	            this.editingCell = false;
	            return;
	        }
	        this.cellEditor = cellEditor;
	        this.cellEditorInPopup = cellEditor.isPopup !== undefined && cellEditor.isPopup();
	        this.setInlineEditingClass();
	        if (this.cellEditorInPopup) {
	            this.addPopupCellEditor();
	        }
	        else {
	            this.addInCellEditor();
	        }
	        if (cellEditor.afterGuiAttached) {
	            cellEditor.afterGuiAttached();
	        }
	        var event = this.createEvent(null, events_1.Events.EVENT_CELL_EDITING_STARTED);
	        this.beans.eventService.dispatchEvent(event);
	    };
	    CellComp.prototype.addInCellEditor = function () {
	        utils_1._.clearElement(this.getGui());
	        if (this.cellEditor) {
	            this.getGui().appendChild(this.cellEditor.getGui());
	        }
	        this.angular1Compile();
	    };
	    CellComp.prototype.addPopupCellEditor = function () {
	        var _this = this;
	        var ePopupGui = this.cellEditor ? this.cellEditor.getGui() : null;
	        this.hideEditorPopup = this.beans.popupService.addAsModalPopup(ePopupGui, true, 
	        // callback for when popup disappears
	        function () {
	            _this.onPopupEditorClosed();
	        });
	        this.beans.popupService.positionPopupOverComponent({
	            column: this.column,
	            rowNode: this.rowNode,
	            type: 'popupCellEditor',
	            eventSource: this.getGui(),
	            ePopup: ePopupGui,
	            keepWithinBounds: true
	        });
	        this.angular1Compile();
	    };
	    CellComp.prototype.onPopupEditorClosed = function () {
	        // we only call stopEditing if we are editing, as
	        // it's possible the popup called 'stop editing'
	        // before this, eg if 'enter key' was pressed on
	        // the editor.
	        if (this.editingCell) {
	            // note: this only happens when use clicks outside of the grid. if use clicks on another
	            // cell, then the editing will have already stopped on this cell
	            this.stopRowOrCellEdit();
	            // we only focus cell again if this cell is still focused. it is possible
	            // it is not focused if the user cancelled the edit by clicking on another
	            // cell outside of this one
	            if (this.beans.focusedCellController.isCellFocused(this.cellPosition)) {
	                this.focusCell(true);
	            }
	        }
	    };
	    // if we are editing inline, then we don't have the padding in the cell (set in the themes)
	    // to allow the text editor full access to the entire cell
	    CellComp.prototype.setInlineEditingClass = function () {
	        // ag-cell-inline-editing - appears when user is inline editing
	        // ag-cell-not-inline-editing - appears when user is no inline editing
	        // ag-cell-popup-editing - appears when user is editing cell in popup (appears on the cell, not on the popup)
	        // note: one of {ag-cell-inline-editing, ag-cell-not-inline-editing} is always present, they toggle.
	        //       however {ag-cell-popup-editing} shows when popup, so you have both {ag-cell-popup-editing}
	        //       and {ag-cell-not-inline-editing} showing at the same time.
	        var editingInline = this.editingCell && !this.cellEditorInPopup;
	        var popupEditorShowing = this.editingCell && this.cellEditorInPopup;
	        utils_1._.addOrRemoveCssClass(this.getGui(), "ag-cell-inline-editing", editingInline);
	        utils_1._.addOrRemoveCssClass(this.getGui(), "ag-cell-not-inline-editing", !editingInline);
	        utils_1._.addOrRemoveCssClass(this.getGui(), "ag-cell-popup-editing", popupEditorShowing);
	        utils_1._.addOrRemoveCssClass(this.getGui().parentNode, "ag-row-inline-editing", editingInline);
	        utils_1._.addOrRemoveCssClass(this.getGui().parentNode, "ag-row-not-inline-editing", !editingInline);
	    };
	    CellComp.prototype.createCellEditorParams = function (keyPress, charPress, cellStartedEdit) {
	        var params = {
	            value: this.getValue(),
	            keyPress: keyPress,
	            charPress: charPress,
	            column: this.column,
	            colDef: this.column.getColDef(),
	            rowIndex: this.cellPosition.rowIndex,
	            node: this.rowNode,
	            data: this.rowNode.data,
	            api: this.beans.gridOptionsWrapper.getApi(),
	            cellStartedEdit: cellStartedEdit,
	            columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
	            context: this.beans.gridOptionsWrapper.getContext(),
	            $scope: this.scope,
	            onKeyDown: this.onKeyDown.bind(this),
	            stopEditing: this.stopEditingAndFocus.bind(this),
	            eGridCell: this.getGui(),
	            parseValue: this.parseValue.bind(this),
	            formatValue: this.formatValue.bind(this)
	        };
	        return params;
	    };
	    // cell editors call this, when they want to stop for reasons other
	    // than what we pick up on. eg selecting from a dropdown ends editing.
	    CellComp.prototype.stopEditingAndFocus = function (suppressNavigateAfterEdit) {
	        if (suppressNavigateAfterEdit === void 0) { suppressNavigateAfterEdit = false; }
	        this.stopRowOrCellEdit();
	        this.focusCell(true);
	        if (!suppressNavigateAfterEdit) {
	            this.navigateAfterEdit();
	        }
	    };
	    CellComp.prototype.parseValue = function (newValue) {
	        var colDef = this.getComponentHolder();
	        var params = {
	            node: this.rowNode,
	            data: this.rowNode.data,
	            oldValue: this.value,
	            newValue: newValue,
	            colDef: colDef,
	            column: this.column,
	            api: this.beans.gridOptionsWrapper.getApi(),
	            columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
	            context: this.beans.gridOptionsWrapper.getContext()
	        };
	        var valueParser = colDef.valueParser;
	        return utils_1._.exists(valueParser) ? this.beans.expressionService.evaluate(valueParser, params) : newValue;
	    };
	    CellComp.prototype.focusCell = function (forceBrowserFocus) {
	        if (forceBrowserFocus === void 0) { forceBrowserFocus = false; }
	        this.beans.focusedCellController.setFocusedCell(this.cellPosition.rowIndex, this.column, this.rowNode.rowPinned, forceBrowserFocus);
	    };
	    CellComp.prototype.setFocusInOnEditor = function () {
	        if (this.editingCell) {
	            if (this.cellEditor && this.cellEditor.focusIn) {
	                // if the editor is present, then we just focus it
	                this.cellEditor.focusIn();
	            }
	            else {
	                // if the editor is not present, it means async cell editor (eg React fibre)
	                // and we are trying to set focus before the cell editor is present, so we
	                // focus the cell instead
	                this.focusCell(true);
	            }
	        }
	    };
	    CellComp.prototype.isEditing = function () {
	        return this.editingCell;
	    };
	    CellComp.prototype.onKeyDown = function (event) {
	        var key = event.which || event.keyCode;
	        switch (key) {
	            case constants_1.Constants.KEY_ENTER:
	                this.onEnterKeyDown();
	                break;
	            case constants_1.Constants.KEY_F2:
	                this.onF2KeyDown();
	                break;
	            case constants_1.Constants.KEY_ESCAPE:
	                this.onEscapeKeyDown();
	                break;
	            case constants_1.Constants.KEY_TAB:
	                this.onTabKeyDown(event);
	                break;
	            case constants_1.Constants.KEY_BACKSPACE:
	            case constants_1.Constants.KEY_DELETE:
	                this.onBackspaceOrDeleteKeyPressed(key);
	                break;
	            case constants_1.Constants.KEY_DOWN:
	            case constants_1.Constants.KEY_UP:
	            case constants_1.Constants.KEY_RIGHT:
	            case constants_1.Constants.KEY_LEFT:
	                this.onNavigationKeyPressed(event, key);
	                break;
	        }
	    };
	    CellComp.prototype.setFocusOutOnEditor = function () {
	        if (this.editingCell && this.cellEditor && this.cellEditor.focusOut) {
	            this.cellEditor.focusOut();
	        }
	    };
	    CellComp.prototype.onNavigationKeyPressed = function (event, key) {
	        if (this.editingCell) {
	            return;
	        }
	        if (event.shiftKey && this.rangeSelectionEnabled) {
	            this.onShiftRangeSelect(key);
	        }
	        else {
	            this.beans.rowRenderer.navigateToNextCell(event, key, this.cellPosition, true);
	        }
	        // if we don't prevent default, the grid will scroll with the navigation keys
	        event.preventDefault();
	    };
	    CellComp.prototype.onShiftRangeSelect = function (key) {
	        var endCell = this.beans.rangeController.extendLatestRangeInDirection(key);
	        if (endCell) {
	            this.beans.rowRenderer.ensureCellVisible(endCell);
	        }
	    };
	    CellComp.prototype.onTabKeyDown = function (event) {
	        this.beans.rowRenderer.onTabKeyDown(this, event);
	    };
	    CellComp.prototype.onBackspaceOrDeleteKeyPressed = function (key) {
	        if (!this.editingCell) {
	            this.startRowOrCellEdit(key);
	        }
	    };
	    CellComp.prototype.onEnterKeyDown = function () {
	        if (this.editingCell || this.rowComp.isEditing()) {
	            this.stopEditingAndFocus();
	        }
	        else {
	            if (this.beans.gridOptionsWrapper.isEnterMovesDown()) {
	                this.beans.rowRenderer.navigateToNextCell(null, constants_1.Constants.KEY_DOWN, this.cellPosition, false);
	            }
	            else {
	                this.startRowOrCellEdit(constants_1.Constants.KEY_ENTER);
	            }
	        }
	    };
	    CellComp.prototype.navigateAfterEdit = function () {
	        var fullRowEdit = this.beans.gridOptionsWrapper.isFullRowEdit();
	        if (fullRowEdit) {
	            return;
	        }
	        var enterMovesDownAfterEdit = this.beans.gridOptionsWrapper.isEnterMovesDownAfterEdit();
	        if (enterMovesDownAfterEdit) {
	            this.beans.rowRenderer.navigateToNextCell(null, constants_1.Constants.KEY_DOWN, this.cellPosition, false);
	        }
	    };
	    CellComp.prototype.onF2KeyDown = function () {
	        if (!this.editingCell) {
	            this.startRowOrCellEdit(constants_1.Constants.KEY_F2);
	        }
	    };
	    CellComp.prototype.onEscapeKeyDown = function () {
	        if (this.editingCell) {
	            this.stopRowOrCellEdit(true);
	            this.focusCell(true);
	        }
	    };
	    CellComp.prototype.onKeyPress = function (event) {
	        // check this, in case focus is on a (for example) a text field inside the cell,
	        // in which cse we should not be listening for these key pressed
	        var eventTarget = utils_1._.getTarget(event);
	        var eventOnChildComponent = eventTarget !== this.getGui();
	        if (eventOnChildComponent || this.editingCell) {
	            return;
	        }
	        var pressedChar = String.fromCharCode(event.charCode);
	        if (pressedChar === ' ') {
	            this.onSpaceKeyPressed(event);
	        }
	        else {
	            if (utils_1._.isEventFromPrintableCharacter(event)) {
	                this.startRowOrCellEdit(null, pressedChar);
	                // if we don't prevent default, then the keypress also gets applied to the text field
	                // (at least when doing the default editor), but we need to allow the editor to decide
	                // what it wants to do. we only do this IF editing was started - otherwise it messes
	                // up when the use is not doing editing, but using rendering with text fields in cellRenderer
	                // (as it would block the the user from typing into text fields).
	                event.preventDefault();
	            }
	        }
	    };
	    CellComp.prototype.onSpaceKeyPressed = function (event) {
	        if (!this.editingCell && this.beans.gridOptionsWrapper.isRowSelection()) {
	            var selected = this.rowNode.isSelected();
	            this.rowNode.setSelected(!selected);
	        }
	        // prevent default as space key, by default, moves browser scroll down
	        event.preventDefault();
	    };
	    CellComp.prototype.onMouseDown = function (mouseEvent) {
	        // we only need to pass true to focusCell in when the browser is IE
	        // and we are trying to focus a cell (has ag-cell class), otherwise
	        // we pass false, as we don't want the cell to focus also get the browser
	        // focus. if we did, then the cellRenderer could have a text field in it,
	        // for example, and as the user clicks on the text field, the text field,
	        // the focus doesn't get to the text field, instead to goes to the div
	        // behind, making it impossible to select the text field.
	        var forceBrowserFocus = false;
	        var button = mouseEvent.button, ctrlKey = mouseEvent.ctrlKey, metaKey = mouseEvent.metaKey, shiftKey = mouseEvent.shiftKey, target = mouseEvent.target;
	        var _a = this.beans, eventService = _a.eventService, rangeController = _a.rangeController;
	        if (rangeController) {
	            var cellInRange = rangeController.isCellInAnyRange(this.getCellPosition());
	            if (cellInRange && button === 2) {
	                return;
	            }
	        }
	        if (utils_1._.isBrowserIE()) {
	            if (target.classList.contains('ag-cell')) {
	                forceBrowserFocus = true;
	            }
	        }
	        if (!shiftKey || (rangeController && !rangeController.getCellRanges().length)) {
	            this.focusCell(forceBrowserFocus);
	        }
	        else {
	            // if a range is being changed, we need to make sure the focused cell does not change.
	            mouseEvent.preventDefault();
	        }
	        // if we are clicking on a checkbox, we need to make sure the cell wrapping that checkbox
	        // is focused but we don't want to change the range selection, so return here.
	        if (utils_1._.isElementChildOfClass(target, 'ag-selection-checkbox', 3)) {
	            return;
	        }
	        // if it's a right click, then if the cell is already in range,
	        // don't change the range, however if the cell is not in a range,
	        // we set a new range
	        var leftMouseButtonClick = utils_1._.isLeftClick(mouseEvent);
	        if (leftMouseButtonClick && rangeController) {
	            var thisCell = this.cellPosition;
	            if (shiftKey) {
	                rangeController.extendLatestRangeToCell(thisCell);
	            }
	            else {
	                var ctrlKeyPressed = ctrlKey || metaKey;
	                rangeController.setRangeToCell(thisCell, ctrlKeyPressed);
	            }
	        }
	        var cellMouseDownEvent = this.createEvent(mouseEvent, events_1.Events.EVENT_CELL_MOUSE_DOWN);
	        eventService.dispatchEvent(cellMouseDownEvent);
	    };
	    // returns true if on iPad and this is second 'click' event in 200ms
	    CellComp.prototype.isDoubleClickOnIPad = function () {
	        if (!utils_1._.isUserAgentIPad()) {
	            return false;
	        }
	        var nowMillis = new Date().getTime();
	        var res = nowMillis - this.lastIPadMouseClickEvent < 200;
	        this.lastIPadMouseClickEvent = nowMillis;
	        return res;
	    };
	    CellComp.prototype.onCellClicked = function (mouseEvent) {
	        // iPad doesn't have double click - so we need to mimic it do enable editing for
	        // iPad.
	        if (this.isDoubleClickOnIPad()) {
	            this.onCellDoubleClicked(mouseEvent);
	            mouseEvent.preventDefault(); // if we don't do this, then iPad zooms in
	            return;
	        }
	        var cellClickedEvent = this.createEvent(mouseEvent, events_1.Events.EVENT_CELL_CLICKED);
	        this.beans.eventService.dispatchEvent(cellClickedEvent);
	        var colDef = this.getComponentHolder();
	        if (colDef.onCellClicked) {
	            // to make callback async, do in a timeout
	            window.setTimeout(function () { return colDef.onCellClicked(cellClickedEvent); }, 0);
	        }
	        var editOnSingleClick = (this.beans.gridOptionsWrapper.isSingleClickEdit() || colDef.singleClickEdit)
	            && !this.beans.gridOptionsWrapper.isSuppressClickEdit();
	        if (editOnSingleClick) {
	            this.startRowOrCellEdit();
	        }
	        utils_1._.doIeFocusHack(this.getGui());
	    };
	    CellComp.prototype.createGridCellVo = function () {
	        this.cellPosition = {
	            rowIndex: this.rowNode.rowIndex,
	            rowPinned: this.rowNode.rowPinned,
	            column: this.column
	        };
	    };
	    CellComp.prototype.getCellPosition = function () {
	        return this.cellPosition;
	    };
	    CellComp.prototype.getParentRow = function () {
	        return this.eParentRow;
	    };
	    CellComp.prototype.setParentRow = function (eParentRow) {
	        this.eParentRow = eParentRow;
	    };
	    CellComp.prototype.getColumn = function () {
	        return this.column;
	    };
	    CellComp.prototype.getComponentHolder = function () {
	        return this.column.getColDef();
	    };
	    CellComp.prototype.detach = function () {
	        this.eParentRow.removeChild(this.getGui());
	    };
	    // if the row is also getting destroyed, then we don't need to remove from dom,
	    // as the row will also get removed, so no need to take out the cells from the row
	    // if the row is going (removing is an expensive operation, so only need to remove
	    // the top part)
	    CellComp.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        if (this.cellEditor && this.cellEditor.destroy) {
	            this.cellEditor.destroy();
	            this.cellEditor = null;
	        }
	        if (this.cellRenderer && this.cellRenderer.destroy) {
	            this.cellRenderer.destroy();
	            this.cellRenderer = null;
	        }
	        if (this.selectionHandle) {
	            this.selectionHandle.destroy();
	        }
	    };
	    CellComp.prototype.onLeftChanged = function () {
	        var left = this.modifyLeftForPrintLayout(this.getCellLeft());
	        this.getGui().style.left = left + 'px';
	    };
	    CellComp.prototype.modifyLeftForPrintLayout = function (leftPosition) {
	        if (!this.printLayout) {
	            return leftPosition;
	        }
	        if (this.column.getPinned() === column_1.Column.PINNED_LEFT) {
	            return leftPosition;
	        }
	        if (this.column.getPinned() === column_1.Column.PINNED_RIGHT) {
	            var leftWidth_1 = this.beans.columnController.getPinnedLeftContainerWidth();
	            var bodyWidth = this.beans.columnController.getBodyContainerWidth();
	            return leftWidth_1 + bodyWidth + leftPosition;
	        }
	        // is in body
	        var leftWidth = this.beans.columnController.getPinnedLeftContainerWidth();
	        return leftWidth + leftPosition;
	    };
	    CellComp.prototype.onWidthChanged = function () {
	        var width = this.getCellWidth();
	        this.getGui().style.width = width + 'px';
	    };
	    CellComp.prototype.getRangeBorders = function () {
	        var _this = this;
	        var isRtl = this.beans.gridOptionsWrapper.isEnableRtl();
	        var top = false;
	        var right = false;
	        var bottom = false;
	        var left = false;
	        var thisCol = this.cellPosition.column;
	        var rangeController = this.beans.rangeController;
	        var leftCol;
	        var rightCol;
	        if (isRtl) {
	            leftCol = this.beans.columnController.getDisplayedColAfter(thisCol);
	            rightCol = this.beans.columnController.getDisplayedColBefore(thisCol);
	        }
	        else {
	            leftCol = this.beans.columnController.getDisplayedColBefore(thisCol);
	            rightCol = this.beans.columnController.getDisplayedColAfter(thisCol);
	        }
	        var ranges = rangeController.getCellRanges().filter(function (range) { return rangeController.isCellInSpecificRange(_this.cellPosition, range); });
	        // this means we are the first column in the grid
	        if (!leftCol) {
	            left = true;
	        }
	        // this means we are the last column in the grid
	        if (!rightCol) {
	            right = true;
	        }
	        for (var i = 0; i < ranges.length; i++) {
	            if (top && right && bottom && left) {
	                break;
	            }
	            var range = ranges[i];
	            var startRow = rangeController.getRangeStartRow(range);
	            var endRow = rangeController.getRangeEndRow(range);
	            if (!top && this.beans.rowPositionUtils.sameRow(startRow, this.cellPosition)) {
	                top = true;
	            }
	            if (!bottom && this.beans.rowPositionUtils.sameRow(endRow, this.cellPosition)) {
	                bottom = true;
	            }
	            if (!left && range.columns.indexOf(leftCol) < 0) {
	                left = true;
	            }
	            if (!right && range.columns.indexOf(rightCol) < 0) {
	                right = true;
	            }
	        }
	        return { top: top, right: right, bottom: bottom, left: left };
	    };
	    CellComp.prototype.getInitialRangeClasses = function () {
	        var res = [];
	        if (!this.rangeSelectionEnabled || !this.rangeCount) {
	            return res;
	        }
	        var beans = this.beans;
	        var rangeController = beans.rangeController;
	        res.push('ag-cell-range-selected');
	        if (this.hasChartRange) {
	            res.push('ag-cell-range-chart');
	        }
	        var count = Math.min(this.rangeCount, 4);
	        res.push("ag-cell-range-selected-" + count);
	        if (this.rangeCount === 1 && !rangeController.isMoreThanOneCell()) {
	            res.push('ag-cell-range-single-cell');
	        }
	        if (this.rangeCount > 0) {
	            var borders = this.getRangeBorders();
	            if (borders.top) {
	                res.push('ag-cell-range-top');
	            }
	            if (borders.right) {
	                res.push('ag-cell-range-right');
	            }
	            if (borders.bottom) {
	                res.push('ag-cell-range-bottom');
	            }
	            if (borders.left) {
	                res.push('ag-cell-range-left');
	            }
	        }
	        if (!!this.selectionHandle) {
	            res.push('ag-cell-range-handle');
	        }
	        return res;
	    };
	    CellComp.prototype.onRowIndexChanged = function () {
	        // when index changes, this influences items that need the index, so we update the
	        // grid cell so they are working off the new index.
	        this.createGridCellVo();
	        // when the index of the row changes, ie means the cell may have lost or gained focus
	        this.onCellFocused();
	        // check range selection
	        this.onRangeSelectionChanged();
	    };
	    CellComp.prototype.onRangeSelectionChanged = function () {
	        if (!this.beans.enterprise) {
	            return;
	        }
	        var _a = this, beans = _a.beans, cellPosition = _a.cellPosition, rangeCount = _a.rangeCount;
	        var rangeController = beans.rangeController;
	        var newRangeCount = rangeController.getCellRangeCount(cellPosition);
	        var element = this.getGui();
	        if (rangeCount !== newRangeCount) {
	            utils_1._.addOrRemoveCssClass(element, 'ag-cell-range-selected', newRangeCount !== 0);
	            utils_1._.addOrRemoveCssClass(element, 'ag-cell-range-selected-1', newRangeCount === 1);
	            utils_1._.addOrRemoveCssClass(element, 'ag-cell-range-selected-2', newRangeCount === 2);
	            utils_1._.addOrRemoveCssClass(element, 'ag-cell-range-selected-3', newRangeCount === 3);
	            utils_1._.addOrRemoveCssClass(element, 'ag-cell-range-selected-4', newRangeCount >= 4);
	            this.rangeCount = newRangeCount;
	        }
	        var hasChartRange = this.rangeCount && rangeController.getCellRanges().every(function (range) { return utils_1._.exists(range.type); });
	        if (this.hasChartRange !== hasChartRange) {
	            utils_1._.addOrRemoveCssClass(element, 'ag-cell-range-chart', hasChartRange);
	            this.hasChartRange = hasChartRange;
	        }
	        this.updateRangeBorders();
	        var isSingleCell = this.rangeCount === 1 && !rangeController.isMoreThanOneCell();
	        utils_1._.addOrRemoveCssClass(element, 'ag-cell-range-single-cell', isSingleCell);
	        this.refreshHandle();
	        utils_1._.addOrRemoveCssClass(element, 'ag-cell-range-handle', !!this.selectionHandle);
	    };
	    CellComp.prototype.shouldHaveSelectionHandle = function () {
	        var _a = this.beans, gridOptionsWrapper = _a.gridOptionsWrapper, rangeController = _a.rangeController;
	        var el = this.getGui();
	        var cellRanges = rangeController.getCellRanges();
	        var rangesLen = cellRanges.length;
	        if (!rangesLen) {
	            return false;
	        }
	        var lastRange = utils_1._.last(cellRanges);
	        var isFirstRangeCategory = cellRanges[0].type === iRangeController_1.CellRangeType.DIMENSION;
	        var handlesAllowed = (gridOptionsWrapper.isEnableFillHandle() ||
	            gridOptionsWrapper.isEnableRangeHandle() ||
	            this.hasChartRange && !isFirstRangeCategory) && rangesLen === 1;
	        if (!handlesAllowed && this.hasChartRange) {
	            var cellPosition = this.getCellPosition();
	            handlesAllowed =
	                isFirstRangeCategory &&
	                    rangesLen === 2 &&
	                    rangeController.isCellInSpecificRange(this.getCellPosition(), lastRange);
	            var isCategory = isFirstRangeCategory &&
	                rangeController.isCellInSpecificRange(cellPosition, cellRanges[0]);
	            utils_1._.addOrRemoveCssClass(el, 'ag-cell-range-chart-category', isCategory);
	        }
	        return this.rangeCount &&
	            handlesAllowed &&
	            lastRange.endRow != null &&
	            this.beans.rangeController.isContiguousRange(lastRange) &&
	            (utils_1._.containsClass(el, 'ag-cell-range-single-cell') ||
	                (utils_1._.containsClass(el, 'ag-cell-range-bottom') && utils_1._.containsClass(el, 'ag-cell-range-right')));
	    };
	    CellComp.prototype.addSelectionHandle = function () {
	        var _a = this.beans, gridOptionsWrapper = _a.gridOptionsWrapper, context = _a.context, rangeController = _a.rangeController;
	        var cellRangeType = utils_1._.last(rangeController.getCellRanges()).type;
	        var type = (gridOptionsWrapper.isEnableFillHandle() && utils_1._.missing(cellRangeType)) ? 'fill' : 'range';
	        if (this.selectionHandle && this.selectionHandle.getType() !== type) {
	            this.selectionHandle.destroy();
	            this.selectionHandle = undefined;
	        }
	        if (!this.selectionHandle) {
	            this.selectionHandle = context.createComponentFromElement(document.createElement("ag-" + type + "-handle"));
	        }
	        this.selectionHandle.refresh(this);
	    };
	    CellComp.prototype.updateRangeBordersIfRangeCount = function () {
	        // we only need to update range borders if we are in a range
	        if (this.rangeCount > 0) {
	            this.updateRangeBorders();
	            this.refreshHandle();
	        }
	    };
	    CellComp.prototype.refreshHandle = function () {
	        var shouldHaveSelectionHandle = this.shouldHaveSelectionHandle();
	        if (this.selectionHandle && !shouldHaveSelectionHandle) {
	            this.selectionHandle.destroy();
	            this.selectionHandle = null;
	        }
	        if (shouldHaveSelectionHandle) {
	            this.addSelectionHandle();
	        }
	    };
	    CellComp.prototype.updateRangeBorders = function () {
	        var rangeBorders = this.getRangeBorders();
	        var isSingleCell = this.rangeCount === 1 && !this.beans.rangeController.isMoreThanOneCell();
	        var isTop = !isSingleCell && rangeBorders.top;
	        var isRight = !isSingleCell && rangeBorders.right;
	        var isBottom = !isSingleCell && rangeBorders.bottom;
	        var isLeft = !isSingleCell && rangeBorders.left;
	        var element = this.getGui();
	        utils_1._.addOrRemoveCssClass(element, 'ag-cell-range-top', isTop);
	        utils_1._.addOrRemoveCssClass(element, 'ag-cell-range-right', isRight);
	        utils_1._.addOrRemoveCssClass(element, 'ag-cell-range-bottom', isBottom);
	        utils_1._.addOrRemoveCssClass(element, 'ag-cell-range-left', isLeft);
	    };
	    CellComp.prototype.onFirstRightPinnedChanged = function () {
	        var firstRightPinned = this.column.isFirstRightPinned();
	        if (this.firstRightPinned !== firstRightPinned) {
	            this.firstRightPinned = firstRightPinned;
	            utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-cell-first-right-pinned', firstRightPinned);
	        }
	    };
	    CellComp.prototype.onLastLeftPinnedChanged = function () {
	        var lastLeftPinned = this.column.isLastLeftPinned();
	        if (this.lastLeftPinned !== lastLeftPinned) {
	            this.lastLeftPinned = lastLeftPinned;
	            utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-cell-last-left-pinned', lastLeftPinned);
	        }
	    };
	    CellComp.prototype.populateTemplate = function () {
	        if (this.usingWrapper) {
	            this.eParentOfValue = this.getRefElement('eCellValue');
	            this.eCellWrapper = this.getRefElement('eCellWrapper');
	            if (this.includeRowDraggingComponent) {
	                this.addRowDragging();
	            }
	            if (this.includeDndSourceComponent) {
	                this.addDndSource();
	            }
	            if (this.includeSelectionComponent) {
	                this.addSelectionCheckbox();
	            }
	        }
	        else {
	            this.eParentOfValue = this.getGui();
	        }
	    };
	    CellComp.prototype.getFrameworkOverrides = function () {
	        return this.beans.frameworkOverrides;
	    };
	    CellComp.prototype.addRowDragging = function () {
	        var pagination = this.beans.gridOptionsWrapper.isPagination();
	        var rowDragManaged = this.beans.gridOptionsWrapper.isRowDragManaged();
	        var clientSideRowModelActive = this.beans.gridOptionsWrapper.isRowModelDefault();
	        if (rowDragManaged) {
	            // row dragging only available in default row model
	            if (!clientSideRowModelActive) {
	                utils_1._.doOnce(function () { return console.warn('ag-Grid: managed row dragging is only allowed in the Client Side Row Model'); }, 'CellComp.addRowDragging');
	                return;
	            }
	            if (pagination) {
	                utils_1._.doOnce(function () { return console.warn('ag-Grid: managed row dragging is not possible when doing pagination'); }, 'CellComp.addRowDragging');
	                return;
	            }
	        }
	        var rowDraggingComp = new rowDragComp_1.RowDragComp(this.rowNode, this.column, this.getValueToUse(), this.beans);
	        this.addFeature(this.beans.context, rowDraggingComp);
	        // put the checkbox in before the value
	        this.eCellWrapper.insertBefore(rowDraggingComp.getGui(), this.eParentOfValue);
	    };
	    CellComp.prototype.addDndSource = function () {
	        var dndSourceComp = new dndSourceComp_1.DndSourceComp(this.rowNode, this.column, this.getValueToUse(), this.beans, this.getGui());
	        this.addFeature(this.beans.context, dndSourceComp);
	        // put the checkbox in before the value
	        this.eCellWrapper.insertBefore(dndSourceComp.getGui(), this.eParentOfValue);
	    };
	    CellComp.prototype.addSelectionCheckbox = function () {
	        var cbSelectionComponent = new checkboxSelectionComponent_1.CheckboxSelectionComponent();
	        this.beans.context.wireBean(cbSelectionComponent);
	        var visibleFunc = this.getComponentHolder().checkboxSelection;
	        visibleFunc = typeof visibleFunc === 'function' ? visibleFunc : null;
	        cbSelectionComponent.init({ rowNode: this.rowNode, column: this.column, visibleFunc: visibleFunc });
	        this.addDestroyFunc(function () { return cbSelectionComponent.destroy(); });
	        // put the checkbox in before the value
	        this.eCellWrapper.insertBefore(cbSelectionComponent.getGui(), this.eParentOfValue);
	    };
	    CellComp.prototype.addDomData = function () {
	        var _this = this;
	        var element = this.getGui();
	        this.beans.gridOptionsWrapper.setDomData(element, CellComp.DOM_DATA_KEY_CELL_COMP, this);
	        this.addDestroyFunc(function () {
	            return _this.beans.gridOptionsWrapper.setDomData(element, CellComp.DOM_DATA_KEY_CELL_COMP, null);
	        });
	    };
	    CellComp.prototype.onCellFocused = function (event) {
	        var cellFocused = this.beans.focusedCellController.isCellFocused(this.cellPosition);
	        // see if we need to change the classes on this cell
	        if (cellFocused !== this.cellFocused) {
	            // if we are not doing cell selection, then the focus class does not change
	            var doingFocusCss = !this.beans.gridOptionsWrapper.isSuppressCellSelection();
	            if (doingFocusCss) {
	                utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-cell-focus', cellFocused);
	            }
	            this.cellFocused = cellFocused;
	        }
	        // if this cell was just focused, see if we need to force browser focus, his can
	        // happen if focus is programmatically set.
	        if (cellFocused && event && event.forceBrowserFocus) {
	            var eGui = this.getGui();
	            eGui.focus();
	            utils_1._.doIeFocusHack(eGui);
	        }
	        // if another cell was focused, and we are editing, then stop editing
	        var fullRowEdit = this.beans.gridOptionsWrapper.isFullRowEdit();
	        if (!cellFocused && !fullRowEdit && this.editingCell) {
	            this.stopRowOrCellEdit();
	        }
	    };
	    // pass in 'true' to cancel the editing.
	    CellComp.prototype.stopRowOrCellEdit = function (cancel) {
	        if (cancel === void 0) { cancel = false; }
	        if (this.beans.gridOptionsWrapper.isFullRowEdit()) {
	            this.rowComp.stopRowEditing(cancel);
	        }
	        else {
	            this.stopEditing(cancel);
	        }
	    };
	    CellComp.prototype.stopEditing = function (cancel) {
	        if (cancel === void 0) { cancel = false; }
	        if (!this.editingCell) {
	            return;
	        }
	        // if no cell editor, this means due to async, that the cell editor never got initialised,
	        // so we just carry on regardless as if the editing was never started.
	        if (!this.cellEditor) {
	            this.editingCell = false;
	            return;
	        }
	        var newValueExists = false;
	        var newValue;
	        if (!cancel) {
	            // also have another option here to cancel after editing, so for example user could have a popup editor and
	            // it is closed by user clicking outside the editor. then the editor will close automatically (with false
	            // passed above) and we need to see if the editor wants to accept the new value.
	            var userWantsToCancel = this.cellEditor.isCancelAfterEnd && this.cellEditor.isCancelAfterEnd();
	            if (!userWantsToCancel) {
	                newValue = this.cellEditor.getValue();
	                newValueExists = true;
	            }
	        }
	        // it is important we set this after setValue() above, as otherwise the cell will flash
	        // when editing stops. the 'refresh' method checks editing, and doesn't refresh editing cells.
	        // thus it will skip the refresh on this cell until the end of this method where we call
	        // refresh directly and we suppress the flash.
	        this.editingCell = false;
	        if (this.cellEditor.destroy) {
	            this.cellEditor.destroy();
	        }
	        // important to clear this out - as parts of the code will check for
	        // this to see if an async cellEditor has yet to be created
	        this.cellEditor = null;
	        if (this.cellEditorInPopup && this.hideEditorPopup) {
	            this.hideEditorPopup();
	            this.hideEditorPopup = null;
	        }
	        else {
	            utils_1._.clearElement(this.getGui());
	            // put the cell back the way it was before editing
	            if (this.usingWrapper) {
	                // if wrapper, then put the wrapper back
	                this.getGui().appendChild(this.eCellWrapper);
	            }
	            else {
	                // if cellRenderer, then put the gui back in. if the renderer has
	                // a refresh, it will be called. however if it doesn't, then later
	                // the renderer will be destroyed and a new one will be created.
	                if (this.cellRenderer) {
	                    // we know it's a dom element (not a string) because we converted
	                    // it after the gui was attached if it was a string.
	                    var eCell = this.cellRendererGui;
	                    // can be null if cell was previously null / contained empty string,
	                    // this will result in new value not being rendered.
	                    if (eCell) {
	                        this.getGui().appendChild(eCell);
	                    }
	                }
	            }
	        }
	        this.setInlineEditingClass();
	        if (newValueExists) {
	            // we suppressRefreshCell because the call to rowNode.setDataValue() results in change detection
	            // getting triggered, which results in all cells getting refreshed. we do not want this refresh
	            // to happen on this call as we want to call it explicitly below. otherwise refresh gets called twice.
	            // if we only did this refresh (and not the one below) then the cell would flash and not be forced.
	            this.suppressRefreshCell = true;
	            this.rowNode.setDataValue(this.column, newValue);
	            this.suppressRefreshCell = false;
	        }
	        // we suppress the flash, as it is not correct to flash the cell the user has finished editing,
	        // the user doesn't need to flash as they were the one who did the edit, the flash is pointless
	        // (as the flash is meant to draw the user to a change that they didn't manually do themselves).
	        this.refreshCell({ forceRefresh: true, suppressFlash: true });
	        var event = this.createEvent(null, events_1.Events.EVENT_CELL_EDITING_STOPPED);
	        this.beans.eventService.dispatchEvent(event);
	    };
	    CellComp.DOM_DATA_KEY_CELL_COMP = 'cellComp';
	    CellComp.CELL_RENDERER_TYPE_NORMAL = 'cellRenderer';
	    CellComp.CELL_RENDERER_TYPE_PINNED = 'pinnedRowCellRenderer';
	    return CellComp;
	}(component_1.Component));
	exports.CellComp = CellComp;


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var eventService_1 = __webpack_require__(22);
	var context_1 = __webpack_require__(8);
	var events_1 = __webpack_require__(29);
	var beanStub_1 = __webpack_require__(71);
	var columnApi_1 = __webpack_require__(38);
	var gridApi_1 = __webpack_require__(33);
	var ColumnHoverService = /** @class */ (function (_super) {
	    __extends(ColumnHoverService, _super);
	    function ColumnHoverService() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ColumnHoverService.prototype.setMouseOver = function (columns) {
	        this.selectedColumns = columns;
	        var event = {
	            type: events_1.Events.EVENT_COLUMN_HOVER_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ColumnHoverService.prototype.clearMouseOver = function () {
	        this.selectedColumns = null;
	        var event = {
	            type: events_1.Events.EVENT_COLUMN_HOVER_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ColumnHoverService.prototype.isHovered = function (column) {
	        return this.selectedColumns && this.selectedColumns.indexOf(column) >= 0;
	    };
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], ColumnHoverService.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], ColumnHoverService.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], ColumnHoverService.prototype, "gridApi", void 0);
	    ColumnHoverService = __decorate([
	        context_1.Bean('columnHoverService')
	    ], ColumnHoverService);
	    return ColumnHoverService;
	}(beanStub_1.BeanStub));
	exports.ColumnHoverService = ColumnHoverService;


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var expressionService_1 = __webpack_require__(121);
	var ValueFormatterService = /** @class */ (function () {
	    function ValueFormatterService() {
	    }
	    ValueFormatterService.prototype.formatValue = function (column, rowNode, $scope, value) {
	        var formatter;
	        var colDef = column.getColDef();
	        // if floating, give preference to the floating formatter
	        if (rowNode && rowNode.rowPinned) {
	            formatter = colDef.pinnedRowValueFormatter ? colDef.pinnedRowValueFormatter : colDef.valueFormatter;
	        }
	        else {
	            formatter = colDef.valueFormatter;
	        }
	        var result = null;
	        if (formatter) {
	            var params = {
	                value: value,
	                node: rowNode,
	                data: rowNode ? rowNode.data : null,
	                colDef: column.getColDef(),
	                column: column,
	                api: this.gridOptionsWrapper.getApi(),
	                columnApi: this.gridOptionsWrapper.getColumnApi(),
	                context: this.gridOptionsWrapper.getContext()
	            };
	            // originally we put the angular 1 scope here, but we don't want the scope
	            // in the params interface, as other frameworks will see the interface, and
	            // angular 1 is not cool any more. so we hack the scope in here (we cannot
	            // include it above, as it's not in the interface, so would cause a compile error).
	            // in the future, when we stop supporting angular 1, we can take this out.
	            params.$scope = $scope;
	            result = this.expressionService.evaluate(formatter, params);
	        }
	        else if (colDef.refData) {
	            return colDef.refData[value] || '';
	        }
	        // if we don't do this, then arrays get displayed as 1,2,3, but we want 1, 2, 3 (ie with spaces)
	        if ((result === null || result === undefined) && Array.isArray(value)) {
	            result = value.join(', ');
	        }
	        return result;
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], ValueFormatterService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('expressionService'),
	        __metadata("design:type", expressionService_1.ExpressionService)
	    ], ValueFormatterService.prototype, "expressionService", void 0);
	    ValueFormatterService = __decorate([
	        context_1.Bean('valueFormatterService')
	    ], ValueFormatterService);
	    return ValueFormatterService;
	}());
	exports.ValueFormatterService = ValueFormatterService;


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var componentAnnotations_1 = __webpack_require__(39);
	var agAbstractField_1 = __webpack_require__(162);
	var utils_1 = __webpack_require__(10);
	var AgAbstractInputField = /** @class */ (function (_super) {
	    __extends(AgAbstractInputField, _super);
	    function AgAbstractInputField() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.config = {};
	        _this.TEMPLATE = "<div class=\"ag-input-field\" role=\"presentation\">\n            <label ref=\"eLabel\"></label>\n            <div ref=\"eWrapper\" class=\"ag-wrapper ag-input-wrapper\" role=\"presentation\">\n                <%displayField% ref=\"eInput\"></%displayField%>\n            </div>\n        </div>";
	        return _this;
	    }
	    AgAbstractInputField.prototype.postConstruct = function () {
	        _super.prototype.postConstruct.call(this);
	        this.setInputType();
	        utils_1._.addCssClass(this.getGui(), this.className);
	        var _a = this.config, width = _a.width, value = _a.value;
	        if (width != null) {
	            this.setWidth(width);
	        }
	        if (value != null) {
	            this.setValue(value);
	        }
	        this.addInputListeners();
	    };
	    AgAbstractInputField.prototype.addInputListeners = function () {
	        var _this = this;
	        this.addDestroyableEventListener(this.eInput, 'input', function (e) {
	            var value = e.target.value;
	            _this.setValue(value);
	        });
	    };
	    AgAbstractInputField.prototype.setInputType = function () {
	        if (this.inputType) {
	            this.eInput.setAttribute('type', this.inputType);
	        }
	    };
	    AgAbstractInputField.prototype.getInputElement = function () {
	        return this.eInput;
	    };
	    AgAbstractInputField.prototype.setInputWidth = function (width) {
	        utils_1._.setElementWidth(this.eWrapper, width);
	        return this;
	    };
	    AgAbstractInputField.prototype.setInputName = function (name) {
	        this.getInputElement().setAttribute('name', name);
	        return this;
	    };
	    __decorate([
	        componentAnnotations_1.RefSelector('eLabel'),
	        __metadata("design:type", HTMLElement)
	    ], AgAbstractInputField.prototype, "eLabel", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eWrapper'),
	        __metadata("design:type", HTMLElement)
	    ], AgAbstractInputField.prototype, "eWrapper", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eInput'),
	        __metadata("design:type", Object)
	    ], AgAbstractInputField.prototype, "eInput", void 0);
	    return AgAbstractInputField;
	}(agAbstractField_1.AgAbstractField));
	exports.AgAbstractInputField = AgAbstractInputField;


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var eventService_1 = __webpack_require__(22);
	var utils_1 = __webpack_require__(10);
	var TouchListener = /** @class */ (function () {
	    function TouchListener(eElement, preventMouseClick) {
	        var _this = this;
	        if (preventMouseClick === void 0) { preventMouseClick = false; }
	        this.destroyFuncs = [];
	        this.touching = false;
	        this.eventService = new eventService_1.EventService();
	        this.eElement = eElement;
	        this.preventMouseClick = preventMouseClick;
	        var startListener = this.onTouchStart.bind(this);
	        var moveListener = this.onTouchMove.bind(this);
	        var endListener = this.onTouchEnd.bind(this);
	        this.eElement.addEventListener("touchstart", startListener, { passive: true });
	        this.eElement.addEventListener("touchmove", moveListener, { passive: true });
	        // we set passive=false, as we want to prevent default on this event
	        this.eElement.addEventListener("touchend", endListener, { passive: false });
	        this.destroyFuncs.push(function () {
	            _this.eElement.removeEventListener("touchstart", startListener, { passive: true });
	            _this.eElement.removeEventListener("touchmove", moveListener, { passive: true });
	            _this.eElement.removeEventListener("touchend", endListener, { passive: false });
	        });
	    }
	    TouchListener.prototype.getActiveTouch = function (touchList) {
	        for (var i = 0; i < touchList.length; i++) {
	            var matches = touchList[i].identifier === this.touchStart.identifier;
	            if (matches) {
	                return touchList[i];
	            }
	        }
	        return null;
	    };
	    TouchListener.prototype.addEventListener = function (eventType, listener) {
	        this.eventService.addEventListener(eventType, listener);
	    };
	    TouchListener.prototype.removeEventListener = function (eventType, listener) {
	        this.eventService.removeEventListener(eventType, listener);
	    };
	    TouchListener.prototype.onTouchStart = function (touchEvent) {
	        var _this = this;
	        // only looking at one touch point at any time
	        if (this.touching) {
	            return;
	        }
	        this.touchStart = touchEvent.touches[0];
	        this.touching = true;
	        this.moved = false;
	        var touchStartCopy = this.touchStart;
	        window.setTimeout(function () {
	            var touchesMatch = _this.touchStart === touchStartCopy;
	            if (_this.touching && touchesMatch && !_this.moved) {
	                _this.moved = true;
	                var event_1 = {
	                    type: TouchListener.EVENT_LONG_TAP,
	                    touchStart: _this.touchStart,
	                    touchEvent: touchEvent
	                };
	                _this.eventService.dispatchEvent(event_1);
	            }
	        }, 500);
	    };
	    TouchListener.prototype.onTouchMove = function (touchEvent) {
	        if (!this.touching) {
	            return;
	        }
	        var touch = this.getActiveTouch(touchEvent.touches);
	        if (!touch) {
	            return;
	        }
	        var eventIsFarAway = !utils_1._.areEventsNear(touch, this.touchStart, 4);
	        if (eventIsFarAway) {
	            this.moved = true;
	        }
	    };
	    TouchListener.prototype.onTouchEnd = function (touchEvent) {
	        if (!this.touching) {
	            return;
	        }
	        if (!this.moved) {
	            var event_2 = {
	                type: TouchListener.EVENT_TAP,
	                touchStart: this.touchStart
	            };
	            this.eventService.dispatchEvent(event_2);
	            this.checkForDoubleTap();
	        }
	        // stops the tap from also been processed as a mouse click
	        if (this.preventMouseClick) {
	            touchEvent.preventDefault();
	        }
	        this.touching = false;
	    };
	    TouchListener.prototype.checkForDoubleTap = function () {
	        var now = new Date().getTime();
	        if (this.lastTapTime && this.lastTapTime > 0) {
	            // if previous tap, see if duration is short enough to be considered double tap
	            var interval = now - this.lastTapTime;
	            if (interval > TouchListener.DOUBLE_TAP_MILLIS) {
	                // dispatch double tap event
	                var event_3 = {
	                    type: TouchListener.EVENT_DOUBLE_TAP,
	                    touchStart: this.touchStart
	                };
	                this.eventService.dispatchEvent(event_3);
	                // this stops a tripple tap ending up as two double taps
	                this.lastTapTime = null;
	            }
	            else {
	                this.lastTapTime = now;
	            }
	        }
	        else {
	            this.lastTapTime = now;
	        }
	    };
	    TouchListener.prototype.destroy = function () {
	        this.destroyFuncs.forEach(function (func) { return func(); });
	    };
	    TouchListener.EVENT_TAP = "tap";
	    TouchListener.EVENT_DOUBLE_TAP = "doubleTap";
	    TouchListener.EVENT_LONG_TAP = "longTap";
	    TouchListener.DOUBLE_TAP_MILLIS = 500;
	    return TouchListener;
	}());
	exports.TouchListener = TouchListener;


/***/ },
/* 256 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isPrefixedValue;
	var regex = /-webkit-|-moz-|-ms-/;
	
	function isPrefixedValue(value) {
	  return typeof value === 'string' && regex.test(value);
	}
	module.exports = exports['default'];

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__(952);
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
	
	var toStr = Object.prototype.toString;
	var concat = Array.prototype.concat;
	var origDefineProperty = Object.defineProperty;
	
	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};
	
	var arePropertyDescriptorsSupported = function () {
		var obj = {};
		try {
			origDefineProperty(obj, 'x', { enumerable: false, value: obj });
			// eslint-disable-next-line no-unused-vars, no-restricted-syntax
			for (var _ in obj) { // jscs:ignore disallowUnusedVariables
				return false;
			}
			return obj.x === obj;
		} catch (e) { /* this is IE 8. */
			return false;
		}
	};
	var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();
	
	var defineProperty = function (object, name, value, predicate) {
		if (name in object && (!isFunction(predicate) || !predicate())) {
			return;
		}
		if (supportsDescriptors) {
			origDefineProperty(object, name, {
				configurable: true,
				enumerable: false,
				value: value,
				writable: true
			});
		} else {
			object[name] = value;
		}
	};
	
	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = concat.call(props, Object.getOwnPropertySymbols(map));
		}
		for (var i = 0; i < props.length; i += 1) {
			defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
		}
	};
	
	defineProperties.supportsDescriptors = !!supportsDescriptors;
	
	module.exports = defineProperties;


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(16);
	
	var SymbolClz = __webpack_require__(330);
	
	var _util = __webpack_require__(3);
	
	var isObject = _util.isObject;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/chart/helper/SymbolDraw
	 */
	
	/**
	 * @constructor
	 * @alias module:echarts/chart/helper/SymbolDraw
	 * @param {module:zrender/graphic/Group} [symbolCtor]
	 */
	function SymbolDraw(symbolCtor) {
	  this.group = new graphic.Group();
	  this._symbolCtor = symbolCtor || SymbolClz;
	}
	
	var symbolDrawProto = SymbolDraw.prototype;
	
	function symbolNeedsDraw(data, point, idx, opt) {
	  return point && !isNaN(point[0]) && !isNaN(point[1]) && !(opt.isIgnore && opt.isIgnore(idx)) // We do not set clipShape on group, because it will cut part of
	  // the symbol element shape. We use the same clip shape here as
	  // the line clip.
	  && !(opt.clipShape && !opt.clipShape.contain(point[0], point[1])) && data.getItemVisual(idx, 'symbol') !== 'none';
	}
	/**
	 * Update symbols draw by new data
	 * @param {module:echarts/data/List} data
	 * @param {Object} [opt] Or isIgnore
	 * @param {Function} [opt.isIgnore]
	 * @param {Object} [opt.clipShape]
	 */
	
	
	symbolDrawProto.updateData = function (data, opt) {
	  opt = normalizeUpdateOpt(opt);
	  var group = this.group;
	  var seriesModel = data.hostModel;
	  var oldData = this._data;
	  var SymbolCtor = this._symbolCtor;
	  var seriesScope = makeSeriesScope(data); // There is no oldLineData only when first rendering or switching from
	  // stream mode to normal mode, where previous elements should be removed.
	
	  if (!oldData) {
	    group.removeAll();
	  }
	
	  data.diff(oldData).add(function (newIdx) {
	    var point = data.getItemLayout(newIdx);
	
	    if (symbolNeedsDraw(data, point, newIdx, opt)) {
	      var symbolEl = new SymbolCtor(data, newIdx, seriesScope);
	      symbolEl.attr('position', point);
	      data.setItemGraphicEl(newIdx, symbolEl);
	      group.add(symbolEl);
	    }
	  }).update(function (newIdx, oldIdx) {
	    var symbolEl = oldData.getItemGraphicEl(oldIdx);
	    var point = data.getItemLayout(newIdx);
	
	    if (!symbolNeedsDraw(data, point, newIdx, opt)) {
	      group.remove(symbolEl);
	      return;
	    }
	
	    if (!symbolEl) {
	      symbolEl = new SymbolCtor(data, newIdx);
	      symbolEl.attr('position', point);
	    } else {
	      symbolEl.updateData(data, newIdx, seriesScope);
	      graphic.updateProps(symbolEl, {
	        position: point
	      }, seriesModel);
	    } // Add back
	
	
	    group.add(symbolEl);
	    data.setItemGraphicEl(newIdx, symbolEl);
	  }).remove(function (oldIdx) {
	    var el = oldData.getItemGraphicEl(oldIdx);
	    el && el.fadeOut(function () {
	      group.remove(el);
	    });
	  }).execute();
	  this._data = data;
	};
	
	symbolDrawProto.isPersistent = function () {
	  return true;
	};
	
	symbolDrawProto.updateLayout = function () {
	  var data = this._data;
	
	  if (data) {
	    // Not use animation
	    data.eachItemGraphicEl(function (el, idx) {
	      var point = data.getItemLayout(idx);
	      el.attr('position', point);
	    });
	  }
	};
	
	symbolDrawProto.incrementalPrepareUpdate = function (data) {
	  this._seriesScope = makeSeriesScope(data);
	  this._data = null;
	  this.group.removeAll();
	};
	/**
	 * Update symbols draw by new data
	 * @param {module:echarts/data/List} data
	 * @param {Object} [opt] Or isIgnore
	 * @param {Function} [opt.isIgnore]
	 * @param {Object} [opt.clipShape]
	 */
	
	
	symbolDrawProto.incrementalUpdate = function (taskParams, data, opt) {
	  opt = normalizeUpdateOpt(opt);
	
	  function updateIncrementalAndHover(el) {
	    if (!el.isGroup) {
	      el.incremental = el.useHoverLayer = true;
	    }
	  }
	
	  for (var idx = taskParams.start; idx < taskParams.end; idx++) {
	    var point = data.getItemLayout(idx);
	
	    if (symbolNeedsDraw(data, point, idx, opt)) {
	      var el = new this._symbolCtor(data, idx, this._seriesScope);
	      el.traverse(updateIncrementalAndHover);
	      el.attr('position', point);
	      this.group.add(el);
	      data.setItemGraphicEl(idx, el);
	    }
	  }
	};
	
	function normalizeUpdateOpt(opt) {
	  if (opt != null && !isObject(opt)) {
	    opt = {
	      isIgnore: opt
	    };
	  }
	
	  return opt || {};
	}
	
	symbolDrawProto.remove = function (enableAnimation) {
	  var group = this.group;
	  var data = this._data; // Incremental model do not have this._data.
	
	  if (data && enableAnimation) {
	    data.eachItemGraphicEl(function (el) {
	      el.fadeOut(function () {
	        group.remove(el);
	      });
	    });
	  } else {
	    group.removeAll();
	  }
	};
	
	function makeSeriesScope(data) {
	  var seriesModel = data.hostModel;
	  return {
	    itemStyle: seriesModel.getModel('itemStyle').getItemStyle(['color']),
	    hoverItemStyle: seriesModel.getModel('emphasis.itemStyle').getItemStyle(),
	    symbolRotate: seriesModel.get('symbolRotate'),
	    symbolOffset: seriesModel.get('symbolOffset'),
	    hoverAnimation: seriesModel.get('hoverAnimation'),
	    labelModel: seriesModel.getModel('label'),
	    hoverLabelModel: seriesModel.getModel('emphasis.label'),
	    cursorStyle: seriesModel.get('cursor')
	  };
	}
	
	var _default = SymbolDraw;
	module.exports = _default;

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(16);
	
	var _number = __webpack_require__(20);
	
	var round = _number.round;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function createGridClipPath(cartesian, hasAnimation, seriesModel) {
	  var rect = cartesian.getArea();
	  var isHorizontal = cartesian.getBaseAxis().isHorizontal();
	  var x = rect.x;
	  var y = rect.y;
	  var width = rect.width;
	  var height = rect.height;
	  var lineWidth = seriesModel.get('lineStyle.width') || 2; // Expand the clip path a bit to avoid the border is clipped and looks thinner
	
	  x -= lineWidth / 2;
	  y -= lineWidth / 2;
	  width += lineWidth;
	  height += lineWidth; // fix: https://github.com/apache/incubator-echarts/issues/11369
	
	  x = Math.floor(x);
	  width = Math.round(width);
	  var clipPath = new graphic.Rect({
	    shape: {
	      x: x,
	      y: y,
	      width: width,
	      height: height
	    }
	  });
	
	  if (hasAnimation) {
	    clipPath.shape[isHorizontal ? 'width' : 'height'] = 0;
	    graphic.initProps(clipPath, {
	      shape: {
	        width: width,
	        height: height
	      }
	    }, seriesModel);
	  }
	
	  return clipPath;
	}
	
	function createPolarClipPath(polar, hasAnimation, seriesModel) {
	  var sectorArea = polar.getArea(); // Avoid float number rounding error for symbol on the edge of axis extent.
	
	  var clipPath = new graphic.Sector({
	    shape: {
	      cx: round(polar.cx, 1),
	      cy: round(polar.cy, 1),
	      r0: round(sectorArea.r0, 1),
	      r: round(sectorArea.r, 1),
	      startAngle: sectorArea.startAngle,
	      endAngle: sectorArea.endAngle,
	      clockwise: sectorArea.clockwise
	    }
	  });
	
	  if (hasAnimation) {
	    clipPath.shape.endAngle = sectorArea.startAngle;
	    graphic.initProps(clipPath, {
	      shape: {
	        endAngle: sectorArea.endAngle
	      }
	    }, seriesModel);
	  }
	
	  return clipPath;
	}
	
	function createClipPath(coordSys, hasAnimation, seriesModel) {
	  if (!coordSys) {
	    return null;
	  } else if (coordSys.type === 'polar') {
	    return createPolarClipPath(coordSys, hasAnimation, seriesModel);
	  } else if (coordSys.type === 'cartesian2d') {
	    return createGridClipPath(coordSys, hasAnimation, seriesModel);
	  }
	
	  return null;
	}
	
	exports.createGridClipPath = createGridClipPath;
	exports.createPolarClipPath = createPolarClipPath;
	exports.createClipPath = createClipPath;

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var axisPointerModelHelper = __webpack_require__(332);
	
	var axisTrigger = __webpack_require__(1579);
	
	__webpack_require__(1575);
	
	__webpack_require__(1576);
	
	__webpack_require__(710);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// CartesianAxisPointer is not supposed to be required here. But consider
	// echarts.simple.js and online build tooltip, which only require gridSimple,
	// CartesianAxisPointer should be able to required somewhere.
	echarts.registerPreprocessor(function (option) {
	  // Always has a global axisPointerModel for default setting.
	  if (option) {
	    (!option.axisPointer || option.axisPointer.length === 0) && (option.axisPointer = {});
	    var link = option.axisPointer.link; // Normalize to array to avoid object mergin. But if link
	    // is not set, remain null/undefined, otherwise it will
	    // override existent link setting.
	
	    if (link && !zrUtil.isArray(link)) {
	      option.axisPointer.link = [link];
	    }
	  }
	}); // This process should proformed after coordinate systems created
	// and series data processed. So put it on statistic processing stage.
	
	echarts.registerProcessor(echarts.PRIORITY.PROCESSOR.STATISTIC, function (ecModel, api) {
	  // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
	  // allAxesInfo should be updated when setOption performed.
	  ecModel.getComponent('axisPointer').coordSysAxesInfo = axisPointerModelHelper.collect(ecModel, api);
	}); // Broadcast to all views.
	
	echarts.registerAction({
	  type: 'updateAxisPointer',
	  event: 'updateAxisPointer',
	  update: ':updateAxisPointer'
	}, axisTrigger);

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var graphic = __webpack_require__(16);
	
	__webpack_require__(470);
	
	__webpack_require__(1568);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Grid view
	echarts.extendComponentView({
	  type: 'grid',
	  render: function (gridModel, ecModel) {
	    this.group.removeAll();
	
	    if (gridModel.get('show')) {
	      this.group.add(new graphic.Rect({
	        shape: gridModel.coordinateSystem.getRect(),
	        style: zrUtil.defaults({
	          fill: gridModel.get('backgroundColor')
	        }, gridModel.getItemStyle()),
	        silent: true,
	        z2: -1
	      }));
	    }
	  }
	});
	echarts.registerPreprocessor(function (option) {
	  // Only create grid when need
	  if (option.xAxis && option.yAxis && !option.grid) {
	    option.grid = {};
	  }
	});

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var Eventful = __webpack_require__(189);
	
	var eventTool = __webpack_require__(113);
	
	var interactionMutex = __webpack_require__(721);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @alias module:echarts/component/helper/RoamController
	 * @constructor
	 * @mixin {module:zrender/mixin/Eventful}
	 *
	 * @param {module:zrender/zrender~ZRender} zr
	 */
	function RoamController(zr) {
	  /**
	   * @type {Function}
	   */
	  this.pointerChecker;
	  /**
	   * @type {module:zrender}
	   */
	
	  this._zr = zr;
	  /**
	   * @type {Object}
	   */
	
	  this._opt = {}; // Avoid two roamController bind the same handler
	
	  var bind = zrUtil.bind;
	  var mousedownHandler = bind(mousedown, this);
	  var mousemoveHandler = bind(mousemove, this);
	  var mouseupHandler = bind(mouseup, this);
	  var mousewheelHandler = bind(mousewheel, this);
	  var pinchHandler = bind(pinch, this);
	  Eventful.call(this);
	  /**
	   * @param {Function} pointerChecker
	   *                   input: x, y
	   *                   output: boolean
	   */
	
	  this.setPointerChecker = function (pointerChecker) {
	    this.pointerChecker = pointerChecker;
	  };
	  /**
	   * Notice: only enable needed types. For example, if 'zoom'
	   * is not needed, 'zoom' should not be enabled, otherwise
	   * default mousewheel behaviour (scroll page) will be disabled.
	   *
	   * @param  {boolean|string} [controlType=true] Specify the control type,
	   *                          which can be null/undefined or true/false
	   *                          or 'pan/move' or 'zoom'/'scale'
	   * @param {Object} [opt]
	   * @param {Object} [opt.zoomOnMouseWheel=true] The value can be: true / false / 'shift' / 'ctrl' / 'alt'.
	   * @param {Object} [opt.moveOnMouseMove=true] The value can be: true / false / 'shift' / 'ctrl' / 'alt'.
	   * @param {Object} [opt.moveOnMouseWheel=false] The value can be: true / false / 'shift' / 'ctrl' / 'alt'.
	   * @param {Object} [opt.preventDefaultMouseMove=true] When pan.
	   */
	
	
	  this.enable = function (controlType, opt) {
	    // Disable previous first
	    this.disable();
	    this._opt = zrUtil.defaults(zrUtil.clone(opt) || {}, {
	      zoomOnMouseWheel: true,
	      moveOnMouseMove: true,
	      // By default, wheel do not trigger move.
	      moveOnMouseWheel: false,
	      preventDefaultMouseMove: true
	    });
	
	    if (controlType == null) {
	      controlType = true;
	    }
	
	    if (controlType === true || controlType === 'move' || controlType === 'pan') {
	      zr.on('mousedown', mousedownHandler);
	      zr.on('mousemove', mousemoveHandler);
	      zr.on('mouseup', mouseupHandler);
	    }
	
	    if (controlType === true || controlType === 'scale' || controlType === 'zoom') {
	      zr.on('mousewheel', mousewheelHandler);
	      zr.on('pinch', pinchHandler);
	    }
	  };
	
	  this.disable = function () {
	    zr.off('mousedown', mousedownHandler);
	    zr.off('mousemove', mousemoveHandler);
	    zr.off('mouseup', mouseupHandler);
	    zr.off('mousewheel', mousewheelHandler);
	    zr.off('pinch', pinchHandler);
	  };
	
	  this.dispose = this.disable;
	
	  this.isDragging = function () {
	    return this._dragging;
	  };
	
	  this.isPinching = function () {
	    return this._pinching;
	  };
	}
	
	zrUtil.mixin(RoamController, Eventful);
	
	function mousedown(e) {
	  if (eventTool.isMiddleOrRightButtonOnMouseUpDown(e) || e.target && e.target.draggable) {
	    return;
	  }
	
	  var x = e.offsetX;
	  var y = e.offsetY; // Only check on mosedown, but not mousemove.
	  // Mouse can be out of target when mouse moving.
	
	  if (this.pointerChecker && this.pointerChecker(e, x, y)) {
	    this._x = x;
	    this._y = y;
	    this._dragging = true;
	  }
	}
	
	function mousemove(e) {
	  if (!this._dragging || !isAvailableBehavior('moveOnMouseMove', e, this._opt) || e.gestureEvent === 'pinch' || interactionMutex.isTaken(this._zr, 'globalPan')) {
	    return;
	  }
	
	  var x = e.offsetX;
	  var y = e.offsetY;
	  var oldX = this._x;
	  var oldY = this._y;
	  var dx = x - oldX;
	  var dy = y - oldY;
	  this._x = x;
	  this._y = y;
	  this._opt.preventDefaultMouseMove && eventTool.stop(e.event);
	  trigger(this, 'pan', 'moveOnMouseMove', e, {
	    dx: dx,
	    dy: dy,
	    oldX: oldX,
	    oldY: oldY,
	    newX: x,
	    newY: y
	  });
	}
	
	function mouseup(e) {
	  if (!eventTool.isMiddleOrRightButtonOnMouseUpDown(e)) {
	    this._dragging = false;
	  }
	}
	
	function mousewheel(e) {
	  var shouldZoom = isAvailableBehavior('zoomOnMouseWheel', e, this._opt);
	  var shouldMove = isAvailableBehavior('moveOnMouseWheel', e, this._opt);
	  var wheelDelta = e.wheelDelta;
	  var absWheelDeltaDelta = Math.abs(wheelDelta);
	  var originX = e.offsetX;
	  var originY = e.offsetY; // wheelDelta maybe -0 in chrome mac.
	
	  if (wheelDelta === 0 || !shouldZoom && !shouldMove) {
	    return;
	  } // If both `shouldZoom` and `shouldMove` is true, trigger
	  // their event both, and the final behavior is determined
	  // by event listener themselves.
	
	
	  if (shouldZoom) {
	    // Convenience:
	    // Mac and VM Windows on Mac: scroll up: zoom out.
	    // Windows: scroll up: zoom in.
	    // FIXME: Should do more test in different environment.
	    // wheelDelta is too complicated in difference nvironment
	    // (https://developer.mozilla.org/en-US/docs/Web/Events/mousewheel),
	    // although it has been normallized by zrender.
	    // wheelDelta of mouse wheel is bigger than touch pad.
	    var factor = absWheelDeltaDelta > 3 ? 1.4 : absWheelDeltaDelta > 1 ? 1.2 : 1.1;
	    var scale = wheelDelta > 0 ? factor : 1 / factor;
	    checkPointerAndTrigger(this, 'zoom', 'zoomOnMouseWheel', e, {
	      scale: scale,
	      originX: originX,
	      originY: originY
	    });
	  }
	
	  if (shouldMove) {
	    // FIXME: Should do more test in different environment.
	    var absDelta = Math.abs(wheelDelta); // wheelDelta of mouse wheel is bigger than touch pad.
	
	    var scrollDelta = (wheelDelta > 0 ? 1 : -1) * (absDelta > 3 ? 0.4 : absDelta > 1 ? 0.15 : 0.05);
	    checkPointerAndTrigger(this, 'scrollMove', 'moveOnMouseWheel', e, {
	      scrollDelta: scrollDelta,
	      originX: originX,
	      originY: originY
	    });
	  }
	}
	
	function pinch(e) {
	  if (interactionMutex.isTaken(this._zr, 'globalPan')) {
	    return;
	  }
	
	  var scale = e.pinchScale > 1 ? 1.1 : 1 / 1.1;
	  checkPointerAndTrigger(this, 'zoom', null, e, {
	    scale: scale,
	    originX: e.pinchX,
	    originY: e.pinchY
	  });
	}
	
	function checkPointerAndTrigger(controller, eventName, behaviorToCheck, e, contollerEvent) {
	  if (controller.pointerChecker && controller.pointerChecker(e, contollerEvent.originX, contollerEvent.originY)) {
	    // When mouse is out of roamController rect,
	    // default befavoius should not be be disabled, otherwise
	    // page sliding is disabled, contrary to expectation.
	    eventTool.stop(e.event);
	    trigger(controller, eventName, behaviorToCheck, e, contollerEvent);
	  }
	}
	
	function trigger(controller, eventName, behaviorToCheck, e, contollerEvent) {
	  // Also provide behavior checker for event listener, for some case that
	  // multiple components share one listener.
	  contollerEvent.isAvailableBehavior = zrUtil.bind(isAvailableBehavior, null, behaviorToCheck, e);
	  controller.trigger(eventName, contollerEvent);
	} // settings: {
	//     zoomOnMouseWheel
	//     moveOnMouseMove
	//     moveOnMouseWheel
	// }
	// The value can be: true / false / 'shift' / 'ctrl' / 'alt'.
	
	
	function isAvailableBehavior(behaviorToCheck, e, settings) {
	  var setting = settings[behaviorToCheck];
	  return !behaviorToCheck || setting && (!zrUtil.isString(setting) || e.event[setting + 'Key']);
	}
	
	var _default = RoamController;
	module.exports = _default;

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(3);
	
	var createHashMap = _util.createHashMap;
	var isTypedArray = _util.isTypedArray;
	
	var _clazz = __webpack_require__(124);
	
	var enableClassCheck = _clazz.enableClassCheck;
	
	var _sourceType = __webpack_require__(265);
	
	var SOURCE_FORMAT_ORIGINAL = _sourceType.SOURCE_FORMAT_ORIGINAL;
	var SERIES_LAYOUT_BY_COLUMN = _sourceType.SERIES_LAYOUT_BY_COLUMN;
	var SOURCE_FORMAT_UNKNOWN = _sourceType.SOURCE_FORMAT_UNKNOWN;
	var SOURCE_FORMAT_TYPED_ARRAY = _sourceType.SOURCE_FORMAT_TYPED_ARRAY;
	var SOURCE_FORMAT_KEYED_COLUMNS = _sourceType.SOURCE_FORMAT_KEYED_COLUMNS;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * [sourceFormat]
	 *
	 * + "original":
	 * This format is only used in series.data, where
	 * itemStyle can be specified in data item.
	 *
	 * + "arrayRows":
	 * [
	 *     ['product', 'score', 'amount'],
	 *     ['Matcha Latte', 89.3, 95.8],
	 *     ['Milk Tea', 92.1, 89.4],
	 *     ['Cheese Cocoa', 94.4, 91.2],
	 *     ['Walnut Brownie', 85.4, 76.9]
	 * ]
	 *
	 * + "objectRows":
	 * [
	 *     {product: 'Matcha Latte', score: 89.3, amount: 95.8},
	 *     {product: 'Milk Tea', score: 92.1, amount: 89.4},
	 *     {product: 'Cheese Cocoa', score: 94.4, amount: 91.2},
	 *     {product: 'Walnut Brownie', score: 85.4, amount: 76.9}
	 * ]
	 *
	 * + "keyedColumns":
	 * {
	 *     'product': ['Matcha Latte', 'Milk Tea', 'Cheese Cocoa', 'Walnut Brownie'],
	 *     'count': [823, 235, 1042, 988],
	 *     'score': [95.8, 81.4, 91.2, 76.9]
	 * }
	 *
	 * + "typedArray"
	 *
	 * + "unknown"
	 */
	
	/**
	 * @constructor
	 * @param {Object} fields
	 * @param {string} fields.sourceFormat
	 * @param {Array|Object} fields.fromDataset
	 * @param {Array|Object} [fields.data]
	 * @param {string} [seriesLayoutBy='column']
	 * @param {Array.<Object|string>} [dimensionsDefine]
	 * @param {Objet|HashMap} [encodeDefine]
	 * @param {number} [startIndex=0]
	 * @param {number} [dimensionsDetectCount]
	 */
	function Source(fields) {
	  /**
	   * @type {boolean}
	   */
	  this.fromDataset = fields.fromDataset;
	  /**
	   * Not null/undefined.
	   * @type {Array|Object}
	   */
	
	  this.data = fields.data || (fields.sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS ? {} : []);
	  /**
	   * See also "detectSourceFormat".
	   * Not null/undefined.
	   * @type {string}
	   */
	
	  this.sourceFormat = fields.sourceFormat || SOURCE_FORMAT_UNKNOWN;
	  /**
	   * 'row' or 'column'
	   * Not null/undefined.
	   * @type {string} seriesLayoutBy
	   */
	
	  this.seriesLayoutBy = fields.seriesLayoutBy || SERIES_LAYOUT_BY_COLUMN;
	  /**
	   * dimensions definition in option.
	   * can be null/undefined.
	   * @type {Array.<Object|string>}
	   */
	
	  this.dimensionsDefine = fields.dimensionsDefine;
	  /**
	   * encode definition in option.
	   * can be null/undefined.
	   * @type {Objet|HashMap}
	   */
	
	  this.encodeDefine = fields.encodeDefine && createHashMap(fields.encodeDefine);
	  /**
	   * Not null/undefined, uint.
	   * @type {number}
	   */
	
	  this.startIndex = fields.startIndex || 0;
	  /**
	   * Can be null/undefined (when unknown), uint.
	   * @type {number}
	   */
	
	  this.dimensionsDetectCount = fields.dimensionsDetectCount;
	}
	/**
	 * Wrap original series data for some compatibility cases.
	 */
	
	
	Source.seriesDataToSource = function (data) {
	  return new Source({
	    data: data,
	    sourceFormat: isTypedArray(data) ? SOURCE_FORMAT_TYPED_ARRAY : SOURCE_FORMAT_ORIGINAL,
	    fromDataset: false
	  });
	};
	
	enableClassCheck(Source);
	var _default = Source;
	module.exports = _default;

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(3);
	
	var each = _util.each;
	var createHashMap = _util.createHashMap;
	var assert = _util.assert;
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var OTHER_DIMENSIONS = createHashMap(['tooltip', 'label', 'itemName', 'itemId', 'seriesName']);
	
	function summarizeDimensions(data) {
	  var summary = {};
	  var encode = summary.encode = {};
	  var notExtraCoordDimMap = createHashMap();
	  var defaultedLabel = [];
	  var defaultedTooltip = []; // See the comment of `List.js#userOutput`.
	
	  var userOutput = summary.userOutput = {
	    dimensionNames: data.dimensions.slice(),
	    encode: {}
	  };
	  each(data.dimensions, function (dimName) {
	    var dimItem = data.getDimensionInfo(dimName);
	    var coordDim = dimItem.coordDim;
	
	    if (coordDim) {
	      var coordDimIndex = dimItem.coordDimIndex;
	      getOrCreateEncodeArr(encode, coordDim)[coordDimIndex] = dimName;
	
	      if (!dimItem.isExtraCoord) {
	        notExtraCoordDimMap.set(coordDim, 1); // Use the last coord dim (and label friendly) as default label,
	        // because when dataset is used, it is hard to guess which dimension
	        // can be value dimension. If both show x, y on label is not look good,
	        // and conventionally y axis is focused more.
	
	        if (mayLabelDimType(dimItem.type)) {
	          defaultedLabel[0] = dimName;
	        } // User output encode do not contain generated coords.
	        // And it only has index. User can use index to retrieve value from the raw item array.
	
	
	        getOrCreateEncodeArr(userOutput.encode, coordDim)[coordDimIndex] = dimItem.index;
	      }
	
	      if (dimItem.defaultTooltip) {
	        defaultedTooltip.push(dimName);
	      }
	    }
	
	    OTHER_DIMENSIONS.each(function (v, otherDim) {
	      var encodeArr = getOrCreateEncodeArr(encode, otherDim);
	      var dimIndex = dimItem.otherDims[otherDim];
	
	      if (dimIndex != null && dimIndex !== false) {
	        encodeArr[dimIndex] = dimItem.name;
	      }
	    });
	  });
	  var dataDimsOnCoord = [];
	  var encodeFirstDimNotExtra = {};
	  notExtraCoordDimMap.each(function (v, coordDim) {
	    var dimArr = encode[coordDim]; // ??? FIXME extra coord should not be set in dataDimsOnCoord.
	    // But should fix the case that radar axes: simplify the logic
	    // of `completeDimension`, remove `extraPrefix`.
	
	    encodeFirstDimNotExtra[coordDim] = dimArr[0]; // Not necessary to remove duplicate, because a data
	    // dim canot on more than one coordDim.
	
	    dataDimsOnCoord = dataDimsOnCoord.concat(dimArr);
	  });
	  summary.dataDimsOnCoord = dataDimsOnCoord;
	  summary.encodeFirstDimNotExtra = encodeFirstDimNotExtra;
	  var encodeLabel = encode.label; // FIXME `encode.label` is not recommanded, because formatter can not be set
	  // in this way. Use label.formatter instead. May be remove this approach someday.
	
	  if (encodeLabel && encodeLabel.length) {
	    defaultedLabel = encodeLabel.slice();
	  }
	
	  var encodeTooltip = encode.tooltip;
	
	  if (encodeTooltip && encodeTooltip.length) {
	    defaultedTooltip = encodeTooltip.slice();
	  } else if (!defaultedTooltip.length) {
	    defaultedTooltip = defaultedLabel.slice();
	  }
	
	  encode.defaultedLabel = defaultedLabel;
	  encode.defaultedTooltip = defaultedTooltip;
	  return summary;
	}
	
	function getOrCreateEncodeArr(encode, dim) {
	  if (!encode.hasOwnProperty(dim)) {
	    encode[dim] = [];
	  }
	
	  return encode[dim];
	}
	
	function getDimensionTypeByAxis(axisType) {
	  return axisType === 'category' ? 'ordinal' : axisType === 'time' ? 'time' : 'float';
	}
	
	function mayLabelDimType(dimType) {
	  // In most cases, ordinal and time do not suitable for label.
	  // Ordinal info can be displayed on axis. Time is too long.
	  return !(dimType === 'ordinal' || dimType === 'time');
	} // function findTheLastDimMayLabel(data) {
	//     // Get last value dim
	//     var dimensions = data.dimensions.slice();
	//     var valueType;
	//     var valueDim;
	//     while (dimensions.length && (
	//         valueDim = dimensions.pop(),
	//         valueType = data.getDimensionInfo(valueDim).type,
	//         valueType === 'ordinal' || valueType === 'time'
	//     )) {} // jshint ignore:line
	//     return valueDim;
	// }
	
	
	exports.OTHER_DIMENSIONS = OTHER_DIMENSIONS;
	exports.summarizeDimensions = summarizeDimensions;
	exports.getDimensionTypeByAxis = getDimensionTypeByAxis;

/***/ },
/* 265 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Avoid typo.
	var SOURCE_FORMAT_ORIGINAL = 'original';
	var SOURCE_FORMAT_ARRAY_ROWS = 'arrayRows';
	var SOURCE_FORMAT_OBJECT_ROWS = 'objectRows';
	var SOURCE_FORMAT_KEYED_COLUMNS = 'keyedColumns';
	var SOURCE_FORMAT_UNKNOWN = 'unknown'; // ??? CHANGE A NAME
	
	var SOURCE_FORMAT_TYPED_ARRAY = 'typedArray';
	var SERIES_LAYOUT_BY_COLUMN = 'column';
	var SERIES_LAYOUT_BY_ROW = 'row';
	exports.SOURCE_FORMAT_ORIGINAL = SOURCE_FORMAT_ORIGINAL;
	exports.SOURCE_FORMAT_ARRAY_ROWS = SOURCE_FORMAT_ARRAY_ROWS;
	exports.SOURCE_FORMAT_OBJECT_ROWS = SOURCE_FORMAT_OBJECT_ROWS;
	exports.SOURCE_FORMAT_KEYED_COLUMNS = SOURCE_FORMAT_KEYED_COLUMNS;
	exports.SOURCE_FORMAT_UNKNOWN = SOURCE_FORMAT_UNKNOWN;
	exports.SOURCE_FORMAT_TYPED_ARRAY = SOURCE_FORMAT_TYPED_ARRAY;
	exports.SERIES_LAYOUT_BY_COLUMN = SERIES_LAYOUT_BY_COLUMN;
	exports.SERIES_LAYOUT_BY_ROW = SERIES_LAYOUT_BY_ROW;

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(3);
	
	var map = _util.map;
	
	var createRenderPlanner = __webpack_require__(202);
	
	var _dataStackHelper = __webpack_require__(105);
	
	var isDimensionStacked = _dataStackHelper.isDimensionStacked;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Float32Array */
	function _default(seriesType) {
	  return {
	    seriesType: seriesType,
	    plan: createRenderPlanner(),
	    reset: function (seriesModel) {
	      var data = seriesModel.getData();
	      var coordSys = seriesModel.coordinateSystem;
	      var pipelineContext = seriesModel.pipelineContext;
	      var isLargeRender = pipelineContext.large;
	
	      if (!coordSys) {
	        return;
	      }
	
	      var dims = map(coordSys.dimensions, function (dim) {
	        return data.mapDimension(dim);
	      }).slice(0, 2);
	      var dimLen = dims.length;
	      var stackResultDim = data.getCalculationInfo('stackResultDimension');
	
	      if (isDimensionStacked(data, dims[0]
	      /*, dims[1]*/
	      )) {
	        dims[0] = stackResultDim;
	      }
	
	      if (isDimensionStacked(data, dims[1]
	      /*, dims[0]*/
	      )) {
	        dims[1] = stackResultDim;
	      }
	
	      function progress(params, data) {
	        var segCount = params.end - params.start;
	        var points = isLargeRender && new Float32Array(segCount * dimLen);
	
	        for (var i = params.start, offset = 0, tmpIn = [], tmpOut = []; i < params.end; i++) {
	          var point;
	
	          if (dimLen === 1) {
	            var x = data.get(dims[0], i);
	            point = !isNaN(x) && coordSys.dataToPoint(x, null, tmpOut);
	          } else {
	            var x = tmpIn[0] = data.get(dims[0], i);
	            var y = tmpIn[1] = data.get(dims[1], i); // Also {Array.<number>}, not undefined to avoid if...else... statement
	
	            point = !isNaN(x) && !isNaN(y) && coordSys.dataToPoint(tmpIn, null, tmpOut);
	          }
	
	          if (isLargeRender) {
	            points[offset++] = point ? point[0] : NaN;
	            points[offset++] = point ? point[1] : NaN;
	          } else {
	            data.setItemLayout(i, point && point.slice() || [NaN, NaN]);
	          }
	        }
	
	        isLargeRender && data.setLayout('symbolPoints', points);
	      }
	
	      return dimLen && {
	        progress: progress
	      };
	    }
	  };
	}
	
	module.exports = _default;

/***/ },
/* 267 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(seriesType) {
	  return {
	    seriesType: seriesType,
	    reset: function (seriesModel, ecModel) {
	      var legendModels = ecModel.findComponents({
	        mainType: 'legend'
	      });
	
	      if (!legendModels || !legendModels.length) {
	        return;
	      }
	
	      var data = seriesModel.getData();
	      data.filterSelf(function (idx) {
	        var name = data.getName(idx); // If in any legend component the status is not selected.
	
	        for (var i = 0; i < legendModels.length; i++) {
	          if (!legendModels[i].isSelected(name)) {
	            return false;
	          }
	        }
	
	        return true;
	      });
	    }
	  };
	}
	
	module.exports = _default;

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var _clazz = __webpack_require__(124);
	
	var parseClassType = _clazz.parseClassType;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var base = 0;
	/**
	 * @public
	 * @param {string} type
	 * @return {string}
	 */
	
	function getUID(type) {
	  // Considering the case of crossing js context,
	  // use Math.random to make id as unique as possible.
	  return [type || '', base++, Math.random().toFixed(5)].join('_');
	}
	/**
	 * @inner
	 */
	
	
	function enableSubTypeDefaulter(entity) {
	  var subTypeDefaulters = {};
	
	  entity.registerSubTypeDefaulter = function (componentType, defaulter) {
	    componentType = parseClassType(componentType);
	    subTypeDefaulters[componentType.main] = defaulter;
	  };
	
	  entity.determineSubType = function (componentType, option) {
	    var type = option.type;
	
	    if (!type) {
	      var componentTypeMain = parseClassType(componentType).main;
	
	      if (entity.hasSubTypes(componentType) && subTypeDefaulters[componentTypeMain]) {
	        type = subTypeDefaulters[componentTypeMain](option);
	      }
	    }
	
	    return type;
	  };
	
	  return entity;
	}
	/**
	 * Topological travel on Activity Network (Activity On Vertices).
	 * Dependencies is defined in Model.prototype.dependencies, like ['xAxis', 'yAxis'].
	 *
	 * If 'xAxis' or 'yAxis' is absent in componentTypeList, just ignore it in topology.
	 *
	 * If there is circle dependencey, Error will be thrown.
	 *
	 */
	
	
	function enableTopologicalTravel(entity, dependencyGetter) {
	  /**
	   * @public
	   * @param {Array.<string>} targetNameList Target Component type list.
	   *                                           Can be ['aa', 'bb', 'aa.xx']
	   * @param {Array.<string>} fullNameList By which we can build dependency graph.
	   * @param {Function} callback Params: componentType, dependencies.
	   * @param {Object} context Scope of callback.
	   */
	  entity.topologicalTravel = function (targetNameList, fullNameList, callback, context) {
	    if (!targetNameList.length) {
	      return;
	    }
	
	    var result = makeDepndencyGraph(fullNameList);
	    var graph = result.graph;
	    var stack = result.noEntryList;
	    var targetNameSet = {};
	    zrUtil.each(targetNameList, function (name) {
	      targetNameSet[name] = true;
	    });
	
	    while (stack.length) {
	      var currComponentType = stack.pop();
	      var currVertex = graph[currComponentType];
	      var isInTargetNameSet = !!targetNameSet[currComponentType];
	
	      if (isInTargetNameSet) {
	        callback.call(context, currComponentType, currVertex.originalDeps.slice());
	        delete targetNameSet[currComponentType];
	      }
	
	      zrUtil.each(currVertex.successor, isInTargetNameSet ? removeEdgeAndAdd : removeEdge);
	    }
	
	    zrUtil.each(targetNameSet, function () {
	      throw new Error('Circle dependency may exists');
	    });
	
	    function removeEdge(succComponentType) {
	      graph[succComponentType].entryCount--;
	
	      if (graph[succComponentType].entryCount === 0) {
	        stack.push(succComponentType);
	      }
	    } // Consider this case: legend depends on series, and we call
	    // chart.setOption({series: [...]}), where only series is in option.
	    // If we do not have 'removeEdgeAndAdd', legendModel.mergeOption will
	    // not be called, but only sereis.mergeOption is called. Thus legend
	    // have no chance to update its local record about series (like which
	    // name of series is available in legend).
	
	
	    function removeEdgeAndAdd(succComponentType) {
	      targetNameSet[succComponentType] = true;
	      removeEdge(succComponentType);
	    }
	  };
	  /**
	   * DepndencyGraph: {Object}
	   * key: conponentType,
	   * value: {
	   *     successor: [conponentTypes...],
	   *     originalDeps: [conponentTypes...],
	   *     entryCount: {number}
	   * }
	   */
	
	
	  function makeDepndencyGraph(fullNameList) {
	    var graph = {};
	    var noEntryList = [];
	    zrUtil.each(fullNameList, function (name) {
	      var thisItem = createDependencyGraphItem(graph, name);
	      var originalDeps = thisItem.originalDeps = dependencyGetter(name);
	      var availableDeps = getAvailableDependencies(originalDeps, fullNameList);
	      thisItem.entryCount = availableDeps.length;
	
	      if (thisItem.entryCount === 0) {
	        noEntryList.push(name);
	      }
	
	      zrUtil.each(availableDeps, function (dependentName) {
	        if (zrUtil.indexOf(thisItem.predecessor, dependentName) < 0) {
	          thisItem.predecessor.push(dependentName);
	        }
	
	        var thatItem = createDependencyGraphItem(graph, dependentName);
	
	        if (zrUtil.indexOf(thatItem.successor, dependentName) < 0) {
	          thatItem.successor.push(name);
	        }
	      });
	    });
	    return {
	      graph: graph,
	      noEntryList: noEntryList
	    };
	  }
	
	  function createDependencyGraphItem(graph, name) {
	    if (!graph[name]) {
	      graph[name] = {
	        predecessor: [],
	        successor: []
	      };
	    }
	
	    return graph[name];
	  }
	
	  function getAvailableDependencies(originalDeps, fullNameList) {
	    var availableDeps = [];
	    zrUtil.each(originalDeps, function (dep) {
	      zrUtil.indexOf(fullNameList, dep) >= 0 && availableDeps.push(dep);
	    });
	    return availableDeps;
	  }
	}
	
	exports.getUID = getUID;
	exports.enableSubTypeDefaulter = enableSubTypeDefaulter;
	exports.enableTopologicalTravel = enableTopologicalTravel;

/***/ },
/* 269 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * LegendVisualProvider is an bridge that pick encoded color from data and
	 * provide to the legend component.
	 * @param {Function} getDataWithEncodedVisual Function to get data after filtered. It stores all the encoding info
	 * @param {Function} getRawData Function to get raw data before filtered.
	 */
	function LegendVisualProvider(getDataWithEncodedVisual, getRawData) {
	  this.getAllNames = function () {
	    var rawData = getRawData(); // We find the name from the raw data. In case it's filtered by the legend component.
	    // Normally, the name can be found in rawData, but can't be found in filtered data will display as gray.
	
	    return rawData.mapArray(rawData.getName);
	  };
	
	  this.containName = function (name) {
	    var rawData = getRawData();
	    return rawData.indexOfName(name) >= 0;
	  };
	
	  this.indexOfName = function (name) {
	    // Only get data when necessary.
	    // Because LegendVisualProvider constructor may be new in the stage that data is not prepared yet.
	    // Invoking Series#getData immediately will throw an error.
	    var dataWithEncodedVisual = getDataWithEncodedVisual();
	    return dataWithEncodedVisual.indexOfName(name);
	  };
	
	  this.getItemVisual = function (dataIndex, key) {
	    // Get encoded visual properties from final filtered data.
	    var dataWithEncodedVisual = getDataWithEncodedVisual();
	    return dataWithEncodedVisual.getItemVisual(dataIndex, key);
	  };
	}
	
	var _default = LegendVisualProvider;
	module.exports = _default;

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(125);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(357),
	    isArrayLike = __webpack_require__(109),
	    isIndex = __webpack_require__(492),
	    isObject = __webpack_require__(177);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(275);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 273 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(109),
	    isObjectLike = __webpack_require__(146);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(175),
	    isObjectLike = __webpack_require__(146);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(1910);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var EventPluginRegistry = __webpack_require__(499);
	var EventPluginUtils = __webpack_require__(500);
	var ReactErrorUtils = __webpack_require__(504);
	
	var accumulateInto = __webpack_require__(968);
	var forEachAccumulated = __webpack_require__(969);
	var invariant = __webpack_require__(28);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(277);
	var EventPluginUtils = __webpack_require__(500);
	
	var accumulateInto = __webpack_require__(968);
	var forEachAccumulated = __webpack_require__(969);
	var warning = __webpack_require__(34);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 279 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(127);
	
	var getEventTarget = __webpack_require__(509);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 281 */
37,
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _propTypes = __webpack_require__(4);
	
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = (0, _propTypes.shape)({
	  listen: _propTypes.func.isRequired,
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired
	});
	
	var component = exports.component = _propTypes.elementType;
	var components = exports.components = (0, _propTypes.oneOfType)([component, _propTypes.object]);
	var route = exports.route = (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.element]);
	var routes = exports.routes = (0, _propTypes.oneOfType)([route, (0, _propTypes.arrayOf)(route)]);

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _HomeAction = __webpack_require__(52);
	
	var _HomeAction2 = _interopRequireDefault(_HomeAction);
	
	var _Action = __webpack_require__(1017);
	
	var _Action2 = _interopRequireDefault(_Action);
	
	var _Notif = __webpack_require__(2095);
	
	var _Notif2 = _interopRequireDefault(_Notif);
	
	var _ActionConstants = __webpack_require__(2096);
	
	var _uuid = __webpack_require__(44);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActionComponent = function (_Component) {
		_inherits(ActionComponent, _Component);
	
		function ActionComponent() {
			_classCallCheck(this, ActionComponent);
	
			return _possibleConstructorReturn(this, (ActionComponent.__proto__ || Object.getPrototypeOf(ActionComponent)).apply(this, arguments));
		}
	
		_createClass(ActionComponent, [{
			key: 'setAction',
			value: function setAction(actions) {
				var comp = actions.map(function (action) {
					switch (action.type) {
						case _ActionConstants.NOTIF:
							return _react2.default.createElement(_Notif2.default, { key: 'notif-' + action.title, onClick: action.fn, icon: action.icon, content: action.content, title: action.title, color: action.color, label: action.label, notifs: action.notifs });
						default:
							return _react2.default.createElement(_Action2.default, { key: _uuid2.default.v4(), onClick: action.fn, icon: action.icon, component: action.component, title: action.title });
					}
				});
				_AppStore2.default.dispatch(_HomeAction2.default.setAction(comp));
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				_AppStore2.default.dispatch(_HomeAction2.default.setAction([]));
			}
		}, {
			key: 'render',
			value: function render() {
				return null;
			}
		}]);
	
		return ActionComponent;
	}(_react.Component);
	
	exports.default = ActionComponent;

/***/ },
/* 284 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.login = obj.userlogin;
		this.credit = obj.credit;
	};
	
	exports.default = _class;

/***/ },
/* 285 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.code = obj.code;
		this.mnemonique = obj.mnemonique;
	};
	
	exports.default = _class;

/***/ },
/* 286 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.code = obj.code;
		this.supportCode = obj.support_id;
		this.beginDate = obj.date_creation;
		this.endDate = obj.date_close;
		this.xCoordinate = obj.x_coordinate;
		this.yCoordinate = obj.y_coordinate;
		this.name = obj.code;
	};
	
	exports.default = _class;

/***/ },
/* 287 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.pickupid;
		this.date = obj.pickupdate;
		this.sampleNumber = obj.pickupsample;
		this.comments = obj.pickupcomment;
		this.producerReference = obj.pickupproducer;
		this.idStation = obj.pickupqualitometer;
	};
	
	exports.default = _class;

/***/ },
/* 288 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		CITY: {
			i18n: 'town',
			color: '56,61,128',
			type: 'CITY'
		},
		WATERSHED: {
			i18n: 'watershed',
			color: '22,24,50',
			type: 'WATERSHED'
		},
		STATION: {
			i18n: 'station',
			color: '84,91,191',
			type: 'STATION'
		},
		DEPARTMENT: {
			i18n: 'department',
			color: '56,61,128',
			type: 'DEPARTMENT'
		},
		RADIUS: {
			i18n: 'radius',
			color: '22,24,50',
			type: 'RADIUS'
		},
		LAYER: {
			i18n: 'layer',
			color: '22,24,50',
			type: 'LAYER'
		},
		THEME: {
			i18n: 'themes',
			color: '22,24,50',
			type: 'THEME'
		},
		MANAGEMENT_WATER: {
			i18n: 'managementWater',
			color: '22,24,50',
			type: 'MANAGEMENT_WATER'
		}
	};

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _openlayers = __webpack_require__(110);
	
	var _openlayers2 = _interopRequireDefault(_openlayers);
	
	var _reactDom = __webpack_require__(51);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__(15);
	
	var _reactRedux = __webpack_require__(18);
	
	var _HoverDto = __webpack_require__(1046);
	
	var _HoverDto2 = _interopRequireDefault(_HoverDto);
	
	var _SiteTypes = __webpack_require__(56);
	
	var _SiteTypes2 = _interopRequireDefault(_SiteTypes);
	
	var _DtoSiteType = __webpack_require__(96);
	
	var _DtoSiteType2 = _interopRequireDefault(_DtoSiteType);
	
	var _SitesConstants = __webpack_require__(226);
	
	var _reactDnd = __webpack_require__(218);
	
	var _ItemTypes = __webpack_require__(374);
	
	var _ItemTypes2 = _interopRequireDefault(_ItemTypes);
	
	var _BoxDustbin = __webpack_require__(2104);
	
	var _BoxDustbin2 = _interopRequireDefault(_BoxDustbin);
	
	var _LegendDto = __webpack_require__(373);
	
	var _LegendDto2 = _interopRequireDefault(_LegendDto);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _AdministrationAction = __webpack_require__(61);
	
	var _AdministrationAction2 = _interopRequireDefault(_AdministrationAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import Popup from './Popup'
	
	var Map = function (_Component) {
		_inherits(Map, _Component);
	
		function Map(props) {
			_classCallCheck(this, Map);
	
			var _this = _possibleConstructorReturn(this, (Map.__proto__ || Object.getPrototypeOf(Map)).call(this, props));
	
			_this.state = {
				event: {},
				popup: {
					filters: ['Point', 'Polygon']
				}
			};
			_this.moveBox = _this.moveBox.bind(_this);
			_this.removeBox = _this.removeBox.bind(_this);
			_this.clickMap = _this.clickMap.bind(_this);
			return _this;
		}
	
		_createClass(Map, [{
			key: 'moveBox',
			value: function moveBox(id, left, top, content) {
				var boxes = this.props.legends.slice();
				var box = (0, _lodash.findIndex)(boxes, function (b) {
					return b.id === id;
				});
				if (box === -1) {
					boxes.push({ id: id, content: content, left: left, top: top });
				}
				_AppStore2.default.dispatch(_AdministrationAction2.default.setLegends(boxes.map(function (b) {
					if (b.id === id) {
						b.left = left;
						b.top = top;
					}
					return b;
				})));
			}
		}, {
			key: 'removeBox',
			value: function removeBox(id) {
				var boxes = this.props.legends.filter(function (b) {
					return b.id !== id;
				});
				_AppStore2.default.dispatch(_AdministrationAction2.default.setLegends(boxes));
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _this2 = this;
	
				var layersTab = this.props.layers.map(function (el) {
					return el.getLayer();
				});
				var map = new _openlayers2.default.Map({
					controls: _openlayers2.default.control.defaults({
						attribution: false
					}).extend([new _openlayers2.default.control.ScaleLine()]),
					layers: layersTab,
					view: new _openlayers2.default.View({
						//extent: ol.proj.transformExtent([0.882156, 45.296869, 4.087841, 49.069019], 'EPSG:4326', 'EPSG:3857'),
						center: _openlayers2.default.proj.fromLonLat(this.props.mapConf.center),
						zoom: this.props.mapConf.zoom
					})
				});
				this.olMap = map;
				this.visualisation = {};
				this.layers = {};
				this.hover = new _openlayers2.default.layer.Vector({
					source: new _openlayers2.default.source.Vector({})
				});
				this.hover.setZIndex(9999);
				this.olMap.addLayer(this.hover);
				//this.setVisualisationsLayers()
				this.olMap.getLayers().forEach(function (l) {
					var type = l.get('type');
					if (l.get('id') === 'points' && type && type.type) {
						_this2.layers[type.type] = l;
					}
				});
			}
		}, {
			key: 'setVisualisationsLayers',
			value: function setVisualisationsLayers() {
				var _this3 = this;
	
				if (this.visualisation.element) {
					this.visualisation.element.remove();
					this.visualisation.element = null;
				}
				if (this.visualisation.overlay) {
					this.olMap.removeOverlay(this.visualisation.overlay);
					this.visualisation.overlay = null;
				}
				if (this.visualisation.layer) {
					this.olMap.removeLayer(this.visualisation.layer);
					this.visualisation.layer = null;
				}
				if (this.visualisation.interaction) {
					this.olMap.removeInteraction(this.visualisation.interaction);
					this.visualisation.interaction = null;
				}
	
				switch (this.props.visualisation) {
					case _SitesConstants.PANEL_RADIUS:
						this.setState({ popup: { filter: [] } });
						var source = new _openlayers2.default.source.Vector({ wrapX: false });
						var vector = new _openlayers2.default.layer.Vector({
							id: _SitesConstants.PANEL_RADIUS,
							source: source
						});
						this.olMap.addLayer(vector);
						this.visualisation.layer = vector;
						var draw = new _openlayers2.default.interaction.Draw({
							source: source,
							type: 'Circle'
						});
						this.olMap.addInteraction(draw);
						this.visualisation.interaction = draw;
						this.listener = '';
						this.visualisation.element = document.createElement('div');
						this.visualisation.element.className = 'tooltip tooltip-measure';
						document.body.prepend(this.visualisation.element);
						var measureTooltip = new _openlayers2.default.Overlay({
							element: this.visualisation.element,
							offset: [0, -15],
							positioning: 'bottom-center'
						});
						this.olMap.addOverlay(measureTooltip);
						this.visualisation.overlay = measureTooltip;
	
						draw.on('drawstart', function (e) {
							e.feature.getGeometry().on('change', function (event) {
								var units = _this3.olMap.getView().getProjection().getUnits();
								_this3.listener = event.target;
								_this3.visualisation.element.innerHTML = (_this3.listener.getRadius() * _openlayers2.default.proj.METERS_PER_UNIT[units] / 1000).toFixed(2);
								measureTooltip.setPosition(_this3.listener.getLastCoordinate());
							});
						}, this);
						draw.on('drawend', function (e) {
							var coord = _openlayers2.default.proj.transform(e.feature.getGeometry().getFirstCoordinate(), 'EPSG:3857', 'EPSG:4326');
							var radius = _this3.listener.getRadius() / 1000;
							_this3.visualisation.element.innerHTML = '';
							_this3.props.radius(coord, radius);
							_this3.setVisualisationsLayers();
						}, this);
						break;
					default:
						this.setState({ popup: { filters: ['Point', 'Polygon'] } });
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this4 = this;
	
				var overlay = new _openlayers2.default.Overlay({
					element: document.getElementById('popup-container'),
					positioning: 'bottom-center',
					offset: [0, -10]
				});
				this.overlay = overlay;
				this.olMap.addOverlay(overlay);
	
				this.olMap.on('click', function (e) {
					overlay.setPosition();
					var features = [];
					_this4.olMap.forEachFeatureAtPixel(e.pixel, function (f) {
						features.push(f);
					});
					var featuresByType = features.filter(function (p) {
						return p.I.name && (p.I.name.id || p.I.id);
					}).reduce(function (a, v) {
						if (!a[v.I.type.type]) {
							a[v.I.type.type] = {
								sites: '',
								type: v.I.type
							};
						}
						//const siteType = this.props.siteTypes.find(o => o.parameter === v.I.type.type)
						a[v.I.type.type].sites += '<div class=\'percel-link\'>' + v.I.name + ' - ' + v.I.code + '</div>';
						return a;
					}, {});
					var content = Object.keys(featuresByType).map(function (k) {
						var p = featuresByType[k];
						return '<div class=\'sites-component\'><h5 class=\'site-type-title\'>' + p.type.title + '</h5><div class=\'sites-component\'>' + p.sites + '</div></div>';
					}).join('');
					if (content && features.length) {
						var coords = features[0].getGeometry().getCoordinates();
						overlay.getElement().innerHTML = '<div class=\'popup-content\'>' + content + '</div>';
						overlay.setPosition(coords);
					}
				});
	
				var map = _reactDom2.default.findDOMNode(this.refs[this.props.idRef]);
				this.olMap.setTarget(map);
				if (this.props.mapConf.extent && this.props.mapConf.extent.length === 4) {
					this.olMap.getView().fit(_openlayers2.default.proj.transformExtent(this.props.mapConf.extent, 'EPSG:4326', 'EPSG:3857'), this.olMap.getSize());
				}
				this.olMap.updateSize();
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var _this5 = this;
	
				var added = nextProps.layers.filter(function (next) {
					return !_this5.props.layers.find(function (prec) {
						return prec === next;
					});
				});
				added.forEach(function (element) {
					_this5.olMap.addLayer(element.getLayer());
				}, this);
	
				var removed = this.props.layers.filter(function (prec) {
					return !nextProps.layers.find(function (next) {
						return prec === next;
					});
				});
	
				removed.forEach(function (element) {
					_this5.olMap.removeLayer(element.getLayer());
				}, this);
				if (nextProps.mapConf.extent && !(0, _lodash.isEqual)(nextProps.mapConf.extent, this.props.mapConf.extent)) {
					this.olMap.getView().fit(_openlayers2.default.proj.transformExtent(nextProps.mapConf.extent, 'EPSG:4326', 'EPSG:3857'), this.olMap.getSize());
					if (nextProps.mapConf.zoom != this.props.mapConf.zoom) {
						this.olMap.getView().setZoom(nextProps.mapConf.zoom);
					}
				} else if (nextProps.mapConf.zoom != this.props.mapConf.zoom) {
					this.olMap.getView().setCenter(_openlayers2.default.proj.fromLonLat(nextProps.mapConf.center));
					this.olMap.getView().setZoom(nextProps.mapConf.zoom);
				}
				if (!(0, _lodash.isEqual)(nextProps.hover, this.props.hover)) {
					this.removeFeatures(this.hover);
					if (this.layers && this.layers[nextProps.hover.type]) {
						var point = this.layers[nextProps.hover.type].getSource().getFeatures().find(function (f) {
							return f.get('id') === nextProps.hover.id;
						});
						if (point) {
							var hoverFeature = new _openlayers2.default.Feature({
								geometry: point.getGeometry()
							});
							hoverFeature.setStyle(_SiteTypes2.default.createIconStyleHover(_SiteTypes2.default[nextProps.hover.type].icon));
							this.hover.getSource().addFeature(hoverFeature);
							//point.setStyle(SiteTypes.createIconStyleHover(SiteTypes[nextProps.hover.type].icon))
						}
					}
				} else {
					this.olMap.removeOverlay(this.overLay);
				}
				if (this.props.layers !== nextProps.layers) {
					this.olMap.getLayers().forEach(function (l) {
						var type = l.get('type');
						if (l.get('id') === 'points' && type && type.type) {
							_this5.layers[type.type] = l;
						}
					});
				}
				this.olMap.updateSize();
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps) {
				if (prevProps.visualisation !== this.props.visualisation) {
					this.setVisualisationsLayers(prevProps);
				}
				this.olMap.updateSize();
			}
		}, {
			key: 'removeFeatures',
			value: function removeFeatures(layer) {
				layer.getSource().getFeatures().forEach(function (f) {
					layer.getSource().removeFeature(f);
				});
			}
	
			/*createMeasureTooltip = () => {
	  	if (this.measureTooltipElement) {
	  		this.measureTooltipElement.parentNode.removeChild(this.measureTooltipElement)
	  	}
	  	this.measureTooltipElement = document.createElement('div')
	  	this.measureTooltipElement.className = 'tooltip tooltip-measure'
	  	this.measureTooltip = new ol.Overlay({
	  		element: this.measureTooltipElement,
	  		offset: [0, -15],
	  		positioning: 'bottom-center'
	  	})
	  	this.olMap.addOverlay(this.measureTooltip)
	  }*/
	
		}, {
			key: 'clickMap',
			value: function clickMap(e) {
				e.preventDefault();
				/*if (this.props.visualisation === PANEL_CITY) {
	   	this.setState({ event: { clientX: e.clientX, clientY: e.clientY } })
	   	if (this.props.event) {
	   		const coordinate = this.olMap.getCoordinateFromPixel(this.olMap.getEventPixel({
	   			clientX: e.clientX,
	   			clientY: e.clientY
	   		}))
	   		const pointTransform = ol.proj.transform(coordinate, 'EPSG:3857', 'EPSG:4326')
	   		this.props.event(pointTransform, this.state.zoom)
	   	}
	   }*/
	
				if (this.props.event) {
					var coordinate = this.olMap.getCoordinateFromPixel(this.olMap.getEventPixel({
						clientX: e.clientX,
						clientY: e.clientY
					}));
					var pointTransform = _openlayers2.default.proj.transform(coordinate, 'EPSG:3857', 'EPSG:4326');
					this.props.event(pointTransform, this.olMap.getView().getZoom());
				}
			}
		}, {
			key: 'render',
			value: function render() {
				return this.props.connectDropTarget(_react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'div',
						{ ref: this.props.idRef, id: 'map', style: { height: this.props.mapConf.size + 'px' },
							onClick: this.clickMap },
						this.props.legends.map(function (b) {
							var id = b.id,
							    left = b.left,
							    top = b.top,
							    content = b.content;
	
							return _react2.default.createElement(
								_BoxDustbin2.default,
								{ key: id, id: id, left: left,
									top: top, hideSourceOnDrag: true },
								content
							);
						})
					),
					_react2.default.createElement('div', { className: 'arrow_box ol-popup', id: 'popup-container' })
				));
			}
		}]);
	
		return Map;
	}(_react.Component);
	
	Map.propTypes = {
		layers: _propTypes2.default.arrayOf(_propTypes2.default.object),
		mapConf: _propTypes2.default.shape({
			size: _propTypes2.default.number,
			center: _propTypes2.default.array,
			zoom: _propTypes2.default.number,
			extent: _propTypes2.default.arrayOf(_propTypes2.default.number)
		}),
		event: _propTypes2.default.func,
		drawFunction: _propTypes2.default.bool,
		radius: _propTypes2.default.func,
		hover: _propTypes2.default.instanceOf(_HoverDto2.default),
		idRef: _propTypes2.default.string,
		visualisation: _propTypes2.default.string,
		legends: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_LegendDto2.default)),
		siteTypes: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoSiteType2.default)),
		connectDropTarget: _propTypes2.default.func.isRequired
	};
	
	Map.defaultProps = {
		mapConf: {
			size: 300,
			center: [47.123010186224576, -1.820669934399723],
			zoom: 10,
			extent: null
		},
		layers: [],
		drawFunction: false,
		event: function event() {},
		radius: function radius() {},
		idRef: 'map',
		visualisation: _SitesConstants.PANEL_CITY
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			visualisation: store.SitesReducer.visualisation,
			hover: store.SitesReducer.hover,
			siteTypes: store.ReferentialReducer.siteTypes,
			legends: store.AdministrationReducer.legends
		};
	};
	
	var boxTarget = {
		drop: function drop(props, monitor, component) {
			var moveBox = function moveBox(box) {
				var delta = monitor.getDifferenceFromInitialOffset();
				if (delta) {
					var left = Math.round(box.left + delta.x);
					var top = Math.round(box.top + delta.y);
					component.moveBox(box.id, left, top, box.children);
				} else {
					component.removeBox(box.id);
				}
			};
	
			var item = monitor.getItem();
			if (item.id && item.left && item.top) {
				moveBox(item);
			} else if (item.boxes && item.boxes.length) {
				item.boxes.forEach(function (b) {
					return moveBox(b);
				});
			}
		}
	};
	
	var collect = function collect(dndConnect) {
		return {
			connectDropTarget: dndConnect.dropTarget()
		};
	};
	
	var dropTarget = (0, _reactDnd.DropTarget)([_ItemTypes2.default.BOX, _ItemTypes2.default.DUSTBIN_BOX], boxTarget, collect)(Map);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(dropTarget);

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = OSM;
	
	var _ILayers = __webpack_require__(229);
	
	var _ILayers2 = _interopRequireDefault(_ILayers);
	
	var _openlayers = __webpack_require__(110);
	
	var _openlayers2 = _interopRequireDefault(_openlayers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _OSM = function (_Layers) {
	    _inherits(_OSM, _Layers);
	
	    function _OSM() {
	        _classCallCheck(this, _OSM);
	
	        var _this = _possibleConstructorReturn(this, (_OSM.__proto__ || Object.getPrototypeOf(_OSM)).call(this));
	
	        _this.layer = _this.createLayer();
	        return _this;
	    }
	
	    _createClass(_OSM, [{
	        key: 'createLayer',
	        value: function createLayer() {
	            return new _openlayers2.default.layer.Tile({
	                source: new _openlayers2.default.source.OSM()
	            });
	        }
	    }, {
	        key: 'getLayer',
	        value: function getLayer() {
	            return this.layer;
	        }
	    }]);
	
	    return _OSM;
	}(_ILayers2.default);
	
	function OSM() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	    }
	
	    return new (Function.prototype.bind.apply(_OSM, [null].concat(args)))();
	}

/***/ },
/* 291 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	var vec2 = __webpack_require__(41);
	
	var curve = __webpack_require__(152);
	
	/**
	 * @author Yi Shen(https://github.com/pissang)
	 */
	var mathMin = Math.min;
	var mathMax = Math.max;
	var mathSin = Math.sin;
	var mathCos = Math.cos;
	var PI2 = Math.PI * 2;
	var start = vec2.create();
	var end = vec2.create();
	var extremity = vec2.create();
	/**
	 * 从顶点数组中计算出最小包围盒，写入`min`和`max`中
	 * @module zrender/core/bbox
	 * @param {Array<Object>} points 顶点数组
	 * @param {number} min
	 * @param {number} max
	 */
	
	function fromPoints(points, min, max) {
	  if (points.length === 0) {
	    return;
	  }
	
	  var p = points[0];
	  var left = p[0];
	  var right = p[0];
	  var top = p[1];
	  var bottom = p[1];
	  var i;
	
	  for (i = 1; i < points.length; i++) {
	    p = points[i];
	    left = mathMin(left, p[0]);
	    right = mathMax(right, p[0]);
	    top = mathMin(top, p[1]);
	    bottom = mathMax(bottom, p[1]);
	  }
	
	  min[0] = left;
	  min[1] = top;
	  max[0] = right;
	  max[1] = bottom;
	}
	/**
	 * @memberOf module:zrender/core/bbox
	 * @param {number} x0
	 * @param {number} y0
	 * @param {number} x1
	 * @param {number} y1
	 * @param {Array.<number>} min
	 * @param {Array.<number>} max
	 */
	
	
	function fromLine(x0, y0, x1, y1, min, max) {
	  min[0] = mathMin(x0, x1);
	  min[1] = mathMin(y0, y1);
	  max[0] = mathMax(x0, x1);
	  max[1] = mathMax(y0, y1);
	}
	
	var xDim = [];
	var yDim = [];
	/**
	 * 从三阶贝塞尔曲线(p0, p1, p2, p3)中计算出最小包围盒，写入`min`和`max`中
	 * @memberOf module:zrender/core/bbox
	 * @param {number} x0
	 * @param {number} y0
	 * @param {number} x1
	 * @param {number} y1
	 * @param {number} x2
	 * @param {number} y2
	 * @param {number} x3
	 * @param {number} y3
	 * @param {Array.<number>} min
	 * @param {Array.<number>} max
	 */
	
	function fromCubic(x0, y0, x1, y1, x2, y2, x3, y3, min, max) {
	  var cubicExtrema = curve.cubicExtrema;
	  var cubicAt = curve.cubicAt;
	  var i;
	  var n = cubicExtrema(x0, x1, x2, x3, xDim);
	  min[0] = Infinity;
	  min[1] = Infinity;
	  max[0] = -Infinity;
	  max[1] = -Infinity;
	
	  for (i = 0; i < n; i++) {
	    var x = cubicAt(x0, x1, x2, x3, xDim[i]);
	    min[0] = mathMin(x, min[0]);
	    max[0] = mathMax(x, max[0]);
	  }
	
	  n = cubicExtrema(y0, y1, y2, y3, yDim);
	
	  for (i = 0; i < n; i++) {
	    var y = cubicAt(y0, y1, y2, y3, yDim[i]);
	    min[1] = mathMin(y, min[1]);
	    max[1] = mathMax(y, max[1]);
	  }
	
	  min[0] = mathMin(x0, min[0]);
	  max[0] = mathMax(x0, max[0]);
	  min[0] = mathMin(x3, min[0]);
	  max[0] = mathMax(x3, max[0]);
	  min[1] = mathMin(y0, min[1]);
	  max[1] = mathMax(y0, max[1]);
	  min[1] = mathMin(y3, min[1]);
	  max[1] = mathMax(y3, max[1]);
	}
	/**
	 * 从二阶贝塞尔曲线(p0, p1, p2)中计算出最小包围盒，写入`min`和`max`中
	 * @memberOf module:zrender/core/bbox
	 * @param {number} x0
	 * @param {number} y0
	 * @param {number} x1
	 * @param {number} y1
	 * @param {number} x2
	 * @param {number} y2
	 * @param {Array.<number>} min
	 * @param {Array.<number>} max
	 */
	
	
	function fromQuadratic(x0, y0, x1, y1, x2, y2, min, max) {
	  var quadraticExtremum = curve.quadraticExtremum;
	  var quadraticAt = curve.quadraticAt; // Find extremities, where derivative in x dim or y dim is zero
	
	  var tx = mathMax(mathMin(quadraticExtremum(x0, x1, x2), 1), 0);
	  var ty = mathMax(mathMin(quadraticExtremum(y0, y1, y2), 1), 0);
	  var x = quadraticAt(x0, x1, x2, tx);
	  var y = quadraticAt(y0, y1, y2, ty);
	  min[0] = mathMin(x0, x2, x);
	  min[1] = mathMin(y0, y2, y);
	  max[0] = mathMax(x0, x2, x);
	  max[1] = mathMax(y0, y2, y);
	}
	/**
	 * 从圆弧中计算出最小包围盒，写入`min`和`max`中
	 * @method
	 * @memberOf module:zrender/core/bbox
	 * @param {number} x
	 * @param {number} y
	 * @param {number} rx
	 * @param {number} ry
	 * @param {number} startAngle
	 * @param {number} endAngle
	 * @param {number} anticlockwise
	 * @param {Array.<number>} min
	 * @param {Array.<number>} max
	 */
	
	
	function fromArc(x, y, rx, ry, startAngle, endAngle, anticlockwise, min, max) {
	  var vec2Min = vec2.min;
	  var vec2Max = vec2.max;
	  var diff = Math.abs(startAngle - endAngle);
	
	  if (diff % PI2 < 1e-4 && diff > 1e-4) {
	    // Is a circle
	    min[0] = x - rx;
	    min[1] = y - ry;
	    max[0] = x + rx;
	    max[1] = y + ry;
	    return;
	  }
	
	  start[0] = mathCos(startAngle) * rx + x;
	  start[1] = mathSin(startAngle) * ry + y;
	  end[0] = mathCos(endAngle) * rx + x;
	  end[1] = mathSin(endAngle) * ry + y;
	  vec2Min(min, start, end);
	  vec2Max(max, start, end); // Thresh to [0, Math.PI * 2]
	
	  startAngle = startAngle % PI2;
	
	  if (startAngle < 0) {
	    startAngle = startAngle + PI2;
	  }
	
	  endAngle = endAngle % PI2;
	
	  if (endAngle < 0) {
	    endAngle = endAngle + PI2;
	  }
	
	  if (startAngle > endAngle && !anticlockwise) {
	    endAngle += PI2;
	  } else if (startAngle < endAngle && anticlockwise) {
	    startAngle += PI2;
	  }
	
	  if (anticlockwise) {
	    var tmp = endAngle;
	    endAngle = startAngle;
	    startAngle = tmp;
	  } // var number = 0;
	  // var step = (anticlockwise ? -Math.PI : Math.PI) / 2;
	
	
	  for (var angle = 0; angle < endAngle; angle += Math.PI / 2) {
	    if (angle > startAngle) {
	      extremity[0] = mathCos(angle) * rx + x;
	      extremity[1] = mathSin(angle) * ry + y;
	      vec2Min(min, extremity, min);
	      vec2Max(max, extremity, max);
	    }
	  }
	}
	
	exports.fromPoints = fromPoints;
	exports.fromLine = fromLine;
	exports.fromCubic = fromCubic;
	exports.fromQuadratic = fromQuadratic;
	exports.fromArc = fromArc;

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(385);
	
	var debugMode = _config.debugMode;
	
	var logError = function () {};
	
	if (debugMode === 1) {
	  logError = console.error;
	}
	
	var _default = logError;
	module.exports = _default;

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(3);
	
	var Style = __webpack_require__(558);
	
	var Element = __webpack_require__(1076);
	
	var RectText = __webpack_require__(1092);
	
	/**
	 * Base class of all displayable graphic objects
	 * @module zrender/graphic/Displayable
	 */
	
	/**
	 * @alias module:zrender/graphic/Displayable
	 * @extends module:zrender/Element
	 * @extends module:zrender/graphic/mixin/RectText
	 */
	function Displayable(opts) {
	  opts = opts || {};
	  Element.call(this, opts); // Extend properties
	
	  for (var name in opts) {
	    if (opts.hasOwnProperty(name) && name !== 'style') {
	      this[name] = opts[name];
	    }
	  }
	  /**
	   * @type {module:zrender/graphic/Style}
	   */
	
	
	  this.style = new Style(opts.style, this);
	  this._rect = null; // Shapes for cascade clipping.
	  // Can only be `null`/`undefined` or an non-empty array, MUST NOT be an empty array.
	  // because it is easy to only using null to check whether clipPaths changed.
	
	  this.__clipPaths = null; // FIXME Stateful must be mixined after style is setted
	  // Stateful.call(this, opts);
	}
	
	Displayable.prototype = {
	  constructor: Displayable,
	  type: 'displayable',
	
	  /**
	   * Dirty flag. From which painter will determine if this displayable object needs brush.
	   * @name module:zrender/graphic/Displayable#__dirty
	   * @type {boolean}
	   */
	  __dirty: true,
	
	  /**
	   * Whether the displayable object is visible. when it is true, the displayable object
	   * is not drawn, but the mouse event can still trigger the object.
	   * @name module:/zrender/graphic/Displayable#invisible
	   * @type {boolean}
	   * @default false
	   */
	  invisible: false,
	
	  /**
	   * @name module:/zrender/graphic/Displayable#z
	   * @type {number}
	   * @default 0
	   */
	  z: 0,
	
	  /**
	   * @name module:/zrender/graphic/Displayable#z
	   * @type {number}
	   * @default 0
	   */
	  z2: 0,
	
	  /**
	   * The z level determines the displayable object can be drawn in which layer canvas.
	   * @name module:/zrender/graphic/Displayable#zlevel
	   * @type {number}
	   * @default 0
	   */
	  zlevel: 0,
	
	  /**
	   * Whether it can be dragged.
	   * @name module:/zrender/graphic/Displayable#draggable
	   * @type {boolean}
	   * @default false
	   */
	  draggable: false,
	
	  /**
	   * Whether is it dragging.
	   * @name module:/zrender/graphic/Displayable#draggable
	   * @type {boolean}
	   * @default false
	   */
	  dragging: false,
	
	  /**
	   * Whether to respond to mouse events.
	   * @name module:/zrender/graphic/Displayable#silent
	   * @type {boolean}
	   * @default false
	   */
	  silent: false,
	
	  /**
	   * If enable culling
	   * @type {boolean}
	   * @default false
	   */
	  culling: false,
	
	  /**
	   * Mouse cursor when hovered
	   * @name module:/zrender/graphic/Displayable#cursor
	   * @type {string}
	   */
	  cursor: 'pointer',
	
	  /**
	   * If hover area is bounding rect
	   * @name module:/zrender/graphic/Displayable#rectHover
	   * @type {string}
	   */
	  rectHover: false,
	
	  /**
	   * Render the element progressively when the value >= 0,
	   * usefull for large data.
	   * @type {boolean}
	   */
	  progressive: false,
	
	  /**
	   * @type {boolean}
	   */
	  incremental: false,
	
	  /**
	   * Scale ratio for global scale.
	   * @type {boolean}
	   */
	  globalScaleRatio: 1,
	  beforeBrush: function (ctx) {},
	  afterBrush: function (ctx) {},
	
	  /**
	   * Graphic drawing method.
	   * @param {CanvasRenderingContext2D} ctx
	   */
	  // Interface
	  brush: function (ctx, prevEl) {},
	
	  /**
	   * Get the minimum bounding box.
	   * @return {module:zrender/core/BoundingRect}
	   */
	  // Interface
	  getBoundingRect: function () {},
	
	  /**
	   * If displayable element contain coord x, y
	   * @param  {number} x
	   * @param  {number} y
	   * @return {boolean}
	   */
	  contain: function (x, y) {
	    return this.rectContain(x, y);
	  },
	
	  /**
	   * @param  {Function} cb
	   * @param  {}   context
	   */
	  traverse: function (cb, context) {
	    cb.call(context, this);
	  },
	
	  /**
	   * If bounding rect of element contain coord x, y
	   * @param  {number} x
	   * @param  {number} y
	   * @return {boolean}
	   */
	  rectContain: function (x, y) {
	    var coord = this.transformCoordToLocal(x, y);
	    var rect = this.getBoundingRect();
	    return rect.contain(coord[0], coord[1]);
	  },
	
	  /**
	   * Mark displayable element dirty and refresh next frame
	   */
	  dirty: function () {
	    this.__dirty = this.__dirtyText = true;
	    this._rect = null;
	    this.__zr && this.__zr.refresh();
	  },
	
	  /**
	   * If displayable object binded any event
	   * @return {boolean}
	   */
	  // TODO, events bound by bind
	  // isSilent: function () {
	  //     return !(
	  //         this.hoverable || this.draggable
	  //         || this.onmousemove || this.onmouseover || this.onmouseout
	  //         || this.onmousedown || this.onmouseup || this.onclick
	  //         || this.ondragenter || this.ondragover || this.ondragleave
	  //         || this.ondrop
	  //     );
	  // },
	
	  /**
	   * Alias for animate('style')
	   * @param {boolean} loop
	   */
	  animateStyle: function (loop) {
	    return this.animate('style', loop);
	  },
	  attrKV: function (key, value) {
	    if (key !== 'style') {
	      Element.prototype.attrKV.call(this, key, value);
	    } else {
	      this.style.set(value);
	    }
	  },
	
	  /**
	   * @param {Object|string} key
	   * @param {*} value
	   */
	  setStyle: function (key, value) {
	    this.style.set(key, value);
	    this.dirty(false);
	    return this;
	  },
	
	  /**
	   * Use given style object
	   * @param  {Object} obj
	   */
	  useStyle: function (obj) {
	    this.style = new Style(obj, this);
	    this.dirty(false);
	    return this;
	  },
	
	  /**
	   * The string value of `textPosition` needs to be calculated to a real postion.
	   * For example, `'inside'` is calculated to `[rect.width/2, rect.height/2]`
	   * by default. See `contain/text.js#calculateTextPosition` for more details.
	   * But some coutom shapes like "pin", "flag" have center that is not exactly
	   * `[width/2, height/2]`. So we provide this hook to customize the calculation
	   * for those shapes. It will be called if the `style.textPosition` is a string.
	   * @param {Obejct} [out] Prepared out object. If not provided, this method should
	   *        be responsible for creating one.
	   * @param {module:zrender/graphic/Style} style
	   * @param {Object} rect {x, y, width, height}
	   * @return {Obejct} out The same as the input out.
	   *         {
	   *             x: number. mandatory.
	   *             y: number. mandatory.
	   *             textAlign: string. optional. use style.textAlign by default.
	   *             textVerticalAlign: string. optional. use style.textVerticalAlign by default.
	   *         }
	   */
	  calculateTextPosition: null
	};
	zrUtil.inherits(Displayable, Element);
	zrUtil.mixin(Displayable, RectText); // zrUtil.mixin(Displayable, Stateful);
	
	var _default = Displayable;
	module.exports = _default;

/***/ },
/* 295 */
/***/ function(module, exports) {

	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	module.exports = _createClass;

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Collapse.default;
	  }
	});
	
	var _Collapse = _interopRequireDefault(__webpack_require__(1152));

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _DialogActions.default;
	  }
	});
	
	var _DialogActions = _interopRequireDefault(__webpack_require__(1158));

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useFormControl = useFormControl;
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	/**
	 * @ignore - internal component.
	 */
	var FormControlContext = /*#__PURE__*/React.createContext();
	
	if (false) {
	  FormControlContext.displayName = 'FormControlContext';
	}
	
	function useFormControl() {
	  return React.useContext(FormControlContext);
	}
	
	var _default = FormControlContext;
	exports.default = _default;

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Grow.default;
	  }
	});
	
	var _Grow = _interopRequireDefault(__webpack_require__(1186));

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Icon.default;
	  }
	});
	
	var _Icon = _interopRequireDefault(__webpack_require__(1191));

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Input.default;
	  }
	});
	
	var _Input = _interopRequireDefault(__webpack_require__(1193));

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _LinearProgress.default;
	  }
	});
	
	var _LinearProgress = _interopRequireDefault(__webpack_require__(1198));

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _List.default;
	  }
	});
	
	var _List = _interopRequireDefault(__webpack_require__(1201));

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItem.default;
	  }
	});
	
	var _ListItem = _interopRequireDefault(__webpack_require__(1202));

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemAvatar.default;
	  }
	});
	
	var _ListItemAvatar = _interopRequireDefault(__webpack_require__(1203));

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemText.default;
	  }
	});
	
	var _ListItemText = _interopRequireDefault(__webpack_require__(1208));

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Modal.default;
	  }
	});
	Object.defineProperty(exports, "ModalManager", {
	  enumerable: true,
	  get: function get() {
	    return _ModalManager.default;
	  }
	});
	
	var _Modal = _interopRequireDefault(__webpack_require__(1215));
	
	var _ModalManager = _interopRequireDefault(__webpack_require__(592));

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _SvgIcon.default;
	  }
	});
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(1249));

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ownerWindow;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(90));
	
	function ownerWindow(node) {
	  var doc = (0, _ownerDocument.default)(node);
	  return doc.defaultView || window;
	}

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useId;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	/**
	 * Private module reserved for @material-ui/x packages.
	 */
	function useId(idOverride) {
	  var _React$useState = React.useState(idOverride),
	      defaultId = _React$useState[0],
	      setDefaultId = _React$useState[1];
	
	  var id = idOverride || defaultId;
	  React.useEffect(function () {
	    if (defaultId == null) {
	      // Fallback to this default id when possible.
	      // Use the random value for client-side rendering only.
	      // We can't use it server-side.
	      setDefaultId("mui-".concat(Math.round(Math.random() * 1e5)));
	    }
	  }, [defaultId]);
	  return id;
	}

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = unsupportedProp;
	
	function unsupportedProp(props, propName, componentName, location, propFullName) {
	  if (true) {
	    return null;
	  }
	
	  var propFullNameSafe = propFullName || propName;
	
	  if (typeof props[propName] !== 'undefined') {
	    return new Error("The prop `".concat(propFullNameSafe, "` is not supported. Please remove it."));
	  }
	
	  return null;
	}

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _utils = __webpack_require__(19);
	
	function merge(acc, item) {
	  if (!item) {
	    return acc;
	  }
	
	  return (0, _utils.deepmerge)(acc, item, {
	    clone: false // No need to clone deep, it's way faster.
	
	  });
	}
	
	var _default = merge;
	exports.default = _default;

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var columnController_1 = __webpack_require__(26);
	var eventService_1 = __webpack_require__(22);
	var logger_1 = __webpack_require__(68);
	var events_1 = __webpack_require__(29);
	var context_1 = __webpack_require__(8);
	var context_2 = __webpack_require__(8);
	var context_3 = __webpack_require__(8);
	var context_4 = __webpack_require__(8);
	var AlignedGridsService = /** @class */ (function () {
	    function AlignedGridsService() {
	        // flag to mark if we are consuming. to avoid cyclic events (ie other grid firing back to master
	        // while processing a master event) we mark this if consuming an event, and if we are, then
	        // we don't fire back any events.
	        this.consuming = false;
	    }
	    AlignedGridsService.prototype.setBeans = function (loggerFactory) {
	        this.logger = loggerFactory.create('AlignedGridsService');
	    };
	    AlignedGridsService.prototype.registerGridComp = function (gridPanel) {
	        this.gridPanel = gridPanel;
	    };
	    AlignedGridsService.prototype.init = function () {
	        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_MOVED, this.fireColumnEvent.bind(this));
	        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_VISIBLE, this.fireColumnEvent.bind(this));
	        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_PINNED, this.fireColumnEvent.bind(this));
	        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_GROUP_OPENED, this.fireColumnEvent.bind(this));
	        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_RESIZED, this.fireColumnEvent.bind(this));
	        this.eventService.addEventListener(events_1.Events.EVENT_BODY_SCROLL, this.fireScrollEvent.bind(this));
	    };
	    // common logic across all the fire methods
	    AlignedGridsService.prototype.fireEvent = function (callback) {
	        // if we are already consuming, then we are acting on an event from a master,
	        // so we don't cause a cyclic firing of events
	        if (this.consuming) {
	            return;
	        }
	        // iterate through the aligned grids, and pass each aligned grid service to the callback
	        var otherGrids = this.gridOptionsWrapper.getAlignedGrids();
	        if (otherGrids) {
	            otherGrids.forEach(function (otherGridOptions) {
	                if (otherGridOptions.api) {
	                    var alignedGridService = otherGridOptions.api.__getAlignedGridService();
	                    callback(alignedGridService);
	                }
	            });
	        }
	    };
	    // common logic across all consume methods. very little common logic, however extracting
	    // guarantees consistency across the methods.
	    AlignedGridsService.prototype.onEvent = function (callback) {
	        this.consuming = true;
	        callback();
	        this.consuming = false;
	    };
	    AlignedGridsService.prototype.fireColumnEvent = function (event) {
	        this.fireEvent(function (alignedGridsService) {
	            alignedGridsService.onColumnEvent(event);
	        });
	    };
	    AlignedGridsService.prototype.fireScrollEvent = function (event) {
	        if (event.direction !== 'horizontal') {
	            return;
	        }
	        this.fireEvent(function (alignedGridsService) {
	            alignedGridsService.onScrollEvent(event);
	        });
	    };
	    AlignedGridsService.prototype.onScrollEvent = function (event) {
	        var _this = this;
	        this.onEvent(function () {
	            _this.gridPanel.setHorizontalScrollPosition(event.left);
	        });
	    };
	    AlignedGridsService.prototype.getMasterColumns = function (event) {
	        var result = [];
	        if (event.columns) {
	            event.columns.forEach(function (column) {
	                result.push(column);
	            });
	        }
	        else if (event.column) {
	            result.push(event.column);
	        }
	        return result;
	    };
	    AlignedGridsService.prototype.getColumnIds = function (event) {
	        var result = [];
	        if (event.columns) {
	            event.columns.forEach(function (column) {
	                result.push(column.getColId());
	            });
	        }
	        else if (event.column) {
	            result.push(event.column.getColId());
	        }
	        return result;
	    };
	    AlignedGridsService.prototype.onColumnEvent = function (event) {
	        var _this = this;
	        this.onEvent(function () {
	            switch (event.type) {
	                case events_1.Events.EVENT_COLUMN_MOVED:
	                case events_1.Events.EVENT_COLUMN_VISIBLE:
	                case events_1.Events.EVENT_COLUMN_PINNED:
	                case events_1.Events.EVENT_COLUMN_RESIZED:
	                    var colEvent = event;
	                    _this.processColumnEvent(colEvent);
	                    break;
	                case events_1.Events.EVENT_COLUMN_GROUP_OPENED:
	                    var groupOpenedEvent = event;
	                    _this.processGroupOpenedEvent(groupOpenedEvent);
	                    break;
	                case events_1.Events.EVENT_COLUMN_PIVOT_CHANGED:
	                    // we cannot support pivoting with aligned grids as the columns will be out of sync as the
	                    // grids will have columns created based on the row data of the grid.
	                    console.warn('ag-Grid: pivoting is not supported with aligned grids. ' +
	                        'You can only use one of these features at a time in a grid.');
	                    break;
	            }
	        });
	    };
	    AlignedGridsService.prototype.processGroupOpenedEvent = function (groupOpenedEvent) {
	        // likewise for column group
	        var masterColumnGroup = groupOpenedEvent.columnGroup;
	        var otherColumnGroup;
	        if (masterColumnGroup) {
	            var groupId = masterColumnGroup.getGroupId();
	            otherColumnGroup = this.columnController.getOriginalColumnGroup(groupId);
	        }
	        if (masterColumnGroup && !otherColumnGroup) {
	            return;
	        }
	        this.logger.log('onColumnEvent-> processing ' + groupOpenedEvent + ' expanded = ' + masterColumnGroup.isExpanded());
	        this.columnController.setColumnGroupOpened(otherColumnGroup, masterColumnGroup.isExpanded(), "alignedGridChanged");
	    };
	    AlignedGridsService.prototype.processColumnEvent = function (colEvent) {
	        var _this = this;
	        // the column in the event is from the master grid. need to
	        // look up the equivalent from this (other) grid
	        var masterColumn = colEvent.column;
	        var otherColumn;
	        if (masterColumn) {
	            otherColumn = this.columnController.getPrimaryColumn(masterColumn.getColId());
	        }
	        // if event was with respect to a master column, that is not present in this
	        // grid, then we ignore the event
	        if (masterColumn && !otherColumn) {
	            return;
	        }
	        // in time, all the methods below should use the column ids, it's a more generic way
	        // of handling columns, and also allows for single or multi column events
	        var columnIds = this.getColumnIds(colEvent);
	        var masterColumns = this.getMasterColumns(colEvent);
	        switch (colEvent.type) {
	            case events_1.Events.EVENT_COLUMN_MOVED:
	                var movedEvent = colEvent;
	                this.logger.log("onColumnEvent-> processing " + colEvent.type + " toIndex = " + movedEvent.toIndex);
	                this.columnController.moveColumns(columnIds, movedEvent.toIndex, "alignedGridChanged");
	                break;
	            case events_1.Events.EVENT_COLUMN_VISIBLE:
	                var visibleEvent = colEvent;
	                this.logger.log("onColumnEvent-> processing " + colEvent.type + " visible = " + visibleEvent.visible);
	                this.columnController.setColumnsVisible(columnIds, visibleEvent.visible, "alignedGridChanged");
	                break;
	            case events_1.Events.EVENT_COLUMN_PINNED:
	                var pinnedEvent = colEvent;
	                this.logger.log("onColumnEvent-> processing " + colEvent.type + " pinned = " + pinnedEvent.pinned);
	                this.columnController.setColumnsPinned(columnIds, pinnedEvent.pinned, "alignedGridChanged");
	                break;
	            case events_1.Events.EVENT_COLUMN_RESIZED:
	                var resizedEvent_1 = colEvent;
	                masterColumns.forEach(function (column) {
	                    _this.logger.log("onColumnEvent-> processing " + colEvent.type + " actualWidth = " + column.getActualWidth());
	                    _this.columnController.setColumnWidth(column.getColId(), column.getActualWidth(), false, resizedEvent_1.finished, "alignedGridChanged");
	                });
	                break;
	        }
	        var isVerticalScrollShowing = this.gridPanel.isVerticalScrollShowing();
	        var alignedGrids = this.gridOptionsWrapper.getAlignedGrids();
	        alignedGrids.forEach(function (grid) {
	            grid.api.setAlwaysShowVerticalScroll(isVerticalScrollShowing);
	        });
	    };
	    __decorate([
	        context_3.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], AlignedGridsService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_3.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], AlignedGridsService.prototype, "columnController", void 0);
	    __decorate([
	        context_3.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], AlignedGridsService.prototype, "eventService", void 0);
	    __decorate([
	        __param(0, context_2.Qualifier('loggerFactory')),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [logger_1.LoggerFactory]),
	        __metadata("design:returntype", void 0)
	    ], AlignedGridsService.prototype, "setBeans", null);
	    __decorate([
	        context_4.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], AlignedGridsService.prototype, "init", null);
	    AlignedGridsService = __decorate([
	        context_1.Bean('alignedGridsService')
	    ], AlignedGridsService);
	    return AlignedGridsService;
	}());
	exports.AlignedGridsService = AlignedGridsService;


/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var columnUtils_1 = __webpack_require__(195);
	var columnGroup_1 = __webpack_require__(159);
	var originalColumnGroup_1 = __webpack_require__(196);
	var context_2 = __webpack_require__(8);
	var utils_1 = __webpack_require__(10);
	// takes in a list of columns, as specified by the column definitions, and returns column groups
	var DisplayedGroupCreator = /** @class */ (function () {
	    function DisplayedGroupCreator() {
	    }
	    DisplayedGroupCreator.prototype.createDisplayedGroups = function (
	    // all displayed columns sorted - this is the columns the grid should show
	    sortedVisibleColumns, 
	    // the tree of columns, as provided by the users, used to know what groups columns roll up into
	    balancedColumnTree, 
	    // creates unique id's for the group
	    groupInstanceIdCreator, 
	    // whether it's left, right or center col
	    pinned, 
	    // we try to reuse old groups if we can, to allow gui to do animation
	    oldDisplayedGroups) {
	        var _this = this;
	        var result = [];
	        var previousRealPath;
	        var previousOriginalPath;
	        var oldColumnsMapped = this.mapOldGroupsById(oldDisplayedGroups);
	        // go through each column, then do a bottom up comparison to the previous column, and start
	        // to share groups if they converge at any point.
	        sortedVisibleColumns.forEach(function (currentColumn) {
	            var currentOriginalPath = _this.getOriginalPathForColumn(balancedColumnTree, currentColumn);
	            var currentRealPath = [];
	            var firstColumn = !previousOriginalPath;
	            for (var i = 0; i < currentOriginalPath.length; i++) {
	                if (firstColumn || currentOriginalPath[i] !== previousOriginalPath[i]) {
	                    // new group needed
	                    var newGroup = _this.createColumnGroup(currentOriginalPath[i], groupInstanceIdCreator, oldColumnsMapped, pinned);
	                    currentRealPath[i] = newGroup;
	                    // if top level, add to result, otherwise add to parent
	                    if (i == 0) {
	                        result.push(newGroup);
	                    }
	                    else {
	                        currentRealPath[i - 1].addChild(newGroup);
	                    }
	                }
	                else {
	                    // reuse old group
	                    currentRealPath[i] = previousRealPath[i];
	                }
	            }
	            var noColumnGroups = currentRealPath.length === 0;
	            if (noColumnGroups) {
	                // if we are not grouping, then the result of the above is an empty
	                // path (no groups), and we just add the column to the root list.
	                result.push(currentColumn);
	            }
	            else {
	                var leafGroup = utils_1._.last(currentRealPath);
	                leafGroup.addChild(currentColumn);
	            }
	            previousRealPath = currentRealPath;
	            previousOriginalPath = currentOriginalPath;
	        });
	        this.setupParentsIntoColumns(result, null);
	        return result;
	    };
	    DisplayedGroupCreator.prototype.createColumnGroup = function (originalGroup, groupInstanceIdCreator, oldColumnsMapped, pinned) {
	        var groupId = originalGroup.getGroupId();
	        var instanceId = groupInstanceIdCreator.getInstanceIdForKey(groupId);
	        var uniqueId = columnGroup_1.ColumnGroup.createUniqueId(groupId, instanceId);
	        var columnGroup = oldColumnsMapped[uniqueId];
	        // if the user is setting new colDefs, it is possible that the id's overlap, and we
	        // would have a false match from above. so we double check we are talking about the
	        // same original column group.
	        if (columnGroup && columnGroup.getOriginalColumnGroup() !== originalGroup) {
	            columnGroup = null;
	        }
	        if (utils_1._.exists(columnGroup)) {
	            // clean out the old column group here, as we will be adding children into it again
	            columnGroup.reset();
	        }
	        else {
	            columnGroup = new columnGroup_1.ColumnGroup(originalGroup, groupId, instanceId, pinned);
	            this.context.wireBean(columnGroup);
	        }
	        return columnGroup;
	    };
	    // returns back a 2d map of ColumnGroup as follows: groupId -> instanceId -> ColumnGroup
	    DisplayedGroupCreator.prototype.mapOldGroupsById = function (displayedGroups) {
	        var result = {};
	        var recursive = function (columnsOrGroups) {
	            columnsOrGroups.forEach(function (columnOrGroup) {
	                if (columnOrGroup instanceof columnGroup_1.ColumnGroup) {
	                    var columnGroup = columnOrGroup;
	                    result[columnOrGroup.getUniqueId()] = columnGroup;
	                    recursive(columnGroup.getChildren());
	                }
	            });
	        };
	        if (displayedGroups) {
	            recursive(displayedGroups);
	        }
	        return result;
	    };
	    DisplayedGroupCreator.prototype.setupParentsIntoColumns = function (columnsOrGroups, parent) {
	        var _this = this;
	        columnsOrGroups.forEach(function (columnsOrGroup) {
	            columnsOrGroup.setParent(parent);
	            if (columnsOrGroup instanceof columnGroup_1.ColumnGroup) {
	                var columnGroup = columnsOrGroup;
	                _this.setupParentsIntoColumns(columnGroup.getChildren(), columnGroup);
	            }
	        });
	    };
	    // private createFakePath(balancedColumnTree: OriginalColumnGroupChild[], column: Column): OriginalColumnGroup[] {
	    //     let fakePath: OriginalColumnGroup[] = [];
	    //     let currentChildren = balancedColumnTree;
	    //     // this while loop does search on the balanced tree, so our result is the right length
	    //     let index = 0;
	    //     while (currentChildren && currentChildren[0] && currentChildren[0] instanceof OriginalColumnGroup) {
	    //         // putting in a deterministic fake id, in case the API in the future needs to reference the col
	    //         let fakeGroup = new OriginalColumnGroup(null, 'FAKE_PATH_' + index, true);
	    //         this.context.wireBean(fakeGroup);
	    //
	    //         // fakePath.setChildren(children);
	    //
	    //         fakePath.push(fakeGroup);
	    //         currentChildren = (<OriginalColumnGroup>currentChildren[0]).getChildren();
	    //         index++;
	    //     }
	    //
	    //     fakePath.forEach( (fakePathGroup: OriginalColumnGroup, i: number) => {
	    //         let lastItemInList = i === fakePath.length-1;
	    //         let child = lastItemInList ? column : fakePath[i+1];
	    //         fakePathGroup.setChildren([child]);
	    //     });
	    //
	    //     return fakePath;
	    // }
	    DisplayedGroupCreator.prototype.getOriginalPathForColumn = function (balancedColumnTree, column) {
	        var result = [];
	        var found = false;
	        recursePath(balancedColumnTree, 0);
	        // it's possible we didn't find a path. this happens if the column is generated
	        // by the grid (auto-group), in that the definition didn't come from the client. in this case,
	        // we create a fake original path.
	        if (found) {
	            return result;
	        }
	        else {
	            console.warn('could not get path');
	            return null;
	            // return this.createFakePath(balancedColumnTree, column);
	        }
	        function recursePath(balancedColumnTree, dept) {
	            for (var i = 0; i < balancedColumnTree.length; i++) {
	                if (found) {
	                    // quit the search, so 'result' is kept with the found result
	                    return;
	                }
	                var node = balancedColumnTree[i];
	                if (node instanceof originalColumnGroup_1.OriginalColumnGroup) {
	                    var nextNode = node;
	                    recursePath(nextNode.getChildren(), dept + 1);
	                    result[dept] = node;
	                }
	                else {
	                    if (node === column) {
	                        found = true;
	                    }
	                }
	            }
	        }
	    };
	    __decorate([
	        context_1.Autowired('columnUtils'),
	        __metadata("design:type", columnUtils_1.ColumnUtils)
	    ], DisplayedGroupCreator.prototype, "columnUtils", void 0);
	    __decorate([
	        context_1.Autowired('context'),
	        __metadata("design:type", context_2.Context)
	    ], DisplayedGroupCreator.prototype, "context", void 0);
	    DisplayedGroupCreator = __decorate([
	        context_2.Bean('displayedGroupCreator')
	    ], DisplayedGroupCreator);
	    return DisplayedGroupCreator;
	}());
	exports.DisplayedGroupCreator = DisplayedGroupCreator;


/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var constants_1 = __webpack_require__(30);
	var context_1 = __webpack_require__(8);
	var pinnedRowModel_1 = __webpack_require__(136);
	var utils_1 = __webpack_require__(10);
	var RowPositionUtils = /** @class */ (function () {
	    function RowPositionUtils() {
	    }
	    RowPositionUtils.prototype.getRowNode = function (gridRow) {
	        switch (gridRow.rowPinned) {
	            case constants_1.Constants.PINNED_TOP:
	                return this.pinnedRowModel.getPinnedTopRowData()[gridRow.rowIndex];
	            case constants_1.Constants.PINNED_BOTTOM:
	                return this.pinnedRowModel.getPinnedBottomRowData()[gridRow.rowIndex];
	            default:
	                return this.rowModel.getRow(gridRow.rowIndex);
	        }
	    };
	    RowPositionUtils.prototype.sameRow = function (rowA, rowB) {
	        // if both missing
	        if (!rowA && !rowB) {
	            return true;
	        }
	        // if only one missing
	        if ((rowA && !rowB) || (!rowA && rowB)) {
	            return false;
	        }
	        // otherwise compare (use == to compare rowPinned because it can be null or undefined)
	        return rowA.rowIndex === rowB.rowIndex && rowA.rowPinned == rowB.rowPinned;
	    };
	    // tests if this row selection is before the other row selection
	    RowPositionUtils.prototype.before = function (rowA, rowB) {
	        switch (rowA.rowPinned) {
	            case constants_1.Constants.PINNED_TOP:
	                // we we are floating top, and other isn't, then we are always before
	                if (rowB.rowPinned !== constants_1.Constants.PINNED_TOP) {
	                    return true;
	                }
	                break;
	            case constants_1.Constants.PINNED_BOTTOM:
	                // if we are floating bottom, and the other isn't, then we are never before
	                if (rowB.rowPinned !== constants_1.Constants.PINNED_BOTTOM) {
	                    return false;
	                }
	                break;
	            default:
	                // if we are not floating, but the other one is floating...
	                if (utils_1._.exists(rowB.rowPinned)) {
	                    return rowB.rowPinned !== constants_1.Constants.PINNED_TOP;
	                }
	                break;
	        }
	        return rowA.rowIndex < rowB.rowIndex;
	    };
	    __decorate([
	        context_1.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], RowPositionUtils.prototype, "rowModel", void 0);
	    __decorate([
	        context_1.Autowired('pinnedRowModel'),
	        __metadata("design:type", pinnedRowModel_1.PinnedRowModel)
	    ], RowPositionUtils.prototype, "pinnedRowModel", void 0);
	    RowPositionUtils = __decorate([
	        context_1.Bean('rowPositionUtils')
	    ], RowPositionUtils);
	    return RowPositionUtils;
	}());
	exports.RowPositionUtils = RowPositionUtils;


/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var columnController_1 = __webpack_require__(26);
	var constants_1 = __webpack_require__(30);
	var selectionController_1 = __webpack_require__(102);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var displayedGroupCreator_1 = __webpack_require__(314);
	var columnFactory_1 = __webpack_require__(246);
	var groupInstanceIdCreator_1 = __webpack_require__(416);
	var columnGroup_1 = __webpack_require__(159);
	var pinnedRowModel_1 = __webpack_require__(136);
	var utils_1 = __webpack_require__(10);
	var BaseGridSerializingSession = /** @class */ (function () {
	    function BaseGridSerializingSession(config) {
	        var columnController = config.columnController, valueService = config.valueService, gridOptionsWrapper = config.gridOptionsWrapper, processCellCallback = config.processCellCallback, processHeaderCallback = config.processHeaderCallback, cellAndHeaderEscaper = config.cellAndHeaderEscaper;
	        this.columnController = columnController;
	        this.valueService = valueService;
	        this.gridOptionsWrapper = gridOptionsWrapper;
	        this.processCellCallback = processCellCallback;
	        this.processHeaderCallback = processHeaderCallback;
	        this.cellAndHeaderEscaper = cellAndHeaderEscaper;
	    }
	    BaseGridSerializingSession.prototype.extractHeaderValue = function (column) {
	        var nameForCol = this.getHeaderName(this.processHeaderCallback, column);
	        if (nameForCol === null || nameForCol === undefined) {
	            nameForCol = '';
	        }
	        return this.cellAndHeaderEscaper ? this.cellAndHeaderEscaper(nameForCol) : nameForCol;
	    };
	    BaseGridSerializingSession.prototype.extractRowCellValue = function (column, index, type, node) {
	        var isRowGrouping = this.columnController.getRowGroupColumns().length > 0;
	        var valueForCell;
	        if (node && node.group && isRowGrouping && index === 0) {
	            valueForCell = this.createValueForGroupNode(node);
	        }
	        else {
	            valueForCell = this.valueService.getValue(column, node);
	        }
	        valueForCell = this.processCell(node, column, valueForCell, this.processCellCallback, type);
	        if (valueForCell === null || valueForCell === undefined) {
	            valueForCell = '';
	        }
	        return this.cellAndHeaderEscaper ? this.cellAndHeaderEscaper(valueForCell) : valueForCell;
	    };
	    BaseGridSerializingSession.prototype.getHeaderName = function (callback, column) {
	        if (callback) {
	            return callback({
	                column: column,
	                api: this.gridOptionsWrapper.getApi(),
	                columnApi: this.gridOptionsWrapper.getColumnApi(),
	                context: this.gridOptionsWrapper.getContext()
	            });
	        }
	        else {
	            return this.columnController.getDisplayNameForColumn(column, 'csv', true);
	        }
	    };
	    BaseGridSerializingSession.prototype.createValueForGroupNode = function (node) {
	        var keys = [node.key];
	        while (node.parent) {
	            node = node.parent;
	            keys.push(node.key);
	        }
	        return keys.reverse().join(' -> ');
	    };
	    BaseGridSerializingSession.prototype.processCell = function (rowNode, column, value, processCellCallback, type) {
	        if (processCellCallback) {
	            return processCellCallback({
	                column: column,
	                node: rowNode,
	                value: value,
	                api: this.gridOptionsWrapper.getApi(),
	                columnApi: this.gridOptionsWrapper.getColumnApi(),
	                context: this.gridOptionsWrapper.getContext(),
	                type: type
	            });
	        }
	        else {
	            return value;
	        }
	    };
	    return BaseGridSerializingSession;
	}());
	exports.BaseGridSerializingSession = BaseGridSerializingSession;
	var GridSerializer = /** @class */ (function () {
	    function GridSerializer() {
	    }
	    GridSerializer.prototype.serialize = function (gridSerializingSession, params) {
	        var dontSkipRows = function () { return false; };
	        var skipGroups = params && params.skipGroups;
	        var skipHeader = params && params.skipHeader;
	        var columnGroups = params && params.columnGroups;
	        var skipFooters = params && params.skipFooters;
	        var skipPinnedTop = params && params.skipPinnedTop;
	        var skipPinnedBottom = params && params.skipPinnedBottom;
	        var includeCustomHeader = params && params.customHeader;
	        var includeCustomFooter = params && params.customFooter;
	        var allColumns = params && params.allColumns;
	        var onlySelected = params && params.onlySelected;
	        var columnKeys = params && params.columnKeys;
	        var onlySelectedAllPages = params && params.onlySelectedAllPages;
	        var rowSkipper = (params && params.shouldRowBeSkipped) || dontSkipRows;
	        var api = this.gridOptionsWrapper.getApi();
	        var skipSingleChildrenGroup = this.gridOptionsWrapper.isGroupRemoveSingleChildren();
	        var skipLowestSingleChildrenGroup = this.gridOptionsWrapper.isGroupRemoveLowestSingleChildren();
	        var context = this.gridOptionsWrapper.getContext();
	        // when in pivot mode, we always render cols on screen, never 'all columns'
	        var isPivotMode = this.columnController.isPivotMode();
	        var rowModelNormal = this.rowModel.getType() === constants_1.Constants.ROW_MODEL_TYPE_CLIENT_SIDE;
	        var onlySelectedNonStandardModel = !rowModelNormal && onlySelected;
	        var columnsToExport = [];
	        if (utils_1._.existsAndNotEmpty(columnKeys)) {
	            columnsToExport = this.columnController.getGridColumns(columnKeys);
	        }
	        else if (allColumns && !isPivotMode) {
	            // add auto group column for tree data
	            columnsToExport = this.gridOptionsWrapper.isTreeData() ?
	                this.columnController.getGridColumns([constants_1.Constants.GROUP_AUTO_COLUMN_ID]) : [];
	            columnsToExport = columnsToExport.concat(this.columnController.getAllPrimaryColumns() || []);
	        }
	        else {
	            columnsToExport = this.columnController.getAllDisplayedColumns();
	        }
	        if (includeCustomHeader) {
	            gridSerializingSession.addCustomHeader(includeCustomHeader);
	        }
	        gridSerializingSession.prepare(columnsToExport);
	        // first pass, put in the header names of the cols
	        if (columnGroups) {
	            var groupInstanceIdCreator = new groupInstanceIdCreator_1.GroupInstanceIdCreator();
	            var displayedGroups = this.displayedGroupCreator.createDisplayedGroups(columnsToExport, this.columnController.getGridBalancedTree(), groupInstanceIdCreator, null);
	            this.recursivelyAddHeaderGroups(displayedGroups, gridSerializingSession);
	        }
	        if (!skipHeader) {
	            var gridRowIterator_1 = gridSerializingSession.onNewHeaderRow();
	            columnsToExport.forEach(function (column, index) {
	                gridRowIterator_1.onColumn(column, index, undefined);
	            });
	        }
	        this.pinnedRowModel.forEachPinnedTopRow(processRow);
	        if (isPivotMode) {
	            if (this.rowModel.forEachPivotNode) {
	                this.rowModel.forEachPivotNode(processRow);
	            }
	            else {
	                //Must be enterprise, so we can just loop through all the nodes
	                this.rowModel.forEachNode(processRow);
	            }
	        }
	        else {
	            // onlySelectedAllPages: user doing pagination and wants selected items from
	            // other pages, so cannot use the standard row model as it won't have rows from
	            // other pages.
	            // onlySelectedNonStandardModel: if user wants selected in non standard row model
	            // (eg viewport) then again rowmodel cannot be used, so need to use selected instead.
	            if (onlySelectedAllPages || onlySelectedNonStandardModel) {
	                var selectedNodes = this.selectionController.getSelectedNodes();
	                selectedNodes.forEach(function (node) {
	                    processRow(node);
	                });
	            }
	            else {
	                // here is everything else - including standard row model and selected. we don't use
	                // the selection model even when just using selected, so that the result is the order
	                // of the rows appearing on the screen.
	                if (rowModelNormal) {
	                    this.rowModel.forEachNodeAfterFilterAndSort(processRow);
	                }
	                else {
	                    this.rowModel.forEachNode(processRow);
	                }
	            }
	        }
	        this.pinnedRowModel.forEachPinnedBottomRow(processRow);
	        if (includeCustomFooter) {
	            gridSerializingSession.addCustomFooter(includeCustomFooter);
	        }
	        function processRow(node) {
	            var shouldSkipLowestGroup = skipLowestSingleChildrenGroup && node.leafGroup;
	            var shouldSkipCurrentGroup = node.allChildrenCount === 1 && (skipSingleChildrenGroup || shouldSkipLowestGroup);
	            if (node.group && (skipGroups || shouldSkipCurrentGroup)) {
	                return;
	            }
	            if (skipFooters && node.footer) {
	                return;
	            }
	            if (onlySelected && !node.isSelected()) {
	                return;
	            }
	            if (skipPinnedTop && node.rowPinned === 'top') {
	                return;
	            }
	            if (skipPinnedBottom && node.rowPinned === 'bottom') {
	                return;
	            }
	            // if we are in pivotMode, then the grid will show the root node only
	            // if it's not a leaf group
	            var nodeIsRootNode = node.level === -1;
	            if (nodeIsRootNode && !node.leafGroup) {
	                return;
	            }
	            var shouldRowBeSkipped = rowSkipper({
	                node: node,
	                api: api,
	                context: context
	            });
	            if (shouldRowBeSkipped) {
	                return;
	            }
	            var rowAccumulator = gridSerializingSession.onNewBodyRow();
	            columnsToExport.forEach(function (column, index) {
	                rowAccumulator.onColumn(column, index, node);
	            });
	        }
	        return gridSerializingSession.parse();
	    };
	    GridSerializer.prototype.recursivelyAddHeaderGroups = function (displayedGroups, gridSerializingSession) {
	        var directChildrenHeaderGroups = [];
	        displayedGroups.forEach(function (columnGroupChild) {
	            var columnGroup = columnGroupChild;
	            if (!columnGroup.getChildren) {
	                return;
	            }
	            columnGroup.getChildren().forEach(function (it) { return directChildrenHeaderGroups.push(it); });
	        });
	        if (displayedGroups.length > 0 && displayedGroups[0] instanceof columnGroup_1.ColumnGroup) {
	            this.doAddHeaderHeader(gridSerializingSession, displayedGroups);
	        }
	        if (directChildrenHeaderGroups && directChildrenHeaderGroups.length > 0) {
	            this.recursivelyAddHeaderGroups(directChildrenHeaderGroups, gridSerializingSession);
	        }
	    };
	    GridSerializer.prototype.doAddHeaderHeader = function (gridSerializingSession, displayedGroups) {
	        var _this = this;
	        var gridRowIterator = gridSerializingSession.onNewHeaderGroupingRow();
	        var columnIndex = 0;
	        displayedGroups.forEach(function (columnGroupChild) {
	            var columnGroup = columnGroupChild;
	            var columnName = _this.columnController.getDisplayNameForColumnGroup(columnGroup, 'header');
	            gridRowIterator.onColumn(columnName || '', columnIndex++, columnGroup.getLeafColumns().length - 1);
	        });
	    };
	    __decorate([
	        context_1.Autowired('displayedGroupCreator'),
	        __metadata("design:type", displayedGroupCreator_1.DisplayedGroupCreator)
	    ], GridSerializer.prototype, "displayedGroupCreator", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], GridSerializer.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], GridSerializer.prototype, "rowModel", void 0);
	    __decorate([
	        context_1.Autowired('pinnedRowModel'),
	        __metadata("design:type", pinnedRowModel_1.PinnedRowModel)
	    ], GridSerializer.prototype, "pinnedRowModel", void 0);
	    __decorate([
	        context_1.Autowired('selectionController'),
	        __metadata("design:type", selectionController_1.SelectionController)
	    ], GridSerializer.prototype, "selectionController", void 0);
	    __decorate([
	        context_1.Autowired('columnFactory'),
	        __metadata("design:type", columnFactory_1.ColumnFactory)
	    ], GridSerializer.prototype, "columnFactory", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], GridSerializer.prototype, "gridOptionsWrapper", void 0);
	    GridSerializer = __decorate([
	        context_1.Bean("gridSerializer")
	    ], GridSerializer);
	    return GridSerializer;
	}());
	exports.GridSerializer = GridSerializer;
	var RowType;
	(function (RowType) {
	    RowType[RowType["HEADER_GROUPING"] = 0] = "HEADER_GROUPING";
	    RowType[RowType["HEADER"] = 1] = "HEADER";
	    RowType[RowType["BODY"] = 2] = "BODY";
	})(RowType = exports.RowType || (exports.RowType = {}));


/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(31);
	var componentAnnotations_1 = __webpack_require__(39);
	var context_1 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var utils_1 = __webpack_require__(10);
	var constants_1 = __webpack_require__(30);
	/**
	 * Contains common logic to all provided filters (apply button, clear button, etc).
	 * All the filters that come with ag-Grid extend this class. User filters do not
	 * extend this class.
	 */
	var ProvidedFilter = /** @class */ (function (_super) {
	    __extends(ProvidedFilter, _super);
	    function ProvidedFilter() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /** @deprecated */
	    ProvidedFilter.prototype.onFilterChanged = function () {
	        console.warn("ag-Grid: you should not call onFilterChanged() directly on the filter, please call\n        gridApi.onFilterChanged() instead. onFilterChanged is not part of the exposed filter interface (it was\n        a method that existed on an old version of the filters that was not intended for public use.");
	        this.providedFilterParams.filterChangedCallback();
	    };
	    ProvidedFilter.prototype.isFilterActive = function () {
	        // filter is active if we have a valid applied model
	        return !!this.appliedModel;
	    };
	    ProvidedFilter.prototype.postConstruct = function () {
	        var templateString = this.createTemplate();
	        this.setTemplate(templateString);
	    };
	    ProvidedFilter.prototype.init = function (params) {
	        this.setParams(params);
	        this.resetUiToDefaults();
	        this.updateUiVisibility();
	        this.setupOnBtApplyDebounce();
	    };
	    ProvidedFilter.prototype.setParams = function (params) {
	        var _this = this;
	        this.providedFilterParams = params;
	        this.clearActive = params.clearButton === true;
	        this.applyActive = ProvidedFilter.isUseApplyButton(params);
	        if (params.newRowsAction === ProvidedFilter.NEW_ROWS_ACTION_KEEP) {
	            this.newRowsActionKeep = true;
	        }
	        else if (params.newRowsAction === ProvidedFilter.NEW_ROWS_ACTION_CLEAR) {
	            this.newRowsActionKeep = false;
	        }
	        else {
	            // the default for SSRM and IRM is 'keep', for CSRM and VRM teh default is 'clear'
	            var rowModelType = this.rowModel.getType();
	            var modelsForKeep = [constants_1.Constants.ROW_MODEL_TYPE_SERVER_SIDE, constants_1.Constants.ROW_MODEL_TYPE_INFINITE];
	            this.newRowsActionKeep = modelsForKeep.indexOf(rowModelType) >= 0;
	        }
	        utils_1._.setDisplayed(this.eApplyButton, this.applyActive);
	        // we do not bind onBtApply here because onBtApply() has a parameter, and it is not the event. if we
	        // just applied, the event would get passed as the second parameter, which we do not want.
	        this.addDestroyableEventListener(this.eApplyButton, "click", function () { return _this.onBtApply(); });
	        utils_1._.setDisplayed(this.eClearButton, this.clearActive);
	        this.addDestroyableEventListener(this.eClearButton, "click", this.onBtClear.bind(this));
	        var anyButtonVisible = this.applyActive || this.clearActive;
	        utils_1._.setDisplayed(this.eButtonsPanel, anyButtonVisible);
	    };
	    // subclasses can override this to provide alternative debounce defaults
	    ProvidedFilter.prototype.getDefaultDebounceMs = function () {
	        return 0;
	    };
	    ProvidedFilter.prototype.setupOnBtApplyDebounce = function () {
	        var debounceMs = ProvidedFilter.getDebounceMs(this.providedFilterParams, this.getDefaultDebounceMs());
	        this.onBtApplyDebounce = utils_1._.debounce(this.onBtApply.bind(this), debounceMs);
	    };
	    ProvidedFilter.prototype.getModel = function () {
	        return this.appliedModel;
	    };
	    ProvidedFilter.prototype.setModel = function (model) {
	        if (model) {
	            this.setModelIntoUi(model);
	        }
	        else {
	            this.resetUiToDefaults();
	        }
	        this.updateUiVisibility();
	        // we set the model from the gui, rather than the provided model,
	        // so the model is consistent. eg handling of null/undefined will be the same,
	        // of if model is case insensitive, then casing is removed.
	        this.applyModel();
	    };
	    ProvidedFilter.prototype.onBtClear = function () {
	        this.resetUiToDefaults();
	        this.updateUiVisibility();
	        this.onUiChanged();
	    };
	    // returns true if the new model is different to the old model
	    ProvidedFilter.prototype.applyModel = function () {
	        var oldAppliedModel = this.appliedModel;
	        this.appliedModel = this.getModelFromUi();
	        // models can be same if user pasted same content into text field, or maybe just changed the case
	        // and it's a case insensitive filter
	        var newModelDifferent = !this.areModelsEqual(this.appliedModel, oldAppliedModel);
	        return newModelDifferent;
	    };
	    ProvidedFilter.prototype.onBtApply = function (afterFloatingFilter) {
	        if (afterFloatingFilter === void 0) { afterFloatingFilter = false; }
	        var newModelDifferent = this.applyModel();
	        if (newModelDifferent) {
	            // the floating filter uses 'afterFloatingFilter' info, so it doesn't refresh after filter changed if change
	            // came from floating filter
	            this.providedFilterParams.filterChangedCallback({ afterFloatingFilter: afterFloatingFilter });
	        }
	    };
	    ProvidedFilter.prototype.onNewRowsLoaded = function () {
	        if (!this.newRowsActionKeep) {
	            this.resetUiToDefaults();
	            this.appliedModel = null;
	        }
	    };
	    // called by set filter
	    ProvidedFilter.prototype.isNewRowsActionKeep = function () {
	        return this.newRowsActionKeep;
	    };
	    ProvidedFilter.prototype.onUiChanged = function (afterFloatingFilter) {
	        if (afterFloatingFilter === void 0) { afterFloatingFilter = false; }
	        this.updateUiVisibility();
	        this.providedFilterParams.filterModifiedCallback();
	        // applyNow=true for floating filter changes, we always act on these immediately
	        if (afterFloatingFilter) {
	            this.onBtApply(true);
	            // otherwise if no apply button, we apply (but debounce for time delay)
	        }
	        else if (!this.applyActive) {
	            this.onBtApplyDebounce();
	        }
	    };
	    ProvidedFilter.prototype.createTemplate = function () {
	        var body = this.createBodyTemplate();
	        var translate = this.gridOptionsWrapper.getLocaleTextFunc();
	        return "<div>\n                    <div class='ag-filter-body-wrapper' ref=\"eFilterBodyWrapper\">" + body + "</div>\n                    <div class=\"ag-filter-apply-panel\" ref=\"eButtonsPanel\">\n                        <button type=\"button\" ref=\"eClearButton\">" + translate('clearFilter', 'Clear Filter') + "</button>\n                        <button type=\"button\" ref=\"eApplyButton\">" + translate('applyFilter', 'Apply Filter') + "</button>\n                    </div>\n                </div>";
	    };
	    // static, as used by floating filter also
	    ProvidedFilter.getDebounceMs = function (params, debounceDefault) {
	        var applyActive = ProvidedFilter.isUseApplyButton(params);
	        if (applyActive) {
	            if (params.debounceMs != null) {
	                console.warn('ag-Grid: debounceMs is ignored when applyButton = true');
	            }
	            return 0;
	        }
	        return params.debounceMs != null ? params.debounceMs : debounceDefault;
	    };
	    // static, as used by floating filter also
	    ProvidedFilter.isUseApplyButton = function (params) {
	        if (params.apply && !params.applyButton) {
	            console.warn('ag-Grid: as of ag-Grid v21, filterParams.apply is now filterParams.applyButton, please change to applyButton');
	            params.applyButton = true;
	        }
	        return params.applyButton === true;
	    };
	    ProvidedFilter.NEW_ROWS_ACTION_KEEP = 'keep';
	    ProvidedFilter.NEW_ROWS_ACTION_CLEAR = 'clear';
	    __decorate([
	        componentAnnotations_1.RefSelector('eButtonsPanel'),
	        __metadata("design:type", HTMLElement)
	    ], ProvidedFilter.prototype, "eButtonsPanel", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eFilterBodyWrapper'),
	        __metadata("design:type", HTMLElement)
	    ], ProvidedFilter.prototype, "eFilterBodyWrapper", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eApplyButton'),
	        __metadata("design:type", HTMLElement)
	    ], ProvidedFilter.prototype, "eApplyButton", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eClearButton'),
	        __metadata("design:type", HTMLElement)
	    ], ProvidedFilter.prototype, "eClearButton", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], ProvidedFilter.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], ProvidedFilter.prototype, "rowModel", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ProvidedFilter.prototype, "postConstruct", null);
	    return ProvidedFilter;
	}(component_1.Component));
	exports.ProvidedFilter = ProvidedFilter;


/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var context_1 = __webpack_require__(8);
	var dragService_1 = __webpack_require__(158);
	var HorizontalResizeService = /** @class */ (function () {
	    function HorizontalResizeService() {
	    }
	    HorizontalResizeService.prototype.addResizeBar = function (params) {
	        var _this = this;
	        var dragSource = {
	            dragStartPixels: params.dragStartPixels || 0,
	            eElement: params.eResizeBar,
	            onDragStart: this.onDragStart.bind(this, params),
	            onDragStop: this.onDragStop.bind(this, params),
	            onDragging: this.onDragging.bind(this, params)
	        };
	        this.dragService.addDragSource(dragSource, true);
	        // we pass remove func back to the caller, so call can tell us when they
	        // are finished, and then we remove the listener from the drag source
	        var finishedWithResizeFunc = function () { return _this.dragService.removeDragSource(dragSource); };
	        return finishedWithResizeFunc;
	    };
	    HorizontalResizeService.prototype.onDragStart = function (params, mouseEvent) {
	        this.draggingStarted = true;
	        this.dragStartX = mouseEvent.clientX;
	        this.setResizeIcons();
	        var shiftKey = mouseEvent instanceof MouseEvent ? mouseEvent.shiftKey === true : false;
	        params.onResizeStart(shiftKey);
	    };
	    HorizontalResizeService.prototype.setResizeIcons = function () {
	        this.oldBodyCursor = this.eGridDiv.style.cursor;
	        this.oldMsUserSelect = this.eGridDiv.style.msUserSelect;
	        this.oldWebkitUserSelect = this.eGridDiv.style.webkitUserSelect;
	        // change the body cursor, so when drag moves out of the drag bar, the cursor is still 'resize' (or 'move'
	        this.eGridDiv.style.cursor = 'col-resize';
	        // we don't want text selection outside the grid (otherwise it looks weird as text highlights when we move)
	        this.eGridDiv.style.msUserSelect = 'none';
	        this.eGridDiv.style.webkitUserSelect = 'none';
	    };
	    HorizontalResizeService.prototype.onDragStop = function (params, mouseEvent) {
	        params.onResizeEnd(this.resizeAmount);
	        this.resetIcons();
	    };
	    HorizontalResizeService.prototype.resetIcons = function () {
	        // we don't want text selection outside the grid (otherwise it looks weird as text highlights when we move)
	        this.eGridDiv.style.cursor = this.oldBodyCursor;
	        this.eGridDiv.style.msUserSelect = this.oldMsUserSelect;
	        this.eGridDiv.style.webkitUserSelect = this.oldWebkitUserSelect;
	    };
	    HorizontalResizeService.prototype.onDragging = function (params, mouseEvent) {
	        this.resizeAmount = mouseEvent.clientX - this.dragStartX;
	        params.onResizing(this.resizeAmount);
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], HorizontalResizeService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('dragService'),
	        __metadata("design:type", dragService_1.DragService)
	    ], HorizontalResizeService.prototype, "dragService", void 0);
	    __decorate([
	        context_1.Autowired('eGridDiv'),
	        __metadata("design:type", HTMLElement)
	    ], HorizontalResizeService.prototype, "eGridDiv", void 0);
	    HorizontalResizeService = __decorate([
	        context_1.Bean('horizontalResizeService')
	    ], HorizontalResizeService);
	    return HorizontalResizeService;
	}());
	exports.HorizontalResizeService = HorizontalResizeService;


/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var utils_1 = __webpack_require__(10);
	var ResizeObserverService = /** @class */ (function () {
	    function ResizeObserverService() {
	    }
	    ResizeObserverService.prototype.observeResize = function (element, callback, debounceDelay) {
	        if (debounceDelay === void 0) { debounceDelay = 50; }
	        // put in variable, so available to usePolyfill() function below
	        var frameworkFactory = this.frameworkOverrides;
	        // this gets fired too often and might cause some relayout issues
	        // so we add a debounce to the callback here to avoid the flashing effect.
	        var debouncedCallback = utils_1._.debounce(callback, debounceDelay);
	        var useBrowserResizeObserver = function () {
	            var resizeObserver = new window.ResizeObserver(debouncedCallback);
	            resizeObserver.observe(element);
	            return function () { return resizeObserver.disconnect(); };
	        };
	        var usePolyfill = function () {
	            // initialise to the current width and height, so first call will have no changes
	            var widthLastTime = utils_1._.offsetWidth(element);
	            var heightLastTime = utils_1._.offsetHeight(element);
	            // when finished, this gets turned to false.
	            var running = true;
	            var periodicallyCheckWidthAndHeight = function () {
	                if (running) {
	                    var newWidth = utils_1._.offsetWidth(element);
	                    var newHeight = utils_1._.offsetHeight(element);
	                    var changed = newWidth !== widthLastTime || newHeight !== heightLastTime;
	                    if (changed) {
	                        widthLastTime = newWidth;
	                        heightLastTime = newHeight;
	                        callback();
	                    }
	                    frameworkFactory.setTimeout(periodicallyCheckWidthAndHeight, debounceDelay);
	                }
	            };
	            periodicallyCheckWidthAndHeight();
	            // the callback function we return sets running to false
	            return function () { return running = false; };
	        };
	        var suppressResize = this.gridOptionsWrapper.isSuppressBrowserResizeObserver();
	        var resizeObserverExists = !!window.ResizeObserver;
	        if (resizeObserverExists && !suppressResize) {
	            return useBrowserResizeObserver();
	        }
	        else {
	            return usePolyfill();
	        }
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], ResizeObserverService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('frameworkOverrides'),
	        __metadata("design:type", Object)
	    ], ResizeObserverService.prototype, "frameworkOverrides", void 0);
	    ResizeObserverService = __decorate([
	        context_1.Bean('resizeObserverService')
	    ], ResizeObserverService);
	    return ResizeObserverService;
	}());
	exports.ResizeObserverService = ResizeObserverService;


/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var eventService_1 = __webpack_require__(22);
	var expressionService_1 = __webpack_require__(121);
	var animateSlideCellRenderer_1 = __webpack_require__(438);
	var animateShowChangeCellRenderer_1 = __webpack_require__(437);
	var groupCellRenderer_1 = __webpack_require__(439);
	var utils_1 = __webpack_require__(10);
	var CellRendererFactory = /** @class */ (function () {
	    function CellRendererFactory() {
	        this.cellRendererMap = {};
	    }
	    CellRendererFactory_1 = CellRendererFactory;
	    CellRendererFactory.prototype.init = function () {
	        this.cellRendererMap[CellRendererFactory_1.ANIMATE_SLIDE] = animateSlideCellRenderer_1.AnimateSlideCellRenderer;
	        this.cellRendererMap[CellRendererFactory_1.ANIMATE_SHOW_CHANGE] = animateShowChangeCellRenderer_1.AnimateShowChangeCellRenderer;
	        this.cellRendererMap[CellRendererFactory_1.GROUP] = groupCellRenderer_1.GroupCellRenderer;
	        // this.registerRenderersFromGridOptions();
	    };
	    // private registerRenderersFromGridOptions(): void {
	    //     let userProvidedCellRenderers = this.gridOptionsWrapper.getCellRenderers();
	    //     _.iterateObject(userProvidedCellRenderers, (key: string, cellRenderer: {new(): ICellRenderer} | ICellRendererFunc)=> {
	    //         this.addCellRenderer(key, cellRenderer);
	    //     });
	    // }
	    CellRendererFactory.prototype.addCellRenderer = function (key, cellRenderer) {
	        this.cellRendererMap[key] = cellRenderer;
	    };
	    CellRendererFactory.prototype.getCellRenderer = function (key) {
	        var result = this.cellRendererMap[key];
	        if (utils_1._.missing(result)) {
	            console.warn('ag-Grid: unable to find cellRenderer for key ' + key);
	            return null;
	        }
	        return result;
	    };
	    var CellRendererFactory_1;
	    CellRendererFactory.ANIMATE_SLIDE = 'animateSlide';
	    CellRendererFactory.ANIMATE_SHOW_CHANGE = 'animateShowChange';
	    CellRendererFactory.GROUP = 'group';
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], CellRendererFactory.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('expressionService'),
	        __metadata("design:type", expressionService_1.ExpressionService)
	    ], CellRendererFactory.prototype, "expressionService", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], CellRendererFactory.prototype, "eventService", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], CellRendererFactory.prototype, "init", null);
	    CellRendererFactory = CellRendererFactory_1 = __decorate([
	        context_1.Bean('cellRendererFactory')
	    ], CellRendererFactory);
	    return CellRendererFactory;
	}());
	exports.CellRendererFactory = CellRendererFactory;


/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var ColumnAnimationService = /** @class */ (function () {
	    function ColumnAnimationService() {
	        this.executeNextFuncs = [];
	        this.executeLaterFuncs = [];
	        this.active = false;
	        this.animationThreadCount = 0;
	    }
	    ColumnAnimationService.prototype.registerGridComp = function (gridPanel) {
	        this.gridPanel = gridPanel;
	    };
	    ColumnAnimationService.prototype.isActive = function () {
	        return this.active;
	    };
	    ColumnAnimationService.prototype.start = function () {
	        if (this.active) {
	            return;
	        }
	        if (this.gridOptionsWrapper.isSuppressColumnMoveAnimation()) {
	            return;
	        }
	        // if doing RTL, we don't animate open / close as due to how the pixels are inverted,
	        // the animation moves all the row the the right rather than to the left (ie it's the static
	        // columns that actually get their coordinates updated)
	        if (this.gridOptionsWrapper.isEnableRtl()) {
	            return;
	        }
	        this.ensureAnimationCssClassPresent();
	        this.active = true;
	    };
	    ColumnAnimationService.prototype.finish = function () {
	        if (!this.active) {
	            return;
	        }
	        this.flush();
	        this.active = false;
	    };
	    ColumnAnimationService.prototype.executeNextVMTurn = function (func) {
	        if (this.active) {
	            this.executeNextFuncs.push(func);
	        }
	        else {
	            func();
	        }
	    };
	    ColumnAnimationService.prototype.executeLaterVMTurn = function (func) {
	        if (this.active) {
	            this.executeLaterFuncs.push(func);
	        }
	        else {
	            func();
	        }
	    };
	    ColumnAnimationService.prototype.ensureAnimationCssClassPresent = function () {
	        var _this = this;
	        // up the count, so we can tell if someone else has updated the count
	        // by the time the 'wait' func executes
	        this.animationThreadCount++;
	        var animationThreadCountCopy = this.animationThreadCount;
	        this.gridPanel.setColumnMovingCss(true);
	        this.executeLaterFuncs.push(function () {
	            // only remove the class if this thread was the last one to update it
	            if (_this.animationThreadCount === animationThreadCountCopy) {
	                _this.gridPanel.setColumnMovingCss(false);
	            }
	        });
	    };
	    ColumnAnimationService.prototype.flush = function () {
	        var nowFuncs = this.executeNextFuncs;
	        this.executeNextFuncs = [];
	        var waitFuncs = this.executeLaterFuncs;
	        this.executeLaterFuncs = [];
	        if (nowFuncs.length === 0 && waitFuncs.length === 0) {
	            return;
	        }
	        window.setTimeout(function () { return nowFuncs.forEach(function (func) { return func(); }); }, 0);
	        window.setTimeout(function () { return waitFuncs.forEach(function (func) { return func(); }); }, 300);
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], ColumnAnimationService.prototype, "gridOptionsWrapper", void 0);
	    ColumnAnimationService = __decorate([
	        context_1.Bean('columnAnimationService')
	    ], ColumnAnimationService);
	    return ColumnAnimationService;
	}());
	exports.ColumnAnimationService = ColumnAnimationService;


/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var column_1 = __webpack_require__(45);
	var beanStub_1 = __webpack_require__(71);
	var constants_1 = __webpack_require__(30);
	var utils_1 = __webpack_require__(10);
	var SetLeftFeature = /** @class */ (function (_super) {
	    __extends(SetLeftFeature, _super);
	    function SetLeftFeature(columnOrGroup, eCell, beans, colsSpanning) {
	        var _this = _super.call(this) || this;
	        _this.columnOrGroup = columnOrGroup;
	        _this.eCell = eCell;
	        _this.colsSpanning = colsSpanning;
	        _this.beans = beans;
	        _this.printLayout = beans.gridOptionsWrapper.getDomLayout() === constants_1.Constants.DOM_LAYOUT_PRINT;
	        return _this;
	    }
	    SetLeftFeature.prototype.setColsSpanning = function (colsSpanning) {
	        this.colsSpanning = colsSpanning;
	        this.onLeftChanged();
	    };
	    SetLeftFeature.prototype.getColumnOrGroup = function () {
	        if (this.beans.gridOptionsWrapper.isEnableRtl() && this.colsSpanning) {
	            return utils_1._.last(this.colsSpanning);
	        }
	        else {
	            return this.columnOrGroup;
	        }
	    };
	    SetLeftFeature.prototype.init = function () {
	        this.addDestroyableEventListener(this.columnOrGroup, column_1.Column.EVENT_LEFT_CHANGED, this.onLeftChanged.bind(this));
	        this.setLeftFirstTime();
	    };
	    SetLeftFeature.prototype.setLeftFirstTime = function () {
	        var suppressMoveAnimation = this.beans.gridOptionsWrapper.isSuppressColumnMoveAnimation();
	        var oldLeftExists = utils_1._.exists(this.columnOrGroup.getOldLeft());
	        var animateColumnMove = this.beans.columnAnimationService.isActive() && oldLeftExists && !suppressMoveAnimation;
	        if (animateColumnMove) {
	            this.animateInLeft();
	        }
	        else {
	            this.onLeftChanged();
	        }
	    };
	    SetLeftFeature.prototype.animateInLeft = function () {
	        var _this = this;
	        var left = this.getColumnOrGroup().getLeft();
	        var oldLeft = this.getColumnOrGroup().getOldLeft();
	        this.setLeft(oldLeft);
	        // we must keep track of the left we want to set to, as this would otherwise lead to a race
	        // condition, if the user changed the left value many times in one VM turn, then we want to make
	        // make sure the actualLeft we set in the timeout below (in the next VM turn) is the correct left
	        // position. eg if user changes column position twice, then setLeft() below executes twice in next
	        // VM turn, but only one (the correct one) should get applied.
	        this.actualLeft = left;
	        this.beans.columnAnimationService.executeNextVMTurn(function () {
	            // test this left value is the latest one to be applied, and if not, do nothing
	            if (_this.actualLeft === left) {
	                _this.setLeft(left);
	            }
	        });
	    };
	    SetLeftFeature.prototype.onLeftChanged = function () {
	        var colOrGroup = this.getColumnOrGroup();
	        var left = colOrGroup.getLeft();
	        this.actualLeft = this.modifyLeftForPrintLayout(colOrGroup, left);
	        this.setLeft(this.actualLeft);
	    };
	    SetLeftFeature.prototype.modifyLeftForPrintLayout = function (colOrGroup, leftPosition) {
	        if (!this.printLayout) {
	            return leftPosition;
	        }
	        if (colOrGroup.getPinned() === column_1.Column.PINNED_LEFT) {
	            return leftPosition;
	        }
	        else if (colOrGroup.getPinned() === column_1.Column.PINNED_RIGHT) {
	            var leftWidth = this.beans.columnController.getPinnedLeftContainerWidth();
	            var bodyWidth = this.beans.columnController.getBodyContainerWidth();
	            return leftWidth + bodyWidth + leftPosition;
	        }
	        else {
	            // is in body
	            var leftWidth = this.beans.columnController.getPinnedLeftContainerWidth();
	            return leftWidth + leftPosition;
	        }
	    };
	    SetLeftFeature.prototype.setLeft = function (value) {
	        // if the value is null, then that means the column is no longer
	        // displayed. there is logic in the rendering to fade these columns
	        // out, so we don't try and change their left positions.
	        if (utils_1._.exists(value)) {
	            this.eCell.style.left = value + "px";
	        }
	    };
	    return SetLeftFeature;
	}(beanStub_1.BeanStub));
	exports.SetLeftFeature = SetLeftFeature;


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var beanStub_1 = __webpack_require__(71);
	var context_1 = __webpack_require__(8);
	var eventService_1 = __webpack_require__(22);
	var eventKeys_1 = __webpack_require__(160);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var utils_1 = __webpack_require__(10);
	/**
	 * This class solves the 'max height' problem, where the user might want to show more data than
	 * the max div height actually allows.
	 */
	var MaxDivHeightScaler = /** @class */ (function (_super) {
	    __extends(MaxDivHeightScaler, _super);
	    function MaxDivHeightScaler() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        // the scrollY position
	        _this.scrollY = 0;
	        // how tall the body is
	        _this.uiBodyHeight = 0;
	        return _this;
	    }
	    MaxDivHeightScaler.prototype.postConstruct = function () {
	        this.addDestroyableEventListener(this.eventService, eventKeys_1.Events.EVENT_BODY_HEIGHT_CHANGED, this.updateOffset.bind(this));
	        this.scrollBarWidth = this.gridOptionsWrapper.getScrollbarWidth();
	        this.maxDivHeight = utils_1._.getMaxDivHeight();
	    };
	    MaxDivHeightScaler.prototype.registerGridComp = function (gridPanel) {
	        this.gridPanel = gridPanel;
	    };
	    MaxDivHeightScaler.prototype.isScaling = function () {
	        return this.scaling;
	    };
	    MaxDivHeightScaler.prototype.getOffset = function () {
	        return this.offset;
	    };
	    MaxDivHeightScaler.prototype.updateOffset = function () {
	        if (!this.scaling) {
	            return;
	        }
	        var newScrollY = this.gridPanel.getVScrollPosition().top;
	        var newBodyHeight = this.getUiBodyHeight();
	        var atLeastOneChanged = newScrollY !== this.scrollY || newBodyHeight !== this.uiBodyHeight;
	        if (atLeastOneChanged) {
	            this.scrollY = newScrollY;
	            this.uiBodyHeight = newBodyHeight;
	            this.calculateOffset();
	        }
	    };
	    MaxDivHeightScaler.prototype.calculateOffset = function () {
	        this.uiContainerHeight = this.maxDivHeight;
	        this.pixelsToShave = this.modelHeight - this.uiContainerHeight;
	        this.maxScrollY = this.uiContainerHeight - this.uiBodyHeight;
	        var scrollPercent = this.scrollY / this.maxScrollY;
	        this.setOffset(scrollPercent * this.pixelsToShave);
	    };
	    MaxDivHeightScaler.prototype.clearOffset = function () {
	        this.uiContainerHeight = this.modelHeight;
	        this.pixelsToShave = 0;
	        this.setOffset(0);
	    };
	    MaxDivHeightScaler.prototype.setOffset = function (newOffset) {
	        // because we are talking pixels, no point in confusing things with half numbers
	        var newOffsetFloor = typeof newOffset === 'number' ? Math.floor(newOffset) : null;
	        if (this.offset === newOffsetFloor) {
	            return;
	        }
	        this.offset = newOffsetFloor;
	        this.eventService.dispatchEvent({ type: eventKeys_1.Events.EVENT_HEIGHT_SCALE_CHANGED });
	    };
	    MaxDivHeightScaler.prototype.setModelHeight = function (modelHeight) {
	        this.modelHeight = modelHeight;
	        this.scaling = this.maxDivHeight > 0 && modelHeight > this.maxDivHeight;
	        if (this.scaling) {
	            this.calculateOffset();
	        }
	        else {
	            this.clearOffset();
	        }
	    };
	    MaxDivHeightScaler.prototype.getUiContainerHeight = function () {
	        return this.uiContainerHeight;
	    };
	    MaxDivHeightScaler.prototype.getRealPixelPosition = function (modelPixel) {
	        return modelPixel - this.offset;
	    };
	    MaxDivHeightScaler.prototype.getUiBodyHeight = function () {
	        var pos = this.gridPanel.getVScrollPosition();
	        return pos.bottom - pos.top;
	    };
	    MaxDivHeightScaler.prototype.getScrollPositionForPixel = function (rowTop) {
	        if (this.pixelsToShave <= 0) {
	            return rowTop;
	        }
	        var modelMaxScroll = this.modelHeight - this.getUiBodyHeight();
	        var scrollPercent = rowTop / modelMaxScroll;
	        var scrollPixel = this.maxScrollY * scrollPercent;
	        return scrollPixel;
	    };
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], MaxDivHeightScaler.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], MaxDivHeightScaler.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], MaxDivHeightScaler.prototype, "postConstruct", null);
	    MaxDivHeightScaler = __decorate([
	        context_1.Bean('maxDivHeightScaler')
	    ], MaxDivHeightScaler);
	    return MaxDivHeightScaler;
	}(beanStub_1.BeanStub));
	exports.MaxDivHeightScaler = MaxDivHeightScaler;


/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(10);
	var rowNode_1 = __webpack_require__(101);
	var beanStub_1 = __webpack_require__(71);
	var RowNodeBlock = /** @class */ (function (_super) {
	    __extends(RowNodeBlock, _super);
	    function RowNodeBlock(blockNumber, rowNodeCacheParams) {
	        var _this = _super.call(this) || this;
	        _this.version = 0;
	        _this.state = RowNodeBlock.STATE_DIRTY;
	        _this.rowNodeCacheParams = rowNodeCacheParams;
	        _this.blockNumber = blockNumber;
	        // we don't need to calculate these now, as the inputs don't change,
	        // however it makes the code easier to read if we work them out up front
	        _this.startRow = blockNumber * rowNodeCacheParams.blockSize;
	        _this.endRow = _this.startRow + rowNodeCacheParams.blockSize;
	        return _this;
	    }
	    RowNodeBlock.prototype.isAnyNodeOpen = function (rowCount) {
	        var result = false;
	        this.forEachNodeCallback(function (rowNode) {
	            if (rowNode.expanded) {
	                result = true;
	            }
	        }, rowCount);
	        return result;
	    };
	    RowNodeBlock.prototype.forEachNodeCallback = function (callback, rowCount) {
	        for (var rowIndex = this.startRow; rowIndex < this.endRow; rowIndex++) {
	            // we check against rowCount as this page may be the last one, and if it is, then
	            // the last rows are not part of the set
	            if (rowIndex < rowCount) {
	                var rowNode = this.getRowUsingLocalIndex(rowIndex);
	                callback(rowNode, rowIndex);
	            }
	        }
	    };
	    RowNodeBlock.prototype.forEachNode = function (callback, sequence, rowCount, deep) {
	        this.forEachNodeCallback(function (rowNode) {
	            callback(rowNode, sequence.next());
	            // this will only every happen for server side row model, as infinite
	            // row model doesn't have groups
	            if (deep && rowNode.childrenCache) {
	                rowNode.childrenCache.forEachNodeDeep(callback, sequence);
	            }
	        }, rowCount);
	    };
	    RowNodeBlock.prototype.forEachNodeDeep = function (callback, sequence, rowCount) {
	        this.forEachNode(callback, sequence, rowCount, true);
	    };
	    RowNodeBlock.prototype.forEachNodeShallow = function (callback, sequence, rowCount) {
	        this.forEachNode(callback, sequence, rowCount, false);
	    };
	    RowNodeBlock.prototype.getVersion = function () {
	        return this.version;
	    };
	    RowNodeBlock.prototype.getLastAccessed = function () {
	        return this.lastAccessed;
	    };
	    RowNodeBlock.prototype.getRowUsingLocalIndex = function (rowIndex, dontTouchLastAccessed) {
	        if (dontTouchLastAccessed === void 0) { dontTouchLastAccessed = false; }
	        if (!dontTouchLastAccessed) {
	            this.lastAccessed = this.rowNodeCacheParams.lastAccessedSequence.next();
	        }
	        var localIndex = rowIndex - this.startRow;
	        return this.rowNodes[localIndex];
	    };
	    RowNodeBlock.prototype.init = function (beans) {
	        this.beans = beans;
	        this.createRowNodes();
	    };
	    RowNodeBlock.prototype.getStartRow = function () {
	        return this.startRow;
	    };
	    RowNodeBlock.prototype.getEndRow = function () {
	        return this.endRow;
	    };
	    RowNodeBlock.prototype.getBlockNumber = function () {
	        return this.blockNumber;
	    };
	    RowNodeBlock.prototype.setDirty = function () {
	        // in case any current loads in progress, this will have their results ignored
	        this.version++;
	        this.state = RowNodeBlock.STATE_DIRTY;
	    };
	    RowNodeBlock.prototype.setDirtyAndPurge = function () {
	        this.setDirty();
	        this.rowNodes.forEach(function (rowNode) {
	            rowNode.setData(null);
	        });
	    };
	    RowNodeBlock.prototype.getState = function () {
	        return this.state;
	    };
	    RowNodeBlock.prototype.setRowNode = function (rowIndex, rowNode) {
	        var localIndex = rowIndex - this.startRow;
	        this.rowNodes[localIndex] = rowNode;
	    };
	    RowNodeBlock.prototype.setBlankRowNode = function (rowIndex) {
	        var localIndex = rowIndex - this.startRow;
	        var newRowNode = this.createBlankRowNode(rowIndex);
	        this.rowNodes[localIndex] = newRowNode;
	        return newRowNode;
	    };
	    RowNodeBlock.prototype.setNewData = function (rowIndex, dataItem) {
	        var newRowNode = this.setBlankRowNode(rowIndex);
	        this.setDataAndId(newRowNode, dataItem, this.startRow + rowIndex);
	        return newRowNode;
	    };
	    RowNodeBlock.prototype.createBlankRowNode = function (rowIndex) {
	        var rowNode = new rowNode_1.RowNode();
	        this.beans.context.wireBean(rowNode);
	        rowNode.setRowHeight(this.rowNodeCacheParams.rowHeight);
	        return rowNode;
	    };
	    // creates empty row nodes, data is missing as not loaded yet
	    RowNodeBlock.prototype.createRowNodes = function () {
	        this.rowNodes = [];
	        for (var i = 0; i < this.rowNodeCacheParams.blockSize; i++) {
	            var rowIndex = this.startRow + i;
	            var rowNode = this.createBlankRowNode(rowIndex);
	            this.rowNodes.push(rowNode);
	        }
	    };
	    RowNodeBlock.prototype.load = function () {
	        this.state = RowNodeBlock.STATE_LOADING;
	        this.loadFromDatasource();
	    };
	    RowNodeBlock.prototype.pageLoadFailed = function () {
	        this.state = RowNodeBlock.STATE_FAILED;
	        var event = {
	            type: RowNodeBlock.EVENT_LOAD_COMPLETE,
	            success: false,
	            page: this,
	            lastRow: null
	        };
	        this.dispatchEvent(event);
	    };
	    RowNodeBlock.prototype.populateWithRowData = function (rows) {
	        var _this = this;
	        var rowNodesToRefresh = [];
	        this.rowNodes.forEach(function (rowNode, index) {
	            var data = rows[index];
	            if (rowNode.stub) {
	                rowNodesToRefresh.push(rowNode);
	            }
	            _this.setDataAndId(rowNode, data, _this.startRow + index);
	        });
	        if (rowNodesToRefresh.length > 0) {
	            this.beans.rowRenderer.redrawRows(rowNodesToRefresh);
	        }
	    };
	    RowNodeBlock.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        this.rowNodes.forEach(function (rowNode) {
	            if (rowNode.childrenCache) {
	                rowNode.childrenCache.destroy();
	                rowNode.childrenCache = null;
	            }
	            // this is needed, so row render knows to fade out the row, otherwise it
	            // sees row top is present, and thinks the row should be shown. maybe
	            // rowNode should have a flag on whether it is visible???
	            rowNode.clearRowTop();
	        });
	    };
	    RowNodeBlock.prototype.pageLoaded = function (version, rows, lastRow) {
	        // we need to check the version, in case there was an old request
	        // from the server that was sent before we refreshed the cache,
	        // if the load was done as a result of a cache refresh
	        if (version === this.version) {
	            this.state = RowNodeBlock.STATE_LOADED;
	            this.populateWithRowData(rows);
	        }
	        lastRow = utils_1._.cleanNumber(lastRow);
	        // check here if lastRow should be set
	        var event = {
	            type: RowNodeBlock.EVENT_LOAD_COMPLETE,
	            success: true,
	            page: this,
	            lastRow: lastRow
	        };
	        this.dispatchEvent(event);
	    };
	    RowNodeBlock.EVENT_LOAD_COMPLETE = 'loadComplete';
	    RowNodeBlock.STATE_DIRTY = 'dirty';
	    RowNodeBlock.STATE_LOADING = 'loading';
	    RowNodeBlock.STATE_LOADED = 'loaded';
	    RowNodeBlock.STATE_FAILED = 'failed';
	    return RowNodeBlock;
	}(beanStub_1.BeanStub));
	exports.RowNodeBlock = RowNodeBlock;


/***/ },
/* 325 */
/***/ function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// when doing transactions, or change detection, and grouping is present
	// in the data, there is no need for the ClientSideRowModel to update each
	// group after an update, ony parts that were impacted by the change.
	// this class keeps track of all groups that were impacted by a transaction.
	// the the different CSRM operations (filter, sort etc) use the forEach method
	// to visit each group that was changed.
	var ChangedPath = /** @class */ (function () {
	    function ChangedPath(keepingColumns, rootNode) {
	        // whether changed path is active of not. it is active when a) doing
	        // a transaction update or b) doing change detection. if we are doing
	        // a CSRM refresh for other reasons (after sort or filter, or user calling
	        // setRowData() without delta mode) then we are not active. we are also
	        // marked as not active if secondary columns change in pivot (as this impacts
	        // aggregations)
	        this.active = true;
	        // for each node in the change path, we also store which columns need
	        // to be re-aggregated.
	        this.nodeIdsToColumns = {};
	        // for quick lookup, all items in the change path are mapped by nodeId
	        this.mapToItems = {};
	        this.keepingColumns = keepingColumns;
	        this.pathRoot = {
	            rowNode: rootNode,
	            children: null
	        };
	        this.mapToItems[rootNode.id] = this.pathRoot;
	    }
	    // can be set inactive by:
	    // a) ClientSideRowModel, if no transactions or
	    // b) PivotService, if secondary columns changed
	    ChangedPath.prototype.setInactive = function () {
	        this.active = false;
	    };
	    ChangedPath.prototype.isActive = function () {
	        return this.active;
	    };
	    ChangedPath.prototype.depthFirstSearchChangedPath = function (pathItem, callback) {
	        if (pathItem.children) {
	            for (var i = 0; i < pathItem.children.length; i++) {
	                this.depthFirstSearchChangedPath(pathItem.children[i], callback);
	            }
	        }
	        callback(pathItem.rowNode);
	    };
	    ChangedPath.prototype.depthFirstSearchEverything = function (rowNode, callback, traverseEverything) {
	        if (rowNode.childrenAfterGroup) {
	            for (var i = 0; i < rowNode.childrenAfterGroup.length; i++) {
	                var childNode = rowNode.childrenAfterGroup[i];
	                if (childNode.childrenAfterGroup) {
	                    this.depthFirstSearchEverything(rowNode.childrenAfterGroup[i], callback, traverseEverything);
	                }
	                else if (traverseEverything) {
	                    callback(childNode);
	                }
	            }
	        }
	        callback(rowNode);
	    };
	    // traverseLeafNodes -> used when NOT doing changed path, ie traversing everything. the callback
	    // will be called for child nodes in addition to parent nodes.
	    ChangedPath.prototype.forEachChangedNodeDepthFirst = function (callback, traverseLeafNodes) {
	        if (traverseLeafNodes === void 0) { traverseLeafNodes = false; }
	        if (this.active) {
	            // if we are active, then use the change path to callback
	            // only for updated groups
	            this.depthFirstSearchChangedPath(this.pathRoot, callback);
	        }
	        else {
	            // we are not active, so callback for everything, walk the entire path
	            this.depthFirstSearchEverything(this.pathRoot.rowNode, callback, traverseLeafNodes);
	        }
	    };
	    ChangedPath.prototype.executeFromRootNode = function (callback) {
	        callback(this.pathRoot.rowNode);
	    };
	    ChangedPath.prototype.createPathItems = function (rowNode) {
	        var pointer = rowNode;
	        var newEntryCount = 0;
	        while (!this.mapToItems[pointer.id]) {
	            var newEntry = {
	                rowNode: pointer,
	                children: null
	            };
	            this.mapToItems[pointer.id] = newEntry;
	            newEntryCount++;
	            pointer = pointer.parent;
	        }
	        return newEntryCount;
	    };
	    ChangedPath.prototype.populateColumnsMap = function (rowNode, columns) {
	        var _this = this;
	        if (!this.keepingColumns || !columns) {
	            return;
	        }
	        var pointer = rowNode;
	        while (pointer) {
	            // if columns, add the columns in all the way to parent, merging
	            // in any other columns that might be there already
	            if (!this.nodeIdsToColumns[pointer.id]) {
	                this.nodeIdsToColumns[pointer.id] = {};
	            }
	            columns.forEach(function (col) { return _this.nodeIdsToColumns[pointer.id][col.getId()] = true; });
	            pointer = pointer.parent;
	        }
	    };
	    ChangedPath.prototype.linkPathItems = function (rowNode, newEntryCount) {
	        var pointer = rowNode;
	        for (var i = 0; i < newEntryCount; i++) {
	            var thisItem = this.mapToItems[pointer.id];
	            var parentItem = this.mapToItems[pointer.parent.id];
	            if (!parentItem.children) {
	                parentItem.children = [];
	            }
	            parentItem.children.push(thisItem);
	            pointer = pointer.parent;
	        }
	    };
	    // called by
	    // 1) change detection (provides cols) and
	    // 2) groupStage if doing transaction update (doesn't provide cols)
	    ChangedPath.prototype.addParentNode = function (rowNode, columns) {
	        // we cannot do  both steps below in the same loop as
	        // the second loop has a dependency on the first loop.
	        // ie the hierarchy cannot be stitched up yet because
	        // we don't have it built yet
	        // create the new PathItem objects.
	        var newEntryCount = this.createPathItems(rowNode);
	        // link in the node items
	        this.linkPathItems(rowNode, newEntryCount);
	        // update columns
	        this.populateColumnsMap(rowNode, columns);
	    };
	    ChangedPath.prototype.canSkip = function (rowNode) {
	        return this.active && !this.mapToItems[rowNode.id];
	    };
	    ChangedPath.prototype.getValueColumnsForNode = function (rowNode, valueColumns) {
	        if (!this.keepingColumns) {
	            return valueColumns;
	        }
	        var colsForThisNode = this.nodeIdsToColumns[rowNode.id];
	        var result = valueColumns.filter(function (col) { return colsForThisNode[col.getId()]; });
	        return result;
	    };
	    ChangedPath.prototype.getNotValueColumnsForNode = function (rowNode, valueColumns) {
	        if (!this.keepingColumns) {
	            return null;
	        }
	        var colsForThisNode = this.nodeIdsToColumns[rowNode.id];
	        var result = valueColumns.filter(function (col) { return !colsForThisNode[col.getId()]; });
	        return result;
	    };
	    return ChangedPath;
	}());
	exports.ChangedPath = ChangedPath;


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var dragService_1 = __webpack_require__(158);
	var context_1 = __webpack_require__(8);
	var agPanel_1 = __webpack_require__(449);
	var component_1 = __webpack_require__(31);
	var utils_1 = __webpack_require__(10);
	var AgDialog = /** @class */ (function (_super) {
	    __extends(AgDialog, _super);
	    function AgDialog(config) {
	        var _this = _super.call(this, config) || this;
	        _this.RESIZE_TEMPLATE = "\n        <div class=\"ag-resizer-wrapper\">\n            <div ref=\"eTopLeftResizer\" class=\"ag-resizer ag-resizer-topLeft\"></div>\n            <div ref=\"eTopResizer\" class=\"ag-resizer ag-resizer-top\"></div>\n            <div ref=\"eTopRightResizer\" class=\"ag-resizer ag-resizer-topRight\"></div>\n            <div ref=\"eRightResizer\" class=\"ag-resizer ag-resizer-right\"></div>\n            <div ref=\"eBottomRightResizer\" class=\"ag-resizer ag-resizer-bottomRight\"></div>\n            <div ref=\"eBottomResizer\" class=\"ag-resizer ag-resizer-bottom\"></div>\n            <div ref=\"eBottomLeftResizer\" class=\"ag-resizer ag-resizer-bottomLeft\"></div>\n            <div ref=\"eLeftResizer\" class=\"ag-resizer ag-resizer-left\"></div>\n        </div>\n    ";
	        _this.MAXIMIZE_BTN_TEMPLATE = "<div class=\"ag-dialog-button\"></span>";
	        _this.resizable = {};
	        _this.isResizable = false;
	        _this.movable = false;
	        _this.isMoving = false;
	        _this.isMaximizable = false;
	        _this.isMaximized = false;
	        _this.maximizeListeners = [];
	        _this.resizeListenerDestroy = null;
	        _this.isResizing = false;
	        _this.lastPosition = {
	            x: 0,
	            y: 0,
	            width: 0,
	            height: 0
	        };
	        return _this;
	    }
	    AgDialog.prototype.postConstruct = function () {
	        var _this = this;
	        var eGui = this.getGui();
	        var _a = this.config, movable = _a.movable, resizable = _a.resizable, maximizable = _a.maximizable;
	        utils_1._.addCssClass(eGui, 'ag-dialog');
	        this.moveElement = this.eTitleBar;
	        _super.prototype.postConstruct.call(this);
	        this.addDestroyableEventListener(eGui, 'focusin', function (e) {
	            if (eGui.contains(e.relatedTarget)) {
	                return;
	            }
	            _this.popupService.bringPopupToFront(eGui);
	        });
	        if (movable) {
	            this.setMovable(movable);
	        }
	        if (maximizable) {
	            this.setMaximizable(maximizable);
	        }
	        this.addResizers();
	        if (resizable) {
	            this.setResizable(resizable);
	        }
	    };
	    AgDialog.prototype.renderComponent = function () {
	        var eGui = this.getGui();
	        var _a = this.config, alwaysOnTop = _a.alwaysOnTop, modal = _a.modal;
	        this.close = this.popupService.addPopup(modal, eGui, true, this.destroy.bind(this), undefined, alwaysOnTop);
	        eGui.focus();
	    };
	    AgDialog.prototype.addResizers = function () {
	        var eGui = this.getGui();
	        if (!eGui) {
	            return;
	        }
	        var parser = new DOMParser();
	        var resizers = parser.parseFromString(this.RESIZE_TEMPLATE, 'text/html').body;
	        eGui.appendChild(resizers.firstChild);
	        this.createMap();
	    };
	    AgDialog.prototype.createMap = function () {
	        var eGui = this.getGui();
	        this.resizerMap = {
	            topLeft: { element: eGui.querySelector('[ref=eTopLeftResizer]') },
	            top: { element: eGui.querySelector('[ref=eTopResizer]') },
	            topRight: { element: eGui.querySelector('[ref=eTopRightResizer]') },
	            right: { element: eGui.querySelector('[ref=eRightResizer]') },
	            bottomRight: { element: eGui.querySelector('[ref=eBottomRightResizer]') },
	            bottom: { element: eGui.querySelector('[ref=eBottomResizer]') },
	            bottomLeft: { element: eGui.querySelector('[ref=eBottomLeftResizer]') },
	            left: { element: eGui.querySelector('[ref=eLeftResizer]') }
	        };
	    };
	    AgDialog.prototype.getResizerElement = function (side) {
	        return this.resizerMap[side].element;
	    };
	    AgDialog.prototype.onResizeStart = function (e) {
	        this.isResizing = true;
	        this.updateDragStartPosition(e.clientX, e.clientY);
	    };
	    AgDialog.prototype.onResize = function (e, side) {
	        if (!this.isResizing) {
	            return;
	        }
	        var isLeft = !!side.match(/left/i);
	        var isRight = !!side.match(/right/i);
	        var isTop = !!side.match(/top/i);
	        var isBottom = !!side.match(/bottom/i);
	        var isHorizontal = isLeft || isRight;
	        var isVertical = isTop || isBottom;
	        var _a = this.calculateMouseMovement({ e: e, isLeft: isLeft, isTop: isTop }), movementX = _a.movementX, movementY = _a.movementY;
	        var offsetLeft = 0;
	        var offsetTop = 0;
	        if (isHorizontal && movementX) {
	            var direction = isLeft ? -1 : 1;
	            var oldWidth = this.getWidth();
	            var newWidth = oldWidth + (movementX * direction);
	            var skipWidth = false;
	            if (isLeft) {
	                offsetLeft = oldWidth - newWidth;
	                if (this.position.x + offsetLeft <= 0 || newWidth <= this.minWidth) {
	                    skipWidth = true;
	                    offsetLeft = 0;
	                }
	            }
	            if (!skipWidth) {
	                this.setWidth(newWidth);
	            }
	        }
	        if (isVertical && movementY) {
	            var direction = isTop ? -1 : 1;
	            var oldHeight = this.getHeight();
	            var newHeight = oldHeight + (movementY * direction);
	            var skipHeight = false;
	            if (isTop) {
	                offsetTop = oldHeight - newHeight;
	                if (this.position.y + offsetTop <= 0 || newHeight <= this.minHeight) {
	                    skipHeight = true;
	                    offsetTop = 0;
	                }
	            }
	            if (!skipHeight) {
	                this.setHeight(newHeight);
	            }
	        }
	        this.updateDragStartPosition(e.clientX, e.clientY);
	        if (offsetLeft || offsetTop) {
	            this.offsetElement(this.position.x + offsetLeft, this.position.y + offsetTop);
	        }
	    };
	    AgDialog.prototype.onResizeEnd = function () {
	        this.isResizing = false;
	        var params = {
	            type: 'resize',
	            api: this.gridOptionsWrapper.getApi(),
	            columnApi: this.gridOptionsWrapper.getColumnApi()
	        };
	        if (this.localEventService) {
	            this.localEventService.dispatchEvent(params);
	        }
	    };
	    AgDialog.prototype.onMoveStart = function (e) {
	        this.isMoving = true;
	        this.updateDragStartPosition(e.clientX, e.clientY);
	    };
	    AgDialog.prototype.onMove = function (e) {
	        if (!this.isMoving) {
	            return;
	        }
	        var _a = this.position, x = _a.x, y = _a.y;
	        var _b = this.calculateMouseMovement({
	            e: e,
	            isTop: true,
	            anywhereWithin: true,
	            topBuffer: this.getHeight() - this.getBodyHeight()
	        }), movementX = _b.movementX, movementY = _b.movementY;
	        this.offsetElement(x + movementX, y + movementY);
	        this.updateDragStartPosition(e.clientX, e.clientY);
	    };
	    AgDialog.prototype.onMoveEnd = function () {
	        this.isMoving = false;
	    };
	    AgDialog.prototype.toggleMaximize = function () {
	        if (this.isMaximized) {
	            var _a = this.lastPosition, x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	            this.setWidth(width);
	            this.setHeight(height);
	            this.offsetElement(x, y);
	        }
	        else {
	            this.lastPosition.width = this.getWidth();
	            this.lastPosition.height = this.getHeight();
	            this.lastPosition.x = this.position.x;
	            this.lastPosition.y = this.position.y;
	            this.offsetElement(0, 0);
	            this.setHeight('100%');
	            this.setWidth('100%');
	        }
	        this.isMaximized = !this.isMaximized;
	        this.refreshMaximizeIcon();
	    };
	    AgDialog.prototype.refreshMaximizeIcon = function () {
	        utils_1._.addOrRemoveCssClass(this.maximizeIcon, 'ag-hidden', this.isMaximized);
	        utils_1._.addOrRemoveCssClass(this.minimizeIcon, 'ag-hidden', !this.isMaximized);
	    };
	    AgDialog.prototype.clearMaximizebleListeners = function () {
	        if (this.maximizeListeners.length) {
	            this.maximizeListeners.forEach(function (destroyListener) { return destroyListener(); });
	            this.maximizeListeners.length = 0;
	        }
	        if (this.resizeListenerDestroy) {
	            this.resizeListenerDestroy();
	            this.resizeListenerDestroy = null;
	        }
	    };
	    AgDialog.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        this.setResizable(false);
	        this.setMovable(false);
	        if (this.maximizeButtonComp) {
	            this.maximizeButtonComp.destroy();
	            this.maximizeButtonComp = undefined;
	        }
	        this.clearMaximizebleListeners();
	    };
	    AgDialog.prototype.setResizable = function (resizable) {
	        var _this = this;
	        var isResizable = false;
	        if (typeof resizable === 'boolean') {
	            resizable = {
	                topLeft: resizable,
	                top: resizable,
	                topRight: resizable,
	                right: resizable,
	                bottomRight: resizable,
	                bottom: resizable,
	                bottomLeft: resizable,
	                left: resizable
	            };
	        }
	        Object.keys(resizable).forEach(function (side) {
	            var r = resizable;
	            var s = side;
	            var val = !!r[s];
	            var el = _this.getResizerElement(s);
	            var params = _this.resizerMap[s].dragSource || {
	                eElement: el,
	                onDragStart: _this.onResizeStart.bind(_this),
	                onDragging: function (e) { return _this.onResize(e, s); },
	                onDragStop: _this.onResizeEnd.bind(_this),
	            };
	            if (!!_this.resizable[s] !== val || (!_this.isAlive() && !val)) {
	                if (val) {
	                    _this.dragService.addDragSource(params);
	                    el.style.pointerEvents = 'all';
	                    isResizable = true;
	                }
	                else {
	                    _this.dragService.removeDragSource(params);
	                    el.style.pointerEvents = 'none';
	                }
	                _this.resizerMap[s].dragSource = val ? params : undefined;
	            }
	        });
	        this.isResizable = isResizable;
	    };
	    AgDialog.prototype.setMovable = function (movable) {
	        if (movable !== this.movable) {
	            this.movable = movable;
	            var params = this.moveElementDragListener || {
	                eElement: this.moveElement,
	                onDragStart: this.onMoveStart.bind(this),
	                onDragging: this.onMove.bind(this),
	                onDragStop: this.onMoveEnd.bind(this)
	            };
	            if (movable) {
	                this.dragService.addDragSource(params);
	                this.moveElementDragListener = params;
	            }
	            else {
	                this.dragService.removeDragSource(params);
	                this.moveElementDragListener = undefined;
	            }
	        }
	    };
	    AgDialog.prototype.setMaximizable = function (maximizable) {
	        var _this = this;
	        if (maximizable === false) {
	            this.clearMaximizebleListeners();
	            if (this.maximizeButtonComp) {
	                this.maximizeButtonComp.destroy();
	                this.maximizeButtonComp = this.maximizeIcon = this.minimizeIcon = undefined;
	            }
	            return;
	        }
	        var eTitleBar = this.eTitleBar;
	        if (!eTitleBar || maximizable === this.isMaximizable) {
	            return;
	        }
	        var maximizeButtonComp = this.maximizeButtonComp = new component_1.Component(this.MAXIMIZE_BTN_TEMPLATE);
	        this.getContext().wireBean(maximizeButtonComp);
	        var eGui = maximizeButtonComp.getGui();
	        eGui.appendChild(this.maximizeIcon = utils_1._.createIconNoSpan('maximize', this.gridOptionsWrapper));
	        eGui.appendChild(this.minimizeIcon = utils_1._.createIconNoSpan('minimize', this.gridOptionsWrapper));
	        utils_1._.addCssClass(this.minimizeIcon, 'ag-hidden');
	        maximizeButtonComp.addDestroyableEventListener(eGui, 'click', this.toggleMaximize.bind(this));
	        this.addTitleBarButton(maximizeButtonComp, 0);
	        this.maximizeListeners.push(this.addDestroyableEventListener(eTitleBar, 'dblclick', this.toggleMaximize.bind(this)));
	        this.resizeListenerDestroy = this.addDestroyableEventListener(this, 'resize', function () {
	            _this.isMaximized = false;
	            _this.refreshMaximizeIcon();
	        });
	    };
	    __decorate([
	        context_1.Autowired('dragService'),
	        __metadata("design:type", dragService_1.DragService)
	    ], AgDialog.prototype, "dragService", void 0);
	    return AgDialog;
	}(agPanel_1.AgPanel));
	exports.AgDialog = AgDialog;


/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var agInputTextField_1 = __webpack_require__(448);
	var AgInputNumberField = /** @class */ (function (_super) {
	    __extends(AgInputNumberField, _super);
	    function AgInputNumberField() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.className = 'ag-number-field';
	        _this.inputType = 'number';
	        return _this;
	    }
	    AgInputNumberField.prototype.postConstruct = function () {
	        var _this = this;
	        _super.prototype.postConstruct.call(this);
	        this.addDestroyableEventListener(this.eInput, 'blur', function () {
	            var value = _this.normalizeValue(_this.eInput.value);
	            if (_this.value !== value) {
	                _this.setValue(value);
	            }
	        });
	    };
	    AgInputNumberField.prototype.normalizeValue = function (value) {
	        if (value === '') {
	            return '';
	        }
	        if (this.precision) {
	            value = this.adjustPrecision(value);
	        }
	        var val = parseFloat(value);
	        if (this.min != null && val < this.min) {
	            value = this.min.toString();
	        }
	        else if (this.max != null && val > this.max) {
	            value = this.max.toString();
	        }
	        return value;
	    };
	    AgInputNumberField.prototype.adjustPrecision = function (value) {
	        if (this.precision) {
	            var floatString = parseFloat(value).toFixed(this.precision);
	            value = parseFloat(floatString).toString();
	        }
	        return value;
	    };
	    AgInputNumberField.prototype.setMin = function (min) {
	        if (this.min === min) {
	            return this;
	        }
	        this.min = min;
	        if (this.min != null) {
	            this.eInput.setAttribute('min', min.toString());
	        }
	        else {
	            this.eInput.removeAttribute('min');
	        }
	        return this;
	    };
	    AgInputNumberField.prototype.setMax = function (max) {
	        if (this.max === max) {
	            return this;
	        }
	        this.max = max;
	        if (this.max != null) {
	            this.eInput.setAttribute('max', max.toString());
	        }
	        else {
	            this.eInput.removeAttribute('max');
	        }
	        return this;
	    };
	    AgInputNumberField.prototype.setPrecision = function (precision) {
	        this.precision = precision;
	        return this;
	    };
	    AgInputNumberField.prototype.setStep = function (step) {
	        if (this.step === step) {
	            return this;
	        }
	        this.step = step;
	        if (step != null) {
	            this.eInput.setAttribute('step', step.toString());
	        }
	        else {
	            this.eInput.removeAttribute('step');
	        }
	        return this;
	    };
	    AgInputNumberField.prototype.setValue = function (value, silent) {
	        value = this.adjustPrecision(value);
	        var normalizedValue = this.normalizeValue(value);
	        if (value != normalizedValue) {
	            return this;
	        }
	        return _super.prototype.setValue.call(this, value, silent);
	    };
	    return AgInputNumberField;
	}(agInputTextField_1.AgInputTextField));
	exports.AgInputNumberField = AgInputNumberField;


/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.END_DRAG = exports.DROP = exports.HOVER = exports.PUBLISH_DRAG_SOURCE = exports.BEGIN_DRAG = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.beginDrag = beginDrag;
	exports.publishDragSource = publishDragSource;
	exports.hover = hover;
	exports.drop = drop;
	exports.endDrag = endDrag;
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isArray = __webpack_require__(35);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isObject = __webpack_require__(177);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _matchesType = __webpack_require__(691);
	
	var _matchesType2 = _interopRequireDefault(_matchesType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BEGIN_DRAG = exports.BEGIN_DRAG = 'dnd-core/BEGIN_DRAG';
	var PUBLISH_DRAG_SOURCE = exports.PUBLISH_DRAG_SOURCE = 'dnd-core/PUBLISH_DRAG_SOURCE';
	var HOVER = exports.HOVER = 'dnd-core/HOVER';
	var DROP = exports.DROP = 'dnd-core/DROP';
	var END_DRAG = exports.END_DRAG = 'dnd-core/END_DRAG';
	
	function beginDrag(sourceIds) {
		var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { publishSource: true, clientOffset: null };
		var publishSource = options.publishSource,
		    clientOffset = options.clientOffset,
		    getSourceClientOffset = options.getSourceClientOffset;
	
		(0, _invariant2.default)((0, _isArray2.default)(sourceIds), 'Expected sourceIds to be an array.');
	
		var monitor = this.getMonitor();
		var registry = this.getRegistry();
		(0, _invariant2.default)(!monitor.isDragging(), 'Cannot call beginDrag while dragging.');
	
		for (var i = 0; i < sourceIds.length; i++) {
			(0, _invariant2.default)(registry.getSource(sourceIds[i]), 'Expected sourceIds to be registered.');
		}
	
		var sourceId = null;
		for (var _i = sourceIds.length - 1; _i >= 0; _i--) {
			if (monitor.canDragSource(sourceIds[_i])) {
				sourceId = sourceIds[_i];
				break;
			}
		}
		if (sourceId === null) {
			return;
		}
	
		var sourceClientOffset = null;
		if (clientOffset) {
			(0, _invariant2.default)(typeof getSourceClientOffset === 'function', 'When clientOffset is provided, getSourceClientOffset must be a function.');
			sourceClientOffset = getSourceClientOffset(sourceId);
		}
	
		var source = registry.getSource(sourceId);
		var item = source.beginDrag(monitor, sourceId);
		(0, _invariant2.default)((0, _isObject2.default)(item), 'Item must be an object.');
	
		registry.pinSource(sourceId);
	
		var itemType = registry.getSourceType(sourceId);
		return {
			type: BEGIN_DRAG,
			itemType: itemType,
			item: item,
			sourceId: sourceId,
			clientOffset: clientOffset,
			sourceClientOffset: sourceClientOffset,
			isSourcePublic: publishSource
		};
	}
	
	function publishDragSource() {
		var monitor = this.getMonitor();
		if (!monitor.isDragging()) {
			return;
		}
	
		return { type: PUBLISH_DRAG_SOURCE };
	}
	
	function hover(targetIdsArg) {
		var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
		    _ref$clientOffset = _ref.clientOffset,
		    clientOffset = _ref$clientOffset === undefined ? null : _ref$clientOffset;
	
		(0, _invariant2.default)((0, _isArray2.default)(targetIdsArg), 'Expected targetIds to be an array.');
		var targetIds = targetIdsArg.slice(0);
	
		var monitor = this.getMonitor();
		var registry = this.getRegistry();
		(0, _invariant2.default)(monitor.isDragging(), 'Cannot call hover while not dragging.');
		(0, _invariant2.default)(!monitor.didDrop(), 'Cannot call hover after drop.');
	
		// First check invariants.
		for (var i = 0; i < targetIds.length; i++) {
			var targetId = targetIds[i];
			(0, _invariant2.default)(targetIds.lastIndexOf(targetId) === i, 'Expected targetIds to be unique in the passed array.');
	
			var target = registry.getTarget(targetId);
			(0, _invariant2.default)(target, 'Expected targetIds to be registered.');
		}
	
		var draggedItemType = monitor.getItemType();
	
		// Remove those targetIds that don't match the targetType.  This
		// fixes shallow isOver which would only be non-shallow because of
		// non-matching targets.
		for (var _i2 = targetIds.length - 1; _i2 >= 0; _i2--) {
			var _targetId = targetIds[_i2];
			var targetType = registry.getTargetType(_targetId);
			if (!(0, _matchesType2.default)(targetType, draggedItemType)) {
				targetIds.splice(_i2, 1);
			}
		}
	
		// Finally call hover on all matching targets.
		for (var _i3 = 0; _i3 < targetIds.length; _i3++) {
			var _targetId2 = targetIds[_i3];
			var _target = registry.getTarget(_targetId2);
			_target.hover(monitor, _targetId2);
		}
	
		return {
			type: HOVER,
			targetIds: targetIds,
			clientOffset: clientOffset
		};
	}
	
	function drop() {
		var _this = this;
	
		var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
		var monitor = this.getMonitor();
		var registry = this.getRegistry();
		(0, _invariant2.default)(monitor.isDragging(), 'Cannot call drop while not dragging.');
		(0, _invariant2.default)(!monitor.didDrop(), 'Cannot call drop twice during one drag operation.');
	
		var targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
	
		targetIds.reverse();
		targetIds.forEach(function (targetId, index) {
			var target = registry.getTarget(targetId);
	
			var dropResult = target.drop(monitor, targetId);
			(0, _invariant2.default)(typeof dropResult === 'undefined' || (0, _isObject2.default)(dropResult), 'Drop result must either be an object or undefined.');
			if (typeof dropResult === 'undefined') {
				dropResult = index === 0 ? {} : monitor.getDropResult();
			}
	
			_this.store.dispatch({
				type: DROP,
				dropResult: _extends({}, options, dropResult)
			});
		});
	}
	
	function endDrag() {
		var monitor = this.getMonitor();
		var registry = this.getRegistry();
		(0, _invariant2.default)(monitor.isDragging(), 'Cannot call endDrag while not dragging.');
	
		var sourceId = monitor.getSourceId();
		var source = registry.getSource(sourceId, true);
		source.endDrag(monitor, sourceId);
	
		registry.unpinSource();
	
		return { type: END_DRAG };
	}

/***/ },
/* 329 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.addSource = addSource;
	exports.addTarget = addTarget;
	exports.removeSource = removeSource;
	exports.removeTarget = removeTarget;
	var ADD_SOURCE = exports.ADD_SOURCE = 'dnd-core/ADD_SOURCE';
	var ADD_TARGET = exports.ADD_TARGET = 'dnd-core/ADD_TARGET';
	var REMOVE_SOURCE = exports.REMOVE_SOURCE = 'dnd-core/REMOVE_SOURCE';
	var REMOVE_TARGET = exports.REMOVE_TARGET = 'dnd-core/REMOVE_TARGET';
	
	function addSource(sourceId) {
		return {
			type: ADD_SOURCE,
			sourceId: sourceId
		};
	}
	
	function addTarget(targetId) {
		return {
			type: ADD_TARGET,
			targetId: targetId
		};
	}
	
	function removeSource(sourceId) {
		return {
			type: REMOVE_SOURCE,
			sourceId: sourceId
		};
	}
	
	function removeTarget(targetId) {
		return {
			type: REMOVE_TARGET,
			targetId: targetId
		};
	}

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var _symbol = __webpack_require__(84);
	
	var createSymbol = _symbol.createSymbol;
	
	var graphic = __webpack_require__(16);
	
	var _number = __webpack_require__(20);
	
	var parsePercent = _number.parsePercent;
	
	var _labelHelper = __webpack_require__(457);
	
	var getDefaultLabel = _labelHelper.getDefaultLabel;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/chart/helper/Symbol
	 */
	
	/**
	 * @constructor
	 * @alias {module:echarts/chart/helper/Symbol}
	 * @param {module:echarts/data/List} data
	 * @param {number} idx
	 * @extends {module:zrender/graphic/Group}
	 */
	function SymbolClz(data, idx, seriesScope) {
	  graphic.Group.call(this);
	  this.updateData(data, idx, seriesScope);
	}
	
	var symbolProto = SymbolClz.prototype;
	/**
	 * @public
	 * @static
	 * @param {module:echarts/data/List} data
	 * @param {number} dataIndex
	 * @return {Array.<number>} [width, height]
	 */
	
	var getSymbolSize = SymbolClz.getSymbolSize = function (data, idx) {
	  var symbolSize = data.getItemVisual(idx, 'symbolSize');
	  return symbolSize instanceof Array ? symbolSize.slice() : [+symbolSize, +symbolSize];
	};
	
	function getScale(symbolSize) {
	  return [symbolSize[0] / 2, symbolSize[1] / 2];
	}
	
	function driftSymbol(dx, dy) {
	  this.parent.drift(dx, dy);
	}
	
	symbolProto._createSymbol = function (symbolType, data, idx, symbolSize, keepAspect) {
	  // Remove paths created before
	  this.removeAll();
	  var color = data.getItemVisual(idx, 'color'); // var symbolPath = createSymbol(
	  //     symbolType, -0.5, -0.5, 1, 1, color
	  // );
	  // If width/height are set too small (e.g., set to 1) on ios10
	  // and macOS Sierra, a circle stroke become a rect, no matter what
	  // the scale is set. So we set width/height as 2. See #4150.
	
	  var symbolPath = createSymbol(symbolType, -1, -1, 2, 2, color, keepAspect);
	  symbolPath.attr({
	    z2: 100,
	    culling: true,
	    scale: getScale(symbolSize)
	  }); // Rewrite drift method
	
	  symbolPath.drift = driftSymbol;
	  this._symbolType = symbolType;
	  this.add(symbolPath);
	};
	/**
	 * Stop animation
	 * @param {boolean} toLastFrame
	 */
	
	
	symbolProto.stopSymbolAnimation = function (toLastFrame) {
	  this.childAt(0).stopAnimation(toLastFrame);
	};
	/**
	 * FIXME:
	 * Caution: This method breaks the encapsulation of this module,
	 * but it indeed brings convenience. So do not use the method
	 * unless you detailedly know all the implements of `Symbol`,
	 * especially animation.
	 *
	 * Get symbol path element.
	 */
	
	
	symbolProto.getSymbolPath = function () {
	  return this.childAt(0);
	};
	/**
	 * Get scale(aka, current symbol size).
	 * Including the change caused by animation
	 */
	
	
	symbolProto.getScale = function () {
	  return this.childAt(0).scale;
	};
	/**
	 * Highlight symbol
	 */
	
	
	symbolProto.highlight = function () {
	  this.childAt(0).trigger('emphasis');
	};
	/**
	 * Downplay symbol
	 */
	
	
	symbolProto.downplay = function () {
	  this.childAt(0).trigger('normal');
	};
	/**
	 * @param {number} zlevel
	 * @param {number} z
	 */
	
	
	symbolProto.setZ = function (zlevel, z) {
	  var symbolPath = this.childAt(0);
	  symbolPath.zlevel = zlevel;
	  symbolPath.z = z;
	};
	
	symbolProto.setDraggable = function (draggable) {
	  var symbolPath = this.childAt(0);
	  symbolPath.draggable = draggable;
	  symbolPath.cursor = draggable ? 'move' : symbolPath.cursor;
	};
	/**
	 * Update symbol properties
	 * @param {module:echarts/data/List} data
	 * @param {number} idx
	 * @param {Object} [seriesScope]
	 * @param {Object} [seriesScope.itemStyle]
	 * @param {Object} [seriesScope.hoverItemStyle]
	 * @param {Object} [seriesScope.symbolRotate]
	 * @param {Object} [seriesScope.symbolOffset]
	 * @param {module:echarts/model/Model} [seriesScope.labelModel]
	 * @param {module:echarts/model/Model} [seriesScope.hoverLabelModel]
	 * @param {boolean} [seriesScope.hoverAnimation]
	 * @param {Object} [seriesScope.cursorStyle]
	 * @param {module:echarts/model/Model} [seriesScope.itemModel]
	 * @param {string} [seriesScope.symbolInnerColor]
	 * @param {Object} [seriesScope.fadeIn=false]
	 */
	
	
	symbolProto.updateData = function (data, idx, seriesScope) {
	  this.silent = false;
	  var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';
	  var seriesModel = data.hostModel;
	  var symbolSize = getSymbolSize(data, idx);
	  var isInit = symbolType !== this._symbolType;
	
	  if (isInit) {
	    var keepAspect = data.getItemVisual(idx, 'symbolKeepAspect');
	
	    this._createSymbol(symbolType, data, idx, symbolSize, keepAspect);
	  } else {
	    var symbolPath = this.childAt(0);
	    symbolPath.silent = false;
	    graphic.updateProps(symbolPath, {
	      scale: getScale(symbolSize)
	    }, seriesModel, idx);
	  }
	
	  this._updateCommon(data, idx, symbolSize, seriesScope);
	
	  if (isInit) {
	    var symbolPath = this.childAt(0);
	    var fadeIn = seriesScope && seriesScope.fadeIn;
	    var target = {
	      scale: symbolPath.scale.slice()
	    };
	    fadeIn && (target.style = {
	      opacity: symbolPath.style.opacity
	    });
	    symbolPath.scale = [0, 0];
	    fadeIn && (symbolPath.style.opacity = 0);
	    graphic.initProps(symbolPath, target, seriesModel, idx);
	  }
	
	  this._seriesModel = seriesModel;
	}; // Update common properties
	
	
	var normalStyleAccessPath = ['itemStyle'];
	var emphasisStyleAccessPath = ['emphasis', 'itemStyle'];
	var normalLabelAccessPath = ['label'];
	var emphasisLabelAccessPath = ['emphasis', 'label'];
	/**
	 * @param {module:echarts/data/List} data
	 * @param {number} idx
	 * @param {Array.<number>} symbolSize
	 * @param {Object} [seriesScope]
	 */
	
	symbolProto._updateCommon = function (data, idx, symbolSize, seriesScope) {
	  var symbolPath = this.childAt(0);
	  var seriesModel = data.hostModel;
	  var color = data.getItemVisual(idx, 'color'); // Reset style
	
	  if (symbolPath.type !== 'image') {
	    symbolPath.useStyle({
	      strokeNoScale: true
	    });
	  } else {
	    symbolPath.setStyle({
	      opacity: 1,
	      shadowBlur: null,
	      shadowOffsetX: null,
	      shadowOffsetY: null,
	      shadowColor: null
	    });
	  }
	
	  var itemStyle = seriesScope && seriesScope.itemStyle;
	  var hoverItemStyle = seriesScope && seriesScope.hoverItemStyle;
	  var symbolOffset = seriesScope && seriesScope.symbolOffset;
	  var labelModel = seriesScope && seriesScope.labelModel;
	  var hoverLabelModel = seriesScope && seriesScope.hoverLabelModel;
	  var hoverAnimation = seriesScope && seriesScope.hoverAnimation;
	  var cursorStyle = seriesScope && seriesScope.cursorStyle;
	
	  if (!seriesScope || data.hasItemOption) {
	    var itemModel = seriesScope && seriesScope.itemModel ? seriesScope.itemModel : data.getItemModel(idx); // Color must be excluded.
	    // Because symbol provide setColor individually to set fill and stroke
	
	    itemStyle = itemModel.getModel(normalStyleAccessPath).getItemStyle(['color']);
	    hoverItemStyle = itemModel.getModel(emphasisStyleAccessPath).getItemStyle();
	    symbolOffset = itemModel.getShallow('symbolOffset');
	    labelModel = itemModel.getModel(normalLabelAccessPath);
	    hoverLabelModel = itemModel.getModel(emphasisLabelAccessPath);
	    hoverAnimation = itemModel.getShallow('hoverAnimation');
	    cursorStyle = itemModel.getShallow('cursor');
	  } else {
	    hoverItemStyle = zrUtil.extend({}, hoverItemStyle);
	  }
	
	  var elStyle = symbolPath.style;
	  var symbolRotate = data.getItemVisual(idx, 'symbolRotate');
	  symbolPath.attr('rotation', (symbolRotate || 0) * Math.PI / 180 || 0);
	
	  if (symbolOffset) {
	    symbolPath.attr('position', [parsePercent(symbolOffset[0], symbolSize[0]), parsePercent(symbolOffset[1], symbolSize[1])]);
	  }
	
	  cursorStyle && symbolPath.attr('cursor', cursorStyle); // PENDING setColor before setStyle!!!
	
	  symbolPath.setColor(color, seriesScope && seriesScope.symbolInnerColor);
	  symbolPath.setStyle(itemStyle);
	  var opacity = data.getItemVisual(idx, 'opacity');
	
	  if (opacity != null) {
	    elStyle.opacity = opacity;
	  }
	
	  var liftZ = data.getItemVisual(idx, 'liftZ');
	  var z2Origin = symbolPath.__z2Origin;
	
	  if (liftZ != null) {
	    if (z2Origin == null) {
	      symbolPath.__z2Origin = symbolPath.z2;
	      symbolPath.z2 += liftZ;
	    }
	  } else if (z2Origin != null) {
	    symbolPath.z2 = z2Origin;
	    symbolPath.__z2Origin = null;
	  }
	
	  var useNameLabel = seriesScope && seriesScope.useNameLabel;
	  graphic.setLabelStyle(elStyle, hoverItemStyle, labelModel, hoverLabelModel, {
	    labelFetcher: seriesModel,
	    labelDataIndex: idx,
	    defaultText: getLabelDefaultText,
	    isRectText: true,
	    autoColor: color
	  }); // Do not execute util needed.
	
	  function getLabelDefaultText(idx, opt) {
	    return useNameLabel ? data.getName(idx) : getDefaultLabel(data, idx);
	  }
	
	  symbolPath.__symbolOriginalScale = getScale(symbolSize);
	  symbolPath.hoverStyle = hoverItemStyle;
	  symbolPath.highDownOnUpdate = hoverAnimation && seriesModel.isAnimationEnabled() ? highDownOnUpdate : null;
	  graphic.setHoverStyle(symbolPath);
	};
	
	function highDownOnUpdate(fromState, toState) {
	  // Do not support this hover animation util some scenario required.
	  // Animation can only be supported in hover layer when using `el.incremetal`.
	  if (this.incremental || this.useHoverLayer) {
	    return;
	  }
	
	  if (toState === 'emphasis') {
	    var scale = this.__symbolOriginalScale;
	    var ratio = scale[1] / scale[0];
	    var emphasisOpt = {
	      scale: [Math.max(scale[0] * 1.1, scale[0] + 3), Math.max(scale[1] * 1.1, scale[1] + 3 * ratio)]
	    }; // FIXME
	    // modify it after support stop specified animation.
	    // toState === fromState
	    //     ? (this.stopAnimation(), this.attr(emphasisOpt))
	
	    this.animateTo(emphasisOpt, 400, 'elasticOut');
	  } else if (toState === 'normal') {
	    this.animateTo({
	      scale: this.__symbolOriginalScale
	    }, 400, 'elasticOut');
	  }
	}
	/**
	 * @param {Function} cb
	 * @param {Object} [opt]
	 * @param {Object} [opt.keepLabel=true]
	 */
	
	
	symbolProto.fadeOut = function (cb, opt) {
	  var symbolPath = this.childAt(0); // Avoid mistaken hover when fading out
	
	  this.silent = symbolPath.silent = true; // Not show text when animating
	
	  !(opt && opt.keepLabel) && (symbolPath.style.text = null);
	  graphic.updateProps(symbolPath, {
	    style: {
	      opacity: 0
	    },
	    scale: [0, 0]
	  }, this._seriesModel, this.dataIndex, cb);
	};
	
	zrUtil.inherits(SymbolClz, graphic.Group);
	var _default = SymbolClz;
	module.exports = _default;

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var KEY_DELIMITER = '-->';
	/**
	 * params handler
	 * @param {module:echarts/model/SeriesModel} seriesModel
	 * @returns {*}
	 */
	
	var getAutoCurvenessParams = function (seriesModel) {
	  return seriesModel.get('autoCurveness') || null;
	};
	/**
	 * Generate a list of edge curvatures, 20 is the default
	 * @param {module:echarts/model/SeriesModel} seriesModel
	 * @param {number} appendLength
	 * @return  20 => [0, -0.2, 0.2, -0.4, 0.4, -0.6, 0.6, -0.8, 0.8, -1, 1, -1.2, 1.2, -1.4, 1.4, -1.6, 1.6, -1.8, 1.8, -2]
	 */
	
	
	var createCurveness = function (seriesModel, appendLength) {
	  var autoCurvenessParmas = getAutoCurvenessParams(seriesModel);
	  var length = 20;
	  var curvenessList = []; // handler the function set
	
	  if (typeof autoCurvenessParmas === 'number') {
	    length = autoCurvenessParmas;
	  } else if (zrUtil.isArray(autoCurvenessParmas)) {
	    seriesModel.__curvenessList = autoCurvenessParmas;
	    return;
	  } // append length
	
	
	  if (appendLength > length) {
	    length = appendLength;
	  } // make sure the length is even
	
	
	  var len = length % 2 ? length + 2 : length + 3;
	  curvenessList = [];
	
	  for (var i = 0; i < len; i++) {
	    curvenessList.push((i % 2 ? i + 1 : i) / 10 * (i % 2 ? -1 : 1));
	  }
	
	  seriesModel.__curvenessList = curvenessList;
	};
	/**
	 * Create different cache key data in the positive and negative directions, in order to set the curvature later
	 * @param {number|string|module:echarts/data/Graph.Node} n1
	 * @param {number|string|module:echarts/data/Graph.Node} n2
	 * @param {module:echarts/model/SeriesModel} seriesModel
	 * @returns {string} key
	 */
	
	
	var getKeyOfEdges = function (n1, n2, seriesModel) {
	  var source = [n1.id, n1.dataIndex].join('.');
	  var target = [n2.id, n2.dataIndex].join('.');
	  return [seriesModel.uid, source, target].join(KEY_DELIMITER);
	};
	/**
	 * get opposite key
	 * @param {string} key
	 * @returns {string}
	 */
	
	
	var getOppositeKey = function (key) {
	  var keys = key.split(KEY_DELIMITER);
	  return [keys[0], keys[2], keys[1]].join(KEY_DELIMITER);
	};
	/**
	 * get edgeMap with key
	 * @param edge
	 * @param {module:echarts/model/SeriesModel} seriesModel
	 */
	
	
	var getEdgeFromMap = function (edge, seriesModel) {
	  var key = getKeyOfEdges(edge.node1, edge.node2, seriesModel);
	  return seriesModel.__edgeMap[key];
	};
	/**
	 * calculate all cases total length
	 * @param edge
	 * @param seriesModel
	 * @returns {number}
	 */
	
	
	var getTotalLengthBetweenNodes = function (edge, seriesModel) {
	  var len = getEdgeMapLengthWithKey(getKeyOfEdges(edge.node1, edge.node2, seriesModel), seriesModel);
	  var lenV = getEdgeMapLengthWithKey(getKeyOfEdges(edge.node2, edge.node1, seriesModel), seriesModel);
	  return len + lenV;
	};
	/**
	 *
	 * @param key
	 */
	
	
	var getEdgeMapLengthWithKey = function (key, seriesModel) {
	  var edgeMap = seriesModel.__edgeMap;
	  return edgeMap[key] ? edgeMap[key].length : 0;
	};
	/**
	 * Count the number of edges between the same two points, used to obtain the curvature table and the parity of the edge
	 * @see /graph/GraphSeries.js@getInitialData
	 * @param {module:echarts/model/SeriesModel} seriesModel
	 */
	
	
	function initCurvenessList(seriesModel) {
	  if (!getAutoCurvenessParams(seriesModel)) {
	    return;
	  }
	
	  seriesModel.__curvenessList = [];
	  seriesModel.__edgeMap = {}; // calc the array of curveness List
	
	  createCurveness(seriesModel);
	}
	/**
	 * set edgeMap with key
	 * @param {number|string|module:echarts/data/Graph.Node} n1
	 * @param {number|string|module:echarts/data/Graph.Node} n2
	 * @param {module:echarts/model/SeriesModel} seriesModel
	 * @param {number} index
	 */
	
	
	function createEdgeMapForCurveness(n1, n2, seriesModel, index) {
	  if (!getAutoCurvenessParams(seriesModel)) {
	    return;
	  }
	
	  var key = getKeyOfEdges(n1, n2, seriesModel);
	  var edgeMap = seriesModel.__edgeMap;
	  var oppositeEdges = edgeMap[getOppositeKey(key)]; // set direction
	
	  if (edgeMap[key] && !oppositeEdges) {
	    edgeMap[key].isForward = true;
	  } else if (oppositeEdges && edgeMap[key]) {
	    oppositeEdges.isForward = true;
	    edgeMap[key].isForward = false;
	  }
	
	  edgeMap[key] = edgeMap[key] || [];
	  edgeMap[key].push(index);
	}
	/**
	 * get curvature for edge
	 * @param edge
	 * @param {module:echarts/model/SeriesModel} seriesModel
	 * @param index
	 */
	
	
	function getCurvenessForEdge(edge, seriesModel, index, needReverse) {
	  var autoCurvenessParams = getAutoCurvenessParams(seriesModel);
	  var isArrayParam = zrUtil.isArray(autoCurvenessParams);
	
	  if (!autoCurvenessParams) {
	    return null;
	  }
	
	  var edgeArray = getEdgeFromMap(edge, seriesModel);
	
	  if (!edgeArray) {
	    return null;
	  }
	
	  var edgeIndex = -1;
	
	  for (var i = 0; i < edgeArray.length; i++) {
	    if (edgeArray[i] === index) {
	      edgeIndex = i;
	      break;
	    }
	  } // if totalLen is Longer createCurveness
	
	
	  var totalLen = getTotalLengthBetweenNodes(edge, seriesModel);
	  createCurveness(seriesModel, totalLen);
	  edge.lineStyle = edge.lineStyle || {}; // if is opposite edge, must set curvenss to opposite number
	
	  var curKey = getKeyOfEdges(edge.node1, edge.node2, seriesModel);
	  var curvenessList = seriesModel.__curvenessList; // if pass array no need parity
	
	  var parityCorrection = isArrayParam ? 0 : totalLen % 2 ? 0 : 1;
	
	  if (!edgeArray.isForward) {
	    // the opposite edge show outside
	    var oppositeKey = getOppositeKey(curKey);
	    var len = getEdgeMapLengthWithKey(oppositeKey, seriesModel);
	    var resValue = curvenessList[edgeIndex + len + parityCorrection]; // isNeedReverse, simple, force type need reverse the curveness in the junction of the forword and the opposite
	
	    if (needReverse) {
	      // set as array may make the parity handle with the len of opposite
	      if (isArrayParam) {
	        if (autoCurvenessParams && autoCurvenessParams[0] === 0) {
	          return (len + parityCorrection) % 2 ? resValue : -resValue;
	        } else {
	          return ((len % 2 ? 0 : 1) + parityCorrection) % 2 ? resValue : -resValue;
	        }
	      } else {
	        return (len + parityCorrection) % 2 ? resValue : -resValue;
	      }
	    } else {
	      return curvenessList[edgeIndex + len + parityCorrection];
	    }
	  } else {
	    return curvenessList[parityCorrection + edgeIndex];
	  }
	}
	
	exports.initCurvenessList = initCurvenessList;
	exports.createEdgeMapForCurveness = createEdgeMapForCurveness;
	exports.getCurvenessForEdge = getCurvenessForEdge;

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var Model = __webpack_require__(48);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var curry = zrUtil.curry; // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
	// allAxesInfo should be updated when setOption performed.
	
	function collect(ecModel, api) {
	  var result = {
	    /**
	     * key: makeKey(axis.model)
	     * value: {
	     *      axis,
	     *      coordSys,
	     *      axisPointerModel,
	     *      triggerTooltip,
	     *      involveSeries,
	     *      snap,
	     *      seriesModels,
	     *      seriesDataCount
	     * }
	     */
	    axesInfo: {},
	    seriesInvolved: false,
	
	    /**
	     * key: makeKey(coordSys.model)
	     * value: Object: key makeKey(axis.model), value: axisInfo
	     */
	    coordSysAxesInfo: {},
	    coordSysMap: {}
	  };
	  collectAxesInfo(result, ecModel, api); // Check seriesInvolved for performance, in case too many series in some chart.
	
	  result.seriesInvolved && collectSeriesInfo(result, ecModel);
	  return result;
	}
	
	function collectAxesInfo(result, ecModel, api) {
	  var globalTooltipModel = ecModel.getComponent('tooltip');
	  var globalAxisPointerModel = ecModel.getComponent('axisPointer'); // links can only be set on global.
	
	  var linksOption = globalAxisPointerModel.get('link', true) || [];
	  var linkGroups = []; // Collect axes info.
	
	  each(api.getCoordinateSystems(), function (coordSys) {
	    // Some coordinate system do not support axes, like geo.
	    if (!coordSys.axisPointerEnabled) {
	      return;
	    }
	
	    var coordSysKey = makeKey(coordSys.model);
	    var axesInfoInCoordSys = result.coordSysAxesInfo[coordSysKey] = {};
	    result.coordSysMap[coordSysKey] = coordSys; // Set tooltip (like 'cross') is a convienent way to show axisPointer
	    // for user. So we enable seting tooltip on coordSys model.
	
	    var coordSysModel = coordSys.model;
	    var baseTooltipModel = coordSysModel.getModel('tooltip', globalTooltipModel);
	    each(coordSys.getAxes(), curry(saveTooltipAxisInfo, false, null)); // If axis tooltip used, choose tooltip axis for each coordSys.
	    // Notice this case: coordSys is `grid` but not `cartesian2D` here.
	
	    if (coordSys.getTooltipAxes && globalTooltipModel // If tooltip.showContent is set as false, tooltip will not
	    // show but axisPointer will show as normal.
	    && baseTooltipModel.get('show')) {
	      // Compatible with previous logic. But series.tooltip.trigger: 'axis'
	      // or series.data[n].tooltip.trigger: 'axis' are not support any more.
	      var triggerAxis = baseTooltipModel.get('trigger') === 'axis';
	      var cross = baseTooltipModel.get('axisPointer.type') === 'cross';
	      var tooltipAxes = coordSys.getTooltipAxes(baseTooltipModel.get('axisPointer.axis'));
	
	      if (triggerAxis || cross) {
	        each(tooltipAxes.baseAxes, curry(saveTooltipAxisInfo, cross ? 'cross' : true, triggerAxis));
	      }
	
	      if (cross) {
	        each(tooltipAxes.otherAxes, curry(saveTooltipAxisInfo, 'cross', false));
	      }
	    } // fromTooltip: true | false | 'cross'
	    // triggerTooltip: true | false | null
	
	
	    function saveTooltipAxisInfo(fromTooltip, triggerTooltip, axis) {
	      var axisPointerModel = axis.model.getModel('axisPointer', globalAxisPointerModel);
	      var axisPointerShow = axisPointerModel.get('show');
	
	      if (!axisPointerShow || axisPointerShow === 'auto' && !fromTooltip && !isHandleTrigger(axisPointerModel)) {
	        return;
	      }
	
	      if (triggerTooltip == null) {
	        triggerTooltip = axisPointerModel.get('triggerTooltip');
	      }
	
	      axisPointerModel = fromTooltip ? makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) : axisPointerModel;
	      var snap = axisPointerModel.get('snap');
	      var key = makeKey(axis.model);
	      var involveSeries = triggerTooltip || snap || axis.type === 'category'; // If result.axesInfo[key] exist, override it (tooltip has higher priority).
	
	      var axisInfo = result.axesInfo[key] = {
	        key: key,
	        axis: axis,
	        coordSys: coordSys,
	        axisPointerModel: axisPointerModel,
	        triggerTooltip: triggerTooltip,
	        involveSeries: involveSeries,
	        snap: snap,
	        useHandle: isHandleTrigger(axisPointerModel),
	        seriesModels: []
	      };
	      axesInfoInCoordSys[key] = axisInfo;
	      result.seriesInvolved |= involveSeries;
	      var groupIndex = getLinkGroupIndex(linksOption, axis);
	
	      if (groupIndex != null) {
	        var linkGroup = linkGroups[groupIndex] || (linkGroups[groupIndex] = {
	          axesInfo: {}
	        });
	        linkGroup.axesInfo[key] = axisInfo;
	        linkGroup.mapper = linksOption[groupIndex].mapper;
	        axisInfo.linkGroup = linkGroup;
	      }
	    }
	  });
	}
	
	function makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) {
	  var tooltipAxisPointerModel = baseTooltipModel.getModel('axisPointer');
	  var volatileOption = {};
	  each(['type', 'snap', 'lineStyle', 'shadowStyle', 'label', 'animation', 'animationDurationUpdate', 'animationEasingUpdate', 'z'], function (field) {
	    volatileOption[field] = zrUtil.clone(tooltipAxisPointerModel.get(field));
	  }); // category axis do not auto snap, otherwise some tick that do not
	  // has value can not be hovered. value/time/log axis default snap if
	  // triggered from tooltip and trigger tooltip.
	
	  volatileOption.snap = axis.type !== 'category' && !!triggerTooltip; // Compatibel with previous behavior, tooltip axis do not show label by default.
	  // Only these properties can be overrided from tooltip to axisPointer.
	
	  if (tooltipAxisPointerModel.get('type') === 'cross') {
	    volatileOption.type = 'line';
	  }
	
	  var labelOption = volatileOption.label || (volatileOption.label = {}); // Follow the convention, do not show label when triggered by tooltip by default.
	
	  labelOption.show == null && (labelOption.show = false);
	
	  if (fromTooltip === 'cross') {
	    // When 'cross', both axes show labels.
	    var tooltipAxisPointerLabelShow = tooltipAxisPointerModel.get('label.show');
	    labelOption.show = tooltipAxisPointerLabelShow != null ? tooltipAxisPointerLabelShow : true; // If triggerTooltip, this is a base axis, which should better not use cross style
	    // (cross style is dashed by default)
	
	    if (!triggerTooltip) {
	      var crossStyle = volatileOption.lineStyle = tooltipAxisPointerModel.get('crossStyle');
	      crossStyle && zrUtil.defaults(labelOption, crossStyle.textStyle);
	    }
	  }
	
	  return axis.model.getModel('axisPointer', new Model(volatileOption, globalAxisPointerModel, ecModel));
	}
	
	function collectSeriesInfo(result, ecModel) {
	  // Prepare data for axis trigger
	  ecModel.eachSeries(function (seriesModel) {
	    // Notice this case: this coordSys is `cartesian2D` but not `grid`.
	    var coordSys = seriesModel.coordinateSystem;
	    var seriesTooltipTrigger = seriesModel.get('tooltip.trigger', true);
	    var seriesTooltipShow = seriesModel.get('tooltip.show', true);
	
	    if (!coordSys || seriesTooltipTrigger === 'none' || seriesTooltipTrigger === false || seriesTooltipTrigger === 'item' || seriesTooltipShow === false || seriesModel.get('axisPointer.show', true) === false) {
	      return;
	    }
	
	    each(result.coordSysAxesInfo[makeKey(coordSys.model)], function (axisInfo) {
	      var axis = axisInfo.axis;
	
	      if (coordSys.getAxis(axis.dim) === axis) {
	        axisInfo.seriesModels.push(seriesModel);
	        axisInfo.seriesDataCount == null && (axisInfo.seriesDataCount = 0);
	        axisInfo.seriesDataCount += seriesModel.getData().count();
	      }
	    });
	  }, this);
	}
	/**
	 * For example:
	 * {
	 *     axisPointer: {
	 *         links: [{
	 *             xAxisIndex: [2, 4],
	 *             yAxisIndex: 'all'
	 *         }, {
	 *             xAxisId: ['a5', 'a7'],
	 *             xAxisName: 'xxx'
	 *         }]
	 *     }
	 * }
	 */
	
	
	function getLinkGroupIndex(linksOption, axis) {
	  var axisModel = axis.model;
	  var dim = axis.dim;
	
	  for (var i = 0; i < linksOption.length; i++) {
	    var linkOption = linksOption[i] || {};
	
	    if (checkPropInLink(linkOption[dim + 'AxisId'], axisModel.id) || checkPropInLink(linkOption[dim + 'AxisIndex'], axisModel.componentIndex) || checkPropInLink(linkOption[dim + 'AxisName'], axisModel.name)) {
	      return i;
	    }
	  }
	}
	
	function checkPropInLink(linkPropValue, axisPropValue) {
	  return linkPropValue === 'all' || zrUtil.isArray(linkPropValue) && zrUtil.indexOf(linkPropValue, axisPropValue) >= 0 || linkPropValue === axisPropValue;
	}
	
	function fixValue(axisModel) {
	  var axisInfo = getAxisInfo(axisModel);
	
	  if (!axisInfo) {
	    return;
	  }
	
	  var axisPointerModel = axisInfo.axisPointerModel;
	  var scale = axisInfo.axis.scale;
	  var option = axisPointerModel.option;
	  var status = axisPointerModel.get('status');
	  var value = axisPointerModel.get('value'); // Parse init value for category and time axis.
	
	  if (value != null) {
	    value = scale.parse(value);
	  }
	
	  var useHandle = isHandleTrigger(axisPointerModel); // If `handle` used, `axisPointer` will always be displayed, so value
	  // and status should be initialized.
	
	  if (status == null) {
	    option.status = useHandle ? 'show' : 'hide';
	  }
	
	  var extent = scale.getExtent().slice();
	  extent[0] > extent[1] && extent.reverse();
	
	  if ( // Pick a value on axis when initializing.
	  value == null // If both `handle` and `dataZoom` are used, value may be out of axis extent,
	  // where we should re-pick a value to keep `handle` displaying normally.
	  || value > extent[1]) {
	    // Make handle displayed on the end of the axis when init, which looks better.
	    value = extent[1];
	  }
	
	  if (value < extent[0]) {
	    value = extent[0];
	  }
	
	  option.value = value;
	
	  if (useHandle) {
	    option.status = axisInfo.axis.scale.isBlank() ? 'hide' : 'show';
	  }
	}
	
	function getAxisInfo(axisModel) {
	  var coordSysAxesInfo = (axisModel.ecModel.getComponent('axisPointer') || {}).coordSysAxesInfo;
	  return coordSysAxesInfo && coordSysAxesInfo.axesInfo[makeKey(axisModel)];
	}
	
	function getAxisPointerModel(axisModel) {
	  var axisInfo = getAxisInfo(axisModel);
	  return axisInfo && axisInfo.axisPointerModel;
	}
	
	function isHandleTrigger(axisPointerModel) {
	  return !!axisPointerModel.get('handle.show');
	}
	/**
	 * @param {module:echarts/model/Model} model
	 * @return {string} unique key
	 */
	
	
	function makeKey(model) {
	  return model.type + '||' + model.id;
	}
	
	exports.collect = collect;
	exports.fixValue = fixValue;
	exports.getAxisInfo = getAxisInfo;
	exports.getAxisPointerModel = getAxisPointerModel;
	exports.makeKey = makeKey;

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var graphic = __webpack_require__(16);
	
	var textContain = __webpack_require__(79);
	
	var formatUtil = __webpack_require__(40);
	
	var matrix = __webpack_require__(73);
	
	var axisHelper = __webpack_require__(93);
	
	var AxisBuilder = __webpack_require__(138);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {module:echarts/model/Model} axisPointerModel
	 */
	function buildElStyle(axisPointerModel) {
	  var axisPointerType = axisPointerModel.get('type');
	  var styleModel = axisPointerModel.getModel(axisPointerType + 'Style');
	  var style;
	
	  if (axisPointerType === 'line') {
	    style = styleModel.getLineStyle();
	    style.fill = null;
	  } else if (axisPointerType === 'shadow') {
	    style = styleModel.getAreaStyle();
	    style.stroke = null;
	  }
	
	  return style;
	}
	/**
	 * @param {Function} labelPos {align, verticalAlign, position}
	 */
	
	
	function buildLabelElOption(elOption, axisModel, axisPointerModel, api, labelPos) {
	  var value = axisPointerModel.get('value');
	  var text = getValueLabel(value, axisModel.axis, axisModel.ecModel, axisPointerModel.get('seriesDataIndices'), {
	    precision: axisPointerModel.get('label.precision'),
	    formatter: axisPointerModel.get('label.formatter')
	  });
	  var labelModel = axisPointerModel.getModel('label');
	  var paddings = formatUtil.normalizeCssArray(labelModel.get('padding') || 0);
	  var font = labelModel.getFont();
	  var textRect = textContain.getBoundingRect(text, font);
	  var position = labelPos.position;
	  var width = textRect.width + paddings[1] + paddings[3];
	  var height = textRect.height + paddings[0] + paddings[2]; // Adjust by align.
	
	  var align = labelPos.align;
	  align === 'right' && (position[0] -= width);
	  align === 'center' && (position[0] -= width / 2);
	  var verticalAlign = labelPos.verticalAlign;
	  verticalAlign === 'bottom' && (position[1] -= height);
	  verticalAlign === 'middle' && (position[1] -= height / 2); // Not overflow ec container
	
	  confineInContainer(position, width, height, api);
	  var bgColor = labelModel.get('backgroundColor');
	
	  if (!bgColor || bgColor === 'auto') {
	    bgColor = axisModel.get('axisLine.lineStyle.color');
	  }
	
	  elOption.label = {
	    shape: {
	      x: 0,
	      y: 0,
	      width: width,
	      height: height,
	      r: labelModel.get('borderRadius')
	    },
	    position: position.slice(),
	    // TODO: rich
	    style: {
	      text: text,
	      textFont: font,
	      textFill: labelModel.getTextColor(),
	      textPosition: 'inside',
	      textPadding: paddings,
	      fill: bgColor,
	      stroke: labelModel.get('borderColor') || 'transparent',
	      lineWidth: labelModel.get('borderWidth') || 0,
	      shadowBlur: labelModel.get('shadowBlur'),
	      shadowColor: labelModel.get('shadowColor'),
	      shadowOffsetX: labelModel.get('shadowOffsetX'),
	      shadowOffsetY: labelModel.get('shadowOffsetY')
	    },
	    // Lable should be over axisPointer.
	    z2: 10
	  };
	} // Do not overflow ec container
	
	
	function confineInContainer(position, width, height, api) {
	  var viewWidth = api.getWidth();
	  var viewHeight = api.getHeight();
	  position[0] = Math.min(position[0] + width, viewWidth) - width;
	  position[1] = Math.min(position[1] + height, viewHeight) - height;
	  position[0] = Math.max(position[0], 0);
	  position[1] = Math.max(position[1], 0);
	}
	/**
	 * @param {number} value
	 * @param {module:echarts/coord/Axis} axis
	 * @param {module:echarts/model/Global} ecModel
	 * @param {Object} opt
	 * @param {Array.<Object>} seriesDataIndices
	 * @param {number|string} opt.precision 'auto' or a number
	 * @param {string|Function} opt.formatter label formatter
	 */
	
	
	function getValueLabel(value, axis, ecModel, seriesDataIndices, opt) {
	  value = axis.scale.parse(value);
	  var text = axis.scale.getLabel( // If `precision` is set, width can be fixed (like '12.00500'), which
	  // helps to debounce when when moving label.
	  value, {
	    precision: opt.precision
	  });
	  var formatter = opt.formatter;
	
	  if (formatter) {
	    var params = {
	      value: axisHelper.getAxisRawValue(axis, value),
	      axisDimension: axis.dim,
	      axisIndex: axis.index,
	      seriesData: []
	    };
	    zrUtil.each(seriesDataIndices, function (idxItem) {
	      var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
	      var dataIndex = idxItem.dataIndexInside;
	      var dataParams = series && series.getDataParams(dataIndex);
	      dataParams && params.seriesData.push(dataParams);
	    });
	
	    if (zrUtil.isString(formatter)) {
	      text = formatter.replace('{value}', text);
	    } else if (zrUtil.isFunction(formatter)) {
	      text = formatter(params);
	    }
	  }
	
	  return text;
	}
	/**
	 * @param {module:echarts/coord/Axis} axis
	 * @param {number} value
	 * @param {Object} layoutInfo {
	 *  rotation, position, labelOffset, labelDirection, labelMargin
	 * }
	 */
	
	
	function getTransformedPosition(axis, value, layoutInfo) {
	  var transform = matrix.create();
	  matrix.rotate(transform, transform, layoutInfo.rotation);
	  matrix.translate(transform, transform, layoutInfo.position);
	  return graphic.applyTransform([axis.dataToCoord(value), (layoutInfo.labelOffset || 0) + (layoutInfo.labelDirection || 1) * (layoutInfo.labelMargin || 0)], transform);
	}
	
	function buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api) {
	  var textLayout = AxisBuilder.innerTextLayout(layoutInfo.rotation, 0, layoutInfo.labelDirection);
	  layoutInfo.labelMargin = axisPointerModel.get('label.margin');
	  buildLabelElOption(elOption, axisModel, axisPointerModel, api, {
	    position: getTransformedPosition(axisModel.axis, value, layoutInfo),
	    align: textLayout.textAlign,
	    verticalAlign: textLayout.textVerticalAlign
	  });
	}
	/**
	 * @param {Array.<number>} p1
	 * @param {Array.<number>} p2
	 * @param {number} [xDimIndex=0] or 1
	 */
	
	
	function makeLineShape(p1, p2, xDimIndex) {
	  xDimIndex = xDimIndex || 0;
	  return {
	    x1: p1[xDimIndex],
	    y1: p1[1 - xDimIndex],
	    x2: p2[xDimIndex],
	    y2: p2[1 - xDimIndex]
	  };
	}
	/**
	 * @param {Array.<number>} xy
	 * @param {Array.<number>} wh
	 * @param {number} [xDimIndex=0] or 1
	 */
	
	
	function makeRectShape(xy, wh, xDimIndex) {
	  xDimIndex = xDimIndex || 0;
	  return {
	    x: xy[xDimIndex],
	    y: xy[1 - xDimIndex],
	    width: wh[xDimIndex],
	    height: wh[1 - xDimIndex]
	  };
	}
	
	function makeSectorShape(cx, cy, r0, r, startAngle, endAngle) {
	  return {
	    cx: cx,
	    cy: cy,
	    r0: r0,
	    r: r,
	    startAngle: startAngle,
	    endAngle: endAngle,
	    clockwise: true
	  };
	}
	
	exports.buildElStyle = buildElStyle;
	exports.buildLabelElOption = buildLabelElOption;
	exports.getValueLabel = getValueLabel;
	exports.getTransformedPosition = getTransformedPosition;
	exports.buildCartesianSingleLabelElOption = buildCartesianSingleLabelElOption;
	exports.makeLineShape = makeLineShape;
	exports.makeRectShape = makeRectShape;
	exports.makeSectorShape = makeSectorShape;

/***/ },
/* 334 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var IRRELEVANT_EXCLUDES = {
	  'axisPointer': 1,
	  'tooltip': 1,
	  'brush': 1
	};
	/**
	 * Avoid that: mouse click on a elements that is over geo or graph,
	 * but roam is triggered.
	 */
	
	function onIrrelevantElement(e, api, targetCoordSysModel) {
	  var model = api.getComponentByElement(e.topTarget); // If model is axisModel, it works only if it is injected with coordinateSystem.
	
	  var coordSys = model && model.coordinateSystem;
	  return model && model !== targetCoordSysModel && !IRRELEVANT_EXCLUDES[model.mainType] && coordSys && coordSys.model !== targetCoordSysModel;
	}
	
	exports.onIrrelevantElement = onIrrelevantElement;

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var axisDefault = __webpack_require__(737);
	
	var ComponentModel = __webpack_require__(57);
	
	var _layout = __webpack_require__(36);
	
	var getLayoutParams = _layout.getLayoutParams;
	var mergeLayoutParam = _layout.mergeLayoutParam;
	
	var OrdinalMeta = __webpack_require__(745);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// FIXME axisType is fixed ?
	var AXIS_TYPES = ['value', 'category', 'time', 'log'];
	/**
	 * Generate sub axis model class
	 * @param {string} axisName 'x' 'y' 'radius' 'angle' 'parallel'
	 * @param {module:echarts/model/Component} BaseAxisModelClass
	 * @param {Function} axisTypeDefaulter
	 * @param {Object} [extraDefaultOption]
	 */
	
	function _default(axisName, BaseAxisModelClass, axisTypeDefaulter, extraDefaultOption) {
	  zrUtil.each(AXIS_TYPES, function (axisType) {
	    BaseAxisModelClass.extend({
	      /**
	       * @readOnly
	       */
	      type: axisName + 'Axis.' + axisType,
	      mergeDefaultAndTheme: function (option, ecModel) {
	        var layoutMode = this.layoutMode;
	        var inputPositionParams = layoutMode ? getLayoutParams(option) : {};
	        var themeModel = ecModel.getTheme();
	        zrUtil.merge(option, themeModel.get(axisType + 'Axis'));
	        zrUtil.merge(option, this.getDefaultOption());
	        option.type = axisTypeDefaulter(axisName, option);
	
	        if (layoutMode) {
	          mergeLayoutParam(option, inputPositionParams, layoutMode);
	        }
	      },
	
	      /**
	       * @override
	       */
	      optionUpdated: function () {
	        var thisOption = this.option;
	
	        if (thisOption.type === 'category') {
	          this.__ordinalMeta = OrdinalMeta.createByAxisModel(this);
	        }
	      },
	
	      /**
	       * Should not be called before all of 'getInitailData' finished.
	       * Because categories are collected during initializing data.
	       */
	      getCategories: function (rawData) {
	        var option = this.option; // FIXME
	        // warning if called before all of 'getInitailData' finished.
	
	        if (option.type === 'category') {
	          if (rawData) {
	            return option.data;
	          }
	
	          return this.__ordinalMeta.categories;
	        }
	      },
	      getOrdinalMeta: function () {
	        return this.__ordinalMeta;
	      },
	      defaultOption: zrUtil.mergeAll([{}, axisDefault[axisType + 'Axis'], extraDefaultOption], true)
	    });
	  });
	  ComponentModel.registerSubTypeDefaulter(axisName + 'Axis', zrUtil.curry(axisTypeDefaulter, axisName));
	}
	
	module.exports = _default;

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	var _util = __webpack_require__(3);
	
	var each = _util.each;
	var createHashMap = _util.createHashMap;
	
	var mapDataStorage = __webpack_require__(472);
	
	var geoJSONLoader = __webpack_require__(1666);
	
	var geoSVGLoader = __webpack_require__(1667);
	
	var BoundingRect = __webpack_require__(42);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var loaders = {
	  geoJSON: geoJSONLoader,
	  svg: geoSVGLoader
	};
	var _default = {
	  /**
	   * @param {string} mapName
	   * @param {Object} nameMap
	   * @param {string} nameProperty
	   * @return {Object} source {regions, regionsMap, nameCoordMap, boundingRect}
	   */
	  load: function (mapName, nameMap, nameProperty) {
	    var regions = [];
	    var regionsMap = createHashMap();
	    var nameCoordMap = createHashMap();
	    var boundingRect;
	    var mapRecords = retrieveMap(mapName);
	    each(mapRecords, function (record) {
	      var singleSource = loaders[record.type].load(mapName, record, nameProperty);
	      each(singleSource.regions, function (region) {
	        var regionName = region.name; // Try use the alias in geoNameMap
	
	        if (nameMap && nameMap.hasOwnProperty(regionName)) {
	          region = region.cloneShallow(regionName = nameMap[regionName]);
	        }
	
	        regions.push(region);
	        regionsMap.set(regionName, region);
	        nameCoordMap.set(regionName, region.center);
	      });
	      var rect = singleSource.boundingRect;
	
	      if (rect) {
	        boundingRect ? boundingRect.union(rect) : boundingRect = rect.clone();
	      }
	    });
	    return {
	      regions: regions,
	      regionsMap: regionsMap,
	      nameCoordMap: nameCoordMap,
	      // FIXME Always return new ?
	      boundingRect: boundingRect || new BoundingRect(0, 0, 0, 0)
	    };
	  },
	
	  /**
	   * @param {string} mapName
	   * @param {string} hostKey For cache.
	   * @return {Array.<module:zrender/Element>} Roots.
	   */
	  makeGraphic: makeInvoker('makeGraphic'),
	
	  /**
	   * @param {string} mapName
	   * @param {string} hostKey For cache.
	   */
	  removeGraphic: makeInvoker('removeGraphic')
	};
	
	function makeInvoker(methodName) {
	  return function (mapName, hostKey) {
	    var mapRecords = retrieveMap(mapName);
	    var results = [];
	    each(mapRecords, function (record) {
	      var method = loaders[record.type][methodName];
	      method && results.push(method(mapName, record, hostKey));
	    });
	    return results;
	  };
	}
	
	function mapNotExistsError(mapName) {}
	
	function retrieveMap(mapName) {
	  var mapRecords = mapDataStorage.retrieveMap(mapName) || [];
	  return mapRecords;
	}
	
	module.exports = _default;

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var _number = __webpack_require__(20);
	
	var parsePercent = _number.parsePercent;
	
	var _dataStackHelper = __webpack_require__(105);
	
	var isDimensionStacked = _dataStackHelper.isDimensionStacked;
	
	var createRenderPlanner = __webpack_require__(202);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Float32Array */
	var STACK_PREFIX = '__ec_stack_';
	var LARGE_BAR_MIN_WIDTH = 0.5;
	var LargeArr = typeof Float32Array !== 'undefined' ? Float32Array : Array;
	
	function getSeriesStackId(seriesModel) {
	  return seriesModel.get('stack') || STACK_PREFIX + seriesModel.seriesIndex;
	}
	
	function getAxisKey(axis) {
	  return axis.dim + axis.index;
	}
	/**
	 * @param {Object} opt
	 * @param {module:echarts/coord/Axis} opt.axis Only support category axis currently.
	 * @param {number} opt.count Positive interger.
	 * @param {number} [opt.barWidth]
	 * @param {number} [opt.barMaxWidth]
	 * @param {number} [opt.barMinWidth]
	 * @param {number} [opt.barGap]
	 * @param {number} [opt.barCategoryGap]
	 * @return {Object} {width, offset, offsetCenter} If axis.type is not 'category', return undefined.
	 */
	
	
	function getLayoutOnAxis(opt) {
	  var params = [];
	  var baseAxis = opt.axis;
	  var axisKey = 'axis0';
	
	  if (baseAxis.type !== 'category') {
	    return;
	  }
	
	  var bandWidth = baseAxis.getBandWidth();
	
	  for (var i = 0; i < opt.count || 0; i++) {
	    params.push(zrUtil.defaults({
	      bandWidth: bandWidth,
	      axisKey: axisKey,
	      stackId: STACK_PREFIX + i
	    }, opt));
	  }
	
	  var widthAndOffsets = doCalBarWidthAndOffset(params);
	  var result = [];
	
	  for (var i = 0; i < opt.count; i++) {
	    var item = widthAndOffsets[axisKey][STACK_PREFIX + i];
	    item.offsetCenter = item.offset + item.width / 2;
	    result.push(item);
	  }
	
	  return result;
	}
	
	function prepareLayoutBarSeries(seriesType, ecModel) {
	  var seriesModels = [];
	  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
	    // Check series coordinate, do layout for cartesian2d only
	    if (isOnCartesian(seriesModel) && !isInLargeMode(seriesModel)) {
	      seriesModels.push(seriesModel);
	    }
	  });
	  return seriesModels;
	}
	/**
	 * Map from (baseAxis.dim + '_' + baseAxis.index) to min gap of two adjacent
	 * values.
	 * This works for time axes, value axes, and log axes.
	 * For a single time axis, return value is in the form like
	 * {'x_0': [1000000]}.
	 * The value of 1000000 is in milliseconds.
	 */
	
	
	function getValueAxesMinGaps(barSeries) {
	  /**
	   * Map from axis.index to values.
	   * For a single time axis, axisValues is in the form like
	   * {'x_0': [1495555200000, 1495641600000, 1495728000000]}.
	   * Items in axisValues[x], e.g. 1495555200000, are time values of all
	   * series.
	   */
	  var axisValues = {};
	  zrUtil.each(barSeries, function (seriesModel) {
	    var cartesian = seriesModel.coordinateSystem;
	    var baseAxis = cartesian.getBaseAxis();
	
	    if (baseAxis.type !== 'time' && baseAxis.type !== 'value') {
	      return;
	    }
	
	    var data = seriesModel.getData();
	    var key = baseAxis.dim + '_' + baseAxis.index;
	    var dim = data.mapDimension(baseAxis.dim);
	
	    for (var i = 0, cnt = data.count(); i < cnt; ++i) {
	      var value = data.get(dim, i);
	
	      if (!axisValues[key]) {
	        // No previous data for the axis
	        axisValues[key] = [value];
	      } else {
	        // No value in previous series
	        axisValues[key].push(value);
	      } // Ignore duplicated time values in the same axis
	
	    }
	  });
	  var axisMinGaps = [];
	
	  for (var key in axisValues) {
	    if (axisValues.hasOwnProperty(key)) {
	      var valuesInAxis = axisValues[key];
	
	      if (valuesInAxis) {
	        // Sort axis values into ascending order to calculate gaps
	        valuesInAxis.sort(function (a, b) {
	          return a - b;
	        });
	        var min = null;
	
	        for (var j = 1; j < valuesInAxis.length; ++j) {
	          var delta = valuesInAxis[j] - valuesInAxis[j - 1];
	
	          if (delta > 0) {
	            // Ignore 0 delta because they are of the same axis value
	            min = min === null ? delta : Math.min(min, delta);
	          }
	        } // Set to null if only have one data
	
	
	        axisMinGaps[key] = min;
	      }
	    }
	  }
	
	  return axisMinGaps;
	}
	
	function makeColumnLayout(barSeries) {
	  var axisMinGaps = getValueAxesMinGaps(barSeries);
	  var seriesInfoList = [];
	  zrUtil.each(barSeries, function (seriesModel) {
	    var cartesian = seriesModel.coordinateSystem;
	    var baseAxis = cartesian.getBaseAxis();
	    var axisExtent = baseAxis.getExtent();
	    var bandWidth;
	
	    if (baseAxis.type === 'category') {
	      bandWidth = baseAxis.getBandWidth();
	    } else if (baseAxis.type === 'value' || baseAxis.type === 'time') {
	      var key = baseAxis.dim + '_' + baseAxis.index;
	      var minGap = axisMinGaps[key];
	      var extentSpan = Math.abs(axisExtent[1] - axisExtent[0]);
	      var scale = baseAxis.scale.getExtent();
	      var scaleSpan = Math.abs(scale[1] - scale[0]);
	      bandWidth = minGap ? extentSpan / scaleSpan * minGap : extentSpan; // When there is only one data value
	    } else {
	      var data = seriesModel.getData();
	      bandWidth = Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
	    }
	
	    var barWidth = parsePercent(seriesModel.get('barWidth'), bandWidth);
	    var barMaxWidth = parsePercent(seriesModel.get('barMaxWidth'), bandWidth);
	    var barMinWidth = parsePercent( // barMinWidth by default is 1 in cartesian. Because in value axis,
	    // the auto-calculated bar width might be less than 1.
	    seriesModel.get('barMinWidth') || 1, bandWidth);
	    var barGap = seriesModel.get('barGap');
	    var barCategoryGap = seriesModel.get('barCategoryGap');
	    seriesInfoList.push({
	      bandWidth: bandWidth,
	      barWidth: barWidth,
	      barMaxWidth: barMaxWidth,
	      barMinWidth: barMinWidth,
	      barGap: barGap,
	      barCategoryGap: barCategoryGap,
	      axisKey: getAxisKey(baseAxis),
	      stackId: getSeriesStackId(seriesModel)
	    });
	  });
	  return doCalBarWidthAndOffset(seriesInfoList);
	}
	
	function doCalBarWidthAndOffset(seriesInfoList) {
	  // Columns info on each category axis. Key is cartesian name
	  var columnsMap = {};
	  zrUtil.each(seriesInfoList, function (seriesInfo, idx) {
	    var axisKey = seriesInfo.axisKey;
	    var bandWidth = seriesInfo.bandWidth;
	    var columnsOnAxis = columnsMap[axisKey] || {
	      bandWidth: bandWidth,
	      remainedWidth: bandWidth,
	      autoWidthCount: 0,
	      categoryGap: '20%',
	      gap: '30%',
	      stacks: {}
	    };
	    var stacks = columnsOnAxis.stacks;
	    columnsMap[axisKey] = columnsOnAxis;
	    var stackId = seriesInfo.stackId;
	
	    if (!stacks[stackId]) {
	      columnsOnAxis.autoWidthCount++;
	    }
	
	    stacks[stackId] = stacks[stackId] || {
	      width: 0,
	      maxWidth: 0
	    }; // Caution: In a single coordinate system, these barGrid attributes
	    // will be shared by series. Consider that they have default values,
	    // only the attributes set on the last series will work.
	    // Do not change this fact unless there will be a break change.
	
	    var barWidth = seriesInfo.barWidth;
	
	    if (barWidth && !stacks[stackId].width) {
	      // See #6312, do not restrict width.
	      stacks[stackId].width = barWidth;
	      barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
	      columnsOnAxis.remainedWidth -= barWidth;
	    }
	
	    var barMaxWidth = seriesInfo.barMaxWidth;
	    barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
	    var barMinWidth = seriesInfo.barMinWidth;
	    barMinWidth && (stacks[stackId].minWidth = barMinWidth);
	    var barGap = seriesInfo.barGap;
	    barGap != null && (columnsOnAxis.gap = barGap);
	    var barCategoryGap = seriesInfo.barCategoryGap;
	    barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
	  });
	  var result = {};
	  zrUtil.each(columnsMap, function (columnsOnAxis, coordSysName) {
	    result[coordSysName] = {};
	    var stacks = columnsOnAxis.stacks;
	    var bandWidth = columnsOnAxis.bandWidth;
	    var categoryGap = parsePercent(columnsOnAxis.categoryGap, bandWidth);
	    var barGapPercent = parsePercent(columnsOnAxis.gap, 1);
	    var remainedWidth = columnsOnAxis.remainedWidth;
	    var autoWidthCount = columnsOnAxis.autoWidthCount;
	    var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
	    autoWidth = Math.max(autoWidth, 0); // Find if any auto calculated bar exceeded maxBarWidth
	
	    zrUtil.each(stacks, function (column) {
	      var maxWidth = column.maxWidth;
	      var minWidth = column.minWidth;
	
	      if (!column.width) {
	        var finalWidth = autoWidth;
	
	        if (maxWidth && maxWidth < finalWidth) {
	          finalWidth = Math.min(maxWidth, remainedWidth);
	        } // `minWidth` has higher priority. `minWidth` decide that wheter the
	        // bar is able to be visible. So `minWidth` should not be restricted
	        // by `maxWidth` or `remainedWidth` (which is from `bandWidth`). In
	        // the extreme cases for `value` axis, bars are allowed to overlap
	        // with each other if `minWidth` specified.
	
	
	        if (minWidth && minWidth > finalWidth) {
	          finalWidth = minWidth;
	        }
	
	        if (finalWidth !== autoWidth) {
	          column.width = finalWidth;
	          remainedWidth -= finalWidth + barGapPercent * finalWidth;
	          autoWidthCount--;
	        }
	      } else {
	        // `barMinWidth/barMaxWidth` has higher priority than `barWidth`, as
	        // CSS does. Becuase barWidth can be a percent value, where
	        // `barMaxWidth` can be used to restrict the final width.
	        var finalWidth = column.width;
	
	        if (maxWidth) {
	          finalWidth = Math.min(finalWidth, maxWidth);
	        } // `minWidth` has higher priority, as described above
	
	
	        if (minWidth) {
	          finalWidth = Math.max(finalWidth, minWidth);
	        }
	
	        column.width = finalWidth;
	        remainedWidth -= finalWidth + barGapPercent * finalWidth;
	        autoWidthCount--;
	      }
	    }); // Recalculate width again
	
	    autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
	    autoWidth = Math.max(autoWidth, 0);
	    var widthSum = 0;
	    var lastColumn;
	    zrUtil.each(stacks, function (column, idx) {
	      if (!column.width) {
	        column.width = autoWidth;
	      }
	
	      lastColumn = column;
	      widthSum += column.width * (1 + barGapPercent);
	    });
	
	    if (lastColumn) {
	      widthSum -= lastColumn.width * barGapPercent;
	    }
	
	    var offset = -widthSum / 2;
	    zrUtil.each(stacks, function (column, stackId) {
	      result[coordSysName][stackId] = result[coordSysName][stackId] || {
	        bandWidth: bandWidth,
	        offset: offset,
	        width: column.width
	      };
	      offset += column.width * (1 + barGapPercent);
	    });
	  });
	  return result;
	}
	/**
	 * @param {Object} barWidthAndOffset The result of makeColumnLayout
	 * @param {module:echarts/coord/Axis} axis
	 * @param {module:echarts/model/Series} [seriesModel] If not provided, return all.
	 * @return {Object} {stackId: {offset, width}} or {offset, width} if seriesModel provided.
	 */
	
	
	function retrieveColumnLayout(barWidthAndOffset, axis, seriesModel) {
	  if (barWidthAndOffset && axis) {
	    var result = barWidthAndOffset[getAxisKey(axis)];
	
	    if (result != null && seriesModel != null) {
	      result = result[getSeriesStackId(seriesModel)];
	    }
	
	    return result;
	  }
	}
	/**
	 * @param {string} seriesType
	 * @param {module:echarts/model/Global} ecModel
	 */
	
	
	function layout(seriesType, ecModel) {
	  var seriesModels = prepareLayoutBarSeries(seriesType, ecModel);
	  var barWidthAndOffset = makeColumnLayout(seriesModels);
	  var lastStackCoords = {};
	  var lastStackCoordsOrigin = {};
	  zrUtil.each(seriesModels, function (seriesModel) {
	    var data = seriesModel.getData();
	    var cartesian = seriesModel.coordinateSystem;
	    var baseAxis = cartesian.getBaseAxis();
	    var stackId = getSeriesStackId(seriesModel);
	    var columnLayoutInfo = barWidthAndOffset[getAxisKey(baseAxis)][stackId];
	    var columnOffset = columnLayoutInfo.offset;
	    var columnWidth = columnLayoutInfo.width;
	    var valueAxis = cartesian.getOtherAxis(baseAxis);
	    var barMinHeight = seriesModel.get('barMinHeight') || 0;
	    lastStackCoords[stackId] = lastStackCoords[stackId] || [];
	    lastStackCoordsOrigin[stackId] = lastStackCoordsOrigin[stackId] || []; // Fix #4243
	
	    data.setLayout({
	      bandWidth: columnLayoutInfo.bandWidth,
	      offset: columnOffset,
	      size: columnWidth
	    });
	    var valueDim = data.mapDimension(valueAxis.dim);
	    var baseDim = data.mapDimension(baseAxis.dim);
	    var stacked = isDimensionStacked(data, valueDim
	    /*, baseDim*/
	    );
	    var isValueAxisH = valueAxis.isHorizontal();
	    var valueAxisStart = getValueAxisStart(baseAxis, valueAxis, stacked);
	
	    for (var idx = 0, len = data.count(); idx < len; idx++) {
	      var value = data.get(valueDim, idx);
	      var baseValue = data.get(baseDim, idx);
	      var sign = value >= 0 ? 'p' : 'n';
	      var baseCoord = valueAxisStart; // Because of the barMinHeight, we can not use the value in
	      // stackResultDimension directly.
	
	      if (stacked) {
	        // Only ordinal axis can be stacked.
	        if (!lastStackCoords[stackId][baseValue]) {
	          lastStackCoords[stackId][baseValue] = {
	            p: valueAxisStart,
	            // Positive stack
	            n: valueAxisStart // Negative stack
	
	          };
	        } // Should also consider #4243
	
	
	        baseCoord = lastStackCoords[stackId][baseValue][sign];
	      }
	
	      var x;
	      var y;
	      var width;
	      var height;
	
	      if (isValueAxisH) {
	        var coord = cartesian.dataToPoint([value, baseValue]);
	        x = baseCoord;
	        y = coord[1] + columnOffset;
	        width = coord[0] - valueAxisStart;
	        height = columnWidth;
	
	        if (Math.abs(width) < barMinHeight) {
	          width = (width < 0 ? -1 : 1) * barMinHeight;
	        } // Ignore stack from NaN value
	
	
	        if (!isNaN(width)) {
	          stacked && (lastStackCoords[stackId][baseValue][sign] += width);
	        }
	      } else {
	        var coord = cartesian.dataToPoint([baseValue, value]);
	        x = coord[0] + columnOffset;
	        y = baseCoord;
	        width = columnWidth;
	        height = coord[1] - valueAxisStart;
	
	        if (Math.abs(height) < barMinHeight) {
	          // Include zero to has a positive bar
	          height = (height <= 0 ? -1 : 1) * barMinHeight;
	        } // Ignore stack from NaN value
	
	
	        if (!isNaN(height)) {
	          stacked && (lastStackCoords[stackId][baseValue][sign] += height);
	        }
	      }
	
	      data.setItemLayout(idx, {
	        x: x,
	        y: y,
	        width: width,
	        height: height
	      });
	    }
	  }, this);
	} // TODO: Do not support stack in large mode yet.
	
	
	var largeLayout = {
	  seriesType: 'bar',
	  plan: createRenderPlanner(),
	  reset: function (seriesModel) {
	    if (!isOnCartesian(seriesModel) || !isInLargeMode(seriesModel)) {
	      return;
	    }
	
	    var data = seriesModel.getData();
	    var cartesian = seriesModel.coordinateSystem;
	    var coordLayout = cartesian.grid.getRect();
	    var baseAxis = cartesian.getBaseAxis();
	    var valueAxis = cartesian.getOtherAxis(baseAxis);
	    var valueDim = data.mapDimension(valueAxis.dim);
	    var baseDim = data.mapDimension(baseAxis.dim);
	    var valueAxisHorizontal = valueAxis.isHorizontal();
	    var valueDimIdx = valueAxisHorizontal ? 0 : 1;
	    var barWidth = retrieveColumnLayout(makeColumnLayout([seriesModel]), baseAxis, seriesModel).width;
	
	    if (!(barWidth > LARGE_BAR_MIN_WIDTH)) {
	      // jshint ignore:line
	      barWidth = LARGE_BAR_MIN_WIDTH;
	    }
	
	    return {
	      progress: progress
	    };
	
	    function progress(params, data) {
	      var count = params.count;
	      var largePoints = new LargeArr(count * 2);
	      var largeBackgroundPoints = new LargeArr(count * 2);
	      var largeDataIndices = new LargeArr(count);
	      var dataIndex;
	      var coord = [];
	      var valuePair = [];
	      var pointsOffset = 0;
	      var idxOffset = 0;
	
	      while ((dataIndex = params.next()) != null) {
	        valuePair[valueDimIdx] = data.get(valueDim, dataIndex);
	        valuePair[1 - valueDimIdx] = data.get(baseDim, dataIndex);
	        coord = cartesian.dataToPoint(valuePair, null, coord); // Data index might not be in order, depends on `progressiveChunkMode`.
	
	        largeBackgroundPoints[pointsOffset] = valueAxisHorizontal ? coordLayout.x + coordLayout.width : coord[0];
	        largePoints[pointsOffset++] = coord[0];
	        largeBackgroundPoints[pointsOffset] = valueAxisHorizontal ? coord[1] : coordLayout.y + coordLayout.height;
	        largePoints[pointsOffset++] = coord[1];
	        largeDataIndices[idxOffset++] = dataIndex;
	      }
	
	      data.setLayout({
	        largePoints: largePoints,
	        largeDataIndices: largeDataIndices,
	        largeBackgroundPoints: largeBackgroundPoints,
	        barWidth: barWidth,
	        valueAxisStart: getValueAxisStart(baseAxis, valueAxis, false),
	        backgroundStart: valueAxisHorizontal ? coordLayout.x : coordLayout.y,
	        valueAxisHorizontal: valueAxisHorizontal
	      });
	    }
	  }
	};
	
	function isOnCartesian(seriesModel) {
	  return seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'cartesian2d';
	}
	
	function isInLargeMode(seriesModel) {
	  return seriesModel.pipelineContext && seriesModel.pipelineContext.large;
	} // See cases in `test/bar-start.html` and `#7412`, `#8747`.
	
	
	function getValueAxisStart(baseAxis, valueAxis, stacked) {
	  return valueAxis.toGlobalCoord(valueAxis.dataToCoord(valueAxis.type === 'log' ? 1 : 0));
	}
	
	exports.getLayoutOnAxis = getLayoutOnAxis;
	exports.prepareLayoutBarSeries = prepareLayoutBarSeries;
	exports.makeColumnLayout = makeColumnLayout;
	exports.retrieveColumnLayout = retrieveColumnLayout;
	exports.layout = layout;
	exports.largeLayout = largeLayout;

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var numberUtil = __webpack_require__(20);
	
	var formatUtil = __webpack_require__(40);
	
	var Scale = __webpack_require__(339);
	
	var helper = __webpack_require__(752);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Interval scale
	 * @module echarts/scale/Interval
	 */
	var roundNumber = numberUtil.round;
	/**
	 * @alias module:echarts/coord/scale/Interval
	 * @constructor
	 */
	
	var IntervalScale = Scale.extend({
	  type: 'interval',
	  _interval: 0,
	  _intervalPrecision: 2,
	  setExtent: function (start, end) {
	    var thisExtent = this._extent; //start,end may be a Number like '25',so...
	
	    if (!isNaN(start)) {
	      thisExtent[0] = parseFloat(start);
	    }
	
	    if (!isNaN(end)) {
	      thisExtent[1] = parseFloat(end);
	    }
	  },
	  unionExtent: function (other) {
	    var extent = this._extent;
	    other[0] < extent[0] && (extent[0] = other[0]);
	    other[1] > extent[1] && (extent[1] = other[1]); // unionExtent may called by it's sub classes
	
	    IntervalScale.prototype.setExtent.call(this, extent[0], extent[1]);
	  },
	
	  /**
	   * Get interval
	   */
	  getInterval: function () {
	    return this._interval;
	  },
	
	  /**
	   * Set interval
	   */
	  setInterval: function (interval) {
	    this._interval = interval; // Dropped auto calculated niceExtent and use user setted extent
	    // We assume user wan't to set both interval, min, max to get a better result
	
	    this._niceExtent = this._extent.slice();
	    this._intervalPrecision = helper.getIntervalPrecision(interval);
	  },
	
	  /**
	   * @param {boolean} [expandToNicedExtent=false] If expand the ticks to niced extent.
	   * @return {Array.<number>}
	   */
	  getTicks: function (expandToNicedExtent) {
	    var interval = this._interval;
	    var extent = this._extent;
	    var niceTickExtent = this._niceExtent;
	    var intervalPrecision = this._intervalPrecision;
	    var ticks = []; // If interval is 0, return [];
	
	    if (!interval) {
	      return ticks;
	    } // Consider this case: using dataZoom toolbox, zoom and zoom.
	
	
	    var safeLimit = 10000;
	
	    if (extent[0] < niceTickExtent[0]) {
	      if (expandToNicedExtent) {
	        ticks.push(roundNumber(niceTickExtent[0] - interval, intervalPrecision));
	      } else {
	        ticks.push(extent[0]);
	      }
	    }
	
	    var tick = niceTickExtent[0];
	
	    while (tick <= niceTickExtent[1]) {
	      ticks.push(tick); // Avoid rounding error
	
	      tick = roundNumber(tick + interval, intervalPrecision);
	
	      if (tick === ticks[ticks.length - 1]) {
	        // Consider out of safe float point, e.g.,
	        // -3711126.9907707 + 2e-10 === -3711126.9907707
	        break;
	      }
	
	      if (ticks.length > safeLimit) {
	        return [];
	      }
	    } // Consider this case: the last item of ticks is smaller
	    // than niceTickExtent[1] and niceTickExtent[1] === extent[1].
	
	
	    var lastNiceTick = ticks.length ? ticks[ticks.length - 1] : niceTickExtent[1];
	
	    if (extent[1] > lastNiceTick) {
	      if (expandToNicedExtent) {
	        ticks.push(roundNumber(lastNiceTick + interval, intervalPrecision));
	      } else {
	        ticks.push(extent[1]);
	      }
	    }
	
	    return ticks;
	  },
	
	  /**
	   * @param {number} [splitNumber=5]
	   * @return {Array.<Array.<number>>}
	   */
	  getMinorTicks: function (splitNumber) {
	    var ticks = this.getTicks(true);
	    var minorTicks = [];
	    var extent = this.getExtent();
	
	    for (var i = 1; i < ticks.length; i++) {
	      var nextTick = ticks[i];
	      var prevTick = ticks[i - 1];
	      var count = 0;
	      var minorTicksGroup = [];
	      var interval = nextTick - prevTick;
	      var minorInterval = interval / splitNumber;
	
	      while (count < splitNumber - 1) {
	        var minorTick = numberUtil.round(prevTick + (count + 1) * minorInterval); // For the first and last interval. The count may be less than splitNumber.
	
	        if (minorTick > extent[0] && minorTick < extent[1]) {
	          minorTicksGroup.push(minorTick);
	        }
	
	        count++;
	      }
	
	      minorTicks.push(minorTicksGroup);
	    }
	
	    return minorTicks;
	  },
	
	  /**
	   * @param {number} data
	   * @param {Object} [opt]
	   * @param {number|string} [opt.precision] If 'auto', use nice presision.
	   * @param {boolean} [opt.pad] returns 1.50 but not 1.5 if precision is 2.
	   * @return {string}
	   */
	  getLabel: function (data, opt) {
	    if (data == null) {
	      return '';
	    }
	
	    var precision = opt && opt.precision;
	
	    if (precision == null) {
	      precision = numberUtil.getPrecisionSafe(data) || 0;
	    } else if (precision === 'auto') {
	      // Should be more precise then tick.
	      precision = this._intervalPrecision;
	    } // (1) If `precision` is set, 12.005 should be display as '12.00500'.
	    // (2) Use roundNumber (toFixed) to avoid scientific notation like '3.5e-7'.
	
	
	    data = roundNumber(data, precision, true);
	    return formatUtil.addCommas(data);
	  },
	
	  /**
	   * Update interval and extent of intervals for nice ticks
	   *
	   * @param {number} [splitNumber = 5] Desired number of ticks
	   * @param {number} [minInterval]
	   * @param {number} [maxInterval]
	   */
	  niceTicks: function (splitNumber, minInterval, maxInterval) {
	    splitNumber = splitNumber || 5;
	    var extent = this._extent;
	    var span = extent[1] - extent[0];
	
	    if (!isFinite(span)) {
	      return;
	    } // User may set axis min 0 and data are all negative
	    // FIXME If it needs to reverse ?
	
	
	    if (span < 0) {
	      span = -span;
	      extent.reverse();
	    }
	
	    var result = helper.intervalScaleNiceTicks(extent, splitNumber, minInterval, maxInterval);
	    this._intervalPrecision = result.intervalPrecision;
	    this._interval = result.interval;
	    this._niceExtent = result.niceTickExtent;
	  },
	
	  /**
	   * Nice extent.
	   * @param {Object} opt
	   * @param {number} [opt.splitNumber = 5] Given approx tick number
	   * @param {boolean} [opt.fixMin=false]
	   * @param {boolean} [opt.fixMax=false]
	   * @param {boolean} [opt.minInterval]
	   * @param {boolean} [opt.maxInterval]
	   */
	  niceExtent: function (opt) {
	    var extent = this._extent; // If extent start and end are same, expand them
	
	    if (extent[0] === extent[1]) {
	      if (extent[0] !== 0) {
	        // Expand extent
	        var expandSize = extent[0]; // In the fowllowing case
	        //      Axis has been fixed max 100
	        //      Plus data are all 100 and axis extent are [100, 100].
	        // Extend to the both side will cause expanded max is larger than fixed max.
	        // So only expand to the smaller side.
	
	        if (!opt.fixMax) {
	          extent[1] += expandSize / 2;
	          extent[0] -= expandSize / 2;
	        } else {
	          extent[0] -= expandSize / 2;
	        }
	      } else {
	        extent[1] = 1;
	      }
	    }
	
	    var span = extent[1] - extent[0]; // If there are no data and extent are [Infinity, -Infinity]
	
	    if (!isFinite(span)) {
	      extent[0] = 0;
	      extent[1] = 1;
	    }
	
	    this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval); // var extent = this._extent;
	
	    var interval = this._interval;
	
	    if (!opt.fixMin) {
	      extent[0] = roundNumber(Math.floor(extent[0] / interval) * interval);
	    }
	
	    if (!opt.fixMax) {
	      extent[1] = roundNumber(Math.ceil(extent[1] / interval) * interval);
	    }
	  }
	});
	/**
	 * @return {module:echarts/scale/Time}
	 */
	
	IntervalScale.create = function () {
	  return new IntervalScale();
	};
	
	var _default = IntervalScale;
	module.exports = _default;

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var clazzUtil = __webpack_require__(124);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * // Scale class management
	 * @module echarts/scale/Scale
	 */
	
	/**
	 * @param {Object} [setting]
	 */
	function Scale(setting) {
	  this._setting = setting || {};
	  /**
	   * Extent
	   * @type {Array.<number>}
	   * @protected
	   */
	
	  this._extent = [Infinity, -Infinity];
	  /**
	   * Step is calculated in adjustExtent
	   * @type {Array.<number>}
	   * @protected
	   */
	
	  this._interval = 0;
	  this.init && this.init.apply(this, arguments);
	}
	/**
	 * Parse input val to valid inner number.
	 * @param {*} val
	 * @return {number}
	 */
	
	
	Scale.prototype.parse = function (val) {
	  // Notice: This would be a trap here, If the implementation
	  // of this method depends on extent, and this method is used
	  // before extent set (like in dataZoom), it would be wrong.
	  // Nevertheless, parse does not depend on extent generally.
	  return val;
	};
	
	Scale.prototype.getSetting = function (name) {
	  return this._setting[name];
	};
	
	Scale.prototype.contain = function (val) {
	  var extent = this._extent;
	  return val >= extent[0] && val <= extent[1];
	};
	/**
	 * Normalize value to linear [0, 1], return 0.5 if extent span is 0
	 * @param {number} val
	 * @return {number}
	 */
	
	
	Scale.prototype.normalize = function (val) {
	  var extent = this._extent;
	
	  if (extent[1] === extent[0]) {
	    return 0.5;
	  }
	
	  return (val - extent[0]) / (extent[1] - extent[0]);
	};
	/**
	 * Scale normalized value
	 * @param {number} val
	 * @return {number}
	 */
	
	
	Scale.prototype.scale = function (val) {
	  var extent = this._extent;
	  return val * (extent[1] - extent[0]) + extent[0];
	};
	/**
	 * Set extent from data
	 * @param {Array.<number>} other
	 */
	
	
	Scale.prototype.unionExtent = function (other) {
	  var extent = this._extent;
	  other[0] < extent[0] && (extent[0] = other[0]);
	  other[1] > extent[1] && (extent[1] = other[1]); // not setExtent because in log axis it may transformed to power
	  // this.setExtent(extent[0], extent[1]);
	};
	/**
	 * Set extent from data
	 * @param {module:echarts/data/List} data
	 * @param {string} dim
	 */
	
	
	Scale.prototype.unionExtentFromData = function (data, dim) {
	  this.unionExtent(data.getApproximateExtent(dim));
	};
	/**
	 * Get extent
	 * @return {Array.<number>}
	 */
	
	
	Scale.prototype.getExtent = function () {
	  return this._extent.slice();
	};
	/**
	 * Set extent
	 * @param {number} start
	 * @param {number} end
	 */
	
	
	Scale.prototype.setExtent = function (start, end) {
	  var thisExtent = this._extent;
	
	  if (!isNaN(start)) {
	    thisExtent[0] = start;
	  }
	
	  if (!isNaN(end)) {
	    thisExtent[1] = end;
	  }
	};
	/**
	 * When axis extent depends on data and no data exists,
	 * axis ticks should not be drawn, which is named 'blank'.
	 */
	
	
	Scale.prototype.isBlank = function () {
	  return this._isBlank;
	},
	/**
	 * When axis extent depends on data and no data exists,
	 * axis ticks should not be drawn, which is named 'blank'.
	 */
	Scale.prototype.setBlank = function (isBlank) {
	  this._isBlank = isBlank;
	};
	/**
	 * @abstract
	 * @param {*} tick
	 * @return {string} label of the tick.
	 */
	
	Scale.prototype.getLabel = null;
	clazzUtil.enableClassExtend(Scale);
	clazzUtil.enableClassManagement(Scale, {
	  registerWhenExtend: true
	});
	var _default = Scale;
	module.exports = _default;

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Group = __webpack_require__(187);
	
	var componentUtil = __webpack_require__(268);
	
	var clazzUtil = __webpack_require__(124);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var Component = function () {
	  /**
	   * @type {module:zrender/container/Group}
	   * @readOnly
	   */
	  this.group = new Group();
	  /**
	   * @type {string}
	   * @readOnly
	   */
	
	  this.uid = componentUtil.getUID('viewComponent');
	};
	
	Component.prototype = {
	  constructor: Component,
	  init: function (ecModel, api) {},
	  render: function (componentModel, ecModel, api, payload) {},
	  dispose: function () {},
	
	  /**
	   * @param {string} eventType
	   * @param {Object} query
	   * @param {module:zrender/Element} targetEl
	   * @param {Object} packedEvent
	   * @return {boolen} Pass only when return `true`.
	   */
	  filterForExposedEvent: null
	};
	var componentProto = Component.prototype;
	
	componentProto.updateView = componentProto.updateLayout = componentProto.updateVisual = function (seriesModel, ecModel, api, payload) {// Do nothing;
	}; // Enable Component.extend.
	
	
	clazzUtil.enableClassExtend(Component); // Enable capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.
	
	clazzUtil.enableClassManagement(Component, {
	  registerWhenExtend: true
	});
	var _default = Component;
	module.exports = _default;

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(3);
	
	var createHashMap = _util.createHashMap;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Pick color from palette for each data item.
	// Applicable for charts that require applying color palette
	// in data level (like pie, funnel, chord).
	function _default(seriesType) {
	  return {
	    getTargetSeries: function (ecModel) {
	      // Pie and funnel may use diferrent scope
	      var paletteScope = {};
	      var seiresModelMap = createHashMap();
	      ecModel.eachSeriesByType(seriesType, function (seriesModel) {
	        seriesModel.__paletteScope = paletteScope;
	        seiresModelMap.set(seriesModel.uid, seriesModel);
	      });
	      return seiresModelMap;
	    },
	    reset: function (seriesModel, ecModel) {
	      var dataAll = seriesModel.getRawData();
	      var idxMap = {};
	      var data = seriesModel.getData();
	      data.each(function (idx) {
	        var rawIdx = data.getRawIndex(idx);
	        idxMap[rawIdx] = idx;
	      });
	      dataAll.each(function (rawIdx) {
	        var filteredIdx = idxMap[rawIdx]; // If series.itemStyle.normal.color is a function. itemVisual may be encoded
	
	        var singleDataColor = filteredIdx != null && data.getItemVisual(filteredIdx, 'color', true);
	        var singleDataBorderColor = filteredIdx != null && data.getItemVisual(filteredIdx, 'borderColor', true);
	        var itemModel;
	
	        if (!singleDataColor || !singleDataBorderColor) {
	          // FIXME Performance
	          itemModel = dataAll.getItemModel(rawIdx);
	        }
	
	        if (!singleDataColor) {
	          var color = itemModel.get('itemStyle.color') || seriesModel.getColorFromPalette(dataAll.getName(rawIdx) || rawIdx + '', seriesModel.__paletteScope, dataAll.count()); // Data is not filtered
	
	          if (filteredIdx != null) {
	            data.setItemVisual(filteredIdx, 'color', color);
	          }
	        }
	
	        if (!singleDataBorderColor) {
	          var borderColor = itemModel.get('itemStyle.borderColor'); // Data is not filtered
	
	          if (filteredIdx != null) {
	            data.setItemVisual(filteredIdx, 'borderColor', borderColor);
	          }
	        }
	      });
	    }
	  };
	}
	
	module.exports = _default;

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var VisualMapping = __webpack_require__(168);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @file Visual solution, for consistent option specification.
	 */
	var each = zrUtil.each;
	
	function hasKeys(obj) {
	  if (obj) {
	    for (var name in obj) {
	      if (obj.hasOwnProperty(name)) {
	        return true;
	      }
	    }
	  }
	}
	/**
	 * @param {Object} option
	 * @param {Array.<string>} stateList
	 * @param {Function} [supplementVisualOption]
	 * @return {Object} visualMappings <state, <visualType, module:echarts/visual/VisualMapping>>
	 */
	
	
	function createVisualMappings(option, stateList, supplementVisualOption) {
	  var visualMappings = {};
	  each(stateList, function (state) {
	    var mappings = visualMappings[state] = createMappings();
	    each(option[state], function (visualData, visualType) {
	      if (!VisualMapping.isValidType(visualType)) {
	        return;
	      }
	
	      var mappingOption = {
	        type: visualType,
	        visual: visualData
	      };
	      supplementVisualOption && supplementVisualOption(mappingOption, state);
	      mappings[visualType] = new VisualMapping(mappingOption); // Prepare a alpha for opacity, for some case that opacity
	      // is not supported, such as rendering using gradient color.
	
	      if (visualType === 'opacity') {
	        mappingOption = zrUtil.clone(mappingOption);
	        mappingOption.type = 'colorAlpha';
	        mappings.__hidden.__alphaForOpacity = new VisualMapping(mappingOption);
	      }
	    });
	  });
	  return visualMappings;
	
	  function createMappings() {
	    var Creater = function () {}; // Make sure hidden fields will not be visited by
	    // object iteration (with hasOwnProperty checking).
	
	
	    Creater.prototype.__hidden = Creater.prototype;
	    var obj = new Creater();
	    return obj;
	  }
	}
	/**
	 * @param {Object} thisOption
	 * @param {Object} newOption
	 * @param {Array.<string>} keys
	 */
	
	
	function replaceVisualOption(thisOption, newOption, keys) {
	  // Visual attributes merge is not supported, otherwise it
	  // brings overcomplicated merge logic. See #2853. So if
	  // newOption has anyone of these keys, all of these keys
	  // will be reset. Otherwise, all keys remain.
	  var has;
	  zrUtil.each(keys, function (key) {
	    if (newOption.hasOwnProperty(key) && hasKeys(newOption[key])) {
	      has = true;
	    }
	  });
	  has && zrUtil.each(keys, function (key) {
	    if (newOption.hasOwnProperty(key) && hasKeys(newOption[key])) {
	      thisOption[key] = zrUtil.clone(newOption[key]);
	    } else {
	      delete thisOption[key];
	    }
	  });
	}
	/**
	 * @param {Array.<string>} stateList
	 * @param {Object} visualMappings <state, Object.<visualType, module:echarts/visual/VisualMapping>>
	 * @param {module:echarts/data/List} list
	 * @param {Function} getValueState param: valueOrIndex, return: state.
	 * @param {object} [scope] Scope for getValueState
	 * @param {string} [dimension] Concrete dimension, if used.
	 */
	// ???! handle brush?
	
	
	function applyVisual(stateList, visualMappings, data, getValueState, scope, dimension) {
	  var visualTypesMap = {};
	  zrUtil.each(stateList, function (state) {
	    var visualTypes = VisualMapping.prepareVisualTypes(visualMappings[state]);
	    visualTypesMap[state] = visualTypes;
	  });
	  var dataIndex;
	
	  function getVisual(key) {
	    return data.getItemVisual(dataIndex, key);
	  }
	
	  function setVisual(key, value) {
	    data.setItemVisual(dataIndex, key, value);
	  }
	
	  if (dimension == null) {
	    data.each(eachItem);
	  } else {
	    data.each([dimension], eachItem);
	  }
	
	  function eachItem(valueOrIndex, index) {
	    dataIndex = dimension == null ? valueOrIndex : index;
	    var rawDataItem = data.getRawDataItem(dataIndex); // Consider performance
	
	    if (rawDataItem && rawDataItem.visualMap === false) {
	      return;
	    }
	
	    var valueState = getValueState.call(scope, valueOrIndex);
	    var mappings = visualMappings[valueState];
	    var visualTypes = visualTypesMap[valueState];
	
	    for (var i = 0, len = visualTypes.length; i < len; i++) {
	      var type = visualTypes[i];
	      mappings[type] && mappings[type].applyVisual(valueOrIndex, getVisual, setVisual);
	    }
	  }
	}
	/**
	 * @param {module:echarts/data/List} data
	 * @param {Array.<string>} stateList
	 * @param {Object} visualMappings <state, Object.<visualType, module:echarts/visual/VisualMapping>>
	 * @param {Function} getValueState param: valueOrIndex, return: state.
	 * @param {number} [dim] dimension or dimension index.
	 */
	
	
	function incrementalApplyVisual(stateList, visualMappings, getValueState, dim) {
	  var visualTypesMap = {};
	  zrUtil.each(stateList, function (state) {
	    var visualTypes = VisualMapping.prepareVisualTypes(visualMappings[state]);
	    visualTypesMap[state] = visualTypes;
	  });
	
	  function progress(params, data) {
	    if (dim != null) {
	      dim = data.getDimension(dim);
	    }
	
	    function getVisual(key) {
	      return data.getItemVisual(dataIndex, key);
	    }
	
	    function setVisual(key, value) {
	      data.setItemVisual(dataIndex, key, value);
	    }
	
	    var dataIndex;
	
	    while ((dataIndex = params.next()) != null) {
	      var rawDataItem = data.getRawDataItem(dataIndex); // Consider performance
	
	      if (rawDataItem && rawDataItem.visualMap === false) {
	        continue;
	      }
	
	      var value = dim != null ? data.get(dim, dataIndex, true) : dataIndex;
	      var valueState = getValueState(value);
	      var mappings = visualMappings[valueState];
	      var visualTypes = visualTypesMap[valueState];
	
	      for (var i = 0, len = visualTypes.length; i < len; i++) {
	        var type = visualTypes[i];
	        mappings[type] && mappings[type].applyVisual(value, getVisual, setVisual);
	      }
	    }
	  }
	
	  return {
	    progress: progress
	  };
	}
	
	exports.createVisualMappings = createVisualMappings;
	exports.replaceVisualOption = replaceVisualOption;
	exports.applyVisual = applyVisual;
	exports.incrementalApplyVisual = incrementalApplyVisual;

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var origSymbol = global.Symbol;
	var hasSymbolSham = __webpack_require__(1747);
	
	module.exports = function hasNativeSymbols() {
		if (typeof origSymbol !== 'function') { return false; }
		if (typeof Symbol !== 'function') { return false; }
		if (typeof origSymbol('foo') !== 'symbol') { return false; }
		if (typeof Symbol('bar') !== 'symbol') { return false; }
	
		return hasSymbolSham();
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 344 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	exports.canUseDOM = canUseDOM;

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(108);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _queryString = __webpack_require__(1929);
	
	var _runTransitionHook = __webpack_require__(482);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(171);
	
	var _deprecate = __webpack_require__(481);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var SEARCH_BASE_KEY = '$searchBase';
	
	function defaultStringifyQuery(query) {
	  return _queryString.stringify(query).replace(/%20/g, '+');
	}
	
	var defaultParseQueryString = _queryString.parse;
	
	function isNestedObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
	  }return false;
	}
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var stringifyQuery = options.stringifyQuery;
	    var parseQueryString = options.parseQueryString;
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    function addQuery(location) {
	      if (location.query == null) {
	        var search = location.search;
	
	        location.query = parseQueryString(search.substring(1));
	        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
	      }
	
	      // TODO: Instead of all the book-keeping here, this should just strip the
	      // stringified query from the search.
	
	      return location;
	    }
	
	    function appendQuery(location, query) {
	      var _extends2;
	
	      var searchBaseSpec = location[SEARCH_BASE_KEY];
	      var queryString = query ? stringifyQuery(query) : '';
	      if (!searchBaseSpec && !queryString) {
	        return location;
	      }
	
	       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var searchBase = undefined;
	      if (searchBaseSpec && location.search === searchBaseSpec.search) {
	        searchBase = searchBaseSpec.searchBase;
	      } else {
	        searchBase = location.search || '';
	      }
	
	      var search = searchBase;
	      if (queryString) {
	        search += (search ? '&' : '?') + queryString;
	      }
	
	      return _extends({}, location, (_extends2 = {
	        search: search
	      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
	    }
	
	    // Override all read methods with query-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addQuery(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addQuery(location));
	      });
	    }
	
	    // Override all write methods with query-aware versions.
	    function push(location) {
	      history.push(appendQuery(location, location.query));
	    }
	
	    function replace(location) {
	      history.replace(appendQuery(location, location.query));
	    }
	
	    function createPath(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createPath is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createPath(appendQuery(location, query || location.query));
	    }
	
	    function createHref(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createHref is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createHref(appendQuery(location, query || location.query));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var fullLocation = history.createLocation.apply(history, [appendQuery(location, location.query)].concat(args));
	      if (location.query) {
	        fullLocation.query = location.query;
	      }
	      return addQuery(fullLocation);
	    }
	
	    // deprecated
	    function pushState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path, { query: query }));
	    }
	
	    // deprecated
	    function replaceState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path, { query: query }));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useQueries;
	module.exports = exports['default'];

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(1844),
	    listCacheDelete = __webpack_require__(1845),
	    listCacheGet = __webpack_require__(1846),
	    listCacheHas = __webpack_require__(1847),
	    listCacheSet = __webpack_require__(1848);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(484),
	    setCacheAdd = __webpack_require__(1862),
	    setCacheHas = __webpack_require__(1863);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 348 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(357);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(491),
	    toKey = __webpack_require__(272);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 351 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 352 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	var arrayAggregator = __webpack_require__(1781),
	    baseAggregator = __webpack_require__(1790),
	    baseIteratee = __webpack_require__(85),
	    isArray = __webpack_require__(35);
	
	/**
	 * Creates a function like `_.groupBy`.
	 *
	 * @private
	 * @param {Function} setter The function to set accumulator values.
	 * @param {Function} [initializer] The accumulator object initializer.
	 * @returns {Function} Returns the new aggregator function.
	 */
	function createAggregator(setter, initializer) {
	  return function(collection, iteratee) {
	    var func = isArray(collection) ? arrayAggregator : baseAggregator,
	        accumulator = initializer ? initializer() : {};
	
	    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
	  };
	}
	
	module.exports = createAggregator;


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(1842);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(176);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	var baseRandom = __webpack_require__(786);
	
	/**
	 * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	 *
	 * @private
	 * @param {Array} array The array to shuffle.
	 * @param {number} [size=array.length] The size of `array`.
	 * @returns {Array} Returns `array`.
	 */
	function shuffleSelf(array, size) {
	  var index = -1,
	      length = array.length,
	      lastIndex = length - 1;
	
	  size = size === undefined ? length : size;
	  while (++index < size) {
	    var rand = baseRandom(index, lastIndex),
	        value = array[rand];
	
	    array[rand] = array[index];
	    array[index] = value;
	  }
	  array.length = size;
	  return array;
	}
	
	module.exports = shuffleSelf;


/***/ },
/* 357 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(173),
	    baseIteratee = __webpack_require__(85),
	    baseMap = __webpack_require__(783),
	    isArray = __webpack_require__(35);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(1819),
	    keys = __webpack_require__(211);
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object == null ? [] : baseValues(object, keys(object));
	}
	
	module.exports = values;


/***/ },
/* 360 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(32);
	
	var EventPluginRegistry = __webpack_require__(499);
	var ReactEventEmitterMixin = __webpack_require__(1960);
	var ViewportMetrics = __webpack_require__(967);
	
	var getVendorPrefixedEventName = __webpack_require__(1992);
	var isEventSupported = __webpack_require__(510);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(280);
	var ViewportMetrics = __webpack_require__(967);
	
	var getEventModifierState = __webpack_require__(508);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var invariant = __webpack_require__(28);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 364 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(74);
	var DOMNamespaces = __webpack_require__(498);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(506);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(60);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deprecateObjectProperties = __webpack_require__(367);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _getRouteParams = __webpack_require__(2009);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _RouteUtils = __webpack_require__(147);
	
	var _routerWarning = __webpack_require__(64);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var array = _React$PropTypes.array;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	
	var RouterContext = _react2.default.createClass({
	  displayName: 'RouterContext',
	
	
	  propTypes: {
	    history: object,
	    router: object.isRequired,
	    location: object.isRequired,
	    routes: array.isRequired,
	    params: object.isRequired,
	    components: array.isRequired,
	    createElement: func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    history: object,
	    location: object.isRequired,
	    router: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    var _props = this.props;
	    var router = _props.router;
	    var history = _props.history;
	    var location = _props.location;
	
	    if (!router) {
	       false ? (0, _routerWarning2.default)(false, '`<RouterContext>` expects a `router` rather than a `history`') : void 0;
	
	      router = _extends({}, history, {
	        setRouteLeaveHook: history.listenBeforeLeavingRoute
	      });
	      delete router.listenBeforeLeavingRoute;
	    }
	
	    if (false) {
	      location = (0, _deprecateObjectProperties2.default)(location, '`context.location` is deprecated, please use a route component\'s `props.location` instead. http://tiny.cc/router-accessinglocation');
	    }
	
	    return { history: history, location: location, router: router };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props2 = this.props;
	    var history = _props2.history;
	    var location = _props2.location;
	    var routes = _props2.routes;
	    var params = _props2.params;
	    var components = _props2.components;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          history: history,
	          location: location,
	          params: params,
	          route: route,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.canUseMembrane = undefined;
	
	var _routerWarning = __webpack_require__(64);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseMembrane = exports.canUseMembrane = false;
	
	// No-op by default.
	var deprecateObjectProperties = function deprecateObjectProperties(object) {
	  return object;
	};
	
	if (false) {
	  try {
	    if (Object.defineProperty({}, 'x', {
	      get: function get() {
	        return true;
	      }
	    }).x) {
	      exports.canUseMembrane = canUseMembrane = true;
	    }
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	  if (canUseMembrane) {
	    deprecateObjectProperties = function deprecateObjectProperties(object, message) {
	      // Wrap the deprecated object in a membrane to warn on property access.
	      var membrane = {};
	
	      var _loop = function _loop(prop) {
	        if (!Object.prototype.hasOwnProperty.call(object, prop)) {
	          return 'continue';
	        }
	
	        if (typeof object[prop] === 'function') {
	          // Can't use fat arrow here because of use of arguments below.
	          membrane[prop] = function () {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop].apply(object, arguments);
	          };
	          return 'continue';
	        }
	
	        // These properties are non-enumerable to prevent React dev tools from
	        // seeing them and causing spurious warnings when accessing them. In
	        // principle this could be done with a proxy, but support for the
	        // ownKeys trap on proxies is not universal, even among browsers that
	        // otherwise support proxies.
	        Object.defineProperty(membrane, prop, {
	          get: function get() {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop];
	          }
	        });
	      };
	
	      for (var prop in object) {
	        var _ret = _loop(prop);
	
	        if (_ret === 'continue') continue;
	      }
	
	      return membrane;
	    };
	  }
	}
	
	exports.default = deprecateObjectProperties;

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = checkDecoratorArguments;
	function checkDecoratorArguments(functionName, signature) {
		if (false) {
			for (var i = 0; i < (arguments.length <= 2 ? 0 : arguments.length - 2); i += 1) {
				var arg = arguments.length <= i + 2 ? undefined : arguments[i + 2];
				if (arg && arg.prototype && arg.prototype.render) {
					// eslint-disable-next-line no-console
					console.error('You seem to be applying the arguments in the wrong order. ' + ('It should be ' + functionName + '(' + signature + ')(Component), not the other way around. ') + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#you-seem-to-be-applying-the-arguments-in-the-wrong-order');
					return;
				}
			}
		}
	}

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(2), __webpack_require__(4));
		else if(typeof define === 'function' && define.amd)
			define(["react", "prop-types"], factory);
		else {
			var a = typeof exports === 'object' ? factory(require("react"), require("prop-types")) : factory(root["react"], root["prop-types"]);
			for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__12__, __WEBPACK_EXTERNAL_MODULE__13__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 10);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = warn;
	
	function warn(s) {
	  console.warn('[react-ga]', s);
	}
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = trim;
	
	// GA strings need to have leading/trailing whitespace trimmed, and not all
	// browsers have String.prototoype.trim().
	function trim(s) {
	  return s.replace(/^\s+|\s+$/g, '');
	}
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialize = initialize;
	exports.ga = ga;
	exports.set = set;
	exports.send = send;
	exports.pageview = pageview;
	exports.modalview = modalview;
	exports.timing = timing;
	exports.event = event;
	exports.exception = exception;
	exports.outboundLink = outboundLink;
	exports["default"] = exports.testModeAPI = exports.plugin = void 0;
	
	var _format2 = _interopRequireDefault(__webpack_require__(3));
	
	var _removeLeadingSlash = _interopRequireDefault(__webpack_require__(6));
	
	var _trim = _interopRequireDefault(__webpack_require__(1));
	
	var _loadGA = _interopRequireDefault(__webpack_require__(7));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	var _log = _interopRequireDefault(__webpack_require__(8));
	
	var _testModeAPI = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var _isNotBrowser = typeof window === 'undefined' || typeof document === 'undefined';
	
	var _debug = false;
	var _titleCase = true;
	var _testMode = false;
	var _alwaysSendToDefaultTracker = true;
	
	var internalGa = function internalGa() {
	  var _window;
	
	  if (_testMode) return _testModeAPI["default"].ga.apply(_testModeAPI["default"], arguments);
	  if (_isNotBrowser) return false;
	  if (!window.ga) return (0, _warn["default"])('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
	  return (_window = window).ga.apply(_window, arguments);
	};
	
	function _format(s) {
	  return (0, _format2["default"])(s, _titleCase);
	}
	
	function _gaCommand(trackerNames) {
	  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  var command = args[0];
	
	  if (typeof internalGa === 'function') {
	    if (typeof command !== 'string') {
	      (0, _warn["default"])('ga command must be a string');
	      return;
	    }
	
	    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(void 0, args);
	
	    if (Array.isArray(trackerNames)) {
	      trackerNames.forEach(function (name) {
	        internalGa.apply(void 0, _toConsumableArray(["".concat(name, ".").concat(command)].concat(args.slice(1))));
	      });
	    }
	  }
	}
	
	function _initialize(gaTrackingID, options) {
	  if (!gaTrackingID) {
	    (0, _warn["default"])('gaTrackingID is required in initialize()');
	    return;
	  }
	
	  if (options) {
	    if (options.debug && options.debug === true) {
	      _debug = true;
	    }
	
	    if (options.titleCase === false) {
	      _titleCase = false;
	    }
	
	    if (options.useExistingGa) {
	      return;
	    }
	  }
	
	  if (options && options.gaOptions) {
	    internalGa('create', gaTrackingID, options.gaOptions);
	  } else {
	    internalGa('create', gaTrackingID, 'auto');
	  }
	}
	
	function initialize(configsOrTrackingId, options) {
	  if (options && options.testMode === true) {
	    _testMode = true;
	  } else {
	    if (_isNotBrowser) {
	      return false;
	    }
	
	    if (!options || options.standardImplementation !== true) (0, _loadGA["default"])(options);
	  }
	
	  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;
	
	  if (Array.isArray(configsOrTrackingId)) {
	    configsOrTrackingId.forEach(function (config) {
	      if (_typeof(config) !== 'object') {
	        (0, _warn["default"])('All configs must be an object');
	        return;
	      }
	
	      _initialize(config.trackingId, config);
	    });
	  } else {
	    _initialize(configsOrTrackingId, options);
	  }
	
	  return true;
	}
	/**
	 * ga:
	 * Returns the original GA object.
	 */
	
	
	function ga() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  if (args.length > 0) {
	    internalGa.apply(void 0, args);
	
	    if (_debug) {
	      (0, _log["default"])('called ga(\'arguments\');');
	      (0, _log["default"])("with arguments: ".concat(JSON.stringify(args)));
	    }
	  }
	
	  return window.ga;
	}
	/**
	 * set:
	 * GA tracker set method
	 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function set(fieldsObject, trackerNames) {
	  if (!fieldsObject) {
	    (0, _warn["default"])('`fieldsObject` is required in .set()');
	    return;
	  }
	
	  if (_typeof(fieldsObject) !== 'object') {
	    (0, _warn["default"])('Expected `fieldsObject` arg to be an Object');
	    return;
	  }
	
	  if (Object.keys(fieldsObject).length === 0) {
	    (0, _warn["default"])('empty `fieldsObject` given to .set()');
	  }
	
	  _gaCommand(trackerNames, 'set', fieldsObject);
	
	  if (_debug) {
	    (0, _log["default"])('called ga(\'set\', fieldsObject);');
	    (0, _log["default"])("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
	  }
	}
	/**
	 * send:
	 * Clone of the low level `ga.send` method
	 * WARNING: No validations will be applied to this
	 * @param  {Object} fieldObject - field object for tracking different analytics
	 * @param  {Array} trackerNames - trackers to send the command to
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function send(fieldObject, trackerNames) {
	  _gaCommand(trackerNames, 'send', fieldObject);
	
	  if (_debug) {
	    (0, _log["default"])('called ga(\'send\', fieldObject);');
	    (0, _log["default"])("with fieldObject: ".concat(JSON.stringify(fieldObject)));
	    (0, _log["default"])("with trackers: ".concat(JSON.stringify(trackerNames)));
	  }
	}
	/**
	 * pageview:
	 * Basic GA pageview tracking
	 * @param  {String} path - the current page page e.g. '/about'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 * @param {String} title - (optional) the page title e. g. 'My Website'
	 */
	
	
	function pageview(rawPath, trackerNames, title) {
	  if (!rawPath) {
	    (0, _warn["default"])('path is required in .pageview()');
	    return;
	  }
	
	  var path = (0, _trim["default"])(rawPath);
	
	  if (path === '') {
	    (0, _warn["default"])('path cannot be an empty string in .pageview()');
	    return;
	  }
	
	  var extraFields = {};
	
	  if (title) {
	    extraFields.title = title;
	  }
	
	  if (typeof ga === 'function') {
	    _gaCommand(trackerNames, 'send', _objectSpread({
	      hitType: 'pageview',
	      page: path
	    }, extraFields));
	
	    if (_debug) {
	      (0, _log["default"])('called ga(\'send\', \'pageview\', path);');
	      var extraLog = '';
	
	      if (title) {
	        extraLog = " and title: ".concat(title);
	      }
	
	      (0, _log["default"])("with path: ".concat(path).concat(extraLog));
	    }
	  }
	}
	/**
	 * modalview:
	 * a proxy to basic GA pageview tracking to consistently track
	 * modal views that are an equivalent UX to a traditional pageview
	 * @param  {String} modalName e.g. 'add-or-edit-club'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function modalview(rawModalName, trackerNames) {
	  if (!rawModalName) {
	    (0, _warn["default"])('modalName is required in .modalview(modalName)');
	    return;
	  }
	
	  var modalName = (0, _removeLeadingSlash["default"])((0, _trim["default"])(rawModalName));
	
	  if (modalName === '') {
	    (0, _warn["default"])('modalName cannot be an empty string or a single / in .modalview()');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    var path = "/modal/".concat(modalName);
	
	    _gaCommand(trackerNames, 'send', 'pageview', path);
	
	    if (_debug) {
	      (0, _log["default"])('called ga(\'send\', \'pageview\', path);');
	      (0, _log["default"])("with path: ".concat(path));
	    }
	  }
	}
	/**
	 * timing:
	 * GA timing
	 * @param args.category {String} required
	 * @param args.variable {String} required
	 * @param args.value  {Int}  required
	 * @param args.label  {String} required
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function timing() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      category = _ref.category,
	      variable = _ref.variable,
	      value = _ref.value,
	      label = _ref.label;
	
	  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;
	
	  if (typeof ga === 'function') {
	    if (!category || !variable || !value || typeof value !== 'number') {
	      (0, _warn["default"])('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'timing',
	      timingCategory: _format(category),
	      timingVar: _format(variable),
	      timingValue: value
	    };
	
	    if (label) {
	      fieldObject.timingLabel = _format(label);
	    }
	
	    send(fieldObject, trackerNames);
	  }
	}
	/**
	 * event:
	 * GA event tracking
	 * @param args.category {String} required
	 * @param args.action {String} required
	 * @param args.label {String} optional
	 * @param args.value {Int} optional
	 * @param args.nonInteraction {boolean} optional
	 * @param args.transport {string} optional
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function event() {
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      category = _ref2.category,
	      action = _ref2.action,
	      label = _ref2.label,
	      value = _ref2.value,
	      nonInteraction = _ref2.nonInteraction,
	      transport = _ref2.transport,
	      args = _objectWithoutProperties(_ref2, ["category", "action", "label", "value", "nonInteraction", "transport"]);
	
	  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!category || !action) {
	      (0, _warn["default"])('args.category AND args.action are required in event()');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: _format(category),
	      eventAction: _format(action)
	    }; // Optional Fields
	
	    if (label) {
	      fieldObject.eventLabel = _format(label);
	    }
	
	    if (typeof value !== 'undefined') {
	      if (typeof value !== 'number') {
	        (0, _warn["default"])('Expected `args.value` arg to be a Number.');
	      } else {
	        fieldObject.eventValue = value;
	      }
	    }
	
	    if (typeof nonInteraction !== 'undefined') {
	      if (typeof nonInteraction !== 'boolean') {
	        (0, _warn["default"])('`args.nonInteraction` must be a boolean.');
	      } else {
	        fieldObject.nonInteraction = nonInteraction;
	      }
	    }
	
	    if (typeof transport !== 'undefined') {
	      if (typeof transport !== 'string') {
	        (0, _warn["default"])('`args.transport` must be a string.');
	      } else {
	        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
	          (0, _warn["default"])('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
	        }
	
	        fieldObject.transport = transport;
	      }
	    }
	
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'dimension'.length) === 'dimension';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    });
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'metric'.length) === 'metric';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    }); // Send to GA
	
	    send(fieldObject, trackerNames);
	  }
	}
	/**
	 * exception:
	 * GA exception tracking
	 * @param args.description {String} optional
	 * @param args.fatal {boolean} optional
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function exception(_ref3, trackerNames) {
	  var description = _ref3.description,
	      fatal = _ref3.fatal;
	
	  if (typeof ga === 'function') {
	    // Required Fields
	    var fieldObject = {
	      hitType: 'exception'
	    }; // Optional Fields
	
	    if (description) {
	      fieldObject.exDescription = _format(description);
	    }
	
	    if (typeof fatal !== 'undefined') {
	      if (typeof fatal !== 'boolean') {
	        (0, _warn["default"])('`args.fatal` must be a boolean.');
	      } else {
	        fieldObject.exFatal = fatal;
	      }
	    } // Send to GA
	
	
	    send(fieldObject, trackerNames);
	  }
	}
	
	var plugin = {
	  /**
	   * require:
	   * GA requires a plugin
	   * @param name {String} e.g. 'ecommerce' or 'myplugin'
	   * @param options {Object} optional e.g {path: '/log', debug: true}
	   * @param trackerName {String} optional e.g 'trackerName'
	   */
	  require: function require(rawName, options, trackerName) {
	    if (typeof ga === 'function') {
	      // Required Fields
	      if (!rawName) {
	        (0, _warn["default"])('`name` is required in .require()');
	        return;
	      }
	
	      var name = (0, _trim["default"])(rawName);
	
	      if (name === '') {
	        (0, _warn["default"])('`name` cannot be an empty string in .require()');
	        return;
	      }
	
	      var requireString = trackerName ? "".concat(trackerName, ".require") : 'require'; // Optional Fields
	
	      if (options) {
	        if (_typeof(options) !== 'object') {
	          (0, _warn["default"])('Expected `options` arg to be an Object');
	          return;
	        }
	
	        if (Object.keys(options).length === 0) {
	          (0, _warn["default"])('Empty `options` given to .require()');
	        }
	
	        ga(requireString, name, options);
	
	        if (_debug) {
	          (0, _log["default"])("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
	        }
	      } else {
	        ga(requireString, name);
	
	        if (_debug) {
	          (0, _log["default"])("called ga('require', '".concat(name, "');"));
	        }
	      }
	    }
	  },
	
	  /**
	   * execute:
	   * GA execute action for plugin
	   * Takes variable number of arguments
	   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
	   * @param action {String} e.g. 'addItem' or 'myCustomAction'
	   * @param actionType {String} optional e.g. 'detail'
	   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
	   */
	  execute: function execute(pluginName, action) {
	    var payload;
	    var actionType;
	
	    if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
	      payload = arguments.length <= 2 ? undefined : arguments[2];
	    } else {
	      actionType = arguments.length <= 2 ? undefined : arguments[2];
	      payload = arguments.length <= 3 ? undefined : arguments[3];
	    }
	
	    if (typeof ga === 'function') {
	      if (typeof pluginName !== 'string') {
	        (0, _warn["default"])('Expected `pluginName` arg to be a String.');
	      } else if (typeof action !== 'string') {
	        (0, _warn["default"])('Expected `action` arg to be a String.');
	      } else {
	        var command = "".concat(pluginName, ":").concat(action);
	        payload = payload || null;
	
	        if (actionType && payload) {
	          ga(command, actionType, payload);
	
	          if (_debug) {
	            (0, _log["default"])("called ga('".concat(command, "');"));
	            (0, _log["default"])("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
	          }
	        } else if (payload) {
	          ga(command, payload);
	
	          if (_debug) {
	            (0, _log["default"])("called ga('".concat(command, "');"));
	            (0, _log["default"])("with payload: ".concat(JSON.stringify(payload)));
	          }
	        } else {
	          ga(command);
	
	          if (_debug) {
	            (0, _log["default"])("called ga('".concat(command, "');"));
	          }
	        }
	      }
	    }
	  }
	};
	/**
	 * outboundLink:
	 * GA outboundLink tracking
	 * @param args.label {String} e.g. url, or 'Create an Account'
	 * @param {function} hitCallback - Called after processing a hit.
	 */
	
	exports.plugin = plugin;
	
	function outboundLink(args, hitCallback, trackerNames) {
	  if (typeof hitCallback !== 'function') {
	    (0, _warn["default"])('hitCallback function is required');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!args || !args.label) {
	      (0, _warn["default"])('args.label is required in outboundLink()');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: 'Outbound',
	      eventAction: 'Click',
	      eventLabel: _format(args.label)
	    };
	    var safetyCallbackCalled = false;
	
	    var safetyCallback = function safetyCallback() {
	      // This prevents a delayed response from GA
	      // causing hitCallback from being fired twice
	      safetyCallbackCalled = true;
	      hitCallback();
	    }; // Using a timeout to ensure the execution of critical application code
	    // in the case when the GA server might be down
	    // or an ad blocker prevents sending the data
	    // register safety net timeout:
	
	
	    var t = setTimeout(safetyCallback, 250);
	
	    var clearableCallbackForGA = function clearableCallbackForGA() {
	      clearTimeout(t);
	
	      if (!safetyCallbackCalled) {
	        hitCallback();
	      }
	    };
	
	    fieldObject.hitCallback = clearableCallbackForGA; // Send to GA
	
	    send(fieldObject, trackerNames);
	  } else {
	    // if ga is not defined, return the callback so the application
	    // continues to work as expected
	    setTimeout(hitCallback, 0);
	  }
	}
	
	var testModeAPI = _testModeAPI["default"];
	exports.testModeAPI = testModeAPI;
	var _default = {
	  initialize: initialize,
	  ga: ga,
	  set: set,
	  send: send,
	  pageview: pageview,
	  modalview: modalview,
	  timing: timing,
	  event: event,
	  exception: exception,
	  plugin: plugin,
	  outboundLink: outboundLink,
	  testModeAPI: _testModeAPI["default"]
	};
	exports["default"] = _default;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = format;
	
	var _mightBeEmail = _interopRequireDefault(__webpack_require__(4));
	
	var _toTitleCase = _interopRequireDefault(__webpack_require__(5));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var redacted = 'REDACTED (Potential Email Address)';
	
	function format(s, titleCase) {
	  if ((0, _mightBeEmail["default"])(s)) {
	    (0, _warn["default"])('This arg looks like an email address, redacting.');
	    return redacted;
	  }
	
	  if (titleCase) {
	    return (0, _toTitleCase["default"])(s);
	  }
	
	  return s;
	}
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = mightBeEmail;
	
	// See if s could be an email address. We don't want to send personal data like email.
	// https://support.google.com/analytics/answer/2795983?hl=en
	function mightBeEmail(s) {
	  // There's no point trying to validate rfc822 fully, just look for ...@...
	  return typeof s === 'string' && s.indexOf('@') !== -1;
	}
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = toTitleCase;
	
	var _trim = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * To Title Case 2.1 - http://individed.com/code/to-title-case/
	 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
	 * https://github.com/gouch/to-title-case
	 */
	var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
	
	function toTitleCase(string) {
	  return (0, _trim["default"])(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
	    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
	      return match.toLowerCase();
	    }
	
	    if (match.substr(1).search(/[A-Z]|\../) > -1) {
	      return match;
	    }
	
	    return match.charAt(0).toUpperCase() + match.substr(1);
	  });
	}
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = removeLeadingSlash;
	
	function removeLeadingSlash(string) {
	  if (string.substring(0, 1) === '/') {
	    return string.substring(1);
	  }
	
	  return string;
	}
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = _default;
	
	function _default(options) {
	  var gaAddress = 'https://www.google-analytics.com/analytics.js';
	
	  if (options && options.gaAddress) {
	    gaAddress = options.gaAddress;
	  } else if (options && options.debug) {
	    gaAddress = 'https://www.google-analytics.com/analytics_debug.js';
	  } // https://developers.google.com/analytics/devguides/collection/analyticsjs/
	
	  /* eslint-disable */
	
	
	  (function (i, s, o, g, r, a, m) {
	    i['GoogleAnalyticsObject'] = r;
	    i[r] = i[r] || function () {
	      (i[r].q = i[r].q || []).push(arguments);
	    }, i[r].l = 1 * new Date();
	    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
	    a.async = 1;
	    a.src = g;
	    m.parentNode.insertBefore(a, m);
	  })(window, document, 'script', gaAddress, 'ga');
	  /* eslint-enable */
	
	}
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = log;
	
	function log(s) {
	  console.info('[react-ga]', s);
	}
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.gaCalls = void 0;
	var gaCalls = [];
	exports.gaCalls = gaCalls;
	var _default = {
	  calls: gaCalls,
	  ga: function ga() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    gaCalls.push([].concat(args));
	  },
	  resetCalls: function resetCalls() {
	    gaCalls.length = 0;
	  }
	};
	exports["default"] = _default;
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.OutboundLink = exports.testModeAPI = exports.outboundLink = exports.plugin = exports.exception = exports.event = exports.timing = exports.modalview = exports.pageview = exports.send = exports.set = exports.ga = exports.initialize = void 0;
	
	var _OutboundLink = _interopRequireDefault(__webpack_require__(11));
	
	var Defaults = _interopRequireWildcard(__webpack_require__(2));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialize = Defaults.initialize;
	exports.initialize = initialize;
	var ga = Defaults.ga;
	exports.ga = ga;
	var set = Defaults.set;
	exports.set = set;
	var send = Defaults.send;
	exports.send = send;
	var pageview = Defaults.pageview;
	exports.pageview = pageview;
	var modalview = Defaults.modalview;
	exports.modalview = modalview;
	var timing = Defaults.timing;
	exports.timing = timing;
	var event = Defaults.event;
	exports.event = event;
	var exception = Defaults.exception;
	exports.exception = exception;
	var plugin = Defaults.plugin;
	exports.plugin = plugin;
	var outboundLink = Defaults.outboundLink;
	exports.outboundLink = outboundLink;
	var testModeAPI = Defaults.testModeAPI;
	exports.testModeAPI = testModeAPI;
	_OutboundLink["default"].origTrackLink = _OutboundLink["default"].trackLink;
	_OutboundLink["default"].trackLink = Defaults.outboundLink;
	var OutboundLink = _OutboundLink["default"];
	exports.OutboundLink = OutboundLink;
	
	var _default = _objectSpread({}, Defaults, {
	  OutboundLink: OutboundLink
	});
	
	exports["default"] = _default;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(12));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var NEWTAB = '_blank';
	var MIDDLECLICK = 1;
	
	var OutboundLink =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(OutboundLink, _Component);
	
	  function OutboundLink() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, OutboundLink);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(OutboundLink)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
	      var _this$props = _this.props,
	          target = _this$props.target,
	          eventLabel = _this$props.eventLabel,
	          to = _this$props.to,
	          onClick = _this$props.onClick,
	          trackerNames = _this$props.trackerNames;
	      var eventMeta = {
	        label: eventLabel
	      };
	      var sameTarget = target !== NEWTAB;
	      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);
	
	      if (sameTarget && normalClick) {
	        event.preventDefault();
	        OutboundLink.trackLink(eventMeta, function () {
	          window.location.href = to;
	        }, trackerNames);
	      } else {
	        OutboundLink.trackLink(eventMeta, function () {}, trackerNames);
	      }
	
	      if (onClick) {
	        onClick(event);
	      }
	    });
	
	    return _this;
	  }
	
	  _createClass(OutboundLink, [{
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          href = _this$props2.to,
	          oldProps = _objectWithoutProperties(_this$props2, ["to"]);
	
	      var props = _objectSpread({}, oldProps, {
	        href: href,
	        onClick: this.handleClick
	      });
	
	      if (this.props.target === NEWTAB) {
	        props.rel = 'noopener noreferrer';
	      }
	
	      delete props.eventLabel;
	      delete props.trackerNames;
	      return _react["default"].createElement('a', props);
	    }
	  }]);
	
	  return OutboundLink;
	}(_react.Component);
	
	exports["default"] = OutboundLink;
	
	_defineProperty(OutboundLink, "trackLink", function () {
	  (0, _warn["default"])('ga tracking not enabled');
	});
	
	_defineProperty(OutboundLink, "propTypes", {
	  eventLabel: _propTypes["default"].string.isRequired,
	  target: _propTypes["default"].string,
	  to: _propTypes["default"].string,
	  onClick: _propTypes["default"].func,
	  trackerNames: _propTypes["default"].arrayOf(_propTypes["default"].string)
	});
	
	_defineProperty(OutboundLink, "defaultProps", {
	  target: null,
	  to: null,
	  onClick: null,
	  trackerNames: null
	});
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE__12__;
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE__13__;
	
	/***/ })
	/******/ ]);
	});

/***/ },
/* 370 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	var PUSH = exports.PUSH = 'PUSH';
	
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = exports.REPLACE = 'REPLACE';
	
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = exports.POP = 'POP';

/***/ },
/* 371 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _MapStyles = __webpack_require__(546);
	
	var _MapStyles2 = _interopRequireDefault(_MapStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DtoLayer = function DtoLayer(obj, type) {
		var color = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _MapStyles2.default.FILL_RED;
		var visibility = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
		_classCallCheck(this, DtoLayer);
	
		this.id = obj.id;
		this.name = obj.name;
		this.code = obj.code;
		this.type = type;
		this.url = obj.url;
		this.opacity = 1;
		this.visibility = obj.visibility || obj.visibility === false ? obj.visibility : visibility;
		this.color = color;
		this.extractStyles = obj.extractStyles ? obj.extractStyles : false;
		this.zoom = obj.zoom;
		this.updateDate = obj.updateDate;
	};
	
	exports.default = DtoLayer;

/***/ },
/* 373 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
	    _classCallCheck(this, _class);
	
	    this.id = obj.id;
	    this.left = obj.left;
	    this.top = obj.top;
	    this.content = obj.content;
	};
	
	exports.default = _class;

/***/ },
/* 374 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  BOX: 'box',
	  DUSTBIN_BOX: 'dustbinBox'
	};

/***/ },
/* 375 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DtoDashboardSite = function DtoDashboardSite(obj) {
		_classCallCheck(this, DtoDashboardSite);
	
		this.id = obj.idstation;
		this.code = obj.code;
		this.name = obj.name;
		this.city = obj.cityid;
		this.longitude = obj.longitude;
		this.latitude = obj.latitude;
	};
	
	exports.default = DtoDashboardSite;

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _isomorphicFetch = __webpack_require__(78);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _ActionUtils = __webpack_require__(112);
	
	var _ApplicationConf = __webpack_require__(65);
	
	var _ApplicationConf2 = _interopRequireDefault(_ApplicationConf);
	
	var _CreditConstants = __webpack_require__(1031);
	
	var _HomeAction = __webpack_require__(52);
	
	var _HomeAction2 = _interopRequireDefault(_HomeAction);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _lodash = __webpack_require__(15);
	
	var _ToastrAction = __webpack_require__(66);
	
	var _ToastrAction2 = _interopRequireDefault(_ToastrAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CreditAction = {
		fetchUserInitCredit: function fetchUserInitCredit(login) {
			return function (dispatch) {
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.credit.initCredit(), {
					method: 'GET',
					headers: { authorization: btoa('Basic ' + login) }
				}).then(function () {
					dispatch(CreditAction.fetchUserCredit(login));
				}).catch(function (err) {
					dispatch(_HomeAction2.default.errorOnFetch('fetchUser' + err));
				});
			};
		},
		receiveUserCredit: function receiveUserCredit(userCredit) {
			return {
				type: _CreditConstants.RECEIVE_USER_CREDIT,
				userCredit: userCredit
			};
		},
		fetchUserCredit: function fetchUserCredit(login) {
			return function (dispatch) {
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.credit.userCredit(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({ login: login })
				}).then(_ActionUtils.checkAuth).then(_ActionUtils.getJson).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(CreditAction.receiveUserCredit(json));
					return json;
				}).then(function (jsonUserCredit) {
					dispatch(CreditAction.fetchUserCreditHistory(jsonUserCredit[0].id));
				}).catch(function (err) {
					dispatch(_HomeAction2.default.errorOnFetch('fetchUser' + err));
				});
			};
		},
		receiveUserCreditHistory: function receiveUserCreditHistory(userCreditHistory) {
			return {
				type: _CreditConstants.RECEIVE_USER_CREDIT_HISTORY,
				userCreditHistory: userCreditHistory
			};
		},
		fetchUserCreditHistory: function fetchUserCreditHistory(idUserCredit) {
			return function (dispatch) {
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.credit.userCreditHystory(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({ usercreditid: idUserCredit })
				}).then(_ActionUtils.checkAuth).then(_ActionUtils.getJson).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(CreditAction.receiveUserCreditHistory(json));
				}).catch(function (err) {
					dispatch(_HomeAction2.default.errorOnFetch('fetchUser' + err));
				});
			};
		},
		receiveCreditTypes: function receiveCreditTypes(creditTypes) {
			return {
				type: _CreditConstants.RECEIVE_ALL_CREDIT_TYPE,
				creditTypes: creditTypes
			};
		},
		fetchCreditTypes: function fetchCreditTypes() {
			return function (dispatch) {
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.credit.creditType(), {
					method: 'GET'
				}).then(_ActionUtils.getJson).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(CreditAction.receiveCreditTypes(json));
				}).catch(function (err) {
					dispatch(_HomeAction2.default.errorOnFetch('fetchUser' + err));
				});
			};
		},
		fetchCreditRequest: function fetchCreditRequest(login, creditNumber) {
			return function (dispatch) {
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.credit.creditRequest(), {
					method: 'POST',
					headers: { authorization: btoa('Basic ' + login) },
					body: JSON.stringify({ credit: creditNumber })
				}).then(_ActionUtils.checkAuth).then(function () {
					dispatch(CreditAction.receiveUserCreditHistory([]));
					dispatch(CreditAction.fetchUserCredit(login));
					dispatch(_ToastrAction2.default.success((0, _lodash.template)(_simpleReactI18n2.default.information.successRequestingCredits)({ content: creditNumber })));
				}).catch(function () {
					dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.error.errorRequestingCredits));
				});
			};
		},
		reset: function reset() {
			return { type: _CreditConstants.RESET_CREDITS_INFORMATION };
		}
	};
	
	exports.default = CreditAction;

/***/ },
/* 377 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
		ERROR: 'ERROR',
		WARNING: 'WARNING',
		SUCCESS: 'SUCCESS',
		INFO: 'INFO',
		RESET_MODAL: 'RESET_MODAL'
	};

/***/ },
/* 378 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DtoUserRole = function DtoUserRole(obj) {
		_classCallCheck(this, DtoUserRole);
	
		this.login = obj.login;
		this.roleId = obj.roleId;
	};
	
	exports.default = DtoUserRole;

/***/ },
/* 379 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.code = obj.code;
		this.beginDate = obj.creationdate;
		this.endDate = obj.closedate;
		this.updateDate = obj.updatedate;
		this.xCoordinate = obj.xcoordinate;
		this.yCoordinate = obj.ycoordinate;
		this.comment = obj.comment;
		this.status = obj.status;
		this.supportCode = obj.supportcode;
		this.methodId = obj.methodid;
		this.natureId = obj.natureid;
	};
	
	exports.default = _class;

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _ReferentialConstants = __webpack_require__(1039);
	
	var _ApplicationConf = __webpack_require__(65);
	
	var _ApplicationConf2 = _interopRequireDefault(_ApplicationConf);
	
	var _ActionUtils = __webpack_require__(112);
	
	var _reactAquasys = __webpack_require__(49);
	
	var _ApplicationUtils = __webpack_require__(186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReferentialAction = {
		receiveUnits: function receiveUnits(units) {
			return {
				type: _ReferentialConstants.RECEIVE_ALL_UNITS,
				units: units
			};
		},
		fetchUnits: function fetchUnits() {
			return ReferentialAction.fetchGetReferencial(_ApplicationConf2.default.referencial.getUnits(), ReferentialAction.receiveUnits);
		},
		receiveRemarks: function receiveRemarks(remarks) {
			return {
				type: _ReferentialConstants.RECEIVE_ALL_REMARKS,
				remarks: remarks
			};
		},
	
		fetchRemarks: function fetchRemarks() {
			return ReferentialAction.fetchGetReferencial(_ApplicationConf2.default.referencial.getRemarks(), ReferentialAction.receiveRemarks);
		},
		receiveSupports: function receiveSupports(supports) {
			return {
				type: _ReferentialConstants.RECEIVE_ALL_SUPPORTS,
				supports: supports
			};
		},
		fetchSupports: function fetchSupports() {
			return ReferentialAction.fetchGetReferencial(_ApplicationConf2.default.referencial.getSupports(), ReferentialAction.receiveSupports);
		},
		receiveStandardCodifications: function receiveStandardCodifications(standardCodifications) {
			return {
				type: _ReferentialConstants.RECEIVE_ALL_STANDARD_CODIFICATION,
				standardCodifications: standardCodifications
			};
		},
	
		fetchStandardCodifications: function fetchStandardCodifications() {
			return ReferentialAction.fetchGetReferencial(_ApplicationConf2.default.referencial.getStandardCodification(), ReferentialAction.receiveStandardCodifications);
		},
		receiveParameters: function receiveParameters(parameters) {
			return {
				type: _ReferentialConstants.RECEIVE_ALL_PARAMETERS,
				parameters: parameters
			};
		},
		fetchParameters: function fetchParameters() {
			return ReferentialAction.fetchGetReferencial(_ApplicationConf2.default.referencial.getParameters(), ReferentialAction.receiveParameters);
		},
		receiveCities: function receiveCities(cities) {
			return {
				type: _ReferentialConstants.RECEIVE_ALL_CITIES,
				cities: cities
			};
		},
		fetchCities: function fetchCities() {
			return ReferentialAction.fetchPostReferencial(_ApplicationConf2.default.referencial.getCities(), ReferentialAction.receiveCities);
		},
		receiveDepartments: function receiveDepartments(departments) {
			return {
				type: _ReferentialConstants.RECEIVE_ALL_DEPARTMENTS,
				departments: departments
			};
		},
		fetchDepartments: function fetchDepartments() {
			return ReferentialAction.fetchPostReferencial(_ApplicationConf2.default.referencial.getDepartments(), ReferentialAction.receiveDepartments);
		},
		receiveFilterTypes: function receiveFilterTypes(filterTypes) {
			return {
				type: _ReferentialConstants.RECEIVE_ALL_FILTER_TYPES,
				filterTypes: filterTypes
			};
		},
		fetchFilterTypes: function fetchFilterTypes() {
			return ReferentialAction.fetchGetReferencial(_ApplicationConf2.default.referencial.getFilterTypes(), ReferentialAction.receiveFilterTypes);
		},
		receiveSiteTypes: function receiveSiteTypes(siteTypes) {
			return {
				type: _ReferentialConstants.RECEIVE_ALL_SITE_TYPES,
				siteTypes: siteTypes
			};
		},
		fetchSiteTypes: function fetchSiteTypes() {
			return ReferentialAction.fetchGetReferencial(_ApplicationConf2.default.referencial.getSiteTypes(), ReferentialAction.receiveSiteTypes);
		},
		receiveWatersheds: function receiveWatersheds(watersheds) {
			return {
				type: _ReferentialConstants.RECEIVE_ALL_WATERSHED,
				watersheds: watersheds
			};
		},
		fetchWatersheds: function fetchWatersheds() {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return fetch(_ApplicationConf2.default.referencial.getWatershed(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					}
				}).then(_ActionUtils.getJson).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					if (!json.error) {
						dispatch(ReferentialAction.receiveWatersheds(json));
					}
					return [];
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
		receiveManagementWaters: function receiveManagementWaters(managementWaters) {
			return {
				type: _ReferentialConstants.RECEIVE_ALL_MANAGEMENT_WATER,
				managementWaters: managementWaters
			};
		},
		fetchManagementWaters: function fetchManagementWaters() {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return fetch(_ApplicationConf2.default.referencial.getManagementWaters(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					}
				}).then(_ActionUtils.getJson).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					if (!json.error) {
						dispatch(ReferentialAction.receiveManagementWaters(json));
					}
					return [];
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
		receiveSimpleStations: function receiveSimpleStations(stations) {
			return {
				type: _ReferentialConstants.RECEIVE_ALL_STATIONS,
				stations: stations
			};
		},
		fetchIndicatorTypes: function fetchIndicatorTypes() {
			return ReferentialAction.fetchGetReferencial(_ApplicationConf2.default.referencial.getIndicatorTypes(), ReferentialAction.receiveIndicatorTypes);
		},
		receiveIndicatorTypes: function receiveIndicatorTypes(indicatorTypes) {
			return {
				type: _ReferentialConstants.RECEIVE_ALL_INDICATOR_TYPES,
				indicatorTypes: indicatorTypes
			};
		},
		fetchIndicators: function fetchIndicators() {
			return ReferentialAction.fetchGetReferencial(_ApplicationConf2.default.referencial.getIndicators(), ReferentialAction.receiveIndicators);
		},
		receiveIndicators: function receiveIndicators(indicators) {
			return {
				type: _ReferentialConstants.RECEIVE_ALL_INDICATORS,
				indicators: indicators
			};
		},
		fetchSimpleStations: function fetchSimpleStations(parameters) {
			return ReferentialAction.fetchPostReferencial(_ApplicationConf2.default.referencial.getSimpleStations(), ReferentialAction.receiveSimpleStations, JSON.stringify({
				parameters: (0, _ApplicationUtils.getFetchSiteTypeAllowWithTypes)(parameters)
			}));
		},
		fetchGetReferencial: function fetchGetReferencial(link, receive) {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return fetch(link, {
					method: 'GET',
					headers: {
						'Content-Type': 'application/json'
					}
				}).then(_ActionUtils.getJson).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					if (!json.error) {
						dispatch(receive(json));
					}
					return [];
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
		fetchPostReferencial: function fetchPostReferencial(link, receive) {
			var argument = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
	
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				var defaultResult = function () {
					var resultParam = {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json'
						}
					};
					if (argument) {
						return Object.assign({}, resultParam, {
							body: argument
						});
					}
					return resultParam;
				}();
				return fetch(link, defaultResult).then(_ActionUtils.getJson).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					if (!json.error) {
						dispatch(receive(json));
					}
					return [];
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
		resetReferential: function resetReferential() {
			return { type: _ReferentialConstants.RESET_REFERENTIAL };
		}
	};
	exports.default = ReferentialAction;

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _lodash = __webpack_require__(15);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DtoDepartment = function DtoDepartment(obj) {
		_classCallCheck(this, DtoDepartment);
	
		this.id = obj.code;
		this.name = (0, _lodash.capitalize)(obj.name);
		this.code = obj.code;
		this.nameResearch = obj.nameresearch;
		this.codeResearch = obj.coderesearch;
	};
	
	exports.default = DtoDepartment;

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _lodash = __webpack_require__(15);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.code = obj.code;
		this.name = (0, _lodash.capitalize)(obj.name);
		this.typeId = obj.type_id;
		this.typeParameter = obj.typeparameter;
		this.isPiezometer = obj.ispiezometer;
		this.isQualitometer = obj.isqualitometer;
		this.nameResearch = obj.nameresearch;
		this.codeResearch = obj.coderesearch;
	};
	
	exports.default = _class;

/***/ },
/* 383 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.code;
		this.name = obj.name;
		this.symbol = obj.symbol;
	};
	
	exports.default = _class;

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getColor = exports.getSiteTypesSelected = undefined;
	
	var _lodash = __webpack_require__(15);
	
	var _ResearchTypesUtils = __webpack_require__(228);
	
	var getSiteTypesSelected = function getSiteTypesSelected(listOfThemes) {
		var reduceTypes = (0, _lodash.reduce)(listOfThemes, function (result, theme) {
			if (theme.value.siteTypes) {
				theme.value.siteTypes.forEach(function (o) {
					if (result[o.type]) {
						result[o.type] = result[o.type] + 1;
					} else {
						result[o.type] = 1;
					}
				});
			}
			return result;
		}, {});
		return Object.keys(reduceTypes).map(function (o) {
			return o;
		});
	};
	
	var getColor = function getColor(listOfThemes, childrenTheme) {
		var opacity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.3;
	
		var result = listOfThemes.find(function (a) {
			var themeFound = a.themes.find(function (b) {
				return b.id == childrenTheme.id;
			});
			if (themeFound) {
				return a;
			}
			return null;
		});
		if (result) {
			return (0, _ResearchTypesUtils.getRgba)(result.color, opacity);
		}
		return (0, _ResearchTypesUtils.getRgba)('3, 169, 244', opacity);
	};
	
	exports.getSiteTypesSelected = getSiteTypesSelected;
	exports.getColor = getColor;

/***/ },
/* 385 */
/***/ function(module, exports) {

	var dpr = 1; // If in browser environment
	
	if (typeof window !== 'undefined') {
	  dpr = Math.max(window.devicePixelRatio || 1, 1);
	}
	/**
	 * config默认配置项
	 * @exports zrender/config
	 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
	 */
	
	/**
	 * Debug log mode:
	 * 0: Do nothing, for release.
	 * 1: console.error, for debug.
	 */
	
	
	var debugMode = 0; // retina 屏幕优化
	
	var devicePixelRatio = dpr;
	exports.debugMode = debugMode;
	exports.devicePixelRatio = devicePixelRatio;

/***/ },
/* 386 */
/***/ function(module, exports) {

	/**
	 * @param {Array.<Object>} colorStops
	 */
	var Gradient = function (colorStops) {
	  this.colorStops = colorStops || [];
	};
	
	Gradient.prototype = {
	  constructor: Gradient,
	  addColorStop: function (offset, color) {
	    this.colorStops.push({
	      offset: offset,
	      color: color
	    });
	  }
	};
	var _default = Gradient;
	module.exports = _default;

/***/ },
/* 387 */
/***/ function(module, exports) {

	var ContextCachedBy = {
	  NONE: 0,
	  STYLE_BIND: 1,
	  PLAIN_TEXT: 2
	}; // Avoid confused with 0/false.
	
	var WILL_BE_RESTORED = 9;
	exports.ContextCachedBy = ContextCachedBy;
	exports.WILL_BE_RESTORED = WILL_BE_RESTORED;

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	var _util = __webpack_require__(3);
	
	var retrieve2 = _util.retrieve2;
	var retrieve3 = _util.retrieve3;
	var each = _util.each;
	var normalizeCssArray = _util.normalizeCssArray;
	var isString = _util.isString;
	var isObject = _util.isObject;
	
	var textContain = __webpack_require__(79);
	
	var roundRectHelper = __webpack_require__(1091);
	
	var imageHelper = __webpack_require__(559);
	
	var fixShadow = __webpack_require__(1089);
	
	var _constant = __webpack_require__(387);
	
	var ContextCachedBy = _constant.ContextCachedBy;
	var WILL_BE_RESTORED = _constant.WILL_BE_RESTORED;
	var DEFAULT_FONT = textContain.DEFAULT_FONT; // TODO: Have not support 'start', 'end' yet.
	
	var VALID_TEXT_ALIGN = {
	  left: 1,
	  right: 1,
	  center: 1
	};
	var VALID_TEXT_VERTICAL_ALIGN = {
	  top: 1,
	  bottom: 1,
	  middle: 1
	}; // Different from `STYLE_COMMON_PROPS` of `graphic/Style`,
	// the default value of shadowColor is `'transparent'`.
	
	var SHADOW_STYLE_COMMON_PROPS = [['textShadowBlur', 'shadowBlur', 0], ['textShadowOffsetX', 'shadowOffsetX', 0], ['textShadowOffsetY', 'shadowOffsetY', 0], ['textShadowColor', 'shadowColor', 'transparent']];
	var _tmpTextPositionResult = {};
	var _tmpBoxPositionResult = {};
	/**
	 * @param {module:zrender/graphic/Style} style
	 * @return {module:zrender/graphic/Style} The input style.
	 */
	
	function normalizeTextStyle(style) {
	  normalizeStyle(style);
	  each(style.rich, normalizeStyle);
	  return style;
	}
	
	function normalizeStyle(style) {
	  if (style) {
	    style.font = textContain.makeFont(style);
	    var textAlign = style.textAlign;
	    textAlign === 'middle' && (textAlign = 'center');
	    style.textAlign = textAlign == null || VALID_TEXT_ALIGN[textAlign] ? textAlign : 'left'; // Compatible with textBaseline.
	
	    var textVerticalAlign = style.textVerticalAlign || style.textBaseline;
	    textVerticalAlign === 'center' && (textVerticalAlign = 'middle');
	    style.textVerticalAlign = textVerticalAlign == null || VALID_TEXT_VERTICAL_ALIGN[textVerticalAlign] ? textVerticalAlign : 'top';
	    var textPadding = style.textPadding;
	
	    if (textPadding) {
	      style.textPadding = normalizeCssArray(style.textPadding);
	    }
	  }
	}
	/**
	 * @param {CanvasRenderingContext2D} ctx
	 * @param {string} text
	 * @param {module:zrender/graphic/Style} style
	 * @param {Object|boolean} [rect] {x, y, width, height}
	 *                  If set false, rect text is not used.
	 * @param {Element|module:zrender/graphic/helper/constant.WILL_BE_RESTORED} [prevEl] For ctx prop cache.
	 */
	
	
	function renderText(hostEl, ctx, text, style, rect, prevEl) {
	  style.rich ? renderRichText(hostEl, ctx, text, style, rect, prevEl) : renderPlainText(hostEl, ctx, text, style, rect, prevEl);
	} // Avoid setting to ctx according to prevEl if possible for
	// performance in scenarios of large amount text.
	
	
	function renderPlainText(hostEl, ctx, text, style, rect, prevEl) {
	  'use strict';
	
	  var needDrawBg = needDrawBackground(style);
	  var prevStyle;
	  var checkCache = false;
	  var cachedByMe = ctx.__attrCachedBy === ContextCachedBy.PLAIN_TEXT; // Only take and check cache for `Text` el, but not RectText.
	
	  if (prevEl !== WILL_BE_RESTORED) {
	    if (prevEl) {
	      prevStyle = prevEl.style;
	      checkCache = !needDrawBg && cachedByMe && prevStyle;
	    } // Prevent from using cache in `Style::bind`, because of the case:
	    // ctx property is modified by other properties than `Style::bind`
	    // used, and Style::bind is called next.
	
	
	    ctx.__attrCachedBy = needDrawBg ? ContextCachedBy.NONE : ContextCachedBy.PLAIN_TEXT;
	  } // Since this will be restored, prevent from using these props to check cache in the next
	  // entering of this method. But do not need to clear other cache like `Style::bind`.
	  else if (cachedByMe) {
	      ctx.__attrCachedBy = ContextCachedBy.NONE;
	    }
	
	  var styleFont = style.font || DEFAULT_FONT; // PENDING
	  // Only `Text` el set `font` and keep it (`RectText` will restore). So theoretically
	  // we can make font cache on ctx, which can cache for text el that are discontinuous.
	  // But layer save/restore needed to be considered.
	  // if (styleFont !== ctx.__fontCache) {
	  //     ctx.font = styleFont;
	  //     if (prevEl !== WILL_BE_RESTORED) {
	  //         ctx.__fontCache = styleFont;
	  //     }
	  // }
	
	  if (!checkCache || styleFont !== (prevStyle.font || DEFAULT_FONT)) {
	    ctx.font = styleFont;
	  } // Use the final font from context-2d, because the final
	  // font might not be the style.font when it is illegal.
	  // But get `ctx.font` might be time consuming.
	
	
	  var computedFont = hostEl.__computedFont;
	
	  if (hostEl.__styleFont !== styleFont) {
	    hostEl.__styleFont = styleFont;
	    computedFont = hostEl.__computedFont = ctx.font;
	  }
	
	  var textPadding = style.textPadding;
	  var textLineHeight = style.textLineHeight;
	  var contentBlock = hostEl.__textCotentBlock;
	
	  if (!contentBlock || hostEl.__dirtyText) {
	    contentBlock = hostEl.__textCotentBlock = textContain.parsePlainText(text, computedFont, textPadding, textLineHeight, style.truncate);
	  }
	
	  var outerHeight = contentBlock.outerHeight;
	  var textLines = contentBlock.lines;
	  var lineHeight = contentBlock.lineHeight;
	  var boxPos = getBoxPosition(_tmpBoxPositionResult, hostEl, style, rect);
	  var baseX = boxPos.baseX;
	  var baseY = boxPos.baseY;
	  var textAlign = boxPos.textAlign || 'left';
	  var textVerticalAlign = boxPos.textVerticalAlign; // Origin of textRotation should be the base point of text drawing.
	
	  applyTextRotation(ctx, style, rect, baseX, baseY);
	  var boxY = textContain.adjustTextY(baseY, outerHeight, textVerticalAlign);
	  var textX = baseX;
	  var textY = boxY;
	
	  if (needDrawBg || textPadding) {
	    // Consider performance, do not call getTextWidth util necessary.
	    var textWidth = textContain.getWidth(text, computedFont);
	    var outerWidth = textWidth;
	    textPadding && (outerWidth += textPadding[1] + textPadding[3]);
	    var boxX = textContain.adjustTextX(baseX, outerWidth, textAlign);
	    needDrawBg && drawBackground(hostEl, ctx, style, boxX, boxY, outerWidth, outerHeight);
	
	    if (textPadding) {
	      textX = getTextXForPadding(baseX, textAlign, textPadding);
	      textY += textPadding[0];
	    }
	  } // Always set textAlign and textBase line, because it is difficute to calculate
	  // textAlign from prevEl, and we dont sure whether textAlign will be reset if
	  // font set happened.
	
	
	  ctx.textAlign = textAlign; // Force baseline to be "middle". Otherwise, if using "top", the
	  // text will offset downward a little bit in font "Microsoft YaHei".
	
	  ctx.textBaseline = 'middle'; // Set text opacity
	
	  ctx.globalAlpha = style.opacity || 1; // Always set shadowBlur and shadowOffset to avoid leak from displayable.
	
	  for (var i = 0; i < SHADOW_STYLE_COMMON_PROPS.length; i++) {
	    var propItem = SHADOW_STYLE_COMMON_PROPS[i];
	    var styleProp = propItem[0];
	    var ctxProp = propItem[1];
	    var val = style[styleProp];
	
	    if (!checkCache || val !== prevStyle[styleProp]) {
	      ctx[ctxProp] = fixShadow(ctx, ctxProp, val || propItem[2]);
	    }
	  } // `textBaseline` is set as 'middle'.
	
	
	  textY += lineHeight / 2;
	  var textStrokeWidth = style.textStrokeWidth;
	  var textStrokeWidthPrev = checkCache ? prevStyle.textStrokeWidth : null;
	  var strokeWidthChanged = !checkCache || textStrokeWidth !== textStrokeWidthPrev;
	  var strokeChanged = !checkCache || strokeWidthChanged || style.textStroke !== prevStyle.textStroke;
	  var textStroke = getStroke(style.textStroke, textStrokeWidth);
	  var textFill = getFill(style.textFill);
	
	  if (textStroke) {
	    if (strokeWidthChanged) {
	      ctx.lineWidth = textStrokeWidth;
	    }
	
	    if (strokeChanged) {
	      ctx.strokeStyle = textStroke;
	    }
	  }
	
	  if (textFill) {
	    if (!checkCache || style.textFill !== prevStyle.textFill) {
	      ctx.fillStyle = textFill;
	    }
	  } // Optimize simply, in most cases only one line exists.
	
	
	  if (textLines.length === 1) {
	    // Fill after stroke so the outline will not cover the main part.
	    textStroke && ctx.strokeText(textLines[0], textX, textY);
	    textFill && ctx.fillText(textLines[0], textX, textY);
	  } else {
	    for (var i = 0; i < textLines.length; i++) {
	      // Fill after stroke so the outline will not cover the main part.
	      textStroke && ctx.strokeText(textLines[i], textX, textY);
	      textFill && ctx.fillText(textLines[i], textX, textY);
	      textY += lineHeight;
	    }
	  }
	}
	
	function renderRichText(hostEl, ctx, text, style, rect, prevEl) {
	  // Do not do cache for rich text because of the complexity.
	  // But `RectText` this will be restored, do not need to clear other cache like `Style::bind`.
	  if (prevEl !== WILL_BE_RESTORED) {
	    ctx.__attrCachedBy = ContextCachedBy.NONE;
	  }
	
	  var contentBlock = hostEl.__textCotentBlock;
	
	  if (!contentBlock || hostEl.__dirtyText) {
	    contentBlock = hostEl.__textCotentBlock = textContain.parseRichText(text, style);
	  }
	
	  drawRichText(hostEl, ctx, contentBlock, style, rect);
	}
	
	function drawRichText(hostEl, ctx, contentBlock, style, rect) {
	  var contentWidth = contentBlock.width;
	  var outerWidth = contentBlock.outerWidth;
	  var outerHeight = contentBlock.outerHeight;
	  var textPadding = style.textPadding;
	  var boxPos = getBoxPosition(_tmpBoxPositionResult, hostEl, style, rect);
	  var baseX = boxPos.baseX;
	  var baseY = boxPos.baseY;
	  var textAlign = boxPos.textAlign;
	  var textVerticalAlign = boxPos.textVerticalAlign; // Origin of textRotation should be the base point of text drawing.
	
	  applyTextRotation(ctx, style, rect, baseX, baseY);
	  var boxX = textContain.adjustTextX(baseX, outerWidth, textAlign);
	  var boxY = textContain.adjustTextY(baseY, outerHeight, textVerticalAlign);
	  var xLeft = boxX;
	  var lineTop = boxY;
	
	  if (textPadding) {
	    xLeft += textPadding[3];
	    lineTop += textPadding[0];
	  }
	
	  var xRight = xLeft + contentWidth;
	  needDrawBackground(style) && drawBackground(hostEl, ctx, style, boxX, boxY, outerWidth, outerHeight);
	
	  for (var i = 0; i < contentBlock.lines.length; i++) {
	    var line = contentBlock.lines[i];
	    var tokens = line.tokens;
	    var tokenCount = tokens.length;
	    var lineHeight = line.lineHeight;
	    var usedWidth = line.width;
	    var leftIndex = 0;
	    var lineXLeft = xLeft;
	    var lineXRight = xRight;
	    var rightIndex = tokenCount - 1;
	    var token;
	
	    while (leftIndex < tokenCount && (token = tokens[leftIndex], !token.textAlign || token.textAlign === 'left')) {
	      placeToken(hostEl, ctx, token, style, lineHeight, lineTop, lineXLeft, 'left');
	      usedWidth -= token.width;
	      lineXLeft += token.width;
	      leftIndex++;
	    }
	
	    while (rightIndex >= 0 && (token = tokens[rightIndex], token.textAlign === 'right')) {
	      placeToken(hostEl, ctx, token, style, lineHeight, lineTop, lineXRight, 'right');
	      usedWidth -= token.width;
	      lineXRight -= token.width;
	      rightIndex--;
	    } // The other tokens are placed as textAlign 'center' if there is enough space.
	
	
	    lineXLeft += (contentWidth - (lineXLeft - xLeft) - (xRight - lineXRight) - usedWidth) / 2;
	
	    while (leftIndex <= rightIndex) {
	      token = tokens[leftIndex]; // Consider width specified by user, use 'center' rather than 'left'.
	
	      placeToken(hostEl, ctx, token, style, lineHeight, lineTop, lineXLeft + token.width / 2, 'center');
	      lineXLeft += token.width;
	      leftIndex++;
	    }
	
	    lineTop += lineHeight;
	  }
	}
	
	function applyTextRotation(ctx, style, rect, x, y) {
	  // textRotation only apply in RectText.
	  if (rect && style.textRotation) {
	    var origin = style.textOrigin;
	
	    if (origin === 'center') {
	      x = rect.width / 2 + rect.x;
	      y = rect.height / 2 + rect.y;
	    } else if (origin) {
	      x = origin[0] + rect.x;
	      y = origin[1] + rect.y;
	    }
	
	    ctx.translate(x, y); // Positive: anticlockwise
	
	    ctx.rotate(-style.textRotation);
	    ctx.translate(-x, -y);
	  }
	}
	
	function placeToken(hostEl, ctx, token, style, lineHeight, lineTop, x, textAlign) {
	  var tokenStyle = style.rich[token.styleName] || {};
	  tokenStyle.text = token.text; // 'ctx.textBaseline' is always set as 'middle', for sake of
	  // the bias of "Microsoft YaHei".
	
	  var textVerticalAlign = token.textVerticalAlign;
	  var y = lineTop + lineHeight / 2;
	
	  if (textVerticalAlign === 'top') {
	    y = lineTop + token.height / 2;
	  } else if (textVerticalAlign === 'bottom') {
	    y = lineTop + lineHeight - token.height / 2;
	  }
	
	  !token.isLineHolder && needDrawBackground(tokenStyle) && drawBackground(hostEl, ctx, tokenStyle, textAlign === 'right' ? x - token.width : textAlign === 'center' ? x - token.width / 2 : x, y - token.height / 2, token.width, token.height);
	  var textPadding = token.textPadding;
	
	  if (textPadding) {
	    x = getTextXForPadding(x, textAlign, textPadding);
	    y -= token.height / 2 - textPadding[2] - token.textHeight / 2;
	  }
	
	  setCtx(ctx, 'shadowBlur', retrieve3(tokenStyle.textShadowBlur, style.textShadowBlur, 0));
	  setCtx(ctx, 'shadowColor', tokenStyle.textShadowColor || style.textShadowColor || 'transparent');
	  setCtx(ctx, 'shadowOffsetX', retrieve3(tokenStyle.textShadowOffsetX, style.textShadowOffsetX, 0));
	  setCtx(ctx, 'shadowOffsetY', retrieve3(tokenStyle.textShadowOffsetY, style.textShadowOffsetY, 0));
	  setCtx(ctx, 'textAlign', textAlign); // Force baseline to be "middle". Otherwise, if using "top", the
	  // text will offset downward a little bit in font "Microsoft YaHei".
	
	  setCtx(ctx, 'textBaseline', 'middle');
	  setCtx(ctx, 'font', token.font || DEFAULT_FONT);
	  var textStroke = getStroke(tokenStyle.textStroke || style.textStroke, textStrokeWidth);
	  var textFill = getFill(tokenStyle.textFill || style.textFill);
	  var textStrokeWidth = retrieve2(tokenStyle.textStrokeWidth, style.textStrokeWidth); // Fill after stroke so the outline will not cover the main part.
	
	  if (textStroke) {
	    setCtx(ctx, 'lineWidth', textStrokeWidth);
	    setCtx(ctx, 'strokeStyle', textStroke);
	    ctx.strokeText(token.text, x, y);
	  }
	
	  if (textFill) {
	    setCtx(ctx, 'fillStyle', textFill);
	    ctx.fillText(token.text, x, y);
	  }
	}
	
	function needDrawBackground(style) {
	  return !!(style.textBackgroundColor || style.textBorderWidth && style.textBorderColor);
	} // style: {textBackgroundColor, textBorderWidth, textBorderColor, textBorderRadius, text}
	// shape: {x, y, width, height}
	
	
	function drawBackground(hostEl, ctx, style, x, y, width, height) {
	  var textBackgroundColor = style.textBackgroundColor;
	  var textBorderWidth = style.textBorderWidth;
	  var textBorderColor = style.textBorderColor;
	  var isPlainBg = isString(textBackgroundColor);
	  setCtx(ctx, 'shadowBlur', style.textBoxShadowBlur || 0);
	  setCtx(ctx, 'shadowColor', style.textBoxShadowColor || 'transparent');
	  setCtx(ctx, 'shadowOffsetX', style.textBoxShadowOffsetX || 0);
	  setCtx(ctx, 'shadowOffsetY', style.textBoxShadowOffsetY || 0);
	
	  if (isPlainBg || textBorderWidth && textBorderColor) {
	    ctx.beginPath();
	    var textBorderRadius = style.textBorderRadius;
	
	    if (!textBorderRadius) {
	      ctx.rect(x, y, width, height);
	    } else {
	      roundRectHelper.buildPath(ctx, {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        r: textBorderRadius
	      });
	    }
	
	    ctx.closePath();
	  }
	
	  if (isPlainBg) {
	    setCtx(ctx, 'fillStyle', textBackgroundColor);
	
	    if (style.fillOpacity != null) {
	      var originalGlobalAlpha = ctx.globalAlpha;
	      ctx.globalAlpha = style.fillOpacity * style.opacity;
	      ctx.fill();
	      ctx.globalAlpha = originalGlobalAlpha;
	    } else {
	      ctx.fill();
	    }
	  } else if (isObject(textBackgroundColor)) {
	    var image = textBackgroundColor.image;
	    image = imageHelper.createOrUpdateImage(image, null, hostEl, onBgImageLoaded, textBackgroundColor);
	
	    if (image && imageHelper.isImageReady(image)) {
	      ctx.drawImage(image, x, y, width, height);
	    }
	  }
	
	  if (textBorderWidth && textBorderColor) {
	    setCtx(ctx, 'lineWidth', textBorderWidth);
	    setCtx(ctx, 'strokeStyle', textBorderColor);
	
	    if (style.strokeOpacity != null) {
	      var originalGlobalAlpha = ctx.globalAlpha;
	      ctx.globalAlpha = style.strokeOpacity * style.opacity;
	      ctx.stroke();
	      ctx.globalAlpha = originalGlobalAlpha;
	    } else {
	      ctx.stroke();
	    }
	  }
	}
	
	function onBgImageLoaded(image, textBackgroundColor) {
	  // Replace image, so that `contain/text.js#parseRichText`
	  // will get correct result in next tick.
	  textBackgroundColor.image = image;
	}
	
	function getBoxPosition(out, hostEl, style, rect) {
	  var baseX = style.x || 0;
	  var baseY = style.y || 0;
	  var textAlign = style.textAlign;
	  var textVerticalAlign = style.textVerticalAlign; // Text position represented by coord
	
	  if (rect) {
	    var textPosition = style.textPosition;
	
	    if (textPosition instanceof Array) {
	      // Percent
	      baseX = rect.x + parsePercent(textPosition[0], rect.width);
	      baseY = rect.y + parsePercent(textPosition[1], rect.height);
	    } else {
	      var res = hostEl && hostEl.calculateTextPosition ? hostEl.calculateTextPosition(_tmpTextPositionResult, style, rect) : textContain.calculateTextPosition(_tmpTextPositionResult, style, rect);
	      baseX = res.x;
	      baseY = res.y; // Default align and baseline when has textPosition
	
	      textAlign = textAlign || res.textAlign;
	      textVerticalAlign = textVerticalAlign || res.textVerticalAlign;
	    } // textOffset is only support in RectText, otherwise
	    // we have to adjust boundingRect for textOffset.
	
	
	    var textOffset = style.textOffset;
	
	    if (textOffset) {
	      baseX += textOffset[0];
	      baseY += textOffset[1];
	    }
	  }
	
	  out = out || {};
	  out.baseX = baseX;
	  out.baseY = baseY;
	  out.textAlign = textAlign;
	  out.textVerticalAlign = textVerticalAlign;
	  return out;
	}
	
	function setCtx(ctx, prop, value) {
	  ctx[prop] = fixShadow(ctx, prop, value);
	  return ctx[prop];
	}
	/**
	 * @param {string} [stroke] If specified, do not check style.textStroke.
	 * @param {string} [lineWidth] If specified, do not check style.textStroke.
	 * @param {number} style
	 */
	
	
	function getStroke(stroke, lineWidth) {
	  return stroke == null || lineWidth <= 0 || stroke === 'transparent' || stroke === 'none' ? null // TODO pattern and gradient?
	  : stroke.image || stroke.colorStops ? '#000' : stroke;
	}
	
	function getFill(fill) {
	  return fill == null || fill === 'none' ? null // TODO pattern and gradient?
	  : fill.image || fill.colorStops ? '#000' : fill;
	}
	
	function parsePercent(value, maxValue) {
	  if (typeof value === 'string') {
	    if (value.lastIndexOf('%') >= 0) {
	      return parseFloat(value) / 100 * maxValue;
	    }
	
	    return parseFloat(value);
	  }
	
	  return value;
	}
	
	function getTextXForPadding(x, textAlign, textPadding) {
	  return textAlign === 'right' ? x - textPadding[1] : textAlign === 'center' ? x + textPadding[3] / 2 - textPadding[1] / 2 : x + textPadding[3];
	}
	/**
	 * @param {string} text
	 * @param {module:zrender/Style} style
	 * @return {boolean}
	 */
	
	
	function needDrawText(text, style) {
	  return text != null && (text || style.textBackgroundColor || style.textBorderWidth && style.textBorderColor || style.textPadding);
	}
	
	exports.normalizeTextStyle = normalizeTextStyle;
	exports.renderText = renderText;
	exports.getBoxPosition = getBoxPosition;
	exports.getStroke = getStroke;
	exports.getFill = getFill;
	exports.parsePercent = parsePercent;
	exports.needDrawText = needDrawText;

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	var matrix = __webpack_require__(73);
	
	var vector = __webpack_require__(41);
	
	/**
	 * 提供变换扩展
	 * @module zrender/mixin/Transformable
	 * @author pissang (https://www.github.com/pissang)
	 */
	var mIdentity = matrix.identity;
	var EPSILON = 5e-5;
	
	function isNotAroundZero(val) {
	  return val > EPSILON || val < -EPSILON;
	}
	/**
	 * @alias module:zrender/mixin/Transformable
	 * @constructor
	 */
	
	
	var Transformable = function (opts) {
	  opts = opts || {}; // If there are no given position, rotation, scale
	
	  if (!opts.position) {
	    /**
	     * 平移
	     * @type {Array.<number>}
	     * @default [0, 0]
	     */
	    this.position = [0, 0];
	  }
	
	  if (opts.rotation == null) {
	    /**
	     * 旋转
	     * @type {Array.<number>}
	     * @default 0
	     */
	    this.rotation = 0;
	  }
	
	  if (!opts.scale) {
	    /**
	     * 缩放
	     * @type {Array.<number>}
	     * @default [1, 1]
	     */
	    this.scale = [1, 1];
	  }
	  /**
	   * 旋转和缩放的原点
	   * @type {Array.<number>}
	   * @default null
	   */
	
	
	  this.origin = this.origin || null;
	};
	
	var transformableProto = Transformable.prototype;
	transformableProto.transform = null;
	/**
	 * 判断是否需要有坐标变换
	 * 如果有坐标变换, 则从position, rotation, scale以及父节点的transform计算出自身的transform矩阵
	 */
	
	transformableProto.needLocalTransform = function () {
	  return isNotAroundZero(this.rotation) || isNotAroundZero(this.position[0]) || isNotAroundZero(this.position[1]) || isNotAroundZero(this.scale[0] - 1) || isNotAroundZero(this.scale[1] - 1);
	};
	
	var scaleTmp = [];
	
	transformableProto.updateTransform = function () {
	  var parent = this.parent;
	  var parentHasTransform = parent && parent.transform;
	  var needLocalTransform = this.needLocalTransform();
	  var m = this.transform;
	
	  if (!(needLocalTransform || parentHasTransform)) {
	    m && mIdentity(m);
	    return;
	  }
	
	  m = m || matrix.create();
	
	  if (needLocalTransform) {
	    this.getLocalTransform(m);
	  } else {
	    mIdentity(m);
	  } // 应用父节点变换
	
	
	  if (parentHasTransform) {
	    if (needLocalTransform) {
	      matrix.mul(m, parent.transform, m);
	    } else {
	      matrix.copy(m, parent.transform);
	    }
	  } // 保存这个变换矩阵
	
	
	  this.transform = m;
	  var globalScaleRatio = this.globalScaleRatio;
	
	  if (globalScaleRatio != null && globalScaleRatio !== 1) {
	    this.getGlobalScale(scaleTmp);
	    var relX = scaleTmp[0] < 0 ? -1 : 1;
	    var relY = scaleTmp[1] < 0 ? -1 : 1;
	    var sx = ((scaleTmp[0] - relX) * globalScaleRatio + relX) / scaleTmp[0] || 0;
	    var sy = ((scaleTmp[1] - relY) * globalScaleRatio + relY) / scaleTmp[1] || 0;
	    m[0] *= sx;
	    m[1] *= sx;
	    m[2] *= sy;
	    m[3] *= sy;
	  }
	
	  this.invTransform = this.invTransform || matrix.create();
	  matrix.invert(this.invTransform, m);
	};
	
	transformableProto.getLocalTransform = function (m) {
	  return Transformable.getLocalTransform(this, m);
	};
	/**
	 * 将自己的transform应用到context上
	 * @param {CanvasRenderingContext2D} ctx
	 */
	
	
	transformableProto.setTransform = function (ctx) {
	  var m = this.transform;
	  var dpr = ctx.dpr || 1;
	
	  if (m) {
	    ctx.setTransform(dpr * m[0], dpr * m[1], dpr * m[2], dpr * m[3], dpr * m[4], dpr * m[5]);
	  } else {
	    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
	  }
	};
	
	transformableProto.restoreTransform = function (ctx) {
	  var dpr = ctx.dpr || 1;
	  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
	};
	
	var tmpTransform = [];
	var originTransform = matrix.create();
	
	transformableProto.setLocalTransform = function (m) {
	  if (!m) {
	    // TODO return or set identity?
	    return;
	  }
	
	  var sx = m[0] * m[0] + m[1] * m[1];
	  var sy = m[2] * m[2] + m[3] * m[3];
	  var position = this.position;
	  var scale = this.scale;
	
	  if (isNotAroundZero(sx - 1)) {
	    sx = Math.sqrt(sx);
	  }
	
	  if (isNotAroundZero(sy - 1)) {
	    sy = Math.sqrt(sy);
	  }
	
	  if (m[0] < 0) {
	    sx = -sx;
	  }
	
	  if (m[3] < 0) {
	    sy = -sy;
	  }
	
	  position[0] = m[4];
	  position[1] = m[5];
	  scale[0] = sx;
	  scale[1] = sy;
	  this.rotation = Math.atan2(-m[1] / sy, m[0] / sx);
	};
	/**
	 * 分解`transform`矩阵到`position`, `rotation`, `scale`
	 */
	
	
	transformableProto.decomposeTransform = function () {
	  if (!this.transform) {
	    return;
	  }
	
	  var parent = this.parent;
	  var m = this.transform;
	
	  if (parent && parent.transform) {
	    // Get local transform and decompose them to position, scale, rotation
	    matrix.mul(tmpTransform, parent.invTransform, m);
	    m = tmpTransform;
	  }
	
	  var origin = this.origin;
	
	  if (origin && (origin[0] || origin[1])) {
	    originTransform[4] = origin[0];
	    originTransform[5] = origin[1];
	    matrix.mul(tmpTransform, m, originTransform);
	    tmpTransform[4] -= origin[0];
	    tmpTransform[5] -= origin[1];
	    m = tmpTransform;
	  }
	
	  this.setLocalTransform(m);
	};
	/**
	 * Get global scale
	 * @return {Array.<number>}
	 */
	
	
	transformableProto.getGlobalScale = function (out) {
	  var m = this.transform;
	  out = out || [];
	
	  if (!m) {
	    out[0] = 1;
	    out[1] = 1;
	    return out;
	  }
	
	  out[0] = Math.sqrt(m[0] * m[0] + m[1] * m[1]);
	  out[1] = Math.sqrt(m[2] * m[2] + m[3] * m[3]);
	
	  if (m[0] < 0) {
	    out[0] = -out[0];
	  }
	
	  if (m[3] < 0) {
	    out[1] = -out[1];
	  }
	
	  return out;
	};
	/**
	 * 变换坐标位置到 shape 的局部坐标空间
	 * @method
	 * @param {number} x
	 * @param {number} y
	 * @return {Array.<number>}
	 */
	
	
	transformableProto.transformCoordToLocal = function (x, y) {
	  var v2 = [x, y];
	  var invTransform = this.invTransform;
	
	  if (invTransform) {
	    vector.applyTransform(v2, v2, invTransform);
	  }
	
	  return v2;
	};
	/**
	 * 变换局部坐标位置到全局坐标空间
	 * @method
	 * @param {number} x
	 * @param {number} y
	 * @return {Array.<number>}
	 */
	
	
	transformableProto.transformCoordToGlobal = function (x, y) {
	  var v2 = [x, y];
	  var transform = this.transform;
	
	  if (transform) {
	    vector.applyTransform(v2, v2, transform);
	  }
	
	  return v2;
	};
	/**
	 * @static
	 * @param {Object} target
	 * @param {Array.<number>} target.origin
	 * @param {number} target.rotation
	 * @param {Array.<number>} target.position
	 * @param {Array.<number>} [m]
	 */
	
	
	Transformable.getLocalTransform = function (target, m) {
	  m = m || [];
	  mIdentity(m);
	  var origin = target.origin;
	  var scale = target.scale || [1, 1];
	  var rotation = target.rotation || 0;
	  var position = target.position || [0, 0];
	
	  if (origin) {
	    // Translate to origin
	    m[4] -= origin[0];
	    m[5] -= origin[1];
	  }
	
	  matrix.scale(m, m, scale);
	
	  if (rotation) {
	    matrix.rotate(m, m, rotation);
	  }
	
	  if (origin) {
	    // Translate back from origin
	    m[4] += origin[0];
	    m[5] += origin[1];
	  }
	
	  m[4] += position[0];
	  m[5] += position[1];
	  return m;
	};
	
	var _default = Transformable;
	module.exports = _default;

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	var guid = __webpack_require__(1086);
	
	var env = __webpack_require__(55);
	
	var zrUtil = __webpack_require__(3);
	
	var Handler = __webpack_require__(2271);
	
	var Storage = __webpack_require__(2274);
	
	var Painter = __webpack_require__(2273);
	
	var Animation = __webpack_require__(2275);
	
	var HandlerProxy = __webpack_require__(2284);
	
	/*!
	* ZRender, a high performance 2d drawing library.
	*
	* Copyright (c) 2013, Baidu Inc.
	* All rights reserved.
	*
	* LICENSE
	* https://github.com/ecomfe/zrender/blob/master/LICENSE.txt
	*/
	var useVML = !env.canvasSupported;
	var painterCtors = {
	  canvas: Painter
	};
	var instances = {}; // ZRender实例map索引
	
	/**
	 * @type {string}
	 */
	
	var version = '4.3.2';
	/**
	 * Initializing a zrender instance
	 * @param {HTMLElement} dom
	 * @param {Object} [opts]
	 * @param {string} [opts.renderer='canvas'] 'canvas' or 'svg'
	 * @param {number} [opts.devicePixelRatio]
	 * @param {number|string} [opts.width] Can be 'auto' (the same as null/undefined)
	 * @param {number|string} [opts.height] Can be 'auto' (the same as null/undefined)
	 * @return {module:zrender/ZRender}
	 */
	
	function init(dom, opts) {
	  var zr = new ZRender(guid(), dom, opts);
	  instances[zr.id] = zr;
	  return zr;
	}
	/**
	 * Dispose zrender instance
	 * @param {module:zrender/ZRender} zr
	 */
	
	
	function dispose(zr) {
	  if (zr) {
	    zr.dispose();
	  } else {
	    for (var key in instances) {
	      if (instances.hasOwnProperty(key)) {
	        instances[key].dispose();
	      }
	    }
	
	    instances = {};
	  }
	
	  return this;
	}
	/**
	 * Get zrender instance by id
	 * @param {string} id zrender instance id
	 * @return {module:zrender/ZRender}
	 */
	
	
	function getInstance(id) {
	  return instances[id];
	}
	
	function registerPainter(name, Ctor) {
	  painterCtors[name] = Ctor;
	}
	
	function delInstance(id) {
	  delete instances[id];
	}
	/**
	 * @module zrender/ZRender
	 */
	
	/**
	 * @constructor
	 * @alias module:zrender/ZRender
	 * @param {string} id
	 * @param {HTMLElement} dom
	 * @param {Object} opts
	 * @param {string} [opts.renderer='canvas'] 'canvas' or 'svg'
	 * @param {number} [opts.devicePixelRatio]
	 * @param {number} [opts.width] Can be 'auto' (the same as null/undefined)
	 * @param {number} [opts.height] Can be 'auto' (the same as null/undefined)
	 */
	
	
	var ZRender = function (id, dom, opts) {
	  opts = opts || {};
	  /**
	   * @type {HTMLDomElement}
	   */
	
	  this.dom = dom;
	  /**
	   * @type {string}
	   */
	
	  this.id = id;
	  var self = this;
	  var storage = new Storage();
	  var rendererType = opts.renderer; // TODO WebGL
	
	  if (useVML) {
	    if (!painterCtors.vml) {
	      throw new Error('You need to require \'zrender/vml/vml\' to support IE8');
	    }
	
	    rendererType = 'vml';
	  } else if (!rendererType || !painterCtors[rendererType]) {
	    rendererType = 'canvas';
	  }
	
	  var painter = new painterCtors[rendererType](dom, storage, opts, id);
	  this.storage = storage;
	  this.painter = painter;
	  var handerProxy = !env.node && !env.worker ? new HandlerProxy(painter.getViewportRoot(), painter.root) : null;
	  this.handler = new Handler(storage, painter, handerProxy, painter.root);
	  /**
	   * @type {module:zrender/animation/Animation}
	   */
	
	  this.animation = new Animation({
	    stage: {
	      update: zrUtil.bind(this.flush, this)
	    }
	  });
	  this.animation.start();
	  /**
	   * @type {boolean}
	   * @private
	   */
	
	  this._needsRefresh; // 修改 storage.delFromStorage, 每次删除元素之前删除动画
	  // FIXME 有点ugly
	
	  var oldDelFromStorage = storage.delFromStorage;
	  var oldAddToStorage = storage.addToStorage;
	
	  storage.delFromStorage = function (el) {
	    oldDelFromStorage.call(storage, el);
	    el && el.removeSelfFromZr(self);
	  };
	
	  storage.addToStorage = function (el) {
	    oldAddToStorage.call(storage, el);
	    el.addSelfToZr(self);
	  };
	};
	
	ZRender.prototype = {
	  constructor: ZRender,
	
	  /**
	   * 获取实例唯一标识
	   * @return {string}
	   */
	  getId: function () {
	    return this.id;
	  },
	
	  /**
	   * 添加元素
	   * @param  {module:zrender/Element} el
	   */
	  add: function (el) {
	    this.storage.addRoot(el);
	    this._needsRefresh = true;
	  },
	
	  /**
	   * 删除元素
	   * @param  {module:zrender/Element} el
	   */
	  remove: function (el) {
	    this.storage.delRoot(el);
	    this._needsRefresh = true;
	  },
	
	  /**
	   * Change configuration of layer
	   * @param {string} zLevel
	   * @param {Object} config
	   * @param {string} [config.clearColor=0] Clear color
	   * @param {string} [config.motionBlur=false] If enable motion blur
	   * @param {number} [config.lastFrameAlpha=0.7] Motion blur factor. Larger value cause longer trailer
	  */
	  configLayer: function (zLevel, config) {
	    if (this.painter.configLayer) {
	      this.painter.configLayer(zLevel, config);
	    }
	
	    this._needsRefresh = true;
	  },
	
	  /**
	   * Set background color
	   * @param {string} backgroundColor
	   */
	  setBackgroundColor: function (backgroundColor) {
	    if (this.painter.setBackgroundColor) {
	      this.painter.setBackgroundColor(backgroundColor);
	    }
	
	    this._needsRefresh = true;
	  },
	
	  /**
	   * Repaint the canvas immediately
	   */
	  refreshImmediately: function () {
	    // var start = new Date();
	    // Clear needsRefresh ahead to avoid something wrong happens in refresh
	    // Or it will cause zrender refreshes again and again.
	    this._needsRefresh = this._needsRefreshHover = false;
	    this.painter.refresh(); // Avoid trigger zr.refresh in Element#beforeUpdate hook
	
	    this._needsRefresh = this._needsRefreshHover = false; // var end = new Date();
	    // var log = document.getElementById('log');
	    // if (log) {
	    //     log.innerHTML = log.innerHTML + '<br>' + (end - start);
	    // }
	  },
	
	  /**
	   * Mark and repaint the canvas in the next frame of browser
	   */
	  refresh: function () {
	    this._needsRefresh = true;
	  },
	
	  /**
	   * Perform all refresh
	   */
	  flush: function () {
	    var triggerRendered;
	
	    if (this._needsRefresh) {
	      triggerRendered = true;
	      this.refreshImmediately();
	    }
	
	    if (this._needsRefreshHover) {
	      triggerRendered = true;
	      this.refreshHoverImmediately();
	    }
	
	    triggerRendered && this.trigger('rendered');
	  },
	
	  /**
	   * Add element to hover layer
	   * @param  {module:zrender/Element} el
	   * @param {Object} style
	   */
	  addHover: function (el, style) {
	    if (this.painter.addHover) {
	      var elMirror = this.painter.addHover(el, style);
	      this.refreshHover();
	      return elMirror;
	    }
	  },
	
	  /**
	   * Add element from hover layer
	   * @param  {module:zrender/Element} el
	   */
	  removeHover: function (el) {
	    if (this.painter.removeHover) {
	      this.painter.removeHover(el);
	      this.refreshHover();
	    }
	  },
	
	  /**
	   * Clear all hover elements in hover layer
	   * @param  {module:zrender/Element} el
	   */
	  clearHover: function () {
	    if (this.painter.clearHover) {
	      this.painter.clearHover();
	      this.refreshHover();
	    }
	  },
	
	  /**
	   * Refresh hover in next frame
	   */
	  refreshHover: function () {
	    this._needsRefreshHover = true;
	  },
	
	  /**
	   * Refresh hover immediately
	   */
	  refreshHoverImmediately: function () {
	    this._needsRefreshHover = false;
	    this.painter.refreshHover && this.painter.refreshHover();
	  },
	
	  /**
	   * Resize the canvas.
	   * Should be invoked when container size is changed
	   * @param {Object} [opts]
	   * @param {number|string} [opts.width] Can be 'auto' (the same as null/undefined)
	   * @param {number|string} [opts.height] Can be 'auto' (the same as null/undefined)
	   */
	  resize: function (opts) {
	    opts = opts || {};
	    this.painter.resize(opts.width, opts.height);
	    this.handler.resize();
	  },
	
	  /**
	   * Stop and clear all animation immediately
	   */
	  clearAnimation: function () {
	    this.animation.clear();
	  },
	
	  /**
	   * Get container width
	   */
	  getWidth: function () {
	    return this.painter.getWidth();
	  },
	
	  /**
	   * Get container height
	   */
	  getHeight: function () {
	    return this.painter.getHeight();
	  },
	
	  /**
	   * Export the canvas as Base64 URL
	   * @param {string} type
	   * @param {string} [backgroundColor='#fff']
	   * @return {string} Base64 URL
	   */
	  // toDataURL: function(type, backgroundColor) {
	  //     return this.painter.getRenderedCanvas({
	  //         backgroundColor: backgroundColor
	  //     }).toDataURL(type);
	  // },
	
	  /**
	   * Converting a path to image.
	   * It has much better performance of drawing image rather than drawing a vector path.
	   * @param {module:zrender/graphic/Path} e
	   * @param {number} width
	   * @param {number} height
	   */
	  pathToImage: function (e, dpr) {
	    return this.painter.pathToImage(e, dpr);
	  },
	
	  /**
	   * Set default cursor
	   * @param {string} [cursorStyle='default'] 例如 crosshair
	   */
	  setCursorStyle: function (cursorStyle) {
	    this.handler.setCursorStyle(cursorStyle);
	  },
	
	  /**
	   * Find hovered element
	   * @param {number} x
	   * @param {number} y
	   * @return {Object} {target, topTarget}
	   */
	  findHover: function (x, y) {
	    return this.handler.findHover(x, y);
	  },
	
	  /**
	   * Bind event
	   *
	   * @param {string} eventName Event name
	   * @param {Function} eventHandler Handler function
	   * @param {Object} [context] Context object
	   */
	  on: function (eventName, eventHandler, context) {
	    this.handler.on(eventName, eventHandler, context);
	  },
	
	  /**
	   * Unbind event
	   * @param {string} eventName Event name
	   * @param {Function} [eventHandler] Handler function
	   */
	  off: function (eventName, eventHandler) {
	    this.handler.off(eventName, eventHandler);
	  },
	
	  /**
	   * Trigger event manually
	   *
	   * @param {string} eventName Event name
	   * @param {event=} event Event object
	   */
	  trigger: function (eventName, event) {
	    this.handler.trigger(eventName, event);
	  },
	
	  /**
	   * Clear all objects and the canvas.
	   */
	  clear: function () {
	    this.storage.delRoot();
	    this.painter.clear();
	  },
	
	  /**
	   * Dispose self.
	   */
	  dispose: function () {
	    this.animation.stop();
	    this.clear();
	    this.storage.dispose();
	    this.painter.dispose();
	    this.handler.dispose();
	    this.animation = this.storage = this.painter = this.handler = null;
	    delInstance(this.id);
	  }
	};
	exports.version = version;
	exports.init = init;
	exports.dispose = dispose;
	exports.getInstance = getInstance;
	exports.registerPainter = registerPainter;

/***/ },
/* 391 */
/***/ function(module, exports) {

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	module.exports = _classCallCheck;

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeToArray = __webpack_require__(565);
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;
	  if (typeof o === "string") return arrayLikeToArray(o, minLen);
	  var n = Object.prototype.toString.call(o).slice(8, -1);
	  if (n === "Object" && o.constructor) n = o.constructor.name;
	  if (n === "Map" || n === "Set") return Array.from(o);
	  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
	}
	
	module.exports = _unsupportedIterableToArray;

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Backdrop.default;
	  }
	});
	
	var _Backdrop = _interopRequireDefault(__webpack_require__(1119));

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Checkbox.default;
	  }
	});
	
	var _Checkbox = _interopRequireDefault(__webpack_require__(1147));

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isHorizontal = isHorizontal;
	exports.getAnchor = getAnchor;
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _Modal = _interopRequireDefault(__webpack_require__(307));
	
	var _Backdrop = _interopRequireDefault(__webpack_require__(393));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _Slide = _interopRequireDefault(__webpack_require__(155));
	
	var _Paper = _interopRequireDefault(__webpack_require__(89));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var _transitions = __webpack_require__(99);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(59));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {},
	
	    /* Styles applied to the root element if `variant="permanent or persistent"`. */
	    docked: {
	      flex: '0 0 auto'
	    },
	
	    /* Styles applied to the `Paper` component. */
	    paper: {
	      overflowY: 'auto',
	      display: 'flex',
	      flexDirection: 'column',
	      height: '100%',
	      flex: '1 0 auto',
	      zIndex: theme.zIndex.drawer,
	      WebkitOverflowScrolling: 'touch',
	      // Add iOS momentum scrolling.
	      // temporary style
	      position: 'fixed',
	      top: 0,
	      // We disable the focus ring for mouse, touch and keyboard users.
	      // At some point, it would be better to keep it for keyboard users.
	      // :focus-ring CSS pseudo-class will help.
	      outline: 0
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="left"`. */
	    paperAnchorLeft: {
	      left: 0,
	      right: 'auto'
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="right"`. */
	    paperAnchorRight: {
	      left: 'auto',
	      right: 0
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="top"`. */
	    paperAnchorTop: {
	      top: 0,
	      left: 0,
	      bottom: 'auto',
	      right: 0,
	      height: 'auto',
	      maxHeight: '100%'
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="bottom"`. */
	    paperAnchorBottom: {
	      top: 'auto',
	      left: 0,
	      bottom: 0,
	      right: 0,
	      height: 'auto',
	      maxHeight: '100%'
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="left"` and `variant` is not "temporary". */
	    paperAnchorDockedLeft: {
	      borderRight: "1px solid ".concat(theme.palette.divider)
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="top"` and `variant` is not "temporary". */
	    paperAnchorDockedTop: {
	      borderBottom: "1px solid ".concat(theme.palette.divider)
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="right"` and `variant` is not "temporary". */
	    paperAnchorDockedRight: {
	      borderLeft: "1px solid ".concat(theme.palette.divider)
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="bottom"` and `variant` is not "temporary". */
	    paperAnchorDockedBottom: {
	      borderTop: "1px solid ".concat(theme.palette.divider)
	    },
	
	    /* Styles applied to the `Modal` component. */
	    modal: {}
	  };
	};
	
	exports.styles = styles;
	var oppositeDirection = {
	  left: 'right',
	  right: 'left',
	  top: 'down',
	  bottom: 'up'
	};
	
	function isHorizontal(anchor) {
	  return ['left', 'right'].indexOf(anchor) !== -1;
	}
	
	function getAnchor(theme, anchor) {
	  return theme.direction === 'rtl' && isHorizontal(anchor) ? oppositeDirection[anchor] : anchor;
	}
	
	var defaultTransitionDuration = {
	  enter: _transitions.duration.enteringScreen,
	  exit: _transitions.duration.leavingScreen
	};
	/**
	 * The props of the [Modal](/api/modal/) component are available
	 * when `variant="temporary"` is set.
	 */
	
	var Drawer = /*#__PURE__*/React.forwardRef(function Drawer(props, ref) {
	  var _props$anchor = props.anchor,
	      anchorProp = _props$anchor === void 0 ? 'left' : _props$anchor,
	      BackdropProps = props.BackdropProps,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$elevation = props.elevation,
	      elevation = _props$elevation === void 0 ? 16 : _props$elevation,
	      _props$ModalProps = props.ModalProps;
	  _props$ModalProps = _props$ModalProps === void 0 ? {} : _props$ModalProps;
	  var BackdropPropsProp = _props$ModalProps.BackdropProps,
	      ModalProps = (0, _objectWithoutProperties2.default)(_props$ModalProps, ["BackdropProps"]),
	      onClose = props.onClose,
	      _props$open = props.open,
	      open = _props$open === void 0 ? false : _props$open,
	      _props$PaperProps = props.PaperProps,
	      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
	      SlideProps = props.SlideProps,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Slide.default : _props$TransitionComp,
	      _props$transitionDura = props.transitionDuration,
	      transitionDuration = _props$transitionDura === void 0 ? defaultTransitionDuration : _props$transitionDura,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'temporary' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["anchor", "BackdropProps", "children", "classes", "className", "elevation", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "TransitionComponent", "transitionDuration", "variant"]);
	  var theme = (0, _useTheme.default)(); // Let's assume that the Drawer will always be rendered on user space.
	  // We use this state is order to skip the appear transition during the
	  // initial mount of the component.
	
	  var mounted = React.useRef(false);
	  React.useEffect(function () {
	    mounted.current = true;
	  }, []);
	  var anchor = getAnchor(theme, anchorProp);
	  var drawer = /*#__PURE__*/React.createElement(_Paper.default, (0, _extends2.default)({
	    elevation: variant === 'temporary' ? elevation : 0,
	    square: true
	  }, PaperProps, {
	    className: (0, _clsx.default)(classes.paper, classes["paperAnchor".concat((0, _capitalize.default)(anchor))], PaperProps.className, variant !== 'temporary' && classes["paperAnchorDocked".concat((0, _capitalize.default)(anchor))])
	  }), children);
	
	  if (variant === 'permanent') {
	    return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	      className: (0, _clsx.default)(classes.root, classes.docked, className),
	      ref: ref
	    }, other), drawer);
	  }
	
	  var slidingDrawer = /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    in: open,
	    direction: oppositeDirection[anchor],
	    timeout: transitionDuration,
	    appear: mounted.current
	  }, SlideProps), drawer);
	
	  if (variant === 'persistent') {
	    return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	      className: (0, _clsx.default)(classes.root, classes.docked, className),
	      ref: ref
	    }, other), slidingDrawer);
	  } // variant === temporary
	
	
	  return /*#__PURE__*/React.createElement(_Modal.default, (0, _extends2.default)({
	    BackdropProps: (0, _extends2.default)({}, BackdropProps, BackdropPropsProp, {
	      transitionDuration: transitionDuration
	    }),
	    BackdropComponent: _Backdrop.default,
	    className: (0, _clsx.default)(classes.root, classes.modal, className),
	    open: open,
	    onClose: onClose,
	    ref: ref
	  }, other, ModalProps), slidingDrawer);
	});
	 false ? Drawer.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Side from which the drawer will appear.
	   */
	  anchor: _propTypes.default.oneOf(['bottom', 'left', 'right', 'top']),
	
	  /**
	   * @ignore
	   */
	  BackdropProps: _propTypes.default.object,
	
	  /**
	   * The contents of the drawer.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The elevation of the drawer.
	   */
	  elevation: _propTypes.default.number,
	
	  /**
	   * Props applied to the [`Modal`](/api/modal/) element.
	   */
	  ModalProps: _propTypes.default.object,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * If `true`, the drawer is open.
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * Props applied to the [`Paper`](/api/paper/) element.
	   */
	  PaperProps: _propTypes.default.object,
	
	  /**
	   * Props applied to the [`Slide`](/api/slide/) element.
	   */
	  SlideProps: _propTypes.default.object,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['permanent', 'persistent', 'temporary'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDrawer',
	  flip: false
	})(Drawer);
	
	exports.default = _default;

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Fab.default;
	  }
	});
	
	var _Fab = _interopRequireDefault(__webpack_require__(1170));

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Fade.default;
	  }
	});
	
	var _Fade = _interopRequireDefault(__webpack_require__(1171));

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FilledInput.default;
	  }
	});
	
	var _FilledInput = _interopRequireDefault(__webpack_require__(1172));

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FormControl.default;
	  }
	});
	Object.defineProperty(exports, "useFormControl", {
	  enumerable: true,
	  get: function get() {
	    return _useFormControl.default;
	  }
	});
	
	var _FormControl = _interopRequireDefault(__webpack_require__(1173));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(154));

/***/ },
/* 400 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hasValue = hasValue;
	exports.isFilled = isFilled;
	exports.isAdornedStart = isAdornedStart;
	
	// Supports determination of isControlled().
	// Controlled input accepts its current value as a prop.
	//
	// @see https://facebook.github.io/react/docs/forms.html#controlled-components
	// @param value
	// @returns {boolean} true if string (including '') or number (including zero)
	function hasValue(value) {
	  return value != null && !(Array.isArray(value) && value.length === 0);
	} // Determine if field is empty or filled.
	// Response determines if label is presented above field or as placeholder.
	//
	// @param obj
	// @param SSR
	// @returns {boolean} False when not present or empty string.
	//                    True when any number or string with length.
	
	
	function isFilled(obj) {
	  var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
	} // Determine if an Input is adorned on start.
	// It's corresponding to the left with LTR.
	//
	// @param obj
	// @returns {boolean} False when no adornments.
	//                    True when adorned at the start.
	
	
	function isAdornedStart(obj) {
	  return obj.startAdornment;
	}

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _OutlinedInput.default;
	  }
	});
	
	var _OutlinedInput = _interopRequireDefault(__webpack_require__(1220));

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Portal.default;
	  }
	});
	
	var _Portal = _interopRequireDefault(__webpack_require__(1224));

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Select.default;
	  }
	});
	
	var _Select = _interopRequireDefault(__webpack_require__(1232));

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _SnackbarContent.default;
	  }
	});
	
	var _SnackbarContent = _interopRequireDefault(__webpack_require__(1239));

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _StepLabel.default;
	  }
	});
	
	var _StepLabel = _interopRequireDefault(__webpack_require__(1247));

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TextField.default;
	  }
	});
	
	var _TextField = _interopRequireDefault(__webpack_require__(1279));

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(80));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _utils = __webpack_require__(19);
	
	var _useControlled3 = _interopRequireDefault(__webpack_require__(133));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(154));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _IconButton = _interopRequireDefault(__webpack_require__(236));
	
	var styles = {
	  root: {
	    padding: 9
	  },
	  checked: {},
	  disabled: {},
	  input: {
	    cursor: 'inherit',
	    position: 'absolute',
	    opacity: 0,
	    width: '100%',
	    height: '100%',
	    top: 0,
	    left: 0,
	    margin: 0,
	    padding: 0,
	    zIndex: 1
	  }
	};
	/**
	 * @ignore - internal component.
	 */
	
	exports.styles = styles;
	var SwitchBase = /*#__PURE__*/React.forwardRef(function SwitchBase(props, ref) {
	  var autoFocus = props.autoFocus,
	      checkedProp = props.checked,
	      checkedIcon = props.checkedIcon,
	      classes = props.classes,
	      className = props.className,
	      defaultChecked = props.defaultChecked,
	      disabledProp = props.disabled,
	      icon = props.icon,
	      id = props.id,
	      inputProps = props.inputProps,
	      inputRef = props.inputRef,
	      name = props.name,
	      onBlur = props.onBlur,
	      onChange = props.onChange,
	      onFocus = props.onFocus,
	      readOnly = props.readOnly,
	      required = props.required,
	      tabIndex = props.tabIndex,
	      type = props.type,
	      value = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["autoFocus", "checked", "checkedIcon", "classes", "className", "defaultChecked", "disabled", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"]);
	
	  var _useControlled = (0, _useControlled3.default)({
	    controlled: checkedProp,
	    default: Boolean(defaultChecked),
	    name: 'SwitchBase',
	    state: 'checked'
	  }),
	      _useControlled2 = (0, _slicedToArray2.default)(_useControlled, 2),
	      checked = _useControlled2[0],
	      setCheckedState = _useControlled2[1];
	
	  var muiFormControl = (0, _useFormControl.default)();
	
	  var handleFocus = function handleFocus(event) {
	    if (onFocus) {
	      onFocus(event);
	    }
	
	    if (muiFormControl && muiFormControl.onFocus) {
	      muiFormControl.onFocus(event);
	    }
	  };
	
	  var handleBlur = function handleBlur(event) {
	    if (onBlur) {
	      onBlur(event);
	    }
	
	    if (muiFormControl && muiFormControl.onBlur) {
	      muiFormControl.onBlur(event);
	    }
	  };
	
	  var handleInputChange = function handleInputChange(event) {
	    var newChecked = event.target.checked;
	    setCheckedState(newChecked);
	
	    if (onChange) {
	      // TODO v5: remove the second argument.
	      onChange(event, newChecked);
	    }
	  };
	
	  var disabled = disabledProp;
	
	  if (muiFormControl) {
	    if (typeof disabled === 'undefined') {
	      disabled = muiFormControl.disabled;
	    }
	  }
	
	  var hasLabelFor = type === 'checkbox' || type === 'radio';
	  return /*#__PURE__*/React.createElement(_IconButton.default, (0, _extends2.default)({
	    component: "span",
	    className: (0, _clsx.default)(classes.root, className, checked && classes.checked, disabled && classes.disabled),
	    disabled: disabled,
	    tabIndex: null,
	    role: undefined,
	    onFocus: handleFocus,
	    onBlur: handleBlur,
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("input", (0, _extends2.default)({
	    autoFocus: autoFocus,
	    checked: checkedProp,
	    defaultChecked: defaultChecked,
	    className: classes.input,
	    disabled: disabled,
	    id: hasLabelFor && id,
	    name: name,
	    onChange: handleInputChange,
	    readOnly: readOnly,
	    ref: inputRef,
	    required: required,
	    tabIndex: tabIndex,
	    type: type,
	    value: value
	  }, inputProps)), checked ? checkedIcon : icon);
	}); // NB: If changed, please update Checkbox, Switch and Radio
	// so that the API documentation is updated.
	
	 false ? SwitchBase.propTypes = {
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is checked.
	   */
	  checkedIcon: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  defaultChecked: _propTypes.default.bool,
	
	  /**
	   * If `true`, the switch will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is unchecked.
	   */
	  icon: _propTypes.default.node.isRequired,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /*
	   * @ignore
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * It prevents the user from changing the value of the field
	   * (not from interacting with the field).
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * The input component prop `type`.
	   */
	  type: _propTypes.default.string.isRequired,
	
	  /**
	   * The value of the component.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateSwitchBase'
	})(SwitchBase);
	
	exports.default = _default;

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(62));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(19);
	
	var _createBreakpoints = _interopRequireDefault(__webpack_require__(622));
	
	var _createMixins = _interopRequireDefault(__webpack_require__(1312));
	
	var _createPalette = _interopRequireDefault(__webpack_require__(1314));
	
	var _createTypography = _interopRequireDefault(__webpack_require__(1317));
	
	var _shadows = _interopRequireDefault(__webpack_require__(1322));
	
	var _shape = _interopRequireDefault(__webpack_require__(1323));
	
	var _createSpacing = _interopRequireDefault(__webpack_require__(1315));
	
	var _transitions = _interopRequireDefault(__webpack_require__(99));
	
	var _zIndex = _interopRequireDefault(__webpack_require__(624));
	
	function createMuiTheme() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _options$breakpoints = options.breakpoints,
	      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
	      _options$mixins = options.mixins,
	      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
	      _options$palette = options.palette,
	      paletteInput = _options$palette === void 0 ? {} : _options$palette,
	      spacingInput = options.spacing,
	      _options$typography = options.typography,
	      typographyInput = _options$typography === void 0 ? {} : _options$typography,
	      other = (0, _objectWithoutProperties2.default)(options, ["breakpoints", "mixins", "palette", "spacing", "typography"]);
	  var palette = (0, _createPalette.default)(paletteInput);
	  var breakpoints = (0, _createBreakpoints.default)(breakpointsInput);
	  var spacing = (0, _createSpacing.default)(spacingInput);
	  var muiTheme = (0, _utils.deepmerge)({
	    breakpoints: breakpoints,
	    direction: 'ltr',
	    mixins: (0, _createMixins.default)(breakpoints, spacing, mixinsInput),
	    overrides: {},
	    // Inject custom styles
	    palette: palette,
	    props: {},
	    // Provide default props
	    shadows: _shadows.default,
	    typography: (0, _createTypography.default)(palette, typographyInput),
	    spacing: spacing,
	    shape: _shape.default,
	    transitions: _transitions.default,
	    zIndex: _zIndex.default
	  }, other);
	
	  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  muiTheme = args.reduce(function (acc, argument) {
	    return (0, _utils.deepmerge)(acc, argument);
	  }, muiTheme);
	
	  if (false) {
	    var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected'];
	
	    var traverse = function traverse(node, parentKey) {
	      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	      var key; // eslint-disable-next-line guard-for-in, no-restricted-syntax
	
	      for (key in node) {
	        var child = node[key];
	
	        if (depth === 1) {
	          if (key.indexOf('Mui') === 0 && child) {
	            traverse(child, key, depth + 1);
	          }
	        } else if (pseudoClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
	          if (process.env.NODE_ENV !== 'production') {
	            console.error(["Material-UI: The `".concat(parentKey, "` component increases ") + "the CSS specificity of the `".concat(key, "` internal state."), 'You can not override it like this: ', JSON.stringify(node, null, 2), '', 'Instead, you need to use the $ruleName syntax:', JSON.stringify({
	              root: (0, _defineProperty2.default)({}, "&$".concat(key), child)
	            }, null, 2), '', 'https://material-ui.com/r/pseudo-classes-guide'].join('\n'));
	          } // Remove the style to prevent global conflicts.
	
	
	          node[key] = {};
	        }
	      }
	    };
	
	    traverse(muiTheme.overrides);
	  }
	
	  return muiTheme;
	}
	
	var _default = createMuiTheme;
	exports.default = _default;

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {};
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _withWidth.default;
	  }
	});
	
	var _withWidth = _interopRequireWildcard(__webpack_require__(1332));
	
	Object.keys(_withWidth).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withWidth[key];
	    }
	  });
	});

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {};
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _StylesProvider.default;
	  }
	});
	
	var _StylesProvider = _interopRequireWildcard(__webpack_require__(1338));
	
	Object.keys(_StylesProvider).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _StylesProvider[key];
	    }
	  });
	});

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _createGenerateClassName.default;
	  }
	});
	
	var _createGenerateClassName = _interopRequireDefault(__webpack_require__(1341));

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _makeStyles.default;
	  }
	});
	
	var _makeStyles = _interopRequireDefault(__webpack_require__(1349));

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleBreakpoints = handleBreakpoints;
	exports.default = void 0;
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(115));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(153));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _merge = _interopRequireDefault(__webpack_require__(312));
	
	// The breakpoint **start** at this value.
	// For instance with the first breakpoint xs: [xs, sm[.
	var values = {
	  xs: 0,
	  sm: 600,
	  md: 960,
	  lg: 1280,
	  xl: 1920
	};
	var defaultBreakpoints = {
	  // Sorted ASC by size. That's important.
	  // It can't be configured as it's used statically for propTypes.
	  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
	  up: function up(key) {
	    return "@media (min-width:".concat(values[key], "px)");
	  }
	};
	
	function handleBreakpoints(props, propValue, styleFromPropValue) {
	  if (false) {
	    if (!props.theme) {
	      console.error('Material-UI: You are calling a style function without a theme value.');
	    }
	  }
	
	  if (Array.isArray(propValue)) {
	    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
	    return propValue.reduce(function (acc, item, index) {
	      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
	      return acc;
	    }, {});
	  }
	
	  if ((0, _typeof2.default)(propValue) === 'object') {
	    var _themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
	
	    return Object.keys(propValue).reduce(function (acc, breakpoint) {
	      acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
	      return acc;
	    }, {});
	  }
	
	  var output = styleFromPropValue(propValue);
	  return output;
	}
	
	function breakpoints(styleFunction) {
	  var newStyleFunction = function newStyleFunction(props) {
	    var base = styleFunction(props);
	    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
	    var extended = themeBreakpoints.keys.reduce(function (acc, key) {
	      if (props[key]) {
	        acc = acc || {};
	        acc[themeBreakpoints.up(key)] = styleFunction((0, _extends2.default)({
	          theme: props.theme
	        }, props[key]));
	      }
	
	      return acc;
	    }, null);
	    return (0, _merge.default)(base, extended);
	  };
	
	  newStyleFunction.propTypes =  false ? (0, _extends2.default)((0, _extends2.default)({}, styleFunction.propTypes), {}, {
	    xs: _propTypes.default.object,
	    sm: _propTypes.default.object,
	    md: _propTypes.default.object,
	    lg: _propTypes.default.object,
	    xl: _propTypes.default.object
	  }) : {};
	  newStyleFunction.filterProps = ['xs', 'sm', 'md', 'lg', 'xl'].concat((0, _toConsumableArray2.default)(styleFunction.filterProps));
	  return newStyleFunction;
	}
	
	var _default = breakpoints;
	exports.default = _default;

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = chainPropTypes;
	
	function chainPropTypes(propType1, propType2) {
	  if (true) {
	    return function () {
	      return null;
	    };
	  }
	
	  return function validate() {
	    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
	  };
	}

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var constants_1 = __webpack_require__(30);
	var columnController_1 = __webpack_require__(26);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var pinnedRowModel_1 = __webpack_require__(136);
	var utils_1 = __webpack_require__(10);
	var CellNavigationService = /** @class */ (function () {
	    function CellNavigationService() {
	    }
	    // returns null if no cell to focus on, ie at the end of the grid
	    CellNavigationService.prototype.getNextCellToFocus = function (key, lastCellToFocus) {
	        // starting with the provided cell, we keep moving until we find a cell we can
	        // focus on.
	        var pointer = lastCellToFocus;
	        var finished = false;
	        // finished will be true when either:
	        // a) cell found that we can focus on
	        // b) run out of cells (ie the method returns null)
	        while (!finished) {
	            switch (key) {
	                case constants_1.Constants.KEY_UP:
	                    pointer = this.getCellAbove(pointer);
	                    break;
	                case constants_1.Constants.KEY_DOWN:
	                    pointer = this.getCellBelow(pointer);
	                    break;
	                case constants_1.Constants.KEY_RIGHT:
	                    if (this.gridOptionsWrapper.isEnableRtl()) {
	                        pointer = this.getCellToLeft(pointer);
	                    }
	                    else {
	                        pointer = this.getCellToRight(pointer);
	                    }
	                    break;
	                case constants_1.Constants.KEY_LEFT:
	                    if (this.gridOptionsWrapper.isEnableRtl()) {
	                        pointer = this.getCellToRight(pointer);
	                    }
	                    else {
	                        pointer = this.getCellToLeft(pointer);
	                    }
	                    break;
	                default:
	                    pointer = null;
	                    console.warn('ag-Grid: unknown key for navigation ' + key);
	                    break;
	            }
	            if (pointer) {
	                finished = this.isCellGoodToFocusOn(pointer);
	            }
	            else {
	                finished = true;
	            }
	        }
	        return pointer;
	    };
	    CellNavigationService.prototype.isCellGoodToFocusOn = function (gridCell) {
	        var column = gridCell.column;
	        var rowNode;
	        switch (gridCell.rowPinned) {
	            case constants_1.Constants.PINNED_TOP:
	                rowNode = this.pinnedRowModel.getPinnedTopRow(gridCell.rowIndex);
	                break;
	            case constants_1.Constants.PINNED_BOTTOM:
	                rowNode = this.pinnedRowModel.getPinnedBottomRow(gridCell.rowIndex);
	                break;
	            default:
	                rowNode = this.rowModel.getRow(gridCell.rowIndex);
	                break;
	        }
	        var suppressNavigable = column.isSuppressNavigable(rowNode);
	        return !suppressNavigable;
	    };
	    CellNavigationService.prototype.getCellToLeft = function (lastCell) {
	        if (!lastCell) {
	            return null;
	        }
	        var colToLeft = this.columnController.getDisplayedColBefore(lastCell.column);
	        if (!colToLeft) {
	            return null;
	        }
	        return {
	            rowIndex: lastCell.rowIndex,
	            column: colToLeft,
	            rowPinned: lastCell.rowPinned
	        };
	    };
	    CellNavigationService.prototype.getCellToRight = function (lastCell) {
	        if (!lastCell) {
	            return null;
	        }
	        var colToRight = this.columnController.getDisplayedColAfter(lastCell.column);
	        // if already on right, do nothing
	        if (!colToRight) {
	            return null;
	        }
	        return {
	            rowIndex: lastCell.rowIndex,
	            column: colToRight,
	            rowPinned: lastCell.rowPinned
	        };
	    };
	    CellNavigationService.prototype.getRowBelow = function (rowPosition) {
	        // if already on top row, do nothing
	        var index = rowPosition.rowIndex;
	        var pinned = rowPosition.rowPinned;
	        if (this.isLastRowInContainer(rowPosition)) {
	            switch (pinned) {
	                case constants_1.Constants.PINNED_BOTTOM:
	                    // never any rows after pinned bottom
	                    return null;
	                case constants_1.Constants.PINNED_TOP:
	                    // if on last row of pinned top, then next row is main body (if rows exist),
	                    // otherwise it's the pinned bottom
	                    if (this.rowModel.isRowsToRender()) {
	                        return { rowIndex: 0, rowPinned: null };
	                    }
	                    else if (this.pinnedRowModel.isRowsToRender(constants_1.Constants.PINNED_BOTTOM)) {
	                        return { rowIndex: 0, rowPinned: constants_1.Constants.PINNED_BOTTOM };
	                    }
	                    return null;
	                default:
	                    // if in the main body, then try pinned bottom, otherwise return nothing
	                    if (this.pinnedRowModel.isRowsToRender(constants_1.Constants.PINNED_BOTTOM)) {
	                        return { rowIndex: 0, rowPinned: constants_1.Constants.PINNED_BOTTOM };
	                    }
	                    return null;
	            }
	        }
	        return { rowIndex: index + 1, rowPinned: pinned };
	    };
	    CellNavigationService.prototype.getCellBelow = function (lastCell) {
	        if (!lastCell) {
	            return null;
	        }
	        var rowBelow = this.getRowBelow(lastCell);
	        if (rowBelow) {
	            return {
	                rowIndex: rowBelow.rowIndex,
	                column: lastCell.column,
	                rowPinned: rowBelow.rowPinned
	            };
	        }
	        return null;
	    };
	    CellNavigationService.prototype.isLastRowInContainer = function (rowPosition) {
	        var pinned = rowPosition.rowPinned;
	        var index = rowPosition.rowIndex;
	        if (pinned === constants_1.Constants.PINNED_TOP) {
	            var lastTopIndex = this.pinnedRowModel.getPinnedTopRowData().length - 1;
	            return lastTopIndex <= index;
	        }
	        else if (pinned === constants_1.Constants.PINNED_BOTTOM) {
	            var lastBottomIndex = this.pinnedRowModel.getPinnedBottomRowData().length - 1;
	            return lastBottomIndex <= index;
	        }
	        var lastBodyIndex = this.rowModel.getRowCount() - 1;
	        return lastBodyIndex <= index;
	    };
	    CellNavigationService.prototype.getRowAbove = function (rowPosition) {
	        // if already on top row, do nothing
	        var index = rowPosition.rowIndex;
	        var pinned = rowPosition.rowPinned;
	        // if already on top row, do nothing
	        if (index === 0) {
	            if (pinned === constants_1.Constants.PINNED_TOP) {
	                return null;
	            }
	            else if (!pinned) {
	                if (this.pinnedRowModel.isRowsToRender(constants_1.Constants.PINNED_TOP)) {
	                    return this.getLastFloatingTopRow();
	                }
	                return null;
	            }
	            else {
	                // last floating bottom
	                if (this.rowModel.isRowsToRender()) {
	                    return this.getLastBodyCell();
	                }
	                else if (this.pinnedRowModel.isRowsToRender(constants_1.Constants.PINNED_TOP)) {
	                    return this.getLastFloatingTopRow();
	                }
	                return null;
	            }
	        }
	        return { rowIndex: index - 1, rowPinned: pinned };
	    };
	    CellNavigationService.prototype.getCellAbove = function (lastCell) {
	        if (!lastCell) {
	            return null;
	        }
	        var rowAbove = this.getRowAbove({ rowIndex: lastCell.rowIndex, rowPinned: lastCell.rowPinned });
	        if (rowAbove) {
	            return {
	                rowIndex: rowAbove.rowIndex,
	                column: lastCell.column,
	                rowPinned: rowAbove.rowPinned
	            };
	        }
	        return null;
	    };
	    CellNavigationService.prototype.getLastBodyCell = function () {
	        var lastBodyRow = this.rowModel.getRowCount() - 1;
	        return { rowIndex: lastBodyRow, rowPinned: null };
	    };
	    CellNavigationService.prototype.getLastFloatingTopRow = function () {
	        var lastFloatingRow = this.pinnedRowModel.getPinnedTopRowData().length - 1;
	        return { rowIndex: lastFloatingRow, rowPinned: constants_1.Constants.PINNED_TOP };
	    };
	    CellNavigationService.prototype.getNextTabbedCell = function (gridCell, backwards) {
	        if (backwards) {
	            return this.getNextTabbedCellBackwards(gridCell);
	        }
	        return this.getNextTabbedCellForwards(gridCell);
	    };
	    CellNavigationService.prototype.getNextTabbedCellForwards = function (gridCell) {
	        var displayedColumns = this.columnController.getAllDisplayedColumns();
	        var newRowIndex = gridCell.rowIndex;
	        var newFloating = gridCell.rowPinned;
	        // move along to the next cell
	        var newColumn = this.columnController.getDisplayedColAfter(gridCell.column);
	        // check if end of the row, and if so, go forward a row
	        if (!newColumn) {
	            newColumn = displayedColumns[0];
	            var rowBelow = this.getRowBelow(gridCell);
	            if (utils_1._.missing(rowBelow)) {
	                return null;
	            }
	            newRowIndex = rowBelow ? rowBelow.rowIndex : null;
	            newFloating = rowBelow ? rowBelow.rowPinned : null;
	        }
	        return { rowIndex: newRowIndex, column: newColumn, rowPinned: newFloating };
	    };
	    CellNavigationService.prototype.getNextTabbedCellBackwards = function (gridCell) {
	        var displayedColumns = this.columnController.getAllDisplayedColumns();
	        var newRowIndex = gridCell.rowIndex;
	        var newFloating = gridCell.rowPinned;
	        // move along to the next cell
	        var newColumn = this.columnController.getDisplayedColBefore(gridCell.column);
	        // check if end of the row, and if so, go forward a row
	        if (!newColumn) {
	            newColumn = utils_1._.last(displayedColumns);
	            var rowAbove = this.getRowAbove({ rowIndex: gridCell.rowIndex, rowPinned: gridCell.rowPinned });
	            if (utils_1._.missing(rowAbove)) {
	                return null;
	            }
	            newRowIndex = rowAbove ? rowAbove.rowIndex : null;
	            newFloating = rowAbove ? rowAbove.rowPinned : null;
	        }
	        return { rowIndex: newRowIndex, column: newColumn, rowPinned: newFloating };
	    };
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], CellNavigationService.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], CellNavigationService.prototype, "rowModel", void 0);
	    __decorate([
	        context_1.Autowired('pinnedRowModel'),
	        __metadata("design:type", pinnedRowModel_1.PinnedRowModel)
	    ], CellNavigationService.prototype, "pinnedRowModel", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], CellNavigationService.prototype, "gridOptionsWrapper", void 0);
	    CellNavigationService = __decorate([
	        context_1.Bean('cellNavigationService')
	    ], CellNavigationService);
	    return CellNavigationService;
	}());
	exports.CellNavigationService = CellNavigationService;


/***/ },
/* 416 */
/***/ function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// class returns unique instance id's for columns.
	// eg, the following calls (in this order) will result in:
	//
	// getInstanceIdForKey('country') => 0
	// getInstanceIdForKey('country') => 1
	// getInstanceIdForKey('country') => 2
	// getInstanceIdForKey('country') => 3
	// getInstanceIdForKey('age') => 0
	// getInstanceIdForKey('age') => 1
	// getInstanceIdForKey('country') => 4
	var GroupInstanceIdCreator = /** @class */ (function () {
	    function GroupInstanceIdCreator() {
	        // this map contains keys to numbers, so we remember what the last call was
	        this.existingIds = {};
	    }
	    GroupInstanceIdCreator.prototype.getInstanceIdForKey = function (key) {
	        var lastResult = this.existingIds[key];
	        var result;
	        if (typeof lastResult !== 'number') {
	            // first time this key
	            result = 0;
	        }
	        else {
	            result = lastResult + 1;
	        }
	        this.existingIds[key] = result;
	        return result;
	    };
	    return GroupInstanceIdCreator;
	}());
	exports.GroupInstanceIdCreator = GroupInstanceIdCreator;


/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var events_1 = __webpack_require__(29);
	var propertyKeys_1 = __webpack_require__(659);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var utils_1 = __webpack_require__(10);
	var ComponentUtil = /** @class */ (function () {
	    function ComponentUtil() {
	    }
	    ComponentUtil.getEventCallbacks = function () {
	        if (!ComponentUtil.EVENT_CALLBACKS) {
	            ComponentUtil.EVENT_CALLBACKS = [];
	            ComponentUtil.EVENT_CALLBACKS_NO_PREFIX = [];
	            ComponentUtil.EVENTS.forEach(function (eventName) {
	                ComponentUtil.EVENT_CALLBACKS.push(ComponentUtil.getCallbackForEvent(eventName));
	                ComponentUtil.EVENT_CALLBACKS_NO_PREFIX.push(eventName);
	            });
	        }
	        return ComponentUtil.EVENT_CALLBACKS;
	    };
	    ComponentUtil.copyAttributesToGridOptions = function (gridOptions, component, skipEventDeprecationCheck) {
	        if (skipEventDeprecationCheck === void 0) { skipEventDeprecationCheck = false; }
	        checkForDeprecated(component);
	        // create empty grid options if none were passed
	        if (typeof gridOptions !== 'object') {
	            gridOptions = {};
	        }
	        // to allow array style lookup in TypeScript, take type away from 'this' and 'gridOptions'
	        var pGridOptions = gridOptions;
	        // add in all the simple properties
	        ComponentUtil.ARRAY_PROPERTIES
	            .concat(ComponentUtil.STRING_PROPERTIES)
	            .concat(ComponentUtil.OBJECT_PROPERTIES)
	            .concat(ComponentUtil.FUNCTION_PROPERTIES)
	            .forEach(function (key) {
	            if (typeof component[key] !== 'undefined') {
	                pGridOptions[key] = component[key];
	            }
	        });
	        ComponentUtil.BOOLEAN_PROPERTIES.forEach(function (key) {
	            if (typeof component[key] !== 'undefined') {
	                pGridOptions[key] = ComponentUtil.toBoolean(component[key]);
	            }
	        });
	        ComponentUtil.NUMBER_PROPERTIES.forEach(function (key) {
	            if (typeof component[key] !== 'undefined') {
	                pGridOptions[key] = ComponentUtil.toNumber(component[key]);
	            }
	        });
	        ComponentUtil.getEventCallbacks().forEach(function (funcName) {
	            if (typeof component[funcName] !== 'undefined') {
	                pGridOptions[funcName] = component[funcName];
	            }
	        });
	        // purely for event deprecation checks (for frameworks - wouldn't apply for non-fw versions)
	        if (!skipEventDeprecationCheck) {
	            ComponentUtil.EVENT_CALLBACKS_NO_PREFIX.forEach(function (funcName) {
	                // react uses onXXX...not sure why this is diff to the other frameworks
	                var onMethodName = ComponentUtil.getCallbackForEvent(funcName);
	                if (typeof component[funcName] !== 'undefined' ||
	                    typeof component[onMethodName] !== 'undefined') {
	                    gridOptionsWrapper_1.GridOptionsWrapper.checkEventDeprecation(funcName);
	                }
	            });
	        }
	        return gridOptions;
	    };
	    ComponentUtil.getCallbackForEvent = function (eventName) {
	        if (!eventName || eventName.length < 2) {
	            return eventName;
	        }
	        else {
	            return 'on' + eventName[0].toUpperCase() + eventName.substr(1);
	        }
	    };
	    ComponentUtil.processOnChange = function (changes, gridOptions, api, columnApi) {
	        if (!changes) {
	            return;
	        }
	        checkForDeprecated(changes);
	        // to allow array style lookup in TypeScript, take type away from 'this' and 'gridOptions'
	        var pGridOptions = gridOptions;
	        // check if any change for the simple types, and if so, then just copy in the new value
	        ComponentUtil.ARRAY_PROPERTIES
	            .concat(ComponentUtil.OBJECT_PROPERTIES)
	            .concat(ComponentUtil.STRING_PROPERTIES)
	            .forEach(function (key) {
	            if (changes[key]) {
	                pGridOptions[key] = changes[key].currentValue;
	            }
	        });
	        ComponentUtil.BOOLEAN_PROPERTIES.forEach(function (key) {
	            if (changes[key]) {
	                pGridOptions[key] = ComponentUtil.toBoolean(changes[key].currentValue);
	            }
	        });
	        ComponentUtil.NUMBER_PROPERTIES.forEach(function (key) {
	            if (changes[key]) {
	                pGridOptions[key] = ComponentUtil.toNumber(changes[key].currentValue);
	            }
	        });
	        ComponentUtil.getEventCallbacks().forEach(function (funcName) {
	            if (changes[funcName]) {
	                pGridOptions[funcName] = changes[funcName].currentValue;
	            }
	        });
	        if (changes.enableCellTextSelection) {
	            api.setEnableCellTextSelection(ComponentUtil.toBoolean(changes.enableCellTextSelection.currentValue));
	        }
	        if (changes.showToolPanel) {
	            api.showToolPanel(ComponentUtil.toBoolean(changes.showToolPanel.currentValue));
	        }
	        if (changes.quickFilterText) {
	            api.setQuickFilter(changes.quickFilterText.currentValue);
	        }
	        if (changes.rowData) {
	            api.setRowData(changes.rowData.currentValue);
	        }
	        if (changes.pinnedTopRowData) {
	            api.setPinnedTopRowData(changes.pinnedTopRowData.currentValue);
	        }
	        if (changes.pinnedBottomRowData) {
	            api.setPinnedBottomRowData(changes.pinnedBottomRowData.currentValue);
	        }
	        if (changes.columnDefs) {
	            api.setColumnDefs(changes.columnDefs.currentValue, "gridOptionsChanged");
	        }
	        if (changes.datasource) {
	            api.setDatasource(changes.datasource.currentValue);
	        }
	        if (changes.headerHeight) {
	            api.setHeaderHeight(ComponentUtil.toNumber(changes.headerHeight.currentValue));
	        }
	        if (changes.paginationPageSize) {
	            api.paginationSetPageSize(ComponentUtil.toNumber(changes.paginationPageSize.currentValue));
	        }
	        if (changes.pivotMode) {
	            columnApi.setPivotMode(ComponentUtil.toBoolean(changes.pivotMode.currentValue));
	        }
	        if (changes.groupRemoveSingleChildren) {
	            api.setGroupRemoveSingleChildren(ComponentUtil.toBoolean(changes.groupRemoveSingleChildren.currentValue));
	        }
	        if (changes.suppressRowDrag) {
	            api.setSuppressRowDrag(ComponentUtil.toBoolean(changes.suppressRowDrag.currentValue));
	        }
	        if (changes.gridAutoHeight) {
	            api.setGridAutoHeight(ComponentUtil.toBoolean(changes.gridAutoHeight.currentValue));
	        }
	        if (changes.suppressClipboardPaste) {
	            api.setSuppressClipboardPaste(ComponentUtil.toBoolean(changes.suppressClipboardPaste.currentValue));
	        }
	        if (changes.sideBar) {
	            api.setSideBar(changes.sideBar.currentValue);
	        }
	        if (changes.datasource) {
	            api.setDatasource(changes.datasource.currentValue);
	        }
	        // copy changes into an event for dispatch
	        var event = {
	            type: events_1.Events.EVENT_COMPONENT_STATE_CHANGED,
	            api: gridOptions.api,
	            columnApi: gridOptions.columnApi
	        };
	        utils_1._.iterateObject(changes, function (key, value) {
	            event[key] = value;
	        });
	        api.dispatchEvent(event);
	    };
	    ComponentUtil.toBoolean = function (value) {
	        if (typeof value === 'boolean') {
	            return value;
	        }
	        else if (typeof value === 'string') {
	            // for boolean, compare to empty String to allow attributes appearing with
	            // not value to be treated as 'true'
	            return value.toUpperCase() === 'TRUE' || value == '';
	        }
	        else {
	            return false;
	        }
	    };
	    ComponentUtil.toNumber = function (value) {
	        if (typeof value === 'number') {
	            return value;
	        }
	        else if (typeof value === 'string') {
	            return Number(value);
	        }
	        else {
	            return undefined;
	        }
	    };
	    // all the events are populated in here AFTER this class (at the bottom of the file).
	    ComponentUtil.EVENTS = [];
	    ComponentUtil.STRING_PROPERTIES = propertyKeys_1.PropertyKeys.STRING_PROPERTIES;
	    ComponentUtil.OBJECT_PROPERTIES = propertyKeys_1.PropertyKeys.OBJECT_PROPERTIES;
	    ComponentUtil.ARRAY_PROPERTIES = propertyKeys_1.PropertyKeys.ARRAY_PROPERTIES;
	    ComponentUtil.NUMBER_PROPERTIES = propertyKeys_1.PropertyKeys.NUMBER_PROPERTIES;
	    ComponentUtil.BOOLEAN_PROPERTIES = propertyKeys_1.PropertyKeys.BOOLEAN_PROPERTIES;
	    ComponentUtil.FUNCTION_PROPERTIES = propertyKeys_1.PropertyKeys.FUNCTION_PROPERTIES;
	    ComponentUtil.ALL_PROPERTIES = propertyKeys_1.PropertyKeys.ALL_PROPERTIES;
	    return ComponentUtil;
	}());
	exports.ComponentUtil = ComponentUtil;
	utils_1._.iterateObject(events_1.Events, function (key, value) {
	    ComponentUtil.EVENTS.push(value);
	});
	function checkForDeprecated(changes) {
	    if (changes.rowDeselected || changes.onRowDeselected) {
	        console.warn('ag-grid: as of v3.4 rowDeselected no longer exists. Please check the docs.');
	    }
	}


/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var componentMetadataProvider_1 = __webpack_require__(419);
	var utils_1 = __webpack_require__(10);
	var AgComponentUtils = /** @class */ (function () {
	    function AgComponentUtils() {
	    }
	    AgComponentUtils.prototype.adaptFunction = function (propertyName, hardcodedJsFunction, componentFromFramework, source) {
	        if (hardcodedJsFunction == null) {
	            return {
	                component: null,
	                componentFromFramework: componentFromFramework,
	                source: source,
	                paramsFromSelector: null
	            };
	        }
	        var metadata = this.componentMetadataProvider.retrieve(propertyName);
	        if (metadata && metadata.functionAdapter) {
	            return {
	                componentFromFramework: componentFromFramework,
	                component: metadata.functionAdapter(hardcodedJsFunction),
	                source: source,
	                paramsFromSelector: null
	            };
	        }
	        return null;
	    };
	    AgComponentUtils.prototype.adaptCellRendererFunction = function (callback) {
	        var Adapter = /** @class */ (function () {
	            function Adapter() {
	            }
	            Adapter.prototype.refresh = function (params) {
	                return false;
	            };
	            Adapter.prototype.getGui = function () {
	                var callbackResult = callback(this.params);
	                var type = typeof callbackResult;
	                if (type === 'string' || type === 'number' || type === 'boolean') {
	                    return utils_1._.loadTemplate('<span>' + callbackResult + '</span>');
	                }
	                else {
	                    return callbackResult;
	                }
	            };
	            Adapter.prototype.init = function (params) {
	                this.params = params;
	            };
	            return Adapter;
	        }());
	        return Adapter;
	    };
	    AgComponentUtils.prototype.doesImplementIComponent = function (candidate) {
	        if (!candidate) {
	            return false;
	        }
	        return candidate.prototype && 'getGui' in candidate.prototype;
	    };
	    __decorate([
	        context_1.Autowired("componentMetadataProvider"),
	        __metadata("design:type", componentMetadataProvider_1.ComponentMetadataProvider)
	    ], AgComponentUtils.prototype, "componentMetadataProvider", void 0);
	    AgComponentUtils = __decorate([
	        context_1.Bean("agComponentUtils")
	    ], AgComponentUtils);
	    return AgComponentUtils;
	}());
	exports.AgComponentUtils = AgComponentUtils;


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var agComponentUtils_1 = __webpack_require__(418);
	var ComponentMetadataProvider = /** @class */ (function () {
	    function ComponentMetadataProvider() {
	    }
	    ComponentMetadataProvider.prototype.postConstruct = function () {
	        this.componentMetaData = {
	            dateComponent: {
	                mandatoryMethodList: ['getDate', 'setDate'],
	                optionalMethodList: ['afterGuiAttached']
	            },
	            detailCellRenderer: {
	                mandatoryMethodList: [],
	                optionalMethodList: ['refresh']
	            },
	            headerComponent: {
	                mandatoryMethodList: [],
	                optionalMethodList: []
	            },
	            headerGroupComponent: {
	                mandatoryMethodList: [],
	                optionalMethodList: []
	            },
	            loadingCellRenderer: {
	                mandatoryMethodList: [],
	                optionalMethodList: []
	            },
	            loadingOverlayComponent: {
	                mandatoryMethodList: [],
	                optionalMethodList: []
	            },
	            noRowsOverlayComponent: {
	                mandatoryMethodList: [],
	                optionalMethodList: []
	            },
	            floatingFilterComponent: {
	                mandatoryMethodList: ['onParentModelChanged'],
	                optionalMethodList: ['afterGuiAttached']
	            },
	            floatingFilterWrapperComponent: {
	                mandatoryMethodList: [],
	                optionalMethodList: []
	            },
	            cellRenderer: {
	                mandatoryMethodList: [],
	                optionalMethodList: ['refresh', 'afterGuiAttached'],
	                functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
	            },
	            cellEditor: {
	                mandatoryMethodList: ['getValue'],
	                optionalMethodList: ['isPopup', 'isCancelBeforeStart', 'isCancelAfterEnd', 'focusIn', 'focusOut', 'afterGuiAttached']
	            },
	            innerRenderer: {
	                mandatoryMethodList: [],
	                optionalMethodList: ['afterGuiAttached'],
	                functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
	            },
	            fullWidthCellRenderer: {
	                mandatoryMethodList: [],
	                optionalMethodList: ['refresh', 'afterGuiAttached'],
	                functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
	            },
	            pinnedRowCellRenderer: {
	                mandatoryMethodList: [],
	                optionalMethodList: ['refresh', 'afterGuiAttached'],
	                functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
	            },
	            groupRowInnerRenderer: {
	                mandatoryMethodList: [],
	                optionalMethodList: ['afterGuiAttached'],
	                functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
	            },
	            groupRowRenderer: {
	                mandatoryMethodList: [],
	                optionalMethodList: ['afterGuiAttached'],
	                functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
	            },
	            filter: {
	                mandatoryMethodList: ['isFilterActive', 'doesFilterPass', 'getModel', 'setModel'],
	                optionalMethodList: ['afterGuiAttached', 'onNewRowsLoaded', 'getModelAsString', 'onFloatingFilterChanged']
	            },
	            filterComponent: {
	                mandatoryMethodList: ['isFilterActive', 'doesFilterPass', 'getModel', 'setModel'],
	                optionalMethodList: ['afterGuiAttached', 'onNewRowsLoaded', 'getModelAsString', 'onFloatingFilterChanged']
	            },
	            statusPanel: {
	                mandatoryMethodList: [],
	                optionalMethodList: ['afterGuiAttached'],
	            },
	            toolPanel: {
	                mandatoryMethodList: [],
	                optionalMethodList: ['refresh', 'afterGuiAttached']
	            },
	            tooltipComponent: {
	                mandatoryMethodList: [],
	                optionalMethodList: []
	            }
	        };
	    };
	    ComponentMetadataProvider.prototype.retrieve = function (name) {
	        return this.componentMetaData[name];
	    };
	    __decorate([
	        context_1.Autowired("agComponentUtils"),
	        __metadata("design:type", agComponentUtils_1.AgComponentUtils)
	    ], ComponentMetadataProvider.prototype, "agComponentUtils", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ComponentMetadataProvider.prototype, "postConstruct", null);
	    ComponentMetadataProvider = __decorate([
	        context_1.Bean("componentMetadataProvider")
	    ], ComponentMetadataProvider);
	    return ComponentMetadataProvider;
	}());
	exports.ComponentMetadataProvider = ComponentMetadataProvider;


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var textCellEditor_1 = __webpack_require__(436);
	var context_1 = __webpack_require__(8);
	var dateFilter_1 = __webpack_require__(424);
	var headerComp_1 = __webpack_require__(1392);
	var headerGroupComp_1 = __webpack_require__(1394);
	var groupCellRenderer_1 = __webpack_require__(439);
	var animateShowChangeCellRenderer_1 = __webpack_require__(437);
	var animateSlideCellRenderer_1 = __webpack_require__(438);
	var loadingCellRenderer_1 = __webpack_require__(1400);
	var selectCellEditor_1 = __webpack_require__(435);
	var popupTextCellEditor_1 = __webpack_require__(662);
	var popupSelectCellEditor_1 = __webpack_require__(661);
	var largeTextCellEditor_1 = __webpack_require__(660);
	var numberFilter_1 = __webpack_require__(425);
	var loadingOverlayComponent_1 = __webpack_require__(1402);
	var noRowsOverlayComponent_1 = __webpack_require__(1403);
	var tooltipComponent_1 = __webpack_require__(1406);
	var utils_1 = __webpack_require__(10);
	var defaultDateComponent_1 = __webpack_require__(1387);
	var dateFloatingFilter_1 = __webpack_require__(1386);
	var textFilter_1 = __webpack_require__(427);
	var numberFloatingFilter_1 = __webpack_require__(1388);
	var textFloatingFilter_1 = __webpack_require__(1389);
	var RegisteredComponentSource;
	(function (RegisteredComponentSource) {
	    RegisteredComponentSource[RegisteredComponentSource["DEFAULT"] = 0] = "DEFAULT";
	    RegisteredComponentSource[RegisteredComponentSource["REGISTERED"] = 1] = "REGISTERED";
	})(RegisteredComponentSource = exports.RegisteredComponentSource || (exports.RegisteredComponentSource = {}));
	var UserComponentRegistry = /** @class */ (function () {
	    function UserComponentRegistry() {
	        this.agGridDefaults = {
	            //date
	            agDateInput: defaultDateComponent_1.DefaultDateComponent,
	            //header
	            agColumnHeader: headerComp_1.HeaderComp,
	            agColumnGroupHeader: headerGroupComp_1.HeaderGroupComp,
	            //floating filters
	            agTextColumnFloatingFilter: textFloatingFilter_1.TextFloatingFilter,
	            agNumberColumnFloatingFilter: numberFloatingFilter_1.NumberFloatingFilter,
	            agDateColumnFloatingFilter: dateFloatingFilter_1.DateFloatingFilter,
	            // renderers
	            agAnimateShowChangeCellRenderer: animateShowChangeCellRenderer_1.AnimateShowChangeCellRenderer,
	            agAnimateSlideCellRenderer: animateSlideCellRenderer_1.AnimateSlideCellRenderer,
	            agGroupCellRenderer: groupCellRenderer_1.GroupCellRenderer,
	            agGroupRowRenderer: groupCellRenderer_1.GroupCellRenderer,
	            agLoadingCellRenderer: loadingCellRenderer_1.LoadingCellRenderer,
	            //editors
	            agCellEditor: textCellEditor_1.TextCellEditor,
	            agTextCellEditor: textCellEditor_1.TextCellEditor,
	            agSelectCellEditor: selectCellEditor_1.SelectCellEditor,
	            agPopupTextCellEditor: popupTextCellEditor_1.PopupTextCellEditor,
	            agPopupSelectCellEditor: popupSelectCellEditor_1.PopupSelectCellEditor,
	            agLargeTextCellEditor: largeTextCellEditor_1.LargeTextCellEditor,
	            //filter
	            agTextColumnFilter: textFilter_1.TextFilter,
	            agNumberColumnFilter: numberFilter_1.NumberFilter,
	            agDateColumnFilter: dateFilter_1.DateFilter,
	            //overlays
	            agLoadingOverlay: loadingOverlayComponent_1.LoadingOverlayComponent,
	            agNoRowsOverlay: noRowsOverlayComponent_1.NoRowsOverlayComponent,
	            // tooltips
	            agTooltipComponent: tooltipComponent_1.TooltipComponent
	        };
	        this.agDeprecatedNames = {
	            set: {
	                newComponentName: 'agSetColumnFilter',
	                propertyHolder: 'filter'
	            },
	            text: {
	                newComponentName: 'agTextColumnFilter',
	                propertyHolder: 'filter'
	            },
	            number: {
	                newComponentName: 'agNumberColumnFilter',
	                propertyHolder: 'filter'
	            },
	            date: {
	                newComponentName: 'agDateColumnFilter',
	                propertyHolder: 'filter'
	            },
	            group: {
	                newComponentName: 'agGroupCellRenderer',
	                propertyHolder: 'cellRenderer'
	            },
	            animateShowChange: {
	                newComponentName: 'agAnimateShowChangeCellRenderer',
	                propertyHolder: 'cellRenderer'
	            },
	            animateSlide: {
	                newComponentName: 'agAnimateSlideCellRenderer',
	                propertyHolder: 'cellRenderer'
	            },
	            select: {
	                newComponentName: 'agSelectCellEditor',
	                propertyHolder: 'cellEditor'
	            },
	            largeText: {
	                newComponentName: 'agLargeTextCellEditor',
	                propertyHolder: 'cellEditor'
	            },
	            popupSelect: {
	                newComponentName: 'agPopupSelectCellEditor',
	                propertyHolder: 'cellEditor'
	            },
	            popupText: {
	                newComponentName: 'agPopupTextCellEditor',
	                propertyHolder: 'cellEditor'
	            },
	            richSelect: {
	                newComponentName: 'agRichSelectCellEditor',
	                propertyHolder: 'cellEditor'
	            },
	            headerComponent: {
	                newComponentName: 'agColumnHeader',
	                propertyHolder: 'headerComponent'
	            }
	        };
	        this.jsComponents = {};
	        this.frameworkComponents = {};
	    }
	    UserComponentRegistry.prototype.init = function () {
	        var _this = this;
	        var enterpriseDefaultComponents = this.context.getEnterpriseDefaultComponents();
	        if (enterpriseDefaultComponents) {
	            utils_1._.forEach(enterpriseDefaultComponents, function (config) {
	                _this.registerDefaultComponent(config.componentName, config.theClass);
	            });
	        }
	        if (this.gridOptions.components != null) {
	            Object.keys(this.gridOptions.components).forEach(function (it) {
	                _this.registerComponent(it, _this.gridOptions.components[it]);
	            });
	        }
	        if (this.gridOptions.frameworkComponents != null) {
	            Object.keys(this.gridOptions.frameworkComponents).forEach(function (it) {
	                _this.registerFwComponent(it, _this.gridOptions.frameworkComponents[it]);
	            });
	        }
	    };
	    UserComponentRegistry.prototype.registerDefaultComponent = function (rawName, component) {
	        var name = this.translateIfDeprecated(rawName);
	        if (this.agGridDefaults[name]) {
	            console.error("Trying to overwrite a default component. You should call registerComponent");
	            return;
	        }
	        this.agGridDefaults[name] = component;
	    };
	    UserComponentRegistry.prototype.registerComponent = function (rawName, component) {
	        var name = this.translateIfDeprecated(rawName);
	        if (this.frameworkComponents[name]) {
	            console.error("Trying to register a component that you have already registered for frameworks: " + name);
	            return;
	        }
	        this.jsComponents[name] = component;
	    };
	    /**
	     * B the business interface (ie IHeader)
	     * A the agGridComponent interface (ie IHeaderComp). The final object acceptable by ag-grid
	     */
	    UserComponentRegistry.prototype.registerFwComponent = function (rawName, component) {
	        var name = this.translateIfDeprecated(rawName);
	        if (this.jsComponents[name]) {
	            console.error("Trying to register a component that you have already registered for plain javascript: " + name);
	            return;
	        }
	        this.frameworkComponents[name] = component;
	    };
	    /**
	     * B the business interface (ie IHeader)
	     * A the agGridComponent interface (ie IHeaderComp). The final object acceptable by ag-grid
	     */
	    UserComponentRegistry.prototype.retrieve = function (rawName) {
	        var name = this.translateIfDeprecated(rawName);
	        if (this.frameworkComponents[name]) {
	            return {
	                componentFromFramework: true,
	                component: this.frameworkComponents[name],
	                source: RegisteredComponentSource.REGISTERED
	            };
	        }
	        if (this.jsComponents[name]) {
	            return {
	                componentFromFramework: false,
	                component: this.jsComponents[name],
	                source: RegisteredComponentSource.REGISTERED
	            };
	        }
	        if (this.agGridDefaults[name]) {
	            return this.agGridDefaults[name] ?
	                {
	                    componentFromFramework: false,
	                    component: this.agGridDefaults[name],
	                    source: RegisteredComponentSource.DEFAULT
	                } :
	                null;
	        }
	        if (Object.keys(this.agGridDefaults).indexOf(name) < 0) {
	            console.warn("ag-Grid: Looking for component [" + name + "] but it wasn't found.");
	        }
	        return null;
	    };
	    UserComponentRegistry.prototype.translateIfDeprecated = function (raw) {
	        var deprecatedInfo = this.agDeprecatedNames[raw];
	        if (deprecatedInfo != null) {
	            utils_1._.doOnce(function () {
	                console.warn("ag-grid. Since v15.0 component names have been renamed to be namespaced. You should rename " + deprecatedInfo.propertyHolder + ":" + raw + " to " + deprecatedInfo.propertyHolder + ":" + deprecatedInfo.newComponentName);
	            }, 'DEPRECATE_COMPONENT_' + raw);
	            return deprecatedInfo.newComponentName;
	        }
	        return raw;
	    };
	    __decorate([
	        context_1.Autowired('gridOptions'),
	        __metadata("design:type", Object)
	    ], UserComponentRegistry.prototype, "gridOptions", void 0);
	    __decorate([
	        context_1.Autowired('context'),
	        __metadata("design:type", context_1.Context)
	    ], UserComponentRegistry.prototype, "context", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], UserComponentRegistry.prototype, "init", null);
	    UserComponentRegistry = __decorate([
	        context_1.Bean('userComponentRegistry')
	    ], UserComponentRegistry);
	    return UserComponentRegistry;
	}());
	exports.UserComponentRegistry = UserComponentRegistry;


/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var CellPositionUtils = /** @class */ (function () {
	    function CellPositionUtils() {
	    }
	    CellPositionUtils.prototype.createId = function (cellPosition) {
	        var rowIndex = cellPosition.rowIndex, rowPinned = cellPosition.rowPinned, column = cellPosition.column;
	        return rowIndex + "." + (rowPinned == null ? 'null' : rowPinned) + "." + column.getId();
	    };
	    CellPositionUtils.prototype.equals = function (cellA, cellB) {
	        var colsMatch = cellA.column === cellB.column;
	        var floatingMatch = cellA.rowPinned === cellB.rowPinned;
	        var indexMatch = cellA.rowIndex === cellB.rowIndex;
	        return colsMatch && floatingMatch && indexMatch;
	    };
	    CellPositionUtils = __decorate([
	        context_1.Bean('cellPositionUtils')
	    ], CellPositionUtils);
	    return CellPositionUtils;
	}());
	exports.CellPositionUtils = CellPositionUtils;


/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var gridSerializer_1 = __webpack_require__(316);
	var downloader_1 = __webpack_require__(423);
	var columnController_1 = __webpack_require__(26);
	var valueService_1 = __webpack_require__(103);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var constants_1 = __webpack_require__(30);
	var utils_1 = __webpack_require__(10);
	var LINE_SEPARATOR = '\r\n';
	var CsvSerializingSession = /** @class */ (function (_super) {
	    __extends(CsvSerializingSession, _super);
	    function CsvSerializingSession(config) {
	        var _this = _super.call(this, {
	            columnController: config.columnController,
	            valueService: config.valueService,
	            gridOptionsWrapper: config.gridOptionsWrapper,
	            processCellCallback: config.processCellCallback,
	            processHeaderCallback: config.processHeaderCallback
	        }) || this;
	        _this.result = '';
	        _this.lineOpened = false;
	        var suppressQuotes = config.suppressQuotes, columnSeparator = config.columnSeparator;
	        _this.suppressQuotes = suppressQuotes;
	        _this.columnSeparator = columnSeparator;
	        return _this;
	    }
	    CsvSerializingSession.prototype.prepare = function (columnsToExport) {
	    };
	    CsvSerializingSession.prototype.addCustomHeader = function (customHeader) {
	        if (!customHeader) {
	            return;
	        }
	        this.result += customHeader + LINE_SEPARATOR;
	    };
	    CsvSerializingSession.prototype.addCustomFooter = function (customFooter) {
	        if (!customFooter) {
	            return;
	        }
	        this.result += customFooter + LINE_SEPARATOR;
	    };
	    CsvSerializingSession.prototype.onNewHeaderGroupingRow = function () {
	        if (this.lineOpened) {
	            this.result += LINE_SEPARATOR;
	        }
	        return {
	            onColumn: this.onNewHeaderGroupingRowColumn.bind(this)
	        };
	    };
	    CsvSerializingSession.prototype.onNewHeaderGroupingRowColumn = function (header, index, span) {
	        if (index != 0) {
	            this.result += this.columnSeparator;
	        }
	        this.result += this.putInQuotes(header, this.suppressQuotes);
	        for (var i = 1; i <= span; i++) {
	            this.result += this.columnSeparator + this.putInQuotes("", this.suppressQuotes);
	        }
	        this.lineOpened = true;
	    };
	    CsvSerializingSession.prototype.onNewHeaderRow = function () {
	        if (this.lineOpened) {
	            this.result += LINE_SEPARATOR;
	        }
	        return {
	            onColumn: this.onNewHeaderRowColumn.bind(this)
	        };
	    };
	    CsvSerializingSession.prototype.onNewHeaderRowColumn = function (column, index, node) {
	        if (index != 0) {
	            this.result += this.columnSeparator;
	        }
	        this.result += this.putInQuotes(this.extractHeaderValue(column), this.suppressQuotes);
	        this.lineOpened = true;
	    };
	    CsvSerializingSession.prototype.onNewBodyRow = function () {
	        if (this.lineOpened) {
	            this.result += LINE_SEPARATOR;
	        }
	        return {
	            onColumn: this.onNewBodyRowColumn.bind(this)
	        };
	    };
	    CsvSerializingSession.prototype.onNewBodyRowColumn = function (column, index, node) {
	        if (index != 0) {
	            this.result += this.columnSeparator;
	        }
	        this.result += this.putInQuotes(this.extractRowCellValue(column, index, constants_1.Constants.EXPORT_TYPE_CSV, node), this.suppressQuotes);
	        this.lineOpened = true;
	    };
	    CsvSerializingSession.prototype.putInQuotes = function (value, suppressQuotes) {
	        if (suppressQuotes) {
	            return value;
	        }
	        if (value === null || value === undefined) {
	            return '""';
	        }
	        var stringValue;
	        if (typeof value === 'string') {
	            stringValue = value;
	        }
	        else if (typeof value.toString === 'function') {
	            stringValue = value.toString();
	        }
	        else {
	            console.warn('unknown value type during csv conversion');
	            stringValue = '';
	        }
	        // replace each " with "" (ie two sets of double quotes is how to do double quotes in csv)
	        var valueEscaped = stringValue.replace(/"/g, "\"\"");
	        return '"' + valueEscaped + '"';
	    };
	    CsvSerializingSession.prototype.parse = function () {
	        return this.result;
	    };
	    return CsvSerializingSession;
	}(gridSerializer_1.BaseGridSerializingSession));
	exports.CsvSerializingSession = CsvSerializingSession;
	var BaseCreator = /** @class */ (function () {
	    function BaseCreator() {
	    }
	    BaseCreator.prototype.setBeans = function (beans) {
	        this.beans = beans;
	    };
	    BaseCreator.prototype.export = function (userParams) {
	        if (this.isExportSuppressed()) {
	            console.warn("ag-grid: Export cancelled. Export is not allowed as per your configuration.");
	            return '';
	        }
	        var _a = this.getMergedParamsAndData(userParams), mergedParams = _a.mergedParams, data = _a.data;
	        var fileNamePresent = mergedParams && mergedParams.fileName && mergedParams.fileName.length !== 0;
	        var fileName = fileNamePresent ? mergedParams.fileName : this.getDefaultFileName();
	        if (fileName.indexOf(".") === -1) {
	            fileName = fileName + "." + this.getDefaultFileExtension();
	        }
	        this.beans.downloader.download(fileName, this.packageFile(data));
	        return data;
	    };
	    BaseCreator.prototype.getData = function (params) {
	        return this.getMergedParamsAndData(params).data;
	    };
	    BaseCreator.prototype.getMergedParamsAndData = function (userParams) {
	        var mergedParams = this.mergeDefaultParams(userParams);
	        var data = this.beans.gridSerializer.serialize(this.createSerializingSession(mergedParams), mergedParams);
	        return { mergedParams: mergedParams, data: data };
	    };
	    BaseCreator.prototype.mergeDefaultParams = function (userParams) {
	        var baseParams = this.beans.gridOptionsWrapper.getDefaultExportParams();
	        var params = {};
	        utils_1._.assign(params, baseParams);
	        utils_1._.assign(params, userParams);
	        return params;
	    };
	    BaseCreator.prototype.packageFile = function (data) {
	        return new Blob(["\ufeff", data], {
	            type: window.navigator.msSaveOrOpenBlob ? this.getMimeType() : 'octet/stream'
	        });
	    };
	    return BaseCreator;
	}());
	exports.BaseCreator = BaseCreator;
	var CsvCreator = /** @class */ (function (_super) {
	    __extends(CsvCreator, _super);
	    function CsvCreator() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    CsvCreator.prototype.postConstruct = function () {
	        this.setBeans({
	            downloader: this.downloader,
	            gridSerializer: this.gridSerializer,
	            gridOptionsWrapper: this.gridOptionsWrapper
	        });
	    };
	    CsvCreator.prototype.exportDataAsCsv = function (params) {
	        return this.export(params);
	    };
	    CsvCreator.prototype.getDataAsCsv = function (params) {
	        return this.getData(params);
	    };
	    CsvCreator.prototype.getMimeType = function () {
	        return 'text/csv;charset=utf-8;';
	    };
	    CsvCreator.prototype.getDefaultFileName = function () {
	        return 'export.csv';
	    };
	    CsvCreator.prototype.getDefaultFileExtension = function () {
	        return 'csv';
	    };
	    CsvCreator.prototype.createSerializingSession = function (params) {
	        var _a = this, columnController = _a.columnController, valueService = _a.valueService, gridOptionsWrapper = _a.gridOptionsWrapper;
	        var _b = params, processCellCallback = _b.processCellCallback, processHeaderCallback = _b.processHeaderCallback, suppressQuotes = _b.suppressQuotes, columnSeparator = _b.columnSeparator;
	        return new CsvSerializingSession({
	            columnController: columnController,
	            valueService: valueService,
	            gridOptionsWrapper: gridOptionsWrapper,
	            processCellCallback: processCellCallback || undefined,
	            processHeaderCallback: processHeaderCallback || undefined,
	            suppressQuotes: suppressQuotes || false,
	            columnSeparator: columnSeparator || ','
	        });
	    };
	    CsvCreator.prototype.isExportSuppressed = function () {
	        return this.gridOptionsWrapper.isSuppressCsvExport();
	    };
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], CsvCreator.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('valueService'),
	        __metadata("design:type", valueService_1.ValueService)
	    ], CsvCreator.prototype, "valueService", void 0);
	    __decorate([
	        context_1.Autowired('downloader'),
	        __metadata("design:type", downloader_1.Downloader)
	    ], CsvCreator.prototype, "downloader", void 0);
	    __decorate([
	        context_1.Autowired('gridSerializer'),
	        __metadata("design:type", gridSerializer_1.GridSerializer)
	    ], CsvCreator.prototype, "gridSerializer", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], CsvCreator.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], CsvCreator.prototype, "postConstruct", null);
	    CsvCreator = __decorate([
	        context_1.Bean('csvCreator')
	    ], CsvCreator);
	    return CsvCreator;
	}(BaseCreator));
	exports.CsvCreator = CsvCreator;


/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var Downloader = /** @class */ (function () {
	    function Downloader() {
	    }
	    Downloader.prototype.download = function (fileName, content) {
	        // Internet Explorer
	        if (window.navigator.msSaveOrOpenBlob) {
	            window.navigator.msSaveOrOpenBlob(content, fileName);
	        }
	        else {
	            // Other Browsers
	            var element = document.createElement("a");
	            var url_1 = window.URL.createObjectURL(content);
	            element.setAttribute("href", url_1);
	            element.setAttribute("download", fileName);
	            element.style.display = "none";
	            document.body.appendChild(element);
	            element.dispatchEvent(new MouseEvent('click', {
	                bubbles: false,
	                cancelable: true,
	                view: window
	            }));
	            document.body.removeChild(element);
	            window.setTimeout(function () {
	                window.URL.revokeObjectURL(url_1);
	            }, 0);
	        }
	    };
	    Downloader = __decorate([
	        context_1.Bean("downloader")
	    ], Downloader);
	    return Downloader;
	}());
	exports.Downloader = Downloader;


/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var componentAnnotations_1 = __webpack_require__(39);
	var context_1 = __webpack_require__(8);
	var userComponentFactory_1 = __webpack_require__(81);
	var utils_1 = __webpack_require__(10);
	var dateCompWrapper_1 = __webpack_require__(647);
	var simpleFilter_1 = __webpack_require__(134);
	var scalerFilter_1 = __webpack_require__(426);
	var DateFilter = /** @class */ (function (_super) {
	    __extends(DateFilter, _super);
	    function DateFilter() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    DateFilter.prototype.mapRangeFromModel = function (filterModel) {
	        // unlike the other filters, we do two things here:
	        // 1) allow for different attribute names (same as done for other filters) (eg the 'from' and 'to'
	        //    are in different locations in Date and Number filter models)
	        // 2) convert the type (cos Date filter uses Dates, however model is 'string')
	        //
	        // NOTE: The conversion of string to date also removes the timezone - ie when user picks
	        //       a date form the UI, it will have timezone info in it. This is lost when creating
	        //       the model. Then when we recreate the date again here, it's without timezone.
	        return {
	            from: utils_1._.parseYyyyMmDdToDate(filterModel.dateFrom, "-"),
	            to: utils_1._.parseYyyyMmDdToDate(filterModel.dateTo, "-")
	        };
	    };
	    DateFilter.prototype.setValueFromFloatingFilter = function (value) {
	        if (value != null) {
	            var dateFrom = utils_1._.parseYyyyMmDdToDate(value, "-");
	            this.dateCompFrom1.setDate(dateFrom);
	        }
	        else {
	            this.dateCompFrom1.setDate(null);
	        }
	        this.dateCompTo1.setDate(null);
	        this.dateCompFrom2.setDate(null);
	        this.dateCompTo2.setDate(null);
	    };
	    DateFilter.prototype.setConditionIntoUi = function (model, position) {
	        var positionOne = position === simpleFilter_1.ConditionPosition.One;
	        var dateFromString = model ? model.dateFrom : null;
	        var dateToString = model ? model.dateTo : null;
	        var dateFrom = utils_1._.parseYyyyMmDdToDate(dateFromString, "-");
	        var dateTo = utils_1._.parseYyyyMmDdToDate(dateToString, "-");
	        var compFrom = positionOne ? this.dateCompFrom1 : this.dateCompFrom2;
	        var compTo = positionOne ? this.dateCompTo1 : this.dateCompTo2;
	        compFrom.setDate(dateFrom);
	        compTo.setDate(dateTo);
	    };
	    DateFilter.prototype.resetUiToDefaults = function () {
	        _super.prototype.resetUiToDefaults.call(this);
	        this.dateCompTo1.setDate(null);
	        this.dateCompTo2.setDate(null);
	        this.dateCompFrom1.setDate(null);
	        this.dateCompFrom2.setDate(null);
	    };
	    DateFilter.prototype.comparator = function () {
	        return this.dateFilterParams.comparator ? this.dateFilterParams.comparator : this.defaultComparator.bind(this);
	    };
	    DateFilter.prototype.defaultComparator = function (filterDate, cellValue) {
	        //The default comparator assumes that the cellValue is a date
	        var cellAsDate = cellValue;
	        if (cellAsDate < filterDate) {
	            return -1;
	        }
	        if (cellAsDate > filterDate) {
	            return 1;
	        }
	        return cellValue != null ? 0 : -1;
	    };
	    DateFilter.prototype.setParams = function (params) {
	        _super.prototype.setParams.call(this, params);
	        this.dateFilterParams = params;
	        this.createDateComponents();
	    };
	    DateFilter.prototype.createDateComponents = function () {
	        var _this = this;
	        // params to pass to all four date comps
	        var dateComponentParams = {
	            onDateChanged: function () { return _this.onUiChanged(); },
	            filterParams: this.dateFilterParams
	        };
	        this.dateCompFrom1 = new dateCompWrapper_1.DateCompWrapper(this.userComponentFactory, dateComponentParams, this.ePanelFrom1);
	        this.dateCompFrom2 = new dateCompWrapper_1.DateCompWrapper(this.userComponentFactory, dateComponentParams, this.ePanelFrom2);
	        this.dateCompTo1 = new dateCompWrapper_1.DateCompWrapper(this.userComponentFactory, dateComponentParams, this.ePanelTo1);
	        this.dateCompTo2 = new dateCompWrapper_1.DateCompWrapper(this.userComponentFactory, dateComponentParams, this.ePanelTo2);
	        this.addDestroyFunc(function () {
	            _this.dateCompFrom1.destroy();
	            _this.dateCompFrom2.destroy();
	            _this.dateCompTo1.destroy();
	            _this.dateCompTo2.destroy();
	        });
	    };
	    DateFilter.prototype.getDefaultFilterOptions = function () {
	        return DateFilter.DEFAULT_FILTER_OPTIONS;
	    };
	    DateFilter.prototype.createValueTemplate = function (position) {
	        var positionOne = position === simpleFilter_1.ConditionPosition.One;
	        var pos = positionOne ? '1' : '2';
	        return "<div class=\"ag-filter-body\" ref=\"eCondition" + pos + "Body\">\n                    <div class=\"ag-filter-date-from\" ref=\"ePanelFrom" + pos + "\">\n                    </div>\n                    <div class=\"ag-filter-date-to\" ref=\"ePanelTo" + pos + "\"\">\n                    </div>\n                </div>";
	    };
	    DateFilter.prototype.isConditionUiComplete = function (position) {
	        var positionOne = position === simpleFilter_1.ConditionPosition.One;
	        var option = positionOne ? this.getCondition1Type() : this.getCondition2Type();
	        var compFrom = positionOne ? this.dateCompFrom1 : this.dateCompFrom2;
	        var compTo = positionOne ? this.dateCompTo1 : this.dateCompTo2;
	        var valueFrom = compFrom.getDate();
	        var valueTo = compTo.getDate();
	        if (option === simpleFilter_1.SimpleFilter.EMPTY) {
	            return false;
	        }
	        if (this.doesFilterHaveHiddenInput(option)) {
	            return true;
	        }
	        if (option === simpleFilter_1.SimpleFilter.IN_RANGE) {
	            return valueFrom != null && valueTo != null;
	        }
	        else {
	            return valueFrom != null;
	        }
	    };
	    DateFilter.prototype.areSimpleModelsEqual = function (aSimple, bSimple) {
	        return aSimple.dateFrom === bSimple.dateFrom
	            && aSimple.dateTo === bSimple.dateTo
	            && aSimple.type === bSimple.type;
	    };
	    // needed for creating filter model
	    DateFilter.prototype.getFilterType = function () {
	        return DateFilter.FILTER_TYPE;
	    };
	    DateFilter.prototype.createCondition = function (position) {
	        var positionOne = position === simpleFilter_1.ConditionPosition.One;
	        var type = positionOne ? this.getCondition1Type() : this.getCondition2Type();
	        var dateCompTo = positionOne ? this.dateCompTo1 : this.dateCompTo2;
	        var dateCompFrom = positionOne ? this.dateCompFrom1 : this.dateCompFrom2;
	        return {
	            dateTo: utils_1._.serializeDateToYyyyMmDd(dateCompTo.getDate(), "-"),
	            dateFrom: utils_1._.serializeDateToYyyyMmDd(dateCompFrom.getDate(), "-"),
	            type: type,
	            filterType: DateFilter.FILTER_TYPE
	        };
	    };
	    DateFilter.prototype.updateUiVisibility = function () {
	        _super.prototype.updateUiVisibility.call(this);
	        var showFrom1 = this.showValueFrom(this.getCondition1Type());
	        utils_1._.setDisplayed(this.ePanelFrom1, showFrom1);
	        var showTo1 = this.showValueTo(this.getCondition1Type());
	        utils_1._.setDisplayed(this.ePanelTo1, showTo1);
	        var showFrom2 = this.showValueFrom(this.getCondition2Type());
	        utils_1._.setDisplayed(this.ePanelFrom2, showFrom2);
	        var showTo2 = this.showValueTo(this.getCondition2Type());
	        utils_1._.setDisplayed(this.ePanelTo2, showTo2);
	    };
	    DateFilter.FILTER_TYPE = 'date';
	    DateFilter.DEFAULT_FILTER_OPTIONS = [scalerFilter_1.ScalerFilter.EQUALS, scalerFilter_1.ScalerFilter.GREATER_THAN,
	        scalerFilter_1.ScalerFilter.LESS_THAN, scalerFilter_1.ScalerFilter.NOT_EQUAL, scalerFilter_1.ScalerFilter.IN_RANGE];
	    __decorate([
	        componentAnnotations_1.RefSelector('ePanelFrom1'),
	        __metadata("design:type", HTMLElement)
	    ], DateFilter.prototype, "ePanelFrom1", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('ePanelFrom2'),
	        __metadata("design:type", HTMLElement)
	    ], DateFilter.prototype, "ePanelFrom2", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('ePanelTo1'),
	        __metadata("design:type", HTMLElement)
	    ], DateFilter.prototype, "ePanelTo1", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('ePanelTo2'),
	        __metadata("design:type", HTMLElement)
	    ], DateFilter.prototype, "ePanelTo2", void 0);
	    __decorate([
	        context_1.Autowired('userComponentFactory'),
	        __metadata("design:type", userComponentFactory_1.UserComponentFactory)
	    ], DateFilter.prototype, "userComponentFactory", void 0);
	    return DateFilter;
	}(scalerFilter_1.ScalerFilter));
	exports.DateFilter = DateFilter;


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var componentAnnotations_1 = __webpack_require__(39);
	var utils_1 = __webpack_require__(10);
	var simpleFilter_1 = __webpack_require__(134);
	var scalerFilter_1 = __webpack_require__(426);
	var NumberFilter = /** @class */ (function (_super) {
	    __extends(NumberFilter, _super);
	    function NumberFilter() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    NumberFilter.prototype.mapRangeFromModel = function (filterModel) {
	        return {
	            from: filterModel.filter,
	            to: filterModel.filterTo
	        };
	    };
	    NumberFilter.prototype.getDefaultDebounceMs = function () {
	        return 500;
	    };
	    NumberFilter.prototype.resetUiToDefaults = function () {
	        _super.prototype.resetUiToDefaults.call(this);
	        this.eValueFrom1.value = null;
	        this.eValueFrom2.value = null;
	        this.eValueTo1.value = null;
	        this.eValueTo2.value = null;
	    };
	    NumberFilter.prototype.setConditionIntoUi = function (model, position) {
	        var positionOne = position === simpleFilter_1.ConditionPosition.One;
	        var eValueFrom = positionOne ? this.eValueFrom1 : this.eValueFrom2;
	        var eValueTo = positionOne ? this.eValueTo1 : this.eValueTo2;
	        eValueFrom.value = model ? ('' + model.filter) : null;
	        eValueTo.value = model ? ('' + model.filterTo) : null;
	    };
	    NumberFilter.prototype.setValueFromFloatingFilter = function (value) {
	        this.eValueFrom1.value = value;
	        this.eValueFrom2.value = null;
	        this.eValueTo1.value = null;
	        this.eValueTo2.value = null;
	    };
	    NumberFilter.prototype.comparator = function () {
	        return function (left, right) {
	            if (left === right) {
	                return 0;
	            }
	            if (left < right) {
	                return 1;
	            }
	            if (left > right) {
	                return -1;
	            }
	        };
	    };
	    NumberFilter.prototype.setParams = function (params) {
	        _super.prototype.setParams.call(this, params);
	        this.addValueChangedListeners();
	    };
	    NumberFilter.prototype.addValueChangedListeners = function () {
	        var _this = this;
	        var listener = function () { return _this.onUiChanged(); };
	        this.addDestroyableEventListener(this.eValueFrom1, 'input', listener);
	        this.addDestroyableEventListener(this.eValueFrom2, 'input', listener);
	        this.addDestroyableEventListener(this.eValueTo1, 'input', listener);
	        this.addDestroyableEventListener(this.eValueTo2, 'input', listener);
	    };
	    NumberFilter.prototype.afterGuiAttached = function () {
	        this.eValueFrom1.focus();
	    };
	    NumberFilter.prototype.getDefaultFilterOptions = function () {
	        return NumberFilter.DEFAULT_FILTER_OPTIONS;
	    };
	    NumberFilter.prototype.createValueTemplate = function (position) {
	        var positionOne = position === simpleFilter_1.ConditionPosition.One;
	        var pos = positionOne ? '1' : '2';
	        var translate = this.translate.bind(this);
	        return "<div class=\"ag-filter-body\" ref=\"eCondition" + pos + "Body\" role=\"presentation\">\n            <div class=\"ag-input-wrapper\" role=\"presentation\">\n                <input class=\"ag-filter-filter\" ref=\"eValueFrom" + pos + "\" type=\"text\" placeholder=\"" + translate('filterOoo') + "\"/>\n            </div>\n             <div class=\"ag-input-wrapper ag-filter-number-to\" ref=\"ePanel" + pos + "\" role=\"presentation\">\n                <input class=\"ag-filter-filter\" ref=\"eValueTo" + pos + "\" type=\"text\" placeholder=\"" + translate('filterOoo') + "\"/>\n            </div>\n        </div>";
	    };
	    NumberFilter.prototype.isConditionUiComplete = function (position) {
	        var positionOne = position === simpleFilter_1.ConditionPosition.One;
	        var option = positionOne ? this.getCondition1Type() : this.getCondition2Type();
	        var eValue = positionOne ? this.eValueFrom1 : this.eValueFrom2;
	        var eValueTo = positionOne ? this.eValueTo1 : this.eValueTo2;
	        var value = this.stringToFloat(eValue.value);
	        var valueTo = this.stringToFloat(eValueTo.value);
	        if (option === simpleFilter_1.SimpleFilter.EMPTY) {
	            return false;
	        }
	        if (this.doesFilterHaveHiddenInput(option)) {
	            return true;
	        }
	        if (option === simpleFilter_1.SimpleFilter.IN_RANGE) {
	            return value != null && valueTo != null;
	        }
	        else {
	            return value != null;
	        }
	    };
	    NumberFilter.prototype.areSimpleModelsEqual = function (aSimple, bSimple) {
	        return aSimple.filter === bSimple.filter
	            && aSimple.filterTo === bSimple.filterTo
	            && aSimple.type === bSimple.type;
	    };
	    // needed for creating filter model
	    NumberFilter.prototype.getFilterType = function () {
	        return NumberFilter.FILTER_TYPE;
	    };
	    NumberFilter.prototype.stringToFloat = function (value) {
	        var filterText = utils_1._.makeNull(value);
	        if (filterText && filterText.trim() === '') {
	            filterText = null;
	        }
	        var newFilter;
	        if (filterText !== null && filterText !== undefined) {
	            newFilter = parseFloat(filterText);
	        }
	        else {
	            newFilter = null;
	        }
	        return newFilter;
	    };
	    NumberFilter.prototype.createCondition = function (position) {
	        var positionOne = position === simpleFilter_1.ConditionPosition.One;
	        var type = positionOne ? this.getCondition1Type() : this.getCondition2Type();
	        var eValue = positionOne ? this.eValueFrom1 : this.eValueFrom2;
	        var value = this.stringToFloat(eValue.value);
	        var eValueTo = positionOne ? this.eValueTo1 : this.eValueTo2;
	        var valueTo = this.stringToFloat(eValueTo.value);
	        var model = {
	            filterType: NumberFilter.FILTER_TYPE,
	            type: type
	        };
	        if (!this.doesFilterHaveHiddenInput(type)) {
	            model.filter = value;
	            model.filterTo = valueTo; // FIX - should only populate this when filter choice has 'to' option
	        }
	        return model;
	    };
	    NumberFilter.prototype.updateUiVisibility = function () {
	        _super.prototype.updateUiVisibility.call(this);
	        var showFrom1 = this.showValueFrom(this.getCondition1Type());
	        utils_1._.setDisplayed(this.eValueFrom1, showFrom1);
	        var showTo1 = this.showValueTo(this.getCondition1Type());
	        utils_1._.setDisplayed(this.eValueTo1, showTo1);
	        var showFrom2 = this.showValueFrom(this.getCondition2Type());
	        utils_1._.setDisplayed(this.eValueFrom2, showFrom2);
	        var showTo2 = this.showValueTo(this.getCondition2Type());
	        utils_1._.setDisplayed(this.eValueTo2, showTo2);
	    };
	    NumberFilter.FILTER_TYPE = 'number';
	    NumberFilter.DEFAULT_FILTER_OPTIONS = [scalerFilter_1.ScalerFilter.EQUALS, scalerFilter_1.ScalerFilter.NOT_EQUAL,
	        scalerFilter_1.ScalerFilter.LESS_THAN, scalerFilter_1.ScalerFilter.LESS_THAN_OR_EQUAL,
	        scalerFilter_1.ScalerFilter.GREATER_THAN, scalerFilter_1.ScalerFilter.GREATER_THAN_OR_EQUAL,
	        scalerFilter_1.ScalerFilter.IN_RANGE];
	    __decorate([
	        componentAnnotations_1.RefSelector('eValueFrom1'),
	        __metadata("design:type", HTMLInputElement)
	    ], NumberFilter.prototype, "eValueFrom1", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eValueFrom2'),
	        __metadata("design:type", HTMLInputElement)
	    ], NumberFilter.prototype, "eValueFrom2", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eValueTo1'),
	        __metadata("design:type", HTMLInputElement)
	    ], NumberFilter.prototype, "eValueTo1", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eValueTo2'),
	        __metadata("design:type", HTMLInputElement)
	    ], NumberFilter.prototype, "eValueTo2", void 0);
	    return NumberFilter;
	}(scalerFilter_1.ScalerFilter));
	exports.NumberFilter = NumberFilter;


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var simpleFilter_1 = __webpack_require__(134);
	var ScalerFilter = /** @class */ (function (_super) {
	    __extends(ScalerFilter, _super);
	    function ScalerFilter() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ScalerFilter.prototype.setParams = function (params) {
	        _super.prototype.setParams.call(this, params);
	        this.scalarFilterParams = params;
	        this.checkDeprecatedParams();
	    };
	    ScalerFilter.prototype.checkDeprecatedParams = function () {
	        if (this.scalarFilterParams.nullComparator) {
	            console.warn('ag-Grid: Since v21.0, the property filterParams.nullComparator is deprecated. ' +
	                'Please use filterParams.includeBlanksInEquals, filterParams.includeBlanksInLessThan and ' +
	                'filterParams.includeBlanksInGreaterThan instead.');
	            this.scalarFilterParams.includeBlanksInEquals = this.scalarFilterParams.nullComparator.equals;
	            this.scalarFilterParams.includeBlanksInLessThan = this.scalarFilterParams.nullComparator.lessThan;
	            this.scalarFilterParams.includeBlanksInGreaterThan = this.scalarFilterParams.nullComparator.greaterThan;
	        }
	    };
	    ScalerFilter.prototype.nullComparator = function (selectedOption, filterValue, gridValue) {
	        if (gridValue == null) {
	            var nullValue = this.canNullsPassFilter(selectedOption);
	            if (selectedOption === ScalerFilter.EMPTY) {
	                return 0;
	            }
	            if (selectedOption === ScalerFilter.EQUALS) {
	                return nullValue ? 0 : 1;
	            }
	            if (selectedOption === ScalerFilter.GREATER_THAN) {
	                return nullValue ? 1 : -1;
	            }
	            if (selectedOption === ScalerFilter.GREATER_THAN_OR_EQUAL) {
	                return nullValue ? 1 : -1;
	            }
	            if (selectedOption === ScalerFilter.LESS_THAN_OR_EQUAL) {
	                return nullValue ? -1 : 1;
	            }
	            if (selectedOption === ScalerFilter.LESS_THAN) {
	                return nullValue ? -1 : 1;
	            }
	            if (selectedOption === ScalerFilter.NOT_EQUAL) {
	                return nullValue ? 1 : 0;
	            }
	        }
	        var actualComparator = this.comparator();
	        return actualComparator(filterValue, gridValue);
	    };
	    ScalerFilter.prototype.canNullsPassFilter = function (type) {
	        switch (type) {
	            case simpleFilter_1.SimpleFilter.GREATER_THAN:
	            case simpleFilter_1.SimpleFilter.GREATER_THAN_OR_EQUAL:
	                return this.scalarFilterParams.includeBlanksInGreaterThan;
	            case simpleFilter_1.SimpleFilter.LESS_THAN:
	            case simpleFilter_1.SimpleFilter.LESS_THAN_OR_EQUAL:
	                return this.scalarFilterParams.includeBlanksInLessThan;
	            case simpleFilter_1.SimpleFilter.EQUALS:
	                return this.scalarFilterParams.includeBlanksInEquals;
	        }
	    };
	    ScalerFilter.prototype.individualConditionPasses = function (params, filterModel) {
	        var cellValue = this.scalarFilterParams.valueGetter(params.node);
	        var range = this.mapRangeFromModel(filterModel);
	        var filterValue = range.from;
	        var filterValueTo = range.to;
	        var filterType = filterModel.type;
	        var customFilterOption = this.optionsFactory.getCustomOption(filterType);
	        if (customFilterOption) {
	            // only execute the custom filter if a value exists or a value isn't required, i.e. input is hidden
	            if (filterValue != null || customFilterOption.hideFilterInput) {
	                return customFilterOption.test(filterValue, cellValue);
	            }
	        }
	        // why this? looks like logic that should be in parent class????
	        // if (filterValue == null) {
	        //     return type === FilterConditionType.MAIN ? true : this.conditionValue === 'AND';
	        // }
	        var compareResult = this.nullComparator(filterType, filterValue, cellValue);
	        if (filterType === ScalerFilter.EQUALS) {
	            return compareResult === 0;
	        }
	        if (filterType === ScalerFilter.GREATER_THAN) {
	            return compareResult > 0;
	        }
	        if (filterType === ScalerFilter.GREATER_THAN_OR_EQUAL) {
	            return compareResult >= 0;
	        }
	        if (filterType === ScalerFilter.LESS_THAN_OR_EQUAL) {
	            return compareResult <= 0;
	        }
	        if (filterType === ScalerFilter.LESS_THAN) {
	            return compareResult < 0;
	        }
	        if (filterType === ScalerFilter.NOT_EQUAL) {
	            return compareResult != 0;
	        }
	        // From now on the type is a range and rawFilterValues must be an array!
	        var compareToResult = this.nullComparator(filterType, filterValueTo, cellValue);
	        if (filterType === ScalerFilter.IN_RANGE) {
	            if (!this.scalarFilterParams.inRangeInclusive) {
	                return compareResult > 0 && compareToResult < 0;
	            }
	            else {
	                return compareResult >= 0 && compareToResult <= 0;
	            }
	        }
	        throw new Error('Unexpected type of filter: ' + filterType);
	    };
	    ScalerFilter.DEFAULT_NULL_COMPARATOR = {
	        equals: false,
	        lessThan: false,
	        greaterThan: false
	    };
	    return ScalerFilter;
	}(simpleFilter_1.SimpleFilter));
	exports.ScalerFilter = ScalerFilter;


/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var componentAnnotations_1 = __webpack_require__(39);
	var utils_1 = __webpack_require__(10);
	var simpleFilter_1 = __webpack_require__(134);
	var TextFilter = /** @class */ (function (_super) {
	    __extends(TextFilter, _super);
	    function TextFilter() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TextFilter.prototype.getDefaultDebounceMs = function () {
	        return 500;
	    };
	    TextFilter.prototype.getValue = function (element) {
	        var val = element.value;
	        val = utils_1._.makeNull(val);
	        if (val && val.trim() === '') {
	            val = null;
	        }
	        return val;
	    };
	    TextFilter.prototype.addValueChangedListeners = function () {
	        var _this = this;
	        var listener = function () { return _this.onUiChanged(); };
	        this.addDestroyableEventListener(this.eValue1, 'input', listener);
	        this.addDestroyableEventListener(this.eValue2, 'input', listener);
	    };
	    TextFilter.prototype.setParams = function (params) {
	        _super.prototype.setParams.call(this, params);
	        this.textFilterParams = params;
	        this.comparator = this.textFilterParams.textCustomComparator ? this.textFilterParams.textCustomComparator : TextFilter.DEFAULT_COMPARATOR;
	        this.formatter =
	            this.textFilterParams.textFormatter ? this.textFilterParams.textFormatter :
	                this.textFilterParams.caseSensitive == true ? TextFilter.DEFAULT_FORMATTER :
	                    TextFilter.DEFAULT_LOWERCASE_FORMATTER;
	        this.addValueChangedListeners();
	    };
	    TextFilter.prototype.setConditionIntoUi = function (model, position) {
	        var positionOne = position === simpleFilter_1.ConditionPosition.One;
	        var eValue = positionOne ? this.eValue1 : this.eValue2;
	        eValue.value = model ? model.filter : null;
	    };
	    TextFilter.prototype.createCondition = function (position) {
	        var positionOne = position === simpleFilter_1.ConditionPosition.One;
	        var type = positionOne ? this.getCondition1Type() : this.getCondition2Type();
	        var eValue = positionOne ? this.eValue1 : this.eValue2;
	        var value = this.getValue(eValue);
	        var model = {
	            filterType: TextFilter.FILTER_TYPE,
	            type: type
	        };
	        if (!this.doesFilterHaveHiddenInput(type)) {
	            model.filter = value;
	        }
	        return model;
	    };
	    TextFilter.prototype.getFilterType = function () {
	        return TextFilter.FILTER_TYPE;
	    };
	    TextFilter.prototype.areSimpleModelsEqual = function (aSimple, bSimple) {
	        return aSimple.filter === bSimple.filter && aSimple.type === bSimple.type;
	    };
	    TextFilter.prototype.resetUiToDefaults = function () {
	        _super.prototype.resetUiToDefaults.call(this);
	        this.eValue1.value = null;
	        this.eValue2.value = null;
	    };
	    TextFilter.prototype.setValueFromFloatingFilter = function (value) {
	        this.eValue1.value = value;
	        this.eValue2.value = null;
	    };
	    TextFilter.prototype.getDefaultFilterOptions = function () {
	        return TextFilter.DEFAULT_FILTER_OPTIONS;
	    };
	    TextFilter.prototype.createValueTemplate = function (position) {
	        var pos = position === simpleFilter_1.ConditionPosition.One ? '1' : '2';
	        var translate = this.gridOptionsWrapper.getLocaleTextFunc();
	        return "<div class=\"ag-filter-body\" ref=\"eCondition" + pos + "Body\" role=\"presentation\">\n            <div class=\"ag-input-wrapper\" ref=\"eInputWrapper" + pos + "\" role=\"presentation\">\n                <input class=\"ag-filter-filter\" ref=\"eValue" + pos + "\" type=\"text\" placeholder=\"" + translate('filterOoo', 'Filter...') + "\"/>\n            </div>\n        </div>";
	    };
	    TextFilter.prototype.updateUiVisibility = function () {
	        _super.prototype.updateUiVisibility.call(this);
	        var showValue1 = this.showValueFrom(this.getCondition1Type());
	        utils_1._.setDisplayed(this.eInputWrapper1, showValue1);
	        var showValue2 = this.showValueFrom(this.getCondition2Type());
	        utils_1._.setDisplayed(this.eInputWrapper2, showValue2);
	    };
	    TextFilter.prototype.afterGuiAttached = function () {
	        this.eValue1.focus();
	    };
	    TextFilter.prototype.isConditionUiComplete = function (position) {
	        var positionOne = position === simpleFilter_1.ConditionPosition.One;
	        var option = positionOne ? this.getCondition1Type() : this.getCondition2Type();
	        var eFilterValue = positionOne ? this.eValue1 : this.eValue2;
	        if (option === simpleFilter_1.SimpleFilter.EMPTY) {
	            return false;
	        }
	        var value = this.getValue(eFilterValue);
	        if (this.doesFilterHaveHiddenInput(option)) {
	            return true;
	        }
	        return value != null;
	    };
	    TextFilter.prototype.individualConditionPasses = function (params, filterModel) {
	        var filterText = filterModel.filter;
	        var filterOption = filterModel.type;
	        var cellValue = this.textFilterParams.valueGetter(params.node);
	        var cellValueFormatted = this.formatter(cellValue);
	        var customFilterOption = this.optionsFactory.getCustomOption(filterOption);
	        if (customFilterOption) {
	            // only execute the custom filter if a value exists or a value isn't required, i.e. input is hidden
	            if (filterText != null || customFilterOption.hideFilterInput) {
	                return customFilterOption.test(filterText, cellValueFormatted);
	            }
	        }
	        if (cellValue == null) {
	            return filterOption === simpleFilter_1.SimpleFilter.NOT_EQUAL || filterOption === simpleFilter_1.SimpleFilter.NOT_CONTAINS;
	        }
	        var filterTextFormatted = this.formatter(filterText);
	        return this.comparator(filterOption, cellValueFormatted, filterTextFormatted);
	    };
	    TextFilter.FILTER_TYPE = 'text';
	    TextFilter.DEFAULT_FILTER_OPTIONS = [simpleFilter_1.SimpleFilter.CONTAINS, simpleFilter_1.SimpleFilter.NOT_CONTAINS,
	        simpleFilter_1.SimpleFilter.EQUALS, simpleFilter_1.SimpleFilter.NOT_EQUAL,
	        simpleFilter_1.SimpleFilter.STARTS_WITH, simpleFilter_1.SimpleFilter.ENDS_WITH];
	    TextFilter.DEFAULT_FORMATTER = function (from) {
	        return from;
	    };
	    TextFilter.DEFAULT_LOWERCASE_FORMATTER = function (from) {
	        if (from == null) {
	            return null;
	        }
	        return from.toString().toLowerCase();
	    };
	    TextFilter.DEFAULT_COMPARATOR = function (filter, value, filterText) {
	        switch (filter) {
	            case TextFilter.CONTAINS:
	                return value.indexOf(filterText) >= 0;
	            case TextFilter.NOT_CONTAINS:
	                return value.indexOf(filterText) === -1;
	            case TextFilter.EQUALS:
	                return value === filterText;
	            case TextFilter.NOT_EQUAL:
	                return value != filterText;
	            case TextFilter.STARTS_WITH:
	                return value.indexOf(filterText) === 0;
	            case TextFilter.ENDS_WITH:
	                var index = value.lastIndexOf(filterText);
	                return index >= 0 && index === (value.length - filterText.length);
	            default:
	                // should never happen
	                console.warn('invalid filter type ' + filter);
	                return false;
	        }
	    };
	    __decorate([
	        componentAnnotations_1.RefSelector('eValue1'),
	        __metadata("design:type", HTMLInputElement)
	    ], TextFilter.prototype, "eValue1", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eValue2'),
	        __metadata("design:type", HTMLInputElement)
	    ], TextFilter.prototype, "eValue2", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eInputWrapper1'),
	        __metadata("design:type", HTMLElement)
	    ], TextFilter.prototype, "eInputWrapper1", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eInputWrapper2'),
	        __metadata("design:type", HTMLElement)
	    ], TextFilter.prototype, "eInputWrapper2", void 0);
	    return TextFilter;
	}(simpleFilter_1.SimpleFilter));
	exports.TextFilter = TextFilter;


/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var selectionController_1 = __webpack_require__(102);
	var columnApi_1 = __webpack_require__(38);
	var columnController_1 = __webpack_require__(26);
	var rowRenderer_1 = __webpack_require__(91);
	var headerRootComp_1 = __webpack_require__(431);
	var filterManager_1 = __webpack_require__(77);
	var valueService_1 = __webpack_require__(103);
	var eventService_1 = __webpack_require__(22);
	var gridPanel_1 = __webpack_require__(429);
	var gridApi_1 = __webpack_require__(33);
	var columnFactory_1 = __webpack_require__(246);
	var displayedGroupCreator_1 = __webpack_require__(314);
	var expressionService_1 = __webpack_require__(121);
	var templateService_1 = __webpack_require__(445);
	var popupService_1 = __webpack_require__(137);
	var logger_1 = __webpack_require__(68);
	var columnUtils_1 = __webpack_require__(195);
	var autoWidthCalculator_1 = __webpack_require__(250);
	var horizontalResizeService_1 = __webpack_require__(318);
	var context_1 = __webpack_require__(8);
	var csvCreator_1 = __webpack_require__(422);
	var gridCore_1 = __webpack_require__(649);
	var standardMenu_1 = __webpack_require__(657);
	var dragAndDropService_1 = __webpack_require__(82);
	var dragService_1 = __webpack_require__(158);
	var sortController_1 = __webpack_require__(120);
	var focusedCellController_1 = __webpack_require__(119);
	var mouseEventService_1 = __webpack_require__(248);
	var cellNavigationService_1 = __webpack_require__(415);
	var filterStage_1 = __webpack_require__(668);
	var sortStage_1 = __webpack_require__(671);
	var flattenStage_1 = __webpack_require__(669);
	var events_1 = __webpack_require__(29);
	var infiniteRowModel_1 = __webpack_require__(672);
	var clientSideRowModel_1 = __webpack_require__(667);
	var cellRendererFactory_1 = __webpack_require__(320);
	var valueFormatterService_1 = __webpack_require__(253);
	var agCheckbox_1 = __webpack_require__(199);
	var agRadioButton_1 = __webpack_require__(450);
	var vanillaFrameworkOverrides_1 = __webpack_require__(676);
	var scrollVisibleService_1 = __webpack_require__(249);
	var downloader_1 = __webpack_require__(423);
	var xmlFactory_1 = __webpack_require__(644);
	var gridSerializer_1 = __webpack_require__(316);
	var stylingService_1 = __webpack_require__(444);
	var columnHoverService_1 = __webpack_require__(252);
	var columnAnimationService_1 = __webpack_require__(321);
	var sortService_1 = __webpack_require__(675);
	var filterService_1 = __webpack_require__(674);
	var autoGroupColService_1 = __webpack_require__(639);
	var paginationProxy_1 = __webpack_require__(135);
	var paginationAutoPageSizeService_1 = __webpack_require__(673);
	var immutableService_1 = __webpack_require__(670);
	var constants_1 = __webpack_require__(30);
	var valueCache_1 = __webpack_require__(198);
	var changeDetectionService_1 = __webpack_require__(1414);
	var alignedGridsService_1 = __webpack_require__(313);
	var pinnedRowModel_1 = __webpack_require__(136);
	var userComponentFactory_1 = __webpack_require__(81);
	var userComponentRegistry_1 = __webpack_require__(420);
	var agComponentUtils_1 = __webpack_require__(418);
	var componentMetadataProvider_1 = __webpack_require__(419);
	var beans_1 = __webpack_require__(161);
	var environment_1 = __webpack_require__(247);
	var animationFrameService_1 = __webpack_require__(197);
	var navigationService_1 = __webpack_require__(650);
	var maxDivHeightScaler_1 = __webpack_require__(323);
	var selectableService_1 = __webpack_require__(443);
	var autoHeightCalculator_1 = __webpack_require__(433);
	var paginationComp_1 = __webpack_require__(1409);
	var resizeObserverService_1 = __webpack_require__(319);
	var zipContainer_1 = __webpack_require__(643);
	var tooltipManager_1 = __webpack_require__(451);
	var overlayWrapperComponent_1 = __webpack_require__(664);
	var agGroupComponent_1 = __webpack_require__(679);
	var agDialog_1 = __webpack_require__(326);
	var agPanel_1 = __webpack_require__(449);
	var agInputTextField_1 = __webpack_require__(448);
	var agInputTextArea_1 = __webpack_require__(680);
	var agSlider_1 = __webpack_require__(682);
	var utils_1 = __webpack_require__(10);
	var agColorPicker_1 = __webpack_require__(678);
	var agInputNumberField_1 = __webpack_require__(327);
	var agInputRange_1 = __webpack_require__(447);
	var agSelect_1 = __webpack_require__(681);
	var agAngleSelect_1 = __webpack_require__(677);
	var agToggleButton_1 = __webpack_require__(683);
	var detailRowCompCache_1 = __webpack_require__(663);
	var rowPosition_1 = __webpack_require__(315);
	var cellPosition_1 = __webpack_require__(421);
	var Grid = /** @class */ (function () {
	    function Grid(eGridDiv, gridOptions, params) {
	        if (!eGridDiv) {
	            console.error('ag-Grid: no div element provided to the grid');
	        }
	        if (!gridOptions) {
	            console.error('ag-Grid: no gridOptions provided to the grid');
	        }
	        this.gridOptions = gridOptions;
	        var rowModelClass = this.getRowModelClass(gridOptions);
	        var enterprise = !utils_1._.missingOrEmpty(Grid.enterpriseBeans);
	        var moduleBeans = this.extractModuleEntity(Grid.modulesToInclude, function (module) { return module.beans ? module.beans : []; });
	        var moduleEnterpriseBeans = this.extractModuleEntity(Grid.modulesToInclude, function (module) { return module.enterpriseBeans ? module.enterpriseBeans : []; });
	        var moduleEnterpriseComponents = this.extractModuleEntity(Grid.modulesToInclude, function (module) { return module.enterpriseComponents ? module.enterpriseComponents : []; });
	        var modulesEnterpriseDefaultComponents = this.extractModuleEntity(Grid.modulesToInclude, function (module) { return module.enterpriseDefaultComponents ? module.enterpriseDefaultComponents : []; });
	        var frameworkOverrides = params ? params.frameworkOverrides : null;
	        if (utils_1._.missing(frameworkOverrides)) {
	            frameworkOverrides = new vanillaFrameworkOverrides_1.VanillaFrameworkOverrides();
	        }
	        var overrideBeans = [];
	        if (Grid.enterpriseBeans) {
	            overrideBeans = overrideBeans.concat(Grid.enterpriseBeans)
	                .concat(moduleEnterpriseBeans);
	        }
	        if (Grid.frameworkBeans) {
	            overrideBeans = overrideBeans.concat(Grid.frameworkBeans);
	        }
	        var seed = {
	            enterprise: enterprise,
	            gridOptions: gridOptions,
	            eGridDiv: eGridDiv,
	            $scope: params ? params.$scope : null,
	            $compile: params ? params.$compile : null,
	            quickFilterOnScope: params ? params.quickFilterOnScope : null,
	            globalEventListener: params ? params.globalEventListener : null,
	            frameworkOverrides: frameworkOverrides
	        };
	        if (params && params.seedBeanInstances) {
	            utils_1._.assign(seed, params.seedBeanInstances);
	        }
	        var components = [
	            { componentName: 'AgCheckbox', theClass: agCheckbox_1.AgCheckbox },
	            { componentName: 'AgRadioButton', theClass: agRadioButton_1.AgRadioButton },
	            { componentName: 'AgToggleButton', theClass: agToggleButton_1.AgToggleButton },
	            { componentName: 'AgInputTextField', theClass: agInputTextField_1.AgInputTextField },
	            { componentName: 'AgInputTextArea', theClass: agInputTextArea_1.AgInputTextArea },
	            { componentName: 'AgInputNumberField', theClass: agInputNumberField_1.AgInputNumberField },
	            { componentName: 'AgInputRange', theClass: agInputRange_1.AgInputRange },
	            { componentName: 'AgSelect', theClass: agSelect_1.AgSelect },
	            { componentName: 'AgSlider', theClass: agSlider_1.AgSlider },
	            { componentName: 'AgAngleSelect', theClass: agAngleSelect_1.AgAngleSelect },
	            { componentName: 'AgColorPicker', theClass: agColorPicker_1.AgColorPicker },
	            { componentName: 'AgGridComp', theClass: gridPanel_1.GridPanel },
	            { componentName: 'AgHeaderRoot', theClass: headerRootComp_1.HeaderRootComp },
	            { componentName: 'AgPagination', theClass: paginationComp_1.PaginationComp },
	            { componentName: 'AgOverlayWrapper', theClass: overlayWrapperComponent_1.OverlayWrapperComponent },
	            { componentName: 'AgGroupComponent', theClass: agGroupComponent_1.AgGroupComponent },
	            { componentName: 'AgPanel', theClass: agPanel_1.AgPanel },
	            { componentName: 'AgDialog', theClass: agDialog_1.AgDialog }
	        ];
	        if (Grid.enterpriseComponents) {
	            components = components.concat(Grid.enterpriseComponents)
	                .concat(moduleEnterpriseComponents);
	        }
	        var contextParams = {
	            overrideBeans: overrideBeans,
	            seed: seed,
	            //Careful with the order of the beans here, there are dependencies between them that need to be kept
	            beans: [
	                // this should only contain SERVICES, it should NEVER contain COMPONENTS
	                rowModelClass, beans_1.Beans, rowPosition_1.RowPositionUtils, cellPosition_1.CellPositionUtils,
	                paginationAutoPageSizeService_1.PaginationAutoPageSizeService, gridApi_1.GridApi, userComponentRegistry_1.UserComponentRegistry, agComponentUtils_1.AgComponentUtils,
	                componentMetadataProvider_1.ComponentMetadataProvider, resizeObserverService_1.ResizeObserverService, userComponentRegistry_1.UserComponentRegistry, userComponentFactory_1.UserComponentFactory,
	                maxDivHeightScaler_1.MaxDivHeightScaler, autoHeightCalculator_1.AutoHeightCalculator, cellRendererFactory_1.CellRendererFactory, horizontalResizeService_1.HorizontalResizeService,
	                pinnedRowModel_1.PinnedRowModel, dragService_1.DragService, displayedGroupCreator_1.DisplayedGroupCreator, eventService_1.EventService, gridOptionsWrapper_1.GridOptionsWrapper, popupService_1.PopupService,
	                selectionController_1.SelectionController, filterManager_1.FilterManager, columnController_1.ColumnController, paginationProxy_1.PaginationProxy, rowRenderer_1.RowRenderer, expressionService_1.ExpressionService,
	                columnFactory_1.ColumnFactory, csvCreator_1.CsvCreator, downloader_1.Downloader, xmlFactory_1.XmlFactory, gridSerializer_1.GridSerializer, templateService_1.TemplateService, alignedGridsService_1.AlignedGridsService,
	                navigationService_1.NavigationService, popupService_1.PopupService, valueCache_1.ValueCache, valueService_1.ValueService, logger_1.LoggerFactory, columnUtils_1.ColumnUtils, autoWidthCalculator_1.AutoWidthCalculator,
	                standardMenu_1.StandardMenuFactory, dragAndDropService_1.DragAndDropService, columnApi_1.ColumnApi, focusedCellController_1.FocusedCellController, mouseEventService_1.MouseEventService, environment_1.Environment,
	                cellNavigationService_1.CellNavigationService, filterStage_1.FilterStage, sortStage_1.SortStage, flattenStage_1.FlattenStage, filterService_1.FilterService,
	                valueFormatterService_1.ValueFormatterService, stylingService_1.StylingService, scrollVisibleService_1.ScrollVisibleService, sortController_1.SortController,
	                columnHoverService_1.ColumnHoverService, columnAnimationService_1.ColumnAnimationService, sortService_1.SortService, selectableService_1.SelectableService, autoGroupColService_1.AutoGroupColService,
	                immutableService_1.ImmutableService, changeDetectionService_1.ChangeDetectionService, animationFrameService_1.AnimationFrameService, tooltipManager_1.TooltipManager, zipContainer_1.ZipContainer,
	                detailRowCompCache_1.DetailRowCompCache
	            ].concat(moduleBeans),
	            components: components,
	            enterpriseDefaultComponents: Grid.enterpriseDefaultComponents.concat(modulesEnterpriseDefaultComponents),
	            registeredModules: Grid.modulesToInclude.map(function (module) { return module.moduleName; }),
	            debug: !!gridOptions.debug
	        };
	        this.logger = new logger_1.Logger('ag-Grid', function () { return gridOptions.debug; });
	        var contextLogger = new logger_1.Logger('Context', function () { return contextParams.debug; });
	        this.context = new context_1.Context(contextParams, contextLogger);
	        var gridCore = new gridCore_1.GridCore();
	        this.context.wireBean(gridCore);
	        this.setColumnsAndData();
	        this.dispatchGridReadyEvent(gridOptions);
	        this.logger.log("initialised successfully, enterprise = " + enterprise);
	    }
	    Grid.setEnterpriseBeans = function (enterpriseBeans, rowModelClasses) {
	        Grid.enterpriseBeans = enterpriseBeans;
	        // the enterprise can inject additional row models. this is how it injects the viewportRowModel
	        utils_1._.iterateObject(rowModelClasses, function (key, value) { return Grid.RowModelClasses[key] = value; });
	    };
	    Grid.setEnterpriseComponents = function (components) {
	        Grid.enterpriseComponents = components;
	    };
	    Grid.setFrameworkBeans = function (frameworkBeans) {
	        Grid.frameworkBeans = frameworkBeans;
	    };
	    Grid.setEnterpriseDefaultComponents = function (enterpriseDefaultComponents) {
	        Grid.enterpriseDefaultComponents = enterpriseDefaultComponents;
	    };
	    Grid.addModule = function (modulesToInclude) {
	        var _a;
	        // de-duping would need to be done here (while ensuring order etc)
	        (_a = Grid.modulesToInclude).push.apply(_a, modulesToInclude);
	    };
	    Grid.prototype.extractModuleEntity = function (moduleEntities, extractor) {
	        return [].concat.apply([], moduleEntities.map(extractor));
	    };
	    Grid.prototype.setColumnsAndData = function () {
	        var gridOptionsWrapper = this.context.getBean('gridOptionsWrapper');
	        var columnController = this.context.getBean('columnController');
	        var rowModel = this.context.getBean('rowModel');
	        var columnDefs = gridOptionsWrapper.getColumnDefs();
	        var rowData = gridOptionsWrapper.getRowData();
	        var nothingToSet = utils_1._.missing(columnDefs) && utils_1._.missing(rowData);
	        if (nothingToSet) {
	            return;
	        }
	        if (utils_1._.exists(columnDefs)) {
	            columnController.setColumnDefs(columnDefs, "gridInitializing");
	        }
	        if (utils_1._.exists(rowData) && rowModel.getType() === constants_1.Constants.ROW_MODEL_TYPE_CLIENT_SIDE) {
	            var clientSideRowModel = rowModel;
	            clientSideRowModel.setRowData(rowData);
	        }
	    };
	    Grid.prototype.dispatchGridReadyEvent = function (gridOptions) {
	        var eventService = this.context.getBean('eventService');
	        var readyEvent = {
	            type: events_1.Events.EVENT_GRID_READY,
	            api: gridOptions.api,
	            columnApi: gridOptions.columnApi
	        };
	        eventService.dispatchEvent(readyEvent);
	    };
	    Grid.prototype.getRowModelClass = function (gridOptions) {
	        var rowModelType = gridOptions.rowModelType;
	        //TODO: temporary measure before 'enterprise' is completely removed (similar handling in gridOptionsWrapper is also required)
	        rowModelType = rowModelType === 'enterprise' ? constants_1.Constants.ROW_MODEL_TYPE_SERVER_SIDE : rowModelType;
	        if (utils_1._.exists(rowModelType)) {
	            var rowModelClass = Grid.RowModelClasses[rowModelType];
	            if (utils_1._.exists(rowModelClass)) {
	                return rowModelClass;
	            }
	            else {
	                if (rowModelType === 'normal') {
	                    console.warn("ag-Grid: normal rowModel deprecated. Should now be called client side row model instead.");
	                    return clientSideRowModel_1.ClientSideRowModel;
	                }
	                console.error('ag-Grid: could not find matching row model for rowModelType ' + rowModelType);
	                if (rowModelType === constants_1.Constants.ROW_MODEL_TYPE_VIEWPORT) {
	                    console.error('ag-Grid: rowModelType viewport is only available in ag-Grid Enterprise');
	                }
	                if (rowModelType === constants_1.Constants.ROW_MODEL_TYPE_SERVER_SIDE) {
	                    console.error('ag-Grid: rowModelType server side is only available in ag-Grid Enterprise');
	                }
	            }
	        }
	        return clientSideRowModel_1.ClientSideRowModel;
	    };
	    Grid.prototype.destroy = function () {
	        this.gridOptions.api.destroy();
	    };
	    Grid.enterpriseBeans = [];
	    Grid.enterpriseComponents = [];
	    Grid.enterpriseDefaultComponents = [];
	    Grid.modulesToInclude = [];
	    // the default is ClientSideRowModel, which is also used for pagination.
	    // the enterprise adds viewport to this list.
	    Grid.RowModelClasses = {
	        infinite: infiniteRowModel_1.InfiniteRowModel,
	        clientSide: clientSideRowModel_1.ClientSideRowModel
	    };
	    return Grid;
	}());
	exports.Grid = Grid;


/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var columnController_1 = __webpack_require__(26);
	var columnApi_1 = __webpack_require__(38);
	var rowRenderer_1 = __webpack_require__(91);
	var context_1 = __webpack_require__(8);
	var eventService_1 = __webpack_require__(22);
	var events_1 = __webpack_require__(29);
	var dragService_1 = __webpack_require__(158);
	var constants_1 = __webpack_require__(30);
	var mouseEventService_1 = __webpack_require__(248);
	var focusedCellController_1 = __webpack_require__(119);
	var scrollVisibleService_1 = __webpack_require__(249);
	var rowContainerComponent_1 = __webpack_require__(1404);
	var paginationProxy_1 = __webpack_require__(135);
	var paginationAutoPageSizeService_1 = __webpack_require__(673);
	var popupEditorWrapper_1 = __webpack_require__(434);
	var alignedGridsService_1 = __webpack_require__(313);
	var pinnedRowModel_1 = __webpack_require__(136);
	var gridApi_1 = __webpack_require__(33);
	var animationFrameService_1 = __webpack_require__(197);
	var rowComp_1 = __webpack_require__(441);
	var navigationService_1 = __webpack_require__(650);
	var valueService_1 = __webpack_require__(103);
	var touchListener_1 = __webpack_require__(255);
	var dragAndDropService_1 = __webpack_require__(82);
	var rowDragFeature_1 = __webpack_require__(1391);
	var maxDivHeightScaler_1 = __webpack_require__(323);
	var overlayWrapperComponent_1 = __webpack_require__(664);
	var component_1 = __webpack_require__(31);
	var autoHeightCalculator_1 = __webpack_require__(433);
	var columnAnimationService_1 = __webpack_require__(321);
	var autoWidthCalculator_1 = __webpack_require__(250);
	var beans_1 = __webpack_require__(161);
	var componentAnnotations_1 = __webpack_require__(39);
	var headerRootComp_1 = __webpack_require__(431);
	var resizeObserverService_1 = __webpack_require__(319);
	var utils_1 = __webpack_require__(10);
	// in the html below, it is important that there are no white space between some of the divs, as if there is white space,
	// it won't render correctly in safari, as safari renders white space as a gap
	var GRID_PANEL_NORMAL_TEMPLATE = "<div class=\"ag-root ag-unselectable\" role=\"grid\" unselectable=\"on\">\n        <ag-header-root ref=\"headerRoot\" unselectable=\"on\"></ag-header-root>\n        <div class=\"ag-floating-top\" ref=\"eTop\" role=\"presentation\" unselectable=\"on\">\n            <div class=\"ag-pinned-left-floating-top\" ref=\"eLeftTop\" role=\"presentation\" unselectable=\"on\"></div>\n            <div class=\"ag-floating-top-viewport\" ref=\"eTopViewport\" role=\"presentation\" unselectable=\"on\">\n                <div class=\"ag-floating-top-container\" ref=\"eTopContainer\" role=\"presentation\" unselectable=\"on\"></div>\n            </div>\n            <div class=\"ag-pinned-right-floating-top\" ref=\"eRightTop\" role=\"presentation\" unselectable=\"on\"></div>\n            <div class=\"ag-floating-top-full-width-container\" ref=\"eTopFullWidthContainer\" role=\"presentation\" unselectable=\"on\"></div>\n        </div>\n        <div class=\"ag-body-viewport\" ref=\"eBodyViewport\" role=\"presentation\" unselectable=\"on\">\n            <div class=\"ag-pinned-left-cols-container\" ref=\"eLeftContainer\" role=\"presentation\" unselectable=\"on\"></div>\n            <div class=\"ag-center-cols-clipper\" ref=\"eCenterColsClipper\" role=\"presentation\" unselectable=\"on\">\n                <div class=\"ag-center-cols-viewport\" ref=\"eCenterViewport\" role=\"presentation\" unselectable=\"on\">\n                    <div class=\"ag-center-cols-container\" ref=\"eCenterContainer\" role=\"rowgroup\" unselectable=\"on\"></div>\n                </div>\n            </div>\n            <div class=\"ag-pinned-right-cols-container\" ref=\"eRightContainer\" role=\"presentation\" unselectable=\"on\"></div>\n            <div class=\"ag-full-width-container\" ref=\"eFullWidthContainer\" role=\"presentation\" unselectable=\"on\"></div>\n        </div>\n        <div class=\"ag-floating-bottom\" ref=\"eBottom\" role=\"presentation\" unselectable=\"on\">\n            <div class=\"ag-pinned-left-floating-bottom\" ref=\"eLeftBottom\" role=\"presentation\" unselectable=\"on\"></div>\n            <div class=\"ag-floating-bottom-viewport\" ref=\"eBottomViewport\" role=\"presentation\" unselectable=\"on\">\n                <div class=\"ag-floating-bottom-container\" ref=\"eBottomContainer\" role=\"presentation\" unselectable=\"on\"></div>\n            </div>\n            <div class=\"ag-pinned-right-floating-bottom\" ref=\"eRightBottom\" role=\"presentation\" unselectable=\"on\"></div>\n            <div class=\"ag-floating-bottom-full-width-container\" ref=\"eBottomFullWidthContainer\" role=\"presentation\" unselectable=\"on\"></div>\n        </div>\n        <div class=\"ag-body-horizontal-scroll\" ref=\"eHorizontalScrollBody\" aria-hidden=\"true\">\n            <div class=\"ag-horizontal-left-spacer\" ref=\"eHorizontalLeftSpacer\"></div>\n            <div class=\"ag-body-horizontal-scroll-viewport\" ref=\"eBodyHorizontalScrollViewport\">\n                <div class=\"ag-body-horizontal-scroll-container\" ref=\"eBodyHorizontalScrollContainer\"></div>\n            </div>\n            <div class=\"ag-horizontal-right-spacer\" ref=\"eHorizontalRightSpacer\"></div>\n        </div>\n        <ag-overlay-wrapper ref=\"overlayWrapper\"></ag-overlay-wrapper>\n    </div>";
	var GridPanel = /** @class */ (function (_super) {
	    __extends(GridPanel, _super);
	    function GridPanel() {
	        var _this = _super.call(this, GRID_PANEL_NORMAL_TEMPLATE) || this;
	        _this.scrollLeft = -1;
	        _this.scrollTop = -1;
	        _this.nextScrollTop = -1;
	        _this.resetLastHorizontalScrollElementDebounce = utils_1._.debounce(_this.resetLastHorizontalScrollElement.bind(_this), 500);
	        return _this;
	    }
	    GridPanel.prototype.getVScrollPosition = function () {
	        var result = {
	            top: this.eBodyViewport.scrollTop,
	            bottom: this.eBodyViewport.scrollTop + this.eBodyViewport.offsetHeight
	        };
	        return result;
	    };
	    GridPanel.prototype.getHScrollPosition = function () {
	        var result = {
	            left: this.eCenterViewport.scrollLeft,
	            right: this.eCenterViewport.scrollLeft + this.eCenterViewport.offsetWidth
	        };
	        return result;
	    };
	    GridPanel.prototype.onRowDataChanged = function () {
	        this.showOrHideOverlay();
	    };
	    GridPanel.prototype.showOrHideOverlay = function () {
	        var isEmpty = this.paginationProxy.isEmpty();
	        var isSuppressNoRowsOverlay = this.gridOptionsWrapper.isSuppressNoRowsOverlay();
	        var method = isEmpty && !isSuppressNoRowsOverlay ? 'showNoRowsOverlay' : 'hideOverlay';
	        this[method]();
	    };
	    GridPanel.prototype.onNewColumnsLoaded = function () {
	        // hide overlay if columns and rows exist, this can happen if columns are loaded after data.
	        // this problem exists before of the race condition between the services (column controller in this case)
	        // and the view (grid panel). if the model beans were all initialised first, and then the view beans second,
	        // this race condition would not happen.
	        if (this.columnController.isReady() && !this.paginationProxy.isEmpty()) {
	            this.hideOverlay();
	        }
	    };
	    GridPanel.prototype.init = function () {
	        var _this = this;
	        this.scrollWidth = this.gridOptionsWrapper.getScrollbarWidth();
	        this.enableRtl = this.gridOptionsWrapper.isEnableRtl();
	        this.printLayout = this.gridOptionsWrapper.getDomLayout() === constants_1.Constants.DOM_LAYOUT_PRINT;
	        // these elements have different CSS when layout changes
	        this.gridOptionsWrapper.addLayoutElement(this.getGui());
	        this.gridOptionsWrapper.addLayoutElement(this.eBodyViewport);
	        this.suppressScrollOnFloatingRow();
	        this.setupRowAnimationCssClass();
	        this.buildRowContainerComponents();
	        this.addEventListeners();
	        this.addDragListeners();
	        this.addScrollListener();
	        if (this.gridOptionsWrapper.isRowModelDefault() && !this.gridOptionsWrapper.getRowData()) {
	            this.showLoadingOverlay();
	        }
	        this.setCellTextSelection(this.gridOptionsWrapper.isEnableCellTextSelect());
	        this.setPinnedContainerSize();
	        this.setHeaderAndFloatingHeights();
	        this.disableBrowserDragging();
	        this.addMouseListeners();
	        this.addKeyboardEvents();
	        this.addBodyViewportListener();
	        this.addStopEditingWhenGridLosesFocus();
	        this.mockContextMenuForIPad();
	        this.addRowDragListener();
	        if (this.$scope) {
	            this.addAngularApplyCheck();
	        }
	        this.onDisplayedColumnsWidthChanged();
	        this.gridApi.registerGridComp(this);
	        this.alignedGridsService.registerGridComp(this);
	        this.headerRootComp.registerGridComp(this);
	        this.navigationService.registerGridComp(this);
	        this.heightScaler.registerGridComp(this);
	        this.autoHeightCalculator.registerGridComp(this);
	        this.columnAnimationService.registerGridComp(this);
	        this.autoWidthCalculator.registerGridComp(this);
	        this.paginationAutoPageSizeService.registerGridComp(this);
	        this.beans.registerGridComp(this);
	        this.rowRenderer.registerGridComp(this);
	        this.animationFrameService.registerGridComp(this);
	        if (this.rangeController) {
	            this.rangeController.registerGridComp(this);
	        }
	        [this.eCenterViewport, this.eBodyViewport].forEach(function (viewport) {
	            var unsubscribeFromResize = _this.resizeObserverService.observeResize(viewport, _this.onCenterViewportResized.bind(_this));
	            _this.addDestroyFunc(function () { return unsubscribeFromResize(); });
	        });
	    };
	    GridPanel.prototype.onDomLayoutChanged = function () {
	        var newPrintLayout = this.gridOptionsWrapper.getDomLayout() === constants_1.Constants.DOM_LAYOUT_PRINT;
	        if (this.printLayout !== newPrintLayout) {
	            this.printLayout = newPrintLayout;
	            this.setWidthsOfContainers();
	            // pinned containers are always hidden for print layout
	            this.setPinnedContainerSize();
	        }
	    };
	    GridPanel.prototype.onCenterViewportResized = function () {
	        if (utils_1._.isVisible(this.eCenterViewport)) {
	            this.checkViewportAndScrolls();
	        }
	        else {
	            this.bodyHeight = 0;
	        }
	    };
	    // used by ColumnAnimationService
	    GridPanel.prototype.setColumnMovingCss = function (moving) {
	        this.addOrRemoveCssClass('ag-column-moving', moving);
	    };
	    GridPanel.prototype.setCellTextSelection = function (selectable) {
	        if (selectable === void 0) { selectable = false; }
	        [this.eTop, this.eBodyViewport, this.eBottom]
	            .forEach(function (ct) { return utils_1._.addOrRemoveCssClass(ct, 'ag-selectable', selectable); });
	    };
	    GridPanel.prototype.addRowDragListener = function () {
	        var rowDragFeature = new rowDragFeature_1.RowDragFeature(this.eBodyViewport, this);
	        this.getContext().wireBean(rowDragFeature);
	        this.dragAndDropService.addDropTarget(rowDragFeature);
	    };
	    GridPanel.prototype.addStopEditingWhenGridLosesFocus = function () {
	        var _this = this;
	        if (!this.gridOptionsWrapper.isStopEditingWhenGridLosesFocus()) {
	            return;
	        }
	        var focusOutListener = function (event) {
	            // this is the element the focus is moving to
	            var elementWithFocus = event.relatedTarget;
	            // see if the element the focus is going to is part of the grid
	            var clickInsideGrid = false;
	            var pointer = elementWithFocus;
	            while (utils_1._.exists(pointer) && !clickInsideGrid) {
	                var isPopup = !!_this.gridOptionsWrapper.getDomData(pointer, popupEditorWrapper_1.PopupEditorWrapper.DOM_KEY_POPUP_EDITOR_WRAPPER);
	                var isBody = _this.eBodyViewport === pointer || _this.eBottom === pointer || _this.eTop === pointer;
	                clickInsideGrid = isPopup || isBody;
	                pointer = pointer.parentNode;
	            }
	            if (!clickInsideGrid) {
	                _this.rowRenderer.stopEditing();
	            }
	        };
	        this.addDestroyableEventListener(this.eBodyViewport, 'focusout', focusOutListener);
	        this.addDestroyableEventListener(this.eTop, 'focusout', focusOutListener);
	        this.addDestroyableEventListener(this.eBottom, 'focusout', focusOutListener);
	    };
	    GridPanel.prototype.addAngularApplyCheck = function () {
	        var _this = this;
	        // this makes sure if we queue up requests, we only execute oe
	        var applyTriggered = false;
	        var listener = function () {
	            // only need to do one apply at a time
	            if (applyTriggered) {
	                return;
	            }
	            applyTriggered = true; // mark 'need apply' to true
	            window.setTimeout(function () {
	                applyTriggered = false;
	                _this.$scope.$apply();
	            }, 0);
	        };
	        // these are the events we need to do an apply after - these are the ones that can end up
	        // with columns added or removed
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, listener);
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_VIRTUAL_COLUMNS_CHANGED, listener);
	    };
	    // if we do not do this, then the user can select a pic in the grid (eg an image in a custom cell renderer)
	    // and then that will start the browser native drag n' drop, which messes up with our own drag and drop.
	    GridPanel.prototype.disableBrowserDragging = function () {
	        this.addGuiEventListener('dragstart', function (event) {
	            if (event.target instanceof HTMLImageElement) {
	                event.preventDefault();
	                return false;
	            }
	        });
	    };
	    GridPanel.prototype.addEventListeners = function () {
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onDisplayedColumnsWidthChanged.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_PINNED_ROW_DATA_CHANGED, this.setHeaderAndFloatingHeights.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_ROW_DATA_CHANGED, this.onRowDataChanged.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_ROW_DATA_UPDATED, this.onRowDataChanged.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_NEW_COLUMNS_LOADED, this.onNewColumnsLoaded.bind(this));
	        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_HEADER_HEIGHT, this.setHeaderAndFloatingHeights.bind(this));
	        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_PIVOT_HEADER_HEIGHT, this.setHeaderAndFloatingHeights.bind(this));
	        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_GROUP_HEADER_HEIGHT, this.setHeaderAndFloatingHeights.bind(this));
	        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_PIVOT_GROUP_HEADER_HEIGHT, this.setHeaderAndFloatingHeights.bind(this));
	        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_FLOATING_FILTERS_HEIGHT, this.setHeaderAndFloatingHeights.bind(this));
	        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_DOM_LAYOUT, this.onDomLayoutChanged.bind(this));
	    };
	    GridPanel.prototype.addDragListeners = function () {
	        var _this = this;
	        if (!this.gridOptionsWrapper.isEnableRangeSelection() || // no range selection if no property
	            utils_1._.missing(this.rangeController) // no range selection if not enterprise version
	        ) {
	            return;
	        }
	        var containers = [
	            this.eLeftContainer,
	            this.eRightContainer,
	            this.eCenterContainer,
	            this.eTop,
	            this.eBottom
	        ];
	        containers.forEach(function (container) {
	            var params = {
	                eElement: container,
	                onDragStart: _this.rangeController.onDragStart.bind(_this.rangeController),
	                onDragStop: _this.rangeController.onDragStop.bind(_this.rangeController),
	                onDragging: _this.rangeController.onDragging.bind(_this.rangeController)
	            };
	            _this.dragService.addDragSource(params);
	            _this.addDestroyFunc(function () { return _this.dragService.removeDragSource(params); });
	        });
	    };
	    GridPanel.prototype.addMouseListeners = function () {
	        var _this = this;
	        var eventNames = ['click', 'mousedown', 'dblclick', 'contextmenu', 'mouseover', 'mouseout'];
	        eventNames.forEach(function (eventName) {
	            var listener = _this.processMouseEvent.bind(_this, eventName);
	            _this.eAllCellContainers.forEach(function (container) {
	                return _this.addDestroyableEventListener(container, eventName, listener);
	            });
	        });
	    };
	    GridPanel.prototype.addKeyboardEvents = function () {
	        var _this = this;
	        var eventNames = ['keydown', 'keypress'];
	        eventNames.forEach(function (eventName) {
	            var listener = _this.processKeyboardEvent.bind(_this, eventName);
	            _this.eAllCellContainers.forEach(function (container) {
	                _this.addDestroyableEventListener(container, eventName, listener);
	            });
	        });
	    };
	    GridPanel.prototype.addBodyViewportListener = function () {
	        var _this = this;
	        // we want to listen for clicks directly on the eBodyViewport, so the user has a way of showing
	        // the context menu if no rows or columns are displayed, or user simply clicks outside of a cell
	        var listener = function (mouseEvent) {
	            var target = utils_1._.getTarget(mouseEvent);
	            if (target === _this.eBodyViewport || target === _this.eCenterViewport) {
	                // show it
	                _this.onContextMenu(mouseEvent, null, null, null, null);
	                _this.preventDefaultOnContextMenu(mouseEvent);
	            }
	        };
	        this.addDestroyableEventListener(this.eBodyViewport, 'contextmenu', listener);
	    };
	    // + rangeController - used to know when to scroll when user is dragging outside the
	    // main viewport while doing a range selection
	    GridPanel.prototype.getBodyClientRect = function () {
	        if (!this.eBodyViewport) {
	            return;
	        }
	        return this.eBodyViewport.getBoundingClientRect();
	    };
	    GridPanel.prototype.getRowForEvent = function (event) {
	        var sourceElement = utils_1._.getTarget(event);
	        while (sourceElement) {
	            var renderedRow = this.gridOptionsWrapper.getDomData(sourceElement, rowComp_1.RowComp.DOM_DATA_KEY_RENDERED_ROW);
	            if (renderedRow) {
	                return renderedRow;
	            }
	            sourceElement = sourceElement.parentElement;
	        }
	        return null;
	    };
	    GridPanel.prototype.processKeyboardEvent = function (eventName, keyboardEvent) {
	        var cellComp = utils_1._.getCellCompForEvent(this.gridOptionsWrapper, keyboardEvent);
	        if (!cellComp) {
	            return;
	        }
	        var rowNode = cellComp.getRenderedRow().getRowNode();
	        var column = cellComp.getColumn();
	        var editing = cellComp.isEditing();
	        var gridProcessingAllowed = !utils_1._.isUserSuppressingKeyboardEvent(this.gridOptionsWrapper, keyboardEvent, rowNode, column, editing);
	        if (gridProcessingAllowed) {
	            switch (eventName) {
	                case 'keydown':
	                    // first see if it's a scroll key, page up / down, home / end etc
	                    var wasScrollKey = !editing && this.navigationService.handlePageScrollingKey(keyboardEvent);
	                    // if not a scroll key, then we pass onto cell
	                    if (!wasScrollKey) {
	                        cellComp.onKeyDown(keyboardEvent);
	                    }
	                    this.doClipboardOperations(keyboardEvent, cellComp);
	                    break;
	                case 'keypress':
	                    cellComp.onKeyPress(keyboardEvent);
	                    break;
	            }
	        }
	        if (eventName === 'keydown') {
	            var cellKeyDownEvent = cellComp.createEvent(keyboardEvent, events_1.Events.EVENT_CELL_KEY_DOWN);
	            this.beans.eventService.dispatchEvent(cellKeyDownEvent);
	        }
	        if (eventName === 'keypress') {
	            var cellKeyPressEvent = cellComp.createEvent(keyboardEvent, events_1.Events.EVENT_CELL_KEY_PRESS);
	            this.beans.eventService.dispatchEvent(cellKeyPressEvent);
	        }
	    };
	    GridPanel.prototype.doClipboardOperations = function (keyboardEvent, cellComp) {
	        // check if ctrl or meta key pressed
	        if (!keyboardEvent.ctrlKey && !keyboardEvent.metaKey) {
	            return;
	        }
	        // if the cell the event came from is editing, then we do not
	        // want to do the default shortcut keys, otherwise the editor
	        // (eg a text field) would not be able to do the normal cut/copy/paste
	        if (cellComp.isEditing()) {
	            return;
	        }
	        // for copy / paste, we don't want to execute when the event
	        // was from a child grid (happens in master detail)
	        if (!this.mouseEventService.isEventFromThisGrid(keyboardEvent)) {
	            return;
	        }
	        switch (keyboardEvent.which) {
	            case constants_1.Constants.KEY_A:
	                return this.onCtrlAndA(keyboardEvent);
	            case constants_1.Constants.KEY_C:
	                return this.onCtrlAndC(keyboardEvent);
	            case constants_1.Constants.KEY_V:
	                return this.onCtrlAndV();
	            case constants_1.Constants.KEY_D:
	                return this.onCtrlAndD(keyboardEvent);
	        }
	    };
	    // gets called by rowRenderer when new data loaded, as it will want to scroll to the top
	    GridPanel.prototype.scrollToTop = function () {
	        this.eBodyViewport.scrollTop = 0;
	    };
	    GridPanel.prototype.processMouseEvent = function (eventName, mouseEvent) {
	        if (!this.mouseEventService.isEventFromThisGrid(mouseEvent) ||
	            utils_1._.isStopPropagationForAgGrid(mouseEvent)) {
	            return;
	        }
	        var rowComp = this.getRowForEvent(mouseEvent);
	        var cellComp = this.mouseEventService.getRenderedCellForEvent(mouseEvent);
	        if (eventName === "contextmenu") {
	            this.handleContextMenuMouseEvent(mouseEvent, null, rowComp, cellComp);
	        }
	        else {
	            if (cellComp) {
	                cellComp.onMouseEvent(eventName, mouseEvent);
	            }
	            if (rowComp) {
	                rowComp.onMouseEvent(eventName, mouseEvent);
	            }
	        }
	        this.preventDefaultOnContextMenu(mouseEvent);
	    };
	    GridPanel.prototype.mockContextMenuForIPad = function () {
	        var _this = this;
	        // we do NOT want this when not in iPad, otherwise we will be doing
	        if (!utils_1._.isUserAgentIPad()) {
	            return;
	        }
	        this.eAllCellContainers.forEach(function (container) {
	            var touchListener = new touchListener_1.TouchListener(container);
	            var longTapListener = function (event) {
	                var rowComp = _this.getRowForEvent(event.touchEvent);
	                var cellComp = _this.mouseEventService.getRenderedCellForEvent(event.touchEvent);
	                _this.handleContextMenuMouseEvent(null, event.touchEvent, rowComp, cellComp);
	            };
	            _this.addDestroyableEventListener(touchListener, touchListener_1.TouchListener.EVENT_LONG_TAP, longTapListener);
	            _this.addDestroyFunc(function () { return touchListener.destroy(); });
	        });
	    };
	    GridPanel.prototype.handleContextMenuMouseEvent = function (mouseEvent, touchEvent, rowComp, cellComp) {
	        var rowNode = rowComp ? rowComp.getRowNode() : null;
	        var column = cellComp ? cellComp.getColumn() : null;
	        var value = null;
	        if (column) {
	            var event_1 = mouseEvent ? mouseEvent : touchEvent;
	            cellComp.dispatchCellContextMenuEvent(event_1);
	            value = this.valueService.getValue(column, rowNode);
	        }
	        this.onContextMenu(mouseEvent, touchEvent, rowNode, column, value);
	    };
	    GridPanel.prototype.onContextMenu = function (mouseEvent, touchEvent, rowNode, column, value) {
	        // to allow us to debug in chrome, we ignore the event if ctrl is pressed.
	        // not everyone wants this, so first 'if' below allows to turn this hack off.
	        if (!this.gridOptionsWrapper.isAllowContextMenuWithControlKey()) {
	            // then do the check
	            if (mouseEvent && (mouseEvent.ctrlKey || mouseEvent.metaKey)) {
	                return;
	            }
	        }
	        if (this.contextMenuFactory && !this.gridOptionsWrapper.isSuppressContextMenu()) {
	            var eventOrTouch = mouseEvent ? mouseEvent : touchEvent.touches[0];
	            this.contextMenuFactory.showMenu(rowNode, column, value, eventOrTouch);
	            var event_2 = mouseEvent ? mouseEvent : touchEvent;
	            event_2.preventDefault();
	        }
	    };
	    GridPanel.prototype.preventDefaultOnContextMenu = function (mouseEvent) {
	        // if we don't do this, then middle click will never result in a 'click' event, as 'mousedown'
	        // will be consumed by the browser to mean 'scroll' (as you can scroll with the middle mouse
	        // button in the browser). so this property allows the user to receive middle button clicks if
	        // they want.
	        var gridOptionsWrapper = this.gridOptionsWrapper;
	        var which = mouseEvent.which;
	        if (gridOptionsWrapper.isPreventDefaultOnContextMenu() ||
	            (gridOptionsWrapper.isSuppressMiddleClickScrolls() && which === 2)) {
	            mouseEvent.preventDefault();
	        }
	    };
	    GridPanel.prototype.onCtrlAndA = function (event) {
	        var _a = this, columnController = _a.columnController, pinnedRowModel = _a.pinnedRowModel, paginationProxy = _a.paginationProxy, rangeController = _a.rangeController;
	        var PINNED_BOTTOM = constants_1.Constants.PINNED_BOTTOM, PINNED_TOP = constants_1.Constants.PINNED_TOP;
	        if (rangeController && paginationProxy.isRowsToRender()) {
	            var _b = [
	                pinnedRowModel.isEmpty(PINNED_TOP),
	                pinnedRowModel.isEmpty(PINNED_BOTTOM)
	            ], isEmptyPinnedTop = _b[0], isEmptyPinnedBottom = _b[1];
	            var floatingStart = isEmptyPinnedTop ? null : PINNED_TOP;
	            var floatingEnd = void 0;
	            var rowEnd = void 0;
	            if (isEmptyPinnedBottom) {
	                floatingEnd = null;
	                rowEnd = this.paginationProxy.getRowCount() - 1;
	            }
	            else {
	                floatingEnd = PINNED_BOTTOM;
	                rowEnd = pinnedRowModel.getPinnedBottomRowData().length - 1;
	            }
	            var allDisplayedColumns = columnController.getAllDisplayedColumns();
	            if (utils_1._.missingOrEmpty(allDisplayedColumns)) {
	                return;
	            }
	            rangeController.setCellRange({
	                rowStartIndex: 0,
	                rowStartPinned: floatingStart,
	                rowEndIndex: rowEnd,
	                rowEndPinned: floatingEnd,
	                columnStart: allDisplayedColumns[0],
	                columnEnd: utils_1._.last(allDisplayedColumns)
	            });
	        }
	        event.preventDefault();
	    };
	    GridPanel.prototype.onCtrlAndC = function (event) {
	        if (!this.clipboardService || this.gridOptionsWrapper.isEnableCellTextSelection()) {
	            return;
	        }
	        var focusedCell = this.focusedCellController.getFocusedCell();
	        this.clipboardService.copyToClipboard();
	        event.preventDefault();
	        // the copy operation results in loosing focus on the cell,
	        // because of the trickery the copy logic uses with a temporary
	        // widget. so we set it back again.
	        if (focusedCell) {
	            this.focusedCellController.setFocusedCell(focusedCell.rowIndex, focusedCell.column, focusedCell.rowPinned, true);
	        }
	    };
	    GridPanel.prototype.onCtrlAndV = function () {
	        if (!this.enterprise || this.gridOptionsWrapper.isSuppressClipboardPaste()) {
	            return;
	        }
	        this.clipboardService.pasteFromClipboard();
	    };
	    GridPanel.prototype.onCtrlAndD = function (event) {
	        if (!this.enterprise) {
	            return;
	        }
	        this.clipboardService.copyRangeDown();
	        event.preventDefault();
	    };
	    // Valid values for position are bottom, middle and top
	    // position should be {'top','middle','bottom', or undefined/null}.
	    // if undefined/null, then the grid will to the minimal amount of scrolling,
	    // eg if grid needs to scroll up, it scrolls until row is on top,
	    //    if grid needs to scroll down, it scrolls until row is on bottom,
	    //    if row is already in view, grid does not scroll
	    // fixme - how does this work in the new way
	    GridPanel.prototype.ensureIndexVisible = function (index, position) {
	        // if for print or auto height, everything is always visible
	        if (this.printLayout) {
	            return;
	        }
	        var rowCount = this.paginationProxy.getRowCount();
	        if (typeof index !== 'number' || index < 0 || index >= rowCount) {
	            console.warn('invalid row index for ensureIndexVisible: ' + index);
	            return;
	        }
	        this.paginationProxy.goToPageWithIndex(index);
	        var rowNode = this.paginationProxy.getRow(index);
	        var rowGotShiftedDuringOperation;
	        do {
	            var startingRowTop = rowNode.rowTop;
	            var startingRowHeight = rowNode.rowHeight;
	            var paginationOffset = this.paginationProxy.getPixelOffset();
	            var rowTopPixel = rowNode.rowTop - paginationOffset;
	            var rowBottomPixel = rowTopPixel + rowNode.rowHeight;
	            var scrollPosition = this.getVScrollPosition();
	            var heightOffset = this.heightScaler.getOffset();
	            var vScrollTop = scrollPosition.top + heightOffset;
	            var vScrollBottom = scrollPosition.bottom + heightOffset;
	            var viewportHeight = vScrollBottom - vScrollTop;
	            // work out the pixels for top, middle and bottom up front,
	            // make the if/else below easier to read
	            var pxTop = this.heightScaler.getScrollPositionForPixel(rowTopPixel);
	            var pxBottom = this.heightScaler.getScrollPositionForPixel(rowBottomPixel - viewportHeight);
	            // make sure if middle, the row is not outside the top of the grid
	            var pxMiddle = Math.min((pxTop + pxBottom) / 2, rowTopPixel);
	            var rowBelowViewport = vScrollTop > rowTopPixel;
	            var rowAboveViewport = vScrollBottom < rowBottomPixel;
	            var newScrollPosition = null;
	            if (position === 'top') {
	                newScrollPosition = pxTop;
	            }
	            else if (position === 'bottom') {
	                newScrollPosition = pxBottom;
	            }
	            else if (position === 'middle') {
	                newScrollPosition = pxMiddle;
	            }
	            else if (rowBelowViewport) {
	                // if row is before, scroll up with row at top
	                newScrollPosition = pxTop;
	            }
	            else if (rowAboveViewport) {
	                // if row is below, scroll down with row at bottom
	                newScrollPosition = pxBottom;
	            }
	            if (newScrollPosition !== null) {
	                this.eBodyViewport.scrollTop = newScrollPosition;
	                this.rowRenderer.redrawAfterScroll();
	            }
	            // the row can get shifted if during the rendering (during rowRenderer.redrawAfterScroll()),
	            // the height of a row changes due to lazy calculation of row heights when using
	            // colDef.autoHeight or gridOptions.getRowHeight.
	            // if row was shifted, then the position we scrolled to is incorrect.
	            rowGotShiftedDuringOperation = (startingRowTop !== rowNode.rowTop)
	                || (startingRowHeight !== rowNode.rowHeight);
	        } while (rowGotShiftedDuringOperation);
	        // so when we return back to user, the cells have rendered
	        this.animationFrameService.flushAllFrames();
	    };
	    // + moveColumnController
	    GridPanel.prototype.getCenterWidth = function () {
	        return this.eCenterViewport.clientWidth;
	    };
	    GridPanel.prototype.isVerticalScrollShowing = function () {
	        var isAlwaysShowVerticalScroll = this.gridOptionsWrapper.isAlwaysShowVerticalScroll();
	        utils_1._.addOrRemoveCssClass(this.eBodyViewport, 'ag-force-vertical-scroll', isAlwaysShowVerticalScroll);
	        return isAlwaysShowVerticalScroll || utils_1._.isVerticalScrollShowing(this.eBodyViewport);
	    };
	    GridPanel.prototype.isHorizontalScrollShowing = function () {
	        return utils_1._.isHorizontalScrollShowing(this.eCenterViewport);
	    };
	    // gets called every time the viewport size changes. we use this to check visibility of scrollbars
	    // in the grid panel, and also to check size and position of viewport for row and column virtualisation.
	    GridPanel.prototype.checkViewportAndScrolls = function () {
	        // results in updating anything that depends on scroll showing
	        this.updateScrollVisibleService();
	        // fires event if height changes, used by PaginationService, HeightScalerService, RowRenderer
	        this.checkBodyHeight();
	        // check for virtual columns for ColumnController
	        this.onHorizontalViewportChanged();
	        this.setPinnedContainerSize();
	    };
	    GridPanel.prototype.updateScrollVisibleService = function () {
	        // because of column animation (which takes 200ms), we have to do this twice.
	        // eg if user removes cols anywhere except at the RHS, then the cols on the RHS
	        // will animate to the left to fill the gap. this animation means just after
	        // the cols are removed, the remaining cols are still in the original location
	        // at the start of the animation, so pre animation the H scrollbar is still needed,
	        // but post animation it is not.
	        this.updateScrollVisibleServiceImpl();
	        setTimeout(this.updateScrollVisibleServiceImpl.bind(this), 500);
	    };
	    GridPanel.prototype.updateScrollVisibleServiceImpl = function () {
	        var params = {
	            horizontalScrollShowing: false,
	            verticalScrollShowing: false
	        };
	        params.verticalScrollShowing = this.isVerticalScrollShowing();
	        params.horizontalScrollShowing = this.isHorizontalScrollShowing();
	        this.scrollVisibleService.setScrollsVisible(params);
	        this.setHorizontalScrollVisible(params.horizontalScrollShowing);
	        this.setVerticalScrollPaddingVisible(params.verticalScrollShowing);
	    };
	    GridPanel.prototype.setHorizontalScrollVisible = function (visible) {
	        var isSuppressHorizontalScroll = this.gridOptionsWrapper.isSuppressHorizontalScroll();
	        var scrollSize = visible ? (this.gridOptionsWrapper.getScrollbarWidth() || 0) : 0;
	        var scrollContainerSize = !isSuppressHorizontalScroll ? scrollSize : 0;
	        var addIEPadding = utils_1._.isBrowserIE() && visible;
	        this.eCenterViewport.style.height = "calc(100% + " + scrollSize + "px)";
	        utils_1._.setFixedHeight(this.eHorizontalScrollBody, scrollContainerSize);
	        // we have to add an extra pixel to the scroller viewport on IE because
	        // if the container has the same size as the scrollbar, the scroll button won't work
	        utils_1._.setFixedHeight(this.eBodyHorizontalScrollViewport, scrollContainerSize + (addIEPadding ? 1 : 0));
	        utils_1._.setFixedHeight(this.eBodyHorizontalScrollContainer, scrollContainerSize);
	    };
	    GridPanel.prototype.setVerticalScrollPaddingVisible = function (show) {
	        var scroller = show ? "scroll" : "hidden";
	        this.eTop.style.overflowY = this.eBottom.style.overflowY = scroller;
	        this.setFakeHScrollSpacerWidths();
	    };
	    GridPanel.prototype.updateRowCount = function () {
	        var headerCount = this.headerRootComp.getHeaderRowCount();
	        var rowCount = this.paginationProxy.getRowCount();
	        var total = (headerCount + rowCount).toString();
	        this.getGui().setAttribute('aria-rowcount', total);
	    };
	    GridPanel.prototype.ensureColumnVisible = function (key) {
	        var column = this.columnController.getGridColumn(key);
	        if (!column) {
	            return;
	        }
	        if (column.isPinned()) {
	            console.warn('calling ensureIndexVisible on a ' + column.getPinned() + ' pinned column doesn\'t make sense for column ' + column.getColId());
	            return;
	        }
	        if (!this.columnController.isColumnDisplayed(column)) {
	            console.warn('column is not currently visible');
	            return;
	        }
	        var colLeftPixel = column.getLeft();
	        var colRightPixel = colLeftPixel + column.getActualWidth();
	        var viewportWidth = this.eCenterViewport.clientWidth;
	        var scrollPosition = this.getCenterViewportScrollLeft();
	        var bodyWidth = this.columnController.getBodyContainerWidth();
	        var viewportLeftPixel;
	        var viewportRightPixel;
	        // the logic of working out left and right viewport px is both here and in the ColumnController,
	        // need to refactor it out to one place
	        if (this.enableRtl) {
	            viewportLeftPixel = bodyWidth - scrollPosition - viewportWidth;
	            viewportRightPixel = bodyWidth - scrollPosition;
	        }
	        else {
	            viewportLeftPixel = scrollPosition;
	            viewportRightPixel = viewportWidth + scrollPosition;
	        }
	        var viewportScrolledPastCol = viewportLeftPixel > colLeftPixel;
	        var viewportScrolledBeforeCol = viewportRightPixel < colRightPixel;
	        var colToSmallForViewport = viewportWidth < column.getActualWidth();
	        var alignColToLeft = viewportScrolledPastCol || colToSmallForViewport;
	        var alignColToRight = viewportScrolledBeforeCol;
	        var newScrollPosition = this.getCenterViewportScrollLeft();
	        if (alignColToLeft || alignColToRight) {
	            if (this.enableRtl) {
	                newScrollPosition = alignColToLeft ? (bodyWidth - viewportWidth - colLeftPixel) : (bodyWidth - colRightPixel);
	            }
	            else {
	                newScrollPosition = alignColToLeft ? colLeftPixel : (colRightPixel - viewportWidth);
	            }
	            this.setCenterViewportScrollLeft(newScrollPosition);
	        }
	        else {
	            // otherwise, col is already in view, so do nothing
	        }
	        // this will happen anyway, as the move will cause a 'scroll' event on the body, however
	        // it is possible that the ensureColumnVisible method is called from within ag-Grid and
	        // the caller will need to have the columns rendered to continue, which will be before
	        // the event has been worked on (which is the case for cell navigation).
	        this.onHorizontalViewportChanged();
	        // so when we return back to user, the cells have rendered
	        this.animationFrameService.flushAllFrames();
	    };
	    GridPanel.prototype.showLoadingOverlay = function () {
	        if (!this.gridOptionsWrapper.isSuppressLoadingOverlay()) {
	            this.overlayWrapper.showLoadingOverlay();
	        }
	    };
	    GridPanel.prototype.showNoRowsOverlay = function () {
	        if (!this.gridOptionsWrapper.isSuppressNoRowsOverlay()) {
	            this.overlayWrapper.showNoRowsOverlay();
	        }
	    };
	    GridPanel.prototype.hideOverlay = function () {
	        this.overlayWrapper.hideOverlay();
	    };
	    // method will call itself if no available width. this covers if the grid
	    // isn't visible, but is just about to be visible.
	    GridPanel.prototype.sizeColumnsToFit = function (nextTimeout) {
	        var _this = this;
	        var availableWidth = this.eBodyViewport.clientWidth;
	        if (availableWidth > 0) {
	            this.columnController.sizeColumnsToFit(availableWidth, "sizeColumnsToFit");
	            return;
	        }
	        if (nextTimeout === undefined) {
	            window.setTimeout(function () {
	                _this.sizeColumnsToFit(100);
	            }, 0);
	        }
	        else if (nextTimeout === 100) {
	            window.setTimeout(function () {
	                _this.sizeColumnsToFit(500);
	            }, 100);
	        }
	        else if (nextTimeout === 500) {
	            window.setTimeout(function () {
	                _this.sizeColumnsToFit(-1);
	            }, 500);
	        }
	        else {
	            console.warn('ag-Grid: tried to call sizeColumnsToFit() but the grid is coming back with ' +
	                'zero width, maybe the grid is not visible yet on the screen?');
	        }
	    };
	    // used by autoWidthCalculator and autoHeightCalculator
	    GridPanel.prototype.getCenterContainer = function () {
	        return this.eCenterContainer;
	    };
	    GridPanel.prototype.getDropTargetBodyContainers = function () {
	        return [this.eCenterViewport, this.eTopViewport, this.eBottomViewport];
	    };
	    GridPanel.prototype.getDropTargetLeftContainers = function () {
	        return [this.eLeftContainer, this.eLeftBottom, this.eLeftTop];
	    };
	    GridPanel.prototype.getDropTargetRightContainers = function () {
	        return [this.eRightContainer, this.eRightBottom, this.eRightTop];
	    };
	    GridPanel.prototype.buildRowContainerComponents = function () {
	        var _this = this;
	        this.eAllCellContainers = [
	            this.eLeftContainer, this.eRightContainer, this.eCenterContainer,
	            this.eTop, this.eBottom, this.eFullWidthContainer
	        ];
	        this.rowContainerComponents = {
	            body: new rowContainerComponent_1.RowContainerComponent({
	                eContainer: this.eCenterContainer,
	                eWrapper: this.eCenterColsClipper,
	                eViewport: this.eBodyViewport
	            }),
	            fullWidth: new rowContainerComponent_1.RowContainerComponent({
	                eContainer: this.eFullWidthContainer
	            }),
	            pinnedLeft: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.eLeftContainer }),
	            pinnedRight: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.eRightContainer }),
	            floatingTop: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.eTopContainer }),
	            floatingTopPinnedLeft: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.eLeftTop }),
	            floatingTopPinnedRight: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.eRightTop }),
	            floatingTopFullWidth: new rowContainerComponent_1.RowContainerComponent({
	                eContainer: this.eTopFullWidthContainer,
	                hideWhenNoChildren: true
	            }),
	            floatingBottom: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.eBottomContainer }),
	            floatingBottomPinnedLeft: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.eLeftBottom }),
	            floatingBottomPinnedRight: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.eRightBottom }),
	            floatingBottomFullWith: new rowContainerComponent_1.RowContainerComponent({
	                eContainer: this.eBottomFullWidthContainer,
	                hideWhenNoChildren: true
	            }),
	        };
	        utils_1._.iterateObject(this.rowContainerComponents, function (key, container) {
	            if (container) {
	                _this.getContext().wireBean(container);
	            }
	        });
	    };
	    GridPanel.prototype.setupRowAnimationCssClass = function () {
	        var _this = this;
	        var listener = function () {
	            // we don't want to use row animation if scaling, as rows jump strangely as you scroll,
	            // when scaling and doing row animation.
	            var animateRows = _this.gridOptionsWrapper.isAnimateRows() && !_this.heightScaler.isScaling();
	            utils_1._.addOrRemoveCssClass(_this.eBodyViewport, 'ag-row-animation', animateRows);
	            utils_1._.addOrRemoveCssClass(_this.eBodyViewport, 'ag-row-no-animation', !animateRows);
	        };
	        listener();
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_HEIGHT_SCALE_CHANGED, listener);
	    };
	    // when editing a pinned row, if the cell is half outside the scrollable area, the browser can
	    // scroll the column into view. we do not want this, the pinned sections should never scroll.
	    // so we listen to scrolls on these containers and reset the scroll if we find one.
	    GridPanel.prototype.suppressScrollOnFloatingRow = function () {
	        var _this = this;
	        var resetTopScroll = function () { return _this.eTopViewport.scrollLeft = 0; };
	        var resetBottomScroll = function () { return _this.eTopViewport.scrollLeft = 0; };
	        this.addDestroyableEventListener(this.eTopViewport, 'scroll', resetTopScroll);
	        this.addDestroyableEventListener(this.eBottomViewport, 'scroll', resetBottomScroll);
	    };
	    GridPanel.prototype.getRowContainers = function () {
	        return this.rowContainerComponents;
	    };
	    GridPanel.prototype.getFloatingTopBottom = function () {
	        return [this.eTop, this.eBottom];
	    };
	    GridPanel.prototype.onDisplayedColumnsChanged = function () {
	        this.setPinnedContainerSize();
	        this.setHeaderAndFloatingHeights();
	        this.onHorizontalViewportChanged();
	        this.updateScrollVisibleService();
	    };
	    GridPanel.prototype.onDisplayedColumnsWidthChanged = function () {
	        this.setWidthsOfContainers();
	        this.onHorizontalViewportChanged();
	        this.updateScrollVisibleService();
	        if (this.enableRtl) {
	            // because RTL is all backwards, a change in the width of the row
	            // can cause a change in the scroll position, without a scroll event,
	            // because the scroll position in RTL is a function that depends on
	            // the width. to be convinced of this, take out this line, enable RTL,
	            // scroll all the way to the left and then resize a column
	            this.horizontallyScrollHeaderCenterAndFloatingCenter();
	        }
	    };
	    GridPanel.prototype.setWidthsOfContainers = function () {
	        this.setCenterWidth();
	        this.setPinnedContainerSize();
	    };
	    GridPanel.prototype.setCenterWidth = function () {
	        var width = this.columnController.getBodyContainerWidth();
	        if (this.printLayout) {
	            var pinnedContainerWidths = this.columnController.getPinnedLeftContainerWidth()
	                + this.columnController.getPinnedRightContainerWidth();
	            width += pinnedContainerWidths;
	        }
	        this.headerRootComp.setHeaderContainerWidth(width);
	        var widthPx = width + "px";
	        this.eCenterContainer.style.width = widthPx;
	        this.eBottomContainer.style.width = widthPx;
	        this.eTopContainer.style.width = widthPx;
	        if (!this.printLayout) {
	            this.eBodyHorizontalScrollContainer.style.width = widthPx;
	        }
	    };
	    GridPanel.prototype.setPinnedLeftWidth = function () {
	        var _this = this;
	        var oldPinning = this.pinningLeft;
	        var widthOfCols = this.columnController.getPinnedLeftContainerWidth();
	        var newPinning = this.pinningLeft = !this.printLayout && widthOfCols > 0;
	        var containers = [this.eLeftContainer, this.eLeftTop, this.eLeftBottom];
	        if (oldPinning !== newPinning) {
	            this.headerRootComp.setLeftVisible(newPinning);
	        }
	        containers.forEach(function (e) { return utils_1._.setDisplayed(e, _this.pinningLeft); });
	        if (newPinning) {
	            containers.forEach(function (ct) { return utils_1._.setFixedWidth(ct, widthOfCols); });
	        }
	    };
	    GridPanel.prototype.setPinnedRightWidth = function () {
	        var oldPinning = this.pinningRight;
	        var widthOfCols = this.columnController.getPinnedRightContainerWidth();
	        var newPinning = this.pinningRight = !this.printLayout && widthOfCols > 0;
	        var containers = [this.eRightContainer, this.eRightTop, this.eRightBottom];
	        if (oldPinning !== newPinning) {
	            this.headerRootComp.setRightVisible(newPinning);
	        }
	        containers.forEach(function (ct) { return utils_1._.setDisplayed(ct, newPinning); });
	        if (newPinning) {
	            containers.forEach(function (ct) { return utils_1._.setFixedWidth(ct, widthOfCols); });
	        }
	    };
	    GridPanel.prototype.setPinnedContainerSize = function () {
	        this.setPinnedLeftWidth();
	        this.setPinnedRightWidth();
	        this.setFakeHScrollSpacerWidths();
	    };
	    GridPanel.prototype.setFakeHScrollSpacerWidths = function () {
	        // we pad the right based on a) if cols are pinned to the right and
	        // b) if v scroll is showing on the right (normal position of scroll)
	        var rightSpacing = this.columnController.getPinnedRightContainerWidth();
	        var scrollOnRight = !this.enableRtl && this.isVerticalScrollShowing();
	        if (scrollOnRight) {
	            rightSpacing += this.scrollWidth;
	        }
	        utils_1._.setFixedWidth(this.eHorizontalRightSpacer, rightSpacing);
	        utils_1._.addOrRemoveCssClass(this.eHorizontalRightSpacer, 'ag-scroller-corner', rightSpacing <= this.scrollWidth);
	        // we pad the left based on a) if cols are pinned to the left and
	        // b) if v scroll is showing on the left (happens in LTR layout only)
	        var leftSpacing = this.columnController.getPinnedLeftContainerWidth();
	        var scrollOnLeft = this.enableRtl && this.isVerticalScrollShowing();
	        if (scrollOnLeft) {
	            leftSpacing += this.scrollWidth;
	        }
	        utils_1._.setFixedWidth(this.eHorizontalLeftSpacer, leftSpacing);
	        utils_1._.addOrRemoveCssClass(this.eHorizontalLeftSpacer, 'ag-scroller-corner', leftSpacing <= this.scrollWidth);
	    };
	    GridPanel.prototype.checkBodyHeight = function () {
	        var bodyHeight = this.eBodyViewport.clientHeight;
	        if (this.bodyHeight !== bodyHeight) {
	            this.bodyHeight = bodyHeight;
	            var event_3 = {
	                type: events_1.Events.EVENT_BODY_HEIGHT_CHANGED,
	                api: this.gridApi,
	                columnApi: this.columnApi
	            };
	            this.eventService.dispatchEvent(event_3);
	        }
	    };
	    GridPanel.prototype.setHeaderAndFloatingHeights = function () {
	        var _a = this, columnController = _a.columnController, gridOptionsWrapper = _a.gridOptionsWrapper, pinnedRowModel = _a.pinnedRowModel, eTop = _a.eTop, eBottom = _a.eBottom;
	        var numberOfFloating = 0;
	        var headerRowCount = columnController.getHeaderRowCount();
	        var totalHeaderHeight;
	        var groupHeight;
	        var headerHeight;
	        if (!columnController.isPivotMode()) {
	            if (gridOptionsWrapper.isFloatingFilter()) {
	                headerRowCount++;
	            }
	            numberOfFloating = (gridOptionsWrapper.isFloatingFilter()) ? 1 : 0;
	            groupHeight = gridOptionsWrapper.getGroupHeaderHeight();
	            headerHeight = gridOptionsWrapper.getHeaderHeight();
	        }
	        else {
	            numberOfFloating = 0;
	            groupHeight = gridOptionsWrapper.getPivotGroupHeaderHeight();
	            headerHeight = gridOptionsWrapper.getPivotHeaderHeight();
	        }
	        var numberOfNonGroups = 1 + numberOfFloating;
	        var numberOfGroups = headerRowCount - numberOfNonGroups;
	        totalHeaderHeight = numberOfFloating * gridOptionsWrapper.getFloatingFiltersHeight();
	        totalHeaderHeight += numberOfGroups * groupHeight;
	        totalHeaderHeight += headerHeight;
	        this.headerRootComp.setHeight(totalHeaderHeight);
	        var floatingTopHeight = pinnedRowModel.getPinnedTopTotalHeight();
	        if (floatingTopHeight) {
	            // adding 1px for cell bottom border
	            floatingTopHeight += 1;
	        }
	        var floatingBottomHeight = pinnedRowModel.getPinnedBottomTotalHeight();
	        if (floatingBottomHeight) {
	            // adding 1px for cell bottom border
	            floatingBottomHeight += 1;
	        }
	        var floatingTopHeightString = floatingTopHeight + "px";
	        var floatingBottomHeightString = floatingBottomHeight + "px";
	        eTop.style.minHeight = floatingTopHeightString;
	        eTop.style.height = floatingTopHeightString;
	        eTop.style.display = floatingTopHeight ? 'inherit' : 'none';
	        eBottom.style.minHeight = floatingBottomHeightString;
	        eBottom.style.height = floatingBottomHeightString;
	        eBottom.style.display = floatingBottomHeight ? 'inherit' : 'none';
	        this.checkBodyHeight();
	    };
	    GridPanel.prototype.getBodyHeight = function () {
	        return this.bodyHeight;
	    };
	    // called by scrollHorizontally method and alignedGridsService
	    GridPanel.prototype.setHorizontalScrollPosition = function (hScrollPosition) {
	        this.eCenterViewport.scrollLeft = hScrollPosition;
	        // we need to manually do the event handling (rather than wait for the event)
	        // for the alignedGridsService, as if we don't, the aligned grid service gets
	        // notified async, and then it's 'consuming' flag doesn't get used right, and
	        // we can end up with an infinite loop
	        this.doHorizontalScroll(hScrollPosition);
	    };
	    GridPanel.prototype.setVerticalScrollPosition = function (vScrollPosition) {
	        this.eBodyViewport.scrollTop = vScrollPosition;
	    };
	    // called by the headerRootComp and moveColumnController
	    GridPanel.prototype.scrollHorizontally = function (pixels) {
	        var oldScrollPosition = this.eCenterViewport.scrollLeft;
	        this.setHorizontalScrollPosition(oldScrollPosition + pixels);
	        return this.eCenterViewport.scrollLeft - oldScrollPosition;
	    };
	    // called by rowDragFeature
	    GridPanel.prototype.scrollVertically = function (pixels) {
	        var oldScrollPosition = this.eBodyViewport.scrollTop;
	        this.setVerticalScrollPosition(oldScrollPosition + pixels);
	        return this.eBodyViewport.scrollTop - oldScrollPosition;
	    };
	    GridPanel.prototype.addScrollListener = function () {
	        this.addDestroyableEventListener(this.eCenterViewport, 'scroll', this.onCenterViewportScroll.bind(this));
	        this.addDestroyableEventListener(this.eBodyHorizontalScrollViewport, 'scroll', this.onFakeHorizontalScroll.bind(this));
	        this.addDestroyableEventListener(this.eBodyViewport, 'scroll', this.onVerticalScroll.bind(this));
	    };
	    GridPanel.prototype.onVerticalScroll = function () {
	        var scrollTop = this.eBodyViewport.scrollTop;
	        this.animationFrameService.setScrollTop(scrollTop);
	        this.nextScrollTop = scrollTop;
	        if (this.gridOptionsWrapper.isSuppressAnimationFrame()) {
	            this.redrawRowsAfterScroll();
	        }
	        else {
	            this.animationFrameService.schedule();
	        }
	    };
	    GridPanel.prototype.executeFrame = function () {
	        var frameNeeded = this.scrollTop !== this.nextScrollTop;
	        if (frameNeeded) {
	            this.scrollTop = this.nextScrollTop;
	            this.redrawRowsAfterScroll();
	        }
	        return frameNeeded;
	    };
	    GridPanel.prototype.isControllingScroll = function (eDiv) {
	        if (!this.lastHorizontalScrollElement) {
	            this.lastHorizontalScrollElement = eDiv;
	            return true;
	        }
	        return eDiv === this.lastHorizontalScrollElement;
	    };
	    GridPanel.prototype.onFakeHorizontalScroll = function () {
	        if (!this.isControllingScroll(this.eBodyHorizontalScrollViewport)) {
	            return;
	        }
	        this.onBodyHorizontalScroll(this.eBodyHorizontalScrollViewport);
	    };
	    GridPanel.prototype.onCenterViewportScroll = function () {
	        if (!this.isControllingScroll(this.eCenterViewport)) {
	            return;
	        }
	        this.onBodyHorizontalScroll(this.eCenterViewport);
	    };
	    GridPanel.prototype.onBodyHorizontalScroll = function (eSource) {
	        var _a = this.eCenterViewport, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
	        // in chrome, fractions can be in the scroll left, eg 250.342234 - which messes up our 'scrollWentPastBounds'
	        // formula. so we floor it to allow the formula to work.
	        var scrollLeft = Math.floor(utils_1._.getScrollLeft(eSource, this.enableRtl));
	        // touch devices allow elastic scroll - which temporally scrolls the panel outside of the viewport
	        // (eg user uses touch to go to the left of the grid, but drags past the left, the rows will actually
	        // scroll past the left until the user releases the mouse). when this happens, we want ignore the scroll,
	        // as otherwise it was causing the rows and header to flicker.
	        var scrollWentPastBounds = scrollLeft < 0 || (scrollLeft + clientWidth > scrollWidth);
	        if (scrollWentPastBounds) {
	            return;
	        }
	        this.doHorizontalScroll(scrollLeft);
	        this.resetLastHorizontalScrollElementDebounce();
	    };
	    GridPanel.prototype.resetLastHorizontalScrollElement = function () {
	        this.lastHorizontalScrollElement = null;
	    };
	    GridPanel.prototype.doHorizontalScroll = function (scrollLeft) {
	        this.scrollLeft = scrollLeft;
	        var event = {
	            type: events_1.Events.EVENT_BODY_SCROLL,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            direction: 'horizontal',
	            left: this.scrollLeft,
	            top: this.scrollTop
	        };
	        this.eventService.dispatchEvent(event);
	        this.horizontallyScrollHeaderCenterAndFloatingCenter(scrollLeft);
	        this.onHorizontalViewportChanged();
	    };
	    GridPanel.prototype.redrawRowsAfterScroll = function () {
	        var event = {
	            type: events_1.Events.EVENT_BODY_SCROLL,
	            direction: 'vertical',
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            left: this.scrollLeft,
	            top: this.scrollTop
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    // this gets called whenever a change in the viewport, so we can inform column controller it has to work
	    // out the virtual columns again. gets called from following locations:
	    // + ensureColVisible, scroll, init, layoutChanged, displayedColumnsChanged, API (doLayout)
	    GridPanel.prototype.onHorizontalViewportChanged = function () {
	        var scrollWidth = this.eCenterViewport.clientWidth;
	        var scrollPosition = this.getCenterViewportScrollLeft();
	        this.columnController.setVirtualViewportPosition(scrollWidth, scrollPosition);
	    };
	    GridPanel.prototype.getCenterViewportScrollLeft = function () {
	        // we defer to a util, as how you calculated scrollLeft when doing RTL depends on the browser
	        return utils_1._.getScrollLeft(this.eCenterViewport, this.enableRtl);
	    };
	    GridPanel.prototype.setCenterViewportScrollLeft = function (value) {
	        // we defer to a util, as how you calculated scrollLeft when doing RTL depends on the browser
	        utils_1._.setScrollLeft(this.eCenterViewport, value, this.enableRtl);
	    };
	    GridPanel.prototype.horizontallyScrollHeaderCenterAndFloatingCenter = function (scrollLeft) {
	        if (scrollLeft === undefined) {
	            scrollLeft = this.getCenterViewportScrollLeft();
	        }
	        var offset = this.enableRtl ? scrollLeft : -scrollLeft;
	        var _a = this.eCenterViewport, clientWidth = _a.clientWidth, scrollWidth = _a.scrollWidth;
	        var scrollWentPastBounds = Math.abs(offset) + clientWidth > scrollWidth;
	        if (scrollWentPastBounds ||
	            (this.enableRtl && offset < 0) ||
	            (!this.enableRtl && offset > 0)) {
	            return;
	        }
	        this.headerRootComp.setHorizontalScroll(offset);
	        this.eBottomContainer.style.transform = "translateX(" + offset + "px)";
	        this.eTopContainer.style.transform = "translateX(" + offset + "px)";
	        var partner = this.lastHorizontalScrollElement === this.eCenterViewport ? this.eBodyHorizontalScrollViewport : this.eCenterViewport;
	        utils_1._.setScrollLeft(partner, scrollLeft, this.enableRtl);
	    };
	    // + rangeController
	    GridPanel.prototype.addScrollEventListener = function (listener) {
	        this.eBodyViewport.addEventListener('scroll', listener);
	    };
	    // + rangeController
	    GridPanel.prototype.removeScrollEventListener = function (listener) {
	        this.eBodyViewport.removeEventListener('scroll', listener);
	    };
	    __decorate([
	        context_1.Autowired('alignedGridsService'),
	        __metadata("design:type", alignedGridsService_1.AlignedGridsService)
	    ], GridPanel.prototype, "alignedGridsService", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], GridPanel.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], GridPanel.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('rowRenderer'),
	        __metadata("design:type", rowRenderer_1.RowRenderer)
	    ], GridPanel.prototype, "rowRenderer", void 0);
	    __decorate([
	        context_1.Autowired('pinnedRowModel'),
	        __metadata("design:type", pinnedRowModel_1.PinnedRowModel)
	    ], GridPanel.prototype, "pinnedRowModel", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], GridPanel.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('animationFrameService'),
	        __metadata("design:type", animationFrameService_1.AnimationFrameService)
	    ], GridPanel.prototype, "animationFrameService", void 0);
	    __decorate([
	        context_1.Autowired('navigationService'),
	        __metadata("design:type", navigationService_1.NavigationService)
	    ], GridPanel.prototype, "navigationService", void 0);
	    __decorate([
	        context_1.Autowired('autoHeightCalculator'),
	        __metadata("design:type", autoHeightCalculator_1.AutoHeightCalculator)
	    ], GridPanel.prototype, "autoHeightCalculator", void 0);
	    __decorate([
	        context_1.Autowired('columnAnimationService'),
	        __metadata("design:type", columnAnimationService_1.ColumnAnimationService)
	    ], GridPanel.prototype, "columnAnimationService", void 0);
	    __decorate([
	        context_1.Autowired('autoWidthCalculator'),
	        __metadata("design:type", autoWidthCalculator_1.AutoWidthCalculator)
	    ], GridPanel.prototype, "autoWidthCalculator", void 0);
	    __decorate([
	        context_1.Autowired('paginationAutoPageSizeService'),
	        __metadata("design:type", paginationAutoPageSizeService_1.PaginationAutoPageSizeService)
	    ], GridPanel.prototype, "paginationAutoPageSizeService", void 0);
	    __decorate([
	        context_1.Autowired('beans'),
	        __metadata("design:type", beans_1.Beans)
	    ], GridPanel.prototype, "beans", void 0);
	    __decorate([
	        context_1.Autowired('paginationProxy'),
	        __metadata("design:type", paginationProxy_1.PaginationProxy)
	    ], GridPanel.prototype, "paginationProxy", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], GridPanel.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], GridPanel.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.Autowired('dragService'),
	        __metadata("design:type", dragService_1.DragService)
	    ], GridPanel.prototype, "dragService", void 0);
	    __decorate([
	        context_1.Autowired('mouseEventService'),
	        __metadata("design:type", mouseEventService_1.MouseEventService)
	    ], GridPanel.prototype, "mouseEventService", void 0);
	    __decorate([
	        context_1.Autowired('focusedCellController'),
	        __metadata("design:type", focusedCellController_1.FocusedCellController)
	    ], GridPanel.prototype, "focusedCellController", void 0);
	    __decorate([
	        context_1.Autowired('$scope'),
	        __metadata("design:type", Object)
	    ], GridPanel.prototype, "$scope", void 0);
	    __decorate([
	        context_1.Autowired('scrollVisibleService'),
	        __metadata("design:type", scrollVisibleService_1.ScrollVisibleService)
	    ], GridPanel.prototype, "scrollVisibleService", void 0);
	    __decorate([
	        context_1.Autowired('valueService'),
	        __metadata("design:type", valueService_1.ValueService)
	    ], GridPanel.prototype, "valueService", void 0);
	    __decorate([
	        context_1.Autowired('dragAndDropService'),
	        __metadata("design:type", dragAndDropService_1.DragAndDropService)
	    ], GridPanel.prototype, "dragAndDropService", void 0);
	    __decorate([
	        context_1.Autowired('maxDivHeightScaler'),
	        __metadata("design:type", maxDivHeightScaler_1.MaxDivHeightScaler)
	    ], GridPanel.prototype, "heightScaler", void 0);
	    __decorate([
	        context_1.Autowired('enterprise'),
	        __metadata("design:type", Boolean)
	    ], GridPanel.prototype, "enterprise", void 0);
	    __decorate([
	        context_1.Autowired('resizeObserverService'),
	        __metadata("design:type", resizeObserverService_1.ResizeObserverService)
	    ], GridPanel.prototype, "resizeObserverService", void 0);
	    __decorate([
	        context_1.Optional('rangeController'),
	        __metadata("design:type", Object)
	    ], GridPanel.prototype, "rangeController", void 0);
	    __decorate([
	        context_1.Optional('contextMenuFactory'),
	        __metadata("design:type", Object)
	    ], GridPanel.prototype, "contextMenuFactory", void 0);
	    __decorate([
	        context_1.Optional('clipboardService'),
	        __metadata("design:type", Object)
	    ], GridPanel.prototype, "clipboardService", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eBodyViewport'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eBodyViewport", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eCenterContainer'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eCenterContainer", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eCenterViewport'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eCenterViewport", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eLeftContainer'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eLeftContainer", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eRightContainer'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eRightContainer", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eCenterColsClipper'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eCenterColsClipper", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eHorizontalScrollBody'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eHorizontalScrollBody", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eHorizontalLeftSpacer'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eHorizontalLeftSpacer", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eHorizontalRightSpacer'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eHorizontalRightSpacer", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eBodyHorizontalScrollViewport'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eBodyHorizontalScrollViewport", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eBodyHorizontalScrollContainer'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eBodyHorizontalScrollContainer", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eFullWidthContainer'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eFullWidthContainer", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eTop'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eTop", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eLeftTop'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eLeftTop", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eRightTop'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eRightTop", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eTopContainer'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eTopContainer", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eTopViewport'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eTopViewport", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eTopFullWidthContainer'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eTopFullWidthContainer", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eBottom'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eBottom", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eLeftBottom'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eLeftBottom", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eRightBottom'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eRightBottom", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eBottomContainer'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eBottomContainer", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eBottomViewport'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eBottomViewport", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eBottomFullWidthContainer'),
	        __metadata("design:type", HTMLElement)
	    ], GridPanel.prototype, "eBottomFullWidthContainer", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('headerRoot'),
	        __metadata("design:type", headerRootComp_1.HeaderRootComp)
	    ], GridPanel.prototype, "headerRootComp", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('overlayWrapper'),
	        __metadata("design:type", overlayWrapperComponent_1.OverlayWrapperComponent)
	    ], GridPanel.prototype, "overlayWrapper", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], GridPanel.prototype, "init", null);
	    return GridPanel;
	}(component_1.Component));
	exports.GridPanel = GridPanel;


/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(10);
	var CssClassApplier = /** @class */ (function () {
	    function CssClassApplier() {
	    }
	    CssClassApplier.addHeaderClassesFromColDef = function (abstractColDef, eHeaderCell, gridOptionsWrapper, column, columnGroup) {
	        if (utils_1._.missing(abstractColDef)) {
	            return;
	        }
	        this.addColumnClassesFromCollDef(abstractColDef.headerClass, abstractColDef, eHeaderCell, gridOptionsWrapper, column, columnGroup);
	    };
	    CssClassApplier.addToolPanelClassesFromColDef = function (abstractColDef, eHeaderCell, gridOptionsWrapper, column, columnGroup) {
	        if (utils_1._.missing(abstractColDef)) {
	            return;
	        }
	        this.addColumnClassesFromCollDef(abstractColDef.toolPanelClass, abstractColDef, eHeaderCell, gridOptionsWrapper, column, columnGroup);
	    };
	    CssClassApplier.addColumnClassesFromCollDef = function (classesOrFunc, abstractColDef, eHeaderCell, gridOptionsWrapper, column, columnGroup) {
	        if (utils_1._.missing(classesOrFunc)) {
	            return;
	        }
	        var classToUse;
	        if (typeof classesOrFunc === 'function') {
	            var params = {
	                // bad naming, as colDef here can be a group or a column,
	                // however most people won't appreciate the difference,
	                // so keeping it as colDef to avoid confusion.
	                colDef: abstractColDef,
	                column: column,
	                columnGroup: columnGroup,
	                context: gridOptionsWrapper.getContext(),
	                api: gridOptionsWrapper.getApi()
	            };
	            var headerClassFunc = classesOrFunc;
	            classToUse = headerClassFunc(params);
	        }
	        else {
	            classToUse = classesOrFunc;
	        }
	        if (typeof classToUse === 'string') {
	            utils_1._.addCssClass(eHeaderCell, classToUse);
	        }
	        else if (Array.isArray(classToUse)) {
	            classToUse.forEach(function (cssClassItem) {
	                utils_1._.addCssClass(eHeaderCell, cssClassItem);
	            });
	        }
	    };
	    return CssClassApplier;
	}());
	exports.CssClassApplier = CssClassApplier;


/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var columnController_1 = __webpack_require__(26);
	var column_1 = __webpack_require__(45);
	var context_1 = __webpack_require__(8);
	var headerContainer_1 = __webpack_require__(654);
	var eventService_1 = __webpack_require__(22);
	var events_1 = __webpack_require__(29);
	var component_1 = __webpack_require__(31);
	var componentAnnotations_1 = __webpack_require__(39);
	var gridApi_1 = __webpack_require__(33);
	var autoWidthCalculator_1 = __webpack_require__(250);
	var constants_1 = __webpack_require__(30);
	var utils_1 = __webpack_require__(10);
	var HeaderRootComp = /** @class */ (function (_super) {
	    __extends(HeaderRootComp, _super);
	    function HeaderRootComp() {
	        return _super.call(this, HeaderRootComp.TEMPLATE) || this;
	    }
	    HeaderRootComp.prototype.registerGridComp = function (gridPanel) {
	        this.gridPanel = gridPanel;
	        this.childContainers.forEach(function (c) { return c.registerGridComp(gridPanel); });
	    };
	    HeaderRootComp.prototype.postConstruct = function () {
	        var _this = this;
	        this.printLayout = this.gridOptionsWrapper.getDomLayout() === constants_1.Constants.DOM_LAYOUT_PRINT;
	        this.gridApi.registerHeaderRootComp(this);
	        this.autoWidthCalculator.registerHeaderRootComp(this);
	        var centerContainer = new headerContainer_1.HeaderContainer(this.eHeaderContainer, this.eHeaderViewport, null);
	        var pinnedLeftContainer = new headerContainer_1.HeaderContainer(this.ePinnedLeftHeader, null, column_1.Column.PINNED_LEFT);
	        var pinnedRightContainer = new headerContainer_1.HeaderContainer(this.ePinnedRightHeader, null, column_1.Column.PINNED_RIGHT);
	        this.childContainers = [centerContainer, pinnedLeftContainer, pinnedRightContainer];
	        this.childContainers.forEach(function (container) { return _this.getContext().wireBean(container); });
	        // shotgun way to get labels to change, eg from sum(amount) to avg(amount)
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_COLUMN_VALUE_CHANGED, this.refreshHeader.bind(this));
	        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_DOM_LAYOUT, this.onDomLayoutChanged.bind(this));
	        // for setting ag-pivot-on / ag-pivot-off CSS classes
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.onPivotModeChanged.bind(this));
	        this.onPivotModeChanged();
	        this.addPreventHeaderScroll();
	        if (this.columnController.isReady()) {
	            this.refreshHeader();
	        }
	    };
	    HeaderRootComp.prototype.onDomLayoutChanged = function () {
	        var newValue = this.gridOptionsWrapper.getDomLayout() === constants_1.Constants.DOM_LAYOUT_PRINT;
	        if (this.printLayout !== newValue) {
	            this.printLayout = newValue;
	            this.refreshHeader();
	        }
	    };
	    HeaderRootComp.prototype.setHorizontalScroll = function (offset) {
	        this.eHeaderContainer.style.transform = "translateX(" + offset + "px)";
	    };
	    HeaderRootComp.prototype.forEachHeaderElement = function (callback) {
	        this.childContainers.forEach(function (childContainer) { return childContainer.forEachHeaderElement(callback); });
	    };
	    HeaderRootComp.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        this.childContainers.forEach(function (container) { return container.destroy(); });
	    };
	    HeaderRootComp.prototype.refreshHeader = function () {
	        this.childContainers.forEach(function (container) { return container.refresh(); });
	    };
	    HeaderRootComp.prototype.onPivotModeChanged = function () {
	        var pivotMode = this.columnController.isPivotMode();
	        utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-pivot-on', pivotMode);
	        utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-pivot-off', !pivotMode);
	    };
	    HeaderRootComp.prototype.setHeight = function (height) {
	        var px = height + "px";
	        this.getGui().style.height = px;
	        this.getGui().style.minHeight = px;
	    };
	    // if the user is in floating filter and hits tab a few times, the header can
	    // end up scrolling to show items off the screen, leaving the grid and header
	    // and the grid columns no longer in sync.
	    HeaderRootComp.prototype.addPreventHeaderScroll = function () {
	        var _this = this;
	        this.addDestroyableEventListener(this.eHeaderViewport, 'scroll', function () {
	            // if the header scrolls, the header will be out of sync. so we reset the
	            // header scroll, and then scroll the body, which will in turn set the offset
	            // on the header, giving the impression that the header scrolled as expected.
	            var scrollLeft = _this.eHeaderViewport.scrollLeft;
	            if (scrollLeft !== 0) {
	                _this.gridPanel.scrollHorizontally(scrollLeft);
	                _this.eHeaderViewport.scrollLeft = 0;
	            }
	        });
	    };
	    HeaderRootComp.prototype.setHeaderContainerWidth = function (width) {
	        this.eHeaderContainer.style.width = width + "px";
	    };
	    HeaderRootComp.prototype.setLeftVisible = function (visible) {
	        utils_1._.setDisplayed(this.ePinnedLeftHeader, visible);
	    };
	    HeaderRootComp.prototype.setRightVisible = function (visible) {
	        utils_1._.setDisplayed(this.ePinnedRightHeader, visible);
	    };
	    HeaderRootComp.prototype.getHeaderRowCount = function () {
	        if (this.childContainers.length === 0) {
	            return 0;
	        }
	        return this.childContainers[0].getRowComps().length;
	    };
	    HeaderRootComp.TEMPLATE = "<div class=\"ag-header\" role=\"presentation\">\n            <div class=\"ag-pinned-left-header\" ref=\"ePinnedLeftHeader\" role=\"presentation\"></div>\n            <div class=\"ag-header-viewport\" ref=\"eHeaderViewport\" role=\"presentation\">\n                <div class=\"ag-header-container\" ref=\"eHeaderContainer\" role=\"rowgroup\"></div>\n            </div>\n            <div class=\"ag-pinned-right-header\" ref=\"ePinnedRightHeader\" role=\"presentation\"></div>\n        </div>";
	    __decorate([
	        componentAnnotations_1.RefSelector('ePinnedLeftHeader'),
	        __metadata("design:type", HTMLElement)
	    ], HeaderRootComp.prototype, "ePinnedLeftHeader", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('ePinnedRightHeader'),
	        __metadata("design:type", HTMLElement)
	    ], HeaderRootComp.prototype, "ePinnedRightHeader", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eHeaderContainer'),
	        __metadata("design:type", HTMLElement)
	    ], HeaderRootComp.prototype, "eHeaderContainer", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eHeaderViewport'),
	        __metadata("design:type", HTMLElement)
	    ], HeaderRootComp.prototype, "eHeaderViewport", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], HeaderRootComp.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], HeaderRootComp.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], HeaderRootComp.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], HeaderRootComp.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.Autowired('autoWidthCalculator'),
	        __metadata("design:type", autoWidthCalculator_1.AutoWidthCalculator)
	    ], HeaderRootComp.prototype, "autoWidthCalculator", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], HeaderRootComp.prototype, "postConstruct", null);
	    return HeaderRootComp;
	}(component_1.Component));
	exports.HeaderRootComp = HeaderRootComp;


/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var beanStub_1 = __webpack_require__(71);
	var context_1 = __webpack_require__(8);
	var columnHoverService_1 = __webpack_require__(252);
	var HoverFeature = /** @class */ (function (_super) {
	    __extends(HoverFeature, _super);
	    function HoverFeature(columns, element) {
	        var _this = _super.call(this) || this;
	        _this.columns = columns;
	        _this.element = element;
	        return _this;
	    }
	    HoverFeature.prototype.postConstruct = function () {
	        this.addMouseHoverListeners();
	    };
	    HoverFeature.prototype.addMouseHoverListeners = function () {
	        this.addDestroyableEventListener(this.element, 'mouseout', this.onMouseOut.bind(this));
	        this.addDestroyableEventListener(this.element, 'mouseover', this.onMouseOver.bind(this));
	    };
	    HoverFeature.prototype.onMouseOut = function () {
	        this.columnHoverService.clearMouseOver();
	    };
	    HoverFeature.prototype.onMouseOver = function () {
	        this.columnHoverService.setMouseOver(this.columns);
	    };
	    __decorate([
	        context_1.Autowired('columnHoverService'),
	        __metadata("design:type", columnHoverService_1.ColumnHoverService)
	    ], HoverFeature.prototype, "columnHoverService", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], HoverFeature.prototype, "postConstruct", null);
	    return HoverFeature;
	}(beanStub_1.BeanStub));
	exports.HoverFeature = HoverFeature;


/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var beans_1 = __webpack_require__(161);
	var cellComp_1 = __webpack_require__(251);
	var columnController_1 = __webpack_require__(26);
	var utils_1 = __webpack_require__(10);
	var AutoHeightCalculator = /** @class */ (function () {
	    function AutoHeightCalculator() {
	    }
	    AutoHeightCalculator.prototype.registerGridComp = function (gridPanel) {
	        this.gridPanel = gridPanel;
	    };
	    AutoHeightCalculator.prototype.getPreferredHeightForRow = function (rowNode) {
	        var _this = this;
	        if (!this.eDummyContainer) {
	            this.eDummyContainer = document.createElement('div');
	            // so any styles on row also get applied in dummy, otherwise
	            // the content in dummy may differ to the real
	            utils_1._.addCssClass(this.eDummyContainer, 'ag-row ag-row-no-focus');
	        }
	        // we put the dummy into the body container, so it will inherit all the
	        // css styles that the real cells are inheriting
	        var eBodyContainer = this.gridPanel.getCenterContainer();
	        eBodyContainer.appendChild(this.eDummyContainer);
	        var cellComps = [];
	        var autoRowHeightCols = this.columnController.getAllAutoRowHeightCols();
	        var visibleAutoRowHeightCols = autoRowHeightCols.filter(function (col) { return col.isVisible(); });
	        visibleAutoRowHeightCols.forEach(function (col) {
	            var cellComp = new cellComp_1.CellComp(_this.$scope, _this.beans, col, rowNode, null, true, false);
	            cellComp.setParentRow(_this.eDummyContainer);
	            cellComps.push(cellComp);
	        });
	        var template = cellComps.map(function (cellComp) { return cellComp.getCreateTemplate(); }).join(' ');
	        this.eDummyContainer.innerHTML = template;
	        // this gets any cellComps that are using components to put the components in
	        cellComps.forEach(function (cellComp) { return cellComp.afterAttached(); });
	        // we should be able to just take the height of the row at this point, however
	        // the row isn't expanding to cover the cell heights, i don't know why, i couldn't
	        // figure it out so instead looking at the individual cells instead
	        var maxCellHeight = 0;
	        for (var i = 0; i < this.eDummyContainer.children.length; i++) {
	            var child = this.eDummyContainer.children[i];
	            if (child.offsetHeight > maxCellHeight) {
	                maxCellHeight = child.offsetHeight;
	            }
	        }
	        // we are finished with the dummy container, so get rid of it
	        eBodyContainer.removeChild(this.eDummyContainer);
	        cellComps.forEach(function (cellComp) {
	            // dunno why we need to detach first, doing it here to be consistent with code in RowComp
	            cellComp.detach();
	            cellComp.destroy();
	        });
	        // in case anything left over from last time
	        utils_1._.clearElement(this.eDummyContainer);
	        return maxCellHeight;
	    };
	    __decorate([
	        context_1.Autowired('beans'),
	        __metadata("design:type", beans_1.Beans)
	    ], AutoHeightCalculator.prototype, "beans", void 0);
	    __decorate([
	        context_1.Autowired("$scope"),
	        __metadata("design:type", Object)
	    ], AutoHeightCalculator.prototype, "$scope", void 0);
	    __decorate([
	        context_1.Autowired("columnController"),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], AutoHeightCalculator.prototype, "columnController", void 0);
	    AutoHeightCalculator = __decorate([
	        context_1.Bean('autoHeightCalculator')
	    ], AutoHeightCalculator);
	    return AutoHeightCalculator;
	}());
	exports.AutoHeightCalculator = AutoHeightCalculator;


/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var popupComponent_1 = __webpack_require__(200);
	var context_1 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var utils_1 = __webpack_require__(10);
	var PopupEditorWrapper = /** @class */ (function (_super) {
	    __extends(PopupEditorWrapper, _super);
	    function PopupEditorWrapper(cellEditor) {
	        var _this = _super.call(this, "<div class=\"ag-popup-editor\" tabindex=\"-1\"/>") || this;
	        _this.getGuiCalledOnChild = false;
	        _this.cellEditor = cellEditor;
	        return _this;
	    }
	    PopupEditorWrapper.prototype.onKeyDown = function (event) {
	        if (!utils_1._.isUserSuppressingKeyboardEvent(this.gridOptionsWrapper, event, this.params.node, this.params.column, true)) {
	            this.params.onKeyDown(event);
	        }
	    };
	    PopupEditorWrapper.prototype.getGui = function () {
	        // we call getGui() on child here (rather than in the constructor)
	        // as we should wait for 'init' to be called on child first.
	        if (!this.getGuiCalledOnChild) {
	            this.appendChild(this.cellEditor.getGui());
	            this.getGuiCalledOnChild = true;
	        }
	        return _super.prototype.getGui.call(this);
	    };
	    PopupEditorWrapper.prototype.init = function (params) {
	        var _this = this;
	        this.params = params;
	        this.gridOptionsWrapper.setDomData(this.getGui(), PopupEditorWrapper.DOM_KEY_POPUP_EDITOR_WRAPPER, true);
	        this.addDestroyFunc(function () {
	            if (_this.cellEditor.destroy) {
	                _this.cellEditor.destroy();
	            }
	        });
	        this.addDestroyableEventListener(
	        // this needs to be 'super' and not 'this' as if we call 'this',
	        // it ends up called 'getGui()' on the child before 'init' was called,
	        // which is not good
	        _super.prototype.getGui.call(this), 'keydown', this.onKeyDown.bind(this));
	    };
	    PopupEditorWrapper.prototype.afterGuiAttached = function () {
	        if (this.cellEditor.afterGuiAttached) {
	            this.cellEditor.afterGuiAttached();
	        }
	    };
	    PopupEditorWrapper.prototype.getValue = function () {
	        return this.cellEditor.getValue();
	    };
	    PopupEditorWrapper.prototype.isCancelBeforeStart = function () {
	        if (this.cellEditor.isCancelBeforeStart) {
	            return this.cellEditor.isCancelBeforeStart();
	        }
	    };
	    PopupEditorWrapper.prototype.isCancelAfterEnd = function () {
	        if (this.cellEditor.isCancelAfterEnd) {
	            return this.cellEditor.isCancelAfterEnd();
	        }
	    };
	    PopupEditorWrapper.prototype.focusIn = function () {
	        if (this.cellEditor.focusIn) {
	            this.cellEditor.focusIn();
	        }
	    };
	    PopupEditorWrapper.prototype.focusOut = function () {
	        if (this.cellEditor.focusOut) {
	            this.cellEditor.focusOut();
	        }
	    };
	    PopupEditorWrapper.DOM_KEY_POPUP_EDITOR_WRAPPER = 'popupEditorWrapper';
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], PopupEditorWrapper.prototype, "gridOptionsWrapper", void 0);
	    return PopupEditorWrapper;
	}(popupComponent_1.PopupComponent));
	exports.PopupEditorWrapper = PopupEditorWrapper;


/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var popupComponent_1 = __webpack_require__(200);
	var constants_1 = __webpack_require__(30);
	var context_1 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var valueFormatterService_1 = __webpack_require__(253);
	var utils_1 = __webpack_require__(10);
	var SelectCellEditor = /** @class */ (function (_super) {
	    __extends(SelectCellEditor, _super);
	    function SelectCellEditor() {
	        var _this = _super.call(this, '<div class="ag-cell-edit-input"><select class="ag-cell-edit-input"/></div>') || this;
	        _this.eSelect = _this.getGui().querySelector('select');
	        return _this;
	    }
	    SelectCellEditor.prototype.init = function (params) {
	        var _this = this;
	        this.focusAfterAttached = params.cellStartedEdit;
	        if (utils_1._.missing(params.values)) {
	            console.warn('ag-Grid: no values found for select cellEditor');
	            return;
	        }
	        params.values.forEach(function (value) {
	            var option = document.createElement('option');
	            option.value = value;
	            var valueFormatted = _this.valueFormatterService.formatValue(params.column, null, null, value);
	            var valueFormattedExits = valueFormatted !== null && valueFormatted !== undefined;
	            option.text = valueFormattedExits ? valueFormatted : value;
	            if (params.value === value) {
	                option.selected = true;
	            }
	            _this.eSelect.appendChild(option);
	        });
	        // we don't want to add this if full row editing, otherwise selecting will stop the
	        // full row editing.
	        if (!this.gridOptionsWrapper.isFullRowEdit()) {
	            this.addDestroyableEventListener(this.eSelect, 'change', function () { return params.stopEditing(); });
	        }
	        this.addDestroyableEventListener(this.eSelect, 'keydown', function (event) {
	            var isNavigationKey = event.keyCode === constants_1.Constants.KEY_UP || event.keyCode === constants_1.Constants.KEY_DOWN;
	            if (isNavigationKey) {
	                event.stopPropagation();
	            }
	        });
	        this.addDestroyableEventListener(this.eSelect, 'mousedown', function (event) {
	            event.stopPropagation();
	        });
	    };
	    SelectCellEditor.prototype.afterGuiAttached = function () {
	        if (this.focusAfterAttached) {
	            this.eSelect.focus();
	        }
	    };
	    SelectCellEditor.prototype.focusIn = function () {
	        this.eSelect.focus();
	    };
	    SelectCellEditor.prototype.getValue = function () {
	        return this.eSelect.value;
	    };
	    SelectCellEditor.prototype.isPopup = function () {
	        return false;
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], SelectCellEditor.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('valueFormatterService'),
	        __metadata("design:type", valueFormatterService_1.ValueFormatterService)
	    ], SelectCellEditor.prototype, "valueFormatterService", void 0);
	    return SelectCellEditor;
	}(popupComponent_1.PopupComponent));
	exports.SelectCellEditor = SelectCellEditor;


/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var constants_1 = __webpack_require__(30);
	var popupComponent_1 = __webpack_require__(200);
	var utils_1 = __webpack_require__(10);
	var TextCellEditor = /** @class */ (function (_super) {
	    __extends(TextCellEditor, _super);
	    function TextCellEditor() {
	        var _this = _super.call(this, TextCellEditor.TEMPLATE) || this;
	        _this.eInput = _this.getGui().querySelector('input');
	        return _this;
	    }
	    TextCellEditor.prototype.init = function (params) {
	        this.params = params;
	        var eInput = this.eInput;
	        var startValue;
	        // cellStartedEdit is only false if we are doing fullRow editing
	        if (params.cellStartedEdit) {
	            this.focusAfterAttached = true;
	            var keyPressBackspaceOrDelete = params.keyPress === constants_1.Constants.KEY_BACKSPACE
	                || params.keyPress === constants_1.Constants.KEY_DELETE;
	            if (keyPressBackspaceOrDelete) {
	                startValue = '';
	            }
	            else if (params.charPress) {
	                startValue = params.charPress;
	            }
	            else {
	                startValue = this.getStartValue(params);
	                if (params.keyPress !== constants_1.Constants.KEY_F2) {
	                    this.highlightAllOnFocus = true;
	                }
	            }
	        }
	        else {
	            this.focusAfterAttached = false;
	            startValue = this.getStartValue(params);
	        }
	        if (utils_1._.exists(startValue)) {
	            eInput.value = startValue;
	        }
	        this.addDestroyableEventListener(eInput, 'keydown', function (event) {
	            var pageUp = event.keyCode === constants_1.Constants.KEY_PAGE_UP;
	            var pageDown = event.keyCode === constants_1.Constants.KEY_PAGE_DOWN;
	            if (pageUp || pageDown) {
	                event.preventDefault();
	            }
	        });
	    };
	    TextCellEditor.prototype.afterGuiAttached = function () {
	        if (!this.focusAfterAttached) {
	            return;
	        }
	        var eInput = this.eInput;
	        eInput.focus();
	        if (this.highlightAllOnFocus) {
	            eInput.select();
	        }
	        else {
	            // when we started editing, we want the caret at the end, not the start.
	            // this comes into play in two scenarios: a) when user hits F2 and b)
	            // when user hits a printable character, then on IE (and only IE) the caret
	            // was placed after the first character, thus 'apply' would end up as 'pplea'
	            var length_1 = eInput.value ? eInput.value.length : 0;
	            if (length_1 > 0) {
	                eInput.setSelectionRange(length_1, length_1);
	            }
	        }
	    };
	    // gets called when tabbing trough cells and in full row edit mode
	    TextCellEditor.prototype.focusIn = function () {
	        var eInput = this.eInput;
	        eInput.focus();
	        eInput.select();
	    };
	    TextCellEditor.prototype.getValue = function () {
	        var eInput = this.eInput;
	        return this.params.parseValue(eInput.value);
	    };
	    TextCellEditor.prototype.getStartValue = function (params) {
	        var formatValue = params.useFormatter || params.column.getColDef().refData;
	        return formatValue ? params.formatValue(params.value) : params.value;
	    };
	    TextCellEditor.prototype.isPopup = function () {
	        return false;
	    };
	    TextCellEditor.TEMPLATE = '<div class="ag-input-wrapper" role="presentation"><input class="ag-cell-edit-input" type="text"/></div>';
	    return TextCellEditor;
	}(popupComponent_1.PopupComponent));
	exports.TextCellEditor = TextCellEditor;


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(31);
	var utils_1 = __webpack_require__(10);
	var filterManager_1 = __webpack_require__(77);
	var context_1 = __webpack_require__(8);
	var ARROW_UP = '\u2191';
	var ARROW_DOWN = '\u2193';
	var AnimateShowChangeCellRenderer = /** @class */ (function (_super) {
	    __extends(AnimateShowChangeCellRenderer, _super);
	    function AnimateShowChangeCellRenderer() {
	        var _this = _super.call(this, AnimateShowChangeCellRenderer.TEMPLATE) || this;
	        _this.refreshCount = 0;
	        return _this;
	    }
	    AnimateShowChangeCellRenderer.prototype.init = function (params) {
	        // this.params = params;
	        this.eValue = this.queryForHtmlElement('.ag-value-change-value');
	        this.eDelta = this.queryForHtmlElement('.ag-value-change-delta');
	        this.refresh(params);
	    };
	    AnimateShowChangeCellRenderer.prototype.showDelta = function (params, delta) {
	        var absDelta = Math.abs(delta);
	        var valueFormatted = params.formatValue(absDelta);
	        var valueToUse = utils_1._.exists(valueFormatted) ? valueFormatted : absDelta;
	        var deltaUp = (delta >= 0);
	        if (deltaUp) {
	            this.eDelta.innerHTML = ARROW_UP + valueToUse;
	        }
	        else {
	            // because negative, use ABS to remove sign
	            this.eDelta.innerHTML = ARROW_DOWN + valueToUse;
	        }
	        // class makes it green (in ag-fresh)
	        utils_1._.addOrRemoveCssClass(this.eDelta, 'ag-value-change-delta-up', deltaUp);
	        // class makes it red (in ag-fresh)
	        utils_1._.addOrRemoveCssClass(this.eDelta, 'ag-value-change-delta-down', !deltaUp);
	    };
	    AnimateShowChangeCellRenderer.prototype.setTimerToRemoveDelta = function () {
	        var _this = this;
	        // the refreshCount makes sure that if the value updates again while
	        // the below timer is waiting, then the below timer will realise it
	        // is not the most recent and will not try to remove the delta value.
	        this.refreshCount++;
	        var refreshCountCopy = this.refreshCount;
	        window.setTimeout(function () {
	            if (refreshCountCopy === _this.refreshCount) {
	                _this.hideDeltaValue();
	            }
	        }, 2000);
	    };
	    AnimateShowChangeCellRenderer.prototype.hideDeltaValue = function () {
	        utils_1._.removeCssClass(this.eValue, 'ag-value-change-value-highlight');
	        utils_1._.clearElement(this.eDelta);
	    };
	    AnimateShowChangeCellRenderer.prototype.refresh = function (params) {
	        var value = params.value;
	        if (value === this.lastValue) {
	            return;
	        }
	        if (utils_1._.exists(params.valueFormatted)) {
	            this.eValue.innerHTML = params.valueFormatted;
	        }
	        else if (utils_1._.exists(params.value)) {
	            this.eValue.innerHTML = value;
	        }
	        else {
	            utils_1._.clearElement(this.eValue);
	        }
	        // we don't show the delta if we are in the middle of a filter. see comment on FilterManager
	        // with regards processingFilterChange
	        if (this.filterManager.isSuppressFlashingCellsBecauseFiltering()) {
	            return;
	        }
	        if (typeof value === 'number' && typeof this.lastValue === 'number') {
	            var delta = value - this.lastValue;
	            this.showDelta(params, delta);
	        }
	        // highlight the current value, but only if it's not new, otherwise it
	        // would get highlighted first time the value is shown
	        if (this.lastValue) {
	            utils_1._.addCssClass(this.eValue, 'ag-value-change-value-highlight');
	        }
	        this.setTimerToRemoveDelta();
	        this.lastValue = value;
	        return true;
	    };
	    AnimateShowChangeCellRenderer.TEMPLATE = '<span>' +
	        '<span class="ag-value-change-delta"></span>' +
	        '<span class="ag-value-change-value"></span>' +
	        '</span>';
	    __decorate([
	        context_1.Autowired('filterManager'),
	        __metadata("design:type", filterManager_1.FilterManager)
	    ], AnimateShowChangeCellRenderer.prototype, "filterManager", void 0);
	    return AnimateShowChangeCellRenderer;
	}(component_1.Component));
	exports.AnimateShowChangeCellRenderer = AnimateShowChangeCellRenderer;


/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(31);
	var utils_1 = __webpack_require__(10);
	var context_1 = __webpack_require__(8);
	var filterManager_1 = __webpack_require__(77);
	var AnimateSlideCellRenderer = /** @class */ (function (_super) {
	    __extends(AnimateSlideCellRenderer, _super);
	    function AnimateSlideCellRenderer() {
	        var _this = _super.call(this, AnimateSlideCellRenderer.TEMPLATE) || this;
	        _this.refreshCount = 0;
	        _this.eCurrent = _this.queryForHtmlElement('.ag-value-slide-current');
	        return _this;
	    }
	    AnimateSlideCellRenderer.prototype.init = function (params) {
	        this.params = params;
	        this.refresh(params);
	    };
	    AnimateSlideCellRenderer.prototype.addSlideAnimation = function () {
	        var _this = this;
	        this.refreshCount++;
	        // below we keep checking this, and stop working on the animation
	        // if it no longer matches - this means another animation has started
	        // and this one is stale.
	        var refreshCountCopy = this.refreshCount;
	        // if old animation, remove it
	        if (this.ePrevious) {
	            this.getGui().removeChild(this.ePrevious);
	        }
	        this.ePrevious = utils_1._.loadTemplate('<span class="ag-value-slide-previous ag-value-slide-out"></span>');
	        this.ePrevious.innerHTML = this.eCurrent.innerHTML;
	        this.getGui().insertBefore(this.ePrevious, this.eCurrent);
	        // having timeout of 0 allows use to skip to the next css turn,
	        // so we know the previous css classes have been applied. so the
	        // complex set of setTimeout below creates the animation
	        window.setTimeout(function () {
	            if (refreshCountCopy !== _this.refreshCount) {
	                return;
	            }
	            utils_1._.addCssClass(_this.ePrevious, 'ag-value-slide-out-end');
	        }, 50);
	        window.setTimeout(function () {
	            if (refreshCountCopy !== _this.refreshCount) {
	                return;
	            }
	            _this.getGui().removeChild(_this.ePrevious);
	            _this.ePrevious = null;
	        }, 3000);
	    };
	    AnimateSlideCellRenderer.prototype.refresh = function (params) {
	        var value = params.value;
	        if (utils_1._.missing(value)) {
	            value = '';
	        }
	        if (value === this.lastValue) {
	            return;
	        }
	        // we don't show the delta if we are in the middle of a filter. see comment on FilterManager
	        // with regards processingFilterChange
	        if (this.filterManager.isSuppressFlashingCellsBecauseFiltering()) {
	            return;
	        }
	        this.addSlideAnimation();
	        this.lastValue = value;
	        if (utils_1._.exists(params.valueFormatted)) {
	            this.eCurrent.innerHTML = params.valueFormatted;
	        }
	        else if (utils_1._.exists(params.value)) {
	            this.eCurrent.innerHTML = value;
	        }
	        else {
	            utils_1._.clearElement(this.eCurrent);
	        }
	        return true;
	    };
	    AnimateSlideCellRenderer.TEMPLATE = '<span>' +
	        '<span class="ag-value-slide-current"></span>' +
	        '</span>';
	    __decorate([
	        context_1.Autowired('filterManager'),
	        __metadata("design:type", filterManager_1.FilterManager)
	    ], AnimateSlideCellRenderer.prototype, "filterManager", void 0);
	    return AnimateSlideCellRenderer;
	}(component_1.Component));
	exports.AnimateSlideCellRenderer = AnimateSlideCellRenderer;


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var expressionService_1 = __webpack_require__(121);
	var eventService_1 = __webpack_require__(22);
	var constants_1 = __webpack_require__(30);
	var context_1 = __webpack_require__(8);
	var component_1 = __webpack_require__(31);
	var rowNode_1 = __webpack_require__(101);
	var valueFormatterService_1 = __webpack_require__(253);
	var checkboxSelectionComponent_1 = __webpack_require__(440);
	var columnController_1 = __webpack_require__(26);
	var column_1 = __webpack_require__(45);
	var componentAnnotations_1 = __webpack_require__(39);
	var mouseEventService_1 = __webpack_require__(248);
	var userComponentFactory_1 = __webpack_require__(81);
	var utils_1 = __webpack_require__(10);
	var GroupCellRenderer = /** @class */ (function (_super) {
	    __extends(GroupCellRenderer, _super);
	    function GroupCellRenderer() {
	        return _super.call(this, GroupCellRenderer.TEMPLATE) || this;
	    }
	    GroupCellRenderer.prototype.init = function (params) {
	        this.params = params;
	        if (this.gridOptionsWrapper.isGroupIncludeTotalFooter()) {
	            this.assignBlankValueToGroupFooterCell(params);
	        }
	        var embeddedRowMismatch = this.isEmbeddedRowMismatch();
	        // This allows for empty strings to appear as groups since
	        // it will only return for null or undefined.
	        var cellIsEmpty = params.value == null;
	        this.cellIsBlank = embeddedRowMismatch || cellIsEmpty;
	        if (this.cellIsBlank) {
	            return;
	        }
	        this.setupDragOpenParents();
	        this.addExpandAndContract();
	        this.addCheckboxIfNeeded();
	        this.addValueElement();
	        this.setupIndent();
	    };
	    GroupCellRenderer.prototype.assignBlankValueToGroupFooterCell = function (params) {
	        // this is not ideal, but it was the only way we could get footer working for the root node
	        if (!params.value && params.node.level == -1) {
	            params.value = '';
	        }
	    };
	    // if we are doing embedded full width rows, we only show the renderer when
	    // in the body, or if pinning in the pinned section, or if pinning and RTL,
	    // in the right section. otherwise we would have the cell repeated in each section.
	    GroupCellRenderer.prototype.isEmbeddedRowMismatch = function () {
	        if (this.params.fullWidth && this.gridOptionsWrapper.isEmbedFullWidthRows()) {
	            var pinnedLeftCell = this.params.pinned === column_1.Column.PINNED_LEFT;
	            var pinnedRightCell = this.params.pinned === column_1.Column.PINNED_RIGHT;
	            var bodyCell = !pinnedLeftCell && !pinnedRightCell;
	            if (this.gridOptionsWrapper.isEnableRtl()) {
	                if (this.columnController.isPinningLeft()) {
	                    return !pinnedRightCell;
	                }
	                else {
	                    return !bodyCell;
	                }
	            }
	            else {
	                if (this.columnController.isPinningLeft()) {
	                    return !pinnedLeftCell;
	                }
	                else {
	                    return !bodyCell;
	                }
	            }
	        }
	        else {
	            return false;
	        }
	    };
	    GroupCellRenderer.prototype.setIndent = function () {
	        if (this.gridOptionsWrapper.isGroupHideOpenParents()) {
	            return;
	        }
	        var params = this.params;
	        var rowNode = params.node;
	        var paddingCount = rowNode.uiLevel;
	        var userProvidedPaddingPixelsTheDeprecatedWay = params.padding >= 0;
	        if (userProvidedPaddingPixelsTheDeprecatedWay) {
	            this.setPaddingDeprecatedWay(paddingCount, params.padding);
	            return;
	        }
	        if (this.indentClass) {
	            this.removeCssClass(this.indentClass);
	        }
	        this.indentClass = 'ag-row-group-indent-' + paddingCount;
	        this.addCssClass(this.indentClass);
	    };
	    GroupCellRenderer.prototype.setPaddingDeprecatedWay = function (paddingCount, padding) {
	        utils_1._.doOnce(function () { return console.warn('ag-Grid: since v14.2, configuring padding for groupCellRenderer should be done with Sass variables and themes. Please see the ag-Grid documentation page for Themes, in particular the property $row-group-indent-size.'); }, 'groupCellRenderer->doDeprecatedWay');
	        var paddingPx = paddingCount * padding;
	        if (this.gridOptionsWrapper.isEnableRtl()) {
	            // if doing rtl, padding is on the right
	            this.getGui().style.paddingRight = paddingPx + 'px';
	        }
	        else {
	            // otherwise it is on the left
	            this.getGui().style.paddingLeft = paddingPx + 'px';
	        }
	    };
	    GroupCellRenderer.prototype.setupIndent = function () {
	        // only do this if an indent - as this overwrites the padding that
	        // the theme set, which will make things look 'not aligned' for the
	        // first group level.
	        var node = this.params.node;
	        var suppressPadding = this.params.suppressPadding;
	        if (!suppressPadding) {
	            this.addDestroyableEventListener(node, rowNode_1.RowNode.EVENT_UI_LEVEL_CHANGED, this.setIndent.bind(this));
	            this.setIndent();
	        }
	    };
	    GroupCellRenderer.prototype.addValueElement = function () {
	        var params = this.params;
	        var rowNode = this.displayedGroup;
	        if (rowNode.footer) {
	            this.createFooterCell();
	        }
	        else if (rowNode.hasChildren() ||
	            utils_1._.get(params.colDef, 'cellRendererParams.innerRenderer', null) ||
	            utils_1._.get(params.colDef, 'cellRendererParams.innerRendererFramework', null)) {
	            this.createGroupCell();
	            if (rowNode.hasChildren()) {
	                this.addChildCount();
	            }
	        }
	        else {
	            this.createLeafCell();
	        }
	    };
	    GroupCellRenderer.prototype.createFooterCell = function () {
	        var footerValue;
	        var footerValueGetter = this.params.footerValueGetter;
	        if (footerValueGetter) {
	            // params is same as we were given, except we set the value as the item to display
	            var paramsClone = utils_1._.cloneObject(this.params);
	            paramsClone.value = this.params.value;
	            if (typeof footerValueGetter === 'function') {
	                footerValue = footerValueGetter(paramsClone);
	            }
	            else if (typeof footerValueGetter === 'string') {
	                footerValue = this.expressionService.evaluate(footerValueGetter, paramsClone);
	            }
	            else {
	                console.warn('ag-Grid: footerValueGetter should be either a function or a string (expression)');
	            }
	        }
	        else {
	            footerValue = 'Total ' + this.params.value;
	        }
	        this.eValue.innerHTML = footerValue;
	    };
	    GroupCellRenderer.prototype.createGroupCell = function () {
	        var _this = this;
	        var params = this.params;
	        var rowGroupColumn = this.displayedGroup.rowGroupColumn;
	        // we try and use the cellRenderer of the column used for the grouping if we can
	        var columnToUse = rowGroupColumn ? rowGroupColumn : params.column;
	        var groupName = this.params.value;
	        var valueFormatted = columnToUse ?
	            this.valueFormatterService.formatValue(columnToUse, params.node, params.scope, groupName) : null;
	        params.valueFormatted = valueFormatted;
	        var rendererPromise;
	        if (params.fullWidth == true) {
	            rendererPromise = this.useFullWidth(params);
	        }
	        else {
	            rendererPromise = this.useInnerRenderer(this.params.colDef.cellRendererParams, columnToUse.getColDef(), params);
	        }
	        // retain a reference to the created renderer - we'll use this later for cleanup (in destroy)
	        if (rendererPromise) {
	            rendererPromise.then(function (value) {
	                _this.innerCellRenderer = value;
	            });
	        }
	    };
	    GroupCellRenderer.prototype.useInnerRenderer = function (groupCellRendererParams, groupedColumnDef, // the column this group row is for, eg 'Country'
	    params) {
	        // when grouping, the normal case is we use the cell renderer of the grouped column. eg if grouping by country
	        // and then rating, we will use the country cell renderer for each country group row and likewise the rating
	        // cell renderer for each rating group row.
	        //
	        // however if the user has innerCellRenderer defined, this gets preference and we don't use cell renderers
	        // of the grouped columns.
	        //
	        // so we check and use in the following order:
	        //
	        // 1) thisColDef.cellRendererParams.innerRenderer of the column showing the groups (eg auto group column)
	        // 2) groupedColDef.cellRenderer of the grouped column
	        // 3) groupedColDef.cellRendererParams.innerRenderer
	        var _this = this;
	        var cellRendererPromise = null;
	        // we check if cell renderer provided for the group cell renderer, eg colDef.cellRendererParams.innerRenderer
	        var groupInnerRendererClass = this.userComponentFactory
	            .lookupComponentClassDef(groupCellRendererParams, "innerRenderer");
	        if (groupInnerRendererClass && groupInnerRendererClass.component != null
	            && groupInnerRendererClass.source != userComponentFactory_1.ComponentSource.DEFAULT) {
	            // use the renderer defined in cellRendererParams.innerRenderer
	            cellRendererPromise = this.userComponentFactory.newInnerCellRenderer(groupCellRendererParams, params);
	        }
	        else {
	            // otherwise see if we can use the cellRenderer of the column we are grouping by
	            var groupColumnRendererClass = this.userComponentFactory
	                .lookupComponentClassDef(groupedColumnDef, "cellRenderer");
	            if (groupColumnRendererClass && groupColumnRendererClass.source != userComponentFactory_1.ComponentSource.DEFAULT) {
	                // Only if the original column is using a specific renderer, it it is a using a DEFAULT one ignore it
	                cellRendererPromise = this.userComponentFactory.newCellRenderer(groupedColumnDef, params);
	            }
	            else if (groupColumnRendererClass && groupColumnRendererClass.source == userComponentFactory_1.ComponentSource.DEFAULT
	                && (utils_1._.get(groupedColumnDef, 'cellRendererParams.innerRenderer', null))) {
	                // EDGE CASE - THIS COMES FROM A COLUMN WHICH HAS BEEN GROUPED DYNAMICALLY, THAT HAS AS RENDERER 'group'
	                // AND HAS A INNER CELL RENDERER
	                cellRendererPromise = this.userComponentFactory.newInnerCellRenderer(groupedColumnDef.cellRendererParams, params);
	            }
	            else {
	                // This forces the retrieval of the default plain cellRenderer that just renders the values.
	                cellRendererPromise = this.userComponentFactory.newCellRenderer({}, params);
	            }
	        }
	        if (cellRendererPromise != null) {
	            cellRendererPromise.then(function (rendererToUse) {
	                if (rendererToUse == null) {
	                    _this.eValue.innerText = params.valueFormatted != null ? params.valueFormatted : params.value;
	                    return;
	                }
	                utils_1._.bindCellRendererToHtmlElement(cellRendererPromise, _this.eValue);
	            });
	        }
	        else {
	            this.eValue.innerText = params.valueFormatted != null ? params.valueFormatted : params.value;
	        }
	        return cellRendererPromise;
	    };
	    GroupCellRenderer.prototype.useFullWidth = function (params) {
	        var cellRendererPromise = this.userComponentFactory.newFullWidthGroupRowInnerCellRenderer(params);
	        if (cellRendererPromise != null) {
	            utils_1._.bindCellRendererToHtmlElement(cellRendererPromise, this.eValue);
	        }
	        else {
	            this.eValue.innerText = params.valueFormatted != null ? params.valueFormatted : params.value;
	        }
	        return cellRendererPromise;
	    };
	    GroupCellRenderer.prototype.addChildCount = function () {
	        // only include the child count if it's included, eg if user doing custom aggregation,
	        // then this could be left out, or set to -1, ie no child count
	        if (this.params.suppressCount) {
	            return;
	        }
	        this.addDestroyableEventListener(this.displayedGroup, rowNode_1.RowNode.EVENT_ALL_CHILDREN_COUNT_CHANGED, this.updateChildCount.bind(this));
	        // filtering changes the child count, so need to cater for it
	        this.updateChildCount();
	    };
	    GroupCellRenderer.prototype.updateChildCount = function () {
	        var allChildrenCount = this.displayedGroup.allChildrenCount;
	        this.eChildCount.innerHTML = allChildrenCount >= 0 ? "(" + allChildrenCount + ")" : "";
	    };
	    GroupCellRenderer.prototype.createLeafCell = function () {
	        if (utils_1._.exists(this.params.value)) {
	            this.eValue.innerText = this.params.valueFormatted ? this.params.valueFormatted : this.params.value;
	        }
	    };
	    GroupCellRenderer.prototype.isUserWantsSelected = function () {
	        var paramsCheckbox = this.params.checkbox;
	        if (typeof paramsCheckbox === 'function') {
	            return paramsCheckbox(this.params);
	        }
	        else {
	            return paramsCheckbox === true;
	        }
	    };
	    GroupCellRenderer.prototype.addCheckboxIfNeeded = function () {
	        var rowNode = this.displayedGroup;
	        var checkboxNeeded = this.isUserWantsSelected()
	            // footers cannot be selected
	            && !rowNode.footer
	            // pinned rows cannot be selected
	            && !rowNode.rowPinned
	            // details cannot be selected
	            && !rowNode.detail;
	        if (checkboxNeeded) {
	            var cbSelectionComponent_1 = new checkboxSelectionComponent_1.CheckboxSelectionComponent();
	            this.getContext().wireBean(cbSelectionComponent_1);
	            cbSelectionComponent_1.init({ rowNode: rowNode, column: this.params.column });
	            this.eCheckbox.appendChild(cbSelectionComponent_1.getGui());
	            this.addDestroyFunc(function () { return cbSelectionComponent_1.destroy(); });
	        }
	        utils_1._.addOrRemoveCssClass(this.eCheckbox, 'ag-invisible', !checkboxNeeded);
	    };
	    GroupCellRenderer.prototype.addExpandAndContract = function () {
	        var params = this.params;
	        var eGroupCell = params.eGridCell;
	        var eExpandedIcon = utils_1._.createIconNoSpan('groupExpanded', this.gridOptionsWrapper, null);
	        var eContractedIcon = utils_1._.createIconNoSpan('groupContracted', this.gridOptionsWrapper, null);
	        this.eExpanded.appendChild(eExpandedIcon);
	        this.eContracted.appendChild(eContractedIcon);
	        this.addDestroyableEventListener(this.eExpanded, 'click', this.onExpandClicked.bind(this));
	        this.addDestroyableEventListener(this.eContracted, 'click', this.onExpandClicked.bind(this));
	        // expand / contract as the user hits enter
	        this.addDestroyableEventListener(eGroupCell, 'keydown', this.onKeyDown.bind(this));
	        this.addDestroyableEventListener(params.node, rowNode_1.RowNode.EVENT_EXPANDED_CHANGED, this.showExpandAndContractIcons.bind(this));
	        this.showExpandAndContractIcons();
	        // because we don't show the expand / contract when there are no children, we need to check every time
	        // the number of children change.
	        this.addDestroyableEventListener(this.displayedGroup, rowNode_1.RowNode.EVENT_ALL_CHILDREN_COUNT_CHANGED, this.onAllChildrenCountChanged.bind(this));
	        // if editing groups, then double click is to start editing
	        if (!this.gridOptionsWrapper.isEnableGroupEdit() && this.isExpandable() && !params.suppressDoubleClickExpand) {
	            this.addDestroyableEventListener(eGroupCell, 'dblclick', this.onCellDblClicked.bind(this));
	        }
	    };
	    GroupCellRenderer.prototype.onAllChildrenCountChanged = function () {
	        // maybe if no children now, we should hide the expand / contract icons
	        this.showExpandAndContractIcons();
	        // if we have no children, this impacts the indent
	        this.setIndent();
	    };
	    GroupCellRenderer.prototype.onKeyDown = function (event) {
	        var enterKeyPressed = utils_1._.isKeyPressed(event, constants_1.Constants.KEY_ENTER);
	        if (enterKeyPressed) {
	            if (this.params.suppressEnterExpand) {
	                return;
	            }
	            var cellEditable = this.params.column && this.params.column.isCellEditable(this.params.node);
	            if (cellEditable) {
	                return;
	            }
	            event.preventDefault();
	            this.onExpandOrContract();
	        }
	    };
	    GroupCellRenderer.prototype.setupDragOpenParents = function () {
	        var column = this.params.column;
	        var rowNode = this.params.node;
	        if (!this.gridOptionsWrapper.isGroupHideOpenParents()) {
	            this.draggedFromHideOpenParents = false;
	        }
	        else if (!rowNode.hasChildren()) {
	            // if we are here, and we are not a group, then we must of been dragged down,
	            // as otherwise the cell would be blank, and if cell is blank, this method is never called.
	            this.draggedFromHideOpenParents = true;
	        }
	        else {
	            var rowGroupColumn = rowNode.rowGroupColumn;
	            if (rowGroupColumn) {
	                // if the displayGroup column for this col matches the rowGroupColumn we grouped by for this node,
	                // then nothing was dragged down
	                this.draggedFromHideOpenParents = !column.isRowGroupDisplayed(rowGroupColumn.getId());
	            }
	            else {
	                // the only way we can end up here (no column, but a group) is if we are at the root node,
	                // which only happens when 'groupIncludeTotalFooter' is true. here, we are never dragging
	                this.draggedFromHideOpenParents = false;
	            }
	        }
	        if (this.draggedFromHideOpenParents) {
	            var pointer = rowNode.parent;
	            while (true) {
	                if (utils_1._.missing(pointer)) {
	                    break;
	                }
	                if (pointer.rowGroupColumn && column.isRowGroupDisplayed(pointer.rowGroupColumn.getId())) {
	                    this.displayedGroup = pointer;
	                    break;
	                }
	                pointer = pointer.parent;
	            }
	        }
	        // if we didn't find a displayed group, set it to the row node
	        if (utils_1._.missing(this.displayedGroup)) {
	            this.displayedGroup = rowNode;
	        }
	    };
	    GroupCellRenderer.prototype.onExpandClicked = function (mouseEvent) {
	        if (utils_1._.isStopPropagationForAgGrid(mouseEvent)) {
	            return;
	        }
	        // so if we expand a node, it does not also get selected.
	        utils_1._.stopPropagationForAgGrid(mouseEvent);
	        this.onExpandOrContract();
	    };
	    GroupCellRenderer.prototype.onCellDblClicked = function (mouseEvent) {
	        if (utils_1._.isStopPropagationForAgGrid(mouseEvent)) {
	            return;
	        }
	        // we want to avoid acting on double click events on the expand / contract icon,
	        // as that icons already has expand / collapse functionality on it. otherwise if
	        // the icon was double clicked, we would get 'click', 'click', 'dblclick' which
	        // is open->close->open, however double click should be open->close only.
	        var targetIsExpandIcon = utils_1._.isElementInEventPath(this.eExpanded, mouseEvent)
	            || utils_1._.isElementInEventPath(this.eContracted, mouseEvent);
	        if (!targetIsExpandIcon) {
	            this.onExpandOrContract();
	        }
	    };
	    GroupCellRenderer.prototype.onExpandOrContract = function () {
	        // must use the displayedGroup, so if data was dragged down, we expand the parent, not this row
	        var rowNode = this.displayedGroup;
	        rowNode.setExpanded(!rowNode.expanded);
	    };
	    GroupCellRenderer.prototype.isExpandable = function () {
	        var rowNode = this.params.node;
	        var reducedLeafNode = this.columnController.isPivotMode() && rowNode.leafGroup;
	        return this.draggedFromHideOpenParents ||
	            (rowNode.isExpandable() && !rowNode.footer && !reducedLeafNode);
	    };
	    GroupCellRenderer.prototype.showExpandAndContractIcons = function () {
	        var rowNode = this.params.node;
	        if (this.isExpandable()) {
	            // if expandable, show one based on expand state.
	            // if we were dragged down, means our parent is always expanded
	            var expanded = this.draggedFromHideOpenParents ? true : rowNode.expanded;
	            utils_1._.setDisplayed(this.eContracted, !expanded);
	            utils_1._.setDisplayed(this.eExpanded, expanded);
	        }
	        else {
	            // it not expandable, show neither
	            utils_1._.setDisplayed(this.eExpanded, false);
	            utils_1._.setDisplayed(this.eContracted, false);
	        }
	        var displayedGroup = this.displayedGroup;
	        // compensation padding for leaf nodes, so there is blank space instead of the expand icon
	        var pivotModeAndLeafGroup = this.columnController.isPivotMode() && displayedGroup.leafGroup;
	        var notExpandable = !displayedGroup.isExpandable();
	        var addLeafIndentClass = displayedGroup.footer || notExpandable || pivotModeAndLeafGroup;
	        this.addOrRemoveCssClass('ag-row-group', !addLeafIndentClass);
	        this.addOrRemoveCssClass('ag-row-group-leaf-indent', addLeafIndentClass);
	    };
	    GroupCellRenderer.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        if (this.innerCellRenderer && this.innerCellRenderer.destroy) {
	            this.innerCellRenderer.destroy();
	        }
	    };
	    GroupCellRenderer.prototype.refresh = function () {
	        return false;
	    };
	    GroupCellRenderer.TEMPLATE = '<span class="ag-cell-wrapper">' +
	        '<span class="ag-group-expanded" ref="eExpanded"></span>' +
	        '<span class="ag-group-contracted" ref="eContracted"></span>' +
	        '<span class="ag-group-checkbox ag-invisible" ref="eCheckbox"></span>' +
	        '<span class="ag-group-value" ref="eValue"></span>' +
	        '<span class="ag-group-child-count" ref="eChildCount"></span>' +
	        '</span>';
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], GroupCellRenderer.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('expressionService'),
	        __metadata("design:type", expressionService_1.ExpressionService)
	    ], GroupCellRenderer.prototype, "expressionService", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], GroupCellRenderer.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('valueFormatterService'),
	        __metadata("design:type", valueFormatterService_1.ValueFormatterService)
	    ], GroupCellRenderer.prototype, "valueFormatterService", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], GroupCellRenderer.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('mouseEventService'),
	        __metadata("design:type", mouseEventService_1.MouseEventService)
	    ], GroupCellRenderer.prototype, "mouseEventService", void 0);
	    __decorate([
	        context_1.Autowired('userComponentFactory'),
	        __metadata("design:type", userComponentFactory_1.UserComponentFactory)
	    ], GroupCellRenderer.prototype, "userComponentFactory", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eExpanded'),
	        __metadata("design:type", HTMLElement)
	    ], GroupCellRenderer.prototype, "eExpanded", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eContracted'),
	        __metadata("design:type", HTMLElement)
	    ], GroupCellRenderer.prototype, "eContracted", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eCheckbox'),
	        __metadata("design:type", HTMLElement)
	    ], GroupCellRenderer.prototype, "eCheckbox", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eValue'),
	        __metadata("design:type", HTMLElement)
	    ], GroupCellRenderer.prototype, "eValue", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eChildCount'),
	        __metadata("design:type", HTMLElement)
	    ], GroupCellRenderer.prototype, "eChildCount", void 0);
	    return GroupCellRenderer;
	}(component_1.Component));
	exports.GroupCellRenderer = GroupCellRenderer;


/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(31);
	var rowNode_1 = __webpack_require__(101);
	var context_1 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var events_1 = __webpack_require__(29);
	var eventService_1 = __webpack_require__(22);
	var gridApi_1 = __webpack_require__(33);
	var columnApi_1 = __webpack_require__(38);
	var utils_1 = __webpack_require__(10);
	var CheckboxSelectionComponent = /** @class */ (function (_super) {
	    __extends(CheckboxSelectionComponent, _super);
	    function CheckboxSelectionComponent() {
	        return _super.call(this, "<span class=\"ag-selection-checkbox\" unselectable=\"on\"/>") || this;
	    }
	    CheckboxSelectionComponent.prototype.createAndAddIcons = function () {
	        this.eCheckedIcon = utils_1._.createIconNoSpan('checkboxChecked', this.gridOptionsWrapper, this.column);
	        this.eUncheckedIcon = utils_1._.createIconNoSpan('checkboxUnchecked', this.gridOptionsWrapper, this.column);
	        this.eIndeterminateIcon = utils_1._.createIconNoSpan('checkboxIndeterminate', this.gridOptionsWrapper, this.column);
	        var element = this.getGui();
	        element.appendChild(this.eCheckedIcon);
	        element.appendChild(this.eUncheckedIcon);
	        element.appendChild(this.eIndeterminateIcon);
	    };
	    CheckboxSelectionComponent.prototype.onDataChanged = function () {
	        // when rows are loaded for the second time, this can impact the selection, as a row
	        // could be loaded as already selected (if user scrolls down, and then up again).
	        this.onSelectionChanged();
	    };
	    CheckboxSelectionComponent.prototype.onSelectableChanged = function () {
	        this.showOrHideSelect();
	    };
	    CheckboxSelectionComponent.prototype.onSelectionChanged = function () {
	        var state = this.rowNode.isSelected();
	        utils_1._.setDisplayed(this.eCheckedIcon, state === true);
	        utils_1._.setDisplayed(this.eUncheckedIcon, state === false);
	        utils_1._.setDisplayed(this.eIndeterminateIcon, typeof state !== 'boolean');
	    };
	    CheckboxSelectionComponent.prototype.onCheckedClicked = function () {
	        var groupSelectsFiltered = this.gridOptionsWrapper.isGroupSelectsFiltered();
	        var updatedCount = this.rowNode.setSelectedParams({ newValue: false, groupSelectsFiltered: groupSelectsFiltered });
	        return updatedCount;
	    };
	    CheckboxSelectionComponent.prototype.onUncheckedClicked = function (event) {
	        var groupSelectsFiltered = this.gridOptionsWrapper.isGroupSelectsFiltered();
	        var updatedCount = this.rowNode.setSelectedParams({ newValue: true, rangeSelect: event.shiftKey, groupSelectsFiltered: groupSelectsFiltered });
	        return updatedCount;
	    };
	    CheckboxSelectionComponent.prototype.onIndeterminateClicked = function (event) {
	        var result = this.onUncheckedClicked(event);
	        if (result === 0) {
	            this.onCheckedClicked();
	        }
	    };
	    CheckboxSelectionComponent.prototype.init = function (params) {
	        this.rowNode = params.rowNode;
	        this.column = params.column;
	        this.createAndAddIcons();
	        this.onSelectionChanged();
	        // we don't want the row clicked event to fire when selecting the checkbox, otherwise the row
	        // would possibly get selected twice
	        this.addGuiEventListener('click', function (event) { return utils_1._.stopPropagationForAgGrid(event); });
	        // likewise we don't want double click on this icon to open a group
	        this.addGuiEventListener('dblclick', function (event) { return utils_1._.stopPropagationForAgGrid(event); });
	        this.addDestroyableEventListener(this.eCheckedIcon, 'click', this.onCheckedClicked.bind(this));
	        this.addDestroyableEventListener(this.eUncheckedIcon, 'click', this.onUncheckedClicked.bind(this));
	        this.addDestroyableEventListener(this.eIndeterminateIcon, 'click', this.onIndeterminateClicked.bind(this));
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_ROW_SELECTED, this.onSelectionChanged.bind(this));
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_DATA_CHANGED, this.onDataChanged.bind(this));
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_SELECTABLE_CHANGED, this.onSelectableChanged.bind(this));
	        this.isRowSelectableFunc = this.gridOptionsWrapper.getIsRowSelectableFunc();
	        var checkboxVisibleIsDynamic = this.isRowSelectableFunc || this.checkboxCallbackExists();
	        if (checkboxVisibleIsDynamic) {
	            this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.showOrHideSelect.bind(this));
	            this.showOrHideSelect();
	        }
	    };
	    CheckboxSelectionComponent.prototype.showOrHideSelect = function () {
	        // if the isRowSelectable() is not provided the row node is selectable by default
	        var selectable = this.rowNode.selectable;
	        // checkboxSelection callback is deemed a legacy solution however we will still consider it's result.
	        // If selectable, then also check the colDef callback. if not selectable, this it short circuits - no need
	        // to call the colDef callback.
	        if (selectable && this.checkboxCallbackExists()) {
	            selectable = this.column.isCellCheckboxSelection(this.rowNode);
	        }
	        // show checkbox if both conditions are true
	        this.setDisplayed(selectable);
	    };
	    CheckboxSelectionComponent.prototype.checkboxCallbackExists = function () {
	        // column will be missing if groupUseEntireRow=true
	        var colDef = this.column ? this.column.getColDef() : null;
	        return colDef && typeof colDef.checkboxSelection === 'function';
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], CheckboxSelectionComponent.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], CheckboxSelectionComponent.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], CheckboxSelectionComponent.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], CheckboxSelectionComponent.prototype, "columnApi", void 0);
	    return CheckboxSelectionComponent;
	}(component_1.Component));
	exports.CheckboxSelectionComponent = CheckboxSelectionComponent;


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var cellComp_1 = __webpack_require__(251);
	var rowNode_1 = __webpack_require__(101);
	var column_1 = __webpack_require__(45);
	var events_1 = __webpack_require__(29);
	var component_1 = __webpack_require__(31);
	var utils_1 = __webpack_require__(10);
	var RowComp = /** @class */ (function (_super) {
	    __extends(RowComp, _super);
	    function RowComp(parentScope, bodyContainerComp, pinnedLeftContainerComp, pinnedRightContainerComp, fullWidthContainerComp, rowNode, beans, animateIn, useAnimationFrameForCreate, printLayout, embedFullWidth) {
	        var _this = _super.call(this) || this;
	        _this.eAllRowContainers = [];
	        _this.active = true;
	        _this.rowContainerReadyCount = 0;
	        _this.refreshNeeded = false;
	        _this.columnRefreshPending = false;
	        _this.cellComps = {};
	        // for animations, there are bits we want done in the next VM turn, to all DOM to update first.
	        // instead of each row doing a setTimeout(func,0), we put the functions here and the rowRenderer
	        // executes them all in one timeout
	        _this.createSecondPassFuncs = [];
	        // these get called before the row is destroyed - they set up the DOM for the remove animation (ie they
	        // set the DOM up for the animation), then the delayedDestroyFunctions get called when the animation is
	        // complete (ie removes from the dom).
	        _this.removeFirstPassFuncs = [];
	        // for animations, these functions get called 400ms after the row is cleared, called by the rowRenderer
	        // so each row isn't setting up it's own timeout
	        _this.removeSecondPassFuncs = [];
	        _this.initialised = false;
	        _this.parentScope = parentScope;
	        _this.beans = beans;
	        _this.bodyContainerComp = bodyContainerComp;
	        _this.pinnedLeftContainerComp = pinnedLeftContainerComp;
	        _this.pinnedRightContainerComp = pinnedRightContainerComp;
	        _this.fullWidthContainerComp = fullWidthContainerComp;
	        _this.rowNode = rowNode;
	        _this.rowIsEven = _this.rowNode.rowIndex % 2 === 0;
	        _this.paginationPage = _this.beans.paginationProxy.getCurrentPage();
	        _this.useAnimationFrameForCreate = useAnimationFrameForCreate;
	        _this.printLayout = printLayout;
	        _this.embedFullWidth = embedFullWidth;
	        _this.setAnimateFlags(animateIn);
	        return _this;
	    }
	    RowComp.prototype.init = function () {
	        var _this = this;
	        this.rowFocused = this.beans.focusedCellController.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned);
	        this.scope = this.createChildScopeOrNull(this.rowNode.data);
	        this.setupRowContainers();
	        this.addListeners();
	        if (this.slideRowIn) {
	            this.createSecondPassFuncs.push(function () {
	                _this.onTopChanged();
	            });
	        }
	        if (this.fadeRowIn) {
	            this.createSecondPassFuncs.push(function () {
	                _this.eAllRowContainers.forEach(function (eRow) { return utils_1._.removeCssClass(eRow, 'ag-opacity-zero'); });
	            });
	        }
	    };
	    RowComp.prototype.createTemplate = function (contents, extraCssClass) {
	        if (extraCssClass === void 0) { extraCssClass = null; }
	        var templateParts = [];
	        var rowHeight = this.rowNode.rowHeight;
	        var rowClasses = this.getInitialRowClasses(extraCssClass).join(' ');
	        var rowIdSanitised = utils_1._.escape(this.rowNode.id);
	        var userRowStyles = this.preProcessStylesFromGridOptions();
	        var businessKey = this.getRowBusinessKey();
	        var businessKeySanitised = utils_1._.escape(businessKey);
	        var rowTopStyle = this.getInitialRowTopStyle();
	        var rowIdx = this.rowNode.getRowIndexString();
	        var headerRowCount = this.beans.gridPanel.headerRootComp.getHeaderRowCount();
	        templateParts.push("<div");
	        templateParts.push(" role=\"row\"");
	        templateParts.push(" row-index=\"" + rowIdx + "\" aria-rowindex=\"" + (headerRowCount + this.rowNode.rowIndex + 1) + "\"");
	        templateParts.push(rowIdSanitised ? " row-id=\"" + rowIdSanitised + "\"" : "");
	        templateParts.push(businessKey ? " row-business-key=\"" + businessKeySanitised + "\"" : "");
	        templateParts.push(" comp-id=\"" + this.getCompId() + "\"");
	        templateParts.push(" class=\"" + rowClasses + "\"");
	        templateParts.push(" style=\"height: " + rowHeight + "px; " + rowTopStyle + " " + userRowStyles + "\">");
	        // add in the template for the cells
	        templateParts.push(contents);
	        templateParts.push("</div>");
	        return templateParts.join('');
	    };
	    RowComp.prototype.getCellForCol = function (column) {
	        var cellComp = this.cellComps[column.getColId()];
	        return cellComp ? cellComp.getGui() : null;
	    };
	    RowComp.prototype.afterFlush = function () {
	        if (this.initialised) {
	            return;
	        }
	        this.initialised = true;
	        this.executeProcessRowPostCreateFunc();
	    };
	    RowComp.prototype.executeProcessRowPostCreateFunc = function () {
	        var func = this.beans.gridOptionsWrapper.getProcessRowPostCreateFunc();
	        if (!func) {
	            return;
	        }
	        var params = {
	            eRow: this.eBodyRow,
	            ePinnedLeftRow: this.ePinnedLeftRow,
	            ePinnedRightRow: this.ePinnedRightRow,
	            node: this.rowNode,
	            api: this.beans.gridOptionsWrapper.getApi(),
	            rowIndex: this.rowNode.rowIndex,
	            addRenderedRowListener: this.addEventListener.bind(this),
	            columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
	            context: this.beans.gridOptionsWrapper.getContext()
	        };
	        func(params);
	    };
	    RowComp.prototype.getInitialRowTopStyle = function () {
	        // print layout uses normal flow layout for row positioning
	        if (this.printLayout) {
	            return '';
	        }
	        // if sliding in, we take the old row top. otherwise we just set the current row top.
	        var pixels = this.slideRowIn ? this.roundRowTopToBounds(this.rowNode.oldRowTop) : this.rowNode.rowTop;
	        var afterPaginationPixels = this.applyPaginationOffset(pixels);
	        var afterScalingPixels = this.beans.maxDivHeightScaler.getRealPixelPosition(afterPaginationPixels);
	        var isSuppressRowTransform = this.beans.gridOptionsWrapper.isSuppressRowTransform();
	        return isSuppressRowTransform ? "top: " + afterScalingPixels + "px; " : "transform: translateY(" + afterScalingPixels + "px);";
	    };
	    RowComp.prototype.getRowBusinessKey = function () {
	        var businessKeyForNodeFunc = this.beans.gridOptionsWrapper.getBusinessKeyForNodeFunc();
	        if (typeof businessKeyForNodeFunc !== 'function') {
	            return;
	        }
	        return businessKeyForNodeFunc(this.rowNode);
	    };
	    RowComp.prototype.areAllContainersReady = function () {
	        return this.rowContainerReadyCount === 3;
	    };
	    RowComp.prototype.lazyCreateCells = function (cols, eRow) {
	        if (!this.active) {
	            return;
	        }
	        var cellTemplatesAndComps = this.createCells(cols);
	        eRow.innerHTML = cellTemplatesAndComps.template;
	        this.callAfterRowAttachedOnCells(cellTemplatesAndComps.cellComps, eRow);
	        this.rowContainerReadyCount++;
	        if (this.areAllContainersReady() && this.refreshNeeded) {
	            this.refreshCells();
	        }
	    };
	    RowComp.prototype.createRowContainer = function (rowContainerComp, cols, callback) {
	        var _this = this;
	        var useAnimationsFrameForCreate = this.useAnimationFrameForCreate;
	        var cellTemplatesAndComps = useAnimationsFrameForCreate ? { cellComps: [], template: '' } : this.createCells(cols);
	        var rowTemplate = this.createTemplate(cellTemplatesAndComps.template);
	        // the RowRenderer is probably inserting many rows. rather than inserting each template one
	        // at a time, the grid inserts all rows together - so the callback here is called by the
	        // rowRenderer when all RowComps are created, then all the HTML is inserted in one go,
	        // and then all the callbacks are called. this is NOT done in an animation frame.
	        rowContainerComp.appendRowTemplate(rowTemplate, function () {
	            var eRow = rowContainerComp.getRowElement(_this.getCompId());
	            _this.afterRowAttached(rowContainerComp, eRow);
	            callback(eRow);
	            if (useAnimationsFrameForCreate) {
	                _this.beans.taskQueue.addP1Task(_this.lazyCreateCells.bind(_this, cols, eRow), _this.rowNode.rowIndex);
	            }
	            else {
	                _this.callAfterRowAttachedOnCells(cellTemplatesAndComps.cellComps, eRow);
	                _this.rowContainerReadyCount = 3;
	            }
	        });
	    };
	    RowComp.prototype.createChildScopeOrNull = function (data) {
	        var isAngularCompileRows = this.beans.gridOptionsWrapper.isAngularCompileRows();
	        if (!isAngularCompileRows) {
	            return null;
	        }
	        var newChildScope = this.parentScope.$new();
	        newChildScope.data = __assign({}, data);
	        newChildScope.rowNode = this.rowNode;
	        newChildScope.context = this.beans.gridOptionsWrapper.getContext();
	        this.addDestroyFunc(function () {
	            newChildScope.$destroy();
	            newChildScope.data = null;
	            newChildScope.rowNode = null;
	            newChildScope.context = null;
	        });
	        return newChildScope;
	    };
	    RowComp.prototype.setupRowContainers = function () {
	        var isFullWidthCellFunc = this.beans.gridOptionsWrapper.getIsFullWidthCellFunc();
	        var isFullWidthCell = isFullWidthCellFunc ? isFullWidthCellFunc(this.rowNode) : false;
	        var isDetailCell = this.beans.doingMasterDetail && this.rowNode.detail;
	        var pivotMode = this.beans.columnController.isPivotMode();
	        // we only use full width for groups, not footers. it wouldn't make sense to include footers if not looking
	        // for totals. if users complain about this, then we should introduce a new property 'footerUseEntireRow'
	        // so each can be set independently (as a customer complained about footers getting full width, hence
	        // introducing this logic)
	        var isGroupRow = this.rowNode.group && !this.rowNode.footer;
	        var isFullWidthGroup = isGroupRow && this.beans.gridOptionsWrapper.isGroupUseEntireRow(pivotMode);
	        if (this.rowNode.stub) {
	            this.createFullWidthRows(RowComp.LOADING_CELL_RENDERER, RowComp.LOADING_CELL_RENDERER_COMP_NAME);
	        }
	        else if (isDetailCell) {
	            this.createFullWidthRows(RowComp.DETAIL_CELL_RENDERER, RowComp.DETAIL_CELL_RENDERER_COMP_NAME);
	        }
	        else if (isFullWidthCell) {
	            this.createFullWidthRows(RowComp.FULL_WIDTH_CELL_RENDERER, null);
	        }
	        else if (isFullWidthGroup) {
	            this.createFullWidthRows(RowComp.GROUP_ROW_RENDERER, RowComp.GROUP_ROW_RENDERER_COMP_NAME);
	        }
	        else {
	            this.setupNormalRowContainers();
	        }
	    };
	    RowComp.prototype.setupNormalRowContainers = function () {
	        var _this = this;
	        var centerCols;
	        var leftCols;
	        var rightCols;
	        if (this.printLayout) {
	            centerCols = this.beans.columnController.getAllDisplayedColumns();
	            leftCols = [];
	            rightCols = [];
	        }
	        else {
	            centerCols = this.beans.columnController.getAllDisplayedCenterVirtualColumnsForRow(this.rowNode);
	            leftCols = this.beans.columnController.getDisplayedLeftColumnsForRow(this.rowNode);
	            rightCols = this.beans.columnController.getDisplayedRightColumnsForRow(this.rowNode);
	        }
	        this.createRowContainer(this.bodyContainerComp, centerCols, function (eRow) { return _this.eBodyRow = eRow; });
	        this.createRowContainer(this.pinnedRightContainerComp, rightCols, function (eRow) { return _this.ePinnedRightRow = eRow; });
	        this.createRowContainer(this.pinnedLeftContainerComp, leftCols, function (eRow) { return _this.ePinnedLeftRow = eRow; });
	    };
	    RowComp.prototype.createFullWidthRows = function (type, name) {
	        var _this = this;
	        this.fullWidthRow = true;
	        if (this.embedFullWidth) {
	            this.createFullWidthRowContainer(this.bodyContainerComp, null, null, type, name, function (eRow) {
	                _this.eFullWidthRowBody = eRow;
	            }, function (cellRenderer) {
	                _this.fullWidthRowComponentBody = cellRenderer;
	            });
	            // printLayout doesn't put components into the pinned sections
	            if (!this.printLayout) {
	                this.createFullWidthRowContainer(this.pinnedLeftContainerComp, column_1.Column.PINNED_LEFT, 'ag-cell-last-left-pinned', type, name, function (eRow) {
	                    _this.eFullWidthRowLeft = eRow;
	                }, function (cellRenderer) {
	                    _this.fullWidthRowComponentLeft = cellRenderer;
	                });
	                this.createFullWidthRowContainer(this.pinnedRightContainerComp, column_1.Column.PINNED_RIGHT, 'ag-cell-first-right-pinned', type, name, function (eRow) {
	                    _this.eFullWidthRowRight = eRow;
	                }, function (cellRenderer) {
	                    _this.fullWidthRowComponentRight = cellRenderer;
	                });
	            }
	        }
	        else {
	            // otherwise we add to the fullWidth container as normal
	            // let previousFullWidth = ensureDomOrder ? this.lastPlacedElements.eFullWidth : null;
	            this.createFullWidthRowContainer(this.fullWidthContainerComp, null, null, type, name, function (eRow) {
	                _this.eFullWidthRow = eRow;
	            }, function (cellRenderer) {
	                _this.fullWidthRowComponent = cellRenderer;
	            });
	        }
	    };
	    RowComp.prototype.setAnimateFlags = function (animateIn) {
	        if (animateIn) {
	            var oldRowTopExists = utils_1._.exists(this.rowNode.oldRowTop);
	            // if the row had a previous position, we slide it in (animate row top)
	            this.slideRowIn = oldRowTopExists;
	            // if the row had no previous position, we fade it in (animate
	            this.fadeRowIn = !oldRowTopExists;
	        }
	        else {
	            this.slideRowIn = false;
	            this.fadeRowIn = false;
	        }
	    };
	    RowComp.prototype.isEditing = function () {
	        return this.editingRow;
	    };
	    RowComp.prototype.stopRowEditing = function (cancel) {
	        this.stopEditing(cancel);
	    };
	    RowComp.prototype.isFullWidth = function () {
	        return this.fullWidthRow;
	    };
	    RowComp.prototype.refreshFullWidth = function () {
	        var _this = this;
	        // returns 'true' if refresh succeeded
	        var tryRefresh = function (eRow, eCellComp, pinned) {
	            if (!eRow || !eCellComp) {
	                // no refresh needed
	                return true;
	            }
	            if (!eCellComp.refresh) {
	                // no refresh method present, so can't refresh, hard refresh needed
	                return false;
	            }
	            var params = _this.createFullWidthParams(eRow, pinned);
	            var refreshSucceeded = eCellComp.refresh(params);
	            return refreshSucceeded;
	        };
	        var normalSuccess = tryRefresh(this.eFullWidthRow, this.fullWidthRowComponent, null);
	        var bodySuccess = tryRefresh(this.eFullWidthRowBody, this.fullWidthRowComponentBody, null);
	        var leftSuccess = tryRefresh(this.eFullWidthRowLeft, this.fullWidthRowComponentLeft, column_1.Column.PINNED_LEFT);
	        var rightSuccess = tryRefresh(this.eFullWidthRowRight, this.fullWidthRowComponentRight, column_1.Column.PINNED_RIGHT);
	        var allFullWidthRowsRefreshed = normalSuccess && bodySuccess && leftSuccess && rightSuccess;
	        return allFullWidthRowsRefreshed;
	    };
	    RowComp.prototype.addListeners = function () {
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_HEIGHT_CHANGED, this.onRowHeightChanged.bind(this));
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_ROW_SELECTED, this.onRowSelected.bind(this));
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_ROW_INDEX_CHANGED, this.onRowIndexChanged.bind(this));
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_TOP_CHANGED, this.onTopChanged.bind(this));
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_EXPANDED_CHANGED, this.onExpandedChanged.bind(this));
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_DATA_CHANGED, this.onRowNodeDataChanged.bind(this));
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_CELL_CHANGED, this.onRowNodeCellChanged.bind(this));
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_DRAGGING_CHANGED, this.onRowNodeDraggingChanged.bind(this));
	        var eventService = this.beans.eventService;
	        this.addDestroyableEventListener(eventService, events_1.Events.EVENT_HEIGHT_SCALE_CHANGED, this.onTopChanged.bind(this));
	        this.addDestroyableEventListener(eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
	        this.addDestroyableEventListener(eventService, events_1.Events.EVENT_VIRTUAL_COLUMNS_CHANGED, this.onVirtualColumnsChanged.bind(this));
	        this.addDestroyableEventListener(eventService, events_1.Events.EVENT_COLUMN_RESIZED, this.onColumnResized.bind(this));
	        this.addDestroyableEventListener(eventService, events_1.Events.EVENT_CELL_FOCUSED, this.onCellFocusChanged.bind(this));
	        this.addDestroyableEventListener(eventService, events_1.Events.EVENT_PAGINATION_CHANGED, this.onPaginationChanged.bind(this));
	        this.addDestroyableEventListener(eventService, events_1.Events.EVENT_GRID_COLUMNS_CHANGED, this.onGridColumnsChanged.bind(this));
	        this.addDestroyableEventListener(eventService, events_1.Events.EVENT_MODEL_UPDATED, this.onModelUpdated.bind(this));
	        this.addListenersForCellComps();
	    };
	    RowComp.prototype.addListenersForCellComps = function () {
	        var _this = this;
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_ROW_INDEX_CHANGED, function () {
	            _this.forEachCellComp(function (cellComp) { return cellComp.onRowIndexChanged(); });
	        });
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_CELL_CHANGED, function (event) {
	            _this.forEachCellComp(function (cellComp) { return cellComp.onCellChanged(event); });
	        });
	    };
	    // when grid columns change, then all cells should be cleaned out,
	    // as the new columns could have same id as the previous columns and may conflict
	    RowComp.prototype.onGridColumnsChanged = function () {
	        this.removeRenderedCells(Object.keys(this.cellComps));
	    };
	    RowComp.prototype.onRowNodeDataChanged = function (event) {
	        // if this is an update, we want to refresh, as this will allow the user to put in a transition
	        // into the cellRenderer refresh method. otherwise this might be completely new data, in which case
	        // we will want to completely replace the cells
	        this.forEachCellComp(function (cellComp) {
	            return cellComp.refreshCell({
	                suppressFlash: !event.update,
	                newData: !event.update
	            });
	        });
	        // check for selected also, as this could be after lazy loading of the row data, in which case
	        // the id might of just gotten set inside the row and the row selected state may of changed
	        // as a result. this is what happens when selected rows are loaded in virtual pagination.
	        // - niall note - since moving to the stub component, this may no longer be true, as replacing
	        // the stub component now replaces the entire row
	        this.onRowSelected();
	        // as data has changed, then the style and class needs to be recomputed
	        this.postProcessCss();
	    };
	    RowComp.prototype.onRowNodeCellChanged = function (event) {
	        // as data has changed, then the style and class needs to be recomputed
	        this.postProcessCss();
	    };
	    RowComp.prototype.postProcessCss = function () {
	        this.postProcessStylesFromGridOptions();
	        this.postProcessClassesFromGridOptions();
	        this.postProcessRowClassRules();
	        this.postProcessRowDragging();
	    };
	    RowComp.prototype.onRowNodeDraggingChanged = function () {
	        this.postProcessRowDragging();
	    };
	    RowComp.prototype.postProcessRowDragging = function () {
	        var dragging = this.rowNode.dragging;
	        this.eAllRowContainers.forEach(function (row) { return utils_1._.addOrRemoveCssClass(row, 'ag-row-dragging', dragging); });
	    };
	    RowComp.prototype.onExpandedChanged = function () {
	        var rowNode = this.rowNode;
	        this.eAllRowContainers.forEach(function (row) { return utils_1._.addOrRemoveCssClass(row, 'ag-row-group-expanded', rowNode.expanded); });
	        this.eAllRowContainers.forEach(function (row) { return utils_1._.addOrRemoveCssClass(row, 'ag-row-group-contracted', !rowNode.expanded); });
	    };
	    RowComp.prototype.onDisplayedColumnsChanged = function () {
	        if (this.fullWidthRow) {
	            return;
	        }
	        this.refreshCells();
	    };
	    RowComp.prototype.destroyFullWidthComponents = function () {
	        if (this.fullWidthRowComponent) {
	            this.beans.detailRowCompCache.addOrDestroy(this.rowNode, null, this.fullWidthRowComponent);
	            this.fullWidthRowComponent = null;
	        }
	        if (this.fullWidthRowComponentBody) {
	            this.beans.detailRowCompCache.addOrDestroy(this.rowNode, null, this.fullWidthRowComponentBody);
	            this.fullWidthRowComponent = null;
	        }
	        if (this.fullWidthRowComponentLeft) {
	            this.beans.detailRowCompCache.addOrDestroy(this.rowNode, column_1.Column.PINNED_LEFT, this.fullWidthRowComponentLeft);
	            this.fullWidthRowComponentLeft = null;
	        }
	        if (this.fullWidthRowComponentRight) {
	            this.beans.detailRowCompCache.addOrDestroy(this.rowNode, column_1.Column.PINNED_RIGHT, this.fullWidthRowComponentRight);
	            this.fullWidthRowComponent = null;
	        }
	    };
	    RowComp.prototype.getContainerForCell = function (pinnedType) {
	        switch (pinnedType) {
	            case column_1.Column.PINNED_LEFT: return this.ePinnedLeftRow;
	            case column_1.Column.PINNED_RIGHT: return this.ePinnedRightRow;
	            default: return this.eBodyRow;
	        }
	    };
	    RowComp.prototype.onVirtualColumnsChanged = function () {
	        if (this.fullWidthRow) {
	            return;
	        }
	        this.refreshCells();
	    };
	    RowComp.prototype.onColumnResized = function () {
	        if (this.fullWidthRow) {
	            return;
	        }
	        this.refreshCells();
	    };
	    RowComp.prototype.refreshCells = function () {
	        if (!this.areAllContainersReady()) {
	            this.refreshNeeded = true;
	            return;
	        }
	        var suppressAnimationFrame = this.beans.gridOptionsWrapper.isSuppressAnimationFrame();
	        var skipAnimationFrame = suppressAnimationFrame || this.printLayout;
	        if (skipAnimationFrame) {
	            this.refreshCellsInAnimationFrame();
	        }
	        else {
	            if (this.columnRefreshPending) {
	                return;
	            }
	            this.beans.taskQueue.addP1Task(this.refreshCellsInAnimationFrame.bind(this), this.rowNode.rowIndex);
	        }
	    };
	    RowComp.prototype.refreshCellsInAnimationFrame = function () {
	        if (!this.active) {
	            return;
	        }
	        this.columnRefreshPending = false;
	        var centerCols;
	        var leftCols;
	        var rightCols;
	        if (this.printLayout) {
	            centerCols = this.beans.columnController.getAllDisplayedColumns();
	            leftCols = [];
	            rightCols = [];
	        }
	        else {
	            centerCols = this.beans.columnController.getAllDisplayedCenterVirtualColumnsForRow(this.rowNode);
	            leftCols = this.beans.columnController.getDisplayedLeftColumnsForRow(this.rowNode);
	            rightCols = this.beans.columnController.getDisplayedRightColumnsForRow(this.rowNode);
	        }
	        this.insertCellsIntoContainer(this.eBodyRow, centerCols);
	        this.insertCellsIntoContainer(this.ePinnedLeftRow, leftCols);
	        this.insertCellsIntoContainer(this.ePinnedRightRow, rightCols);
	        var colIdsToRemove = Object.keys(this.cellComps);
	        centerCols.forEach(function (col) { return utils_1._.removeFromArray(colIdsToRemove, col.getId()); });
	        leftCols.forEach(function (col) { return utils_1._.removeFromArray(colIdsToRemove, col.getId()); });
	        rightCols.forEach(function (col) { return utils_1._.removeFromArray(colIdsToRemove, col.getId()); });
	        // we never remove editing cells, as this would cause the cells to loose their values while editing
	        // as the grid is scrolling horizontally.
	        var eligibleToBeRemoved = utils_1._.filter(colIdsToRemove, this.isCellEligibleToBeRemoved.bind(this));
	        // remove old cells from gui, but we don't destroy them, we might use them again
	        this.removeRenderedCells(eligibleToBeRemoved);
	    };
	    RowComp.prototype.removeRenderedCells = function (colIds) {
	        var _this = this;
	        colIds.forEach(function (key) {
	            var cellComp = _this.cellComps[key];
	            // could be old reference, ie removed cell
	            if (utils_1._.missing(cellComp)) {
	                return;
	            }
	            cellComp.detach();
	            cellComp.destroy();
	            _this.cellComps[key] = null;
	        });
	    };
	    RowComp.prototype.isCellEligibleToBeRemoved = function (indexStr) {
	        var displayedColumns = this.beans.columnController.getAllDisplayedColumns();
	        var REMOVE_CELL = true;
	        var KEEP_CELL = false;
	        var renderedCell = this.cellComps[indexStr];
	        if (!renderedCell) {
	            return REMOVE_CELL;
	        }
	        // always remove the cell if it's in the wrong pinned location
	        if (this.isCellInWrongRow(renderedCell)) {
	            return REMOVE_CELL;
	        }
	        // we want to try and keep editing and focused cells
	        var editing = renderedCell.isEditing();
	        var focused = this.beans.focusedCellController.isCellFocused(renderedCell.getCellPosition());
	        var mightWantToKeepCell = editing || focused;
	        if (mightWantToKeepCell) {
	            var column = renderedCell.getColumn();
	            var cellStillDisplayed = displayedColumns.indexOf(column) >= 0;
	            return cellStillDisplayed ? KEEP_CELL : REMOVE_CELL;
	        }
	        return REMOVE_CELL;
	    };
	    RowComp.prototype.ensureCellInCorrectContainer = function (cellComp) {
	        // for print layout, we always put cells into centre, otherwise we put in correct pinned section
	        if (this.printLayout) {
	            return;
	        }
	        var element = cellComp.getGui();
	        var column = cellComp.getColumn();
	        var pinnedType = column.getPinned();
	        var eContainer = this.getContainerForCell(pinnedType);
	        // if in wrong container, remove it
	        var eOldContainer = cellComp.getParentRow();
	        var inWrongRow = eOldContainer !== eContainer;
	        if (inWrongRow) {
	            // take out from old row
	            if (eOldContainer) {
	                eOldContainer.removeChild(element);
	            }
	            eContainer.appendChild(element);
	            cellComp.setParentRow(eContainer);
	        }
	    };
	    RowComp.prototype.isCellInWrongRow = function (cellComp) {
	        var column = cellComp.getColumn();
	        var rowWeWant = this.getContainerForCell(column.getPinned());
	        // if in wrong container, remove it
	        var oldRow = cellComp.getParentRow();
	        return oldRow !== rowWeWant;
	    };
	    RowComp.prototype.insertCellsIntoContainer = function (eRow, cols) {
	        var _this = this;
	        if (!eRow) {
	            return;
	        }
	        var cellTemplates = [];
	        var newCellComps = [];
	        cols.forEach(function (col) {
	            var colId = col.getId();
	            var existingCell = _this.cellComps[colId];
	            if (existingCell) {
	                _this.ensureCellInCorrectContainer(existingCell);
	            }
	            else {
	                _this.createNewCell(col, eRow, cellTemplates, newCellComps);
	            }
	        });
	        if (cellTemplates.length > 0) {
	            utils_1._.appendHtml(eRow, cellTemplates.join(''));
	            this.callAfterRowAttachedOnCells(newCellComps, eRow);
	        }
	    };
	    RowComp.prototype.addDomData = function (eRowContainer) {
	        var gow = this.beans.gridOptionsWrapper;
	        gow.setDomData(eRowContainer, RowComp.DOM_DATA_KEY_RENDERED_ROW, this);
	        this.addDestroyFunc(function () {
	            gow.setDomData(eRowContainer, RowComp.DOM_DATA_KEY_RENDERED_ROW, null);
	        });
	    };
	    RowComp.prototype.createNewCell = function (col, eContainer, cellTemplates, newCellComps) {
	        var newCellComp = new cellComp_1.CellComp(this.scope, this.beans, col, this.rowNode, this, false, this.printLayout);
	        var cellTemplate = newCellComp.getCreateTemplate();
	        cellTemplates.push(cellTemplate);
	        newCellComps.push(newCellComp);
	        this.cellComps[col.getId()] = newCellComp;
	        newCellComp.setParentRow(eContainer);
	    };
	    RowComp.prototype.onMouseEvent = function (eventName, mouseEvent) {
	        switch (eventName) {
	            case 'dblclick':
	                this.onRowDblClick(mouseEvent);
	                break;
	            case 'click':
	                this.onRowClick(mouseEvent);
	                break;
	        }
	    };
	    RowComp.prototype.createRowEvent = function (type, domEvent) {
	        return {
	            type: type,
	            node: this.rowNode,
	            data: this.rowNode.data,
	            rowIndex: this.rowNode.rowIndex,
	            rowPinned: this.rowNode.rowPinned,
	            context: this.beans.gridOptionsWrapper.getContext(),
	            api: this.beans.gridOptionsWrapper.getApi(),
	            columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
	            event: domEvent
	        };
	    };
	    RowComp.prototype.createRowEventWithSource = function (type, domEvent) {
	        var event = this.createRowEvent(type, domEvent);
	        // when first developing this, we included the rowComp in the event.
	        // this seems very weird. so when introducing the event types, i left the 'source'
	        // out of the type, and just include the source in the two places where this event
	        // was fired (rowClicked and rowDoubleClicked). it doesn't make sense for any
	        // users to be using this, as the rowComp isn't an object we expose, so would be
	        // very surprising if a user was using it.
	        event.source = this;
	        return event;
	    };
	    RowComp.prototype.onRowDblClick = function (mouseEvent) {
	        if (utils_1._.isStopPropagationForAgGrid(mouseEvent)) {
	            return;
	        }
	        var agEvent = this.createRowEventWithSource(events_1.Events.EVENT_ROW_DOUBLE_CLICKED, mouseEvent);
	        this.beans.eventService.dispatchEvent(agEvent);
	    };
	    RowComp.prototype.onRowClick = function (mouseEvent) {
	        var stop = utils_1._.isStopPropagationForAgGrid(mouseEvent);
	        if (stop) {
	            return;
	        }
	        var agEvent = this.createRowEventWithSource(events_1.Events.EVENT_ROW_CLICKED, mouseEvent);
	        this.beans.eventService.dispatchEvent(agEvent);
	        // ctrlKey for windows, metaKey for Apple
	        var multiSelectKeyPressed = mouseEvent.ctrlKey || mouseEvent.metaKey;
	        var shiftKeyPressed = mouseEvent.shiftKey;
	        if (
	        // we do not allow selecting groups by clicking (as the click here expands the group), or if it's a detail row,
	        // so return if it's a group row
	        this.rowNode.group ||
	            // this is needed so we don't unselect other rows when we click this row, eg if this row is not selectable,
	            // and we click it, the selection should not change (ie any currently selected row should stay selected)
	            !this.rowNode.selectable ||
	            // we also don't allow selection of pinned rows
	            this.rowNode.rowPinned ||
	            // if no selection method enabled, do nothing
	            !this.beans.gridOptionsWrapper.isRowSelection() ||
	            // if click selection suppressed, do nothing
	            this.beans.gridOptionsWrapper.isSuppressRowClickSelection()) {
	            return;
	        }
	        var multiSelectOnClick = this.beans.gridOptionsWrapper.isRowMultiSelectWithClick();
	        var rowDeselectionWithCtrl = this.beans.gridOptionsWrapper.isRowDeselection();
	        if (this.rowNode.isSelected()) {
	            if (multiSelectOnClick) {
	                this.rowNode.setSelectedParams({ newValue: false });
	            }
	            else if (multiSelectKeyPressed) {
	                if (rowDeselectionWithCtrl) {
	                    this.rowNode.setSelectedParams({ newValue: false });
	                }
	            }
	            else {
	                // selected with no multi key, must make sure anything else is unselected
	                this.rowNode.setSelectedParams({ newValue: true, clearSelection: true });
	            }
	        }
	        else {
	            var clearSelection = multiSelectOnClick ? false : !multiSelectKeyPressed;
	            this.rowNode.setSelectedParams({ newValue: true, clearSelection: clearSelection, rangeSelect: shiftKeyPressed });
	        }
	    };
	    RowComp.prototype.createFullWidthRowContainer = function (rowContainerComp, pinned, extraCssClass, cellRendererType, cellRendererName, eRowCallback, cellRendererCallback) {
	        var _this = this;
	        var rowTemplate = this.createTemplate('', extraCssClass);
	        rowContainerComp.appendRowTemplate(rowTemplate, function () {
	            var eRow = rowContainerComp.getRowElement(_this.getCompId());
	            var params = _this.createFullWidthParams(eRow, pinned);
	            var callback = function (cellRenderer) {
	                if (_this.isAlive()) {
	                    var gui = cellRenderer.getGui();
	                    eRow.appendChild(gui);
	                    cellRendererCallback(cellRenderer);
	                }
	                else {
	                    if (cellRenderer.destroy) {
	                        cellRenderer.destroy();
	                    }
	                }
	            };
	            // if doing master detail, it's possible we have a cached row comp from last time detail was displayed
	            var cachedRowComp = _this.beans.detailRowCompCache.get(_this.rowNode, pinned);
	            if (cachedRowComp) {
	                callback(cachedRowComp);
	            }
	            else {
	                var res = _this.beans.userComponentFactory.newFullWidthCellRenderer(params, cellRendererType, cellRendererName);
	                if (!res) {
	                    console.error('ag-Grid: fullWidthCellRenderer not defined');
	                    return;
	                }
	                res.then(callback);
	            }
	            _this.afterRowAttached(rowContainerComp, eRow);
	            eRowCallback(eRow);
	            _this.angular1Compile(eRow);
	        });
	    };
	    RowComp.prototype.angular1Compile = function (element) {
	        if (!this.scope) {
	            return;
	        }
	        this.beans.$compile(element)(this.scope);
	    };
	    RowComp.prototype.createFullWidthParams = function (eRow, pinned) {
	        var params = {
	            fullWidth: true,
	            data: this.rowNode.data,
	            node: this.rowNode,
	            value: this.rowNode.key,
	            $scope: this.scope ? this.scope : this.parentScope,
	            $compile: this.beans.$compile,
	            rowIndex: this.rowNode.rowIndex,
	            api: this.beans.gridOptionsWrapper.getApi(),
	            columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
	            context: this.beans.gridOptionsWrapper.getContext(),
	            // these need to be taken out, as part of 'afterAttached' now
	            eGridCell: eRow,
	            eParentOfValue: eRow,
	            pinned: pinned,
	            addRenderedRowListener: this.addEventListener.bind(this)
	        };
	        return params;
	    };
	    RowComp.prototype.getInitialRowClasses = function (extraCssClass) {
	        var classes = [];
	        var isTreeData = this.beans.gridOptionsWrapper.isTreeData();
	        var rowNode = this.rowNode;
	        if (utils_1._.exists(extraCssClass)) {
	            classes.push(extraCssClass);
	        }
	        classes.push('ag-row');
	        classes.push(this.rowFocused ? 'ag-row-focus' : 'ag-row-no-focus');
	        if (this.fadeRowIn) {
	            classes.push('ag-opacity-zero');
	        }
	        classes.push(this.rowIsEven ? 'ag-row-even' : 'ag-row-odd');
	        if (rowNode.isSelected()) {
	            classes.push('ag-row-selected');
	        }
	        if (rowNode.group) {
	            classes.push('ag-row-group');
	            // if a group, put the level of the group in
	            classes.push('ag-row-level-' + rowNode.level);
	            if (rowNode.footer) {
	                classes.push('ag-row-footer');
	            }
	        }
	        else {
	            // if a leaf, and a parent exists, put a level of the parent, else put level of 0 for top level item
	            classes.push('ag-row-level-' + (rowNode.parent ? (rowNode.parent.level + 1) : '0'));
	        }
	        if (rowNode.stub) {
	            classes.push('ag-row-stub');
	        }
	        if (this.fullWidthRow) {
	            classes.push('ag-full-width-row');
	        }
	        var addExpandedClass = isTreeData ?
	            // if doing tree data, we add the expanded classes if any children, as any node can be a parent
	            rowNode.allChildrenCount :
	            // if normal row grouping, we add expanded classes to groups only
	            rowNode.group && !rowNode.footer;
	        if (addExpandedClass) {
	            classes.push(rowNode.expanded ? 'ag-row-group-expanded' : 'ag-row-group-contracted');
	        }
	        if (rowNode.dragging) {
	            classes.push('ag-row-dragging');
	        }
	        utils_1._.pushAll(classes, this.processClassesFromGridOptions());
	        utils_1._.pushAll(classes, this.preProcessRowClassRules());
	        // we use absolute position unless we are doing print layout
	        classes.push(this.printLayout ? 'ag-row-position-relative' : 'ag-row-position-absolute');
	        this.firstRowOnPage = this.isFirstRowOnPage();
	        this.lastRowOnPage = this.isLastRowOnPage();
	        if (this.firstRowOnPage) {
	            classes.push('ag-row-first');
	        }
	        if (this.lastRowOnPage) {
	            classes.push('ag-row-last');
	        }
	        return classes;
	    };
	    RowComp.prototype.isFirstRowOnPage = function () {
	        return this.rowNode.rowIndex === this.beans.paginationProxy.getPageFirstRow();
	    };
	    RowComp.prototype.isLastRowOnPage = function () {
	        return this.rowNode.rowIndex === this.beans.paginationProxy.getPageLastRow();
	    };
	    RowComp.prototype.onModelUpdated = function () {
	        var newFirst = this.isFirstRowOnPage();
	        var newLast = this.isLastRowOnPage();
	        if (this.firstRowOnPage !== newFirst) {
	            this.firstRowOnPage = newFirst;
	            this.eAllRowContainers.forEach(function (row) { return utils_1._.addOrRemoveCssClass(row, 'ag-row-first', newFirst); });
	        }
	        if (this.lastRowOnPage !== newLast) {
	            this.lastRowOnPage = newLast;
	            this.eAllRowContainers.forEach(function (row) { return utils_1._.addOrRemoveCssClass(row, 'ag-row-last', newLast); });
	        }
	    };
	    RowComp.prototype.preProcessRowClassRules = function () {
	        var res = [];
	        this.processRowClassRules(function (className) {
	            res.push(className);
	        }, function (className) {
	            // not catered for, if creating, no need
	            // to remove class as it was never there
	        });
	        return res;
	    };
	    RowComp.prototype.processRowClassRules = function (onApplicableClass, onNotApplicableClass) {
	        this.beans.stylingService.processClassRules(this.beans.gridOptionsWrapper.rowClassRules(), {
	            value: undefined,
	            colDef: undefined,
	            data: this.rowNode.data,
	            node: this.rowNode,
	            rowIndex: this.rowNode.rowIndex,
	            api: this.beans.gridOptionsWrapper.getApi(),
	            columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
	            $scope: this.scope,
	            context: this.beans.gridOptionsWrapper.getContext()
	        }, onApplicableClass, onNotApplicableClass);
	    };
	    RowComp.prototype.stopEditing = function (cancel) {
	        if (cancel === void 0) { cancel = false; }
	        this.forEachCellComp(function (renderedCell) {
	            renderedCell.stopEditing(cancel);
	        });
	        if (!this.editingRow) {
	            return;
	        }
	        if (!cancel) {
	            var event_1 = this.createRowEvent(events_1.Events.EVENT_ROW_VALUE_CHANGED);
	            this.beans.eventService.dispatchEvent(event_1);
	        }
	        this.setEditingRow(false);
	    };
	    RowComp.prototype.setEditingRow = function (value) {
	        this.editingRow = value;
	        this.eAllRowContainers.forEach(function (row) { return utils_1._.addOrRemoveCssClass(row, 'ag-row-editing', value); });
	        var event = value ?
	            this.createRowEvent(events_1.Events.EVENT_ROW_EDITING_STARTED)
	            : this.createRowEvent(events_1.Events.EVENT_ROW_EDITING_STOPPED);
	        this.beans.eventService.dispatchEvent(event);
	    };
	    RowComp.prototype.startRowEditing = function (keyPress, charPress, sourceRenderedCell) {
	        if (keyPress === void 0) { keyPress = null; }
	        if (charPress === void 0) { charPress = null; }
	        if (sourceRenderedCell === void 0) { sourceRenderedCell = null; }
	        // don't do it if already editing
	        if (this.editingRow) {
	            return;
	        }
	        this.forEachCellComp(function (renderedCell) {
	            var cellStartedEdit = renderedCell === sourceRenderedCell;
	            if (cellStartedEdit) {
	                renderedCell.startEditingIfEnabled(keyPress, charPress, cellStartedEdit);
	            }
	            else {
	                renderedCell.startEditingIfEnabled(null, null, cellStartedEdit);
	            }
	        });
	        this.setEditingRow(true);
	    };
	    RowComp.prototype.forEachCellComp = function (callback) {
	        utils_1._.iterateObject(this.cellComps, function (key, cellComp) {
	            if (!cellComp) {
	                return;
	            }
	            callback(cellComp);
	        });
	    };
	    RowComp.prototype.postProcessClassesFromGridOptions = function () {
	        var _this = this;
	        var cssClasses = this.processClassesFromGridOptions();
	        if (!cssClasses || !cssClasses.length) {
	            return;
	        }
	        cssClasses.forEach(function (classStr) {
	            _this.eAllRowContainers.forEach(function (row) { return utils_1._.addCssClass(row, classStr); });
	        });
	    };
	    RowComp.prototype.postProcessRowClassRules = function () {
	        var _this = this;
	        this.processRowClassRules(function (className) {
	            _this.eAllRowContainers.forEach(function (row) { return utils_1._.addCssClass(row, className); });
	        }, function (className) {
	            _this.eAllRowContainers.forEach(function (row) { return utils_1._.removeCssClass(row, className); });
	        });
	    };
	    RowComp.prototype.processClassesFromGridOptions = function () {
	        var res = [];
	        var process = function (rowCls) {
	            if (typeof rowCls === 'string') {
	                res.push(rowCls);
	            }
	            else if (Array.isArray(rowCls)) {
	                rowCls.forEach(function (e) { return res.push(e); });
	            }
	        };
	        // part 1 - rowClass
	        var rowClass = this.beans.gridOptionsWrapper.getRowClass();
	        if (rowClass) {
	            if (typeof rowClass === 'function') {
	                console.warn('ag-Grid: rowClass should not be a function, please use getRowClass instead');
	                return;
	            }
	            process(rowClass);
	        }
	        // part 2 - rowClassFunc
	        var rowClassFunc = this.beans.gridOptionsWrapper.getRowClassFunc();
	        if (rowClassFunc) {
	            var params = {
	                node: this.rowNode,
	                data: this.rowNode.data,
	                rowIndex: this.rowNode.rowIndex,
	                context: this.beans.gridOptionsWrapper.getContext(),
	                api: this.beans.gridOptionsWrapper.getApi()
	            };
	            var rowClassFuncResult = rowClassFunc(params);
	            process(rowClassFuncResult);
	        }
	        return res;
	    };
	    RowComp.prototype.preProcessStylesFromGridOptions = function () {
	        var rowStyles = this.processStylesFromGridOptions();
	        return utils_1._.cssStyleObjectToMarkup(rowStyles);
	    };
	    RowComp.prototype.postProcessStylesFromGridOptions = function () {
	        var rowStyles = this.processStylesFromGridOptions();
	        this.eAllRowContainers.forEach(function (row) { return utils_1._.addStylesToElement(row, rowStyles); });
	    };
	    RowComp.prototype.processStylesFromGridOptions = function () {
	        // part 1 - rowStyle
	        var rowStyle = this.beans.gridOptionsWrapper.getRowStyle();
	        if (rowStyle && typeof rowStyle === 'function') {
	            console.warn('ag-Grid: rowStyle should be an object of key/value styles, not be a function, use getRowStyle() instead');
	            return;
	        }
	        // part 1 - rowStyleFunc
	        var rowStyleFunc = this.beans.gridOptionsWrapper.getRowStyleFunc();
	        var rowStyleFuncResult;
	        if (rowStyleFunc) {
	            var params = {
	                data: this.rowNode.data,
	                node: this.rowNode,
	                api: this.beans.gridOptionsWrapper.getApi(),
	                context: this.beans.gridOptionsWrapper.getContext(),
	                $scope: this.scope
	            };
	            rowStyleFuncResult = rowStyleFunc(params);
	        }
	        return utils_1._.assign({}, rowStyle, rowStyleFuncResult);
	    };
	    RowComp.prototype.createCells = function (cols) {
	        var _this = this;
	        var templateParts = [];
	        var newCellComps = [];
	        cols.forEach(function (col) {
	            var newCellComp = new cellComp_1.CellComp(_this.scope, _this.beans, col, _this.rowNode, _this, false, _this.printLayout);
	            var cellTemplate = newCellComp.getCreateTemplate();
	            templateParts.push(cellTemplate);
	            newCellComps.push(newCellComp);
	            _this.cellComps[col.getId()] = newCellComp;
	        });
	        var templateAndComps = {
	            template: templateParts.join(''),
	            cellComps: newCellComps
	        };
	        return templateAndComps;
	    };
	    RowComp.prototype.onRowSelected = function () {
	        var selected = this.rowNode.isSelected();
	        this.eAllRowContainers.forEach(function (row) { return utils_1._.addOrRemoveCssClass(row, 'ag-row-selected', selected); });
	    };
	    // called:
	    // + after row created for first time
	    // + after horizontal scroll, so new cells due to column virtualisation
	    RowComp.prototype.callAfterRowAttachedOnCells = function (newCellComps, eRow) {
	        var _this = this;
	        newCellComps.forEach(function (cellComp) {
	            cellComp.setParentRow(eRow);
	            cellComp.afterAttached();
	            // if we are editing the row, then the cell needs to turn
	            // into edit mode
	            if (_this.editingRow) {
	                cellComp.startEditingIfEnabled();
	            }
	        });
	    };
	    RowComp.prototype.afterRowAttached = function (rowContainerComp, eRow) {
	        var _this = this;
	        this.addDomData(eRow);
	        this.removeSecondPassFuncs.push(function () {
	            rowContainerComp.removeRowElement(eRow);
	        });
	        this.removeFirstPassFuncs.push(function () {
	            if (utils_1._.exists(_this.rowNode.rowTop)) {
	                // the row top is updated anyway, however we set it here again
	                // to something more reasonable for the animation - ie if the
	                // row top is 10000px away, the row will flash out, so this
	                // gives it a rounded value, so row animates out more slowly
	                var rowTop = _this.roundRowTopToBounds(_this.rowNode.rowTop);
	                _this.setRowTop(rowTop);
	            }
	            else {
	                utils_1._.addCssClass(eRow, 'ag-opacity-zero');
	            }
	        });
	        this.eAllRowContainers.push(eRow);
	        // adding hover functionality adds listener to this row, so we
	        // do it lazily in an animation frame
	        if (this.useAnimationFrameForCreate) {
	            this.beans.taskQueue.addP2Task(this.addHoverFunctionality.bind(this, eRow));
	        }
	        else {
	            this.addHoverFunctionality(eRow);
	        }
	    };
	    RowComp.prototype.addHoverFunctionality = function (eRow) {
	        var _this = this;
	        // because we use animation frames to do this, it's possible the row no longer exists
	        // by the time we get to add it
	        if (!this.active) {
	            return;
	        }
	        // because mouseenter and mouseleave do not propagate, we cannot listen on the gridPanel
	        // like we do for all the other mouse events.
	        // because of the pinning, we cannot simply add / remove the class based on the eRow. we
	        // have to check all eRow's (body & pinned). so the trick is if any of the rows gets a
	        // mouse hover, it sets such in the rowNode, and then all three reflect the change as
	        // all are listening for event on the row node.
	        // step 1 - add listener, to set flag on row node
	        this.addDestroyableEventListener(eRow, 'mouseenter', function () { return _this.rowNode.onMouseEnter(); });
	        this.addDestroyableEventListener(eRow, 'mouseleave', function () { return _this.rowNode.onMouseLeave(); });
	        // step 2 - listen for changes on row node (which any eRow can trigger)
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_MOUSE_ENTER, function () {
	            // if hover turned off, we don't add the class. we do this here so that if the application
	            // toggles this property mid way, we remove the hover form the last row, but we stop
	            // adding hovers from that point onwards.
	            if (!_this.beans.gridOptionsWrapper.isSuppressRowHoverHighlight()) {
	                utils_1._.addCssClass(eRow, 'ag-row-hover');
	            }
	        });
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_MOUSE_LEAVE, function () {
	            utils_1._.removeCssClass(eRow, 'ag-row-hover');
	        });
	    };
	    // for animation, we don't want to animate entry or exit to a very far away pixel,
	    // otherwise the row would move so fast, it would appear to disappear. so this method
	    // moves the row closer to the viewport if it is far away, so the row slide in / out
	    // at a speed the user can see.
	    RowComp.prototype.roundRowTopToBounds = function (rowTop) {
	        var range = this.beans.gridPanel.getVScrollPosition();
	        var minPixel = this.applyPaginationOffset(range.top, true) - 100;
	        var maxPixel = this.applyPaginationOffset(range.bottom, true) + 100;
	        return Math.min(Math.max(minPixel, rowTop), maxPixel);
	    };
	    RowComp.prototype.getFrameworkOverrides = function () {
	        return this.beans.frameworkOverrides;
	    };
	    RowComp.prototype.onRowHeightChanged = function () {
	        // check for exists first - if the user is resetting the row height, then
	        // it will be null (or undefined) momentarily until the next time the flatten
	        // stage is called where the row will then update again with a new height
	        if (utils_1._.exists(this.rowNode.rowHeight)) {
	            var heightPx_1 = this.rowNode.rowHeight + "px";
	            this.eAllRowContainers.forEach(function (row) { return row.style.height = heightPx_1; });
	        }
	    };
	    RowComp.prototype.addEventListener = function (eventType, listener) {
	        if (eventType === 'renderedRowRemoved' || eventType === 'rowRemoved') {
	            eventType = events_1.Events.EVENT_VIRTUAL_ROW_REMOVED;
	            console.warn('ag-Grid: Since version 11, event renderedRowRemoved is now called ' + events_1.Events.EVENT_VIRTUAL_ROW_REMOVED);
	        }
	        _super.prototype.addEventListener.call(this, eventType, listener);
	    };
	    RowComp.prototype.removeEventListener = function (eventType, listener) {
	        if (eventType === 'renderedRowRemoved' || eventType === 'rowRemoved') {
	            eventType = events_1.Events.EVENT_VIRTUAL_ROW_REMOVED;
	            console.warn('ag-Grid: Since version 11, event renderedRowRemoved and rowRemoved is now called ' + events_1.Events.EVENT_VIRTUAL_ROW_REMOVED);
	        }
	        _super.prototype.removeEventListener.call(this, eventType, listener);
	    };
	    RowComp.prototype.destroy = function (animate) {
	        if (animate === void 0) { animate = false; }
	        _super.prototype.destroy.call(this);
	        this.active = false;
	        // why do we have this method? shouldn't everything below be added as a destroy func beside
	        // the corresponding create logic?
	        this.destroyFullWidthComponents();
	        if (animate) {
	            this.removeFirstPassFuncs.forEach(function (func) { return func(); });
	            this.removeSecondPassFuncs.push(this.destroyContainingCells.bind(this));
	        }
	        else {
	            this.destroyContainingCells();
	            // we are not animating, so execute the second stage of removal now.
	            // we call getAndClear, so that they are only called once
	            var delayedDestroyFunctions = this.getAndClearDelayedDestroyFunctions();
	            delayedDestroyFunctions.forEach(function (func) { return func(); });
	        }
	        var event = this.createRowEvent(events_1.Events.EVENT_VIRTUAL_ROW_REMOVED);
	        this.dispatchEvent(event);
	        this.beans.eventService.dispatchEvent(event);
	    };
	    RowComp.prototype.destroyContainingCells = function () {
	        this.forEachCellComp(function (renderedCell) { return renderedCell.destroy(); });
	        this.destroyFullWidthComponents();
	    };
	    // we clear so that the functions are never executed twice
	    RowComp.prototype.getAndClearDelayedDestroyFunctions = function () {
	        var result = this.removeSecondPassFuncs;
	        this.removeSecondPassFuncs = [];
	        return result;
	    };
	    RowComp.prototype.onCellFocusChanged = function () {
	        var rowFocused = this.beans.focusedCellController.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned);
	        if (rowFocused !== this.rowFocused) {
	            this.eAllRowContainers.forEach(function (row) { return utils_1._.addOrRemoveCssClass(row, 'ag-row-focus', rowFocused); });
	            this.eAllRowContainers.forEach(function (row) { return utils_1._.addOrRemoveCssClass(row, 'ag-row-no-focus', !rowFocused); });
	            this.rowFocused = rowFocused;
	        }
	        // if we are editing, then moving the focus out of a row will stop editing
	        if (!rowFocused && this.editingRow) {
	            this.stopEditing(false);
	        }
	    };
	    RowComp.prototype.onPaginationChanged = function () {
	        var currentPage = this.beans.paginationProxy.getCurrentPage();
	        // it is possible this row is in the new page, but the page number has changed, which means
	        // it needs to reposition itself relative to the new page
	        if (this.paginationPage !== currentPage) {
	            this.paginationPage = currentPage;
	            this.onTopChanged();
	        }
	    };
	    RowComp.prototype.onTopChanged = function () {
	        this.setRowTop(this.rowNode.rowTop);
	    };
	    // applies pagination offset, eg if on second page, and page height is 500px, then removes
	    // 500px from the top position, so a row with rowTop 600px is displayed at location 100px.
	    // reverse will take the offset away rather than add.
	    RowComp.prototype.applyPaginationOffset = function (topPx, reverse) {
	        if (reverse === void 0) { reverse = false; }
	        if (this.rowNode.isRowPinned()) {
	            return topPx;
	        }
	        var pixelOffset = this.beans.paginationProxy.getPixelOffset();
	        var multiplier = reverse ? 1 : -1;
	        return topPx + (pixelOffset * multiplier);
	    };
	    RowComp.prototype.setRowTop = function (pixels) {
	        // print layout uses normal flow layout for row positioning
	        if (this.printLayout) {
	            return;
	        }
	        // need to make sure rowTop is not null, as this can happen if the node was once
	        // visible (ie parent group was expanded) but is now not visible
	        if (utils_1._.exists(pixels)) {
	            var afterPaginationPixels = this.applyPaginationOffset(pixels);
	            var afterScalingPixels = this.beans.maxDivHeightScaler.getRealPixelPosition(afterPaginationPixels);
	            var topPx_1 = afterScalingPixels + "px";
	            if (this.beans.gridOptionsWrapper.isSuppressRowTransform()) {
	                this.eAllRowContainers.forEach(function (row) { return row.style.top = topPx_1; });
	            }
	            else {
	                this.eAllRowContainers.forEach(function (row) { return row.style.transform = "translateY(" + topPx_1 + ")"; });
	            }
	        }
	    };
	    // we clear so that the functions are never executed twice
	    RowComp.prototype.getAndClearNextVMTurnFunctions = function () {
	        var result = this.createSecondPassFuncs;
	        this.createSecondPassFuncs = [];
	        return result;
	    };
	    RowComp.prototype.getRowNode = function () {
	        return this.rowNode;
	    };
	    RowComp.prototype.getRenderedCellForColumn = function (column) {
	        var _this = this;
	        var cellComp = this.cellComps[column.getColId()];
	        if (cellComp) {
	            return cellComp;
	        }
	        var spanList = Object.keys(this.cellComps)
	            .map(function (name) { return _this.cellComps[name]; })
	            .filter(function (cmp) { return cmp && cmp.getColSpanningList().indexOf(column) !== -1; });
	        return spanList.length ? spanList[0] : undefined;
	    };
	    RowComp.prototype.onRowIndexChanged = function () {
	        this.onCellFocusChanged();
	        this.updateRowIndexes();
	    };
	    RowComp.prototype.updateRowIndexes = function () {
	        var _this = this;
	        var rowIndexStr = this.rowNode.getRowIndexString();
	        var rowIsEven = this.rowNode.rowIndex % 2 === 0;
	        var rowIsEvenChanged = this.rowIsEven !== rowIsEven;
	        var headerRowCount = this.beans.gridPanel.headerRootComp.getHeaderRowCount();
	        if (rowIsEvenChanged) {
	            this.rowIsEven = rowIsEven;
	        }
	        this.eAllRowContainers.forEach(function (eRow) {
	            eRow.setAttribute('row-index', rowIndexStr);
	            eRow.setAttribute('aria-rowindex', (headerRowCount + _this.rowNode.rowIndex + 1).toString());
	            if (!rowIsEvenChanged) {
	                return;
	            }
	            utils_1._.addOrRemoveCssClass(eRow, 'ag-row-even', rowIsEven);
	            utils_1._.addOrRemoveCssClass(eRow, 'ag-row-odd', !rowIsEven);
	        });
	    };
	    RowComp.prototype.ensureDomOrder = function () {
	        var sides = [
	            {
	                el: this.getBodyRowElement(),
	                ct: this.bodyContainerComp
	            },
	            {
	                el: this.getPinnedLeftRowElement(),
	                ct: this.pinnedLeftContainerComp
	            }, {
	                el: this.getPinnedRightRowElement(),
	                ct: this.pinnedRightContainerComp
	            }, {
	                el: this.getFullWidthRowElement(),
	                ct: this.fullWidthContainerComp
	            }
	        ];
	        sides.forEach(function (side) {
	            if (!side.el) {
	                return;
	            }
	            side.ct.ensureDomOrder(side.el);
	        });
	    };
	    // returns the pinned left container, either the normal one, or the embedded full with one if exists
	    RowComp.prototype.getPinnedLeftRowElement = function () {
	        return this.ePinnedLeftRow ? this.ePinnedLeftRow : this.eFullWidthRowLeft;
	    };
	    // returns the pinned right container, either the normal one, or the embedded full with one if exists
	    RowComp.prototype.getPinnedRightRowElement = function () {
	        return this.ePinnedRightRow ? this.ePinnedRightRow : this.eFullWidthRowRight;
	    };
	    // returns the body container, either the normal one, or the embedded full with one if exists
	    RowComp.prototype.getBodyRowElement = function () {
	        return this.eBodyRow ? this.eBodyRow : this.eFullWidthRowBody;
	    };
	    // returns the full width container
	    RowComp.prototype.getFullWidthRowElement = function () {
	        return this.eFullWidthRow;
	    };
	    RowComp.DOM_DATA_KEY_RENDERED_ROW = 'renderedRow';
	    RowComp.FULL_WIDTH_CELL_RENDERER = 'fullWidthCellRenderer';
	    RowComp.GROUP_ROW_RENDERER = 'groupRowRenderer';
	    RowComp.GROUP_ROW_RENDERER_COMP_NAME = 'agGroupRowRenderer';
	    RowComp.LOADING_CELL_RENDERER = 'loadingCellRenderer';
	    RowComp.LOADING_CELL_RENDERER_COMP_NAME = 'agLoadingCellRenderer';
	    RowComp.DETAIL_CELL_RENDERER = 'detailCellRenderer';
	    RowComp.DETAIL_CELL_RENDERER_COMP_NAME = 'agDetailCellRenderer';
	    return RowComp;
	}(component_1.Component));
	exports.RowComp = RowComp;


/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var beanStub_1 = __webpack_require__(71);
	var rowNodeBlock_1 = __webpack_require__(324);
	var utils_1 = __webpack_require__(10);
	var RowNodeCache = /** @class */ (function (_super) {
	    __extends(RowNodeCache, _super);
	    function RowNodeCache(cacheParams) {
	        var _this = _super.call(this) || this;
	        _this.maxRowFound = false;
	        _this.blocks = {};
	        _this.blockCount = 0;
	        _this.virtualRowCount = cacheParams.initialRowCount;
	        _this.cacheParams = cacheParams;
	        return _this;
	    }
	    RowNodeCache.prototype.destroy = function () {
	        var _this = this;
	        _super.prototype.destroy.call(this);
	        this.forEachBlockInOrder(function (block) { return _this.destroyBlock(block); });
	    };
	    RowNodeCache.prototype.init = function () {
	        var _this = this;
	        this.active = true;
	        this.addDestroyFunc(function () { return _this.active = false; });
	    };
	    RowNodeCache.prototype.isActive = function () {
	        return this.active;
	    };
	    RowNodeCache.prototype.getVirtualRowCount = function () {
	        return this.virtualRowCount;
	    };
	    RowNodeCache.prototype.hack_setVirtualRowCount = function (virtualRowCount) {
	        this.virtualRowCount = virtualRowCount;
	    };
	    RowNodeCache.prototype.isMaxRowFound = function () {
	        return this.maxRowFound;
	    };
	    // listener on EVENT_LOAD_COMPLETE
	    RowNodeCache.prototype.onPageLoaded = function (event) {
	        this.cacheParams.rowNodeBlockLoader.loadComplete();
	        this.checkBlockToLoad();
	        // if we are not active, then we ignore all events, otherwise we could end up getting the
	        // grid to refresh even though we are no longer the active cache
	        if (!this.isActive()) {
	            return;
	        }
	        this.logger.log("onPageLoaded: page = " + event.page.getBlockNumber() + ", lastRow = " + event.lastRow);
	        if (event.success) {
	            this.checkVirtualRowCount(event.page, event.lastRow);
	        }
	    };
	    RowNodeCache.prototype.purgeBlocksIfNeeded = function (blockToExclude) {
	        var _this = this;
	        // put all candidate blocks into a list for sorting
	        var blocksForPurging = [];
	        this.forEachBlockInOrder(function (block) {
	            // we exclude checking for the page just created, as this has yet to be accessed and hence
	            // the lastAccessed stamp will not be updated for the first time yet
	            if (block === blockToExclude) {
	                return;
	            }
	            blocksForPurging.push(block);
	        });
	        // note: need to verify that this sorts items in the right order
	        blocksForPurging.sort(function (a, b) { return b.getLastAccessed() - a.getLastAccessed(); });
	        // we remove (maxBlocksInCache - 1) as we already excluded the 'just created' page.
	        // in other words, after the splice operation below, we have taken out the blocks
	        // we want to keep, which means we are left with blocks that we can potentially purge
	        var maxBlocksProvided = this.cacheParams.maxBlocksInCache > 0;
	        var blocksToKeep = maxBlocksProvided ? this.cacheParams.maxBlocksInCache - 1 : null;
	        var emptyBlocksToKeep = RowNodeCache.MAX_EMPTY_BLOCKS_TO_KEEP - 1;
	        blocksForPurging.forEach(function (block, index) {
	            var purgeBecauseBlockEmpty = block.getState() === rowNodeBlock_1.RowNodeBlock.STATE_DIRTY && index >= emptyBlocksToKeep;
	            var purgeBecauseCacheFull = maxBlocksProvided ? index >= blocksToKeep : false;
	            if (purgeBecauseBlockEmpty || purgeBecauseCacheFull) {
	                // we never purge blocks if they are open, as purging them would mess up with
	                // our indexes, it would be very messy to restore the purged block to it's
	                // previous state if it had open children (and what if open children of open
	                // children, jeeeesus, just thinking about it freaks me out) so best is have a
	                // rule, if block is open, we never purge.
	                if (block.isAnyNodeOpen(_this.virtualRowCount)) {
	                    return;
	                }
	                // at this point, block is not needed, and no open nodes, so burn baby burn
	                _this.removeBlockFromCache(block);
	            }
	        });
	    };
	    RowNodeCache.prototype.postCreateBlock = function (newBlock) {
	        newBlock.addEventListener(rowNodeBlock_1.RowNodeBlock.EVENT_LOAD_COMPLETE, this.onPageLoaded.bind(this));
	        this.setBlock(newBlock.getBlockNumber(), newBlock);
	        this.purgeBlocksIfNeeded(newBlock);
	        this.checkBlockToLoad();
	    };
	    RowNodeCache.prototype.removeBlockFromCache = function (blockToRemove) {
	        if (!blockToRemove) {
	            return;
	        }
	        this.destroyBlock(blockToRemove);
	        // we do not want to remove the 'loaded' event listener, as the
	        // concurrent loads count needs to be updated when the load is complete
	        // if the purged page is in loading state
	    };
	    // gets called after: 1) block loaded 2) block created 3) cache refresh
	    RowNodeCache.prototype.checkBlockToLoad = function () {
	        this.cacheParams.rowNodeBlockLoader.checkBlockToLoad();
	    };
	    RowNodeCache.prototype.checkVirtualRowCount = function (block, lastRow) {
	        // if client provided a last row, we always use it, as it could change between server calls
	        // if user deleted data and then called refresh on the grid.
	        if (typeof lastRow === 'number' && lastRow >= 0) {
	            this.virtualRowCount = lastRow;
	            this.maxRowFound = true;
	            this.onCacheUpdated();
	        }
	        else if (!this.maxRowFound) {
	            // otherwise, see if we need to add some virtual rows
	            var lastRowIndex = (block.getBlockNumber() + 1) * this.cacheParams.blockSize;
	            var lastRowIndexPlusOverflow = lastRowIndex + this.cacheParams.overflowSize;
	            if (this.virtualRowCount < lastRowIndexPlusOverflow) {
	                this.virtualRowCount = lastRowIndexPlusOverflow;
	                this.onCacheUpdated();
	            }
	            else if (this.cacheParams.dynamicRowHeight) {
	                // the only other time is if dynamic row height, as loading rows
	                // will change the height of the block, given the height of the rows
	                // is only known after the row is loaded.
	                this.onCacheUpdated();
	            }
	        }
	    };
	    RowNodeCache.prototype.setVirtualRowCount = function (rowCount, maxRowFound) {
	        this.virtualRowCount = rowCount;
	        // if undefined is passed, we do not set this value, if one of {true,false}
	        // is passed, we do set the value.
	        if (utils_1._.exists(maxRowFound)) {
	            this.maxRowFound = maxRowFound;
	        }
	        // if we are still searching, then the row count must not end at the end
	        // of a particular page, otherwise the searching will not pop into the
	        // next page
	        if (!this.maxRowFound) {
	            if (this.virtualRowCount % this.cacheParams.blockSize === 0) {
	                this.virtualRowCount++;
	            }
	        }
	        this.onCacheUpdated();
	    };
	    RowNodeCache.prototype.forEachNodeDeep = function (callback, sequence) {
	        var _this = this;
	        if (sequence === void 0) { sequence = new utils_1.NumberSequence(); }
	        this.forEachBlockInOrder(function (block) {
	            block.forEachNodeDeep(callback, sequence, _this.virtualRowCount);
	        });
	    };
	    RowNodeCache.prototype.forEachBlockInOrder = function (callback) {
	        var ids = this.getBlockIdsSorted();
	        this.forEachBlockId(ids, callback);
	    };
	    RowNodeCache.prototype.forEachBlockInReverseOrder = function (callback) {
	        var ids = this.getBlockIdsSorted().reverse();
	        this.forEachBlockId(ids, callback);
	    };
	    RowNodeCache.prototype.forEachBlockId = function (ids, callback) {
	        var _this = this;
	        ids.forEach(function (id) {
	            var block = _this.blocks[id];
	            callback(block, id);
	        });
	    };
	    RowNodeCache.prototype.getBlockIdsSorted = function () {
	        // get all page id's as NUMBERS (not strings, as we need to sort as numbers) and in descending order
	        var numberComparator = function (a, b) { return a - b; }; // default comparator for array is string comparison
	        var blockIds = Object.keys(this.blocks).map(function (idStr) { return parseInt(idStr, 10); }).sort(numberComparator);
	        return blockIds;
	    };
	    RowNodeCache.prototype.getBlock = function (blockId) {
	        return this.blocks[blockId];
	    };
	    RowNodeCache.prototype.setBlock = function (id, block) {
	        this.blocks[id] = block;
	        this.blockCount++;
	        this.cacheParams.rowNodeBlockLoader.addBlock(block);
	    };
	    RowNodeCache.prototype.destroyBlock = function (block) {
	        delete this.blocks[block.getBlockNumber()];
	        block.destroy();
	        this.blockCount--;
	        this.cacheParams.rowNodeBlockLoader.removeBlock(block);
	    };
	    // gets called 1) row count changed 2) cache purged 3) items inserted
	    RowNodeCache.prototype.onCacheUpdated = function () {
	        if (this.isActive()) {
	            // this results in both row models (infinite and server side) firing ModelUpdated,
	            // however server side row model also updates the row indexes first
	            var event_1 = {
	                type: RowNodeCache.EVENT_CACHE_UPDATED
	            };
	            this.dispatchEvent(event_1);
	        }
	    };
	    RowNodeCache.prototype.purgeCache = function () {
	        var _this = this;
	        this.forEachBlockInOrder(function (block) { return _this.removeBlockFromCache(block); });
	        // re-initialise cache - this ensures a cache with no rows can reload when purged!
	        this.virtualRowCount = this.cacheParams.initialRowCount;
	        this.maxRowFound = false;
	        this.onCacheUpdated();
	    };
	    RowNodeCache.prototype.getRowNodesInRange = function (firstInRange, lastInRange) {
	        var _this = this;
	        var result = [];
	        var lastBlockId = -1;
	        var inActiveRange = false;
	        var numberSequence = new utils_1.NumberSequence();
	        // if only one node passed, we start the selection at the top
	        if (utils_1._.missing(firstInRange)) {
	            inActiveRange = true;
	        }
	        var foundGapInSelection = false;
	        this.forEachBlockInOrder(function (block, id) {
	            if (foundGapInSelection) {
	                return;
	            }
	            if (inActiveRange && (lastBlockId + 1 !== id)) {
	                foundGapInSelection = true;
	                return;
	            }
	            lastBlockId = id;
	            block.forEachNodeShallow(function (rowNode) {
	                var hitFirstOrLast = rowNode === firstInRange || rowNode === lastInRange;
	                if (inActiveRange || hitFirstOrLast) {
	                    result.push(rowNode);
	                }
	                if (hitFirstOrLast) {
	                    inActiveRange = !inActiveRange;
	                }
	            }, numberSequence, _this.virtualRowCount);
	        });
	        // inActiveRange will be still true if we never hit the second rowNode
	        var invalidRange = foundGapInSelection || inActiveRange;
	        return invalidRange ? [] : result;
	    };
	    RowNodeCache.EVENT_CACHE_UPDATED = 'cacheUpdated';
	    // this property says how many empty blocks should be in a cache, eg if scrolls down fast and creates 10
	    // blocks all for loading, the grid will only load the last 2 - it will assume the blocks the user quickly
	    // scrolled over are not needed to be loaded.
	    RowNodeCache.MAX_EMPTY_BLOCKS_TO_KEEP = 2;
	    return RowNodeCache;
	}(beanStub_1.BeanStub));
	exports.RowNodeCache = RowNodeCache;


/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var utils_1 = __webpack_require__(10);
	var SelectableService = /** @class */ (function () {
	    function SelectableService() {
	    }
	    SelectableService.prototype.init = function () {
	        this.groupSelectsChildren = this.gridOptionsWrapper.isGroupSelectsChildren();
	        this.isRowSelectableFunc = this.gridOptionsWrapper.getIsRowSelectableFunc();
	    };
	    SelectableService.prototype.updateSelectableAfterGrouping = function (rowNode) {
	        if (this.isRowSelectableFunc) {
	            var nextChildrenFunc = function (rowNode) { return rowNode.childrenAfterGroup; };
	            this.recurseDown(rowNode.childrenAfterGroup, nextChildrenFunc);
	        }
	    };
	    SelectableService.prototype.updateSelectableAfterFiltering = function (rowNode) {
	        if (this.isRowSelectableFunc) {
	            var nextChildrenFunc = function (rowNode) { return rowNode.childrenAfterFilter; };
	            this.recurseDown(rowNode.childrenAfterGroup, nextChildrenFunc);
	        }
	    };
	    SelectableService.prototype.recurseDown = function (children, nextChildrenFunc) {
	        var _this = this;
	        children.forEach(function (child) {
	            if (!child.group) {
	                return;
	            } // only interested in groups
	            if (child.hasChildren()) {
	                _this.recurseDown(nextChildrenFunc(child), nextChildrenFunc);
	            }
	            var rowSelectable;
	            if (_this.groupSelectsChildren) {
	                // have this group selectable if at least one direct child is selectable
	                var firstSelectable = utils_1._.find(nextChildrenFunc(child), 'selectable', true);
	                rowSelectable = utils_1._.exists(firstSelectable);
	            }
	            else {
	                // directly retrieve selectable value from user callback
	                rowSelectable = _this.isRowSelectableFunc ? _this.isRowSelectableFunc(child) : false;
	            }
	            child.setRowSelectable(rowSelectable);
	        });
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], SelectableService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], SelectableService.prototype, "init", null);
	    SelectableService = __decorate([
	        context_1.Bean('selectableService')
	    ], SelectableService);
	    return SelectableService;
	}());
	exports.SelectableService = SelectableService;


/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var expressionService_1 = __webpack_require__(121);
	var StylingService = /** @class */ (function () {
	    function StylingService() {
	    }
	    StylingService.prototype.processAllCellClasses = function (colDef, params, onApplicableClass, onNotApplicableClass) {
	        this.processClassRules(colDef.cellClassRules, params, onApplicableClass, onNotApplicableClass);
	        this.processStaticCellClasses(colDef, params, onApplicableClass);
	    };
	    StylingService.prototype.processClassRules = function (classRules, params, onApplicableClass, onNotApplicableClass) {
	        if (typeof classRules === 'object' && classRules !== null) {
	            var classNames = Object.keys(classRules);
	            for (var i = 0; i < classNames.length; i++) {
	                var className = classNames[i];
	                var rule = classRules[className];
	                var resultOfRule = void 0;
	                if (typeof rule === 'string') {
	                    resultOfRule = this.expressionService.evaluate(rule, params);
	                }
	                else if (typeof rule === 'function') {
	                    resultOfRule = rule(params);
	                }
	                if (resultOfRule) {
	                    onApplicableClass(className);
	                }
	                else if (onNotApplicableClass) {
	                    onNotApplicableClass(className);
	                }
	            }
	        }
	    };
	    StylingService.prototype.processStaticCellClasses = function (colDef, params, onApplicableClass) {
	        var cellClass = colDef.cellClass;
	        if (cellClass) {
	            var classOrClasses = void 0;
	            if (typeof colDef.cellClass === 'function') {
	                var cellClassFunc = colDef.cellClass;
	                classOrClasses = cellClassFunc(params);
	            }
	            else {
	                classOrClasses = colDef.cellClass;
	            }
	            if (typeof classOrClasses === 'string') {
	                onApplicableClass(classOrClasses);
	            }
	            else if (Array.isArray(classOrClasses)) {
	                classOrClasses.forEach(function (cssClassItem) {
	                    onApplicableClass(cssClassItem);
	                });
	            }
	        }
	    };
	    __decorate([
	        context_1.Autowired('expressionService'),
	        __metadata("design:type", expressionService_1.ExpressionService)
	    ], StylingService.prototype, "expressionService", void 0);
	    StylingService = __decorate([
	        context_1.Bean('stylingService')
	    ], StylingService);
	    return StylingService;
	}());
	exports.StylingService = StylingService;


/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var context_2 = __webpack_require__(8);
	var TemplateService = /** @class */ (function () {
	    function TemplateService() {
	        this.templateCache = {};
	        this.waitingCallbacks = {};
	    }
	    // returns the template if it is loaded, or null if it is not loaded
	    // but will call the callback when it is loaded
	    TemplateService.prototype.getTemplate = function (url, callback) {
	        var templateFromCache = this.templateCache[url];
	        if (templateFromCache) {
	            return templateFromCache;
	        }
	        var callbackList = this.waitingCallbacks[url];
	        var that = this;
	        if (!callbackList) {
	            // first time this was called, so need a new list for callbacks
	            callbackList = [];
	            this.waitingCallbacks[url] = callbackList;
	            // and also need to do the http request
	            var client = new XMLHttpRequest();
	            client.onload = function () {
	                that.handleHttpResult(this, url);
	            };
	            client.open("GET", url);
	            client.send();
	        }
	        // add this callback
	        if (callback) {
	            callbackList.push(callback);
	        }
	        // caller needs to wait for template to load, so return null
	        return null;
	    };
	    TemplateService.prototype.handleHttpResult = function (httpResult, url) {
	        if (httpResult.status !== 200 || httpResult.response === null) {
	            console.warn("Unable to get template error " + httpResult.status + " - " + url);
	            return;
	        }
	        // response success, so process it
	        // in IE9 the response is in - responseText
	        this.templateCache[url] = httpResult.response || httpResult.responseText;
	        // inform all listeners that this is now in the cache
	        var callbacks = this.waitingCallbacks[url];
	        for (var i = 0; i < callbacks.length; i++) {
	            var callback = callbacks[i];
	            // we could pass the callback the response, however we know the client of this code
	            // is the cell renderer, and it passes the 'cellRefresh' method in as the callback
	            // which doesn't take any parameters.
	            callback();
	        }
	        if (this.$scope) {
	            var that_1 = this;
	            window.setTimeout(function () {
	                that_1.$scope.$apply();
	            }, 0);
	        }
	    };
	    __decorate([
	        context_2.Autowired('$scope'),
	        __metadata("design:type", Object)
	    ], TemplateService.prototype, "$scope", void 0);
	    TemplateService = __decorate([
	        context_1.Bean('templateService')
	    ], TemplateService);
	    return TemplateService;
	}());
	exports.TemplateService = TemplateService;


/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(31);
	var context_1 = __webpack_require__(8);
	var utils_1 = __webpack_require__(10);
	var AgAbstractLabel = /** @class */ (function (_super) {
	    __extends(AgAbstractLabel, _super);
	    function AgAbstractLabel() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.labelSeparator = '';
	        _this.labelAlignment = 'left';
	        _this.config = {};
	        _this.label = '';
	        return _this;
	    }
	    AgAbstractLabel.prototype.postConstruct = function () {
	        utils_1._.addCssClass(this.getGui(), 'ag-labeled');
	        var _a = this.config, labelSeparator = _a.labelSeparator, label = _a.label, labelWidth = _a.labelWidth, labelAlignment = _a.labelAlignment;
	        if (labelSeparator != null) {
	            this.setLabelSeparator(labelSeparator);
	        }
	        if (label != null) {
	            this.setLabel(label);
	        }
	        if (labelWidth != null) {
	            this.setLabelWidth(labelWidth);
	        }
	        this.setLabelAlignment(labelAlignment || this.labelAlignment);
	        this.refreshLabel();
	    };
	    AgAbstractLabel.prototype.refreshLabel = function () {
	        this.eLabel.innerText = this.label + this.labelSeparator;
	        utils_1._.addOrRemoveCssClass(this.eLabel, 'ag-hidden', this.label === '');
	    };
	    AgAbstractLabel.prototype.setLabelSeparator = function (labelSeparator) {
	        if (this.labelSeparator === labelSeparator) {
	            return this;
	        }
	        this.labelSeparator = labelSeparator;
	        if (this.label != null) {
	            this.refreshLabel();
	        }
	        return this;
	    };
	    AgAbstractLabel.prototype.setLabel = function (label) {
	        if (this.label === label) {
	            return this;
	        }
	        this.label = label;
	        this.refreshLabel();
	        return this;
	    };
	    AgAbstractLabel.prototype.setLabelAlignment = function (alignment) {
	        var eGui = this.getGui();
	        utils_1._.addOrRemoveCssClass(eGui, 'ag-label-align-left', alignment === 'left');
	        utils_1._.addOrRemoveCssClass(eGui, 'ag-label-align-right', alignment === 'right');
	        utils_1._.addOrRemoveCssClass(eGui, 'ag-label-align-top', alignment === 'top');
	        return this;
	    };
	    AgAbstractLabel.prototype.setLabelWidth = function (width) {
	        if (this.label == null) {
	            return this;
	        }
	        utils_1._.setElementWidth(this.eLabel, width);
	        return this;
	    };
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], AgAbstractLabel.prototype, "postConstruct", null);
	    return AgAbstractLabel;
	}(component_1.Component));
	exports.AgAbstractLabel = AgAbstractLabel;


/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var agAbstractInputField_1 = __webpack_require__(254);
	var utils_1 = __webpack_require__(10);
	var AgInputRange = /** @class */ (function (_super) {
	    __extends(AgInputRange, _super);
	    function AgInputRange(config) {
	        var _this = _super.call(this) || this;
	        _this.className = 'ag-range-field';
	        _this.displayTag = 'input';
	        _this.inputType = 'range';
	        _this.setTemplate(_this.TEMPLATE.replace(/%displayField%/g, _this.displayTag));
	        if (config) {
	            _this.config = config;
	        }
	        return _this;
	    }
	    AgInputRange.prototype.postConstruct = function () {
	        _super.prototype.postConstruct.call(this);
	        var _a = this.config, min = _a.min, max = _a.max, step = _a.step;
	        if (min != null) {
	            this.setMinValue(min);
	        }
	        if (max != null) {
	            this.setMaxValue(max);
	        }
	        this.setStep(step || 1);
	    };
	    AgInputRange.prototype.addInputListeners = function () {
	        var _this = this;
	        var isIE = utils_1._.isBrowserIE();
	        var eventName = isIE ? 'change' : 'input';
	        this.addDestroyableEventListener(this.eInput, eventName, function (e) {
	            var value = e.target.value;
	            _this.setValue(value);
	        });
	    };
	    AgInputRange.prototype.setMinValue = function (value) {
	        this.min = value;
	        this.eInput.setAttribute('min', value.toString());
	        return this;
	    };
	    AgInputRange.prototype.setMaxValue = function (value) {
	        this.max = value;
	        this.eInput.setAttribute('max', value.toString());
	        return this;
	    };
	    AgInputRange.prototype.setStep = function (value) {
	        this.step = value;
	        this.eInput.setAttribute('step', value.toString());
	        return this;
	    };
	    AgInputRange.prototype.setValue = function (value, silent) {
	        if (this.min != null) {
	            value = Math.max(parseFloat(value), this.min).toString();
	        }
	        if (this.max != null) {
	            value = Math.min(parseFloat(value), this.max).toString();
	        }
	        var ret = _super.prototype.setValue.call(this, value, silent);
	        this.eInput.value = value;
	        return ret;
	    };
	    return AgInputRange;
	}(agAbstractInputField_1.AgAbstractInputField));
	exports.AgInputRange = AgInputRange;


/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var agAbstractInputField_1 = __webpack_require__(254);
	var AgInputTextField = /** @class */ (function (_super) {
	    __extends(AgInputTextField, _super);
	    function AgInputTextField(config) {
	        var _this = _super.call(this) || this;
	        _this.className = 'ag-text-field';
	        _this.displayTag = 'input';
	        _this.inputType = 'text';
	        _this.setTemplate(_this.TEMPLATE.replace(/%displayField%/g, _this.displayTag));
	        if (config) {
	            _this.config = config;
	        }
	        return _this;
	    }
	    AgInputTextField.prototype.setValue = function (value, silent) {
	        var ret = _super.prototype.setValue.call(this, value, silent);
	        if (this.eInput.value !== value) {
	            this.eInput.value = value;
	        }
	        return ret;
	    };
	    return AgInputTextField;
	}(agAbstractInputField_1.AgAbstractInputField));
	exports.AgInputTextField = AgInputTextField;


/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var componentAnnotations_1 = __webpack_require__(39);
	var context_1 = __webpack_require__(8);
	var component_1 = __webpack_require__(31);
	var popupService_1 = __webpack_require__(137);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var utils_1 = __webpack_require__(10);
	var AgPanel = /** @class */ (function (_super) {
	    __extends(AgPanel, _super);
	    function AgPanel(config) {
	        var _this = _super.call(this, AgPanel.TEMPLATE) || this;
	        _this.closable = true;
	        _this.positioned = false;
	        _this.dragStartPosition = {
	            x: 0,
	            y: 0
	        };
	        _this.position = {
	            x: 0,
	            y: 0
	        };
	        _this.size = {
	            width: undefined,
	            height: undefined
	        };
	        _this.config = config;
	        return _this;
	    }
	    AgPanel.prototype.postConstruct = function () {
	        var _this = this;
	        var _a = this.config, component = _a.component, closable = _a.closable, hideTitleBar = _a.hideTitleBar, title = _a.title, minWidth = _a.minWidth, width = _a.width, minHeight = _a.minHeight, height = _a.height, centered = _a.centered, x = _a.x, y = _a.y;
	        var eGui = this.getGui();
	        if (component) {
	            this.setBodyComponent(component);
	        }
	        if (!hideTitleBar) {
	            if (title) {
	                this.setTitle(title);
	            }
	            this.setClosable(closable != null ? closable : this.closable);
	        }
	        else {
	            utils_1._.addCssClass(this.eTitleBar, 'ag-hidden');
	        }
	        this.addDestroyableEventListener(this.eTitleBar, 'mousedown', function (e) {
	            if (eGui.contains(e.relatedTarget) ||
	                eGui.contains(document.activeElement) ||
	                _this.eTitleBarButtons.contains(e.target)) {
	                e.preventDefault();
	                return;
	            }
	            var focusEl = _this.eContentWrapper.querySelector('button, [href], input, select, textarea, [tabindex]');
	            if (focusEl) {
	                focusEl.focus();
	            }
	        });
	        if (this.positioned) {
	            return;
	        }
	        this.minHeight = minHeight != null ? minHeight : 250;
	        this.minWidth = minWidth != null ? minWidth : 250;
	        this.popupParent = this.popupService.getPopupParent();
	        if (width) {
	            this.setWidth(width);
	        }
	        if (height) {
	            this.setHeight(height);
	        }
	        if (this.renderComponent) {
	            this.renderComponent();
	        }
	        if (!width || !height) {
	            this.refreshSize();
	        }
	        if (centered) {
	            this.center();
	        }
	        else if (x || y) {
	            this.offsetElement(x, y);
	        }
	        this.positioned = true;
	        this.eContentWrapper.style.height = '0';
	    };
	    AgPanel.prototype.renderComponent = function () {
	        var _this = this;
	        var eGui = this.getGui();
	        eGui.focus();
	        this.close = function () {
	            eGui.parentElement.removeChild(eGui);
	            _this.destroy();
	        };
	    };
	    AgPanel.prototype.updateDragStartPosition = function (x, y) {
	        this.dragStartPosition = { x: x, y: y };
	    };
	    AgPanel.prototype.calculateMouseMovement = function (params) {
	        var parentRect = this.popupParent.getBoundingClientRect();
	        var e = params.e, isLeft = params.isLeft, isTop = params.isTop, anywhereWithin = params.anywhereWithin, topBuffer = params.topBuffer;
	        var movementX = e.clientX - this.dragStartPosition.x;
	        var movementY = e.clientY - this.dragStartPosition.y;
	        var width = this.getWidth();
	        var height = this.getHeight();
	        // skip if cursor is outside of popupParent horizontally
	        var skipX = (parentRect.left >= e.clientX && this.position.x <= 0 ||
	            parentRect.right <= e.clientX && parentRect.right <= this.position.x + parentRect.left + width);
	        if (!skipX) {
	            if (isLeft) {
	                skipX = (
	                // skip if we are moving to the left and the cursor
	                // is positioned to the right of the left side anchor
	                (movementX < 0 && e.clientX > this.position.x + parentRect.left) ||
	                    // skip if we are moving to the right and the cursor
	                    // is positioned to the left of the dialog
	                    (movementX > 0 && e.clientX < this.position.x + parentRect.left));
	            }
	            else {
	                if (anywhereWithin) {
	                    // if anywhereWithin is true, we allow to move
	                    // as long as the cursor is within the dialog
	                    skipX = ((movementX < 0 && e.clientX > this.position.x + parentRect.left + width) ||
	                        (movementX > 0 && e.clientX < this.position.x + parentRect.left));
	                }
	                else {
	                    skipX = (
	                    // if the movement is bound to the right side of the dialog
	                    // we skip if we are moving to the left and the cursor
	                    // is to the right of the dialog
	                    (movementX < 0 && e.clientX > this.position.x + parentRect.left + width) ||
	                        // or skip if we are moving to the right and the cursor
	                        // is to the left of the right side anchor
	                        (movementX > 0 && e.clientX < this.position.x + parentRect.left + width));
	                }
	            }
	        }
	        movementX = skipX ? 0 : movementX;
	        var skipY = (
	        // skip if cursor is outside of popupParent vertically
	        parentRect.top >= e.clientY && this.position.y <= 0 ||
	            parentRect.bottom <= e.clientY && parentRect.bottom <= this.position.y + parentRect.top + height ||
	            isTop && (
	            // skip if we are moving to towards top and the cursor is
	            // below the top anchor + topBuffer
	            // note: topBuffer is used when moving the dialog using the title bar
	            (movementY < 0 && e.clientY > this.position.y + parentRect.top + (topBuffer || 0)) ||
	                // skip if we are moving to the bottom and the cursor is
	                // above the top anchor
	                (movementY > 0 && e.clientY < this.position.y + parentRect.top)) ||
	            // we are anchored to the bottom of the dialog
	            !isTop && (
	            // skip if we are moving towards the top and the cursor
	            // is below the bottom anchor
	            (movementY < 0 && e.clientY > this.position.y + parentRect.top + height) ||
	                // skip if we are moving towards the bottom and the cursor
	                // is above the bottom anchor
	                (movementY > 0 && e.clientY < this.position.y + parentRect.top + height)));
	        movementY = skipY ? 0 : movementY;
	        return { movementX: movementX, movementY: movementY };
	    };
	    AgPanel.prototype.refreshSize = function () {
	        var _a = this.size, width = _a.width, height = _a.height;
	        if (!width) {
	            this.setWidth(this.getGui().offsetWidth);
	        }
	        if (!height) {
	            this.setHeight(this.getGui().offsetHeight);
	        }
	    };
	    AgPanel.prototype.offsetElement = function (x, y) {
	        if (x === void 0) { x = 0; }
	        if (y === void 0) { y = 0; }
	        var ePopup = this.getGui();
	        this.popupService.positionPopup({
	            ePopup: ePopup,
	            x: x,
	            y: y,
	            minWidth: this.minWidth,
	            minHeight: this.minHeight,
	            keepWithinBounds: true
	        });
	        this.position.x = parseInt(ePopup.style.left, 10);
	        this.position.y = parseInt(ePopup.style.top, 10);
	    };
	    AgPanel.prototype.getHeight = function () {
	        return this.size.height;
	    };
	    AgPanel.prototype.setHeight = function (height) {
	        var eGui = this.getGui();
	        var isPercent = false;
	        if (typeof height === 'string' && height.indexOf('%') !== -1) {
	            utils_1._.setFixedHeight(eGui, height);
	            height = utils_1._.getAbsoluteHeight(eGui);
	            isPercent = true;
	        }
	        else {
	            height = Math.max(this.minHeight, height);
	            var offsetParent = eGui.offsetParent;
	            if (offsetParent && offsetParent.clientHeight && (height + this.position.y > offsetParent.clientHeight)) {
	                height = offsetParent.clientHeight - this.position.y;
	            }
	        }
	        if (this.size.height === height) {
	            return;
	        }
	        this.size.height = height;
	        if (!isPercent) {
	            utils_1._.setFixedHeight(eGui, height);
	        }
	        else {
	            eGui.style.maxHeight = 'unset';
	            eGui.style.minHeight = 'unset';
	        }
	    };
	    AgPanel.prototype.getWidth = function () {
	        return this.size.width;
	    };
	    AgPanel.prototype.setWidth = function (width) {
	        var eGui = this.getGui();
	        var isPercent = false;
	        if (typeof width === 'string' && width.indexOf('%') !== -1) {
	            utils_1._.setFixedWidth(eGui, width);
	            width = utils_1._.getAbsoluteWidth(eGui);
	            isPercent = true;
	        }
	        else {
	            width = Math.max(this.minWidth, width);
	            var offsetParent = eGui.offsetParent;
	            if (offsetParent && offsetParent.clientWidth && (width + this.position.x > offsetParent.clientWidth)) {
	                width = offsetParent.clientWidth - this.position.x;
	            }
	        }
	        if (this.size.width === width) {
	            return;
	        }
	        this.size.width = width;
	        if (!isPercent) {
	            utils_1._.setFixedWidth(eGui, width);
	        }
	        else {
	            eGui.style.maxWidth = 'unset';
	            eGui.style.minWidth = 'unset';
	        }
	    };
	    AgPanel.prototype.center = function () {
	        var eGui = this.getGui();
	        var x = (eGui.offsetParent.clientWidth / 2) - (this.getWidth() / 2);
	        var y = (eGui.offsetParent.clientHeight / 2) - (this.getHeight() / 2);
	        this.offsetElement(x, y);
	    };
	    AgPanel.prototype.setClosable = function (closable) {
	        if (closable !== this.closable) {
	            this.closable = closable;
	        }
	        if (closable) {
	            var closeButtonComp = this.closeButtonComp = new component_1.Component(AgPanel.CLOSE_BTN_TEMPLATE);
	            this.getContext().wireBean(closeButtonComp);
	            var eGui = closeButtonComp.getGui();
	            eGui.appendChild(utils_1._.createIconNoSpan('close', this.gridOptionsWrapper));
	            this.addTitleBarButton(closeButtonComp);
	            closeButtonComp.addDestroyableEventListener(eGui, 'click', this.onBtClose.bind(this));
	        }
	        else if (this.closeButtonComp) {
	            var eGui = this.closeButtonComp.getGui();
	            eGui.parentElement.removeChild(eGui);
	            this.closeButtonComp.destroy();
	            this.closeButtonComp = undefined;
	        }
	    };
	    AgPanel.prototype.setBodyComponent = function (bodyComponent) {
	        bodyComponent.setParentComponent(this);
	        this.eContentWrapper.appendChild(bodyComponent.getGui());
	    };
	    AgPanel.prototype.addTitleBarButton = function (button, position) {
	        var eTitleBarButtons = this.eTitleBarButtons;
	        var buttons = eTitleBarButtons.children;
	        var len = buttons.length;
	        if (position == null) {
	            position = len;
	        }
	        position = Math.max(0, Math.min(position, len));
	        var eGui = button.getGui();
	        utils_1._.addCssClass(eGui, 'ag-button');
	        if (position === 0) {
	            eTitleBarButtons.insertAdjacentElement('afterbegin', eGui);
	        }
	        else if (position === len) {
	            eTitleBarButtons.insertAdjacentElement('beforeend', eGui);
	        }
	        else {
	            buttons[position - 1].insertAdjacentElement('afterend', eGui);
	        }
	        button.setParentComponent(this);
	    };
	    AgPanel.prototype.getBodyHeight = function () {
	        return utils_1._.getInnerHeight(this.eContentWrapper);
	    };
	    AgPanel.prototype.getBodyWidth = function () {
	        return utils_1._.getInnerWidth(this.eContentWrapper);
	    };
	    AgPanel.prototype.setTitle = function (title) {
	        this.eTitle.innerText = title;
	    };
	    // called when user hits the 'x' in the top right
	    AgPanel.prototype.onBtClose = function () {
	        this.close();
	    };
	    AgPanel.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        if (this.closeButtonComp) {
	            this.closeButtonComp.destroy();
	            this.closeButtonComp = undefined;
	        }
	        var eGui = this.getGui();
	        if (eGui && eGui.offsetParent) {
	            this.close();
	        }
	    };
	    AgPanel.TEMPLATE = "<div class=\"ag-panel\" tabindex=\"-1\">\n            <div ref=\"eTitleBar\" class=\"ag-title-bar ag-unselectable\">\n                <span ref=\"eTitle\" class=\"ag-title-bar-title\"></span>\n                <div ref=\"eTitleBarButtons\" class=\"ag-title-bar-buttons\"></div>\n            </div>\n            <div ref=\"eContentWrapper\" class=\"ag-panel-content-wrapper\"></div>\n        </div>";
	    AgPanel.CLOSE_BTN_TEMPLATE = "<div class=\"ag-button\"></div>";
	    __decorate([
	        context_1.Autowired('popupService'),
	        __metadata("design:type", popupService_1.PopupService)
	    ], AgPanel.prototype, "popupService", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], AgPanel.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eContentWrapper'),
	        __metadata("design:type", HTMLElement)
	    ], AgPanel.prototype, "eContentWrapper", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eTitleBar'),
	        __metadata("design:type", HTMLElement)
	    ], AgPanel.prototype, "eTitleBar", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eTitleBarButtons'),
	        __metadata("design:type", HTMLElement)
	    ], AgPanel.prototype, "eTitleBarButtons", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eTitle'),
	        __metadata("design:type", HTMLElement)
	    ], AgPanel.prototype, "eTitle", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], AgPanel.prototype, "postConstruct", null);
	    return AgPanel;
	}(component_1.Component));
	exports.AgPanel = AgPanel;


/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var agCheckbox_1 = __webpack_require__(199);
	var AgRadioButton = /** @class */ (function (_super) {
	    __extends(AgRadioButton, _super);
	    function AgRadioButton() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.className = 'ag-radio-button';
	        _this.inputType = 'radio';
	        _this.iconMap = {
	            selected: 'radioButtonOn',
	            unselected: 'radioButtonOff'
	        };
	        return _this;
	    }
	    AgRadioButton.prototype.toggle = function () {
	        var nextValue = this.getNextValue();
	        this.setValue(nextValue);
	    };
	    AgRadioButton.prototype.getIconName = function () {
	        var value = this.getValue();
	        var prop = value ? 'selected' : 'unselected';
	        var readOnlyStr = this.isReadOnly() ? 'ReadOnly' : '';
	        return "" + this.iconMap[prop] + readOnlyStr;
	    };
	    return AgRadioButton;
	}(agCheckbox_1.AgCheckbox));
	exports.AgRadioButton = AgRadioButton;


/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var popupService_1 = __webpack_require__(137);
	var userComponentFactory_1 = __webpack_require__(81);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var columnApi_1 = __webpack_require__(38);
	var gridApi_1 = __webpack_require__(33);
	var utils_1 = __webpack_require__(10);
	var TooltipManager = /** @class */ (function () {
	    function TooltipManager() {
	        this.DEFAULT_HIDE_TOOLTIP_TIMEOUT = 10000;
	        this.MOUSEOUT_HIDE_TOOLTIP_TIMEOUT = 1000;
	        this.MOUSEOVER_SHOW_TOOLTIP_TIMEOUT = 2000;
	        this.HIDE_SHOW_ONLY = true;
	        this.showTimeoutId = 0;
	        this.hideTimeoutId = 0;
	        // map of compId to [tooltip component, close function]
	        this.registeredComponents = {};
	    }
	    TooltipManager.prototype.registerTooltip = function (targetCmp) {
	        var _this = this;
	        var el = targetCmp.getGui();
	        var id = targetCmp.getCompId();
	        this.registeredComponents[id] = {
	            tooltipComp: undefined,
	            destroyFunc: undefined,
	            eventDestroyFuncs: [
	                targetCmp.addDestroyableEventListener(el, 'mouseover', function (e) { return _this.processMouseOver(e, targetCmp); }),
	                targetCmp.addDestroyableEventListener(el, 'mousemove', function (e) { return _this.processMouseMove(e); }),
	                targetCmp.addDestroyableEventListener(el, 'mousedown', this.hideTooltip.bind(this)),
	                targetCmp.addDestroyableEventListener(el, 'mouseout', this.processMouseOut.bind(this))
	            ]
	        };
	        targetCmp.addDestroyFunc(function () { return _this.unregisterTooltip(targetCmp); });
	    };
	    TooltipManager.prototype.unregisterTooltip = function (targetCmp) {
	        var id = targetCmp.getCompId();
	        var registeredComponent = this.registeredComponents[id];
	        // hide the tooltip if it's being displayed while unregistering the component
	        if (this.activeComponent === targetCmp) {
	            this.hideTooltip();
	        }
	        if (targetCmp.isAlive() && registeredComponent && registeredComponent.eventDestroyFuncs.length) {
	            registeredComponent.eventDestroyFuncs.forEach(function (func) { return func(); });
	        }
	        delete this.registeredComponents[id];
	    };
	    TooltipManager.prototype.processMouseOver = function (e, targetCmp) {
	        var delay = this.MOUSEOVER_SHOW_TOOLTIP_TIMEOUT;
	        if (this.activeComponent) {
	            // lastHoveredComponent will be the activeComponent when we are hovering
	            // a component with many child elements like the grid header
	            if (this.lastHoveredComponent === this.activeComponent) {
	                return;
	            }
	            delay = 200;
	        }
	        else if (this.showTimeoutId && this.lastHoveredComponent === targetCmp) {
	            return;
	        }
	        this.clearTimers(this.HIDE_SHOW_ONLY);
	        // lastHoveredComponent will be the targetCmp when a click hid the tooltip
	        // and the lastHoveredComponent has many child elements
	        if (this.lastHoveredComponent === targetCmp) {
	            return;
	        }
	        this.lastHoveredComponent = targetCmp;
	        this.lastMouseEvent = e;
	        this.showTimeoutId = window.setTimeout(this.showTooltip.bind(this), delay, e);
	    };
	    TooltipManager.prototype.processMouseOut = function (e) {
	        var activeComponent = this.activeComponent;
	        var relatedTarget = e.relatedTarget;
	        if (!activeComponent) {
	            if (this.lastHoveredComponent) {
	                var containsElement = this.lastHoveredComponent.getGui().contains(relatedTarget);
	                if (this.showTimeoutId && containsElement) {
	                    // if we are hovering within a component with multiple child elements before
	                    // the tooltip has been displayed, we should cancel this event
	                    return;
	                }
	                else if (!containsElement) {
	                    // when a click hides the tooltip we need to reset the lastHoveredComponent
	                    // otherwise the tooltip won't appear until another registered component is hovered.
	                    this.lastHoveredComponent = undefined;
	                }
	            }
	            this.clearTimers();
	            return;
	        }
	        // the mouseout was called from within the activeComponent so we do nothing
	        if (activeComponent.getGui().contains(relatedTarget)) {
	            return;
	        }
	        var registeredComponent = this.registeredComponents[activeComponent.getCompId()];
	        utils_1._.addCssClass(registeredComponent.tooltipComp.getGui(), 'ag-tooltip-hiding');
	        this.lastHoveredComponent = undefined;
	        this.clearTimers();
	        this.hideTimeoutId = window.setTimeout(this.hideTooltip.bind(this), this.MOUSEOUT_HIDE_TOOLTIP_TIMEOUT);
	    };
	    TooltipManager.prototype.processMouseMove = function (e) {
	        // there is a delay from the time we mouseOver a component and the time the
	        // tooltip is displayed, so we need to track mousemove to be able to correctly
	        // position the tooltip when showTooltip is called.
	        this.lastMouseEvent = e;
	    };
	    TooltipManager.prototype.showTooltip = function (e) {
	        var targetCmp = this.lastHoveredComponent;
	        var cellComp = targetCmp;
	        var registeredComponent = this.registeredComponents[targetCmp.getCompId()];
	        this.hideTooltip();
	        var params = {
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            colDef: targetCmp.getComponentHolder(),
	            column: cellComp.getColumn && cellComp.getColumn(),
	            context: this.gridOptionsWrapper.getContext(),
	            rowIndex: cellComp.getCellPosition && cellComp.getCellPosition().rowIndex,
	            value: targetCmp.getTooltipText()
	        };
	        this.createTooltipComponent(params, registeredComponent, e);
	    };
	    TooltipManager.prototype.createTooltipComponent = function (params, cmp, e) {
	        var _this = this;
	        this.userComponentFactory.newTooltipComponent(params).then(function (tooltipComp) {
	            // if the component was unregistered while creating
	            // the tooltip (async) we should return undefined here.
	            if (!cmp) {
	                return;
	            }
	            cmp.tooltipComp = tooltipComp;
	            var eGui = tooltipComp.getGui();
	            if (!utils_1._.containsClass(eGui, 'ag-tooltip')) {
	                utils_1._.addCssClass(eGui, 'ag-tooltip-custom');
	            }
	            var closeFnc = _this.popupService.addPopup(false, eGui, false);
	            cmp.destroyFunc = function () {
	                closeFnc();
	                if (tooltipComp.destroy) {
	                    tooltipComp.destroy();
	                }
	            };
	            _this.popupService.positionPopupUnderMouseEvent({
	                type: 'tooltip',
	                mouseEvent: _this.lastMouseEvent,
	                ePopup: eGui,
	                nudgeY: 18
	            });
	            _this.activeComponent = _this.lastHoveredComponent;
	            _this.hideTimeoutId = window.setTimeout(_this.hideTooltip.bind(_this), _this.DEFAULT_HIDE_TOOLTIP_TIMEOUT);
	        });
	    };
	    TooltipManager.prototype.hideTooltip = function () {
	        var activeComponent = this.activeComponent;
	        this.clearTimers();
	        if (!activeComponent) {
	            return;
	        }
	        var id = activeComponent.getCompId();
	        var registeredComponent = this.registeredComponents[id];
	        this.activeComponent = undefined;
	        if (!registeredComponent) {
	            return;
	        }
	        if (registeredComponent.destroyFunc) {
	            registeredComponent.destroyFunc();
	        }
	        this.clearRegisteredComponent(registeredComponent);
	    };
	    TooltipManager.prototype.clearRegisteredComponent = function (registeredComponent) {
	        delete registeredComponent.destroyFunc;
	        delete registeredComponent.tooltipComp;
	    };
	    TooltipManager.prototype.clearTimers = function (showOnly) {
	        if (showOnly === void 0) { showOnly = false; }
	        if (this.hideTimeoutId && !showOnly) {
	            window.clearTimeout(this.hideTimeoutId);
	            this.hideTimeoutId = 0;
	        }
	        if (this.showTimeoutId) {
	            window.clearTimeout(this.showTimeoutId);
	            this.showTimeoutId = 0;
	        }
	    };
	    __decorate([
	        context_1.Autowired('popupService'),
	        __metadata("design:type", popupService_1.PopupService)
	    ], TooltipManager.prototype, "popupService", void 0);
	    __decorate([
	        context_1.Autowired('userComponentFactory'),
	        __metadata("design:type", userComponentFactory_1.UserComponentFactory)
	    ], TooltipManager.prototype, "userComponentFactory", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], TooltipManager.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], TooltipManager.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], TooltipManager.prototype, "gridOptionsWrapper", void 0);
	    TooltipManager = __decorate([
	        context_1.Bean('tooltipManager')
	    ], TooltipManager);
	    return TooltipManager;
	}());
	exports.TooltipManager = TooltipManager;


/***/ },
/* 452 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = isDisposable;
	
	function isDisposable(obj) {
	  return Boolean(obj && typeof obj.dispose === 'function');
	}
	
	module.exports = exports['default'];

/***/ },
/* 453 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {module:echarts/coord/View} view
	 * @param {Object} payload
	 * @param {Object} [zoomLimit]
	 */
	function updateCenterAndZoom(view, payload, zoomLimit) {
	  var previousZoom = view.getZoom();
	  var center = view.getCenter();
	  var zoom = payload.zoom;
	  var point = view.dataToPoint(center);
	
	  if (payload.dx != null && payload.dy != null) {
	    point[0] -= payload.dx;
	    point[1] -= payload.dy;
	    var center = view.pointToData(point);
	    view.setCenter(center);
	  }
	
	  if (zoom != null) {
	    if (zoomLimit) {
	      var zoomMin = zoomLimit.min || 0;
	      var zoomMax = zoomLimit.max || Infinity;
	      zoom = Math.max(Math.min(previousZoom * zoom, zoomMax), zoomMin) / previousZoom;
	    } // Zoom on given point(originX, originY)
	
	
	    view.scale[0] *= zoom;
	    view.scale[1] *= zoom;
	    var position = view.position;
	    var fixX = (payload.originX - position[0]) * (zoom - 1);
	    var fixY = (payload.originY - position[1]) * (zoom - 1);
	    position[0] -= fixX;
	    position[1] -= fixY;
	    view.updateTransform(); // Get the new center
	
	    var center = view.pointToData(point);
	    view.setCenter(center);
	    view.setZoom(zoom * previousZoom);
	  }
	
	  return {
	    center: view.getCenter(),
	    zoom: view.getZoom()
	  };
	}
	
	exports.updateCenterAndZoom = updateCenterAndZoom;

/***/ },
/* 454 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function getNodeGlobalScale(seriesModel) {
	  var coordSys = seriesModel.coordinateSystem;
	
	  if (coordSys.type !== 'view') {
	    return 1;
	  }
	
	  var nodeScaleRatio = seriesModel.option.nodeScaleRatio;
	  var groupScale = coordSys.scale;
	  var groupZoom = groupScale && groupScale[0] || 1; // Scale node when zoom changes
	
	  var roamZoom = coordSys.getZoom();
	  var nodeScale = (roamZoom - 1) * nodeScaleRatio + 1;
	  return nodeScale / groupZoom;
	}
	
	function getSymbolSize(node) {
	  var symbolSize = node.getVisual('symbolSize');
	
	  if (symbolSize instanceof Array) {
	    symbolSize = (symbolSize[0] + symbolSize[1]) / 2;
	  }
	
	  return +symbolSize;
	}
	
	exports.getNodeGlobalScale = getNodeGlobalScale;
	exports.getSymbolSize = getSymbolSize;

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var vector = __webpack_require__(41);
	
	var symbolUtil = __webpack_require__(84);
	
	var LinePath = __webpack_require__(1503);
	
	var graphic = __webpack_require__(16);
	
	var _number = __webpack_require__(20);
	
	var round = _number.round;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/chart/helper/Line
	 */
	var SYMBOL_CATEGORIES = ['fromSymbol', 'toSymbol'];
	
	function makeSymbolTypeKey(symbolCategory) {
	  return '_' + symbolCategory + 'Type';
	}
	/**
	 * @inner
	 */
	
	
	function createSymbol(name, lineData, idx) {
	  var symbolType = lineData.getItemVisual(idx, name);
	
	  if (!symbolType || symbolType === 'none') {
	    return;
	  }
	
	  var color = lineData.getItemVisual(idx, 'color');
	  var symbolSize = lineData.getItemVisual(idx, name + 'Size');
	  var symbolRotate = lineData.getItemVisual(idx, name + 'Rotate');
	
	  if (!zrUtil.isArray(symbolSize)) {
	    symbolSize = [symbolSize, symbolSize];
	  }
	
	  var symbolPath = symbolUtil.createSymbol(symbolType, -symbolSize[0] / 2, -symbolSize[1] / 2, symbolSize[0], symbolSize[1], color); // rotate by default if symbolRotate is not specified or NaN
	
	  symbolPath.__specifiedRotation = symbolRotate == null || isNaN(symbolRotate) ? void 0 : +symbolRotate * Math.PI / 180 || 0;
	  symbolPath.name = name;
	  return symbolPath;
	}
	
	function createLine(points) {
	  var line = new LinePath({
	    name: 'line',
	    subPixelOptimize: true
	  });
	  setLinePoints(line.shape, points);
	  return line;
	}
	
	function setLinePoints(targetShape, points) {
	  targetShape.x1 = points[0][0];
	  targetShape.y1 = points[0][1];
	  targetShape.x2 = points[1][0];
	  targetShape.y2 = points[1][1];
	  targetShape.percent = 1;
	  var cp1 = points[2];
	
	  if (cp1) {
	    targetShape.cpx1 = cp1[0];
	    targetShape.cpy1 = cp1[1];
	  } else {
	    targetShape.cpx1 = NaN;
	    targetShape.cpy1 = NaN;
	  }
	}
	
	function updateSymbolAndLabelBeforeLineUpdate() {
	  var lineGroup = this;
	  var symbolFrom = lineGroup.childOfName('fromSymbol');
	  var symbolTo = lineGroup.childOfName('toSymbol');
	  var label = lineGroup.childOfName('label'); // Quick reject
	
	  if (!symbolFrom && !symbolTo && label.ignore) {
	    return;
	  }
	
	  var invScale = 1;
	  var parentNode = this.parent;
	
	  while (parentNode) {
	    if (parentNode.scale) {
	      invScale /= parentNode.scale[0];
	    }
	
	    parentNode = parentNode.parent;
	  }
	
	  var line = lineGroup.childOfName('line'); // If line not changed
	  // FIXME Parent scale changed
	
	  if (!this.__dirty && !line.__dirty) {
	    return;
	  }
	
	  var percent = line.shape.percent;
	  var fromPos = line.pointAt(0);
	  var toPos = line.pointAt(percent);
	  var d = vector.sub([], toPos, fromPos);
	  vector.normalize(d, d);
	
	  if (symbolFrom) {
	    symbolFrom.attr('position', fromPos); // Fix #12388
	    // when symbol is set to be 'arrow' in markLine,
	    // symbolRotate value will be ignored, and compulsively use tangent angle.
	    // rotate by default if symbol rotation is not specified
	
	    var specifiedRotation = symbolFrom.__specifiedRotation;
	
	    if (specifiedRotation == null) {
	      var tangent = line.tangentAt(0);
	      symbolFrom.attr('rotation', Math.PI / 2 - Math.atan2(tangent[1], tangent[0]));
	    } else {
	      symbolFrom.attr('rotation', specifiedRotation);
	    }
	
	    symbolFrom.attr('scale', [invScale * percent, invScale * percent]);
	  }
	
	  if (symbolTo) {
	    symbolTo.attr('position', toPos); // Fix #12388
	    // when symbol is set to be 'arrow' in markLine,
	    // symbolRotate value will be ignored, and compulsively use tangent angle.
	    // rotate by default if symbol rotation is not specified
	
	    var specifiedRotation = symbolTo.__specifiedRotation;
	
	    if (specifiedRotation == null) {
	      var tangent = line.tangentAt(1);
	      symbolTo.attr('rotation', -Math.PI / 2 - Math.atan2(tangent[1], tangent[0]));
	    } else {
	      symbolTo.attr('rotation', specifiedRotation);
	    }
	
	    symbolTo.attr('scale', [invScale * percent, invScale * percent]);
	  }
	
	  if (!label.ignore) {
	    label.attr('position', toPos);
	    var textPosition;
	    var textAlign;
	    var textVerticalAlign;
	    var textOrigin;
	    var distance = label.__labelDistance;
	    var distanceX = distance[0] * invScale;
	    var distanceY = distance[1] * invScale;
	    var halfPercent = percent / 2;
	    var tangent = line.tangentAt(halfPercent);
	    var n = [tangent[1], -tangent[0]];
	    var cp = line.pointAt(halfPercent);
	
	    if (n[1] > 0) {
	      n[0] = -n[0];
	      n[1] = -n[1];
	    }
	
	    var dir = tangent[0] < 0 ? -1 : 1;
	
	    if (label.__position !== 'start' && label.__position !== 'end') {
	      var rotation = -Math.atan2(tangent[1], tangent[0]);
	
	      if (toPos[0] < fromPos[0]) {
	        rotation = Math.PI + rotation;
	      }
	
	      label.attr('rotation', rotation);
	    }
	
	    var dy;
	
	    switch (label.__position) {
	      case 'insideStartTop':
	      case 'insideMiddleTop':
	      case 'insideEndTop':
	      case 'middle':
	        dy = -distanceY;
	        textVerticalAlign = 'bottom';
	        break;
	
	      case 'insideStartBottom':
	      case 'insideMiddleBottom':
	      case 'insideEndBottom':
	        dy = distanceY;
	        textVerticalAlign = 'top';
	        break;
	
	      default:
	        dy = 0;
	        textVerticalAlign = 'middle';
	    }
	
	    switch (label.__position) {
	      case 'end':
	        textPosition = [d[0] * distanceX + toPos[0], d[1] * distanceY + toPos[1]];
	        textAlign = d[0] > 0.8 ? 'left' : d[0] < -0.8 ? 'right' : 'center';
	        textVerticalAlign = d[1] > 0.8 ? 'top' : d[1] < -0.8 ? 'bottom' : 'middle';
	        break;
	
	      case 'start':
	        textPosition = [-d[0] * distanceX + fromPos[0], -d[1] * distanceY + fromPos[1]];
	        textAlign = d[0] > 0.8 ? 'right' : d[0] < -0.8 ? 'left' : 'center';
	        textVerticalAlign = d[1] > 0.8 ? 'bottom' : d[1] < -0.8 ? 'top' : 'middle';
	        break;
	
	      case 'insideStartTop':
	      case 'insideStart':
	      case 'insideStartBottom':
	        textPosition = [distanceX * dir + fromPos[0], fromPos[1] + dy];
	        textAlign = tangent[0] < 0 ? 'right' : 'left';
	        textOrigin = [-distanceX * dir, -dy];
	        break;
	
	      case 'insideMiddleTop':
	      case 'insideMiddle':
	      case 'insideMiddleBottom':
	      case 'middle':
	        textPosition = [cp[0], cp[1] + dy];
	        textAlign = 'center';
	        textOrigin = [0, -dy];
	        break;
	
	      case 'insideEndTop':
	      case 'insideEnd':
	      case 'insideEndBottom':
	        textPosition = [-distanceX * dir + toPos[0], toPos[1] + dy];
	        textAlign = tangent[0] >= 0 ? 'right' : 'left';
	        textOrigin = [distanceX * dir, -dy];
	        break;
	    }
	
	    label.attr({
	      style: {
	        // Use the user specified text align and baseline first
	        textVerticalAlign: label.__verticalAlign || textVerticalAlign,
	        textAlign: label.__textAlign || textAlign
	      },
	      position: textPosition,
	      scale: [invScale, invScale],
	      origin: textOrigin
	    });
	  }
	}
	/**
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 * @alias {module:echarts/chart/helper/Line}
	 */
	
	
	function Line(lineData, idx, seriesScope) {
	  graphic.Group.call(this);
	
	  this._createLine(lineData, idx, seriesScope);
	}
	
	var lineProto = Line.prototype; // Update symbol position and rotation
	
	lineProto.beforeUpdate = updateSymbolAndLabelBeforeLineUpdate;
	
	lineProto._createLine = function (lineData, idx, seriesScope) {
	  var seriesModel = lineData.hostModel;
	  var linePoints = lineData.getItemLayout(idx);
	  var line = createLine(linePoints);
	  line.shape.percent = 0;
	  graphic.initProps(line, {
	    shape: {
	      percent: 1
	    }
	  }, seriesModel, idx);
	  this.add(line);
	  var label = new graphic.Text({
	    name: 'label',
	    // FIXME
	    // Temporary solution for `focusNodeAdjacency`.
	    // line label do not use the opacity of lineStyle.
	    lineLabelOriginalOpacity: 1
	  });
	  this.add(label);
	  zrUtil.each(SYMBOL_CATEGORIES, function (symbolCategory) {
	    var symbol = createSymbol(symbolCategory, lineData, idx); // symbols must added after line to make sure
	    // it will be updated after line#update.
	    // Or symbol position and rotation update in line#beforeUpdate will be one frame slow
	
	    this.add(symbol);
	    this[makeSymbolTypeKey(symbolCategory)] = lineData.getItemVisual(idx, symbolCategory);
	  }, this);
	
	  this._updateCommonStl(lineData, idx, seriesScope);
	};
	
	lineProto.updateData = function (lineData, idx, seriesScope) {
	  var seriesModel = lineData.hostModel;
	  var line = this.childOfName('line');
	  var linePoints = lineData.getItemLayout(idx);
	  var target = {
	    shape: {}
	  };
	  setLinePoints(target.shape, linePoints);
	  graphic.updateProps(line, target, seriesModel, idx);
	  zrUtil.each(SYMBOL_CATEGORIES, function (symbolCategory) {
	    var symbolType = lineData.getItemVisual(idx, symbolCategory);
	    var key = makeSymbolTypeKey(symbolCategory); // Symbol changed
	
	    if (this[key] !== symbolType) {
	      this.remove(this.childOfName(symbolCategory));
	      var symbol = createSymbol(symbolCategory, lineData, idx);
	      this.add(symbol);
	    }
	
	    this[key] = symbolType;
	  }, this);
	
	  this._updateCommonStl(lineData, idx, seriesScope);
	};
	
	lineProto._updateCommonStl = function (lineData, idx, seriesScope) {
	  var seriesModel = lineData.hostModel;
	  var line = this.childOfName('line');
	  var lineStyle = seriesScope && seriesScope.lineStyle;
	  var hoverLineStyle = seriesScope && seriesScope.hoverLineStyle;
	  var labelModel = seriesScope && seriesScope.labelModel;
	  var hoverLabelModel = seriesScope && seriesScope.hoverLabelModel; // Optimization for large dataset
	
	  if (!seriesScope || lineData.hasItemOption) {
	    var itemModel = lineData.getItemModel(idx);
	    lineStyle = itemModel.getModel('lineStyle').getLineStyle();
	    hoverLineStyle = itemModel.getModel('emphasis.lineStyle').getLineStyle();
	    labelModel = itemModel.getModel('label');
	    hoverLabelModel = itemModel.getModel('emphasis.label');
	  }
	
	  var visualColor = lineData.getItemVisual(idx, 'color');
	  var visualOpacity = zrUtil.retrieve3(lineData.getItemVisual(idx, 'opacity'), lineStyle.opacity, 1);
	  line.useStyle(zrUtil.defaults({
	    strokeNoScale: true,
	    fill: 'none',
	    stroke: visualColor,
	    opacity: visualOpacity
	  }, lineStyle));
	  line.hoverStyle = hoverLineStyle; // Update symbol
	
	  zrUtil.each(SYMBOL_CATEGORIES, function (symbolCategory) {
	    var symbol = this.childOfName(symbolCategory);
	
	    if (symbol) {
	      symbol.setColor(visualColor);
	      symbol.setStyle({
	        opacity: visualOpacity
	      });
	    }
	  }, this);
	  var showLabel = labelModel.getShallow('show');
	  var hoverShowLabel = hoverLabelModel.getShallow('show');
	  var label = this.childOfName('label');
	  var defaultLabelColor;
	  var baseText; // FIXME: the logic below probably should be merged to `graphic.setLabelStyle`.
	
	  if (showLabel || hoverShowLabel) {
	    defaultLabelColor = visualColor || '#000';
	    baseText = seriesModel.getFormattedLabel(idx, 'normal', lineData.dataType);
	
	    if (baseText == null) {
	      var rawVal = seriesModel.getRawValue(idx);
	      baseText = rawVal == null ? lineData.getName(idx) : isFinite(rawVal) ? round(rawVal) : rawVal;
	    }
	  }
	
	  var normalText = showLabel ? baseText : null;
	  var emphasisText = hoverShowLabel ? zrUtil.retrieve2(seriesModel.getFormattedLabel(idx, 'emphasis', lineData.dataType), baseText) : null;
	  var labelStyle = label.style; // Always set `textStyle` even if `normalStyle.text` is null, because default
	  // values have to be set on `normalStyle`.
	
	  if (normalText != null || emphasisText != null) {
	    graphic.setTextStyle(label.style, labelModel, {
	      text: normalText
	    }, {
	      autoColor: defaultLabelColor
	    });
	    label.__textAlign = labelStyle.textAlign;
	    label.__verticalAlign = labelStyle.textVerticalAlign; // 'start', 'middle', 'end'
	
	    label.__position = labelModel.get('position') || 'middle';
	    var distance = labelModel.get('distance');
	
	    if (!zrUtil.isArray(distance)) {
	      distance = [distance, distance];
	    }
	
	    label.__labelDistance = distance;
	  }
	
	  if (emphasisText != null) {
	    // Only these properties supported in this emphasis style here.
	    label.hoverStyle = {
	      text: emphasisText,
	      textFill: hoverLabelModel.getTextColor(true),
	      // For merging hover style to normal style, do not use
	      // `hoverLabelModel.getFont()` here.
	      fontStyle: hoverLabelModel.getShallow('fontStyle'),
	      fontWeight: hoverLabelModel.getShallow('fontWeight'),
	      fontSize: hoverLabelModel.getShallow('fontSize'),
	      fontFamily: hoverLabelModel.getShallow('fontFamily')
	    };
	  } else {
	    label.hoverStyle = {
	      text: null
	    };
	  }
	
	  label.ignore = !showLabel && !hoverShowLabel;
	  graphic.setHoverStyle(this);
	};
	
	lineProto.highlight = function () {
	  this.trigger('emphasis');
	};
	
	lineProto.downplay = function () {
	  this.trigger('normal');
	};
	
	lineProto.updateLayout = function (lineData, idx) {
	  this.setLinePoints(lineData.getItemLayout(idx));
	};
	
	lineProto.setLinePoints = function (points) {
	  var linePath = this.childOfName('line');
	  setLinePoints(linePath.shape, points);
	  linePath.dirty();
	};
	
	zrUtil.inherits(Line, graphic.Group);
	var _default = Line;
	module.exports = _default;

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(16);
	
	var LineGroup = __webpack_require__(455);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/chart/helper/LineDraw
	 */
	// import IncrementalDisplayable from 'zrender/src/graphic/IncrementalDisplayable';
	
	/**
	 * @alias module:echarts/component/marker/LineDraw
	 * @constructor
	 */
	function LineDraw(ctor) {
	  this._ctor = ctor || LineGroup;
	  this.group = new graphic.Group();
	}
	
	var lineDrawProto = LineDraw.prototype;
	
	lineDrawProto.isPersistent = function () {
	  return true;
	};
	/**
	 * @param {module:echarts/data/List} lineData
	 */
	
	
	lineDrawProto.updateData = function (lineData) {
	  var lineDraw = this;
	  var group = lineDraw.group;
	  var oldLineData = lineDraw._lineData;
	  lineDraw._lineData = lineData; // There is no oldLineData only when first rendering or switching from
	  // stream mode to normal mode, where previous elements should be removed.
	
	  if (!oldLineData) {
	    group.removeAll();
	  }
	
	  var seriesScope = makeSeriesScope(lineData);
	  lineData.diff(oldLineData).add(function (idx) {
	    doAdd(lineDraw, lineData, idx, seriesScope);
	  }).update(function (newIdx, oldIdx) {
	    doUpdate(lineDraw, oldLineData, lineData, oldIdx, newIdx, seriesScope);
	  }).remove(function (idx) {
	    group.remove(oldLineData.getItemGraphicEl(idx));
	  }).execute();
	};
	
	function doAdd(lineDraw, lineData, idx, seriesScope) {
	  var itemLayout = lineData.getItemLayout(idx);
	
	  if (!lineNeedsDraw(itemLayout)) {
	    return;
	  }
	
	  var el = new lineDraw._ctor(lineData, idx, seriesScope);
	  lineData.setItemGraphicEl(idx, el);
	  lineDraw.group.add(el);
	}
	
	function doUpdate(lineDraw, oldLineData, newLineData, oldIdx, newIdx, seriesScope) {
	  var itemEl = oldLineData.getItemGraphicEl(oldIdx);
	
	  if (!lineNeedsDraw(newLineData.getItemLayout(newIdx))) {
	    lineDraw.group.remove(itemEl);
	    return;
	  }
	
	  if (!itemEl) {
	    itemEl = new lineDraw._ctor(newLineData, newIdx, seriesScope);
	  } else {
	    itemEl.updateData(newLineData, newIdx, seriesScope);
	  }
	
	  newLineData.setItemGraphicEl(newIdx, itemEl);
	  lineDraw.group.add(itemEl);
	}
	
	lineDrawProto.updateLayout = function () {
	  var lineData = this._lineData; // Do not support update layout in incremental mode.
	
	  if (!lineData) {
	    return;
	  }
	
	  lineData.eachItemGraphicEl(function (el, idx) {
	    el.updateLayout(lineData, idx);
	  }, this);
	};
	
	lineDrawProto.incrementalPrepareUpdate = function (lineData) {
	  this._seriesScope = makeSeriesScope(lineData);
	  this._lineData = null;
	  this.group.removeAll();
	};
	
	function isEffectObject(el) {
	  return el.animators && el.animators.length > 0;
	}
	
	lineDrawProto.incrementalUpdate = function (taskParams, lineData) {
	  function updateIncrementalAndHover(el) {
	    if (!el.isGroup && !isEffectObject(el)) {
	      el.incremental = el.useHoverLayer = true;
	    }
	  }
	
	  for (var idx = taskParams.start; idx < taskParams.end; idx++) {
	    var itemLayout = lineData.getItemLayout(idx);
	
	    if (lineNeedsDraw(itemLayout)) {
	      var el = new this._ctor(lineData, idx, this._seriesScope);
	      el.traverse(updateIncrementalAndHover);
	      this.group.add(el);
	      lineData.setItemGraphicEl(idx, el);
	    }
	  }
	};
	
	function makeSeriesScope(lineData) {
	  var hostModel = lineData.hostModel;
	  return {
	    lineStyle: hostModel.getModel('lineStyle').getLineStyle(),
	    hoverLineStyle: hostModel.getModel('emphasis.lineStyle').getLineStyle(),
	    labelModel: hostModel.getModel('label'),
	    hoverLabelModel: hostModel.getModel('emphasis.label')
	  };
	}
	
	lineDrawProto.remove = function () {
	  this._clearIncremental();
	
	  this._incremental = null;
	  this.group.removeAll();
	};
	
	lineDrawProto._clearIncremental = function () {
	  var incremental = this._incremental;
	
	  if (incremental) {
	    incremental.clearDisplaybles();
	  }
	};
	
	function isPointNaN(pt) {
	  return isNaN(pt[0]) || isNaN(pt[1]);
	}
	
	function lineNeedsDraw(pts) {
	  return !isPointNaN(pts[0]) && !isPointNaN(pts[1]);
	}
	
	var _default = LineDraw;
	module.exports = _default;

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _dataProvider = __webpack_require__(167);
	
	var retrieveRawValue = _dataProvider.retrieveRawValue;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {module:echarts/data/List} data
	 * @param {number} dataIndex
	 * @return {string} label string. Not null/undefined
	 */
	function getDefaultLabel(data, dataIndex) {
	  var labelDims = data.mapDimension('defaultedLabel', true);
	  var len = labelDims.length; // Simple optimization (in lots of cases, label dims length is 1)
	
	  if (len === 1) {
	    return retrieveRawValue(data, dataIndex, labelDims[0]);
	  } else if (len) {
	    var vals = [];
	
	    for (var i = 0; i < labelDims.length; i++) {
	      var val = retrieveRawValue(data, dataIndex, labelDims[i]);
	      vals.push(val);
	    }
	
	    return vals.join(' ');
	  }
	}
	
	exports.getDefaultLabel = getDefaultLabel;

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var clazzUtil = __webpack_require__(124);
	
	var graphic = __webpack_require__(16);
	
	var axisPointerModelHelper = __webpack_require__(332);
	
	var eventTool = __webpack_require__(113);
	
	var throttleUtil = __webpack_require__(142);
	
	var _model = __webpack_require__(24);
	
	var makeInner = _model.makeInner;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = makeInner();
	var clone = zrUtil.clone;
	var bind = zrUtil.bind;
	/**
	 * Base axis pointer class in 2D.
	 * Implemenents {module:echarts/component/axis/IAxisPointer}.
	 */
	
	function BaseAxisPointer() {}
	
	BaseAxisPointer.prototype = {
	  /**
	   * @private
	   */
	  _group: null,
	
	  /**
	   * @private
	   */
	  _lastGraphicKey: null,
	
	  /**
	   * @private
	   */
	  _handle: null,
	
	  /**
	   * @private
	   */
	  _dragging: false,
	
	  /**
	   * @private
	   */
	  _lastValue: null,
	
	  /**
	   * @private
	   */
	  _lastStatus: null,
	
	  /**
	   * @private
	   */
	  _payloadInfo: null,
	
	  /**
	   * In px, arbitrary value. Do not set too small,
	   * no animation is ok for most cases.
	   * @protected
	   */
	  animationThreshold: 15,
	
	  /**
	   * @implement
	   */
	  render: function (axisModel, axisPointerModel, api, forceRender) {
	    var value = axisPointerModel.get('value');
	    var status = axisPointerModel.get('status'); // Bind them to `this`, not in closure, otherwise they will not
	    // be replaced when user calling setOption in not merge mode.
	
	    this._axisModel = axisModel;
	    this._axisPointerModel = axisPointerModel;
	    this._api = api; // Optimize: `render` will be called repeatly during mouse move.
	    // So it is power consuming if performing `render` each time,
	    // especially on mobile device.
	
	    if (!forceRender && this._lastValue === value && this._lastStatus === status) {
	      return;
	    }
	
	    this._lastValue = value;
	    this._lastStatus = status;
	    var group = this._group;
	    var handle = this._handle;
	
	    if (!status || status === 'hide') {
	      // Do not clear here, for animation better.
	      group && group.hide();
	      handle && handle.hide();
	      return;
	    }
	
	    group && group.show();
	    handle && handle.show(); // Otherwise status is 'show'
	
	    var elOption = {};
	    this.makeElOption(elOption, value, axisModel, axisPointerModel, api); // Enable change axis pointer type.
	
	    var graphicKey = elOption.graphicKey;
	
	    if (graphicKey !== this._lastGraphicKey) {
	      this.clear(api);
	    }
	
	    this._lastGraphicKey = graphicKey;
	    var moveAnimation = this._moveAnimation = this.determineAnimation(axisModel, axisPointerModel);
	
	    if (!group) {
	      group = this._group = new graphic.Group();
	      this.createPointerEl(group, elOption, axisModel, axisPointerModel);
	      this.createLabelEl(group, elOption, axisModel, axisPointerModel);
	      api.getZr().add(group);
	    } else {
	      var doUpdateProps = zrUtil.curry(updateProps, axisPointerModel, moveAnimation);
	      this.updatePointerEl(group, elOption, doUpdateProps, axisPointerModel);
	      this.updateLabelEl(group, elOption, doUpdateProps, axisPointerModel);
	    }
	
	    updateMandatoryProps(group, axisPointerModel, true);
	
	    this._renderHandle(value);
	  },
	
	  /**
	   * @implement
	   */
	  remove: function (api) {
	    this.clear(api);
	  },
	
	  /**
	   * @implement
	   */
	  dispose: function (api) {
	    this.clear(api);
	  },
	
	  /**
	   * @protected
	   */
	  determineAnimation: function (axisModel, axisPointerModel) {
	    var animation = axisPointerModel.get('animation');
	    var axis = axisModel.axis;
	    var isCategoryAxis = axis.type === 'category';
	    var useSnap = axisPointerModel.get('snap'); // Value axis without snap always do not snap.
	
	    if (!useSnap && !isCategoryAxis) {
	      return false;
	    }
	
	    if (animation === 'auto' || animation == null) {
	      var animationThreshold = this.animationThreshold;
	
	      if (isCategoryAxis && axis.getBandWidth() > animationThreshold) {
	        return true;
	      } // It is important to auto animation when snap used. Consider if there is
	      // a dataZoom, animation will be disabled when too many points exist, while
	      // it will be enabled for better visual effect when little points exist.
	
	
	      if (useSnap) {
	        var seriesDataCount = axisPointerModelHelper.getAxisInfo(axisModel).seriesDataCount;
	        var axisExtent = axis.getExtent(); // Approximate band width
	
	        return Math.abs(axisExtent[0] - axisExtent[1]) / seriesDataCount > animationThreshold;
	      }
	
	      return false;
	    }
	
	    return animation === true;
	  },
	
	  /**
	   * add {pointer, label, graphicKey} to elOption
	   * @protected
	   */
	  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {// Shoule be implemenented by sub-class.
	  },
	
	  /**
	   * @protected
	   */
	  createPointerEl: function (group, elOption, axisModel, axisPointerModel) {
	    var pointerOption = elOption.pointer;
	
	    if (pointerOption) {
	      var pointerEl = inner(group).pointerEl = new graphic[pointerOption.type](clone(elOption.pointer));
	      group.add(pointerEl);
	    }
	  },
	
	  /**
	   * @protected
	   */
	  createLabelEl: function (group, elOption, axisModel, axisPointerModel) {
	    if (elOption.label) {
	      var labelEl = inner(group).labelEl = new graphic.Rect(clone(elOption.label));
	      group.add(labelEl);
	      updateLabelShowHide(labelEl, axisPointerModel);
	    }
	  },
	
	  /**
	   * @protected
	   */
	  updatePointerEl: function (group, elOption, updateProps) {
	    var pointerEl = inner(group).pointerEl;
	
	    if (pointerEl && elOption.pointer) {
	      pointerEl.setStyle(elOption.pointer.style);
	      updateProps(pointerEl, {
	        shape: elOption.pointer.shape
	      });
	    }
	  },
	
	  /**
	   * @protected
	   */
	  updateLabelEl: function (group, elOption, updateProps, axisPointerModel) {
	    var labelEl = inner(group).labelEl;
	
	    if (labelEl) {
	      labelEl.setStyle(elOption.label.style);
	      updateProps(labelEl, {
	        // Consider text length change in vertical axis, animation should
	        // be used on shape, otherwise the effect will be weird.
	        shape: elOption.label.shape,
	        position: elOption.label.position
	      });
	      updateLabelShowHide(labelEl, axisPointerModel);
	    }
	  },
	
	  /**
	   * @private
	   */
	  _renderHandle: function (value) {
	    if (this._dragging || !this.updateHandleTransform) {
	      return;
	    }
	
	    var axisPointerModel = this._axisPointerModel;
	
	    var zr = this._api.getZr();
	
	    var handle = this._handle;
	    var handleModel = axisPointerModel.getModel('handle');
	    var status = axisPointerModel.get('status');
	
	    if (!handleModel.get('show') || !status || status === 'hide') {
	      handle && zr.remove(handle);
	      this._handle = null;
	      return;
	    }
	
	    var isInit;
	
	    if (!this._handle) {
	      isInit = true;
	      handle = this._handle = graphic.createIcon(handleModel.get('icon'), {
	        cursor: 'move',
	        draggable: true,
	        onmousemove: function (e) {
	          // Fot mobile devicem, prevent screen slider on the button.
	          eventTool.stop(e.event);
	        },
	        onmousedown: bind(this._onHandleDragMove, this, 0, 0),
	        drift: bind(this._onHandleDragMove, this),
	        ondragend: bind(this._onHandleDragEnd, this)
	      });
	      zr.add(handle);
	    }
	
	    updateMandatoryProps(handle, axisPointerModel, false); // update style
	
	    var includeStyles = ['color', 'borderColor', 'borderWidth', 'opacity', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY'];
	    handle.setStyle(handleModel.getItemStyle(null, includeStyles)); // update position
	
	    var handleSize = handleModel.get('size');
	
	    if (!zrUtil.isArray(handleSize)) {
	      handleSize = [handleSize, handleSize];
	    }
	
	    handle.attr('scale', [handleSize[0] / 2, handleSize[1] / 2]);
	    throttleUtil.createOrUpdate(this, '_doDispatchAxisPointer', handleModel.get('throttle') || 0, 'fixRate');
	
	    this._moveHandleToValue(value, isInit);
	  },
	
	  /**
	   * @private
	   */
	  _moveHandleToValue: function (value, isInit) {
	    updateProps(this._axisPointerModel, !isInit && this._moveAnimation, this._handle, getHandleTransProps(this.getHandleTransform(value, this._axisModel, this._axisPointerModel)));
	  },
	
	  /**
	   * @private
	   */
	  _onHandleDragMove: function (dx, dy) {
	    var handle = this._handle;
	
	    if (!handle) {
	      return;
	    }
	
	    this._dragging = true; // Persistent for throttle.
	
	    var trans = this.updateHandleTransform(getHandleTransProps(handle), [dx, dy], this._axisModel, this._axisPointerModel);
	    this._payloadInfo = trans;
	    handle.stopAnimation();
	    handle.attr(getHandleTransProps(trans));
	    inner(handle).lastProp = null;
	
	    this._doDispatchAxisPointer();
	  },
	
	  /**
	   * Throttled method.
	   * @private
	   */
	  _doDispatchAxisPointer: function () {
	    var handle = this._handle;
	
	    if (!handle) {
	      return;
	    }
	
	    var payloadInfo = this._payloadInfo;
	    var axisModel = this._axisModel;
	
	    this._api.dispatchAction({
	      type: 'updateAxisPointer',
	      x: payloadInfo.cursorPoint[0],
	      y: payloadInfo.cursorPoint[1],
	      tooltipOption: payloadInfo.tooltipOption,
	      axesInfo: [{
	        axisDim: axisModel.axis.dim,
	        axisIndex: axisModel.componentIndex
	      }]
	    });
	  },
	
	  /**
	   * @private
	   */
	  _onHandleDragEnd: function (moveAnimation) {
	    this._dragging = false;
	    var handle = this._handle;
	
	    if (!handle) {
	      return;
	    }
	
	    var value = this._axisPointerModel.get('value'); // Consider snap or categroy axis, handle may be not consistent with
	    // axisPointer. So move handle to align the exact value position when
	    // drag ended.
	
	
	    this._moveHandleToValue(value); // For the effect: tooltip will be shown when finger holding on handle
	    // button, and will be hidden after finger left handle button.
	
	
	    this._api.dispatchAction({
	      type: 'hideTip'
	    });
	  },
	
	  /**
	   * Should be implemenented by sub-class if support `handle`.
	   * @protected
	   * @param {number} value
	   * @param {module:echarts/model/Model} axisModel
	   * @param {module:echarts/model/Model} axisPointerModel
	   * @return {Object} {position: [x, y], rotation: 0}
	   */
	  getHandleTransform: null,
	
	  /**
	   * * Should be implemenented by sub-class if support `handle`.
	   * @protected
	   * @param {Object} transform {position, rotation}
	   * @param {Array.<number>} delta [dx, dy]
	   * @param {module:echarts/model/Model} axisModel
	   * @param {module:echarts/model/Model} axisPointerModel
	   * @return {Object} {position: [x, y], rotation: 0, cursorPoint: [x, y]}
	   */
	  updateHandleTransform: null,
	
	  /**
	   * @private
	   */
	  clear: function (api) {
	    this._lastValue = null;
	    this._lastStatus = null;
	    var zr = api.getZr();
	    var group = this._group;
	    var handle = this._handle;
	
	    if (zr && group) {
	      this._lastGraphicKey = null;
	      group && zr.remove(group);
	      handle && zr.remove(handle);
	      this._group = null;
	      this._handle = null;
	      this._payloadInfo = null;
	    }
	  },
	
	  /**
	   * @protected
	   */
	  doClear: function () {// Implemented by sub-class if necessary.
	  },
	
	  /**
	   * @protected
	   * @param {Array.<number>} xy
	   * @param {Array.<number>} wh
	   * @param {number} [xDimIndex=0] or 1
	   */
	  buildLabel: function (xy, wh, xDimIndex) {
	    xDimIndex = xDimIndex || 0;
	    return {
	      x: xy[xDimIndex],
	      y: xy[1 - xDimIndex],
	      width: wh[xDimIndex],
	      height: wh[1 - xDimIndex]
	    };
	  }
	};
	BaseAxisPointer.prototype.constructor = BaseAxisPointer;
	
	function updateProps(animationModel, moveAnimation, el, props) {
	  // Animation optimize.
	  if (!propsEqual(inner(el).lastProp, props)) {
	    inner(el).lastProp = props;
	    moveAnimation ? graphic.updateProps(el, props, animationModel) : (el.stopAnimation(), el.attr(props));
	  }
	}
	
	function propsEqual(lastProps, newProps) {
	  if (zrUtil.isObject(lastProps) && zrUtil.isObject(newProps)) {
	    var equals = true;
	    zrUtil.each(newProps, function (item, key) {
	      equals = equals && propsEqual(lastProps[key], item);
	    });
	    return !!equals;
	  } else {
	    return lastProps === newProps;
	  }
	}
	
	function updateLabelShowHide(labelEl, axisPointerModel) {
	  labelEl[axisPointerModel.get('label.show') ? 'show' : 'hide']();
	}
	
	function getHandleTransProps(trans) {
	  return {
	    position: trans.position.slice(),
	    rotation: trans.rotation || 0
	  };
	}
	
	function updateMandatoryProps(group, axisPointerModel, silent) {
	  var z = axisPointerModel.get('z');
	  var zlevel = axisPointerModel.get('zlevel');
	  group && group.traverse(function (el) {
	    if (el.type !== 'group') {
	      z != null && (el.z = z);
	      zlevel != null && (el.zlevel = zlevel);
	      el.silent = silent;
	    }
	  });
	}
	
	clazzUtil.enableClassExtend(BaseAxisPointer);
	var _default = BaseAxisPointer;
	module.exports = _default;

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var helper = __webpack_require__(461);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerAction('dataZoom', function (payload, ecModel) {
	  var linkedNodesFinder = helper.createLinkedNodesFinder(zrUtil.bind(ecModel.eachComponent, ecModel, 'dataZoom'), helper.eachAxisDim, function (model, dimNames) {
	    return model.get(dimNames.axisIndex);
	  });
	  var effectedModels = [];
	  ecModel.eachComponent({
	    mainType: 'dataZoom',
	    query: payload
	  }, function (model, index) {
	    effectedModels.push.apply(effectedModels, linkedNodesFinder(model).nodes);
	  });
	  zrUtil.each(effectedModels, function (dataZoomModel, index) {
	    dataZoomModel.setRawRange({
	      start: payload.start,
	      end: payload.end,
	      startValue: payload.startValue,
	      endValue: payload.endValue
	    });
	  });
	});

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var _util = __webpack_require__(3);
	
	var createHashMap = _util.createHashMap;
	var each = _util.each;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerProcessor({
	  // `dataZoomProcessor` will only be performed in needed series. Consider if
	  // there is a line series and a pie series, it is better not to update the
	  // line series if only pie series is needed to be updated.
	  getTargetSeries: function (ecModel) {
	    var seriesModelMap = createHashMap();
	    ecModel.eachComponent('dataZoom', function (dataZoomModel) {
	      dataZoomModel.eachTargetAxis(function (dimNames, axisIndex, dataZoomModel) {
	        var axisProxy = dataZoomModel.getAxisProxy(dimNames.name, axisIndex);
	        each(axisProxy.getTargetSeriesModels(), function (seriesModel) {
	          seriesModelMap.set(seriesModel.uid, seriesModel);
	        });
	      });
	    });
	    return seriesModelMap;
	  },
	  modifyOutputEnd: true,
	  // Consider appendData, where filter should be performed. Because data process is
	  // in block mode currently, it is not need to worry about that the overallProgress
	  // execute every frame.
	  overallReset: function (ecModel, api) {
	    ecModel.eachComponent('dataZoom', function (dataZoomModel) {
	      // We calculate window and reset axis here but not in model
	      // init stage and not after action dispatch handler, because
	      // reset should be called after seriesData.restoreData.
	      dataZoomModel.eachTargetAxis(function (dimNames, axisIndex, dataZoomModel) {
	        dataZoomModel.getAxisProxy(dimNames.name, axisIndex).reset(dataZoomModel, api);
	      }); // Caution: data zoom filtering is order sensitive when using
	      // percent range and no min/max/scale set on axis.
	      // For example, we have dataZoom definition:
	      // [
	      //      {xAxisIndex: 0, start: 30, end: 70},
	      //      {yAxisIndex: 0, start: 20, end: 80}
	      // ]
	      // In this case, [20, 80] of y-dataZoom should be based on data
	      // that have filtered by x-dataZoom using range of [30, 70],
	      // but should not be based on full raw data. Thus sliding
	      // x-dataZoom will change both ranges of xAxis and yAxis,
	      // while sliding y-dataZoom will only change the range of yAxis.
	      // So we should filter x-axis after reset x-axis immediately,
	      // and then reset y-axis and filter y-axis.
	
	      dataZoomModel.eachTargetAxis(function (dimNames, axisIndex, dataZoomModel) {
	        dataZoomModel.getAxisProxy(dimNames.name, axisIndex).filterData(dataZoomModel, api);
	      });
	    });
	    ecModel.eachComponent('dataZoom', function (dataZoomModel) {
	      // Fullfill all of the range props so that user
	      // is able to get them from chart.getOption().
	      var axisProxy = dataZoomModel.findRepresentativeAxisProxy();
	      var percentRange = axisProxy.getDataPercentWindow();
	      var valueRange = axisProxy.getDataValueWindow();
	      dataZoomModel.setCalculatedRange({
	        start: percentRange[0],
	        end: percentRange[1],
	        startValue: valueRange[0],
	        endValue: valueRange[1]
	      });
	    });
	  }
	});

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var formatUtil = __webpack_require__(40);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var AXIS_DIMS = ['x', 'y', 'z', 'radius', 'angle', 'single']; // Supported coords.
	
	var COORDS = ['cartesian2d', 'polar', 'singleAxis'];
	/**
	 * @param {string} coordType
	 * @return {boolean}
	 */
	
	function isCoordSupported(coordType) {
	  return zrUtil.indexOf(COORDS, coordType) >= 0;
	}
	/**
	 * Create "each" method to iterate names.
	 *
	 * @pubilc
	 * @param  {Array.<string>} names
	 * @param  {Array.<string>=} attrs
	 * @return {Function}
	 */
	
	
	function createNameEach(names, attrs) {
	  names = names.slice();
	  var capitalNames = zrUtil.map(names, formatUtil.capitalFirst);
	  attrs = (attrs || []).slice();
	  var capitalAttrs = zrUtil.map(attrs, formatUtil.capitalFirst);
	  return function (callback, context) {
	    zrUtil.each(names, function (name, index) {
	      var nameObj = {
	        name: name,
	        capital: capitalNames[index]
	      };
	
	      for (var j = 0; j < attrs.length; j++) {
	        nameObj[attrs[j]] = name + capitalAttrs[j];
	      }
	
	      callback.call(context, nameObj);
	    });
	  };
	}
	/**
	 * Iterate each dimension name.
	 *
	 * @public
	 * @param {Function} callback The parameter is like:
	 *                            {
	 *                                name: 'angle',
	 *                                capital: 'Angle',
	 *                                axis: 'angleAxis',
	 *                                axisIndex: 'angleAixs',
	 *                                index: 'angleIndex'
	 *                            }
	 * @param {Object} context
	 */
	
	
	var eachAxisDim = createNameEach(AXIS_DIMS, ['axisIndex', 'axis', 'index', 'id']);
	/**
	 * If tow dataZoomModels has the same axis controlled, we say that they are 'linked'.
	 * dataZoomModels and 'links' make up one or more graphics.
	 * This function finds the graphic where the source dataZoomModel is in.
	 *
	 * @public
	 * @param {Function} forEachNode Node iterator.
	 * @param {Function} forEachEdgeType edgeType iterator
	 * @param {Function} edgeIdGetter Giving node and edgeType, return an array of edge id.
	 * @return {Function} Input: sourceNode, Output: Like {nodes: [], dims: {}}
	 */
	
	function createLinkedNodesFinder(forEachNode, forEachEdgeType, edgeIdGetter) {
	  return function (sourceNode) {
	    var result = {
	      nodes: [],
	      records: {} // key: edgeType.name, value: Object (key: edge id, value: boolean).
	
	    };
	    forEachEdgeType(function (edgeType) {
	      result.records[edgeType.name] = {};
	    });
	
	    if (!sourceNode) {
	      return result;
	    }
	
	    absorb(sourceNode, result);
	    var existsLink;
	
	    do {
	      existsLink = false;
	      forEachNode(processSingleNode);
	    } while (existsLink);
	
	    function processSingleNode(node) {
	      if (!isNodeAbsorded(node, result) && isLinked(node, result)) {
	        absorb(node, result);
	        existsLink = true;
	      }
	    }
	
	    return result;
	  };
	
	  function isNodeAbsorded(node, result) {
	    return zrUtil.indexOf(result.nodes, node) >= 0;
	  }
	
	  function isLinked(node, result) {
	    var hasLink = false;
	    forEachEdgeType(function (edgeType) {
	      zrUtil.each(edgeIdGetter(node, edgeType) || [], function (edgeId) {
	        result.records[edgeType.name][edgeId] && (hasLink = true);
	      });
	    });
	    return hasLink;
	  }
	
	  function absorb(node, result) {
	    result.nodes.push(node);
	    forEachEdgeType(function (edgeType) {
	      zrUtil.each(edgeIdGetter(node, edgeType) || [], function (edgeId) {
	        result.records[edgeType.name][edgeId] = true;
	      });
	    });
	  }
	}
	
	exports.isCoordSupported = isCoordSupported;
	exports.createNameEach = createNameEach;
	exports.eachAxisDim = eachAxisDim;
	exports.createLinkedNodesFinder = createLinkedNodesFinder;

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Component = __webpack_require__(57);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	Component.registerSubTypeDefaulter('dataZoom', function () {
	  // Default 'slider' when no type specified.
	  return 'slider';
	});

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(3);
	
	var Eventful = __webpack_require__(189);
	
	var graphic = __webpack_require__(16);
	
	var interactionMutex = __webpack_require__(721);
	
	var DataDiffer = __webpack_require__(166);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var curry = zrUtil.curry;
	var each = zrUtil.each;
	var map = zrUtil.map;
	var mathMin = Math.min;
	var mathMax = Math.max;
	var mathPow = Math.pow;
	var COVER_Z = 10000;
	var UNSELECT_THRESHOLD = 6;
	var MIN_RESIZE_LINE_WIDTH = 6;
	var MUTEX_RESOURCE_KEY = 'globalPan';
	var DIRECTION_MAP = {
	  w: [0, 0],
	  e: [0, 1],
	  n: [1, 0],
	  s: [1, 1]
	};
	var CURSOR_MAP = {
	  w: 'ew',
	  e: 'ew',
	  n: 'ns',
	  s: 'ns',
	  ne: 'nesw',
	  sw: 'nesw',
	  nw: 'nwse',
	  se: 'nwse'
	};
	var DEFAULT_BRUSH_OPT = {
	  brushStyle: {
	    lineWidth: 2,
	    stroke: 'rgba(0,0,0,0.3)',
	    fill: 'rgba(0,0,0,0.1)'
	  },
	  transformable: true,
	  brushMode: 'single',
	  removeOnClick: false
	};
	var baseUID = 0;
	/**
	 * @alias module:echarts/component/helper/BrushController
	 * @constructor
	 * @mixin {module:zrender/mixin/Eventful}
	 * @event module:echarts/component/helper/BrushController#brush
	 *        params:
	 *            areas: Array.<Array>, coord relates to container group,
	 *                                    If no container specified, to global.
	 *            opt {
	 *                isEnd: boolean,
	 *                removeOnClick: boolean
	 *            }
	 *
	 * @param {module:zrender/zrender~ZRender} zr
	 */
	
	function BrushController(zr) {
	  Eventful.call(this);
	  /**
	   * @type {module:zrender/zrender~ZRender}
	   * @private
	   */
	
	  this._zr = zr;
	  /**
	   * @type {module:zrender/container/Group}
	   * @readOnly
	   */
	
	  this.group = new graphic.Group();
	  /**
	   * Only for drawing (after enabledBrush).
	   *     'line', 'rect', 'polygon' or false
	   *     If passing false/null/undefined, disable brush.
	   *     If passing 'auto', determined by panel.defaultBrushType
	   * @private
	   * @type {string}
	   */
	
	  this._brushType;
	  /**
	   * Only for drawing (after enabledBrush).
	   *
	   * @private
	   * @type {Object}
	   */
	
	  this._brushOption;
	  /**
	   * @private
	   * @type {Object}
	   */
	
	  this._panels;
	  /**
	   * @private
	   * @type {Array.<nubmer>}
	   */
	
	  this._track = [];
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._dragging;
	  /**
	   * @private
	   * @type {Array}
	   */
	
	  this._covers = [];
	  /**
	   * @private
	   * @type {moudule:zrender/container/Group}
	   */
	
	  this._creatingCover;
	  /**
	   * `true` means global panel
	   * @private
	   * @type {module:zrender/container/Group|boolean}
	   */
	
	  this._creatingPanel;
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._enableGlobalPan;
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  /**
	   * @private
	   * @type {string}
	   */
	  this._uid = 'brushController_' + baseUID++;
	  /**
	   * @private
	   * @type {Object}
	   */
	
	  this._handlers = {};
	  each(pointerHandlers, function (handler, eventName) {
	    this._handlers[eventName] = zrUtil.bind(handler, this);
	  }, this);
	}
	
	BrushController.prototype = {
	  constructor: BrushController,
	
	  /**
	   * If set to null/undefined/false, select disabled.
	   * @param {Object} brushOption
	   * @param {string|boolean} brushOption.brushType 'line', 'rect', 'polygon' or false
	   *                          If passing false/null/undefined, disable brush.
	   *                          If passing 'auto', determined by panel.defaultBrushType.
	   *                              ('auto' can not be used in global panel)
	   * @param {number} [brushOption.brushMode='single'] 'single' or 'multiple'
	   * @param {boolean} [brushOption.transformable=true]
	   * @param {boolean} [brushOption.removeOnClick=false]
	   * @param {Object} [brushOption.brushStyle]
	   * @param {number} [brushOption.brushStyle.width]
	   * @param {number} [brushOption.brushStyle.lineWidth]
	   * @param {string} [brushOption.brushStyle.stroke]
	   * @param {string} [brushOption.brushStyle.fill]
	   * @param {number} [brushOption.z]
	   */
	  enableBrush: function (brushOption) {
	    this._brushType && doDisableBrush(this);
	    brushOption.brushType && doEnableBrush(this, brushOption);
	    return this;
	  },
	
	  /**
	   * @param {Array.<Object>} panelOpts If not pass, it is global brush.
	   *        Each items: {
	   *            panelId, // mandatory.
	   *            clipPath, // mandatory. function.
	   *            isTargetByCursor, // mandatory. function.
	   *            defaultBrushType, // optional, only used when brushType is 'auto'.
	   *            getLinearBrushOtherExtent, // optional. function.
	   *        }
	   */
	  setPanels: function (panelOpts) {
	    if (panelOpts && panelOpts.length) {
	      var panels = this._panels = {};
	      zrUtil.each(panelOpts, function (panelOpts) {
	        panels[panelOpts.panelId] = zrUtil.clone(panelOpts);
	      });
	    } else {
	      this._panels = null;
	    }
	
	    return this;
	  },
	
	  /**
	   * @param {Object} [opt]
	   * @return {boolean} [opt.enableGlobalPan=false]
	   */
	  mount: function (opt) {
	    opt = opt || {};
	    this._enableGlobalPan = opt.enableGlobalPan;
	    var thisGroup = this.group;
	
	    this._zr.add(thisGroup);
	
	    thisGroup.attr({
	      position: opt.position || [0, 0],
	      rotation: opt.rotation || 0,
	      scale: opt.scale || [1, 1]
	    });
	    this._transform = thisGroup.getLocalTransform();
	    return this;
	  },
	  eachCover: function (cb, context) {
	    each(this._covers, cb, context);
	  },
	
	  /**
	   * Update covers.
	   * @param {Array.<Object>} brushOptionList Like:
	   *        [
	   *            {id: 'xx', brushType: 'line', range: [23, 44], brushStyle, transformable},
	   *            {id: 'yy', brushType: 'rect', range: [[23, 44], [23, 54]]},
	   *            ...
	   *        ]
	   *        `brushType` is required in each cover info. (can not be 'auto')
	   *        `id` is not mandatory.
	   *        `brushStyle`, `transformable` is not mandatory, use DEFAULT_BRUSH_OPT by default.
	   *        If brushOptionList is null/undefined, all covers removed.
	   */
	  updateCovers: function (brushOptionList) {
	    brushOptionList = zrUtil.map(brushOptionList, function (brushOption) {
	      return zrUtil.merge(zrUtil.clone(DEFAULT_BRUSH_OPT), brushOption, true);
	    });
	    var tmpIdPrefix = '\0-brush-index-';
	    var oldCovers = this._covers;
	    var newCovers = this._covers = [];
	    var controller = this;
	    var creatingCover = this._creatingCover;
	    new DataDiffer(oldCovers, brushOptionList, oldGetKey, getKey).add(addOrUpdate).update(addOrUpdate).remove(remove).execute();
	    return this;
	
	    function getKey(brushOption, index) {
	      return (brushOption.id != null ? brushOption.id : tmpIdPrefix + index) + '-' + brushOption.brushType;
	    }
	
	    function oldGetKey(cover, index) {
	      return getKey(cover.__brushOption, index);
	    }
	
	    function addOrUpdate(newIndex, oldIndex) {
	      var newBrushOption = brushOptionList[newIndex]; // Consider setOption in event listener of brushSelect,
	      // where updating cover when creating should be forbiden.
	
	      if (oldIndex != null && oldCovers[oldIndex] === creatingCover) {
	        newCovers[newIndex] = oldCovers[oldIndex];
	      } else {
	        var cover = newCovers[newIndex] = oldIndex != null ? (oldCovers[oldIndex].__brushOption = newBrushOption, oldCovers[oldIndex]) : endCreating(controller, createCover(controller, newBrushOption));
	        updateCoverAfterCreation(controller, cover);
	      }
	    }
	
	    function remove(oldIndex) {
	      if (oldCovers[oldIndex] !== creatingCover) {
	        controller.group.remove(oldCovers[oldIndex]);
	      }
	    }
	  },
	  unmount: function () {
	    this.enableBrush(false); // container may 'removeAll' outside.
	
	    clearCovers(this);
	
	    this._zr.remove(this.group);
	
	    return this;
	  },
	  dispose: function () {
	    this.unmount();
	    this.off();
	  }
	};
	zrUtil.mixin(BrushController, Eventful);
	
	function doEnableBrush(controller, brushOption) {
	  var zr = controller._zr; // Consider roam, which takes globalPan too.
	
	  if (!controller._enableGlobalPan) {
	    interactionMutex.take(zr, MUTEX_RESOURCE_KEY, controller._uid);
	  }
	
	  mountHandlers(zr, controller._handlers);
	  controller._brushType = brushOption.brushType;
	  controller._brushOption = zrUtil.merge(zrUtil.clone(DEFAULT_BRUSH_OPT), brushOption, true);
	}
	
	function doDisableBrush(controller) {
	  var zr = controller._zr;
	  interactionMutex.release(zr, MUTEX_RESOURCE_KEY, controller._uid);
	  unmountHandlers(zr, controller._handlers);
	  controller._brushType = controller._brushOption = null;
	}
	
	function mountHandlers(zr, handlers) {
	  each(handlers, function (handler, eventName) {
	    zr.on(eventName, handler);
	  });
	}
	
	function unmountHandlers(zr, handlers) {
	  each(handlers, function (handler, eventName) {
	    zr.off(eventName, handler);
	  });
	}
	
	function createCover(controller, brushOption) {
	  var cover = coverRenderers[brushOption.brushType].createCover(controller, brushOption);
	  cover.__brushOption = brushOption;
	  updateZ(cover, brushOption);
	  controller.group.add(cover);
	  return cover;
	}
	
	function endCreating(controller, creatingCover) {
	  var coverRenderer = getCoverRenderer(creatingCover);
	
	  if (coverRenderer.endCreating) {
	    coverRenderer.endCreating(controller, creatingCover);
	    updateZ(creatingCover, creatingCover.__brushOption);
	  }
	
	  return creatingCover;
	}
	
	function updateCoverShape(controller, cover) {
	  var brushOption = cover.__brushOption;
	  getCoverRenderer(cover).updateCoverShape(controller, cover, brushOption.range, brushOption);
	}
	
	function updateZ(cover, brushOption) {
	  var z = brushOption.z;
	  z == null && (z = COVER_Z);
	  cover.traverse(function (el) {
	    el.z = z;
	    el.z2 = z; // Consider in given container.
	  });
	}
	
	function updateCoverAfterCreation(controller, cover) {
	  getCoverRenderer(cover).updateCommon(controller, cover);
	  updateCoverShape(controller, cover);
	}
	
	function getCoverRenderer(cover) {
	  return coverRenderers[cover.__brushOption.brushType];
	} // return target panel or `true` (means global panel)
	
	
	function getPanelByPoint(controller, e, localCursorPoint) {
	  var panels = controller._panels;
	
	  if (!panels) {
	    return true; // Global panel
	  }
	
	  var panel;
	  var transform = controller._transform;
	  each(panels, function (pn) {
	    pn.isTargetByCursor(e, localCursorPoint, transform) && (panel = pn);
	  });
	  return panel;
	} // Return a panel or true
	
	
	function getPanelByCover(controller, cover) {
	  var panels = controller._panels;
	
	  if (!panels) {
	    return true; // Global panel
	  }
	
	  var panelId = cover.__brushOption.panelId; // User may give cover without coord sys info,
	  // which is then treated as global panel.
	
	  return panelId != null ? panels[panelId] : true;
	}
	
	function clearCovers(controller) {
	  var covers = controller._covers;
	  var originalLength = covers.length;
	  each(covers, function (cover) {
	    controller.group.remove(cover);
	  }, controller);
	  covers.length = 0;
	  return !!originalLength;
	}
	
	function trigger(controller, opt) {
	  var areas = map(controller._covers, function (cover) {
	    var brushOption = cover.__brushOption;
	    var range = zrUtil.clone(brushOption.range);
	    return {
	      brushType: brushOption.brushType,
	      panelId: brushOption.panelId,
	      range: range
	    };
	  });
	  controller.trigger('brush', areas, {
	    isEnd: !!opt.isEnd,
	    removeOnClick: !!opt.removeOnClick
	  });
	}
	
	function shouldShowCover(controller) {
	  var track = controller._track;
	
	  if (!track.length) {
	    return false;
	  }
	
	  var p2 = track[track.length - 1];
	  var p1 = track[0];
	  var dx = p2[0] - p1[0];
	  var dy = p2[1] - p1[1];
	  var dist = mathPow(dx * dx + dy * dy, 0.5);
	  return dist > UNSELECT_THRESHOLD;
	}
	
	function getTrackEnds(track) {
	  var tail = track.length - 1;
	  tail < 0 && (tail = 0);
	  return [track[0], track[tail]];
	}
	
	function createBaseRectCover(doDrift, controller, brushOption, edgeNames) {
	  var cover = new graphic.Group();
	  cover.add(new graphic.Rect({
	    name: 'main',
	    style: makeStyle(brushOption),
	    silent: true,
	    draggable: true,
	    cursor: 'move',
	    drift: curry(doDrift, controller, cover, 'nswe'),
	    ondragend: curry(trigger, controller, {
	      isEnd: true
	    })
	  }));
	  each(edgeNames, function (name) {
	    cover.add(new graphic.Rect({
	      name: name,
	      style: {
	        opacity: 0
	      },
	      draggable: true,
	      silent: true,
	      invisible: true,
	      drift: curry(doDrift, controller, cover, name),
	      ondragend: curry(trigger, controller, {
	        isEnd: true
	      })
	    }));
	  });
	  return cover;
	}
	
	function updateBaseRect(controller, cover, localRange, brushOption) {
	  var lineWidth = brushOption.brushStyle.lineWidth || 0;
	  var handleSize = mathMax(lineWidth, MIN_RESIZE_LINE_WIDTH);
	  var x = localRange[0][0];
	  var y = localRange[1][0];
	  var xa = x - lineWidth / 2;
	  var ya = y - lineWidth / 2;
	  var x2 = localRange[0][1];
	  var y2 = localRange[1][1];
	  var x2a = x2 - handleSize + lineWidth / 2;
	  var y2a = y2 - handleSize + lineWidth / 2;
	  var width = x2 - x;
	  var height = y2 - y;
	  var widtha = width + lineWidth;
	  var heighta = height + lineWidth;
	  updateRectShape(controller, cover, 'main', x, y, width, height);
	
	  if (brushOption.transformable) {
	    updateRectShape(controller, cover, 'w', xa, ya, handleSize, heighta);
	    updateRectShape(controller, cover, 'e', x2a, ya, handleSize, heighta);
	    updateRectShape(controller, cover, 'n', xa, ya, widtha, handleSize);
	    updateRectShape(controller, cover, 's', xa, y2a, widtha, handleSize);
	    updateRectShape(controller, cover, 'nw', xa, ya, handleSize, handleSize);
	    updateRectShape(controller, cover, 'ne', x2a, ya, handleSize, handleSize);
	    updateRectShape(controller, cover, 'sw', xa, y2a, handleSize, handleSize);
	    updateRectShape(controller, cover, 'se', x2a, y2a, handleSize, handleSize);
	  }
	}
	
	function updateCommon(controller, cover) {
	  var brushOption = cover.__brushOption;
	  var transformable = brushOption.transformable;
	  var mainEl = cover.childAt(0);
	  mainEl.useStyle(makeStyle(brushOption));
	  mainEl.attr({
	    silent: !transformable,
	    cursor: transformable ? 'move' : 'default'
	  });
	  each(['w', 'e', 'n', 's', 'se', 'sw', 'ne', 'nw'], function (name) {
	    var el = cover.childOfName(name);
	    var globalDir = getGlobalDirection(controller, name);
	    el && el.attr({
	      silent: !transformable,
	      invisible: !transformable,
	      cursor: transformable ? CURSOR_MAP[globalDir] + '-resize' : null
	    });
	  });
	}
	
	function updateRectShape(controller, cover, name, x, y, w, h) {
	  var el = cover.childOfName(name);
	  el && el.setShape(pointsToRect(clipByPanel(controller, cover, [[x, y], [x + w, y + h]])));
	}
	
	function makeStyle(brushOption) {
	  return zrUtil.defaults({
	    strokeNoScale: true
	  }, brushOption.brushStyle);
	}
	
	function formatRectRange(x, y, x2, y2) {
	  var min = [mathMin(x, x2), mathMin(y, y2)];
	  var max = [mathMax(x, x2), mathMax(y, y2)];
	  return [[min[0], max[0]], // x range
	  [min[1], max[1]] // y range
	  ];
	}
	
	function getTransform(controller) {
	  return graphic.getTransform(controller.group);
	}
	
	function getGlobalDirection(controller, localDirection) {
	  if (localDirection.length > 1) {
	    localDirection = localDirection.split('');
	    var globalDir = [getGlobalDirection(controller, localDirection[0]), getGlobalDirection(controller, localDirection[1])];
	    (globalDir[0] === 'e' || globalDir[0] === 'w') && globalDir.reverse();
	    return globalDir.join('');
	  } else {
	    var map = {
	      w: 'left',
	      e: 'right',
	      n: 'top',
	      s: 'bottom'
	    };
	    var inverseMap = {
	      left: 'w',
	      right: 'e',
	      top: 'n',
	      bottom: 's'
	    };
	    var globalDir = graphic.transformDirection(map[localDirection], getTransform(controller));
	    return inverseMap[globalDir];
	  }
	}
	
	function driftRect(toRectRange, fromRectRange, controller, cover, name, dx, dy, e) {
	  var brushOption = cover.__brushOption;
	  var rectRange = toRectRange(brushOption.range);
	  var localDelta = toLocalDelta(controller, dx, dy);
	  each(name.split(''), function (namePart) {
	    var ind = DIRECTION_MAP[namePart];
	    rectRange[ind[0]][ind[1]] += localDelta[ind[0]];
	  });
	  brushOption.range = fromRectRange(formatRectRange(rectRange[0][0], rectRange[1][0], rectRange[0][1], rectRange[1][1]));
	  updateCoverAfterCreation(controller, cover);
	  trigger(controller, {
	    isEnd: false
	  });
	}
	
	function driftPolygon(controller, cover, dx, dy, e) {
	  var range = cover.__brushOption.range;
	  var localDelta = toLocalDelta(controller, dx, dy);
	  each(range, function (point) {
	    point[0] += localDelta[0];
	    point[1] += localDelta[1];
	  });
	  updateCoverAfterCreation(controller, cover);
	  trigger(controller, {
	    isEnd: false
	  });
	}
	
	function toLocalDelta(controller, dx, dy) {
	  var thisGroup = controller.group;
	  var localD = thisGroup.transformCoordToLocal(dx, dy);
	  var localZero = thisGroup.transformCoordToLocal(0, 0);
	  return [localD[0] - localZero[0], localD[1] - localZero[1]];
	}
	
	function clipByPanel(controller, cover, data) {
	  var panel = getPanelByCover(controller, cover);
	  return panel && panel !== true ? panel.clipPath(data, controller._transform) : zrUtil.clone(data);
	}
	
	function pointsToRect(points) {
	  var xmin = mathMin(points[0][0], points[1][0]);
	  var ymin = mathMin(points[0][1], points[1][1]);
	  var xmax = mathMax(points[0][0], points[1][0]);
	  var ymax = mathMax(points[0][1], points[1][1]);
	  return {
	    x: xmin,
	    y: ymin,
	    width: xmax - xmin,
	    height: ymax - ymin
	  };
	}
	
	function resetCursor(controller, e, localCursorPoint) {
	  if ( // Check active
	  !controller._brushType // resetCursor should be always called when mouse is in zr area,
	  // but not called when mouse is out of zr area to avoid bad influence
	  // if `mousemove`, `mouseup` are triggered from `document` event.
	  || isOutsideZrArea(controller, e)) {
	    return;
	  }
	
	  var zr = controller._zr;
	  var covers = controller._covers;
	  var currPanel = getPanelByPoint(controller, e, localCursorPoint); // Check whether in covers.
	
	  if (!controller._dragging) {
	    for (var i = 0; i < covers.length; i++) {
	      var brushOption = covers[i].__brushOption;
	
	      if (currPanel && (currPanel === true || brushOption.panelId === currPanel.panelId) && coverRenderers[brushOption.brushType].contain(covers[i], localCursorPoint[0], localCursorPoint[1])) {
	        // Use cursor style set on cover.
	        return;
	      }
	    }
	  }
	
	  currPanel && zr.setCursorStyle('crosshair');
	}
	
	function preventDefault(e) {
	  var rawE = e.event;
	  rawE.preventDefault && rawE.preventDefault();
	}
	
	function mainShapeContain(cover, x, y) {
	  return cover.childOfName('main').contain(x, y);
	}
	
	function updateCoverByMouse(controller, e, localCursorPoint, isEnd) {
	  var creatingCover = controller._creatingCover;
	  var panel = controller._creatingPanel;
	  var thisBrushOption = controller._brushOption;
	  var eventParams;
	
	  controller._track.push(localCursorPoint.slice());
	
	  if (shouldShowCover(controller) || creatingCover) {
	    if (panel && !creatingCover) {
	      thisBrushOption.brushMode === 'single' && clearCovers(controller);
	      var brushOption = zrUtil.clone(thisBrushOption);
	      brushOption.brushType = determineBrushType(brushOption.brushType, panel);
	      brushOption.panelId = panel === true ? null : panel.panelId;
	      creatingCover = controller._creatingCover = createCover(controller, brushOption);
	
	      controller._covers.push(creatingCover);
	    }
	
	    if (creatingCover) {
	      var coverRenderer = coverRenderers[determineBrushType(controller._brushType, panel)];
	      var coverBrushOption = creatingCover.__brushOption;
	      coverBrushOption.range = coverRenderer.getCreatingRange(clipByPanel(controller, creatingCover, controller._track));
	
	      if (isEnd) {
	        endCreating(controller, creatingCover);
	        coverRenderer.updateCommon(controller, creatingCover);
	      }
	
	      updateCoverShape(controller, creatingCover);
	      eventParams = {
	        isEnd: isEnd
	      };
	    }
	  } else if (isEnd && thisBrushOption.brushMode === 'single' && thisBrushOption.removeOnClick) {
	    // Help user to remove covers easily, only by a tiny drag, in 'single' mode.
	    // But a single click do not clear covers, because user may have casual
	    // clicks (for example, click on other component and do not expect covers
	    // disappear).
	    // Only some cover removed, trigger action, but not every click trigger action.
	    if (getPanelByPoint(controller, e, localCursorPoint) && clearCovers(controller)) {
	      eventParams = {
	        isEnd: isEnd,
	        removeOnClick: true
	      };
	    }
	  }
	
	  return eventParams;
	}
	
	function determineBrushType(brushType, panel) {
	  if (brushType === 'auto') {
	    return panel.defaultBrushType;
	  }
	
	  return brushType;
	}
	
	var pointerHandlers = {
	  mousedown: function (e) {
	    if (this._dragging) {
	      // In case some browser do not support globalOut,
	      // and release mose out side the browser.
	      handleDragEnd(this, e);
	    } else if (!e.target || !e.target.draggable) {
	      preventDefault(e);
	      var localCursorPoint = this.group.transformCoordToLocal(e.offsetX, e.offsetY);
	      this._creatingCover = null;
	      var panel = this._creatingPanel = getPanelByPoint(this, e, localCursorPoint);
	
	      if (panel) {
	        this._dragging = true;
	        this._track = [localCursorPoint.slice()];
	      }
	    }
	  },
	  mousemove: function (e) {
	    var x = e.offsetX;
	    var y = e.offsetY;
	    var localCursorPoint = this.group.transformCoordToLocal(x, y);
	    resetCursor(this, e, localCursorPoint);
	
	    if (this._dragging) {
	      preventDefault(e);
	      var eventParams = updateCoverByMouse(this, e, localCursorPoint, false);
	      eventParams && trigger(this, eventParams);
	    }
	  },
	  mouseup: function (e) {
	    handleDragEnd(this, e);
	  }
	};
	
	function handleDragEnd(controller, e) {
	  if (controller._dragging) {
	    preventDefault(e);
	    var x = e.offsetX;
	    var y = e.offsetY;
	    var localCursorPoint = controller.group.transformCoordToLocal(x, y);
	    var eventParams = updateCoverByMouse(controller, e, localCursorPoint, true);
	    controller._dragging = false;
	    controller._track = [];
	    controller._creatingCover = null; // trigger event shoule be at final, after procedure will be nested.
	
	    eventParams && trigger(controller, eventParams);
	  }
	}
	
	function isOutsideZrArea(controller, x, y) {
	  var zr = controller._zr;
	  return x < 0 || x > zr.getWidth() || y < 0 || y > zr.getHeight();
	}
	/**
	 * key: brushType
	 * @type {Object}
	 */
	
	
	var coverRenderers = {
	  lineX: getLineRenderer(0),
	  lineY: getLineRenderer(1),
	  rect: {
	    createCover: function (controller, brushOption) {
	      return createBaseRectCover(curry(driftRect, function (range) {
	        return range;
	      }, function (range) {
	        return range;
	      }), controller, brushOption, ['w', 'e', 'n', 's', 'se', 'sw', 'ne', 'nw']);
	    },
	    getCreatingRange: function (localTrack) {
	      var ends = getTrackEnds(localTrack);
	      return formatRectRange(ends[1][0], ends[1][1], ends[0][0], ends[0][1]);
	    },
	    updateCoverShape: function (controller, cover, localRange, brushOption) {
	      updateBaseRect(controller, cover, localRange, brushOption);
	    },
	    updateCommon: updateCommon,
	    contain: mainShapeContain
	  },
	  polygon: {
	    createCover: function (controller, brushOption) {
	      var cover = new graphic.Group(); // Do not use graphic.Polygon because graphic.Polyline do not close the
	      // border of the shape when drawing, which is a better experience for user.
	
	      cover.add(new graphic.Polyline({
	        name: 'main',
	        style: makeStyle(brushOption),
	        silent: true
	      }));
	      return cover;
	    },
	    getCreatingRange: function (localTrack) {
	      return localTrack;
	    },
	    endCreating: function (controller, cover) {
	      cover.remove(cover.childAt(0)); // Use graphic.Polygon close the shape.
	
	      cover.add(new graphic.Polygon({
	        name: 'main',
	        draggable: true,
	        drift: curry(driftPolygon, controller, cover),
	        ondragend: curry(trigger, controller, {
	          isEnd: true
	        })
	      }));
	    },
	    updateCoverShape: function (controller, cover, localRange, brushOption) {
	      cover.childAt(0).setShape({
	        points: clipByPanel(controller, cover, localRange)
	      });
	    },
	    updateCommon: updateCommon,
	    contain: mainShapeContain
	  }
	};
	
	function getLineRenderer(xyIndex) {
	  return {
	    createCover: function (controller, brushOption) {
	      return createBaseRectCover(curry(driftRect, function (range) {
	        var rectRange = [range, [0, 100]];
	        xyIndex && rectRange.reverse();
	        return rectRange;
	      }, function (rectRange) {
	        return rectRange[xyIndex];
	      }), controller, brushOption, [['w', 'e'], ['n', 's']][xyIndex]);
	    },
	    getCreatingRange: function (localTrack) {
	      var ends = getTrackEnds(localTrack);
	      var min = mathMin(ends[0][xyIndex], ends[1][xyIndex]);
	      var max = mathMax(ends[0][xyIndex], ends[1][xyIndex]);
	      return [min, max];
	    },
	    updateCoverShape: function (controller, cover, localRange, brushOption) {
	      var otherExtent; // If brushWidth not specified, fit the panel.
	
	      var panel = getPanelByCover(controller, cover);
	
	      if (panel !== true && panel.getLinearBrushOtherExtent) {
	        otherExtent = panel.getLinearBrushOtherExtent(xyIndex, controller._transform);
	      } else {
	        var zr = controller._zr;
	        otherExtent = [0, [zr.getWidth(), zr.getHeight()][1 - xyIndex]];
	      }
	
	      var rectRange = [localRange, otherExtent];
	      xyIndex && rectRange.reverse();
	      updateBaseRect(controller, cover, rectRange, brushOption);
	    },
	    updateCommon: updateCommon,
	    contain: mainShapeContain
	  };
	}
	
	var _default = BrushController;
	module.exports = _default;

/***/ },
/* 464 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * For geo and graph.
	 *
	 * @param {Object} controllerHost
	 * @param {module:zrender/Element} controllerHost.target
	 */
	function updateViewOnPan(controllerHost, dx, dy) {
	  var target = controllerHost.target;
	  var pos = target.position;
	  pos[0] += dx;
	  pos[1] += dy;
	  target.dirty();
	}
	/**
	 * For geo and graph.
	 *
	 * @param {Object} controllerHost
	 * @param {module:zrender/Element} controllerHost.target
	 * @param {number} controllerHost.zoom
	 * @param {number} controllerHost.zoomLimit like: {min: 1, max: 2}
	 */
	
	
	function updateViewOnZoom(controllerHost, zoomDelta, zoomX, zoomY) {
	  var target = controllerHost.target;
	  var zoomLimit = controllerHost.zoomLimit;
	  var pos = target.position;
	  var scale = target.scale;
	  var newZoom = controllerHost.zoom = controllerHost.zoom || 1;
	  newZoom *= zoomDelta;
	
	  if (zoomLimit) {
	    var zoomMin = zoomLimit.min || 0;
	    var zoomMax = zoomLimit.max || Infinity;
	    newZoom = Math.max(Math.min(zoomMax, newZoom), zoomMin);
	  }
	
	  var zoomScale = newZoom / controllerHost.zoom;
	  controllerHost.zoom = newZoom; // Keep the mouse center when scaling
	
	  pos[0] -= (zoomX - pos[0]) * (zoomScale - 1);
	  pos[1] -= (zoomY - pos[1]) * (zoomScale - 1);
	  scale[0] *= zoomScale;
	  scale[1] *= zoomScale;
	  target.dirty();
	}
	
	exports.updateViewOnPan = updateViewOnPan;
	exports.updateViewOnZoom = updateViewOnZoom;

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Data selectable mixin for chart series.
	 * To eanble data select, option of series must have `selectedMode`.
	 * And each data item will use `selected` to toggle itself selected status
	 */
	var _default = {
	  /**
	   * @param {Array.<Object>} targetList [{name, value, selected}, ...]
	   *        If targetList is an array, it should like [{name: ..., value: ...}, ...].
	   *        If targetList is a "List", it must have coordDim: 'value' dimension and name.
	   */
	  updateSelectedMap: function (targetList) {
	    this._targetList = zrUtil.isArray(targetList) ? targetList.slice() : [];
	    this._selectTargetMap = zrUtil.reduce(targetList || [], function (targetMap, target) {
	      targetMap.set(target.name, target);
	      return targetMap;
	    }, zrUtil.createHashMap());
	  },
	
	  /**
	   * Either name or id should be passed as input here.
	   * If both of them are defined, id is used.
	   *
	   * @param {string|undefined} name name of data
	   * @param {number|undefined} id dataIndex of data
	   */
	  // PENGING If selectedMode is null ?
	  select: function (name, id) {
	    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name);
	    var selectedMode = this.get('selectedMode');
	
	    if (selectedMode === 'single') {
	      this._selectTargetMap.each(function (target) {
	        target.selected = false;
	      });
	    }
	
	    target && (target.selected = true);
	  },
	
	  /**
	   * Either name or id should be passed as input here.
	   * If both of them are defined, id is used.
	   *
	   * @param {string|undefined} name name of data
	   * @param {number|undefined} id dataIndex of data
	   */
	  unSelect: function (name, id) {
	    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name); // var selectedMode = this.get('selectedMode');
	    // selectedMode !== 'single' && target && (target.selected = false);
	
	    target && (target.selected = false);
	  },
	
	  /**
	   * Either name or id should be passed as input here.
	   * If both of them are defined, id is used.
	   *
	   * @param {string|undefined} name name of data
	   * @param {number|undefined} id dataIndex of data
	   */
	  toggleSelected: function (name, id) {
	    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name);
	
	    if (target != null) {
	      this[target.selected ? 'unSelect' : 'select'](name, id);
	      return target.selected;
	    }
	  },
	
	  /**
	   * Either name or id should be passed as input here.
	   * If both of them are defined, id is used.
	   *
	   * @param {string|undefined} name name of data
	   * @param {number|undefined} id dataIndex of data
	   */
	  isSelected: function (name, id) {
	    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name);
	    return target && target.selected;
	  }
	};
	module.exports = _default;

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var env = __webpack_require__(55);
	
	var modelUtil = __webpack_require__(24);
	
	var formatUtil = __webpack_require__(40);
	
	var dataFormatMixin = __webpack_require__(475);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var addCommas = formatUtil.addCommas;
	var encodeHTML = formatUtil.encodeHTML;
	
	function fillLabel(opt) {
	  modelUtil.defaultEmphasis(opt, 'label', ['show']);
	}
	
	var MarkerModel = echarts.extendComponentModel({
	  type: 'marker',
	  dependencies: ['series', 'grid', 'polar', 'geo'],
	
	  /**
	   * @overrite
	   */
	  init: function (option, parentModel, ecModel) {
	    this.mergeDefaultAndTheme(option, ecModel);
	
	    this._mergeOption(option, ecModel, false, true);
	  },
	
	  /**
	   * @return {boolean}
	   */
	  isAnimationEnabled: function () {
	    if (env.node) {
	      return false;
	    }
	
	    var hostSeries = this.__hostSeries;
	    return this.getShallow('animation') && hostSeries && hostSeries.isAnimationEnabled();
	  },
	
	  /**
	   * @overrite
	   */
	  mergeOption: function (newOpt, ecModel) {
	    this._mergeOption(newOpt, ecModel, false, false);
	  },
	  _mergeOption: function (newOpt, ecModel, createdBySelf, isInit) {
	    var MarkerModel = this.constructor;
	    var modelPropName = this.mainType + 'Model';
	
	    if (!createdBySelf) {
	      ecModel.eachSeries(function (seriesModel) {
	        var markerOpt = seriesModel.get(this.mainType, true);
	        var markerModel = seriesModel[modelPropName];
	
	        if (!markerOpt || !markerOpt.data) {
	          seriesModel[modelPropName] = null;
	          return;
	        }
	
	        if (!markerModel) {
	          if (isInit) {
	            // Default label emphasis `position` and `show`
	            fillLabel(markerOpt);
	          }
	
	          zrUtil.each(markerOpt.data, function (item) {
	            // FIXME Overwrite fillLabel method ?
	            if (item instanceof Array) {
	              fillLabel(item[0]);
	              fillLabel(item[1]);
	            } else {
	              fillLabel(item);
	            }
	          });
	          markerModel = new MarkerModel(markerOpt, this, ecModel);
	          zrUtil.extend(markerModel, {
	            mainType: this.mainType,
	            // Use the same series index and name
	            seriesIndex: seriesModel.seriesIndex,
	            name: seriesModel.name,
	            createdBySelf: true
	          });
	          markerModel.__hostSeries = seriesModel;
	        } else {
	          markerModel._mergeOption(markerOpt, ecModel, true);
	        }
	
	        seriesModel[modelPropName] = markerModel;
	      }, this);
	    }
	  },
	  formatTooltip: function (dataIndex, multipleSeries, dataType, renderMode) {
	    var data = this.getData();
	    var value = this.getRawValue(dataIndex);
	    var formattedValue = zrUtil.isArray(value) ? zrUtil.map(value, addCommas).join(', ') : addCommas(value);
	    var name = data.getName(dataIndex);
	    var html = encodeHTML(this.name);
	    var newLine = renderMode === 'html' ? '<br/>' : '\n';
	
	    if (value != null || name) {
	      html += newLine;
	    }
	
	    if (name) {
	      html += encodeHTML(name);
	
	      if (value != null) {
	        html += ' : ';
	      }
	    }
	
	    if (value != null) {
	      html += encodeHTML(formattedValue);
	    }
	
	    return html;
	  },
	  getData: function () {
	    return this._data;
	  },
	  setData: function (data) {
	    this._data = data;
	  }
	});
	zrUtil.mixin(MarkerModel, dataFormatMixin);
	var _default = MarkerModel;
	module.exports = _default;

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentView({
	  type: 'marker',
	  init: function () {
	    /**
	     * Markline grouped by series
	     * @private
	     * @type {module:zrender/core/util.HashMap}
	     */
	    this.markerGroupMap = zrUtil.createHashMap();
	  },
	  render: function (markerModel, ecModel, api) {
	    var markerGroupMap = this.markerGroupMap;
	    markerGroupMap.each(function (item) {
	      item.__keep = false;
	    });
	    var markerModelKey = this.type + 'Model';
	    ecModel.eachSeries(function (seriesModel) {
	      var markerModel = seriesModel[markerModelKey];
	      markerModel && this.renderSeries(seriesModel, markerModel, ecModel, api);
	    }, this);
	    markerGroupMap.each(function (item) {
	      !item.__keep && this.group.remove(item.group);
	    }, this);
	  },
	  renderSeries: function () {}
	});
	
	module.exports = _default;

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var numberUtil = __webpack_require__(20);
	
	var _dataStackHelper = __webpack_require__(105);
	
	var isDimensionStacked = _dataStackHelper.isDimensionStacked;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var indexOf = zrUtil.indexOf;
	
	function hasXOrY(item) {
	  return !(isNaN(parseFloat(item.x)) && isNaN(parseFloat(item.y)));
	}
	
	function hasXAndY(item) {
	  return !isNaN(parseFloat(item.x)) && !isNaN(parseFloat(item.y));
	} // Make it simple, do not visit all stacked value to count precision.
	// function getPrecision(data, valueAxisDim, dataIndex) {
	//     var precision = -1;
	//     var stackedDim = data.mapDimension(valueAxisDim);
	//     do {
	//         precision = Math.max(
	//             numberUtil.getPrecision(data.get(stackedDim, dataIndex)),
	//             precision
	//         );
	//         var stackedOnSeries = data.getCalculationInfo('stackedOnSeries');
	//         if (stackedOnSeries) {
	//             var byValue = data.get(data.getCalculationInfo('stackedByDimension'), dataIndex);
	//             data = stackedOnSeries.getData();
	//             dataIndex = data.indexOf(data.getCalculationInfo('stackedByDimension'), byValue);
	//             stackedDim = data.getCalculationInfo('stackedDimension');
	//         }
	//         else {
	//             data = null;
	//         }
	//     } while (data);
	//     return precision;
	// }
	
	
	function markerTypeCalculatorWithExtent(mlType, data, otherDataDim, targetDataDim, otherCoordIndex, targetCoordIndex) {
	  var coordArr = [];
	  var stacked = isDimensionStacked(data, targetDataDim
	  /*, otherDataDim*/
	  );
	  var calcDataDim = stacked ? data.getCalculationInfo('stackResultDimension') : targetDataDim;
	  var value = numCalculate(data, calcDataDim, mlType);
	  var dataIndex = data.indicesOfNearest(calcDataDim, value)[0];
	  coordArr[otherCoordIndex] = data.get(otherDataDim, dataIndex);
	  coordArr[targetCoordIndex] = data.get(calcDataDim, dataIndex);
	  var coordArrValue = data.get(targetDataDim, dataIndex); // Make it simple, do not visit all stacked value to count precision.
	
	  var precision = numberUtil.getPrecision(data.get(targetDataDim, dataIndex));
	  precision = Math.min(precision, 20);
	
	  if (precision >= 0) {
	    coordArr[targetCoordIndex] = +coordArr[targetCoordIndex].toFixed(precision);
	  }
	
	  return [coordArr, coordArrValue];
	}
	
	var curry = zrUtil.curry; // TODO Specified percent
	
	var markerTypeCalculator = {
	  /**
	   * @method
	   * @param {module:echarts/data/List} data
	   * @param {string} baseAxisDim
	   * @param {string} valueAxisDim
	   */
	  min: curry(markerTypeCalculatorWithExtent, 'min'),
	
	  /**
	   * @method
	   * @param {module:echarts/data/List} data
	   * @param {string} baseAxisDim
	   * @param {string} valueAxisDim
	   */
	  max: curry(markerTypeCalculatorWithExtent, 'max'),
	
	  /**
	   * @method
	   * @param {module:echarts/data/List} data
	   * @param {string} baseAxisDim
	   * @param {string} valueAxisDim
	   */
	  average: curry(markerTypeCalculatorWithExtent, 'average')
	};
	/**
	 * Transform markPoint data item to format used in List by do the following
	 * 1. Calculate statistic like `max`, `min`, `average`
	 * 2. Convert `item.xAxis`, `item.yAxis` to `item.coord` array
	 * @param  {module:echarts/model/Series} seriesModel
	 * @param  {module:echarts/coord/*} [coordSys]
	 * @param  {Object} item
	 * @return {Object}
	 */
	
	function dataTransform(seriesModel, item) {
	  var data = seriesModel.getData();
	  var coordSys = seriesModel.coordinateSystem; // 1. If not specify the position with pixel directly
	  // 2. If `coord` is not a data array. Which uses `xAxis`,
	  // `yAxis` to specify the coord on each dimension
	  // parseFloat first because item.x and item.y can be percent string like '20%'
	
	  if (item && !hasXAndY(item) && !zrUtil.isArray(item.coord) && coordSys) {
	    var dims = coordSys.dimensions;
	    var axisInfo = getAxisInfo(item, data, coordSys, seriesModel); // Clone the option
	    // Transform the properties xAxis, yAxis, radiusAxis, angleAxis, geoCoord to value
	
	    item = zrUtil.clone(item);
	
	    if (item.type && markerTypeCalculator[item.type] && axisInfo.baseAxis && axisInfo.valueAxis) {
	      var otherCoordIndex = indexOf(dims, axisInfo.baseAxis.dim);
	      var targetCoordIndex = indexOf(dims, axisInfo.valueAxis.dim);
	      var coordInfo = markerTypeCalculator[item.type](data, axisInfo.baseDataDim, axisInfo.valueDataDim, otherCoordIndex, targetCoordIndex);
	      item.coord = coordInfo[0]; // Force to use the value of calculated value.
	      // let item use the value without stack.
	
	      item.value = coordInfo[1];
	    } else {
	      // FIXME Only has one of xAxis and yAxis.
	      var coord = [item.xAxis != null ? item.xAxis : item.radiusAxis, item.yAxis != null ? item.yAxis : item.angleAxis]; // Each coord support max, min, average
	
	      for (var i = 0; i < 2; i++) {
	        if (markerTypeCalculator[coord[i]]) {
	          coord[i] = numCalculate(data, data.mapDimension(dims[i]), coord[i]);
	        }
	      }
	
	      item.coord = coord;
	    }
	  }
	
	  return item;
	}
	
	function getAxisInfo(item, data, coordSys, seriesModel) {
	  var ret = {};
	
	  if (item.valueIndex != null || item.valueDim != null) {
	    ret.valueDataDim = item.valueIndex != null ? data.getDimension(item.valueIndex) : item.valueDim;
	    ret.valueAxis = coordSys.getAxis(dataDimToCoordDim(seriesModel, ret.valueDataDim));
	    ret.baseAxis = coordSys.getOtherAxis(ret.valueAxis);
	    ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
	  } else {
	    ret.baseAxis = seriesModel.getBaseAxis();
	    ret.valueAxis = coordSys.getOtherAxis(ret.baseAxis);
	    ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
	    ret.valueDataDim = data.mapDimension(ret.valueAxis.dim);
	  }
	
	  return ret;
	}
	
	function dataDimToCoordDim(seriesModel, dataDim) {
	  var data = seriesModel.getData();
	  var dimensions = data.dimensions;
	  dataDim = data.getDimension(dataDim);
	
	  for (var i = 0; i < dimensions.length; i++) {
	    var dimItem = data.getDimensionInfo(dimensions[i]);
	
	    if (dimItem.name === dataDim) {
	      return dimItem.coordDim;
	    }
	  }
	}
	/**
	 * Filter data which is out of coordinateSystem range
	 * [dataFilter description]
	 * @param  {module:echarts/coord/*} [coordSys]
	 * @param  {Object} item
	 * @return {boolean}
	 */
	
	
	function dataFilter(coordSys, item) {
	  // Alwalys return true if there is no coordSys
	  return coordSys && coordSys.containData && item.coord && !hasXOrY(item) ? coordSys.containData(item.coord) : true;
	}
	
	function dimValueGetter(item, dimName, dataIndex, dimIndex) {
	  // x, y, radius, angle
	  if (dimIndex < 2) {
	    return item.coord && item.coord[dimIndex];
	  }
	
	  return item.value;
	}
	
	function numCalculate(data, valueDataDim, type) {
	  if (type === 'average') {
	    var sum = 0;
	    var count = 0;
	    data.each(valueDataDim, function (val, idx) {
	      if (!isNaN(val)) {
	        sum += val;
	        count++;
	      }
	    });
	    return sum / count;
	  } else if (type === 'median') {
	    return data.getMedian(valueDataDim);
	  } else {
	    // max & min
	    return data.getDataExtent(valueDataDim, true)[type === 'max' ? 1 : 0];
	  }
	}
	
	exports.dataTransform = dataTransform;
	exports.getAxisInfo = getAxisInfo;
	exports.dataFilter = dataFilter;
	exports.dimValueGetter = dimValueGetter;
	exports.numCalculate = numCalculate;

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var vector = __webpack_require__(41);
	
	var matrix = __webpack_require__(73);
	
	var BoundingRect = __webpack_require__(42);
	
	var Transformable = __webpack_require__(389);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Simple view coordinate system
	 * Mapping given x, y to transformd view x, y
	 */
	var v2ApplyTransform = vector.applyTransform; // Dummy transform node
	
	function TransformDummy() {
	  Transformable.call(this);
	}
	
	zrUtil.mixin(TransformDummy, Transformable);
	
	function View(name) {
	  /**
	   * @type {string}
	   */
	  this.name = name;
	  /**
	   * @type {Object}
	   */
	
	  this.zoomLimit;
	  Transformable.call(this);
	  this._roamTransformable = new TransformDummy();
	  this._rawTransformable = new TransformDummy();
	  this._center;
	  this._zoom;
	}
	
	View.prototype = {
	  constructor: View,
	  type: 'view',
	
	  /**
	   * @param {Array.<string>}
	   * @readOnly
	   */
	  dimensions: ['x', 'y'],
	
	  /**
	   * Set bounding rect
	   * @param {number} x
	   * @param {number} y
	   * @param {number} width
	   * @param {number} height
	   */
	  // PENDING to getRect
	  setBoundingRect: function (x, y, width, height) {
	    this._rect = new BoundingRect(x, y, width, height);
	    return this._rect;
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  // PENDING to getRect
	  getBoundingRect: function () {
	    return this._rect;
	  },
	
	  /**
	   * @param {number} x
	   * @param {number} y
	   * @param {number} width
	   * @param {number} height
	   */
	  setViewRect: function (x, y, width, height) {
	    this.transformTo(x, y, width, height);
	    this._viewRect = new BoundingRect(x, y, width, height);
	  },
	
	  /**
	   * Transformed to particular position and size
	   * @param {number} x
	   * @param {number} y
	   * @param {number} width
	   * @param {number} height
	   */
	  transformTo: function (x, y, width, height) {
	    var rect = this.getBoundingRect();
	    var rawTransform = this._rawTransformable;
	    rawTransform.transform = rect.calculateTransform(new BoundingRect(x, y, width, height));
	    rawTransform.decomposeTransform();
	
	    this._updateTransform();
	  },
	
	  /**
	   * Set center of view
	   * @param {Array.<number>} [centerCoord]
	   */
	  setCenter: function (centerCoord) {
	    if (!centerCoord) {
	      return;
	    }
	
	    this._center = centerCoord;
	
	    this._updateCenterAndZoom();
	  },
	
	  /**
	   * @param {number} zoom
	   */
	  setZoom: function (zoom) {
	    zoom = zoom || 1;
	    var zoomLimit = this.zoomLimit;
	
	    if (zoomLimit) {
	      if (zoomLimit.max != null) {
	        zoom = Math.min(zoomLimit.max, zoom);
	      }
	
	      if (zoomLimit.min != null) {
	        zoom = Math.max(zoomLimit.min, zoom);
	      }
	    }
	
	    this._zoom = zoom;
	
	    this._updateCenterAndZoom();
	  },
	
	  /**
	   * Get default center without roam
	   */
	  getDefaultCenter: function () {
	    // Rect before any transform
	    var rawRect = this.getBoundingRect();
	    var cx = rawRect.x + rawRect.width / 2;
	    var cy = rawRect.y + rawRect.height / 2;
	    return [cx, cy];
	  },
	  getCenter: function () {
	    return this._center || this.getDefaultCenter();
	  },
	  getZoom: function () {
	    return this._zoom || 1;
	  },
	
	  /**
	   * @return {Array.<number}
	   */
	  getRoamTransform: function () {
	    return this._roamTransformable.getLocalTransform();
	  },
	
	  /**
	   * Remove roam
	   */
	  _updateCenterAndZoom: function () {
	    // Must update after view transform updated
	    var rawTransformMatrix = this._rawTransformable.getLocalTransform();
	
	    var roamTransform = this._roamTransformable;
	    var defaultCenter = this.getDefaultCenter();
	    var center = this.getCenter();
	    var zoom = this.getZoom();
	    center = vector.applyTransform([], center, rawTransformMatrix);
	    defaultCenter = vector.applyTransform([], defaultCenter, rawTransformMatrix);
	    roamTransform.origin = center;
	    roamTransform.position = [defaultCenter[0] - center[0], defaultCenter[1] - center[1]];
	    roamTransform.scale = [zoom, zoom];
	
	    this._updateTransform();
	  },
	
	  /**
	   * Update transform from roam and mapLocation
	   * @private
	   */
	  _updateTransform: function () {
	    var roamTransformable = this._roamTransformable;
	    var rawTransformable = this._rawTransformable;
	    rawTransformable.parent = roamTransformable;
	    roamTransformable.updateTransform();
	    rawTransformable.updateTransform();
	    matrix.copy(this.transform || (this.transform = []), rawTransformable.transform || matrix.create());
	    this._rawTransform = rawTransformable.getLocalTransform();
	    this.invTransform = this.invTransform || [];
	    matrix.invert(this.invTransform, this.transform);
	    this.decomposeTransform();
	  },
	  getTransformInfo: function () {
	    var roamTransform = this._roamTransformable.transform;
	    var rawTransformable = this._rawTransformable;
	    return {
	      roamTransform: roamTransform ? zrUtil.slice(roamTransform) : matrix.create(),
	      rawScale: zrUtil.slice(rawTransformable.scale),
	      rawPosition: zrUtil.slice(rawTransformable.position)
	    };
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getViewRect: function () {
	    return this._viewRect;
	  },
	
	  /**
	   * Get view rect after roam transform
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getViewRectAfterRoam: function () {
	    var rect = this.getBoundingRect().clone();
	    rect.applyTransform(this.transform);
	    return rect;
	  },
	
	  /**
	   * Convert a single (lon, lat) data item to (x, y) point.
	   * @param {Array.<number>} data
	   * @param {boolean} noRoam
	   * @param {Array.<number>} [out]
	   * @return {Array.<number>}
	   */
	  dataToPoint: function (data, noRoam, out) {
	    var transform = noRoam ? this._rawTransform : this.transform;
	    out = out || [];
	    return transform ? v2ApplyTransform(out, data, transform) : vector.copy(out, data);
	  },
	
	  /**
	   * Convert a (x, y) point to (lon, lat) data
	   * @param {Array.<number>} point
	   * @return {Array.<number>}
	   */
	  pointToData: function (point) {
	    var invTransform = this.invTransform;
	    return invTransform ? v2ApplyTransform([], point, invTransform) : [point[0], point[1]];
	  },
	
	  /**
	   * @implements
	   * see {module:echarts/CoodinateSystem}
	   */
	  convertToPixel: zrUtil.curry(doConvert, 'dataToPoint'),
	
	  /**
	   * @implements
	   * see {module:echarts/CoodinateSystem}
	   */
	  convertFromPixel: zrUtil.curry(doConvert, 'pointToData'),
	
	  /**
	   * @implements
	   * see {module:echarts/CoodinateSystem}
	   */
	  containPoint: function (point) {
	    return this.getViewRectAfterRoam().contain(point[0], point[1]);
	  }
	  /**
	   * @return {number}
	   */
	  // getScalarScale: function () {
	  //     // Use determinant square root of transform to mutiply scalar
	  //     var m = this.transform;
	  //     var det = Math.sqrt(Math.abs(m[0] * m[3] - m[2] * m[1]));
	  //     return det;
	  // }
	
	};
	zrUtil.mixin(View, Transformable);
	
	function doConvert(methodName, ecModel, finder, value) {
	  var seriesModel = finder.seriesModel;
	  var coordSys = seriesModel ? seriesModel.coordinateSystem : null; // e.g., graph.
	
	  return coordSys === this ? coordSys[methodName](value) : null;
	}
	
	var _default = View;
	module.exports = _default;

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	var _util = __webpack_require__(3);
	
	var isObject = _util.isObject;
	var each = _util.each;
	var map = _util.map;
	var indexOf = _util.indexOf;
	var retrieve = _util.retrieve;
	
	var _layout = __webpack_require__(36);
	
	var getLayoutRect = _layout.getLayoutRect;
	
	var _axisHelper = __webpack_require__(93);
	
	var createScaleByModel = _axisHelper.createScaleByModel;
	var ifAxisCrossZero = _axisHelper.ifAxisCrossZero;
	var niceScaleExtent = _axisHelper.niceScaleExtent;
	var estimateLabelUnionRect = _axisHelper.estimateLabelUnionRect;
	
	var Cartesian2D = __webpack_require__(1657);
	
	var Axis2D = __webpack_require__(1655);
	
	var CoordinateSystem = __webpack_require__(92);
	
	var _dataStackHelper = __webpack_require__(105);
	
	var getStackedDimension = _dataStackHelper.getStackedDimension;
	
	__webpack_require__(1658);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Grid is a region which contains at most 4 cartesian systems
	 *
	 * TODO Default cartesian
	 */
	// Depends on GridModel, AxisModel, which performs preprocess.
	
	/**
	 * Check if the axis is used in the specified grid
	 * @inner
	 */
	function isAxisUsedInTheGrid(axisModel, gridModel, ecModel) {
	  return axisModel.getCoordSysModel() === gridModel;
	}
	
	function Grid(gridModel, ecModel, api) {
	  /**
	   * @type {Object.<string, module:echarts/coord/cartesian/Cartesian2D>}
	   * @private
	   */
	  this._coordsMap = {};
	  /**
	   * @type {Array.<module:echarts/coord/cartesian/Cartesian>}
	   * @private
	   */
	
	  this._coordsList = [];
	  /**
	   * @type {Object.<string, Array.<module:echarts/coord/cartesian/Axis2D>>}
	   * @private
	   */
	
	  this._axesMap = {};
	  /**
	   * @type {Array.<module:echarts/coord/cartesian/Axis2D>}
	   * @private
	   */
	
	  this._axesList = [];
	
	  this._initCartesian(gridModel, ecModel, api);
	
	  this.model = gridModel;
	}
	
	var gridProto = Grid.prototype;
	gridProto.type = 'grid';
	gridProto.axisPointerEnabled = true;
	
	gridProto.getRect = function () {
	  return this._rect;
	};
	
	gridProto.update = function (ecModel, api) {
	  var axesMap = this._axesMap;
	
	  this._updateScale(ecModel, this.model);
	
	  each(axesMap.x, function (xAxis) {
	    niceScaleExtent(xAxis.scale, xAxis.model);
	  });
	  each(axesMap.y, function (yAxis) {
	    niceScaleExtent(yAxis.scale, yAxis.model);
	  }); // Key: axisDim_axisIndex, value: boolean, whether onZero target.
	
	  var onZeroRecords = {};
	  each(axesMap.x, function (xAxis) {
	    fixAxisOnZero(axesMap, 'y', xAxis, onZeroRecords);
	  });
	  each(axesMap.y, function (yAxis) {
	    fixAxisOnZero(axesMap, 'x', yAxis, onZeroRecords);
	  }); // Resize again if containLabel is enabled
	  // FIXME It may cause getting wrong grid size in data processing stage
	
	  this.resize(this.model, api);
	};
	
	function fixAxisOnZero(axesMap, otherAxisDim, axis, onZeroRecords) {
	  axis.getAxesOnZeroOf = function () {
	    // TODO: onZero of multiple axes.
	    return otherAxisOnZeroOf ? [otherAxisOnZeroOf] : [];
	  }; // onZero can not be enabled in these two situations:
	  // 1. When any other axis is a category axis.
	  // 2. When no axis is cross 0 point.
	
	
	  var otherAxes = axesMap[otherAxisDim];
	  var otherAxisOnZeroOf;
	  var axisModel = axis.model;
	  var onZero = axisModel.get('axisLine.onZero');
	  var onZeroAxisIndex = axisModel.get('axisLine.onZeroAxisIndex');
	
	  if (!onZero) {
	    return;
	  } // If target axis is specified.
	
	
	  if (onZeroAxisIndex != null) {
	    if (canOnZeroToAxis(otherAxes[onZeroAxisIndex])) {
	      otherAxisOnZeroOf = otherAxes[onZeroAxisIndex];
	    }
	  } else {
	    // Find the first available other axis.
	    for (var idx in otherAxes) {
	      if (otherAxes.hasOwnProperty(idx) && canOnZeroToAxis(otherAxes[idx]) // Consider that two Y axes on one value axis,
	      // if both onZero, the two Y axes overlap.
	      && !onZeroRecords[getOnZeroRecordKey(otherAxes[idx])]) {
	        otherAxisOnZeroOf = otherAxes[idx];
	        break;
	      }
	    }
	  }
	
	  if (otherAxisOnZeroOf) {
	    onZeroRecords[getOnZeroRecordKey(otherAxisOnZeroOf)] = true;
	  }
	
	  function getOnZeroRecordKey(axis) {
	    return axis.dim + '_' + axis.index;
	  }
	}
	
	function canOnZeroToAxis(axis) {
	  return axis && axis.type !== 'category' && axis.type !== 'time' && ifAxisCrossZero(axis);
	}
	/**
	 * Resize the grid
	 * @param {module:echarts/coord/cartesian/GridModel} gridModel
	 * @param {module:echarts/ExtensionAPI} api
	 */
	
	
	gridProto.resize = function (gridModel, api, ignoreContainLabel) {
	  var gridRect = getLayoutRect(gridModel.getBoxLayoutParams(), {
	    width: api.getWidth(),
	    height: api.getHeight()
	  });
	  this._rect = gridRect;
	  var axesList = this._axesList;
	  adjustAxes(); // Minus label size
	
	  if (!ignoreContainLabel && gridModel.get('containLabel')) {
	    each(axesList, function (axis) {
	      if (!axis.model.get('axisLabel.inside')) {
	        var labelUnionRect = estimateLabelUnionRect(axis);
	
	        if (labelUnionRect) {
	          var dim = axis.isHorizontal() ? 'height' : 'width';
	          var margin = axis.model.get('axisLabel.margin');
	          gridRect[dim] -= labelUnionRect[dim] + margin;
	
	          if (axis.position === 'top') {
	            gridRect.y += labelUnionRect.height + margin;
	          } else if (axis.position === 'left') {
	            gridRect.x += labelUnionRect.width + margin;
	          }
	        }
	      }
	    });
	    adjustAxes();
	  }
	
	  function adjustAxes() {
	    each(axesList, function (axis) {
	      var isHorizontal = axis.isHorizontal();
	      var extent = isHorizontal ? [0, gridRect.width] : [0, gridRect.height];
	      var idx = axis.inverse ? 1 : 0;
	      axis.setExtent(extent[idx], extent[1 - idx]);
	      updateAxisTransform(axis, isHorizontal ? gridRect.x : gridRect.y);
	    });
	  }
	};
	/**
	 * @param {string} axisType
	 * @param {number} [axisIndex]
	 */
	
	
	gridProto.getAxis = function (axisType, axisIndex) {
	  var axesMapOnDim = this._axesMap[axisType];
	
	  if (axesMapOnDim != null) {
	    if (axisIndex == null) {
	      // Find first axis
	      for (var name in axesMapOnDim) {
	        if (axesMapOnDim.hasOwnProperty(name)) {
	          return axesMapOnDim[name];
	        }
	      }
	    }
	
	    return axesMapOnDim[axisIndex];
	  }
	};
	/**
	 * @return {Array.<module:echarts/coord/Axis>}
	 */
	
	
	gridProto.getAxes = function () {
	  return this._axesList.slice();
	};
	/**
	 * Usage:
	 *      grid.getCartesian(xAxisIndex, yAxisIndex);
	 *      grid.getCartesian(xAxisIndex);
	 *      grid.getCartesian(null, yAxisIndex);
	 *      grid.getCartesian({xAxisIndex: ..., yAxisIndex: ...});
	 *
	 * @param {number|Object} [xAxisIndex]
	 * @param {number} [yAxisIndex]
	 */
	
	
	gridProto.getCartesian = function (xAxisIndex, yAxisIndex) {
	  if (xAxisIndex != null && yAxisIndex != null) {
	    var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
	    return this._coordsMap[key];
	  }
	
	  if (isObject(xAxisIndex)) {
	    yAxisIndex = xAxisIndex.yAxisIndex;
	    xAxisIndex = xAxisIndex.xAxisIndex;
	  } // When only xAxisIndex or yAxisIndex given, find its first cartesian.
	
	
	  for (var i = 0, coordList = this._coordsList; i < coordList.length; i++) {
	    if (coordList[i].getAxis('x').index === xAxisIndex || coordList[i].getAxis('y').index === yAxisIndex) {
	      return coordList[i];
	    }
	  }
	};
	
	gridProto.getCartesians = function () {
	  return this._coordsList.slice();
	};
	/**
	 * @implements
	 * see {module:echarts/CoodinateSystem}
	 */
	
	
	gridProto.convertToPixel = function (ecModel, finder, value) {
	  var target = this._findConvertTarget(ecModel, finder);
	
	  return target.cartesian ? target.cartesian.dataToPoint(value) : target.axis ? target.axis.toGlobalCoord(target.axis.dataToCoord(value)) : null;
	};
	/**
	 * @implements
	 * see {module:echarts/CoodinateSystem}
	 */
	
	
	gridProto.convertFromPixel = function (ecModel, finder, value) {
	  var target = this._findConvertTarget(ecModel, finder);
	
	  return target.cartesian ? target.cartesian.pointToData(value) : target.axis ? target.axis.coordToData(target.axis.toLocalCoord(value)) : null;
	};
	/**
	 * @inner
	 */
	
	
	gridProto._findConvertTarget = function (ecModel, finder) {
	  var seriesModel = finder.seriesModel;
	  var xAxisModel = finder.xAxisModel || seriesModel && seriesModel.getReferringComponents('xAxis')[0];
	  var yAxisModel = finder.yAxisModel || seriesModel && seriesModel.getReferringComponents('yAxis')[0];
	  var gridModel = finder.gridModel;
	  var coordsList = this._coordsList;
	  var cartesian;
	  var axis;
	
	  if (seriesModel) {
	    cartesian = seriesModel.coordinateSystem;
	    indexOf(coordsList, cartesian) < 0 && (cartesian = null);
	  } else if (xAxisModel && yAxisModel) {
	    cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
	  } else if (xAxisModel) {
	    axis = this.getAxis('x', xAxisModel.componentIndex);
	  } else if (yAxisModel) {
	    axis = this.getAxis('y', yAxisModel.componentIndex);
	  } // Lowest priority.
	  else if (gridModel) {
	      var grid = gridModel.coordinateSystem;
	
	      if (grid === this) {
	        cartesian = this._coordsList[0];
	      }
	    }
	
	  return {
	    cartesian: cartesian,
	    axis: axis
	  };
	};
	/**
	 * @implements
	 * see {module:echarts/CoodinateSystem}
	 */
	
	
	gridProto.containPoint = function (point) {
	  var coord = this._coordsList[0];
	
	  if (coord) {
	    return coord.containPoint(point);
	  }
	};
	/**
	 * Initialize cartesian coordinate systems
	 * @private
	 */
	
	
	gridProto._initCartesian = function (gridModel, ecModel, api) {
	  var axisPositionUsed = {
	    left: false,
	    right: false,
	    top: false,
	    bottom: false
	  };
	  var axesMap = {
	    x: {},
	    y: {}
	  };
	  var axesCount = {
	    x: 0,
	    y: 0
	  }; /// Create axis
	
	  ecModel.eachComponent('xAxis', createAxisCreator('x'), this);
	  ecModel.eachComponent('yAxis', createAxisCreator('y'), this);
	
	  if (!axesCount.x || !axesCount.y) {
	    // Roll back when there no either x or y axis
	    this._axesMap = {};
	    this._axesList = [];
	    return;
	  }
	
	  this._axesMap = axesMap; /// Create cartesian2d
	
	  each(axesMap.x, function (xAxis, xAxisIndex) {
	    each(axesMap.y, function (yAxis, yAxisIndex) {
	      var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
	      var cartesian = new Cartesian2D(key);
	      cartesian.grid = this;
	      cartesian.model = gridModel;
	      this._coordsMap[key] = cartesian;
	
	      this._coordsList.push(cartesian);
	
	      cartesian.addAxis(xAxis);
	      cartesian.addAxis(yAxis);
	    }, this);
	  }, this);
	
	  function createAxisCreator(axisType) {
	    return function (axisModel, idx) {
	      if (!isAxisUsedInTheGrid(axisModel, gridModel, ecModel)) {
	        return;
	      }
	
	      var axisPosition = axisModel.get('position');
	
	      if (axisType === 'x') {
	        // Fix position
	        if (axisPosition !== 'top' && axisPosition !== 'bottom') {
	          // Default bottom of X
	          axisPosition = axisPositionUsed.bottom ? 'top' : 'bottom';
	        }
	      } else {
	        // Fix position
	        if (axisPosition !== 'left' && axisPosition !== 'right') {
	          // Default left of Y
	          axisPosition = axisPositionUsed.left ? 'right' : 'left';
	        }
	      }
	
	      axisPositionUsed[axisPosition] = true;
	      var axis = new Axis2D(axisType, createScaleByModel(axisModel), [0, 0], axisModel.get('type'), axisPosition);
	      var isCategory = axis.type === 'category';
	      axis.onBand = isCategory && axisModel.get('boundaryGap');
	      axis.inverse = axisModel.get('inverse'); // Inject axis into axisModel
	
	      axisModel.axis = axis; // Inject axisModel into axis
	
	      axis.model = axisModel; // Inject grid info axis
	
	      axis.grid = this; // Index of axis, can be used as key
	
	      axis.index = idx;
	
	      this._axesList.push(axis);
	
	      axesMap[axisType][idx] = axis;
	      axesCount[axisType]++;
	    };
	  }
	};
	/**
	 * Update cartesian properties from series
	 * @param  {module:echarts/model/Option} option
	 * @private
	 */
	
	
	gridProto._updateScale = function (ecModel, gridModel) {
	  // Reset scale
	  each(this._axesList, function (axis) {
	    axis.scale.setExtent(Infinity, -Infinity);
	  });
	  ecModel.eachSeries(function (seriesModel) {
	    if (isCartesian2D(seriesModel)) {
	      var axesModels = findAxesModels(seriesModel, ecModel);
	      var xAxisModel = axesModels[0];
	      var yAxisModel = axesModels[1];
	
	      if (!isAxisUsedInTheGrid(xAxisModel, gridModel, ecModel) || !isAxisUsedInTheGrid(yAxisModel, gridModel, ecModel)) {
	        return;
	      }
	
	      var cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
	      var data = seriesModel.getData();
	      var xAxis = cartesian.getAxis('x');
	      var yAxis = cartesian.getAxis('y');
	
	      if (data.type === 'list') {
	        unionExtent(data, xAxis, seriesModel);
	        unionExtent(data, yAxis, seriesModel);
	      }
	    }
	  }, this);
	
	  function unionExtent(data, axis, seriesModel) {
	    each(data.mapDimension(axis.dim, true), function (dim) {
	      axis.scale.unionExtentFromData( // For example, the extent of the orginal dimension
	      // is [0.1, 0.5], the extent of the `stackResultDimension`
	      // is [7, 9], the final extent should not include [0.1, 0.5].
	      data, getStackedDimension(data, dim));
	    });
	  }
	};
	/**
	 * @param {string} [dim] 'x' or 'y' or 'auto' or null/undefined
	 * @return {Object} {baseAxes: [], otherAxes: []}
	 */
	
	
	gridProto.getTooltipAxes = function (dim) {
	  var baseAxes = [];
	  var otherAxes = [];
	  each(this.getCartesians(), function (cartesian) {
	    var baseAxis = dim != null && dim !== 'auto' ? cartesian.getAxis(dim) : cartesian.getBaseAxis();
	    var otherAxis = cartesian.getOtherAxis(baseAxis);
	    indexOf(baseAxes, baseAxis) < 0 && baseAxes.push(baseAxis);
	    indexOf(otherAxes, otherAxis) < 0 && otherAxes.push(otherAxis);
	  });
	  return {
	    baseAxes: baseAxes,
	    otherAxes: otherAxes
	  };
	};
	/**
	 * @inner
	 */
	
	
	function updateAxisTransform(axis, coordBase) {
	  var axisExtent = axis.getExtent();
	  var axisExtentSum = axisExtent[0] + axisExtent[1]; // Fast transform
	
	  axis.toGlobalCoord = axis.dim === 'x' ? function (coord) {
	    return coord + coordBase;
	  } : function (coord) {
	    return axisExtentSum - coord + coordBase;
	  };
	  axis.toLocalCoord = axis.dim === 'x' ? function (coord) {
	    return coord - coordBase;
	  } : function (coord) {
	    return axisExtentSum - coord + coordBase;
	  };
	}
	
	var axesTypes = ['xAxis', 'yAxis'];
	/**
	 * @inner
	 */
	
	function findAxesModels(seriesModel, ecModel) {
	  return map(axesTypes, function (axisType) {
	    var axisModel = seriesModel.getReferringComponents(axisType)[0];
	    return axisModel;
	  });
	}
	/**
	 * @inner
	 */
	
	
	function isCartesian2D(seriesModel) {
	  return seriesModel.get('coordinateSystem') === 'cartesian2d';
	}
	
	Grid.create = function (ecModel, api) {
	  var grids = [];
	  ecModel.eachComponent('grid', function (gridModel, idx) {
	    var grid = new Grid(gridModel, ecModel, api);
	    grid.name = 'grid_' + idx; // dataSampling requires axis extent, so resize
	    // should be performed in create stage.
	
	    grid.resize(gridModel, api, true);
	    gridModel.coordinateSystem = grid;
	    grids.push(grid);
	  }); // Inject the coordinateSystems into seriesModel
	
	  ecModel.eachSeries(function (seriesModel) {
	    if (!isCartesian2D(seriesModel)) {
	      return;
	    }
	
	    var axesModels = findAxesModels(seriesModel, ecModel);
	    var xAxisModel = axesModels[0];
	    var yAxisModel = axesModels[1];
	    var gridModel = xAxisModel.getCoordSysModel();
	    var grid = gridModel.coordinateSystem;
	    seriesModel.coordinateSystem = grid.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
	  });
	  return grids;
	}; // For deciding which dimensions to use when creating list data
	
	
	Grid.dimensions = Grid.prototype.dimensions = Cartesian2D.prototype.dimensions;
	CoordinateSystem.register('cartesian2d', Grid);
	var _default = Grid;
	module.exports = _default;

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var Geo = __webpack_require__(1660);
	
	var layout = __webpack_require__(36);
	
	var numberUtil = __webpack_require__(20);
	
	var geoSourceManager = __webpack_require__(336);
	
	var mapDataStorage = __webpack_require__(472);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Resize method bound to the geo
	 * @param {module:echarts/coord/geo/GeoModel|module:echarts/chart/map/MapModel} geoModel
	 * @param {module:echarts/ExtensionAPI} api
	 */
	function resizeGeo(geoModel, api) {
	  var boundingCoords = geoModel.get('boundingCoords');
	
	  if (boundingCoords != null) {
	    var leftTop = boundingCoords[0];
	    var rightBottom = boundingCoords[1];
	
	    if (isNaN(leftTop[0]) || isNaN(leftTop[1]) || isNaN(rightBottom[0]) || isNaN(rightBottom[1])) {} else {
	      this.setBoundingRect(leftTop[0], leftTop[1], rightBottom[0] - leftTop[0], rightBottom[1] - leftTop[1]);
	    }
	  }
	
	  var rect = this.getBoundingRect();
	  var boxLayoutOption;
	  var center = geoModel.get('layoutCenter');
	  var size = geoModel.get('layoutSize');
	  var viewWidth = api.getWidth();
	  var viewHeight = api.getHeight();
	  var aspect = rect.width / rect.height * this.aspectScale;
	  var useCenterAndSize = false;
	
	  if (center && size) {
	    center = [numberUtil.parsePercent(center[0], viewWidth), numberUtil.parsePercent(center[1], viewHeight)];
	    size = numberUtil.parsePercent(size, Math.min(viewWidth, viewHeight));
	
	    if (!isNaN(center[0]) && !isNaN(center[1]) && !isNaN(size)) {
	      useCenterAndSize = true;
	    } else {}
	  }
	
	  var viewRect;
	
	  if (useCenterAndSize) {
	    var viewRect = {};
	
	    if (aspect > 1) {
	      // Width is same with size
	      viewRect.width = size;
	      viewRect.height = size / aspect;
	    } else {
	      viewRect.height = size;
	      viewRect.width = size * aspect;
	    }
	
	    viewRect.y = center[1] - viewRect.height / 2;
	    viewRect.x = center[0] - viewRect.width / 2;
	  } else {
	    // Use left/top/width/height
	    boxLayoutOption = geoModel.getBoxLayoutParams(); // 0.75 rate
	
	    boxLayoutOption.aspect = aspect;
	    viewRect = layout.getLayoutRect(boxLayoutOption, {
	      width: viewWidth,
	      height: viewHeight
	    });
	  }
	
	  this.setViewRect(viewRect.x, viewRect.y, viewRect.width, viewRect.height);
	  this.setCenter(geoModel.get('center'));
	  this.setZoom(geoModel.get('zoom'));
	}
	/**
	 * @param {module:echarts/coord/Geo} geo
	 * @param {module:echarts/model/Model} model
	 * @inner
	 */
	
	
	function setGeoCoords(geo, model) {
	  zrUtil.each(model.get('geoCoord'), function (geoCoord, name) {
	    geo.addGeoCoord(name, geoCoord);
	  });
	}
	
	var geoCreator = {
	  // For deciding which dimensions to use when creating list data
	  dimensions: Geo.prototype.dimensions,
	  create: function (ecModel, api) {
	    var geoList = []; // FIXME Create each time may be slow
	
	    ecModel.eachComponent('geo', function (geoModel, idx) {
	      var name = geoModel.get('map');
	      var aspectScale = geoModel.get('aspectScale');
	      var invertLongitute = true;
	      var mapRecords = mapDataStorage.retrieveMap(name);
	
	      if (mapRecords && mapRecords[0] && mapRecords[0].type === 'svg') {
	        aspectScale == null && (aspectScale = 1);
	        invertLongitute = false;
	      } else {
	        aspectScale == null && (aspectScale = 0.75);
	      }
	
	      var geo = new Geo(name + idx, name, geoModel.get('nameMap'), invertLongitute);
	      geo.aspectScale = aspectScale;
	      geo.zoomLimit = geoModel.get('scaleLimit');
	      geoList.push(geo);
	      setGeoCoords(geo, geoModel);
	      geoModel.coordinateSystem = geo;
	      geo.model = geoModel; // Inject resize method
	
	      geo.resize = resizeGeo;
	      geo.resize(geoModel, api);
	    });
	    ecModel.eachSeries(function (seriesModel) {
	      var coordSys = seriesModel.get('coordinateSystem');
	
	      if (coordSys === 'geo') {
	        var geoIndex = seriesModel.get('geoIndex') || 0;
	        seriesModel.coordinateSystem = geoList[geoIndex];
	      }
	    }); // If has map series
	
	    var mapModelGroupBySeries = {};
	    ecModel.eachSeriesByType('map', function (seriesModel) {
	      if (!seriesModel.getHostGeoModel()) {
	        var mapType = seriesModel.getMapType();
	        mapModelGroupBySeries[mapType] = mapModelGroupBySeries[mapType] || [];
	        mapModelGroupBySeries[mapType].push(seriesModel);
	      }
	    });
	    zrUtil.each(mapModelGroupBySeries, function (mapSeries, mapType) {
	      var nameMapList = zrUtil.map(mapSeries, function (singleMapSeries) {
	        return singleMapSeries.get('nameMap');
	      });
	      var geo = new Geo(mapType, mapType, zrUtil.mergeAll(nameMapList));
	      geo.zoomLimit = zrUtil.retrieve.apply(null, zrUtil.map(mapSeries, function (singleMapSeries) {
	        return singleMapSeries.get('scaleLimit');
	      }));
	      geoList.push(geo); // Inject resize method
	
	      geo.resize = resizeGeo;
	      geo.aspectScale = mapSeries[0].get('aspectScale');
	      geo.resize(mapSeries[0], api);
	      zrUtil.each(mapSeries, function (singleMapSeries) {
	        singleMapSeries.coordinateSystem = geo;
	        setGeoCoords(geo, singleMapSeries);
	      });
	    });
	    return geoList;
	  },
	
	  /**
	   * Fill given regions array
	   * @param  {Array.<Object>} originRegionArr
	   * @param  {string} mapName
	   * @param  {Object} [nameMap]
	   * @return {Array}
	   */
	  getFilledRegions: function (originRegionArr, mapName, nameMap) {
	    // Not use the original
	    var regionsArr = (originRegionArr || []).slice();
	    var dataNameMap = zrUtil.createHashMap();
	
	    for (var i = 0; i < regionsArr.length; i++) {
	      dataNameMap.set(regionsArr[i].name, regionsArr[i]);
	    }
	
	    var source = geoSourceManager.load(mapName, nameMap);
	    zrUtil.each(source.regions, function (region) {
	      var name = region.name;
	      !dataNameMap.get(name) && regionsArr.push({
	        name: name
	      });
	    });
	    return regionsArr;
	  }
	};
	echarts.registerCoordinateSystem('geo', geoCreator);
	var _default = geoCreator;
	module.exports = _default;

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	var _util = __webpack_require__(3);
	
	var createHashMap = _util.createHashMap;
	var isString = _util.isString;
	var isArray = _util.isArray;
	var each = _util.each;
	var assert = _util.assert;
	
	var _parseSVG = __webpack_require__(1097);
	
	var parseXML = _parseSVG.parseXML;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var storage = createHashMap(); // For minimize the code size of common echarts package,
	// do not put too much logic in this module.
	
	var _default = {
	  // The format of record: see `echarts.registerMap`.
	  // Compatible with previous `echarts.registerMap`.
	  registerMap: function (mapName, rawGeoJson, rawSpecialAreas) {
	    var records;
	
	    if (isArray(rawGeoJson)) {
	      records = rawGeoJson;
	    } else if (rawGeoJson.svg) {
	      records = [{
	        type: 'svg',
	        source: rawGeoJson.svg,
	        specialAreas: rawGeoJson.specialAreas
	      }];
	    } else {
	      // Backward compatibility.
	      if (rawGeoJson.geoJson && !rawGeoJson.features) {
	        rawSpecialAreas = rawGeoJson.specialAreas;
	        rawGeoJson = rawGeoJson.geoJson;
	      }
	
	      records = [{
	        type: 'geoJSON',
	        source: rawGeoJson,
	        specialAreas: rawSpecialAreas
	      }];
	    }
	
	    each(records, function (record) {
	      var type = record.type;
	      type === 'geoJson' && (type = record.type = 'geoJSON');
	      var parse = parsers[type];
	      parse(record);
	    });
	    return storage.set(mapName, records);
	  },
	  retrieveMap: function (mapName) {
	    return storage.get(mapName);
	  }
	};
	var parsers = {
	  geoJSON: function (record) {
	    var source = record.source;
	    record.geoJSON = !isString(source) ? source : typeof JSON !== 'undefined' && JSON.parse ? JSON.parse(source) : new Function('return (' + source + ');')();
	  },
	  // Only perform parse to XML object here, which might be time
	  // consiming for large SVG.
	  // Although convert XML to zrender element is also time consiming,
	  // if we do it here, the clone of zrender elements has to be
	  // required. So we do it once for each geo instance, util real
	  // performance issues call for optimizing it.
	  svg: function (record) {
	    record.svgXML = parseXML(record.source);
	  }
	};
	module.exports = _default;

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(3);
	
	var Polar = __webpack_require__(1676);
	
	var _number = __webpack_require__(20);
	
	var parsePercent = _number.parsePercent;
	
	var _axisHelper = __webpack_require__(93);
	
	var createScaleByModel = _axisHelper.createScaleByModel;
	var niceScaleExtent = _axisHelper.niceScaleExtent;
	
	var CoordinateSystem = __webpack_require__(92);
	
	var _dataStackHelper = __webpack_require__(105);
	
	var getStackedDimension = _dataStackHelper.getStackedDimension;
	
	__webpack_require__(1677);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// TODO Axis scale
	
	/**
	 * Resize method bound to the polar
	 * @param {module:echarts/coord/polar/PolarModel} polarModel
	 * @param {module:echarts/ExtensionAPI} api
	 */
	function resizePolar(polar, polarModel, api) {
	  var center = polarModel.get('center');
	  var width = api.getWidth();
	  var height = api.getHeight();
	  polar.cx = parsePercent(center[0], width);
	  polar.cy = parsePercent(center[1], height);
	  var radiusAxis = polar.getRadiusAxis();
	  var size = Math.min(width, height) / 2;
	  var radius = polarModel.get('radius');
	
	  if (radius == null) {
	    radius = [0, '100%'];
	  } else if (!zrUtil.isArray(radius)) {
	    // r0 = 0
	    radius = [0, radius];
	  }
	
	  radius = [parsePercent(radius[0], size), parsePercent(radius[1], size)];
	  radiusAxis.inverse ? radiusAxis.setExtent(radius[1], radius[0]) : radiusAxis.setExtent(radius[0], radius[1]);
	}
	/**
	 * Update polar
	 */
	
	
	function updatePolarScale(ecModel, api) {
	  var polar = this;
	  var angleAxis = polar.getAngleAxis();
	  var radiusAxis = polar.getRadiusAxis(); // Reset scale
	
	  angleAxis.scale.setExtent(Infinity, -Infinity);
	  radiusAxis.scale.setExtent(Infinity, -Infinity);
	  ecModel.eachSeries(function (seriesModel) {
	    if (seriesModel.coordinateSystem === polar) {
	      var data = seriesModel.getData();
	      zrUtil.each(data.mapDimension('radius', true), function (dim) {
	        radiusAxis.scale.unionExtentFromData(data, getStackedDimension(data, dim));
	      });
	      zrUtil.each(data.mapDimension('angle', true), function (dim) {
	        angleAxis.scale.unionExtentFromData(data, getStackedDimension(data, dim));
	      });
	    }
	  });
	  niceScaleExtent(angleAxis.scale, angleAxis.model);
	  niceScaleExtent(radiusAxis.scale, radiusAxis.model); // Fix extent of category angle axis
	
	  if (angleAxis.type === 'category' && !angleAxis.onBand) {
	    var extent = angleAxis.getExtent();
	    var diff = 360 / angleAxis.scale.count();
	    angleAxis.inverse ? extent[1] += diff : extent[1] -= diff;
	    angleAxis.setExtent(extent[0], extent[1]);
	  }
	}
	/**
	 * Set common axis properties
	 * @param {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
	 * @param {module:echarts/coord/polar/AxisModel}
	 * @inner
	 */
	
	
	function setAxis(axis, axisModel) {
	  axis.type = axisModel.get('type');
	  axis.scale = createScaleByModel(axisModel);
	  axis.onBand = axisModel.get('boundaryGap') && axis.type === 'category';
	  axis.inverse = axisModel.get('inverse');
	
	  if (axisModel.mainType === 'angleAxis') {
	    axis.inverse ^= axisModel.get('clockwise');
	    var startAngle = axisModel.get('startAngle');
	    axis.setExtent(startAngle, startAngle + (axis.inverse ? -360 : 360));
	  } // Inject axis instance
	
	
	  axisModel.axis = axis;
	  axis.model = axisModel;
	}
	
	var polarCreator = {
	  dimensions: Polar.prototype.dimensions,
	  create: function (ecModel, api) {
	    var polarList = [];
	    ecModel.eachComponent('polar', function (polarModel, idx) {
	      var polar = new Polar(idx); // Inject resize and update method
	
	      polar.update = updatePolarScale;
	      var radiusAxis = polar.getRadiusAxis();
	      var angleAxis = polar.getAngleAxis();
	      var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
	      var angleAxisModel = polarModel.findAxisModel('angleAxis');
	      setAxis(radiusAxis, radiusAxisModel);
	      setAxis(angleAxis, angleAxisModel);
	      resizePolar(polar, polarModel, api);
	      polarList.push(polar);
	      polarModel.coordinateSystem = polar;
	      polar.model = polarModel;
	    }); // Inject coordinateSystem to series
	
	    ecModel.eachSeries(function (seriesModel) {
	      if (seriesModel.get('coordinateSystem') === 'polar') {
	        var polarModel = ecModel.queryComponents({
	          mainType: 'polar',
	          index: seriesModel.get('polarIndex'),
	          id: seriesModel.get('polarId')
	        })[0];
	        seriesModel.coordinateSystem = polarModel.coordinateSystem;
	      }
	    });
	    return polarList;
	  }
	};
	CoordinateSystem.register('polar', polarCreator);

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var linkList = __webpack_require__(747);
	
	var List = __webpack_require__(83);
	
	var createDimensions = __webpack_require__(207);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Tree data structure
	 *
	 * @module echarts/data/Tree
	 */
	
	/**
	 * @constructor module:echarts/data/Tree~TreeNode
	 * @param {string} name
	 * @param {module:echarts/data/Tree} hostTree
	 */
	var TreeNode = function (name, hostTree) {
	  /**
	   * @type {string}
	   */
	  this.name = name || '';
	  /**
	   * Depth of node
	   *
	   * @type {number}
	   * @readOnly
	   */
	
	  this.depth = 0;
	  /**
	   * Height of the subtree rooted at this node.
	   * @type {number}
	   * @readOnly
	   */
	
	  this.height = 0;
	  /**
	   * @type {module:echarts/data/Tree~TreeNode}
	   * @readOnly
	   */
	
	  this.parentNode = null;
	  /**
	   * Reference to list item.
	   * Do not persistent dataIndex outside,
	   * besause it may be changed by list.
	   * If dataIndex -1,
	   * this node is logical deleted (filtered) in list.
	   *
	   * @type {Object}
	   * @readOnly
	   */
	
	  this.dataIndex = -1;
	  /**
	   * @type {Array.<module:echarts/data/Tree~TreeNode>}
	   * @readOnly
	   */
	
	  this.children = [];
	  /**
	   * @type {Array.<module:echarts/data/Tree~TreeNode>}
	   * @pubilc
	   */
	
	  this.viewChildren = [];
	  /**
	   * @type {moduel:echarts/data/Tree}
	   * @readOnly
	   */
	
	  this.hostTree = hostTree;
	};
	
	TreeNode.prototype = {
	  constructor: TreeNode,
	
	  /**
	   * The node is removed.
	   * @return {boolean} is removed.
	   */
	  isRemoved: function () {
	    return this.dataIndex < 0;
	  },
	
	  /**
	   * Travel this subtree (include this node).
	   * Usage:
	   *    node.eachNode(function () { ... }); // preorder
	   *    node.eachNode('preorder', function () { ... }); // preorder
	   *    node.eachNode('postorder', function () { ... }); // postorder
	   *    node.eachNode(
	   *        {order: 'postorder', attr: 'viewChildren'},
	   *        function () { ... }
	   *    ); // postorder
	   *
	   * @param {(Object|string)} options If string, means order.
	   * @param {string=} options.order 'preorder' or 'postorder'
	   * @param {string=} options.attr 'children' or 'viewChildren'
	   * @param {Function} cb If in preorder and return false,
	   *                      its subtree will not be visited.
	   * @param {Object} [context]
	   */
	  eachNode: function (options, cb, context) {
	    if (typeof options === 'function') {
	      context = cb;
	      cb = options;
	      options = null;
	    }
	
	    options = options || {};
	
	    if (zrUtil.isString(options)) {
	      options = {
	        order: options
	      };
	    }
	
	    var order = options.order || 'preorder';
	    var children = this[options.attr || 'children'];
	    var suppressVisitSub;
	    order === 'preorder' && (suppressVisitSub = cb.call(context, this));
	
	    for (var i = 0; !suppressVisitSub && i < children.length; i++) {
	      children[i].eachNode(options, cb, context);
	    }
	
	    order === 'postorder' && cb.call(context, this);
	  },
	
	  /**
	   * Update depth and height of this subtree.
	   *
	   * @param  {number} depth
	   */
	  updateDepthAndHeight: function (depth) {
	    var height = 0;
	    this.depth = depth;
	
	    for (var i = 0; i < this.children.length; i++) {
	      var child = this.children[i];
	      child.updateDepthAndHeight(depth + 1);
	
	      if (child.height > height) {
	        height = child.height;
	      }
	    }
	
	    this.height = height + 1;
	  },
	
	  /**
	   * @param  {string} id
	   * @return {module:echarts/data/Tree~TreeNode}
	   */
	  getNodeById: function (id) {
	    if (this.getId() === id) {
	      return this;
	    }
	
	    for (var i = 0, children = this.children, len = children.length; i < len; i++) {
	      var res = children[i].getNodeById(id);
	
	      if (res) {
	        return res;
	      }
	    }
	  },
	
	  /**
	   * @param {module:echarts/data/Tree~TreeNode} node
	   * @return {boolean}
	   */
	  contains: function (node) {
	    if (node === this) {
	      return true;
	    }
	
	    for (var i = 0, children = this.children, len = children.length; i < len; i++) {
	      var res = children[i].contains(node);
	
	      if (res) {
	        return res;
	      }
	    }
	  },
	
	  /**
	   * @param {boolean} includeSelf Default false.
	   * @return {Array.<module:echarts/data/Tree~TreeNode>} order: [root, child, grandchild, ...]
	   */
	  getAncestors: function (includeSelf) {
	    var ancestors = [];
	    var node = includeSelf ? this : this.parentNode;
	
	    while (node) {
	      ancestors.push(node);
	      node = node.parentNode;
	    }
	
	    ancestors.reverse();
	    return ancestors;
	  },
	
	  /**
	   * @param {string|Array=} [dimension='value'] Default 'value'. can be 0, 1, 2, 3
	   * @return {number} Value.
	   */
	  getValue: function (dimension) {
	    var data = this.hostTree.data;
	    return data.get(data.getDimension(dimension || 'value'), this.dataIndex);
	  },
	
	  /**
	   * @param {Object} layout
	   * @param {boolean=} [merge=false]
	   */
	  setLayout: function (layout, merge) {
	    this.dataIndex >= 0 && this.hostTree.data.setItemLayout(this.dataIndex, layout, merge);
	  },
	
	  /**
	   * @return {Object} layout
	   */
	  getLayout: function () {
	    return this.hostTree.data.getItemLayout(this.dataIndex);
	  },
	
	  /**
	   * @param {string} [path]
	   * @return {module:echarts/model/Model}
	   */
	  getModel: function (path) {
	    if (this.dataIndex < 0) {
	      return;
	    }
	
	    var hostTree = this.hostTree;
	    var itemModel = hostTree.data.getItemModel(this.dataIndex);
	    return itemModel.getModel(path);
	  },
	
	  /**
	   * @example
	   *  setItemVisual('color', color);
	   *  setItemVisual({
	   *      'color': color
	   *  });
	   */
	  setVisual: function (key, value) {
	    this.dataIndex >= 0 && this.hostTree.data.setItemVisual(this.dataIndex, key, value);
	  },
	
	  /**
	   * Get item visual
	   */
	  getVisual: function (key, ignoreParent) {
	    return this.hostTree.data.getItemVisual(this.dataIndex, key, ignoreParent);
	  },
	
	  /**
	   * @public
	   * @return {number}
	   */
	  getRawIndex: function () {
	    return this.hostTree.data.getRawIndex(this.dataIndex);
	  },
	
	  /**
	   * @public
	   * @return {string}
	   */
	  getId: function () {
	    return this.hostTree.data.getId(this.dataIndex);
	  },
	
	  /**
	   * if this is an ancestor of another node
	   *
	   * @public
	   * @param {TreeNode} node another node
	   * @return {boolean} if is ancestor
	   */
	  isAncestorOf: function (node) {
	    var parent = node.parentNode;
	
	    while (parent) {
	      if (parent === this) {
	        return true;
	      }
	
	      parent = parent.parentNode;
	    }
	
	    return false;
	  },
	
	  /**
	   * if this is an descendant of another node
	   *
	   * @public
	   * @param {TreeNode} node another node
	   * @return {boolean} if is descendant
	   */
	  isDescendantOf: function (node) {
	    return node !== this && node.isAncestorOf(this);
	  }
	};
	/**
	 * @constructor
	 * @alias module:echarts/data/Tree
	 * @param {module:echarts/model/Model} hostModel
	 */
	
	function Tree(hostModel) {
	  /**
	   * @type {module:echarts/data/Tree~TreeNode}
	   * @readOnly
	   */
	  this.root;
	  /**
	   * @type {module:echarts/data/List}
	   * @readOnly
	   */
	
	  this.data;
	  /**
	   * Index of each item is the same as the raw index of coresponding list item.
	   * @private
	   * @type {Array.<module:echarts/data/Tree~TreeNode}
	   */
	
	  this._nodes = [];
	  /**
	   * @private
	   * @readOnly
	   * @type {module:echarts/model/Model}
	   */
	
	  this.hostModel = hostModel;
	}
	
	Tree.prototype = {
	  constructor: Tree,
	  type: 'tree',
	
	  /**
	   * Travel this subtree (include this node).
	   * Usage:
	   *    node.eachNode(function () { ... }); // preorder
	   *    node.eachNode('preorder', function () { ... }); // preorder
	   *    node.eachNode('postorder', function () { ... }); // postorder
	   *    node.eachNode(
	   *        {order: 'postorder', attr: 'viewChildren'},
	   *        function () { ... }
	   *    ); // postorder
	   *
	   * @param {(Object|string)} options If string, means order.
	   * @param {string=} options.order 'preorder' or 'postorder'
	   * @param {string=} options.attr 'children' or 'viewChildren'
	   * @param {Function} cb
	   * @param {Object}   [context]
	   */
	  eachNode: function (options, cb, context) {
	    this.root.eachNode(options, cb, context);
	  },
	
	  /**
	   * @param {number} dataIndex
	   * @return {module:echarts/data/Tree~TreeNode}
	   */
	  getNodeByDataIndex: function (dataIndex) {
	    var rawIndex = this.data.getRawIndex(dataIndex);
	    return this._nodes[rawIndex];
	  },
	
	  /**
	   * @param {string} name
	   * @return {module:echarts/data/Tree~TreeNode}
	   */
	  getNodeByName: function (name) {
	    return this.root.getNodeByName(name);
	  },
	
	  /**
	   * Update item available by list,
	   * when list has been performed options like 'filterSelf' or 'map'.
	   */
	  update: function () {
	    var data = this.data;
	    var nodes = this._nodes;
	
	    for (var i = 0, len = nodes.length; i < len; i++) {
	      nodes[i].dataIndex = -1;
	    }
	
	    for (var i = 0, len = data.count(); i < len; i++) {
	      nodes[data.getRawIndex(i)].dataIndex = i;
	    }
	  },
	
	  /**
	   * Clear all layouts
	   */
	  clearLayouts: function () {
	    this.data.clearItemLayouts();
	  }
	};
	/**
	 * data node format:
	 * {
	 *     name: ...
	 *     value: ...
	 *     children: [
	 *         {
	 *             name: ...
	 *             value: ...
	 *             children: ...
	 *         },
	 *         ...
	 *     ]
	 * }
	 *
	 * @static
	 * @param {Object} dataRoot Root node.
	 * @param {module:echarts/model/Model} hostModel
	 * @return module:echarts/data/Tree
	 */
	
	Tree.createTree = function (dataRoot, hostModel, beforeLink) {
	  var tree = new Tree(hostModel);
	  var listData = [];
	  var dimMax = 1;
	  buildHierarchy(dataRoot);
	
	  function buildHierarchy(dataNode, parentNode) {
	    var value = dataNode.value;
	    dimMax = Math.max(dimMax, zrUtil.isArray(value) ? value.length : 1);
	    listData.push(dataNode);
	    var node = new TreeNode(dataNode.name, tree);
	    parentNode ? addChild(node, parentNode) : tree.root = node;
	
	    tree._nodes.push(node);
	
	    var children = dataNode.children;
	
	    if (children) {
	      for (var i = 0; i < children.length; i++) {
	        buildHierarchy(children[i], node);
	      }
	    }
	  }
	
	  tree.root.updateDepthAndHeight(0);
	  var dimensionsInfo = createDimensions(listData, {
	    coordDimensions: ['value'],
	    dimensionsCount: dimMax
	  });
	  var list = new List(dimensionsInfo, hostModel);
	  list.initData(listData);
	  beforeLink && beforeLink(list);
	  linkList({
	    mainData: list,
	    struct: tree,
	    structAttr: 'tree'
	  });
	  tree.update();
	  return tree;
	};
	/**
	 * It is needed to consider the mess of 'list', 'hostModel' when creating a TreeNote,
	 * so this function is not ready and not necessary to be public.
	 *
	 * @param {(module:echarts/data/Tree~TreeNode|Object)} child
	 */
	
	
	function addChild(child, node) {
	  var children = node.children;
	
	  if (child.parentNode === node) {
	    return;
	  }
	
	  children.push(child);
	  child.parentNode = node;
	}
	
	var _default = Tree;
	module.exports = _default;

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _dataProvider = __webpack_require__(167);
	
	var retrieveRawValue = _dataProvider.retrieveRawValue;
	
	var _format = __webpack_require__(40);
	
	var getTooltipMarker = _format.getTooltipMarker;
	var formatTpl = _format.formatTpl;
	
	var _model = __webpack_require__(24);
	
	var getTooltipRenderMode = _model.getTooltipRenderMode;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var DIMENSION_LABEL_REG = /\{@(.+?)\}/g; // PENDING A little ugly
	
	var _default = {
	  /**
	   * Get params for formatter
	   * @param {number} dataIndex
	   * @param {string} [dataType]
	   * @return {Object}
	   */
	  getDataParams: function (dataIndex, dataType) {
	    var data = this.getData(dataType);
	    var rawValue = this.getRawValue(dataIndex, dataType);
	    var rawDataIndex = data.getRawIndex(dataIndex);
	    var name = data.getName(dataIndex);
	    var itemOpt = data.getRawDataItem(dataIndex);
	    var color = data.getItemVisual(dataIndex, 'color');
	    var borderColor = data.getItemVisual(dataIndex, 'borderColor');
	    var tooltipModel = this.ecModel.getComponent('tooltip');
	    var renderModeOption = tooltipModel && tooltipModel.get('renderMode');
	    var renderMode = getTooltipRenderMode(renderModeOption);
	    var mainType = this.mainType;
	    var isSeries = mainType === 'series';
	    var userOutput = data.userOutput;
	    return {
	      componentType: mainType,
	      componentSubType: this.subType,
	      componentIndex: this.componentIndex,
	      seriesType: isSeries ? this.subType : null,
	      seriesIndex: this.seriesIndex,
	      seriesId: isSeries ? this.id : null,
	      seriesName: isSeries ? this.name : null,
	      name: name,
	      dataIndex: rawDataIndex,
	      data: itemOpt,
	      dataType: dataType,
	      value: rawValue,
	      color: color,
	      borderColor: borderColor,
	      dimensionNames: userOutput ? userOutput.dimensionNames : null,
	      encode: userOutput ? userOutput.encode : null,
	      marker: getTooltipMarker({
	        color: color,
	        renderMode: renderMode
	      }),
	      // Param name list for mapping `a`, `b`, `c`, `d`, `e`
	      $vars: ['seriesName', 'name', 'value']
	    };
	  },
	
	  /**
	   * Format label
	   * @param {number} dataIndex
	   * @param {string} [status='normal'] 'normal' or 'emphasis'
	   * @param {string} [dataType]
	   * @param {number} [dimIndex] Only used in some chart that
	   *        use formatter in different dimensions, like radar.
	   * @param {string} [labelProp='label']
	   * @return {string} If not formatter, return null/undefined
	   */
	  getFormattedLabel: function (dataIndex, status, dataType, dimIndex, labelProp) {
	    status = status || 'normal';
	    var data = this.getData(dataType);
	    var itemModel = data.getItemModel(dataIndex);
	    var params = this.getDataParams(dataIndex, dataType);
	
	    if (dimIndex != null && params.value instanceof Array) {
	      params.value = params.value[dimIndex];
	    }
	
	    var formatter = itemModel.get(status === 'normal' ? [labelProp || 'label', 'formatter'] : [status, labelProp || 'label', 'formatter']);
	
	    if (typeof formatter === 'function') {
	      params.status = status;
	      params.dimensionIndex = dimIndex;
	      return formatter(params);
	    } else if (typeof formatter === 'string') {
	      var str = formatTpl(formatter, params); // Support 'aaa{@[3]}bbb{@product}ccc'.
	      // Do not support '}' in dim name util have to.
	
	      return str.replace(DIMENSION_LABEL_REG, function (origin, dim) {
	        var len = dim.length;
	
	        if (dim.charAt(0) === '[' && dim.charAt(len - 1) === ']') {
	          dim = +dim.slice(1, len - 1); // Also: '[]' => 0
	        }
	
	        return retrieveRawValue(data, dataIndex, dim);
	      });
	    }
	  },
	
	  /**
	   * Get raw value in option
	   * @param {number} idx
	   * @param {string} [dataType]
	   * @return {Array|number|string}
	   */
	  getRawValue: function (idx, dataType) {
	    return retrieveRawValue(this.getData(dataType), idx);
	  },
	
	  /**
	   * Should be implemented.
	   * @param {number} dataIndex
	   * @param {boolean} [multipleSeries=false]
	   * @param {number} [dataType]
	   * @return {string} tooltip string
	   */
	  formatTooltip: function () {// Empty function
	  }
	};
	module.exports = _default;

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(3);
	
	var assert = _util.assert;
	var isArray = _util.isArray;
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {Object} define
	 * @return See the return of `createTask`.
	 */
	function createTask(define) {
	  return new Task(define);
	}
	/**
	 * @constructor
	 * @param {Object} define
	 * @param {Function} define.reset Custom reset
	 * @param {Function} [define.plan] Returns 'reset' indicate reset immediately.
	 * @param {Function} [define.count] count is used to determin data task.
	 * @param {Function} [define.onDirty] count is used to determin data task.
	 */
	
	
	function Task(define) {
	  define = define || {};
	  this._reset = define.reset;
	  this._plan = define.plan;
	  this._count = define.count;
	  this._onDirty = define.onDirty;
	  this._dirty = true; // Context must be specified implicitly, to
	  // avoid miss update context when model changed.
	
	  this.context;
	}
	
	var taskProto = Task.prototype;
	/**
	 * @param {Object} performArgs
	 * @param {number} [performArgs.step] Specified step.
	 * @param {number} [performArgs.skip] Skip customer perform call.
	 * @param {number} [performArgs.modBy] Sampling window size.
	 * @param {number} [performArgs.modDataCount] Sampling count.
	 */
	
	taskProto.perform = function (performArgs) {
	  var upTask = this._upstream;
	  var skip = performArgs && performArgs.skip; // TODO some refactor.
	  // Pull data. Must pull data each time, because context.data
	  // may be updated by Series.setData.
	
	  if (this._dirty && upTask) {
	    var context = this.context;
	    context.data = context.outputData = upTask.context.outputData;
	  }
	
	  if (this.__pipeline) {
	    this.__pipeline.currentTask = this;
	  }
	
	  var planResult;
	
	  if (this._plan && !skip) {
	    planResult = this._plan(this.context);
	  } // Support sharding by mod, which changes the render sequence and makes the rendered graphic
	  // elements uniformed distributed when progress, especially when moving or zooming.
	
	
	  var lastModBy = normalizeModBy(this._modBy);
	  var lastModDataCount = this._modDataCount || 0;
	  var modBy = normalizeModBy(performArgs && performArgs.modBy);
	  var modDataCount = performArgs && performArgs.modDataCount || 0;
	
	  if (lastModBy !== modBy || lastModDataCount !== modDataCount) {
	    planResult = 'reset';
	  }
	
	  function normalizeModBy(val) {
	    !(val >= 1) && (val = 1); // jshint ignore:line
	
	    return val;
	  }
	
	  var forceFirstProgress;
	
	  if (this._dirty || planResult === 'reset') {
	    this._dirty = false;
	    forceFirstProgress = reset(this, skip);
	  }
	
	  this._modBy = modBy;
	  this._modDataCount = modDataCount;
	  var step = performArgs && performArgs.step;
	
	  if (upTask) {
	    this._dueEnd = upTask._outputDueEnd;
	  } // DataTask or overallTask
	  else {
	      this._dueEnd = this._count ? this._count(this.context) : Infinity;
	    } // Note: Stubs, that its host overall task let it has progress, has progress.
	  // If no progress, pass index from upstream to downstream each time plan called.
	
	
	  if (this._progress) {
	    var start = this._dueIndex;
	    var end = Math.min(step != null ? this._dueIndex + step : Infinity, this._dueEnd);
	
	    if (!skip && (forceFirstProgress || start < end)) {
	      var progress = this._progress;
	
	      if (isArray(progress)) {
	        for (var i = 0; i < progress.length; i++) {
	          doProgress(this, progress[i], start, end, modBy, modDataCount);
	        }
	      } else {
	        doProgress(this, progress, start, end, modBy, modDataCount);
	      }
	    }
	
	    this._dueIndex = end; // If no `outputDueEnd`, assume that output data and
	    // input data is the same, so use `dueIndex` as `outputDueEnd`.
	
	    var outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : end;
	    this._outputDueEnd = outputDueEnd;
	  } else {
	    // (1) Some overall task has no progress.
	    // (2) Stubs, that its host overall task do not let it has progress, has no progress.
	    // This should always be performed so it can be passed to downstream.
	    this._dueIndex = this._outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : this._dueEnd;
	  }
	
	  return this.unfinished();
	};
	
	var iterator = function () {
	  var end;
	  var current;
	  var modBy;
	  var modDataCount;
	  var winCount;
	  var it = {
	    reset: function (s, e, sStep, sCount) {
	      current = s;
	      end = e;
	      modBy = sStep;
	      modDataCount = sCount;
	      winCount = Math.ceil(modDataCount / modBy);
	      it.next = modBy > 1 && modDataCount > 0 ? modNext : sequentialNext;
	    }
	  };
	  return it;
	
	  function sequentialNext() {
	    return current < end ? current++ : null;
	  }
	
	  function modNext() {
	    var dataIndex = current % winCount * modBy + Math.ceil(current / winCount);
	    var result = current >= end ? null : dataIndex < modDataCount ? dataIndex // If modDataCount is smaller than data.count() (consider `appendData` case),
	    // Use normal linear rendering mode.
	    : current;
	    current++;
	    return result;
	  }
	}();
	
	taskProto.dirty = function () {
	  this._dirty = true;
	  this._onDirty && this._onDirty(this.context);
	};
	
	function doProgress(taskIns, progress, start, end, modBy, modDataCount) {
	  iterator.reset(start, end, modBy, modDataCount);
	  taskIns._callingProgress = progress;
	
	  taskIns._callingProgress({
	    start: start,
	    end: end,
	    count: end - start,
	    next: iterator.next
	  }, taskIns.context);
	}
	
	function reset(taskIns, skip) {
	  taskIns._dueIndex = taskIns._outputDueEnd = taskIns._dueEnd = 0;
	  taskIns._settedOutputEnd = null;
	  var progress;
	  var forceFirstProgress;
	
	  if (!skip && taskIns._reset) {
	    progress = taskIns._reset(taskIns.context);
	
	    if (progress && progress.progress) {
	      forceFirstProgress = progress.forceFirstProgress;
	      progress = progress.progress;
	    } // To simplify no progress checking, array must has item.
	
	
	    if (isArray(progress) && !progress.length) {
	      progress = null;
	    }
	  }
	
	  taskIns._progress = progress;
	  taskIns._modBy = taskIns._modDataCount = null;
	  var downstream = taskIns._downstream;
	  downstream && downstream.dirty();
	  return forceFirstProgress;
	}
	/**
	 * @return {boolean}
	 */
	
	
	taskProto.unfinished = function () {
	  return this._progress && this._dueIndex < this._dueEnd;
	};
	/**
	 * @param {Object} downTask The downstream task.
	 * @return {Object} The downstream task.
	 */
	
	
	taskProto.pipe = function (downTask) {
	  // If already downstream, do not dirty downTask.
	  if (this._downstream !== downTask || this._dirty) {
	    this._downstream = downTask;
	    downTask._upstream = this;
	    downTask.dirty();
	  }
	};
	
	taskProto.dispose = function () {
	  if (this._disposed) {
	    return;
	  }
	
	  this._upstream && (this._upstream._downstream = null);
	  this._downstream && (this._downstream._upstream = null);
	  this._dirty = false;
	  this._disposed = true;
	};
	
	taskProto.getUpstream = function () {
	  return this._upstream;
	};
	
	taskProto.getDownstream = function () {
	  return this._downstream;
	};
	
	taskProto.setOutputEnd = function (end) {
	  // This only happend in dataTask, dataZoom, map, currently.
	  // where dataZoom do not set end each time, but only set
	  // when reset. So we should record the setted end, in case
	  // that the stub of dataZoom perform again and earse the
	  // setted end by upstream.
	  this._outputDueEnd = this._settedOutputEnd = end;
	}; ///////////////////////////////////////////////////////////
	// For stream debug (Should be commented out after used!)
	// Usage: printTask(this, 'begin');
	// Usage: printTask(this, null, {someExtraProp});
	// function printTask(task, prefix, extra) {
	//     window.ecTaskUID == null && (window.ecTaskUID = 0);
	//     task.uidDebug == null && (task.uidDebug = `task_${window.ecTaskUID++}`);
	//     task.agent && task.agent.uidDebug == null && (task.agent.uidDebug = `task_${window.ecTaskUID++}`);
	//     var props = [];
	//     if (task.__pipeline) {
	//         var val = `${task.__idxInPipeline}/${task.__pipeline.tail.__idxInPipeline} ${task.agent ? '(stub)' : ''}`;
	//         props.push({text: 'idx', value: val});
	//     } else {
	//         var stubCount = 0;
	//         task.agentStubMap.each(() => stubCount++);
	//         props.push({text: 'idx', value: `overall (stubs: ${stubCount})`});
	//     }
	//     props.push({text: 'uid', value: task.uidDebug});
	//     if (task.__pipeline) {
	//         props.push({text: 'pid', value: task.__pipeline.id});
	//         task.agent && props.push(
	//             {text: 'stubFor', value: task.agent.uidDebug}
	//         );
	//     }
	//     props.push(
	//         {text: 'dirty', value: task._dirty},
	//         {text: 'dueIndex', value: task._dueIndex},
	//         {text: 'dueEnd', value: task._dueEnd},
	//         {text: 'outputDueEnd', value: task._outputDueEnd}
	//     );
	//     if (extra) {
	//         Object.keys(extra).forEach(key => {
	//             props.push({text: key, value: extra[key]});
	//         });
	//     }
	//     var args = ['color: blue'];
	//     var msg = `%c[${prefix || 'T'}] %c` + props.map(item => (
	//         args.push('color: black', 'color: red'),
	//         `${item.text}: %c${item.value}`
	//     )).join('%c, ');
	//     console.log.apply(console, [msg].concat(args));
	//     // console.log(this);
	// }
	
	
	exports.createTask = createTask;

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 478 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(170);
	
	module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ },
/* 480 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.getHashPath = getHashPath;
	exports.replaceHashPath = replaceHashPath;
	exports.getWindowPath = getWindowPath;
	exports.go = go;
	exports.getUserConfirmation = getUserConfirmation;
	exports.supportsHistory = supportsHistory;
	exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;
	
	function addEventListener(node, event, listener) {
	  if (node.addEventListener) {
	    node.addEventListener(event, listener, false);
	  } else {
	    node.attachEvent('on' + event, listener);
	  }
	}
	
	function removeEventListener(node, event, listener) {
	  if (node.removeEventListener) {
	    node.removeEventListener(event, listener, false);
	  } else {
	    node.detachEvent('on' + event, listener);
	  }
	}
	
	function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  return window.location.href.split('#')[1] || '';
	}
	
	function replaceHashPath(path) {
	  window.location.replace(window.location.pathname + window.location.search + '#' + path);
	}
	
	function getWindowPath() {
	  return window.location.pathname + window.location.search + window.location.hash;
	}
	
	function go(n) {
	  if (n) window.history.go(n);
	}
	
	function getUserConfirmation(message, callback) {
	  callback(window.confirm(message));
	}
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	 */
	
	function supportsHistory() {
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	
	function supportsGoWithoutReloadUsingHash() {
	  var ua = navigator.userAgent;
	  return ua.indexOf('Firefox') === -1;
	}

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(108);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function deprecate(fn, message) {
	  return function () {
	     false ? _warning2['default'](false, '[history] ' + message) : undefined;
	    return fn.apply(this, arguments);
	  };
	}
	
	exports['default'] = deprecate;
	module.exports = exports['default'];

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(108);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
	  }
	}
	
	exports['default'] = runTransitionHook;
	module.exports = exports['default'];

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(176),
	    root = __webpack_require__(125);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(1849),
	    mapCacheDelete = __webpack_require__(1850),
	    mapCacheGet = __webpack_require__(1851),
	    mapCacheHas = __webpack_require__(1852),
	    mapCacheSet = __webpack_require__(1853);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 485 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(780);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ },
/* 487 */
/***/ function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(793);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ },
/* 489 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(347),
	    arrayIncludes = __webpack_require__(486),
	    arrayIncludesWith = __webpack_require__(487),
	    cacheHas = __webpack_require__(352),
	    createSet = __webpack_require__(1825),
	    setToArray = __webpack_require__(494);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(35),
	    isKey = __webpack_require__(493),
	    stringToPath = __webpack_require__(1873),
	    toString = __webpack_require__(1912);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 492 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(35),
	    isSymbol = __webpack_require__(275);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 494 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(1800),
	    isObjectLike = __webpack_require__(146);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 496 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(212);
	var Danger = __webpack_require__(1937);
	var ReactDOMComponentTree = __webpack_require__(50);
	var ReactInstrumentation = __webpack_require__(94);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(506);
	var setInnerHTML = __webpack_require__(365);
	var setTextContent = __webpack_require__(975);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 498 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var invariant = __webpack_require__(28);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var ReactErrorUtils = __webpack_require__(504);
	
	var invariant = __webpack_require__(28);
	var warning = __webpack_require__(34);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 501 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var ReactPropTypesSecret = __webpack_require__(1966);
	var propTypesFactory = __webpack_require__(954);
	
	var React = __webpack_require__(216);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(28);
	var warning = __webpack_require__(34);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var invariant = __webpack_require__(28);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var ReactCurrentOwner = __webpack_require__(128);
	var ReactInstanceMap = __webpack_require__(279);
	var ReactInstrumentation = __webpack_require__(94);
	var ReactUpdates = __webpack_require__(111);
	
	var invariant = __webpack_require__(28);
	var warning = __webpack_require__(34);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 506 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 507 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 508 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 509 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(74);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 511 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(32);
	
	var emptyFunction = __webpack_require__(107);
	var warning = __webpack_require__(34);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 513 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.router = exports.routes = exports.route = exports.components = exports.component = exports.location = exports.history = exports.falsy = exports.locationShape = exports.routerShape = undefined;
	
	var _react = __webpack_require__(60);
	
	var _deprecateObjectProperties = __webpack_require__(367);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _InternalPropTypes = __webpack_require__(179);
	
	var InternalPropTypes = _interopRequireWildcard(_InternalPropTypes);
	
	var _routerWarning = __webpack_require__(64);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	var routerShape = exports.routerShape = shape({
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired,
	  setRouteLeaveHook: func.isRequired,
	  isActive: func.isRequired
	});
	
	var locationShape = exports.locationShape = shape({
	  pathname: string.isRequired,
	  search: string.isRequired,
	  state: object,
	  action: string.isRequired,
	  key: string
	});
	
	// Deprecated stuff below:
	
	var falsy = exports.falsy = InternalPropTypes.falsy;
	var history = exports.history = InternalPropTypes.history;
	var location = exports.location = locationShape;
	var component = exports.component = InternalPropTypes.component;
	var components = exports.components = InternalPropTypes.components;
	var route = exports.route = InternalPropTypes.route;
	var routes = exports.routes = InternalPropTypes.routes;
	var router = exports.router = routerShape;
	
	if (false) {
	  (function () {
	    var deprecatePropType = function deprecatePropType(propType, message) {
	      return function () {
	        process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	        return propType.apply(undefined, arguments);
	      };
	    };
	
	    var deprecateInternalPropType = function deprecateInternalPropType(propType) {
	      return deprecatePropType(propType, 'This prop type is not intended for external use, and was previously exported by mistake. These internal prop types are deprecated for external use, and will be removed in a later version.');
	    };
	
	    var deprecateRenamedPropType = function deprecateRenamedPropType(propType, name) {
	      return deprecatePropType(propType, 'The `' + name + '` prop type is now exported as `' + name + 'Shape` to avoid name conflicts. This export is deprecated and will be removed in a later version.');
	    };
	
	    exports.falsy = falsy = deprecateInternalPropType(falsy);
	    exports.history = history = deprecateInternalPropType(history);
	    exports.component = component = deprecateInternalPropType(component);
	    exports.components = components = deprecateInternalPropType(components);
	    exports.route = route = deprecateInternalPropType(route);
	    exports.routes = routes = deprecateInternalPropType(routes);
	
	    exports.location = location = deprecateRenamedPropType(location, 'location');
	    exports.router = router = deprecateRenamedPropType(router, 'router');
	  })();
	}
	
	var defaultExport = {
	  falsy: falsy,
	  history: history,
	  location: location,
	  component: component,
	  components: components,
	  route: route,
	  // For some reason, routes was never here.
	  router: router
	};
	
	if (false) {
	  defaultExport = (0, _deprecateObjectProperties2.default)(defaultExport, 'The default export from `react-router/lib/PropTypes` is deprecated. Please use the named exports instead.');
	}
	
	exports.default = defaultExport;

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(64);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(2007);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(2004);
	
	var _isActive2 = __webpack_require__(2012);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(2008);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(2014);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	  function isActive(location) {
	    var indexOnlyOrDeprecatedQuery = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	    var deprecatedIndexOnly = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	    var indexOnly = void 0;
	    if (indexOnlyOrDeprecatedQuery && indexOnlyOrDeprecatedQuery !== true || deprecatedIndexOnly !== null) {
	       false ? (0, _routerWarning2.default)(false, '`isActive(pathname, query, indexOnly) is deprecated; use `isActive(location, indexOnly)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      location = { pathname: location, query: indexOnlyOrDeprecatedQuery };
	      indexOnly = deprecatedIndexOnly || false;
	    } else {
	      location = history.createLocation(location);
	      indexOnly = indexOnlyOrDeprecatedQuery;
	    }
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState);
	
	    var leaveRoutes = _computeChangedRoutes.leaveRoutes;
	    var changeRoutes = _computeChangedRoutes.changeRoutes;
	    var enterRoutes = _computeChangedRoutes.enterRoutes;
	
	
	    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.reduce(function (hooks, route) {
	      hooks.push.apply(hooks, RouteHooks[getRouteID(route)]);
	      return hooks;
	    }, []);
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route, false);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    // TODO: Warn if they register for a route that isn't currently
	    // active. They're probably doing something wrong, like re-creating
	    // route objects on every location change.
	    var routeID = getRouteID(route);
	    var hooks = RouteHooks[routeID];
	
	    if (!hooks) {
	      var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	
	      RouteHooks[routeID] = [hook];
	
	      if (thereWereNoRouteHooks) {
	        // setup transition & beforeunload hooks
	        unlistenBefore = history.listenBefore(transitionHook);
	
	        if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	      }
	    } else {
	      if (hooks.indexOf(hook) === -1) {
	         false ? (0, _routerWarning2.default)(false, 'adding multiple leave hooks for the same route is deprecated; manage multiple confirmations in your own code instead') : void 0;
	
	        hooks.push(hook);
	      }
	    }
	
	    return function () {
	      var hooks = RouteHooks[routeID];
	
	      if (hooks) {
	        var newHooks = hooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (newHooks.length === 0) {
	          removeListenBeforeHooksForRoute(route);
	        } else {
	          RouteHooks[routeID] = newHooks;
	        }
	      }
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    // TODO: Only use a single history listener. Otherwise we'll
	    // end up with multiple concurrent calls to match.
	    return history.listen(function (location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    });
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	
	//export default useRoutes
	
	module.exports = exports['default'];

/***/ },
/* 516 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var FILE = exports.FILE = '__NATIVE_FILE__';
	var URL = exports.URL = '__NATIVE_URL__';
	var TEXT = exports.TEXT = '__NATIVE_TEXT__';

/***/ },
/* 517 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = shallowEqual;
	function shallowEqual(objA, objB) {
		if (objA === objB) {
			return true;
		}
	
		var keysA = Object.keys(objA);
		var keysB = Object.keys(objB);
	
		if (keysA.length !== keysB.length) {
			return false;
		}
	
		// Test for A's keys different from B.
		var hasOwn = Object.prototype.hasOwnProperty;
		for (var i = 0; i < keysA.length; i += 1) {
			if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
				return false;
			}
	
			var valA = objA[keysA[i]];
			var valB = objB[keysA[i]];
	
			if (valA !== valB) {
				return false;
			}
		}
	
		return true;
	}

/***/ },
/* 518 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 519 */
513,
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContextProvider = ContextProvider;
	exports.ContextSubscriber = ContextSubscriber;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Works around issues with context updates failing to propagate.
	// Caveat: the context value is expected to never change its identity.
	// https://github.com/facebook/react/issues/2517
	// https://github.com/reactjs/react-router/issues/470
	
	var contextProviderShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  eventIndex: _propTypes2.default.number.isRequired
	});
	
	function makeContextName(name) {
	  return '@@contextSubscriber/' + name;
	}
	
	var prefixUnsafeLifecycleMethods = typeof _react2.default.forwardRef !== 'undefined';
	
	function ContextProvider(name) {
	  var _childContextTypes, _config;
	
	  var contextName = makeContextName(name);
	  var listenersKey = contextName + '/listeners';
	  var eventIndexKey = contextName + '/eventIndex';
	  var subscribeKey = contextName + '/subscribe';
	
	  var config = (_config = {
	    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),
	
	    getChildContext: function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextName] = {
	        eventIndex: this[eventIndexKey],
	        subscribe: this[subscribeKey]
	      }, _ref;
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
	    componentWillMount: function componentWillMount() {
	      this[listenersKey] = [];
	      this[eventIndexKey] = 0;
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this[eventIndexKey]++;
	    },
	    componentDidUpdate: function componentDidUpdate() {
	      var _this = this;
	
	      this[listenersKey].forEach(function (listener) {
	        return listener(_this[eventIndexKey]);
	      });
	    }
	  }, _config[subscribeKey] = function (listener) {
	    var _this2 = this;
	
	    // No need to immediately call listener here.
	    this[listenersKey].push(listener);
	
	    return function () {
	      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }, _config);
	
	  if (prefixUnsafeLifecycleMethods) {
	    config.UNSAFE_componentWillMount = config.componentWillMount;
	    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
	    delete config.componentWillMount;
	    delete config.componentWillReceiveProps;
	  }
	  return config;
	}
	
	function ContextSubscriber(name) {
	  var _contextTypes, _config2;
	
	  var contextName = makeContextName(name);
	  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
	  var handleContextUpdateKey = contextName + '/handleContextUpdate';
	  var unsubscribeKey = contextName + '/unsubscribe';
	
	  var config = (_config2 = {
	    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),
	
	    getInitialState: function getInitialState() {
	      var _ref2;
	
	      if (!this.context[contextName]) {
	        return {};
	      }
	
	      return _ref2 = {}, _ref2[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref2;
	    },
	    componentDidMount: function componentDidMount() {
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      var _setState;
	
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      if (!this[unsubscribeKey]) {
	        return;
	      }
	
	      this[unsubscribeKey]();
	      this[unsubscribeKey] = null;
	    }
	  }, _config2[handleContextUpdateKey] = function (eventIndex) {
	    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
	      var _setState2;
	
	      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
	    }
	  }, _config2);
	
	  if (prefixUnsafeLifecycleMethods) {
	    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
	    delete config.componentWillReceiveProps;
	  }
	  return config;
	}

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationShape = exports.routerShape = undefined;
	
	var _propTypes = __webpack_require__(4);
	
	var routerShape = exports.routerShape = (0, _propTypes.shape)({
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired,
	  setRouteLeaveHook: _propTypes.func.isRequired,
	  isActive: _propTypes.func.isRequired
	});
	
	var locationShape = exports.locationShape = (0, _propTypes.shape)({
	  pathname: _propTypes.string.isRequired,
	  search: _propTypes.string.isRequired,
	  state: _propTypes.object,
	  action: _propTypes.string.isRequired,
	  key: _propTypes.string
	});

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIs = __webpack_require__(72);
	
	var _createReactClass = __webpack_require__(104);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(4);
	
	var _getRouteParams = __webpack_require__(2070);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _ContextUtils = __webpack_require__(520);
	
	var _RouteUtils = __webpack_require__(148);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	var RouterContext = (0, _createReactClass2.default)({
	  displayName: 'RouterContext',
	
	  mixins: [(0, _ContextUtils.ContextProvider)('router')],
	
	  propTypes: {
	    router: _propTypes.object.isRequired,
	    location: _propTypes.object.isRequired,
	    routes: _propTypes.array.isRequired,
	    params: _propTypes.object.isRequired,
	    components: _propTypes.array.isRequired,
	    createElement: _propTypes.func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    router: _propTypes.object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      router: this.props.router
	    };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        location = _props.location,
	        routes = _props.routes,
	        params = _props.params,
	        components = _props.components,
	        router = _props.router;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          location: location,
	          params: params,
	          route: route,
	          router: router,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        // Handle components is object for { [name]: component } but not valid element
	        // type of react, such as React.memo, React.lazy and so on.
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object' && !(0, _reactIs.isValidElementType)(components)) {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;
	
	var _LocationUtils = __webpack_require__(221);
	
	var _DOMUtils = __webpack_require__(371);
	
	var _DOMStateStorage = __webpack_require__(1011);
	
	var _PathUtils = __webpack_require__(149);
	
	var _ExecutionEnvironment = __webpack_require__(524);
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();
	
	var _createLocation = function _createLocation(historyState) {
	  var key = historyState && historyState.key;
	
	  return (0, _LocationUtils.createLocation)({
	    pathname: window.location.pathname,
	    search: window.location.search,
	    hash: window.location.hash,
	    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
	  }, undefined, key);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  var historyState = void 0;
	  try {
	    historyState = window.history.state || {};
	  } catch (error) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    historyState = {};
	  }
	
	  return _createLocation(historyState);
	};
	
	var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	var startListener = exports.startListener = function startListener(listener) {
	  var handlePopState = function handlePopState(event) {
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
	      return;
	    listener(_createLocation(event.state));
	  };
	
	  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
	    return listener(getCurrentLocation());
	  };
	
	  if (needsHashchangeListener) {
	    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	  }
	
	  return function () {
	    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	    if (needsHashchangeListener) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	    }
	  };
	};
	
	var updateLocation = function updateLocation(location, updateState) {
	  var state = location.state,
	      key = location.key;
	
	
	  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);
	
	  updateState({ key: key }, (0, _PathUtils.createPath)(location));
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.pushState(state, null, path);
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.replaceState(state, null, path);
	  });
	};
	
	var go = exports.go = function go(n) {
	  if (n) window.history.go(n);
	};

/***/ },
/* 524 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(2076);
	
	var _PathUtils = __webpack_require__(149);
	
	var _runTransitionHook = __webpack_require__(526);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _Actions = __webpack_require__(370);
	
	var _LocationUtils = __webpack_require__(221);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHistory = function createHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getCurrentLocation = options.getCurrentLocation,
	      getUserConfirmation = options.getUserConfirmation,
	      pushLocation = options.pushLocation,
	      replaceLocation = options.replaceLocation,
	      go = options.go,
	      keyLength = options.keyLength;
	
	
	  var currentLocation = void 0;
	  var pendingLocation = void 0;
	  var beforeListeners = [];
	  var listeners = [];
	  var allKeys = [];
	
	  var getCurrentIndex = function getCurrentIndex() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);
	
	    if (currentLocation) return allKeys.indexOf(currentLocation.key);
	
	    return -1;
	  };
	
	  var updateLocation = function updateLocation(nextLocation) {
	    var currentIndex = getCurrentIndex();
	
	    currentLocation = nextLocation;
	
	    if (currentLocation.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
	    } else if (currentLocation.action === _Actions.REPLACE) {
	      allKeys[currentIndex] = currentLocation.key;
	    }
	
	    listeners.forEach(function (listener) {
	      return listener(currentLocation);
	    });
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    beforeListeners.push(listener);
	
	    return function () {
	      return beforeListeners = beforeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var listen = function listen(listener) {
	    listeners.push(listener);
	
	    return function () {
	      return listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
	    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
	      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
	        return result != null ? done(result) : next();
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          return callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  };
	
	  var transitionTo = function transitionTo(nextLocation) {
	    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation
	
	      pendingLocation = null;
	
	      if (ok) {
	        // Treat PUSH to same path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = (0, _PathUtils.createPath)(currentLocation);
	          var nextPath = (0, _PathUtils.createPath)(nextLocation);
	
	          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (nextLocation.action === _Actions.POP) {
	          updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.PUSH) {
	          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.REPLACE) {
	          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
	        }
	      } else if (currentLocation && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(currentLocation.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
	      }
	    });
	  };
	
	  var push = function push(input) {
	    return transitionTo(createLocation(input, _Actions.PUSH));
	  };
	
	  var replace = function replace(input) {
	    return transitionTo(createLocation(input, _Actions.REPLACE));
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength || 6);
	  };
	
	  var createHref = function createHref(location) {
	    return (0, _PathUtils.createPath)(location);
	  };
	
	  var createLocation = function createLocation(location, action) {
	    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
	    return (0, _LocationUtils.createLocation)(location, action, key);
	  };
	
	  return {
	    getCurrentLocation: getCurrentLocation,
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: _PathUtils.createPath,
	    createHref: createHref,
	    createLocation: createLocation
	  };
	};
	
	exports.default = createHistory;

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(132);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var runTransitionHook = function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
	  }
	};
	
	exports.default = runTransitionHook;

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _ThemeDto = __webpack_require__(129);
	
	var _ThemeDto2 = _interopRequireDefault(_ThemeDto);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.comment = obj.comment;
		this.title = obj.title;
		this.image = obj.image;
		this.color = obj.color;
		this.themes = obj.themes.map(function (t) {
			return Object.assign({}, new _ThemeDto2.default(t));
		});
	};
	
	exports.default = _class;

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _uuid = __webpack_require__(44);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _ListStation = __webpack_require__(2107);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = window.$;
	
	var ListComponent = function (_Component) {
		_inherits(ListComponent, _Component);
	
		function ListComponent(props) {
			_classCallCheck(this, ListComponent);
	
			var _this = _possibleConstructorReturn(this, (ListComponent.__proto__ || Object.getPrototypeOf(ListComponent)).call(this, props));
	
			_this.getCheckBox = function (dataId, isChecked, isToogle) {
				if (_this.props.generalFunction) {
					var idTmp = dataId + _uuid2.default.v4();
					if (isToogle !== null && isToogle !== undefined) {
						return _react2.default.createElement(
							'div',
							{ className: 'switch' },
							_react2.default.createElement(
								'label',
								{ htmlFor: idTmp },
								_react2.default.createElement('input', { checked: isToogle, onChange: function onChange() {
										return _this.props.generalFunction(dataId, !isToogle);
									},
									type: 'checkbox',
									id: idTmp }),
								_react2.default.createElement('span', { className: 'lever' })
							)
						);
					} else if (isChecked !== null && isChecked !== undefined) {
						return _react2.default.createElement(
							'div',
							{ className: 'col s1 right-align group-input' },
							_react2.default.createElement('input', { checked: isChecked, className: 'filled-in',
								onChange: function onChange() {
									return _this.props.generalFunction(dataId, !isChecked);
								}, type: 'checkbox',
								id: idTmp }),
							_react2.default.createElement('label', { htmlFor: idTmp })
						);
					}
				}
				return null;
			};
	
			_this.getIcon = function (data) {
				if (data.picture) {
					return _react2.default.createElement('img', { className: 'iconeTypeResearch circle responsive-img', src: data.picture });
				} else if (data.icon) {
					return _react2.default.createElement(
						'div',
						{ className: 'material-icons iconeTypeResearch circle' },
						data.icon
					);
				}
				return '';
			};
	
			_this.openModal = function (id) {
				var idModal = '#' + id;
				$(idModal).modal('open');
			};
	
			return _this;
		}
	
		_createClass(ListComponent, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				$('.collapsible').collapsible();
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				$('.collapsible').collapsible();
			}
		}, {
			key: 'getData',
			value: function getData() {
				var _this2 = this;
	
				return this.props.tables.map(function (data, i) {
					var icon = _this2.getIcon(data);
					var color = data.color ? data.color : 'white';
					var checkBox = _this2.getCheckBox(data.id, data.isChecked, data.isToogle);
					var className = checkBox ? 's11' : 's12';
	
					var title = function () {
						if (data.modal) {
							return _react2.default.createElement(
								'div',
								{ className: 'row no-margin' },
								_react2.default.createElement(
									'div',
									{ className: 'col s11 no-padding truncate' },
									_react2.default.createElement(
										'span',
										{ className: 'truncate' },
										_react2.default.createElement(
											'b',
											null,
											data.title
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col s1 no-padding' },
									data.modal,
									_react2.default.createElement(
										'i',
										{ className: 'material-icons help-icon',
											onClick: function onClick() {
												return _this2.openModal(data.idModal);
											} },
										'info_outline'
									)
								)
							);
						}
						return _react2.default.createElement(
							'div',
							{ className: 'row no-margin' },
							_react2.default.createElement(
								'div',
								{ className: 'col s12 no-padding ' },
								_react2.default.createElement(
									'span',
									{ className: 'truncate' },
									_react2.default.createElement(
										'b',
										null,
										data.title
									)
								)
							)
						);
					}();
					var iconPanel = function () {
						if (icon) {
							return _react2.default.createElement(
								'div',
								{ className: 'col s2 no-padding' },
								_react2.default.createElement(
									'div',
									{ className: 'iconeTypeResearchWrapper' },
									icon
								)
							);
						}
						return null;
					}();
					var classNameTitle = iconPanel ? 's10' : 's12';
					var list = function () {
						if (data.lightMode) {
							return _react2.default.createElement(_ListStation.ListStation, { stations: data.component });
						}
						return _react2.default.createElement(
							'div',
							{ className: 'collapsible-body no-padding no-margin' },
							data.component
						);
					}();
					return _react2.default.createElement(
						'div',
						{ className: 'row no-margin', style: { width: '100%' } },
						_react2.default.createElement(
							'ul',
							{ className: 'collapsible no-margin', 'data-collapsible': 'expandable' },
							_react2.default.createElement(
								'li',
								{ key: i + 2000 },
								_react2.default.createElement(
									'div',
									{ className: 'collapsible-header valign-wrapper ', style: { backgroundColor: color } },
									_react2.default.createElement(
										'div',
										{ className: 'col no-padding ' + className },
										_react2.default.createElement(
											'div',
											{ className: 'row no-margin', style: { width: '100%' } },
											iconPanel,
											_react2.default.createElement(
												'div',
												{ className: 'col no-padding site-type-title ' + classNameTitle },
												title
											)
										)
									),
									checkBox
								),
								list
							)
						)
					);
				});
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'ul',
					{ style: { width: '100%' }, className: 'no-margin no-padding' },
					_react2.default.createElement(
						'li',
						null,
						this.getData()
					)
				);
			}
		}]);
	
		return ListComponent;
	}(_react.Component);
	
	ListComponent.propTypes = {
		tables: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			title: _propTypes2.default.string,
			component: _propTypes2.default.object,
			modal: _propTypes2.default.object,
			idModal: _propTypes2.default.string,
			color: _propTypes2.default.string,
			id: _propTypes2.default.number,
			isChecked: _propTypes2.default.bool,
			isToogle: _propTypes2.default.bool,
			icon: _propTypes2.default.string,
			picture: _propTypes2.default.string
		})),
		generalFunction: _propTypes2.default.func
	};
	
	ListComponent.defaultProps = {
		tables: []
	};
	
	exports.default = ListComponent;

/***/ },
/* 529 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
		RECEIVE_ALL_SELECTIONS: 'RECEIVE_SELECTIONS',
		RECEIVE_SELECTIONS_FILTERS: 'RECEIVE_SELECTIONS_FILTERS',
		RECEIVE_FILTERS_VALUES: 'RECEIVE_FILTERS_VALUES',
		RECEIVE_SELECTIONS_SITES: 'RECEIVE_SELECTIONS_SITES',
		RECEIVE_SELECTIONS_DETAIL_SITES: 'RECEIVE_SELECTIONS_DETAIL_SITES',
		RESET_USER_SELECTION: 'RESET_USER_SELECTION',
		SELECTED_SELECTION: 'SELECTED_SELECTION',
		SELECTED_SELECTION_INFORMATION: 'SELECTED_SELECTION_INFORMATION',
		RESET_SELECTED_SELECTION_INFORMATION: 'RESET_SELECTED_SELECTION_INFORMATION',
		OPEN_MODAL_SELECTED_SELECTION_INFORMATION: 'OPEN_MODAL_SELECTED_SELECTION_INFORMATION',
		OPEN_MODAL_SELECTED_SELECTION_DELETE: 'OPEN_MODAL_SELECTED_SELECTION_DELETE',
		OPEN_MODAL_SELECTED_SELECTION_EXPORT: 'OPEN_MODAL_SELECTED_SELECTION_EXPORT',
		OPEN_MODAL_SELECTED_SELECTION_SAVE: 'OPEN_MODAL_SELECTED_SELECTION_SAVE',
		CLOSE_MODAL_SELECTED_SELECTION_INFORMATION: 'CLOSE_MODAL_SELECTED_SELECTION_INFORMATION',
		CLOSE_MODAL_SELECTED_SELECTION_DELETE: 'CLOSE_MODAL_SELECTED_SELECTION_DELETE',
		CLOSE_MODAL_SELECTED_SELECTION_EXPORT: 'CLOSE_MODAL_SELECTED_SELECTION_EXPORT',
		CLOSE_MODAL_SELECTED_SELECTION_SAVE: 'CLOSE_MODAL_SELECTED_SELECTION_SAVE',
		RESET_SELECTED_SELECTION: 'RESET_SELECTED_SELECTION',
		RECEIVE_SELECTIONS_KEY_FIGURES: 'RECEIVE_SELECTIONS_KEY_FIGURES',
		RECEIVE_SELECTIONS_EXPORT_HISTORY: 'RECEIVE_SELECTIONS_EXPORT_HISTORY',
		RECEIVE_SELECTIONS_WATERSHED: 'RECEIVE_SELECTIONS_WATERSHED',
		RECEIVE_SELECTIONS_STATUS: 'RECEIVE_SELECTIONS_STATUS',
		RECEIVE_DELETE_SELECTION: 'RECEIVE_DELETE_SELECTION',
		RECEIVE_AND_SELECT_SELECTION: 'RECEIVE_AND_SELECT_SELECTION',
		RECEIVE_REMOVE_FAVORITE_SELECTION: 'RECEIVE_REMOVE_FAVORITE_SELECTION',
		RECEIVE_FAVORITE_SELECTION: 'RECEIVE_FAVORITE_SELECTION',
		RECEIVE_SELECTED_EXPORT_SELECTIONS: 'RECEIVE_SELECTED_EXPORT_SELECTIONS',
		RESET_SELECTED_EXPORT_SELECTIONS: 'RESET_SELECTED_EXPORT_SELECTIONS',
		RESET_SELECTION_INFORMATIONS: 'RESET_SELECTION_INFORMATIONS',
		SITE_DESCRIPTION_EXPORT_OPTION: 'SITE_DESCRIPTION',
		SITE_DATA_EXPORT_OPTION: 'SITE_DATA'
	};

/***/ },
/* 530 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.value = obj.value;
		this.filterTypeId = obj.filtertype_id;
		this.filterParameter = obj.filterParameter;
	};
	
	exports.default = _class;

/***/ },
/* 531 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.beginDate = obj.begindate;
		this.endDate = obj.enddate;
		this.filename = obj.filename;
		this.terminated = obj.terminated;
		this.selectionId = obj.selectionid;
		this.error = obj.error;
	};
	
	exports.default = _class;

/***/ },
/* 532 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.mnemonique = obj.mnemonique;
		this.name = obj.name;
	};
	
	exports.default = _class;

/***/ },
/* 533 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.action = obj.action_type;
		this.libelle = obj.libelle;
		this.type = obj.type;
	};
	
	exports.default = _class;

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _reactGa = __webpack_require__(369);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	var _ApplicationUtil = __webpack_require__(544);
	
	var _ApplicationConf = __webpack_require__(65);
	
	var _ApplicationConf2 = _interopRequireDefault(_ApplicationConf);
	
	var _ActionUtils = __webpack_require__(112);
	
	var _LoginConstants = __webpack_require__(2151);
	
	var _SelectionAction = __webpack_require__(95);
	
	var _SelectionAction2 = _interopRequireDefault(_SelectionAction);
	
	var _CreditAction = __webpack_require__(376);
	
	var _CreditAction2 = _interopRequireDefault(_CreditAction);
	
	var _HomeAction = __webpack_require__(52);
	
	var _HomeAction2 = _interopRequireDefault(_HomeAction);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _ToastrAction = __webpack_require__(66);
	
	var _ToastrAction2 = _interopRequireDefault(_ToastrAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SignInAction = {
		login: function login(_login, password) {
			var functionToLoad = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
	
			return function (dispatch) {
				_reactGa2.default.set({ userId: _ApplicationUtil.ApplicationUtil.getUserId(_login) });
				var basicAuth = btoa(_login + ':' + password);
				return fetch(_ApplicationConf2.default.login.login(), {
					method: 'POST',
					headers: {
						Authorization: 'Basic ' + basicAuth,
						Accept: 'application/json'
					},
					body: JSON.stringify({
						licence: btoa(_LoginConstants.LICENCE_KEY)
					})
				}).then(_ActionUtils.checkAuth).then(function () {
					sessionStorage.setItem('TOKEN', btoa(_login));
					dispatch(_SelectionAction2.default.fetchSelections(_login));
					dispatch(_CreditAction2.default.fetchUserInitCredit(_login));
					dispatch(_HomeAction2.default.updateLoginModalState(false));
					dispatch(_HomeAction2.default.fetchUser(_login));
				}).then(function () {
					if (functionToLoad && functionToLoad.length) {
						functionToLoad[0]();
					}
				}).catch(function () {
					dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.error.loginError));
				});
			};
		}
	};
	
	exports.default = SignInAction;

/***/ },
/* 535 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
		RECEIVE_POINT: 'RECEIVE_POINT',
		RECEIVE_POINT_KEY_FIGURES: 'RECEIVE_POINT_KEY_FIGURES',
		RECEIVE_POINT_NETWORKS: 'RECEIVE_POINT_NETWORKS',
		RECEIVE_SAMPLING_SURFACE_POINT: 'RECEIVE_SAMPLING_SURFACE_POINT',
		PANEL_QUALITY_ANALYSIS: 'PANEL_QUALITY_ANALYSIS',
		PANEL_QUALITY_SAMPLING_POINTS: 'PANEL_QUALITY_SAMPLING_POINTS',
		RESET_POINT_INFORMATIONS: 'RESET_POINT_INFORMATIONS'
	};

/***/ },
/* 536 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.code = obj.code;
		this.name = obj.name;
		this.unit = obj.unit;
		this.typeId = obj.indicatortype_id;
	};
	
	exports.default = _class;

/***/ },
/* 537 */
532,
/* 538 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.code = obj.code;
		this.name = obj.name;
		this.typeId = obj.typeid;
		this.isPiezometer = obj.ispiezometer;
		this.isQualitometer = obj.isqualitometer;
	};
	
	exports.default = _class;

/***/ },
/* 539 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.name = obj.name;
		this.code = obj.code;
	};
	
	exports.default = _class;

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _DetailStationConstants = __webpack_require__(542);
	
	var _ApplicationConf = __webpack_require__(65);
	
	var _ApplicationConf2 = _interopRequireDefault(_ApplicationConf);
	
	var _isomorphicFetch = __webpack_require__(78);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _reactAquasys = __webpack_require__(49);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _lodash = __webpack_require__(15);
	
	var _ActionUtils = __webpack_require__(112);
	
	var _downloadjs = __webpack_require__(692);
	
	var _downloadjs2 = _interopRequireDefault(_downloadjs);
	
	var _ToastrAction = __webpack_require__(66);
	
	var _ToastrAction2 = _interopRequireDefault(_ToastrAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DetailStationAction = {
		receiveStation: function receiveStation(content, type) {
			return {
				type: type,
				station: content
			};
		},
		receiveMeasures: function receiveMeasures(content, type) {
			return {
				type: type,
				measures: content
			};
		},
		receiveNetworks: function receiveNetworks(content) {
			return {
				type: _DetailStationConstants.RECEIVE_DETAIL_STATION_NETWORK,
				networks: content
			};
		},
		receiveSamplingSurfacePoint: function receiveSamplingSurfacePoint(content) {
			return {
				type: _DetailStationConstants.RECEIVE_DETAIL_QUALITO_SAMPLING_SURFACE_POINT,
				samplingSurfacePoints: content
			};
		},
	
		fetchDetailSation: function fetchDetailSation(id) {
			return function (dispatch) {
				dispatch(DetailStationAction.fetchStation(id));
				dispatch(DetailStationAction.fetchStationNetwork(id));
				dispatch(DetailStationAction.fetchPiezoMeasures(id));
				dispatch(DetailStationAction.fetchPiezometerMeasureMax(id));
				dispatch(DetailStationAction.fetchPiezometerMeasureMin(id));
				dispatch(DetailStationAction.fetchPiezometerMeasureMoyenne(id));
				dispatch(DetailStationAction.fetchPickupOperation(id));
				dispatch(DetailStationAction.fetchQualitoSamplingSurfacePoint(id));
				dispatch(DetailStationAction.fetchIndustrialSite(id));
				dispatch(DetailStationAction.fetchPollutedSoil(id));
			};
		},
		fetchStation: function fetchStation(id) {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.station.getStation(id)).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							throw Error(_simpleReactI18n2.default.error.nonexistent);
						},
						404: function _() {
							throw Error(_simpleReactI18n2.default.error.notFound);
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(DetailStationAction.receiveStation(json, _DetailStationConstants.RECEIVE_DETAIL_STATION));
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				}).catch(function () {
					dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.error.errorLoadingData));
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
	
		fetchQualito: function fetchQualito(id) {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.qualito.getStation(id)).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(DetailStationAction.receiveStation(json, _DetailStationConstants.RECEIVE_DETAIL_QUALITO));
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				}).catch(function () {
					dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.error.errorLoadingData));
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
		receivePickupOperations: function receivePickupOperations(operations) {
			return {
				type: _DetailStationConstants.RECEIVE_DETAIL_PICKUP_OPERATION,
				pickupOperations: operations
			};
		},
		fetchPickupOperation: function fetchPickupOperation(qualitometerId) {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.qualito.getPickupOperation(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						idstation: qualitometerId
					})
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(DetailStationAction.receivePickupOperations(json));
					return json;
				}).then(function (jsonResult) {
					dispatch(_reactAquasys.WaitAction.waitStart());
					var analysis = jsonResult.map(function (pickupOperation) {
						dispatch(_reactAquasys.WaitAction.waitStart());
						return DetailStationAction.fetchAnalysis(pickupOperation.pickupid);
					});
					var analysisResult = (0, _lodash.flatten)(analysis);
					Promise.all(analysisResult).then(function (ana) {
						dispatch(_reactAquasys.WaitAction.waitStart());
						var resultAnalysis = (0, _lodash.flatten)(ana);
						dispatch(DetailStationAction.receiveAnalysis(resultAnalysis));
					});
				});
			};
		},
	
		receiveAnalysis: function receiveAnalysis(analysis) {
			return {
				type: _DetailStationConstants.ADD_QUALITOMETER_DETAIL_ANALYSIS,
				analysis: analysis
			};
		},
		fetchAnalysis: function fetchAnalysis(operationId) {
			return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.qualito.getAnalysis(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					idoperation: operationId
				})
			}).then(function (response) {
				return (0, _ActionUtils.checkStatus)({
					200: function _(rep) {
						return rep.json();
					},
					204: function _() {
						return [];
					}
				}, response);
			}).then(function () {
				var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
				if (!json.error) {
					return json;
				}
				return [];
			});
		},
	
		receivePiezometerMeasure: function receivePiezometerMeasure(measures) {
			return {
				type: _DetailStationConstants.RECEIVE_DETAIL_PIEZOMETER_MEASURE,
				measures: measures
			};
		},
		fetchPiezoMeasures: function fetchPiezoMeasures(piezometerId) {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.piezo.getPiezometerMeasure(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						piezometerid: piezometerId
					})
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					if (!json.error) {
						dispatch(DetailStationAction.receivePiezometerMeasure(json));
					}
					return [];
				});
			};
		},
		fetchPiezometerMeasureMax: function fetchPiezometerMeasureMax(id) {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.piezo.getPiezometerMeasureMax(id), {
					method: 'GET'
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							return [];
						},
						404: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(DetailStationAction.receiveMeasures(json, _DetailStationConstants.RECEIVE_DETAIL_PIEZOMETER_MEASURE_STATISTIC_MAX));
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				}).catch(function () {
					dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.error.errorLoadingData));
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
		fetchPiezometerMeasureMin: function fetchPiezometerMeasureMin(id) {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.piezo.getPiezometerMeasureMin(id), {
					method: 'GET'
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							return [];
						},
						404: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(DetailStationAction.receiveMeasures(json, _DetailStationConstants.RECEIVE_DETAIL_PIEZOMETER_MEASURE_STATISTIC_MIN));
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				}).catch(function () {
					dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.error.errorLoadingData));
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
		fetchPiezometerMeasureMoyenne: function fetchPiezometerMeasureMoyenne(id) {
			return function (dispatch) {
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.piezo.getPiezometerMeasureMoyenne(id), {
					method: 'GET'
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							return [];
						},
						404: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(DetailStationAction.receiveMeasures(json, _DetailStationConstants.RECEIVE_DETAIL_PIEZOMETER_MEASURE_STATISTIC_MOYENNE));
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				}).catch(function () {
					dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.error.errorLoadingData));
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
		fetchStationNetwork: function fetchStationNetwork(id) {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.station.getNetworks(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						idstation: id
					})
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							return [];
						},
						404: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(DetailStationAction.receiveNetworks(json));
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				}).catch(function () {
					dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.error.errorLoadingData));
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
		fetchQualitoSamplingSurfacePoint: function fetchQualitoSamplingSurfacePoint(id) {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.station.getSamplingSurfacePoints(id), {
					method: 'GET'
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							return [];
						},
						404: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(DetailStationAction.receiveSamplingSurfacePoint(json));
					return json;
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				}).catch(function () {
					dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.error.errorLoadingData));
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
	
		receivePollutedSoil: function receivePollutedSoil(pollutedSoil) {
			return {
				type: _DetailStationConstants.RECEIVE_DETAIL_POLLUTED_SOIL,
				pollutedSoil: pollutedSoil
			};
		},
	
		fetchPollutedSoil: function fetchPollutedSoil(id) {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.pollutedSoil.get(id), {
					method: 'GET'
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							return [];
						},
						404: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
					if (json && json.length > 0) {
						dispatch(DetailStationAction.receivePollutedSoil(json[0]));
						return json;
					}
					return null;
				}).then(function () {
					var jsonSampling = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					if (jsonSampling && jsonSampling.length > 0) {
						dispatch(DetailStationAction.fetchIcpeActivity());
					}
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				}).catch(function () {
					dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.error.errorLoadingData));
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
		receiveIcpeActivity: function receiveIcpeActivity(icpeActivity) {
			return {
				type: _DetailStationConstants.RECEIVE_ICPE_ACTIVITY,
				icpeActivity: icpeActivity
			};
		},
	
		fetchIcpeActivity: function fetchIcpeActivity() {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.referencial.getStandardCodification('ICPE_ACTIVITY'), {
					method: 'GET'
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							return [];
						},
						404: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(DetailStationAction.receiveIcpeActivity(json));
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				}).catch(function () {
					dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.error.errorLoadingData));
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
	
		receiveIndustrialSite: function receiveIndustrialSite(industrialSite) {
			return {
				type: _DetailStationConstants.RECEIVE_DETAIL_INDUSTRIAL,
				industrialSite: industrialSite
			};
		},
	
		fetchIndustrialSite: function fetchIndustrialSite(id) {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.industrialSite.get(id), {
					method: 'GET'
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							return [];
						},
						404: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
					if (json && json.length > 0) {
						dispatch(DetailStationAction.receiveIndustrialSite(json[0]));
						return json;
					}
					return null;
				}).then(function () {
					var jsonSampling = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					if (jsonSampling && jsonSampling.length > 0) {
						dispatch(DetailStationAction.fetchIndustrialSiteFamily());
						dispatch(DetailStationAction.fetchIndustrialSiteSeveso());
						dispatch(DetailStationAction.fetchIndustrialSiteActivity());
					}
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				}).catch(function () {
					dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.error.errorLoadingData));
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
		receiveIndustrialSiteFamily: function receiveIndustrialSiteFamily(industrialFamily) {
			return {
				type: _DetailStationConstants.RECEIVE_INDUSTRIAL_FAMILY,
				industrialFamily: industrialFamily
			};
		},
	
		fetchIndustrialSiteFamily: function fetchIndustrialSiteFamily() {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.referencial.getStandardCodification('INDUSTRIAL_FAMILY'), {
					method: 'GET'
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							return [];
						},
						404: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(DetailStationAction.receiveIndustrialSiteFamily(json));
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				}).catch(function () {
					dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.error.errorLoadingData));
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
	
		receiveIndustrialSiteSeveso: function receiveIndustrialSiteSeveso(industrialSeveso) {
			return {
				type: _DetailStationConstants.RECEIVE_INDUSTRIAL_SEVESO,
				industrialSeveso: industrialSeveso
			};
		},
	
		fetchIndustrialSiteSeveso: function fetchIndustrialSiteSeveso() {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.referencial.getStandardCodification('INDUSTRIAL_SEVESO'), {
					method: 'GET'
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							return [];
						},
						404: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(DetailStationAction.receiveIndustrialSiteSeveso(json));
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				}).catch(function () {
					dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.error.errorLoadingData));
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
	
		receiveIndustrialSiteActivity: function receiveIndustrialSiteActivity(industrialActivity) {
			return {
				type: _DetailStationConstants.RECEIVE_INDUSTRIAL_ACTIVITY,
				industrialActivity: industrialActivity
			};
		},
	
		fetchIndustrialSiteActivity: function fetchIndustrialSiteActivity() {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.referencial.getStandardCodification('INDUSTRIAL_ACTIVITY'), {
					method: 'GET'
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							return [];
						},
						404: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(DetailStationAction.receiveIndustrialSiteActivity(json));
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				}).catch(function () {
					dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.error.errorLoadingData));
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
	
		exportStation: function exportStation(id) {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.station.exportStation(id), {
					method: 'GET',
					headers: { authorization: btoa('Basic ' + atob(sessionStorage.getItem('TOKEN'))) }
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.blob();
						}
					}, response);
				}).then(function (blob) {
					(0, _downloadjs2.default)(blob, 'station_' + id + '.zip', blob.type);
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				}).catch(function () {
					dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.error.errorLoadingData));
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
	
		synchroniseAdesSites: function synchroniseAdesSites(id, code) {
			return function (dispatch) {
				var body = JSON.stringify({
					code: code
				});
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.webService.ades(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: body
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					dispatch(DetailStationAction.fetchDetailSation(id));
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				}).catch(function () {
					dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.error.errorLoadingData));
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
		reset: function reset() {
			return {
				type: _DetailStationConstants.DETAIL_STATION_RESET
			};
		}
	};
	
	exports.default = DetailStationAction;

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Map = __webpack_require__(289);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _OSM = __webpack_require__(290);
	
	var _OSM2 = _interopRequireDefault(_OSM);
	
	var _DtoDetailStation = __webpack_require__(227);
	
	var _DtoDetailStation2 = _interopRequireDefault(_DtoDetailStation);
	
	var _SiteTypes = __webpack_require__(56);
	
	var _SiteTypes2 = _interopRequireDefault(_SiteTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _DtoDetailStationSamplingSurfacePoint = __webpack_require__(286);
	
	var _DtoDetailStationSamplingSurfacePoint2 = _interopRequireDefault(_DtoDetailStationSamplingSurfacePoint);
	
	var _SingleStationPoint = __webpack_require__(548);
	
	var _SingleStationPoint2 = _interopRequireDefault(_SingleStationPoint);
	
	var _SitesPoint = __webpack_require__(549);
	
	var _SitesPoint2 = _interopRequireDefault(_SitesPoint);
	
	var _PopupFactory = __webpack_require__(547);
	
	var _PopupFactory2 = _interopRequireDefault(_PopupFactory);
	
	var _lodash = __webpack_require__(15);
	
	var _DtoSupport = __webpack_require__(150);
	
	var _DtoSupport2 = _interopRequireDefault(_DtoSupport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapDetailStationPanel = function (_Component) {
		_inherits(MapDetailStationPanel, _Component);
	
		function MapDetailStationPanel(props) {
			_classCallCheck(this, MapDetailStationPanel);
	
			var _this = _possibleConstructorReturn(this, (MapDetailStationPanel.__proto__ || Object.getPrototypeOf(MapDetailStationPanel)).call(this, props));
	
			_this.getData = function () {
				if (_this.props.station && _this.props.station.natureStation) {
					var layersGroup1 = [(0, _OSM2.default)(), (0, _SingleStationPoint2.default)({
						site: _this.props.station,
						type: _this.props.station.natureStation.length > 0 ? _SiteTypes2.default[_this.props.station.natureStation[0]] : _SiteTypes2.default.QUALITOMETER
					})];
	
					var data = _this.props.samplingSurfacePoints.map(function (samplingSurfacePoints) {
						var support = samplingSurfacePoints.supportCode ? (0, _lodash.find)(_this.props.supports, function (o) {
							return o.id == samplingSurfacePoints.supportCode;
						}) : null;
						if (support) {
							return Object.assign({}, samplingSurfacePoints, {
								name: support.name + ' [' + samplingSurfacePoints.supportCode + ']'
							});
						}
						return samplingSurfacePoints;
					});
	
					var saplingSurfacePoints = function () {
						return (0, _SitesPoint2.default)({
							site: data,
							type: _SiteTypes2.default.SAMPLING_SURFACE_POINT,
							popup: _PopupFactory2.default.popupSamplingSurfacePoint
						});
					}();
	
					var mapConf = {
						size: _this.props.height,
						center: [_this.props.station.site.localization.xCoordinate, _this.props.station.site.localization.yCoordinate],
						zoom: 18
					};
					var layers = layersGroup1.concat(saplingSurfacePoints);
					return [mapConf, layers];
				}
				return ['', ''];
			};
	
			_this.state = {
				popupFilter: ['Point']
			};
			return _this;
		}
	
		_createClass(MapDetailStationPanel, [{
			key: 'render',
			value: function render() {
				var data = this.getData();
				var popupProps = {
					filters: this.state.popupFilter
				};
				return _react2.default.createElement(
					'div',
					{ className: 'col s12 no-padding' },
					_react2.default.createElement(_Map2.default, { mapConf: data[0], layers: data[1], popupProps: popupProps })
				);
			}
		}]);
	
		return MapDetailStationPanel;
	}(_react.Component);
	
	MapDetailStationPanel.propTypes = {
		station: _propTypes2.default.instanceOf(_DtoDetailStation2.default),
		samplingSurfacePoints: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoDetailStationSamplingSurfacePoint2.default)),
		supports: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoSupport2.default)),
		height: _propTypes2.default.number
	};
	
	MapDetailStationPanel.defaultProps = {
		height: 250
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			station: store.DetailStationReducer.station,
			samplingSurfacePoints: store.DetailStationReducer.samplingSurfacePoints,
			supports: store.ReferentialReducer.supports
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(MapDetailStationPanel);

/***/ },
/* 542 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
		RECEIVE_DETAIL_STATION: 'RECEIVE_DETAIL_STATION',
		RECEIVE_DETAIL_QUALITO: 'RECEIVE_DETAIL_QUALITO',
		RECEIVE_DETAIL_PICKUP_OPERATION: 'RECEIVE_DETAIL_PICKUP_OPERATION',
		RECEIVE_DETAIL_PIEZOMETER_MEASURE: 'RECEIVE_DETAIL_PIEZOMETER_MEASURE',
		RECEIVE_DETAIL_PIEZOMETER_MEASURE_STATISTIC_MAX: 'RECEIVE_DETAIL_PIEZOMETER_MEASURE_STATISTIC_MAX',
		RECEIVE_DETAIL_PIEZOMETER_MEASURE_STATISTIC_MIN: 'RECEIVE_DETAIL_PIEZOMETER_MEASURE_STATISTIC_MIN',
		RECEIVE_DETAIL_PIEZOMETER_MEASURE_STATISTIC_MOYENNE: 'RECEIVE_DETAIL_PIEZOMETER_MEASURE_STATISTIC_MOYENNE',
		RECEIVE_DETAIL_STATION_NETWORK: 'RECEIVE_DETAIL_STATION_NETWORK',
		RECEIVE_DETAIL_QUALITO_SAMPLING_SURFACE_POINT: 'RECEIVE_DETAIL_QUALITO_SAMPLING_SURFACE_POINT',
		ADD_QUALITOMETER_DETAIL_ANALYSIS: 'ADD_QUALITOMETER_DETAIL_ANALYSIS',
		DETAIL_STATION_RESET: 'DETAIL_STATION_RESET',
		RECEIVE_INDUSTRIAL_SEVESO: 'RECEIVE_INDUSTRIAL_SEVESO',
		RECEIVE_INDUSTRIAL_ACTIVITY: 'RECEIVE_INDUSTRIAL_ACTIVITY',
		RECEIVE_INDUSTRIAL_FAMILY: 'RECEIVE_INDUSTRIAL_FAMILY',
		RECEIVE_DETAIL_INDUSTRIAL: 'RECEIVE_DETAIL_INDUSTRIAL',
		RECEIVE_DETAIL_POLLUTED_SOIL: 'RECEIVE_DETAIL_POLLUTED_SOIL',
		RECEIVE_ICPE_ACTIVITY: 'RECEIVE_ICPE_ACTIVITY',
		PANEL_DASHBOARD: 'PANEL_DASHBOARD',
		PANEL_DETAIL: 'PANEL_DETAIL'
	};

/***/ },
/* 543 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.networkid;
		this.name = obj.label;
		this.code = obj.code;
		this.beginDate = obj.begindate;
		this.endDate = obj.enddate;
		this.mnemonique = obj.mnemonique;
		this.networkemprise = obj.networkemprise;
		this.networktype = obj.networktype;
	};
	
	exports.default = _class;

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.ApplicationUtil = undefined;
	
	var _reactGa = __webpack_require__(369);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ApplicationUtil = {
		sumbitRegister: function sumbitRegister(category, action, labelSubmit) {
			_reactGa2.default.event({
				category: category,
				action: action,
				label: labelSubmit
			});
		},
		getUserId: function getUserId(login) {
			var idUser = parseInt(login, 36);
			return idUser;
		}
	};
	
	exports.ApplicationUtil = ApplicationUtil;

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.putAnalyticsCookieUser = exports.getPageViewAnalytics = exports.initCookieOption = exports.getAquaDBCookie = exports.getCookie = exports.purgeAquaDBCookies = exports.deleteCookie = exports.createCookie = exports.checkCookies = undefined;
	
	var _reactCookieConsent = __webpack_require__(989);
	
	var _CookieConstants = __webpack_require__(1058);
	
	var _DtoCookie = __webpack_require__(2212);
	
	var _DtoCookie2 = _interopRequireDefault(_DtoCookie);
	
	var _reactGa = __webpack_require__(369);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createCookie = function createCookie(key, value) {
		_reactCookieConsent.Cookies.set(key, value, { expires: Number(_CookieConstants.AQUADB_EXPIRE_DAYS) });
	};
	var deleteCookie = function deleteCookie(key) {
		_reactCookieConsent.Cookies.remove(key);
	};
	
	var getCookie = function getCookie(key) {
		return _reactCookieConsent.Cookies.get(key);
	};
	
	var purgeAquaDBCookies = function purgeAquaDBCookies() {
		deleteCookie(_CookieConstants.AQUADB_COOKIE);
	};
	
	var checkCookies = function checkCookies() {
		if (!getCookie(_CookieConstants.AQUADB_COOKIE)) {
			purgeAquaDBCookies();
			return true;
		}
		return false;
	};
	
	var getAquaDBCookie = function getAquaDBCookie() {
		var result = getCookie(_CookieConstants.AQUADB_COOKIE);
		if (result) {
			return new _DtoCookie2.default(JSON.parse(result));
		}
		return undefined;
	};
	
	var initCookieOption = function initCookieOption() {
		var aquadbCookie = getAquaDBCookie();
		if (aquadbCookie) {
			if (aquadbCookie.statisticsCookies) {
				_reactGa2.default.initialize('UA-90991121-1');
			}
		}
	};
	var putAnalyticsCookieUser = function putAnalyticsCookieUser(login) {
		var aquadbCookie = getAquaDBCookie();
		if (aquadbCookie) {
			if (aquadbCookie.statisticsCookies && login) {
				_reactGa2.default.set({ userId: login });
			}
		}
	};
	
	var getPageViewAnalytics = function getPageViewAnalytics(viewPageHash) {
		var aquadbCookie = getAquaDBCookie();
		if (aquadbCookie) {
			if (aquadbCookie.statisticsCookies) {
				_reactGa2.default.pageview(viewPageHash);
			}
		}
	};
	exports.checkCookies = checkCookies;
	exports.createCookie = createCookie;
	exports.deleteCookie = deleteCookie;
	exports.purgeAquaDBCookies = purgeAquaDBCookies;
	exports.getCookie = getCookie;
	exports.getAquaDBCookie = getAquaDBCookie;
	exports.initCookieOption = initCookieOption;
	exports.getPageViewAnalytics = getPageViewAnalytics;
	exports.putAnalyticsCookieUser = putAnalyticsCookieUser;

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _openlayers = __webpack_require__(110);
	
	var _openlayers2 = _interopRequireDefault(_openlayers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fillBlack = function fillBlack() {
		var fill = new _openlayers2.default.style.Fill({
			color: _openlayers2.default.color.asString('rgba(255,255,255,0.5)')
		});
		var stroke = new _openlayers2.default.style.Stroke({
			color: _openlayers2.default.color.asString('#000000'),
			width: 2
		});
		return [new _openlayers2.default.style.Style({
			fill: fill,
			stroke: stroke
		})];
	};
	
	var fillRed = function fillRed() {
		var fill = new _openlayers2.default.style.Fill({
			color: _openlayers2.default.color.asString('rgba(255,255,255,0.3)')
		});
		var stroke = new _openlayers2.default.style.Stroke({
			color: _openlayers2.default.color.asString('#ff0000'),
			width: 2
		});
		return [new _openlayers2.default.style.Style({
			fill: fill,
			stroke: stroke
		})];
	};
	var fillBlue = function fillBlue() {
		var fill = new _openlayers2.default.style.Fill({
			color: _openlayers2.default.color.asString('rgba(0, 0, 255,0.1)')
		});
		var stroke = new _openlayers2.default.style.Stroke({
			color: _openlayers2.default.color.asString('#0000ff'),
			width: 2
		});
		return [new _openlayers2.default.style.Style({
			fill: fill,
			stroke: stroke
		})];
	};
	
	exports.default = {
		FILL_RED: fillRed(),
		FILL_BLACK: fillBlack(),
		FILL_BLUE: fillBlue()
	};

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		popupStationPoint: {
			name: function name(layer) {
				return layer.type.name;
			},
			content: function content(layer, feature) {
				var station = layer.getUuid().find(function (el) {
					return el.uuid === feature.id;
				}).obj;
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'b',
						null,
						station.code,
						' '
					),
					':',
					_react2.default.createElement('br', null),
					feature.name
				);
			}
		},
		popupSitePoint: {
			name: function name(layer) {
				return layer.type.name;
			},
			content: function content(layer, feature) {
				var station = layer.getUuid().find(function (el) {
					return el.uuid === feature.id;
				}).obj;
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'b',
						null,
						station.code,
						' '
					),
					':',
					_react2.default.createElement('br', null),
					feature.name
				);
			}
		},
		popupSamplingSurfacePoint: {
			name: function name(layer) {
				return layer.type.name;
			},
			content: function content(layer, feature) {
				var station = layer.getUuid().find(function (el) {
					return el.uuid === feature.id;
				}).obj;
				return _react2.default.createElement(
					'div',
					null,
					'[',
					station.code,
					'] - ',
					feature.name
				);
			}
		},
		popupKmlCity: {
			name: function name(layer, feature) {
				return feature.NAME;
			},
			content: function content(layer, feature) {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'b',
						null,
						feature.NAME
					),
					_react2.default.createElement('br', null),
					'Code postal : ',
					feature.CODE_POSTAL,
					_react2.default.createElement('br', null),
					'Population : ',
					feature.POPULATION,
					_react2.default.createElement('br', null),
					'D\xE9partement : ',
					feature.NAME_DEPARTMENT,
					_react2.default.createElement('br', null)
				);
			}
		},
		popupKmlDepartments: {
			name: function name(layer, feature) {
				return feature.NAME;
			},
			content: function content(layer, feature) {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'b',
						null,
						feature.NAME
					),
					_react2.default.createElement('br', null),
					'Code : ',
					feature.CODE_DEPARTMENT,
					_react2.default.createElement('br', null),
					'D\xE9partement : ',
					feature.NAME_DEPARTMENT,
					_react2.default.createElement('br', null)
				);
			}
		},
		popupKmlWaterSheed: {
			name: function name(layer, feature) {
				return feature.CODE;
			},
			content: function content(layer, feature) {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'b',
						null,
						feature.CODE
					),
					_react2.default.createElement('br', null),
					'Nom : ',
					feature.NAME,
					_react2.default.createElement('br', null)
				);
			}
		},
		popupKmlManagementWater: {
			name: function name(layer, feature) {
				return feature.CODE;
			},
			content: function content(layer, feature) {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'b',
						null,
						feature.CODE
					),
					_react2.default.createElement('br', null),
					'Nom : ',
					feature.NAME,
					_react2.default.createElement('br', null)
				);
			}
		}
	};

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = SingleStationPoint;
	
	var _ILayers = __webpack_require__(229);
	
	var _ILayers2 = _interopRequireDefault(_ILayers);
	
	var _openlayers = __webpack_require__(110);
	
	var _openlayers2 = _interopRequireDefault(_openlayers);
	
	var _SiteTypes = __webpack_require__(56);
	
	var _SiteTypes2 = _interopRequireDefault(_SiteTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _SingleStationPoint = function (_Layers) {
		_inherits(_SingleStationPoint, _Layers);
	
		function _SingleStationPoint(obj) {
			_classCallCheck(this, _SingleStationPoint);
	
			var _this = _possibleConstructorReturn(this, (_SingleStationPoint.__proto__ || Object.getPrototypeOf(_SingleStationPoint)).call(this));
	
			_this.getStyle = function (point, type) {
				if (_this.hoverCoordinate) {
					var isHoverPoint = _this.hoverCoordinate.xCoordinate == point.xCoordinate && _this.hoverCoordinate.yCoordinate == point.yCoordinate;
					if (isHoverPoint) {
						return _SiteTypes2.default.createIconStyleHover(type.icon);
					}
					return type.img;
				}
				return type.img;
			};
	
			_this.type = obj.type;
			_this.objPoints = obj;
			_this.hoverCoordinate = obj.hoverCoordinate;
			_this.layer = _this.createLayer();
			return _this;
		}
	
		_createClass(_SingleStationPoint, [{
			key: 'createLayer',
			value: function createLayer() {
				var feature = this.createFeature(this.objPoints.site.xCoordinate, this.objPoints.site.yCoordinate, this.getStyle(this.objPoints.site, this.objPoints.type), this.objPoints.site.name, this.objPoints.site);
				var vectorSource = new _openlayers2.default.source.Vector({
					features: [feature]
				});
	
				return new _openlayers2.default.layer.Vector({
					source: vectorSource
				});
			}
		}, {
			key: 'getLayer',
			value: function getLayer() {
				return this.layer;
			}
		}, {
			key: 'createFeature',
			value: function createFeature(x, y, style, name, site) {
				var f = new _openlayers2.default.Feature({
					geometry: new _openlayers2.default.geom.Point(_openlayers2.default.proj.transform([+x, +y], 'EPSG:4326', 'EPSG:3857')),
					name: name
				});
				f.setId(this.registerFeature(site));
				f.setStyle(style);
				return f;
			}
		}]);
	
		return _SingleStationPoint;
	}(_ILayers2.default);
	
	function SingleStationPoint() {
		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}
	
		return new (Function.prototype.bind.apply(_SingleStationPoint, [null].concat(args)))();
	}

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = SitesPoint;
	
	var _ILayers = __webpack_require__(229);
	
	var _ILayers2 = _interopRequireDefault(_ILayers);
	
	var _openlayers = __webpack_require__(110);
	
	var _openlayers2 = _interopRequireDefault(_openlayers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _SitesPoint = function (_Layers) {
		_inherits(_SitesPoint, _Layers);
	
		function _SitesPoint(obj) {
			_classCallCheck(this, _SitesPoint);
	
			var _this = _possibleConstructorReturn(this, (_SitesPoint.__proto__ || Object.getPrototypeOf(_SitesPoint)).call(this));
	
			_this.getStyle = function (point, type) {
				return type.img;
			};
	
			_this.type = obj.type;
			_this.objPoints = obj;
			_this.link = obj.link;
			_this.layer = _this.createLayer();
			return _this;
		}
	
		_createClass(_SitesPoint, [{
			key: 'createLayer',
			value: function createLayer() {
				var _this2 = this;
	
				var features = this.objPoints.site.map(function (point) {
					return _this2.createFeature(point.xCoordinate, point.yCoordinate, _this2.getStyle(point, _this2.objPoints.type), point.name, point);
				});
	
				var vectorSource = new _openlayers2.default.source.Vector({
					features: features
				});
	
				return new _openlayers2.default.layer.Vector({
					source: vectorSource,
					id: 'points',
					type: this.type
				});
			}
		}, {
			key: 'getLayer',
			value: function getLayer() {
				return this.layer;
			}
		}, {
			key: 'createFeature',
			value: function createFeature(x, y, style, name, site) {
				var f = new _openlayers2.default.Feature({
					geometry: new _openlayers2.default.geom.Point(_openlayers2.default.proj.transform([+x, +y], 'EPSG:4326', 'EPSG:3857')),
					name: name,
					code: site.code,
					link: this.link,
					id: site.id,
					type: this.type
				});
				f.setId(site.id);
				f.setStyle(style);
				return f;
			}
		}]);
	
		return _SitesPoint;
	}(_ILayers2.default);
	
	function SitesPoint() {
		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}
	
		return new (Function.prototype.bind.apply(_SitesPoint, [null].concat(args)))();
	}

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(51));
	
	var _config = _interopRequireDefault(__webpack_require__(1063));
	
	var _PropTypes = __webpack_require__(1064);
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(551));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * ---
	 *
	 * **Note**: `Transition` is a platform-agnostic base component. If you're using
	 * transitions in CSS, you'll probably want to use
	 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
	 * instead. It inherits all the features of `Transition`, but contains
	 * additional features necessary to play nice with CSS transitions (hence the
	 * name of the component).
	 *
	 * ---
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the
	 * components. It's up to you to give meaning and effect to those states. For
	 * example we can add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import { Transition } from 'react-transition-group';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 1 },
	 *   entered:  { opacity: 1 },
	 *   exiting:  { opacity: 0 },
	 *   exited:  { opacity: 0 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {state => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component
	 * begins the "Enter" stage. During this stage, the component will shift from
	 * its current transition state, to `'entering'` for the duration of the
	 * transition and then to the `'entered'` stage once it's complete. Let's take
	 * the following example (we'll use the
	 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <Transition in={inProp} timeout={500}>
	 *         {state => (
	 *           // ...
	 *         )}
	 *       </Transition>
	 *       <button onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state
	 * and stay there for 500ms (the value of `timeout`) before it finally switches
	 * to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from
	 * `'exiting'` to `'exited'`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  } // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	  ;
	
	  var _proto = Transition.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter; // TODO: remove fallback for next major
	
	      appear = timeout.appear !== undefined ? timeout.appear : enter;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(mounting);
	      } else {
	        this.performExit();
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context ? this.context.isMounting : mounting;
	
	    var _ref2 = this.props.nodeRef ? [appearing] : [_reactDom.default.findDOMNode(this), appearing],
	        maybeNode = _ref2[0],
	        maybeAppearing = _ref2[1];
	
	    var timeouts = this.getTimeouts();
	    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter || _config.default.disabled) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(maybeNode);
	      });
	      return;
	    }
	
	    this.props.onEnter(maybeNode, maybeAppearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(maybeNode, maybeAppearing);
	
	      _this2.onTransitionEnd(enterTimeout, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(maybeNode, maybeAppearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit() {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts();
	    var maybeNode = this.props.nodeRef ? undefined : _reactDom.default.findDOMNode(this); // no exit animation skip right to EXITED
	
	    if (!exit || _config.default.disabled) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(maybeNode);
	      });
	      return;
	    }
	
	    this.props.onExit(maybeNode);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(maybeNode);
	
	      _this3.onTransitionEnd(timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(maybeNode);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
	    this.setNextCallback(handler);
	    var node = this.props.nodeRef ? this.props.nodeRef.current : _reactDom.default.findDOMNode(this);
	    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
	
	    if (!node || doesNotHaveTimeoutOrListener) {
	      setTimeout(this.nextCallback, 0);
	      return;
	    }
	
	    if (this.props.addEndListener) {
	      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
	          maybeNode = _ref3[0],
	          maybeNextCallback = _ref3[1];
	
	      this.props.addEndListener(maybeNode, maybeNextCallback);
	    }
	
	    if (timeout != null) {
	      setTimeout(this.nextCallback, timeout);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        _in = _this$props.in,
	        _mountOnEnter = _this$props.mountOnEnter,
	        _unmountOnExit = _this$props.unmountOnExit,
	        _appear = _this$props.appear,
	        _enter = _this$props.enter,
	        _exit = _this$props.exit,
	        _timeout = _this$props.timeout,
	        _addEndListener = _this$props.addEndListener,
	        _onEnter = _this$props.onEnter,
	        _onEntering = _this$props.onEntering,
	        _onEntered = _this$props.onEntered,
	        _onExit = _this$props.onExit,
	        _onExiting = _this$props.onExiting,
	        _onExited = _this$props.onExited,
	        _nodeRef = _this$props.nodeRef,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
	
	    return (
	      /*#__PURE__*/
	      // allows for nested Transitions
	      _react.default.createElement(_TransitionGroupContext.default.Provider, {
	        value: null
	      }, typeof children === 'function' ? children(status, childProps) : _react.default.cloneElement(_react.default.Children.only(children), childProps))
	    );
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextType = _TransitionGroupContext.default;
	Transition.propTypes =  false ? {
	  /**
	   * A React reference to DOM element that need to transition:
	   * https://stackoverflow.com/a/51127130/4671932
	   *
	   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
	   *      (e.g. `onEnter`) because user already has direct access to the node.
	   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
	   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
	   *     (see
	   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
	   */
	  nodeRef: _propTypes.default.shape({
	    current: typeof Element === 'undefined' ? _propTypes.default.any : _propTypes.default.instanceOf(Element)
	  }),
	
	  /**
	   * A `function` child can be used instead of a React element. This function is
	   * called with the current transition status (`'entering'`, `'entered'`,
	   * `'exiting'`, `'exited'`), which can be used to apply context
	   * specific props to a component.
	   *
	   * ```jsx
	   * <Transition in={this.state.in} timeout={150}>
	   *   {state => (
	   *     <MyComponent className={`fade fade-${state}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: _propTypes.default.oneOfType([_propTypes.default.func.isRequired, _propTypes.default.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: _propTypes.default.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: _propTypes.default.bool,
	
	  /**
	   * By default the child component does not perform the enter transition when
	   * it first mounts, regardless of the value of `in`. If you want this
	   * behavior, set both `appear` and `in` to `true`.
	   *
	   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
	   * > only adds an additional enter transition. However, in the
	   * > `<CSSTransition>` component that first enter transition does result in
	   * > additional `.appear-*` classes, that way you can choose to style it
	   * > differently.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided.
	   *
	   * You may specify a single timeout for all transitions:
	   *
	   * ```jsx
	   * timeout={500}
	   * ```
	   *
	   * or individually:
	   *
	   * ```jsx
	   * timeout={{
	   *  appear: 500,
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * - `appear` defaults to the value of `enter`
	   * - `enter` defaults to `0`
	   * - `exit` defaults to `0`
	   *
	   * @type {number | { enter?: number, exit?: number, appear?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. Timeouts are still used as a fallback if provided.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: _propTypes.default.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: _propTypes.default.func
	} : {}; // Name the function so it is clearer in the documentation
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = UNMOUNTED;
	Transition.EXITED = EXITED;
	Transition.ENTERING = ENTERING;
	Transition.ENTERED = ENTERED;
	Transition.EXITING = EXITING;
	var _default = Transition;
	exports.default = _default;

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = _react.default.createContext(null);
	
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(126);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(2266);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(552);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(2253);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(2252);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(2251);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(1067);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(1068);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ },
/* 555 */
/***/ function(module, exports) {

	// https://github.com/mziccard/node-timsort
	var DEFAULT_MIN_MERGE = 32;
	var DEFAULT_MIN_GALLOPING = 7;
	var DEFAULT_TMP_STORAGE_LENGTH = 256;
	
	function minRunLength(n) {
	  var r = 0;
	
	  while (n >= DEFAULT_MIN_MERGE) {
	    r |= n & 1;
	    n >>= 1;
	  }
	
	  return n + r;
	}
	
	function makeAscendingRun(array, lo, hi, compare) {
	  var runHi = lo + 1;
	
	  if (runHi === hi) {
	    return 1;
	  }
	
	  if (compare(array[runHi++], array[lo]) < 0) {
	    while (runHi < hi && compare(array[runHi], array[runHi - 1]) < 0) {
	      runHi++;
	    }
	
	    reverseRun(array, lo, runHi);
	  } else {
	    while (runHi < hi && compare(array[runHi], array[runHi - 1]) >= 0) {
	      runHi++;
	    }
	  }
	
	  return runHi - lo;
	}
	
	function reverseRun(array, lo, hi) {
	  hi--;
	
	  while (lo < hi) {
	    var t = array[lo];
	    array[lo++] = array[hi];
	    array[hi--] = t;
	  }
	}
	
	function binaryInsertionSort(array, lo, hi, start, compare) {
	  if (start === lo) {
	    start++;
	  }
	
	  for (; start < hi; start++) {
	    var pivot = array[start];
	    var left = lo;
	    var right = start;
	    var mid;
	
	    while (left < right) {
	      mid = left + right >>> 1;
	
	      if (compare(pivot, array[mid]) < 0) {
	        right = mid;
	      } else {
	        left = mid + 1;
	      }
	    }
	
	    var n = start - left;
	
	    switch (n) {
	      case 3:
	        array[left + 3] = array[left + 2];
	
	      case 2:
	        array[left + 2] = array[left + 1];
	
	      case 1:
	        array[left + 1] = array[left];
	        break;
	
	      default:
	        while (n > 0) {
	          array[left + n] = array[left + n - 1];
	          n--;
	        }
	
	    }
	
	    array[left] = pivot;
	  }
	}
	
	function gallopLeft(value, array, start, length, hint, compare) {
	  var lastOffset = 0;
	  var maxOffset = 0;
	  var offset = 1;
	
	  if (compare(value, array[start + hint]) > 0) {
	    maxOffset = length - hint;
	
	    while (offset < maxOffset && compare(value, array[start + hint + offset]) > 0) {
	      lastOffset = offset;
	      offset = (offset << 1) + 1;
	
	      if (offset <= 0) {
	        offset = maxOffset;
	      }
	    }
	
	    if (offset > maxOffset) {
	      offset = maxOffset;
	    }
	
	    lastOffset += hint;
	    offset += hint;
	  } else {
	    maxOffset = hint + 1;
	
	    while (offset < maxOffset && compare(value, array[start + hint - offset]) <= 0) {
	      lastOffset = offset;
	      offset = (offset << 1) + 1;
	
	      if (offset <= 0) {
	        offset = maxOffset;
	      }
	    }
	
	    if (offset > maxOffset) {
	      offset = maxOffset;
	    }
	
	    var tmp = lastOffset;
	    lastOffset = hint - offset;
	    offset = hint - tmp;
	  }
	
	  lastOffset++;
	
	  while (lastOffset < offset) {
	    var m = lastOffset + (offset - lastOffset >>> 1);
	
	    if (compare(value, array[start + m]) > 0) {
	      lastOffset = m + 1;
	    } else {
	      offset = m;
	    }
	  }
	
	  return offset;
	}
	
	function gallopRight(value, array, start, length, hint, compare) {
	  var lastOffset = 0;
	  var maxOffset = 0;
	  var offset = 1;
	
	  if (compare(value, array[start + hint]) < 0) {
	    maxOffset = hint + 1;
	
	    while (offset < maxOffset && compare(value, array[start + hint - offset]) < 0) {
	      lastOffset = offset;
	      offset = (offset << 1) + 1;
	
	      if (offset <= 0) {
	        offset = maxOffset;
	      }
	    }
	
	    if (offset > maxOffset) {
	      offset = maxOffset;
	    }
	
	    var tmp = lastOffset;
	    lastOffset = hint - offset;
	    offset = hint - tmp;
	  } else {
	    maxOffset = length - hint;
	
	    while (offset < maxOffset && compare(value, array[start + hint + offset]) >= 0) {
	      lastOffset = offset;
	      offset = (offset << 1) + 1;
	
	      if (offset <= 0) {
	        offset = maxOffset;
	      }
	    }
	
	    if (offset > maxOffset) {
	      offset = maxOffset;
	    }
	
	    lastOffset += hint;
	    offset += hint;
	  }
	
	  lastOffset++;
	
	  while (lastOffset < offset) {
	    var m = lastOffset + (offset - lastOffset >>> 1);
	
	    if (compare(value, array[start + m]) < 0) {
	      offset = m;
	    } else {
	      lastOffset = m + 1;
	    }
	  }
	
	  return offset;
	}
	
	function TimSort(array, compare) {
	  var minGallop = DEFAULT_MIN_GALLOPING;
	  var length = 0;
	  var tmpStorageLength = DEFAULT_TMP_STORAGE_LENGTH;
	  var stackLength = 0;
	  var runStart;
	  var runLength;
	  var stackSize = 0;
	  length = array.length;
	
	  if (length < 2 * DEFAULT_TMP_STORAGE_LENGTH) {
	    tmpStorageLength = length >>> 1;
	  }
	
	  var tmp = [];
	  stackLength = length < 120 ? 5 : length < 1542 ? 10 : length < 119151 ? 19 : 40;
	  runStart = [];
	  runLength = [];
	
	  function pushRun(_runStart, _runLength) {
	    runStart[stackSize] = _runStart;
	    runLength[stackSize] = _runLength;
	    stackSize += 1;
	  }
	
	  function mergeRuns() {
	    while (stackSize > 1) {
	      var n = stackSize - 2;
	
	      if (n >= 1 && runLength[n - 1] <= runLength[n] + runLength[n + 1] || n >= 2 && runLength[n - 2] <= runLength[n] + runLength[n - 1]) {
	        if (runLength[n - 1] < runLength[n + 1]) {
	          n--;
	        }
	      } else if (runLength[n] > runLength[n + 1]) {
	        break;
	      }
	
	      mergeAt(n);
	    }
	  }
	
	  function forceMergeRuns() {
	    while (stackSize > 1) {
	      var n = stackSize - 2;
	
	      if (n > 0 && runLength[n - 1] < runLength[n + 1]) {
	        n--;
	      }
	
	      mergeAt(n);
	    }
	  }
	
	  function mergeAt(i) {
	    var start1 = runStart[i];
	    var length1 = runLength[i];
	    var start2 = runStart[i + 1];
	    var length2 = runLength[i + 1];
	    runLength[i] = length1 + length2;
	
	    if (i === stackSize - 3) {
	      runStart[i + 1] = runStart[i + 2];
	      runLength[i + 1] = runLength[i + 2];
	    }
	
	    stackSize--;
	    var k = gallopRight(array[start2], array, start1, length1, 0, compare);
	    start1 += k;
	    length1 -= k;
	
	    if (length1 === 0) {
	      return;
	    }
	
	    length2 = gallopLeft(array[start1 + length1 - 1], array, start2, length2, length2 - 1, compare);
	
	    if (length2 === 0) {
	      return;
	    }
	
	    if (length1 <= length2) {
	      mergeLow(start1, length1, start2, length2);
	    } else {
	      mergeHigh(start1, length1, start2, length2);
	    }
	  }
	
	  function mergeLow(start1, length1, start2, length2) {
	    var i = 0;
	
	    for (i = 0; i < length1; i++) {
	      tmp[i] = array[start1 + i];
	    }
	
	    var cursor1 = 0;
	    var cursor2 = start2;
	    var dest = start1;
	    array[dest++] = array[cursor2++];
	
	    if (--length2 === 0) {
	      for (i = 0; i < length1; i++) {
	        array[dest + i] = tmp[cursor1 + i];
	      }
	
	      return;
	    }
	
	    if (length1 === 1) {
	      for (i = 0; i < length2; i++) {
	        array[dest + i] = array[cursor2 + i];
	      }
	
	      array[dest + length2] = tmp[cursor1];
	      return;
	    }
	
	    var _minGallop = minGallop;
	    var count1;
	    var count2;
	    var exit;
	
	    while (1) {
	      count1 = 0;
	      count2 = 0;
	      exit = false;
	
	      do {
	        if (compare(array[cursor2], tmp[cursor1]) < 0) {
	          array[dest++] = array[cursor2++];
	          count2++;
	          count1 = 0;
	
	          if (--length2 === 0) {
	            exit = true;
	            break;
	          }
	        } else {
	          array[dest++] = tmp[cursor1++];
	          count1++;
	          count2 = 0;
	
	          if (--length1 === 1) {
	            exit = true;
	            break;
	          }
	        }
	      } while ((count1 | count2) < _minGallop);
	
	      if (exit) {
	        break;
	      }
	
	      do {
	        count1 = gallopRight(array[cursor2], tmp, cursor1, length1, 0, compare);
	
	        if (count1 !== 0) {
	          for (i = 0; i < count1; i++) {
	            array[dest + i] = tmp[cursor1 + i];
	          }
	
	          dest += count1;
	          cursor1 += count1;
	          length1 -= count1;
	
	          if (length1 <= 1) {
	            exit = true;
	            break;
	          }
	        }
	
	        array[dest++] = array[cursor2++];
	
	        if (--length2 === 0) {
	          exit = true;
	          break;
	        }
	
	        count2 = gallopLeft(tmp[cursor1], array, cursor2, length2, 0, compare);
	
	        if (count2 !== 0) {
	          for (i = 0; i < count2; i++) {
	            array[dest + i] = array[cursor2 + i];
	          }
	
	          dest += count2;
	          cursor2 += count2;
	          length2 -= count2;
	
	          if (length2 === 0) {
	            exit = true;
	            break;
	          }
	        }
	
	        array[dest++] = tmp[cursor1++];
	
	        if (--length1 === 1) {
	          exit = true;
	          break;
	        }
	
	        _minGallop--;
	      } while (count1 >= DEFAULT_MIN_GALLOPING || count2 >= DEFAULT_MIN_GALLOPING);
	
	      if (exit) {
	        break;
	      }
	
	      if (_minGallop < 0) {
	        _minGallop = 0;
	      }
	
	      _minGallop += 2;
	    }
	
	    minGallop = _minGallop;
	    minGallop < 1 && (minGallop = 1);
	
	    if (length1 === 1) {
	      for (i = 0; i < length2; i++) {
	        array[dest + i] = array[cursor2 + i];
	      }
	
	      array[dest + length2] = tmp[cursor1];
	    } else if (length1 === 0) {
	      throw new Error(); // throw new Error('mergeLow preconditions were not respected');
	    } else {
	      for (i = 0; i < length1; i++) {
	        array[dest + i] = tmp[cursor1 + i];
	      }
	    }
	  }
	
	  function mergeHigh(start1, length1, start2, length2) {
	    var i = 0;
	
	    for (i = 0; i < length2; i++) {
	      tmp[i] = array[start2 + i];
	    }
	
	    var cursor1 = start1 + length1 - 1;
	    var cursor2 = length2 - 1;
	    var dest = start2 + length2 - 1;
	    var customCursor = 0;
	    var customDest = 0;
	    array[dest--] = array[cursor1--];
	
	    if (--length1 === 0) {
	      customCursor = dest - (length2 - 1);
	
	      for (i = 0; i < length2; i++) {
	        array[customCursor + i] = tmp[i];
	      }
	
	      return;
	    }
	
	    if (length2 === 1) {
	      dest -= length1;
	      cursor1 -= length1;
	      customDest = dest + 1;
	      customCursor = cursor1 + 1;
	
	      for (i = length1 - 1; i >= 0; i--) {
	        array[customDest + i] = array[customCursor + i];
	      }
	
	      array[dest] = tmp[cursor2];
	      return;
	    }
	
	    var _minGallop = minGallop;
	
	    while (true) {
	      var count1 = 0;
	      var count2 = 0;
	      var exit = false;
	
	      do {
	        if (compare(tmp[cursor2], array[cursor1]) < 0) {
	          array[dest--] = array[cursor1--];
	          count1++;
	          count2 = 0;
	
	          if (--length1 === 0) {
	            exit = true;
	            break;
	          }
	        } else {
	          array[dest--] = tmp[cursor2--];
	          count2++;
	          count1 = 0;
	
	          if (--length2 === 1) {
	            exit = true;
	            break;
	          }
	        }
	      } while ((count1 | count2) < _minGallop);
	
	      if (exit) {
	        break;
	      }
	
	      do {
	        count1 = length1 - gallopRight(tmp[cursor2], array, start1, length1, length1 - 1, compare);
	
	        if (count1 !== 0) {
	          dest -= count1;
	          cursor1 -= count1;
	          length1 -= count1;
	          customDest = dest + 1;
	          customCursor = cursor1 + 1;
	
	          for (i = count1 - 1; i >= 0; i--) {
	            array[customDest + i] = array[customCursor + i];
	          }
	
	          if (length1 === 0) {
	            exit = true;
	            break;
	          }
	        }
	
	        array[dest--] = tmp[cursor2--];
	
	        if (--length2 === 1) {
	          exit = true;
	          break;
	        }
	
	        count2 = length2 - gallopLeft(array[cursor1], tmp, 0, length2, length2 - 1, compare);
	
	        if (count2 !== 0) {
	          dest -= count2;
	          cursor2 -= count2;
	          length2 -= count2;
	          customDest = dest + 1;
	          customCursor = cursor2 + 1;
	
	          for (i = 0; i < count2; i++) {
	            array[customDest + i] = tmp[customCursor + i];
	          }
	
	          if (length2 <= 1) {
	            exit = true;
	            break;
	          }
	        }
	
	        array[dest--] = array[cursor1--];
	
	        if (--length1 === 0) {
	          exit = true;
	          break;
	        }
	
	        _minGallop--;
	      } while (count1 >= DEFAULT_MIN_GALLOPING || count2 >= DEFAULT_MIN_GALLOPING);
	
	      if (exit) {
	        break;
	      }
	
	      if (_minGallop < 0) {
	        _minGallop = 0;
	      }
	
	      _minGallop += 2;
	    }
	
	    minGallop = _minGallop;
	
	    if (minGallop < 1) {
	      minGallop = 1;
	    }
	
	    if (length2 === 1) {
	      dest -= length1;
	      cursor1 -= length1;
	      customDest = dest + 1;
	      customCursor = cursor1 + 1;
	
	      for (i = length1 - 1; i >= 0; i--) {
	        array[customDest + i] = array[customCursor + i];
	      }
	
	      array[dest] = tmp[cursor2];
	    } else if (length2 === 0) {
	      throw new Error(); // throw new Error('mergeHigh preconditions were not respected');
	    } else {
	      customCursor = dest - (length2 - 1);
	
	      for (i = 0; i < length2; i++) {
	        array[customCursor + i] = tmp[i];
	      }
	    }
	  }
	
	  this.mergeRuns = mergeRuns;
	  this.forceMergeRuns = forceMergeRuns;
	  this.pushRun = pushRun;
	}
	
	function sort(array, compare, lo, hi) {
	  if (!lo) {
	    lo = 0;
	  }
	
	  if (!hi) {
	    hi = array.length;
	  }
	
	  var remaining = hi - lo;
	
	  if (remaining < 2) {
	    return;
	  }
	
	  var runLength = 0;
	
	  if (remaining < DEFAULT_MIN_MERGE) {
	    runLength = makeAscendingRun(array, lo, hi, compare);
	    binaryInsertionSort(array, lo, hi, lo + runLength, compare);
	    return;
	  }
	
	  var ts = new TimSort(array, compare);
	  var minRun = minRunLength(remaining);
	
	  do {
	    runLength = makeAscendingRun(array, lo, hi, compare);
	
	    if (runLength < minRun) {
	      var force = remaining;
	
	      if (force > minRun) {
	        force = minRun;
	      }
	
	      binaryInsertionSort(array, lo, lo + force, lo + runLength, compare);
	      runLength = force;
	    }
	
	    ts.pushRun(lo, runLength);
	    ts.mergeRuns();
	    remaining -= runLength;
	    lo += runLength;
	  } while (remaining !== 0);
	
	  ts.forceMergeRuns();
	}
	
	module.exports = sort;

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	var _util = __webpack_require__(3);
	
	var inherits = _util.inherits;
	
	var Displayble = __webpack_require__(294);
	
	var BoundingRect = __webpack_require__(42);
	
	/**
	 * Displayable for incremental rendering. It will be rendered in a separate layer
	 * IncrementalDisplay have two main methods. `clearDisplayables` and `addDisplayables`
	 * addDisplayables will render the added displayables incremetally.
	 *
	 * It use a not clearFlag to tell the painter don't clear the layer if it's the first element.
	 */
	// TODO Style override ?
	function IncrementalDisplayble(opts) {
	  Displayble.call(this, opts);
	  this._displayables = [];
	  this._temporaryDisplayables = [];
	  this._cursor = 0;
	  this.notClear = true;
	}
	
	IncrementalDisplayble.prototype.incremental = true;
	
	IncrementalDisplayble.prototype.clearDisplaybles = function () {
	  this._displayables = [];
	  this._temporaryDisplayables = [];
	  this._cursor = 0;
	  this.dirty();
	  this.notClear = false;
	};
	
	IncrementalDisplayble.prototype.addDisplayable = function (displayable, notPersistent) {
	  if (notPersistent) {
	    this._temporaryDisplayables.push(displayable);
	  } else {
	    this._displayables.push(displayable);
	  }
	
	  this.dirty();
	};
	
	IncrementalDisplayble.prototype.addDisplayables = function (displayables, notPersistent) {
	  notPersistent = notPersistent || false;
	
	  for (var i = 0; i < displayables.length; i++) {
	    this.addDisplayable(displayables[i], notPersistent);
	  }
	};
	
	IncrementalDisplayble.prototype.eachPendingDisplayable = function (cb) {
	  for (var i = this._cursor; i < this._displayables.length; i++) {
	    cb && cb(this._displayables[i]);
	  }
	
	  for (var i = 0; i < this._temporaryDisplayables.length; i++) {
	    cb && cb(this._temporaryDisplayables[i]);
	  }
	};
	
	IncrementalDisplayble.prototype.update = function () {
	  this.updateTransform();
	
	  for (var i = this._cursor; i < this._displayables.length; i++) {
	    var displayable = this._displayables[i]; // PENDING
	
	    displayable.parent = this;
	    displayable.update();
	    displayable.parent = null;
	  }
	
	  for (var i = 0; i < this._temporaryDisplayables.length; i++) {
	    var displayable = this._temporaryDisplayables[i]; // PENDING
	
	    displayable.parent = this;
	    displayable.update();
	    displayable.parent = null;
	  }
	};
	
	IncrementalDisplayble.prototype.brush = function (ctx, prevEl) {
	  // Render persistant displayables.
	  for (var i = this._cursor; i < this._displayables.length; i++) {
	    var displayable = this._displayables[i];
	    displayable.beforeBrush && displayable.beforeBrush(ctx);
	    displayable.brush(ctx, i === this._cursor ? null : this._displayables[i - 1]);
	    displayable.afterBrush && displayable.afterBrush(ctx);
	  }
	
	  this._cursor = i; // Render temporary displayables.
	
	  for (var i = 0; i < this._temporaryDisplayables.length; i++) {
	    var displayable = this._temporaryDisplayables[i];
	    displayable.beforeBrush && displayable.beforeBrush(ctx);
	    displayable.brush(ctx, i === 0 ? null : this._temporaryDisplayables[i - 1]);
	    displayable.afterBrush && displayable.afterBrush(ctx);
	  }
	
	  this._temporaryDisplayables = [];
	  this.notClear = true;
	};
	
	var m = [];
	
	IncrementalDisplayble.prototype.getBoundingRect = function () {
	  if (!this._rect) {
	    var rect = new BoundingRect(Infinity, Infinity, -Infinity, -Infinity);
	
	    for (var i = 0; i < this._displayables.length; i++) {
	      var displayable = this._displayables[i];
	      var childRect = displayable.getBoundingRect().clone();
	
	      if (displayable.needLocalTransform()) {
	        childRect.applyTransform(displayable.getLocalTransform(m));
	      }
	
	      rect.union(childRect);
	    }
	
	    this._rect = rect;
	  }
	
	  return this._rect;
	};
	
	IncrementalDisplayble.prototype.contain = function (x, y) {
	  var localPos = this.transformCoordToLocal(x, y);
	  var rect = this.getBoundingRect();
	
	  if (rect.contain(localPos[0], localPos[1])) {
	    for (var i = 0; i < this._displayables.length; i++) {
	      var displayable = this._displayables[i];
	
	      if (displayable.contain(x, y)) {
	        return true;
	      }
	    }
	  }
	
	  return false;
	};
	
	inherits(IncrementalDisplayble, Displayble);
	var _default = IncrementalDisplayble;
	module.exports = _default;

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(3);
	
	var Gradient = __webpack_require__(386);
	
	/**
	 * x, y, x2, y2 are all percent from 0 to 1
	 * @param {number} [x=0]
	 * @param {number} [y=0]
	 * @param {number} [x2=1]
	 * @param {number} [y2=0]
	 * @param {Array.<Object>} colorStops
	 * @param {boolean} [globalCoord=false]
	 */
	var LinearGradient = function (x, y, x2, y2, colorStops, globalCoord) {
	  // Should do nothing more in this constructor. Because gradient can be
	  // declard by `color: {type: 'linear', colorStops: ...}`, where
	  // this constructor will not be called.
	  this.x = x == null ? 0 : x;
	  this.y = y == null ? 0 : y;
	  this.x2 = x2 == null ? 1 : x2;
	  this.y2 = y2 == null ? 0 : y2; // Can be cloned
	
	  this.type = 'linear'; // If use global coord
	
	  this.global = globalCoord || false;
	  Gradient.call(this, colorStops);
	};
	
	LinearGradient.prototype = {
	  constructor: LinearGradient
	};
	zrUtil.inherits(LinearGradient, Gradient);
	var _default = LinearGradient;
	module.exports = _default;

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	var fixShadow = __webpack_require__(1089);
	
	var _constant = __webpack_require__(387);
	
	var ContextCachedBy = _constant.ContextCachedBy;
	var STYLE_COMMON_PROPS = [['shadowBlur', 0], ['shadowOffsetX', 0], ['shadowOffsetY', 0], ['shadowColor', '#000'], ['lineCap', 'butt'], ['lineJoin', 'miter'], ['miterLimit', 10]]; // var SHADOW_PROPS = STYLE_COMMON_PROPS.slice(0, 4);
	// var LINE_PROPS = STYLE_COMMON_PROPS.slice(4);
	
	var Style = function (opts) {
	  this.extendFrom(opts, false);
	};
	
	function createLinearGradient(ctx, obj, rect) {
	  var x = obj.x == null ? 0 : obj.x;
	  var x2 = obj.x2 == null ? 1 : obj.x2;
	  var y = obj.y == null ? 0 : obj.y;
	  var y2 = obj.y2 == null ? 0 : obj.y2;
	
	  if (!obj.global) {
	    x = x * rect.width + rect.x;
	    x2 = x2 * rect.width + rect.x;
	    y = y * rect.height + rect.y;
	    y2 = y2 * rect.height + rect.y;
	  } // Fix NaN when rect is Infinity
	
	
	  x = isNaN(x) ? 0 : x;
	  x2 = isNaN(x2) ? 1 : x2;
	  y = isNaN(y) ? 0 : y;
	  y2 = isNaN(y2) ? 0 : y2;
	  var canvasGradient = ctx.createLinearGradient(x, y, x2, y2);
	  return canvasGradient;
	}
	
	function createRadialGradient(ctx, obj, rect) {
	  var width = rect.width;
	  var height = rect.height;
	  var min = Math.min(width, height);
	  var x = obj.x == null ? 0.5 : obj.x;
	  var y = obj.y == null ? 0.5 : obj.y;
	  var r = obj.r == null ? 0.5 : obj.r;
	
	  if (!obj.global) {
	    x = x * width + rect.x;
	    y = y * height + rect.y;
	    r = r * min;
	  }
	
	  var canvasGradient = ctx.createRadialGradient(x, y, 0, x, y, r);
	  return canvasGradient;
	}
	
	Style.prototype = {
	  constructor: Style,
	
	  /**
	   * @type {string}
	   */
	  fill: '#000',
	
	  /**
	   * @type {string}
	   */
	  stroke: null,
	
	  /**
	   * @type {number}
	   */
	  opacity: 1,
	
	  /**
	   * @type {number}
	   */
	  fillOpacity: null,
	
	  /**
	   * @type {number}
	   */
	  strokeOpacity: null,
	
	  /**
	   * `true` is not supported.
	   * `false`/`null`/`undefined` are the same.
	   * `false` is used to remove lineDash in some
	   * case that `null`/`undefined` can not be set.
	   * (e.g., emphasis.lineStyle in echarts)
	   * @type {Array.<number>|boolean}
	   */
	  lineDash: null,
	
	  /**
	   * @type {number}
	   */
	  lineDashOffset: 0,
	
	  /**
	   * @type {number}
	   */
	  shadowBlur: 0,
	
	  /**
	   * @type {number}
	   */
	  shadowOffsetX: 0,
	
	  /**
	   * @type {number}
	   */
	  shadowOffsetY: 0,
	
	  /**
	   * @type {number}
	   */
	  lineWidth: 1,
	
	  /**
	   * If stroke ignore scale
	   * @type {Boolean}
	   */
	  strokeNoScale: false,
	  // Bounding rect text configuration
	  // Not affected by element transform
	
	  /**
	   * @type {string}
	   */
	  text: null,
	
	  /**
	   * If `fontSize` or `fontFamily` exists, `font` will be reset by
	   * `fontSize`, `fontStyle`, `fontWeight`, `fontFamily`.
	   * So do not visit it directly in upper application (like echarts),
	   * but use `contain/text#makeFont` instead.
	   * @type {string}
	   */
	  font: null,
	
	  /**
	   * The same as font. Use font please.
	   * @deprecated
	   * @type {string}
	   */
	  textFont: null,
	
	  /**
	   * It helps merging respectively, rather than parsing an entire font string.
	   * @type {string}
	   */
	  fontStyle: null,
	
	  /**
	   * It helps merging respectively, rather than parsing an entire font string.
	   * @type {string}
	   */
	  fontWeight: null,
	
	  /**
	   * It helps merging respectively, rather than parsing an entire font string.
	   * Should be 12 but not '12px'.
	   * @type {number}
	   */
	  fontSize: null,
	
	  /**
	   * It helps merging respectively, rather than parsing an entire font string.
	   * @type {string}
	   */
	  fontFamily: null,
	
	  /**
	   * Reserved for special functinality, like 'hr'.
	   * @type {string}
	   */
	  textTag: null,
	
	  /**
	   * @type {string}
	   */
	  textFill: '#000',
	
	  /**
	   * @type {string}
	   */
	  textStroke: null,
	
	  /**
	   * @type {number}
	   */
	  textWidth: null,
	
	  /**
	   * Only for textBackground.
	   * @type {number}
	   */
	  textHeight: null,
	
	  /**
	   * textStroke may be set as some color as a default
	   * value in upper applicaion, where the default value
	   * of textStrokeWidth should be 0 to make sure that
	   * user can choose to do not use text stroke.
	   * @type {number}
	   */
	  textStrokeWidth: 0,
	
	  /**
	   * @type {number}
	   */
	  textLineHeight: null,
	
	  /**
	   * 'inside', 'left', 'right', 'top', 'bottom'
	   * [x, y]
	   * Based on x, y of rect.
	   * @type {string|Array.<number>}
	   * @default 'inside'
	   */
	  textPosition: 'inside',
	
	  /**
	   * If not specified, use the boundingRect of a `displayable`.
	   * @type {Object}
	   */
	  textRect: null,
	
	  /**
	   * [x, y]
	   * @type {Array.<number>}
	   */
	  textOffset: null,
	
	  /**
	   * @type {string}
	   */
	  textAlign: null,
	
	  /**
	   * @type {string}
	   */
	  textVerticalAlign: null,
	
	  /**
	   * @type {number}
	   */
	  textDistance: 5,
	
	  /**
	   * @type {string}
	   */
	  textShadowColor: 'transparent',
	
	  /**
	   * @type {number}
	   */
	  textShadowBlur: 0,
	
	  /**
	   * @type {number}
	   */
	  textShadowOffsetX: 0,
	
	  /**
	   * @type {number}
	   */
	  textShadowOffsetY: 0,
	
	  /**
	   * @type {string}
	   */
	  textBoxShadowColor: 'transparent',
	
	  /**
	   * @type {number}
	   */
	  textBoxShadowBlur: 0,
	
	  /**
	   * @type {number}
	   */
	  textBoxShadowOffsetX: 0,
	
	  /**
	   * @type {number}
	   */
	  textBoxShadowOffsetY: 0,
	
	  /**
	   * Whether transform text.
	   * Only available in Path and Image element,
	   * where the text is called as `RectText`.
	   * @type {boolean}
	   */
	  transformText: false,
	
	  /**
	   * Text rotate around position of Path or Image.
	   * The origin of the rotation can be specified by `textOrigin`.
	   * Only available in Path and Image element,
	   * where the text is called as `RectText`.
	   */
	  textRotation: 0,
	
	  /**
	   * Text origin of text rotation.
	   * Useful in the case like label rotation of circular symbol.
	   * Only available in Path and Image element, where the text is called
	   * as `RectText` and the element is called as "host element".
	   * The value can be:
	   * + If specified as a coordinate like `[10, 40]`, it is the `[x, y]`
	   * base on the left-top corner of the rect of its host element.
	   * + If specified as a string `center`, it is the center of the rect of
	   * its host element.
	   * + By default, this origin is the `textPosition`.
	   * @type {string|Array.<number>}
	   */
	  textOrigin: null,
	
	  /**
	   * @type {string}
	   */
	  textBackgroundColor: null,
	
	  /**
	   * @type {string}
	   */
	  textBorderColor: null,
	
	  /**
	   * @type {number}
	   */
	  textBorderWidth: 0,
	
	  /**
	   * @type {number}
	   */
	  textBorderRadius: 0,
	
	  /**
	   * Can be `2` or `[2, 4]` or `[2, 3, 4, 5]`
	   * @type {number|Array.<number>}
	   */
	  textPadding: null,
	
	  /**
	   * Text styles for rich text.
	   * @type {Object}
	   */
	  rich: null,
	
	  /**
	   * {outerWidth, outerHeight, ellipsis, placeholder}
	   * @type {Object}
	   */
	  truncate: null,
	
	  /**
	   * https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
	   * @type {string}
	   */
	  blend: null,
	
	  /**
	   * @param {CanvasRenderingContext2D} ctx
	   */
	  bind: function (ctx, el, prevEl) {
	    var style = this;
	    var prevStyle = prevEl && prevEl.style; // If no prevStyle, it means first draw.
	    // Only apply cache if the last time cachced by this function.
	
	    var notCheckCache = !prevStyle || ctx.__attrCachedBy !== ContextCachedBy.STYLE_BIND;
	    ctx.__attrCachedBy = ContextCachedBy.STYLE_BIND;
	
	    for (var i = 0; i < STYLE_COMMON_PROPS.length; i++) {
	      var prop = STYLE_COMMON_PROPS[i];
	      var styleName = prop[0];
	
	      if (notCheckCache || style[styleName] !== prevStyle[styleName]) {
	        // FIXME Invalid property value will cause style leak from previous element.
	        ctx[styleName] = fixShadow(ctx, styleName, style[styleName] || prop[1]);
	      }
	    }
	
	    if (notCheckCache || style.fill !== prevStyle.fill) {
	      ctx.fillStyle = style.fill;
	    }
	
	    if (notCheckCache || style.stroke !== prevStyle.stroke) {
	      ctx.strokeStyle = style.stroke;
	    }
	
	    if (notCheckCache || style.opacity !== prevStyle.opacity) {
	      ctx.globalAlpha = style.opacity == null ? 1 : style.opacity;
	    }
	
	    if (notCheckCache || style.blend !== prevStyle.blend) {
	      ctx.globalCompositeOperation = style.blend || 'source-over';
	    }
	
	    if (this.hasStroke()) {
	      var lineWidth = style.lineWidth;
	      ctx.lineWidth = lineWidth / (this.strokeNoScale && el && el.getLineScale ? el.getLineScale() : 1);
	    }
	  },
	  hasFill: function () {
	    var fill = this.fill;
	    return fill != null && fill !== 'none';
	  },
	  hasStroke: function () {
	    var stroke = this.stroke;
	    return stroke != null && stroke !== 'none' && this.lineWidth > 0;
	  },
	
	  /**
	   * Extend from other style
	   * @param {zrender/graphic/Style} otherStyle
	   * @param {boolean} overwrite true: overwrirte any way.
	   *                            false: overwrite only when !target.hasOwnProperty
	   *                            others: overwrite when property is not null/undefined.
	   */
	  extendFrom: function (otherStyle, overwrite) {
	    if (otherStyle) {
	      for (var name in otherStyle) {
	        if (otherStyle.hasOwnProperty(name) && (overwrite === true || (overwrite === false ? !this.hasOwnProperty(name) : otherStyle[name] != null))) {
	          this[name] = otherStyle[name];
	        }
	      }
	    }
	  },
	
	  /**
	   * Batch setting style with a given object
	   * @param {Object|string} obj
	   * @param {*} [obj]
	   */
	  set: function (obj, value) {
	    if (typeof obj === 'string') {
	      this[obj] = value;
	    } else {
	      this.extendFrom(obj, true);
	    }
	  },
	
	  /**
	   * Clone
	   * @return {zrender/graphic/Style} [description]
	   */
	  clone: function () {
	    var newStyle = new this.constructor();
	    newStyle.extendFrom(this, true);
	    return newStyle;
	  },
	  getGradient: function (ctx, obj, rect) {
	    var method = obj.type === 'radial' ? createRadialGradient : createLinearGradient;
	    var canvasGradient = method(ctx, obj, rect);
	    var colorStops = obj.colorStops;
	
	    for (var i = 0; i < colorStops.length; i++) {
	      canvasGradient.addColorStop(colorStops[i].offset, colorStops[i].color);
	    }
	
	    return canvasGradient;
	  }
	};
	var styleProto = Style.prototype;
	
	for (var i = 0; i < STYLE_COMMON_PROPS.length; i++) {
	  var prop = STYLE_COMMON_PROPS[i];
	
	  if (!(prop[0] in styleProto)) {
	    styleProto[prop[0]] = prop[1];
	  }
	} // Provide for others
	
	
	Style.getGradient = styleProto.getGradient;
	var _default = Style;
	module.exports = _default;

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	var LRU = __webpack_require__(1084);
	
	var globalImageCache = new LRU(50);
	/**
	 * @param {string|HTMLImageElement|HTMLCanvasElement|Canvas} newImageOrSrc
	 * @return {HTMLImageElement|HTMLCanvasElement|Canvas} image
	 */
	
	function findExistImage(newImageOrSrc) {
	  if (typeof newImageOrSrc === 'string') {
	    var cachedImgObj = globalImageCache.get(newImageOrSrc);
	    return cachedImgObj && cachedImgObj.image;
	  } else {
	    return newImageOrSrc;
	  }
	}
	/**
	 * Caution: User should cache loaded images, but not just count on LRU.
	 * Consider if required images more than LRU size, will dead loop occur?
	 *
	 * @param {string|HTMLImageElement|HTMLCanvasElement|Canvas} newImageOrSrc
	 * @param {HTMLImageElement|HTMLCanvasElement|Canvas} image Existent image.
	 * @param {module:zrender/Element} [hostEl] For calling `dirty`.
	 * @param {Function} [cb] params: (image, cbPayload)
	 * @param {Object} [cbPayload] Payload on cb calling.
	 * @return {HTMLImageElement|HTMLCanvasElement|Canvas} image
	 */
	
	
	function createOrUpdateImage(newImageOrSrc, image, hostEl, cb, cbPayload) {
	  if (!newImageOrSrc) {
	    return image;
	  } else if (typeof newImageOrSrc === 'string') {
	    // Image should not be loaded repeatly.
	    if (image && image.__zrImageSrc === newImageOrSrc || !hostEl) {
	      return image;
	    } // Only when there is no existent image or existent image src
	    // is different, this method is responsible for load.
	
	
	    var cachedImgObj = globalImageCache.get(newImageOrSrc);
	    var pendingWrap = {
	      hostEl: hostEl,
	      cb: cb,
	      cbPayload: cbPayload
	    };
	
	    if (cachedImgObj) {
	      image = cachedImgObj.image;
	      !isImageReady(image) && cachedImgObj.pending.push(pendingWrap);
	    } else {
	      image = new Image();
	      image.onload = image.onerror = imageOnLoad;
	      globalImageCache.put(newImageOrSrc, image.__cachedImgObj = {
	        image: image,
	        pending: [pendingWrap]
	      });
	      image.src = image.__zrImageSrc = newImageOrSrc;
	    }
	
	    return image;
	  } // newImageOrSrc is an HTMLImageElement or HTMLCanvasElement or Canvas
	  else {
	      return newImageOrSrc;
	    }
	}
	
	function imageOnLoad() {
	  var cachedImgObj = this.__cachedImgObj;
	  this.onload = this.onerror = this.__cachedImgObj = null;
	
	  for (var i = 0; i < cachedImgObj.pending.length; i++) {
	    var pendingWrap = cachedImgObj.pending[i];
	    var cb = pendingWrap.cb;
	    cb && cb(this, pendingWrap.cbPayload);
	    pendingWrap.hostEl.dirty();
	  }
	
	  cachedImgObj.pending.length = 0;
	}
	
	function isImageReady(image) {
	  return image && image.width && image.height;
	}
	
	exports.findExistImage = findExistImage;
	exports.createOrUpdateImage = createOrUpdateImage;
	exports.isImageReady = isImageReady;

/***/ },
/* 560 */
/***/ function(module, exports) {

	/**
	 * Sub-pixel optimize for canvas rendering, prevent from blur
	 * when rendering a thin vertical/horizontal line.
	 */
	var round = Math.round;
	/**
	 * Sub pixel optimize line for canvas
	 *
	 * @param {Object} outputShape The modification will be performed on `outputShape`.
	 *                 `outputShape` and `inputShape` can be the same object.
	 *                 `outputShape` object can be used repeatly, because all of
	 *                 the `x1`, `x2`, `y1`, `y2` will be assigned in this method.
	 * @param {Object} [inputShape]
	 * @param {number} [inputShape.x1]
	 * @param {number} [inputShape.y1]
	 * @param {number} [inputShape.x2]
	 * @param {number} [inputShape.y2]
	 * @param {Object} [style]
	 * @param {number} [style.lineWidth] If `null`/`undefined`/`0`, do not optimize.
	 */
	
	function subPixelOptimizeLine(outputShape, inputShape, style) {
	  if (!inputShape) {
	    return;
	  }
	
	  var x1 = inputShape.x1;
	  var x2 = inputShape.x2;
	  var y1 = inputShape.y1;
	  var y2 = inputShape.y2;
	  outputShape.x1 = x1;
	  outputShape.x2 = x2;
	  outputShape.y1 = y1;
	  outputShape.y2 = y2;
	  var lineWidth = style && style.lineWidth;
	
	  if (!lineWidth) {
	    return;
	  }
	
	  if (round(x1 * 2) === round(x2 * 2)) {
	    outputShape.x1 = outputShape.x2 = subPixelOptimize(x1, lineWidth, true);
	  }
	
	  if (round(y1 * 2) === round(y2 * 2)) {
	    outputShape.y1 = outputShape.y2 = subPixelOptimize(y1, lineWidth, true);
	  }
	}
	/**
	 * Sub pixel optimize rect for canvas
	 *
	 * @param {Object} outputShape The modification will be performed on `outputShape`.
	 *                 `outputShape` and `inputShape` can be the same object.
	 *                 `outputShape` object can be used repeatly, because all of
	 *                 the `x`, `y`, `width`, `height` will be assigned in this method.
	 * @param {Object} [inputShape]
	 * @param {number} [inputShape.x]
	 * @param {number} [inputShape.y]
	 * @param {number} [inputShape.width]
	 * @param {number} [inputShape.height]
	 * @param {Object} [style]
	 * @param {number} [style.lineWidth] If `null`/`undefined`/`0`, do not optimize.
	 */
	
	
	function subPixelOptimizeRect(outputShape, inputShape, style) {
	  if (!inputShape) {
	    return;
	  }
	
	  var originX = inputShape.x;
	  var originY = inputShape.y;
	  var originWidth = inputShape.width;
	  var originHeight = inputShape.height;
	  outputShape.x = originX;
	  outputShape.y = originY;
	  outputShape.width = originWidth;
	  outputShape.height = originHeight;
	  var lineWidth = style && style.lineWidth;
	
	  if (!lineWidth) {
	    return;
	  }
	
	  outputShape.x = subPixelOptimize(originX, lineWidth, true);
	  outputShape.y = subPixelOptimize(originY, lineWidth, true);
	  outputShape.width = Math.max(subPixelOptimize(originX + originWidth, lineWidth, false) - outputShape.x, originWidth === 0 ? 0 : 1);
	  outputShape.height = Math.max(subPixelOptimize(originY + originHeight, lineWidth, false) - outputShape.y, originHeight === 0 ? 0 : 1);
	}
	/**
	 * Sub pixel optimize for canvas
	 *
	 * @param {number} position Coordinate, such as x, y
	 * @param {number} lineWidth If `null`/`undefined`/`0`, do not optimize.
	 * @param {boolean=} positiveOrNegative Default false (negative).
	 * @return {number} Optimized position.
	 */
	
	
	function subPixelOptimize(position, lineWidth, positiveOrNegative) {
	  if (!lineWidth) {
	    return position;
	  } // Assure that (position + lineWidth / 2) is near integer edge,
	  // otherwise line will be fuzzy in canvas.
	
	
	  var doubledPosition = round(position * 2);
	  return (doubledPosition + round(lineWidth)) % 2 === 0 ? doubledPosition / 2 : (doubledPosition + (positiveOrNegative ? 1 : -1)) / 2;
	}
	
	exports.subPixelOptimizeLine = subPixelOptimizeLine;
	exports.subPixelOptimizeRect = subPixelOptimizeRect;
	exports.subPixelOptimize = subPixelOptimize;

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(46);
	
	var roundRectHelper = __webpack_require__(1091);
	
	var _subPixelOptimize = __webpack_require__(560);
	
	var subPixelOptimizeRect = _subPixelOptimize.subPixelOptimizeRect;
	
	/**
	 * 矩形
	 * @module zrender/graphic/shape/Rect
	 */
	// Avoid create repeatly.
	var subPixelOptimizeOutputShape = {};
	
	var _default = Path.extend({
	  type: 'rect',
	  shape: {
	    // 左上、右上、右下、左下角的半径依次为r1、r2、r3、r4
	    // r缩写为1         相当于 [1, 1, 1, 1]
	    // r缩写为[1]       相当于 [1, 1, 1, 1]
	    // r缩写为[1, 2]    相当于 [1, 2, 1, 2]
	    // r缩写为[1, 2, 3] 相当于 [1, 2, 3, 2]
	    r: 0,
	    x: 0,
	    y: 0,
	    width: 0,
	    height: 0
	  },
	  buildPath: function (ctx, shape) {
	    var x;
	    var y;
	    var width;
	    var height;
	
	    if (this.subPixelOptimize) {
	      subPixelOptimizeRect(subPixelOptimizeOutputShape, shape, this.style);
	      x = subPixelOptimizeOutputShape.x;
	      y = subPixelOptimizeOutputShape.y;
	      width = subPixelOptimizeOutputShape.width;
	      height = subPixelOptimizeOutputShape.height;
	      subPixelOptimizeOutputShape.r = shape.r;
	      shape = subPixelOptimizeOutputShape;
	    } else {
	      x = shape.x;
	      y = shape.y;
	      width = shape.width;
	      height = shape.height;
	    }
	
	    if (!shape.r) {
	      ctx.rect(x, y, width, height);
	    } else {
	      roundRectHelper.buildPath(ctx, shape);
	    }
	
	    ctx.closePath();
	    return;
	  }
	});
	
	module.exports = _default;

/***/ },
/* 562 */
/***/ function(module, exports) {

	var svgURI = 'http://www.w3.org/2000/svg';
	
	function createElement(name) {
	  return document.createElementNS(svgURI, name);
	}
	
	exports.createElement = createElement;

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	var _core = __webpack_require__(562);
	
	var createElement = _core.createElement;
	
	var PathProxy = __webpack_require__(231);
	
	var BoundingRect = __webpack_require__(42);
	
	var matrix = __webpack_require__(73);
	
	var textContain = __webpack_require__(79);
	
	var textHelper = __webpack_require__(388);
	
	var Text = __webpack_require__(188);
	
	// TODO
	// 1. shadow
	// 2. Image: sx, sy, sw, sh
	var CMD = PathProxy.CMD;
	var arrayJoin = Array.prototype.join;
	var NONE = 'none';
	var mathRound = Math.round;
	var mathSin = Math.sin;
	var mathCos = Math.cos;
	var PI = Math.PI;
	var PI2 = Math.PI * 2;
	var degree = 180 / PI;
	var EPSILON = 1e-4;
	
	function round4(val) {
	  return mathRound(val * 1e4) / 1e4;
	}
	
	function isAroundZero(val) {
	  return val < EPSILON && val > -EPSILON;
	}
	
	function pathHasFill(style, isText) {
	  var fill = isText ? style.textFill : style.fill;
	  return fill != null && fill !== NONE;
	}
	
	function pathHasStroke(style, isText) {
	  var stroke = isText ? style.textStroke : style.stroke;
	  return stroke != null && stroke !== NONE;
	}
	
	function setTransform(svgEl, m) {
	  if (m) {
	    attr(svgEl, 'transform', 'matrix(' + arrayJoin.call(m, ',') + ')');
	  }
	}
	
	function attr(el, key, val) {
	  if (!val || val.type !== 'linear' && val.type !== 'radial') {
	    // Don't set attribute for gradient, since it need new dom nodes
	    el.setAttribute(key, val);
	  }
	}
	
	function attrXLink(el, key, val) {
	  el.setAttributeNS('http://www.w3.org/1999/xlink', key, val);
	}
	
	function bindStyle(svgEl, style, isText, el) {
	  if (pathHasFill(style, isText)) {
	    var fill = isText ? style.textFill : style.fill;
	    fill = fill === 'transparent' ? NONE : fill;
	    attr(svgEl, 'fill', fill);
	    attr(svgEl, 'fill-opacity', style.fillOpacity != null ? style.fillOpacity * style.opacity : style.opacity);
	  } else {
	    attr(svgEl, 'fill', NONE);
	  }
	
	  if (pathHasStroke(style, isText)) {
	    var stroke = isText ? style.textStroke : style.stroke;
	    stroke = stroke === 'transparent' ? NONE : stroke;
	    attr(svgEl, 'stroke', stroke);
	    var strokeWidth = isText ? style.textStrokeWidth : style.lineWidth;
	    var strokeScale = !isText && style.strokeNoScale ? el.getLineScale() : 1;
	    attr(svgEl, 'stroke-width', strokeWidth / strokeScale); // stroke then fill for text; fill then stroke for others
	
	    attr(svgEl, 'paint-order', isText ? 'stroke' : 'fill');
	    attr(svgEl, 'stroke-opacity', style.strokeOpacity != null ? style.strokeOpacity : style.opacity);
	    var lineDash = style.lineDash;
	
	    if (lineDash) {
	      attr(svgEl, 'stroke-dasharray', style.lineDash.join(','));
	      attr(svgEl, 'stroke-dashoffset', mathRound(style.lineDashOffset || 0));
	    } else {
	      attr(svgEl, 'stroke-dasharray', '');
	    } // PENDING
	
	
	    style.lineCap && attr(svgEl, 'stroke-linecap', style.lineCap);
	    style.lineJoin && attr(svgEl, 'stroke-linejoin', style.lineJoin);
	    style.miterLimit && attr(svgEl, 'stroke-miterlimit', style.miterLimit);
	  } else {
	    attr(svgEl, 'stroke', NONE);
	  }
	}
	/***************************************************
	 * PATH
	 **************************************************/
	
	
	function pathDataToString(path) {
	  var str = [];
	  var data = path.data;
	  var dataLength = path.len();
	
	  for (var i = 0; i < dataLength;) {
	    var cmd = data[i++];
	    var cmdStr = '';
	    var nData = 0;
	
	    switch (cmd) {
	      case CMD.M:
	        cmdStr = 'M';
	        nData = 2;
	        break;
	
	      case CMD.L:
	        cmdStr = 'L';
	        nData = 2;
	        break;
	
	      case CMD.Q:
	        cmdStr = 'Q';
	        nData = 4;
	        break;
	
	      case CMD.C:
	        cmdStr = 'C';
	        nData = 6;
	        break;
	
	      case CMD.A:
	        var cx = data[i++];
	        var cy = data[i++];
	        var rx = data[i++];
	        var ry = data[i++];
	        var theta = data[i++];
	        var dTheta = data[i++];
	        var psi = data[i++];
	        var clockwise = data[i++];
	        var dThetaPositive = Math.abs(dTheta);
	        var isCircle = isAroundZero(dThetaPositive - PI2) || (clockwise ? dTheta >= PI2 : -dTheta >= PI2); // Mapping to 0~2PI
	
	        var unifiedTheta = dTheta > 0 ? dTheta % PI2 : dTheta % PI2 + PI2;
	        var large = false;
	
	        if (isCircle) {
	          large = true;
	        } else if (isAroundZero(dThetaPositive)) {
	          large = false;
	        } else {
	          large = unifiedTheta >= PI === !!clockwise;
	        }
	
	        var x0 = round4(cx + rx * mathCos(theta));
	        var y0 = round4(cy + ry * mathSin(theta)); // It will not draw if start point and end point are exactly the same
	        // We need to shift the end point with a small value
	        // FIXME A better way to draw circle ?
	
	        if (isCircle) {
	          if (clockwise) {
	            dTheta = PI2 - 1e-4;
	          } else {
	            dTheta = -PI2 + 1e-4;
	          }
	
	          large = true;
	
	          if (i === 9) {
	            // Move to (x0, y0) only when CMD.A comes at the
	            // first position of a shape.
	            // For instance, when drawing a ring, CMD.A comes
	            // after CMD.M, so it's unnecessary to move to
	            // (x0, y0).
	            str.push('M', x0, y0);
	          }
	        }
	
	        var x = round4(cx + rx * mathCos(theta + dTheta));
	        var y = round4(cy + ry * mathSin(theta + dTheta)); // FIXME Ellipse
	
	        str.push('A', round4(rx), round4(ry), mathRound(psi * degree), +large, +clockwise, x, y);
	        break;
	
	      case CMD.Z:
	        cmdStr = 'Z';
	        break;
	
	      case CMD.R:
	        var x = round4(data[i++]);
	        var y = round4(data[i++]);
	        var w = round4(data[i++]);
	        var h = round4(data[i++]);
	        str.push('M', x, y, 'L', x + w, y, 'L', x + w, y + h, 'L', x, y + h, 'L', x, y);
	        break;
	    }
	
	    cmdStr && str.push(cmdStr);
	
	    for (var j = 0; j < nData; j++) {
	      // PENDING With scale
	      str.push(round4(data[i++]));
	    }
	  }
	
	  return str.join(' ');
	}
	
	var svgPath = {};
	
	svgPath.brush = function (el) {
	  var style = el.style;
	  var svgEl = el.__svgEl;
	
	  if (!svgEl) {
	    svgEl = createElement('path');
	    el.__svgEl = svgEl;
	  }
	
	  if (!el.path) {
	    el.createPathProxy();
	  }
	
	  var path = el.path;
	
	  if (el.__dirtyPath) {
	    path.beginPath();
	    path.subPixelOptimize = false;
	    el.buildPath(path, el.shape);
	    el.__dirtyPath = false;
	    var pathStr = pathDataToString(path);
	
	    if (pathStr.indexOf('NaN') < 0) {
	      // Ignore illegal path, which may happen such in out-of-range
	      // data in Calendar series.
	      attr(svgEl, 'd', pathStr);
	    }
	  }
	
	  bindStyle(svgEl, style, false, el);
	  setTransform(svgEl, el.transform);
	
	  if (style.text != null) {
	    svgTextDrawRectText(el, el.getBoundingRect());
	  } else {
	    removeOldTextNode(el);
	  }
	};
	/***************************************************
	 * IMAGE
	 **************************************************/
	
	
	var svgImage = {};
	
	svgImage.brush = function (el) {
	  var style = el.style;
	  var image = style.image;
	
	  if (image instanceof HTMLImageElement) {
	    var src = image.src;
	    image = src;
	  }
	
	  if (!image) {
	    return;
	  }
	
	  var x = style.x || 0;
	  var y = style.y || 0;
	  var dw = style.width;
	  var dh = style.height;
	  var svgEl = el.__svgEl;
	
	  if (!svgEl) {
	    svgEl = createElement('image');
	    el.__svgEl = svgEl;
	  }
	
	  if (image !== el.__imageSrc) {
	    attrXLink(svgEl, 'href', image); // Caching image src
	
	    el.__imageSrc = image;
	  }
	
	  attr(svgEl, 'width', dw);
	  attr(svgEl, 'height', dh);
	  attr(svgEl, 'x', x);
	  attr(svgEl, 'y', y);
	  setTransform(svgEl, el.transform);
	
	  if (style.text != null) {
	    svgTextDrawRectText(el, el.getBoundingRect());
	  } else {
	    removeOldTextNode(el);
	  }
	};
	/***************************************************
	 * TEXT
	 **************************************************/
	
	
	var svgText = {};
	
	var _tmpTextHostRect = new BoundingRect();
	
	var _tmpTextBoxPos = {};
	var _tmpTextTransform = [];
	var TEXT_ALIGN_TO_ANCHRO = {
	  left: 'start',
	  right: 'end',
	  center: 'middle',
	  middle: 'middle'
	};
	/**
	 * @param {module:zrender/Element} el
	 * @param {Object|boolean} [hostRect] {x, y, width, height}
	 *        If set false, rect text is not used.
	 */
	
	var svgTextDrawRectText = function (el, hostRect) {
	  var style = el.style;
	  var elTransform = el.transform;
	  var needTransformTextByHostEl = el instanceof Text || style.transformText;
	  el.__dirty && textHelper.normalizeTextStyle(style, true);
	  var text = style.text; // Convert to string
	
	  text != null && (text += '');
	
	  if (!textHelper.needDrawText(text, style)) {
	    return;
	  } // render empty text for svg if no text but need draw text.
	
	
	  text == null && (text = ''); // Follow the setting in the canvas renderer, if not transform the
	  // text, transform the hostRect, by which the text is located.
	
	  if (!needTransformTextByHostEl && elTransform) {
	    _tmpTextHostRect.copy(hostRect);
	
	    _tmpTextHostRect.applyTransform(elTransform);
	
	    hostRect = _tmpTextHostRect;
	  }
	
	  var textSvgEl = el.__textSvgEl;
	
	  if (!textSvgEl) {
	    textSvgEl = createElement('text');
	    el.__textSvgEl = textSvgEl;
	  } // style.font has been normalized by `normalizeTextStyle`.
	
	
	  var textSvgElStyle = textSvgEl.style;
	  var font = style.font || textContain.DEFAULT_FONT;
	  var computedFont = textSvgEl.__computedFont;
	
	  if (font !== textSvgEl.__styleFont) {
	    textSvgElStyle.font = textSvgEl.__styleFont = font; // The computedFont might not be the orginal font if it is illegal font.
	
	    computedFont = textSvgEl.__computedFont = textSvgElStyle.font;
	  }
	
	  var textPadding = style.textPadding;
	  var textLineHeight = style.textLineHeight;
	  var contentBlock = el.__textCotentBlock;
	
	  if (!contentBlock || el.__dirtyText) {
	    contentBlock = el.__textCotentBlock = textContain.parsePlainText(text, computedFont, textPadding, textLineHeight, style.truncate);
	  }
	
	  var outerHeight = contentBlock.outerHeight;
	  var lineHeight = contentBlock.lineHeight;
	  textHelper.getBoxPosition(_tmpTextBoxPos, el, style, hostRect);
	  var baseX = _tmpTextBoxPos.baseX;
	  var baseY = _tmpTextBoxPos.baseY;
	  var textAlign = _tmpTextBoxPos.textAlign || 'left';
	  var textVerticalAlign = _tmpTextBoxPos.textVerticalAlign;
	  setTextTransform(textSvgEl, needTransformTextByHostEl, elTransform, style, hostRect, baseX, baseY);
	  var boxY = textContain.adjustTextY(baseY, outerHeight, textVerticalAlign);
	  var textX = baseX;
	  var textY = boxY; // TODO needDrawBg
	
	  if (textPadding) {
	    textX = getTextXForPadding(baseX, textAlign, textPadding);
	    textY += textPadding[0];
	  } // `textBaseline` is set as 'middle'.
	
	
	  textY += lineHeight / 2;
	  bindStyle(textSvgEl, style, true, el); // FIXME
	  // Add a <style> to reset all of the text font as inherit?
	  // otherwise the outer <style> may set the unexpected style.
	  // Font may affect position of each tspan elements
	
	  var canCacheByTextString = contentBlock.canCacheByTextString;
	  var tspanList = el.__tspanList || (el.__tspanList = []);
	  var tspanOriginLen = tspanList.length; // Optimize for most cases, just compare text string to determine change.
	
	  if (canCacheByTextString && el.__canCacheByTextString && el.__text === text) {
	    if (el.__dirtyText && tspanOriginLen) {
	      for (var idx = 0; idx < tspanOriginLen; ++idx) {
	        updateTextLocation(tspanList[idx], textAlign, textX, textY + idx * lineHeight);
	      }
	    }
	  } else {
	    el.__text = text;
	    el.__canCacheByTextString = canCacheByTextString;
	    var textLines = contentBlock.lines;
	    var nTextLines = textLines.length;
	    var idx = 0;
	
	    for (; idx < nTextLines; idx++) {
	      // Using cached tspan elements
	      var tspan = tspanList[idx];
	      var singleLineText = textLines[idx];
	
	      if (!tspan) {
	        tspan = tspanList[idx] = createElement('tspan');
	        textSvgEl.appendChild(tspan);
	        tspan.appendChild(document.createTextNode(singleLineText));
	      } else if (tspan.__zrText !== singleLineText) {
	        tspan.innerHTML = '';
	        tspan.appendChild(document.createTextNode(singleLineText));
	      }
	
	      updateTextLocation(tspan, textAlign, textX, textY + idx * lineHeight);
	    } // Remove unused tspan elements
	
	
	    if (tspanOriginLen > nTextLines) {
	      for (; idx < tspanOriginLen; idx++) {
	        textSvgEl.removeChild(tspanList[idx]);
	      }
	
	      tspanList.length = nTextLines;
	    }
	  }
	};
	
	function setTextTransform(textSvgEl, needTransformTextByHostEl, elTransform, style, hostRect, baseX, baseY) {
	  matrix.identity(_tmpTextTransform);
	
	  if (needTransformTextByHostEl && elTransform) {
	    matrix.copy(_tmpTextTransform, elTransform);
	  } // textRotation only apply in RectText.
	
	
	  var textRotation = style.textRotation;
	
	  if (hostRect && textRotation) {
	    var origin = style.textOrigin;
	
	    if (origin === 'center') {
	      baseX = hostRect.width / 2 + hostRect.x;
	      baseY = hostRect.height / 2 + hostRect.y;
	    } else if (origin) {
	      baseX = origin[0] + hostRect.x;
	      baseY = origin[1] + hostRect.y;
	    }
	
	    _tmpTextTransform[4] -= baseX;
	    _tmpTextTransform[5] -= baseY; // Positive: anticlockwise
	
	    matrix.rotate(_tmpTextTransform, _tmpTextTransform, textRotation);
	    _tmpTextTransform[4] += baseX;
	    _tmpTextTransform[5] += baseY;
	  } // See the definition in `Style.js#textOrigin`, the default
	  // origin is from the result of `getBoxPosition`.
	
	
	  setTransform(textSvgEl, _tmpTextTransform);
	} // FIXME merge the same code with `helper/text.js#getTextXForPadding`;
	
	
	function getTextXForPadding(x, textAlign, textPadding) {
	  return textAlign === 'right' ? x - textPadding[1] : textAlign === 'center' ? x + textPadding[3] / 2 - textPadding[1] / 2 : x + textPadding[3];
	}
	
	function updateTextLocation(tspan, textAlign, x, y) {
	  // Consider different font display differently in vertial align, we always
	  // set vertialAlign as 'middle', and use 'y' to locate text vertically.
	  attr(tspan, 'dominant-baseline', 'middle');
	  attr(tspan, 'text-anchor', TEXT_ALIGN_TO_ANCHRO[textAlign]);
	  attr(tspan, 'x', x);
	  attr(tspan, 'y', y);
	}
	
	function removeOldTextNode(el) {
	  if (el && el.__textSvgEl) {
	    // textSvgEl may has no parentNode if el has been removed temporary.
	    if (el.__textSvgEl.parentNode) {
	      el.__textSvgEl.parentNode.removeChild(el.__textSvgEl);
	    }
	
	    el.__textSvgEl = null;
	    el.__tspanList = [];
	    el.__text = null;
	  }
	}
	
	svgText.drawRectText = svgTextDrawRectText;
	
	svgText.brush = function (el) {
	  var style = el.style;
	
	  if (style.text != null) {
	    svgTextDrawRectText(el, false);
	  } else {
	    removeOldTextNode(el);
	  }
	};
	
	exports.path = svgPath;
	exports.image = svgImage;
	exports.text = svgText;

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	var _core = __webpack_require__(562);
	
	var createElement = _core.createElement;
	
	var zrUtil = __webpack_require__(3);
	
	var Path = __webpack_require__(46);
	
	var ZImage = __webpack_require__(232);
	
	var ZText = __webpack_require__(188);
	
	var _graphic = __webpack_require__(563);
	
	var svgPath = _graphic.path;
	var svgImage = _graphic.image;
	var svgText = _graphic.text;
	
	/**
	 * @file Manages elements that can be defined in <defs> in SVG,
	 *       e.g., gradients, clip path, etc.
	 * @author Zhang Wenli
	 */
	var MARK_UNUSED = '0';
	var MARK_USED = '1';
	/**
	 * Manages elements that can be defined in <defs> in SVG,
	 * e.g., gradients, clip path, etc.
	 *
	 * @class
	 * @param {number}          zrId      zrender instance id
	 * @param {SVGElement}      svgRoot   root of SVG document
	 * @param {string|string[]} tagNames  possible tag names
	 * @param {string}          markLabel label name to make if the element
	 *                                    is used
	 */
	
	function Definable(zrId, svgRoot, tagNames, markLabel, domName) {
	  this._zrId = zrId;
	  this._svgRoot = svgRoot;
	  this._tagNames = typeof tagNames === 'string' ? [tagNames] : tagNames;
	  this._markLabel = markLabel;
	  this._domName = domName || '_dom';
	  this.nextId = 0;
	}
	
	Definable.prototype.createElement = createElement;
	/**
	 * Get the <defs> tag for svgRoot; optionally creates one if not exists.
	 *
	 * @param {boolean} isForceCreating if need to create when not exists
	 * @return {SVGDefsElement} SVG <defs> element, null if it doesn't
	 * exist and isForceCreating is false
	 */
	
	Definable.prototype.getDefs = function (isForceCreating) {
	  var svgRoot = this._svgRoot;
	
	  var defs = this._svgRoot.getElementsByTagName('defs');
	
	  if (defs.length === 0) {
	    // Not exist
	    if (isForceCreating) {
	      defs = svgRoot.insertBefore(this.createElement('defs'), // Create new tag
	      svgRoot.firstChild // Insert in the front of svg
	      );
	
	      if (!defs.contains) {
	        // IE doesn't support contains method
	        defs.contains = function (el) {
	          var children = defs.children;
	
	          if (!children) {
	            return false;
	          }
	
	          for (var i = children.length - 1; i >= 0; --i) {
	            if (children[i] === el) {
	              return true;
	            }
	          }
	
	          return false;
	        };
	      }
	
	      return defs;
	    } else {
	      return null;
	    }
	  } else {
	    return defs[0];
	  }
	};
	/**
	 * Update DOM element if necessary.
	 *
	 * @param {Object|string} element style element. e.g., for gradient,
	 *                                it may be '#ccc' or {type: 'linear', ...}
	 * @param {Function|undefined} onUpdate update callback
	 */
	
	
	Definable.prototype.update = function (element, onUpdate) {
	  if (!element) {
	    return;
	  }
	
	  var defs = this.getDefs(false);
	
	  if (element[this._domName] && defs.contains(element[this._domName])) {
	    // Update DOM
	    if (typeof onUpdate === 'function') {
	      onUpdate(element);
	    }
	  } else {
	    // No previous dom, create new
	    var dom = this.add(element);
	
	    if (dom) {
	      element[this._domName] = dom;
	    }
	  }
	};
	/**
	 * Add gradient dom to defs
	 *
	 * @param {SVGElement} dom DOM to be added to <defs>
	 */
	
	
	Definable.prototype.addDom = function (dom) {
	  var defs = this.getDefs(true);
	  defs.appendChild(dom);
	};
	/**
	 * Remove DOM of a given element.
	 *
	 * @param {SVGElement} element element to remove dom
	 */
	
	
	Definable.prototype.removeDom = function (element) {
	  var defs = this.getDefs(false);
	
	  if (defs && element[this._domName]) {
	    defs.removeChild(element[this._domName]);
	    element[this._domName] = null;
	  }
	};
	/**
	 * Get DOMs of this element.
	 *
	 * @return {HTMLDomElement} doms of this defineable elements in <defs>
	 */
	
	
	Definable.prototype.getDoms = function () {
	  var defs = this.getDefs(false);
	
	  if (!defs) {
	    // No dom when defs is not defined
	    return [];
	  }
	
	  var doms = [];
	  zrUtil.each(this._tagNames, function (tagName) {
	    var tags = defs.getElementsByTagName(tagName); // Note that tags is HTMLCollection, which is array-like
	    // rather than real array.
	    // So `doms.concat(tags)` add tags as one object.
	
	    doms = doms.concat([].slice.call(tags));
	  });
	  return doms;
	};
	/**
	 * Mark DOMs to be unused before painting, and clear unused ones at the end
	 * of the painting.
	 */
	
	
	Definable.prototype.markAllUnused = function () {
	  var doms = this.getDoms();
	  var that = this;
	  zrUtil.each(doms, function (dom) {
	    dom[that._markLabel] = MARK_UNUSED;
	  });
	};
	/**
	 * Mark a single DOM to be used.
	 *
	 * @param {SVGElement} dom DOM to mark
	 */
	
	
	Definable.prototype.markUsed = function (dom) {
	  if (dom) {
	    dom[this._markLabel] = MARK_USED;
	  }
	};
	/**
	 * Remove unused DOMs defined in <defs>
	 */
	
	
	Definable.prototype.removeUnused = function () {
	  var defs = this.getDefs(false);
	
	  if (!defs) {
	    // Nothing to remove
	    return;
	  }
	
	  var doms = this.getDoms();
	  var that = this;
	  zrUtil.each(doms, function (dom) {
	    if (dom[that._markLabel] !== MARK_USED) {
	      // Remove gradient
	      defs.removeChild(dom);
	    }
	  });
	};
	/**
	 * Get SVG proxy.
	 *
	 * @param {Displayable} displayable displayable element
	 * @return {Path|Image|Text} svg proxy of given element
	 */
	
	
	Definable.prototype.getSvgProxy = function (displayable) {
	  if (displayable instanceof Path) {
	    return svgPath;
	  } else if (displayable instanceof ZImage) {
	    return svgImage;
	  } else if (displayable instanceof ZText) {
	    return svgText;
	  } else {
	    return svgPath;
	  }
	};
	/**
	 * Get text SVG element.
	 *
	 * @param {Displayable} displayable displayable element
	 * @return {SVGElement} SVG element of text
	 */
	
	
	Definable.prototype.getTextSvgElement = function (displayable) {
	  return displayable.__textSvgEl;
	};
	/**
	 * Get SVG element.
	 *
	 * @param {Displayable} displayable displayable element
	 * @return {SVGElement} SVG element
	 */
	
	
	Definable.prototype.getSvgElement = function (displayable) {
	  return displayable.__svgEl;
	};
	
	var _default = Definable;
	module.exports = _default;

/***/ },
/* 565 */
/***/ function(module, exports) {

	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;
	
	  for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }
	
	  return arr2;
	}
	
	module.exports = _arrayLikeToArray;

/***/ },
/* 566 */
/***/ function(module, exports) {

	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	
	module.exports = _arrayWithHoles;

/***/ },
/* 567 */
/***/ function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	module.exports = _assertThisInitialized;

/***/ },
/* 568 */
/***/ function(module, exports) {

	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	module.exports = _iterableToArray;

/***/ },
/* 569 */
/***/ function(module, exports) {

	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	module.exports = _nonIterableRest;

/***/ },
/* 570 */
/***/ function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose;

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	var arrayWithHoles = __webpack_require__(566);
	
	var iterableToArray = __webpack_require__(568);
	
	var unsupportedIterableToArray = __webpack_require__(392);
	
	var nonIterableRest = __webpack_require__(569);
	
	function _toArray(arr) {
	  return arrayWithHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableRest();
	}
	
	module.exports = _toArray;

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	/**
	 * @ignore - internal component.
	 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
	 */
	var AccordionContext = /*#__PURE__*/React.createContext({});
	
	if (false) {
	  AccordionContext.displayName = 'AccordionContext';
	}
	
	var _default = AccordionContext;
	exports.default = _default;

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Avatar.default;
	  }
	});
	
	var _Avatar = _interopRequireDefault(__webpack_require__(1118));

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Card.default;
	  }
	});
	
	var _Card = _interopRequireDefault(__webpack_require__(1137));

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CardHeader.default;
	  }
	});
	
	var _CardHeader = _interopRequireDefault(__webpack_require__(1144));

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ClickAwayListener.default;
	  }
	});
	
	var _ClickAwayListener = _interopRequireDefault(__webpack_require__(1151));

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _DialogContent.default;
	  }
	});
	
	var _DialogContent = _interopRequireDefault(__webpack_require__(1159));

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Divider.default;
	  }
	});
	
	var _Divider = _interopRequireDefault(__webpack_require__(1163));

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	/**
	 * @ignore - internal component.
	 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
	 */
	var ExpansionPanelContext = /*#__PURE__*/React.createContext({});
	
	if (false) {
	  ExpansionPanelContext.displayName = 'ExpansionPanelContext';
	}
	
	var _default = ExpansionPanelContext;
	exports.default = _default;

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanel.default;
	  }
	});
	
	var _ExpansionPanel = _interopRequireDefault(__webpack_require__(1165));

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelDetails.default;
	  }
	});
	
	var _ExpansionPanelDetails = _interopRequireDefault(__webpack_require__(1168));

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelSummary.default;
	  }
	});
	
	var _ExpansionPanelSummary = _interopRequireDefault(__webpack_require__(1169));

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FormControlLabel.default;
	  }
	});
	
	var _FormControlLabel = _interopRequireDefault(__webpack_require__(1174));

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FormGroup.default;
	  }
	});
	
	var _FormGroup = _interopRequireDefault(__webpack_require__(1175));

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FormHelperText.default;
	  }
	});
	
	var _FormHelperText = _interopRequireDefault(__webpack_require__(1176));

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FormLabel.default;
	  }
	});
	
	var _FormLabel = _interopRequireDefault(__webpack_require__(1177));

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _InputLabel.default;
	  }
	});
	
	var _InputLabel = _interopRequireDefault(__webpack_require__(1197));

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListSubheader.default;
	  }
	});
	
	var _ListSubheader = _interopRequireDefault(__webpack_require__(1209));

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactIs = __webpack_require__(72);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _utils = __webpack_require__(19);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _Popover = _interopRequireDefault(__webpack_require__(596));
	
	var _MenuList = _interopRequireDefault(__webpack_require__(591));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(51));
	
	var _setRef = _interopRequireDefault(__webpack_require__(157));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(59));
	
	var RTL_ORIGIN = {
	  vertical: 'top',
	  horizontal: 'right'
	};
	var LTR_ORIGIN = {
	  vertical: 'top',
	  horizontal: 'left'
	};
	var styles = {
	  /* Styles applied to the `Paper` component. */
	  paper: {
	    // specZ: The maximum height of a simple menu should be one or more rows less than the view
	    // height. This ensures a tapable area outside of the simple menu with which to dismiss
	    // the menu.
	    maxHeight: 'calc(100% - 96px)',
	    // Add iOS momentum scrolling.
	    WebkitOverflowScrolling: 'touch'
	  },
	
	  /* Styles applied to the `List` component via `MenuList`. */
	  list: {
	    // We disable the focus ring for mouse, touch and keyboard users.
	    outline: 0
	  }
	};
	exports.styles = styles;
	var Menu = /*#__PURE__*/React.forwardRef(function Menu(props, ref) {
	  var _props$autoFocus = props.autoFocus,
	      autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus,
	      children = props.children,
	      classes = props.classes,
	      _props$disableAutoFoc = props.disableAutoFocusItem,
	      disableAutoFocusItem = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
	      _props$MenuListProps = props.MenuListProps,
	      MenuListProps = _props$MenuListProps === void 0 ? {} : _props$MenuListProps,
	      onClose = props.onClose,
	      onEntering = props.onEntering,
	      open = props.open,
	      _props$PaperProps = props.PaperProps,
	      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
	      PopoverClasses = props.PopoverClasses,
	      _props$transitionDura = props.transitionDuration,
	      transitionDuration = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["autoFocus", "children", "classes", "disableAutoFocusItem", "MenuListProps", "onClose", "onEntering", "open", "PaperProps", "PopoverClasses", "transitionDuration", "variant"]);
	  var theme = (0, _useTheme.default)();
	  var autoFocusItem = autoFocus && !disableAutoFocusItem && open;
	  var menuListActionsRef = React.useRef(null);
	  var contentAnchorRef = React.useRef(null);
	
	  var getContentAnchorEl = function getContentAnchorEl() {
	    return contentAnchorRef.current;
	  };
	
	  var handleEntering = function handleEntering(element, isAppearing) {
	    if (menuListActionsRef.current) {
	      menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
	    }
	
	    if (onEntering) {
	      onEntering(element, isAppearing);
	    }
	  };
	
	  var handleListKeyDown = function handleListKeyDown(event) {
	    if (event.key === 'Tab') {
	      event.preventDefault();
	
	      if (onClose) {
	        onClose(event, 'tabKeyDown');
	      }
	    }
	  };
	  /**
	   * the index of the item should receive focus
	   * in a `variant="selectedMenu"` it's the first `selected` item
	   * otherwise it's the very first item.
	   */
	
	
	  var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
	  // to check if there is a `selected` item. We're looking for the last `selected`
	  // item and use the first valid item as a fallback
	
	  React.Children.map(children, function (child, index) {
	    if (! /*#__PURE__*/React.isValidElement(child)) {
	      return;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: The Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    if (!child.props.disabled) {
	      if (variant !== "menu" && child.props.selected) {
	        activeItemIndex = index;
	      } else if (activeItemIndex === -1) {
	        activeItemIndex = index;
	      }
	    }
	  });
	  var items = React.Children.map(children, function (child, index) {
	    if (index === activeItemIndex) {
	      return /*#__PURE__*/React.cloneElement(child, {
	        ref: function ref(instance) {
	          // #StrictMode ready
	          contentAnchorRef.current = ReactDOM.findDOMNode(instance);
	          (0, _setRef.default)(child.ref, instance);
	        }
	      });
	    }
	
	    return child;
	  });
	  return /*#__PURE__*/React.createElement(_Popover.default, (0, _extends2.default)({
	    getContentAnchorEl: getContentAnchorEl,
	    classes: PopoverClasses,
	    onClose: onClose,
	    onEntering: handleEntering,
	    anchorOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
	    transformOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
	    PaperProps: (0, _extends2.default)({}, PaperProps, {
	      classes: (0, _extends2.default)({}, PaperProps.classes, {
	        root: classes.paper
	      })
	    }),
	    open: open,
	    ref: ref,
	    transitionDuration: transitionDuration
	  }, other), /*#__PURE__*/React.createElement(_MenuList.default, (0, _extends2.default)({
	    onKeyDown: handleListKeyDown,
	    actions: menuListActionsRef,
	    autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
	    autoFocusItem: autoFocusItem,
	    variant: variant
	  }, MenuListProps, {
	    className: (0, _clsx.default)(classes.list, MenuListProps.className)
	  }), items));
	});
	 false ? Menu.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A HTML element, or a function that returns it.
	   * It's used to set the position of the menu.
	   */
	  anchorEl: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .oneOfType([_utils.HTMLElementType, _propTypes.default.func]),
	
	  /**
	   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
	   * children are not focusable. If you set this prop to `false` focus will be placed
	   * on the parent modal container. This has severe accessibility implications
	   * and should only be considered if you manage focus otherwise.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * Menu contents, normally `MenuItem`s.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * When opening the menu will not focus the active item but the `[role="menu"]`
	   * unless `autoFocus` is also set to `false`. Not using the default means not
	   * following WAI-ARIA authoring practices. Please be considerate about possible
	   * accessibility implications.
	   */
	  disableAutoFocusItem: _propTypes.default.bool,
	
	  /**
	   * Props applied to the [`MenuList`](/api/menu-list/) element.
	   */
	  MenuListProps: _propTypes.default.object,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired before the Menu enters.
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired when the Menu has entered.
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired when the Menu is entering.
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired before the Menu exits.
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired when the Menu has exited.
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * Callback fired when the Menu is exiting.
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * If `true`, the menu is visible.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * @ignore
	   */
	  PaperProps: _propTypes.default.object,
	
	  /**
	   * `classes` prop applied to the [`Popover`](/api/popover/) element.
	   */
	  PopoverClasses: _propTypes.default.object,
	
	  /**
	   * The length of the transition in `ms`, or 'auto'
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.oneOf(['auto']), _propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
	   * and the vertical alignment relative to the anchor element.
	   */
	  variant: _propTypes.default.oneOf(['menu', 'selectedMenu'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiMenu'
	})(Menu);
	
	exports.default = _default;

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _MenuItem.default;
	  }
	});
	
	var _MenuItem = _interopRequireDefault(__webpack_require__(1211));

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _MenuList.default;
	  }
	});
	
	var _MenuList = _interopRequireDefault(__webpack_require__(1212));

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ariaHidden = ariaHidden;
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(391));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(295));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(115));
	
	var _getScrollbarSize = _interopRequireDefault(__webpack_require__(626));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(90));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(309));
	
	// Is a vertical scrollbar displayed?
	function isOverflowing(container) {
	  var doc = (0, _ownerDocument.default)(container);
	
	  if (doc.body === container) {
	    return (0, _ownerWindow.default)(doc).innerWidth > doc.documentElement.clientWidth;
	  }
	
	  return container.scrollHeight > container.clientHeight;
	}
	
	function ariaHidden(node, show) {
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function getPaddingRight(node) {
	  return parseInt(window.getComputedStyle(node)['padding-right'], 10) || 0;
	}
	
	function ariaHiddenSiblings(container, mountNode, currentNode) {
	  var nodesToExclude = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	  var show = arguments.length > 4 ? arguments[4] : undefined;
	  var blacklist = [mountNode, currentNode].concat((0, _toConsumableArray2.default)(nodesToExclude));
	  var blacklistTagNames = ['TEMPLATE', 'SCRIPT', 'STYLE'];
	  [].forEach.call(container.children, function (node) {
	    if (node.nodeType === 1 && blacklist.indexOf(node) === -1 && blacklistTagNames.indexOf(node.tagName) === -1) {
	      ariaHidden(node, show);
	    }
	  });
	}
	
	function findIndexOf(containerInfo, callback) {
	  var idx = -1;
	  containerInfo.some(function (item, index) {
	    if (callback(item)) {
	      idx = index;
	      return true;
	    }
	
	    return false;
	  });
	  return idx;
	}
	
	function handleContainer(containerInfo, props) {
	  var restoreStyle = [];
	  var restorePaddings = [];
	  var container = containerInfo.container;
	  var fixedNodes;
	
	  if (!props.disableScrollLock) {
	    if (isOverflowing(container)) {
	      // Compute the size before applying overflow hidden to avoid any scroll jumps.
	      var scrollbarSize = (0, _getScrollbarSize.default)();
	      restoreStyle.push({
	        value: container.style.paddingRight,
	        key: 'padding-right',
	        el: container
	      }); // Use computed style, here to get the real padding to add our scrollbar width.
	
	      container.style['padding-right'] = "".concat(getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.
	
	      fixedNodes = (0, _ownerDocument.default)(container).querySelectorAll('.mui-fixed');
	      [].forEach.call(fixedNodes, function (node) {
	        restorePaddings.push(node.style.paddingRight);
	        node.style.paddingRight = "".concat(getPaddingRight(node) + scrollbarSize, "px");
	      });
	    } // Improve Gatsby support
	    // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
	
	
	    var parent = container.parentElement;
	    var scrollContainer = parent.nodeName === 'HTML' && window.getComputedStyle(parent)['overflow-y'] === 'scroll' ? parent : container; // Block the scroll even if no scrollbar is visible to account for mobile keyboard
	    // screensize shrink.
	
	    restoreStyle.push({
	      value: scrollContainer.style.overflow,
	      key: 'overflow',
	      el: scrollContainer
	    });
	    scrollContainer.style.overflow = 'hidden';
	  }
	
	  var restore = function restore() {
	    if (fixedNodes) {
	      [].forEach.call(fixedNodes, function (node, i) {
	        if (restorePaddings[i]) {
	          node.style.paddingRight = restorePaddings[i];
	        } else {
	          node.style.removeProperty('padding-right');
	        }
	      });
	    }
	
	    restoreStyle.forEach(function (_ref) {
	      var value = _ref.value,
	          el = _ref.el,
	          key = _ref.key;
	
	      if (value) {
	        el.style.setProperty(key, value);
	      } else {
	        el.style.removeProperty(key);
	      }
	    });
	  };
	
	  return restore;
	}
	
	function getHiddenSiblings(container) {
	  var hiddenSiblings = [];
	  [].forEach.call(container.children, function (node) {
	    if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') {
	      hiddenSiblings.push(node);
	    }
	  });
	  return hiddenSiblings;
	}
	/**
	 * @ignore - do not document.
	 *
	 * Proper state management for containers and the modals in those containers.
	 * Simplified, but inspired by react-overlay's ModalManager class.
	 * Used by the Modal to ensure proper styling of containers.
	 */
	
	
	var ModalManager = /*#__PURE__*/function () {
	  function ModalManager() {
	    (0, _classCallCheck2.default)(this, ModalManager);
	    // this.modals[modalIndex] = modal
	    this.modals = []; // this.containers[containerIndex] = {
	    //   modals: [],
	    //   container,
	    //   restore: null,
	    // }
	
	    this.containers = [];
	  }
	
	  (0, _createClass2.default)(ModalManager, [{
	    key: "add",
	    value: function add(modal, container) {
	      var modalIndex = this.modals.indexOf(modal);
	
	      if (modalIndex !== -1) {
	        return modalIndex;
	      }
	
	      modalIndex = this.modals.length;
	      this.modals.push(modal); // If the modal we are adding is already in the DOM.
	
	      if (modal.modalRef) {
	        ariaHidden(modal.modalRef, false);
	      }
	
	      var hiddenSiblingNodes = getHiddenSiblings(container);
	      ariaHiddenSiblings(container, modal.mountNode, modal.modalRef, hiddenSiblingNodes, true);
	      var containerIndex = findIndexOf(this.containers, function (item) {
	        return item.container === container;
	      });
	
	      if (containerIndex !== -1) {
	        this.containers[containerIndex].modals.push(modal);
	        return modalIndex;
	      }
	
	      this.containers.push({
	        modals: [modal],
	        container: container,
	        restore: null,
	        hiddenSiblingNodes: hiddenSiblingNodes
	      });
	      return modalIndex;
	    }
	  }, {
	    key: "mount",
	    value: function mount(modal, props) {
	      var containerIndex = findIndexOf(this.containers, function (item) {
	        return item.modals.indexOf(modal) !== -1;
	      });
	      var containerInfo = this.containers[containerIndex];
	
	      if (!containerInfo.restore) {
	        containerInfo.restore = handleContainer(containerInfo, props);
	      }
	    }
	  }, {
	    key: "remove",
	    value: function remove(modal) {
	      var modalIndex = this.modals.indexOf(modal);
	
	      if (modalIndex === -1) {
	        return modalIndex;
	      }
	
	      var containerIndex = findIndexOf(this.containers, function (item) {
	        return item.modals.indexOf(modal) !== -1;
	      });
	      var containerInfo = this.containers[containerIndex];
	      containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
	      this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.
	
	      if (containerInfo.modals.length === 0) {
	        // The modal might be closed before it had the chance to be mounted in the DOM.
	        if (containerInfo.restore) {
	          containerInfo.restore();
	        }
	
	        if (modal.modalRef) {
	          // In case the modal wasn't in the DOM yet.
	          ariaHidden(modal.modalRef, true);
	        }
	
	        ariaHiddenSiblings(containerInfo.container, modal.mountNode, modal.modalRef, containerInfo.hiddenSiblingNodes, false);
	        this.containers.splice(containerIndex, 1);
	      } else {
	        // Otherwise make sure the next top modal is visible to a screen reader.
	        var nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
	        // aria-hidden because the dom element doesn't exist either
	        // when modal was unmounted before modalRef gets null
	
	        if (nextTop.modalRef) {
	          ariaHidden(nextTop.modalRef, false);
	        }
	      }
	
	      return modalIndex;
	    }
	  }, {
	    key: "isTopModal",
	    value: function isTopModal(modal) {
	      return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
	    }
	  }]);
	  return ModalManager;
	}();
	
	exports.default = ModalManager;

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _NativeSelectInput = _interopRequireDefault(__webpack_require__(594));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _formControlState = _interopRequireDefault(__webpack_require__(191));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(154));
	
	var _ArrowDropDown = _interopRequireDefault(__webpack_require__(619));
	
	var _Input = _interopRequireDefault(__webpack_require__(301));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the select component `root` class. */
	    root: {},
	
	    /* Styles applied to the select component `select` class. */
	    select: {
	      '-moz-appearance': 'none',
	      // Reset
	      '-webkit-appearance': 'none',
	      // Reset
	      // When interacting quickly, the text can end up selected.
	      // Native select can't be selected either.
	      userSelect: 'none',
	      borderRadius: 0,
	      // Reset
	      minWidth: 16,
	      // So it doesn't collapse.
	      cursor: 'pointer',
	      '&:focus': {
	        // Show that it's not an text input
	        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)',
	        borderRadius: 0 // Reset Chrome style
	
	      },
	      // Remove IE 11 arrow
	      '&::-ms-expand': {
	        display: 'none'
	      },
	      '&$disabled': {
	        cursor: 'default'
	      },
	      '&[multiple]': {
	        height: 'auto'
	      },
	      '&:not([multiple]) option, &:not([multiple]) optgroup': {
	        backgroundColor: theme.palette.background.paper
	      },
	      '&&': {
	        paddingRight: 24
	      }
	    },
	
	    /* Styles applied to the select component if `variant="filled"`. */
	    filled: {
	      '&&': {
	        paddingRight: 32
	      }
	    },
	
	    /* Styles applied to the select component if `variant="outlined"`. */
	    outlined: {
	      borderRadius: theme.shape.borderRadius,
	      '&&': {
	        paddingRight: 32
	      }
	    },
	
	    /* Styles applied to the select component `selectMenu` class. */
	    selectMenu: {
	      height: 'auto',
	      // Resets for multpile select with chips
	      minHeight: '1.1876em',
	      // Required for select\text-field height consistency
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap',
	      overflow: 'hidden'
	    },
	
	    /* Pseudo-class applied to the select component `disabled` class. */
	    disabled: {},
	
	    /* Styles applied to the icon component. */
	    icon: {
	      // We use a position absolute over a flexbox in order to forward the pointer events
	      // to the input and to support wrapping tags..
	      position: 'absolute',
	      right: 0,
	      top: 'calc(50% - 12px)',
	      // Center vertically
	      pointerEvents: 'none',
	      // Don't block pointer events on the select under the icon.
	      color: theme.palette.action.active,
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    },
	
	    /* Styles applied to the icon component if the popup is open. */
	    iconOpen: {
	      transform: 'rotate(180deg)'
	    },
	
	    /* Styles applied to the icon component if `variant="filled"`. */
	    iconFilled: {
	      right: 7
	    },
	
	    /* Styles applied to the icon component if `variant="outlined"`. */
	    iconOutlined: {
	      right: 7
	    },
	
	    /* Styles applied to the underlying native input component. */
	    nativeInput: {
	      bottom: 0,
	      left: 0,
	      position: 'absolute',
	      opacity: 0,
	      pointerEvents: 'none',
	      width: '100%'
	    }
	  };
	};
	
	exports.styles = styles;
	var defaultInput = /*#__PURE__*/React.createElement(_Input.default, null);
	/**
	 * An alternative to `<Select native />` with a much smaller bundle size footprint.
	 */
	
	var NativeSelect = /*#__PURE__*/React.forwardRef(function NativeSelect(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      _props$IconComponent = props.IconComponent,
	      IconComponent = _props$IconComponent === void 0 ? _ArrowDropDown.default : _props$IconComponent,
	      _props$input = props.input,
	      input = _props$input === void 0 ? defaultInput : _props$input,
	      inputProps = props.inputProps,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "IconComponent", "input", "inputProps", "variant"]);
	  var muiFormControl = (0, _useFormControl.default)();
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['variant']
	  });
	  return /*#__PURE__*/React.cloneElement(input, (0, _extends2.default)({
	    // Most of the logic is implemented in `NativeSelectInput`.
	    // The `Select` component is a simple API wrapper to expose something better to play with.
	    inputComponent: _NativeSelectInput.default,
	    inputProps: (0, _extends2.default)({
	      children: children,
	      classes: classes,
	      IconComponent: IconComponent,
	      variant: fcs.variant,
	      type: undefined
	    }, inputProps, input ? input.props.inputProps : {}),
	    ref: ref
	  }, other));
	});
	 false ? NativeSelect.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The option elements to populate the select with.
	   * Can be some `<option>` elements.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * The icon that displays the arrow.
	   */
	  IconComponent: _propTypes.default.elementType,
	
	  /**
	   * An `Input` element; does not have to be a material-ui specific `Input`.
	   */
	  input: _propTypes.default.element,
	
	  /**
	   * Attributes applied to the `select` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The input value. The DOM API casts this to a string.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['filled', 'outlined', 'standard'])
	} : void 0;
	NativeSelect.muiName = 'Select';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiNativeSelect'
	})(NativeSelect);
	
	exports.default = _default;

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _utils = __webpack_require__(19);
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	/**
	 * @ignore - internal component.
	 */
	var NativeSelectInput = /*#__PURE__*/React.forwardRef(function NativeSelectInput(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      disabled = props.disabled,
	      IconComponent = props.IconComponent,
	      inputRef = props.inputRef,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "disabled", "IconComponent", "inputRef", "variant"]);
	  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("select", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, // TODO v5: merge root and select
	    classes.select, classes[variant], className, disabled && classes.disabled),
	    disabled: disabled,
	    ref: inputRef || ref
	  }, other)), props.multiple ? null : /*#__PURE__*/React.createElement(IconComponent, {
	    className: (0, _clsx.default)(classes.icon, classes["icon".concat((0, _capitalize.default)(variant))], disabled && classes.disabled)
	  }));
	});
	 false ? NativeSelectInput.propTypes = {
	  /**
	   * The option elements to populate the select with.
	   * Can be some `<option>` elements.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * The CSS class name of the select element.
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the select will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * The icon that displays the arrow.
	   */
	  IconComponent: _propTypes.default.elementType.isRequired,
	
	  /**
	   * Use that prop to pass a ref to the native select element.
	   * @deprecated
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * @ignore
	   */
	  multiple: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `select` or hidden `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The input value.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
	} : void 0;
	var _default = NativeSelectInput;
	exports.default = _default;

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _NoSsr.default;
	  }
	});
	
	var _NoSsr = _interopRequireDefault(__webpack_require__(1218));

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Popover.default;
	  }
	});
	
	var _Popover = _interopRequireDefault(__webpack_require__(1222));

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.default;
	  }
	});
	
	var _Popper = _interopRequireDefault(__webpack_require__(1223));

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	/**
	 * @ignore - internal component.
	 */
	var RadioGroupContext = /*#__PURE__*/React.createContext();
	
	if (false) {
	  RadioGroupContext.displayName = 'RadioGroupContext';
	}
	
	var _default = RadioGroupContext;
	exports.default = _default;

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useRadioGroup;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _RadioGroupContext = _interopRequireDefault(__webpack_require__(598));
	
	function useRadioGroup() {
	  return React.useContext(_RadioGroupContext.default);
	}

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Step.default;
	  }
	});
	
	var _Step = _interopRequireDefault(__webpack_require__(1240));

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _StepConnector.default;
	  }
	});
	
	var _StepConnector = _interopRequireDefault(__webpack_require__(1243));

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _StepIcon.default;
	  }
	});
	
	var _StepIcon = _interopRequireDefault(__webpack_require__(1246));

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Stepper.default;
	  }
	});
	
	var _Stepper = _interopRequireDefault(__webpack_require__(1248));

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TabScrollButton.default;
	  }
	});
	
	var _TabScrollButton = _interopRequireDefault(__webpack_require__(1257));

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	/**
	 * @ignore - internal component.
	 */
	var TableContext = /*#__PURE__*/React.createContext();
	
	if (false) {
	  TableContext.displayName = 'TableContext';
	}
	
	var _default = TableContext;
	exports.default = _default;

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TableCell.default;
	  }
	});
	
	var _TableCell = _interopRequireDefault(__webpack_require__(1262));

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Tabs.default;
	  }
	});
	
	var _Tabs = _interopRequireDefault(__webpack_require__(1278));

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TextareaAutosize.default;
	  }
	});
	
	var _TextareaAutosize = _interopRequireDefault(__webpack_require__(1280));

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Toolbar.default;
	  }
	});
	
	var _Toolbar = _interopRequireDefault(__webpack_require__(1281));

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Unstable_TrapFocus.default;
	  }
	});
	
	var _Unstable_TrapFocus = _interopRequireDefault(__webpack_require__(1284));

/***/ },
/* 611 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var blue = {
	  50: '#e3f2fd',
	  100: '#bbdefb',
	  200: '#90caf9',
	  300: '#64b5f6',
	  400: '#42a5f5',
	  500: '#2196f3',
	  600: '#1e88e5',
	  700: '#1976d2',
	  800: '#1565c0',
	  900: '#0d47a1',
	  A100: '#82b1ff',
	  A200: '#448aff',
	  A400: '#2979ff',
	  A700: '#2962ff'
	};
	var _default = blue;
	exports.default = _default;

/***/ },
/* 612 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var common = {
	  black: '#000',
	  white: '#fff'
	};
	var _default = common;
	exports.default = _default;

/***/ },
/* 613 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var green = {
	  50: '#e8f5e9',
	  100: '#c8e6c9',
	  200: '#a5d6a7',
	  300: '#81c784',
	  400: '#66bb6a',
	  500: '#4caf50',
	  600: '#43a047',
	  700: '#388e3c',
	  800: '#2e7d32',
	  900: '#1b5e20',
	  A100: '#b9f6ca',
	  A200: '#69f0ae',
	  A400: '#00e676',
	  A700: '#00c853'
	};
	var _default = green;
	exports.default = _default;

/***/ },
/* 614 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var grey = {
	  50: '#fafafa',
	  100: '#f5f5f5',
	  200: '#eeeeee',
	  300: '#e0e0e0',
	  400: '#bdbdbd',
	  500: '#9e9e9e',
	  600: '#757575',
	  700: '#616161',
	  800: '#424242',
	  900: '#212121',
	  A100: '#d5d5d5',
	  A200: '#aaaaaa',
	  A400: '#303030',
	  A700: '#616161'
	};
	var _default = grey;
	exports.default = _default;

/***/ },
/* 615 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var indigo = {
	  50: '#e8eaf6',
	  100: '#c5cae9',
	  200: '#9fa8da',
	  300: '#7986cb',
	  400: '#5c6bc0',
	  500: '#3f51b5',
	  600: '#3949ab',
	  700: '#303f9f',
	  800: '#283593',
	  900: '#1a237e',
	  A100: '#8c9eff',
	  A200: '#536dfe',
	  A400: '#3d5afe',
	  A700: '#304ffe'
	};
	var _default = indigo;
	exports.default = _default;

/***/ },
/* 616 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var orange = {
	  50: '#fff3e0',
	  100: '#ffe0b2',
	  200: '#ffcc80',
	  300: '#ffb74d',
	  400: '#ffa726',
	  500: '#ff9800',
	  600: '#fb8c00',
	  700: '#f57c00',
	  800: '#ef6c00',
	  900: '#e65100',
	  A100: '#ffd180',
	  A200: '#ffab40',
	  A400: '#ff9100',
	  A700: '#ff6d00'
	};
	var _default = orange;
	exports.default = _default;

/***/ },
/* 617 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var pink = {
	  50: '#fce4ec',
	  100: '#f8bbd0',
	  200: '#f48fb1',
	  300: '#f06292',
	  400: '#ec407a',
	  500: '#e91e63',
	  600: '#d81b60',
	  700: '#c2185b',
	  800: '#ad1457',
	  900: '#880e4f',
	  A100: '#ff80ab',
	  A200: '#ff4081',
	  A400: '#f50057',
	  A700: '#c51162'
	};
	var _default = pink;
	exports.default = _default;

/***/ },
/* 618 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var red = {
	  50: '#ffebee',
	  100: '#ffcdd2',
	  200: '#ef9a9a',
	  300: '#e57373',
	  400: '#ef5350',
	  500: '#f44336',
	  600: '#e53935',
	  700: '#d32f2f',
	  800: '#c62828',
	  900: '#b71c1c',
	  A100: '#ff8a80',
	  A200: '#ff5252',
	  A400: '#ff1744',
	  A700: '#d50000'
	};
	var _default = red;
	exports.default = _default;

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(70));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M7 10l5 5 5-5z"
	}), 'ArrowDropDown');
	
	exports.default = _default;

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(70));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
	}), 'KeyboardArrowLeft');
	
	exports.default = _default;

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(70));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
	}), 'KeyboardArrowRight');
	
	exports.default = _default;

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createBreakpoints;
	exports.keys = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	// Sorted ASC by size. That's important.
	// It can't be configured as it's used statically for propTypes.
	var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.
	
	exports.keys = keys;
	
	function createBreakpoints(breakpoints) {
	  var _breakpoints$values = breakpoints.values,
	      values = _breakpoints$values === void 0 ? {
	    xs: 0,
	    sm: 600,
	    md: 960,
	    lg: 1280,
	    xl: 1920
	  } : _breakpoints$values,
	      _breakpoints$unit = breakpoints.unit,
	      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
	      _breakpoints$step = breakpoints.step,
	      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
	      other = (0, _objectWithoutProperties2.default)(breakpoints, ["values", "unit", "step"]);
	
	  function up(key) {
	    var value = typeof values[key] === 'number' ? values[key] : key;
	    return "@media (min-width:".concat(value).concat(unit, ")");
	  }
	
	  function down(key) {
	    var endIndex = keys.indexOf(key) + 1;
	    var upperbound = values[keys[endIndex]];
	
	    if (endIndex === keys.length) {
	      // xl down applies to all sizes
	      return up('xs');
	    }
	
	    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
	    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
	  }
	
	  function between(start, end) {
	    var endIndex = keys.indexOf(end);
	
	    if (endIndex === keys.length - 1) {
	      return up(start);
	    }
	
	    return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[keys[endIndex + 1]] === 'number' ? values[keys[endIndex + 1]] : end) - step / 100).concat(unit, ")");
	  }
	
	  function only(key) {
	    return between(key, key);
	  }
	
	  function width(key) {
	    return values[key];
	  }
	
	  return (0, _extends2.default)({
	    keys: keys,
	    values: values,
	    up: up,
	    down: down,
	    between: between,
	    only: only,
	    width: width
	  }, other);
	}

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _styles = __webpack_require__(76);
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(241));
	
	var styled = function styled(Component) {
	  var componentCreator = (0, _styles.styled)(Component);
	  return function (style, options) {
	    return componentCreator(style, (0, _extends2.default)({
	      defaultTheme: _defaultTheme.default
	    }, options));
	  };
	};
	
	var _default = styled;
	exports.default = _default;

/***/ },
/* 624 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	// We need to centralize the zIndex definitions as they work
	// like global values in the browser.
	var zIndex = {
	  mobileStepper: 1000,
	  speedDial: 1050,
	  appBar: 1100,
	  drawer: 1200,
	  modal: 1300,
	  snackbar: 1400,
	  tooltip: 1500
	};
	var _default = zIndex;
	exports.default = _default;

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _useMediaQuery.default;
	  }
	});
	
	var _useMediaQuery = _interopRequireDefault(__webpack_require__(1325));

/***/ },
/* 626 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getScrollbarSize;
	
	// A change of the browser zoom change the scrollbar size.
	// Credit https://github.com/twbs/bootstrap/blob/3ffe3a5d82f6f561b82ff78d82b32a7d14aed558/js/src/modal.js#L512-L519
	function getScrollbarSize() {
	  var scrollDiv = document.createElement('div');
	  scrollDiv.style.width = '99px';
	  scrollDiv.style.height = '99px';
	  scrollDiv.style.position = 'absolute';
	  scrollDiv.style.top = '-9999px';
	  scrollDiv.style.overflow = 'scroll';
	  document.body.appendChild(scrollDiv);
	  var scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	  document.body.removeChild(scrollDiv);
	  return scrollbarSize;
	}

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "capitalize", {
	  enumerable: true,
	  get: function get() {
	    return _capitalize.default;
	  }
	});
	Object.defineProperty(exports, "createChainedFunction", {
	  enumerable: true,
	  get: function get() {
	    return _createChainedFunction.default;
	  }
	});
	Object.defineProperty(exports, "createSvgIcon", {
	  enumerable: true,
	  get: function get() {
	    return _createSvgIcon.default;
	  }
	});
	Object.defineProperty(exports, "debounce", {
	  enumerable: true,
	  get: function get() {
	    return _debounce.default;
	  }
	});
	Object.defineProperty(exports, "deprecatedPropType", {
	  enumerable: true,
	  get: function get() {
	    return _deprecatedPropType.default;
	  }
	});
	Object.defineProperty(exports, "isMuiElement", {
	  enumerable: true,
	  get: function get() {
	    return _isMuiElement.default;
	  }
	});
	Object.defineProperty(exports, "ownerDocument", {
	  enumerable: true,
	  get: function get() {
	    return _ownerDocument.default;
	  }
	});
	Object.defineProperty(exports, "ownerWindow", {
	  enumerable: true,
	  get: function get() {
	    return _ownerWindow.default;
	  }
	});
	Object.defineProperty(exports, "requirePropFactory", {
	  enumerable: true,
	  get: function get() {
	    return _requirePropFactory.default;
	  }
	});
	Object.defineProperty(exports, "setRef", {
	  enumerable: true,
	  get: function get() {
	    return _setRef.default;
	  }
	});
	Object.defineProperty(exports, "unsupportedProp", {
	  enumerable: true,
	  get: function get() {
	    return _unsupportedProp.default;
	  }
	});
	Object.defineProperty(exports, "useControlled", {
	  enumerable: true,
	  get: function get() {
	    return _useControlled.default;
	  }
	});
	Object.defineProperty(exports, "useEventCallback", {
	  enumerable: true,
	  get: function get() {
	    return _useEventCallback.default;
	  }
	});
	Object.defineProperty(exports, "useForkRef", {
	  enumerable: true,
	  get: function get() {
	    return _useForkRef.default;
	  }
	});
	Object.defineProperty(exports, "unstable_useId", {
	  enumerable: true,
	  get: function get() {
	    return _unstable_useId.default;
	  }
	});
	Object.defineProperty(exports, "useIsFocusVisible", {
	  enumerable: true,
	  get: function get() {
	    return _useIsFocusVisible.default;
	  }
	});
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(194));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(70));
	
	var _debounce = _interopRequireDefault(__webpack_require__(156));
	
	var _deprecatedPropType = _interopRequireDefault(__webpack_require__(1328));
	
	var _isMuiElement = _interopRequireDefault(__webpack_require__(242));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(90));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(309));
	
	var _requirePropFactory = _interopRequireDefault(__webpack_require__(628));
	
	var _setRef = _interopRequireDefault(__webpack_require__(157));
	
	var _unsupportedProp = _interopRequireDefault(__webpack_require__(311));
	
	var _useControlled = _interopRequireDefault(__webpack_require__(133));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(117));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(47));
	
	var _unstable_useId = _interopRequireDefault(__webpack_require__(310));
	
	var _useIsFocusVisible = _interopRequireDefault(__webpack_require__(243));

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = requirePropFactory;
	
	function requirePropFactory(componentNameInError) {
	  if (true) {
	    return function () {
	      return null;
	    };
	  }
	
	  var requireProp = function requireProp(requiredProp) {
	    return function (props, propName, componentName, location, propFullName) {
	      var propFullNameSafe = propFullName || propName;
	
	      if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
	        return new Error("The prop `".concat(propFullNameSafe, "` of ") + "`".concat(componentNameInError, "` must be used on `").concat(requiredProp, "`."));
	      }
	
	      return null;
	    };
	  };
	
	  return requireProp;
	}

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(244));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
	}), 'ArrowBack');
	
	exports.default = _default;

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(244));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
	}), 'ArrowForward');
	
	exports.default = _default;

/***/ },
/* 631 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	
	var _default = hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';
	
	exports.default = _default;

/***/ },
/* 632 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	// We use the same empty object to ref count the styles that don't need a theme object.
	var noopTheme = {};
	var _default = noopTheme;
	exports.default = _default;

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _getThemeProps.default;
	  }
	});
	
	var _getThemeProps = _interopRequireDefault(__webpack_require__(1346));

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _jssPreset.default;
	  }
	});
	
	var _jssPreset = _interopRequireDefault(__webpack_require__(1347));

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _mergeClasses.default;
	  }
	});
	
	var _mergeClasses = _interopRequireDefault(__webpack_require__(1351));

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var ThemeContext = _react.default.createContext(null);
	
	if (false) {
	  ThemeContext.displayName = 'ThemeContext';
	}
	
	var _default = ThemeContext;
	exports.default = _default;

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	/** @license Material-UI v4.9.14
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  borders: true,
	  breakpoints: true,
	  compose: true,
	  css: true,
	  display: true,
	  flexbox: true,
	  grid: true,
	  palette: true,
	  positions: true,
	  shadows: true,
	  sizing: true,
	  spacing: true,
	  style: true,
	  typography: true
	};
	Object.defineProperty(exports, "borders", {
	  enumerable: true,
	  get: function get() {
	    return _borders.default;
	  }
	});
	Object.defineProperty(exports, "breakpoints", {
	  enumerable: true,
	  get: function get() {
	    return _breakpoints.default;
	  }
	});
	Object.defineProperty(exports, "compose", {
	  enumerable: true,
	  get: function get() {
	    return _compose.default;
	  }
	});
	Object.defineProperty(exports, "css", {
	  enumerable: true,
	  get: function get() {
	    return _css.default;
	  }
	});
	Object.defineProperty(exports, "display", {
	  enumerable: true,
	  get: function get() {
	    return _display.default;
	  }
	});
	Object.defineProperty(exports, "flexbox", {
	  enumerable: true,
	  get: function get() {
	    return _flexbox.default;
	  }
	});
	Object.defineProperty(exports, "grid", {
	  enumerable: true,
	  get: function get() {
	    return _grid.default;
	  }
	});
	Object.defineProperty(exports, "palette", {
	  enumerable: true,
	  get: function get() {
	    return _palette.default;
	  }
	});
	Object.defineProperty(exports, "positions", {
	  enumerable: true,
	  get: function get() {
	    return _positions.default;
	  }
	});
	Object.defineProperty(exports, "shadows", {
	  enumerable: true,
	  get: function get() {
	    return _shadows.default;
	  }
	});
	Object.defineProperty(exports, "sizing", {
	  enumerable: true,
	  get: function get() {
	    return _sizing.default;
	  }
	});
	Object.defineProperty(exports, "spacing", {
	  enumerable: true,
	  get: function get() {
	    return _spacing.default;
	  }
	});
	Object.defineProperty(exports, "style", {
	  enumerable: true,
	  get: function get() {
	    return _style.default;
	  }
	});
	Object.defineProperty(exports, "typography", {
	  enumerable: true,
	  get: function get() {
	    return _typography.default;
	  }
	});
	
	var _borders = _interopRequireWildcard(__webpack_require__(1359));
	
	Object.keys(_borders).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _borders[key];
	    }
	  });
	});
	
	var _breakpoints = _interopRequireDefault(__webpack_require__(413));
	
	var _compose = _interopRequireDefault(__webpack_require__(118));
	
	var _css = _interopRequireDefault(__webpack_require__(1360));
	
	var _display = _interopRequireDefault(__webpack_require__(1361));
	
	var _flexbox = _interopRequireWildcard(__webpack_require__(1362));
	
	Object.keys(_flexbox).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _flexbox[key];
	    }
	  });
	});
	
	var _grid = _interopRequireWildcard(__webpack_require__(1363));
	
	Object.keys(_grid).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _grid[key];
	    }
	  });
	});
	
	var _palette = _interopRequireWildcard(__webpack_require__(1365));
	
	Object.keys(_palette).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _palette[key];
	    }
	  });
	});
	
	var _positions = _interopRequireWildcard(__webpack_require__(1366));
	
	Object.keys(_positions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _positions[key];
	    }
	  });
	});
	
	var _shadows = _interopRequireDefault(__webpack_require__(1367));
	
	var _sizing = _interopRequireWildcard(__webpack_require__(1368));
	
	Object.keys(_sizing).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _sizing[key];
	    }
	  });
	});
	
	var _spacing = _interopRequireWildcard(__webpack_require__(1369));
	
	Object.keys(_spacing).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _spacing[key];
	    }
	  });
	});
	
	var _style = _interopRequireDefault(__webpack_require__(100));
	
	var _typography = _interopRequireWildcard(__webpack_require__(1370));
	
	Object.keys(_typography).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _typography[key];
	    }
	  });
	});

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var responsivePropType =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.object, _propTypes.default.array]) : {};
	var _default = responsivePropType;
	exports.default = _default;

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var column_1 = __webpack_require__(45);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var columnController_1 = __webpack_require__(26);
	var columnFactory_1 = __webpack_require__(246);
	var constants_1 = __webpack_require__(30);
	var utils_1 = __webpack_require__(10);
	var AutoGroupColService = /** @class */ (function () {
	    function AutoGroupColService() {
	    }
	    AutoGroupColService_1 = AutoGroupColService;
	    AutoGroupColService.prototype.createAutoGroupColumns = function (rowGroupColumns) {
	        var _this = this;
	        var groupAutoColumns = [];
	        var doingTreeData = this.gridOptionsWrapper.isTreeData();
	        var doingMultiAutoColumn = this.gridOptionsWrapper.isGroupMultiAutoColumn();
	        if (doingTreeData && doingMultiAutoColumn) {
	            console.warn('ag-Grid: you cannot mix groupMultiAutoColumn with treeData, only one column can be used to display groups when doing tree data');
	            doingMultiAutoColumn = false;
	        }
	        // if doing groupMultiAutoColumn, then we call the method multiple times, once
	        // for each column we are grouping by
	        if (doingMultiAutoColumn) {
	            rowGroupColumns.forEach(function (rowGroupCol, index) {
	                groupAutoColumns.push(_this.createOneAutoGroupColumn(rowGroupCol, index));
	            });
	        }
	        else {
	            groupAutoColumns.push(this.createOneAutoGroupColumn());
	        }
	        return groupAutoColumns;
	    };
	    // rowGroupCol and index are missing if groupMultiAutoColumn=false
	    AutoGroupColService.prototype.createOneAutoGroupColumn = function (rowGroupCol, index) {
	        // if one provided by user, use it, otherwise create one
	        var defaultAutoColDef = this.generateDefaultColDef(rowGroupCol);
	        // if doing multi, set the field
	        var colId;
	        if (rowGroupCol) {
	            colId = constants_1.Constants.GROUP_AUTO_COLUMN_ID + "-" + rowGroupCol.getId();
	        }
	        else {
	            colId = AutoGroupColService_1.GROUP_AUTO_COLUMN_BUNDLE_ID;
	        }
	        var userAutoColDef = this.gridOptionsWrapper.getAutoGroupColumnDef();
	        utils_1._.mergeDeep(defaultAutoColDef, userAutoColDef);
	        defaultAutoColDef = this.columnFactory.mergeColDefs(defaultAutoColDef);
	        defaultAutoColDef.colId = colId;
	        // For tree data the filter is always allowed
	        if (!this.gridOptionsWrapper.isTreeData()) {
	            // we would only allow filter if the user has provided field or value getter. otherwise the filter
	            // would not be able to work.
	            var noFieldOrValueGetter = utils_1._.missing(defaultAutoColDef.field) && utils_1._.missing(defaultAutoColDef.valueGetter) && utils_1._.missing(defaultAutoColDef.filterValueGetter);
	            if (noFieldOrValueGetter) {
	                defaultAutoColDef.filter = false;
	            }
	        }
	        // if showing many cols, we don't want to show more than one with a checkbox for selection
	        if (index && index > 0) {
	            defaultAutoColDef.headerCheckboxSelection = false;
	        }
	        var newCol = new column_1.Column(defaultAutoColDef, null, colId, true);
	        this.context.wireBean(newCol);
	        return newCol;
	    };
	    AutoGroupColService.prototype.generateDefaultColDef = function (rowGroupCol) {
	        var userAutoColDef = this.gridOptionsWrapper.getAutoGroupColumnDef();
	        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
	        var defaultAutoColDef = {
	            headerName: localeTextFunc('group', 'Group')
	        };
	        var userHasProvidedGroupCellRenderer = userAutoColDef && (userAutoColDef.cellRenderer || userAutoColDef.cellRendererFramework);
	        // only add the default group cell renderer if user hasn't provided one
	        if (!userHasProvidedGroupCellRenderer) {
	            defaultAutoColDef.cellRenderer = 'agGroupCellRenderer';
	        }
	        // we never allow moving the group column
	        // defaultAutoColDef.suppressMovable = true;
	        if (rowGroupCol) {
	            var rowGroupColDef = rowGroupCol.getColDef();
	            utils_1._.assign(defaultAutoColDef, {
	                // cellRendererParams.groupKey: colDefToCopy.field;
	                headerName: this.columnController.getDisplayNameForColumn(rowGroupCol, 'header'),
	                headerValueGetter: rowGroupColDef.headerValueGetter
	            });
	            if (rowGroupColDef.cellRenderer) {
	                utils_1._.assign(defaultAutoColDef, {
	                    cellRendererParams: {
	                        innerRenderer: rowGroupColDef.cellRenderer,
	                        innerRendererParams: rowGroupColDef.cellRendererParams
	                    }
	                });
	            }
	            defaultAutoColDef.showRowGroup = rowGroupCol.getColId();
	        }
	        else {
	            defaultAutoColDef.showRowGroup = true;
	        }
	        return defaultAutoColDef;
	    };
	    var AutoGroupColService_1;
	    AutoGroupColService.GROUP_AUTO_COLUMN_BUNDLE_ID = constants_1.Constants.GROUP_AUTO_COLUMN_ID;
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], AutoGroupColService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('context'),
	        __metadata("design:type", context_1.Context)
	    ], AutoGroupColService.prototype, "context", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], AutoGroupColService.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('columnFactory'),
	        __metadata("design:type", columnFactory_1.ColumnFactory)
	    ], AutoGroupColService.prototype, "columnFactory", void 0);
	    AutoGroupColService = AutoGroupColService_1 = __decorate([
	        context_1.Bean('autoGroupColService')
	    ], AutoGroupColService);
	    return AutoGroupColService;
	}());
	exports.AutoGroupColService = AutoGroupColService;


/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// class returns a unique id to use for the column. it checks the existing columns, and if the requested
	// id is already taken, it will start appending numbers until it gets a unique id.
	// eg, if the col field is 'name', it will try ids: {name, name_1, name_2...}
	// if no field or id provided in the col, it will try the ids of natural numbers
	var utils_1 = __webpack_require__(10);
	var ColumnKeyCreator = /** @class */ (function () {
	    function ColumnKeyCreator() {
	        this.existingKeys = [];
	    }
	    ColumnKeyCreator.prototype.addExistingKeys = function (keys) {
	        this.existingKeys = this.existingKeys.concat(keys);
	    };
	    ColumnKeyCreator.prototype.getUniqueKey = function (colId, colField) {
	        // in case user passed in number for colId, convert to string
	        colId = utils_1._.toStringOrNull(colId);
	        var count = 0;
	        while (true) {
	            var idToTry = void 0;
	            if (colId) {
	                idToTry = colId;
	                if (count !== 0) {
	                    idToTry += '_' + count;
	                }
	            }
	            else if (colField) {
	                idToTry = colField;
	                if (count !== 0) {
	                    idToTry += '_' + count;
	                }
	            }
	            else {
	                idToTry = '' + count;
	            }
	            if (this.existingKeys.indexOf(idToTry) < 0) {
	                this.existingKeys.push(idToTry);
	                return idToTry;
	            }
	            count++;
	        }
	    };
	    return ColumnKeyCreator;
	}());
	exports.ColumnKeyCreator = ColumnKeyCreator;


/***/ },
/* 641 */
/***/ function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ColDefUtil = /** @class */ (function () {
	    function ColDefUtil() {
	    }
	    ColDefUtil.STRING_PROPERTIES = [
	        'headerName',
	        'columnGroupShow',
	        'headerClass',
	        'toolPanelClass',
	        'headerValueGetter',
	        'pivotKeys',
	        'groupId',
	        'colId',
	        'sort',
	        'field',
	        'type',
	        'tooltipComponent',
	        'tooltipField',
	        'headerTooltip',
	        'cellClass',
	        'showRowGroup',
	        'template',
	        'templateUrl',
	        'filter',
	        'aggFunc',
	        'cellRenderer',
	        'cellEditor',
	        'pinned',
	        'chartDataType'
	    ];
	    ColDefUtil.OBJECT_PROPERTIES = [
	        'headerGroupComponent',
	        'headerGroupComponentFramework',
	        'headerGroupComponentParams',
	        'cellStyle',
	        'cellRendererParams',
	        'cellEditorFramework',
	        'cellEditorParams',
	        'pinnedRowCellRendererFramework',
	        'pinnedRowCellRendererParams',
	        'filterFramework',
	        'filterParams',
	        'pivotValueColumn',
	        'headerComponent',
	        'headerComponentFramework',
	        'headerComponentParams',
	        'floatingFilterComponent',
	        'floatingFilterComponentParams',
	        'floatingFilterComponentFramework',
	        'tooltipComponent',
	        'tooltipComponentParams',
	        'tooltipComponentFramework',
	        'refData'
	    ];
	    ColDefUtil.ARRAY_PROPERTIES = [
	        'children',
	        'sortingOrder',
	        'allowedAggFuncs',
	        'menuTabs',
	        'pivotTotalColumnIds',
	        'cellClassRules',
	        'icons'
	    ];
	    ColDefUtil.NUMBER_PROPERTIES = [
	        'sortedAt',
	        'width',
	        'minWidth',
	        'maxWidth',
	        'rowGroupIndex',
	        'pivotIndex'
	    ];
	    ColDefUtil.BOOLEAN_PROPERTIES = [
	        'suppressCellFlash',
	        'suppressToolPanel',
	        'openByDefault',
	        'marryChildren',
	        'hide',
	        'rowGroup',
	        'pivot',
	        'checkboxSelection',
	        'headerCheckboxSelection',
	        'headerCheckboxSelectionFilteredOnly',
	        'suppressMenu',
	        'suppressSorting',
	        'suppressMovable',
	        'suppressFilter',
	        'lockPosition',
	        'lockVisible',
	        'lockPinned',
	        'unSortIcon',
	        'suppressSizeToFit',
	        'suppressResize',
	        'suppressAutoSize',
	        'enableRowGroup',
	        'enablePivot',
	        'enableValue',
	        'editable',
	        'suppressPaste',
	        'suppressNavigable',
	        'enableCellChangeFlash',
	        'rowDrag',
	        'dndSource',
	        'autoHeight',
	        'sortable',
	        'resizable',
	        'singleClickEdit'
	    ];
	    ColDefUtil.FUNCTION_PROPERTIES = [
	        'dndSourceOnRowDrag',
	        'valueGetter',
	        'valueSetter',
	        'filterValueGetter',
	        'keyCreator',
	        'cellRenderer',
	        'cellRendererFramework',
	        'pinnedRowCellRenderer',
	        'valueFormatter',
	        'pinnedRowValueFormatter',
	        'valueParser',
	        'comparator',
	        'equals',
	        'pivotComparator',
	        'suppressKeyboardEvent',
	        'colSpan',
	        'rowSpan',
	        'getQuickFilterText',
	        'newValueHandler',
	        'onCellValueChanged',
	        'onCellClicked',
	        'onCellDoubleClicked',
	        'onCellContextMenu',
	        'tooltip',
	        'tooltipValueGetter',
	        'tooltipComponent',
	        'tooltipComponentFramework',
	        'cellRendererSelector',
	        'cellEditorSelector'
	    ];
	    ColDefUtil.ALL_PROPERTIES = ColDefUtil.ARRAY_PROPERTIES
	        .concat(ColDefUtil.OBJECT_PROPERTIES)
	        .concat(ColDefUtil.STRING_PROPERTIES)
	        .concat(ColDefUtil.NUMBER_PROPERTIES)
	        .concat(ColDefUtil.FUNCTION_PROPERTIES)
	        .concat(ColDefUtil.BOOLEAN_PROPERTIES);
	    // used when doing property checks - this causes noise when using frameworks which can add their own fw specific
	    // properties to colDefs, gridOptions etc
	    ColDefUtil.FRAMEWORK_PROPERTIES = ['__ob__', '__metadata__', 'mappedColumnProperties', 'hasChildColumns',
	        'toColDef', 'createColDefFromGridColumn'];
	    return ColDefUtil;
	}());
	exports.ColDefUtil = ColDefUtil;


/***/ },
/* 642 */
/***/ function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var SideBarDefParser = /** @class */ (function () {
	    function SideBarDefParser() {
	    }
	    SideBarDefParser.parse = function (toParse) {
	        if (!toParse) {
	            return null;
	        }
	        if (toParse === true) {
	            return {
	                toolPanels: [
	                    SideBarDefParser.DEFAULT_COLUMN_COMP,
	                    SideBarDefParser.DEFAULT_FILTER_COMP,
	                ],
	                defaultToolPanel: 'columns'
	            };
	        }
	        if (typeof toParse === 'string') {
	            return SideBarDefParser.parse([toParse]);
	        }
	        if (Array.isArray(toParse)) {
	            var comps_1 = [];
	            toParse.forEach(function (key) {
	                var lookupResult = SideBarDefParser.DEFAULT_BY_KEY[key];
	                if (!lookupResult) {
	                    console.warn("ag-grid: the key " + key + " is not a valid key for specifying a tool panel, valid keys are: " + Object.keys(SideBarDefParser.DEFAULT_BY_KEY).join(','));
	                    return;
	                }
	                comps_1.push(lookupResult);
	            });
	            if (comps_1.length === 0) {
	                return null;
	            }
	            return {
	                toolPanels: comps_1,
	                defaultToolPanel: comps_1[0].id
	            };
	        }
	        var result = {
	            toolPanels: SideBarDefParser.parseComponents(toParse.toolPanels),
	            defaultToolPanel: toParse.defaultToolPanel,
	            hiddenByDefault: toParse.hiddenByDefault
	        };
	        return result;
	    };
	    SideBarDefParser.parseComponents = function (from) {
	        var result = [];
	        from.forEach(function (it) {
	            var toAdd = null;
	            if (typeof it === 'string') {
	                var lookupResult = SideBarDefParser.DEFAULT_BY_KEY[it];
	                if (!lookupResult) {
	                    console.warn("ag-grid: the key " + it + " is not a valid key for specifying a tool panel, valid keys are: " + Object.keys(SideBarDefParser.DEFAULT_BY_KEY).join(','));
	                    return;
	                }
	                toAdd = lookupResult;
	            }
	            else {
	                toAdd = it;
	            }
	            result.push(toAdd);
	        });
	        return result;
	    };
	    SideBarDefParser.DEFAULT_COLUMN_COMP = {
	        id: 'columns',
	        labelDefault: 'Columns',
	        labelKey: 'columns',
	        iconKey: 'columns',
	        toolPanel: 'agColumnsToolPanel',
	    };
	    SideBarDefParser.DEFAULT_FILTER_COMP = {
	        id: 'filters',
	        labelDefault: 'Filters',
	        labelKey: 'filters',
	        iconKey: 'filter',
	        toolPanel: 'agFiltersToolPanel',
	    };
	    SideBarDefParser.DEFAULT_BY_KEY = {
	        columns: SideBarDefParser.DEFAULT_COLUMN_COMP,
	        filters: SideBarDefParser.DEFAULT_FILTER_COMP
	    };
	    return SideBarDefParser;
	}());
	exports.SideBarDefParser = SideBarDefParser;


/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var utils_1 = __webpack_require__(10);
	// table for crc calculation
	// from: https://referencesource.microsoft.com/#System/sys/System/IO/compression/Crc32Helper.cs,3b31978c7d7f7246,references
	var crcTable = [
	    0, 1996959894, -301047508, -1727442502, 124634137, 1886057615, -379345611, -1637575261, 249268274,
	    2044508324, -522852066, -1747789432, 162941995, 2125561021, -407360249, -1866523247, 498536548,
	    1789927666, -205950648, -2067906082, 450548861, 1843258603, -187386543, -2083289657, 325883990,
	    1684777152, -43845254, -1973040660, 335633487, 1661365465, -99664541, -1928851979, 997073096,
	    1281953886, -715111964, -1570279054, 1006888145, 1258607687, -770865667, -1526024853, 901097722,
	    1119000684, -608450090, -1396901568, 853044451, 1172266101, -589951537, -1412350631, 651767980,
	    1373503546, -925412992, -1076862698, 565507253, 1454621731, -809855591, -1195530993, 671266974,
	    1594198024, -972236366, -1324619484, 795835527, 1483230225, -1050600021, -1234817731, 1994146192,
	    31158534, -1731059524, -271249366, 1907459465, 112637215, -1614814043, -390540237, 2013776290,
	    251722036, -1777751922, -519137256, 2137656763, 141376813, -1855689577, -429695999, 1802195444,
	    476864866, -2056965928, -228458418, 1812370925, 453092731, -2113342271, -183516073, 1706088902,
	    314042704, -1950435094, -54949764, 1658658271, 366619977, -1932296973, -69972891, 1303535960,
	    984961486, -1547960204, -725929758, 1256170817, 1037604311, -1529756563, -740887301, 1131014506,
	    879679996, -1385723834, -631195440, 1141124467, 855842277, -1442165665, -586318647, 1342533948,
	    654459306, -1106571248, -921952122, 1466479909, 544179635, -1184443383, -832445281, 1591671054,
	    702138776, -1328506846, -942167884, 1504918807, 783551873, -1212326853, -1061524307, -306674912,
	    -1698712650, 62317068, 1957810842, -355121351, -1647151185, 81470997, 1943803523, -480048366,
	    -1805370492, 225274430, 2053790376, -468791541, -1828061283, 167816743, 2097651377, -267414716,
	    -2029476910, 503444072, 1762050814, -144550051, -2140837941, 426522225, 1852507879, -19653770,
	    -1982649376, 282753626, 1742555852, -105259153, -1900089351, 397917763, 1622183637, -690576408,
	    -1580100738, 953729732, 1340076626, -776247311, -1497606297, 1068828381, 1219638859, -670225446,
	    -1358292148, 906185462, 1090812512, -547295293, -1469587627, 829329135, 1181335161, -882789492,
	    -1134132454, 628085408, 1382605366, -871598187, -1156888829, 570562233, 1426400815, -977650754,
	    -1296233688, 733239954, 1555261956, -1026031705, -1244606671, 752459403, 1541320221, -1687895376,
	    -328994266, 1969922972, 40735498, -1677130071, -351390145, 1913087877, 83908371, -1782625662,
	    -491226604, 2075208622, 213261112, -1831694693, -438977011, 2094854071, 198958881, -2032938284,
	    -237706686, 1759359992, 534414190, -2118248755, -155638181, 1873836001, 414664567, -2012718362,
	    -15766928, 1711684554, 285281116, -1889165569, -127750551, 1634467795, 376229701, -1609899400,
	    -686959890, 1308918612, 956543938, -1486412191, -799009033, 1231636301, 1047427035, -1362007478,
	    -640263460, 1088359270, 936918000, -1447252397, -558129467, 1202900863, 817233897, -1111625188,
	    -893730166, 1404277552, 615818150, -1160759803, -841546093, 1423857449, 601450431, -1285129682,
	    -1000256840, 1567103746, 711928724, -1274298825, -1022587231, 1510334235, 755167117
	];
	var ZipContainer = /** @class */ (function () {
	    function ZipContainer() {
	        var _this = this;
	        this.folders = [];
	        this.files = [];
	        this.addFolder = function (path) {
	            _this.folders.push({
	                path: path,
	                created: new Date()
	            });
	        };
	    }
	    ZipContainer.prototype.addFolders = function (paths) {
	        paths.forEach(this.addFolder);
	    };
	    ZipContainer.prototype.addFile = function (path, content) {
	        this.files.push({
	            path: path,
	            created: new Date(),
	            content: content
	        });
	    };
	    ZipContainer.prototype.clearStream = function () {
	        this.folders = [];
	        this.files = [];
	    };
	    ZipContainer.prototype.getContent = function (mimeType) {
	        if (mimeType === void 0) { mimeType = 'application/zip'; }
	        var textOutput = this.buildFileStream();
	        var uInt8Output = this.buildUint8Array(textOutput);
	        this.clearStream();
	        return new Blob([uInt8Output], { type: mimeType });
	    };
	    ZipContainer.prototype.buildFileStream = function (fData) {
	        if (fData === void 0) { fData = ''; }
	        var totalFiles = this.folders.concat(this.files);
	        var len = totalFiles.length;
	        var foData = '';
	        var lL = 0;
	        var cL = 0;
	        for (var _i = 0, totalFiles_1 = totalFiles; _i < totalFiles_1.length; _i++) {
	            var currentFile = totalFiles_1[_i];
	            var _a = this.getHeader(currentFile, lL), fileHeader = _a.fileHeader, folderHeader = _a.folderHeader, content = _a.content;
	            lL += fileHeader.length + content.length;
	            cL += folderHeader.length;
	            fData += fileHeader + content;
	            foData += folderHeader;
	        }
	        var foEnd = this.buildFolderEnd(len, cL, lL);
	        return fData + foData + foEnd;
	    };
	    ZipContainer.prototype.getHeader = function (currentFile, offset) {
	        var content = currentFile.content, path = currentFile.path, created = currentFile.created;
	        var utf8_encode = utils_1._.utf8_encode, decToHex = utils_1._.decToHex;
	        var utfPath = utf8_encode(path);
	        var isUTF8 = utfPath !== path;
	        var time = this.convertTime(created);
	        var dt = this.convertDate(created);
	        var extraFields = '';
	        if (isUTF8) {
	            var uExtraFieldPath = decToHex(1, 1) + decToHex(this.getFromCrc32Table(utfPath), 4) + utfPath;
	            extraFields = "\x75\x70" + decToHex(uExtraFieldPath.length, 2) + uExtraFieldPath;
	        }
	        var header = '\x0A\x00' +
	            (isUTF8 ? '\x00\x08' : '\x00\x00') +
	            '\x00\x00' +
	            decToHex(time, 2) + // last modified time
	            decToHex(dt, 2) + // last modified date
	            decToHex(content ? this.getFromCrc32Table(content) : 0, 4) +
	            decToHex(content ? content.length : 0, 4) + // compressed size
	            decToHex(content ? content.length : 0, 4) + // uncompressed size
	            decToHex(utfPath.length, 2) + // file name length
	            decToHex(extraFields.length, 2); // extra field length
	        var fileHeader = 'PK\x03\x04' + header + utfPath + extraFields;
	        var folderHeader = 'PK\x01\x02' + // central header
	            '\x14\x00' +
	            header + // file header
	            '\x00\x00' +
	            '\x00\x00' +
	            '\x00\x00' +
	            (content ? '\x00\x00\x00\x00' : '\x10\x00\x00\x00') + // external file attributes
	            decToHex(offset, 4) + // relative offset of local header
	            utfPath + // file name
	            extraFields; // extra field
	        return { fileHeader: fileHeader, folderHeader: folderHeader, content: content || '' };
	    };
	    ZipContainer.prototype.buildFolderEnd = function (tLen, cLen, lLen) {
	        var decToHex = utils_1._.decToHex;
	        return 'PK\x05\x06' + // central folder end
	            '\x00\x00' +
	            '\x00\x00' +
	            decToHex(tLen, 2) + // total number of entries in the central folder
	            decToHex(tLen, 2) + // total number of entries in the central folder
	            decToHex(cLen, 4) + // size of the central folder
	            decToHex(lLen, 4) + // central folder start offset
	            '\x00\x00';
	    };
	    ZipContainer.prototype.buildUint8Array = function (content) {
	        var uint8 = new Uint8Array(content.length);
	        for (var i = 0; i < uint8.length; i++) {
	            uint8[i] = content.charCodeAt(i);
	        }
	        return uint8;
	    };
	    ZipContainer.prototype.getFromCrc32Table = function (content, crc) {
	        if (crc === void 0) { crc = 0; }
	        if (!content.length) {
	            return 0;
	        }
	        crc ^= (-1);
	        var j = 0;
	        var k = 0;
	        var l = 0;
	        for (var i = 0; i < content.length; i++) {
	            j = content.charCodeAt(i);
	            k = (crc ^ j) & 0xFF;
	            l = crcTable[k];
	            crc = (crc >>> 8) ^ l;
	        }
	        return crc ^ (-1);
	    };
	    ZipContainer.prototype.convertTime = function (date) {
	        var time = date.getHours();
	        time <<= 6;
	        time = time | date.getMinutes();
	        time <<= 5;
	        time = time | date.getSeconds() / 2;
	        return time;
	    };
	    ZipContainer.prototype.convertDate = function (date) {
	        var dt = date.getFullYear() - 1980;
	        dt <<= 4;
	        dt = dt | (date.getMonth() + 1);
	        dt <<= 5;
	        dt = dt | date.getDate();
	        return dt;
	    };
	    ZipContainer = __decorate([
	        context_1.Bean('zipContainer')
	    ], ZipContainer);
	    return ZipContainer;
	}());
	exports.ZipContainer = ZipContainer;


/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var LINE_SEPARATOR = '\r\n';
	var XmlFactory = /** @class */ (function () {
	    function XmlFactory() {
	    }
	    XmlFactory.prototype.createHeader = function (headerElement) {
	        if (headerElement === void 0) { headerElement = {}; }
	        var headerStart = '<?';
	        var headerEnd = '?>';
	        var keys = ['version'];
	        if (!headerElement.version) {
	            headerElement.version = "1.0";
	        }
	        if (headerElement.encoding) {
	            keys.push('encoding');
	        }
	        if (headerElement.standalone) {
	            keys.push('standalone');
	        }
	        var att = keys.map(function (key) { return key + "=\"" + headerElement[key] + "\""; }).join(' ');
	        return headerStart + "xml " + att + " " + headerEnd;
	    };
	    XmlFactory.prototype.createXml = function (xmlElement, booleanTransformer) {
	        var _this = this;
	        var props = '';
	        if (xmlElement.properties) {
	            if (xmlElement.properties.prefixedAttributes) {
	                xmlElement.properties.prefixedAttributes.forEach(function (prefixedSet) {
	                    Object.keys(prefixedSet.map).forEach(function (key) {
	                        props += _this.returnAttributeIfPopulated(prefixedSet.prefix + key, prefixedSet.map[key], booleanTransformer);
	                    });
	                });
	            }
	            if (xmlElement.properties.rawMap) {
	                Object.keys(xmlElement.properties.rawMap).forEach(function (key) {
	                    props += _this.returnAttributeIfPopulated(key, xmlElement.properties.rawMap[key], booleanTransformer);
	                });
	            }
	        }
	        var result = '<' + xmlElement.name + props;
	        if (!xmlElement.children && xmlElement.textNode == null) {
	            return result + '/>' + LINE_SEPARATOR;
	        }
	        if (xmlElement.textNode != null) {
	            return result + '>' + xmlElement.textNode + '</' + xmlElement.name + '>' + LINE_SEPARATOR;
	        }
	        result += '>' + LINE_SEPARATOR;
	        if (xmlElement.children) {
	            xmlElement.children.forEach(function (it) {
	                result += _this.createXml(it, booleanTransformer);
	            });
	        }
	        return result + '</' + xmlElement.name + '>' + LINE_SEPARATOR;
	    };
	    XmlFactory.prototype.returnAttributeIfPopulated = function (key, value, booleanTransformer) {
	        if (!value && value !== '' && value !== 0) {
	            return '';
	        }
	        var xmlValue = value;
	        if ((typeof (value) === 'boolean')) {
	            if (booleanTransformer) {
	                xmlValue = booleanTransformer(value);
	            }
	        }
	        return " " + key + "=\"" + xmlValue + "\"";
	    };
	    XmlFactory = __decorate([
	        context_1.Bean('xmlFactory')
	    ], XmlFactory);
	    return XmlFactory;
	}());
	exports.XmlFactory = XmlFactory;


/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(31);
	var simpleFilter_1 = __webpack_require__(134);
	var optionsFactory_1 = __webpack_require__(648);
	var SimpleFloatingFilter = /** @class */ (function (_super) {
	    __extends(SimpleFloatingFilter, _super);
	    function SimpleFloatingFilter() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    SimpleFloatingFilter.prototype.getDefaultDebounceMs = function () {
	        return 0;
	    };
	    // used by:
	    // 1) NumberFloatingFilter & TextFloatingFilter: Always, for both when editable and read only.
	    // 2) DateFloatingFilter: Only when read only (as we show text rather than a date picker when read only)
	    SimpleFloatingFilter.prototype.getTextFromModel = function (model) {
	        if (!model) {
	            return null;
	        }
	        var isCombined = model.operator;
	        if (isCombined) {
	            var combinedModel = model;
	            var con1Str = this.conditionToString(combinedModel.condition1);
	            var con2Str = this.conditionToString(combinedModel.condition2);
	            return con1Str + " " + combinedModel.operator + " " + con2Str;
	        }
	        else {
	            var condition = model;
	            return this.conditionToString(condition);
	        }
	    };
	    SimpleFloatingFilter.prototype.isEventFromFloatingFilter = function (event) {
	        return (event && event.afterFloatingFilter);
	    };
	    SimpleFloatingFilter.prototype.getLastType = function () {
	        return this.lastType;
	    };
	    SimpleFloatingFilter.prototype.setLastTypeFromModel = function (model) {
	        // if no model provided by the parent filter, we continue to use the last type used
	        if (!model) {
	            return;
	        }
	        var isCombined = model.operator;
	        var condition;
	        if (isCombined) {
	            var combinedModel = model;
	            condition = combinedModel.condition1;
	        }
	        else {
	            condition = model;
	        }
	        this.lastType = condition.type;
	    };
	    SimpleFloatingFilter.prototype.canWeEditAfterModelFromParentFilter = function (model) {
	        if (!model) {
	            // if no model, then we can edit as long as the lastType is something we can edit, as this
	            // is the type we will provide to the parent filter if the user decides to use the floating filter.
	            return this.isTypeEditable(this.lastType);
	        }
	        // never allow editing if the filter is combined (ie has two parts)
	        var isCombined = model.operator;
	        if (isCombined) {
	            return false;
	        }
	        var simpleModel = model;
	        var typeIsEditable = this.isTypeEditable(simpleModel.type);
	        return typeIsEditable;
	    };
	    SimpleFloatingFilter.prototype.init = function (params) {
	        this.optionsFactory = new optionsFactory_1.OptionsFactory();
	        this.optionsFactory.init(params.filterParams, this.getDefaultFilterOptions());
	        this.lastType = this.optionsFactory.getDefaultOption();
	        // we are editable if:
	        // 1) there is a type (user has configured filter wrong if not type)
	        //  AND
	        // 2) the default type is not 'in range'
	        var editable = this.isTypeEditable(this.lastType);
	        this.setEditable(editable);
	    };
	    SimpleFloatingFilter.prototype.doesFilterHaveHiddenInput = function (filterType) {
	        var customFilterOption = this.optionsFactory.getCustomOption(filterType);
	        return customFilterOption && customFilterOption.hideFilterInput;
	    };
	    SimpleFloatingFilter.prototype.isTypeEditable = function (type) {
	        if (this.doesFilterHaveHiddenInput(type)) {
	            return false;
	        }
	        return type
	            && (type != simpleFilter_1.SimpleFilter.IN_RANGE)
	            && (type != simpleFilter_1.SimpleFilter.EMPTY);
	    };
	    return SimpleFloatingFilter;
	}(component_1.Component));
	exports.SimpleFloatingFilter = SimpleFloatingFilter;


/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var componentAnnotations_1 = __webpack_require__(39);
	var utils_1 = __webpack_require__(10);
	var constants_1 = __webpack_require__(30);
	var providedFilter_1 = __webpack_require__(317);
	var context_1 = __webpack_require__(8);
	var simpleFloatingFilter_1 = __webpack_require__(645);
	var TextInputFloatingFilter = /** @class */ (function (_super) {
	    __extends(TextInputFloatingFilter, _super);
	    function TextInputFloatingFilter() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TextInputFloatingFilter.prototype.postConstruct = function () {
	        this.setTemplate("<div class=\"ag-input-wrapper\" role=\"presentation\">\n                <input ref=\"eFloatingFilterText\" class=\"ag-floating-filter-input\">\n            </div>");
	    };
	    TextInputFloatingFilter.prototype.getDefaultDebounceMs = function () {
	        return 500;
	    };
	    TextInputFloatingFilter.prototype.onParentModelChanged = function (model, event) {
	        // we don't want to update the floating filter if the floating filter caused the change.
	        // as if it caused the change, the ui is already in sycn. if we didn't do this, the UI
	        // would behave strange as it would be updating as the user is typing
	        if (this.isEventFromFloatingFilter(event)) {
	            return;
	        }
	        this.setLastTypeFromModel(model);
	        var modelString = this.getTextFromModel(model);
	        this.eFloatingFilterText.value = modelString;
	        var editable = this.canWeEditAfterModelFromParentFilter(model);
	        this.setEditable(editable);
	    };
	    TextInputFloatingFilter.prototype.init = function (params) {
	        _super.prototype.init.call(this, params);
	        this.params = params;
	        this.applyActive = providedFilter_1.ProvidedFilter.isUseApplyButton(this.params.filterParams);
	        var debounceMs = providedFilter_1.ProvidedFilter.getDebounceMs(this.params.filterParams, this.getDefaultDebounceMs());
	        var toDebounce = utils_1._.debounce(this.syncUpWithParentFilter.bind(this), debounceMs);
	        this.addDestroyableEventListener(this.eFloatingFilterText, 'input', toDebounce);
	        this.addDestroyableEventListener(this.eFloatingFilterText, 'keypress', toDebounce);
	        this.addDestroyableEventListener(this.eFloatingFilterText, 'keydown', toDebounce);
	        var columnDef = params.column.getDefinition();
	        if (columnDef.filterParams && columnDef.filterParams.filterOptions && columnDef.filterParams.filterOptions.length === 1 && columnDef.filterParams.filterOptions[0] === 'inRange') {
	            this.eFloatingFilterText.disabled = true;
	        }
	    };
	    TextInputFloatingFilter.prototype.syncUpWithParentFilter = function (e) {
	        var _this = this;
	        var value = this.eFloatingFilterText.value;
	        var enterKeyPressed = utils_1._.isKeyPressed(e, constants_1.Constants.KEY_ENTER);
	        if (this.applyActive && !enterKeyPressed) {
	            return;
	        }
	        this.params.parentFilterInstance(function (filterInstance) {
	            if (filterInstance) {
	                var simpleFilter = filterInstance;
	                simpleFilter.onFloatingFilterChanged(_this.getLastType(), value);
	            }
	        });
	    };
	    TextInputFloatingFilter.prototype.setEditable = function (editable) {
	        this.eFloatingFilterText.disabled = !editable;
	    };
	    __decorate([
	        componentAnnotations_1.RefSelector('eFloatingFilterText'),
	        __metadata("design:type", HTMLInputElement)
	    ], TextInputFloatingFilter.prototype, "eFloatingFilterText", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], TextInputFloatingFilter.prototype, "postConstruct", null);
	    return TextInputFloatingFilter;
	}(simpleFloatingFilter_1.SimpleFloatingFilter));
	exports.TextInputFloatingFilter = TextInputFloatingFilter;


/***/ },
/* 647 */
/***/ function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** Provides sync access to async component. Date component can be lazy created - this class encapsulates
	 * this by keeping value locally until DateComp has loaded, then passing DateComp the value. */
	var DateCompWrapper = /** @class */ (function () {
	    function DateCompWrapper(userComponentFactory, dateComponentParams, eParent) {
	        var _this = this;
	        this.alive = true;
	        userComponentFactory.newDateComponent(dateComponentParams).then(function (dateComp) {
	            // because async, check the filter still exists after component comes back
	            if (!_this.alive) {
	                if (dateComp.destroy) {
	                    dateComp.destroy();
	                }
	                return;
	            }
	            _this.dateComp = dateComp;
	            eParent.appendChild(dateComp.getGui());
	            if (dateComp.afterGuiAttached) {
	                dateComp.afterGuiAttached();
	            }
	            if (_this.tempValue) {
	                dateComp.setDate(_this.tempValue);
	            }
	        });
	    }
	    DateCompWrapper.prototype.destroy = function () {
	        this.alive = false;
	        if (this.dateComp && this.dateComp.destroy) {
	            this.dateComp.destroy();
	        }
	    };
	    DateCompWrapper.prototype.getDate = function () {
	        if (this.dateComp) {
	            return this.dateComp.getDate();
	        }
	        else {
	            return this.tempValue;
	        }
	    };
	    DateCompWrapper.prototype.setDate = function (value) {
	        if (this.dateComp) {
	            this.dateComp.setDate(value);
	        }
	        else {
	            this.tempValue = value;
	        }
	    };
	    return DateCompWrapper;
	}());
	exports.DateCompWrapper = DateCompWrapper;


/***/ },
/* 648 */
/***/ function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* Common logic for options, used by both filters and floating filters. */
	var OptionsFactory = /** @class */ (function () {
	    function OptionsFactory() {
	        this.customFilterOptions = {};
	    }
	    OptionsFactory.prototype.init = function (params, defaultOptions) {
	        this.filterOptions = params.filterOptions ? params.filterOptions : defaultOptions;
	        this.mapCustomOptions();
	        this.selectDefaultItem(params);
	    };
	    OptionsFactory.prototype.getFilterOptions = function () {
	        return this.filterOptions;
	    };
	    OptionsFactory.prototype.mapCustomOptions = function () {
	        var _this = this;
	        if (!this.filterOptions) {
	            return;
	        }
	        this.filterOptions.forEach(function (filterOption) {
	            if (typeof filterOption === 'string') {
	                return;
	            }
	            if (!filterOption.displayKey) {
	                console.warn("ag-Grid: ignoring FilterOptionDef as it doesn't contain a 'displayKey'");
	                return;
	            }
	            if (!filterOption.displayName) {
	                console.warn("ag-Grid: ignoring FilterOptionDef as it doesn't contain a 'displayName'");
	                return;
	            }
	            if (!filterOption.test) {
	                console.warn("ag-Grid: ignoring FilterOptionDef as it doesn't contain a 'test'");
	                return;
	            }
	            _this.customFilterOptions[filterOption.displayKey] = filterOption;
	        });
	    };
	    OptionsFactory.prototype.selectDefaultItem = function (params) {
	        if (params.defaultOption) {
	            this.defaultOption = params.defaultOption;
	        }
	        else if (this.filterOptions.length >= 1) {
	            var firstFilterOption = this.filterOptions[0];
	            if (typeof firstFilterOption === 'string') {
	                this.defaultOption = firstFilterOption;
	            }
	            else if (firstFilterOption.displayKey) {
	                this.defaultOption = firstFilterOption.displayKey;
	            }
	            else {
	                console.warn("ag-Grid: invalid FilterOptionDef supplied as it doesn't contain a 'displayKey'");
	            }
	        }
	        else {
	            console.warn('ag-Grid: no filter options for filter');
	        }
	    };
	    OptionsFactory.prototype.getDefaultOption = function () {
	        return this.defaultOption;
	    };
	    OptionsFactory.prototype.getCustomOption = function (name) {
	        return this.customFilterOptions[name];
	    };
	    return OptionsFactory;
	}());
	exports.OptionsFactory = OptionsFactory;


/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var columnApi_1 = __webpack_require__(38);
	var columnController_1 = __webpack_require__(26);
	var rowRenderer_1 = __webpack_require__(91);
	var filterManager_1 = __webpack_require__(77);
	var eventService_1 = __webpack_require__(22);
	var gridPanel_1 = __webpack_require__(429);
	var logger_1 = __webpack_require__(68);
	var popupService_1 = __webpack_require__(137);
	var context_1 = __webpack_require__(8);
	var focusedCellController_1 = __webpack_require__(119);
	var component_1 = __webpack_require__(31);
	var gridApi_1 = __webpack_require__(33);
	var componentAnnotations_1 = __webpack_require__(39);
	var events_1 = __webpack_require__(29);
	var resizeObserverService_1 = __webpack_require__(319);
	var sideBar_1 = __webpack_require__(642);
	var utils_1 = __webpack_require__(10);
	var GridCore = /** @class */ (function (_super) {
	    __extends(GridCore, _super);
	    function GridCore() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    GridCore.prototype.init = function () {
	        var _this = this;
	        this.logger = this.loggerFactory.create('GridCore');
	        var template = this.enterprise ? GridCore.TEMPLATE_ENTERPRISE : GridCore.TEMPLATE_NORMAL;
	        this.setTemplate(template);
	        // register with services that need grid core
	        [
	            this.gridApi,
	            this.filterManager,
	            this.rowRenderer,
	            this.popupService
	        ].forEach(function (service) { return service.registerGridCore(_this); });
	        if (this.enterprise) {
	            this.clipboardService.registerGridCore(this);
	        }
	        this.gridOptionsWrapper.addLayoutElement(this.getGui());
	        // see what the grid options are for default of toolbar
	        this.setSideBarVisible(this.gridOptionsWrapper.isShowToolPanel());
	        this.eGridDiv.appendChild(this.getGui());
	        this.addDestroyFunc(function () {
	            _this.eGridDiv.removeChild(_this.getGui());
	        });
	        // if using angular, watch for quickFilter changes
	        if (this.$scope) {
	            var quickFilterUnregisterFn = this.$scope.$watch(this.quickFilterOnScope, function (newFilter) { return _this.filterManager.setQuickFilter(newFilter); });
	            this.addDestroyFunc(quickFilterUnregisterFn);
	        }
	        // important to set rtl before doLayout, as setting the RTL class impacts the scroll position,
	        // which doLayout indirectly depends on
	        this.addRtlSupport();
	        this.logger.log('ready');
	        this.gridOptionsWrapper.addLayoutElement(this.eRootWrapperBody);
	        var gridPanelEl = this.gridPanel.getGui();
	        this.addDestroyableEventListener(gridPanelEl, 'focusin', function () {
	            utils_1._.addCssClass(gridPanelEl, 'ag-has-focus');
	        });
	        this.addDestroyableEventListener(gridPanelEl, 'focusout', function (e) {
	            if (!gridPanelEl.contains(e.relatedTarget)) {
	                utils_1._.removeCssClass(gridPanelEl, 'ag-has-focus');
	            }
	        });
	        var unsubscribeFromResize = this.resizeObserverService.observeResize(this.eGridDiv, this.onGridSizeChanged.bind(this));
	        this.addDestroyFunc(function () { return unsubscribeFromResize(); });
	    };
	    GridCore.prototype.onGridSizeChanged = function () {
	        var event = {
	            type: events_1.Events.EVENT_GRID_SIZE_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            clientWidth: this.eGridDiv.clientWidth,
	            clientHeight: this.eGridDiv.clientHeight
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    GridCore.prototype.addRtlSupport = function () {
	        var cssClass = this.gridOptionsWrapper.isEnableRtl() ? 'ag-rtl' : 'ag-ltr';
	        utils_1._.addCssClass(this.getGui(), cssClass);
	    };
	    GridCore.prototype.getRootGui = function () {
	        return this.getGui();
	    };
	    GridCore.prototype.isSideBarVisible = function () {
	        if (!this.sideBarComp) {
	            return false;
	        }
	        return this.sideBarComp.isDisplayed();
	    };
	    GridCore.prototype.setSideBarVisible = function (show) {
	        if (!this.sideBarComp) {
	            if (show) {
	                console.warn('ag-Grid: toolPanel is only available in ag-Grid Enterprise');
	            }
	            return;
	        }
	        this.sideBarComp.setDisplayed(show);
	    };
	    GridCore.prototype.closeToolPanel = function () {
	        if (!this.sideBarComp) {
	            console.warn('ag-Grid: toolPanel is only available in ag-Grid Enterprise');
	            return;
	        }
	        this.sideBarComp.close();
	    };
	    GridCore.prototype.getSideBar = function () {
	        return this.gridOptions.sideBar;
	    };
	    GridCore.prototype.refreshSideBar = function () {
	        if (this.sideBarComp) {
	            this.sideBarComp.refresh();
	        }
	    };
	    GridCore.prototype.setSideBar = function (def) {
	        this.eRootWrapperBody.removeChild(this.sideBarComp.getGui());
	        this.gridOptions.sideBar = sideBar_1.SideBarDefParser.parse(def);
	        this.sideBarComp.reset();
	        this.eRootWrapperBody.appendChild(this.sideBarComp.getGui());
	    };
	    GridCore.prototype.getOpenedToolPanel = function () {
	        if (!this.sideBarComp) {
	            return null;
	        }
	        return this.sideBarComp.openedItem();
	    };
	    GridCore.prototype.openToolPanel = function (key) {
	        if (!this.sideBarComp) {
	            console.warn('ag-Grid: toolPanel is only available in ag-Grid Enterprise');
	            return;
	        }
	        this.sideBarComp.openToolPanel(key);
	    };
	    GridCore.prototype.isToolPanelShowing = function () {
	        return this.sideBarComp.isToolPanelShowing();
	    };
	    GridCore.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        this.logger.log('Grid DOM removed');
	    };
	    // Valid values for position are bottom, middle and top
	    GridCore.prototype.ensureNodeVisible = function (comparator, position) {
	        if (position === void 0) { position = 'top'; }
	        if (this.doingVirtualPaging) {
	            throw new Error('Cannot use ensureNodeVisible when doing virtual paging, as we cannot check rows that are not in memory');
	        }
	        // look for the node index we want to display
	        var rowCount = this.rowModel.getRowCount();
	        var comparatorIsAFunction = typeof comparator === 'function';
	        var indexToSelect = -1;
	        // go through all the nodes, find the one we want to show
	        for (var i = 0; i < rowCount; i++) {
	            var node = this.rowModel.getRow(i);
	            if (comparatorIsAFunction) {
	                if (comparator(node)) {
	                    indexToSelect = i;
	                    break;
	                }
	            }
	            else {
	                // check object equality against node and data
	                if (comparator === node || comparator === node.data) {
	                    indexToSelect = i;
	                    break;
	                }
	            }
	        }
	        if (indexToSelect >= 0) {
	            this.gridPanel.ensureIndexVisible(indexToSelect, position);
	        }
	    };
	    GridCore.TEMPLATE_NORMAL = "<div class=\"ag-root-wrapper\">\n            <div class=\"ag-root-wrapper-body\" ref=\"rootWrapperBody\">\n                <ag-grid-comp ref=\"gridPanel\"></ag-grid-comp>\n            </div>\n            <ag-pagination></ag-pagination>\n        </div>";
	    GridCore.TEMPLATE_ENTERPRISE = "<div class=\"ag-root-wrapper\">\n            <ag-grid-header-drop-zones></ag-grid-header-drop-zones>\n            <div ref=\"rootWrapperBody\" class=\"ag-root-wrapper-body\">\n                <ag-grid-comp ref=\"gridPanel\"></ag-grid-comp>\n                <ag-side-bar ref=\"sideBar\"></ag-side-bar>\n            </div>\n            <ag-status-bar ref=\"statusBar\"></ag-status-bar>\n            <ag-pagination></ag-pagination>\n            <ag-watermark></ag-watermark>\n        </div>";
	    __decorate([
	        context_1.Autowired('enterprise'),
	        __metadata("design:type", Boolean)
	    ], GridCore.prototype, "enterprise", void 0);
	    __decorate([
	        context_1.Autowired('gridOptions'),
	        __metadata("design:type", Object)
	    ], GridCore.prototype, "gridOptions", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], GridCore.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], GridCore.prototype, "rowModel", void 0);
	    __decorate([
	        context_1.Autowired('resizeObserverService'),
	        __metadata("design:type", resizeObserverService_1.ResizeObserverService)
	    ], GridCore.prototype, "resizeObserverService", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], GridCore.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('rowRenderer'),
	        __metadata("design:type", rowRenderer_1.RowRenderer)
	    ], GridCore.prototype, "rowRenderer", void 0);
	    __decorate([
	        context_1.Autowired('filterManager'),
	        __metadata("design:type", filterManager_1.FilterManager)
	    ], GridCore.prototype, "filterManager", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], GridCore.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('eGridDiv'),
	        __metadata("design:type", HTMLElement)
	    ], GridCore.prototype, "eGridDiv", void 0);
	    __decorate([
	        context_1.Autowired('$scope'),
	        __metadata("design:type", Object)
	    ], GridCore.prototype, "$scope", void 0);
	    __decorate([
	        context_1.Autowired('quickFilterOnScope'),
	        __metadata("design:type", String)
	    ], GridCore.prototype, "quickFilterOnScope", void 0);
	    __decorate([
	        context_1.Autowired('popupService'),
	        __metadata("design:type", popupService_1.PopupService)
	    ], GridCore.prototype, "popupService", void 0);
	    __decorate([
	        context_1.Autowired('focusedCellController'),
	        __metadata("design:type", focusedCellController_1.FocusedCellController)
	    ], GridCore.prototype, "focusedCellController", void 0);
	    __decorate([
	        context_1.Autowired('loggerFactory'),
	        __metadata("design:type", logger_1.LoggerFactory)
	    ], GridCore.prototype, "loggerFactory", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], GridCore.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], GridCore.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.Optional('clipboardService'),
	        __metadata("design:type", Object)
	    ], GridCore.prototype, "clipboardService", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('gridPanel'),
	        __metadata("design:type", gridPanel_1.GridPanel)
	    ], GridCore.prototype, "gridPanel", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('sideBar'),
	        __metadata("design:type", Object)
	    ], GridCore.prototype, "sideBarComp", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('rootWrapperBody'),
	        __metadata("design:type", HTMLElement)
	    ], GridCore.prototype, "eRootWrapperBody", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], GridCore.prototype, "init", null);
	    return GridCore;
	}(component_1.Component));
	exports.GridCore = GridCore;


/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var constants_1 = __webpack_require__(30);
	var mouseEventService_1 = __webpack_require__(248);
	var paginationProxy_1 = __webpack_require__(135);
	var focusedCellController_1 = __webpack_require__(119);
	var animationFrameService_1 = __webpack_require__(197);
	var columnController_1 = __webpack_require__(26);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var utils_1 = __webpack_require__(10);
	var NavigationService = /** @class */ (function () {
	    function NavigationService() {
	        this.timeLastPageEventProcessed = 0;
	    }
	    NavigationService.prototype.init = function () {
	        this.scrollWidth = this.gridOptionsWrapper.getScrollbarWidth();
	    };
	    NavigationService.prototype.registerGridComp = function (gridPanel) {
	        this.gridPanel = gridPanel;
	    };
	    NavigationService.prototype.handlePageScrollingKey = function (event) {
	        var key = event.which || event.keyCode;
	        var alt = event.altKey;
	        var ctrl = event.ctrlKey;
	        var currentCell = this.mouseEventService.getCellPositionForEvent(event);
	        if (!currentCell) {
	            return false;
	        }
	        var processed = false;
	        switch (key) {
	            case constants_1.Constants.KEY_PAGE_HOME:
	            case constants_1.Constants.KEY_PAGE_END:
	                // handle home and end when ctrl & alt are NOT pressed
	                if (!ctrl && !alt) {
	                    this.onHomeOrEndKey(key);
	                    processed = true;
	                }
	                break;
	            case constants_1.Constants.KEY_LEFT:
	            case constants_1.Constants.KEY_RIGHT:
	                // handle left and right when ctrl is pressed only
	                if (ctrl && !alt) {
	                    this.onCtrlLeftOrRight(key, currentCell);
	                    processed = true;
	                }
	                break;
	            case constants_1.Constants.KEY_UP:
	            case constants_1.Constants.KEY_DOWN:
	                // handle up and down when ctrl is pressed only
	                if (ctrl && !alt) {
	                    this.onCtrlUpOrDown(key, currentCell);
	                    processed = true;
	                }
	                break;
	            case constants_1.Constants.KEY_PAGE_DOWN:
	                // handle page up and page down when ctrl & alt are NOT pressed
	                if (!ctrl && !alt) {
	                    this.onPageDown(currentCell);
	                    processed = true;
	                }
	                break;
	            case constants_1.Constants.KEY_PAGE_UP:
	                // handle page up and page down when ctrl & alt are NOT pressed
	                if (!ctrl && !alt) {
	                    this.onPageUp(currentCell);
	                    processed = true;
	                }
	                break;
	        }
	        if (processed) {
	            event.preventDefault();
	        }
	        return processed;
	    };
	    // the page up/down keys caused a problem, in that if the user
	    // held the page up/down key down, lots of events got generated,
	    // which clogged up the event queue (as they take time to process)
	    // which in turn froze the grid. Logic below makes sure we wait 100ms
	    // between processing the page up/down events, so when user has finger
	    // held down on key, we ignore page up/down events until 100ms has passed,
	    // which effectively empties the queue of page up/down events.
	    NavigationService.prototype.isTimeSinceLastPageEventToRecent = function () {
	        var now = new Date().getTime();
	        var diff = now - this.timeLastPageEventProcessed;
	        return (diff < 100);
	    };
	    NavigationService.prototype.setTimeLastPageEventProcessed = function () {
	        this.timeLastPageEventProcessed = new Date().getTime();
	    };
	    NavigationService.prototype.onPageDown = function (gridCell) {
	        if (this.isTimeSinceLastPageEventToRecent()) {
	            return;
	        }
	        var scrollPosition = this.gridPanel.getVScrollPosition();
	        var pixelsInOnePage = scrollPosition.bottom - scrollPosition.top;
	        if (this.gridPanel.isHorizontalScrollShowing()) {
	            pixelsInOnePage -= this.scrollWidth;
	        }
	        var pagingPixelOffset = this.paginationProxy.getPixelOffset();
	        var currentPageBottomPixel = scrollPosition.top + pixelsInOnePage;
	        var currentPageBottomRow = this.paginationProxy.getRowIndexAtPixel(currentPageBottomPixel + pagingPixelOffset);
	        var scrollIndex = currentPageBottomRow;
	        var currentCellPixel = this.paginationProxy.getRow(gridCell.rowIndex).rowTop;
	        var nextCellPixel = currentCellPixel + pixelsInOnePage - pagingPixelOffset;
	        var focusIndex = this.paginationProxy.getRowIndexAtPixel(nextCellPixel + pagingPixelOffset);
	        var pageLastRow = this.paginationProxy.getPageLastRow();
	        if (focusIndex > pageLastRow) {
	            focusIndex = pageLastRow;
	        }
	        if (scrollIndex > pageLastRow) {
	            scrollIndex = pageLastRow;
	        }
	        this.navigateTo(scrollIndex, 'top', null, focusIndex, gridCell.column);
	        this.setTimeLastPageEventProcessed();
	    };
	    NavigationService.prototype.onPageUp = function (gridCell) {
	        if (this.isTimeSinceLastPageEventToRecent()) {
	            return;
	        }
	        var scrollPosition = this.gridPanel.getVScrollPosition();
	        var pixelsInOnePage = scrollPosition.bottom - scrollPosition.top;
	        if (this.gridPanel.isHorizontalScrollShowing()) {
	            pixelsInOnePage -= this.scrollWidth;
	        }
	        var pagingPixelOffset = this.paginationProxy.getPixelOffset();
	        var currentPageTopPixel = scrollPosition.top;
	        var currentPageTopRow = this.paginationProxy.getRowIndexAtPixel(currentPageTopPixel + pagingPixelOffset);
	        var scrollIndex = currentPageTopRow;
	        var currentRowNode = this.paginationProxy.getRow(gridCell.rowIndex);
	        var nextCellPixel = currentRowNode.rowTop + currentRowNode.rowHeight - pixelsInOnePage - pagingPixelOffset;
	        var focusIndex = this.paginationProxy.getRowIndexAtPixel(nextCellPixel + pagingPixelOffset);
	        var firstRow = this.paginationProxy.getPageFirstRow();
	        if (focusIndex < firstRow) {
	            focusIndex = firstRow;
	        }
	        if (scrollIndex < firstRow) {
	            scrollIndex = firstRow;
	        }
	        this.navigateTo(scrollIndex, 'bottom', null, focusIndex, gridCell.column);
	        this.setTimeLastPageEventProcessed();
	    };
	    // common logic to navigate. takes parameters:
	    // scrollIndex - what row to vertically scroll to
	    // scrollType - what position to put scroll index ie top/bottom
	    // scrollColumn - what column to horizontally scroll to
	    // focusIndex / focusColumn - for page up / down, we want to scroll to one row/column, but focus another
	    NavigationService.prototype.navigateTo = function (scrollIndex, scrollType, scrollColumn, focusIndex, focusColumn) {
	        if (utils_1._.exists(scrollColumn)) {
	            this.gridPanel.ensureColumnVisible(scrollColumn);
	        }
	        if (utils_1._.exists(scrollIndex)) {
	            this.gridPanel.ensureIndexVisible(scrollIndex, scrollType);
	        }
	        // make sure the cell is rendered, needed if we are to focus
	        this.animationFrameService.flushAllFrames();
	        // if we don't do this, the range will be left on the last cell, which will leave the last focused cell
	        // highlighted.
	        this.focusedCellController.setFocusedCell(focusIndex, focusColumn, null, true);
	        if (this.rangeController) {
	            var cellPosition = { rowIndex: focusIndex, rowPinned: null, column: focusColumn };
	            this.rangeController.setRangeToCell(cellPosition);
	        }
	    };
	    // ctrl + up/down will bring focus to same column, first/last row. no horizontal scrolling.
	    NavigationService.prototype.onCtrlUpOrDown = function (key, gridCell) {
	        var upKey = key === constants_1.Constants.KEY_UP;
	        var rowIndexToScrollTo = upKey ? 0 : this.paginationProxy.getPageLastRow();
	        this.navigateTo(rowIndexToScrollTo, null, gridCell.column, rowIndexToScrollTo, gridCell.column);
	    };
	    // ctrl + left/right will bring focus to same row, first/last cell. no vertical scrolling.
	    NavigationService.prototype.onCtrlLeftOrRight = function (key, gridCell) {
	        var leftKey = key === constants_1.Constants.KEY_LEFT;
	        var allColumns = this.columnController.getAllDisplayedColumns();
	        var columnToSelect = leftKey ? allColumns[0] : utils_1._.last(allColumns);
	        this.navigateTo(gridCell.rowIndex, null, columnToSelect, gridCell.rowIndex, columnToSelect);
	    };
	    // home brings focus to top left cell, end brings focus to bottom right, grid scrolled to bring
	    // same cell into view (which means either scroll all the way up, or all the way down).
	    NavigationService.prototype.onHomeOrEndKey = function (key) {
	        var homeKey = key === constants_1.Constants.KEY_PAGE_HOME;
	        var allColumns = this.columnController.getAllDisplayedColumns();
	        var columnToSelect = homeKey ? allColumns[0] : utils_1._.last(allColumns);
	        var rowIndexToScrollTo = homeKey ? 0 : this.paginationProxy.getPageLastRow();
	        this.navigateTo(rowIndexToScrollTo, null, columnToSelect, rowIndexToScrollTo, columnToSelect);
	    };
	    __decorate([
	        context_1.Autowired('mouseEventService'),
	        __metadata("design:type", mouseEventService_1.MouseEventService)
	    ], NavigationService.prototype, "mouseEventService", void 0);
	    __decorate([
	        context_1.Autowired('paginationProxy'),
	        __metadata("design:type", paginationProxy_1.PaginationProxy)
	    ], NavigationService.prototype, "paginationProxy", void 0);
	    __decorate([
	        context_1.Autowired('focusedCellController'),
	        __metadata("design:type", focusedCellController_1.FocusedCellController)
	    ], NavigationService.prototype, "focusedCellController", void 0);
	    __decorate([
	        context_1.Autowired('animationFrameService'),
	        __metadata("design:type", animationFrameService_1.AnimationFrameService)
	    ], NavigationService.prototype, "animationFrameService", void 0);
	    __decorate([
	        context_1.Optional('rangeController'),
	        __metadata("design:type", Object)
	    ], NavigationService.prototype, "rangeController", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], NavigationService.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], NavigationService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], NavigationService.prototype, "init", null);
	    NavigationService = __decorate([
	        context_1.Bean('navigationService')
	    ], NavigationService);
	    return NavigationService;
	}());
	exports.NavigationService = NavigationService;


/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var dragAndDropService_1 = __webpack_require__(82);
	var columnController_1 = __webpack_require__(26);
	var context_1 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var BodyDropPivotTarget = /** @class */ (function () {
	    function BodyDropPivotTarget(pinned) {
	        this.columnsToAggregate = [];
	        this.columnsToGroup = [];
	        this.columnsToPivot = [];
	        this.pinned = pinned;
	    }
	    /** Callback for when drag enters */
	    BodyDropPivotTarget.prototype.onDragEnter = function (draggingEvent) {
	        var _this = this;
	        this.clearColumnsList();
	        // in pivot mode, we don't accept any drops if functions are read only
	        if (this.gridOptionsWrapper.isFunctionsReadOnly()) {
	            return;
	        }
	        var dragColumns = draggingEvent.dragItem.columns;
	        dragColumns.forEach(function (column) {
	            // we don't allow adding secondary columns
	            if (!column.isPrimary()) {
	                return;
	            }
	            if (column.isAnyFunctionActive()) {
	                return;
	            }
	            if (column.isAllowValue()) {
	                _this.columnsToAggregate.push(column);
	            }
	            else if (column.isAllowRowGroup()) {
	                _this.columnsToGroup.push(column);
	            }
	            else if (column.isAllowRowGroup()) {
	                _this.columnsToPivot.push(column);
	            }
	        });
	    };
	    BodyDropPivotTarget.prototype.getIconName = function () {
	        var totalColumns = this.columnsToAggregate.length + this.columnsToGroup.length + this.columnsToPivot.length;
	        if (totalColumns > 0) {
	            return this.pinned ? dragAndDropService_1.DragAndDropService.ICON_PINNED : dragAndDropService_1.DragAndDropService.ICON_MOVE;
	        }
	        else {
	            return null;
	        }
	    };
	    /** Callback for when drag leaves */
	    BodyDropPivotTarget.prototype.onDragLeave = function (draggingEvent) {
	        // if we are taking columns out of the center, then we remove them from the report
	        this.clearColumnsList();
	    };
	    BodyDropPivotTarget.prototype.clearColumnsList = function () {
	        this.columnsToAggregate.length = 0;
	        this.columnsToGroup.length = 0;
	        this.columnsToPivot.length = 0;
	    };
	    /** Callback for when dragging */
	    BodyDropPivotTarget.prototype.onDragging = function (draggingEvent) {
	    };
	    /** Callback for when drag stops */
	    BodyDropPivotTarget.prototype.onDragStop = function (draggingEvent) {
	        if (this.columnsToAggregate.length > 0) {
	            this.columnController.addValueColumns(this.columnsToAggregate, "toolPanelDragAndDrop");
	        }
	        if (this.columnsToGroup.length > 0) {
	            this.columnController.addRowGroupColumns(this.columnsToGroup, "toolPanelDragAndDrop");
	        }
	        if (this.columnsToPivot.length > 0) {
	            this.columnController.addPivotColumns(this.columnsToPivot, "toolPanelDragAndDrop");
	        }
	    };
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], BodyDropPivotTarget.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], BodyDropPivotTarget.prototype, "gridOptionsWrapper", void 0);
	    return BodyDropPivotTarget;
	}());
	exports.BodyDropPivotTarget = BodyDropPivotTarget;


/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var dragAndDropService_1 = __webpack_require__(82);
	var context_1 = __webpack_require__(8);
	var moveColumnController_1 = __webpack_require__(656);
	var column_1 = __webpack_require__(45);
	var bodyDropPivotTarget_1 = __webpack_require__(651);
	var columnController_1 = __webpack_require__(26);
	var DropType;
	(function (DropType) {
	    DropType[DropType["ColumnMove"] = 0] = "ColumnMove";
	    DropType[DropType["Pivot"] = 1] = "Pivot";
	})(DropType || (DropType = {}));
	var BodyDropTarget = /** @class */ (function () {
	    function BodyDropTarget(pinned, eContainer) {
	        this.dropListeners = {};
	        this.pinned = pinned;
	        this.eContainer = eContainer;
	    }
	    BodyDropTarget.prototype.registerGridComp = function (gridPanel) {
	        this.gridPanel = gridPanel;
	        this.moveColumnController.registerGridComp(gridPanel);
	        switch (this.pinned) {
	            case column_1.Column.PINNED_LEFT:
	                this.eSecondaryContainers = this.gridPanel.getDropTargetLeftContainers();
	                break;
	            case column_1.Column.PINNED_RIGHT:
	                this.eSecondaryContainers = this.gridPanel.getDropTargetRightContainers();
	                break;
	            default:
	                this.eSecondaryContainers = this.gridPanel.getDropTargetBodyContainers();
	                break;
	        }
	    };
	    BodyDropTarget.prototype.isInterestedIn = function (type) {
	        // not interested in row drags
	        return type === dragAndDropService_1.DragSourceType.HeaderCell || type === dragAndDropService_1.DragSourceType.ToolPanel;
	    };
	    BodyDropTarget.prototype.getSecondaryContainers = function () {
	        return this.eSecondaryContainers;
	    };
	    BodyDropTarget.prototype.getContainer = function () {
	        return this.eContainer;
	    };
	    BodyDropTarget.prototype.init = function () {
	        this.moveColumnController = new moveColumnController_1.MoveColumnController(this.pinned, this.eContainer);
	        this.context.wireBean(this.moveColumnController);
	        var bodyDropPivotTarget = new bodyDropPivotTarget_1.BodyDropPivotTarget(this.pinned);
	        this.context.wireBean(bodyDropPivotTarget);
	        this.dropListeners[DropType.ColumnMove] = this.moveColumnController;
	        this.dropListeners[DropType.Pivot] = bodyDropPivotTarget;
	        this.dragAndDropService.addDropTarget(this);
	    };
	    BodyDropTarget.prototype.getIconName = function () {
	        return this.currentDropListener.getIconName();
	    };
	    // we want to use the bodyPivotTarget if the user is dragging columns in from the toolPanel
	    // and we are in pivot mode, as it has to logic to set pivot/value/group on the columns when
	    // dropped into the grid's body.
	    BodyDropTarget.prototype.getDropType = function (draggingEvent) {
	        if (this.columnController.isPivotMode()) {
	            // in pivot mode, then if moving a column (ie didn't come from toolpanel) then it's
	            // a standard column move, however if it came from teh toolpanel, then we are introducing
	            // dimensions or values to the grid
	            if (draggingEvent.dragSource.type === dragAndDropService_1.DragSourceType.ToolPanel) {
	                return DropType.Pivot;
	            }
	            else {
	                return DropType.ColumnMove;
	            }
	        }
	        else {
	            // it's a column, and not pivot mode, so always moving
	            return DropType.ColumnMove;
	        }
	    };
	    BodyDropTarget.prototype.onDragEnter = function (draggingEvent) {
	        // we pick the drop listener depending on whether we are in pivot mode are not. if we are
	        // in pivot mode, then dropping cols changes the row group, pivot, value stats. otherwise
	        // we change visibility state and position.
	        // if (this.columnController.isPivotMode()) {
	        var dropType = this.getDropType(draggingEvent);
	        this.currentDropListener = this.dropListeners[dropType];
	        this.currentDropListener.onDragEnter(draggingEvent);
	    };
	    BodyDropTarget.prototype.onDragLeave = function (params) {
	        this.currentDropListener.onDragLeave(params);
	    };
	    BodyDropTarget.prototype.onDragging = function (params) {
	        this.currentDropListener.onDragging(params);
	    };
	    BodyDropTarget.prototype.onDragStop = function (params) {
	        this.currentDropListener.onDragStop(params);
	    };
	    __decorate([
	        context_1.Autowired('context'),
	        __metadata("design:type", context_1.Context)
	    ], BodyDropTarget.prototype, "context", void 0);
	    __decorate([
	        context_1.Autowired('dragAndDropService'),
	        __metadata("design:type", dragAndDropService_1.DragAndDropService)
	    ], BodyDropTarget.prototype, "dragAndDropService", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], BodyDropTarget.prototype, "columnController", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], BodyDropTarget.prototype, "init", null);
	    return BodyDropTarget;
	}());
	exports.BodyDropTarget = BodyDropTarget;


/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(31);
	var context_1 = __webpack_require__(8);
	var column_1 = __webpack_require__(45);
	var dragAndDropService_1 = __webpack_require__(82);
	var columnApi_1 = __webpack_require__(38);
	var columnController_1 = __webpack_require__(26);
	var horizontalResizeService_1 = __webpack_require__(318);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var cssClassApplier_1 = __webpack_require__(430);
	var setLeftFeature_1 = __webpack_require__(322);
	var gridApi_1 = __webpack_require__(33);
	var sortController_1 = __webpack_require__(120);
	var eventService_1 = __webpack_require__(22);
	var userComponentFactory_1 = __webpack_require__(81);
	var agCheckbox_1 = __webpack_require__(199);
	var componentAnnotations_1 = __webpack_require__(39);
	var selectAllFeature_1 = __webpack_require__(1393);
	var events_1 = __webpack_require__(29);
	var columnHoverService_1 = __webpack_require__(252);
	var beans_1 = __webpack_require__(161);
	var hoverFeature_1 = __webpack_require__(432);
	var touchListener_1 = __webpack_require__(255);
	var utils_1 = __webpack_require__(10);
	var HeaderWrapperComp = /** @class */ (function (_super) {
	    __extends(HeaderWrapperComp, _super);
	    function HeaderWrapperComp(column, dragSourceDropTarget, pinned) {
	        var _this = _super.call(this, HeaderWrapperComp.TEMPLATE) || this;
	        _this.column = column;
	        _this.dragSourceDropTarget = dragSourceDropTarget;
	        _this.pinned = pinned;
	        return _this;
	    }
	    HeaderWrapperComp.prototype.getColumn = function () {
	        return this.column;
	    };
	    HeaderWrapperComp.prototype.getComponentHolder = function () {
	        return this.column.getColDef();
	    };
	    HeaderWrapperComp.prototype.init = function () {
	        var colDef = this.getComponentHolder();
	        var displayName = this.columnController.getDisplayNameForColumn(this.column, 'header', true);
	        var enableSorting = colDef.sortable;
	        var enableMenu = this.menuFactory.isMenuEnabled(this.column) && !colDef.suppressMenu;
	        this.appendHeaderComp(displayName, enableSorting, enableMenu);
	        this.setupWidth();
	        this.setupMovingCss();
	        this.setupTooltip();
	        this.setupResize();
	        this.setupMenuClass();
	        this.setupSortableClass(enableSorting);
	        this.addColumnHoverListener();
	        this.addFeature(this.getContext(), new hoverFeature_1.HoverFeature([this.column], this.getGui()));
	        this.addDestroyableEventListener(this.column, column_1.Column.EVENT_FILTER_ACTIVE_CHANGED, this.onFilterChanged.bind(this));
	        this.onFilterChanged();
	        this.addFeature(this.getContext(), new selectAllFeature_1.SelectAllFeature(this.cbSelectAll, this.column));
	        var setLeftFeature = new setLeftFeature_1.SetLeftFeature(this.column, this.getGui(), this.beans);
	        setLeftFeature.init();
	        this.addDestroyFunc(setLeftFeature.destroy.bind(setLeftFeature));
	        this.addAttributes();
	        cssClassApplier_1.CssClassApplier.addHeaderClassesFromColDef(colDef, this.getGui(), this.gridOptionsWrapper, this.column, null);
	    };
	    HeaderWrapperComp.prototype.addColumnHoverListener = function () {
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_COLUMN_HOVER_CHANGED, this.onColumnHover.bind(this));
	        this.onColumnHover();
	    };
	    HeaderWrapperComp.prototype.onColumnHover = function () {
	        var isHovered = this.columnHoverService.isHovered(this.column);
	        utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-column-hover', isHovered);
	    };
	    HeaderWrapperComp.prototype.setupSortableClass = function (enableSorting) {
	        if (enableSorting) {
	            var element = this.getGui();
	            utils_1._.addCssClass(element, 'ag-header-cell-sortable');
	        }
	    };
	    HeaderWrapperComp.prototype.onFilterChanged = function () {
	        var filterPresent = this.column.isFilterActive();
	        utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-header-cell-filtered', filterPresent);
	    };
	    HeaderWrapperComp.prototype.appendHeaderComp = function (displayName, enableSorting, enableMenu) {
	        var _this = this;
	        var params = {
	            column: this.column,
	            displayName: displayName,
	            enableSorting: enableSorting,
	            enableMenu: enableMenu,
	            showColumnMenu: function (source) {
	                _this.gridApi.showColumnMenuAfterButtonClick(_this.column, source);
	            },
	            progressSort: function (multiSort) {
	                _this.sortController.progressSort(_this.column, !!multiSort, "uiColumnSorted");
	            },
	            setSort: function (sort, multiSort) {
	                _this.sortController.setSortForColumn(_this.column, sort, !!multiSort, "uiColumnSorted");
	            },
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            context: this.gridOptionsWrapper.getContext()
	        };
	        var callback = this.afterHeaderCompCreated.bind(this, displayName);
	        this.userComponentFactory.newHeaderComponent(params).then(callback);
	    };
	    HeaderWrapperComp.prototype.afterHeaderCompCreated = function (displayName, headerComp) {
	        this.appendChild(headerComp);
	        this.setupMove(headerComp.getGui(), displayName);
	    };
	    HeaderWrapperComp.prototype.onColumnMovingChanged = function () {
	        // this function adds or removes the moving css, based on if the col is moving.
	        // this is what makes the header go dark when it is been moved (gives impression to
	        // user that the column was picked up).
	        if (this.column.isMoving()) {
	            utils_1._.addCssClass(this.getGui(), 'ag-header-cell-moving');
	        }
	        else {
	            utils_1._.removeCssClass(this.getGui(), 'ag-header-cell-moving');
	        }
	    };
	    HeaderWrapperComp.prototype.setupMove = function (eHeaderCellLabel, displayName) {
	        var _this = this;
	        var suppressMove = this.gridOptionsWrapper.isSuppressMovableColumns()
	            || this.getComponentHolder().suppressMovable
	            || this.column.getColDef().lockPosition;
	        if (suppressMove) {
	            return;
	        }
	        if (eHeaderCellLabel) {
	            var dragSource_1 = {
	                type: dragAndDropService_1.DragSourceType.HeaderCell,
	                eElement: eHeaderCellLabel,
	                dragItemCallback: function () { return _this.createDragItem(); },
	                dragItemName: displayName,
	                dragSourceDropTarget: this.dragSourceDropTarget,
	                dragStarted: function () { return _this.column.setMoving(true, "uiColumnMoved"); },
	                dragStopped: function () { return _this.column.setMoving(false, "uiColumnMoved"); }
	            };
	            this.dragAndDropService.addDragSource(dragSource_1, true);
	            this.addDestroyFunc(function () { return _this.dragAndDropService.removeDragSource(dragSource_1); });
	        }
	    };
	    HeaderWrapperComp.prototype.createDragItem = function () {
	        var visibleState = {};
	        visibleState[this.column.getId()] = this.column.isVisible();
	        return {
	            columns: [this.column],
	            visibleState: visibleState
	        };
	    };
	    HeaderWrapperComp.prototype.setupResize = function () {
	        var _this = this;
	        var colDef = this.getComponentHolder();
	        // if no eResize in template, do nothing
	        if (!this.eResize) {
	            return;
	        }
	        if (!this.column.isResizable()) {
	            utils_1._.removeFromParent(this.eResize);
	            return;
	        }
	        var finishedWithResizeFunc = this.horizontalResizeService.addResizeBar({
	            eResizeBar: this.eResize,
	            onResizeStart: this.onResizeStart.bind(this),
	            onResizing: this.onResizing.bind(this, false),
	            onResizeEnd: this.onResizing.bind(this, true)
	        });
	        this.addDestroyFunc(finishedWithResizeFunc);
	        var weWantAutoSize = !this.gridOptionsWrapper.isSuppressAutoSize() && !colDef.suppressAutoSize;
	        if (weWantAutoSize) {
	            this.addDestroyableEventListener(this.eResize, 'dblclick', function () {
	                _this.columnController.autoSizeColumn(_this.column, "uiColumnResized");
	            });
	            var touchListener = new touchListener_1.TouchListener(this.eResize);
	            this.addDestroyableEventListener(touchListener, touchListener_1.TouchListener.EVENT_DOUBLE_TAP, function () {
	                _this.columnController.autoSizeColumn(_this.column, "uiColumnResized");
	            });
	            this.addDestroyFunc(touchListener.destroy.bind(touchListener));
	        }
	    };
	    HeaderWrapperComp.prototype.onResizing = function (finished, resizeAmount) {
	        var resizeAmountNormalised = this.normaliseResizeAmount(resizeAmount);
	        var newWidth = this.resizeStartWidth + resizeAmountNormalised;
	        this.columnController.setColumnWidth(this.column, newWidth, this.resizeWithShiftKey, finished, "uiColumnDragged");
	        if (finished) {
	            utils_1._.removeCssClass(this.getGui(), 'ag-column-resizing');
	        }
	    };
	    HeaderWrapperComp.prototype.onResizeStart = function (shiftKey) {
	        this.resizeStartWidth = this.column.getActualWidth();
	        this.resizeWithShiftKey = shiftKey;
	        utils_1._.addCssClass(this.getGui(), 'ag-column-resizing');
	    };
	    HeaderWrapperComp.prototype.getTooltipText = function () {
	        var colDef = this.getComponentHolder();
	        return colDef.headerTooltip;
	    };
	    HeaderWrapperComp.prototype.setupTooltip = function () {
	        var tooltipText = this.getTooltipText();
	        // add tooltip if exists
	        if (tooltipText == null) {
	            return;
	        }
	        if (this.gridOptionsWrapper.isEnableBrowserTooltips()) {
	            this.getGui().setAttribute('title', tooltipText);
	        }
	        else {
	            this.beans.tooltipManager.registerTooltip(this);
	        }
	    };
	    HeaderWrapperComp.prototype.setupMovingCss = function () {
	        this.addDestroyableEventListener(this.column, column_1.Column.EVENT_MOVING_CHANGED, this.onColumnMovingChanged.bind(this));
	        this.onColumnMovingChanged();
	    };
	    HeaderWrapperComp.prototype.addAttributes = function () {
	        this.getGui().setAttribute("col-id", this.column.getColId());
	    };
	    HeaderWrapperComp.prototype.setupWidth = function () {
	        this.addDestroyableEventListener(this.column, column_1.Column.EVENT_WIDTH_CHANGED, this.onColumnWidthChanged.bind(this));
	        this.onColumnWidthChanged();
	    };
	    HeaderWrapperComp.prototype.setupMenuClass = function () {
	        this.addDestroyableEventListener(this.column, column_1.Column.EVENT_MENU_VISIBLE_CHANGED, this.onMenuVisible.bind(this));
	        this.onColumnWidthChanged();
	    };
	    HeaderWrapperComp.prototype.onMenuVisible = function () {
	        this.addOrRemoveCssClass('ag-column-menu-visible', this.column.isMenuVisible());
	    };
	    HeaderWrapperComp.prototype.onColumnWidthChanged = function () {
	        this.getGui().style.width = this.column.getActualWidth() + 'px';
	    };
	    // optionally inverts the drag, depending on pinned and RTL
	    // note - this method is duplicated in RenderedHeaderGroupCell - should refactor out?
	    HeaderWrapperComp.prototype.normaliseResizeAmount = function (dragChange) {
	        var result = dragChange;
	        if (this.gridOptionsWrapper.isEnableRtl()) {
	            // for RTL, dragging left makes the col bigger, except when pinning left
	            if (this.pinned !== column_1.Column.PINNED_LEFT) {
	                result *= -1;
	            }
	        }
	        else {
	            // for LTR (ie normal), dragging left makes the col smaller, except when pinning right
	            if (this.pinned === column_1.Column.PINNED_RIGHT) {
	                result *= -1;
	            }
	        }
	        return result;
	    };
	    HeaderWrapperComp.TEMPLATE = '<div class="ag-header-cell" role="presentation" unselectable="on">' +
	        '<div ref="eResize" class="ag-header-cell-resize" role="presentation"></div>' +
	        '<ag-checkbox ref="cbSelectAll" class="ag-header-select-all" role="presentation"></ag-checkbox>' +
	        // <inner component goes here>
	        '</div>';
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], HeaderWrapperComp.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('dragAndDropService'),
	        __metadata("design:type", dragAndDropService_1.DragAndDropService)
	    ], HeaderWrapperComp.prototype, "dragAndDropService", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], HeaderWrapperComp.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('horizontalResizeService'),
	        __metadata("design:type", horizontalResizeService_1.HorizontalResizeService)
	    ], HeaderWrapperComp.prototype, "horizontalResizeService", void 0);
	    __decorate([
	        context_1.Autowired('menuFactory'),
	        __metadata("design:type", Object)
	    ], HeaderWrapperComp.prototype, "menuFactory", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], HeaderWrapperComp.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], HeaderWrapperComp.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('sortController'),
	        __metadata("design:type", sortController_1.SortController)
	    ], HeaderWrapperComp.prototype, "sortController", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], HeaderWrapperComp.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('userComponentFactory'),
	        __metadata("design:type", userComponentFactory_1.UserComponentFactory)
	    ], HeaderWrapperComp.prototype, "userComponentFactory", void 0);
	    __decorate([
	        context_1.Autowired('columnHoverService'),
	        __metadata("design:type", columnHoverService_1.ColumnHoverService)
	    ], HeaderWrapperComp.prototype, "columnHoverService", void 0);
	    __decorate([
	        context_1.Autowired('beans'),
	        __metadata("design:type", beans_1.Beans)
	    ], HeaderWrapperComp.prototype, "beans", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eResize'),
	        __metadata("design:type", HTMLElement)
	    ], HeaderWrapperComp.prototype, "eResize", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('cbSelectAll'),
	        __metadata("design:type", agCheckbox_1.AgCheckbox)
	    ], HeaderWrapperComp.prototype, "cbSelectAll", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], HeaderWrapperComp.prototype, "init", null);
	    return HeaderWrapperComp;
	}(component_1.Component));
	exports.HeaderWrapperComp = HeaderWrapperComp;


/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var context_1 = __webpack_require__(8);
	var dragAndDropService_1 = __webpack_require__(82);
	var columnController_1 = __webpack_require__(26);
	var eventService_1 = __webpack_require__(22);
	var events_1 = __webpack_require__(29);
	var headerRowComp_1 = __webpack_require__(655);
	var bodyDropTarget_1 = __webpack_require__(652);
	var column_1 = __webpack_require__(45);
	var scrollVisibleService_1 = __webpack_require__(249);
	var utils_1 = __webpack_require__(10);
	var HeaderContainer = /** @class */ (function () {
	    function HeaderContainer(eContainer, eViewport, pinned) {
	        this.headerRowComps = [];
	        this.eContainer = eContainer;
	        this.pinned = pinned;
	        this.eViewport = eViewport;
	    }
	    HeaderContainer.prototype.registerGridComp = function (gridPanel) {
	        this.setupDragAndDrop(gridPanel);
	    };
	    HeaderContainer.prototype.forEachHeaderElement = function (callback) {
	        this.headerRowComps.forEach(function (headerRowComp) { return headerRowComp.forEachHeaderElement(callback); });
	    };
	    HeaderContainer.prototype.init = function () {
	        this.scrollWidth = this.gridOptionsWrapper.getScrollbarWidth();
	        // if value changes, then if not pivoting, we at least need to change the label eg from sum() to avg(),
	        // if pivoting, then the columns have changed
	        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_VALUE_CHANGED, this.onColumnValueChanged.bind(this));
	        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.onColumnRowGroupChanged.bind(this));
	        this.eventService.addEventListener(events_1.Events.EVENT_GRID_COLUMNS_CHANGED, this.onGridColumnsChanged.bind(this));
	        this.eventService.addEventListener(events_1.Events.EVENT_SCROLL_VISIBILITY_CHANGED, this.onScrollVisibilityChanged.bind(this));
	        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_RESIZED, this.onColumnResized.bind(this));
	        this.eventService.addEventListener(events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
	    };
	    // if row group changes, that means we may need to add aggFuncs to the column headers,
	    // if the grid goes from no aggregation (ie no grouping) to grouping
	    HeaderContainer.prototype.onColumnRowGroupChanged = function () {
	        this.onGridColumnsChanged();
	    };
	    // if the agg func of a column changes, then we may need to update the agg func in columns header
	    HeaderContainer.prototype.onColumnValueChanged = function () {
	        this.onGridColumnsChanged();
	    };
	    HeaderContainer.prototype.onColumnResized = function () {
	        this.setWidthOfPinnedContainer();
	    };
	    HeaderContainer.prototype.onDisplayedColumnsChanged = function () {
	        this.setWidthOfPinnedContainer();
	    };
	    HeaderContainer.prototype.onScrollVisibilityChanged = function () {
	        this.setWidthOfPinnedContainer();
	    };
	    HeaderContainer.prototype.setWidthOfPinnedContainer = function () {
	        var pinningLeft = this.pinned === column_1.Column.PINNED_LEFT;
	        var pinningRight = this.pinned === column_1.Column.PINNED_RIGHT;
	        var controller = this.columnController;
	        var isRtl = this.gridOptionsWrapper.isEnableRtl();
	        if (pinningLeft || pinningRight) {
	            // size to fit all columns
	            var width = controller[pinningLeft ? 'getPinnedLeftContainerWidth' : 'getPinnedRightContainerWidth']();
	            // if there is a scroll showing (and taking up space, so Windows, and not iOS)
	            // in the body, then we add extra space to keep header aligned with the body,
	            // as body width fits the cols and the scrollbar
	            var addPaddingForScrollbar = this.scrollVisibleService.isVerticalScrollShowing() && ((isRtl && pinningLeft) || (!isRtl && pinningRight));
	            if (addPaddingForScrollbar) {
	                width += this.scrollWidth;
	            }
	            utils_1._.setFixedWidth(this.eContainer, width);
	        }
	    };
	    HeaderContainer.prototype.destroy = function () {
	        this.removeHeaderRowComps();
	    };
	    HeaderContainer.prototype.getRowComps = function () {
	        return this.headerRowComps;
	    };
	    // grid cols have changed - this also means the number of rows in the header can have
	    // changed. so we remove all the old rows and insert new ones for a complete refresh
	    HeaderContainer.prototype.onGridColumnsChanged = function () {
	        this.removeAndCreateAllRowComps();
	    };
	    HeaderContainer.prototype.removeAndCreateAllRowComps = function () {
	        this.removeHeaderRowComps();
	        this.createHeaderRowComps();
	    };
	    // we expose this for gridOptions.api.refreshHeader() to call
	    HeaderContainer.prototype.refresh = function () {
	        this.removeAndCreateAllRowComps();
	    };
	    HeaderContainer.prototype.setupDragAndDrop = function (gridComp) {
	        var dropContainer = this.eViewport ? this.eViewport : this.eContainer;
	        var bodyDropTarget = new bodyDropTarget_1.BodyDropTarget(this.pinned, dropContainer);
	        this.context.wireBean(bodyDropTarget);
	        bodyDropTarget.registerGridComp(gridComp);
	    };
	    HeaderContainer.prototype.removeHeaderRowComps = function () {
	        this.headerRowComps.forEach(function (headerRowComp) {
	            headerRowComp.destroy();
	        });
	        this.headerRowComps.length = 0;
	        utils_1._.clearElement(this.eContainer);
	    };
	    HeaderContainer.prototype.createHeaderRowComps = function () {
	        // if we are displaying header groups, then we have many rows here.
	        // go through each row of the header, one by one.
	        var rowCount = this.columnController.getHeaderRowCount();
	        for (var dept = 0; dept < rowCount; dept++) {
	            var groupRow = dept !== (rowCount - 1);
	            var type = groupRow ? headerRowComp_1.HeaderRowType.COLUMN_GROUP : headerRowComp_1.HeaderRowType.COLUMN;
	            var headerRowComp = new headerRowComp_1.HeaderRowComp(dept, type, this.pinned, this.dropTarget);
	            this.context.wireBean(headerRowComp);
	            this.headerRowComps.push(headerRowComp);
	            headerRowComp.getGui().setAttribute('aria-rowindex', this.headerRowComps.length.toString());
	            this.eContainer.appendChild(headerRowComp.getGui());
	        }
	        var includeFloatingFilterRow = this.gridOptionsWrapper.isFloatingFilter() && !this.columnController.isPivotMode();
	        if (includeFloatingFilterRow) {
	            var headerRowComp = new headerRowComp_1.HeaderRowComp(rowCount, headerRowComp_1.HeaderRowType.FLOATING_FILTER, this.pinned, this.dropTarget);
	            this.context.wireBean(headerRowComp);
	            this.headerRowComps.push(headerRowComp);
	            headerRowComp.getGui().setAttribute('aria-rowindex', this.headerRowComps.length.toString());
	            this.eContainer.appendChild(headerRowComp.getGui());
	        }
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], HeaderContainer.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('context'),
	        __metadata("design:type", context_1.Context)
	    ], HeaderContainer.prototype, "context", void 0);
	    __decorate([
	        context_1.Autowired('$scope'),
	        __metadata("design:type", Object)
	    ], HeaderContainer.prototype, "$scope", void 0);
	    __decorate([
	        context_1.Autowired('dragAndDropService'),
	        __metadata("design:type", dragAndDropService_1.DragAndDropService)
	    ], HeaderContainer.prototype, "dragAndDropService", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], HeaderContainer.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], HeaderContainer.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('scrollVisibleService'),
	        __metadata("design:type", scrollVisibleService_1.ScrollVisibleService)
	    ], HeaderContainer.prototype, "scrollVisibleService", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], HeaderContainer.prototype, "init", null);
	    return HeaderContainer;
	}());
	exports.HeaderContainer = HeaderContainer;


/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(31);
	var context_1 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var columnController_1 = __webpack_require__(26);
	var column_1 = __webpack_require__(45);
	var eventService_1 = __webpack_require__(22);
	var events_1 = __webpack_require__(29);
	var headerWrapperComp_1 = __webpack_require__(653);
	var headerGroupWrapperComp_1 = __webpack_require__(1395);
	var filterManager_1 = __webpack_require__(77);
	var gridApi_1 = __webpack_require__(33);
	var constants_1 = __webpack_require__(30);
	var utils_1 = __webpack_require__(10);
	var floatingFilterWrapper_1 = __webpack_require__(1384);
	var HeaderRowType;
	(function (HeaderRowType) {
	    HeaderRowType[HeaderRowType["COLUMN_GROUP"] = 0] = "COLUMN_GROUP";
	    HeaderRowType[HeaderRowType["COLUMN"] = 1] = "COLUMN";
	    HeaderRowType[HeaderRowType["FLOATING_FILTER"] = 2] = "FLOATING_FILTER";
	})(HeaderRowType = exports.HeaderRowType || (exports.HeaderRowType = {}));
	var HeaderRowComp = /** @class */ (function (_super) {
	    __extends(HeaderRowComp, _super);
	    function HeaderRowComp(dept, type, pinned, dropTarget) {
	        var _this = _super.call(this, "<div class=\"ag-header-row\" role=\"row\"/>") || this;
	        _this.headerComps = {};
	        _this.dept = dept;
	        _this.type = type;
	        _this.pinned = pinned;
	        _this.dropTarget = dropTarget;
	        return _this;
	    }
	    HeaderRowComp.prototype.forEachHeaderElement = function (callback) {
	        var _this = this;
	        Object.keys(this.headerComps).forEach(function (key) {
	            callback(_this.headerComps[key]);
	        });
	    };
	    HeaderRowComp.prototype.destroy = function () {
	        var idsOfAllChildren = Object.keys(this.headerComps);
	        this.removeAndDestroyChildComponents(idsOfAllChildren);
	        _super.prototype.destroy.call(this);
	    };
	    HeaderRowComp.prototype.removeAndDestroyChildComponents = function (idsToDestroy) {
	        var _this = this;
	        idsToDestroy.forEach(function (id) {
	            var childHeaderComp = _this.headerComps[id];
	            _this.getGui().removeChild(childHeaderComp.getGui());
	            childHeaderComp.destroy();
	            delete _this.headerComps[id];
	        });
	    };
	    HeaderRowComp.prototype.onRowHeightChanged = function () {
	        var headerRowCount = this.columnController.getHeaderRowCount();
	        var sizes = [];
	        var numberOfFloating = 0;
	        var groupHeight;
	        var headerHeight;
	        if (!this.columnController.isPivotMode()) {
	            if (this.gridOptionsWrapper.isFloatingFilter()) {
	                headerRowCount++;
	            }
	            numberOfFloating = (this.gridOptionsWrapper.isFloatingFilter()) ? 1 : 0;
	            groupHeight = this.gridOptionsWrapper.getGroupHeaderHeight();
	            headerHeight = this.gridOptionsWrapper.getHeaderHeight();
	        }
	        else {
	            numberOfFloating = 0;
	            groupHeight = this.gridOptionsWrapper.getPivotGroupHeaderHeight();
	            headerHeight = this.gridOptionsWrapper.getPivotHeaderHeight();
	        }
	        var numberOfNonGroups = 1 + numberOfFloating;
	        var numberOfGroups = headerRowCount - numberOfNonGroups;
	        for (var i = 0; i < numberOfGroups; i++) {
	            sizes.push(groupHeight);
	        }
	        sizes.push(headerHeight);
	        for (var i = 0; i < numberOfFloating; i++) {
	            sizes.push(this.gridOptionsWrapper.getFloatingFiltersHeight());
	        }
	        var rowHeight = 0;
	        for (var i = 0; i < this.dept; i++) {
	            rowHeight += sizes[i];
	        }
	        this.getGui().style.top = rowHeight + 'px';
	        this.getGui().style.height = sizes[this.dept] + 'px';
	    };
	    //noinspection JSUnusedLocalSymbols
	    HeaderRowComp.prototype.init = function () {
	        this.onRowHeightChanged();
	        this.onVirtualColumnsChanged();
	        this.setWidth();
	        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_HEADER_HEIGHT, this.onRowHeightChanged.bind(this));
	        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_PIVOT_HEADER_HEIGHT, this.onRowHeightChanged.bind(this));
	        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_GROUP_HEADER_HEIGHT, this.onRowHeightChanged.bind(this));
	        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_PIVOT_GROUP_HEADER_HEIGHT, this.onRowHeightChanged.bind(this));
	        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_FLOATING_FILTERS_HEIGHT, this.onRowHeightChanged.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_VIRTUAL_COLUMNS_CHANGED, this.onVirtualColumnsChanged.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_COLUMN_RESIZED, this.onColumnResized.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_GRID_COLUMNS_CHANGED, this.onGridColumnsChanged.bind(this));
	    };
	    HeaderRowComp.prototype.onColumnResized = function () {
	        this.setWidth();
	    };
	    HeaderRowComp.prototype.setWidth = function () {
	        var width = this.getWidthForRow();
	        this.getGui().style.width = width + 'px';
	    };
	    HeaderRowComp.prototype.getWidthForRow = function () {
	        var printLayout = this.gridOptionsWrapper.getDomLayout() === constants_1.Constants.DOM_LAYOUT_PRINT;
	        if (printLayout) {
	            var centerRow = utils_1._.missing(this.pinned);
	            if (centerRow) {
	                return this.columnController.getContainerWidth(column_1.Column.PINNED_RIGHT)
	                    + this.columnController.getContainerWidth(column_1.Column.PINNED_LEFT)
	                    + this.columnController.getContainerWidth(null);
	            }
	            else {
	                return 0;
	            }
	        }
	        else {
	            // if not printing, just return the width as normal
	            return this.columnController.getContainerWidth(this.pinned);
	        }
	    };
	    HeaderRowComp.prototype.onGridColumnsChanged = function () {
	        this.removeAndDestroyAllChildComponents();
	    };
	    HeaderRowComp.prototype.removeAndDestroyAllChildComponents = function () {
	        var idsOfAllChildren = Object.keys(this.headerComps);
	        this.removeAndDestroyChildComponents(idsOfAllChildren);
	    };
	    HeaderRowComp.prototype.onDisplayedColumnsChanged = function () {
	        this.onVirtualColumnsChanged();
	        this.setWidth();
	    };
	    HeaderRowComp.prototype.getItemsAtDept = function () {
	        var _this = this;
	        var printLayout = this.gridOptionsWrapper.getDomLayout() === constants_1.Constants.DOM_LAYOUT_PRINT;
	        if (printLayout) {
	            // for print layout, we add all columns into the center
	            var centerContainer = utils_1._.missing(this.pinned);
	            if (centerContainer) {
	                var result_1 = [];
	                [column_1.Column.PINNED_LEFT, null, column_1.Column.PINNED_RIGHT].forEach(function (pinned) {
	                    var items = _this.columnController.getVirtualHeaderGroupRow(pinned, _this.type == HeaderRowType.FLOATING_FILTER ?
	                        _this.dept - 1 :
	                        _this.dept);
	                    result_1 = result_1.concat(items);
	                });
	                return result_1;
	            }
	            else {
	                return [];
	            }
	        }
	        else {
	            // when in normal layout, we add the columns for that container only
	            return this.columnController.getVirtualHeaderGroupRow(this.pinned, this.type == HeaderRowType.FLOATING_FILTER ?
	                this.dept - 1 :
	                this.dept);
	        }
	    };
	    HeaderRowComp.prototype.onVirtualColumnsChanged = function () {
	        var _this = this;
	        var currentChildIds = Object.keys(this.headerComps);
	        var itemsAtDepth = this.getItemsAtDept();
	        var ensureDomOrder = this.gridOptionsWrapper.isEnsureDomOrder();
	        var eBefore;
	        itemsAtDepth.forEach(function (child) {
	            // skip groups that have no displayed children. this can happen when the group is broken,
	            // and this section happens to have nothing to display for the open / closed state.
	            // (a broken group is one that is split, ie columns in the group have a non-group column
	            // in between them)
	            if (child.isEmptyGroup()) {
	                return;
	            }
	            var idOfChild = child.getUniqueId();
	            var eParentContainer = _this.getGui();
	            // if we already have this cell rendered, do nothing
	            var colAlreadyInDom = currentChildIds.indexOf(idOfChild) >= 0;
	            var headerComp;
	            var eHeaderCompGui;
	            if (colAlreadyInDom) {
	                utils_1._.removeFromArray(currentChildIds, idOfChild);
	                headerComp = _this.headerComps[idOfChild];
	                eHeaderCompGui = headerComp.getGui();
	                if (ensureDomOrder) {
	                    utils_1._.ensureDomOrder(eParentContainer, eHeaderCompGui, eBefore);
	                }
	                eBefore = eHeaderCompGui;
	            }
	            else {
	                headerComp = _this.createHeaderComp(child);
	                _this.headerComps[idOfChild] = headerComp;
	                eHeaderCompGui = headerComp.getGui();
	                if (ensureDomOrder) {
	                    utils_1._.insertWithDomOrder(eParentContainer, eHeaderCompGui, eBefore);
	                }
	                else {
	                    eParentContainer.appendChild(eHeaderCompGui);
	                }
	                eBefore = eHeaderCompGui;
	            }
	        });
	        // at this point, anything left in currentChildIds is an element that is no longer in the viewport
	        this.removeAndDestroyChildComponents(currentChildIds);
	    };
	    HeaderRowComp.prototype.createHeaderComp = function (columnGroupChild) {
	        var result;
	        switch (this.type) {
	            case HeaderRowType.COLUMN:
	                result = new headerWrapperComp_1.HeaderWrapperComp(columnGroupChild, this.dropTarget, this.pinned);
	                break;
	            case HeaderRowType.COLUMN_GROUP:
	                result = new headerGroupWrapperComp_1.HeaderGroupWrapperComp(columnGroupChild, this.dropTarget, this.pinned);
	                break;
	            case HeaderRowType.FLOATING_FILTER:
	                result = new floatingFilterWrapper_1.FloatingFilterWrapper(columnGroupChild);
	                break;
	        }
	        this.getContext().wireBean(result);
	        return result;
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], HeaderRowComp.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], HeaderRowComp.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], HeaderRowComp.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], HeaderRowComp.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('filterManager'),
	        __metadata("design:type", filterManager_1.FilterManager)
	    ], HeaderRowComp.prototype, "filterManager", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], HeaderRowComp.prototype, "init", null);
	    return HeaderRowComp;
	}(component_1.Component));
	exports.HeaderRowComp = HeaderRowComp;


/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var logger_1 = __webpack_require__(68);
	var columnController_1 = __webpack_require__(26);
	var column_1 = __webpack_require__(45);
	var utils_1 = __webpack_require__(10);
	var dragAndDropService_1 = __webpack_require__(82);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var MoveColumnController = /** @class */ (function () {
	    function MoveColumnController(pinned, eContainer) {
	        this.needToMoveLeft = false;
	        this.needToMoveRight = false;
	        this.pinned = pinned;
	        this.eContainer = eContainer;
	        this.centerContainer = !utils_1._.exists(pinned);
	    }
	    MoveColumnController.prototype.registerGridComp = function (gridPanel) {
	        this.gridPanel = gridPanel;
	    };
	    MoveColumnController.prototype.init = function () {
	        this.logger = this.loggerFactory.create('MoveColumnController');
	    };
	    MoveColumnController.prototype.getIconName = function () {
	        return this.pinned ? dragAndDropService_1.DragAndDropService.ICON_PINNED : dragAndDropService_1.DragAndDropService.ICON_MOVE;
	    };
	    MoveColumnController.prototype.onDragEnter = function (draggingEvent) {
	        // we do dummy drag, so make sure column appears in the right location when first placed
	        var columns = draggingEvent.dragItem.columns;
	        var dragCameFromToolPanel = draggingEvent.dragSource.type === dragAndDropService_1.DragSourceType.ToolPanel;
	        if (dragCameFromToolPanel) {
	            // the if statement doesn't work if drag leaves grid, then enters again
	            this.setColumnsVisible(columns, true, "uiColumnDragged");
	        }
	        else {
	            // restore previous state of visible columns upon re-entering. this means if the user drags
	            // a group out, and then drags the group back in, only columns that were originally visible
	            // will be visible again. otherwise a group with three columns (but only two visible) could
	            // be dragged out, then when it's dragged in again, all three are visible. this stops that.
	            var visibleState_1 = draggingEvent.dragItem.visibleState;
	            var visibleColumns = columns.filter(function (column) { return visibleState_1[column.getId()]; });
	            this.setColumnsVisible(visibleColumns, true, "uiColumnDragged");
	        }
	        this.setColumnsPinned(columns, this.pinned, "uiColumnDragged");
	        this.onDragging(draggingEvent, true);
	    };
	    MoveColumnController.prototype.onDragLeave = function (draggingEvent) {
	        var hideColumnOnExit = !this.gridOptionsWrapper.isSuppressDragLeaveHidesColumns() && !draggingEvent.fromNudge;
	        if (hideColumnOnExit) {
	            var dragItem = draggingEvent.dragSource.dragItemCallback();
	            var columns = dragItem.columns;
	            this.setColumnsVisible(columns, false, "uiColumnDragged");
	        }
	        this.ensureIntervalCleared();
	    };
	    MoveColumnController.prototype.setColumnsVisible = function (columns, visible, source) {
	        if (source === void 0) { source = "api"; }
	        if (columns) {
	            var allowedCols = columns.filter(function (c) { return !c.getColDef().lockVisible; });
	            this.columnController.setColumnsVisible(allowedCols, visible, source);
	        }
	    };
	    MoveColumnController.prototype.setColumnsPinned = function (columns, pinned, source) {
	        if (source === void 0) { source = "api"; }
	        if (columns) {
	            var allowedCols = columns.filter(function (c) { return !c.getColDef().lockPinned; });
	            this.columnController.setColumnsPinned(allowedCols, pinned, source);
	        }
	    };
	    MoveColumnController.prototype.onDragStop = function () {
	        this.ensureIntervalCleared();
	    };
	    MoveColumnController.prototype.normaliseX = function (x) {
	        // flip the coordinate if doing RTL
	        var flipHorizontallyForRtl = this.gridOptionsWrapper.isEnableRtl();
	        if (flipHorizontallyForRtl) {
	            var clientWidth = this.eContainer.clientWidth;
	            x = clientWidth - x;
	        }
	        // adjust for scroll only if centre container (the pinned containers dont scroll)
	        var adjustForScroll = this.centerContainer;
	        if (adjustForScroll) {
	            x += this.gridPanel.getCenterViewportScrollLeft();
	        }
	        return x;
	    };
	    MoveColumnController.prototype.checkCenterForScrolling = function (xAdjustedForScroll) {
	        if (this.centerContainer) {
	            // scroll if the mouse has gone outside the grid (or just outside the scrollable part if pinning)
	            // putting in 50 buffer, so even if user gets to edge of grid, a scroll will happen
	            var firstVisiblePixel = this.gridPanel.getCenterViewportScrollLeft();
	            var lastVisiblePixel = firstVisiblePixel + this.gridPanel.getCenterWidth();
	            if (this.gridOptionsWrapper.isEnableRtl()) {
	                this.needToMoveRight = xAdjustedForScroll < (firstVisiblePixel + 50);
	                this.needToMoveLeft = xAdjustedForScroll > (lastVisiblePixel - 50);
	            }
	            else {
	                this.needToMoveLeft = xAdjustedForScroll < (firstVisiblePixel + 50);
	                this.needToMoveRight = xAdjustedForScroll > (lastVisiblePixel - 50);
	            }
	            if (this.needToMoveLeft || this.needToMoveRight) {
	                this.ensureIntervalStarted();
	            }
	            else {
	                this.ensureIntervalCleared();
	            }
	        }
	    };
	    MoveColumnController.prototype.onDragging = function (draggingEvent, fromEnter) {
	        var _this = this;
	        if (fromEnter === void 0) { fromEnter = false; }
	        this.lastDraggingEvent = draggingEvent;
	        // if moving up or down (ie not left or right) then do nothing
	        if (utils_1._.missing(draggingEvent.hDirection)) {
	            return;
	        }
	        var mouseXNormalised = this.normaliseX(draggingEvent.x);
	        // if the user is dragging into the panel, ie coming from the side panel into the main grid,
	        // we don't want to scroll the grid this time, it would appear like the table is jumping
	        // each time a column is dragged in.
	        if (!fromEnter) {
	            this.checkCenterForScrolling(mouseXNormalised);
	        }
	        var hDirectionNormalised = this.normaliseDirection(draggingEvent.hDirection);
	        var dragSourceType = draggingEvent.dragSource.type;
	        var columnsToMove = draggingEvent.dragSource.dragItemCallback().columns;
	        columnsToMove = columnsToMove.filter(function (col) {
	            if (col.getColDef().lockPinned) {
	                // if locked return true only if both col and container are same pin type.
	                // double equals (==) here on purpose so that null==undefined is true (for not pinned options)
	                return col.getPinned() == _this.pinned;
	            }
	            else {
	                // if not pin locked, then always allowed to be in this container
	                return true;
	            }
	        });
	        this.attemptMoveColumns(dragSourceType, columnsToMove, hDirectionNormalised, mouseXNormalised, fromEnter);
	    };
	    MoveColumnController.prototype.normaliseDirection = function (hDirection) {
	        if (this.gridOptionsWrapper.isEnableRtl()) {
	            switch (hDirection) {
	                case dragAndDropService_1.HDirection.Left: return dragAndDropService_1.HDirection.Right;
	                case dragAndDropService_1.HDirection.Right: return dragAndDropService_1.HDirection.Left;
	                default: console.error("ag-Grid: Unknown direction " + hDirection);
	            }
	        }
	        else {
	            return hDirection;
	        }
	    };
	    // returns the index of the first column in the list ONLY if the cols are all beside
	    // each other. if the cols are not beside each other, then returns null
	    MoveColumnController.prototype.calculateOldIndex = function (movingCols) {
	        var gridCols = this.columnController.getAllGridColumns();
	        var indexes = [];
	        movingCols.forEach(function (col) { return indexes.push(gridCols.indexOf(col)); });
	        utils_1._.sortNumberArray(indexes);
	        var firstIndex = indexes[0];
	        var lastIndex = utils_1._.last(indexes);
	        var spread = lastIndex - firstIndex;
	        var gapsExist = spread !== indexes.length - 1;
	        return gapsExist ? null : firstIndex;
	    };
	    MoveColumnController.prototype.attemptMoveColumns = function (dragSourceType, allMovingColumns, hDirection, mouseX, fromEnter) {
	        var draggingLeft = hDirection === dragAndDropService_1.HDirection.Left;
	        var draggingRight = hDirection === dragAndDropService_1.HDirection.Right;
	        var validMoves = this.calculateValidMoves(allMovingColumns, draggingRight, mouseX);
	        // if cols are not adjacent, then this returns null. when moving, we constrain the direction of the move
	        // (ie left or right) to the mouse direction. however
	        var oldIndex = this.calculateOldIndex(allMovingColumns);
	        if (validMoves.length === 0) {
	            return;
	        }
	        var firstValidMove = validMoves[0];
	        // the two check below stop an error when the user grabs a group my a middle column, then
	        // it is possible the mouse pointer is to the right of a column while been dragged left.
	        // so we need to make sure that the mouse pointer is actually left of the left most column
	        // if moving left, and right of the right most column if moving right
	        // we check 'fromEnter' below so we move the column to the new spot if the mouse is coming from
	        // outside the grid, eg if the column is moving from side panel, mouse is moving left, then we should
	        // place the column to the RHS even if the mouse is moving left and the column is already on
	        // the LHS. otherwise we stick to the rule described above.
	        var constrainDirection = oldIndex !== null && !fromEnter;
	        // don't consider 'fromEnter' when dragging header cells, otherwise group can jump to opposite direction of drag
	        if (dragSourceType == dragAndDropService_1.DragSourceType.HeaderCell) {
	            constrainDirection = oldIndex !== null;
	        }
	        if (constrainDirection) {
	            // only allow left drag if this column is moving left
	            if (draggingLeft && firstValidMove >= oldIndex) {
	                return;
	            }
	            // only allow right drag if this column is moving right
	            if (draggingRight && firstValidMove <= oldIndex) {
	                return;
	            }
	        }
	        for (var i = 0; i < validMoves.length; i++) {
	            var move = validMoves[i];
	            if (!this.columnController.doesMovePassRules(allMovingColumns, move)) {
	                continue;
	            }
	            this.columnController.moveColumns(allMovingColumns, move, "uiColumnDragged");
	            // important to return here, so once we do the first valid move, we don't try do any more
	            return;
	        }
	    };
	    MoveColumnController.prototype.calculateValidMoves = function (movingCols, draggingRight, mouseX) {
	        // this is the list of cols on the screen, so it's these we use when comparing the x mouse position
	        var allDisplayedCols = this.columnController.getDisplayedColumns(this.pinned);
	        // but this list is the list of all cols, when we move a col it's the index within this list that gets used,
	        // so the result we return has to be and index location for this list
	        var allGridCols = this.columnController.getAllGridColumns();
	        var colIsMovingFunc = function (col) { return movingCols.indexOf(col) >= 0; };
	        var colIsNotMovingFunc = function (col) { return movingCols.indexOf(col) < 0; };
	        var movingDisplayedCols = allDisplayedCols.filter(colIsMovingFunc);
	        var otherDisplayedCols = allDisplayedCols.filter(colIsNotMovingFunc);
	        var otherGridCols = allGridCols.filter(colIsNotMovingFunc);
	        // work out how many DISPLAYED columns fit before the 'x' position. this gives us the displayIndex.
	        // for example, if cols are a,b,c,d and we find a,b fit before 'x', then we want to place the moving
	        // col between b and c (so that it is under the mouse position).
	        var displayIndex = 0;
	        var availableWidth = mouseX;
	        // if we are dragging right, then the columns will be to the left of the mouse, so we also want to
	        // include the width of the moving columns
	        if (draggingRight) {
	            var widthOfMovingDisplayedCols_1 = 0;
	            movingDisplayedCols.forEach(function (col) { return widthOfMovingDisplayedCols_1 += col.getActualWidth(); });
	            availableWidth -= widthOfMovingDisplayedCols_1;
	        }
	        if (availableWidth > 0) {
	            // now count how many of the displayed columns will fit to the left
	            for (var i = 0; i < otherDisplayedCols.length; i++) {
	                var col = otherDisplayedCols[i];
	                availableWidth -= col.getActualWidth();
	                if (availableWidth < 0) {
	                    break;
	                }
	                displayIndex++;
	            }
	            // trial and error, if going right, we adjust by one, i didn't manage to quantify why, but it works
	            if (draggingRight) {
	                displayIndex++;
	            }
	        }
	        // the display index is with respect to all the showing columns, however when we move, it's with
	        // respect to all grid columns, so we need to translate from display index to grid index
	        var firstValidMove;
	        if (displayIndex > 0) {
	            var leftColumn = otherDisplayedCols[displayIndex - 1];
	            firstValidMove = otherGridCols.indexOf(leftColumn) + 1;
	        }
	        else {
	            firstValidMove = 0;
	        }
	        var validMoves = [firstValidMove];
	        // add in other valid moves due to hidden columns and married children. for example, a particular
	        // move might break a group that has married children (so move isn't valid), however there could
	        // be hidden columns (not displayed) that we could jump over to make the move valid. because
	        // they are hidden, user doesn't see any different, however it allows moves that would otherwise
	        // not work. for example imagine a group with 9 columns and all columns are hidden except the
	        // middle one (so 4 hidden to left, 4 hidden to right), then when moving 'firstValidMove' will
	        // be relative to the not-shown column, however we need to consider the move jumping over all the
	        // hidden children. if we didn't do this, then if the group just described was at the end (RHS) of the
	        // grid, there would be no way to put a column after it (as the grid would only consider beside the
	        // visible column, which would fail valid move rules).
	        if (draggingRight) {
	            // if dragging right, then we add all the additional moves to the right. so in other words
	            // if the next move is not valid, find the next move to the right that is valid.
	            var pointer = firstValidMove + 1;
	            var lastIndex = allGridCols.length - 1;
	            while (pointer <= lastIndex) {
	                validMoves.push(pointer);
	                pointer++;
	            }
	        }
	        else {
	            // if dragging left we do the reverse of dragging right, we add in all the valid moves to the
	            // left. however we also have to consider moves to the right for all hidden columns first.
	            // (this logic is hard to reason with, it was worked out with trial and error,
	            // move observation rather than science).
	            // add moves to the right
	            var pointer = firstValidMove;
	            var lastIndex = allGridCols.length - 1;
	            var displacedCol = allGridCols[pointer];
	            while (pointer <= lastIndex && this.isColumnHidden(allDisplayedCols, displacedCol)) {
	                pointer++;
	                validMoves.push(pointer);
	                displacedCol = allGridCols[pointer];
	            }
	            // add moves to the left
	            pointer = firstValidMove - 1;
	            var firstDisplayIndex = 0;
	            while (pointer >= firstDisplayIndex) {
	                validMoves.push(pointer);
	                pointer--;
	            }
	        }
	        return validMoves;
	    };
	    // isHidden takes into account visible=false and group=closed, ie it is not displayed
	    MoveColumnController.prototype.isColumnHidden = function (displayedColumns, col) {
	        return displayedColumns.indexOf(col) < 0;
	    };
	    MoveColumnController.prototype.ensureIntervalStarted = function () {
	        if (!this.movingIntervalId) {
	            this.intervalCount = 0;
	            this.failedMoveAttempts = 0;
	            this.movingIntervalId = window.setInterval(this.moveInterval.bind(this), 100);
	            if (this.needToMoveLeft) {
	                this.dragAndDropService.setGhostIcon(dragAndDropService_1.DragAndDropService.ICON_LEFT, true);
	            }
	            else {
	                this.dragAndDropService.setGhostIcon(dragAndDropService_1.DragAndDropService.ICON_RIGHT, true);
	            }
	        }
	    };
	    MoveColumnController.prototype.ensureIntervalCleared = function () {
	        if (this.moveInterval) {
	            window.clearInterval(this.movingIntervalId);
	            this.movingIntervalId = null;
	            this.dragAndDropService.setGhostIcon(dragAndDropService_1.DragAndDropService.ICON_MOVE);
	        }
	    };
	    MoveColumnController.prototype.moveInterval = function () {
	        // the amounts we move get bigger at each interval, so the speed accelerates, starting a bit slow
	        // and getting faster. this is to give smoother user experience. we max at 100px to limit the speed.
	        var pixelsToMove;
	        this.intervalCount++;
	        pixelsToMove = 10 + (this.intervalCount * 5);
	        if (pixelsToMove > 100) {
	            pixelsToMove = 100;
	        }
	        var pixelsMoved;
	        if (this.needToMoveLeft) {
	            pixelsMoved = this.gridPanel.scrollHorizontally(-pixelsToMove);
	        }
	        else if (this.needToMoveRight) {
	            pixelsMoved = this.gridPanel.scrollHorizontally(pixelsToMove);
	        }
	        if (pixelsMoved !== 0) {
	            this.onDragging(this.lastDraggingEvent);
	            this.failedMoveAttempts = 0;
	        }
	        else {
	            // we count the failed move attempts. if we fail to move 7 times, then we pin the column.
	            // this is how we achieve pining by dragging the column to the edge of the grid.
	            this.failedMoveAttempts++;
	            var columns = this.lastDraggingEvent.dragItem.columns;
	            var columnsThatCanPin = columns.filter(function (c) { return !c.getColDef().lockPinned; });
	            if (columnsThatCanPin.length > 0) {
	                this.dragAndDropService.setGhostIcon(dragAndDropService_1.DragAndDropService.ICON_PINNED);
	                if (this.failedMoveAttempts > 7) {
	                    var pinType = this.needToMoveLeft ? column_1.Column.PINNED_LEFT : column_1.Column.PINNED_RIGHT;
	                    this.setColumnsPinned(columnsThatCanPin, pinType, "uiColumnDragged");
	                    this.dragAndDropService.nudge();
	                }
	            }
	        }
	    };
	    __decorate([
	        context_1.Autowired('loggerFactory'),
	        __metadata("design:type", logger_1.LoggerFactory)
	    ], MoveColumnController.prototype, "loggerFactory", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], MoveColumnController.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('dragAndDropService'),
	        __metadata("design:type", dragAndDropService_1.DragAndDropService)
	    ], MoveColumnController.prototype, "dragAndDropService", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], MoveColumnController.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], MoveColumnController.prototype, "init", null);
	    return MoveColumnController;
	}());
	exports.MoveColumnController = MoveColumnController;


/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var filterManager_1 = __webpack_require__(77);
	var popupService_1 = __webpack_require__(137);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var eventService_1 = __webpack_require__(22);
	var utils_1 = __webpack_require__(10);
	var StandardMenuFactory = /** @class */ (function () {
	    function StandardMenuFactory() {
	    }
	    StandardMenuFactory.prototype.hideActiveMenu = function () {
	        if (this.hidePopup) {
	            this.hidePopup();
	        }
	    };
	    StandardMenuFactory.prototype.showMenuAfterMouseEvent = function (column, mouseEvent) {
	        var _this = this;
	        this.showPopup(column, function (eMenu) {
	            _this.popupService.positionPopupUnderMouseEvent({
	                column: column,
	                type: 'columnMenu',
	                mouseEvent: mouseEvent,
	                ePopup: eMenu
	            });
	        });
	    };
	    StandardMenuFactory.prototype.showMenuAfterButtonClick = function (column, eventSource) {
	        var _this = this;
	        this.showPopup(column, function (eMenu) {
	            _this.popupService.positionPopupUnderComponent({
	                type: 'columnMenu', eventSource: eventSource,
	                ePopup: eMenu, keepWithinBounds: true, column: column
	            });
	        });
	    };
	    StandardMenuFactory.prototype.showPopup = function (column, positionCallback) {
	        var _this = this;
	        var filterWrapper = this.filterManager.getOrCreateFilterWrapper(column, 'COLUMN_MENU');
	        var eMenu = document.createElement('div');
	        utils_1._.addCssClass(eMenu, 'ag-menu');
	        filterWrapper.guiPromise.promise.then(function (gui) {
	            eMenu.appendChild(gui);
	        });
	        var hidePopup;
	        var bodyScrollListener = function (event) {
	            // if h scroll, popup is no longer over the column
	            if (event.direction === 'horizontal') {
	                hidePopup();
	            }
	        };
	        this.eventService.addEventListener('bodyScroll', bodyScrollListener);
	        var closedCallback = function () {
	            _this.eventService.removeEventListener('bodyScroll', bodyScrollListener);
	            column.setMenuVisible(false, "contextMenu");
	        };
	        // need to show filter before positioning, as only after filter
	        // is visible can we find out what the width of it is
	        hidePopup = this.popupService.addAsModalPopup(eMenu, true, closedCallback);
	        positionCallback(eMenu);
	        filterWrapper.filterPromise.then(function (filter) {
	            if (filter.afterGuiAttached) {
	                var params = {
	                    hidePopup: hidePopup
	                };
	                filter.afterGuiAttached(params);
	            }
	        });
	        this.hidePopup = hidePopup;
	        column.setMenuVisible(true, "contextMenu");
	    };
	    StandardMenuFactory.prototype.isMenuEnabled = function (column) {
	        // for standard, we show menu if filter is enabled, and he menu is not suppressed
	        return column.isFilterAllowed();
	    };
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], StandardMenuFactory.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('filterManager'),
	        __metadata("design:type", filterManager_1.FilterManager)
	    ], StandardMenuFactory.prototype, "filterManager", void 0);
	    __decorate([
	        context_1.Autowired('popupService'),
	        __metadata("design:type", popupService_1.PopupService)
	    ], StandardMenuFactory.prototype, "popupService", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], StandardMenuFactory.prototype, "gridOptionsWrapper", void 0);
	    StandardMenuFactory = __decorate([
	        context_1.Bean('menuFactory')
	    ], StandardMenuFactory);
	    return StandardMenuFactory;
	}());
	exports.StandardMenuFactory = StandardMenuFactory;


/***/ },
/* 658 */
/***/ function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var CellRangeType;
	(function (CellRangeType) {
	    CellRangeType[CellRangeType["VALUE"] = 0] = "VALUE";
	    CellRangeType[CellRangeType["DIMENSION"] = 1] = "DIMENSION";
	})(CellRangeType = exports.CellRangeType || (exports.CellRangeType = {}));


/***/ },
/* 659 */
/***/ function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var PropertyKeys = /** @class */ (function () {
	    function PropertyKeys() {
	    }
	    PropertyKeys.STRING_PROPERTIES = [
	        'sortingOrder', 'rowClass', 'rowSelection', 'overlayLoadingTemplate',
	        'overlayNoRowsTemplate', 'quickFilterText', 'rowModelType',
	        'editType', 'domLayout', 'clipboardDeliminator', 'rowGroupPanelShow',
	        'multiSortKey', 'pivotColumnGroupTotals', 'pivotRowTotals', 'pivotPanelShow'
	    ];
	    PropertyKeys.OBJECT_PROPERTIES = [
	        'components', 'frameworkComponents', 'rowStyle', 'context', 'autoGroupColumnDef', 'groupColumnDef', 'localeText',
	        'icons', 'datasource', 'serverSideDatasource', 'viewportDatasource', 'groupRowRendererParams', 'aggFuncs',
	        'fullWidthCellRendererParams', 'defaultColGroupDef', 'defaultColDef', 'defaultExportParams', 'columnTypes',
	        'rowClassRules', 'detailGridOptions', 'detailCellRendererParams', 'loadingCellRendererParams', 'loadingOverlayComponentParams',
	        'noRowsOverlayComponentParams', 'popupParent', 'colResizeDefault', 'reduxStore', 'statusBar', 'sideBar'
	    ];
	    PropertyKeys.ARRAY_PROPERTIES = [
	        'slaveGrids', 'alignedGrids', 'rowData',
	        'columnDefs', 'excelStyles', 'pinnedTopRowData', 'pinnedBottomRowData'
	        /** @deprecated */
	    ];
	    PropertyKeys.NUMBER_PROPERTIES = [
	        'rowHeight', 'detailRowHeight', 'rowBuffer', 'colWidth', 'headerHeight', 'groupHeaderHeight',
	        'floatingFiltersHeight', 'pivotHeaderHeight', 'pivotGroupHeaderHeight', 'groupDefaultExpanded',
	        'minColWidth', 'maxColWidth', 'viewportRowModelPageSize', 'viewportRowModelBufferSize',
	        'autoSizePadding', 'maxBlocksInCache', 'maxConcurrentDatasourceRequests',
	        'cacheOverflowSize', 'paginationPageSize', 'cacheBlockSize', 'infiniteInitialRowCount',
	        'scrollbarWidth', 'paginationStartPage', 'infiniteBlockSize', 'batchUpdateWaitMillis',
	        'blockLoadDebounceMillis', 'keepDetailRowsCount'
	    ];
	    PropertyKeys.BOOLEAN_PROPERTIES = [
	        'toolPanelSuppressRowGroups', 'toolPanelSuppressValues', 'toolPanelSuppressPivots', 'toolPanelSuppressPivotMode',
	        'toolPanelSuppressSideButtons', 'toolPanelSuppressColumnFilter', 'toolPanelSuppressColumnSelectAll',
	        'toolPanelSuppressColumnExpandAll', 'suppressMakeColumnVisibleAfterUnGroup', 'suppressRowClickSelection',
	        'suppressCellSelection', 'suppressHorizontalScroll', 'alwaysShowVerticalScroll', 'debug', 'enableBrowserTooltips', 'enableColResize',
	        'enableCellExpressions', 'enableSorting', 'enableServerSideSorting', 'enableFilter', 'enableServerSideFilter',
	        'angularCompileRows', 'angularCompileFilters', 'angularCompileHeaders', 'groupSuppressAutoColumn', 'groupSelectsChildren',
	        'groupIncludeFooter', 'groupIncludeTotalFooter', 'groupUseEntireRow', 'groupSuppressRow', 'groupSuppressBlankHeader',
	        'forPrint', 'suppressMenuHide', 'rowDeselection', 'unSortIcon', 'suppressMultiSort', 'singleClickEdit',
	        'suppressLoadingOverlay', 'suppressNoRowsOverlay', 'suppressAutoSize', 'suppressParentsInRowNodes', 'showToolPanel',
	        'suppressColumnMoveAnimation', 'suppressMovableColumns', 'suppressFieldDotNotation', 'enableRangeSelection',
	        'enableRangeHandle', 'enableFillHandle', 'deltaSort', 'suppressTouch', 'suppressAsyncEvents', 'allowContextMenuWithControlKey',
	        'suppressContextMenu', 'suppressMenuFilterPanel', 'suppressMenuMainPanel', 'suppressMenuColumnPanel', 'rememberGroupStateWhenNewData',
	        'enableCellChangeFlash', 'suppressDragLeaveHidesColumns', 'suppressMiddleClickScrolls', 'suppressPreventDefaultOnMouseWheel',
	        'suppressUseColIdForGroups', 'suppressCopyRowsToClipboard', 'copyHeadersToClipboard', 'pivotMode', 'suppressAggFuncInHeader',
	        'suppressColumnVirtualisation', 'suppressAggAtRootLevel', 'suppressFocusAfterRefresh', 'functionsPassive', 'functionsReadOnly',
	        'animateRows', 'groupSelectsFiltered', 'groupRemoveSingleChildren', 'groupRemoveLowestSingleChildren', 'enableRtl',
	        'suppressClickEdit', 'rowDragManaged', 'suppressRowDrag', 'enableGroupEdit', 'embedFullWidthRows', 'deprecatedEmbedFullWidthRows',
	        'suppressTabbing', 'suppressPaginationPanel', 'floatingFilter', 'groupHideOpenParents', 'groupMultiAutoColumn', 'pagination',
	        'stopEditingWhenGridLosesFocus', 'paginationAutoPageSize', 'suppressScrollOnNewData', 'purgeClosedRowNodes', 'cacheQuickFilter',
	        'deltaRowDataMode', 'ensureDomOrder', 'accentedSort', 'pivotTotals', 'suppressChangeDetection', 'valueCache', 'valueCacheNeverExpires',
	        'aggregateOnlyChangedColumns', 'suppressAnimationFrame', 'suppressExcelExport', 'suppressCsvExport', 'treeData', 'masterDetail',
	        'suppressMultiRangeSelection', 'enterMovesDownAfterEdit', 'enterMovesDown', 'suppressPropertyNamesCheck', 'rowMultiSelectWithClick',
	        'contractColumnSelection', 'suppressEnterpriseResetOnNewColumns', 'enableOldSetFilterModel', 'suppressRowHoverHighlight',
	        'gridAutoHeight', 'suppressRowTransform', 'suppressClipboardPaste', 'serverSideSortingAlwaysResets', 'reactNext',
	        'suppressSetColumnStateEvents', 'enableCharts', 'deltaColumnMode', 'suppressMaintainUnsortedOrder', 'enableCellTextSelection',
	        'suppressBrowserResizeObserver', 'suppressMaxRenderedRowRestriction', 'excludeChildrenWhenTreeDataFiltering',
	        'keepDetailRows', 'paginateChildRows', 'preventDefaultOnContextMenu'
	    ];
	    PropertyKeys.FUNCTION_PROPERTIES = ['localeTextFunc', 'groupRowInnerRenderer', 'groupRowInnerRendererFramework',
	        'dateComponent', 'dateComponentFramework', 'groupRowRenderer', 'groupRowRendererFramework', 'isExternalFilterPresent',
	        'getRowHeight', 'doesExternalFilterPass', 'getRowClass', 'getRowStyle', 'getRowClassRules',
	        'traverseNode', 'getContextMenuItems', 'getMainMenuItems', 'processRowPostCreate', 'processCellForClipboard',
	        'getNodeChildDetails', 'groupRowAggNodes', 'getRowNodeId', 'isFullWidthCell', 'fullWidthCellRenderer',
	        'fullWidthCellRendererFramework', 'doesDataFlower', 'processSecondaryColDef', 'processSecondaryColGroupDef',
	        'getBusinessKeyForNode', 'sendToClipboard', 'navigateToNextCell', 'tabToNextCell', 'getDetailRowData',
	        'processCellFromClipboard', 'getDocument', 'postProcessPopup', 'getChildCount', 'getDataPath', 'loadingCellRenderer',
	        'loadingCellRendererFramework', 'loadingOverlayComponent', 'loadingOverlayComponentFramework', 'noRowsOverlayComponent',
	        'noRowsOverlayComponentFramework', 'detailCellRenderer', 'detailCellRendererFramework', 'onGridReady',
	        'defaultGroupSortComparator', 'isRowMaster', 'isRowSelectable', 'postSort', 'processHeaderForClipboard',
	        'paginationNumberFormatter', 'processDataFromClipboard', 'getServerSideGroupKey', 'isServerSideGroup',
	        'suppressKeyboardEvent', 'createChartContainer', 'processChartOptions', 'getChartToolbarItems'];
	    PropertyKeys.ALL_PROPERTIES = PropertyKeys.ARRAY_PROPERTIES
	        .concat(PropertyKeys.OBJECT_PROPERTIES)
	        .concat(PropertyKeys.STRING_PROPERTIES)
	        .concat(PropertyKeys.NUMBER_PROPERTIES)
	        .concat(PropertyKeys.FUNCTION_PROPERTIES)
	        .concat(PropertyKeys.BOOLEAN_PROPERTIES);
	    // used when doing property checks - this causes noise when using frameworks which can add their own fw specific
	    // properties to colDefs, gridOptions etc
	    PropertyKeys.FRAMEWORK_PROPERTIES = ['__ob__', '__metadata__', 'mappedColumnProperties', 'hasChildColumns',
	        'toColDef', 'createColDefFromGridColumn'];
	    return PropertyKeys;
	}());
	exports.PropertyKeys = PropertyKeys;


/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var popupComponent_1 = __webpack_require__(200);
	var constants_1 = __webpack_require__(30);
	var utils_1 = __webpack_require__(10);
	var LargeTextCellEditor = /** @class */ (function (_super) {
	    __extends(LargeTextCellEditor, _super);
	    function LargeTextCellEditor() {
	        return _super.call(this, LargeTextCellEditor.TEMPLATE) || this;
	    }
	    LargeTextCellEditor.prototype.init = function (params) {
	        this.params = params;
	        this.focusAfterAttached = params.cellStartedEdit;
	        this.textarea = document.createElement("textarea");
	        this.textarea.maxLength = params.maxLength ? params.maxLength : "200";
	        this.textarea.cols = params.cols ? params.cols : "60";
	        this.textarea.rows = params.rows ? params.rows : "10";
	        if (utils_1._.exists(params.value)) {
	            this.textarea.value = params.value.toString();
	        }
	        this.getGui().querySelector('.ag-large-textarea').appendChild(this.textarea);
	        this.addGuiEventListener('keydown', this.onKeyDown.bind(this));
	    };
	    LargeTextCellEditor.prototype.onKeyDown = function (event) {
	        var key = event.which || event.keyCode;
	        if (key == constants_1.Constants.KEY_LEFT ||
	            key == constants_1.Constants.KEY_UP ||
	            key == constants_1.Constants.KEY_RIGHT ||
	            key == constants_1.Constants.KEY_DOWN ||
	            (event.shiftKey && key == constants_1.Constants.KEY_ENTER)) { // shift+enter allows for newlines
	            event.stopPropagation();
	        }
	    };
	    LargeTextCellEditor.prototype.afterGuiAttached = function () {
	        if (this.focusAfterAttached) {
	            this.textarea.focus();
	        }
	    };
	    LargeTextCellEditor.prototype.getValue = function () {
	        return this.params.parseValue(this.textarea.value);
	    };
	    LargeTextCellEditor.TEMPLATE = 
	    // tab index is needed so we can focus, which is needed for keyboard events
	    '<div class="ag-large-text" tabindex="0">' +
	        '<div class="ag-large-textarea"></div>' +
	        '</div>';
	    return LargeTextCellEditor;
	}(popupComponent_1.PopupComponent));
	exports.LargeTextCellEditor = LargeTextCellEditor;


/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var selectCellEditor_1 = __webpack_require__(435);
	var PopupSelectCellEditor = /** @class */ (function (_super) {
	    __extends(PopupSelectCellEditor, _super);
	    function PopupSelectCellEditor() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PopupSelectCellEditor.prototype.isPopup = function () {
	        return true;
	    };
	    return PopupSelectCellEditor;
	}(selectCellEditor_1.SelectCellEditor));
	exports.PopupSelectCellEditor = PopupSelectCellEditor;


/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var textCellEditor_1 = __webpack_require__(436);
	var PopupTextCellEditor = /** @class */ (function (_super) {
	    __extends(PopupTextCellEditor, _super);
	    function PopupTextCellEditor() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PopupTextCellEditor.prototype.isPopup = function () {
	        return true;
	    };
	    return PopupTextCellEditor;
	}(textCellEditor_1.TextCellEditor));
	exports.PopupTextCellEditor = PopupTextCellEditor;


/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var column_1 = __webpack_require__(45);
	var context_1 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	/**
	 * For Master Detail, it is required to keep components between expanding & collapsing parents.
	 * For example a user expands row A (and shows a detail grid for this row), then when row A
	 * is closed, we want to keep the detail grid, so next time row A is expanded the detail grid
	 * is showed with it's context intact, eg if user sorted in the detail grid, that sort should
	 * still be applied after the detail grid is shown for the second time.
	 */
	var DetailRowCompCache = /** @class */ (function () {
	    function DetailRowCompCache() {
	        this.cacheItems = [];
	    }
	    DetailRowCompCache.prototype.postConstruct = function () {
	        this.active = this.gridOptionsWrapper.isKeepDetailRows();
	        this.maxCacheSize = this.gridOptionsWrapper.getKeepDetailRowsCount();
	    };
	    DetailRowCompCache.prototype.addOrDestroy = function (rowNode, pinned, comp) {
	        // only accept detail rows
	        var doNotUseCache = !this.active || !rowNode.detail;
	        if (doNotUseCache) {
	            this.destroyFullWidthRow(comp);
	            return;
	        }
	        var item = this.getCacheItem(rowNode, true);
	        // put the comp in the right location of the item.
	        // we also destroy any previous comp - this should never happen
	        // as the logic outside of this class shouldn't be adding same item to the
	        // cache twice, however we cater for it in case in future releases code
	        // outside of this class is changed and this could happen.
	        switch (pinned) {
	            case column_1.Column.PINNED_LEFT:
	                this.destroyFullWidthRow(item.left);
	                item.left = comp;
	                break;
	            case column_1.Column.PINNED_RIGHT:
	                this.destroyFullWidthRow(item.right);
	                item.right = comp;
	                break;
	            default:
	                this.destroyFullWidthRow(item.center);
	                item.center = comp;
	                break;
	        }
	        this.cacheItems.sort(function (a, b) {
	            return b.lastAccessedTime - a.lastAccessedTime;
	        });
	        this.purgeCache(this.maxCacheSize);
	    };
	    DetailRowCompCache.prototype.getCacheItem = function (rowNode, autoCreate) {
	        if (autoCreate === void 0) { autoCreate = false; }
	        var res;
	        for (var i = 0; i < this.cacheItems.length; i++) {
	            var item = this.cacheItems[i];
	            if (item.rowNode === rowNode) {
	                res = item;
	                break;
	            }
	        }
	        if (!res && autoCreate) {
	            res = {
	                rowNode: rowNode
	            };
	            this.cacheItems.push(res);
	        }
	        if (res) {
	            this.stampCacheItem(res);
	        }
	        return res;
	    };
	    DetailRowCompCache.prototype.stampCacheItem = function (item) {
	        item.lastAccessedTime = new Date().getTime();
	    };
	    DetailRowCompCache.prototype.destroyFullWidthRow = function (comp) {
	        if (comp && comp.destroy) {
	            comp.destroy();
	        }
	    };
	    DetailRowCompCache.prototype.purgeCache = function (startIndex) {
	        // delete all rows past the index of interest
	        for (var i = startIndex; i < this.cacheItems.length; i++) {
	            var item = this.cacheItems[i];
	            this.destroyFullWidthRow(item.center);
	            this.destroyFullWidthRow(item.left);
	            this.destroyFullWidthRow(item.right);
	        }
	        // change the length of the array so it no longer contains the deleted items
	        if (this.cacheItems.length > startIndex) {
	            this.cacheItems.length = startIndex;
	        }
	    };
	    DetailRowCompCache.prototype.get = function (rowNode, pinned) {
	        if (!rowNode.detail) {
	            return undefined;
	        }
	        var item = this.getCacheItem(rowNode);
	        var res;
	        if (item) {
	            switch (pinned) {
	                case column_1.Column.PINNED_LEFT:
	                    if (item.left) {
	                        res = item.left;
	                        item.left = undefined;
	                    }
	                    break;
	                case column_1.Column.PINNED_RIGHT:
	                    if (item.right) {
	                        res = item.right;
	                        item.right = undefined;
	                    }
	                    break;
	                default:
	                    if (item.center) {
	                        res = item.center;
	                        item.center = undefined;
	                    }
	                    break;
	            }
	        }
	        return res;
	    };
	    DetailRowCompCache.prototype.destroy = function () {
	        this.purgeCache(0);
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], DetailRowCompCache.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], DetailRowCompCache.prototype, "postConstruct", null);
	    __decorate([
	        context_1.PreDestroy,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], DetailRowCompCache.prototype, "destroy", null);
	    DetailRowCompCache = __decorate([
	        context_1.Bean('detailRowCompCache')
	    ], DetailRowCompCache);
	    return DetailRowCompCache;
	}());
	exports.DetailRowCompCache = DetailRowCompCache;


/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var context_1 = __webpack_require__(8);
	var component_1 = __webpack_require__(31);
	var userComponentFactory_1 = __webpack_require__(81);
	var componentAnnotations_1 = __webpack_require__(39);
	var utils_1 = __webpack_require__(10);
	var LoadingType;
	(function (LoadingType) {
	    LoadingType[LoadingType["Loading"] = 0] = "Loading";
	    LoadingType[LoadingType["NoRows"] = 1] = "NoRows";
	})(LoadingType || (LoadingType = {}));
	var OverlayWrapperComponent = /** @class */ (function (_super) {
	    __extends(OverlayWrapperComponent, _super);
	    function OverlayWrapperComponent() {
	        return _super.call(this, OverlayWrapperComponent.TEMPLATE) || this;
	    }
	    OverlayWrapperComponent.prototype.postConstruct = function () {
	        this.gridOptionsWrapper.addLayoutElement(this.eOverlayWrapper);
	        this.setDisplayed(false);
	    };
	    OverlayWrapperComponent.prototype.setWrapperTypeClass = function (loadingType) {
	        utils_1._.addOrRemoveCssClass(this.eOverlayWrapper, 'ag-overlay-loading-wrapper', loadingType === LoadingType.Loading);
	        utils_1._.addOrRemoveCssClass(this.eOverlayWrapper, 'ag-overlay-no-rows-wrapper', loadingType === LoadingType.NoRows);
	    };
	    OverlayWrapperComponent.prototype.showLoadingOverlay = function () {
	        var _this = this;
	        this.setWrapperTypeClass(LoadingType.Loading);
	        this.destroyActiveOverlay();
	        var params = { api: this.gridOptionsWrapper.getApi() };
	        this.userComponentFactory.newLoadingOverlayComponent(params).then(function (comp) {
	            _this.eOverlayWrapper.appendChild(comp.getGui());
	            _this.activeOverlay = comp;
	        });
	        this.setDisplayed(true);
	    };
	    OverlayWrapperComponent.prototype.showNoRowsOverlay = function () {
	        var _this = this;
	        this.setWrapperTypeClass(LoadingType.NoRows);
	        this.destroyActiveOverlay();
	        var params = { api: this.gridOptionsWrapper.getApi() };
	        this.userComponentFactory.newNoRowsOverlayComponent(params).then(function (comp) {
	            _this.eOverlayWrapper.appendChild(comp.getGui());
	            _this.activeOverlay = comp;
	        });
	        this.setDisplayed(true);
	    };
	    OverlayWrapperComponent.prototype.destroyActiveOverlay = function () {
	        if (!this.activeOverlay) {
	            return;
	        }
	        if (this.activeOverlay.destroy) {
	            this.activeOverlay.destroy();
	        }
	        this.activeOverlay = undefined;
	        utils_1._.clearElement(this.eOverlayWrapper);
	    };
	    OverlayWrapperComponent.prototype.hideOverlay = function () {
	        this.destroyActiveOverlay();
	        this.setDisplayed(false);
	    };
	    OverlayWrapperComponent.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        this.destroyActiveOverlay();
	    };
	    // wrapping in outer div, and wrapper, is needed to center the loading icon
	    // The idea for centering came from here: http://www.vanseodesign.com/css/vertical-centering/
	    OverlayWrapperComponent.TEMPLATE = "<div class=\"ag-overlay\" aria-hidden=\"true\">\n            <div class=\"ag-overlay-panel\">\n                <div class=\"ag-overlay-wrapper\" ref=\"eOverlayWrapper\"></div>\n            </div>\n        </div>";
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], OverlayWrapperComponent.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('userComponentFactory'),
	        __metadata("design:type", userComponentFactory_1.UserComponentFactory)
	    ], OverlayWrapperComponent.prototype, "userComponentFactory", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eOverlayWrapper'),
	        __metadata("design:type", HTMLElement)
	    ], OverlayWrapperComponent.prototype, "eOverlayWrapper", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], OverlayWrapperComponent.prototype, "postConstruct", null);
	    return OverlayWrapperComponent;
	}(component_1.Component));
	exports.OverlayWrapperComponent = OverlayWrapperComponent;


/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var rowNodeBlock_1 = __webpack_require__(324);
	var logger_1 = __webpack_require__(68);
	var context_1 = __webpack_require__(8);
	var utils_1 = __webpack_require__(10);
	var RowNodeBlockLoader = /** @class */ (function () {
	    function RowNodeBlockLoader(maxConcurrentRequests, blockLoadDebounceMillis) {
	        this.activeBlockLoadsCount = 0;
	        this.blocks = [];
	        this.active = true;
	        this.maxConcurrentRequests = maxConcurrentRequests;
	        if (blockLoadDebounceMillis && blockLoadDebounceMillis > 0) {
	            this.checkBlockToLoadDebounce = utils_1._.debounce(this.performCheckBlocksToLoad.bind(this), blockLoadDebounceMillis);
	        }
	    }
	    RowNodeBlockLoader.prototype.setBeans = function (loggerFactory) {
	        this.logger = loggerFactory.create('RowNodeBlockLoader');
	    };
	    RowNodeBlockLoader.prototype.addBlock = function (block) {
	        this.blocks.push(block);
	    };
	    RowNodeBlockLoader.prototype.removeBlock = function (block) {
	        utils_1._.removeFromArray(this.blocks, block);
	    };
	    RowNodeBlockLoader.prototype.destroy = function () {
	        this.active = false;
	    };
	    RowNodeBlockLoader.prototype.loadComplete = function () {
	        this.activeBlockLoadsCount--;
	    };
	    RowNodeBlockLoader.prototype.checkBlockToLoad = function () {
	        if (this.checkBlockToLoadDebounce) {
	            this.checkBlockToLoadDebounce();
	        }
	        else {
	            this.performCheckBlocksToLoad();
	        }
	    };
	    RowNodeBlockLoader.prototype.performCheckBlocksToLoad = function () {
	        if (!this.active) {
	            return;
	        }
	        this.printCacheStatus();
	        if (this.activeBlockLoadsCount >= this.maxConcurrentRequests) {
	            this.logger.log("checkBlockToLoad: max loads exceeded");
	            return;
	        }
	        var blockToLoad = null;
	        this.blocks.forEach(function (block) {
	            if (block.getState() === rowNodeBlock_1.RowNodeBlock.STATE_DIRTY) {
	                blockToLoad = block;
	            }
	        });
	        if (blockToLoad) {
	            blockToLoad.load();
	            this.activeBlockLoadsCount++;
	            this.logger.log("checkBlockToLoad: loading page " + blockToLoad.getBlockNumber());
	            this.printCacheStatus();
	        }
	        else {
	            this.logger.log("checkBlockToLoad: no pages to load");
	        }
	    };
	    RowNodeBlockLoader.prototype.getBlockState = function () {
	        var result = {};
	        this.blocks.forEach(function (block) {
	            var nodeIdPrefix = block.getNodeIdPrefix();
	            var stateItem = {
	                blockNumber: block.getBlockNumber(),
	                startRow: block.getStartRow(),
	                endRow: block.getEndRow(),
	                pageStatus: block.getState()
	            };
	            if (utils_1._.exists(nodeIdPrefix)) {
	                result[nodeIdPrefix + block.getBlockNumber()] = stateItem;
	            }
	            else {
	                result[block.getBlockNumber()] = stateItem;
	            }
	        });
	        return result;
	    };
	    RowNodeBlockLoader.prototype.printCacheStatus = function () {
	        if (this.logger.isLogging()) {
	            this.logger.log("printCacheStatus: activePageLoadsCount = " + this.activeBlockLoadsCount + ","
	                + (" blocks = " + JSON.stringify(this.getBlockState())));
	        }
	    };
	    RowNodeBlockLoader.prototype.isLoading = function () {
	        return this.activeBlockLoadsCount > 0;
	    };
	    __decorate([
	        __param(0, context_1.Qualifier('loggerFactory')),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [logger_1.LoggerFactory]),
	        __metadata("design:returntype", void 0)
	    ], RowNodeBlockLoader.prototype, "setBeans", null);
	    return RowNodeBlockLoader;
	}());
	exports.RowNodeBlockLoader = RowNodeBlockLoader;


/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var rowNode_1 = __webpack_require__(101);
	var events_1 = __webpack_require__(29);
	var utils_1 = __webpack_require__(10);
	var ClientSideNodeManager = /** @class */ (function () {
	    function ClientSideNodeManager(rootNode, gridOptionsWrapper, context, eventService, columnController, gridApi, columnApi, selectionController) {
	        this.nextId = 0;
	        // when user is provide the id's, we also keep a map of ids to row nodes for convenience
	        this.allNodesMap = {};
	        this.rootNode = rootNode;
	        this.gridOptionsWrapper = gridOptionsWrapper;
	        this.context = context;
	        this.eventService = eventService;
	        this.columnController = columnController;
	        this.gridApi = gridApi;
	        this.columnApi = columnApi;
	        this.selectionController = selectionController;
	        this.rootNode.group = true;
	        this.rootNode.level = -1;
	        this.rootNode.id = ClientSideNodeManager.ROOT_NODE_ID;
	        this.rootNode.allLeafChildren = [];
	        this.rootNode.childrenAfterGroup = [];
	        this.rootNode.childrenAfterSort = [];
	        this.rootNode.childrenAfterFilter = [];
	        // if we make this class a bean, then can annotate postConstruct
	        this.postConstruct();
	    }
	    // @PostConstruct - this is not a bean, so postConstruct called by constructor
	    ClientSideNodeManager.prototype.postConstruct = function () {
	        // func below doesn't have 'this' pointer, so need to pull out these bits
	        this.getNodeChildDetails = this.gridOptionsWrapper.getNodeChildDetailsFunc();
	        this.suppressParentsInRowNodes = this.gridOptionsWrapper.isSuppressParentsInRowNodes();
	        this.doesDataFlower = this.gridOptionsWrapper.getDoesDataFlowerFunc();
	        this.isRowMasterFunc = this.gridOptionsWrapper.getIsRowMasterFunc();
	        this.doingLegacyTreeData = utils_1._.exists(this.getNodeChildDetails);
	        this.doingMasterDetail = this.gridOptionsWrapper.isMasterDetail();
	        if (this.getNodeChildDetails) {
	            console.warn("ag-Grid: the callback nodeChildDetailsFunc() is now deprecated. The new way of doing\n                                    tree data in ag-Grid was introduced in v14 (released November 2017). In the next\n                                    major release of ag-Grid we will be dropping support for the old version of\n                                    tree data. If you are reading this message, please go to the docs to see how\n                                    to implement Tree Data without using nodeChildDetailsFunc().");
	        }
	    };
	    ClientSideNodeManager.prototype.getCopyOfNodesMap = function () {
	        var result = utils_1._.cloneObject(this.allNodesMap);
	        return result;
	    };
	    ClientSideNodeManager.prototype.getRowNode = function (id) {
	        return this.allNodesMap[id];
	    };
	    ClientSideNodeManager.prototype.setRowData = function (rowData) {
	        this.rootNode.childrenAfterFilter = null;
	        this.rootNode.childrenAfterGroup = null;
	        this.rootNode.childrenAfterSort = null;
	        this.rootNode.childrenMapped = null;
	        this.nextId = 0;
	        this.allNodesMap = {};
	        if (!rowData) {
	            this.rootNode.allLeafChildren = [];
	            this.rootNode.childrenAfterGroup = [];
	            return;
	        }
	        // kick off recursion
	        // we add rootNode as the parent, however if using ag-grid-enterprise, the grouping stage
	        // sets the parent node on each row (even if we are not grouping). so setting parent node
	        // here is for benefit of ag-grid-community users
	        var result = this.recursiveFunction(rowData, this.rootNode, ClientSideNodeManager.TOP_LEVEL);
	        if (this.doingLegacyTreeData) {
	            this.rootNode.childrenAfterGroup = result;
	            this.setLeafChildren(this.rootNode);
	        }
	        else {
	            this.rootNode.allLeafChildren = result;
	        }
	    };
	    ClientSideNodeManager.prototype.updateRowData = function (rowDataTran, rowNodeOrder) {
	        if (this.isLegacyTreeData()) {
	            return null;
	        }
	        var add = rowDataTran.add, addIndex = rowDataTran.addIndex, remove = rowDataTran.remove, update = rowDataTran.update;
	        var rowNodeTransaction = {
	            remove: [],
	            update: [],
	            add: []
	        };
	        this.executeAdd(rowDataTran, rowNodeTransaction);
	        this.executeRemove(rowDataTran, rowNodeTransaction);
	        this.executeUpdate(rowDataTran, rowNodeTransaction);
	        if (rowNodeOrder) {
	            utils_1._.sortRowNodesByOrder(this.rootNode.allLeafChildren, rowNodeOrder);
	        }
	        return rowNodeTransaction;
	    };
	    ClientSideNodeManager.prototype.executeAdd = function (rowDataTran, rowNodeTransaction) {
	        var _this = this;
	        var add = rowDataTran.add, addIndex = rowDataTran.addIndex;
	        if (!add) {
	            return;
	        }
	        var useIndex = typeof addIndex === 'number' && addIndex >= 0;
	        if (useIndex) {
	            // items get inserted in reverse order for index insertion
	            add.reverse().forEach(function (item) {
	                var newRowNode = _this.addRowNode(item, addIndex);
	                rowNodeTransaction.add.push(newRowNode);
	            });
	        }
	        else {
	            add.forEach(function (item) {
	                var newRowNode = _this.addRowNode(item);
	                rowNodeTransaction.add.push(newRowNode);
	            });
	        }
	    };
	    ClientSideNodeManager.prototype.executeRemove = function (rowDataTran, rowNodeTransaction) {
	        var _this = this;
	        var remove = rowDataTran.remove;
	        if (!remove) {
	            return;
	        }
	        var rowIdsRemoved = {};
	        var anyNodesSelected = false;
	        remove.forEach(function (item) {
	            var rowNode = _this.lookupRowNode(item);
	            if (!rowNode) {
	                return;
	            }
	            if (rowNode.isSelected()) {
	                anyNodesSelected = true;
	            }
	            // do delete - setting 'tailingNodeInSequence = true' to ensure EVENT_SELECTION_CHANGED is not raised for
	            // each row node updated, instead it is raised once by the calling code if any selected nodes exist.
	            rowNode.setSelected(false, false, true);
	            // so row renderer knows to fade row out (and not reposition it)
	            rowNode.clearRowTop();
	            // NOTE: were we could remove from allLeaveChildren, however _.removeFromArray() is expensive, especially
	            // if called multiple times (eg deleting lots of rows) and if allLeafChildren is a large list
	            rowIdsRemoved[rowNode.id] = true;
	            // _.removeFromArray(this.rootNode.allLeafChildren, rowNode);
	            delete _this.allNodesMap[rowNode.id];
	            rowNodeTransaction.remove.push(rowNode);
	        });
	        this.rootNode.allLeafChildren = this.rootNode.allLeafChildren.filter(function (rowNode) { return !rowIdsRemoved[rowNode.id]; });
	        if (anyNodesSelected) {
	            this.selectionController.updateGroupsFromChildrenSelections();
	            var event_1 = {
	                type: events_1.Events.EVENT_SELECTION_CHANGED,
	                api: this.gridApi,
	                columnApi: this.columnApi
	            };
	            this.eventService.dispatchEvent(event_1);
	        }
	    };
	    ClientSideNodeManager.prototype.executeUpdate = function (rowDataTran, rowNodeTransaction) {
	        var _this = this;
	        var update = rowDataTran.update;
	        if (!update) {
	            return;
	        }
	        update.forEach(function (item) {
	            var rowNode = _this.lookupRowNode(item);
	            if (!rowNode) {
	                return;
	            }
	            rowNode.updateData(item);
	            rowNodeTransaction.update.push(rowNode);
	        });
	    };
	    ClientSideNodeManager.prototype.addRowNode = function (data, index) {
	        var newNode = this.createNode(data, this.rootNode, ClientSideNodeManager.TOP_LEVEL);
	        if (utils_1._.exists(index)) {
	            utils_1._.insertIntoArray(this.rootNode.allLeafChildren, newNode, index);
	        }
	        else {
	            this.rootNode.allLeafChildren.push(newNode);
	        }
	        return newNode;
	    };
	    ClientSideNodeManager.prototype.lookupRowNode = function (data) {
	        var rowNodeIdFunc = this.gridOptionsWrapper.getRowNodeIdFunc();
	        var rowNode;
	        if (utils_1._.exists(rowNodeIdFunc)) {
	            // find rowNode using id
	            var id = rowNodeIdFunc(data);
	            rowNode = this.allNodesMap[id];
	            if (!rowNode) {
	                console.error("ag-Grid: could not find row id=" + id + ", data item was not found for this id");
	                return null;
	            }
	        }
	        else {
	            // find rowNode using object references
	            rowNode = utils_1._.find(this.rootNode.allLeafChildren, function (rowNode) { return rowNode.data === data; });
	            if (!rowNode) {
	                console.error("ag-Grid: could not find data item as object was not found", data);
	                return null;
	            }
	        }
	        return rowNode;
	    };
	    ClientSideNodeManager.prototype.recursiveFunction = function (rowData, parent, level) {
	        var _this = this;
	        // make sure the rowData is an array and not a string of json - this was a commonly reported problem on the forum
	        if (typeof rowData === 'string') {
	            console.warn('ag-Grid: rowData must be an array, however you passed in a string. If you are loading JSON, make sure you convert the JSON string to JavaScript objects first');
	            return;
	        }
	        var rowNodes = [];
	        rowData.forEach(function (dataItem) {
	            var node = _this.createNode(dataItem, parent, level);
	            rowNodes.push(node);
	        });
	        return rowNodes;
	    };
	    ClientSideNodeManager.prototype.createNode = function (dataItem, parent, level) {
	        var node = new rowNode_1.RowNode();
	        this.context.wireBean(node);
	        var doingTreeData = this.gridOptionsWrapper.isTreeData();
	        var doingLegacyTreeData = !doingTreeData && utils_1._.exists(this.getNodeChildDetails);
	        var nodeChildDetails = doingLegacyTreeData ? this.getNodeChildDetails(dataItem) : null;
	        if (nodeChildDetails && nodeChildDetails.group) {
	            node.group = true;
	            node.childrenAfterGroup = this.recursiveFunction(nodeChildDetails.children, node, level + 1);
	            node.expanded = nodeChildDetails.expanded === true;
	            node.field = nodeChildDetails.field;
	            node.key = nodeChildDetails.key;
	            /** @deprecated is now 'master' */
	            node.canFlower = node.master;
	            // pull out all the leaf children and add to our node
	            this.setLeafChildren(node);
	        }
	        else {
	            node.group = false;
	            if (doingTreeData) {
	                node.master = false;
	                node.expanded = false;
	            }
	            else {
	                // this is the default, for when doing grid data
	                if (this.doesDataFlower) {
	                    node.master = this.doesDataFlower(dataItem);
	                }
	                else if (this.doingMasterDetail) {
	                    // if we are doing master detail, then the
	                    // default is that everything can flower.
	                    if (this.isRowMasterFunc) {
	                        node.master = this.isRowMasterFunc(dataItem);
	                    }
	                    else {
	                        node.master = true;
	                    }
	                }
	                else {
	                    node.master = false;
	                }
	                var rowGroupColumns = this.columnController.getRowGroupColumns();
	                var numRowGroupColumns = rowGroupColumns ? rowGroupColumns.length : 0;
	                // need to take row group into account when determining level
	                var masterRowLevel = level + numRowGroupColumns;
	                node.expanded = node.master ? this.isExpanded(masterRowLevel) : false;
	            }
	        }
	        // support for backwards compatibility, canFlow is now called 'master'
	        node.canFlower = node.master;
	        if (parent && !this.suppressParentsInRowNodes) {
	            node.parent = parent;
	        }
	        node.level = level;
	        node.setDataAndId(dataItem, this.nextId.toString());
	        if (this.allNodesMap[node.id]) {
	            console.warn("ag-grid: duplicate node id '" + node.id + "' detected from getRowNodeId callback, this could cause issues in your grid.");
	        }
	        this.allNodesMap[node.id] = node;
	        this.nextId++;
	        return node;
	    };
	    ClientSideNodeManager.prototype.isExpanded = function (level) {
	        var expandByDefault = this.gridOptionsWrapper.getGroupDefaultExpanded();
	        if (expandByDefault === -1) {
	            return true;
	        }
	        else {
	            return level < expandByDefault;
	        }
	    };
	    // this is only used for doing legacy tree data
	    ClientSideNodeManager.prototype.setLeafChildren = function (node) {
	        node.allLeafChildren = [];
	        if (node.childrenAfterGroup) {
	            node.childrenAfterGroup.forEach(function (childAfterGroup) {
	                if (childAfterGroup.group) {
	                    if (childAfterGroup.allLeafChildren) {
	                        childAfterGroup.allLeafChildren.forEach(function (leafChild) { return node.allLeafChildren.push(leafChild); });
	                    }
	                }
	                else {
	                    node.allLeafChildren.push(childAfterGroup);
	                }
	            });
	        }
	    };
	    ClientSideNodeManager.prototype.isLegacyTreeData = function () {
	        var rowsAlreadyGrouped = utils_1._.exists(this.gridOptionsWrapper.getNodeChildDetailsFunc());
	        if (rowsAlreadyGrouped) {
	            console.warn('ag-Grid: adding and removing rows is not supported when using nodeChildDetailsFunc, ie it is not ' +
	                'supported for legacy tree data. Please see the docs on the new preferred way of providing tree data that works with delta updates.');
	            return true;
	        }
	        else {
	            return false;
	        }
	    };
	    ClientSideNodeManager.TOP_LEVEL = 0;
	    ClientSideNodeManager.ROOT_NODE_ID = 'ROOT_NODE_ID';
	    return ClientSideNodeManager;
	}());
	exports.ClientSideNodeManager = ClientSideNodeManager;


/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var constants_1 = __webpack_require__(30);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var columnApi_1 = __webpack_require__(38);
	var columnController_1 = __webpack_require__(26);
	var filterManager_1 = __webpack_require__(77);
	var rowNode_1 = __webpack_require__(101);
	var eventService_1 = __webpack_require__(22);
	var events_1 = __webpack_require__(29);
	var context_1 = __webpack_require__(8);
	var selectionController_1 = __webpack_require__(102);
	var clientSideNodeManager_1 = __webpack_require__(666);
	var changedPath_1 = __webpack_require__(325);
	var valueService_1 = __webpack_require__(103);
	var valueCache_1 = __webpack_require__(198);
	var gridApi_1 = __webpack_require__(33);
	var utils_1 = __webpack_require__(10);
	var RecursionType;
	(function (RecursionType) {
	    RecursionType[RecursionType["Normal"] = 0] = "Normal";
	    RecursionType[RecursionType["AfterFilter"] = 1] = "AfterFilter";
	    RecursionType[RecursionType["AfterFilterAndSort"] = 2] = "AfterFilterAndSort";
	    RecursionType[RecursionType["PivotNodes"] = 3] = "PivotNodes";
	})(RecursionType || (RecursionType = {}));
	var ClientSideRowModel = /** @class */ (function () {
	    function ClientSideRowModel() {
	    }
	    ClientSideRowModel.prototype.init = function () {
	        var refreshEverythingFunc = this.refreshModel.bind(this, { step: constants_1.Constants.STEP_EVERYTHING });
	        var refreshEverythingAfterColsChangedFunc = this.refreshModel.bind(this, { step: constants_1.Constants.STEP_EVERYTHING, afterColumnsChanged: true });
	        this.eventService.addModalPriorityEventListener(events_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED, refreshEverythingAfterColsChangedFunc);
	        this.eventService.addModalPriorityEventListener(events_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, refreshEverythingFunc);
	        this.eventService.addModalPriorityEventListener(events_1.Events.EVENT_COLUMN_VALUE_CHANGED, this.onValueChanged.bind(this));
	        this.eventService.addModalPriorityEventListener(events_1.Events.EVENT_COLUMN_PIVOT_CHANGED, this.refreshModel.bind(this, { step: constants_1.Constants.STEP_PIVOT }));
	        this.eventService.addModalPriorityEventListener(events_1.Events.EVENT_ROW_GROUP_OPENED, this.onRowGroupOpened.bind(this));
	        this.eventService.addModalPriorityEventListener(events_1.Events.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this));
	        this.eventService.addModalPriorityEventListener(events_1.Events.EVENT_SORT_CHANGED, this.onSortChanged.bind(this));
	        this.eventService.addModalPriorityEventListener(events_1.Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, refreshEverythingFunc);
	        var refreshMapFunc = this.refreshModel.bind(this, {
	            step: constants_1.Constants.STEP_MAP,
	            keepRenderedRows: true,
	            animate: true
	        });
	        this.gridOptionsWrapper.addEventListener(gridOptionsWrapper_1.GridOptionsWrapper.PROP_GROUP_REMOVE_SINGLE_CHILDREN, refreshMapFunc);
	        this.gridOptionsWrapper.addEventListener(gridOptionsWrapper_1.GridOptionsWrapper.PROP_GROUP_REMOVE_LOWEST_SINGLE_CHILDREN, refreshMapFunc);
	        this.rootNode = new rowNode_1.RowNode();
	        this.nodeManager = new clientSideNodeManager_1.ClientSideNodeManager(this.rootNode, this.gridOptionsWrapper, this.context, this.eventService, this.columnController, this.gridApi, this.columnApi, this.selectionController);
	        this.context.wireBean(this.rootNode);
	    };
	    ClientSideRowModel.prototype.ensureRowHeightsValid = function (startPixel, endPixel, startLimitIndex, endLimitIndex) {
	        var atLeastOneChange;
	        var res = false;
	        // we do this multiple times as changing the row heights can also change the first and last rows,
	        // so the first pass can make lots of rows smaller, which means the second pass we end up changing
	        // more rows.
	        do {
	            atLeastOneChange = false;
	            var rowAtStartPixel = this.getRowIndexAtPixel(startPixel);
	            var rowAtEndPixel = this.getRowIndexAtPixel(endPixel);
	            // keep check to current page if doing pagination
	            var firstRow = Math.max(rowAtStartPixel, startLimitIndex);
	            var lastRow = Math.min(rowAtEndPixel, endLimitIndex);
	            for (var rowIndex = firstRow; rowIndex <= lastRow; rowIndex++) {
	                var rowNode = this.getRow(rowIndex);
	                if (rowNode.rowHeightEstimated) {
	                    var rowHeight = this.gridOptionsWrapper.getRowHeightForNode(rowNode);
	                    rowNode.setRowHeight(rowHeight.height);
	                    atLeastOneChange = true;
	                    res = true;
	                }
	            }
	            if (atLeastOneChange) {
	                this.setRowTops();
	            }
	        } while (atLeastOneChange);
	        return res;
	    };
	    ClientSideRowModel.prototype.setRowTops = function () {
	        var nextRowTop = 0;
	        for (var i = 0; i < this.rowsToDisplay.length; i++) {
	            // we don't estimate if doing fullHeight or autoHeight, as all rows get rendered all the time
	            // with these two layouts.
	            var allowEstimate = this.gridOptionsWrapper.getDomLayout() === constants_1.Constants.DOM_LAYOUT_NORMAL;
	            var rowNode = this.rowsToDisplay[i];
	            if (utils_1._.missing(rowNode.rowHeight)) {
	                var rowHeight = this.gridOptionsWrapper.getRowHeightForNode(rowNode, allowEstimate);
	                rowNode.setRowHeight(rowHeight.height, rowHeight.estimated);
	            }
	            rowNode.setRowTop(nextRowTop);
	            rowNode.setRowIndex(i);
	            nextRowTop += rowNode.rowHeight;
	        }
	    };
	    ClientSideRowModel.prototype.resetRowTops = function (rowNode, changedPath) {
	        rowNode.clearRowTop();
	        if (rowNode.hasChildren()) {
	            if (rowNode.childrenAfterGroup) {
	                // if a changedPath is active, it means we are here because of a transaction update or
	                // a change detection. neither of these impacts the open/closed state of groups. so if
	                // a group is not open this time, it was not open last time. so we know all closed groups
	                // already have their top positions cleared. so there is no need to traverse all the way
	                // when changedPath is active and the rowNode is not expanded.
	                var skipChildren = changedPath.isActive() && !rowNode.expanded;
	                if (!skipChildren) {
	                    for (var i = 0; i < rowNode.childrenAfterGroup.length; i++) {
	                        this.resetRowTops(rowNode.childrenAfterGroup[i], changedPath);
	                    }
	                }
	            }
	            if (rowNode.sibling) {
	                rowNode.sibling.clearRowTop();
	            }
	        }
	        if (rowNode.detailNode) {
	            rowNode.detailNode.clearRowTop();
	        }
	    };
	    // returns false if row was moved, otherwise true
	    ClientSideRowModel.prototype.ensureRowAtPixel = function (rowNode, pixel) {
	        var indexAtPixelNow = this.getRowIndexAtPixel(pixel);
	        var rowNodeAtPixelNow = this.getRow(indexAtPixelNow);
	        if (rowNodeAtPixelNow === rowNode) {
	            return false;
	        }
	        utils_1._.removeFromArray(this.rootNode.allLeafChildren, rowNode);
	        utils_1._.insertIntoArray(this.rootNode.allLeafChildren, rowNode, indexAtPixelNow);
	        this.refreshModel({
	            step: constants_1.Constants.STEP_EVERYTHING,
	            keepRenderedRows: true,
	            animate: true,
	            keepEditingRows: true
	        });
	        return true;
	    };
	    ClientSideRowModel.prototype.isLastRowFound = function () {
	        return true;
	    };
	    ClientSideRowModel.prototype.getRowCount = function () {
	        if (this.rowsToDisplay) {
	            return this.rowsToDisplay.length;
	        }
	        else {
	            return 0;
	        }
	    };
	    ClientSideRowModel.prototype.getTopLevelRowCount = function () {
	        var showingRootNode = this.rowsToDisplay && this.rowsToDisplay[0] === this.rootNode;
	        if (showingRootNode) {
	            return 1;
	        }
	        else {
	            return this.rootNode.childrenAfterFilter ? this.rootNode.childrenAfterFilter.length : 0;
	        }
	    };
	    ClientSideRowModel.prototype.getTopLevelRowDisplayedIndex = function (topLevelIndex) {
	        var showingRootNode = this.rowsToDisplay && this.rowsToDisplay[0] === this.rootNode;
	        if (showingRootNode) {
	            return topLevelIndex;
	        }
	        else {
	            var rowNode = this.rootNode.childrenAfterSort[topLevelIndex];
	            if (this.gridOptionsWrapper.isGroupHideOpenParents()) {
	                // if hideOpenParents, and this row open, then this row is now displayed at this index, first child is
	                while (rowNode.expanded && rowNode.childrenAfterSort && rowNode.childrenAfterSort.length > 0) {
	                    rowNode = rowNode.childrenAfterSort[0];
	                }
	            }
	            return rowNode.rowIndex;
	        }
	    };
	    ClientSideRowModel.prototype.getRowBounds = function (index) {
	        if (utils_1._.missing(this.rowsToDisplay)) {
	            return null;
	        }
	        var rowNode = this.rowsToDisplay[index];
	        if (rowNode) {
	            return {
	                rowTop: rowNode.rowTop,
	                rowHeight: rowNode.rowHeight
	            };
	        }
	        else {
	            return null;
	        }
	    };
	    ClientSideRowModel.prototype.onRowGroupOpened = function () {
	        var animate = this.gridOptionsWrapper.isAnimateRows();
	        this.refreshModel({ step: constants_1.Constants.STEP_MAP, keepRenderedRows: true, animate: animate });
	    };
	    ClientSideRowModel.prototype.onFilterChanged = function () {
	        var animate = this.gridOptionsWrapper.isAnimateRows();
	        this.refreshModel({ step: constants_1.Constants.STEP_FILTER, keepRenderedRows: true, animate: animate });
	    };
	    ClientSideRowModel.prototype.onSortChanged = function () {
	        var animate = this.gridOptionsWrapper.isAnimateRows();
	        this.refreshModel({ step: constants_1.Constants.STEP_SORT, keepRenderedRows: true, animate: animate, keepEditingRows: true });
	    };
	    ClientSideRowModel.prototype.getType = function () {
	        return constants_1.Constants.ROW_MODEL_TYPE_CLIENT_SIDE;
	    };
	    ClientSideRowModel.prototype.onValueChanged = function () {
	        if (this.columnController.isPivotActive()) {
	            this.refreshModel({ step: constants_1.Constants.STEP_PIVOT });
	        }
	        else {
	            this.refreshModel({ step: constants_1.Constants.STEP_AGGREGATE });
	        }
	    };
	    ClientSideRowModel.prototype.createChangePath = function (rowNodeTransactions) {
	        // for updates, if the row is updated at all, then we re-calc all the values
	        // in that row. we could compare each value to each old value, however if we
	        // did this, we would be calling the valueService twice, once on the old value
	        // and once on the new value. so it's less valueGetter calls if we just assume
	        // each column is different. that way the changedPath is used so that only
	        // the impacted parent rows are recalculated, parents who's children have
	        // not changed are not impacted.
	        var noTransactions = utils_1._.missingOrEmpty(rowNodeTransactions);
	        var changedPath = new changedPath_1.ChangedPath(false, this.rootNode);
	        if (noTransactions || this.gridOptionsWrapper.isTreeData()) {
	            changedPath.setInactive();
	        }
	        return changedPath;
	    };
	    ClientSideRowModel.prototype.refreshModel = function (params) {
	        // this goes through the pipeline of stages. what's in my head is similar
	        // to the diagram on this page:
	        // http://commons.apache.org/sandbox/commons-pipeline/pipeline_basics.html
	        // however we want to keep the results of each stage, hence we manually call
	        // each step rather than have them chain each other.
	        var _this = this;
	        // fallthrough in below switch is on purpose,
	        // eg if STEP_FILTER, then all steps below this
	        // step get done
	        // let start: number;
	        // console.log('======= start =======');
	        var changedPath = this.createChangePath(params.rowNodeTransactions);
	        switch (params.step) {
	            case constants_1.Constants.STEP_EVERYTHING:
	                // start = new Date().getTime();
	                this.doRowGrouping(params.groupState, params.rowNodeTransactions, params.rowNodeOrder, changedPath, params.afterColumnsChanged);
	            // console.log('rowGrouping = ' + (new Date().getTime() - start));
	            case constants_1.Constants.STEP_FILTER:
	                // start = new Date().getTime();
	                this.doFilter(changedPath);
	            // console.log('filter = ' + (new Date().getTime() - start));
	            case constants_1.Constants.STEP_PIVOT:
	                this.doPivot(changedPath);
	            case constants_1.Constants.STEP_AGGREGATE: // depends on agg fields
	                // start = new Date().getTime();
	                this.doAggregate(changedPath);
	            // console.log('aggregation = ' + (new Date().getTime() - start));
	            case constants_1.Constants.STEP_SORT:
	                // start = new Date().getTime();
	                this.doSort(params.rowNodeTransactions, changedPath);
	            // console.log('sort = ' + (new Date().getTime() - start));
	            case constants_1.Constants.STEP_MAP:
	                // start = new Date().getTime();
	                this.doRowsToDisplay();
	            // console.log('rowsToDisplay = ' + (new Date().getTime() - start));
	        }
	        // set all row tops to null, then set row tops on all visible rows. if we don't
	        // do this, then the algorithm below only sets row tops, old row tops from old rows
	        // will still lie around
	        this.resetRowTops(this.rootNode, changedPath);
	        this.setRowTops();
	        var event = {
	            type: events_1.Events.EVENT_MODEL_UPDATED,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            animate: params.animate,
	            keepRenderedRows: params.keepRenderedRows,
	            newData: params.newData,
	            newPage: false
	        };
	        this.eventService.dispatchEvent(event);
	        if (this.$scope) {
	            window.setTimeout(function () {
	                _this.$scope.$apply();
	            }, 0);
	        }
	    };
	    ClientSideRowModel.prototype.isEmpty = function () {
	        var rowsMissing;
	        var doingLegacyTreeData = utils_1._.exists(this.gridOptionsWrapper.getNodeChildDetailsFunc());
	        if (doingLegacyTreeData) {
	            rowsMissing = utils_1._.missing(this.rootNode.childrenAfterGroup) || this.rootNode.childrenAfterGroup.length === 0;
	        }
	        else {
	            rowsMissing = utils_1._.missing(this.rootNode.allLeafChildren) || this.rootNode.allLeafChildren.length === 0;
	        }
	        var empty = utils_1._.missing(this.rootNode) || rowsMissing || !this.columnController.isReady();
	        return empty;
	    };
	    ClientSideRowModel.prototype.isRowsToRender = function () {
	        return utils_1._.exists(this.rowsToDisplay) && this.rowsToDisplay.length > 0;
	    };
	    ClientSideRowModel.prototype.getNodesInRangeForSelection = function (firstInRange, lastInRange) {
	        // if lastSelectedNode is missing, we start at the first row
	        var firstRowHit = !lastInRange;
	        var lastRowHit = false;
	        var lastRow;
	        var result = [];
	        var groupsSelectChildren = this.gridOptionsWrapper.isGroupSelectsChildren();
	        this.forEachNodeAfterFilterAndSort(function (rowNode) {
	            var lookingForLastRow = firstRowHit && !lastRowHit;
	            // check if we need to flip the select switch
	            if (!firstRowHit) {
	                if (rowNode === lastInRange || rowNode === firstInRange) {
	                    firstRowHit = true;
	                }
	            }
	            var skipThisGroupNode = rowNode.group && groupsSelectChildren;
	            if (!skipThisGroupNode) {
	                var inRange = firstRowHit && !lastRowHit;
	                var childOfLastRow = rowNode.isParentOfNode(lastRow);
	                if (inRange || childOfLastRow) {
	                    result.push(rowNode);
	                }
	            }
	            if (lookingForLastRow) {
	                if (rowNode === lastInRange || rowNode === firstInRange) {
	                    lastRowHit = true;
	                    if (rowNode === lastInRange) {
	                        lastRow = lastInRange;
	                    }
	                    else {
	                        lastRow = firstInRange;
	                    }
	                }
	            }
	        });
	        return result;
	    };
	    ClientSideRowModel.prototype.setDatasource = function (datasource) {
	        console.error('ag-Grid: should never call setDatasource on clientSideRowController');
	    };
	    ClientSideRowModel.prototype.getTopLevelNodes = function () {
	        return this.rootNode ? this.rootNode.childrenAfterGroup : null;
	    };
	    ClientSideRowModel.prototype.getRootNode = function () {
	        return this.rootNode;
	    };
	    ClientSideRowModel.prototype.getRow = function (index) {
	        return this.rowsToDisplay[index];
	    };
	    ClientSideRowModel.prototype.isRowPresent = function (rowNode) {
	        return this.rowsToDisplay.indexOf(rowNode) >= 0;
	    };
	    ClientSideRowModel.prototype.getRowIndexAtPixel = function (pixelToMatch) {
	        if (this.isEmpty()) {
	            return -1;
	        }
	        // do binary search of tree
	        // http://oli.me.uk/2013/06/08/searching-javascript-arrays-with-a-binary-search/
	        var bottomPointer = 0;
	        var topPointer = this.rowsToDisplay.length - 1;
	        // quick check, if the pixel is out of bounds, then return last row
	        if (pixelToMatch <= 0) {
	            // if pixel is less than or equal zero, it's always the first row
	            return 0;
	        }
	        var lastNode = utils_1._.last(this.rowsToDisplay);
	        if (lastNode.rowTop <= pixelToMatch) {
	            return this.rowsToDisplay.length - 1;
	        }
	        while (true) {
	            var midPointer = Math.floor((bottomPointer + topPointer) / 2);
	            var currentRowNode = this.rowsToDisplay[midPointer];
	            if (this.isRowInPixel(currentRowNode, pixelToMatch)) {
	                return midPointer;
	            }
	            else if (currentRowNode.rowTop < pixelToMatch) {
	                bottomPointer = midPointer + 1;
	            }
	            else if (currentRowNode.rowTop > pixelToMatch) {
	                topPointer = midPointer - 1;
	            }
	        }
	    };
	    ClientSideRowModel.prototype.isRowInPixel = function (rowNode, pixelToMatch) {
	        var topPixel = rowNode.rowTop;
	        var bottomPixel = rowNode.rowTop + rowNode.rowHeight;
	        var pixelInRow = topPixel <= pixelToMatch && bottomPixel > pixelToMatch;
	        return pixelInRow;
	    };
	    ClientSideRowModel.prototype.getCurrentPageHeight = function () {
	        if (this.rowsToDisplay && this.rowsToDisplay.length > 0) {
	            var lastRow = utils_1._.last(this.rowsToDisplay);
	            var lastPixel = lastRow.rowTop + lastRow.rowHeight;
	            return lastPixel;
	        }
	        else {
	            return 0;
	        }
	    };
	    ClientSideRowModel.prototype.forEachLeafNode = function (callback) {
	        if (this.rootNode.allLeafChildren) {
	            this.rootNode.allLeafChildren.forEach(function (rowNode, index) { return callback(rowNode, index); });
	        }
	    };
	    ClientSideRowModel.prototype.forEachNode = function (callback) {
	        this.recursivelyWalkNodesAndCallback(this.rootNode.childrenAfterGroup, callback, RecursionType.Normal, 0);
	    };
	    ClientSideRowModel.prototype.forEachNodeAfterFilter = function (callback) {
	        this.recursivelyWalkNodesAndCallback(this.rootNode.childrenAfterFilter, callback, RecursionType.AfterFilter, 0);
	    };
	    ClientSideRowModel.prototype.forEachNodeAfterFilterAndSort = function (callback) {
	        this.recursivelyWalkNodesAndCallback(this.rootNode.childrenAfterSort, callback, RecursionType.AfterFilterAndSort, 0);
	    };
	    ClientSideRowModel.prototype.forEachPivotNode = function (callback) {
	        this.recursivelyWalkNodesAndCallback([this.rootNode], callback, RecursionType.PivotNodes, 0);
	    };
	    // iterates through each item in memory, and calls the callback function
	    // nodes - the rowNodes to traverse
	    // callback - the user provided callback
	    // recursion type - need this to know what child nodes to recurse, eg if looking at all nodes, or filtered notes etc
	    // index - works similar to the index in forEach in javascript's array function
	    ClientSideRowModel.prototype.recursivelyWalkNodesAndCallback = function (nodes, callback, recursionType, index) {
	        if (nodes) {
	            for (var i = 0; i < nodes.length; i++) {
	                var node = nodes[i];
	                callback(node, index++);
	                // go to the next level if it is a group
	                if (node.hasChildren()) {
	                    // depending on the recursion type, we pick a difference set of children
	                    var nodeChildren = null;
	                    switch (recursionType) {
	                        case RecursionType.Normal:
	                            nodeChildren = node.childrenAfterGroup;
	                            break;
	                        case RecursionType.AfterFilter:
	                            nodeChildren = node.childrenAfterFilter;
	                            break;
	                        case RecursionType.AfterFilterAndSort:
	                            nodeChildren = node.childrenAfterSort;
	                            break;
	                        case RecursionType.PivotNodes:
	                            // for pivot, we don't go below leafGroup levels
	                            nodeChildren = !node.leafGroup ? node.childrenAfterSort : null;
	                            break;
	                    }
	                    if (nodeChildren) {
	                        index = this.recursivelyWalkNodesAndCallback(nodeChildren, callback, recursionType, index);
	                    }
	                }
	            }
	        }
	        return index;
	    };
	    // it's possible to recompute the aggregate without doing the other parts
	    // + gridApi.recomputeAggregates()
	    ClientSideRowModel.prototype.doAggregate = function (changedPath) {
	        if (this.aggregationStage) {
	            this.aggregationStage.execute({ rowNode: this.rootNode, changedPath: changedPath });
	        }
	    };
	    // + gridApi.expandAll()
	    // + gridApi.collapseAll()
	    ClientSideRowModel.prototype.expandOrCollapseAll = function (expand) {
	        var usingTreeData = this.gridOptionsWrapper.isTreeData();
	        if (this.rootNode) {
	            recursiveExpandOrCollapse(this.rootNode.childrenAfterGroup);
	        }
	        function recursiveExpandOrCollapse(rowNodes) {
	            if (!rowNodes) {
	                return;
	            }
	            rowNodes.forEach(function (rowNode) {
	                var shouldExpandOrCollapse = usingTreeData ? utils_1._.exists(rowNode.childrenAfterGroup) : rowNode.group;
	                if (shouldExpandOrCollapse) {
	                    rowNode.expanded = expand;
	                    recursiveExpandOrCollapse(rowNode.childrenAfterGroup);
	                }
	            });
	        }
	        this.refreshModel({ step: constants_1.Constants.STEP_MAP });
	        var eventSource = expand ? 'expandAll' : 'collapseAll';
	        var event = {
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            type: events_1.Events.EVENT_EXPAND_COLLAPSE_ALL,
	            source: eventSource
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ClientSideRowModel.prototype.doSort = function (rowNodeTransactions, changedPath) {
	        this.sortStage.execute({
	            rowNode: this.rootNode,
	            rowNodeTransactions: rowNodeTransactions,
	            changedPath: changedPath
	        });
	    };
	    ClientSideRowModel.prototype.doRowGrouping = function (groupState, rowNodeTransactions, rowNodeOrder, changedPath, afterColumnsChanged) {
	        var _this = this;
	        // grouping is enterprise only, so if service missing, skip the step
	        var doingLegacyTreeData = utils_1._.exists(this.gridOptionsWrapper.getNodeChildDetailsFunc());
	        if (doingLegacyTreeData) {
	            return;
	        }
	        if (this.groupStage) {
	            if (rowNodeTransactions && utils_1._.exists(rowNodeTransactions)) {
	                rowNodeTransactions.forEach(function (tran) {
	                    _this.groupStage.execute({
	                        rowNode: _this.rootNode,
	                        rowNodeTransaction: tran,
	                        rowNodeOrder: rowNodeOrder,
	                        changedPath: changedPath
	                    });
	                });
	            }
	            else {
	                // groups are about to get disposed, so need to deselect any that are selected
	                this.selectionController.removeGroupsFromSelection();
	                this.groupStage.execute({
	                    rowNode: this.rootNode,
	                    changedPath: changedPath,
	                    afterColumnsChanged: afterColumnsChanged
	                });
	                // set open/closed state on groups
	                this.restoreGroupState(groupState);
	            }
	            if (this.gridOptionsWrapper.isGroupSelectsChildren()) {
	                this.selectionController.updateGroupsFromChildrenSelections(changedPath);
	            }
	        }
	        else {
	            this.rootNode.childrenAfterGroup = this.rootNode.allLeafChildren;
	        }
	    };
	    ClientSideRowModel.prototype.restoreGroupState = function (groupState) {
	        if (!groupState) {
	            return;
	        }
	        utils_1._.traverseNodesWithKey(this.rootNode.childrenAfterGroup, function (node, key) {
	            // if the group was open last time, then open it this time. however
	            // if was not open last time, then don't touch the group, so the 'groupDefaultExpanded'
	            // setting will take effect.
	            if (typeof groupState[key] === 'boolean') {
	                node.expanded = groupState[key];
	            }
	        });
	    };
	    ClientSideRowModel.prototype.doFilter = function (changedPath) {
	        this.filterStage.execute({ rowNode: this.rootNode, changedPath: changedPath });
	    };
	    ClientSideRowModel.prototype.doPivot = function (changedPath) {
	        if (this.pivotStage) {
	            this.pivotStage.execute({ rowNode: this.rootNode, changedPath: changedPath });
	        }
	    };
	    ClientSideRowModel.prototype.getGroupState = function () {
	        if (!this.rootNode.childrenAfterGroup || !this.gridOptionsWrapper.isRememberGroupStateWhenNewData()) {
	            return null;
	        }
	        var result = {};
	        utils_1._.traverseNodesWithKey(this.rootNode.childrenAfterGroup, function (node, key) { return result[key] = node.expanded; });
	        return result;
	    };
	    ClientSideRowModel.prototype.getCopyOfNodesMap = function () {
	        return this.nodeManager.getCopyOfNodesMap();
	    };
	    ClientSideRowModel.prototype.getRowNode = function (id) {
	        return this.nodeManager.getRowNode(id);
	    };
	    // rows: the rows to put into the model
	    ClientSideRowModel.prototype.setRowData = function (rowData) {
	        // no need to invalidate cache, as the cache is stored on the rowNode,
	        // so new rowNodes means the cache is wiped anyway.
	        // remember group state, so we can expand groups that should be expanded
	        var groupState = this.getGroupState();
	        this.nodeManager.setRowData(rowData);
	        // this event kicks off:
	        // - clears selection
	        // - updates filters
	        // - shows 'no rows' overlay if needed
	        var rowDataChangedEvent = {
	            type: events_1.Events.EVENT_ROW_DATA_CHANGED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(rowDataChangedEvent);
	        this.refreshModel({
	            step: constants_1.Constants.STEP_EVERYTHING,
	            groupState: groupState,
	            newData: true
	        });
	    };
	    ClientSideRowModel.prototype.batchUpdateRowData = function (rowDataTransaction, callback) {
	        var _this = this;
	        if (!this.rowDataTransactionBatch) {
	            this.rowDataTransactionBatch = [];
	            var waitMillis = this.gridOptionsWrapper.getBatchUpdateWaitMillis();
	            window.setTimeout(function () {
	                _this.executeBatchUpdateRowData();
	                _this.rowDataTransactionBatch = null;
	            }, waitMillis);
	        }
	        this.rowDataTransactionBatch.push({ rowDataTransaction: rowDataTransaction, callback: callback });
	    };
	    ClientSideRowModel.prototype.executeBatchUpdateRowData = function () {
	        var _this = this;
	        this.valueCache.onDataChanged();
	        var callbackFuncsBound = [];
	        var rowNodeTrans = [];
	        if (this.rowDataTransactionBatch) {
	            this.rowDataTransactionBatch.forEach(function (tranItem) {
	                var rowNodeTran = _this.nodeManager.updateRowData(tranItem.rowDataTransaction, null);
	                rowNodeTrans.push(rowNodeTran);
	                if (tranItem.callback) {
	                    callbackFuncsBound.push(tranItem.callback.bind(null, rowNodeTran));
	                }
	            });
	        }
	        this.commonUpdateRowData(rowNodeTrans);
	        // do callbacks in next VM turn so it's async
	        if (callbackFuncsBound.length > 0) {
	            window.setTimeout(function () {
	                callbackFuncsBound.forEach(function (func) { return func(); });
	            }, 0);
	        }
	    };
	    ClientSideRowModel.prototype.updateRowData = function (rowDataTran, rowNodeOrder) {
	        this.valueCache.onDataChanged();
	        var rowNodeTran = this.nodeManager.updateRowData(rowDataTran, rowNodeOrder);
	        this.commonUpdateRowData([rowNodeTran], rowNodeOrder);
	        return rowNodeTran;
	    };
	    // common to updateRowData and batchUpdateRowData
	    ClientSideRowModel.prototype.commonUpdateRowData = function (rowNodeTrans, rowNodeOrder) {
	        this.refreshModel({
	            step: constants_1.Constants.STEP_EVERYTHING,
	            rowNodeTransactions: rowNodeTrans,
	            rowNodeOrder: rowNodeOrder,
	            keepRenderedRows: true,
	            animate: true,
	            keepEditingRows: true
	        });
	        var event = {
	            type: events_1.Events.EVENT_ROW_DATA_UPDATED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    ClientSideRowModel.prototype.doRowsToDisplay = function () {
	        this.rowsToDisplay = this.flattenStage.execute({ rowNode: this.rootNode });
	    };
	    ClientSideRowModel.prototype.onRowHeightChanged = function () {
	        this.refreshModel({ step: constants_1.Constants.STEP_MAP, keepRenderedRows: true, keepEditingRows: true });
	    };
	    ClientSideRowModel.prototype.resetRowHeights = function () {
	        this.forEachNode(function (rowNode) { return rowNode.setRowHeight(null); });
	        this.onRowHeightChanged();
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], ClientSideRowModel.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], ClientSideRowModel.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('filterManager'),
	        __metadata("design:type", filterManager_1.FilterManager)
	    ], ClientSideRowModel.prototype, "filterManager", void 0);
	    __decorate([
	        context_1.Autowired('$scope'),
	        __metadata("design:type", Object)
	    ], ClientSideRowModel.prototype, "$scope", void 0);
	    __decorate([
	        context_1.Autowired('selectionController'),
	        __metadata("design:type", selectionController_1.SelectionController)
	    ], ClientSideRowModel.prototype, "selectionController", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], ClientSideRowModel.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('context'),
	        __metadata("design:type", context_1.Context)
	    ], ClientSideRowModel.prototype, "context", void 0);
	    __decorate([
	        context_1.Autowired('valueService'),
	        __metadata("design:type", valueService_1.ValueService)
	    ], ClientSideRowModel.prototype, "valueService", void 0);
	    __decorate([
	        context_1.Autowired('valueCache'),
	        __metadata("design:type", valueCache_1.ValueCache)
	    ], ClientSideRowModel.prototype, "valueCache", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], ClientSideRowModel.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], ClientSideRowModel.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.Autowired('filterStage'),
	        __metadata("design:type", Object)
	    ], ClientSideRowModel.prototype, "filterStage", void 0);
	    __decorate([
	        context_1.Autowired('sortStage'),
	        __metadata("design:type", Object)
	    ], ClientSideRowModel.prototype, "sortStage", void 0);
	    __decorate([
	        context_1.Autowired('flattenStage'),
	        __metadata("design:type", Object)
	    ], ClientSideRowModel.prototype, "flattenStage", void 0);
	    __decorate([
	        context_1.Optional('groupStage'),
	        __metadata("design:type", Object)
	    ], ClientSideRowModel.prototype, "groupStage", void 0);
	    __decorate([
	        context_1.Optional('aggregationStage'),
	        __metadata("design:type", Object)
	    ], ClientSideRowModel.prototype, "aggregationStage", void 0);
	    __decorate([
	        context_1.Optional('pivotStage'),
	        __metadata("design:type", Object)
	    ], ClientSideRowModel.prototype, "pivotStage", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ClientSideRowModel.prototype, "init", null);
	    ClientSideRowModel = __decorate([
	        context_1.Bean('rowModel')
	    ], ClientSideRowModel);
	    return ClientSideRowModel;
	}());
	exports.ClientSideRowModel = ClientSideRowModel;


/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var filterService_1 = __webpack_require__(674);
	var selectableService_1 = __webpack_require__(443);
	var FilterStage = /** @class */ (function () {
	    function FilterStage() {
	    }
	    FilterStage.prototype.execute = function (params) {
	        var rowNode = params.rowNode, changedPath = params.changedPath;
	        this.filterService.filter(changedPath);
	        this.selectableService.updateSelectableAfterFiltering(rowNode);
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], FilterStage.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('selectableService'),
	        __metadata("design:type", selectableService_1.SelectableService)
	    ], FilterStage.prototype, "selectableService", void 0);
	    __decorate([
	        context_1.Autowired('filterService'),
	        __metadata("design:type", filterService_1.FilterService)
	    ], FilterStage.prototype, "filterService", void 0);
	    FilterStage = __decorate([
	        context_1.Bean('filterStage')
	    ], FilterStage);
	    return FilterStage;
	}());
	exports.FilterStage = FilterStage;


/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var rowNode_1 = __webpack_require__(101);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var selectionController_1 = __webpack_require__(102);
	var eventService_1 = __webpack_require__(22);
	var columnController_1 = __webpack_require__(26);
	var utils_1 = __webpack_require__(10);
	var FlattenStage = /** @class */ (function () {
	    function FlattenStage() {
	    }
	    FlattenStage.prototype.execute = function (params) {
	        var rootNode = params.rowNode;
	        // even if not doing grouping, we do the mapping, as the client might
	        // of passed in data that already has a grouping in it somewhere
	        var result = [];
	        // putting value into a wrapper so it's passed by reference
	        var nextRowTop = { value: 0 };
	        var skipLeafNodes = this.columnController.isPivotMode();
	        // if we are reducing, and not grouping, then we want to show the root node, as that
	        // is where the pivot values are
	        var showRootNode = skipLeafNodes && rootNode.leafGroup;
	        var topList = showRootNode ? [rootNode] : rootNode.childrenAfterSort;
	        this.recursivelyAddToRowsToDisplay(topList, result, nextRowTop, skipLeafNodes, 0);
	        // don't show total footer when showRootNode is true (i.e. in pivot mode and no groups)
	        var includeGroupTotalFooter = !showRootNode && this.gridOptionsWrapper.isGroupIncludeTotalFooter();
	        if (includeGroupTotalFooter) {
	            this.ensureFooterNodeExists(rootNode);
	            this.addRowNodeToRowsToDisplay(rootNode.sibling, result, nextRowTop, 0);
	        }
	        return result;
	    };
	    FlattenStage.prototype.recursivelyAddToRowsToDisplay = function (rowsToFlatten, result, nextRowTop, skipLeafNodes, uiLevel) {
	        if (utils_1._.missingOrEmpty(rowsToFlatten)) {
	            return;
	        }
	        var groupSuppressRow = this.gridOptionsWrapper.isGroupSuppressRow();
	        var hideOpenParents = this.gridOptionsWrapper.isGroupHideOpenParents();
	        // these two are mutually exclusive, so if first set, we don't set the second
	        var groupRemoveSingleChildren = this.gridOptionsWrapper.isGroupRemoveSingleChildren();
	        var groupRemoveLowestSingleChildren = !groupRemoveSingleChildren && this.gridOptionsWrapper.isGroupRemoveLowestSingleChildren();
	        for (var i = 0; i < rowsToFlatten.length; i++) {
	            var rowNode = rowsToFlatten[i];
	            // check all these cases, for working out if this row should be included in the final mapped list
	            var isParent = rowNode.hasChildren();
	            var isGroupSuppressedNode = groupSuppressRow && isParent;
	            var isSkippedLeafNode = skipLeafNodes && !isParent;
	            var isRemovedSingleChildrenGroup = groupRemoveSingleChildren && isParent && rowNode.childrenAfterGroup.length === 1;
	            var isRemovedLowestSingleChildrenGroup = groupRemoveLowestSingleChildren && isParent && rowNode.leafGroup && rowNode.childrenAfterGroup.length === 1;
	            // hide open parents means when group is open, we don't show it. we also need to make sure the
	            // group is expandable in the first place (as leaf groups are not expandable if pivot mode is on).
	            // the UI will never allow expanding leaf  groups, however the user might via the API (or menu option 'expand all')
	            var neverAllowToExpand = skipLeafNodes && rowNode.leafGroup;
	            var isHiddenOpenParent = hideOpenParents && rowNode.expanded && (!neverAllowToExpand);
	            var thisRowShouldBeRendered = !isSkippedLeafNode && !isGroupSuppressedNode && !isHiddenOpenParent && !isRemovedSingleChildrenGroup && !isRemovedLowestSingleChildrenGroup;
	            if (thisRowShouldBeRendered) {
	                this.addRowNodeToRowsToDisplay(rowNode, result, nextRowTop, uiLevel);
	            }
	            // if we are pivoting, we never map below the leaf group
	            if (skipLeafNodes && rowNode.leafGroup) {
	                continue;
	            }
	            if (isParent) {
	                var excludedParent = isRemovedSingleChildrenGroup || isRemovedLowestSingleChildrenGroup;
	                // we traverse the group if it is expended, however we always traverse if the parent node
	                // was removed (as the group will never be opened if it is not displayed, we show the children instead)
	                if (rowNode.expanded || excludedParent) {
	                    // if the parent was excluded, then ui level is that of the parent
	                    var uiLevelForChildren = excludedParent ? uiLevel : uiLevel + 1;
	                    this.recursivelyAddToRowsToDisplay(rowNode.childrenAfterSort, result, nextRowTop, skipLeafNodes, uiLevelForChildren);
	                    // put a footer in if user is looking for it
	                    if (this.gridOptionsWrapper.isGroupIncludeFooter()) {
	                        this.ensureFooterNodeExists(rowNode);
	                        this.addRowNodeToRowsToDisplay(rowNode.sibling, result, nextRowTop, uiLevel);
	                    }
	                }
	            }
	            else if (rowNode.master && rowNode.expanded) {
	                var detailNode = this.createDetailNode(rowNode);
	                this.addRowNodeToRowsToDisplay(detailNode, result, nextRowTop, uiLevel);
	            }
	        }
	    };
	    // duplicated method, it's also in floatingRowModel
	    FlattenStage.prototype.addRowNodeToRowsToDisplay = function (rowNode, result, nextRowTop, uiLevel) {
	        result.push(rowNode);
	        var isGroupMultiAutoColumn = this.gridOptionsWrapper.isGroupMultiAutoColumn();
	        rowNode.setUiLevel(isGroupMultiAutoColumn ? 0 : uiLevel);
	    };
	    FlattenStage.prototype.ensureFooterNodeExists = function (groupNode) {
	        // only create footer node once, otherwise we have daemons and
	        // the animate screws up with the daemons hanging around
	        if (utils_1._.exists(groupNode.sibling)) {
	            return;
	        }
	        var footerNode = new rowNode_1.RowNode();
	        this.context.wireBean(footerNode);
	        Object.keys(groupNode).forEach(function (key) {
	            footerNode[key] = groupNode[key];
	        });
	        footerNode.footer = true;
	        footerNode.rowTop = null;
	        footerNode.oldRowTop = null;
	        if (utils_1._.exists(footerNode.id)) {
	            footerNode.id = 'rowGroupFooter_' + footerNode.id;
	        }
	        // get both header and footer to reference each other as siblings. this is never undone,
	        // only overwritten. so if a group is expanded, then contracted, it will have a ghost
	        // sibling - but that's fine, as we can ignore this if the header is contracted.
	        footerNode.sibling = groupNode;
	        groupNode.sibling = footerNode;
	    };
	    FlattenStage.prototype.createDetailNode = function (masterNode) {
	        if (utils_1._.exists(masterNode.detailNode)) {
	            return masterNode.detailNode;
	        }
	        else {
	            var detailNode = new rowNode_1.RowNode();
	            this.context.wireBean(detailNode);
	            detailNode.detail = true;
	            detailNode.selectable = false;
	            // flower was renamed to 'detail', but keeping for backwards compatibility
	            detailNode.flower = detailNode.detail;
	            detailNode.parent = masterNode;
	            if (utils_1._.exists(masterNode.id)) {
	                detailNode.id = 'detail_' + masterNode.id;
	            }
	            detailNode.data = masterNode.data;
	            detailNode.level = masterNode.level + 1;
	            masterNode.detailNode = detailNode;
	            masterNode.childFlower = masterNode.detailNode; // for backwards compatibility
	            return detailNode;
	        }
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], FlattenStage.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('selectionController'),
	        __metadata("design:type", selectionController_1.SelectionController)
	    ], FlattenStage.prototype, "selectionController", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], FlattenStage.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('context'),
	        __metadata("design:type", context_1.Context)
	    ], FlattenStage.prototype, "context", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], FlattenStage.prototype, "columnController", void 0);
	    FlattenStage = __decorate([
	        context_1.Bean('flattenStage')
	    ], FlattenStage);
	    return FlattenStage;
	}());
	exports.FlattenStage = FlattenStage;


/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var constants_1 = __webpack_require__(30);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var utils_1 = __webpack_require__(10);
	var ImmutableService = /** @class */ (function () {
	    function ImmutableService() {
	    }
	    ImmutableService.prototype.postConstruct = function () {
	        if (this.rowModel.getType() === constants_1.Constants.ROW_MODEL_TYPE_CLIENT_SIDE) {
	            this.clientSideRowModel = this.rowModel;
	        }
	    };
	    // converts the setRowData() command to a transaction
	    ImmutableService.prototype.createTransactionForRowData = function (data) {
	        if (utils_1._.missing(this.clientSideRowModel)) {
	            console.error('ag-Grid: ImmutableService only works with ClientSideRowModel');
	            return;
	        }
	        var getRowNodeIdFunc = this.gridOptionsWrapper.getRowNodeIdFunc();
	        if (!getRowNodeIdFunc || utils_1._.missing(getRowNodeIdFunc)) {
	            console.error('ag-Grid: ImmutableService requires getRowNodeId() callback to be implemented, your row data need IDs!');
	            return;
	        }
	        // convert the data into a transaction object by working out adds, removes and updates
	        var transaction = {
	            remove: [],
	            update: [],
	            add: []
	        };
	        var existingNodesMap = this.clientSideRowModel.getCopyOfNodesMap();
	        var suppressSortOrder = this.gridOptionsWrapper.isSuppressMaintainUnsortedOrder();
	        var orderMap = suppressSortOrder ? null : {};
	        if (utils_1._.exists(data)) {
	            // split all the new data in the following:
	            // if new, push to 'add'
	            // if update, push to 'update'
	            // if not changed, do not include in the transaction
	            data.forEach(function (dataItem, index) {
	                var id = getRowNodeIdFunc(dataItem);
	                var existingNode = existingNodesMap[id];
	                if (orderMap) {
	                    orderMap[id] = index;
	                }
	                if (existingNode) {
	                    var dataHasChanged = existingNode.data !== dataItem;
	                    if (dataHasChanged) {
	                        transaction.update.push(dataItem);
	                    }
	                    // otherwise, if data not changed, we just don't include it anywhere, as it's not a delta
	                    // remove from list, so we know the item is not to be removed
	                    existingNodesMap[id] = undefined;
	                }
	                else {
	                    transaction.add.push(dataItem);
	                }
	            });
	        }
	        // at this point, all rows that are left, should be removed
	        utils_1._.iterateObject(existingNodesMap, function (id, rowNode) {
	            if (rowNode) {
	                transaction.remove.push(rowNode.data);
	            }
	        });
	        return [transaction, orderMap];
	    };
	    __decorate([
	        context_1.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], ImmutableService.prototype, "rowModel", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], ImmutableService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ImmutableService.prototype, "postConstruct", null);
	    ImmutableService = __decorate([
	        context_1.Bean('immutableService')
	    ], ImmutableService);
	    return ImmutableService;
	}());
	exports.ImmutableService = ImmutableService;


/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var sortService_1 = __webpack_require__(675);
	var sortController_1 = __webpack_require__(120);
	var columnController_1 = __webpack_require__(26);
	var utils_1 = __webpack_require__(10);
	var SortStage = /** @class */ (function () {
	    function SortStage() {
	    }
	    SortStage.prototype.execute = function (params) {
	        var sortOptions = this.sortController.getSortForRowController();
	        var sortActive = utils_1._.exists(sortOptions) && sortOptions.length > 0;
	        var deltaSort = sortActive
	            && utils_1._.exists(params.rowNodeTransactions)
	            // in time we can remove this check, so that delta sort is always
	            // on if transactions are present. it's off for now so that we can
	            // selectively turn it on and test it with some select users before
	            // rolling out to everyone.
	            && this.gridOptionsWrapper.isDeltaSort();
	        // we only need dirty nodes if doing delta sort
	        var dirtyLeafNodes = deltaSort ? this.calculateDirtyNodes(params.rowNodeTransactions) : null;
	        var valueColumns = this.columnController.getValueColumns();
	        var noAggregations = utils_1._.missingOrEmpty(valueColumns);
	        this.sortService.sort(sortOptions, sortActive, deltaSort, dirtyLeafNodes, params.changedPath, noAggregations);
	    };
	    SortStage.prototype.calculateDirtyNodes = function (rowNodeTransactions) {
	        var dirtyNodes = {};
	        var addNodesFunc = function (rowNodes) {
	            if (rowNodes) {
	                rowNodes.forEach(function (rowNode) { return dirtyNodes[rowNode.id] = true; });
	            }
	        };
	        // all leaf level nodes in the transaction were impacted
	        rowNodeTransactions.forEach(function (tran) {
	            addNodesFunc(tran.add);
	            addNodesFunc(tran.update);
	            addNodesFunc(tran.remove);
	        });
	        return dirtyNodes;
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], SortStage.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('sortService'),
	        __metadata("design:type", sortService_1.SortService)
	    ], SortStage.prototype, "sortService", void 0);
	    __decorate([
	        context_1.Autowired('sortController'),
	        __metadata("design:type", sortController_1.SortController)
	    ], SortStage.prototype, "sortController", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], SortStage.prototype, "columnController", void 0);
	    SortStage = __decorate([
	        context_1.Bean('sortStage')
	    ], SortStage);
	    return SortStage;
	}());
	exports.SortStage = SortStage;


/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var context_1 = __webpack_require__(8);
	var eventService_1 = __webpack_require__(22);
	var selectionController_1 = __webpack_require__(102);
	var events_1 = __webpack_require__(29);
	var sortController_1 = __webpack_require__(120);
	var filterManager_1 = __webpack_require__(77);
	var constants_1 = __webpack_require__(30);
	var infiniteCache_1 = __webpack_require__(1408);
	var beanStub_1 = __webpack_require__(71);
	var rowNodeCache_1 = __webpack_require__(442);
	var rowNodeBlockLoader_1 = __webpack_require__(665);
	var gridApi_1 = __webpack_require__(33);
	var columnApi_1 = __webpack_require__(38);
	var utils_1 = __webpack_require__(10);
	var rowRenderer_1 = __webpack_require__(91);
	var InfiniteRowModel = /** @class */ (function (_super) {
	    __extends(InfiniteRowModel, _super);
	    function InfiniteRowModel() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    InfiniteRowModel.prototype.getRowBounds = function (index) {
	        return {
	            rowHeight: this.rowHeight,
	            rowTop: this.rowHeight * index
	        };
	    };
	    // we don't implement as lazy row heights is not supported in this row model
	    InfiniteRowModel.prototype.ensureRowHeightsValid = function (startPixel, endPixel, startLimitIndex, endLimitIndex) { return false; };
	    InfiniteRowModel.prototype.init = function () {
	        var _this = this;
	        if (!this.gridOptionsWrapper.isRowModelInfinite()) {
	            return;
	        }
	        this.rowHeight = this.gridOptionsWrapper.getRowHeightAsNumber();
	        this.addEventListeners();
	        this.setDatasource(this.gridOptionsWrapper.getDatasource());
	        this.addDestroyFunc(function () { return _this.destroyCache(); });
	    };
	    InfiniteRowModel.prototype.destroyDatasource = function () {
	        if (this.datasource) {
	            if (this.datasource.destroy) {
	                this.datasource.destroy();
	            }
	            this.rowRenderer.datasourceChanged();
	            this.datasource = null;
	        }
	    };
	    InfiniteRowModel.prototype.isLastRowFound = function () {
	        return this.infiniteCache ? this.infiniteCache.isMaxRowFound() : false;
	    };
	    InfiniteRowModel.prototype.addEventListeners = function () {
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_SORT_CHANGED, this.onSortChanged.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED, this.onColumnEverything.bind(this));
	    };
	    InfiniteRowModel.prototype.onFilterChanged = function () {
	        this.reset();
	    };
	    InfiniteRowModel.prototype.onSortChanged = function () {
	        this.reset();
	    };
	    InfiniteRowModel.prototype.onColumnEverything = function () {
	        var resetRequired;
	        // if cache params, we require reset only if sort model has changed. we don't need to check
	        // for filter model, as the filter manager will fire an event when columns change that result
	        // in the filter changing.
	        if (this.cacheParams) {
	            resetRequired = this.isSortModelDifferent();
	        }
	        else {
	            // if no cacheParams, means first time creating the cache, so always create one
	            resetRequired = true;
	        }
	        if (resetRequired) {
	            this.reset();
	        }
	    };
	    InfiniteRowModel.prototype.isSortModelDifferent = function () {
	        return !utils_1._.jsonEquals(this.cacheParams.sortModel, this.sortController.getSortModel());
	    };
	    InfiniteRowModel.prototype.getType = function () {
	        return constants_1.Constants.ROW_MODEL_TYPE_INFINITE;
	    };
	    InfiniteRowModel.prototype.setDatasource = function (datasource) {
	        this.destroyDatasource();
	        this.datasource = datasource;
	        // only reset if we have a valid datasource to working with
	        if (datasource) {
	            this.checkForDeprecated();
	            this.reset();
	        }
	    };
	    InfiniteRowModel.prototype.checkForDeprecated = function () {
	        var ds = this.datasource;
	        // the number of concurrent loads we are allowed to the server
	        if (utils_1._.exists(ds.maxConcurrentRequests)) {
	            console.error('ag-Grid: since version 5.1.x, maxConcurrentRequests is replaced with grid property maxConcurrentDatasourceRequests');
	        }
	        if (utils_1._.exists(ds.maxPagesInCache)) {
	            console.error('ag-Grid: since version 5.1.x, maxPagesInCache is replaced with grid property maxPagesInPaginationCache');
	        }
	        if (utils_1._.exists(ds.overflowSize)) {
	            console.error('ag-Grid: since version 5.1.x, overflowSize is replaced with grid property paginationOverflowSize');
	        }
	        if (utils_1._.exists(ds.blockSize)) {
	            console.error('ag-Grid: since version 5.1.x, pageSize/blockSize is replaced with grid property infinitePageSize');
	        }
	    };
	    InfiniteRowModel.prototype.isEmpty = function () {
	        return utils_1._.missing(this.infiniteCache);
	    };
	    InfiniteRowModel.prototype.isRowsToRender = function () {
	        return utils_1._.exists(this.infiniteCache);
	    };
	    InfiniteRowModel.prototype.getNodesInRangeForSelection = function (firstInRange, lastInRange) {
	        return this.infiniteCache ? this.infiniteCache.getRowNodesInRange(firstInRange, lastInRange) : [];
	    };
	    InfiniteRowModel.prototype.reset = function () {
	        // important to return here, as the user could be setting filter or sort before
	        // data-source is set
	        if (utils_1._.missing(this.datasource)) {
	            return;
	        }
	        // if user is providing id's, then this means we can keep the selection between datasource hits,
	        // as the rows will keep their unique id's even if, for example, server side sorting or filtering
	        // is done.
	        var userGeneratingIds = utils_1._.exists(this.gridOptionsWrapper.getRowNodeIdFunc());
	        if (!userGeneratingIds) {
	            this.selectionController.reset();
	        }
	        this.resetCache();
	        var event = this.createModelUpdatedEvent();
	        this.eventService.dispatchEvent(event);
	    };
	    InfiniteRowModel.prototype.createModelUpdatedEvent = function () {
	        return {
	            type: events_1.Events.EVENT_MODEL_UPDATED,
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            // not sure if these should all be false - noticed if after implementing,
	            // maybe they should be true?
	            newPage: false,
	            newData: false,
	            keepRenderedRows: false,
	            animate: false
	        };
	    };
	    InfiniteRowModel.prototype.resetCache = function () {
	        // if not first time creating a cache, need to destroy the old one
	        this.destroyCache();
	        var maxConcurrentRequests = this.gridOptionsWrapper.getMaxConcurrentDatasourceRequests();
	        var blockLoadDebounceMillis = this.gridOptionsWrapper.getBlockLoadDebounceMillis();
	        // there is a bi-directional dependency between the loader and the cache,
	        // so we create loader here, and then pass dependencies in setDependencies() method later
	        this.rowNodeBlockLoader = new rowNodeBlockLoader_1.RowNodeBlockLoader(maxConcurrentRequests, blockLoadDebounceMillis);
	        this.getContext().wireBean(this.rowNodeBlockLoader);
	        this.cacheParams = {
	            // the user provided datasource
	            datasource: this.datasource,
	            // sort and filter model
	            filterModel: this.filterManager.getFilterModel(),
	            sortModel: this.sortController.getSortModel(),
	            rowNodeBlockLoader: this.rowNodeBlockLoader,
	            // properties - this way we take a snapshot of them, so if user changes any, they will be
	            // used next time we create a new cache, which is generally after a filter or sort change,
	            // or a new datasource is set
	            maxConcurrentRequests: maxConcurrentRequests,
	            overflowSize: this.gridOptionsWrapper.getCacheOverflowSize(),
	            initialRowCount: this.gridOptionsWrapper.getInfiniteInitialRowCount(),
	            maxBlocksInCache: this.gridOptionsWrapper.getMaxBlocksInCache(),
	            blockSize: this.gridOptionsWrapper.getCacheBlockSize(),
	            rowHeight: this.gridOptionsWrapper.getRowHeightAsNumber(),
	            // the cache could create this, however it is also used by the pages, so handy to create it
	            // here as the settings are also passed to the pages
	            lastAccessedSequence: new utils_1.NumberSequence()
	        };
	        // set defaults
	        if (!this.cacheParams.maxConcurrentRequests || !(this.cacheParams.maxConcurrentRequests >= 1)) {
	            this.cacheParams.maxConcurrentRequests = 2;
	        }
	        // page size needs to be 1 or greater. having it at 1 would be silly, as you would be hitting the
	        // server for one page at a time. so the default if not specified is 100.
	        if (!this.cacheParams.blockSize || !(this.cacheParams.blockSize >= 1)) {
	            this.cacheParams.blockSize = 100;
	        }
	        // if user doesn't give initial rows to display, we assume zero
	        if (!(this.cacheParams.initialRowCount >= 1)) {
	            this.cacheParams.initialRowCount = 0;
	        }
	        // if user doesn't provide overflow, we use default overflow of 1, so user can scroll past
	        // the current page and request first row of next page
	        if (!(this.cacheParams.overflowSize >= 1)) {
	            this.cacheParams.overflowSize = 1;
	        }
	        this.infiniteCache = new infiniteCache_1.InfiniteCache(this.cacheParams);
	        this.getContext().wireBean(this.infiniteCache);
	        this.infiniteCache.addEventListener(rowNodeCache_1.RowNodeCache.EVENT_CACHE_UPDATED, this.onCacheUpdated.bind(this));
	    };
	    InfiniteRowModel.prototype.destroyCache = function () {
	        if (this.infiniteCache) {
	            this.infiniteCache.destroy();
	            this.infiniteCache = null;
	        }
	        if (this.rowNodeBlockLoader) {
	            this.rowNodeBlockLoader.destroy();
	            this.rowNodeBlockLoader = null;
	        }
	    };
	    InfiniteRowModel.prototype.onCacheUpdated = function () {
	        var event = this.createModelUpdatedEvent();
	        this.eventService.dispatchEvent(event);
	    };
	    InfiniteRowModel.prototype.getRow = function (rowIndex) {
	        return this.infiniteCache ? this.infiniteCache.getRow(rowIndex) : null;
	    };
	    InfiniteRowModel.prototype.getRowNode = function (id) {
	        var result = null;
	        this.forEachNode(function (rowNode) {
	            if (rowNode.id === id) {
	                result = rowNode;
	            }
	        });
	        return result;
	    };
	    InfiniteRowModel.prototype.forEachNode = function (callback) {
	        if (this.infiniteCache) {
	            this.infiniteCache.forEachNodeDeep(callback, new utils_1.NumberSequence());
	        }
	    };
	    InfiniteRowModel.prototype.getCurrentPageHeight = function () {
	        return this.getRowCount() * this.rowHeight;
	    };
	    InfiniteRowModel.prototype.getTopLevelRowCount = function () {
	        return this.getRowCount();
	    };
	    InfiniteRowModel.prototype.getTopLevelRowDisplayedIndex = function (topLevelIndex) {
	        return topLevelIndex;
	    };
	    InfiniteRowModel.prototype.getRowIndexAtPixel = function (pixel) {
	        if (this.rowHeight !== 0) { // avoid divide by zero error
	            var rowIndexForPixel = Math.floor(pixel / this.rowHeight);
	            var lastRowIndex = this.getRowCount() - 1;
	            if (rowIndexForPixel > lastRowIndex) {
	                return lastRowIndex;
	            }
	            else {
	                return rowIndexForPixel;
	            }
	        }
	        else {
	            return 0;
	        }
	    };
	    InfiniteRowModel.prototype.getRowCount = function () {
	        return this.infiniteCache ? this.infiniteCache.getVirtualRowCount() : 0;
	    };
	    InfiniteRowModel.prototype.updateRowData = function (transaction) {
	        if (utils_1._.exists(transaction.remove) || utils_1._.exists(transaction.update)) {
	            console.warn('ag-Grid: updateRowData for InfiniteRowModel does not support remove or update, only add');
	            return;
	        }
	        if (utils_1._.missing(transaction.addIndex)) {
	            console.warn('ag-Grid: updateRowData for InfiniteRowModel requires add and addIndex to be set');
	            return;
	        }
	        if (this.infiniteCache) {
	            this.infiniteCache.insertItemsAtIndex(transaction.addIndex, transaction.add);
	        }
	    };
	    InfiniteRowModel.prototype.isRowPresent = function (rowNode) {
	        return false;
	    };
	    InfiniteRowModel.prototype.refreshCache = function () {
	        if (this.infiniteCache) {
	            this.infiniteCache.refreshCache();
	        }
	    };
	    InfiniteRowModel.prototype.purgeCache = function () {
	        if (this.infiniteCache) {
	            this.infiniteCache.purgeCache();
	        }
	    };
	    InfiniteRowModel.prototype.getVirtualRowCount = function () {
	        if (this.infiniteCache) {
	            return this.infiniteCache.getVirtualRowCount();
	        }
	        else {
	            return null;
	        }
	    };
	    InfiniteRowModel.prototype.isMaxRowFound = function () {
	        if (this.infiniteCache) {
	            return this.infiniteCache.isMaxRowFound();
	        }
	    };
	    InfiniteRowModel.prototype.setVirtualRowCount = function (rowCount, maxRowFound) {
	        if (this.infiniteCache) {
	            this.infiniteCache.setVirtualRowCount(rowCount, maxRowFound);
	        }
	    };
	    InfiniteRowModel.prototype.getBlockState = function () {
	        if (this.rowNodeBlockLoader) {
	            return this.rowNodeBlockLoader.getBlockState();
	        }
	        else {
	            return null;
	        }
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], InfiniteRowModel.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('filterManager'),
	        __metadata("design:type", filterManager_1.FilterManager)
	    ], InfiniteRowModel.prototype, "filterManager", void 0);
	    __decorate([
	        context_1.Autowired('sortController'),
	        __metadata("design:type", sortController_1.SortController)
	    ], InfiniteRowModel.prototype, "sortController", void 0);
	    __decorate([
	        context_1.Autowired('selectionController'),
	        __metadata("design:type", selectionController_1.SelectionController)
	    ], InfiniteRowModel.prototype, "selectionController", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], InfiniteRowModel.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], InfiniteRowModel.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], InfiniteRowModel.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('rowRenderer'),
	        __metadata("design:type", rowRenderer_1.RowRenderer)
	    ], InfiniteRowModel.prototype, "rowRenderer", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], InfiniteRowModel.prototype, "init", null);
	    __decorate([
	        context_1.PreDestroy,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], InfiniteRowModel.prototype, "destroyDatasource", null);
	    InfiniteRowModel = __decorate([
	        context_1.Bean('rowModel')
	    ], InfiniteRowModel);
	    return InfiniteRowModel;
	}(beanStub_1.BeanStub));
	exports.InfiniteRowModel = InfiniteRowModel;


/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var beanStub_1 = __webpack_require__(71);
	var eventService_1 = __webpack_require__(22);
	var events_1 = __webpack_require__(29);
	var context_1 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var scrollVisibleService_1 = __webpack_require__(249);
	var PaginationAutoPageSizeService = /** @class */ (function (_super) {
	    __extends(PaginationAutoPageSizeService, _super);
	    function PaginationAutoPageSizeService() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PaginationAutoPageSizeService.prototype.registerGridComp = function (gridPanel) {
	        this.gridPanel = gridPanel;
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_BODY_HEIGHT_CHANGED, this.onBodyHeightChanged.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_SCROLL_VISIBILITY_CHANGED, this.onScrollVisibilityChanged.bind(this));
	        this.checkPageSize();
	    };
	    PaginationAutoPageSizeService.prototype.notActive = function () {
	        return !this.gridOptionsWrapper.isPaginationAutoPageSize();
	    };
	    PaginationAutoPageSizeService.prototype.onScrollVisibilityChanged = function () {
	        this.checkPageSize();
	    };
	    PaginationAutoPageSizeService.prototype.onBodyHeightChanged = function () {
	        this.checkPageSize();
	    };
	    PaginationAutoPageSizeService.prototype.checkPageSize = function () {
	        if (this.notActive()) {
	            return;
	        }
	        var rowHeight = this.gridOptionsWrapper.getRowHeightAsNumber();
	        var bodyHeight = this.gridPanel.getBodyHeight();
	        if (bodyHeight > 0) {
	            var newPageSize = Math.floor(bodyHeight / rowHeight);
	            this.gridOptionsWrapper.setProperty('paginationPageSize', newPageSize);
	        }
	    };
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], PaginationAutoPageSizeService.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], PaginationAutoPageSizeService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('scrollVisibleService'),
	        __metadata("design:type", scrollVisibleService_1.ScrollVisibleService)
	    ], PaginationAutoPageSizeService.prototype, "scrollVisibleService", void 0);
	    PaginationAutoPageSizeService = __decorate([
	        context_1.Bean('paginationAutoPageSizeService')
	    ], PaginationAutoPageSizeService);
	    return PaginationAutoPageSizeService;
	}(beanStub_1.BeanStub));
	exports.PaginationAutoPageSizeService = PaginationAutoPageSizeService;


/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var filterManager_1 = __webpack_require__(77);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var FilterService = /** @class */ (function () {
	    function FilterService() {
	    }
	    FilterService.prototype.postConstruct = function () {
	        this.doingTreeData = this.gridOptionsWrapper.isTreeData();
	    };
	    FilterService.prototype.filter = function (changedPath) {
	        var filterActive = this.filterManager.isAnyFilterPresent();
	        this.filterNodes(filterActive, changedPath);
	    };
	    FilterService.prototype.filterNodes = function (filterActive, changedPath) {
	        var _this = this;
	        var filterCallback = function (rowNode, includeChildNodes) {
	            // recursively get all children that are groups to also filter
	            if (rowNode.hasChildren()) {
	                // result of filter for this node. when filtering tree data, includeChildNodes = true when parent passes
	                if (filterActive && !includeChildNodes) {
	                    rowNode.childrenAfterFilter = rowNode.childrenAfterGroup.filter(function (childNode) {
	                        // a group is included in the result if it has any children of it's own.
	                        // by this stage, the child groups are already filtered
	                        var passBecauseChildren = childNode.childrenAfterFilter && childNode.childrenAfterFilter.length > 0;
	                        // both leaf level nodes and tree data nodes have data. these get added if
	                        // the data passes the filter
	                        var passBecauseDataPasses = childNode.data && _this.filterManager.doesRowPassFilter(childNode);
	                        // note - tree data nodes pass either if a) they pass themselves or b) any children of that node pass
	                        return passBecauseChildren || passBecauseDataPasses;
	                    });
	                }
	                else {
	                    // if not filtering, the result is the original list
	                    rowNode.childrenAfterFilter = rowNode.childrenAfterGroup;
	                }
	                _this.setAllChildrenCount(rowNode);
	            }
	            else {
	                rowNode.childrenAfterFilter = rowNode.childrenAfterGroup;
	                rowNode.setAllChildrenCount(null);
	            }
	        };
	        if (this.doingTreeDataFiltering()) {
	            var treeDataDepthFirstFilter_1 = function (rowNode, alreadyFoundInParent) {
	                // tree data filter traverses the hierarchy depth first and includes child nodes if parent passes
	                // filter, and parent nodes will be include if any children exist.
	                if (rowNode.childrenAfterGroup) {
	                    for (var i = 0; i < rowNode.childrenAfterGroup.length; i++) {
	                        var childNode = rowNode.childrenAfterGroup[i];
	                        // first check if current node passes filter before invoking child nodes
	                        var foundInParent = alreadyFoundInParent || _this.filterManager.doesRowPassFilter(childNode);
	                        if (childNode.childrenAfterGroup) {
	                            treeDataDepthFirstFilter_1(rowNode.childrenAfterGroup[i], foundInParent);
	                        }
	                        else {
	                            filterCallback(childNode, foundInParent);
	                        }
	                    }
	                }
	                filterCallback(rowNode, alreadyFoundInParent);
	            };
	            var treeDataFilterCallback = function (rowNode) { return treeDataDepthFirstFilter_1(rowNode, false); };
	            changedPath.executeFromRootNode(treeDataFilterCallback);
	        }
	        else {
	            var defaultFilterCallback = function (rowNode) { return filterCallback(rowNode, false); };
	            changedPath.forEachChangedNodeDepthFirst(defaultFilterCallback, true);
	        }
	    };
	    FilterService.prototype.setAllChildrenCountTreeData = function (rowNode) {
	        // for tree data, we include all children, groups and leafs
	        var allChildrenCount = 0;
	        rowNode.childrenAfterFilter.forEach(function (child) {
	            // include child itself
	            allChildrenCount++;
	            // include children of children
	            allChildrenCount += child.allChildrenCount;
	        });
	        rowNode.setAllChildrenCount(allChildrenCount);
	    };
	    FilterService.prototype.setAllChildrenCountGridGrouping = function (rowNode) {
	        // for grid data, we only count the leafs
	        var allChildrenCount = 0;
	        rowNode.childrenAfterFilter.forEach(function (child) {
	            if (child.group) {
	                allChildrenCount += child.allChildrenCount;
	            }
	            else {
	                allChildrenCount++;
	            }
	        });
	        rowNode.setAllChildrenCount(allChildrenCount);
	    };
	    FilterService.prototype.setAllChildrenCount = function (rowNode) {
	        if (this.doingTreeData) {
	            this.setAllChildrenCountTreeData(rowNode);
	        }
	        else {
	            this.setAllChildrenCountGridGrouping(rowNode);
	        }
	    };
	    FilterService.prototype.doingTreeDataFiltering = function () {
	        return this.gridOptionsWrapper.isTreeData() && !this.gridOptionsWrapper.isExcludeChildrenWhenTreeDataFiltering();
	    };
	    __decorate([
	        context_1.Autowired('filterManager'),
	        __metadata("design:type", filterManager_1.FilterManager)
	    ], FilterService.prototype, "filterManager", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], FilterService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], FilterService.prototype, "postConstruct", null);
	    FilterService = __decorate([
	        context_1.Bean("filterService")
	    ], FilterService);
	    return FilterService;
	}());
	exports.FilterService = FilterService;


/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var sortController_1 = __webpack_require__(120);
	var valueService_1 = __webpack_require__(103);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var columnController_1 = __webpack_require__(26);
	var utils_1 = __webpack_require__(10);
	var SortService = /** @class */ (function () {
	    function SortService() {
	    }
	    SortService.prototype.init = function () {
	        this.postSortFunc = this.gridOptionsWrapper.getPostSortFunc();
	    };
	    SortService.prototype.sort = function (sortOptions, sortActive, deltaSort, dirtyLeafNodes, changedPath, noAggregations) {
	        var _this = this;
	        var callback = function (rowNode) {
	            // we clear out the 'pull down open parents' first, as the values mix up the sorting
	            _this.pullDownGroupDataForHideOpenParents(rowNode.childrenAfterFilter, true);
	            // Javascript sort is non deterministic when all the array items are equals, ie Comparator always returns 0,
	            // so to ensure the array keeps its order, add an additional sorting condition manually, in this case we
	            // are going to inspect the original array position. This is what sortedRowNodes is for.
	            if (sortActive) {
	                var sortedRowNodes = deltaSort ?
	                    _this.doDeltaSort(rowNode, sortOptions, dirtyLeafNodes, changedPath, noAggregations)
	                    : _this.doFullSort(rowNode, sortOptions);
	                rowNode.childrenAfterSort = sortedRowNodes.map(function (sorted) { return sorted.rowNode; });
	            }
	            else {
	                rowNode.childrenAfterSort = rowNode.childrenAfterFilter.slice(0);
	            }
	            _this.updateChildIndexes(rowNode);
	            if (_this.postSortFunc) {
	                _this.postSortFunc(rowNode.childrenAfterSort);
	            }
	        };
	        changedPath.forEachChangedNodeDepthFirst(callback);
	        this.updateGroupDataForHiddenOpenParents(changedPath);
	    };
	    SortService.prototype.doFullSort = function (rowNode, sortOptions) {
	        var sortedRowNodes = rowNode.childrenAfterFilter
	            .map(this.mapNodeToSortedNode.bind(this));
	        sortedRowNodes.sort(this.compareRowNodes.bind(this, sortOptions));
	        return sortedRowNodes;
	    };
	    SortService.prototype.mapNodeToSortedNode = function (rowNode, pos) {
	        return { currentPos: pos, rowNode: rowNode };
	    };
	    SortService.prototype.doDeltaSort = function (rowNode, sortOptions, dirtyLeafNodes, changedPath, noAggregations) {
	        // clean nodes will be a list of all row nodes that remain in the set
	        // and ordered. we start with the old sorted set and take out any nodes
	        // that were removed or changed (but not added, added doesn't make sense,
	        // if a node was added, there is no way it could be here from last time).
	        var cleanNodes = rowNode.childrenAfterSort
	            .filter(function (rowNode) {
	            // take out all nodes that were changed as part of the current transaction.
	            // a changed node could a) be in a different sort position or b) may
	            // no longer be in this set as the changed node may not pass filtering,
	            // or be in a different group.
	            var passesDirtyNodesCheck = !dirtyLeafNodes[rowNode.id];
	            // also remove group nodes in the changed path, as they can have different aggregate
	            // values which could impact the sort order.
	            // note: changed path is not active if a) no value columns or b) no transactions. it is never
	            // (b) in deltaSort as we only do deltaSort for transactions. for (a) if no value columns, then
	            // there is no value in the group that could of changed (ie no aggregate values)
	            var passesChangedPathCheck = noAggregations || changedPath.canSkip(rowNode);
	            return passesDirtyNodesCheck && passesChangedPathCheck;
	        })
	            .map(this.mapNodeToSortedNode.bind(this));
	        // for fast access below, we map them
	        var cleanNodesMapped = {};
	        cleanNodes.forEach(function (sortedRowNode) { return cleanNodesMapped[sortedRowNode.rowNode.id] = sortedRowNode.rowNode; });
	        // these are all nodes that need to be placed
	        var changedNodes = rowNode.childrenAfterFilter
	            // ignore nodes in the clean list
	            .filter(function (rowNode) { return !cleanNodesMapped[rowNode.id]; })
	            .map(this.mapNodeToSortedNode.bind(this));
	        // sort changed nodes. note that we don't need to sort cleanNodes as they are
	        // already sorted from last time.
	        changedNodes.sort(this.compareRowNodes.bind(this, sortOptions));
	        if (changedNodes.length === 0) {
	            return cleanNodes;
	        }
	        else if (cleanNodes.length === 0) {
	            return changedNodes;
	        }
	        else {
	            return this.mergeSortedArrays(sortOptions, cleanNodes, changedNodes);
	        }
	    };
	    // Merge two sorted arrays into each other
	    SortService.prototype.mergeSortedArrays = function (sortOptions, arr1, arr2) {
	        var res = [];
	        var i = 0;
	        var j = 0;
	        // Traverse both array, adding them in order
	        while (i < arr1.length && j < arr2.length) {
	            // Check if current element of first
	            // array is smaller than current element
	            // of second array. If yes, store first
	            // array element and increment first array
	            // index. Otherwise do same with second array
	            var compareResult = this.compareRowNodes(sortOptions, arr1[i], arr2[j]);
	            if (compareResult < 0) {
	                res.push(arr1[i++]);
	            }
	            else {
	                res.push(arr2[j++]);
	            }
	        }
	        // add remaining from arr1
	        while (i < arr1.length) {
	            res.push(arr1[i++]);
	        }
	        // add remaining from arr2
	        while (j < arr2.length) {
	            res.push(arr2[j++]);
	        }
	        return res;
	    };
	    SortService.prototype.compareRowNodes = function (sortOptions, sortedNodeA, sortedNodeB) {
	        var nodeA = sortedNodeA.rowNode;
	        var nodeB = sortedNodeB.rowNode;
	        // Iterate columns, return the first that doesn't match
	        for (var i = 0, len = sortOptions.length; i < len; i++) {
	            var sortOption = sortOptions[i];
	            // let compared = compare(nodeA, nodeB, sortOption.column, sortOption.inverter === -1);
	            var isInverted = sortOption.inverter === -1;
	            var valueA = this.getValue(nodeA, sortOption.column);
	            var valueB = this.getValue(nodeB, sortOption.column);
	            var comparatorResult = void 0;
	            if (sortOption.column.getColDef().comparator) {
	                //if comparator provided, use it
	                comparatorResult = sortOption.column.getColDef().comparator(valueA, valueB, nodeA, nodeB, isInverted);
	            }
	            else {
	                //otherwise do our own comparison
	                comparatorResult = utils_1._.defaultComparator(valueA, valueB, this.gridOptionsWrapper.isAccentedSort());
	            }
	            if (comparatorResult !== 0) {
	                return comparatorResult * sortOption.inverter;
	            }
	        }
	        // All matched, we make is so that the original sort order is kept:
	        return sortedNodeA.currentPos - sortedNodeB.currentPos;
	    };
	    SortService.prototype.getValue = function (nodeA, column) {
	        return this.valueService.getValue(column, nodeA);
	    };
	    SortService.prototype.updateChildIndexes = function (rowNode) {
	        if (utils_1._.missing(rowNode.childrenAfterSort)) {
	            return;
	        }
	        var listToSort = rowNode.childrenAfterSort;
	        for (var i = 0; i < listToSort.length; i++) {
	            var child = listToSort[i];
	            var firstChild = i === 0;
	            var lastChild = i === rowNode.childrenAfterSort.length - 1;
	            child.setFirstChild(firstChild);
	            child.setLastChild(lastChild);
	            child.setChildIndex(i);
	        }
	    };
	    SortService.prototype.updateGroupDataForHiddenOpenParents = function (changedPath) {
	        var _this = this;
	        if (!this.gridOptionsWrapper.isGroupHideOpenParents()) {
	            return;
	        }
	        // recurse breadth first over group nodes after sort to 'pull down' group data to child groups
	        var callback = function (rowNode) {
	            _this.pullDownGroupDataForHideOpenParents(rowNode.childrenAfterSort, false);
	            rowNode.childrenAfterSort.forEach(function (child) {
	                if (child.hasChildren()) {
	                    callback(child);
	                }
	            });
	        };
	        changedPath.executeFromRootNode(function (rowNode) { return callback(rowNode); });
	    };
	    SortService.prototype.pullDownGroupDataForHideOpenParents = function (rowNodes, clearOperation) {
	        var _this = this;
	        if (utils_1._.missing(rowNodes)) {
	            return;
	        }
	        if (!this.gridOptionsWrapper.isGroupHideOpenParents()) {
	            return;
	        }
	        rowNodes.forEach(function (childRowNode) {
	            var groupDisplayCols = _this.columnController.getGroupDisplayColumns();
	            groupDisplayCols.forEach(function (groupDisplayCol) {
	                var showRowGroup = groupDisplayCol.getColDef().showRowGroup;
	                if (typeof showRowGroup !== 'string') {
	                    console.error('ag-Grid: groupHideOpenParents only works when specifying specific columns for colDef.showRowGroup');
	                    return;
	                }
	                var displayingGroupKey = showRowGroup;
	                var rowGroupColumn = _this.columnController.getPrimaryColumn(displayingGroupKey);
	                var thisRowNodeMatches = rowGroupColumn === childRowNode.rowGroupColumn;
	                if (thisRowNodeMatches) {
	                    return;
	                }
	                if (clearOperation) {
	                    // if doing a clear operation, we clear down the value for every possible group column
	                    childRowNode.setGroupValue(groupDisplayCol.getId(), null);
	                }
	                else {
	                    // if doing a set operation, we set only where the pull down is to occur
	                    var parentToStealFrom = childRowNode.getFirstChildOfFirstChild(rowGroupColumn);
	                    if (parentToStealFrom) {
	                        childRowNode.setGroupValue(groupDisplayCol.getId(), parentToStealFrom.key);
	                    }
	                }
	            });
	        });
	    };
	    __decorate([
	        context_1.Autowired('sortController'),
	        __metadata("design:type", sortController_1.SortController)
	    ], SortService.prototype, "sortController", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], SortService.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('valueService'),
	        __metadata("design:type", valueService_1.ValueService)
	    ], SortService.prototype, "valueService", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], SortService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], SortService.prototype, "init", null);
	    SortService = __decorate([
	        context_1.Bean('sortService')
	    ], SortService);
	    return SortService;
	}());
	exports.SortService = SortService;


/***/ },
/* 676 */
/***/ function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** The base frameworks, eg React & Angular 2, override this bean with implementations specific to their requirement. */
	var VanillaFrameworkOverrides = /** @class */ (function () {
	    function VanillaFrameworkOverrides() {
	    }
	    // for Vanilla JS, we use simple timeout
	    VanillaFrameworkOverrides.prototype.setTimeout = function (action, timeout) {
	        window.setTimeout(action, timeout);
	    };
	    // for Vanilla JS, we just add the event to the element
	    VanillaFrameworkOverrides.prototype.addEventListenerOutsideAngular = function (element, type, listener, useCapture) {
	        element.addEventListener(type, listener, useCapture);
	    };
	    return VanillaFrameworkOverrides;
	}());
	exports.VanillaFrameworkOverrides = VanillaFrameworkOverrides;


/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var agAbstractLabel_1 = __webpack_require__(446);
	var componentAnnotations_1 = __webpack_require__(39);
	var context_1 = __webpack_require__(8);
	var dragService_1 = __webpack_require__(158);
	var agInputNumberField_1 = __webpack_require__(327);
	var agAbstractField_1 = __webpack_require__(162);
	var utils_1 = __webpack_require__(10);
	var AgAngleSelect = /** @class */ (function (_super) {
	    __extends(AgAngleSelect, _super);
	    function AgAngleSelect() {
	        var _this = _super.call(this, AgAngleSelect.TEMPLATE) || this;
	        _this.radius = 0;
	        _this.offsetX = 0;
	        _this.offsetY = 0;
	        return _this;
	    }
	    AgAngleSelect.prototype.postConstruct = function () {
	        var _this = this;
	        _super.prototype.postConstruct.call(this);
	        this.dragListener = {
	            eElement: this.eParentCircle,
	            dragStartPixels: 0,
	            onDragStart: function (e) {
	                _this.parentCircleRect = _this.eParentCircle.getBoundingClientRect();
	            },
	            onDragging: function (e) { return _this.calculateAngleDrag(e); },
	            onDragStop: function () { }
	        };
	        this.dragService.addDragSource(this.dragListener);
	        this.eAngleValue
	            .setLabel('')
	            .setLabelWidth(5)
	            .setInputWidth(45)
	            .setMin(0)
	            .setMax(360)
	            .setValue("" + this.degrees)
	            .onValueChange(function (value) {
	            if (value == null || value === '') {
	                value = '0';
	            }
	            value = _this.eAngleValue.normalizeValue(value);
	            var floatValue = parseFloat(value);
	            if (floatValue > 180) {
	                floatValue = floatValue - 360;
	            }
	            _this.setValue(floatValue);
	        });
	        this.updateNumberInput();
	        if (utils_1._.exists(this.getValue())) {
	            this.eAngleValue.setValue(this.normalizeNegativeValue(this.getValue()).toString());
	        }
	        this.addDestroyableEventListener(this, agAbstractField_1.AgAbstractField.EVENT_CHANGED, function () {
	            if (_this.eAngleValue.getInputElement().contains(document.activeElement)) {
	                return;
	            }
	            _this.updateNumberInput();
	        });
	    };
	    AgAngleSelect.prototype.updateNumberInput = function () {
	        var normalizedValue = this.normalizeNegativeValue(this.getValue());
	        this.eAngleValue.setValue(normalizedValue.toString());
	    };
	    AgAngleSelect.prototype.positionChildCircle = function (radians) {
	        var rect = this.parentCircleRect || { width: 24, height: 24 };
	        var eChildCircle = this.eChildCircle;
	        var centerX = rect.width / 2;
	        var centerY = rect.height / 2;
	        eChildCircle.style.left = centerX + Math.cos(radians) * 8 + "px";
	        eChildCircle.style.top = centerY + Math.sin(radians) * 8 + "px";
	    };
	    AgAngleSelect.prototype.calculatePolar = function () {
	        var x = this.offsetX;
	        var y = this.offsetY;
	        var radians = Math.atan2(y, x);
	        this.degrees = this.toDegrees(radians);
	        this.radius = Math.sqrt((x * x) + (y * y));
	        this.positionChildCircle(radians);
	    };
	    AgAngleSelect.prototype.calculateCartesian = function () {
	        var radians = this.toRadians(this.getValue());
	        var radius = this.getRadius();
	        this
	            .setOffsetX(Math.cos(radians) * radius)
	            .setOffsetY(Math.sin(radians) * radius);
	    };
	    AgAngleSelect.prototype.setOffsetX = function (offset) {
	        if (this.offsetX !== offset) {
	            this.offsetX = offset;
	            this.calculatePolar();
	        }
	        return this;
	    };
	    AgAngleSelect.prototype.setOffsetY = function (offset) {
	        if (this.offsetY !== offset) {
	            this.offsetY = offset;
	            this.calculatePolar();
	        }
	        return this;
	    };
	    AgAngleSelect.prototype.calculateAngleDrag = function (e) {
	        var rect = this.parentCircleRect;
	        var centerX = rect.width / 2;
	        var centerY = rect.height / 2;
	        var x = e.clientX - rect.left;
	        var y = e.clientY - rect.top;
	        var dx = x - centerX;
	        var dy = y - centerY;
	        var radians = Math.atan2(dy, dx);
	        this.setValue(radians, true);
	    };
	    AgAngleSelect.prototype.toDegrees = function (radians) {
	        return radians / Math.PI * 180;
	    };
	    AgAngleSelect.prototype.toRadians = function (degrees) {
	        return degrees / 180 * Math.PI;
	    };
	    AgAngleSelect.prototype.normalizeNegativeValue = function (degrees) {
	        return degrees < 0 ? 360 + degrees : degrees;
	    };
	    AgAngleSelect.prototype.normalizeAngle180 = function (radians) {
	        radians %= Math.PI * 2;
	        if (radians < -Math.PI) {
	            radians += Math.PI * 2;
	        }
	        else if (radians >= Math.PI) {
	            radians -= Math.PI * 2;
	        }
	        return radians;
	    };
	    AgAngleSelect.prototype.getRadius = function () {
	        return this.radius;
	    };
	    AgAngleSelect.prototype.setRadius = function (r) {
	        if (this.radius === r) {
	            return this;
	        }
	        this.radius = r;
	        this.calculateCartesian();
	        return this;
	    };
	    AgAngleSelect.prototype.onValueChange = function (callbackFn) {
	        var _this = this;
	        this.addDestroyableEventListener(this, agAbstractField_1.AgAbstractField.EVENT_CHANGED, function () {
	            callbackFn(_this.degrees);
	        });
	        return this;
	    };
	    AgAngleSelect.prototype.getValue = function (radians) {
	        return radians ? this.toRadians(this.degrees) : this.degrees;
	    };
	    AgAngleSelect.prototype.setValue = function (degrees, radians) {
	        var radiansValue;
	        if (!radians) {
	            radiansValue = this.normalizeAngle180(this.toRadians(degrees));
	        }
	        else {
	            radiansValue = degrees;
	        }
	        degrees = this.toDegrees(radiansValue);
	        if (this.degrees !== degrees) {
	            this.degrees = Math.floor(degrees);
	            this.calculateCartesian();
	            this.positionChildCircle(radiansValue);
	            this.dispatchEvent({ type: agAbstractField_1.AgAbstractField.EVENT_CHANGED });
	        }
	        return this;
	    };
	    AgAngleSelect.prototype.setWidth = function (width) {
	        utils_1._.setFixedWidth(this.getGui(), width);
	        return this;
	    };
	    AgAngleSelect.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        this.dragService.removeDragSource(this.dragListener);
	    };
	    AgAngleSelect.TEMPLATE = "<div class=\"ag-angle-select\">\n            <label ref=\"eLabel\"></label>\n            <div class=\"ag-wrapper\">\n                <div ref=\"eAngleSelectField\" class=\"ag-angle-select-field\">\n                    <div ref=\"eParentCircle\" class=\"ag-parent-circle\">\n                        <div ref=\"eChildCircle\" class=\"ag-child-circle\"></div>\n                    </div>\n                </div>\n                <ag-input-number-field ref=\"eAngleValue\"></ag-input-number-field>\n            </div>\n        </div>";
	    __decorate([
	        componentAnnotations_1.RefSelector('eLabel'),
	        __metadata("design:type", HTMLElement)
	    ], AgAngleSelect.prototype, "eLabel", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eParentCircle'),
	        __metadata("design:type", HTMLElement)
	    ], AgAngleSelect.prototype, "eParentCircle", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eChildCircle'),
	        __metadata("design:type", HTMLElement)
	    ], AgAngleSelect.prototype, "eChildCircle", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eAngleValue'),
	        __metadata("design:type", agInputNumberField_1.AgInputNumberField)
	    ], AgAngleSelect.prototype, "eAngleValue", void 0);
	    __decorate([
	        context_1.Autowired("dragService"),
	        __metadata("design:type", dragService_1.DragService)
	    ], AgAngleSelect.prototype, "dragService", void 0);
	    return AgAngleSelect;
	}(agAbstractLabel_1.AgAbstractLabel));
	exports.AgAngleSelect = AgAngleSelect;


/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var agColorPanel_1 = __webpack_require__(1415);
	var agDialog_1 = __webpack_require__(326);
	var agPickerField_1 = __webpack_require__(1416);
	var agAbstractField_1 = __webpack_require__(162);
	var utils_1 = __webpack_require__(10);
	var AgColorPicker = /** @class */ (function (_super) {
	    __extends(AgColorPicker, _super);
	    function AgColorPicker(config) {
	        var _this = _super.call(this) || this;
	        _this.displayTag = 'div';
	        _this.className = 'ag-color-picker';
	        _this.pickerIcon = 'colorPicker';
	        _this.setTemplate(_this.TEMPLATE.replace(/%displayField%/g, _this.displayTag));
	        if (config && config.color) {
	            _this.value = config.color;
	        }
	        return _this;
	    }
	    AgColorPicker.prototype.postConstruct = function () {
	        var _this = this;
	        _super.prototype.postConstruct.call(this);
	        utils_1._.addCssClass(this.getGui(), this.className);
	        this.addDestroyableEventListener(this.eDisplayField, 'click', function () { return _this.showPicker(); });
	        if (this.value) {
	            this.setValue(this.value);
	        }
	    };
	    AgColorPicker.prototype.showPicker = function () {
	        var _this = this;
	        if (this.displayedPicker) {
	            this.displayedPicker = false;
	            return;
	        }
	        var eGuiRect = this.getGui().getBoundingClientRect();
	        var colorDialog = new agDialog_1.AgDialog({
	            closable: false,
	            modal: true,
	            hideTitleBar: true,
	            minWidth: 190,
	            width: 190,
	            height: 250,
	            x: eGuiRect.right - 190,
	            y: eGuiRect.top - 250
	        });
	        this.getContext().wireBean(colorDialog);
	        utils_1._.addCssClass(colorDialog.getGui(), 'ag-color-dialog');
	        var colorPanel = new agColorPanel_1.AgColorPanel({
	            picker: this
	        });
	        this.getContext().wireBean(colorPanel);
	        colorPanel.addDestroyFunc(function () {
	            if (colorDialog.isAlive()) {
	                colorDialog.destroy();
	            }
	        });
	        colorDialog.setParentComponent(this);
	        colorDialog.setBodyComponent(colorPanel);
	        colorPanel.setValue(this.getValue());
	        colorDialog.addDestroyFunc(function () {
	            var wasDestroying = _this.isDestroyingPicker;
	            _this.displayedPicker = false;
	            // here we check if the picker was already being
	            // destroyed to avoid a stackoverflow
	            if (!wasDestroying) {
	                _this.isDestroyingPicker = true;
	                if (colorPanel.isAlive()) {
	                    colorPanel.destroy();
	                }
	            }
	            else {
	                _this.isDestroyingPicker = false;
	            }
	        });
	    };
	    AgColorPicker.prototype.setValue = function (color) {
	        if (this.value === color) {
	            return this;
	        }
	        this.value = color;
	        this.eDisplayField.style.backgroundColor = color;
	        this.dispatchEvent({ type: agAbstractField_1.AgAbstractField.EVENT_CHANGED });
	        return this;
	    };
	    AgColorPicker.prototype.getValue = function () {
	        return this.value;
	    };
	    return AgColorPicker;
	}(agPickerField_1.AgPickerField));
	exports.AgColorPicker = AgColorPicker;


/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(31);
	var componentAnnotations_1 = __webpack_require__(39);
	var context_1 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var agCheckbox_1 = __webpack_require__(199);
	var utils_1 = __webpack_require__(10);
	var AgGroupComponent = /** @class */ (function (_super) {
	    __extends(AgGroupComponent, _super);
	    function AgGroupComponent(params) {
	        var _this = _super.call(this, AgGroupComponent.TEMPLATE) || this;
	        _this.suppressEnabledCheckbox = true;
	        _this.suppressOpenCloseIcons = false;
	        if (!params) {
	            params = {};
	        }
	        var title = params.title, enabled = params.enabled, items = params.items, suppressEnabledCheckbox = params.suppressEnabledCheckbox, suppressOpenCloseIcons = params.suppressOpenCloseIcons;
	        _this.title = title;
	        _this.enabled = enabled != null ? enabled : true;
	        _this.items = items || [];
	        if (suppressEnabledCheckbox != null) {
	            _this.suppressEnabledCheckbox = suppressEnabledCheckbox;
	        }
	        if (suppressOpenCloseIcons != null) {
	            _this.suppressOpenCloseIcons = suppressOpenCloseIcons;
	        }
	        return _this;
	    }
	    AgGroupComponent.prototype.postConstruct = function () {
	        if (this.items.length) {
	            var initialItems = this.items;
	            this.items = [];
	            this.addItems(initialItems);
	        }
	        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
	        this.cbGroupEnabled.setLabel(localeTextFunc('enabled', 'Enabled'));
	        if (this.title) {
	            this.setTitle(this.title);
	        }
	        if (this.enabled) {
	            this.setEnabled(this.enabled);
	        }
	        this.hideEnabledCheckbox(this.suppressEnabledCheckbox);
	        this.hideOpenCloseIcons(this.suppressOpenCloseIcons);
	        this.setupExpandContract();
	    };
	    AgGroupComponent.prototype.setupExpandContract = function () {
	        var _this = this;
	        this.eGroupClosedIcon.appendChild(utils_1._.createIcon('columnSelectClosed', this.gridOptionsWrapper, null));
	        this.eGroupOpenedIcon.appendChild(utils_1._.createIcon('columnSelectOpen', this.gridOptionsWrapper, null));
	        this.setOpenClosedIcons();
	        this.addDestroyableEventListener(this.groupTitle, 'click', function () { return _this.toggleGroupExpand(); });
	    };
	    AgGroupComponent.prototype.setOpenClosedIcons = function () {
	        var folderOpen = this.expanded;
	        utils_1._.setDisplayed(this.eGroupClosedIcon, !folderOpen);
	        utils_1._.setDisplayed(this.eGroupOpenedIcon, folderOpen);
	    };
	    AgGroupComponent.prototype.isExpanded = function () {
	        return this.expanded;
	    };
	    AgGroupComponent.prototype.toggleGroupExpand = function (expanded) {
	        var eGui = this.getGui();
	        if (this.suppressOpenCloseIcons) {
	            this.expanded = true;
	            utils_1._.removeCssClass(eGui, 'ag-collapsed');
	            return this;
	        }
	        expanded = expanded != null ? expanded : !this.expanded;
	        if (this.expanded === expanded) {
	            return this;
	        }
	        this.expanded = expanded;
	        this.setOpenClosedIcons();
	        utils_1._.addOrRemoveCssClass(eGui, 'ag-collapsed', !expanded);
	        if (this.expanded) {
	            var event_1 = {
	                type: 'expanded',
	            };
	            this.dispatchEvent(event_1);
	        }
	        return this;
	    };
	    AgGroupComponent.prototype.addItems = function (items) {
	        var _this = this;
	        items.forEach(function (item) { return _this.addItem(item); });
	    };
	    AgGroupComponent.prototype.addItem = function (item) {
	        var container = this.groupContainer;
	        var el = item instanceof component_1.Component ? item.getGui() : item;
	        utils_1._.addCssClass(el, 'ag-group-item');
	        container.appendChild(el);
	        this.items.push(el);
	    };
	    AgGroupComponent.prototype.setTitle = function (title) {
	        this.lbGroupTitle.innerText = title;
	        return this;
	    };
	    AgGroupComponent.prototype.setEnabled = function (enabled, skipToggle) {
	        this.enabled = enabled;
	        utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-disabled', !enabled);
	        this.toggleGroupExpand(enabled);
	        if (!skipToggle) {
	            this.cbGroupEnabled.setValue(enabled);
	        }
	        return this;
	    };
	    AgGroupComponent.prototype.isEnabled = function () {
	        return this.enabled;
	    };
	    AgGroupComponent.prototype.onEnableChange = function (callbackFn) {
	        var _this = this;
	        this.cbGroupEnabled.onValueChange(function (newSelection) {
	            _this.setEnabled(newSelection, true);
	            callbackFn(newSelection);
	        });
	        return this;
	    };
	    AgGroupComponent.prototype.hideEnabledCheckbox = function (hide) {
	        utils_1._.addOrRemoveCssClass(this.eToolbar, 'ag-hidden', hide);
	        return this;
	    };
	    AgGroupComponent.prototype.hideOpenCloseIcons = function (hide) {
	        this.suppressOpenCloseIcons = hide;
	        utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-collapsible', !hide);
	        if (hide) {
	            this.toggleGroupExpand(true);
	        }
	        return this;
	    };
	    AgGroupComponent.TEMPLATE = "<div class=\"ag-group-component\">\n            <div class=\"ag-group-component-title-bar\" ref=\"groupTitle\">\n                 <span class=\"ag-column-group-icons\">\n                    <span class=\"ag-column-group-closed-icon\" ref=\"eGroupOpenedIcon\"></span>\n                    <span class=\"ag-column-group-opened-icon\" ref=\"eGroupClosedIcon\"></span>\n                </span>\n                <span ref=\"lbGroupTitle\" class=\"ag-group-component-title\"></span>\n            </div>\n            <div ref=\"eToolbar\" class=\"ag-group-component-toolbar\">\n                <ag-checkbox ref=\"cbGroupEnabled\"></ag-checkbox>\n            </div>\n            <div ref=\"eContainer\" class=\"ag-group-component-container\"></div>\n        </div>";
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], AgGroupComponent.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('groupTitle'),
	        __metadata("design:type", HTMLElement)
	    ], AgGroupComponent.prototype, "groupTitle", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eGroupOpenedIcon'),
	        __metadata("design:type", HTMLElement)
	    ], AgGroupComponent.prototype, "eGroupOpenedIcon", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eGroupClosedIcon'),
	        __metadata("design:type", HTMLElement)
	    ], AgGroupComponent.prototype, "eGroupClosedIcon", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eToolbar'),
	        __metadata("design:type", HTMLElement)
	    ], AgGroupComponent.prototype, "eToolbar", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('cbGroupEnabled'),
	        __metadata("design:type", agCheckbox_1.AgCheckbox)
	    ], AgGroupComponent.prototype, "cbGroupEnabled", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector("lbGroupTitle"),
	        __metadata("design:type", HTMLElement)
	    ], AgGroupComponent.prototype, "lbGroupTitle", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector("eContainer"),
	        __metadata("design:type", HTMLElement)
	    ], AgGroupComponent.prototype, "groupContainer", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], AgGroupComponent.prototype, "postConstruct", null);
	    return AgGroupComponent;
	}(component_1.Component));
	exports.AgGroupComponent = AgGroupComponent;


/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var agAbstractInputField_1 = __webpack_require__(254);
	var AgInputTextArea = /** @class */ (function (_super) {
	    __extends(AgInputTextArea, _super);
	    function AgInputTextArea(config) {
	        var _this = _super.call(this) || this;
	        _this.className = 'ag-text-area';
	        _this.displayTag = 'textarea';
	        _this.inputType = '';
	        _this.setTemplate(_this.TEMPLATE.replace(/%displayField%/g, _this.displayTag));
	        if (config) {
	            _this.config = config;
	        }
	        return _this;
	    }
	    AgInputTextArea.prototype.setValue = function (value, silent) {
	        var ret = _super.prototype.setValue.call(this, value, silent);
	        this.eInput.value = value;
	        return ret;
	    };
	    return AgInputTextArea;
	}(agAbstractInputField_1.AgAbstractInputField));
	exports.AgInputTextArea = AgInputTextArea;


/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var agAbstractInputField_1 = __webpack_require__(254);
	var AgSelect = /** @class */ (function (_super) {
	    __extends(AgSelect, _super);
	    function AgSelect() {
	        var _this = _super.call(this) || this;
	        _this.className = 'ag-select';
	        _this.displayTag = 'select';
	        _this.inputType = '';
	        _this.setTemplate(_this.TEMPLATE.replace(/%displayField%/g, _this.displayTag));
	        return _this;
	    }
	    AgSelect.prototype.addOptions = function (options) {
	        var _this = this;
	        options.forEach(function (option) { return _this.addOption(option); });
	        return this;
	    };
	    AgSelect.prototype.addOption = function (option) {
	        var optionEl = document.createElement('option');
	        optionEl.value = option.value;
	        optionEl.text = option.text || option.value;
	        this.eInput.appendChild(optionEl);
	        return this;
	    };
	    AgSelect.prototype.setValue = function (value, silent) {
	        var ret = _super.prototype.setValue.call(this, value, silent);
	        this.eInput.value = value;
	        return ret;
	    };
	    return AgSelect;
	}(agAbstractInputField_1.AgAbstractInputField));
	exports.AgSelect = AgSelect;


/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var componentAnnotations_1 = __webpack_require__(39);
	var agInputRange_1 = __webpack_require__(447);
	var agAbstractLabel_1 = __webpack_require__(446);
	var agInputNumberField_1 = __webpack_require__(327);
	var agAbstractField_1 = __webpack_require__(162);
	var AgSlider = /** @class */ (function (_super) {
	    __extends(AgSlider, _super);
	    function AgSlider() {
	        var _this = _super.call(this, AgSlider.TEMPLATE) || this;
	        _this.labelAlignment = 'top';
	        return _this;
	    }
	    AgSlider.prototype.postConstruct = function () {
	        _super.prototype.postConstruct.call(this);
	        this.setMinValue(0);
	    };
	    AgSlider.prototype.onValueChange = function (callbackFn) {
	        var _this = this;
	        var eventChanged = agAbstractField_1.AgAbstractField.EVENT_CHANGED;
	        this.addDestroyableEventListener(this.eText, eventChanged, function () {
	            var textValue = parseFloat(_this.eText.getValue());
	            _this.eSlider.setValue(textValue.toString(), true);
	            callbackFn(textValue || 0);
	        });
	        this.addDestroyableEventListener(this.eSlider, eventChanged, function () {
	            var sliderValue = _this.eSlider.getValue();
	            _this.eText.setValue(sliderValue, true);
	            callbackFn(parseFloat(sliderValue));
	        });
	        return this;
	    };
	    AgSlider.prototype.setSliderWidth = function (width) {
	        this.eSlider.setWidth(width);
	        return this;
	    };
	    AgSlider.prototype.setTextFieldWidth = function (width) {
	        this.eText.setWidth(width);
	        return this;
	    };
	    AgSlider.prototype.setMinValue = function (minValue) {
	        this.eSlider.setMinValue(minValue);
	        this.eText.setMin(minValue);
	        return this;
	    };
	    AgSlider.prototype.setMaxValue = function (maxValue) {
	        this.eSlider.setMaxValue(maxValue);
	        this.eText.setMax(maxValue);
	        return this;
	    };
	    AgSlider.prototype.getValue = function () {
	        return this.eText.getValue();
	    };
	    AgSlider.prototype.setValue = function (value) {
	        if (this.getValue() === value) {
	            return this;
	        }
	        this.eText.setValue(value, true);
	        this.eSlider.setValue(value, true);
	        this.dispatchEvent({ type: agAbstractField_1.AgAbstractField.EVENT_CHANGED });
	        return this;
	    };
	    AgSlider.prototype.setStep = function (step) {
	        this.eSlider.setStep(step);
	        this.eText.setStep(step);
	        return this;
	    };
	    AgSlider.TEMPLATE = "<div class=\"ag-slider\">\n            <label ref=\"eLabel\"></label>\n            <div class=\"ag-wrapper\">\n                <ag-input-range ref=\"eSlider\"></ag-input-range>\n                <ag-input-number-field ref=\"eText\"></ag-input-number-field>\n            </div>\n        </div>";
	    __decorate([
	        componentAnnotations_1.RefSelector('eLabel'),
	        __metadata("design:type", HTMLElement)
	    ], AgSlider.prototype, "eLabel", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eSlider'),
	        __metadata("design:type", agInputRange_1.AgInputRange)
	    ], AgSlider.prototype, "eSlider", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eText'),
	        __metadata("design:type", agInputNumberField_1.AgInputNumberField)
	    ], AgSlider.prototype, "eText", void 0);
	    return AgSlider;
	}(agAbstractLabel_1.AgAbstractLabel));
	exports.AgSlider = AgSlider;


/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var agRadioButton_1 = __webpack_require__(450);
	var utils_1 = __webpack_require__(10);
	var AgToggleButton = /** @class */ (function (_super) {
	    __extends(AgToggleButton, _super);
	    function AgToggleButton() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.className = 'ag-toggle-button';
	        return _this;
	    }
	    AgToggleButton.prototype.postConstruct = function () {
	        _super.prototype.postConstruct.call(this);
	        utils_1._.addCssClass(this.eIconEl, 'ag-icon');
	    };
	    AgToggleButton.prototype.updateIcons = function () {
	        var value = this.getValue();
	        utils_1._.addOrRemoveCssClass(this.eIconEl, 'ag-icon-toggle-on', value);
	        utils_1._.addOrRemoveCssClass(this.eIconEl, 'ag-icon-toggle-off', !value);
	    };
	    AgToggleButton.prototype.setValue = function (value, silent) {
	        _super.prototype.setValue.call(this, value, silent);
	        utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-selected', this.getValue());
	        return this;
	    };
	    return AgToggleButton;
	}(agRadioButton_1.AgRadioButton));
	exports.AgToggleButton = AgToggleButton;


/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	// ag-grid-react v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(2);
	var react_1 = __webpack_require__(2);
	var PropTypes = __webpack_require__(4);
	var AgGrid = __webpack_require__(163);
	var AgGridColumn = /** @class */ (function (_super) {
	    __extends(AgGridColumn, _super);
	    function AgGridColumn(props, state) {
	        var _this = _super.call(this, props, state) || this;
	        _this.props = props;
	        _this.state = state;
	        return _this;
	    }
	    AgGridColumn.prototype.render = function () {
	        return null;
	    };
	    AgGridColumn.mapChildColumnDefs = function (columnProps) {
	        return React.Children.map(columnProps.children, function (child) {
	            return AgGridColumn.toColDef(child.props);
	        });
	    };
	    AgGridColumn.toColDef = function (columnProps) {
	        var colDef = AgGridColumn.createColDefFromGridColumn(columnProps);
	        if (AgGridColumn.hasChildColumns(columnProps)) {
	            colDef["children"] = AgGridColumn.getChildColDefs(columnProps.children);
	        }
	        return colDef;
	    };
	    AgGridColumn.hasChildColumns = function (columnProps) {
	        return React.Children.count(columnProps.children) > 0;
	    };
	    AgGridColumn.getChildColDefs = function (columnChildren) {
	        return React.Children.map(columnChildren, function (child) {
	            return AgGridColumn.createColDefFromGridColumn(child.props);
	        });
	    };
	    ;
	    AgGridColumn.createColDefFromGridColumn = function (columnProps) {
	        var colDef = {};
	        AgGridColumn.assign(colDef, columnProps);
	        delete colDef.children;
	        return colDef;
	    };
	    ;
	    AgGridColumn.assign = function (colDef, from) {
	        // effectively Object.assign - here for IE compatibility
	        return [from].reduce(function (r, o) {
	            Object.keys(o).forEach(function (k) {
	                r[k] = o[k];
	            });
	            return r;
	        }, colDef);
	    };
	    return AgGridColumn;
	}(react_1.Component));
	exports.AgGridColumn = AgGridColumn;
	addProperties(AgGrid.ColDefUtil.BOOLEAN_PROPERTIES, PropTypes.bool);
	addProperties(AgGrid.ColDefUtil.STRING_PROPERTIES, PropTypes.string);
	addProperties(AgGrid.ColDefUtil.OBJECT_PROPERTIES, PropTypes.object);
	addProperties(AgGrid.ColDefUtil.ARRAY_PROPERTIES, PropTypes.array);
	addProperties(AgGrid.ColDefUtil.NUMBER_PROPERTIES, PropTypes.number);
	addProperties(AgGrid.ColDefUtil.FUNCTION_PROPERTIES, PropTypes.func);
	function addProperties(listOfProps, propType) {
	    listOfProps.forEach(function (propKey) {
	        AgGridColumn[propKey] = propType;
	    });
	}


/***/ },
/* 685 */
/***/ function(module, exports) {

	// ag-grid-react v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var BaseReactComponent = /** @class */ (function () {
	    function BaseReactComponent() {
	    }
	    BaseReactComponent.prototype.hasMethod = function (name) {
	        var frameworkComponentInstance = this.getFrameworkComponentInstance();
	        if (frameworkComponentInstance == null) {
	            return false;
	        }
	        return frameworkComponentInstance[name] != null;
	    };
	    BaseReactComponent.prototype.callMethod = function (name, args) {
	        var _this = this;
	        var frameworkComponentInstance = this.getFrameworkComponentInstance();
	        // this should never happen now that AgGridReact.waitForInstance is in use
	        if (frameworkComponentInstance == null) {
	            window.setTimeout(function () { return _this.callMethod(name, args); }, 100);
	        }
	        else {
	            var method = this.getFrameworkComponentInstance()[name];
	            if (method == null)
	                return;
	            return method.apply(frameworkComponentInstance, args);
	        }
	    };
	    BaseReactComponent.prototype.addMethod = function (name, callback) {
	        this[name] = callback;
	    };
	    return BaseReactComponent;
	}());
	exports.BaseReactComponent = BaseReactComponent;


/***/ },
/* 686 */
/***/ function(module, exports) {

	// ag-grid-react v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// effectively Object.assign - here for IE compatibility
	exports.assignProperties = function (to, from) {
	    var styleKeys = Object.keys(from);
	    styleKeys.forEach(function (key) {
	        to[key] = from[key];
	    });
	};


/***/ },
/* 687 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(32);
	
	// -- Inlined from fbjs --
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function _invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	var warning = function(){};
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	// /-- Inlined from fbjs --
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = dirtyHandlerIds;
	exports.areDirty = areDirty;
	
	var _xor = __webpack_require__(1915);
	
	var _xor2 = _interopRequireDefault(_xor);
	
	var _intersection = __webpack_require__(1892);
	
	var _intersection2 = _interopRequireDefault(_intersection);
	
	var _dragDrop = __webpack_require__(328);
	
	var _registry = __webpack_require__(329);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NONE = [];
	var ALL = [];
	
	function dirtyHandlerIds() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NONE;
		var action = arguments[1];
		var dragOperation = arguments[2];
	
		switch (action.type) {
			case _dragDrop.HOVER:
				break;
			case _registry.ADD_SOURCE:
			case _registry.ADD_TARGET:
			case _registry.REMOVE_TARGET:
			case _registry.REMOVE_SOURCE:
				return NONE;
			case _dragDrop.BEGIN_DRAG:
			case _dragDrop.PUBLISH_DRAG_SOURCE:
			case _dragDrop.END_DRAG:
			case _dragDrop.DROP:
			default:
				return ALL;
		}
	
		var targetIds = action.targetIds;
		var prevTargetIds = dragOperation.targetIds;
	
		var result = (0, _xor2.default)(targetIds, prevTargetIds);
	
		var didChange = false;
		if (result.length === 0) {
			for (var i = 0; i < targetIds.length; i++) {
				if (targetIds[i] !== prevTargetIds[i]) {
					didChange = true;
					break;
				}
			}
		} else {
			didChange = true;
		}
	
		if (!didChange) {
			return NONE;
		}
	
		var prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
		var innermostTargetId = targetIds[targetIds.length - 1];
	
		if (prevInnermostTargetId !== innermostTargetId) {
			if (prevInnermostTargetId) {
				result.push(prevInnermostTargetId);
			}
			if (innermostTargetId) {
				result.push(innermostTargetId);
			}
		}
	
		return result;
	}
	
	function areDirty(state, handlerIds) {
		if (state === NONE) {
			return false;
		}
	
		if (state === ALL || typeof handlerIds === 'undefined') {
			return true;
		}
	
		return (0, _intersection2.default)(handlerIds, state).length > 0;
	}

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = dragOffset;
	exports.getSourceClientOffset = getSourceClientOffset;
	exports.getDifferenceFromInitialOffset = getDifferenceFromInitialOffset;
	
	var _dragDrop = __webpack_require__(328);
	
	var initialState = {
		initialSourceClientOffset: null,
		initialClientOffset: null,
		clientOffset: null
	};
	
	function areOffsetsEqual(offsetA, offsetB) {
		if (offsetA === offsetB) {
			return true;
		}
		return offsetA && offsetB && offsetA.x === offsetB.x && offsetA.y === offsetB.y;
	}
	
	function dragOffset() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
		var action = arguments[1];
	
		switch (action.type) {
			case _dragDrop.BEGIN_DRAG:
				return {
					initialSourceClientOffset: action.sourceClientOffset,
					initialClientOffset: action.clientOffset,
					clientOffset: action.clientOffset
				};
			case _dragDrop.HOVER:
				if (areOffsetsEqual(state.clientOffset, action.clientOffset)) {
					return state;
				}
				return _extends({}, state, {
					clientOffset: action.clientOffset
				});
			case _dragDrop.END_DRAG:
			case _dragDrop.DROP:
				return initialState;
			default:
				return state;
		}
	}
	
	function getSourceClientOffset(state) {
		var clientOffset = state.clientOffset,
		    initialClientOffset = state.initialClientOffset,
		    initialSourceClientOffset = state.initialSourceClientOffset;
	
		if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) {
			return null;
		}
		return {
			x: clientOffset.x + initialSourceClientOffset.x - initialClientOffset.x,
			y: clientOffset.y + initialSourceClientOffset.y - initialClientOffset.y
		};
	}
	
	function getDifferenceFromInitialOffset(state) {
		var clientOffset = state.clientOffset,
		    initialClientOffset = state.initialClientOffset;
	
		if (!clientOffset || !initialClientOffset) {
			return null;
		}
		return {
			x: clientOffset.x - initialClientOffset.x,
			y: clientOffset.y - initialClientOffset.y
		};
	}

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = matchesType;
	
	var _isArray = __webpack_require__(35);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function matchesType(targetType, draggedItemType) {
		if ((0, _isArray2.default)(targetType)) {
			return targetType.some(function (t) {
				return t === draggedItemType;
			});
		} else {
			return targetType === draggedItemType;
		}
	}

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//download.js v4.2, by dandavis; 2008-2016. [MIT] see http://danml.com/download.html for tests/usage
	// v1 landed a FF+Chrome compat way of downloading strings to local un-named files, upgraded to use a hidden frame and optional mime
	// v2 added named files via a[download], msSaveBlob, IE (10+) support, and window.URL support for larger+faster saves than dataURLs
	// v3 added dataURL and Blob Input, bind-toggle arity, and legacy dataURL fallback was improved with force-download mime and base64 support. 3.1 improved safari handling.
	// v4 adds AMD/UMD, commonJS, and plain browser support
	// v4.1 adds url download capability via solo URL argument (same domain/CORS only)
	// v4.2 adds semantic variable names, long (over 2MB) dataURL support, and hidden by default temp anchors
	// https://github.com/rndme/download
	
	(function (root, factory) {
		if (true) {
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports === 'object') {
			// Node. Does not work with strict CommonJS, but
			// only CommonJS-like environments that support module.exports,
			// like Node.
			module.exports = factory();
		} else {
			// Browser globals (root is window)
			root.download = factory();
	  }
	}(this, function () {
	
		return function download(data, strFileName, strMimeType) {
	
			var self = window, // this script is only for browsers anyway...
				defaultMime = "application/octet-stream", // this default mime also triggers iframe downloads
				mimeType = strMimeType || defaultMime,
				payload = data,
				url = !strFileName && !strMimeType && payload,
				anchor = document.createElement("a"),
				toString = function(a){return String(a);},
				myBlob = (self.Blob || self.MozBlob || self.WebKitBlob || toString),
				fileName = strFileName || "download",
				blob,
				reader;
				myBlob= myBlob.call ? myBlob.bind(self) : Blob ;
		  
			if(String(this)==="true"){ //reverse arguments, allowing download.bind(true, "text/xml", "export.xml") to act as a callback
				payload=[payload, mimeType];
				mimeType=payload[0];
				payload=payload[1];
			}
	
	
			if(url && url.length< 2048){ // if no filename and no mime, assume a url was passed as the only argument
				fileName = url.split("/").pop().split("?")[0];
				anchor.href = url; // assign href prop to temp anchor
			  	if(anchor.href.indexOf(url) !== -1){ // if the browser determines that it's a potentially valid url path:
	        		var ajax=new XMLHttpRequest();
	        		ajax.open( "GET", url, true);
	        		ajax.responseType = 'blob';
	        		ajax.onload= function(e){ 
					  download(e.target.response, fileName, defaultMime);
					};
	        		setTimeout(function(){ ajax.send();}, 0); // allows setting custom ajax headers using the return:
				    return ajax;
				} // end if valid url?
			} // end if url?
	
	
			//go ahead and download dataURLs right away
			if(/^data:([\w+-]+\/[\w+.-]+)?[,;]/.test(payload)){
			
				if(payload.length > (1024*1024*1.999) && myBlob !== toString ){
					payload=dataUrlToBlob(payload);
					mimeType=payload.type || defaultMime;
				}else{			
					return navigator.msSaveBlob ?  // IE10 can't do a[download], only Blobs:
						navigator.msSaveBlob(dataUrlToBlob(payload), fileName) :
						saver(payload) ; // everyone else can save dataURLs un-processed
				}
				
			}else{//not data url, is it a string with special needs?
				if(/([\x80-\xff])/.test(payload)){			  
					var i=0, tempUiArr= new Uint8Array(payload.length), mx=tempUiArr.length;
					for(i;i<mx;++i) tempUiArr[i]= payload.charCodeAt(i);
				 	payload=new myBlob([tempUiArr], {type: mimeType});
				}		  
			}
			blob = payload instanceof myBlob ?
				payload :
				new myBlob([payload], {type: mimeType}) ;
	
	
			function dataUrlToBlob(strUrl) {
				var parts= strUrl.split(/[:;,]/),
				type= parts[1],
				decoder= parts[2] == "base64" ? atob : decodeURIComponent,
				binData= decoder( parts.pop() ),
				mx= binData.length,
				i= 0,
				uiArr= new Uint8Array(mx);
	
				for(i;i<mx;++i) uiArr[i]= binData.charCodeAt(i);
	
				return new myBlob([uiArr], {type: type});
			 }
	
			function saver(url, winMode){
	
				if ('download' in anchor) { //html5 A[download]
					anchor.href = url;
					anchor.setAttribute("download", fileName);
					anchor.className = "download-js-link";
					anchor.innerHTML = "downloading...";
					anchor.style.display = "none";
					document.body.appendChild(anchor);
					setTimeout(function() {
						anchor.click();
						document.body.removeChild(anchor);
						if(winMode===true){setTimeout(function(){ self.URL.revokeObjectURL(anchor.href);}, 250 );}
					}, 66);
					return true;
				}
	
				// handle non-a[download] safari as best we can:
				if(/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
					if(/^data:/.test(url))	url="data:"+url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
					if(!window.open(url)){ // popup blocked, offer direct download:
						if(confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")){ location.href=url; }
					}
					return true;
				}
	
				//do iframe dataURL download (old ch+FF):
				var f = document.createElement("iframe");
				document.body.appendChild(f);
	
				if(!winMode && /^data:/.test(url)){ // force a mime that will download:
					url="data:"+url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
				}
				f.src=url;
				setTimeout(function(){ document.body.removeChild(f); }, 333);
	
			}//end saver
	
	
	
	
			if (navigator.msSaveBlob) { // IE10+ : (has Blob, but not a[download] or URL)
				return navigator.msSaveBlob(blob, fileName);
			}
	
			if(self.URL){ // simple fast and modern way using Blob and URL:
				saver(self.URL.createObjectURL(blob), true);
			}else{
				// handle non-Blob()+non-URL browsers:
				if(typeof blob === "string" || blob.constructor===toString ){
					try{
						return saver( "data:" +  mimeType   + ";base64,"  +  self.btoa(blob)  );
					}catch(y){
						return saver( "data:" +  mimeType   + "," + encodeURIComponent(blob)  );
					}
				}
	
				// Blob but not URL support:
				reader=new FileReader();
				reader.onload=function(e){
					saver(this.result);
				};
				reader.readAsDataURL(blob);
			}
			return true;
		}; /* end download() */
	}));


/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var echartsAPIList = ['getDom', 'getZr', 'getWidth', 'getHeight', 'getDevicePixelRatio', 'dispatchAction', 'isDisposed', 'on', 'off', 'getDataURL', 'getConnectedDataURL', 'getModel', 'getOption', 'getViewOfComponentModel', 'getViewOfSeriesModel']; // And `getCoordinateSystems` and `getComponentByElement` will be injected in echarts.js
	
	function ExtensionAPI(chartInstance) {
	  zrUtil.each(echartsAPIList, function (name) {
	    this[name] = zrUtil.bind(chartInstance[name], chartInstance);
	  }, this);
	}
	
	var _default = ExtensionAPI;
	module.exports = _default;

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(seriesType, actionInfos) {
	  zrUtil.each(actionInfos, function (actionInfo) {
	    actionInfo.update = 'updateView';
	    /**
	     * @payload
	     * @property {string} seriesName
	     * @property {string} name
	     */
	
	    echarts.registerAction(actionInfo, function (payload, ecModel) {
	      var selected = {};
	      ecModel.eachComponent({
	        mainType: 'series',
	        subType: seriesType,
	        query: payload
	      }, function (seriesModel) {
	        if (seriesModel[actionInfo.method]) {
	          seriesModel[actionInfo.method](payload.name, payload.dataIndex);
	        }
	
	        var data = seriesModel.getData(); // Create selected map
	
	        data.each(function (idx) {
	          var name = data.getName(idx);
	          selected[name] = seriesModel.isSelected(name) || false;
	        });
	      });
	      return {
	        name: payload.name,
	        selected: selected,
	        seriesId: payload.seriesId
	      };
	    });
	  });
	}
	
	module.exports = _default;

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var _roamHelper = __webpack_require__(453);
	
	var updateCenterAndZoom = _roamHelper.updateCenterAndZoom;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @payload
	 * @property {string} [componentType=series]
	 * @property {number} [dx]
	 * @property {number} [dy]
	 * @property {number} [zoom]
	 * @property {number} [originX]
	 * @property {number} [originY]
	 */
	echarts.registerAction({
	  type: 'geoRoam',
	  event: 'geoRoam',
	  update: 'updateTransform'
	}, function (payload, ecModel) {
	  var componentType = payload.componentType || 'series';
	  ecModel.eachComponent({
	    mainType: componentType,
	    query: payload
	  }, function (componentModel) {
	    var geo = componentModel.coordinateSystem;
	
	    if (geo.type !== 'geo') {
	      return;
	    }
	
	    var res = updateCenterAndZoom(geo, payload, componentModel.get('scaleLimit'));
	    componentModel.setCenter && componentModel.setCenter(res.center);
	    componentModel.setZoom && componentModel.setZoom(res.zoom); // All map series with same `map` use the same geo coordinate system
	    // So the center and zoom must be in sync. Include the series not selected by legend
	
	    if (componentType === 'series') {
	      zrUtil.each(componentModel.seriesGroup, function (seriesModel) {
	        seriesModel.setCenter(res.center);
	        seriesModel.setZoom(res.zoom);
	      });
	    }
	  });
	});

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SeriesModel = __webpack_require__(58);
	
	var createListFromArray = __webpack_require__(122);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.__base_bar__',
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(this.getSource(), this, {
	      useEncodeDefaulter: true
	    });
	  },
	  getMarkerPosition: function (value) {
	    var coordSys = this.coordinateSystem;
	
	    if (coordSys) {
	      // PENDING if clamp ?
	      var pt = coordSys.dataToPoint(coordSys.clampData(value));
	      var data = this.getData();
	      var offset = data.getLayout('offset');
	      var size = data.getLayout('size');
	      var offsetIndex = coordSys.getBaseAxis().isHorizontal() ? 0 : 1;
	      pt[offsetIndex] += offset + size / 2;
	      return pt;
	    }
	
	    return [NaN, NaN];
	  },
	  defaultOption: {
	    zlevel: 0,
	    // 一级层叠
	    z: 2,
	    // 二级层叠
	    coordinateSystem: 'cartesian2d',
	    legendHoverLink: true,
	    // stack: null
	    // Cartesian coordinate system
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // 最小高度改为0
	    barMinHeight: 0,
	    // 最小角度为0，仅对极坐标系下的柱状图有效
	    barMinAngle: 0,
	    // cursor: null,
	    large: false,
	    largeThreshold: 400,
	    progressive: 3e3,
	    progressiveChunkMode: 'mod',
	    // barMaxWidth: null,
	    // In cartesian, the default value is 1. Otherwise null.
	    // barMinWidth: null,
	    // 默认自适应
	    // barWidth: null,
	    // 柱间距离，默认为柱形宽度的30%，可设固定值
	    // barGap: '30%',
	    // 类目间柱形距离，默认为类目间距的20%，可设固定值
	    // barCategoryGap: '20%',
	    // label: {
	    //      show: false
	    // },
	    itemStyle: {},
	    emphasis: {}
	  }
	});
	
	module.exports = _default;

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(16);
	
	var _labelHelper = __webpack_require__(457);
	
	var getDefaultLabel = _labelHelper.getDefaultLabel;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function setLabel(normalStyle, hoverStyle, itemModel, color, seriesModel, dataIndex, labelPositionOutside) {
	  var labelModel = itemModel.getModel('label');
	  var hoverLabelModel = itemModel.getModel('emphasis.label');
	  graphic.setLabelStyle(normalStyle, hoverStyle, labelModel, hoverLabelModel, {
	    labelFetcher: seriesModel,
	    labelDataIndex: dataIndex,
	    defaultText: getDefaultLabel(seriesModel.getData(), dataIndex),
	    isRectText: true,
	    autoColor: color
	  });
	  fixPosition(normalStyle);
	  fixPosition(hoverStyle);
	}
	
	function fixPosition(style, labelPositionOutside) {
	  if (style.textPosition === 'outside') {
	    style.textPosition = labelPositionOutside;
	  }
	}
	
	exports.setLabel = setLabel;

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var vec2 = __webpack_require__(41);
	
	var _graphHelper = __webpack_require__(454);
	
	var getSymbolSize = _graphHelper.getSymbolSize;
	var getNodeGlobalScale = _graphHelper.getNodeGlobalScale;
	
	var zrUtil = __webpack_require__(3);
	
	var _multipleGraphEdgeHelper = __webpack_require__(331);
	
	var getCurvenessForEdge = _multipleGraphEdgeHelper.getCurvenessForEdge;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PI = Math.PI;
	var _symbolRadiansHalf = [];
	/**
	 * `basedOn` can be:
	 * 'value':
	 *     This layout is not accurate and have same bad case. For example,
	 *     if the min value is very smaller than the max value, the nodes
	 *     with the min value probably overlap even though there is enough
	 *     space to layout them. So we only use this approach in the as the
	 *     init layout of the force layout.
	 *     FIXME
	 *     Probably we do not need this method any more but use
	 *     `basedOn: 'symbolSize'` in force layout if
	 *     delay its init operations to GraphView.
	 * 'symbolSize':
	 *     This approach work only if all of the symbol size calculated.
	 *     That is, the progressive rendering is not applied to graph.
	 *     FIXME
	 *     If progressive rendering is applied to graph some day,
	 *     probably we have to use `basedOn: 'value'`.
	 *
	 * @param {module:echarts/src/model/Series} seriesModel
	 * @param {string} basedOn 'value' or 'symbolSize'
	 */
	
	function circularLayout(seriesModel, basedOn) {
	  var coordSys = seriesModel.coordinateSystem;
	
	  if (coordSys && coordSys.type !== 'view') {
	    return;
	  }
	
	  var rect = coordSys.getBoundingRect();
	  var nodeData = seriesModel.getData();
	  var graph = nodeData.graph;
	  var cx = rect.width / 2 + rect.x;
	  var cy = rect.height / 2 + rect.y;
	  var r = Math.min(rect.width, rect.height) / 2;
	  var count = nodeData.count();
	  nodeData.setLayout({
	    cx: cx,
	    cy: cy
	  });
	
	  if (!count) {
	    return;
	  }
	
	  _layoutNodesBasedOn[basedOn](seriesModel, coordSys, graph, nodeData, r, cx, cy, count);
	
	  graph.eachEdge(function (edge, index) {
	    var curveness = zrUtil.retrieve3(edge.getModel().get('lineStyle.curveness'), getCurvenessForEdge(edge, seriesModel, index), 0);
	    var p1 = vec2.clone(edge.node1.getLayout());
	    var p2 = vec2.clone(edge.node2.getLayout());
	    var cp1;
	    var x12 = (p1[0] + p2[0]) / 2;
	    var y12 = (p1[1] + p2[1]) / 2;
	
	    if (+curveness) {
	      curveness *= 3;
	      cp1 = [cx * curveness + x12 * (1 - curveness), cy * curveness + y12 * (1 - curveness)];
	    }
	
	    edge.setLayout([p1, p2, cp1]);
	  });
	}
	
	var _layoutNodesBasedOn = {
	  value: function (seriesModel, coordSys, graph, nodeData, r, cx, cy, count) {
	    var angle = 0;
	    var sum = nodeData.getSum('value');
	    var unitAngle = Math.PI * 2 / (sum || count);
	    graph.eachNode(function (node) {
	      var value = node.getValue('value');
	      var radianHalf = unitAngle * (sum ? value : 1) / 2;
	      angle += radianHalf;
	      node.setLayout([r * Math.cos(angle) + cx, r * Math.sin(angle) + cy]);
	      angle += radianHalf;
	    });
	  },
	  symbolSize: function (seriesModel, coordSys, graph, nodeData, r, cx, cy, count) {
	    var sumRadian = 0;
	    _symbolRadiansHalf.length = count;
	    var nodeScale = getNodeGlobalScale(seriesModel);
	    graph.eachNode(function (node) {
	      var symbolSize = getSymbolSize(node); // Normally this case will not happen, but we still add
	      // some the defensive code (2px is an arbitrary value).
	
	      isNaN(symbolSize) && (symbolSize = 2);
	      symbolSize < 0 && (symbolSize = 0);
	      symbolSize *= nodeScale;
	      var symbolRadianHalf = Math.asin(symbolSize / 2 / r); // when `symbolSize / 2` is bigger than `r`.
	
	      isNaN(symbolRadianHalf) && (symbolRadianHalf = PI / 2);
	      _symbolRadiansHalf[node.dataIndex] = symbolRadianHalf;
	      sumRadian += symbolRadianHalf * 2;
	    });
	    var halfRemainRadian = (2 * PI - sumRadian) / count / 2;
	    var angle = 0;
	    graph.eachNode(function (node) {
	      var radianHalf = halfRemainRadian + _symbolRadiansHalf[node.dataIndex];
	      angle += radianHalf;
	      node.setLayout([r * Math.cos(angle) + cx, r * Math.sin(angle) + cy]);
	      angle += radianHalf;
	    });
	  }
	};
	exports.circularLayout = circularLayout;

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var vec2 = __webpack_require__(41);
	
	var zrUtil = __webpack_require__(3);
	
	var _multipleGraphEdgeHelper = __webpack_require__(331);
	
	var getCurvenessForEdge = _multipleGraphEdgeHelper.getCurvenessForEdge;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function simpleLayout(seriesModel) {
	  var coordSys = seriesModel.coordinateSystem;
	
	  if (coordSys && coordSys.type !== 'view') {
	    return;
	  }
	
	  var graph = seriesModel.getGraph();
	  graph.eachNode(function (node) {
	    var model = node.getModel();
	    node.setLayout([+model.get('x'), +model.get('y')]);
	  });
	  simpleLayoutEdge(graph, seriesModel);
	}
	
	function simpleLayoutEdge(graph, seriesModel) {
	  graph.eachEdge(function (edge, index) {
	    var curveness = zrUtil.retrieve3(edge.getModel().get('lineStyle.curveness'), -getCurvenessForEdge(edge, seriesModel, index, true), 0);
	    var p1 = vec2.clone(edge.node1.getLayout());
	    var p2 = vec2.clone(edge.node2.getLayout());
	    var points = [p1, p2];
	
	    if (+curveness) {
	      points.push([(p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * curveness, (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * curveness]);
	    }
	
	    edge.setLayout(points);
	  });
	}
	
	exports.simpleLayout = simpleLayout;
	exports.simpleLayoutEdge = simpleLayoutEdge;

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(16);
	
	var Line = __webpack_require__(455);
	
	var zrUtil = __webpack_require__(3);
	
	var _symbol = __webpack_require__(84);
	
	var createSymbol = _symbol.createSymbol;
	
	var vec2 = __webpack_require__(41);
	
	var curveUtil = __webpack_require__(152);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Provide effect for line
	 * @module echarts/chart/helper/EffectLine
	 */
	
	/**
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 * @alias {module:echarts/chart/helper/Line}
	 */
	function EffectLine(lineData, idx, seriesScope) {
	  graphic.Group.call(this);
	  this.add(this.createLine(lineData, idx, seriesScope));
	
	  this._updateEffectSymbol(lineData, idx);
	}
	
	var effectLineProto = EffectLine.prototype;
	
	effectLineProto.createLine = function (lineData, idx, seriesScope) {
	  return new Line(lineData, idx, seriesScope);
	};
	
	effectLineProto._updateEffectSymbol = function (lineData, idx) {
	  var itemModel = lineData.getItemModel(idx);
	  var effectModel = itemModel.getModel('effect');
	  var size = effectModel.get('symbolSize');
	  var symbolType = effectModel.get('symbol');
	
	  if (!zrUtil.isArray(size)) {
	    size = [size, size];
	  }
	
	  var color = effectModel.get('color') || lineData.getItemVisual(idx, 'color');
	  var symbol = this.childAt(1);
	
	  if (this._symbolType !== symbolType) {
	    // Remove previous
	    this.remove(symbol);
	    symbol = createSymbol(symbolType, -0.5, -0.5, 1, 1, color);
	    symbol.z2 = 100;
	    symbol.culling = true;
	    this.add(symbol);
	  } // Symbol may be removed if loop is false
	
	
	  if (!symbol) {
	    return;
	  } // Shadow color is same with color in default
	
	
	  symbol.setStyle('shadowColor', color);
	  symbol.setStyle(effectModel.getItemStyle(['color']));
	  symbol.attr('scale', size);
	  symbol.setColor(color);
	  symbol.attr('scale', size);
	  this._symbolType = symbolType;
	  this._symbolScale = size;
	
	  this._updateEffectAnimation(lineData, effectModel, idx);
	};
	
	effectLineProto._updateEffectAnimation = function (lineData, effectModel, idx) {
	  var symbol = this.childAt(1);
	
	  if (!symbol) {
	    return;
	  }
	
	  var self = this;
	  var points = lineData.getItemLayout(idx);
	  var period = effectModel.get('period') * 1000;
	  var loop = effectModel.get('loop');
	  var constantSpeed = effectModel.get('constantSpeed');
	  var delayExpr = zrUtil.retrieve(effectModel.get('delay'), function (idx) {
	    return idx / lineData.count() * period / 3;
	  });
	  var isDelayFunc = typeof delayExpr === 'function'; // Ignore when updating
	
	  symbol.ignore = true;
	  this.updateAnimationPoints(symbol, points);
	
	  if (constantSpeed > 0) {
	    period = this.getLineLength(symbol) / constantSpeed * 1000;
	  }
	
	  if (period !== this._period || loop !== this._loop) {
	    symbol.stopAnimation();
	    var delay = delayExpr;
	
	    if (isDelayFunc) {
	      delay = delayExpr(idx);
	    }
	
	    if (symbol.__t > 0) {
	      delay = -period * symbol.__t;
	    }
	
	    symbol.__t = 0;
	    var animator = symbol.animate('', loop).when(period, {
	      __t: 1
	    }).delay(delay).during(function () {
	      self.updateSymbolPosition(symbol);
	    });
	
	    if (!loop) {
	      animator.done(function () {
	        self.remove(symbol);
	      });
	    }
	
	    animator.start();
	  }
	
	  this._period = period;
	  this._loop = loop;
	};
	
	effectLineProto.getLineLength = function (symbol) {
	  // Not so accurate
	  return vec2.dist(symbol.__p1, symbol.__cp1) + vec2.dist(symbol.__cp1, symbol.__p2);
	};
	
	effectLineProto.updateAnimationPoints = function (symbol, points) {
	  symbol.__p1 = points[0];
	  symbol.__p2 = points[1];
	  symbol.__cp1 = points[2] || [(points[0][0] + points[1][0]) / 2, (points[0][1] + points[1][1]) / 2];
	};
	
	effectLineProto.updateData = function (lineData, idx, seriesScope) {
	  this.childAt(0).updateData(lineData, idx, seriesScope);
	
	  this._updateEffectSymbol(lineData, idx);
	};
	
	effectLineProto.updateSymbolPosition = function (symbol) {
	  var p1 = symbol.__p1;
	  var p2 = symbol.__p2;
	  var cp1 = symbol.__cp1;
	  var t = symbol.__t;
	  var pos = symbol.position;
	  var lastPos = [pos[0], pos[1]];
	  var quadraticAt = curveUtil.quadraticAt;
	  var quadraticDerivativeAt = curveUtil.quadraticDerivativeAt;
	  pos[0] = quadraticAt(p1[0], cp1[0], p2[0], t);
	  pos[1] = quadraticAt(p1[1], cp1[1], p2[1], t); // Tangent
	
	  var tx = quadraticDerivativeAt(p1[0], cp1[0], p2[0], t);
	  var ty = quadraticDerivativeAt(p1[1], cp1[1], p2[1], t);
	  symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2; // enable continuity trail for 'line', 'rect', 'roundRect' symbolType
	
	  if (this._symbolType === 'line' || this._symbolType === 'rect' || this._symbolType === 'roundRect') {
	    if (symbol.__lastT !== undefined && symbol.__lastT < symbol.__t) {
	      var scaleY = vec2.dist(lastPos, pos) * 1.05;
	      symbol.attr('scale', [symbol.scale[0], scaleY]); // make sure the last segment render within endPoint
	
	      if (t === 1) {
	        pos[0] = lastPos[0] + (pos[0] - lastPos[0]) / 2;
	        pos[1] = lastPos[1] + (pos[1] - lastPos[1]) / 2;
	      }
	    } else if (symbol.__lastT === 1) {
	      // After first loop, symbol.__t does NOT start with 0, so connect p1 to pos directly.
	      var scaleY = 2 * vec2.dist(p1, pos);
	      symbol.attr('scale', [symbol.scale[0], scaleY]);
	    } else {
	      symbol.attr('scale', this._symbolScale);
	    }
	  }
	
	  symbol.__lastT = symbol.__t;
	  symbol.ignore = false;
	};
	
	effectLineProto.updateLayout = function (lineData, idx) {
	  this.childAt(0).updateLayout(lineData, idx);
	  var effectModel = lineData.getItemModel(idx).getModel('effect');
	
	  this._updateEffectAnimation(lineData, effectModel, idx);
	};
	
	zrUtil.inherits(EffectLine, graphic.Group);
	var _default = EffectLine;
	module.exports = _default;

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(16);
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/chart/helper/Line
	 */
	
	/**
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 * @alias {module:echarts/chart/helper/Polyline}
	 */
	function Polyline(lineData, idx, seriesScope) {
	  graphic.Group.call(this);
	
	  this._createPolyline(lineData, idx, seriesScope);
	}
	
	var polylineProto = Polyline.prototype;
	
	polylineProto._createPolyline = function (lineData, idx, seriesScope) {
	  // var seriesModel = lineData.hostModel;
	  var points = lineData.getItemLayout(idx);
	  var line = new graphic.Polyline({
	    shape: {
	      points: points
	    }
	  });
	  this.add(line);
	
	  this._updateCommonStl(lineData, idx, seriesScope);
	};
	
	polylineProto.updateData = function (lineData, idx, seriesScope) {
	  var seriesModel = lineData.hostModel;
	  var line = this.childAt(0);
	  var target = {
	    shape: {
	      points: lineData.getItemLayout(idx)
	    }
	  };
	  graphic.updateProps(line, target, seriesModel, idx);
	
	  this._updateCommonStl(lineData, idx, seriesScope);
	};
	
	polylineProto._updateCommonStl = function (lineData, idx, seriesScope) {
	  var line = this.childAt(0);
	  var itemModel = lineData.getItemModel(idx);
	  var visualColor = lineData.getItemVisual(idx, 'color');
	  var lineStyle = seriesScope && seriesScope.lineStyle;
	  var hoverLineStyle = seriesScope && seriesScope.hoverLineStyle;
	
	  if (!seriesScope || lineData.hasItemOption) {
	    lineStyle = itemModel.getModel('lineStyle').getLineStyle();
	    hoverLineStyle = itemModel.getModel('emphasis.lineStyle').getLineStyle();
	  }
	
	  line.useStyle(zrUtil.defaults({
	    strokeNoScale: true,
	    fill: 'none',
	    stroke: visualColor
	  }, lineStyle));
	  line.hoverStyle = hoverLineStyle;
	  graphic.setHoverStyle(this);
	};
	
	polylineProto.updateLayout = function (lineData, idx) {
	  var polyline = this.childAt(0);
	  polyline.setShape('points', lineData.getItemLayout(idx));
	};
	
	zrUtil.inherits(Polyline, graphic.Group);
	var _default = Polyline;
	module.exports = _default;

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var List = __webpack_require__(83);
	
	var Graph = __webpack_require__(1688);
	
	var linkList = __webpack_require__(747);
	
	var createDimensions = __webpack_require__(207);
	
	var CoordinateSystem = __webpack_require__(92);
	
	var createListFromArray = __webpack_require__(122);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(nodes, edges, seriesModel, directed, beforeLink) {
	  // ??? TODO
	  // support dataset?
	  var graph = new Graph(directed);
	
	  for (var i = 0; i < nodes.length; i++) {
	    graph.addNode(zrUtil.retrieve( // Id, name, dataIndex
	    nodes[i].id, nodes[i].name, i), i);
	  }
	
	  var linkNameList = [];
	  var validEdges = [];
	  var linkCount = 0;
	
	  for (var i = 0; i < edges.length; i++) {
	    var link = edges[i];
	    var source = link.source;
	    var target = link.target; // addEdge may fail when source or target not exists
	
	    if (graph.addEdge(source, target, linkCount)) {
	      validEdges.push(link);
	      linkNameList.push(zrUtil.retrieve(link.id, source + ' > ' + target));
	      linkCount++;
	    }
	  }
	
	  var coordSys = seriesModel.get('coordinateSystem');
	  var nodeData;
	
	  if (coordSys === 'cartesian2d' || coordSys === 'polar') {
	    nodeData = createListFromArray(nodes, seriesModel);
	  } else {
	    var coordSysCtor = CoordinateSystem.get(coordSys);
	    var coordDimensions = coordSysCtor && coordSysCtor.type !== 'view' ? coordSysCtor.dimensions || [] : []; // FIXME: Some geo do not need `value` dimenson, whereas `calendar` needs
	    // `value` dimension, but graph need `value` dimension. It's better to
	    // uniform this behavior.
	
	    if (zrUtil.indexOf(coordDimensions, 'value') < 0) {
	      coordDimensions.concat(['value']);
	    }
	
	    var dimensionNames = createDimensions(nodes, {
	      coordDimensions: coordDimensions
	    });
	    nodeData = new List(dimensionNames, seriesModel);
	    nodeData.initData(nodes);
	  }
	
	  var edgeData = new List(['value'], seriesModel);
	  edgeData.initData(validEdges, linkNameList);
	  beforeLink && beforeLink(nodeData, edgeData);
	  linkList({
	    mainData: nodeData,
	    struct: graph,
	    structAttr: 'graph',
	    datas: {
	      node: nodeData,
	      edge: edgeData
	    },
	    datasAttr: {
	      node: 'data',
	      edge: 'edgeData'
	    }
	  }); // Update dataIndex of nodes and edges because invalid edge may be removed
	
	  graph.update();
	  return graph;
	}
	
	module.exports = _default;

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @payload
	 * @property {number} [seriesIndex]
	 * @property {string} [seriesId]
	 * @property {string} [seriesName]
	 * @property {number} [dataIndex]
	 */
	echarts.registerAction({
	  type: 'focusNodeAdjacency',
	  event: 'focusNodeAdjacency',
	  update: 'series:focusNodeAdjacency'
	}, function () {});
	/**
	 * @payload
	 * @property {number} [seriesIndex]
	 * @property {string} [seriesId]
	 * @property {string} [seriesName]
	 */
	
	echarts.registerAction({
	  type: 'unfocusNodeAdjacency',
	  event: 'unfocusNodeAdjacency',
	  update: 'series:unfocusNodeAdjacency'
	}, function () {});

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createListSimply = __webpack_require__(201);
	
	var zrUtil = __webpack_require__(3);
	
	var _dimensionHelper = __webpack_require__(264);
	
	var getDimensionTypeByAxis = _dimensionHelper.getDimensionTypeByAxis;
	
	var _sourceHelper = __webpack_require__(123);
	
	var makeSeriesEncodeForAxisCoordSys = _sourceHelper.makeSeriesEncodeForAxisCoordSys;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var seriesModelMixin = {
	  /**
	   * @private
	   * @type {string}
	   */
	  _baseAxisDim: null,
	
	  /**
	   * @override
	   */
	  getInitialData: function (option, ecModel) {
	    // When both types of xAxis and yAxis are 'value', layout is
	    // needed to be specified by user. Otherwise, layout can be
	    // judged by which axis is category.
	    var ordinalMeta;
	    var xAxisModel = ecModel.getComponent('xAxis', this.get('xAxisIndex'));
	    var yAxisModel = ecModel.getComponent('yAxis', this.get('yAxisIndex'));
	    var xAxisType = xAxisModel.get('type');
	    var yAxisType = yAxisModel.get('type');
	    var addOrdinal; // FIXME
	    // Consider time axis.
	
	    if (xAxisType === 'category') {
	      option.layout = 'horizontal';
	      ordinalMeta = xAxisModel.getOrdinalMeta();
	      addOrdinal = true;
	    } else if (yAxisType === 'category') {
	      option.layout = 'vertical';
	      ordinalMeta = yAxisModel.getOrdinalMeta();
	      addOrdinal = true;
	    } else {
	      option.layout = option.layout || 'horizontal';
	    }
	
	    var coordDims = ['x', 'y'];
	    var baseAxisDimIndex = option.layout === 'horizontal' ? 0 : 1;
	    var baseAxisDim = this._baseAxisDim = coordDims[baseAxisDimIndex];
	    var otherAxisDim = coordDims[1 - baseAxisDimIndex];
	    var axisModels = [xAxisModel, yAxisModel];
	    var baseAxisType = axisModels[baseAxisDimIndex].get('type');
	    var otherAxisType = axisModels[1 - baseAxisDimIndex].get('type');
	    var data = option.data; // ??? FIXME make a stage to perform data transfrom.
	    // MUST create a new data, consider setOption({}) again.
	
	    if (data && addOrdinal) {
	      var newOptionData = [];
	      zrUtil.each(data, function (item, index) {
	        var newItem;
	
	        if (item.value && zrUtil.isArray(item.value)) {
	          newItem = item.value.slice();
	          item.value.unshift(index);
	        } else if (zrUtil.isArray(item)) {
	          newItem = item.slice();
	          item.unshift(index);
	        } else {
	          newItem = item;
	        }
	
	        newOptionData.push(newItem);
	      });
	      option.data = newOptionData;
	    }
	
	    var defaultValueDimensions = this.defaultValueDimensions;
	    var coordDimensions = [{
	      name: baseAxisDim,
	      type: getDimensionTypeByAxis(baseAxisType),
	      ordinalMeta: ordinalMeta,
	      otherDims: {
	        tooltip: false,
	        itemName: 0
	      },
	      dimsDef: ['base']
	    }, {
	      name: otherAxisDim,
	      type: getDimensionTypeByAxis(otherAxisType),
	      dimsDef: defaultValueDimensions.slice()
	    }];
	    return createListSimply(this, {
	      coordDimensions: coordDimensions,
	      dimensionsCount: defaultValueDimensions.length + 1,
	      encodeDefaulter: zrUtil.curry(makeSeriesEncodeForAxisCoordSys, coordDimensions, this)
	    });
	  },
	
	  /**
	   * If horizontal, base axis is x, otherwise y.
	   * @override
	   */
	  getBaseAxis: function () {
	    var dim = this._baseAxisDim;
	    return this.ecModel.getComponent(dim + 'Axis', this.get(dim + 'AxisIndex')).axis;
	  }
	};
	exports.seriesModelMixin = seriesModelMixin;

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _dataStackHelper = __webpack_require__(105);
	
	var isDimensionStacked = _dataStackHelper.isDimensionStacked;
	
	var _util = __webpack_require__(3);
	
	var map = _util.map;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {Object} coordSys
	 * @param {module:echarts/data/List} data
	 * @param {string} valueOrigin lineSeries.option.areaStyle.origin
	 */
	function prepareDataCoordInfo(coordSys, data, valueOrigin) {
	  var baseAxis = coordSys.getBaseAxis();
	  var valueAxis = coordSys.getOtherAxis(baseAxis);
	  var valueStart = getValueStart(valueAxis, valueOrigin);
	  var baseAxisDim = baseAxis.dim;
	  var valueAxisDim = valueAxis.dim;
	  var valueDim = data.mapDimension(valueAxisDim);
	  var baseDim = data.mapDimension(baseAxisDim);
	  var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
	  var dims = map(coordSys.dimensions, function (coordDim) {
	    return data.mapDimension(coordDim);
	  });
	  var stacked;
	  var stackResultDim = data.getCalculationInfo('stackResultDimension');
	
	  if (stacked |= isDimensionStacked(data, dims[0]
	  /*, dims[1]*/
	  )) {
	    // jshint ignore:line
	    dims[0] = stackResultDim;
	  }
	
	  if (stacked |= isDimensionStacked(data, dims[1]
	  /*, dims[0]*/
	  )) {
	    // jshint ignore:line
	    dims[1] = stackResultDim;
	  }
	
	  return {
	    dataDimsForPoint: dims,
	    valueStart: valueStart,
	    valueAxisDim: valueAxisDim,
	    baseAxisDim: baseAxisDim,
	    stacked: !!stacked,
	    valueDim: valueDim,
	    baseDim: baseDim,
	    baseDataOffset: baseDataOffset,
	    stackedOverDimension: data.getCalculationInfo('stackedOverDimension')
	  };
	}
	
	function getValueStart(valueAxis, valueOrigin) {
	  var valueStart = 0;
	  var extent = valueAxis.scale.getExtent();
	
	  if (valueOrigin === 'start') {
	    valueStart = extent[0];
	  } else if (valueOrigin === 'end') {
	    valueStart = extent[1];
	  } // auto
	  else {
	      // Both positive
	      if (extent[0] > 0) {
	        valueStart = extent[0];
	      } // Both negative
	      else if (extent[1] < 0) {
	          valueStart = extent[1];
	        } // If is one positive, and one negative, onZero shall be true
	
	    }
	
	  return valueStart;
	}
	
	function getStackedOnPoint(dataCoordInfo, coordSys, data, idx) {
	  var value = NaN;
	
	  if (dataCoordInfo.stacked) {
	    value = data.get(data.getCalculationInfo('stackedOverDimension'), idx);
	  }
	
	  if (isNaN(value)) {
	    value = dataCoordInfo.valueStart;
	  }
	
	  var baseDataOffset = dataCoordInfo.baseDataOffset;
	  var stackedData = [];
	  stackedData[baseDataOffset] = data.get(dataCoordInfo.baseDim, idx);
	  stackedData[1 - baseDataOffset] = value;
	  return coordSys.dataToPoint(stackedData);
	}
	
	exports.prepareDataCoordInfo = prepareDataCoordInfo;
	exports.getStackedOnPoint = getStackedOnPoint;

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Path = __webpack_require__(46);
	
	var vec2 = __webpack_require__(41);
	
	var fixClipWithShadow = __webpack_require__(1088);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Poly path support NaN point
	var vec2Min = vec2.min;
	var vec2Max = vec2.max;
	var scaleAndAdd = vec2.scaleAndAdd;
	var v2Copy = vec2.copy; // Temporary variable
	
	var v = [];
	var cp0 = [];
	var cp1 = [];
	
	function isPointNull(p) {
	  return isNaN(p[0]) || isNaN(p[1]);
	}
	
	function drawSegment(ctx, points, start, segLen, allLen, dir, smoothMin, smoothMax, smooth, smoothMonotone, connectNulls) {
	  // if (smoothMonotone == null) {
	  //     if (isMono(points, 'x')) {
	  //         return drawMono(ctx, points, start, segLen, allLen,
	  //             dir, smoothMin, smoothMax, smooth, 'x', connectNulls);
	  //     }
	  //     else if (isMono(points, 'y')) {
	  //         return drawMono(ctx, points, start, segLen, allLen,
	  //             dir, smoothMin, smoothMax, smooth, 'y', connectNulls);
	  //     }
	  //     else {
	  //         return drawNonMono.apply(this, arguments);
	  //     }
	  // }
	  // else if (smoothMonotone !== 'none' && isMono(points, smoothMonotone)) {
	  //     return drawMono.apply(this, arguments);
	  // }
	  // else {
	  //     return drawNonMono.apply(this, arguments);
	  // }
	  if (smoothMonotone === 'none' || !smoothMonotone) {
	    return drawNonMono.apply(this, arguments);
	  } else {
	    return drawMono.apply(this, arguments);
	  }
	}
	/**
	 * Check if points is in monotone.
	 *
	 * @param {number[][]} points         Array of points which is in [x, y] form
	 * @param {string}     smoothMonotone 'x', 'y', or 'none', stating for which
	 *                                    dimension that is checking.
	 *                                    If is 'none', `drawNonMono` should be
	 *                                    called.
	 *                                    If is undefined, either being monotone
	 *                                    in 'x' or 'y' will call `drawMono`.
	 */
	// function isMono(points, smoothMonotone) {
	//     if (points.length <= 1) {
	//         return true;
	//     }
	//     var dim = smoothMonotone === 'x' ? 0 : 1;
	//     var last = points[0][dim];
	//     var lastDiff = 0;
	//     for (var i = 1; i < points.length; ++i) {
	//         var diff = points[i][dim] - last;
	//         if (!isNaN(diff) && !isNaN(lastDiff)
	//             && diff !== 0 && lastDiff !== 0
	//             && ((diff >= 0) !== (lastDiff >= 0))
	//         ) {
	//             return false;
	//         }
	//         if (!isNaN(diff) && diff !== 0) {
	//             lastDiff = diff;
	//             last = points[i][dim];
	//         }
	//     }
	//     return true;
	// }
	
	/**
	 * Draw smoothed line in monotone, in which only vertical or horizontal bezier
	 * control points will be used. This should be used when points are monotone
	 * either in x or y dimension.
	 */
	
	
	function drawMono(ctx, points, start, segLen, allLen, dir, smoothMin, smoothMax, smooth, smoothMonotone, connectNulls) {
	  var prevIdx = 0;
	  var idx = start;
	
	  for (var k = 0; k < segLen; k++) {
	    var p = points[idx];
	
	    if (idx >= allLen || idx < 0) {
	      break;
	    }
	
	    if (isPointNull(p)) {
	      if (connectNulls) {
	        idx += dir;
	        continue;
	      }
	
	      break;
	    }
	
	    if (idx === start) {
	      ctx[dir > 0 ? 'moveTo' : 'lineTo'](p[0], p[1]);
	    } else {
	      if (smooth > 0) {
	        var prevP = points[prevIdx];
	        var dim = smoothMonotone === 'y' ? 1 : 0; // Length of control point to p, either in x or y, but not both
	
	        var ctrlLen = (p[dim] - prevP[dim]) * smooth;
	        v2Copy(cp0, prevP);
	        cp0[dim] = prevP[dim] + ctrlLen;
	        v2Copy(cp1, p);
	        cp1[dim] = p[dim] - ctrlLen;
	        ctx.bezierCurveTo(cp0[0], cp0[1], cp1[0], cp1[1], p[0], p[1]);
	      } else {
	        ctx.lineTo(p[0], p[1]);
	      }
	    }
	
	    prevIdx = idx;
	    idx += dir;
	  }
	
	  return k;
	}
	/**
	 * Draw smoothed line in non-monotone, in may cause undesired curve in extreme
	 * situations. This should be used when points are non-monotone neither in x or
	 * y dimension.
	 */
	
	
	function drawNonMono(ctx, points, start, segLen, allLen, dir, smoothMin, smoothMax, smooth, smoothMonotone, connectNulls) {
	  var prevIdx = 0;
	  var idx = start;
	
	  for (var k = 0; k < segLen; k++) {
	    var p = points[idx];
	
	    if (idx >= allLen || idx < 0) {
	      break;
	    }
	
	    if (isPointNull(p)) {
	      if (connectNulls) {
	        idx += dir;
	        continue;
	      }
	
	      break;
	    }
	
	    if (idx === start) {
	      ctx[dir > 0 ? 'moveTo' : 'lineTo'](p[0], p[1]);
	      v2Copy(cp0, p);
	    } else {
	      if (smooth > 0) {
	        var nextIdx = idx + dir;
	        var nextP = points[nextIdx];
	
	        if (connectNulls) {
	          // Find next point not null
	          while (nextP && isPointNull(points[nextIdx])) {
	            nextIdx += dir;
	            nextP = points[nextIdx];
	          }
	        }
	
	        var ratioNextSeg = 0.5;
	        var prevP = points[prevIdx];
	        var nextP = points[nextIdx]; // Last point
	
	        if (!nextP || isPointNull(nextP)) {
	          v2Copy(cp1, p);
	        } else {
	          // If next data is null in not connect case
	          if (isPointNull(nextP) && !connectNulls) {
	            nextP = p;
	          }
	
	          vec2.sub(v, nextP, prevP);
	          var lenPrevSeg;
	          var lenNextSeg;
	
	          if (smoothMonotone === 'x' || smoothMonotone === 'y') {
	            var dim = smoothMonotone === 'x' ? 0 : 1;
	            lenPrevSeg = Math.abs(p[dim] - prevP[dim]);
	            lenNextSeg = Math.abs(p[dim] - nextP[dim]);
	          } else {
	            lenPrevSeg = vec2.dist(p, prevP);
	            lenNextSeg = vec2.dist(p, nextP);
	          } // Use ratio of seg length
	
	
	          ratioNextSeg = lenNextSeg / (lenNextSeg + lenPrevSeg);
	          scaleAndAdd(cp1, p, v, -smooth * (1 - ratioNextSeg));
	        } // Smooth constraint
	
	
	        vec2Min(cp0, cp0, smoothMax);
	        vec2Max(cp0, cp0, smoothMin);
	        vec2Min(cp1, cp1, smoothMax);
	        vec2Max(cp1, cp1, smoothMin);
	        ctx.bezierCurveTo(cp0[0], cp0[1], cp1[0], cp1[1], p[0], p[1]); // cp0 of next segment
	
	        scaleAndAdd(cp0, p, v, smooth * ratioNextSeg);
	      } else {
	        ctx.lineTo(p[0], p[1]);
	      }
	    }
	
	    prevIdx = idx;
	    idx += dir;
	  }
	
	  return k;
	}
	
	function getBoundingBox(points, smoothConstraint) {
	  var ptMin = [Infinity, Infinity];
	  var ptMax = [-Infinity, -Infinity];
	
	  if (smoothConstraint) {
	    for (var i = 0; i < points.length; i++) {
	      var pt = points[i];
	
	      if (pt[0] < ptMin[0]) {
	        ptMin[0] = pt[0];
	      }
	
	      if (pt[1] < ptMin[1]) {
	        ptMin[1] = pt[1];
	      }
	
	      if (pt[0] > ptMax[0]) {
	        ptMax[0] = pt[0];
	      }
	
	      if (pt[1] > ptMax[1]) {
	        ptMax[1] = pt[1];
	      }
	    }
	  }
	
	  return {
	    min: smoothConstraint ? ptMin : ptMax,
	    max: smoothConstraint ? ptMax : ptMin
	  };
	}
	
	var Polyline = Path.extend({
	  type: 'ec-polyline',
	  shape: {
	    points: [],
	    smooth: 0,
	    smoothConstraint: true,
	    smoothMonotone: null,
	    connectNulls: false
	  },
	  style: {
	    fill: null,
	    stroke: '#000'
	  },
	  brush: fixClipWithShadow(Path.prototype.brush),
	  buildPath: function (ctx, shape) {
	    var points = shape.points;
	    var i = 0;
	    var len = points.length;
	    var result = getBoundingBox(points, shape.smoothConstraint);
	
	    if (shape.connectNulls) {
	      // Must remove first and last null values avoid draw error in polygon
	      for (; len > 0; len--) {
	        if (!isPointNull(points[len - 1])) {
	          break;
	        }
	      }
	
	      for (; i < len; i++) {
	        if (!isPointNull(points[i])) {
	          break;
	        }
	      }
	    }
	
	    while (i < len) {
	      i += drawSegment(ctx, points, i, len, len, 1, result.min, result.max, shape.smooth, shape.smoothMonotone, shape.connectNulls) + 1;
	    }
	  }
	});
	var Polygon = Path.extend({
	  type: 'ec-polygon',
	  shape: {
	    points: [],
	    // Offset between stacked base points and points
	    stackedOnPoints: [],
	    smooth: 0,
	    stackedOnSmooth: 0,
	    smoothConstraint: true,
	    smoothMonotone: null,
	    connectNulls: false
	  },
	  brush: fixClipWithShadow(Path.prototype.brush),
	  buildPath: function (ctx, shape) {
	    var points = shape.points;
	    var stackedOnPoints = shape.stackedOnPoints;
	    var i = 0;
	    var len = points.length;
	    var smoothMonotone = shape.smoothMonotone;
	    var bbox = getBoundingBox(points, shape.smoothConstraint);
	    var stackedOnBBox = getBoundingBox(stackedOnPoints, shape.smoothConstraint);
	
	    if (shape.connectNulls) {
	      // Must remove first and last null values avoid draw error in polygon
	      for (; len > 0; len--) {
	        if (!isPointNull(points[len - 1])) {
	          break;
	        }
	      }
	
	      for (; i < len; i++) {
	        if (!isPointNull(points[i])) {
	          break;
	        }
	      }
	    }
	
	    while (i < len) {
	      var k = drawSegment(ctx, points, i, len, len, 1, bbox.min, bbox.max, shape.smooth, smoothMonotone, shape.connectNulls);
	      drawSegment(ctx, stackedOnPoints, i + k - 1, k, len, -1, stackedOnBBox.min, stackedOnBBox.max, shape.stackedOnSmooth, smoothMonotone, shape.connectNulls);
	      i += k + 1;
	      ctx.closePath();
	    }
	  }
	});
	exports.Polyline = Polyline;
	exports.Polygon = Polygon;

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createRenderPlanner = __webpack_require__(202);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Float32Array */
	var _default = {
	  seriesType: 'lines',
	  plan: createRenderPlanner(),
	  reset: function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	    var isPolyline = seriesModel.get('polyline');
	    var isLarge = seriesModel.pipelineContext.large;
	
	    function progress(params, lineData) {
	      var lineCoords = [];
	
	      if (isLarge) {
	        var points;
	        var segCount = params.end - params.start;
	
	        if (isPolyline) {
	          var totalCoordsCount = 0;
	
	          for (var i = params.start; i < params.end; i++) {
	            totalCoordsCount += seriesModel.getLineCoordsCount(i);
	          }
	
	          points = new Float32Array(segCount + totalCoordsCount * 2);
	        } else {
	          points = new Float32Array(segCount * 4);
	        }
	
	        var offset = 0;
	        var pt = [];
	
	        for (var i = params.start; i < params.end; i++) {
	          var len = seriesModel.getLineCoords(i, lineCoords);
	
	          if (isPolyline) {
	            points[offset++] = len;
	          }
	
	          for (var k = 0; k < len; k++) {
	            pt = coordSys.dataToPoint(lineCoords[k], false, pt);
	            points[offset++] = pt[0];
	            points[offset++] = pt[1];
	          }
	        }
	
	        lineData.setLayout('linesPoints', points);
	      } else {
	        for (var i = params.start; i < params.end; i++) {
	          var itemModel = lineData.getItemModel(i);
	          var len = seriesModel.getLineCoords(i, lineCoords);
	          var pts = [];
	
	          if (isPolyline) {
	            for (var j = 0; j < len; j++) {
	              pts.push(coordSys.dataToPoint(lineCoords[j]));
	            }
	          } else {
	            pts[0] = coordSys.dataToPoint(lineCoords[0]);
	            pts[1] = coordSys.dataToPoint(lineCoords[1]);
	            var curveness = itemModel.get('lineStyle.curveness');
	
	            if (+curveness) {
	              pts[2] = [(pts[0][0] + pts[1][0]) / 2 - (pts[0][1] - pts[1][1]) * curveness, (pts[0][1] + pts[1][1]) / 2 - (pts[1][0] - pts[0][0]) * curveness];
	            }
	          }
	
	          lineData.setItemLayout(i, pts);
	        }
	      }
	    }
	
	    return {
	      progress: progress
	    };
	  }
	};
	module.exports = _default;

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var layout = __webpack_require__(36);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* A third-party license is embeded for some of the code in this file:
	* The tree layoutHelper implementation was originally copied from
	* "d3.js"(https://github.com/d3/d3-hierarchy) with
	* some modifications made for this project.
	* (see more details in the comment of the specific method below.)
	* The use of the source code of this file is also subject to the terms
	* and consitions of the licence of "d3.js" (BSD-3Clause, see
	* </licenses/LICENSE-d3>).
	*/
	
	/**
	 * @file The layout algorithm of node-link tree diagrams. Here we using Reingold-Tilford algorithm to drawing
	 *       the tree.
	 */
	
	/**
	 * Initialize all computational message for following algorithm.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} root   The virtual root of the tree.
	 */
	function init(root) {
	  root.hierNode = {
	    defaultAncestor: null,
	    ancestor: root,
	    prelim: 0,
	    modifier: 0,
	    change: 0,
	    shift: 0,
	    i: 0,
	    thread: null
	  };
	  var nodes = [root];
	  var node;
	  var children;
	
	  while (node = nodes.pop()) {
	    // jshint ignore:line
	    children = node.children;
	
	    if (node.isExpand && children.length) {
	      var n = children.length;
	
	      for (var i = n - 1; i >= 0; i--) {
	        var child = children[i];
	        child.hierNode = {
	          defaultAncestor: null,
	          ancestor: child,
	          prelim: 0,
	          modifier: 0,
	          change: 0,
	          shift: 0,
	          i: i,
	          thread: null
	        };
	        nodes.push(child);
	      }
	    }
	  }
	}
	/**
	 * The implementation of this function was originally copied from "d3.js"
	 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 *
	 * Computes a preliminary x coordinate for node. Before that, this function is
	 * applied recursively to the children of node, as well as the function
	 * apportion(). After spacing out the children by calling executeShifts(), the
	 * node is placed to the midpoint of its outermost children.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 * @param {Function} separation
	 */
	
	
	function firstWalk(node, separation) {
	  var children = node.isExpand ? node.children : [];
	  var siblings = node.parentNode.children;
	  var subtreeW = node.hierNode.i ? siblings[node.hierNode.i - 1] : null;
	
	  if (children.length) {
	    executeShifts(node);
	    var midPoint = (children[0].hierNode.prelim + children[children.length - 1].hierNode.prelim) / 2;
	
	    if (subtreeW) {
	      node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
	      node.hierNode.modifier = node.hierNode.prelim - midPoint;
	    } else {
	      node.hierNode.prelim = midPoint;
	    }
	  } else if (subtreeW) {
	    node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
	  }
	
	  node.parentNode.hierNode.defaultAncestor = apportion(node, subtreeW, node.parentNode.hierNode.defaultAncestor || siblings[0], separation);
	}
	/**
	 * The implementation of this function was originally copied from "d3.js"
	 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 *
	 * Computes all real x-coordinates by summing up the modifiers recursively.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 */
	
	
	function secondWalk(node) {
	  var nodeX = node.hierNode.prelim + node.parentNode.hierNode.modifier;
	  node.setLayout({
	    x: nodeX
	  }, true);
	  node.hierNode.modifier += node.parentNode.hierNode.modifier;
	}
	
	function separation(cb) {
	  return arguments.length ? cb : defaultSeparation;
	}
	/**
	 * Transform the common coordinate to radial coordinate.
	 *
	 * @param  {number} x
	 * @param  {number} y
	 * @return {Object}
	 */
	
	
	function radialCoordinate(x, y) {
	  var radialCoor = {};
	  x -= Math.PI / 2;
	  radialCoor.x = y * Math.cos(x);
	  radialCoor.y = y * Math.sin(x);
	  return radialCoor;
	}
	/**
	 * Get the layout position of the whole view.
	 *
	 * @param {module:echarts/model/Series} seriesModel  the model object of sankey series
	 * @param {module:echarts/ExtensionAPI} api  provide the API list that the developer can call
	 * @return {module:zrender/core/BoundingRect}  size of rect to draw the sankey view
	 */
	
	
	function getViewRect(seriesModel, api) {
	  return layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
	    width: api.getWidth(),
	    height: api.getHeight()
	  });
	}
	/**
	 * All other shifts, applied to the smaller subtrees between w- and w+, are
	 * performed by this function.
	 *
	 * The implementation of this function was originally copied from "d3.js"
	 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 */
	
	
	function executeShifts(node) {
	  var children = node.children;
	  var n = children.length;
	  var shift = 0;
	  var change = 0;
	
	  while (--n >= 0) {
	    var child = children[n];
	    child.hierNode.prelim += shift;
	    child.hierNode.modifier += shift;
	    change += child.hierNode.change;
	    shift += child.hierNode.shift + change;
	  }
	}
	/**
	 * The implementation of this function was originally copied from "d3.js"
	 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 *
	 * The core of the algorithm. Here, a new subtree is combined with the
	 * previous subtrees. Threads are used to traverse the inside and outside
	 * contours of the left and right subtree up to the highest common level.
	 * Whenever two nodes of the inside contours conflict, we compute the left
	 * one of the greatest uncommon ancestors using the function nextAncestor()
	 * and call moveSubtree() to shift the subtree and prepare the shifts of
	 * smaller subtrees. Finally, we add a new thread (if necessary).
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} subtreeV
	 * @param  {module:echarts/data/Tree~TreeNode} subtreeW
	 * @param  {module:echarts/data/Tree~TreeNode} ancestor
	 * @param  {Function} separation
	 * @return {module:echarts/data/Tree~TreeNode}
	 */
	
	
	function apportion(subtreeV, subtreeW, ancestor, separation) {
	  if (subtreeW) {
	    var nodeOutRight = subtreeV;
	    var nodeInRight = subtreeV;
	    var nodeOutLeft = nodeInRight.parentNode.children[0];
	    var nodeInLeft = subtreeW;
	    var sumOutRight = nodeOutRight.hierNode.modifier;
	    var sumInRight = nodeInRight.hierNode.modifier;
	    var sumOutLeft = nodeOutLeft.hierNode.modifier;
	    var sumInLeft = nodeInLeft.hierNode.modifier;
	
	    while (nodeInLeft = nextRight(nodeInLeft), nodeInRight = nextLeft(nodeInRight), nodeInLeft && nodeInRight) {
	      nodeOutRight = nextRight(nodeOutRight);
	      nodeOutLeft = nextLeft(nodeOutLeft);
	      nodeOutRight.hierNode.ancestor = subtreeV;
	      var shift = nodeInLeft.hierNode.prelim + sumInLeft - nodeInRight.hierNode.prelim - sumInRight + separation(nodeInLeft, nodeInRight);
	
	      if (shift > 0) {
	        moveSubtree(nextAncestor(nodeInLeft, subtreeV, ancestor), subtreeV, shift);
	        sumInRight += shift;
	        sumOutRight += shift;
	      }
	
	      sumInLeft += nodeInLeft.hierNode.modifier;
	      sumInRight += nodeInRight.hierNode.modifier;
	      sumOutRight += nodeOutRight.hierNode.modifier;
	      sumOutLeft += nodeOutLeft.hierNode.modifier;
	    }
	
	    if (nodeInLeft && !nextRight(nodeOutRight)) {
	      nodeOutRight.hierNode.thread = nodeInLeft;
	      nodeOutRight.hierNode.modifier += sumInLeft - sumOutRight;
	    }
	
	    if (nodeInRight && !nextLeft(nodeOutLeft)) {
	      nodeOutLeft.hierNode.thread = nodeInRight;
	      nodeOutLeft.hierNode.modifier += sumInRight - sumOutLeft;
	      ancestor = subtreeV;
	    }
	  }
	
	  return ancestor;
	}
	/**
	 * This function is used to traverse the right contour of a subtree.
	 * It returns the rightmost child of node or the thread of node. The function
	 * returns null if and only if node is on the highest depth of its subtree.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 * @return {module:echarts/data/Tree~TreeNode}
	 */
	
	
	function nextRight(node) {
	  var children = node.children;
	  return children.length && node.isExpand ? children[children.length - 1] : node.hierNode.thread;
	}
	/**
	 * This function is used to traverse the left contour of a subtree (or a subforest).
	 * It returns the leftmost child of node or the thread of node. The function
	 * returns null if and only if node is on the highest depth of its subtree.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 * @return {module:echarts/data/Tree~TreeNode}
	 */
	
	
	function nextLeft(node) {
	  var children = node.children;
	  return children.length && node.isExpand ? children[0] : node.hierNode.thread;
	}
	/**
	 * If nodeInLeft’s ancestor is a sibling of node, returns nodeInLeft’s ancestor.
	 * Otherwise, returns the specified ancestor.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} nodeInLeft
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 * @param  {module:echarts/data/Tree~TreeNode} ancestor
	 * @return {module:echarts/data/Tree~TreeNode}
	 */
	
	
	function nextAncestor(nodeInLeft, node, ancestor) {
	  return nodeInLeft.hierNode.ancestor.parentNode === node.parentNode ? nodeInLeft.hierNode.ancestor : ancestor;
	}
	/**
	 * The implementation of this function was originally copied from "d3.js"
	 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 *
	 * Shifts the current subtree rooted at wr.
	 * This is done by increasing prelim(w+) and modifier(w+) by shift.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} wl
	 * @param  {module:echarts/data/Tree~TreeNode} wr
	 * @param  {number} shift [description]
	 */
	
	
	function moveSubtree(wl, wr, shift) {
	  var change = shift / (wr.hierNode.i - wl.hierNode.i);
	  wr.hierNode.change -= change;
	  wr.hierNode.shift += shift;
	  wr.hierNode.modifier += shift;
	  wr.hierNode.prelim += shift;
	  wl.hierNode.change += change;
	}
	/**
	 * The implementation of this function was originally copied from "d3.js"
	 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 */
	
	
	function defaultSeparation(node1, node2) {
	  return node1.parentNode === node2.parentNode ? 1 : 2;
	}
	
	exports.init = init;
	exports.firstWalk = firstWalk;
	exports.secondWalk = secondWalk;
	exports.separation = separation;
	exports.radialCoordinate = radialCoordinate;
	exports.getViewRect = getViewRect;

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var graphic = __webpack_require__(16);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function rectCoordAxisBuildSplitArea(axisView, axisGroup, axisModel, gridModel) {
	  var axis = axisModel.axis;
	
	  if (axis.scale.isBlank()) {
	    return;
	  }
	
	  var splitAreaModel = axisModel.getModel('splitArea');
	  var areaStyleModel = splitAreaModel.getModel('areaStyle');
	  var areaColors = areaStyleModel.get('color');
	  var gridRect = gridModel.coordinateSystem.getRect();
	  var ticksCoords = axis.getTicksCoords({
	    tickModel: splitAreaModel,
	    clamp: true
	  });
	
	  if (!ticksCoords.length) {
	    return;
	  } // For Making appropriate splitArea animation, the color and anid
	  // should be corresponding to previous one if possible.
	
	
	  var areaColorsLen = areaColors.length;
	  var lastSplitAreaColors = axisView.__splitAreaColors;
	  var newSplitAreaColors = zrUtil.createHashMap();
	  var colorIndex = 0;
	
	  if (lastSplitAreaColors) {
	    for (var i = 0; i < ticksCoords.length; i++) {
	      var cIndex = lastSplitAreaColors.get(ticksCoords[i].tickValue);
	
	      if (cIndex != null) {
	        colorIndex = (cIndex + (areaColorsLen - 1) * i) % areaColorsLen;
	        break;
	      }
	    }
	  }
	
	  var prev = axis.toGlobalCoord(ticksCoords[0].coord);
	  var areaStyle = areaStyleModel.getAreaStyle();
	  areaColors = zrUtil.isArray(areaColors) ? areaColors : [areaColors];
	
	  for (var i = 1; i < ticksCoords.length; i++) {
	    var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
	    var x;
	    var y;
	    var width;
	    var height;
	
	    if (axis.isHorizontal()) {
	      x = prev;
	      y = gridRect.y;
	      width = tickCoord - x;
	      height = gridRect.height;
	      prev = x + width;
	    } else {
	      x = gridRect.x;
	      y = prev;
	      width = gridRect.width;
	      height = tickCoord - y;
	      prev = y + height;
	    }
	
	    var tickValue = ticksCoords[i - 1].tickValue;
	    tickValue != null && newSplitAreaColors.set(tickValue, colorIndex);
	    axisGroup.add(new graphic.Rect({
	      anid: tickValue != null ? 'area_' + tickValue : null,
	      shape: {
	        x: x,
	        y: y,
	        width: width,
	        height: height
	      },
	      style: zrUtil.defaults({
	        fill: areaColors[colorIndex]
	      }, areaStyle),
	      silent: true
	    }));
	    colorIndex = (colorIndex + 1) % areaColorsLen;
	  }
	
	  axisView.__splitAreaColors = newSplitAreaColors;
	}
	
	function rectCoordAxisHandleRemove(axisView) {
	  axisView.__splitAreaColors = null;
	}
	
	exports.rectCoordAxisBuildSplitArea = rectCoordAxisBuildSplitArea;
	exports.rectCoordAxisHandleRemove = rectCoordAxisHandleRemove;

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var BaseAxisPointer = __webpack_require__(458);
	
	var viewHelper = __webpack_require__(333);
	
	var cartesianAxisHelper = __webpack_require__(739);
	
	var AxisView = __webpack_require__(165);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var CartesianAxisPointer = BaseAxisPointer.extend({
	  /**
	   * @override
	   */
	  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {
	    var axis = axisModel.axis;
	    var grid = axis.grid;
	    var axisPointerType = axisPointerModel.get('type');
	    var otherExtent = getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
	    var pixelValue = axis.toGlobalCoord(axis.dataToCoord(value, true));
	
	    if (axisPointerType && axisPointerType !== 'none') {
	      var elStyle = viewHelper.buildElStyle(axisPointerModel);
	      var pointerOption = pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
	      pointerOption.style = elStyle;
	      elOption.graphicKey = pointerOption.type;
	      elOption.pointer = pointerOption;
	    }
	
	    var layoutInfo = cartesianAxisHelper.layout(grid.model, axisModel);
	    viewHelper.buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
	  },
	
	  /**
	   * @override
	   */
	  getHandleTransform: function (value, axisModel, axisPointerModel) {
	    var layoutInfo = cartesianAxisHelper.layout(axisModel.axis.grid.model, axisModel, {
	      labelInside: false
	    });
	    layoutInfo.labelMargin = axisPointerModel.get('handle.margin');
	    return {
	      position: viewHelper.getTransformedPosition(axisModel.axis, value, layoutInfo),
	      rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
	    };
	  },
	
	  /**
	   * @override
	   */
	  updateHandleTransform: function (transform, delta, axisModel, axisPointerModel) {
	    var axis = axisModel.axis;
	    var grid = axis.grid;
	    var axisExtent = axis.getGlobalExtent(true);
	    var otherExtent = getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
	    var dimIndex = axis.dim === 'x' ? 0 : 1;
	    var currPosition = transform.position;
	    currPosition[dimIndex] += delta[dimIndex];
	    currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
	    currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
	    var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
	    var cursorPoint = [cursorOtherValue, cursorOtherValue];
	    cursorPoint[dimIndex] = currPosition[dimIndex]; // Make tooltip do not overlap axisPointer and in the middle of the grid.
	
	    var tooltipOptions = [{
	      verticalAlign: 'middle'
	    }, {
	      align: 'center'
	    }];
	    return {
	      position: currPosition,
	      rotation: transform.rotation,
	      cursorPoint: cursorPoint,
	      tooltipOption: tooltipOptions[dimIndex]
	    };
	  }
	});
	
	function getCartesian(grid, axis) {
	  var opt = {};
	  opt[axis.dim + 'AxisIndex'] = axis.index;
	  return grid.getCartesian(opt);
	}
	
	var pointerShapeBuilder = {
	  line: function (axis, pixelValue, otherExtent) {
	    var targetShape = viewHelper.makeLineShape([pixelValue, otherExtent[0]], [pixelValue, otherExtent[1]], getAxisDimIndex(axis));
	    return {
	      type: 'Line',
	      subPixelOptimize: true,
	      shape: targetShape
	    };
	  },
	  shadow: function (axis, pixelValue, otherExtent) {
	    var bandWidth = Math.max(1, axis.getBandWidth());
	    var span = otherExtent[1] - otherExtent[0];
	    return {
	      type: 'Rect',
	      shape: viewHelper.makeRectShape([pixelValue - bandWidth / 2, otherExtent[0]], [bandWidth, span], getAxisDimIndex(axis))
	    };
	  }
	};
	
	function getAxisDimIndex(axis) {
	  return axis.dim === 'x' ? 0 : 1;
	}
	
	AxisView.registerAxisPointerClass('CartesianAxisPointer', CartesianAxisPointer);
	var _default = CartesianAxisPointer;
	module.exports = _default;

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var modelUtil = __webpack_require__(24);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {Object} finder contains {seriesIndex, dataIndex, dataIndexInside}
	 * @param {module:echarts/model/Global} ecModel
	 * @return {Object} {point: [x, y], el: ...} point Will not be null.
	 */
	function _default(finder, ecModel) {
	  var point = [];
	  var seriesIndex = finder.seriesIndex;
	  var seriesModel;
	
	  if (seriesIndex == null || !(seriesModel = ecModel.getSeriesByIndex(seriesIndex))) {
	    return {
	      point: []
	    };
	  }
	
	  var data = seriesModel.getData();
	  var dataIndex = modelUtil.queryDataIndex(data, finder);
	
	  if (dataIndex == null || dataIndex < 0 || zrUtil.isArray(dataIndex)) {
	    return {
	      point: []
	    };
	  }
	
	  var el = data.getItemGraphicEl(dataIndex);
	  var coordSys = seriesModel.coordinateSystem;
	
	  if (seriesModel.getTooltipPosition) {
	    point = seriesModel.getTooltipPosition(dataIndex) || [];
	  } else if (coordSys && coordSys.dataToPoint) {
	    point = coordSys.dataToPoint(data.getValues(zrUtil.map(coordSys.dimensions, function (dim) {
	      return data.mapDimension(dim);
	    }), dataIndex, true)) || [];
	  } else if (el) {
	    // Use graphic bounding rect
	    var rect = el.getBoundingRect().clone();
	    rect.applyTransform(el.transform);
	    point = [rect.x + rect.width / 2, rect.y + rect.height / 2];
	  }
	
	  return {
	    point: point,
	    el: el
	  };
	}
	
	module.exports = _default;

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var env = __webpack_require__(55);
	
	var _model = __webpack_require__(24);
	
	var makeInner = _model.makeInner;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = makeInner();
	var each = zrUtil.each;
	/**
	 * @param {string} key
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {Function} handler
	 *      param: {string} currTrigger
	 *      param: {Array.<number>} point
	 */
	
	function register(key, api, handler) {
	  if (env.node) {
	    return;
	  }
	
	  var zr = api.getZr();
	  inner(zr).records || (inner(zr).records = {});
	  initGlobalListeners(zr, api);
	  var record = inner(zr).records[key] || (inner(zr).records[key] = {});
	  record.handler = handler;
	}
	
	function initGlobalListeners(zr, api) {
	  if (inner(zr).initialized) {
	    return;
	  }
	
	  inner(zr).initialized = true;
	  useHandler('click', zrUtil.curry(doEnter, 'click'));
	  useHandler('mousemove', zrUtil.curry(doEnter, 'mousemove')); // useHandler('mouseout', onLeave);
	
	  useHandler('globalout', onLeave);
	
	  function useHandler(eventType, cb) {
	    zr.on(eventType, function (e) {
	      var dis = makeDispatchAction(api);
	      each(inner(zr).records, function (record) {
	        record && cb(record, e, dis.dispatchAction);
	      });
	      dispatchTooltipFinally(dis.pendings, api);
	    });
	  }
	}
	
	function dispatchTooltipFinally(pendings, api) {
	  var showLen = pendings.showTip.length;
	  var hideLen = pendings.hideTip.length;
	  var actuallyPayload;
	
	  if (showLen) {
	    actuallyPayload = pendings.showTip[showLen - 1];
	  } else if (hideLen) {
	    actuallyPayload = pendings.hideTip[hideLen - 1];
	  }
	
	  if (actuallyPayload) {
	    actuallyPayload.dispatchAction = null;
	    api.dispatchAction(actuallyPayload);
	  }
	}
	
	function onLeave(record, e, dispatchAction) {
	  record.handler('leave', null, dispatchAction);
	}
	
	function doEnter(currTrigger, record, e, dispatchAction) {
	  record.handler(currTrigger, e, dispatchAction);
	}
	
	function makeDispatchAction(api) {
	  var pendings = {
	    showTip: [],
	    hideTip: []
	  }; // FIXME
	  // better approach?
	  // 'showTip' and 'hideTip' can be triggered by axisPointer and tooltip,
	  // which may be conflict, (axisPointer call showTip but tooltip call hideTip);
	  // So we have to add "final stage" to merge those dispatched actions.
	
	  var dispatchAction = function (payload) {
	    var pendingList = pendings[payload.type];
	
	    if (pendingList) {
	      pendingList.push(payload);
	    } else {
	      payload.dispatchAction = dispatchAction;
	      api.dispatchAction(payload);
	    }
	  };
	
	  return {
	    dispatchAction: dispatchAction,
	    pendings: pendings
	  };
	}
	/**
	 * @param {string} key
	 * @param {module:echarts/ExtensionAPI} api
	 */
	
	
	function unregister(key, api) {
	  if (env.node) {
	    return;
	  }
	
	  var zr = api.getZr();
	  var record = (inner(zr).records || {})[key];
	
	  if (record) {
	    inner(zr).records[key] = null;
	  }
	}
	
	exports.register = register;
	exports.unregister = unregister;

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var BoundingRect = __webpack_require__(42);
	
	var visualSolution = __webpack_require__(342);
	
	var selector = __webpack_require__(1585);
	
	var throttleUtil = __webpack_require__(142);
	
	var BrushTargetManager = __webpack_require__(718);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var STATE_LIST = ['inBrush', 'outOfBrush'];
	var DISPATCH_METHOD = '__ecBrushSelect';
	var DISPATCH_FLAG = '__ecInBrushSelectEvent';
	var PRIORITY_BRUSH = echarts.PRIORITY.VISUAL.BRUSH;
	/**
	 * Layout for visual, the priority higher than other layout, and before brush visual.
	 */
	
	echarts.registerLayout(PRIORITY_BRUSH, function (ecModel, api, payload) {
	  ecModel.eachComponent({
	    mainType: 'brush'
	  }, function (brushModel) {
	    payload && payload.type === 'takeGlobalCursor' && brushModel.setBrushOption(payload.key === 'brush' ? payload.brushOption : {
	      brushType: false
	    });
	  });
	  layoutCovers(ecModel);
	});
	
	function layoutCovers(ecModel) {
	  ecModel.eachComponent({
	    mainType: 'brush'
	  }, function (brushModel) {
	    var brushTargetManager = brushModel.brushTargetManager = new BrushTargetManager(brushModel.option, ecModel);
	    brushTargetManager.setInputRanges(brushModel.areas, ecModel);
	  });
	}
	/**
	 * Register the visual encoding if this modules required.
	 */
	
	
	echarts.registerVisual(PRIORITY_BRUSH, function (ecModel, api, payload) {
	  var brushSelected = [];
	  var throttleType;
	  var throttleDelay;
	  ecModel.eachComponent({
	    mainType: 'brush'
	  }, function (brushModel, brushIndex) {
	    var thisBrushSelected = {
	      brushId: brushModel.id,
	      brushIndex: brushIndex,
	      brushName: brushModel.name,
	      areas: zrUtil.clone(brushModel.areas),
	      selected: []
	    }; // Every brush component exists in event params, convenient
	    // for user to find by index.
	
	    brushSelected.push(thisBrushSelected);
	    var brushOption = brushModel.option;
	    var brushLink = brushOption.brushLink;
	    var linkedSeriesMap = [];
	    var selectedDataIndexForLink = [];
	    var rangeInfoBySeries = [];
	    var hasBrushExists = 0;
	
	    if (!brushIndex) {
	      // Only the first throttle setting works.
	      throttleType = brushOption.throttleType;
	      throttleDelay = brushOption.throttleDelay;
	    } // Add boundingRect and selectors to range.
	
	
	    var areas = zrUtil.map(brushModel.areas, function (area) {
	      return bindSelector(zrUtil.defaults({
	        boundingRect: boundingRectBuilders[area.brushType](area)
	      }, area));
	    });
	    var visualMappings = visualSolution.createVisualMappings(brushModel.option, STATE_LIST, function (mappingOption) {
	      mappingOption.mappingMethod = 'fixed';
	    });
	    zrUtil.isArray(brushLink) && zrUtil.each(brushLink, function (seriesIndex) {
	      linkedSeriesMap[seriesIndex] = 1;
	    });
	
	    function linkOthers(seriesIndex) {
	      return brushLink === 'all' || linkedSeriesMap[seriesIndex];
	    } // If no supported brush or no brush on the series,
	    // all visuals should be in original state.
	
	
	    function brushed(rangeInfoList) {
	      return !!rangeInfoList.length;
	    }
	    /**
	     * Logic for each series: (If the logic has to be modified one day, do it carefully!)
	     *
	     * ( brushed ┬ && ┬hasBrushExist ┬ && linkOthers  ) => StepA: ┬record, ┬ StepB: ┬visualByRecord.
	     *   !brushed┘    ├hasBrushExist ┤                            └nothing,┘        ├visualByRecord.
	     *                └!hasBrushExist┘                                              └nothing.
	     * ( !brushed  && ┬hasBrushExist ┬ && linkOthers  ) => StepA:  nothing,  StepB: ┬visualByRecord.
	     *                └!hasBrushExist┘                                              └nothing.
	     * ( brushed ┬ &&                     !linkOthers ) => StepA:  nothing,  StepB: ┬visualByCheck.
	     *   !brushed┘                                                                  └nothing.
	     * ( !brushed  &&                     !linkOthers ) => StepA:  nothing,  StepB:  nothing.
	     */
	    // Step A
	
	
	    ecModel.eachSeries(function (seriesModel, seriesIndex) {
	      var rangeInfoList = rangeInfoBySeries[seriesIndex] = [];
	      seriesModel.subType === 'parallel' ? stepAParallel(seriesModel, seriesIndex, rangeInfoList) : stepAOthers(seriesModel, seriesIndex, rangeInfoList);
	    });
	
	    function stepAParallel(seriesModel, seriesIndex) {
	      var coordSys = seriesModel.coordinateSystem;
	      hasBrushExists |= coordSys.hasAxisBrushed();
	      linkOthers(seriesIndex) && coordSys.eachActiveState(seriesModel.getData(), function (activeState, dataIndex) {
	        activeState === 'active' && (selectedDataIndexForLink[dataIndex] = 1);
	      });
	    }
	
	    function stepAOthers(seriesModel, seriesIndex, rangeInfoList) {
	      var selectorsByBrushType = getSelectorsByBrushType(seriesModel);
	
	      if (!selectorsByBrushType || brushModelNotControll(brushModel, seriesIndex)) {
	        return;
	      }
	
	      zrUtil.each(areas, function (area) {
	        selectorsByBrushType[area.brushType] && brushModel.brushTargetManager.controlSeries(area, seriesModel, ecModel) && rangeInfoList.push(area);
	        hasBrushExists |= brushed(rangeInfoList);
	      });
	
	      if (linkOthers(seriesIndex) && brushed(rangeInfoList)) {
	        var data = seriesModel.getData();
	        data.each(function (dataIndex) {
	          if (checkInRange(selectorsByBrushType, rangeInfoList, data, dataIndex)) {
	            selectedDataIndexForLink[dataIndex] = 1;
	          }
	        });
	      }
	    } // Step B
	
	
	    ecModel.eachSeries(function (seriesModel, seriesIndex) {
	      var seriesBrushSelected = {
	        seriesId: seriesModel.id,
	        seriesIndex: seriesIndex,
	        seriesName: seriesModel.name,
	        dataIndex: []
	      }; // Every series exists in event params, convenient
	      // for user to find series by seriesIndex.
	
	      thisBrushSelected.selected.push(seriesBrushSelected);
	      var selectorsByBrushType = getSelectorsByBrushType(seriesModel);
	      var rangeInfoList = rangeInfoBySeries[seriesIndex];
	      var data = seriesModel.getData();
	      var getValueState = linkOthers(seriesIndex) ? function (dataIndex) {
	        return selectedDataIndexForLink[dataIndex] ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), 'inBrush') : 'outOfBrush';
	      } : function (dataIndex) {
	        return checkInRange(selectorsByBrushType, rangeInfoList, data, dataIndex) ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), 'inBrush') : 'outOfBrush';
	      }; // If no supported brush or no brush, all visuals are in original state.
	
	      (linkOthers(seriesIndex) ? hasBrushExists : brushed(rangeInfoList)) && visualSolution.applyVisual(STATE_LIST, visualMappings, data, getValueState);
	    });
	  });
	  dispatchAction(api, throttleType, throttleDelay, brushSelected, payload);
	});
	
	function dispatchAction(api, throttleType, throttleDelay, brushSelected, payload) {
	  // This event will not be triggered when `setOpion`, otherwise dead lock may
	  // triggered when do `setOption` in event listener, which we do not find
	  // satisfactory way to solve yet. Some considered resolutions:
	  // (a) Diff with prevoius selected data ant only trigger event when changed.
	  // But store previous data and diff precisely (i.e., not only by dataIndex, but
	  // also detect value changes in selected data) might bring complexity or fragility.
	  // (b) Use spectial param like `silent` to suppress event triggering.
	  // But such kind of volatile param may be weird in `setOption`.
	  if (!payload) {
	    return;
	  }
	
	  var zr = api.getZr();
	
	  if (zr[DISPATCH_FLAG]) {
	    return;
	  }
	
	  if (!zr[DISPATCH_METHOD]) {
	    zr[DISPATCH_METHOD] = doDispatch;
	  }
	
	  var fn = throttleUtil.createOrUpdate(zr, DISPATCH_METHOD, throttleDelay, throttleType);
	  fn(api, brushSelected);
	}
	
	function doDispatch(api, brushSelected) {
	  if (!api.isDisposed()) {
	    var zr = api.getZr();
	    zr[DISPATCH_FLAG] = true;
	    api.dispatchAction({
	      type: 'brushSelect',
	      batch: brushSelected
	    });
	    zr[DISPATCH_FLAG] = false;
	  }
	}
	
	function checkInRange(selectorsByBrushType, rangeInfoList, data, dataIndex) {
	  for (var i = 0, len = rangeInfoList.length; i < len; i++) {
	    var area = rangeInfoList[i];
	
	    if (selectorsByBrushType[area.brushType](dataIndex, data, area.selectors, area)) {
	      return true;
	    }
	  }
	}
	
	function getSelectorsByBrushType(seriesModel) {
	  var brushSelector = seriesModel.brushSelector;
	
	  if (zrUtil.isString(brushSelector)) {
	    var sels = [];
	    zrUtil.each(selector, function (selectorsByElementType, brushType) {
	      sels[brushType] = function (dataIndex, data, selectors, area) {
	        var itemLayout = data.getItemLayout(dataIndex);
	        return selectorsByElementType[brushSelector](itemLayout, selectors, area);
	      };
	    });
	    return sels;
	  } else if (zrUtil.isFunction(brushSelector)) {
	    var bSelector = {};
	    zrUtil.each(selector, function (sel, brushType) {
	      bSelector[brushType] = brushSelector;
	    });
	    return bSelector;
	  }
	
	  return brushSelector;
	}
	
	function brushModelNotControll(brushModel, seriesIndex) {
	  var seriesIndices = brushModel.option.seriesIndex;
	  return seriesIndices != null && seriesIndices !== 'all' && (zrUtil.isArray(seriesIndices) ? zrUtil.indexOf(seriesIndices, seriesIndex) < 0 : seriesIndex !== seriesIndices);
	}
	
	function bindSelector(area) {
	  var selectors = area.selectors = {};
	  zrUtil.each(selector[area.brushType], function (selFn, elType) {
	    // Do not use function binding or curry for performance.
	    selectors[elType] = function (itemLayout) {
	      return selFn(itemLayout, selectors, area);
	    };
	  });
	  return area;
	}
	
	var boundingRectBuilders = {
	  lineX: zrUtil.noop,
	  lineY: zrUtil.noop,
	  rect: function (area) {
	    return getBoundingRectFromMinMax(area.range);
	  },
	  polygon: function (area) {
	    var minMax;
	    var range = area.range;
	
	    for (var i = 0, len = range.length; i < len; i++) {
	      minMax = minMax || [[Infinity, -Infinity], [Infinity, -Infinity]];
	      var rg = range[i];
	      rg[0] < minMax[0][0] && (minMax[0][0] = rg[0]);
	      rg[0] > minMax[0][1] && (minMax[0][1] = rg[0]);
	      rg[1] < minMax[1][0] && (minMax[1][0] = rg[1]);
	      rg[1] > minMax[1][1] && (minMax[1][1] = rg[1]);
	    }
	
	    return minMax && getBoundingRectFromMinMax(minMax);
	  }
	};
	
	function getBoundingRectFromMinMax(minMax) {
	  return new BoundingRect(minMax[0][0], minMax[1][0], minMax[0][1] - minMax[0][0], minMax[1][1] - minMax[1][0]);
	}
	
	exports.layoutCovers = layoutCovers;

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var ATTR = '\0_ec_hist_store';
	/**
	 * @param {module:echarts/model/Global} ecModel
	 * @param {Object} newSnapshot {dataZoomId, batch: [payloadInfo, ...]}
	 */
	
	function push(ecModel, newSnapshot) {
	  var store = giveStore(ecModel); // If previous dataZoom can not be found,
	  // complete an range with current range.
	
	  each(newSnapshot, function (batchItem, dataZoomId) {
	    var i = store.length - 1;
	
	    for (; i >= 0; i--) {
	      var snapshot = store[i];
	
	      if (snapshot[dataZoomId]) {
	        break;
	      }
	    }
	
	    if (i < 0) {
	      // No origin range set, create one by current range.
	      var dataZoomModel = ecModel.queryComponents({
	        mainType: 'dataZoom',
	        subType: 'select',
	        id: dataZoomId
	      })[0];
	
	      if (dataZoomModel) {
	        var percentRange = dataZoomModel.getPercentRange();
	        store[0][dataZoomId] = {
	          dataZoomId: dataZoomId,
	          start: percentRange[0],
	          end: percentRange[1]
	        };
	      }
	    }
	  });
	  store.push(newSnapshot);
	}
	/**
	 * @param {module:echarts/model/Global} ecModel
	 * @return {Object} snapshot
	 */
	
	
	function pop(ecModel) {
	  var store = giveStore(ecModel);
	  var head = store[store.length - 1];
	  store.length > 1 && store.pop(); // Find top for all dataZoom.
	
	  var snapshot = {};
	  each(head, function (batchItem, dataZoomId) {
	    for (var i = store.length - 1; i >= 0; i--) {
	      var batchItem = store[i][dataZoomId];
	
	      if (batchItem) {
	        snapshot[dataZoomId] = batchItem;
	        break;
	      }
	    }
	  });
	  return snapshot;
	}
	/**
	 * @param {module:echarts/model/Global} ecModel
	 */
	
	
	function clear(ecModel) {
	  ecModel[ATTR] = null;
	}
	/**
	 * @param {module:echarts/model/Global} ecModel
	 * @return {number} records. always >= 1.
	 */
	
	
	function count(ecModel) {
	  return giveStore(ecModel).length;
	}
	/**
	 * [{key: dataZoomId, value: {dataZoomId, range}}, ...]
	 * History length of each dataZoom may be different.
	 * this._history[0] is used to store origin range.
	 * @type {Array.<Object>}
	 */
	
	
	function giveStore(ecModel) {
	  var store = ecModel[ATTR];
	
	  if (!store) {
	    store = ecModel[ATTR] = [{}];
	  }
	
	  return store;
	}
	
	exports.push = push;
	exports.pop = pop;
	exports.clear = clear;
	exports.count = count;

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(462);
	
	__webpack_require__(203);
	
	__webpack_require__(204);
	
	__webpack_require__(1590);
	
	__webpack_require__(1591);
	
	__webpack_require__(460);
	
	__webpack_require__(459);

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(462);
	
	__webpack_require__(203);
	
	__webpack_require__(204);
	
	__webpack_require__(1594);
	
	__webpack_require__(1595);
	
	__webpack_require__(460);
	
	__webpack_require__(459);

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var ComponentModel = __webpack_require__(57);
	
	var ComponentView = __webpack_require__(340);
	
	var _sourceHelper = __webpack_require__(123);
	
	var detectSourceFormat = _sourceHelper.detectSourceFormat;
	
	var _sourceType = __webpack_require__(265);
	
	var SERIES_LAYOUT_BY_COLUMN = _sourceType.SERIES_LAYOUT_BY_COLUMN;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * This module is imported by echarts directly.
	 *
	 * Notice:
	 * Always keep this file exists for backward compatibility.
	 * Because before 4.1.0, dataset is an optional component,
	 * some users may import this module manually.
	 */
	ComponentModel.extend({
	  type: 'dataset',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    // 'row', 'column'
	    seriesLayoutBy: SERIES_LAYOUT_BY_COLUMN,
	    // null/'auto': auto detect header, see "module:echarts/data/helper/sourceHelper"
	    sourceHeader: null,
	    dimensions: null,
	    source: null
	  },
	  optionUpdated: function () {
	    detectSourceFormat(this);
	  }
	});
	ComponentView.extend({
	  type: 'dataset'
	});

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(3);
	
	var graphic = __webpack_require__(16);
	
	var modelUtil = __webpack_require__(24);
	
	var brushHelper = __webpack_require__(720);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var indexOf = zrUtil.indexOf;
	var curry = zrUtil.curry;
	var COORD_CONVERTS = ['dataToPoint', 'pointToData']; // FIXME
	// how to genarialize to more coordinate systems.
	
	var INCLUDE_FINDER_MAIN_TYPES = ['grid', 'xAxis', 'yAxis', 'geo', 'graph', 'polar', 'radiusAxis', 'angleAxis', 'bmap'];
	/**
	 * [option in constructor]:
	 * {
	 *     Index/Id/Name of geo, xAxis, yAxis, grid: See util/model#parseFinder.
	 * }
	 *
	 *
	 * [targetInfo]:
	 *
	 * There can be multiple axes in a single targetInfo. Consider the case
	 * of `grid` component, a targetInfo represents a grid which contains one or more
	 * cartesian and one or more axes. And consider the case of parallel system,
	 * which has multiple axes in a coordinate system.
	 * Can be {
	 *     panelId: ...,
	 *     coordSys: <a representitive cartesian in grid (first cartesian by default)>,
	 *     coordSyses: all cartesians.
	 *     gridModel: <grid component>
	 *     xAxes: correspond to coordSyses on index
	 *     yAxes: correspond to coordSyses on index
	 * }
	 * or {
	 *     panelId: ...,
	 *     coordSys: <geo coord sys>
	 *     coordSyses: [<geo coord sys>]
	 *     geoModel: <geo component>
	 * }
	 *
	 *
	 * [panelOpt]:
	 *
	 * Make from targetInfo. Input to BrushController.
	 * {
	 *     panelId: ...,
	 *     rect: ...
	 * }
	 *
	 *
	 * [area]:
	 *
	 * Generated by BrushController or user input.
	 * {
	 *     panelId: Used to locate coordInfo directly. If user inpput, no panelId.
	 *     brushType: determine how to convert to/from coord('rect' or 'polygon' or 'lineX/Y').
	 *     Index/Id/Name of geo, xAxis, yAxis, grid: See util/model#parseFinder.
	 *     range: pixel range.
	 *     coordRange: representitive coord range (the first one of coordRanges).
	 *     coordRanges: <Array> coord ranges, used in multiple cartesian in one grid.
	 * }
	 */
	
	/**
	 * @param {Object} option contains Index/Id/Name of xAxis/yAxis/geo/grid
	 *        Each can be {number|Array.<number>}. like: {xAxisIndex: [3, 4]}
	 * @param {module:echarts/model/Global} ecModel
	 * @param {Object} [opt]
	 * @param {Array.<string>} [opt.include] include coordinate system types.
	 */
	
	function BrushTargetManager(option, ecModel, opt) {
	  /**
	   * @private
	   * @type {Array.<Object>}
	   */
	  var targetInfoList = this._targetInfoList = [];
	  var info = {};
	  var foundCpts = parseFinder(ecModel, option);
	  each(targetInfoBuilders, function (builder, type) {
	    if (!opt || !opt.include || indexOf(opt.include, type) >= 0) {
	      builder(foundCpts, targetInfoList, info);
	    }
	  });
	}
	
	var proto = BrushTargetManager.prototype;
	
	proto.setOutputRanges = function (areas, ecModel) {
	  this.matchOutputRanges(areas, ecModel, function (area, coordRange, coordSys) {
	    (area.coordRanges || (area.coordRanges = [])).push(coordRange); // area.coordRange is the first of area.coordRanges
	
	    if (!area.coordRange) {
	      area.coordRange = coordRange; // In 'category' axis, coord to pixel is not reversible, so we can not
	      // rebuild range by coordRange accrately, which may bring trouble when
	      // brushing only one item. So we use __rangeOffset to rebuilding range
	      // by coordRange. And this it only used in brush component so it is no
	      // need to be adapted to coordRanges.
	
	      var result = coordConvert[area.brushType](0, coordSys, coordRange);
	      area.__rangeOffset = {
	        offset: diffProcessor[area.brushType](result.values, area.range, [1, 1]),
	        xyMinMax: result.xyMinMax
	      };
	    }
	  });
	};
	
	proto.matchOutputRanges = function (areas, ecModel, cb) {
	  each(areas, function (area) {
	    var targetInfo = this.findTargetInfo(area, ecModel);
	
	    if (targetInfo && targetInfo !== true) {
	      zrUtil.each(targetInfo.coordSyses, function (coordSys) {
	        var result = coordConvert[area.brushType](1, coordSys, area.range);
	        cb(area, result.values, coordSys, ecModel);
	      });
	    }
	  }, this);
	};
	
	proto.setInputRanges = function (areas, ecModel) {
	  each(areas, function (area) {
	    var targetInfo = this.findTargetInfo(area, ecModel);
	    area.range = area.range || []; // convert coordRange to global range and set panelId.
	
	    if (targetInfo && targetInfo !== true) {
	      area.panelId = targetInfo.panelId; // (1) area.range shoule always be calculate from coordRange but does
	      // not keep its original value, for the sake of the dataZoom scenario,
	      // where area.coordRange remains unchanged but area.range may be changed.
	      // (2) Only support converting one coordRange to pixel range in brush
	      // component. So do not consider `coordRanges`.
	      // (3) About __rangeOffset, see comment above.
	
	      var result = coordConvert[area.brushType](0, targetInfo.coordSys, area.coordRange);
	      var rangeOffset = area.__rangeOffset;
	      area.range = rangeOffset ? diffProcessor[area.brushType](result.values, rangeOffset.offset, getScales(result.xyMinMax, rangeOffset.xyMinMax)) : result.values;
	    }
	  }, this);
	};
	
	proto.makePanelOpts = function (api, getDefaultBrushType) {
	  return zrUtil.map(this._targetInfoList, function (targetInfo) {
	    var rect = targetInfo.getPanelRect();
	    return {
	      panelId: targetInfo.panelId,
	      defaultBrushType: getDefaultBrushType && getDefaultBrushType(targetInfo),
	      clipPath: brushHelper.makeRectPanelClipPath(rect),
	      isTargetByCursor: brushHelper.makeRectIsTargetByCursor(rect, api, targetInfo.coordSysModel),
	      getLinearBrushOtherExtent: brushHelper.makeLinearBrushOtherExtent(rect)
	    };
	  });
	};
	
	proto.controlSeries = function (area, seriesModel, ecModel) {
	  // Check whether area is bound in coord, and series do not belong to that coord.
	  // If do not do this check, some brush (like lineX) will controll all axes.
	  var targetInfo = this.findTargetInfo(area, ecModel);
	  return targetInfo === true || targetInfo && indexOf(targetInfo.coordSyses, seriesModel.coordinateSystem) >= 0;
	};
	/**
	 * If return Object, a coord found.
	 * If reutrn true, global found.
	 * Otherwise nothing found.
	 *
	 * @param {Object} area
	 * @param {Array} targetInfoList
	 * @return {Object|boolean}
	 */
	
	
	proto.findTargetInfo = function (area, ecModel) {
	  var targetInfoList = this._targetInfoList;
	  var foundCpts = parseFinder(ecModel, area);
	
	  for (var i = 0; i < targetInfoList.length; i++) {
	    var targetInfo = targetInfoList[i];
	    var areaPanelId = area.panelId;
	
	    if (areaPanelId) {
	      if (targetInfo.panelId === areaPanelId) {
	        return targetInfo;
	      }
	    } else {
	      for (var i = 0; i < targetInfoMatchers.length; i++) {
	        if (targetInfoMatchers[i](foundCpts, targetInfo)) {
	          return targetInfo;
	        }
	      }
	    }
	  }
	
	  return true;
	};
	
	function formatMinMax(minMax) {
	  minMax[0] > minMax[1] && minMax.reverse();
	  return minMax;
	}
	
	function parseFinder(ecModel, option) {
	  return modelUtil.parseFinder(ecModel, option, {
	    includeMainTypes: INCLUDE_FINDER_MAIN_TYPES
	  });
	}
	
	var targetInfoBuilders = {
	  grid: function (foundCpts, targetInfoList) {
	    var xAxisModels = foundCpts.xAxisModels;
	    var yAxisModels = foundCpts.yAxisModels;
	    var gridModels = foundCpts.gridModels; // Remove duplicated.
	
	    var gridModelMap = zrUtil.createHashMap();
	    var xAxesHas = {};
	    var yAxesHas = {};
	
	    if (!xAxisModels && !yAxisModels && !gridModels) {
	      return;
	    }
	
	    each(xAxisModels, function (axisModel) {
	      var gridModel = axisModel.axis.grid.model;
	      gridModelMap.set(gridModel.id, gridModel);
	      xAxesHas[gridModel.id] = true;
	    });
	    each(yAxisModels, function (axisModel) {
	      var gridModel = axisModel.axis.grid.model;
	      gridModelMap.set(gridModel.id, gridModel);
	      yAxesHas[gridModel.id] = true;
	    });
	    each(gridModels, function (gridModel) {
	      gridModelMap.set(gridModel.id, gridModel);
	      xAxesHas[gridModel.id] = true;
	      yAxesHas[gridModel.id] = true;
	    });
	    gridModelMap.each(function (gridModel) {
	      var grid = gridModel.coordinateSystem;
	      var cartesians = [];
	      each(grid.getCartesians(), function (cartesian, index) {
	        if (indexOf(xAxisModels, cartesian.getAxis('x').model) >= 0 || indexOf(yAxisModels, cartesian.getAxis('y').model) >= 0) {
	          cartesians.push(cartesian);
	        }
	      });
	      targetInfoList.push({
	        panelId: 'grid--' + gridModel.id,
	        gridModel: gridModel,
	        coordSysModel: gridModel,
	        // Use the first one as the representitive coordSys.
	        coordSys: cartesians[0],
	        coordSyses: cartesians,
	        getPanelRect: panelRectBuilder.grid,
	        xAxisDeclared: xAxesHas[gridModel.id],
	        yAxisDeclared: yAxesHas[gridModel.id]
	      });
	    });
	  },
	  geo: function (foundCpts, targetInfoList) {
	    each(foundCpts.geoModels, function (geoModel) {
	      var coordSys = geoModel.coordinateSystem;
	      targetInfoList.push({
	        panelId: 'geo--' + geoModel.id,
	        geoModel: geoModel,
	        coordSysModel: geoModel,
	        coordSys: coordSys,
	        coordSyses: [coordSys],
	        getPanelRect: panelRectBuilder.geo
	      });
	    });
	  }
	};
	var targetInfoMatchers = [// grid
	function (foundCpts, targetInfo) {
	  var xAxisModel = foundCpts.xAxisModel;
	  var yAxisModel = foundCpts.yAxisModel;
	  var gridModel = foundCpts.gridModel;
	  !gridModel && xAxisModel && (gridModel = xAxisModel.axis.grid.model);
	  !gridModel && yAxisModel && (gridModel = yAxisModel.axis.grid.model);
	  return gridModel && gridModel === targetInfo.gridModel;
	}, // geo
	function (foundCpts, targetInfo) {
	  var geoModel = foundCpts.geoModel;
	  return geoModel && geoModel === targetInfo.geoModel;
	}];
	var panelRectBuilder = {
	  grid: function () {
	    // grid is not Transformable.
	    return this.coordSys.grid.getRect().clone();
	  },
	  geo: function () {
	    var coordSys = this.coordSys;
	    var rect = coordSys.getBoundingRect().clone(); // geo roam and zoom transform
	
	    rect.applyTransform(graphic.getTransform(coordSys));
	    return rect;
	  }
	};
	var coordConvert = {
	  lineX: curry(axisConvert, 0),
	  lineY: curry(axisConvert, 1),
	  rect: function (to, coordSys, rangeOrCoordRange) {
	    var xminymin = coordSys[COORD_CONVERTS[to]]([rangeOrCoordRange[0][0], rangeOrCoordRange[1][0]]);
	    var xmaxymax = coordSys[COORD_CONVERTS[to]]([rangeOrCoordRange[0][1], rangeOrCoordRange[1][1]]);
	    var values = [formatMinMax([xminymin[0], xmaxymax[0]]), formatMinMax([xminymin[1], xmaxymax[1]])];
	    return {
	      values: values,
	      xyMinMax: values
	    };
	  },
	  polygon: function (to, coordSys, rangeOrCoordRange) {
	    var xyMinMax = [[Infinity, -Infinity], [Infinity, -Infinity]];
	    var values = zrUtil.map(rangeOrCoordRange, function (item) {
	      var p = coordSys[COORD_CONVERTS[to]](item);
	      xyMinMax[0][0] = Math.min(xyMinMax[0][0], p[0]);
	      xyMinMax[1][0] = Math.min(xyMinMax[1][0], p[1]);
	      xyMinMax[0][1] = Math.max(xyMinMax[0][1], p[0]);
	      xyMinMax[1][1] = Math.max(xyMinMax[1][1], p[1]);
	      return p;
	    });
	    return {
	      values: values,
	      xyMinMax: xyMinMax
	    };
	  }
	};
	
	function axisConvert(axisNameIndex, to, coordSys, rangeOrCoordRange) {
	  var axis = coordSys.getAxis(['x', 'y'][axisNameIndex]);
	  var values = formatMinMax(zrUtil.map([0, 1], function (i) {
	    return to ? axis.coordToData(axis.toLocalCoord(rangeOrCoordRange[i])) : axis.toGlobalCoord(axis.dataToCoord(rangeOrCoordRange[i]));
	  }));
	  var xyMinMax = [];
	  xyMinMax[axisNameIndex] = values;
	  xyMinMax[1 - axisNameIndex] = [NaN, NaN];
	  return {
	    values: values,
	    xyMinMax: xyMinMax
	  };
	}
	
	var diffProcessor = {
	  lineX: curry(axisDiffProcessor, 0),
	  lineY: curry(axisDiffProcessor, 1),
	  rect: function (values, refer, scales) {
	    return [[values[0][0] - scales[0] * refer[0][0], values[0][1] - scales[0] * refer[0][1]], [values[1][0] - scales[1] * refer[1][0], values[1][1] - scales[1] * refer[1][1]]];
	  },
	  polygon: function (values, refer, scales) {
	    return zrUtil.map(values, function (item, idx) {
	      return [item[0] - scales[0] * refer[idx][0], item[1] - scales[1] * refer[idx][1]];
	    });
	  }
	};
	
	function axisDiffProcessor(axisNameIndex, values, refer, scales) {
	  return [values[0] - scales[axisNameIndex] * refer[0], values[1] - scales[axisNameIndex] * refer[1]];
	} // We have to process scale caused by dataZoom manually,
	// although it might be not accurate.
	
	
	function getScales(xyMinMaxCurr, xyMinMaxOrigin) {
	  var sizeCurr = getSize(xyMinMaxCurr);
	  var sizeOrigin = getSize(xyMinMaxOrigin);
	  var scales = [sizeCurr[0] / sizeOrigin[0], sizeCurr[1] / sizeOrigin[1]];
	  isNaN(scales[0]) && (scales[0] = 1);
	  isNaN(scales[1]) && (scales[1] = 1);
	  return scales;
	}
	
	function getSize(xyMinMax) {
	  return xyMinMax ? [xyMinMax[0][1] - xyMinMax[0][0], xyMinMax[1][1] - xyMinMax[1][0]] : [NaN, NaN];
	}
	
	var _default = BrushTargetManager;
	module.exports = _default;

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var RoamController = __webpack_require__(262);
	
	var roamHelper = __webpack_require__(464);
	
	var _cursorHelper = __webpack_require__(334);
	
	var onIrrelevantElement = _cursorHelper.onIrrelevantElement;
	
	var graphic = __webpack_require__(16);
	
	var geoSourceManager = __webpack_require__(336);
	
	var _component = __webpack_require__(268);
	
	var getUID = _component.getUID;
	
	var Transformable = __webpack_require__(389);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function getFixedItemStyle(model) {
	  var itemStyle = model.getItemStyle();
	  var areaColor = model.get('areaColor'); // If user want the color not to be changed when hover,
	  // they should both set areaColor and color to be null.
	
	  if (areaColor != null) {
	    itemStyle.fill = areaColor;
	  }
	
	  return itemStyle;
	}
	
	function updateMapSelectHandler(mapDraw, mapOrGeoModel, regionsGroup, api, fromView) {
	  regionsGroup.off('click');
	  regionsGroup.off('mousedown');
	
	  if (mapOrGeoModel.get('selectedMode')) {
	    regionsGroup.on('mousedown', function () {
	      mapDraw._mouseDownFlag = true;
	    });
	    regionsGroup.on('click', function (e) {
	      if (!mapDraw._mouseDownFlag) {
	        return;
	      }
	
	      mapDraw._mouseDownFlag = false;
	      var el = e.target;
	
	      while (!el.__regions) {
	        el = el.parent;
	      }
	
	      if (!el) {
	        return;
	      }
	
	      var action = {
	        type: (mapOrGeoModel.mainType === 'geo' ? 'geo' : 'map') + 'ToggleSelect',
	        batch: zrUtil.map(el.__regions, function (region) {
	          return {
	            name: region.name,
	            from: fromView.uid
	          };
	        })
	      };
	      action[mapOrGeoModel.mainType + 'Id'] = mapOrGeoModel.id;
	      api.dispatchAction(action);
	      updateMapSelected(mapOrGeoModel, regionsGroup);
	    });
	  }
	}
	
	function updateMapSelected(mapOrGeoModel, regionsGroup) {
	  // FIXME
	  regionsGroup.eachChild(function (otherRegionEl) {
	    zrUtil.each(otherRegionEl.__regions, function (region) {
	      otherRegionEl.trigger(mapOrGeoModel.isSelected(region.name) ? 'emphasis' : 'normal');
	    });
	  });
	}
	/**
	 * @alias module:echarts/component/helper/MapDraw
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {boolean} updateGroup
	 */
	
	
	function MapDraw(api, updateGroup) {
	  var group = new graphic.Group();
	  /**
	   * @type {string}
	   * @private
	   */
	
	  this.uid = getUID('ec_map_draw');
	  /**
	   * @type {module:echarts/component/helper/RoamController}
	   * @private
	   */
	
	  this._controller = new RoamController(api.getZr());
	  /**
	   * @type {Object} {target, zoom, zoomLimit}
	   * @private
	   */
	
	  this._controllerHost = {
	    target: updateGroup ? group : null
	  };
	  /**
	   * @type {module:zrender/container/Group}
	   * @readOnly
	   */
	
	  this.group = group;
	  /**
	   * @type {boolean}
	   * @private
	   */
	
	  this._updateGroup = updateGroup;
	  /**
	   * This flag is used to make sure that only one among
	   * `pan`, `zoom`, `click` can occurs, otherwise 'selected'
	   * action may be triggered when `pan`, which is unexpected.
	   * @type {booelan}
	   */
	
	  this._mouseDownFlag;
	  /**
	   * @type {string}
	   */
	
	  this._mapName;
	  /**
	   * @type {boolean}
	   */
	
	  this._initialized;
	  /**
	   * @type {module:zrender/container/Group}
	   */
	
	  group.add(this._regionsGroup = new graphic.Group());
	  /**
	   * @type {module:zrender/container/Group}
	   */
	
	  group.add(this._backgroundGroup = new graphic.Group());
	}
	
	MapDraw.prototype = {
	  constructor: MapDraw,
	  draw: function (mapOrGeoModel, ecModel, api, fromView, payload) {
	    var isGeo = mapOrGeoModel.mainType === 'geo'; // Map series has data. GEO model that controlled by map series
	    // will be assigned with map data. Other GEO model has no data.
	
	    var data = mapOrGeoModel.getData && mapOrGeoModel.getData();
	    isGeo && ecModel.eachComponent({
	      mainType: 'series',
	      subType: 'map'
	    }, function (mapSeries) {
	      if (!data && mapSeries.getHostGeoModel() === mapOrGeoModel) {
	        data = mapSeries.getData();
	      }
	    });
	    var geo = mapOrGeoModel.coordinateSystem;
	
	    this._updateBackground(geo);
	
	    var regionsGroup = this._regionsGroup;
	    var group = this.group;
	    var transformInfo = geo.getTransformInfo(); // No animation when first draw or in action
	
	    var isFirstDraw = !regionsGroup.childAt(0) || payload;
	    var targetScale;
	
	    if (isFirstDraw) {
	      group.transform = transformInfo.roamTransform;
	      group.decomposeTransform();
	      group.dirty();
	    } else {
	      var target = new Transformable();
	      target.transform = transformInfo.roamTransform;
	      target.decomposeTransform();
	      var props = {
	        scale: target.scale,
	        position: target.position
	      };
	      targetScale = target.scale;
	      graphic.updateProps(group, props, mapOrGeoModel);
	    }
	
	    var scale = transformInfo.rawScale;
	    var position = transformInfo.rawPosition;
	    regionsGroup.removeAll();
	    var itemStyleAccessPath = ['itemStyle'];
	    var hoverItemStyleAccessPath = ['emphasis', 'itemStyle'];
	    var labelAccessPath = ['label'];
	    var hoverLabelAccessPath = ['emphasis', 'label'];
	    var nameMap = zrUtil.createHashMap();
	    zrUtil.each(geo.regions, function (region) {
	      // Consider in GeoJson properties.name may be duplicated, for example,
	      // there is multiple region named "United Kindom" or "France" (so many
	      // colonies). And it is not appropriate to merge them in geo, which
	      // will make them share the same label and bring trouble in label
	      // location calculation.
	      var regionGroup = nameMap.get(region.name) || nameMap.set(region.name, new graphic.Group());
	      var compoundPath = new graphic.CompoundPath({
	        segmentIgnoreThreshold: 1,
	        shape: {
	          paths: []
	        }
	      });
	      regionGroup.add(compoundPath);
	      var regionModel = mapOrGeoModel.getRegionModel(region.name) || mapOrGeoModel;
	      var itemStyleModel = regionModel.getModel(itemStyleAccessPath);
	      var hoverItemStyleModel = regionModel.getModel(hoverItemStyleAccessPath);
	      var itemStyle = getFixedItemStyle(itemStyleModel);
	      var hoverItemStyle = getFixedItemStyle(hoverItemStyleModel);
	      var labelModel = regionModel.getModel(labelAccessPath);
	      var hoverLabelModel = regionModel.getModel(hoverLabelAccessPath);
	      var dataIdx; // Use the itemStyle in data if has data
	
	      if (data) {
	        dataIdx = data.indexOfName(region.name); // Only visual color of each item will be used. It can be encoded by dataRange
	        // But visual color of series is used in symbol drawing
	        //
	        // Visual color for each series is for the symbol draw
	
	        var visualColor = data.getItemVisual(dataIdx, 'color', true);
	
	        if (visualColor) {
	          itemStyle.fill = visualColor;
	        }
	      }
	
	      var transformPoint = function (point) {
	        return [point[0] * scale[0] + position[0], point[1] * scale[1] + position[1]];
	      };
	
	      zrUtil.each(region.geometries, function (geometry) {
	        if (geometry.type !== 'polygon') {
	          return;
	        }
	
	        var points = [];
	
	        for (var i = 0; i < geometry.exterior.length; ++i) {
	          points.push(transformPoint(geometry.exterior[i]));
	        }
	
	        compoundPath.shape.paths.push(new graphic.Polygon({
	          segmentIgnoreThreshold: 1,
	          shape: {
	            points: points
	          }
	        }));
	
	        for (var i = 0; i < (geometry.interiors ? geometry.interiors.length : 0); ++i) {
	          var interior = geometry.interiors[i];
	          var points = [];
	
	          for (var j = 0; j < interior.length; ++j) {
	            points.push(transformPoint(interior[j]));
	          }
	
	          compoundPath.shape.paths.push(new graphic.Polygon({
	            segmentIgnoreThreshold: 1,
	            shape: {
	              points: points
	            }
	          }));
	        }
	      });
	      compoundPath.setStyle(itemStyle);
	      compoundPath.style.strokeNoScale = true;
	      compoundPath.culling = true; // Label
	
	      var showLabel = labelModel.get('show');
	      var hoverShowLabel = hoverLabelModel.get('show');
	      var isDataNaN = data && isNaN(data.get(data.mapDimension('value'), dataIdx));
	      var itemLayout = data && data.getItemLayout(dataIdx); // In the following cases label will be drawn
	      // 1. In map series and data value is NaN
	      // 2. In geo component
	      // 4. Region has no series legendSymbol, which will be add a showLabel flag in mapSymbolLayout
	
	      if (isGeo || isDataNaN && (showLabel || hoverShowLabel) || itemLayout && itemLayout.showLabel) {
	        var query = !isGeo ? dataIdx : region.name;
	        var labelFetcher; // Consider dataIdx not found.
	
	        if (!data || dataIdx >= 0) {
	          labelFetcher = mapOrGeoModel;
	        }
	
	        var textEl = new graphic.Text({
	          position: transformPoint(region.center.slice()),
	          // FIXME
	          // label rotation is not support yet in geo or regions of series-map
	          // that has no data. The rotation will be effected by this `scale`.
	          // So needed to change to RectText?
	          scale: [1 / group.scale[0], 1 / group.scale[1]],
	          z2: 10,
	          silent: true
	        });
	        graphic.setLabelStyle(textEl.style, textEl.hoverStyle = {}, labelModel, hoverLabelModel, {
	          labelFetcher: labelFetcher,
	          labelDataIndex: query,
	          defaultText: region.name,
	          useInsideStyle: false
	        }, {
	          textAlign: 'center',
	          textVerticalAlign: 'middle'
	        });
	
	        if (!isFirstDraw) {
	          // Text animation
	          var textScale = [1 / targetScale[0], 1 / targetScale[1]];
	          graphic.updateProps(textEl, {
	            scale: textScale
	          }, mapOrGeoModel);
	        }
	
	        regionGroup.add(textEl);
	      } // setItemGraphicEl, setHoverStyle after all polygons and labels
	      // are added to the rigionGroup
	
	
	      if (data) {
	        data.setItemGraphicEl(dataIdx, regionGroup);
	      } else {
	        var regionModel = mapOrGeoModel.getRegionModel(region.name); // Package custom mouse event for geo component
	
	        compoundPath.eventData = {
	          componentType: 'geo',
	          componentIndex: mapOrGeoModel.componentIndex,
	          geoIndex: mapOrGeoModel.componentIndex,
	          name: region.name,
	          region: regionModel && regionModel.option || {}
	        };
	      }
	
	      var groupRegions = regionGroup.__regions || (regionGroup.__regions = []);
	      groupRegions.push(region);
	      regionGroup.highDownSilentOnTouch = !!mapOrGeoModel.get('selectedMode');
	      graphic.setHoverStyle(regionGroup, hoverItemStyle);
	      regionsGroup.add(regionGroup);
	    });
	
	    this._updateController(mapOrGeoModel, ecModel, api);
	
	    updateMapSelectHandler(this, mapOrGeoModel, regionsGroup, api, fromView);
	    updateMapSelected(mapOrGeoModel, regionsGroup);
	  },
	  remove: function () {
	    this._regionsGroup.removeAll();
	
	    this._backgroundGroup.removeAll();
	
	    this._controller.dispose();
	
	    this._mapName && geoSourceManager.removeGraphic(this._mapName, this.uid);
	    this._mapName = null;
	    this._controllerHost = {};
	  },
	  _updateBackground: function (geo) {
	    var mapName = geo.map;
	
	    if (this._mapName !== mapName) {
	      zrUtil.each(geoSourceManager.makeGraphic(mapName, this.uid), function (root) {
	        this._backgroundGroup.add(root);
	      }, this);
	    }
	
	    this._mapName = mapName;
	  },
	  _updateController: function (mapOrGeoModel, ecModel, api) {
	    var geo = mapOrGeoModel.coordinateSystem;
	    var controller = this._controller;
	    var controllerHost = this._controllerHost;
	    controllerHost.zoomLimit = mapOrGeoModel.get('scaleLimit');
	    controllerHost.zoom = geo.getZoom(); // roamType is will be set default true if it is null
	
	    controller.enable(mapOrGeoModel.get('roam') || false);
	    var mainType = mapOrGeoModel.mainType;
	
	    function makeActionBase() {
	      var action = {
	        type: 'geoRoam',
	        componentType: mainType
	      };
	      action[mainType + 'Id'] = mapOrGeoModel.id;
	      return action;
	    }
	
	    controller.off('pan').on('pan', function (e) {
	      this._mouseDownFlag = false;
	      roamHelper.updateViewOnPan(controllerHost, e.dx, e.dy);
	      api.dispatchAction(zrUtil.extend(makeActionBase(), {
	        dx: e.dx,
	        dy: e.dy
	      }));
	    }, this);
	    controller.off('zoom').on('zoom', function (e) {
	      this._mouseDownFlag = false;
	      roamHelper.updateViewOnZoom(controllerHost, e.scale, e.originX, e.originY);
	      api.dispatchAction(zrUtil.extend(makeActionBase(), {
	        zoom: e.scale,
	        originX: e.originX,
	        originY: e.originY
	      }));
	
	      if (this._updateGroup) {
	        var scale = this.group.scale;
	
	        this._regionsGroup.traverse(function (el) {
	          if (el.type === 'text') {
	            el.attr('scale', [1 / scale[0], 1 / scale[1]]);
	          }
	        });
	      }
	    }, this);
	    controller.setPointerChecker(function (e, x, y) {
	      return geo.getViewRectAfterRoam().contain(x, y) && !onIrrelevantElement(e, api, mapOrGeoModel);
	    });
	  }
	};
	var _default = MapDraw;
	module.exports = _default;

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var BoundingRect = __webpack_require__(42);
	
	var _cursorHelper = __webpack_require__(334);
	
	var onIrrelevantElement = _cursorHelper.onIrrelevantElement;
	
	var graphicUtil = __webpack_require__(16);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function makeRectPanelClipPath(rect) {
	  rect = normalizeRect(rect);
	  return function (localPoints, transform) {
	    return graphicUtil.clipPointsByRect(localPoints, rect);
	  };
	}
	
	function makeLinearBrushOtherExtent(rect, specifiedXYIndex) {
	  rect = normalizeRect(rect);
	  return function (xyIndex) {
	    var idx = specifiedXYIndex != null ? specifiedXYIndex : xyIndex;
	    var brushWidth = idx ? rect.width : rect.height;
	    var base = idx ? rect.x : rect.y;
	    return [base, base + (brushWidth || 0)];
	  };
	}
	
	function makeRectIsTargetByCursor(rect, api, targetModel) {
	  rect = normalizeRect(rect);
	  return function (e, localCursorPoint, transform) {
	    return rect.contain(localCursorPoint[0], localCursorPoint[1]) && !onIrrelevantElement(e, api, targetModel);
	  };
	} // Consider width/height is negative.
	
	
	function normalizeRect(rect) {
	  return BoundingRect.create(rect);
	}
	
	exports.makeRectPanelClipPath = makeRectPanelClipPath;
	exports.makeLinearBrushOtherExtent = makeLinearBrushOtherExtent;
	exports.makeRectIsTargetByCursor = makeRectIsTargetByCursor;

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var ATTR = '\0_ec_interaction_mutex';
	
	function take(zr, resourceKey, userKey) {
	  var store = getStore(zr);
	  store[resourceKey] = userKey;
	}
	
	function release(zr, resourceKey, userKey) {
	  var store = getStore(zr);
	  var uKey = store[resourceKey];
	
	  if (uKey === userKey) {
	    store[resourceKey] = null;
	  }
	}
	
	function isTaken(zr, resourceKey) {
	  return !!getStore(zr)[resourceKey];
	}
	
	function getStore(zr) {
	  return zr[ATTR] || (zr[ATTR] = {});
	}
	/**
	 * payload: {
	 *     type: 'takeGlobalCursor',
	 *     key: 'dataZoomSelect', or 'brush', or ...,
	 *         If no userKey, release global cursor.
	 * }
	 */
	
	
	echarts.registerAction({
	  type: 'takeGlobalCursor',
	  event: 'globalCursorTaken',
	  update: 'update'
	}, function () {});
	exports.take = take;
	exports.release = release;
	exports.isTaken = isTaken;

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _layout = __webpack_require__(36);
	
	var getLayoutRect = _layout.getLayoutRect;
	var layoutBox = _layout.box;
	var positionElement = _layout.positionElement;
	
	var formatUtil = __webpack_require__(40);
	
	var graphic = __webpack_require__(16);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Layout list like component.
	 * It will box layout each items in group of component and then position the whole group in the viewport
	 * @param {module:zrender/group/Group} group
	 * @param {module:echarts/model/Component} componentModel
	 * @param {module:echarts/ExtensionAPI}
	 */
	function layout(group, componentModel, api) {
	  var boxLayoutParams = componentModel.getBoxLayoutParams();
	  var padding = componentModel.get('padding');
	  var viewportSize = {
	    width: api.getWidth(),
	    height: api.getHeight()
	  };
	  var rect = getLayoutRect(boxLayoutParams, viewportSize, padding);
	  layoutBox(componentModel.get('orient'), group, componentModel.get('itemGap'), rect.width, rect.height);
	  positionElement(group, boxLayoutParams, viewportSize, padding);
	}
	
	function makeBackground(rect, componentModel) {
	  var padding = formatUtil.normalizeCssArray(componentModel.get('padding'));
	  var style = componentModel.getItemStyle(['color', 'opacity']);
	  style.fill = componentModel.get('backgroundColor');
	  var rect = new graphic.Rect({
	    shape: {
	      x: rect.x - padding[3],
	      y: rect.y - padding[0],
	      width: rect.width + padding[1] + padding[3],
	      height: rect.height + padding[0] + padding[2],
	      r: componentModel.get('borderRadius')
	    },
	    style: style,
	    silent: true,
	    z2: -1
	  }); // FIXME
	  // `subPixelOptimizeRect` may bring some gap between edge of viewpart
	  // and background rect when setting like `left: 0`, `top: 0`.
	  // graphic.subPixelOptimizeRect(rect);
	
	  return rect;
	}
	
	exports.layout = layout;
	exports.makeBackground = makeBackground;

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	__webpack_require__(724);
	
	__webpack_require__(1604);
	
	__webpack_require__(725);
	
	var legendFilter = __webpack_require__(1605);
	
	var Component = __webpack_require__(57);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Do not contain scrollable legend, for sake of file size.
	// Series Filter
	echarts.registerProcessor(echarts.PRIORITY.PROCESSOR.SERIES_FILTER, legendFilter);
	Component.registerSubTypeDefaulter('legend', function () {
	  // Default 'plain' when no type specified.
	  return 'plain';
	});

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var Model = __webpack_require__(48);
	
	var _model = __webpack_require__(24);
	
	var isNameSpecified = _model.isNameSpecified;
	
	var lang = __webpack_require__(141);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var langSelector = lang.legend.selector;
	var defaultSelectorOption = {
	  all: {
	    type: 'all',
	    title: zrUtil.clone(langSelector.all)
	  },
	  inverse: {
	    type: 'inverse',
	    title: zrUtil.clone(langSelector.inverse)
	  }
	};
	var LegendModel = echarts.extendComponentModel({
	  type: 'legend.plain',
	  dependencies: ['series'],
	  layoutMode: {
	    type: 'box',
	    // legend.width/height are maxWidth/maxHeight actually,
	    // whereas realy width/height is calculated by its content.
	    // (Setting {left: 10, right: 10} does not make sense).
	    // So consider the case:
	    // `setOption({legend: {left: 10});`
	    // then `setOption({legend: {right: 10});`
	    // The previous `left` should be cleared by setting `ignoreSize`.
	    ignoreSize: true
	  },
	  init: function (option, parentModel, ecModel) {
	    this.mergeDefaultAndTheme(option, ecModel);
	    option.selected = option.selected || {};
	
	    this._updateSelector(option);
	  },
	  mergeOption: function (option) {
	    LegendModel.superCall(this, 'mergeOption', option);
	
	    this._updateSelector(option);
	  },
	  _updateSelector: function (option) {
	    var selector = option.selector;
	
	    if (selector === true) {
	      selector = option.selector = ['all', 'inverse'];
	    }
	
	    if (zrUtil.isArray(selector)) {
	      zrUtil.each(selector, function (item, index) {
	        zrUtil.isString(item) && (item = {
	          type: item
	        });
	        selector[index] = zrUtil.merge(item, defaultSelectorOption[item.type]);
	      });
	    }
	  },
	  optionUpdated: function () {
	    this._updateData(this.ecModel);
	
	    var legendData = this._data; // If selectedMode is single, try to select one
	
	    if (legendData[0] && this.get('selectedMode') === 'single') {
	      var hasSelected = false; // If has any selected in option.selected
	
	      for (var i = 0; i < legendData.length; i++) {
	        var name = legendData[i].get('name');
	
	        if (this.isSelected(name)) {
	          // Force to unselect others
	          this.select(name);
	          hasSelected = true;
	          break;
	        }
	      } // Try select the first if selectedMode is single
	
	
	      !hasSelected && this.select(legendData[0].get('name'));
	    }
	  },
	  _updateData: function (ecModel) {
	    var potentialData = [];
	    var availableNames = [];
	    ecModel.eachRawSeries(function (seriesModel) {
	      var seriesName = seriesModel.name;
	      availableNames.push(seriesName);
	      var isPotential;
	
	      if (seriesModel.legendVisualProvider) {
	        var provider = seriesModel.legendVisualProvider;
	        var names = provider.getAllNames();
	
	        if (!ecModel.isSeriesFiltered(seriesModel)) {
	          availableNames = availableNames.concat(names);
	        }
	
	        if (names.length) {
	          potentialData = potentialData.concat(names);
	        } else {
	          isPotential = true;
	        }
	      } else {
	        isPotential = true;
	      }
	
	      if (isPotential && isNameSpecified(seriesModel)) {
	        potentialData.push(seriesModel.name);
	      }
	    });
	    /**
	     * @type {Array.<string>}
	     * @private
	     */
	
	    this._availableNames = availableNames; // If legend.data not specified in option, use availableNames as data,
	    // which is convinient for user preparing option.
	
	    var rawData = this.get('data') || potentialData;
	    var legendData = zrUtil.map(rawData, function (dataItem) {
	      // Can be string or number
	      if (typeof dataItem === 'string' || typeof dataItem === 'number') {
	        dataItem = {
	          name: dataItem
	        };
	      }
	
	      return new Model(dataItem, this, this.ecModel);
	    }, this);
	    /**
	     * @type {Array.<module:echarts/model/Model>}
	     * @private
	     */
	
	    this._data = legendData;
	  },
	
	  /**
	   * @return {Array.<module:echarts/model/Model>}
	   */
	  getData: function () {
	    return this._data;
	  },
	
	  /**
	   * @param {string} name
	   */
	  select: function (name) {
	    var selected = this.option.selected;
	    var selectedMode = this.get('selectedMode');
	
	    if (selectedMode === 'single') {
	      var data = this._data;
	      zrUtil.each(data, function (dataItem) {
	        selected[dataItem.get('name')] = false;
	      });
	    }
	
	    selected[name] = true;
	  },
	
	  /**
	   * @param {string} name
	   */
	  unSelect: function (name) {
	    if (this.get('selectedMode') !== 'single') {
	      this.option.selected[name] = false;
	    }
	  },
	
	  /**
	   * @param {string} name
	   */
	  toggleSelected: function (name) {
	    var selected = this.option.selected; // Default is true
	
	    if (!selected.hasOwnProperty(name)) {
	      selected[name] = true;
	    }
	
	    this[selected[name] ? 'unSelect' : 'select'](name);
	  },
	  allSelect: function () {
	    var data = this._data;
	    var selected = this.option.selected;
	    zrUtil.each(data, function (dataItem) {
	      selected[dataItem.get('name', true)] = true;
	    });
	  },
	  inverseSelect: function () {
	    var data = this._data;
	    var selected = this.option.selected;
	    zrUtil.each(data, function (dataItem) {
	      var name = dataItem.get('name', true); // Initially, default value is true
	
	      if (!selected.hasOwnProperty(name)) {
	        selected[name] = true;
	      }
	
	      selected[name] = !selected[name];
	    });
	  },
	
	  /**
	   * @param {string} name
	   */
	  isSelected: function (name) {
	    var selected = this.option.selected;
	    return !(selected.hasOwnProperty(name) && !selected[name]) && zrUtil.indexOf(this._availableNames, name) >= 0;
	  },
	  getOrient: function () {
	    return this.get('orient') === 'vertical' ? {
	      index: 1,
	      name: 'vertical'
	    } : {
	      index: 0,
	      name: 'horizontal'
	    };
	  },
	  defaultOption: {
	    // 一级层叠
	    zlevel: 0,
	    // 二级层叠
	    z: 4,
	    show: true,
	    // 布局方式，默认为水平布局，可选为：
	    // 'horizontal' | 'vertical'
	    orient: 'horizontal',
	    left: 'center',
	    // right: 'center',
	    top: 0,
	    // bottom: null,
	    // 水平对齐
	    // 'auto' | 'left' | 'right'
	    // 默认为 'auto', 根据 x 的位置判断是左对齐还是右对齐
	    align: 'auto',
	    backgroundColor: 'rgba(0,0,0,0)',
	    // 图例边框颜色
	    borderColor: '#ccc',
	    borderRadius: 0,
	    // 图例边框线宽，单位px，默认为0（无边框）
	    borderWidth: 0,
	    // 图例内边距，单位px，默认各方向内边距为5，
	    // 接受数组分别设定上右下左边距，同css
	    padding: 5,
	    // 各个item之间的间隔，单位px，默认为10，
	    // 横向布局时为水平间隔，纵向布局时为纵向间隔
	    itemGap: 10,
	    // the width of legend symbol
	    itemWidth: 25,
	    // the height of legend symbol
	    itemHeight: 14,
	    // the color of unselected legend symbol
	    inactiveColor: '#ccc',
	    // the borderColor of unselected legend symbol
	    inactiveBorderColor: '#ccc',
	    itemStyle: {
	      // the default borderWidth of legend symbol
	      borderWidth: 0
	    },
	    textStyle: {
	      // 图例文字颜色
	      color: '#333'
	    },
	    // formatter: '',
	    // 选择模式，默认开启图例开关
	    selectedMode: true,
	    // 配置默认选中状态，可配合LEGEND.SELECTED事件做动态数据载入
	    // selected: null,
	    // 图例内容（详见legend.data，数组中每一项代表一个item
	    // data: [],
	    // Usage:
	    // selector: [{type: 'all or inverse', title: xxx}]
	    // or
	    // selector: true
	    // or
	    // selector: ['all', 'inverse']
	    selector: false,
	    selectorLabel: {
	      show: true,
	      borderRadius: 10,
	      padding: [3, 5, 3, 5],
	      fontSize: 12,
	      fontFamily: ' sans-serif',
	      color: '#666',
	      borderWidth: 1,
	      borderColor: '#666'
	    },
	    emphasis: {
	      selectorLabel: {
	        show: true,
	        color: '#eee',
	        backgroundColor: '#666'
	      }
	    },
	    // Value can be 'start' or 'end'
	    selectorPosition: 'auto',
	    selectorItemGap: 7,
	    selectorButtonGap: 10,
	    // Tooltip 相关配置
	    tooltip: {
	      show: false
	    }
	  }
	});
	var _default = LegendModel;
	module.exports = _default;

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var _symbol = __webpack_require__(84);
	
	var createSymbol = _symbol.createSymbol;
	
	var graphic = __webpack_require__(16);
	
	var _listComponent = __webpack_require__(722);
	
	var makeBackground = _listComponent.makeBackground;
	
	var layoutUtil = __webpack_require__(36);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var curry = zrUtil.curry;
	var each = zrUtil.each;
	var Group = graphic.Group;
	
	var _default = echarts.extendComponentView({
	  type: 'legend.plain',
	  newlineDisabled: false,
	
	  /**
	   * @override
	   */
	  init: function () {
	    /**
	     * @private
	     * @type {module:zrender/container/Group}
	     */
	    this.group.add(this._contentGroup = new Group());
	    /**
	     * @private
	     * @type {module:zrender/Element}
	     */
	
	    this._backgroundEl;
	    /**
	     * @private
	     * @type {module:zrender/container/Group}
	     */
	
	    this.group.add(this._selectorGroup = new Group());
	    /**
	     * If first rendering, `contentGroup.position` is [0, 0], which
	     * does not make sense and may cause unexepcted animation if adopted.
	     * @private
	     * @type {boolean}
	     */
	
	    this._isFirstRender = true;
	  },
	
	  /**
	   * @protected
	   */
	  getContentGroup: function () {
	    return this._contentGroup;
	  },
	
	  /**
	   * @protected
	   */
	  getSelectorGroup: function () {
	    return this._selectorGroup;
	  },
	
	  /**
	   * @override
	   */
	  render: function (legendModel, ecModel, api) {
	    var isFirstRender = this._isFirstRender;
	    this._isFirstRender = false;
	    this.resetInner();
	
	    if (!legendModel.get('show', true)) {
	      return;
	    }
	
	    var itemAlign = legendModel.get('align');
	    var orient = legendModel.get('orient');
	
	    if (!itemAlign || itemAlign === 'auto') {
	      itemAlign = legendModel.get('left') === 'right' && orient === 'vertical' ? 'right' : 'left';
	    }
	
	    var selector = legendModel.get('selector', true);
	    var selectorPosition = legendModel.get('selectorPosition', true);
	
	    if (selector && (!selectorPosition || selectorPosition === 'auto')) {
	      selectorPosition = orient === 'horizontal' ? 'end' : 'start';
	    }
	
	    this.renderInner(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition); // Perform layout.
	
	    var positionInfo = legendModel.getBoxLayoutParams();
	    var viewportSize = {
	      width: api.getWidth(),
	      height: api.getHeight()
	    };
	    var padding = legendModel.get('padding');
	    var maxSize = layoutUtil.getLayoutRect(positionInfo, viewportSize, padding);
	    var mainRect = this.layoutInner(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition); // Place mainGroup, based on the calculated `mainRect`.
	
	    var layoutRect = layoutUtil.getLayoutRect(zrUtil.defaults({
	      width: mainRect.width,
	      height: mainRect.height
	    }, positionInfo), viewportSize, padding);
	    this.group.attr('position', [layoutRect.x - mainRect.x, layoutRect.y - mainRect.y]); // Render background after group is layout.
	
	    this.group.add(this._backgroundEl = makeBackground(mainRect, legendModel));
	  },
	
	  /**
	   * @protected
	   */
	  resetInner: function () {
	    this.getContentGroup().removeAll();
	    this._backgroundEl && this.group.remove(this._backgroundEl);
	    this.getSelectorGroup().removeAll();
	  },
	
	  /**
	   * @protected
	   */
	  renderInner: function (itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
	    var contentGroup = this.getContentGroup();
	    var legendDrawnMap = zrUtil.createHashMap();
	    var selectMode = legendModel.get('selectedMode');
	    var excludeSeriesId = [];
	    ecModel.eachRawSeries(function (seriesModel) {
	      !seriesModel.get('legendHoverLink') && excludeSeriesId.push(seriesModel.id);
	    });
	    each(legendModel.getData(), function (itemModel, dataIndex) {
	      var name = itemModel.get('name'); // Use empty string or \n as a newline string
	
	      if (!this.newlineDisabled && (name === '' || name === '\n')) {
	        contentGroup.add(new Group({
	          newline: true
	        }));
	        return;
	      } // Representitive series.
	
	
	      var seriesModel = ecModel.getSeriesByName(name)[0];
	
	      if (legendDrawnMap.get(name)) {
	        // Have been drawed
	        return;
	      } // Legend to control series.
	
	
	      if (seriesModel) {
	        var data = seriesModel.getData();
	        var color = data.getVisual('color');
	        var borderColor = data.getVisual('borderColor'); // If color is a callback function
	
	        if (typeof color === 'function') {
	          // Use the first data
	          color = color(seriesModel.getDataParams(0));
	        } // If borderColor is a callback function
	
	
	        if (typeof borderColor === 'function') {
	          // Use the first data
	          borderColor = borderColor(seriesModel.getDataParams(0));
	        } // Using rect symbol defaultly
	
	
	        var legendSymbolType = data.getVisual('legendSymbol') || 'roundRect';
	        var symbolType = data.getVisual('symbol');
	
	        var itemGroup = this._createItem(name, dataIndex, itemModel, legendModel, legendSymbolType, symbolType, itemAlign, color, borderColor, selectMode);
	
	        itemGroup.on('click', curry(dispatchSelectAction, name, null, api, excludeSeriesId)).on('mouseover', curry(dispatchHighlightAction, seriesModel.name, null, api, excludeSeriesId)).on('mouseout', curry(dispatchDownplayAction, seriesModel.name, null, api, excludeSeriesId));
	        legendDrawnMap.set(name, true);
	      } else {
	        // Legend to control data. In pie and funnel.
	        ecModel.eachRawSeries(function (seriesModel) {
	          // In case multiple series has same data name
	          if (legendDrawnMap.get(name)) {
	            return;
	          }
	
	          if (seriesModel.legendVisualProvider) {
	            var provider = seriesModel.legendVisualProvider;
	
	            if (!provider.containName(name)) {
	              return;
	            }
	
	            var idx = provider.indexOfName(name);
	            var color = provider.getItemVisual(idx, 'color');
	            var borderColor = provider.getItemVisual(idx, 'borderColor');
	            var legendSymbolType = 'roundRect';
	
	            var itemGroup = this._createItem(name, dataIndex, itemModel, legendModel, legendSymbolType, null, itemAlign, color, borderColor, selectMode); // FIXME: consider different series has items with the same name.
	
	
	            itemGroup.on('click', curry(dispatchSelectAction, null, name, api, excludeSeriesId)) // Should not specify the series name, consider legend controls
	            // more than one pie series.
	            .on('mouseover', curry(dispatchHighlightAction, null, name, api, excludeSeriesId)).on('mouseout', curry(dispatchDownplayAction, null, name, api, excludeSeriesId));
	            legendDrawnMap.set(name, true);
	          }
	        }, this);
	      }
	    }, this);
	
	    if (selector) {
	      this._createSelector(selector, legendModel, api, orient, selectorPosition);
	    }
	  },
	  _createSelector: function (selector, legendModel, api, orient, selectorPosition) {
	    var selectorGroup = this.getSelectorGroup();
	    each(selector, function (selectorItem) {
	      createSelectorButton(selectorItem);
	    });
	
	    function createSelectorButton(selectorItem) {
	      var type = selectorItem.type;
	      var labelText = new graphic.Text({
	        style: {
	          x: 0,
	          y: 0,
	          align: 'center',
	          verticalAlign: 'middle'
	        },
	        onclick: function () {
	          api.dispatchAction({
	            type: type === 'all' ? 'legendAllSelect' : 'legendInverseSelect'
	          });
	        }
	      });
	      selectorGroup.add(labelText);
	      var labelModel = legendModel.getModel('selectorLabel');
	      var emphasisLabelModel = legendModel.getModel('emphasis.selectorLabel');
	      graphic.setLabelStyle(labelText.style, labelText.hoverStyle = {}, labelModel, emphasisLabelModel, {
	        defaultText: selectorItem.title,
	        isRectText: false
	      });
	      graphic.setHoverStyle(labelText);
	    }
	  },
	  _createItem: function (name, dataIndex, itemModel, legendModel, legendSymbolType, symbolType, itemAlign, color, borderColor, selectMode) {
	    var itemWidth = legendModel.get('itemWidth');
	    var itemHeight = legendModel.get('itemHeight');
	    var inactiveColor = legendModel.get('inactiveColor');
	    var inactiveBorderColor = legendModel.get('inactiveBorderColor');
	    var symbolKeepAspect = legendModel.get('symbolKeepAspect');
	    var legendModelItemStyle = legendModel.getModel('itemStyle');
	    var isSelected = legendModel.isSelected(name);
	    var itemGroup = new Group();
	    var textStyleModel = itemModel.getModel('textStyle');
	    var itemIcon = itemModel.get('icon');
	    var tooltipModel = itemModel.getModel('tooltip');
	    var legendGlobalTooltipModel = tooltipModel.parentModel; // Use user given icon first
	
	    legendSymbolType = itemIcon || legendSymbolType;
	    var legendSymbol = createSymbol(legendSymbolType, 0, 0, itemWidth, itemHeight, isSelected ? color : inactiveColor, // symbolKeepAspect default true for legend
	    symbolKeepAspect == null ? true : symbolKeepAspect);
	    itemGroup.add(setSymbolStyle(legendSymbol, legendSymbolType, legendModelItemStyle, borderColor, inactiveBorderColor, isSelected)); // Compose symbols
	    // PENDING
	
	    if (!itemIcon && symbolType // At least show one symbol, can't be all none
	    && (symbolType !== legendSymbolType || symbolType === 'none')) {
	      var size = itemHeight * 0.8;
	
	      if (symbolType === 'none') {
	        symbolType = 'circle';
	      }
	
	      var legendSymbolCenter = createSymbol(symbolType, (itemWidth - size) / 2, (itemHeight - size) / 2, size, size, isSelected ? color : inactiveColor, // symbolKeepAspect default true for legend
	      symbolKeepAspect == null ? true : symbolKeepAspect); // Put symbol in the center
	
	      itemGroup.add(setSymbolStyle(legendSymbolCenter, symbolType, legendModelItemStyle, borderColor, inactiveBorderColor, isSelected));
	    }
	
	    var textX = itemAlign === 'left' ? itemWidth + 5 : -5;
	    var textAlign = itemAlign;
	    var formatter = legendModel.get('formatter');
	    var content = name;
	
	    if (typeof formatter === 'string' && formatter) {
	      content = formatter.replace('{name}', name != null ? name : '');
	    } else if (typeof formatter === 'function') {
	      content = formatter(name);
	    }
	
	    itemGroup.add(new graphic.Text({
	      style: graphic.setTextStyle({}, textStyleModel, {
	        text: content,
	        x: textX,
	        y: itemHeight / 2,
	        textFill: isSelected ? textStyleModel.getTextColor() : inactiveColor,
	        textAlign: textAlign,
	        textVerticalAlign: 'middle'
	      })
	    })); // Add a invisible rect to increase the area of mouse hover
	
	    var hitRect = new graphic.Rect({
	      shape: itemGroup.getBoundingRect(),
	      invisible: true,
	      tooltip: tooltipModel.get('show') ? zrUtil.extend({
	        content: name,
	        // Defaul formatter
	        formatter: legendGlobalTooltipModel.get('formatter', true) || function () {
	          return name;
	        },
	        formatterParams: {
	          componentType: 'legend',
	          legendIndex: legendModel.componentIndex,
	          name: name,
	          $vars: ['name']
	        }
	      }, tooltipModel.option) : null
	    });
	    itemGroup.add(hitRect);
	    itemGroup.eachChild(function (child) {
	      child.silent = true;
	    });
	    hitRect.silent = !selectMode;
	    this.getContentGroup().add(itemGroup);
	    graphic.setHoverStyle(itemGroup);
	    itemGroup.__legendDataIndex = dataIndex;
	    return itemGroup;
	  },
	
	  /**
	   * @protected
	   */
	  layoutInner: function (legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
	    var contentGroup = this.getContentGroup();
	    var selectorGroup = this.getSelectorGroup(); // Place items in contentGroup.
	
	    layoutUtil.box(legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), maxSize.width, maxSize.height);
	    var contentRect = contentGroup.getBoundingRect();
	    var contentPos = [-contentRect.x, -contentRect.y];
	
	    if (selector) {
	      // Place buttons in selectorGroup
	      layoutUtil.box( // Buttons in selectorGroup always layout horizontally
	      'horizontal', selectorGroup, legendModel.get('selectorItemGap', true));
	      var selectorRect = selectorGroup.getBoundingRect();
	      var selectorPos = [-selectorRect.x, -selectorRect.y];
	      var selectorButtonGap = legendModel.get('selectorButtonGap', true);
	      var orientIdx = legendModel.getOrient().index;
	      var wh = orientIdx === 0 ? 'width' : 'height';
	      var hw = orientIdx === 0 ? 'height' : 'width';
	      var yx = orientIdx === 0 ? 'y' : 'x';
	
	      if (selectorPosition === 'end') {
	        selectorPos[orientIdx] += contentRect[wh] + selectorButtonGap;
	      } else {
	        contentPos[orientIdx] += selectorRect[wh] + selectorButtonGap;
	      } //Always align selector to content as 'middle'
	
	
	      selectorPos[1 - orientIdx] += contentRect[hw] / 2 - selectorRect[hw] / 2;
	      selectorGroup.attr('position', selectorPos);
	      contentGroup.attr('position', contentPos);
	      var mainRect = {
	        x: 0,
	        y: 0
	      };
	      mainRect[wh] = contentRect[wh] + selectorButtonGap + selectorRect[wh];
	      mainRect[hw] = Math.max(contentRect[hw], selectorRect[hw]);
	      mainRect[yx] = Math.min(0, selectorRect[yx] + selectorPos[1 - orientIdx]);
	      return mainRect;
	    } else {
	      contentGroup.attr('position', contentPos);
	      return this.group.getBoundingRect();
	    }
	  },
	
	  /**
	   * @protected
	   */
	  remove: function () {
	    this.getContentGroup().removeAll();
	    this._isFirstRender = true;
	  }
	});
	
	function setSymbolStyle(symbol, symbolType, legendModelItemStyle, borderColor, inactiveBorderColor, isSelected) {
	  var itemStyle;
	
	  if (symbolType !== 'line' && symbolType.indexOf('empty') < 0) {
	    itemStyle = legendModelItemStyle.getItemStyle();
	    symbol.style.stroke = borderColor;
	
	    if (!isSelected) {
	      itemStyle.stroke = inactiveBorderColor;
	    }
	  } else {
	    itemStyle = legendModelItemStyle.getItemStyle(['borderWidth', 'borderColor']);
	  }
	
	  return symbol.setStyle(itemStyle);
	}
	
	function dispatchSelectAction(seriesName, dataName, api, excludeSeriesId) {
	  // downplay before unselect
	  dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId);
	  api.dispatchAction({
	    type: 'legendToggleSelect',
	    name: seriesName != null ? seriesName : dataName
	  }); // highlight after select
	
	  dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId);
	}
	
	function dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId) {
	  // If element hover will move to a hoverLayer.
	  var el = api.getZr().storage.getDisplayList()[0];
	
	  if (!(el && el.useHoverLayer)) {
	    api.dispatchAction({
	      type: 'highlight',
	      seriesName: seriesName,
	      name: dataName,
	      excludeSeriesId: excludeSeriesId
	    });
	  }
	}
	
	function dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId) {
	  // If element hover will move to a hoverLayer.
	  var el = api.getZr().storage.getDisplayList()[0];
	
	  if (!(el && el.useHoverLayer)) {
	    api.dispatchAction({
	      type: 'downplay',
	      seriesName: seriesName,
	      name: dataName,
	      excludeSeriesId: excludeSeriesId
	    });
	  }
	}
	
	module.exports = _default;

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var throttleUtil = __webpack_require__(142);
	
	var parallelPreprocessor = __webpack_require__(1673);
	
	__webpack_require__(742);
	
	__webpack_require__(1672);
	
	__webpack_require__(1617);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var CLICK_THRESHOLD = 5; // > 4
	// Parallel view
	
	echarts.extendComponentView({
	  type: 'parallel',
	  render: function (parallelModel, ecModel, api) {
	    this._model = parallelModel;
	    this._api = api;
	
	    if (!this._handlers) {
	      this._handlers = {};
	      zrUtil.each(handlers, function (handler, eventName) {
	        api.getZr().on(eventName, this._handlers[eventName] = zrUtil.bind(handler, this));
	      }, this);
	    }
	
	    throttleUtil.createOrUpdate(this, '_throttledDispatchExpand', parallelModel.get('axisExpandRate'), 'fixRate');
	  },
	  dispose: function (ecModel, api) {
	    zrUtil.each(this._handlers, function (handler, eventName) {
	      api.getZr().off(eventName, handler);
	    });
	    this._handlers = null;
	  },
	
	  /**
	   * @param {Object} [opt] If null, cancle the last action triggering for debounce.
	   */
	  _throttledDispatchExpand: function (opt) {
	    this._dispatchExpand(opt);
	  },
	  _dispatchExpand: function (opt) {
	    opt && this._api.dispatchAction(zrUtil.extend({
	      type: 'parallelAxisExpand'
	    }, opt));
	  }
	});
	var handlers = {
	  mousedown: function (e) {
	    if (checkTrigger(this, 'click')) {
	      this._mouseDownPoint = [e.offsetX, e.offsetY];
	    }
	  },
	  mouseup: function (e) {
	    var mouseDownPoint = this._mouseDownPoint;
	
	    if (checkTrigger(this, 'click') && mouseDownPoint) {
	      var point = [e.offsetX, e.offsetY];
	      var dist = Math.pow(mouseDownPoint[0] - point[0], 2) + Math.pow(mouseDownPoint[1] - point[1], 2);
	
	      if (dist > CLICK_THRESHOLD) {
	        return;
	      }
	
	      var result = this._model.coordinateSystem.getSlidedAxisExpandWindow([e.offsetX, e.offsetY]);
	
	      result.behavior !== 'none' && this._dispatchExpand({
	        axisExpandWindow: result.axisExpandWindow
	      });
	    }
	
	    this._mouseDownPoint = null;
	  },
	  mousemove: function (e) {
	    // Should do nothing when brushing.
	    if (this._mouseDownPoint || !checkTrigger(this, 'mousemove')) {
	      return;
	    }
	
	    var model = this._model;
	    var result = model.coordinateSystem.getSlidedAxisExpandWindow([e.offsetX, e.offsetY]);
	    var behavior = result.behavior;
	    behavior === 'jump' && this._throttledDispatchExpand.debounceNextCall(model.get('axisExpandDebounce'));
	
	    this._throttledDispatchExpand(behavior === 'none' ? null // Cancle the last trigger, in case that mouse slide out of the area quickly.
	    : {
	      axisExpandWindow: result.axisExpandWindow,
	      // Jumping uses animation, and sliding suppresses animation.
	      animation: behavior === 'jump' ? null : false
	    });
	  }
	};
	
	function checkTrigger(view, triggerOn) {
	  var model = view._model;
	  return model.get('axisExpandable') && model.get('axisExpandTriggerOn') === triggerOn;
	}
	
	echarts.registerPreprocessor(parallelPreprocessor);

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	__webpack_require__(1687);
	
	__webpack_require__(1573);
	
	__webpack_require__(1683);
	
	__webpack_require__(260);
	
	__webpack_require__(1578);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.extendComponentView({
	  type: 'single'
	});

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var env = __webpack_require__(55);
	
	var visualDefault = __webpack_require__(753);
	
	var VisualMapping = __webpack_require__(168);
	
	var visualSolution = __webpack_require__(342);
	
	var modelUtil = __webpack_require__(24);
	
	var numberUtil = __webpack_require__(20);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var mapVisual = VisualMapping.mapVisual;
	var eachVisual = VisualMapping.eachVisual;
	var isArray = zrUtil.isArray;
	var each = zrUtil.each;
	var asc = numberUtil.asc;
	var linearMap = numberUtil.linearMap;
	var noop = zrUtil.noop;
	var VisualMapModel = echarts.extendComponentModel({
	  type: 'visualMap',
	  dependencies: ['series'],
	
	  /**
	   * @readOnly
	   * @type {Array.<string>}
	   */
	  stateList: ['inRange', 'outOfRange'],
	
	  /**
	   * @readOnly
	   * @type {Array.<string>}
	   */
	  replacableOptionKeys: ['inRange', 'outOfRange', 'target', 'controller', 'color'],
	
	  /**
	   * [lowerBound, upperBound]
	   *
	   * @readOnly
	   * @type {Array.<number>}
	   */
	  dataBound: [-Infinity, Infinity],
	
	  /**
	   * @readOnly
	   * @type {string|Object}
	   */
	  layoutMode: {
	    type: 'box',
	    ignoreSize: true
	  },
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    show: true,
	    zlevel: 0,
	    z: 4,
	    seriesIndex: 'all',
	    // 'all' or null/undefined: all series.
	    // A number or an array of number: the specified series.
	    // set min: 0, max: 200, only for campatible with ec2.
	    // In fact min max should not have default value.
	    min: 0,
	    // min value, must specified if pieces is not specified.
	    max: 200,
	    // max value, must specified if pieces is not specified.
	    dimension: null,
	    inRange: null,
	    // 'color', 'colorHue', 'colorSaturation', 'colorLightness', 'colorAlpha',
	    // 'symbol', 'symbolSize'
	    outOfRange: null,
	    // 'color', 'colorHue', 'colorSaturation',
	    // 'colorLightness', 'colorAlpha',
	    // 'symbol', 'symbolSize'
	    left: 0,
	    // 'center' ¦ 'left' ¦ 'right' ¦ {number} (px)
	    right: null,
	    // The same as left.
	    top: null,
	    // 'top' ¦ 'bottom' ¦ 'center' ¦ {number} (px)
	    bottom: 0,
	    // The same as top.
	    itemWidth: null,
	    itemHeight: null,
	    inverse: false,
	    orient: 'vertical',
	    // 'horizontal' ¦ 'vertical'
	    backgroundColor: 'rgba(0,0,0,0)',
	    borderColor: '#ccc',
	    // 值域边框颜色
	    contentColor: '#5793f3',
	    inactiveColor: '#aaa',
	    borderWidth: 0,
	    // 值域边框线宽，单位px，默认为0（无边框）
	    padding: 5,
	    // 值域内边距，单位px，默认各方向内边距为5，
	    // 接受数组分别设定上右下左边距，同css
	    textGap: 10,
	    //
	    precision: 0,
	    // 小数精度，默认为0，无小数点
	    color: null,
	    //颜色（deprecated，兼容ec2，顺序同pieces，不同于inRange/outOfRange）
	    formatter: null,
	    text: null,
	    // 文本，如['高', '低']，兼容ec2，text[0]对应高值，text[1]对应低值
	    textStyle: {
	      color: '#333' // 值域文字颜色
	
	    }
	  },
	
	  /**
	   * @protected
	   */
	  init: function (option, parentModel, ecModel) {
	    /**
	     * @private
	     * @type {Array.<number>}
	     */
	    this._dataExtent;
	    /**
	     * @readOnly
	     */
	
	    this.targetVisuals = {};
	    /**
	     * @readOnly
	     */
	
	    this.controllerVisuals = {};
	    /**
	     * @readOnly
	     */
	
	    this.textStyleModel;
	    /**
	     * [width, height]
	     * @readOnly
	     * @type {Array.<number>}
	     */
	
	    this.itemSize;
	    this.mergeDefaultAndTheme(option, ecModel);
	  },
	
	  /**
	   * @protected
	   */
	  optionUpdated: function (newOption, isInit) {
	    var thisOption = this.option; // FIXME
	    // necessary?
	    // Disable realtime view update if canvas is not supported.
	
	    if (!env.canvasSupported) {
	      thisOption.realtime = false;
	    }
	
	    !isInit && visualSolution.replaceVisualOption(thisOption, newOption, this.replacableOptionKeys);
	    this.textStyleModel = this.getModel('textStyle');
	    this.resetItemSize();
	    this.completeVisualOption();
	  },
	
	  /**
	   * @protected
	   */
	  resetVisual: function (supplementVisualOption) {
	    var stateList = this.stateList;
	    supplementVisualOption = zrUtil.bind(supplementVisualOption, this);
	    this.controllerVisuals = visualSolution.createVisualMappings(this.option.controller, stateList, supplementVisualOption);
	    this.targetVisuals = visualSolution.createVisualMappings(this.option.target, stateList, supplementVisualOption);
	  },
	
	  /**
	   * @protected
	   * @return {Array.<number>} An array of series indices.
	   */
	  getTargetSeriesIndices: function () {
	    var optionSeriesIndex = this.option.seriesIndex;
	    var seriesIndices = [];
	
	    if (optionSeriesIndex == null || optionSeriesIndex === 'all') {
	      this.ecModel.eachSeries(function (seriesModel, index) {
	        seriesIndices.push(index);
	      });
	    } else {
	      seriesIndices = modelUtil.normalizeToArray(optionSeriesIndex);
	    }
	
	    return seriesIndices;
	  },
	
	  /**
	   * @public
	   */
	  eachTargetSeries: function (callback, context) {
	    zrUtil.each(this.getTargetSeriesIndices(), function (seriesIndex) {
	      callback.call(context, this.ecModel.getSeriesByIndex(seriesIndex));
	    }, this);
	  },
	
	  /**
	   * @pubilc
	   */
	  isTargetSeries: function (seriesModel) {
	    var is = false;
	    this.eachTargetSeries(function (model) {
	      model === seriesModel && (is = true);
	    });
	    return is;
	  },
	
	  /**
	   * @example
	   * this.formatValueText(someVal); // format single numeric value to text.
	   * this.formatValueText(someVal, true); // format single category value to text.
	   * this.formatValueText([min, max]); // format numeric min-max to text.
	   * this.formatValueText([this.dataBound[0], max]); // using data lower bound.
	   * this.formatValueText([min, this.dataBound[1]]); // using data upper bound.
	   *
	   * @param {number|Array.<number>} value Real value, or this.dataBound[0 or 1].
	   * @param {boolean} [isCategory=false] Only available when value is number.
	   * @param {Array.<string>} edgeSymbols Open-close symbol when value is interval.
	   * @return {string}
	   * @protected
	   */
	  formatValueText: function (value, isCategory, edgeSymbols) {
	    var option = this.option;
	    var precision = option.precision;
	    var dataBound = this.dataBound;
	    var formatter = option.formatter;
	    var isMinMax;
	    var textValue;
	    edgeSymbols = edgeSymbols || ['<', '>'];
	
	    if (zrUtil.isArray(value)) {
	      value = value.slice();
	      isMinMax = true;
	    }
	
	    textValue = isCategory ? value : isMinMax ? [toFixed(value[0]), toFixed(value[1])] : toFixed(value);
	
	    if (zrUtil.isString(formatter)) {
	      return formatter.replace('{value}', isMinMax ? textValue[0] : textValue).replace('{value2}', isMinMax ? textValue[1] : textValue);
	    } else if (zrUtil.isFunction(formatter)) {
	      return isMinMax ? formatter(value[0], value[1]) : formatter(value);
	    }
	
	    if (isMinMax) {
	      if (value[0] === dataBound[0]) {
	        return edgeSymbols[0] + ' ' + textValue[1];
	      } else if (value[1] === dataBound[1]) {
	        return edgeSymbols[1] + ' ' + textValue[0];
	      } else {
	        return textValue[0] + ' - ' + textValue[1];
	      }
	    } else {
	      // Format single value (includes category case).
	      return textValue;
	    }
	
	    function toFixed(val) {
	      return val === dataBound[0] ? 'min' : val === dataBound[1] ? 'max' : (+val).toFixed(Math.min(precision, 20));
	    }
	  },
	
	  /**
	   * @protected
	   */
	  resetExtent: function () {
	    var thisOption = this.option; // Can not calculate data extent by data here.
	    // Because series and data may be modified in processing stage.
	    // So we do not support the feature "auto min/max".
	
	    var extent = asc([thisOption.min, thisOption.max]);
	    this._dataExtent = extent;
	  },
	
	  /**
	   * @public
	   * @param {module:echarts/data/List} list
	   * @return {string} Concrete dimention. If return null/undefined,
	   *                  no dimension used.
	   */
	  getDataDimension: function (list) {
	    var optDim = this.option.dimension;
	    var listDimensions = list.dimensions;
	
	    if (optDim == null && !listDimensions.length) {
	      return;
	    }
	
	    if (optDim != null) {
	      return list.getDimension(optDim);
	    }
	
	    var dimNames = list.dimensions;
	
	    for (var i = dimNames.length - 1; i >= 0; i--) {
	      var dimName = dimNames[i];
	      var dimInfo = list.getDimensionInfo(dimName);
	
	      if (!dimInfo.isCalculationCoord) {
	        return dimName;
	      }
	    }
	  },
	
	  /**
	   * @public
	   * @override
	   */
	  getExtent: function () {
	    return this._dataExtent.slice();
	  },
	
	  /**
	   * @protected
	   */
	  completeVisualOption: function () {
	    var ecModel = this.ecModel;
	    var thisOption = this.option;
	    var base = {
	      inRange: thisOption.inRange,
	      outOfRange: thisOption.outOfRange
	    };
	    var target = thisOption.target || (thisOption.target = {});
	    var controller = thisOption.controller || (thisOption.controller = {});
	    zrUtil.merge(target, base); // Do not override
	
	    zrUtil.merge(controller, base); // Do not override
	
	    var isCategory = this.isCategory();
	    completeSingle.call(this, target);
	    completeSingle.call(this, controller);
	    completeInactive.call(this, target, 'inRange', 'outOfRange'); // completeInactive.call(this, target, 'outOfRange', 'inRange');
	
	    completeController.call(this, controller);
	
	    function completeSingle(base) {
	      // Compatible with ec2 dataRange.color.
	      // The mapping order of dataRange.color is: [high value, ..., low value]
	      // whereas inRange.color and outOfRange.color is [low value, ..., high value]
	      // Notice: ec2 has no inverse.
	      if (isArray(thisOption.color) // If there has been inRange: {symbol: ...}, adding color is a mistake.
	      // So adding color only when no inRange defined.
	      && !base.inRange) {
	        base.inRange = {
	          color: thisOption.color.slice().reverse()
	        };
	      } // Compatible with previous logic, always give a defautl color, otherwise
	      // simple config with no inRange and outOfRange will not work.
	      // Originally we use visualMap.color as the default color, but setOption at
	      // the second time the default color will be erased. So we change to use
	      // constant DEFAULT_COLOR.
	      // If user do not want the default color, set inRange: {color: null}.
	
	
	      base.inRange = base.inRange || {
	        color: ecModel.get('gradientColor')
	      }; // If using shortcut like: {inRange: 'symbol'}, complete default value.
	
	      each(this.stateList, function (state) {
	        var visualType = base[state];
	
	        if (zrUtil.isString(visualType)) {
	          var defa = visualDefault.get(visualType, 'active', isCategory);
	
	          if (defa) {
	            base[state] = {};
	            base[state][visualType] = defa;
	          } else {
	            // Mark as not specified.
	            delete base[state];
	          }
	        }
	      }, this);
	    }
	
	    function completeInactive(base, stateExist, stateAbsent) {
	      var optExist = base[stateExist];
	      var optAbsent = base[stateAbsent];
	
	      if (optExist && !optAbsent) {
	        optAbsent = base[stateAbsent] = {};
	        each(optExist, function (visualData, visualType) {
	          if (!VisualMapping.isValidType(visualType)) {
	            return;
	          }
	
	          var defa = visualDefault.get(visualType, 'inactive', isCategory);
	
	          if (defa != null) {
	            optAbsent[visualType] = defa; // Compatibable with ec2:
	            // Only inactive color to rgba(0,0,0,0) can not
	            // make label transparent, so use opacity also.
	
	            if (visualType === 'color' && !optAbsent.hasOwnProperty('opacity') && !optAbsent.hasOwnProperty('colorAlpha')) {
	              optAbsent.opacity = [0, 0];
	            }
	          }
	        });
	      }
	    }
	
	    function completeController(controller) {
	      var symbolExists = (controller.inRange || {}).symbol || (controller.outOfRange || {}).symbol;
	      var symbolSizeExists = (controller.inRange || {}).symbolSize || (controller.outOfRange || {}).symbolSize;
	      var inactiveColor = this.get('inactiveColor');
	      each(this.stateList, function (state) {
	        var itemSize = this.itemSize;
	        var visuals = controller[state]; // Set inactive color for controller if no other color
	        // attr (like colorAlpha) specified.
	
	        if (!visuals) {
	          visuals = controller[state] = {
	            color: isCategory ? inactiveColor : [inactiveColor]
	          };
	        } // Consistent symbol and symbolSize if not specified.
	
	
	        if (visuals.symbol == null) {
	          visuals.symbol = symbolExists && zrUtil.clone(symbolExists) || (isCategory ? 'roundRect' : ['roundRect']);
	        }
	
	        if (visuals.symbolSize == null) {
	          visuals.symbolSize = symbolSizeExists && zrUtil.clone(symbolSizeExists) || (isCategory ? itemSize[0] : [itemSize[0], itemSize[0]]);
	        } // Filter square and none.
	
	
	        visuals.symbol = mapVisual(visuals.symbol, function (symbol) {
	          return symbol === 'none' || symbol === 'square' ? 'roundRect' : symbol;
	        }); // Normalize symbolSize
	
	        var symbolSize = visuals.symbolSize;
	
	        if (symbolSize != null) {
	          var max = -Infinity; // symbolSize can be object when categories defined.
	
	          eachVisual(symbolSize, function (value) {
	            value > max && (max = value);
	          });
	          visuals.symbolSize = mapVisual(symbolSize, function (value) {
	            return linearMap(value, [0, max], [0, itemSize[0]], true);
	          });
	        }
	      }, this);
	    }
	  },
	
	  /**
	   * @protected
	   */
	  resetItemSize: function () {
	    this.itemSize = [parseFloat(this.get('itemWidth')), parseFloat(this.get('itemHeight'))];
	  },
	
	  /**
	   * @public
	   */
	  isCategory: function () {
	    return !!this.option.categories;
	  },
	
	  /**
	   * @public
	   * @abstract
	   */
	  setSelected: noop,
	
	  /**
	   * @public
	   * @abstract
	   * @param {*|module:echarts/data/List} valueOrData
	   * @param {number} dataIndex
	   * @return {string} state See this.stateList
	   */
	  getValueState: noop,
	
	  /**
	   * FIXME
	   * Do not publish to thirt-part-dev temporarily
	   * util the interface is stable. (Should it return
	   * a function but not visual meta?)
	   *
	   * @pubilc
	   * @abstract
	   * @param {Function} getColorVisual
	   *        params: value, valueState
	   *        return: color
	   * @return {Object} visualMeta
	   *        should includes {stops, outerColors}
	   *        outerColor means [colorBeyondMinValue, colorBeyondMaxValue]
	   */
	  getVisualMeta: noop
	});
	var _default = VisualMapModel;
	module.exports = _default;

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var graphic = __webpack_require__(16);
	
	var formatUtil = __webpack_require__(40);
	
	var layout = __webpack_require__(36);
	
	var VisualMapping = __webpack_require__(168);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentView({
	  type: 'visualMap',
	
	  /**
	   * @readOnly
	   * @type {Object}
	   */
	  autoPositionValues: {
	    left: 1,
	    right: 1,
	    top: 1,
	    bottom: 1
	  },
	  init: function (ecModel, api) {
	    /**
	     * @readOnly
	     * @type {module:echarts/model/Global}
	     */
	    this.ecModel = ecModel;
	    /**
	     * @readOnly
	     * @type {module:echarts/ExtensionAPI}
	     */
	
	    this.api = api;
	    /**
	     * @readOnly
	     * @type {module:echarts/component/visualMap/visualMapModel}
	     */
	
	    this.visualMapModel;
	  },
	
	  /**
	   * @protected
	   */
	  render: function (visualMapModel, ecModel, api, payload) {
	    this.visualMapModel = visualMapModel;
	
	    if (visualMapModel.get('show') === false) {
	      this.group.removeAll();
	      return;
	    }
	
	    this.doRender.apply(this, arguments);
	  },
	
	  /**
	   * @protected
	   */
	  renderBackground: function (group) {
	    var visualMapModel = this.visualMapModel;
	    var padding = formatUtil.normalizeCssArray(visualMapModel.get('padding') || 0);
	    var rect = group.getBoundingRect();
	    group.add(new graphic.Rect({
	      z2: -1,
	      // Lay background rect on the lowest layer.
	      silent: true,
	      shape: {
	        x: rect.x - padding[3],
	        y: rect.y - padding[0],
	        width: rect.width + padding[3] + padding[1],
	        height: rect.height + padding[0] + padding[2]
	      },
	      style: {
	        fill: visualMapModel.get('backgroundColor'),
	        stroke: visualMapModel.get('borderColor'),
	        lineWidth: visualMapModel.get('borderWidth')
	      }
	    }));
	  },
	
	  /**
	   * @protected
	   * @param {number} targetValue can be Infinity or -Infinity
	   * @param {string=} visualCluster Only can be 'color' 'opacity' 'symbol' 'symbolSize'
	   * @param {Object} [opts]
	   * @param {string=} [opts.forceState] Specify state, instead of using getValueState method.
	   * @param {string=} [opts.convertOpacityToAlpha=false] For color gradient in controller widget.
	   * @return {*} Visual value.
	   */
	  getControllerVisual: function (targetValue, visualCluster, opts) {
	    opts = opts || {};
	    var forceState = opts.forceState;
	    var visualMapModel = this.visualMapModel;
	    var visualObj = {}; // Default values.
	
	    if (visualCluster === 'symbol') {
	      visualObj.symbol = visualMapModel.get('itemSymbol');
	    }
	
	    if (visualCluster === 'color') {
	      var defaultColor = visualMapModel.get('contentColor');
	      visualObj.color = defaultColor;
	    }
	
	    function getter(key) {
	      return visualObj[key];
	    }
	
	    function setter(key, value) {
	      visualObj[key] = value;
	    }
	
	    var mappings = visualMapModel.controllerVisuals[forceState || visualMapModel.getValueState(targetValue)];
	    var visualTypes = VisualMapping.prepareVisualTypes(mappings);
	    zrUtil.each(visualTypes, function (type) {
	      var visualMapping = mappings[type];
	
	      if (opts.convertOpacityToAlpha && type === 'opacity') {
	        type = 'colorAlpha';
	        visualMapping = mappings.__alphaForOpacity;
	      }
	
	      if (VisualMapping.dependsOn(type, visualCluster)) {
	        visualMapping && visualMapping.applyVisual(targetValue, getter, setter);
	      }
	    });
	    return visualObj[visualCluster];
	  },
	
	  /**
	   * @protected
	   */
	  positionGroup: function (group) {
	    var model = this.visualMapModel;
	    var api = this.api;
	    layout.positionElement(group, model.getBoxLayoutParams(), {
	      width: api.getWidth(),
	      height: api.getHeight()
	    });
	  },
	
	  /**
	   * @protected
	   * @abstract
	   */
	  doRender: zrUtil.noop
	});
	
	module.exports = _default;

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var _layout = __webpack_require__(36);
	
	var getLayoutRect = _layout.getLayoutRect;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {module:echarts/component/visualMap/VisualMapModel} visualMapModel\
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {Array.<number>} itemSize always [short, long]
	 * @return {string} 'left' or 'right' or 'top' or 'bottom'
	 */
	function getItemAlign(visualMapModel, api, itemSize) {
	  var modelOption = visualMapModel.option;
	  var itemAlign = modelOption.align;
	
	  if (itemAlign != null && itemAlign !== 'auto') {
	    return itemAlign;
	  } // Auto decision align.
	
	
	  var ecSize = {
	    width: api.getWidth(),
	    height: api.getHeight()
	  };
	  var realIndex = modelOption.orient === 'horizontal' ? 1 : 0;
	  var paramsSet = [['left', 'right', 'width'], ['top', 'bottom', 'height']];
	  var reals = paramsSet[realIndex];
	  var fakeValue = [0, null, 10];
	  var layoutInput = {};
	
	  for (var i = 0; i < 3; i++) {
	    layoutInput[paramsSet[1 - realIndex][i]] = fakeValue[i];
	    layoutInput[reals[i]] = i === 2 ? itemSize[0] : modelOption[reals[i]];
	  }
	
	  var rParam = [['x', 'width', 3], ['y', 'height', 0]][realIndex];
	  var rect = getLayoutRect(layoutInput, ecSize, modelOption.padding);
	  return reals[(rect.margin[rParam[2]] || 0) + rect[rParam[0]] + rect[rParam[1]] * 0.5 < ecSize[rParam[1]] * 0.5 ? 0 : 1];
	}
	/**
	 * Prepare dataIndex for outside usage, where dataIndex means rawIndex, and
	 * dataIndexInside means filtered index.
	 */
	
	
	function makeHighDownBatch(batch, visualMapModel) {
	  zrUtil.each(batch || [], function (batchItem) {
	    if (batchItem.dataIndex != null) {
	      batchItem.dataIndexInside = batchItem.dataIndex;
	      batchItem.dataIndex = null;
	    }
	
	    batchItem.highlightKey = 'visualMap' + (visualMapModel ? visualMapModel.componentIndex : '');
	  });
	  return batch;
	}
	
	exports.getItemAlign = getItemAlign;
	exports.makeHighDownBatch = makeHighDownBatch;

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	
	function _default(option) {
	  var visualMap = option && option.visualMap;
	
	  if (!zrUtil.isArray(visualMap)) {
	    visualMap = visualMap ? [visualMap] : [];
	  }
	
	  each(visualMap, function (opt) {
	    if (!opt) {
	      return;
	    } // rename splitList to pieces
	
	
	    if (has(opt, 'splitList') && !has(opt, 'pieces')) {
	      opt.pieces = opt.splitList;
	      delete opt.splitList;
	    }
	
	    var pieces = opt.pieces;
	
	    if (pieces && zrUtil.isArray(pieces)) {
	      each(pieces, function (piece) {
	        if (zrUtil.isObject(piece)) {
	          if (has(piece, 'start') && !has(piece, 'min')) {
	            piece.min = piece.start;
	          }
	
	          if (has(piece, 'end') && !has(piece, 'max')) {
	            piece.max = piece.end;
	          }
	        }
	      });
	    }
	  });
	}
	
	function has(obj, name) {
	  return obj && obj.hasOwnProperty && obj.hasOwnProperty(name);
	}
	
	module.exports = _default;

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Component = __webpack_require__(57);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	Component.registerSubTypeDefaulter('visualMap', function (option) {
	  // Compatible with ec2, when splitNumber === 0, continuous visualMap will be used.
	  return !option.categories && (!(option.pieces ? option.pieces.length > 0 : option.splitNumber > 0) || option.calculable) ? 'continuous' : 'piecewise';
	});

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var visualSolution = __webpack_require__(342);
	
	var VisualMapping = __webpack_require__(168);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var VISUAL_PRIORITY = echarts.PRIORITY.VISUAL.COMPONENT;
	echarts.registerVisual(VISUAL_PRIORITY, {
	  createOnAllSeries: true,
	  reset: function (seriesModel, ecModel) {
	    var resetDefines = [];
	    ecModel.eachComponent('visualMap', function (visualMapModel) {
	      var pipelineContext = seriesModel.pipelineContext;
	
	      if (!visualMapModel.isTargetSeries(seriesModel) || pipelineContext && pipelineContext.large) {
	        return;
	      }
	
	      resetDefines.push(visualSolution.incrementalApplyVisual(visualMapModel.stateList, visualMapModel.targetVisuals, zrUtil.bind(visualMapModel.getValueState, visualMapModel), visualMapModel.getDataDimension(seriesModel.getData())));
	    });
	    return resetDefines;
	  }
	}); // Only support color.
	
	echarts.registerVisual(VISUAL_PRIORITY, {
	  createOnAllSeries: true,
	  reset: function (seriesModel, ecModel) {
	    var data = seriesModel.getData();
	    var visualMetaList = [];
	    ecModel.eachComponent('visualMap', function (visualMapModel) {
	      if (visualMapModel.isTargetSeries(seriesModel)) {
	        var visualMeta = visualMapModel.getVisualMeta(zrUtil.bind(getColorVisual, null, seriesModel, visualMapModel)) || {
	          stops: [],
	          outerColors: []
	        };
	        var concreteDim = visualMapModel.getDataDimension(data);
	        var dimInfo = data.getDimensionInfo(concreteDim);
	
	        if (dimInfo != null) {
	          // visualMeta.dimension should be dimension index, but not concrete dimension.
	          visualMeta.dimension = dimInfo.index;
	          visualMetaList.push(visualMeta);
	        }
	      }
	    }); // console.log(JSON.stringify(visualMetaList.map(a => a.stops)));
	
	    seriesModel.getData().setVisual('visualMeta', visualMetaList);
	  }
	}); // FIXME
	// performance and export for heatmap?
	// value can be Infinity or -Infinity
	
	function getColorVisual(seriesModel, visualMapModel, value, valueState) {
	  var mappings = visualMapModel.targetVisuals[valueState];
	  var visualTypes = VisualMapping.prepareVisualTypes(mappings);
	  var resultVisual = {
	    color: seriesModel.getData().getVisual('color') // default color.
	
	  };
	
	  for (var i = 0, len = visualTypes.length; i < len; i++) {
	    var type = visualTypes[i];
	    var mapping = mappings[type === 'opacity' ? '__alphaForOpacity' : type];
	    mapping && mapping.applyVisual(value, getVisual, setVisual);
	  }
	
	  return resultVisual.color;
	
	  function getVisual(key) {
	    return resultVisual[key];
	  }
	
	  function setVisual(key, value) {
	    resultVisual[key] = value;
	  }
	}

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var actionInfo = {
	  type: 'selectDataRange',
	  event: 'dataRangeSelected',
	  // FIXME use updateView appears wrong
	  update: 'update'
	};
	echarts.registerAction(actionInfo, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'visualMap',
	    query: payload
	  }, function (model) {
	    model.setSelected(payload.selected);
	  });
	});

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var preprocessor = __webpack_require__(731);
	
	__webpack_require__(732);
	
	__webpack_require__(733);
	
	__webpack_require__(1647);
	
	__webpack_require__(1648);
	
	__webpack_require__(734);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * DataZoom component entry
	 */
	echarts.registerPreprocessor(preprocessor);

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var preprocessor = __webpack_require__(731);
	
	__webpack_require__(732);
	
	__webpack_require__(733);
	
	__webpack_require__(1649);
	
	__webpack_require__(1650);
	
	__webpack_require__(734);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * DataZoom component entry
	 */
	echarts.registerPreprocessor(preprocessor);

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var defaultOption = {
	  show: true,
	  zlevel: 0,
	  z: 0,
	  // Inverse the axis.
	  inverse: false,
	  // Axis name displayed.
	  name: '',
	  // 'start' | 'middle' | 'end'
	  nameLocation: 'end',
	  // By degree. By default auto rotate by nameLocation.
	  nameRotate: null,
	  nameTruncate: {
	    maxWidth: null,
	    ellipsis: '...',
	    placeholder: '.'
	  },
	  // Use global text style by default.
	  nameTextStyle: {},
	  // The gap between axisName and axisLine.
	  nameGap: 15,
	  // Default `false` to support tooltip.
	  silent: false,
	  // Default `false` to avoid legacy user event listener fail.
	  triggerEvent: false,
	  tooltip: {
	    show: false
	  },
	  axisPointer: {},
	  axisLine: {
	    show: true,
	    onZero: true,
	    onZeroAxisIndex: null,
	    lineStyle: {
	      color: '#333',
	      width: 1,
	      type: 'solid'
	    },
	    // The arrow at both ends the the axis.
	    symbol: ['none', 'none'],
	    symbolSize: [10, 15]
	  },
	  axisTick: {
	    show: true,
	    // Whether axisTick is inside the grid or outside the grid.
	    inside: false,
	    // The length of axisTick.
	    length: 5,
	    lineStyle: {
	      width: 1
	    }
	  },
	  axisLabel: {
	    show: true,
	    // Whether axisLabel is inside the grid or outside the grid.
	    inside: false,
	    rotate: 0,
	    // true | false | null/undefined (auto)
	    showMinLabel: null,
	    // true | false | null/undefined (auto)
	    showMaxLabel: null,
	    margin: 8,
	    // formatter: null,
	    fontSize: 12
	  },
	  splitLine: {
	    show: true,
	    lineStyle: {
	      color: ['#ccc'],
	      width: 1,
	      type: 'solid'
	    }
	  },
	  splitArea: {
	    show: false,
	    areaStyle: {
	      color: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
	    }
	  }
	};
	var axisDefault = {};
	axisDefault.categoryAxis = zrUtil.merge({
	  // The gap at both ends of the axis. For categoryAxis, boolean.
	  boundaryGap: true,
	  // Set false to faster category collection.
	  // Only usefull in the case like: category is
	  // ['2012-01-01', '2012-01-02', ...], where the input
	  // data has been ensured not duplicate and is large data.
	  // null means "auto":
	  // if axis.data provided, do not deduplication,
	  // else do deduplication.
	  deduplication: null,
	  // splitArea: {
	  // show: false
	  // },
	  splitLine: {
	    show: false
	  },
	  axisTick: {
	    // If tick is align with label when boundaryGap is true
	    alignWithLabel: false,
	    interval: 'auto'
	  },
	  axisLabel: {
	    interval: 'auto'
	  }
	}, defaultOption);
	axisDefault.valueAxis = zrUtil.merge({
	  // The gap at both ends of the axis. For value axis, [GAP, GAP], where
	  // `GAP` can be an absolute pixel number (like `35`), or percent (like `'30%'`)
	  boundaryGap: [0, 0],
	  // TODO
	  // min/max: [30, datamin, 60] or [20, datamin] or [datamin, 60]
	  // Min value of the axis. can be:
	  // + a number
	  // + 'dataMin': use the min value in data.
	  // + null/undefined: auto decide min value (consider pretty look and boundaryGap).
	  // min: null,
	  // Max value of the axis. can be:
	  // + a number
	  // + 'dataMax': use the max value in data.
	  // + null/undefined: auto decide max value (consider pretty look and boundaryGap).
	  // max: null,
	  // Readonly prop, specifies start value of the range when using data zoom.
	  // rangeStart: null
	  // Readonly prop, specifies end value of the range when using data zoom.
	  // rangeEnd: null
	  // Optional value can be:
	  // + `false`: always include value 0.
	  // + `true`: the extent do not consider value 0.
	  // scale: false,
	  // AxisTick and axisLabel and splitLine are caculated based on splitNumber.
	  splitNumber: 5,
	  // Interval specifies the span of the ticks is mandatorily.
	  // interval: null
	  // Specify min interval when auto calculate tick interval.
	  // minInterval: null
	  // Specify max interval when auto calculate tick interval.
	  // maxInterval: null
	  minorTick: {
	    // Minor tick, not available for cateogry axis.
	    show: false,
	    // Split number of minor ticks. The value should be in range of (0, 100)
	    splitNumber: 5,
	    // Lenght of minor tick
	    length: 3,
	    // Same inside with axisTick
	    // Line style
	    lineStyle: {// Default to be same with axisTick
	    }
	  },
	  minorSplitLine: {
	    show: false,
	    lineStyle: {
	      color: '#eee',
	      width: 1
	    }
	  }
	}, defaultOption);
	axisDefault.timeAxis = zrUtil.defaults({
	  scale: true,
	  min: 'dataMin',
	  max: 'dataMax'
	}, axisDefault.valueAxis);
	axisDefault.logAxis = zrUtil.defaults({
	  scale: true,
	  logBase: 10
	}, axisDefault.valueAxis);
	var _default = axisDefault;
	module.exports = _default;

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var ComponentModel = __webpack_require__(57);
	
	var axisModelCreator = __webpack_require__(335);
	
	var axisModelCommonMixin = __webpack_require__(206);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var AxisModel = ComponentModel.extend({
	  type: 'cartesian2dAxis',
	
	  /**
	   * @type {module:echarts/coord/cartesian/Axis2D}
	   */
	  axis: null,
	
	  /**
	   * @override
	   */
	  init: function () {
	    AxisModel.superApply(this, 'init', arguments);
	    this.resetRange();
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function () {
	    AxisModel.superApply(this, 'mergeOption', arguments);
	    this.resetRange();
	  },
	
	  /**
	   * @override
	   */
	  restoreData: function () {
	    AxisModel.superApply(this, 'restoreData', arguments);
	    this.resetRange();
	  },
	
	  /**
	   * @override
	   * @return {module:echarts/model/Component}
	   */
	  getCoordSysModel: function () {
	    return this.ecModel.queryComponents({
	      mainType: 'grid',
	      index: this.option.gridIndex,
	      id: this.option.gridId
	    })[0];
	  }
	});
	
	function getAxisType(axisDim, option) {
	  // Default axis with data is category axis
	  return option.type || (option.data ? 'category' : 'value');
	}
	
	zrUtil.merge(AxisModel.prototype, axisModelCommonMixin);
	var extraOption = {
	  // gridIndex: 0,
	  // gridId: '',
	  // Offset is for multiple axis on the same position
	  offset: 0
	};
	axisModelCreator('x', AxisModel, getAxisType, extraOption);
	axisModelCreator('y', AxisModel, getAxisType, extraOption);
	var _default = AxisModel;
	module.exports = _default;

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Can only be called after coordinate system creation stage.
	 * (Can be called before coordinate system update stage).
	 *
	 * @param {Object} opt {labelInside}
	 * @return {Object} {
	 *  position, rotation, labelDirection, labelOffset,
	 *  tickDirection, labelRotate, z2
	 * }
	 */
	function layout(gridModel, axisModel, opt) {
	  opt = opt || {};
	  var grid = gridModel.coordinateSystem;
	  var axis = axisModel.axis;
	  var layout = {};
	  var otherAxisOnZeroOf = axis.getAxesOnZeroOf()[0];
	  var rawAxisPosition = axis.position;
	  var axisPosition = otherAxisOnZeroOf ? 'onZero' : rawAxisPosition;
	  var axisDim = axis.dim;
	  var rect = grid.getRect();
	  var rectBound = [rect.x, rect.x + rect.width, rect.y, rect.y + rect.height];
	  var idx = {
	    left: 0,
	    right: 1,
	    top: 0,
	    bottom: 1,
	    onZero: 2
	  };
	  var axisOffset = axisModel.get('offset') || 0;
	  var posBound = axisDim === 'x' ? [rectBound[2] - axisOffset, rectBound[3] + axisOffset] : [rectBound[0] - axisOffset, rectBound[1] + axisOffset];
	
	  if (otherAxisOnZeroOf) {
	    var onZeroCoord = otherAxisOnZeroOf.toGlobalCoord(otherAxisOnZeroOf.dataToCoord(0));
	    posBound[idx.onZero] = Math.max(Math.min(onZeroCoord, posBound[1]), posBound[0]);
	  } // Axis position
	
	
	  layout.position = [axisDim === 'y' ? posBound[idx[axisPosition]] : rectBound[0], axisDim === 'x' ? posBound[idx[axisPosition]] : rectBound[3]]; // Axis rotation
	
	  layout.rotation = Math.PI / 2 * (axisDim === 'x' ? 0 : 1); // Tick and label direction, x y is axisDim
	
	  var dirMap = {
	    top: -1,
	    bottom: 1,
	    left: -1,
	    right: 1
	  };
	  layout.labelDirection = layout.tickDirection = layout.nameDirection = dirMap[rawAxisPosition];
	  layout.labelOffset = otherAxisOnZeroOf ? posBound[idx[rawAxisPosition]] - posBound[idx.onZero] : 0;
	
	  if (axisModel.get('axisTick.inside')) {
	    layout.tickDirection = -layout.tickDirection;
	  }
	
	  if (zrUtil.retrieve(opt.labelInside, axisModel.get('axisLabel.inside'))) {
	    layout.labelDirection = -layout.labelDirection;
	  } // Special label rotation
	
	
	  var labelRotate = axisModel.get('axisLabel.rotate');
	  layout.labelRotate = axisPosition === 'top' ? -labelRotate : labelRotate; // Over splitLine and splitArea
	
	  layout.z2 = 1;
	  return layout;
	}
	
	exports.layout = layout;

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var BoundingRect = __webpack_require__(42);
	
	var bbox = __webpack_require__(292);
	
	var vec2 = __webpack_require__(41);
	
	var polygonContain = __webpack_require__(1080);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/coord/geo/Region
	 */
	
	/**
	 * @param {string|Region} name
	 * @param {Array} geometries
	 * @param {Array.<number>} cp
	 */
	function Region(name, geometries, cp) {
	  /**
	   * @type {string}
	   * @readOnly
	   */
	  this.name = name;
	  /**
	   * @type {Array.<Array>}
	   * @readOnly
	   */
	
	  this.geometries = geometries;
	
	  if (!cp) {
	    var rect = this.getBoundingRect();
	    cp = [rect.x + rect.width / 2, rect.y + rect.height / 2];
	  } else {
	    cp = [cp[0], cp[1]];
	  }
	  /**
	   * @type {Array.<number>}
	   */
	
	
	  this.center = cp;
	}
	
	Region.prototype = {
	  constructor: Region,
	  properties: null,
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getBoundingRect: function () {
	    var rect = this._rect;
	
	    if (rect) {
	      return rect;
	    }
	
	    var MAX_NUMBER = Number.MAX_VALUE;
	    var min = [MAX_NUMBER, MAX_NUMBER];
	    var max = [-MAX_NUMBER, -MAX_NUMBER];
	    var min2 = [];
	    var max2 = [];
	    var geometries = this.geometries;
	
	    for (var i = 0; i < geometries.length; i++) {
	      // Only support polygon
	      if (geometries[i].type !== 'polygon') {
	        continue;
	      } // Doesn't consider hole
	
	
	      var exterior = geometries[i].exterior;
	      bbox.fromPoints(exterior, min2, max2);
	      vec2.min(min, min, min2);
	      vec2.max(max, max, max2);
	    } // No data
	
	
	    if (i === 0) {
	      min[0] = min[1] = max[0] = max[1] = 0;
	    }
	
	    return this._rect = new BoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
	  },
	
	  /**
	   * @param {<Array.<number>} coord
	   * @return {boolean}
	   */
	  contain: function (coord) {
	    var rect = this.getBoundingRect();
	    var geometries = this.geometries;
	
	    if (!rect.contain(coord[0], coord[1])) {
	      return false;
	    }
	
	    loopGeo: for (var i = 0, len = geometries.length; i < len; i++) {
	      // Only support polygon.
	      if (geometries[i].type !== 'polygon') {
	        continue;
	      }
	
	      var exterior = geometries[i].exterior;
	      var interiors = geometries[i].interiors;
	
	      if (polygonContain.contain(exterior, coord[0], coord[1])) {
	        // Not in the region if point is in the hole.
	        for (var k = 0; k < (interiors ? interiors.length : 0); k++) {
	          if (polygonContain.contain(interiors[k])) {
	            continue loopGeo;
	          }
	        }
	
	        return true;
	      }
	    }
	
	    return false;
	  },
	  transformTo: function (x, y, width, height) {
	    var rect = this.getBoundingRect();
	    var aspect = rect.width / rect.height;
	
	    if (!width) {
	      width = aspect * height;
	    } else if (!height) {
	      height = width / aspect;
	    }
	
	    var target = new BoundingRect(x, y, width, height);
	    var transform = rect.calculateTransform(target);
	    var geometries = this.geometries;
	
	    for (var i = 0; i < geometries.length; i++) {
	      // Only support polygon.
	      if (geometries[i].type !== 'polygon') {
	        continue;
	      }
	
	      var exterior = geometries[i].exterior;
	      var interiors = geometries[i].interiors;
	
	      for (var p = 0; p < exterior.length; p++) {
	        vec2.applyTransform(exterior[p], exterior[p], transform);
	      }
	
	      for (var h = 0; h < (interiors ? interiors.length : 0); h++) {
	        for (var p = 0; p < interiors[h].length; p++) {
	          vec2.applyTransform(interiors[h][p], interiors[h][p], transform);
	        }
	      }
	    }
	
	    rect = this._rect;
	    rect.copy(target); // Update center
	
	    this.center = [rect.x + rect.width / 2, rect.y + rect.height / 2];
	  },
	  cloneShallow: function (name) {
	    name == null && (name = this.name);
	    var newRegion = new Region(name, this.geometries, this.center);
	    newRegion._rect = this._rect;
	    newRegion.transformTo = null; // Simply avoid to be called.
	
	    return newRegion;
	  }
	};
	var _default = Region;
	module.exports = _default;

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var Region = __webpack_require__(740);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Parse and decode geo json
	 * @module echarts/coord/geo/parseGeoJson
	 */
	function decode(json) {
	  if (!json.UTF8Encoding) {
	    return json;
	  }
	
	  var encodeScale = json.UTF8Scale;
	
	  if (encodeScale == null) {
	    encodeScale = 1024;
	  }
	
	  var features = json.features;
	
	  for (var f = 0; f < features.length; f++) {
	    var feature = features[f];
	    var geometry = feature.geometry;
	    var coordinates = geometry.coordinates;
	    var encodeOffsets = geometry.encodeOffsets;
	
	    for (var c = 0; c < coordinates.length; c++) {
	      var coordinate = coordinates[c];
	
	      if (geometry.type === 'Polygon') {
	        coordinates[c] = decodePolygon(coordinate, encodeOffsets[c], encodeScale);
	      } else if (geometry.type === 'MultiPolygon') {
	        for (var c2 = 0; c2 < coordinate.length; c2++) {
	          var polygon = coordinate[c2];
	          coordinate[c2] = decodePolygon(polygon, encodeOffsets[c][c2], encodeScale);
	        }
	      }
	    }
	  } // Has been decoded
	
	
	  json.UTF8Encoding = false;
	  return json;
	}
	
	function decodePolygon(coordinate, encodeOffsets, encodeScale) {
	  var result = [];
	  var prevX = encodeOffsets[0];
	  var prevY = encodeOffsets[1];
	
	  for (var i = 0; i < coordinate.length; i += 2) {
	    var x = coordinate.charCodeAt(i) - 64;
	    var y = coordinate.charCodeAt(i + 1) - 64; // ZigZag decoding
	
	    x = x >> 1 ^ -(x & 1);
	    y = y >> 1 ^ -(y & 1); // Delta deocding
	
	    x += prevX;
	    y += prevY;
	    prevX = x;
	    prevY = y; // Dequantize
	
	    result.push([x / encodeScale, y / encodeScale]);
	  }
	
	  return result;
	}
	/**
	 * @alias module:echarts/coord/geo/parseGeoJson
	 * @param {Object} geoJson
	 * @param {string} nameProperty
	 * @return {module:zrender/container/Group}
	 */
	
	
	function _default(geoJson, nameProperty) {
	  decode(geoJson);
	  return zrUtil.map(zrUtil.filter(geoJson.features, function (featureObj) {
	    // Output of mapshaper may have geometry null
	    return featureObj.geometry && featureObj.properties && featureObj.geometry.coordinates.length > 0;
	  }), function (featureObj) {
	    var properties = featureObj.properties;
	    var geo = featureObj.geometry;
	    var coordinates = geo.coordinates;
	    var geometries = [];
	
	    if (geo.type === 'Polygon') {
	      geometries.push({
	        type: 'polygon',
	        // According to the GeoJSON specification.
	        // First must be exterior, and the rest are all interior(holes).
	        exterior: coordinates[0],
	        interiors: coordinates.slice(1)
	      });
	    }
	
	    if (geo.type === 'MultiPolygon') {
	      zrUtil.each(coordinates, function (item) {
	        if (item[0]) {
	          geometries.push({
	            type: 'polygon',
	            exterior: item[0],
	            interiors: item.slice(1)
	          });
	        }
	      });
	    }
	
	    var region = new Region(properties[nameProperty || 'name'], geometries, properties.cp);
	    region.properties = properties;
	    return region;
	  });
	}
	
	module.exports = _default;

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Parallel = __webpack_require__(1670);
	
	var CoordinateSystem = __webpack_require__(92);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Parallel coordinate system creater.
	 */
	function create(ecModel, api) {
	  var coordSysList = [];
	  ecModel.eachComponent('parallel', function (parallelModel, idx) {
	    var coordSys = new Parallel(parallelModel, ecModel, api);
	    coordSys.name = 'parallel_' + idx;
	    coordSys.resize(parallelModel, api);
	    parallelModel.coordinateSystem = coordSys;
	    coordSys.model = parallelModel;
	    coordSysList.push(coordSys);
	  }); // Inject the coordinateSystems into seriesModel
	
	  ecModel.eachSeries(function (seriesModel) {
	    if (seriesModel.get('coordinateSystem') === 'parallel') {
	      var parallelModel = ecModel.queryComponents({
	        mainType: 'parallel',
	        index: seriesModel.get('parallelIndex'),
	        id: seriesModel.get('parallelId')
	      })[0];
	      seriesModel.coordinateSystem = parallelModel.coordinateSystem;
	    }
	  });
	  return coordSysList;
	}
	
	CoordinateSystem.register('parallel', {
	  create: create
	});

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {Object} opt {labelInside}
	 * @return {Object} {
	 *  position, rotation, labelDirection, labelOffset,
	 *  tickDirection, labelRotate, z2
	 * }
	 */
	function layout(axisModel, opt) {
	  opt = opt || {};
	  var single = axisModel.coordinateSystem;
	  var axis = axisModel.axis;
	  var layout = {};
	  var axisPosition = axis.position;
	  var orient = axis.orient;
	  var rect = single.getRect();
	  var rectBound = [rect.x, rect.x + rect.width, rect.y, rect.y + rect.height];
	  var positionMap = {
	    horizontal: {
	      top: rectBound[2],
	      bottom: rectBound[3]
	    },
	    vertical: {
	      left: rectBound[0],
	      right: rectBound[1]
	    }
	  };
	  layout.position = [orient === 'vertical' ? positionMap.vertical[axisPosition] : rectBound[0], orient === 'horizontal' ? positionMap.horizontal[axisPosition] : rectBound[3]];
	  var r = {
	    horizontal: 0,
	    vertical: 1
	  };
	  layout.rotation = Math.PI / 2 * r[orient];
	  var directionMap = {
	    top: -1,
	    bottom: 1,
	    right: 1,
	    left: -1
	  };
	  layout.labelDirection = layout.tickDirection = layout.nameDirection = directionMap[axisPosition];
	
	  if (axisModel.get('axisTick.inside')) {
	    layout.tickDirection = -layout.tickDirection;
	  }
	
	  if (zrUtil.retrieve(opt.labelInside, axisModel.get('axisLabel.inside'))) {
	    layout.labelDirection = -layout.labelDirection;
	  }
	
	  var labelRotation = opt.rotate;
	  labelRotation == null && (labelRotation = axisModel.get('axisLabel.rotate'));
	  layout.labelRotation = axisPosition === 'top' ? -labelRotation : labelRotation;
	  layout.z2 = 1;
	  return layout;
	}
	
	exports.layout = layout;

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @class
	 * @param {Object|DataDimensionInfo} [opt] All of the fields will be shallow copied.
	 */
	function DataDimensionInfo(opt) {
	  if (opt != null) {
	    zrUtil.extend(this, opt);
	  }
	  /**
	   * Dimension name.
	   * Mandatory.
	   * @type {string}
	   */
	  // this.name;
	
	  /**
	   * The origin name in dimsDef, see source helper.
	   * If displayName given, the tooltip will displayed vertically.
	   * Optional.
	   * @type {string}
	   */
	  // this.displayName;
	
	  /**
	   * Which coordSys dimension this dimension mapped to.
	   * A `coordDim` can be a "coordSysDim" that the coordSys required
	   * (for example, an item in `coordSysDims` of `model/referHelper#CoordSysInfo`),
	   * or an generated "extra coord name" if does not mapped to any "coordSysDim"
	   * (That is determined by whether `isExtraCoord` is `true`).
	   * Mandatory.
	   * @type {string}
	   */
	  // this.coordDim;
	
	  /**
	   * The index of this dimension in `series.encode[coordDim]`.
	   * Mandatory.
	   * @type {number}
	   */
	  // this.coordDimIndex;
	
	  /**
	   * Dimension type. The enumerable values are the key of
	   * `dataCtors` of `data/List`.
	   * Optional.
	   * @type {string}
	   */
	  // this.type;
	
	  /**
	   * This index of this dimension info in `data/List#_dimensionInfos`.
	   * Mandatory after added to `data/List`.
	   * @type {number}
	   */
	  // this.index;
	
	  /**
	   * The format of `otherDims` is:
	   * ```js
	   * {
	   *     tooltip: number optional,
	   *     label: number optional,
	   *     itemName: number optional,
	   *     seriesName: number optional,
	   * }
	   * ```
	   *
	   * A `series.encode` can specified these fields:
	   * ```js
	   * encode: {
	   *     // "3, 1, 5" is the index of data dimension.
	   *     tooltip: [3, 1, 5],
	   *     label: [0, 3],
	   *     ...
	   * }
	   * ```
	   * `otherDims` is the parse result of the `series.encode` above, like:
	   * ```js
	   * // Suppose the index of this data dimension is `3`.
	   * this.otherDims = {
	   *     // `3` is at the index `0` of the `encode.tooltip`
	   *     tooltip: 0,
	   *     // `3` is at the index `1` of the `encode.tooltip`
	   *     label: 1
	   * };
	   * ```
	   *
	   * This prop should never be `null`/`undefined` after initialized.
	   * @type {Object}
	   */
	
	
	  this.otherDims = {};
	  /**
	   * Be `true` if this dimension is not mapped to any "coordSysDim" that the
	   * "coordSys" required.
	   * Mandatory.
	   * @type {boolean}
	   */
	  // this.isExtraCoord;
	
	  /**
	   * @type {module:data/OrdinalMeta}
	   */
	  // this.ordinalMeta;
	
	  /**
	   * Whether to create inverted indices.
	   * @type {boolean}
	   */
	  // this.createInvertedIndices;
	}
	
	;
	var _default = DataDimensionInfo;
	module.exports = _default;

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(3);
	
	var createHashMap = _util.createHashMap;
	var isObject = _util.isObject;
	var map = _util.map;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @constructor
	 * @param {Object} [opt]
	 * @param {Object} [opt.categories=[]]
	 * @param {Object} [opt.needCollect=false]
	 * @param {Object} [opt.deduplication=false]
	 */
	function OrdinalMeta(opt) {
	  /**
	   * @readOnly
	   * @type {Array.<string>}
	   */
	  this.categories = opt.categories || [];
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._needCollect = opt.needCollect;
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._deduplication = opt.deduplication;
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._map;
	}
	/**
	 * @param {module:echarts/model/Model} axisModel
	 * @return {module:echarts/data/OrdinalMeta}
	 */
	
	
	OrdinalMeta.createByAxisModel = function (axisModel) {
	  var option = axisModel.option;
	  var data = option.data;
	  var categories = data && map(data, getName);
	  return new OrdinalMeta({
	    categories: categories,
	    needCollect: !categories,
	    // deduplication is default in axis.
	    deduplication: option.dedplication !== false
	  });
	};
	
	var proto = OrdinalMeta.prototype;
	/**
	 * @param {string} category
	 * @return {number} ordinal
	 */
	
	proto.getOrdinal = function (category) {
	  return getOrCreateMap(this).get(category);
	};
	/**
	 * @param {*} category
	 * @return {number} The ordinal. If not found, return NaN.
	 */
	
	
	proto.parseAndCollect = function (category) {
	  var index;
	  var needCollect = this._needCollect; // The value of category dim can be the index of the given category set.
	  // This feature is only supported when !needCollect, because we should
	  // consider a common case: a value is 2017, which is a number but is
	  // expected to be tread as a category. This case usually happen in dataset,
	  // where it happent to be no need of the index feature.
	
	  if (typeof category !== 'string' && !needCollect) {
	    return category;
	  } // Optimize for the scenario:
	  // category is ['2012-01-01', '2012-01-02', ...], where the input
	  // data has been ensured not duplicate and is large data.
	  // Notice, if a dataset dimension provide categroies, usually echarts
	  // should remove duplication except user tell echarts dont do that
	  // (set axis.deduplication = false), because echarts do not know whether
	  // the values in the category dimension has duplication (consider the
	  // parallel-aqi example)
	
	
	  if (needCollect && !this._deduplication) {
	    index = this.categories.length;
	    this.categories[index] = category;
	    return index;
	  }
	
	  var map = getOrCreateMap(this);
	  index = map.get(category);
	
	  if (index == null) {
	    if (needCollect) {
	      index = this.categories.length;
	      this.categories[index] = category;
	      map.set(category, index);
	    } else {
	      index = NaN;
	    }
	  }
	
	  return index;
	}; // Consider big data, do not create map until needed.
	
	
	function getOrCreateMap(ordinalMeta) {
	  return ordinalMeta._map || (ordinalMeta._map = createHashMap(ordinalMeta.categories));
	}
	
	function getName(obj) {
	  if (isObject(obj) && obj.value != null) {
	    return obj.value;
	  } else {
	    return obj + '';
	  }
	}
	
	var _default = OrdinalMeta;
	module.exports = _default;

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(3);
	
	var createHashMap = _util.createHashMap;
	var each = _util.each;
	var isString = _util.isString;
	var defaults = _util.defaults;
	var extend = _util.extend;
	var isObject = _util.isObject;
	var clone = _util.clone;
	
	var _model = __webpack_require__(24);
	
	var normalizeToArray = _model.normalizeToArray;
	
	var _sourceHelper = __webpack_require__(123);
	
	var guessOrdinal = _sourceHelper.guessOrdinal;
	var BE_ORDINAL = _sourceHelper.BE_ORDINAL;
	
	var Source = __webpack_require__(263);
	
	var _dimensionHelper = __webpack_require__(264);
	
	var OTHER_DIMENSIONS = _dimensionHelper.OTHER_DIMENSIONS;
	
	var DataDimensionInfo = __webpack_require__(744);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @deprecated
	 * Use `echarts/data/helper/createDimensions` instead.
	 */
	
	/**
	 * @see {module:echarts/test/ut/spec/data/completeDimensions}
	 *
	 * This method builds the relationship between:
	 * + "what the coord sys or series requires (see `sysDims`)",
	 * + "what the user defines (in `encode` and `dimensions`, see `opt.dimsDef` and `opt.encodeDef`)"
	 * + "what the data source provids (see `source`)".
	 *
	 * Some guess strategy will be adapted if user does not define something.
	 * If no 'value' dimension specified, the first no-named dimension will be
	 * named as 'value'.
	 *
	 * @param {Array.<string>} sysDims Necessary dimensions, like ['x', 'y'], which
	 *      provides not only dim template, but also default order.
	 *      properties: 'name', 'type', 'displayName'.
	 *      `name` of each item provides default coord name.
	 *      [{dimsDef: [string|Object, ...]}, ...] dimsDef of sysDim item provides default dim name, and
	 *                                    provide dims count that the sysDim required.
	 *      [{ordinalMeta}] can be specified.
	 * @param {module:echarts/data/Source|Array|Object} source or data (for compatibal with pervious)
	 * @param {Object} [opt]
	 * @param {Array.<Object|string>} [opt.dimsDef] option.series.dimensions User defined dimensions
	 *      For example: ['asdf', {name, type}, ...].
	 * @param {Object|HashMap} [opt.encodeDef] option.series.encode {x: 2, y: [3, 1], tooltip: [1, 2], label: 3}
	 * @param {Function} [opt.encodeDefaulter] Called if no `opt.encodeDef` exists.
	 *      If not specified, auto find the next available data dim.
	 *      param source {module:data/Source}
	 *      param dimCount {number}
	 *      return {Object} encode Never be `null/undefined`.
	 * @param {string} [opt.generateCoord] Generate coord dim with the given name.
	 *      If not specified, extra dim names will be:
	 *      'value', 'value0', 'value1', ...
	 * @param {number} [opt.generateCoordCount] By default, the generated dim name is `generateCoord`.
	 *      If `generateCoordCount` specified, the generated dim names will be:
	 *      `generateCoord` + 0, `generateCoord` + 1, ...
	 *      can be Infinity, indicate that use all of the remain columns.
	 * @param {number} [opt.dimCount] If not specified, guess by the first data item.
	 * @return {Array.<module:data/DataDimensionInfo>}
	 */
	function completeDimensions(sysDims, source, opt) {
	  if (!Source.isInstance(source)) {
	    source = Source.seriesDataToSource(source);
	  }
	
	  opt = opt || {};
	  sysDims = (sysDims || []).slice();
	  var dimsDef = (opt.dimsDef || []).slice();
	  var dataDimNameMap = createHashMap();
	  var coordDimNameMap = createHashMap(); // var valueCandidate;
	
	  var result = [];
	  var dimCount = getDimCount(source, sysDims, dimsDef, opt.dimCount); // Apply user defined dims (`name` and `type`) and init result.
	
	  for (var i = 0; i < dimCount; i++) {
	    var dimDefItem = dimsDef[i] = extend({}, isObject(dimsDef[i]) ? dimsDef[i] : {
	      name: dimsDef[i]
	    });
	    var userDimName = dimDefItem.name;
	    var resultItem = result[i] = new DataDimensionInfo(); // Name will be applied later for avoiding duplication.
	
	    if (userDimName != null && dataDimNameMap.get(userDimName) == null) {
	      // Only if `series.dimensions` is defined in option
	      // displayName, will be set, and dimension will be diplayed vertically in
	      // tooltip by default.
	      resultItem.name = resultItem.displayName = userDimName;
	      dataDimNameMap.set(userDimName, i);
	    }
	
	    dimDefItem.type != null && (resultItem.type = dimDefItem.type);
	    dimDefItem.displayName != null && (resultItem.displayName = dimDefItem.displayName);
	  }
	
	  var encodeDef = opt.encodeDef;
	
	  if (!encodeDef && opt.encodeDefaulter) {
	    encodeDef = opt.encodeDefaulter(source, dimCount);
	  }
	
	  encodeDef = createHashMap(encodeDef); // Set `coordDim` and `coordDimIndex` by `encodeDef` and normalize `encodeDef`.
	
	  encodeDef.each(function (dataDims, coordDim) {
	    dataDims = normalizeToArray(dataDims).slice(); // Note: It is allowed that `dataDims.length` is `0`, e.g., options is
	    // `{encode: {x: -1, y: 1}}`. Should not filter anything in
	    // this case.
	
	    if (dataDims.length === 1 && !isString(dataDims[0]) && dataDims[0] < 0) {
	      encodeDef.set(coordDim, false);
	      return;
	    }
	
	    var validDataDims = encodeDef.set(coordDim, []);
	    each(dataDims, function (resultDimIdx, idx) {
	      // The input resultDimIdx can be dim name or index.
	      isString(resultDimIdx) && (resultDimIdx = dataDimNameMap.get(resultDimIdx));
	
	      if (resultDimIdx != null && resultDimIdx < dimCount) {
	        validDataDims[idx] = resultDimIdx;
	        applyDim(result[resultDimIdx], coordDim, idx);
	      }
	    });
	  }); // Apply templetes and default order from `sysDims`.
	
	  var availDimIdx = 0;
	  each(sysDims, function (sysDimItem, sysDimIndex) {
	    var coordDim;
	    var sysDimItem;
	    var sysDimItemDimsDef;
	    var sysDimItemOtherDims;
	
	    if (isString(sysDimItem)) {
	      coordDim = sysDimItem;
	      sysDimItem = {};
	    } else {
	      coordDim = sysDimItem.name;
	      var ordinalMeta = sysDimItem.ordinalMeta;
	      sysDimItem.ordinalMeta = null;
	      sysDimItem = clone(sysDimItem);
	      sysDimItem.ordinalMeta = ordinalMeta; // `coordDimIndex` should not be set directly.
	
	      sysDimItemDimsDef = sysDimItem.dimsDef;
	      sysDimItemOtherDims = sysDimItem.otherDims;
	      sysDimItem.name = sysDimItem.coordDim = sysDimItem.coordDimIndex = sysDimItem.dimsDef = sysDimItem.otherDims = null;
	    }
	
	    var dataDims = encodeDef.get(coordDim); // negative resultDimIdx means no need to mapping.
	
	    if (dataDims === false) {
	      return;
	    }
	
	    var dataDims = normalizeToArray(dataDims); // dimensions provides default dim sequences.
	
	    if (!dataDims.length) {
	      for (var i = 0; i < (sysDimItemDimsDef && sysDimItemDimsDef.length || 1); i++) {
	        while (availDimIdx < result.length && result[availDimIdx].coordDim != null) {
	          availDimIdx++;
	        }
	
	        availDimIdx < result.length && dataDims.push(availDimIdx++);
	      }
	    } // Apply templates.
	
	
	    each(dataDims, function (resultDimIdx, coordDimIndex) {
	      var resultItem = result[resultDimIdx];
	      applyDim(defaults(resultItem, sysDimItem), coordDim, coordDimIndex);
	
	      if (resultItem.name == null && sysDimItemDimsDef) {
	        var sysDimItemDimsDefItem = sysDimItemDimsDef[coordDimIndex];
	        !isObject(sysDimItemDimsDefItem) && (sysDimItemDimsDefItem = {
	          name: sysDimItemDimsDefItem
	        });
	        resultItem.name = resultItem.displayName = sysDimItemDimsDefItem.name;
	        resultItem.defaultTooltip = sysDimItemDimsDefItem.defaultTooltip;
	      } // FIXME refactor, currently only used in case: {otherDims: {tooltip: false}}
	
	
	      sysDimItemOtherDims && defaults(resultItem.otherDims, sysDimItemOtherDims);
	    });
	  });
	
	  function applyDim(resultItem, coordDim, coordDimIndex) {
	    if (OTHER_DIMENSIONS.get(coordDim) != null) {
	      resultItem.otherDims[coordDim] = coordDimIndex;
	    } else {
	      resultItem.coordDim = coordDim;
	      resultItem.coordDimIndex = coordDimIndex;
	      coordDimNameMap.set(coordDim, true);
	    }
	  } // Make sure the first extra dim is 'value'.
	
	
	  var generateCoord = opt.generateCoord;
	  var generateCoordCount = opt.generateCoordCount;
	  var fromZero = generateCoordCount != null;
	  generateCoordCount = generateCoord ? generateCoordCount || 1 : 0;
	  var extra = generateCoord || 'value'; // Set dim `name` and other `coordDim` and other props.
	
	  for (var resultDimIdx = 0; resultDimIdx < dimCount; resultDimIdx++) {
	    var resultItem = result[resultDimIdx] = result[resultDimIdx] || new DataDimensionInfo();
	    var coordDim = resultItem.coordDim;
	
	    if (coordDim == null) {
	      resultItem.coordDim = genName(extra, coordDimNameMap, fromZero);
	      resultItem.coordDimIndex = 0;
	
	      if (!generateCoord || generateCoordCount <= 0) {
	        resultItem.isExtraCoord = true;
	      }
	
	      generateCoordCount--;
	    }
	
	    resultItem.name == null && (resultItem.name = genName(resultItem.coordDim, dataDimNameMap));
	
	    if (resultItem.type == null && (guessOrdinal(source, resultDimIdx, resultItem.name) === BE_ORDINAL.Must // Consider the case:
	    // {
	    //    dataset: {source: [
	    //        ['2001', 123],
	    //        ['2002', 456],
	    //        ...
	    //        ['The others', 987],
	    //    ]},
	    //    series: {type: 'pie'}
	    // }
	    // The first colum should better be treated as a "ordinal" although it
	    // might not able to be detected as an "ordinal" by `guessOrdinal`.
	    || resultItem.isExtraCoord && (resultItem.otherDims.itemName != null || resultItem.otherDims.seriesName != null))) {
	      resultItem.type = 'ordinal';
	    }
	  }
	
	  return result;
	} // ??? TODO
	// Originally detect dimCount by data[0]. Should we
	// optimize it to only by sysDims and dimensions and encode.
	// So only necessary dims will be initialized.
	// But
	// (1) custom series should be considered. where other dims
	// may be visited.
	// (2) sometimes user need to calcualte bubble size or use visualMap
	// on other dimensions besides coordSys needed.
	// So, dims that is not used by system, should be shared in storage?
	
	
	function getDimCount(source, sysDims, dimsDef, optDimCount) {
	  // Note that the result dimCount should not small than columns count
	  // of data, otherwise `dataDimNameMap` checking will be incorrect.
	  var dimCount = Math.max(source.dimensionsDetectCount || 1, sysDims.length, dimsDef.length, optDimCount || 0);
	  each(sysDims, function (sysDimItem) {
	    var sysDimItemDimsDef = sysDimItem.dimsDef;
	    sysDimItemDimsDef && (dimCount = Math.max(dimCount, sysDimItemDimsDef.length));
	  });
	  return dimCount;
	}
	
	function genName(name, map, fromZero) {
	  if (fromZero || map.get(name) != null) {
	    var i = 0;
	
	    while (map.get(name + i) != null) {
	      i++;
	    }
	
	    name += i;
	  }
	
	  map.set(name, true);
	  return name;
	}
	
	var _default = completeDimensions;
	module.exports = _default;

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Link lists and struct (graph or tree)
	 */
	var each = zrUtil.each;
	var DATAS = '\0__link_datas';
	var MAIN_DATA = '\0__link_mainData'; // Caution:
	// In most case, either list or its shallow clones (see list.cloneShallow)
	// is active in echarts process. So considering heap memory consumption,
	// we do not clone tree or graph, but share them among list and its shallow clones.
	// But in some rare case, we have to keep old list (like do animation in chart). So
	// please take care that both the old list and the new list share the same tree/graph.
	
	/**
	 * @param {Object} opt
	 * @param {module:echarts/data/List} opt.mainData
	 * @param {Object} [opt.struct] For example, instance of Graph or Tree.
	 * @param {string} [opt.structAttr] designation: list[structAttr] = struct;
	 * @param {Object} [opt.datas] {dataType: data},
	 *                 like: {node: nodeList, edge: edgeList}.
	 *                 Should contain mainData.
	 * @param {Object} [opt.datasAttr] {dataType: attr},
	 *                 designation: struct[datasAttr[dataType]] = list;
	 */
	
	function linkList(opt) {
	  var mainData = opt.mainData;
	  var datas = opt.datas;
	
	  if (!datas) {
	    datas = {
	      main: mainData
	    };
	    opt.datasAttr = {
	      main: 'data'
	    };
	  }
	
	  opt.datas = opt.mainData = null;
	  linkAll(mainData, datas, opt); // Porxy data original methods.
	
	  each(datas, function (data) {
	    each(mainData.TRANSFERABLE_METHODS, function (methodName) {
	      data.wrapMethod(methodName, zrUtil.curry(transferInjection, opt));
	    });
	  }); // Beyond transfer, additional features should be added to `cloneShallow`.
	
	  mainData.wrapMethod('cloneShallow', zrUtil.curry(cloneShallowInjection, opt)); // Only mainData trigger change, because struct.update may trigger
	  // another changable methods, which may bring about dead lock.
	
	  each(mainData.CHANGABLE_METHODS, function (methodName) {
	    mainData.wrapMethod(methodName, zrUtil.curry(changeInjection, opt));
	  }); // Make sure datas contains mainData.
	
	  zrUtil.assert(datas[mainData.dataType] === mainData);
	}
	
	function transferInjection(opt, res) {
	  if (isMainData(this)) {
	    // Transfer datas to new main data.
	    var datas = zrUtil.extend({}, this[DATAS]);
	    datas[this.dataType] = res;
	    linkAll(res, datas, opt);
	  } else {
	    // Modify the reference in main data to point newData.
	    linkSingle(res, this.dataType, this[MAIN_DATA], opt);
	  }
	
	  return res;
	}
	
	function changeInjection(opt, res) {
	  opt.struct && opt.struct.update(this);
	  return res;
	}
	
	function cloneShallowInjection(opt, res) {
	  // cloneShallow, which brings about some fragilities, may be inappropriate
	  // to be exposed as an API. So for implementation simplicity we can make
	  // the restriction that cloneShallow of not-mainData should not be invoked
	  // outside, but only be invoked here.
	  each(res[DATAS], function (data, dataType) {
	    data !== res && linkSingle(data.cloneShallow(), dataType, res, opt);
	  });
	  return res;
	}
	/**
	 * Supplement method to List.
	 *
	 * @public
	 * @param {string} [dataType] If not specified, return mainData.
	 * @return {module:echarts/data/List}
	 */
	
	
	function getLinkedData(dataType) {
	  var mainData = this[MAIN_DATA];
	  return dataType == null || mainData == null ? mainData : mainData[DATAS][dataType];
	}
	
	function isMainData(data) {
	  return data[MAIN_DATA] === data;
	}
	
	function linkAll(mainData, datas, opt) {
	  mainData[DATAS] = {};
	  each(datas, function (data, dataType) {
	    linkSingle(data, dataType, mainData, opt);
	  });
	}
	
	function linkSingle(data, dataType, mainData, opt) {
	  mainData[DATAS][dataType] = data;
	  data[MAIN_DATA] = mainData;
	  data.dataType = dataType;
	
	  if (opt.struct) {
	    data[opt.structAttr] = opt.struct;
	    opt.struct[opt.datasAttr[dataType]] = data;
	  } // Supplement method.
	
	
	  data.getLinkedData = getLinkedData;
	}
	
	var _default = linkList;
	module.exports = _default;

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrender = __webpack_require__(390);
	
	exports.zrender = zrender;
	
	var matrix = __webpack_require__(73);
	
	exports.matrix = matrix;
	
	var vector = __webpack_require__(41);
	
	exports.vector = vector;
	
	var zrUtil = __webpack_require__(3);
	
	var colorTool = __webpack_require__(114);
	
	exports.color = colorTool;
	
	var graphicUtil = __webpack_require__(16);
	
	var numberUtil = __webpack_require__(20);
	
	exports.number = numberUtil;
	
	var formatUtil = __webpack_require__(40);
	
	exports.format = formatUtil;
	
	var _throttle = __webpack_require__(142);
	
	var throttle = _throttle.throttle;
	exports.throttle = _throttle.throttle;
	
	var ecHelper = __webpack_require__(1689);
	
	exports.helper = ecHelper;
	
	var parseGeoJSON = __webpack_require__(741);
	
	exports.parseGeoJSON = parseGeoJSON;
	
	var _List = __webpack_require__(83);
	
	exports.List = _List;
	
	var _Model = __webpack_require__(48);
	
	exports.Model = _Model;
	
	var _Axis = __webpack_require__(140);
	
	exports.Axis = _Axis;
	
	var _env = __webpack_require__(55);
	
	exports.env = _env;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Do not mount those modules on 'src/echarts' for better tree shaking.
	 */
	var parseGeoJson = parseGeoJSON;
	var ecUtil = {};
	zrUtil.each(['map', 'each', 'filter', 'indexOf', 'inherits', 'reduce', 'filter', 'bind', 'curry', 'isArray', 'isString', 'isObject', 'isFunction', 'extend', 'defaults', 'clone', 'merge'], function (name) {
	  ecUtil[name] = zrUtil[name];
	});
	var graphic = {};
	zrUtil.each(['extendShape', 'extendPath', 'makePath', 'makeImage', 'mergePath', 'resizePath', 'createIcon', 'setHoverStyle', 'setLabelStyle', 'setTextStyle', 'setText', 'getFont', 'updateProps', 'initProps', 'getTransform', 'clipPointsByRect', 'clipRectByRect', 'registerShape', 'getShapeClass', 'Group', 'Image', 'Text', 'Circle', 'Sector', 'Ring', 'Polygon', 'Polyline', 'Rect', 'Line', 'BezierCurve', 'Arc', 'IncrementalDisplayable', 'CompoundPath', 'LinearGradient', 'RadialGradient', 'BoundingRect'], function (name) {
	  graphic[name] = graphicUtil[name];
	});
	exports.parseGeoJson = parseGeoJson;
	exports.util = ecUtil;
	exports.graphic = graphic;

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	var _util = __webpack_require__(3);
	
	var each = _util.each;
	var filter = _util.filter;
	var map = _util.map;
	var isArray = _util.isArray;
	var indexOf = _util.indexOf;
	var isObject = _util.isObject;
	var isString = _util.isString;
	var createHashMap = _util.createHashMap;
	var assert = _util.assert;
	var clone = _util.clone;
	var merge = _util.merge;
	var extend = _util.extend;
	var mixin = _util.mixin;
	
	var modelUtil = __webpack_require__(24);
	
	var Model = __webpack_require__(48);
	
	var ComponentModel = __webpack_require__(57);
	
	var globalDefault = __webpack_require__(1693);
	
	var colorPaletteMixin = __webpack_require__(750);
	
	var _sourceHelper = __webpack_require__(123);
	
	var resetSourceDefaulter = _sourceHelper.resetSourceDefaulter;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * ECharts global model
	 *
	 * @module {echarts/model/Global}
	 */
	
	/**
	 * Caution: If the mechanism should be changed some day, these cases
	 * should be considered:
	 *
	 * (1) In `merge option` mode, if using the same option to call `setOption`
	 * many times, the result should be the same (try our best to ensure that).
	 * (2) In `merge option` mode, if a component has no id/name specified, it
	 * will be merged by index, and the result sequence of the components is
	 * consistent to the original sequence.
	 * (3) `reset` feature (in toolbox). Find detailed info in comments about
	 * `mergeOption` in module:echarts/model/OptionManager.
	 */
	var OPTION_INNER_KEY = '\0_ec_inner';
	/**
	 * @alias module:echarts/model/Global
	 *
	 * @param {Object} option
	 * @param {module:echarts/model/Model} parentModel
	 * @param {Object} theme
	 */
	
	var GlobalModel = Model.extend({
	  init: function (option, parentModel, theme, optionManager) {
	    theme = theme || {};
	    this.option = null; // Mark as not initialized.
	
	    /**
	     * @type {module:echarts/model/Model}
	     * @private
	     */
	
	    this._theme = new Model(theme);
	    /**
	     * @type {module:echarts/model/OptionManager}
	     */
	
	    this._optionManager = optionManager;
	  },
	  setOption: function (option, optionPreprocessorFuncs) {
	    assert(!(OPTION_INNER_KEY in option), 'please use chart.getOption()');
	
	    this._optionManager.setOption(option, optionPreprocessorFuncs);
	
	    this.resetOption(null);
	  },
	
	  /**
	   * @param {string} type null/undefined: reset all.
	   *                      'recreate': force recreate all.
	   *                      'timeline': only reset timeline option
	   *                      'media': only reset media query option
	   * @return {boolean} Whether option changed.
	   */
	  resetOption: function (type) {
	    var optionChanged = false;
	    var optionManager = this._optionManager;
	
	    if (!type || type === 'recreate') {
	      var baseOption = optionManager.mountOption(type === 'recreate');
	
	      if (!this.option || type === 'recreate') {
	        initBase.call(this, baseOption);
	      } else {
	        this.restoreData();
	        this.mergeOption(baseOption);
	      }
	
	      optionChanged = true;
	    }
	
	    if (type === 'timeline' || type === 'media') {
	      this.restoreData();
	    }
	
	    if (!type || type === 'recreate' || type === 'timeline') {
	      var timelineOption = optionManager.getTimelineOption(this);
	      timelineOption && (this.mergeOption(timelineOption), optionChanged = true);
	    }
	
	    if (!type || type === 'recreate' || type === 'media') {
	      var mediaOptions = optionManager.getMediaOption(this, this._api);
	
	      if (mediaOptions.length) {
	        each(mediaOptions, function (mediaOption) {
	          this.mergeOption(mediaOption, optionChanged = true);
	        }, this);
	      }
	    }
	
	    return optionChanged;
	  },
	
	  /**
	   * @protected
	   */
	  mergeOption: function (newOption) {
	    var option = this.option;
	    var componentsMap = this._componentsMap;
	    var newCptTypes = [];
	    resetSourceDefaulter(this); // If no component class, merge directly.
	    // For example: color, animaiton options, etc.
	
	    each(newOption, function (componentOption, mainType) {
	      if (componentOption == null) {
	        return;
	      }
	
	      if (!ComponentModel.hasClass(mainType)) {
	        // globalSettingTask.dirty();
	        option[mainType] = option[mainType] == null ? clone(componentOption) : merge(option[mainType], componentOption, true);
	      } else if (mainType) {
	        newCptTypes.push(mainType);
	      }
	    });
	    ComponentModel.topologicalTravel(newCptTypes, ComponentModel.getAllClassMainTypes(), visitComponent, this);
	
	    function visitComponent(mainType, dependencies) {
	      var newCptOptionList = modelUtil.normalizeToArray(newOption[mainType]);
	      var mapResult = modelUtil.mappingToExists(componentsMap.get(mainType), newCptOptionList);
	      modelUtil.makeIdAndName(mapResult); // Set mainType and complete subType.
	
	      each(mapResult, function (item, index) {
	        var opt = item.option;
	
	        if (isObject(opt)) {
	          item.keyInfo.mainType = mainType;
	          item.keyInfo.subType = determineSubType(mainType, opt, item.exist);
	        }
	      });
	      var dependentModels = getComponentsByTypes(componentsMap, dependencies);
	      option[mainType] = [];
	      componentsMap.set(mainType, []);
	      each(mapResult, function (resultItem, index) {
	        var componentModel = resultItem.exist;
	        var newCptOption = resultItem.option;
	        assert(isObject(newCptOption) || componentModel, 'Empty component definition'); // Consider where is no new option and should be merged using {},
	        // see removeEdgeAndAdd in topologicalTravel and
	        // ComponentModel.getAllClassMainTypes.
	
	        if (!newCptOption) {
	          componentModel.mergeOption({}, this);
	          componentModel.optionUpdated({}, false);
	        } else {
	          var ComponentModelClass = ComponentModel.getClass(mainType, resultItem.keyInfo.subType, true);
	
	          if (componentModel && componentModel.constructor === ComponentModelClass) {
	            componentModel.name = resultItem.keyInfo.name; // componentModel.settingTask && componentModel.settingTask.dirty();
	
	            componentModel.mergeOption(newCptOption, this);
	            componentModel.optionUpdated(newCptOption, false);
	          } else {
	            // PENDING Global as parent ?
	            var extraOpt = extend({
	              dependentModels: dependentModels,
	              componentIndex: index
	            }, resultItem.keyInfo);
	            componentModel = new ComponentModelClass(newCptOption, this, this, extraOpt);
	            extend(componentModel, extraOpt);
	            componentModel.init(newCptOption, this, this, extraOpt); // Call optionUpdated after init.
	            // newCptOption has been used as componentModel.option
	            // and may be merged with theme and default, so pass null
	            // to avoid confusion.
	
	            componentModel.optionUpdated(null, true);
	          }
	        }
	
	        componentsMap.get(mainType)[index] = componentModel;
	        option[mainType][index] = componentModel.option;
	      }, this); // Backup series for filtering.
	
	      if (mainType === 'series') {
	        createSeriesIndices(this, componentsMap.get('series'));
	      }
	    }
	
	    this._seriesIndicesMap = createHashMap(this._seriesIndices = this._seriesIndices || []);
	  },
	
	  /**
	   * Get option for output (cloned option and inner info removed)
	   * @public
	   * @return {Object}
	   */
	  getOption: function () {
	    var option = clone(this.option);
	    each(option, function (opts, mainType) {
	      if (ComponentModel.hasClass(mainType)) {
	        var opts = modelUtil.normalizeToArray(opts);
	
	        for (var i = opts.length - 1; i >= 0; i--) {
	          // Remove options with inner id.
	          if (modelUtil.isIdInner(opts[i])) {
	            opts.splice(i, 1);
	          }
	        }
	
	        option[mainType] = opts;
	      }
	    });
	    delete option[OPTION_INNER_KEY];
	    return option;
	  },
	
	  /**
	   * @return {module:echarts/model/Model}
	   */
	  getTheme: function () {
	    return this._theme;
	  },
	
	  /**
	   * @param {string} mainType
	   * @param {number} [idx=0]
	   * @return {module:echarts/model/Component}
	   */
	  getComponent: function (mainType, idx) {
	    var list = this._componentsMap.get(mainType);
	
	    if (list) {
	      return list[idx || 0];
	    }
	  },
	
	  /**
	   * If none of index and id and name used, return all components with mainType.
	   * @param {Object} condition
	   * @param {string} condition.mainType
	   * @param {string} [condition.subType] If ignore, only query by mainType
	   * @param {number|Array.<number>} [condition.index] Either input index or id or name.
	   * @param {string|Array.<string>} [condition.id] Either input index or id or name.
	   * @param {string|Array.<string>} [condition.name] Either input index or id or name.
	   * @return {Array.<module:echarts/model/Component>}
	   */
	  queryComponents: function (condition) {
	    var mainType = condition.mainType;
	
	    if (!mainType) {
	      return [];
	    }
	
	    var index = condition.index;
	    var id = condition.id;
	    var name = condition.name;
	
	    var cpts = this._componentsMap.get(mainType);
	
	    if (!cpts || !cpts.length) {
	      return [];
	    }
	
	    var result;
	
	    if (index != null) {
	      if (!isArray(index)) {
	        index = [index];
	      }
	
	      result = filter(map(index, function (idx) {
	        return cpts[idx];
	      }), function (val) {
	        return !!val;
	      });
	    } else if (id != null) {
	      var isIdArray = isArray(id);
	      result = filter(cpts, function (cpt) {
	        return isIdArray && indexOf(id, cpt.id) >= 0 || !isIdArray && cpt.id === id;
	      });
	    } else if (name != null) {
	      var isNameArray = isArray(name);
	      result = filter(cpts, function (cpt) {
	        return isNameArray && indexOf(name, cpt.name) >= 0 || !isNameArray && cpt.name === name;
	      });
	    } else {
	      // Return all components with mainType
	      result = cpts.slice();
	    }
	
	    return filterBySubType(result, condition);
	  },
	
	  /**
	   * The interface is different from queryComponents,
	   * which is convenient for inner usage.
	   *
	   * @usage
	   * var result = findComponents(
	   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}}
	   * );
	   * var result = findComponents(
	   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}}
	   * );
	   * var result = findComponents(
	   *     {mainType: 'series',
	   *     filter: function (model, index) {...}}
	   * );
	   * // result like [component0, componnet1, ...]
	   *
	   * @param {Object} condition
	   * @param {string} condition.mainType Mandatory.
	   * @param {string} [condition.subType] Optional.
	   * @param {Object} [condition.query] like {xxxIndex, xxxId, xxxName},
	   *        where xxx is mainType.
	   *        If query attribute is null/undefined or has no index/id/name,
	   *        do not filtering by query conditions, which is convenient for
	   *        no-payload situations or when target of action is global.
	   * @param {Function} [condition.filter] parameter: component, return boolean.
	   * @return {Array.<module:echarts/model/Component>}
	   */
	  findComponents: function (condition) {
	    var query = condition.query;
	    var mainType = condition.mainType;
	    var queryCond = getQueryCond(query);
	    var result = queryCond ? this.queryComponents(queryCond) : this._componentsMap.get(mainType);
	    return doFilter(filterBySubType(result, condition));
	
	    function getQueryCond(q) {
	      var indexAttr = mainType + 'Index';
	      var idAttr = mainType + 'Id';
	      var nameAttr = mainType + 'Name';
	      return q && (q[indexAttr] != null || q[idAttr] != null || q[nameAttr] != null) ? {
	        mainType: mainType,
	        // subType will be filtered finally.
	        index: q[indexAttr],
	        id: q[idAttr],
	        name: q[nameAttr]
	      } : null;
	    }
	
	    function doFilter(res) {
	      return condition.filter ? filter(res, condition.filter) : res;
	    }
	  },
	
	  /**
	   * @usage
	   * eachComponent('legend', function (legendModel, index) {
	   *     ...
	   * });
	   * eachComponent(function (componentType, model, index) {
	   *     // componentType does not include subType
	   *     // (componentType is 'xxx' but not 'xxx.aa')
	   * });
	   * eachComponent(
	   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}},
	   *     function (model, index) {...}
	   * );
	   * eachComponent(
	   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}},
	   *     function (model, index) {...}
	   * );
	   *
	   * @param {string|Object=} mainType When mainType is object, the definition
	   *                                  is the same as the method 'findComponents'.
	   * @param {Function} cb
	   * @param {*} context
	   */
	  eachComponent: function (mainType, cb, context) {
	    var componentsMap = this._componentsMap;
	
	    if (typeof mainType === 'function') {
	      context = cb;
	      cb = mainType;
	      componentsMap.each(function (components, componentType) {
	        each(components, function (component, index) {
	          cb.call(context, componentType, component, index);
	        });
	      });
	    } else if (isString(mainType)) {
	      each(componentsMap.get(mainType), cb, context);
	    } else if (isObject(mainType)) {
	      var queryResult = this.findComponents(mainType);
	      each(queryResult, cb, context);
	    }
	  },
	
	  /**
	   * @param {string} name
	   * @return {Array.<module:echarts/model/Series>}
	   */
	  getSeriesByName: function (name) {
	    var series = this._componentsMap.get('series');
	
	    return filter(series, function (oneSeries) {
	      return oneSeries.name === name;
	    });
	  },
	
	  /**
	   * @param {number} seriesIndex
	   * @return {module:echarts/model/Series}
	   */
	  getSeriesByIndex: function (seriesIndex) {
	    return this._componentsMap.get('series')[seriesIndex];
	  },
	
	  /**
	   * Get series list before filtered by type.
	   * FIXME: rename to getRawSeriesByType?
	   *
	   * @param {string} subType
	   * @return {Array.<module:echarts/model/Series>}
	   */
	  getSeriesByType: function (subType) {
	    var series = this._componentsMap.get('series');
	
	    return filter(series, function (oneSeries) {
	      return oneSeries.subType === subType;
	    });
	  },
	
	  /**
	   * @return {Array.<module:echarts/model/Series>}
	   */
	  getSeries: function () {
	    return this._componentsMap.get('series').slice();
	  },
	
	  /**
	   * @return {number}
	   */
	  getSeriesCount: function () {
	    return this._componentsMap.get('series').length;
	  },
	
	  /**
	   * After filtering, series may be different
	   * frome raw series.
	   *
	   * @param {Function} cb
	   * @param {*} context
	   */
	  eachSeries: function (cb, context) {
	    assertSeriesInitialized(this);
	    each(this._seriesIndices, function (rawSeriesIndex) {
	      var series = this._componentsMap.get('series')[rawSeriesIndex];
	
	      cb.call(context, series, rawSeriesIndex);
	    }, this);
	  },
	
	  /**
	   * Iterate raw series before filtered.
	   *
	   * @param {Function} cb
	   * @param {*} context
	   */
	  eachRawSeries: function (cb, context) {
	    each(this._componentsMap.get('series'), cb, context);
	  },
	
	  /**
	   * After filtering, series may be different.
	   * frome raw series.
	   *
	   * @param {string} subType.
	   * @param {Function} cb
	   * @param {*} context
	   */
	  eachSeriesByType: function (subType, cb, context) {
	    assertSeriesInitialized(this);
	    each(this._seriesIndices, function (rawSeriesIndex) {
	      var series = this._componentsMap.get('series')[rawSeriesIndex];
	
	      if (series.subType === subType) {
	        cb.call(context, series, rawSeriesIndex);
	      }
	    }, this);
	  },
	
	  /**
	   * Iterate raw series before filtered of given type.
	   *
	   * @parma {string} subType
	   * @param {Function} cb
	   * @param {*} context
	   */
	  eachRawSeriesByType: function (subType, cb, context) {
	    return each(this.getSeriesByType(subType), cb, context);
	  },
	
	  /**
	   * @param {module:echarts/model/Series} seriesModel
	   */
	  isSeriesFiltered: function (seriesModel) {
	    assertSeriesInitialized(this);
	    return this._seriesIndicesMap.get(seriesModel.componentIndex) == null;
	  },
	
	  /**
	   * @return {Array.<number>}
	   */
	  getCurrentSeriesIndices: function () {
	    return (this._seriesIndices || []).slice();
	  },
	
	  /**
	   * @param {Function} cb
	   * @param {*} context
	   */
	  filterSeries: function (cb, context) {
	    assertSeriesInitialized(this);
	    var filteredSeries = filter(this._componentsMap.get('series'), cb, context);
	    createSeriesIndices(this, filteredSeries);
	  },
	  restoreData: function (payload) {
	    var componentsMap = this._componentsMap;
	    createSeriesIndices(this, componentsMap.get('series'));
	    var componentTypes = [];
	    componentsMap.each(function (components, componentType) {
	      componentTypes.push(componentType);
	    });
	    ComponentModel.topologicalTravel(componentTypes, ComponentModel.getAllClassMainTypes(), function (componentType, dependencies) {
	      each(componentsMap.get(componentType), function (component) {
	        (componentType !== 'series' || !isNotTargetSeries(component, payload)) && component.restoreData();
	      });
	    });
	  }
	});
	
	function isNotTargetSeries(seriesModel, payload) {
	  if (payload) {
	    var index = payload.seiresIndex;
	    var id = payload.seriesId;
	    var name = payload.seriesName;
	    return index != null && seriesModel.componentIndex !== index || id != null && seriesModel.id !== id || name != null && seriesModel.name !== name;
	  }
	}
	/**
	 * @inner
	 */
	
	
	function mergeTheme(option, theme) {
	  // PENDING
	  // NOT use `colorLayer` in theme if option has `color`
	  var notMergeColorLayer = option.color && !option.colorLayer;
	  each(theme, function (themeItem, name) {
	    if (name === 'colorLayer' && notMergeColorLayer) {
	      return;
	    } // 如果有 component model 则把具体的 merge 逻辑交给该 model 处理
	
	
	    if (!ComponentModel.hasClass(name)) {
	      if (typeof themeItem === 'object') {
	        option[name] = !option[name] ? clone(themeItem) : merge(option[name], themeItem, false);
	      } else {
	        if (option[name] == null) {
	          option[name] = themeItem;
	        }
	      }
	    }
	  });
	}
	
	function initBase(baseOption) {
	  baseOption = baseOption; // Using OPTION_INNER_KEY to mark that this option can not be used outside,
	  // i.e. `chart.setOption(chart.getModel().option);` is forbiden.
	
	  this.option = {};
	  this.option[OPTION_INNER_KEY] = 1;
	  /**
	   * Init with series: [], in case of calling findSeries method
	   * before series initialized.
	   * @type {Object.<string, Array.<module:echarts/model/Model>>}
	   * @private
	   */
	
	  this._componentsMap = createHashMap({
	    series: []
	  });
	  /**
	   * Mapping between filtered series list and raw series list.
	   * key: filtered series indices, value: raw series indices.
	   * @type {Array.<nubmer>}
	   * @private
	   */
	
	  this._seriesIndices;
	  this._seriesIndicesMap;
	  mergeTheme(baseOption, this._theme.option); // TODO Needs clone when merging to the unexisted property
	
	  merge(baseOption, globalDefault, false);
	  this.mergeOption(baseOption);
	}
	/**
	 * @inner
	 * @param {Array.<string>|string} types model types
	 * @return {Object} key: {string} type, value: {Array.<Object>} models
	 */
	
	
	function getComponentsByTypes(componentsMap, types) {
	  if (!isArray(types)) {
	    types = types ? [types] : [];
	  }
	
	  var ret = {};
	  each(types, function (type) {
	    ret[type] = (componentsMap.get(type) || []).slice();
	  });
	  return ret;
	}
	/**
	 * @inner
	 */
	
	
	function determineSubType(mainType, newCptOption, existComponent) {
	  var subType = newCptOption.type ? newCptOption.type : existComponent ? existComponent.subType // Use determineSubType only when there is no existComponent.
	  : ComponentModel.determineSubType(mainType, newCptOption); // tooltip, markline, markpoint may always has no subType
	
	  return subType;
	}
	/**
	 * @inner
	 */
	
	
	function createSeriesIndices(ecModel, seriesModels) {
	  ecModel._seriesIndicesMap = createHashMap(ecModel._seriesIndices = map(seriesModels, function (series) {
	    return series.componentIndex;
	  }) || []);
	}
	/**
	 * @inner
	 */
	
	
	function filterBySubType(components, condition) {
	  // Using hasOwnProperty for restrict. Consider
	  // subType is undefined in user payload.
	  return condition.hasOwnProperty('subType') ? filter(components, function (cpt) {
	    return cpt.subType === condition.subType;
	  }) : components;
	}
	/**
	 * @inner
	 */
	
	
	function assertSeriesInitialized(ecModel) {}
	
	mixin(GlobalModel, colorPaletteMixin);
	var _default = GlobalModel;
	module.exports = _default;

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _model = __webpack_require__(24);
	
	var makeInner = _model.makeInner;
	var normalizeToArray = _model.normalizeToArray;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = makeInner();
	
	function getNearestColorPalette(colors, requestColorNum) {
	  var paletteNum = colors.length; // TODO colors must be in order
	
	  for (var i = 0; i < paletteNum; i++) {
	    if (colors[i].length > requestColorNum) {
	      return colors[i];
	    }
	  }
	
	  return colors[paletteNum - 1];
	}
	
	var _default = {
	  clearColorPalette: function () {
	    inner(this).colorIdx = 0;
	    inner(this).colorNameMap = {};
	  },
	
	  /**
	   * @param {string} name MUST NOT be null/undefined. Otherwise call this function
	   *                 twise with the same parameters will get different result.
	   * @param {Object} [scope=this]
	   * @param {Object} [requestColorNum]
	   * @return {string} color string.
	   */
	  getColorFromPalette: function (name, scope, requestColorNum) {
	    scope = scope || this;
	    var scopeFields = inner(scope);
	    var colorIdx = scopeFields.colorIdx || 0;
	    var colorNameMap = scopeFields.colorNameMap = scopeFields.colorNameMap || {}; // Use `hasOwnProperty` to avoid conflict with Object.prototype.
	
	    if (colorNameMap.hasOwnProperty(name)) {
	      return colorNameMap[name];
	    }
	
	    var defaultColorPalette = normalizeToArray(this.get('color', true));
	    var layeredColorPalette = this.get('colorLayer', true);
	    var colorPalette = requestColorNum == null || !layeredColorPalette ? defaultColorPalette : getNearestColorPalette(layeredColorPalette, requestColorNum); // In case can't find in layered color palette.
	
	    colorPalette = colorPalette || defaultColorPalette;
	
	    if (!colorPalette || !colorPalette.length) {
	      return;
	    }
	
	    var color = colorPalette[colorIdx];
	
	    if (name) {
	      colorNameMap[name] = color;
	    }
	
	    scopeFields.colorIdx = (colorIdx + 1) % colorPalette.length;
	    return color;
	  }
	};
	module.exports = _default;

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var Scale = __webpack_require__(339);
	
	var numberUtil = __webpack_require__(20);
	
	var IntervalScale = __webpack_require__(338);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Log scale
	 * @module echarts/scale/Log
	 */
	// Use some method of IntervalScale
	var scaleProto = Scale.prototype;
	var intervalScaleProto = IntervalScale.prototype;
	var getPrecisionSafe = numberUtil.getPrecisionSafe;
	var roundingErrorFix = numberUtil.round;
	var mathFloor = Math.floor;
	var mathCeil = Math.ceil;
	var mathPow = Math.pow;
	var mathLog = Math.log;
	var LogScale = Scale.extend({
	  type: 'log',
	  base: 10,
	  $constructor: function () {
	    Scale.apply(this, arguments);
	    this._originalScale = new IntervalScale();
	  },
	
	  /**
	   * @param {boolean} [expandToNicedExtent=false] If expand the ticks to niced extent.
	   * @return {Array.<number>}
	   */
	  getTicks: function (expandToNicedExtent) {
	    var originalScale = this._originalScale;
	    var extent = this._extent;
	    var originalExtent = originalScale.getExtent();
	    return zrUtil.map(intervalScaleProto.getTicks.call(this, expandToNicedExtent), function (val) {
	      var powVal = numberUtil.round(mathPow(this.base, val)); // Fix #4158
	
	      powVal = val === extent[0] && originalScale.__fixMin ? fixRoundingError(powVal, originalExtent[0]) : powVal;
	      powVal = val === extent[1] && originalScale.__fixMax ? fixRoundingError(powVal, originalExtent[1]) : powVal;
	      return powVal;
	    }, this);
	  },
	
	  /**
	   * @param {number} splitNumber
	   * @return {Array.<Array.<number>>}
	   */
	  getMinorTicks: intervalScaleProto.getMinorTicks,
	
	  /**
	   * @param {number} val
	   * @return {string}
	   */
	  getLabel: intervalScaleProto.getLabel,
	
	  /**
	   * @param  {number} val
	   * @return {number}
	   */
	  scale: function (val) {
	    val = scaleProto.scale.call(this, val);
	    return mathPow(this.base, val);
	  },
	
	  /**
	   * @param {number} start
	   * @param {number} end
	   */
	  setExtent: function (start, end) {
	    var base = this.base;
	    start = mathLog(start) / mathLog(base);
	    end = mathLog(end) / mathLog(base);
	    intervalScaleProto.setExtent.call(this, start, end);
	  },
	
	  /**
	   * @return {number} end
	   */
	  getExtent: function () {
	    var base = this.base;
	    var extent = scaleProto.getExtent.call(this);
	    extent[0] = mathPow(base, extent[0]);
	    extent[1] = mathPow(base, extent[1]); // Fix #4158
	
	    var originalScale = this._originalScale;
	    var originalExtent = originalScale.getExtent();
	    originalScale.__fixMin && (extent[0] = fixRoundingError(extent[0], originalExtent[0]));
	    originalScale.__fixMax && (extent[1] = fixRoundingError(extent[1], originalExtent[1]));
	    return extent;
	  },
	
	  /**
	   * @param  {Array.<number>} extent
	   */
	  unionExtent: function (extent) {
	    this._originalScale.unionExtent(extent);
	
	    var base = this.base;
	    extent[0] = mathLog(extent[0]) / mathLog(base);
	    extent[1] = mathLog(extent[1]) / mathLog(base);
	    scaleProto.unionExtent.call(this, extent);
	  },
	
	  /**
	   * @override
	   */
	  unionExtentFromData: function (data, dim) {
	    // TODO
	    // filter value that <= 0
	    this.unionExtent(data.getApproximateExtent(dim));
	  },
	
	  /**
	   * Update interval and extent of intervals for nice ticks
	   * @param  {number} [approxTickNum = 10] Given approx tick number
	   */
	  niceTicks: function (approxTickNum) {
	    approxTickNum = approxTickNum || 10;
	    var extent = this._extent;
	    var span = extent[1] - extent[0];
	
	    if (span === Infinity || span <= 0) {
	      return;
	    }
	
	    var interval = numberUtil.quantity(span);
	    var err = approxTickNum / span * interval; // Filter ticks to get closer to the desired count.
	
	    if (err <= 0.5) {
	      interval *= 10;
	    } // Interval should be integer
	
	
	    while (!isNaN(interval) && Math.abs(interval) < 1 && Math.abs(interval) > 0) {
	      interval *= 10;
	    }
	
	    var niceExtent = [numberUtil.round(mathCeil(extent[0] / interval) * interval), numberUtil.round(mathFloor(extent[1] / interval) * interval)];
	    this._interval = interval;
	    this._niceExtent = niceExtent;
	  },
	
	  /**
	   * Nice extent.
	   * @override
	   */
	  niceExtent: function (opt) {
	    intervalScaleProto.niceExtent.call(this, opt);
	    var originalScale = this._originalScale;
	    originalScale.__fixMin = opt.fixMin;
	    originalScale.__fixMax = opt.fixMax;
	  }
	});
	zrUtil.each(['contain', 'normalize'], function (methodName) {
	  LogScale.prototype[methodName] = function (val) {
	    val = mathLog(val) / mathLog(this.base);
	    return scaleProto[methodName].call(this, val);
	  };
	});
	
	LogScale.create = function () {
	  return new LogScale();
	};
	
	function fixRoundingError(val, originalVal) {
	  return roundingErrorFix(val, getPrecisionSafe(originalVal));
	}
	
	var _default = LogScale;
	module.exports = _default;

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var numberUtil = __webpack_require__(20);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * For testable.
	 */
	var roundNumber = numberUtil.round;
	/**
	 * @param {Array.<number>} extent Both extent[0] and extent[1] should be valid number.
	 *                                Should be extent[0] < extent[1].
	 * @param {number} splitNumber splitNumber should be >= 1.
	 * @param {number} [minInterval]
	 * @param {number} [maxInterval]
	 * @return {Object} {interval, intervalPrecision, niceTickExtent}
	 */
	
	function intervalScaleNiceTicks(extent, splitNumber, minInterval, maxInterval) {
	  var result = {};
	  var span = extent[1] - extent[0];
	  var interval = result.interval = numberUtil.nice(span / splitNumber, true);
	
	  if (minInterval != null && interval < minInterval) {
	    interval = result.interval = minInterval;
	  }
	
	  if (maxInterval != null && interval > maxInterval) {
	    interval = result.interval = maxInterval;
	  } // Tow more digital for tick.
	
	
	  var precision = result.intervalPrecision = getIntervalPrecision(interval); // Niced extent inside original extent
	
	  var niceTickExtent = result.niceTickExtent = [roundNumber(Math.ceil(extent[0] / interval) * interval, precision), roundNumber(Math.floor(extent[1] / interval) * interval, precision)];
	  fixExtent(niceTickExtent, extent);
	  return result;
	}
	/**
	 * @param {number} interval
	 * @return {number} interval precision
	 */
	
	
	function getIntervalPrecision(interval) {
	  // Tow more digital for tick.
	  return numberUtil.getPrecisionSafe(interval) + 2;
	}
	
	function clamp(niceTickExtent, idx, extent) {
	  niceTickExtent[idx] = Math.max(Math.min(niceTickExtent[idx], extent[1]), extent[0]);
	} // In some cases (e.g., splitNumber is 1), niceTickExtent may be out of extent.
	
	
	function fixExtent(niceTickExtent, extent) {
	  !isFinite(niceTickExtent[0]) && (niceTickExtent[0] = extent[0]);
	  !isFinite(niceTickExtent[1]) && (niceTickExtent[1] = extent[1]);
	  clamp(niceTickExtent, 0, extent);
	  clamp(niceTickExtent, 1, extent);
	
	  if (niceTickExtent[0] > niceTickExtent[1]) {
	    niceTickExtent[0] = niceTickExtent[1];
	  }
	}
	
	exports.intervalScaleNiceTicks = intervalScaleNiceTicks;
	exports.getIntervalPrecision = getIntervalPrecision;
	exports.fixExtent = fixExtent;

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @file Visual mapping.
	 */
	var visualDefault = {
	  /**
	   * @public
	   */
	  get: function (visualType, key, isCategory) {
	    var value = zrUtil.clone((defaultOption[visualType] || {})[key]);
	    return isCategory ? zrUtil.isArray(value) ? value[value.length - 1] : value : value;
	  }
	};
	var defaultOption = {
	  color: {
	    active: ['#006edd', '#e0ffff'],
	    inactive: ['rgba(0,0,0,0)']
	  },
	  colorHue: {
	    active: [0, 360],
	    inactive: [0, 0]
	  },
	  colorSaturation: {
	    active: [0.3, 1],
	    inactive: [0, 0]
	  },
	  colorLightness: {
	    active: [0.9, 0.5],
	    inactive: [0, 0]
	  },
	  colorAlpha: {
	    active: [0.3, 1],
	    inactive: [0, 0]
	  },
	  opacity: {
	    active: [0.3, 1],
	    inactive: [0, 0]
	  },
	  symbol: {
	    active: ['circle', 'roundRect', 'diamond'],
	    inactive: ['none']
	  },
	  symbolSize: {
	    active: [10, 50],
	    inactive: [0, 0]
	  }
	};
	var _default = visualDefault;
	module.exports = _default;

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(107);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(1730);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 756 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 757 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(1736);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 759 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/* globals
		AggregateError,
		Atomics,
		FinalizationRegistry,
		SharedArrayBuffer,
		WeakRef,
	*/
	
	var undefined;
	
	var $SyntaxError = SyntaxError;
	var $Function = Function;
	var $TypeError = TypeError;
	
	// eslint-disable-next-line consistent-return
	var getEvalledConstructor = function (expressionSyntax) {
		try {
			// eslint-disable-next-line no-new-func
			return Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
		} catch (e) {}
	};
	
	var $gOPD = Object.getOwnPropertyDescriptor;
	if ($gOPD) {
		try {
			$gOPD({}, '');
		} catch (e) {
			$gOPD = null; // this is IE 8, which has a broken gOPD
		}
	}
	
	var throwTypeError = function () {
		throw new $TypeError();
	};
	var ThrowTypeError = $gOPD
		? (function () {
			try {
				// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
				arguments.callee; // IE 8 does not throw here
				return throwTypeError;
			} catch (calleeThrows) {
				try {
					// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
					return $gOPD(arguments, 'callee').get;
				} catch (gOPDthrows) {
					return throwTypeError;
				}
			}
		}())
		: throwTypeError;
	
	var hasSymbols = __webpack_require__(343)();
	
	var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto
	
	var asyncGenFunction = getEvalledConstructor('async function* () {}');
	var asyncGenFunctionPrototype = asyncGenFunction ? asyncGenFunction.prototype : undefined;
	var asyncGenPrototype = asyncGenFunctionPrototype ? asyncGenFunctionPrototype.prototype : undefined;
	
	var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);
	
	var INTRINSICS = {
		'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
		'%Array%': Array,
		'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
		'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
		'%AsyncFromSyncIteratorPrototype%': undefined,
		'%AsyncFunction%': getEvalledConstructor('async function () {}'),
		'%AsyncGenerator%': asyncGenFunctionPrototype,
		'%AsyncGeneratorFunction%': asyncGenFunction,
		'%AsyncIteratorPrototype%': asyncGenPrototype ? getProto(asyncGenPrototype) : undefined,
		'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
		'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
		'%Boolean%': Boolean,
		'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
		'%Date%': Date,
		'%decodeURI%': decodeURI,
		'%decodeURIComponent%': decodeURIComponent,
		'%encodeURI%': encodeURI,
		'%encodeURIComponent%': encodeURIComponent,
		'%Error%': Error,
		'%eval%': eval, // eslint-disable-line no-eval
		'%EvalError%': EvalError,
		'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
		'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
		'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
		'%Function%': $Function,
		'%GeneratorFunction%': getEvalledConstructor('function* () {}'),
		'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
		'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
		'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
		'%isFinite%': isFinite,
		'%isNaN%': isNaN,
		'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
		'%JSON%': typeof JSON === 'object' ? JSON : undefined,
		'%Map%': typeof Map === 'undefined' ? undefined : Map,
		'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
		'%Math%': Math,
		'%Number%': Number,
		'%Object%': Object,
		'%parseFloat%': parseFloat,
		'%parseInt%': parseInt,
		'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
		'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
		'%RangeError%': RangeError,
		'%ReferenceError%': ReferenceError,
		'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
		'%RegExp%': RegExp,
		'%Set%': typeof Set === 'undefined' ? undefined : Set,
		'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
		'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
		'%String%': String,
		'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
		'%Symbol%': hasSymbols ? Symbol : undefined,
		'%SyntaxError%': $SyntaxError,
		'%ThrowTypeError%': ThrowTypeError,
		'%TypedArray%': TypedArray,
		'%TypeError%': $TypeError,
		'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
		'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
		'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
		'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
		'%URIError%': URIError,
		'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
		'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
		'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
	};
	
	var LEGACY_ALIASES = {
		'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
		'%ArrayPrototype%': ['Array', 'prototype'],
		'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
		'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
		'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
		'%ArrayProto_values%': ['Array', 'prototype', 'values'],
		'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
		'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
		'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
		'%BooleanPrototype%': ['Boolean', 'prototype'],
		'%DataViewPrototype%': ['DataView', 'prototype'],
		'%DatePrototype%': ['Date', 'prototype'],
		'%ErrorPrototype%': ['Error', 'prototype'],
		'%EvalErrorPrototype%': ['EvalError', 'prototype'],
		'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
		'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
		'%FunctionPrototype%': ['Function', 'prototype'],
		'%Generator%': ['GeneratorFunction', 'prototype'],
		'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
		'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
		'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
		'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
		'%JSONParse%': ['JSON', 'parse'],
		'%JSONStringify%': ['JSON', 'stringify'],
		'%MapPrototype%': ['Map', 'prototype'],
		'%NumberPrototype%': ['Number', 'prototype'],
		'%ObjectPrototype%': ['Object', 'prototype'],
		'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
		'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
		'%PromisePrototype%': ['Promise', 'prototype'],
		'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
		'%Promise_all%': ['Promise', 'all'],
		'%Promise_reject%': ['Promise', 'reject'],
		'%Promise_resolve%': ['Promise', 'resolve'],
		'%RangeErrorPrototype%': ['RangeError', 'prototype'],
		'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
		'%RegExpPrototype%': ['RegExp', 'prototype'],
		'%SetPrototype%': ['Set', 'prototype'],
		'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
		'%StringPrototype%': ['String', 'prototype'],
		'%SymbolPrototype%': ['Symbol', 'prototype'],
		'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
		'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
		'%TypeErrorPrototype%': ['TypeError', 'prototype'],
		'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
		'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
		'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
		'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
		'%URIErrorPrototype%': ['URIError', 'prototype'],
		'%WeakMapPrototype%': ['WeakMap', 'prototype'],
		'%WeakSetPrototype%': ['WeakSet', 'prototype']
	};
	
	var bind = __webpack_require__(170);
	var hasOwn = __webpack_require__(479);
	var $concat = bind.call(Function.call, Array.prototype.concat);
	var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
	var $replace = bind.call(Function.call, String.prototype.replace);
	
	/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
	var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
	var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
	var stringToPath = function stringToPath(string) {
		var result = [];
		$replace(string, rePropName, function (match, number, quote, subString) {
			result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
		});
		return result;
	};
	/* end adaptation */
	
	var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
		var intrinsicName = name;
		var alias;
		if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
			alias = LEGACY_ALIASES[intrinsicName];
			intrinsicName = '%' + alias[0] + '%';
		}
	
		if (hasOwn(INTRINSICS, intrinsicName)) {
			var value = INTRINSICS[intrinsicName];
			if (typeof value === 'undefined' && !allowMissing) {
				throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
			}
	
			return {
				alias: alias,
				name: intrinsicName,
				value: value
			};
		}
	
		throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
	};
	
	module.exports = function GetIntrinsic(name, allowMissing) {
		if (typeof name !== 'string' || name.length === 0) {
			throw new $TypeError('intrinsic name must be a non-empty string');
		}
		if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
			throw new $TypeError('"allowMissing" argument must be a boolean');
		}
	
		var parts = stringToPath(name);
		var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
	
		var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
		var intrinsicRealName = intrinsic.name;
		var value = intrinsic.value;
		var skipFurtherCaching = false;
	
		var alias = intrinsic.alias;
		if (alias) {
			intrinsicBaseName = alias[0];
			$spliceApply(parts, $concat([0, 1], alias));
		}
	
		for (var i = 1, isOwn = true; i < parts.length; i += 1) {
			var part = parts[i];
			if (part === 'constructor' || !isOwn) {
				skipFurtherCaching = true;
			}
	
			intrinsicBaseName += '.' + part;
			intrinsicRealName = '%' + intrinsicBaseName + '%';
	
			if (hasOwn(INTRINSICS, intrinsicRealName)) {
				value = INTRINSICS[intrinsicRealName];
			} else if (value != null) {
				if ($gOPD && (i + 1) >= parts.length) {
					var desc = $gOPD(value, part);
					isOwn = !!desc;
	
					if (!allowMissing && !(part in value)) {
						throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
					}
					// By convention, when a data property is converted to an accessor
					// property to emulate a data property that does not suffer from
					// the override mistake, that accessor's getter is marked with
					// an `originalValue` property. Here, when we detect this, we
					// uphold the illusion by pretending to see that original data
					// property, i.e., returning the value rather than the getter
					// itself.
					if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
						value = desc.get;
					} else {
						value = value[part];
					}
				} else {
					isOwn = hasOwn(value, part);
					value = value[part];
				}
	
				if (isOwn && !skipFurtherCaching) {
					INTRINSICS[intrinsicRealName] = value;
				}
			}
		}
		return value;
	};


/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.processStyleName = undefined;
	exports.createMarkupForStyles = createMarkupForStyles;
	
	var _camelizeStyleName = __webpack_require__(755);
	
	var _camelizeStyleName2 = _interopRequireDefault(_camelizeStyleName);
	
	var _dangerousStyleValue = __webpack_require__(1741);
	
	var _dangerousStyleValue2 = _interopRequireDefault(_dangerousStyleValue);
	
	var _hyphenateStyleName = __webpack_require__(758);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _memoizeStringOnly = __webpack_require__(759);
	
	var _memoizeStringOnly2 = _interopRequireDefault(_memoizeStringOnly);
	
	var _warning = __webpack_require__(34);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var processStyleName = exports.processStyleName = (0, _memoizeStringOnly2.default)(_hyphenateStyleName2.default); /**
	                                                                                                                   * Copyright 2013-present, Facebook, Inc.
	                                                                                                                   * All rights reserved.
	                                                                                                                   *
	                                                                                                                   * This source code is licensed under the BSD-style license found in the
	                                                                                                                   * LICENSE file in the root directory of this source tree. An additional grant
	                                                                                                                   * of patent rights can be found in the PATENTS file in the same directory.
	                                                                                                                   *
	                                                                                                                   * @providesModule CSSPropertyOperations
	                                                                                                                   */
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function warnHyphenatedStyleName(name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Unsupported style property %s. Did you mean %s?%s', name, (0, _camelizeStyleName2.default)(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function warnBadVendoredStyleName(name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function warnStyleValueWithSemicolon(name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function warnStyleValueIsNaN(name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function checkRenderMessage(owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function warnValidStyle(name, value, component) {
	    //eslint-disable-line no-var
	    var owner = void 0;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	
	function createMarkupForStyles(styles, component) {
	  var serialized = '';
	  for (var styleName in styles) {
	    var isCustomProp = styleName.indexOf('--') === 0;
	    if (!styles.hasOwnProperty(styleName)) {
	      continue;
	    }
	    if (styleName === 'label') {
	      continue;
	    }
	    var styleValue = styles[styleName];
	    if (false) {
	      warnValidStyle(styleName, styleValue, component);
	    }
	    if (styleValue != null) {
	      if (isCustomProp) {
	        serialized += styleName + ':' + styleValue + ';';
	      } else {
	        serialized += processStyleName(styleName) + ':';
	        serialized += (0, _dangerousStyleValue2.default)(styleName, styleValue, component) + ';';
	      }
	    }
	  }
	  return serialized || null;
	}

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	/*eslint-disable no-empty */
	'use strict';
	
	exports.__esModule = true;
	exports.saveState = saveState;
	exports.readState = readState;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(108);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var KeyPrefix = '@@History/';
	var QuotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR'];
	
	var SecurityError = 'SecurityError';
	
	function createKey(key) {
	  return KeyPrefix + key;
	}
	
	function saveState(key, state) {
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;
	
	      return;
	    }
	
	    if (QuotaExceededErrors.indexOf(error.name) >= 0 && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;
	
	      return;
	    }
	
	    throw error;
	  }
	}
	
	function readState(key) {
	  var json = undefined;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;
	
	      return null;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return null;
	}

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(344);
	
	var _DOMUtils = __webpack_require__(480);
	
	var _createHistory = __webpack_require__(765);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createDOMHistory(options) {
	  var history = _createHistory2['default'](_extends({
	    getUserConfirmation: _DOMUtils.getUserConfirmation
	  }, options, {
	    go: _DOMUtils.go
	  }));
	
	  function listen(listener) {
	    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;
	
	    return history.listen(listener);
	  }
	
	  return _extends({}, history, {
	    listen: listen
	  });
	}
	
	exports['default'] = createDOMHistory;
	module.exports = exports['default'];

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(108);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(209);
	
	var _PathUtils = __webpack_require__(171);
	
	var _ExecutionEnvironment = __webpack_require__(344);
	
	var _DOMUtils = __webpack_require__(480);
	
	var _DOMStateStorage = __webpack_require__(762);
	
	var _createDOMHistory = __webpack_require__(763);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	function isAbsolutePath(path) {
	  return typeof path === 'string' && path.charAt(0) === '/';
	}
	
	function ensureSlash() {
	  var path = _DOMUtils.getHashPath();
	
	  if (isAbsolutePath(path)) return true;
	
	  _DOMUtils.replaceHashPath('/' + path);
	
	  return false;
	}
	
	function addQueryStringValueToPath(path, key, value) {
	  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
	}
	
	function stripQueryStringValueFromPath(path, key) {
	  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
	}
	
	function getQueryStringValueFromPath(path, key) {
	  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
	  return match && match[1];
	}
	
	var DefaultQueryKey = '_k';
	
	function createHashHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var queryKey = options.queryKey;
	
	  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;
	
	  function getCurrentLocation() {
	    var path = _DOMUtils.getHashPath();
	
	    var key = undefined,
	        state = undefined;
	    if (queryKey) {
	      key = getQueryStringValueFromPath(path, queryKey);
	      path = stripQueryStringValueFromPath(path, queryKey);
	
	      if (key) {
	        state = _DOMStateStorage.readState(key);
	      } else {
	        state = null;
	        key = history.createKey();
	        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
	      }
	    } else {
	      key = state = null;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startHashChangeListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function hashChangeListener() {
	      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.
	
	      transitionTo(getCurrentLocation());
	    }
	
	    ensureSlash();
	    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    var path = (basename || '') + pathname + search;
	
	    if (queryKey) {
	      path = addQueryStringValueToPath(path, queryKey, key);
	      _DOMStateStorage.saveState(key, state);
	    } else {
	      // Drop key and state.
	      location.key = location.state = null;
	    }
	
	    var currentHash = _DOMUtils.getHashPath();
	
	    if (action === _Actions.PUSH) {
	      if (currentHash !== path) {
	        window.location.hash = path;
	      } else {
	         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
	      }
	    } else if (currentHash !== path) {
	      // REPLACE
	      _DOMUtils.replaceHashPath(path);
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopHashChangeListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function push(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.push(location);
	  }
	
	  function replace(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replace(location);
	  }
	
	  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();
	
	  function go(n) {
	     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;
	
	    history.go(n);
	  }
	
	  function createHref(path) {
	    return '#' + history.createHref(path);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopHashChangeListener();
	  }
	
	  // deprecated
	  function pushState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.pushState(state, path);
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replaceState(state, path);
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    push: push,
	    replace: replace,
	    go: go,
	    createHref: createHref,
	
	    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
	    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
	    pushState: pushState, // deprecated - warning is in createHistory
	    replaceState: replaceState // deprecated - warning is in createHistory
	  });
	}
	
	exports['default'] = createHashHistory;
	module.exports = exports['default'];

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(108);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _deepEqual = __webpack_require__(1429);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _PathUtils = __webpack_require__(171);
	
	var _AsyncUtils = __webpack_require__(1748);
	
	var _Actions = __webpack_require__(209);
	
	var _createLocation2 = __webpack_require__(1750);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _runTransitionHook = __webpack_require__(482);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(481);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function createRandomKey(length) {
	  return Math.random().toString(36).substr(2, length);
	}
	
	function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search &&
	  //a.action === b.action && // Different action !== location change.
	  a.key === b.key && _deepEqual2['default'](a.state, b.state);
	}
	
	var DefaultKeyLength = 6;
	
	function createHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var getCurrentLocation = options.getCurrentLocation;
	  var finishTransition = options.finishTransition;
	  var saveState = options.saveState;
	  var go = options.go;
	  var getUserConfirmation = options.getUserConfirmation;
	  var keyLength = options.keyLength;
	
	  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;
	
	  var transitionHooks = [];
	
	  function listenBefore(hook) {
	    transitionHooks.push(hook);
	
	    return function () {
	      transitionHooks = transitionHooks.filter(function (item) {
	        return item !== hook;
	      });
	    };
	  }
	
	  var allKeys = [];
	  var changeListeners = [];
	  var location = undefined;
	
	  function getCurrent() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) {
	      return allKeys.indexOf(pendingLocation.key);
	    } else if (location) {
	      return allKeys.indexOf(location.key);
	    } else {
	      return -1;
	    }
	  }
	
	  function updateLocation(newLocation) {
	    var current = getCurrent();
	
	    location = newLocation;
	
	    if (location.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
	    } else if (location.action === _Actions.REPLACE) {
	      allKeys[current] = location.key;
	    }
	
	    changeListeners.forEach(function (listener) {
	      listener(location);
	    });
	  }
	
	  function listen(listener) {
	    changeListeners.push(listener);
	
	    if (location) {
	      listener(location);
	    } else {
	      var _location = getCurrentLocation();
	      allKeys = [_location.key];
	      updateLocation(_location);
	    }
	
	    return function () {
	      changeListeners = changeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }
	
	  function confirmTransitionTo(location, callback) {
	    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
	      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
	        if (result != null) {
	          done(result);
	        } else {
	          next();
	        }
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  }
	
	  var pendingLocation = undefined;
	
	  function transitionTo(nextLocation) {
	    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted.
	
	      if (ok) {
	        // treat PUSH to current path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = createPath(location);
	          var nextPath = createPath(nextLocation);
	
	          if (nextPath === prevPath && _deepEqual2['default'](location.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
	      } else if (location && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(location.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
	      }
	    });
	  }
	
	  function push(location) {
	    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
	  }
	
	  function replace(location) {
	    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
	  }
	
	  function goBack() {
	    go(-1);
	  }
	
	  function goForward() {
	    go(1);
	  }
	
	  function createKey() {
	    return createRandomKey(keyLength);
	  }
	
	  function createPath(location) {
	    if (location == null || typeof location === 'string') return location;
	
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	
	    var result = pathname;
	
	    if (search) result += search;
	
	    if (hash) result += hash;
	
	    return result;
	  }
	
	  function createHref(location) {
	    return createPath(location);
	  }
	
	  function createLocation(location, action) {
	    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
	
	    if (typeof action === 'object') {
	       false ? _warning2['default'](false, 'The state (2nd) argument to history.createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      location = _extends({}, location, { state: action });
	
	      action = key;
	      key = arguments[3] || createKey();
	    }
	
	    return _createLocation3['default'](location, action, key);
	  }
	
	  // deprecated
	  function setState(state) {
	    if (location) {
	      updateLocationState(location, state);
	      updateLocation(location);
	    } else {
	      updateLocationState(getCurrentLocation(), state);
	    }
	  }
	
	  function updateLocationState(location, state) {
	    location.state = _extends({}, location.state, state);
	    saveState(location.key, location.state);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    transitionHooks = transitionHooks.filter(function (item) {
	      return item !== hook;
	    });
	  }
	
	  // deprecated
	  function pushState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    push(_extends({ state: state }, path));
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    replace(_extends({ state: state }, path));
	  }
	
	  return {
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: createPath,
	    createHref: createHref,
	    createLocation: createLocation,
	
	    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
	    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
	    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
	    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	  };
	}
	
	exports['default'] = createHistory;
	module.exports = exports['default'];

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(108);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ExecutionEnvironment = __webpack_require__(344);
	
	var _PathUtils = __webpack_require__(171);
	
	var _runTransitionHook = __webpack_require__(482);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(481);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var basename = options.basename;
	
	    var checkedBaseHref = false;
	
	    function checkBaseHref() {
	      if (checkedBaseHref) {
	        return;
	      }
	
	      // Automatically use the value of <base href> in HTML
	      // documents as basename if it's not explicitly given.
	      if (basename == null && _ExecutionEnvironment.canUseDOM) {
	        var base = document.getElementsByTagName('base')[0];
	        var baseHref = base && base.getAttribute('href');
	
	        if (baseHref != null) {
	          basename = baseHref;
	
	           false ? _warning2['default'](false, 'Automatically setting basename using <base href> is deprecated and will ' + 'be removed in the next major release. The semantics of <base href> are ' + 'subtly different from basename. Please pass the basename explicitly in ' + 'the options to createHistory') : undefined;
	        }
	      }
	
	      checkedBaseHref = true;
	    }
	
	    function addBasename(location) {
	      checkBaseHref();
	
	      if (basename && location.basename == null) {
	        if (location.pathname.indexOf(basename) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    }
	
	    function prependBasename(location) {
	      checkBaseHref();
	
	      if (!basename) return location;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var pname = location.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, location, {
	        pathname: pathname
	      });
	    }
	
	    // Override all read methods with basename-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addBasename(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addBasename(location));
	      });
	    }
	
	    // Override all write methods with basename-aware versions.
	    function push(location) {
	      history.push(prependBasename(location));
	    }
	
	    function replace(location) {
	      history.replace(prependBasename(location));
	    }
	
	    function createPath(location) {
	      return history.createPath(prependBasename(location));
	    }
	
	    function createHref(location) {
	      return history.createHref(prependBasename(location));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    }
	
	    // deprecated
	    function pushState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path));
	    }
	
	    // deprecated
	    function replaceState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useBasename;
	module.exports = exports['default'];

/***/ },
/* 767 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint-disable no-var, prefer-template */
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	var cache = {};
	
	function toHyphenLower(match) {
	  return '-' + match.toLowerCase()
	}
	
	function hyphenateStyleName(name) {
	  if (cache.hasOwnProperty(name)) {
	    return cache[name]
	  }
	
	  var hName = name.replace(uppercasePattern, toHyphenLower);
	  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
	}
	
	module.exports = hyphenateStyleName;


/***/ },
/* 768 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = capitalizeString;
	function capitalizeString(str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	}
	module.exports = exports["default"];

/***/ },
/* 769 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var isBrowser = exports.isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;
	
	exports.default = isBrowser;

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(176),
	    root = __webpack_require__(125);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(346),
	    stackClear = __webpack_require__(1866),
	    stackDelete = __webpack_require__(1867),
	    stackGet = __webpack_require__(1868),
	    stackHas = __webpack_require__(1869),
	    stackSet = __webpack_require__(1870);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(1817),
	    isArguments = __webpack_require__(495),
	    isArray = __webpack_require__(35),
	    isBuffer = __webpack_require__(806),
	    isIndex = __webpack_require__(492),
	    isTypedArray = __webpack_require__(809);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 773 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	var baseRandom = __webpack_require__(786);
	
	/**
	 * A specialized version of `_.sample` for arrays.
	 *
	 * @private
	 * @param {Array} array The array to sample.
	 * @returns {*} Returns the random element.
	 */
	function arraySample(array) {
	  var length = array.length;
	  return length ? array[baseRandom(0, length - 1)] : undefined;
	}
	
	module.exports = arraySample;


/***/ },
/* 775 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 776 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.clamp` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {number} number The number to clamp.
	 * @param {number} [lower] The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the clamped number.
	 */
	function baseClamp(number, lower, upper) {
	  if (number === number) {
	    if (upper !== undefined) {
	      number = number <= upper ? number : upper;
	    }
	    if (lower !== undefined) {
	      number = number >= lower ? number : lower;
	    }
	  }
	  return number;
	}
	
	module.exports = baseClamp;


/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(347),
	    arrayIncludes = __webpack_require__(486),
	    arrayIncludesWith = __webpack_require__(487),
	    arrayMap = __webpack_require__(173),
	    baseUnary = __webpack_require__(351),
	    cacheHas = __webpack_require__(352);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee == null ? value : iteratee(value);
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwnRight = __webpack_require__(1794),
	    createBaseEach = __webpack_require__(790);
	
	/**
	 * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	module.exports = baseEachRight;


/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(144);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(489),
	    baseIsNaN = __webpack_require__(1803),
	    strictIndexOf = __webpack_require__(1871);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(1801),
	    isObjectLike = __webpack_require__(146);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(797),
	    nativeKeys = __webpack_require__(1856);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(144),
	    isArrayLike = __webpack_require__(109);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(173),
	    baseGet = __webpack_require__(350),
	    baseIteratee = __webpack_require__(85),
	    baseMap = __webpack_require__(783),
	    baseSortBy = __webpack_require__(1816),
	    baseUnary = __webpack_require__(351),
	    compareMultiple = __webpack_require__(1823),
	    identity = __webpack_require__(273),
	    isArray = __webpack_require__(35);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  if (iteratees.length) {
	    iteratees = arrayMap(iteratees, function(iteratee) {
	      if (isArray(iteratee)) {
	        return function(value) {
	          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	        }
	      }
	      return iteratee;
	    });
	  } else {
	    iteratees = [identity];
	  }
	
	  var index = -1;
	  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ },
/* 785 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 786 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeFloor = Math.floor,
	    nativeRandom = Math.random;
	
	/**
	 * The base implementation of `_.random` without support for returning
	 * floating-point numbers.
	 *
	 * @private
	 * @param {number} lower The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the random number.
	 */
	function baseRandom(lower, upper) {
	  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	}
	
	module.exports = baseRandom;


/***/ },
/* 787 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.reduce` and `_.reduceRight`, without support
	 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} accumulator The initial value.
	 * @param {boolean} initAccum Specify using the first or last element of
	 *  `collection` as the initial value.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @returns {*} Returns the accumulated value.
	 */
	function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	  eachFunc(collection, function(value, index, collection) {
	    accumulator = initAccum
	      ? (initAccum = false, value)
	      : iteratee(accumulator, value, index, collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseReduce;


/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(273);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ },
/* 789 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(109);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 791 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(85),
	    isArrayLike = __webpack_require__(109),
	    keys = __webpack_require__(211);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(176);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(347),
	    arraySome = __webpack_require__(775),
	    cacheHas = __webpack_require__(352);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Check that cyclic values are equal.
	  var arrStacked = stack.get(array);
	  var othStacked = stack.get(other);
	  if (arrStacked && othStacked) {
	    return arrStacked == other && othStacked == array;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 795 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(1776),
	    Map = __webpack_require__(483),
	    Promise = __webpack_require__(1778),
	    Set = __webpack_require__(770),
	    WeakMap = __webpack_require__(1780),
	    baseGetTag = __webpack_require__(175),
	    toSource = __webpack_require__(801);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 797 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(177);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 799 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 800 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 801 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(348),
	    baseFilter = __webpack_require__(779),
	    baseIteratee = __webpack_require__(85),
	    isArray = __webpack_require__(35);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * **Note:** Unlike `_.remove`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 *
	 * // Combining several predicates using `_.overEvery` or `_.overSome`.
	 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	 * // => objects for ['fred', 'barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(174),
	    map = __webpack_require__(358);
	
	/**
	 * Creates a flattened array of values by running each element in `collection`
	 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	 * with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * function duplicate(n) {
	 *   return [n, n];
	 * }
	 *
	 * _.flatMap([1, 2], duplicate);
	 * // => [1, 1, 2, 2]
	 */
	function flatMap(collection, iteratee) {
	  return baseFlatten(map(collection, iteratee), 1);
	}
	
	module.exports = flatMap;


/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(1782),
	    baseEach = __webpack_require__(144),
	    castFunction = __webpack_require__(788),
	    isArray = __webpack_require__(35);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, castFunction(iteratee));
	}
	
	module.exports = forEach;


/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEachRight = __webpack_require__(1783),
	    baseEachRight = __webpack_require__(778),
	    castFunction = __webpack_require__(788),
	    isArray = __webpack_require__(35);
	
	/**
	 * This method is like `_.forEach` except that it iterates over elements of
	 * `collection` from right to left.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @alias eachRight
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEach
	 * @example
	 *
	 * _.forEachRight([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `2` then `1`.
	 */
	function forEachRight(collection, iteratee) {
	  var func = isArray(collection) ? arrayEachRight : baseEachRight;
	  return func(collection, castFunction(iteratee));
	}
	
	module.exports = forEachRight;


/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(125),
	    stubFalse = __webpack_require__(1909);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(291)(module)))

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(175),
	    isObject = __webpack_require__(177);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(175),
	    isArray = __webpack_require__(35),
	    isObjectLike = __webpack_require__(146);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(1805),
	    baseUnary = __webpack_require__(351),
	    nodeUtil = __webpack_require__(1858);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 810 */
/***/ function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(484);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 812 */
/***/ function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(1785),
	    baseEach = __webpack_require__(144),
	    baseIteratee = __webpack_require__(85),
	    baseReduce = __webpack_require__(787),
	    isArray = __webpack_require__(35);
	
	/**
	 * Reduces `collection` to a value which is the accumulated result of running
	 * each element in `collection` thru `iteratee`, where each successive
	 * invocation is supplied the return value of the previous. If `accumulator`
	 * is not given, the first element of `collection` is used as the initial
	 * value. The iteratee is invoked with four arguments:
	 * (accumulator, value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.reduce`, `_.reduceRight`, and `_.transform`.
	 *
	 * The guarded methods are:
	 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	 * and `sortBy`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @returns {*} Returns the accumulated value.
	 * @see _.reduceRight
	 * @example
	 *
	 * _.reduce([1, 2], function(sum, n) {
	 *   return sum + n;
	 * }, 0);
	 * // => 3
	 *
	 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	 *   (result[value] || (result[value] = [])).push(key);
	 *   return result;
	 * }, {});
	 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	 */
	function reduce(collection, iteratee, accumulator) {
	  var func = isArray(collection) ? arrayReduce : baseReduce,
	      initAccum = arguments.length < 3;
	
	  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	}
	
	module.exports = reduce;


/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(777),
	    baseRest = __webpack_require__(145),
	    isArrayLikeObject = __webpack_require__(274);
	
	/**
	 * Creates an array excluding all given values using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * **Note:** Unlike `_.pull`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...*} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.difference, _.xor
	 * @example
	 *
	 * _.without([2, 1, 2, 3], 1, 2);
	 * // => [3]
	 */
	var without = baseRest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, values)
	    : [];
	});
	
	module.exports = without;


/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var af = moment.defineLocale('af', {
	        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM: function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Vandag om] LT',
	            nextDay: '[Môre om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[Gister om] LT',
	            lastWeek: '[Laas] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oor %s',
	            past: '%s gelede',
	            s: "'n paar sekondes",
	            ss: '%d sekondes',
	            m: "'n minuut",
	            mm: '%d minute',
	            h: "'n uur",
	            hh: '%d ure',
	            d: "'n dag",
	            dd: '%d dae',
	            M: "'n maand",
	            MM: '%d maande',
	            y: "'n jaar",
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            ); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week: {
	            dow: 1, // Maandag is die eerste dag van die week.
	            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        },
	    });
	
	    return af;
	
	})));


/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Amine Roukh: https://github.com/Amine27
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'جانفي',
	            'فيفري',
	            'مارس',
	            'أفريل',
	            'ماي',
	            'جوان',
	            'جويلية',
	            'أوت',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arDz;
	
	})));


/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arKw;
	
	})));


/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '1',
	            2: '2',
	            3: '3',
	            4: '4',
	            5: '5',
	            6: '6',
	            7: '7',
	            8: '8',
	            9: '9',
	            0: '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arLy;
	
	})));


/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arMa;
	
	})));


/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arSa;
	
	})));


/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arTn;
	
	})));


/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var ar = moment.defineLocale('ar', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ar;
	
	})));


/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı',
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays: 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
	            '_'
	        ),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'bir neçə saniyə',
	            ss: '%d saniyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il',
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function (number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = (number % 100) - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return az;
	
	})));


/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            dd: 'дзень_дні_дзён',
	            MM: 'месяц_месяцы_месяцаў',
	            yy: 'год_гады_гадоў',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months: {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
	                '_'
	            ),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split(
	            '_'
	        ),
	        weekdays: {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
	                '_'
	            ),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
	        },
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) &&
	                        number % 100 !== 12 &&
	                        number % 100 !== 13
	                        ? number + '-і'
	                        : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return be;
	
	})));


/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bg = moment.defineLocale('bg', {
	        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Днес в] LT',
	            nextDay: '[Утре в] LT',
	            nextWeek: 'dddd [в] LT',
	            lastDay: '[Вчера в] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Миналата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Миналия] dddd [в] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'след %s',
	            past: 'преди %s',
	            s: 'няколко секунди',
	            ss: '%d секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дена',
	            w: 'седмица',
	            ww: '%d седмици',
	            M: 'месец',
	            MM: '%d месеца',
	            y: 'година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bg;
	
	})));


/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bm = moment.defineLocale('bm', {
	        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
	            '_'
	        ),
	        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'MMMM [tile] D [san] YYYY',
	            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bi lɛrɛ] LT',
	            nextDay: '[Sini lɛrɛ] LT',
	            nextWeek: 'dddd [don lɛrɛ] LT',
	            lastDay: '[Kunu lɛrɛ] LT',
	            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s kɔnɔ',
	            past: 'a bɛ %s bɔ',
	            s: 'sanga dama dama',
	            ss: 'sekondi %d',
	            m: 'miniti kelen',
	            mm: 'miniti %d',
	            h: 'lɛrɛ kelen',
	            hh: 'lɛrɛ %d',
	            d: 'tile kelen',
	            dd: 'tile %d',
	            M: 'kalo kelen',
	            MM: 'kalo %d',
	            y: 'san kelen',
	            yy: 'san %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return bm;
	
	})));


/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali (Bangladesh) [bn-bd]
	//! author : Asraf Hossain Patoary : https://github.com/ashwoolford
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bnBd = moment.defineLocale('bn-bd', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	            '_'
	        ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	
	        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'রাত') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ভোর') {
	                return hour;
	            } else if (meridiem === 'সকাল') {
	                return hour;
	            } else if (meridiem === 'দুপুর') {
	                return hour >= 3 ? hour : hour + 12;
	            } else if (meridiem === 'বিকাল') {
	                return hour + 12;
	            } else if (meridiem === 'সন্ধ্যা') {
	                return hour + 12;
	            }
	        },
	
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 6) {
	                return 'ভোর';
	            } else if (hour < 12) {
	                return 'সকাল';
	            } else if (hour < 15) {
	                return 'দুপুর';
	            } else if (hour < 18) {
	                return 'বিকাল';
	            } else if (hour < 20) {
	                return 'সন্ধ্যা';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bnBd;
	
	})));


/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	            '_'
	        ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bn;
	
	})));


/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '༡',
	            2: '༢',
	            3: '༣',
	            4: '༤',
	            5: '༥',
	            6: '༦',
	            7: '༧',
	            8: '༨',
	            9: '༩',
	            0: '༠',
	        },
	        numberMap = {
	            '༡': '1',
	            '༢': '2',
	            '༣': '3',
	            '༤': '4',
	            '༥': '5',
	            '༦': '6',
	            '༧': '7',
	            '༨': '8',
	            '༩': '9',
	            '༠': '0',
	        };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
	            '_'
	        ),
	        monthsShort: 'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
	            '_'
	        ),
	        monthsShortRegex: /^(ཟླ་\d{1,2})/,
	        monthsParseExact: true,
	        weekdays: 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            ss: '%d སྐར་ཆ།',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ',
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bo;
	
	})));


/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            mm: 'munutenn',
	            MM: 'miz',
	            dd: 'devezh',
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            m: 'v',
	            b: 'v',
	            d: 'z',
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var monthsParse = [
	            /^gen/i,
	            /^c[ʼ\']hwe/i,
	            /^meu/i,
	            /^ebr/i,
	            /^mae/i,
	            /^(mez|eve)/i,
	            /^gou/i,
	            /^eos/i,
	            /^gwe/i,
	            /^her/i,
	            /^du/i,
	            /^ker/i,
	        ],
	        monthsRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        monthsStrictRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
	        monthsShortStrictRegex = /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        fullWeekdaysParse = [
	            /^sul/i,
	            /^lun/i,
	            /^meurzh/i,
	            /^merc[ʼ\']her/i,
	            /^yaou/i,
	            /^gwener/i,
	            /^sadorn/i,
	        ],
	        shortWeekdaysParse = [
	            /^Sul/i,
	            /^Lun/i,
	            /^Meu/i,
	            /^Mer/i,
	            /^Yao/i,
	            /^Gwe/i,
	            /^Sad/i,
	        ],
	        minWeekdaysParse = [
	            /^Su/i,
	            /^Lu/i,
	            /^Me([^r]|$)/i,
	            /^Mer/i,
	            /^Ya/i,
	            /^Gw/i,
	            /^Sa/i,
	        ];
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
	            '_'
	        ),
	        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParse: minWeekdaysParse,
	        fullWeekdaysParse: fullWeekdaysParse,
	        shortWeekdaysParse: shortWeekdaysParse,
	        minWeekdaysParse: minWeekdaysParse,
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warcʼhoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Decʼh da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s ʼzo',
	            s: 'un nebeud segondennoù',
	            ss: '%d eilenn',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
	        isPM: function (token) {
	            return token === 'g.m.';
	        },
	        meridiem: function (hour, minute, isLower) {
	            return hour < 12 ? 'a.m.' : 'g.m.';
	        },
	    });
	
	    return br;
	
	})));


/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bs;
	
	})));


/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ca = moment.defineLocale('ca', {
	        months: {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
	                '_'
	            ),
	            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort: 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a les] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function () {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function () {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [passat a ' +
	                    (this.hours() !== 1 ? 'les' : 'la') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'uns segons',
	            ss: '%d segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ca;
	
	})));


/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
	            '_'
	        ),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
	        monthsParse = [
	            /^led/i,
	            /^úno/i,
	            /^bře/i,
	            /^dub/i,
	            /^kvě/i,
	            /^(čvn|červen$|června)/i,
	            /^(čvc|červenec|července)/i,
	            /^srp/i,
	            /^zář/i,
	            /^říj/i,
	            /^lis/i,
	            /^pro/i,
	        ],
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex: /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex: /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	            l: 'D. M. YYYY',
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cs;
	
	})));


/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
	            '_'
	        ),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays: 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
	            '_'
	        ),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (output) {
	                var affix = /сехет$/i.exec(output)
	                    ? 'рен'
	                    : /ҫул$/i.exec(output)
	                    ? 'тан'
	                    : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            ss: '%d ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return cv;
	
	})));


/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
	            '_'
	        ),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
	            '_'
	        ),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact: true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '',
	                    'af',
	                    'il',
	                    'ydd',
	                    'ydd',
	                    'ed',
	                    'ed',
	                    'ed',
	                    'fed',
	                    'fed',
	                    'fed', // 1af to 10fed
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'fed', // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cy;
	
	})));


/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var da = moment.defineLocale('da', {
	        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'på dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[i] dddd[s kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'få sekunder',
	            ss: '%d sekunder',
	            m: 'et minut',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dage',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'et år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return da;
	
	})));


/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deAt;
	
	})));


/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deCh;
	
	})));


/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return de;
	
	})));


/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'ޖެނުއަރީ',
	            'ފެބްރުއަރީ',
	            'މާރިޗު',
	            'އޭޕްރީލު',
	            'މޭ',
	            'ޖޫން',
	            'ޖުލައި',
	            'އޯގަސްޓު',
	            'ސެޕްޓެމްބަރު',
	            'އޮކްޓޯބަރު',
	            'ނޮވެމްބަރު',
	            'ޑިސެމްބަރު',
	        ],
	        weekdays = [
	            'އާދިއްތަ',
	            'ހޯމަ',
	            'އަންގާރަ',
	            'ބުދަ',
	            'ބުރާސްފަތި',
	            'ހުކުރު',
	            'ހޮނިހިރު',
	        ];
	
	    var dv = moment.defineLocale('dv', {
	        months: months,
	        monthsShort: months,
	        weekdays: weekdays,
	        weekdaysShort: weekdays,
	        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/M/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM: function (input) {
	            return 'މފ' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar: {
	            sameDay: '[މިއަދު] LT',
	            nextDay: '[މާދަމާ] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[އިއްޔެ] LT',
	            lastWeek: '[ފާއިތުވި] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ތެރޭގައި %s',
	            past: 'ކުރިން %s',
	            s: 'ސިކުންތުކޮޅެއް',
	            ss: 'd% ސިކުންތު',
	            m: 'މިނިޓެއް',
	            mm: 'މިނިޓު %d',
	            h: 'ގަޑިއިރެއް',
	            hh: 'ގަޑިއިރު %d',
	            d: 'ދުވަހެއް',
	            dd: 'ދުވަސް %d',
	            M: 'މަހެއް',
	            MM: 'މަސް %d',
	            y: 'އަހަރެއް',
	            yy: 'އަހަރު %d',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 7, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return dv;
	
	})));


/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl: 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
	            '_'
	        ),
	        monthsGenitiveEl: 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
	            '_'
	        ),
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (
	                typeof format === 'string' &&
	                /D/.test(format.substring(0, format.indexOf('MMMM')))
	            ) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
	            '_'
	        ),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function (input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        calendar: function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            ss: '%d δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4st is the first week of the year.
	        },
	    });
	
	    return el;
	
	})));


/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enAu;
	
	})));


/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Israel) [en-il]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIl = moment.defineLocale('en-il', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enIl;
	
	})));


/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (India) [en-in]
	//! author : Jatin Agrawal : https://github.com/jatinag22
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIn = moment.defineLocale('en-in', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return enIn;
	
	})));


/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enNz;
	
	})));


/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Singapore) [en-sg]
	//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enSg = moment.defineLocale('en-sg', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enSg;
	
	})));


/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	//! comment : Vivakvo corrected the translation by colindean and miestasmia
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eo = moment.defineLocale('eo', {
	        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
	        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: '[la] D[-an de] MMMM, YYYY',
	            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
	            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
	            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar: {
	            sameDay: '[Hodiaŭ je] LT',
	            nextDay: '[Morgaŭ je] LT',
	            nextWeek: 'dddd[n je] LT',
	            lastDay: '[Hieraŭ je] LT',
	            lastWeek: '[pasintan] dddd[n je] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'post %s',
	            past: 'antaŭ %s',
	            s: 'kelkaj sekundoj',
	            ss: '%d sekundoj',
	            m: 'unu minuto',
	            mm: '%d minutoj',
	            h: 'unu horo',
	            hh: '%d horoj',
	            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
	            dd: '%d tagoj',
	            M: 'unu monato',
	            MM: '%d monatoj',
	            y: 'unu jaro',
	            yy: '%d jaroj',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal: '%da',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eo;
	
	})));


/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return esDo;
	
	})));


/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Mexico) [es-mx]
	//! author : JC Franco : https://github.com/jcfranco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esMx = moment.defineLocale('es-mx', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return esMx;
	
	})));


/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	//! author : chrisrodz : https://github.com/chrisrodz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'MM/DD/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return esUs;
	
	})));


/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return es;
	
	})));


/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            ss: [number + 'sekundi', number + 'sekundit'],
	            m: ['ühe minuti', 'üks minut'],
	            mm: [number + ' minuti', number + ' minutit'],
	            h: ['ühe tunni', 'tund aega', 'üks tund'],
	            hh: [number + ' tunni', number + ' tundi'],
	            d: ['ühe päeva', 'üks päev'],
	            M: ['kuu aja', 'kuu aega', 'üks kuu'],
	            MM: [number + ' kuu', number + ' kuud'],
	            y: ['ühe aasta', 'aasta', 'üks aasta'],
	            yy: [number + ' aasta', number + ' aastat'],
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
	            '_'
	        ),
	        monthsShort: 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split(
	            '_'
	        ),
	        weekdays: 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
	            '_'
	        ),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return et;
	
	})));


/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
	            '_'
	        ),
	        monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
	            '_'
	        ),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            ss: '%d segundo',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eu;
	
	})));


/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '۱',
	            2: '۲',
	            3: '۳',
	            4: '۴',
	            5: '۵',
	            6: '۶',
	            7: '۷',
	            8: '۸',
	            9: '۹',
	            0: '۰',
	        },
	        numberMap = {
	            '۱': '1',
	            '۲': '2',
	            '۳': '3',
	            '۴': '4',
	            '۵': '5',
	            '۶': '6',
	            '۷': '7',
	            '۸': '8',
	            '۹': '9',
	            '۰': '0',
	        };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        monthsShort: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        weekdays: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	            '_'
	        ),
	        weekdaysShort: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	            '_'
	        ),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چند ثانیه',
	            ss: '%d ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[۰-۹]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return fa;
	
	})));


/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
	            ' '
	        ),
	        numbersFuture = [
	            'nolla',
	            'yhden',
	            'kahden',
	            'kolmen',
	            'neljän',
	            'viiden',
	            'kuuden',
	            numbersPast[7],
	            numbersPast[8],
	            numbersPast[9],
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                result = isFuture ? 'sekunnin' : 'sekuntia';
	                break;
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10
	            ? isFuture
	                ? numbersFuture[number]
	                : numbersPast[number]
	            : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
	            '_'
	        ),
	        monthsShort: 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
	            '_'
	        ),
	        weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
	            '_'
	        ),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fi;
	
	})));


/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Filipino [fil]
	//! author : Dan Hagman : https://github.com/hagmandan
	//! author : Matthew Co : https://github.com/matthewdeeco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fil = moment.defineLocale('fil', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fil;
	
	})));


/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	//! author : Kristian Sakarisson : https://github.com/sakarisson
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays: 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
	            '_'
	        ),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            ss: '%d sekundir',
	            m: 'ein minuttur',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaður',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fo;
	
	})));


/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	    });
	
	    return frCa;
	
	})));


/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return frCh;
	
	})));


/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsStrictRegex = /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsShortStrictRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
	        monthsRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsParse = [
	            /^janv/i,
	            /^févr/i,
	            /^mars/i,
	            /^avr/i,
	            /^mai/i,
	            /^juin/i,
	            /^juil/i,
	            /^août/i,
	            /^sept/i,
	            /^oct/i,
	            /^nov/i,
	            /^déc/i,
	        ];
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            w: 'une semaine',
	            ww: '%d semaines',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split(
	            '_'
	        );
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
	            '_'
	        ),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            ss: '%d sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fy;
	
	})));


/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Irish or Irish Gaelic [ga]
	//! author : André Silva : https://github.com/askpt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Eanáir',
	            'Feabhra',
	            'Márta',
	            'Aibreán',
	            'Bealtaine',
	            'Meitheamh',
	            'Iúil',
	            'Lúnasa',
	            'Meán Fómhair',
	            'Deireadh Fómhair',
	            'Samhain',
	            'Nollaig',
	        ],
	        monthsShort = [
	            'Ean',
	            'Feabh',
	            'Márt',
	            'Aib',
	            'Beal',
	            'Meith',
	            'Iúil',
	            'Lún',
	            'M.F.',
	            'D.F.',
	            'Samh',
	            'Noll',
	        ],
	        weekdays = [
	            'Dé Domhnaigh',
	            'Dé Luain',
	            'Dé Máirt',
	            'Dé Céadaoin',
	            'Déardaoin',
	            'Dé hAoine',
	            'Dé Sathairn',
	        ],
	        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
	        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné ag] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d míonna',
	            y: 'bliain',
	            yy: '%d bliain',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ga;
	
	})));


/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Am Faoilleach',
	            'An Gearran',
	            'Am Màrt',
	            'An Giblean',
	            'An Cèitean',
	            'An t-Ògmhios',
	            'An t-Iuchar',
	            'An Lùnastal',
	            'An t-Sultain',
	            'An Dàmhair',
	            'An t-Samhain',
	            'An Dùbhlachd',
	        ],
	        monthsShort = [
	            'Faoi',
	            'Gear',
	            'Màrt',
	            'Gibl',
	            'Cèit',
	            'Ògmh',
	            'Iuch',
	            'Lùn',
	            'Sult',
	            'Dàmh',
	            'Samh',
	            'Dùbh',
	        ],
	        weekdays = [
	            'Didòmhnaich',
	            'Diluain',
	            'Dimàirt',
	            'Diciadain',
	            'Diardaoin',
	            'Dihaoine',
	            'Disathairne',
	        ],
	        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
	        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[An-diugh aig] LT',
	            nextDay: '[A-màireach aig] LT',
	            nextWeek: 'dddd [aig] LT',
	            lastDay: '[An-dè aig] LT',
	            lastWeek: 'dddd [seo chaidh] [aig] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ann an %s',
	            past: 'bho chionn %s',
	            s: 'beagan diogan',
	            ss: '%d diogan',
	            m: 'mionaid',
	            mm: '%d mionaidean',
	            h: 'uair',
	            hh: '%d uairean',
	            d: 'latha',
	            dd: '%d latha',
	            M: 'mìos',
	            MM: '%d mìosan',
	            y: 'bliadhna',
	            yy: '%d bliadhna',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gd;
	
	})));


/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var gl = moment.defineLocale('gl', {
	        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function () {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gl;
	
	})));


/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Devanagari script [gom-deva]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
	            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
	            m: ['एका मिणटान', 'एक मिनूट'],
	            mm: [number + ' मिणटांनी', number + ' मिणटां'],
	            h: ['एका वरान', 'एक वर'],
	            hh: [number + ' वरांनी', number + ' वरां'],
	            d: ['एका दिसान', 'एक दीस'],
	            dd: [number + ' दिसांनी', number + ' दीस'],
	            M: ['एका म्हयन्यान', 'एक म्हयनो'],
	            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
	            y: ['एका वर्सान', 'एक वर्स'],
	            yy: [number + ' वर्सांनी', number + ' वर्सां'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomDeva = moment.defineLocale('gom-deva', {
	        months: {
	            standalone: 'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	                '_'
	            ),
	            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort: 'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
	        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
	        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [वाजतां]',
	            LTS: 'A h:mm:ss [वाजतां]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
	            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
	        },
	        calendar: {
	            sameDay: '[आयज] LT',
	            nextDay: '[फाल्यां] LT',
	            nextWeek: '[फुडलो] dddd[,] LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[फाटलो] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s आदीं',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'वेर' only applies to day of the month
	                case 'D':
	                    return number + 'वेर';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळीं') {
	                return hour;
	            } else if (meridiem === 'दनपारां') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'सांजे') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'राती';
	            } else if (hour < 12) {
	                return 'सकाळीं';
	            } else if (hour < 16) {
	                return 'दनपारां';
	            } else if (hour < 20) {
	                return 'सांजे';
	            } else {
	                return 'राती';
	            }
	        },
	    });
	
	    return gomDeva;
	
	})));


/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['thoddea sekondamni', 'thodde sekond'],
	            ss: [number + ' sekondamni', number + ' sekond'],
	            m: ['eka mintan', 'ek minut'],
	            mm: [number + ' mintamni', number + ' mintam'],
	            h: ['eka voran', 'ek vor'],
	            hh: [number + ' voramni', number + ' voram'],
	            d: ['eka disan', 'ek dis'],
	            dd: [number + ' disamni', number + ' dis'],
	            M: ['eka mhoinean', 'ek mhoino'],
	            MM: [number + ' mhoineamni', number + ' mhoine'],
	            y: ['eka vorsan', 'ek voros'],
	            yy: [number + ' vorsamni', number + ' vorsam'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months: {
	            standalone: 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
	                '_'
	            ),
	            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort: 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
	        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [vazta]',
	            LTS: 'A h:mm:ss [vazta]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [vazta]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
	        },
	        calendar: {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Fuddlo] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fattlo] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s adim',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /rati|sokallim|donparam|sanje/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokallim') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokallim';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        },
	    });
	
	    return gomLatn;
	
	})));


/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '૧',
	            2: '૨',
	            3: '૩',
	            4: '૪',
	            5: '૫',
	            6: '૬',
	            7: '૭',
	            8: '૮',
	            9: '૯',
	            0: '૦',
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0',
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
	            '_'
	        ),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
	            '_'
	        ),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પહેલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ',
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return gu;
	
	})));


/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
	            '_'
	        ),
	        monthsShort: 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split(
	            '_'
	        ),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            ss: '%d שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            },
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM: function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        },
	    });
	
	    return he;
	
	})));


/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        },
	        monthsParse = [
	            /^जन/i,
	            /^फ़र|फर/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सितं|सित/i,
	            /^अक्टू/i,
	            /^नव|नवं/i,
	            /^दिसं|दिस/i,
	        ],
	        shortMonthsParse = [
	            /^जन/i,
	            /^फ़र/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सित/i,
	            /^अक्टू/i,
	            /^नव/i,
	            /^दिस/i,
	        ];
	
	    var hi = moment.defineLocale('hi', {
	        months: {
	            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
	                '_'
	            ),
	            standalone: 'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split(
	            '_'
	        ),
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
	        },
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: shortMonthsParse,
	
	        monthsRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsShortRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsStrictRegex: /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
	
	        monthsShortStrictRegex: /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
	
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            ss: '%d सेकंड',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return hi;
	
	})));


/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
	                '_'
	            ),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM YYYY',
	            LLL: 'Do MMMM YYYY H:mm',
	            LLLL: 'dddd, Do MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prošlu] [nedjelju] [u] LT';
	                    case 3:
	                        return '[prošlu] [srijedu] [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hr;
	
	})));


/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	//! author : Peter Viszt  : https://github.com/passatgt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(
	        ' '
	    );
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix
	                    ? 'néhány másodperc'
	                    : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix)
	                    ? ' másodperc'
	                    : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (
	            (isFuture ? '' : '[múlt] ') +
	            '[' +
	            weekEndings[this.day()] +
	            '] LT[-kor]'
	        );
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm',
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function () {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function () {
	                return week.call(this, false);
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return hu;
	
	})));


/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months: {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
	                '_'
	            ),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays: 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
	            '_'
	        ),
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            ss: '%d վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի',
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem: function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hyAm;
	
	})));


/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var id = moment.defineLocale('id', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Besok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kemarin pukul] LT',
	            lastWeek: 'dddd [lalu pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lalu',
	            s: 'beberapa detik',
	            ss: '%d detik',
	            m: 'semenit',
	            mm: '%d menit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return id;
	
	})));


/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nokkrar sekúndur'
	                    : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
	                    );
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return (
	                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
	                    );
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture
	                            ? 'klukkustundir'
	                            : 'klukkustundum')
	                    );
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays: 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
	            '_'
	        ),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return is;
	
	})));


/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian (Switzerland) [it-ch]
	//! author : xfh : https://github.com/xfh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var itCh = moment.defineLocale('it-ch', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return itCh;
	
	})));


/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	//! author: Marco : https://github.com/Manfre98
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return (
	                    '[Oggi a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextDay: function () {
	                return (
	                    '[Domani a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextWeek: function () {
	                return (
	                    'dddd [a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastDay: function () {
	                return (
	                    '[Ieri a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return (
	                            '[La scorsa] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                    default:
	                        return (
	                            '[Lo scorso] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'tra %s',
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            w: 'una settimana',
	            ww: '%d settimane',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return it;
	
	})));


/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ja = moment.defineLocale('ja', {
	        eras: [
	            {
	                since: '2019-05-01',
	                offset: 1,
	                name: '令和',
	                narrow: '㋿',
	                abbr: 'R',
	            },
	            {
	                since: '1989-01-08',
	                until: '2019-04-30',
	                offset: 1,
	                name: '平成',
	                narrow: '㍻',
	                abbr: 'H',
	            },
	            {
	                since: '1926-12-25',
	                until: '1989-01-07',
	                offset: 1,
	                name: '昭和',
	                narrow: '㍼',
	                abbr: 'S',
	            },
	            {
	                since: '1912-07-30',
	                until: '1926-12-24',
	                offset: 1,
	                name: '大正',
	                narrow: '㍽',
	                abbr: 'T',
	            },
	            {
	                since: '1873-01-01',
	                until: '1912-07-29',
	                offset: 6,
	                name: '明治',
	                narrow: '㍾',
	                abbr: 'M',
	            },
	            {
	                since: '0001-01-01',
	                until: '1873-12-31',
	                offset: 1,
	                name: '西暦',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: '紀元前',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        eraYearOrdinalRegex: /(元|\d+)年/,
	        eraYearOrdinalParse: function (input, match) {
	            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
	        },
	        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日 dddd HH:mm',
	            l: 'YYYY/MM/DD',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日(ddd) HH:mm',
	        },
	        meridiemParse: /午前|午後/i,
	        isPM: function (input) {
	            return input === '午後';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar: {
	            sameDay: '[今日] LT',
	            nextDay: '[明日] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay: '[昨日] LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}日/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'y':
	                    return number === 1 ? '元年' : number + '年';
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '数秒',
	            ss: '%d秒',
	            m: '1分',
	            mm: '%d分',
	            h: '1時間',
	            hh: '%d時間',
	            d: '1日',
	            dd: '%d日',
	            M: '1ヶ月',
	            MM: '%dヶ月',
	            y: '1年',
	            yy: '%d年',
	        },
	    });
	
	    return ja;
	
	})));


/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var jv = moment.defineLocale('jv', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar: {
	            sameDay: '[Dinten puniko pukul] LT',
	            nextDay: '[Mbenjang pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kala wingi pukul] LT',
	            lastWeek: 'dddd [kepengker pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'wonten ing %s',
	            past: '%s ingkang kepengker',
	            s: 'sawetawis detik',
	            ss: '%d detik',
	            m: 'setunggal menit',
	            mm: '%d menit',
	            h: 'setunggal jam',
	            hh: '%d jam',
	            d: 'sedinten',
	            dd: '%d dinten',
	            M: 'sewulan',
	            MM: '%d wulan',
	            y: 'setaun',
	            yy: '%d taun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return jv;
	
	})));


/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/IrakliJani
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ka = moment.defineLocale('ka', {
	        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
	            '_'
	        ),
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
	                '_'
	            ),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
	                '_'
	            ),
	            isFormat: /(წინა|შემდეგ)/,
	        },
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return s.replace(/(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/, function (
	                    $0,
	                    $1,
	                    $2
	                ) {
	                    return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
	                });
	            },
	            past: function (s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	                return s;
	            },
	            s: 'რამდენიმე წამი',
	            ss: '%d წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი',
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (
	                number < 20 ||
	                (number <= 100 && number % 20 === 0) ||
	                number % 100 === 0
	            ) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7,
	        },
	    });
	
	    return ka;
	
	})));


/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші',
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
	            '_'
	        ),
	        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
	            '_'
	        ),
	        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгін сағат] LT',
	            nextDay: '[Ертең сағат] LT',
	            nextWeek: 'dddd [сағат] LT',
	            lastDay: '[Кеше сағат] LT',
	            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ішінде',
	            past: '%s бұрын',
	            s: 'бірнеше секунд',
	            ss: '%d секунд',
	            m: 'бір минут',
	            mm: '%d минут',
	            h: 'бір сағат',
	            hh: '%d сағат',
	            d: 'бір күн',
	            dd: '%d күн',
	            M: 'бір ай',
	            MM: '%d ай',
	            y: 'бір жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return kk;
	
	})));


/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '១',
	            2: '២',
	            3: '៣',
	            4: '៤',
	            5: '៥',
	            6: '៦',
	            7: '៧',
	            8: '៨',
	            9: '៩',
	            0: '០',
	        },
	        numberMap = {
	            '១': '1',
	            '២': '2',
	            '៣': '3',
	            '៤': '4',
	            '៥': '5',
	            '៦': '6',
	            '៧': '7',
	            '៨': '8',
	            '៩': '9',
	            '០': '0',
	        };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ',
	        },
	        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
	        ordinal: 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return km;
	
	})));


/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '೧',
	            2: '೨',
	            3: '೩',
	            4: '೪',
	            5: '೫',
	            6: '೬',
	            7: '೭',
	            8: '೮',
	            9: '೯',
	            0: '೦',
	        },
	        numberMap = {
	            '೧': '1',
	            '೨': '2',
	            '೩': '3',
	            '೪': '4',
	            '೫': '5',
	            '೬': '6',
	            '೭': '7',
	            '೮': '8',
	            '೯': '9',
	            '೦': '0',
	        };
	
	    var kn = moment.defineLocale('kn', {
	        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
	            '_'
	        ),
	        monthsShort: 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[ಇಂದು] LT',
	            nextDay: '[ನಾಳೆ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ನಿನ್ನೆ] LT',
	            lastWeek: '[ಕೊನೆಯ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ನಂತರ',
	            past: '%s ಹಿಂದೆ',
	            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss: '%d ಸೆಕೆಂಡುಗಳು',
	            m: 'ಒಂದು ನಿಮಿಷ',
	            mm: '%d ನಿಮಿಷ',
	            h: 'ಒಂದು ಗಂಟೆ',
	            hh: '%d ಗಂಟೆ',
	            d: 'ಒಂದು ದಿನ',
	            dd: '%d ದಿನ',
	            M: 'ಒಂದು ತಿಂಗಳು',
	            MM: '%d ತಿಂಗಳು',
	            y: 'ಒಂದು ವರ್ಷ',
	            yy: '%d ವರ್ಷ',
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal: function (number) {
	            return number + 'ನೇ';
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return kn;
	
	})));


/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ko = moment.defineLocale('ko', {
	        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
	            '_'
	        ),
	        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY년 MMMM D일',
	            LLL: 'YYYY년 MMMM D일 A h:mm',
	            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
	            l: 'YYYY.MM.DD.',
	            ll: 'YYYY년 MMMM D일',
	            lll: 'YYYY년 MMMM D일 A h:mm',
	            llll: 'YYYY년 MMMM D일 dddd A h:mm',
	        },
	        calendar: {
	            sameDay: '오늘 LT',
	            nextDay: '내일 LT',
	            nextWeek: 'dddd LT',
	            lastDay: '어제 LT',
	            lastWeek: '지난주 dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s 후',
	            past: '%s 전',
	            s: '몇 초',
	            ss: '%d초',
	            m: '1분',
	            mm: '%d분',
	            h: '한 시간',
	            hh: '%d시간',
	            d: '하루',
	            dd: '%d일',
	            M: '한 달',
	            MM: '%d달',
	            y: '일 년',
	            yy: '%d년',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse: /오전|오후/,
	        isPM: function (token) {
	            return token === '오후';
	        },
	        meridiem: function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        },
	    });
	
	    return ko;
	
	})));


/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kurdish [ku]
	//! author : Shahram Mebashar : https://github.com/ShahramMebashar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        months = [
	            'کانونی دووەم',
	            'شوبات',
	            'ئازار',
	            'نیسان',
	            'ئایار',
	            'حوزەیران',
	            'تەمموز',
	            'ئاب',
	            'ئەیلوول',
	            'تشرینی یەكەم',
	            'تشرینی دووەم',
	            'كانونی یەکەم',
	        ];
	
	    var ku = moment.defineLocale('ku', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
	            '_'
	        ),
	        weekdaysShort: 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split(
	            '_'
	        ),
	        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar: {
	            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay: '[به‌یانی كاتژمێر] LT',
	            nextWeek: 'dddd [كاتژمێر] LT',
	            lastDay: '[دوێنێ كاتژمێر] LT',
	            lastWeek: 'dddd [كاتژمێر] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'له‌ %s',
	            past: '%s',
	            s: 'چه‌ند چركه‌یه‌ك',
	            ss: 'چركه‌ %d',
	            m: 'یه‌ك خوله‌ك',
	            mm: '%d خوله‌ك',
	            h: 'یه‌ك كاتژمێر',
	            hh: '%d كاتژمێر',
	            d: 'یه‌ك ڕۆژ',
	            dd: '%d ڕۆژ',
	            M: 'یه‌ك مانگ',
	            MM: '%d مانگ',
	            y: 'یه‌ك ساڵ',
	            yy: '%d ساڵ',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ku;
	
	})));


/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү',
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
	            '_'
	        ),
	        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
	            '_'
	        ),
	        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгүн саат] LT',
	            nextDay: '[Эртең саат] LT',
	            nextWeek: 'dddd [саат] LT',
	            lastDay: '[Кечээ саат] LT',
	            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ичинде',
	            past: '%s мурун',
	            s: 'бирнече секунд',
	            ss: '%d секунд',
	            m: 'бир мүнөт',
	            mm: '%d мүнөт',
	            h: 'бир саат',
	            hh: '%d саат',
	            d: 'бир күн',
	            dd: '%d күн',
	            M: 'бир ай',
	            MM: '%d ай',
	            y: 'бир жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ky;
	
	})));


/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eng Minutt', 'enger Minutt'],
	            h: ['eng Stonn', 'enger Stonn'],
	            d: ['een Dag', 'engem Dag'],
	            M: ['ee Mount', 'engem Mount'],
	            y: ['ee Joer', 'engem Joer'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            },
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            ss: '%d Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lb;
	
	})));


/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var lo = moment.defineLocale('lo', {
	        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        monthsShort: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar: {
	            sameDay: '[ມື້ນີ້ເວລາ] LT',
	            nextDay: '[ມື້ອື່ນເວລາ] LT',
	            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ອີກ %s',
	            past: '%sຜ່ານມາ',
	            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss: '%d ວິນາທີ',
	            m: '1 ນາທີ',
	            mm: '%d ນາທີ',
	            h: '1 ຊົ່ວໂມງ',
	            hh: '%d ຊົ່ວໂມງ',
	            d: '1 ມື້',
	            dd: '%d ມື້',
	            M: '1 ເດືອນ',
	            MM: '%d ເດືອນ',
	            y: '1 ປີ',
	            yy: '%d ປີ',
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal: function (number) {
	            return 'ທີ່' + number;
	        },
	    });
	
	    return lo;
	
	})));


/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundė_sekundžių_sekundes',
	        m: 'minutė_minutės_minutę',
	        mm: 'minutės_minučių_minutes',
	        h: 'valanda_valandos_valandą',
	        hh: 'valandos_valandų_valandas',
	        d: 'diena_dienos_dieną',
	        dd: 'dienos_dienų_dienas',
	        M: 'mėnuo_mėnesio_mėnesį',
	        MM: 'mėnesiai_mėnesių_mėnesius',
	        y: 'metai_metų_metus',
	        yy: 'metai_metų_metus',
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix
	            ? forms(key)[0]
	            : isFuture
	            ? forms(key)[1]
	            : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return (
	                result + translateSingular(number, withoutSuffix, key[0], isFuture)
	            );
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months: {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
	                '_'
	            ),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
	        },
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
	                '_'
	            ),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
	                '_'
	            ),
	            isFormat: /dddd HH:mm/,
	        },
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            ss: translate,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal: function (number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lt;
	
	})));


/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        h: 'stundas_stundām_stunda_stundas'.split('_'),
	        hh: 'stundas_stundām_stunda_stundas'.split('_'),
	        d: 'dienas_dienām_diena_dienas'.split('_'),
	        dd: 'dienas_dienām_diena_dienas'.split('_'),
	        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        y: 'gada_gadiem_gads_gadi'.split('_'),
	        yy: 'gada_gadiem_gads_gadi'.split('_'),
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lv;
	
	})));


/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return me;
	
	})));


/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
	            '_'
	        ),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
	            '_'
	        ),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mi;
	
	})));


/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	//! author : Sashko Todorov : https://github.com/bkyceh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mk = moment.defineLocale('mk', {
	        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Денес во] LT',
	            nextDay: '[Утре во] LT',
	            nextWeek: '[Во] dddd [во] LT',
	            lastDay: '[Вчера во] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пред %s',
	            s: 'неколку секунди',
	            ss: '%d секунди',
	            m: 'една минута',
	            mm: '%d минути',
	            h: 'еден час',
	            hh: '%d часа',
	            d: 'еден ден',
	            dd: '%d дена',
	            M: 'еден месец',
	            MM: '%d месеци',
	            y: 'една година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return mk;
	
	})));


/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
	            '_'
	        ),
	        monthsShort: 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
	            '_'
	        ),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            ss: '%d സെക്കൻഡ്',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം',
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        },
	    });
	
	    return ml;
	
	})));


/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Mongolian [mn]
	//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
	            '_'
	        ),
	        monthsShort: '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY оны MMMMын D',
	            LLL: 'YYYY оны MMMMын D HH:mm',
	            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM: function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar: {
	            sameDay: '[Өнөөдөр] LT',
	            nextDay: '[Маргааш] LT',
	            nextWeek: '[Ирэх] dddd LT',
	            lastDay: '[Өчигдөр] LT',
	            lastWeek: '[Өнгөрсөн] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s дараа',
	            past: '%s өмнө',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        },
	    });
	
	    return mn;
	
	})));


/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंद';
	                    break;
	                case 'ss':
	                    output = '%d सेकंद';
	                    break;
	                case 'm':
	                    output = 'एक मिनिट';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटे';
	                    break;
	                case 'h':
	                    output = 'एक तास';
	                    break;
	                case 'hh':
	                    output = '%d तास';
	                    break;
	                case 'd':
	                    output = 'एक दिवस';
	                    break;
	                case 'dd':
	                    output = '%d दिवस';
	                    break;
	                case 'M':
	                    output = 'एक महिना';
	                    break;
	                case 'MM':
	                    output = '%d महिने';
	                    break;
	                case 'y':
	                    output = 'एक वर्ष';
	                    break;
	                case 'yy':
	                    output = '%d वर्षे';
	                    break;
	            }
	        } else {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंदां';
	                    break;
	                case 'ss':
	                    output = '%d सेकंदां';
	                    break;
	                case 'm':
	                    output = 'एका मिनिटा';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटां';
	                    break;
	                case 'h':
	                    output = 'एका तासा';
	                    break;
	                case 'hh':
	                    output = '%d तासां';
	                    break;
	                case 'd':
	                    output = 'एका दिवसा';
	                    break;
	                case 'dd':
	                    output = '%d दिवसां';
	                    break;
	                case 'M':
	                    output = 'एका महिन्या';
	                    break;
	                case 'MM':
	                    output = '%d महिन्यां';
	                    break;
	                case 'y':
	                    output = 'एका वर्षा';
	                    break;
	                case 'yy':
	                    output = '%d वर्षां';
	                    break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	            '_'
	        ),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr,
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
	                return hour;
	            } else if (
	                meridiem === 'दुपारी' ||
	                meridiem === 'सायंकाळी' ||
	                meridiem === 'रात्री'
	            ) {
	                return hour >= 12 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour >= 0 && hour < 6) {
	                return 'पहाटे';
	            } else if (hour < 12) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return mr;
	
	})));


/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var msMy = moment.defineLocale('ms-my', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return msMy;
	
	})));


/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ms = moment.defineLocale('ms', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ms;
	
	})));


/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mt = moment.defineLocale('mt', {
	        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays: 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Illum fil-]LT',
	            nextDay: '[Għada fil-]LT',
	            nextWeek: 'dddd [fil-]LT',
	            lastDay: '[Il-bieraħ fil-]LT',
	            lastWeek: 'dddd [li għadda] [fil-]LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'f’ %s',
	            past: '%s ilu',
	            s: 'ftit sekondi',
	            ss: '%d sekondi',
	            m: 'minuta',
	            mm: '%d minuti',
	            h: 'siegħa',
	            hh: '%d siegħat',
	            d: 'ġurnata',
	            dd: '%d ġranet',
	            M: 'xahar',
	            MM: '%d xhur',
	            y: 'sena',
	            yy: '%d sni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mt;
	
	})));


/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '၁',
	            2: '၂',
	            3: '၃',
	            4: '၄',
	            5: '၅',
	            6: '၆',
	            7: '၇',
	            8: '၈',
	            9: '၉',
	            0: '၀',
	        },
	        numberMap = {
	            '၁': '1',
	            '၂': '2',
	            '၃': '3',
	            '၄': '4',
	            '၅': '5',
	            '၆': '6',
	            '၇': '7',
	            '၈': '8',
	            '၉': '9',
	            '၀': '0',
	        };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
	            '_'
	        ),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
	            '_'
	        ),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss: '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်',
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return my;
	
	})));


/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'noen sekunder',
	            ss: '%d sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dager',
	            w: 'en uke',
	            ww: '%d uker',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nb;
	
	})));


/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
	            '_'
	        ),
	        monthsShort: 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
	            '_'
	        ),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोलि] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडि',
	            s: 'केही क्षण',
	            ss: '%d सेकेण्ड',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ne;
	
	})));


/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nlBe;
	
	})));


/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            w: 'één week',
	            ww: '%d weken',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nl;
	
	})));


/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! authors : https://github.com/mechuwind
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s sidan',
	            s: 'nokre sekund',
	            ss: '%d sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            w: 'ei veke',
	            ww: '%d veker',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nn;
	
	})));


/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Occitan, lengadocian dialecte [oc-lnc]
	//! author : Quentin PAGÈS : https://github.com/Quenty31
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ocLnc = moment.defineLocale('oc-lnc', {
	        months: {
	            standalone: 'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
	                '_'
	            ),
	            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort: 'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: '[uèi a] LT',
	            nextDay: '[deman a] LT',
	            nextWeek: 'dddd [a] LT',
	            lastDay: '[ièr a] LT',
	            lastWeek: 'dddd [passat a] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'unas segondas',
	            ss: '%d segondas',
	            m: 'una minuta',
	            mm: '%d minutas',
	            h: 'una ora',
	            hh: '%d oras',
	            d: 'un jorn',
	            dd: '%d jorns',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4,
	        },
	    });
	
	    return ocLnc;
	
	})));


/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '੧',
	            2: '੨',
	            3: '੩',
	            4: '੪',
	            5: '੫',
	            6: '੬',
	            7: '੭',
	            8: '੮',
	            9: '੯',
	            0: '੦',
	        },
	        numberMap = {
	            '੧': '1',
	            '੨': '2',
	            '੩': '3',
	            '੪': '4',
	            '੫': '5',
	            '੬': '6',
	            '੭': '7',
	            '੮': '8',
	            '੯': '9',
	            '੦': '0',
	        };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        monthsShort: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm ਵਜੇ',
	            LTS: 'A h:mm:ss ਵਜੇ',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
	        },
	        calendar: {
	            sameDay: '[ਅਜ] LT',
	            nextDay: '[ਕਲ] LT',
	            nextWeek: '[ਅਗਲਾ] dddd, LT',
	            lastDay: '[ਕਲ] LT',
	            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ਵਿੱਚ',
	            past: '%s ਪਿਛਲੇ',
	            s: 'ਕੁਝ ਸਕਿੰਟ',
	            ss: '%d ਸਕਿੰਟ',
	            m: 'ਇਕ ਮਿੰਟ',
	            mm: '%d ਮਿੰਟ',
	            h: 'ਇੱਕ ਘੰਟਾ',
	            hh: '%d ਘੰਟੇ',
	            d: 'ਇੱਕ ਦਿਨ',
	            dd: '%d ਦਿਨ',
	            M: 'ਇੱਕ ਮਹੀਨਾ',
	            MM: '%d ਮਹੀਨੇ',
	            y: 'ਇੱਕ ਸਾਲ',
	            yy: '%d ਸਾਲ',
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return paIn;
	
	})));


/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
	            '_'
	        ),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^sty/i,
	            /^lut/i,
	            /^mar/i,
	            /^kwi/i,
	            /^maj/i,
	            /^cze/i,
	            /^lip/i,
	            /^sie/i,
	            /^wrz/i,
	            /^paź/i,
	            /^lis/i,
	            /^gru/i,
	        ];
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'ww':
	                return result + (plural(number) ? 'tygodnie' : 'tygodni');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            w: 'tydzień',
	            ww: translate,
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pl;
	
	})));


/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays: 'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
	        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'poucos segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        invalidDate: 'Data inválida',
	    });
	
	    return ptBr;
	
	})));


/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pt = moment.defineLocale('pt', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays: 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            w: 'uma semana',
	            ww: '%d semanas',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pt;
	
	})));


/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	//! author : Emanuel Cepoi : https://github.com/cepem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                ss: 'secunde',
	                mm: 'minute',
	                hh: 'ore',
	                dd: 'zile',
	                ww: 'săptămâni',
	                MM: 'luni',
	                yy: 'ani',
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
	            '_'
	        ),
	        monthsShort: 'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            ss: relativeTimeWithPlural,
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            w: 'o săptămână',
	            ww: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural,
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ro;
	
	})));


/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            hh: 'час_часа_часов',
	            dd: 'день_дня_дней',
	            ww: 'неделя_недели_недель',
	            MM: 'месяц_месяца_месяцев',
	            yy: 'год_года_лет',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [
	        /^янв/i,
	        /^фев/i,
	        /^мар/i,
	        /^апр/i,
	        /^ма[йя]/i,
	        /^июн/i,
	        /^июл/i,
	        /^авг/i,
	        /^сен/i,
	        /^окт/i,
	        /^ноя/i,
	        /^дек/i,
	    ];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months: {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
	                '_'
	            ),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	                '_'
	            ),
	        },
	        monthsShort: {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	        },
	        weekdays: {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
	                '_'
	            ),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
	        },
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соответствует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., H:mm',
	            LLLL: 'dddd, D MMMM YYYY г., H:mm',
	        },
	        calendar: {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            w: 'неделя',
	            ww: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ru;
	
	})));


/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوري',
	            'فيبروري',
	            'مارچ',
	            'اپريل',
	            'مئي',
	            'جون',
	            'جولاءِ',
	            'آگسٽ',
	            'سيپٽمبر',
	            'آڪٽوبر',
	            'نومبر',
	            'ڊسمبر',
	        ],
	        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
	
	    var sd = moment.defineLocale('sd', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[اڄ] LT',
	            nextDay: '[سڀاڻي] LT',
	            nextWeek: 'dddd [اڳين هفتي تي] LT',
	            lastDay: '[ڪالهه] LT',
	            lastWeek: '[گزريل هفتي] dddd [تي] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s پوء',
	            past: '%s اڳ',
	            s: 'چند سيڪنڊ',
	            ss: '%d سيڪنڊ',
	            m: 'هڪ منٽ',
	            mm: '%d منٽ',
	            h: 'هڪ ڪلاڪ',
	            hh: '%d ڪلاڪ',
	            d: 'هڪ ڏينهن',
	            dd: '%d ڏينهن',
	            M: 'هڪ مهينو',
	            MM: '%d مهينا',
	            y: 'هڪ سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sd;
	
	})));


/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var se = moment.defineLocale('se', {
	        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
	            '_'
	        ),
	        monthsShort: 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split(
	            '_'
	        ),
	        weekdays: 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
	            '_'
	        ),
	        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'MMMM D. [b.] YYYY',
	            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s geažes',
	            past: 'maŋit %s',
	            s: 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m: 'okta minuhta',
	            mm: '%d minuhtat',
	            h: 'okta diimmu',
	            hh: '%d diimmut',
	            d: 'okta beaivi',
	            dd: '%d beaivvit',
	            M: 'okta mánnu',
	            MM: '%d mánut',
	            y: 'okta jahki',
	            yy: '%d jagit',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return se;
	
	})));


/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
	            '_'
	        ),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
	            '_'
	        ),
	        weekdays: 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
	            '_'
	        ),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            ss: 'තත්පර %d',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal: function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM: function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        },
	    });
	
	    return si;
	
	})));


/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
	            '_'
	        ),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sk;
	
	})));


/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nekaj sekund'
	                    : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sl;
	
	})));


/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sq = moment.defineLocale('sq', {
	        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
	            '_'
	        ),
	        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Sot në] LT',
	            nextDay: '[Nesër në] LT',
	            nextWeek: 'dddd [në] LT',
	            lastDay: '[Dje në] LT',
	            lastWeek: 'dddd [e kaluar në] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'në %s',
	            past: '%s më parë',
	            s: 'disa sekonda',
	            ss: '%d sekonda',
	            m: 'një minutë',
	            mm: '%d minuta',
	            h: 'një orë',
	            hh: '%d orë',
	            d: 'një ditë',
	            dd: '%d ditë',
	            M: 'një muaj',
	            MM: '%d muaj',
	            y: 'një vit',
	            yy: '%d vite',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sq;
	
	})));


/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
	            '_'
	        ),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'дан',
	            dd: translator.translate,
	            M: 'месец',
	            MM: translator.translate,
	            y: 'годину',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return srCyrl;
	
	})));


/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sr;
	
	})));


/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ss = moment.defineLocale('ss', {
	        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
	            '_'
	        ),
	        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays: 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Namuhla nga] LT',
	            nextDay: '[Kusasa nga] LT',
	            nextWeek: 'dddd [nga] LT',
	            lastDay: '[Itolo nga] LT',
	            lastWeek: 'dddd [leliphelile] [nga] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'nga %s',
	            past: 'wenteka nga %s',
	            s: 'emizuzwana lomcane',
	            ss: '%d mzuzwana',
	            m: 'umzuzu',
	            mm: '%d emizuzu',
	            h: 'lihora',
	            hh: '%d emahora',
	            d: 'lilanga',
	            dd: '%d emalanga',
	            M: 'inyanga',
	            MM: '%d tinyanga',
	            y: 'umnyaka',
	            yy: '%d iminyaka',
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: '%d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ss;
	
	})));


/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sv = moment.defineLocale('sv', {
	        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'för %s sedan',
	            s: 'några sekunder',
	            ss: '%d sekunder',
	            m: 'en minut',
	            mm: '%d minuter',
	            h: 'en timme',
	            hh: '%d timmar',
	            d: 'en dag',
	            dd: '%d dagar',
	            M: 'en månad',
	            MM: '%d månader',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? ':e'
	                        : b === 1
	                        ? ':a'
	                        : b === 2
	                        ? ':a'
	                        : b === 3
	                        ? ':e'
	                        : ':e';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sv;
	
	})));


/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sw = moment.defineLocale('sw', {
	        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'hh:mm A',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[leo saa] LT',
	            nextDay: '[kesho saa] LT',
	            nextWeek: '[wiki ijayo] dddd [saat] LT',
	            lastDay: '[jana] LT',
	            lastWeek: '[wiki iliyopita] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s baadaye',
	            past: 'tokea %s',
	            s: 'hivi punde',
	            ss: 'sekunde %d',
	            m: 'dakika moja',
	            mm: 'dakika %d',
	            h: 'saa limoja',
	            hh: 'masaa %d',
	            d: 'siku moja',
	            dd: 'siku %d',
	            M: 'mwezi mmoja',
	            MM: 'miezi %d',
	            y: 'mwaka mmoja',
	            yy: 'miaka %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sw;
	
	})));


/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '௧',
	            2: '௨',
	            3: '௩',
	            4: '௪',
	            5: '௫',
	            6: '௬',
	            7: '௭',
	            8: '௮',
	            9: '௯',
	            0: '௦',
	        },
	        numberMap = {
	            '௧': '1',
	            '௨': '2',
	            '௩': '3',
	            '௪': '4',
	            '௫': '5',
	            '௬': '6',
	            '௭': '7',
	            '௮': '8',
	            '௯': '9',
	            '௦': '0',
	        };
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        monthsShort: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        weekdays: 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
	            '_'
	        ),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
	            '_'
	        ),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm',
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            ss: '%d விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal: function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ta;
	
	})));


/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var te = moment.defineLocale('te', {
	        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
	            '_'
	        ),
	        monthsShort: 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
	            '_'
	        ),
	        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[నేడు] LT',
	            nextDay: '[రేపు] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[నిన్న] LT',
	            lastWeek: '[గత] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s లో',
	            past: '%s క్రితం',
	            s: 'కొన్ని క్షణాలు',
	            ss: '%d సెకన్లు',
	            m: 'ఒక నిమిషం',
	            mm: '%d నిమిషాలు',
	            h: 'ఒక గంట',
	            hh: '%d గంటలు',
	            d: 'ఒక రోజు',
	            dd: '%d రోజులు',
	            M: 'ఒక నెల',
	            MM: '%d నెలలు',
	            y: 'ఒక సంవత్సరం',
	            yy: '%d సంవత్సరాలు',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}వ/,
	        ordinal: '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return te;
	
	})));


/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	//! author : Sonia Simoes : https://github.com/soniasimoes
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tet = moment.defineLocale('tet', {
	        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'iha %s',
	            past: '%s liuba',
	            s: 'segundu balun',
	            ss: 'segundu %d',
	            m: 'minutu ida',
	            mm: 'minutu %d',
	            h: 'oras ida',
	            hh: 'oras %d',
	            d: 'loron ida',
	            dd: 'loron %d',
	            M: 'fulan ida',
	            MM: 'fulan %d',
	            y: 'tinan ida',
	            yy: 'tinan %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tet;
	
	})));


/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tajik [tg]
	//! author : Orif N. Jr. : https://github.com/orif-jr
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум',
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months: {
	            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
	                '_'
	            ),
	            standalone: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
	            '_'
	        ),
	        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Имрӯз соати] LT',
	            nextDay: '[Фардо соати] LT',
	            lastDay: '[Дирӯз соати] LT',
	            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'баъди %s',
	            past: '%s пеш',
	            s: 'якчанд сония',
	            m: 'як дақиқа',
	            mm: '%d дақиқа',
	            h: 'як соат',
	            hh: '%d соат',
	            d: 'як рӯз',
	            dd: '%d рӯз',
	            M: 'як моҳ',
	            MM: '%d моҳ',
	            y: 'як сол',
	            yy: '%d сол',
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1th is the first week of the year.
	        },
	    });
	
	    return tg;
	
	})));


/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
	            '_'
	        ),
	        monthsShort: 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H:mm',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            ss: '%d วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            w: '1 สัปดาห์',
	            ww: '%d สัปดาห์',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี',
	        },
	    });
	
	    return th;
	
	})));


/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkmen [tk]
	//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inji",
	        5: "'inji",
	        8: "'inji",
	        70: "'inji",
	        80: "'inji",
	        2: "'nji",
	        7: "'nji",
	        20: "'nji",
	        50: "'nji",
	        3: "'ünji",
	        4: "'ünji",
	        100: "'ünji",
	        6: "'njy",
	        9: "'unjy",
	        10: "'unjy",
	        30: "'unjy",
	        60: "'ynjy",
	        90: "'ynjy",
	    };
	
	    var tk = moment.defineLocale('tk', {
	        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
	        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
	        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün sagat] LT',
	            nextDay: '[ertir sagat] LT',
	            nextWeek: '[indiki] dddd [sagat] LT',
	            lastDay: '[düýn] LT',
	            lastWeek: '[geçen] dddd [sagat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s soň',
	            past: '%s öň',
	            s: 'birnäçe sekunt',
	            m: 'bir minut',
	            mm: '%d minut',
	            h: 'bir sagat',
	            hh: '%d sagat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir aý',
	            MM: '%d aý',
	            y: 'bir ýyl',
	            yy: '%d ýyl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'unjy";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tk;
	
	})));


/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlPh;
	
	})));


/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'leS'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'waQ'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'nem'
	                : time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'Hu’'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'wen'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'ben'
	                : time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	            ten = Math.floor((number % 100) / 10),
	            one = number % 10,
	            word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[one];
	        }
	        return word === '' ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsShort: 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysShort: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysMin: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: translateFuture,
	            past: translatePast,
	            s: 'puS lup',
	            ss: translate,
	            m: 'wa’ tup',
	            mm: translate,
	            h: 'wa’ rep',
	            hh: translate,
	            d: 'wa’ jaj',
	            dd: translate,
	            M: 'wa’ jar',
	            MM: translate,
	            y: 'wa’ DIS',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlh;
	
	})));


/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inci",
	        5: "'inci",
	        8: "'inci",
	        70: "'inci",
	        80: "'inci",
	        2: "'nci",
	        7: "'nci",
	        20: "'nci",
	        50: "'nci",
	        3: "'üncü",
	        4: "'üncü",
	        100: "'üncü",
	        6: "'ncı",
	        9: "'uncu",
	        10: "'uncu",
	        30: "'uncu",
	        60: "'ıncı",
	        90: "'ıncı",
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
	            '_'
	        ),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'öö' : 'ÖÖ';
	            } else {
	                return isLower ? 'ös' : 'ÖS';
	            }
	        },
	        meridiemParse: /öö|ÖÖ|ös|ÖS/,
	        isPM: function (input) {
	            return input === 'ös' || input === 'ÖS';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[gelecek] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            ss: '%d saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            w: 'bir hafta',
	            ww: '%d hafta',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'ıncı";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tr;
	
	})));


/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM [dallas] YYYY',
	            LLL: 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM: function (input) {
	            return "d'o" === input.toLowerCase();
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? "d'o" : "D'O";
	            } else {
	                return isLower ? "d'a" : "D'A";
	            }
	        },
	        calendar: {
	            sameDay: '[oxhi à] LT',
	            nextDay: '[demà à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[ieiri à] LT',
	            lastWeek: '[sür el] dddd [lasteu à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'osprei %s',
	            past: 'ja%s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['viensas secunds', "'iensas secunds"],
	            ss: [number + ' secunds', '' + number + ' secunds'],
	            m: ["'n míut", "'iens míut"],
	            mm: [number + ' míuts', '' + number + ' míuts'],
	            h: ["'n þora", "'iensa þora"],
	            hh: [number + ' þoras', '' + number + ' þoras'],
	            d: ["'n ziua", "'iensa ziua"],
	            dd: [number + ' ziuas', '' + number + ' ziuas'],
	            M: ["'n mes", "'iens mes"],
	            MM: [number + ' mesen', '' + number + ' mesen'],
	            y: ["'n ar", "'iens ar"],
	            yy: [number + ' ars', '' + number + ' ars'],
	        };
	        return isFuture
	            ? format[key][0]
	            : withoutSuffix
	            ? format[key][0]
	            : format[key][1];
	    }
	
	    return tzl;
	
	})));


/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        monthsShort: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            ss: '%d imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzmLatn;
	
	})));


/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        monthsShort: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            ss: '%d ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzm;
	
	})));


/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uyghur (China) [ug-cn]
	//! author: boyaq : https://github.com/boyaq
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل',
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return ugCn;
	
	})));


/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            dd: 'день_дні_днів',
	            MM: 'місяць_місяці_місяців',
	            yy: 'рік_роки_років',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	                nominative: 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
	                    '_'
	                ),
	                accusative: 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
	                    '_'
	                ),
	                genitive: 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
	                    '_'
	                ),
	            },
	            nounCase;
	
	        if (m === true) {
	            return weekdays['nominative']
	                .slice(1, 7)
	                .concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
	            ? 'accusative'
	            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
	            ? 'genitive'
	            : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: {
	            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
	                '_'
	            ),
	            standalone: 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
	            '_'
	        ),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural,
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uk;
	
	})));


/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوری',
	            'فروری',
	            'مارچ',
	            'اپریل',
	            'مئی',
	            'جون',
	            'جولائی',
	            'اگست',
	            'ستمبر',
	            'اکتوبر',
	            'نومبر',
	            'دسمبر',
	        ],
	        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
	
	    var ur = moment.defineLocale('ur', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[آج بوقت] LT',
	            nextDay: '[کل بوقت] LT',
	            nextWeek: 'dddd [بوقت] LT',
	            lastDay: '[گذشتہ روز بوقت] LT',
	            lastWeek: '[گذشتہ] dddd [بوقت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s بعد',
	            past: '%s قبل',
	            s: 'چند سیکنڈ',
	            ss: '%d سیکنڈ',
	            m: 'ایک منٹ',
	            mm: '%d منٹ',
	            h: 'ایک گھنٹہ',
	            hh: '%d گھنٹے',
	            d: 'ایک دن',
	            dd: '%d دن',
	            M: 'ایک ماہ',
	            MM: '%d ماہ',
	            y: 'ایک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ur;
	
	})));


/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays: 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
	            '_'
	        ),
	        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bugun soat] LT [da]',
	            nextDay: '[Ertaga] LT [da]',
	            nextWeek: 'dddd [kuni soat] LT [da]',
	            lastDay: '[Kecha soat] LT [da]',
	            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Yaqin %s ichida',
	            past: 'Bir necha %s oldin',
	            s: 'soniya',
	            ss: '%d soniya',
	            m: 'bir daqiqa',
	            mm: '%d daqiqa',
	            h: 'bir soat',
	            hh: '%d soat',
	            d: 'bir kun',
	            dd: '%d kun',
	            M: 'bir oy',
	            MM: '%d oy',
	            y: 'bir yil',
	            yy: '%d yil',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uzLatn;
	
	})));


/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uz = moment.defineLocale('uz', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бугун соат] LT [да]',
	            nextDay: '[Эртага] LT [да]',
	            nextWeek: 'dddd [куни соат] LT [да]',
	            lastDay: '[Кеча соат] LT [да]',
	            lastWeek: '[Утган] dddd [куни соат] LT [да]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Якин %s ичида',
	            past: 'Бир неча %s олдин',
	            s: 'фурсат',
	            ss: '%d фурсат',
	            m: 'бир дакика',
	            mm: '%d дакика',
	            h: 'бир соат',
	            hh: '%d соат',
	            d: 'бир кун',
	            dd: '%d кун',
	            M: 'бир ой',
	            MM: '%d ой',
	            y: 'бир йил',
	            yy: '%d йил',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return uz;
	
	})));


/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	//! author : Chien Kira : https://github.com/chienkira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
	            '_'
	        ),
	        monthsShort: 'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
	            '_'
	        ),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /sa|ch/i,
	        isPM: function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần trước lúc] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            ss: '%d giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            w: 'một tuần',
	            ww: '%d tuần',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return vi;
	
	})));


/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
	            '_'
	        ),
	        monthsShort: 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
	            '_'
	        ),
	        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[T~ódá~ý át] LT',
	            nextDay: '[T~ómó~rró~w át] LT',
	            nextWeek: 'dddd [át] LT',
	            lastDay: '[Ý~ést~érdá~ý át] LT',
	            lastWeek: '[L~ást] dddd [át] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'í~ñ %s',
	            past: '%s á~gó',
	            s: 'á ~féw ~sécó~ñds',
	            ss: '%d s~écóñ~ds',
	            m: 'á ~míñ~úté',
	            mm: '%d m~íñú~tés',
	            h: 'á~ñ hó~úr',
	            hh: '%d h~óúrs',
	            d: 'á ~dáý',
	            dd: '%d d~áýs',
	            M: 'á ~móñ~th',
	            MM: '%d m~óñt~hs',
	            y: 'á ~ýéár',
	            yy: '%d ý~éárs',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return xPseudo;
	
	})));


/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var yo = moment.defineLocale('yo', {
	        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
	            '_'
	        ),
	        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Ònì ni] LT',
	            nextDay: '[Ọ̀la ni] LT',
	            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
	            lastDay: '[Àna ni] LT',
	            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ní %s',
	            past: '%s kọjá',
	            s: 'ìsẹjú aayá die',
	            ss: 'aayá %d',
	            m: 'ìsẹjú kan',
	            mm: 'ìsẹjú %d',
	            h: 'wákati kan',
	            hh: 'wákati %d',
	            d: 'ọjọ́ kan',
	            dd: 'ọjọ́ %d',
	            M: 'osù kan',
	            MM: 'osù %d',
	            y: 'ọdún kan',
	            yy: 'ọdún %d',
	        },
	        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
	        ordinal: 'ọjọ́ %d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return yo;
	
	})));


/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	//! author : uu109 : https://github.com/uu109
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日Ah点mm分',
	            LLLL: 'YYYY年M月D日ddddAh点mm分',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[下]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            lastDay: '[昨天]LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[上]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s后',
	            past: '%s前',
	            s: '几秒',
	            ss: '%d 秒',
	            m: '1 分钟',
	            mm: '%d 分钟',
	            h: '1 小时',
	            hh: '%d 小时',
	            d: '1 天',
	            dd: '%d 天',
	            w: '1 周',
	            ww: '%d 周',
	            M: '1 个月',
	            MM: '%d 个月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return zhCn;
	
	})));


/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	//! author : Anthony : https://github.com/anthonylau
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1200) {
	                return '上午';
	            } else if (hm === 1200) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhHk;
	
	})));


/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Macau) [zh-mo]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Tan Yuanhong : https://github.com/le0tan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhMo = moment.defineLocale('zh-mo', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhMo;
	
	})));


/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhTw;
	
	})));


/***/ },
/* 950 */
/***/ function(module, exports) {

	'use strict';
	
	var numberIsNaN = function (value) {
		return value !== value;
	};
	
	module.exports = function is(a, b) {
		if (a === 0 && b === 0) {
			return 1 / a === 1 / b;
		}
		if (a === b) {
			return true;
		}
		if (numberIsNaN(a) && numberIsNaN(b)) {
			return true;
		}
		return false;
	};
	


/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(950);
	
	module.exports = function getPolyfill() {
		return typeof Object.is === 'function' ? Object.is : implementation;
	};


/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(953);
	
	var origKeys = Object.keys;
	var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(1923);
	
	var originalKeys = Object.keys;
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				var args = Object.keys(arguments);
				return args && args.length === arguments.length;
			}(1, 2));
			if (!keysWorksWithArguments) {
				Object.keys = function keys(object) { // eslint-disable-line func-name-matching
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					}
					return originalKeys(object);
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ },
/* 953 */
/***/ function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(1928);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 955 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 956 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(178);
	
	var invariant = __webpack_require__(28);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(213);
	var ReactDOMComponentTree = __webpack_require__(50);
	var ReactInstrumentation = __webpack_require__(94);
	
	var quoteAttributeValueForBrowser = __webpack_require__(1993);
	var warning = __webpack_require__(34);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 959 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(32);
	
	var LinkedValueUtils = __webpack_require__(502);
	var ReactDOMComponentTree = __webpack_require__(50);
	var ReactUpdates = __webpack_require__(111);
	
	var warning = __webpack_require__(34);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 961 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 962 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var invariant = __webpack_require__(28);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(1953);
	
	var containsNode = __webpack_require__(1731);
	var focusNode = __webpack_require__(756);
	var getActiveElement = __webpack_require__(757);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var DOMLazyTree = __webpack_require__(212);
	var DOMProperty = __webpack_require__(213);
	var React = __webpack_require__(216);
	var ReactBrowserEventEmitter = __webpack_require__(361);
	var ReactCurrentOwner = __webpack_require__(128);
	var ReactDOMComponentTree = __webpack_require__(50);
	var ReactDOMContainerInfo = __webpack_require__(1947);
	var ReactDOMFeatureFlags = __webpack_require__(1949);
	var ReactFeatureFlags = __webpack_require__(962);
	var ReactInstanceMap = __webpack_require__(279);
	var ReactInstrumentation = __webpack_require__(94);
	var ReactMarkupChecksum = __webpack_require__(1963);
	var ReactReconciler = __webpack_require__(214);
	var ReactUpdateQueue = __webpack_require__(505);
	var ReactUpdates = __webpack_require__(111);
	
	var emptyObject = __webpack_require__(477);
	var instantiateReactComponent = __webpack_require__(973);
	var invariant = __webpack_require__(28);
	var setInnerHTML = __webpack_require__(365);
	var shouldUpdateReactComponent = __webpack_require__(511);
	var warning = __webpack_require__(34);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var React = __webpack_require__(216);
	
	var invariant = __webpack_require__(28);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 967 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var invariant = __webpack_require__(28);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 969 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(966);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(74);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(50);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37),
	    _assign = __webpack_require__(32);
	
	var ReactCompositeComponent = __webpack_require__(1944);
	var ReactEmptyComponent = __webpack_require__(961);
	var ReactHostComponent = __webpack_require__(963);
	
	var getNextDebugID = __webpack_require__(2027);
	var invariant = __webpack_require__(28);
	var warning = __webpack_require__(34);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },
/* 974 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(74);
	var escapeTextContentForBrowser = __webpack_require__(364);
	var setInnerHTML = __webpack_require__(365);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 976 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var ReactCurrentOwner = __webpack_require__(128);
	var REACT_ELEMENT_TYPE = __webpack_require__(1959);
	
	var getIteratorFn = __webpack_require__(1990);
	var invariant = __webpack_require__(28);
	var KeyEscapeUtils = __webpack_require__(501);
	var warning = __webpack_require__(34);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(60);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(64);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(514);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var bool = _React$PropTypes.bool;
	var object = _React$PropTypes.object;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	var oneOfType = _React$PropTypes.oneOfType;
	
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function createLocationDescriptor(to, _ref) {
	  var query = _ref.query;
	  var hash = _ref.hash;
	  var state = _ref.state;
	
	  if (query || hash || state) {
	    return { pathname: to, query: query, hash: hash, state: state };
	  }
	
	  return to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 *
	 * Links may pass along location state and/or query string parameters
	 * in the state/query props, respectively.
	 *
	 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
	 */
	var Link = _react2.default.createClass({
	  displayName: 'Link',
	
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: oneOfType([string, object]),
	    query: object,
	    hash: string,
	    state: object,
	    activeStyle: object,
	    activeClassName: string,
	    onlyActiveOnIndex: bool.isRequired,
	    onClick: func,
	    target: string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    !this.context.router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    var _props = this.props;
	    var to = _props.to;
	    var query = _props.query;
	    var hash = _props.hash;
	    var state = _props.state;
	
	    var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	
	    this.context.router.push(location);
	  },
	  render: function render() {
	    var _props2 = this.props;
	    var to = _props2.to;
	    var query = _props2.query;
	    var hash = _props2.hash;
	    var state = _props2.state;
	    var activeClassName = _props2.activeClassName;
	    var activeStyle = _props2.activeStyle;
	    var onlyActiveOnIndex = _props2.onlyActiveOnIndex;
	
	    var props = _objectWithoutProperties(_props2, ['to', 'query', 'hash', 'state', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	     false ? (0, _routerWarning2.default)(!(query || hash || state), 'the `query`, `hash`, and `state` props on `<Link>` are deprecated, use `<Link to={{ pathname, query, hash, state }}/>. http://tiny.cc/router-isActivedeprecated') : void 0;
	
	    // Ignore if rendered outside the context of router, simplifies unit testing.
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (to == null) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	      props.href = router.createHref(location);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(location, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(60);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(147);
	
	var _PatternUtils = __webpack_require__(215);
	
	var _InternalPropTypes = __webpack_require__(179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	
	var Redirect = _react2.default.createClass({
	  displayName: 'Redirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location;
	        var params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: string,
	    from: string, // Alias for path
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.createRoutingHistory = createRoutingHistory;
	
	var _deprecateObjectProperties = __webpack_require__(367);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createRouterObject(history, transitionManager) {
	  return _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	}
	
	// deprecated
	function createRoutingHistory(history, transitionManager) {
	  history = _extends({}, history, transitionManager);
	
	  if (false) {
	    history = (0, _deprecateObjectProperties2.default)(history, '`props.history` and `context.history` are deprecated. Please use `context.router`. http://tiny.cc/router-contextchanges');
	  }
	
	  return history;
	}

/***/ },
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(345);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(766);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(1751);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useRoutes` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  history.__v2_compatible__ = true;
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	};
	
	var _useRouterHistory = __webpack_require__(983);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	module.exports = exports['default'];

/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = makeStateWithLocation;
	
	var _deprecateObjectProperties = __webpack_require__(367);
	
	var _routerWarning = __webpack_require__(64);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeStateWithLocation(state, location) {
	  if (false) {
	    var stateWithLocation = _extends({}, state);
	
	    // I don't use deprecateObjectProperties here because I want to keep the
	    // same code path between development and production, in that we just
	    // assign extra properties to the copy of the state object in both cases.
	
	    var _loop = function _loop(prop) {
	      if (!Object.prototype.hasOwnProperty.call(location, prop)) {
	        return 'continue';
	      }
	
	      Object.defineProperty(stateWithLocation, prop, {
	        get: function get() {
	          process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, 'Accessing location properties directly from the first argument to `getComponent`, `getComponents`, `getChildRoutes`, and `getIndexRoute` is deprecated. That argument is now the router state (`nextState` or `partialNextState`) rather than the location. To access the location, use `nextState.location` or `partialNextState.location`.') : void 0;
	          return location[prop];
	        }
	      });
	    };
	
	    for (var prop in location) {
	      var _ret = _loop(prop);
	
	      if (_ret === 'continue') continue;
	    }
	
	    return stateWithLocation;
	  }
	
	  return _extends({}, state, location);
	}
	module.exports = exports['default'];

/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(345);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(766);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    history.__v2_compatible__ = true;
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(281),
	    _assign = __webpack_require__(32);
	
	var ReactNoopUpdateQueue = __webpack_require__(987);
	
	var canDefineProperty = __webpack_require__(988);
	var emptyObject = __webpack_require__(477);
	var invariant = __webpack_require__(28);
	var lowPriorityWarning = __webpack_require__(2028);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(281);
	
	var ReactCurrentOwner = __webpack_require__(128);
	
	var invariant = __webpack_require__(28);
	var warning = __webpack_require__(34);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 986 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(34);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 8);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports) {
	
	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (process.env.NODE_ENV !== 'production') {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;
	
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	
	
	var emptyFunction = __webpack_require__(1);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (process.env.NODE_ENV !== 'production') {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.2.0
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader = false;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
					__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
					(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
					__WEBPACK_AMD_DEFINE_FACTORY__),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (true) {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function init (converter) {
			function api (key, value, attributes) {
				var result;
				if (typeof document === 'undefined') {
					return;
				}
	
				// Write
	
				if (arguments.length > 1) {
					attributes = extend({
						path: '/'
					}, api.defaults, attributes);
	
					if (typeof attributes.expires === 'number') {
						var expires = new Date();
						expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
						attributes.expires = expires;
					}
	
					// We're using "expires" because "max-age" is not supported by IE
					attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
					try {
						result = JSON.stringify(value);
						if (/^[\{\[]/.test(result)) {
							value = result;
						}
					} catch (e) {}
	
					if (!converter.write) {
						value = encodeURIComponent(String(value))
							.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
					} else {
						value = converter.write(value, key);
					}
	
					key = encodeURIComponent(String(key));
					key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
					key = key.replace(/[\(\)]/g, escape);
	
					var stringifiedAttributes = '';
	
					for (var attributeName in attributes) {
						if (!attributes[attributeName]) {
							continue;
						}
						stringifiedAttributes += '; ' + attributeName;
						if (attributes[attributeName] === true) {
							continue;
						}
						stringifiedAttributes += '=' + attributes[attributeName];
					}
					return (document.cookie = key + '=' + value + stringifiedAttributes);
				}
	
				// Read
	
				if (!key) {
					result = {};
				}
	
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all. Also prevents odd result when
				// calling "get()"
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var rdecode = /(%[0-9A-Z]{2})+/g;
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (!this.json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = parts[0].replace(rdecode, decodeURIComponent);
						cookie = converter.read ?
							converter.read(cookie, name) : converter(cookie, name) ||
							cookie.replace(rdecode, decodeURIComponent);
	
						if (this.json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						if (key === name) {
							result = cookie;
							break;
						}
	
						if (!key) {
							result[name] = cookie;
						}
					} catch (e) {}
				}
	
				return result;
			}
	
			api.set = api;
			api.get = function (key) {
				return api.call(api, key);
			};
			api.getJSON = function () {
				return api.apply({
					json: true
				}, [].slice.call(arguments));
			};
			api.defaults = {};
	
			api.remove = function (key, attributes) {
				api(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));
	
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (process.env.NODE_ENV !== 'production') {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = __webpack_require__(12)(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(11)();
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(2);
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Cookies = exports.OPTIONS = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(7);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _jsCookie = __webpack_require__(5);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OPTIONS = exports.OPTIONS = {
	  TOP: "top",
	  BOTTOM: "bottom",
	  NONE: "none"
	};
	
	var CookieConsent = function (_Component) {
	  _inherits(CookieConsent, _Component);
	
	  function CookieConsent(props) {
	    _classCallCheck(this, CookieConsent);
	
	    var _this = _possibleConstructorReturn(this, (CookieConsent.__proto__ || Object.getPrototypeOf(CookieConsent)).call(this, props));
	
	    _this.accept.bind(_this);
	
	    _this.state = {
	      visible: false,
	      style: {
	        alignItems: "baseline",
	        background: "#353535",
	        color: "white",
	        display: "flex",
	        flexWrap: "wrap",
	        justifyContent: "space-between",
	        left: "0",
	        position: "fixed",
	        width: "100%",
	        zIndex: "999"
	      },
	      buttonStyle: {
	        background: "#ffd42d",
	        border: "0",
	        borderRadius: "0px",
	        boxShadow: "none",
	        color: "black",
	        flex: "0 0 auto",
	        padding: "5px 10px",
	        margin: "15px"
	      },
	      contentStyle: {
	        flex: "1 0 300px",
	        margin: "15px"
	      }
	    };
	
	    _this.handleScroll = _this.handleScroll.bind(_this);
	    return _this;
	  }
	
	  _createClass(CookieConsent, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _props = this.props,
	          cookieName = _props.cookieName,
	          debug = _props.debug;
	
	      // if cookie undefined or debug
	
	      if (_jsCookie2.default.get(cookieName) === undefined || debug) {
	        this.setState({ visible: true });
	      }
	
	      // if acceptOnScroll is set to true, add a listener
	      if (this.props.acceptOnScroll) {
	        window.addEventListener("scroll", this.handleScroll, { passive: true });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      // remove listener if still set
	      window.removeEventListener("scroll", this.handleScroll);
	    }
	
	    /**
	     * checks whether scroll has exceeded set amount and fire accept if so.
	     */
	
	  }, {
	    key: "handleScroll",
	    value: function handleScroll() {
	      // (top / height) - height * 100
	      var rootNode = document.documentElement,
	          body = document.body,
	          top = "scrollTop",
	          height = "scrollHeight";
	
	      var percentage = (rootNode[top] || body[top]) / ((rootNode[height] || body[height]) - rootNode.clientHeight) * 100;
	
	      if (percentage > this.props.acceptOnScrollPercentage) {
	        this.accept();
	      }
	    }
	
	    /**
	     * Set a persistent cookie
	     */
	
	  }, {
	    key: "accept",
	    value: function accept() {
	      var _props2 = this.props,
	          cookieName = _props2.cookieName,
	          cookieValue = _props2.cookieValue,
	          expires = _props2.expires,
	          hideOnAccept = _props2.hideOnAccept,
	          onAccept = _props2.onAccept,
	          extraCookieOptions = _props2.extraCookieOptions;
	
	      // fire onAccept
	
	      onAccept();
	      // remove listener if set
	      window.removeEventListener("scroll", this.handleScroll);
	
	      _jsCookie2.default.set(cookieName, cookieValue, _extends({ expires: expires }, extraCookieOptions));
	
	      if (hideOnAccept) {
	        this.setState({ visible: false });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      // If the bar shouldn't be visible don't render anything.
	      if (!this.state.visible) {
	        return null;
	      }
	
	      var _props3 = this.props,
	          location = _props3.location,
	          style = _props3.style,
	          buttonStyle = _props3.buttonStyle,
	          contentStyle = _props3.contentStyle,
	          disableStyles = _props3.disableStyles,
	          buttonText = _props3.buttonText,
	          containerClasses = _props3.containerClasses,
	          contentClasses = _props3.contentClasses,
	          buttonClasses = _props3.buttonClasses,
	          buttonId = _props3.buttonId;
	
	
	      var myStyle = {};
	      var myButtonStyle = {};
	      var myContentStyle = {};
	
	      if (disableStyles) {
	        // if styles are disabled use the provided styles (or non)
	        myStyle = Object.assign({}, style);
	        myButtonStyle = Object.assign({}, buttonStyle);
	        myContentStyle = Object.assign({}, contentStyle);
	      } else {
	        // if styles aren't disabled merge them with the styles that are provided (or use default styles)
	        myStyle = Object.assign({}, _extends({}, this.state.style, style));
	        myButtonStyle = Object.assign({}, _extends({}, this.state.buttonStyle, buttonStyle));
	        myContentStyle = Object.assign({}, _extends({}, this.state.contentStyle, contentStyle));
	      }
	
	      // syntactic sugar to enable user to easily select top / bottom
	      switch (location) {
	        case OPTIONS.TOP:
	          myStyle.top = "0";
	          myStyle.position = "fixed";
	          break;
	
	        case OPTIONS.BOTTOM:
	          myStyle.bottom = "0";
	          myStyle.position = "fixed";
	          break;
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "cookieConsent " + containerClasses, style: myStyle },
	        _react2.default.createElement(
	          "div",
	          { style: myContentStyle, className: contentClasses },
	          this.props.children
	        ),
	        _react2.default.createElement(
	          "button",
	          {
	            style: myButtonStyle,
	            className: buttonClasses,
	            id: buttonId,
	            onClick: function onClick() {
	              _this2.accept();
	            }
	          },
	          buttonText
	        )
	      );
	    }
	  }]);
	
	  return CookieConsent;
	}(_react.Component);
	
	CookieConsent.propTypes = {
	  location: _propTypes2.default.oneOf(Object.keys(OPTIONS).map(function (key) {
	    return OPTIONS[key];
	  })),
	  style: _propTypes2.default.object,
	  buttonStyle: _propTypes2.default.object,
	  contentStyle: _propTypes2.default.object,
	  children: _propTypes2.default.any, // eslint-disable-line react/forbid-prop-types
	  disableStyles: _propTypes2.default.bool,
	  hideOnAccept: _propTypes2.default.bool,
	  onAccept: _propTypes2.default.func,
	  buttonText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.element]),
	  cookieName: _propTypes2.default.string,
	  cookieValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool, _propTypes2.default.number]),
	  debug: _propTypes2.default.bool,
	  expires: _propTypes2.default.number,
	  containerClasses: _propTypes2.default.string,
	  contentClasses: _propTypes2.default.string,
	  buttonClasses: _propTypes2.default.string,
	  buttonId: _propTypes2.default.string,
	  acceptOnScroll: _propTypes2.default.bool,
	  acceptOnScrollPercentage: _propTypes2.default.number,
	  extraCookieOptions: _propTypes2.default.object
	};
	
	CookieConsent.defaultProps = {
	  disableStyles: false,
	  hideOnAccept: true,
	  acceptOnScroll: false,
	  acceptOnScrollPercentage: 25,
	  location: OPTIONS.BOTTOM,
	  onAccept: function onAccept() {},
	  cookieName: "CookieConsent",
	  cookieValue: true,
	  buttonText: "I understand",
	  debug: false,
	  expires: 365,
	  containerClasses: "",
	  contentClasses: "",
	  buttonClasses: "",
	  buttonId: "",
	  extraCookieOptions: {}
	};
	
	exports.default = CookieConsent;
	exports.Cookies = _jsCookie2.default;
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};
	
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	
	
	if (process.env.NODE_ENV !== 'production') {
	  var invariant = __webpack_require__(2);
	  var warning = __webpack_require__(4);
	  var ReactPropTypesSecret = __webpack_require__(3);
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	
	
	var emptyFunction = __webpack_require__(1);
	var invariant = __webpack_require__(2);
	var ReactPropTypesSecret = __webpack_require__(3);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	
	
	var emptyFunction = __webpack_require__(1);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(4);
	var assign = __webpack_require__(9);
	
	var ReactPropTypesSecret = __webpack_require__(3);
	var checkPropTypes = __webpack_require__(10);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))
	
	/***/ })
	/******/ ]);

/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isSafari = exports.isFirefox = undefined;
	
	var _memoize = __webpack_require__(811);
	
	var _memoize2 = _interopRequireDefault(_memoize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isFirefox = exports.isFirefox = (0, _memoize2.default)(function () {
	  return (/firefox/i.test(navigator.userAgent)
	  );
	});
	var isSafari = exports.isSafari = (0, _memoize2.default)(function () {
	  return Boolean(window.safari);
	});

/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getEmptyImage = exports.NativeTypes = undefined;
	exports.default = createHTML5Backend;
	
	var _HTML5Backend = __webpack_require__(2033);
	
	var _HTML5Backend2 = _interopRequireDefault(_HTML5Backend);
	
	var _getEmptyImage = __webpack_require__(2037);
	
	var _getEmptyImage2 = _interopRequireDefault(_getEmptyImage);
	
	var _NativeTypes = __webpack_require__(516);
	
	var NativeTypes = _interopRequireWildcard(_NativeTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.NativeTypes = NativeTypes;
	exports.getEmptyImage = _getEmptyImage2.default;
	function createHTML5Backend(manager) {
		return new _HTML5Backend2.default(manager);
	}

/***/ },
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.unpackBackendForEs5Users = exports.createChildContext = exports.CHILD_CONTEXT_TYPES = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = DragDropContext;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dndCore = __webpack_require__(1440);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _hoistNonReactStatics = __webpack_require__(518);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _checkDecoratorArguments = __webpack_require__(368);
	
	var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CHILD_CONTEXT_TYPES = exports.CHILD_CONTEXT_TYPES = {
		dragDropManager: _propTypes2.default.object.isRequired
	};
	
	var createChildContext = exports.createChildContext = function createChildContext(backend, context) {
		return {
			dragDropManager: new _dndCore.DragDropManager(backend, context)
		};
	};
	
	var unpackBackendForEs5Users = exports.unpackBackendForEs5Users = function unpackBackendForEs5Users(backendOrModule) {
		// Auto-detect ES6 default export for people still using ES5
		var backend = backendOrModule;
		if ((typeof backend === 'undefined' ? 'undefined' : _typeof(backend)) === 'object' && typeof backend.default === 'function') {
			backend = backend.default;
		}
		(0, _invariant2.default)(typeof backend === 'function', 'Expected the backend to be a function or an ES6 module exporting a default function. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-drop-context.html');
		return backend;
	};
	
	function DragDropContext(backendOrModule) {
		_checkDecoratorArguments2.default.apply(undefined, ['DragDropContext', 'backend'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params
	
		var backend = unpackBackendForEs5Users(backendOrModule);
		var childContext = createChildContext(backend);
	
		return function decorateContext(DecoratedComponent) {
			var _class, _temp;
	
			var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
	
			var DragDropContextContainer = (_temp = _class = function (_Component) {
				_inherits(DragDropContextContainer, _Component);
	
				function DragDropContextContainer() {
					_classCallCheck(this, DragDropContextContainer);
	
					return _possibleConstructorReturn(this, (DragDropContextContainer.__proto__ || Object.getPrototypeOf(DragDropContextContainer)).apply(this, arguments));
				}
	
				_createClass(DragDropContextContainer, [{
					key: 'getDecoratedComponentInstance',
					value: function getDecoratedComponentInstance() {
						(0, _invariant2.default)(this.child, 'In order to access an instance of the decorated component it can not be a stateless component.');
						return this.child;
					}
				}, {
					key: 'getManager',
					value: function getManager() {
						return childContext.dragDropManager;
					}
				}, {
					key: 'getChildContext',
					value: function getChildContext() {
						return childContext;
					}
				}, {
					key: 'render',
					value: function render() {
						var _this2 = this;
	
						return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, {
							ref: function ref(child) {
								_this2.child = child;
							}
						}));
					}
				}]);
	
				return DragDropContextContainer;
			}(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = 'DragDropContext(' + displayName + ')', _class.childContextTypes = CHILD_CONTEXT_TYPES, _temp);
	
	
			return (0, _hoistNonReactStatics2.default)(DragDropContextContainer, DecoratedComponent);
		};
	}

/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = areOptionsEqual;
	
	var _shallowEqual = __webpack_require__(517);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function areOptionsEqual(nextOptions, currentOptions) {
		if (currentOptions === nextOptions) {
			return true;
		}
	
		return currentOptions !== null && nextOptions !== null && (0, _shallowEqual2.default)(currentOptions, nextOptions);
	}

/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = decorateHandler;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _disposables = __webpack_require__(1433);
	
	var _isPlainObject = __webpack_require__(126);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _hoistNonReactStatics = __webpack_require__(518);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _shallowEqual = __webpack_require__(517);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _shallowEqualScalar = __webpack_require__(996);
	
	var _shallowEqualScalar2 = _interopRequireDefault(_shallowEqualScalar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isClassComponent = function isClassComponent(Comp) {
		return Boolean(Comp && Comp.prototype && typeof Comp.prototype.render === 'function');
	};
	
	function decorateHandler(_ref) {
		var _class, _temp;
	
		var DecoratedComponent = _ref.DecoratedComponent,
		    createHandler = _ref.createHandler,
		    createMonitor = _ref.createMonitor,
		    createConnector = _ref.createConnector,
		    registerHandler = _ref.registerHandler,
		    containerDisplayName = _ref.containerDisplayName,
		    getType = _ref.getType,
		    collect = _ref.collect,
		    options = _ref.options;
		var _options$arePropsEqua = options.arePropsEqual,
		    arePropsEqual = _options$arePropsEqua === undefined ? _shallowEqualScalar2.default : _options$arePropsEqua;
	
		var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
	
		var DragDropContainer = (_temp = _class = function (_Component) {
			_inherits(DragDropContainer, _Component);
	
			_createClass(DragDropContainer, [{
				key: 'getHandlerId',
				value: function getHandlerId() {
					return this.handlerId;
				}
			}, {
				key: 'getDecoratedComponentInstance',
				value: function getDecoratedComponentInstance() {
					return this.decoratedComponentInstance;
				}
			}, {
				key: 'shouldComponentUpdate',
				value: function shouldComponentUpdate(nextProps, nextState) {
					return !arePropsEqual(nextProps, this.props) || !(0, _shallowEqual2.default)(nextState, this.state);
				}
			}]);
	
			function DragDropContainer(props, context) {
				_classCallCheck(this, DragDropContainer);
	
				var _this = _possibleConstructorReturn(this, (DragDropContainer.__proto__ || Object.getPrototypeOf(DragDropContainer)).call(this, props, context));
	
				_this.handleChange = _this.handleChange.bind(_this);
				_this.handleChildRef = _this.handleChildRef.bind(_this);
	
				(0, _invariant2.default)(_typeof(_this.context.dragDropManager) === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to wrap the top-level component of your app with DragDropContext. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);
	
				_this.manager = _this.context.dragDropManager;
				_this.handlerMonitor = createMonitor(_this.manager);
				_this.handlerConnector = createConnector(_this.manager.getBackend());
				_this.handler = createHandler(_this.handlerMonitor);
	
				_this.disposable = new _disposables.SerialDisposable();
				_this.receiveProps(props);
				_this.state = _this.getCurrentState();
				_this.dispose();
				return _this;
			}
	
			_createClass(DragDropContainer, [{
				key: 'componentDidMount',
				value: function componentDidMount() {
					this.isCurrentlyMounted = true;
					this.disposable = new _disposables.SerialDisposable();
					this.currentType = null;
					this.receiveProps(this.props);
					this.handleChange();
				}
			}, {
				key: 'componentWillReceiveProps',
				value: function componentWillReceiveProps(nextProps) {
					if (!arePropsEqual(nextProps, this.props)) {
						this.receiveProps(nextProps);
						this.handleChange();
					}
				}
			}, {
				key: 'componentWillUnmount',
				value: function componentWillUnmount() {
					this.dispose();
					this.isCurrentlyMounted = false;
				}
			}, {
				key: 'receiveProps',
				value: function receiveProps(props) {
					this.handler.receiveProps(props);
					this.receiveType(getType(props));
				}
			}, {
				key: 'receiveType',
				value: function receiveType(type) {
					if (type === this.currentType) {
						return;
					}
	
					this.currentType = type;
	
					var _registerHandler = registerHandler(type, this.handler, this.manager),
					    handlerId = _registerHandler.handlerId,
					    unregister = _registerHandler.unregister;
	
					this.handlerId = handlerId;
					this.handlerMonitor.receiveHandlerId(handlerId);
					this.handlerConnector.receiveHandlerId(handlerId);
	
					var globalMonitor = this.manager.getMonitor();
					var unsubscribe = globalMonitor.subscribeToStateChange(this.handleChange, { handlerIds: [handlerId] });
	
					this.disposable.setDisposable(new _disposables.CompositeDisposable(new _disposables.Disposable(unsubscribe), new _disposables.Disposable(unregister)));
				}
			}, {
				key: 'handleChange',
				value: function handleChange() {
					if (!this.isCurrentlyMounted) {
						return;
					}
	
					var nextState = this.getCurrentState();
					if (!(0, _shallowEqual2.default)(nextState, this.state)) {
						this.setState(nextState);
					}
				}
			}, {
				key: 'dispose',
				value: function dispose() {
					this.disposable.dispose();
					this.handlerConnector.receiveHandlerId(null);
				}
			}, {
				key: 'handleChildRef',
				value: function handleChildRef(component) {
					this.decoratedComponentInstance = component;
					this.handler.receiveComponent(component);
				}
			}, {
				key: 'getCurrentState',
				value: function getCurrentState() {
					var nextState = collect(this.handlerConnector.hooks, this.handlerMonitor);
	
					if (false) {
						(0, _invariant2.default)((0, _isPlainObject2.default)(nextState), 'Expected `collect` specified as the second argument to ' + '%s for %s to return a plain object of props to inject. ' + 'Instead, received %s.', containerDisplayName, displayName, nextState);
					}
	
					return nextState;
				}
			}, {
				key: 'render',
				value: function render() {
					return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, this.state, {
						ref: isClassComponent(DecoratedComponent) ? this.handleChildRef : null
					}));
				}
			}]);
	
			return DragDropContainer;
		}(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = containerDisplayName + '(' + displayName + ')', _class.contextTypes = {
			dragDropManager: _propTypes2.default.object.isRequired
		}, _temp);
	
	
		return (0, _hoistNonReactStatics2.default)(DragDropContainer, DecoratedComponent);
	}

/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isValidType;
	
	var _isArray = __webpack_require__(35);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidType(type, allowArray) {
		return typeof type === 'string' || (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'symbol' || allowArray && (0, _isArray2.default)(type) && type.every(function (t) {
			return isValidType(t, false);
		});
	}

/***/ },
/* 996 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = shallowEqualScalar;
	function shallowEqualScalar(objA, objB) {
		if (objA === objB) {
			return true;
		}
	
		if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
			return false;
		}
	
		var keysA = Object.keys(objA);
		var keysB = Object.keys(objB);
	
		if (keysA.length !== keysB.length) {
			return false;
		}
	
		// Test for A's keys different from B.
		var hasOwn = Object.prototype.hasOwnProperty;
		for (var i = 0; i < keysA.length; i += 1) {
			if (!hasOwn.call(objB, keysA[i])) {
				return false;
			}
	
			var valA = objA[keysA[i]];
			var valB = objB[keysA[i]];
	
			if (valA !== valB || (typeof valA === 'undefined' ? 'undefined' : _typeof(valA)) === 'object' || (typeof valB === 'undefined' ? 'undefined' : _typeof(valB)) === 'object') {
				return false;
			}
		}
	
		return true;
	}

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = wrapConnectorHooks;
	
	var _react = __webpack_require__(2);
	
	var _cloneWithRef = __webpack_require__(2051);
	
	var _cloneWithRef2 = _interopRequireDefault(_cloneWithRef);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function throwIfCompositeComponentElement(element) {
		// Custom components can no longer be wrapped directly in React DnD 2.0
		// so that we don't need to depend on findDOMNode() from react-dom.
		if (typeof element.type === 'string') {
			return;
		}
	
		var displayName = element.type.displayName || element.type.name || 'the component';
	
		throw new Error('Only native element nodes can now be passed to React DnD connectors.' + ('You can either wrap ' + displayName + ' into a <div>, or turn it into a ') + 'drag source or a drop target itself.');
	}
	
	function wrapHookToRecognizeElement(hook) {
		return function () {
			var elementOrNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
			// When passed a node, call the hook straight away.
			if (!(0, _react.isValidElement)(elementOrNode)) {
				var node = elementOrNode;
				hook(node, options);
				return undefined;
			}
	
			// If passed a ReactElement, clone it and attach this function as a ref.
			// This helps us achieve a neat API where user doesn't even know that refs
			// are being used under the hood.
			var element = elementOrNode;
			throwIfCompositeComponentElement(element);
	
			// When no options are passed, use the hook directly
			var ref = options ? function (node) {
				return hook(node, options);
			} : hook;
	
			return (0, _cloneWithRef2.default)(element, ref);
		};
	}
	
	function wrapConnectorHooks(hooks) {
		var wrappedHooks = {};
	
		Object.keys(hooks).forEach(function (key) {
			var hook = hooks[key];
			var wrappedHook = wrapHookToRecognizeElement(hook);
			wrappedHooks[key] = function () {
				return wrappedHook;
			};
		});
	
		return wrappedHooks;
	}

/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports["default"] = _propTypes2["default"].shape({
	  subscribe: _propTypes2["default"].func.isRequired,
	  dispatch: _propTypes2["default"].func.isRequired,
	  getState: _propTypes2["default"].func.isRequired
	});

/***/ },
/* 999 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 1000 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * This action type will be dispatched by the history actions below.
	 * If you're writing a middleware to watch for navigation events, be sure to
	 * look for actions of this type.
	 */
	var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
	
	function updateLocation(method) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: CALL_HISTORY_METHOD,
	      payload: { method: method, args: args }
	    };
	  };
	}
	
	/**
	 * These actions correspond to the history API.
	 * The associated routerMiddleware will capture these events before they get to
	 * your reducer and reissue them as the matching function on your history.
	 */
	var push = exports.push = updateLocation('push');
	var replace = exports.replace = updateLocation('replace');
	var go = exports.go = updateLocation('go');
	var goBack = exports.goBack = updateLocation('goBack');
	var goForward = exports.goForward = updateLocation('goForward');
	
	var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ },
/* 1001 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.routerReducer = routerReducer;
	/**
	 * This action type will be dispatched when your history
	 * receives a location change.
	 */
	var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
	
	var initialState = {
	  locationBeforeTransitions: null
	};
	
	/**
	 * This reducer will update the state with the most recent location history
	 * has transitioned to. This may not be in sync with the router, particularly
	 * if you have asynchronously-loaded routes, so reading from and relying on
	 * this state is discouraged.
	 */
	function routerReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      type = _ref.type,
	      payload = _ref.payload;
	
	  if (type === LOCATION_CHANGE) {
	    return _extends({}, state, { locationBeforeTransitions: payload });
	  }
	
	  return state;
	}

/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(104);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(4);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(521);
	
	var _ContextUtils = __webpack_require__(520);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function resolveToLocation(to, router) {
	  return typeof to === 'function' ? to(router.location) : to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 */
	var Link = (0, _createReactClass2.default)({
	  displayName: 'Link',
	
	  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object, _propTypes.func]),
	    activeStyle: _propTypes.object,
	    activeClassName: _propTypes.string,
	    onlyActiveOnIndex: _propTypes.bool.isRequired,
	    onClick: _propTypes.func,
	    target: _propTypes.string,
	    innerRef: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func, (0, _propTypes.shape)({ current: _propTypes.elementType })])
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    var router = this.context.router;
	
	    !router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    router.push(resolveToLocation(this.props.to, router));
	  },
	  render: function render() {
	    var _props = this.props,
	        to = _props.to,
	        activeClassName = _props.activeClassName,
	        activeStyle = _props.activeStyle,
	        onlyActiveOnIndex = _props.onlyActiveOnIndex,
	        innerRef = _props.innerRef,
	        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex', 'innerRef']);
	
	    // Ignore if rendered outside the context of router to simplify unit testing.
	
	
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (!to) {
	        return _react2.default.createElement('a', _extends({}, props, { ref: innerRef }));
	      }
	
	      var toLocation = resolveToLocation(to, router);
	      props.href = router.createHref(toLocation);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(toLocation, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick, ref: innerRef }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 1003 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isPromise = isPromise;
	function isPromise(obj) {
	  return obj && typeof obj.then === 'function';
	}

/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(104);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(4);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(148);
	
	var _PatternUtils = __webpack_require__(219);
	
	var _InternalPropTypes = __webpack_require__(282);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	/* eslint-disable react/require-render-return */
	var Redirect = (0, _createReactClass2.default)({
	  displayName: 'Redirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location,
	            params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    from: _propTypes.string, // Alias for path
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 1005 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.assignRouterState = assignRouterState;
	function createRouterObject(history, transitionManager, state) {
	  var router = _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	
	  return assignRouterState(router, state);
	}
	
	function assignRouterState(router, _ref) {
	  var location = _ref.location,
	      params = _ref.params,
	      routes = _ref.routes;
	
	  router.location = location;
	  router.params = params;
	  router.routes = routes;
	
	  return router;
	}

/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(1013);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(1012);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(2081);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useQueries` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createRouterHistory;
	
	var _useRouterHistory = __webpack_require__(1010);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	function createRouterHistory(createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(220);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(2068);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(2065);
	
	var _TransitionUtils2 = _interopRequireDefault(_TransitionUtils);
	
	var _isActive2 = __webpack_require__(2072);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(2069);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(2074);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  var _getTransitionUtils = (0, _TransitionUtils2.default)(),
	      runEnterHooks = _getTransitionUtils.runEnterHooks,
	      runChangeHooks = _getTransitionUtils.runChangeHooks,
	      runLeaveHooks = _getTransitionUtils.runLeaveHooks;
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	
	
	  function isActive(location, indexOnly) {
	    location = history.createLocation(location);
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
	        leaveRoutes = _computeChangedRoutes.leaveRoutes,
	        changeRoutes = _computeChangedRoutes.changeRoutes,
	        enterRoutes = _computeChangedRoutes.enterRoutes;
	
	    runLeaveHooks(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.map(function (route) {
	      return RouteHooks[getRouteID(route)];
	    }).filter(function (hook) {
	      return hook;
	    });
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	    var routeID = getRouteID(route, true);
	
	    RouteHooks[routeID] = hook;
	
	    if (thereWereNoRouteHooks) {
	      // setup transition & beforeunload hooks
	      unlistenBefore = history.listenBefore(transitionHook);
	
	      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	    }
	
	    return function () {
	      removeListenBeforeHooksForRoute(route);
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    function historyListener(location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    }
	
	    // TODO: Only use a single history listener. Otherwise we'll end up with
	    // multiple concurrent calls to match.
	
	    // Set up the history listener first in case the initial match redirects.
	    var unsubscribe = history.listen(historyListener);
	
	    if (state.location) {
	      // Picking up on a matchContext.
	      listener(null, state);
	    } else {
	      historyListener(history.getCurrentLocation());
	    }
	
	    return unsubscribe;
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.RouterContext = exports.createRoutes = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(148);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes = __webpack_require__(521);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(219);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(2064);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(1002);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(2060);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(2075);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(2061);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(2062);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(1004);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(2063);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _RouterContext2 = __webpack_require__(522);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _match2 = __webpack_require__(2073);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(1010);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(2066);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(2067);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(2071);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(1006);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* utils */
	
	exports.RouterContext = _RouterContext3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(1013);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(1012);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.readState = exports.saveState = undefined;
	
	var _warning = __webpack_require__(132);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuotaExceededErrors = {
	  QuotaExceededError: true,
	  QUOTA_EXCEEDED_ERR: true
	};
	
	var SecurityErrors = {
	  SecurityError: true
	};
	
	var KeyPrefix = '@@History/';
	
	var createKey = function createKey(key) {
	  return KeyPrefix + key;
	};
	
	var saveState = exports.saveState = function saveState(key, state) {
	  if (!window.sessionStorage) {
	    // Session storage is not available or hidden.
	    // sessionStorage is undefined in Internet Explorer when served via file protocol.
	     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;
	
	    return;
	  }
	
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;
	
	      return;
	    }
	
	    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;
	
	      return;
	    }
	
	    throw error;
	  }
	};
	
	var readState = exports.readState = function readState(key) {
	  var json = void 0;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;
	
	      return undefined;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return undefined;
	};

/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _runTransitionHook = __webpack_require__(526);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(149);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useBasename = function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var basename = options.basename;
	
	
	    var addBasename = function addBasename(location) {
	      if (!location) return location;
	
	      if (basename && location.basename == null) {
	        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    };
	
	    var prependBasename = function prependBasename(location) {
	      if (!basename) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var pname = object.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, object, {
	        pathname: pathname
	      });
	    };
	
	    // Override all read methods with basename-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return addBasename(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(addBasename(location));
	      });
	    };
	
	    // Override all write methods with basename-aware versions.
	    var push = function push(location) {
	      return history.push(prependBasename(location));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(prependBasename(location));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(prependBasename(location));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(prependBasename(location));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useBasename;

/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _queryString = __webpack_require__(2082);
	
	var _runTransitionHook = __webpack_require__(526);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _LocationUtils = __webpack_require__(221);
	
	var _PathUtils = __webpack_require__(149);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStringifyQuery = function defaultStringifyQuery(query) {
	  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
	};
	
	var defaultParseQueryString = _queryString.parse;
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	var useQueries = function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var stringifyQuery = options.stringifyQuery,
	        parseQueryString = options.parseQueryString;
	
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    var decodeQuery = function decodeQuery(location) {
	      if (!location) return location;
	
	      if (location.query == null) location.query = parseQueryString(location.search.substring(1));
	
	      return location;
	    };
	
	    var encodeQuery = function encodeQuery(location, query) {
	      if (query == null) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var queryString = stringifyQuery(query);
	      var search = queryString ? '?' + queryString : '';
	
	      return _extends({}, object, {
	        search: search
	      });
	    };
	
	    // Override all read methods with query-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return decodeQuery(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(decodeQuery(location));
	      });
	    };
	
	    // Override all write methods with query-aware versions.
	    var push = function push(location) {
	      return history.push(encodeQuery(location, location.query));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(encodeQuery(location, location.query));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(encodeQuery(location, location.query));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(encodeQuery(location, location.query));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));
	
	      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);
	
	      return decodeQuery(newLocation);
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useQueries;

/***/ },
/* 1014 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
				RECEIVE_THEMES: 'RECEIVE_THEMES',
				SELECTED_THEMES: 'SELECTED_THEMES',
				SELECTED_FILTERS: 'SELECTED_FILTERS',
				ENTRY_FILTER: 'ENTRY_FILTER',
				RESET_SELECTED_THEMES: 'RESET_SELECTED_THEMES',
				RESET_SELECTED_FILTERS: 'RESET_SELECTED_FILTERS',
				RESET_ENTRY_FILTER: 'RESET_ENTRY_FILTER',
				RESET_ADMINISTRATION_STORE: 'RESET_ADMINISTRATION_STORE',
				RECEIVE_ALL_SOURCES: 'RECEIVE_ALL_SOURCES',
				RECEIVE_DATA_TYPE_STATISTICS: 'RECEIVE_DATA_TYPE_STATISTICS',
				RECEIVE_LEGENDS: 'RECEIVE_LEGENDS',
				ADD_LEGEND: 'ADD_LEGEND',
				REMOVE_LEGEND: 'REMOVE_LEGEND',
				READ_NEWS: 'READ_NEWS',
				RECEIVE_NEWS: 'RECEIVE_NEWS'
	};

/***/ },
/* 1015 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DtoDataTypeStatistics = function DtoDataTypeStatistics(obj) {
		_classCallCheck(this, DtoDataTypeStatistics);
	
		this.typeParameter = obj.sitetypeparameter;
		this.nbSites = obj.nbsites;
	};
	
	exports.default = DtoDataTypeStatistics;

/***/ },
/* 1016 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.link = obj.link;
		this.title = obj.title;
		this.content = obj.content;
		this.status = obj.status;
		this.date = obj.date;
	};
	
	exports.default = _class;

/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _IAction2 = __webpack_require__(1018);
	
	var _IAction3 = _interopRequireDefault(_IAction2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Action = function (_IAction) {
		_inherits(Action, _IAction);
	
		function Action() {
			_classCallCheck(this, Action);
	
			return _possibleConstructorReturn(this, (Action.__proto__ || Object.getPrototypeOf(Action)).apply(this, arguments));
		}
	
		_createClass(Action, [{
			key: 'fn',
			value: function fn() {
				return this.props.onClick;
			}
		}, {
			key: 'icon',
			value: function icon() {
				return this.props.icon;
			}
		}, {
			key: 'title',
			value: function title() {
				return this.props.notifs;
			}
		}, {
			key: 'title',
			value: function title() {
				return this.props.title;
			}
		}, {
			key: 'component',
			value: function component() {
				return this.props.component;
			}
		}]);
	
		return Action;
	}(_IAction3.default);
	
	Action.propTypes = {
		onClick: _propTypes2.default.func.isRequired,
		notifs: _propTypes2.default.number,
		icon: _propTypes2.default.string,
		title: _propTypes2.default.string,
		component: _propTypes2.default.element
	};
	
	exports.default = Action;

/***/ },
/* 1018 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Tooltip = __webpack_require__(240);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IAction = function (_Component) {
		_inherits(IAction, _Component);
	
		function IAction() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, IAction);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = IAction.__proto__ || Object.getPrototypeOf(IAction)).call.apply(_ref, [this].concat(args))), _this), _this.getNotifs = function () {
				return _this.notifs ? _this.notifs() : null;
			}, _this.getDropDown = function () {
				return _this.dropdown ? _this.dropdown() : null;
			}, _this.getComponent = function () {
				return _this.component ? _this.component() : null;
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(IAction, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var content = function () {
					if (_this2.getComponent()) {
						return _this2.getComponent();
					}
					var dropdown = _this2.getDropDown();
					var classes = 'right waves-effect nav-actions blue-arrow ' + (dropdown ? 'dropdown-button' : '');
					return _react2.default.createElement(
						'div',
						{ className: 'action-wrapper' },
						_react2.default.createElement(
							_Tooltip2.default,
							{ title: _this2.title(), 'aria-label': _this2.title() },
							_react2.default.createElement(
								'a',
								{ className: classes, onClick: _this2.fn() },
								_react2.default.createElement(
									'i',
									{ className: 'material-icons left no-margin font-size-30' },
									_this2.icon()
								),
								_this2.getNotifs()
							)
						),
						dropdown
					);
				}();
				return _react2.default.createElement(
					'div',
					null,
					content
				);
			}
		}]);
	
		return IAction;
	}(_react.Component);
	
	exports.default = IAction;

/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCookieConsent = __webpack_require__(989);
	
	var _reactCookieConsent2 = _interopRequireDefault(_reactCookieConsent);
	
	var _core = __webpack_require__(116);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _CookieConstants = __webpack_require__(1058);
	
	var _CookieUtils = __webpack_require__(545);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CookiePanel = function (_Component) {
		_inherits(CookiePanel, _Component);
	
		function CookiePanel(props) {
			_classCallCheck(this, CookiePanel);
	
			var _this = _possibleConstructorReturn(this, (CookiePanel.__proto__ || Object.getPrototypeOf(CookiePanel)).call(this, props));
	
			_this.handleModal = function () {
				var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
				_this.setState({ open: value });
			};
	
			_this.changeState = function (cookieId) {
				var actualState = Object.assign({}, _this.state);
				actualState[cookieId] = !actualState[cookieId];
				_this.setState(actualState);
			};
	
			_this.validateCookies = function () {
				(0, _CookieUtils.createCookie)(_CookieConstants.AQUADB_COOKIE, {
					advertisingCookies: _this.state.advertisingCookies,
					statisticsCookies: _this.state.statisticsCookies
				});
				_this.setState({ open: false });
			};
	
			_this.getPanelAcceptCookie = function (title, text, cookieStateName) {
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin' },
					_react2.default.createElement(
						'div',
						{ className: 'col s12 ' },
						_react2.default.createElement(
							'div',
							{ className: 'row no-margin' },
							_react2.default.createElement(
								'div',
								{ className: 'col s11 no-padding' },
								_react2.default.createElement(
									'span',
									{ className: 'bold', style: { fontSize: '20px', fontWeight: 'bolder' } },
									title
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'col s1 no-padding' },
								_react2.default.createElement(_core.Toggle, {
									defaultToggled: _this.state[cookieStateName],
									onToggle: function onToggle() {
										return _this.changeState(cookieStateName);
									}
								})
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'col s12 ' },
						_react2.default.createElement(
							'span',
							null,
							text
						)
					)
				);
			};
	
			_this.state = {
				open: false,
				statisticsCookies: true,
				advertisingCookies: true
			};
			return _this;
		}
	
		_createClass(CookiePanel, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				(0, _CookieUtils.initCookieOption)();
				if ((0, _CookieUtils.checkCookies)()) {
					var actions = [_react2.default.createElement(_core.FlatButton, {
						label: _simpleReactI18n2.default.cancel,
						primary: true,
						onClick: function onClick() {
							return _this2.handleModal();
						}
					}), _react2.default.createElement(_core.FlatButton, {
						label: _simpleReactI18n2.default.validate,
						primary: true,
						onClick: function onClick() {
							return _this2.validateCookies();
						}
					})];
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							_reactCookieConsent2.default,
							{
								debug: true,
								location: 'bottom',
								buttonText: _simpleReactI18n2.default.accepted,
								cookieName: _CookieConstants.AQUADB_COOKIE,
								containerClasses: 'no-margin no-padding',
								style: { background: '#2B373B' },
								buttonStyle: {
									height: '36px',
									borderRadius: '2px',
									transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
									top: '0px'
								},
								onAccept: function onAccept() {
									return _this2.validateCookies();
								}
							},
							_simpleReactI18n2.default.cookie.description,
							_react2.default.createElement('br', null),
							_react2.default.createElement(
								'a',
								{ onClick: function onClick() {
										return _this2.handleModal(true);
									} },
								_simpleReactI18n2.default.cookie.more
							)
						),
						_react2.default.createElement(
							_core.Dialog,
							{
								actions: actions,
								modal: true,
								open: this.state.open
							},
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col s12' },
									_react2.default.createElement(
										'div',
										{ className: 'row center-align' },
										_react2.default.createElement(
											'h5',
											null,
											_simpleReactI18n2.default.cookie.moreTitle
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'row' },
										_react2.default.createElement(
											'div',
											{ className: 'col s6' },
											this.getPanelAcceptCookie(_simpleReactI18n2.default.cookie.communication, _simpleReactI18n2.default.cookie.communicationComment, 'advertisingCookies')
										),
										_react2.default.createElement(
											'div',
											{ className: 'col s6' },
											this.getPanelAcceptCookie(_simpleReactI18n2.default.cookie.statistics, _simpleReactI18n2.default.cookie.statisticsComment, 'statisticsCookies')
										)
									)
								)
							)
						)
					);
				}
				return null;
			}
		}]);
	
		return CookiePanel;
	}(_react.Component);
	
	exports.default = CookiePanel;

/***/ },
/* 1020 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LinearProgress = __webpack_require__(302);
	
	var _LinearProgress2 = _interopRequireDefault(_LinearProgress);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoadingPanel = function (_Component) {
		_inherits(LoadingPanel, _Component);
	
		function LoadingPanel(props) {
			_classCallCheck(this, LoadingPanel);
	
			return _possibleConstructorReturn(this, (LoadingPanel.__proto__ || Object.getPrototypeOf(LoadingPanel)).call(this, props));
		}
	
		_createClass(LoadingPanel, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin' },
					_react2.default.createElement(
						'div',
						{ className: 'col s12 no-padding center' },
						_react2.default.createElement(
							'div',
							{ className: 'white-filter-fill' },
							_react2.default.createElement(
								'h4',
								null,
								_react2.default.createElement(
									'span',
									null,
									this.props.title
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'white-filter', style: { padding: '20px 0 30px 0' } },
							_react2.default.createElement(_LinearProgress2.default, { className: 'white-filter', mode: 'indeterminate', style: { height: '10px' } })
						)
					)
				);
			}
		}]);
	
		return LoadingPanel;
	}(_react.Component);
	
	LoadingPanel.propTypes = {
		title: _propTypes2.default.string.isRequired
	};
	
	LoadingPanel.defaultProps = {
		title: ''
	};
	
	exports.default = LoadingPanel;

/***/ },
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _DtoSelectionRow = __webpack_require__(182);
	
	var _DtoSelectionRow2 = _interopRequireDefault(_DtoSelectionRow);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _SelectionAction = __webpack_require__(95);
	
	var _SelectionAction2 = _interopRequireDefault(_SelectionAction);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _DtoUserCredit = __webpack_require__(284);
	
	var _DtoUserCredit2 = _interopRequireDefault(_DtoUserCredit);
	
	var _DtoUser = __webpack_require__(54);
	
	var _DtoUser2 = _interopRequireDefault(_DtoUser);
	
	var _reactRouterRedux = __webpack_require__(43);
	
	var _HomeConstants = __webpack_require__(53);
	
	var _Chip = __webpack_require__(234);
	
	var _Chip2 = _interopRequireDefault(_Chip);
	
	var _Dialog = __webpack_require__(190);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _DialogTitle = __webpack_require__(235);
	
	var _DialogTitle2 = _interopRequireDefault(_DialogTitle);
	
	var _DialogActions = __webpack_require__(297);
	
	var _DialogActions2 = _interopRequireDefault(_DialogActions);
	
	var _Button = __webpack_require__(233);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Slide = __webpack_require__(155);
	
	var _Slide2 = _interopRequireDefault(_Slide);
	
	var _glamor = __webpack_require__(143);
	
	var _ToastrAction = __webpack_require__(66);
	
	var _ToastrAction2 = _interopRequireDefault(_ToastrAction);
	
	var _FormControlLabel = __webpack_require__(583);
	
	var _FormControlLabel2 = _interopRequireDefault(_FormControlLabel);
	
	var _Checkbox = __webpack_require__(394);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _lodash = __webpack_require__(15);
	
	var _SelectionConstants = __webpack_require__(529);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Transition = _react2.default.forwardRef(function Transition(props, ref) {
		return _react2.default.createElement(_Slide2.default, Object.assign({ direction: 'up', ref: ref }, props));
	});
	
	var SelectionExportModal = function (_Component) {
		_inherits(SelectionExportModal, _Component);
	
		function SelectionExportModal(props) {
			_classCallCheck(this, SelectionExportModal);
	
			var _this = _possibleConstructorReturn(this, (SelectionExportModal.__proto__ || Object.getPrototypeOf(SelectionExportModal)).call(this, props));
	
			_this.handleClose = function () {
				_AppStore2.default.dispatch(_SelectionAction2.default.closeModalSelectionExport());
			};
	
			_this.pushTo = function () {
				_AppStore2.default.dispatch((0, _reactRouterRedux.push)(_HomeConstants.PATH_ADMINISTRATION_CREDIT));
			};
	
			_this.export = function () {
				if (!_this.props.user.email) {
					_AppStore2.default.dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.warning.pleaseMailInform));
				} else {
					_AppStore2.default.dispatch(_SelectionAction2.default.exportSelection(_this.props.user.login, _this.props.selectedSelectionInformation.id, _this.state.selectedOptions));
				}
			};
	
			_this.getAvailable = function () {
				if (_this.props.selectedSelectionInformation.selectionWatershed && _this.props.selectedSelectionInformation.selectionWatershed.length) {
					var totalCredit = _this.props.selectedSelectionInformation.themes.length * _this.props.selectedSelectionInformation.selectionWatershed.length;
					return function () {
						if (_this.props.userCredit && _this.props.userCredit.credit) {
							return _this.props.userCredit.credit > totalCredit;
						}
						return false;
					}();
				}
				return false;
			};
	
			_this.getCreditAfterExport = function () {
				var totalCredit = _this.props.selectedSelectionInformation.themes.length * _this.props.selectedSelectionInformation.selectionWatershed.length;
				return _this.props.userCredit.credit - totalCredit;
			};
	
			_this.getCreditMessage = function (isAvailable) {
				if (!isAvailable) {
					return _react2.default.createElement(
						_Chip2.default,
						null,
						_simpleReactI18n2.default.insufficientCreditExport
					);
				}
				var finalCreditAfterExport = _this.getCreditAfterExport();
				return _react2.default.createElement(
					'span',
					null,
					_simpleReactI18n2.default.information.finalCreditAfterExport,
					' : ',
					finalCreditAfterExport,
					' '
				);
			};
	
			_this.getDialogAction = function () {
				if (_this.props.selectedSelectionInformation && _this.props.modalSelectionExport) {
					var isAvailable = _this.getAvailable();
					var isDisabled = function () {
						return !_this.state.selectedOptions.filter(function (o) {
							return o === _SelectionConstants.SITE_DESCRIPTION_EXPORT_OPTION || o === _SelectionConstants.SITE_DATA_EXPORT_OPTION;
						}).length > 0;
					}();
					var backgroundColor = function () {
						if (isDisabled) {
							return '#BDBDBD !important';
						}
						return '#53A1FF !important';
					}();
					var validateFunction = function () {
						if (isAvailable) {
							return _react2.default.createElement(
								_Button2.default,
								Object.assign({ onClick: _this.export }, (0, _glamor.css)({ backgroundColor: backgroundColor, color: 'white !important' }), { autoFocus: true, disabled: isDisabled }),
								_simpleReactI18n2.default.validate
							);
						}
						return _react2.default.createElement(
							_Button2.default,
							Object.assign({ onClick: _this.pushTo }, (0, _glamor.css)({ backgroundColor: backgroundColor, color: 'white !important' }), { autoFocus: true, disabled: isDisabled }),
							_simpleReactI18n2.default.recharge
						);
					}();
					return _react2.default.createElement(
						_DialogActions2.default,
						null,
						_react2.default.createElement(
							_Button2.default,
							Object.assign({ onClick: _this.handleClose }, (0, _glamor.css)({ backgroundColor: 'red !important', color: 'white !important' })),
							_simpleReactI18n2.default.cancel
						),
						validateFunction
					);
				}
				return null;
			};
	
			_this.getContent = function () {
				if (_this.props.selectedSelectionInformation && _this.props.modalSelectionExport) {
					var siteClassName = function () {
						if ((0, _lodash.find)(_this.state.selectedOptions, function (o) {
							return o === _SelectionConstants.SITE_DESCRIPTION_EXPORT_OPTION;
						})) {
							return 'col s12 no-padding checkbox-selected';
						}
						return 'col s12 no-padding';
					}();
					var dataClassName = function () {
						if ((0, _lodash.find)(_this.state.selectedOptions, function (o) {
							return o === _SelectionConstants.SITE_DATA_EXPORT_OPTION;
						})) {
							return 'col s12 no-padding checkbox-selected';
						}
						return 'col s12 no-padding';
					}();
					return _react2.default.createElement(
						'div',
						{ className: 'row export-modal' },
						_simpleReactI18n2.default.question.exportSelection,
						_react2.default.createElement(
							'div',
							{ className: siteClassName },
							_this.getCheckBoxExportOptions('Description des sites', _SelectionConstants.SITE_DESCRIPTION_EXPORT_OPTION)
						),
						_react2.default.createElement(
							'div',
							{ className: dataClassName },
							_this.getCheckBoxExportOptions('Données des sites', _SelectionConstants.SITE_DATA_EXPORT_OPTION)
						)
					);
				}
				return null;
			};
	
			_this.getTitle = function () {
				if (_this.props.selectedSelectionInformation && _this.props.modalSelectionExport) {
					return _react2.default.createElement(
						_DialogTitle2.default,
						{ id: 'alert-dialog-slide-title', className: 'export-modal-title' },
						_simpleReactI18n2.default.exportSelection,
						' : ',
						_react2.default.createElement(
							'span',
							null,
							_this.props.selectedSelectionInformation.title
						)
					);
				}
				return null;
			};
	
			_this.changeSelectedOption = function (parameter) {
				var tmpValue = function () {
					var tmp = [].concat(_toConsumableArray(_this.state.selectedOptions));
					if ((0, _lodash.find)(tmp, function (o) {
						return o === parameter;
					})) {
						return tmp.filter(function (o) {
							return o !== parameter;
						});
					}
					return tmp.concat([parameter]);
				}();
				_this.setState({
					selectedOptions: tmpValue
				});
			};
	
			_this.getCheckBoxExportOptions = function (title, parameter) {
				var isSelected = (0, _lodash.find)(_this.state.selectedOptions, function (o) {
					return o === parameter;
				});
				return _react2.default.createElement(_FormControlLabel2.default, {
					control: _react2.default.createElement(_Checkbox2.default, {
						checked: isSelected,
						onChange: function onChange() {
							return _this.changeSelectedOption(parameter);
						},
						value: parameter,
						color: 'primary'
					}),
					label: title
				});
			};
	
			_this.state = {
				selectedOptions: [_SelectionConstants.SITE_DESCRIPTION_EXPORT_OPTION, _SelectionConstants.SITE_DATA_EXPORT_OPTION]
			};
			return _this;
		}
	
		_createClass(SelectionExportModal, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_Dialog2.default,
					{
						maxWidth: 'sm',
						fullWidth: true,
						TransitionComponent: Transition,
						modal: false,
						keepMounted: true,
						open: this.props.modalSelectionExport,
						onClose: this.handleClose
					},
					this.getTitle(),
					this.getContent(),
					this.getDialogAction()
				);
			}
		}]);
	
		return SelectionExportModal;
	}(_react.Component);
	
	SelectionExportModal.propTypes = {
		selectedSelectionInformation: _propTypes2.default.instanceOf(_DtoSelectionRow2.default),
		modalSelectionExport: _propTypes2.default.bool,
		user: _propTypes2.default.objectOf(_DtoUser2.default),
		userCredit: _propTypes2.default.objectOf(_DtoUserCredit2.default)
	};
	var mapStateToProps = function mapStateToProps(store) {
		return {
			selectedSelectionInformation: store.SelectionReducer.selectedSelectionInformation,
			modalSelectionExport: store.SelectionReducer.modalSelectionExport,
			user: store.HomeReducer.user,
			userCredit: store.CreditReducer.userCredit
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(SelectionExportModal);

/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _uuid = __webpack_require__(44);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _reactRouterRedux = __webpack_require__(43);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CheckPanel = function (_Component) {
		_inherits(CheckPanel, _Component);
	
		function CheckPanel(props) {
			_classCallCheck(this, CheckPanel);
	
			var _this = _possibleConstructorReturn(this, (CheckPanel.__proto__ || Object.getPrototypeOf(CheckPanel)).call(this, props));
	
			_this.toggleCheck = _this.toggleCheck.bind(_this);
			_this.onClick = _this.onClick.bind(_this);
			return _this;
		}
	
		_createClass(CheckPanel, [{
			key: 'toggleCheck',
			value: function toggleCheck() {
				this.props.onToggleCheck();
			}
		}, {
			key: 'onClick',
			value: function onClick() {
				if (this.props.link) {
					_AppStore2.default.dispatch((0, _reactRouterRedux.push)('/' + this.props.link));
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var id = _uuid2.default.v4();
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin componentListItem clickable ' + this.props.className,
						style: { backgroundColor: this.props.backgroundColor } },
					_react2.default.createElement(
						'div',
						{ className: 'col s12' },
						_react2.default.createElement(
							'div',
							{ className: 'row no-margin valign-wrapper inline-flex' },
							_react2.default.createElement(
								'div',
								{ className: 'no-padding col s11', onClick: this.onClick },
								this.props.children
							),
							_react2.default.createElement(
								'div',
								{ className: 'no-padding col s1 right-align float-right"' },
								_react2.default.createElement('input', { checked: this.props.checked, className: 'filled-in', onChange: this.toggleCheck,
									type: 'checkbox', id: id }),
								_react2.default.createElement('label', { htmlFor: id })
							)
						)
					)
				);
			}
		}]);
	
		return CheckPanel;
	}(_react.Component);
	
	CheckPanel.propTypes = {
		onToggleCheck: _propTypes2.default.func.required,
		children: _propTypes2.default.element,
		checked: _propTypes2.default.bool,
		link: _propTypes2.default.string,
		backgroundColor: _propTypes2.default.string,
		onHover: _propTypes2.default.bool,
		className: _propTypes2.default.string
	};
	
	CheckPanel.defaultProps = {
		onToggleCheck: function onToggleCheck() {},
		children: '',
		checked: true,
		link: '',
		backgroundColor: 'white'
	};
	
	exports.default = CheckPanel;

/***/ },
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _IndicatorTile = __webpack_require__(2118);
	
	var _IndicatorTile2 = _interopRequireDefault(_IndicatorTile);
	
	var _uuid = __webpack_require__(44);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndicatorPanel = function (_Component) {
		_inherits(IndicatorPanel, _Component);
	
		function IndicatorPanel() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, IndicatorPanel);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = IndicatorPanel.__proto__ || Object.getPrototypeOf(IndicatorPanel)).call.apply(_ref, [this].concat(args))), _this), _this.getIndicators = function () {
				return _this.props.datas.map(function (data) {
					return _react2.default.createElement(_IndicatorTile2.default, { key: _uuid2.default.v4(),
						title: data.title,
						titlePosition: data.titlePosition,
						number: data.number,
						text: data.text
					});
				});
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(IndicatorPanel, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ key: _uuid2.default.v4(), className: 'row no-margin' },
					_react2.default.createElement(
						'div',
						{ className: 'col s12 no-padding' },
						this.getIndicators()
					)
				);
			}
		}]);
	
		return IndicatorPanel;
	}(_react.Component);
	
	IndicatorPanel.propTypes = {
		datas: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			title: _propTypes2.default.string.isRequired,
			titlePosition: _propTypes2.default.string,
			size: _propTypes2.default.number.isRequired,
			number: _propTypes2.default.number,
			text: _propTypes2.default.string
		}))
	};
	
	IndicatorPanel.defaultProps = {
		datas: []
	};
	
	exports.default = IndicatorPanel;

/***/ },
/* 1024 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
		RECEIVE_PIEZOMETER: 'RECEIVE_PIEZOMETER',
		RECEIVE_QUALITOMETER: 'RECEIVE_QUALITOMETER',
		RECEIVE_SURFACE_QUALITOMETER: 'RECEIVE_SURFACE_QUALITOMETER',
		RECEIVE_POLLUTED_SOIL: 'RECEIVE_POLLUTED_SOIL',
		RECEIVE_INDUSTRIAL_SITE: 'RECEIVE_INDUSTRIAL_SITE',
		ADD_PIEZOMETER_MEASURE: 'ADD_PIEZOMETER_MEASURE',
		ADD_PICKUP_OPERATION: 'ADD_PICKUP_OPERATION',
		ADD_QUALITOMETER_ANALYSIS: 'ADD_QUALITOMETER_ANALYSIS',
		ADD_CITIES: 'ADD_CITIES',
		ADD_PIEZOMETER_KEY_FIGURE: 'ADD_PIEZOMETER_KEY_FIGURE',
		ADD_QUALITOMETER_KEY_FIGURE: 'ADD_QUALITOMETER_KEY_FIGURE',
		RESET_USER_STATION: 'RESET_USER_STATION'
	};

/***/ },
/* 1025 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.date = obj.date;
		this.measure = obj.measure;
		this.piezometerId = obj.idpiezometer;
	};
	
	exports.default = _class;

/***/ },
/* 1026 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.filterId = obj.filter_id;
		this.selectionId = obj.selection_id;
	};
	
	exports.default = _class;

/***/ },
/* 1027 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.selectionId = obj.selection_id;
		this.siteId = obj.site_id;
	};
	
	exports.default = _class;

/***/ },
/* 1028 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.selectionId = obj.selectionid;
		this.watershedId = obj.watershedid;
	};
	
	exports.default = _class;

/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _isomorphicFetch = __webpack_require__(78);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _ApplicationConf = __webpack_require__(65);
	
	var _ApplicationConf2 = _interopRequireDefault(_ApplicationConf);
	
	var _reactAquasys = __webpack_require__(49);
	
	var _findPasswordConstants = __webpack_require__(2133);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var findPasswordAction = {
		findemail: function findemail(resultData) {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.user.checkEmailExist(), {
					method: 'POST',
					headers: {
						Accept: 'application/json'
					},
					body: JSON.stringify({
						licence: 'AQUADB_FRONTEND_BETA',
						data: resultData
					})
				}).then(function (response) {
					switch (response.status) {
						case 200:
							return response.json();
						case 400:
							return {
								error: _simpleReactI18n2.default.error.thanksContactSupport
							};
						case 403:
							return {
								error: _simpleReactI18n2.default.error.notRegister
							};
						case 404:
							return {
								error: _simpleReactI18n2.default.error.notRegister
							};
						default:
							return undefined;
					}
				}).then(function (json) {
					if (json) {
						dispatch(findPasswordAction.addMessage(_simpleReactI18n2.default.findEmailSuccess));
					}
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
		addMessage: function addMessage(value) {
			return {
				type: _findPasswordConstants.ADD_MESSAGE,
				message: value
			};
		},
		setError: function setError() {
			return {
				type: _findPasswordConstants.ERROR
			};
		},
		resetMessage: function resetMessage() {
			return {
				type: _findPasswordConstants.RESET_MESSAGE
			};
		}
	};
	exports.default = findPasswordAction;

/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _InformationConstants = __webpack_require__(1032);
	
	var InformationAction = {
		message: function message(_message) {
			return {
				type: _InformationConstants.MESSAGE,
				message: _message
			};
		},
		reset: function reset() {
			return {
				type: _InformationConstants.RESET_INFORMATION
			};
		}
	};
	
	exports.default = InformationAction;

/***/ },
/* 1031 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
		RECEIVE_USER_CREDIT: 'RECEIVE_USER_CREDIT',
		RECEIVE_USER_CREDIT_HISTORY: 'RECEIVE_USER_CREDIT_HISTORY',
		RECEIVE_ALL_CREDIT_TYPE: 'RECEIVE_ALL_CREDIT_TYPE',
		RESET_CREDITS_INFORMATION: 'RESET_CREDITS_INFORMATION'
	};

/***/ },
/* 1032 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
		MESSAGE: 'MESSAGE',
		RESET_INFORMATION: 'RESET_INFORMATION'
	};

/***/ },
/* 1033 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.creditId = obj.creditid;
		this.credit = obj.credit;
		this.creditTypeId = obj.credittypeid;
		this.selectionId = obj.selectionid;
		this.date = obj.date;
	};
	
	exports.default = _class;

/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _isomorphicFetch = __webpack_require__(78);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _ApplicationConf = __webpack_require__(65);
	
	var _ApplicationConf2 = _interopRequireDefault(_ApplicationConf);
	
	var _reactAquasys = __webpack_require__(49);
	
	var _SignInAction = __webpack_require__(534);
	
	var _SignInAction2 = _interopRequireDefault(_SignInAction);
	
	var _InitPasswordConstants = __webpack_require__(1035);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _SitesAction = __webpack_require__(97);
	
	var _SitesAction2 = _interopRequireDefault(_SitesAction);
	
	var _reactRouterRedux = __webpack_require__(43);
	
	var _HomeConstants = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InitPasswordAction = {
		initPassword: function initPassword(resultData) {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.user.checkUserExist(), {
					method: 'POST',
					headers: {
						Accept: 'application/json'
					},
					body: JSON.stringify({
						licence: 'AQUADB_FRONTEND_BETA',
						data: resultData
					})
				}).then(function (response) {
					switch (response.status) {
						case 200:
							return response.json();
						case 400:
							return {
								error: _simpleReactI18n2.default.error.thanksContactSupport
							};
						case 403:
							return {
								error: _simpleReactI18n2.default.error.notAllowToConnect
							};
						case 404:
							return {
								error: _simpleReactI18n2.default.error.notRegister
							};
						default:
							return undefined;
					}
				}).then(function (json) {
					if (json) {
						if (!json.error) {
							dispatch(_SignInAction2.default.login(resultData.login, resultData.password));
							_AppStore2.default.dispatch(_SitesAction2.default.reset());
							_AppStore2.default.dispatch((0, _reactRouterRedux.push)(_HomeConstants.PATH_MAIN));
						} else {
							dispatch(InitPasswordAction.addMessage(json.error));
							dispatch(InitPasswordAction.setError());
						}
					}
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
		addMessage: function addMessage(value) {
			return {
				type: _InitPasswordConstants.ADD_MESSAGE,
				message: value
			};
		},
		setError: function setError() {
			return {
				type: _InitPasswordConstants.ERROR
			};
		},
		resetMessage: function resetMessage() {
			return {
				type: _InitPasswordConstants.RESET_MESSAGE
			};
		}
	};
	exports.default = InitPasswordAction;

/***/ },
/* 1035 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
		ADD_MESSAGE: 'ADD_MESSAGE',
		RESET_MESSAGE: 'RESET_MESSAGE',
		ERROR: 'ERROR'
	};

/***/ },
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _SignInAction = __webpack_require__(534);
	
	var _SignInAction2 = _interopRequireDefault(_SignInAction);
	
	var _ToastrAction = __webpack_require__(66);
	
	var _ToastrAction2 = _interopRequireDefault(_ToastrAction);
	
	var _HomeConstants = __webpack_require__(53);
	
	var _reactRouterRedux = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SignIn = function (_Component) {
		_inherits(SignIn, _Component);
	
		function SignIn() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, SignIn);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SignIn.__proto__ || Object.getPrototypeOf(SignIn)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (event) {
				event.preventDefault();
				var pwd = _this.refs.password.value;
				var login = _this.refs.login.value;
				if (!pwd) {
					_AppStore2.default.dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.error.password));
				}
				if (!login) {
					_AppStore2.default.dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.error.login));
				}
				if (pwd && login) {
					_AppStore2.default.dispatch(_SignInAction2.default.login(login, pwd, _this.props.actions));
				}
			}, _this.goFindEmail = function () {
				_AppStore2.default.dispatch((0, _reactRouterRedux.push)(_HomeConstants.PATH_FIND_EMAIL));
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(SignIn, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'no-margin radius10' },
					_react2.default.createElement(
						'div',
						{ className: 'card-content no-padding row no-margin cardLogin' },
						_react2.default.createElement(
							'form',
							{ onSubmit: this.onSubmit },
							_react2.default.createElement(
								'div',
								{ className: 'row no-margin' },
								_react2.default.createElement(
									'div',
									{ className: 'col l12 m10 s10 padding-top-20' },
									_react2.default.createElement(
										'label',
										{ htmlFor: 'login', className: 'valign-wrapper black-text' },
										_react2.default.createElement(
											'i',
											{ className: 'material-icons' },
											'person'
										),
										_simpleReactI18n2.default.login
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col l12 m10 s10' },
									_react2.default.createElement('input', { ref: 'login', id: 'login', type: 'text', className: 'validate' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'col l12 m10 s10 padding-top-20' },
									_react2.default.createElement(
										'label',
										{ htmlFor: 'password', className: 'valign-wrapper black-text' },
										_react2.default.createElement(
											'i',
											{ className: 'material-icons' },
											'lock_outline'
										),
										_simpleReactI18n2.default.password
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col l12 m10 s10' },
									_react2.default.createElement('input', { ref: 'password', id: 'password', type: 'password', className: 'validate' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'col l12 m10 s10 offset-m1 offset-s1 padding-top-20' },
									_react2.default.createElement(
										'button',
										{ to: 'dashboard',
											className: 'waves-effect col l12 m12 s12 waves-light btn' },
										_simpleReactI18n2.default.signin
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col l12 m10 s10 offset-m1 offset-s1 center margin-top-10' },
									_react2.default.createElement(
										'a',
										{ href: 'https://www.aquasys.fr/aquadb/#aquadb-form',
											target: '_blank' },
										_react2.default.createElement(
											'span',
											null,
											_simpleReactI18n2.default.notYetRegistered
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col l12 m10 s10 offset-m1 offset-s1 center margin-top-10' },
									_react2.default.createElement(
										'a',
										{ onClick: function onClick() {
												return _this2.goFindEmail();
											} },
										_react2.default.createElement(
											'span',
											null,
											'Mot de passe oubli\xE9 ?'
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col s12 center-align' },
								_react2.default.createElement(
									'a',
									{ href: 'http://www.aquasys.fr', target: '_blank' },
									_react2.default.createElement('img', { src: 'https://www.aquasys.fr/wp-content/uploads/2017/10/AQUASYS-512-PX.jpg',
										alt: 'logo Aquasys', width: '70px', className: 'z-depth-1' })
								)
							)
						)
					)
				);
			}
		}]);
	
		return SignIn;
	}(_react.Component);
	
	SignIn.propTypes = {
		actions: _propTypes2.default.func
	};
	exports.default = SignIn;

/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NoInformationPanel = function (_Component) {
		_inherits(NoInformationPanel, _Component);
	
		function NoInformationPanel(props) {
			_classCallCheck(this, NoInformationPanel);
	
			return _possibleConstructorReturn(this, (NoInformationPanel.__proto__ || Object.getPrototypeOf(NoInformationPanel)).call(this, props));
		}
	
		_createClass(NoInformationPanel, [{
			key: 'render',
			value: function render() {
				if (this.props.title) {
					return _react2.default.createElement(
						'div',
						{ className: 'card-padding' },
						_react2.default.createElement(
							'div',
							{ className: 'card-title no-margin' },
							_react2.default.createElement(
								'h6',
								{ className: 'aquadb-title' },
								this.props.title
							)
						)
					);
				}
				return null;
			}
		}]);
	
		return NoInformationPanel;
	}(_react.Component);
	
	NoInformationPanel.propTypes = {
		title: _propTypes2.default.string.isRequired
	};
	NoInformationPanel.defaultProps = {
		title: 'Aucune information disponible'
	};
	exports.default = NoInformationPanel;

/***/ },
/* 1038 */
543,
/* 1039 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
		RECEIVE_ALL_UNITS: 'RECEIVE_CITIES',
		RECEIVE_ALL_REMARKS: 'RECEIVE_ALL_REMARKS',
		RECEIVE_ALL_SUPPORTS: 'RECEIVE_ALL_SUPPORTS',
		RECEIVE_ALL_STANDARD_CODIFICATION: 'RECEIVE_ALL_STANDARD_CODIFICATION',
		RECEIVE_ALL_PARAMETERS: 'RECEIVE_ALL_PARAMETERS',
		RECEIVE_ALL_CITIES: 'RECEIVE_ALL_CITIES',
		RECEIVE_ALL_DEPARTMENTS: 'RECEIVE_ALL_DEPARTMENTS',
		RECEIVE_ALL_FILTER_TYPES: 'RECEIVE_ALL_FILTER_TYPES',
		RECEIVE_ALL_SITE_TYPES: 'RECEIVE_ALL_SITE_TYPES',
		RECEIVE_ALL_WATERSHED: 'RECEIVE_ALL_WATERSHED',
		RECEIVE_ALL_STATIONS: 'RECEIVE_ALL_STATIONS',
		RECEIVE_ALL_SOURCES: 'RECEIVE_ALL_SOURCES',
		RECEIVE_ALL_INDICATOR_TYPES: 'RECEIVE_ALL_INDICATOR_TYPES',
		RECEIVE_ALL_INDICATORS: 'RECEIVE_ALL_INDICATORS',
		RECEIVE_ALL_MANAGEMENT_WATER: 'RECEIVE_ALL_MANAGEMENT_WATER',
		RESET_REFERENTIAL: 'RESET_REFERENTIAL'
	};

/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _AutoComplete = __webpack_require__(2097);
	
	var _AutoComplete2 = _interopRequireDefault(_AutoComplete);
	
	var _ChipsPanel = __webpack_require__(2099);
	
	var _ChipsPanel2 = _interopRequireDefault(_ChipsPanel);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _UserUtils = __webpack_require__(1057);
	
	var _DtoUserRole = __webpack_require__(378);
	
	var _DtoUserRole2 = _interopRequireDefault(_DtoUserRole);
	
	var _DtoUser = __webpack_require__(54);
	
	var _DtoUser2 = _interopRequireDefault(_DtoUser);
	
	var _SitesConstants = __webpack_require__(226);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResearchBarPanel = function (_Component) {
		_inherits(ResearchBarPanel, _Component);
	
		function ResearchBarPanel(props) {
			_classCallCheck(this, ResearchBarPanel);
	
			var _this = _possibleConstructorReturn(this, (ResearchBarPanel.__proto__ || Object.getPrototypeOf(ResearchBarPanel)).call(this, props));
	
			_this.getActionButtons = function () {
				if (_this.props.actions) {
					return _react2.default.createElement(
						'div',
						{ className: 'col s1 right-align no-padding' },
						_this.props.actions
					);
				}
				return _react2.default.createElement(
					'div',
					{ className: 'col s1 right-align no-padding' },
					_react2.default.createElement(
						'a',
						{ type: 'submit', name: 'action', onClick: function onClick() {
								return _this.props.researchClick();
							} },
						_react2.default.createElement(
							'i',
							{ className: 'material-icons black-text small-research-icon' },
							'search'
						)
					)
				);
			};
	
			_this.getRestrictPanel = function () {
				var color = function () {
					if (_this.props.page === _SitesConstants.MAP_RESEARCH) {
						return '#696969';
					}
					return 'white';
				}();
				return _react2.default.createElement(
					'div',
					{ className: 'col s12 no-padding' },
					_react2.default.createElement(
						'div',
						{ className: 'row no-margin' },
						_react2.default.createElement(
							'div',
							{ className: 'col s12 left-align no-padding', style: { backgroundColor: 'transparent !important' } },
							_react2.default.createElement(
								'div',
								{ className: 'row no-margin text-left', style: {
										color: color,
										borderBottom: '0',
										boxShadow: 'none',
										fontSize: '14px'
									} },
								_simpleReactI18n2.default.criteriaLimitBeta
							)
						)
					)
				);
			};
	
			_this.setRestrictPanel = function (isBeta) {
				if (!_this.props.isLogged) {
					if (!_this.props.selectedFilters.length) {
						return null;
					}
					return _this.getRestrictPanel();
				} else if (isBeta) {
					if (!_this.props.selectedFilters.length) {
						return null;
					}
					return _this.getRestrictPanel();
				}
				return null;
			};
	
			_this.getAutoComplete = function (isBeta) {
				if (!_this.props.isLogged) {
					if (!_this.props.selectedFilters.length) {
						return _react2.default.createElement(_AutoComplete2.default, { isResearchMap: _this.props.isResearchMap });
					}
					return null;
				} else if (isBeta) {
					if (!_this.props.selectedFilters.length) {
						return _react2.default.createElement(_AutoComplete2.default, { isResearchMap: _this.props.isResearchMap });
					}
					return null;
				}
				return _react2.default.createElement(_AutoComplete2.default, { isResearchMap: _this.props.isResearchMap });
			};
	
			return _this;
		}
	
		_createClass(ResearchBarPanel, [{
			key: 'render',
			value: function render() {
				var isBeta = (0, _UserUtils.checkBetaUser)(this.props.userRoles).length;
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin' },
					_react2.default.createElement(
						'div',
						{ className: 'col s12 no-padding search-panel ' },
						_react2.default.createElement(
							'div',
							{ className: 'row no-margin valign-wrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'col s12 left-align no-padding' },
								_react2.default.createElement(_ChipsPanel2.default, null),
								_react2.default.createElement(
									'div',
									{ className: 'row no-margin no-padding' },
									_react2.default.createElement(
										'div',
										{ className: 'col s11 no-padding no-margin' },
										this.getAutoComplete(isBeta)
									),
									this.getActionButtons()
								)
							)
						)
					),
					this.setRestrictPanel(isBeta)
				);
			}
		}]);
	
		return ResearchBarPanel;
	}(_react.Component);
	
	ResearchBarPanel.propTypes = {
		selectedFilters: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			label: _propTypes2.default.string,
			value: _propTypes2.default.object
		})),
		isLogged: _propTypes2.default.bool,
		isResearchMap: _propTypes2.default.bool,
		researchClick: _propTypes2.default.func,
		actions: _propTypes2.default.object,
		user: _propTypes2.default.instanceOf(_DtoUser2.default),
		userRoles: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoUserRole2.default)),
		page: _propTypes2.default.string
	};
	ResearchBarPanel.defaultProps = {
		isResearchMap: false,
		isLogged: false,
		page: _SitesConstants.MAP_RESEARCH
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			selectedFilters: store.AdministrationReducer.selectedFilters,
			selectedThemes: store.AdministrationReducer.selectedThemes,
			themes: store.AdministrationReducer.themes,
			filterTypes: store.ReferentialReducer.filterTypes,
			user: store.HomeReducer.user,
			userRoles: store.HomeReducer.userRoles
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ResearchBarPanel);

/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _isomorphicFetch = __webpack_require__(78);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _ApplicationConf = __webpack_require__(65);
	
	var _ApplicationConf2 = _interopRequireDefault(_ApplicationConf);
	
	var _reactAquasys = __webpack_require__(49);
	
	var _SignInAction = __webpack_require__(534);
	
	var _SignInAction2 = _interopRequireDefault(_SignInAction);
	
	var _resetPasswordConstants = __webpack_require__(2170);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var resetPasswordAction = {
		resetPassword: function resetPassword(resultData) {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.user.updatePassword(), {
					method: 'POST',
					headers: {
						Accept: 'application/json'
					},
					body: JSON.stringify({
						licence: 'AQUADB_FRONTEND_BETA',
						data: resultData
					})
				}).then(function (response) {
					switch (response.status) {
						case 200:
							return response.json();
						case 400:
							return {
								error: _simpleReactI18n2.default.error.thanksContactSupport
							};
						case 403:
							return {
								error: _simpleReactI18n2.default.error.notAllowToConnect
							};
						case 404:
							return {
								error: _simpleReactI18n2.default.error.notRegister
							};
						default:
							return undefined;
					}
				}).then(function (json) {
					if (json) {
						if (!json.error) {
							dispatch(_SignInAction2.default.login(resultData.login, resultData.password));
						} else {
							dispatch(resetPasswordAction.addMessage(json.error));
							dispatch(resetPasswordAction.setError());
						}
					}
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
		addMessage: function addMessage(value) {
			return {
				type: _resetPasswordConstants.ADD_MESSAGE,
				message: value
			};
		},
		setError: function setError() {
			return {
				type: _resetPasswordConstants.ERROR
			};
		},
		resetMessage: function resetMessage() {
			return {
				type: _resetPasswordConstants.RESET_MESSAGE
			};
		}
	};
	exports.default = resetPasswordAction;

/***/ },
/* 1042 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	    SIGNUPVALIDATION_FAIL: 'SIGNUPVALIDATION_FAIL',
	    SIGNUPVALIDATION_SUCCESS: 'SIGNUPVALIDATION_SUCCESS'
	};

/***/ },
/* 1043 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.date = obj.date;
		this.stationId = obj.stationid;
		this.indicatorId = obj.indicatorid;
	};
	
	exports.default = _class;

/***/ },
/* 1044 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.code = obj.code;
		this.postalCode = obj.postalcode;
		this.population = obj.population;
	};
	
	exports.default = _class;

/***/ },
/* 1045 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.code = obj.code;
	};
	
	exports.default = _class;

/***/ },
/* 1046 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class() {
	    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, _class);
	
	    this.id = obj.id;
	    this.type = obj.type;
	};
	
	exports.default = _class;

/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _DtoStandardCodification = __webpack_require__(225);
	
	var _DtoStandardCodification2 = _interopRequireDefault(_DtoStandardCodification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DtoIcpeActivity = function (_DtoStandardCodificat) {
		_inherits(DtoIcpeActivity, _DtoStandardCodificat);
	
		function DtoIcpeActivity(obj) {
			_classCallCheck(this, DtoIcpeActivity);
	
			return _possibleConstructorReturn(this, (DtoIcpeActivity.__proto__ || Object.getPrototypeOf(DtoIcpeActivity)).call(this, obj));
		}
	
		return DtoIcpeActivity;
	}(_DtoStandardCodification2.default);
	
	exports.default = DtoIcpeActivity;

/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _DtoStandardCodification = __webpack_require__(225);
	
	var _DtoStandardCodification2 = _interopRequireDefault(_DtoStandardCodification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DtoIndustrialActivity = function (_DtoStandardCodificat) {
		_inherits(DtoIndustrialActivity, _DtoStandardCodificat);
	
		function DtoIndustrialActivity(obj) {
			_classCallCheck(this, DtoIndustrialActivity);
	
			return _possibleConstructorReturn(this, (DtoIndustrialActivity.__proto__ || Object.getPrototypeOf(DtoIndustrialActivity)).call(this, obj));
		}
	
		return DtoIndustrialActivity;
	}(_DtoStandardCodification2.default);
	
	exports.default = DtoIndustrialActivity;

/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _DtoStandardCodification = __webpack_require__(225);
	
	var _DtoStandardCodification2 = _interopRequireDefault(_DtoStandardCodification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DtoIndustrialFamily = function (_DtoStandardCodificat) {
		_inherits(DtoIndustrialFamily, _DtoStandardCodificat);
	
		function DtoIndustrialFamily(obj) {
			_classCallCheck(this, DtoIndustrialFamily);
	
			return _possibleConstructorReturn(this, (DtoIndustrialFamily.__proto__ || Object.getPrototypeOf(DtoIndustrialFamily)).call(this, obj));
		}
	
		return DtoIndustrialFamily;
	}(_DtoStandardCodification2.default);
	
	exports.default = DtoIndustrialFamily;

/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _DtoStandardCodification = __webpack_require__(225);
	
	var _DtoStandardCodification2 = _interopRequireDefault(_DtoStandardCodification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DtoIndustrialSeveso = function (_DtoStandardCodificat) {
		_inherits(DtoIndustrialSeveso, _DtoStandardCodificat);
	
		function DtoIndustrialSeveso(obj) {
			_classCallCheck(this, DtoIndustrialSeveso);
	
			return _possibleConstructorReturn(this, (DtoIndustrialSeveso.__proto__ || Object.getPrototypeOf(DtoIndustrialSeveso)).call(this, obj));
		}
	
		return DtoIndustrialSeveso;
	}(_DtoStandardCodification2.default);
	
	exports.default = DtoIndustrialSeveso;

/***/ },
/* 1051 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DtoIndustrialSite = function DtoIndustrialSite(obj) {
		_classCallCheck(this, DtoIndustrialSite);
	
		this.id = obj.id;
		this.activity = obj.activity;
		this.state = obj.state_of_knowledge;
		this.familyCode = obj.industrialsitefamily_code;
		this.sevesoCode = obj.industrialsiteseveso_code;
		this.activityCode = obj.industrialsiteactivity_code;
	};
	
	exports.default = DtoIndustrialSite;

/***/ },
/* 1052 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DtoPollutedSoil = function DtoPollutedSoil(obj) {
		_classCallCheck(this, DtoPollutedSoil);
	
		this.id = obj.id;
		this.icpeActivityCode = obj.icpeactivitycode_code;
	};
	
	exports.default = DtoPollutedSoil;

/***/ },
/* 1053 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
		CATEGORY_EXPORT: 'CATEGORY_EXPORT',
		CATEGORY_RESEARCH: 'CATEGORY_RESEARCH',
		ACTION_EXPORT: 'ACTION_EXPORT',
		ACTION_RESEARCH: 'ACTION_RESEARCH',
		ACTION_ADVANCED_RESEARCH: 'ACTION_ADVANCED_RESEARCH'
	};

/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.checkEntryValue = exports.getResult = exports.filterList = undefined;
	
	var _lodash = __webpack_require__(15);
	
	var checkEntryValue = function checkEntryValue(str) {
		if (str) {
			return str.toLowerCase().replace(new RegExp('\\s', 'g'), '').replace(new RegExp('[àáâãäå]', 'g'), 'a').replace(new RegExp('æ', 'g'), 'ae').replace(new RegExp('ç', 'g'), 'c').replace(new RegExp('[èéêë]', 'g'), 'e').replace(new RegExp('[ìíîï]', 'g'), 'i').replace(new RegExp('ñ', 'g'), 'n').replace(new RegExp('[òóôõö]', 'g'), 'o').replace(new RegExp('œ', 'g'), 'oe').replace(new RegExp('[ùúûü]', 'g'), 'u').replace(new RegExp('[ýÿ]', 'g'), 'y').replace(new RegExp('\\W', 'g'), '');
		}
		return str;
	};
	var getResult = function getResult(list, nbResult) {
		if (nbResult) {
			return (0, _lodash.take)((0, _lodash.orderBy)(list, ['name'], ['asc']), nbResult);
		}
		return (0, _lodash.orderBy)(list, ['name'], ['asc']);
	};
	var filterList = function filterList(list, filterInput) {
		var nbResult = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
		if (filterInput) {
			var formatFilterInput = checkEntryValue(filterInput);
			return getResult((0, _lodash.filter)(list, function (o) {
				return (o.nameResearch ? o.nameResearch.includes(formatFilterInput) : false) || (o.codeResearch ? o.codeResearch.includes(formatFilterInput) : false) || (o.postalCodeResearch ? o.postalCodeResearch.includes(formatFilterInput) : false);
			}), nbResult);
		}
		return getResult(list, nbResult);
	};
	
	exports.filterList = filterList;
	exports.getResult = getResult;
	exports.checkEntryValue = checkEntryValue;

/***/ },
/* 1055 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
		RIGHT_POSITION: 'RIGHT_POSITION',
		LEFT_POSITION: 'LEFT_POSITION'
	};

/***/ },
/* 1056 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
		NUMBER: 'number',
		DATE: 'date',
		TEXT: 'TEXT',
		BOOLEAN: 'BOOLEAN',
		FUNCTION: 'FUNCTION',
		STATUS: 'STATUS'
	};

/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.checkBetaUser = undefined;
	
	var _lodash = __webpack_require__(15);
	
	var checkBetaUser = function checkBetaUser(userRoles) {
		if (userRoles) {
			return (0, _lodash.filter)(userRoles, function (o) {
				return o.roleId.includes('BETABETA');
			});
		}
		return ['ADMIN'];
	};
	
	exports.checkBetaUser = checkBetaUser;

/***/ },
/* 1058 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
		AQUADB_COOKIE: 'aquadb-be-user-accept-cookie',
		AQUADB_COOKIE_ADVERTISEMENT: 'advertisingCookies',
		AQUADB_COOKIE_STATISTICS: 'statisticsCookies',
		AQUADB_EXPIRE_DAYS: '30'
	};

/***/ },
/* 1059 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var getLegendUrl = function getLegendUrl(layer) {
		return layer.url + 'version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&format=image/jpeg&layer=' + layer.layer;
	};
	exports.getLegendUrl = getLegendUrl;

/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(687);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 1061 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(551));
	
	var _ChildMapping = __webpack_require__(2249);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	/**
	 * The `<TransitionGroup>` component manages a set of transition components
	 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
	 * components, `<TransitionGroup>` is a state machine for managing the mounting
	 * and unmounting of components over time.
	 *
	 * Consider the example below. As items are removed or added to the TodoList the
	 * `in` prop is toggled automatically by the `<TransitionGroup>`.
	 *
	 * Note that `<TransitionGroup>`  does not define any animation behavior!
	 * Exactly _how_ a list item animates is up to the individual transition
	 * component. This means you can mix and match animations across different list
	 * items.
	 */
	
	var TransitionGroup = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	
	    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this)); // Initial children should all be entering, dependent on appear
	
	
	    _this.state = {
	      contextValue: {
	        isMounting: true
	      },
	      handleExited: handleExited,
	      firstRender: true
	    };
	    return _this;
	  }
	
	  var _proto = TransitionGroup.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.mounted = true;
	    this.setState({
	      contextValue: {
	        isMounting: false
	      }
	    });
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.mounted = false;
	  };
	
	  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
	    var prevChildMapping = _ref.children,
	        handleExited = _ref.handleExited,
	        firstRender = _ref.firstRender;
	    return {
	      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
	      firstRender: false
	    };
	  } // node is `undefined` when user provided `nodeRef` prop
	  ;
	
	  _proto.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    if (this.mounted) {
	      this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[child.key];
	        return {
	          children: children
	        };
	      });
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.component,
	        childFactory = _this$props.childFactory,
	        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
	
	    var contextValue = this.state.contextValue;
	    var children = values(this.state.children).map(childFactory);
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return /*#__PURE__*/_react.default.createElement(_TransitionGroupContext.default.Provider, {
	        value: contextValue
	      }, children);
	    }
	
	    return /*#__PURE__*/_react.default.createElement(_TransitionGroupContext.default.Provider, {
	      value: contextValue
	    }, /*#__PURE__*/_react.default.createElement(Component, props, children));
	  };
	
	  return TransitionGroup;
	}(_react.default.Component);
	
	TransitionGroup.propTypes =  false ? {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes.default.any,
	
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   *
	   * While this component is meant for multiple `Transition` or `CSSTransition`
	   * children, sometimes you may want to have a single transition child with
	   * content that you want to be transitioned out and in when you change it
	   * (e.g. routes, images etc.) In that case you can change the `key` prop of
	   * the transition child as you change its content, this will cause
	   * `TransitionGroup` to transition the child out and back in.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables exit animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes.default.func
	} : {};
	TransitionGroup.defaultProps = defaultProps;
	var _default = TransitionGroup;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1063 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	var _default = {
	  disabled: false
	};
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	  enter: _propTypes.default.number,
	  exit: _propTypes.default.number,
	  appear: _propTypes.default.number
	}).isRequired]) : null;
	exports.timeoutsShape = timeoutsShape;
	var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  active: _propTypes.default.string
	}), _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  enterDone: _propTypes.default.string,
	  enterActive: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  exitDone: _propTypes.default.string,
	  exitActive: _propTypes.default.string
	})]) : null;
	exports.classNamesShape = classNamesShape;

/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1066 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ },
/* 1067 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ },
/* 1068 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 1069 */
/***/ function(module, exports) {

	'use strict';
	
	var $Object = Object;
	var $TypeError = TypeError;
	
	module.exports = function flags() {
		if (this != null && this !== $Object(this)) {
			throw new $TypeError('RegExp.prototype.flags getter called on non-object');
		}
		var result = '';
		if (this.global) {
			result += 'g';
		}
		if (this.ignoreCase) {
			result += 'i';
		}
		if (this.multiline) {
			result += 'm';
		}
		if (this.dotAll) {
			result += 's';
		}
		if (this.unicode) {
			result += 'u';
		}
		if (this.sticky) {
			result += 'y';
		}
		return result;
	};


/***/ },
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(1069);
	
	var supportsDescriptors = __webpack_require__(257).supportsDescriptors;
	var $gOPD = Object.getOwnPropertyDescriptor;
	var $TypeError = TypeError;
	
	module.exports = function getPolyfill() {
		if (!supportsDescriptors) {
			throw new $TypeError('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
		}
		if ((/a/mig).flags === 'gim') {
			var descriptor = $gOPD(RegExp.prototype, 'flags');
			if (descriptor && typeof descriptor.get === 'function' && typeof (/a/).dotAll === 'boolean') {
				return descriptor.get;
			}
		}
		return implementation;
	};


/***/ },
/* 1071 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SensorTabIndex = exports.SensorClassName = exports.SizeSensorId = void 0;
	
	/**
	 * Created by hustcc on 18/6/9.
	 * Contract: i@hust.cc
	 */
	var SizeSensorId = 'size-sensor-id';
	exports.SizeSensorId = SizeSensorId;
	var SensorClassName = 'size-sensor-object';
	exports.SensorClassName = SensorClassName;
	var SensorTabIndex = '-1';
	exports.SensorTabIndex = SensorTabIndex;

/***/ },
/* 1072 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	/**
	 * Created by hustcc on 18/6/9.
	 * Contract: i@hust.cc
	 */
	var _default = function _default(fn) {
	  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60;
	  var timer = null;
	  return function () {
	    var _this = this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    clearTimeout(timer);
	    timer = setTimeout(function () {
	      fn.apply(_this, args);
	    }, delay);
	  };
	};
	
	exports["default"] = _default;

/***/ },
/* 1073 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 1074 */
/***/ function(module, exports) {

	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	for (var i = 0; i < 256; ++i) {
	  byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}
	
	function bytesToUuid(buf, offset) {
	  var i = offset || 0;
	  var bth = byteToHex;
	  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
	  return ([
	    bth[buf[i++]], bth[buf[i++]],
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]],
	    bth[buf[i++]], bth[buf[i++]],
	    bth[buf[i++]], bth[buf[i++]]
	  ]).join('');
	}
	
	module.exports = bytesToUuid;


/***/ },
/* 1075 */
/***/ function(module, exports) {

	// Unique ID creation requires a high quality random # generator.  In the
	// browser this is a little complicated due to unknown quality of Math.random()
	// and inconsistent support for the `crypto` API.  We do the best we can via
	// feature-detection
	
	// getRandomValues needs to be invoked in a context where "this" is a Crypto
	// implementation. Also, find the complete implementation of crypto on IE11.
	var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
	                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));
	
	if (getRandomValues) {
	  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
	  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
	
	  module.exports = function whatwgRNG() {
	    getRandomValues(rnds8);
	    return rnds8;
	  };
	} else {
	  // Math.random()-based (RNG)
	  //
	  // If all else fails, use Math.random().  It's fast, but is of unspecified
	  // quality.
	  var rnds = new Array(16);
	
	  module.exports = function mathRNG() {
	    for (var i = 0, r; i < 16; i++) {
	      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
	      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	    }
	
	    return rnds;
	  };
	}


/***/ },
/* 1076 */
/***/ function(module, exports, __webpack_require__) {

	var guid = __webpack_require__(1086);
	
	var Eventful = __webpack_require__(189);
	
	var Transformable = __webpack_require__(389);
	
	var Animatable = __webpack_require__(2294);
	
	var zrUtil = __webpack_require__(3);
	
	/**
	 * @alias module:zrender/Element
	 * @constructor
	 * @extends {module:zrender/mixin/Animatable}
	 * @extends {module:zrender/mixin/Transformable}
	 * @extends {module:zrender/mixin/Eventful}
	 */
	var Element = function (opts) {
	  // jshint ignore:line
	  Transformable.call(this, opts);
	  Eventful.call(this, opts);
	  Animatable.call(this, opts);
	  /**
	   * 画布元素ID
	   * @type {string}
	   */
	
	  this.id = opts.id || guid();
	};
	
	Element.prototype = {
	  /**
	   * 元素类型
	   * Element type
	   * @type {string}
	   */
	  type: 'element',
	
	  /**
	   * 元素名字
	   * Element name
	   * @type {string}
	   */
	  name: '',
	
	  /**
	   * ZRender 实例对象，会在 element 添加到 zrender 实例中后自动赋值
	   * ZRender instance will be assigned when element is associated with zrender
	   * @name module:/zrender/Element#__zr
	   * @type {module:zrender/ZRender}
	   */
	  __zr: null,
	
	  /**
	   * 图形是否忽略，为true时忽略图形的绘制以及事件触发
	   * If ignore drawing and events of the element object
	   * @name module:/zrender/Element#ignore
	   * @type {boolean}
	   * @default false
	   */
	  ignore: false,
	
	  /**
	   * 用于裁剪的路径(shape)，所有 Group 内的路径在绘制时都会被这个路径裁剪
	   * 该路径会继承被裁减对象的变换
	   * @type {module:zrender/graphic/Path}
	   * @see http://www.w3.org/TR/2dcontext/#clipping-region
	   * @readOnly
	   */
	  clipPath: null,
	
	  /**
	   * 是否是 Group
	   * @type {boolean}
	   */
	  isGroup: false,
	
	  /**
	   * Drift element
	   * @param  {number} dx dx on the global space
	   * @param  {number} dy dy on the global space
	   */
	  drift: function (dx, dy) {
	    switch (this.draggable) {
	      case 'horizontal':
	        dy = 0;
	        break;
	
	      case 'vertical':
	        dx = 0;
	        break;
	    }
	
	    var m = this.transform;
	
	    if (!m) {
	      m = this.transform = [1, 0, 0, 1, 0, 0];
	    }
	
	    m[4] += dx;
	    m[5] += dy;
	    this.decomposeTransform();
	    this.dirty(false);
	  },
	
	  /**
	   * Hook before update
	   */
	  beforeUpdate: function () {},
	
	  /**
	   * Hook after update
	   */
	  afterUpdate: function () {},
	
	  /**
	   * Update each frame
	   */
	  update: function () {
	    this.updateTransform();
	  },
	
	  /**
	   * @param  {Function} cb
	   * @param  {}   context
	   */
	  traverse: function (cb, context) {},
	
	  /**
	   * @protected
	   */
	  attrKV: function (key, value) {
	    if (key === 'position' || key === 'scale' || key === 'origin') {
	      // Copy the array
	      if (value) {
	        var target = this[key];
	
	        if (!target) {
	          target = this[key] = [];
	        }
	
	        target[0] = value[0];
	        target[1] = value[1];
	      }
	    } else {
	      this[key] = value;
	    }
	  },
	
	  /**
	   * Hide the element
	   */
	  hide: function () {
	    this.ignore = true;
	    this.__zr && this.__zr.refresh();
	  },
	
	  /**
	   * Show the element
	   */
	  show: function () {
	    this.ignore = false;
	    this.__zr && this.__zr.refresh();
	  },
	
	  /**
	   * @param {string|Object} key
	   * @param {*} value
	   */
	  attr: function (key, value) {
	    if (typeof key === 'string') {
	      this.attrKV(key, value);
	    } else if (zrUtil.isObject(key)) {
	      for (var name in key) {
	        if (key.hasOwnProperty(name)) {
	          this.attrKV(name, key[name]);
	        }
	      }
	    }
	
	    this.dirty(false);
	    return this;
	  },
	
	  /**
	   * @param {module:zrender/graphic/Path} clipPath
	   */
	  setClipPath: function (clipPath) {
	    var zr = this.__zr;
	
	    if (zr) {
	      clipPath.addSelfToZr(zr);
	    } // Remove previous clip path
	
	
	    if (this.clipPath && this.clipPath !== clipPath) {
	      this.removeClipPath();
	    }
	
	    this.clipPath = clipPath;
	    clipPath.__zr = zr;
	    clipPath.__clipTarget = this;
	    this.dirty(false);
	  },
	
	  /**
	   */
	  removeClipPath: function () {
	    var clipPath = this.clipPath;
	
	    if (clipPath) {
	      if (clipPath.__zr) {
	        clipPath.removeSelfFromZr(clipPath.__zr);
	      }
	
	      clipPath.__zr = null;
	      clipPath.__clipTarget = null;
	      this.clipPath = null;
	      this.dirty(false);
	    }
	  },
	
	  /**
	   * Add self from zrender instance.
	   * Not recursively because it will be invoked when element added to storage.
	   * @param {module:zrender/ZRender} zr
	   */
	  addSelfToZr: function (zr) {
	    this.__zr = zr; // 添加动画
	
	    var animators = this.animators;
	
	    if (animators) {
	      for (var i = 0; i < animators.length; i++) {
	        zr.animation.addAnimator(animators[i]);
	      }
	    }
	
	    if (this.clipPath) {
	      this.clipPath.addSelfToZr(zr);
	    }
	  },
	
	  /**
	   * Remove self from zrender instance.
	   * Not recursively because it will be invoked when element added to storage.
	   * @param {module:zrender/ZRender} zr
	   */
	  removeSelfFromZr: function (zr) {
	    this.__zr = null; // 移除动画
	
	    var animators = this.animators;
	
	    if (animators) {
	      for (var i = 0; i < animators.length; i++) {
	        zr.animation.removeAnimator(animators[i]);
	      }
	    }
	
	    if (this.clipPath) {
	      this.clipPath.removeSelfFromZr(zr);
	    }
	  }
	};
	zrUtil.mixin(Element, Animatable);
	zrUtil.mixin(Element, Transformable);
	zrUtil.mixin(Element, Eventful);
	var _default = Element;
	module.exports = _default;

/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	var Clip = __webpack_require__(2276);
	
	var color = __webpack_require__(114);
	
	var _util = __webpack_require__(3);
	
	var isArrayLike = _util.isArrayLike;
	
	/**
	 * @module echarts/animation/Animator
	 */
	var arraySlice = Array.prototype.slice;
	
	function defaultGetter(target, key) {
	  return target[key];
	}
	
	function defaultSetter(target, key, value) {
	  target[key] = value;
	}
	/**
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} percent
	 * @return {number}
	 */
	
	
	function interpolateNumber(p0, p1, percent) {
	  return (p1 - p0) * percent + p0;
	}
	/**
	 * @param  {string} p0
	 * @param  {string} p1
	 * @param  {number} percent
	 * @return {string}
	 */
	
	
	function interpolateString(p0, p1, percent) {
	  return percent > 0.5 ? p1 : p0;
	}
	/**
	 * @param  {Array} p0
	 * @param  {Array} p1
	 * @param  {number} percent
	 * @param  {Array} out
	 * @param  {number} arrDim
	 */
	
	
	function interpolateArray(p0, p1, percent, out, arrDim) {
	  var len = p0.length;
	
	  if (arrDim === 1) {
	    for (var i = 0; i < len; i++) {
	      out[i] = interpolateNumber(p0[i], p1[i], percent);
	    }
	  } else {
	    var len2 = len && p0[0].length;
	
	    for (var i = 0; i < len; i++) {
	      for (var j = 0; j < len2; j++) {
	        out[i][j] = interpolateNumber(p0[i][j], p1[i][j], percent);
	      }
	    }
	  }
	} // arr0 is source array, arr1 is target array.
	// Do some preprocess to avoid error happened when interpolating from arr0 to arr1
	
	
	function fillArr(arr0, arr1, arrDim) {
	  var arr0Len = arr0.length;
	  var arr1Len = arr1.length;
	
	  if (arr0Len !== arr1Len) {
	    // FIXME Not work for TypedArray
	    var isPreviousLarger = arr0Len > arr1Len;
	
	    if (isPreviousLarger) {
	      // Cut the previous
	      arr0.length = arr1Len;
	    } else {
	      // Fill the previous
	      for (var i = arr0Len; i < arr1Len; i++) {
	        arr0.push(arrDim === 1 ? arr1[i] : arraySlice.call(arr1[i]));
	      }
	    }
	  } // Handling NaN value
	
	
	  var len2 = arr0[0] && arr0[0].length;
	
	  for (var i = 0; i < arr0.length; i++) {
	    if (arrDim === 1) {
	      if (isNaN(arr0[i])) {
	        arr0[i] = arr1[i];
	      }
	    } else {
	      for (var j = 0; j < len2; j++) {
	        if (isNaN(arr0[i][j])) {
	          arr0[i][j] = arr1[i][j];
	        }
	      }
	    }
	  }
	}
	/**
	 * @param  {Array} arr0
	 * @param  {Array} arr1
	 * @param  {number} arrDim
	 * @return {boolean}
	 */
	
	
	function isArraySame(arr0, arr1, arrDim) {
	  if (arr0 === arr1) {
	    return true;
	  }
	
	  var len = arr0.length;
	
	  if (len !== arr1.length) {
	    return false;
	  }
	
	  if (arrDim === 1) {
	    for (var i = 0; i < len; i++) {
	      if (arr0[i] !== arr1[i]) {
	        return false;
	      }
	    }
	  } else {
	    var len2 = arr0[0].length;
	
	    for (var i = 0; i < len; i++) {
	      for (var j = 0; j < len2; j++) {
	        if (arr0[i][j] !== arr1[i][j]) {
	          return false;
	        }
	      }
	    }
	  }
	
	  return true;
	}
	/**
	 * Catmull Rom interpolate array
	 * @param  {Array} p0
	 * @param  {Array} p1
	 * @param  {Array} p2
	 * @param  {Array} p3
	 * @param  {number} t
	 * @param  {number} t2
	 * @param  {number} t3
	 * @param  {Array} out
	 * @param  {number} arrDim
	 */
	
	
	function catmullRomInterpolateArray(p0, p1, p2, p3, t, t2, t3, out, arrDim) {
	  var len = p0.length;
	
	  if (arrDim === 1) {
	    for (var i = 0; i < len; i++) {
	      out[i] = catmullRomInterpolate(p0[i], p1[i], p2[i], p3[i], t, t2, t3);
	    }
	  } else {
	    var len2 = p0[0].length;
	
	    for (var i = 0; i < len; i++) {
	      for (var j = 0; j < len2; j++) {
	        out[i][j] = catmullRomInterpolate(p0[i][j], p1[i][j], p2[i][j], p3[i][j], t, t2, t3);
	      }
	    }
	  }
	}
	/**
	 * Catmull Rom interpolate number
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {number} t
	 * @param  {number} t2
	 * @param  {number} t3
	 * @return {number}
	 */
	
	
	function catmullRomInterpolate(p0, p1, p2, p3, t, t2, t3) {
	  var v0 = (p2 - p0) * 0.5;
	  var v1 = (p3 - p1) * 0.5;
	  return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
	}
	
	function cloneValue(value) {
	  if (isArrayLike(value)) {
	    var len = value.length;
	
	    if (isArrayLike(value[0])) {
	      var ret = [];
	
	      for (var i = 0; i < len; i++) {
	        ret.push(arraySlice.call(value[i]));
	      }
	
	      return ret;
	    }
	
	    return arraySlice.call(value);
	  }
	
	  return value;
	}
	
	function rgba2String(rgba) {
	  rgba[0] = Math.floor(rgba[0]);
	  rgba[1] = Math.floor(rgba[1]);
	  rgba[2] = Math.floor(rgba[2]);
	  return 'rgba(' + rgba.join(',') + ')';
	}
	
	function getArrayDim(keyframes) {
	  var lastValue = keyframes[keyframes.length - 1].value;
	  return isArrayLike(lastValue && lastValue[0]) ? 2 : 1;
	}
	
	function createTrackClip(animator, easing, oneTrackDone, keyframes, propName, forceAnimate) {
	  var getter = animator._getter;
	  var setter = animator._setter;
	  var useSpline = easing === 'spline';
	  var trackLen = keyframes.length;
	
	  if (!trackLen) {
	    return;
	  } // Guess data type
	
	
	  var firstVal = keyframes[0].value;
	  var isValueArray = isArrayLike(firstVal);
	  var isValueColor = false;
	  var isValueString = false; // For vertices morphing
	
	  var arrDim = isValueArray ? getArrayDim(keyframes) : 0;
	  var trackMaxTime; // Sort keyframe as ascending
	
	  keyframes.sort(function (a, b) {
	    return a.time - b.time;
	  });
	  trackMaxTime = keyframes[trackLen - 1].time; // Percents of each keyframe
	
	  var kfPercents = []; // Value of each keyframe
	
	  var kfValues = [];
	  var prevValue = keyframes[0].value;
	  var isAllValueEqual = true;
	
	  for (var i = 0; i < trackLen; i++) {
	    kfPercents.push(keyframes[i].time / trackMaxTime); // Assume value is a color when it is a string
	
	    var value = keyframes[i].value; // Check if value is equal, deep check if value is array
	
	    if (!(isValueArray && isArraySame(value, prevValue, arrDim) || !isValueArray && value === prevValue)) {
	      isAllValueEqual = false;
	    }
	
	    prevValue = value; // Try converting a string to a color array
	
	    if (typeof value === 'string') {
	      var colorArray = color.parse(value);
	
	      if (colorArray) {
	        value = colorArray;
	        isValueColor = true;
	      } else {
	        isValueString = true;
	      }
	    }
	
	    kfValues.push(value);
	  }
	
	  if (!forceAnimate && isAllValueEqual) {
	    return;
	  }
	
	  var lastValue = kfValues[trackLen - 1]; // Polyfill array and NaN value
	
	  for (var i = 0; i < trackLen - 1; i++) {
	    if (isValueArray) {
	      fillArr(kfValues[i], lastValue, arrDim);
	    } else {
	      if (isNaN(kfValues[i]) && !isNaN(lastValue) && !isValueString && !isValueColor) {
	        kfValues[i] = lastValue;
	      }
	    }
	  }
	
	  isValueArray && fillArr(getter(animator._target, propName), lastValue, arrDim); // Cache the key of last frame to speed up when
	  // animation playback is sequency
	
	  var lastFrame = 0;
	  var lastFramePercent = 0;
	  var start;
	  var w;
	  var p0;
	  var p1;
	  var p2;
	  var p3;
	
	  if (isValueColor) {
	    var rgba = [0, 0, 0, 0];
	  }
	
	  var onframe = function (target, percent) {
	    // Find the range keyframes
	    // kf1-----kf2---------current--------kf3
	    // find kf2 and kf3 and do interpolation
	    var frame; // In the easing function like elasticOut, percent may less than 0
	
	    if (percent < 0) {
	      frame = 0;
	    } else if (percent < lastFramePercent) {
	      // Start from next key
	      // PENDING start from lastFrame ?
	      start = Math.min(lastFrame + 1, trackLen - 1);
	
	      for (frame = start; frame >= 0; frame--) {
	        if (kfPercents[frame] <= percent) {
	          break;
	        }
	      } // PENDING really need to do this ?
	
	
	      frame = Math.min(frame, trackLen - 2);
	    } else {
	      for (frame = lastFrame; frame < trackLen; frame++) {
	        if (kfPercents[frame] > percent) {
	          break;
	        }
	      }
	
	      frame = Math.min(frame - 1, trackLen - 2);
	    }
	
	    lastFrame = frame;
	    lastFramePercent = percent;
	    var range = kfPercents[frame + 1] - kfPercents[frame];
	
	    if (range === 0) {
	      return;
	    } else {
	      w = (percent - kfPercents[frame]) / range;
	    }
	
	    if (useSpline) {
	      p1 = kfValues[frame];
	      p0 = kfValues[frame === 0 ? frame : frame - 1];
	      p2 = kfValues[frame > trackLen - 2 ? trackLen - 1 : frame + 1];
	      p3 = kfValues[frame > trackLen - 3 ? trackLen - 1 : frame + 2];
	
	      if (isValueArray) {
	        catmullRomInterpolateArray(p0, p1, p2, p3, w, w * w, w * w * w, getter(target, propName), arrDim);
	      } else {
	        var value;
	
	        if (isValueColor) {
	          value = catmullRomInterpolateArray(p0, p1, p2, p3, w, w * w, w * w * w, rgba, 1);
	          value = rgba2String(rgba);
	        } else if (isValueString) {
	          // String is step(0.5)
	          return interpolateString(p1, p2, w);
	        } else {
	          value = catmullRomInterpolate(p0, p1, p2, p3, w, w * w, w * w * w);
	        }
	
	        setter(target, propName, value);
	      }
	    } else {
	      if (isValueArray) {
	        interpolateArray(kfValues[frame], kfValues[frame + 1], w, getter(target, propName), arrDim);
	      } else {
	        var value;
	
	        if (isValueColor) {
	          interpolateArray(kfValues[frame], kfValues[frame + 1], w, rgba, 1);
	          value = rgba2String(rgba);
	        } else if (isValueString) {
	          // String is step(0.5)
	          return interpolateString(kfValues[frame], kfValues[frame + 1], w);
	        } else {
	          value = interpolateNumber(kfValues[frame], kfValues[frame + 1], w);
	        }
	
	        setter(target, propName, value);
	      }
	    }
	  };
	
	  var clip = new Clip({
	    target: animator._target,
	    life: trackMaxTime,
	    loop: animator._loop,
	    delay: animator._delay,
	    onframe: onframe,
	    ondestroy: oneTrackDone
	  });
	
	  if (easing && easing !== 'spline') {
	    clip.easing = easing;
	  }
	
	  return clip;
	}
	/**
	 * @alias module:zrender/animation/Animator
	 * @constructor
	 * @param {Object} target
	 * @param {boolean} loop
	 * @param {Function} getter
	 * @param {Function} setter
	 */
	
	
	var Animator = function (target, loop, getter, setter) {
	  this._tracks = {};
	  this._target = target;
	  this._loop = loop || false;
	  this._getter = getter || defaultGetter;
	  this._setter = setter || defaultSetter;
	  this._clipCount = 0;
	  this._delay = 0;
	  this._doneList = [];
	  this._onframeList = [];
	  this._clipList = [];
	};
	
	Animator.prototype = {
	  /**
	   * Set Animation keyframe
	   * @param  {number} time 关键帧时间，单位是ms
	   * @param  {Object} props 关键帧的属性值，key-value表示
	   * @return {module:zrender/animation/Animator}
	   */
	  when: function (time
	  /* ms */
	  , props) {
	    var tracks = this._tracks;
	
	    for (var propName in props) {
	      if (!props.hasOwnProperty(propName)) {
	        continue;
	      }
	
	      if (!tracks[propName]) {
	        tracks[propName] = []; // Invalid value
	
	        var value = this._getter(this._target, propName);
	
	        if (value == null) {
	          // zrLog('Invalid property ' + propName);
	          continue;
	        } // If time is 0
	        //  Then props is given initialize value
	        // Else
	        //  Initialize value from current prop value
	
	
	        if (time !== 0) {
	          tracks[propName].push({
	            time: 0,
	            value: cloneValue(value)
	          });
	        }
	      }
	
	      tracks[propName].push({
	        time: time,
	        value: props[propName]
	      });
	    }
	
	    return this;
	  },
	
	  /**
	   * 添加动画每一帧的回调函数
	   * @param  {Function} callback
	   * @return {module:zrender/animation/Animator}
	   */
	  during: function (callback) {
	    this._onframeList.push(callback);
	
	    return this;
	  },
	  pause: function () {
	    for (var i = 0; i < this._clipList.length; i++) {
	      this._clipList[i].pause();
	    }
	
	    this._paused = true;
	  },
	  resume: function () {
	    for (var i = 0; i < this._clipList.length; i++) {
	      this._clipList[i].resume();
	    }
	
	    this._paused = false;
	  },
	  isPaused: function () {
	    return !!this._paused;
	  },
	  _doneCallback: function () {
	    // Clear all tracks
	    this._tracks = {}; // Clear all clips
	
	    this._clipList.length = 0;
	    var doneList = this._doneList;
	    var len = doneList.length;
	
	    for (var i = 0; i < len; i++) {
	      doneList[i].call(this);
	    }
	  },
	
	  /**
	   * Start the animation
	   * @param  {string|Function} [easing]
	   *         动画缓动函数，详见{@link module:zrender/animation/easing}
	   * @param  {boolean} forceAnimate
	   * @return {module:zrender/animation/Animator}
	   */
	  start: function (easing, forceAnimate) {
	    var self = this;
	    var clipCount = 0;
	
	    var oneTrackDone = function () {
	      clipCount--;
	
	      if (!clipCount) {
	        self._doneCallback();
	      }
	    };
	
	    var lastClip;
	
	    for (var propName in this._tracks) {
	      if (!this._tracks.hasOwnProperty(propName)) {
	        continue;
	      }
	
	      var clip = createTrackClip(this, easing, oneTrackDone, this._tracks[propName], propName, forceAnimate);
	
	      if (clip) {
	        this._clipList.push(clip);
	
	        clipCount++; // If start after added to animation
	
	        if (this.animation) {
	          this.animation.addClip(clip);
	        }
	
	        lastClip = clip;
	      }
	    } // Add during callback on the last clip
	
	
	    if (lastClip) {
	      var oldOnFrame = lastClip.onframe;
	
	      lastClip.onframe = function (target, percent) {
	        oldOnFrame(target, percent);
	
	        for (var i = 0; i < self._onframeList.length; i++) {
	          self._onframeList[i](target, percent);
	        }
	      };
	    } // This optimization will help the case that in the upper application
	    // the view may be refreshed frequently, where animation will be
	    // called repeatly but nothing changed.
	
	
	    if (!clipCount) {
	      this._doneCallback();
	    }
	
	    return this;
	  },
	
	  /**
	   * Stop animation
	   * @param {boolean} forwardToLast If move to last frame before stop
	   */
	  stop: function (forwardToLast) {
	    var clipList = this._clipList;
	    var animation = this.animation;
	
	    for (var i = 0; i < clipList.length; i++) {
	      var clip = clipList[i];
	
	      if (forwardToLast) {
	        // Move to last frame before stop
	        clip.onframe(this._target, 1);
	      }
	
	      animation && animation.removeClip(clip);
	    }
	
	    clipList.length = 0;
	  },
	
	  /**
	   * Set when animation delay starts
	   * @param  {number} time 单位ms
	   * @return {module:zrender/animation/Animator}
	   */
	  delay: function (time) {
	    this._delay = time;
	    return this;
	  },
	
	  /**
	   * Add callback for animation end
	   * @param  {Function} cb
	   * @return {module:zrender/animation/Animator}
	   */
	  done: function (cb) {
	    if (cb) {
	      this._doneList.push(cb);
	    }
	
	    return this;
	  },
	
	  /**
	   * @return {Array.<module:zrender/animation/Clip>}
	   */
	  getClips: function () {
	    return this._clipList;
	  }
	};
	var _default = Animator;
	module.exports = _default;

/***/ },
/* 1078 */
/***/ function(module, exports) {

	var _default = typeof window !== 'undefined' && (window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || // https://github.com/ecomfe/zrender/issues/189#issuecomment-224919809
	window.msRequestAnimationFrame && window.msRequestAnimationFrame.bind(window) || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame) || function (func) {
	  setTimeout(func, 16);
	};
	
	module.exports = _default;

/***/ },
/* 1079 */
/***/ function(module, exports) {

	/**
	 * 线段包含判断
	 * @param  {number}  x0
	 * @param  {number}  y0
	 * @param  {number}  x1
	 * @param  {number}  y1
	 * @param  {number}  lineWidth
	 * @param  {number}  x
	 * @param  {number}  y
	 * @return {boolean}
	 */
	function containStroke(x0, y0, x1, y1, lineWidth, x, y) {
	  if (lineWidth === 0) {
	    return false;
	  }
	
	  var _l = lineWidth;
	  var _a = 0;
	  var _b = x0; // Quick reject
	
	  if (y > y0 + _l && y > y1 + _l || y < y0 - _l && y < y1 - _l || x > x0 + _l && x > x1 + _l || x < x0 - _l && x < x1 - _l) {
	    return false;
	  }
	
	  if (x0 !== x1) {
	    _a = (y0 - y1) / (x0 - x1);
	    _b = (x0 * y1 - x1 * y0) / (x0 - x1);
	  } else {
	    return Math.abs(x - x0) <= _l / 2;
	  }
	
	  var tmp = _a * x - y + _b;
	
	  var _s = tmp * tmp / (_a * _a + 1);
	
	  return _s <= _l / 2 * _l / 2;
	}
	
	exports.containStroke = containStroke;

/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	var windingLine = __webpack_require__(1083);
	
	var EPSILON = 1e-8;
	
	function isAroundEqual(a, b) {
	  return Math.abs(a - b) < EPSILON;
	}
	
	function contain(points, x, y) {
	  var w = 0;
	  var p = points[0];
	
	  if (!p) {
	    return false;
	  }
	
	  for (var i = 1; i < points.length; i++) {
	    var p2 = points[i];
	    w += windingLine(p[0], p[1], p2[0], p2[1], x, y);
	    p = p2;
	  } // Close polygon
	
	
	  var p0 = points[0];
	
	  if (!isAroundEqual(p[0], p0[0]) || !isAroundEqual(p[1], p0[1])) {
	    w += windingLine(p[0], p[1], p0[0], p0[1], x, y);
	  }
	
	  return w !== 0;
	}
	
	exports.contain = contain;

/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	var _curve = __webpack_require__(152);
	
	var quadraticProjectPoint = _curve.quadraticProjectPoint;
	
	/**
	 * 二次贝塞尔曲线描边包含判断
	 * @param  {number}  x0
	 * @param  {number}  y0
	 * @param  {number}  x1
	 * @param  {number}  y1
	 * @param  {number}  x2
	 * @param  {number}  y2
	 * @param  {number}  lineWidth
	 * @param  {number}  x
	 * @param  {number}  y
	 * @return {boolean}
	 */
	function containStroke(x0, y0, x1, y1, x2, y2, lineWidth, x, y) {
	  if (lineWidth === 0) {
	    return false;
	  }
	
	  var _l = lineWidth; // Quick reject
	
	  if (y > y0 + _l && y > y1 + _l && y > y2 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l) {
	    return false;
	  }
	
	  var d = quadraticProjectPoint(x0, y0, x1, y1, x2, y2, x, y, null);
	  return d <= _l / 2;
	}
	
	exports.containStroke = containStroke;

/***/ },
/* 1082 */
/***/ function(module, exports) {

	var PI2 = Math.PI * 2;
	
	function normalizeRadian(angle) {
	  angle %= PI2;
	
	  if (angle < 0) {
	    angle += PI2;
	  }
	
	  return angle;
	}
	
	exports.normalizeRadian = normalizeRadian;

/***/ },
/* 1083 */
/***/ function(module, exports) {

	function windingLine(x0, y0, x1, y1, x, y) {
	  if (y > y0 && y > y1 || y < y0 && y < y1) {
	    return 0;
	  } // Ignore horizontal line
	
	
	  if (y1 === y0) {
	    return 0;
	  }
	
	  var dir = y1 < y0 ? 1 : -1;
	  var t = (y - y0) / (y1 - y0); // Avoid winding error when intersection point is the connect point of two line of polygon
	
	  if (t === 1 || t === 0) {
	    dir = y1 < y0 ? 0.5 : -0.5;
	  }
	
	  var x_ = t * (x1 - x0) + x0; // If (x, y) on the line, considered as "contain".
	
	  return x_ === x ? Infinity : x_ > x ? dir : 0;
	}
	
	module.exports = windingLine;

/***/ },
/* 1084 */
/***/ function(module, exports) {

	// Simple LRU cache use doubly linked list
	// @module zrender/core/LRU
	
	/**
	 * Simple double linked list. Compared with array, it has O(1) remove operation.
	 * @constructor
	 */
	var LinkedList = function () {
	  /**
	   * @type {module:zrender/core/LRU~Entry}
	   */
	  this.head = null;
	  /**
	   * @type {module:zrender/core/LRU~Entry}
	   */
	
	  this.tail = null;
	  this._len = 0;
	};
	
	var linkedListProto = LinkedList.prototype;
	/**
	 * Insert a new value at the tail
	 * @param  {} val
	 * @return {module:zrender/core/LRU~Entry}
	 */
	
	linkedListProto.insert = function (val) {
	  var entry = new Entry(val);
	  this.insertEntry(entry);
	  return entry;
	};
	/**
	 * Insert an entry at the tail
	 * @param  {module:zrender/core/LRU~Entry} entry
	 */
	
	
	linkedListProto.insertEntry = function (entry) {
	  if (!this.head) {
	    this.head = this.tail = entry;
	  } else {
	    this.tail.next = entry;
	    entry.prev = this.tail;
	    entry.next = null;
	    this.tail = entry;
	  }
	
	  this._len++;
	};
	/**
	 * Remove entry.
	 * @param  {module:zrender/core/LRU~Entry} entry
	 */
	
	
	linkedListProto.remove = function (entry) {
	  var prev = entry.prev;
	  var next = entry.next;
	
	  if (prev) {
	    prev.next = next;
	  } else {
	    // Is head
	    this.head = next;
	  }
	
	  if (next) {
	    next.prev = prev;
	  } else {
	    // Is tail
	    this.tail = prev;
	  }
	
	  entry.next = entry.prev = null;
	  this._len--;
	};
	/**
	 * @return {number}
	 */
	
	
	linkedListProto.len = function () {
	  return this._len;
	};
	/**
	 * Clear list
	 */
	
	
	linkedListProto.clear = function () {
	  this.head = this.tail = null;
	  this._len = 0;
	};
	/**
	 * @constructor
	 * @param {} val
	 */
	
	
	var Entry = function (val) {
	  /**
	   * @type {}
	   */
	  this.value = val;
	  /**
	   * @type {module:zrender/core/LRU~Entry}
	   */
	
	  this.next;
	  /**
	   * @type {module:zrender/core/LRU~Entry}
	   */
	
	  this.prev;
	};
	/**
	 * LRU Cache
	 * @constructor
	 * @alias module:zrender/core/LRU
	 */
	
	
	var LRU = function (maxSize) {
	  this._list = new LinkedList();
	  this._map = {};
	  this._maxSize = maxSize || 10;
	  this._lastRemovedEntry = null;
	};
	
	var LRUProto = LRU.prototype;
	/**
	 * @param  {string} key
	 * @param  {} value
	 * @return {} Removed value
	 */
	
	LRUProto.put = function (key, value) {
	  var list = this._list;
	  var map = this._map;
	  var removed = null;
	
	  if (map[key] == null) {
	    var len = list.len(); // Reuse last removed entry
	
	    var entry = this._lastRemovedEntry;
	
	    if (len >= this._maxSize && len > 0) {
	      // Remove the least recently used
	      var leastUsedEntry = list.head;
	      list.remove(leastUsedEntry);
	      delete map[leastUsedEntry.key];
	      removed = leastUsedEntry.value;
	      this._lastRemovedEntry = leastUsedEntry;
	    }
	
	    if (entry) {
	      entry.value = value;
	    } else {
	      entry = new Entry(value);
	    }
	
	    entry.key = key;
	    list.insertEntry(entry);
	    map[key] = entry;
	  }
	
	  return removed;
	};
	/**
	 * @param  {string} key
	 * @return {}
	 */
	
	
	LRUProto.get = function (key) {
	  var entry = this._map[key];
	  var list = this._list;
	
	  if (entry != null) {
	    // Put the latest used entry in the tail
	    if (entry !== list.tail) {
	      list.remove(entry);
	      list.insertEntry(entry);
	    }
	
	    return entry.value;
	  }
	};
	/**
	 * Clear the cache
	 */
	
	
	LRUProto.clear = function () {
	  this._list.clear();
	
	  this._map = {};
	};
	
	var _default = LRU;
	module.exports = _default;

/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	var env = __webpack_require__(55);
	
	var _fourPointsTransform = __webpack_require__(2283);
	
	var buildTransformer = _fourPointsTransform.buildTransformer;
	var EVENT_SAVED_PROP = '___zrEVENTSAVED';
	var _calcOut = [];
	/**
	 * Transform "local coord" from `elFrom` to `elTarget`.
	 * "local coord": the coord based on the input `el`. The origin point is at
	 *     the position of "left: 0; top: 0;" in the `el`.
	 *
	 * Support when CSS transform is used.
	 *
	 * Having the `out` (that is, `[outX, outY]`), we can create an DOM element
	 * and set the CSS style as "left: outX; top: outY;" and append it to `elTarge`
	 * to locate the element.
	 *
	 * For example, this code below positions a child of `document.body` on the event
	 * point, no matter whether `body` has `margin`/`paddin`/`transfrom`/... :
	 * ```js
	 * transformLocalCoord(out, container, document.body, event.offsetX, event.offsetY);
	 * if (!eqNaN(out[0])) {
	 *     // Then locate the tip element on the event point.
	 *     var tipEl = document.createElement('div');
	 *     tipEl.style.cssText = 'position: absolute; left:' + out[0] + ';top:' + out[1] + ';';
	 *     document.body.appendChild(tipEl);
	 * }
	 * ```
	 *
	 * Notice: In some env this method is not supported. If called, `out` will be `[NaN, NaN]`.
	 *
	 * @param {Array.<number>} out [inX: number, inY: number] The output..
	 *        If can not transform, `out` will not be modified but return `false`.
	 * @param {HTMLElement} elFrom The `[inX, inY]` is based on elFrom.
	 * @param {HTMLElement} elTarget The `out` is based on elTarget.
	 * @param {number} inX
	 * @param {number} inY
	 * @return {boolean} Whether transform successfully.
	 */
	
	function transformLocalCoord(out, elFrom, elTarget, inX, inY) {
	  return transformCoordWithViewport(_calcOut, elFrom, inX, inY, true) && transformCoordWithViewport(out, elTarget, _calcOut[0], _calcOut[1]);
	}
	/**
	 * Transform between a "viewport coord" and a "local coord".
	 * "viewport coord": the coord based on the left-top corner of the viewport
	 *     of the browser.
	 * "local coord": the coord based on the input `el`. The origin point is at
	 *     the position of "left: 0; top: 0;" in the `el`.
	 *
	 * Support the case when CSS transform is used on el.
	 *
	 * @param {Array.<number>} out [inX: number, inY: number] The output. If `inverse: false`,
	 *        it represents "local coord", otherwise "vireport coord".
	 *        If can not transform, `out` will not be modified but return `false`.
	 * @param {HTMLElement} el The "local coord" is based on the `el`, see comment above.
	 * @param {number} inX If `inverse: false`,
	 *        it represents "vireport coord", otherwise "local coord".
	 * @param {number} inY If `inverse: false`,
	 *        it represents "vireport coord", otherwise "local coord".
	 * @param {boolean} [inverse=false]
	 *        `true`: from "viewport coord" to "local coord".
	 *        `false`: from "local coord" to "viewport coord".
	 * @return {boolean} Whether transform successfully.
	 */
	
	
	function transformCoordWithViewport(out, el, inX, inY, inverse) {
	  if (el.getBoundingClientRect && env.domSupported && !isCanvasEl(el)) {
	    var saved = el[EVENT_SAVED_PROP] || (el[EVENT_SAVED_PROP] = {});
	    var markers = prepareCoordMarkers(el, saved);
	    var transformer = preparePointerTransformer(markers, saved, inverse);
	
	    if (transformer) {
	      transformer(out, inX, inY);
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function prepareCoordMarkers(el, saved) {
	  var markers = saved.markers;
	
	  if (markers) {
	    return markers;
	  }
	
	  markers = saved.markers = [];
	  var propLR = ['left', 'right'];
	  var propTB = ['top', 'bottom'];
	
	  for (var i = 0; i < 4; i++) {
	    var marker = document.createElement('div');
	    var stl = marker.style;
	    var idxLR = i % 2;
	    var idxTB = (i >> 1) % 2;
	    stl.cssText = ['position: absolute', 'visibility: hidden', 'padding: 0', 'margin: 0', 'border-width: 0', 'user-select: none', 'width:0', 'height:0', // 'width: 5px',
	    // 'height: 5px',
	    propLR[idxLR] + ':0', propTB[idxTB] + ':0', propLR[1 - idxLR] + ':auto', propTB[1 - idxTB] + ':auto', ''].join('!important;');
	    el.appendChild(marker);
	    markers.push(marker);
	  }
	
	  return markers;
	}
	
	function preparePointerTransformer(markers, saved, inverse) {
	  var transformerName = inverse ? 'invTrans' : 'trans';
	  var transformer = saved[transformerName];
	  var oldSrcCoords = saved.srcCoords;
	  var oldCoordTheSame = true;
	  var srcCoords = [];
	  var destCoords = [];
	
	  for (var i = 0; i < 4; i++) {
	    var rect = markers[i].getBoundingClientRect();
	    var ii = 2 * i;
	    var x = rect.left;
	    var y = rect.top;
	    srcCoords.push(x, y);
	    oldCoordTheSame = oldCoordTheSame && oldSrcCoords && x === oldSrcCoords[ii] && y === oldSrcCoords[ii + 1];
	    destCoords.push(markers[i].offsetLeft, markers[i].offsetTop);
	  } // Cache to avoid time consuming of `buildTransformer`.
	
	
	  return oldCoordTheSame && transformer ? transformer : (saved.srcCoords = srcCoords, saved[transformerName] = inverse ? buildTransformer(destCoords, srcCoords) : buildTransformer(srcCoords, destCoords));
	}
	
	function isCanvasEl(el) {
	  return el.nodeName.toUpperCase() === 'CANVAS';
	}
	
	exports.transformLocalCoord = transformLocalCoord;
	exports.transformCoordWithViewport = transformCoordWithViewport;
	exports.isCanvasEl = isCanvasEl;

/***/ },
/* 1086 */
/***/ function(module, exports) {

	/**
	 * zrender: 生成唯一id
	 *
	 * @author errorrik (errorrik@gmail.com)
	 */
	var idStart = 0x0907;
	
	function _default() {
	  return idStart++;
	}
	
	module.exports = _default;

/***/ },
/* 1087 */
/***/ function(module, exports) {

	var Pattern = function (image, repeat) {
	  // Should do nothing more in this constructor. Because gradient can be
	  // declard by `color: {image: ...}`, where this constructor will not be called.
	  this.image = image;
	  this.repeat = repeat; // Can be cloned
	
	  this.type = 'pattern';
	};
	
	Pattern.prototype.getCanvasPattern = function (ctx) {
	  return ctx.createPattern(this.image, this.repeat || 'repeat');
	};
	
	var _default = Pattern;
	module.exports = _default;

/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	var env = __webpack_require__(55);
	
	// Fix weird bug in some version of IE11 (like 11.0.9600.178**),
	// where exception "unexpected call to method or property access"
	// might be thrown when calling ctx.fill or ctx.stroke after a path
	// whose area size is zero is drawn and ctx.clip() is called and
	// shadowBlur is set. See #4572, #3112, #5777.
	// (e.g.,
	//  ctx.moveTo(10, 10);
	//  ctx.lineTo(20, 10);
	//  ctx.closePath();
	//  ctx.clip();
	//  ctx.shadowBlur = 10;
	//  ...
	//  ctx.fill();
	// )
	var shadowTemp = [['shadowBlur', 0], ['shadowColor', '#000'], ['shadowOffsetX', 0], ['shadowOffsetY', 0]];
	
	function _default(orignalBrush) {
	  // version string can be: '11.0'
	  return env.browser.ie && env.browser.version >= 11 ? function () {
	    var clipPaths = this.__clipPaths;
	    var style = this.style;
	    var modified;
	
	    if (clipPaths) {
	      for (var i = 0; i < clipPaths.length; i++) {
	        var clipPath = clipPaths[i];
	        var shape = clipPath && clipPath.shape;
	        var type = clipPath && clipPath.type;
	
	        if (shape && (type === 'sector' && shape.startAngle === shape.endAngle || type === 'rect' && (!shape.width || !shape.height))) {
	          for (var j = 0; j < shadowTemp.length; j++) {
	            // It is save to put shadowTemp static, because shadowTemp
	            // will be all modified each item brush called.
	            shadowTemp[j][2] = style[shadowTemp[j][0]];
	            style[shadowTemp[j][0]] = shadowTemp[j][1];
	          }
	
	          modified = true;
	          break;
	        }
	      }
	    }
	
	    orignalBrush.apply(this, arguments);
	
	    if (modified) {
	      for (var j = 0; j < shadowTemp.length; j++) {
	        style[shadowTemp[j][0]] = shadowTemp[j][2];
	      }
	    }
	  } : orignalBrush;
	}
	
	module.exports = _default;

/***/ },
/* 1089 */
/***/ function(module, exports) {

	var SHADOW_PROPS = {
	  'shadowBlur': 1,
	  'shadowOffsetX': 1,
	  'shadowOffsetY': 1,
	  'textShadowBlur': 1,
	  'textShadowOffsetX': 1,
	  'textShadowOffsetY': 1,
	  'textBoxShadowBlur': 1,
	  'textBoxShadowOffsetX': 1,
	  'textBoxShadowOffsetY': 1
	};
	
	function _default(ctx, propName, value) {
	  if (SHADOW_PROPS.hasOwnProperty(propName)) {
	    return value *= ctx.dpr;
	  }
	
	  return value;
	}
	
	module.exports = _default;

/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	var smoothSpline = __webpack_require__(2288);
	
	var smoothBezier = __webpack_require__(2287);
	
	function buildPath(ctx, shape, closePath) {
	  var points = shape.points;
	  var smooth = shape.smooth;
	
	  if (points && points.length >= 2) {
	    if (smooth && smooth !== 'spline') {
	      var controlPoints = smoothBezier(points, smooth, closePath, shape.smoothConstraint);
	      ctx.moveTo(points[0][0], points[0][1]);
	      var len = points.length;
	
	      for (var i = 0; i < (closePath ? len : len - 1); i++) {
	        var cp1 = controlPoints[i * 2];
	        var cp2 = controlPoints[i * 2 + 1];
	        var p = points[(i + 1) % len];
	        ctx.bezierCurveTo(cp1[0], cp1[1], cp2[0], cp2[1], p[0], p[1]);
	      }
	    } else {
	      if (smooth === 'spline') {
	        points = smoothSpline(points, closePath);
	      }
	
	      ctx.moveTo(points[0][0], points[0][1]);
	
	      for (var i = 1, l = points.length; i < l; i++) {
	        ctx.lineTo(points[i][0], points[i][1]);
	      }
	    }
	
	    closePath && ctx.closePath();
	  }
	}
	
	exports.buildPath = buildPath;

/***/ },
/* 1091 */
/***/ function(module, exports) {

	/**
	 * @param {Object} ctx
	 * @param {Object} shape
	 * @param {number} shape.x
	 * @param {number} shape.y
	 * @param {number} shape.width
	 * @param {number} shape.height
	 * @param {number} shape.r
	 */
	function buildPath(ctx, shape) {
	  var x = shape.x;
	  var y = shape.y;
	  var width = shape.width;
	  var height = shape.height;
	  var r = shape.r;
	  var r1;
	  var r2;
	  var r3;
	  var r4; // Convert width and height to positive for better borderRadius
	
	  if (width < 0) {
	    x = x + width;
	    width = -width;
	  }
	
	  if (height < 0) {
	    y = y + height;
	    height = -height;
	  }
	
	  if (typeof r === 'number') {
	    r1 = r2 = r3 = r4 = r;
	  } else if (r instanceof Array) {
	    if (r.length === 1) {
	      r1 = r2 = r3 = r4 = r[0];
	    } else if (r.length === 2) {
	      r1 = r3 = r[0];
	      r2 = r4 = r[1];
	    } else if (r.length === 3) {
	      r1 = r[0];
	      r2 = r4 = r[1];
	      r3 = r[2];
	    } else {
	      r1 = r[0];
	      r2 = r[1];
	      r3 = r[2];
	      r4 = r[3];
	    }
	  } else {
	    r1 = r2 = r3 = r4 = 0;
	  }
	
	  var total;
	
	  if (r1 + r2 > width) {
	    total = r1 + r2;
	    r1 *= width / total;
	    r2 *= width / total;
	  }
	
	  if (r3 + r4 > width) {
	    total = r3 + r4;
	    r3 *= width / total;
	    r4 *= width / total;
	  }
	
	  if (r2 + r3 > height) {
	    total = r2 + r3;
	    r2 *= height / total;
	    r3 *= height / total;
	  }
	
	  if (r1 + r4 > height) {
	    total = r1 + r4;
	    r1 *= height / total;
	    r4 *= height / total;
	  }
	
	  ctx.moveTo(x + r1, y);
	  ctx.lineTo(x + width - r2, y);
	  r2 !== 0 && ctx.arc(x + width - r2, y + r2, r2, -Math.PI / 2, 0);
	  ctx.lineTo(x + width, y + height - r3);
	  r3 !== 0 && ctx.arc(x + width - r3, y + height - r3, r3, 0, Math.PI / 2);
	  ctx.lineTo(x + r4, y + height);
	  r4 !== 0 && ctx.arc(x + r4, y + height - r4, r4, Math.PI / 2, Math.PI);
	  ctx.lineTo(x, y + r1);
	  r1 !== 0 && ctx.arc(x + r1, y + r1, r1, Math.PI, Math.PI * 1.5);
	}
	
	exports.buildPath = buildPath;

/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	var textHelper = __webpack_require__(388);
	
	var BoundingRect = __webpack_require__(42);
	
	var _constant = __webpack_require__(387);
	
	var WILL_BE_RESTORED = _constant.WILL_BE_RESTORED;
	
	/**
	 * Mixin for drawing text in a element bounding rect
	 * @module zrender/mixin/RectText
	 */
	var tmpRect = new BoundingRect();
	
	var RectText = function () {};
	
	RectText.prototype = {
	  constructor: RectText,
	
	  /**
	   * Draw text in a rect with specified position.
	   * @param  {CanvasRenderingContext2D} ctx
	   * @param  {Object} rect Displayable rect
	   */
	  drawRectText: function (ctx, rect) {
	    var style = this.style;
	    rect = style.textRect || rect; // Optimize, avoid normalize every time.
	
	    this.__dirty && textHelper.normalizeTextStyle(style, true);
	    var text = style.text; // Convert to string
	
	    text != null && (text += '');
	
	    if (!textHelper.needDrawText(text, style)) {
	      return;
	    } // FIXME
	    // Do not provide prevEl to `textHelper.renderText` for ctx prop cache,
	    // but use `ctx.save()` and `ctx.restore()`. Because the cache for rect
	    // text propably break the cache for its host elements.
	
	
	    ctx.save(); // Transform rect to view space
	
	    var transform = this.transform;
	
	    if (!style.transformText) {
	      if (transform) {
	        tmpRect.copy(rect);
	        tmpRect.applyTransform(transform);
	        rect = tmpRect;
	      }
	    } else {
	      this.setTransform(ctx);
	    } // transformText and textRotation can not be used at the same time.
	
	
	    textHelper.renderText(this, ctx, text, style, rect, WILL_BE_RESTORED);
	    ctx.restore();
	  }
	};
	var _default = RectText;
	module.exports = _default;

/***/ },
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(46);
	
	/**
	 * 圆形
	 * @module zrender/shape/Circle
	 */
	var _default = Path.extend({
	  type: 'circle',
	  shape: {
	    cx: 0,
	    cy: 0,
	    r: 0
	  },
	  buildPath: function (ctx, shape, inBundle) {
	    // Better stroking in ShapeBundle
	    // Always do it may have performence issue ( fill may be 2x more cost)
	    if (inBundle) {
	      ctx.moveTo(shape.cx + shape.r, shape.cy);
	    } // else {
	    //     if (ctx.allocate && !ctx.data.length) {
	    //         ctx.allocate(ctx.CMD_MEM_SIZE.A);
	    //     }
	    // }
	    // Better stroking in ShapeBundle
	    // ctx.moveTo(shape.cx + shape.r, shape.cy);
	
	
	    ctx.arc(shape.cx, shape.cy, shape.r, 0, Math.PI * 2, true);
	  }
	});
	
	module.exports = _default;

/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(46);
	
	var _subPixelOptimize = __webpack_require__(560);
	
	var subPixelOptimizeLine = _subPixelOptimize.subPixelOptimizeLine;
	
	/**
	 * 直线
	 * @module zrender/graphic/shape/Line
	 */
	// Avoid create repeatly.
	var subPixelOptimizeOutputShape = {};
	
	var _default = Path.extend({
	  type: 'line',
	  shape: {
	    // Start point
	    x1: 0,
	    y1: 0,
	    // End point
	    x2: 0,
	    y2: 0,
	    percent: 1
	  },
	  style: {
	    stroke: '#000',
	    fill: null
	  },
	  buildPath: function (ctx, shape) {
	    var x1;
	    var y1;
	    var x2;
	    var y2;
	
	    if (this.subPixelOptimize) {
	      subPixelOptimizeLine(subPixelOptimizeOutputShape, shape, this.style);
	      x1 = subPixelOptimizeOutputShape.x1;
	      y1 = subPixelOptimizeOutputShape.y1;
	      x2 = subPixelOptimizeOutputShape.x2;
	      y2 = subPixelOptimizeOutputShape.y2;
	    } else {
	      x1 = shape.x1;
	      y1 = shape.y1;
	      x2 = shape.x2;
	      y2 = shape.y2;
	    }
	
	    var percent = shape.percent;
	
	    if (percent === 0) {
	      return;
	    }
	
	    ctx.moveTo(x1, y1);
	
	    if (percent < 1) {
	      x2 = x1 * (1 - percent) + x2 * percent;
	      y2 = y1 * (1 - percent) + y2 * percent;
	    }
	
	    ctx.lineTo(x2, y2);
	  },
	
	  /**
	   * Get point at percent
	   * @param  {number} percent
	   * @return {Array.<number>}
	   */
	  pointAt: function (p) {
	    var shape = this.shape;
	    return [shape.x1 * (1 - p) + shape.x2 * p, shape.y1 * (1 - p) + shape.y2 * p];
	  }
	});
	
	module.exports = _default;

/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(46);
	
	var polyHelper = __webpack_require__(1090);
	
	/**
	 * 多边形
	 * @module zrender/shape/Polygon
	 */
	var _default = Path.extend({
	  type: 'polygon',
	  shape: {
	    points: null,
	    smooth: false,
	    smoothConstraint: null
	  },
	  buildPath: function (ctx, shape) {
	    polyHelper.buildPath(ctx, shape, true);
	  }
	});
	
	module.exports = _default;

/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(46);
	
	var polyHelper = __webpack_require__(1090);
	
	/**
	 * @module zrender/graphic/shape/Polyline
	 */
	var _default = Path.extend({
	  type: 'polyline',
	  shape: {
	    points: null,
	    smooth: false,
	    smoothConstraint: null
	  },
	  style: {
	    stroke: '#000',
	    fill: null
	  },
	  buildPath: function (ctx, shape) {
	    polyHelper.buildPath(ctx, shape, false);
	  }
	});
	
	module.exports = _default;

/***/ },
/* 1097 */
/***/ function(module, exports, __webpack_require__) {

	var Group = __webpack_require__(187);
	
	var ZImage = __webpack_require__(232);
	
	var Text = __webpack_require__(188);
	
	var Circle = __webpack_require__(1093);
	
	var Rect = __webpack_require__(561);
	
	var Ellipse = __webpack_require__(2291);
	
	var Line = __webpack_require__(1094);
	
	var Path = __webpack_require__(46);
	
	var Polygon = __webpack_require__(1095);
	
	var Polyline = __webpack_require__(1096);
	
	var LinearGradient = __webpack_require__(557);
	
	var Style = __webpack_require__(558);
	
	var matrix = __webpack_require__(73);
	
	var _path = __webpack_require__(1098);
	
	var createFromString = _path.createFromString;
	
	var _util = __webpack_require__(3);
	
	var isString = _util.isString;
	var extend = _util.extend;
	var defaults = _util.defaults;
	var trim = _util.trim;
	var each = _util.each;
	// import RadialGradient from '../graphic/RadialGradient';
	// import Pattern from '../graphic/Pattern';
	// import * as vector from '../core/vector';
	// Most of the values can be separated by comma and/or white space.
	var DILIMITER_REG = /[\s,]+/;
	/**
	 * For big svg string, this method might be time consuming.
	 *
	 * @param {string} svg xml string
	 * @return {Object} xml root.
	 */
	
	function parseXML(svg) {
	  if (isString(svg)) {
	    var parser = new DOMParser();
	    svg = parser.parseFromString(svg, 'text/xml');
	  } // Document node. If using $.get, doc node may be input.
	
	
	  if (svg.nodeType === 9) {
	    svg = svg.firstChild;
	  } // nodeName of <!DOCTYPE svg> is also 'svg'.
	
	
	  while (svg.nodeName.toLowerCase() !== 'svg' || svg.nodeType !== 1) {
	    svg = svg.nextSibling;
	  }
	
	  return svg;
	}
	
	function SVGParser() {
	  this._defs = {};
	  this._root = null;
	  this._isDefine = false;
	  this._isText = false;
	}
	
	SVGParser.prototype.parse = function (xml, opt) {
	  opt = opt || {};
	  var svg = parseXML(xml);
	
	  if (!svg) {
	    throw new Error('Illegal svg');
	  }
	
	  var root = new Group();
	  this._root = root; // parse view port
	
	  var viewBox = svg.getAttribute('viewBox') || ''; // If width/height not specified, means "100%" of `opt.width/height`.
	  // TODO: Other percent value not supported yet.
	
	  var width = parseFloat(svg.getAttribute('width') || opt.width);
	  var height = parseFloat(svg.getAttribute('height') || opt.height); // If width/height not specified, set as null for output.
	
	  isNaN(width) && (width = null);
	  isNaN(height) && (height = null); // Apply inline style on svg element.
	
	  parseAttributes(svg, root, null, true);
	  var child = svg.firstChild;
	
	  while (child) {
	    this._parseNode(child, root);
	
	    child = child.nextSibling;
	  }
	
	  var viewBoxRect;
	  var viewBoxTransform;
	
	  if (viewBox) {
	    var viewBoxArr = trim(viewBox).split(DILIMITER_REG); // Some invalid case like viewBox: 'none'.
	
	    if (viewBoxArr.length >= 4) {
	      viewBoxRect = {
	        x: parseFloat(viewBoxArr[0] || 0),
	        y: parseFloat(viewBoxArr[1] || 0),
	        width: parseFloat(viewBoxArr[2]),
	        height: parseFloat(viewBoxArr[3])
	      };
	    }
	  }
	
	  if (viewBoxRect && width != null && height != null) {
	    viewBoxTransform = makeViewBoxTransform(viewBoxRect, width, height);
	
	    if (!opt.ignoreViewBox) {
	      // If set transform on the output group, it probably bring trouble when
	      // some users only intend to show the clipped content inside the viewBox,
	      // but not intend to transform the output group. So we keep the output
	      // group no transform. If the user intend to use the viewBox as a
	      // camera, just set `opt.ignoreViewBox` as `true` and set transfrom
	      // manually according to the viewBox info in the output of this method.
	      var elRoot = root;
	      root = new Group();
	      root.add(elRoot);
	      elRoot.scale = viewBoxTransform.scale.slice();
	      elRoot.position = viewBoxTransform.position.slice();
	    }
	  } // Some shapes might be overflow the viewport, which should be
	  // clipped despite whether the viewBox is used, as the SVG does.
	
	
	  if (!opt.ignoreRootClip && width != null && height != null) {
	    root.setClipPath(new Rect({
	      shape: {
	        x: 0,
	        y: 0,
	        width: width,
	        height: height
	      }
	    }));
	  } // Set width/height on group just for output the viewport size.
	
	
	  return {
	    root: root,
	    width: width,
	    height: height,
	    viewBoxRect: viewBoxRect,
	    viewBoxTransform: viewBoxTransform
	  };
	};
	
	SVGParser.prototype._parseNode = function (xmlNode, parentGroup) {
	  var nodeName = xmlNode.nodeName.toLowerCase(); // TODO
	  // support <style>...</style> in svg, where nodeName is 'style',
	  // CSS classes is defined globally wherever the style tags are declared.
	
	  if (nodeName === 'defs') {
	    // define flag
	    this._isDefine = true;
	  } else if (nodeName === 'text') {
	    this._isText = true;
	  }
	
	  var el;
	
	  if (this._isDefine) {
	    var parser = defineParsers[nodeName];
	
	    if (parser) {
	      var def = parser.call(this, xmlNode);
	      var id = xmlNode.getAttribute('id');
	
	      if (id) {
	        this._defs[id] = def;
	      }
	    }
	  } else {
	    var parser = nodeParsers[nodeName];
	
	    if (parser) {
	      el = parser.call(this, xmlNode, parentGroup);
	      parentGroup.add(el);
	    }
	  }
	
	  var child = xmlNode.firstChild;
	
	  while (child) {
	    if (child.nodeType === 1) {
	      this._parseNode(child, el);
	    } // Is text
	
	
	    if (child.nodeType === 3 && this._isText) {
	      this._parseText(child, el);
	    }
	
	    child = child.nextSibling;
	  } // Quit define
	
	
	  if (nodeName === 'defs') {
	    this._isDefine = false;
	  } else if (nodeName === 'text') {
	    this._isText = false;
	  }
	};
	
	SVGParser.prototype._parseText = function (xmlNode, parentGroup) {
	  if (xmlNode.nodeType === 1) {
	    var dx = xmlNode.getAttribute('dx') || 0;
	    var dy = xmlNode.getAttribute('dy') || 0;
	    this._textX += parseFloat(dx);
	    this._textY += parseFloat(dy);
	  }
	
	  var text = new Text({
	    style: {
	      text: xmlNode.textContent,
	      transformText: true
	    },
	    position: [this._textX || 0, this._textY || 0]
	  });
	  inheritStyle(parentGroup, text);
	  parseAttributes(xmlNode, text, this._defs);
	  var fontSize = text.style.fontSize;
	
	  if (fontSize && fontSize < 9) {
	    // PENDING
	    text.style.fontSize = 9;
	    text.scale = text.scale || [1, 1];
	    text.scale[0] *= fontSize / 9;
	    text.scale[1] *= fontSize / 9;
	  }
	
	  var rect = text.getBoundingRect();
	  this._textX += rect.width;
	  parentGroup.add(text);
	  return text;
	};
	
	var nodeParsers = {
	  'g': function (xmlNode, parentGroup) {
	    var g = new Group();
	    inheritStyle(parentGroup, g);
	    parseAttributes(xmlNode, g, this._defs);
	    return g;
	  },
	  'rect': function (xmlNode, parentGroup) {
	    var rect = new Rect();
	    inheritStyle(parentGroup, rect);
	    parseAttributes(xmlNode, rect, this._defs);
	    rect.setShape({
	      x: parseFloat(xmlNode.getAttribute('x') || 0),
	      y: parseFloat(xmlNode.getAttribute('y') || 0),
	      width: parseFloat(xmlNode.getAttribute('width') || 0),
	      height: parseFloat(xmlNode.getAttribute('height') || 0)
	    }); // console.log(xmlNode.getAttribute('transform'));
	    // console.log(rect.transform);
	
	    return rect;
	  },
	  'circle': function (xmlNode, parentGroup) {
	    var circle = new Circle();
	    inheritStyle(parentGroup, circle);
	    parseAttributes(xmlNode, circle, this._defs);
	    circle.setShape({
	      cx: parseFloat(xmlNode.getAttribute('cx') || 0),
	      cy: parseFloat(xmlNode.getAttribute('cy') || 0),
	      r: parseFloat(xmlNode.getAttribute('r') || 0)
	    });
	    return circle;
	  },
	  'line': function (xmlNode, parentGroup) {
	    var line = new Line();
	    inheritStyle(parentGroup, line);
	    parseAttributes(xmlNode, line, this._defs);
	    line.setShape({
	      x1: parseFloat(xmlNode.getAttribute('x1') || 0),
	      y1: parseFloat(xmlNode.getAttribute('y1') || 0),
	      x2: parseFloat(xmlNode.getAttribute('x2') || 0),
	      y2: parseFloat(xmlNode.getAttribute('y2') || 0)
	    });
	    return line;
	  },
	  'ellipse': function (xmlNode, parentGroup) {
	    var ellipse = new Ellipse();
	    inheritStyle(parentGroup, ellipse);
	    parseAttributes(xmlNode, ellipse, this._defs);
	    ellipse.setShape({
	      cx: parseFloat(xmlNode.getAttribute('cx') || 0),
	      cy: parseFloat(xmlNode.getAttribute('cy') || 0),
	      rx: parseFloat(xmlNode.getAttribute('rx') || 0),
	      ry: parseFloat(xmlNode.getAttribute('ry') || 0)
	    });
	    return ellipse;
	  },
	  'polygon': function (xmlNode, parentGroup) {
	    var points = xmlNode.getAttribute('points');
	
	    if (points) {
	      points = parsePoints(points);
	    }
	
	    var polygon = new Polygon({
	      shape: {
	        points: points || []
	      }
	    });
	    inheritStyle(parentGroup, polygon);
	    parseAttributes(xmlNode, polygon, this._defs);
	    return polygon;
	  },
	  'polyline': function (xmlNode, parentGroup) {
	    var path = new Path();
	    inheritStyle(parentGroup, path);
	    parseAttributes(xmlNode, path, this._defs);
	    var points = xmlNode.getAttribute('points');
	
	    if (points) {
	      points = parsePoints(points);
	    }
	
	    var polyline = new Polyline({
	      shape: {
	        points: points || []
	      }
	    });
	    return polyline;
	  },
	  'image': function (xmlNode, parentGroup) {
	    var img = new ZImage();
	    inheritStyle(parentGroup, img);
	    parseAttributes(xmlNode, img, this._defs);
	    img.setStyle({
	      image: xmlNode.getAttribute('xlink:href'),
	      x: xmlNode.getAttribute('x'),
	      y: xmlNode.getAttribute('y'),
	      width: xmlNode.getAttribute('width'),
	      height: xmlNode.getAttribute('height')
	    });
	    return img;
	  },
	  'text': function (xmlNode, parentGroup) {
	    var x = xmlNode.getAttribute('x') || 0;
	    var y = xmlNode.getAttribute('y') || 0;
	    var dx = xmlNode.getAttribute('dx') || 0;
	    var dy = xmlNode.getAttribute('dy') || 0;
	    this._textX = parseFloat(x) + parseFloat(dx);
	    this._textY = parseFloat(y) + parseFloat(dy);
	    var g = new Group();
	    inheritStyle(parentGroup, g);
	    parseAttributes(xmlNode, g, this._defs);
	    return g;
	  },
	  'tspan': function (xmlNode, parentGroup) {
	    var x = xmlNode.getAttribute('x');
	    var y = xmlNode.getAttribute('y');
	
	    if (x != null) {
	      // new offset x
	      this._textX = parseFloat(x);
	    }
	
	    if (y != null) {
	      // new offset y
	      this._textY = parseFloat(y);
	    }
	
	    var dx = xmlNode.getAttribute('dx') || 0;
	    var dy = xmlNode.getAttribute('dy') || 0;
	    var g = new Group();
	    inheritStyle(parentGroup, g);
	    parseAttributes(xmlNode, g, this._defs);
	    this._textX += dx;
	    this._textY += dy;
	    return g;
	  },
	  'path': function (xmlNode, parentGroup) {
	    // TODO svg fill rule
	    // https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/fill-rule
	    // path.style.globalCompositeOperation = 'xor';
	    var d = xmlNode.getAttribute('d') || ''; // Performance sensitive.
	
	    var path = createFromString(d);
	    inheritStyle(parentGroup, path);
	    parseAttributes(xmlNode, path, this._defs);
	    return path;
	  }
	};
	var defineParsers = {
	  'lineargradient': function (xmlNode) {
	    var x1 = parseInt(xmlNode.getAttribute('x1') || 0, 10);
	    var y1 = parseInt(xmlNode.getAttribute('y1') || 0, 10);
	    var x2 = parseInt(xmlNode.getAttribute('x2') || 10, 10);
	    var y2 = parseInt(xmlNode.getAttribute('y2') || 0, 10);
	    var gradient = new LinearGradient(x1, y1, x2, y2);
	
	    _parseGradientColorStops(xmlNode, gradient);
	
	    return gradient;
	  },
	  'radialgradient': function (xmlNode) {}
	};
	
	function _parseGradientColorStops(xmlNode, gradient) {
	  var stop = xmlNode.firstChild;
	
	  while (stop) {
	    if (stop.nodeType === 1) {
	      var offset = stop.getAttribute('offset');
	
	      if (offset.indexOf('%') > 0) {
	        // percentage
	        offset = parseInt(offset, 10) / 100;
	      } else if (offset) {
	        // number from 0 to 1
	        offset = parseFloat(offset);
	      } else {
	        offset = 0;
	      }
	
	      var stopColor = stop.getAttribute('stop-color') || '#000000';
	      gradient.addColorStop(offset, stopColor);
	    }
	
	    stop = stop.nextSibling;
	  }
	}
	
	function inheritStyle(parent, child) {
	  if (parent && parent.__inheritedStyle) {
	    if (!child.__inheritedStyle) {
	      child.__inheritedStyle = {};
	    }
	
	    defaults(child.__inheritedStyle, parent.__inheritedStyle);
	  }
	}
	
	function parsePoints(pointsString) {
	  var list = trim(pointsString).split(DILIMITER_REG);
	  var points = [];
	
	  for (var i = 0; i < list.length; i += 2) {
	    var x = parseFloat(list[i]);
	    var y = parseFloat(list[i + 1]);
	    points.push([x, y]);
	  }
	
	  return points;
	}
	
	var attributesMap = {
	  'fill': 'fill',
	  'stroke': 'stroke',
	  'stroke-width': 'lineWidth',
	  'opacity': 'opacity',
	  'fill-opacity': 'fillOpacity',
	  'stroke-opacity': 'strokeOpacity',
	  'stroke-dasharray': 'lineDash',
	  'stroke-dashoffset': 'lineDashOffset',
	  'stroke-linecap': 'lineCap',
	  'stroke-linejoin': 'lineJoin',
	  'stroke-miterlimit': 'miterLimit',
	  'font-family': 'fontFamily',
	  'font-size': 'fontSize',
	  'font-style': 'fontStyle',
	  'font-weight': 'fontWeight',
	  'text-align': 'textAlign',
	  'alignment-baseline': 'textBaseline'
	};
	
	function parseAttributes(xmlNode, el, defs, onlyInlineStyle) {
	  var zrStyle = el.__inheritedStyle || {};
	  var isTextEl = el.type === 'text'; // TODO Shadow
	
	  if (xmlNode.nodeType === 1) {
	    parseTransformAttribute(xmlNode, el);
	    extend(zrStyle, parseStyleAttribute(xmlNode));
	
	    if (!onlyInlineStyle) {
	      for (var svgAttrName in attributesMap) {
	        if (attributesMap.hasOwnProperty(svgAttrName)) {
	          var attrValue = xmlNode.getAttribute(svgAttrName);
	
	          if (attrValue != null) {
	            zrStyle[attributesMap[svgAttrName]] = attrValue;
	          }
	        }
	      }
	    }
	  }
	
	  var elFillProp = isTextEl ? 'textFill' : 'fill';
	  var elStrokeProp = isTextEl ? 'textStroke' : 'stroke';
	  el.style = el.style || new Style();
	  var elStyle = el.style;
	  zrStyle.fill != null && elStyle.set(elFillProp, getPaint(zrStyle.fill, defs));
	  zrStyle.stroke != null && elStyle.set(elStrokeProp, getPaint(zrStyle.stroke, defs));
	  each(['lineWidth', 'opacity', 'fillOpacity', 'strokeOpacity', 'miterLimit', 'fontSize'], function (propName) {
	    var elPropName = propName === 'lineWidth' && isTextEl ? 'textStrokeWidth' : propName;
	    zrStyle[propName] != null && elStyle.set(elPropName, parseFloat(zrStyle[propName]));
	  });
	
	  if (!zrStyle.textBaseline || zrStyle.textBaseline === 'auto') {
	    zrStyle.textBaseline = 'alphabetic';
	  }
	
	  if (zrStyle.textBaseline === 'alphabetic') {
	    zrStyle.textBaseline = 'bottom';
	  }
	
	  if (zrStyle.textAlign === 'start') {
	    zrStyle.textAlign = 'left';
	  }
	
	  if (zrStyle.textAlign === 'end') {
	    zrStyle.textAlign = 'right';
	  }
	
	  each(['lineDashOffset', 'lineCap', 'lineJoin', 'fontWeight', 'fontFamily', 'fontStyle', 'textAlign', 'textBaseline'], function (propName) {
	    zrStyle[propName] != null && elStyle.set(propName, zrStyle[propName]);
	  });
	
	  if (zrStyle.lineDash) {
	    el.style.lineDash = trim(zrStyle.lineDash).split(DILIMITER_REG);
	  }
	
	  if (elStyle[elStrokeProp] && elStyle[elStrokeProp] !== 'none') {
	    // enable stroke
	    el[elStrokeProp] = true;
	  }
	
	  el.__inheritedStyle = zrStyle;
	}
	
	var urlRegex = /url\(\s*#(.*?)\)/;
	
	function getPaint(str, defs) {
	  // if (str === 'none') {
	  //     return;
	  // }
	  var urlMatch = defs && str && str.match(urlRegex);
	
	  if (urlMatch) {
	    var url = trim(urlMatch[1]);
	    var def = defs[url];
	    return def;
	  }
	
	  return str;
	}
	
	var transformRegex = /(translate|scale|rotate|skewX|skewY|matrix)\(([\-\s0-9\.e,]*)\)/g;
	
	function parseTransformAttribute(xmlNode, node) {
	  var transform = xmlNode.getAttribute('transform');
	
	  if (transform) {
	    transform = transform.replace(/,/g, ' ');
	    var m = null;
	    var transformOps = [];
	    transform.replace(transformRegex, function (str, type, value) {
	      transformOps.push(type, value);
	    });
	
	    for (var i = transformOps.length - 1; i > 0; i -= 2) {
	      var value = transformOps[i];
	      var type = transformOps[i - 1];
	      m = m || matrix.create();
	
	      switch (type) {
	        case 'translate':
	          value = trim(value).split(DILIMITER_REG);
	          matrix.translate(m, m, [parseFloat(value[0]), parseFloat(value[1] || 0)]);
	          break;
	
	        case 'scale':
	          value = trim(value).split(DILIMITER_REG);
	          matrix.scale(m, m, [parseFloat(value[0]), parseFloat(value[1] || value[0])]);
	          break;
	
	        case 'rotate':
	          value = trim(value).split(DILIMITER_REG);
	          matrix.rotate(m, m, parseFloat(value[0]));
	          break;
	
	        case 'skew':
	          value = trim(value).split(DILIMITER_REG);
	          console.warn('Skew transform is not supported yet');
	          break;
	
	        case 'matrix':
	          var value = trim(value).split(DILIMITER_REG);
	          m[0] = parseFloat(value[0]);
	          m[1] = parseFloat(value[1]);
	          m[2] = parseFloat(value[2]);
	          m[3] = parseFloat(value[3]);
	          m[4] = parseFloat(value[4]);
	          m[5] = parseFloat(value[5]);
	          break;
	      }
	    }
	
	    node.setLocalTransform(m);
	  }
	} // Value may contain space.
	
	
	var styleRegex = /([^\s:;]+)\s*:\s*([^:;]+)/g;
	
	function parseStyleAttribute(xmlNode) {
	  var style = xmlNode.getAttribute('style');
	  var result = {};
	
	  if (!style) {
	    return result;
	  }
	
	  var styleList = {};
	  styleRegex.lastIndex = 0;
	  var styleRegResult;
	
	  while ((styleRegResult = styleRegex.exec(style)) != null) {
	    styleList[styleRegResult[1]] = styleRegResult[2];
	  }
	
	  for (var svgAttrName in attributesMap) {
	    if (attributesMap.hasOwnProperty(svgAttrName) && styleList[svgAttrName] != null) {
	      result[attributesMap[svgAttrName]] = styleList[svgAttrName];
	    }
	  }
	
	  return result;
	}
	/**
	 * @param {Array.<number>} viewBoxRect
	 * @param {number} width
	 * @param {number} height
	 * @return {Object} {scale, position}
	 */
	
	
	function makeViewBoxTransform(viewBoxRect, width, height) {
	  var scaleX = width / viewBoxRect.width;
	  var scaleY = height / viewBoxRect.height;
	  var scale = Math.min(scaleX, scaleY); // preserveAspectRatio 'xMidYMid'
	
	  var viewBoxScale = [scale, scale];
	  var viewBoxPosition = [-(viewBoxRect.x + viewBoxRect.width / 2) * scale + width / 2, -(viewBoxRect.y + viewBoxRect.height / 2) * scale + height / 2];
	  return {
	    scale: viewBoxScale,
	    position: viewBoxPosition
	  };
	}
	/**
	 * @param {string|XMLElement} xml
	 * @param {Object} [opt]
	 * @param {number} [opt.width] Default width if svg width not specified or is a percent value.
	 * @param {number} [opt.height] Default height if svg height not specified or is a percent value.
	 * @param {boolean} [opt.ignoreViewBox]
	 * @param {boolean} [opt.ignoreRootClip]
	 * @return {Object} result:
	 * {
	 *     root: Group, The root of the the result tree of zrender shapes,
	 *     width: number, the viewport width of the SVG,
	 *     height: number, the viewport height of the SVG,
	 *     viewBoxRect: {x, y, width, height}, the declared viewBox rect of the SVG, if exists,
	 *     viewBoxTransform: the {scale, position} calculated by viewBox and viewport, is exists.
	 * }
	 */
	
	
	function parseSVG(xml, opt) {
	  var parser = new SVGParser();
	  return parser.parse(xml, opt);
	}
	
	exports.parseXML = parseXML;
	exports.makeViewBoxTransform = makeViewBoxTransform;
	exports.parseSVG = parseSVG;

/***/ },
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(46);
	
	var PathProxy = __webpack_require__(231);
	
	var transformPath = __webpack_require__(2301);
	
	// command chars
	// var cc = [
	//     'm', 'M', 'l', 'L', 'v', 'V', 'h', 'H', 'z', 'Z',
	//     'c', 'C', 'q', 'Q', 't', 'T', 's', 'S', 'a', 'A'
	// ];
	var mathSqrt = Math.sqrt;
	var mathSin = Math.sin;
	var mathCos = Math.cos;
	var PI = Math.PI;
	
	var vMag = function (v) {
	  return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
	};
	
	var vRatio = function (u, v) {
	  return (u[0] * v[0] + u[1] * v[1]) / (vMag(u) * vMag(v));
	};
	
	var vAngle = function (u, v) {
	  return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos(vRatio(u, v));
	};
	
	function processArc(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg, cmd, path) {
	  var psi = psiDeg * (PI / 180.0);
	  var xp = mathCos(psi) * (x1 - x2) / 2.0 + mathSin(psi) * (y1 - y2) / 2.0;
	  var yp = -1 * mathSin(psi) * (x1 - x2) / 2.0 + mathCos(psi) * (y1 - y2) / 2.0;
	  var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
	
	  if (lambda > 1) {
	    rx *= mathSqrt(lambda);
	    ry *= mathSqrt(lambda);
	  }
	
	  var f = (fa === fs ? -1 : 1) * mathSqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp))) || 0;
	  var cxp = f * rx * yp / ry;
	  var cyp = f * -ry * xp / rx;
	  var cx = (x1 + x2) / 2.0 + mathCos(psi) * cxp - mathSin(psi) * cyp;
	  var cy = (y1 + y2) / 2.0 + mathSin(psi) * cxp + mathCos(psi) * cyp;
	  var theta = vAngle([1, 0], [(xp - cxp) / rx, (yp - cyp) / ry]);
	  var u = [(xp - cxp) / rx, (yp - cyp) / ry];
	  var v = [(-1 * xp - cxp) / rx, (-1 * yp - cyp) / ry];
	  var dTheta = vAngle(u, v);
	
	  if (vRatio(u, v) <= -1) {
	    dTheta = PI;
	  }
	
	  if (vRatio(u, v) >= 1) {
	    dTheta = 0;
	  }
	
	  if (fs === 0 && dTheta > 0) {
	    dTheta = dTheta - 2 * PI;
	  }
	
	  if (fs === 1 && dTheta < 0) {
	    dTheta = dTheta + 2 * PI;
	  }
	
	  path.addData(cmd, cx, cy, rx, ry, theta, dTheta, psi, fs);
	}
	
	var commandReg = /([mlvhzcqtsa])([^mlvhzcqtsa]*)/ig; // Consider case:
	// (1) delimiter can be comma or space, where continuous commas
	// or spaces should be seen as one comma.
	// (2) value can be like:
	// '2e-4', 'l.5.9' (ignore 0), 'M-10-10', 'l-2.43e-1,34.9983',
	// 'l-.5E1,54', '121-23-44-11' (no delimiter)
	
	var numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g; // var valueSplitReg = /[\s,]+/;
	
	function createPathProxyFromString(data) {
	  if (!data) {
	    return new PathProxy();
	  } // var data = data.replace(/-/g, ' -')
	  //     .replace(/  /g, ' ')
	  //     .replace(/ /g, ',')
	  //     .replace(/,,/g, ',');
	  // var n;
	  // create pipes so that we can split the data
	  // for (n = 0; n < cc.length; n++) {
	  //     cs = cs.replace(new RegExp(cc[n], 'g'), '|' + cc[n]);
	  // }
	  // data = data.replace(/-/g, ',-');
	  // create array
	  // var arr = cs.split('|');
	  // init context point
	
	
	  var cpx = 0;
	  var cpy = 0;
	  var subpathX = cpx;
	  var subpathY = cpy;
	  var prevCmd;
	  var path = new PathProxy();
	  var CMD = PathProxy.CMD; // commandReg.lastIndex = 0;
	  // var cmdResult;
	  // while ((cmdResult = commandReg.exec(data)) != null) {
	  //     var cmdStr = cmdResult[1];
	  //     var cmdContent = cmdResult[2];
	
	  var cmdList = data.match(commandReg);
	
	  for (var l = 0; l < cmdList.length; l++) {
	    var cmdText = cmdList[l];
	    var cmdStr = cmdText.charAt(0);
	    var cmd; // String#split is faster a little bit than String#replace or RegExp#exec.
	    // var p = cmdContent.split(valueSplitReg);
	    // var pLen = 0;
	    // for (var i = 0; i < p.length; i++) {
	    //     // '' and other invalid str => NaN
	    //     var val = parseFloat(p[i]);
	    //     !isNaN(val) && (p[pLen++] = val);
	    // }
	
	    var p = cmdText.match(numberReg) || [];
	    var pLen = p.length;
	
	    for (var i = 0; i < pLen; i++) {
	      p[i] = parseFloat(p[i]);
	    }
	
	    var off = 0;
	
	    while (off < pLen) {
	      var ctlPtx;
	      var ctlPty;
	      var rx;
	      var ry;
	      var psi;
	      var fa;
	      var fs;
	      var x1 = cpx;
	      var y1 = cpy; // convert l, H, h, V, and v to L
	
	      switch (cmdStr) {
	        case 'l':
	          cpx += p[off++];
	          cpy += p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'L':
	          cpx = p[off++];
	          cpy = p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'm':
	          cpx += p[off++];
	          cpy += p[off++];
	          cmd = CMD.M;
	          path.addData(cmd, cpx, cpy);
	          subpathX = cpx;
	          subpathY = cpy;
	          cmdStr = 'l';
	          break;
	
	        case 'M':
	          cpx = p[off++];
	          cpy = p[off++];
	          cmd = CMD.M;
	          path.addData(cmd, cpx, cpy);
	          subpathX = cpx;
	          subpathY = cpy;
	          cmdStr = 'L';
	          break;
	
	        case 'h':
	          cpx += p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'H':
	          cpx = p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'v':
	          cpy += p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'V':
	          cpy = p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'C':
	          cmd = CMD.C;
	          path.addData(cmd, p[off++], p[off++], p[off++], p[off++], p[off++], p[off++]);
	          cpx = p[off - 2];
	          cpy = p[off - 1];
	          break;
	
	        case 'c':
	          cmd = CMD.C;
	          path.addData(cmd, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy);
	          cpx += p[off - 2];
	          cpy += p[off - 1];
	          break;
	
	        case 'S':
	          ctlPtx = cpx;
	          ctlPty = cpy;
	          var len = path.len();
	          var pathData = path.data;
	
	          if (prevCmd === CMD.C) {
	            ctlPtx += cpx - pathData[len - 4];
	            ctlPty += cpy - pathData[len - 3];
	          }
	
	          cmd = CMD.C;
	          x1 = p[off++];
	          y1 = p[off++];
	          cpx = p[off++];
	          cpy = p[off++];
	          path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
	          break;
	
	        case 's':
	          ctlPtx = cpx;
	          ctlPty = cpy;
	          var len = path.len();
	          var pathData = path.data;
	
	          if (prevCmd === CMD.C) {
	            ctlPtx += cpx - pathData[len - 4];
	            ctlPty += cpy - pathData[len - 3];
	          }
	
	          cmd = CMD.C;
	          x1 = cpx + p[off++];
	          y1 = cpy + p[off++];
	          cpx += p[off++];
	          cpy += p[off++];
	          path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
	          break;
	
	        case 'Q':
	          x1 = p[off++];
	          y1 = p[off++];
	          cpx = p[off++];
	          cpy = p[off++];
	          cmd = CMD.Q;
	          path.addData(cmd, x1, y1, cpx, cpy);
	          break;
	
	        case 'q':
	          x1 = p[off++] + cpx;
	          y1 = p[off++] + cpy;
	          cpx += p[off++];
	          cpy += p[off++];
	          cmd = CMD.Q;
	          path.addData(cmd, x1, y1, cpx, cpy);
	          break;
	
	        case 'T':
	          ctlPtx = cpx;
	          ctlPty = cpy;
	          var len = path.len();
	          var pathData = path.data;
	
	          if (prevCmd === CMD.Q) {
	            ctlPtx += cpx - pathData[len - 4];
	            ctlPty += cpy - pathData[len - 3];
	          }
	
	          cpx = p[off++];
	          cpy = p[off++];
	          cmd = CMD.Q;
	          path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
	          break;
	
	        case 't':
	          ctlPtx = cpx;
	          ctlPty = cpy;
	          var len = path.len();
	          var pathData = path.data;
	
	          if (prevCmd === CMD.Q) {
	            ctlPtx += cpx - pathData[len - 4];
	            ctlPty += cpy - pathData[len - 3];
	          }
	
	          cpx += p[off++];
	          cpy += p[off++];
	          cmd = CMD.Q;
	          path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
	          break;
	
	        case 'A':
	          rx = p[off++];
	          ry = p[off++];
	          psi = p[off++];
	          fa = p[off++];
	          fs = p[off++];
	          x1 = cpx, y1 = cpy;
	          cpx = p[off++];
	          cpy = p[off++];
	          cmd = CMD.A;
	          processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
	          break;
	
	        case 'a':
	          rx = p[off++];
	          ry = p[off++];
	          psi = p[off++];
	          fa = p[off++];
	          fs = p[off++];
	          x1 = cpx, y1 = cpy;
	          cpx += p[off++];
	          cpy += p[off++];
	          cmd = CMD.A;
	          processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
	          break;
	      }
	    }
	
	    if (cmdStr === 'z' || cmdStr === 'Z') {
	      cmd = CMD.Z;
	      path.addData(cmd); // z may be in the middle of the path.
	
	      cpx = subpathX;
	      cpy = subpathY;
	    }
	
	    prevCmd = cmd;
	  }
	
	  path.toStatic();
	  return path;
	} // TODO Optimize double memory cost problem
	
	
	function createPathOptions(str, opts) {
	  var pathProxy = createPathProxyFromString(str);
	  opts = opts || {};
	
	  opts.buildPath = function (path) {
	    if (path.setData) {
	      path.setData(pathProxy.data); // Svg and vml renderer don't have context
	
	      var ctx = path.getContext();
	
	      if (ctx) {
	        path.rebuildPath(ctx);
	      }
	    } else {
	      var ctx = path;
	      pathProxy.rebuildPath(ctx);
	    }
	  };
	
	  opts.applyTransform = function (m) {
	    transformPath(pathProxy, m);
	    this.dirty(true);
	  };
	
	  return opts;
	}
	/**
	 * Create a Path object from path string data
	 * http://www.w3.org/TR/SVG/paths.html#PathData
	 * @param  {Object} opts Other options
	 */
	
	
	function createFromString(str, opts) {
	  return new Path(createPathOptions(str, opts));
	}
	/**
	 * Create a Path class from path string data
	 * @param  {string} str
	 * @param  {Object} opts Other options
	 */
	
	
	function extendFromString(str, opts) {
	  return Path.extend(createPathOptions(str, opts));
	}
	/**
	 * Merge multiple paths
	 */
	// TODO Apply transform
	// TODO stroke dash
	// TODO Optimize double memory cost problem
	
	
	function mergePath(pathEls, opts) {
	  var pathList = [];
	  var len = pathEls.length;
	
	  for (var i = 0; i < len; i++) {
	    var pathEl = pathEls[i];
	
	    if (!pathEl.path) {
	      pathEl.createPathProxy();
	    }
	
	    if (pathEl.__dirtyPath) {
	      pathEl.buildPath(pathEl.path, pathEl.shape, true);
	    }
	
	    pathList.push(pathEl.path);
	  }
	
	  var pathBundle = new Path(opts); // Need path proxy.
	
	  pathBundle.createPathProxy();
	
	  pathBundle.buildPath = function (path) {
	    path.appendPath(pathList); // Svg and vml renderer don't have context
	
	    var ctx = path.getContext();
	
	    if (ctx) {
	      path.rebuildPath(ctx);
	    }
	  };
	
	  return pathBundle;
	}
	
	exports.createFromString = createFromString;
	exports.extendFromString = extendFromString;
	exports.mergePath = mergePath;

/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	var env = __webpack_require__(55);
	
	var urn = 'urn:schemas-microsoft-com:vml';
	var win = typeof window === 'undefined' ? null : window;
	var vmlInited = false;
	var doc = win && win.document;
	
	function createNode(tagName) {
	  return doCreateNode(tagName);
	} // Avoid assign to an exported variable, for transforming to cjs.
	
	
	var doCreateNode;
	
	if (doc && !env.canvasSupported) {
	  try {
	    !doc.namespaces.zrvml && doc.namespaces.add('zrvml', urn);
	
	    doCreateNode = function (tagName) {
	      return doc.createElement('<zrvml:' + tagName + ' class="zrvml">');
	    };
	  } catch (e) {
	    doCreateNode = function (tagName) {
	      return doc.createElement('<' + tagName + ' xmlns="' + urn + '" class="zrvml">');
	    };
	  }
	} // From raphael
	
	
	function initVML() {
	  if (vmlInited || !doc) {
	    return;
	  }
	
	  vmlInited = true;
	  var styleSheets = doc.styleSheets;
	
	  if (styleSheets.length < 31) {
	    doc.createStyleSheet().addRule('.zrvml', 'behavior:url(#default#VML)');
	  } else {
	    // http://msdn.microsoft.com/en-us/library/ms531194%28VS.85%29.aspx
	    styleSheets[0].addRule('.zrvml', 'behavior:url(#default#VML)');
	  }
	}
	
	exports.doc = doc;
	exports.createNode = createNode;
	exports.initVML = initVML;

/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeToArray = __webpack_require__(565);
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return arrayLikeToArray(arr);
	}
	
	module.exports = _arrayWithoutHoles;

/***/ },
/* 1101 */
/***/ function(module, exports) {

	function _getPrototypeOf(o) {
	  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf(o);
	}
	
	module.exports = _getPrototypeOf;

/***/ },
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(1107);
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) setPrototypeOf(subClass, superClass);
	}
	
	module.exports = _inherits;

/***/ },
/* 1103 */
/***/ function(module, exports) {

	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	module.exports = _inheritsLoose;

/***/ },
/* 1104 */
/***/ function(module, exports) {

	function _iterableToArrayLimit(arr, i) {
	  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
	  var _arr = [];
	  var _n = true;
	  var _d = false;
	  var _e = undefined;
	
	  try {
	    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);
	
	      if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;
	    _e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }
	
	  return _arr;
	}
	
	module.exports = _iterableToArrayLimit;

/***/ },
/* 1105 */
/***/ function(module, exports) {

	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	module.exports = _nonIterableSpread;

/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(153);
	
	var assertThisInitialized = __webpack_require__(567);
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }
	
	  return assertThisInitialized(self);
	}
	
	module.exports = _possibleConstructorReturn;

/***/ },
/* 1107 */
/***/ function(module, exports) {

	function _setPrototypeOf(o, p) {
	  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	module.exports = _setPrototypeOf;

/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _toArray2 = _interopRequireDefault(__webpack_require__(571));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(80));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactIs = __webpack_require__(72);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _utils = __webpack_require__(19);
	
	var _Collapse = _interopRequireDefault(__webpack_require__(296));
	
	var _Paper = _interopRequireDefault(__webpack_require__(89));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _AccordionContext = _interopRequireDefault(__webpack_require__(572));
	
	var _useControlled3 = _interopRequireDefault(__webpack_require__(133));
	
	var styles = function styles(theme) {
	  var transition = {
	    duration: theme.transitions.duration.shortest
	  };
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      transition: theme.transitions.create(['margin'], transition),
	      '&:before': {
	        position: 'absolute',
	        left: 0,
	        top: -1,
	        right: 0,
	        height: 1,
	        content: '""',
	        opacity: 1,
	        backgroundColor: theme.palette.divider,
	        transition: theme.transitions.create(['opacity', 'background-color'], transition)
	      },
	      '&:first-child': {
	        '&:before': {
	          display: 'none'
	        }
	      },
	      '&$expanded': {
	        margin: '16px 0',
	        '&:first-child': {
	          marginTop: 0
	        },
	        '&:last-child': {
	          marginBottom: 0
	        },
	        '&:before': {
	          opacity: 0
	        }
	      },
	      '&$expanded + &': {
	        '&:before': {
	          display: 'none'
	        }
	      },
	      '&$disabled': {
	        backgroundColor: theme.palette.action.disabledBackground
	      }
	    },
	
	    /* Styles applied to the root element if `square={false}`. */
	    rounded: {
	      borderRadius: 0,
	      '&:first-child': {
	        borderTopLeftRadius: theme.shape.borderRadius,
	        borderTopRightRadius: theme.shape.borderRadius
	      },
	      '&:last-child': {
	        borderBottomLeftRadius: theme.shape.borderRadius,
	        borderBottomRightRadius: theme.shape.borderRadius,
	        // Fix a rendering issue on Edge
	        '@supports (-ms-ime-align: auto)': {
	          borderBottomLeftRadius: 0,
	          borderBottomRightRadius: 0
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `expanded={true}`. */
	    expanded: {},
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {}
	  };
	};
	
	exports.styles = styles;
	var Accordion = /*#__PURE__*/React.forwardRef(function Accordion(props, ref) {
	  var childrenProp = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$defaultExpande = props.defaultExpanded,
	      defaultExpanded = _props$defaultExpande === void 0 ? false : _props$defaultExpande,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      expandedProp = props.expanded,
	      onChange = props.onChange,
	      _props$square = props.square,
	      square = _props$square === void 0 ? false : _props$square,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Collapse.default : _props$TransitionComp,
	      TransitionProps = props.TransitionProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "defaultExpanded", "disabled", "expanded", "onChange", "square", "TransitionComponent", "TransitionProps"]);
	
	  var _useControlled = (0, _useControlled3.default)({
	    controlled: expandedProp,
	    default: defaultExpanded,
	    name: 'Accordion',
	    state: 'expanded'
	  }),
	      _useControlled2 = (0, _slicedToArray2.default)(_useControlled, 2),
	      expanded = _useControlled2[0],
	      setExpandedState = _useControlled2[1];
	
	  var handleChange = React.useCallback(function (event) {
	    setExpandedState(!expanded);
	
	    if (onChange) {
	      onChange(event, !expanded);
	    }
	  }, [expanded, onChange, setExpandedState]);
	
	  var _React$Children$toArr = React.Children.toArray(childrenProp),
	      _React$Children$toArr2 = (0, _toArray2.default)(_React$Children$toArr),
	      summary = _React$Children$toArr2[0],
	      children = _React$Children$toArr2.slice(1);
	
	  var contextValue = React.useMemo(function () {
	    return {
	      expanded: expanded,
	      disabled: disabled,
	      toggle: handleChange
	    };
	  }, [expanded, disabled, handleChange]);
	  return /*#__PURE__*/React.createElement(_Paper.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, expanded && classes.expanded, disabled && classes.disabled, !square && classes.rounded),
	    ref: ref,
	    square: square
	  }, other), /*#__PURE__*/React.createElement(_AccordionContext.default.Provider, {
	    value: contextValue
	  }, summary), /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    in: expanded,
	    timeout: "auto"
	  }, TransitionProps), /*#__PURE__*/React.createElement("div", {
	    "aria-labelledby": summary.props.id,
	    id: summary.props['aria-controls'],
	    role: "region"
	  }, children)));
	});
	 false ? Accordion.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the accordion.
	   */
	  children: (0, _utils.chainPropTypes)(_propTypes.default.node.isRequired, function (props) {
	    var summary = React.Children.toArray(props.children)[0];
	
	    if ((0, _reactIs.isFragment)(summary)) {
	      return new Error("Material-UI: The Accordion doesn't accept a Fragment as a child. " + 'Consider providing an array instead.');
	    }
	
	    if (! /*#__PURE__*/React.isValidElement(summary)) {
	      return new Error('Material-UI: Expected the first child of Accordion to be a valid element.');
	    }
	
	    return null;
	  }),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, expands the accordion by default.
	   */
	  defaultExpanded: _propTypes.default.bool,
	
	  /**
	   * If `true`, the accordion will be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, expands the accordion, otherwise collapse it.
	   * Setting this prop enables control over the accordion.
	   */
	  expanded: _propTypes.default.bool,
	
	  /**
	   * Callback fired when the expand/collapse state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {boolean} expanded The `expanded` state of the accordion.
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * If `true`, rounded corners are disabled.
	   */
	  square: _propTypes.default.bool,
	
	  /**
	   * The component used for the collapse effect.
	   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
	   */
	  TransitionComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
	   */
	  TransitionProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiAccordion'
	})(Accordion);
	
	exports.default = _default;

/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Accordion.default;
	  }
	});
	
	var _Accordion = _interopRequireDefault(__webpack_require__(1108));

/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    alignItems: 'center',
	    padding: 8,
	    justifyContent: 'flex-end'
	  },
	
	  /* Styles applied to the root element if `disableSpacing={false}`. */
	  spacing: {
	    '& > :not(:first-child)': {
	      marginLeft: 8
	    }
	  }
	};
	exports.styles = styles;
	var AccordionActions = /*#__PURE__*/React.forwardRef(function AccordionActions(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$disableSpacing = props.disableSpacing,
	      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "disableSpacing"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, !disableSpacing && classes.spacing),
	    ref: ref
	  }, other));
	});
	 false ? AccordionActions.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the actions do not have additional margin.
	   */
	  disableSpacing: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiAccordionActions'
	})(AccordionActions);
	
	exports.default = _default;

/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _AccordionActions.default;
	  }
	});
	
	var _AccordionActions = _interopRequireDefault(__webpack_require__(1110));

/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'flex',
	      padding: theme.spacing(1, 2, 2)
	    }
	  };
	};
	
	exports.styles = styles;
	var AccordionDetails = /*#__PURE__*/React.forwardRef(function AccordionDetails(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other));
	});
	 false ? AccordionDetails.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the accordion details.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiAccordionDetails'
	})(AccordionDetails);
	
	exports.default = _default;

/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _AccordionDetails.default;
	  }
	});
	
	var _AccordionDetails = _interopRequireDefault(__webpack_require__(1112));

/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(69));
	
	var _IconButton = _interopRequireDefault(__webpack_require__(236));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _AccordionContext = _interopRequireDefault(__webpack_require__(572));
	
	/* eslint-disable jsx-a11y/aria-role */
	var styles = function styles(theme) {
	  var transition = {
	    duration: theme.transitions.duration.shortest
	  };
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'flex',
	      minHeight: 8 * 6,
	      transition: theme.transitions.create(['min-height', 'background-color'], transition),
	      padding: theme.spacing(0, 2),
	      '&:hover:not($disabled)': {
	        cursor: 'pointer'
	      },
	      '&$expanded': {
	        minHeight: 64
	      },
	      '&$focused': {
	        backgroundColor: theme.palette.action.focus
	      },
	      '&$disabled': {
	        opacity: theme.palette.action.disabledOpacity
	      }
	    },
	
	    /* Pseudo-class applied to the root element, children wrapper element and `IconButton` component if `expanded={true}`. */
	    expanded: {},
	
	    /* Pseudo-class applied to the root element if `focused={true}`. */
	    focused: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the children wrapper element. */
	    content: {
	      display: 'flex',
	      flexGrow: 1,
	      transition: theme.transitions.create(['margin'], transition),
	      margin: '12px 0',
	      '&$expanded': {
	        margin: '20px 0'
	      }
	    },
	
	    /* Styles applied to the `IconButton` component when `expandIcon` is supplied. */
	    expandIcon: {
	      transform: 'rotate(0deg)',
	      transition: theme.transitions.create('transform', transition),
	      '&:hover': {
	        // Disable the hover effect for the IconButton,
	        // because a hover effect should apply to the entire Expand button and
	        // not only to the IconButton.
	        backgroundColor: 'transparent'
	      },
	      '&$expanded': {
	        transform: 'rotate(180deg)'
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var AccordionSummary = /*#__PURE__*/React.forwardRef(function AccordionSummary(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      expandIcon = props.expandIcon,
	      IconButtonProps = props.IconButtonProps,
	      onBlur = props.onBlur,
	      onClick = props.onClick,
	      onFocusVisible = props.onFocusVisible,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "expandIcon", "IconButtonProps", "onBlur", "onClick", "onFocusVisible"]);
	
	  var _React$useState = React.useState(false),
	      focusedState = _React$useState[0],
	      setFocusedState = _React$useState[1];
	
	  var handleFocusVisible = function handleFocusVisible(event) {
	    setFocusedState(true);
	
	    if (onFocusVisible) {
	      onFocusVisible(event);
	    }
	  };
	
	  var handleBlur = function handleBlur(event) {
	    setFocusedState(false);
	
	    if (onBlur) {
	      onBlur(event);
	    }
	  };
	
	  var _React$useContext = React.useContext(_AccordionContext.default),
	      _React$useContext$dis = _React$useContext.disabled,
	      disabled = _React$useContext$dis === void 0 ? false : _React$useContext$dis,
	      expanded = _React$useContext.expanded,
	      toggle = _React$useContext.toggle;
	
	  var handleChange = function handleChange(event) {
	    if (toggle) {
	      toggle(event);
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    focusRipple: false,
	    disableRipple: true,
	    disabled: disabled,
	    component: "div",
	    "aria-expanded": expanded,
	    className: (0, _clsx.default)(classes.root, className, disabled && classes.disabled, expanded && classes.expanded, focusedState && classes.focused),
	    onFocusVisible: handleFocusVisible,
	    onBlur: handleBlur,
	    onClick: handleChange,
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.content, expanded && classes.expanded)
	  }, children), expandIcon && /*#__PURE__*/React.createElement(_IconButton.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.expandIcon, expanded && classes.expanded),
	    edge: "end",
	    component: "div",
	    tabIndex: null,
	    role: null,
	    "aria-hidden": true
	  }, IconButtonProps), expandIcon));
	});
	 false ? AccordionSummary.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the accordion summary.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The icon to display as the expand indicator.
	   */
	  expandIcon: _propTypes.default.node,
	
	  /**
	   * Props applied to the `IconButton` element wrapping the expand icon.
	   */
	  IconButtonProps: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocusVisible: _propTypes.default.func
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiAccordionSummary'
	})(AccordionSummary);
	
	exports.default = _default;

/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _AccordionSummary.default;
	  }
	});
	
	var _AccordionSummary = _interopRequireDefault(__webpack_require__(1114));

/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var _Paper = _interopRequireDefault(__webpack_require__(89));
	
	var styles = function styles(theme) {
	  var backgroundColorDefault = theme.palette.type === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'flex',
	      flexDirection: 'column',
	      width: '100%',
	      boxSizing: 'border-box',
	      // Prevent padding issue with the Modal and fixed positioned AppBar.
	      zIndex: theme.zIndex.appBar,
	      flexShrink: 0
	    },
	
	    /* Styles applied to the root element if `position="fixed"`. */
	    positionFixed: {
	      position: 'fixed',
	      top: 0,
	      left: 'auto',
	      right: 0,
	      '@media print': {
	        // Prevent the app bar to be visible on each printed page.
	        position: 'absolute'
	      }
	    },
	
	    /* Styles applied to the root element if `position="absolute"`. */
	    positionAbsolute: {
	      position: 'absolute',
	      top: 0,
	      left: 'auto',
	      right: 0
	    },
	
	    /* Styles applied to the root element if `position="sticky"`. */
	    positionSticky: {
	      // ⚠️ sticky is not supported by IE 11.
	      position: 'sticky',
	      top: 0,
	      left: 'auto',
	      right: 0
	    },
	
	    /* Styles applied to the root element if `position="static"`. */
	    positionStatic: {
	      position: 'static'
	    },
	
	    /* Styles applied to the root element if `position="relative"`. */
	    positionRelative: {
	      position: 'relative'
	    },
	
	    /* Styles applied to the root element if `color="default"`. */
	    colorDefault: {
	      backgroundColor: backgroundColorDefault,
	      color: theme.palette.getContrastText(backgroundColorDefault)
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      backgroundColor: theme.palette.primary.main,
	      color: theme.palette.primary.contrastText
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      backgroundColor: theme.palette.secondary.main,
	      color: theme.palette.secondary.contrastText
	    },
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the root element if `color="transparent"`. */
	    colorTransparent: {
	      backgroundColor: 'transparent',
	      color: 'inherit'
	    }
	  };
	};
	
	exports.styles = styles;
	var AppBar = /*#__PURE__*/React.forwardRef(function AppBar(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      _props$position = props.position,
	      position = _props$position === void 0 ? 'fixed' : _props$position,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "position"]);
	  return /*#__PURE__*/React.createElement(_Paper.default, (0, _extends2.default)({
	    square: true,
	    component: "header",
	    elevation: 4,
	    className: (0, _clsx.default)(classes.root, classes["position".concat((0, _capitalize.default)(position))], classes["color".concat((0, _capitalize.default)(color))], className, position === 'fixed' && 'mui-fixed'),
	    ref: ref
	  }, other));
	});
	 false ? AppBar.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary', 'transparent']),
	
	  /**
	   * The positioning type. The behavior of the different options is described
	   * [in the MDN web docs](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning).
	   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
	   */
	  position: _propTypes.default.oneOf(['absolute', 'fixed', 'relative', 'static', 'sticky'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiAppBar'
	})(AppBar);
	
	exports.default = _default;

/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _AppBar.default;
	  }
	});
	
	var _AppBar = _interopRequireDefault(__webpack_require__(1116));

/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _Person = _interopRequireDefault(__webpack_require__(1308));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      flexShrink: 0,
	      width: 40,
	      height: 40,
	      fontFamily: theme.typography.fontFamily,
	      fontSize: theme.typography.pxToRem(20),
	      lineHeight: 1,
	      borderRadius: '50%',
	      overflow: 'hidden',
	      userSelect: 'none'
	    },
	
	    /* Styles applied to the root element if not `src` or `srcSet`. */
	    colorDefault: {
	      color: theme.palette.background.default,
	      backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
	    },
	
	    /* Styles applied to the root element if `variant="circle"`. */
	    circle: {},
	
	    /* Styles applied to the root element if `variant="rounded"`. */
	    rounded: {
	      borderRadius: theme.shape.borderRadius
	    },
	
	    /* Styles applied to the root element if `variant="square"`. */
	    square: {
	      borderRadius: 0
	    },
	
	    /* Styles applied to the img element if either `src` or `srcSet` is defined. */
	    img: {
	      width: '100%',
	      height: '100%',
	      textAlign: 'center',
	      // Handle non-square image. The property isn't supported by IE 11.
	      objectFit: 'cover',
	      // Hide alt text.
	      color: 'transparent',
	      // Hide the image broken icon, only works on Chrome.
	      textIndent: 10000
	    },
	
	    /* Styles applied to the fallback icon */
	    fallback: {
	      width: '75%',
	      height: '75%'
	    }
	  };
	};
	
	exports.styles = styles;
	
	function useLoaded(_ref) {
	  var src = _ref.src,
	      srcSet = _ref.srcSet;
	
	  var _React$useState = React.useState(false),
	      loaded = _React$useState[0],
	      setLoaded = _React$useState[1];
	
	  React.useEffect(function () {
	    if (!src && !srcSet) {
	      return undefined;
	    }
	
	    setLoaded(false);
	    var active = true;
	    var image = new Image();
	    image.src = src;
	    image.srcSet = srcSet;
	
	    image.onload = function () {
	      if (!active) {
	        return;
	      }
	
	      setLoaded('loaded');
	    };
	
	    image.onerror = function () {
	      if (!active) {
	        return;
	      }
	
	      setLoaded('error');
	    };
	
	    return function () {
	      active = false;
	    };
	  }, [src, srcSet]);
	  return loaded;
	}
	
	var Avatar = /*#__PURE__*/React.forwardRef(function Avatar(props, ref) {
	  var alt = props.alt,
	      childrenProp = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      imgProps = props.imgProps,
	      sizes = props.sizes,
	      src = props.src,
	      srcSet = props.srcSet,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'circle' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["alt", "children", "classes", "className", "component", "imgProps", "sizes", "src", "srcSet", "variant"]);
	  var children = null; // Use a hook instead of onError on the img element to support server-side rendering.
	
	  var loaded = useLoaded({
	    src: src,
	    srcSet: srcSet
	  });
	  var hasImg = src || srcSet;
	  var hasImgNotFailing = hasImg && loaded !== 'error';
	
	  if (hasImgNotFailing) {
	    children = /*#__PURE__*/React.createElement("img", (0, _extends2.default)({
	      alt: alt,
	      src: src,
	      srcSet: srcSet,
	      sizes: sizes,
	      className: classes.img
	    }, imgProps));
	  } else if (childrenProp != null) {
	    children = childrenProp;
	  } else if (hasImg && alt) {
	    children = alt[0];
	  } else {
	    children = /*#__PURE__*/React.createElement(_Person.default, {
	      className: classes.fallback
	    });
	  }
	
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes.system, classes[variant], className, !hasImgNotFailing && classes.colorDefault),
	    ref: ref
	  }, other), children);
	});
	 false ? Avatar.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Used in combination with `src` or `srcSet` to
	   * provide an alt attribute for the rendered `img` element.
	   */
	  alt: _propTypes.default.string,
	
	  /**
	   * Used to render icon or text elements inside the Avatar if `src` is not set.
	   * This can be an element, or just a string.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * Attributes applied to the `img` element if the component is used to display an image.
	   * It can be used to listen for the loading error event.
	   */
	  imgProps: _propTypes.default.object,
	
	  /**
	   * The `sizes` attribute for the `img` element.
	   */
	  sizes: _propTypes.default.string,
	
	  /**
	   * The `src` attribute for the `img` element.
	   */
	  src: _propTypes.default.string,
	
	  /**
	   * The `srcSet` attribute for the `img` element.
	   * Use this attribute for responsive image display.
	   */
	  srcSet: _propTypes.default.string,
	
	  /**
	   * The shape of the avatar.
	   */
	  variant: _propTypes.default.oneOf(['circle', 'rounded', 'square'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiAvatar'
	})(Avatar);
	
	exports.default = _default;

/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _Fade = _interopRequireDefault(__webpack_require__(397));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    // Improve scrollable dialog support.
	    zIndex: -1,
	    position: 'fixed',
	    display: 'flex',
	    alignItems: 'center',
	    justifyContent: 'center',
	    right: 0,
	    bottom: 0,
	    top: 0,
	    left: 0,
	    backgroundColor: 'rgba(0, 0, 0, 0.5)',
	    WebkitTapHighlightColor: 'transparent'
	  },
	
	  /* Styles applied to the root element if `invisible={true}`. */
	  invisible: {
	    backgroundColor: 'transparent'
	  }
	};
	exports.styles = styles;
	var Backdrop = /*#__PURE__*/React.forwardRef(function Backdrop(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$invisible = props.invisible,
	      invisible = _props$invisible === void 0 ? false : _props$invisible,
	      open = props.open,
	      transitionDuration = props.transitionDuration,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Fade.default : _props$TransitionComp,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "invisible", "open", "transitionDuration", "TransitionComponent"]);
	  return /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    in: open,
	    timeout: transitionDuration
	  }, other), /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.root, className, invisible && classes.invisible),
	    "aria-hidden": true,
	    ref: ref
	  }, children));
	});
	 false ? Backdrop.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the backdrop is invisible.
	   * It can be used when rendering a popover or a custom select component.
	   */
	  invisible: _propTypes.default.bool,
	
	  /**
	   * If `true`, the backdrop is open.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiBackdrop'
	})(Backdrop);
	
	exports.default = _default;

/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var RADIUS_STANDARD = 10;
	var RADIUS_DOT = 4;
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      display: 'inline-flex',
	      // For correct alignment with the text.
	      verticalAlign: 'middle',
	      flexShrink: 0
	    },
	
	    /* Styles applied to the badge `span` element. */
	    badge: {
	      display: 'flex',
	      flexDirection: 'row',
	      flexWrap: 'wrap',
	      justifyContent: 'center',
	      alignContent: 'center',
	      alignItems: 'center',
	      position: 'absolute',
	      boxSizing: 'border-box',
	      fontFamily: theme.typography.fontFamily,
	      fontWeight: theme.typography.fontWeightMedium,
	      fontSize: theme.typography.pxToRem(12),
	      minWidth: RADIUS_STANDARD * 2,
	      lineHeight: 1,
	      padding: '0 6px',
	      height: RADIUS_STANDARD * 2,
	      borderRadius: RADIUS_STANDARD,
	      zIndex: 1,
	      // Render the badge on top of potential ripples.
	      transition: theme.transitions.create('transform', {
	        easing: theme.transitions.easing.easeInOut,
	        duration: theme.transitions.duration.enteringScreen
	      })
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      backgroundColor: theme.palette.primary.main,
	      color: theme.palette.primary.contrastText
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      backgroundColor: theme.palette.secondary.main,
	      color: theme.palette.secondary.contrastText
	    },
	
	    /* Styles applied to the root element if `color="error"`. */
	    colorError: {
	      backgroundColor: theme.palette.error.main,
	      color: theme.palette.error.contrastText
	    },
	
	    /* Styles applied to the root element if `variant="dot"`. */
	    dot: {
	      borderRadius: RADIUS_DOT,
	      height: RADIUS_DOT * 2,
	      minWidth: RADIUS_DOT * 2,
	      padding: 0
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="rectangle"`. */
	    anchorOriginTopRightRectangle: {
	      top: 0,
	      right: 0,
	      transform: 'scale(1) translate(50%, -50%)',
	      transformOrigin: '100% 0%',
	      '&$invisible': {
	        transform: 'scale(0) translate(50%, -50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="rectangle"`. */
	    anchorOriginBottomRightRectangle: {
	      bottom: 0,
	      right: 0,
	      transform: 'scale(1) translate(50%, 50%)',
	      transformOrigin: '100% 100%',
	      '&$invisible': {
	        transform: 'scale(0) translate(50%, 50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="rectangle"`. */
	    anchorOriginTopLeftRectangle: {
	      top: 0,
	      left: 0,
	      transform: 'scale(1) translate(-50%, -50%)',
	      transformOrigin: '0% 0%',
	      '&$invisible': {
	        transform: 'scale(0) translate(-50%, -50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="rectangle"`. */
	    anchorOriginBottomLeftRectangle: {
	      bottom: 0,
	      left: 0,
	      transform: 'scale(1) translate(-50%, 50%)',
	      transformOrigin: '0% 100%',
	      '&$invisible': {
	        transform: 'scale(0) translate(-50%, 50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="circle"`. */
	    anchorOriginTopRightCircle: {
	      top: '14%',
	      right: '14%',
	      transform: 'scale(1) translate(50%, -50%)',
	      transformOrigin: '100% 0%',
	      '&$invisible': {
	        transform: 'scale(0) translate(50%, -50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="circle"`. */
	    anchorOriginBottomRightCircle: {
	      bottom: '14%',
	      right: '14%',
	      transform: 'scale(1) translate(50%, 50%)',
	      transformOrigin: '100% 100%',
	      '&$invisible': {
	        transform: 'scale(0) translate(50%, 50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="circle"`. */
	    anchorOriginTopLeftCircle: {
	      top: '14%',
	      left: '14%',
	      transform: 'scale(1) translate(-50%, -50%)',
	      transformOrigin: '0% 0%',
	      '&$invisible': {
	        transform: 'scale(0) translate(-50%, -50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="circle"`. */
	    anchorOriginBottomLeftCircle: {
	      bottom: '14%',
	      left: '14%',
	      transform: 'scale(1) translate(-50%, 50%)',
	      transformOrigin: '0% 100%',
	      '&$invisible': {
	        transform: 'scale(0) translate(-50%, 50%)'
	      }
	    },
	
	    /* Pseudo-class to the badge `span` element if `invisible={true}`. */
	    invisible: {
	      transition: theme.transitions.create('transform', {
	        easing: theme.transitions.easing.easeInOut,
	        duration: theme.transitions.duration.leavingScreen
	      })
	    }
	  };
	};
	
	exports.styles = styles;
	var Badge = /*#__PURE__*/React.forwardRef(function Badge(props, ref) {
	  var _props$anchorOrigin = props.anchorOrigin,
	      anchorOrigin = _props$anchorOrigin === void 0 ? {
	    vertical: 'top',
	    horizontal: 'right'
	  } : _props$anchorOrigin,
	      badgeContent = props.badgeContent,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      _props$component = props.component,
	      ComponentProp = _props$component === void 0 ? 'span' : _props$component,
	      invisibleProp = props.invisible,
	      _props$max = props.max,
	      max = _props$max === void 0 ? 99 : _props$max,
	      _props$overlap = props.overlap,
	      overlap = _props$overlap === void 0 ? 'rectangle' : _props$overlap,
	      _props$showZero = props.showZero,
	      showZero = _props$showZero === void 0 ? false : _props$showZero,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["anchorOrigin", "badgeContent", "children", "classes", "className", "color", "component", "invisible", "max", "overlap", "showZero", "variant"]);
	  var invisible = invisibleProp;
	
	  if (invisibleProp == null && (badgeContent === 0 && !showZero || badgeContent == null && variant !== 'dot')) {
	    invisible = true;
	  }
	
	  var displayValue = '';
	
	  if (variant !== 'dot') {
	    displayValue = badgeContent > max ? "".concat(max, "+") : badgeContent;
	  }
	
	  return /*#__PURE__*/React.createElement(ComponentProp, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), children, /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.badge, classes["".concat(anchorOrigin.horizontal).concat((0, _capitalize.default)(anchorOrigin.vertical), "}")], classes["anchorOrigin".concat((0, _capitalize.default)(anchorOrigin.vertical)).concat((0, _capitalize.default)(anchorOrigin.horizontal)).concat((0, _capitalize.default)(overlap))], color !== 'default' && classes["color".concat((0, _capitalize.default)(color))], invisible && classes.invisible, variant === 'dot' && classes.dot)
	  }, displayValue));
	});
	 false ? Badge.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The anchor of the badge.
	   */
	  anchorOrigin: _propTypes.default.shape({
	    horizontal: _propTypes.default.oneOf(['left', 'right']).isRequired,
	    vertical: _propTypes.default.oneOf(['bottom', 'top']).isRequired
	  }),
	
	  /**
	   * The content rendered within the badge.
	   */
	  badgeContent: _propTypes.default.node,
	
	  /**
	   * The badge will be added relative to this node.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'error', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, the badge will be invisible.
	   */
	  invisible: _propTypes.default.bool,
	
	  /**
	   * Max count to show.
	   */
	  max: _propTypes.default.number,
	
	  /**
	   * Wrapped shape the badge should overlap.
	   */
	  overlap: _propTypes.default.oneOf(['circle', 'rectangle']),
	
	  /**
	   * Controls whether the badge is hidden when `badgeContent` is zero.
	   */
	  showZero: _propTypes.default.bool,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['dot', 'standard'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiBadge'
	})(Badge);
	
	exports.default = _default;

/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Badge.default;
	  }
	});
	
	var _Badge = _interopRequireDefault(__webpack_require__(1120));

/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactIs = __webpack_require__(72);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'flex',
	      justifyContent: 'center',
	      height: 56,
	      backgroundColor: theme.palette.background.paper
	    }
	  };
	};
	
	exports.styles = styles;
	var BottomNavigation = /*#__PURE__*/React.forwardRef(function BottomNavigation(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      onChange = props.onChange,
	      _props$showLabels = props.showLabels,
	      showLabels = _props$showLabels === void 0 ? false : _props$showLabels,
	      value = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "onChange", "showLabels", "value"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), React.Children.map(children, function (child, childIndex) {
	    if (! /*#__PURE__*/React.isValidElement(child)) {
	      return null;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: The BottomNavigation component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    var childValue = child.props.value === undefined ? childIndex : child.props.value;
	    return /*#__PURE__*/React.cloneElement(child, {
	      selected: childValue === value,
	      showLabel: child.props.showLabel !== undefined ? child.props.showLabel : showLabels,
	      value: childValue,
	      onChange: onChange
	    });
	  }));
	});
	 false ? BottomNavigation.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * Callback fired when the value changes.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {any} value We default to the index of the child.
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * If `true`, all `BottomNavigationAction`s will show their labels.
	   * By default, only the selected `BottomNavigationAction` will show its label.
	   */
	  showLabels: _propTypes.default.bool,
	
	  /**
	   * The value of the currently selected `BottomNavigationAction`.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiBottomNavigation'
	})(BottomNavigation);
	
	exports.default = _default;

/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _BottomNavigation.default;
	  }
	});
	
	var _BottomNavigation = _interopRequireDefault(__webpack_require__(1122));

/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(69));
	
	var _unsupportedProp = _interopRequireDefault(__webpack_require__(311));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      transition: theme.transitions.create(['color', 'padding-top'], {
	        duration: theme.transitions.duration.short
	      }),
	      padding: '6px 12px 8px',
	      minWidth: 80,
	      maxWidth: 168,
	      color: theme.palette.text.secondary,
	      flex: '1',
	      '&$iconOnly': {
	        paddingTop: 16
	      },
	      '&$selected': {
	        paddingTop: 6,
	        color: theme.palette.primary.main
	      }
	    },
	
	    /* Pseudo-class applied to the root element if selected. */
	    selected: {},
	
	    /* Pseudo-class applied to the root element if `showLabel={false}` and not selected. */
	    iconOnly: {},
	
	    /* Styles applied to the span element that wraps the icon and label. */
	    wrapper: {
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      width: '100%',
	      flexDirection: 'column'
	    },
	
	    /* Styles applied to the label's span element. */
	    label: {
	      fontFamily: theme.typography.fontFamily,
	      fontSize: theme.typography.pxToRem(12),
	      opacity: 1,
	      transition: 'font-size 0.2s, opacity 0.2s',
	      transitionDelay: '0.1s',
	      '&$iconOnly': {
	        opacity: 0,
	        transitionDelay: '0s'
	      },
	      '&$selected': {
	        fontSize: theme.typography.pxToRem(14)
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var BottomNavigationAction = /*#__PURE__*/React.forwardRef(function BottomNavigationAction(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      icon = props.icon,
	      label = props.label,
	      onChange = props.onChange,
	      onClick = props.onClick,
	      selected = props.selected,
	      showLabel = props.showLabel,
	      value = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "icon", "label", "onChange", "onClick", "selected", "showLabel", "value"]);
	
	  var handleChange = function handleChange(event) {
	    if (onChange) {
	      onChange(event, value);
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    ref: ref,
	    className: (0, _clsx.default)(classes.root, className, selected ? classes.selected : !showLabel && classes.iconOnly),
	    focusRipple: true,
	    onClick: handleChange
	  }, other), /*#__PURE__*/React.createElement("span", {
	    className: classes.wrapper
	  }, icon, /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.label, selected ? classes.selected : !showLabel && classes.iconOnly)
	  }, label)));
	});
	 false ? BottomNavigationAction.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * This prop isn't supported.
	   * Use the `component` prop if you need to change the children structure.
	   */
	  children: _unsupportedProp.default,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The icon element.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * The label element.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  selected: _propTypes.default.bool,
	
	  /**
	   * If `true`, the `BottomNavigationAction` will show its label.
	   * By default, only the selected `BottomNavigationAction`
	   * inside `BottomNavigation` will show its label.
	   */
	  showLabel: _propTypes.default.bool,
	
	  /**
	   * You can provide your own value. Otherwise, we fallback to the child position index.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiBottomNavigationAction'
	})(BottomNavigationAction);
	
	exports.default = _default;

/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _BottomNavigationAction.default;
	  }
	});
	
	var _BottomNavigationAction = _interopRequireDefault(__webpack_require__(1124));

/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styleFunction = void 0;
	
	var _system = __webpack_require__(637);
	
	var _styled = _interopRequireDefault(__webpack_require__(623));
	
	var styleFunction = (0, _system.css)((0, _system.compose)(_system.borders, _system.display, _system.flexbox, _system.grid, _system.positions, _system.palette, _system.shadows, _system.sizing, _system.spacing, _system.typography));
	/**
	 * @ignore - do not document.
	 */
	
	exports.styleFunction = styleFunction;
	var Box = (0, _styled.default)('div')(styleFunction, {
	  name: 'MuiBox'
	});
	var _default = Box;
	exports.default = _default;

/***/ },
/* 1127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Box.default;
	  }
	});
	Object.defineProperty(exports, "styleFunction", {
	  enumerable: true,
	  get: function get() {
	    return _Box.styleFunction;
	  }
	});
	
	var _Box = _interopRequireWildcard(__webpack_require__(1126));

/***/ },
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _colorManipulator = __webpack_require__(63);
	
	var _MoreHoriz = _interopRequireDefault(__webpack_require__(1307));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(69));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      marginLeft: theme.spacing(0.5),
	      marginRight: theme.spacing(0.5),
	      backgroundColor: theme.palette.grey[100],
	      color: theme.palette.grey[700],
	      borderRadius: 2,
	      cursor: 'pointer',
	      '&:hover, &:focus': {
	        backgroundColor: theme.palette.grey[200]
	      },
	      '&:active': {
	        boxShadow: theme.shadows[0],
	        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.grey[200], 0.12)
	      }
	    },
	    icon: {
	      width: 24,
	      height: 16
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	function BreadcrumbCollapsed(props) {
	  var classes = props.classes,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes"]);
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    component: "li",
	    className: classes.root,
	    focusRipple: true
	  }, other), /*#__PURE__*/React.createElement(_MoreHoriz.default, {
	    className: classes.icon
	  }));
	}
	
	 false ? BreadcrumbCollapsed.propTypes = {
	  /**
	   * @ignore
	   */
	  classes: _propTypes.default.object.isRequired
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateBreadcrumbCollapsed'
	})(BreadcrumbCollapsed);
	
	exports.default = _default;

/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(115));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactIs = __webpack_require__(72);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _Typography = _interopRequireDefault(__webpack_require__(75));
	
	var _BreadcrumbCollapsed = _interopRequireDefault(__webpack_require__(1128));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {},
	
	  /* Styles applied to the ol element. */
	  ol: {
	    display: 'flex',
	    flexWrap: 'wrap',
	    alignItems: 'center',
	    padding: 0,
	    margin: 0,
	    listStyle: 'none'
	  },
	
	  /* Styles applied to the li element. */
	  li: {},
	
	  /* Styles applied to the separator element. */
	  separator: {
	    display: 'flex',
	    userSelect: 'none',
	    marginLeft: 8,
	    marginRight: 8
	  }
	};
	exports.styles = styles;
	
	function insertSeparators(items, className, separator) {
	  return items.reduce(function (acc, current, index) {
	    if (index < items.length - 1) {
	      acc = acc.concat(current, /*#__PURE__*/React.createElement("li", {
	        "aria-hidden": true,
	        key: "separator-".concat(index),
	        className: className
	      }, separator));
	    } else {
	      acc.push(current);
	    }
	
	    return acc;
	  }, []);
	}
	
	var Breadcrumbs = /*#__PURE__*/React.forwardRef(function Breadcrumbs(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'nav' : _props$component,
	      _props$expandText = props.expandText,
	      expandText = _props$expandText === void 0 ? 'Show path' : _props$expandText,
	      _props$itemsAfterColl = props.itemsAfterCollapse,
	      itemsAfterCollapse = _props$itemsAfterColl === void 0 ? 1 : _props$itemsAfterColl,
	      _props$itemsBeforeCol = props.itemsBeforeCollapse,
	      itemsBeforeCollapse = _props$itemsBeforeCol === void 0 ? 1 : _props$itemsBeforeCol,
	      _props$maxItems = props.maxItems,
	      maxItems = _props$maxItems === void 0 ? 8 : _props$maxItems,
	      _props$separator = props.separator,
	      separator = _props$separator === void 0 ? '/' : _props$separator,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "expandText", "itemsAfterCollapse", "itemsBeforeCollapse", "maxItems", "separator"]);
	
	  var _React$useState = React.useState(false),
	      expanded = _React$useState[0],
	      setExpanded = _React$useState[1];
	
	  var renderItemsBeforeAndAfter = function renderItemsBeforeAndAfter(allItems) {
	    var handleClickExpand = function handleClickExpand(event) {
	      setExpanded(true); // The clicked element received the focus but gets removed from the DOM.
	      // Let's keep the focus in the component after expanding.
	
	      var focusable = event.currentTarget.parentNode.querySelector('a[href],button,[tabindex]');
	
	      if (focusable) {
	        focusable.focus();
	      }
	    }; // This defends against someone passing weird input, to ensure that if all
	    // items would be shown anyway, we just show all items without the EllipsisItem
	
	
	    if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) {
	      if (false) {
	        console.error(['Material-UI: You have provided an invalid combination of props to the Breadcrumbs.', "itemsAfterCollapse={".concat(itemsAfterCollapse, "} + itemsBeforeCollapse={").concat(itemsBeforeCollapse, "} >= maxItems={").concat(maxItems, "}")].join('\n'));
	      }
	
	      return allItems;
	    }
	
	    return [].concat((0, _toConsumableArray2.default)(allItems.slice(0, itemsBeforeCollapse)), [/*#__PURE__*/React.createElement(_BreadcrumbCollapsed.default, {
	      "aria-label": expandText,
	      key: "ellipsis",
	      onClick: handleClickExpand
	    })], (0, _toConsumableArray2.default)(allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)));
	  };
	
	  var allItems = React.Children.toArray(children).filter(function (child) {
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: The Breadcrumbs component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    return /*#__PURE__*/React.isValidElement(child);
	  }).map(function (child, index) {
	    return /*#__PURE__*/React.createElement("li", {
	      className: classes.li,
	      key: "child-".concat(index)
	    }, child);
	  });
	  return /*#__PURE__*/React.createElement(_Typography.default, (0, _extends2.default)({
	    ref: ref,
	    component: Component,
	    color: "textSecondary",
	    className: (0, _clsx.default)(classes.root, className)
	  }, other), /*#__PURE__*/React.createElement("ol", {
	    className: classes.ol
	  }, insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator)));
	});
	 false ? Breadcrumbs.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The breadcrumb children.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * Override the default label for the expand button.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  expandText: _propTypes.default.string,
	
	  /**
	   * If max items is exceeded, the number of items to show after the ellipsis.
	   */
	  itemsAfterCollapse: _propTypes.default.number,
	
	  /**
	   * If max items is exceeded, the number of items to show before the ellipsis.
	   */
	  itemsBeforeCollapse: _propTypes.default.number,
	
	  /**
	   * Specifies the maximum number of breadcrumbs to display. When there are more
	   * than the maximum number, only the first `itemsBeforeCollapse` and last `itemsAfterCollapse`
	   * will be shown, with an ellipsis in between.
	   */
	  maxItems: _propTypes.default.number,
	
	  /**
	   * Custom separator node.
	   */
	  separator: _propTypes.default.node
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiBreadcrumbs'
	})(Breadcrumbs);
	
	exports.default = _default;

/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Breadcrumbs.default;
	  }
	});
	
	var _Breadcrumbs = _interopRequireDefault(__webpack_require__(1129));

/***/ },
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _colorManipulator = __webpack_require__(63);
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(69));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({}, theme.typography.button, {
	      boxSizing: 'border-box',
	      minWidth: 64,
	      padding: '6px 16px',
	      borderRadius: theme.shape.borderRadius,
	      color: theme.palette.text.primary,
	      transition: theme.transitions.create(['background-color', 'box-shadow', 'border'], {
	        duration: theme.transitions.duration.short
	      }),
	      '&:hover': {
	        textDecoration: 'none',
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        },
	        '&$disabled': {
	          backgroundColor: 'transparent'
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    }),
	
	    /* Styles applied to the span element that wraps the children. */
	    label: {
	      width: '100%',
	      // Ensure the correct width for iOS Safari
	      display: 'inherit',
	      alignItems: 'inherit',
	      justifyContent: 'inherit'
	    },
	
	    /* Styles applied to the root element if `variant="text"`. */
	    text: {
	      padding: '6px 8px'
	    },
	
	    /* Styles applied to the root element if `variant="text"` and `color="primary"`. */
	    textPrimary: {
	      color: theme.palette.primary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */
	    textSecondary: {
	      color: theme.palette.secondary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"`. */
	    outlined: {
	      padding: '5px 15px',
	      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
	      '&$disabled': {
	        border: "1px solid ".concat(theme.palette.action.disabledBackground)
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
	    outlinedPrimary: {
	      color: theme.palette.primary.main,
	      border: "1px solid ".concat((0, _colorManipulator.fade)(theme.palette.primary.main, 0.5)),
	      '&:hover': {
	        border: "1px solid ".concat(theme.palette.primary.main),
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
	    outlinedSecondary: {
	      color: theme.palette.secondary.main,
	      border: "1px solid ".concat((0, _colorManipulator.fade)(theme.palette.secondary.main, 0.5)),
	      '&:hover': {
	        border: "1px solid ".concat(theme.palette.secondary.main),
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      },
	      '&$disabled': {
	        border: "1px solid ".concat(theme.palette.action.disabled)
	      }
	    },
	
	    /* Styles applied to the root element if `variant="contained"`. */
	    contained: {
	      color: theme.palette.getContrastText(theme.palette.grey[300]),
	      backgroundColor: theme.palette.grey[300],
	      boxShadow: theme.shadows[2],
	      '&:hover': {
	        backgroundColor: theme.palette.grey.A100,
	        boxShadow: theme.shadows[4],
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          boxShadow: theme.shadows[2],
	          backgroundColor: theme.palette.grey[300]
	        },
	        '&$disabled': {
	          backgroundColor: theme.palette.action.disabledBackground
	        }
	      },
	      '&$focusVisible': {
	        boxShadow: theme.shadows[6]
	      },
	      '&:active': {
	        boxShadow: theme.shadows[8]
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled,
	        boxShadow: theme.shadows[0],
	        backgroundColor: theme.palette.action.disabledBackground
	      }
	    },
	
	    /* Styles applied to the root element if `variant="contained"` and `color="primary"`. */
	    containedPrimary: {
	      color: theme.palette.primary.contrastText,
	      backgroundColor: theme.palette.primary.main,
	      '&:hover': {
	        backgroundColor: theme.palette.primary.dark,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.primary.main
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="contained"` and `color="secondary"`. */
	    containedSecondary: {
	      color: theme.palette.secondary.contrastText,
	      backgroundColor: theme.palette.secondary.main,
	      '&:hover': {
	        backgroundColor: theme.palette.secondary.dark,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.secondary.main
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `disableElevation={true}`. */
	    disableElevation: {
	      boxShadow: 'none',
	      '&:hover': {
	        boxShadow: 'none'
	      },
	      '&$focusVisible': {
	        boxShadow: 'none'
	      },
	      '&:active': {
	        boxShadow: 'none'
	      },
	      '&$disabled': {
	        boxShadow: 'none'
	      }
	    },
	
	    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
	    focusVisible: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit',
	      borderColor: 'currentColor'
	    },
	
	    /* Styles applied to the root element if `size="small"` and `variant="text"`. */
	    textSizeSmall: {
	      padding: '4px 5px',
	      fontSize: theme.typography.pxToRem(13)
	    },
	
	    /* Styles applied to the root element if `size="large"` and `variant="text"`. */
	    textSizeLarge: {
	      padding: '8px 11px',
	      fontSize: theme.typography.pxToRem(15)
	    },
	
	    /* Styles applied to the root element if `size="small"` and `variant="outlined"`. */
	    outlinedSizeSmall: {
	      padding: '3px 9px',
	      fontSize: theme.typography.pxToRem(13)
	    },
	
	    /* Styles applied to the root element if `size="large"` and `variant="outlined"`. */
	    outlinedSizeLarge: {
	      padding: '7px 21px',
	      fontSize: theme.typography.pxToRem(15)
	    },
	
	    /* Styles applied to the root element if `size="small"` and `variant="contained"`. */
	    containedSizeSmall: {
	      padding: '4px 10px',
	      fontSize: theme.typography.pxToRem(13)
	    },
	
	    /* Styles applied to the root element if `size="large"` and `variant="contained"`. */
	    containedSizeLarge: {
	      padding: '8px 22px',
	      fontSize: theme.typography.pxToRem(15)
	    },
	
	    /* Styles applied to the root element if `size="small"`. */
	    sizeSmall: {},
	
	    /* Styles applied to the root element if `size="large"`. */
	    sizeLarge: {},
	
	    /* Styles applied to the root element if `fullWidth={true}`. */
	    fullWidth: {
	      width: '100%'
	    },
	
	    /* Styles applied to the startIcon element if supplied. */
	    startIcon: {
	      display: 'inherit',
	      marginRight: 8,
	      marginLeft: -4,
	      '&$iconSizeSmall': {
	        marginLeft: -2
	      }
	    },
	
	    /* Styles applied to the endIcon element if supplied. */
	    endIcon: {
	      display: 'inherit',
	      marginRight: -4,
	      marginLeft: 8,
	      '&$iconSizeSmall': {
	        marginRight: -2
	      }
	    },
	
	    /* Styles applied to the icon element if supplied and `size="small"`. */
	    iconSizeSmall: {
	      '& > *:first-child': {
	        fontSize: 18
	      }
	    },
	
	    /* Styles applied to the icon element if supplied and `size="medium"`. */
	    iconSizeMedium: {
	      '& > *:first-child': {
	        fontSize: 20
	      }
	    },
	
	    /* Styles applied to the icon element if supplied and `size="large"`. */
	    iconSizeLarge: {
	      '& > *:first-child': {
	        fontSize: 22
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var Button = /*#__PURE__*/React.forwardRef(function Button(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      _props$component = props.component,
	      component = _props$component === void 0 ? 'button' : _props$component,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableElevati = props.disableElevation,
	      disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati,
	      _props$disableFocusRi = props.disableFocusRipple,
	      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
	      endIconProp = props.endIcon,
	      focusVisibleClassName = props.focusVisibleClassName,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      startIconProp = props.startIcon,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'button' : _props$type,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'text' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"]);
	  var startIcon = startIconProp && /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.startIcon, classes["iconSize".concat((0, _capitalize.default)(size))])
	  }, startIconProp);
	  var endIcon = endIconProp && /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.endIcon, classes["iconSize".concat((0, _capitalize.default)(size))])
	  }, endIconProp);
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes[variant], className, color === 'inherit' ? classes.colorInherit : color !== 'default' && classes["".concat(variant).concat((0, _capitalize.default)(color))], size !== 'medium' && [classes["".concat(variant, "Size").concat((0, _capitalize.default)(size))], classes["size".concat((0, _capitalize.default)(size))]], disableElevation && classes.disableElevation, disabled && classes.disabled, fullWidth && classes.fullWidth),
	    component: component,
	    disabled: disabled,
	    focusRipple: !disableFocusRipple,
	    focusVisibleClassName: (0, _clsx.default)(classes.focusVisible, focusVisibleClassName),
	    ref: ref,
	    type: type
	  }, other), /*#__PURE__*/React.createElement("span", {
	    className: classes.label
	  }, startIcon, children, endIcon));
	});
	 false ? Button.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the button.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, the button will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, no elevation is used.
	   */
	  disableElevation: _propTypes.default.bool,
	
	  /**
	   * If `true`, the  keyboard focus ripple will be disabled.
	   */
	  disableFocusRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   *
	   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
	   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * Element placed after the children.
	   */
	  endIcon: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  focusVisibleClassName: _propTypes.default.string,
	
	  /**
	   * If `true`, the button will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The URL to link to when the button is clicked.
	   * If defined, an `a` element will be used as the root node.
	   */
	  href: _propTypes.default.string,
	
	  /**
	   * The size of the button.
	   * `small` is equivalent to the dense button styling.
	   */
	  size: _propTypes.default.oneOf(['large', 'medium', 'small']),
	
	  /**
	   * Element placed before the children.
	   */
	  startIcon: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  type: _propTypes.default.oneOfType([_propTypes.default.oneOf(['button', 'reset', 'submit']), _propTypes.default.string]),
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['contained', 'outlined', 'text'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiButton'
	})(Button);
	
	exports.default = _default;

/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(51));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _utils = __webpack_require__(19);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(47));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(117));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _useIsFocusVisible2 = _interopRequireDefault(__webpack_require__(243));
	
	var _TouchRipple = _interopRequireDefault(__webpack_require__(1134));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'inline-flex',
	    alignItems: 'center',
	    justifyContent: 'center',
	    position: 'relative',
	    WebkitTapHighlightColor: 'transparent',
	    backgroundColor: 'transparent',
	    // Reset default value
	    // We disable the focus ring for mouse, touch and keyboard users.
	    outline: 0,
	    border: 0,
	    margin: 0,
	    // Remove the margin in Safari
	    borderRadius: 0,
	    padding: 0,
	    // Remove the padding in Firefox
	    cursor: 'pointer',
	    userSelect: 'none',
	    verticalAlign: 'middle',
	    '-moz-appearance': 'none',
	    // Reset
	    '-webkit-appearance': 'none',
	    // Reset
	    textDecoration: 'none',
	    // So we take precedent over the style of a native <a /> element.
	    color: 'inherit',
	    '&::-moz-focus-inner': {
	      borderStyle: 'none' // Remove Firefox dotted outline.
	
	    },
	    '&$disabled': {
	      pointerEvents: 'none',
	      // Disable link interactions
	      cursor: 'default'
	    },
	    '@media print': {
	      colorAdjust: 'exact'
	    }
	  },
	
	  /* Pseudo-class applied to the root element if `disabled={true}`. */
	  disabled: {},
	
	  /* Pseudo-class applied to the root element if keyboard focused. */
	  focusVisible: {}
	};
	/**
	 * `ButtonBase` contains as few styles as possible.
	 * It aims to be a simple building block for creating a button.
	 * It contains a load of style reset and some focus/ripple logic.
	 */
	
	exports.styles = styles;
	var ButtonBase = /*#__PURE__*/React.forwardRef(function ButtonBase(props, ref) {
	  var action = props.action,
	      buttonRefProp = props.buttonRef,
	      _props$centerRipple = props.centerRipple,
	      centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      component = _props$component === void 0 ? 'button' : _props$component,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableRipple = props.disableRipple,
	      disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple,
	      _props$disableTouchRi = props.disableTouchRipple,
	      disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi,
	      _props$focusRipple = props.focusRipple,
	      focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple,
	      focusVisibleClassName = props.focusVisibleClassName,
	      onBlur = props.onBlur,
	      onClick = props.onClick,
	      onFocus = props.onFocus,
	      onFocusVisible = props.onFocusVisible,
	      onKeyDown = props.onKeyDown,
	      onKeyUp = props.onKeyUp,
	      onMouseDown = props.onMouseDown,
	      onMouseLeave = props.onMouseLeave,
	      onMouseUp = props.onMouseUp,
	      onTouchEnd = props.onTouchEnd,
	      onTouchMove = props.onTouchMove,
	      onTouchStart = props.onTouchStart,
	      onDragLeave = props.onDragLeave,
	      _props$tabIndex = props.tabIndex,
	      tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
	      TouchRippleProps = props.TouchRippleProps,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'button' : _props$type,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onClick", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "onDragLeave", "tabIndex", "TouchRippleProps", "type"]);
	  var buttonRef = React.useRef(null);
	
	  function getButtonNode() {
	    // #StrictMode ready
	    return ReactDOM.findDOMNode(buttonRef.current);
	  }
	
	  var rippleRef = React.useRef(null);
	
	  var _React$useState = React.useState(false),
	      focusVisible = _React$useState[0],
	      setFocusVisible = _React$useState[1];
	
	  if (disabled && focusVisible) {
	    setFocusVisible(false);
	  }
	
	  var _useIsFocusVisible = (0, _useIsFocusVisible2.default)(),
	      isFocusVisible = _useIsFocusVisible.isFocusVisible,
	      onBlurVisible = _useIsFocusVisible.onBlurVisible,
	      focusVisibleRef = _useIsFocusVisible.ref;
	
	  React.useImperativeHandle(action, function () {
	    return {
	      focusVisible: function focusVisible() {
	        setFocusVisible(true);
	        buttonRef.current.focus();
	      }
	    };
	  }, []);
	  React.useEffect(function () {
	    if (focusVisible && focusRipple && !disableRipple) {
	      rippleRef.current.pulsate();
	    }
	  }, [disableRipple, focusRipple, focusVisible]);
	
	  function useRippleHandler(rippleAction, eventCallback) {
	    var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
	    return (0, _useEventCallback.default)(function (event) {
	      if (eventCallback) {
	        eventCallback(event);
	      }
	
	      var ignore = skipRippleAction;
	
	      if (!ignore && rippleRef.current) {
	        rippleRef.current[rippleAction](event);
	      }
	
	      return true;
	    });
	  }
	
	  var handleMouseDown = useRippleHandler('start', onMouseDown);
	  var handleDragLeave = useRippleHandler('stop', onDragLeave);
	  var handleMouseUp = useRippleHandler('stop', onMouseUp);
	  var handleMouseLeave = useRippleHandler('stop', function (event) {
	    if (focusVisible) {
	      event.preventDefault();
	    }
	
	    if (onMouseLeave) {
	      onMouseLeave(event);
	    }
	  });
	  var handleTouchStart = useRippleHandler('start', onTouchStart);
	  var handleTouchEnd = useRippleHandler('stop', onTouchEnd);
	  var handleTouchMove = useRippleHandler('stop', onTouchMove);
	  var handleBlur = useRippleHandler('stop', function (event) {
	    if (focusVisible) {
	      onBlurVisible(event);
	      setFocusVisible(false);
	    }
	
	    if (onBlur) {
	      onBlur(event);
	    }
	  }, false);
	  var handleFocus = (0, _useEventCallback.default)(function (event) {
	    // Fix for https://github.com/facebook/react/issues/7769
	    if (!buttonRef.current) {
	      buttonRef.current = event.currentTarget;
	    }
	
	    if (isFocusVisible(event)) {
	      setFocusVisible(true);
	
	      if (onFocusVisible) {
	        onFocusVisible(event);
	      }
	    }
	
	    if (onFocus) {
	      onFocus(event);
	    }
	  });
	
	  var isNonNativeButton = function isNonNativeButton() {
	    var button = getButtonNode();
	    return component && component !== 'button' && !(button.tagName === 'A' && button.href);
	  };
	  /**
	   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
	   */
	
	
	  var keydownRef = React.useRef(false);
	  var handleKeyDown = (0, _useEventCallback.default)(function (event) {
	    // Check if key is already down to avoid repeats being counted as multiple activations
	    if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
	      keydownRef.current = true;
	      event.persist();
	      rippleRef.current.stop(event, function () {
	        rippleRef.current.start(event);
	      });
	    }
	
	    if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') {
	      event.preventDefault();
	    }
	
	    if (onKeyDown) {
	      onKeyDown(event);
	    } // Keyboard accessibility for non interactive elements
	
	
	    if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
	      event.preventDefault();
	
	      if (onClick) {
	        onClick(event);
	      }
	    }
	  });
	  var handleKeyUp = (0, _useEventCallback.default)(function (event) {
	    // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
	    // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
	    if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
	      keydownRef.current = false;
	      event.persist();
	      rippleRef.current.stop(event, function () {
	        rippleRef.current.pulsate(event);
	      });
	    }
	
	    if (onKeyUp) {
	      onKeyUp(event);
	    } // Keyboard accessibility for non interactive elements
	
	
	    if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) {
	      onClick(event);
	    }
	  });
	  var ComponentProp = component;
	
	  if (ComponentProp === 'button' && other.href) {
	    ComponentProp = 'a';
	  }
	
	  var buttonProps = {};
	
	  if (ComponentProp === 'button') {
	    buttonProps.type = type;
	    buttonProps.disabled = disabled;
	  } else {
	    if (ComponentProp !== 'a' || !other.href) {
	      buttonProps.role = 'button';
	    }
	
	    buttonProps['aria-disabled'] = disabled;
	  }
	
	  var handleUserRef = (0, _useForkRef.default)(buttonRefProp, ref);
	  var handleOwnRef = (0, _useForkRef.default)(focusVisibleRef, buttonRef);
	  var handleRef = (0, _useForkRef.default)(handleUserRef, handleOwnRef);
	
	  var _React$useState2 = React.useState(false),
	      mountedState = _React$useState2[0],
	      setMountedState = _React$useState2[1];
	
	  React.useEffect(function () {
	    setMountedState(true);
	  }, []);
	  var enableTouchRipple = mountedState && !disableRipple && !disabled;
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    React.useEffect(function () {
	      if (enableTouchRipple && !rippleRef.current) {
	        console.error(['Material-UI: The `component` prop provided to ButtonBase is invalid.', 'Please make sure the children prop is rendered in this custom component.'].join('\n'));
	      }
	    }, [enableTouchRipple]);
	  }
	
	  return /*#__PURE__*/React.createElement(ComponentProp, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, focusVisible && [classes.focusVisible, focusVisibleClassName], disabled && classes.disabled),
	    onBlur: handleBlur,
	    onClick: onClick,
	    onFocus: handleFocus,
	    onKeyDown: handleKeyDown,
	    onKeyUp: handleKeyUp,
	    onMouseDown: handleMouseDown,
	    onMouseLeave: handleMouseLeave,
	    onMouseUp: handleMouseUp,
	    onDragLeave: handleDragLeave,
	    onTouchEnd: handleTouchEnd,
	    onTouchMove: handleTouchMove,
	    onTouchStart: handleTouchStart,
	    ref: handleRef,
	    tabIndex: disabled ? -1 : tabIndex
	  }, buttonProps, other), children, enableTouchRipple ?
	  /*#__PURE__*/
	
	  /* TouchRipple is only needed client-side, x2 boost on the server. */
	  React.createElement(_TouchRipple.default, (0, _extends2.default)({
	    ref: rippleRef,
	    center: centerRipple
	  }, TouchRippleProps)) : null);
	});
	 false ? ButtonBase.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A ref for imperative actions.
	   * It currently only supports `focusVisible()` action.
	   */
	  action: _utils.refType,
	
	  /**
	   * @ignore
	   *
	   * Use that prop to pass a ref to the native button component.
	   * @deprecated Use `ref` instead.
	   */
	  buttonRef: _utils.refType,
	
	  /**
	   * If `true`, the ripples will be centered.
	   * They won't start at the cursor interaction position.
	   */
	  centerRipple: _propTypes.default.bool,
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _utils.elementTypeAcceptingRef,
	
	  /**
	   * If `true`, the base button will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   *
	   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
	   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the touch ripple effect will be disabled.
	   */
	  disableTouchRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the base button will have a keyboard focus ripple.
	   */
	  focusRipple: _propTypes.default.bool,
	
	  /**
	   * This prop can help a person know which element has the keyboard focus.
	   * The class name will be applied when the element gain the focus through a keyboard interaction.
	   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
	   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/master/explainer.md).
	   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
	   * if needed.
	   */
	  focusVisibleClassName: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  href: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onDragLeave: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component is focused with a keyboard.
	   * We trigger a `onFocus` callback too.
	   */
	  onFocusVisible: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyUp: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseLeave: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseUp: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onTouchEnd: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onTouchMove: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onTouchStart: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Props applied to the `TouchRipple` element.
	   */
	  TouchRippleProps: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  type: _propTypes.default.oneOfType([_propTypes.default.oneOf(['button', 'reset', 'submit']), _propTypes.default.string])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiButtonBase'
	})(ButtonBase);
	
	exports.default = _default;

/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(117));
	
	var useEnhancedEffect = typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;
	/**
	 * @ignore - internal component.
	 */
	
	function Ripple(props) {
	  var classes = props.classes,
	      _props$pulsate = props.pulsate,
	      pulsate = _props$pulsate === void 0 ? false : _props$pulsate,
	      rippleX = props.rippleX,
	      rippleY = props.rippleY,
	      rippleSize = props.rippleSize,
	      inProp = props.in,
	      _props$onExited = props.onExited,
	      onExited = _props$onExited === void 0 ? function () {} : _props$onExited,
	      timeout = props.timeout;
	
	  var _React$useState = React.useState(false),
	      leaving = _React$useState[0],
	      setLeaving = _React$useState[1];
	
	  var rippleClassName = (0, _clsx.default)(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
	  var rippleStyles = {
	    width: rippleSize,
	    height: rippleSize,
	    top: -(rippleSize / 2) + rippleY,
	    left: -(rippleSize / 2) + rippleX
	  };
	  var childClassName = (0, _clsx.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
	  var handleExited = (0, _useEventCallback.default)(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority
	
	  useEnhancedEffect(function () {
	    if (!inProp) {
	      // react-transition-group#onExit
	      setLeaving(true); // react-transition-group#onExited
	
	      var timeoutId = setTimeout(handleExited, timeout);
	      return function () {
	        clearTimeout(timeoutId);
	      };
	    }
	
	    return undefined;
	  }, [handleExited, inProp, timeout]);
	  return /*#__PURE__*/React.createElement("span", {
	    className: rippleClassName,
	    style: rippleStyles
	  }, /*#__PURE__*/React.createElement("span", {
	    className: childClassName
	  }));
	}
	
	 false ? Ripple.propTypes = {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore - injected from TransitionGroup
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore - injected from TransitionGroup
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
	   */
	  pulsate: _propTypes.default.bool,
	
	  /**
	   * Diameter of the ripple.
	   */
	  rippleSize: _propTypes.default.number,
	
	  /**
	   * Horizontal position of the ripple center.
	   */
	  rippleX: _propTypes.default.number,
	
	  /**
	   * Vertical position of the ripple center.
	   */
	  rippleY: _propTypes.default.number,
	
	  /**
	   * exit delay
	   */
	  timeout: _propTypes.default.number.isRequired
	} : void 0;
	var _default = Ripple;
	exports.default = _default;

/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = exports.DELAY_RIPPLE = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(115));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactTransitionGroup = __webpack_require__(230);
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _Ripple = _interopRequireDefault(__webpack_require__(1133));
	
	var DURATION = 550;
	var DELAY_RIPPLE = 80;
	exports.DELAY_RIPPLE = DELAY_RIPPLE;
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      overflow: 'hidden',
	      pointerEvents: 'none',
	      position: 'absolute',
	      zIndex: 0,
	      top: 0,
	      right: 0,
	      bottom: 0,
	      left: 0,
	      borderRadius: 'inherit'
	    },
	
	    /* Styles applied to the internal `Ripple` components `ripple` class. */
	    ripple: {
	      opacity: 0,
	      position: 'absolute'
	    },
	
	    /* Styles applied to the internal `Ripple` components `rippleVisible` class. */
	    rippleVisible: {
	      opacity: 0.3,
	      transform: 'scale(1)',
	      animation: "$enter ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
	    },
	
	    /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */
	    ripplePulsate: {
	      animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
	    },
	
	    /* Styles applied to the internal `Ripple` components `child` class. */
	    child: {
	      opacity: 1,
	      display: 'block',
	      width: '100%',
	      height: '100%',
	      borderRadius: '50%',
	      backgroundColor: 'currentColor'
	    },
	
	    /* Styles applied to the internal `Ripple` components `childLeaving` class. */
	    childLeaving: {
	      opacity: 0,
	      animation: "$exit ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
	    },
	
	    /* Styles applied to the internal `Ripple` components `childPulsate` class. */
	    childPulsate: {
	      position: 'absolute',
	      left: 0,
	      top: 0,
	      animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
	    },
	    '@keyframes enter': {
	      '0%': {
	        transform: 'scale(0)',
	        opacity: 0.1
	      },
	      '100%': {
	        transform: 'scale(1)',
	        opacity: 0.3
	      }
	    },
	    '@keyframes exit': {
	      '0%': {
	        opacity: 1
	      },
	      '100%': {
	        opacity: 0
	      }
	    },
	    '@keyframes pulsate': {
	      '0%': {
	        transform: 'scale(1)'
	      },
	      '50%': {
	        transform: 'scale(0.92)'
	      },
	      '100%': {
	        transform: 'scale(1)'
	      }
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 *
	 * TODO v5: Make private
	 */
	
	
	exports.styles = styles;
	var TouchRipple = /*#__PURE__*/React.forwardRef(function TouchRipple(props, ref) {
	  var _props$center = props.center,
	      centerProp = _props$center === void 0 ? false : _props$center,
	      classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["center", "classes", "className"]);
	
	  var _React$useState = React.useState([]),
	      ripples = _React$useState[0],
	      setRipples = _React$useState[1];
	
	  var nextKey = React.useRef(0);
	  var rippleCallback = React.useRef(null);
	  React.useEffect(function () {
	    if (rippleCallback.current) {
	      rippleCallback.current();
	      rippleCallback.current = null;
	    }
	  }, [ripples]); // Used to filter out mouse emulated events on mobile.
	
	  var ignoringMouseDown = React.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
	  // We don't want to display the ripple for touch scroll events.
	
	  var startTimer = React.useRef(null); // This is the hook called once the previous timeout is ready.
	
	  var startTimerCommit = React.useRef(null);
	  var container = React.useRef(null);
	  React.useEffect(function () {
	    return function () {
	      clearTimeout(startTimer.current);
	    };
	  }, []);
	  var startCommit = React.useCallback(function (params) {
	    var pulsate = params.pulsate,
	        rippleX = params.rippleX,
	        rippleY = params.rippleY,
	        rippleSize = params.rippleSize,
	        cb = params.cb;
	    setRipples(function (oldRipples) {
	      return [].concat((0, _toConsumableArray2.default)(oldRipples), [/*#__PURE__*/React.createElement(_Ripple.default, {
	        key: nextKey.current,
	        classes: classes,
	        timeout: DURATION,
	        pulsate: pulsate,
	        rippleX: rippleX,
	        rippleY: rippleY,
	        rippleSize: rippleSize
	      })]);
	    });
	    nextKey.current += 1;
	    rippleCallback.current = cb;
	  }, [classes]);
	  var start = React.useCallback(function () {
	    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var cb = arguments.length > 2 ? arguments[2] : undefined;
	    var _options$pulsate = options.pulsate,
	        pulsate = _options$pulsate === void 0 ? false : _options$pulsate,
	        _options$center = options.center,
	        center = _options$center === void 0 ? centerProp || options.pulsate : _options$center,
	        _options$fakeElement = options.fakeElement,
	        fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;
	
	    if (event.type === 'mousedown' && ignoringMouseDown.current) {
	      ignoringMouseDown.current = false;
	      return;
	    }
	
	    if (event.type === 'touchstart') {
	      ignoringMouseDown.current = true;
	    }
	
	    var element = fakeElement ? null : container.current;
	    var rect = element ? element.getBoundingClientRect() : {
	      width: 0,
	      height: 0,
	      left: 0,
	      top: 0
	    }; // Get the size of the ripple
	
	    var rippleX;
	    var rippleY;
	    var rippleSize;
	
	    if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
	      rippleX = Math.round(rect.width / 2);
	      rippleY = Math.round(rect.height / 2);
	    } else {
	      var _ref = event.touches ? event.touches[0] : event,
	          clientX = _ref.clientX,
	          clientY = _ref.clientY;
	
	      rippleX = Math.round(clientX - rect.left);
	      rippleY = Math.round(clientY - rect.top);
	    }
	
	    if (center) {
	      rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.
	
	      if (rippleSize % 2 === 0) {
	        rippleSize += 1;
	      }
	    } else {
	      var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
	      var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
	      rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
	    } // Touche devices
	
	
	    if (event.touches) {
	      // check that this isn't another touchstart due to multitouch
	      // otherwise we will only clear a single timer when unmounting while two
	      // are running
	      if (startTimerCommit.current === null) {
	        // Prepare the ripple effect.
	        startTimerCommit.current = function () {
	          startCommit({
	            pulsate: pulsate,
	            rippleX: rippleX,
	            rippleY: rippleY,
	            rippleSize: rippleSize,
	            cb: cb
	          });
	        }; // Delay the execution of the ripple effect.
	
	
	        startTimer.current = setTimeout(function () {
	          if (startTimerCommit.current) {
	            startTimerCommit.current();
	            startTimerCommit.current = null;
	          }
	        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
	      }
	    } else {
	      startCommit({
	        pulsate: pulsate,
	        rippleX: rippleX,
	        rippleY: rippleY,
	        rippleSize: rippleSize,
	        cb: cb
	      });
	    }
	  }, [centerProp, startCommit]);
	  var pulsate = React.useCallback(function () {
	    start({}, {
	      pulsate: true
	    });
	  }, [start]);
	  var stop = React.useCallback(function (event, cb) {
	    clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
	    // We still want to show ripple effect.
	
	    if (event.type === 'touchend' && startTimerCommit.current) {
	      event.persist();
	      startTimerCommit.current();
	      startTimerCommit.current = null;
	      startTimer.current = setTimeout(function () {
	        stop(event, cb);
	      });
	      return;
	    }
	
	    startTimerCommit.current = null;
	    setRipples(function (oldRipples) {
	      if (oldRipples.length > 0) {
	        return oldRipples.slice(1);
	      }
	
	      return oldRipples;
	    });
	    rippleCallback.current = cb;
	  }, []);
	  React.useImperativeHandle(ref, function () {
	    return {
	      pulsate: pulsate,
	      start: start,
	      stop: stop
	    };
	  }, [pulsate, start, stop]);
	  return /*#__PURE__*/React.createElement("span", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: container
	  }, other), /*#__PURE__*/React.createElement(_reactTransitionGroup.TransitionGroup, {
	    component: null,
	    exit: true
	  }, ripples));
	});
	 false ? TouchRipple.propTypes = {
	  /**
	   * If `true`, the ripple starts at the center of the component
	   * rather than at the point of interaction.
	   */
	  center: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  flip: false,
	  name: 'MuiTouchRipple'
	})( /*#__PURE__*/React.memo(TouchRipple));
	
	exports.default = _default;

/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactIs = __webpack_require__(72);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var _colorManipulator = __webpack_require__(63);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _Button = _interopRequireDefault(__webpack_require__(233));
	
	// Force a side effect so we don't have any override priority issue.
	// eslint-disable-next-line no-unused-expressions
	_Button.default.styles;
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'inline-flex',
	      borderRadius: theme.shape.borderRadius
	    },
	
	    /* Styles applied to the root element if `variant="contained"`. */
	    contained: {
	      boxShadow: theme.shadows[2]
	    },
	
	    /* Styles applied to the root element if `disableElevation={true}`. */
	    disableElevation: {
	      boxShadow: 'none'
	    },
	
	    /* Pseudo-class applied to child elements if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `fullWidth={true}`. */
	    fullWidth: {
	      width: '100%'
	    },
	
	    /* Styles applied to the root element if `orientation="vertical"`. */
	    vertical: {
	      flexDirection: 'column'
	    },
	
	    /* Styles applied to the children. */
	    grouped: {
	      minWidth: 40
	    },
	
	    /* Styles applied to the children if `orientation="horizontal"`. */
	    groupedHorizontal: {
	      '&:not(:first-child)': {
	        borderTopLeftRadius: 0,
	        borderBottomLeftRadius: 0
	      },
	      '&:not(:last-child)': {
	        borderTopRightRadius: 0,
	        borderBottomRightRadius: 0
	      }
	    },
	
	    /* Styles applied to the children if `orientation="vertical"`. */
	    groupedVertical: {
	      '&:not(:first-child)': {
	        borderTopRightRadius: 0,
	        borderTopLeftRadius: 0
	      },
	      '&:not(:last-child)': {
	        borderBottomRightRadius: 0,
	        borderBottomLeftRadius: 0
	      }
	    },
	
	    /* Styles applied to the children if `variant="text"`. */
	    groupedText: {},
	
	    /* Styles applied to the children if `variant="text"` and `orientation="horizontal"`. */
	    groupedTextHorizontal: {
	      '&:not(:last-child)': {
	        borderRight: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)')
	      }
	    },
	
	    /* Styles applied to the children if `variant="text"` and `orientation="vertical"`. */
	    groupedTextVertical: {
	      '&:not(:last-child)': {
	        borderBottom: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)')
	      }
	    },
	
	    /* Styles applied to the children if `variant="text"` and `color="primary"`. */
	    groupedTextPrimary: {
	      '&:not(:last-child)': {
	        borderColor: (0, _colorManipulator.fade)(theme.palette.primary.main, 0.5)
	      }
	    },
	
	    /* Styles applied to the children if `variant="text"` and `color="secondary"`. */
	    groupedTextSecondary: {
	      '&:not(:last-child)': {
	        borderColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, 0.5)
	      }
	    },
	
	    /* Styles applied to the children if `variant="outlined"`. */
	    groupedOutlined: {},
	
	    /* Styles applied to the children if `variant="outlined"` and `orientation="horizontal"`. */
	    groupedOutlinedHorizontal: {
	      '&:not(:first-child)': {
	        marginLeft: -1
	      },
	      '&:not(:last-child)': {
	        borderRightColor: 'transparent'
	      }
	    },
	
	    /* Styles applied to the children if `variant="outlined"` and `orientation="vertical"`. */
	    groupedOutlinedVertical: {
	      '&:not(:first-child)': {
	        marginTop: -1
	      },
	      '&:not(:last-child)': {
	        borderBottomColor: 'transparent'
	      }
	    },
	
	    /* Styles applied to the children if `variant="outlined"` and `color="primary"`. */
	    groupedOutlinedPrimary: {
	      '&:hover': {
	        borderColor: theme.palette.primary.main
	      }
	    },
	
	    /* Styles applied to the children if `variant="outlined"` and `color="secondary"`. */
	    groupedOutlinedSecondary: {
	      '&:hover': {
	        borderColor: theme.palette.secondary.main
	      }
	    },
	
	    /* Styles applied to the children if `variant="contained"`. */
	    groupedContained: {
	      boxShadow: 'none'
	    },
	
	    /* Styles applied to the children if `variant="contained"` and `orientation="horizontal"`. */
	    groupedContainedHorizontal: {
	      '&:not(:last-child)': {
	        borderRight: "1px solid ".concat(theme.palette.grey[400]),
	        '&$disabled': {
	          borderRight: "1px solid ".concat(theme.palette.action.disabled)
	        }
	      }
	    },
	
	    /* Styles applied to the children if `variant="contained"` and `orientation="vertical"`. */
	    groupedContainedVertical: {
	      '&:not(:last-child)': {
	        borderBottom: "1px solid ".concat(theme.palette.grey[400]),
	        '&$disabled': {
	          borderBottom: "1px solid ".concat(theme.palette.action.disabled)
	        }
	      }
	    },
	
	    /* Styles applied to the children if `variant="contained"` and `color="primary"`. */
	    groupedContainedPrimary: {
	      '&:not(:last-child)': {
	        borderColor: theme.palette.primary.dark
	      }
	    },
	
	    /* Styles applied to the children if `variant="contained"` and `color="secondary"`. */
	    groupedContainedSecondary: {
	      '&:not(:last-child)': {
	        borderColor: theme.palette.secondary.dark
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var ButtonGroup = /*#__PURE__*/React.forwardRef(function ButtonGroup(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableElevati = props.disableElevation,
	      disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati,
	      _props$disableFocusRi = props.disableFocusRipple,
	      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
	      _props$disableRipple = props.disableRipple,
	      disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'outlined' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "disableRipple", "fullWidth", "orientation", "size", "variant"]);
	  var buttonClassName = (0, _clsx.default)(classes.grouped, classes["grouped".concat((0, _capitalize.default)(orientation))], classes["grouped".concat((0, _capitalize.default)(variant))], classes["grouped".concat((0, _capitalize.default)(variant)).concat((0, _capitalize.default)(orientation))], classes["grouped".concat((0, _capitalize.default)(variant)).concat(color !== 'default' ? (0, _capitalize.default)(color) : '')], disabled && classes.disabled);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    role: "group",
	    className: (0, _clsx.default)(classes.root, className, fullWidth && classes.fullWidth, disableElevation && classes.disableElevation, variant === 'contained' && classes.contained, orientation === 'vertical' && classes.vertical),
	    ref: ref
	  }, other), React.Children.map(children, function (child) {
	    if (! /*#__PURE__*/React.isValidElement(child)) {
	      return null;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: The ButtonGroup component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    return /*#__PURE__*/React.cloneElement(child, {
	      className: (0, _clsx.default)(buttonClassName, child.props.className),
	      color: child.props.color || color,
	      disabled: child.props.disabled || disabled,
	      disableElevation: child.props.disableElevation || disableElevation,
	      disableFocusRipple: disableFocusRipple,
	      disableRipple: disableRipple,
	      fullWidth: fullWidth,
	      size: child.props.size || size,
	      variant: child.props.variant || variant
	    });
	  }));
	});
	 false ? ButtonGroup.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the button group.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, the buttons will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, no elevation is used.
	   */
	  disableElevation: _propTypes.default.bool,
	
	  /**
	   * If `true`, the button keyboard focus ripple will be disabled.
	   */
	  disableFocusRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the button ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the buttons will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The group orientation (layout flow direction).
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']),
	
	  /**
	   * The size of the button.
	   * `small` is equivalent to the dense button styling.
	   */
	  size: _propTypes.default.oneOf(['large', 'medium', 'small']),
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['contained', 'outlined', 'text'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiButtonGroup'
	})(ButtonGroup);
	
	exports.default = _default;

/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ButtonGroup.default;
	  }
	});
	
	var _ButtonGroup = _interopRequireDefault(__webpack_require__(1135));

/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _Paper = _interopRequireDefault(__webpack_require__(89));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    overflow: 'hidden'
	  }
	};
	exports.styles = styles;
	var Card = /*#__PURE__*/React.forwardRef(function Card(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$raised = props.raised,
	      raised = _props$raised === void 0 ? false : _props$raised,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "raised"]);
	  return /*#__PURE__*/React.createElement(_Paper.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    elevation: raised ? 8 : 1,
	    ref: ref
	  }, other));
	});
	 false ? Card.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the card will use raised styling.
	   */
	  raised: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCard'
	})(Card);
	
	exports.default = _default;

/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(69));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'block',
	      textAlign: 'inherit',
	      width: '100%',
	      '&:hover $focusHighlight': {
	        opacity: theme.palette.action.hoverOpacity
	      },
	      '&$focusVisible $focusHighlight': {
	        opacity: 0.12
	      }
	    },
	
	    /* Pseudo-class applied to the ButtonBase root element if the action area is keyboard focused. */
	    focusVisible: {},
	
	    /* Styles applied to the overlay that covers the action area when it is keyboard focused. */
	    focusHighlight: {
	      overflow: 'hidden',
	      pointerEvents: 'none',
	      position: 'absolute',
	      top: 0,
	      right: 0,
	      bottom: 0,
	      left: 0,
	      borderRadius: 'inherit',
	      opacity: 0,
	      backgroundColor: 'currentcolor',
	      transition: theme.transitions.create('opacity', {
	        duration: theme.transitions.duration.short
	      })
	    }
	  };
	};
	
	exports.styles = styles;
	var CardActionArea = /*#__PURE__*/React.forwardRef(function CardActionArea(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      focusVisibleClassName = props.focusVisibleClassName,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "focusVisibleClassName"]);
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    focusVisibleClassName: (0, _clsx.default)(focusVisibleClassName, classes.focusVisible),
	    ref: ref
	  }, other), children, /*#__PURE__*/React.createElement("span", {
	    className: classes.focusHighlight
	  }));
	});
	 false ? CardActionArea.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  focusVisibleClassName: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCardActionArea'
	})(CardActionArea);
	
	exports.default = _default;

/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CardActionArea.default;
	  }
	});
	
	var _CardActionArea = _interopRequireDefault(__webpack_require__(1138));

/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    alignItems: 'center',
	    padding: 8
	  },
	
	  /* Styles applied to the root element if `disableSpacing={false}`. */
	  spacing: {
	    '& > :not(:first-child)': {
	      marginLeft: 8
	    }
	  }
	};
	exports.styles = styles;
	var CardActions = /*#__PURE__*/React.forwardRef(function CardActions(props, ref) {
	  var _props$disableSpacing = props.disableSpacing,
	      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
	      classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["disableSpacing", "classes", "className"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, !disableSpacing && classes.spacing),
	    ref: ref
	  }, other));
	});
	 false ? CardActions.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the actions do not have additional margin.
	   */
	  disableSpacing: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCardActions'
	})(CardActions);
	
	exports.default = _default;

/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CardActions.default;
	  }
	});
	
	var _CardActions = _interopRequireDefault(__webpack_require__(1140));

/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    padding: 16,
	    '&:last-child': {
	      paddingBottom: 24
	    }
	  }
	};
	exports.styles = styles;
	var CardContent = /*#__PURE__*/React.forwardRef(function CardContent(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other));
	});
	 false ? CardContent.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCardContent'
	})(CardContent);
	
	exports.default = _default;

/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CardContent.default;
	  }
	});
	
	var _CardContent = _interopRequireDefault(__webpack_require__(1142));

/***/ },
/* 1144 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _Typography = _interopRequireDefault(__webpack_require__(75));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    alignItems: 'center',
	    padding: 16
	  },
	
	  /* Styles applied to the avatar element. */
	  avatar: {
	    flex: '0 0 auto',
	    marginRight: 16
	  },
	
	  /* Styles applied to the action element. */
	  action: {
	    flex: '0 0 auto',
	    alignSelf: 'flex-start',
	    marginTop: -8,
	    marginRight: -8
	  },
	
	  /* Styles applied to the content wrapper element. */
	  content: {
	    flex: '1 1 auto'
	  },
	
	  /* Styles applied to the title Typography element. */
	  title: {},
	
	  /* Styles applied to the subheader Typography element. */
	  subheader: {}
	};
	exports.styles = styles;
	var CardHeader = /*#__PURE__*/React.forwardRef(function CardHeader(props, ref) {
	  var action = props.action,
	      avatar = props.avatar,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$disableTypogra = props.disableTypography,
	      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
	      subheaderProp = props.subheader,
	      subheaderTypographyProps = props.subheaderTypographyProps,
	      titleProp = props.title,
	      titleTypographyProps = props.titleTypographyProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "avatar", "classes", "className", "component", "disableTypography", "subheader", "subheaderTypographyProps", "title", "titleTypographyProps"]);
	  var title = titleProp;
	
	  if (title != null && title.type !== _Typography.default && !disableTypography) {
	    title = /*#__PURE__*/React.createElement(_Typography.default, (0, _extends2.default)({
	      variant: avatar ? 'body2' : 'h5',
	      className: classes.title,
	      component: "span",
	      display: "block"
	    }, titleTypographyProps), title);
	  }
	
	  var subheader = subheaderProp;
	
	  if (subheader != null && subheader.type !== _Typography.default && !disableTypography) {
	    subheader = /*#__PURE__*/React.createElement(_Typography.default, (0, _extends2.default)({
	      variant: avatar ? 'body2' : 'body1',
	      className: classes.subheader,
	      color: "textSecondary",
	      component: "span",
	      display: "block"
	    }, subheaderTypographyProps), subheader);
	  }
	
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), avatar && /*#__PURE__*/React.createElement("div", {
	    className: classes.avatar
	  }, avatar), /*#__PURE__*/React.createElement("div", {
	    className: classes.content
	  }, title, subheader), action && /*#__PURE__*/React.createElement("div", {
	    className: classes.action
	  }, action));
	});
	 false ? CardHeader.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The action to display in the card header.
	   */
	  action: _propTypes.default.node,
	
	  /**
	   * The Avatar for the Card Header.
	   */
	  avatar: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, `subheader` and `title` won't be wrapped by a Typography component.
	   * This can be useful to render an alternative Typography variant by wrapping
	   * the `title` text, and optional `subheader` text
	   * with the Typography component.
	   */
	  disableTypography: _propTypes.default.bool,
	
	  /**
	   * The content of the component.
	   */
	  subheader: _propTypes.default.node,
	
	  /**
	   * These props will be forwarded to the subheader
	   * (as long as disableTypography is not `true`).
	   */
	  subheaderTypographyProps: _propTypes.default.object,
	
	  /**
	   * The content of the Card Title.
	   */
	  title: _propTypes.default.node,
	
	  /**
	   * These props will be forwarded to the title
	   * (as long as disableTypography is not `true`).
	   */
	  titleTypographyProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCardHeader'
	})(CardHeader);
	
	exports.default = _default;

/***/ },
/* 1145 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _utils = __webpack_require__(19);
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'block',
	    backgroundSize: 'cover',
	    backgroundRepeat: 'no-repeat',
	    backgroundPosition: 'center'
	  },
	
	  /* Styles applied to the root element if `component="video, audio, picture, iframe, or img"`. */
	  media: {
	    width: '100%'
	  },
	
	  /* Styles applied to the root element if `component="picture or img"`. */
	  img: {
	    // ⚠️ object-fit is not supported by IE 11.
	    objectFit: 'cover'
	  }
	};
	exports.styles = styles;
	var MEDIA_COMPONENTS = ['video', 'audio', 'picture', 'iframe', 'img'];
	var CardMedia = /*#__PURE__*/React.forwardRef(function CardMedia(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      image = props.image,
	      src = props.src,
	      style = props.style,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "image", "src", "style"]);
	  var isMediaComponent = MEDIA_COMPONENTS.indexOf(Component) !== -1;
	  var composedStyle = !isMediaComponent && image ? (0, _extends2.default)({
	    backgroundImage: "url(\"".concat(image, "\")")
	  }, style) : style;
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, isMediaComponent && classes.media, "picture img".indexOf(Component) !== -1 && classes.img),
	    ref: ref,
	    style: composedStyle,
	    src: isMediaComponent ? image || src : undefined
	  }, other), children);
	});
	 false ? CardMedia.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: (0, _utils.chainPropTypes)(_propTypes.default.node, function (props) {
	    if (!props.children && !props.image && !props.src && !props.component) {
	      return new Error('Material-UI: Either `children`, `image`, `src` or `component` prop must be specified.');
	    }
	
	    return null;
	  }),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * Image to be displayed as a background image.
	   * Either `image` or `src` prop must be specified.
	   * Note that caller must specify height otherwise the image will not be visible.
	   */
	  image: _propTypes.default.string,
	
	  /**
	   * An alias for `image` property.
	   * Available only with media components.
	   * Media components: `video`, `audio`, `picture`, `iframe`, `img`.
	   */
	  src: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCardMedia'
	})(CardMedia);
	
	exports.default = _default;

/***/ },
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CardMedia.default;
	  }
	});
	
	var _CardMedia = _interopRequireDefault(__webpack_require__(1145));

/***/ },
/* 1147 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _utils = __webpack_require__(19);
	
	var _SwitchBase = _interopRequireDefault(__webpack_require__(407));
	
	var _CheckBoxOutlineBlank = _interopRequireDefault(__webpack_require__(1304));
	
	var _CheckBox = _interopRequireDefault(__webpack_require__(1303));
	
	var _colorManipulator = __webpack_require__(63);
	
	var _IndeterminateCheckBox = _interopRequireDefault(__webpack_require__(1306));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      color: theme.palette.text.secondary
	    },
	
	    /* Pseudo-class applied to the root element if `checked={true}`. */
	    checked: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Pseudo-class applied to the root element if `indeterminate={true}`. */
	    indeterminate: {},
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      '&$checked': {
	        color: theme.palette.primary.main,
	        '&:hover': {
	          backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	          // Reset on touch devices, it doesn't add specificity
	          '@media (hover: none)': {
	            backgroundColor: 'transparent'
	          }
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      '&$checked': {
	        color: theme.palette.secondary.main,
	        '&:hover': {
	          backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	          // Reset on touch devices, it doesn't add specificity
	          '@media (hover: none)': {
	            backgroundColor: 'transparent'
	          }
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var defaultCheckedIcon = /*#__PURE__*/React.createElement(_CheckBox.default, null);
	var defaultIcon = /*#__PURE__*/React.createElement(_CheckBoxOutlineBlank.default, null);
	var defaultIndeterminateIcon = /*#__PURE__*/React.createElement(_IndeterminateCheckBox.default, null);
	var Checkbox = /*#__PURE__*/React.forwardRef(function Checkbox(props, ref) {
	  var _props$checkedIcon = props.checkedIcon,
	      checkedIcon = _props$checkedIcon === void 0 ? defaultCheckedIcon : _props$checkedIcon,
	      classes = props.classes,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'secondary' : _props$color,
	      _props$icon = props.icon,
	      iconProp = _props$icon === void 0 ? defaultIcon : _props$icon,
	      _props$indeterminate = props.indeterminate,
	      indeterminate = _props$indeterminate === void 0 ? false : _props$indeterminate,
	      _props$indeterminateI = props.indeterminateIcon,
	      indeterminateIconProp = _props$indeterminateI === void 0 ? defaultIndeterminateIcon : _props$indeterminateI,
	      inputProps = props.inputProps,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      other = (0, _objectWithoutProperties2.default)(props, ["checkedIcon", "classes", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps", "size"]);
	  var icon = indeterminate ? indeterminateIconProp : iconProp;
	  var indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
	  return /*#__PURE__*/React.createElement(_SwitchBase.default, (0, _extends2.default)({
	    type: "checkbox",
	    classes: {
	      root: (0, _clsx.default)(classes.root, classes["color".concat((0, _capitalize.default)(color))], indeterminate && classes.indeterminate),
	      checked: classes.checked,
	      disabled: classes.disabled
	    },
	    color: color,
	    inputProps: (0, _extends2.default)({
	      'data-indeterminate': indeterminate
	    }, inputProps),
	    icon: /*#__PURE__*/React.cloneElement(icon, {
	      fontSize: icon.props.fontSize === undefined && size === "small" ? size : icon.props.fontSize
	    }),
	    checkedIcon: /*#__PURE__*/React.cloneElement(indeterminateIcon, {
	      fontSize: indeterminateIcon.props.fontSize === undefined && size === "small" ? size : indeterminateIcon.props.fontSize
	    }),
	    ref: ref
	  }, other));
	});
	 false ? Checkbox.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is checked.
	   */
	  checkedIcon: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'primary', 'secondary']),
	
	  /**
	   * If `true`, the checkbox will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is unchecked.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * If `true`, the component appears indeterminate.
	   * This does not set the native input element to indeterminate due
	   * to inconsistent behavior across browsers.
	   * However, we set a `data-indeterminate` attribute on the input.
	   */
	  indeterminate: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is indeterminate.
	   */
	  indeterminateIcon: _propTypes.default.node,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * The size of the checkbox.
	   * `small` is equivalent to the dense checkbox styling.
	   */
	  size: _propTypes.default.oneOf(['medium', 'small']),
	
	  /**
	   * The value of the component. The DOM API casts this to a string.
	   * The browser uses "on" as the default value.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCheckbox'
	})(Checkbox);
	
	exports.default = _default;

/***/ },
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _Cancel = _interopRequireDefault(__webpack_require__(1302));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _colorManipulator = __webpack_require__(63);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(47));
	
	var _unsupportedProp = _interopRequireDefault(__webpack_require__(311));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(69));
	
	var styles = function styles(theme) {
	  var backgroundColor = theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700];
	  var deleteIconColor = (0, _colorManipulator.fade)(theme.palette.text.primary, 0.26);
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      fontFamily: theme.typography.fontFamily,
	      fontSize: theme.typography.pxToRem(13),
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      height: 32,
	      color: theme.palette.getContrastText(backgroundColor),
	      backgroundColor: backgroundColor,
	      borderRadius: 32 / 2,
	      whiteSpace: 'nowrap',
	      transition: theme.transitions.create(['background-color', 'box-shadow']),
	      // label will inherit this from root, then `clickable` class overrides this for both
	      cursor: 'default',
	      // We disable the focus ring for mouse, touch and keyboard users.
	      outline: 0,
	      textDecoration: 'none',
	      border: 'none',
	      // Remove `button` border
	      padding: 0,
	      // Remove `button` padding
	      verticalAlign: 'middle',
	      boxSizing: 'border-box',
	      '&$disabled': {
	        opacity: 0.5,
	        pointerEvents: 'none'
	      },
	      '& $avatar': {
	        marginLeft: 5,
	        marginRight: -6,
	        width: 24,
	        height: 24,
	        color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
	        fontSize: theme.typography.pxToRem(12)
	      },
	      '& $avatarColorPrimary': {
	        color: theme.palette.primary.contrastText,
	        backgroundColor: theme.palette.primary.dark
	      },
	      '& $avatarColorSecondary': {
	        color: theme.palette.secondary.contrastText,
	        backgroundColor: theme.palette.secondary.dark
	      },
	      '& $avatarSmall': {
	        marginLeft: 4,
	        marginRight: -4,
	        width: 18,
	        height: 18,
	        fontSize: theme.typography.pxToRem(10)
	      }
	    },
	
	    /* Styles applied to the root element if `size="small"`. */
	    sizeSmall: {
	      height: 24
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      backgroundColor: theme.palette.primary.main,
	      color: theme.palette.primary.contrastText
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      backgroundColor: theme.palette.secondary.main,
	      color: theme.palette.secondary.contrastText
	    },
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `onClick` is defined or `clickable={true}`. */
	    clickable: {
	      userSelect: 'none',
	      WebkitTapHighlightColor: 'transparent',
	      cursor: 'pointer',
	      '&:hover, &:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.08)
	      },
	      '&:active': {
	        boxShadow: theme.shadows[1]
	      }
	    },
	
	    /* Styles applied to the root element if `onClick` and `color="primary"` is defined or `clickable={true}`. */
	    clickableColorPrimary: {
	      '&:hover, &:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.primary.main, 0.08)
	      }
	    },
	
	    /* Styles applied to the root element if `onClick` and `color="secondary"` is defined or `clickable={true}`. */
	    clickableColorSecondary: {
	      '&:hover, &:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.secondary.main, 0.08)
	      }
	    },
	
	    /* Styles applied to the root element if `onDelete` is defined. */
	    deletable: {
	      '&:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.08)
	      }
	    },
	
	    /* Styles applied to the root element if `onDelete` and `color="primary"` is defined. */
	    deletableColorPrimary: {
	      '&:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.primary.main, 0.2)
	      }
	    },
	
	    /* Styles applied to the root element if `onDelete` and `color="secondary"` is defined. */
	    deletableColorSecondary: {
	      '&:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.secondary.main, 0.2)
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"`. */
	    outlined: {
	      backgroundColor: 'transparent',
	      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
	      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.text.primary, theme.palette.action.hoverOpacity)
	      },
	      '& $avatar': {
	        marginLeft: 4
	      },
	      '& $avatarSmall': {
	        marginLeft: 2
	      },
	      '& $icon': {
	        marginLeft: 4
	      },
	      '& $iconSmall': {
	        marginLeft: 2
	      },
	      '& $deleteIcon': {
	        marginRight: 5
	      },
	      '& $deleteIconSmall': {
	        marginRight: 3
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
	    outlinedPrimary: {
	      color: theme.palette.primary.main,
	      border: "1px solid ".concat(theme.palette.primary.main),
	      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
	    outlinedSecondary: {
	      color: theme.palette.secondary.main,
	      border: "1px solid ".concat(theme.palette.secondary.main),
	      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity)
	      }
	    },
	    // TODO v5: remove
	
	    /* Styles applied to the `avatar` element. */
	    avatar: {},
	
	    /* Styles applied to the `avatar` element if `size="small"`. */
	    avatarSmall: {},
	
	    /* Styles applied to the `avatar` element if `color="primary"`. */
	    avatarColorPrimary: {},
	
	    /* Styles applied to the `avatar` element if `color="secondary"`. */
	    avatarColorSecondary: {},
	
	    /* Styles applied to the `icon` element. */
	    icon: {
	      color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
	      marginLeft: 5,
	      marginRight: -6
	    },
	
	    /* Styles applied to the `icon` element if `size="small"`. */
	    iconSmall: {
	      width: 18,
	      height: 18,
	      marginLeft: 4,
	      marginRight: -4
	    },
	
	    /* Styles applied to the `icon` element if `color="primary"`. */
	    iconColorPrimary: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the `icon` element if `color="secondary"`. */
	    iconColorSecondary: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the label `span` element. */
	    label: {
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      paddingLeft: 12,
	      paddingRight: 12,
	      whiteSpace: 'nowrap'
	    },
	
	    /* Styles applied to the label `span` element if `size="small"`. */
	    labelSmall: {
	      paddingLeft: 8,
	      paddingRight: 8
	    },
	
	    /* Styles applied to the `deleteIcon` element. */
	    deleteIcon: {
	      WebkitTapHighlightColor: 'transparent',
	      color: deleteIconColor,
	      height: 22,
	      width: 22,
	      cursor: 'pointer',
	      margin: '0 5px 0 -6px',
	      '&:hover': {
	        color: (0, _colorManipulator.fade)(deleteIconColor, 0.4)
	      }
	    },
	
	    /* Styles applied to the `deleteIcon` element if `size="small"`. */
	    deleteIconSmall: {
	      height: 16,
	      width: 16,
	      marginRight: 4,
	      marginLeft: -4
	    },
	
	    /* Styles applied to the deleteIcon element if `color="primary"` and `variant="default"`. */
	    deleteIconColorPrimary: {
	      color: (0, _colorManipulator.fade)(theme.palette.primary.contrastText, 0.7),
	      '&:hover, &:active': {
	        color: theme.palette.primary.contrastText
	      }
	    },
	
	    /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="default"`. */
	    deleteIconColorSecondary: {
	      color: (0, _colorManipulator.fade)(theme.palette.secondary.contrastText, 0.7),
	      '&:hover, &:active': {
	        color: theme.palette.secondary.contrastText
	      }
	    },
	
	    /* Styles applied to the deleteIcon element if `color="primary"` and `variant="outlined"`. */
	    deleteIconOutlinedColorPrimary: {
	      color: (0, _colorManipulator.fade)(theme.palette.primary.main, 0.7),
	      '&:hover, &:active': {
	        color: theme.palette.primary.main
	      }
	    },
	
	    /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="outlined"`. */
	    deleteIconOutlinedColorSecondary: {
	      color: (0, _colorManipulator.fade)(theme.palette.secondary.main, 0.7),
	      '&:hover, &:active': {
	        color: theme.palette.secondary.main
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	
	function isDeleteKeyboardEvent(keyboardEvent) {
	  return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
	}
	/**
	 * Chips represent complex entities in small blocks, such as a contact.
	 */
	
	
	var Chip = /*#__PURE__*/React.forwardRef(function Chip(props, ref) {
	  var avatarProp = props.avatar,
	      classes = props.classes,
	      className = props.className,
	      clickableProp = props.clickable,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      ComponentProp = props.component,
	      deleteIconProp = props.deleteIcon,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      iconProp = props.icon,
	      label = props.label,
	      onClick = props.onClick,
	      onDelete = props.onDelete,
	      onKeyDown = props.onKeyDown,
	      onKeyUp = props.onKeyUp,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'default' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["avatar", "classes", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant"]);
	  var chipRef = React.useRef(null);
	  var handleRef = (0, _useForkRef.default)(chipRef, ref);
	
	  var handleDeleteIconClick = function handleDeleteIconClick(event) {
	    // Stop the event from bubbling up to the `Chip`
	    event.stopPropagation();
	
	    if (onDelete) {
	      onDelete(event);
	    }
	  };
	
	  var handleKeyDown = function handleKeyDown(event) {
	    // Ignore events from children of `Chip`.
	    if (event.currentTarget === event.target && isDeleteKeyboardEvent(event)) {
	      // will be handled in keyUp, otherwise some browsers
	      // might init navigation
	      event.preventDefault();
	    }
	
	    if (onKeyDown) {
	      onKeyDown(event);
	    }
	  };
	
	  var handleKeyUp = function handleKeyUp(event) {
	    // Ignore events from children of `Chip`.
	    if (event.currentTarget === event.target) {
	      if (onDelete && isDeleteKeyboardEvent(event)) {
	        onDelete(event);
	      } else if (event.key === 'Escape' && chipRef.current) {
	        chipRef.current.blur();
	      }
	    }
	
	    if (onKeyUp) {
	      onKeyUp(event);
	    }
	  };
	
	  var clickable = clickableProp !== false && onClick ? true : clickableProp;
	  var small = size === 'small';
	  var Component = ComponentProp || (clickable ? _ButtonBase.default : 'div');
	  var moreProps = Component === _ButtonBase.default ? {
	    component: 'div'
	  } : {};
	  var deleteIcon = null;
	
	  if (onDelete) {
	    var customClasses = (0, _clsx.default)(color !== 'default' && (variant === "default" ? classes["deleteIconColor".concat((0, _capitalize.default)(color))] : classes["deleteIconOutlinedColor".concat((0, _capitalize.default)(color))]), small && classes.deleteIconSmall);
	    deleteIcon = deleteIconProp && /*#__PURE__*/React.isValidElement(deleteIconProp) ? /*#__PURE__*/React.cloneElement(deleteIconProp, {
	      className: (0, _clsx.default)(deleteIconProp.props.className, classes.deleteIcon, customClasses),
	      onClick: handleDeleteIconClick
	    }) : /*#__PURE__*/React.createElement(_Cancel.default, {
	      className: (0, _clsx.default)(classes.deleteIcon, customClasses),
	      onClick: handleDeleteIconClick
	    });
	  }
	
	  var avatar = null;
	
	  if (avatarProp && /*#__PURE__*/React.isValidElement(avatarProp)) {
	    avatar = /*#__PURE__*/React.cloneElement(avatarProp, {
	      className: (0, _clsx.default)(classes.avatar, avatarProp.props.className, small && classes.avatarSmall, color !== 'default' && classes["avatarColor".concat((0, _capitalize.default)(color))])
	    });
	  }
	
	  var icon = null;
	
	  if (iconProp && /*#__PURE__*/React.isValidElement(iconProp)) {
	    icon = /*#__PURE__*/React.cloneElement(iconProp, {
	      className: (0, _clsx.default)(classes.icon, iconProp.props.className, small && classes.iconSmall, color !== 'default' && classes["iconColor".concat((0, _capitalize.default)(color))])
	    });
	  }
	
	  if (false) {
	    if (avatar && icon) {
	      console.error('Material-UI: The Chip component can not handle the avatar ' + 'and the icon prop at the same time. Pick one.');
	    }
	  }
	
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    role: clickable || onDelete ? 'button' : undefined,
	    className: (0, _clsx.default)(classes.root, className, color !== 'default' && [classes["color".concat((0, _capitalize.default)(color))], clickable && classes["clickableColor".concat((0, _capitalize.default)(color))], onDelete && classes["deletableColor".concat((0, _capitalize.default)(color))]], variant !== "default" && [classes.outlined, {
	      'primary': classes.outlinedPrimary,
	      'secondary': classes.outlinedSecondary
	    }[color]], disabled && classes.disabled, small && classes.sizeSmall, clickable && classes.clickable, onDelete && classes.deletable),
	    "aria-disabled": disabled ? true : undefined,
	    tabIndex: clickable || onDelete ? 0 : undefined,
	    onClick: onClick,
	    onKeyDown: handleKeyDown,
	    onKeyUp: handleKeyUp,
	    ref: handleRef
	  }, moreProps, other), avatar || icon, /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.label, small && classes.labelSmall)
	  }, label), deleteIcon);
	});
	 false ? Chip.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Avatar element.
	   */
	  avatar: _propTypes.default.element,
	
	  /**
	   * This prop isn't supported.
	   * Use the `component` prop if you need to change the children structure.
	   */
	  children: _unsupportedProp.default,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the chip will appear clickable, and will raise when pressed,
	   * even if the onClick prop is not defined.
	   * If false, the chip will not be clickable, even if onClick prop is defined.
	   * This can be used, for example,
	   * along with the component prop to indicate an anchor Chip is clickable.
	   */
	  clickable: _propTypes.default.bool,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * Override the default delete icon element. Shown only if `onDelete` is set.
	   */
	  deleteIcon: _propTypes.default.element,
	
	  /**
	   * If `true`, the chip should be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Icon element.
	   */
	  icon: _propTypes.default.element,
	
	  /**
	   * The content of the label.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * Callback function fired when the delete icon is clicked.
	   * If set, the delete icon will be shown.
	   */
	  onDelete: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyUp: _propTypes.default.func,
	
	  /**
	   * The size of the chip.
	   */
	  size: _propTypes.default.oneOf(['medium', 'small']),
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['default', 'outlined'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiChip'
	})(Chip);
	
	exports.default = _default;

/***/ },
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _utils = __webpack_require__(19);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var SIZE = 44;
	
	function getRelativeValue(value, min, max) {
	  return (Math.min(Math.max(min, value), max) - min) / (max - min);
	}
	
	function easeOut(t) {
	  t = getRelativeValue(t, 0, 1); // https://gist.github.com/gre/1650294
	
	  t = (t -= 1) * t * t + 1;
	  return t;
	}
	
	function easeIn(t) {
	  return t * t;
	}
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'inline-block'
	    },
	
	    /* Styles applied to the root element if `variant="static"`. */
	    static: {
	      transition: theme.transitions.create('transform')
	    },
	
	    /* Styles applied to the root element if `variant="indeterminate"`. */
	    indeterminate: {
	      animation: '$circular-rotate 1.4s linear infinite'
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the `svg` element. */
	    svg: {
	      display: 'block' // Keeps the progress centered
	
	    },
	
	    /* Styles applied to the `circle` svg path. */
	    circle: {
	      stroke: 'currentColor' // Use butt to follow the specification, by chance, it's already the default CSS value.
	      // strokeLinecap: 'butt',
	
	    },
	
	    /* Styles applied to the `circle` svg path if `variant="static"`. */
	    circleStatic: {
	      transition: theme.transitions.create('stroke-dashoffset')
	    },
	
	    /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */
	    circleIndeterminate: {
	      animation: '$circular-dash 1.4s ease-in-out infinite',
	      // Some default value that looks fine waiting for the animation to kicks in.
	      strokeDasharray: '80px, 200px',
	      strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.
	
	    },
	    '@keyframes circular-rotate': {
	      '0%': {
	        // Fix IE 11 wobbly
	        transformOrigin: '50% 50%'
	      },
	      '100%': {
	        transform: 'rotate(360deg)'
	      }
	    },
	    '@keyframes circular-dash': {
	      '0%': {
	        strokeDasharray: '1px, 200px',
	        strokeDashoffset: '0px'
	      },
	      '50%': {
	        strokeDasharray: '100px, 200px',
	        strokeDashoffset: '-15px'
	      },
	      '100%': {
	        strokeDasharray: '100px, 200px',
	        strokeDashoffset: '-125px'
	      }
	    },
	
	    /* Styles applied to the `circle` svg path if `disableShrink={true}`. */
	    circleDisableShrink: {
	      animation: 'none'
	    }
	  };
	};
	/**
	 * ## ARIA
	 *
	 * If the progress bar is describing the loading progress of a particular region of a page,
	 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
	 * attribute to `true` on that region until it has finished loading.
	 */
	
	
	exports.styles = styles;
	var CircularProgress = /*#__PURE__*/React.forwardRef(function CircularProgress(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      _props$disableShrink = props.disableShrink,
	      disableShrink = _props$disableShrink === void 0 ? false : _props$disableShrink,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 40 : _props$size,
	      style = props.style,
	      _props$thickness = props.thickness,
	      thickness = _props$thickness === void 0 ? 3.6 : _props$thickness,
	      _props$value = props.value,
	      value = _props$value === void 0 ? 0 : _props$value,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'indeterminate' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"]);
	  var circleStyle = {};
	  var rootStyle = {};
	  var rootProps = {};
	
	  if (variant === 'determinate' || variant === 'static') {
	    var circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
	    circleStyle.strokeDasharray = circumference.toFixed(3);
	    rootProps['aria-valuenow'] = Math.round(value);
	
	    if (variant === 'static') {
	      circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
	      rootStyle.transform = 'rotate(-90deg)';
	    } else {
	      circleStyle.strokeDashoffset = "".concat((easeIn((100 - value) / 100) * circumference).toFixed(3), "px");
	      rootStyle.transform = "rotate(".concat((easeOut(value / 70) * 270).toFixed(3), "deg)");
	    }
	  }
	
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, color !== 'inherit' && classes["color".concat((0, _capitalize.default)(color))], {
	      'indeterminate': classes.indeterminate,
	      'static': classes.static
	    }[variant]),
	    style: (0, _extends2.default)({
	      width: size,
	      height: size
	    }, rootStyle, style),
	    ref: ref,
	    role: "progressbar"
	  }, rootProps, other), /*#__PURE__*/React.createElement("svg", {
	    className: classes.svg,
	    viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE)
	  }, /*#__PURE__*/React.createElement("circle", {
	    className: (0, _clsx.default)(classes.circle, disableShrink && classes.circleDisableShrink, {
	      'indeterminate': classes.circleIndeterminate,
	      'static': classes.circleStatic
	    }[variant]),
	    style: circleStyle,
	    cx: SIZE,
	    cy: SIZE,
	    r: (SIZE - thickness) / 2,
	    fill: "none",
	    strokeWidth: thickness
	  })));
	});
	 false ? CircularProgress.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['inherit', 'primary', 'secondary']),
	
	  /**
	   * If `true`, the shrink animation is disabled.
	   * This only works if variant is `indeterminate`.
	   */
	  disableShrink: (0, _utils.chainPropTypes)(_propTypes.default.bool, function (props) {
	    if (props.disableShrink && props.variant && props.variant !== 'indeterminate') {
	      return new Error('Material-UI: You have provided the `disableShrink` prop ' + 'with a variant other than `indeterminate`. This will have no effect.');
	    }
	
	    return null;
	  }),
	
	  /**
	   * The size of the circle.
	   * If using a number, the pixel unit is assumed.
	   * If using a string, you need to provide the CSS unit, e.g '3rem'.
	   */
	  size: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The thickness of the circle.
	   */
	  thickness: _propTypes.default.number,
	
	  /**
	   * The value of the progress indicator for the determinate and static variants.
	   * Value between 0 and 100.
	   */
	  value: _propTypes.default.number,
	
	  /**
	   * The variant to use.
	   * Use indeterminate when there is no progress value.
	   */
	  variant: _propTypes.default.oneOf(['determinate', 'indeterminate', 'static'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCircularProgress',
	  flip: false
	})(CircularProgress);
	
	exports.default = _default;

/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CircularProgress.default;
	  }
	});
	
	var _CircularProgress = _interopRequireDefault(__webpack_require__(1149));

/***/ },
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(51));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(90));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(47));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(117));
	
	var _utils = __webpack_require__(19);
	
	function mapEventPropToEvent(eventProp) {
	  return eventProp.substring(2).toLowerCase();
	}
	
	function clickedRootScrollbar(event) {
	  return document.documentElement.clientWidth < event.clientX || document.documentElement.clientHeight < event.clientY;
	}
	/**
	 * Listen for click events that occur somewhere in the document, outside of the element itself.
	 * For instance, if you need to hide a menu when people click anywhere else on your page.
	 */
	
	
	function ClickAwayListener(props) {
	  var children = props.children,
	      _props$disableReactTr = props.disableReactTree,
	      disableReactTree = _props$disableReactTr === void 0 ? false : _props$disableReactTr,
	      _props$mouseEvent = props.mouseEvent,
	      mouseEvent = _props$mouseEvent === void 0 ? 'onClick' : _props$mouseEvent,
	      onClickAway = props.onClickAway,
	      _props$touchEvent = props.touchEvent,
	      touchEvent = _props$touchEvent === void 0 ? 'onTouchEnd' : _props$touchEvent;
	  var movedRef = React.useRef(false);
	  var nodeRef = React.useRef(null);
	  var mountedRef = React.useRef(false);
	  var syntheticEventRef = React.useRef(false);
	  React.useEffect(function () {
	    mountedRef.current = true;
	    return function () {
	      mountedRef.current = false;
	    };
	  }, []); // can be removed once we drop support for non ref forwarding class components
	
	  var handleOwnRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    nodeRef.current = ReactDOM.findDOMNode(instance);
	  }, []);
	  var handleRef = (0, _useForkRef.default)(children.ref, handleOwnRef); // The handler doesn't take event.defaultPrevented into account:
	  //
	  // event.preventDefault() is meant to stop default behaviours like
	  // clicking a checkbox to check it, hitting a button to submit a form,
	  // and hitting left arrow to move the cursor in a text input etc.
	  // Only special HTML elements have these default behaviors.
	
	  var handleClickAway = (0, _useEventCallback.default)(function (event) {
	    // Given developers can stop the propagation of the synthetic event,
	    // we can only be confident with a positive value.
	    var insideReactTree = syntheticEventRef.current;
	    syntheticEventRef.current = false; // 1. IE 11 support, which trigger the handleClickAway even after the unbind
	    // 2. The child might render null.
	    // 3. Behave like a blur listener.
	
	    if (!mountedRef.current || !nodeRef.current || clickedRootScrollbar(event)) {
	      return;
	    } // Do not act if user performed touchmove
	
	
	    if (movedRef.current) {
	      movedRef.current = false;
	      return;
	    }
	
	    var insideDOM; // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
	
	    if (event.composedPath) {
	      insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
	    } else {
	      // TODO v6 remove dead logic https://caniuse.com/#search=composedPath.
	      var doc = (0, _ownerDocument.default)(nodeRef.current);
	      insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
	    }
	
	    if (!insideDOM && (disableReactTree || !insideReactTree)) {
	      onClickAway(event);
	    }
	  }); // Keep track of mouse/touch events that bubbled up through the portal.
	
	  var createHandleSynthetic = function createHandleSynthetic(handlerName) {
	    return function (event) {
	      syntheticEventRef.current = true;
	      var childrenPropsHandler = children.props[handlerName];
	
	      if (childrenPropsHandler) {
	        childrenPropsHandler(event);
	      }
	    };
	  };
	
	  var childrenProps = {
	    ref: handleRef
	  };
	
	  if (touchEvent !== false) {
	    childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
	  }
	
	  React.useEffect(function () {
	    if (touchEvent !== false) {
	      var mappedTouchEvent = mapEventPropToEvent(touchEvent);
	      var doc = (0, _ownerDocument.default)(nodeRef.current);
	
	      var handleTouchMove = function handleTouchMove() {
	        movedRef.current = true;
	      };
	
	      doc.addEventListener(mappedTouchEvent, handleClickAway);
	      doc.addEventListener('touchmove', handleTouchMove);
	      return function () {
	        doc.removeEventListener(mappedTouchEvent, handleClickAway);
	        doc.removeEventListener('touchmove', handleTouchMove);
	      };
	    }
	
	    return undefined;
	  }, [handleClickAway, touchEvent]);
	
	  if (mouseEvent !== false) {
	    childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
	  }
	
	  React.useEffect(function () {
	    if (mouseEvent !== false) {
	      var mappedMouseEvent = mapEventPropToEvent(mouseEvent);
	      var doc = (0, _ownerDocument.default)(nodeRef.current);
	      doc.addEventListener(mappedMouseEvent, handleClickAway);
	      return function () {
	        doc.removeEventListener(mappedMouseEvent, handleClickAway);
	      };
	    }
	
	    return undefined;
	  }, [handleClickAway, mouseEvent]);
	  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.cloneElement(children, childrenProps));
	}
	
	 false ? ClickAwayListener.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The wrapped element.
	   */
	  children: _utils.elementAcceptingRef.isRequired,
	
	  /**
	   * If `true`, the React tree is ignored and only the DOM tree is considered.
	   * This prop changes how portaled elements are handled.
	   */
	  disableReactTree: _propTypes.default.bool,
	
	  /**
	   * The mouse event to listen to. You can disable the listener by providing `false`.
	   */
	  mouseEvent: _propTypes.default.oneOf(['onClick', 'onMouseDown', 'onMouseUp', false]),
	
	  /**
	   * Callback fired when a "click away" event is detected.
	   */
	  onClickAway: _propTypes.default.func.isRequired,
	
	  /**
	   * The touch event to listen to. You can disable the listener by providing `false`.
	   */
	  touchEvent: _propTypes.default.oneOf(['onTouchEnd', 'onTouchStart', false])
	} : void 0;
	
	if (false) {
	  // eslint-disable-next-line
	  ClickAwayListener['propTypes' + ''] = (0, _utils.exactProp)(ClickAwayListener.propTypes);
	}
	
	var _default = ClickAwayListener;
	exports.default = _default;

/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(80));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactTransitionGroup = __webpack_require__(230);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _transitions = __webpack_require__(99);
	
	var _utils = __webpack_require__(193);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(59));
	
	var _utils2 = __webpack_require__(627);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the container element. */
	    container: {
	      height: 0,
	      overflow: 'hidden',
	      transition: theme.transitions.create('height')
	    },
	
	    /* Styles applied to the container element when the transition has entered. */
	    entered: {
	      height: 'auto',
	      overflow: 'visible'
	    },
	
	    /* Styles applied to the container element when the transition has exited and `collapsedHeight` != 0px. */
	    hidden: {
	      visibility: 'hidden'
	    },
	
	    /* Styles applied to the outer wrapper element. */
	    wrapper: {
	      // Hack to get children with a negative margin to not falsify the height computation.
	      display: 'flex'
	    },
	
	    /* Styles applied to the inner wrapper element. */
	    wrapperInner: {
	      width: '100%'
	    }
	  };
	};
	/**
	 * The Collapse transition is used by the
	 * [Vertical Stepper](/components/steppers/#vertical-stepper) StepContent component.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	
	exports.styles = styles;
	var Collapse = /*#__PURE__*/React.forwardRef(function Collapse(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$collapsedHeigh = props.collapsedHeight,
	      collapsedHeightProp = _props$collapsedHeigh === void 0 ? '0px' : _props$collapsedHeigh,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$disableStrictM = props.disableStrictModeCompat,
	      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
	      inProp = props.in,
	      onEnter = props.onEnter,
	      onEntered = props.onEntered,
	      onEntering = props.onEntering,
	      onExit = props.onExit,
	      onExited = props.onExited,
	      onExiting = props.onExiting,
	      style = props.style,
	      _props$timeout = props.timeout,
	      timeout = _props$timeout === void 0 ? _transitions.duration.standard : _props$timeout,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _reactTransitionGroup.Transition : _props$TransitionComp,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "collapsedHeight", "component", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);
	  var theme = (0, _useTheme.default)();
	  var timer = React.useRef();
	  var wrapperRef = React.useRef(null);
	  var autoTransitionDuration = React.useRef();
	  var collapsedHeight = typeof collapsedHeightProp === 'number' ? "".concat(collapsedHeightProp, "px") : collapsedHeightProp;
	  React.useEffect(function () {
	    return function () {
	      clearTimeout(timer.current);
	    };
	  }, []);
	  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
	  var nodeRef = React.useRef(null);
	  var handleRef = (0, _utils2.useForkRef)(ref, enableStrictModeCompat ? nodeRef : undefined);
	
	  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
	    return function (nodeOrAppearing, maybeAppearing) {
	      if (callback) {
	        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
	            _ref2 = (0, _slicedToArray2.default)(_ref, 2),
	            node = _ref2[0],
	            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
	
	
	        if (isAppearing === undefined) {
	          callback(node);
	        } else {
	          callback(node, isAppearing);
	        }
	      }
	    };
	  };
	
	  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
	    node.style.height = collapsedHeight;
	
	    if (onEnter) {
	      onEnter(node, isAppearing);
	    }
	  });
	  var handleEntering = normalizedTransitionCallback(function (node, isAppearing) {
	    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
	
	    var _getTransitionProps = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'enter'
	    }),
	        transitionDuration = _getTransitionProps.duration;
	
	    if (timeout === 'auto') {
	      var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
	      node.style.transitionDuration = "".concat(duration2, "ms");
	      autoTransitionDuration.current = duration2;
	    } else {
	      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
	    }
	
	    node.style.height = "".concat(wrapperHeight, "px");
	
	    if (onEntering) {
	      onEntering(node, isAppearing);
	    }
	  });
	  var handleEntered = normalizedTransitionCallback(function (node, isAppearing) {
	    node.style.height = 'auto';
	
	    if (onEntered) {
	      onEntered(node, isAppearing);
	    }
	  });
	  var handleExit = normalizedTransitionCallback(function (node) {
	    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
	    node.style.height = "".concat(wrapperHeight, "px");
	
	    if (onExit) {
	      onExit(node);
	    }
	  });
	  var handleExited = normalizedTransitionCallback(onExited);
	  var handleExiting = normalizedTransitionCallback(function (node) {
	    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
	
	    var _getTransitionProps2 = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'exit'
	    }),
	        transitionDuration = _getTransitionProps2.duration;
	
	    if (timeout === 'auto') {
	      var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
	      node.style.transitionDuration = "".concat(duration2, "ms");
	      autoTransitionDuration.current = duration2;
	    } else {
	      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
	    }
	
	    node.style.height = collapsedHeight;
	
	    if (onExiting) {
	      onExiting(node);
	    }
	  });
	
	  var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
	    var next = enableStrictModeCompat ? nodeOrNext : maybeNext;
	
	    if (timeout === 'auto') {
	      timer.current = setTimeout(next, autoTransitionDuration.current || 0);
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    in: inProp,
	    onEnter: handleEnter,
	    onEntered: handleEntered,
	    onEntering: handleEntering,
	    onExit: handleExit,
	    onExited: handleExited,
	    onExiting: handleExiting,
	    addEndListener: addEndListener,
	    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
	    timeout: timeout === 'auto' ? null : timeout
	  }, other), function (state, childProps) {
	    return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	      className: (0, _clsx.default)(classes.container, className, {
	        'entered': classes.entered,
	        'exited': !inProp && collapsedHeight === '0px' && classes.hidden
	      }[state]),
	      style: (0, _extends2.default)({
	        minHeight: collapsedHeight
	      }, style),
	      ref: handleRef
	    }, childProps), /*#__PURE__*/React.createElement("div", {
	      className: classes.wrapper,
	      ref: wrapperRef
	    }, /*#__PURE__*/React.createElement("div", {
	      className: classes.wrapperInner
	    }, children)));
	  });
	});
	 false ? Collapse.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content node to be collapsed.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The height of the container when collapsed.
	   */
	  collapsedHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * Enable this prop if you encounter 'Function components cannot be given refs',
	   * use `unstable_createStrictModeTheme`,
	   * and can't forward the ref in the passed `Component`.
	   */
	  disableStrictModeCompat: _propTypes.default.bool,
	
	  /**
	   * If `true`, the component will transition in.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   *
	   * Set to 'auto' to automatically calculate transition time based on height.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.oneOf(['auto']), _propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : void 0;
	Collapse.muiSupportAuto = true;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCollapse'
	})(Collapse);
	
	exports.default = _default;

/***/ },
/* 1153 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(62));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _defineProperty2.default)({
	      width: '100%',
	      marginLeft: 'auto',
	      boxSizing: 'border-box',
	      marginRight: 'auto',
	      paddingLeft: theme.spacing(2),
	      paddingRight: theme.spacing(2),
	      display: 'block'
	    }, theme.breakpoints.up('sm'), {
	      paddingLeft: theme.spacing(3),
	      paddingRight: theme.spacing(3)
	    }),
	
	    /* Styles applied to the root element if `disableGutters={true}`. */
	    disableGutters: {
	      paddingLeft: 0,
	      paddingRight: 0
	    },
	
	    /* Styles applied to the root element if `fixed={true}`. */
	    fixed: Object.keys(theme.breakpoints.values).reduce(function (acc, breakpoint) {
	      var value = theme.breakpoints.values[breakpoint];
	
	      if (value !== 0) {
	        acc[theme.breakpoints.up(breakpoint)] = {
	          maxWidth: value
	        };
	      }
	
	      return acc;
	    }, {}),
	
	    /* Styles applied to the root element if `maxWidth="xs"`. */
	    maxWidthXs: (0, _defineProperty2.default)({}, theme.breakpoints.up('xs'), {
	      maxWidth: Math.max(theme.breakpoints.values.xs, 444)
	    }),
	
	    /* Styles applied to the root element if `maxWidth="sm"`. */
	    maxWidthSm: (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), {
	      maxWidth: theme.breakpoints.values.sm
	    }),
	
	    /* Styles applied to the root element if `maxWidth="md"`. */
	    maxWidthMd: (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), {
	      maxWidth: theme.breakpoints.values.md
	    }),
	
	    /* Styles applied to the root element if `maxWidth="lg"`. */
	    maxWidthLg: (0, _defineProperty2.default)({}, theme.breakpoints.up('lg'), {
	      maxWidth: theme.breakpoints.values.lg
	    }),
	
	    /* Styles applied to the root element if `maxWidth="xl"`. */
	    maxWidthXl: (0, _defineProperty2.default)({}, theme.breakpoints.up('xl'), {
	      maxWidth: theme.breakpoints.values.xl
	    })
	  };
	};
	
	exports.styles = styles;
	var Container = /*#__PURE__*/React.forwardRef(function Container(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$disableGutters = props.disableGutters,
	      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
	      _props$fixed = props.fixed,
	      fixed = _props$fixed === void 0 ? false : _props$fixed,
	      _props$maxWidth = props.maxWidth,
	      maxWidth = _props$maxWidth === void 0 ? 'lg' : _props$maxWidth,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "disableGutters", "fixed", "maxWidth"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, fixed && classes.fixed, disableGutters && classes.disableGutters, maxWidth !== false && classes["maxWidth".concat((0, _capitalize.default)(String(maxWidth)))]),
	    ref: ref
	  }, other));
	});
	 false ? Container.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * @ignore
	   */
	  children: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, the left and right padding is removed.
	   */
	  disableGutters: _propTypes.default.bool,
	
	  /**
	   * Set the max-width to match the min-width of the current breakpoint.
	   * This is useful if you'd prefer to design for a fixed set of sizes
	   * instead of trying to accommodate a fully fluid viewport.
	   * It's fluid by default.
	   */
	  fixed: _propTypes.default.bool,
	
	  /**
	   * Determine the max-width of the container.
	   * The container width grows with the size of the screen.
	   * Set to `false` to disable `maxWidth`.
	   */
	  maxWidth: _propTypes.default.oneOf(['lg', 'md', 'sm', 'xl', 'xs', false])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiContainer'
	})(Container);
	
	exports.default = _default;

/***/ },
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Container.default;
	  }
	});
	
	var _Container = _interopRequireDefault(__webpack_require__(1153));

/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = exports.body = exports.html = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _utils = __webpack_require__(19);
	
	var html = {
	  WebkitFontSmoothing: 'antialiased',
	  // Antialiasing.
	  MozOsxFontSmoothing: 'grayscale',
	  // Antialiasing.
	  // Change from `box-sizing: content-box` so that `width`
	  // is not affected by `padding` or `border`.
	  boxSizing: 'border-box'
	};
	exports.html = html;
	
	var body = function body(theme) {
	  return (0, _extends2.default)({
	    color: theme.palette.text.primary
	  }, theme.typography.body2, {
	    backgroundColor: theme.palette.background.default,
	    '@media print': {
	      // Save printer ink.
	      backgroundColor: theme.palette.common.white
	    }
	  });
	};
	
	exports.body = body;
	
	var styles = function styles(theme) {
	  return {
	    '@global': {
	      html: html,
	      '*, *::before, *::after': {
	        boxSizing: 'inherit'
	      },
	      'strong, b': {
	        fontWeight: theme.typography.fontWeightBold
	      },
	      body: (0, _extends2.default)({
	        margin: 0
	      }, body(theme), {
	        // Add support for document.body.requestFullScreen().
	        // Other elements, if background transparent, are not supported.
	        '&::backdrop': {
	          backgroundColor: theme.palette.background.default
	        }
	      })
	    }
	  };
	};
	/**
	 * Kickstart an elegant, consistent, and simple baseline to build upon.
	 */
	
	
	exports.styles = styles;
	
	function CssBaseline(props) {
	  /* eslint-disable no-unused-vars */
	  var _props$children = props.children,
	      children = _props$children === void 0 ? null : _props$children,
	      classes = props.classes;
	  /* eslint-enable no-unused-vars */
	
	  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
	}
	
	 false ? CssBaseline.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * You can wrap a node.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object
	} : void 0;
	
	if (false) {
	  // eslint-disable-next-line
	  CssBaseline['propTypes' + ''] = (0, _utils.exactProp)(CssBaseline.propTypes);
	}
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCssBaseline'
	})(CssBaseline);
	
	exports.default = _default;

/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CssBaseline.default;
	  }
	});
	
	var _CssBaseline = _interopRequireDefault(__webpack_require__(1155));

/***/ },
/* 1157 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(62));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var _Modal = _interopRequireDefault(__webpack_require__(307));
	
	var _Backdrop = _interopRequireDefault(__webpack_require__(393));
	
	var _Fade = _interopRequireDefault(__webpack_require__(397));
	
	var _transitions = __webpack_require__(99);
	
	var _Paper = _interopRequireDefault(__webpack_require__(89));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      '@media print': {
	        // Use !important to override the Modal inline-style.
	        position: 'absolute !important'
	      }
	    },
	
	    /* Styles applied to the container element if `scroll="paper"`. */
	    scrollPaper: {
	      display: 'flex',
	      justifyContent: 'center',
	      alignItems: 'center'
	    },
	
	    /* Styles applied to the container element if `scroll="body"`. */
	    scrollBody: {
	      overflowY: 'auto',
	      overflowX: 'hidden',
	      textAlign: 'center',
	      '&:after': {
	        content: '""',
	        display: 'inline-block',
	        verticalAlign: 'middle',
	        height: '100%',
	        width: '0'
	      }
	    },
	
	    /* Styles applied to the container element. */
	    container: {
	      height: '100%',
	      '@media print': {
	        height: 'auto'
	      },
	      // We disable the focus ring for mouse, touch and keyboard users.
	      outline: 0
	    },
	
	    /* Styles applied to the `Paper` component. */
	    paper: {
	      margin: 32,
	      position: 'relative',
	      overflowY: 'auto',
	      // Fix IE 11 issue, to remove at some point.
	      '@media print': {
	        overflowY: 'visible',
	        boxShadow: 'none'
	      }
	    },
	
	    /* Styles applied to the `Paper` component if `scroll="paper"`. */
	    paperScrollPaper: {
	      display: 'flex',
	      flexDirection: 'column',
	      maxHeight: 'calc(100% - 64px)'
	    },
	
	    /* Styles applied to the `Paper` component if `scroll="body"`. */
	    paperScrollBody: {
	      display: 'inline-block',
	      verticalAlign: 'middle',
	      textAlign: 'left' // 'initial' doesn't work on IE 11
	
	    },
	
	    /* Styles applied to the `Paper` component if `maxWidth=false`. */
	    paperWidthFalse: {
	      maxWidth: 'calc(100% - 64px)'
	    },
	
	    /* Styles applied to the `Paper` component if `maxWidth="xs"`. */
	    paperWidthXs: {
	      maxWidth: Math.max(theme.breakpoints.values.xs, 444),
	      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 32 * 2), {
	        maxWidth: 'calc(100% - 64px)'
	      })
	    },
	
	    /* Styles applied to the `Paper` component if `maxWidth="sm"`. */
	    paperWidthSm: {
	      maxWidth: theme.breakpoints.values.sm,
	      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.sm + 32 * 2), {
	        maxWidth: 'calc(100% - 64px)'
	      })
	    },
	
	    /* Styles applied to the `Paper` component if `maxWidth="md"`. */
	    paperWidthMd: {
	      maxWidth: theme.breakpoints.values.md,
	      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.md + 32 * 2), {
	        maxWidth: 'calc(100% - 64px)'
	      })
	    },
	
	    /* Styles applied to the `Paper` component if `maxWidth="lg"`. */
	    paperWidthLg: {
	      maxWidth: theme.breakpoints.values.lg,
	      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.lg + 32 * 2), {
	        maxWidth: 'calc(100% - 64px)'
	      })
	    },
	
	    /* Styles applied to the `Paper` component if `maxWidth="xl"`. */
	    paperWidthXl: {
	      maxWidth: theme.breakpoints.values.xl,
	      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.xl + 32 * 2), {
	        maxWidth: 'calc(100% - 64px)'
	      })
	    },
	
	    /* Styles applied to the `Paper` component if `fullWidth={true}`. */
	    paperFullWidth: {
	      width: 'calc(100% - 64px)'
	    },
	
	    /* Styles applied to the `Paper` component if `fullScreen={true}`. */
	    paperFullScreen: {
	      margin: 0,
	      width: '100%',
	      maxWidth: '100%',
	      height: '100%',
	      maxHeight: 'none',
	      borderRadius: 0,
	      '&$paperScrollBody': {
	        margin: 0,
	        maxWidth: '100%'
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var defaultTransitionDuration = {
	  enter: _transitions.duration.enteringScreen,
	  exit: _transitions.duration.leavingScreen
	};
	/**
	 * Dialogs are overlaid modal paper based components with a backdrop.
	 */
	
	var Dialog = /*#__PURE__*/React.forwardRef(function Dialog(props, ref) {
	  var BackdropProps = props.BackdropProps,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$disableBackdro = props.disableBackdropClick,
	      disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
	      _props$disableEscapeK = props.disableEscapeKeyDown,
	      disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
	      _props$fullScreen = props.fullScreen,
	      fullScreen = _props$fullScreen === void 0 ? false : _props$fullScreen,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$maxWidth = props.maxWidth,
	      maxWidth = _props$maxWidth === void 0 ? 'sm' : _props$maxWidth,
	      onBackdropClick = props.onBackdropClick,
	      onClose = props.onClose,
	      onEnter = props.onEnter,
	      onEntered = props.onEntered,
	      onEntering = props.onEntering,
	      onEscapeKeyDown = props.onEscapeKeyDown,
	      onExit = props.onExit,
	      onExited = props.onExited,
	      onExiting = props.onExiting,
	      open = props.open,
	      _props$PaperComponent = props.PaperComponent,
	      PaperComponent = _props$PaperComponent === void 0 ? _Paper.default : _props$PaperComponent,
	      _props$PaperProps = props.PaperProps,
	      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
	      _props$scroll = props.scroll,
	      scroll = _props$scroll === void 0 ? 'paper' : _props$scroll,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Fade.default : _props$TransitionComp,
	      _props$transitionDura = props.transitionDuration,
	      transitionDuration = _props$transitionDura === void 0 ? defaultTransitionDuration : _props$transitionDura,
	      TransitionProps = props.TransitionProps,
	      ariaDescribedby = props['aria-describedby'],
	      ariaLabelledby = props['aria-labelledby'],
	      other = (0, _objectWithoutProperties2.default)(props, ["BackdropProps", "children", "classes", "className", "disableBackdropClick", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "onEnter", "onEntered", "onEntering", "onEscapeKeyDown", "onExit", "onExited", "onExiting", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps", "aria-describedby", "aria-labelledby"]);
	  var mouseDownTarget = React.useRef();
	
	  var handleMouseDown = function handleMouseDown(event) {
	    mouseDownTarget.current = event.target;
	  };
	
	  var handleBackdropClick = function handleBackdropClick(event) {
	    // Ignore the events not coming from the "backdrop"
	    // We don't want to close the dialog when clicking the dialog content.
	    if (event.target !== event.currentTarget) {
	      return;
	    } // Make sure the event starts and ends on the same DOM element.
	
	
	    if (event.target !== mouseDownTarget.current) {
	      return;
	    }
	
	    mouseDownTarget.current = null;
	
	    if (onBackdropClick) {
	      onBackdropClick(event);
	    }
	
	    if (!disableBackdropClick && onClose) {
	      onClose(event, 'backdropClick');
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(_Modal.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    BackdropComponent: _Backdrop.default,
	    BackdropProps: (0, _extends2.default)({
	      transitionDuration: transitionDuration
	    }, BackdropProps),
	    closeAfterTransition: true,
	    disableBackdropClick: disableBackdropClick,
	    disableEscapeKeyDown: disableEscapeKeyDown,
	    onEscapeKeyDown: onEscapeKeyDown,
	    onClose: onClose,
	    open: open,
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    appear: true,
	    in: open,
	    timeout: transitionDuration,
	    onEnter: onEnter,
	    onEntering: onEntering,
	    onEntered: onEntered,
	    onExit: onExit,
	    onExiting: onExiting,
	    onExited: onExited,
	    role: "none presentation"
	  }, TransitionProps), /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.container, classes["scroll".concat((0, _capitalize.default)(scroll))]),
	    onMouseUp: handleBackdropClick,
	    onMouseDown: handleMouseDown
	  }, /*#__PURE__*/React.createElement(PaperComponent, (0, _extends2.default)({
	    elevation: 24,
	    role: "dialog",
	    "aria-describedby": ariaDescribedby,
	    "aria-labelledby": ariaLabelledby
	  }, PaperProps, {
	    className: (0, _clsx.default)(classes.paper, classes["paperScroll".concat((0, _capitalize.default)(scroll))], classes["paperWidth".concat((0, _capitalize.default)(String(maxWidth)))], PaperProps.className, fullScreen && classes.paperFullScreen, fullWidth && classes.paperFullWidth)
	  }), children))));
	});
	 false ? Dialog.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The id(s) of the element(s) that describe the dialog.
	   */
	  'aria-describedby': _propTypes.default.string,
	
	  /**
	   * The id(s) of the element(s) that label the dialog.
	   */
	  'aria-labelledby': _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  BackdropProps: _propTypes.default.object,
	
	  /**
	   * Dialog children, usually the included sub-components.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, clicking the backdrop will not fire the `onClose` callback.
	   */
	  disableBackdropClick: _propTypes.default.bool,
	
	  /**
	   * If `true`, hitting escape will not fire the `onClose` callback.
	   */
	  disableEscapeKeyDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, the dialog will be full-screen
	   */
	  fullScreen: _propTypes.default.bool,
	
	  /**
	   * If `true`, the dialog stretches to `maxWidth`.
	   *
	   * Notice that the dialog width grow is limited by the default margin.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * Determine the max-width of the dialog.
	   * The dialog width grows with the size of the screen.
	   * Set to `false` to disable `maxWidth`.
	   */
	  maxWidth: _propTypes.default.oneOf(['lg', 'md', 'sm', 'xl', 'xs', false]),
	
	  /**
	   * Callback fired when the backdrop is clicked.
	   */
	  onBackdropClick: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired before the dialog enters.
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired when the dialog has entered.
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired when the dialog is entering.
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired when the escape key is pressed,
	   * `disableKeyboard` is false and the modal is in focus.
	   */
	  onEscapeKeyDown: _propTypes.default.func,
	
	  /**
	   * Callback fired before the dialog exits.
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired when the dialog has exited.
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * Callback fired when the dialog is exiting.
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * If `true`, the Dialog is open.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * The component used to render the body of the dialog.
	   */
	  PaperComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the [`Paper`](/api/paper/) element.
	   */
	  PaperProps: _propTypes.default.object,
	
	  /**
	   * Determine the container for scrolling the dialog.
	   */
	  scroll: _propTypes.default.oneOf(['body', 'paper']),
	
	  /**
	   * The component used for the transition.
	   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
	   */
	  TransitionComponent: _propTypes.default.elementType,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
	   */
	  TransitionProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDialog'
	})(Dialog);
	
	exports.default = _default;

/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    alignItems: 'center',
	    padding: 8,
	    justifyContent: 'flex-end',
	    flex: '0 0 auto'
	  },
	
	  /* Styles applied to the root element if `disableSpacing={false}`. */
	  spacing: {
	    '& > :not(:first-child)': {
	      marginLeft: 8
	    }
	  }
	};
	exports.styles = styles;
	var DialogActions = /*#__PURE__*/React.forwardRef(function DialogActions(props, ref) {
	  var _props$disableSpacing = props.disableSpacing,
	      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
	      classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["disableSpacing", "classes", "className"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, !disableSpacing && classes.spacing),
	    ref: ref
	  }, other));
	});
	 false ? DialogActions.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the actions do not have additional margin.
	   */
	  disableSpacing: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDialogActions'
	})(DialogActions);
	
	exports.default = _default;

/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      flex: '1 1 auto',
	      WebkitOverflowScrolling: 'touch',
	      // Add iOS momentum scrolling.
	      overflowY: 'auto',
	      padding: '8px 24px',
	      '&:first-child': {
	        // dialog without title
	        paddingTop: 20
	      }
	    },
	
	    /* Styles applied to the root element if `dividers={true}`. */
	    dividers: {
	      padding: '16px 24px',
	      borderTop: "1px solid ".concat(theme.palette.divider),
	      borderBottom: "1px solid ".concat(theme.palette.divider)
	    }
	  };
	};
	
	exports.styles = styles;
	var DialogContent = /*#__PURE__*/React.forwardRef(function DialogContent(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$dividers = props.dividers,
	      dividers = _props$dividers === void 0 ? false : _props$dividers,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "dividers"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, dividers && classes.dividers),
	    ref: ref
	  }, other));
	});
	 false ? DialogContent.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Display the top and bottom dividers.
	   */
	  dividers: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDialogContent'
	})(DialogContent);
	
	exports.default = _default;

/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _Typography = _interopRequireDefault(__webpack_require__(75));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    marginBottom: 12
	  }
	};
	exports.styles = styles;
	var DialogContentText = /*#__PURE__*/React.forwardRef(function DialogContentText(props, ref) {
	  return /*#__PURE__*/React.createElement(_Typography.default, (0, _extends2.default)({
	    component: "p",
	    variant: "body1",
	    color: "textSecondary",
	    ref: ref
	  }, props));
	});
	 false ? DialogContentText.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDialogContentText'
	})(DialogContentText);
	
	exports.default = _default;

/***/ },
/* 1161 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _DialogContentText.default;
	  }
	});
	
	var _DialogContentText = _interopRequireDefault(__webpack_require__(1160));

/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _Typography = _interopRequireDefault(__webpack_require__(75));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    margin: 0,
	    padding: '16px 24px',
	    flex: '0 0 auto'
	  }
	};
	exports.styles = styles;
	var DialogTitle = /*#__PURE__*/React.forwardRef(function DialogTitle(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$disableTypogra = props.disableTypography,
	      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableTypography"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), disableTypography ? children : /*#__PURE__*/React.createElement(_Typography.default, {
	    component: "h2",
	    variant: "h6"
	  }, children));
	});
	 false ? DialogTitle.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the children won't be wrapped by a typography component.
	   * For instance, this can be useful to render an h4 instead of the default h2.
	   */
	  disableTypography: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDialogTitle'
	})(DialogTitle);
	
	exports.default = _default;

/***/ },
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _colorManipulator = __webpack_require__(63);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      height: 1,
	      margin: 0,
	      // Reset browser default style.
	      border: 'none',
	      flexShrink: 0,
	      backgroundColor: theme.palette.divider
	    },
	
	    /* Styles applied to the root element if `absolute={true}`. */
	    absolute: {
	      position: 'absolute',
	      bottom: 0,
	      left: 0,
	      width: '100%'
	    },
	
	    /* Styles applied to the root element if `variant="inset"`. */
	    inset: {
	      marginLeft: 72
	    },
	
	    /* Styles applied to the root element if `light={true}`. */
	    light: {
	      backgroundColor: (0, _colorManipulator.fade)(theme.palette.divider, 0.08)
	    },
	
	    /* Styles applied to the root element if `variant="middle"`. */
	    middle: {
	      marginLeft: theme.spacing(2),
	      marginRight: theme.spacing(2)
	    },
	
	    /* Styles applied to the root element if `orientation="vertical"`. */
	    vertical: {
	      height: '100%',
	      width: 1
	    },
	
	    /* Styles applied to the root element if `flexItem={true}`. */
	    flexItem: {
	      alignSelf: 'stretch',
	      height: 'auto'
	    }
	  };
	};
	
	exports.styles = styles;
	var Divider = /*#__PURE__*/React.forwardRef(function Divider(props, ref) {
	  var _props$absolute = props.absolute,
	      absolute = _props$absolute === void 0 ? false : _props$absolute,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'hr' : _props$component,
	      _props$flexItem = props.flexItem,
	      flexItem = _props$flexItem === void 0 ? false : _props$flexItem,
	      _props$light = props.light,
	      light = _props$light === void 0 ? false : _props$light,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      _props$role = props.role,
	      role = _props$role === void 0 ? Component !== 'hr' ? 'separator' : undefined : _props$role,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'fullWidth' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["absolute", "classes", "className", "component", "flexItem", "light", "orientation", "role", "variant"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, variant !== 'fullWidth' && classes[variant], absolute && classes.absolute, flexItem && classes.flexItem, light && classes.light, orientation === 'vertical' && classes.vertical),
	    role: role,
	    ref: ref
	  }, other));
	});
	 false ? Divider.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Absolutely position the element.
	   */
	  absolute: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, a vertical divider will have the correct height when used in flex container.
	   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
	   */
	  flexItem: _propTypes.default.bool,
	
	  /**
	   * If `true`, the divider will have a lighter color.
	   */
	  light: _propTypes.default.bool,
	
	  /**
	   * The divider orientation.
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']),
	
	  /**
	   * @ignore
	   */
	  role: _propTypes.default.string,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['fullWidth', 'inset', 'middle'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDivider'
	})(Divider);
	
	exports.default = _default;

/***/ },
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Drawer.default;
	  }
	});
	
	var _Drawer = _interopRequireDefault(__webpack_require__(395));

/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _toArray2 = _interopRequireDefault(__webpack_require__(571));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(80));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactIs = __webpack_require__(72);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _utils = __webpack_require__(19);
	
	var _Collapse = _interopRequireDefault(__webpack_require__(296));
	
	var _Paper = _interopRequireDefault(__webpack_require__(89));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _ExpansionPanelContext = _interopRequireDefault(__webpack_require__(579));
	
	var _useControlled3 = _interopRequireDefault(__webpack_require__(133));
	
	var styles = function styles(theme) {
	  var transition = {
	    duration: theme.transitions.duration.shortest
	  };
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      transition: theme.transitions.create(['margin'], transition),
	      '&:before': {
	        position: 'absolute',
	        left: 0,
	        top: -1,
	        right: 0,
	        height: 1,
	        content: '""',
	        opacity: 1,
	        backgroundColor: theme.palette.divider,
	        transition: theme.transitions.create(['opacity', 'background-color'], transition)
	      },
	      '&:first-child': {
	        '&:before': {
	          display: 'none'
	        }
	      },
	      '&$expanded': {
	        margin: '16px 0',
	        '&:first-child': {
	          marginTop: 0
	        },
	        '&:last-child': {
	          marginBottom: 0
	        },
	        '&:before': {
	          opacity: 0
	        }
	      },
	      '&$expanded + &': {
	        '&:before': {
	          display: 'none'
	        }
	      },
	      '&$disabled': {
	        backgroundColor: theme.palette.action.disabledBackground
	      }
	    },
	
	    /* Styles applied to the root element if `square={false}`. */
	    rounded: {
	      borderRadius: 0,
	      '&:first-child': {
	        borderTopLeftRadius: theme.shape.borderRadius,
	        borderTopRightRadius: theme.shape.borderRadius
	      },
	      '&:last-child': {
	        borderBottomLeftRadius: theme.shape.borderRadius,
	        borderBottomRightRadius: theme.shape.borderRadius,
	        // Fix a rendering issue on Edge
	        '@supports (-ms-ime-align: auto)': {
	          borderBottomLeftRadius: 0,
	          borderBottomRightRadius: 0
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `expanded={true}`. */
	    expanded: {},
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {}
	  };
	};
	
	exports.styles = styles;
	var warnedOnce = false;
	/**
	 * ⚠️ The ExpansionPanel component was renamed to Accordion to use a more common naming convention.
	 *
	 * You should use `import { Accordion } from '@material-ui/core'`
	 * or `import Accordion from '@material-ui/core/Accordion'`.
	 */
	
	var ExpansionPanel = /*#__PURE__*/React.forwardRef(function ExpansionPanel(props, ref) {
	  if (false) {
	    if (!warnedOnce) {
	      warnedOnce = true;
	      console.error(['Material-UI: the ExpansionPanel component was renamed to Accordion to use a more common naming convention.', '', "You should use `import { Accordion } from '@material-ui/core'`", "or `import Accordion from '@material-ui/core/Accordion'`"].join('\n'));
	    }
	  }
	
	  var childrenProp = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$defaultExpande = props.defaultExpanded,
	      defaultExpanded = _props$defaultExpande === void 0 ? false : _props$defaultExpande,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      expandedProp = props.expanded,
	      onChange = props.onChange,
	      _props$square = props.square,
	      square = _props$square === void 0 ? false : _props$square,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Collapse.default : _props$TransitionComp,
	      TransitionProps = props.TransitionProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "defaultExpanded", "disabled", "expanded", "onChange", "square", "TransitionComponent", "TransitionProps"]);
	
	  var _useControlled = (0, _useControlled3.default)({
	    controlled: expandedProp,
	    default: defaultExpanded,
	    name: 'ExpansionPanel',
	    state: 'expanded'
	  }),
	      _useControlled2 = (0, _slicedToArray2.default)(_useControlled, 2),
	      expanded = _useControlled2[0],
	      setExpandedState = _useControlled2[1];
	
	  var handleChange = React.useCallback(function (event) {
	    setExpandedState(!expanded);
	
	    if (onChange) {
	      onChange(event, !expanded);
	    }
	  }, [expanded, onChange, setExpandedState]);
	
	  var _React$Children$toArr = React.Children.toArray(childrenProp),
	      _React$Children$toArr2 = (0, _toArray2.default)(_React$Children$toArr),
	      summary = _React$Children$toArr2[0],
	      children = _React$Children$toArr2.slice(1);
	
	  var contextValue = React.useMemo(function () {
	    return {
	      expanded: expanded,
	      disabled: disabled,
	      toggle: handleChange
	    };
	  }, [expanded, disabled, handleChange]);
	  return /*#__PURE__*/React.createElement(_Paper.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, expanded && classes.expanded, disabled && classes.disabled, !square && classes.rounded),
	    ref: ref,
	    square: square
	  }, other), /*#__PURE__*/React.createElement(_ExpansionPanelContext.default.Provider, {
	    value: contextValue
	  }, summary), /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    in: expanded,
	    timeout: "auto"
	  }, TransitionProps), /*#__PURE__*/React.createElement("div", {
	    "aria-labelledby": summary.props.id,
	    id: summary.props['aria-controls'],
	    role: "region"
	  }, children)));
	});
	 false ? ExpansionPanel.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the expansion panel.
	   */
	  children: (0, _utils.chainPropTypes)(_propTypes.default.node.isRequired, function (props) {
	    var summary = React.Children.toArray(props.children)[0];
	
	    if ((0, _reactIs.isFragment)(summary)) {
	      return new Error("Material-UI: The ExpansionPanel doesn't accept a Fragment as a child. " + 'Consider providing an array instead.');
	    }
	
	    if (! /*#__PURE__*/React.isValidElement(summary)) {
	      return new Error('Material-UI: Expected the first child of ExpansionPanel to be a valid element.');
	    }
	
	    return null;
	  }),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, expands the panel by default.
	   */
	  defaultExpanded: _propTypes.default.bool,
	
	  /**
	   * If `true`, the panel will be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, expands the panel, otherwise collapse it.
	   * Setting this prop enables control over the panel.
	   */
	  expanded: _propTypes.default.bool,
	
	  /**
	   * Callback fired when the expand/collapse state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {boolean} expanded The `expanded` state of the panel.
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * If `true`, rounded corners are disabled.
	   */
	  square: _propTypes.default.bool,
	
	  /**
	   * The component used for the collapse effect.
	   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
	   */
	  TransitionComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
	   */
	  TransitionProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiExpansionPanel'
	})(ExpansionPanel);
	
	exports.default = _default;

/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    alignItems: 'center',
	    padding: 8,
	    justifyContent: 'flex-end'
	  },
	
	  /* Styles applied to the root element if `disableSpacing={false}`. */
	  spacing: {
	    '& > :not(:first-child)': {
	      marginLeft: 8
	    }
	  }
	};
	exports.styles = styles;
	var warnedOnce = false;
	/**
	 * ⚠️ The ExpansionPanelActions component was renamed to AccordionActions to use a more common naming convention.
	 *
	 * You should use `import { AccordionActions } from '@material-ui/core'`
	 * or `import AccordionActions from '@material-ui/core/AccordionActions'`.
	 */
	
	var ExpansionPanelActions = /*#__PURE__*/React.forwardRef(function ExpansionPanelActions(props, ref) {
	  if (false) {
	    if (!warnedOnce) {
	      warnedOnce = true;
	      console.error(['Material-UI: the ExpansionPanelActions component was renamed to AccordionActions to use a more common naming convention.', '', "You should use `import { AccordionActions } from '@material-ui/core'`", "or `import AccordionActions from '@material-ui/core/AccordionActions'`"].join('\n'));
	    }
	  }
	
	  var classes = props.classes,
	      className = props.className,
	      _props$disableSpacing = props.disableSpacing,
	      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "disableSpacing"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, !disableSpacing && classes.spacing),
	    ref: ref
	  }, other));
	});
	 false ? ExpansionPanelActions.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the actions do not have additional margin.
	   */
	  disableSpacing: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiExpansionPanelActions'
	})(ExpansionPanelActions);
	
	exports.default = _default;

/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelActions.default;
	  }
	});
	
	var _ExpansionPanelActions = _interopRequireDefault(__webpack_require__(1166));

/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'flex',
	      padding: theme.spacing(1, 2, 2)
	    }
	  };
	};
	
	exports.styles = styles;
	var warnedOnce = false;
	/**
	 * ⚠️ The ExpansionPanelDetails component was renamed to AccordionDetails to use a more common naming convention.
	 *
	 * You should use `import { AccordionDetails } from '@material-ui/core'`
	 * or `import AccordionDetails from '@material-ui/core/AccordionDetails'`.
	 */
	
	var ExpansionPanelDetails = /*#__PURE__*/React.forwardRef(function ExpansionPanelDetails(props, ref) {
	  if (false) {
	    if (!warnedOnce) {
	      warnedOnce = true;
	      console.error(['Material-UI: the ExpansionPanelDetails component was renamed to AccordionDetails to use a more common naming convention.', '', "You should use `import { AccordionDetails } from '@material-ui/core'`", "or `import AccordionDetails from '@material-ui/core/AccordionActions'`"].join('\n'));
	    }
	  }
	
	  var classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other));
	});
	 false ? ExpansionPanelDetails.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the expansion panel details.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiExpansionPanelDetails'
	})(ExpansionPanelDetails);
	
	exports.default = _default;

/***/ },
/* 1169 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(69));
	
	var _IconButton = _interopRequireDefault(__webpack_require__(236));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _ExpansionPanelContext = _interopRequireDefault(__webpack_require__(579));
	
	/* eslint-disable jsx-a11y/aria-role */
	var styles = function styles(theme) {
	  var transition = {
	    duration: theme.transitions.duration.shortest
	  };
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'flex',
	      minHeight: 8 * 6,
	      transition: theme.transitions.create(['min-height', 'background-color'], transition),
	      padding: theme.spacing(0, 2),
	      '&:hover:not($disabled)': {
	        cursor: 'pointer'
	      },
	      '&$expanded': {
	        minHeight: 64
	      },
	      '&$focused': {
	        backgroundColor: theme.palette.action.focus
	      },
	      '&$disabled': {
	        opacity: theme.palette.action.disabledOpacity
	      }
	    },
	
	    /* Pseudo-class applied to the root element, children wrapper element and `IconButton` component if `expanded={true}`. */
	    expanded: {},
	
	    /* Pseudo-class applied to the root element if `focused={true}`. */
	    focused: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the children wrapper element. */
	    content: {
	      display: 'flex',
	      flexGrow: 1,
	      transition: theme.transitions.create(['margin'], transition),
	      margin: '12px 0',
	      '&$expanded': {
	        margin: '20px 0'
	      }
	    },
	
	    /* Styles applied to the `IconButton` component when `expandIcon` is supplied. */
	    expandIcon: {
	      transform: 'rotate(0deg)',
	      transition: theme.transitions.create('transform', transition),
	      '&:hover': {
	        // Disable the hover effect for the IconButton,
	        // because a hover effect should apply to the entire Expand button and
	        // not only to the IconButton.
	        backgroundColor: 'transparent'
	      },
	      '&$expanded': {
	        transform: 'rotate(180deg)'
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var warnedOnce = false;
	/**
	 * ⚠️ The ExpansionPanelSummary component was renamed to AccordionSummary to use a more common naming convention.
	 *
	 * You should use `import { AccordionSummary } from '@material-ui/core'`
	 * or `import AccordionSummary from '@material-ui/core/AccordionSummary'`.
	 */
	
	var ExpansionPanelSummary = /*#__PURE__*/React.forwardRef(function ExpansionPanelSummary(props, ref) {
	  if (false) {
	    if (!warnedOnce) {
	      warnedOnce = true;
	      console.error(['Material-UI: the ExpansionPanelSummary component was renamed to AccordionSummary to use a more common naming convention.', '', "You should use `import { AccordionSummary } from '@material-ui/core'`", "or `import AccordionSummary from '@material-ui/core/AccordionSummary'`"].join('\n'));
	    }
	  }
	
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      expandIcon = props.expandIcon,
	      IconButtonProps = props.IconButtonProps,
	      onBlur = props.onBlur,
	      onClick = props.onClick,
	      onFocusVisible = props.onFocusVisible,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "expandIcon", "IconButtonProps", "onBlur", "onClick", "onFocusVisible"]);
	
	  var _React$useState = React.useState(false),
	      focusedState = _React$useState[0],
	      setFocusedState = _React$useState[1];
	
	  var handleFocusVisible = function handleFocusVisible(event) {
	    setFocusedState(true);
	
	    if (onFocusVisible) {
	      onFocusVisible(event);
	    }
	  };
	
	  var handleBlur = function handleBlur(event) {
	    setFocusedState(false);
	
	    if (onBlur) {
	      onBlur(event);
	    }
	  };
	
	  var _React$useContext = React.useContext(_ExpansionPanelContext.default),
	      _React$useContext$dis = _React$useContext.disabled,
	      disabled = _React$useContext$dis === void 0 ? false : _React$useContext$dis,
	      expanded = _React$useContext.expanded,
	      toggle = _React$useContext.toggle;
	
	  var handleChange = function handleChange(event) {
	    if (toggle) {
	      toggle(event);
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    focusRipple: false,
	    disableRipple: true,
	    disabled: disabled,
	    component: "div",
	    "aria-expanded": expanded,
	    className: (0, _clsx.default)(classes.root, className, disabled && classes.disabled, expanded && classes.expanded, focusedState && classes.focused),
	    onFocusVisible: handleFocusVisible,
	    onBlur: handleBlur,
	    onClick: handleChange,
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.content, expanded && classes.expanded)
	  }, children), expandIcon && /*#__PURE__*/React.createElement(_IconButton.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.expandIcon, expanded && classes.expanded),
	    edge: "end",
	    component: "div",
	    tabIndex: null,
	    role: null,
	    "aria-hidden": true
	  }, IconButtonProps), expandIcon));
	});
	 false ? ExpansionPanelSummary.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the expansion panel summary.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The icon to display as the expand indicator.
	   */
	  expandIcon: _propTypes.default.node,
	
	  /**
	   * Props applied to the `IconButton` element wrapping the expand icon.
	   */
	  IconButtonProps: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component is focused with a keyboard.
	   * We trigger a `onFocus` callback too.
	   */
	  onFocusVisible: _propTypes.default.func
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiExpansionPanelSummary'
	})(ExpansionPanelSummary);
	
	exports.default = _default;

/***/ },
/* 1170 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(69));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({}, theme.typography.button, {
	      boxSizing: 'border-box',
	      minHeight: 36,
	      transition: theme.transitions.create(['background-color', 'box-shadow', 'border'], {
	        duration: theme.transitions.duration.short
	      }),
	      borderRadius: '50%',
	      padding: 0,
	      minWidth: 0,
	      width: 56,
	      height: 56,
	      boxShadow: theme.shadows[6],
	      '&:active': {
	        boxShadow: theme.shadows[12]
	      },
	      color: theme.palette.getContrastText(theme.palette.grey[300]),
	      backgroundColor: theme.palette.grey[300],
	      '&:hover': {
	        backgroundColor: theme.palette.grey.A100,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.grey[300]
	        },
	        '&$disabled': {
	          backgroundColor: theme.palette.action.disabledBackground
	        },
	        textDecoration: 'none'
	      },
	      '&$focusVisible': {
	        boxShadow: theme.shadows[6]
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled,
	        boxShadow: theme.shadows[0],
	        backgroundColor: theme.palette.action.disabledBackground
	      }
	    }),
	
	    /* Styles applied to the span element that wraps the children. */
	    label: {
	      width: '100%',
	      // assure the correct width for iOS Safari
	      display: 'inherit',
	      alignItems: 'inherit',
	      justifyContent: 'inherit'
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    primary: {
	      color: theme.palette.primary.contrastText,
	      backgroundColor: theme.palette.primary.main,
	      '&:hover': {
	        backgroundColor: theme.palette.primary.dark,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.primary.main
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    secondary: {
	      color: theme.palette.secondary.contrastText,
	      backgroundColor: theme.palette.secondary.main,
	      '&:hover': {
	        backgroundColor: theme.palette.secondary.dark,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.secondary.main
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="extended"`. */
	    extended: {
	      borderRadius: 48 / 2,
	      padding: '0 16px',
	      width: 'auto',
	      minHeight: 'auto',
	      minWidth: 48,
	      height: 48,
	      '&$sizeSmall': {
	        width: 'auto',
	        padding: '0 8px',
	        borderRadius: 34 / 2,
	        minWidth: 34,
	        height: 34
	      },
	      '&$sizeMedium': {
	        width: 'auto',
	        padding: '0 16px',
	        borderRadius: 40 / 2,
	        minWidth: 40,
	        height: 40
	      }
	    },
	
	    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
	    focusVisible: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the root element if `size="small"``. */
	    sizeSmall: {
	      width: 40,
	      height: 40
	    },
	
	    /* Styles applied to the root element if `size="medium"``. */
	    sizeMedium: {
	      width: 48,
	      height: 48
	    }
	  };
	};
	
	exports.styles = styles;
	var Fab = /*#__PURE__*/React.forwardRef(function Fab(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      _props$component = props.component,
	      component = _props$component === void 0 ? 'button' : _props$component,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableFocusRi = props.disableFocusRipple,
	      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
	      focusVisibleClassName = props.focusVisibleClassName,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'large' : _props$size,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'round' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "disabled", "disableFocusRipple", "focusVisibleClassName", "size", "variant"]);
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, variant !== "round" && classes.extended, size !== 'large' && classes["size".concat((0, _capitalize.default)(size))], disabled && classes.disabled, {
	      'primary': classes.primary,
	      'secondary': classes.secondary,
	      'inherit': classes.colorInherit
	    }[color]),
	    component: component,
	    disabled: disabled,
	    focusRipple: !disableFocusRipple,
	    focusVisibleClassName: (0, _clsx.default)(classes.focusVisible, focusVisibleClassName),
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("span", {
	    className: classes.label
	  }, children));
	});
	 false ? Fab.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the button.
	   */
	  children: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, the button will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the  keyboard focus ripple will be disabled.
	   */
	  disableFocusRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  focusVisibleClassName: _propTypes.default.string,
	
	  /**
	   * The URL to link to when the button is clicked.
	   * If defined, an `a` element will be used as the root node.
	   */
	  href: _propTypes.default.string,
	
	  /**
	   * The size of the button.
	   * `small` is equivalent to the dense button styling.
	   */
	  size: _propTypes.default.oneOf(['large', 'medium', 'small']),
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['extended', 'round'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFab'
	})(Fab);
	
	exports.default = _default;

/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(80));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactTransitionGroup = __webpack_require__(230);
	
	var _transitions = __webpack_require__(99);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(59));
	
	var _utils = __webpack_require__(193);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(47));
	
	var styles = {
	  entering: {
	    opacity: 1
	  },
	  entered: {
	    opacity: 1
	  }
	};
	var defaultTimeout = {
	  enter: _transitions.duration.enteringScreen,
	  exit: _transitions.duration.leavingScreen
	};
	/**
	 * The Fade transition is used by the [Modal](/components/modal/) component.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	var Fade = /*#__PURE__*/React.forwardRef(function Fade(props, ref) {
	  var children = props.children,
	      _props$disableStrictM = props.disableStrictModeCompat,
	      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
	      inProp = props.in,
	      onEnter = props.onEnter,
	      onEntered = props.onEntered,
	      onEntering = props.onEntering,
	      onExit = props.onExit,
	      onExited = props.onExited,
	      onExiting = props.onExiting,
	      style = props.style,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _reactTransitionGroup.Transition : _props$TransitionComp,
	      _props$timeout = props.timeout,
	      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "TransitionComponent", "timeout"]);
	  var theme = (0, _useTheme.default)();
	  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
	  var nodeRef = React.useRef(null);
	  var foreignRef = (0, _useForkRef.default)(children.ref, ref);
	  var handleRef = (0, _useForkRef.default)(enableStrictModeCompat ? nodeRef : undefined, foreignRef);
	
	  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
	    return function (nodeOrAppearing, maybeAppearing) {
	      if (callback) {
	        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
	            _ref2 = (0, _slicedToArray2.default)(_ref, 2),
	            node = _ref2[0],
	            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
	
	
	        if (isAppearing === undefined) {
	          callback(node);
	        } else {
	          callback(node, isAppearing);
	        }
	      }
	    };
	  };
	
	  var handleEntering = normalizedTransitionCallback(onEntering);
	  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
	    (0, _utils.reflow)(node); // So the animation always start from the start.
	
	    var transitionProps = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'enter'
	    });
	    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
	    node.style.transition = theme.transitions.create('opacity', transitionProps);
	
	    if (onEnter) {
	      onEnter(node, isAppearing);
	    }
	  });
	  var handleEntered = normalizedTransitionCallback(onEntered);
	  var handleExiting = normalizedTransitionCallback(onExiting);
	  var handleExit = normalizedTransitionCallback(function (node) {
	    var transitionProps = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'exit'
	    });
	    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
	    node.style.transition = theme.transitions.create('opacity', transitionProps);
	
	    if (onExit) {
	      onExit(node);
	    }
	  });
	  var handleExited = normalizedTransitionCallback(onExited);
	  return /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    appear: true,
	    in: inProp,
	    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
	    onEnter: handleEnter,
	    onEntered: handleEntered,
	    onEntering: handleEntering,
	    onExit: handleExit,
	    onExited: handleExited,
	    onExiting: handleExiting,
	    timeout: timeout
	  }, other), function (state, childProps) {
	    return /*#__PURE__*/React.cloneElement(children, (0, _extends2.default)({
	      style: (0, _extends2.default)({
	        opacity: 0,
	        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
	      }, styles[state], style, children.props.style),
	      ref: handleRef
	    }, childProps));
	  });
	});
	 false ? Fade.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.element,
	
	  /**
	   * Enable this prop if you encounter 'Function components cannot be given refs',
	   * use `unstable_createStrictModeTheme`,
	   * and can't forward the ref in the child component.
	   */
	  disableStrictModeCompat: _propTypes.default.bool,
	
	  /**
	   * If `true`, the component will transition in.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : void 0;
	var _default = Fade;
	exports.default = _default;

/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _utils = __webpack_require__(19);
	
	var _InputBase = _interopRequireDefault(__webpack_require__(237));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var styles = function styles(theme) {
	  var light = theme.palette.type === 'light';
	  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
	  var backgroundColor = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)';
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      backgroundColor: backgroundColor,
	      borderTopLeftRadius: theme.shape.borderRadius,
	      borderTopRightRadius: theme.shape.borderRadius,
	      transition: theme.transitions.create('background-color', {
	        duration: theme.transitions.duration.shorter,
	        easing: theme.transitions.easing.easeOut
	      }),
	      '&:hover': {
	        backgroundColor: light ? 'rgba(0, 0, 0, 0.13)' : 'rgba(255, 255, 255, 0.13)',
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: backgroundColor
	        }
	      },
	      '&$focused': {
	        backgroundColor: light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)'
	      },
	      '&$disabled': {
	        backgroundColor: light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)'
	      }
	    },
	
	    /* Styles applied to the root element if color secondary. */
	    colorSecondary: {
	      '&$underline:after': {
	        borderBottomColor: theme.palette.secondary.main
	      }
	    },
	
	    /* Styles applied to the root element if `disableUnderline={false}`. */
	    underline: {
	      '&:after': {
	        borderBottom: "2px solid ".concat(theme.palette.primary.main),
	        left: 0,
	        bottom: 0,
	        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
	        content: '""',
	        position: 'absolute',
	        right: 0,
	        transform: 'scaleX(0)',
	        transition: theme.transitions.create('transform', {
	          duration: theme.transitions.duration.shorter,
	          easing: theme.transitions.easing.easeOut
	        }),
	        pointerEvents: 'none' // Transparent to the hover style.
	
	      },
	      '&$focused:after': {
	        transform: 'scaleX(1)'
	      },
	      '&$error:after': {
	        borderBottomColor: theme.palette.error.main,
	        transform: 'scaleX(1)' // error is always underlined in red
	
	      },
	      '&:before': {
	        borderBottom: "1px solid ".concat(bottomLineColor),
	        left: 0,
	        bottom: 0,
	        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
	        content: '"\\00a0"',
	        position: 'absolute',
	        right: 0,
	        transition: theme.transitions.create('border-bottom-color', {
	          duration: theme.transitions.duration.shorter
	        }),
	        pointerEvents: 'none' // Transparent to the hover style.
	
	      },
	      '&:hover:before': {
	        borderBottom: "1px solid ".concat(theme.palette.text.primary)
	      },
	      '&$disabled:before': {
	        borderBottomStyle: 'dotted'
	      }
	    },
	
	    /* Pseudo-class applied to the root element if the component is focused. */
	    focused: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `startAdornment` is provided. */
	    adornedStart: {
	      paddingLeft: 12
	    },
	
	    /* Styles applied to the root element if `endAdornment` is provided. */
	    adornedEnd: {
	      paddingRight: 12
	    },
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    marginDense: {},
	
	    /* Styles applied to the root element if `multiline={true}`. */
	    multiline: {
	      padding: '27px 12px 10px',
	      '&$marginDense': {
	        paddingTop: 23,
	        paddingBottom: 6
	      }
	    },
	
	    /* Styles applied to the `input` element. */
	    input: {
	      padding: '27px 12px 10px',
	      '&:-webkit-autofill': {
	        WebkitBoxShadow: theme.palette.type === 'light' ? null : '0 0 0 100px #266798 inset',
	        WebkitTextFillColor: theme.palette.type === 'light' ? null : '#fff',
	        caretColor: theme.palette.type === 'light' ? null : '#fff',
	        borderTopLeftRadius: 'inherit',
	        borderTopRightRadius: 'inherit'
	      }
	    },
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    inputMarginDense: {
	      paddingTop: 23,
	      paddingBottom: 6
	    },
	
	    /* Styles applied to the `input` if in `<FormControl hiddenLabel />`. */
	    inputHiddenLabel: {
	      paddingTop: 18,
	      paddingBottom: 19,
	      '&$inputMarginDense': {
	        paddingTop: 10,
	        paddingBottom: 11
	      }
	    },
	
	    /* Styles applied to the `input` element if `multiline={true}`. */
	    inputMultiline: {
	      padding: 0
	    },
	
	    /* Styles applied to the `input` element if `startAdornment` is provided. */
	    inputAdornedStart: {
	      paddingLeft: 0
	    },
	
	    /* Styles applied to the `input` element if `endAdornment` is provided. */
	    inputAdornedEnd: {
	      paddingRight: 0
	    }
	  };
	};
	
	exports.styles = styles;
	var FilledInput = /*#__PURE__*/React.forwardRef(function FilledInput(props, ref) {
	  var disableUnderline = props.disableUnderline,
	      classes = props.classes,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$inputComponent = props.inputComponent,
	      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
	      _props$multiline = props.multiline,
	      multiline = _props$multiline === void 0 ? false : _props$multiline,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'text' : _props$type,
	      other = (0, _objectWithoutProperties2.default)(props, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);
	  return /*#__PURE__*/React.createElement(_InputBase.default, (0, _extends2.default)({
	    classes: (0, _extends2.default)({}, classes, {
	      root: (0, _clsx.default)(classes.root, !disableUnderline && classes.underline),
	      underline: null
	    }),
	    fullWidth: fullWidth,
	    inputComponent: inputComponent,
	    multiline: multiline,
	    ref: ref,
	    type: type
	  }, other));
	});
	 false ? FilledInput.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * This prop helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
	   */
	  autoComplete: _propTypes.default.string,
	
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The default `input` element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the `input` element will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will not have an underline.
	   */
	  disableUnderline: _propTypes.default.bool,
	
	  /**
	   * End `InputAdornment` for this component.
	   */
	  endAdornment: _propTypes.default.node,
	
	  /**
	   * If `true`, the input will indicate an error. This is normally obtained via context from
	   * FormControl.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * The component used for the `input` element.
	   * Either a string to use a HTML element or a component.
	   */
	  inputComponent: _propTypes.default.elementType,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense', 'none']),
	
	  /**
	   * If `true`, a textarea element will be rendered.
	   */
	  multiline: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * It prevents the user from changing the value of the field
	   * (not from interacting with the field).
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Start `InputAdornment` for this component.
	   */
	  startAdornment: _propTypes.default.node,
	
	  /**
	   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the `input` element, required for a controlled component.
	   */
	  value: _propTypes.default.any
	} : void 0;
	FilledInput.muiName = 'Input';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFilledInput'
	})(FilledInput);
	
	exports.default = _default;

/***/ },
/* 1173 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _utils = __webpack_require__(400);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var _isMuiElement = _interopRequireDefault(__webpack_require__(242));
	
	var _FormControlContext = _interopRequireDefault(__webpack_require__(298));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'inline-flex',
	    flexDirection: 'column',
	    position: 'relative',
	    // Reset fieldset default style.
	    minWidth: 0,
	    padding: 0,
	    margin: 0,
	    border: 0,
	    verticalAlign: 'top' // Fix alignment issue on Safari.
	
	  },
	
	  /* Styles applied to the root element if `margin="normal"`. */
	  marginNormal: {
	    marginTop: 16,
	    marginBottom: 8
	  },
	
	  /* Styles applied to the root element if `margin="dense"`. */
	  marginDense: {
	    marginTop: 8,
	    marginBottom: 4
	  },
	
	  /* Styles applied to the root element if `fullWidth={true}`. */
	  fullWidth: {
	    width: '100%'
	  }
	};
	/**
	 * Provides context such as filled/focused/error/required for form inputs.
	 * Relying on the context provides high flexibility and ensures that the state always stays
	 * consistent across the children of the `FormControl`.
	 * This context is used by the following components:
	 *
	 *  - FormLabel
	 *  - FormHelperText
	 *  - Input
	 *  - InputLabel
	 *
	 * You can find one composition example below and more going to [the demos](/components/text-fields/#components).
	 *
	 * ```jsx
	 * <FormControl>
	 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
	 *   <Input id="my-input" aria-describedby="my-helper-text" />
	 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
	 * </FormControl>
	 * ```
	 *
	 * ⚠️Only one input can be used within a FormControl.
	 */
	
	exports.styles = styles;
	var FormControl = /*#__PURE__*/React.forwardRef(function FormControl(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$error = props.error,
	      error = _props$error === void 0 ? false : _props$error,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      visuallyFocused = props.focused,
	      _props$hiddenLabel = props.hiddenLabel,
	      hiddenLabel = _props$hiddenLabel === void 0 ? false : _props$hiddenLabel,
	      _props$margin = props.margin,
	      margin = _props$margin === void 0 ? 'none' : _props$margin,
	      _props$required = props.required,
	      required = _props$required === void 0 ? false : _props$required,
	      size = props.size,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "disabled", "error", "fullWidth", "focused", "hiddenLabel", "margin", "required", "size", "variant"]);
	
	  var _React$useState = React.useState(function () {
	    // We need to iterate through the children and find the Input in order
	    // to fully support server-side rendering.
	    var initialAdornedStart = false;
	
	    if (children) {
	      React.Children.forEach(children, function (child) {
	        if (!(0, _isMuiElement.default)(child, ['Input', 'Select'])) {
	          return;
	        }
	
	        var input = (0, _isMuiElement.default)(child, ['Select']) ? child.props.input : child;
	
	        if (input && (0, _utils.isAdornedStart)(input.props)) {
	          initialAdornedStart = true;
	        }
	      });
	    }
	
	    return initialAdornedStart;
	  }),
	      adornedStart = _React$useState[0],
	      setAdornedStart = _React$useState[1];
	
	  var _React$useState2 = React.useState(function () {
	    // We need to iterate through the children and find the Input in order
	    // to fully support server-side rendering.
	    var initialFilled = false;
	
	    if (children) {
	      React.Children.forEach(children, function (child) {
	        if (!(0, _isMuiElement.default)(child, ['Input', 'Select'])) {
	          return;
	        }
	
	        if ((0, _utils.isFilled)(child.props, true)) {
	          initialFilled = true;
	        }
	      });
	    }
	
	    return initialFilled;
	  }),
	      filled = _React$useState2[0],
	      setFilled = _React$useState2[1];
	
	  var _React$useState3 = React.useState(false),
	      _focused = _React$useState3[0],
	      setFocused = _React$useState3[1];
	
	  var focused = visuallyFocused !== undefined ? visuallyFocused : _focused;
	
	  if (disabled && focused) {
	    setFocused(false);
	  }
	
	  var registerEffect;
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    var registeredInput = React.useRef(false);
	
	    registerEffect = function registerEffect() {
	      if (registeredInput.current) {
	        console.error(['Material-UI: There are multiple InputBase components inside a FormControl.', 'This is not supported. It might cause infinite rendering loops.', 'Only use one InputBase.'].join('\n'));
	      }
	
	      registeredInput.current = true;
	      return function () {
	        registeredInput.current = false;
	      };
	    };
	  }
	
	  var onFilled = React.useCallback(function () {
	    setFilled(true);
	  }, []);
	  var onEmpty = React.useCallback(function () {
	    setFilled(false);
	  }, []);
	  var childContext = {
	    adornedStart: adornedStart,
	    setAdornedStart: setAdornedStart,
	    color: color,
	    disabled: disabled,
	    error: error,
	    filled: filled,
	    focused: focused,
	    fullWidth: fullWidth,
	    hiddenLabel: hiddenLabel,
	    margin: (size === 'small' ? 'dense' : undefined) || margin,
	    onBlur: function onBlur() {
	      setFocused(false);
	    },
	    onEmpty: onEmpty,
	    onFilled: onFilled,
	    onFocus: function onFocus() {
	      setFocused(true);
	    },
	    registerEffect: registerEffect,
	    required: required,
	    variant: variant
	  };
	  return /*#__PURE__*/React.createElement(_FormControlContext.default.Provider, {
	    value: childContext
	  }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, margin !== 'none' && classes["margin".concat((0, _capitalize.default)(margin))], fullWidth && classes.fullWidth),
	    ref: ref
	  }, other), children));
	});
	 false ? FormControl.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The contents of the form control.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, the label, input and helper text should be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label should be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the component will be displayed in focused state.
	   */
	  focused: _propTypes.default.bool,
	
	  /**
	   * If `true`, the component will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label will be hidden.
	   * This is used to increase density for a `FilledInput`.
	   * Be sure to add `aria-label` to the `input` element.
	   */
	  hiddenLabel: _propTypes.default.bool,
	
	  /**
	   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
	   */
	  margin: _propTypes.default.oneOf(['dense', 'none', 'normal']),
	
	  /**
	   * If `true`, the label will indicate that the input is required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * The size of the text field.
	   */
	  size: _propTypes.default.oneOf(['medium', 'small']),
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['filled', 'outlined', 'standard'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFormControl'
	})(FormControl);
	
	exports.default = _default;

/***/ },
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _utils = __webpack_require__(19);
	
	var _FormControl = __webpack_require__(399);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _Typography = _interopRequireDefault(__webpack_require__(75));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'inline-flex',
	      alignItems: 'center',
	      cursor: 'pointer',
	      // For correct alignment with the text.
	      verticalAlign: 'middle',
	      WebkitTapHighlightColor: 'transparent',
	      marginLeft: -11,
	      marginRight: 16,
	      // used for row presentation of radio/checkbox
	      '&$disabled': {
	        cursor: 'default'
	      }
	    },
	
	    /* Styles applied to the root element if `labelPlacement="start"`. */
	    labelPlacementStart: {
	      flexDirection: 'row-reverse',
	      marginLeft: 16,
	      // used for row presentation of radio/checkbox
	      marginRight: -11
	    },
	
	    /* Styles applied to the root element if `labelPlacement="top"`. */
	    labelPlacementTop: {
	      flexDirection: 'column-reverse',
	      marginLeft: 16
	    },
	
	    /* Styles applied to the root element if `labelPlacement="bottom"`. */
	    labelPlacementBottom: {
	      flexDirection: 'column',
	      marginLeft: 16
	    },
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the label's Typography component. */
	    label: {
	      '&$disabled': {
	        color: theme.palette.text.disabled
	      }
	    }
	  };
	};
	/**
	 * Drop in replacement of the `Radio`, `Switch` and `Checkbox` component.
	 * Use this component if you want to display an extra label.
	 */
	
	
	exports.styles = styles;
	var FormControlLabel = /*#__PURE__*/React.forwardRef(function FormControlLabel(props, ref) {
	  var checked = props.checked,
	      classes = props.classes,
	      className = props.className,
	      control = props.control,
	      disabledProp = props.disabled,
	      inputRef = props.inputRef,
	      label = props.label,
	      _props$labelPlacement = props.labelPlacement,
	      labelPlacement = _props$labelPlacement === void 0 ? 'end' : _props$labelPlacement,
	      name = props.name,
	      onChange = props.onChange,
	      value = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["checked", "classes", "className", "control", "disabled", "inputRef", "label", "labelPlacement", "name", "onChange", "value"]);
	  var muiFormControl = (0, _FormControl.useFormControl)();
	  var disabled = disabledProp;
	
	  if (typeof disabled === 'undefined' && typeof control.props.disabled !== 'undefined') {
	    disabled = control.props.disabled;
	  }
	
	  if (typeof disabled === 'undefined' && muiFormControl) {
	    disabled = muiFormControl.disabled;
	  }
	
	  var controlProps = {
	    disabled: disabled
	  };
	  ['checked', 'name', 'onChange', 'value', 'inputRef'].forEach(function (key) {
	    if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') {
	      controlProps[key] = props[key];
	    }
	  });
	  return /*#__PURE__*/React.createElement("label", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, labelPlacement !== 'end' && classes["labelPlacement".concat((0, _capitalize.default)(labelPlacement))], disabled && classes.disabled),
	    ref: ref
	  }, other), /*#__PURE__*/React.cloneElement(control, controlProps), /*#__PURE__*/React.createElement(_Typography.default, {
	    component: "span",
	    className: (0, _clsx.default)(classes.label, disabled && classes.disabled)
	  }, label));
	});
	 false ? FormControlLabel.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * If `true`, the component appears selected.
	   */
	  checked: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * A control element. For instance, it can be be a `Radio`, a `Switch` or a `Checkbox`.
	   */
	  control: _propTypes.default.element.isRequired,
	
	  /**
	   * If `true`, the control will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * The text to be used in an enclosing label element.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * The position of the label.
	   */
	  labelPlacement: _propTypes.default.oneOf(['bottom', 'end', 'start', 'top']),
	
	  /**
	   * @ignore
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The value of the component.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFormControlLabel'
	})(FormControlLabel);
	
	exports.default = _default;

/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    flexDirection: 'column',
	    flexWrap: 'wrap'
	  },
	
	  /* Styles applied to the root element if `row={true}`. */
	  row: {
	    flexDirection: 'row'
	  }
	};
	/**
	 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
	 * It provides compact row layout.
	 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
	 */
	
	exports.styles = styles;
	var FormGroup = /*#__PURE__*/React.forwardRef(function FormGroup(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$row = props.row,
	      row = _props$row === void 0 ? false : _props$row,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "row"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, row && classes.row),
	    ref: ref
	  }, other));
	});
	 false ? FormGroup.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Display group of elements in a compact row.
	   */
	  row: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFormGroup'
	})(FormGroup);
	
	exports.default = _default;

/***/ },
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _formControlState = _interopRequireDefault(__webpack_require__(191));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(154));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({
	      color: theme.palette.text.secondary
	    }, theme.typography.caption, {
	      textAlign: 'left',
	      marginTop: 3,
	      margin: 0,
	      '&$disabled': {
	        color: theme.palette.text.disabled
	      },
	      '&$error': {
	        color: theme.palette.error.main
	      }
	    }),
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `margin="dense"`. */
	    marginDense: {
	      marginTop: 4
	    },
	
	    /* Styles applied to the root element if `variant="filled"` or `variant="outlined"`. */
	    contained: {
	      marginLeft: 14,
	      marginRight: 14
	    },
	
	    /* Pseudo-class applied to the root element if `focused={true}`. */
	    focused: {},
	
	    /* Pseudo-class applied to the root element if `filled={true}`. */
	    filled: {},
	
	    /* Pseudo-class applied to the root element if `required={true}`. */
	    required: {}
	  };
	};
	
	exports.styles = styles;
	var FormHelperText = /*#__PURE__*/React.forwardRef(function FormHelperText(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'p' : _props$component,
	      disabled = props.disabled,
	      error = props.error,
	      filled = props.filled,
	      focused = props.focused,
	      margin = props.margin,
	      required = props.required,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"]);
	  var muiFormControl = (0, _useFormControl.default)();
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['variant', 'margin', 'disabled', 'error', 'filled', 'focused', 'required']
	  });
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, (fcs.variant === 'filled' || fcs.variant === 'outlined') && classes.contained, className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required, fcs.margin === 'dense' && classes.marginDense),
	    ref: ref
	  }, other), children === ' ' ?
	  /*#__PURE__*/
	  // eslint-disable-next-line react/no-danger
	  React.createElement("span", {
	    dangerouslySetInnerHTML: {
	      __html: '&#8203;'
	    }
	  }) : children);
	});
	 false ? FormHelperText.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   *
	   * If `' '` is provided, the component reserves one line height for displaying a future message.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, the helper text should be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, helper text should be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the helper text should use filled classes key.
	   */
	  filled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the helper text should use focused classes key.
	   */
	  focused: _propTypes.default.bool,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense']),
	
	  /**
	   * If `true`, the helper text should use required classes key.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['filled', 'outlined', 'standard'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFormHelperText'
	})(FormHelperText);
	
	exports.default = _default;

/***/ },
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _formControlState = _interopRequireDefault(__webpack_require__(191));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(154));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({
	      color: theme.palette.text.secondary
	    }, theme.typography.body1, {
	      lineHeight: 1,
	      padding: 0,
	      '&$focused': {
	        color: theme.palette.primary.main
	      },
	      '&$disabled': {
	        color: theme.palette.text.disabled
	      },
	      '&$error': {
	        color: theme.palette.error.main
	      }
	    }),
	
	    /* Styles applied to the root element if the color is secondary. */
	    colorSecondary: {
	      '&$focused': {
	        color: theme.palette.secondary.main
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `focused={true}`. */
	    focused: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Pseudo-class applied to the root element if `filled={true}`. */
	    filled: {},
	
	    /* Pseudo-class applied to the root element if `required={true}`. */
	    required: {},
	
	    /* Styles applied to the asterisk element. */
	    asterisk: {
	      '&$error': {
	        color: theme.palette.error.main
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var FormLabel = /*#__PURE__*/React.forwardRef(function FormLabel(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      color = props.color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'label' : _props$component,
	      disabled = props.disabled,
	      error = props.error,
	      filled = props.filled,
	      focused = props.focused,
	      required = props.required,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "disabled", "error", "filled", "focused", "required"]);
	  var muiFormControl = (0, _useFormControl.default)();
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['color', 'required', 'focused', 'disabled', 'error', 'filled']
	  });
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes["color".concat((0, _capitalize.default)(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required),
	    ref: ref
	  }, other), children, fcs.required && /*#__PURE__*/React.createElement("span", {
	    "aria-hidden": true,
	    className: (0, _clsx.default)(classes.asterisk, fcs.error && classes.error)
	  }, "\u2009", '*'));
	});
	 false ? FormLabel.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, the label should be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label should be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label should use filled classes key.
	   */
	  filled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input of this label is focused (used by `FormGroup` components).
	   */
	  focused: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label will indicate that the input is required.
	   */
	  required: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFormLabel'
	})(FormLabel);
	
	exports.default = _default;

/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _requirePropFactory = _interopRequireDefault(__webpack_require__(628));
	
	// A grid component using the following libs as inspiration.
	//
	// For the implementation:
	// - https://getbootstrap.com/docs/4.3/layout/grid/
	// - https://github.com/kristoferjoseph/flexboxgrid/blob/master/src/css/flexboxgrid.css
	// - https://github.com/roylee0704/react-flexbox-grid
	// - https://material.angularjs.org/latest/layout/introduction
	//
	// Follow this flexbox Guide to better understand the underlying model:
	// - https://css-tricks.com/snippets/css/a-guide-to-flexbox/
	var SPACINGS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
	var GRID_SIZES = ['auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
	
	function generateGrid(globalStyles, theme, breakpoint) {
	  var styles = {};
	  GRID_SIZES.forEach(function (size) {
	    var key = "grid-".concat(breakpoint, "-").concat(size);
	
	    if (size === true) {
	      // For the auto layouting
	      styles[key] = {
	        flexBasis: 0,
	        flexGrow: 1,
	        maxWidth: '100%'
	      };
	      return;
	    }
	
	    if (size === 'auto') {
	      styles[key] = {
	        flexBasis: 'auto',
	        flexGrow: 0,
	        maxWidth: 'none'
	      };
	      return;
	    } // Keep 7 significant numbers.
	
	
	    var width = "".concat(Math.round(size / 12 * 10e7) / 10e5, "%"); // Close to the bootstrap implementation:
	    // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
	
	    styles[key] = {
	      flexBasis: width,
	      flexGrow: 0,
	      maxWidth: width
	    };
	  }); // No need for a media query for the first size.
	
	  if (breakpoint === 'xs') {
	    (0, _extends2.default)(globalStyles, styles);
	  } else {
	    globalStyles[theme.breakpoints.up(breakpoint)] = styles;
	  }
	}
	
	function getOffset(val) {
	  var div = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var parse = parseFloat(val);
	  return "".concat(parse / div).concat(String(val).replace(String(parse), '') || 'px');
	}
	
	function generateGutter(theme, breakpoint) {
	  var styles = {};
	  SPACINGS.forEach(function (spacing) {
	    var themeSpacing = theme.spacing(spacing);
	
	    if (themeSpacing === 0) {
	      return;
	    }
	
	    styles["spacing-".concat(breakpoint, "-").concat(spacing)] = {
	      margin: "-".concat(getOffset(themeSpacing, 2)),
	      width: "calc(100% + ".concat(getOffset(themeSpacing), ")"),
	      '& > $item': {
	        padding: getOffset(themeSpacing, 2)
	      }
	    };
	  });
	  return styles;
	} // Default CSS values
	// flex: '0 1 auto',
	// flexDirection: 'row',
	// alignItems: 'flex-start',
	// flexWrap: 'nowrap',
	// justifyContent: 'flex-start',
	
	
	var styles = function styles(theme) {
	  return (0, _extends2.default)({
	    /* Styles applied to the root element. */
	    root: {},
	
	    /* Styles applied to the root element if `container={true}`. */
	    container: {
	      boxSizing: 'border-box',
	      display: 'flex',
	      flexWrap: 'wrap',
	      width: '100%'
	    },
	
	    /* Styles applied to the root element if `item={true}`. */
	    item: {
	      boxSizing: 'border-box',
	      margin: '0' // For instance, it's useful when used with a `figure` element.
	
	    },
	
	    /* Styles applied to the root element if `zeroMinWidth={true}`. */
	    zeroMinWidth: {
	      minWidth: 0
	    },
	
	    /* Styles applied to the root element if `direction="column"`. */
	    'direction-xs-column': {
	      flexDirection: 'column'
	    },
	
	    /* Styles applied to the root element if `direction="column-reverse"`. */
	    'direction-xs-column-reverse': {
	      flexDirection: 'column-reverse'
	    },
	
	    /* Styles applied to the root element if `direction="row-reverse"`. */
	    'direction-xs-row-reverse': {
	      flexDirection: 'row-reverse'
	    },
	
	    /* Styles applied to the root element if `wrap="nowrap"`. */
	    'wrap-xs-nowrap': {
	      flexWrap: 'nowrap'
	    },
	
	    /* Styles applied to the root element if `wrap="reverse"`. */
	    'wrap-xs-wrap-reverse': {
	      flexWrap: 'wrap-reverse'
	    },
	
	    /* Styles applied to the root element if `alignItems="center"`. */
	    'align-items-xs-center': {
	      alignItems: 'center'
	    },
	
	    /* Styles applied to the root element if `alignItems="flex-start"`. */
	    'align-items-xs-flex-start': {
	      alignItems: 'flex-start'
	    },
	
	    /* Styles applied to the root element if `alignItems="flex-end"`. */
	    'align-items-xs-flex-end': {
	      alignItems: 'flex-end'
	    },
	
	    /* Styles applied to the root element if `alignItems="baseline"`. */
	    'align-items-xs-baseline': {
	      alignItems: 'baseline'
	    },
	
	    /* Styles applied to the root element if `alignContent="center"`. */
	    'align-content-xs-center': {
	      alignContent: 'center'
	    },
	
	    /* Styles applied to the root element if `alignContent="flex-start"`. */
	    'align-content-xs-flex-start': {
	      alignContent: 'flex-start'
	    },
	
	    /* Styles applied to the root element if `alignContent="flex-end"`. */
	    'align-content-xs-flex-end': {
	      alignContent: 'flex-end'
	    },
	
	    /* Styles applied to the root element if `alignContent="space-between"`. */
	    'align-content-xs-space-between': {
	      alignContent: 'space-between'
	    },
	
	    /* Styles applied to the root element if `alignContent="space-around"`. */
	    'align-content-xs-space-around': {
	      alignContent: 'space-around'
	    },
	
	    /* Styles applied to the root element if `justify="center"`. */
	    'justify-xs-center': {
	      justifyContent: 'center'
	    },
	
	    /* Styles applied to the root element if `justify="flex-end"`. */
	    'justify-xs-flex-end': {
	      justifyContent: 'flex-end'
	    },
	
	    /* Styles applied to the root element if `justify="space-between"`. */
	    'justify-xs-space-between': {
	      justifyContent: 'space-between'
	    },
	
	    /* Styles applied to the root element if `justify="space-around"`. */
	    'justify-xs-space-around': {
	      justifyContent: 'space-around'
	    },
	
	    /* Styles applied to the root element if `justify="space-evenly"`. */
	    'justify-xs-space-evenly': {
	      justifyContent: 'space-evenly'
	    }
	  }, generateGutter(theme, 'xs'), theme.breakpoints.keys.reduce(function (accumulator, key) {
	    // Use side effect over immutability for better performance.
	    generateGrid(accumulator, theme, key);
	    return accumulator;
	  }, {}));
	};
	
	exports.styles = styles;
	var Grid = /*#__PURE__*/React.forwardRef(function Grid(props, ref) {
	  var _props$alignContent = props.alignContent,
	      alignContent = _props$alignContent === void 0 ? 'stretch' : _props$alignContent,
	      _props$alignItems = props.alignItems,
	      alignItems = _props$alignItems === void 0 ? 'stretch' : _props$alignItems,
	      classes = props.classes,
	      classNameProp = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$container = props.container,
	      container = _props$container === void 0 ? false : _props$container,
	      _props$direction = props.direction,
	      direction = _props$direction === void 0 ? 'row' : _props$direction,
	      _props$item = props.item,
	      item = _props$item === void 0 ? false : _props$item,
	      _props$justify = props.justify,
	      justify = _props$justify === void 0 ? 'flex-start' : _props$justify,
	      _props$lg = props.lg,
	      lg = _props$lg === void 0 ? false : _props$lg,
	      _props$md = props.md,
	      md = _props$md === void 0 ? false : _props$md,
	      _props$sm = props.sm,
	      sm = _props$sm === void 0 ? false : _props$sm,
	      _props$spacing = props.spacing,
	      spacing = _props$spacing === void 0 ? 0 : _props$spacing,
	      _props$wrap = props.wrap,
	      wrap = _props$wrap === void 0 ? 'wrap' : _props$wrap,
	      _props$xl = props.xl,
	      xl = _props$xl === void 0 ? false : _props$xl,
	      _props$xs = props.xs,
	      xs = _props$xs === void 0 ? false : _props$xs,
	      _props$zeroMinWidth = props.zeroMinWidth,
	      zeroMinWidth = _props$zeroMinWidth === void 0 ? false : _props$zeroMinWidth,
	      other = (0, _objectWithoutProperties2.default)(props, ["alignContent", "alignItems", "classes", "className", "component", "container", "direction", "item", "justify", "lg", "md", "sm", "spacing", "wrap", "xl", "xs", "zeroMinWidth"]);
	  var className = (0, _clsx.default)(classes.root, classNameProp, container && [classes.container, spacing !== 0 && classes["spacing-xs-".concat(String(spacing))]], item && classes.item, zeroMinWidth && classes.zeroMinWidth, direction !== 'row' && classes["direction-xs-".concat(String(direction))], wrap !== 'wrap' && classes["wrap-xs-".concat(String(wrap))], alignItems !== 'stretch' && classes["align-items-xs-".concat(String(alignItems))], alignContent !== 'stretch' && classes["align-content-xs-".concat(String(alignContent))], justify !== 'flex-start' && classes["justify-xs-".concat(String(justify))], xs !== false && classes["grid-xs-".concat(String(xs))], sm !== false && classes["grid-sm-".concat(String(sm))], md !== false && classes["grid-md-".concat(String(md))], lg !== false && classes["grid-lg-".concat(String(lg))], xl !== false && classes["grid-xl-".concat(String(xl))]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: className,
	    ref: ref
	  }, other));
	});
	 false ? Grid.propTypes = {
	  /**
	   * Defines the `align-content` style property.
	   * It's applied for all screen sizes.
	   */
	  alignContent: _propTypes.default.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around']),
	
	  /**
	   * Defines the `align-items` style property.
	   * It's applied for all screen sizes.
	   */
	  alignItems: _propTypes.default.oneOf(['flex-start', 'center', 'flex-end', 'stretch', 'baseline']),
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, the component will have the flex *container* behavior.
	   * You should be wrapping *items* with a *container*.
	   */
	  container: _propTypes.default.bool,
	
	  /**
	   * Defines the `flex-direction` style property.
	   * It is applied for all screen sizes.
	   */
	  direction: _propTypes.default.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),
	
	  /**
	   * If `true`, the component will have the flex *item* behavior.
	   * You should be wrapping *items* with a *container*.
	   */
	  item: _propTypes.default.bool,
	
	  /**
	   * Defines the `justify-content` style property.
	   * It is applied for all screen sizes.
	   */
	  justify: _propTypes.default.oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly']),
	
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for the `lg` breakpoint and wider screens if not overridden.
	   */
	  lg: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for the `md` breakpoint and wider screens if not overridden.
	   */
	  md: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for the `sm` breakpoint and wider screens if not overridden.
	   */
	  sm: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	
	  /**
	   * Defines the space between the type `item` component.
	   * It can only be used on a type `container` component.
	   */
	  spacing: _propTypes.default.oneOf(SPACINGS),
	
	  /**
	   * Defines the `flex-wrap` style property.
	   * It's applied for all screen sizes.
	   */
	  wrap: _propTypes.default.oneOf(['nowrap', 'wrap', 'wrap-reverse']),
	
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for the `xl` breakpoint and wider screens.
	   */
	  xl: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for all the screen sizes with the lowest priority.
	   */
	  xs: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	
	  /**
	   * If `true`, it sets `min-width: 0` on the item.
	   * Refer to the limitations section of the documentation to better understand the use case.
	   */
	  zeroMinWidth: _propTypes.default.bool
	} : void 0;
	var StyledGrid = (0, _withStyles.default)(styles, {
	  name: 'MuiGrid'
	})(Grid);
	
	if (false) {
	  var requireProp = (0, _requirePropFactory.default)('Grid');
	  StyledGrid.propTypes = (0, _extends2.default)({}, StyledGrid.propTypes, {
	    alignContent: requireProp('container'),
	    alignItems: requireProp('container'),
	    direction: requireProp('container'),
	    justify: requireProp('container'),
	    lg: requireProp('item'),
	    md: requireProp('item'),
	    sm: requireProp('item'),
	    spacing: requireProp('container'),
	    wrap: requireProp('container'),
	    xs: requireProp('item'),
	    zeroMinWidth: requireProp('item')
	  });
	}
	
	var _default = StyledGrid;
	exports.default = _default;

/***/ },
/* 1179 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Grid.default;
	  }
	});
	
	var _Grid = _interopRequireDefault(__webpack_require__(1178));

/***/ },
/* 1180 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactIs = __webpack_require__(72);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    flexWrap: 'wrap',
	    overflowY: 'auto',
	    listStyle: 'none',
	    padding: 0,
	    WebkitOverflowScrolling: 'touch' // Add iOS momentum scrolling.
	
	  }
	};
	exports.styles = styles;
	var GridList = /*#__PURE__*/React.forwardRef(function GridList(props, ref) {
	  var _props$cellHeight = props.cellHeight,
	      cellHeight = _props$cellHeight === void 0 ? 180 : _props$cellHeight,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$cols = props.cols,
	      cols = _props$cols === void 0 ? 2 : _props$cols,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'ul' : _props$component,
	      _props$spacing = props.spacing,
	      spacing = _props$spacing === void 0 ? 4 : _props$spacing,
	      style = props.style,
	      other = (0, _objectWithoutProperties2.default)(props, ["cellHeight", "children", "classes", "className", "cols", "component", "spacing", "style"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref,
	    style: (0, _extends2.default)({
	      margin: -spacing / 2
	    }, style)
	  }, other), React.Children.map(children, function (child) {
	    if (! /*#__PURE__*/React.isValidElement(child)) {
	      return null;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: The GridList component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    var childCols = child.props.cols || 1;
	    var childRows = child.props.rows || 1;
	    return /*#__PURE__*/React.cloneElement(child, {
	      style: (0, _extends2.default)({
	        width: "".concat(100 / cols * childCols, "%"),
	        height: cellHeight === 'auto' ? 'auto' : cellHeight * childRows + spacing,
	        padding: spacing / 2
	      }, child.props.style)
	    });
	  }));
	});
	 false ? GridList.propTypes = {
	  /**
	   * Number of px for one cell height.
	   * You can set `'auto'` if you want to let the children determine the height.
	   */
	  cellHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['auto'])]),
	
	  /**
	   * Grid Tiles that will be in Grid List.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Number of columns.
	   */
	  cols: _propTypes.default.number,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * Number of px for the spacing between tiles.
	   */
	  spacing: _propTypes.default.number,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiGridList'
	})(GridList);
	
	exports.default = _default;

/***/ },
/* 1181 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _GridList.default;
	  }
	});
	
	var _GridList = _interopRequireDefault(__webpack_require__(1180));

/***/ },
/* 1182 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(115));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _debounce = _interopRequireDefault(__webpack_require__(156));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _isMuiElement = _interopRequireDefault(__webpack_require__(242));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    boxSizing: 'border-box',
	    flexShrink: 0
	  },
	
	  /* Styles applied to the `div` element that wraps the children. */
	  tile: {
	    position: 'relative',
	    display: 'block',
	    // In case it's not rendered with a div.
	    height: '100%',
	    overflow: 'hidden'
	  },
	
	  /* Styles applied to an `img` element child, if needed to ensure it covers the tile. */
	  imgFullHeight: {
	    height: '100%',
	    transform: 'translateX(-50%)',
	    position: 'relative',
	    left: '50%'
	  },
	
	  /* Styles applied to an `img` element child, if needed to ensure it covers the tile. */
	  imgFullWidth: {
	    width: '100%',
	    position: 'relative',
	    transform: 'translateY(-50%)',
	    top: '50%'
	  }
	};
	exports.styles = styles;
	
	var fit = function fit(imgEl, classes) {
	  if (!imgEl || !imgEl.complete) {
	    return;
	  }
	
	  if (imgEl.width / imgEl.height > imgEl.parentElement.offsetWidth / imgEl.parentElement.offsetHeight) {
	    var _imgEl$classList, _imgEl$classList2;
	
	    (_imgEl$classList = imgEl.classList).remove.apply(_imgEl$classList, (0, _toConsumableArray2.default)(classes.imgFullWidth.split(' ')));
	
	    (_imgEl$classList2 = imgEl.classList).add.apply(_imgEl$classList2, (0, _toConsumableArray2.default)(classes.imgFullHeight.split(' ')));
	  } else {
	    var _imgEl$classList3, _imgEl$classList4;
	
	    (_imgEl$classList3 = imgEl.classList).remove.apply(_imgEl$classList3, (0, _toConsumableArray2.default)(classes.imgFullHeight.split(' ')));
	
	    (_imgEl$classList4 = imgEl.classList).add.apply(_imgEl$classList4, (0, _toConsumableArray2.default)(classes.imgFullWidth.split(' ')));
	  }
	};
	
	function ensureImageCover(imgEl, classes) {
	  if (!imgEl) {
	    return;
	  }
	
	  if (imgEl.complete) {
	    fit(imgEl, classes);
	  } else {
	    imgEl.addEventListener('load', function () {
	      fit(imgEl, classes);
	    });
	  }
	}
	
	var GridListTile = /*#__PURE__*/React.forwardRef(function GridListTile(props, ref) {
	  // cols rows default values are for docs only
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$cols = props.cols,
	      cols = _props$cols === void 0 ? 1 : _props$cols,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'li' : _props$component,
	      _props$rows = props.rows,
	      rows = _props$rows === void 0 ? 1 : _props$rows,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "cols", "component", "rows"]);
	  var imgRef = React.useRef(null);
	  React.useEffect(function () {
	    ensureImageCover(imgRef.current, classes);
	  });
	  React.useEffect(function () {
	    var handleResize = (0, _debounce.default)(function () {
	      fit(imgRef.current, classes);
	    });
	    window.addEventListener('resize', handleResize);
	    return function () {
	      handleResize.clear();
	      window.removeEventListener('resize', handleResize);
	    };
	  }, [classes]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("div", {
	    className: classes.tile
	  }, React.Children.map(children, function (child) {
	    if (! /*#__PURE__*/React.isValidElement(child)) {
	      return null;
	    }
	
	    if (child.type === 'img' || (0, _isMuiElement.default)(child, ['Image'])) {
	      return /*#__PURE__*/React.cloneElement(child, {
	        ref: imgRef
	      });
	    }
	
	    return child;
	  })));
	});
	 false ? GridListTile.propTypes = {
	  /**
	   * Theoretically you can pass any node as children, but the main use case is to pass an img,
	   * in which case GridListTile takes care of making the image "cover" available space
	   * (similar to `background-size: cover` or to `object-fit: cover`).
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Width of the tile in number of grid cells.
	   */
	  cols: _propTypes.default.number,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * Height of the tile in number of grid cells.
	   */
	  rows: _propTypes.default.number
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiGridListTile'
	})(GridListTile);
	
	exports.default = _default;

/***/ },
/* 1183 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _GridListTile.default;
	  }
	});
	
	var _GridListTile = _interopRequireDefault(__webpack_require__(1182));

/***/ },
/* 1184 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'absolute',
	      left: 0,
	      right: 0,
	      height: 48,
	      background: 'rgba(0, 0, 0, 0.5)',
	      display: 'flex',
	      alignItems: 'center',
	      fontFamily: theme.typography.fontFamily
	    },
	
	    /* Styles applied to the root element if `titlePosition="bottom"`. */
	    titlePositionBottom: {
	      bottom: 0
	    },
	
	    /* Styles applied to the root element if `titlePosition="top"`. */
	    titlePositionTop: {
	      top: 0
	    },
	
	    /* Styles applied to the root element if a `subtitle` is provided. */
	    rootSubtitle: {
	      height: 68
	    },
	
	    /* Styles applied to the title and subtitle container element. */
	    titleWrap: {
	      flexGrow: 1,
	      marginLeft: 16,
	      marginRight: 16,
	      color: theme.palette.common.white,
	      overflow: 'hidden'
	    },
	
	    /* Styles applied to the container element if `actionPosition="left"`. */
	    titleWrapActionPosLeft: {
	      marginLeft: 0
	    },
	
	    /* Styles applied to the container element if `actionPosition="right"`. */
	    titleWrapActionPosRight: {
	      marginRight: 0
	    },
	
	    /* Styles applied to the title container element. */
	    title: {
	      fontSize: theme.typography.pxToRem(16),
	      lineHeight: '24px',
	      textOverflow: 'ellipsis',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    },
	
	    /* Styles applied to the subtitle container element. */
	    subtitle: {
	      fontSize: theme.typography.pxToRem(12),
	      lineHeight: 1,
	      textOverflow: 'ellipsis',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    },
	
	    /* Styles applied to the actionIcon if supplied. */
	    actionIcon: {},
	
	    /* Styles applied to the actionIcon if `actionPosition="left"`. */
	    actionIconActionPosLeft: {
	      order: -1
	    }
	  };
	};
	
	exports.styles = styles;
	var GridListTileBar = /*#__PURE__*/React.forwardRef(function GridListTileBar(props, ref) {
	  var actionIcon = props.actionIcon,
	      _props$actionPosition = props.actionPosition,
	      actionPosition = _props$actionPosition === void 0 ? 'right' : _props$actionPosition,
	      classes = props.classes,
	      className = props.className,
	      subtitle = props.subtitle,
	      title = props.title,
	      _props$titlePosition = props.titlePosition,
	      titlePosition = _props$titlePosition === void 0 ? 'bottom' : _props$titlePosition,
	      other = (0, _objectWithoutProperties2.default)(props, ["actionIcon", "actionPosition", "classes", "className", "subtitle", "title", "titlePosition"]);
	  var actionPos = actionIcon && actionPosition;
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, titlePosition === 'top' ? classes.titlePositionTop : classes.titlePositionBottom, subtitle && classes.rootSubtitle),
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.titleWrap, {
	      'left': classes.titleWrapActionPosLeft,
	      'right': classes.titleWrapActionPosRight
	    }[actionPos])
	  }, /*#__PURE__*/React.createElement("div", {
	    className: classes.title
	  }, title), subtitle ? /*#__PURE__*/React.createElement("div", {
	    className: classes.subtitle
	  }, subtitle) : null), actionIcon ? /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.actionIcon, actionPos === 'left' && classes.actionIconActionPosLeft)
	  }, actionIcon) : null);
	});
	 false ? GridListTileBar.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * An IconButton element to be used as secondary action target
	   * (primary action target is the tile itself).
	   */
	  actionIcon: _propTypes.default.node,
	
	  /**
	   * Position of secondary action IconButton.
	   */
	  actionPosition: _propTypes.default.oneOf(['left', 'right']),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * String or element serving as subtitle (support text).
	   */
	  subtitle: _propTypes.default.node,
	
	  /**
	   * Title to be displayed on tile.
	   */
	  title: _propTypes.default.node,
	
	  /**
	   * Position of the title bar.
	   */
	  titlePosition: _propTypes.default.oneOf(['bottom', 'top'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiGridListTileBar'
	})(GridListTileBar);
	
	exports.default = _default;

/***/ },
/* 1185 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _GridListTileBar.default;
	  }
	});
	
	var _GridListTileBar = _interopRequireDefault(__webpack_require__(1184));

/***/ },
/* 1186 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(80));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactTransitionGroup = __webpack_require__(230);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(59));
	
	var _utils = __webpack_require__(193);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(47));
	
	function getScale(value) {
	  return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
	}
	
	var styles = {
	  entering: {
	    opacity: 1,
	    transform: getScale(1)
	  },
	  entered: {
	    opacity: 1,
	    transform: 'none'
	  }
	};
	/**
	 * The Grow transition is used by the [Tooltip](/components/tooltips/) and
	 * [Popover](/components/popover/) components.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	var Grow = /*#__PURE__*/React.forwardRef(function Grow(props, ref) {
	  var children = props.children,
	      _props$disableStrictM = props.disableStrictModeCompat,
	      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
	      inProp = props.in,
	      onEnter = props.onEnter,
	      onEntered = props.onEntered,
	      onEntering = props.onEntering,
	      onExit = props.onExit,
	      onExited = props.onExited,
	      onExiting = props.onExiting,
	      style = props.style,
	      _props$timeout = props.timeout,
	      timeout = _props$timeout === void 0 ? 'auto' : _props$timeout,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _reactTransitionGroup.Transition : _props$TransitionComp,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);
	  var timer = React.useRef();
	  var autoTimeout = React.useRef();
	  var theme = (0, _useTheme.default)();
	  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
	  var nodeRef = React.useRef(null);
	  var foreignRef = (0, _useForkRef.default)(children.ref, ref);
	  var handleRef = (0, _useForkRef.default)(enableStrictModeCompat ? nodeRef : undefined, foreignRef);
	
	  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
	    return function (nodeOrAppearing, maybeAppearing) {
	      if (callback) {
	        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
	            _ref2 = (0, _slicedToArray2.default)(_ref, 2),
	            node = _ref2[0],
	            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
	
	
	        if (isAppearing === undefined) {
	          callback(node);
	        } else {
	          callback(node, isAppearing);
	        }
	      }
	    };
	  };
	
	  var handleEntering = normalizedTransitionCallback(onEntering);
	  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
	    (0, _utils.reflow)(node); // So the animation always start from the start.
	
	    var _getTransitionProps = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'enter'
	    }),
	        transitionDuration = _getTransitionProps.duration,
	        delay = _getTransitionProps.delay;
	
	    var duration;
	
	    if (timeout === 'auto') {
	      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
	      autoTimeout.current = duration;
	    } else {
	      duration = transitionDuration;
	    }
	
	    node.style.transition = [theme.transitions.create('opacity', {
	      duration: duration,
	      delay: delay
	    }), theme.transitions.create('transform', {
	      duration: duration * 0.666,
	      delay: delay
	    })].join(',');
	
	    if (onEnter) {
	      onEnter(node, isAppearing);
	    }
	  });
	  var handleEntered = normalizedTransitionCallback(onEntered);
	  var handleExiting = normalizedTransitionCallback(onExiting);
	  var handleExit = normalizedTransitionCallback(function (node) {
	    var _getTransitionProps2 = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'exit'
	    }),
	        transitionDuration = _getTransitionProps2.duration,
	        delay = _getTransitionProps2.delay;
	
	    var duration;
	
	    if (timeout === 'auto') {
	      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
	      autoTimeout.current = duration;
	    } else {
	      duration = transitionDuration;
	    }
	
	    node.style.transition = [theme.transitions.create('opacity', {
	      duration: duration,
	      delay: delay
	    }), theme.transitions.create('transform', {
	      duration: duration * 0.666,
	      delay: delay || duration * 0.333
	    })].join(',');
	    node.style.opacity = '0';
	    node.style.transform = getScale(0.75);
	
	    if (onExit) {
	      onExit(node);
	    }
	  });
	  var handleExited = normalizedTransitionCallback(onExited);
	
	  var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
	    var next = enableStrictModeCompat ? nodeOrNext : maybeNext;
	
	    if (timeout === 'auto') {
	      timer.current = setTimeout(next, autoTimeout.current || 0);
	    }
	  };
	
	  React.useEffect(function () {
	    return function () {
	      clearTimeout(timer.current);
	    };
	  }, []);
	  return /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    appear: true,
	    in: inProp,
	    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
	    onEnter: handleEnter,
	    onEntered: handleEntered,
	    onEntering: handleEntering,
	    onExit: handleExit,
	    onExited: handleExited,
	    onExiting: handleExiting,
	    addEndListener: addEndListener,
	    timeout: timeout === 'auto' ? null : timeout
	  }, other), function (state, childProps) {
	    return /*#__PURE__*/React.cloneElement(children, (0, _extends2.default)({
	      style: (0, _extends2.default)({
	        opacity: 0,
	        transform: getScale(0.75),
	        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
	      }, styles[state], style, children.props.style),
	      ref: handleRef
	    }, childProps));
	  });
	});
	 false ? Grow.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.element,
	
	  /**
	   * Enable this prop if you encounter 'Function components cannot be given refs',
	   * use `unstable_createStrictModeTheme`,
	   * and can't forward the ref in the child component.
	   */
	  disableStrictModeCompat: _propTypes.default.bool,
	
	  /**
	   * If `true`, show the component; triggers the enter or exit animation.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   *
	   * Set to 'auto' to automatically calculate transition time based on height.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.oneOf(['auto']), _propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : void 0;
	Grow.muiSupportAuto = true;
	var _default = Grow;
	exports.default = _default;

/***/ },
/* 1187 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _HiddenJs = _interopRequireDefault(__webpack_require__(1189));
	
	var _HiddenCss = _interopRequireDefault(__webpack_require__(1188));
	
	/**
	 * Responsively hides children based on the selected implementation.
	 */
	function Hidden(props) {
	  var _props$implementation = props.implementation,
	      implementation = _props$implementation === void 0 ? 'js' : _props$implementation,
	      _props$lgDown = props.lgDown,
	      lgDown = _props$lgDown === void 0 ? false : _props$lgDown,
	      _props$lgUp = props.lgUp,
	      lgUp = _props$lgUp === void 0 ? false : _props$lgUp,
	      _props$mdDown = props.mdDown,
	      mdDown = _props$mdDown === void 0 ? false : _props$mdDown,
	      _props$mdUp = props.mdUp,
	      mdUp = _props$mdUp === void 0 ? false : _props$mdUp,
	      _props$smDown = props.smDown,
	      smDown = _props$smDown === void 0 ? false : _props$smDown,
	      _props$smUp = props.smUp,
	      smUp = _props$smUp === void 0 ? false : _props$smUp,
	      _props$xlDown = props.xlDown,
	      xlDown = _props$xlDown === void 0 ? false : _props$xlDown,
	      _props$xlUp = props.xlUp,
	      xlUp = _props$xlUp === void 0 ? false : _props$xlUp,
	      _props$xsDown = props.xsDown,
	      xsDown = _props$xsDown === void 0 ? false : _props$xsDown,
	      _props$xsUp = props.xsUp,
	      xsUp = _props$xsUp === void 0 ? false : _props$xsUp,
	      other = (0, _objectWithoutProperties2.default)(props, ["implementation", "lgDown", "lgUp", "mdDown", "mdUp", "smDown", "smUp", "xlDown", "xlUp", "xsDown", "xsUp"]);
	
	  if (implementation === 'js') {
	    return /*#__PURE__*/React.createElement(_HiddenJs.default, (0, _extends2.default)({
	      lgDown: lgDown,
	      lgUp: lgUp,
	      mdDown: mdDown,
	      mdUp: mdUp,
	      smDown: smDown,
	      smUp: smUp,
	      xlDown: xlDown,
	      xlUp: xlUp,
	      xsDown: xsDown,
	      xsUp: xsUp
	    }, other));
	  }
	
	  return /*#__PURE__*/React.createElement(_HiddenCss.default, (0, _extends2.default)({
	    lgDown: lgDown,
	    lgUp: lgUp,
	    mdDown: mdDown,
	    mdUp: mdUp,
	    smDown: smDown,
	    smUp: smUp,
	    xlDown: xlDown,
	    xlUp: xlUp,
	    xsDown: xsDown,
	    xsUp: xsUp
	  }, other));
	}
	
	 false ? Hidden.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Specify which implementation to use.  'js' is the default, 'css' works better for
	   * server-side rendering.
	   */
	  implementation: _propTypes.default.oneOf(['js', 'css']),
	
	  /**
	   * You can use this prop when choosing the `js` implementation with server-side rendering.
	   *
	   * As `window.innerWidth` is unavailable on the server,
	   * we default to rendering an empty component during the first mount.
	   * You might want to use an heuristic to approximate
	   * the screen width of the client browser screen width.
	   *
	   * For instance, you could be using the user-agent or the client-hints.
	   * https://caniuse.com/#search=client%20hint
	   */
	  initialWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  lgDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  lgUp: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  mdDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  mdUp: _propTypes.default.bool,
	
	  /**
	   * Hide the given breakpoint(s).
	   */
	  only: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  smDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  smUp: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  xlDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  xlUp: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  xsDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  xsUp: _propTypes.default.bool
	} : void 0;
	var _default = Hidden;
	exports.default = _default;

/***/ },
/* 1188 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(62));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(59));
	
	var styles = function styles(theme) {
	  var hidden = {
	    display: 'none'
	  };
	  return theme.breakpoints.keys.reduce(function (acc, key) {
	    acc["only".concat((0, _capitalize.default)(key))] = (0, _defineProperty2.default)({}, theme.breakpoints.only(key), hidden);
	    acc["".concat(key, "Up")] = (0, _defineProperty2.default)({}, theme.breakpoints.up(key), hidden);
	    acc["".concat(key, "Down")] = (0, _defineProperty2.default)({}, theme.breakpoints.down(key), hidden);
	    return acc;
	  }, {});
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	function HiddenCss(props) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      only = props.only,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "only"]);
	  var theme = (0, _useTheme.default)();
	
	  if (false) {
	    var unknownProps = Object.keys(other).filter(function (propName) {
	      var isUndeclaredBreakpoint = !theme.breakpoints.keys.some(function (breakpoint) {
	        return "".concat(breakpoint, "Up") === propName || "".concat(breakpoint, "Down") === propName;
	      });
	      return isUndeclaredBreakpoint;
	    });
	
	    if (unknownProps.length > 0) {
	      console.error("Material-UI: Unsupported props received by `<Hidden implementation=\"css\" />`: ".concat(unknownProps.join(', '), ". Did you forget to wrap this component in a ThemeProvider declaring these breakpoints?"));
	    }
	  }
	
	  var clsx = [];
	
	  if (className) {
	    clsx.push(className);
	  }
	
	  for (var i = 0; i < theme.breakpoints.keys.length; i += 1) {
	    var breakpoint = theme.breakpoints.keys[i];
	    var breakpointUp = props["".concat(breakpoint, "Up")];
	    var breakpointDown = props["".concat(breakpoint, "Down")];
	
	    if (breakpointUp) {
	      clsx.push(classes["".concat(breakpoint, "Up")]);
	    }
	
	    if (breakpointDown) {
	      clsx.push(classes["".concat(breakpoint, "Down")]);
	    }
	  }
	
	  if (only) {
	    var onlyBreakpoints = Array.isArray(only) ? only : [only];
	    onlyBreakpoints.forEach(function (breakpoint) {
	      clsx.push(classes["only".concat((0, _capitalize.default)(breakpoint))]);
	    });
	  }
	
	  return /*#__PURE__*/React.createElement("div", {
	    className: clsx.join(' ')
	  }, children);
	}
	
	 false ? HiddenCss.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Specify which implementation to use.  'js' is the default, 'css' works better for
	   * server-side rendering.
	   */
	  implementation: _propTypes.default.oneOf(['js', 'css']),
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  lgDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  lgUp: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  mdDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  mdUp: _propTypes.default.bool,
	
	  /**
	   * Hide the given breakpoint(s).
	   */
	  only: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  smDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  smUp: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  xlDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  xlUp: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  xsDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  xsUp: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateHiddenCss'
	})(HiddenCss);
	
	exports.default = _default;

/***/ },
/* 1189 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(19);
	
	var _withWidth = _interopRequireWildcard(__webpack_require__(409));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(59));
	
	/**
	 * @ignore - internal component.
	 */
	function HiddenJs(props) {
	  var children = props.children,
	      only = props.only,
	      width = props.width;
	  var theme = (0, _useTheme.default)();
	  var visible = true; // `only` check is faster to get out sooner if used.
	
	  if (only) {
	    if (Array.isArray(only)) {
	      for (var i = 0; i < only.length; i += 1) {
	        var breakpoint = only[i];
	
	        if (width === breakpoint) {
	          visible = false;
	          break;
	        }
	      }
	    } else if (only && width === only) {
	      visible = false;
	    }
	  } // Allow `only` to be combined with other props. If already hidden, no need to check others.
	
	
	  if (visible) {
	    // determine visibility based on the smallest size up
	    for (var _i = 0; _i < theme.breakpoints.keys.length; _i += 1) {
	      var _breakpoint = theme.breakpoints.keys[_i];
	      var breakpointUp = props["".concat(_breakpoint, "Up")];
	      var breakpointDown = props["".concat(_breakpoint, "Down")];
	
	      if (breakpointUp && (0, _withWidth.isWidthUp)(_breakpoint, width) || breakpointDown && (0, _withWidth.isWidthDown)(_breakpoint, width)) {
	        visible = false;
	        break;
	      }
	    }
	  }
	
	  if (!visible) {
	    return null;
	  }
	
	  return children;
	}
	
	HiddenJs.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Specify which implementation to use.  'js' is the default, 'css' works better for
	   * server-side rendering.
	   */
	  implementation: _propTypes.default.oneOf(['js', 'css']),
	
	  /**
	   * You can use this prop when choosing the `js` implementation with server-side rendering.
	   *
	   * As `window.innerWidth` is unavailable on the server,
	   * we default to rendering an empty component during the first mount.
	   * You might want to use an heuristic to approximate
	   * the screen width of the client browser screen width.
	   *
	   * For instance, you could be using the user-agent or the client-hints.
	   * https://caniuse.com/#search=client%20hint
	   */
	  initialWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  lgDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  lgUp: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  mdDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  mdUp: _propTypes.default.bool,
	
	  /**
	   * Hide the given breakpoint(s).
	   */
	  only: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  smDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  smUp: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * width prop provided by withWidth decorator.
	   */
	  width: _propTypes.default.string.isRequired,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  xlDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  xlUp: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  xsDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  xsUp: _propTypes.default.bool
	};
	
	if (false) {
	  HiddenJs.propTypes = (0, _utils.exactProp)(HiddenJs.propTypes);
	}
	
	var _default = (0, _withWidth.default)()(HiddenJs);
	
	exports.default = _default;

/***/ },
/* 1190 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Hidden.default;
	  }
	});
	
	var _Hidden = _interopRequireDefault(__webpack_require__(1187));

/***/ },
/* 1191 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      userSelect: 'none',
	      fontSize: theme.typography.pxToRem(24),
	      width: '1em',
	      height: '1em',
	      // Chrome fix for https://bugs.chromium.org/p/chromium/issues/detail?id=820541
	      // To remove at some point.
	      overflow: 'hidden',
	      flexShrink: 0
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the root element if `color="action"`. */
	    colorAction: {
	      color: theme.palette.action.active
	    },
	
	    /* Styles applied to the root element if `color="error"`. */
	    colorError: {
	      color: theme.palette.error.main
	    },
	
	    /* Styles applied to the root element if `color="disabled"`. */
	    colorDisabled: {
	      color: theme.palette.action.disabled
	    },
	
	    /* Styles applied to the root element if `fontSize="inherit"`. */
	    fontSizeInherit: {
	      fontSize: 'inherit'
	    },
	
	    /* Styles applied to the root element if `fontSize="small"`. */
	    fontSizeSmall: {
	      fontSize: theme.typography.pxToRem(20)
	    },
	
	    /* Styles applied to the root element if `fontSize="large"`. */
	    fontSizeLarge: {
	      fontSize: theme.typography.pxToRem(36)
	    }
	  };
	};
	
	exports.styles = styles;
	var Icon = /*#__PURE__*/React.forwardRef(function Icon(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'inherit' : _props$color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'span' : _props$component,
	      _props$fontSize = props.fontSize,
	      fontSize = _props$fontSize === void 0 ? 'default' : _props$fontSize,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "component", "fontSize"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)('material-icons', classes.root, className, color !== 'inherit' && classes["color".concat((0, _capitalize.default)(color))], fontSize !== 'default' && classes["fontSize".concat((0, _capitalize.default)(fontSize))]),
	    "aria-hidden": true,
	    ref: ref
	  }, other));
	});
	 false ? Icon.propTypes = {
	  /**
	   * The name of the icon font ligature.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['inherit', 'primary', 'secondary', 'action', 'error', 'disabled']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
	   */
	  fontSize: _propTypes.default.oneOf(['inherit', 'default', 'small', 'large'])
	} : void 0;
	Icon.muiName = 'Icon';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiIcon'
	})(Icon);
	
	exports.default = _default;

/***/ },
/* 1192 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _utils = __webpack_require__(19);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _colorManipulator = __webpack_require__(63);
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(69));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      textAlign: 'center',
	      flex: '0 0 auto',
	      fontSize: theme.typography.pxToRem(24),
	      padding: 12,
	      borderRadius: '50%',
	      overflow: 'visible',
	      // Explicitly set the default value to solve a bug on IE 11.
	      color: theme.palette.action.active,
	      transition: theme.transitions.create('background-color', {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.action.active, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      },
	      '&$disabled': {
	        backgroundColor: 'transparent',
	        color: theme.palette.action.disabled
	      }
	    },
	
	    /* Styles applied to the root element if `edge="start"`. */
	    edgeStart: {
	      marginLeft: -12,
	      '$sizeSmall&': {
	        marginLeft: -3
	      }
	    },
	
	    /* Styles applied to the root element if `edge="end"`. */
	    edgeEnd: {
	      marginRight: -12,
	      '$sizeSmall&': {
	        marginRight: -3
	      }
	    },
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `size="small"`. */
	    sizeSmall: {
	      padding: 3,
	      fontSize: theme.typography.pxToRem(18)
	    },
	
	    /* Styles applied to the children container element. */
	    label: {
	      width: '100%',
	      display: 'flex',
	      alignItems: 'inherit',
	      justifyContent: 'inherit'
	    }
	  };
	};
	/**
	 * Refer to the [Icons](/components/icons/) section of the documentation
	 * regarding the available icon options.
	 */
	
	
	exports.styles = styles;
	var IconButton = /*#__PURE__*/React.forwardRef(function IconButton(props, ref) {
	  var _props$edge = props.edge,
	      edge = _props$edge === void 0 ? false : _props$edge,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableFocusRi = props.disableFocusRipple,
	      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      other = (0, _objectWithoutProperties2.default)(props, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, color !== 'default' && classes["color".concat((0, _capitalize.default)(color))], disabled && classes.disabled, size === "small" && classes["size".concat((0, _capitalize.default)(size))], {
	      'start': classes.edgeStart,
	      'end': classes.edgeEnd
	    }[edge]),
	    centerRipple: true,
	    focusRipple: !disableFocusRipple,
	    disabled: disabled,
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("span", {
	    className: classes.label
	  }, children));
	});
	 false ? IconButton.propTypes = {
	  /**
	   * The icon element.
	   */
	  children: (0, _utils.chainPropTypes)(_propTypes.default.node, function (props) {
	    var found = React.Children.toArray(props.children).some(function (child) {
	      return /*#__PURE__*/React.isValidElement(child) && child.props.onClick;
	    });
	
	    if (found) {
	      return new Error(['Material-UI: You are providing an onClick event listener ' + 'to a child of a button element.', 'Firefox will never trigger the event.', 'You should move the onClick listener to the parent button element.', 'https://github.com/mui-org/material-ui/issues/13957'].join('\n'));
	    }
	
	    return null;
	  }),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * If `true`, the button will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the  keyboard focus ripple will be disabled.
	   */
	  disableFocusRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * If given, uses a negative margin to counteract the padding on one
	   * side (this is often helpful for aligning the left or right
	   * side of the icon with content above or below, without ruining the border
	   * size and shape).
	   */
	  edge: _propTypes.default.oneOf(['start', 'end', false]),
	
	  /**
	   * The size of the button.
	   * `small` is equivalent to the dense button styling.
	   */
	  size: _propTypes.default.oneOf(['small', 'medium'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiIconButton'
	})(IconButton);
	
	exports.default = _default;

/***/ },
/* 1193 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _utils = __webpack_require__(19);
	
	var _InputBase = _interopRequireDefault(__webpack_require__(237));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var styles = function styles(theme) {
	  var light = theme.palette.type === 'light';
	  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative'
	    },
	
	    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
	    formControl: {
	      'label + &': {
	        marginTop: 16
	      }
	    },
	
	    /* Styles applied to the root element if the component is focused. */
	    focused: {},
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if color secondary. */
	    colorSecondary: {
	      '&$underline:after': {
	        borderBottomColor: theme.palette.secondary.main
	      }
	    },
	
	    /* Styles applied to the root element if `disableUnderline={false}`. */
	    underline: {
	      '&:after': {
	        borderBottom: "2px solid ".concat(theme.palette.primary.main),
	        left: 0,
	        bottom: 0,
	        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
	        content: '""',
	        position: 'absolute',
	        right: 0,
	        transform: 'scaleX(0)',
	        transition: theme.transitions.create('transform', {
	          duration: theme.transitions.duration.shorter,
	          easing: theme.transitions.easing.easeOut
	        }),
	        pointerEvents: 'none' // Transparent to the hover style.
	
	      },
	      '&$focused:after': {
	        transform: 'scaleX(1)'
	      },
	      '&$error:after': {
	        borderBottomColor: theme.palette.error.main,
	        transform: 'scaleX(1)' // error is always underlined in red
	
	      },
	      '&:before': {
	        borderBottom: "1px solid ".concat(bottomLineColor),
	        left: 0,
	        bottom: 0,
	        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
	        content: '"\\00a0"',
	        position: 'absolute',
	        right: 0,
	        transition: theme.transitions.create('border-bottom-color', {
	          duration: theme.transitions.duration.shorter
	        }),
	        pointerEvents: 'none' // Transparent to the hover style.
	
	      },
	      '&:hover:not($disabled):before': {
	        borderBottom: "2px solid ".concat(theme.palette.text.primary),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          borderBottom: "1px solid ".concat(bottomLineColor)
	        }
	      },
	      '&$disabled:before': {
	        borderBottomStyle: 'dotted'
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    marginDense: {},
	
	    /* Styles applied to the root element if `multiline={true}`. */
	    multiline: {},
	
	    /* Styles applied to the root element if `fullWidth={true}`. */
	    fullWidth: {},
	
	    /* Styles applied to the `input` element. */
	    input: {},
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    inputMarginDense: {},
	
	    /* Styles applied to the `input` element if `multiline={true}`. */
	    inputMultiline: {},
	
	    /* Styles applied to the `input` element if `type="search"`. */
	    inputTypeSearch: {}
	  };
	};
	
	exports.styles = styles;
	var Input = /*#__PURE__*/React.forwardRef(function Input(props, ref) {
	  var disableUnderline = props.disableUnderline,
	      classes = props.classes,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$inputComponent = props.inputComponent,
	      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
	      _props$multiline = props.multiline,
	      multiline = _props$multiline === void 0 ? false : _props$multiline,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'text' : _props$type,
	      other = (0, _objectWithoutProperties2.default)(props, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);
	  return /*#__PURE__*/React.createElement(_InputBase.default, (0, _extends2.default)({
	    classes: (0, _extends2.default)({}, classes, {
	      root: (0, _clsx.default)(classes.root, !disableUnderline && classes.underline),
	      underline: null
	    }),
	    fullWidth: fullWidth,
	    inputComponent: inputComponent,
	    multiline: multiline,
	    ref: ref,
	    type: type
	  }, other));
	});
	 false ? Input.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * This prop helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
	   */
	  autoComplete: _propTypes.default.string,
	
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The default `input` element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the `input` element will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will not have an underline.
	   */
	  disableUnderline: _propTypes.default.bool,
	
	  /**
	   * End `InputAdornment` for this component.
	   */
	  endAdornment: _propTypes.default.node,
	
	  /**
	   * If `true`, the input will indicate an error. This is normally obtained via context from
	   * FormControl.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * The component used for the `input` element.
	   * Either a string to use a HTML element or a component.
	   */
	  inputComponent: _propTypes.default.elementType,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense', 'none']),
	
	  /**
	   * If `true`, a textarea element will be rendered.
	   */
	  multiline: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * It prevents the user from changing the value of the field
	   * (not from interacting with the field).
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Start `InputAdornment` for this component.
	   */
	  startAdornment: _propTypes.default.node,
	
	  /**
	   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the `input` element, required for a controlled component.
	   */
	  value: _propTypes.default.any
	} : void 0;
	Input.muiName = 'Input';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiInput'
	})(Input);
	
	exports.default = _default;

/***/ },
/* 1194 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _Typography = _interopRequireDefault(__webpack_require__(75));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _FormControlContext = _interopRequireWildcard(__webpack_require__(298));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    height: '0.01em',
	    // Fix IE 11 flexbox alignment. To remove at some point.
	    maxHeight: '2em',
	    alignItems: 'center',
	    whiteSpace: 'nowrap'
	  },
	
	  /* Styles applied to the root element if `variant="filled"`. */
	  filled: {
	    '&$positionStart:not($hiddenLabel)': {
	      marginTop: 16
	    }
	  },
	
	  /* Styles applied to the root element if `position="start"`. */
	  positionStart: {
	    marginRight: 8
	  },
	
	  /* Styles applied to the root element if `position="end"`. */
	  positionEnd: {
	    marginLeft: 8
	  },
	
	  /* Styles applied to the root element if `disablePointerEvents=true`. */
	  disablePointerEvents: {
	    pointerEvents: 'none'
	  },
	
	  /* Styles applied if the adornment is used inside <FormControl hiddenLabel />. */
	  hiddenLabel: {},
	
	  /* Styles applied if the adornment is used inside <FormControl margin="dense" />. */
	  marginDense: {}
	};
	exports.styles = styles;
	var InputAdornment = /*#__PURE__*/React.forwardRef(function InputAdornment(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$disablePointer = props.disablePointerEvents,
	      disablePointerEvents = _props$disablePointer === void 0 ? false : _props$disablePointer,
	      _props$disableTypogra = props.disableTypography,
	      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
	      position = props.position,
	      variantProp = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"]);
	  var muiFormControl = (0, _FormControlContext.useFormControl)() || {};
	  var variant = variantProp;
	
	  if (variantProp && muiFormControl.variant) {
	    if (false) {
	      if (variantProp === muiFormControl.variant) {
	        console.error('Material-UI: The `InputAdornment` variant infers the variant prop ' + 'you do not have to provide one.');
	      }
	    }
	  }
	
	  if (muiFormControl && !variant) {
	    variant = muiFormControl.variant;
	  }
	
	  return /*#__PURE__*/React.createElement(_FormControlContext.default.Provider, {
	    value: null
	  }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, disablePointerEvents && classes.disablePointerEvents, muiFormControl.hiddenLabel && classes.hiddenLabel, variant === 'filled' && classes.filled, {
	      'start': classes.positionStart,
	      'end': classes.positionEnd
	    }[position], muiFormControl.margin === 'dense' && classes.marginDense),
	    ref: ref
	  }, other), typeof children === 'string' && !disableTypography ? /*#__PURE__*/React.createElement(_Typography.default, {
	    color: "textSecondary"
	  }, children) : children));
	});
	 false ? InputAdornment.propTypes = {
	  /**
	   * The content of the component, normally an `IconButton` or string.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * Disable pointer events on the root.
	   * This allows for the content of the adornment to focus the input on click.
	   */
	  disablePointerEvents: _propTypes.default.bool,
	
	  /**
	   * If children is a string then disable wrapping in a Typography component.
	   */
	  disableTypography: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  muiFormControl: _propTypes.default.object,
	
	  /**
	   * The position this adornment should appear relative to the `Input`.
	   */
	  position: _propTypes.default.oneOf(['start', 'end']),
	
	  /**
	   * The variant to use.
	   * Note: If you are using the `TextField` component or the `FormControl` component
	   * you do not have to set this manually.
	   */
	  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiInputAdornment'
	})(InputAdornment);
	
	exports.default = _default;

/***/ },
/* 1195 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _InputAdornment.default;
	  }
	});
	
	var _InputAdornment = _interopRequireDefault(__webpack_require__(1194));

/***/ },
/* 1196 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(19);
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _formControlState = _interopRequireDefault(__webpack_require__(191));
	
	var _FormControlContext = _interopRequireWildcard(__webpack_require__(298));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(47));
	
	var _TextareaAutosize = _interopRequireDefault(__webpack_require__(608));
	
	var _utils2 = __webpack_require__(400);
	
	/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
	var styles = function styles(theme) {
	  var light = theme.palette.type === 'light';
	  var placeholder = {
	    color: 'currentColor',
	    opacity: light ? 0.42 : 0.5,
	    transition: theme.transitions.create('opacity', {
	      duration: theme.transitions.duration.shorter
	    })
	  };
	  var placeholderHidden = {
	    opacity: '0 !important'
	  };
	  var placeholderVisible = {
	    opacity: light ? 0.42 : 0.5
	  };
	  return {
	    '@global': {
	      '@keyframes mui-auto-fill': {},
	      '@keyframes mui-auto-fill-cancel': {}
	    },
	
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({}, theme.typography.body1, {
	      color: theme.palette.text.primary,
	      lineHeight: '1.1876em',
	      // Reset (19px), match the native input line-height
	      boxSizing: 'border-box',
	      // Prevent padding issue with fullWidth.
	      position: 'relative',
	      cursor: 'text',
	      display: 'inline-flex',
	      alignItems: 'center',
	      '&$disabled': {
	        color: theme.palette.text.disabled,
	        cursor: 'default'
	      }
	    }),
	
	    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
	    formControl: {},
	
	    /* Styles applied to the root element if the component is focused. */
	    focused: {},
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `startAdornment` is provided. */
	    adornedStart: {},
	
	    /* Styles applied to the root element if `endAdornment` is provided. */
	    adornedEnd: {},
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    marginDense: {},
	
	    /* Styles applied to the root element if `multiline={true}`. */
	    multiline: {
	      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
	      '&$marginDense': {
	        paddingTop: 4 - 1
	      }
	    },
	
	    /* Styles applied to the root element if the color is secondary. */
	    colorSecondary: {},
	
	    /* Styles applied to the root element if `fullWidth={true}`. */
	    fullWidth: {
	      width: '100%'
	    },
	
	    /* Styles applied to the `input` element. */
	    input: {
	      font: 'inherit',
	      letterSpacing: 'inherit',
	      color: 'currentColor',
	      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
	      border: 0,
	      boxSizing: 'content-box',
	      background: 'none',
	      height: '1.1876em',
	      // Reset (19px), match the native input line-height
	      margin: 0,
	      // Reset for Safari
	      WebkitTapHighlightColor: 'transparent',
	      display: 'block',
	      // Make the flex item shrink with Firefox
	      minWidth: 0,
	      width: '100%',
	      // Fix IE 11 width issue
	      animationName: 'mui-auto-fill-cancel',
	      animationDuration: '10ms',
	      '&::-webkit-input-placeholder': placeholder,
	      '&::-moz-placeholder': placeholder,
	      // Firefox 19+
	      '&:-ms-input-placeholder': placeholder,
	      // IE 11
	      '&::-ms-input-placeholder': placeholder,
	      // Edge
	      '&:focus': {
	        outline: 0
	      },
	      // Reset Firefox invalid required input style
	      '&:invalid': {
	        boxShadow: 'none'
	      },
	      '&::-webkit-search-decoration': {
	        // Remove the padding when type=search.
	        '-webkit-appearance': 'none'
	      },
	      // Show and hide the placeholder logic
	      'label[data-shrink=false] + $formControl &': {
	        '&::-webkit-input-placeholder': placeholderHidden,
	        '&::-moz-placeholder': placeholderHidden,
	        // Firefox 19+
	        '&:-ms-input-placeholder': placeholderHidden,
	        // IE 11
	        '&::-ms-input-placeholder': placeholderHidden,
	        // Edge
	        '&:focus::-webkit-input-placeholder': placeholderVisible,
	        '&:focus::-moz-placeholder': placeholderVisible,
	        // Firefox 19+
	        '&:focus:-ms-input-placeholder': placeholderVisible,
	        // IE 11
	        '&:focus::-ms-input-placeholder': placeholderVisible // Edge
	
	      },
	      '&$disabled': {
	        opacity: 1 // Reset iOS opacity
	
	      },
	      '&:-webkit-autofill': {
	        animationDuration: '5000s',
	        animationName: 'mui-auto-fill'
	      }
	    },
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    inputMarginDense: {
	      paddingTop: 4 - 1
	    },
	
	    /* Styles applied to the `input` element if `multiline={true}`. */
	    inputMultiline: {
	      height: 'auto',
	      resize: 'none',
	      padding: 0
	    },
	
	    /* Styles applied to the `input` element if `type="search"`. */
	    inputTypeSearch: {
	      // Improve type search style.
	      '-moz-appearance': 'textfield',
	      '-webkit-appearance': 'textfield'
	    },
	
	    /* Styles applied to the `input` element if `startAdornment` is provided. */
	    inputAdornedStart: {},
	
	    /* Styles applied to the `input` element if `endAdornment` is provided. */
	    inputAdornedEnd: {},
	
	    /* Styles applied to the `input` element if `hiddenLabel={true}`. */
	    inputHiddenLabel: {}
	  };
	};
	
	exports.styles = styles;
	var useEnhancedEffect = typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;
	/**
	 * `InputBase` contains as few styles as possible.
	 * It aims to be a simple building block for creating an input.
	 * It contains a load of style reset and some state logic.
	 */
	
	var InputBase = /*#__PURE__*/React.forwardRef(function InputBase(props, ref) {
	  var ariaDescribedby = props['aria-describedby'],
	      autoComplete = props.autoComplete,
	      autoFocus = props.autoFocus,
	      classes = props.classes,
	      className = props.className,
	      color = props.color,
	      defaultValue = props.defaultValue,
	      disabled = props.disabled,
	      endAdornment = props.endAdornment,
	      error = props.error,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      id = props.id,
	      _props$inputComponent = props.inputComponent,
	      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
	      _props$inputProps = props.inputProps,
	      inputPropsProp = _props$inputProps === void 0 ? {} : _props$inputProps,
	      inputRefProp = props.inputRef,
	      margin = props.margin,
	      _props$multiline = props.multiline,
	      multiline = _props$multiline === void 0 ? false : _props$multiline,
	      name = props.name,
	      onBlur = props.onBlur,
	      onChange = props.onChange,
	      onClick = props.onClick,
	      onFocus = props.onFocus,
	      onKeyDown = props.onKeyDown,
	      onKeyUp = props.onKeyUp,
	      placeholder = props.placeholder,
	      readOnly = props.readOnly,
	      renderSuffix = props.renderSuffix,
	      rows = props.rows,
	      rowsMax = props.rowsMax,
	      rowsMin = props.rowsMin,
	      startAdornment = props.startAdornment,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'text' : _props$type,
	      valueProp = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["aria-describedby", "autoComplete", "autoFocus", "classes", "className", "color", "defaultValue", "disabled", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "rowsMax", "rowsMin", "startAdornment", "type", "value"]);
	  var value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
	
	  var _React$useRef = React.useRef(value != null),
	      isControlled = _React$useRef.current;
	
	  var inputRef = React.useRef();
	  var handleInputRefWarning = React.useCallback(function (instance) {
	    if (false) {
	      if (instance && instance.nodeName !== 'INPUT' && !instance.focus) {
	        console.error(['Material-UI: You have provided a `inputComponent` to the input component', 'that does not correctly handle the `inputRef` prop.', 'Make sure the `inputRef` prop is called with a HTMLInputElement.'].join('\n'));
	      }
	    }
	  }, []);
	  var handleInputPropsRefProp = (0, _useForkRef.default)(inputPropsProp.ref, handleInputRefWarning);
	  var handleInputRefProp = (0, _useForkRef.default)(inputRefProp, handleInputPropsRefProp);
	  var handleInputRef = (0, _useForkRef.default)(inputRef, handleInputRefProp);
	
	  var _React$useState = React.useState(false),
	      focused = _React$useState[0],
	      setFocused = _React$useState[1];
	
	  var muiFormControl = (0, _FormControlContext.useFormControl)();
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    React.useEffect(function () {
	      if (muiFormControl) {
	        return muiFormControl.registerEffect();
	      }
	
	      return undefined;
	    }, [muiFormControl]);
	  }
	
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['color', 'disabled', 'error', 'hiddenLabel', 'margin', 'required', 'filled']
	  });
	  fcs.focused = muiFormControl ? muiFormControl.focused : focused; // The blur won't fire when the disabled state is set on a focused input.
	  // We need to book keep the focused state manually.
	
	  React.useEffect(function () {
	    if (!muiFormControl && disabled && focused) {
	      setFocused(false);
	
	      if (onBlur) {
	        onBlur();
	      }
	    }
	  }, [muiFormControl, disabled, focused, onBlur]);
	  var onFilled = muiFormControl && muiFormControl.onFilled;
	  var onEmpty = muiFormControl && muiFormControl.onEmpty;
	  var checkDirty = React.useCallback(function (obj) {
	    if ((0, _utils2.isFilled)(obj)) {
	      if (onFilled) {
	        onFilled();
	      }
	    } else if (onEmpty) {
	      onEmpty();
	    }
	  }, [onFilled, onEmpty]);
	  useEnhancedEffect(function () {
	    if (isControlled) {
	      checkDirty({
	        value: value
	      });
	    }
	  }, [value, checkDirty, isControlled]);
	
	  var handleFocus = function handleFocus(event) {
	    // Fix a bug with IE 11 where the focus/blur events are triggered
	    // while the input is disabled.
	    if (fcs.disabled) {
	      event.stopPropagation();
	      return;
	    }
	
	    if (onFocus) {
	      onFocus(event);
	    }
	
	    if (inputPropsProp.onFocus) {
	      inputPropsProp.onFocus(event);
	    }
	
	    if (muiFormControl && muiFormControl.onFocus) {
	      muiFormControl.onFocus(event);
	    } else {
	      setFocused(true);
	    }
	  };
	
	  var handleBlur = function handleBlur(event) {
	    if (onBlur) {
	      onBlur(event);
	    }
	
	    if (inputPropsProp.onBlur) {
	      inputPropsProp.onBlur(event);
	    }
	
	    if (muiFormControl && muiFormControl.onBlur) {
	      muiFormControl.onBlur(event);
	    } else {
	      setFocused(false);
	    }
	  };
	
	  var handleChange = function handleChange(event) {
	    if (!isControlled) {
	      var element = event.target || inputRef.current;
	
	      if (element == null) {
	        throw new Error( false ? "Material-UI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://material-ui.com/r/input-component-ref-interface for more info." : (0, _utils.formatMuiErrorMessage)(1));
	      }
	
	      checkDirty({
	        value: element.value
	      });
	    }
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    if (inputPropsProp.onChange) {
	      inputPropsProp.onChange.apply(inputPropsProp, [event].concat(args));
	    } // Perform in the willUpdate
	
	
	    if (onChange) {
	      onChange.apply(void 0, [event].concat(args));
	    }
	  }; // Check the input state on mount, in case it was filled by the user
	  // or auto filled by the browser before the hydration (for SSR).
	
	
	  React.useEffect(function () {
	    checkDirty(inputRef.current);
	  }, []); // eslint-disable-line react-hooks/exhaustive-deps
	
	  var handleClick = function handleClick(event) {
	    if (inputRef.current && event.currentTarget === event.target) {
	      inputRef.current.focus();
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  var InputComponent = inputComponent;
	  var inputProps = (0, _extends2.default)({}, inputPropsProp, {
	    ref: handleInputRef
	  });
	
	  if (typeof InputComponent !== 'string') {
	    inputProps = (0, _extends2.default)({
	      // Rename ref to inputRef as we don't know the
	      // provided `inputComponent` structure.
	      inputRef: handleInputRef,
	      type: type
	    }, inputProps, {
	      ref: null
	    });
	  } else if (multiline) {
	    if (rows && !rowsMax && !rowsMin) {
	      InputComponent = 'textarea';
	    } else {
	      inputProps = (0, _extends2.default)({
	        rows: rows,
	        rowsMax: rowsMax
	      }, inputProps);
	      InputComponent = _TextareaAutosize.default;
	    }
	  } else {
	    inputProps = (0, _extends2.default)({
	      type: type
	    }, inputProps);
	  }
	
	  var handleAutoFill = function handleAutoFill(event) {
	    // Provide a fake value as Chrome might not let you access it for security reasons.
	    checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
	      value: 'x'
	    });
	  };
	
	  React.useEffect(function () {
	    if (muiFormControl) {
	      muiFormControl.setAdornedStart(Boolean(startAdornment));
	    }
	  }, [muiFormControl, startAdornment]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes["color".concat((0, _capitalize.default)(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fullWidth && classes.fullWidth, fcs.focused && classes.focused, muiFormControl && classes.formControl, multiline && classes.multiline, startAdornment && classes.adornedStart, endAdornment && classes.adornedEnd, fcs.margin === 'dense' && classes.marginDense),
	    onClick: handleClick,
	    ref: ref
	  }, other), startAdornment, /*#__PURE__*/React.createElement(_FormControlContext.default.Provider, {
	    value: null
	  }, /*#__PURE__*/React.createElement(InputComponent, (0, _extends2.default)({
	    "aria-invalid": fcs.error,
	    "aria-describedby": ariaDescribedby,
	    autoComplete: autoComplete,
	    autoFocus: autoFocus,
	    defaultValue: defaultValue,
	    disabled: fcs.disabled,
	    id: id,
	    onAnimationStart: handleAutoFill,
	    name: name,
	    placeholder: placeholder,
	    readOnly: readOnly,
	    required: fcs.required,
	    rows: rows,
	    value: value,
	    onKeyDown: onKeyDown,
	    onKeyUp: onKeyUp
	  }, inputProps, {
	    className: (0, _clsx.default)(classes.input, inputPropsProp.className, fcs.disabled && classes.disabled, multiline && classes.inputMultiline, fcs.hiddenLabel && classes.inputHiddenLabel, startAdornment && classes.inputAdornedStart, endAdornment && classes.inputAdornedEnd, type === 'search' && classes.inputTypeSearch, fcs.margin === 'dense' && classes.inputMarginDense),
	    onBlur: handleBlur,
	    onChange: handleChange,
	    onFocus: handleFocus
	  }))), endAdornment, renderSuffix ? renderSuffix((0, _extends2.default)({}, fcs, {
	    startAdornment: startAdornment
	  })) : null);
	});
	 false ? InputBase.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * @ignore
	   */
	  'aria-describedby': _propTypes.default.string,
	
	  /**
	   * This prop helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
	   */
	  autoComplete: _propTypes.default.string,
	
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The default `input` element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the `input` element will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * End `InputAdornment` for this component.
	   */
	  endAdornment: _propTypes.default.node,
	
	  /**
	   * If `true`, the input will indicate an error. This is normally obtained via context from
	   * FormControl.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * The component used for the `input` element.
	   * Either a string to use a HTML element or a component.
	   */
	  inputComponent: _propTypes.default.elementType,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense', 'none']),
	
	  /**
	   * If `true`, a textarea element will be rendered.
	   */
	  multiline: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback fired when the input is blurred.
	   *
	   * Notice that the first argument (event) might be undefined.
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyUp: _propTypes.default.func,
	
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * It prevents the user from changing the value of the field
	   * (not from interacting with the field).
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  renderSuffix: _propTypes.default.func,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Minimum number of rows to display when multiline option is set to true.
	   */
	  rowsMin: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Start `InputAdornment` for this component.
	   */
	  startAdornment: _propTypes.default.node,
	
	  /**
	   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the `input` element, required for a controlled component.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiInputBase'
	})(InputBase);
	
	exports.default = _default;

/***/ },
/* 1197 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _formControlState = _interopRequireDefault(__webpack_require__(191));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(154));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _FormLabel = _interopRequireDefault(__webpack_require__(586));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'block',
	      transformOrigin: 'top left'
	    },
	
	    /* Pseudo-class applied to the root element if `focused={true}`. */
	    focused: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Pseudo-class applied to the root element if `required={true}`. */
	    required: {},
	
	    /* Pseudo-class applied to the asterisk element. */
	    asterisk: {},
	
	    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
	    formControl: {
	      position: 'absolute',
	      left: 0,
	      top: 0,
	      // slight alteration to spec spacing to match visual spec result
	      transform: 'translate(0, 24px) scale(1)'
	    },
	
	    /* Styles applied to the root element if `margin="dense"`. */
	    marginDense: {
	      // Compensation for the `Input.inputDense` style.
	      transform: 'translate(0, 21px) scale(1)'
	    },
	
	    /* Styles applied to the `input` element if `shrink={true}`. */
	    shrink: {
	      transform: 'translate(0, 1.5px) scale(0.75)',
	      transformOrigin: 'top left'
	    },
	
	    /* Styles applied to the `input` element if `disableAnimation={false}`. */
	    animated: {
	      transition: theme.transitions.create(['color', 'transform'], {
	        duration: theme.transitions.duration.shorter,
	        easing: theme.transitions.easing.easeOut
	      })
	    },
	
	    /* Styles applied to the root element if `variant="filled"`. */
	    filled: {
	      // Chrome's autofill feature gives the input field a yellow background.
	      // Since the input field is behind the label in the HTML tree,
	      // the input field is drawn last and hides the label with an opaque background color.
	      // zIndex: 1 will raise the label above opaque background-colors of input.
	      zIndex: 1,
	      pointerEvents: 'none',
	      transform: 'translate(12px, 20px) scale(1)',
	      '&$marginDense': {
	        transform: 'translate(12px, 17px) scale(1)'
	      },
	      '&$shrink': {
	        transform: 'translate(12px, 10px) scale(0.75)',
	        '&$marginDense': {
	          transform: 'translate(12px, 7px) scale(0.75)'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"`. */
	    outlined: {
	      // see comment above on filled.zIndex
	      zIndex: 1,
	      pointerEvents: 'none',
	      transform: 'translate(14px, 20px) scale(1)',
	      '&$marginDense': {
	        transform: 'translate(14px, 12px) scale(1)'
	      },
	      '&$shrink': {
	        transform: 'translate(14px, -6px) scale(0.75)'
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var InputLabel = /*#__PURE__*/React.forwardRef(function InputLabel(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$disableAnimati = props.disableAnimation,
	      disableAnimation = _props$disableAnimati === void 0 ? false : _props$disableAnimati,
	      margin = props.margin,
	      shrinkProp = props.shrink,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "disableAnimation", "margin", "shrink", "variant"]);
	  var muiFormControl = (0, _useFormControl.default)();
	  var shrink = shrinkProp;
	
	  if (typeof shrink === 'undefined' && muiFormControl) {
	    shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
	  }
	
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['margin', 'variant']
	  });
	  return /*#__PURE__*/React.createElement(_FormLabel.default, (0, _extends2.default)({
	    "data-shrink": shrink,
	    className: (0, _clsx.default)(classes.root, className, muiFormControl && classes.formControl, !disableAnimation && classes.animated, shrink && classes.shrink, fcs.margin === 'dense' && classes.marginDense, {
	      'filled': classes.filled,
	      'outlined': classes.outlined
	    }[fcs.variant]),
	    classes: {
	      focused: classes.focused,
	      disabled: classes.disabled,
	      error: classes.error,
	      required: classes.required,
	      asterisk: classes.asterisk
	    },
	    ref: ref
	  }, other));
	});
	 false ? InputLabel.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The contents of the `InputLabel`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * If `true`, the transition animation is disabled.
	   */
	  disableAnimation: _propTypes.default.bool,
	
	  /**
	   * If `true`, apply disabled class.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label will be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input of this label is focused.
	   */
	  focused: _propTypes.default.bool,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense']),
	
	  /**
	   * if `true`, the label will indicate that the input is required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label is shrunk.
	   */
	  shrink: _propTypes.default.bool,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['filled', 'outlined', 'standard'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiInputLabel'
	})(InputLabel);
	
	exports.default = _default;

/***/ },
/* 1198 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _colorManipulator = __webpack_require__(63);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(59));
	
	var TRANSITION_DURATION = 4; // seconds
	
	var styles = function styles(theme) {
	  var getColor = function getColor(color) {
	    return theme.palette.type === 'light' ? (0, _colorManipulator.lighten)(color, 0.62) : (0, _colorManipulator.darken)(color, 0.5);
	  };
	
	  var backgroundPrimary = getColor(theme.palette.primary.main);
	  var backgroundSecondary = getColor(theme.palette.secondary.main);
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      overflow: 'hidden',
	      height: 4,
	      '@media print': {
	        colorAdjust: 'exact'
	      }
	    },
	
	    /* Styles applied to the root and bar2 element if `color="primary"`; bar2 if `variant="buffer"`. */
	    colorPrimary: {
	      backgroundColor: backgroundPrimary
	    },
	
	    /* Styles applied to the root and bar2 elements if `color="secondary"`; bar2 if `variant="buffer"`. */
	    colorSecondary: {
	      backgroundColor: backgroundSecondary
	    },
	
	    /* Styles applied to the root element if `variant="determinate"`. */
	    determinate: {},
	
	    /* Styles applied to the root element if `variant="indeterminate"`. */
	    indeterminate: {},
	
	    /* Styles applied to the root element if `variant="buffer"`. */
	    buffer: {
	      backgroundColor: 'transparent'
	    },
	
	    /* Styles applied to the root element if `variant="query"`. */
	    query: {
	      transform: 'rotate(180deg)'
	    },
	
	    /* Styles applied to the additional bar element if `variant="buffer"`. */
	    dashed: {
	      position: 'absolute',
	      marginTop: 0,
	      height: '100%',
	      width: '100%',
	      animation: '$buffer 3s infinite linear'
	    },
	
	    /* Styles applied to the additional bar element if `variant="buffer"` and `color="primary"`. */
	    dashedColorPrimary: {
	      backgroundImage: "radial-gradient(".concat(backgroundPrimary, " 0%, ").concat(backgroundPrimary, " 16%, transparent 42%)"),
	      backgroundSize: '10px 10px',
	      backgroundPosition: '0 -23px'
	    },
	
	    /* Styles applied to the additional bar element if `variant="buffer"` and `color="secondary"`. */
	    dashedColorSecondary: {
	      backgroundImage: "radial-gradient(".concat(backgroundSecondary, " 0%, ").concat(backgroundSecondary, " 16%, transparent 42%)"),
	      backgroundSize: '10px 10px',
	      backgroundPosition: '0 -23px'
	    },
	
	    /* Styles applied to the layered bar1 and bar2 elements. */
	    bar: {
	      width: '100%',
	      position: 'absolute',
	      left: 0,
	      bottom: 0,
	      top: 0,
	      transition: 'transform 0.2s linear',
	      transformOrigin: 'left'
	    },
	
	    /* Styles applied to the bar elements if `color="primary"`; bar2 if `variant` not "buffer". */
	    barColorPrimary: {
	      backgroundColor: theme.palette.primary.main
	    },
	
	    /* Styles applied to the bar elements if `color="secondary"`; bar2 if `variant` not "buffer". */
	    barColorSecondary: {
	      backgroundColor: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the bar1 element if `variant="indeterminate or query"`. */
	    bar1Indeterminate: {
	      width: 'auto',
	      animation: '$indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite'
	    },
	
	    /* Styles applied to the bar1 element if `variant="determinate"`. */
	    bar1Determinate: {
	      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
	    },
	
	    /* Styles applied to the bar1 element if `variant="buffer"`. */
	    bar1Buffer: {
	      zIndex: 1,
	      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
	    },
	
	    /* Styles applied to the bar2 element if `variant="indeterminate or query"`. */
	    bar2Indeterminate: {
	      width: 'auto',
	      animation: '$indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite'
	    },
	
	    /* Styles applied to the bar2 element if `variant="buffer"`. */
	    bar2Buffer: {
	      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
	    },
	    // Legends:
	    // || represents the viewport
	    // -  represents a light background
	    // x  represents a dark background
	    '@keyframes indeterminate1': {
	      //  |-----|---x-||-----||-----|
	      '0%': {
	        left: '-35%',
	        right: '100%'
	      },
	      //  |-----|-----||-----||xxxx-|
	      '60%': {
	        left: '100%',
	        right: '-90%'
	      },
	      '100%': {
	        left: '100%',
	        right: '-90%'
	      }
	    },
	    '@keyframes indeterminate2': {
	      //  |xxxxx|xxxxx||-----||-----|
	      '0%': {
	        left: '-200%',
	        right: '100%'
	      },
	      //  |-----|-----||-----||-x----|
	      '60%': {
	        left: '107%',
	        right: '-8%'
	      },
	      '100%': {
	        left: '107%',
	        right: '-8%'
	      }
	    },
	    '@keyframes buffer': {
	      '0%': {
	        opacity: 1,
	        backgroundPosition: '0 -23px'
	      },
	      '50%': {
	        opacity: 0,
	        backgroundPosition: '0 -23px'
	      },
	      '100%': {
	        opacity: 1,
	        backgroundPosition: '-200px -23px'
	      }
	    }
	  };
	};
	/**
	 * ## ARIA
	 *
	 * If the progress bar is describing the loading progress of a particular region of a page,
	 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
	 * attribute to `true` on that region until it has finished loading.
	 */
	
	
	exports.styles = styles;
	var LinearProgress = /*#__PURE__*/React.forwardRef(function LinearProgress(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      value = props.value,
	      valueBuffer = props.valueBuffer,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'indeterminate' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "value", "valueBuffer", "variant"]);
	  var theme = (0, _useTheme.default)();
	  var rootProps = {};
	  var inlineStyles = {
	    bar1: {},
	    bar2: {}
	  };
	
	  if (variant === 'determinate' || variant === 'buffer') {
	    if (value !== undefined) {
	      rootProps['aria-valuenow'] = Math.round(value);
	      rootProps['aria-valuemin'] = 0;
	      rootProps['aria-valuemax'] = 100;
	      var transform = value - 100;
	
	      if (theme.direction === 'rtl') {
	        transform = -transform;
	      }
	
	      inlineStyles.bar1.transform = "translateX(".concat(transform, "%)");
	    } else if (false) {
	      console.error('Material-UI: You need to provide a value prop ' + 'when using the determinate or buffer variant of LinearProgress .');
	    }
	  }
	
	  if (variant === 'buffer') {
	    if (valueBuffer !== undefined) {
	      var _transform = (valueBuffer || 0) - 100;
	
	      if (theme.direction === 'rtl') {
	        _transform = -_transform;
	      }
	
	      inlineStyles.bar2.transform = "translateX(".concat(_transform, "%)");
	    } else if (false) {
	      console.error('Material-UI: You need to provide a valueBuffer prop ' + 'when using the buffer variant of LinearProgress.');
	    }
	  }
	
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes["color".concat((0, _capitalize.default)(color))], className, {
	      'determinate': classes.determinate,
	      'indeterminate': classes.indeterminate,
	      'buffer': classes.buffer,
	      'query': classes.query
	    }[variant]),
	    role: "progressbar"
	  }, rootProps, {
	    ref: ref
	  }, other), variant === 'buffer' ? /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.dashed, classes["dashedColor".concat((0, _capitalize.default)(color))])
	  }) : null, /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.bar, classes["barColor".concat((0, _capitalize.default)(color))], (variant === 'indeterminate' || variant === 'query') && classes.bar1Indeterminate, {
	      'determinate': classes.bar1Determinate,
	      'buffer': classes.bar1Buffer
	    }[variant]),
	    style: inlineStyles.bar1
	  }), variant === 'determinate' ? null : /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.bar, (variant === 'indeterminate' || variant === 'query') && classes.bar2Indeterminate, variant === 'buffer' ? [classes["color".concat((0, _capitalize.default)(color))], classes.bar2Buffer] : classes["barColor".concat((0, _capitalize.default)(color))]),
	    style: inlineStyles.bar2
	  }));
	});
	 false ? LinearProgress.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The value of the progress indicator for the determinate and buffer variants.
	   * Value between 0 and 100.
	   */
	  value: _propTypes.default.number,
	
	  /**
	   * The value for the buffer variant.
	   * Value between 0 and 100.
	   */
	  valueBuffer: _propTypes.default.number,
	
	  /**
	   * The variant to use.
	   * Use indeterminate or query when there is no progress value.
	   */
	  variant: _propTypes.default.oneOf(['buffer', 'determinate', 'indeterminate', 'query'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiLinearProgress'
	})(LinearProgress);
	
	exports.default = _default;

/***/ },
/* 1199 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _utils = __webpack_require__(19);
	
	var _useIsFocusVisible2 = _interopRequireDefault(__webpack_require__(243));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(47));
	
	var _Typography = _interopRequireDefault(__webpack_require__(75));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {},
	
	  /* Styles applied to the root element if `underline="none"`. */
	  underlineNone: {
	    textDecoration: 'none'
	  },
	
	  /* Styles applied to the root element if `underline="hover"`. */
	  underlineHover: {
	    textDecoration: 'none',
	    '&:hover': {
	      textDecoration: 'underline'
	    }
	  },
	
	  /* Styles applied to the root element if `underline="always"`. */
	  underlineAlways: {
	    textDecoration: 'underline'
	  },
	  // Same reset as ButtonBase.root
	
	  /* Styles applied to the root element if `component="button"`. */
	  button: {
	    position: 'relative',
	    WebkitTapHighlightColor: 'transparent',
	    backgroundColor: 'transparent',
	    // Reset default value
	    // We disable the focus ring for mouse, touch and keyboard users.
	    outline: 0,
	    border: 0,
	    margin: 0,
	    // Remove the margin in Safari
	    borderRadius: 0,
	    padding: 0,
	    // Remove the padding in Firefox
	    cursor: 'pointer',
	    userSelect: 'none',
	    verticalAlign: 'middle',
	    '-moz-appearance': 'none',
	    // Reset
	    '-webkit-appearance': 'none',
	    // Reset
	    '&::-moz-focus-inner': {
	      borderStyle: 'none' // Remove Firefox dotted outline.
	
	    },
	    '&$focusVisible': {
	      outline: 'auto'
	    }
	  },
	
	  /* Pseudo-class applied to the root element if the link is keyboard focused. */
	  focusVisible: {}
	};
	exports.styles = styles;
	var Link = /*#__PURE__*/React.forwardRef(function Link(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      _props$component = props.component,
	      component = _props$component === void 0 ? 'a' : _props$component,
	      onBlur = props.onBlur,
	      onFocus = props.onFocus,
	      TypographyClasses = props.TypographyClasses,
	      _props$underline = props.underline,
	      underline = _props$underline === void 0 ? 'hover' : _props$underline,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'inherit' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant"]);
	
	  var _useIsFocusVisible = (0, _useIsFocusVisible2.default)(),
	      isFocusVisible = _useIsFocusVisible.isFocusVisible,
	      onBlurVisible = _useIsFocusVisible.onBlurVisible,
	      focusVisibleRef = _useIsFocusVisible.ref;
	
	  var _React$useState = React.useState(false),
	      focusVisible = _React$useState[0],
	      setFocusVisible = _React$useState[1];
	
	  var handlerRef = (0, _useForkRef.default)(ref, focusVisibleRef);
	
	  var handleBlur = function handleBlur(event) {
	    if (focusVisible) {
	      onBlurVisible();
	      setFocusVisible(false);
	    }
	
	    if (onBlur) {
	      onBlur(event);
	    }
	  };
	
	  var handleFocus = function handleFocus(event) {
	    if (isFocusVisible(event)) {
	      setFocusVisible(true);
	    }
	
	    if (onFocus) {
	      onFocus(event);
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(_Typography.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes["underline".concat((0, _capitalize.default)(underline))], className, focusVisible && classes.focusVisible, component === 'button' && classes.button),
	    classes: TypographyClasses,
	    color: color,
	    component: component,
	    onBlur: handleBlur,
	    onFocus: handleFocus,
	    ref: handlerRef,
	    variant: variant
	  }, other));
	});
	 false ? Link.propTypes = {
	  /**
	   * The content of the link.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the link.
	   */
	  color: _propTypes.default.oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _utils.elementTypeAcceptingRef,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * `classes` prop applied to the [`Typography`](/api/typography/) element.
	   */
	  TypographyClasses: _propTypes.default.object,
	
	  /**
	   * Controls when the link should have an underline.
	   */
	  underline: _propTypes.default.oneOf(['none', 'hover', 'always']),
	
	  /**
	   * Applies the theme typography styles.
	   */
	  variant: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiLink'
	})(Link);
	
	exports.default = _default;

/***/ },
/* 1200 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Link.default;
	  }
	});
	
	var _Link = _interopRequireDefault(__webpack_require__(1199));

/***/ },
/* 1201 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _ListContext = _interopRequireDefault(__webpack_require__(238));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    listStyle: 'none',
	    margin: 0,
	    padding: 0,
	    position: 'relative'
	  },
	
	  /* Styles applied to the root element if `disablePadding={false}`. */
	  padding: {
	    paddingTop: 8,
	    paddingBottom: 8
	  },
	
	  /* Styles applied to the root element if dense. */
	  dense: {},
	
	  /* Styles applied to the root element if a `subheader` is provided. */
	  subheader: {
	    paddingTop: 0
	  }
	};
	exports.styles = styles;
	var List = /*#__PURE__*/React.forwardRef(function List(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'ul' : _props$component,
	      _props$dense = props.dense,
	      dense = _props$dense === void 0 ? false : _props$dense,
	      _props$disablePadding = props.disablePadding,
	      disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding,
	      subheader = props.subheader,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]);
	  var context = React.useMemo(function () {
	    return {
	      dense: dense
	    };
	  }, [dense]);
	  return /*#__PURE__*/React.createElement(_ListContext.default.Provider, {
	    value: context
	  }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, dense && classes.dense, !disablePadding && classes.padding, subheader && classes.subheader),
	    ref: ref
	  }, other), subheader, children));
	});
	 false ? List.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, compact vertical padding designed for keyboard and mouse input will be used for
	   * the list and list items.
	   * The prop is available to descendant components as the `dense` context.
	   */
	  dense: _propTypes.default.bool,
	
	  /**
	   * If `true`, vertical padding will be removed from the list.
	   */
	  disablePadding: _propTypes.default.bool,
	
	  /**
	   * The content of the subheader, normally `ListSubheader`.
	   */
	  subheader: _propTypes.default.node
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiList'
	})(List);
	
	exports.default = _default;

/***/ },
/* 1202 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _utils = __webpack_require__(19);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(69));
	
	var _isMuiElement = _interopRequireDefault(__webpack_require__(242));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(47));
	
	var _ListContext = _interopRequireDefault(__webpack_require__(238));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(51));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */
	    root: {
	      display: 'flex',
	      justifyContent: 'flex-start',
	      alignItems: 'center',
	      position: 'relative',
	      textDecoration: 'none',
	      width: '100%',
	      boxSizing: 'border-box',
	      textAlign: 'left',
	      paddingTop: 8,
	      paddingBottom: 8,
	      '&$focusVisible': {
	        backgroundColor: theme.palette.action.selected
	      },
	      '&$selected, &$selected:hover': {
	        backgroundColor: theme.palette.action.selected
	      },
	      '&$disabled': {
	        opacity: 0.5
	      }
	    },
	
	    /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */
	    container: {
	      position: 'relative'
	    },
	
	    /* Pseudo-class applied to the `component`'s `focusVisibleClassName` prop if `button={true}`. */
	    focusVisible: {},
	
	    /* Styles applied to the `component` element if dense. */
	    dense: {
	      paddingTop: 4,
	      paddingBottom: 4
	    },
	
	    /* Styles applied to the `component` element if `alignItems="flex-start"`. */
	    alignItemsFlexStart: {
	      alignItems: 'flex-start'
	    },
	
	    /* Pseudo-class applied to the inner `component` element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the inner `component` element if `divider={true}`. */
	    divider: {
	      borderBottom: "1px solid ".concat(theme.palette.divider),
	      backgroundClip: 'padding-box'
	    },
	
	    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
	    gutters: {
	      paddingLeft: 16,
	      paddingRight: 16
	    },
	
	    /* Styles applied to the inner `component` element if `button={true}`. */
	    button: {
	      transition: theme.transitions.create('background-color', {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&:hover': {
	        textDecoration: 'none',
	        backgroundColor: theme.palette.action.hover,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */
	    secondaryAction: {
	      // Add some space to avoid collision as `ListItemSecondaryAction`
	      // is absolutely positioned.
	      paddingRight: 48
	    },
	
	    /* Pseudo-class applied to the root element if `selected={true}`. */
	    selected: {}
	  };
	};
	
	exports.styles = styles;
	var useEnhancedEffect = typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;
	/**
	 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
	 */
	
	var ListItem = /*#__PURE__*/React.forwardRef(function ListItem(props, ref) {
	  var _props$alignItems = props.alignItems,
	      alignItems = _props$alignItems === void 0 ? 'center' : _props$alignItems,
	      _props$autoFocus = props.autoFocus,
	      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
	      _props$button = props.button,
	      button = _props$button === void 0 ? false : _props$button,
	      childrenProp = props.children,
	      classes = props.classes,
	      className = props.className,
	      componentProp = props.component,
	      _props$ContainerCompo = props.ContainerComponent,
	      ContainerComponent = _props$ContainerCompo === void 0 ? 'li' : _props$ContainerCompo,
	      _props$ContainerProps = props.ContainerProps;
	  _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;
	  var ContainerClassName = _props$ContainerProps.className,
	      ContainerProps = (0, _objectWithoutProperties2.default)(_props$ContainerProps, ["className"]),
	      _props$dense = props.dense,
	      dense = _props$dense === void 0 ? false : _props$dense,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableGutters = props.disableGutters,
	      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
	      _props$divider = props.divider,
	      divider = _props$divider === void 0 ? false : _props$divider,
	      focusVisibleClassName = props.focusVisibleClassName,
	      _props$selected = props.selected,
	      selected = _props$selected === void 0 ? false : _props$selected,
	      other = (0, _objectWithoutProperties2.default)(props, ["alignItems", "autoFocus", "button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName", "selected"]);
	  var context = React.useContext(_ListContext.default);
	  var childContext = {
	    dense: dense || context.dense || false,
	    alignItems: alignItems
	  };
	  var listItemRef = React.useRef(null);
	  useEnhancedEffect(function () {
	    if (autoFocus) {
	      if (listItemRef.current) {
	        listItemRef.current.focus();
	      } else if (false) {
	        console.error('Material-UI: Unable to set focus to a ListItem whose component has not been rendered.');
	      }
	    }
	  }, [autoFocus]);
	  var children = React.Children.toArray(childrenProp);
	  var hasSecondaryAction = children.length && (0, _isMuiElement.default)(children[children.length - 1], ['ListItemSecondaryAction']);
	  var handleOwnRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    listItemRef.current = ReactDOM.findDOMNode(instance);
	  }, []);
	  var handleRef = (0, _useForkRef.default)(handleOwnRef, ref);
	  var componentProps = (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, childContext.dense && classes.dense, !disableGutters && classes.gutters, divider && classes.divider, disabled && classes.disabled, button && classes.button, alignItems !== "center" && classes.alignItemsFlexStart, hasSecondaryAction && classes.secondaryAction, selected && classes.selected),
	    disabled: disabled
	  }, other);
	  var Component = componentProp || 'li';
	
	  if (button) {
	    componentProps.component = componentProp || 'div';
	    componentProps.focusVisibleClassName = (0, _clsx.default)(classes.focusVisible, focusVisibleClassName);
	    Component = _ButtonBase.default;
	  }
	
	  if (hasSecondaryAction) {
	    // Use div by default.
	    Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.
	
	    if (ContainerComponent === 'li') {
	      if (Component === 'li') {
	        Component = 'div';
	      } else if (componentProps.component === 'li') {
	        componentProps.component = 'div';
	      }
	    }
	
	    return /*#__PURE__*/React.createElement(_ListContext.default.Provider, {
	      value: childContext
	    }, /*#__PURE__*/React.createElement(ContainerComponent, (0, _extends2.default)({
	      className: (0, _clsx.default)(classes.container, ContainerClassName),
	      ref: handleRef
	    }, ContainerProps), /*#__PURE__*/React.createElement(Component, componentProps, children), children.pop()));
	  }
	
	  return /*#__PURE__*/React.createElement(_ListContext.default.Provider, {
	    value: childContext
	  }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    ref: handleRef
	  }, componentProps), children));
	});
	 false ? ListItem.propTypes = {
	  /**
	   * Defines the `align-items` style property.
	   */
	  alignItems: _propTypes.default.oneOf(['flex-start', 'center']),
	
	  /**
	   * If `true`, the list item will be focused during the first mount.
	   * Focus will also be triggered if the value changes from false to true.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, the list item will be a button (using `ButtonBase`). Props intended
	   * for `ButtonBase` can then be applied to `ListItem`.
	   */
	  button: _propTypes.default.bool,
	
	  /**
	   * The content of the component. If a `ListItemSecondaryAction` is used it must
	   * be the last child.
	   */
	  children: (0, _utils.chainPropTypes)(_propTypes.default.node, function (props) {
	    var children = React.Children.toArray(props.children); // React.Children.toArray(props.children).findLastIndex(isListItemSecondaryAction)
	
	    var secondaryActionIndex = -1;
	
	    for (var i = children.length - 1; i >= 0; i -= 1) {
	      var child = children[i];
	
	      if ((0, _isMuiElement.default)(child, ['ListItemSecondaryAction'])) {
	        secondaryActionIndex = i;
	        break;
	      }
	    } //  is ListItemSecondaryAction the last child of ListItem
	
	
	    if (secondaryActionIndex !== -1 && secondaryActionIndex !== children.length - 1) {
	      return new Error('Material-UI: You used an element after ListItemSecondaryAction. ' + 'For ListItem to detect that it has a secondary action ' + 'you must pass it as the last child to ListItem.');
	    }
	
	    return null;
	  }),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   * By default, it's a `li` when `button` is `false` and a `div` when `button` is `true`.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * The container component used when a `ListItemSecondaryAction` is the last child.
	   */
	  ContainerComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the container component if used.
	   */
	  ContainerProps: _propTypes.default.object,
	
	  /**
	   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
	   */
	  dense: _propTypes.default.bool,
	
	  /**
	   * If `true`, the list item will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the left and right padding is removed.
	   */
	  disableGutters: _propTypes.default.bool,
	
	  /**
	   * If `true`, a 1px light border is added to the bottom of the list item.
	   */
	  divider: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  focusVisibleClassName: _propTypes.default.string,
	
	  /**
	   * Use to apply selected styling.
	   */
	  selected: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItem'
	})(ListItem);
	
	exports.default = _default;

/***/ },
/* 1203 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _ListContext = _interopRequireDefault(__webpack_require__(238));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    minWidth: 56,
	    flexShrink: 0
	  },
	
	  /* Styles applied to the root element when the parent `ListItem` uses `alignItems="flex-start"`. */
	  alignItemsFlexStart: {
	    marginTop: 8
	  }
	};
	/**
	 * A simple wrapper to apply `List` styles to an `Avatar`.
	 */
	
	exports.styles = styles;
	var ListItemAvatar = /*#__PURE__*/React.forwardRef(function ListItemAvatar(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className"]);
	  var context = React.useContext(_ListContext.default);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, context.alignItems === 'flex-start' && classes.alignItemsFlexStart),
	    ref: ref
	  }, other));
	});
	 false ? ListItemAvatar.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component – normally `Avatar`.
	   */
	  children: _propTypes.default.element.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItemAvatar'
	})(ListItemAvatar);
	
	exports.default = _default;

/***/ },
/* 1204 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _ListContext = _interopRequireDefault(__webpack_require__(238));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      minWidth: 56,
	      color: theme.palette.action.active,
	      flexShrink: 0,
	      display: 'inline-flex'
	    },
	
	    /* Styles applied to the root element when the parent `ListItem` uses `alignItems="flex-start"`. */
	    alignItemsFlexStart: {
	      marginTop: 8
	    }
	  };
	};
	/**
	 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
	 */
	
	
	exports.styles = styles;
	var ListItemIcon = /*#__PURE__*/React.forwardRef(function ListItemIcon(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className"]);
	  var context = React.useContext(_ListContext.default);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, context.alignItems === 'flex-start' && classes.alignItemsFlexStart),
	    ref: ref
	  }, other));
	});
	 false ? ListItemIcon.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component, normally `Icon`, `SvgIcon`,
	   * or a `@material-ui/icons` SVG icon element.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItemIcon'
	})(ListItemIcon);
	
	exports.default = _default;

/***/ },
/* 1205 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemIcon.default;
	  }
	});
	
	var _ListItemIcon = _interopRequireDefault(__webpack_require__(1204));

/***/ },
/* 1206 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    position: 'absolute',
	    right: 16,
	    top: '50%',
	    transform: 'translateY(-50%)'
	  }
	};
	/**
	 * Must be used as the last child of ListItem to function properly.
	 */
	
	exports.styles = styles;
	var ListItemSecondaryAction = /*#__PURE__*/React.forwardRef(function ListItemSecondaryAction(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other));
	});
	 false ? ListItemSecondaryAction.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component, normally an `IconButton` or selection control.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : void 0;
	ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItemSecondaryAction'
	})(ListItemSecondaryAction);
	
	exports.default = _default;

/***/ },
/* 1207 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemSecondaryAction.default;
	  }
	});
	
	var _ListItemSecondaryAction = _interopRequireDefault(__webpack_require__(1206));

/***/ },
/* 1208 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _Typography = _interopRequireDefault(__webpack_require__(75));
	
	var _ListContext = _interopRequireDefault(__webpack_require__(238));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    flex: '1 1 auto',
	    minWidth: 0,
	    marginTop: 4,
	    marginBottom: 4
	  },
	
	  /* Styles applied to the `Typography` components if primary and secondary are set. */
	  multiline: {
	    marginTop: 6,
	    marginBottom: 6
	  },
	
	  /* Styles applied to the `Typography` components if dense. */
	  dense: {},
	
	  /* Styles applied to the root element if `inset={true}`. */
	  inset: {
	    paddingLeft: 56
	  },
	
	  /* Styles applied to the primary `Typography` component. */
	  primary: {},
	
	  /* Styles applied to the secondary `Typography` component. */
	  secondary: {}
	};
	exports.styles = styles;
	var ListItemText = /*#__PURE__*/React.forwardRef(function ListItemText(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$disableTypogra = props.disableTypography,
	      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
	      _props$inset = props.inset,
	      inset = _props$inset === void 0 ? false : _props$inset,
	      primaryProp = props.primary,
	      primaryTypographyProps = props.primaryTypographyProps,
	      secondaryProp = props.secondary,
	      secondaryTypographyProps = props.secondaryTypographyProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"]);
	
	  var _React$useContext = React.useContext(_ListContext.default),
	      dense = _React$useContext.dense;
	
	  var primary = primaryProp != null ? primaryProp : children;
	
	  if (primary != null && primary.type !== _Typography.default && !disableTypography) {
	    primary = /*#__PURE__*/React.createElement(_Typography.default, (0, _extends2.default)({
	      variant: dense ? 'body2' : 'body1',
	      className: classes.primary,
	      component: "span",
	      display: "block"
	    }, primaryTypographyProps), primary);
	  }
	
	  var secondary = secondaryProp;
	
	  if (secondary != null && secondary.type !== _Typography.default && !disableTypography) {
	    secondary = /*#__PURE__*/React.createElement(_Typography.default, (0, _extends2.default)({
	      variant: "body2",
	      className: classes.secondary,
	      color: "textSecondary",
	      display: "block"
	    }, secondaryTypographyProps), secondary);
	  }
	
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, dense && classes.dense, inset && classes.inset, primary && secondary && classes.multiline),
	    ref: ref
	  }, other), primary, secondary);
	});
	 false ? ListItemText.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Alias for the `primary` prop.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the children won't be wrapped by a Typography component.
	   * This can be useful to render an alternative Typography variant by wrapping
	   * the `children` (or `primary`) text, and optional `secondary` text
	   * with the Typography component.
	   */
	  disableTypography: _propTypes.default.bool,
	
	  /**
	   * If `true`, the children will be indented.
	   * This should be used if there is no left avatar or left icon.
	   */
	  inset: _propTypes.default.bool,
	
	  /**
	   * The main content element.
	   */
	  primary: _propTypes.default.node,
	
	  /**
	   * These props will be forwarded to the primary typography component
	   * (as long as disableTypography is not `true`).
	   */
	  primaryTypographyProps: _propTypes.default.object,
	
	  /**
	   * The secondary content element.
	   */
	  secondary: _propTypes.default.node,
	
	  /**
	   * These props will be forwarded to the secondary typography component
	   * (as long as disableTypography is not `true`).
	   */
	  secondaryTypographyProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItemText'
	})(ListItemText);
	
	exports.default = _default;

/***/ },
/* 1209 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      boxSizing: 'border-box',
	      lineHeight: '48px',
	      listStyle: 'none',
	      color: theme.palette.text.secondary,
	      fontFamily: theme.typography.fontFamily,
	      fontWeight: theme.typography.fontWeightMedium,
	      fontSize: theme.typography.pxToRem(14)
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
	    gutters: {
	      paddingLeft: 16,
	      paddingRight: 16
	    },
	
	    /* Styles applied to the root element if `inset={true}`. */
	    inset: {
	      paddingLeft: 72
	    },
	
	    /* Styles applied to the root element if `disableSticky={false}`. */
	    sticky: {
	      position: 'sticky',
	      top: 0,
	      zIndex: 1,
	      backgroundColor: 'inherit'
	    }
	  };
	};
	
	exports.styles = styles;
	var ListSubheader = /*#__PURE__*/React.forwardRef(function ListSubheader(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'li' : _props$component,
	      _props$disableGutters = props.disableGutters,
	      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
	      _props$disableSticky = props.disableSticky,
	      disableSticky = _props$disableSticky === void 0 ? false : _props$disableSticky,
	      _props$inset = props.inset,
	      inset = _props$inset === void 0 ? false : _props$inset,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "component", "disableGutters", "disableSticky", "inset"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, color !== 'default' && classes["color".concat((0, _capitalize.default)(color))], inset && classes.inset, !disableSticky && classes.sticky, !disableGutters && classes.gutters),
	    ref: ref
	  }, other));
	});
	 false ? ListSubheader.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'primary', 'inherit']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, the List Subheader will not have gutters.
	   */
	  disableGutters: _propTypes.default.bool,
	
	  /**
	   * If `true`, the List Subheader will not stick to the top during scroll.
	   */
	  disableSticky: _propTypes.default.bool,
	
	  /**
	   * If `true`, the List Subheader will be indented.
	   */
	  inset: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListSubheader'
	})(ListSubheader);
	
	exports.default = _default;

/***/ },
/* 1210 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Menu.default;
	  }
	});
	
	var _Menu = _interopRequireDefault(__webpack_require__(589));

/***/ },
/* 1211 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(62));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _ListItem = _interopRequireDefault(__webpack_require__(304));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends3.default)({}, theme.typography.body1, (0, _defineProperty2.default)({
	      minHeight: 48,
	      paddingTop: 6,
	      paddingBottom: 6,
	      boxSizing: 'border-box',
	      width: 'auto',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    }, theme.breakpoints.up('sm'), {
	      minHeight: 'auto'
	    })),
	    // TODO v5: remove
	
	    /* Styles applied to the root element if `disableGutters={false}`. */
	    gutters: {},
	
	    /* Styles applied to the root element if `selected={true}`. */
	    selected: {},
	
	    /* Styles applied to the root element if dense. */
	    dense: (0, _extends3.default)({}, theme.typography.body2, {
	      minHeight: 'auto'
	    })
	  };
	};
	
	exports.styles = styles;
	var MenuItem = /*#__PURE__*/React.forwardRef(function MenuItem(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      component = _props$component === void 0 ? 'li' : _props$component,
	      _props$disableGutters = props.disableGutters,
	      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
	      ListItemClasses = props.ListItemClasses,
	      _props$role = props.role,
	      role = _props$role === void 0 ? 'menuitem' : _props$role,
	      selected = props.selected,
	      tabIndexProp = props.tabIndex,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "disableGutters", "ListItemClasses", "role", "selected", "tabIndex"]);
	  var tabIndex;
	
	  if (!props.disabled) {
	    tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
	  }
	
	  return /*#__PURE__*/React.createElement(_ListItem.default, (0, _extends3.default)({
	    button: true,
	    role: role,
	    tabIndex: tabIndex,
	    component: component,
	    selected: selected,
	    disableGutters: disableGutters,
	    classes: (0, _extends3.default)({
	      dense: classes.dense
	    }, ListItemClasses),
	    className: (0, _clsx.default)(classes.root, className, selected && classes.selected, !disableGutters && classes.gutters),
	    ref: ref
	  }, other));
	});
	 false ? MenuItem.propTypes = {
	  /**
	   * Menu item contents.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
	   */
	  dense: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the left and right padding is removed.
	   */
	  disableGutters: _propTypes.default.bool,
	
	  /**
	   * `classes` prop applied to the [`ListItem`](/api/list-item/) element.
	   */
	  ListItemClasses: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  role: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  selected: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes.default.number
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiMenuItem'
	})(MenuItem);
	
	exports.default = _default;

/***/ },
/* 1212 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactIs = __webpack_require__(72);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(51));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(90));
	
	var _List = _interopRequireDefault(__webpack_require__(303));
	
	var _getScrollbarSize = _interopRequireDefault(__webpack_require__(626));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(47));
	
	function nextItem(list, item, disableListWrap) {
	  if (list === item) {
	    return list.firstChild;
	  }
	
	  if (item && item.nextElementSibling) {
	    return item.nextElementSibling;
	  }
	
	  return disableListWrap ? null : list.firstChild;
	}
	
	function previousItem(list, item, disableListWrap) {
	  if (list === item) {
	    return disableListWrap ? list.firstChild : list.lastChild;
	  }
	
	  if (item && item.previousElementSibling) {
	    return item.previousElementSibling;
	  }
	
	  return disableListWrap ? null : list.lastChild;
	}
	
	function textCriteriaMatches(nextFocus, textCriteria) {
	  if (textCriteria === undefined) {
	    return true;
	  }
	
	  var text = nextFocus.innerText;
	
	  if (text === undefined) {
	    // jsdom doesn't support innerText
	    text = nextFocus.textContent;
	  }
	
	  text = text.trim().toLowerCase();
	
	  if (text.length === 0) {
	    return false;
	  }
	
	  if (textCriteria.repeating) {
	    return text[0] === textCriteria.keys[0];
	  }
	
	  return text.indexOf(textCriteria.keys.join('')) === 0;
	}
	
	function moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
	  var wrappedOnce = false;
	  var nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
	
	  while (nextFocus) {
	    // Prevent infinite loop.
	    if (nextFocus === list.firstChild) {
	      if (wrappedOnce) {
	        return;
	      }
	
	      wrappedOnce = true;
	    } // Same logic as useAutocomplete.js
	
	
	    var nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
	
	    if (!nextFocus.hasAttribute('tabindex') || !textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) {
	      // Move to the next element.
	      nextFocus = traversalFunction(list, nextFocus, disableListWrap);
	    } else {
	      nextFocus.focus();
	      return;
	    }
	  }
	}
	
	var useEnhancedEffect = typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;
	/**
	 * A permanently displayed menu following https://www.w3.org/TR/wai-aria-practices/#menubutton.
	 * It's exposed to help customization of the [`Menu`](/api/menu/) component. If you
	 * use it separately you need to move focus into the component manually. Once
	 * the focus is placed inside the component it is fully keyboard accessible.
	 */
	
	var MenuList = /*#__PURE__*/React.forwardRef(function MenuList(props, ref) {
	  var actions = props.actions,
	      _props$autoFocus = props.autoFocus,
	      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
	      _props$autoFocusItem = props.autoFocusItem,
	      autoFocusItem = _props$autoFocusItem === void 0 ? false : _props$autoFocusItem,
	      children = props.children,
	      className = props.className,
	      _props$disabledItemsF = props.disabledItemsFocusable,
	      disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF,
	      _props$disableListWra = props.disableListWrap,
	      disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra,
	      onKeyDown = props.onKeyDown,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"]);
	  var listRef = React.useRef(null);
	  var textCriteriaRef = React.useRef({
	    keys: [],
	    repeating: true,
	    previousKeyMatched: true,
	    lastTime: null
	  });
	  useEnhancedEffect(function () {
	    if (autoFocus) {
	      listRef.current.focus();
	    }
	  }, [autoFocus]);
	  React.useImperativeHandle(actions, function () {
	    return {
	      adjustStyleForScrollbar: function adjustStyleForScrollbar(containerElement, theme) {
	        // Let's ignore that piece of logic if users are already overriding the width
	        // of the menu.
	        var noExplicitWidth = !listRef.current.style.width;
	
	        if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
	          var scrollbarSize = "".concat((0, _getScrollbarSize.default)(true), "px");
	          listRef.current.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
	          listRef.current.style.width = "calc(100% + ".concat(scrollbarSize, ")");
	        }
	
	        return listRef.current;
	      }
	    };
	  }, []);
	
	  var handleKeyDown = function handleKeyDown(event) {
	    var list = listRef.current;
	    var key = event.key;
	    /**
	     * @type {Element} - will always be defined since we are in a keydown handler
	     * attached to an element. A keydown event is either dispatched to the activeElement
	     * or document.body or document.documentElement. Only the first case will
	     * trigger this specific handler.
	     */
	
	    var currentFocus = (0, _ownerDocument.default)(list).activeElement;
	
	    if (key === 'ArrowDown') {
	      // Prevent scroll of the page
	      event.preventDefault();
	      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, nextItem);
	    } else if (key === 'ArrowUp') {
	      event.preventDefault();
	      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, previousItem);
	    } else if (key === 'Home') {
	      event.preventDefault();
	      moveFocus(list, null, disableListWrap, disabledItemsFocusable, nextItem);
	    } else if (key === 'End') {
	      event.preventDefault();
	      moveFocus(list, null, disableListWrap, disabledItemsFocusable, previousItem);
	    } else if (key.length === 1) {
	      var criteria = textCriteriaRef.current;
	      var lowerKey = key.toLowerCase();
	      var currTime = performance.now();
	
	      if (criteria.keys.length > 0) {
	        // Reset
	        if (currTime - criteria.lastTime > 500) {
	          criteria.keys = [];
	          criteria.repeating = true;
	          criteria.previousKeyMatched = true;
	        } else if (criteria.repeating && lowerKey !== criteria.keys[0]) {
	          criteria.repeating = false;
	        }
	      }
	
	      criteria.lastTime = currTime;
	      criteria.keys.push(lowerKey);
	      var keepFocusOnCurrent = currentFocus && !criteria.repeating && textCriteriaMatches(currentFocus, criteria);
	
	      if (criteria.previousKeyMatched && (keepFocusOnCurrent || moveFocus(list, currentFocus, false, disabledItemsFocusable, nextItem, criteria))) {
	        event.preventDefault();
	      } else {
	        criteria.previousKeyMatched = false;
	      }
	    }
	
	    if (onKeyDown) {
	      onKeyDown(event);
	    }
	  };
	
	  var handleOwnRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    listRef.current = ReactDOM.findDOMNode(instance);
	  }, []);
	  var handleRef = (0, _useForkRef.default)(handleOwnRef, ref);
	  /**
	   * the index of the item should receive focus
	   * in a `variant="selectedMenu"` it's the first `selected` item
	   * otherwise it's the very first item.
	   */
	
	  var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
	  // to check if there is a `selected` item. We're looking for the last `selected`
	  // item and use the first valid item as a fallback
	
	  React.Children.forEach(children, function (child, index) {
	    if (! /*#__PURE__*/React.isValidElement(child)) {
	      return;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: The Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    if (!child.props.disabled) {
	      if (variant === 'selectedMenu' && child.props.selected) {
	        activeItemIndex = index;
	      } else if (activeItemIndex === -1) {
	        activeItemIndex = index;
	      }
	    }
	  });
	  var items = React.Children.map(children, function (child, index) {
	    if (index === activeItemIndex) {
	      var newChildProps = {};
	
	      if (autoFocusItem) {
	        newChildProps.autoFocus = true;
	      }
	
	      if (child.props.tabIndex === undefined && variant === 'selectedMenu') {
	        newChildProps.tabIndex = 0;
	      }
	
	      return /*#__PURE__*/React.cloneElement(child, newChildProps);
	    }
	
	    return child;
	  });
	  return /*#__PURE__*/React.createElement(_List.default, (0, _extends2.default)({
	    role: "menu",
	    ref: handleRef,
	    className: className,
	    onKeyDown: handleKeyDown,
	    tabIndex: autoFocus ? 0 : -1
	  }, other), items);
	});
	 false ? MenuList.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * If `true`, will focus the `[role="menu"]` container and move into tab order.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
	   * if `variant="selectedMenu"`.
	   */
	  autoFocusItem: _propTypes.default.bool,
	
	  /**
	   * MenuList contents, normally `MenuItem`s.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, will allow focus on disabled items.
	   */
	  disabledItemsFocusable: _propTypes.default.bool,
	
	  /**
	   * If `true`, the menu items will not wrap focus.
	   */
	  disableListWrap: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func,
	
	  /**
	   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
	   * and the vertical alignment relative to the anchor element.
	   */
	  variant: _propTypes.default.oneOf(['menu', 'selectedMenu'])
	} : void 0;
	var _default = MenuList;
	exports.default = _default;

/***/ },
/* 1213 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(115));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _Paper = _interopRequireDefault(__webpack_require__(89));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var _LinearProgress = _interopRequireDefault(__webpack_require__(302));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'flex',
	      flexDirection: 'row',
	      justifyContent: 'space-between',
	      alignItems: 'center',
	      background: theme.palette.background.default,
	      padding: 8
	    },
	
	    /* Styles applied to the root element if `position="bottom"`. */
	    positionBottom: {
	      position: 'fixed',
	      bottom: 0,
	      left: 0,
	      right: 0,
	      zIndex: theme.zIndex.mobileStepper
	    },
	
	    /* Styles applied to the root element if `position="top"`. */
	    positionTop: {
	      position: 'fixed',
	      top: 0,
	      left: 0,
	      right: 0,
	      zIndex: theme.zIndex.mobileStepper
	    },
	
	    /* Styles applied to the root element if `position="static"`. */
	    positionStatic: {},
	
	    /* Styles applied to the dots container if `variant="dots"`. */
	    dots: {
	      display: 'flex',
	      flexDirection: 'row'
	    },
	
	    /* Styles applied to each dot if `variant="dots"`. */
	    dot: {
	      backgroundColor: theme.palette.action.disabled,
	      borderRadius: '50%',
	      width: 8,
	      height: 8,
	      margin: '0 2px'
	    },
	
	    /* Styles applied to a dot if `variant="dots"` and this is the active step. */
	    dotActive: {
	      backgroundColor: theme.palette.primary.main
	    },
	
	    /* Styles applied to the Linear Progress component if `variant="progress"`. */
	    progress: {
	      width: '50%'
	    }
	  };
	};
	
	exports.styles = styles;
	var MobileStepper = /*#__PURE__*/React.forwardRef(function MobileStepper(props, ref) {
	  var _props$activeStep = props.activeStep,
	      activeStep = _props$activeStep === void 0 ? 0 : _props$activeStep,
	      backButton = props.backButton,
	      classes = props.classes,
	      className = props.className,
	      LinearProgressProps = props.LinearProgressProps,
	      nextButton = props.nextButton,
	      _props$position = props.position,
	      position = _props$position === void 0 ? 'bottom' : _props$position,
	      steps = props.steps,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'dots' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["activeStep", "backButton", "classes", "className", "LinearProgressProps", "nextButton", "position", "steps", "variant"]);
	  return /*#__PURE__*/React.createElement(_Paper.default, (0, _extends2.default)({
	    square: true,
	    elevation: 0,
	    className: (0, _clsx.default)(classes.root, classes["position".concat((0, _capitalize.default)(position))], className),
	    ref: ref
	  }, other), backButton, variant === 'text' && /*#__PURE__*/React.createElement(React.Fragment, null, activeStep + 1, " / ", steps), variant === 'dots' && /*#__PURE__*/React.createElement("div", {
	    className: classes.dots
	  }, (0, _toConsumableArray2.default)(new Array(steps)).map(function (_, index) {
	    return /*#__PURE__*/React.createElement("div", {
	      key: index,
	      className: (0, _clsx.default)(classes.dot, index === activeStep && classes.dotActive)
	    });
	  })), variant === 'progress' && /*#__PURE__*/React.createElement(_LinearProgress.default, (0, _extends2.default)({
	    className: classes.progress,
	    variant: "determinate",
	    value: Math.ceil(activeStep / (steps - 1) * 100)
	  }, LinearProgressProps)), nextButton);
	});
	 false ? MobileStepper.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Set the active step (zero based index).
	   * Defines which dot is highlighted when the variant is 'dots'.
	   */
	  activeStep: _propTypes.default.number,
	
	  /**
	   * A back button element. For instance, it can be a `Button` or an `IconButton`.
	   */
	  backButton: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Props applied to the `LinearProgress` element.
	   */
	  LinearProgressProps: _propTypes.default.object,
	
	  /**
	   * A next button element. For instance, it can be a `Button` or an `IconButton`.
	   */
	  nextButton: _propTypes.default.node,
	
	  /**
	   * Set the positioning type.
	   */
	  position: _propTypes.default.oneOf(['bottom', 'static', 'top']),
	
	  /**
	   * The total steps.
	   */
	  steps: _propTypes.default.number.isRequired,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['dots', 'progress', 'text'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiMobileStepper'
	})(MobileStepper);
	
	exports.default = _default;

/***/ },
/* 1214 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _MobileStepper.default;
	  }
	});
	
	var _MobileStepper = _interopRequireDefault(__webpack_require__(1213));

/***/ },
/* 1215 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(51));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _styles = __webpack_require__(76);
	
	var _utils = __webpack_require__(19);
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(90));
	
	var _Portal = _interopRequireDefault(__webpack_require__(402));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(194));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(47));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(117));
	
	var _zIndex = _interopRequireDefault(__webpack_require__(624));
	
	var _ModalManager = _interopRequireWildcard(__webpack_require__(592));
	
	var _Unstable_TrapFocus = _interopRequireDefault(__webpack_require__(610));
	
	var _SimpleBackdrop = _interopRequireDefault(__webpack_require__(1216));
	
	function getContainer(container) {
	  container = typeof container === 'function' ? container() : container;
	  return ReactDOM.findDOMNode(container);
	}
	
	function getHasTransition(props) {
	  return props.children ? props.children.props.hasOwnProperty('in') : false;
	} // A modal manager used to track and manage the state of open Modals.
	// Modals don't open on the server so this won't conflict with concurrent requests.
	
	
	var defaultManager = new _ModalManager.default();
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'fixed',
	      zIndex: theme.zIndex.modal,
	      right: 0,
	      bottom: 0,
	      top: 0,
	      left: 0
	    },
	
	    /* Styles applied to the root element if the `Modal` has exited. */
	    hidden: {
	      visibility: 'hidden'
	    }
	  };
	};
	/**
	 * Modal is a lower-level construct that is leveraged by the following components:
	 *
	 * - [Dialog](/api/dialog/)
	 * - [Drawer](/api/drawer/)
	 * - [Menu](/api/menu/)
	 * - [Popover](/api/popover/)
	 *
	 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
	 * rather than directly using Modal.
	 *
	 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
	 */
	
	
	exports.styles = styles;
	var Modal = /*#__PURE__*/React.forwardRef(function Modal(inProps, ref) {
	  var theme = (0, _styles.useTheme)();
	  var props = (0, _styles.getThemeProps)({
	    name: 'MuiModal',
	    props: (0, _extends2.default)({}, inProps),
	    theme: theme
	  });
	  var _props$BackdropCompon = props.BackdropComponent,
	      BackdropComponent = _props$BackdropCompon === void 0 ? _SimpleBackdrop.default : _props$BackdropCompon,
	      BackdropProps = props.BackdropProps,
	      children = props.children,
	      _props$closeAfterTran = props.closeAfterTransition,
	      closeAfterTransition = _props$closeAfterTran === void 0 ? false : _props$closeAfterTran,
	      container = props.container,
	      _props$disableAutoFoc = props.disableAutoFocus,
	      disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
	      _props$disableBackdro = props.disableBackdropClick,
	      disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
	      _props$disableEnforce = props.disableEnforceFocus,
	      disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
	      _props$disableEscapeK = props.disableEscapeKeyDown,
	      disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
	      _props$disablePortal = props.disablePortal,
	      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
	      _props$disableRestore = props.disableRestoreFocus,
	      disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
	      _props$disableScrollL = props.disableScrollLock,
	      disableScrollLock = _props$disableScrollL === void 0 ? false : _props$disableScrollL,
	      _props$hideBackdrop = props.hideBackdrop,
	      hideBackdrop = _props$hideBackdrop === void 0 ? false : _props$hideBackdrop,
	      _props$keepMounted = props.keepMounted,
	      keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
	      _props$manager = props.manager,
	      manager = _props$manager === void 0 ? defaultManager : _props$manager,
	      onBackdropClick = props.onBackdropClick,
	      onClose = props.onClose,
	      onEscapeKeyDown = props.onEscapeKeyDown,
	      onRendered = props.onRendered,
	      open = props.open,
	      other = (0, _objectWithoutProperties2.default)(props, ["BackdropComponent", "BackdropProps", "children", "closeAfterTransition", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"]);
	
	  var _React$useState = React.useState(true),
	      exited = _React$useState[0],
	      setExited = _React$useState[1];
	
	  var modal = React.useRef({});
	  var mountNodeRef = React.useRef(null);
	  var modalRef = React.useRef(null);
	  var handleRef = (0, _useForkRef.default)(modalRef, ref);
	  var hasTransition = getHasTransition(props);
	
	  var getDoc = function getDoc() {
	    return (0, _ownerDocument.default)(mountNodeRef.current);
	  };
	
	  var getModal = function getModal() {
	    modal.current.modalRef = modalRef.current;
	    modal.current.mountNode = mountNodeRef.current;
	    return modal.current;
	  };
	
	  var handleMounted = function handleMounted() {
	    manager.mount(getModal(), {
	      disableScrollLock: disableScrollLock
	    }); // Fix a bug on Chrome where the scroll isn't initially 0.
	
	    modalRef.current.scrollTop = 0;
	  };
	
	  var handleOpen = (0, _useEventCallback.default)(function () {
	    var resolvedContainer = getContainer(container) || getDoc().body;
	    manager.add(getModal(), resolvedContainer); // The element was already mounted.
	
	    if (modalRef.current) {
	      handleMounted();
	    }
	  });
	  var isTopModal = React.useCallback(function () {
	    return manager.isTopModal(getModal());
	  }, [manager]);
	  var handlePortalRef = (0, _useEventCallback.default)(function (node) {
	    mountNodeRef.current = node;
	
	    if (!node) {
	      return;
	    }
	
	    if (onRendered) {
	      onRendered();
	    }
	
	    if (open && isTopModal()) {
	      handleMounted();
	    } else {
	      (0, _ModalManager.ariaHidden)(modalRef.current, true);
	    }
	  });
	  var handleClose = React.useCallback(function () {
	    manager.remove(getModal());
	  }, [manager]);
	  React.useEffect(function () {
	    return function () {
	      handleClose();
	    };
	  }, [handleClose]);
	  React.useEffect(function () {
	    if (open) {
	      handleOpen();
	    } else if (!hasTransition || !closeAfterTransition) {
	      handleClose();
	    }
	  }, [open, handleClose, hasTransition, closeAfterTransition, handleOpen]);
	
	  if (!keepMounted && !open && (!hasTransition || exited)) {
	    return null;
	  }
	
	  var handleEnter = function handleEnter() {
	    setExited(false);
	  };
	
	  var handleExited = function handleExited() {
	    setExited(true);
	
	    if (closeAfterTransition) {
	      handleClose();
	    }
	  };
	
	  var handleBackdropClick = function handleBackdropClick(event) {
	    if (event.target !== event.currentTarget) {
	      return;
	    }
	
	    if (onBackdropClick) {
	      onBackdropClick(event);
	    }
	
	    if (!disableBackdropClick && onClose) {
	      onClose(event, 'backdropClick');
	    }
	  };
	
	  var handleKeyDown = function handleKeyDown(event) {
	    // The handler doesn't take event.defaultPrevented into account:
	    //
	    // event.preventDefault() is meant to stop default behaviours like
	    // clicking a checkbox to check it, hitting a button to submit a form,
	    // and hitting left arrow to move the cursor in a text input etc.
	    // Only special HTML elements have these default behaviors.
	    if (event.key !== 'Escape' || !isTopModal()) {
	      return;
	    }
	
	    if (onEscapeKeyDown) {
	      onEscapeKeyDown(event);
	    }
	
	    if (!disableEscapeKeyDown) {
	      // Swallow the event, in case someone is listening for the escape key on the body.
	      event.stopPropagation();
	
	      if (onClose) {
	        onClose(event, 'escapeKeyDown');
	      }
	    }
	  };
	
	  var inlineStyle = styles(theme || {
	    zIndex: _zIndex.default
	  });
	  var childProps = {};
	
	  if (children.props.tabIndex === undefined) {
	    childProps.tabIndex = children.props.tabIndex || '-1';
	  } // It's a Transition like component
	
	
	  if (hasTransition) {
	    childProps.onEnter = (0, _createChainedFunction.default)(handleEnter, children.props.onEnter);
	    childProps.onExited = (0, _createChainedFunction.default)(handleExited, children.props.onExited);
	  }
	
	  return /*#__PURE__*/React.createElement(_Portal.default, {
	    ref: handlePortalRef,
	    container: container,
	    disablePortal: disablePortal
	  }, /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    ref: handleRef,
	    onKeyDown: handleKeyDown,
	    role: "presentation"
	  }, other, {
	    style: (0, _extends2.default)({}, inlineStyle.root, !open && exited ? inlineStyle.hidden : {}, other.style)
	  }), hideBackdrop ? null : /*#__PURE__*/React.createElement(BackdropComponent, (0, _extends2.default)({
	    open: open,
	    onClick: handleBackdropClick
	  }, BackdropProps)), /*#__PURE__*/React.createElement(_Unstable_TrapFocus.default, {
	    disableEnforceFocus: disableEnforceFocus,
	    disableAutoFocus: disableAutoFocus,
	    disableRestoreFocus: disableRestoreFocus,
	    getDoc: getDoc,
	    isEnabled: isTopModal,
	    open: open
	  }, /*#__PURE__*/React.cloneElement(children, childProps))));
	});
	 false ? Modal.propTypes = {
	  /**
	   * A backdrop component. This prop enables custom backdrop rendering.
	   */
	  BackdropComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the [`Backdrop`](/api/backdrop/) element.
	   */
	  BackdropProps: _propTypes.default.object,
	
	  /**
	   * A single child content element.
	   */
	  children: _utils.elementAcceptingRef.isRequired,
	
	  /**
	   * When set to true the Modal waits until a nested Transition is completed before closing.
	   */
	  closeAfterTransition: _propTypes.default.bool,
	
	  /**
	   * A HTML element, component instance, or function that returns either.
	   * The `container` will have the portal children appended to it.
	   *
	   * By default, it uses the body of the top-level document object,
	   * so it's simply `document.body` most of the time.
	   */
	  container: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .oneOfType([_utils.HTMLElementType, _propTypes.default.instanceOf(React.Component), _propTypes.default.func]),
	
	  /**
	   * If `true`, the modal will not automatically shift focus to itself when it opens, and
	   * replace it to the last focused element when it closes.
	   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
	   *
	   * Generally this should never be set to `true` as it makes the modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableAutoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, clicking the backdrop will not fire `onClose`.
	   */
	  disableBackdropClick: _propTypes.default.bool,
	
	  /**
	   * If `true`, the modal will not prevent focus from leaving the modal while open.
	   *
	   * Generally this should never be set to `true` as it makes the modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableEnforceFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, hitting escape will not fire `onClose`.
	   */
	  disableEscapeKeyDown: _propTypes.default.bool,
	
	  /**
	   * Disable the portal behavior.
	   * The children stay within it's parent DOM hierarchy.
	   */
	  disablePortal: _propTypes.default.bool,
	
	  /**
	   * If `true`, the modal will not restore focus to previously focused element once
	   * modal is hidden.
	   */
	  disableRestoreFocus: _propTypes.default.bool,
	
	  /**
	   * Disable the scroll lock behavior.
	   */
	  disableScrollLock: _propTypes.default.bool,
	
	  /**
	   * If `true`, the backdrop is not rendered.
	   */
	  hideBackdrop: _propTypes.default.bool,
	
	  /**
	   * Always keep the children in the DOM.
	   * This prop can be useful in SEO situation or
	   * when you want to maximize the responsiveness of the Modal.
	   */
	  keepMounted: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  manager: _propTypes.default.object,
	
	  /**
	   * Callback fired when the backdrop is clicked.
	   */
	  onBackdropClick: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   * The `reason` parameter can optionally be used to control the response to `onClose`.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired when the escape key is pressed,
	   * `disableEscapeKeyDown` is false and the modal is in focus.
	   */
	  onEscapeKeyDown: _propTypes.default.func,
	
	  /**
	   * Callback fired once the children has been mounted into the `container`.
	   * It signals that the `open={true}` prop took effect.
	   *
	   * This prop will be deprecated and removed in v5, the ref can be used instead.
	   */
	  onRendered: _propTypes.default.func,
	
	  /**
	   * If `true`, the modal is open.
	   */
	  open: _propTypes.default.bool.isRequired
	} : void 0;
	var _default = Modal;
	exports.default = _default;

/***/ },
/* 1216 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    zIndex: -1,
	    position: 'fixed',
	    right: 0,
	    bottom: 0,
	    top: 0,
	    left: 0,
	    backgroundColor: 'rgba(0, 0, 0, 0.5)',
	    WebkitTapHighlightColor: 'transparent'
	  },
	
	  /* Styles applied to the root element if `invisible={true}`. */
	  invisible: {
	    backgroundColor: 'transparent'
	  }
	};
	/**
	 * @ignore - internal component.
	 */
	
	exports.styles = styles;
	var SimpleBackdrop = /*#__PURE__*/React.forwardRef(function SimpleBackdrop(props, ref) {
	  var _props$invisible = props.invisible,
	      invisible = _props$invisible === void 0 ? false : _props$invisible,
	      open = props.open,
	      other = (0, _objectWithoutProperties2.default)(props, ["invisible", "open"]);
	  return open ? /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    "aria-hidden": true,
	    ref: ref
	  }, other, {
	    style: (0, _extends2.default)({}, styles.root, invisible ? styles.invisible : {}, other.style)
	  })) : null;
	});
	 false ? SimpleBackdrop.propTypes = {
	  /**
	   * If `true`, the backdrop is invisible.
	   * It can be used when rendering a popover or a custom select component.
	   */
	  invisible: _propTypes.default.bool,
	
	  /**
	   * If `true`, the backdrop is open.
	   */
	  open: _propTypes.default.bool.isRequired
	} : void 0;
	var _default = SimpleBackdrop;
	exports.default = _default;

/***/ },
/* 1217 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _NativeSelect.default;
	  }
	});
	
	var _NativeSelect = _interopRequireDefault(__webpack_require__(593));

/***/ },
/* 1218 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(19);
	
	var useEnhancedEffect = typeof window !== 'undefined' && ("production") !== 'test' ? React.useLayoutEffect : React.useEffect;
	/**
	 * NoSsr purposely removes components from the subject of Server Side Rendering (SSR).
	 *
	 * This component can be useful in a variety of situations:
	 * - Escape hatch for broken dependencies not supporting SSR.
	 * - Improve the time-to-first paint on the client by only rendering above the fold.
	 * - Reduce the rendering time on the server.
	 * - Under too heavy server load, you can turn on service degradation.
	 */
	
	function NoSsr(props) {
	  var children = props.children,
	      _props$defer = props.defer,
	      defer = _props$defer === void 0 ? false : _props$defer,
	      _props$fallback = props.fallback,
	      fallback = _props$fallback === void 0 ? null : _props$fallback;
	
	  var _React$useState = React.useState(false),
	      mountedState = _React$useState[0],
	      setMountedState = _React$useState[1];
	
	  useEnhancedEffect(function () {
	    if (!defer) {
	      setMountedState(true);
	    }
	  }, [defer]);
	  React.useEffect(function () {
	    if (defer) {
	      setMountedState(true);
	    }
	  }, [defer]); // We need the Fragment here to force react-docgen to recognise NoSsr as a component.
	
	  return /*#__PURE__*/React.createElement(React.Fragment, null, mountedState ? children : fallback);
	}
	
	 false ? NoSsr.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * You can wrap a node.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * If `true`, the component will not only prevent server-side rendering.
	   * It will also defer the rendering of the children into a different screen frame.
	   */
	  defer: _propTypes.default.bool,
	
	  /**
	   * The fallback content to display.
	   */
	  fallback: _propTypes.default.node
	} : void 0;
	
	if (false) {
	  // eslint-disable-next-line
	  NoSsr['propTypes' + ''] = (0, _utils.exactProp)(NoSsr.propTypes);
	}
	
	var _default = NoSsr;
	exports.default = _default;

/***/ },
/* 1219 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(62));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(59));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'absolute',
	      bottom: 0,
	      right: 0,
	      top: -5,
	      left: 0,
	      margin: 0,
	      padding: '0 8px',
	      pointerEvents: 'none',
	      borderRadius: 'inherit',
	      borderStyle: 'solid',
	      borderWidth: 1,
	      overflow: 'hidden'
	    },
	
	    /* Styles applied to the legend element when `labelWidth` is provided. */
	    legend: {
	      textAlign: 'left',
	      padding: 0,
	      lineHeight: '11px',
	      // sync with `height` in `legend` styles
	      transition: theme.transitions.create('width', {
	        duration: 150,
	        easing: theme.transitions.easing.easeOut
	      })
	    },
	
	    /* Styles applied to the legend element. */
	    legendLabelled: {
	      display: 'block',
	      width: 'auto',
	      textAlign: 'left',
	      padding: 0,
	      height: 11,
	      // sync with `lineHeight` in `legend` styles
	      fontSize: '0.75em',
	      visibility: 'hidden',
	      maxWidth: 0.01,
	      transition: theme.transitions.create('max-width', {
	        duration: 50,
	        easing: theme.transitions.easing.easeOut
	      }),
	      '& > span': {
	        paddingLeft: 5,
	        paddingRight: 5,
	        display: 'inline-block'
	      }
	    },
	
	    /* Styles applied to the legend element is notched. */
	    legendNotched: {
	      maxWidth: 1000,
	      transition: theme.transitions.create('max-width', {
	        duration: 100,
	        easing: theme.transitions.easing.easeOut,
	        delay: 50
	      })
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	exports.styles = styles;
	var NotchedOutline = /*#__PURE__*/React.forwardRef(function NotchedOutline(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      label = props.label,
	      labelWidthProp = props.labelWidth,
	      notched = props.notched,
	      style = props.style,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "label", "labelWidth", "notched", "style"]);
	  var theme = (0, _useTheme.default)();
	  var align = theme.direction === 'rtl' ? 'right' : 'left';
	
	  if (label !== undefined) {
	    return /*#__PURE__*/React.createElement("fieldset", (0, _extends3.default)({
	      "aria-hidden": true,
	      className: (0, _clsx.default)(classes.root, className),
	      ref: ref,
	      style: style
	    }, other), /*#__PURE__*/React.createElement("legend", {
	      className: (0, _clsx.default)(classes.legendLabelled, notched && classes.legendNotched)
	    }, label ? /*#__PURE__*/React.createElement("span", null, label) : /*#__PURE__*/React.createElement("span", {
	      dangerouslySetInnerHTML: {
	        __html: '&#8203;'
	      }
	    })));
	  }
	
	  var labelWidth = labelWidthProp > 0 ? labelWidthProp * 0.75 + 8 : 0.01;
	  return /*#__PURE__*/React.createElement("fieldset", (0, _extends3.default)({
	    "aria-hidden": true,
	    style: (0, _extends3.default)((0, _defineProperty2.default)({}, "padding".concat((0, _capitalize.default)(align)), 8), style),
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("legend", {
	    className: classes.legend,
	    style: {
	      // IE 11: fieldset with legend does not render
	      // a border radius. This maintains consistency
	      // by always having a legend rendered
	      width: notched ? labelWidth : 0.01
	    }
	  }, /*#__PURE__*/React.createElement("span", {
	    dangerouslySetInnerHTML: {
	      __html: '&#8203;'
	    }
	  })));
	});
	 false ? NotchedOutline.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The label.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * The width of the label.
	   */
	  labelWidth: _propTypes.default.number.isRequired,
	
	  /**
	   * If `true`, the outline is notched to accommodate the label.
	   */
	  notched: _propTypes.default.bool.isRequired,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateNotchedOutline'
	})(NotchedOutline);
	
	exports.default = _default;

/***/ },
/* 1220 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _utils = __webpack_require__(19);
	
	var _InputBase = _interopRequireDefault(__webpack_require__(237));
	
	var _NotchedOutline = _interopRequireDefault(__webpack_require__(1219));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var styles = function styles(theme) {
	  var borderColor = theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      borderRadius: theme.shape.borderRadius,
	      '&:hover $notchedOutline': {
	        borderColor: theme.palette.text.primary
	      },
	      // Reset on touch devices, it doesn't add specificity
	      '@media (hover: none)': {
	        '&:hover $notchedOutline': {
	          borderColor: borderColor
	        }
	      },
	      '&$focused $notchedOutline': {
	        borderColor: theme.palette.primary.main,
	        borderWidth: 2
	      },
	      '&$error $notchedOutline': {
	        borderColor: theme.palette.error.main
	      },
	      '&$disabled $notchedOutline': {
	        borderColor: theme.palette.action.disabled
	      }
	    },
	
	    /* Styles applied to the root element if the color is secondary. */
	    colorSecondary: {
	      '&$focused $notchedOutline': {
	        borderColor: theme.palette.secondary.main
	      }
	    },
	
	    /* Styles applied to the root element if the component is focused. */
	    focused: {},
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `startAdornment` is provided. */
	    adornedStart: {
	      paddingLeft: 14
	    },
	
	    /* Styles applied to the root element if `endAdornment` is provided. */
	    adornedEnd: {
	      paddingRight: 14
	    },
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    marginDense: {},
	
	    /* Styles applied to the root element if `multiline={true}`. */
	    multiline: {
	      padding: '18.5px 14px',
	      '&$marginDense': {
	        paddingTop: 10.5,
	        paddingBottom: 10.5
	      }
	    },
	
	    /* Styles applied to the `NotchedOutline` element. */
	    notchedOutline: {
	      borderColor: borderColor
	    },
	
	    /* Styles applied to the `input` element. */
	    input: {
	      padding: '18.5px 14px',
	      '&:-webkit-autofill': {
	        WebkitBoxShadow: theme.palette.type === 'light' ? null : '0 0 0 100px #266798 inset',
	        WebkitTextFillColor: theme.palette.type === 'light' ? null : '#fff',
	        caretColor: theme.palette.type === 'light' ? null : '#fff',
	        borderRadius: 'inherit'
	      }
	    },
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    inputMarginDense: {
	      paddingTop: 10.5,
	      paddingBottom: 10.5
	    },
	
	    /* Styles applied to the `input` element if `multiline={true}`. */
	    inputMultiline: {
	      padding: 0
	    },
	
	    /* Styles applied to the `input` element if `startAdornment` is provided. */
	    inputAdornedStart: {
	      paddingLeft: 0
	    },
	
	    /* Styles applied to the `input` element if `endAdornment` is provided. */
	    inputAdornedEnd: {
	      paddingRight: 0
	    }
	  };
	};
	
	exports.styles = styles;
	var OutlinedInput = /*#__PURE__*/React.forwardRef(function OutlinedInput(props, ref) {
	  var classes = props.classes,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$inputComponent = props.inputComponent,
	      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
	      label = props.label,
	      _props$labelWidth = props.labelWidth,
	      labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth,
	      _props$multiline = props.multiline,
	      multiline = _props$multiline === void 0 ? false : _props$multiline,
	      notched = props.notched,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'text' : _props$type,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "fullWidth", "inputComponent", "label", "labelWidth", "multiline", "notched", "type"]);
	  return /*#__PURE__*/React.createElement(_InputBase.default, (0, _extends2.default)({
	    renderSuffix: function renderSuffix(state) {
	      return /*#__PURE__*/React.createElement(_NotchedOutline.default, {
	        className: classes.notchedOutline,
	        label: label,
	        labelWidth: labelWidth,
	        notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
	      });
	    },
	    classes: (0, _extends2.default)({}, classes, {
	      root: (0, _clsx.default)(classes.root, classes.underline),
	      notchedOutline: null
	    }),
	    fullWidth: fullWidth,
	    inputComponent: inputComponent,
	    multiline: multiline,
	    ref: ref,
	    type: type
	  }, other));
	});
	 false ? OutlinedInput.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * This prop helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
	   */
	  autoComplete: _propTypes.default.string,
	
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The default `input` element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the `input` element will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * End `InputAdornment` for this component.
	   */
	  endAdornment: _propTypes.default.node,
	
	  /**
	   * If `true`, the input will indicate an error. This is normally obtained via context from
	   * FormControl.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * The component used for the `input` element.
	   * Either a string to use a HTML element or a component.
	   */
	  inputComponent: _propTypes.default.elementType,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * The label of the input. It is only used for layout. The actual labelling
	   * is handled by `InputLabel`. If specified `labelWidth` is ignored.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * The width of the label. Is ignored if `label` is provided. Prefer `label`
	   * if the input label appears with a strike through.
	   */
	  labelWidth: _propTypes.default.number,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense', 'none']),
	
	  /**
	   * If `true`, a textarea element will be rendered.
	   */
	  multiline: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * If `true`, the outline is notched to accommodate the label.
	   */
	  notched: _propTypes.default.bool,
	
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * It prevents the user from changing the value of the field
	   * (not from interacting with the field).
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Start `InputAdornment` for this component.
	   */
	  startAdornment: _propTypes.default.node,
	
	  /**
	   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the `input` element, required for a controlled component.
	   */
	  value: _propTypes.default.any
	} : void 0;
	OutlinedInput.muiName = 'Input';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiOutlinedInput'
	})(OutlinedInput);
	
	exports.default = _default;

/***/ },
/* 1221 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _utils = __webpack_require__(19);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var styles = function styles(theme) {
	  var elevations = {};
	  theme.shadows.forEach(function (shadow, index) {
	    elevations["elevation".concat(index)] = {
	      boxShadow: shadow
	    };
	  });
	  return (0, _extends2.default)({
	    /* Styles applied to the root element. */
	    root: {
	      backgroundColor: theme.palette.background.paper,
	      color: theme.palette.text.primary,
	      transition: theme.transitions.create('box-shadow')
	    },
	
	    /* Styles applied to the root element if `square={false}`. */
	    rounded: {
	      borderRadius: theme.shape.borderRadius
	    },
	
	    /* Styles applied to the root element if `variant="outlined"`. */
	    outlined: {
	      border: "1px solid ".concat(theme.palette.divider)
	    }
	  }, elevations);
	};
	
	exports.styles = styles;
	var Paper = /*#__PURE__*/React.forwardRef(function Paper(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$square = props.square,
	      square = _props$square === void 0 ? false : _props$square,
	      _props$elevation = props.elevation,
	      elevation = _props$elevation === void 0 ? 1 : _props$elevation,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'elevation' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "square", "elevation", "variant"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, variant === 'outlined' ? classes.outlined : classes["elevation".concat(elevation)], !square && classes.rounded),
	    ref: ref
	  }, other));
	});
	 false ? Paper.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * Shadow depth, corresponds to `dp` in the spec.
	   * It accepts values between 0 and 24 inclusive.
	   */
	  elevation: (0, _utils.chainPropTypes)(_propTypes.default.number, function (props) {
	    var classes = props.classes,
	        elevation = props.elevation; // in case `withStyles` fails to inject we don't need this warning
	
	    if (classes === undefined) {
	      return null;
	    }
	
	    if (elevation != null && classes["elevation".concat(elevation)] === undefined) {
	      return new Error("Material-UI: This elevation `".concat(elevation, "` is not implemented."));
	    }
	
	    return null;
	  }),
	
	  /**
	   * If `true`, rounded corners are disabled.
	   */
	  square: _propTypes.default.bool,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['elevation', 'outlined'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiPaper'
	})(Paper);
	
	exports.default = _default;

/***/ },
/* 1222 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getOffsetTop = getOffsetTop;
	exports.getOffsetLeft = getOffsetLeft;
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(51));
	
	var _utils = __webpack_require__(19);
	
	var _debounce = _interopRequireDefault(__webpack_require__(156));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(90));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(309));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(194));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _Modal = _interopRequireDefault(__webpack_require__(307));
	
	var _Grow = _interopRequireDefault(__webpack_require__(299));
	
	var _Paper = _interopRequireDefault(__webpack_require__(89));
	
	function getOffsetTop(rect, vertical) {
	  var offset = 0;
	
	  if (typeof vertical === 'number') {
	    offset = vertical;
	  } else if (vertical === 'center') {
	    offset = rect.height / 2;
	  } else if (vertical === 'bottom') {
	    offset = rect.height;
	  }
	
	  return offset;
	}
	
	function getOffsetLeft(rect, horizontal) {
	  var offset = 0;
	
	  if (typeof horizontal === 'number') {
	    offset = horizontal;
	  } else if (horizontal === 'center') {
	    offset = rect.width / 2;
	  } else if (horizontal === 'right') {
	    offset = rect.width;
	  }
	
	  return offset;
	}
	
	function getTransformOriginValue(transformOrigin) {
	  return [transformOrigin.horizontal, transformOrigin.vertical].map(function (n) {
	    return typeof n === 'number' ? "".concat(n, "px") : n;
	  }).join(' ');
	} // Sum the scrollTop between two elements.
	
	
	function getScrollParent(parent, child) {
	  var element = child;
	  var scrollTop = 0;
	
	  while (element && element !== parent) {
	    element = element.parentElement;
	    scrollTop += element.scrollTop;
	  }
	
	  return scrollTop;
	}
	
	function getAnchorEl(anchorEl) {
	  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
	}
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {},
	
	  /* Styles applied to the `Paper` component. */
	  paper: {
	    position: 'absolute',
	    overflowY: 'auto',
	    overflowX: 'hidden',
	    // So we see the popover when it's empty.
	    // It's most likely on issue on userland.
	    minWidth: 16,
	    minHeight: 16,
	    maxWidth: 'calc(100% - 32px)',
	    maxHeight: 'calc(100% - 32px)',
	    // We disable the focus ring for mouse, touch and keyboard users.
	    outline: 0
	  }
	};
	exports.styles = styles;
	var Popover = /*#__PURE__*/React.forwardRef(function Popover(props, ref) {
	  var action = props.action,
	      anchorEl = props.anchorEl,
	      _props$anchorOrigin = props.anchorOrigin,
	      anchorOrigin = _props$anchorOrigin === void 0 ? {
	    vertical: 'top',
	    horizontal: 'left'
	  } : _props$anchorOrigin,
	      anchorPosition = props.anchorPosition,
	      _props$anchorReferenc = props.anchorReference,
	      anchorReference = _props$anchorReferenc === void 0 ? 'anchorEl' : _props$anchorReferenc,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      containerProp = props.container,
	      _props$elevation = props.elevation,
	      elevation = _props$elevation === void 0 ? 8 : _props$elevation,
	      getContentAnchorEl = props.getContentAnchorEl,
	      _props$marginThreshol = props.marginThreshold,
	      marginThreshold = _props$marginThreshol === void 0 ? 16 : _props$marginThreshol,
	      onEnter = props.onEnter,
	      onEntered = props.onEntered,
	      onEntering = props.onEntering,
	      onExit = props.onExit,
	      onExited = props.onExited,
	      onExiting = props.onExiting,
	      open = props.open,
	      _props$PaperProps = props.PaperProps,
	      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
	      _props$transformOrigi = props.transformOrigin,
	      transformOrigin = _props$transformOrigi === void 0 ? {
	    vertical: 'top',
	    horizontal: 'left'
	  } : _props$transformOrigi,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Grow.default : _props$TransitionComp,
	      _props$transitionDura = props.transitionDuration,
	      transitionDurationProp = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
	      _props$TransitionProp = props.TransitionProps,
	      TransitionProps = _props$TransitionProp === void 0 ? {} : _props$TransitionProp,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "classes", "className", "container", "elevation", "getContentAnchorEl", "marginThreshold", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "open", "PaperProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"]);
	  var paperRef = React.useRef(); // Returns the top/left offset of the position
	  // to attach to on the anchor element (or body if none is provided)
	
	  var getAnchorOffset = React.useCallback(function (contentAnchorOffset) {
	    if (anchorReference === 'anchorPosition') {
	      if (false) {
	        if (!anchorPosition) {
	          console.error('Material-UI: You need to provide a `anchorPosition` prop when using ' + '<Popover anchorReference="anchorPosition" />.');
	        }
	      }
	
	      return anchorPosition;
	    }
	
	    var resolvedAnchorEl = getAnchorEl(anchorEl); // If an anchor element wasn't provided, just use the parent body element of this Popover
	
	    var anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, _ownerDocument.default)(paperRef.current).body;
	    var anchorRect = anchorElement.getBoundingClientRect();
	
	    if (false) {
	      var box = anchorElement.getBoundingClientRect();
	
	      if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
	        console.warn(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
	      }
	    }
	
	    var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : 'center';
	    return {
	      top: anchorRect.top + getOffsetTop(anchorRect, anchorVertical),
	      left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal)
	    };
	  }, [anchorEl, anchorOrigin.horizontal, anchorOrigin.vertical, anchorPosition, anchorReference]); // Returns the vertical offset of inner content to anchor the transform on if provided
	
	  var getContentAnchorOffset = React.useCallback(function (element) {
	    var contentAnchorOffset = 0;
	
	    if (getContentAnchorEl && anchorReference === 'anchorEl') {
	      var contentAnchorEl = getContentAnchorEl(element);
	
	      if (contentAnchorEl && element.contains(contentAnchorEl)) {
	        var scrollTop = getScrollParent(element, contentAnchorEl);
	        contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
	      } // != the default value
	
	
	      if (false) {
	        if (anchorOrigin.vertical !== 'top') {
	          console.error(['Material-UI: You can not change the default `anchorOrigin.vertical` value ', 'when also providing the `getContentAnchorEl` prop to the popover component.', 'Only use one of the two props.', 'Set `getContentAnchorEl` to `null | undefined`' + ' or leave `anchorOrigin.vertical` unchanged.'].join('\n'));
	        }
	      }
	    }
	
	    return contentAnchorOffset;
	  }, [anchorOrigin.vertical, anchorReference, getContentAnchorEl]); // Return the base transform origin using the element
	  // and taking the content anchor offset into account if in use
	
	  var getTransformOrigin = React.useCallback(function (elemRect) {
	    var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    return {
	      vertical: getOffsetTop(elemRect, transformOrigin.vertical) + contentAnchorOffset,
	      horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal)
	    };
	  }, [transformOrigin.horizontal, transformOrigin.vertical]);
	  var getPositioningStyle = React.useCallback(function (element) {
	    // Check if the parent has requested anchoring on an inner content node
	    var contentAnchorOffset = getContentAnchorOffset(element);
	    var elemRect = {
	      width: element.offsetWidth,
	      height: element.offsetHeight
	    }; // Get the transform origin point on the element itself
	
	    var elemTransformOrigin = getTransformOrigin(elemRect, contentAnchorOffset);
	
	    if (anchorReference === 'none') {
	      return {
	        top: null,
	        left: null,
	        transformOrigin: getTransformOriginValue(elemTransformOrigin)
	      };
	    } // Get the offset of of the anchoring element
	
	
	    var anchorOffset = getAnchorOffset(contentAnchorOffset); // Calculate element positioning
	
	    var top = anchorOffset.top - elemTransformOrigin.vertical;
	    var left = anchorOffset.left - elemTransformOrigin.horizontal;
	    var bottom = top + elemRect.height;
	    var right = left + elemRect.width; // Use the parent window of the anchorEl if provided
	
	    var containerWindow = (0, _ownerWindow.default)(getAnchorEl(anchorEl)); // Window thresholds taking required margin into account
	
	    var heightThreshold = containerWindow.innerHeight - marginThreshold;
	    var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting
	
	    if (top < marginThreshold) {
	      var diff = top - marginThreshold;
	      top -= diff;
	      elemTransformOrigin.vertical += diff;
	    } else if (bottom > heightThreshold) {
	      var _diff = bottom - heightThreshold;
	
	      top -= _diff;
	      elemTransformOrigin.vertical += _diff;
	    }
	
	    if (false) {
	      if (elemRect.height > heightThreshold && elemRect.height && heightThreshold) {
	        console.error(['Material-UI: The popover component is too tall.', "Some part of it can not be seen on the screen (".concat(elemRect.height - heightThreshold, "px)."), 'Please consider adding a `max-height` to improve the user-experience.'].join('\n'));
	      }
	    } // Check if the horizontal axis needs shifting
	
	
	    if (left < marginThreshold) {
	      var _diff2 = left - marginThreshold;
	
	      left -= _diff2;
	      elemTransformOrigin.horizontal += _diff2;
	    } else if (right > widthThreshold) {
	      var _diff3 = right - widthThreshold;
	
	      left -= _diff3;
	      elemTransformOrigin.horizontal += _diff3;
	    }
	
	    return {
	      top: "".concat(Math.round(top), "px"),
	      left: "".concat(Math.round(left), "px"),
	      transformOrigin: getTransformOriginValue(elemTransformOrigin)
	    };
	  }, [anchorEl, anchorReference, getAnchorOffset, getContentAnchorOffset, getTransformOrigin, marginThreshold]);
	  var setPositioningStyles = React.useCallback(function () {
	    var element = paperRef.current;
	
	    if (!element) {
	      return;
	    }
	
	    var positioning = getPositioningStyle(element);
	
	    if (positioning.top !== null) {
	      element.style.top = positioning.top;
	    }
	
	    if (positioning.left !== null) {
	      element.style.left = positioning.left;
	    }
	
	    element.style.transformOrigin = positioning.transformOrigin;
	  }, [getPositioningStyle]);
	
	  var handleEntering = function handleEntering(element, isAppearing) {
	    if (onEntering) {
	      onEntering(element, isAppearing);
	    }
	
	    setPositioningStyles();
	  };
	
	  var handlePaperRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    paperRef.current = ReactDOM.findDOMNode(instance);
	  }, []);
	  React.useEffect(function () {
	    if (open) {
	      setPositioningStyles();
	    }
	  });
	  React.useImperativeHandle(action, function () {
	    return open ? {
	      updatePosition: function updatePosition() {
	        setPositioningStyles();
	      }
	    } : null;
	  }, [open, setPositioningStyles]);
	  React.useEffect(function () {
	    if (!open) {
	      return undefined;
	    }
	
	    var handleResize = (0, _debounce.default)(function () {
	      setPositioningStyles();
	    });
	    window.addEventListener('resize', handleResize);
	    return function () {
	      handleResize.clear();
	      window.removeEventListener('resize', handleResize);
	    };
	  }, [open, setPositioningStyles]);
	  var transitionDuration = transitionDurationProp;
	
	  if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
	    transitionDuration = undefined;
	  } // If the container prop is provided, use that
	  // If the anchorEl prop is provided, use its parent body element as the container
	  // If neither are provided let the Modal take care of choosing the container
	
	
	  var container = containerProp || (anchorEl ? (0, _ownerDocument.default)(getAnchorEl(anchorEl)).body : undefined);
	  return /*#__PURE__*/React.createElement(_Modal.default, (0, _extends2.default)({
	    container: container,
	    open: open,
	    ref: ref,
	    BackdropProps: {
	      invisible: true
	    },
	    className: (0, _clsx.default)(classes.root, className)
	  }, other), /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    appear: true,
	    in: open,
	    onEnter: onEnter,
	    onEntered: onEntered,
	    onExit: onExit,
	    onExited: onExited,
	    onExiting: onExiting,
	    timeout: transitionDuration
	  }, TransitionProps, {
	    onEntering: (0, _createChainedFunction.default)(handleEntering, TransitionProps.onEntering)
	  }), /*#__PURE__*/React.createElement(_Paper.default, (0, _extends2.default)({
	    elevation: elevation,
	    ref: handlePaperRef
	  }, PaperProps, {
	    className: (0, _clsx.default)(classes.paper, PaperProps.className)
	  }), children)));
	});
	 false ? Popover.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A ref for imperative actions.
	   * It currently only supports updatePosition() action.
	   */
	  action: _utils.refType,
	
	  /**
	   * A HTML element, or a function that returns it.
	   * It's used to set the position of the popover.
	   */
	  anchorEl: (0, _utils.chainPropTypes)(_propTypes.default.oneOfType([_utils.HTMLElementType, _propTypes.default.func]), function (props) {
	    if (props.open && (!props.anchorReference || props.anchorReference === 'anchorEl')) {
	      var resolvedAnchorEl = getAnchorEl(props.anchorEl);
	
	      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
	        var box = resolvedAnchorEl.getBoundingClientRect();
	
	        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
	          return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
	        }
	      } else {
	        return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', "It should be an Element instance but it's `".concat(resolvedAnchorEl, "` instead.")].join('\n'));
	      }
	    }
	
	    return null;
	  }),
	
	  /**
	   * This is the point on the anchor where the popover's
	   * `anchorEl` will attach to. This is not used when the
	   * anchorReference is 'anchorPosition'.
	   *
	   * Options:
	   * vertical: [top, center, bottom];
	   * horizontal: [left, center, right].
	   */
	  anchorOrigin: _propTypes.default.shape({
	    horizontal: _propTypes.default.oneOfType([_propTypes.default.oneOf(['center', 'left', 'right']), _propTypes.default.number]).isRequired,
	    vertical: _propTypes.default.oneOfType([_propTypes.default.oneOf(['bottom', 'center', 'top']), _propTypes.default.number]).isRequired
	  }),
	
	  /**
	   * This is the position that may be used
	   * to set the position of the popover.
	   * The coordinates are relative to
	   * the application's client area.
	   */
	  anchorPosition: _propTypes.default.shape({
	    left: _propTypes.default.number.isRequired,
	    top: _propTypes.default.number.isRequired
	  }),
	
	  /**
	   * This determines which anchor prop to refer to to set
	   * the position of the popover.
	   */
	  anchorReference: _propTypes.default.oneOf(['anchorEl', 'anchorPosition', 'none']),
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * A HTML element, component instance, or function that returns either.
	   * The `container` will passed to the Modal component.
	   *
	   * By default, it uses the body of the anchorEl's top-level document object,
	   * so it's simply `document.body` most of the time.
	   */
	  container: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .oneOfType([_utils.HTMLElementType, _propTypes.default.instanceOf(React.Component), _propTypes.default.func]),
	
	  /**
	   * The elevation of the popover.
	   */
	  elevation: _propTypes.default.number,
	
	  /**
	   * This function is called in order to retrieve the content anchor element.
	   * It's the opposite of the `anchorEl` prop.
	   * The content anchor element should be an element inside the popover.
	   * It's used to correctly scroll and set the position of the popover.
	   * The positioning strategy tries to make the content anchor element just above the
	   * anchor element.
	   */
	  getContentAnchorEl: _propTypes.default.func,
	
	  /**
	   * Specifies how close to the edge of the window the popover can appear.
	   */
	  marginThreshold: _propTypes.default.number,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired before the component is entering.
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component has entered.
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component is entering.
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired before the component is exiting.
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component has exited.
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component is exiting.
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * If `true`, the popover is visible.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * Props applied to the [`Paper`](/api/paper/) element.
	   */
	  PaperProps: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .shape({
	    component: _utils.elementTypeAcceptingRef
	  }),
	
	  /**
	   * This is the point on the popover which
	   * will attach to the anchor's origin.
	   *
	   * Options:
	   * vertical: [top, center, bottom, x(px)];
	   * horizontal: [left, center, right, x(px)].
	   */
	  transformOrigin: _propTypes.default.shape({
	    horizontal: _propTypes.default.oneOfType([_propTypes.default.oneOf(['center', 'left', 'right']), _propTypes.default.number]).isRequired,
	    vertical: _propTypes.default.oneOfType([_propTypes.default.oneOf(['bottom', 'center', 'top']), _propTypes.default.number]).isRequired
	  }),
	
	  /**
	   * The component used for the transition.
	   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
	   */
	  TransitionComponent: _propTypes.default.elementType,
	
	  /**
	   * Set to 'auto' to automatically calculate transition time based on height.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.oneOf(['auto']), _propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
	   */
	  TransitionProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiPopover'
	})(Popover);
	
	exports.default = _default;

/***/ },
/* 1223 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _popper = _interopRequireDefault(__webpack_require__(1924));
	
	var _utils = __webpack_require__(19);
	
	var _styles = __webpack_require__(76);
	
	var _Portal = _interopRequireDefault(__webpack_require__(402));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(194));
	
	var _setRef = _interopRequireDefault(__webpack_require__(157));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(47));
	
	function flipPlacement(placement, theme) {
	  var direction = theme && theme.direction || 'ltr';
	
	  if (direction === 'ltr') {
	    return placement;
	  }
	
	  switch (placement) {
	    case 'bottom-end':
	      return 'bottom-start';
	
	    case 'bottom-start':
	      return 'bottom-end';
	
	    case 'top-end':
	      return 'top-start';
	
	    case 'top-start':
	      return 'top-end';
	
	    default:
	      return placement;
	  }
	}
	
	function getAnchorEl(anchorEl) {
	  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
	}
	
	var useEnhancedEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
	var defaultPopperOptions = {};
	/**
	 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v1/) for positioning.
	 */
	
	var Popper = /*#__PURE__*/React.forwardRef(function Popper(props, ref) {
	  var anchorEl = props.anchorEl,
	      children = props.children,
	      container = props.container,
	      _props$disablePortal = props.disablePortal,
	      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
	      _props$keepMounted = props.keepMounted,
	      keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
	      modifiers = props.modifiers,
	      open = props.open,
	      _props$placement = props.placement,
	      initialPlacement = _props$placement === void 0 ? 'bottom' : _props$placement,
	      _props$popperOptions = props.popperOptions,
	      popperOptions = _props$popperOptions === void 0 ? defaultPopperOptions : _props$popperOptions,
	      popperRefProp = props.popperRef,
	      style = props.style,
	      _props$transition = props.transition,
	      transition = _props$transition === void 0 ? false : _props$transition,
	      other = (0, _objectWithoutProperties2.default)(props, ["anchorEl", "children", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition"]);
	  var tooltipRef = React.useRef(null);
	  var ownRef = (0, _useForkRef.default)(tooltipRef, ref);
	  var popperRef = React.useRef(null);
	  var handlePopperRef = (0, _useForkRef.default)(popperRef, popperRefProp);
	  var handlePopperRefRef = React.useRef(handlePopperRef);
	  useEnhancedEffect(function () {
	    handlePopperRefRef.current = handlePopperRef;
	  }, [handlePopperRef]);
	  React.useImperativeHandle(popperRefProp, function () {
	    return popperRef.current;
	  }, []);
	
	  var _React$useState = React.useState(true),
	      exited = _React$useState[0],
	      setExited = _React$useState[1];
	
	  var theme = (0, _styles.useTheme)();
	  var rtlPlacement = flipPlacement(initialPlacement, theme);
	  /**
	   * placement initialized from prop but can change during lifetime if modifiers.flip.
	   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
	   */
	
	  var _React$useState2 = React.useState(rtlPlacement),
	      placement = _React$useState2[0],
	      setPlacement = _React$useState2[1];
	
	  React.useEffect(function () {
	    if (popperRef.current) {
	      popperRef.current.update();
	    }
	  });
	  var handleOpen = React.useCallback(function () {
	    if (!tooltipRef.current || !anchorEl || !open) {
	      return;
	    }
	
	    if (popperRef.current) {
	      popperRef.current.destroy();
	      handlePopperRefRef.current(null);
	    }
	
	    var handlePopperUpdate = function handlePopperUpdate(data) {
	      setPlacement(data.placement);
	    };
	
	    var resolvedAnchorEl = getAnchorEl(anchorEl);
	
	    if (false) {
	      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
	        var box = resolvedAnchorEl.getBoundingClientRect();
	
	        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
	          console.warn(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
	        }
	      }
	    }
	
	    var popper = new _popper.default(getAnchorEl(anchorEl), tooltipRef.current, (0, _extends2.default)({
	      placement: rtlPlacement
	    }, popperOptions, {
	      modifiers: (0, _extends2.default)({}, disablePortal ? {} : {
	        // It's using scrollParent by default, we can use the viewport when using a portal.
	        preventOverflow: {
	          boundariesElement: 'window'
	        }
	      }, modifiers, popperOptions.modifiers),
	      // We could have been using a custom modifier like react-popper is doing.
	      // But it seems this is the best public API for this use case.
	      onCreate: (0, _createChainedFunction.default)(handlePopperUpdate, popperOptions.onCreate),
	      onUpdate: (0, _createChainedFunction.default)(handlePopperUpdate, popperOptions.onUpdate)
	    }));
	    handlePopperRefRef.current(popper);
	  }, [anchorEl, disablePortal, modifiers, open, rtlPlacement, popperOptions]);
	  var handleRef = React.useCallback(function (node) {
	    (0, _setRef.default)(ownRef, node);
	    handleOpen();
	  }, [ownRef, handleOpen]);
	
	  var handleEnter = function handleEnter() {
	    setExited(false);
	  };
	
	  var handleClose = function handleClose() {
	    if (!popperRef.current) {
	      return;
	    }
	
	    popperRef.current.destroy();
	    handlePopperRefRef.current(null);
	  };
	
	  var handleExited = function handleExited() {
	    setExited(true);
	    handleClose();
	  };
	
	  React.useEffect(function () {
	    return function () {
	      handleClose();
	    };
	  }, []);
	  React.useEffect(function () {
	    if (!open && !transition) {
	      // Otherwise handleExited will call this.
	      handleClose();
	    }
	  }, [open, transition]);
	
	  if (!keepMounted && !open && (!transition || exited)) {
	    return null;
	  }
	
	  var childProps = {
	    placement: placement
	  };
	
	  if (transition) {
	    childProps.TransitionProps = {
	      in: open,
	      onEnter: handleEnter,
	      onExited: handleExited
	    };
	  }
	
	  return /*#__PURE__*/React.createElement(_Portal.default, {
	    disablePortal: disablePortal,
	    container: container
	  }, /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    ref: handleRef,
	    role: "tooltip"
	  }, other, {
	    style: (0, _extends2.default)({
	      // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
	      position: 'fixed',
	      // Fix Popper.js display issue
	      top: 0,
	      left: 0,
	      display: !open && keepMounted && !transition ? 'none' : null
	    }, style)
	  }), typeof children === 'function' ? children(childProps) : children));
	});
	 false ? Popper.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A HTML element, [referenceObject](https://popper.js.org/docs/v1/#referenceObject),
	   * or a function that returns either.
	   * It's used to set the position of the popper.
	   * The return value will passed as the reference object of the Popper instance.
	   */
	  anchorEl: (0, _utils.chainPropTypes)(_propTypes.default.oneOfType([_utils.HTMLElementType, _propTypes.default.object, _propTypes.default.func]), function (props) {
	    if (props.open) {
	      var resolvedAnchorEl = getAnchorEl(props.anchorEl);
	
	      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
	        var box = resolvedAnchorEl.getBoundingClientRect();
	
	        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
	          return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
	        }
	      } else if (!resolvedAnchorEl || typeof resolvedAnchorEl.clientWidth !== 'number' || typeof resolvedAnchorEl.clientHeight !== 'number' || typeof resolvedAnchorEl.getBoundingClientRect !== 'function') {
	        return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'It should be an HTML element instance or a referenceObject ', '(https://popper.js.org/docs/v1/#referenceObject).'].join('\n'));
	      }
	    }
	
	    return null;
	  }),
	
	  /**
	   * Popper render function or node.
	   */
	  children: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .oneOfType([_propTypes.default.node, _propTypes.default.func]).isRequired,
	
	  /**
	   * A HTML element, component instance, or function that returns either.
	   * The `container` will have the portal children appended to it.
	   *
	   * By default, it uses the body of the top-level document object,
	   * so it's simply `document.body` most of the time.
	   */
	  container: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .oneOfType([_utils.HTMLElementType, _propTypes.default.instanceOf(React.Component), _propTypes.default.func]),
	
	  /**
	   * Disable the portal behavior.
	   * The children stay within it's parent DOM hierarchy.
	   */
	  disablePortal: _propTypes.default.bool,
	
	  /**
	   * Always keep the children in the DOM.
	   * This prop can be useful in SEO situation or
	   * when you want to maximize the responsiveness of the Popper.
	   */
	  keepMounted: _propTypes.default.bool,
	
	  /**
	   * Popper.js is based on a "plugin-like" architecture,
	   * most of its features are fully encapsulated "modifiers".
	   *
	   * A modifier is a function that is called each time Popper.js needs to
	   * compute the position of the popper.
	   * For this reason, modifiers should be very performant to avoid bottlenecks.
	   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v1/#modifiers).
	   */
	  modifiers: _propTypes.default.object,
	
	  /**
	   * If `true`, the popper is visible.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * Popper placement.
	   */
	  placement: _propTypes.default.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
	
	  /**
	   * Options provided to the [`popper.js`](https://popper.js.org/docs/v1/) instance.
	   */
	  popperOptions: _propTypes.default.object,
	
	  /**
	   * A ref that points to the used popper instance.
	   */
	  popperRef: _utils.refType,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * Help supporting a react-transition-group/Transition component.
	   */
	  transition: _propTypes.default.bool
	} : void 0;
	var _default = Popper;
	exports.default = _default;

/***/ },
/* 1224 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(51));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(19);
	
	var _setRef = _interopRequireDefault(__webpack_require__(157));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(47));
	
	function getContainer(container) {
	  container = typeof container === 'function' ? container() : container; // #StrictMode ready
	
	  return ReactDOM.findDOMNode(container);
	}
	
	var useEnhancedEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
	/**
	 * Portals provide a first-class way to render children into a DOM node
	 * that exists outside the DOM hierarchy of the parent component.
	 */
	
	var Portal = /*#__PURE__*/React.forwardRef(function Portal(props, ref) {
	  var children = props.children,
	      container = props.container,
	      _props$disablePortal = props.disablePortal,
	      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
	      onRendered = props.onRendered;
	
	  var _React$useState = React.useState(null),
	      mountNode = _React$useState[0],
	      setMountNode = _React$useState[1];
	
	  var handleRef = (0, _useForkRef.default)( /*#__PURE__*/React.isValidElement(children) ? children.ref : null, ref);
	  useEnhancedEffect(function () {
	    if (!disablePortal) {
	      setMountNode(getContainer(container) || document.body);
	    }
	  }, [container, disablePortal]);
	  useEnhancedEffect(function () {
	    if (mountNode && !disablePortal) {
	      (0, _setRef.default)(ref, mountNode);
	      return function () {
	        (0, _setRef.default)(ref, null);
	      };
	    }
	
	    return undefined;
	  }, [ref, mountNode, disablePortal]);
	  useEnhancedEffect(function () {
	    if (onRendered && (mountNode || disablePortal)) {
	      onRendered();
	    }
	  }, [onRendered, mountNode, disablePortal]);
	
	  if (disablePortal) {
	    if ( /*#__PURE__*/React.isValidElement(children)) {
	      return /*#__PURE__*/React.cloneElement(children, {
	        ref: handleRef
	      });
	    }
	
	    return children;
	  }
	
	  return mountNode ? /*#__PURE__*/ReactDOM.createPortal(children, mountNode) : mountNode;
	});
	 false ? Portal.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The children to render into the `container`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A HTML element, component instance, or function that returns either.
	   * The `container` will have the portal children appended to it.
	   *
	   * By default, it uses the body of the top-level document object,
	   * so it's simply `document.body` most of the time.
	   */
	  container: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .oneOfType([_utils.HTMLElementType, _propTypes.default.instanceOf(React.Component), _propTypes.default.func]),
	
	  /**
	   * Disable the portal behavior.
	   * The children stay within it's parent DOM hierarchy.
	   */
	  disablePortal: _propTypes.default.bool,
	
	  /**
	   * Callback fired once the children has been mounted into the `container`.
	   *
	   * This prop will be deprecated and removed in v5, the ref can be used instead.
	   */
	  onRendered: _propTypes.default.func
	} : void 0;
	
	if (false) {
	  // eslint-disable-next-line
	  Portal['propTypes' + ''] = (0, _utils.exactProp)(Portal.propTypes);
	}
	
	var _default = Portal;
	exports.default = _default;

/***/ },
/* 1225 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _utils = __webpack_require__(19);
	
	var _SwitchBase = _interopRequireDefault(__webpack_require__(407));
	
	var _RadioButtonIcon = _interopRequireDefault(__webpack_require__(1226));
	
	var _colorManipulator = __webpack_require__(63);
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(194));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _useRadioGroup = _interopRequireDefault(__webpack_require__(599));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      color: theme.palette.text.secondary
	    },
	
	    /* Pseudo-class applied to the root element if `checked={true}`. */
	    checked: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      '&$checked': {
	        color: theme.palette.primary.main,
	        '&:hover': {
	          backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	          // Reset on touch devices, it doesn't add specificity
	          '@media (hover: none)': {
	            backgroundColor: 'transparent'
	          }
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      '&$checked': {
	        color: theme.palette.secondary.main,
	        '&:hover': {
	          backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	          // Reset on touch devices, it doesn't add specificity
	          '@media (hover: none)': {
	            backgroundColor: 'transparent'
	          }
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var defaultCheckedIcon = /*#__PURE__*/React.createElement(_RadioButtonIcon.default, {
	  checked: true
	});
	var defaultIcon = /*#__PURE__*/React.createElement(_RadioButtonIcon.default, null);
	var Radio = /*#__PURE__*/React.forwardRef(function Radio(props, ref) {
	  var checkedProp = props.checked,
	      classes = props.classes,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'secondary' : _props$color,
	      nameProp = props.name,
	      onChangeProp = props.onChange,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      other = (0, _objectWithoutProperties2.default)(props, ["checked", "classes", "color", "name", "onChange", "size"]);
	  var radioGroup = (0, _useRadioGroup.default)();
	  var checked = checkedProp;
	  var onChange = (0, _createChainedFunction.default)(onChangeProp, radioGroup && radioGroup.onChange);
	  var name = nameProp;
	
	  if (radioGroup) {
	    if (typeof checked === 'undefined') {
	      checked = radioGroup.value === props.value;
	    }
	
	    if (typeof name === 'undefined') {
	      name = radioGroup.name;
	    }
	  }
	
	  return /*#__PURE__*/React.createElement(_SwitchBase.default, (0, _extends2.default)({
	    color: color,
	    type: "radio",
	    icon: /*#__PURE__*/React.cloneElement(defaultIcon, {
	      fontSize: size === 'small' ? 'small' : 'default'
	    }),
	    checkedIcon: /*#__PURE__*/React.cloneElement(defaultCheckedIcon, {
	      fontSize: size === 'small' ? 'small' : 'default'
	    }),
	    classes: {
	      root: (0, _clsx.default)(classes.root, classes["color".concat((0, _capitalize.default)(color))]),
	      checked: classes.checked,
	      disabled: classes.disabled
	    },
	    name: name,
	    checked: checked,
	    onChange: onChange,
	    ref: ref
	  }, other));
	});
	 false ? Radio.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is checked.
	   */
	  checkedIcon: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'primary', 'secondary']),
	
	  /**
	   * If `true`, the radio will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is unchecked.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * The size of the radio.
	   * `small` is equivalent to the dense radio styling.
	   */
	  size: _propTypes.default.oneOf(['medium', 'small']),
	
	  /**
	   * The value of the component. The DOM API casts this to a string.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiRadio'
	})(Radio);
	
	exports.default = _default;

/***/ },
/* 1226 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _RadioButtonUnchecked = _interopRequireDefault(__webpack_require__(1310));
	
	var _RadioButtonChecked = _interopRequireDefault(__webpack_require__(1309));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      position: 'relative',
	      display: 'flex',
	      '&$checked $layer': {
	        transform: 'scale(1)',
	        transition: theme.transitions.create('transform', {
	          easing: theme.transitions.easing.easeOut,
	          duration: theme.transitions.duration.shortest
	        })
	      }
	    },
	    layer: {
	      left: 0,
	      position: 'absolute',
	      transform: 'scale(0)',
	      transition: theme.transitions.create('transform', {
	        easing: theme.transitions.easing.easeIn,
	        duration: theme.transitions.duration.shortest
	      })
	    },
	    checked: {}
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	exports.styles = styles;
	
	function RadioButtonIcon(props) {
	  var checked = props.checked,
	      classes = props.classes,
	      fontSize = props.fontSize;
	  return /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.root, checked && classes.checked)
	  }, /*#__PURE__*/React.createElement(_RadioButtonUnchecked.default, {
	    fontSize: fontSize
	  }), /*#__PURE__*/React.createElement(_RadioButtonChecked.default, {
	    fontSize: fontSize,
	    className: classes.layer
	  }));
	}
	
	 false ? RadioButtonIcon.propTypes = {
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * The size of the radio.
	   * `small` is equivalent to the dense radio styling.
	   */
	  fontSize: _propTypes.default.oneOf(['small', 'default'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateRadioButtonIcon'
	})(RadioButtonIcon);
	
	exports.default = _default;

/***/ },
/* 1227 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Radio.default;
	  }
	});
	
	var _Radio = _interopRequireDefault(__webpack_require__(1225));

/***/ },
/* 1228 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(80));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _FormGroup = _interopRequireDefault(__webpack_require__(584));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(47));
	
	var _useControlled3 = _interopRequireDefault(__webpack_require__(133));
	
	var _RadioGroupContext = _interopRequireDefault(__webpack_require__(598));
	
	var _unstable_useId = _interopRequireDefault(__webpack_require__(310));
	
	var RadioGroup = /*#__PURE__*/React.forwardRef(function RadioGroup(props, ref) {
	  var actions = props.actions,
	      children = props.children,
	      nameProp = props.name,
	      valueProp = props.value,
	      onChange = props.onChange,
	      other = (0, _objectWithoutProperties2.default)(props, ["actions", "children", "name", "value", "onChange"]);
	  var rootRef = React.useRef(null);
	
	  var _useControlled = (0, _useControlled3.default)({
	    controlled: valueProp,
	    default: props.defaultValue,
	    name: 'RadioGroup'
	  }),
	      _useControlled2 = (0, _slicedToArray2.default)(_useControlled, 2),
	      value = _useControlled2[0],
	      setValue = _useControlled2[1];
	
	  React.useImperativeHandle(actions, function () {
	    return {
	      focus: function focus() {
	        var input = rootRef.current.querySelector('input:not(:disabled):checked');
	
	        if (!input) {
	          input = rootRef.current.querySelector('input:not(:disabled)');
	        }
	
	        if (input) {
	          input.focus();
	        }
	      }
	    };
	  }, []);
	  var handleRef = (0, _useForkRef.default)(ref, rootRef);
	
	  var handleChange = function handleChange(event) {
	    setValue(event.target.value);
	
	    if (onChange) {
	      onChange(event, event.target.value);
	    }
	  };
	
	  var name = (0, _unstable_useId.default)(nameProp);
	  return /*#__PURE__*/React.createElement(_RadioGroupContext.default.Provider, {
	    value: {
	      name: name,
	      onChange: handleChange,
	      value: value
	    }
	  }, /*#__PURE__*/React.createElement(_FormGroup.default, (0, _extends2.default)({
	    role: "radiogroup",
	    ref: handleRef
	  }, other), children));
	});
	 false ? RadioGroup.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * The default `input` element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * The name used to reference the value of the control.
	   * If you don't provide this prop, it falls back to a randomly generated name.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback fired when a radio button is selected.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * Value of the selected radio button. The DOM API casts this to a string.
	   */
	  value: _propTypes.default.any
	} : void 0;
	var _default = RadioGroup;
	exports.default = _default;

/***/ },
/* 1229 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _RadioGroup.default;
	  }
	});
	Object.defineProperty(exports, "useRadioGroup", {
	  enumerable: true,
	  get: function get() {
	    return _useRadioGroup.default;
	  }
	});
	
	var _RadioGroup = _interopRequireDefault(__webpack_require__(1228));
	
	var _useRadioGroup = _interopRequireDefault(__webpack_require__(599));

/***/ },
/* 1230 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(391));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(295));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(1102));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(1106));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(1101));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(51));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(19);
	
	var _setRef = _interopRequireDefault(__webpack_require__(157));
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	/**
	 * ⚠️⚠️⚠️
	 * If you want the DOM element of a Material-UI component check out
	 * [FAQ: How can I access the DOM element?](/getting-started/faq/#how-can-i-access-the-dom-element)
	 * first.
	 *
	 * This component uses `findDOMNode` which is deprecated in React.StrictMode.
	 *
	 * Helper component to allow attaching a ref to a
	 * wrapped element to access the underlying DOM element.
	 *
	 * It's highly inspired by https://github.com/facebook/react/issues/11401#issuecomment-340543801.
	 * For example:
	 * ```jsx
	 * import React from 'react';
	 * import RootRef from '@material-ui/core/RootRef';
	 *
	 * function MyComponent() {
	 *   const domRef = React.useRef();
	 *
	 *   React.useEffect(() => {
	 *     console.log(domRef.current); // DOM node
	 *   }, []);
	 *
	 *   return (
	 *     <RootRef rootRef={domRef}>
	 *       <SomeChildComponent />
	 *     </RootRef>
	 *   );
	 * }
	 * ```
	 */
	var RootRef = /*#__PURE__*/function (_React$Component) {
	  (0, _inherits2.default)(RootRef, _React$Component);
	
	  var _super = _createSuper(RootRef);
	
	  function RootRef() {
	    (0, _classCallCheck2.default)(this, RootRef);
	    return _super.apply(this, arguments);
	  }
	
	  (0, _createClass2.default)(RootRef, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.ref = ReactDOM.findDOMNode(this);
	      (0, _setRef.default)(this.props.rootRef, this.ref);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var ref = ReactDOM.findDOMNode(this);
	
	      if (prevProps.rootRef !== this.props.rootRef || this.ref !== ref) {
	        if (prevProps.rootRef !== this.props.rootRef) {
	          (0, _setRef.default)(prevProps.rootRef, null);
	        }
	
	        this.ref = ref;
	        (0, _setRef.default)(this.props.rootRef, this.ref);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.ref = null;
	      (0, _setRef.default)(this.props.rootRef, null);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return RootRef;
	}(React.Component);
	
	 false ? RootRef.propTypes = {
	  /**
	   * The wrapped element.
	   */
	  children: _propTypes.default.element.isRequired,
	
	  /**
	   * A ref that points to the first DOM node of the wrapped element.
	   */
	  rootRef: _utils.refType.isRequired
	} : void 0;
	
	if (false) {
	  process.env.NODE_ENV !== "production" ? RootRef.propTypes = (0, _utils.exactProp)(RootRef.propTypes) : void 0;
	}
	
	var _default = RootRef;
	exports.default = _default;

/***/ },
/* 1231 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _RootRef.default;
	  }
	});
	
	var _RootRef = _interopRequireDefault(__webpack_require__(1230));

/***/ },
/* 1232 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _styles = __webpack_require__(76);
	
	var _SelectInput = _interopRequireDefault(__webpack_require__(1233));
	
	var _formControlState = _interopRequireDefault(__webpack_require__(191));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(154));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _ArrowDropDown = _interopRequireDefault(__webpack_require__(619));
	
	var _Input = _interopRequireDefault(__webpack_require__(301));
	
	var _NativeSelect = __webpack_require__(593);
	
	var _NativeSelectInput = _interopRequireDefault(__webpack_require__(594));
	
	var _FilledInput = _interopRequireDefault(__webpack_require__(398));
	
	var _OutlinedInput = _interopRequireDefault(__webpack_require__(401));
	
	var styles = _NativeSelect.styles;
	exports.styles = styles;
	
	var _ref = /*#__PURE__*/React.createElement(_Input.default, null);
	
	var _ref2 = /*#__PURE__*/React.createElement(_FilledInput.default, null);
	
	var Select = /*#__PURE__*/React.forwardRef(function Select(props, ref) {
	  var _props$autoWidth = props.autoWidth,
	      autoWidth = _props$autoWidth === void 0 ? false : _props$autoWidth,
	      children = props.children,
	      classes = props.classes,
	      _props$displayEmpty = props.displayEmpty,
	      displayEmpty = _props$displayEmpty === void 0 ? false : _props$displayEmpty,
	      _props$IconComponent = props.IconComponent,
	      IconComponent = _props$IconComponent === void 0 ? _ArrowDropDown.default : _props$IconComponent,
	      id = props.id,
	      input = props.input,
	      inputProps = props.inputProps,
	      label = props.label,
	      labelId = props.labelId,
	      _props$labelWidth = props.labelWidth,
	      labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth,
	      MenuProps = props.MenuProps,
	      _props$multiple = props.multiple,
	      multiple = _props$multiple === void 0 ? false : _props$multiple,
	      _props$native = props.native,
	      native = _props$native === void 0 ? false : _props$native,
	      onClose = props.onClose,
	      onOpen = props.onOpen,
	      open = props.open,
	      renderValue = props.renderValue,
	      SelectDisplayProps = props.SelectDisplayProps,
	      _props$variant = props.variant,
	      variantProps = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["autoWidth", "children", "classes", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "labelWidth", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"]);
	  var inputComponent = native ? _NativeSelectInput.default : _SelectInput.default;
	  var muiFormControl = (0, _useFormControl.default)();
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['variant']
	  });
	  var variant = fcs.variant || variantProps;
	  var InputComponent = input || {
	    standard: _ref,
	    outlined: /*#__PURE__*/React.createElement(_OutlinedInput.default, {
	      label: label,
	      labelWidth: labelWidth
	    }),
	    filled: _ref2
	  }[variant];
	  return /*#__PURE__*/React.cloneElement(InputComponent, (0, _extends2.default)({
	    // Most of the logic is implemented in `SelectInput`.
	    // The `Select` component is a simple API wrapper to expose something better to play with.
	    inputComponent: inputComponent,
	    inputProps: (0, _extends2.default)({
	      children: children,
	      IconComponent: IconComponent,
	      variant: variant,
	      type: undefined,
	      // We render a select. We can ignore the type provided by the `Input`.
	      multiple: multiple
	    }, native ? {
	      id: id
	    } : {
	      autoWidth: autoWidth,
	      displayEmpty: displayEmpty,
	      labelId: labelId,
	      MenuProps: MenuProps,
	      onClose: onClose,
	      onOpen: onOpen,
	      open: open,
	      renderValue: renderValue,
	      SelectDisplayProps: (0, _extends2.default)({
	        id: id
	      }, SelectDisplayProps)
	    }, inputProps, {
	      classes: inputProps ? (0, _styles.mergeClasses)({
	        baseClasses: classes,
	        newClasses: inputProps.classes,
	        Component: Select
	      }) : classes
	    }, input ? input.props.inputProps : {}),
	    ref: ref
	  }, other));
	});
	 false ? Select.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * If `true`, the width of the popover will automatically be set according to the items inside the
	   * menu, otherwise it will be at least the width of the select input.
	   */
	  autoWidth: _propTypes.default.bool,
	
	  /**
	   * The option elements to populate the select with.
	   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
	   *
	   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * The default element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, a value is displayed even if no items are selected.
	   *
	   * In order to display a meaningful value, a function should be passed to the `renderValue` prop which returns the value to be displayed when no items are selected.
	   * You can only use it when the `native` prop is `false` (default).
	   */
	  displayEmpty: _propTypes.default.bool,
	
	  /**
	   * The icon that displays the arrow.
	   */
	  IconComponent: _propTypes.default.elementType,
	
	  /**
	   * The `id` of the wrapper element or the `select` element when `native`.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * An `Input` element; does not have to be a material-ui specific `Input`.
	   */
	  input: _propTypes.default.element,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   * When `native` is `true`, the attributes are applied on the `select` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * See [OutlinedInput#label](/api/outlined-input/#props)
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * The ID of an element that acts as an additional label. The Select will
	   * be labelled by the additional label and the selected value.
	   */
	  labelId: _propTypes.default.string,
	
	  /**
	   * See [OutlinedInput#label](/api/outlined-input/#props)
	   */
	  labelWidth: _propTypes.default.number,
	
	  /**
	   * Props applied to the [`Menu`](/api/menu/) element.
	   */
	  MenuProps: _propTypes.default.object,
	
	  /**
	   * If `true`, `value` must be an array and the menu will support multiple selections.
	   */
	  multiple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the component will be using a native `select` element.
	   */
	  native: _propTypes.default.bool,
	
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (any).
	   * @param {object} [child] The react element that was selected when `native` is `false` (default).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be opened.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onOpen: _propTypes.default.func,
	
	  /**
	   * Control `select` open state.
	   * You can only use it when the `native` prop is `false` (default).
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * Render the selected value.
	   * You can only use it when the `native` prop is `false` (default).
	   *
	   * @param {any} value The `value` provided to the component.
	   * @returns {ReactNode}
	   */
	  renderValue: _propTypes.default.func,
	
	  /**
	   * Props applied to the clickable div element.
	   */
	  SelectDisplayProps: _propTypes.default.object,
	
	  /**
	   * The input value. Providing an empty string will select no options.
	   * This prop is required when the `native` prop is `false` (default).
	   * Set to an empty string `''` if you don't want any of the available options to be selected.
	   *
	   * If the value is an object it must have reference equality with the option in order to be selected.
	   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['filled', 'outlined', 'standard'])
	} : void 0;
	Select.muiName = 'Select';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSelect'
	})(Select);
	
	exports.default = _default;

/***/ },
/* 1233 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(80));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(153));
	
	var _utils = __webpack_require__(19);
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactIs = __webpack_require__(72);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(90));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var _Menu = _interopRequireDefault(__webpack_require__(589));
	
	var _utils2 = __webpack_require__(400);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(47));
	
	var _useControlled3 = _interopRequireDefault(__webpack_require__(133));
	
	function areEqualValues(a, b) {
	  if ((0, _typeof2.default)(b) === 'object' && b !== null) {
	    return a === b;
	  }
	
	  return String(a) === String(b);
	}
	
	function isEmpty(display) {
	  return display == null || typeof display === 'string' && !display.trim();
	}
	/**
	 * @ignore - internal component.
	 */
	
	
	var SelectInput = /*#__PURE__*/React.forwardRef(function SelectInput(props, ref) {
	  var ariaLabel = props['aria-label'],
	      autoFocus = props.autoFocus,
	      autoWidth = props.autoWidth,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      defaultValue = props.defaultValue,
	      disabled = props.disabled,
	      displayEmpty = props.displayEmpty,
	      IconComponent = props.IconComponent,
	      inputRefProp = props.inputRef,
	      labelId = props.labelId,
	      _props$MenuProps = props.MenuProps,
	      MenuProps = _props$MenuProps === void 0 ? {} : _props$MenuProps,
	      multiple = props.multiple,
	      name = props.name,
	      onBlur = props.onBlur,
	      onChange = props.onChange,
	      onClose = props.onClose,
	      onFocus = props.onFocus,
	      onOpen = props.onOpen,
	      openProp = props.open,
	      readOnly = props.readOnly,
	      renderValue = props.renderValue,
	      _props$SelectDisplayP = props.SelectDisplayProps,
	      SelectDisplayProps = _props$SelectDisplayP === void 0 ? {} : _props$SelectDisplayP,
	      tabIndexProp = props.tabIndex,
	      type = props.type,
	      valueProp = props.value,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["aria-label", "autoFocus", "autoWidth", "children", "classes", "className", "defaultValue", "disabled", "displayEmpty", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"]);
	
	  var _useControlled = (0, _useControlled3.default)({
	    controlled: valueProp,
	    default: defaultValue,
	    name: 'Select'
	  }),
	      _useControlled2 = (0, _slicedToArray2.default)(_useControlled, 2),
	      value = _useControlled2[0],
	      setValue = _useControlled2[1];
	
	  var inputRef = React.useRef(null);
	
	  var _React$useState = React.useState(null),
	      displayNode = _React$useState[0],
	      setDisplayNode = _React$useState[1];
	
	  var _React$useRef = React.useRef(openProp != null),
	      isOpenControlled = _React$useRef.current;
	
	  var _React$useState2 = React.useState(),
	      menuMinWidthState = _React$useState2[0],
	      setMenuMinWidthState = _React$useState2[1];
	
	  var _React$useState3 = React.useState(false),
	      openState = _React$useState3[0],
	      setOpenState = _React$useState3[1];
	
	  var handleRef = (0, _useForkRef.default)(ref, inputRefProp);
	  React.useImperativeHandle(handleRef, function () {
	    return {
	      focus: function focus() {
	        displayNode.focus();
	      },
	      node: inputRef.current,
	      value: value
	    };
	  }, [displayNode, value]);
	  React.useEffect(function () {
	    if (autoFocus && displayNode) {
	      displayNode.focus();
	    }
	  }, [autoFocus, displayNode]);
	  React.useEffect(function () {
	    if (displayNode) {
	      var label = (0, _ownerDocument.default)(displayNode).getElementById(labelId);
	
	      if (label) {
	        var handler = function handler() {
	          if (getSelection().isCollapsed) {
	            displayNode.focus();
	          }
	        };
	
	        label.addEventListener('click', handler);
	        return function () {
	          label.removeEventListener('click', handler);
	        };
	      }
	    }
	
	    return undefined;
	  }, [labelId, displayNode]);
	
	  var update = function update(open, event) {
	    if (open) {
	      if (onOpen) {
	        onOpen(event);
	      }
	    } else if (onClose) {
	      onClose(event);
	    }
	
	    if (!isOpenControlled) {
	      setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
	      setOpenState(open);
	    }
	  };
	
	  var handleMouseDown = function handleMouseDown(event) {
	    // Ignore everything but left-click
	    if (event.button !== 0) {
	      return;
	    } // Hijack the default focus behavior.
	
	
	    event.preventDefault();
	    displayNode.focus();
	    update(true, event);
	  };
	
	  var handleClose = function handleClose(event) {
	    update(false, event);
	  };
	
	  var childrenArray = React.Children.toArray(children); // Support autofill.
	
	  var handleChange = function handleChange(event) {
	    var index = childrenArray.map(function (child) {
	      return child.props.value;
	    }).indexOf(event.target.value);
	
	    if (index === -1) {
	      return;
	    }
	
	    var child = childrenArray[index];
	    setValue(child.props.value);
	
	    if (onChange) {
	      onChange(event, child);
	    }
	  };
	
	  var handleItemClick = function handleItemClick(child) {
	    return function (event) {
	      if (!multiple) {
	        update(false, event);
	      }
	
	      var newValue;
	
	      if (multiple) {
	        newValue = Array.isArray(value) ? value.slice() : [];
	        var itemIndex = value.indexOf(child.props.value);
	
	        if (itemIndex === -1) {
	          newValue.push(child.props.value);
	        } else {
	          newValue.splice(itemIndex, 1);
	        }
	      } else {
	        newValue = child.props.value;
	      }
	
	      if (child.props.onClick) {
	        child.props.onClick(event);
	      }
	
	      if (value === newValue) {
	        return;
	      }
	
	      setValue(newValue);
	
	      if (onChange) {
	        event.persist(); // Preact support, target is read only property on a native event.
	
	        Object.defineProperty(event, 'target', {
	          writable: true,
	          value: {
	            value: newValue,
	            name: name
	          }
	        });
	        onChange(event, child);
	      }
	    };
	  };
	
	  var handleKeyDown = function handleKeyDown(event) {
	    if (!readOnly) {
	      var validKeys = [' ', 'ArrowUp', 'ArrowDown', // The native select doesn't respond to enter on MacOS, but it's recommended by
	      // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
	      'Enter'];
	
	      if (validKeys.indexOf(event.key) !== -1) {
	        event.preventDefault();
	        update(true, event);
	      }
	    }
	  };
	
	  var open = displayNode !== null && (isOpenControlled ? openProp : openState);
	
	  var handleBlur = function handleBlur(event) {
	    // if open event.stopImmediatePropagation
	    if (!open && onBlur) {
	      event.persist(); // Preact support, target is read only property on a native event.
	
	      Object.defineProperty(event, 'target', {
	        writable: true,
	        value: {
	          value: value,
	          name: name
	        }
	      });
	      onBlur(event);
	    }
	  };
	
	  delete other['aria-invalid'];
	  var display;
	  var displaySingle;
	  var displayMultiple = [];
	  var computeDisplay = false;
	  var foundMatch = false; // No need to display any value if the field is empty.
	
	  if ((0, _utils2.isFilled)({
	    value: value
	  }) || displayEmpty) {
	    if (renderValue) {
	      display = renderValue(value);
	    } else {
	      computeDisplay = true;
	    }
	  }
	
	  var items = childrenArray.map(function (child) {
	    if (! /*#__PURE__*/React.isValidElement(child)) {
	      return null;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: The Select component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    var selected;
	
	    if (multiple) {
	      if (!Array.isArray(value)) {
	        throw new Error( false ? "Material-UI: The `value` prop must be an array when using the `Select` component with `multiple`." : (0, _utils.formatMuiErrorMessage)(2));
	      }
	
	      selected = value.some(function (v) {
	        return areEqualValues(v, child.props.value);
	      });
	
	      if (selected && computeDisplay) {
	        displayMultiple.push(child.props.children);
	      }
	    } else {
	      selected = areEqualValues(value, child.props.value);
	
	      if (selected && computeDisplay) {
	        displaySingle = child.props.children;
	      }
	    }
	
	    if (selected) {
	      foundMatch = true;
	    }
	
	    return /*#__PURE__*/React.cloneElement(child, {
	      'aria-selected': selected ? 'true' : undefined,
	      onClick: handleItemClick(child),
	      onKeyUp: function onKeyUp(event) {
	        if (event.key === ' ') {
	          // otherwise our MenuItems dispatches a click event
	          // it's not behavior of the native <option> and causes
	          // the select to close immediately since we open on space keydown
	          event.preventDefault();
	        }
	
	        if (child.props.onKeyUp) {
	          child.props.onKeyUp(event);
	        }
	      },
	      role: 'option',
	      selected: selected,
	      value: undefined,
	      // The value is most likely not a valid HTML attribute.
	      'data-value': child.props.value // Instead, we provide it as a data attribute.
	
	    });
	  });
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    React.useEffect(function () {
	      if (!foundMatch && !multiple && value !== '') {
	        var values = childrenArray.map(function (child) {
	          return child.props.value;
	        });
	        console.warn(["Material-UI: You have provided an out-of-range value `".concat(value, "` for the select ").concat(name ? "(name=\"".concat(name, "\") ") : '', "component."), "Consider providing a value that matches one of the available options or ''.", "The available values are ".concat(values.filter(function (x) {
	          return x != null;
	        }).map(function (x) {
	          return "`".concat(x, "`");
	        }).join(', ') || '""', ".")].join('\n'));
	      }
	    }, [foundMatch, childrenArray, multiple, name, value]);
	  }
	
	  if (computeDisplay) {
	    display = multiple ? displayMultiple.join(', ') : displaySingle;
	  } // Avoid performing a layout computation in the render method.
	
	
	  var menuMinWidth = menuMinWidthState;
	
	  if (!autoWidth && isOpenControlled && displayNode) {
	    menuMinWidth = displayNode.clientWidth;
	  }
	
	  var tabIndex;
	
	  if (typeof tabIndexProp !== 'undefined') {
	    tabIndex = tabIndexProp;
	  } else {
	    tabIndex = disabled ? null : 0;
	  }
	
	  var buttonId = SelectDisplayProps.id || (name ? "mui-component-select-".concat(name) : undefined);
	  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, // TODO v5: merge root and select
	    classes.select, classes.selectMenu, classes[variant], className, disabled && classes.disabled),
	    ref: setDisplayNode,
	    tabIndex: tabIndex,
	    role: "button",
	    "aria-disabled": disabled ? 'true' : undefined,
	    "aria-expanded": open ? 'true' : undefined,
	    "aria-haspopup": "listbox",
	    "aria-label": ariaLabel,
	    "aria-labelledby": [labelId, buttonId].filter(Boolean).join(' ') || undefined,
	    onKeyDown: handleKeyDown,
	    onMouseDown: disabled || readOnly ? null : handleMouseDown,
	    onBlur: handleBlur,
	    onFocus: onFocus
	  }, SelectDisplayProps, {
	    // The id is required for proper a11y
	    id: buttonId
	  }), isEmpty(display) ?
	  /*#__PURE__*/
	  // eslint-disable-next-line react/no-danger
	  React.createElement("span", {
	    dangerouslySetInnerHTML: {
	      __html: '&#8203;'
	    }
	  }) : display), /*#__PURE__*/React.createElement("input", (0, _extends2.default)({
	    value: Array.isArray(value) ? value.join(',') : value,
	    name: name,
	    ref: inputRef,
	    "aria-hidden": true,
	    onChange: handleChange,
	    tabIndex: -1,
	    className: classes.nativeInput,
	    autoFocus: autoFocus
	  }, other)), /*#__PURE__*/React.createElement(IconComponent, {
	    className: (0, _clsx.default)(classes.icon, classes["icon".concat((0, _capitalize.default)(variant))], open && classes.iconOpen, disabled && classes.disabled)
	  }), /*#__PURE__*/React.createElement(_Menu.default, (0, _extends2.default)({
	    id: "menu-".concat(name || ''),
	    anchorEl: displayNode,
	    open: open,
	    onClose: handleClose
	  }, MenuProps, {
	    MenuListProps: (0, _extends2.default)({
	      'aria-labelledby': labelId,
	      role: 'listbox',
	      disableListWrap: true
	    }, MenuProps.MenuListProps),
	    PaperProps: (0, _extends2.default)({}, MenuProps.PaperProps, {
	      style: (0, _extends2.default)({
	        minWidth: menuMinWidth
	      }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
	    })
	  }), items));
	});
	 false ? SelectInput.propTypes = {
	  /**
	   * @ignore
	   */
	  'aria-label': _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, the width of the popover will automatically be set according to the items inside the
	   * menu, otherwise it will be at least the width of the select input.
	   */
	  autoWidth: _propTypes.default.bool,
	
	  /**
	   * The option elements to populate the select with.
	   * Can be some `<MenuItem>` elements.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * The CSS class name of the select element.
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The default element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the select will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the selected item is displayed even if its value is empty.
	   */
	  displayEmpty: _propTypes.default.bool,
	
	  /**
	   * The icon that displays the arrow.
	   */
	  IconComponent: _propTypes.default.elementType.isRequired,
	
	  /**
	   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
	   * Equivalent to `ref`
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * The ID of an element that acts as an additional label. The Select will
	   * be labelled by the additional label and the selected value.
	   */
	  labelId: _propTypes.default.string,
	
	  /**
	   * Props applied to the [`Menu`](/api/menu/) element.
	   */
	  MenuProps: _propTypes.default.object,
	
	  /**
	   * If `true`, `value` must be an array and the menu will support multiple selections.
	   */
	  multiple: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `select` or hidden `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (any).
	   * @param {object} [child] The react element that was selected.
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be opened.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onOpen: _propTypes.default.func,
	
	  /**
	   * Control `select` open state.
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * Render the selected value.
	   *
	   * @param {any} value The `value` provided to the component.
	   * @returns {ReactNode}
	   */
	  renderValue: _propTypes.default.func,
	
	  /**
	   * Props applied to the clickable div element.
	   */
	  SelectDisplayProps: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * @ignore
	   */
	  type: _propTypes.default.any,
	
	  /**
	   * The input value.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
	} : void 0;
	var _default = SelectInput;
	exports.default = _default;

/***/ },
/* 1234 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setTranslateValue = setTranslateValue;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(51));
	
	var _debounce = _interopRequireDefault(__webpack_require__(156));
	
	var _reactTransitionGroup = __webpack_require__(230);
	
	var _utils = __webpack_require__(19);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(47));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(59));
	
	var _transitions = __webpack_require__(99);
	
	var _utils2 = __webpack_require__(193);
	
	// Translate the node so he can't be seen on the screen.
	// Later, we gonna translate back the node to his original location
	// with `none`.`
	function getTranslateValue(direction, node) {
	  var rect = node.getBoundingClientRect();
	  var transform;
	
	  if (node.fakeTransform) {
	    transform = node.fakeTransform;
	  } else {
	    var computedStyle = window.getComputedStyle(node);
	    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
	  }
	
	  var offsetX = 0;
	  var offsetY = 0;
	
	  if (transform && transform !== 'none' && typeof transform === 'string') {
	    var transformValues = transform.split('(')[1].split(')')[0].split(',');
	    offsetX = parseInt(transformValues[4], 10);
	    offsetY = parseInt(transformValues[5], 10);
	  }
	
	  if (direction === 'left') {
	    return "translateX(".concat(window.innerWidth, "px) translateX(").concat(offsetX - rect.left, "px)");
	  }
	
	  if (direction === 'right') {
	    return "translateX(-".concat(rect.left + rect.width - offsetX, "px)");
	  }
	
	  if (direction === 'up') {
	    return "translateY(".concat(window.innerHeight, "px) translateY(").concat(offsetY - rect.top, "px)");
	  } // direction === 'down'
	
	
	  return "translateY(-".concat(rect.top + rect.height - offsetY, "px)");
	}
	
	function setTranslateValue(direction, node) {
	  var transform = getTranslateValue(direction, node);
	
	  if (transform) {
	    node.style.webkitTransform = transform;
	    node.style.transform = transform;
	  }
	}
	
	var defaultTimeout = {
	  enter: _transitions.duration.enteringScreen,
	  exit: _transitions.duration.leavingScreen
	};
	/**
	 * The Slide transition is used by the [Drawer](/components/drawers/) component.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	var Slide = /*#__PURE__*/React.forwardRef(function Slide(props, ref) {
	  var children = props.children,
	      _props$direction = props.direction,
	      direction = _props$direction === void 0 ? 'down' : _props$direction,
	      inProp = props.in,
	      onEnter = props.onEnter,
	      onEntered = props.onEntered,
	      onEntering = props.onEntering,
	      onExit = props.onExit,
	      onExited = props.onExited,
	      onExiting = props.onExiting,
	      style = props.style,
	      _props$timeout = props.timeout,
	      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _reactTransitionGroup.Transition : _props$TransitionComp,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "direction", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);
	  var theme = (0, _useTheme.default)();
	  var childrenRef = React.useRef(null);
	  /**
	   * used in cloneElement(children, { ref: handleRef })
	   */
	
	  var handleOwnRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    childrenRef.current = ReactDOM.findDOMNode(instance);
	  }, []);
	  var handleRefIntermediary = (0, _useForkRef.default)(children.ref, handleOwnRef);
	  var handleRef = (0, _useForkRef.default)(handleRefIntermediary, ref);
	
	  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
	    return function (isAppearing) {
	      if (callback) {
	        // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
	        if (isAppearing === undefined) {
	          callback(childrenRef.current);
	        } else {
	          callback(childrenRef.current, isAppearing);
	        }
	      }
	    };
	  };
	
	  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
	    setTranslateValue(direction, node);
	    (0, _utils2.reflow)(node);
	
	    if (onEnter) {
	      onEnter(node, isAppearing);
	    }
	  });
	  var handleEntering = normalizedTransitionCallback(function (node, isAppearing) {
	    var transitionProps = (0, _utils2.getTransitionProps)({
	      timeout: timeout,
	      style: style
	    }, {
	      mode: 'enter'
	    });
	    node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _extends2.default)({}, transitionProps, {
	      easing: theme.transitions.easing.easeOut
	    }));
	    node.style.transition = theme.transitions.create('transform', (0, _extends2.default)({}, transitionProps, {
	      easing: theme.transitions.easing.easeOut
	    }));
	    node.style.webkitTransform = 'none';
	    node.style.transform = 'none';
	
	    if (onEntering) {
	      onEntering(node, isAppearing);
	    }
	  });
	  var handleEntered = normalizedTransitionCallback(onEntered);
	  var handleExiting = normalizedTransitionCallback(onExiting);
	  var handleExit = normalizedTransitionCallback(function (node) {
	    var transitionProps = (0, _utils2.getTransitionProps)({
	      timeout: timeout,
	      style: style
	    }, {
	      mode: 'exit'
	    });
	    node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _extends2.default)({}, transitionProps, {
	      easing: theme.transitions.easing.sharp
	    }));
	    node.style.transition = theme.transitions.create('transform', (0, _extends2.default)({}, transitionProps, {
	      easing: theme.transitions.easing.sharp
	    }));
	    setTranslateValue(direction, node);
	
	    if (onExit) {
	      onExit(node);
	    }
	  });
	  var handleExited = normalizedTransitionCallback(function (node) {
	    // No need for transitions when the component is hidden
	    node.style.webkitTransition = '';
	    node.style.transition = '';
	
	    if (onExited) {
	      onExited(node);
	    }
	  });
	  var updatePosition = React.useCallback(function () {
	    if (childrenRef.current) {
	      setTranslateValue(direction, childrenRef.current);
	    }
	  }, [direction]);
	  React.useEffect(function () {
	    // Skip configuration where the position is screen size invariant.
	    if (inProp || direction === 'down' || direction === 'right') {
	      return undefined;
	    }
	
	    var handleResize = (0, _debounce.default)(function () {
	      if (childrenRef.current) {
	        setTranslateValue(direction, childrenRef.current);
	      }
	    });
	    window.addEventListener('resize', handleResize);
	    return function () {
	      handleResize.clear();
	      window.removeEventListener('resize', handleResize);
	    };
	  }, [direction, inProp]);
	  React.useEffect(function () {
	    if (!inProp) {
	      // We need to update the position of the drawer when the direction change and
	      // when it's hidden.
	      updatePosition();
	    }
	  }, [inProp, updatePosition]);
	  return /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    nodeRef: childrenRef,
	    onEnter: handleEnter,
	    onEntered: handleEntered,
	    onEntering: handleEntering,
	    onExit: handleExit,
	    onExited: handleExited,
	    onExiting: handleExiting,
	    appear: true,
	    in: inProp,
	    timeout: timeout
	  }, other), function (state, childProps) {
	    return /*#__PURE__*/React.cloneElement(children, (0, _extends2.default)({
	      ref: handleRef,
	      style: (0, _extends2.default)({
	        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
	      }, style, children.props.style)
	    }, childProps));
	  });
	});
	 false ? Slide.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A single child content element.
	   */
	  children: _utils.elementAcceptingRef,
	
	  /**
	   * Direction the child node will enter from.
	   */
	  direction: _propTypes.default.oneOf(['down', 'left', 'right', 'up']),
	
	  /**
	   * If `true`, show the component; triggers the enter or exit animation.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : void 0;
	var _default = Slide;
	exports.default = _default;

/***/ },
/* 1235 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(115));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(80));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _utils = __webpack_require__(19);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(59));
	
	var _colorManipulator = __webpack_require__(63);
	
	var _useIsFocusVisible2 = _interopRequireDefault(__webpack_require__(243));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(90));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(117));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(47));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var _useControlled3 = _interopRequireDefault(__webpack_require__(133));
	
	var _ValueLabel = _interopRequireDefault(__webpack_require__(1236));
	
	function asc(a, b) {
	  return a - b;
	}
	
	function clamp(value, min, max) {
	  return Math.min(Math.max(min, value), max);
	}
	
	function findClosest(values, currentValue) {
	  var _values$reduce = values.reduce(function (acc, value, index) {
	    var distance = Math.abs(currentValue - value);
	
	    if (acc === null || distance < acc.distance || distance === acc.distance) {
	      return {
	        distance: distance,
	        index: index
	      };
	    }
	
	    return acc;
	  }, null),
	      closestIndex = _values$reduce.index;
	
	  return closestIndex;
	}
	
	function trackFinger(event, touchId) {
	  if (touchId.current !== undefined && event.changedTouches) {
	    for (var i = 0; i < event.changedTouches.length; i += 1) {
	      var touch = event.changedTouches[i];
	
	      if (touch.identifier === touchId.current) {
	        return {
	          x: touch.clientX,
	          y: touch.clientY
	        };
	      }
	    }
	
	    return false;
	  }
	
	  return {
	    x: event.clientX,
	    y: event.clientY
	  };
	}
	
	function valueToPercent(value, min, max) {
	  return (value - min) * 100 / (max - min);
	}
	
	function percentToValue(percent, min, max) {
	  return (max - min) * percent + min;
	}
	
	function getDecimalPrecision(num) {
	  // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
	  // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
	  if (Math.abs(num) < 1) {
	    var parts = num.toExponential().split('e-');
	    var matissaDecimalPart = parts[0].split('.')[1];
	    return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
	  }
	
	  var decimalPart = num.toString().split('.')[1];
	  return decimalPart ? decimalPart.length : 0;
	}
	
	function roundValueToStep(value, step, min) {
	  var nearest = Math.round((value - min) / step) * step + min;
	  return Number(nearest.toFixed(getDecimalPrecision(step)));
	}
	
	function setValueIndex(_ref) {
	  var values = _ref.values,
	      source = _ref.source,
	      newValue = _ref.newValue,
	      index = _ref.index;
	
	  // Performance shortcut
	  if (values[index] === newValue) {
	    return source;
	  }
	
	  var output = values.slice();
	  output[index] = newValue;
	  return output;
	}
	
	function focusThumb(_ref2) {
	  var sliderRef = _ref2.sliderRef,
	      activeIndex = _ref2.activeIndex,
	      setActive = _ref2.setActive;
	
	  if (!sliderRef.current.contains(document.activeElement) || Number(document.activeElement.getAttribute('data-index')) !== activeIndex) {
	    sliderRef.current.querySelector("[role=\"slider\"][data-index=\"".concat(activeIndex, "\"]")).focus();
	  }
	
	  if (setActive) {
	    setActive(activeIndex);
	  }
	}
	
	var axisProps = {
	  horizontal: {
	    offset: function offset(percent) {
	      return {
	        left: "".concat(percent, "%")
	      };
	    },
	    leap: function leap(percent) {
	      return {
	        width: "".concat(percent, "%")
	      };
	    }
	  },
	  'horizontal-reverse': {
	    offset: function offset(percent) {
	      return {
	        right: "".concat(percent, "%")
	      };
	    },
	    leap: function leap(percent) {
	      return {
	        width: "".concat(percent, "%")
	      };
	    }
	  },
	  vertical: {
	    offset: function offset(percent) {
	      return {
	        bottom: "".concat(percent, "%")
	      };
	    },
	    leap: function leap(percent) {
	      return {
	        height: "".concat(percent, "%")
	      };
	    }
	  }
	};
	
	var Identity = function Identity(x) {
	  return x;
	};
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      height: 2,
	      width: '100%',
	      boxSizing: 'content-box',
	      padding: '13px 0',
	      display: 'inline-block',
	      position: 'relative',
	      cursor: 'pointer',
	      touchAction: 'none',
	      color: theme.palette.primary.main,
	      WebkitTapHighlightColor: 'transparent',
	      '&$disabled': {
	        pointerEvents: 'none',
	        cursor: 'default',
	        color: theme.palette.grey[400]
	      },
	      '&$vertical': {
	        width: 2,
	        height: '100%',
	        padding: '0 13px'
	      },
	      // The primary input mechanism of the device includes a pointing device of limited accuracy.
	      '@media (pointer: coarse)': {
	        // Reach 42px touch target, about ~8mm on screen.
	        padding: '20px 0',
	        '&$vertical': {
	          padding: '0 20px'
	        }
	      },
	      '@media print': {
	        colorAdjust: 'exact'
	      }
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {// TODO v5: move the style here
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the root element if `marks` is provided with at least one label. */
	    marked: {
	      marginBottom: 20,
	      '&$vertical': {
	        marginBottom: 'auto',
	        marginRight: 20
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `orientation="vertical"`. */
	    vertical: {},
	
	    /* Pseudo-class applied to the root and thumb element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the rail element. */
	    rail: {
	      display: 'block',
	      position: 'absolute',
	      width: '100%',
	      height: 2,
	      borderRadius: 1,
	      backgroundColor: 'currentColor',
	      opacity: 0.38,
	      '$vertical &': {
	        height: '100%',
	        width: 2
	      }
	    },
	
	    /* Styles applied to the track element. */
	    track: {
	      display: 'block',
	      position: 'absolute',
	      height: 2,
	      borderRadius: 1,
	      backgroundColor: 'currentColor',
	      '$vertical &': {
	        width: 2
	      }
	    },
	
	    /* Styles applied to the track element if `track={false}`. */
	    trackFalse: {
	      '& $track': {
	        display: 'none'
	      }
	    },
	
	    /* Styles applied to the track element if `track="inverted"`. */
	    trackInverted: {
	      '& $track': {
	        backgroundColor: // Same logic as the LinearProgress track color
	        theme.palette.type === 'light' ? (0, _colorManipulator.lighten)(theme.palette.primary.main, 0.62) : (0, _colorManipulator.darken)(theme.palette.primary.main, 0.5)
	      },
	      '& $rail': {
	        opacity: 1
	      }
	    },
	
	    /* Styles applied to the thumb element. */
	    thumb: {
	      position: 'absolute',
	      width: 12,
	      height: 12,
	      marginLeft: -6,
	      marginTop: -5,
	      boxSizing: 'border-box',
	      borderRadius: '50%',
	      outline: 0,
	      backgroundColor: 'currentColor',
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      transition: theme.transitions.create(['box-shadow'], {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&::after': {
	        position: 'absolute',
	        content: '""',
	        borderRadius: '50%',
	        // reach 42px hit target (2 * 15 + thumb diameter)
	        left: -15,
	        top: -15,
	        right: -15,
	        bottom: -15
	      },
	      '&$focusVisible,&:hover': {
	        boxShadow: "0px 0px 0px 8px ".concat((0, _colorManipulator.fade)(theme.palette.primary.main, 0.16)),
	        '@media (hover: none)': {
	          boxShadow: 'none'
	        }
	      },
	      '&$active': {
	        boxShadow: "0px 0px 0px 14px ".concat((0, _colorManipulator.fade)(theme.palette.primary.main, 0.16))
	      },
	      '&$disabled': {
	        width: 8,
	        height: 8,
	        marginLeft: -4,
	        marginTop: -3,
	        '&:hover': {
	          boxShadow: 'none'
	        }
	      },
	      '$vertical &': {
	        marginLeft: -5,
	        marginBottom: -6
	      },
	      '$vertical &$disabled': {
	        marginLeft: -3,
	        marginBottom: -4
	      }
	    },
	
	    /* Styles applied to the thumb element if `color="primary"`. */
	    thumbColorPrimary: {// TODO v5: move the style here
	    },
	
	    /* Styles applied to the thumb element if `color="secondary"`. */
	    thumbColorSecondary: {
	      '&$focusVisible,&:hover': {
	        boxShadow: "0px 0px 0px 8px ".concat((0, _colorManipulator.fade)(theme.palette.secondary.main, 0.16))
	      },
	      '&$active': {
	        boxShadow: "0px 0px 0px 14px ".concat((0, _colorManipulator.fade)(theme.palette.secondary.main, 0.16))
	      }
	    },
	
	    /* Pseudo-class applied to the thumb element if it's active. */
	    active: {},
	
	    /* Pseudo-class applied to the thumb element if keyboard focused. */
	    focusVisible: {},
	
	    /* Styles applied to the thumb label element. */
	    valueLabel: {
	      // IE 11 centering bug, to remove from the customization demos once no longer supported
	      left: 'calc(-50% - 4px)'
	    },
	
	    /* Styles applied to the mark element. */
	    mark: {
	      position: 'absolute',
	      width: 2,
	      height: 2,
	      borderRadius: 1,
	      backgroundColor: 'currentColor'
	    },
	
	    /* Styles applied to the mark element if active (depending on the value). */
	    markActive: {
	      backgroundColor: theme.palette.background.paper,
	      opacity: 0.8
	    },
	
	    /* Styles applied to the mark label element. */
	    markLabel: (0, _extends2.default)({}, theme.typography.body2, {
	      color: theme.palette.text.secondary,
	      position: 'absolute',
	      top: 26,
	      transform: 'translateX(-50%)',
	      whiteSpace: 'nowrap',
	      '$vertical &': {
	        top: 'auto',
	        left: 26,
	        transform: 'translateY(50%)'
	      },
	      '@media (pointer: coarse)': {
	        top: 40,
	        '$vertical &': {
	          left: 31
	        }
	      }
	    }),
	
	    /* Styles applied to the mark label element if active (depending on the value). */
	    markLabelActive: {
	      color: theme.palette.text.primary
	    }
	  };
	};
	
	exports.styles = styles;
	var Slider = /*#__PURE__*/React.forwardRef(function Slider(props, ref) {
	  var ariaLabel = props['aria-label'],
	      ariaLabelledby = props['aria-labelledby'],
	      ariaValuetext = props['aria-valuetext'],
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'span' : _props$component,
	      defaultValue = props.defaultValue,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      getAriaLabel = props.getAriaLabel,
	      getAriaValueText = props.getAriaValueText,
	      _props$marks = props.marks,
	      marksProp = _props$marks === void 0 ? false : _props$marks,
	      _props$max = props.max,
	      max = _props$max === void 0 ? 100 : _props$max,
	      _props$min = props.min,
	      min = _props$min === void 0 ? 0 : _props$min,
	      name = props.name,
	      onChange = props.onChange,
	      onChangeCommitted = props.onChangeCommitted,
	      onMouseDown = props.onMouseDown,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      _props$scale = props.scale,
	      scale = _props$scale === void 0 ? Identity : _props$scale,
	      _props$step = props.step,
	      step = _props$step === void 0 ? 1 : _props$step,
	      _props$ThumbComponent = props.ThumbComponent,
	      ThumbComponent = _props$ThumbComponent === void 0 ? 'span' : _props$ThumbComponent,
	      _props$track = props.track,
	      track = _props$track === void 0 ? 'normal' : _props$track,
	      valueProp = props.value,
	      _props$ValueLabelComp = props.ValueLabelComponent,
	      ValueLabelComponent = _props$ValueLabelComp === void 0 ? _ValueLabel.default : _props$ValueLabelComp,
	      _props$valueLabelDisp = props.valueLabelDisplay,
	      valueLabelDisplay = _props$valueLabelDisp === void 0 ? 'off' : _props$valueLabelDisp,
	      _props$valueLabelForm = props.valueLabelFormat,
	      valueLabelFormat = _props$valueLabelForm === void 0 ? Identity : _props$valueLabelForm,
	      other = (0, _objectWithoutProperties2.default)(props, ["aria-label", "aria-labelledby", "aria-valuetext", "classes", "className", "color", "component", "defaultValue", "disabled", "getAriaLabel", "getAriaValueText", "marks", "max", "min", "name", "onChange", "onChangeCommitted", "onMouseDown", "orientation", "scale", "step", "ThumbComponent", "track", "value", "ValueLabelComponent", "valueLabelDisplay", "valueLabelFormat"]);
	  var theme = (0, _useTheme.default)();
	  var touchId = React.useRef(); // We can't use the :active browser pseudo-classes.
	  // - The active state isn't triggered when clicking on the rail.
	  // - The active state isn't transfered when inversing a range slider.
	
	  var _React$useState = React.useState(-1),
	      active = _React$useState[0],
	      setActive = _React$useState[1];
	
	  var _React$useState2 = React.useState(-1),
	      open = _React$useState2[0],
	      setOpen = _React$useState2[1];
	
	  var _useControlled = (0, _useControlled3.default)({
	    controlled: valueProp,
	    default: defaultValue,
	    name: 'Slider'
	  }),
	      _useControlled2 = (0, _slicedToArray2.default)(_useControlled, 2),
	      valueDerived = _useControlled2[0],
	      setValueState = _useControlled2[1];
	
	  var range = Array.isArray(valueDerived);
	  var values = range ? valueDerived.slice().sort(asc) : [valueDerived];
	  values = values.map(function (value) {
	    return clamp(value, min, max);
	  });
	  var marks = marksProp === true && step !== null ? (0, _toConsumableArray2.default)(Array(Math.floor((max - min) / step) + 1)).map(function (_, index) {
	    return {
	      value: min + step * index
	    };
	  }) : marksProp || [];
	
	  var _useIsFocusVisible = (0, _useIsFocusVisible2.default)(),
	      isFocusVisible = _useIsFocusVisible.isFocusVisible,
	      onBlurVisible = _useIsFocusVisible.onBlurVisible,
	      focusVisibleRef = _useIsFocusVisible.ref;
	
	  var _React$useState3 = React.useState(-1),
	      focusVisible = _React$useState3[0],
	      setFocusVisible = _React$useState3[1];
	
	  var sliderRef = React.useRef();
	  var handleFocusRef = (0, _useForkRef.default)(focusVisibleRef, sliderRef);
	  var handleRef = (0, _useForkRef.default)(ref, handleFocusRef);
	  var handleFocus = (0, _useEventCallback.default)(function (event) {
	    var index = Number(event.currentTarget.getAttribute('data-index'));
	
	    if (isFocusVisible(event)) {
	      setFocusVisible(index);
	    }
	
	    setOpen(index);
	  });
	  var handleBlur = (0, _useEventCallback.default)(function () {
	    if (focusVisible !== -1) {
	      setFocusVisible(-1);
	      onBlurVisible();
	    }
	
	    setOpen(-1);
	  });
	  var handleMouseOver = (0, _useEventCallback.default)(function (event) {
	    var index = Number(event.currentTarget.getAttribute('data-index'));
	    setOpen(index);
	  });
	  var handleMouseLeave = (0, _useEventCallback.default)(function () {
	    setOpen(-1);
	  });
	  var isRtl = theme.direction === 'rtl';
	  var handleKeyDown = (0, _useEventCallback.default)(function (event) {
	    var index = Number(event.currentTarget.getAttribute('data-index'));
	    var value = values[index];
	    var tenPercents = (max - min) / 10;
	    var marksValues = marks.map(function (mark) {
	      return mark.value;
	    });
	    var marksIndex = marksValues.indexOf(value);
	    var newValue;
	    var increaseKey = isRtl ? 'ArrowLeft' : 'ArrowRight';
	    var decreaseKey = isRtl ? 'ArrowRight' : 'ArrowLeft';
	
	    switch (event.key) {
	      case 'Home':
	        newValue = min;
	        break;
	
	      case 'End':
	        newValue = max;
	        break;
	
	      case 'PageUp':
	        if (step) {
	          newValue = value + tenPercents;
	        }
	
	        break;
	
	      case 'PageDown':
	        if (step) {
	          newValue = value - tenPercents;
	        }
	
	        break;
	
	      case increaseKey:
	      case 'ArrowUp':
	        if (step) {
	          newValue = value + step;
	        } else {
	          newValue = marksValues[marksIndex + 1] || marksValues[marksValues.length - 1];
	        }
	
	        break;
	
	      case decreaseKey:
	      case 'ArrowDown':
	        if (step) {
	          newValue = value - step;
	        } else {
	          newValue = marksValues[marksIndex - 1] || marksValues[0];
	        }
	
	        break;
	
	      default:
	        return;
	    } // Prevent scroll of the page
	
	
	    event.preventDefault();
	
	    if (step) {
	      newValue = roundValueToStep(newValue, step, min);
	    }
	
	    newValue = clamp(newValue, min, max);
	
	    if (range) {
	      var previousValue = newValue;
	      newValue = setValueIndex({
	        values: values,
	        source: valueDerived,
	        newValue: newValue,
	        index: index
	      }).sort(asc);
	      focusThumb({
	        sliderRef: sliderRef,
	        activeIndex: newValue.indexOf(previousValue)
	      });
	    }
	
	    setValueState(newValue);
	    setFocusVisible(index);
	
	    if (onChange) {
	      onChange(event, newValue);
	    }
	
	    if (onChangeCommitted) {
	      onChangeCommitted(event, newValue);
	    }
	  });
	  var previousIndex = React.useRef();
	  var axis = orientation;
	
	  if (isRtl && orientation !== "vertical") {
	    axis += '-reverse';
	  }
	
	  var getFingerNewValue = function getFingerNewValue(_ref3) {
	    var finger = _ref3.finger,
	        _ref3$move = _ref3.move,
	        move = _ref3$move === void 0 ? false : _ref3$move,
	        values2 = _ref3.values,
	        source = _ref3.source;
	    var slider = sliderRef.current;
	
	    var _slider$getBoundingCl = slider.getBoundingClientRect(),
	        width = _slider$getBoundingCl.width,
	        height = _slider$getBoundingCl.height,
	        bottom = _slider$getBoundingCl.bottom,
	        left = _slider$getBoundingCl.left;
	
	    var percent;
	
	    if (axis.indexOf('vertical') === 0) {
	      percent = (bottom - finger.y) / height;
	    } else {
	      percent = (finger.x - left) / width;
	    }
	
	    if (axis.indexOf('-reverse') !== -1) {
	      percent = 1 - percent;
	    }
	
	    var newValue;
	    newValue = percentToValue(percent, min, max);
	
	    if (step) {
	      newValue = roundValueToStep(newValue, step, min);
	    } else {
	      var marksValues = marks.map(function (mark) {
	        return mark.value;
	      });
	      var closestIndex = findClosest(marksValues, newValue);
	      newValue = marksValues[closestIndex];
	    }
	
	    newValue = clamp(newValue, min, max);
	    var activeIndex = 0;
	
	    if (range) {
	      if (!move) {
	        activeIndex = findClosest(values2, newValue);
	      } else {
	        activeIndex = previousIndex.current;
	      }
	
	      var previousValue = newValue;
	      newValue = setValueIndex({
	        values: values2,
	        source: source,
	        newValue: newValue,
	        index: activeIndex
	      }).sort(asc);
	      activeIndex = newValue.indexOf(previousValue);
	      previousIndex.current = activeIndex;
	    }
	
	    return {
	      newValue: newValue,
	      activeIndex: activeIndex
	    };
	  };
	
	  var handleTouchMove = (0, _useEventCallback.default)(function (event) {
	    var finger = trackFinger(event, touchId);
	
	    if (!finger) {
	      return;
	    }
	
	    var _getFingerNewValue = getFingerNewValue({
	      finger: finger,
	      move: true,
	      values: values,
	      source: valueDerived
	    }),
	        newValue = _getFingerNewValue.newValue,
	        activeIndex = _getFingerNewValue.activeIndex;
	
	    focusThumb({
	      sliderRef: sliderRef,
	      activeIndex: activeIndex,
	      setActive: setActive
	    });
	    setValueState(newValue);
	
	    if (onChange) {
	      onChange(event, newValue);
	    }
	  });
	  var handleTouchEnd = (0, _useEventCallback.default)(function (event) {
	    var finger = trackFinger(event, touchId);
	
	    if (!finger) {
	      return;
	    }
	
	    var _getFingerNewValue2 = getFingerNewValue({
	      finger: finger,
	      values: values,
	      source: valueDerived
	    }),
	        newValue = _getFingerNewValue2.newValue;
	
	    setActive(-1);
	
	    if (event.type === 'touchend') {
	      setOpen(-1);
	    }
	
	    if (onChangeCommitted) {
	      onChangeCommitted(event, newValue);
	    }
	
	    touchId.current = undefined;
	    var doc = (0, _ownerDocument.default)(sliderRef.current);
	    doc.removeEventListener('mousemove', handleTouchMove);
	    doc.removeEventListener('mouseup', handleTouchEnd);
	    doc.removeEventListener('touchmove', handleTouchMove);
	    doc.removeEventListener('touchend', handleTouchEnd);
	  });
	  var handleTouchStart = (0, _useEventCallback.default)(function (event) {
	    // Workaround as Safari has partial support for touchAction: 'none'.
	    event.preventDefault();
	    var touch = event.changedTouches[0];
	
	    if (touch != null) {
	      // A number that uniquely identifies the current finger in the touch session.
	      touchId.current = touch.identifier;
	    }
	
	    var finger = trackFinger(event, touchId);
	
	    var _getFingerNewValue3 = getFingerNewValue({
	      finger: finger,
	      values: values,
	      source: valueDerived
	    }),
	        newValue = _getFingerNewValue3.newValue,
	        activeIndex = _getFingerNewValue3.activeIndex;
	
	    focusThumb({
	      sliderRef: sliderRef,
	      activeIndex: activeIndex,
	      setActive: setActive
	    });
	    setValueState(newValue);
	
	    if (onChange) {
	      onChange(event, newValue);
	    }
	
	    var doc = (0, _ownerDocument.default)(sliderRef.current);
	    doc.addEventListener('touchmove', handleTouchMove);
	    doc.addEventListener('touchend', handleTouchEnd);
	  });
	  React.useEffect(function () {
	    var slider = sliderRef.current;
	    slider.addEventListener('touchstart', handleTouchStart);
	    var doc = (0, _ownerDocument.default)(slider);
	    return function () {
	      slider.removeEventListener('touchstart', handleTouchStart);
	      doc.removeEventListener('mousemove', handleTouchMove);
	      doc.removeEventListener('mouseup', handleTouchEnd);
	      doc.removeEventListener('touchmove', handleTouchMove);
	      doc.removeEventListener('touchend', handleTouchEnd);
	    };
	  }, [handleTouchEnd, handleTouchMove, handleTouchStart]);
	  var handleMouseDown = (0, _useEventCallback.default)(function (event) {
	    if (onMouseDown) {
	      onMouseDown(event);
	    }
	
	    event.preventDefault();
	    var finger = trackFinger(event, touchId);
	
	    var _getFingerNewValue4 = getFingerNewValue({
	      finger: finger,
	      values: values,
	      source: valueDerived
	    }),
	        newValue = _getFingerNewValue4.newValue,
	        activeIndex = _getFingerNewValue4.activeIndex;
	
	    focusThumb({
	      sliderRef: sliderRef,
	      activeIndex: activeIndex,
	      setActive: setActive
	    });
	    setValueState(newValue);
	
	    if (onChange) {
	      onChange(event, newValue);
	    }
	
	    var doc = (0, _ownerDocument.default)(sliderRef.current);
	    doc.addEventListener('mousemove', handleTouchMove);
	    doc.addEventListener('mouseup', handleTouchEnd);
	  });
	  var trackOffset = valueToPercent(range ? values[0] : min, min, max);
	  var trackLeap = valueToPercent(values[values.length - 1], min, max) - trackOffset;
	  var trackStyle = (0, _extends2.default)({}, axisProps[axis].offset(trackOffset), axisProps[axis].leap(trackLeap));
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    ref: handleRef,
	    className: (0, _clsx.default)(classes.root, classes["color".concat((0, _capitalize.default)(color))], className, disabled && classes.disabled, marks.length > 0 && marks.some(function (mark) {
	      return mark.label;
	    }) && classes.marked, track === false && classes.trackFalse, orientation === 'vertical' && classes.vertical, track === 'inverted' && classes.trackInverted),
	    onMouseDown: handleMouseDown
	  }, other), /*#__PURE__*/React.createElement("span", {
	    className: classes.rail
	  }), /*#__PURE__*/React.createElement("span", {
	    className: classes.track,
	    style: trackStyle
	  }), /*#__PURE__*/React.createElement("input", {
	    value: values.join(','),
	    name: name,
	    type: "hidden"
	  }), marks.map(function (mark, index) {
	    var percent = valueToPercent(mark.value, min, max);
	    var style = axisProps[axis].offset(percent);
	    var markActive;
	
	    if (track === false) {
	      markActive = values.indexOf(mark.value) !== -1;
	    } else {
	      markActive = track === 'normal' && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === 'inverted' && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
	    }
	
	    return /*#__PURE__*/React.createElement(React.Fragment, {
	      key: mark.value
	    }, /*#__PURE__*/React.createElement("span", {
	      style: style,
	      "data-index": index,
	      className: (0, _clsx.default)(classes.mark, markActive && classes.markActive)
	    }), mark.label != null ? /*#__PURE__*/React.createElement("span", {
	      "aria-hidden": true,
	      "data-index": index,
	      style: style,
	      className: (0, _clsx.default)(classes.markLabel, markActive && classes.markLabelActive)
	    }, mark.label) : null);
	  }), values.map(function (value, index) {
	    var percent = valueToPercent(value, min, max);
	    var style = axisProps[axis].offset(percent);
	    return /*#__PURE__*/React.createElement(ValueLabelComponent, {
	      key: index,
	      valueLabelFormat: valueLabelFormat,
	      valueLabelDisplay: valueLabelDisplay,
	      className: classes.valueLabel,
	      value: typeof valueLabelFormat === 'function' ? valueLabelFormat(scale(value), index) : valueLabelFormat,
	      index: index,
	      open: open === index || active === index || valueLabelDisplay === 'on',
	      disabled: disabled
	    }, /*#__PURE__*/React.createElement(ThumbComponent, {
	      className: (0, _clsx.default)(classes.thumb, classes["thumbColor".concat((0, _capitalize.default)(color))], active === index && classes.active, disabled && classes.disabled, focusVisible === index && classes.focusVisible),
	      tabIndex: disabled ? null : 0,
	      role: "slider",
	      style: style,
	      "data-index": index,
	      "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
	      "aria-labelledby": ariaLabelledby,
	      "aria-orientation": orientation,
	      "aria-valuemax": scale(max),
	      "aria-valuemin": scale(min),
	      "aria-valuenow": scale(value),
	      "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
	      onKeyDown: handleKeyDown,
	      onFocus: handleFocus,
	      onBlur: handleBlur,
	      onMouseOver: handleMouseOver,
	      onMouseLeave: handleMouseLeave
	    }));
	  }));
	});
	 false ? Slider.propTypes = {
	  /**
	   * The label of the slider.
	   */
	  'aria-label': (0, _utils.chainPropTypes)(_propTypes.default.string, function (props) {
	    var range = Array.isArray(props.value || props.defaultValue);
	
	    if (range && props['aria-label'] != null) {
	      return new Error('Material-UI: You need to use the `getAriaLabel` prop instead of `aria-label` when using a range slider.');
	    }
	
	    return null;
	  }),
	
	  /**
	   * The id of the element containing a label for the slider.
	   */
	  'aria-labelledby': _propTypes.default.string,
	
	  /**
	   * A string value that provides a user-friendly name for the current value of the slider.
	   */
	  'aria-valuetext': (0, _utils.chainPropTypes)(_propTypes.default.string, function (props) {
	    var range = Array.isArray(props.value || props.defaultValue);
	
	    if (range && props['aria-valuetext'] != null) {
	      return new Error('Material-UI: You need to use the `getAriaValueText` prop instead of `aria-valuetext` when using a range slider.');
	    }
	
	    return null;
	  }),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * The default element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.number)]),
	
	  /**
	   * If `true`, the slider will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Accepts a function which returns a string value that provides a user-friendly name for the thumb labels of the slider.
	   *
	   * @param {number} index The thumb label's index to format.
	   * @returns {string}
	   */
	  getAriaLabel: _propTypes.default.func,
	
	  /**
	   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the slider.
	   *
	   * @param {number} value The thumb label's value to format.
	   * @param {number} index The thumb label's index to format.
	   * @returns {string}
	   */
	  getAriaValueText: _propTypes.default.func,
	
	  /**
	   * Marks indicate predetermined values to which the user can move the slider.
	   * If `true` the marks will be spaced according the value of the `step` prop.
	   * If an array, it should contain objects with `value` and an optional `label` keys.
	   */
	  marks: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.array]),
	
	  /**
	   * The maximum allowed value of the slider.
	   * Should not be equal to min.
	   */
	  max: _propTypes.default.number,
	
	  /**
	   * The minimum allowed value of the slider.
	   * Should not be equal to max.
	   */
	  min: _propTypes.default.number,
	
	  /**
	   * Name attribute of the hidden `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback function that is fired when the slider's value changed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {number | number[]} value The new value.
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * Callback function that is fired when the `mouseup` is triggered.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {number | number[]} value The new value.
	   */
	  onChangeCommitted: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseDown: _propTypes.default.func,
	
	  /**
	   * The slider orientation.
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']),
	
	  /**
	   * A transformation function, to change the scale of the slider.
	   */
	  scale: _propTypes.default.func,
	
	  /**
	   * The granularity with which the slider can step through values. (A "discrete" slider.)
	   * The `min` prop serves as the origin for the valid values.
	   * We recommend (max - min) to be evenly divisible by the step.
	   *
	   * When step is `null`, the thumb can only be slid onto marks provided with the `marks` prop.
	   */
	  step: _propTypes.default.number,
	
	  /**
	   * The component used to display the value label.
	   */
	  ThumbComponent: _propTypes.default.elementType,
	
	  /**
	   * The track presentation:
	   *
	   * - `normal` the track will render a bar representing the slider value.
	   * - `inverted` the track will render a bar representing the remaining slider value.
	   * - `false` the track will render without a bar.
	   */
	  track: _propTypes.default.oneOf(['normal', false, 'inverted']),
	
	  /**
	   * The value of the slider.
	   * For ranged sliders, provide an array with two values.
	   */
	  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.number)]),
	
	  /**
	   * The value label component.
	   */
	  ValueLabelComponent: _propTypes.default.elementType,
	
	  /**
	   * Controls when the value label is displayed:
	   *
	   * - `auto` the value label will display when the thumb is hovered or focused.
	   * - `on` will display persistently.
	   * - `off` will never display.
	   */
	  valueLabelDisplay: _propTypes.default.oneOf(['on', 'auto', 'off']),
	
	  /**
	   * The format function the value label's value.
	   *
	   * When a function is provided, it should have the following signature:
	   *
	   * - {number} value The value label's value to format
	   * - {number} index The value label's index to format
	   */
	  valueLabelFormat: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSlider'
	})(Slider);
	
	exports.default = _default;

/***/ },
/* 1236 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var styles = function styles(theme) {
	  return {
	    thumb: {
	      '&$open': {
	        '& $offset': {
	          transform: 'scale(1) translateY(-10px)'
	        }
	      }
	    },
	    open: {},
	    offset: (0, _extends2.default)({
	      zIndex: 1
	    }, theme.typography.body2, {
	      fontSize: theme.typography.pxToRem(12),
	      lineHeight: 1.2,
	      transition: theme.transitions.create(['transform'], {
	        duration: theme.transitions.duration.shortest
	      }),
	      top: -34,
	      transformOrigin: 'bottom center',
	      transform: 'scale(0)',
	      position: 'absolute'
	    }),
	    circle: {
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      width: 32,
	      height: 32,
	      borderRadius: '50% 50% 50% 0',
	      backgroundColor: 'currentColor',
	      transform: 'rotate(-45deg)'
	    },
	    label: {
	      color: theme.palette.primary.contrastText,
	      transform: 'rotate(45deg)'
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	function ValueLabel(props) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      open = props.open,
	      value = props.value,
	      valueLabelDisplay = props.valueLabelDisplay;
	
	  if (valueLabelDisplay === 'off') {
	    return children;
	  }
	
	  return /*#__PURE__*/React.cloneElement(children, {
	    className: (0, _clsx.default)(children.props.className, (open || valueLabelDisplay === 'on') && classes.open, classes.thumb)
	  }, /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.offset, className)
	  }, /*#__PURE__*/React.createElement("span", {
	    className: classes.circle
	  }, /*#__PURE__*/React.createElement("span", {
	    className: classes.label
	  }, value))));
	}
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateValueLabel'
	})(ValueLabel);
	
	exports.default = _default;

/***/ },
/* 1237 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Slider.default;
	  }
	});
	
	var _Slider = _interopRequireDefault(__webpack_require__(1235));

/***/ },
/* 1238 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(62));
	
	var _extends8 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _transitions = __webpack_require__(99);
	
	var _ClickAwayListener = _interopRequireDefault(__webpack_require__(576));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(117));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(194));
	
	var _Grow = _interopRequireDefault(__webpack_require__(299));
	
	var _SnackbarContent = _interopRequireDefault(__webpack_require__(404));
	
	var styles = function styles(theme) {
	  var top1 = {
	    top: 8
	  };
	  var bottom1 = {
	    bottom: 8
	  };
	  var right = {
	    justifyContent: 'flex-end'
	  };
	  var left = {
	    justifyContent: 'flex-start'
	  };
	  var top3 = {
	    top: 24
	  };
	  var bottom3 = {
	    bottom: 24
	  };
	  var right3 = {
	    right: 24
	  };
	  var left3 = {
	    left: 24
	  };
	  var center = {
	    left: '50%',
	    right: 'auto',
	    transform: 'translateX(-50%)'
	  };
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      zIndex: theme.zIndex.snackbar,
	      position: 'fixed',
	      display: 'flex',
	      left: 8,
	      right: 8,
	      justifyContent: 'center',
	      alignItems: 'center'
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'center' }}`. */
	    anchorOriginTopCenter: (0, _extends8.default)({}, top1, (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), (0, _extends8.default)({}, top3, center))),
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'center' }}`. */
	    anchorOriginBottomCenter: (0, _extends8.default)({}, bottom1, (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), (0, _extends8.default)({}, bottom3, center))),
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }}`. */
	    anchorOriginTopRight: (0, _extends8.default)({}, top1, right, (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), (0, _extends8.default)({
	      left: 'auto'
	    }, top3, right3))),
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }}`. */
	    anchorOriginBottomRight: (0, _extends8.default)({}, bottom1, right, (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), (0, _extends8.default)({
	      left: 'auto'
	    }, bottom3, right3))),
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }}`. */
	    anchorOriginTopLeft: (0, _extends8.default)({}, top1, left, (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), (0, _extends8.default)({
	      right: 'auto'
	    }, top3, left3))),
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }}`. */
	    anchorOriginBottomLeft: (0, _extends8.default)({}, bottom1, left, (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), (0, _extends8.default)({
	      right: 'auto'
	    }, bottom3, left3)))
	  };
	};
	
	exports.styles = styles;
	var Snackbar = /*#__PURE__*/React.forwardRef(function Snackbar(props, ref) {
	  var action = props.action,
	      _props$anchorOrigin = props.anchorOrigin;
	  _props$anchorOrigin = _props$anchorOrigin === void 0 ? {
	    vertical: 'bottom',
	    horizontal: 'center'
	  } : _props$anchorOrigin;
	  var vertical = _props$anchorOrigin.vertical,
	      horizontal = _props$anchorOrigin.horizontal,
	      _props$autoHideDurati = props.autoHideDuration,
	      autoHideDuration = _props$autoHideDurati === void 0 ? null : _props$autoHideDurati,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      ClickAwayListenerProps = props.ClickAwayListenerProps,
	      ContentProps = props.ContentProps,
	      _props$disableWindowB = props.disableWindowBlurListener,
	      disableWindowBlurListener = _props$disableWindowB === void 0 ? false : _props$disableWindowB,
	      message = props.message,
	      onClose = props.onClose,
	      onEnter = props.onEnter,
	      onEntered = props.onEntered,
	      onEntering = props.onEntering,
	      onExit = props.onExit,
	      onExited = props.onExited,
	      onExiting = props.onExiting,
	      onMouseEnter = props.onMouseEnter,
	      onMouseLeave = props.onMouseLeave,
	      open = props.open,
	      resumeHideDuration = props.resumeHideDuration,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Grow.default : _props$TransitionComp,
	      _props$transitionDura = props.transitionDuration,
	      transitionDuration = _props$transitionDura === void 0 ? {
	    enter: _transitions.duration.enteringScreen,
	    exit: _transitions.duration.leavingScreen
	  } : _props$transitionDura,
	      TransitionProps = props.TransitionProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "anchorOrigin", "autoHideDuration", "children", "classes", "className", "ClickAwayListenerProps", "ContentProps", "disableWindowBlurListener", "message", "onClose", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "onMouseEnter", "onMouseLeave", "open", "resumeHideDuration", "TransitionComponent", "transitionDuration", "TransitionProps"]);
	  var timerAutoHide = React.useRef();
	
	  var _React$useState = React.useState(true),
	      exited = _React$useState[0],
	      setExited = _React$useState[1];
	
	  var handleClose = (0, _useEventCallback.default)(function () {
	    if (onClose) {
	      onClose.apply(void 0, arguments);
	    }
	  });
	  var setAutoHideTimer = (0, _useEventCallback.default)(function (autoHideDurationParam) {
	    if (!onClose || autoHideDurationParam == null) {
	      return;
	    }
	
	    clearTimeout(timerAutoHide.current);
	    timerAutoHide.current = setTimeout(function () {
	      handleClose(null, 'timeout');
	    }, autoHideDurationParam);
	  });
	  React.useEffect(function () {
	    if (open) {
	      setAutoHideTimer(autoHideDuration);
	    }
	
	    return function () {
	      clearTimeout(timerAutoHide.current);
	    };
	  }, [open, autoHideDuration, setAutoHideTimer]); // Pause the timer when the user is interacting with the Snackbar
	  // or when the user hide the window.
	
	  var handlePause = function handlePause() {
	    clearTimeout(timerAutoHide.current);
	  }; // Restart the timer when the user is no longer interacting with the Snackbar
	  // or when the window is shown back.
	
	
	  var handleResume = React.useCallback(function () {
	    if (autoHideDuration != null) {
	      setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
	    }
	  }, [autoHideDuration, resumeHideDuration, setAutoHideTimer]);
	
	  var handleMouseEnter = function handleMouseEnter(event) {
	    if (onMouseEnter) {
	      onMouseEnter(event);
	    }
	
	    handlePause();
	  };
	
	  var handleMouseLeave = function handleMouseLeave(event) {
	    if (onMouseLeave) {
	      onMouseLeave(event);
	    }
	
	    handleResume();
	  };
	
	  var handleClickAway = function handleClickAway(event) {
	    if (onClose) {
	      onClose(event, 'clickaway');
	    }
	  };
	
	  var handleExited = function handleExited() {
	    setExited(true);
	  };
	
	  var handleEnter = function handleEnter() {
	    setExited(false);
	  };
	
	  React.useEffect(function () {
	    if (!disableWindowBlurListener && open) {
	      window.addEventListener('focus', handleResume);
	      window.addEventListener('blur', handlePause);
	      return function () {
	        window.removeEventListener('focus', handleResume);
	        window.removeEventListener('blur', handlePause);
	      };
	    }
	
	    return undefined;
	  }, [disableWindowBlurListener, handleResume, open]); // So we only render active snackbars.
	
	  if (!open && exited) {
	    return null;
	  }
	
	  return /*#__PURE__*/React.createElement(_ClickAwayListener.default, (0, _extends8.default)({
	    onClickAway: handleClickAway
	  }, ClickAwayListenerProps), /*#__PURE__*/React.createElement("div", (0, _extends8.default)({
	    className: (0, _clsx.default)(classes.root, classes["anchorOrigin".concat((0, _capitalize.default)(vertical)).concat((0, _capitalize.default)(horizontal))], className),
	    onMouseEnter: handleMouseEnter,
	    onMouseLeave: handleMouseLeave,
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends8.default)({
	    appear: true,
	    in: open,
	    onEnter: (0, _createChainedFunction.default)(handleEnter, onEnter),
	    onEntered: onEntered,
	    onEntering: onEntering,
	    onExit: onExit,
	    onExited: (0, _createChainedFunction.default)(handleExited, onExited),
	    onExiting: onExiting,
	    timeout: transitionDuration,
	    direction: vertical === 'top' ? 'down' : 'up'
	  }, TransitionProps), children || /*#__PURE__*/React.createElement(_SnackbarContent.default, (0, _extends8.default)({
	    message: message,
	    action: action
	  }, ContentProps)))));
	});
	 false ? Snackbar.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The action to display. It renders after the message, at the end of the snackbar.
	   */
	  action: _propTypes.default.node,
	
	  /**
	   * The anchor of the `Snackbar`.
	   */
	  anchorOrigin: _propTypes.default.shape({
	    horizontal: _propTypes.default.oneOf(['center', 'left', 'right']).isRequired,
	    vertical: _propTypes.default.oneOf(['bottom', 'top']).isRequired
	  }),
	
	  /**
	   * The number of milliseconds to wait before automatically calling the
	   * `onClose` function. `onClose` should then set the state of the `open`
	   * prop to hide the Snackbar. This behavior is disabled by default with
	   * the `null` value.
	   */
	  autoHideDuration: _propTypes.default.number,
	
	  /**
	   * Replace the `SnackbarContent` component.
	   */
	  children: _propTypes.default.element,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Props applied to the `ClickAwayListener` element.
	   */
	  ClickAwayListenerProps: _propTypes.default.object,
	
	  /**
	   * Props applied to the [`SnackbarContent`](/api/snackbar-content/) element.
	   */
	  ContentProps: _propTypes.default.object,
	
	  /**
	   * If `true`, the `autoHideDuration` timer will expire even if the window is not focused.
	   */
	  disableWindowBlurListener: _propTypes.default.bool,
	
	  /**
	   * When displaying multiple consecutive Snackbars from a parent rendering a single
	   * <Snackbar/>, add the key prop to ensure independent treatment of each message.
	   * e.g. <Snackbar key={message} />, otherwise, the message may update-in-place and
	   * features such as autoHideDuration may be canceled.
	   */
	  key: _propTypes.default.any,
	
	  /**
	   * The message to display.
	   */
	  message: _propTypes.default.node,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   * Typically `onClose` is used to set state in the parent component,
	   * which is used to control the `Snackbar` `open` prop.
	   * The `reason` parameter can optionally be used to control the response to `onClose`,
	   * for example ignoring `clickaway`.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {string} reason Can be: `"timeout"` (`autoHideDuration` expired), `"clickaway"`.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired before the transition is entering.
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired when the transition has entered.
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired when the transition is entering.
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired before the transition is exiting.
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired when the transition has exited.
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * Callback fired when the transition is exiting.
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseLeave: _propTypes.default.func,
	
	  /**
	   * If `true`, `Snackbar` is open.
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * The number of milliseconds to wait before dismissing after user interaction.
	   * If `autoHideDuration` prop isn't specified, it does nothing.
	   * If `autoHideDuration` prop is specified but `resumeHideDuration` isn't,
	   * we default to `autoHideDuration / 2` ms.
	   */
	  resumeHideDuration: _propTypes.default.number,
	
	  /**
	   * The component used for the transition.
	   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
	   */
	  TransitionComponent: _propTypes.default.elementType,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
	   */
	  TransitionProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  flip: false,
	  name: 'MuiSnackbar'
	})(Snackbar);
	
	exports.default = _default;

/***/ },
/* 1239 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(62));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _Paper = _interopRequireDefault(__webpack_require__(89));
	
	var _colorManipulator = __webpack_require__(63);
	
	var styles = function styles(theme) {
	  var emphasis = theme.palette.type === 'light' ? 0.8 : 0.98;
	  var backgroundColor = (0, _colorManipulator.emphasize)(theme.palette.background.default, emphasis);
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends3.default)({}, theme.typography.body2, (0, _defineProperty2.default)({
	      color: theme.palette.getContrastText(backgroundColor),
	      backgroundColor: backgroundColor,
	      display: 'flex',
	      alignItems: 'center',
	      flexWrap: 'wrap',
	      padding: '6px 16px',
	      borderRadius: theme.shape.borderRadius,
	      flexGrow: 1
	    }, theme.breakpoints.up('sm'), {
	      flexGrow: 'initial',
	      minWidth: 288
	    })),
	
	    /* Styles applied to the message wrapper element. */
	    message: {
	      padding: '8px 0'
	    },
	
	    /* Styles applied to the action wrapper element if `action` is provided. */
	    action: {
	      display: 'flex',
	      alignItems: 'center',
	      marginLeft: 'auto',
	      paddingLeft: 16,
	      marginRight: -8
	    }
	  };
	};
	
	exports.styles = styles;
	var SnackbarContent = /*#__PURE__*/React.forwardRef(function SnackbarContent(props, ref) {
	  var action = props.action,
	      classes = props.classes,
	      className = props.className,
	      message = props.message,
	      _props$role = props.role,
	      role = _props$role === void 0 ? 'alert' : _props$role,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "classes", "className", "message", "role"]);
	  return /*#__PURE__*/React.createElement(_Paper.default, (0, _extends3.default)({
	    role: role,
	    square: true,
	    elevation: 6,
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("div", {
	    className: classes.message
	  }, message), action ? /*#__PURE__*/React.createElement("div", {
	    className: classes.action
	  }, action) : null);
	});
	 false ? SnackbarContent.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The action to display. It renders after the message, at the end of the snackbar.
	   */
	  action: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The message to display.
	   */
	  message: _propTypes.default.node,
	
	  /**
	   * The ARIA role attribute of the element.
	   */
	  role: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSnackbarContent'
	})(SnackbarContent);
	
	exports.default = _default;

/***/ },
/* 1240 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactIs = __webpack_require__(72);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {},
	
	  /* Styles applied to the root element if `orientation="horizontal"`. */
	  horizontal: {
	    paddingLeft: 8,
	    paddingRight: 8
	  },
	
	  /* Styles applied to the root element if `orientation="vertical"`. */
	  vertical: {},
	
	  /* Styles applied to the root element if `alternativeLabel={true}`. */
	  alternativeLabel: {
	    flex: 1,
	    position: 'relative'
	  },
	
	  /* Pseudo-class applied to the root element if `completed={true}`. */
	  completed: {}
	};
	exports.styles = styles;
	var Step = /*#__PURE__*/React.forwardRef(function Step(props, ref) {
	  var _props$active = props.active,
	      active = _props$active === void 0 ? false : _props$active,
	      alternativeLabel = props.alternativeLabel,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$completed = props.completed,
	      completed = _props$completed === void 0 ? false : _props$completed,
	      connectorProp = props.connector,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$expanded = props.expanded,
	      expanded = _props$expanded === void 0 ? false : _props$expanded,
	      index = props.index,
	      last = props.last,
	      orientation = props.orientation,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "connector", "disabled", "expanded", "index", "last", "orientation"]);
	  var connector = connectorProp ? /*#__PURE__*/React.cloneElement(connectorProp, {
	    orientation: orientation,
	    alternativeLabel: alternativeLabel,
	    index: index,
	    active: active,
	    completed: completed,
	    disabled: disabled
	  }) : null;
	  var newChildren = /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes[orientation], className, alternativeLabel && classes.alternativeLabel, completed && classes.completed),
	    ref: ref
	  }, other), connector && alternativeLabel && index !== 0 ? connector : null, React.Children.map(children, function (child) {
	    if (! /*#__PURE__*/React.isValidElement(child)) {
	      return null;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: The Step component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    return /*#__PURE__*/React.cloneElement(child, (0, _extends2.default)({
	      active: active,
	      alternativeLabel: alternativeLabel,
	      completed: completed,
	      disabled: disabled,
	      expanded: expanded,
	      last: last,
	      icon: index + 1,
	      orientation: orientation
	    }, child.props));
	  }));
	
	  if (connector && !alternativeLabel && index !== 0) {
	    return /*#__PURE__*/React.createElement(React.Fragment, null, connector, newChildren);
	  }
	
	  return newChildren;
	});
	 false ? Step.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Sets the step as active. Is passed to child components.
	   */
	  active: _propTypes.default.bool,
	
	  /**
	   * Should be `Step` sub-components such as `StepLabel`, `StepContent`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Mark the step as completed. Is passed to child components.
	   */
	  completed: _propTypes.default.bool,
	
	  /**
	   * Mark the step as disabled, will also disable the button if
	   * `StepButton` is a child of `Step`. Is passed to child components.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Expand the step.
	   */
	  expanded: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStep'
	})(Step);
	
	exports.default = _default;

/***/ },
/* 1241 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(69));
	
	var _StepLabel = _interopRequireDefault(__webpack_require__(405));
	
	var _isMuiElement = _interopRequireDefault(__webpack_require__(242));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    width: '100%',
	    padding: '24px 16px',
	    margin: '-24px -16px',
	    boxSizing: 'content-box'
	  },
	
	  /* Styles applied to the root element if `orientation="horizontal"`. */
	  horizontal: {},
	
	  /* Styles applied to the root element if `orientation="vertical"`. */
	  vertical: {
	    justifyContent: 'flex-start',
	    padding: '8px',
	    margin: '-8px'
	  },
	
	  /* Styles applied to the `ButtonBase` touch-ripple. */
	  touchRipple: {
	    color: 'rgba(0, 0, 0, 0.3)'
	  }
	};
	exports.styles = styles;
	var StepButton = /*#__PURE__*/React.forwardRef(function StepButton(props, ref) {
	  var active = props.active,
	      alternativeLabel = props.alternativeLabel,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      completed = props.completed,
	      disabled = props.disabled,
	      expanded = props.expanded,
	      icon = props.icon,
	      last = props.last,
	      optional = props.optional,
	      orientation = props.orientation,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "disabled", "expanded", "icon", "last", "optional", "orientation"]);
	  var childProps = {
	    active: active,
	    alternativeLabel: alternativeLabel,
	    completed: completed,
	    disabled: disabled,
	    icon: icon,
	    optional: optional,
	    orientation: orientation
	  };
	  var child = (0, _isMuiElement.default)(children, ['StepLabel']) ? /*#__PURE__*/React.cloneElement(children, childProps) : /*#__PURE__*/React.createElement(_StepLabel.default, childProps, children);
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    focusRipple: true,
	    disabled: disabled,
	    TouchRippleProps: {
	      className: classes.touchRipple
	    },
	    className: (0, _clsx.default)(classes.root, classes[orientation], className),
	    ref: ref
	  }, other), child);
	});
	 false ? StepButton.propTypes = {
	  /**
	   * @ignore
	   * Passed in via `Step` - passed through to `StepLabel`.
	   */
	  active: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * Set internally by Stepper when it's supplied with the alternativeLabel property.
	   */
	  alternativeLabel: _propTypes.default.bool,
	
	  /**
	   * Can be a `StepLabel` or a node to place inside `StepLabel` as children.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   * Sets completed styling. Is passed to StepLabel.
	   */
	  completed: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * Disables the button and sets disabled styling. Is passed to StepLabel.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * potentially passed from parent `Step`
	   */
	  expanded: _propTypes.default.bool,
	
	  /**
	   * The icon displayed by the step label.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  last: _propTypes.default.bool,
	
	  /**
	   * The optional node to display.
	   */
	  optional: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepButton'
	})(StepButton);
	
	exports.default = _default;

/***/ },
/* 1242 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _StepButton.default;
	  }
	});
	
	var _StepButton = _interopRequireDefault(__webpack_require__(1241));

/***/ },
/* 1243 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      flex: '1 1 auto'
	    },
	
	    /* Styles applied to the root element if `orientation="horizontal"`. */
	    horizontal: {},
	
	    /* Styles applied to the root element if `orientation="vertical"`. */
	    vertical: {
	      marginLeft: 12,
	      // half icon
	      padding: '0 0 8px'
	    },
	
	    /* Styles applied to the root element if `alternativeLabel={true}`. */
	    alternativeLabel: {
	      position: 'absolute',
	      top: 8 + 4,
	      left: 'calc(-50% + 20px)',
	      right: 'calc(50% + 20px)'
	    },
	
	    /* Pseudo-class applied to the root element if `active={true}`. */
	    active: {},
	
	    /* Pseudo-class applied to the root element if `completed={true}`. */
	    completed: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the line element. */
	    line: {
	      display: 'block',
	      borderColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
	    },
	
	    /* Styles applied to the root element if `orientation="horizontal"`. */
	    lineHorizontal: {
	      borderTopStyle: 'solid',
	      borderTopWidth: 1
	    },
	
	    /* Styles applied to the root element if `orientation="vertical"`. */
	    lineVertical: {
	      borderLeftStyle: 'solid',
	      borderLeftWidth: 1,
	      minHeight: 24
	    }
	  };
	};
	
	exports.styles = styles;
	var StepConnector = /*#__PURE__*/React.forwardRef(function StepConnector(props, ref) {
	  var active = props.active,
	      _props$alternativeLab = props.alternativeLabel,
	      alternativeLabel = _props$alternativeLab === void 0 ? false : _props$alternativeLab,
	      classes = props.classes,
	      className = props.className,
	      completed = props.completed,
	      disabled = props.disabled,
	      index = props.index,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "classes", "className", "completed", "disabled", "index", "orientation"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes[orientation], className, alternativeLabel && classes.alternativeLabel, active && classes.active, completed && classes.completed, disabled && classes.disabled),
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.line, {
	      'horizontal': classes.lineHorizontal,
	      'vertical': classes.lineVertical
	    }[orientation])
	  }));
	});
	 false ? StepConnector.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepConnector'
	})(StepConnector);
	
	exports.default = _default;

/***/ },
/* 1244 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _Collapse = _interopRequireDefault(__webpack_require__(296));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      marginTop: 8,
	      marginLeft: 12,
	      // half icon
	      paddingLeft: 8 + 12,
	      // margin + half icon
	      paddingRight: 8,
	      borderLeft: "1px solid ".concat(theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600])
	    },
	
	    /* Styles applied to the root element if `last={true}` (controlled by `Step`). */
	    last: {
	      borderLeft: 'none'
	    },
	
	    /* Styles applied to the Transition component. */
	    transition: {}
	  };
	};
	
	exports.styles = styles;
	var StepContent = /*#__PURE__*/React.forwardRef(function StepContent(props, ref) {
	  var active = props.active,
	      alternativeLabel = props.alternativeLabel,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      completed = props.completed,
	      expanded = props.expanded,
	      last = props.last,
	      optional = props.optional,
	      orientation = props.orientation,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Collapse.default : _props$TransitionComp,
	      _props$transitionDura = props.transitionDuration,
	      transitionDurationProp = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
	      TransitionProps = props.TransitionProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "expanded", "last", "optional", "orientation", "TransitionComponent", "transitionDuration", "TransitionProps"]);
	
	  if (false) {
	    if (orientation !== 'vertical') {
	      console.error('Material-UI: <StepContent /> is only designed for use with the vertical stepper.');
	    }
	  }
	
	  var transitionDuration = transitionDurationProp;
	
	  if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
	    transitionDuration = undefined;
	  }
	
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, last && classes.last),
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    in: active || expanded,
	    className: classes.transition,
	    timeout: transitionDuration,
	    unmountOnExit: true
	  }, TransitionProps), children));
	});
	 false ? StepContent.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Step content.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the transition.
	   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
	   */
	  TransitionComponent: _propTypes.default.elementType,
	
	  /**
	   * Adjust the duration of the content expand transition.
	   * Passed as a prop to the transition component.
	   *
	   * Set to 'auto' to automatically calculate transition time based on height.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.oneOf(['auto']), _propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
	   */
	  TransitionProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepContent'
	})(StepContent);
	
	exports.default = _default;

/***/ },
/* 1245 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _StepContent.default;
	  }
	});
	
	var _StepContent = _interopRequireDefault(__webpack_require__(1244));

/***/ },
/* 1246 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _CheckCircle = _interopRequireDefault(__webpack_require__(1305));
	
	var _Warning = _interopRequireDefault(__webpack_require__(1311));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(308));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'block',
	      color: theme.palette.text.disabled,
	      '&$completed': {
	        color: theme.palette.primary.main
	      },
	      '&$active': {
	        color: theme.palette.primary.main
	      },
	      '&$error': {
	        color: theme.palette.error.main
	      }
	    },
	
	    /* Styles applied to the SVG text element. */
	    text: {
	      fill: theme.palette.primary.contrastText,
	      fontSize: theme.typography.caption.fontSize,
	      fontFamily: theme.typography.fontFamily
	    },
	
	    /* Pseudo-class applied to the root element if `active={true}`. */
	    active: {},
	
	    /* Pseudo-class applied to the root element if `completed={true}`. */
	    completed: {},
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {}
	  };
	};
	
	exports.styles = styles;
	
	var _ref = /*#__PURE__*/React.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "12"
	});
	
	var StepIcon = /*#__PURE__*/React.forwardRef(function StepIcon(props, ref) {
	  var _props$completed = props.completed,
	      completed = _props$completed === void 0 ? false : _props$completed,
	      icon = props.icon,
	      _props$active = props.active,
	      active = _props$active === void 0 ? false : _props$active,
	      _props$error = props.error,
	      error = _props$error === void 0 ? false : _props$error,
	      classes = props.classes;
	
	  if (typeof icon === 'number' || typeof icon === 'string') {
	    var className = (0, _clsx.default)(classes.root, active && classes.active, error && classes.error, completed && classes.completed);
	
	    if (error) {
	      return /*#__PURE__*/React.createElement(_Warning.default, {
	        className: className,
	        ref: ref
	      });
	    }
	
	    if (completed) {
	      return /*#__PURE__*/React.createElement(_CheckCircle.default, {
	        className: className,
	        ref: ref
	      });
	    }
	
	    return /*#__PURE__*/React.createElement(_SvgIcon.default, {
	      className: className,
	      ref: ref
	    }, _ref, /*#__PURE__*/React.createElement("text", {
	      className: classes.text,
	      x: "12",
	      y: "16",
	      textAnchor: "middle"
	    }, icon));
	  }
	
	  return icon;
	});
	 false ? StepIcon.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Whether this step is active.
	   */
	  active: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * Mark the step as completed. Is passed to child components.
	   */
	  completed: _propTypes.default.bool,
	
	  /**
	   * Mark the step as failed.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * The label displayed in the step icon.
	   */
	  icon: _propTypes.default.node
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepIcon'
	})(StepIcon);
	
	exports.default = _default;

/***/ },
/* 1247 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _Typography = _interopRequireDefault(__webpack_require__(75));
	
	var _StepIcon = _interopRequireDefault(__webpack_require__(602));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'flex',
	      alignItems: 'center',
	      '&$alternativeLabel': {
	        flexDirection: 'column'
	      },
	      '&$disabled': {
	        cursor: 'default'
	      }
	    },
	
	    /* Styles applied to the root element if `orientation="horizontal"`. */
	    horizontal: {},
	
	    /* Styles applied to the root element if `orientation="vertical"`. */
	    vertical: {},
	
	    /* Styles applied to the `Typography` component which wraps `children`. */
	    label: {
	      color: theme.palette.text.secondary,
	      '&$active': {
	        color: theme.palette.text.primary,
	        fontWeight: 500
	      },
	      '&$completed': {
	        color: theme.palette.text.primary,
	        fontWeight: 500
	      },
	      '&$alternativeLabel': {
	        textAlign: 'center',
	        marginTop: 16
	      },
	      '&$error': {
	        color: theme.palette.error.main
	      }
	    },
	
	    /* Pseudo-class applied to the `Typography` component if `active={true}`. */
	    active: {},
	
	    /* Pseudo-class applied to the `Typography` component if `completed={true}`. */
	    completed: {},
	
	    /* Pseudo-class applied to the root element and `Typography` component if `error={true}`. */
	    error: {},
	
	    /* Pseudo-class applied to the root element and `Typography` component if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the `icon` container element. */
	    iconContainer: {
	      flexShrink: 0,
	      // Fix IE 11 issue
	      display: 'flex',
	      paddingRight: 8,
	      '&$alternativeLabel': {
	        paddingRight: 0
	      }
	    },
	
	    /* Pseudo-class applied to the root and icon container and `Typography` if `alternativeLabel={true}`. */
	    alternativeLabel: {},
	
	    /* Styles applied to the container element which wraps `Typography` and `optional`. */
	    labelContainer: {
	      width: '100%'
	    }
	  };
	};
	
	exports.styles = styles;
	var StepLabel = /*#__PURE__*/React.forwardRef(function StepLabel(props, ref) {
	  var _props$active = props.active,
	      active = _props$active === void 0 ? false : _props$active,
	      _props$alternativeLab = props.alternativeLabel,
	      alternativeLabel = _props$alternativeLab === void 0 ? false : _props$alternativeLab,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$completed = props.completed,
	      completed = _props$completed === void 0 ? false : _props$completed,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$error = props.error,
	      error = _props$error === void 0 ? false : _props$error,
	      expanded = props.expanded,
	      icon = props.icon,
	      last = props.last,
	      optional = props.optional,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      StepIconComponentProp = props.StepIconComponent,
	      StepIconProps = props.StepIconProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "disabled", "error", "expanded", "icon", "last", "optional", "orientation", "StepIconComponent", "StepIconProps"]);
	  var StepIconComponent = StepIconComponentProp;
	
	  if (icon && !StepIconComponent) {
	    StepIconComponent = _StepIcon.default;
	  }
	
	  return /*#__PURE__*/React.createElement("span", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes[orientation], className, disabled && classes.disabled, alternativeLabel && classes.alternativeLabel, error && classes.error),
	    ref: ref
	  }, other), icon || StepIconComponent ? /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.iconContainer, alternativeLabel && classes.alternativeLabel)
	  }, /*#__PURE__*/React.createElement(StepIconComponent, (0, _extends2.default)({
	    completed: completed,
	    active: active,
	    error: error,
	    icon: icon
	  }, StepIconProps))) : null, /*#__PURE__*/React.createElement("span", {
	    className: classes.labelContainer
	  }, children ? /*#__PURE__*/React.createElement(_Typography.default, {
	    variant: "body2",
	    component: "span",
	    display: "block",
	    className: (0, _clsx.default)(classes.label, alternativeLabel && classes.alternativeLabel, completed && classes.completed, active && classes.active, error && classes.error)
	  }, children) : null, optional));
	});
	 false ? StepLabel.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * In most cases will simply be a string containing a title for the label.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Mark the step as disabled, will also disable the button if
	   * `StepLabelButton` is a child of `StepLabel`. Is passed to child components.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Mark the step as failed.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * Override the default label of the step icon.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * The optional node to display.
	   */
	  optional: _propTypes.default.node,
	
	  /**
	   * The component to render in place of the [`StepIcon`](/api/step-icon/).
	   */
	  StepIconComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the [`StepIcon`](/api/step-icon/) element.
	   */
	  StepIconProps: _propTypes.default.object
	} : void 0;
	StepLabel.muiName = 'StepLabel';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepLabel'
	})(StepLabel);
	
	exports.default = _default;

/***/ },
/* 1248 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _Paper = _interopRequireDefault(__webpack_require__(89));
	
	var _StepConnector = _interopRequireDefault(__webpack_require__(601));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    padding: 24
	  },
	
	  /* Styles applied to the root element if `orientation="horizontal"`. */
	  horizontal: {
	    flexDirection: 'row',
	    alignItems: 'center'
	  },
	
	  /* Styles applied to the root element if `orientation="vertical"`. */
	  vertical: {
	    flexDirection: 'column'
	  },
	
	  /* Styles applied to the root element if `alternativeLabel={true}`. */
	  alternativeLabel: {
	    alignItems: 'flex-start'
	  }
	};
	exports.styles = styles;
	var defaultConnector = /*#__PURE__*/React.createElement(_StepConnector.default, null);
	var Stepper = /*#__PURE__*/React.forwardRef(function Stepper(props, ref) {
	  var _props$activeStep = props.activeStep,
	      activeStep = _props$activeStep === void 0 ? 0 : _props$activeStep,
	      _props$alternativeLab = props.alternativeLabel,
	      alternativeLabel = _props$alternativeLab === void 0 ? false : _props$alternativeLab,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$connector = props.connector,
	      connectorProp = _props$connector === void 0 ? defaultConnector : _props$connector,
	      _props$nonLinear = props.nonLinear,
	      nonLinear = _props$nonLinear === void 0 ? false : _props$nonLinear,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      other = (0, _objectWithoutProperties2.default)(props, ["activeStep", "alternativeLabel", "children", "classes", "className", "connector", "nonLinear", "orientation"]);
	  var connector = /*#__PURE__*/React.isValidElement(connectorProp) ? /*#__PURE__*/React.cloneElement(connectorProp, {
	    orientation: orientation
	  }) : null;
	  var childrenArray = React.Children.toArray(children);
	  var steps = childrenArray.map(function (step, index) {
	    var state = {
	      index: index,
	      active: false,
	      completed: false,
	      disabled: false
	    };
	
	    if (activeStep === index) {
	      state.active = true;
	    } else if (!nonLinear && activeStep > index) {
	      state.completed = true;
	    } else if (!nonLinear && activeStep < index) {
	      state.disabled = true;
	    }
	
	    return /*#__PURE__*/React.cloneElement(step, (0, _extends2.default)({
	      alternativeLabel: alternativeLabel,
	      connector: connector,
	      last: index + 1 === childrenArray.length,
	      orientation: orientation
	    }, state, step.props));
	  });
	  return /*#__PURE__*/React.createElement(_Paper.default, (0, _extends2.default)({
	    square: true,
	    elevation: 0,
	    className: (0, _clsx.default)(classes.root, classes[orientation], className, alternativeLabel && classes.alternativeLabel),
	    ref: ref
	  }, other), steps);
	});
	 false ? Stepper.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Set the active step (zero based index).
	   * Set to -1 to disable all the steps.
	   */
	  activeStep: _propTypes.default.number,
	
	  /**
	   * If set to 'true' and orientation is horizontal,
	   * then the step label will be positioned under the icon.
	   */
	  alternativeLabel: _propTypes.default.bool,
	
	  /**
	   * Two or more `<Step />` components.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * An element to be placed between each step.
	   */
	  connector: _propTypes.default.element,
	
	  /**
	   * If set the `Stepper` will not assist in controlling steps for linear flow.
	   */
	  nonLinear: _propTypes.default.bool,
	
	  /**
	   * The stepper orientation (layout flow direction).
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepper'
	})(Stepper);
	
	exports.default = _default;

/***/ },
/* 1249 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      userSelect: 'none',
	      width: '1em',
	      height: '1em',
	      display: 'inline-block',
	      fill: 'currentColor',
	      flexShrink: 0,
	      fontSize: theme.typography.pxToRem(24),
	      transition: theme.transitions.create('fill', {
	        duration: theme.transitions.duration.shorter
	      })
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the root element if `color="action"`. */
	    colorAction: {
	      color: theme.palette.action.active
	    },
	
	    /* Styles applied to the root element if `color="error"`. */
	    colorError: {
	      color: theme.palette.error.main
	    },
	
	    /* Styles applied to the root element if `color="disabled"`. */
	    colorDisabled: {
	      color: theme.palette.action.disabled
	    },
	
	    /* Styles applied to the root element if `fontSize="inherit"`. */
	    fontSizeInherit: {
	      fontSize: 'inherit'
	    },
	
	    /* Styles applied to the root element if `fontSize="small"`. */
	    fontSizeSmall: {
	      fontSize: theme.typography.pxToRem(20)
	    },
	
	    /* Styles applied to the root element if `fontSize="large"`. */
	    fontSizeLarge: {
	      fontSize: theme.typography.pxToRem(35)
	    }
	  };
	};
	
	exports.styles = styles;
	var SvgIcon = /*#__PURE__*/React.forwardRef(function SvgIcon(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'inherit' : _props$color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'svg' : _props$component,
	      _props$fontSize = props.fontSize,
	      fontSize = _props$fontSize === void 0 ? 'default' : _props$fontSize,
	      htmlColor = props.htmlColor,
	      titleAccess = props.titleAccess,
	      _props$viewBox = props.viewBox,
	      viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, color !== 'inherit' && classes["color".concat((0, _capitalize.default)(color))], fontSize !== 'default' && classes["fontSize".concat((0, _capitalize.default)(fontSize))]),
	    focusable: "false",
	    viewBox: viewBox,
	    color: htmlColor,
	    "aria-hidden": titleAccess ? undefined : true,
	    role: titleAccess ? 'img' : undefined,
	    ref: ref
	  }, other), children, titleAccess ? /*#__PURE__*/React.createElement("title", null, titleAccess) : null);
	});
	 false ? SvgIcon.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Node passed into the SVG element.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
	   */
	  color: _propTypes.default.oneOf(['action', 'disabled', 'error', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
	   */
	  fontSize: _propTypes.default.oneOf(['default', 'inherit', 'large', 'small']),
	
	  /**
	   * Applies a color attribute to the SVG element.
	   */
	  htmlColor: _propTypes.default.string,
	
	  /**
	   * The shape-rendering attribute. The behavior of the different options is described on the
	   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
	   * If you are having issues with blurry icons you should investigate this property.
	   */
	  shapeRendering: _propTypes.default.string,
	
	  /**
	   * Provides a human-readable title for the element that contains it.
	   * https://www.w3.org/TR/SVG-access/#Equivalent
	   */
	  titleAccess: _propTypes.default.string,
	
	  /**
	   * Allows you to redefine what the coordinates without units mean inside an SVG element.
	   * For example, if the SVG element is 500 (width) by 200 (height),
	   * and you pass viewBox="0 0 50 20",
	   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
	   * to bottom right (50,20) and each unit will be worth 10px.
	   */
	  viewBox: _propTypes.default.string
	} : void 0;
	SvgIcon.muiName = 'SvgIcon';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSvgIcon'
	})(SvgIcon);
	
	exports.default = _default;

/***/ },
/* 1250 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(62));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var _Drawer = __webpack_require__(395);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'fixed',
	      top: 0,
	      left: 0,
	      bottom: 0,
	      zIndex: theme.zIndex.drawer - 1
	    },
	    anchorLeft: {
	      right: 'auto'
	    },
	    anchorRight: {
	      left: 'auto',
	      right: 0
	    },
	    anchorTop: {
	      bottom: 'auto',
	      right: 0
	    },
	    anchorBottom: {
	      top: 'auto',
	      bottom: 0,
	      right: 0
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	exports.styles = styles;
	var SwipeArea = /*#__PURE__*/React.forwardRef(function SwipeArea(props, ref) {
	  var anchor = props.anchor,
	      classes = props.classes,
	      className = props.className,
	      width = props.width,
	      other = (0, _objectWithoutProperties2.default)(props, ["anchor", "classes", "className", "width"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes["anchor".concat((0, _capitalize.default)(anchor))], className),
	    ref: ref,
	    style: (0, _defineProperty2.default)({}, (0, _Drawer.isHorizontal)(anchor) ? 'width' : 'height', width)
	  }, other));
	});
	 false ? SwipeArea.propTypes = {
	  /**
	   * Side on which to attach the discovery area.
	   */
	  anchor: _propTypes.default.oneOf(['left', 'top', 'right', 'bottom']).isRequired,
	
	  /**
	   * @ignore
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The width of the left most (or right most) area in pixels where the
	   * drawer can be swiped open from.
	   */
	  width: _propTypes.default.number.isRequired
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateSwipeArea'
	})(SwipeArea);
	
	exports.default = _default;

/***/ },
/* 1251 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.reset = reset;
	exports.default = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(51));
	
	var _utils = __webpack_require__(19);
	
	var _styles = __webpack_require__(76);
	
	var _Drawer = _interopRequireWildcard(__webpack_require__(395));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(90));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(117));
	
	var _transitions = __webpack_require__(99);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(59));
	
	var _utils2 = __webpack_require__(193);
	
	var _NoSsr = _interopRequireDefault(__webpack_require__(595));
	
	var _SwipeArea = _interopRequireDefault(__webpack_require__(1250));
	
	// This value is closed to what browsers are using internally to
	// trigger a native scroll.
	var UNCERTAINTY_THRESHOLD = 3; // px
	// We can only have one node at the time claiming ownership for handling the swipe.
	// Otherwise, the UX would be confusing.
	// That's why we use a singleton here.
	
	var nodeThatClaimedTheSwipe = null; // Exported for test purposes.
	
	function reset() {
	  nodeThatClaimedTheSwipe = null;
	}
	
	function calculateCurrentX(anchor, touches) {
	  return anchor === 'right' ? document.body.offsetWidth - touches[0].pageX : touches[0].pageX;
	}
	
	function calculateCurrentY(anchor, touches) {
	  return anchor === 'bottom' ? window.innerHeight - touches[0].clientY : touches[0].clientY;
	}
	
	function getMaxTranslate(horizontalSwipe, paperInstance) {
	  return horizontalSwipe ? paperInstance.clientWidth : paperInstance.clientHeight;
	}
	
	function getTranslate(currentTranslate, startLocation, open, maxTranslate) {
	  return Math.min(Math.max(open ? startLocation - currentTranslate : maxTranslate + startLocation - currentTranslate, 0), maxTranslate);
	}
	
	function getDomTreeShapes(element, rootNode) {
	  // Adapted from https://github.com/oliviertassinari/react-swipeable-views/blob/7666de1dba253b896911adf2790ce51467670856/packages/react-swipeable-views/src/SwipeableViews.js#L129
	  var domTreeShapes = [];
	
	  while (element && element !== rootNode) {
	    var style = window.getComputedStyle(element);
	
	    if ( // Ignore the scroll children if the element is absolute positioned.
	    style.getPropertyValue('position') === 'absolute' || // Ignore the scroll children if the element has an overflowX hidden
	    style.getPropertyValue('overflow-x') === 'hidden') {
	      domTreeShapes = [];
	    } else if (element.clientWidth > 0 && element.scrollWidth > element.clientWidth || element.clientHeight > 0 && element.scrollHeight > element.clientHeight) {
	      // Ignore the nodes that have no width.
	      // Keep elements with a scroll
	      domTreeShapes.push(element);
	    }
	
	    element = element.parentElement;
	  }
	
	  return domTreeShapes;
	}
	
	function findNativeHandler(_ref) {
	  var domTreeShapes = _ref.domTreeShapes,
	      start = _ref.start,
	      current = _ref.current,
	      anchor = _ref.anchor;
	  // Adapted from https://github.com/oliviertassinari/react-swipeable-views/blob/7666de1dba253b896911adf2790ce51467670856/packages/react-swipeable-views/src/SwipeableViews.js#L175
	  var axisProperties = {
	    scrollPosition: {
	      x: 'scrollLeft',
	      y: 'scrollTop'
	    },
	    scrollLength: {
	      x: 'scrollWidth',
	      y: 'scrollHeight'
	    },
	    clientLength: {
	      x: 'clientWidth',
	      y: 'clientHeight'
	    }
	  };
	  return domTreeShapes.some(function (shape) {
	    // Determine if we are going backward or forward.
	    var goingForward = current >= start;
	
	    if (anchor === 'top' || anchor === 'left') {
	      goingForward = !goingForward;
	    }
	
	    var axis = anchor === 'left' || anchor === 'right' ? 'x' : 'y';
	    var scrollPosition = shape[axisProperties.scrollPosition[axis]];
	    var areNotAtStart = scrollPosition > 0;
	    var areNotAtEnd = scrollPosition + shape[axisProperties.clientLength[axis]] < shape[axisProperties.scrollLength[axis]];
	
	    if (goingForward && areNotAtEnd || !goingForward && areNotAtStart) {
	      return shape;
	    }
	
	    return null;
	  });
	}
	
	var iOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);
	var transitionDurationDefault = {
	  enter: _transitions.duration.enteringScreen,
	  exit: _transitions.duration.leavingScreen
	};
	var useEnhancedEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
	var SwipeableDrawer = /*#__PURE__*/React.forwardRef(function SwipeableDrawer(inProps, ref) {
	  var theme = (0, _useTheme.default)();
	  var props = (0, _styles.getThemeProps)({
	    name: 'MuiSwipeableDrawer',
	    props: (0, _extends2.default)({}, inProps),
	    theme: theme
	  });
	  var _props$anchor = props.anchor,
	      anchor = _props$anchor === void 0 ? 'left' : _props$anchor,
	      _props$disableBackdro = props.disableBackdropTransition,
	      disableBackdropTransition = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
	      _props$disableDiscove = props.disableDiscovery,
	      disableDiscovery = _props$disableDiscove === void 0 ? false : _props$disableDiscove,
	      _props$disableSwipeTo = props.disableSwipeToOpen,
	      disableSwipeToOpen = _props$disableSwipeTo === void 0 ? iOS : _props$disableSwipeTo,
	      hideBackdrop = props.hideBackdrop,
	      _props$hysteresis = props.hysteresis,
	      hysteresis = _props$hysteresis === void 0 ? 0.52 : _props$hysteresis,
	      _props$minFlingVeloci = props.minFlingVelocity,
	      minFlingVelocity = _props$minFlingVeloci === void 0 ? 450 : _props$minFlingVeloci,
	      _props$ModalProps = props.ModalProps;
	  _props$ModalProps = _props$ModalProps === void 0 ? {} : _props$ModalProps;
	  var BackdropProps = _props$ModalProps.BackdropProps,
	      ModalPropsProp = (0, _objectWithoutProperties2.default)(_props$ModalProps, ["BackdropProps"]),
	      onClose = props.onClose,
	      onOpen = props.onOpen,
	      open = props.open,
	      _props$PaperProps = props.PaperProps,
	      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
	      SwipeAreaProps = props.SwipeAreaProps,
	      _props$swipeAreaWidth = props.swipeAreaWidth,
	      swipeAreaWidth = _props$swipeAreaWidth === void 0 ? 20 : _props$swipeAreaWidth,
	      _props$transitionDura = props.transitionDuration,
	      transitionDuration = _props$transitionDura === void 0 ? transitionDurationDefault : _props$transitionDura,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'temporary' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["anchor", "disableBackdropTransition", "disableDiscovery", "disableSwipeToOpen", "hideBackdrop", "hysteresis", "minFlingVelocity", "ModalProps", "onClose", "onOpen", "open", "PaperProps", "SwipeAreaProps", "swipeAreaWidth", "transitionDuration", "variant"]);
	
	  var _React$useState = React.useState(false),
	      maybeSwiping = _React$useState[0],
	      setMaybeSwiping = _React$useState[1];
	
	  var swipeInstance = React.useRef({
	    isSwiping: null
	  });
	  var swipeAreaRef = React.useRef();
	  var backdropRef = React.useRef();
	  var paperRef = React.useRef();
	  var touchDetected = React.useRef(false); // Ref for transition duration based on / to match swipe speed
	
	  var calculatedDurationRef = React.useRef(); // Use a ref so the open value used is always up to date inside useCallback.
	
	  useEnhancedEffect(function () {
	    calculatedDurationRef.current = null;
	  }, [open]);
	  var setPosition = React.useCallback(function (translate) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _options$mode = options.mode,
	        mode = _options$mode === void 0 ? null : _options$mode,
	        _options$changeTransi = options.changeTransition,
	        changeTransition = _options$changeTransi === void 0 ? true : _options$changeTransi;
	    var anchorRtl = (0, _Drawer.getAnchor)(theme, anchor);
	    var rtlTranslateMultiplier = ['right', 'bottom'].indexOf(anchorRtl) !== -1 ? 1 : -1;
	    var horizontalSwipe = (0, _Drawer.isHorizontal)(anchor);
	    var transform = horizontalSwipe ? "translate(".concat(rtlTranslateMultiplier * translate, "px, 0)") : "translate(0, ".concat(rtlTranslateMultiplier * translate, "px)");
	    var drawerStyle = paperRef.current.style;
	    drawerStyle.webkitTransform = transform;
	    drawerStyle.transform = transform;
	    var transition = '';
	
	    if (mode) {
	      transition = theme.transitions.create('all', (0, _utils2.getTransitionProps)({
	        timeout: transitionDuration
	      }, {
	        mode: mode
	      }));
	    }
	
	    if (changeTransition) {
	      drawerStyle.webkitTransition = transition;
	      drawerStyle.transition = transition;
	    }
	
	    if (!disableBackdropTransition && !hideBackdrop) {
	      var backdropStyle = backdropRef.current.style;
	      backdropStyle.opacity = 1 - translate / getMaxTranslate(horizontalSwipe, paperRef.current);
	
	      if (changeTransition) {
	        backdropStyle.webkitTransition = transition;
	        backdropStyle.transition = transition;
	      }
	    }
	  }, [anchor, disableBackdropTransition, hideBackdrop, theme, transitionDuration]);
	  var handleBodyTouchEnd = (0, _useEventCallback.default)(function (event) {
	    if (!touchDetected.current) {
	      return;
	    }
	
	    nodeThatClaimedTheSwipe = null;
	    touchDetected.current = false;
	    setMaybeSwiping(false); // The swipe wasn't started.
	
	    if (!swipeInstance.current.isSwiping) {
	      swipeInstance.current.isSwiping = null;
	      return;
	    }
	
	    swipeInstance.current.isSwiping = null;
	    var anchorRtl = (0, _Drawer.getAnchor)(theme, anchor);
	    var horizontal = (0, _Drawer.isHorizontal)(anchor);
	    var current;
	
	    if (horizontal) {
	      current = calculateCurrentX(anchorRtl, event.changedTouches);
	    } else {
	      current = calculateCurrentY(anchorRtl, event.changedTouches);
	    }
	
	    var startLocation = horizontal ? swipeInstance.current.startX : swipeInstance.current.startY;
	    var maxTranslate = getMaxTranslate(horizontal, paperRef.current);
	    var currentTranslate = getTranslate(current, startLocation, open, maxTranslate);
	    var translateRatio = currentTranslate / maxTranslate;
	
	    if (Math.abs(swipeInstance.current.velocity) > minFlingVelocity) {
	      // Calculate transition duration to match swipe speed
	      calculatedDurationRef.current = Math.abs((maxTranslate - currentTranslate) / swipeInstance.current.velocity) * 1000;
	    }
	
	    if (open) {
	      if (swipeInstance.current.velocity > minFlingVelocity || translateRatio > hysteresis) {
	        onClose();
	      } else {
	        // Reset the position, the swipe was aborted.
	        setPosition(0, {
	          mode: 'exit'
	        });
	      }
	
	      return;
	    }
	
	    if (swipeInstance.current.velocity < -minFlingVelocity || 1 - translateRatio > hysteresis) {
	      onOpen();
	    } else {
	      // Reset the position, the swipe was aborted.
	      setPosition(getMaxTranslate(horizontal, paperRef.current), {
	        mode: 'enter'
	      });
	    }
	  });
	  var handleBodyTouchMove = (0, _useEventCallback.default)(function (event) {
	    // the ref may be null when a parent component updates while swiping
	    if (!paperRef.current || !touchDetected.current) {
	      return;
	    } // We are not supposed to handle this touch move because the swipe was started in a scrollable container in the drawer
	
	
	    if (nodeThatClaimedTheSwipe != null && nodeThatClaimedTheSwipe !== swipeInstance.current) {
	      return;
	    }
	
	    var anchorRtl = (0, _Drawer.getAnchor)(theme, anchor);
	    var horizontalSwipe = (0, _Drawer.isHorizontal)(anchor);
	    var currentX = calculateCurrentX(anchorRtl, event.touches);
	    var currentY = calculateCurrentY(anchorRtl, event.touches);
	
	    if (open && paperRef.current.contains(event.target) && nodeThatClaimedTheSwipe == null) {
	      var domTreeShapes = getDomTreeShapes(event.target, paperRef.current);
	      var nativeHandler = findNativeHandler({
	        domTreeShapes: domTreeShapes,
	        start: horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY,
	        current: horizontalSwipe ? currentX : currentY,
	        anchor: anchor
	      });
	
	      if (nativeHandler) {
	        nodeThatClaimedTheSwipe = nativeHandler;
	        return;
	      }
	
	      nodeThatClaimedTheSwipe = swipeInstance.current;
	    } // We don't know yet.
	
	
	    if (swipeInstance.current.isSwiping == null) {
	      var dx = Math.abs(currentX - swipeInstance.current.startX);
	      var dy = Math.abs(currentY - swipeInstance.current.startY); // We are likely to be swiping, let's prevent the scroll event on iOS.
	
	      if (dx > dy) {
	        if (event.cancelable) {
	          event.preventDefault();
	        }
	      }
	
	      var definitelySwiping = horizontalSwipe ? dx > dy && dx > UNCERTAINTY_THRESHOLD : dy > dx && dy > UNCERTAINTY_THRESHOLD;
	
	      if (definitelySwiping === true || (horizontalSwipe ? dy > UNCERTAINTY_THRESHOLD : dx > UNCERTAINTY_THRESHOLD)) {
	        swipeInstance.current.isSwiping = definitelySwiping;
	
	        if (!definitelySwiping) {
	          handleBodyTouchEnd(event);
	          return;
	        } // Shift the starting point.
	
	
	        swipeInstance.current.startX = currentX;
	        swipeInstance.current.startY = currentY; // Compensate for the part of the drawer displayed on touch start.
	
	        if (!disableDiscovery && !open) {
	          if (horizontalSwipe) {
	            swipeInstance.current.startX -= swipeAreaWidth;
	          } else {
	            swipeInstance.current.startY -= swipeAreaWidth;
	          }
	        }
	      }
	    }
	
	    if (!swipeInstance.current.isSwiping) {
	      return;
	    }
	
	    var maxTranslate = getMaxTranslate(horizontalSwipe, paperRef.current);
	    var startLocation = horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY;
	
	    if (open && !swipeInstance.current.paperHit) {
	      startLocation = Math.min(startLocation, maxTranslate);
	    }
	
	    var translate = getTranslate(horizontalSwipe ? currentX : currentY, startLocation, open, maxTranslate);
	
	    if (open) {
	      if (!swipeInstance.current.paperHit) {
	        var paperHit = horizontalSwipe ? currentX < maxTranslate : currentY < maxTranslate;
	
	        if (paperHit) {
	          swipeInstance.current.paperHit = true;
	          swipeInstance.current.startX = currentX;
	          swipeInstance.current.startY = currentY;
	        } else {
	          return;
	        }
	      } else if (translate === 0) {
	        swipeInstance.current.startX = currentX;
	        swipeInstance.current.startY = currentY;
	      }
	    }
	
	    if (swipeInstance.current.lastTranslate === null) {
	      swipeInstance.current.lastTranslate = translate;
	      swipeInstance.current.lastTime = performance.now() + 1;
	    }
	
	    var velocity = (translate - swipeInstance.current.lastTranslate) / (performance.now() - swipeInstance.current.lastTime) * 1e3; // Low Pass filter.
	
	    swipeInstance.current.velocity = swipeInstance.current.velocity * 0.4 + velocity * 0.6;
	    swipeInstance.current.lastTranslate = translate;
	    swipeInstance.current.lastTime = performance.now(); // We are swiping, let's prevent the scroll event on iOS.
	
	    if (event.cancelable) {
	      event.preventDefault();
	    }
	
	    setPosition(translate);
	  });
	  var handleBodyTouchStart = (0, _useEventCallback.default)(function (event) {
	    // We are not supposed to handle this touch move.
	    // Example of use case: ignore the event if there is a Slider.
	    if (event.defaultPrevented) {
	      return;
	    } // We can only have one node at the time claiming ownership for handling the swipe.
	
	
	    if (event.muiHandled) {
	      return;
	    } // At least one element clogs the drawer interaction zone.
	
	
	    if (open && !backdropRef.current.contains(event.target) && !paperRef.current.contains(event.target)) {
	      return;
	    }
	
	    var anchorRtl = (0, _Drawer.getAnchor)(theme, anchor);
	    var horizontalSwipe = (0, _Drawer.isHorizontal)(anchor);
	    var currentX = calculateCurrentX(anchorRtl, event.touches);
	    var currentY = calculateCurrentY(anchorRtl, event.touches);
	
	    if (!open) {
	      if (disableSwipeToOpen || event.target !== swipeAreaRef.current) {
	        return;
	      }
	
	      if (horizontalSwipe) {
	        if (currentX > swipeAreaWidth) {
	          return;
	        }
	      } else if (currentY > swipeAreaWidth) {
	        return;
	      }
	    }
	
	    event.muiHandled = true;
	    nodeThatClaimedTheSwipe = null;
	    swipeInstance.current.startX = currentX;
	    swipeInstance.current.startY = currentY;
	    setMaybeSwiping(true);
	
	    if (!open && paperRef.current) {
	      // The ref may be null when a parent component updates while swiping.
	      setPosition(getMaxTranslate(horizontalSwipe, paperRef.current) + (disableDiscovery ? 20 : -swipeAreaWidth), {
	        changeTransition: false
	      });
	    }
	
	    swipeInstance.current.velocity = 0;
	    swipeInstance.current.lastTime = null;
	    swipeInstance.current.lastTranslate = null;
	    swipeInstance.current.paperHit = false;
	    touchDetected.current = true;
	  });
	  React.useEffect(function () {
	    if (variant === 'temporary') {
	      var doc = (0, _ownerDocument.default)(paperRef.current);
	      doc.addEventListener('touchstart', handleBodyTouchStart);
	      doc.addEventListener('touchmove', handleBodyTouchMove, {
	        passive: false
	      });
	      doc.addEventListener('touchend', handleBodyTouchEnd);
	      return function () {
	        doc.removeEventListener('touchstart', handleBodyTouchStart);
	        doc.removeEventListener('touchmove', handleBodyTouchMove, {
	          passive: false
	        });
	        doc.removeEventListener('touchend', handleBodyTouchEnd);
	      };
	    }
	
	    return undefined;
	  }, [variant, handleBodyTouchStart, handleBodyTouchMove, handleBodyTouchEnd]);
	  React.useEffect(function () {
	    return function () {
	      // We need to release the lock.
	      if (nodeThatClaimedTheSwipe === swipeInstance.current) {
	        nodeThatClaimedTheSwipe = null;
	      }
	    };
	  }, []);
	  React.useEffect(function () {
	    if (!open) {
	      setMaybeSwiping(false);
	    }
	  }, [open]);
	  var handleBackdropRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    backdropRef.current = ReactDOM.findDOMNode(instance);
	  }, []);
	  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Drawer.default, (0, _extends2.default)({
	    open: variant === 'temporary' && maybeSwiping ? true : open,
	    variant: variant,
	    ModalProps: (0, _extends2.default)({
	      BackdropProps: (0, _extends2.default)({}, BackdropProps, {
	        ref: handleBackdropRef
	      })
	    }, ModalPropsProp),
	    PaperProps: (0, _extends2.default)({}, PaperProps, {
	      style: (0, _extends2.default)({
	        pointerEvents: variant === 'temporary' && !open ? 'none' : ''
	      }, PaperProps.style),
	      ref: paperRef
	    }),
	    anchor: anchor,
	    transitionDuration: calculatedDurationRef.current || transitionDuration,
	    onClose: onClose,
	    ref: ref
	  }, other)), !disableSwipeToOpen && variant === 'temporary' && /*#__PURE__*/React.createElement(_NoSsr.default, null, /*#__PURE__*/React.createElement(_SwipeArea.default, (0, _extends2.default)({
	    anchor: anchor,
	    ref: swipeAreaRef,
	    width: swipeAreaWidth
	  }, SwipeAreaProps))));
	});
	 false ? SwipeableDrawer.propTypes = {
	  /**
	   * @ignore
	   */
	  anchor: _propTypes.default.oneOf(['left', 'top', 'right', 'bottom']),
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Disable the backdrop transition.
	   * This can improve the FPS on low-end devices.
	   */
	  disableBackdropTransition: _propTypes.default.bool,
	
	  /**
	   * If `true`, touching the screen near the edge of the drawer will not slide in the drawer a bit
	   * to promote accidental discovery of the swipe gesture.
	   */
	  disableDiscovery: _propTypes.default.bool,
	
	  /**
	   * If `true`, swipe to open is disabled. This is useful in browsers where swiping triggers
	   * navigation actions. Swipe to open is disabled on iOS browsers by default.
	   */
	  disableSwipeToOpen: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  hideBackdrop: _propTypes.default.bool,
	
	  /**
	   * Affects how far the drawer must be opened/closed to change his state.
	   * Specified as percent (0-1) of the width of the drawer
	   */
	  hysteresis: _propTypes.default.number,
	
	  /**
	   * Defines, from which (average) velocity on, the swipe is
	   * defined as complete although hysteresis isn't reached.
	   * Good threshold is between 250 - 1000 px/s
	   */
	  minFlingVelocity: _propTypes.default.number,
	
	  /**
	   * @ignore
	   */
	  ModalProps: _propTypes.default.shape({
	    BackdropProps: _propTypes.default.shape({
	      component: _utils.elementTypeAcceptingRef
	    })
	  }),
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onClose: _propTypes.default.func.isRequired,
	
	  /**
	   * Callback fired when the component requests to be opened.
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onOpen: _propTypes.default.func.isRequired,
	
	  /**
	   * If `true`, the drawer is open.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * @ignore
	   */
	  PaperProps: _propTypes.default.shape({
	    component: _utils.elementTypeAcceptingRef,
	    style: _propTypes.default.object
	  }),
	
	  /**
	   * The element is used to intercept the touch events on the edge.
	   */
	  SwipeAreaProps: _propTypes.default.object,
	
	  /**
	   * The width of the left most (or right most) area in pixels where the
	   * drawer can be swiped open from.
	   */
	  swipeAreaWidth: _propTypes.default.number,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * @ignore
	   */
	  variant: _propTypes.default.oneOf(['permanent', 'persistent', 'temporary'])
	} : void 0;
	var _default = SwipeableDrawer;
	exports.default = _default;

/***/ },
/* 1252 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _SwipeableDrawer.default;
	  }
	});
	
	var _SwipeableDrawer = _interopRequireDefault(__webpack_require__(1251));

/***/ },
/* 1253 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _utils = __webpack_require__(19);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _colorManipulator = __webpack_require__(63);
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var _SwitchBase = _interopRequireDefault(__webpack_require__(407));
	
	// @inheritedComponent IconButton
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'inline-flex',
	      width: 34 + 12 * 2,
	      height: 14 + 12 * 2,
	      overflow: 'hidden',
	      padding: 12,
	      boxSizing: 'border-box',
	      position: 'relative',
	      flexShrink: 0,
	      zIndex: 0,
	      // Reset the stacking context.
	      verticalAlign: 'middle',
	      // For correct alignment with the text.
	      '@media print': {
	        colorAdjust: 'exact'
	      }
	    },
	
	    /* Styles applied to the root element if `edge="start"`. */
	    edgeStart: {
	      marginLeft: -8
	    },
	
	    /* Styles applied to the root element if `edge="end"`. */
	    edgeEnd: {
	      marginRight: -8
	    },
	
	    /* Styles applied to the internal `SwitchBase` component's `root` class. */
	    switchBase: {
	      position: 'absolute',
	      top: 0,
	      left: 0,
	      zIndex: 1,
	      // Render above the focus ripple.
	      color: theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[400],
	      transition: theme.transitions.create(['left', 'transform'], {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&$checked': {
	        transform: 'translateX(20px)'
	      },
	      '&$disabled': {
	        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
	      },
	      '&$checked + $track': {
	        opacity: 0.5
	      },
	      '&$disabled + $track': {
	        opacity: theme.palette.type === 'light' ? 0.12 : 0.1
	      }
	    },
	
	    /* Styles applied to the internal SwitchBase component's root element if `color="primary"`. */
	    colorPrimary: {
	      '&$checked': {
	        color: theme.palette.primary.main,
	        '&:hover': {
	          backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	          '@media (hover: none)': {
	            backgroundColor: 'transparent'
	          }
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
	      },
	      '&$checked + $track': {
	        backgroundColor: theme.palette.primary.main
	      },
	      '&$disabled + $track': {
	        backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
	      }
	    },
	
	    /* Styles applied to the internal SwitchBase component's root element if `color="secondary"`. */
	    colorSecondary: {
	      '&$checked': {
	        color: theme.palette.secondary.main,
	        '&:hover': {
	          backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	          '@media (hover: none)': {
	            backgroundColor: 'transparent'
	          }
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
	      },
	      '&$checked + $track': {
	        backgroundColor: theme.palette.secondary.main
	      },
	      '&$disabled + $track': {
	        backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
	      }
	    },
	
	    /* Styles applied to the root element if `size="small"`. */
	    sizeSmall: {
	      width: 40,
	      height: 24,
	      padding: 7,
	      '& $thumb': {
	        width: 16,
	        height: 16
	      },
	      '& $switchBase': {
	        padding: 4,
	        '&$checked': {
	          transform: 'translateX(16px)'
	        }
	      }
	    },
	
	    /* Pseudo-class applied to the internal `SwitchBase` component's `checked` class. */
	    checked: {},
	
	    /* Pseudo-class applied to the internal SwitchBase component's disabled class. */
	    disabled: {},
	
	    /* Styles applied to the internal SwitchBase component's input element. */
	    input: {
	      left: '-100%',
	      width: '300%'
	    },
	
	    /* Styles used to create the thumb passed to the internal `SwitchBase` component `icon` prop. */
	    thumb: {
	      boxShadow: theme.shadows[1],
	      backgroundColor: 'currentColor',
	      width: 20,
	      height: 20,
	      borderRadius: '50%'
	    },
	
	    /* Styles applied to the track element. */
	    track: {
	      height: '100%',
	      width: '100%',
	      borderRadius: 14 / 2,
	      zIndex: -1,
	      transition: theme.transitions.create(['opacity', 'background-color'], {
	        duration: theme.transitions.duration.shortest
	      }),
	      backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white,
	      opacity: theme.palette.type === 'light' ? 0.38 : 0.3
	    }
	  };
	};
	
	exports.styles = styles;
	var Switch = /*#__PURE__*/React.forwardRef(function Switch(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'secondary' : _props$color,
	      _props$edge = props.edge,
	      edge = _props$edge === void 0 ? false : _props$edge,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "edge", "size"]);
	  var icon = /*#__PURE__*/React.createElement("span", {
	    className: classes.thumb
	  });
	  return /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.root, className, {
	      'start': classes.edgeStart,
	      'end': classes.edgeEnd
	    }[edge], size === "small" && classes["size".concat((0, _capitalize.default)(size))])
	  }, /*#__PURE__*/React.createElement(_SwitchBase.default, (0, _extends2.default)({
	    type: "checkbox",
	    icon: icon,
	    checkedIcon: icon,
	    classes: {
	      root: (0, _clsx.default)(classes.switchBase, classes["color".concat((0, _capitalize.default)(color))]),
	      input: classes.input,
	      checked: classes.checked,
	      disabled: classes.disabled
	    },
	    ref: ref
	  }, other)), /*#__PURE__*/React.createElement("span", {
	    className: classes.track
	  }));
	});
	 false ? Switch.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is checked.
	   */
	  checkedIcon: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'primary', 'secondary']),
	
	  /**
	   * @ignore
	   */
	  defaultChecked: _propTypes.default.bool,
	
	  /**
	   * If `true`, the switch will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * If given, uses a negative margin to counteract the padding on one
	   * side (this is often helpful for aligning the left or right
	   * side of the icon with content above or below, without ruining the border
	   * size and shape).
	   */
	  edge: _propTypes.default.oneOf(['end', 'start', false]),
	
	  /**
	   * The icon to display when the component is unchecked.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * The size of the switch.
	   * `small` is equivalent to the dense switch styling.
	   */
	  size: _propTypes.default.oneOf(['medium', 'small']),
	
	  /**
	   * The value of the component. The DOM API casts this to a string.
	   * The browser uses "on" as the default value.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSwitch'
	})(Switch);
	
	exports.default = _default;

/***/ },
/* 1254 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Switch.default;
	  }
	});
	
	var _Switch = _interopRequireDefault(__webpack_require__(1253));

/***/ },
/* 1255 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(62));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(69));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var _unsupportedProp = _interopRequireDefault(__webpack_require__(311));
	
	var styles = function styles(theme) {
	  var _extends2;
	
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends3.default)({}, theme.typography.button, (_extends2 = {
	      maxWidth: 264,
	      minWidth: 72,
	      position: 'relative',
	      boxSizing: 'border-box',
	      minHeight: 48,
	      flexShrink: 0,
	      padding: '6px 12px'
	    }, (0, _defineProperty2.default)(_extends2, theme.breakpoints.up('sm'), {
	      padding: '6px 24px'
	    }), (0, _defineProperty2.default)(_extends2, "overflow", 'hidden'), (0, _defineProperty2.default)(_extends2, "whiteSpace", 'normal'), (0, _defineProperty2.default)(_extends2, "textAlign", 'center'), (0, _defineProperty2.default)(_extends2, theme.breakpoints.up('sm'), {
	      minWidth: 160
	    }), _extends2)),
	
	    /* Styles applied to the root element if both `icon` and `label` are provided. */
	    labelIcon: {
	      minHeight: 72,
	      paddingTop: 9,
	      '& $wrapper > *:first-child': {
	        marginBottom: 6
	      }
	    },
	
	    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="inherit"`. */
	    textColorInherit: {
	      color: 'inherit',
	      opacity: 0.7,
	      '&$selected': {
	        opacity: 1
	      },
	      '&$disabled': {
	        opacity: 0.5
	      }
	    },
	
	    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="primary"`. */
	    textColorPrimary: {
	      color: theme.palette.text.secondary,
	      '&$selected': {
	        color: theme.palette.primary.main
	      },
	      '&$disabled': {
	        color: theme.palette.text.disabled
	      }
	    },
	
	    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="secondary"`. */
	    textColorSecondary: {
	      color: theme.palette.text.secondary,
	      '&$selected': {
	        color: theme.palette.secondary.main
	      },
	      '&$disabled': {
	        color: theme.palette.text.disabled
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `selected={true}` (controlled by the Tabs component). */
	    selected: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}` (controlled by the Tabs component). */
	    disabled: {},
	
	    /* Styles applied to the root element if `fullWidth={true}` (controlled by the Tabs component). */
	    fullWidth: {
	      flexShrink: 1,
	      flexGrow: 1,
	      flexBasis: 0,
	      maxWidth: 'none'
	    },
	
	    /* Styles applied to the root element if `wrapped={true}`. */
	    wrapped: {
	      fontSize: theme.typography.pxToRem(12),
	      lineHeight: 1.5
	    },
	
	    /* Styles applied to the `icon` and `label`'s wrapper element. */
	    wrapper: {
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      width: '100%',
	      flexDirection: 'column'
	    }
	  };
	};
	
	exports.styles = styles;
	var Tab = /*#__PURE__*/React.forwardRef(function Tab(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableFocusRi = props.disableFocusRipple,
	      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
	      fullWidth = props.fullWidth,
	      icon = props.icon,
	      indicator = props.indicator,
	      label = props.label,
	      onChange = props.onChange,
	      onClick = props.onClick,
	      onFocus = props.onFocus,
	      selected = props.selected,
	      selectionFollowsFocus = props.selectionFollowsFocus,
	      _props$textColor = props.textColor,
	      textColor = _props$textColor === void 0 ? 'inherit' : _props$textColor,
	      value = props.value,
	      _props$wrapped = props.wrapped,
	      wrapped = _props$wrapped === void 0 ? false : _props$wrapped,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "disabled", "disableFocusRipple", "fullWidth", "icon", "indicator", "label", "onChange", "onClick", "onFocus", "selected", "selectionFollowsFocus", "textColor", "value", "wrapped"]);
	
	  var handleClick = function handleClick(event) {
	    if (onChange) {
	      onChange(event, value);
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  var handleFocus = function handleFocus(event) {
	    if (selectionFollowsFocus && !selected && onChange) {
	      onChange(event, value);
	    }
	
	    if (onFocus) {
	      onFocus(event);
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends3.default)({
	    focusRipple: !disableFocusRipple,
	    className: (0, _clsx.default)(classes.root, classes["textColor".concat((0, _capitalize.default)(textColor))], className, disabled && classes.disabled, selected && classes.selected, label && icon && classes.labelIcon, fullWidth && classes.fullWidth, wrapped && classes.wrapped),
	    ref: ref,
	    role: "tab",
	    "aria-selected": selected,
	    disabled: disabled,
	    onClick: handleClick,
	    onFocus: handleFocus,
	    tabIndex: selected ? 0 : -1
	  }, other), /*#__PURE__*/React.createElement("span", {
	    className: classes.wrapper
	  }, icon, label), indicator);
	});
	 false ? Tab.propTypes = {
	  /**
	   * This prop isn't supported.
	   * Use the `component` prop if you need to change the children structure.
	   */
	  children: _unsupportedProp.default,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the tab will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the  keyboard focus ripple will be disabled.
	   */
	  disableFocusRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The icon element.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * @ignore
	   * For server-side rendering consideration, we let the selected tab
	   * render the indicator.
	   */
	  indicator: _propTypes.default.node,
	
	  /**
	   * The label element.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  selected: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  selectionFollowsFocus: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  textColor: _propTypes.default.oneOf(['secondary', 'primary', 'inherit']),
	
	  /**
	   * You can provide your own value. Otherwise, we fallback to the child position index.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * Tab labels appear in a single row.
	   * They can use a second line if needed.
	   */
	  wrapped: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTab'
	})(Tab);
	
	exports.default = _default;

/***/ },
/* 1256 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Tab.default;
	  }
	});
	
	var _Tab = _interopRequireDefault(__webpack_require__(1255));

/***/ },
/* 1257 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _KeyboardArrowLeft = _interopRequireDefault(__webpack_require__(620));
	
	var _KeyboardArrowRight = _interopRequireDefault(__webpack_require__(621));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(69));
	
	/* eslint-disable jsx-a11y/aria-role */
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    width: 40,
	    flexShrink: 0,
	    opacity: 0.8,
	    '&$disabled': {
	      opacity: 0
	    }
	  },
	
	  /* Styles applied to the root element if `orientation="vertical"`. */
	  vertical: {
	    width: '100%',
	    height: 40,
	    '& svg': {
	      transform: 'rotate(90deg)'
	    }
	  },
	
	  /* Pseudo-class applied to the root element if `disabled={true}`. */
	  disabled: {}
	};
	exports.styles = styles;
	
	var _ref = /*#__PURE__*/React.createElement(_KeyboardArrowLeft.default, {
	  fontSize: "small"
	});
	
	var _ref2 = /*#__PURE__*/React.createElement(_KeyboardArrowRight.default, {
	  fontSize: "small"
	});
	
	var TabScrollButton = /*#__PURE__*/React.forwardRef(function TabScrollButton(props, ref) {
	  var classes = props.classes,
	      classNameProp = props.className,
	      direction = props.direction,
	      orientation = props.orientation,
	      disabled = props.disabled,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "direction", "orientation", "disabled"]);
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    component: "div",
	    className: (0, _clsx.default)(classes.root, classNameProp, disabled && classes.disabled, orientation === 'vertical' && classes.vertical),
	    ref: ref,
	    role: null,
	    tabIndex: null
	  }, other), direction === 'left' ? _ref : _ref2);
	});
	 false ? TabScrollButton.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Which direction should the button indicate?
	   */
	  direction: _propTypes.default.oneOf(['left', 'right']).isRequired,
	
	  /**
	   * If `true`, the element will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * The tabs orientation (layout flow direction).
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']).isRequired
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTabScrollButton'
	})(TabScrollButton);
	
	exports.default = _default;

/***/ },
/* 1258 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _TableContext = _interopRequireDefault(__webpack_require__(605));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'table',
	      width: '100%',
	      borderCollapse: 'collapse',
	      borderSpacing: 0,
	      '& caption': (0, _extends2.default)({}, theme.typography.body2, {
	        padding: theme.spacing(2),
	        color: theme.palette.text.secondary,
	        textAlign: 'left',
	        captionSide: 'bottom'
	      })
	    },
	
	    /* Styles applied to the root element if `stickyHeader={true}`. */
	    stickyHeader: {
	      borderCollapse: 'separate'
	    }
	  };
	};
	
	exports.styles = styles;
	var defaultComponent = 'table';
	var Table = /*#__PURE__*/React.forwardRef(function Table(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? defaultComponent : _props$component,
	      _props$padding = props.padding,
	      padding = _props$padding === void 0 ? 'default' : _props$padding,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      _props$stickyHeader = props.stickyHeader,
	      stickyHeader = _props$stickyHeader === void 0 ? false : _props$stickyHeader,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "padding", "size", "stickyHeader"]);
	  var table = React.useMemo(function () {
	    return {
	      padding: padding,
	      size: size,
	      stickyHeader: stickyHeader
	    };
	  }, [padding, size, stickyHeader]);
	  return /*#__PURE__*/React.createElement(_TableContext.default.Provider, {
	    value: table
	  }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    role: Component === defaultComponent ? null : 'table',
	    ref: ref,
	    className: (0, _clsx.default)(classes.root, className, stickyHeader && classes.stickyHeader)
	  }, other)));
	});
	 false ? Table.propTypes = {
	  /**
	   * The content of the table, normally `TableHead` and `TableBody`.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * Allows TableCells to inherit padding of the Table.
	   */
	  padding: _propTypes.default.oneOf(['default', 'checkbox', 'none']),
	
	  /**
	   * Allows TableCells to inherit size of the Table.
	   */
	  size: _propTypes.default.oneOf(['small', 'medium']),
	
	  /**
	   * Set the header sticky.
	   *
	   * ⚠️ It doesn't work with IE 11.
	   */
	  stickyHeader: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTable'
	})(Table);
	
	exports.default = _default;

/***/ },
/* 1259 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Table.default;
	  }
	});
	
	var _Table = _interopRequireDefault(__webpack_require__(1258));

/***/ },
/* 1260 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _Tablelvl2Context = _interopRequireDefault(__webpack_require__(239));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'table-row-group'
	  }
	};
	exports.styles = styles;
	var tablelvl2 = {
	  variant: 'body'
	};
	var defaultComponent = 'tbody';
	var TableBody = /*#__PURE__*/React.forwardRef(function TableBody(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? defaultComponent : _props$component,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component"]);
	  return /*#__PURE__*/React.createElement(_Tablelvl2Context.default.Provider, {
	    value: tablelvl2
	  }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref,
	    role: Component === defaultComponent ? null : 'rowgroup'
	  }, other)));
	});
	 false ? TableBody.propTypes = {
	  /**
	   * The content of the component, normally `TableRow`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableBody'
	})(TableBody);
	
	exports.default = _default;

/***/ },
/* 1261 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TableBody.default;
	  }
	});
	
	var _TableBody = _interopRequireDefault(__webpack_require__(1260));

/***/ },
/* 1262 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var _colorManipulator = __webpack_require__(63);
	
	var _TableContext = _interopRequireDefault(__webpack_require__(605));
	
	var _Tablelvl2Context = _interopRequireDefault(__webpack_require__(239));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({}, theme.typography.body2, {
	      display: 'table-cell',
	      verticalAlign: 'inherit',
	      // Workaround for a rendering bug with spanned columns in Chrome 62.0.
	      // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
	      borderBottom: "1px solid\n    ".concat(theme.palette.type === 'light' ? (0, _colorManipulator.lighten)((0, _colorManipulator.fade)(theme.palette.divider, 1), 0.88) : (0, _colorManipulator.darken)((0, _colorManipulator.fade)(theme.palette.divider, 1), 0.68)),
	      textAlign: 'left',
	      padding: 16
	    }),
	
	    /* Styles applied to the root element if `variant="head"` or `context.table.head`. */
	    head: {
	      color: theme.palette.text.primary,
	      lineHeight: theme.typography.pxToRem(24),
	      fontWeight: theme.typography.fontWeightMedium
	    },
	
	    /* Styles applied to the root element if `variant="body"` or `context.table.body`. */
	    body: {
	      color: theme.palette.text.primary
	    },
	
	    /* Styles applied to the root element if `variant="footer"` or `context.table.footer`. */
	    footer: {
	      color: theme.palette.text.secondary,
	      lineHeight: theme.typography.pxToRem(21),
	      fontSize: theme.typography.pxToRem(12)
	    },
	
	    /* Styles applied to the root element if `size="small"`. */
	    sizeSmall: {
	      padding: '6px 24px 6px 16px',
	      '&:last-child': {
	        paddingRight: 16
	      },
	      '&$paddingCheckbox': {
	        width: 24,
	        // prevent the checkbox column from growing
	        padding: '0 12px 0 16px',
	        '&:last-child': {
	          paddingLeft: 12,
	          paddingRight: 16
	        },
	        '& > *': {
	          padding: 0
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `padding="checkbox"`. */
	    paddingCheckbox: {
	      width: 48,
	      // prevent the checkbox column from growing
	      padding: '0 0 0 4px',
	      '&:last-child': {
	        paddingLeft: 0,
	        paddingRight: 4
	      }
	    },
	
	    /* Styles applied to the root element if `padding="none"`. */
	    paddingNone: {
	      padding: 0,
	      '&:last-child': {
	        padding: 0
	      }
	    },
	
	    /* Styles applied to the root element if `align="left"`. */
	    alignLeft: {
	      textAlign: 'left'
	    },
	
	    /* Styles applied to the root element if `align="center"`. */
	    alignCenter: {
	      textAlign: 'center'
	    },
	
	    /* Styles applied to the root element if `align="right"`. */
	    alignRight: {
	      textAlign: 'right',
	      flexDirection: 'row-reverse'
	    },
	
	    /* Styles applied to the root element if `align="justify"`. */
	    alignJustify: {
	      textAlign: 'justify'
	    },
	
	    /* Styles applied to the root element if `context.table.stickyHeader={true}`. */
	    stickyHeader: {
	      position: 'sticky',
	      top: 0,
	      left: 0,
	      zIndex: 2,
	      backgroundColor: theme.palette.background.default
	    }
	  };
	};
	/**
	 * The component renders a `<th>` element when the parent context is a header
	 * or otherwise a `<td>` element.
	 */
	
	
	exports.styles = styles;
	var TableCell = /*#__PURE__*/React.forwardRef(function TableCell(props, ref) {
	  var _props$align = props.align,
	      align = _props$align === void 0 ? 'inherit' : _props$align,
	      classes = props.classes,
	      className = props.className,
	      component = props.component,
	      paddingProp = props.padding,
	      scopeProp = props.scope,
	      sizeProp = props.size,
	      sortDirection = props.sortDirection,
	      variantProp = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["align", "classes", "className", "component", "padding", "scope", "size", "sortDirection", "variant"]);
	  var table = React.useContext(_TableContext.default);
	  var tablelvl2 = React.useContext(_Tablelvl2Context.default);
	  var isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
	  var role;
	  var Component;
	
	  if (component) {
	    Component = component;
	    role = isHeadCell ? 'columnheader' : 'cell';
	  } else {
	    Component = isHeadCell ? 'th' : 'td';
	  }
	
	  var scope = scopeProp;
	
	  if (!scope && isHeadCell) {
	    scope = 'col';
	  }
	
	  var padding = paddingProp || (table && table.padding ? table.padding : 'default');
	  var size = sizeProp || (table && table.size ? table.size : 'medium');
	  var variant = variantProp || tablelvl2 && tablelvl2.variant;
	  var ariaSort = null;
	
	  if (sortDirection) {
	    ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
	  }
	
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    ref: ref,
	    className: (0, _clsx.default)(classes.root, classes[variant], className, align !== 'inherit' && classes["align".concat((0, _capitalize.default)(align))], padding !== 'default' && classes["padding".concat((0, _capitalize.default)(padding))], size !== 'medium' && classes["size".concat((0, _capitalize.default)(size))], variant === 'head' && table && table.stickyHeader && classes.stickyHeader),
	    "aria-sort": ariaSort,
	    role: role,
	    scope: scope
	  }, other));
	});
	 false ? TableCell.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Set the text-align on the table cell content.
	   *
	   * Monetary or generally number fields **should be right aligned** as that allows
	   * you to add them up quickly in your head without having to worry about decimals.
	   */
	  align: _propTypes.default.oneOf(['center', 'inherit', 'justify', 'left', 'right']),
	
	  /**
	   * The table cell contents.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * Sets the padding applied to the cell.
	   * By default, the Table parent component set the value (`default`).
	   */
	  padding: _propTypes.default.oneOf(['checkbox', 'default', 'none']),
	
	  /**
	   * Set scope attribute.
	   */
	  scope: _propTypes.default.string,
	
	  /**
	   * Specify the size of the cell.
	   * By default, the Table parent component set the value (`medium`).
	   */
	  size: _propTypes.default.oneOf(['medium', 'small']),
	
	  /**
	   * Set aria-sort direction.
	   */
	  sortDirection: _propTypes.default.oneOf(['asc', 'desc', false]),
	
	  /**
	   * Specify the cell type.
	   * By default, the TableHead, TableBody or TableFooter parent component set the value.
	   */
	  variant: _propTypes.default.oneOf(['body', 'footer', 'head'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableCell'
	})(TableCell);
	
	exports.default = _default;

/***/ },
/* 1263 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    width: '100%',
	    overflowX: 'auto'
	  }
	};
	exports.styles = styles;
	var TableContainer = /*#__PURE__*/React.forwardRef(function TableContainer(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    ref: ref,
	    className: (0, _clsx.default)(classes.root, className)
	  }, other));
	});
	 false ? TableContainer.propTypes = {
	  /**
	   * The table itself, normally `<Table />`
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableContainer'
	})(TableContainer);
	
	exports.default = _default;

/***/ },
/* 1264 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TableContainer.default;
	  }
	});
	
	var _TableContainer = _interopRequireDefault(__webpack_require__(1263));

/***/ },
/* 1265 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _Tablelvl2Context = _interopRequireDefault(__webpack_require__(239));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'table-footer-group'
	  }
	};
	exports.styles = styles;
	var tablelvl2 = {
	  variant: 'footer'
	};
	var defaultComponent = 'tfoot';
	var TableFooter = /*#__PURE__*/React.forwardRef(function TableFooter(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? defaultComponent : _props$component,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component"]);
	  return /*#__PURE__*/React.createElement(_Tablelvl2Context.default.Provider, {
	    value: tablelvl2
	  }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref,
	    role: Component === defaultComponent ? null : 'rowgroup'
	  }, other)));
	});
	 false ? TableFooter.propTypes = {
	  /**
	   * The content of the component, normally `TableRow`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableFooter'
	})(TableFooter);
	
	exports.default = _default;

/***/ },
/* 1266 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TableFooter.default;
	  }
	});
	
	var _TableFooter = _interopRequireDefault(__webpack_require__(1265));

/***/ },
/* 1267 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _Tablelvl2Context = _interopRequireDefault(__webpack_require__(239));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'table-header-group'
	  }
	};
	exports.styles = styles;
	var tablelvl2 = {
	  variant: 'head'
	};
	var defaultComponent = 'thead';
	var TableHead = /*#__PURE__*/React.forwardRef(function TableHead(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? defaultComponent : _props$component,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component"]);
	  return /*#__PURE__*/React.createElement(_Tablelvl2Context.default.Provider, {
	    value: tablelvl2
	  }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref,
	    role: Component === defaultComponent ? null : 'rowgroup'
	  }, other)));
	});
	 false ? TableHead.propTypes = {
	  /**
	   * The content of the component, normally `TableRow`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableHead'
	})(TableHead);
	
	exports.default = _default;

/***/ },
/* 1268 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TableHead.default;
	  }
	});
	
	var _TableHead = _interopRequireDefault(__webpack_require__(1267));

/***/ },
/* 1269 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(19);
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _InputBase = _interopRequireDefault(__webpack_require__(237));
	
	var _MenuItem = _interopRequireDefault(__webpack_require__(590));
	
	var _Select = _interopRequireDefault(__webpack_require__(403));
	
	var _TableCell = _interopRequireDefault(__webpack_require__(606));
	
	var _Toolbar = _interopRequireDefault(__webpack_require__(609));
	
	var _Typography = _interopRequireDefault(__webpack_require__(75));
	
	var _TablePaginationActions = _interopRequireDefault(__webpack_require__(1270));
	
	var _unstable_useId = _interopRequireDefault(__webpack_require__(310));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      color: theme.palette.text.primary,
	      fontSize: theme.typography.pxToRem(14),
	      overflow: 'auto',
	      // Increase the specificity to override TableCell.
	      '&:last-child': {
	        padding: 0
	      }
	    },
	
	    /* Styles applied to the Toolbar component. */
	    toolbar: {
	      minHeight: 52,
	      paddingRight: 2
	    },
	
	    /* Styles applied to the spacer element. */
	    spacer: {
	      flex: '1 1 100%'
	    },
	
	    /* Styles applied to the caption Typography components if `variant="caption"`. */
	    caption: {
	      flexShrink: 0
	    },
	    // TODO v5: `.selectRoot` should be merged with `.input`
	
	    /* Styles applied to the Select component root element. */
	    selectRoot: {
	      marginRight: 32,
	      marginLeft: 8
	    },
	
	    /* Styles applied to the Select component `select` class. */
	    select: {
	      paddingLeft: 8,
	      paddingRight: 24,
	      textAlign: 'right',
	      textAlignLast: 'right' // Align <select> on Chrome.
	
	    },
	    // TODO v5: remove
	
	    /* Styles applied to the Select component `icon` class. */
	    selectIcon: {},
	
	    /* Styles applied to the `InputBase` component. */
	    input: {
	      color: 'inherit',
	      fontSize: 'inherit',
	      flexShrink: 0
	    },
	
	    /* Styles applied to the MenuItem component. */
	    menuItem: {},
	
	    /* Styles applied to the internal `TablePaginationActions` component. */
	    actions: {
	      flexShrink: 0,
	      marginLeft: 20
	    }
	  };
	};
	
	exports.styles = styles;
	
	var defaultLabelDisplayedRows = function defaultLabelDisplayedRows(_ref) {
	  var from = _ref.from,
	      to = _ref.to,
	      count = _ref.count;
	  return "".concat(from, "-").concat(to, " of ").concat(count !== -1 ? count : "more than ".concat(to));
	};
	
	var defaultRowsPerPageOptions = [10, 25, 50, 100];
	/**
	 * A `TableCell` based component for placing inside `TableFooter` for pagination.
	 */
	
	var TablePagination = /*#__PURE__*/React.forwardRef(function TablePagination(props, ref) {
	  var _props$ActionsCompone = props.ActionsComponent,
	      ActionsComponent = _props$ActionsCompone === void 0 ? _TablePaginationActions.default : _props$ActionsCompone,
	      backIconButtonProps = props.backIconButtonProps,
	      _props$backIconButton = props.backIconButtonText,
	      backIconButtonText = _props$backIconButton === void 0 ? 'Previous page' : _props$backIconButton,
	      classes = props.classes,
	      className = props.className,
	      colSpanProp = props.colSpan,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? _TableCell.default : _props$component,
	      count = props.count,
	      _props$labelDisplayed = props.labelDisplayedRows,
	      labelDisplayedRows = _props$labelDisplayed === void 0 ? defaultLabelDisplayedRows : _props$labelDisplayed,
	      _props$labelRowsPerPa = props.labelRowsPerPage,
	      labelRowsPerPage = _props$labelRowsPerPa === void 0 ? 'Rows per page:' : _props$labelRowsPerPa,
	      nextIconButtonProps = props.nextIconButtonProps,
	      _props$nextIconButton = props.nextIconButtonText,
	      nextIconButtonText = _props$nextIconButton === void 0 ? 'Next page' : _props$nextIconButton,
	      onChangePage = props.onChangePage,
	      onChangeRowsPerPage = props.onChangeRowsPerPage,
	      page = props.page,
	      rowsPerPage = props.rowsPerPage,
	      _props$rowsPerPageOpt = props.rowsPerPageOptions,
	      rowsPerPageOptions = _props$rowsPerPageOpt === void 0 ? defaultRowsPerPageOptions : _props$rowsPerPageOpt,
	      _props$SelectProps = props.SelectProps,
	      SelectProps = _props$SelectProps === void 0 ? {} : _props$SelectProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["ActionsComponent", "backIconButtonProps", "backIconButtonText", "classes", "className", "colSpan", "component", "count", "labelDisplayedRows", "labelRowsPerPage", "nextIconButtonProps", "nextIconButtonText", "onChangePage", "onChangeRowsPerPage", "page", "rowsPerPage", "rowsPerPageOptions", "SelectProps"]);
	  var colSpan;
	
	  if (Component === _TableCell.default || Component === 'td') {
	    colSpan = colSpanProp || 1000; // col-span over everything
	  }
	
	  var selectId = (0, _unstable_useId.default)();
	  var labelId = (0, _unstable_useId.default)();
	  var MenuItemComponent = SelectProps.native ? 'option' : _MenuItem.default;
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    colSpan: colSpan,
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement(_Toolbar.default, {
	    className: classes.toolbar
	  }, /*#__PURE__*/React.createElement("div", {
	    className: classes.spacer
	  }), rowsPerPageOptions.length > 1 && /*#__PURE__*/React.createElement(_Typography.default, {
	    color: "inherit",
	    variant: "body2",
	    className: classes.caption,
	    id: labelId
	  }, labelRowsPerPage), rowsPerPageOptions.length > 1 && /*#__PURE__*/React.createElement(_Select.default, (0, _extends2.default)({
	    classes: {
	      select: classes.select,
	      icon: classes.selectIcon
	    },
	    input: /*#__PURE__*/React.createElement(_InputBase.default, {
	      className: (0, _clsx.default)(classes.input, classes.selectRoot)
	    }),
	    value: rowsPerPage,
	    onChange: onChangeRowsPerPage,
	    id: selectId,
	    labelId: labelId
	  }, SelectProps), rowsPerPageOptions.map(function (rowsPerPageOption) {
	    return /*#__PURE__*/React.createElement(MenuItemComponent, {
	      className: classes.menuItem,
	      key: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption,
	      value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
	    }, rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption);
	  })), /*#__PURE__*/React.createElement(_Typography.default, {
	    color: "inherit",
	    variant: "body2",
	    className: classes.caption
	  }, labelDisplayedRows({
	    from: count === 0 ? 0 : page * rowsPerPage + 1,
	    to: count !== -1 ? Math.min(count, (page + 1) * rowsPerPage) : (page + 1) * rowsPerPage,
	    count: count === -1 ? -1 : count,
	    page: page
	  })), /*#__PURE__*/React.createElement(ActionsComponent, {
	    className: classes.actions,
	    backIconButtonProps: (0, _extends2.default)({
	      title: backIconButtonText,
	      'aria-label': backIconButtonText
	    }, backIconButtonProps),
	    count: count,
	    nextIconButtonProps: (0, _extends2.default)({
	      title: nextIconButtonText,
	      'aria-label': nextIconButtonText
	    }, nextIconButtonProps),
	    onChangePage: onChangePage,
	    page: page,
	    rowsPerPage: rowsPerPage
	  })));
	});
	 false ? TablePagination.propTypes = {
	  /**
	   * The component used for displaying the actions.
	   * Either a string to use a HTML element or a component.
	   */
	  ActionsComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the back arrow [`IconButton`](/api/icon-button/) component.
	   */
	  backIconButtonProps: _propTypes.default.object,
	
	  /**
	   * Text label for the back arrow icon button.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  backIconButtonText: _propTypes.default.string,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  colSpan: _propTypes.default.number,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * The total number of rows.
	   *
	   * To enable server side pagination for an unknown number of items, provide -1.
	   */
	  count: _propTypes.default.number.isRequired,
	
	  /**
	   * Customize the displayed rows label. Invoked with a `{ from, to, count, page }`
	   * object.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  labelDisplayedRows: _propTypes.default.func,
	
	  /**
	   * Customize the rows per page label.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  labelRowsPerPage: _propTypes.default.node,
	
	  /**
	   * Props applied to the next arrow [`IconButton`](/api/icon-button/) element.
	   */
	  nextIconButtonProps: _propTypes.default.object,
	
	  /**
	   * Text label for the next arrow icon button.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  nextIconButtonText: _propTypes.default.string,
	
	  /**
	   * Callback fired when the page is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {number} page The page selected.
	   */
	  onChangePage: _propTypes.default.func.isRequired,
	
	  /**
	   * Callback fired when the number of rows per page is changed.
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onChangeRowsPerPage: _propTypes.default.func,
	
	  /**
	   * The zero-based index of the current page.
	   */
	  page: (0, _utils.chainPropTypes)(_propTypes.default.number.isRequired, function (props) {
	    var count = props.count,
	        page = props.page,
	        rowsPerPage = props.rowsPerPage;
	
	    if (count === -1) {
	      return null;
	    }
	
	    var newLastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);
	
	    if (page < 0 || page > newLastPage) {
	      return new Error('Material-UI: The page prop of a TablePagination is out of range ' + "(0 to ".concat(newLastPage, ", but page is ").concat(page, ")."));
	    }
	
	    return null;
	  }),
	
	  /**
	   * The number of rows per page.
	   */
	  rowsPerPage: _propTypes.default.number.isRequired,
	
	  /**
	   * Customizes the options of the rows per page select field. If less than two options are
	   * available, no select field will be displayed.
	   */
	  rowsPerPageOptions: _propTypes.default.array,
	
	  /**
	   * Props applied to the rows per page [`Select`](/api/select/) element.
	   */
	  SelectProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTablePagination'
	})(TablePagination);
	
	exports.default = _default;

/***/ },
/* 1270 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _KeyboardArrowLeft = _interopRequireDefault(__webpack_require__(620));
	
	var _KeyboardArrowRight = _interopRequireDefault(__webpack_require__(621));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(59));
	
	var _IconButton = _interopRequireDefault(__webpack_require__(236));
	
	var _ref = /*#__PURE__*/React.createElement(_KeyboardArrowRight.default, null);
	
	var _ref2 = /*#__PURE__*/React.createElement(_KeyboardArrowLeft.default, null);
	
	var _ref3 = /*#__PURE__*/React.createElement(_KeyboardArrowLeft.default, null);
	
	var _ref4 = /*#__PURE__*/React.createElement(_KeyboardArrowRight.default, null);
	
	/**
	 * @ignore - internal component.
	 */
	var TablePaginationActions = /*#__PURE__*/React.forwardRef(function TablePaginationActions(props, ref) {
	  var backIconButtonProps = props.backIconButtonProps,
	      count = props.count,
	      nextIconButtonProps = props.nextIconButtonProps,
	      onChangePage = props.onChangePage,
	      page = props.page,
	      rowsPerPage = props.rowsPerPage,
	      other = (0, _objectWithoutProperties2.default)(props, ["backIconButtonProps", "count", "nextIconButtonProps", "onChangePage", "page", "rowsPerPage"]);
	  var theme = (0, _useTheme.default)();
	
	  var handleBackButtonClick = function handleBackButtonClick(event) {
	    onChangePage(event, page - 1);
	  };
	
	  var handleNextButtonClick = function handleNextButtonClick(event) {
	    onChangePage(event, page + 1);
	  };
	
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement(_IconButton.default, (0, _extends2.default)({
	    onClick: handleBackButtonClick,
	    disabled: page === 0,
	    color: "inherit"
	  }, backIconButtonProps), theme.direction === 'rtl' ? _ref : _ref2), /*#__PURE__*/React.createElement(_IconButton.default, (0, _extends2.default)({
	    onClick: handleNextButtonClick,
	    disabled: count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false,
	    color: "inherit"
	  }, nextIconButtonProps), theme.direction === 'rtl' ? _ref3 : _ref4));
	});
	 false ? TablePaginationActions.propTypes = {
	  /**
	   * Props applied to the back arrow [`IconButton`](/api/icon-button/) element.
	   */
	  backIconButtonProps: _propTypes.default.object,
	
	  /**
	   * The total number of rows.
	   */
	  count: _propTypes.default.number.isRequired,
	
	  /**
	   * Props applied to the next arrow [`IconButton`](/api/icon-button/) element.
	   */
	  nextIconButtonProps: _propTypes.default.object,
	
	  /**
	   * Callback fired when the page is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {number} page The page selected.
	   */
	  onChangePage: _propTypes.default.func.isRequired,
	
	  /**
	   * The zero-based index of the current page.
	   */
	  page: _propTypes.default.number.isRequired,
	
	  /**
	   * The number of rows per page.
	   */
	  rowsPerPage: _propTypes.default.number.isRequired
	} : void 0;
	var _default = TablePaginationActions;
	exports.default = _default;

/***/ },
/* 1271 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TablePagination.default;
	  }
	});
	
	var _TablePagination = _interopRequireDefault(__webpack_require__(1269));

/***/ },
/* 1272 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _Tablelvl2Context = _interopRequireDefault(__webpack_require__(239));
	
	var _colorManipulator = __webpack_require__(63);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      color: 'inherit',
	      display: 'table-row',
	      verticalAlign: 'middle',
	      // We disable the focus ring for mouse, touch and keyboard users.
	      outline: 0,
	      '&$hover:hover': {
	        backgroundColor: theme.palette.action.hover
	      },
	      '&$selected, &$selected:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.selectedOpacity)
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `selected={true}`. */
	    selected: {},
	
	    /* Pseudo-class applied to the root element if `hover={true}`. */
	    hover: {},
	
	    /* Styles applied to the root element if table variant="head". */
	    head: {},
	
	    /* Styles applied to the root element if table variant="footer". */
	    footer: {}
	  };
	};
	
	exports.styles = styles;
	var defaultComponent = 'tr';
	/**
	 * Will automatically set dynamic row height
	 * based on the material table element parent (head, body, etc).
	 */
	
	var TableRow = /*#__PURE__*/React.forwardRef(function TableRow(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? defaultComponent : _props$component,
	      _props$hover = props.hover,
	      hover = _props$hover === void 0 ? false : _props$hover,
	      _props$selected = props.selected,
	      selected = _props$selected === void 0 ? false : _props$selected,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "hover", "selected"]);
	  var tablelvl2 = React.useContext(_Tablelvl2Context.default);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    ref: ref,
	    className: (0, _clsx.default)(classes.root, className, tablelvl2 && {
	      'head': classes.head,
	      'footer': classes.footer
	    }[tablelvl2.variant], hover && classes.hover, selected && classes.selected),
	    role: Component === defaultComponent ? null : 'row'
	  }, other));
	});
	 false ? TableRow.propTypes = {
	  /**
	   * Should be valid <tr> children such as `TableCell`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, the table row will shade on hover.
	   */
	  hover: _propTypes.default.bool,
	
	  /**
	   * If `true`, the table row will have the selected shading.
	   */
	  selected: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableRow'
	})(TableRow);
	
	exports.default = _default;

/***/ },
/* 1273 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TableRow.default;
	  }
	});
	
	var _TableRow = _interopRequireDefault(__webpack_require__(1272));

/***/ },
/* 1274 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _ArrowDownward = _interopRequireDefault(__webpack_require__(1301));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(69));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      cursor: 'pointer',
	      display: 'inline-flex',
	      justifyContent: 'flex-start',
	      flexDirection: 'inherit',
	      alignItems: 'center',
	      '&:focus': {
	        color: theme.palette.text.secondary
	      },
	      '&:hover': {
	        color: theme.palette.text.secondary,
	        '& $icon': {
	          opacity: 0.5
	        }
	      },
	      '&$active': {
	        color: theme.palette.text.primary,
	        // && instead of & is a workaround for https://github.com/cssinjs/jss/issues/1045
	        '&& $icon': {
	          opacity: 1,
	          color: theme.palette.text.secondary
	        }
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `active={true}`. */
	    active: {},
	
	    /* Styles applied to the icon component. */
	    icon: {
	      fontSize: 18,
	      marginRight: 4,
	      marginLeft: 4,
	      opacity: 0,
	      transition: theme.transitions.create(['opacity', 'transform'], {
	        duration: theme.transitions.duration.shorter
	      }),
	      userSelect: 'none'
	    },
	
	    /* Styles applied to the icon component if `direction="desc"`. */
	    iconDirectionDesc: {
	      transform: 'rotate(0deg)'
	    },
	
	    /* Styles applied to the icon component if `direction="asc"`. */
	    iconDirectionAsc: {
	      transform: 'rotate(180deg)'
	    }
	  };
	};
	/**
	 * A button based label for placing inside `TableCell` for column sorting.
	 */
	
	
	exports.styles = styles;
	var TableSortLabel = /*#__PURE__*/React.forwardRef(function TableSortLabel(props, ref) {
	  var _props$active = props.active,
	      active = _props$active === void 0 ? false : _props$active,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$direction = props.direction,
	      direction = _props$direction === void 0 ? 'asc' : _props$direction,
	      _props$hideSortIcon = props.hideSortIcon,
	      hideSortIcon = _props$hideSortIcon === void 0 ? false : _props$hideSortIcon,
	      _props$IconComponent = props.IconComponent,
	      IconComponent = _props$IconComponent === void 0 ? _ArrowDownward.default : _props$IconComponent,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "children", "classes", "className", "direction", "hideSortIcon", "IconComponent"]);
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, active && classes.active),
	    component: "span",
	    disableRipple: true,
	    ref: ref
	  }, other), children, hideSortIcon && !active ? null : /*#__PURE__*/React.createElement(IconComponent, {
	    className: (0, _clsx.default)(classes.icon, classes["iconDirection".concat((0, _capitalize.default)(direction))])
	  }));
	});
	 false ? TableSortLabel.propTypes = {
	  /**
	   * If `true`, the label will have the active styling (should be true for the sorted column).
	   */
	  active: _propTypes.default.bool,
	
	  /**
	   * Label contents, the arrow will be appended automatically.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The current sort direction.
	   */
	  direction: _propTypes.default.oneOf(['asc', 'desc']),
	
	  /**
	   * Hide sort icon when active is false.
	   */
	  hideSortIcon: _propTypes.default.bool,
	
	  /**
	   * Sort icon to use.
	   */
	  IconComponent: _propTypes.default.elementType
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableSortLabel'
	})(TableSortLabel);
	
	exports.default = _default;

/***/ },
/* 1275 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TableSortLabel.default;
	  }
	});
	
	var _TableSortLabel = _interopRequireDefault(__webpack_require__(1274));

/***/ },
/* 1276 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ScrollbarSize;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _debounce = _interopRequireDefault(__webpack_require__(156));
	
	var styles = {
	  width: 99,
	  height: 99,
	  position: 'absolute',
	  top: -9999,
	  overflow: 'scroll'
	};
	/**
	 * @ignore - internal component.
	 * The component originates from https://github.com/STORIS/react-scrollbar-size.
	 * It has been moved into the core in order to minimize the bundle size.
	 */
	
	function ScrollbarSize(props) {
	  var onChange = props.onChange,
	      other = (0, _objectWithoutProperties2.default)(props, ["onChange"]);
	  var scrollbarHeight = React.useRef();
	  var nodeRef = React.useRef(null);
	
	  var setMeasurements = function setMeasurements() {
	    scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
	  };
	
	  React.useEffect(function () {
	    var handleResize = (0, _debounce.default)(function () {
	      var prevHeight = scrollbarHeight.current;
	      setMeasurements();
	
	      if (prevHeight !== scrollbarHeight.current) {
	        onChange(scrollbarHeight.current);
	      }
	    });
	    window.addEventListener('resize', handleResize);
	    return function () {
	      handleResize.clear();
	      window.removeEventListener('resize', handleResize);
	    };
	  }, [onChange]);
	  React.useEffect(function () {
	    setMeasurements();
	    onChange(scrollbarHeight.current);
	  }, [onChange]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    style: styles,
	    ref: nodeRef
	  }, other));
	}
	
	 false ? ScrollbarSize.propTypes = {
	  onChange: _propTypes.default.func.isRequired
	} : void 0;

/***/ },
/* 1277 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      position: 'absolute',
	      height: 2,
	      bottom: 0,
	      width: '100%',
	      transition: theme.transitions.create()
	    },
	    colorPrimary: {
	      backgroundColor: theme.palette.primary.main
	    },
	    colorSecondary: {
	      backgroundColor: theme.palette.secondary.main
	    },
	    vertical: {
	      height: '100%',
	      width: 2,
	      right: 0
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	exports.styles = styles;
	var TabIndicator = /*#__PURE__*/React.forwardRef(function TabIndicator(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      color = props.color,
	      orientation = props.orientation,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "orientation"]);
	  return /*#__PURE__*/React.createElement("span", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes["color".concat((0, _capitalize.default)(color))], className, orientation === 'vertical' && classes.vertical),
	    ref: ref
	  }, other));
	});
	 false ? TabIndicator.propTypes = {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   * The color of the tab indicator.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']).isRequired,
	
	  /**
	   * The tabs orientation (layout flow direction).
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']).isRequired
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateTabIndicator'
	})(TabIndicator);
	
	exports.default = _default;

/***/ },
/* 1278 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(62));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactIs = __webpack_require__(72);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _utils = __webpack_require__(19);
	
	var _debounce = _interopRequireDefault(__webpack_require__(156));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(309));
	
	var _scrollLeft = __webpack_require__(1329);
	
	var _animate = _interopRequireDefault(__webpack_require__(1300));
	
	var _ScrollbarSize = _interopRequireDefault(__webpack_require__(1276));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _TabIndicator = _interopRequireDefault(__webpack_require__(1277));
	
	var _TabScrollButton = _interopRequireDefault(__webpack_require__(604));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(117));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(59));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      overflow: 'hidden',
	      minHeight: 48,
	      WebkitOverflowScrolling: 'touch',
	      // Add iOS momentum scrolling.
	      display: 'flex'
	    },
	
	    /* Styles applied to the root element if `orientation="vertical"`. */
	    vertical: {
	      flexDirection: 'column'
	    },
	
	    /* Styles applied to the flex container element. */
	    flexContainer: {
	      display: 'flex'
	    },
	
	    /* Styles applied to the flex container element if `orientation="vertical"`. */
	    flexContainerVertical: {
	      flexDirection: 'column'
	    },
	
	    /* Styles applied to the flex container element if `centered={true}` & `!variant="scrollable"`. */
	    centered: {
	      justifyContent: 'center'
	    },
	
	    /* Styles applied to the tablist element. */
	    scroller: {
	      position: 'relative',
	      display: 'inline-block',
	      flex: '1 1 auto',
	      whiteSpace: 'nowrap'
	    },
	
	    /* Styles applied to the tablist element if `!variant="scrollable"`. */
	    fixed: {
	      overflowX: 'hidden',
	      width: '100%'
	    },
	
	    /* Styles applied to the tablist element if `variant="scrollable"`. */
	    scrollable: {
	      overflowX: 'scroll',
	      // Hide dimensionless scrollbar on MacOS
	      scrollbarWidth: 'none',
	      // Firefox
	      '&::-webkit-scrollbar': {
	        display: 'none' // Safari + Chrome
	
	      }
	    },
	
	    /* Styles applied to the `ScrollButtonComponent` component. */
	    scrollButtons: {},
	
	    /* Styles applied to the `ScrollButtonComponent` component if `scrollButtons="auto"` or scrollButtons="desktop"`. */
	    scrollButtonsDesktop: (0, _defineProperty2.default)({}, theme.breakpoints.down('xs'), {
	      display: 'none'
	    }),
	
	    /* Styles applied to the `TabIndicator` component. */
	    indicator: {}
	  };
	};
	
	exports.styles = styles;
	var Tabs = /*#__PURE__*/React.forwardRef(function Tabs(props, ref) {
	  var ariaLabel = props['aria-label'],
	      ariaLabelledBy = props['aria-labelledby'],
	      action = props.action,
	      _props$centered = props.centered,
	      centered = _props$centered === void 0 ? false : _props$centered,
	      childrenProp = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$indicatorColor = props.indicatorColor,
	      indicatorColor = _props$indicatorColor === void 0 ? 'secondary' : _props$indicatorColor,
	      onChange = props.onChange,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      _props$ScrollButtonCo = props.ScrollButtonComponent,
	      ScrollButtonComponent = _props$ScrollButtonCo === void 0 ? _TabScrollButton.default : _props$ScrollButtonCo,
	      _props$scrollButtons = props.scrollButtons,
	      scrollButtons = _props$scrollButtons === void 0 ? 'auto' : _props$scrollButtons,
	      selectionFollowsFocus = props.selectionFollowsFocus,
	      _props$TabIndicatorPr = props.TabIndicatorProps,
	      TabIndicatorProps = _props$TabIndicatorPr === void 0 ? {} : _props$TabIndicatorPr,
	      TabScrollButtonProps = props.TabScrollButtonProps,
	      _props$textColor = props.textColor,
	      textColor = _props$textColor === void 0 ? 'inherit' : _props$textColor,
	      value = props.value,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["aria-label", "aria-labelledby", "action", "centered", "children", "classes", "className", "component", "indicatorColor", "onChange", "orientation", "ScrollButtonComponent", "scrollButtons", "selectionFollowsFocus", "TabIndicatorProps", "TabScrollButtonProps", "textColor", "value", "variant"]);
	  var theme = (0, _useTheme.default)();
	  var scrollable = variant === 'scrollable';
	  var isRtl = theme.direction === 'rtl';
	  var vertical = orientation === 'vertical';
	  var scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
	  var start = vertical ? 'top' : 'left';
	  var end = vertical ? 'bottom' : 'right';
	  var clientSize = vertical ? 'clientHeight' : 'clientWidth';
	  var size = vertical ? 'height' : 'width';
	
	  if (false) {
	    if (centered && scrollable) {
	      console.error('Material-UI: You can not use the `centered={true}` and `variant="scrollable"` properties ' + 'at the same time on a `Tabs` component.');
	    }
	  }
	
	  var _React$useState = React.useState(false),
	      mounted = _React$useState[0],
	      setMounted = _React$useState[1];
	
	  var _React$useState2 = React.useState({}),
	      indicatorStyle = _React$useState2[0],
	      setIndicatorStyle = _React$useState2[1];
	
	  var _React$useState3 = React.useState({
	    start: false,
	    end: false
	  }),
	      displayScroll = _React$useState3[0],
	      setDisplayScroll = _React$useState3[1];
	
	  var _React$useState4 = React.useState({
	    overflow: 'hidden',
	    marginBottom: null
	  }),
	      scrollerStyle = _React$useState4[0],
	      setScrollerStyle = _React$useState4[1];
	
	  var valueToIndex = new Map();
	  var tabsRef = React.useRef(null);
	  var tabListRef = React.useRef(null);
	
	  var getTabsMeta = function getTabsMeta() {
	    var tabsNode = tabsRef.current;
	    var tabsMeta;
	
	    if (tabsNode) {
	      var rect = tabsNode.getBoundingClientRect(); // create a new object with ClientRect class props + scrollLeft
	
	      tabsMeta = {
	        clientWidth: tabsNode.clientWidth,
	        scrollLeft: tabsNode.scrollLeft,
	        scrollTop: tabsNode.scrollTop,
	        scrollLeftNormalized: (0, _scrollLeft.getNormalizedScrollLeft)(tabsNode, theme.direction),
	        scrollWidth: tabsNode.scrollWidth,
	        top: rect.top,
	        bottom: rect.bottom,
	        left: rect.left,
	        right: rect.right
	      };
	    }
	
	    var tabMeta;
	
	    if (tabsNode && value !== false) {
	      var _children = tabListRef.current.children;
	
	      if (_children.length > 0) {
	        var tab = _children[valueToIndex.get(value)];
	
	        if (false) {
	          if (!tab) {
	            console.error(["Material-UI: The value provided to the Tabs component is invalid.", "None of the Tabs' children match with `".concat(value, "`."), valueToIndex.keys ? "You can provide one of the following values: ".concat(Array.from(valueToIndex.keys()).join(', '), ".") : null].join('\n'));
	          }
	        }
	
	        tabMeta = tab ? tab.getBoundingClientRect() : null;
	      }
	    }
	
	    return {
	      tabsMeta: tabsMeta,
	      tabMeta: tabMeta
	    };
	  };
	
	  var updateIndicatorState = (0, _useEventCallback.default)(function () {
	    var _newIndicatorStyle;
	
	    var _getTabsMeta = getTabsMeta(),
	        tabsMeta = _getTabsMeta.tabsMeta,
	        tabMeta = _getTabsMeta.tabMeta;
	
	    var startValue = 0;
	
	    if (tabMeta && tabsMeta) {
	      if (vertical) {
	        startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
	      } else {
	        var correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
	        startValue = tabMeta.left - tabsMeta.left + correction;
	      }
	    }
	
	    var newIndicatorStyle = (_newIndicatorStyle = {}, (0, _defineProperty2.default)(_newIndicatorStyle, start, startValue), (0, _defineProperty2.default)(_newIndicatorStyle, size, tabMeta ? tabMeta[size] : 0), _newIndicatorStyle);
	
	    if (isNaN(indicatorStyle[start]) || isNaN(indicatorStyle[size])) {
	      setIndicatorStyle(newIndicatorStyle);
	    } else {
	      var dStart = Math.abs(indicatorStyle[start] - newIndicatorStyle[start]);
	      var dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
	
	      if (dStart >= 1 || dSize >= 1) {
	        setIndicatorStyle(newIndicatorStyle);
	      }
	    }
	  });
	
	  var scroll = function scroll(scrollValue) {
	    (0, _animate.default)(scrollStart, tabsRef.current, scrollValue);
	  };
	
	  var moveTabsScroll = function moveTabsScroll(delta) {
	    var scrollValue = tabsRef.current[scrollStart];
	
	    if (vertical) {
	      scrollValue += delta;
	    } else {
	      scrollValue += delta * (isRtl ? -1 : 1); // Fix for Edge
	
	      scrollValue *= isRtl && (0, _scrollLeft.detectScrollType)() === 'reverse' ? -1 : 1;
	    }
	
	    scroll(scrollValue);
	  };
	
	  var handleStartScrollClick = function handleStartScrollClick() {
	    moveTabsScroll(-tabsRef.current[clientSize]);
	  };
	
	  var handleEndScrollClick = function handleEndScrollClick() {
	    moveTabsScroll(tabsRef.current[clientSize]);
	  };
	
	  var handleScrollbarSizeChange = React.useCallback(function (scrollbarHeight) {
	    setScrollerStyle({
	      overflow: null,
	      marginBottom: -scrollbarHeight
	    });
	  }, []);
	
	  var getConditionalElements = function getConditionalElements() {
	    var conditionalElements = {};
	    conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/React.createElement(_ScrollbarSize.default, {
	      className: classes.scrollable,
	      onChange: handleScrollbarSizeChange
	    }) : null;
	    var scrollButtonsActive = displayScroll.start || displayScroll.end;
	    var showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === 'desktop' || scrollButtons === 'on');
	    conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/React.createElement(ScrollButtonComponent, (0, _extends2.default)({
	      orientation: orientation,
	      direction: isRtl ? 'right' : 'left',
	      onClick: handleStartScrollClick,
	      disabled: !displayScroll.start,
	      className: (0, _clsx.default)(classes.scrollButtons, scrollButtons !== 'on' && classes.scrollButtonsDesktop)
	    }, TabScrollButtonProps)) : null;
	    conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/React.createElement(ScrollButtonComponent, (0, _extends2.default)({
	      orientation: orientation,
	      direction: isRtl ? 'left' : 'right',
	      onClick: handleEndScrollClick,
	      disabled: !displayScroll.end,
	      className: (0, _clsx.default)(classes.scrollButtons, scrollButtons !== 'on' && classes.scrollButtonsDesktop)
	    }, TabScrollButtonProps)) : null;
	    return conditionalElements;
	  };
	
	  var scrollSelectedIntoView = (0, _useEventCallback.default)(function () {
	    var _getTabsMeta2 = getTabsMeta(),
	        tabsMeta = _getTabsMeta2.tabsMeta,
	        tabMeta = _getTabsMeta2.tabMeta;
	
	    if (!tabMeta || !tabsMeta) {
	      return;
	    }
	
	    if (tabMeta[start] < tabsMeta[start]) {
	      // left side of button is out of view
	      var nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
	      scroll(nextScrollStart);
	    } else if (tabMeta[end] > tabsMeta[end]) {
	      // right side of button is out of view
	      var _nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
	
	      scroll(_nextScrollStart);
	    }
	  });
	  var updateScrollButtonState = (0, _useEventCallback.default)(function () {
	    if (scrollable && scrollButtons !== 'off') {
	      var _tabsRef$current = tabsRef.current,
	          scrollTop = _tabsRef$current.scrollTop,
	          scrollHeight = _tabsRef$current.scrollHeight,
	          clientHeight = _tabsRef$current.clientHeight,
	          scrollWidth = _tabsRef$current.scrollWidth,
	          clientWidth = _tabsRef$current.clientWidth;
	      var showStartScroll;
	      var showEndScroll;
	
	      if (vertical) {
	        showStartScroll = scrollTop > 1;
	        showEndScroll = scrollTop < scrollHeight - clientHeight - 1;
	      } else {
	        var scrollLeft = (0, _scrollLeft.getNormalizedScrollLeft)(tabsRef.current, theme.direction); // use 1 for the potential rounding error with browser zooms.
	
	        showStartScroll = isRtl ? scrollLeft < scrollWidth - clientWidth - 1 : scrollLeft > 1;
	        showEndScroll = !isRtl ? scrollLeft < scrollWidth - clientWidth - 1 : scrollLeft > 1;
	      }
	
	      if (showStartScroll !== displayScroll.start || showEndScroll !== displayScroll.end) {
	        setDisplayScroll({
	          start: showStartScroll,
	          end: showEndScroll
	        });
	      }
	    }
	  });
	  React.useEffect(function () {
	    var handleResize = (0, _debounce.default)(function () {
	      updateIndicatorState();
	      updateScrollButtonState();
	    });
	    var win = (0, _ownerWindow.default)(tabsRef.current);
	    win.addEventListener('resize', handleResize);
	    return function () {
	      handleResize.clear();
	      win.removeEventListener('resize', handleResize);
	    };
	  }, [updateIndicatorState, updateScrollButtonState]);
	  var handleTabsScroll = React.useCallback((0, _debounce.default)(function () {
	    updateScrollButtonState();
	  }));
	  React.useEffect(function () {
	    return function () {
	      handleTabsScroll.clear();
	    };
	  }, [handleTabsScroll]);
	  React.useEffect(function () {
	    setMounted(true);
	  }, []);
	  React.useEffect(function () {
	    updateIndicatorState();
	    updateScrollButtonState();
	  });
	  React.useEffect(function () {
	    scrollSelectedIntoView();
	  }, [scrollSelectedIntoView, indicatorStyle]);
	  React.useImperativeHandle(action, function () {
	    return {
	      updateIndicator: updateIndicatorState,
	      updateScrollButtons: updateScrollButtonState
	    };
	  }, [updateIndicatorState, updateScrollButtonState]);
	  var indicator = /*#__PURE__*/React.createElement(_TabIndicator.default, (0, _extends2.default)({
	    className: classes.indicator,
	    orientation: orientation,
	    color: indicatorColor
	  }, TabIndicatorProps, {
	    style: (0, _extends2.default)({}, indicatorStyle, TabIndicatorProps.style)
	  }));
	  var childIndex = 0;
	  var children = React.Children.map(childrenProp, function (child) {
	    if (! /*#__PURE__*/React.isValidElement(child)) {
	      return null;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: The Tabs component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    var childValue = child.props.value === undefined ? childIndex : child.props.value;
	    valueToIndex.set(childValue, childIndex);
	    var selected = childValue === value;
	    childIndex += 1;
	    return /*#__PURE__*/React.cloneElement(child, {
	      fullWidth: variant === 'fullWidth',
	      indicator: selected && !mounted && indicator,
	      selected: selected,
	      selectionFollowsFocus: selectionFollowsFocus,
	      onChange: onChange,
	      textColor: textColor,
	      value: childValue
	    });
	  });
	
	  var handleKeyDown = function handleKeyDown(event) {
	    var target = event.target; // Keyboard navigation assumes that [role="tab"] are siblings
	    // though we might warn in the future about nested, interactive elements
	    // as a a11y violation
	
	    var role = target.getAttribute('role');
	
	    if (role !== 'tab') {
	      return;
	    }
	
	    var newFocusTarget = null;
	    var previousItemKey = orientation !== "vertical" ? 'ArrowLeft' : 'ArrowUp';
	    var nextItemKey = orientation !== "vertical" ? 'ArrowRight' : 'ArrowDown';
	
	    if (orientation !== "vertical" && theme.direction === 'rtl') {
	      // swap previousItemKey with nextItemKey
	      previousItemKey = 'ArrowRight';
	      nextItemKey = 'ArrowLeft';
	    }
	
	    switch (event.key) {
	      case previousItemKey:
	        newFocusTarget = target.previousElementSibling || tabListRef.current.lastChild;
	        break;
	
	      case nextItemKey:
	        newFocusTarget = target.nextElementSibling || tabListRef.current.firstChild;
	        break;
	
	      case 'Home':
	        newFocusTarget = tabListRef.current.firstChild;
	        break;
	
	      case 'End':
	        newFocusTarget = tabListRef.current.lastChild;
	        break;
	
	      default:
	        break;
	    }
	
	    if (newFocusTarget !== null) {
	      newFocusTarget.focus();
	      event.preventDefault();
	    }
	  };
	
	  var conditionalElements = getConditionalElements();
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, vertical && classes.vertical),
	    ref: ref
	  }, other), conditionalElements.scrollButtonStart, conditionalElements.scrollbarSizeListener, /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.scroller, scrollable ? classes.scrollable : classes.fixed),
	    style: scrollerStyle,
	    ref: tabsRef,
	    onScroll: handleTabsScroll
	  }, /*#__PURE__*/React.createElement("div", {
	    "aria-label": ariaLabel,
	    "aria-labelledby": ariaLabelledBy,
	    className: (0, _clsx.default)(classes.flexContainer, vertical && classes.flexContainerVertical, centered && !scrollable && classes.centered),
	    onKeyDown: handleKeyDown,
	    ref: tabListRef,
	    role: "tablist"
	  }, children), mounted && indicator), conditionalElements.scrollButtonEnd);
	});
	 false ? Tabs.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Callback fired when the component mounts.
	   * This is useful when you want to trigger an action programmatically.
	   * It supports two actions: `updateIndicator()` and `updateScrollButtons()`
	   *
	   * @param {object} actions This object contains all possible actions
	   * that can be triggered programmatically.
	   */
	  action: _utils.refType,
	
	  /**
	   * The label for the Tabs as a string.
	   */
	  'aria-label': _propTypes.default.string,
	
	  /**
	   * An id or list of ids separated by a space that label the Tabs.
	   */
	  'aria-labelledby': _propTypes.default.string,
	
	  /**
	   * If `true`, the tabs will be centered.
	   * This property is intended for large views.
	   */
	  centered: _propTypes.default.bool,
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * Determines the color of the indicator.
	   */
	  indicatorColor: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * Callback fired when the value changes.
	   *
	   * @param {object} event The event source of the callback
	   * @param {any} value We default to the index of the child (number)
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The tabs orientation (layout flow direction).
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']),
	
	  /**
	   * The component used to render the scroll buttons.
	   */
	  ScrollButtonComponent: _propTypes.default.elementType,
	
	  /**
	   * Determine behavior of scroll buttons when tabs are set to scroll:
	   *
	   * - `auto` will only present them when not all the items are visible.
	   * - `desktop` will only present them on medium and larger viewports.
	   * - `on` will always present them.
	   * - `off` will never present them.
	   */
	  scrollButtons: _propTypes.default.oneOf(['auto', 'desktop', 'off', 'on']),
	
	  /**
	   * If `true` the selected tab changes on focus. Otherwise it only
	   * changes on activation.
	   */
	  selectionFollowsFocus: _propTypes.default.bool,
	
	  /**
	   * Props applied to the tab indicator element.
	   */
	  TabIndicatorProps: _propTypes.default.object,
	
	  /**
	   * Props applied to the [`TabScrollButton`](/api/tab-scroll-button/) element.
	   */
	  TabScrollButtonProps: _propTypes.default.object,
	
	  /**
	   * Determines the color of the `Tab`.
	   */
	  textColor: _propTypes.default.oneOf(['inherit', 'primary', 'secondary']),
	
	  /**
	   * The value of the currently selected `Tab`.
	   * If you don't want any selected `Tab`, you can set this property to `false`.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * Determines additional display behavior of the tabs:
	   *
	   *  - `scrollable` will invoke scrolling properties and allow for horizontally
	   *  scrolling (or swiping) of the tab bar.
	   *  -`fullWidth` will make the tabs grow to use all the available space,
	   *  which should be used for small views, like on mobile.
	   *  - `standard` will render the default state.
	   */
	  variant: _propTypes.default.oneOf(['fullWidth', 'scrollable', 'standard'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTabs'
	})(Tabs);
	
	exports.default = _default;

/***/ },
/* 1279 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _utils = __webpack_require__(19);
	
	var _Input = _interopRequireDefault(__webpack_require__(301));
	
	var _FilledInput = _interopRequireDefault(__webpack_require__(398));
	
	var _OutlinedInput = _interopRequireDefault(__webpack_require__(401));
	
	var _InputLabel = _interopRequireDefault(__webpack_require__(587));
	
	var _FormControl = _interopRequireDefault(__webpack_require__(399));
	
	var _FormHelperText = _interopRequireDefault(__webpack_require__(585));
	
	var _Select = _interopRequireDefault(__webpack_require__(403));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var variantComponent = {
	  standard: _Input.default,
	  filled: _FilledInput.default,
	  outlined: _OutlinedInput.default
	};
	var styles = {
	  /* Styles applied to the root element. */
	  root: {}
	};
	/**
	 * The `TextField` is a convenience wrapper for the most common cases (80%).
	 * It cannot be all things to all people, otherwise the API would grow out of control.
	 *
	 * ## Advanced Configuration
	 *
	 * It's important to understand that the text field is a simple abstraction
	 * on top of the following components:
	 *
	 * - [FormControl](/api/form-control/)
	 * - [InputLabel](/api/input-label/)
	 * - [FilledInput](/api/filled-input/)
	 * - [OutlinedInput](/api/outlined-input/)
	 * - [Input](/api/input/)
	 * - [FormHelperText](/api/form-helper-text/)
	 *
	 * If you wish to alter the props applied to the `input` element, you can do so as follows:
	 *
	 * ```jsx
	 * const inputProps = {
	 *   step: 300,
	 * };
	 *
	 * return <TextField id="time" type="time" inputProps={inputProps} />;
	 * ```
	 *
	 * For advanced cases, please look at the source of TextField by clicking on the
	 * "Edit this page" button above. Consider either:
	 *
	 * - using the upper case props for passing values directly to the components
	 * - using the underlying components directly as shown in the demos
	 */
	
	exports.styles = styles;
	var TextField = /*#__PURE__*/React.forwardRef(function TextField(props, ref) {
	  var autoComplete = props.autoComplete,
	      _props$autoFocus = props.autoFocus,
	      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      defaultValue = props.defaultValue,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$error = props.error,
	      error = _props$error === void 0 ? false : _props$error,
	      FormHelperTextProps = props.FormHelperTextProps,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      helperText = props.helperText,
	      hiddenLabel = props.hiddenLabel,
	      id = props.id,
	      InputLabelProps = props.InputLabelProps,
	      inputProps = props.inputProps,
	      InputProps = props.InputProps,
	      inputRef = props.inputRef,
	      label = props.label,
	      _props$multiline = props.multiline,
	      multiline = _props$multiline === void 0 ? false : _props$multiline,
	      name = props.name,
	      onBlur = props.onBlur,
	      onChange = props.onChange,
	      onFocus = props.onFocus,
	      placeholder = props.placeholder,
	      _props$required = props.required,
	      required = _props$required === void 0 ? false : _props$required,
	      rows = props.rows,
	      rowsMax = props.rowsMax,
	      _props$select = props.select,
	      select = _props$select === void 0 ? false : _props$select,
	      SelectProps = props.SelectProps,
	      type = props.type,
	      value = props.value,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["autoComplete", "autoFocus", "children", "classes", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "hiddenLabel", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "rowsMax", "select", "SelectProps", "type", "value", "variant"]);
	
	  if (false) {
	    if (select && !children) {
	      console.error('Material-UI: `children` must be passed when using the `TextField` component with `select`.');
	    }
	  }
	
	  var InputMore = {};
	
	  if (variant === 'outlined') {
	    if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') {
	      InputMore.notched = InputLabelProps.shrink;
	    }
	
	    if (label) {
	      var _InputLabelProps$requ;
	
	      var displayRequired = (_InputLabelProps$requ = InputLabelProps === null || InputLabelProps === void 0 ? void 0 : InputLabelProps.required) !== null && _InputLabelProps$requ !== void 0 ? _InputLabelProps$requ : required;
	      InputMore.label = /*#__PURE__*/React.createElement(React.Fragment, null, label, displayRequired && "\xA0*");
	    }
	  }
	
	  if (select) {
	    // unset defaults from textbox inputs
	    if (!SelectProps || !SelectProps.native) {
	      InputMore.id = undefined;
	    }
	
	    InputMore['aria-describedby'] = undefined;
	  }
	
	  var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
	  var inputLabelId = label && id ? "".concat(id, "-label") : undefined;
	  var InputComponent = variantComponent[variant];
	  var InputElement = /*#__PURE__*/React.createElement(InputComponent, (0, _extends2.default)({
	    "aria-describedby": helperTextId,
	    autoComplete: autoComplete,
	    autoFocus: autoFocus,
	    defaultValue: defaultValue,
	    fullWidth: fullWidth,
	    multiline: multiline,
	    name: name,
	    rows: rows,
	    rowsMax: rowsMax,
	    type: type,
	    value: value,
	    id: id,
	    inputRef: inputRef,
	    onBlur: onBlur,
	    onChange: onChange,
	    onFocus: onFocus,
	    placeholder: placeholder,
	    inputProps: inputProps
	  }, InputMore, InputProps));
	  return /*#__PURE__*/React.createElement(_FormControl.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    disabled: disabled,
	    error: error,
	    fullWidth: fullWidth,
	    hiddenLabel: hiddenLabel,
	    ref: ref,
	    required: required,
	    color: color,
	    variant: variant
	  }, other), label && /*#__PURE__*/React.createElement(_InputLabel.default, (0, _extends2.default)({
	    htmlFor: id,
	    id: inputLabelId
	  }, InputLabelProps), label), select ? /*#__PURE__*/React.createElement(_Select.default, (0, _extends2.default)({
	    "aria-describedby": helperTextId,
	    id: id,
	    labelId: inputLabelId,
	    value: value,
	    input: InputElement
	  }, SelectProps), children) : InputElement, helperText && /*#__PURE__*/React.createElement(_FormHelperText.default, (0, _extends2.default)({
	    id: helperTextId
	  }, FormHelperTextProps), helperText));
	});
	 false ? TextField.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * This prop helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
	   */
	  autoComplete: _propTypes.default.string,
	
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The default value of the `input` element.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the `input` element will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label will be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * Props applied to the [`FormHelperText`](/api/form-helper-text/) element.
	   */
	  FormHelperTextProps: _propTypes.default.object,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The helper text content.
	   */
	  helperText: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  hiddenLabel: _propTypes.default.bool,
	
	  /**
	   * The id of the `input` element.
	   * Use this prop to make `label` and `helperText` accessible for screen readers.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * Props applied to the [`InputLabel`](/api/input-label/) element.
	   */
	  InputLabelProps: _propTypes.default.object,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Props applied to the Input element.
	   * It will be a [`FilledInput`](/api/filled-input/),
	   * [`OutlinedInput`](/api/outlined-input/) or [`Input`](/api/input/)
	   * component depending on the `variant` prop value.
	   */
	  InputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * The label content.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
	   */
	  margin: _propTypes.default.oneOf(['dense', 'none', 'normal']),
	
	  /**
	   * If `true`, a textarea element will be rendered instead of an input.
	   */
	  multiline: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * If `true`, the label is displayed as required and the `input` element` will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Render a [`Select`](/api/select/) element while passing the Input element to `Select` as `input` parameter.
	   * If this option is set you must pass the options of the select as children.
	   */
	  select: _propTypes.default.bool,
	
	  /**
	   * Props applied to the [`Select`](/api/select/) element.
	   */
	  SelectProps: _propTypes.default.object,
	
	  /**
	   * The size of the text field.
	   */
	  size: _propTypes.default.oneOf(['medium', 'small']),
	
	  /**
	   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the `input` element, required for a controlled component.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['filled', 'outlined', 'standard'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTextField'
	})(TextField);
	
	exports.default = _default;

/***/ },
/* 1280 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _debounce = _interopRequireDefault(__webpack_require__(156));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(47));
	
	function getStyleValue(computedStyle, property) {
	  return parseInt(computedStyle[property], 10) || 0;
	}
	
	var useEnhancedEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
	var styles = {
	  /* Styles applied to the shadow textarea element. */
	  shadow: {
	    // Visibility needed to hide the extra text area on iPads
	    visibility: 'hidden',
	    // Remove from the content flow
	    position: 'absolute',
	    // Ignore the scrollbar width
	    overflow: 'hidden',
	    height: 0,
	    top: 0,
	    left: 0,
	    // Create a new layer, increase the isolation of the computed values
	    transform: 'translateZ(0)'
	  }
	};
	var TextareaAutosize = /*#__PURE__*/React.forwardRef(function TextareaAutosize(props, ref) {
	  var onChange = props.onChange,
	      rows = props.rows,
	      rowsMax = props.rowsMax,
	      _props$rowsMin = props.rowsMin,
	      rowsMinProp = _props$rowsMin === void 0 ? 1 : _props$rowsMin,
	      style = props.style,
	      value = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["onChange", "rows", "rowsMax", "rowsMin", "style", "value"]);
	  var rowsMin = rows || rowsMinProp;
	
	  var _React$useRef = React.useRef(value != null),
	      isControlled = _React$useRef.current;
	
	  var inputRef = React.useRef(null);
	  var handleRef = (0, _useForkRef.default)(ref, inputRef);
	  var shadowRef = React.useRef(null);
	  var renders = React.useRef(0);
	
	  var _React$useState = React.useState({}),
	      state = _React$useState[0],
	      setState = _React$useState[1];
	
	  var syncHeight = React.useCallback(function () {
	    var input = inputRef.current;
	    var computedStyle = window.getComputedStyle(input);
	    var inputShallow = shadowRef.current;
	    inputShallow.style.width = computedStyle.width;
	    inputShallow.value = input.value || props.placeholder || 'x';
	
	    if (inputShallow.value.slice(-1) === '\n') {
	      // Certain fonts which overflow the line height will cause the textarea
	      // to report a different scrollHeight depending on whether the last line
	      // is empty. Make it non-empty to avoid this issue.
	      inputShallow.value += ' ';
	    }
	
	    var boxSizing = computedStyle['box-sizing'];
	    var padding = getStyleValue(computedStyle, 'padding-bottom') + getStyleValue(computedStyle, 'padding-top');
	    var border = getStyleValue(computedStyle, 'border-bottom-width') + getStyleValue(computedStyle, 'border-top-width'); // The height of the inner content
	
	    var innerHeight = inputShallow.scrollHeight - padding; // Measure height of a textarea with a single row
	
	    inputShallow.value = 'x';
	    var singleRowHeight = inputShallow.scrollHeight - padding; // The height of the outer content
	
	    var outerHeight = innerHeight;
	
	    if (rowsMin) {
	      outerHeight = Math.max(Number(rowsMin) * singleRowHeight, outerHeight);
	    }
	
	    if (rowsMax) {
	      outerHeight = Math.min(Number(rowsMax) * singleRowHeight, outerHeight);
	    }
	
	    outerHeight = Math.max(outerHeight, singleRowHeight); // Take the box sizing into account for applying this value as a style.
	
	    var outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
	    var overflow = Math.abs(outerHeight - innerHeight) <= 1;
	    setState(function (prevState) {
	      // Need a large enough difference to update the height.
	      // This prevents infinite rendering loop.
	      if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
	        renders.current += 1;
	        return {
	          overflow: overflow,
	          outerHeightStyle: outerHeightStyle
	        };
	      }
	
	      if (false) {
	        if (renders.current === 20) {
	          console.error(['Material-UI: Too many re-renders. The layout is unstable.', 'TextareaAutosize limits the number of renders to prevent an infinite loop.'].join('\n'));
	        }
	      }
	
	      return prevState;
	    });
	  }, [rowsMax, rowsMin, props.placeholder]);
	  React.useEffect(function () {
	    var handleResize = (0, _debounce.default)(function () {
	      renders.current = 0;
	      syncHeight();
	    });
	    window.addEventListener('resize', handleResize);
	    return function () {
	      handleResize.clear();
	      window.removeEventListener('resize', handleResize);
	    };
	  }, [syncHeight]);
	  useEnhancedEffect(function () {
	    syncHeight();
	  });
	  React.useEffect(function () {
	    renders.current = 0;
	  }, [value]);
	
	  var handleChange = function handleChange(event) {
	    renders.current = 0;
	
	    if (!isControlled) {
	      syncHeight();
	    }
	
	    if (onChange) {
	      onChange(event);
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("textarea", (0, _extends2.default)({
	    value: value,
	    onChange: handleChange,
	    ref: handleRef // Apply the rows prop to get a "correct" first SSR paint
	    ,
	    rows: rowsMin,
	    style: (0, _extends2.default)({
	      height: state.outerHeightStyle,
	      // Need a large enough difference to allow scrolling.
	      // This prevents infinite rendering loop.
	      overflow: state.overflow ? 'hidden' : null
	    }, style)
	  }, other)), /*#__PURE__*/React.createElement("textarea", {
	    "aria-hidden": true,
	    className: props.className,
	    readOnly: true,
	    ref: shadowRef,
	    tabIndex: -1,
	    style: (0, _extends2.default)({}, styles.shadow, style)
	  }));
	});
	 false ? TextareaAutosize.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * Use `rowsMin` instead. The prop will be removed in v5.
	   *
	   * @deprecated
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Maximum number of rows to display.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Minimum number of rows to display.
	   */
	  rowsMin: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  value: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.number, _propTypes.default.string])
	} : void 0;
	var _default = TextareaAutosize;
	exports.default = _default;

/***/ },
/* 1281 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(62));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      display: 'flex',
	      alignItems: 'center'
	    },
	
	    /* Styles applied to the root element if `disableGutters={false}`. */
	    gutters: (0, _defineProperty2.default)({
	      paddingLeft: theme.spacing(2),
	      paddingRight: theme.spacing(2)
	    }, theme.breakpoints.up('sm'), {
	      paddingLeft: theme.spacing(3),
	      paddingRight: theme.spacing(3)
	    }),
	
	    /* Styles applied to the root element if `variant="regular"`. */
	    regular: theme.mixins.toolbar,
	
	    /* Styles applied to the root element if `variant="dense"`. */
	    dense: {
	      minHeight: 48
	    }
	  };
	};
	
	exports.styles = styles;
	var Toolbar = /*#__PURE__*/React.forwardRef(function Toolbar(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$disableGutters = props.disableGutters,
	      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'regular' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "disableGutters", "variant"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes[variant], className, !disableGutters && classes.gutters),
	    ref: ref
	  }, other));
	});
	 false ? Toolbar.propTypes = {
	  /**
	   * Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, disables gutter padding.
	   */
	  disableGutters: _propTypes.default.bool,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['regular', 'dense'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiToolbar'
	})(Toolbar);
	
	exports.default = _default;

/***/ },
/* 1282 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.testReset = testReset;
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(80));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(62));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(51));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _utils = __webpack_require__(19);
	
	var _colorManipulator = __webpack_require__(63);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var _Grow = _interopRequireDefault(__webpack_require__(299));
	
	var _Popper = _interopRequireDefault(__webpack_require__(597));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(47));
	
	var _unstable_useId = _interopRequireDefault(__webpack_require__(310));
	
	var _setRef = _interopRequireDefault(__webpack_require__(157));
	
	var _useIsFocusVisible2 = _interopRequireDefault(__webpack_require__(243));
	
	var _useControlled3 = _interopRequireDefault(__webpack_require__(133));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(59));
	
	function round(value) {
	  return Math.round(value * 1e5) / 1e5;
	}
	
	function arrowGenerator() {
	  return {
	    '&[x-placement*="bottom"] $arrow': {
	      top: 0,
	      left: 0,
	      marginTop: '-0.71em',
	      marginLeft: 4,
	      marginRight: 4,
	      '&::before': {
	        transformOrigin: '0 100%'
	      }
	    },
	    '&[x-placement*="top"] $arrow': {
	      bottom: 0,
	      left: 0,
	      marginBottom: '-0.71em',
	      marginLeft: 4,
	      marginRight: 4,
	      '&::before': {
	        transformOrigin: '100% 0'
	      }
	    },
	    '&[x-placement*="right"] $arrow': {
	      left: 0,
	      marginLeft: '-0.71em',
	      height: '1em',
	      width: '0.71em',
	      marginTop: 4,
	      marginBottom: 4,
	      '&::before': {
	        transformOrigin: '100% 100%'
	      }
	    },
	    '&[x-placement*="left"] $arrow': {
	      right: 0,
	      marginRight: '-0.71em',
	      height: '1em',
	      width: '0.71em',
	      marginTop: 4,
	      marginBottom: 4,
	      '&::before': {
	        transformOrigin: '0 0'
	      }
	    }
	  };
	}
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the Popper component. */
	    popper: {
	      zIndex: theme.zIndex.tooltip,
	      pointerEvents: 'none' // disable jss-rtl plugin
	
	    },
	
	    /* Styles applied to the Popper component if `interactive={true}`. */
	    popperInteractive: {
	      pointerEvents: 'auto'
	    },
	
	    /* Styles applied to the Popper component if `arrow={true}`. */
	    popperArrow: arrowGenerator(),
	
	    /* Styles applied to the tooltip (label wrapper) element. */
	    tooltip: {
	      backgroundColor: (0, _colorManipulator.fade)(theme.palette.grey[700], 0.9),
	      borderRadius: theme.shape.borderRadius,
	      color: theme.palette.common.white,
	      fontFamily: theme.typography.fontFamily,
	      padding: '4px 8px',
	      fontSize: theme.typography.pxToRem(10),
	      lineHeight: "".concat(round(14 / 10), "em"),
	      maxWidth: 300,
	      wordWrap: 'break-word',
	      fontWeight: theme.typography.fontWeightMedium
	    },
	
	    /* Styles applied to the tooltip (label wrapper) element if `arrow={true}`. */
	    tooltipArrow: {
	      position: 'relative',
	      margin: '0'
	    },
	
	    /* Styles applied to the arrow element. */
	    arrow: {
	      overflow: 'hidden',
	      position: 'absolute',
	      width: '1em',
	      height: '0.71em'
	      /* = width / sqrt(2) = (length of the hypotenuse) */
	      ,
	      boxSizing: 'border-box',
	      color: (0, _colorManipulator.fade)(theme.palette.grey[700], 0.9),
	      '&::before': {
	        content: '""',
	        margin: 'auto',
	        display: 'block',
	        width: '100%',
	        height: '100%',
	        backgroundColor: 'currentColor',
	        transform: 'rotate(45deg)'
	      }
	    },
	
	    /* Styles applied to the tooltip (label wrapper) element if the tooltip is opened by touch. */
	    touch: {
	      padding: '8px 16px',
	      fontSize: theme.typography.pxToRem(14),
	      lineHeight: "".concat(round(16 / 14), "em"),
	      fontWeight: theme.typography.fontWeightRegular
	    },
	
	    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "left". */
	    tooltipPlacementLeft: (0, _defineProperty2.default)({
	      transformOrigin: 'right center',
	      margin: '0 24px '
	    }, theme.breakpoints.up('sm'), {
	      margin: '0 14px'
	    }),
	
	    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "right". */
	    tooltipPlacementRight: (0, _defineProperty2.default)({
	      transformOrigin: 'left center',
	      margin: '0 24px'
	    }, theme.breakpoints.up('sm'), {
	      margin: '0 14px'
	    }),
	
	    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "top". */
	    tooltipPlacementTop: (0, _defineProperty2.default)({
	      transformOrigin: 'center bottom',
	      margin: '24px 0'
	    }, theme.breakpoints.up('sm'), {
	      margin: '14px 0'
	    }),
	
	    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "bottom". */
	    tooltipPlacementBottom: (0, _defineProperty2.default)({
	      transformOrigin: 'center top',
	      margin: '24px 0'
	    }, theme.breakpoints.up('sm'), {
	      margin: '14px 0'
	    })
	  };
	};
	
	exports.styles = styles;
	var hystersisOpen = false;
	var hystersisTimer = null;
	
	function testReset() {
	  hystersisOpen = false;
	  clearTimeout(hystersisTimer);
	}
	
	var Tooltip = /*#__PURE__*/React.forwardRef(function Tooltip(props, ref) {
	  var _props$arrow = props.arrow,
	      arrow = _props$arrow === void 0 ? false : _props$arrow,
	      children = props.children,
	      classes = props.classes,
	      _props$disableFocusLi = props.disableFocusListener,
	      disableFocusListener = _props$disableFocusLi === void 0 ? false : _props$disableFocusLi,
	      _props$disableHoverLi = props.disableHoverListener,
	      disableHoverListener = _props$disableHoverLi === void 0 ? false : _props$disableHoverLi,
	      _props$disableTouchLi = props.disableTouchListener,
	      disableTouchListener = _props$disableTouchLi === void 0 ? false : _props$disableTouchLi,
	      _props$enterDelay = props.enterDelay,
	      enterDelay = _props$enterDelay === void 0 ? 100 : _props$enterDelay,
	      _props$enterNextDelay = props.enterNextDelay,
	      enterNextDelay = _props$enterNextDelay === void 0 ? 0 : _props$enterNextDelay,
	      _props$enterTouchDela = props.enterTouchDelay,
	      enterTouchDelay = _props$enterTouchDela === void 0 ? 700 : _props$enterTouchDela,
	      idProp = props.id,
	      _props$interactive = props.interactive,
	      interactive = _props$interactive === void 0 ? false : _props$interactive,
	      _props$leaveDelay = props.leaveDelay,
	      leaveDelay = _props$leaveDelay === void 0 ? 0 : _props$leaveDelay,
	      _props$leaveTouchDela = props.leaveTouchDelay,
	      leaveTouchDelay = _props$leaveTouchDela === void 0 ? 1500 : _props$leaveTouchDela,
	      onClose = props.onClose,
	      onOpen = props.onOpen,
	      openProp = props.open,
	      _props$placement = props.placement,
	      placement = _props$placement === void 0 ? 'bottom' : _props$placement,
	      _props$PopperComponen = props.PopperComponent,
	      PopperComponent = _props$PopperComponen === void 0 ? _Popper.default : _props$PopperComponen,
	      PopperProps = props.PopperProps,
	      title = props.title,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Grow.default : _props$TransitionComp,
	      TransitionProps = props.TransitionProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["arrow", "children", "classes", "disableFocusListener", "disableHoverListener", "disableTouchListener", "enterDelay", "enterNextDelay", "enterTouchDelay", "id", "interactive", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperComponent", "PopperProps", "title", "TransitionComponent", "TransitionProps"]);
	  var theme = (0, _useTheme.default)();
	
	  var _React$useState = React.useState(),
	      childNode = _React$useState[0],
	      setChildNode = _React$useState[1];
	
	  var _React$useState2 = React.useState(null),
	      arrowRef = _React$useState2[0],
	      setArrowRef = _React$useState2[1];
	
	  var ignoreNonTouchEvents = React.useRef(false);
	  var closeTimer = React.useRef();
	  var enterTimer = React.useRef();
	  var leaveTimer = React.useRef();
	  var touchTimer = React.useRef();
	
	  var _useControlled = (0, _useControlled3.default)({
	    controlled: openProp,
	    default: false,
	    name: 'Tooltip',
	    state: 'open'
	  }),
	      _useControlled2 = (0, _slicedToArray2.default)(_useControlled, 2),
	      openState = _useControlled2[0],
	      setOpenState = _useControlled2[1];
	
	  var open = openState;
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    var _React$useRef = React.useRef(openProp !== undefined),
	        isControlled = _React$useRef.current; // eslint-disable-next-line react-hooks/rules-of-hooks
	
	
	    React.useEffect(function () {
	      if (childNode && childNode.disabled && !isControlled && title !== '' && childNode.tagName.toLowerCase() === 'button') {
	        console.error(['Material-UI: You are providing a disabled `button` child to the Tooltip component.', 'A disabled element does not fire events.', "Tooltip needs to listen to the child element's events to display the title.", '', 'Add a simple wrapper element, such as a `span`.'].join('\n'));
	      }
	    }, [title, childNode, isControlled]);
	  }
	
	  var id = (0, _unstable_useId.default)(idProp);
	  React.useEffect(function () {
	    return function () {
	      clearTimeout(closeTimer.current);
	      clearTimeout(enterTimer.current);
	      clearTimeout(leaveTimer.current);
	      clearTimeout(touchTimer.current);
	    };
	  }, []);
	
	  var handleOpen = function handleOpen(event) {
	    clearTimeout(hystersisTimer);
	    hystersisOpen = true; // The mouseover event will trigger for every nested element in the tooltip.
	    // We can skip rerendering when the tooltip is already open.
	    // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
	
	    setOpenState(true);
	
	    if (onOpen) {
	      onOpen(event);
	    }
	  };
	
	  var handleEnter = function handleEnter() {
	    var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	    return function (event) {
	      var childrenProps = children.props;
	
	      if (event.type === 'mouseover' && childrenProps.onMouseOver && forward) {
	        childrenProps.onMouseOver(event);
	      }
	
	      if (ignoreNonTouchEvents.current && event.type !== 'touchstart') {
	        return;
	      } // Remove the title ahead of time.
	      // We don't want to wait for the next render commit.
	      // We would risk displaying two tooltips at the same time (native + this one).
	
	
	      if (childNode) {
	        childNode.removeAttribute('title');
	      }
	
	      clearTimeout(enterTimer.current);
	      clearTimeout(leaveTimer.current);
	
	      if (enterDelay || hystersisOpen && enterNextDelay) {
	        event.persist();
	        enterTimer.current = setTimeout(function () {
	          handleOpen(event);
	        }, hystersisOpen ? enterNextDelay : enterDelay);
	      } else {
	        handleOpen(event);
	      }
	    };
	  };
	
	  var _useIsFocusVisible = (0, _useIsFocusVisible2.default)(),
	      isFocusVisible = _useIsFocusVisible.isFocusVisible,
	      onBlurVisible = _useIsFocusVisible.onBlurVisible,
	      focusVisibleRef = _useIsFocusVisible.ref;
	
	  var _React$useState3 = React.useState(false),
	      childIsFocusVisible = _React$useState3[0],
	      setChildIsFocusVisible = _React$useState3[1];
	
	  var handleBlur = function handleBlur() {
	    if (childIsFocusVisible) {
	      setChildIsFocusVisible(false);
	      onBlurVisible();
	    }
	  };
	
	  var handleFocus = function handleFocus() {
	    var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	    return function (event) {
	      // Workaround for https://github.com/facebook/react/issues/7769
	      // The autoFocus of React might trigger the event before the componentDidMount.
	      // We need to account for this eventuality.
	      if (!childNode) {
	        setChildNode(event.currentTarget);
	      }
	
	      if (isFocusVisible(event)) {
	        setChildIsFocusVisible(true);
	        handleEnter()(event);
	      }
	
	      var childrenProps = children.props;
	
	      if (childrenProps.onFocus && forward) {
	        childrenProps.onFocus(event);
	      }
	    };
	  };
	
	  var handleClose = function handleClose(event) {
	    clearTimeout(hystersisTimer);
	    hystersisTimer = setTimeout(function () {
	      hystersisOpen = false;
	    }, 800 + leaveDelay);
	    setOpenState(false);
	
	    if (onClose) {
	      onClose(event);
	    }
	
	    clearTimeout(closeTimer.current);
	    closeTimer.current = setTimeout(function () {
	      ignoreNonTouchEvents.current = false;
	    }, theme.transitions.duration.shortest);
	  };
	
	  var handleLeave = function handleLeave() {
	    var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	    return function (event) {
	      var childrenProps = children.props;
	
	      if (event.type === 'blur') {
	        if (childrenProps.onBlur && forward) {
	          childrenProps.onBlur(event);
	        }
	
	        handleBlur();
	      }
	
	      if (event.type === 'mouseleave' && childrenProps.onMouseLeave && event.currentTarget === childNode) {
	        childrenProps.onMouseLeave(event);
	      }
	
	      clearTimeout(enterTimer.current);
	      clearTimeout(leaveTimer.current);
	      event.persist();
	      leaveTimer.current = setTimeout(function () {
	        handleClose(event);
	      }, leaveDelay);
	    };
	  };
	
	  var detectTouchStart = function detectTouchStart(event) {
	    ignoreNonTouchEvents.current = true;
	    var childrenProps = children.props;
	
	    if (childrenProps.onTouchStart) {
	      childrenProps.onTouchStart(event);
	    }
	  };
	
	  var handleTouchStart = function handleTouchStart(event) {
	    detectTouchStart(event);
	    clearTimeout(leaveTimer.current);
	    clearTimeout(closeTimer.current);
	    clearTimeout(touchTimer.current);
	    event.persist();
	    touchTimer.current = setTimeout(function () {
	      handleEnter()(event);
	    }, enterTouchDelay);
	  };
	
	  var handleTouchEnd = function handleTouchEnd(event) {
	    if (children.props.onTouchEnd) {
	      children.props.onTouchEnd(event);
	    }
	
	    clearTimeout(touchTimer.current);
	    clearTimeout(leaveTimer.current);
	    event.persist();
	    leaveTimer.current = setTimeout(function () {
	      handleClose(event);
	    }, leaveTouchDelay);
	  };
	
	  var handleUseRef = (0, _useForkRef.default)(setChildNode, ref);
	  var handleFocusRef = (0, _useForkRef.default)(focusVisibleRef, handleUseRef); // can be removed once we drop support for non ref forwarding class components
	
	  var handleOwnRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    (0, _setRef.default)(handleFocusRef, ReactDOM.findDOMNode(instance));
	  }, [handleFocusRef]);
	  var handleRef = (0, _useForkRef.default)(children.ref, handleOwnRef); // There is no point in displaying an empty tooltip.
	
	  if (title === '') {
	    open = false;
	  } // For accessibility and SEO concerns, we render the title to the DOM node when
	  // the tooltip is hidden. However, we have made a tradeoff when
	  // `disableHoverListener` is set. This title logic is disabled.
	  // It's allowing us to keep the implementation size minimal.
	  // We are open to change the tradeoff.
	
	
	  var shouldShowNativeTitle = !open && !disableHoverListener;
	  var childrenProps = (0, _extends2.default)({
	    'aria-describedby': open ? id : null,
	    title: shouldShowNativeTitle && typeof title === 'string' ? title : null
	  }, other, children.props, {
	    className: (0, _clsx.default)(other.className, children.props.className),
	    onTouchStart: detectTouchStart,
	    ref: handleRef
	  });
	  var interactiveWrapperListeners = {};
	
	  if (!disableTouchListener) {
	    childrenProps.onTouchStart = handleTouchStart;
	    childrenProps.onTouchEnd = handleTouchEnd;
	  }
	
	  if (!disableHoverListener) {
	    childrenProps.onMouseOver = handleEnter();
	    childrenProps.onMouseLeave = handleLeave();
	
	    if (interactive) {
	      interactiveWrapperListeners.onMouseOver = handleEnter(false);
	      interactiveWrapperListeners.onMouseLeave = handleLeave(false);
	    }
	  }
	
	  if (!disableFocusListener) {
	    childrenProps.onFocus = handleFocus();
	    childrenProps.onBlur = handleLeave();
	
	    if (interactive) {
	      interactiveWrapperListeners.onFocus = handleFocus(false);
	      interactiveWrapperListeners.onBlur = handleLeave(false);
	    }
	  }
	
	  if (false) {
	    if (children.props.title) {
	      console.error(['Material-UI: You have provided a `title` prop to the child of <Tooltip />.', "Remove this title prop `".concat(children.props.title, "` or the Tooltip component.")].join('\n'));
	    }
	  }
	
	  var mergedPopperProps = React.useMemo(function () {
	    return (0, _utils.deepmerge)({
	      popperOptions: {
	        modifiers: {
	          arrow: {
	            enabled: Boolean(arrowRef),
	            element: arrowRef
	          }
	        }
	      }
	    }, PopperProps);
	  }, [arrowRef, PopperProps]);
	  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.cloneElement(children, childrenProps), /*#__PURE__*/React.createElement(PopperComponent, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.popper, interactive && classes.popperInteractive, arrow && classes.popperArrow),
	    placement: placement,
	    anchorEl: childNode,
	    open: childNode ? open : false,
	    id: childrenProps['aria-describedby'],
	    transition: true
	  }, interactiveWrapperListeners, mergedPopperProps), function (_ref) {
	    var placementInner = _ref.placement,
	        TransitionPropsInner = _ref.TransitionProps;
	    return /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	      timeout: theme.transitions.duration.shorter
	    }, TransitionPropsInner, TransitionProps), /*#__PURE__*/React.createElement("div", {
	      className: (0, _clsx.default)(classes.tooltip, classes["tooltipPlacement".concat((0, _capitalize.default)(placementInner.split('-')[0]))], ignoreNonTouchEvents.current && classes.touch, arrow && classes.tooltipArrow)
	    }, title, arrow ? /*#__PURE__*/React.createElement("span", {
	      className: classes.arrow,
	      ref: setArrowRef
	    }) : null));
	  }));
	});
	 false ? Tooltip.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * If `true`, adds an arrow to the tooltip.
	   */
	  arrow: _propTypes.default.bool,
	
	  /**
	   * Tooltip reference element.
	   */
	  children: _utils.elementAcceptingRef.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Do not respond to focus events.
	   */
	  disableFocusListener: _propTypes.default.bool,
	
	  /**
	   * Do not respond to hover events.
	   */
	  disableHoverListener: _propTypes.default.bool,
	
	  /**
	   * Do not respond to long press touch events.
	   */
	  disableTouchListener: _propTypes.default.bool,
	
	  /**
	   * The number of milliseconds to wait before showing the tooltip.
	   * This prop won't impact the enter touch delay (`enterTouchDelay`).
	   */
	  enterDelay: _propTypes.default.number,
	
	  /**
	   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
	   */
	  enterNextDelay: _propTypes.default.number,
	
	  /**
	   * The number of milliseconds a user must touch the element before showing the tooltip.
	   */
	  enterTouchDelay: _propTypes.default.number,
	
	  /**
	   * This prop is used to help implement the accessibility logic.
	   * If you don't provide this prop. It falls back to a randomly generated id.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * Makes a tooltip interactive, i.e. will not close when the user
	   * hovers over the tooltip before the `leaveDelay` is expired.
	   */
	  interactive: _propTypes.default.bool,
	
	  /**
	   * The number of milliseconds to wait before hiding the tooltip.
	   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
	   */
	  leaveDelay: _propTypes.default.number,
	
	  /**
	   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
	   */
	  leaveTouchDelay: _propTypes.default.number,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be open.
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onOpen: _propTypes.default.func,
	
	  /**
	   * If `true`, the tooltip is shown.
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * Tooltip placement.
	   */
	  placement: _propTypes.default.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
	
	  /**
	   * The component used for the popper.
	   */
	  PopperComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the [`Popper`](/api/popper/) element.
	   */
	  PopperProps: _propTypes.default.object,
	
	  /**
	   * Tooltip title. Zero-length titles string are never displayed.
	   */
	  title: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .node.isRequired,
	
	  /**
	   * The component used for the transition.
	   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
	   */
	  TransitionComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
	   */
	  TransitionProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTooltip',
	  flip: false
	})(Tooltip);
	
	exports.default = _default;

/***/ },
/* 1283 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(25));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      margin: 0
	    },
	
	    /* Styles applied to the root element if `variant="body2"`. */
	    body2: theme.typography.body2,
	
	    /* Styles applied to the root element if `variant="body1"`. */
	    body1: theme.typography.body1,
	
	    /* Styles applied to the root element if `variant="caption"`. */
	    caption: theme.typography.caption,
	
	    /* Styles applied to the root element if `variant="button"`. */
	    button: theme.typography.button,
	
	    /* Styles applied to the root element if `variant="h1"`. */
	    h1: theme.typography.h1,
	
	    /* Styles applied to the root element if `variant="h2"`. */
	    h2: theme.typography.h2,
	
	    /* Styles applied to the root element if `variant="h3"`. */
	    h3: theme.typography.h3,
	
	    /* Styles applied to the root element if `variant="h4"`. */
	    h4: theme.typography.h4,
	
	    /* Styles applied to the root element if `variant="h5"`. */
	    h5: theme.typography.h5,
	
	    /* Styles applied to the root element if `variant="h6"`. */
	    h6: theme.typography.h6,
	
	    /* Styles applied to the root element if `variant="subtitle1"`. */
	    subtitle1: theme.typography.subtitle1,
	
	    /* Styles applied to the root element if `variant="subtitle2"`. */
	    subtitle2: theme.typography.subtitle2,
	
	    /* Styles applied to the root element if `variant="overline"`. */
	    overline: theme.typography.overline,
	
	    /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */
	    srOnly: {
	      position: 'absolute',
	      height: 1,
	      width: 1,
	      overflow: 'hidden'
	    },
	
	    /* Styles applied to the root element if `align="left"`. */
	    alignLeft: {
	      textAlign: 'left'
	    },
	
	    /* Styles applied to the root element if `align="center"`. */
	    alignCenter: {
	      textAlign: 'center'
	    },
	
	    /* Styles applied to the root element if `align="right"`. */
	    alignRight: {
	      textAlign: 'right'
	    },
	
	    /* Styles applied to the root element if `align="justify"`. */
	    alignJustify: {
	      textAlign: 'justify'
	    },
	
	    /* Styles applied to the root element if `nowrap={true}`. */
	    noWrap: {
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap'
	    },
	
	    /* Styles applied to the root element if `gutterBottom={true}`. */
	    gutterBottom: {
	      marginBottom: '0.35em'
	    },
	
	    /* Styles applied to the root element if `paragraph={true}`. */
	    paragraph: {
	      marginBottom: 16
	    },
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the root element if `color="textPrimary"`. */
	    colorTextPrimary: {
	      color: theme.palette.text.primary
	    },
	
	    /* Styles applied to the root element if `color="textSecondary"`. */
	    colorTextSecondary: {
	      color: theme.palette.text.secondary
	    },
	
	    /* Styles applied to the root element if `color="error"`. */
	    colorError: {
	      color: theme.palette.error.main
	    },
	
	    /* Styles applied to the root element if `display="inline"`. */
	    displayInline: {
	      display: 'inline'
	    },
	
	    /* Styles applied to the root element if `display="block"`. */
	    displayBlock: {
	      display: 'block'
	    }
	  };
	};
	
	exports.styles = styles;
	var defaultVariantMapping = {
	  h1: 'h1',
	  h2: 'h2',
	  h3: 'h3',
	  h4: 'h4',
	  h5: 'h5',
	  h6: 'h6',
	  subtitle1: 'h6',
	  subtitle2: 'h6',
	  body1: 'p',
	  body2: 'p'
	};
	var Typography = /*#__PURE__*/React.forwardRef(function Typography(props, ref) {
	  var _props$align = props.align,
	      align = _props$align === void 0 ? 'inherit' : _props$align,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'initial' : _props$color,
	      component = props.component,
	      _props$display = props.display,
	      display = _props$display === void 0 ? 'initial' : _props$display,
	      _props$gutterBottom = props.gutterBottom,
	      gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom,
	      _props$noWrap = props.noWrap,
	      noWrap = _props$noWrap === void 0 ? false : _props$noWrap,
	      _props$paragraph = props.paragraph,
	      paragraph = _props$paragraph === void 0 ? false : _props$paragraph,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'body1' : _props$variant,
	      _props$variantMapping = props.variantMapping,
	      variantMapping = _props$variantMapping === void 0 ? defaultVariantMapping : _props$variantMapping,
	      other = (0, _objectWithoutProperties2.default)(props, ["align", "classes", "className", "color", "component", "display", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"]);
	  var Component = component || (paragraph ? 'p' : variantMapping[variant] || defaultVariantMapping[variant]) || 'span';
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, variant !== 'inherit' && classes[variant], color !== 'initial' && classes["color".concat((0, _capitalize.default)(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== 'inherit' && classes["align".concat((0, _capitalize.default)(align))], display !== 'initial' && classes["display".concat((0, _capitalize.default)(display))]),
	    ref: ref
	  }, other));
	});
	 false ? Typography.propTypes = {
	  /**
	   * Set the text-align on the component.
	   */
	  align: _propTypes.default.oneOf(['inherit', 'left', 'center', 'right', 'justify']),
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   * Overrides the behavior of the `variantMapping` prop.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * Controls the display type
	   */
	  display: _propTypes.default.oneOf(['initial', 'block', 'inline']),
	
	  /**
	   * If `true`, the text will have a bottom margin.
	   */
	  gutterBottom: _propTypes.default.bool,
	
	  /**
	   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
	   *
	   * Note that text overflow can only happen with block or inline-block level elements
	   * (the element needs to have a width in order to overflow).
	   */
	  noWrap: _propTypes.default.bool,
	
	  /**
	   * If `true`, the text will have a bottom margin.
	   */
	  paragraph: _propTypes.default.bool,
	
	  /**
	   * Applies the theme typography styles.
	   */
	  variant: _propTypes.default.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline', 'srOnly', 'inherit']),
	
	  /**
	   * The component maps the variant prop to a range of different HTML element types.
	   * For instance, subtitle1 to `<h6>`.
	   * If you wish to change that mapping, you can provide your own.
	   * Alternatively, you can use the `component` prop.
	   */
	  variantMapping: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTypography'
	})(Typography);
	
	exports.default = _default;

/***/ },
/* 1284 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(51));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(90));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(47));
	
	var _utils = __webpack_require__(19);
	
	/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex, camelcase */
	
	/**
	 * Utility component that locks focus inside the component.
	 */
	function Unstable_TrapFocus(props) {
	  var children = props.children,
	      _props$disableAutoFoc = props.disableAutoFocus,
	      disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
	      _props$disableEnforce = props.disableEnforceFocus,
	      disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
	      _props$disableRestore = props.disableRestoreFocus,
	      disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
	      getDoc = props.getDoc,
	      isEnabled = props.isEnabled,
	      open = props.open;
	  var ignoreNextEnforceFocus = React.useRef();
	  var sentinelStart = React.useRef(null);
	  var sentinelEnd = React.useRef(null);
	  var nodeToRestore = React.useRef();
	  var rootRef = React.useRef(null); // can be removed once we drop support for non ref forwarding class components
	
	  var handleOwnRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    rootRef.current = ReactDOM.findDOMNode(instance);
	  }, []);
	  var handleRef = (0, _useForkRef.default)(children.ref, handleOwnRef);
	  var prevOpenRef = React.useRef();
	  React.useEffect(function () {
	    prevOpenRef.current = open;
	  }, [open]);
	
	  if (!prevOpenRef.current && open && typeof window !== 'undefined') {
	    // WARNING: Potentially unsafe in concurrent mode.
	    // The way the read on `nodeToRestore` is setup could make this actually safe.
	    // Say we render `open={false}` -> `open={true}` but never commit.
	    // We have now written a state that wasn't committed. But no committed effect
	    // will read this wrong value. We only read from `nodeToRestore` in effects
	    // that were committed on `open={true}`
	    // WARNING: Prevents the instance from being garbage collected. Should only
	    // hold a weak ref.
	    nodeToRestore.current = getDoc().activeElement;
	  }
	
	  React.useEffect(function () {
	    if (!open) {
	      return;
	    }
	
	    var doc = (0, _ownerDocument.default)(rootRef.current); // We might render an empty child.
	
	    if (!disableAutoFocus && rootRef.current && !rootRef.current.contains(doc.activeElement)) {
	      if (!rootRef.current.hasAttribute('tabIndex')) {
	        if (false) {
	          console.error(['Material-UI: The modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n'));
	        }
	
	        rootRef.current.setAttribute('tabIndex', -1);
	      }
	
	      rootRef.current.focus();
	    }
	
	    var contain = function contain() {
	      if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
	        ignoreNextEnforceFocus.current = false;
	        return;
	      }
	
	      if (rootRef.current && !rootRef.current.contains(doc.activeElement)) {
	        rootRef.current.focus();
	      }
	    };
	
	    var loopFocus = function loopFocus(event) {
	      // 9 = Tab
	      if (disableEnforceFocus || !isEnabled() || event.keyCode !== 9) {
	        return;
	      } // Make sure the next tab starts from the right place.
	
	
	      if (doc.activeElement === rootRef.current) {
	        // We need to ignore the next contain as
	        // it will try to move the focus back to the rootRef element.
	        ignoreNextEnforceFocus.current = true;
	
	        if (event.shiftKey) {
	          sentinelEnd.current.focus();
	        } else {
	          sentinelStart.current.focus();
	        }
	      }
	    };
	
	    doc.addEventListener('focus', contain, true);
	    doc.addEventListener('keydown', loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area
	    // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
	    //
	    // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
	    // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
	
	    var interval = setInterval(function () {
	      contain();
	    }, 50);
	    return function () {
	      clearInterval(interval);
	      doc.removeEventListener('focus', contain, true);
	      doc.removeEventListener('keydown', loopFocus, true); // restoreLastFocus()
	
	      if (!disableRestoreFocus) {
	        // In IE 11 it is possible for document.activeElement to be null resulting
	        // in nodeToRestore.current being null.
	        // Not all elements in IE 11 have a focus method.
	        // Once IE 11 support is dropped the focus() call can be unconditional.
	        if (nodeToRestore.current && nodeToRestore.current.focus) {
	          nodeToRestore.current.focus();
	        }
	
	        nodeToRestore.current = null;
	      }
	    };
	  }, [disableAutoFocus, disableEnforceFocus, disableRestoreFocus, isEnabled, open]);
	  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
	    tabIndex: 0,
	    ref: sentinelStart,
	    "data-test": "sentinelStart"
	  }), /*#__PURE__*/React.cloneElement(children, {
	    ref: handleRef
	  }), /*#__PURE__*/React.createElement("div", {
	    tabIndex: 0,
	    ref: sentinelEnd,
	    "data-test": "sentinelEnd"
	  }));
	}
	
	 false ? Unstable_TrapFocus.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * If `true`, the trap focus will not automatically shift focus to itself when it opens, and
	   * replace it to the last focused element when it closes.
	   * This also works correctly with any trap focus children that have the `disableAutoFocus` prop.
	   *
	   * Generally this should never be set to `true` as it makes the trap focus less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableAutoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, the trap focus will not prevent focus from leaving the trap focus while open.
	   *
	   * Generally this should never be set to `true` as it makes the trap focus less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableEnforceFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, the trap focus will not restore focus to previously focused element once
	   * trap focus is hidden.
	   */
	  disableRestoreFocus: _propTypes.default.bool,
	
	  /**
	   * Return the document to consider.
	   * We use it to implement the restore focus between different browser documents.
	   */
	  getDoc: _propTypes.default.func.isRequired,
	
	  /**
	   * Do we still want to enforce the focus?
	   * This prop helps nesting TrapFocus elements.
	   */
	  isEnabled: _propTypes.default.func.isRequired,
	
	  /**
	   * If `true`, focus will be locked.
	   */
	  open: _propTypes.default.bool.isRequired
	} : void 0;
	
	if (false) {
	  // eslint-disable-next-line
	  Unstable_TrapFocus['propTypes' + ''] = (0, _utils.exactProp)(Unstable_TrapFocus.propTypes);
	}
	
	var _default = Unstable_TrapFocus;
	exports.default = _default;

/***/ },
/* 1285 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(80));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactTransitionGroup = __webpack_require__(230);
	
	var _transitions = __webpack_require__(99);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(59));
	
	var _utils = __webpack_require__(193);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(47));
	
	var styles = {
	  entering: {
	    transform: 'none'
	  },
	  entered: {
	    transform: 'none'
	  }
	};
	var defaultTimeout = {
	  enter: _transitions.duration.enteringScreen,
	  exit: _transitions.duration.leavingScreen
	};
	/**
	 * The Zoom transition can be used for the floating variant of the
	 * [Button](/components/buttons/#floating-action-buttons) component.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	var Zoom = /*#__PURE__*/React.forwardRef(function Zoom(props, ref) {
	  var children = props.children,
	      _props$disableStrictM = props.disableStrictModeCompat,
	      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
	      inProp = props.in,
	      onEnter = props.onEnter,
	      onEntered = props.onEntered,
	      onEntering = props.onEntering,
	      onExit = props.onExit,
	      onExited = props.onExited,
	      onExiting = props.onExiting,
	      style = props.style,
	      _props$timeout = props.timeout,
	      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _reactTransitionGroup.Transition : _props$TransitionComp,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);
	  var theme = (0, _useTheme.default)();
	  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
	  var nodeRef = React.useRef(null);
	  var foreignRef = (0, _useForkRef.default)(children.ref, ref);
	  var handleRef = (0, _useForkRef.default)(enableStrictModeCompat ? nodeRef : undefined, foreignRef);
	
	  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
	    return function (nodeOrAppearing, maybeAppearing) {
	      if (callback) {
	        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
	            _ref2 = (0, _slicedToArray2.default)(_ref, 2),
	            node = _ref2[0],
	            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
	
	
	        if (isAppearing === undefined) {
	          callback(node);
	        } else {
	          callback(node, isAppearing);
	        }
	      }
	    };
	  };
	
	  var handleEntering = normalizedTransitionCallback(onEntering);
	  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
	    (0, _utils.reflow)(node); // So the animation always start from the start.
	
	    var transitionProps = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'enter'
	    });
	    node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
	    node.style.transition = theme.transitions.create('transform', transitionProps);
	
	    if (onEnter) {
	      onEnter(node, isAppearing);
	    }
	  });
	  var handleEntered = normalizedTransitionCallback(onEntered);
	  var handleExiting = normalizedTransitionCallback(onExiting);
	  var handleExit = normalizedTransitionCallback(function (node) {
	    var transitionProps = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'exit'
	    });
	    node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
	    node.style.transition = theme.transitions.create('transform', transitionProps);
	
	    if (onExit) {
	      onExit(node);
	    }
	  });
	  var handleExited = normalizedTransitionCallback(onExited);
	  return /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    appear: true,
	    in: inProp,
	    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
	    onEnter: handleEnter,
	    onEntered: handleEntered,
	    onEntering: handleEntering,
	    onExit: handleExit,
	    onExited: handleExited,
	    onExiting: handleExiting,
	    timeout: timeout
	  }, other), function (state, childProps) {
	    return /*#__PURE__*/React.cloneElement(children, (0, _extends2.default)({
	      style: (0, _extends2.default)({
	        transform: 'scale(0)',
	        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
	      }, styles[state], style, children.props.style),
	      ref: handleRef
	    }, childProps));
	  });
	});
	 false ? Zoom.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.element,
	
	  /**
	   * Enable this prop if you encounter 'Function components cannot be given refs',
	   * use `unstable_createStrictModeTheme`,
	   * and can't forward the ref in the child component.
	   */
	  disableStrictModeCompat: _propTypes.default.bool,
	
	  /**
	   * If `true`, the component will transition in.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : void 0;
	var _default = Zoom;
	exports.default = _default;

/***/ },
/* 1286 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Zoom.default;
	  }
	});
	
	var _Zoom = _interopRequireDefault(__webpack_require__(1285));

/***/ },
/* 1287 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var amber = {
	  50: '#fff8e1',
	  100: '#ffecb3',
	  200: '#ffe082',
	  300: '#ffd54f',
	  400: '#ffca28',
	  500: '#ffc107',
	  600: '#ffb300',
	  700: '#ffa000',
	  800: '#ff8f00',
	  900: '#ff6f00',
	  A100: '#ffe57f',
	  A200: '#ffd740',
	  A400: '#ffc400',
	  A700: '#ffab00'
	};
	var _default = amber;
	exports.default = _default;

/***/ },
/* 1288 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var blueGrey = {
	  50: '#eceff1',
	  100: '#cfd8dc',
	  200: '#b0bec5',
	  300: '#90a4ae',
	  400: '#78909c',
	  500: '#607d8b',
	  600: '#546e7a',
	  700: '#455a64',
	  800: '#37474f',
	  900: '#263238',
	  A100: '#cfd8dc',
	  A200: '#b0bec5',
	  A400: '#78909c',
	  A700: '#455a64'
	};
	var _default = blueGrey;
	exports.default = _default;

/***/ },
/* 1289 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var brown = {
	  50: '#efebe9',
	  100: '#d7ccc8',
	  200: '#bcaaa4',
	  300: '#a1887f',
	  400: '#8d6e63',
	  500: '#795548',
	  600: '#6d4c41',
	  700: '#5d4037',
	  800: '#4e342e',
	  900: '#3e2723',
	  A100: '#d7ccc8',
	  A200: '#bcaaa4',
	  A400: '#8d6e63',
	  A700: '#5d4037'
	};
	var _default = brown;
	exports.default = _default;

/***/ },
/* 1290 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var cyan = {
	  50: '#e0f7fa',
	  100: '#b2ebf2',
	  200: '#80deea',
	  300: '#4dd0e1',
	  400: '#26c6da',
	  500: '#00bcd4',
	  600: '#00acc1',
	  700: '#0097a7',
	  800: '#00838f',
	  900: '#006064',
	  A100: '#84ffff',
	  A200: '#18ffff',
	  A400: '#00e5ff',
	  A700: '#00b8d4'
	};
	var _default = cyan;
	exports.default = _default;

/***/ },
/* 1291 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var deepOrange = {
	  50: '#fbe9e7',
	  100: '#ffccbc',
	  200: '#ffab91',
	  300: '#ff8a65',
	  400: '#ff7043',
	  500: '#ff5722',
	  600: '#f4511e',
	  700: '#e64a19',
	  800: '#d84315',
	  900: '#bf360c',
	  A100: '#ff9e80',
	  A200: '#ff6e40',
	  A400: '#ff3d00',
	  A700: '#dd2c00'
	};
	var _default = deepOrange;
	exports.default = _default;

/***/ },
/* 1292 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var deepPurple = {
	  50: '#ede7f6',
	  100: '#d1c4e9',
	  200: '#b39ddb',
	  300: '#9575cd',
	  400: '#7e57c2',
	  500: '#673ab7',
	  600: '#5e35b1',
	  700: '#512da8',
	  800: '#4527a0',
	  900: '#311b92',
	  A100: '#b388ff',
	  A200: '#7c4dff',
	  A400: '#651fff',
	  A700: '#6200ea'
	};
	var _default = deepPurple;
	exports.default = _default;

/***/ },
/* 1293 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "common", {
	  enumerable: true,
	  get: function get() {
	    return _common.default;
	  }
	});
	Object.defineProperty(exports, "red", {
	  enumerable: true,
	  get: function get() {
	    return _red.default;
	  }
	});
	Object.defineProperty(exports, "pink", {
	  enumerable: true,
	  get: function get() {
	    return _pink.default;
	  }
	});
	Object.defineProperty(exports, "purple", {
	  enumerable: true,
	  get: function get() {
	    return _purple.default;
	  }
	});
	Object.defineProperty(exports, "deepPurple", {
	  enumerable: true,
	  get: function get() {
	    return _deepPurple.default;
	  }
	});
	Object.defineProperty(exports, "indigo", {
	  enumerable: true,
	  get: function get() {
	    return _indigo.default;
	  }
	});
	Object.defineProperty(exports, "blue", {
	  enumerable: true,
	  get: function get() {
	    return _blue.default;
	  }
	});
	Object.defineProperty(exports, "lightBlue", {
	  enumerable: true,
	  get: function get() {
	    return _lightBlue.default;
	  }
	});
	Object.defineProperty(exports, "cyan", {
	  enumerable: true,
	  get: function get() {
	    return _cyan.default;
	  }
	});
	Object.defineProperty(exports, "teal", {
	  enumerable: true,
	  get: function get() {
	    return _teal.default;
	  }
	});
	Object.defineProperty(exports, "green", {
	  enumerable: true,
	  get: function get() {
	    return _green.default;
	  }
	});
	Object.defineProperty(exports, "lightGreen", {
	  enumerable: true,
	  get: function get() {
	    return _lightGreen.default;
	  }
	});
	Object.defineProperty(exports, "lime", {
	  enumerable: true,
	  get: function get() {
	    return _lime.default;
	  }
	});
	Object.defineProperty(exports, "yellow", {
	  enumerable: true,
	  get: function get() {
	    return _yellow.default;
	  }
	});
	Object.defineProperty(exports, "amber", {
	  enumerable: true,
	  get: function get() {
	    return _amber.default;
	  }
	});
	Object.defineProperty(exports, "orange", {
	  enumerable: true,
	  get: function get() {
	    return _orange.default;
	  }
	});
	Object.defineProperty(exports, "deepOrange", {
	  enumerable: true,
	  get: function get() {
	    return _deepOrange.default;
	  }
	});
	Object.defineProperty(exports, "brown", {
	  enumerable: true,
	  get: function get() {
	    return _brown.default;
	  }
	});
	Object.defineProperty(exports, "grey", {
	  enumerable: true,
	  get: function get() {
	    return _grey.default;
	  }
	});
	Object.defineProperty(exports, "blueGrey", {
	  enumerable: true,
	  get: function get() {
	    return _blueGrey.default;
	  }
	});
	
	var _common = _interopRequireDefault(__webpack_require__(612));
	
	var _red = _interopRequireDefault(__webpack_require__(618));
	
	var _pink = _interopRequireDefault(__webpack_require__(617));
	
	var _purple = _interopRequireDefault(__webpack_require__(1297));
	
	var _deepPurple = _interopRequireDefault(__webpack_require__(1292));
	
	var _indigo = _interopRequireDefault(__webpack_require__(615));
	
	var _blue = _interopRequireDefault(__webpack_require__(611));
	
	var _lightBlue = _interopRequireDefault(__webpack_require__(1294));
	
	var _cyan = _interopRequireDefault(__webpack_require__(1290));
	
	var _teal = _interopRequireDefault(__webpack_require__(1298));
	
	var _green = _interopRequireDefault(__webpack_require__(613));
	
	var _lightGreen = _interopRequireDefault(__webpack_require__(1295));
	
	var _lime = _interopRequireDefault(__webpack_require__(1296));
	
	var _yellow = _interopRequireDefault(__webpack_require__(1299));
	
	var _amber = _interopRequireDefault(__webpack_require__(1287));
	
	var _orange = _interopRequireDefault(__webpack_require__(616));
	
	var _deepOrange = _interopRequireDefault(__webpack_require__(1291));
	
	var _brown = _interopRequireDefault(__webpack_require__(1289));
	
	var _grey = _interopRequireDefault(__webpack_require__(614));
	
	var _blueGrey = _interopRequireDefault(__webpack_require__(1288));

/***/ },
/* 1294 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var lightBlue = {
	  50: '#e1f5fe',
	  100: '#b3e5fc',
	  200: '#81d4fa',
	  300: '#4fc3f7',
	  400: '#29b6f6',
	  500: '#03a9f4',
	  600: '#039be5',
	  700: '#0288d1',
	  800: '#0277bd',
	  900: '#01579b',
	  A100: '#80d8ff',
	  A200: '#40c4ff',
	  A400: '#00b0ff',
	  A700: '#0091ea'
	};
	var _default = lightBlue;
	exports.default = _default;

/***/ },
/* 1295 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var lightGreen = {
	  50: '#f1f8e9',
	  100: '#dcedc8',
	  200: '#c5e1a5',
	  300: '#aed581',
	  400: '#9ccc65',
	  500: '#8bc34a',
	  600: '#7cb342',
	  700: '#689f38',
	  800: '#558b2f',
	  900: '#33691e',
	  A100: '#ccff90',
	  A200: '#b2ff59',
	  A400: '#76ff03',
	  A700: '#64dd17'
	};
	var _default = lightGreen;
	exports.default = _default;

/***/ },
/* 1296 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var lime = {
	  50: '#f9fbe7',
	  100: '#f0f4c3',
	  200: '#e6ee9c',
	  300: '#dce775',
	  400: '#d4e157',
	  500: '#cddc39',
	  600: '#c0ca33',
	  700: '#afb42b',
	  800: '#9e9d24',
	  900: '#827717',
	  A100: '#f4ff81',
	  A200: '#eeff41',
	  A400: '#c6ff00',
	  A700: '#aeea00'
	};
	var _default = lime;
	exports.default = _default;

/***/ },
/* 1297 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var purple = {
	  50: '#f3e5f5',
	  100: '#e1bee7',
	  200: '#ce93d8',
	  300: '#ba68c8',
	  400: '#ab47bc',
	  500: '#9c27b0',
	  600: '#8e24aa',
	  700: '#7b1fa2',
	  800: '#6a1b9a',
	  900: '#4a148c',
	  A100: '#ea80fc',
	  A200: '#e040fb',
	  A400: '#d500f9',
	  A700: '#aa00ff'
	};
	var _default = purple;
	exports.default = _default;

/***/ },
/* 1298 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var teal = {
	  50: '#e0f2f1',
	  100: '#b2dfdb',
	  200: '#80cbc4',
	  300: '#4db6ac',
	  400: '#26a69a',
	  500: '#009688',
	  600: '#00897b',
	  700: '#00796b',
	  800: '#00695c',
	  900: '#004d40',
	  A100: '#a7ffeb',
	  A200: '#64ffda',
	  A400: '#1de9b6',
	  A700: '#00bfa5'
	};
	var _default = teal;
	exports.default = _default;

/***/ },
/* 1299 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var yellow = {
	  50: '#fffde7',
	  100: '#fff9c4',
	  200: '#fff59d',
	  300: '#fff176',
	  400: '#ffee58',
	  500: '#ffeb3b',
	  600: '#fdd835',
	  700: '#fbc02d',
	  800: '#f9a825',
	  900: '#f57f17',
	  A100: '#ffff8d',
	  A200: '#ffff00',
	  A400: '#ffea00',
	  A700: '#ffd600'
	};
	var _default = yellow;
	exports.default = _default;

/***/ },
/* 1300 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = animate;
	
	function easeInOutSin(time) {
	  return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
	}
	
	function animate(property, element, to) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var cb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};
	  var _options$ease = options.ease,
	      ease = _options$ease === void 0 ? easeInOutSin : _options$ease,
	      _options$duration = options.duration,
	      duration = _options$duration === void 0 ? 300 : _options$duration;
	  var start = null;
	  var from = element[property];
	  var cancelled = false;
	
	  var cancel = function cancel() {
	    cancelled = true;
	  };
	
	  var step = function step(timestamp) {
	    if (cancelled) {
	      cb(new Error('Animation cancelled'));
	      return;
	    }
	
	    if (start === null) {
	      start = timestamp;
	    }
	
	    var time = Math.min(1, (timestamp - start) / duration);
	    element[property] = ease(time) * (to - from) + from;
	
	    if (time >= 1) {
	      requestAnimationFrame(function () {
	        cb(null);
	      });
	      return;
	    }
	
	    requestAnimationFrame(step);
	  };
	
	  if (from === to) {
	    cb(new Error('Element already at target position'));
	    return cancel;
	  }
	
	  requestAnimationFrame(step);
	  return cancel;
	}

/***/ },
/* 1301 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(70));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
	}), 'ArrowDownward');
	
	exports.default = _default;

/***/ },
/* 1302 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(70));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
	}), 'Cancel');
	
	exports.default = _default;

/***/ },
/* 1303 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(70));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
	}), 'CheckBox');
	
	exports.default = _default;

/***/ },
/* 1304 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(70));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
	}), 'CheckBoxOutlineBlank');
	
	exports.default = _default;

/***/ },
/* 1305 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(70));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
	}), 'CheckCircle');
	
	exports.default = _default;

/***/ },
/* 1306 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(70));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
	}), 'IndeterminateCheckBox');
	
	exports.default = _default;

/***/ },
/* 1307 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(70));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'MoreHoriz');
	
	exports.default = _default;

/***/ },
/* 1308 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(70));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
	}), 'Person');
	
	exports.default = _default;

/***/ },
/* 1309 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(70));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
	}), 'RadioButtonChecked');
	
	exports.default = _default;

/***/ },
/* 1310 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(70));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	}), 'RadioButtonUnchecked');
	
	exports.default = _default;

/***/ },
/* 1311 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(70));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
	}), 'Warning');
	
	exports.default = _default;

/***/ },
/* 1312 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createMixins;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(62));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(6));
	
	function createMixins(breakpoints, spacing, mixins) {
	  var _toolbar;
	
	  return (0, _extends3.default)({
	    gutters: function gutters() {
	      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      // To deprecate in v4.1
	      //       warning(
	      //         false,
	      //         [
	      //           'Material-UI: Theme.mixins.gutters() is deprecated.',
	      //           'You can use the source of the mixin directly:',
	      //           `
	      // paddingLeft: theme.spacing(2),
	      // paddingRight: theme.spacing(2),
	      // [theme.breakpoints.up('sm')]: {
	      //   paddingLeft: theme.spacing(3),
	      //   paddingRight: theme.spacing(3),
	      // },
	      // `,
	      //         ].join('\n'),
	      //       );
	      return (0, _extends3.default)({
	        paddingLeft: spacing(2),
	        paddingRight: spacing(2)
	      }, styles, (0, _defineProperty2.default)({}, breakpoints.up('sm'), (0, _extends3.default)({
	        paddingLeft: spacing(3),
	        paddingRight: spacing(3)
	      }, styles[breakpoints.up('sm')])));
	    },
	    toolbar: (_toolbar = {
	      minHeight: 56
	    }, (0, _defineProperty2.default)(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
	      minHeight: 48
	    }), (0, _defineProperty2.default)(_toolbar, breakpoints.up('sm'), {
	      minHeight: 64
	    }), _toolbar)
	  }, mixins);
	}

/***/ },
/* 1313 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createMuiStrictModeTheme;
	
	var _utils = __webpack_require__(19);
	
	var _createMuiTheme = _interopRequireDefault(__webpack_require__(408));
	
	function createMuiStrictModeTheme(options) {
	  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return _createMuiTheme.default.apply(void 0, [(0, _utils.deepmerge)({
	    unstable_strictMode: true
	  }, options)].concat(args));
	}

/***/ },
/* 1314 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createPalette;
	exports.dark = exports.light = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(19);
	
	var _common = _interopRequireDefault(__webpack_require__(612));
	
	var _grey = _interopRequireDefault(__webpack_require__(614));
	
	var _indigo = _interopRequireDefault(__webpack_require__(615));
	
	var _pink = _interopRequireDefault(__webpack_require__(617));
	
	var _red = _interopRequireDefault(__webpack_require__(618));
	
	var _orange = _interopRequireDefault(__webpack_require__(616));
	
	var _blue = _interopRequireDefault(__webpack_require__(611));
	
	var _green = _interopRequireDefault(__webpack_require__(613));
	
	var _colorManipulator = __webpack_require__(63);
	
	var light = {
	  // The colors used to style the text.
	  text: {
	    // The most important text.
	    primary: 'rgba(0, 0, 0, 0.87)',
	    // Secondary text.
	    secondary: 'rgba(0, 0, 0, 0.54)',
	    // Disabled text have even lower visual prominence.
	    disabled: 'rgba(0, 0, 0, 0.38)',
	    // Text hints.
	    hint: 'rgba(0, 0, 0, 0.38)'
	  },
	  // The color used to divide different elements.
	  divider: 'rgba(0, 0, 0, 0.12)',
	  // The background colors used to style the surfaces.
	  // Consistency between these values is important.
	  background: {
	    paper: _common.default.white,
	    default: _grey.default[50]
	  },
	  // The colors used to style the action elements.
	  action: {
	    // The color of an active action like an icon button.
	    active: 'rgba(0, 0, 0, 0.54)',
	    // The color of an hovered action.
	    hover: 'rgba(0, 0, 0, 0.04)',
	    hoverOpacity: 0.04,
	    // The color of a selected action.
	    selected: 'rgba(0, 0, 0, 0.08)',
	    selectedOpacity: 0.08,
	    // The color of a disabled action.
	    disabled: 'rgba(0, 0, 0, 0.26)',
	    // The background color of a disabled action.
	    disabledBackground: 'rgba(0, 0, 0, 0.12)',
	    disabledOpacity: 0.38,
	    focus: 'rgba(0, 0, 0, 0.12)',
	    focusOpacity: 0.12,
	    activatedOpacity: 0.12
	  }
	};
	exports.light = light;
	var dark = {
	  text: {
	    primary: _common.default.white,
	    secondary: 'rgba(255, 255, 255, 0.7)',
	    disabled: 'rgba(255, 255, 255, 0.5)',
	    hint: 'rgba(255, 255, 255, 0.5)',
	    icon: 'rgba(255, 255, 255, 0.5)'
	  },
	  divider: 'rgba(255, 255, 255, 0.12)',
	  background: {
	    paper: _grey.default[800],
	    default: '#303030'
	  },
	  action: {
	    active: _common.default.white,
	    hover: 'rgba(255, 255, 255, 0.08)',
	    hoverOpacity: 0.08,
	    selected: 'rgba(255, 255, 255, 0.16)',
	    selectedOpacity: 0.16,
	    disabled: 'rgba(255, 255, 255, 0.3)',
	    disabledBackground: 'rgba(255, 255, 255, 0.12)',
	    disabledOpacity: 0.38,
	    focus: 'rgba(255, 255, 255, 0.12)',
	    focusOpacity: 0.12,
	    activatedOpacity: 0.24
	  }
	};
	exports.dark = dark;
	
	function addLightOrDark(intent, direction, shade, tonalOffset) {
	  var tonalOffsetLight = tonalOffset.light || tonalOffset;
	  var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
	
	  if (!intent[direction]) {
	    if (intent.hasOwnProperty(shade)) {
	      intent[direction] = intent[shade];
	    } else if (direction === 'light') {
	      intent.light = (0, _colorManipulator.lighten)(intent.main, tonalOffsetLight);
	    } else if (direction === 'dark') {
	      intent.dark = (0, _colorManipulator.darken)(intent.main, tonalOffsetDark);
	    }
	  }
	}
	
	function createPalette(palette) {
	  var _palette$primary = palette.primary,
	      primary = _palette$primary === void 0 ? {
	    light: _indigo.default[300],
	    main: _indigo.default[500],
	    dark: _indigo.default[700]
	  } : _palette$primary,
	      _palette$secondary = palette.secondary,
	      secondary = _palette$secondary === void 0 ? {
	    light: _pink.default.A200,
	    main: _pink.default.A400,
	    dark: _pink.default.A700
	  } : _palette$secondary,
	      _palette$error = palette.error,
	      error = _palette$error === void 0 ? {
	    light: _red.default[300],
	    main: _red.default[500],
	    dark: _red.default[700]
	  } : _palette$error,
	      _palette$warning = palette.warning,
	      warning = _palette$warning === void 0 ? {
	    light: _orange.default[300],
	    main: _orange.default[500],
	    dark: _orange.default[700]
	  } : _palette$warning,
	      _palette$info = palette.info,
	      info = _palette$info === void 0 ? {
	    light: _blue.default[300],
	    main: _blue.default[500],
	    dark: _blue.default[700]
	  } : _palette$info,
	      _palette$success = palette.success,
	      success = _palette$success === void 0 ? {
	    light: _green.default[300],
	    main: _green.default[500],
	    dark: _green.default[700]
	  } : _palette$success,
	      _palette$type = palette.type,
	      type = _palette$type === void 0 ? 'light' : _palette$type,
	      _palette$contrastThre = palette.contrastThreshold,
	      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
	      _palette$tonalOffset = palette.tonalOffset,
	      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
	      other = (0, _objectWithoutProperties2.default)(palette, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]); // Use the same logic as
	  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
	  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
	
	  function getContrastText(background) {
	    var contrastText = (0, _colorManipulator.getContrastRatio)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;
	
	    if (false) {
	      var contrast = (0, _colorManipulator.getContrastRatio)(background, contrastText);
	
	      if (contrast < 3) {
	        console.error(["Material-UI: The contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WCAG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n'));
	      }
	    }
	
	    return contrastText;
	  }
	
	  var augmentColor = function augmentColor(color) {
	    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
	    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
	    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
	    color = (0, _extends2.default)({}, color);
	
	    if (!color.main && color[mainShade]) {
	      color.main = color[mainShade];
	    }
	
	    if (!color.main) {
	      throw new Error( false ? "Material-UI: The color provided to augmentColor(color) is invalid.\nThe color object needs to have a `main` property or a `".concat(mainShade, "` property.") : (0, _utils.formatMuiErrorMessage)(4, mainShade));
	    }
	
	    if (typeof color.main !== 'string') {
	      throw new Error( false ? "Material-UI: The color provided to augmentColor(color) is invalid.\n`color.main` should be a string, but `".concat(JSON.stringify(color.main), "` was provided instead.\n\nDid you intend to use one of the following approaches?\n\nimport {\xA0green } from \"@material-ui/core/colors\";\n\nconst theme1 = createMuiTheme({ palette: {\n  primary: green,\n} });\n\nconst theme2 = createMuiTheme({ palette: {\n  primary: { main: green[500] },\n} });") : _formatMuiErrorMessage(5, JSON.stringify(color.main)));
	    }
	
	    addLightOrDark(color, 'light', lightShade, tonalOffset);
	    addLightOrDark(color, 'dark', darkShade, tonalOffset);
	
	    if (!color.contrastText) {
	      color.contrastText = getContrastText(color.main);
	    }
	
	    return color;
	  };
	
	  var types = {
	    dark: dark,
	    light: light
	  };
	
	  if (false) {
	    if (!types[type]) {
	      console.error("Material-UI: The palette type `".concat(type, "` is not supported."));
	    }
	  }
	
	  var paletteOutput = (0, _utils.deepmerge)((0, _extends2.default)({
	    // A collection of common colors.
	    common: _common.default,
	    // The palette type, can be light or dark.
	    type: type,
	    // The colors used to represent primary interface elements for a user.
	    primary: augmentColor(primary),
	    // The colors used to represent secondary interface elements for a user.
	    secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
	    // The colors used to represent interface elements that the user should be made aware of.
	    error: augmentColor(error),
	    // The colors used to represent potentially dangerous actions or important messages.
	    warning: augmentColor(warning),
	    // The colors used to present information to the user that is neutral and not necessarily important.
	    info: augmentColor(info),
	    // The colors used to indicate the successful completion of an action that user triggered.
	    success: augmentColor(success),
	    // The grey colors.
	    grey: _grey.default,
	    // Used by `getContrastText()` to maximize the contrast between
	    // the background and the text.
	    contrastThreshold: contrastThreshold,
	    // Takes a background color and returns the text color that maximizes the contrast.
	    getContrastText: getContrastText,
	    // Generate a rich color object.
	    augmentColor: augmentColor,
	    // Used by the functions below to shift a color's luminance by approximately
	    // two indexes within its tonal palette.
	    // E.g., shift from Red 500 to Red 300 or Red 700.
	    tonalOffset: tonalOffset
	  }, types[type]), other);
	  return paletteOutput;
	}

/***/ },
/* 1315 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createSpacing;
	
	var _system = __webpack_require__(637);
	
	var warnOnce;
	
	function createSpacing() {
	  var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
	
	  // Already transformed.
	  if (spacingInput.mui) {
	    return spacingInput;
	  } // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
	  // Smaller components, such as icons and type, can align to a 4dp grid.
	  // https://material.io/design/layout/understanding-layout.html#usage
	
	
	  var transform = (0, _system.createUnarySpacing)({
	    spacing: spacingInput
	  });
	
	  var spacing = function spacing() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    if (false) {
	      if (!(args.length <= 4)) {
	        console.error("Material-UI: Too many arguments provided, expected between 0 and 4, got ".concat(args.length));
	      }
	    }
	
	    if (args.length === 0) {
	      return transform(1);
	    }
	
	    if (args.length === 1) {
	      return transform(args[0]);
	    }
	
	    return args.map(function (argument) {
	      if (typeof argument === 'string') {
	        return argument;
	      }
	
	      var output = transform(argument);
	      return typeof output === 'number' ? "".concat(output, "px") : output;
	    }).join(' ');
	  }; // Backward compatibility, to remove in v5.
	
	
	  Object.defineProperty(spacing, 'unit', {
	    get: function get() {
	      if (false) {
	        if (!warnOnce || process.env.NODE_ENV === 'test') {
	          console.error(['Material-UI: theme.spacing.unit usage has been deprecated.', 'It will be removed in v5.', 'You can replace `theme.spacing.unit * y` with `theme.spacing(y)`.', '', 'You can use the `https://github.com/mui-org/material-ui/tree/master/packages/material-ui-codemod/README.md#theme-spacing-api` migration helper to make the process smoother.'].join('\n'));
	        }
	
	        warnOnce = true;
	      }
	
	      return spacingInput;
	    }
	  });
	  spacing.mui = true;
	  return spacing;
	}

/***/ },
/* 1316 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createStyles;
	
	var _styles = __webpack_require__(76);
	
	// let warnOnce = false;
	// To remove in v5
	function createStyles(styles) {
	  // warning(
	  //   warnOnce,
	  //   [
	  //     'Material-UI: createStyles from @material-ui/core/styles is deprecated.',
	  //     'Please use @material-ui/styles/createStyles',
	  //   ].join('\n'),
	  // );
	  // warnOnce = true;
	  return (0, _styles.createStyles)(styles);
	}

/***/ },
/* 1317 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createTypography;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(19);
	
	function round(value) {
	  return Math.round(value * 1e5) / 1e5;
	}
	
	var caseAllCaps = {
	  textTransform: 'uppercase'
	};
	var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
	/**
	 * @see @link{https://material.io/design/typography/the-type-system.html}
	 * @see @link{https://material.io/design/typography/understanding-typography.html}
	 */
	
	function createTypography(palette, typography) {
	  var _ref = typeof typography === 'function' ? typography(palette) : typography,
	      _ref$fontFamily = _ref.fontFamily,
	      fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
	      _ref$fontSize = _ref.fontSize,
	      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
	      _ref$fontWeightLight = _ref.fontWeightLight,
	      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
	      _ref$fontWeightRegula = _ref.fontWeightRegular,
	      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
	      _ref$fontWeightMedium = _ref.fontWeightMedium,
	      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
	      _ref$fontWeightBold = _ref.fontWeightBold,
	      fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold,
	      _ref$htmlFontSize = _ref.htmlFontSize,
	      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
	      allVariants = _ref.allVariants,
	      pxToRem2 = _ref.pxToRem,
	      other = (0, _objectWithoutProperties2.default)(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);
	
	  if (false) {
	    if (typeof fontSize !== 'number') {
	      console.error('Material-UI: `fontSize` is required to be a number.');
	    }
	
	    if (typeof htmlFontSize !== 'number') {
	      console.error('Material-UI: `htmlFontSize` is required to be a number.');
	    }
	  }
	
	  var coef = fontSize / 14;
	
	  var pxToRem = pxToRem2 || function (size) {
	    return "".concat(size / htmlFontSize * coef, "rem");
	  };
	
	  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
	    return (0, _extends2.default)({
	      fontFamily: fontFamily,
	      fontWeight: fontWeight,
	      fontSize: pxToRem(size),
	      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
	      lineHeight: lineHeight
	    }, fontFamily === defaultFontFamily ? {
	      letterSpacing: "".concat(round(letterSpacing / size), "em")
	    } : {}, casing, allVariants);
	  };
	
	  var variants = {
	    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
	    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
	    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
	    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
	    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
	    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
	    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
	    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
	    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
	    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
	    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
	    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
	    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
	  };
	  return (0, _utils.deepmerge)((0, _extends2.default)({
	    htmlFontSize: htmlFontSize,
	    pxToRem: pxToRem,
	    round: round,
	    // TODO v5: remove
	    fontFamily: fontFamily,
	    fontSize: fontSize,
	    fontWeightLight: fontWeightLight,
	    fontWeightRegular: fontWeightRegular,
	    fontWeightMedium: fontWeightMedium,
	    fontWeightBold: fontWeightBold
	  }, variants), other, {
	    clone: false // No need to clone deep
	
	  });
	}

/***/ },
/* 1318 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isUnitless = isUnitless;
	exports.getUnit = getUnit;
	exports.toUnitless = toUnitless;
	exports.convertLength = convertLength;
	exports.alignProperty = alignProperty;
	exports.fontGrid = fontGrid;
	exports.responsiveProperty = responsiveProperty;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(62));
	
	function isUnitless(value) {
	  return String(parseFloat(value)).length === String(value).length;
	} // Ported from Compass
	// https://github.com/Compass/compass/blob/master/core/stylesheets/compass/typography/_units.scss
	// Emulate the sass function "unit"
	
	
	function getUnit(input) {
	  return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
	} // Emulate the sass function "unitless"
	
	
	function toUnitless(length) {
	  return parseFloat(length);
	} // Convert any CSS <length> or <percentage> value to any another.
	// From https://github.com/KyleAMathews/convert-css-length
	
	
	function convertLength(baseFontSize) {
	  return function (length, toUnit) {
	    var fromUnit = getUnit(length); // Optimize for cases where `from` and `to` units are accidentally the same.
	
	    if (fromUnit === toUnit) {
	      return length;
	    } // Convert input length to pixels.
	
	
	    var pxLength = toUnitless(length);
	
	    if (fromUnit !== 'px') {
	      if (fromUnit === 'em') {
	        pxLength = toUnitless(length) * toUnitless(baseFontSize);
	      } else if (fromUnit === 'rem') {
	        pxLength = toUnitless(length) * toUnitless(baseFontSize);
	        return length;
	      }
	    } // Convert length in pixels to the output unit
	
	
	    var outputLength = pxLength;
	
	    if (toUnit !== 'px') {
	      if (toUnit === 'em') {
	        outputLength = pxLength / toUnitless(baseFontSize);
	      } else if (toUnit === 'rem') {
	        outputLength = pxLength / toUnitless(baseFontSize);
	      } else {
	        return length;
	      }
	    }
	
	    return parseFloat(outputLength.toFixed(5)) + toUnit;
	  };
	}
	
	function alignProperty(_ref) {
	  var size = _ref.size,
	      grid = _ref.grid;
	  var sizeBelow = size - size % grid;
	  var sizeAbove = sizeBelow + grid;
	  return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
	} // fontGrid finds a minimal grid (in rem) for the fontSize values so that the
	// lineHeight falls under a x pixels grid, 4px in the case of Material Design,
	// without changing the relative line height
	
	
	function fontGrid(_ref2) {
	  var lineHeight = _ref2.lineHeight,
	      pixels = _ref2.pixels,
	      htmlFontSize = _ref2.htmlFontSize;
	  return pixels / (lineHeight * htmlFontSize);
	}
	/**
	 * generate a responsive version of a given CSS property
	 * @example
	 * responsiveProperty({
	 *   cssProperty: 'fontSize',
	 *   min: 15,
	 *   max: 20,
	 *   unit: 'px',
	 *   breakpoints: [300, 600],
	 * })
	 *
	 * // this returns
	 *
	 * {
	 *   fontSize: '15px',
	 *   '@media (min-width:300px)': {
	 *     fontSize: '17.5px',
	 *   },
	 *   '@media (min-width:600px)': {
	 *     fontSize: '20px',
	 *   },
	 * }
	 *
	 * @param {Object} params
	 * @param {string} params.cssProperty - The CSS property to be made responsive
	 * @param {number} params.min - The smallest value of the CSS property
	 * @param {number} params.max - The largest value of the CSS property
	 * @param {string} [params.unit] - The unit to be used for the CSS property
	 * @param {Array.number} [params.breakpoints]  - An array of breakpoints
	 * @param {number} [params.alignStep] - Round scaled value to fall under this grid
	 * @returns {Object} responsive styles for {params.cssProperty}
	 */
	
	
	function responsiveProperty(_ref3) {
	  var cssProperty = _ref3.cssProperty,
	      min = _ref3.min,
	      max = _ref3.max,
	      _ref3$unit = _ref3.unit,
	      unit = _ref3$unit === void 0 ? 'rem' : _ref3$unit,
	      _ref3$breakpoints = _ref3.breakpoints,
	      breakpoints = _ref3$breakpoints === void 0 ? [600, 960, 1280] : _ref3$breakpoints,
	      _ref3$transform = _ref3.transform,
	      transform = _ref3$transform === void 0 ? null : _ref3$transform;
	  var output = (0, _defineProperty2.default)({}, cssProperty, "".concat(min).concat(unit));
	  var factor = (max - min) / breakpoints[breakpoints.length - 1];
	  breakpoints.forEach(function (breakpoint) {
	    var value = min + factor * breakpoint;
	
	    if (transform !== null) {
	      value = transform(value);
	    }
	
	    output["@media (min-width:".concat(breakpoint, "px)")] = (0, _defineProperty2.default)({}, cssProperty, "".concat(Math.round(value * 10000) / 10000).concat(unit));
	  });
	  return output;
	}

/***/ },
/* 1319 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  createMuiTheme: true,
	  unstable_createMuiStrictModeTheme: true,
	  createStyles: true,
	  makeStyles: true,
	  responsiveFontSizes: true,
	  styled: true,
	  useTheme: true,
	  withStyles: true,
	  withTheme: true,
	  createGenerateClassName: true,
	  jssPreset: true,
	  ServerStyleSheets: true,
	  StylesProvider: true,
	  MuiThemeProvider: true,
	  ThemeProvider: true
	};
	Object.defineProperty(exports, "createMuiTheme", {
	  enumerable: true,
	  get: function get() {
	    return _createMuiTheme.default;
	  }
	});
	Object.defineProperty(exports, "unstable_createMuiStrictModeTheme", {
	  enumerable: true,
	  get: function get() {
	    return _createMuiStrictModeTheme.default;
	  }
	});
	Object.defineProperty(exports, "createStyles", {
	  enumerable: true,
	  get: function get() {
	    return _createStyles.default;
	  }
	});
	Object.defineProperty(exports, "makeStyles", {
	  enumerable: true,
	  get: function get() {
	    return _makeStyles.default;
	  }
	});
	Object.defineProperty(exports, "responsiveFontSizes", {
	  enumerable: true,
	  get: function get() {
	    return _responsiveFontSizes.default;
	  }
	});
	Object.defineProperty(exports, "styled", {
	  enumerable: true,
	  get: function get() {
	    return _styled.default;
	  }
	});
	Object.defineProperty(exports, "useTheme", {
	  enumerable: true,
	  get: function get() {
	    return _useTheme.default;
	  }
	});
	Object.defineProperty(exports, "withStyles", {
	  enumerable: true,
	  get: function get() {
	    return _withStyles.default;
	  }
	});
	Object.defineProperty(exports, "withTheme", {
	  enumerable: true,
	  get: function get() {
	    return _withTheme.default;
	  }
	});
	Object.defineProperty(exports, "createGenerateClassName", {
	  enumerable: true,
	  get: function get() {
	    return _styles.createGenerateClassName;
	  }
	});
	Object.defineProperty(exports, "jssPreset", {
	  enumerable: true,
	  get: function get() {
	    return _styles.jssPreset;
	  }
	});
	Object.defineProperty(exports, "ServerStyleSheets", {
	  enumerable: true,
	  get: function get() {
	    return _styles.ServerStyleSheets;
	  }
	});
	Object.defineProperty(exports, "StylesProvider", {
	  enumerable: true,
	  get: function get() {
	    return _styles.StylesProvider;
	  }
	});
	Object.defineProperty(exports, "MuiThemeProvider", {
	  enumerable: true,
	  get: function get() {
	    return _styles.ThemeProvider;
	  }
	});
	Object.defineProperty(exports, "ThemeProvider", {
	  enumerable: true,
	  get: function get() {
	    return _styles.ThemeProvider;
	  }
	});
	
	var _colorManipulator = __webpack_require__(63);
	
	Object.keys(_colorManipulator).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _colorManipulator[key];
	    }
	  });
	});
	
	var _createMuiTheme = _interopRequireDefault(__webpack_require__(408));
	
	var _createMuiStrictModeTheme = _interopRequireDefault(__webpack_require__(1313));
	
	var _createStyles = _interopRequireDefault(__webpack_require__(1316));
	
	var _makeStyles = _interopRequireDefault(__webpack_require__(1320));
	
	var _responsiveFontSizes = _interopRequireDefault(__webpack_require__(1321));
	
	var _styled = _interopRequireDefault(__webpack_require__(623));
	
	var _transitions = __webpack_require__(99);
	
	Object.keys(_transitions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _transitions[key];
	    }
	  });
	});
	
	var _useTheme = _interopRequireDefault(__webpack_require__(59));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(11));
	
	var _withTheme = _interopRequireDefault(__webpack_require__(1324));
	
	var _styles = __webpack_require__(76);

/***/ },
/* 1320 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _styles = __webpack_require__(76);
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(241));
	
	function makeStyles(stylesOrCreator) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return (0, _styles.makeStyles)(stylesOrCreator, (0, _extends2.default)({
	    defaultTheme: _defaultTheme.default
	  }, options));
	}
	
	var _default = makeStyles;
	exports.default = _default;

/***/ },
/* 1321 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = responsiveFontSizes;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(19);
	
	var _cssUtils = __webpack_require__(1318);
	
	function responsiveFontSizes(themeInput) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _options$breakpoints = options.breakpoints,
	      breakpoints = _options$breakpoints === void 0 ? ['sm', 'md', 'lg'] : _options$breakpoints,
	      _options$disableAlign = options.disableAlign,
	      disableAlign = _options$disableAlign === void 0 ? false : _options$disableAlign,
	      _options$factor = options.factor,
	      factor = _options$factor === void 0 ? 2 : _options$factor,
	      _options$variants = options.variants,
	      variants = _options$variants === void 0 ? ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline'] : _options$variants;
	  var theme = (0, _extends2.default)({}, themeInput);
	  theme.typography = (0, _extends2.default)({}, theme.typography);
	  var typography = theme.typography; // Convert between css lengths e.g. em->px or px->rem
	  // Set the baseFontSize for your project. Defaults to 16px (also the browser default).
	
	  var convert = (0, _cssUtils.convertLength)(typography.htmlFontSize);
	  var breakpointValues = breakpoints.map(function (x) {
	    return theme.breakpoints.values[x];
	  });
	  variants.forEach(function (variant) {
	    var style = typography[variant];
	    var remFontSize = parseFloat(convert(style.fontSize, 'rem'));
	
	    if (remFontSize <= 1) {
	      return;
	    }
	
	    var maxFontSize = remFontSize;
	    var minFontSize = 1 + (maxFontSize - 1) / factor;
	    var lineHeight = style.lineHeight;
	
	    if (!(0, _cssUtils.isUnitless)(lineHeight) && !disableAlign) {
	      throw new Error( false ? "Material-UI: Unsupported non-unitless line height with grid alignment.\nUse unitless line heights instead." : (0, _utils.formatMuiErrorMessage)(6));
	    }
	
	    if (!(0, _cssUtils.isUnitless)(lineHeight)) {
	      // make it unitless
	      lineHeight = parseFloat(convert(lineHeight, 'rem')) / parseFloat(remFontSize);
	    }
	
	    var transform = null;
	
	    if (!disableAlign) {
	      transform = function transform(value) {
	        return (0, _cssUtils.alignProperty)({
	          size: value,
	          grid: (0, _cssUtils.fontGrid)({
	            pixels: 4,
	            lineHeight: lineHeight,
	            htmlFontSize: typography.htmlFontSize
	          })
	        });
	      };
	    }
	
	    typography[variant] = (0, _extends2.default)({}, style, (0, _cssUtils.responsiveProperty)({
	      cssProperty: 'fontSize',
	      min: minFontSize,
	      max: maxFontSize,
	      unit: 'rem',
	      breakpoints: breakpointValues,
	      transform: transform
	    }));
	  });
	  return theme;
	}

/***/ },
/* 1322 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var shadowKeyUmbraOpacity = 0.2;
	var shadowKeyPenumbraOpacity = 0.14;
	var shadowAmbientShadowOpacity = 0.12;
	
	function createShadow() {
	  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
	} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
	
	
	var shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
	var _default = shadows;
	exports.default = _default;

/***/ },
/* 1323 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var shape = {
	  borderRadius: 4
	};
	var _default = shape;
	exports.default = _default;

/***/ },
/* 1324 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _styles = __webpack_require__(76);
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(241));
	
	var withTheme = (0, _styles.withThemeCreator)({
	  defaultTheme: _defaultTheme.default
	});
	var _default = withTheme;
	exports.default = _default;

/***/ },
/* 1325 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useMediaQuery;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _styles = __webpack_require__(76);
	
	function useMediaQuery(queryInput) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var theme = (0, _styles.useTheme)();
	  var props = (0, _styles.getThemeProps)({
	    theme: theme,
	    name: 'MuiUseMediaQuery',
	    props: {}
	  });
	
	  if (false) {
	    if (typeof queryInput === 'function' && theme === null) {
	      console.error(['Material-UI: The `query` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
	    }
	  }
	
	  var query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
	  query = query.replace(/^@media( ?)/m, ''); // Wait for jsdom to support the match media feature.
	  // All the browsers Material-UI support have this built-in.
	  // This defensive check is here for simplicity.
	  // Most of the time, the match media logic isn't central to people tests.
	
	  var supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
	
	  var _props$options = (0, _extends2.default)({}, props, options),
	      _props$options$defaul = _props$options.defaultMatches,
	      defaultMatches = _props$options$defaul === void 0 ? false : _props$options$defaul,
	      _props$options$matchM = _props$options.matchMedia,
	      matchMedia = _props$options$matchM === void 0 ? supportMatchMedia ? window.matchMedia : null : _props$options$matchM,
	      _props$options$noSsr = _props$options.noSsr,
	      noSsr = _props$options$noSsr === void 0 ? false : _props$options$noSsr,
	      _props$options$ssrMat = _props$options.ssrMatchMedia,
	      ssrMatchMedia = _props$options$ssrMat === void 0 ? null : _props$options$ssrMat;
	
	  var _React$useState = React.useState(function () {
	    if (noSsr && supportMatchMedia) {
	      return matchMedia(query).matches;
	    }
	
	    if (ssrMatchMedia) {
	      return ssrMatchMedia(query).matches;
	    } // Once the component is mounted, we rely on the
	    // event listeners to return the correct matches value.
	
	
	    return defaultMatches;
	  }),
	      match = _React$useState[0],
	      setMatch = _React$useState[1];
	
	  React.useEffect(function () {
	    var active = true;
	
	    if (!supportMatchMedia) {
	      return undefined;
	    }
	
	    var queryList = matchMedia(query);
	
	    var updateMatch = function updateMatch() {
	      // Workaround Safari wrong implementation of matchMedia
	      // TODO can we remove it?
	      // https://github.com/mui-org/material-ui/pull/17315#issuecomment-528286677
	      if (active) {
	        setMatch(queryList.matches);
	      }
	    };
	
	    updateMatch();
	    queryList.addListener(updateMatch);
	    return function () {
	      active = false;
	      queryList.removeListener(updateMatch);
	    };
	  }, [query, matchMedia, supportMatchMedia]);
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    React.useDebugValue({
	      query: query,
	      match: match
	    });
	  }
	
	  return match;
	}

/***/ },
/* 1326 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _useScrollTrigger.default;
	  }
	});
	
	var _useScrollTrigger = _interopRequireDefault(__webpack_require__(1327));

/***/ },
/* 1327 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useScrollTrigger;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	function defaultTrigger(store, options) {
	  var _options$disableHyste = options.disableHysteresis,
	      disableHysteresis = _options$disableHyste === void 0 ? false : _options$disableHyste,
	      _options$threshold = options.threshold,
	      threshold = _options$threshold === void 0 ? 100 : _options$threshold,
	      target = options.target;
	  var previous = store.current;
	
	  if (target) {
	    // Get vertical scroll
	    store.current = target.pageYOffset !== undefined ? target.pageYOffset : target.scrollTop;
	  }
	
	  if (!disableHysteresis && previous !== undefined) {
	    if (store.current < previous) {
	      return false;
	    }
	  }
	
	  return store.current > threshold;
	}
	
	var defaultTarget = typeof window !== 'undefined' ? window : null;
	
	function useScrollTrigger() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _options$getTrigger = options.getTrigger,
	      getTrigger = _options$getTrigger === void 0 ? defaultTrigger : _options$getTrigger,
	      _options$target = options.target,
	      target = _options$target === void 0 ? defaultTarget : _options$target,
	      other = (0, _objectWithoutProperties2.default)(options, ["getTrigger", "target"]);
	  var store = React.useRef();
	
	  var _React$useState = React.useState(function () {
	    return getTrigger(store, other);
	  }),
	      trigger = _React$useState[0],
	      setTrigger = _React$useState[1];
	
	  React.useEffect(function () {
	    var handleScroll = function handleScroll() {
	      setTrigger(getTrigger(store, (0, _extends2.default)({
	        target: target
	      }, other)));
	    };
	
	    handleScroll(); // Re-evaluate trigger when dependencies change
	
	    target.addEventListener('scroll', handleScroll);
	    return function () {
	      target.removeEventListener('scroll', handleScroll);
	    }; // See Option 3. https://github.com/facebook/react/issues/14476#issuecomment-471199055
	    // eslint-disable-next-line react-hooks/exhaustive-deps
	  }, [target, getTrigger, JSON.stringify(other)]);
	  return trigger;
	}

/***/ },
/* 1328 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = deprecatedPropType;
	
	function deprecatedPropType(validator, reason) {
	  if (true) {
	    return function () {
	      return null;
	    };
	  }
	
	  return function (props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (typeof props[propName] !== 'undefined') {
	      return new Error("The ".concat(location, " `").concat(propFullNameSafe, "` of ") + "`".concat(componentNameSafe, "` is deprecated. ").concat(reason));
	    }
	
	    return null;
	  };
	}

/***/ },
/* 1329 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.detectScrollType = detectScrollType;
	exports.getNormalizedScrollLeft = getNormalizedScrollLeft;
	// Source from https://github.com/alitaheri/normalize-scroll-left
	var cachedType;
	/**
	 * Based on the jquery plugin https://github.com/othree/jquery.rtl-scroll-type
	 *
	 * Types of scrollLeft, assiming scrollWidth=100 and direction is rtl.
	 *
	 * Browser        | Type          | <- Most Left | Most Right -> | Initial
	 * -------------- | ------------- | ------------ | ------------- | -------
	 * WebKit         | default       | 0            | 100           | 100
	 * Firefox/Opera  | negative      | -100         | 0             | 0
	 * IE/Edge        | reverse       | 100          | 0             | 0
	 */
	
	function detectScrollType() {
	  if (cachedType) {
	    return cachedType;
	  }
	
	  var dummy = document.createElement('div');
	  dummy.appendChild(document.createTextNode('ABCD'));
	  dummy.dir = 'rtl';
	  dummy.style.fontSize = '14px';
	  dummy.style.width = '4px';
	  dummy.style.height = '1px';
	  dummy.style.position = 'absolute';
	  dummy.style.top = '-1000px';
	  dummy.style.overflow = 'scroll';
	  document.body.appendChild(dummy);
	  cachedType = 'reverse';
	
	  if (dummy.scrollLeft > 0) {
	    cachedType = 'default';
	  } else {
	    dummy.scrollLeft = 1;
	
	    if (dummy.scrollLeft === 0) {
	      cachedType = 'negative';
	    }
	  }
	
	  document.body.removeChild(dummy);
	  return cachedType;
	} // Based on https://stackoverflow.com/a/24394376
	
	
	function getNormalizedScrollLeft(element, direction) {
	  var scrollLeft = element.scrollLeft; // Perform the calculations only when direction is rtl to avoid messing up the ltr bahavior
	
	  if (direction !== 'rtl') {
	    return scrollLeft;
	  }
	
	  var type = detectScrollType();
	
	  switch (type) {
	    case 'negative':
	      return element.scrollWidth - element.clientWidth + scrollLeft;
	
	    case 'reverse':
	      return element.scrollWidth - element.clientWidth - scrollLeft;
	
	    default:
	      return scrollLeft;
	  }
	}

/***/ },
/* 1330 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _withMobileDialog.default;
	  }
	});
	
	var _withMobileDialog = _interopRequireDefault(__webpack_require__(1331));

/***/ },
/* 1331 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _withWidth = _interopRequireWildcard(__webpack_require__(409));
	
	/**
	 * Dialog will responsively be full screen *at or below* the given breakpoint
	 * (defaults to 'sm' for mobile devices).
	 * Notice that this Higher-order Component is incompatible with server-side rendering.
	 */
	var withMobileDialog = function withMobileDialog() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return function (Component) {
	    var _options$breakpoint = options.breakpoint,
	        breakpoint = _options$breakpoint === void 0 ? 'sm' : _options$breakpoint;
	
	    function WithMobileDialog(props) {
	      return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	        fullScreen: (0, _withWidth.isWidthDown)(breakpoint, props.width)
	      }, props));
	    }
	
	     false ? WithMobileDialog.propTypes = {
	      width: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']).isRequired
	    } : void 0;
	    return (0, _withWidth.default)()(WithMobileDialog);
	  };
	};
	
	var _default = withMobileDialog;
	exports.default = _default;

/***/ },
/* 1332 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.isWidthDown = exports.isWidthUp = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(19);
	
	var _styles = __webpack_require__(76);
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(210));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(59));
	
	var _createBreakpoints = __webpack_require__(622);
	
	var _useMediaQuery = _interopRequireDefault(__webpack_require__(625));
	
	// By default, returns true if screen width is the same or greater than the given breakpoint.
	var isWidthUp = function isWidthUp(breakpoint, width) {
	  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (inclusive) {
	    return _createBreakpoints.keys.indexOf(breakpoint) <= _createBreakpoints.keys.indexOf(width);
	  }
	
	  return _createBreakpoints.keys.indexOf(breakpoint) < _createBreakpoints.keys.indexOf(width);
	}; // By default, returns true if screen width is the same or less than the given breakpoint.
	
	
	exports.isWidthUp = isWidthUp;
	
	var isWidthDown = function isWidthDown(breakpoint, width) {
	  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (inclusive) {
	    return _createBreakpoints.keys.indexOf(width) <= _createBreakpoints.keys.indexOf(breakpoint);
	  }
	
	  return _createBreakpoints.keys.indexOf(width) < _createBreakpoints.keys.indexOf(breakpoint);
	};
	
	exports.isWidthDown = isWidthDown;
	var useEnhancedEffect = typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;
	
	var withWidth = function withWidth() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return function (Component) {
	    var _options$withTheme = options.withTheme,
	        withThemeOption = _options$withTheme === void 0 ? false : _options$withTheme,
	        _options$noSSR = options.noSSR,
	        noSSR = _options$noSSR === void 0 ? false : _options$noSSR,
	        initialWidthOption = options.initialWidth;
	
	    function WithWidth(props) {
	      var contextTheme = (0, _useTheme.default)();
	      var theme = props.theme || contextTheme;
	
	      var _getThemeProps = (0, _styles.getThemeProps)({
	        theme: theme,
	        name: 'MuiWithWidth',
	        props: (0, _extends2.default)({}, props)
	      }),
	          initialWidth = _getThemeProps.initialWidth,
	          width = _getThemeProps.width,
	          other = (0, _objectWithoutProperties2.default)(_getThemeProps, ["initialWidth", "width"]);
	
	      var _React$useState = React.useState(false),
	          mountedState = _React$useState[0],
	          setMountedState = _React$useState[1];
	
	      useEnhancedEffect(function () {
	        setMountedState(true);
	      }, []);
	      /**
	       * innerWidth |xs      sm      md      lg      xl
	       *            |-------|-------|-------|-------|------>
	       * width      |  xs   |  sm   |  md   |  lg   |  xl
	       */
	
	      var keys = theme.breakpoints.keys.slice().reverse();
	      var widthComputed = keys.reduce(function (output, key) {
	        // eslint-disable-next-line react-hooks/rules-of-hooks
	        var matches = (0, _useMediaQuery.default)(theme.breakpoints.up(key));
	        return !output && matches ? key : output;
	      }, null);
	      var more = (0, _extends2.default)({
	        width: width || (mountedState || noSSR ? widthComputed : undefined) || initialWidth || initialWidthOption
	      }, withThemeOption ? {
	        theme: theme
	      } : {}, other); // When rendering the component on the server,
	      // we have no idea about the client browser screen width.
	      // In order to prevent blinks and help the reconciliation of the React tree
	      // we are not rendering the child component.
	      //
	      // An alternative is to use the `initialWidth` property.
	
	      if (more.width === undefined) {
	        return null;
	      }
	
	      return /*#__PURE__*/React.createElement(Component, more);
	    }
	
	     false ? WithWidth.propTypes = {
	      /**
	       * As `window.innerWidth` is unavailable on the server,
	       * we default to rendering an empty component during the first mount.
	       * You might want to use an heuristic to approximate
	       * the screen width of the client browser screen width.
	       *
	       * For instance, you could be using the user-agent or the client-hints.
	       * https://caniuse.com/#search=client%20hint
	       */
	      initialWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
	
	      /**
	       * @ignore
	       */
	      theme: _propTypes.default.object,
	
	      /**
	       * Bypass the width calculation logic.
	       */
	      width: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
	    } : void 0;
	
	    if (false) {
	      WithWidth.displayName = "WithWidth(".concat((0, _utils.getDisplayName)(Component), ")");
	    }
	
	    (0, _hoistNonReactStatics.default)(WithWidth, Component);
	    return WithWidth;
	  };
	};
	
	var _default = withWidth;
	exports.default = _default;

/***/ },
/* 1333 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(244));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
	}), 'Close');
	
	exports.default = _default;

/***/ },
/* 1334 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(244));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
	}), 'Done');
	
	exports.default = _default;

/***/ },
/* 1335 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(244));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
	}), 'ExpandMore');
	
	exports.default = _default;

/***/ },
/* 1336 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(391));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(295));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _jss = __webpack_require__(172);
	
	var _StylesProvider = _interopRequireDefault(__webpack_require__(410));
	
	var _createGenerateClassName = _interopRequireDefault(__webpack_require__(411));
	
	var ServerStyleSheets = /*#__PURE__*/function () {
	  function ServerStyleSheets() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck2.default)(this, ServerStyleSheets);
	    this.options = options;
	  }
	
	  (0, _createClass2.default)(ServerStyleSheets, [{
	    key: "collect",
	    value: function collect(children) {
	      // This is needed in order to deduplicate the injection of CSS in the page.
	      var sheetsManager = new Map(); // This is needed in order to inject the critical CSS.
	
	      this.sheetsRegistry = new _jss.SheetsRegistry(); // A new class name generator
	
	      var generateClassName = (0, _createGenerateClassName.default)();
	      return /*#__PURE__*/_react.default.createElement(_StylesProvider.default, (0, _extends2.default)({
	        sheetsManager: sheetsManager,
	        serverGenerateClassName: generateClassName,
	        sheetsRegistry: this.sheetsRegistry
	      }, this.options), children);
	    }
	  }, {
	    key: "toString",
	    value: function toString() {
	      return this.sheetsRegistry ? this.sheetsRegistry.toString() : '';
	    }
	  }, {
	    key: "getStyleElement",
	    value: function getStyleElement(props) {
	      return _react.default.createElement('style', (0, _extends2.default)({
	        id: 'jss-server-side',
	        key: 'jss-server-side',
	        dangerouslySetInnerHTML: {
	          __html: this.toString()
	        }
	      }, props));
	    }
	  }]);
	  return ServerStyleSheets;
	}();
	
	exports.default = ServerStyleSheets;

/***/ },
/* 1337 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ServerStyleSheets.default;
	  }
	});
	
	var _ServerStyleSheets = _interopRequireDefault(__webpack_require__(1336));

/***/ },
/* 1338 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = StylesProvider;
	exports.StylesContext = exports.sheetsManager = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(19);
	
	var _createGenerateClassName = _interopRequireDefault(__webpack_require__(411));
	
	var _jss = __webpack_require__(172);
	
	var _jssPreset = _interopRequireDefault(__webpack_require__(634));
	
	// Default JSS instance.
	var jss = (0, _jss.create)((0, _jssPreset.default)()); // Use a singleton or the provided one by the context.
	//
	// The counter-based approach doesn't tolerate any mistake.
	// It's much safer to use the same counter everywhere.
	
	var generateClassName = (0, _createGenerateClassName.default)(); // Exported for test purposes
	
	var sheetsManager = new Map();
	exports.sheetsManager = sheetsManager;
	var defaultOptions = {
	  disableGeneration: false,
	  generateClassName: generateClassName,
	  jss: jss,
	  sheetsCache: null,
	  sheetsManager: sheetsManager,
	  sheetsRegistry: null
	};
	
	var StylesContext = _react.default.createContext(defaultOptions);
	
	exports.StylesContext = StylesContext;
	
	if (false) {
	  StylesContext.displayName = 'StylesContext';
	}
	
	var injectFirstNode;
	
	function StylesProvider(props) {
	  var children = props.children,
	      _props$injectFirst = props.injectFirst,
	      injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst,
	      _props$disableGenerat = props.disableGeneration,
	      disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat,
	      localOptions = (0, _objectWithoutProperties2.default)(props, ["children", "injectFirst", "disableGeneration"]);
	
	  var outerOptions = _react.default.useContext(StylesContext);
	
	  var context = (0, _extends2.default)((0, _extends2.default)({}, outerOptions), {}, {
	    disableGeneration: disableGeneration
	  }, localOptions);
	
	  if (false) {
	    if (typeof window === 'undefined' && !context.sheetsManager) {
	      console.error('Material-UI: You need to use the ServerStyleSheets API when rendering on the server.');
	    }
	  }
	
	  if (false) {
	    if (context.jss.options.insertionPoint && injectFirst) {
	      console.error('Material-UI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time.');
	    }
	  }
	
	  if (false) {
	    if (injectFirst && localOptions.jss) {
	      console.error('Material-UI: You cannot use the jss and injectFirst props at the same time.');
	    }
	  }
	
	  if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
	    if (!injectFirstNode) {
	      var head = document.head;
	      injectFirstNode = document.createComment('mui-inject-first');
	      head.insertBefore(injectFirstNode, head.firstChild);
	    }
	
	    context.jss = (0, _jss.create)({
	      plugins: (0, _jssPreset.default)().plugins,
	      insertionPoint: injectFirstNode
	    });
	  }
	
	  return /*#__PURE__*/_react.default.createElement(StylesContext.Provider, {
	    value: context
	  }, children);
	}
	
	 false ? StylesProvider.propTypes = {
	  /**
	   * Your component tree.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * You can disable the generation of the styles with this option.
	   * It can be useful when traversing the React tree outside of the HTML
	   * rendering step on the server.
	   * Let's say you are using react-apollo to extract all
	   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
	   */
	  disableGeneration: _propTypes.default.bool,
	
	  /**
	   * JSS's class name generator.
	   */
	  generateClassName: _propTypes.default.func,
	
	  /**
	   * By default, the styles are injected last in the <head> element of the page.
	   * As a result, they gain more specificity than any other style sheet.
	   * If you want to override Material-UI's styles, set this prop.
	   */
	  injectFirst: _propTypes.default.bool,
	
	  /**
	   * JSS's instance.
	   */
	  jss: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  serverGenerateClassName: _propTypes.default.func,
	
	  /**
	   * @ignore
	   *
	   * Beta feature.
	   *
	   * Cache for the sheets.
	   */
	  sheetsCache: _propTypes.default.object,
	
	  /**
	   * @ignore
	   *
	   * The sheetsManager is used to deduplicate style sheet injection in the page.
	   * It's deduplicating using the (theme, styles) couple.
	   * On the server, you should provide a new instance for each request.
	   */
	  sheetsManager: _propTypes.default.object,
	
	  /**
	   * @ignore
	   *
	   * Collect the sheets.
	   */
	  sheetsRegistry: _propTypes.default.object
	} : void 0;
	
	if (false) {
	  process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = (0, _utils.exactProp)(StylesProvider.propTypes) : void 0;
	}

/***/ },
/* 1339 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(19);
	
	var _ThemeContext = _interopRequireDefault(__webpack_require__(636));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(245));
	
	var _nested = _interopRequireDefault(__webpack_require__(631));
	
	// To support composition of theme.
	function mergeOuterLocalTheme(outerTheme, localTheme) {
	  if (typeof localTheme === 'function') {
	    var mergedTheme = localTheme(outerTheme);
	
	    if (false) {
	      if (!mergedTheme) {
	        console.error(['Material-UI: You should return an object from your theme function, i.e.', '<ThemeProvider theme={() => ({})} />'].join('\n'));
	      }
	    }
	
	    return mergedTheme;
	  }
	
	  return (0, _extends2.default)((0, _extends2.default)({}, outerTheme), localTheme);
	}
	/**
	 * This component takes a `theme` prop.
	 * It makes the `theme` available down the React tree thanks to React context.
	 * This component should preferably be used at **the root of your component tree**.
	 */
	
	
	function ThemeProvider(props) {
	  var children = props.children,
	      localTheme = props.theme;
	  var outerTheme = (0, _useTheme.default)();
	
	  if (false) {
	    if (outerTheme === null && typeof localTheme === 'function') {
	      console.error(['Material-UI: You are providing a theme function prop to the ThemeProvider component:', '<ThemeProvider theme={outerTheme => outerTheme} />', '', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n'));
	    }
	  }
	
	  var theme = _react.default.useMemo(function () {
	    var output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);
	
	    if (output != null) {
	      output[_nested.default] = outerTheme !== null;
	    }
	
	    return output;
	  }, [localTheme, outerTheme]);
	
	  return /*#__PURE__*/_react.default.createElement(_ThemeContext.default.Provider, {
	    value: theme
	  }, children);
	}
	
	 false ? ThemeProvider.propTypes = {
	  /**
	   * Your component tree.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * A theme object. You can provide a function to extend the outer theme.
	   */
	  theme: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]).isRequired
	} : void 0;
	
	if (false) {
	  process.env.NODE_ENV !== "production" ? ThemeProvider.propTypes = (0, _utils.exactProp)(ThemeProvider.propTypes) : void 0;
	}
	
	var _default = ThemeProvider;
	exports.default = _default;

/***/ },
/* 1340 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ThemeProvider.default;
	  }
	});
	
	var _ThemeProvider = _interopRequireDefault(__webpack_require__(1339));

/***/ },
/* 1341 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createGenerateClassName;
	
	var _nested = _interopRequireDefault(__webpack_require__(631));
	
	/**
	 * This is the list of the style rule name we use as drop in replacement for the built-in
	 * pseudo classes (:checked, :disabled, :focused, etc.).
	 *
	 * Why do they exist in the first place?
	 * These classes are used at a specificity of 2.
	 * It allows them to override previously definied styles as well as
	 * being untouched by simple user overrides.
	 */
	var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected']; // Returns a function which generates unique class names based on counters.
	// When new generator function is created, rule counter is reset.
	// We need to reset the rule counter for SSR for each request.
	//
	// It's inspired by
	// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js
	
	function createGenerateClassName() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _options$disableGloba = options.disableGlobal,
	      disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba,
	      _options$productionPr = options.productionPrefix,
	      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
	      _options$seed = options.seed,
	      seed = _options$seed === void 0 ? '' : _options$seed;
	  var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
	  var ruleCounter = 0;
	
	  var getNextCounterId = function getNextCounterId() {
	    ruleCounter += 1;
	
	    if (false) {
	      if (ruleCounter >= 1e10) {
	        console.warn(['Material-UI: You might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join(''));
	      }
	    }
	
	    return ruleCounter;
	  };
	
	  return function (rule, styleSheet) {
	    var name = styleSheet.options.name; // Is a global static MUI style?
	
	    if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
	      // We can use a shorthand class name, we never use the keys to style the components.
	      if (pseudoClasses.indexOf(rule.key) !== -1) {
	        return "Mui-".concat(rule.key);
	      }
	
	      var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);
	
	      if (!styleSheet.options.theme[_nested.default] || seed !== '') {
	        return prefix;
	      }
	
	      return "".concat(prefix, "-").concat(getNextCounterId());
	    }
	
	    if (true) {
	      return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
	    }
	
	    var suffix = "".concat(rule.key, "-").concat(getNextCounterId()); // Help with debuggability.
	
	    if (styleSheet.options.classNamePrefix) {
	      return "".concat(seedPrefix).concat(styleSheet.options.classNamePrefix, "-").concat(suffix);
	    }
	
	    return "".concat(seedPrefix).concat(suffix);
	  };
	}

/***/ },
/* 1342 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createStyles;
	
	function createStyles(styles) {
	  return styles;
	}

/***/ },
/* 1343 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _createStyles.default;
	  }
	});
	
	var _createStyles = _interopRequireDefault(__webpack_require__(1342));

/***/ },
/* 1344 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getStylesCreator;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(153));
	
	var _utils = __webpack_require__(19);
	
	var _noopTheme = _interopRequireDefault(__webpack_require__(632));
	
	function getStylesCreator(stylesOrCreator) {
	  var themingEnabled = typeof stylesOrCreator === 'function';
	
	  if (false) {
	    if ((0, _typeof2.default)(stylesOrCreator) !== 'object' && !themingEnabled) {
	      console.error(['Material-UI: The `styles` argument provided is invalid.', 'You need to provide a function generating the styles or a styles object.'].join('\n'));
	    }
	  }
	
	  return {
	    create: function create(theme, name) {
	      var styles;
	
	      try {
	        styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
	      } catch (err) {
	        if (false) {
	          if (themingEnabled === true && theme === _noopTheme.default) {
	            // TODO: prepend error message/name instead
	            console.error(['Material-UI: The `styles` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
	          }
	        }
	
	        throw err;
	      }
	
	      if (!name || !theme.overrides || !theme.overrides[name]) {
	        return styles;
	      }
	
	      var overrides = theme.overrides[name];
	      var stylesWithOverrides = (0, _extends2.default)({}, styles);
	      Object.keys(overrides).forEach(function (key) {
	        if (false) {
	          if (!stylesWithOverrides[key]) {
	            console.warn(['Material-UI: You are trying to override a style that does not exist.', "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join('\n'));
	          }
	        }
	
	        stylesWithOverrides[key] = (0, _utils.deepmerge)(stylesWithOverrides[key], overrides[key]);
	      });
	      return stylesWithOverrides;
	    },
	    options: {}
	  };
	}

/***/ },
/* 1345 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _getStylesCreator.default;
	  }
	});
	
	var _getStylesCreator = _interopRequireDefault(__webpack_require__(1344));

/***/ },
/* 1346 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getThemeProps;
	
	/* eslint-disable no-restricted-syntax */
	function getThemeProps(params) {
	  var theme = params.theme,
	      name = params.name,
	      props = params.props;
	
	  if (!theme || !theme.props || !theme.props[name]) {
	    return props;
	  } // Resolve default props, code borrow from React source.
	  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221
	
	
	  var defaultProps = theme.props[name];
	  var propName;
	
	  for (propName in defaultProps) {
	    if (props[propName] === undefined) {
	      props[propName] = defaultProps[propName];
	    }
	  }
	
	  return props;
	}

/***/ },
/* 1347 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = jssPreset;
	
	var _jssPluginRuleValueFunction = _interopRequireDefault(__webpack_require__(1773));
	
	var _jssPluginGlobal = _interopRequireDefault(__webpack_require__(1770));
	
	var _jssPluginNested = _interopRequireDefault(__webpack_require__(1771));
	
	var _jssPluginCamelCase = _interopRequireDefault(__webpack_require__(1768));
	
	var _jssPluginDefaultUnit = _interopRequireDefault(__webpack_require__(1769));
	
	var _jssPluginVendorPrefixer = _interopRequireDefault(__webpack_require__(1774));
	
	var _jssPluginPropsSort = _interopRequireDefault(__webpack_require__(1772));
	
	// Subset of jss-preset-default with only the plugins the Material-UI components are using.
	function jssPreset() {
	  return {
	    plugins: [(0, _jssPluginRuleValueFunction.default)(), (0, _jssPluginGlobal.default)(), (0, _jssPluginNested.default)(), (0, _jssPluginCamelCase.default)(), (0, _jssPluginDefaultUnit.default)(), // Disable the vendor prefixer server-side, it does nothing.
	    // This way, we can get a performance boost.
	    // In the documentation, we are using `autoprefixer` to solve this problem.
	    typeof window === 'undefined' ? null : (0, _jssPluginVendorPrefixer.default)(), (0, _jssPluginPropsSort.default)()]
	  };
	}

/***/ },
/* 1348 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.increment = increment;
	
	/* eslint-disable import/prefer-default-export */
	// Global index counter to preserve source order.
	// We create the style sheet during the creation of the component,
	// children are handled after the parents, so the order of style elements would be parent->child.
	// It is a problem though when a parent passes a className
	// which needs to override any child's styles.
	// StyleSheet of the child has a higher specificity, because of the source order.
	// So our solution is to render sheets them in the reverse order child->sheet, so
	// that parent has a higher specificity.
	var indexCounter = -1e9;
	
	function increment() {
	  indexCounter += 1;
	
	  if (false) {
	    if (indexCounter >= 0) {
	      console.warn(['Material-UI: You might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join('\n'));
	    }
	  }
	
	  return indexCounter;
	}

/***/ },
/* 1349 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = makeStyles;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _jss = __webpack_require__(172);
	
	var _mergeClasses = _interopRequireDefault(__webpack_require__(635));
	
	var _multiKeyStore = _interopRequireDefault(__webpack_require__(1350));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(245));
	
	var _StylesProvider = __webpack_require__(410);
	
	var _indexCounter = __webpack_require__(1348);
	
	var _getStylesCreator = _interopRequireDefault(__webpack_require__(1345));
	
	var _noopTheme = _interopRequireDefault(__webpack_require__(632));
	
	function getClasses(_ref, classes, Component) {
	  var state = _ref.state,
	      stylesOptions = _ref.stylesOptions;
	
	  if (stylesOptions.disableGeneration) {
	    return classes || {};
	  }
	
	  if (!state.cacheClasses) {
	    state.cacheClasses = {
	      // Cache for the finalized classes value.
	      value: null,
	      // Cache for the last used classes prop pointer.
	      lastProp: null,
	      // Cache for the last used rendered classes pointer.
	      lastJSS: {}
	    };
	  } // Tracks if either the rendered classes or classes prop has changed,
	  // requiring the generation of a new finalized classes object.
	
	
	  var generate = false;
	
	  if (state.classes !== state.cacheClasses.lastJSS) {
	    state.cacheClasses.lastJSS = state.classes;
	    generate = true;
	  }
	
	  if (classes !== state.cacheClasses.lastProp) {
	    state.cacheClasses.lastProp = classes;
	    generate = true;
	  }
	
	  if (generate) {
	    state.cacheClasses.value = (0, _mergeClasses.default)({
	      baseClasses: state.cacheClasses.lastJSS,
	      newClasses: classes,
	      Component: Component
	    });
	  }
	
	  return state.cacheClasses.value;
	}
	
	function attach(_ref2, props) {
	  var state = _ref2.state,
	      theme = _ref2.theme,
	      stylesOptions = _ref2.stylesOptions,
	      stylesCreator = _ref2.stylesCreator,
	      name = _ref2.name;
	
	  if (stylesOptions.disableGeneration) {
	    return;
	  }
	
	  var sheetManager = _multiKeyStore.default.get(stylesOptions.sheetsManager, stylesCreator, theme);
	
	  if (!sheetManager) {
	    sheetManager = {
	      refs: 0,
	      staticSheet: null,
	      dynamicStyles: null
	    };
	
	    _multiKeyStore.default.set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
	  }
	
	  var options = (0, _extends2.default)((0, _extends2.default)((0, _extends2.default)({}, stylesCreator.options), stylesOptions), {}, {
	    theme: theme,
	    flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
	  });
	  options.generateId = options.serverGenerateClassName || options.generateClassName;
	  var sheetsRegistry = stylesOptions.sheetsRegistry;
	
	  if (sheetManager.refs === 0) {
	    var staticSheet;
	
	    if (stylesOptions.sheetsCache) {
	      staticSheet = _multiKeyStore.default.get(stylesOptions.sheetsCache, stylesCreator, theme);
	    }
	
	    var styles = stylesCreator.create(theme, name);
	
	    if (!staticSheet) {
	      staticSheet = stylesOptions.jss.createStyleSheet(styles, (0, _extends2.default)({
	        link: false
	      }, options));
	      staticSheet.attach();
	
	      if (stylesOptions.sheetsCache) {
	        _multiKeyStore.default.set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
	      }
	    }
	
	    if (sheetsRegistry) {
	      sheetsRegistry.add(staticSheet);
	    }
	
	    sheetManager.staticSheet = staticSheet;
	    sheetManager.dynamicStyles = (0, _jss.getDynamicStyles)(styles);
	  }
	
	  if (sheetManager.dynamicStyles) {
	    var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0, _extends2.default)({
	      link: true
	    }, options));
	    dynamicSheet.update(props);
	    dynamicSheet.attach();
	    state.dynamicSheet = dynamicSheet;
	    state.classes = (0, _mergeClasses.default)({
	      baseClasses: sheetManager.staticSheet.classes,
	      newClasses: dynamicSheet.classes
	    });
	
	    if (sheetsRegistry) {
	      sheetsRegistry.add(dynamicSheet);
	    }
	  } else {
	    state.classes = sheetManager.staticSheet.classes;
	  }
	
	  sheetManager.refs += 1;
	}
	
	function update(_ref3, props) {
	  var state = _ref3.state;
	
	  if (state.dynamicSheet) {
	    state.dynamicSheet.update(props);
	  }
	}
	
	function detach(_ref4) {
	  var state = _ref4.state,
	      theme = _ref4.theme,
	      stylesOptions = _ref4.stylesOptions,
	      stylesCreator = _ref4.stylesCreator;
	
	  if (stylesOptions.disableGeneration) {
	    return;
	  }
	
	  var sheetManager = _multiKeyStore.default.get(stylesOptions.sheetsManager, stylesCreator, theme);
	
	  sheetManager.refs -= 1;
	  var sheetsRegistry = stylesOptions.sheetsRegistry;
	
	  if (sheetManager.refs === 0) {
	    _multiKeyStore.default.delete(stylesOptions.sheetsManager, stylesCreator, theme);
	
	    stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
	
	    if (sheetsRegistry) {
	      sheetsRegistry.remove(sheetManager.staticSheet);
	    }
	  }
	
	  if (state.dynamicSheet) {
	    stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
	
	    if (sheetsRegistry) {
	      sheetsRegistry.remove(state.dynamicSheet);
	    }
	  }
	}
	
	function useSynchronousEffect(func, values) {
	  var key = _react.default.useRef([]);
	
	  var output; // Store "generation" key. Just returns a new object every time
	
	  var currentKey = _react.default.useMemo(function () {
	    return {};
	  }, values); // eslint-disable-line react-hooks/exhaustive-deps
	  // "the first render", or "memo dropped the value"
	
	
	  if (key.current !== currentKey) {
	    key.current = currentKey;
	    output = func();
	  }
	
	  _react.default.useEffect(function () {
	    return function () {
	      if (output) {
	        output();
	      }
	    };
	  }, [currentKey] // eslint-disable-line react-hooks/exhaustive-deps
	  );
	}
	
	function makeStyles(stylesOrCreator) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var name = options.name,
	      classNamePrefixOption = options.classNamePrefix,
	      Component = options.Component,
	      _options$defaultTheme = options.defaultTheme,
	      defaultTheme = _options$defaultTheme === void 0 ? _noopTheme.default : _options$defaultTheme,
	      stylesOptions2 = (0, _objectWithoutProperties2.default)(options, ["name", "classNamePrefix", "Component", "defaultTheme"]);
	  var stylesCreator = (0, _getStylesCreator.default)(stylesOrCreator);
	  var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
	  stylesCreator.options = {
	    index: (0, _indexCounter.increment)(),
	    name: name,
	    meta: classNamePrefix,
	    classNamePrefix: classNamePrefix
	  };
	
	  var useStyles = function useStyles() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var theme = (0, _useTheme.default)() || defaultTheme;
	    var stylesOptions = (0, _extends2.default)((0, _extends2.default)({}, _react.default.useContext(_StylesProvider.StylesContext)), stylesOptions2);
	
	    var instance = _react.default.useRef();
	
	    var shouldUpdate = _react.default.useRef();
	
	    useSynchronousEffect(function () {
	      var current = {
	        name: name,
	        state: {},
	        stylesCreator: stylesCreator,
	        stylesOptions: stylesOptions,
	        theme: theme
	      };
	      attach(current, props);
	      shouldUpdate.current = false;
	      instance.current = current;
	      return function () {
	        detach(current);
	      };
	    }, [theme, stylesCreator]);
	
	    _react.default.useEffect(function () {
	      if (shouldUpdate.current) {
	        update(instance.current, props);
	      }
	
	      shouldUpdate.current = true;
	    });
	
	    var classes = getClasses(instance.current, props.classes, Component);
	
	    if (false) {
	      // eslint-disable-next-line react-hooks/rules-of-hooks
	      _react.default.useDebugValue(classes);
	    }
	
	    return classes;
	  };
	
	  return useStyles;
	}

/***/ },
/* 1350 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	// Used https://github.com/thinkloop/multi-key-cache as inspiration
	var multiKeyStore = {
	  set: function set(cache, key1, key2, value) {
	    var subCache = cache.get(key1);
	
	    if (!subCache) {
	      subCache = new Map();
	      cache.set(key1, subCache);
	    }
	
	    subCache.set(key2, value);
	  },
	  get: function get(cache, key1, key2) {
	    var subCache = cache.get(key1);
	    return subCache ? subCache.get(key2) : undefined;
	  },
	  delete: function _delete(cache, key1, key2) {
	    var subCache = cache.get(key1);
	    subCache.delete(key2);
	  }
	};
	var _default = multiKeyStore;
	exports.default = _default;

/***/ },
/* 1351 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = mergeClasses;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(19);
	
	function mergeClasses() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var baseClasses = options.baseClasses,
	      newClasses = options.newClasses,
	      Component = options.Component;
	
	  if (!newClasses) {
	    return baseClasses;
	  }
	
	  var nextClasses = (0, _extends2.default)({}, baseClasses);
	
	  if (false) {
	    if (typeof newClasses === 'string') {
	      console.error(["Material-UI: The value `".concat(newClasses, "` ") + "provided to the classes prop of ".concat((0, _utils.getDisplayName)(Component), " is incorrect."), 'You might want to use the className prop instead.'].join('\n'));
	      return baseClasses;
	    }
	  }
	
	  Object.keys(newClasses).forEach(function (key) {
	    if (false) {
	      if (!baseClasses[key] && newClasses[key]) {
	        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not implemented in ".concat((0, _utils.getDisplayName)(Component), "."), "You can only override one of the following: ".concat(Object.keys(baseClasses).join(','), ".")].join('\n'));
	      }
	
	      if (newClasses[key] && typeof newClasses[key] !== 'string') {
	        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not valid for ".concat((0, _utils.getDisplayName)(Component), "."), "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")].join('\n'));
	      }
	    }
	
	    if (newClasses[key]) {
	      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
	    }
	  });
	  return nextClasses;
	}

/***/ },
/* 1352 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _styled.default;
	  }
	});
	
	var _styled = _interopRequireDefault(__webpack_require__(1353));

/***/ },
/* 1353 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = styled;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _clsx = _interopRequireDefault(__webpack_require__(12));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(19);
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(210));
	
	var _makeStyles = _interopRequireDefault(__webpack_require__(412));
	
	function omit(input, fields) {
	  var output = {};
	  Object.keys(input).forEach(function (prop) {
	    if (fields.indexOf(prop) === -1) {
	      output[prop] = input[prop];
	    }
	  });
	  return output;
	} // styled-components's API removes the mapping between components and styles.
	// Using components as a low-level styling construct can be simpler.
	
	
	function styled(Component) {
	  var componentCreator = function componentCreator(style) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var name = options.name,
	        stylesOptions = (0, _objectWithoutProperties2.default)(options, ["name"]);
	
	    if (false) {
	      throw new Error(['You are calling styled(Component)(style) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
	    }
	
	    var classNamePrefix = name;
	
	    if (false) {
	      if (!name) {
	        // Provide a better DX outside production.
	        var displayName = (0, _utils.getDisplayName)(Component);
	
	        if (displayName !== undefined) {
	          classNamePrefix = displayName;
	        }
	      }
	    }
	
	    var stylesOrCreator = typeof style === 'function' ? function (theme) {
	      return {
	        root: function root(props) {
	          return style((0, _extends2.default)({
	            theme: theme
	          }, props));
	        }
	      };
	    } : {
	      root: style
	    };
	    var useStyles = (0, _makeStyles.default)(stylesOrCreator, (0, _extends2.default)({
	      Component: Component,
	      name: name || Component.displayName,
	      classNamePrefix: classNamePrefix
	    }, stylesOptions));
	    var filterProps;
	    var propTypes = {};
	
	    if (style.filterProps) {
	      filterProps = style.filterProps;
	      delete style.filterProps;
	    }
	    /* eslint-disable react/forbid-foreign-prop-types */
	
	
	    if (style.propTypes) {
	      propTypes = style.propTypes;
	      delete style.propTypes;
	    }
	    /* eslint-enable react/forbid-foreign-prop-types */
	
	
	    var StyledComponent = _react.default.forwardRef(function StyledComponent(props, ref) {
	      var children = props.children,
	          classNameProp = props.className,
	          clone = props.clone,
	          ComponentProp = props.component,
	          other = (0, _objectWithoutProperties2.default)(props, ["children", "className", "clone", "component"]);
	      var classes = useStyles(props);
	      var className = (0, _clsx.default)(classes.root, classNameProp);
	      var spread = other;
	
	      if (filterProps) {
	        spread = omit(spread, filterProps);
	      }
	
	      if (clone) {
	        return _react.default.cloneElement(children, (0, _extends2.default)({
	          className: (0, _clsx.default)(children.props.className, className)
	        }, spread));
	      }
	
	      if (typeof children === 'function') {
	        return children((0, _extends2.default)({
	          className: className
	        }, spread));
	      }
	
	      var FinalComponent = ComponentProp || Component;
	      return /*#__PURE__*/_react.default.createElement(FinalComponent, (0, _extends2.default)({
	        ref: ref,
	        className: className
	      }, spread), children);
	    });
	
	     false ? StyledComponent.propTypes = (0, _extends2.default)({
	      /**
	       * A render function or node.
	       */
	      children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
	
	      /**
	       * @ignore
	       */
	      className: _propTypes.default.string,
	
	      /**
	       * If `true`, the component will recycle it's children HTML element.
	       * It's using `React.cloneElement` internally.
	       *
	       * This prop will be deprecated and removed in v5
	       */
	      clone: (0, _utils.chainPropTypes)(_propTypes.default.bool, function (props) {
	        if (props.clone && props.component) {
	          return new Error('You can not use the clone and component prop at the same time.');
	        }
	
	        return null;
	      }),
	
	      /**
	       * The component used for the root node.
	       * Either a string to use a HTML element or a component.
	       */
	      component: _propTypes.default.elementType
	    }, propTypes) : void 0;
	
	    if (false) {
	      StyledComponent.displayName = "Styled(".concat(classNamePrefix, ")");
	    }
	
	    (0, _hoistNonReactStatics.default)(StyledComponent, Component);
	    return StyledComponent;
	  };
	
	  return componentCreator;
	}

/***/ },
/* 1354 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useTheme;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _ThemeContext = _interopRequireDefault(__webpack_require__(636));
	
	function useTheme() {
	  var theme = _react.default.useContext(_ThemeContext.default);
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    _react.default.useDebugValue(theme);
	  }
	
	  return theme;
	}

/***/ },
/* 1355 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _withStyles.default;
	  }
	});
	
	var _withStyles = _interopRequireDefault(__webpack_require__(1356));

/***/ },
/* 1356 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(210));
	
	var _utils = __webpack_require__(19);
	
	var _makeStyles = _interopRequireDefault(__webpack_require__(412));
	
	var _getThemeProps = _interopRequireDefault(__webpack_require__(633));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(245));
	
	// Link a style sheet with a component.
	// It does not modify the component passed to it;
	// instead, it returns a new component, with a `classes` property.
	var withStyles = function withStyles(stylesOrCreator) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return function (Component) {
	    var defaultTheme = options.defaultTheme,
	        _options$withTheme = options.withTheme,
	        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
	        name = options.name,
	        stylesOptions = (0, _objectWithoutProperties2.default)(options, ["defaultTheme", "withTheme", "name"]);
	
	    if (false) {
	      if (Component === undefined) {
	        throw new Error(['You are calling withStyles(styles)(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
	      }
	    }
	
	    var classNamePrefix = name;
	
	    if (false) {
	      if (!name) {
	        // Provide a better DX outside production.
	        var displayName = (0, _utils.getDisplayName)(Component);
	
	        if (displayName !== undefined) {
	          classNamePrefix = displayName;
	        }
	      }
	    }
	
	    var useStyles = (0, _makeStyles.default)(stylesOrCreator, (0, _extends2.default)({
	      defaultTheme: defaultTheme,
	      Component: Component,
	      name: name || Component.displayName,
	      classNamePrefix: classNamePrefix
	    }, stylesOptions));
	
	    var WithStyles = _react.default.forwardRef(function WithStyles(props, ref) {
	      var classesProp = props.classes,
	          innerRef = props.innerRef,
	          other = (0, _objectWithoutProperties2.default)(props, ["classes", "innerRef"]); // The wrapper receives only user supplied props, which could be a subset of
	      // the actual props Component might receive due to merging with defaultProps.
	      // So copying it here would give us the same result in the wrapper as well.
	
	      var classes = useStyles((0, _extends2.default)((0, _extends2.default)({}, Component.defaultProps), props));
	      var theme;
	      var more = other;
	
	      if (typeof name === 'string' || withTheme) {
	        // name and withTheme are invariant in the outer scope
	        // eslint-disable-next-line react-hooks/rules-of-hooks
	        theme = (0, _useTheme.default)() || defaultTheme;
	
	        if (name) {
	          more = (0, _getThemeProps.default)({
	            theme: theme,
	            name: name,
	            props: other
	          });
	        } // Provide the theme to the wrapped component.
	        // So we don't have to use the `withTheme()` Higher-order Component.
	
	
	        if (withTheme && !more.theme) {
	          more.theme = theme;
	        }
	      }
	
	      return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
	        ref: innerRef || ref,
	        classes: classes
	      }, more));
	    });
	
	     false ? WithStyles.propTypes = {
	      /**
	       * Override or extend the styles applied to the component.
	       */
	      classes: _propTypes.default.object,
	
	      /**
	       * Use that prop to pass a ref to the decorated component.
	       * @deprecated
	       */
	      innerRef: (0, _utils.chainPropTypes)(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]), function (props) {
	        if (props.innerRef == null) {
	          return null;
	        }
	
	        return null; // return new Error(
	        //   'Material-UI: The `innerRef` prop is deprecated and will be removed in v5. ' +
	        //     'Refs are now automatically forwarded to the inner component.',
	        // );
	      })
	    } : void 0;
	
	    if (false) {
	      WithStyles.displayName = "WithStyles(".concat((0, _utils.getDisplayName)(Component), ")");
	    }
	
	    (0, _hoistNonReactStatics.default)(WithStyles, Component);
	
	    if (false) {
	      // Exposed for test purposes.
	      WithStyles.Naked = Component;
	      WithStyles.options = options;
	      WithStyles.useStyles = useStyles;
	    }
	
	    return WithStyles;
	  };
	};
	
	var _default = withStyles;
	exports.default = _default;

/***/ },
/* 1357 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {};
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _withTheme.default;
	  }
	});
	
	var _withTheme = _interopRequireWildcard(__webpack_require__(1358));
	
	Object.keys(_withTheme).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withTheme[key];
	    }
	  });
	});

/***/ },
/* 1358 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withThemeCreator = withThemeCreator;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(9));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(210));
	
	var _utils = __webpack_require__(19);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(245));
	
	function withThemeCreator() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var defaultTheme = options.defaultTheme;
	
	  var withTheme = function withTheme(Component) {
	    if (false) {
	      if (Component === undefined) {
	        throw new Error(['You are calling withTheme(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
	      }
	    }
	
	    var WithTheme = _react.default.forwardRef(function WithTheme(props, ref) {
	      var innerRef = props.innerRef,
	          other = (0, _objectWithoutProperties2.default)(props, ["innerRef"]);
	      var theme = (0, _useTheme.default)() || defaultTheme;
	      return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
	        theme: theme,
	        ref: innerRef || ref
	      }, other));
	    });
	
	     false ? WithTheme.propTypes = {
	      /**
	       * Use that prop to pass a ref to the decorated component.
	       * @deprecated
	       */
	      innerRef: (0, _utils.chainPropTypes)(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]), function (props) {
	        if (props.innerRef == null) {
	          return null;
	        }
	
	        return new Error('Material-UI: The `innerRef` prop is deprecated and will be removed in v5. ' + 'Refs are now automatically forwarded to the inner component.');
	      })
	    } : void 0;
	
	    if (false) {
	      WithTheme.displayName = "WithTheme(".concat((0, _utils.getDisplayName)(Component), ")");
	    }
	
	    (0, _hoistNonReactStatics.default)(WithTheme, Component);
	
	    if (false) {
	      // Exposed for test purposes.
	      WithTheme.Naked = Component;
	    }
	
	    return WithTheme;
	  };
	
	  return withTheme;
	} // Provide the theme object as a prop to the input component.
	// It's an alternative API to useTheme().
	// We encourage the usage of useTheme() where possible.
	
	
	var withTheme = withThemeCreator();
	var _default = withTheme;
	exports.default = _default;

/***/ },
/* 1359 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.borderRadius = exports.borderColor = exports.borderLeft = exports.borderBottom = exports.borderRight = exports.borderTop = exports.border = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(100));
	
	var _compose = _interopRequireDefault(__webpack_require__(118));
	
	function getBorder(value) {
	  if (typeof value !== 'number') {
	    return value;
	  }
	
	  return "".concat(value, "px solid");
	}
	
	var border = (0, _style.default)({
	  prop: 'border',
	  themeKey: 'borders',
	  transform: getBorder
	});
	exports.border = border;
	var borderTop = (0, _style.default)({
	  prop: 'borderTop',
	  themeKey: 'borders',
	  transform: getBorder
	});
	exports.borderTop = borderTop;
	var borderRight = (0, _style.default)({
	  prop: 'borderRight',
	  themeKey: 'borders',
	  transform: getBorder
	});
	exports.borderRight = borderRight;
	var borderBottom = (0, _style.default)({
	  prop: 'borderBottom',
	  themeKey: 'borders',
	  transform: getBorder
	});
	exports.borderBottom = borderBottom;
	var borderLeft = (0, _style.default)({
	  prop: 'borderLeft',
	  themeKey: 'borders',
	  transform: getBorder
	});
	exports.borderLeft = borderLeft;
	var borderColor = (0, _style.default)({
	  prop: 'borderColor',
	  themeKey: 'palette'
	});
	exports.borderColor = borderColor;
	var borderRadius = (0, _style.default)({
	  prop: 'borderRadius',
	  themeKey: 'shape'
	});
	exports.borderRadius = borderRadius;
	var borders = (0, _compose.default)(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderRadius);
	var _default = borders;
	exports.default = _default;

/***/ },
/* 1360 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(115));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _merge = _interopRequireDefault(__webpack_require__(312));
	
	function omit(input, fields) {
	  var output = {};
	  Object.keys(input).forEach(function (prop) {
	    if (fields.indexOf(prop) === -1) {
	      output[prop] = input[prop];
	    }
	  });
	  return output;
	}
	
	function css(styleFunction) {
	  var newStyleFunction = function newStyleFunction(props) {
	    var output = styleFunction(props);
	
	    if (props.css) {
	      return (0, _extends2.default)((0, _extends2.default)({}, (0, _merge.default)(output, styleFunction((0, _extends2.default)({
	        theme: props.theme
	      }, props.css)))), omit(props.css, [styleFunction.filterProps]));
	    }
	
	    return output;
	  };
	
	  newStyleFunction.propTypes =  false ? (0, _extends2.default)((0, _extends2.default)({}, styleFunction.propTypes), {}, {
	    css: _propTypes.default.object
	  }) : {};
	  newStyleFunction.filterProps = ['css'].concat((0, _toConsumableArray2.default)(styleFunction.filterProps));
	  return newStyleFunction;
	}
	
	var _default = css;
	exports.default = _default;

/***/ },
/* 1361 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.whiteSpace = exports.visibility = exports.textOverflow = exports.overflow = exports.displayRaw = exports.displayPrint = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(100));
	
	var _compose = _interopRequireDefault(__webpack_require__(118));
	
	var displayPrint = (0, _style.default)({
	  prop: 'displayPrint',
	  cssProperty: false,
	  transform: function transform(value) {
	    return {
	      '@media print': {
	        display: value
	      }
	    };
	  }
	});
	exports.displayPrint = displayPrint;
	var displayRaw = (0, _style.default)({
	  prop: 'display'
	});
	exports.displayRaw = displayRaw;
	var overflow = (0, _style.default)({
	  prop: 'overflow'
	});
	exports.overflow = overflow;
	var textOverflow = (0, _style.default)({
	  prop: 'textOverflow'
	});
	exports.textOverflow = textOverflow;
	var visibility = (0, _style.default)({
	  prop: 'visibility'
	});
	exports.visibility = visibility;
	var whiteSpace = (0, _style.default)({
	  prop: 'whiteSpace'
	});
	exports.whiteSpace = whiteSpace;
	
	var _default = (0, _compose.default)(displayPrint, displayRaw, overflow, textOverflow, visibility, whiteSpace);
	
	exports.default = _default;

/***/ },
/* 1362 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.justifySelf = exports.justifyItems = exports.alignSelf = exports.flexShrink = exports.flexGrow = exports.flex = exports.order = exports.alignContent = exports.alignItems = exports.justifyContent = exports.flexWrap = exports.flexDirection = exports.flexBasis = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(100));
	
	var _compose = _interopRequireDefault(__webpack_require__(118));
	
	var flexBasis = (0, _style.default)({
	  prop: 'flexBasis'
	});
	exports.flexBasis = flexBasis;
	var flexDirection = (0, _style.default)({
	  prop: 'flexDirection'
	});
	exports.flexDirection = flexDirection;
	var flexWrap = (0, _style.default)({
	  prop: 'flexWrap'
	});
	exports.flexWrap = flexWrap;
	var justifyContent = (0, _style.default)({
	  prop: 'justifyContent'
	});
	exports.justifyContent = justifyContent;
	var alignItems = (0, _style.default)({
	  prop: 'alignItems'
	});
	exports.alignItems = alignItems;
	var alignContent = (0, _style.default)({
	  prop: 'alignContent'
	});
	exports.alignContent = alignContent;
	var order = (0, _style.default)({
	  prop: 'order'
	});
	exports.order = order;
	var flex = (0, _style.default)({
	  prop: 'flex'
	});
	exports.flex = flex;
	var flexGrow = (0, _style.default)({
	  prop: 'flexGrow'
	});
	exports.flexGrow = flexGrow;
	var flexShrink = (0, _style.default)({
	  prop: 'flexShrink'
	});
	exports.flexShrink = flexShrink;
	var alignSelf = (0, _style.default)({
	  prop: 'alignSelf'
	});
	exports.alignSelf = alignSelf;
	var justifyItems = (0, _style.default)({
	  prop: 'justifyItems'
	});
	exports.justifyItems = justifyItems;
	var justifySelf = (0, _style.default)({
	  prop: 'justifySelf'
	});
	exports.justifySelf = justifySelf;
	var flexbox = (0, _compose.default)(flexBasis, flexDirection, flexWrap, justifyContent, alignItems, alignContent, order, flex, flexGrow, flexShrink, alignSelf, justifyItems, justifySelf);
	var _default = flexbox;
	exports.default = _default;

/***/ },
/* 1363 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.gridArea = exports.gridTemplateAreas = exports.gridTemplateRows = exports.gridTemplateColumns = exports.gridAutoRows = exports.gridAutoColumns = exports.gridAutoFlow = exports.gridRow = exports.gridColumn = exports.gridRowGap = exports.gridColumnGap = exports.gridGap = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(100));
	
	var _compose = _interopRequireDefault(__webpack_require__(118));
	
	var gridGap = (0, _style.default)({
	  prop: 'gridGap'
	});
	exports.gridGap = gridGap;
	var gridColumnGap = (0, _style.default)({
	  prop: 'gridColumnGap'
	});
	exports.gridColumnGap = gridColumnGap;
	var gridRowGap = (0, _style.default)({
	  prop: 'gridRowGap'
	});
	exports.gridRowGap = gridRowGap;
	var gridColumn = (0, _style.default)({
	  prop: 'gridColumn'
	});
	exports.gridColumn = gridColumn;
	var gridRow = (0, _style.default)({
	  prop: 'gridRow'
	});
	exports.gridRow = gridRow;
	var gridAutoFlow = (0, _style.default)({
	  prop: 'gridAutoFlow'
	});
	exports.gridAutoFlow = gridAutoFlow;
	var gridAutoColumns = (0, _style.default)({
	  prop: 'gridAutoColumns'
	});
	exports.gridAutoColumns = gridAutoColumns;
	var gridAutoRows = (0, _style.default)({
	  prop: 'gridAutoRows'
	});
	exports.gridAutoRows = gridAutoRows;
	var gridTemplateColumns = (0, _style.default)({
	  prop: 'gridTemplateColumns'
	});
	exports.gridTemplateColumns = gridTemplateColumns;
	var gridTemplateRows = (0, _style.default)({
	  prop: 'gridTemplateRows'
	});
	exports.gridTemplateRows = gridTemplateRows;
	var gridTemplateAreas = (0, _style.default)({
	  prop: 'gridTemplateAreas'
	});
	exports.gridTemplateAreas = gridTemplateAreas;
	var gridArea = (0, _style.default)({
	  prop: 'gridArea'
	});
	exports.gridArea = gridArea;
	var grid = (0, _compose.default)(gridGap, gridColumnGap, gridRowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
	var _default = grid;
	exports.default = _default;

/***/ },
/* 1364 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = memoize;
	
	function memoize(fn) {
	  var cache = {};
	  return function (arg) {
	    if (cache[arg] === undefined) {
	      cache[arg] = fn(arg);
	    }
	
	    return cache[arg];
	  };
	}

/***/ },
/* 1365 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.bgcolor = exports.color = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(100));
	
	var _compose = _interopRequireDefault(__webpack_require__(118));
	
	var color = (0, _style.default)({
	  prop: 'color',
	  themeKey: 'palette'
	});
	exports.color = color;
	var bgcolor = (0, _style.default)({
	  prop: 'bgcolor',
	  cssProperty: 'backgroundColor',
	  themeKey: 'palette'
	});
	exports.bgcolor = bgcolor;
	var palette = (0, _compose.default)(color, bgcolor);
	var _default = palette;
	exports.default = _default;

/***/ },
/* 1366 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.left = exports.bottom = exports.right = exports.top = exports.zIndex = exports.position = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(100));
	
	var _compose = _interopRequireDefault(__webpack_require__(118));
	
	var position = (0, _style.default)({
	  prop: 'position'
	});
	exports.position = position;
	var zIndex = (0, _style.default)({
	  prop: 'zIndex',
	  themeKey: 'zIndex'
	});
	exports.zIndex = zIndex;
	var top = (0, _style.default)({
	  prop: 'top'
	});
	exports.top = top;
	var right = (0, _style.default)({
	  prop: 'right'
	});
	exports.right = right;
	var bottom = (0, _style.default)({
	  prop: 'bottom'
	});
	exports.bottom = bottom;
	var left = (0, _style.default)({
	  prop: 'left'
	});
	exports.left = left;
	
	var _default = (0, _compose.default)(position, zIndex, top, right, bottom, left);
	
	exports.default = _default;

/***/ },
/* 1367 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(100));
	
	var boxShadow = (0, _style.default)({
	  prop: 'boxShadow',
	  themeKey: 'shadows'
	});
	var _default = boxShadow;
	exports.default = _default;

/***/ },
/* 1368 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.boxSizing = exports.sizeHeight = exports.sizeWidth = exports.minHeight = exports.maxHeight = exports.height = exports.minWidth = exports.maxWidth = exports.width = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(100));
	
	var _compose = _interopRequireDefault(__webpack_require__(118));
	
	function transform(value) {
	  return value <= 1 ? "".concat(value * 100, "%") : value;
	}
	
	var width = (0, _style.default)({
	  prop: 'width',
	  transform: transform
	});
	exports.width = width;
	var maxWidth = (0, _style.default)({
	  prop: 'maxWidth',
	  transform: transform
	});
	exports.maxWidth = maxWidth;
	var minWidth = (0, _style.default)({
	  prop: 'minWidth',
	  transform: transform
	});
	exports.minWidth = minWidth;
	var height = (0, _style.default)({
	  prop: 'height',
	  transform: transform
	});
	exports.height = height;
	var maxHeight = (0, _style.default)({
	  prop: 'maxHeight',
	  transform: transform
	});
	exports.maxHeight = maxHeight;
	var minHeight = (0, _style.default)({
	  prop: 'minHeight',
	  transform: transform
	});
	exports.minHeight = minHeight;
	var sizeWidth = (0, _style.default)({
	  prop: 'size',
	  cssProperty: 'width',
	  transform: transform
	});
	exports.sizeWidth = sizeWidth;
	var sizeHeight = (0, _style.default)({
	  prop: 'size',
	  cssProperty: 'height',
	  transform: transform
	});
	exports.sizeHeight = sizeHeight;
	var boxSizing = (0, _style.default)({
	  prop: 'boxSizing'
	});
	exports.boxSizing = boxSizing;
	var sizing = (0, _compose.default)(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
	var _default = sizing;
	exports.default = _default;

/***/ },
/* 1369 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createUnarySpacing = createUnarySpacing;
	exports.default = void 0;
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(80));
	
	var _responsivePropType = _interopRequireDefault(__webpack_require__(638));
	
	var _breakpoints = __webpack_require__(413);
	
	var _merge = _interopRequireDefault(__webpack_require__(312));
	
	var _memoize = _interopRequireDefault(__webpack_require__(1364));
	
	var properties = {
	  m: 'margin',
	  p: 'padding'
	};
	var directions = {
	  t: 'Top',
	  r: 'Right',
	  b: 'Bottom',
	  l: 'Left',
	  x: ['Left', 'Right'],
	  y: ['Top', 'Bottom']
	};
	var aliases = {
	  marginX: 'mx',
	  marginY: 'my',
	  paddingX: 'px',
	  paddingY: 'py'
	}; // memoize() impact:
	// From 300,000 ops/sec
	// To 350,000 ops/sec
	
	var getCssProperties = (0, _memoize.default)(function (prop) {
	  // It's not a shorthand notation.
	  if (prop.length > 2) {
	    if (aliases[prop]) {
	      prop = aliases[prop];
	    } else {
	      return [prop];
	    }
	  }
	
	  var _prop$split = prop.split(''),
	      _prop$split2 = (0, _slicedToArray2.default)(_prop$split, 2),
	      a = _prop$split2[0],
	      b = _prop$split2[1];
	
	  var property = properties[a];
	  var direction = directions[b] || '';
	  return Array.isArray(direction) ? direction.map(function (dir) {
	    return property + dir;
	  }) : [property + direction];
	});
	var spacingKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY'];
	
	function createUnarySpacing(theme) {
	  var themeSpacing = theme.spacing || 8;
	
	  if (typeof themeSpacing === 'number') {
	    return function (abs) {
	      if (false) {
	        if (typeof abs !== 'number') {
	          console.error("Material-UI: Expected spacing argument to be a number, got ".concat(abs, "."));
	        }
	      }
	
	      return themeSpacing * abs;
	    };
	  }
	
	  if (Array.isArray(themeSpacing)) {
	    return function (abs) {
	      if (false) {
	        if (abs > themeSpacing.length - 1) {
	          console.error(["Material-UI: The value provided (".concat(abs, ") overflows."), "The supported values are: ".concat(JSON.stringify(themeSpacing), "."), "".concat(abs, " > ").concat(themeSpacing.length - 1, ", you need to add the missing values.")].join('\n'));
	        }
	      }
	
	      return themeSpacing[abs];
	    };
	  }
	
	  if (typeof themeSpacing === 'function') {
	    return themeSpacing;
	  }
	
	  if (false) {
	    console.error(["Material-UI: The `theme.spacing` value (".concat(themeSpacing, ") is invalid."), 'It should be a number, an array or a function.'].join('\n'));
	  }
	
	  return function () {
	    return undefined;
	  };
	}
	
	function getValue(transformer, propValue) {
	  if (typeof propValue === 'string') {
	    return propValue;
	  }
	
	  var abs = Math.abs(propValue);
	  var transformed = transformer(abs);
	
	  if (propValue >= 0) {
	    return transformed;
	  }
	
	  if (typeof transformed === 'number') {
	    return -transformed;
	  }
	
	  return "-".concat(transformed);
	}
	
	function getStyleFromPropValue(cssProperties, transformer) {
	  return function (propValue) {
	    return cssProperties.reduce(function (acc, cssProperty) {
	      acc[cssProperty] = getValue(transformer, propValue);
	      return acc;
	    }, {});
	  };
	}
	
	function spacing(props) {
	  var theme = props.theme;
	  var transformer = createUnarySpacing(theme);
	  return Object.keys(props).map(function (prop) {
	    // Using a hash computation over an array iteration could be faster, but with only 28 items,
	    // it's doesn't worth the bundle size.
	    if (spacingKeys.indexOf(prop) === -1) {
	      return null;
	    }
	
	    var cssProperties = getCssProperties(prop);
	    var styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
	    var propValue = props[prop];
	    return (0, _breakpoints.handleBreakpoints)(props, propValue, styleFromPropValue);
	  }).reduce(_merge.default, {});
	}
	
	spacing.propTypes =  false ? spacingKeys.reduce(function (obj, key) {
	  obj[key] = _responsivePropType.default;
	  return obj;
	}, {}) : {};
	spacing.filterProps = spacingKeys;
	var _default = spacing;
	exports.default = _default;

/***/ },
/* 1370 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.textAlign = exports.lineHeight = exports.letterSpacing = exports.fontWeight = exports.fontStyle = exports.fontSize = exports.fontFamily = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(100));
	
	var _compose = _interopRequireDefault(__webpack_require__(118));
	
	var fontFamily = (0, _style.default)({
	  prop: 'fontFamily',
	  themeKey: 'typography'
	});
	exports.fontFamily = fontFamily;
	var fontSize = (0, _style.default)({
	  prop: 'fontSize',
	  themeKey: 'typography'
	});
	exports.fontSize = fontSize;
	var fontStyle = (0, _style.default)({
	  prop: 'fontStyle',
	  themeKey: 'typography'
	});
	exports.fontStyle = fontStyle;
	var fontWeight = (0, _style.default)({
	  prop: 'fontWeight',
	  themeKey: 'typography'
	});
	exports.fontWeight = fontWeight;
	var letterSpacing = (0, _style.default)({
	  prop: 'letterSpacing'
	});
	exports.letterSpacing = letterSpacing;
	var lineHeight = (0, _style.default)({
	  prop: 'lineHeight'
	});
	exports.lineHeight = lineHeight;
	var textAlign = (0, _style.default)({
	  prop: 'textAlign'
	});
	exports.textAlign = textAlign;
	var typography = (0, _compose.default)(fontFamily, fontSize, fontStyle, fontWeight, letterSpacing, lineHeight, textAlign);
	var _default = typography;
	exports.default = _default;

/***/ },
/* 1371 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = HTMLElementType;
	
	function HTMLElementType(props, propName, componentName, location, propFullName) {
	  if (true) {
	    return null;
	  }
	
	  var propValue = props[propName];
	  var safePropName = propFullName || propName;
	
	  if (propValue == null) {
	    return null;
	  }
	
	  if (propValue && propValue.nodeType !== 1) {
	    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an HTMLElement.");
	  }
	
	  return null;
	}

/***/ },
/* 1372 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isPlainObject = isPlainObject;
	exports.default = deepmerge;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(153));
	
	function isPlainObject(item) {
	  return item && (0, _typeof2.default)(item) === 'object' && item.constructor === Object;
	}
	
	function deepmerge(target, source) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
	    clone: true
	  };
	  var output = options.clone ? (0, _extends2.default)({}, target) : target;
	
	  if (isPlainObject(target) && isPlainObject(source)) {
	    Object.keys(source).forEach(function (key) {
	      // Avoid prototype pollution
	      if (key === '__proto__') {
	        return;
	      }
	
	      if (isPlainObject(source[key]) && key in target) {
	        output[key] = deepmerge(target[key], source[key], options);
	      } else {
	        output[key] = source[key];
	      }
	    });
	  }
	
	  return output;
	}

/***/ },
/* 1373 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _chainPropTypes = _interopRequireDefault(__webpack_require__(414));
	
	function isClassComponent(elementType) {
	  // elementType.prototype?.isReactComponent
	  var _elementType$prototyp = elementType.prototype,
	      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
	  return Boolean(prototype.isReactComponent);
	}
	
	function acceptingRef(props, propName, componentName, location, propFullName) {
	  var element = props[propName];
	  var safePropName = propFullName || propName;
	
	  if (element == null) {
	    return null;
	  }
	
	  var warningHint;
	  var elementType = element.type;
	  /**
	   * Blacklisting instead of whitelisting
	   *
	   * Blacklisting will miss some components, such as React.Fragment. Those will at least
	   * trigger a warning in React.
	   * We can't whitelist because there is no safe way to detect React.forwardRef
	   * or class components. "Safe" means there's no public API.
	   *
	   */
	
	  if (typeof elementType === 'function' && !isClassComponent(elementType)) {
	    warningHint = 'Did you accidentally use a plain function component for an element instead?';
	  }
	
	  if (warningHint !== undefined) {
	    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://material-ui.com/r/caveat-with-refs-guide');
	  }
	
	  return null;
	}
	
	var elementAcceptingRef = (0, _chainPropTypes.default)(_propTypes.default.element, acceptingRef);
	elementAcceptingRef.isRequired = (0, _chainPropTypes.default)(_propTypes.default.element.isRequired, acceptingRef);
	var _default = elementAcceptingRef;
	exports.default = _default;

/***/ },
/* 1374 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(5);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(4));
	
	var _chainPropTypes = _interopRequireDefault(__webpack_require__(414));
	
	function isClassComponent(elementType) {
	  // elementType.prototype?.isReactComponent
	  var _elementType$prototyp = elementType.prototype,
	      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
	  return Boolean(prototype.isReactComponent);
	}
	
	function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var safePropName = propFullName || propName;
	
	  if (propValue == null) {
	    return null;
	  }
	
	  var warningHint;
	  /**
	   * Blacklisting instead of whitelisting
	   *
	   * Blacklisting will miss some components, such as React.Fragment. Those will at least
	   * trigger a warning in React.
	   * We can't whitelist because there is no safe way to detect React.forwardRef
	   * or class components. "Safe" means there's no public API.
	   *
	   */
	
	  if (typeof propValue === 'function' && !isClassComponent(propValue)) {
	    warningHint = 'Did you accidentally provide a plain function component instead?';
	  }
	
	  if (warningHint !== undefined) {
	    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element type that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://material-ui.com/r/caveat-with-refs-guide');
	  }
	
	  return null;
	}
	
	var _default = (0, _chainPropTypes.default)(PropTypes.elementType, elementTypeAcceptingRef);
	
	exports.default = _default;

/***/ },
/* 1375 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exactProp;
	exports.specialProperty = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(62));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(6));
	
	// This module is based on https://github.com/airbnb/prop-types-exact repository.
	// However, in order to reduce the number of dependencies and to remove some extra safe checks
	// the module was forked.
	// Only exported for test purposes.
	var specialProperty = "exact-prop: \u200B";
	exports.specialProperty = specialProperty;
	
	function exactProp(propTypes) {
	  if (true) {
	    return propTypes;
	  }
	
	  return (0, _extends3.default)({}, propTypes, (0, _defineProperty2.default)({}, specialProperty, function (props) {
	    var unsupportedProps = Object.keys(props).filter(function (prop) {
	      return !propTypes.hasOwnProperty(prop);
	    });
	
	    if (unsupportedProps.length > 0) {
	      return new Error("The following props are not supported: ".concat(unsupportedProps.map(function (prop) {
	        return "`".concat(prop, "`");
	      }).join(', '), ". Please remove them."));
	    }
	
	    return null;
	  }));
	}

/***/ },
/* 1376 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatMuiErrorMessage;
	
	/**
	 * WARNING: Don't import this directly.
	 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
	 * @param {number} code
	 */
	function formatMuiErrorMessage(code) {
	  // Apply babel-plugin-transform-template-literals in loose mode
	  // loose mode is safe iff we're concatenating primitives
	  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
	
	  /* eslint-disable prefer-template */
	  var url = 'https://material-ui.com/production-error/?code=' + code;
	
	  for (var i = 1; i < arguments.length; i += 1) {
	    // rest params over-transpile for this case
	    // eslint-disable-next-line prefer-rest-params
	    url += '&args[]=' + encodeURIComponent(arguments[i]);
	  }
	
	  return 'Minified Material-UI error #' + code + '; visit ' + url + ' for the full message.';
	  /* eslint-enable prefer-template */
	}

/***/ },
/* 1377 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFunctionName = getFunctionName;
	exports.default = getDisplayName;
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(153));
	
	var _reactIs = __webpack_require__(72);
	
	// Simplified polyfill for IE 11 support
	// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
	var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
	
	function getFunctionName(fn) {
	  var match = "".concat(fn).match(fnNameMatchRegex);
	  var name = match && match[1];
	  return name || '';
	}
	/**
	 * @param {function} Component
	 * @param {string} fallback
	 * @returns {string | undefined}
	 */
	
	
	function getFunctionComponentName(Component) {
	  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
	}
	
	function getWrappedName(outerType, innerType, wrapperName) {
	  var functionName = getFunctionComponentName(innerType);
	  return outerType.displayName || (functionName !== '' ? "".concat(wrapperName, "(").concat(functionName, ")") : wrapperName);
	}
	/**
	 * cherry-pick from
	 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
	 * originally forked from recompose/getDisplayName with added IE 11 support
	 *
	 * @param {React.ReactType} Component
	 * @returns {string | undefined}
	 */
	
	
	function getDisplayName(Component) {
	  if (Component == null) {
	    return undefined;
	  }
	
	  if (typeof Component === 'string') {
	    return Component;
	  }
	
	  if (typeof Component === 'function') {
	    return getFunctionComponentName(Component, 'Component');
	  }
	
	  if ((0, _typeof2.default)(Component) === 'object') {
	    switch (Component.$$typeof) {
	      case _reactIs.ForwardRef:
	        return getWrappedName(Component, Component.render, 'ForwardRef');
	
	      case _reactIs.Memo:
	        return getWrappedName(Component, Component.type, 'memo');
	
	      default:
	        return undefined;
	    }
	  }
	
	  return undefined;
	}

/***/ },
/* 1378 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/* eslint-disable */
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var _default = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	
	exports.default = _default;

/***/ },
/* 1379 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var refType = _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]);
	
	var _default = refType;
	exports.default = _default;

/***/ },
/* 1380 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var grid_1 = __webpack_require__(428);
	function initialiseAgGridWithAngular1(angular) {
	    var angularModule = angular.module("agGrid", []);
	    angularModule.directive("agGrid", function () {
	        return {
	            restrict: "A",
	            controller: ['$element', '$scope', '$compile', '$attrs', AngularDirectiveController],
	            scope: true
	        };
	    });
	}
	exports.initialiseAgGridWithAngular1 = initialiseAgGridWithAngular1;
	function AngularDirectiveController($element, $scope, $compile, $attrs) {
	    var gridOptions;
	    var quickFilterOnScope;
	    var keyOfGridInScope = $attrs.agGrid;
	    quickFilterOnScope = keyOfGridInScope + '.quickFilterText';
	    gridOptions = $scope.$eval(keyOfGridInScope);
	    if (!gridOptions) {
	        console.warn("WARNING - grid options for ag-Grid not found. Please ensure the attribute ag-grid points to a valid object on the scope");
	        return;
	    }
	    var eGridDiv = $element[0];
	    var gridParams = {
	        $scope: $scope,
	        $compile: $compile,
	        quickFilterOnScope: quickFilterOnScope
	    };
	    var grid = new grid_1.Grid(eGridDiv, gridOptions, gridParams);
	    $scope.$on("$destroy", function () {
	        grid.destroy();
	        grid = null;
	    });
	}


/***/ },
/* 1381 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var componentUtil_1 = __webpack_require__(417);
	var grid_1 = __webpack_require__(428);
	var registered = false;
	function initialiseAgGridWithWebComponents() {
	    console.warn('ag-grid: initialiseAgGridWithWebComponents is deprecated. Please use the ag-grid-webcomponent dependency instead. ');
	    // only register to WebComponents once
	    if (registered) {
	        return;
	    }
	    registered = true;
	    if (typeof document === 'undefined' || !document.registerElement) {
	        console.error('ag-Grid: unable to find document.registerElement() function, unable to initialise ag-Grid as a Web Component');
	    }
	    // i don't think this type of extension is possible in TypeScript, so back to
	    // plain Javascript to create this object
	    var AgileGridProto = Object.create(HTMLElement.prototype);
	    // wrap each property with a get and set method, so we can track when changes are done
	    componentUtil_1.ComponentUtil.ALL_PROPERTIES.forEach(function (key) {
	        Object.defineProperty(AgileGridProto, key, {
	            set: function (v) {
	                this.__agGridSetProperty(key, v);
	            },
	            get: function () {
	                return this.__agGridGetProperty(key);
	            },
	            enumerable: true,
	            configurable: true
	        });
	    });
	    var agGridProtoNoType = AgileGridProto;
	    agGridProtoNoType.__agGridSetProperty = function (key, value) {
	        if (!this.__attributes) {
	            this.__attributes = {};
	        }
	        this.__attributes[key] = value;
	        // keeping this consistent with the ng2 onChange, so I can reuse the handling code
	        var changeObject = {};
	        changeObject[key] = { currentValue: value };
	        this.onChange(changeObject);
	    };
	    agGridProtoNoType.onChange = function (changes) {
	        if (this._initialised) {
	            componentUtil_1.ComponentUtil.processOnChange(changes, this._gridOptions, this.api, this.columnApi);
	        }
	    };
	    agGridProtoNoType.__agGridGetProperty = function (key) {
	        if (!this.__attributes) {
	            this.__attributes = {};
	        }
	        return this.__attributes[key];
	    };
	    agGridProtoNoType.setGridOptions = function (options) {
	        var globalEventListener = this.globalEventListener.bind(this);
	        this._gridOptions = componentUtil_1.ComponentUtil.copyAttributesToGridOptions(options, this);
	        var gridParams = {
	            globalEventListener: globalEventListener
	        };
	        this._agGrid = new grid_1.Grid(this, this._gridOptions, gridParams);
	        this.api = options.api;
	        this.columnApi = options.columnApi;
	        this._initialised = true;
	    };
	    // copies all the attributes into this object
	    agGridProtoNoType.createdCallback = function () {
	        for (var i = 0; i < this.attributes.length; i++) {
	            var attribute = this.attributes[i];
	            this.setPropertyFromAttribute(attribute);
	        }
	    };
	    agGridProtoNoType.setPropertyFromAttribute = function (attribute) {
	        var name = toCamelCase(attribute.nodeName);
	        var value = attribute.nodeValue;
	        if (componentUtil_1.ComponentUtil.ALL_PROPERTIES.indexOf(name) >= 0) {
	            this[name] = value;
	        }
	    };
	    agGridProtoNoType.attachedCallback = function (params) { };
	    agGridProtoNoType.detachedCallback = function (params) { };
	    agGridProtoNoType.attributeChangedCallback = function (attributeName) {
	        var attribute = this.attributes[attributeName];
	        this.setPropertyFromAttribute(attribute);
	    };
	    agGridProtoNoType.globalEventListener = function (eventType, event) {
	        var eventLowerCase = eventType.toLowerCase();
	        var browserEvent = new Event(eventLowerCase);
	        var browserEventNoType = browserEvent;
	        browserEventNoType.agGridDetails = event;
	        this.dispatchEvent(browserEvent);
	        var callbackMethod = 'on' + eventLowerCase;
	        if (typeof this[callbackMethod] === 'function') {
	            this[callbackMethod](browserEvent);
	        }
	    };
	    // finally, register
	    document.registerElement('ag-grid', { prototype: AgileGridProto });
	}
	exports.initialiseAgGridWithWebComponents = initialiseAgGridWithWebComponents;
	function toCamelCase(myString) {
	    if (typeof myString === 'string') {
	        var result = myString.replace(/-([a-z])/g, function (g) {
	            return g[1].toUpperCase();
	        });
	        return result;
	    }
	    else {
	        return myString;
	    }
	}


/***/ },
/* 1382 */
/***/ function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var BaseComponentWrapper = /** @class */ (function () {
	    function BaseComponentWrapper() {
	    }
	    BaseComponentWrapper.prototype.wrap = function (OriginalConstructor, mandatoryMethodList, optionalMethodList, componentName) {
	        var _this = this;
	        if (optionalMethodList === void 0) { optionalMethodList = []; }
	        var wrapper = this.createWrapper(OriginalConstructor, componentName);
	        mandatoryMethodList.forEach((function (methodName) {
	            _this.createMethod(wrapper, methodName, true);
	        }));
	        optionalMethodList.forEach((function (methodName) {
	            _this.createMethod(wrapper, methodName, false);
	        }));
	        return wrapper;
	    };
	    BaseComponentWrapper.prototype.createMethod = function (wrapper, methodName, mandatory) {
	        wrapper.addMethod(methodName, this.createMethodProxy(wrapper, methodName, mandatory));
	    };
	    BaseComponentWrapper.prototype.createMethodProxy = function (wrapper, methodName, mandatory) {
	        return function () {
	            if (wrapper.hasMethod(methodName)) {
	                return wrapper.callMethod(methodName, arguments);
	            }
	            if (mandatory) {
	                console.warn('ag-Grid: Framework component is missing the method ' + methodName + '()');
	            }
	            return null;
	        };
	    };
	    return BaseComponentWrapper;
	}());
	exports.BaseComponentWrapper = BaseComponentWrapper;


/***/ },
/* 1383 */
/***/ function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.DefaultColumnTypes = {
	    numericColumn: {
	        headerClass: "ag-numeric-header",
	        cellClass: "ag-numeric-cell"
	    }
	};


/***/ },
/* 1384 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var column_1 = __webpack_require__(45);
	var setLeftFeature_1 = __webpack_require__(322);
	var component_1 = __webpack_require__(31);
	var componentAnnotations_1 = __webpack_require__(39);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var beans_1 = __webpack_require__(161);
	var hoverFeature_1 = __webpack_require__(432);
	var events_1 = __webpack_require__(29);
	var eventService_1 = __webpack_require__(22);
	var columnHoverService_1 = __webpack_require__(252);
	var utils_1 = __webpack_require__(10);
	var userComponentFactory_1 = __webpack_require__(81);
	var gridApi_1 = __webpack_require__(33);
	var columnApi_1 = __webpack_require__(38);
	var filterManager_1 = __webpack_require__(77);
	var readOnlyFloatingFilter_1 = __webpack_require__(1385);
	var FloatingFilterWrapper = /** @class */ (function (_super) {
	    __extends(FloatingFilterWrapper, _super);
	    function FloatingFilterWrapper(column) {
	        var _this = _super.call(this, FloatingFilterWrapper.TEMPLATE) || this;
	        _this.column = column;
	        return _this;
	    }
	    FloatingFilterWrapper.prototype.postConstruct = function () {
	        this.setupFloatingFilter();
	        this.setupWidth();
	        this.setupLeftPositioning();
	        this.setupColumnHover();
	        this.addFeature(this.getContext(), new hoverFeature_1.HoverFeature([this.column], this.getGui()));
	        this.addDestroyableEventListener(this.eButtonShowMainFilter, 'click', this.showParentFilter.bind(this));
	    };
	    FloatingFilterWrapper.prototype.setupFloatingFilter = function () {
	        var _this = this;
	        var colDef = this.column.getColDef();
	        if (colDef.filter) {
	            this.floatingFilterCompPromise = this.getFloatingFilterInstance();
	            if (this.floatingFilterCompPromise) {
	                this.floatingFilterCompPromise.then(function (compInstance) {
	                    if (compInstance) {
	                        _this.setupWithFloatingFilter(compInstance);
	                        _this.setupSyncWithFilter();
	                    }
	                    else {
	                        _this.setupEmpty();
	                    }
	                });
	            }
	            else {
	                this.setupEmpty();
	            }
	        }
	        else {
	            this.setupEmpty();
	        }
	    };
	    FloatingFilterWrapper.prototype.setupLeftPositioning = function () {
	        var setLeftFeature = new setLeftFeature_1.SetLeftFeature(this.column, this.getGui(), this.beans);
	        setLeftFeature.init();
	        this.addDestroyFunc(setLeftFeature.destroy.bind(setLeftFeature));
	    };
	    FloatingFilterWrapper.prototype.setupSyncWithFilter = function () {
	        var _this = this;
	        var syncWithFilter = function (filterChangedEvent) {
	            var filterComponentPromise = _this.filterManager.getFilterComponent(_this.column, 'NO_UI');
	            var parentModel = filterComponentPromise.resolveNow(null, function (filter) { return filter.getModel(); });
	            _this.onParentModelChanged(parentModel, filterChangedEvent);
	        };
	        this.addDestroyableEventListener(this.column, column_1.Column.EVENT_FILTER_CHANGED, syncWithFilter);
	        if (this.filterManager.isFilterActive(this.column)) {
	            syncWithFilter(null);
	        }
	    };
	    // linked to event listener in template
	    FloatingFilterWrapper.prototype.showParentFilter = function () {
	        this.menuFactory.showMenuAfterButtonClick(this.column, this.eButtonShowMainFilter, 'filterMenuTab', ['filterMenuTab']);
	    };
	    FloatingFilterWrapper.prototype.setupColumnHover = function () {
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_COLUMN_HOVER_CHANGED, this.onColumnHover.bind(this));
	        this.onColumnHover();
	    };
	    FloatingFilterWrapper.prototype.onColumnHover = function () {
	        var isHovered = this.columnHoverService.isHovered(this.column);
	        utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-column-hover', isHovered);
	    };
	    FloatingFilterWrapper.prototype.setupWidth = function () {
	        this.addDestroyableEventListener(this.column, column_1.Column.EVENT_WIDTH_CHANGED, this.onColumnWidthChanged.bind(this));
	        this.onColumnWidthChanged();
	    };
	    FloatingFilterWrapper.prototype.onColumnWidthChanged = function () {
	        this.getGui().style.width = this.column.getActualWidth() + 'px';
	    };
	    FloatingFilterWrapper.prototype.setupWithFloatingFilter = function (floatingFilterComp) {
	        var disposeFunc = function () {
	            if (floatingFilterComp.destroy) {
	                floatingFilterComp.destroy();
	            }
	        };
	        if (!this.isAlive()) {
	            disposeFunc();
	            return;
	        }
	        this.addDestroyFunc(disposeFunc);
	        var floatingFilterCompUi = floatingFilterComp.getGui();
	        utils_1._.addOrRemoveCssClass(this.eFloatingFilterBody, 'ag-floating-filter-body', !this.suppressFilterButton);
	        utils_1._.addOrRemoveCssClass(this.eFloatingFilterBody, 'ag-floating-filter-full-body', this.suppressFilterButton);
	        utils_1._.setDisplayed(this.eButtonWrapper, !this.suppressFilterButton);
	        var eIcon = utils_1._.createIconNoSpan('filter', this.gridOptionsWrapper, this.column);
	        this.eButtonShowMainFilter.appendChild(eIcon);
	        this.eFloatingFilterBody.appendChild(floatingFilterCompUi);
	        if (floatingFilterComp.afterGuiAttached) {
	            floatingFilterComp.afterGuiAttached();
	        }
	    };
	    FloatingFilterWrapper.prototype.parentFilterInstance = function (callback) {
	        var promise = this.filterManager.getFilterComponent(this.column, 'NO_UI');
	        promise.then(callback);
	    };
	    FloatingFilterWrapper.prototype.getFloatingFilterInstance = function () {
	        var colDef = this.column.getColDef();
	        var defaultFloatingFilterType;
	        if (typeof colDef.filter === 'string') {
	            // will be undefined if not in the map
	            defaultFloatingFilterType = FloatingFilterWrapper.filterToFloatingFilterNames[colDef.filter];
	        }
	        else if (colDef.filter === true) {
	            defaultFloatingFilterType = this.gridOptionsWrapper.isEnterprise() ? 'agSetColumnFloatingFilter' : 'agTextColumnFloatingFilter';
	        }
	        var filterParams = this.filterManager.createFilterParams(this.column, this.column.getColDef());
	        var finalFilterParams = this.userComponentFactory.createFinalParams(colDef, 'filter', filterParams);
	        var params = {
	            api: this.gridApi,
	            column: this.column,
	            filterParams: finalFilterParams,
	            currentParentModel: this.currentParentModel.bind(this),
	            parentFilterInstance: this.parentFilterInstance.bind(this),
	            onFloatingFilterChanged: this.onFloatingFilterChanged.bind(this),
	            suppressFilterButton: false // This one might be overridden from the colDef
	        };
	        // this is unusual - we need a params value OUTSIDE the component the params are for.
	        // the params are for the floating filter component, but this property is actually for the wrapper.
	        this.suppressFilterButton = colDef.floatingFilterComponentParams ? !!colDef.floatingFilterComponentParams.suppressFilterButton : false;
	        var promise = this.userComponentFactory.newFloatingFilterComponent(colDef, params, defaultFloatingFilterType);
	        if (!promise) {
	            var filterComponent = this.getFilterComponentPrototype(colDef);
	            var getModelAsStringExists = filterComponent && filterComponent.prototype && filterComponent.prototype.getModelAsString;
	            if (getModelAsStringExists) {
	                var compInstance = this.userComponentFactory.createUserComponentFromConcreteClass(readOnlyFloatingFilter_1.ReadOnlyFloatingFilter, params);
	                promise = utils_1.Promise.resolve(compInstance);
	            }
	        }
	        return promise;
	    };
	    FloatingFilterWrapper.prototype.createDynamicParams = function () {
	        return {
	            column: this.column,
	            colDef: this.column.getColDef(),
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	    };
	    FloatingFilterWrapper.prototype.getFilterComponentPrototype = function (colDef) {
	        var resolvedComponent = this.userComponentFactory.lookupComponentClassDef(colDef, "filter", this.createDynamicParams());
	        return resolvedComponent ? resolvedComponent.component : null;
	    };
	    FloatingFilterWrapper.prototype.setupEmpty = function () {
	        utils_1._.setDisplayed(this.eButtonWrapper, false);
	    };
	    FloatingFilterWrapper.prototype.currentParentModel = function () {
	        var filterPromise = this.filterManager.getFilterComponent(this.column, 'NO_UI');
	        return filterPromise.resolveNow(null, function (filter) { return filter.getModel(); });
	    };
	    FloatingFilterWrapper.prototype.onParentModelChanged = function (model, filterChangedEvent) {
	        if (!this.floatingFilterCompPromise) {
	            return;
	        }
	        this.floatingFilterCompPromise.then(function (floatingFilterComp) {
	            floatingFilterComp.onParentModelChanged(model, filterChangedEvent);
	        });
	    };
	    FloatingFilterWrapper.prototype.onFloatingFilterChanged = function () {
	        console.warn('ag-Grid: since version 21.x, how floating filters are implemented has changed. ' +
	            'Instead of calling params.onFloatingFilterChanged(), get a reference to the main filter via ' +
	            'params.parentFilterInstance() and then set a value on the parent filter directly.');
	    };
	    FloatingFilterWrapper.filterToFloatingFilterNames = {
	        set: 'agSetColumnFloatingFilter',
	        agSetColumnFilter: 'agSetColumnFloatingFilter',
	        number: 'agNumberColumnFloatingFilter',
	        agNumberColumnFilter: 'agNumberColumnFloatingFilter',
	        date: 'agDateColumnFloatingFilter',
	        agDateColumnFilter: 'agDateColumnFloatingFilter',
	        text: 'agTextColumnFloatingFilter',
	        agTextColumnFilter: 'agTextColumnFloatingFilter'
	    };
	    FloatingFilterWrapper.TEMPLATE = "<div class=\"ag-header-cell\" role=\"presentation\">\n            <div ref=\"eFloatingFilterBody\" role=\"columnheader\"></div>\n            <div class=\"ag-floating-filter-button\" ref=\"eButtonWrapper\" role=\"presentation\">\n                <button type=\"button\" ref=\"eButtonShowMainFilter\"></button>\n            </div>\n        </div>";
	    __decorate([
	        context_1.Autowired('columnHoverService'),
	        __metadata("design:type", columnHoverService_1.ColumnHoverService)
	    ], FloatingFilterWrapper.prototype, "columnHoverService", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], FloatingFilterWrapper.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('beans'),
	        __metadata("design:type", beans_1.Beans)
	    ], FloatingFilterWrapper.prototype, "beans", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], FloatingFilterWrapper.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired("userComponentFactory"),
	        __metadata("design:type", userComponentFactory_1.UserComponentFactory)
	    ], FloatingFilterWrapper.prototype, "userComponentFactory", void 0);
	    __decorate([
	        context_1.Autowired("gridApi"),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], FloatingFilterWrapper.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.Autowired("columnApi"),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], FloatingFilterWrapper.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired("filterManager"),
	        __metadata("design:type", filterManager_1.FilterManager)
	    ], FloatingFilterWrapper.prototype, "filterManager", void 0);
	    __decorate([
	        context_1.Autowired('menuFactory'),
	        __metadata("design:type", Object)
	    ], FloatingFilterWrapper.prototype, "menuFactory", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eFloatingFilterBody'),
	        __metadata("design:type", HTMLElement)
	    ], FloatingFilterWrapper.prototype, "eFloatingFilterBody", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eButtonWrapper'),
	        __metadata("design:type", HTMLElement)
	    ], FloatingFilterWrapper.prototype, "eButtonWrapper", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eButtonShowMainFilter'),
	        __metadata("design:type", HTMLElement)
	    ], FloatingFilterWrapper.prototype, "eButtonShowMainFilter", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], FloatingFilterWrapper.prototype, "postConstruct", null);
	    return FloatingFilterWrapper;
	}(component_1.Component));
	exports.FloatingFilterWrapper = FloatingFilterWrapper;


/***/ },
/* 1385 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(31);
	var componentAnnotations_1 = __webpack_require__(39);
	// optional floating filter for user provided filters - instead of providing a floating filter,
	// they can provide a getModelAsString() method on the filter instead. this class just displays
	// the string returned from getModelAsString()
	var ReadOnlyFloatingFilter = /** @class */ (function (_super) {
	    __extends(ReadOnlyFloatingFilter, _super);
	    function ReadOnlyFloatingFilter() {
	        return _super.call(this, "<div class=\"ag-input-wrapper\" role=\"presentation\"><input ref=\"eFloatingFilterText\" class=\"ag-floating-filter-input\"></div>") || this;
	    }
	    ReadOnlyFloatingFilter.prototype.init = function (params) {
	        this.params = params;
	        this.eFloatingFilterText.disabled = true;
	    };
	    ReadOnlyFloatingFilter.prototype.onParentModelChanged = function (parentModel) {
	        var _this = this;
	        if (!parentModel) {
	            this.eFloatingFilterText.value = '';
	            return;
	        }
	        this.params.parentFilterInstance(function (filterInstance) {
	            // getModelAsString should be present, as we check this
	            // in floatingFilterWrapper
	            if (filterInstance.getModelAsString) {
	                var modelAsString = filterInstance.getModelAsString(parentModel);
	                _this.eFloatingFilterText.value = modelAsString;
	            }
	        });
	    };
	    __decorate([
	        componentAnnotations_1.RefSelector('eFloatingFilterText'),
	        __metadata("design:type", HTMLInputElement)
	    ], ReadOnlyFloatingFilter.prototype, "eFloatingFilterText", void 0);
	    return ReadOnlyFloatingFilter;
	}(component_1.Component));
	exports.ReadOnlyFloatingFilter = ReadOnlyFloatingFilter;


/***/ },
/* 1386 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var dateFilter_1 = __webpack_require__(424);
	var context_1 = __webpack_require__(8);
	var userComponentFactory_1 = __webpack_require__(81);
	var utils_1 = __webpack_require__(10);
	var dateCompWrapper_1 = __webpack_require__(647);
	var componentAnnotations_1 = __webpack_require__(39);
	var simpleFilter_1 = __webpack_require__(134);
	var simpleFloatingFilter_1 = __webpack_require__(645);
	var providedFilter_1 = __webpack_require__(317);
	var DateFloatingFilter = /** @class */ (function (_super) {
	    __extends(DateFloatingFilter, _super);
	    function DateFloatingFilter() {
	        return _super.call(this, "<div class=\"ag-input-wrapper\" role=\"presentation\">\n                <input ref=\"eReadOnlyText\" disabled=\"true\" class=\"ag-floating-filter-input\">\n                <div ref=\"eDateWrapper\" style=\"display: flex; flex: 1 1 auto; overflow: hidden;\"></div>\n            </div>") || this;
	    }
	    DateFloatingFilter.prototype.getDefaultFilterOptions = function () {
	        return dateFilter_1.DateFilter.DEFAULT_FILTER_OPTIONS;
	    };
	    DateFloatingFilter.prototype.conditionToString = function (condition) {
	        var isRange = condition.type == simpleFilter_1.SimpleFilter.IN_RANGE;
	        if (isRange) {
	            return condition.dateFrom + "-" + condition.dateTo;
	        }
	        else {
	            // cater for when the type doesn't need a value
	            if (condition.dateFrom != null) {
	                return "" + condition.dateFrom;
	            }
	            else {
	                return "" + condition.type;
	            }
	        }
	    };
	    DateFloatingFilter.prototype.init = function (params) {
	        _super.prototype.init.call(this, params);
	        this.params = params;
	        this.createDateComponent();
	    };
	    DateFloatingFilter.prototype.setEditable = function (editable) {
	        utils_1._.setDisplayed(this.eDateWrapper, editable);
	        utils_1._.setDisplayed(this.eReadOnlyText, !editable);
	    };
	    DateFloatingFilter.prototype.onParentModelChanged = function (model, event) {
	        // we don't want to update the floating filter if the floating filter caused the change.
	        // as if it caused the change, the ui is already in sycn. if we didn't do this, the UI
	        // would behave strange as it would be updating as the user is typing
	        if (this.isEventFromFloatingFilter(event)) {
	            return;
	        }
	        _super.prototype.setLastTypeFromModel.call(this, model);
	        var allowEditing = this.canWeEditAfterModelFromParentFilter(model);
	        this.setEditable(allowEditing);
	        if (allowEditing) {
	            if (model) {
	                var dateModel = model;
	                this.dateComp.setDate(utils_1._.parseYyyyMmDdToDate(dateModel.dateFrom, '-'));
	            }
	            else {
	                this.dateComp.setDate(null);
	            }
	            this.eReadOnlyText.value = '';
	        }
	        else {
	            this.eReadOnlyText.value = this.getTextFromModel(model);
	            this.dateComp.setDate(null);
	        }
	    };
	    DateFloatingFilter.prototype.onDateChanged = function () {
	        var _this = this;
	        var filterValueDate = this.dateComp.getDate();
	        var filterValueText = utils_1._.serializeDateToYyyyMmDd(filterValueDate, "-");
	        this.params.parentFilterInstance(function (filterInstance) {
	            if (filterInstance) {
	                var simpleFilter = filterInstance;
	                simpleFilter.onFloatingFilterChanged(_this.getLastType(), filterValueText);
	            }
	        });
	    };
	    DateFloatingFilter.prototype.createDateComponent = function () {
	        var _this = this;
	        var debounceMs = providedFilter_1.ProvidedFilter.getDebounceMs(this.params.filterParams, this.getDefaultDebounceMs());
	        var toDebounce = utils_1._.debounce(this.onDateChanged.bind(this), debounceMs);
	        var dateComponentParams = {
	            onDateChanged: toDebounce,
	            filterParams: this.params.column.getColDef().filterParams
	        };
	        this.dateComp = new dateCompWrapper_1.DateCompWrapper(this.userComponentFactory, dateComponentParams, this.eDateWrapper);
	        this.addDestroyFunc(function () {
	            _this.dateComp.destroy();
	        });
	    };
	    __decorate([
	        context_1.Autowired('userComponentFactory'),
	        __metadata("design:type", userComponentFactory_1.UserComponentFactory)
	    ], DateFloatingFilter.prototype, "userComponentFactory", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eReadOnlyText'),
	        __metadata("design:type", HTMLInputElement)
	    ], DateFloatingFilter.prototype, "eReadOnlyText", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eDateWrapper'),
	        __metadata("design:type", HTMLInputElement)
	    ], DateFloatingFilter.prototype, "eDateWrapper", void 0);
	    return DateFloatingFilter;
	}(simpleFloatingFilter_1.SimpleFloatingFilter));
	exports.DateFloatingFilter = DateFloatingFilter;


/***/ },
/* 1387 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(31);
	var utils_1 = __webpack_require__(10);
	var DefaultDateComponent = /** @class */ (function (_super) {
	    __extends(DefaultDateComponent, _super);
	    function DefaultDateComponent() {
	        return _super.call(this, "<div class=\"ag-input-wrapper\" role=\"presentation\"><input class=\"ag-filter-filter\" type=\"text\" placeholder=\"yyyy-mm-dd\"></div>") || this;
	    }
	    DefaultDateComponent.prototype.init = function (params) {
	        this.eDateInput = this.getGui().querySelector('input');
	        if (utils_1._.isBrowserChrome() || params.filterParams.browserDatePicker) {
	            if (utils_1._.isBrowserIE()) {
	                console.warn('ag-grid: browserDatePicker is specified to true, but it is not supported in IE 11, reverting to plain text date picker');
	            }
	            else {
	                this.eDateInput.type = 'date';
	            }
	        }
	        this.listener = params.onDateChanged;
	        this.addGuiEventListener('input', this.listener);
	    };
	    DefaultDateComponent.prototype.getDate = function () {
	        return utils_1._.parseYyyyMmDdToDate(this.eDateInput.value, "-");
	    };
	    DefaultDateComponent.prototype.setDate = function (date) {
	        this.eDateInput.value = utils_1._.serializeDateToYyyyMmDd(date, "-");
	    };
	    return DefaultDateComponent;
	}(component_1.Component));
	exports.DefaultDateComponent = DefaultDateComponent;


/***/ },
/* 1388 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var numberFilter_1 = __webpack_require__(425);
	var simpleFilter_1 = __webpack_require__(134);
	var textInputFloatingFilter_1 = __webpack_require__(646);
	var NumberFloatingFilter = /** @class */ (function (_super) {
	    __extends(NumberFloatingFilter, _super);
	    function NumberFloatingFilter() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    NumberFloatingFilter.prototype.getDefaultFilterOptions = function () {
	        return numberFilter_1.NumberFilter.DEFAULT_FILTER_OPTIONS;
	    };
	    NumberFloatingFilter.prototype.conditionToString = function (condition) {
	        var isRange = condition.type == simpleFilter_1.SimpleFilter.IN_RANGE;
	        if (isRange) {
	            return condition.filter + "-" + condition.filterTo;
	        }
	        else {
	            // cater for when the type doesn't need a value
	            if (condition.filter != null) {
	                return "" + condition.filter;
	            }
	            else {
	                return "" + condition.type;
	            }
	        }
	    };
	    return NumberFloatingFilter;
	}(textInputFloatingFilter_1.TextInputFloatingFilter));
	exports.NumberFloatingFilter = NumberFloatingFilter;


/***/ },
/* 1389 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var textFilter_1 = __webpack_require__(427);
	var textInputFloatingFilter_1 = __webpack_require__(646);
	var TextFloatingFilter = /** @class */ (function (_super) {
	    __extends(TextFloatingFilter, _super);
	    function TextFloatingFilter() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TextFloatingFilter.prototype.conditionToString = function (condition) {
	        // it's not possible to have 'in range' for string, so no need to check for it.
	        // also cater for when the type doesn't need a value
	        if (condition.filter != null) {
	            return "" + condition.filter;
	        }
	        else {
	            return "" + condition.type;
	        }
	    };
	    TextFloatingFilter.prototype.getDefaultFilterOptions = function () {
	        return textFilter_1.TextFilter.DEFAULT_FILTER_OPTIONS;
	    };
	    return TextFloatingFilter;
	}(textInputFloatingFilter_1.TextInputFloatingFilter));
	exports.TextFloatingFilter = TextFloatingFilter;


/***/ },
/* 1390 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(10);
	function defaultGroupComparator(valueA, valueB, nodeA, nodeB, accentedCompare) {
	    if (accentedCompare === void 0) { accentedCompare = false; }
	    console.warn('ag-Grid: Since ag-grid 11.0.0 defaultGroupComparator is not necessary. You can remove this from your colDef');
	    var nodeAIsGroup = utils_1._.exists(nodeA) && nodeA.group;
	    var nodeBIsGroup = utils_1._.exists(nodeB) && nodeB.group;
	    var bothAreGroups = nodeAIsGroup && nodeBIsGroup;
	    var bothAreNormal = !nodeAIsGroup && !nodeBIsGroup;
	    if (bothAreGroups) {
	        return utils_1._.defaultComparator(nodeA.key, nodeB.key, accentedCompare);
	    }
	    else if (bothAreNormal) {
	        return utils_1._.defaultComparator(valueA, valueB, accentedCompare);
	    }
	    else if (nodeAIsGroup) {
	        return 1;
	    }
	    else {
	        return -1;
	    }
	}
	exports.defaultGroupComparator = defaultGroupComparator;


/***/ },
/* 1391 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var dragAndDropService_1 = __webpack_require__(82);
	var context_1 = __webpack_require__(8);
	var focusedCellController_1 = __webpack_require__(119);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var eventService_1 = __webpack_require__(22);
	var eventKeys_1 = __webpack_require__(160);
	var constants_1 = __webpack_require__(30);
	var RowDragFeature = /** @class */ (function () {
	    function RowDragFeature(eContainer, gridPanel) {
	        this.eContainer = eContainer;
	        this.gridPanel = gridPanel;
	    }
	    RowDragFeature.prototype.postConstruct = function () {
	        if (this.gridOptionsWrapper.isRowModelDefault()) {
	            this.clientSideRowModel = this.rowModel;
	        }
	    };
	    RowDragFeature.prototype.getContainer = function () {
	        return this.eContainer;
	    };
	    RowDragFeature.prototype.isInterestedIn = function (type) {
	        return type === dragAndDropService_1.DragSourceType.RowDrag;
	    };
	    RowDragFeature.prototype.getIconName = function () {
	        return dragAndDropService_1.DragAndDropService.ICON_MOVE;
	    };
	    RowDragFeature.prototype.onDragEnter = function (draggingEvent) {
	        // when entering, we fire the enter event, then in onEnterOrDragging,
	        // we also fire the move event. so we get both events when entering.
	        this.dispatchEvent(eventKeys_1.Events.EVENT_ROW_DRAG_ENTER, draggingEvent);
	        this.dragAndDropService.setGhostIcon(dragAndDropService_1.DragAndDropService.ICON_MOVE);
	        draggingEvent.dragItem.rowNode.setDragging(true);
	        this.onEnterOrDragging(draggingEvent);
	    };
	    RowDragFeature.prototype.onDragging = function (draggingEvent) {
	        this.onEnterOrDragging(draggingEvent);
	    };
	    RowDragFeature.prototype.onEnterOrDragging = function (draggingEvent) {
	        // this event is fired for enter and move
	        this.dispatchEvent(eventKeys_1.Events.EVENT_ROW_DRAG_MOVE, draggingEvent);
	        this.lastDraggingEvent = draggingEvent;
	        var pixel = this.normaliseForScroll(draggingEvent.y);
	        var managedDrag = this.gridOptionsWrapper.isRowDragManaged();
	        if (managedDrag) {
	            this.doManagedDrag(draggingEvent, pixel);
	        }
	        this.checkCenterForScrolling(pixel);
	    };
	    RowDragFeature.prototype.doManagedDrag = function (draggingEvent, pixel) {
	        var rowNode = draggingEvent.dragItem.rowNode;
	        var rowWasMoved = this.clientSideRowModel.ensureRowAtPixel(rowNode, pixel);
	        if (rowWasMoved) {
	            this.focusedCellController.clearFocusedCell();
	            if (this.rangeController) {
	                this.rangeController.removeAllCellRanges();
	            }
	        }
	    };
	    RowDragFeature.prototype.normaliseForScroll = function (pixel) {
	        var gridPanelHasScrolls = this.gridOptionsWrapper.getDomLayout() === constants_1.Constants.DOM_LAYOUT_NORMAL;
	        if (gridPanelHasScrolls) {
	            var pixelRange = this.gridPanel.getVScrollPosition();
	            return pixel + pixelRange.top;
	        }
	        else {
	            return pixel;
	        }
	    };
	    RowDragFeature.prototype.checkCenterForScrolling = function (pixel) {
	        // scroll if the mouse is within 50px of the grid edge
	        var pixelRange = this.gridPanel.getVScrollPosition();
	        // console.log(`pixelRange = (${pixelRange.top}, ${pixelRange.bottom})`);
	        this.needToMoveUp = pixel < (pixelRange.top + 50);
	        this.needToMoveDown = pixel > (pixelRange.bottom - 50);
	        // console.log(`needToMoveUp = ${this.needToMoveUp} = pixel < (pixelRange.top + 50) = ${pixel} < (${pixelRange.top} + 50)`);
	        // console.log(`needToMoveDown = ${this.needToMoveDown} = pixel < (pixelRange.top + 50) = ${pixel} < (${pixelRange.top} + 50)`);
	        if (this.needToMoveUp || this.needToMoveDown) {
	            this.ensureIntervalStarted();
	        }
	        else {
	            this.ensureIntervalCleared();
	        }
	    };
	    RowDragFeature.prototype.ensureIntervalStarted = function () {
	        if (!this.movingIntervalId) {
	            this.intervalCount = 0;
	            this.movingIntervalId = window.setInterval(this.moveInterval.bind(this), 100);
	        }
	    };
	    RowDragFeature.prototype.ensureIntervalCleared = function () {
	        if (this.moveInterval) {
	            window.clearInterval(this.movingIntervalId);
	            this.movingIntervalId = null;
	        }
	    };
	    RowDragFeature.prototype.moveInterval = function () {
	        // the amounts we move get bigger at each interval, so the speed accelerates, starting a bit slow
	        // and getting faster. this is to give smoother user experience. we max at 100px to limit the speed.
	        var pixelsToMove;
	        this.intervalCount++;
	        pixelsToMove = 10 + (this.intervalCount * 5);
	        if (pixelsToMove > 100) {
	            pixelsToMove = 100;
	        }
	        var pixelsMoved;
	        if (this.needToMoveDown) {
	            pixelsMoved = this.gridPanel.scrollVertically(pixelsToMove);
	        }
	        else if (this.needToMoveUp) {
	            pixelsMoved = this.gridPanel.scrollVertically(-pixelsToMove);
	        }
	        if (pixelsMoved !== 0) {
	            this.onDragging(this.lastDraggingEvent);
	        }
	    };
	    // i tried using generics here with this:
	    //     public createEvent<T extends RowDragEvent>(type: string, clazz: {new(): T; }, draggingEvent: DraggingEvent) {
	    // but it didn't work - i think it's because it only works with classes, and not interfaces, (the events are interfaces)
	    RowDragFeature.prototype.dispatchEvent = function (type, draggingEvent) {
	        var yNormalised = this.normaliseForScroll(draggingEvent.y);
	        var overIndex = -1;
	        var overNode = null;
	        var mouseIsPastLastRow = yNormalised > this.rowModel.getCurrentPageHeight();
	        if (!mouseIsPastLastRow) {
	            overIndex = this.rowModel.getRowIndexAtPixel(yNormalised);
	            overNode = this.rowModel.getRow(overIndex);
	        }
	        var vDirectionString;
	        switch (draggingEvent.vDirection) {
	            case dragAndDropService_1.VDirection.Down:
	                vDirectionString = 'down';
	                break;
	            case dragAndDropService_1.VDirection.Up:
	                vDirectionString = 'up';
	                break;
	            default:
	                vDirectionString = null;
	                break;
	        }
	        var event = {
	            type: type,
	            api: this.gridOptionsWrapper.getApi(),
	            columnApi: this.gridOptionsWrapper.getColumnApi(),
	            event: draggingEvent.event,
	            node: draggingEvent.dragItem.rowNode,
	            overIndex: overIndex,
	            overNode: overNode,
	            y: yNormalised,
	            vDirection: vDirectionString
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    RowDragFeature.prototype.onDragLeave = function (draggingEvent) {
	        this.dispatchEvent(eventKeys_1.Events.EVENT_ROW_DRAG_LEAVE, draggingEvent);
	        this.stopDragging(draggingEvent);
	    };
	    RowDragFeature.prototype.onDragStop = function (draggingEvent) {
	        this.dispatchEvent(eventKeys_1.Events.EVENT_ROW_DRAG_END, draggingEvent);
	        this.stopDragging(draggingEvent);
	    };
	    RowDragFeature.prototype.stopDragging = function (draggingEvent) {
	        this.ensureIntervalCleared();
	        draggingEvent.dragItem.rowNode.setDragging(false);
	    };
	    __decorate([
	        context_1.Autowired('dragAndDropService'),
	        __metadata("design:type", dragAndDropService_1.DragAndDropService)
	    ], RowDragFeature.prototype, "dragAndDropService", void 0);
	    __decorate([
	        context_1.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], RowDragFeature.prototype, "rowModel", void 0);
	    __decorate([
	        context_1.Autowired('focusedCellController'),
	        __metadata("design:type", focusedCellController_1.FocusedCellController)
	    ], RowDragFeature.prototype, "focusedCellController", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], RowDragFeature.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Optional('rangeController'),
	        __metadata("design:type", Object)
	    ], RowDragFeature.prototype, "rangeController", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], RowDragFeature.prototype, "eventService", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], RowDragFeature.prototype, "postConstruct", null);
	    return RowDragFeature;
	}());
	exports.RowDragFeature = RowDragFeature;


/***/ },
/* 1392 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(31);
	var column_1 = __webpack_require__(45);
	var context_1 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var sortController_1 = __webpack_require__(120);
	var touchListener_1 = __webpack_require__(255);
	var eventService_1 = __webpack_require__(22);
	var componentAnnotations_1 = __webpack_require__(39);
	var events_1 = __webpack_require__(29);
	var utils_1 = __webpack_require__(10);
	var HeaderComp = /** @class */ (function (_super) {
	    __extends(HeaderComp, _super);
	    function HeaderComp() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.lastMovingChanged = 0;
	        return _this;
	    }
	    HeaderComp.prototype.init = function (params) {
	        var template = utils_1._.firstExistingValue(params.template, HeaderComp.TEMPLATE);
	        // take account of any newlines & whitespace before/after the actual template
	        template = template && template.trim ? template.trim() : template;
	        this.setTemplate(template);
	        this.params = params;
	        this.setupTap();
	        this.setupIcons(params.column);
	        this.setupMenu();
	        this.setupSort();
	        this.setupFilterIcon();
	        this.setupText(params.displayName);
	    };
	    HeaderComp.prototype.setupText = function (displayName) {
	        var displayNameSanitised = utils_1._.escape(displayName);
	        if (this.eText) {
	            this.eText.innerHTML = displayNameSanitised;
	        }
	    };
	    HeaderComp.prototype.setupIcons = function (column) {
	        this.addInIcon('sortAscending', this.eSortAsc, column);
	        this.addInIcon('sortDescending', this.eSortDesc, column);
	        this.addInIcon('sortUnSort', this.eSortNone, column);
	        this.addInIcon('menu', this.eMenu, column);
	        this.addInIcon('filter', this.eFilter, column);
	    };
	    HeaderComp.prototype.addInIcon = function (iconName, eParent, column) {
	        if (eParent == null) {
	            return;
	        }
	        var eIcon = utils_1._.createIconNoSpan(iconName, this.gridOptionsWrapper, column);
	        eParent.appendChild(eIcon);
	    };
	    HeaderComp.prototype.setupTap = function () {
	        var _this = this;
	        var options = this.gridOptionsWrapper;
	        if (options.isSuppressTouch()) {
	            return;
	        }
	        var touchListener = new touchListener_1.TouchListener(this.getGui(), true);
	        var suppressMenuHide = options.isSuppressMenuHide();
	        var tapMenuButton = suppressMenuHide && utils_1._.exists(this.eMenu);
	        var menuTouchListener = tapMenuButton ? new touchListener_1.TouchListener(this.eMenu, true) : touchListener;
	        if (this.params.enableMenu) {
	            var eventType = tapMenuButton ? 'EVENT_TAP' : 'EVENT_LONG_TAP';
	            var showMenuFn = function (event) {
	                options.getApi().showColumnMenuAfterMouseClick(_this.params.column, event.touchStart);
	            };
	            this.addDestroyableEventListener(menuTouchListener, touchListener_1.TouchListener[eventType], showMenuFn);
	        }
	        if (this.params.enableSorting) {
	            var tapListener = function (event) {
	                var target = event.touchStart.target;
	                // When suppressMenuHide is true, a tap on the menu icon will bubble up
	                // to the header container, in that case we should not sort
	                if (suppressMenuHide && _this.eMenu.contains(target)) {
	                    return;
	                }
	                _this.sortController.progressSort(_this.params.column, false, "uiColumnSorted");
	            };
	            this.addDestroyableEventListener(touchListener, touchListener_1.TouchListener.EVENT_TAP, tapListener);
	        }
	        // if tapMenuButton is true `touchListener` and `menuTouchListener` are different
	        // so we need to make sure to destroy both listeners here
	        this.addDestroyFunc(function () { return touchListener.destroy(); });
	        if (tapMenuButton) {
	            this.addDestroyFunc(function () { return menuTouchListener.destroy(); });
	        }
	    };
	    HeaderComp.prototype.setupMenu = function () {
	        var _this = this;
	        // if no menu provided in template, do nothing
	        if (!this.eMenu) {
	            return;
	        }
	        // we don't show the menu if on an iPad/iPhone, as the user cannot have a pointer device
	        // Note: If suppressMenuHide is set to true the menu will be displayed, and if suppressMenuHide
	        // is false (default) user will need to use longpress to display the menu.
	        var suppressMenuHide = this.gridOptionsWrapper.isSuppressMenuHide();
	        var hideShowMenu = !this.params.enableMenu || (utils_1._.isUserAgentIPad() && !suppressMenuHide);
	        if (hideShowMenu) {
	            utils_1._.removeFromParent(this.eMenu);
	            return;
	        }
	        this.addDestroyableEventListener(this.eMenu, 'click', function () { return _this.showMenu(_this.eMenu); });
	        if (!suppressMenuHide) {
	            this.eMenu.style.opacity = '0';
	            this.addGuiEventListener('mouseover', function () {
	                _this.eMenu.style.opacity = '1';
	            });
	            this.addGuiEventListener('mouseout', function () {
	                _this.eMenu.style.opacity = '0';
	            });
	        }
	        var style = this.eMenu.style;
	        style.transition = 'opacity 0.2s, border 0.2s';
	        style['-webkit-transition'] = 'opacity 0.2s, border 0.2s';
	    };
	    HeaderComp.prototype.showMenu = function (eventSource) {
	        this.menuFactory.showMenuAfterButtonClick(this.params.column, eventSource);
	    };
	    HeaderComp.prototype.removeSortIcons = function () {
	        utils_1._.removeFromParent(this.eSortAsc);
	        utils_1._.removeFromParent(this.eSortDesc);
	        utils_1._.removeFromParent(this.eSortNone);
	        utils_1._.removeFromParent(this.eSortOrder);
	    };
	    HeaderComp.prototype.setupSort = function () {
	        var _this = this;
	        var enableSorting = this.params.enableSorting;
	        if (!enableSorting) {
	            this.removeSortIcons();
	            return;
	        }
	        var sortUsingCtrl = this.gridOptionsWrapper.isMultiSortKeyCtrl();
	        // keep track of last time the moving changed flag was set
	        this.addDestroyableEventListener(this.params.column, column_1.Column.EVENT_MOVING_CHANGED, function () {
	            _this.lastMovingChanged = new Date().getTime();
	        });
	        // add the event on the header, so when clicked, we do sorting
	        if (this.eLabel) {
	            this.addDestroyableEventListener(this.eLabel, 'click', function (event) {
	                // sometimes when moving a column via dragging, this was also firing a clicked event.
	                // here is issue raised by user: https://ag-grid.zendesk.com/agent/tickets/1076
	                // this check stops sort if a) column is moving or b) column moved less than 200ms ago (so caters for race condition)
	                var moving = _this.params.column.isMoving();
	                var nowTime = new Date().getTime();
	                // typically there is <2ms if moving flag was set recently, as it would be done in same VM turn
	                var movedRecently = (nowTime - _this.lastMovingChanged) < 50;
	                var columnMoving = moving || movedRecently;
	                if (!columnMoving) {
	                    var multiSort = sortUsingCtrl ? (event.ctrlKey || event.metaKey) : event.shiftKey;
	                    _this.params.progressSort(multiSort);
	                }
	            });
	        }
	        this.addDestroyableEventListener(this.params.column, column_1.Column.EVENT_SORT_CHANGED, this.onSortChanged.bind(this));
	        this.onSortChanged();
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_SORT_CHANGED, this.setMultiSortOrder.bind(this));
	        this.setMultiSortOrder();
	    };
	    HeaderComp.prototype.onSortChanged = function () {
	        utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-header-cell-sorted-asc', this.params.column.isSortAscending());
	        utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-header-cell-sorted-desc', this.params.column.isSortDescending());
	        utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-header-cell-sorted-none', this.params.column.isSortNone());
	        if (this.eSortAsc) {
	            utils_1._.addOrRemoveCssClass(this.eSortAsc, 'ag-hidden', !this.params.column.isSortAscending());
	        }
	        if (this.eSortDesc) {
	            utils_1._.addOrRemoveCssClass(this.eSortDesc, 'ag-hidden', !this.params.column.isSortDescending());
	        }
	        if (this.eSortNone) {
	            var alwaysHideNoSort = !this.params.column.getColDef().unSortIcon && !this.gridOptionsWrapper.isUnSortIcon();
	            utils_1._.addOrRemoveCssClass(this.eSortNone, 'ag-hidden', alwaysHideNoSort || !this.params.column.isSortNone());
	        }
	    };
	    // we listen here for global sort events, NOT column sort events, as we want to do this
	    // when sorting has been set on all column (if we listened just for our col (where we
	    // set the asc / desc icons) then it's possible other cols are yet to get their sorting state.
	    HeaderComp.prototype.setMultiSortOrder = function () {
	        if (!this.eSortOrder) {
	            return;
	        }
	        var col = this.params.column;
	        var allColumnsWithSorting = this.sortController.getColumnsWithSortingOrdered();
	        var indexThisCol = allColumnsWithSorting.indexOf(col);
	        var moreThanOneColSorting = allColumnsWithSorting.length > 1;
	        var showIndex = col.isSorting() && moreThanOneColSorting;
	        utils_1._.setDisplayed(this.eSortOrder, showIndex);
	        if (indexThisCol >= 0) {
	            this.eSortOrder.innerHTML = (indexThisCol + 1).toString();
	        }
	        else {
	            utils_1._.clearElement(this.eSortOrder);
	        }
	    };
	    HeaderComp.prototype.setupFilterIcon = function () {
	        if (!this.eFilter) {
	            return;
	        }
	        this.addDestroyableEventListener(this.params.column, column_1.Column.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this));
	        this.onFilterChanged();
	    };
	    HeaderComp.prototype.onFilterChanged = function () {
	        var filterPresent = this.params.column.isFilterActive();
	        utils_1._.addOrRemoveCssClass(this.eFilter, 'ag-hidden', !filterPresent);
	    };
	    HeaderComp.TEMPLATE = '<div class="ag-cell-label-container" role="presentation">' +
	        '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-hidden="true"></span>' +
	        '  <div ref="eLabel" class="ag-header-cell-label" role="presentation" unselectable="on">' +
	        '    <span ref="eText" class="ag-header-cell-text" role="columnheader" unselectable="on"></span>' +
	        '    <span ref="eFilter" class="ag-header-icon ag-filter-icon" aria-hidden="true"></span>' +
	        '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" aria-hidden="true"></span>' +
	        '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" aria-hidden="true"></span>' +
	        '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" aria-hidden="true"></span>' +
	        '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" aria-hidden="true"></span>' +
	        '  </div>' +
	        '</div>';
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], HeaderComp.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('sortController'),
	        __metadata("design:type", sortController_1.SortController)
	    ], HeaderComp.prototype, "sortController", void 0);
	    __decorate([
	        context_1.Autowired('menuFactory'),
	        __metadata("design:type", Object)
	    ], HeaderComp.prototype, "menuFactory", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], HeaderComp.prototype, "eventService", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eFilter'),
	        __metadata("design:type", HTMLElement)
	    ], HeaderComp.prototype, "eFilter", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eSortAsc'),
	        __metadata("design:type", HTMLElement)
	    ], HeaderComp.prototype, "eSortAsc", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eSortDesc'),
	        __metadata("design:type", HTMLElement)
	    ], HeaderComp.prototype, "eSortDesc", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eSortNone'),
	        __metadata("design:type", HTMLElement)
	    ], HeaderComp.prototype, "eSortNone", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eSortOrder'),
	        __metadata("design:type", HTMLElement)
	    ], HeaderComp.prototype, "eSortOrder", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eMenu'),
	        __metadata("design:type", HTMLElement)
	    ], HeaderComp.prototype, "eMenu", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eLabel'),
	        __metadata("design:type", HTMLElement)
	    ], HeaderComp.prototype, "eLabel", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eText'),
	        __metadata("design:type", HTMLElement)
	    ], HeaderComp.prototype, "eText", void 0);
	    return HeaderComp;
	}(component_1.Component));
	exports.HeaderComp = HeaderComp;


/***/ },
/* 1393 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var agCheckbox_1 = __webpack_require__(199);
	var beanStub_1 = __webpack_require__(71);
	var context_1 = __webpack_require__(8);
	var columnApi_1 = __webpack_require__(38);
	var gridApi_1 = __webpack_require__(33);
	var events_1 = __webpack_require__(29);
	var eventService_1 = __webpack_require__(22);
	var constants_1 = __webpack_require__(30);
	var selectionController_1 = __webpack_require__(102);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var SelectAllFeature = /** @class */ (function (_super) {
	    __extends(SelectAllFeature, _super);
	    function SelectAllFeature(cbSelectAll, column) {
	        var _this = _super.call(this) || this;
	        _this.cbSelectAllVisible = false;
	        _this.processingEventFromCheckbox = false;
	        _this.cbSelectAll = cbSelectAll;
	        _this.column = column;
	        var colDef = column.getColDef();
	        _this.filteredOnly = colDef ? !!colDef.headerCheckboxSelectionFilteredOnly : false;
	        return _this;
	    }
	    SelectAllFeature.prototype.postConstruct = function () {
	        this.showOrHideSelectAll();
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.showOrHideSelectAll.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_SELECTION_CHANGED, this.onSelectionChanged.bind(this));
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_MODEL_UPDATED, this.onModelChanged.bind(this));
	        this.addDestroyableEventListener(this.cbSelectAll, agCheckbox_1.AgCheckbox.EVENT_CHANGED, this.onCbSelectAll.bind(this));
	    };
	    SelectAllFeature.prototype.showOrHideSelectAll = function () {
	        this.cbSelectAllVisible = this.isCheckboxSelection();
	        this.cbSelectAll.setDisplayed(this.cbSelectAllVisible);
	        if (this.cbSelectAllVisible) {
	            // in case user is trying this feature with the wrong model type
	            this.checkRightRowModelType();
	            // make sure checkbox is showing the right state
	            this.updateStateOfCheckbox();
	        }
	    };
	    SelectAllFeature.prototype.onModelChanged = function () {
	        if (!this.cbSelectAllVisible) {
	            return;
	        }
	        this.updateStateOfCheckbox();
	    };
	    SelectAllFeature.prototype.onSelectionChanged = function () {
	        if (!this.cbSelectAllVisible) {
	            return;
	        }
	        this.updateStateOfCheckbox();
	    };
	    SelectAllFeature.prototype.getNextCheckboxState = function (selectionCount) {
	        if (selectionCount.selected === 0 && selectionCount.notSelected === 0) {
	            // if no rows, always have it unselected
	            return false;
	        }
	        else if (selectionCount.selected > 0 && selectionCount.notSelected > 0) {
	            // if mix of selected and unselected, this is the tri-state
	            return null;
	        }
	        else if (selectionCount.selected > 0) {
	            // only selected
	            return true;
	        }
	        else {
	            // nothing selected
	            return false;
	        }
	    };
	    SelectAllFeature.prototype.updateStateOfCheckbox = function () {
	        if (this.processingEventFromCheckbox) {
	            return;
	        }
	        this.processingEventFromCheckbox = true;
	        var selectionCount = this.getSelectionCount();
	        var allSelected = this.getNextCheckboxState(selectionCount);
	        this.cbSelectAll.setValue(allSelected);
	        this.processingEventFromCheckbox = false;
	    };
	    SelectAllFeature.prototype.getSelectionCount = function () {
	        var _this = this;
	        var selectedCount = 0;
	        var notSelectedCount = 0;
	        var callback = function (node) {
	            if (_this.gridOptionsWrapper.isGroupSelectsChildren() && node.group) {
	                return;
	            }
	            if (node.isSelected()) {
	                selectedCount++;
	            }
	            else if (!node.selectable) {
	                // don't count non-selectable nodes!
	            }
	            else {
	                notSelectedCount++;
	            }
	        };
	        if (this.filteredOnly) {
	            this.gridApi.forEachNodeAfterFilter(callback);
	        }
	        else {
	            this.gridApi.forEachNode(callback);
	        }
	        return {
	            notSelected: notSelectedCount,
	            selected: selectedCount
	        };
	    };
	    SelectAllFeature.prototype.checkRightRowModelType = function () {
	        var rowModelType = this.rowModel.getType();
	        var rowModelMatches = rowModelType === constants_1.Constants.ROW_MODEL_TYPE_CLIENT_SIDE;
	        if (!rowModelMatches) {
	            console.warn("ag-Grid: selectAllCheckbox is only available if using normal row model, you are using " + rowModelType);
	        }
	    };
	    SelectAllFeature.prototype.onCbSelectAll = function () {
	        if (this.processingEventFromCheckbox) {
	            return;
	        }
	        if (!this.cbSelectAllVisible) {
	            return;
	        }
	        var value = this.cbSelectAll.getValue();
	        if (value) {
	            this.selectionController.selectAllRowNodes(this.filteredOnly);
	        }
	        else {
	            this.selectionController.deselectAllRowNodes(this.filteredOnly);
	        }
	    };
	    SelectAllFeature.prototype.isCheckboxSelection = function () {
	        var result = this.column.getColDef().headerCheckboxSelection;
	        if (typeof result === 'function') {
	            var func = result;
	            result = func({
	                column: this.column,
	                colDef: this.column.getColDef(),
	                columnApi: this.columnApi,
	                api: this.gridApi
	            });
	        }
	        if (result) {
	            if (this.gridOptionsWrapper.isRowModelServerSide()) {
	                console.warn('headerCheckboxSelection is not supported for Server Side Row Model');
	                return false;
	            }
	            if (this.gridOptionsWrapper.isRowModelInfinite()) {
	                console.warn('headerCheckboxSelection is not supported for Infinite Row Model');
	                return false;
	            }
	            if (this.gridOptionsWrapper.isRowModelViewport()) {
	                console.warn('headerCheckboxSelection is not supported for Viewport Row Model');
	                return false;
	            }
	            // otherwise the row model is compatible, so return true
	            return true;
	        }
	        else {
	            return false;
	        }
	    };
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], SelectAllFeature.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], SelectAllFeature.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], SelectAllFeature.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], SelectAllFeature.prototype, "rowModel", void 0);
	    __decorate([
	        context_1.Autowired('selectionController'),
	        __metadata("design:type", selectionController_1.SelectionController)
	    ], SelectAllFeature.prototype, "selectionController", void 0);
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], SelectAllFeature.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], SelectAllFeature.prototype, "postConstruct", null);
	    return SelectAllFeature;
	}(beanStub_1.BeanStub));
	exports.SelectAllFeature = SelectAllFeature;


/***/ },
/* 1394 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(31);
	var columnController_1 = __webpack_require__(26);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var context_1 = __webpack_require__(8);
	var touchListener_1 = __webpack_require__(255);
	var componentAnnotations_1 = __webpack_require__(39);
	var originalColumnGroup_1 = __webpack_require__(196);
	var utils_1 = __webpack_require__(10);
	var HeaderGroupComp = /** @class */ (function (_super) {
	    __extends(HeaderGroupComp, _super);
	    function HeaderGroupComp() {
	        return _super.call(this, HeaderGroupComp.TEMPLATE) || this;
	    }
	    HeaderGroupComp.prototype.init = function (params) {
	        this.params = params;
	        this.setupLabel();
	        this.addGroupExpandIcon();
	        this.setupExpandIcons();
	    };
	    HeaderGroupComp.prototype.setupExpandIcons = function () {
	        var _this = this;
	        this.addInIcon("columnGroupOpened", "agOpened");
	        this.addInIcon("columnGroupClosed", "agClosed");
	        var expandAction = function (event) {
	            if (utils_1._.isStopPropagationForAgGrid(event)) {
	                return;
	            }
	            var newExpandedValue = !_this.params.columnGroup.isExpanded();
	            _this.columnController.setColumnGroupOpened(_this.params.columnGroup.getOriginalColumnGroup(), newExpandedValue, "uiColumnExpanded");
	        };
	        this.addTouchAndClickListeners(this.eCloseIcon, expandAction);
	        this.addTouchAndClickListeners(this.eOpenIcon, expandAction);
	        var stopPropagationAction = function (event) {
	            utils_1._.stopPropagationForAgGrid(event);
	        };
	        // adding stopPropagation to the double click for the icons prevents double click action happening
	        // when the icons are clicked. if the icons are double clicked, then the groups should open and
	        // then close again straight away. if we also listened to double click, then the group would open,
	        // close, then open, which is not what we want. double click should only action if the user double
	        // clicks outside of the icons.
	        this.addDestroyableEventListener(this.eCloseIcon, "dblclick", stopPropagationAction);
	        this.addDestroyableEventListener(this.eOpenIcon, "dblclick", stopPropagationAction);
	        this.addDestroyableEventListener(this.getGui(), "dblclick", expandAction);
	        this.updateIconVisibility();
	        var originalColumnGroup = this.params.columnGroup.getOriginalColumnGroup();
	        this.addDestroyableEventListener(originalColumnGroup, originalColumnGroup_1.OriginalColumnGroup.EVENT_EXPANDED_CHANGED, this.updateIconVisibility.bind(this));
	        this.addDestroyableEventListener(originalColumnGroup, originalColumnGroup_1.OriginalColumnGroup.EVENT_EXPANDABLE_CHANGED, this.updateIconVisibility.bind(this));
	    };
	    HeaderGroupComp.prototype.addTouchAndClickListeners = function (eElement, action) {
	        var touchListener = new touchListener_1.TouchListener(eElement);
	        this.addDestroyableEventListener(touchListener, touchListener_1.TouchListener.EVENT_TAP, action);
	        this.addDestroyFunc(function () { return touchListener.destroy(); });
	        this.addDestroyableEventListener(eElement, "click", action);
	    };
	    HeaderGroupComp.prototype.updateIconVisibility = function () {
	        var columnGroup = this.params.columnGroup;
	        if (columnGroup.isExpandable()) {
	            var expanded = this.params.columnGroup.isExpanded();
	            utils_1._.setDisplayed(this.eOpenIcon, !expanded);
	            utils_1._.setDisplayed(this.eCloseIcon, expanded);
	        }
	        else {
	            utils_1._.setDisplayed(this.eOpenIcon, false);
	            utils_1._.setDisplayed(this.eCloseIcon, false);
	        }
	    };
	    HeaderGroupComp.prototype.addInIcon = function (iconName, refName) {
	        var eIcon = utils_1._.createIconNoSpan(iconName, this.gridOptionsWrapper, null);
	        this.getRefElement(refName).appendChild(eIcon);
	    };
	    HeaderGroupComp.prototype.addGroupExpandIcon = function () {
	        if (!this.params.columnGroup.isExpandable()) {
	            utils_1._.setDisplayed(this.eOpenIcon, false);
	            utils_1._.setDisplayed(this.eCloseIcon, false);
	            return;
	        }
	    };
	    HeaderGroupComp.prototype.setupLabel = function () {
	        // no renderer, default text render
	        if (this.params.displayName && this.params.displayName !== "") {
	            var eInnerText = this.getRefElement("agLabel");
	            eInnerText.innerHTML = this.params.displayName;
	        }
	    };
	    HeaderGroupComp.TEMPLATE = "<div class=\"ag-header-group-cell-label\" ref=\"agContainer\" role=\"presentation\">" +
	        "<span ref=\"agLabel\" class=\"ag-header-group-text\" role=\"columnheader\"></span>" +
	        "<span ref=\"agOpened\" class=\"ag-header-icon ag-header-expand-icon ag-header-expand-icon-expanded\"></span>" +
	        "<span ref=\"agClosed\" class=\"ag-header-icon ag-header-expand-icon ag-header-expand-icon-collapsed\"></span>" +
	        "</div>";
	    __decorate([
	        context_1.Autowired("columnController"),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], HeaderGroupComp.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired("gridOptionsWrapper"),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], HeaderGroupComp.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector("agOpened"),
	        __metadata("design:type", HTMLElement)
	    ], HeaderGroupComp.prototype, "eOpenIcon", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector("agClosed"),
	        __metadata("design:type", HTMLElement)
	    ], HeaderGroupComp.prototype, "eCloseIcon", void 0);
	    return HeaderGroupComp;
	}(component_1.Component));
	exports.HeaderGroupComp = HeaderGroupComp;


/***/ },
/* 1395 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(31);
	var column_1 = __webpack_require__(45);
	var columnGroup_1 = __webpack_require__(159);
	var columnApi_1 = __webpack_require__(38);
	var columnController_1 = __webpack_require__(26);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var horizontalResizeService_1 = __webpack_require__(318);
	var context_1 = __webpack_require__(8);
	var cssClassApplier_1 = __webpack_require__(430);
	var dragAndDropService_1 = __webpack_require__(82);
	var setLeftFeature_1 = __webpack_require__(322);
	var gridApi_1 = __webpack_require__(33);
	var userComponentFactory_1 = __webpack_require__(81);
	var beans_1 = __webpack_require__(161);
	var hoverFeature_1 = __webpack_require__(432);
	var utils_1 = __webpack_require__(10);
	var HeaderGroupWrapperComp = /** @class */ (function (_super) {
	    __extends(HeaderGroupWrapperComp, _super);
	    function HeaderGroupWrapperComp(columnGroup, dragSourceDropTarget, pinned) {
	        var _this = _super.call(this, HeaderGroupWrapperComp.TEMPLATE) || this;
	        // the children can change, we keep destroy functions related to listening to the children here
	        _this.childColumnsDestroyFuncs = [];
	        _this.columnGroup = columnGroup;
	        _this.dragSourceDropTarget = dragSourceDropTarget;
	        _this.pinned = pinned;
	        return _this;
	    }
	    HeaderGroupWrapperComp.prototype.postConstruct = function () {
	        cssClassApplier_1.CssClassApplier.addHeaderClassesFromColDef(this.getComponentHolder(), this.getGui(), this.gridOptionsWrapper, null, this.columnGroup);
	        var displayName = this.columnController.getDisplayNameForColumnGroup(this.columnGroup, 'header');
	        this.appendHeaderGroupComp(displayName);
	        this.setupResize();
	        this.addClasses();
	        this.setupWidth();
	        this.addAttributes();
	        this.setupMovingCss();
	        this.setupTooltip();
	        this.addFeature(this.getContext(), new hoverFeature_1.HoverFeature(this.columnGroup.getOriginalColumnGroup().getLeafColumns(), this.getGui()));
	        var setLeftFeature = new setLeftFeature_1.SetLeftFeature(this.columnGroup, this.getGui(), this.beans);
	        setLeftFeature.init();
	        this.addDestroyFunc(setLeftFeature.destroy.bind(setLeftFeature));
	    };
	    HeaderGroupWrapperComp.prototype.setupMovingCss = function () {
	        var _this = this;
	        var originalColumnGroup = this.columnGroup.getOriginalColumnGroup();
	        var leafColumns = originalColumnGroup.getLeafColumns();
	        leafColumns.forEach(function (col) {
	            _this.addDestroyableEventListener(col, column_1.Column.EVENT_MOVING_CHANGED, _this.onColumnMovingChanged.bind(_this));
	        });
	        this.onColumnMovingChanged();
	    };
	    HeaderGroupWrapperComp.prototype.getColumn = function () {
	        return this.columnGroup;
	    };
	    HeaderGroupWrapperComp.prototype.getComponentHolder = function () {
	        return this.columnGroup.getColGroupDef();
	    };
	    HeaderGroupWrapperComp.prototype.getTooltipText = function () {
	        var colGroupDef = this.getComponentHolder();
	        return colGroupDef && colGroupDef.headerTooltip;
	    };
	    HeaderGroupWrapperComp.prototype.setupTooltip = function () {
	        var tooltipText = this.getTooltipText();
	        if (tooltipText == null) {
	            return;
	        }
	        if (this.gridOptionsWrapper.isEnableBrowserTooltips()) {
	            this.getGui().setAttribute('title', tooltipText);
	        }
	        else {
	            this.beans.tooltipManager.registerTooltip(this);
	        }
	    };
	    HeaderGroupWrapperComp.prototype.onColumnMovingChanged = function () {
	        // this function adds or removes the moving css, based on if the col is moving.
	        // this is what makes the header go dark when it is been moved (gives impression to
	        // user that the column was picked up).
	        utils_1._.addOrRemoveCssClass(this.getGui(), 'ag-header-cell-moving', this.columnGroup.isMoving());
	    };
	    HeaderGroupWrapperComp.prototype.addAttributes = function () {
	        this.getGui().setAttribute("col-id", this.columnGroup.getUniqueId());
	    };
	    HeaderGroupWrapperComp.prototype.appendHeaderGroupComp = function (displayName) {
	        var _this = this;
	        var params = {
	            displayName: displayName,
	            columnGroup: this.columnGroup,
	            setExpanded: function (expanded) {
	                _this.columnController.setColumnGroupOpened(_this.columnGroup.getOriginalColumnGroup(), expanded, "gridInitializing");
	            },
	            api: this.gridApi,
	            columnApi: this.columnApi,
	            context: this.gridOptionsWrapper.getContext()
	        };
	        if (!displayName) {
	            var columnGroup = this.columnGroup;
	            var leafCols = columnGroup.getLeafColumns();
	            // find the top most column group that represents the same columns. so if we are dragging a group, we also
	            // want to visually show the parent groups dragging for the same column set. for example imaging 5 levels
	            // of grouping, with each group only containing the next group, and the last group containing three columns,
	            // then when you move any group (even the lowest level group) you are in-fact moving all the groups, as all
	            // the groups represent the same column set.
	            while (columnGroup.getParent() && columnGroup.getParent().getLeafColumns().length === leafCols.length) {
	                columnGroup = columnGroup.getParent();
	            }
	            var colGroupDef = columnGroup.getColGroupDef();
	            if (colGroupDef) {
	                displayName = colGroupDef.headerName;
	            }
	            if (!displayName) {
	                displayName = leafCols ? this.columnController.getDisplayNameForColumn(leafCols[0], 'header', true) : '';
	            }
	        }
	        var callback = this.afterHeaderCompCreated.bind(this, displayName);
	        this.userComponentFactory.newHeaderGroupComponent(params).then(callback);
	    };
	    HeaderGroupWrapperComp.prototype.afterHeaderCompCreated = function (displayName, headerGroupComp) {
	        this.appendChild(headerGroupComp);
	        this.setupMove(headerGroupComp.getGui(), displayName);
	    };
	    HeaderGroupWrapperComp.prototype.addClasses = function () {
	        // having different classes below allows the style to not have a bottom border
	        // on the group header, if no group is specified
	        // columnGroup.getColGroupDef
	        if (this.columnGroup.isPadding()) {
	            this.addCssClass('ag-header-group-cell-no-group');
	        }
	        else {
	            this.addCssClass('ag-header-group-cell-with-group');
	        }
	    };
	    HeaderGroupWrapperComp.prototype.setupMove = function (eHeaderGroup, displayName) {
	        var _this = this;
	        if (!eHeaderGroup) {
	            return;
	        }
	        if (this.isSuppressMoving()) {
	            return;
	        }
	        var allLeafColumns = this.columnGroup.getOriginalColumnGroup().getLeafColumns();
	        if (eHeaderGroup) {
	            var dragSource_1 = {
	                type: dragAndDropService_1.DragSourceType.HeaderCell,
	                eElement: eHeaderGroup,
	                dragItemName: displayName,
	                // we add in the original group leaf columns, so we move both visible and non-visible items
	                dragItemCallback: this.getDragItemForGroup.bind(this),
	                dragSourceDropTarget: this.dragSourceDropTarget,
	                dragStarted: function () { return allLeafColumns.forEach(function (col) { return col.setMoving(true, "uiColumnDragged"); }); },
	                dragStopped: function () { return allLeafColumns.forEach(function (col) { return col.setMoving(false, "uiColumnDragged"); }); }
	            };
	            this.dragAndDropService.addDragSource(dragSource_1, true);
	            this.addDestroyFunc(function () { return _this.dragAndDropService.removeDragSource(dragSource_1); });
	        }
	    };
	    // when moving the columns, we want to move all the columns (contained within the DragItem) in this group in one go,
	    // and in the order they are currently in the screen.
	    HeaderGroupWrapperComp.prototype.getDragItemForGroup = function () {
	        var allColumnsOriginalOrder = this.columnGroup.getOriginalColumnGroup().getLeafColumns();
	        // capture visible state, used when re-entering grid to dictate which columns should be visible
	        var visibleState = {};
	        allColumnsOriginalOrder.forEach(function (column) { return visibleState[column.getId()] = column.isVisible(); });
	        var allColumnsCurrentOrder = [];
	        this.columnController.getAllDisplayedColumns().forEach(function (column) {
	            if (allColumnsOriginalOrder.indexOf(column) >= 0) {
	                allColumnsCurrentOrder.push(column);
	                utils_1._.removeFromArray(allColumnsOriginalOrder, column);
	            }
	        });
	        // we are left with non-visible columns, stick these in at the end
	        allColumnsOriginalOrder.forEach(function (column) { return allColumnsCurrentOrder.push(column); });
	        // create and return dragItem
	        return {
	            columns: allColumnsCurrentOrder,
	            visibleState: visibleState
	        };
	    };
	    HeaderGroupWrapperComp.prototype.isSuppressMoving = function () {
	        // if any child is fixed, then don't allow moving
	        var childSuppressesMoving = false;
	        this.columnGroup.getLeafColumns().forEach(function (column) {
	            if (column.getColDef().suppressMovable || column.getColDef().lockPosition) {
	                childSuppressesMoving = true;
	            }
	        });
	        var result = childSuppressesMoving || this.gridOptionsWrapper.isSuppressMovableColumns();
	        return result;
	    };
	    HeaderGroupWrapperComp.prototype.setupWidth = function () {
	        // we need to listen to changes in child columns, as they impact our width
	        this.addListenersToChildrenColumns();
	        // the children belonging to this group can change, so we need to add and remove listeners as they change
	        this.addDestroyableEventListener(this.columnGroup, columnGroup_1.ColumnGroup.EVENT_DISPLAYED_CHILDREN_CHANGED, this.onDisplayedChildrenChanged.bind(this));
	        this.onWidthChanged();
	        // the child listeners are not tied to this components life-cycle, as children can get added and removed
	        // to the group - hence they are on a different life-cycle. so we must make sure the existing children
	        // listeners are removed when we finally get destroyed
	        this.addDestroyFunc(this.destroyListenersOnChildrenColumns.bind(this));
	    };
	    HeaderGroupWrapperComp.prototype.onDisplayedChildrenChanged = function () {
	        this.addListenersToChildrenColumns();
	        this.onWidthChanged();
	    };
	    HeaderGroupWrapperComp.prototype.addListenersToChildrenColumns = function () {
	        var _this = this;
	        // first destroy any old listeners
	        this.destroyListenersOnChildrenColumns();
	        // now add new listeners to the new set of children
	        var widthChangedListener = this.onWidthChanged.bind(this);
	        this.columnGroup.getLeafColumns().forEach(function (column) {
	            column.addEventListener(column_1.Column.EVENT_WIDTH_CHANGED, widthChangedListener);
	            column.addEventListener(column_1.Column.EVENT_VISIBLE_CHANGED, widthChangedListener);
	            _this.childColumnsDestroyFuncs.push(function () {
	                column.removeEventListener(column_1.Column.EVENT_WIDTH_CHANGED, widthChangedListener);
	                column.removeEventListener(column_1.Column.EVENT_VISIBLE_CHANGED, widthChangedListener);
	            });
	        });
	    };
	    HeaderGroupWrapperComp.prototype.destroyListenersOnChildrenColumns = function () {
	        this.childColumnsDestroyFuncs.forEach(function (func) { return func(); });
	        this.childColumnsDestroyFuncs = [];
	    };
	    HeaderGroupWrapperComp.prototype.onWidthChanged = function () {
	        this.getGui().style.width = this.columnGroup.getActualWidth() + 'px';
	    };
	    HeaderGroupWrapperComp.prototype.setupResize = function () {
	        var _this = this;
	        this.eHeaderCellResize = this.getRefElement('agResize');
	        if (!this.columnGroup.isResizable()) {
	            utils_1._.removeFromParent(this.eHeaderCellResize);
	            return;
	        }
	        var finishedWithResizeFunc = this.horizontalResizeService.addResizeBar({
	            eResizeBar: this.eHeaderCellResize,
	            onResizeStart: this.onResizeStart.bind(this),
	            onResizing: this.onResizing.bind(this, false),
	            onResizeEnd: this.onResizing.bind(this, true)
	        });
	        this.addDestroyFunc(finishedWithResizeFunc);
	        if (!this.gridOptionsWrapper.isSuppressAutoSize()) {
	            this.eHeaderCellResize.addEventListener('dblclick', function (event) {
	                // get list of all the column keys we are responsible for
	                var keys = [];
	                _this.columnGroup.getDisplayedLeafColumns().forEach(function (column) {
	                    // not all cols in the group may be participating with auto-resize
	                    if (!column.getColDef().suppressAutoSize) {
	                        keys.push(column.getColId());
	                    }
	                });
	                if (keys.length > 0) {
	                    _this.columnController.autoSizeColumns(keys, "uiColumnResized");
	                }
	            });
	        }
	    };
	    HeaderGroupWrapperComp.prototype.onResizeStart = function (shiftKey) {
	        var _this = this;
	        var leafCols = this.columnGroup.getDisplayedLeafColumns();
	        this.resizeCols = utils_1._.filter(leafCols, function (col) { return col.isResizable(); });
	        this.resizeStartWidth = 0;
	        this.resizeCols.forEach(function (col) { return _this.resizeStartWidth += col.getActualWidth(); });
	        this.resizeRatios = [];
	        this.resizeCols.forEach(function (col) { return _this.resizeRatios.push(col.getActualWidth() / _this.resizeStartWidth); });
	        var takeFromGroup = null;
	        if (shiftKey) {
	            takeFromGroup = this.columnController.getDisplayedGroupAfter(this.columnGroup);
	        }
	        if (takeFromGroup) {
	            var takeFromLeafCols = takeFromGroup.getDisplayedLeafColumns();
	            this.resizeTakeFromCols = utils_1._.filter(takeFromLeafCols, function (col) { return col.isResizable(); });
	            this.resizeTakeFromStartWidth = 0;
	            this.resizeTakeFromCols.forEach(function (col) { return _this.resizeTakeFromStartWidth += col.getActualWidth(); });
	            this.resizeTakeFromRatios = [];
	            this.resizeTakeFromCols.forEach(function (col) { return _this.resizeTakeFromRatios.push(col.getActualWidth() / _this.resizeTakeFromStartWidth); });
	        }
	        else {
	            this.resizeTakeFromCols = null;
	            this.resizeTakeFromStartWidth = null;
	            this.resizeTakeFromRatios = null;
	        }
	        utils_1._.addCssClass(this.getGui(), 'ag-column-resizing');
	    };
	    HeaderGroupWrapperComp.prototype.onResizing = function (finished, resizeAmount) {
	        var resizeSets = [];
	        var resizeAmountNormalised = this.normaliseDragChange(resizeAmount);
	        resizeSets.push({
	            columns: this.resizeCols,
	            ratios: this.resizeRatios,
	            width: this.resizeStartWidth + resizeAmountNormalised
	        });
	        if (this.resizeTakeFromCols) {
	            resizeSets.push({
	                columns: this.resizeTakeFromCols,
	                ratios: this.resizeTakeFromRatios,
	                width: this.resizeTakeFromStartWidth - resizeAmountNormalised
	            });
	        }
	        this.columnController.resizeColumnSets(resizeSets, finished, 'uiColumnDragged');
	        if (finished) {
	            utils_1._.removeCssClass(this.getGui(), 'ag-column-resizing');
	        }
	    };
	    // optionally inverts the drag, depending on pinned and RTL
	    // note - this method is duplicated in RenderedHeaderCell - should refactor out?
	    HeaderGroupWrapperComp.prototype.normaliseDragChange = function (dragChange) {
	        var result = dragChange;
	        if (this.gridOptionsWrapper.isEnableRtl()) {
	            // for RTL, dragging left makes the col bigger, except when pinning left
	            if (this.pinned !== column_1.Column.PINNED_LEFT) {
	                result *= -1;
	            }
	        }
	        else {
	            // for LTR (ie normal), dragging left makes the col smaller, except when pinning right
	            if (this.pinned === column_1.Column.PINNED_RIGHT) {
	                result *= -1;
	            }
	        }
	        return result;
	    };
	    HeaderGroupWrapperComp.TEMPLATE = '<div class="ag-header-group-cell" role="presentation">' +
	        '<div ref="agResize" class="ag-header-cell-resize" role="presentation"></div>' +
	        '</div>';
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], HeaderGroupWrapperComp.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('columnController'),
	        __metadata("design:type", columnController_1.ColumnController)
	    ], HeaderGroupWrapperComp.prototype, "columnController", void 0);
	    __decorate([
	        context_1.Autowired('horizontalResizeService'),
	        __metadata("design:type", horizontalResizeService_1.HorizontalResizeService)
	    ], HeaderGroupWrapperComp.prototype, "horizontalResizeService", void 0);
	    __decorate([
	        context_1.Autowired('dragAndDropService'),
	        __metadata("design:type", dragAndDropService_1.DragAndDropService)
	    ], HeaderGroupWrapperComp.prototype, "dragAndDropService", void 0);
	    __decorate([
	        context_1.Autowired('userComponentFactory'),
	        __metadata("design:type", userComponentFactory_1.UserComponentFactory)
	    ], HeaderGroupWrapperComp.prototype, "userComponentFactory", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], HeaderGroupWrapperComp.prototype, "gridApi", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], HeaderGroupWrapperComp.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('beans'),
	        __metadata("design:type", beans_1.Beans)
	    ], HeaderGroupWrapperComp.prototype, "beans", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], HeaderGroupWrapperComp.prototype, "postConstruct", null);
	    return HeaderGroupWrapperComp;
	}(component_1.Component));
	exports.HeaderGroupWrapperComp = HeaderGroupWrapperComp;


/***/ },
/* 1396 */
/***/ function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ChartType;
	(function (ChartType) {
	    ChartType["GroupedColumn"] = "groupedColumn";
	    ChartType["StackedColumn"] = "stackedColumn";
	    ChartType["NormalizedColumn"] = "normalizedColumn";
	    ChartType["GroupedBar"] = "groupedBar";
	    ChartType["StackedBar"] = "stackedBar";
	    ChartType["NormalizedBar"] = "normalizedBar";
	    ChartType["Line"] = "line";
	    ChartType["Scatter"] = "scatter";
	    ChartType["Bubble"] = "bubble";
	    ChartType["Pie"] = "pie";
	    ChartType["Doughnut"] = "doughnut";
	    ChartType["Area"] = "area";
	    ChartType["StackedArea"] = "stackedArea";
	    ChartType["NormalizedArea"] = "normalizedArea";
	})(ChartType = exports.ChartType || (exports.ChartType = {}));


/***/ },
/* 1397 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(10);
	var TabbedLayout = /** @class */ (function () {
	    function TabbedLayout(params) {
	        var _this = this;
	        this.items = [];
	        this.params = params;
	        this.eGui = document.createElement('div');
	        this.eGui.innerHTML = TabbedLayout.TEMPLATE;
	        this.eHeader = this.eGui.querySelector('[ref="tabHeader"]');
	        this.eBody = this.eGui.querySelector('[ref="tabBody"]');
	        utils_1._.addCssClass(this.eGui, params.cssClass);
	        if (params.items) {
	            params.items.forEach(function (item) { return _this.addItem(item); });
	        }
	    }
	    TabbedLayout.prototype.setAfterAttachedParams = function (params) {
	        this.afterAttachedParams = params;
	    };
	    TabbedLayout.prototype.getMinDimensions = function () {
	        var eDummyContainer = this.eGui.cloneNode(true);
	        var eDummyBody = eDummyContainer.querySelector('[ref="tabBody"]');
	        // position fixed, so it isn't restricted to the boundaries of the parent
	        eDummyContainer.style.position = 'fixed';
	        // we put the dummy into the body container, so it will inherit all the
	        // css styles that the real cells are inheriting
	        this.eGui.appendChild(eDummyContainer);
	        var minWidth = 0;
	        var minHeight = 0;
	        this.items.forEach(function (itemWrapper) {
	            utils_1._.clearElement(eDummyBody);
	            var eClone = itemWrapper.tabbedItem.bodyPromise.resolveNow(null, function (body) { return body.cloneNode(true); });
	            if (eClone == null) {
	                return;
	            }
	            eDummyBody.appendChild(eClone);
	            if (minWidth < eDummyContainer.offsetWidth) {
	                minWidth = eDummyContainer.offsetWidth;
	            }
	            if (minHeight < eDummyContainer.offsetHeight) {
	                minHeight = eDummyContainer.offsetHeight;
	            }
	        });
	        // finally check the parent tabs are no wider, as if they
	        // are, then these are the min width and not the child tabs
	        // if (minWidth<this.eGui.offsetWidth) {
	        //     minWidth = this.eGui.offsetWidth;
	        // }
	        this.eGui.removeChild(eDummyContainer);
	        return { height: minHeight, width: minWidth };
	    };
	    TabbedLayout.prototype.showFirstItem = function () {
	        if (this.items.length > 0) {
	            this.showItemWrapper(this.items[0]);
	        }
	    };
	    TabbedLayout.prototype.addItem = function (item) {
	        var eHeaderButton = document.createElement('span');
	        eHeaderButton.appendChild(item.title);
	        utils_1._.addCssClass(eHeaderButton, 'ag-tab');
	        this.eHeader.appendChild(eHeaderButton);
	        var wrapper = {
	            tabbedItem: item,
	            eHeaderButton: eHeaderButton
	        };
	        this.items.push(wrapper);
	        eHeaderButton.addEventListener('click', this.showItemWrapper.bind(this, wrapper));
	    };
	    TabbedLayout.prototype.showItem = function (tabbedItem) {
	        var itemWrapper = utils_1._.find(this.items, function (wrapper) {
	            return wrapper.tabbedItem === tabbedItem;
	        });
	        if (itemWrapper) {
	            this.showItemWrapper(itemWrapper);
	        }
	    };
	    TabbedLayout.prototype.showItemWrapper = function (wrapper) {
	        var _this = this;
	        if (this.params.onItemClicked) {
	            this.params.onItemClicked({ item: wrapper.tabbedItem });
	        }
	        if (this.activeItem === wrapper) {
	            utils_1._.callIfPresent(this.params.onActiveItemClicked);
	            return;
	        }
	        utils_1._.clearElement(this.eBody);
	        wrapper.tabbedItem.bodyPromise.then(function (body) {
	            _this.eBody.appendChild(body);
	        });
	        if (this.activeItem) {
	            utils_1._.removeCssClass(this.activeItem.eHeaderButton, 'ag-tab-selected');
	        }
	        utils_1._.addCssClass(wrapper.eHeaderButton, 'ag-tab-selected');
	        this.activeItem = wrapper;
	        if (wrapper.tabbedItem.afterAttachedCallback) {
	            wrapper.tabbedItem.afterAttachedCallback(this.afterAttachedParams);
	        }
	    };
	    TabbedLayout.prototype.getGui = function () {
	        return this.eGui;
	    };
	    TabbedLayout.TEMPLATE = '<div>' +
	        '<div ref="tabHeader" class="ag-tab-header"></div>' +
	        '<div ref="tabBody" class="ag-tab-body"></div>' +
	        '</div>';
	    return TabbedLayout;
	}());
	exports.TabbedLayout = TabbedLayout;


/***/ },
/* 1398 */
/***/ function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var VerticalStack = /** @class */ (function () {
	    function VerticalStack() {
	        this.isLayoutPanel = true;
	        this.childPanels = [];
	        this.eGui = document.createElement('div');
	        this.eGui.style.height = '100%';
	    }
	    VerticalStack.prototype.addPanel = function (panel, height) {
	        var component;
	        if (panel.isLayoutPanel) {
	            this.childPanels.push(panel);
	            component = panel.getGui();
	        }
	        else {
	            component = panel;
	        }
	        if (height) {
	            component.style.height = height;
	        }
	        this.eGui.appendChild(component);
	    };
	    VerticalStack.prototype.getGui = function () {
	        return this.eGui;
	    };
	    VerticalStack.prototype.doLayout = function () {
	        for (var i = 0; i < this.childPanels.length; i++) {
	            this.childPanels[i].doLayout();
	        }
	    };
	    return VerticalStack;
	}());
	exports.VerticalStack = VerticalStack;


/***/ },
/* 1399 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(10);
	function simpleHttpRequest(params) {
	    return new utils_1.Promise(function (resolve) {
	        var httpRequest = new XMLHttpRequest();
	        httpRequest.open('GET', params.url);
	        httpRequest.send();
	        httpRequest.onreadystatechange = function () {
	            if (httpRequest.readyState == 4 && httpRequest.status == 200) {
	                var httpResponse = JSON.parse(httpRequest.responseText);
	                resolve(httpResponse);
	            }
	        };
	    });
	}
	exports.simpleHttpRequest = simpleHttpRequest;


/***/ },
/* 1400 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var component_1 = __webpack_require__(31);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var componentAnnotations_1 = __webpack_require__(39);
	var utils_1 = __webpack_require__(10);
	var LoadingCellRenderer = /** @class */ (function (_super) {
	    __extends(LoadingCellRenderer, _super);
	    function LoadingCellRenderer() {
	        return _super.call(this, LoadingCellRenderer.TEMPLATE) || this;
	    }
	    LoadingCellRenderer.prototype.init = function (params) {
	        var eLoadingIcon = utils_1._.createIconNoSpan('groupLoading', this.gridOptionsWrapper, null);
	        this.eLoadingIcon.appendChild(eLoadingIcon);
	        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
	        this.eLoadingText.innerText = localeTextFunc('loadingOoo', 'Loading');
	    };
	    LoadingCellRenderer.prototype.refresh = function (params) {
	        return false;
	    };
	    LoadingCellRenderer.TEMPLATE = "<div class=\"ag-stub-cell\">\n            <span class=\"ag-loading-icon\" ref=\"eLoadingIcon\"></span>\n            <span class=\"ag-loading-text\" ref=\"eLoadingText\"></span>\n        </div>";
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], LoadingCellRenderer.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eLoadingIcon'),
	        __metadata("design:type", HTMLElement)
	    ], LoadingCellRenderer.prototype, "eLoadingIcon", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eLoadingText'),
	        __metadata("design:type", HTMLElement)
	    ], LoadingCellRenderer.prototype, "eLoadingText", void 0);
	    return LoadingCellRenderer;
	}(component_1.Component));
	exports.LoadingCellRenderer = LoadingCellRenderer;


/***/ },
/* 1401 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(31);
	var context_1 = __webpack_require__(8);
	var utils_1 = __webpack_require__(10);
	var DndSourceComp = /** @class */ (function (_super) {
	    __extends(DndSourceComp, _super);
	    function DndSourceComp(rowNode, column, cellValue, beans, eCell) {
	        var _this = _super.call(this, "<div class=\"ag-row-drag\" draggable=\"true\"></div>") || this;
	        _this.rowNode = rowNode;
	        _this.column = column;
	        _this.cellValue = cellValue;
	        _this.beans = beans;
	        _this.eCell = eCell;
	        return _this;
	    }
	    DndSourceComp.prototype.postConstruct = function () {
	        var eGui = this.getGui();
	        eGui.appendChild(utils_1._.createIconNoSpan('rowDrag', this.beans.gridOptionsWrapper, null));
	        this.addDragSource();
	        this.checkVisibility();
	    };
	    DndSourceComp.prototype.addDragSource = function () {
	        this.addGuiEventListener('dragstart', this.onDragStart.bind(this));
	    };
	    DndSourceComp.prototype.onDragStart = function (dragEvent) {
	        var _this = this;
	        var providedOnRowDrag = this.column.getColDef().dndSourceOnRowDrag;
	        var isIE = utils_1._.isBrowserIE();
	        if (!isIE) {
	            dragEvent.dataTransfer.setDragImage(this.eCell, 0, 0);
	        }
	        // default behaviour is to convert data to json and set into drag component
	        var defaultOnRowDrag = function () {
	            try {
	                var jsonData = JSON.stringify(_this.rowNode.data);
	                if (isIE) {
	                    dragEvent.dataTransfer.setData('text', jsonData);
	                }
	                else {
	                    dragEvent.dataTransfer.setData('application/json', jsonData);
	                    dragEvent.dataTransfer.setData('text/plain', jsonData);
	                }
	            }
	            catch (e) {
	                // if we cannot convert the data to json, then we do not set the type
	            }
	        };
	        if (providedOnRowDrag) {
	            providedOnRowDrag({ rowNode: this.rowNode, dragEvent: dragEvent });
	        }
	        else {
	            defaultOnRowDrag();
	        }
	    };
	    DndSourceComp.prototype.checkVisibility = function () {
	        var visible = this.column.isDndSource(this.rowNode);
	        this.setDisplayed(visible);
	    };
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], DndSourceComp.prototype, "postConstruct", null);
	    return DndSourceComp;
	}(component_1.Component));
	exports.DndSourceComp = DndSourceComp;


/***/ },
/* 1402 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var context_1 = __webpack_require__(8);
	var component_1 = __webpack_require__(31);
	var LoadingOverlayComponent = /** @class */ (function (_super) {
	    __extends(LoadingOverlayComponent, _super);
	    function LoadingOverlayComponent() {
	        return _super.call(this) || this;
	    }
	    LoadingOverlayComponent.prototype.init = function (params) {
	        var template = this.gridOptionsWrapper.getOverlayLoadingTemplate() ?
	            this.gridOptionsWrapper.getOverlayLoadingTemplate() : LoadingOverlayComponent.DEFAULT_LOADING_OVERLAY_TEMPLATE;
	        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
	        var localisedTemplate = template.replace('[LOADING...]', localeTextFunc('loadingOoo', 'Loading...'));
	        this.setTemplate(localisedTemplate);
	    };
	    LoadingOverlayComponent.DEFAULT_LOADING_OVERLAY_TEMPLATE = '<span class="ag-overlay-loading-center">[LOADING...]</span>';
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], LoadingOverlayComponent.prototype, "gridOptionsWrapper", void 0);
	    return LoadingOverlayComponent;
	}(component_1.Component));
	exports.LoadingOverlayComponent = LoadingOverlayComponent;


/***/ },
/* 1403 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var context_1 = __webpack_require__(8);
	var component_1 = __webpack_require__(31);
	var NoRowsOverlayComponent = /** @class */ (function (_super) {
	    __extends(NoRowsOverlayComponent, _super);
	    function NoRowsOverlayComponent() {
	        return _super.call(this) || this;
	    }
	    NoRowsOverlayComponent.prototype.init = function (params) {
	        var template = this.gridOptionsWrapper.getOverlayNoRowsTemplate() ?
	            this.gridOptionsWrapper.getOverlayNoRowsTemplate() : NoRowsOverlayComponent.DEFAULT_NO_ROWS_TEMPLATE;
	        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
	        var localisedTemplate = template.replace('[NO_ROWS_TO_SHOW]', localeTextFunc('noRowsToShow', 'No Rows To Show'));
	        this.setTemplate(localisedTemplate);
	    };
	    NoRowsOverlayComponent.DEFAULT_NO_ROWS_TEMPLATE = '<span class="ag-overlay-no-rows-center">[NO_ROWS_TO_SHOW]</span>';
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], NoRowsOverlayComponent.prototype, "gridOptionsWrapper", void 0);
	    return NoRowsOverlayComponent;
	}(component_1.Component));
	exports.NoRowsOverlayComponent = NoRowsOverlayComponent;


/***/ },
/* 1404 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var utils_1 = __webpack_require__(10);
	/**
	 * There are many instances of this component covering each of the areas a row can be entered
	 * eg body, pinned left, fullWidth. The component differs from others in that it's given the
	 * elements, there is no template. All of the elements are part of the GridPanel.
	 */
	var RowContainerComponent = /** @class */ (function () {
	    function RowContainerComponent(params) {
	        this.childCount = 0;
	        this.rowTemplatesToAdd = [];
	        this.afterGuiAttachedCallbacks = [];
	        // this is to cater for a 'strange behaviour' where when a panel is made visible, it is firing a scroll
	        // event which we want to ignore. see gridPanel.onAnyBodyScroll()
	        this.lastMadeVisibleTime = 0;
	        this.eContainer = params.eContainer;
	        this.eViewport = params.eViewport;
	        if (params.eWrapper) {
	            this.eWrapper = params.eWrapper;
	        }
	        this.hideWhenNoChildren = params.hideWhenNoChildren;
	    }
	    RowContainerComponent.prototype.setVerticalScrollPosition = function (verticalScrollPosition) {
	        this.scrollTop = verticalScrollPosition;
	    };
	    RowContainerComponent.prototype.postConstruct = function () {
	        this.checkDomOrder();
	        this.checkVisibility();
	        this.gridOptionsWrapper.addEventListener(gridOptionsWrapper_1.GridOptionsWrapper.PROP_DOM_LAYOUT, this.checkDomOrder.bind(this));
	    };
	    RowContainerComponent.prototype.checkDomOrder = function () {
	        this.domOrder = this.gridOptionsWrapper.isEnsureDomOrder();
	    };
	    RowContainerComponent.prototype.getRowElement = function (compId) {
	        return this.eContainer.querySelector("[comp-id=\"" + compId + "\"]");
	    };
	    RowContainerComponent.prototype.setHeight = function (height) {
	        if (height == null) {
	            this.eContainer.style.height = '';
	            return;
	        }
	        this.eContainer.style.height = height + "px";
	        if (this.eWrapper) {
	            this.eWrapper.style.height = height + "px";
	        }
	    };
	    RowContainerComponent.prototype.flushRowTemplates = function () {
	        // if doing dom order, then rowTemplates will be empty,
	        // or if no rows added since last time also empty.
	        if (this.rowTemplatesToAdd.length !== 0) {
	            var htmlToAdd = this.rowTemplatesToAdd.join('');
	            utils_1._.appendHtml(this.eContainer, htmlToAdd);
	            this.rowTemplatesToAdd.length = 0;
	        }
	        // this only empty if no rows since last time, as when
	        // doing dom order, we still have callbacks to process
	        this.afterGuiAttachedCallbacks.forEach(function (func) { return func(); });
	        this.afterGuiAttachedCallbacks.length = 0;
	        this.lastPlacedElement = null;
	    };
	    RowContainerComponent.prototype.appendRowTemplate = function (rowTemplate, callback) {
	        if (this.domOrder) {
	            this.lastPlacedElement = utils_1._.insertTemplateWithDomOrder(this.eContainer, rowTemplate, this.lastPlacedElement);
	        }
	        else {
	            this.rowTemplatesToAdd.push(rowTemplate);
	        }
	        this.afterGuiAttachedCallbacks.push(callback);
	        // it is important we put items in in order, so that when we open a row group,
	        // the new rows are inserted after the opened group, but before the rows below.
	        // that way, the rows below are over the new rows (as dom renders last in dom over
	        // items previous in dom), otherwise the child rows would cover the row below and
	        // that meant the user doesn't see the rows below slide away.
	        this.childCount++;
	        this.checkVisibility();
	    };
	    RowContainerComponent.prototype.ensureDomOrder = function (eRow) {
	        if (this.domOrder) {
	            utils_1._.ensureDomOrder(this.eContainer, eRow, this.lastPlacedElement);
	            this.lastPlacedElement = eRow;
	        }
	    };
	    RowContainerComponent.prototype.removeRowElement = function (eRow) {
	        this.eContainer.removeChild(eRow);
	        this.childCount--;
	        this.checkVisibility();
	    };
	    RowContainerComponent.prototype.checkVisibility = function () {
	        if (!this.hideWhenNoChildren) {
	            return;
	        }
	        var eGui = this.eViewport ? this.eViewport : this.eContainer;
	        var visible = this.childCount > 0;
	        if (this.visible !== visible) {
	            this.visible = visible;
	            this.lastMadeVisibleTime = new Date().getTime();
	            utils_1._.setDisplayed(eGui, visible);
	            // if we are showing the viewport, then the scroll is always zero,
	            // so we need to align with the other sections (ie if this is full
	            // width container, and first time showing a full width row, we need to
	            // scroll it so full width rows are show in right place alongside the
	            // body rows). without this, there was an issue with 'loading rows' for
	            // server side row model, as loading rows are full width, and they were
	            // not getting displayed in the right location when rows were expanded.
	            if (visible && this.eViewport) {
	                this.eViewport.scrollTop = this.scrollTop;
	            }
	        }
	    };
	    RowContainerComponent.prototype.isMadeVisibleRecently = function () {
	        var now = new Date().getTime();
	        var millisSinceVisible = now - this.lastMadeVisibleTime;
	        return millisSinceVisible < 500;
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], RowContainerComponent.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], RowContainerComponent.prototype, "postConstruct", null);
	    return RowContainerComponent;
	}());
	exports.RowContainerComponent = RowContainerComponent;


/***/ },
/* 1405 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(31);
	var context_1 = __webpack_require__(8);
	var rowNode_1 = __webpack_require__(101);
	var dragAndDropService_1 = __webpack_require__(82);
	var eventKeys_1 = __webpack_require__(160);
	var beanStub_1 = __webpack_require__(71);
	var utils_1 = __webpack_require__(10);
	var RowDragComp = /** @class */ (function (_super) {
	    __extends(RowDragComp, _super);
	    function RowDragComp(rowNode, column, cellValue, beans) {
	        var _this = _super.call(this, "<div class=\"ag-row-drag\"></div>") || this;
	        _this.rowNode = rowNode;
	        _this.column = column;
	        _this.cellValue = cellValue;
	        _this.beans = beans;
	        return _this;
	    }
	    RowDragComp.prototype.postConstruct = function () {
	        var eGui = this.getGui();
	        eGui.appendChild(utils_1._.createIconNoSpan('rowDrag', this.beans.gridOptionsWrapper, null));
	        this.addDragSource();
	        this.checkCompatibility();
	        if (this.beans.gridOptionsWrapper.isRowDragManaged()) {
	            this.addFeature(this.beans.context, new ManagedVisibilityStrategy(this, this.beans, this.rowNode, this.column));
	        }
	        else {
	            this.addFeature(this.beans.context, new NonManagedVisibilityStrategy(this, this.beans, this.rowNode, this.column));
	        }
	    };
	    // returns true if all compatibility items work out
	    RowDragComp.prototype.checkCompatibility = function () {
	        var managed = this.beans.gridOptionsWrapper.isRowDragManaged();
	        var treeData = this.beans.gridOptionsWrapper.isTreeData();
	        if (treeData && managed) {
	            utils_1._.doOnce(function () {
	                return console.warn('ag-Grid: If using row drag with tree data, you cannot have rowDragManaged=true');
	            }, 'RowDragComp.managedAndTreeData');
	        }
	    };
	    RowDragComp.prototype.addDragSource = function () {
	        var _this = this;
	        var dragItem = {
	            rowNode: this.rowNode
	        };
	        var dragSource = {
	            type: dragAndDropService_1.DragSourceType.RowDrag,
	            eElement: this.getGui(),
	            dragItemName: this.cellValue,
	            dragItemCallback: function () { return dragItem; },
	            dragStartPixels: 0
	        };
	        this.beans.dragAndDropService.addDragSource(dragSource, true);
	        this.addDestroyFunc(function () { return _this.beans.dragAndDropService.removeDragSource(dragSource); });
	    };
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], RowDragComp.prototype, "postConstruct", null);
	    return RowDragComp;
	}(component_1.Component));
	exports.RowDragComp = RowDragComp;
	var VisibilityStrategy = /** @class */ (function (_super) {
	    __extends(VisibilityStrategy, _super);
	    function VisibilityStrategy(parent, rowNode, column) {
	        var _this = _super.call(this) || this;
	        _this.parent = parent;
	        _this.column = column;
	        _this.rowNode = rowNode;
	        return _this;
	    }
	    VisibilityStrategy.prototype.setDisplayedOrVisible = function (neverDisplayed) {
	        if (neverDisplayed) {
	            this.parent.setDisplayed(false);
	        }
	        else {
	            var shown = this.column.isRowDrag(this.rowNode);
	            var isShownSometimes = utils_1._.isFunction(this.column.getColDef().rowDrag);
	            // if shown sometimes, them some rows can have drag handle while other don't,
	            // so we use setVisible to keep the handles horizontally aligned (as setVisible
	            // keeps the empty space, whereas setDisplayed looses the space)
	            if (isShownSometimes) {
	                this.parent.setVisible(shown);
	            }
	            else {
	                this.parent.setDisplayed(shown);
	            }
	        }
	    };
	    return VisibilityStrategy;
	}(beanStub_1.BeanStub));
	// when non managed, the visibility depends on suppressRowDrag property only
	var NonManagedVisibilityStrategy = /** @class */ (function (_super) {
	    __extends(NonManagedVisibilityStrategy, _super);
	    function NonManagedVisibilityStrategy(parent, beans, rowNode, column) {
	        var _this = _super.call(this, parent, rowNode, column) || this;
	        _this.beans = beans;
	        return _this;
	    }
	    NonManagedVisibilityStrategy.prototype.postConstruct = function () {
	        this.addDestroyableEventListener(this.beans.gridOptionsWrapper, 'suppressRowDrag', this.onSuppressRowDrag.bind(this));
	        // in case data changes, then we need to update visibility of drag item
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_DATA_CHANGED, this.workOutVisibility.bind(this));
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_CELL_CHANGED, this.workOutVisibility.bind(this));
	        this.workOutVisibility();
	    };
	    NonManagedVisibilityStrategy.prototype.onSuppressRowDrag = function () {
	        this.workOutVisibility();
	    };
	    NonManagedVisibilityStrategy.prototype.workOutVisibility = function () {
	        // only show the drag if both sort and filter are not present
	        var neverDisplayed = this.beans.gridOptionsWrapper.isSuppressRowDrag();
	        this.setDisplayedOrVisible(neverDisplayed);
	    };
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], NonManagedVisibilityStrategy.prototype, "postConstruct", null);
	    return NonManagedVisibilityStrategy;
	}(VisibilityStrategy));
	// when managed, the visibility depends on sort, filter and row group, as well as suppressRowDrag property
	var ManagedVisibilityStrategy = /** @class */ (function (_super) {
	    __extends(ManagedVisibilityStrategy, _super);
	    function ManagedVisibilityStrategy(parent, beans, rowNode, column) {
	        var _this = _super.call(this, parent, rowNode, column) || this;
	        _this.beans = beans;
	        return _this;
	    }
	    ManagedVisibilityStrategy.prototype.postConstruct = function () {
	        // we do not show the component if sort, filter or grouping is active
	        this.addDestroyableEventListener(this.beans.eventService, eventKeys_1.Events.EVENT_SORT_CHANGED, this.onSortChanged.bind(this));
	        this.addDestroyableEventListener(this.beans.eventService, eventKeys_1.Events.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this));
	        this.addDestroyableEventListener(this.beans.eventService, eventKeys_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.onRowGroupChanged.bind(this));
	        // in case data changes, then we need to update visibility of drag item
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_DATA_CHANGED, this.workOutVisibility.bind(this));
	        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_CELL_CHANGED, this.workOutVisibility.bind(this));
	        this.addDestroyableEventListener(this.beans.gridOptionsWrapper, 'suppressRowDrag', this.onSuppressRowDrag.bind(this));
	        this.updateSortActive();
	        this.updateFilterActive();
	        this.updateRowGroupActive();
	        this.workOutVisibility();
	    };
	    ManagedVisibilityStrategy.prototype.updateRowGroupActive = function () {
	        var rowGroups = this.beans.columnController.getRowGroupColumns();
	        this.rowGroupActive = !utils_1._.missingOrEmpty(rowGroups);
	    };
	    ManagedVisibilityStrategy.prototype.onRowGroupChanged = function () {
	        this.updateRowGroupActive();
	        this.workOutVisibility();
	    };
	    ManagedVisibilityStrategy.prototype.updateSortActive = function () {
	        var sortModel = this.beans.sortController.getSortModel();
	        this.sortActive = !utils_1._.missingOrEmpty(sortModel);
	    };
	    ManagedVisibilityStrategy.prototype.onSortChanged = function () {
	        this.updateSortActive();
	        this.workOutVisibility();
	    };
	    ManagedVisibilityStrategy.prototype.updateFilterActive = function () {
	        this.filterActive = this.beans.filterManager.isAnyFilterPresent();
	    };
	    ManagedVisibilityStrategy.prototype.onFilterChanged = function () {
	        this.updateFilterActive();
	        this.workOutVisibility();
	    };
	    ManagedVisibilityStrategy.prototype.onSuppressRowDrag = function () {
	        this.workOutVisibility();
	    };
	    ManagedVisibilityStrategy.prototype.workOutVisibility = function () {
	        // only show the drag if both sort and filter are not present
	        var sortOrFilterOrGroupActive = this.sortActive || this.filterActive || this.rowGroupActive;
	        var suppressRowDrag = this.beans.gridOptionsWrapper.isSuppressRowDrag();
	        var neverDisplayed = sortOrFilterOrGroupActive || suppressRowDrag;
	        this.setDisplayedOrVisible(neverDisplayed);
	    };
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ManagedVisibilityStrategy.prototype, "postConstruct", null);
	    return ManagedVisibilityStrategy;
	}(VisibilityStrategy));


/***/ },
/* 1406 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var popupComponent_1 = __webpack_require__(200);
	var TooltipComponent = /** @class */ (function (_super) {
	    __extends(TooltipComponent, _super);
	    function TooltipComponent() {
	        return _super.call(this, "<div class=\"ag-tooltip\"></div>") || this;
	    }
	    // will need to type params
	    TooltipComponent.prototype.init = function (params) {
	        var value = params.value;
	        this.getGui().innerHTML = value;
	    };
	    return TooltipComponent;
	}(popupComponent_1.PopupComponent));
	exports.TooltipComponent = TooltipComponent;


/***/ },
/* 1407 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var context_1 = __webpack_require__(8);
	var rowNodeBlock_1 = __webpack_require__(324);
	var rowRenderer_1 = __webpack_require__(91);
	var utils_1 = __webpack_require__(10);
	var InfiniteBlock = /** @class */ (function (_super) {
	    __extends(InfiniteBlock, _super);
	    function InfiniteBlock(pageNumber, params) {
	        var _this = _super.call(this, pageNumber, params) || this;
	        _this.cacheParams = params;
	        return _this;
	    }
	    InfiniteBlock.prototype.createBlankRowNode = function (rowIndex) {
	        var rowNode = _super.prototype.createBlankRowNode.call(this, rowIndex);
	        rowNode.uiLevel = 0;
	        this.setIndexAndTopOnRowNode(rowNode, rowIndex);
	        return rowNode;
	    };
	    InfiniteBlock.prototype.setDataAndId = function (rowNode, data, index) {
	        if (utils_1._.exists(data)) {
	            // this means if the user is not providing id's we just use the
	            // index for the row. this will allow selection to work (that is based
	            // on index) as long user is not inserting or deleting rows,
	            // or wanting to keep selection between server side sorting or filtering
	            rowNode.setDataAndId(data, index.toString());
	        }
	        else {
	            rowNode.setDataAndId(undefined, undefined);
	        }
	    };
	    InfiniteBlock.prototype.setRowNode = function (rowIndex, rowNode) {
	        _super.prototype.setRowNode.call(this, rowIndex, rowNode);
	        this.setIndexAndTopOnRowNode(rowNode, rowIndex);
	    };
	    InfiniteBlock.prototype.init = function () {
	        _super.prototype.init.call(this, {
	            context: this.getContext(),
	            rowRenderer: this.rowRenderer
	        });
	    };
	    InfiniteBlock.prototype.getNodeIdPrefix = function () {
	        return null;
	    };
	    InfiniteBlock.prototype.getRow = function (displayIndex) {
	        return this.getRowUsingLocalIndex(displayIndex);
	    };
	    InfiniteBlock.prototype.setIndexAndTopOnRowNode = function (rowNode, rowIndex) {
	        rowNode.setRowIndex(rowIndex);
	        rowNode.rowTop = this.cacheParams.rowHeight * rowIndex;
	    };
	    InfiniteBlock.prototype.loadFromDatasource = function () {
	        var _this = this;
	        // PROBLEM . . . . when the user sets sort via colDef.sort, then this code
	        // is executing before the sort is set up, so server is not getting the sort
	        // model. need to change with regards order - so the server side request is
	        // AFTER thus it gets the right sort model.
	        var params = {
	            startRow: this.getStartRow(),
	            endRow: this.getEndRow(),
	            successCallback: this.pageLoaded.bind(this, this.getVersion()),
	            failCallback: this.pageLoadFailed.bind(this),
	            sortModel: this.cacheParams.sortModel,
	            filterModel: this.cacheParams.filterModel,
	            context: this.gridOptionsWrapper.getContext()
	        };
	        if (utils_1._.missing(this.cacheParams.datasource.getRows)) {
	            console.warn("ag-Grid: datasource is missing getRows method");
	            return;
	        }
	        // check if old version of datasource used
	        var getRowsParams = utils_1._.getFunctionParameters(this.cacheParams.datasource.getRows);
	        if (getRowsParams.length > 1) {
	            console.warn('ag-grid: It looks like your paging datasource is of the old type, taking more than one parameter.');
	            console.warn('ag-grid: From ag-grid 1.9.0, now the getRows takes one parameter. See the documentation for details.');
	        }
	        // put in timeout, to force result to be async
	        window.setTimeout(function () {
	            _this.cacheParams.datasource.getRows(params);
	        }, 0);
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], InfiniteBlock.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('rowRenderer'),
	        __metadata("design:type", rowRenderer_1.RowRenderer)
	    ], InfiniteBlock.prototype, "rowRenderer", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], InfiniteBlock.prototype, "init", null);
	    return InfiniteBlock;
	}(rowNodeBlock_1.RowNodeBlock));
	exports.InfiniteBlock = InfiniteBlock;


/***/ },
/* 1408 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var eventService_1 = __webpack_require__(22);
	var events_1 = __webpack_require__(29);
	var logger_1 = __webpack_require__(68);
	var infiniteBlock_1 = __webpack_require__(1407);
	var rowNodeCache_1 = __webpack_require__(442);
	var gridApi_1 = __webpack_require__(33);
	var columnApi_1 = __webpack_require__(38);
	var InfiniteCache = /** @class */ (function (_super) {
	    __extends(InfiniteCache, _super);
	    function InfiniteCache(params) {
	        return _super.call(this, params) || this;
	    }
	    InfiniteCache.prototype.setBeans = function (loggerFactory) {
	        this.logger = loggerFactory.create('InfiniteCache');
	    };
	    InfiniteCache.prototype.init = function () {
	        _super.prototype.init.call(this);
	        // start load of data, as the virtualRowCount will remain at 0 otherwise,
	        // so we need this to kick things off, otherwise grid would never call getRow()
	        this.getRow(0);
	    };
	    InfiniteCache.prototype.moveItemsDown = function (block, moveFromIndex, moveCount) {
	        var startRow = block.getStartRow();
	        var endRow = block.getEndRow();
	        var indexOfLastRowToMove = moveFromIndex + moveCount;
	        // all rows need to be moved down below the insertion index
	        for (var currentRowIndex = endRow - 1; currentRowIndex >= startRow; currentRowIndex--) {
	            // don't move rows at or before the insertion index
	            if (currentRowIndex < indexOfLastRowToMove) {
	                continue;
	            }
	            var indexOfNodeWeWant = currentRowIndex - moveCount;
	            var nodeForThisIndex = this.getRow(indexOfNodeWeWant, true);
	            if (nodeForThisIndex) {
	                block.setRowNode(currentRowIndex, nodeForThisIndex);
	            }
	            else {
	                block.setBlankRowNode(currentRowIndex);
	                block.setDirty();
	            }
	        }
	    };
	    InfiniteCache.prototype.insertItems = function (block, indexToInsert, items) {
	        var pageStartRow = block.getStartRow();
	        var pageEndRow = block.getEndRow();
	        var newRowNodes = [];
	        // next stage is insert the rows into this page, if applicable
	        for (var index = 0; index < items.length; index++) {
	            var rowIndex = indexToInsert + index;
	            var currentRowInThisPage = rowIndex >= pageStartRow && rowIndex < pageEndRow;
	            if (currentRowInThisPage) {
	                var dataItem = items[index];
	                var newRowNode = block.setNewData(rowIndex, dataItem);
	                newRowNodes.push(newRowNode);
	            }
	        }
	        return newRowNodes;
	    };
	    InfiniteCache.prototype.insertItemsAtIndex = function (indexToInsert, items) {
	        // get all page id's as NUMBERS (not strings, as we need to sort as numbers) and in descending order
	        var _this = this;
	        var newNodes = [];
	        this.forEachBlockInReverseOrder(function (block) {
	            var pageEndRow = block.getEndRow();
	            // if the insertion is after this page, then this page is not impacted
	            if (pageEndRow <= indexToInsert) {
	                return;
	            }
	            _this.moveItemsDown(block, indexToInsert, items.length);
	            var newNodesThisPage = _this.insertItems(block, indexToInsert, items);
	            newNodesThisPage.forEach(function (rowNode) { return newNodes.push(rowNode); });
	        });
	        if (this.isMaxRowFound()) {
	            this.hack_setVirtualRowCount(this.getVirtualRowCount() + items.length);
	        }
	        this.onCacheUpdated();
	        var event = {
	            type: events_1.Events.EVENT_ROW_DATA_UPDATED,
	            api: this.gridApi,
	            columnApi: this.columnApi
	        };
	        this.eventService.dispatchEvent(event);
	    };
	    // the rowRenderer will not pass dontCreatePage, meaning when rendering the grid,
	    // it will want new pages in the cache as it asks for rows. only when we are inserting /
	    // removing rows via the api is dontCreatePage set, where we move rows between the pages.
	    InfiniteCache.prototype.getRow = function (rowIndex, dontCreatePage) {
	        if (dontCreatePage === void 0) { dontCreatePage = false; }
	        var blockId = Math.floor(rowIndex / this.cacheParams.blockSize);
	        var block = this.getBlock(blockId);
	        if (!block) {
	            if (dontCreatePage) {
	                return null;
	            }
	            else {
	                block = this.createBlock(blockId);
	            }
	        }
	        return block.getRow(rowIndex);
	    };
	    InfiniteCache.prototype.createBlock = function (blockNumber) {
	        var newBlock = new infiniteBlock_1.InfiniteBlock(blockNumber, this.cacheParams);
	        this.getContext().wireBean(newBlock);
	        this.postCreateBlock(newBlock);
	        return newBlock;
	    };
	    // we have this on infinite row model only, not server side row model,
	    // because for server side, it would leave the children in inconsistent
	    // state - eg if a node had children, but after the refresh it had data
	    // for a different row, then the children would be with the wrong row node.
	    InfiniteCache.prototype.refreshCache = function () {
	        this.forEachBlockInOrder(function (block) { return block.setDirty(); });
	        this.checkBlockToLoad();
	    };
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], InfiniteCache.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('columnApi'),
	        __metadata("design:type", columnApi_1.ColumnApi)
	    ], InfiniteCache.prototype, "columnApi", void 0);
	    __decorate([
	        context_1.Autowired('gridApi'),
	        __metadata("design:type", gridApi_1.GridApi)
	    ], InfiniteCache.prototype, "gridApi", void 0);
	    __decorate([
	        __param(0, context_1.Qualifier('loggerFactory')),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [logger_1.LoggerFactory]),
	        __metadata("design:returntype", void 0)
	    ], InfiniteCache.prototype, "setBeans", null);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], InfiniteCache.prototype, "init", null);
	    return InfiniteCache;
	}(rowNodeCache_1.RowNodeCache));
	exports.InfiniteCache = InfiniteCache;


/***/ },
/* 1409 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(31);
	var context_1 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var componentAnnotations_1 = __webpack_require__(39);
	var eventService_1 = __webpack_require__(22);
	var events_1 = __webpack_require__(29);
	var rowRenderer_1 = __webpack_require__(91);
	var paginationProxy_1 = __webpack_require__(135);
	var utils_1 = __webpack_require__(10);
	var constants_1 = __webpack_require__(30);
	var PaginationComp = /** @class */ (function (_super) {
	    __extends(PaginationComp, _super);
	    function PaginationComp() {
	        return _super.call(this) || this;
	    }
	    PaginationComp.prototype.postConstruct = function () {
	        var isRtl = this.gridOptionsWrapper.isEnableRtl();
	        this.setTemplate(this.getTemplate());
	        this.btFirst.insertAdjacentElement('afterbegin', utils_1._.createIconNoSpan(isRtl ? 'last' : 'first', this.gridOptionsWrapper));
	        this.btPrevious.insertAdjacentElement('afterbegin', utils_1._.createIconNoSpan(isRtl ? 'next' : 'previous', this.gridOptionsWrapper));
	        this.btNext.insertAdjacentElement('afterbegin', utils_1._.createIconNoSpan(isRtl ? 'previous' : 'next', this.gridOptionsWrapper));
	        this.btLast.insertAdjacentElement('afterbegin', utils_1._.createIconNoSpan(isRtl ? 'first' : 'last', this.gridOptionsWrapper));
	        if (this.rowModel.getType() === constants_1.Constants.ROW_MODEL_TYPE_SERVER_SIDE) {
	            this.serverSideRowModel = this.rowModel;
	        }
	        var isPaging = this.gridOptionsWrapper.isPagination();
	        var paginationPanelEnabled = isPaging && !this.gridOptionsWrapper.isSuppressPaginationPanel();
	        if (!paginationPanelEnabled) {
	            this.setDisplayed(false);
	            return;
	        }
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_PAGINATION_CHANGED, this.onPaginationChanged.bind(this));
	        this.addDestroyableEventListener(this.btFirst, 'click', this.onBtFirst.bind(this));
	        this.addDestroyableEventListener(this.btLast, 'click', this.onBtLast.bind(this));
	        this.addDestroyableEventListener(this.btNext, 'click', this.onBtNext.bind(this));
	        this.addDestroyableEventListener(this.btPrevious, 'click', this.onBtPrevious.bind(this));
	        this.onPaginationChanged();
	    };
	    PaginationComp.prototype.onPaginationChanged = function () {
	        this.enableOrDisableButtons();
	        this.updateRowLabels();
	        this.setCurrentPageLabel();
	        this.setTotalLabels();
	    };
	    PaginationComp.prototype.setCurrentPageLabel = function () {
	        var pagesExist = this.paginationProxy.getTotalPages() > 0;
	        var currentPage = this.paginationProxy.getCurrentPage();
	        var toDisplay = pagesExist ? currentPage + 1 : 0;
	        this.lbCurrent.innerHTML = this.formatNumber(toDisplay);
	    };
	    PaginationComp.prototype.formatNumber = function (value) {
	        var userFunc = this.gridOptionsWrapper.getPaginationNumberFormatterFunc();
	        if (userFunc) {
	            return userFunc({ value: value });
	        }
	        else {
	            return utils_1._.formatNumberCommas(value);
	        }
	    };
	    PaginationComp.prototype.getTemplate = function () {
	        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
	        var strPage = localeTextFunc('page', 'Page');
	        var strTo = localeTextFunc('to', 'to');
	        var strOf = localeTextFunc('of', 'of');
	        var strFirst = localeTextFunc('first', 'First');
	        var strPrevious = localeTextFunc('previous', 'Previous');
	        var strNext = localeTextFunc('next', 'Next');
	        var strLast = localeTextFunc('last', 'Last');
	        return "<div class=\"ag-paging-panel ag-unselectable\">\n                <span ref=\"eSummaryPanel\" class=\"ag-paging-row-summary-panel\">\n                    <span ref=\"lbFirstRowOnPage\"></span> " + strTo + " <span ref=\"lbLastRowOnPage\"></span> " + strOf + " <span ref=\"lbRecordCount\"></span>\n                </span>\n                <span class=\"ag-paging-page-summary-panel\">\n                    <div ref=\"btFirst\" class=\"ag-paging-button\">\n                        <button type=\"button\">" + strFirst + "</button>\n                    </div>\n                    <div ref=\"btPrevious\" class=\"ag-paging-button\">\n                        <button type=\"button\">" + strPrevious + "</button>\n                    </div>\n                    " + strPage + " <span ref=\"lbCurrent\"></span> " + strOf + " <span ref=\"lbTotal\"></span>\n                    <div ref=\"btNext\" class=\"ag-paging-button\">\n                        <button type=\"button\">" + strNext + "</button>\n                    </div>\n                    <div ref=\"btLast\" class=\"ag-paging-button\">\n                        <button type=\"button\">" + strLast + "</button>\n                    </div>\n                </span>\n            </div>";
	    };
	    PaginationComp.prototype.onBtNext = function () {
	        this.paginationProxy.goToNextPage();
	    };
	    PaginationComp.prototype.onBtPrevious = function () {
	        this.paginationProxy.goToPreviousPage();
	    };
	    PaginationComp.prototype.onBtFirst = function () {
	        this.paginationProxy.goToFirstPage();
	    };
	    PaginationComp.prototype.onBtLast = function () {
	        this.paginationProxy.goToLastPage();
	    };
	    PaginationComp.prototype.enableOrDisableButtons = function () {
	        var currentPage = this.paginationProxy.getCurrentPage();
	        var maxRowFound = this.paginationProxy.isLastPageFound();
	        var totalPages = this.paginationProxy.getTotalPages();
	        var disablePreviousAndFirst = currentPage === 0;
	        utils_1._.addOrRemoveCssClass(this.btPrevious, 'ag-disabled', disablePreviousAndFirst);
	        utils_1._.addOrRemoveCssClass(this.btFirst, 'ag-disabled', disablePreviousAndFirst);
	        var zeroPagesToDisplay = this.isZeroPagesToDisplay();
	        var onLastPage = maxRowFound && currentPage === (totalPages - 1);
	        var disableNext = onLastPage || zeroPagesToDisplay;
	        utils_1._.addOrRemoveCssClass(this.btNext, 'ag-disabled', disableNext);
	        var disableLast = !maxRowFound || zeroPagesToDisplay || currentPage === (totalPages - 1);
	        utils_1._.addOrRemoveCssClass(this.btLast, 'ag-disabled', disableLast);
	    };
	    PaginationComp.prototype.updateRowLabels = function () {
	        var currentPage = this.paginationProxy.getCurrentPage();
	        var pageSize = this.paginationProxy.getPageSize();
	        var maxRowFound = this.paginationProxy.isLastPageFound();
	        var rowCount = this.paginationProxy.isLastPageFound() ?
	            this.paginationProxy.getMasterRowCount() : null;
	        var startRow;
	        var endRow;
	        if (this.isZeroPagesToDisplay()) {
	            startRow = 0;
	            endRow = 0;
	        }
	        else {
	            startRow = (pageSize * currentPage) + 1;
	            endRow = startRow + pageSize - 1;
	            if (maxRowFound && endRow > rowCount) {
	                endRow = rowCount;
	            }
	        }
	        this.lbFirstRowOnPage.innerHTML = this.formatNumber(startRow);
	        if (this.serverSideRowModel && this.serverSideRowModel.isLoading()) {
	            this.lbLastRowOnPage.innerHTML = '?';
	        }
	        else {
	            this.lbLastRowOnPage.innerHTML = this.formatNumber(endRow);
	        }
	    };
	    PaginationComp.prototype.isZeroPagesToDisplay = function () {
	        var maxRowFound = this.paginationProxy.isLastPageFound();
	        var totalPages = this.paginationProxy.getTotalPages();
	        return maxRowFound && totalPages === 0;
	    };
	    PaginationComp.prototype.setTotalLabels = function () {
	        var lastPageFound = this.paginationProxy.isLastPageFound();
	        var totalPages = this.paginationProxy.getTotalPages();
	        var rowCount = this.paginationProxy.isLastPageFound() ?
	            this.paginationProxy.getMasterRowCount() : null;
	        if (lastPageFound) {
	            this.lbTotal.innerHTML = this.formatNumber(totalPages);
	            this.lbRecordCount.innerHTML = this.formatNumber(rowCount);
	        }
	        else {
	            var moreText = this.gridOptionsWrapper.getLocaleTextFunc()('more', 'more');
	            this.lbTotal.innerHTML = moreText;
	            this.lbRecordCount.innerHTML = moreText;
	        }
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], PaginationComp.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], PaginationComp.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Autowired('paginationProxy'),
	        __metadata("design:type", paginationProxy_1.PaginationProxy)
	    ], PaginationComp.prototype, "paginationProxy", void 0);
	    __decorate([
	        context_1.Autowired('rowRenderer'),
	        __metadata("design:type", rowRenderer_1.RowRenderer)
	    ], PaginationComp.prototype, "rowRenderer", void 0);
	    __decorate([
	        context_1.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], PaginationComp.prototype, "rowModel", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('btFirst'),
	        __metadata("design:type", HTMLElement)
	    ], PaginationComp.prototype, "btFirst", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('btPrevious'),
	        __metadata("design:type", HTMLElement)
	    ], PaginationComp.prototype, "btPrevious", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('btNext'),
	        __metadata("design:type", HTMLElement)
	    ], PaginationComp.prototype, "btNext", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('btLast'),
	        __metadata("design:type", HTMLElement)
	    ], PaginationComp.prototype, "btLast", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('lbRecordCount'),
	        __metadata("design:type", Object)
	    ], PaginationComp.prototype, "lbRecordCount", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('lbFirstRowOnPage'),
	        __metadata("design:type", Object)
	    ], PaginationComp.prototype, "lbFirstRowOnPage", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('lbLastRowOnPage'),
	        __metadata("design:type", Object)
	    ], PaginationComp.prototype, "lbLastRowOnPage", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eSummaryPanel'),
	        __metadata("design:type", Object)
	    ], PaginationComp.prototype, "eSummaryPanel", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('lbCurrent'),
	        __metadata("design:type", Object)
	    ], PaginationComp.prototype, "lbCurrent", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('lbTotal'),
	        __metadata("design:type", Object)
	    ], PaginationComp.prototype, "lbTotal", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], PaginationComp.prototype, "postConstruct", null);
	    return PaginationComp;
	}(component_1.Component));
	exports.PaginationComp = PaginationComp;


/***/ },
/* 1410 */
/***/ function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Color = /** @class */ (function () {
	    /**
	     * Every color component should be in the [0, 1] range.
	     * Some easing functions (such as elastic easing) can overshoot the target value by some amount.
	     * So, when animating colors, if the source or target color components are already near
	     * or at the edge of the allowed [0, 1] range, it is possible for the intermediate color
	     * component value to end up outside of that range mid-animation. For this reason the constructor
	     * performs range checking/constraining.
	     * @param r Red component.
	     * @param g Green component.
	     * @param b Blue component.
	     * @param a Alpha (opacity) component.
	     */
	    function Color(r, g, b, a) {
	        if (a === void 0) { a = 1; }
	        // NaN is treated as 0.
	        this.r = Math.min(1, Math.max(0, r || 0));
	        this.g = Math.min(1, Math.max(0, g || 0));
	        this.b = Math.min(1, Math.max(0, b || 0));
	        this.a = Math.min(1, Math.max(0, a || 0));
	    }
	    /**
	     * The given string can be in one of the following formats:
	     * - #rgb
	     * - #rrggbb
	     * - rgb(r, g, b)
	     * - rgba(r, g, b, a)
	     * - CSS color name such as 'white', 'orange', 'cyan', etc.
	     * @param str
	     */
	    Color.fromString = function (str) {
	        // hexadecimal notation
	        if (str.indexOf('#') >= 0) { // there can be some leading whitespace
	            return Color.fromHexString(str);
	        }
	        // color name
	        var hex = Color.nameToHex[str];
	        if (hex) {
	            return Color.fromHexString(hex);
	        }
	        // rgb(a) notation
	        if (str.indexOf('rgb') >= 0) {
	            return Color.fromRgbaString(str);
	        }
	        throw new Error("Invalid color string: '" + str + "'");
	    };
	    // Using separate RegExp for the short hex notation because strings like `#abcd`
	    // are matched as ['#abcd', 'ab', 'c', 'd', undefined] when the `{1,2}` quantifier is used.
	    Color.fromHexString = function (str) {
	        var values = str.match(Color.hexRe);
	        if (values) {
	            var r = parseInt(values[1], 16);
	            var g = parseInt(values[2], 16);
	            var b = parseInt(values[3], 16);
	            var a = values[4] !== undefined ? parseInt(values[4], 16) : 255;
	            return new Color(r / 255, g / 255, b / 255, a / 255);
	        }
	        values = str.match(Color.shortHexRe);
	        if (values) {
	            var r = parseInt(values[1], 16);
	            var g = parseInt(values[2], 16);
	            var b = parseInt(values[3], 16);
	            var a = values[4] !== undefined ? parseInt(values[4], 16) : 15;
	            r += r * 16;
	            g += g * 16;
	            b += b * 16;
	            a += a * 16;
	            return new Color(r / 255, g / 255, b / 255, a / 255);
	        }
	        throw new Error("Malformed hexadecimal color string: '" + str + "'");
	    };
	    Color.fromRgbaString = function (str) {
	        var values = str.match(Color.rgbRe);
	        if (values) {
	            return new Color(+values[1] / 255, +values[2] / 255, +values[3] / 255);
	        }
	        values = str.match(Color.rgbaRe);
	        if (values) {
	            return new Color(+values[1] / 255, +values[2] / 255, +values[3] / 255, +values[4]);
	        }
	        throw new Error("Malformed rgb/rgba color string: '" + str + "'");
	    };
	    Color.fromArray = function (arr) {
	        if (arr.length === 4) {
	            return new Color(arr[0], arr[1], arr[2], arr[3]);
	        }
	        if (arr.length === 3) {
	            return new Color(arr[0], arr[1], arr[2]);
	        }
	        throw new Error('The given array should contain 3 or 4 color components (numbers).');
	    };
	    Color.fromHSB = function (h, s, b, alpha) {
	        if (alpha === void 0) { alpha = 1; }
	        var rgb = Color.HSBtoRGB(h, s, b);
	        return new Color(rgb[0], rgb[1], rgb[2], alpha);
	    };
	    Color.padHex = function (str) {
	        // Can't use `padStart(2, '0')` here because of IE.
	        return str.length === 1 ? '0' + str : str;
	    };
	    Color.prototype.toHexString = function () {
	        var hex = '#'
	            + Color.padHex(Math.round(this.r * 255).toString(16))
	            + Color.padHex(Math.round(this.g * 255).toString(16))
	            + Color.padHex(Math.round(this.b * 255).toString(16));
	        if (this.a < 1) {
	            hex += Color.padHex(Math.round(this.a * 255).toString(16));
	        }
	        return hex;
	    };
	    Color.prototype.toRgbaString = function (fractionDigits) {
	        if (fractionDigits === void 0) { fractionDigits = 3; }
	        var components = [
	            Math.round(this.r * 255),
	            Math.round(this.g * 255),
	            Math.round(this.b * 255)
	        ];
	        var k = Math.pow(10, fractionDigits);
	        if (this.a !== 1) {
	            components.push(Math.round(this.a * k) / k);
	            return "rgba(" + components.join(', ') + ")";
	        }
	        return "rgb(" + components.join(', ') + ")";
	    };
	    Color.prototype.toString = function () {
	        if (this.a === 1) {
	            return this.toHexString();
	        }
	        return this.toRgbaString();
	    };
	    Color.prototype.toHSB = function () {
	        return Color.RGBtoHSB(this.r, this.g, this.b);
	    };
	    /**
	     * Converts the given RGB triple to an array of HSB (HSV) components.
	     * The hue component will be `NaN` for achromatic colors.
	     */
	    Color.RGBtoHSB = function (r, g, b) {
	        var min = Math.min(r, g, b);
	        var max = Math.max(r, g, b);
	        var S = max !== 0 ? (max - min) / max : 0;
	        var H = NaN;
	        // min == max, means all components are the same
	        // and the color is a shade of gray with no hue (H is NaN)
	        if (min !== max) {
	            var delta = max - min;
	            var rc = (max - r) / delta;
	            var gc = (max - g) / delta;
	            var bc = (max - b) / delta;
	            if (r === max) {
	                H = bc - gc;
	            }
	            else if (g === max) {
	                H = 2.0 + rc - bc;
	            }
	            else {
	                H = 4.0 + gc - rc;
	            }
	            H /= 6.0;
	            if (H < 0) {
	                H = H + 1.0;
	            }
	        }
	        return [H * 360, S, max];
	    };
	    /**
	     * Converts the given HSB (HSV) triple to an array of RGB components.
	     */
	    Color.HSBtoRGB = function (H, S, B) {
	        if (isNaN(H)) {
	            H = 0;
	        }
	        H = (((H % 360) + 360) % 360) / 360; // normalize hue to [0, 360] interval, then scale to [0, 1]
	        var r = 0;
	        var g = 0;
	        var b = 0;
	        if (S === 0) {
	            r = g = b = B;
	        }
	        else {
	            var h = (H - Math.floor(H)) * 6;
	            var f = h - Math.floor(h);
	            var p = B * (1 - S);
	            var q = B * (1 - S * f);
	            var t = B * (1 - (S * (1 - f)));
	            switch (h >> 0) { // discard the floating point part of the number
	                case 0:
	                    r = B;
	                    g = t;
	                    b = p;
	                    break;
	                case 1:
	                    r = q;
	                    g = B;
	                    b = p;
	                    break;
	                case 2:
	                    r = p;
	                    g = B;
	                    b = t;
	                    break;
	                case 3:
	                    r = p;
	                    g = q;
	                    b = B;
	                    break;
	                case 4:
	                    r = t;
	                    g = p;
	                    b = B;
	                    break;
	                case 5:
	                    r = B;
	                    g = p;
	                    b = q;
	                    break;
	            }
	        }
	        return [r, g, b];
	    };
	    Color.prototype.derive = function (hueShift, saturationFactor, brightnessFactor, opacityFactor) {
	        var hsb = Color.RGBtoHSB(this.r, this.g, this.b);
	        var b = hsb[2];
	        if (b == 0 && brightnessFactor > 1.0) {
	            b = 0.05;
	        }
	        var h = (((hsb[0] + hueShift) % 360) + 360) % 360;
	        var s = Math.max(Math.min(hsb[1] * saturationFactor, 1.0), 0.0);
	        b = Math.max(Math.min(b * brightnessFactor, 1.0), 0.0);
	        var a = Math.max(Math.min(this.a * opacityFactor, 1.0), 0.0);
	        var rgba = Color.HSBtoRGB(h, s, b);
	        rgba.push(a);
	        return Color.fromArray(rgba);
	    };
	    Color.prototype.brighter = function () {
	        return this.derive(0, 1.0, 1.0 / 0.7, 1.0);
	    };
	    Color.prototype.darker = function () {
	        return this.derive(0, 1.0, 0.7, 1.0);
	    };
	    // See https://drafts.csswg.org/css-color/#hex-notation
	    Color.hexRe = /\s*#([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})?\s*$/;
	    Color.shortHexRe = /\s*#([0-9a-fA-F])([0-9a-fA-F])([0-9a-fA-F])([0-9a-fA-F])?\s*$/;
	    Color.rgbRe = /\s*rgb\((\d+),\s*(\d+),\s*(\d+)\)\s*/;
	    Color.rgbaRe = /\s*rgba\((\d+),\s*(\d+),\s*(\d+),\s*([.\d]+)\)\s*/;
	    /**
	     * CSS Color Module Level 4:
	     * https://drafts.csswg.org/css-color/#named-colors
	     */
	    Color.nameToHex = Object.freeze({
	        aliceblue: '#F0F8FF',
	        antiquewhite: '#FAEBD7',
	        aqua: '#00FFFF',
	        aquamarine: '#7FFFD4',
	        azure: '#F0FFFF',
	        beige: '#F5F5DC',
	        bisque: '#FFE4C4',
	        black: '#000000',
	        blanchedalmond: '#FFEBCD',
	        blue: '#0000FF',
	        blueviolet: '#8A2BE2',
	        brown: '#A52A2A',
	        burlywood: '#DEB887',
	        cadetblue: '#5F9EA0',
	        chartreuse: '#7FFF00',
	        chocolate: '#D2691E',
	        coral: '#FF7F50',
	        cornflowerblue: '#6495ED',
	        cornsilk: '#FFF8DC',
	        crimson: '#DC143C',
	        cyan: '#00FFFF',
	        darkblue: '#00008B',
	        darkcyan: '#008B8B',
	        darkgoldenrod: '#B8860B',
	        darkgray: '#A9A9A9',
	        darkgreen: '#006400',
	        darkgrey: '#A9A9A9',
	        darkkhaki: '#BDB76B',
	        darkmagenta: '#8B008B',
	        darkolivegreen: '#556B2F',
	        darkorange: '#FF8C00',
	        darkorchid: '#9932CC',
	        darkred: '#8B0000',
	        darksalmon: '#E9967A',
	        darkseagreen: '#8FBC8F',
	        darkslateblue: '#483D8B',
	        darkslategray: '#2F4F4F',
	        darkslategrey: '#2F4F4F',
	        darkturquoise: '#00CED1',
	        darkviolet: '#9400D3',
	        deeppink: '#FF1493',
	        deepskyblue: '#00BFFF',
	        dimgray: '#696969',
	        dimgrey: '#696969',
	        dodgerblue: '#1E90FF',
	        firebrick: '#B22222',
	        floralwhite: '#FFFAF0',
	        forestgreen: '#228B22',
	        fuchsia: '#FF00FF',
	        gainsboro: '#DCDCDC',
	        ghostwhite: '#F8F8FF',
	        gold: '#FFD700',
	        goldenrod: '#DAA520',
	        gray: '#808080',
	        green: '#008000',
	        greenyellow: '#ADFF2F',
	        grey: '#808080',
	        honeydew: '#F0FFF0',
	        hotpink: '#FF69B4',
	        indianred: '#CD5C5C',
	        indigo: '#4B0082',
	        ivory: '#FFFFF0',
	        khaki: '#F0E68C',
	        lavender: '#E6E6FA',
	        lavenderblush: '#FFF0F5',
	        lawngreen: '#7CFC00',
	        lemonchiffon: '#FFFACD',
	        lightblue: '#ADD8E6',
	        lightcoral: '#F08080',
	        lightcyan: '#E0FFFF',
	        lightgoldenrodyellow: '#FAFAD2',
	        lightgray: '#D3D3D3',
	        lightgreen: '#90EE90',
	        lightgrey: '#D3D3D3',
	        lightpink: '#FFB6C1',
	        lightsalmon: '#FFA07A',
	        lightseagreen: '#20B2AA',
	        lightskyblue: '#87CEFA',
	        lightslategray: '#778899',
	        lightslategrey: '#778899',
	        lightsteelblue: '#B0C4DE',
	        lightyellow: '#FFFFE0',
	        lime: '#00FF00',
	        limegreen: '#32CD32',
	        linen: '#FAF0E6',
	        magenta: '#FF00FF',
	        maroon: '#800000',
	        mediumaquamarine: '#66CDAA',
	        mediumblue: '#0000CD',
	        mediumorchid: '#BA55D3',
	        mediumpurple: '#9370DB',
	        mediumseagreen: '#3CB371',
	        mediumslateblue: '#7B68EE',
	        mediumspringgreen: '#00FA9A',
	        mediumturquoise: '#48D1CC',
	        mediumvioletred: '#C71585',
	        midnightblue: '#191970',
	        mintcream: '#F5FFFA',
	        mistyrose: '#FFE4E1',
	        moccasin: '#FFE4B5',
	        navajowhite: '#FFDEAD',
	        navy: '#000080',
	        oldlace: '#FDF5E6',
	        olive: '#808000',
	        olivedrab: '#6B8E23',
	        orange: '#FFA500',
	        orangered: '#FF4500',
	        orchid: '#DA70D6',
	        palegoldenrod: '#EEE8AA',
	        palegreen: '#98FB98',
	        paleturquoise: '#AFEEEE',
	        palevioletred: '#DB7093',
	        papayawhip: '#FFEFD5',
	        peachpuff: '#FFDAB9',
	        peru: '#CD853F',
	        pink: '#FFC0CB',
	        plum: '#DDA0DD',
	        powderblue: '#B0E0E6',
	        purple: '#800080',
	        rebeccapurple: '#663399',
	        red: '#FF0000',
	        rosybrown: '#BC8F8F',
	        royalblue: '#4169E1',
	        saddlebrown: '#8B4513',
	        salmon: '#FA8072',
	        sandybrown: '#F4A460',
	        seagreen: '#2E8B57',
	        seashell: '#FFF5EE',
	        sienna: '#A0522D',
	        silver: '#C0C0C0',
	        skyblue: '#87CEEB',
	        slateblue: '#6A5ACD',
	        slategray: '#708090',
	        slategrey: '#708090',
	        snow: '#FFFAFA',
	        springgreen: '#00FF7F',
	        steelblue: '#4682B4',
	        tan: '#D2B48C',
	        teal: '#008080',
	        thistle: '#D8BFD8',
	        tomato: '#FF6347',
	        turquoise: '#40E0D0',
	        violet: '#EE82EE',
	        wheat: '#F5DEB3',
	        white: '#FFFFFF',
	        whitesmoke: '#F5F5F5',
	        yellow: '#FFFF00',
	        yellowgreen: '#9ACD32'
	    });
	    return Color;
	}());
	exports.Color = Color;


/***/ },
/* 1411 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var constants_1 = __webpack_require__(30);
	var FUNCTION_STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
	var FUNCTION_ARGUMENT_NAMES = /([^\s,]+)/g;
	var AG_GRID_STOP_PROPAGATION = '__ag_Grid_Stop_Propagation';
	/**
	 * HTML Escapes.
	 */
	var HTML_ESCAPES = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	};
	var reUnescapedHtml = /[&<>"']/g;
	var Utils = /** @class */ (function () {
	    function Utils() {
	    }
	    /**
	     * When in IE or Edge, when you are editing a cell, then click on another cell,
	     * the other cell doesn't keep focus, so navigation keys, type to start edit etc
	     * don't work. appears that when you update the dom in IE it looses focus
	     * https://ag-grid.com/forum/showthread.php?tid=4362
	     * @param {HTMLElement} el
	     */
	    Utils.doIeFocusHack = function (el) {
	        if (exports._.isBrowserIE() || exports._.isBrowserEdge()) {
	            if (exports._.missing(document.activeElement) || document.activeElement === document.body) {
	                // console.log('missing focus');
	                el.focus();
	            }
	        }
	    };
	    /**
	     * If the key was passed before, then doesn't execute the func
	     * @param {Function} func
	     * @param {string} key
	     */
	    Utils.doOnce = function (func, key) {
	        if (this.doOnceFlags[key]) {
	            return;
	        }
	        func();
	        this.doOnceFlags[key] = true;
	    };
	    /**
	     * Checks if event was issued by a left click
	     * from https://stackoverflow.com/questions/3944122/detect-left-mouse-button-press
	     * @param {MouseEvent} mouseEvent
	     * @returns {boolean}
	     */
	    Utils.isLeftClick = function (mouseEvent) {
	        if ("buttons" in mouseEvent) {
	            return mouseEvent.buttons == 1;
	        }
	        var button = mouseEvent.which || mouseEvent.button;
	        return button == 1;
	    };
	    /**
	     * `True` if the event is close to the original event by X pixels either vertically or horizontally.
	     * we only start dragging after X pixels so this allows us to know if we should start dragging yet.
	     * @param {MouseEvent | TouchEvent} e1
	     * @param {MouseEvent | TouchEvent} e2
	     * @param {number} pixelCount
	     * @returns {boolean}
	     */
	    Utils.areEventsNear = function (e1, e2, pixelCount) {
	        // by default, we wait 4 pixels before starting the drag
	        if (pixelCount === 0) {
	            return false;
	        }
	        var diffX = Math.abs(e1.clientX - e2.clientX);
	        var diffY = Math.abs(e1.clientY - e2.clientY);
	        return Math.max(diffX, diffY) <= pixelCount;
	    };
	    Utils.jsonEquals = function (val1, val2) {
	        var val1Json = val1 ? JSON.stringify(val1) : null;
	        var val2Json = val2 ? JSON.stringify(val2) : null;
	        var res = val1Json === val2Json;
	        return res;
	    };
	    Utils.shallowCompare = function (arr1, arr2) {
	        // if both are missing, then they are the same
	        if (this.missing(arr1) && this.missing(arr2)) {
	            return true;
	        }
	        // if one is present, but other is missing, then then are different
	        if (this.missing(arr1) || this.missing(arr2)) {
	            return false;
	        }
	        if (arr1.length !== arr2.length) {
	            return false;
	        }
	        for (var i = 0; i < arr1.length; i++) {
	            if (arr1[i] !== arr2[i]) {
	                return false;
	            }
	        }
	        return true;
	    };
	    Utils.getNameOfClass = function (TheClass) {
	        var funcNameRegex = /function (.{1,})\(/;
	        var funcAsString = TheClass.toString();
	        var results = (funcNameRegex).exec(funcAsString);
	        return (results && results.length > 1) ? results[1] : "";
	    };
	    Utils.values = function (object) {
	        var result = [];
	        this.iterateObject(object, function (key, value) {
	            result.push(value);
	        });
	        return result;
	    };
	    Utils.getValueUsingField = function (data, field, fieldContainsDots) {
	        if (!field || !data) {
	            return;
	        }
	        // if no '.', then it's not a deep value
	        if (!fieldContainsDots) {
	            return data[field];
	        }
	        else {
	            // otherwise it is a deep value, so need to dig for it
	            var fields = field.split('.');
	            var currentObject = data;
	            for (var i = 0; i < fields.length; i++) {
	                currentObject = currentObject[fields[i]];
	                if (this.missing(currentObject)) {
	                    return null;
	                }
	            }
	            return currentObject;
	        }
	    };
	    Utils.getElementSize = function (el) {
	        var _a = window.getComputedStyle(el), height = _a.height, width = _a.width, paddingTop = _a.paddingTop, paddingRight = _a.paddingRight, paddingBottom = _a.paddingBottom, paddingLeft = _a.paddingLeft, marginTop = _a.marginTop, marginRight = _a.marginRight, marginBottom = _a.marginBottom, marginLeft = _a.marginLeft, boxSizing = _a.boxSizing;
	        return {
	            height: parseFloat(height),
	            width: parseFloat(width),
	            paddingTop: parseFloat(paddingTop),
	            paddingRight: parseFloat(paddingRight),
	            paddingBottom: parseFloat(paddingBottom),
	            paddingLeft: parseFloat(paddingLeft),
	            marginTop: parseFloat(marginTop),
	            marginRight: parseFloat(marginRight),
	            marginBottom: parseFloat(marginBottom),
	            marginLeft: parseFloat(marginLeft),
	            boxSizing: boxSizing
	        };
	    };
	    Utils.getInnerHeight = function (el) {
	        var size = this.getElementSize(el);
	        if (size.boxSizing === 'border-box') {
	            return size.height - size.paddingTop - size.paddingBottom;
	        }
	        return size.height;
	    };
	    Utils.getInnerWidth = function (el) {
	        var size = this.getElementSize(el);
	        if (size.boxSizing === 'border-box') {
	            return size.width - size.paddingLeft - size.paddingRight;
	        }
	        return size.width;
	    };
	    Utils.getAbsoluteHeight = function (el) {
	        var size = this.getElementSize(el);
	        var marginRight = size.marginBottom + size.marginTop;
	        return Math.ceil(el.offsetHeight + marginRight);
	    };
	    Utils.getAbsoluteWidth = function (el) {
	        var size = this.getElementSize(el);
	        var marginWidth = size.marginLeft + size.marginRight;
	        return Math.ceil(el.offsetWidth + marginWidth);
	    };
	    Utils.getScrollLeft = function (element, rtl) {
	        var scrollLeft = element.scrollLeft;
	        if (rtl) {
	            // Absolute value - for FF that reports RTL scrolls in negative numbers
	            scrollLeft = Math.abs(scrollLeft);
	            // Get Chrome to return the same value as well
	            if (this.isBrowserChrome()) {
	                scrollLeft = element.scrollWidth - element.clientWidth - scrollLeft;
	            }
	        }
	        return scrollLeft;
	    };
	    Utils.cleanNumber = function (value) {
	        if (typeof value === 'string') {
	            value = parseInt(value, 10);
	        }
	        if (typeof value === 'number') {
	            value = Math.floor(value);
	        }
	        else {
	            value = null;
	        }
	        return value;
	    };
	    Utils.setScrollLeft = function (element, value, rtl) {
	        if (rtl) {
	            // Chrome and Safari when doing RTL have the END position of the scroll as zero, not the start
	            if (this.isBrowserSafari() || this.isBrowserChrome()) {
	                value = element.scrollWidth - element.clientWidth - value;
	            }
	            // Firefox uses negative numbers when doing RTL scrolling
	            if (this.isBrowserFirefox()) {
	                value *= -1;
	            }
	        }
	        element.scrollLeft = value;
	    };
	    Utils.iterateNamedNodeMap = function (map, callback) {
	        if (!map) {
	            return;
	        }
	        for (var i = 0; i < map.length; i++) {
	            var attr = map[i];
	            callback(attr.name, attr.value);
	        }
	    };
	    Utils.iterateObject = function (object, callback) {
	        if (!object || this.missing(object)) {
	            return;
	        }
	        if (Array.isArray(object)) {
	            object.forEach(function (value, index) {
	                callback(index + '', value);
	            });
	        }
	        else {
	            var keys = Object.keys(object);
	            for (var i = 0; i < keys.length; i++) {
	                var key = keys[i];
	                var value = object[key];
	                callback(key, value);
	            }
	        }
	    };
	    Utils.cloneObject = function (object) {
	        var copy = {};
	        var keys = Object.keys(object);
	        for (var i = 0; i < keys.length; i++) {
	            var key = keys[i];
	            var value = object[key];
	            copy[key] = value;
	        }
	        return copy;
	    };
	    Utils.deepCloneObject = function (object) {
	        return JSON.parse(JSON.stringify(object));
	    };
	    Utils.map = function (array, callback) {
	        var result = [];
	        for (var i = 0; i < array.length; i++) {
	            var item = array[i];
	            var mappedItem = callback(item, i);
	            result.push(mappedItem);
	        }
	        return result;
	    };
	    Utils.mapObject = function (object, callback) {
	        var result = [];
	        Utils.iterateObject(object, function (key, value) {
	            result.push(callback(value));
	        });
	        return result;
	    };
	    Utils.forEach = function (array, callback) {
	        if (!array) {
	            return;
	        }
	        for (var i = 0; i < array.length; i++) {
	            var value = array[i];
	            callback(value, i);
	        }
	    };
	    Utils.filter = function (array, callback) {
	        var result = [];
	        array.forEach(function (item) {
	            if (callback(item)) {
	                result.push(item);
	            }
	        });
	        return result;
	    };
	    Utils.getAllKeysInObjects = function (objects) {
	        var allValues = {};
	        objects.forEach(function (obj) {
	            if (obj) {
	                Object.keys(obj).forEach(function (key) { return allValues[key] = null; });
	            }
	        });
	        return Object.keys(allValues);
	    };
	    Utils.mergeDeep = function (dest, source) {
	        if (!this.exists(source)) {
	            return;
	        }
	        this.iterateObject(source, function (key, newValue) {
	            var oldValue = dest[key];
	            if (oldValue === newValue) {
	                return;
	            }
	            if (typeof oldValue === 'object' && typeof newValue === 'object') {
	                Utils.mergeDeep(oldValue, newValue);
	            }
	            else {
	                dest[key] = newValue;
	            }
	        });
	    };
	    Utils.assign = function (object) {
	        var _this = this;
	        var sources = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            sources[_i - 1] = arguments[_i];
	        }
	        sources.forEach(function (source) {
	            if (_this.exists(source)) {
	                _this.iterateObject(source, function (key, value) {
	                    object[key] = value;
	                });
	            }
	        });
	        return object;
	    };
	    Utils.flatten = function (arrayOfArrays) {
	        return [].concat.apply([], arrayOfArrays);
	    };
	    Utils.parseYyyyMmDdToDate = function (yyyyMmDd, separator) {
	        try {
	            if (!yyyyMmDd) {
	                return null;
	            }
	            if (yyyyMmDd.indexOf(separator) === -1) {
	                return null;
	            }
	            var fields = yyyyMmDd.split(separator);
	            if (fields.length != 3) {
	                return null;
	            }
	            return new Date(Number(fields[0]), Number(fields[1]) - 1, Number(fields[2]));
	        }
	        catch (e) {
	            return null;
	        }
	    };
	    Utils.serializeDateToYyyyMmDd = function (date, separator) {
	        if (!date) {
	            return null;
	        }
	        return date.getFullYear() + separator + Utils.pad(date.getMonth() + 1, 2) + separator + Utils.pad(date.getDate(), 2);
	    };
	    Utils.pad = function (num, totalStringSize) {
	        var asString = num + "";
	        while (asString.length < totalStringSize) {
	            asString = "0" + asString;
	        }
	        return asString;
	    };
	    Utils.pushAll = function (target, source) {
	        if (this.missing(source) || this.missing(target)) {
	            return;
	        }
	        source.forEach(function (func) { return target.push(func); });
	    };
	    Utils.createArrayOfNumbers = function (first, last) {
	        var result = [];
	        for (var i = first; i <= last; i++) {
	            result.push(i);
	        }
	        return result;
	    };
	    Utils.getFunctionParameters = function (func) {
	        var fnStr = func.toString().replace(FUNCTION_STRIP_COMMENTS, '');
	        var result = fnStr.slice(fnStr.indexOf('(') + 1, fnStr.indexOf(')')).match(FUNCTION_ARGUMENT_NAMES);
	        if (result === null) {
	            return [];
	        }
	        else {
	            return result;
	        }
	    };
	    Utils.find = function (collection, predicate, value) {
	        if (collection === null || collection === undefined) {
	            return null;
	        }
	        if (!Array.isArray(collection)) {
	            var objToArray = this.values(collection);
	            return this.find(objToArray, predicate, value);
	        }
	        var collectionAsArray = collection;
	        var firstMatchingItem = null;
	        for (var i = 0; i < collectionAsArray.length; i++) {
	            var item = collectionAsArray[i];
	            if (typeof predicate === 'string') {
	                if (item[predicate] === value) {
	                    firstMatchingItem = item;
	                    break;
	                }
	            }
	            else {
	                var callback = predicate;
	                if (callback(item)) {
	                    firstMatchingItem = item;
	                    break;
	                }
	            }
	        }
	        return firstMatchingItem;
	    };
	    Utils.toStrings = function (array) {
	        return this.map(array, function (item) {
	            if (item === undefined || item === null || !item.toString) {
	                return null;
	            }
	            else {
	                return item.toString();
	            }
	        });
	    };
	    Utils.iterateArray = function (array, callback) {
	        for (var index = 0; index < array.length; index++) {
	            var value = array[index];
	            callback(value, index);
	        }
	    };
	    Utils.findIndex = function (collection, predicate) {
	        for (var i = 0; i < collection.length; i++) {
	            if (predicate(collection[i], i, collection)) {
	                return i;
	            }
	        }
	        return -1;
	    };
	    /**
	     * Returns true if it is a DOM node
	     * taken from: http://stackoverflow.com/questions/384286/javascript-isdom-how-do-you-check-if-a-javascript-object-is-a-dom-object
	     * @param {any} o
	     * @return {boolean}
	     */
	    Utils.isNode = function (o) {
	        return (typeof Node === "function" ? o instanceof Node :
	            o && typeof o === "object" && typeof o.nodeType === "number" && typeof o.nodeName === "string");
	    };
	    //
	    /**
	     * Returns true if it is a DOM element
	     * taken from: http://stackoverflow.com/questions/384286/javascript-isdom-how-do-you-check-if-a-javascript-object-is-a-dom-object
	     * @param {any} o
	     * @returns {boolean}
	     */
	    Utils.isElement = function (o) {
	        return (typeof HTMLElement === "function" ? o instanceof HTMLElement : //DOM2
	            o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName === "string");
	    };
	    Utils.isNodeOrElement = function (o) {
	        return this.isNode(o) || this.isElement(o);
	    };
	    /**
	     * Makes a copy of a node list into a list
	     * @param {NodeList} nodeList
	     * @returns {Node[]}
	     */
	    Utils.copyNodeList = function (nodeList) {
	        var childCount = nodeList ? nodeList.length : 0;
	        var res = [];
	        for (var i = 0; i < childCount; i++) {
	            res.push(nodeList[i]);
	        }
	        return res;
	    };
	    Utils.isEventFromPrintableCharacter = function (event) {
	        var pressedChar = String.fromCharCode(event.charCode);
	        // newline is an exception, as it counts as a printable character, but we don't
	        // want to start editing when it is pressed. without this check, if user is in chrome
	        // and editing a cell, and they press ctrl+enter, the cell stops editing, and then
	        // starts editing again with a blank value (two 'key down' events are fired). to
	        // test this, remove the line below, edit a cell in chrome and hit ctrl+enter while editing.
	        // https://ag-grid.atlassian.net/browse/AG-605
	        if (this.isKeyPressed(event, constants_1.Constants.KEY_NEW_LINE)) {
	            return false;
	        }
	        // no allowed printable chars have alt or ctrl key combinations
	        if (event.altKey || event.ctrlKey) {
	            return false;
	        }
	        if (exports._.exists(event.key)) {
	            // modern browser will implement key, so we return if key is length 1, eg if it is 'a' for the
	            // a key, or '2' for the '2' key. non-printable characters have names, eg 'Enter' or 'Backspace'.
	            var printableCharacter = event.key.length === 1;
	            // IE11 & Edge treat the numpad del key differently - with numlock on we get "Del" for key,
	            // so this addition checks if its IE11/Edge and handles that specific case the same was as all other browsers
	            var numpadDelWithNumlockOnForEdgeOrIe = Utils.isNumpadDelWithNumlockOnForEdgeOrIe(event);
	            return printableCharacter || numpadDelWithNumlockOnForEdgeOrIe;
	        }
	        else {
	            // otherwise, for older browsers, we test against a list of characters, which doesn't include
	            // accents for non-English, but don't care much, as most users are on modern browsers
	            return Utils.PRINTABLE_CHARACTERS.indexOf(pressedChar) >= 0;
	        }
	    };
	    /**
	     * Allows user to tell the grid to skip specific keyboard events
	     * @param {GridOptionsWrapper} gridOptionsWrapper
	     * @param {KeyboardEvent} keyboardEvent
	     * @param {RowNode} rowNode
	     * @param {Column} column
	     * @param {boolean} editing
	     * @returns {boolean}
	     */
	    Utils.isUserSuppressingKeyboardEvent = function (gridOptionsWrapper, keyboardEvent, rowNode, column, editing) {
	        var gridOptionsFunc = gridOptionsWrapper.getSuppressKeyboardEventFunc();
	        var colDefFunc = column.getColDef().suppressKeyboardEvent;
	        // if no callbacks provided by user, then do nothing
	        if (!gridOptionsFunc && !colDefFunc) {
	            return false;
	        }
	        var params = {
	            event: keyboardEvent,
	            editing: editing,
	            column: column,
	            api: gridOptionsWrapper.getApi(),
	            node: rowNode,
	            data: rowNode.data,
	            colDef: column.getColDef(),
	            context: gridOptionsWrapper.getContext(),
	            columnApi: gridOptionsWrapper.getColumnApi()
	        };
	        // colDef get first preference on suppressing events
	        if (colDefFunc) {
	            var colDefFuncResult = colDefFunc(params);
	            // if colDef func suppressed, then return now, no need to call gridOption func
	            if (colDefFuncResult) {
	                return true;
	            }
	        }
	        if (gridOptionsFunc) {
	            // if gridOption func, return the result
	            return gridOptionsFunc(params);
	        }
	        else {
	            // otherwise return false, don't suppress, as colDef didn't suppress and no func on gridOptions
	            return false;
	        }
	    };
	    Utils.getCellCompForEvent = function (gridOptionsWrapper, event) {
	        var sourceElement = this.getTarget(event);
	        while (sourceElement) {
	            var renderedCell = gridOptionsWrapper.getDomData(sourceElement, 'cellComp');
	            if (renderedCell) {
	                return renderedCell;
	            }
	            sourceElement = sourceElement.parentElement;
	        }
	        return null;
	    };
	    /**
	     * Adds all type of change listeners to an element, intended to be a text field
	     * @param {HTMLElement} element
	     * @param {EventListener} listener
	     */
	    Utils.addChangeListener = function (element, listener) {
	        element.addEventListener("changed", listener);
	        element.addEventListener("paste", listener);
	        element.addEventListener("input", listener);
	        // IE doesn't fire changed for special keys (eg delete, backspace), so need to
	        // listen for this further ones
	        element.addEventListener("keydown", listener);
	        element.addEventListener("keyup", listener);
	    };
	    /**
	     * If value is undefined, null or blank, returns null, otherwise returns the value
	     * @param {T} value
	     * @returns {T | null}
	     */
	    Utils.makeNull = function (value) {
	        var valueNoType = value;
	        if (value === null || value === undefined || valueNoType === "") {
	            return null;
	        }
	        return value;
	    };
	    Utils.missing = function (value) {
	        return !this.exists(value);
	    };
	    Utils.missingOrEmpty = function (value) {
	        return !value || this.missing(value) || value.length === 0;
	    };
	    Utils.missingOrEmptyObject = function (value) {
	        return this.missing(value) || Object.keys(value).length === 0;
	    };
	    Utils.exists = function (value, allowEmptyString) {
	        if (allowEmptyString === void 0) { allowEmptyString = false; }
	        return value != null && (value !== '' || allowEmptyString);
	    };
	    Utils.firstExistingValue = function () {
	        var values = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            values[_i] = arguments[_i];
	        }
	        for (var i = 0; i < values.length; i++) {
	            var value = values[i];
	            if (exports._.exists(value)) {
	                return value;
	            }
	        }
	        return null;
	    };
	    Utils.anyExists = function (values) {
	        if (values) {
	            for (var i = 0; i < values.length; i++) {
	                if (this.exists(values[i])) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    };
	    Utils.existsAndNotEmpty = function (value) {
	        return value != null && this.exists(value) && value.length > 0;
	    };
	    Utils.clearElement = function (el) {
	        while (el && el.firstChild) {
	            el.removeChild(el.firstChild);
	        }
	    };
	    Utils.removeElement = function (parent, cssSelector) {
	        this.removeFromParent(parent.querySelector(cssSelector));
	    };
	    Utils.removeFromParent = function (node) {
	        if (node && node.parentNode) {
	            node.parentNode.removeChild(node);
	        }
	    };
	    Utils.isVisible = function (element) {
	        return (element.offsetParent !== null);
	    };
	    Utils.callIfPresent = function (func) {
	        if (func) {
	            func();
	        }
	    };
	    /**
	     * Loads the template and returns it as an element. makes up for no simple way in
	     * the dom api to load html directly, eg we cannot do this: document.createElement(template)
	     * @param {string} template
	     * @returns {HTMLElement}
	     */
	    Utils.loadTemplate = function (template) {
	        var tempDiv = document.createElement("div");
	        tempDiv.innerHTML = template;
	        return tempDiv.firstChild;
	    };
	    Utils.appendHtml = function (eContainer, htmlTemplate) {
	        if (eContainer.lastChild) {
	            // https://developer.mozilla.org/en-US/docs/Web/API/Element/insertAdjacentHTML
	            // we put the items at the start, so new items appear underneath old items,
	            // so when expanding/collapsing groups, the new rows don't go on top of the
	            // rows below that are moving our of the way
	            eContainer.insertAdjacentHTML('afterbegin', htmlTemplate);
	        }
	        else {
	            eContainer.innerHTML = htmlTemplate;
	        }
	    };
	    Utils.addOrRemoveCssClass = function (element, className, addOrRemove) {
	        if (addOrRemove) {
	            this.addCssClass(element, className);
	        }
	        else {
	            this.removeCssClass(element, className);
	        }
	    };
	    /**
	     * This method adds a class to an element and remove that class from all siblings.
	     * Useful for toggling state.
	     * @param {HTMLElement} element The element to receive the class
	     * @param {string} className The class to be assigned to the element
	     * @param {boolean} [inverted] This inverts the effect, adding the class to all siblings and
	     *        removing from the relevant element (useful when adding a class to hide non-selected elements).
	     */
	    Utils.radioCssClass = function (element, className, inverted) {
	        var parent = element.parentElement;
	        var sibling = parent.firstChild;
	        while (sibling) {
	            exports._.addOrRemoveCssClass(sibling, className, inverted ? (sibling !== element) : (sibling === element));
	            sibling = sibling.nextSibling;
	        }
	    };
	    Utils.addCssClass = function (element, className) {
	        var _this = this;
	        if (!className || className.length === 0) {
	            return;
	        }
	        if (className.indexOf(' ') >= 0) {
	            className.split(' ').forEach(function (value) { return _this.addCssClass(element, value); });
	            return;
	        }
	        if (element.classList) {
	            if (!element.classList.contains(className)) {
	                element.classList.add(className);
	            }
	        }
	        else {
	            if (element.className && element.className.length > 0) {
	                var cssClasses = element.className.split(' ');
	                if (cssClasses.indexOf(className) < 0) {
	                    cssClasses.push(className);
	                    element.setAttribute('class', cssClasses.join(' '));
	                }
	            }
	            else {
	                // do not use element.classList = className here, it will cause
	                // a read-only assignment error on some browsers (IE/Edge).
	                element.setAttribute('class', className);
	            }
	        }
	    };
	    Utils.removeCssClass = function (element, className) {
	        if (element.classList) {
	            if (element.classList.contains(className)) {
	                element.classList.remove(className);
	            }
	        }
	        else {
	            if (element.className && element.className.length > 0) {
	                var cssClasses = element.className.split(' ');
	                if (cssClasses.indexOf(className) >= 0) {
	                    // remove all instances of the item, not just the first, in case it's in more than once
	                    while (cssClasses.indexOf(className) >= 0) {
	                        cssClasses.splice(cssClasses.indexOf(className), 1);
	                    }
	                    element.setAttribute('class', cssClasses.join(' '));
	                }
	            }
	        }
	    };
	    Utils.containsClass = function (element, className) {
	        if (element.classList) {
	            // for modern browsers
	            return element.classList.contains(className);
	        }
	        else if (element.className) {
	            // for older browsers, check against the string of class names
	            // if only one class, can check for exact match
	            var onlyClass = element.className === className;
	            // if many classes, check for class name, we have to pad with ' ' to stop other
	            // class names that are a substring of this class
	            var contains = element.className.indexOf(' ' + className + ' ') >= 0;
	            // the padding above then breaks when it's the first or last class names
	            var startsWithClass = element.className.indexOf(className + ' ') === 0;
	            var endsWithClass = element.className.lastIndexOf(' ' + className) === (element.className.length - className.length - 1);
	            return onlyClass || contains || startsWithClass || endsWithClass;
	        }
	        else {
	            // if item is not a node
	            return false;
	        }
	    };
	    Utils.getElementAttribute = function (element, attributeName) {
	        if (element.attributes) {
	            if (element.attributes[attributeName]) {
	                var attribute = element.attributes[attributeName];
	                return attribute.value;
	            }
	            else {
	                return null;
	            }
	        }
	        else {
	            return null;
	        }
	    };
	    Utils.offsetHeight = function (element) {
	        return element && element.clientHeight ? element.clientHeight : 0;
	    };
	    Utils.offsetWidth = function (element) {
	        return element && element.clientWidth ? element.clientWidth : 0;
	    };
	    Utils.sortNumberArray = function (numberArray) {
	        numberArray.sort(function (a, b) { return a - b; });
	    };
	    Utils.removeRepeatsFromArray = function (array, object) {
	        if (!array) {
	            return;
	        }
	        for (var index = array.length - 2; index >= 0; index--) {
	            var thisOneMatches = array[index] === object;
	            var nextOneMatches = array[index + 1] === object;
	            if (thisOneMatches && nextOneMatches) {
	                array.splice(index + 1, 1);
	            }
	        }
	    };
	    Utils.removeFromArray = function (array, object) {
	        var index = array.indexOf(object);
	        if (index >= 0) {
	            array.splice(index, 1);
	        }
	    };
	    Utils.removeAllFromArray = function (array, toRemove) {
	        toRemove.forEach(function (item) {
	            var index = array.indexOf(item);
	            if (index >= 0) {
	                array.splice(index, 1);
	            }
	        });
	    };
	    Utils.insertIntoArray = function (array, object, toIndex) {
	        array.splice(toIndex, 0, object);
	    };
	    Utils.insertArrayIntoArray = function (dest, src, toIndex) {
	        if (this.missing(dest) || this.missing(src)) {
	            return;
	        }
	        // put items in backwards, otherwise inserted items end up in reverse order
	        for (var i = src.length - 1; i >= 0; i--) {
	            var item = src[i];
	            this.insertIntoArray(dest, item, toIndex);
	        }
	    };
	    Utils.moveInArray = function (array, objectsToMove, toIndex) {
	        var _this = this;
	        // first take out it items from the array
	        objectsToMove.forEach(function (obj) {
	            _this.removeFromArray(array, obj);
	        });
	        // now add the objects, in same order as provided to us, that means we start at the end
	        // as the objects will be pushed to the right as they are inserted
	        objectsToMove.slice().reverse().forEach(function (obj) {
	            _this.insertIntoArray(array, obj, toIndex);
	        });
	    };
	    Utils.defaultComparator = function (valueA, valueB, accentedCompare) {
	        if (accentedCompare === void 0) { accentedCompare = false; }
	        var valueAMissing = valueA === null || valueA === undefined;
	        var valueBMissing = valueB === null || valueB === undefined;
	        // this is for aggregations sum and avg, where the result can be a number that is wrapped.
	        // if we didn't do this, then the toString() value would be used, which would result in
	        // the strings getting used instead of the numbers.
	        if (valueA && valueA.toNumber) {
	            valueA = valueA.toNumber();
	        }
	        if (valueB && valueB.toNumber) {
	            valueB = valueB.toNumber();
	        }
	        if (valueAMissing && valueBMissing) {
	            return 0;
	        }
	        if (valueAMissing) {
	            return -1;
	        }
	        if (valueBMissing) {
	            return 1;
	        }
	        if (typeof valueA === "string") {
	            if (!accentedCompare) {
	                return doQuickCompare(valueA, valueB);
	            }
	            else {
	                try {
	                    // using local compare also allows chinese comparisons
	                    return valueA.localeCompare(valueB);
	                }
	                catch (e) {
	                    // if something wrong with localeCompare, eg not supported
	                    // by browser, then just continue with the quick one
	                    return doQuickCompare(valueA, valueB);
	                }
	            }
	        }
	        if (valueA < valueB) {
	            return -1;
	        }
	        else if (valueA > valueB) {
	            return 1;
	        }
	        else {
	            return 0;
	        }
	        function doQuickCompare(a, b) {
	            return (a > b ? 1 : (a < b ? -1 : 0));
	        }
	    };
	    Utils.last = function (arr) {
	        if (!arr || !arr.length) {
	            return undefined;
	        }
	        return arr[arr.length - 1];
	    };
	    Utils.compareArrays = function (array1, array2) {
	        if (this.missing(array1) && this.missing(array2)) {
	            return true;
	        }
	        if ((this.missing(array1) || this.missing(array2)) ||
	            (!array1 || !array2)) {
	            return false;
	        }
	        if (array1.length !== array2.length) {
	            return false;
	        }
	        for (var i = 0; i < array1.length; i++) {
	            if (array1[i] !== array2[i]) {
	                return false;
	            }
	        }
	        return true;
	    };
	    Utils.ensureDomOrder = function (eContainer, eChild, eChildBefore) {
	        // if already in right order, do nothing
	        if (eChildBefore && eChildBefore.nextSibling === eChild) {
	            return;
	        }
	        if (eChildBefore) {
	            if (eChildBefore.nextSibling) {
	                // insert between the eRowBefore and the row after it
	                eContainer.insertBefore(eChild, eChildBefore.nextSibling);
	            }
	            else {
	                // if nextSibling is missing, means other row is at end, so just append new row at the end
	                eContainer.appendChild(eChild);
	            }
	        }
	        else {
	            // otherwise put at start
	            if (eContainer.firstChild && eContainer.firstChild !== eChild) {
	                // insert it at the first location
	                eContainer.insertAdjacentElement('afterbegin', eChild);
	            }
	        }
	    };
	    Utils.insertWithDomOrder = function (eContainer, eChild, eChildBefore) {
	        if (eChildBefore) {
	            if (eChildBefore.nextSibling) {
	                // insert between the eRowBefore and the row after it
	                eContainer.insertBefore(eChild, eChildBefore.nextSibling);
	            }
	            else {
	                // if nextSibling is missing, means other row is at end, so just append new row at the end
	                eContainer.appendChild(eChild);
	            }
	        }
	        else {
	            if (eContainer.firstChild) {
	                // insert it at the first location
	                eContainer.insertBefore(eChild, eContainer.firstChild);
	            }
	            else {
	                // otherwise eContainer is empty, so just append it
	                eContainer.appendChild(eChild);
	            }
	        }
	    };
	    Utils.insertTemplateWithDomOrder = function (eContainer, htmlTemplate, eChildBefore) {
	        var res;
	        if (eChildBefore) {
	            // if previous element exists, just slot in after the previous element
	            eChildBefore.insertAdjacentHTML('afterend', htmlTemplate);
	            res = eChildBefore.nextSibling;
	        }
	        else {
	            if (eContainer.firstChild) {
	                // insert it at the first location
	                eContainer.insertAdjacentHTML('afterbegin', htmlTemplate);
	            }
	            else {
	                // otherwise eContainer is empty, so just append it
	                eContainer.innerHTML = htmlTemplate;
	            }
	            res = eContainer.firstChild;
	        }
	        return res;
	    };
	    Utils.every = function (items, callback) {
	        if (!items || items.length === 0) {
	            return true;
	        }
	        for (var i = 0; i < items.length; i++) {
	            if (!callback(items[i])) {
	                return false;
	            }
	        }
	        return true;
	    };
	    Utils.toStringOrNull = function (value) {
	        if (this.exists(value) && value.toString) {
	            return value.toString();
	        }
	        else {
	            return null;
	        }
	    };
	    Utils.formatSize = function (size) {
	        if (typeof size === "number") {
	            return size + "px";
	        }
	        else {
	            return size;
	        }
	    };
	    Utils.formatNumberTwoDecimalPlacesAndCommas = function (value) {
	        if (typeof value !== 'number') {
	            return '';
	        }
	        // took this from: http://blog.tompawlak.org/number-currency-formatting-javascript
	        return (Math.round(value * 100) / 100).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	    };
	    /**
	     * the native method number.toLocaleString(undefined, {minimumFractionDigits: 0})
	     * puts in decimal places in IE, so we use this method instead
	     * from: http://blog.tompawlak.org/number-currency-formatting-javascript
	     * @param {number} value
	     * @returns {string}
	     */
	    Utils.formatNumberCommas = function (value) {
	        if (typeof value !== 'number') {
	            return '';
	        }
	        return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	    };
	    Utils.prependDC = function (parent, documentFragment) {
	        if (this.exists(parent.firstChild)) {
	            parent.insertBefore(documentFragment, parent.firstChild);
	        }
	        else {
	            parent.appendChild(documentFragment);
	        }
	    };
	    /**
	     * If icon provided, use this (either a string, or a function callback).
	     * if not, then use the default icon from the theme
	     * @param {string} iconName
	     * @param {GridOptionsWrapper} gridOptionsWrapper
	     * @param {Column | null} [column]
	     * @returns {HTMLElement}
	     */
	    Utils.createIcon = function (iconName, gridOptionsWrapper, column) {
	        var iconContents = this.createIconNoSpan(iconName, gridOptionsWrapper, column);
	        if (iconContents.className.indexOf('ag-icon') > -1) {
	            return iconContents;
	        }
	        else {
	            var eResult = document.createElement('span');
	            eResult.appendChild(iconContents);
	            return eResult;
	        }
	    };
	    Utils.createIconNoSpan = function (iconName, gridOptionsWrapper, column, forceCreate) {
	        var userProvidedIcon = null;
	        // check col for icon first
	        var icons = column && column.getColDef().icons;
	        if (icons) {
	            userProvidedIcon = icons[iconName];
	        }
	        // if not in col, try grid options
	        if (gridOptionsWrapper && !userProvidedIcon) {
	            var optionsIcons = gridOptionsWrapper.getIcons();
	            if (optionsIcons) {
	                userProvidedIcon = optionsIcons[iconName];
	            }
	        }
	        // now if user provided, use it
	        if (userProvidedIcon) {
	            var rendererResult = void 0;
	            if (typeof userProvidedIcon === 'function') {
	                rendererResult = userProvidedIcon();
	            }
	            else if (typeof userProvidedIcon === 'string') {
	                rendererResult = userProvidedIcon;
	            }
	            else {
	                throw new Error('icon from grid options needs to be a string or a function');
	            }
	            if (typeof rendererResult === 'string') {
	                return this.loadTemplate(rendererResult);
	            }
	            else if (this.isNodeOrElement(rendererResult)) {
	                return rendererResult;
	            }
	            else {
	                throw new Error('iconRenderer should return back a string or a dom object');
	            }
	        }
	        else {
	            var span = document.createElement('span');
	            var cssClass = this.iconNameClassMap[iconName];
	            if (!cssClass) {
	                if (!forceCreate) {
	                    throw new Error(iconName + " did not find class");
	                }
	                else {
	                    cssClass = iconName;
	                }
	            }
	            span.setAttribute("class", "ag-icon ag-icon-" + cssClass);
	            span.setAttribute("unselectable", "on");
	            return span;
	        }
	    };
	    Utils.addStylesToElement = function (eElement, styles) {
	        var _this = this;
	        if (!styles) {
	            return;
	        }
	        Object.keys(styles).forEach(function (key) {
	            var keyCamelCase = _this.hyphenToCamelCase(key);
	            if (keyCamelCase) {
	                eElement.style[keyCamelCase] = styles[key];
	            }
	        });
	    };
	    Utils.isHorizontalScrollShowing = function (element) {
	        return element.clientWidth < element.scrollWidth;
	    };
	    Utils.isVerticalScrollShowing = function (element) {
	        return element.clientHeight < element.scrollHeight;
	    };
	    Utils.getMaxDivHeight = function () {
	        if (!document.body) {
	            return -1;
	        }
	        var res = 1000000;
	        // FF reports the height back but still renders blank after ~6M px
	        var testUpTo = navigator.userAgent.toLowerCase().match(/firefox/) ? 6000000 : 1000000000;
	        var div = this.loadTemplate("<div/>");
	        document.body.appendChild(div);
	        while (true) {
	            var test = res * 2;
	            div.style.height = test + 'px';
	            if (test > testUpTo || div.clientHeight !== test) {
	                break;
	            }
	            else {
	                res = test;
	            }
	        }
	        document.body.removeChild(div);
	        return res;
	    };
	    Utils.getScrollbarWidth = function () {
	        var body = document.body;
	        var div = document.createElement("div");
	        div.style.width = div.style.height = "100px";
	        div.style.opacity = "0";
	        div.style.overflow = "scroll";
	        div.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps
	        div.style.position = "absolute";
	        body.appendChild(div);
	        var width = div.offsetWidth - div.clientWidth;
	        // remove divs
	        if (div.parentNode) {
	            div.parentNode.removeChild(div);
	        }
	        return width;
	    };
	    Utils.hasOverflowScrolling = function () {
	        var prefixes = ['webkit', 'moz', 'o', 'ms'];
	        var div = document.createElement('div');
	        var body = document.getElementsByTagName('body')[0];
	        var found = false;
	        var p;
	        body.appendChild(div);
	        div.setAttribute('style', prefixes.map(function (prefix) { return "-" + prefix + "-overflow-scrolling: touch"; }).concat('overflow-scrolling: touch').join(';'));
	        var computedStyle = window.getComputedStyle(div);
	        if (computedStyle.overflowScrolling === 'touch') {
	            found = true;
	        }
	        if (!found) {
	            for (var _i = 0, prefixes_1 = prefixes; _i < prefixes_1.length; _i++) {
	                p = prefixes_1[_i];
	                if (computedStyle[p + "OverflowScrolling"] === 'touch') {
	                    found = true;
	                    break;
	                }
	            }
	        }
	        if (div.parentNode) {
	            div.parentNode.removeChild(div);
	        }
	        return found;
	    };
	    Utils.isKeyPressed = function (event, keyToCheck) {
	        var pressedKey = event.which || event.keyCode;
	        return pressedKey === keyToCheck;
	    };
	    Utils.isCharacterKey = function (event) {
	        // from: https://stackoverflow.com/questions/4179708/how-to-detect-if-the-pressed-key-will-produce-a-character-inside-an-input-text
	        var which = event.which;
	        if (typeof which === 'number' && which) {
	            return !event.ctrlKey && !event.metaKey && !event.altKey && event.which !== 8 && event.which !== 16;
	        }
	        return which === undefined;
	    };
	    Utils.setDisplayed = function (element, displayed) {
	        this.addOrRemoveCssClass(element, 'ag-hidden', !displayed);
	    };
	    Utils.setVisible = function (element, visible) {
	        this.addOrRemoveCssClass(element, 'ag-invisible', !visible);
	    };
	    Utils.setElementWidth = function (element, width) {
	        if (width === 'flex') {
	            element.style.width = null;
	            element.style.minWidth = null;
	            element.style.maxWidth = null;
	            element.style.flex = '1 1 auto';
	        }
	        else {
	            this.setFixedWidth(element, width);
	        }
	    };
	    Utils.setFixedWidth = function (element, width) {
	        width = this.formatSize(width);
	        element.style.width = width;
	        element.style.maxWidth = width;
	        element.style.minWidth = width;
	    };
	    Utils.setElementHeight = function (element, height) {
	        if (height === 'flex') {
	            element.style.height = null;
	            element.style.minHeight = null;
	            element.style.maxHeight = null;
	            element.style.flex = '1 1 auto';
	        }
	        else {
	            this.setFixedHeight(element, height);
	        }
	    };
	    Utils.setFixedHeight = function (element, height) {
	        height = this.formatSize(height);
	        element.style.height = height;
	        element.style.maxHeight = height;
	        element.style.minHeight = height;
	    };
	    Utils.isBrowserIE = function () {
	        if (this.isIE === undefined) {
	            this.isIE = /*@cc_on!@*/ false || !!document.documentMode; // At least IE6
	        }
	        return this.isIE;
	    };
	    Utils.isBrowserEdge = function () {
	        if (this.isEdge === undefined) {
	            this.isEdge = !this.isBrowserIE() && !!window.StyleMedia;
	        }
	        return this.isEdge;
	    };
	    Utils.isBrowserSafari = function () {
	        if (this.isSafari === undefined) {
	            var anyWindow = window;
	            // taken from https://github.com/ag-grid/ag-grid/issues/550
	            this.isSafari = Object.prototype.toString.call(anyWindow.HTMLElement).indexOf('Constructor') > 0
	                || (function (p) {
	                    return p ? p.toString() === "[object SafariRemoteNotification]" : false;
	                })(!anyWindow.safari || anyWindow.safari.pushNotification);
	        }
	        return this.isSafari;
	    };
	    Utils.isBrowserChrome = function () {
	        if (this.isChrome === undefined) {
	            var win = window;
	            this.isChrome = (!!win.chrome && (!!win.chrome.webstore || !!win.chrome.runtime)) ||
	                (/Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor));
	        }
	        return this.isChrome;
	    };
	    Utils.isBrowserFirefox = function () {
	        if (this.isFirefox === undefined) {
	            var win = window;
	            this.isFirefox = typeof win.InstallTrigger !== 'undefined';
	        }
	        return this.isFirefox;
	    };
	    Utils.isUserAgentIPad = function () {
	        if (this.isIPad === undefined) {
	            // taken from https://davidwalsh.name/detect-ipad
	            this.isIPad = navigator.userAgent.match(/iPad|iPhone/i) != null;
	        }
	        return this.isIPad;
	    };
	    /**
	     * srcElement is only available in IE. In all other browsers it is target
	     * http://stackoverflow.com/questions/5301643/how-can-i-make-event-srcelement-work-in-firefox-and-what-does-it-mean
	     * @param {Event} event
	     * @returns {Element}
	     */
	    Utils.getTarget = function (event) {
	        var eventNoType = event;
	        return eventNoType.target || eventNoType.srcElement;
	    };
	    Utils.isElementChildOfClass = function (element, cls, maxNest) {
	        var counter = 0;
	        while (element) {
	            if (this.containsClass(element, cls)) {
	                return true;
	            }
	            element = element.parentElement;
	            if (maxNest && ++counter > maxNest) {
	                break;
	            }
	        }
	        return false;
	    };
	    Utils.isElementInEventPath = function (element, event) {
	        if (!event || !element) {
	            return false;
	        }
	        var path = exports._.getEventPath(event);
	        return path.indexOf(element) >= 0;
	    };
	    Utils.isFunction = function (val) {
	        return !!(val && val.constructor && val.call && val.apply);
	    };
	    Utils.createEventPath = function (event) {
	        var res = [];
	        var pointer = exports._.getTarget(event);
	        while (pointer) {
	            res.push(pointer);
	            pointer = pointer.parentElement;
	        }
	        return res;
	    };
	    /**
	     * firefox doesn't have event.path set, or any alternative to it, so we hack
	     * it in. this is needed as it's to late to work out the path when the item is
	     * removed from the dom. used by MouseEventService, where it works out if a click
	     * was from the current grid, or a detail grid (master / detail).
	     * @param {Event} event
	     */
	    Utils.addAgGridEventPath = function (event) {
	        event.__agGridEventPath = this.getEventPath(event);
	    };
	    /**
	     * Gets the path for an Event.
	     * https://stackoverflow.com/questions/39245488/event-path-undefined-with-firefox-and-vue-js
	     * https://developer.mozilla.org/en-US/docs/Web/API/Event
	     * @param {Event} event
	     * @returns {EventTarget[]}
	     */
	    Utils.getEventPath = function (event) {
	        var eventNoType = event;
	        if (eventNoType.deepPath) {
	            // IE supports deep path
	            return eventNoType.deepPath();
	        }
	        else if (eventNoType.path) {
	            // Chrome supports path
	            return eventNoType.path;
	        }
	        else if (eventNoType.composedPath) {
	            // Firefox supports composePath
	            return eventNoType.composedPath();
	        }
	        else if (eventNoType.__agGridEventPath) {
	            // Firefox supports composePath
	            return eventNoType.__agGridEventPath;
	        }
	        else {
	            // and finally, if none of the above worked,
	            // we create the path ourselves
	            return this.createEventPath(event);
	        }
	    };
	    Utils.forEachSnapshotFirst = function (list, callback) {
	        if (list) {
	            var arrayCopy = list.slice(0);
	            arrayCopy.forEach(callback);
	        }
	    };
	    /**
	     * Gets the document body width
	     * from: http://stackoverflow.com/questions/1038727/how-to-get-browser-width-using-javascript-code
	     * @returns {number}
	     */
	    Utils.getBodyWidth = function () {
	        if (document.body) {
	            return document.body.clientWidth;
	        }
	        if (window.innerHeight) {
	            return window.innerWidth;
	        }
	        if (document.documentElement && document.documentElement.clientWidth) {
	            return document.documentElement.clientWidth;
	        }
	        return -1;
	    };
	    /**
	     * Gets the body height
	     * from: http://stackoverflow.com/questions/1038727/how-to-get-browser-width-using-javascript-code
	     * @returns {number}
	     */
	    Utils.getBodyHeight = function () {
	        if (document.body) {
	            return document.body.clientHeight;
	        }
	        if (window.innerHeight) {
	            return window.innerHeight;
	        }
	        if (document.documentElement && document.documentElement.clientHeight) {
	            return document.documentElement.clientHeight;
	        }
	        return -1;
	    };
	    Utils.setCheckboxState = function (eCheckbox, state) {
	        if (typeof state === 'boolean') {
	            eCheckbox.checked = state;
	            eCheckbox.indeterminate = false;
	        }
	        else {
	            // isNodeSelected returns back undefined if it's a group and the children
	            // are a mix of selected and unselected
	            eCheckbox.indeterminate = true;
	        }
	    };
	    Utils.traverseNodesWithKey = function (nodes, callback) {
	        var keyParts = [];
	        recursiveSearchNodes(nodes);
	        function recursiveSearchNodes(currentNodes) {
	            currentNodes.forEach(function (node) {
	                // also checking for children for tree data
	                if (node.group || node.hasChildren()) {
	                    keyParts.push(node.key);
	                    var key = keyParts.join('|');
	                    callback(node, key);
	                    recursiveSearchNodes(node.childrenAfterGroup);
	                    keyParts.pop();
	                }
	            });
	        }
	    };
	    /**
	     * Converts a camelCase string into hyphenated string
	     * from https://gist.github.com/youssman/745578062609e8acac9f
	     * @param {string} str
	     * @return {string}
	     */
	    Utils.camelCaseToHyphen = function (str) {
	        if (str === null || str === undefined) {
	            return null;
	        }
	        return str.replace(/([A-Z])/g, function (g) { return '-' + g[0].toLowerCase(); });
	    };
	    /**
	     * Converts a hyphenated string into camelCase string
	     * from https://stackoverflow.com/questions/6660977/convert-hyphens-to-camel-case-camelcase
	     * @param {string} str
	     * @return {string}
	     */
	    Utils.hyphenToCamelCase = function (str) {
	        if (str === null || str === undefined) {
	            return null;
	        }
	        return str.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); });
	    };
	    Utils.capitalise = function (str) {
	        return str[0].toUpperCase() + str.substr(1).toLowerCase();
	    };
	    /**
	     * Converts a CSS object into string
	     * @param {Object} stylesToUse an object eg: {color: 'black', top: '25px'}
	     * @return {string} A string like "color: black; top: 25px;" for html
	     */
	    Utils.cssStyleObjectToMarkup = function (stylesToUse) {
	        var _this = this;
	        if (!stylesToUse) {
	            return '';
	        }
	        var resParts = [];
	        this.iterateObject(stylesToUse, function (styleKey, styleValue) {
	            var styleKeyDashed = _this.camelCaseToHyphen(styleKey);
	            resParts.push(styleKeyDashed + ": " + styleValue + ";");
	        });
	        return resParts.join(' ');
	    };
	    /**
	     * Check if a value is numeric
	     * from http://stackoverflow.com/questions/9716468/is-there-any-function-like-isnumeric-in-javascript-to-validate-numbers
	     * @param {any} value
	     * @return {boolean}
	     */
	    Utils.isNumeric = function (value) {
	        if (value === '') {
	            return false;
	        }
	        return !isNaN(parseFloat(value)) && isFinite(value);
	    };
	    Utils.escape = function (toEscape) {
	        if (toEscape === null || toEscape === undefined || !toEscape.replace) {
	            return toEscape;
	        }
	        return toEscape.replace(reUnescapedHtml, function (chr) { return HTML_ESCAPES[chr]; });
	    };
	    /**
	     * Mouse wheel (and 2-finger trackpad) support on the web sucks.  It is
	     * complicated, thus this doc is long and (hopefully) detailed enough to answer
	     * your questions.
	     *
	     * If you need to react to the mouse wheel in a predictable way, this code is
	     * like your bestest friend. * hugs *
	     *
	     * As of today, there are 4 DOM event types you can listen to:
	     *
	     *   'wheel'                -- Chrome(31+), FF(17+), IE(9+)
	     *   'mousewheel'           -- Chrome, IE(6+), Opera, Safari
	     *   'MozMousePixelScroll'  -- FF(3.5 only!) (2010-2013) -- don't bother!
	     *   'DOMMouseScroll'       -- FF(0.9.7+) since 2003
	     *
	     * So what to do?  The is the best:
	     *
	     *   normalizeWheel.getEventType();
	     *
	     * In your event callback, use this code to get sane interpretation of the
	     * deltas.  This code will return an object with properties:
	     *
	     *   spinX   -- normalized spin speed (use for zoom) - x plane
	     *   spinY   -- " - y plane
	     *   pixelX  -- normalized distance (to pixels) - x plane
	     *   pixelY  -- " - y plane
	     *
	     * Wheel values are provided by the browser assuming you are using the wheel to
	     * scroll a web page by a number of lines or pixels (or pages).  Values can vary
	     * significantly on different platforms and browsers, forgetting that you can
	     * scroll at different speeds.  Some devices (like trackpads) emit more events
	     * at smaller increments with fine granularity, and some emit massive jumps with
	     * linear speed or acceleration.
	     *
	     * This code does its best to normalize the deltas for you:
	     *
	     *   - spin is trying to normalize how far the wheel was spun (or trackpad
	     *     dragged).  This is super useful for zoom support where you want to
	     *     throw away the chunky scroll steps on the PC and make those equal to
	     *     the slow and smooth tiny steps on the Mac. Key data: This code tries to
	     *     resolve a single slow step on a wheel to 1.
	     *
	     *   - pixel is normalizing the desired scroll delta in pixel units.  You'll
	     *     get the crazy differences between browsers, but at least it'll be in
	     *     pixels!
	     *
	     *   - positive value indicates scrolling DOWN/RIGHT, negative UP/LEFT.  This
	     *     should translate to positive value zooming IN, negative zooming OUT.
	     *     This matches the newer 'wheel' event.
	     *
	     * Why are there spinX, spinY (or pixels)?
	     *
	     *   - spinX is a 2-finger side drag on the trackpad, and a shift + wheel turn
	     *     with a mouse.  It results in side-scrolling in the browser by default.
	     *
	     *   - spinY is what you expect -- it's the classic axis of a mouse wheel.
	     *
	     *   - I dropped spinZ/pixelZ.  It is supported by the DOM 3 'wheel' event and
	     *     probably is by browsers in conjunction with fancy 3D controllers .. but
	     *     you know.
	     *
	     * Implementation info:
	     *
	     * Examples of 'wheel' event if you scroll slowly (down) by one step with an
	     * average mouse:
	     *
	     *   OS X + Chrome  (mouse)     -    4   pixel delta  (wheelDelta -120)
	     *   OS X + Safari  (mouse)     -  N/A   pixel delta  (wheelDelta  -12)
	     *   OS X + Firefox (mouse)     -    0.1 line  delta  (wheelDelta  N/A)
	     *   Win8 + Chrome  (mouse)     -  100   pixel delta  (wheelDelta -120)
	     *   Win8 + Firefox (mouse)     -    3   line  delta  (wheelDelta -120)
	     *
	     * On the trackpad:
	     *
	     *   OS X + Chrome  (trackpad)  -    2   pixel delta  (wheelDelta   -6)
	     *   OS X + Firefox (trackpad)  -    1   pixel delta  (wheelDelta  N/A)
	     *
	     * On other/older browsers.. it's more complicated as there can be multiple and
	     * also missing delta values.
	     *
	     * The 'wheel' event is more standard:
	     *
	     * http://www.w3.org/TR/DOM-Level-3-Events/#events-wheelevents
	     *
	     * The basics is that it includes a unit, deltaMode (pixels, lines, pages), and
	     * deltaX, deltaY and deltaZ.  Some browsers provide other values to maintain
	     * backward compatibility with older events.  Those other values help us
	     * better normalize spin speed.  Example of what the browsers provide:
	     *
	     *                          | event.wheelDelta | event.detail
	     *        ------------------+------------------+--------------
	     *          Safari v5/OS X  |       -120       |       0
	     *          Safari v5/Win7  |       -120       |       0
	     *         Chrome v17/OS X  |       -120       |       0
	     *         Chrome v17/Win7  |       -120       |       0
	     *                IE9/Win7  |       -120       |   undefined
	     *         Firefox v4/OS X  |     undefined    |       1
	     *         Firefox v4/Win7  |     undefined    |       3
	     *
	     * from: https://github.com/facebook/fixed-data-table/blob/master/src/vendor_upstream/dom/normalizeWheel.js
	     * @param {any} event
	     * @return {any}
	     */
	    Utils.normalizeWheel = function (event) {
	        var PIXEL_STEP = 10;
	        var LINE_HEIGHT = 40;
	        var PAGE_HEIGHT = 800;
	        // spinX, spinY
	        var sX = 0;
	        var sY = 0;
	        // pixelX, pixelY
	        var pX = 0;
	        var pY = 0;
	        // Legacy
	        if ('detail' in event) {
	            sY = event.detail;
	        }
	        if ('wheelDelta' in event) {
	            sY = -event.wheelDelta / 120;
	        }
	        if ('wheelDeltaY' in event) {
	            sY = -event.wheelDeltaY / 120;
	        }
	        if ('wheelDeltaX' in event) {
	            sX = -event.wheelDeltaX / 120;
	        }
	        // side scrolling on FF with DOMMouseScroll
	        if ('axis' in event && event.axis === event.HORIZONTAL_AXIS) {
	            sX = sY;
	            sY = 0;
	        }
	        pX = sX * PIXEL_STEP;
	        pY = sY * PIXEL_STEP;
	        if ('deltaY' in event) {
	            pY = event.deltaY;
	        }
	        if ('deltaX' in event) {
	            pX = event.deltaX;
	        }
	        if ((pX || pY) && event.deltaMode) {
	            if (event.deltaMode == 1) { // delta in LINE units
	                pX *= LINE_HEIGHT;
	                pY *= LINE_HEIGHT;
	            }
	            else { // delta in PAGE units
	                pX *= PAGE_HEIGHT;
	                pY *= PAGE_HEIGHT;
	            }
	        }
	        // Fall-back if spin cannot be determined
	        if (pX && !sX) {
	            sX = (pX < 1) ? -1 : 1;
	        }
	        if (pY && !sY) {
	            sY = (pY < 1) ? -1 : 1;
	        }
	        return {
	            spinX: sX,
	            spinY: sY,
	            pixelX: pX,
	            pixelY: pY
	        };
	    };
	    /**
	     * from https://stackoverflow.com/questions/24004791/can-someone-explain-the-debounce-function-in-javascript
	     * @param {Function} func The function to be debounced
	     * @param {number} wait The time in ms to debounce
	     * @param {boolean} immediate If it should run immediately or wait for the initial debounce delay
	     * @return {Function} The debounced function
	     */
	    Utils.debounce = function (func, wait, immediate) {
	        if (immediate === void 0) { immediate = false; }
	        // 'private' variable for instance
	        // The returned function will be able to reference this due to closure.
	        // Each call to the returned function will share this common timer.
	        var timeout;
	        // Calling debounce returns a new anonymous function
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            // reference the context and args for the setTimeout function
	            var context = this;
	            // Should the function be called now? If immediate is true
	            //   and not already in a timeout then the answer is: Yes
	            var callNow = immediate && !timeout;
	            // This is the basic debounce behaviour where you can call this
	            //   function several times, but it will only execute once
	            //   [before or after imposing a delay].
	            //   Each time the returned function is called, the timer starts over.
	            window.clearTimeout(timeout);
	            // Set the new timeout
	            timeout = window.setTimeout(function () {
	                // Inside the timeout function, clear the timeout variable
	                // which will let the next execution run when in 'immediate' mode
	                timeout = null;
	                // Check if the function already ran with the immediate flag
	                if (!immediate) {
	                    // Call the original function with apply
	                    // apply lets you define the 'this' object as well as the arguments
	                    //    (both captured before setTimeout)
	                    func.apply(context, args);
	                }
	            }, wait);
	            // Immediate mode and no wait timer? Execute the function..
	            if (callNow) {
	                func.apply(context, args);
	            }
	        };
	    };
	    /**
	     * a user once raised an issue - they said that when you opened a popup (eg context menu)
	     * and then clicked on a selection checkbox, the popup wasn't closed. this is because the
	     * popup listens for clicks on the body, however ag-grid WAS stopping propagation on the
	     * checkbox clicks (so the rows didn't pick them up as row selection selection clicks).
	     * to get around this, we have a pattern to stop propagation for the purposes of ag-Grid,
	     * but we still let the event pass back to teh body.
	     * @param {Event} event
	     */
	    Utils.stopPropagationForAgGrid = function (event) {
	        event[AG_GRID_STOP_PROPAGATION] = true;
	    };
	    Utils.isStopPropagationForAgGrid = function (event) {
	        return event[AG_GRID_STOP_PROPAGATION] === true;
	    };
	    Utils.executeInAWhile = function (funcs) {
	        this.executeAfter(funcs, 400);
	    };
	    Utils.executeNextVMTurn = function (funcs) {
	        this.executeAfter(funcs, 0);
	    };
	    Utils.executeAfter = function (funcs, millis) {
	        if (funcs.length > 0) {
	            window.setTimeout(function () {
	                funcs.forEach(function (func) { return func(); });
	            }, millis);
	        }
	    };
	    Utils.referenceCompare = function (left, right) {
	        if (left == null && right == null) {
	            return true;
	        }
	        if (left == null && right) {
	            return false;
	        }
	        if (left && right == null) {
	            return false;
	        }
	        return left === right;
	    };
	    Utils.get = function (source, expression, defaultValue) {
	        if (source == null) {
	            return defaultValue;
	        }
	        if (expression.indexOf('.') > -1) {
	            var fields = expression.split('.');
	            var thisKey = fields[0];
	            var nextValue_1 = source[thisKey];
	            if (nextValue_1 != null) {
	                return Utils.get(nextValue_1, fields.slice(1, fields.length).join('.'), defaultValue);
	            }
	            return defaultValue;
	        }
	        var nextValue = source[expression];
	        return nextValue != null ? nextValue : defaultValue;
	    };
	    Utils.addSafePassiveEventListener = function (frameworkOverrides, eElement, event, listener) {
	        var isPassive = Utils.PASSIVE_EVENTS.indexOf(event) >= 0;
	        var isOutsideAngular = Utils.OUTSIDE_ANGULAR_EVENTS.indexOf(event) >= 0;
	        var options = isPassive ? { passive: true } : undefined;
	        if (isOutsideAngular) {
	            frameworkOverrides.addEventListenerOutsideAngular(eElement, event, listener, options);
	        }
	        else {
	            eElement.addEventListener(event, listener, options);
	        }
	    };
	    /**
	     * Converts a camelCase string into regular text
	     * from: https://stackoverflow.com/questions/15369566/putting-space-in-camel-case-string-using-regular-expression
	     * @param {string} camelCase
	     * @return {string}
	     */
	    Utils.camelCaseToHumanText = function (camelCase) {
	        if (!camelCase || camelCase == null) {
	            return null;
	        }
	        var rex = /([A-Z])([A-Z])([a-z])|([a-z])([A-Z])/g;
	        var words = camelCase.replace(rex, '$1$4 $2$3$5').replace('.', ' ').split(' ');
	        return words.map(function (word) { return word.substring(0, 1).toUpperCase() + ((word.length > 1) ? word.substring(1, word.length) : ''); }).join(' ');
	    };
	    /**
	     * Displays a message to the browser. this is useful in iPad, where you can't easily see the console.
	     * so the javascript code can use this to give feedback. this is NOT intended to be called in production.
	     * it is intended the ag-Grid developer calls this to troubleshoot, but then takes out the calls before
	     * checking in.
	     * @param {string} msg
	     */
	    Utils.message = function (msg) {
	        var eMessage = document.createElement('div');
	        eMessage.innerHTML = msg;
	        var eBox = document.querySelector('#__ag__message');
	        if (!eBox) {
	            var template = "<div id=\"__ag__message\" style=\"display: inline-block; position: absolute; top: 0px; left: 0px; color: white; background-color: black; z-index: 20; padding: 2px; border: 1px solid darkred; height: 200px; overflow-y: auto;\"></div>";
	            eBox = this.loadTemplate(template);
	            if (document.body) {
	                document.body.appendChild(eBox);
	            }
	        }
	        eBox.insertBefore(eMessage, eBox.children[0]);
	        // eBox.appendChild(eMessage);
	    };
	    /**
	     * Gets called by: a) ClientSideNodeManager and b) GroupStage to do sorting.
	     * when in ClientSideNodeManager we always have indexes (as this sorts the items the
	     * user provided) but when in GroupStage, the nodes can contain filler nodes that
	     * don't have order id's
	     * @param {RowNode[]} rowNodes
	     * @param {Object} rowNodeOrder
	     */
	    Utils.sortRowNodesByOrder = function (rowNodes, rowNodeOrder) {
	        if (!rowNodes) {
	            return;
	        }
	        var comparator = function (nodeA, nodeB) {
	            var positionA = rowNodeOrder[nodeA.id];
	            var positionB = rowNodeOrder[nodeB.id];
	            var aHasIndex = positionA !== undefined;
	            var bHasIndex = positionB !== undefined;
	            var bothNodesAreUserNodes = aHasIndex && bHasIndex;
	            var bothNodesAreFillerNodes = !aHasIndex && !bHasIndex;
	            if (bothNodesAreUserNodes) {
	                // when comparing two nodes the user has provided, they always
	                // have indexes
	                return positionA - positionB;
	            }
	            else if (bothNodesAreFillerNodes) {
	                // when comparing two filler nodes, we have no index to compare them
	                // against, however we want this sorting to be deterministic, so that
	                // the rows don't jump around as the user does delta updates. so we
	                // want the same sort result. so we use the __objectId - which doesn't make sense
	                // from a sorting point of view, but does give consistent behaviour between
	                // calls. otherwise groups jump around as delta updates are done.
	                // note: previously here we used nodeId, however this gave a strange order
	                // as string ordering of numbers is wrong, so using id based on creation order
	                // as least gives better looking order.
	                return nodeA.__objectId - nodeB.__objectId;
	            }
	            else if (aHasIndex) {
	                return 1;
	            }
	            return -1;
	        };
	        // const a = new Date().getTime();
	        // check if the list first needs sorting
	        var rowNodeA;
	        var rowNodeB;
	        var atLeastOneOutOfOrder = false;
	        for (var i = 0; i < rowNodes.length - 1; i++) {
	            rowNodeA = rowNodes[i];
	            rowNodeB = rowNodes[i + 1];
	            if (comparator(rowNodeA, rowNodeB) > 0) {
	                atLeastOneOutOfOrder = true;
	                break;
	            }
	        }
	        // const b = new Date().getTime();
	        if (atLeastOneOutOfOrder) {
	            rowNodes.sort(comparator);
	        }
	        // const c = new Date().getTime();
	        // console.log(`${this.count}: ${rowNodes.length} items, ${b-a}ms ${atLeastOneOutOfOrder} ${c-b}ms`);
	    };
	    Utils.fuzzyCheckStrings = function (inputValues, validValues, allSuggestions) {
	        var _this = this;
	        var fuzzyMatches = {};
	        var invalidInputs = inputValues.filter(function (inputValue) {
	            return !validValues.some(function (validValue) { return validValue === inputValue; });
	        });
	        if (invalidInputs.length > 0) {
	            invalidInputs.forEach(function (invalidInput) {
	                return fuzzyMatches[invalidInput] = _this.fuzzySuggestions(invalidInput, allSuggestions);
	            });
	        }
	        return fuzzyMatches;
	    };
	    /**
	     *
	     * @param {String} inputValue The value to be compared against a list of strings
	     * @param allSuggestions The list of strings to be compared against
	     * @param hideIrrelevant By default, fuzzy suggestions will just sort the allSuggestions list, set this to true
	     *        to filter out the irrelevant values
	     * @param weighted Set this to true, to make letters matched in the order they were typed have priority in the results.
	     */
	    Utils.fuzzySuggestions = function (inputValue, allSuggestions, hideIrrelevant, weighted) {
	        var search = weighted ? exports._.string_weighted_distances : exports._.string_distances;
	        var thisSuggestions = allSuggestions.map(function (text) { return ({
	            value: text,
	            relevance: search(inputValue.toLowerCase(), text.toLocaleLowerCase())
	        }); });
	        thisSuggestions.sort(function (a, b) {
	            return b.relevance - a.relevance;
	        });
	        if (hideIrrelevant) {
	            thisSuggestions = thisSuggestions.filter(function (suggestion) { return suggestion.relevance !== 0; });
	        }
	        return thisSuggestions.map(function (suggestion) { return suggestion.value; });
	    };
	    /**
	     * Algorithm to do fuzzy search
	     * from https://stackoverflow.com/questions/23305000/javascript-fuzzy-search-that-makes-sense
	     * @param {string} from
	     * @return {[]}
	     */
	    Utils.get_bigrams = function (from) {
	        var s = from.toLowerCase();
	        var v = new Array(s.length - 1);
	        var i;
	        var j;
	        var ref;
	        for (i = j = 0, ref = v.length; j <= ref; i = j += 1) {
	            v[i] = s.slice(i, i + 2);
	        }
	        return v;
	    };
	    Utils.string_distances = function (str1, str2) {
	        if (str1.length === 0 && str2.length === 0) {
	            return 0;
	        }
	        var pairs1 = exports._.get_bigrams(str1);
	        var pairs2 = exports._.get_bigrams(str2);
	        var union = pairs1.length + pairs2.length;
	        var hit_count = 0;
	        var j;
	        var len;
	        for (j = 0, len = pairs1.length; j < len; j++) {
	            var x = pairs1[j];
	            var k = void 0;
	            var len1 = void 0;
	            for (k = 0, len1 = pairs2.length; k < len1; k++) {
	                var y = pairs2[k];
	                if (x === y) {
	                    hit_count++;
	                }
	            }
	        }
	        return hit_count > 0 ? (2 * hit_count) / union : 0;
	    };
	    Utils.string_weighted_distances = function (str1, str2) {
	        var a = str1.replace(/\s/g, '');
	        var b = str2.replace(/\s/g, '');
	        var weight = 0;
	        var lastIndex = 0;
	        for (var i = 0; i < a.length; i++) {
	            var idx = b.indexOf(a[i]);
	            if (idx === -1) {
	                continue;
	            }
	            lastIndex = idx;
	            weight += ((b.length - lastIndex) * 100) / b.length;
	            weight *= weight;
	        }
	        return weight;
	    };
	    Utils.isNumpadDelWithNumlockOnForEdgeOrIe = function (event) {
	        if (Utils.isBrowserEdge() || Utils.isBrowserIE()) {
	            return event.key === Utils.NUMPAD_DEL_NUMLOCK_ON_KEY &&
	                event.charCode === Utils.NUMPAD_DEL_NUMLOCK_ON_CHARCODE;
	        }
	        return false;
	    };
	    /**
	     * cell renderers are used in a few places. they bind to dom slightly differently to other cell renderes as they
	     * can return back strings (instead of html elemnt) in the getGui() method. common code placed here to handle that.
	     * @param {Promise<ICellRendererComp>} cellRendererPromise
	     * @param {HTMLElement} eTarget
	     */
	    Utils.bindCellRendererToHtmlElement = function (cellRendererPromise, eTarget) {
	        cellRendererPromise.then(function (cellRenderer) {
	            var gui = cellRenderer.getGui();
	            if (gui != null) {
	                if (typeof gui == 'object') {
	                    eTarget.appendChild(gui);
	                }
	                else {
	                    eTarget.innerHTML = gui;
	                }
	            }
	        });
	    };
	    Utils.PASSIVE_EVENTS = ['touchstart', 'touchend', 'touchmove', 'touchcancel'];
	    Utils.OUTSIDE_ANGULAR_EVENTS = ['mouseover', 'mouseout', 'mouseenter', 'mouseleave'];
	    Utils.PRINTABLE_CHARACTERS = 'qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM1234567890!"£$%^&*()_+-=[];\'#,./\\|<>?:@~{}';
	    Utils.NUMPAD_DEL_NUMLOCK_ON_KEY = 'Del';
	    Utils.NUMPAD_DEL_NUMLOCK_ON_CHARCODE = 46;
	    Utils.doOnceFlags = {};
	    Utils.compose = function () {
	        var fns = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            fns[_i] = arguments[_i];
	        }
	        return function (arg) { return fns.reduce(function (composed, f) { return f(composed); }, arg); };
	    };
	    Utils.decToHex = function (number, bytes) {
	        var hex = '';
	        for (var i = 0; i < bytes; i++) {
	            hex += String.fromCharCode(number & 0xff);
	            number >>>= 8;
	        }
	        return hex;
	    };
	    /**
	     * It encodes any string in UTF-8 format
	     * taken from https://github.com/mathiasbynens/utf8.js
	     * @param {string} s
	     * @returns {string}
	     */
	    Utils.utf8_encode = function (s) {
	        var stringFromCharCode = String.fromCharCode;
	        function ucs2decode(string) {
	            var output = [];
	            var counter = 0;
	            var length = string.length;
	            var value;
	            var extra;
	            while (counter < length) {
	                value = string.charCodeAt(counter++);
	                if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
	                    // high surrogate, and there is a next character
	                    extra = string.charCodeAt(counter++);
	                    if ((extra & 0xFC00) == 0xDC00) { // low surrogate
	                        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
	                    }
	                    else {
	                        // unmatched surrogate; only append this code unit, in case the next
	                        // code unit is the high surrogate of a surrogate pair
	                        output.push(value);
	                        counter--;
	                    }
	                }
	                else {
	                    output.push(value);
	                }
	            }
	            return output;
	        }
	        function checkScalarValue(codePoint) {
	            if (codePoint >= 0xD800 && codePoint <= 0xDFFF) {
	                throw Error('Lone surrogate U+' + codePoint.toString(16).toUpperCase() +
	                    ' is not a scalar value');
	            }
	        }
	        function createByte(codePoint, shift) {
	            return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
	        }
	        function encodeCodePoint(codePoint) {
	            if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
	                return stringFromCharCode(codePoint);
	            }
	            var symbol = '';
	            if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
	                symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
	            }
	            else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
	                checkScalarValue(codePoint);
	                symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
	                symbol += createByte(codePoint, 6);
	            }
	            else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
	                symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
	                symbol += createByte(codePoint, 12);
	                symbol += createByte(codePoint, 6);
	            }
	            symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
	            return symbol;
	        }
	        var codePoints = ucs2decode(s);
	        var length = codePoints.length;
	        var index = -1;
	        var codePoint;
	        var byteString = '';
	        while (++index < length) {
	            codePoint = codePoints[index];
	            byteString += encodeCodePoint(codePoint);
	        }
	        return byteString;
	    };
	    Utils.iconNameClassMap = {
	        columnGroupOpened: 'expanded',
	        columnGroupClosed: 'contracted',
	        columnSelectClosed: 'tree-closed',
	        columnSelectOpen: 'tree-open',
	        columnSelectIndeterminate: 'tree-indeterminate',
	        columnMovePin: 'pin',
	        columnMoveAdd: 'plus',
	        columnMoveHide: 'eye-slash',
	        columnMoveMove: 'arrows',
	        columnMoveLeft: 'left',
	        columnMoveRight: 'right',
	        columnMoveGroup: 'group',
	        columnMoveValue: 'aggregation',
	        columnMovePivot: 'pivot',
	        dropNotAllowed: 'not-allowed',
	        groupContracted: 'expanded',
	        groupExpanded: 'contracted',
	        chart: 'chart',
	        close: 'cross',
	        cancel: 'cancel',
	        check: 'tick',
	        checkboxChecked: 'checkbox-checked',
	        checkboxUnchecked: 'checkbox-unchecked',
	        checkboxIndeterminate: 'checkbox-indeterminate',
	        checkboxCheckedReadOnly: 'checkbox-checked-readonly',
	        checkboxUncheckedReadOnly: 'checkbox-unchecked-readonly',
	        checkboxIndeterminateReadOnly: 'checkbox-indeterminate-readonly',
	        first: 'first',
	        previous: 'previous',
	        next: 'next',
	        last: 'last',
	        linked: 'linked',
	        unlinked: 'unlinked',
	        colorPicker: 'color-picker',
	        radioButtonOn: 'radio-button-on',
	        radioButtonOff: 'radio-button-off',
	        groupLoading: 'loading',
	        data: 'data',
	        menu: 'menu',
	        filter: 'filter',
	        columns: 'columns',
	        maximize: 'maximize',
	        minimize: 'minimize',
	        menuPin: 'pin',
	        menuValue: 'aggregation',
	        menuAddRowGroup: 'group',
	        menuRemoveRowGroup: 'group',
	        clipboardCopy: 'copy',
	        clipboardCut: 'cut',
	        clipboardPaste: 'paste',
	        pivotPanel: 'pivot',
	        rowGroupPanel: 'group',
	        valuePanel: 'aggregation',
	        columnDrag: 'grip',
	        rowDrag: 'grip',
	        save: 'save',
	        smallLeft: 'small-left',
	        smallRight: 'small-right',
	        smallUp: 'small-up',
	        smallDown: 'small-down',
	        sortAscending: 'asc',
	        sortDescending: 'desc',
	        sortUnSort: 'none'
	    };
	    return Utils;
	}());
	exports.Utils = Utils;
	var NumberSequence = /** @class */ (function () {
	    function NumberSequence(initValue, step) {
	        if (initValue === void 0) { initValue = 0; }
	        if (step === void 0) { step = 1; }
	        this.nextValue = initValue;
	        this.step = step;
	    }
	    NumberSequence.prototype.next = function () {
	        var valToReturn = this.nextValue;
	        this.nextValue += this.step;
	        return valToReturn;
	    };
	    NumberSequence.prototype.peek = function () {
	        return this.nextValue;
	    };
	    NumberSequence.prototype.skip = function (count) {
	        this.nextValue += count;
	    };
	    return NumberSequence;
	}());
	exports.NumberSequence = NumberSequence;
	exports._ = Utils;


/***/ },
/* 1412 */
/***/ function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var PromiseStatus;
	(function (PromiseStatus) {
	    PromiseStatus[PromiseStatus["IN_PROGRESS"] = 0] = "IN_PROGRESS";
	    PromiseStatus[PromiseStatus["RESOLVED"] = 1] = "RESOLVED";
	})(PromiseStatus = exports.PromiseStatus || (exports.PromiseStatus = {}));
	var Promise = /** @class */ (function () {
	    function Promise(callback) {
	        this.status = PromiseStatus.IN_PROGRESS;
	        this.resolution = null;
	        this.listOfWaiters = [];
	        callback(this.onDone.bind(this), this.onReject.bind(this));
	    }
	    Promise.all = function (toCombine) {
	        return new Promise(function (resolve) {
	            var combinedValues = [];
	            var remainingToResolve = toCombine.length;
	            toCombine.forEach(function (source, index) {
	                source.then(function (sourceResolved) {
	                    remainingToResolve--;
	                    combinedValues[index] = sourceResolved;
	                    if (remainingToResolve == 0) {
	                        resolve(combinedValues);
	                    }
	                });
	                combinedValues.push(null); // spl todo: review with Alberto - why?
	            });
	        });
	    };
	    Promise.resolve = function (value) {
	        return new Promise(function (resolve) { return resolve(value); });
	    };
	    Promise.external = function () {
	        var capture;
	        var promise = new Promise(function (resolve) {
	            capture = resolve;
	        });
	        return {
	            promise: promise,
	            resolve: function (value) {
	                capture(value);
	            }
	        };
	    };
	    Promise.prototype.then = function (func) {
	        if (this.status === PromiseStatus.IN_PROGRESS) {
	            this.listOfWaiters.push(func);
	        }
	        else {
	            func(this.resolution);
	        }
	    };
	    Promise.prototype.firstOneOnly = function (func) {
	        if (this.status === PromiseStatus.IN_PROGRESS) {
	            if (this.listOfWaiters.length === 0) {
	                this.listOfWaiters.push(func);
	            }
	        }
	        else {
	            func(this.resolution);
	        }
	    };
	    Promise.prototype.map = function (adapter) {
	        var _this = this;
	        return new Promise(function (resolve) {
	            _this.then(function (unmapped) {
	                resolve(adapter(unmapped));
	            });
	        });
	    };
	    Promise.prototype.resolveNow = function (ifNotResolvedValue, ifResolved) {
	        if (this.status == PromiseStatus.IN_PROGRESS) {
	            return ifNotResolvedValue;
	        }
	        return ifResolved(this.resolution);
	    };
	    Promise.prototype.onDone = function (value) {
	        this.status = PromiseStatus.RESOLVED;
	        this.resolution = value;
	        this.listOfWaiters.forEach(function (waiter) { return waiter(value); });
	    };
	    Promise.prototype.onReject = function (params) {
	        console.warn('TBI');
	    };
	    return Promise;
	}());
	exports.Promise = Promise;


/***/ },
/* 1413 */
/***/ function(module, exports) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * A Util Class only used when debugging for printing time to console
	 */
	var Timer = /** @class */ (function () {
	    function Timer() {
	        this.timestamp = new Date().getTime();
	    }
	    Timer.prototype.print = function (msg) {
	        var duration = (new Date().getTime()) - this.timestamp;
	        console.info(msg + " = " + duration);
	        this.timestamp = new Date().getTime();
	    };
	    return Timer;
	}());
	exports.Timer = Timer;


/***/ },
/* 1414 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var context_1 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var changedPath_1 = __webpack_require__(325);
	var rowRenderer_1 = __webpack_require__(91);
	var eventService_1 = __webpack_require__(22);
	var constants_1 = __webpack_require__(30);
	var beanStub_1 = __webpack_require__(71);
	var events_1 = __webpack_require__(29);
	var ChangeDetectionService = /** @class */ (function (_super) {
	    __extends(ChangeDetectionService, _super);
	    function ChangeDetectionService() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ChangeDetectionService.prototype.init = function () {
	        if (this.rowModel.getType() === constants_1.Constants.ROW_MODEL_TYPE_CLIENT_SIDE) {
	            this.clientSideRowModel = this.rowModel;
	        }
	        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_CELL_VALUE_CHANGED, this.onCellValueChanged.bind(this));
	    };
	    ChangeDetectionService.prototype.onCellValueChanged = function (event) {
	        this.doChangeDetection(event.node, event.column);
	    };
	    ChangeDetectionService.prototype.doChangeDetection = function (rowNode, column) {
	        if (this.gridOptionsWrapper.isSuppressChangeDetection()) {
	            return;
	        }
	        // clipboard service manages it's own change detection, so no need to do it here.
	        // the clipboard manages it own, as otherwise this would happen once for every cell
	        // that got updated as part of a paste operation. so eg if 100 cells in a paste operation,
	        // this doChangeDetection would get called 100 times (once for each cell), instead clipboard
	        // service executes the logic we have here once (in essence batching up all cell changes
	        // into one change detection).
	        if (this.clipboardService && this.clipboardService.isPasteOperationActive()) {
	            return;
	        }
	        // step 1 of change detection is to update the aggregated values
	        if (this.clientSideRowModel && !rowNode.isRowPinned()) {
	            var onlyChangedColumns = this.gridOptionsWrapper.isAggregateOnlyChangedColumns();
	            var changedPath = new changedPath_1.ChangedPath(onlyChangedColumns, this.clientSideRowModel.getRootNode());
	            changedPath.addParentNode(rowNode.parent, [column]);
	            this.clientSideRowModel.doAggregate(changedPath);
	        }
	        // step 2 of change detection is to refresh the cells
	        this.rowRenderer.refreshCells();
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], ChangeDetectionService.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        context_1.Autowired('rowModel'),
	        __metadata("design:type", Object)
	    ], ChangeDetectionService.prototype, "rowModel", void 0);
	    __decorate([
	        context_1.Autowired('rowRenderer'),
	        __metadata("design:type", rowRenderer_1.RowRenderer)
	    ], ChangeDetectionService.prototype, "rowRenderer", void 0);
	    __decorate([
	        context_1.Autowired('eventService'),
	        __metadata("design:type", eventService_1.EventService)
	    ], ChangeDetectionService.prototype, "eventService", void 0);
	    __decorate([
	        context_1.Optional('clipboardService'),
	        __metadata("design:type", Object)
	    ], ChangeDetectionService.prototype, "clipboardService", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ChangeDetectionService.prototype, "init", null);
	    ChangeDetectionService = __decorate([
	        context_1.Bean('changeDetectionService')
	    ], ChangeDetectionService);
	    return ChangeDetectionService;
	}(beanStub_1.BeanStub));
	exports.ChangeDetectionService = ChangeDetectionService;


/***/ },
/* 1415 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var component_1 = __webpack_require__(31);
	var utils_1 = __webpack_require__(10);
	var componentAnnotations_1 = __webpack_require__(39);
	var context_1 = __webpack_require__(8);
	var AgColorPanel = /** @class */ (function (_super) {
	    __extends(AgColorPanel, _super);
	    function AgColorPanel(config) {
	        var _this = _super.call(this, AgColorPanel.TEMPLATE) || this;
	        _this.H = 1; // in the [0, 1] range
	        _this.S = 1; // in the [0, 1] range
	        _this.B = 1; // in the [0, 1] range
	        _this.A = 1; // in the [0, 1] range
	        _this.isSpectrumDragging = false;
	        _this.isSpectrumHueDragging = false;
	        _this.isSpectrumAlphaDragging = false;
	        _this.colorChanged = false;
	        _this.picker = config.picker;
	        return _this;
	    }
	    AgColorPanel.prototype.postConstruct = function () {
	        var eGui = this.getGui();
	        this.initRecentColors();
	        this.addDestroyableEventListener(this.spectrumVal, 'mousedown', this.onSpectrumDraggerDown.bind(this));
	        this.addDestroyableEventListener(eGui, 'mousemove', this.onSpectrumDraggerMove.bind(this));
	        this.addDestroyableEventListener(this.spectrumHue, 'mousedown', this.onSpectrumHueDown.bind(this));
	        this.addDestroyableEventListener(eGui, 'mousemove', this.onSpectrumHueMove.bind(this));
	        this.addDestroyableEventListener(this.spectrumAlpha, 'mousedown', this.onSpectrumAlphaDown.bind(this));
	        this.addDestroyableEventListener(eGui, 'mousemove', this.onSpectrumAlphaMove.bind(this));
	        // Listening to `mouseup` on the document on purpose. The user might release the mouse button
	        // outside the UI control. When the mouse returns back to the control's area, the dragging
	        // of the thumb is not expected and seen as a bug.
	        this.addDestroyableEventListener(document, 'mouseup', this.onMouseUp.bind(this));
	        this.addDestroyableEventListener(this.recentColors, 'click', this.onRecentColorClick.bind(this));
	    };
	    AgColorPanel.prototype.refreshSpectrumRect = function () {
	        return this.spectrumValRect = this.spectrumVal.getBoundingClientRect();
	    };
	    AgColorPanel.prototype.refreshHueRect = function () {
	        return this.spectrumHueRect = this.spectrumHue.getBoundingClientRect();
	    };
	    AgColorPanel.prototype.refreshAlphaRect = function () {
	        return this.spectrumAlphaRect = this.spectrumAlpha.getBoundingClientRect();
	    };
	    AgColorPanel.prototype.onSpectrumDraggerDown = function (e) {
	        this.refreshSpectrumRect();
	        this.isSpectrumDragging = true;
	        this.moveDragger(e);
	    };
	    AgColorPanel.prototype.onSpectrumDraggerMove = function (e) {
	        if (this.isSpectrumDragging) {
	            this.moveDragger(e);
	        }
	    };
	    AgColorPanel.prototype.onSpectrumHueDown = function (e) {
	        this.refreshHueRect();
	        this.isSpectrumHueDragging = true;
	        this.moveHueSlider(e);
	    };
	    AgColorPanel.prototype.onSpectrumHueMove = function (e) {
	        if (this.isSpectrumHueDragging) {
	            this.moveHueSlider(e);
	        }
	    };
	    AgColorPanel.prototype.onSpectrumAlphaDown = function (e) {
	        this.refreshAlphaRect();
	        this.isSpectrumAlphaDragging = true;
	        this.moveAlphaSlider(e);
	    };
	    AgColorPanel.prototype.onSpectrumAlphaMove = function (e) {
	        if (this.isSpectrumAlphaDragging) {
	            this.moveAlphaSlider(e);
	        }
	    };
	    AgColorPanel.prototype.onMouseUp = function () {
	        this.isSpectrumDragging = false;
	        this.isSpectrumHueDragging = false;
	        this.isSpectrumAlphaDragging = false;
	    };
	    AgColorPanel.prototype.moveDragger = function (e) {
	        var valRect = this.spectrumValRect;
	        if (valRect) {
	            var x = e.clientX - valRect.left;
	            var y = e.clientY - valRect.top;
	            x = Math.max(x, 0);
	            x = Math.min(x, valRect.width);
	            y = Math.max(y, 0);
	            y = Math.min(y, valRect.height);
	            this.setSpectrumValue(x / valRect.width, 1 - y / valRect.height);
	        }
	    };
	    AgColorPanel.prototype.moveHueSlider = function (e) {
	        var hueRect = this.spectrumHueRect;
	        if (hueRect) {
	            var slider = this.spectrumHueSlider;
	            var sliderRect = slider.getBoundingClientRect();
	            var x = e.clientX - hueRect.left;
	            x = Math.max(x, 0);
	            x = Math.min(x, hueRect.width);
	            this.H = 1 - x / hueRect.width;
	            slider.style.left = (x + sliderRect.width / 2) + 'px';
	            this.update();
	        }
	    };
	    AgColorPanel.prototype.moveAlphaSlider = function (e) {
	        var alphaRect = this.spectrumAlphaRect;
	        if (alphaRect) {
	            var slider = this.spectrumAlphaSlider;
	            var sliderRect = slider.getBoundingClientRect();
	            var x = e.clientX - alphaRect.left;
	            x = Math.max(x, 0);
	            x = Math.min(x, alphaRect.width);
	            this.A = x / alphaRect.width;
	            slider.style.left = (x + sliderRect.width / 2) + 'px';
	            this.update();
	        }
	    };
	    AgColorPanel.prototype.update = function () {
	        var color = utils_1.Color.fromHSB(this.H * 360, this.S, this.B, this.A);
	        var spectrumColor = utils_1.Color.fromHSB(this.H * 360, 1, 1);
	        var rgbaColor = color.toRgbaString();
	        // the recent color list needs to know color has actually changed
	        var colorPicker = this.picker;
	        var existingColor = utils_1.Color.fromString(colorPicker.getValue());
	        if (existingColor.toRgbaString() !== rgbaColor) {
	            this.colorChanged = true;
	        }
	        colorPicker.setValue(rgbaColor);
	        this.spectrumColor.style.backgroundColor = spectrumColor.toRgbaString();
	        this.spectrumDragger.style.backgroundColor = rgbaColor;
	    };
	    /**
	     * @param saturation In the [0, 1] interval.
	     * @param brightness In the [0, 1] interval.
	     */
	    AgColorPanel.prototype.setSpectrumValue = function (saturation, brightness) {
	        var valRect = this.spectrumValRect || this.refreshSpectrumRect();
	        if (valRect) {
	            var dragger = this.spectrumDragger;
	            var draggerRect = dragger.getBoundingClientRect();
	            saturation = Math.max(0, saturation);
	            saturation = Math.min(1, saturation);
	            brightness = Math.max(0, brightness);
	            brightness = Math.min(1, brightness);
	            this.S = saturation;
	            this.B = brightness;
	            dragger.style.left = (saturation * valRect.width - draggerRect.width / 2) + 'px';
	            dragger.style.top = ((1 - brightness) * valRect.height - draggerRect.height / 2) + 'px';
	            this.update();
	        }
	    };
	    AgColorPanel.prototype.initRecentColors = function () {
	        var recentColors = AgColorPanel.recentColors;
	        var innerHtml = recentColors.map(function (color, index) {
	            return "<div class=\"ag-recent-color\" id=" + index + " style=\"background-color: " + color + "; width: 15px; height: 15px;\" recent-color=\"" + color + "\"></div>";
	        });
	        this.recentColors.innerHTML = innerHtml.join('');
	    };
	    AgColorPanel.prototype.setValue = function (val) {
	        var color = utils_1.Color.fromString(val);
	        var _a = color.toHSB(), h = _a[0], s = _a[1], b = _a[2];
	        this.H = (isNaN(h) ? 0 : h) / 360;
	        this.A = color.a;
	        var spectrumHueRect = this.spectrumHueRect || this.refreshHueRect();
	        var spectrumAlphaRect = this.spectrumAlphaRect || this.refreshAlphaRect();
	        this.spectrumHueSlider.style.left = ((this.H - 1) * -spectrumHueRect.width) + "px";
	        this.spectrumAlphaSlider.style.left = (this.A * spectrumAlphaRect.width) + "px";
	        this.setSpectrumValue(s, b);
	    };
	    AgColorPanel.prototype.onRecentColorClick = function (e) {
	        var target = e.target;
	        if (!utils_1._.exists(target.id)) {
	            return;
	        }
	        var id = parseInt(target.id, 10);
	        this.setValue(AgColorPanel.recentColors[id]);
	        this.destroy();
	    };
	    AgColorPanel.prototype.addRecentColor = function () {
	        var color = utils_1.Color.fromHSB(this.H * 360, this.S, this.B, this.A);
	        var rgbaColor = color.toRgbaString();
	        var recentColors = AgColorPanel.recentColors;
	        if (!this.colorChanged || recentColors[0] === rgbaColor) {
	            return;
	        }
	        // remove duplicate color
	        recentColors = recentColors.filter(function (color) { return color != rgbaColor; });
	        // add color to head
	        recentColors = [rgbaColor].concat(recentColors);
	        // ensure we don't exceed max number of recent colors
	        if (recentColors.length > AgColorPanel.maxRecentColors) {
	            recentColors = recentColors.slice(0, AgColorPanel.maxRecentColors);
	        }
	        AgColorPanel.recentColors = recentColors;
	    };
	    AgColorPanel.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        this.addRecentColor();
	    };
	    AgColorPanel.maxRecentColors = 8;
	    AgColorPanel.recentColors = [];
	    AgColorPanel.TEMPLATE = "<div class=\"ag-color-panel\">\n            <div ref=\"spectrumColor\" class=\"ag-spectrum-color\">\n                <div class=\"ag-spectrum-sat ag-fill\">\n                    <div ref=\"spectrumVal\" class=\"ag-spectrum-val ag-fill\">\n                        <div ref=\"spectrumDragger\" class=\"ag-spectrum-dragger\"></div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"ag-spectrum-tools\">\n                <div ref=\"spectrumHue\" class=\"ag-spectrum-hue ag-hue-alpha\">\n                    <div class=\"ag-spectrum-hue-background\"></div>\n                    <div ref=\"spectrumHueSlider\" class=\"ag-spectrum-slider\"></div>\n                </div>\n                <div ref=\"spectrumAlpha\" class=\"ag-spectrum-alpha ag-hue-alpha\">\n                    <div class=\"ag-spectrum-alpha-background\"></div>\n                    <div ref=\"spectrumAlphaSlider\" class=\"ag-spectrum-slider\"></div>\n                </div>\n                <div ref=\"recentColors\" class=\"ag-recent-colors\"></div>\n            </div>\n        </div>";
	    __decorate([
	        componentAnnotations_1.RefSelector('spectrumColor'),
	        __metadata("design:type", HTMLElement)
	    ], AgColorPanel.prototype, "spectrumColor", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('spectrumVal'),
	        __metadata("design:type", HTMLElement)
	    ], AgColorPanel.prototype, "spectrumVal", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('spectrumDragger'),
	        __metadata("design:type", HTMLElement)
	    ], AgColorPanel.prototype, "spectrumDragger", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('spectrumHue'),
	        __metadata("design:type", HTMLElement)
	    ], AgColorPanel.prototype, "spectrumHue", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('spectrumHueSlider'),
	        __metadata("design:type", HTMLElement)
	    ], AgColorPanel.prototype, "spectrumHueSlider", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('spectrumAlpha'),
	        __metadata("design:type", HTMLElement)
	    ], AgColorPanel.prototype, "spectrumAlpha", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('spectrumAlphaSlider'),
	        __metadata("design:type", HTMLElement)
	    ], AgColorPanel.prototype, "spectrumAlphaSlider", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('recentColors'),
	        __metadata("design:type", HTMLElement)
	    ], AgColorPanel.prototype, "recentColors", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], AgColorPanel.prototype, "postConstruct", null);
	    return AgColorPanel;
	}(component_1.Component));
	exports.AgColorPanel = AgColorPanel;


/***/ },
/* 1416 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var componentAnnotations_1 = __webpack_require__(39);
	var context_1 = __webpack_require__(8);
	var gridOptionsWrapper_1 = __webpack_require__(14);
	var agAbstractField_1 = __webpack_require__(162);
	var utils_1 = __webpack_require__(10);
	var AgPickerField = /** @class */ (function (_super) {
	    __extends(AgPickerField, _super);
	    function AgPickerField() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.TEMPLATE = "<div class=\"ag-picker-field\">\n            <label ref=\"eLabel\"></label>\n            <div ref=\"eWrapper\" class=\"ag-wrapper\">\n                <%displayField% ref=\"eDisplayField\"></%displayField%>\n                <button ref=\"eButton\" class=\"ag-picker-button\"> </button>\n            </div>\n        </div>";
	        _this.displayedPicker = false;
	        _this.isDestroyingPicker = false;
	        return _this;
	    }
	    AgPickerField.prototype.postConstruct = function () {
	        var _this = this;
	        _super.prototype.postConstruct.call(this);
	        this.addDestroyableEventListener(this.eButton, 'click', function () {
	            _this.showPicker();
	        });
	        if (this.pickerIcon) {
	            this.eButton.appendChild(utils_1._.createIconNoSpan(this.pickerIcon, this.gridOptionsWrapper, null));
	        }
	    };
	    AgPickerField.prototype.setInputWidth = function (width) {
	        utils_1._.setElementWidth(this.eWrapper, width);
	        return this;
	    };
	    __decorate([
	        context_1.Autowired('gridOptionsWrapper'),
	        __metadata("design:type", gridOptionsWrapper_1.GridOptionsWrapper)
	    ], AgPickerField.prototype, "gridOptionsWrapper", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eLabel'),
	        __metadata("design:type", HTMLElement)
	    ], AgPickerField.prototype, "eLabel", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eWrapper'),
	        __metadata("design:type", HTMLElement)
	    ], AgPickerField.prototype, "eWrapper", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eDisplayField'),
	        __metadata("design:type", Object)
	    ], AgPickerField.prototype, "eDisplayField", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eButton'),
	        __metadata("design:type", HTMLButtonElement)
	    ], AgPickerField.prototype, "eButton", void 0);
	    return AgPickerField;
	}(agAbstractField_1.AgAbstractField));
	exports.AgPickerField = AgPickerField;


/***/ },
/* 1417 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
	 * @version v21.2.2
	 * @link http://www.ag-grid.com/
	 * @license MIT
	 */
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var agDialog_1 = __webpack_require__(326);
	var context_1 = __webpack_require__(8);
	var component_1 = __webpack_require__(31);
	var componentAnnotations_1 = __webpack_require__(39);
	var MessageBox = /** @class */ (function (_super) {
	    __extends(MessageBox, _super);
	    function MessageBox(config) {
	        var _this = _super.call(this, config) || this;
	        _this.message = config.message;
	        return _this;
	    }
	    MessageBox.prototype.postConstruct = function () {
	        var _this = this;
	        var messageBodyComp = new MessageBody();
	        this.addFeature(this.getContext(), messageBodyComp);
	        messageBodyComp.setMessage(this.message);
	        this.setBodyComponent(messageBodyComp);
	        _super.prototype.postConstruct.call(this);
	        this.addDestroyableEventListener(messageBodyComp, 'onBtOk', function () { return _this.close(); });
	    };
	    return MessageBox;
	}(agDialog_1.AgDialog));
	exports.MessageBox = MessageBox;
	var MessageBody = /** @class */ (function (_super) {
	    __extends(MessageBody, _super);
	    function MessageBody() {
	        return _super.call(this, MessageBody.TEMPLATE) || this;
	    }
	    MessageBody.prototype.setMessage = function (message) {
	        this.eCenter.innerText = message;
	    };
	    MessageBody.prototype.postConstruct = function () {
	        this.addDestroyableEventListener(this.eOk, 'click', this.onBtOk.bind(this));
	    };
	    MessageBody.prototype.onBtOk = function () {
	        this.dispatchEvent({ type: 'onBtOk' });
	    };
	    MessageBody.TEMPLATE = "<div class=\"ag-message-box\">\n            <div ref=\"eCenter\" class=\"ag-message-box-content\"></div>\n            <div ref=\"eButtons\" class=\"ag-message-box-button-bar\">\n                <button ref=\"eOk\">OK</button>\n            </div>\n        </div>";
	    __decorate([
	        componentAnnotations_1.RefSelector('eCenter'),
	        __metadata("design:type", HTMLElement)
	    ], MessageBody.prototype, "eCenter", void 0);
	    __decorate([
	        componentAnnotations_1.RefSelector('eOk'),
	        __metadata("design:type", HTMLElement)
	    ], MessageBody.prototype, "eOk", void 0);
	    __decorate([
	        context_1.PostConstruct,
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], MessageBody.prototype, "postConstruct", null);
	    return MessageBody;
	}(component_1.Component));


/***/ },
/* 1418 */
/***/ function(module, exports, __webpack_require__) {

	// ag-grid-react v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(2);
	var ReactDOM = __webpack_require__(51);
	var PropTypes = __webpack_require__(4);
	var AgGrid = __webpack_require__(163);
	var ag_grid_community_1 = __webpack_require__(163);
	var agGridColumn_1 = __webpack_require__(684);
	var reactComponent_1 = __webpack_require__(1421);
	var changeDetectionService_1 = __webpack_require__(1419);
	var legacyReactComponent_1 = __webpack_require__(1420);
	var AgGridReact = /** @class */ (function (_super) {
	    __extends(AgGridReact, _super);
	    function AgGridReact(props, state) {
	        var _this = _super.call(this, props, state) || this;
	        _this.props = props;
	        _this.state = state;
	        _this.changeDetectionService = new changeDetectionService_1.ChangeDetectionService();
	        _this.api = null;
	        _this.portals = [];
	        _this.hasPendingPortalUpdate = false;
	        return _this;
	    }
	    AgGridReact.prototype.render = function () {
	        var _this = this;
	        return React.createElement("div", {
	            style: this.createStyleForDiv(),
	            ref: function (e) {
	                _this.eGridDiv = e;
	            }
	        }, this.portals);
	    };
	    AgGridReact.prototype.createStyleForDiv = function () {
	        var style = { height: "100%" };
	        // allow user to override styles
	        var containerStyle = this.props.containerStyle;
	        if (containerStyle) {
	            Object.keys(containerStyle).forEach(function (key) {
	                style[key] = containerStyle[key];
	            });
	        }
	        return style;
	    };
	    AgGridReact.prototype.componentDidMount = function () {
	        var gridParams = {
	            seedBeanInstances: {
	                agGridReact: this
	            }
	        };
	        var gridOptions = this.props.gridOptions || {};
	        if (agGridColumn_1.AgGridColumn.hasChildColumns(this.props)) {
	            gridOptions.columnDefs = agGridColumn_1.AgGridColumn.mapChildColumnDefs(this.props);
	        }
	        this.gridOptions = AgGrid.ComponentUtil.copyAttributesToGridOptions(gridOptions, this.props);
	        // don't need the return value
	        new AgGrid.Grid(this.eGridDiv, this.gridOptions, gridParams);
	        this.api = this.gridOptions.api;
	        this.columnApi = this.gridOptions.columnApi;
	    };
	    AgGridReact.prototype.shouldComponentUpdate = function () {
	        // we want full control of the dom, as ag-Grid doesn't use React internally,
	        // so for performance reasons we tell React we don't need render called after
	        // property changes.
	        return false;
	    };
	    AgGridReact.prototype.waitForInstance = function (reactComponent, resolve, runningTime) {
	        var _this = this;
	        if (runningTime === void 0) { runningTime = 0; }
	        // if the grid has been destroyed in the meantime just resolve
	        if (!this.api) {
	            resolve(null);
	            return;
	        }
	        if (reactComponent.isStatelessComponent() && reactComponent.statelessComponentRendered()) {
	            resolve(null);
	        }
	        else if (!reactComponent.isStatelessComponent() && reactComponent.getFrameworkComponentInstance()) {
	            resolve(null);
	        }
	        else {
	            if (runningTime >= AgGridReact.MAX_COMPONENT_CREATION_TIME) {
	                console.error("ag-Grid: React Component '" + reactComponent.getReactComponentName() + "' not created within " + AgGridReact.MAX_COMPONENT_CREATION_TIME + "ms");
	                return;
	            }
	            window.setTimeout(function () { return _this.waitForInstance(reactComponent, resolve, runningTime + 5); }, 5);
	        }
	    };
	    /**
	     * Mounts a react portal for components registered under the componentFramework.
	     * We do this because we want all portals to be in the same tree - in order to get
	     * Context to work properly.
	     */
	    AgGridReact.prototype.mountReactPortal = function (portal, reactComponent, resolve) {
	        this.portals = this.portals.concat([portal]);
	        this.batchUpdate(this.waitForInstance(reactComponent, resolve));
	    };
	    AgGridReact.prototype.batchUpdate = function (callback) {
	        var _this = this;
	        if (this.hasPendingPortalUpdate) {
	            return callback && callback();
	        }
	        setTimeout(function () {
	            if (_this.api) { // destroyed?
	                _this.forceUpdate(function () {
	                    callback && callback();
	                    _this.hasPendingPortalUpdate = false;
	                });
	            }
	        });
	        this.hasPendingPortalUpdate = true;
	    };
	    AgGridReact.prototype.destroyPortal = function (portal) {
	        this.portals = this.portals.filter(function (curPortal) { return curPortal !== portal; });
	        this.batchUpdate();
	    };
	    AgGridReact.prototype.getStrategyTypeForProp = function (propKey) {
	        if (propKey === 'rowData') {
	            // for row data we either return the supplied strategy, or:
	            // if deltaRowDataMode we default to IdentityChecks,
	            // if not we default to DeepValueChecks (with the rest of the properties)
	            if (!!this.props.rowDataChangeDetectionStrategy) {
	                return this.props.rowDataChangeDetectionStrategy;
	            }
	            else if (this.props['deltaRowDataMode']) {
	                return changeDetectionService_1.ChangeDetectionStrategyType.IdentityCheck;
	            }
	        }
	        // all non row data properties will default to DeepValueCheck
	        return changeDetectionService_1.ChangeDetectionStrategyType.DeepValueCheck;
	    };
	    AgGridReact.prototype.componentWillReceiveProps = function (nextProps) {
	        var changes = {};
	        this.extractGridPropertyChanges(nextProps, changes);
	        this.extractDeclarativeColDefChanges(nextProps, changes);
	        AgGrid.ComponentUtil.processOnChange(changes, this.gridOptions, this.api, this.columnApi);
	    };
	    AgGridReact.prototype.extractDeclarativeColDefChanges = function (nextProps, changes) {
	        var debugLogging = !!nextProps.debug;
	        if (agGridColumn_1.AgGridColumn.hasChildColumns(nextProps)) {
	            var detectionStrategy = this.changeDetectionService.getStrategy(changeDetectionService_1.ChangeDetectionStrategyType.DeepValueCheck);
	            var currentColDefs = this.gridOptions.columnDefs;
	            var newColDefs = agGridColumn_1.AgGridColumn.mapChildColumnDefs(nextProps);
	            if (!detectionStrategy.areEqual(currentColDefs, newColDefs)) {
	                if (debugLogging) {
	                    console.log("agGridReact: colDefs definitions changed");
	                }
	                changes['columnDefs'] =
	                    {
	                        previousValue: this.gridOptions.columnDefs,
	                        currentValue: agGridColumn_1.AgGridColumn.mapChildColumnDefs(nextProps)
	                    };
	            }
	        }
	    };
	    AgGridReact.prototype.extractGridPropertyChanges = function (nextProps, changes) {
	        var _this = this;
	        var debugLogging = !!nextProps.debug;
	        var changedKeys = Object.keys(nextProps);
	        changedKeys.forEach(function (propKey) {
	            if (AgGrid.ComponentUtil.ALL_PROPERTIES.indexOf(propKey) !== -1) {
	                var changeDetectionStrategy = _this.changeDetectionService.getStrategy(_this.getStrategyTypeForProp(propKey));
	                if (!changeDetectionStrategy.areEqual(_this.props[propKey], nextProps[propKey])) {
	                    if (debugLogging) {
	                        console.log("agGridReact: [" + propKey + "] property changed");
	                    }
	                    changes[propKey] = {
	                        previousValue: _this.props[propKey],
	                        currentValue: nextProps[propKey]
	                    };
	                }
	            }
	        });
	        AgGrid.ComponentUtil.getEventCallbacks().forEach(function (funcName) {
	            if (_this.props[funcName] !== nextProps[funcName]) {
	                if (debugLogging) {
	                    console.log("agGridReact: [" + funcName + "] event callback changed");
	                }
	                changes[funcName] = {
	                    previousValue: _this.props[funcName],
	                    currentValue: nextProps[funcName]
	                };
	            }
	        });
	    };
	    AgGridReact.prototype.componentWillUnmount = function () {
	        if (this.api) {
	            this.api.destroy();
	            this.api = null;
	        }
	    };
	    AgGridReact.MAX_COMPONENT_CREATION_TIME = 1000; // a second should be more than enough to instantiate a component
	    return AgGridReact;
	}(React.Component));
	exports.AgGridReact = AgGridReact;
	AgGridReact.propTypes = {
	    gridOptions: PropTypes.object
	};
	addProperties(AgGrid.ComponentUtil.getEventCallbacks(), PropTypes.func);
	addProperties(AgGrid.ComponentUtil.BOOLEAN_PROPERTIES, PropTypes.bool);
	addProperties(AgGrid.ComponentUtil.STRING_PROPERTIES, PropTypes.string);
	addProperties(AgGrid.ComponentUtil.OBJECT_PROPERTIES, PropTypes.object);
	addProperties(AgGrid.ComponentUtil.ARRAY_PROPERTIES, PropTypes.array);
	addProperties(AgGrid.ComponentUtil.NUMBER_PROPERTIES, PropTypes.number);
	addProperties(AgGrid.ComponentUtil.FUNCTION_PROPERTIES, PropTypes.func);
	function addProperties(listOfProps, propType) {
	    listOfProps.forEach(function (propKey) {
	        AgGridReact[propKey] = propType;
	    });
	}
	var ReactFrameworkComponentWrapper = /** @class */ (function (_super) {
	    __extends(ReactFrameworkComponentWrapper, _super);
	    function ReactFrameworkComponentWrapper() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ReactFrameworkComponentWrapper.prototype.createWrapper = function (UserReactComponent) {
	        // at some point soon unstable_renderSubtreeIntoContainer is going to be dropped (and in a minor release at that)
	        // this uses the existing mechanism as long as possible, but switches over to using Portals when
	        // unstable_renderSubtreeIntoContainer is no longer an option
	        return this.useLegacyReact() ?
	            new legacyReactComponent_1.LegacyReactComponent(UserReactComponent, this.agGridReact) :
	            new reactComponent_1.ReactComponent(UserReactComponent, this.agGridReact);
	    };
	    ReactFrameworkComponentWrapper.prototype.useLegacyReact = function () {
	        // force use of react next (ie portals) if unstable_renderSubtreeIntoContainer is no longer present
	        // or if the user elects to try it
	        return (typeof ReactDOM.unstable_renderSubtreeIntoContainer !== "function")
	            || (this.agGridReact && this.agGridReact.gridOptions && !this.agGridReact.gridOptions.reactNext);
	    };
	    __decorate([
	        ag_grid_community_1.Autowired("agGridReact"),
	        __metadata("design:type", AgGridReact)
	    ], ReactFrameworkComponentWrapper.prototype, "agGridReact", void 0);
	    ReactFrameworkComponentWrapper = __decorate([
	        ag_grid_community_1.Bean("frameworkComponentWrapper")
	    ], ReactFrameworkComponentWrapper);
	    return ReactFrameworkComponentWrapper;
	}(ag_grid_community_1.BaseComponentWrapper));
	AgGrid.Grid.setFrameworkBeans([ReactFrameworkComponentWrapper]);


/***/ },
/* 1419 */
/***/ function(module, exports) {

	// ag-grid-react v21.2.2
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ChangeDetectionStrategyType;
	(function (ChangeDetectionStrategyType) {
	    ChangeDetectionStrategyType["IdentityCheck"] = "IdentityCheck";
	    ChangeDetectionStrategyType["DeepValueCheck"] = "DeepValueCheck";
	    ChangeDetectionStrategyType["NoCheck"] = "NoCheck";
	})(ChangeDetectionStrategyType = exports.ChangeDetectionStrategyType || (exports.ChangeDetectionStrategyType = {}));
	var ChangeDetectionService = /** @class */ (function () {
	    function ChangeDetectionService() {
	        var _a;
	        this.strategyMap = (_a = {},
	            _a[ChangeDetectionStrategyType.DeepValueCheck] = new DeepValueStrategy(),
	            _a[ChangeDetectionStrategyType.IdentityCheck] = new SimpleFunctionalStrategy(function (a, b) { return a === b; }),
	            _a[ChangeDetectionStrategyType.NoCheck] = new SimpleFunctionalStrategy(function (a, b) { return true; }),
	            _a);
	    }
	    ChangeDetectionService.prototype.getStrategy = function (changeDetectionStrategy) {
	        return this.strategyMap[changeDetectionStrategy];
	    };
	    return ChangeDetectionService;
	}());
	exports.ChangeDetectionService = ChangeDetectionService;
	var SimpleFunctionalStrategy = /** @class */ (function () {
	    function SimpleFunctionalStrategy(strategy) {
	        this.strategy = strategy;
	    }
	    SimpleFunctionalStrategy.prototype.areEqual = function (a, b) {
	        return this.strategy(a, b);
	    };
	    return SimpleFunctionalStrategy;
	}());
	var DeepValueStrategy = /** @class */ (function () {
	    function DeepValueStrategy() {
	    }
	    DeepValueStrategy.prototype.areEqual = function (a, b) {
	        return DeepValueStrategy.areEquivalent(DeepValueStrategy.copy(a), DeepValueStrategy.copy(b));
	    };
	    /*
	     * deeper object comparison - taken from https://stackoverflow.com/questions/1068834/object-comparison-in-javascript
	     */
	    DeepValueStrategy.unwrapStringOrNumber = function (obj) {
	        return obj instanceof Number || obj instanceof String ? obj.valueOf() : obj;
	    };
	    // sigh, here for ie compatibility
	    DeepValueStrategy.copy = function (value) {
	        if (!value) {
	            return value;
	        }
	        if (Array.isArray(value)) {
	            // shallow copy the array - this will typically be either rowData or columnDefs
	            var arrayCopy = [];
	            for (var i = 0; i < value.length; i++) {
	                arrayCopy.push(this.copy(value[i]));
	            }
	            return arrayCopy;
	        }
	        // for anything without keys (boolean, string etc).
	        // Object.keys - chrome will swallow them, IE will fail (correctly, imho)
	        if (typeof value !== "object") {
	            return value;
	        }
	        return [{}, value].reduce(function (r, o) {
	            Object.keys(o).forEach(function (k) {
	                r[k] = o[k];
	            });
	            return r;
	        }, {});
	    };
	    /*
	     * slightly modified, but taken from https://stackoverflow.com/questions/1068834/object-comparison-in-javascript
	     *
	     * What we're trying to do here is determine if the property being checked has changed in _value_, not just in reference
	     *
	     * For eg, if a user updates the columnDefs via property binding, but the actual columns defs are the same before and
	     * after, then we don't want the grid to re-render
	     */
	    DeepValueStrategy.areEquivalent = function (a, b) {
	        a = DeepValueStrategy.unwrapStringOrNumber(a);
	        b = DeepValueStrategy.unwrapStringOrNumber(b);
	        if (a === b)
	            return true; //e.g. a and b both null
	        if (a === null || b === null || typeof a !== typeof b)
	            return false;
	        if (a instanceof Date) {
	            return b instanceof Date && a.valueOf() === b.valueOf();
	        }
	        if (typeof a === "function") {
	            return a.toString() === b.toString();
	        }
	        if (typeof a !== "object") {
	            return a == b; //for boolean, number, string, function, xml
	        }
	        var newA = a.areEquivPropertyTracking === undefined, newB = b.areEquivPropertyTracking === undefined;
	        try {
	            var prop = void 0;
	            if (newA) {
	                a.areEquivPropertyTracking = [];
	            }
	            else if (a.areEquivPropertyTracking.some(function (other) {
	                return other === b;
	            }))
	                return true;
	            if (newB) {
	                b.areEquivPropertyTracking = [];
	            }
	            else if (b.areEquivPropertyTracking.some(function (other) { return other === a; })) {
	                return true;
	            }
	            a.areEquivPropertyTracking.push(b);
	            b.areEquivPropertyTracking.push(a);
	            var tmp = {};
	            for (prop in a)
	                if (prop != "areEquivPropertyTracking") {
	                    tmp[prop] = null;
	                }
	            for (prop in b)
	                if (prop != "areEquivPropertyTracking") {
	                    tmp[prop] = null;
	                }
	            for (prop in tmp) {
	                if (!this.areEquivalent(a[prop], b[prop])) {
	                    return false;
	                }
	            }
	            return true;
	        }
	        finally {
	            if (newA)
	                delete a.areEquivPropertyTracking;
	            if (newB)
	                delete b.areEquivPropertyTracking;
	        }
	    };
	    return DeepValueStrategy;
	}());


/***/ },
/* 1420 */
/***/ function(module, exports, __webpack_require__) {

	// ag-grid-react v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(2);
	var ReactDOM = __webpack_require__(51);
	var AgGrid = __webpack_require__(163);
	var ag_grid_community_1 = __webpack_require__(163);
	var baseReactComponent_1 = __webpack_require__(685);
	var utils_1 = __webpack_require__(686);
	var LegacyReactComponent = /** @class */ (function (_super) {
	    __extends(LegacyReactComponent, _super);
	    function LegacyReactComponent(reactComponent, parentComponent) {
	        var _this = _super.call(this) || this;
	        _this.reactComponent = reactComponent;
	        _this.parentComponent = parentComponent;
	        return _this;
	    }
	    LegacyReactComponent.prototype.getFrameworkComponentInstance = function () {
	        return this.componentInstance;
	    };
	    LegacyReactComponent.prototype.getReactComponentName = function () {
	        return this.reactComponent.name;
	    };
	    LegacyReactComponent.prototype.init = function (params) {
	        var _this = this;
	        return new ag_grid_community_1.Promise(function (resolve) {
	            _this.eParentElement = document.createElement(_this.parentComponent.props.componentWrappingElement || 'div');
	            AgGrid.Utils.addCssClass(_this.eParentElement, 'ag-react-container');
	            // so user can have access to the react container,
	            // to add css class or style
	            params.reactContainer = _this.eParentElement;
	            _this.createReactComponentLegacy(params, resolve);
	        });
	    };
	    LegacyReactComponent.prototype.getGui = function () {
	        return this.eParentElement;
	    };
	    LegacyReactComponent.prototype.destroy = function () {
	        // only attempt to unmount if not using a doc fragment
	        ReactDOM.unmountComponentAtNode(this.eParentElement);
	    };
	    LegacyReactComponent.prototype.createReactComponentLegacy = function (params, resolve) {
	        var self = this;
	        var ReactComponent = React.createElement(this.reactComponent, params);
	        if (!this.parentComponent) {
	            // MUST be a function, not an arrow function
	            ReactDOM.render(ReactComponent, this.eParentElement, function () {
	                // @ts-ignore
	                self.componentInstance = this;
	                self.addParentContainerStyleAndClasses();
	                resolve(null);
	            });
	        }
	        else {
	            // MUST be a function, not an arrow function
	            ReactDOM.unstable_renderSubtreeIntoContainer(this.parentComponent, ReactComponent, this.eParentElement, function () {
	                // @ts-ignore
	                self.componentInstance = this;
	                self.addParentContainerStyleAndClasses();
	                resolve(null);
	            });
	        }
	    };
	    LegacyReactComponent.prototype.addParentContainerStyleAndClasses = function () {
	        var _this = this;
	        if (!this.componentInstance) {
	            return;
	        }
	        if (this.componentInstance.getReactContainerStyle && this.componentInstance.getReactContainerStyle()) {
	            utils_1.assignProperties(this.eParentElement.style, this.componentInstance.getReactContainerStyle());
	        }
	        if (this.componentInstance.getReactContainerClasses && this.componentInstance.getReactContainerClasses()) {
	            var parentContainerClasses = this.componentInstance.getReactContainerClasses();
	            parentContainerClasses.forEach(function (className) { return AgGrid.Utils.addCssClass(_this.eParentElement, className); });
	        }
	    };
	    return LegacyReactComponent;
	}(baseReactComponent_1.BaseReactComponent));
	exports.LegacyReactComponent = LegacyReactComponent;


/***/ },
/* 1421 */
/***/ function(module, exports, __webpack_require__) {

	// ag-grid-react v21.2.2
	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(2);
	var ReactDOM = __webpack_require__(51);
	var AgGrid = __webpack_require__(163);
	var ag_grid_community_1 = __webpack_require__(163);
	var baseReactComponent_1 = __webpack_require__(685);
	var utils_1 = __webpack_require__(686);
	var ReactComponent = /** @class */ (function (_super) {
	    __extends(ReactComponent, _super);
	    function ReactComponent(reactComponent, parentComponent) {
	        var _this = _super.call(this) || this;
	        _this.portal = null;
	        _this.componentWrappingElement = 'div';
	        _this.unwrapComponent = true;
	        _this.reactComponent = reactComponent;
	        _this.parentComponent = parentComponent;
	        _this.orphans = [];
	        _this.statelessComponent = ReactComponent.isStateless(_this.reactComponent);
	        return _this;
	    }
	    ReactComponent.prototype.getFrameworkComponentInstance = function () {
	        return this.componentInstance;
	    };
	    ReactComponent.prototype.isStatelessComponent = function () {
	        return this.statelessComponent;
	    };
	    ReactComponent.prototype.getReactComponentName = function () {
	        return this.reactComponent.name;
	    };
	    ReactComponent.prototype.init = function (params) {
	        var _this = this;
	        return new ag_grid_community_1.Promise(function (resolve) {
	            _this.unwrapComponent = false;
	            _this.eParentElement = _this.createParentElement(params);
	            _this.createReactComponent(params, resolve);
	        });
	    };
	    ReactComponent.prototype.getGui = function () {
	        if (this.unwrapComponent) {
	            var fragment = document.createDocumentFragment();
	            if (this.orphans.length > 0) {
	                for (var _i = 0, _a = this.orphans; _i < _a.length; _i++) {
	                    var orphan = _a[_i];
	                    fragment.appendChild(orphan);
	                }
	            }
	            else {
	                while (this.eParentElement.firstChild) {
	                    this.orphans.push(this.eParentElement.firstChild);
	                    fragment.appendChild(this.eParentElement.firstChild);
	                }
	            }
	            return fragment;
	        }
	        else {
	            return this.eParentElement;
	        }
	    };
	    ReactComponent.prototype.destroy = function () {
	        if (this.unwrapComponent) {
	            for (var _i = 0, _a = this.orphans; _i < _a.length; _i++) {
	                var orphan = _a[_i];
	                this.eParentElement.appendChild(orphan);
	            }
	        }
	        return this.parentComponent.destroyPortal(this.portal);
	    };
	    ReactComponent.prototype.createReactComponent = function (params, resolve) {
	        var _this = this;
	        if (!this.statelessComponent) {
	            // grab hold of the actual instance created - we use a react ref for this as there is no other mechanism to
	            // retrieve the created instance from either createPortal or render
	            params.ref = function (element) {
	                _this.componentInstance = element;
	                _this.addParentContainerStyleAndClasses();
	            };
	        }
	        var ReactComponent = React.createElement(this.reactComponent, params);
	        var portal = ReactDOM.createPortal(ReactComponent, this.eParentElement);
	        this.portal = portal;
	        this.parentComponent.mountReactPortal(portal, this, resolve);
	    };
	    ReactComponent.prototype.addParentContainerStyleAndClasses = function () {
	        var _this = this;
	        if (!this.componentInstance) {
	            return;
	        }
	        if (this.componentInstance.getReactContainerStyle && this.componentInstance.getReactContainerStyle()) {
	            utils_1.assignProperties(this.eParentElement.style, this.componentInstance.getReactContainerStyle());
	        }
	        if (this.componentInstance.getReactContainerClasses && this.componentInstance.getReactContainerClasses()) {
	            var parentContainerClasses = this.componentInstance.getReactContainerClasses();
	            parentContainerClasses.forEach(function (className) { return AgGrid.Utils.addCssClass(_this.eParentElement, className); });
	        }
	    };
	    ReactComponent.prototype.createParentElement = function (params) {
	        var eParentElement = document.createElement(this.parentComponent.props.componentWrappingElement || 'div');
	        if (!this.unwrapComponent) {
	            AgGrid.Utils.addCssClass(eParentElement, 'ag-react-container');
	            // so user can have access to the react container, to add css class or style
	            params.reactContainer = eParentElement;
	        }
	        return eParentElement;
	    };
	    ReactComponent.prototype.statelessComponentRendered = function () {
	        return this.eParentElement.childElementCount > 0;
	    };
	    ReactComponent.isStateless = function (Component) {
	        return (typeof Component === 'function' &&
	            !(Component.prototype && Component.prototype.isReactComponent));
	    };
	    return ReactComponent;
	}(baseReactComponent_1.BaseReactComponent));
	exports.ReactComponent = ReactComponent;


/***/ },
/* 1422 */
/***/ function(module, exports, __webpack_require__) {

	exports.AgGridReact = __webpack_require__(1418).AgGridReact;
	exports.AgGridColumn = __webpack_require__(684).AgGridColumn;


/***/ },
/* 1423 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	// rawAsap provides everything we need except exception management.
	var rawAsap = __webpack_require__(687);
	// RawTasks are recycled to reduce GC churn.
	var freeTasks = [];
	// We queue errors to ensure they are thrown in right order (FIFO).
	// Array-as-queue is good enough here, since we are just dealing with exceptions.
	var pendingErrors = [];
	var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);
	
	function throwFirstError() {
	    if (pendingErrors.length) {
	        throw pendingErrors.shift();
	    }
	}
	
	/**
	 * Calls a task as soon as possible after returning, in its own event, with priority
	 * over other events like animation, reflow, and repaint. An error thrown from an
	 * event will not interrupt, nor even substantially slow down the processing of
	 * other events, but will be rather postponed to a lower priority event.
	 * @param {{call}} task A callable object, typically a function that takes no
	 * arguments.
	 */
	module.exports = asap;
	function asap(task) {
	    var rawTask;
	    if (freeTasks.length) {
	        rawTask = freeTasks.pop();
	    } else {
	        rawTask = new RawTask();
	    }
	    rawTask.task = task;
	    rawAsap(rawTask);
	}
	
	// We wrap tasks with recyclable task objects.  A task object implements
	// `call`, just like a function.
	function RawTask() {
	    this.task = null;
	}
	
	// The sole purpose of wrapping the task is to catch the exception and recycle
	// the task object after its single use.
	RawTask.prototype.call = function () {
	    try {
	        this.task.call();
	    } catch (error) {
	        if (asap.onerror) {
	            // This hook exists purely for testing purposes.
	            // Its name will be periodically randomized to break any code that
	            // depends on its existence.
	            asap.onerror(error);
	        } else {
	            // In a web browser, exceptions are not fatal. However, to avoid
	            // slowing down the queue of pending tasks, we rethrow the error in a
	            // lower priority turn.
	            pendingErrors.push(error);
	            requestErrorThrow();
	        }
	    } finally {
	        this.task = null;
	        freeTasks[freeTasks.length] = this;
	    }
	};


/***/ },
/* 1424 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(760);
	
	var callBind = __webpack_require__(1425);
	
	var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));
	
	module.exports = function callBoundIntrinsic(name, allowMissing) {
		var intrinsic = GetIntrinsic(name, !!allowMissing);
		if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
			return callBind(intrinsic);
		}
		return intrinsic;
	};


/***/ },
/* 1425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(170);
	var GetIntrinsic = __webpack_require__(760);
	
	var $apply = GetIntrinsic('%Function.prototype.apply%');
	var $call = GetIntrinsic('%Function.prototype.call%');
	var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);
	
	var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
	
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
		} catch (e) {
			// IE 8 has a broken defineProperty
			$defineProperty = null;
		}
	}
	
	module.exports = function callBind() {
		return $reflectApply(bind, $call, arguments);
	};
	
	var applyBind = function applyBind() {
		return $reflectApply(bind, $apply, arguments);
	};
	
	if ($defineProperty) {
		$defineProperty(module.exports, 'apply', { value: applyBind });
	} else {
		module.exports.apply = applyBind;
	}


/***/ },
/* 1426 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 1427 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hyphenateProperty;
	
	var _hyphenateStyleName = __webpack_require__(767);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hyphenateProperty(property) {
	  return (0, _hyphenateStyleName2.default)(property);
	}
	module.exports = exports['default'];

/***/ },
/* 1428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var isInBrowser = _interopDefault(__webpack_require__(769));
	var _toConsumableArray = _interopDefault(__webpack_require__(115));
	
	// Export javascript style and css style vendor prefixes.
	var js = '';
	var css = '';
	var vendor = '';
	var browser = '';
	var isTouch = isInBrowser && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.
	
	if (isInBrowser) {
	  // Order matters. We need to check Webkit the last one because
	  // other vendors use to add Webkit prefixes to some properties
	  var jsCssMap = {
	    Moz: '-moz-',
	    ms: '-ms-',
	    O: '-o-',
	    Webkit: '-webkit-'
	  };
	
	  var _document$createEleme = document.createElement('p'),
	      style = _document$createEleme.style;
	
	  var testProp = 'Transform';
	
	  for (var key in jsCssMap) {
	    if (key + testProp in style) {
	      js = key;
	      css = jsCssMap[key];
	      break;
	    }
	  } // Correctly detect the Edge browser.
	
	
	  if (js === 'Webkit' && 'msHyphens' in style) {
	    js = 'ms';
	    css = jsCssMap.ms;
	    browser = 'edge';
	  } // Correctly detect the Safari browser.
	
	
	  if (js === 'Webkit' && '-apple-trailing-word' in style) {
	    vendor = 'apple';
	  }
	}
	/**
	 * Vendor prefix string for the current browser.
	 *
	 * @type {{js: String, css: String, vendor: String, browser: String}}
	 * @api public
	 */
	
	
	var prefix = {
	  js: js,
	  css: css,
	  vendor: vendor,
	  browser: browser,
	  isTouch: isTouch
	};
	
	/**
	 * Test if a keyframe at-rule should be prefixed or not
	 *
	 * @param {String} vendor prefix string for the current browser.
	 * @return {String}
	 * @api public
	 */
	
	function supportedKeyframes(key) {
	  // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
	  if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
	  // https://caniuse.com/#search=keyframes
	
	  if (prefix.js === 'ms') return key;
	  return "@" + prefix.css + "keyframes" + key.substr(10);
	}
	
	// https://caniuse.com/#search=appearance
	
	var appearence = {
	  noPrefill: ['appearance'],
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'appearance') return false;
	    if (prefix.js === 'ms') return "-webkit-" + prop;
	    return prefix.css + prop;
	  }
	};
	
	// https://caniuse.com/#search=color-adjust
	
	var colorAdjust = {
	  noPrefill: ['color-adjust'],
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'color-adjust') return false;
	    if (prefix.js === 'Webkit') return prefix.css + "print-" + prop;
	    return prop;
	  }
	};
	
	var regExp = /[-\s]+(.)?/g;
	/**
	 * Replaces the letter with the capital letter
	 *
	 * @param {String} match
	 * @param {String} c
	 * @return {String}
	 * @api private
	 */
	
	function toUpper(match, c) {
	  return c ? c.toUpperCase() : '';
	}
	/**
	 * Convert dash separated strings to camel-cased.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	
	function camelize(str) {
	  return str.replace(regExp, toUpper);
	}
	
	/**
	 * Convert dash separated strings to pascal cased.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	function pascalize(str) {
	  return camelize("-" + str);
	}
	
	// but we can use a longhand property instead.
	// https://caniuse.com/#search=mask
	
	var mask = {
	  noPrefill: ['mask'],
	  supportedProperty: function supportedProperty(prop, style) {
	    if (!/^mask/.test(prop)) return false;
	
	    if (prefix.js === 'Webkit') {
	      var longhand = 'mask-image';
	
	      if (camelize(longhand) in style) {
	        return prop;
	      }
	
	      if (prefix.js + pascalize(longhand) in style) {
	        return prefix.css + prop;
	      }
	    }
	
	    return prop;
	  }
	};
	
	// https://caniuse.com/#search=text-orientation
	
	var textOrientation = {
	  noPrefill: ['text-orientation'],
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'text-orientation') return false;
	
	    if (prefix.vendor === 'apple' && !prefix.isTouch) {
	      return prefix.css + prop;
	    }
	
	    return prop;
	  }
	};
	
	// https://caniuse.com/#search=transform
	
	var transform = {
	  noPrefill: ['transform'],
	  supportedProperty: function supportedProperty(prop, style, options) {
	    if (prop !== 'transform') return false;
	
	    if (options.transform) {
	      return prop;
	    }
	
	    return prefix.css + prop;
	  }
	};
	
	// https://caniuse.com/#search=transition
	
	var transition = {
	  noPrefill: ['transition'],
	  supportedProperty: function supportedProperty(prop, style, options) {
	    if (prop !== 'transition') return false;
	
	    if (options.transition) {
	      return prop;
	    }
	
	    return prefix.css + prop;
	  }
	};
	
	// https://caniuse.com/#search=writing-mode
	
	var writingMode = {
	  noPrefill: ['writing-mode'],
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'writing-mode') return false;
	
	    if (prefix.js === 'Webkit' || prefix.js === 'ms' && prefix.browser !== 'edge') {
	      return prefix.css + prop;
	    }
	
	    return prop;
	  }
	};
	
	// https://caniuse.com/#search=user-select
	
	var userSelect = {
	  noPrefill: ['user-select'],
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'user-select') return false;
	
	    if (prefix.js === 'Moz' || prefix.js === 'ms' || prefix.vendor === 'apple') {
	      return prefix.css + prop;
	    }
	
	    return prop;
	  }
	};
	
	// https://caniuse.com/#search=multicolumn
	// https://github.com/postcss/autoprefixer/issues/491
	// https://github.com/postcss/autoprefixer/issues/177
	
	var breakPropsOld = {
	  supportedProperty: function supportedProperty(prop, style) {
	    if (!/^break-/.test(prop)) return false;
	
	    if (prefix.js === 'Webkit') {
	      var jsProp = "WebkitColumn" + pascalize(prop);
	      return jsProp in style ? prefix.css + "column-" + prop : false;
	    }
	
	    if (prefix.js === 'Moz') {
	      var _jsProp = "page" + pascalize(prop);
	
	      return _jsProp in style ? "page-" + prop : false;
	    }
	
	    return false;
	  }
	};
	
	// See https://github.com/postcss/autoprefixer/issues/324.
	
	var inlineLogicalOld = {
	  supportedProperty: function supportedProperty(prop, style) {
	    if (!/^(border|margin|padding)-inline/.test(prop)) return false;
	    if (prefix.js === 'Moz') return prop;
	    var newProp = prop.replace('-inline', '');
	    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
	  }
	};
	
	// Camelization is required because we can't test using.
	// CSS syntax for e.g. in FF.
	
	var unprefixed = {
	  supportedProperty: function supportedProperty(prop, style) {
	    return camelize(prop) in style ? prop : false;
	  }
	};
	
	var prefixed = {
	  supportedProperty: function supportedProperty(prop, style) {
	    var pascalized = pascalize(prop); // Return custom CSS variable without prefixing.
	
	    if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.
	
	    if (prop[0] === '-' && prop[1] === '-') return prop;
	    if (prefix.js + pascalized in style) return prefix.css + prop; // Try webkit fallback.
	
	    if (prefix.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
	    return false;
	  }
	};
	
	// https://caniuse.com/#search=scroll-snap
	
	var scrollSnap = {
	  supportedProperty: function supportedProperty(prop) {
	    if (prop.substring(0, 11) !== 'scroll-snap') return false;
	
	    if (prefix.js === 'ms') {
	      return "" + prefix.css + prop;
	    }
	
	    return prop;
	  }
	};
	
	// https://caniuse.com/#search=overscroll-behavior
	
	var overscrollBehavior = {
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'overscroll-behavior') return false;
	
	    if (prefix.js === 'ms') {
	      return prefix.css + "scroll-chaining";
	    }
	
	    return prop;
	  }
	};
	
	var propMap = {
	  'flex-grow': 'flex-positive',
	  'flex-shrink': 'flex-negative',
	  'flex-basis': 'flex-preferred-size',
	  'justify-content': 'flex-pack',
	  order: 'flex-order',
	  'align-items': 'flex-align',
	  'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.
	
	}; // Support old flex spec from 2012.
	
	var flex2012 = {
	  supportedProperty: function supportedProperty(prop, style) {
	    var newProp = propMap[prop];
	    if (!newProp) return false;
	    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
	  }
	};
	
	var propMap$1 = {
	  flex: 'box-flex',
	  'flex-grow': 'box-flex',
	  'flex-direction': ['box-orient', 'box-direction'],
	  order: 'box-ordinal-group',
	  'align-items': 'box-align',
	  'flex-flow': ['box-orient', 'box-direction'],
	  'justify-content': 'box-pack'
	};
	var propKeys = Object.keys(propMap$1);
	
	var prefixCss = function prefixCss(p) {
	  return prefix.css + p;
	}; // Support old flex spec from 2009.
	
	
	var flex2009 = {
	  supportedProperty: function supportedProperty(prop, style, _ref) {
	    var multiple = _ref.multiple;
	
	    if (propKeys.indexOf(prop) > -1) {
	      var newProp = propMap$1[prop];
	
	      if (!Array.isArray(newProp)) {
	        return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
	      }
	
	      if (!multiple) return false;
	
	      for (var i = 0; i < newProp.length; i++) {
	        if (!(prefix.js + pascalize(newProp[0]) in style)) {
	          return false;
	        }
	      }
	
	      return newProp.map(prefixCss);
	    }
	
	    return false;
	  }
	};
	
	// plugins = [
	//   ...plugins,
	//    breakPropsOld,
	//    inlineLogicalOld,
	//    unprefixed,
	//    prefixed,
	//    scrollSnap,
	//    flex2012,
	//    flex2009
	// ]
	// Plugins without 'noPrefill' value, going last.
	// 'flex-*' plugins should be at the bottom.
	// 'flex2009' going after 'flex2012'.
	// 'prefixed' going after 'unprefixed'
	
	var plugins = [appearence, colorAdjust, mask, textOrientation, transform, transition, writingMode, userSelect, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
	var propertyDetectors = plugins.filter(function (p) {
	  return p.supportedProperty;
	}).map(function (p) {
	  return p.supportedProperty;
	});
	var noPrefill = plugins.filter(function (p) {
	  return p.noPrefill;
	}).reduce(function (a, p) {
	  a.push.apply(a, _toConsumableArray(p.noPrefill));
	  return a;
	}, []);
	
	var el;
	var cache = {};
	
	if (isInBrowser) {
	  el = document.createElement('p'); // We test every property on vendor prefix requirement.
	  // Once tested, result is cached. It gives us up to 70% perf boost.
	  // http://jsperf.com/element-style-object-access-vs-plain-object
	  //
	  // Prefill cache with known css properties to reduce amount of
	  // properties we need to feature test at runtime.
	  // http://davidwalsh.name/vendor-prefix
	
	  var computed = window.getComputedStyle(document.documentElement, '');
	
	  for (var key$1 in computed) {
	    // eslint-disable-next-line no-restricted-globals
	    if (!isNaN(key$1)) cache[computed[key$1]] = computed[key$1];
	  } // Properties that cannot be correctly detected using the
	  // cache prefill method.
	
	
	  noPrefill.forEach(function (x) {
	    return delete cache[x];
	  });
	}
	/**
	 * Test if a property is supported, returns supported property with vendor
	 * prefix if required. Returns `false` if not supported.
	 *
	 * @param {String} prop dash separated
	 * @param {Object} [options]
	 * @return {String|Boolean}
	 * @api public
	 */
	
	
	function supportedProperty(prop, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  // For server-side rendering.
	  if (!el) return prop; // Remove cache for benchmark tests or return property from the cache.
	
	  if (("production") !== 'benchmark' && cache[prop] != null) {
	    return cache[prop];
	  } // Check if 'transition' or 'transform' natively supported in browser.
	
	
	  if (prop === 'transition' || prop === 'transform') {
	    options[prop] = prop in el.style;
	  } // Find a plugin for current prefix property.
	
	
	  for (var i = 0; i < propertyDetectors.length; i++) {
	    cache[prop] = propertyDetectors[i](prop, el.style, options); // Break loop, if value found.
	
	    if (cache[prop]) break;
	  } // Reset styles for current property.
	  // Firefox can even throw an error for invalid properties, e.g., "0".
	
	
	  try {
	    el.style[prop] = '';
	  } catch (err) {
	    return false;
	  }
	
	  return cache[prop];
	}
	
	var cache$1 = {};
	var transitionProperties = {
	  transition: 1,
	  'transition-property': 1,
	  '-webkit-transition': 1,
	  '-webkit-transition-property': 1
	};
	var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
	var el$1;
	/**
	 * Returns prefixed value transition/transform if needed.
	 *
	 * @param {String} match
	 * @param {String} p1
	 * @param {String} p2
	 * @return {String}
	 * @api private
	 */
	
	function prefixTransitionCallback(match, p1, p2) {
	  if (p1 === 'var') return 'var';
	  if (p1 === 'all') return 'all';
	  if (p2 === 'all') return ', all';
	  var prefixedValue = p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
	  if (!prefixedValue) return p1 || p2;
	  return prefixedValue;
	}
	
	if (isInBrowser) el$1 = document.createElement('p');
	/**
	 * Returns prefixed value if needed. Returns `false` if value is not supported.
	 *
	 * @param {String} property
	 * @param {String} value
	 * @return {String|Boolean}
	 * @api public
	 */
	
	function supportedValue(property, value) {
	  // For server-side rendering.
	  var prefixedValue = value;
	  if (!el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
	  // We want only prefixable values here.
	  // eslint-disable-next-line no-restricted-globals
	
	  if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) {
	    return prefixedValue;
	  } // Create cache key for current value.
	
	
	  var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
	
	  if (("production") !== 'benchmark' && cache$1[cacheKey] != null) {
	    return cache$1[cacheKey];
	  } // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
	
	
	  try {
	    // Test value as it is.
	    el$1.style[property] = prefixedValue;
	  } catch (err) {
	    // Return false if value not supported.
	    cache$1[cacheKey] = false;
	    return false;
	  } // If 'transition' or 'transition-property' property.
	
	
	  if (transitionProperties[property]) {
	    prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
	  } else if (el$1.style[property] === '') {
	    // Value with a vendor prefix.
	    prefixedValue = prefix.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
	
	    if (prefixedValue === '-ms-flex') el$1.style[property] = '-ms-flexbox'; // Test prefixed value.
	
	    el$1.style[property] = prefixedValue; // Return false if value not supported.
	
	    if (el$1.style[property] === '') {
	      cache$1[cacheKey] = false;
	      return false;
	    }
	  } // Reset styles for current property.
	
	
	  el$1.style[property] = ''; // Write current value to cache.
	
	  cache$1[cacheKey] = prefixedValue;
	  return cache$1[cacheKey];
	}
	
	exports.prefix = prefix;
	exports.supportedKeyframes = supportedKeyframes;
	exports.supportedProperty = supportedProperty;
	exports.supportedValue = supportedValue;


/***/ },
/* 1429 */
/***/ function(module, exports, __webpack_require__) {

	var objectKeys = __webpack_require__(952);
	var isArguments = __webpack_require__(1765);
	var is = __webpack_require__(1919);
	var isRegex = __webpack_require__(1767);
	var flags = __webpack_require__(2254);
	var isDate = __webpack_require__(1766);
	
	var getTime = Date.prototype.getTime;
	
	function deepEqual(actual, expected, options) {
	  var opts = options || {};
	
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (opts.strict ? is(actual, expected) : actual === expected) {
	    return true;
	  }
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
	  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
	    return opts.strict ? is(actual, expected) : actual == expected;
	  }
	
	  /*
	   * 7.4. For all other Object pairs, including Array objects, equivalence is
	   * determined by having the same number of owned properties (as verified
	   * with Object.prototype.hasOwnProperty.call), the same set of keys
	   * (although not necessarily the same order), equivalent values for every
	   * corresponding key, and an identical 'prototype' property. Note: this
	   * accounts for both named and indexed properties on Arrays.
	   */
	  // eslint-disable-next-line no-use-before-define
	  return objEquiv(actual, expected, opts);
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer(x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
	    return false;
	  }
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') {
	    return false;
	  }
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  /* eslint max-statements: [2, 50] */
	  var i, key;
	  if (typeof a !== typeof b) { return false; }
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }
	
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) { return false; }
	
	  if (isArguments(a) !== isArguments(b)) { return false; }
	
	  var aIsRegex = isRegex(a);
	  var bIsRegex = isRegex(b);
	  if (aIsRegex !== bIsRegex) { return false; }
	  if (aIsRegex || bIsRegex) {
	    return a.source === b.source && flags(a) === flags(b);
	  }
	
	  if (isDate(a) && isDate(b)) {
	    return getTime.call(a) === getTime.call(b);
	  }
	
	  var aIsBuffer = isBuffer(a);
	  var bIsBuffer = isBuffer(b);
	  if (aIsBuffer !== bIsBuffer) { return false; }
	  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
	    if (a.length !== b.length) { return false; }
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) { return false; }
	    }
	    return true;
	  }
	
	  if (typeof a !== typeof b) { return false; }
	
	  try {
	    var ka = objectKeys(a);
	    var kb = objectKeys(b);
	  } catch (e) { // happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates hasOwnProperty)
	  if (ka.length !== kb.length) { return false; }
	
	  // the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  // ~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i]) { return false; }
	  }
	  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) { return false; }
	  }
	
	  return true;
	}
	
	module.exports = deepEqual;


/***/ },
/* 1430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _isDisposable = __webpack_require__(452);
	
	var _isDisposable2 = _interopRequireDefault(_isDisposable);
	
	/**
	 * Represents a group of disposable resources that are disposed together.
	 */
	
	var CompositeDisposable = (function () {
	  function CompositeDisposable() {
	    for (var _len = arguments.length, disposables = Array(_len), _key = 0; _key < _len; _key++) {
	      disposables[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, CompositeDisposable);
	
	    if (Array.isArray(disposables[0]) && disposables.length === 1) {
	      disposables = disposables[0];
	    }
	
	    for (var i = 0; i < disposables.length; i++) {
	      if (!_isDisposable2['default'](disposables[i])) {
	        throw new Error('Expected a disposable');
	      }
	    }
	
	    this.disposables = disposables;
	    this.isDisposed = false;
	  }
	
	  /**
	   * Adds a disposable to the CompositeDisposable or disposes the disposable if the CompositeDisposable is disposed.
	   * @param {Disposable} item Disposable to add.
	   */
	
	  CompositeDisposable.prototype.add = function add(item) {
	    if (this.isDisposed) {
	      item.dispose();
	    } else {
	      this.disposables.push(item);
	    }
	  };
	
	  /**
	   * Removes and disposes the first occurrence of a disposable from the CompositeDisposable.
	   * @param {Disposable} item Disposable to remove.
	   * @returns {Boolean} true if found; false otherwise.
	   */
	
	  CompositeDisposable.prototype.remove = function remove(item) {
	    if (this.isDisposed) {
	      return false;
	    }
	
	    var index = this.disposables.indexOf(item);
	    if (index === -1) {
	      return false;
	    }
	
	    this.disposables.splice(index, 1);
	    item.dispose();
	    return true;
	  };
	
	  /**
	   * Disposes all disposables in the group and removes them from the group.
	   */
	
	  CompositeDisposable.prototype.dispose = function dispose() {
	    if (this.isDisposed) {
	      return;
	    }
	
	    var len = this.disposables.length;
	    var currentDisposables = new Array(len);
	    for (var i = 0; i < len; i++) {
	      currentDisposables[i] = this.disposables[i];
	    }
	
	    this.isDisposed = true;
	    this.disposables = [];
	    this.length = 0;
	
	    for (var i = 0; i < len; i++) {
	      currentDisposables[i].dispose();
	    }
	  };
	
	  return CompositeDisposable;
	})();
	
	exports['default'] = CompositeDisposable;
	module.exports = exports['default'];

/***/ },
/* 1431 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var noop = function noop() {};
	
	/**
	 * The basic disposable.
	 */
	
	var Disposable = (function () {
	  _createClass(Disposable, null, [{
	    key: "empty",
	    value: { dispose: noop },
	    enumerable: true
	  }]);
	
	  function Disposable(action) {
	    _classCallCheck(this, Disposable);
	
	    this.isDisposed = false;
	    this.action = action || noop;
	  }
	
	  Disposable.prototype.dispose = function dispose() {
	    if (!this.isDisposed) {
	      this.action.call(null);
	      this.isDisposed = true;
	    }
	  };
	
	  return Disposable;
	})();
	
	exports["default"] = Disposable;
	module.exports = exports["default"];

/***/ },
/* 1432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _isDisposable = __webpack_require__(452);
	
	var _isDisposable2 = _interopRequireDefault(_isDisposable);
	
	var SerialDisposable = (function () {
	  function SerialDisposable() {
	    _classCallCheck(this, SerialDisposable);
	
	    this.isDisposed = false;
	    this.current = null;
	  }
	
	  /**
	   * Gets the underlying disposable.
	   * @return The underlying disposable.
	   */
	
	  SerialDisposable.prototype.getDisposable = function getDisposable() {
	    return this.current;
	  };
	
	  /**
	   * Sets the underlying disposable.
	   * @param {Disposable} value The new underlying disposable.
	   */
	
	  SerialDisposable.prototype.setDisposable = function setDisposable() {
	    var value = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];
	
	    if (value != null && !_isDisposable2['default'](value)) {
	      throw new Error('Expected either an empty value or a valid disposable');
	    }
	
	    var isDisposed = this.isDisposed;
	    var previous = undefined;
	
	    if (!isDisposed) {
	      previous = this.current;
	      this.current = value;
	    }
	
	    if (previous) {
	      previous.dispose();
	    }
	
	    if (isDisposed && value) {
	      value.dispose();
	    }
	  };
	
	  /**
	   * Disposes the underlying disposable as well as all future replacements.
	   */
	
	  SerialDisposable.prototype.dispose = function dispose() {
	    if (this.isDisposed) {
	      return;
	    }
	
	    this.isDisposed = true;
	    var previous = this.current;
	    this.current = null;
	
	    if (previous) {
	      previous.dispose();
	    }
	  };
	
	  return SerialDisposable;
	})();
	
	exports['default'] = SerialDisposable;
	module.exports = exports['default'];

/***/ },
/* 1433 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _isDisposable2 = __webpack_require__(452);
	
	var _isDisposable3 = _interopRequireDefault(_isDisposable2);
	
	exports.isDisposable = _isDisposable3['default'];
	
	var _Disposable2 = __webpack_require__(1431);
	
	var _Disposable3 = _interopRequireDefault(_Disposable2);
	
	exports.Disposable = _Disposable3['default'];
	
	var _CompositeDisposable2 = __webpack_require__(1430);
	
	var _CompositeDisposable3 = _interopRequireDefault(_CompositeDisposable2);
	
	exports.CompositeDisposable = _CompositeDisposable3['default'];
	
	var _SerialDisposable2 = __webpack_require__(1432);
	
	var _SerialDisposable3 = _interopRequireDefault(_SerialDisposable2);
	
	exports.SerialDisposable = _SerialDisposable3['default'];

/***/ },
/* 1434 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _createStore = __webpack_require__(552);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _reducers = __webpack_require__(1442);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _dragDrop = __webpack_require__(328);
	
	var dragDropActions = _interopRequireWildcard(_dragDrop);
	
	var _DragDropMonitor = __webpack_require__(1435);
	
	var _DragDropMonitor2 = _interopRequireDefault(_DragDropMonitor);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DragDropManager = function () {
		function DragDropManager(createBackend) {
			var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
			_classCallCheck(this, DragDropManager);
	
			var store = (0, _createStore2.default)(_reducers2.default);
			this.context = context;
			this.store = store;
			this.monitor = new _DragDropMonitor2.default(store);
			this.registry = this.monitor.registry;
			this.backend = createBackend(this);
	
			store.subscribe(this.handleRefCountChange.bind(this));
		}
	
		_createClass(DragDropManager, [{
			key: 'handleRefCountChange',
			value: function handleRefCountChange() {
				var shouldSetUp = this.store.getState().refCount > 0;
				if (shouldSetUp && !this.isSetUp) {
					this.backend.setup();
					this.isSetUp = true;
				} else if (!shouldSetUp && this.isSetUp) {
					this.backend.teardown();
					this.isSetUp = false;
				}
			}
		}, {
			key: 'getContext',
			value: function getContext() {
				return this.context;
			}
		}, {
			key: 'getMonitor',
			value: function getMonitor() {
				return this.monitor;
			}
		}, {
			key: 'getBackend',
			value: function getBackend() {
				return this.backend;
			}
		}, {
			key: 'getRegistry',
			value: function getRegistry() {
				return this.registry;
			}
		}, {
			key: 'getActions',
			value: function getActions() {
				var manager = this;
				var dispatch = this.store.dispatch;
	
	
				function bindActionCreator(actionCreator) {
					return function () {
						for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
							args[_key] = arguments[_key];
						}
	
						var action = actionCreator.apply(manager, args);
						if (typeof action !== 'undefined') {
							dispatch(action);
						}
					};
				}
	
				return Object.keys(dragDropActions).filter(function (key) {
					return typeof dragDropActions[key] === 'function';
				}).reduce(function (boundActions, key) {
					var action = dragDropActions[key];
					boundActions[key] = bindActionCreator(action); // eslint-disable-line no-param-reassign
					return boundActions;
				}, {});
			}
		}]);
	
		return DragDropManager;
	}();
	
	exports.default = DragDropManager;

/***/ },
/* 1435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isArray = __webpack_require__(35);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _matchesType = __webpack_require__(691);
	
	var _matchesType2 = _interopRequireDefault(_matchesType);
	
	var _HandlerRegistry = __webpack_require__(1438);
	
	var _HandlerRegistry2 = _interopRequireDefault(_HandlerRegistry);
	
	var _dragOffset = __webpack_require__(690);
	
	var _dirtyHandlerIds = __webpack_require__(689);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DragDropMonitor = function () {
		function DragDropMonitor(store) {
			_classCallCheck(this, DragDropMonitor);
	
			this.store = store;
			this.registry = new _HandlerRegistry2.default(store);
		}
	
		_createClass(DragDropMonitor, [{
			key: 'subscribeToStateChange',
			value: function subscribeToStateChange(listener) {
				var _this = this;
	
				var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
				var handlerIds = options.handlerIds;
	
				(0, _invariant2.default)(typeof listener === 'function', 'listener must be a function.');
				(0, _invariant2.default)(typeof handlerIds === 'undefined' || (0, _isArray2.default)(handlerIds), 'handlerIds, when specified, must be an array of strings.');
	
				var prevStateId = this.store.getState().stateId;
				var handleChange = function handleChange() {
					var state = _this.store.getState();
					var currentStateId = state.stateId;
					try {
						var canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !(0, _dirtyHandlerIds.areDirty)(state.dirtyHandlerIds, handlerIds);
	
						if (!canSkipListener) {
							listener();
						}
					} finally {
						prevStateId = currentStateId;
					}
				};
	
				return this.store.subscribe(handleChange);
			}
		}, {
			key: 'subscribeToOffsetChange',
			value: function subscribeToOffsetChange(listener) {
				var _this2 = this;
	
				(0, _invariant2.default)(typeof listener === 'function', 'listener must be a function.');
	
				var previousState = this.store.getState().dragOffset;
				var handleChange = function handleChange() {
					var nextState = _this2.store.getState().dragOffset;
					if (nextState === previousState) {
						return;
					}
	
					previousState = nextState;
					listener();
				};
	
				return this.store.subscribe(handleChange);
			}
		}, {
			key: 'canDragSource',
			value: function canDragSource(sourceId) {
				var source = this.registry.getSource(sourceId);
				(0, _invariant2.default)(source, 'Expected to find a valid source.');
	
				if (this.isDragging()) {
					return false;
				}
	
				return source.canDrag(this, sourceId);
			}
		}, {
			key: 'canDropOnTarget',
			value: function canDropOnTarget(targetId) {
				var target = this.registry.getTarget(targetId);
				(0, _invariant2.default)(target, 'Expected to find a valid target.');
	
				if (!this.isDragging() || this.didDrop()) {
					return false;
				}
	
				var targetType = this.registry.getTargetType(targetId);
				var draggedItemType = this.getItemType();
				return (0, _matchesType2.default)(targetType, draggedItemType) && target.canDrop(this, targetId);
			}
		}, {
			key: 'isDragging',
			value: function isDragging() {
				return Boolean(this.getItemType());
			}
		}, {
			key: 'isDraggingSource',
			value: function isDraggingSource(sourceId) {
				var source = this.registry.getSource(sourceId, true);
				(0, _invariant2.default)(source, 'Expected to find a valid source.');
	
				if (!this.isDragging() || !this.isSourcePublic()) {
					return false;
				}
	
				var sourceType = this.registry.getSourceType(sourceId);
				var draggedItemType = this.getItemType();
				if (sourceType !== draggedItemType) {
					return false;
				}
	
				return source.isDragging(this, sourceId);
			}
		}, {
			key: 'isOverTarget',
			value: function isOverTarget(targetId) {
				var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { shallow: false };
				var shallow = options.shallow;
	
				if (!this.isDragging()) {
					return false;
				}
	
				var targetType = this.registry.getTargetType(targetId);
				var draggedItemType = this.getItemType();
				if (!(0, _matchesType2.default)(targetType, draggedItemType)) {
					return false;
				}
	
				var targetIds = this.getTargetIds();
				if (!targetIds.length) {
					return false;
				}
	
				var index = targetIds.indexOf(targetId);
				if (shallow) {
					return index === targetIds.length - 1;
				} else {
					return index > -1;
				}
			}
		}, {
			key: 'getItemType',
			value: function getItemType() {
				return this.store.getState().dragOperation.itemType;
			}
		}, {
			key: 'getItem',
			value: function getItem() {
				return this.store.getState().dragOperation.item;
			}
		}, {
			key: 'getSourceId',
			value: function getSourceId() {
				return this.store.getState().dragOperation.sourceId;
			}
		}, {
			key: 'getTargetIds',
			value: function getTargetIds() {
				return this.store.getState().dragOperation.targetIds;
			}
		}, {
			key: 'getDropResult',
			value: function getDropResult() {
				return this.store.getState().dragOperation.dropResult;
			}
		}, {
			key: 'didDrop',
			value: function didDrop() {
				return this.store.getState().dragOperation.didDrop;
			}
		}, {
			key: 'isSourcePublic',
			value: function isSourcePublic() {
				return this.store.getState().dragOperation.isSourcePublic;
			}
		}, {
			key: 'getInitialClientOffset',
			value: function getInitialClientOffset() {
				return this.store.getState().dragOffset.initialClientOffset;
			}
		}, {
			key: 'getInitialSourceClientOffset',
			value: function getInitialSourceClientOffset() {
				return this.store.getState().dragOffset.initialSourceClientOffset;
			}
		}, {
			key: 'getClientOffset',
			value: function getClientOffset() {
				return this.store.getState().dragOffset.clientOffset;
			}
		}, {
			key: 'getSourceClientOffset',
			value: function getSourceClientOffset() {
				return (0, _dragOffset.getSourceClientOffset)(this.store.getState().dragOffset);
			}
		}, {
			key: 'getDifferenceFromInitialOffset',
			value: function getDifferenceFromInitialOffset() {
				return (0, _dragOffset.getDifferenceFromInitialOffset)(this.store.getState().dragOffset);
			}
		}]);
	
		return DragDropMonitor;
	}();
	
	exports.default = DragDropMonitor;

/***/ },
/* 1436 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DragSource = function () {
		function DragSource() {
			_classCallCheck(this, DragSource);
		}
	
		_createClass(DragSource, [{
			key: "canDrag",
			value: function canDrag() {
				return true;
			}
		}, {
			key: "isDragging",
			value: function isDragging(monitor, handle) {
				return handle === monitor.getSourceId();
			}
		}, {
			key: "endDrag",
			value: function endDrag() {}
		}]);
	
		return DragSource;
	}();
	
	exports.default = DragSource;

/***/ },
/* 1437 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DropTarget = function () {
		function DropTarget() {
			_classCallCheck(this, DropTarget);
		}
	
		_createClass(DropTarget, [{
			key: "canDrop",
			value: function canDrop() {
				return true;
			}
		}, {
			key: "hover",
			value: function hover() {}
		}, {
			key: "drop",
			value: function drop() {}
		}]);
	
		return DropTarget;
	}();
	
	exports.default = DropTarget;

/***/ },
/* 1438 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isArray = __webpack_require__(35);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _asap = __webpack_require__(1423);
	
	var _asap2 = _interopRequireDefault(_asap);
	
	var _registry = __webpack_require__(329);
	
	var _getNextUniqueId = __webpack_require__(1445);
	
	var _getNextUniqueId2 = _interopRequireDefault(_getNextUniqueId);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HandlerRoles = {
		SOURCE: 'SOURCE',
		TARGET: 'TARGET'
	};
	
	function validateSourceContract(source) {
		(0, _invariant2.default)(typeof source.canDrag === 'function', 'Expected canDrag to be a function.');
		(0, _invariant2.default)(typeof source.beginDrag === 'function', 'Expected beginDrag to be a function.');
		(0, _invariant2.default)(typeof source.endDrag === 'function', 'Expected endDrag to be a function.');
	}
	
	function validateTargetContract(target) {
		(0, _invariant2.default)(typeof target.canDrop === 'function', 'Expected canDrop to be a function.');
		(0, _invariant2.default)(typeof target.hover === 'function', 'Expected hover to be a function.');
		(0, _invariant2.default)(typeof target.drop === 'function', 'Expected beginDrag to be a function.');
	}
	
	function validateType(type, allowArray) {
		if (allowArray && (0, _isArray2.default)(type)) {
			type.forEach(function (t) {
				return validateType(t, false);
			});
			return;
		}
	
		(0, _invariant2.default)(typeof type === 'string' || (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'symbol', allowArray ? 'Type can only be a string, a symbol, or an array of either.' : 'Type can only be a string or a symbol.');
	}
	
	function getNextHandlerId(role) {
		var id = (0, _getNextUniqueId2.default)().toString();
		switch (role) {
			case HandlerRoles.SOURCE:
				return 'S' + id;
			case HandlerRoles.TARGET:
				return 'T' + id;
			default:
				(0, _invariant2.default)(false, 'Unknown role: ' + role);
		}
	}
	
	function parseRoleFromHandlerId(handlerId) {
		switch (handlerId[0]) {
			case 'S':
				return HandlerRoles.SOURCE;
			case 'T':
				return HandlerRoles.TARGET;
			default:
				(0, _invariant2.default)(false, 'Cannot parse handler ID: ' + handlerId);
		}
	}
	
	var HandlerRegistry = function () {
		function HandlerRegistry(store) {
			_classCallCheck(this, HandlerRegistry);
	
			this.store = store;
	
			this.types = {};
			this.handlers = {};
	
			this.pinnedSourceId = null;
			this.pinnedSource = null;
		}
	
		_createClass(HandlerRegistry, [{
			key: 'addSource',
			value: function addSource(type, source) {
				validateType(type);
				validateSourceContract(source);
	
				var sourceId = this.addHandler(HandlerRoles.SOURCE, type, source);
				this.store.dispatch((0, _registry.addSource)(sourceId));
				return sourceId;
			}
		}, {
			key: 'addTarget',
			value: function addTarget(type, target) {
				validateType(type, true);
				validateTargetContract(target);
	
				var targetId = this.addHandler(HandlerRoles.TARGET, type, target);
				this.store.dispatch((0, _registry.addTarget)(targetId));
				return targetId;
			}
		}, {
			key: 'addHandler',
			value: function addHandler(role, type, handler) {
				var id = getNextHandlerId(role);
				this.types[id] = type;
				this.handlers[id] = handler;
	
				return id;
			}
		}, {
			key: 'containsHandler',
			value: function containsHandler(handler) {
				var _this = this;
	
				return Object.keys(this.handlers).some(function (key) {
					return _this.handlers[key] === handler;
				});
			}
		}, {
			key: 'getSource',
			value: function getSource(sourceId, includePinned) {
				(0, _invariant2.default)(this.isSourceId(sourceId), 'Expected a valid source ID.');
	
				var isPinned = includePinned && sourceId === this.pinnedSourceId;
				var source = isPinned ? this.pinnedSource : this.handlers[sourceId];
	
				return source;
			}
		}, {
			key: 'getTarget',
			value: function getTarget(targetId) {
				(0, _invariant2.default)(this.isTargetId(targetId), 'Expected a valid target ID.');
				return this.handlers[targetId];
			}
		}, {
			key: 'getSourceType',
			value: function getSourceType(sourceId) {
				(0, _invariant2.default)(this.isSourceId(sourceId), 'Expected a valid source ID.');
				return this.types[sourceId];
			}
		}, {
			key: 'getTargetType',
			value: function getTargetType(targetId) {
				(0, _invariant2.default)(this.isTargetId(targetId), 'Expected a valid target ID.');
				return this.types[targetId];
			}
		}, {
			key: 'isSourceId',
			value: function isSourceId(handlerId) {
				var role = parseRoleFromHandlerId(handlerId);
				return role === HandlerRoles.SOURCE;
			}
		}, {
			key: 'isTargetId',
			value: function isTargetId(handlerId) {
				var role = parseRoleFromHandlerId(handlerId);
				return role === HandlerRoles.TARGET;
			}
		}, {
			key: 'removeSource',
			value: function removeSource(sourceId) {
				var _this2 = this;
	
				(0, _invariant2.default)(this.getSource(sourceId), 'Expected an existing source.');
				this.store.dispatch((0, _registry.removeSource)(sourceId));
	
				(0, _asap2.default)(function () {
					delete _this2.handlers[sourceId];
					delete _this2.types[sourceId];
				});
			}
		}, {
			key: 'removeTarget',
			value: function removeTarget(targetId) {
				var _this3 = this;
	
				(0, _invariant2.default)(this.getTarget(targetId), 'Expected an existing target.');
				this.store.dispatch((0, _registry.removeTarget)(targetId));
	
				(0, _asap2.default)(function () {
					delete _this3.handlers[targetId];
					delete _this3.types[targetId];
				});
			}
		}, {
			key: 'pinSource',
			value: function pinSource(sourceId) {
				var source = this.getSource(sourceId);
				(0, _invariant2.default)(source, 'Expected an existing source.');
	
				this.pinnedSourceId = sourceId;
				this.pinnedSource = source;
			}
		}, {
			key: 'unpinSource',
			value: function unpinSource() {
				(0, _invariant2.default)(this.pinnedSource, 'No source is pinned at the time.');
	
				this.pinnedSourceId = null;
				this.pinnedSource = null;
			}
		}]);
	
		return HandlerRegistry;
	}();
	
	exports.default = HandlerRegistry;

/***/ },
/* 1439 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createBackend;
	
	var _noop = __webpack_require__(812);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TestBackend = function () {
		function TestBackend(manager) {
			_classCallCheck(this, TestBackend);
	
			this.actions = manager.getActions();
		}
	
		_createClass(TestBackend, [{
			key: 'setup',
			value: function setup() {
				this.didCallSetup = true;
			}
		}, {
			key: 'teardown',
			value: function teardown() {
				this.didCallTeardown = true;
			}
		}, {
			key: 'connectDragSource',
			value: function connectDragSource() {
				return _noop2.default;
			}
		}, {
			key: 'connectDragPreview',
			value: function connectDragPreview() {
				return _noop2.default;
			}
		}, {
			key: 'connectDropTarget',
			value: function connectDropTarget() {
				return _noop2.default;
			}
		}, {
			key: 'simulateBeginDrag',
			value: function simulateBeginDrag(sourceIds, options) {
				this.actions.beginDrag(sourceIds, options);
			}
		}, {
			key: 'simulatePublishDragSource',
			value: function simulatePublishDragSource() {
				this.actions.publishDragSource();
			}
		}, {
			key: 'simulateHover',
			value: function simulateHover(targetIds, options) {
				this.actions.hover(targetIds, options);
			}
		}, {
			key: 'simulateDrop',
			value: function simulateDrop() {
				this.actions.drop();
			}
		}, {
			key: 'simulateEndDrag',
			value: function simulateEndDrag() {
				this.actions.endDrag();
			}
		}]);
	
		return TestBackend;
	}();
	
	function createBackend(manager) {
		return new TestBackend(manager);
	}

/***/ },
/* 1440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DragDropManager = __webpack_require__(1434);
	
	Object.defineProperty(exports, 'DragDropManager', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DragDropManager).default;
	  }
	});
	
	var _DragSource = __webpack_require__(1436);
	
	Object.defineProperty(exports, 'DragSource', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DragSource).default;
	  }
	});
	
	var _DropTarget = __webpack_require__(1437);
	
	Object.defineProperty(exports, 'DropTarget', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DropTarget).default;
	  }
	});
	
	var _createTestBackend = __webpack_require__(1439);
	
	Object.defineProperty(exports, 'createTestBackend', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_createTestBackend).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1441 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = dragOperation;
	
	var _without = __webpack_require__(814);
	
	var _without2 = _interopRequireDefault(_without);
	
	var _dragDrop = __webpack_require__(328);
	
	var _registry = __webpack_require__(329);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
		itemType: null,
		item: null,
		sourceId: null,
		targetIds: [],
		dropResult: null,
		didDrop: false,
		isSourcePublic: null
	};
	
	function dragOperation() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
		var action = arguments[1];
	
		switch (action.type) {
			case _dragDrop.BEGIN_DRAG:
				return _extends({}, state, {
					itemType: action.itemType,
					item: action.item,
					sourceId: action.sourceId,
					isSourcePublic: action.isSourcePublic,
					dropResult: null,
					didDrop: false
				});
			case _dragDrop.PUBLISH_DRAG_SOURCE:
				return _extends({}, state, {
					isSourcePublic: true
				});
			case _dragDrop.HOVER:
				return _extends({}, state, {
					targetIds: action.targetIds
				});
			case _registry.REMOVE_TARGET:
				if (state.targetIds.indexOf(action.targetId) === -1) {
					return state;
				}
				return _extends({}, state, {
					targetIds: (0, _without2.default)(state.targetIds, action.targetId)
				});
			case _dragDrop.DROP:
				return _extends({}, state, {
					dropResult: action.dropResult,
					didDrop: true,
					targetIds: []
				});
			case _dragDrop.END_DRAG:
				return _extends({}, state, {
					itemType: null,
					item: null,
					sourceId: null,
					dropResult: null,
					didDrop: false,
					isSourcePublic: null,
					targetIds: []
				});
			default:
				return state;
		}
	}

/***/ },
/* 1442 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = reduce;
	
	var _dragOffset = __webpack_require__(690);
	
	var _dragOffset2 = _interopRequireDefault(_dragOffset);
	
	var _dragOperation = __webpack_require__(1441);
	
	var _dragOperation2 = _interopRequireDefault(_dragOperation);
	
	var _refCount = __webpack_require__(1443);
	
	var _refCount2 = _interopRequireDefault(_refCount);
	
	var _dirtyHandlerIds = __webpack_require__(689);
	
	var _dirtyHandlerIds2 = _interopRequireDefault(_dirtyHandlerIds);
	
	var _stateId = __webpack_require__(1444);
	
	var _stateId2 = _interopRequireDefault(_stateId);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function reduce() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		var action = arguments[1];
	
		return {
			dirtyHandlerIds: (0, _dirtyHandlerIds2.default)(state.dirtyHandlerIds, action, state.dragOperation),
			dragOffset: (0, _dragOffset2.default)(state.dragOffset, action),
			refCount: (0, _refCount2.default)(state.refCount, action),
			dragOperation: (0, _dragOperation2.default)(state.dragOperation, action),
			stateId: (0, _stateId2.default)(state.stateId)
		};
	}

/***/ },
/* 1443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = refCount;
	
	var _registry = __webpack_require__(329);
	
	function refCount() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
		var action = arguments[1];
	
		switch (action.type) {
			case _registry.ADD_SOURCE:
			case _registry.ADD_TARGET:
				return state + 1;
			case _registry.REMOVE_SOURCE:
			case _registry.REMOVE_TARGET:
				return state - 1;
			default:
				return state;
		}
	}

/***/ },
/* 1444 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = stateId;
	function stateId() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
		return state + 1;
	}

/***/ },
/* 1445 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = getNextUniqueId;
	var nextUniqueId = 0;
	
	function getNextUniqueId() {
		return nextUniqueId++;
	}

/***/ },
/* 1446 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(1447));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
	}
	
	module.exports = exports["default"];

/***/ },
/* 1447 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);
	  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ },
/* 1448 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeClass;
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	function removeClass(element, className) {
	  if (element.classList) {
	    element.classList.remove(className);
	  } else if (typeof element.className === 'string') {
	    ;
	    element.className = replaceClassName(element.className, className);
	  } else {
	    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	  }
	}
	
	module.exports = exports["default"];

/***/ },
/* 1449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _fastDeepEqual = __webpack_require__(1729);
	
	var _fastDeepEqual2 = _interopRequireDefault(_fastDeepEqual);
	
	var _sizeSensor = __webpack_require__(2261);
	
	var _utils = __webpack_require__(1451);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EchartsReactCore = function (_Component) {
	  _inherits(EchartsReactCore, _Component);
	
	  function EchartsReactCore(props) {
	    _classCallCheck(this, EchartsReactCore);
	
	    var _this = _possibleConstructorReturn(this, (EchartsReactCore.__proto__ || Object.getPrototypeOf(EchartsReactCore)).call(this, props));
	
	    _this.getEchartsInstance = function () {
	      return _this.echartsLib.getInstanceByDom(_this.echartsElement) || _this.echartsLib.init(_this.echartsElement, _this.props.theme, _this.props.opts);
	    };
	
	    _this.dispose = function () {
	      if (_this.echartsElement) {
	        try {
	          (0, _sizeSensor.clear)(_this.echartsElement);
	        } catch (e) {
	          console.warn(e);
	        }
	        // dispose echarts instance
	        _this.echartsLib.dispose(_this.echartsElement);
	      }
	    };
	
	    _this.rerender = function () {
	      var _this$props = _this.props,
	          onEvents = _this$props.onEvents,
	          onChartReady = _this$props.onChartReady;
	
	
	      var echartObj = _this.renderEchartDom();
	      _this.bindEvents(echartObj, onEvents || {});
	
	      // on chart ready
	      if (typeof onChartReady === 'function') _this.props.onChartReady(echartObj);
	      // on resize
	      if (_this.echartsElement) {
	        (0, _sizeSensor.bind)(_this.echartsElement, function () {
	          try {
	            echartObj.resize();
	          } catch (e) {
	            console.warn(e);
	          }
	        });
	      }
	    };
	
	    _this.bindEvents = function (instance, events) {
	      var _bindEvent = function _bindEvent(eventName, func) {
	        // ignore the event config which not satisfy
	        if (typeof eventName === 'string' && typeof func === 'function') {
	          // binding event
	          // instance.off(eventName); // 已经 dispose 在重建，所以无需 off 操作
	          instance.on(eventName, function (param) {
	            func(param, instance);
	          });
	        }
	      };
	
	      // loop and bind
	      for (var eventName in events) {
	        if (Object.prototype.hasOwnProperty.call(events, eventName)) {
	          _bindEvent(eventName, events[eventName]);
	        }
	      }
	    };
	
	    _this.renderEchartDom = function () {
	      // init the echart object
	      var echartObj = _this.getEchartsInstance();
	      // set the echart option
	      echartObj.setOption(_this.props.option, _this.props.notMerge || false, _this.props.lazyUpdate || false);
	      // set loading mask
	      if (_this.props.showLoading) echartObj.showLoading(_this.props.loadingOption || null);else echartObj.hideLoading();
	
	      return echartObj;
	    };
	
	    _this.echartsLib = props.echarts; // the echarts object.
	    _this.echartsElement = null; // echarts div element
	    return _this;
	  }
	
	  // first add
	
	
	  _createClass(EchartsReactCore, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.rerender();
	    }
	
	    // update
	
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      // 判断是否需要 setOption，由开发者自己来确定。默认为 true
	      if (typeof this.props.shouldSetOption === 'function' && !this.props.shouldSetOption(prevProps, this.props)) {
	        return;
	      }
	
	      // 以下属性修改的时候，需要 dispose 之后再新建
	      // 1. 切换 theme 的时候
	      // 2. 修改 opts 的时候
	      // 3. 修改 onEvents 的时候，这样可以取消所有之前绑定的事件 issue #151
	      if (!(0, _fastDeepEqual2['default'])(prevProps.theme, this.props.theme) || !(0, _fastDeepEqual2['default'])(prevProps.opts, this.props.opts) || !(0, _fastDeepEqual2['default'])(prevProps.onEvents, this.props.onEvents)) {
	        this.dispose();
	
	        this.rerender(); // 重建
	        return;
	      }
	
	      // 当这些属性保持不变的时候，不 setOption
	      var pickKeys = ['option', 'notMerge', 'lazyUpdate', 'showLoading', 'loadingOption'];
	      if ((0, _fastDeepEqual2['default'])((0, _utils.pick)(this.props, pickKeys), (0, _utils.pick)(prevProps, pickKeys))) {
	        return;
	      }
	
	      var echartObj = this.renderEchartDom();
	      // 样式修改的时候，可能会导致大小变化，所以触发一下 resize
	      if (!(0, _fastDeepEqual2['default'])(prevProps.style, this.props.style) || !(0, _fastDeepEqual2['default'])(prevProps.className, this.props.className)) {
	        try {
	          echartObj.resize();
	        } catch (e) {
	          console.warn(e);
	        }
	      }
	    }
	
	    // remove
	
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.dispose();
	    }
	
	    // return the echart object
	
	
	    // dispose echarts and clear size-sensor
	
	
	    // bind the events
	
	
	    // render the dom
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className;
	
	      var newStyle = _extends({
	        height: 300
	      }, style);
	      // for render
	      return _react2['default'].createElement('div', {
	        ref: function ref(e) {
	          _this2.echartsElement = e;
	        },
	        style: newStyle,
	        className: 'echarts-for-react ' + className
	      });
	    }
	  }]);
	
	  return EchartsReactCore;
	}(_react.Component);
	
	exports['default'] = EchartsReactCore;
	
	
	EchartsReactCore.propTypes = {
	  option: _propTypes2['default'].object.isRequired, // eslint-disable-line react/forbid-prop-types
	  echarts: _propTypes2['default'].object, // eslint-disable-line react/forbid-prop-types
	  notMerge: _propTypes2['default'].bool,
	  lazyUpdate: _propTypes2['default'].bool,
	  style: _propTypes2['default'].object, // eslint-disable-line react/forbid-prop-types
	  className: _propTypes2['default'].string,
	  theme: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  onChartReady: _propTypes2['default'].func,
	  showLoading: _propTypes2['default'].bool,
	  loadingOption: _propTypes2['default'].object, // eslint-disable-line react/forbid-prop-types
	  onEvents: _propTypes2['default'].object, // eslint-disable-line react/forbid-prop-types
	  opts: _propTypes2['default'].shape({
	    devicePixelRatio: _propTypes2['default'].number,
	    renderer: _propTypes2['default'].oneOf(['canvas', 'svg']),
	    width: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].oneOf([null, undefined, 'auto'])]),
	    height: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].oneOf([null, undefined, 'auto'])])
	  }),
	  shouldSetOption: _propTypes2['default'].func
	};
	
	EchartsReactCore.defaultProps = {
	  echarts: {},
	  notMerge: false,
	  lazyUpdate: false,
	  style: {},
	  className: '',
	  theme: null,
	  onChartReady: function onChartReady() {},
	  showLoading: false,
	  loadingOption: null,
	  onEvents: {},
	  opts: {},
	  shouldSetOption: function shouldSetOption() {
	    return true;
	  }
	};

/***/ },
/* 1450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = undefined;
	
	var _echarts = __webpack_require__(1452);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _core = __webpack_require__(1449);
	
	var _core2 = _interopRequireDefault(_core);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// export the Component the echarts Object.
	var EchartsReact = function (_EchartsReactCore) {
	  _inherits(EchartsReact, _EchartsReactCore);
	
	  function EchartsReact(props) {
	    _classCallCheck(this, EchartsReact);
	
	    var _this = _possibleConstructorReturn(this, (EchartsReact.__proto__ || Object.getPrototypeOf(EchartsReact)).call(this, props));
	
	    _this.echartsLib = _echarts2['default'];
	    return _this;
	  }
	
	  return EchartsReact;
	}(_core2['default']);
	
	exports['default'] = EchartsReact;

/***/ },
/* 1451 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint-disable import/prefer-default-export */
	
	var pick = exports.pick = function pick(obj, keys) {
	  var r = {};
	  keys.forEach(function (key) {
	    r[key] = obj[key];
	  });
	  return r;
	};

/***/ },
/* 1452 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _echarts = __webpack_require__(13);
	
	(function () {
	  for (var key in _echarts) {
	    if (_echarts == null || !_echarts.hasOwnProperty(key) || key === 'default' || key === '__esModule') return;
	    exports[key] = _echarts[key];
	  }
	})();
	
	var _export = __webpack_require__(748);
	
	(function () {
	  for (var key in _export) {
	    if (_export == null || !_export.hasOwnProperty(key) || key === 'default' || key === '__esModule') return;
	    exports[key] = _export[key];
	  }
	})();
	
	__webpack_require__(717);
	
	__webpack_require__(1504);
	
	__webpack_require__(1453);
	
	__webpack_require__(1524);
	
	__webpack_require__(1540);
	
	__webpack_require__(1529);
	
	__webpack_require__(1512);
	
	__webpack_require__(1554);
	
	__webpack_require__(1560);
	
	__webpack_require__(1482);
	
	__webpack_require__(1478);
	
	__webpack_require__(1474);
	
	__webpack_require__(1519);
	
	__webpack_require__(1534);
	
	__webpack_require__(1459);
	
	__webpack_require__(1464);
	
	__webpack_require__(1471);
	
	__webpack_require__(1508);
	
	__webpack_require__(1495);
	
	__webpack_require__(1523);
	
	__webpack_require__(1549);
	
	__webpack_require__(1543);
	
	__webpack_require__(1470);
	
	__webpack_require__(1601);
	
	__webpack_require__(1618);
	
	__webpack_require__(1598);
	
	__webpack_require__(727);
	
	__webpack_require__(726);
	
	__webpack_require__(1586);
	
	__webpack_require__(1600);
	
	__webpack_require__(1632);
	
	__webpack_require__(1641);
	
	__webpack_require__(260);
	
	__webpack_require__(1580);
	
	__webpack_require__(1631);
	
	__webpack_require__(1622);
	
	__webpack_require__(1610);
	
	__webpack_require__(1609);
	
	__webpack_require__(1608);
	
	__webpack_require__(1607);
	
	__webpack_require__(723);
	
	__webpack_require__(1588);
	
	__webpack_require__(715);
	
	__webpack_require__(716);
	
	__webpack_require__(1646);
	
	__webpack_require__(735);
	
	__webpack_require__(736);
	
	__webpack_require__(2304);
	
	__webpack_require__(2300);

/***/ },
/* 1453 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var _barGrid = __webpack_require__(337);
	
	var layout = _barGrid.layout;
	var largeLayout = _barGrid.largeLayout;
	
	__webpack_require__(470);
	
	__webpack_require__(1454);
	
	__webpack_require__(1455);
	
	__webpack_require__(261);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// In case developer forget to include grid component
	echarts.registerLayout(echarts.PRIORITY.VISUAL.LAYOUT, zrUtil.curry(layout, 'bar')); // Use higher prority to avoid to be blocked by other overall layout, which do not
	// only exist in this module, but probably also exist in other modules, like `barPolar`.
	
	echarts.registerLayout(echarts.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, largeLayout);
	echarts.registerVisual({
	  seriesType: 'bar',
	  reset: function (seriesModel) {
	    // Visual coding for legend
	    seriesModel.getData().setVisual('legendSymbol', 'roundRect');
	  }
	});

/***/ },
/* 1454 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var BaseBarSeries = __webpack_require__(696);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = BaseBarSeries.extend({
	  type: 'series.bar',
	  dependencies: ['grid', 'polar'],
	  brushSelector: 'rect',
	
	  /**
	   * @override
	   */
	  getProgressive: function () {
	    // Do not support progressive in normal mode.
	    return this.get('large') ? this.get('progressive') : false;
	  },
	
	  /**
	   * @override
	   */
	  getProgressiveThreshold: function () {
	    // Do not support progressive in normal mode.
	    var progressiveThreshold = this.get('progressiveThreshold');
	    var largeThreshold = this.get('largeThreshold');
	
	    if (largeThreshold > progressiveThreshold) {
	      progressiveThreshold = largeThreshold;
	    }
	
	    return progressiveThreshold;
	  },
	  defaultOption: {
	    // If clipped
	    // Only available on cartesian2d
	    clip: true,
	    // If use caps on two sides of bars
	    // Only available on tangential polar bar
	    roundCap: false,
	    showBackground: false,
	    backgroundStyle: {
	      color: 'rgba(180, 180, 180, 0.2)',
	      borderColor: null,
	      borderWidth: 0,
	      borderType: 'solid',
	      borderRadius: 0,
	      shadowBlur: 0,
	      shadowColor: null,
	      shadowOffsetX: 0,
	      shadowOffsetY: 0,
	      opacity: 1
	    }
	  }
	});
	
	module.exports = _default;

/***/ },
/* 1455 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var graphic = __webpack_require__(16);
	
	var _helper = __webpack_require__(697);
	
	var setLabel = _helper.setLabel;
	
	var Model = __webpack_require__(48);
	
	var barItemStyle = __webpack_require__(1458);
	
	var Path = __webpack_require__(46);
	
	var Group = __webpack_require__(187);
	
	var _throttle = __webpack_require__(142);
	
	var throttle = _throttle.throttle;
	
	var _createClipPathFromCoordSys = __webpack_require__(259);
	
	var createClipPath = _createClipPathFromCoordSys.createClipPath;
	
	var Sausage = __webpack_require__(1710);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var BAR_BORDER_WIDTH_QUERY = ['itemStyle', 'barBorderWidth'];
	var _eventPos = [0, 0]; // FIXME
	// Just for compatible with ec2.
	
	zrUtil.extend(Model.prototype, barItemStyle);
	
	function getClipArea(coord, data) {
	  var coordSysClipArea = coord.getArea && coord.getArea();
	
	  if (coord.type === 'cartesian2d') {
	    var baseAxis = coord.getBaseAxis(); // When boundaryGap is false or using time axis. bar may exceed the grid.
	    // We should not clip this part.
	    // See test/bar2.html
	
	    if (baseAxis.type !== 'category' || !baseAxis.onBand) {
	      var expandWidth = data.getLayout('bandWidth');
	
	      if (baseAxis.isHorizontal()) {
	        coordSysClipArea.x -= expandWidth;
	        coordSysClipArea.width += expandWidth * 2;
	      } else {
	        coordSysClipArea.y -= expandWidth;
	        coordSysClipArea.height += expandWidth * 2;
	      }
	    }
	  }
	
	  return coordSysClipArea;
	}
	
	var _default = echarts.extendChartView({
	  type: 'bar',
	  render: function (seriesModel, ecModel, api) {
	    this._updateDrawMode(seriesModel);
	
	    var coordinateSystemType = seriesModel.get('coordinateSystem');
	
	    if (coordinateSystemType === 'cartesian2d' || coordinateSystemType === 'polar') {
	      this._isLargeDraw ? this._renderLarge(seriesModel, ecModel, api) : this._renderNormal(seriesModel, ecModel, api);
	    } else {}
	
	    return this.group;
	  },
	  incrementalPrepareRender: function (seriesModel, ecModel, api) {
	    this._clear();
	
	    this._updateDrawMode(seriesModel);
	  },
	  incrementalRender: function (params, seriesModel, ecModel, api) {
	    // Do not support progressive in normal mode.
	    this._incrementalRenderLarge(params, seriesModel);
	  },
	  _updateDrawMode: function (seriesModel) {
	    var isLargeDraw = seriesModel.pipelineContext.large;
	
	    if (this._isLargeDraw == null || isLargeDraw ^ this._isLargeDraw) {
	      this._isLargeDraw = isLargeDraw;
	
	      this._clear();
	    }
	  },
	  _renderNormal: function (seriesModel, ecModel, api) {
	    var group = this.group;
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var coord = seriesModel.coordinateSystem;
	    var baseAxis = coord.getBaseAxis();
	    var isHorizontalOrRadial;
	
	    if (coord.type === 'cartesian2d') {
	      isHorizontalOrRadial = baseAxis.isHorizontal();
	    } else if (coord.type === 'polar') {
	      isHorizontalOrRadial = baseAxis.dim === 'angle';
	    }
	
	    var animationModel = seriesModel.isAnimationEnabled() ? seriesModel : null;
	    var needsClip = seriesModel.get('clip', true);
	    var coordSysClipArea = getClipArea(coord, data); // If there is clipPath created in large mode. Remove it.
	
	    group.removeClipPath(); // We don't use clipPath in normal mode because we needs a perfect animation
	    // And don't want the label are clipped.
	
	    var roundCap = seriesModel.get('roundCap', true);
	    var drawBackground = seriesModel.get('showBackground', true);
	    var backgroundModel = seriesModel.getModel('backgroundStyle');
	    var barBorderRadius = backgroundModel.get('barBorderRadius') || 0;
	    var bgEls = [];
	    var oldBgEls = this._backgroundEls || [];
	
	    var createBackground = function (dataIndex) {
	      var bgLayout = getLayout[coord.type](data, dataIndex);
	      var bgEl = createBackgroundEl(coord, isHorizontalOrRadial, bgLayout);
	      bgEl.useStyle(backgroundModel.getBarItemStyle()); // Only cartesian2d support borderRadius.
	
	      if (coord.type === 'cartesian2d') {
	        bgEl.setShape('r', barBorderRadius);
	      }
	
	      bgEls[dataIndex] = bgEl;
	      return bgEl;
	    };
	
	    data.diff(oldData).add(function (dataIndex) {
	      var itemModel = data.getItemModel(dataIndex);
	      var layout = getLayout[coord.type](data, dataIndex, itemModel);
	
	      if (drawBackground) {
	        createBackground(dataIndex);
	      } // If dataZoom in filteMode: 'empty', the baseValue can be set as NaN in "axisProxy".
	
	
	      if (!data.hasValue(dataIndex)) {
	        return;
	      }
	
	      if (needsClip) {
	        // Clip will modify the layout params.
	        // And return a boolean to determine if the shape are fully clipped.
	        var isClipped = clip[coord.type](coordSysClipArea, layout);
	
	        if (isClipped) {
	          group.remove(el);
	          return;
	        }
	      }
	
	      var el = elementCreator[coord.type](dataIndex, layout, isHorizontalOrRadial, animationModel, false, roundCap);
	      data.setItemGraphicEl(dataIndex, el);
	      group.add(el);
	      updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
	    }).update(function (newIndex, oldIndex) {
	      var itemModel = data.getItemModel(newIndex);
	      var layout = getLayout[coord.type](data, newIndex, itemModel);
	
	      if (drawBackground) {
	        var bgEl;
	
	        if (oldBgEls.length === 0) {
	          bgEl = createBackground(oldIndex);
	        } else {
	          bgEl = oldBgEls[oldIndex];
	          bgEl.useStyle(backgroundModel.getBarItemStyle()); // Only cartesian2d support borderRadius.
	
	          if (coord.type === 'cartesian2d') {
	            bgEl.setShape('r', barBorderRadius);
	          }
	
	          bgEls[newIndex] = bgEl;
	        }
	
	        var bgLayout = getLayout[coord.type](data, newIndex);
	        var shape = createBackgroundShape(isHorizontalOrRadial, bgLayout, coord);
	        graphic.updateProps(bgEl, {
	          shape: shape
	        }, animationModel, newIndex);
	      }
	
	      var el = oldData.getItemGraphicEl(oldIndex);
	
	      if (!data.hasValue(newIndex)) {
	        group.remove(el);
	        return;
	      }
	
	      if (needsClip) {
	        var isClipped = clip[coord.type](coordSysClipArea, layout);
	
	        if (isClipped) {
	          group.remove(el);
	          return;
	        }
	      }
	
	      if (el) {
	        graphic.updateProps(el, {
	          shape: layout
	        }, animationModel, newIndex);
	      } else {
	        el = elementCreator[coord.type](newIndex, layout, isHorizontalOrRadial, animationModel, true, roundCap);
	      }
	
	      data.setItemGraphicEl(newIndex, el); // Add back
	
	      group.add(el);
	      updateStyle(el, data, newIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
	    }).remove(function (dataIndex) {
	      var el = oldData.getItemGraphicEl(dataIndex);
	
	      if (coord.type === 'cartesian2d') {
	        el && removeRect(dataIndex, animationModel, el);
	      } else {
	        el && removeSector(dataIndex, animationModel, el);
	      }
	    }).execute();
	    var bgGroup = this._backgroundGroup || (this._backgroundGroup = new Group());
	    bgGroup.removeAll();
	
	    for (var i = 0; i < bgEls.length; ++i) {
	      bgGroup.add(bgEls[i]);
	    }
	
	    group.add(bgGroup);
	    this._backgroundEls = bgEls;
	    this._data = data;
	  },
	  _renderLarge: function (seriesModel, ecModel, api) {
	    this._clear();
	
	    createLarge(seriesModel, this.group); // Use clipPath in large mode.
	
	    var clipPath = seriesModel.get('clip', true) ? createClipPath(seriesModel.coordinateSystem, false, seriesModel) : null;
	
	    if (clipPath) {
	      this.group.setClipPath(clipPath);
	    } else {
	      this.group.removeClipPath();
	    }
	  },
	  _incrementalRenderLarge: function (params, seriesModel) {
	    this._removeBackground();
	
	    createLarge(seriesModel, this.group, true);
	  },
	  dispose: zrUtil.noop,
	  remove: function (ecModel) {
	    this._clear(ecModel);
	  },
	  _clear: function (ecModel) {
	    var group = this.group;
	    var data = this._data;
	
	    if (ecModel && ecModel.get('animation') && data && !this._isLargeDraw) {
	      this._removeBackground();
	
	      this._backgroundEls = [];
	      data.eachItemGraphicEl(function (el) {
	        if (el.type === 'sector') {
	          removeSector(el.dataIndex, ecModel, el);
	        } else {
	          removeRect(el.dataIndex, ecModel, el);
	        }
	      });
	    } else {
	      group.removeAll();
	    }
	
	    this._data = null;
	  },
	  _removeBackground: function () {
	    this.group.remove(this._backgroundGroup);
	    this._backgroundGroup = null;
	  }
	});
	
	var mathMax = Math.max;
	var mathMin = Math.min;
	var clip = {
	  cartesian2d: function (coordSysBoundingRect, layout) {
	    var signWidth = layout.width < 0 ? -1 : 1;
	    var signHeight = layout.height < 0 ? -1 : 1; // Needs positive width and height
	
	    if (signWidth < 0) {
	      layout.x += layout.width;
	      layout.width = -layout.width;
	    }
	
	    if (signHeight < 0) {
	      layout.y += layout.height;
	      layout.height = -layout.height;
	    }
	
	    var x = mathMax(layout.x, coordSysBoundingRect.x);
	    var x2 = mathMin(layout.x + layout.width, coordSysBoundingRect.x + coordSysBoundingRect.width);
	    var y = mathMax(layout.y, coordSysBoundingRect.y);
	    var y2 = mathMin(layout.y + layout.height, coordSysBoundingRect.y + coordSysBoundingRect.height);
	    layout.x = x;
	    layout.y = y;
	    layout.width = x2 - x;
	    layout.height = y2 - y;
	    var clipped = layout.width < 0 || layout.height < 0; // Reverse back
	
	    if (signWidth < 0) {
	      layout.x += layout.width;
	      layout.width = -layout.width;
	    }
	
	    if (signHeight < 0) {
	      layout.y += layout.height;
	      layout.height = -layout.height;
	    }
	
	    return clipped;
	  },
	  polar: function (coordSysClipArea, layout) {
	    var signR = layout.r0 <= layout.r ? 1 : -1; // Make sure r is larger than r0
	
	    if (signR < 0) {
	      var r = layout.r;
	      layout.r = layout.r0;
	      layout.r0 = r;
	    }
	
	    var r = mathMin(layout.r, coordSysClipArea.r);
	    var r0 = mathMax(layout.r0, coordSysClipArea.r0);
	    layout.r = r;
	    layout.r0 = r0;
	    var clipped = r - r0 < 0; // Reverse back
	
	    if (signR < 0) {
	      var r = layout.r;
	      layout.r = layout.r0;
	      layout.r0 = r;
	    }
	
	    return clipped;
	  }
	};
	var elementCreator = {
	  cartesian2d: function (dataIndex, layout, isHorizontal, animationModel, isUpdate) {
	    var rect = new graphic.Rect({
	      shape: zrUtil.extend({}, layout),
	      z2: 1
	    });
	    rect.name = 'item'; // Animation
	
	    if (animationModel) {
	      var rectShape = rect.shape;
	      var animateProperty = isHorizontal ? 'height' : 'width';
	      var animateTarget = {};
	      rectShape[animateProperty] = 0;
	      animateTarget[animateProperty] = layout[animateProperty];
	      graphic[isUpdate ? 'updateProps' : 'initProps'](rect, {
	        shape: animateTarget
	      }, animationModel, dataIndex);
	    }
	
	    return rect;
	  },
	  polar: function (dataIndex, layout, isRadial, animationModel, isUpdate, roundCap) {
	    // Keep the same logic with bar in catesion: use end value to control
	    // direction. Notice that if clockwise is true (by default), the sector
	    // will always draw clockwisely, no matter whether endAngle is greater
	    // or less than startAngle.
	    var clockwise = layout.startAngle < layout.endAngle;
	    var ShapeClass = !isRadial && roundCap ? Sausage : graphic.Sector;
	    var sector = new ShapeClass({
	      shape: zrUtil.defaults({
	        clockwise: clockwise
	      }, layout),
	      z2: 1
	    });
	    sector.name = 'item'; // Animation
	
	    if (animationModel) {
	      var sectorShape = sector.shape;
	      var animateProperty = isRadial ? 'r' : 'endAngle';
	      var animateTarget = {};
	      sectorShape[animateProperty] = isRadial ? 0 : layout.startAngle;
	      animateTarget[animateProperty] = layout[animateProperty];
	      graphic[isUpdate ? 'updateProps' : 'initProps'](sector, {
	        shape: animateTarget
	      }, animationModel, dataIndex);
	    }
	
	    return sector;
	  }
	};
	
	function removeRect(dataIndex, animationModel, el) {
	  // Not show text when animating
	  el.style.text = null;
	  graphic.updateProps(el, {
	    shape: {
	      width: 0
	    }
	  }, animationModel, dataIndex, function () {
	    el.parent && el.parent.remove(el);
	  });
	}
	
	function removeSector(dataIndex, animationModel, el) {
	  // Not show text when animating
	  el.style.text = null;
	  graphic.updateProps(el, {
	    shape: {
	      r: el.shape.r0
	    }
	  }, animationModel, dataIndex, function () {
	    el.parent && el.parent.remove(el);
	  });
	}
	
	var getLayout = {
	  // itemModel is only used to get borderWidth, which is not needed
	  // when calculating bar background layout.
	  cartesian2d: function (data, dataIndex, itemModel) {
	    var layout = data.getItemLayout(dataIndex);
	    var fixedLineWidth = itemModel ? getLineWidth(itemModel, layout) : 0; // fix layout with lineWidth
	
	    var signX = layout.width > 0 ? 1 : -1;
	    var signY = layout.height > 0 ? 1 : -1;
	    return {
	      x: layout.x + signX * fixedLineWidth / 2,
	      y: layout.y + signY * fixedLineWidth / 2,
	      width: layout.width - signX * fixedLineWidth,
	      height: layout.height - signY * fixedLineWidth
	    };
	  },
	  polar: function (data, dataIndex, itemModel) {
	    var layout = data.getItemLayout(dataIndex);
	    return {
	      cx: layout.cx,
	      cy: layout.cy,
	      r0: layout.r0,
	      r: layout.r,
	      startAngle: layout.startAngle,
	      endAngle: layout.endAngle
	    };
	  }
	};
	
	function isZeroOnPolar(layout) {
	  return layout.startAngle != null && layout.endAngle != null && layout.startAngle === layout.endAngle;
	}
	
	function updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontal, isPolar) {
	  var color = data.getItemVisual(dataIndex, 'color');
	  var opacity = data.getItemVisual(dataIndex, 'opacity');
	  var stroke = data.getVisual('borderColor');
	  var itemStyleModel = itemModel.getModel('itemStyle');
	  var hoverStyle = itemModel.getModel('emphasis.itemStyle').getBarItemStyle();
	
	  if (!isPolar) {
	    el.setShape('r', itemStyleModel.get('barBorderRadius') || 0);
	  }
	
	  el.useStyle(zrUtil.defaults({
	    stroke: isZeroOnPolar(layout) ? 'none' : stroke,
	    fill: isZeroOnPolar(layout) ? 'none' : color,
	    opacity: opacity
	  }, itemStyleModel.getBarItemStyle()));
	  var cursorStyle = itemModel.getShallow('cursor');
	  cursorStyle && el.attr('cursor', cursorStyle);
	  var labelPositionOutside = isHorizontal ? layout.height > 0 ? 'bottom' : 'top' : layout.width > 0 ? 'left' : 'right';
	
	  if (!isPolar) {
	    setLabel(el.style, hoverStyle, itemModel, color, seriesModel, dataIndex, labelPositionOutside);
	  }
	
	  if (isZeroOnPolar(layout)) {
	    hoverStyle.fill = hoverStyle.stroke = 'none';
	  }
	
	  graphic.setHoverStyle(el, hoverStyle);
	} // In case width or height are too small.
	
	
	function getLineWidth(itemModel, rawLayout) {
	  var lineWidth = itemModel.get(BAR_BORDER_WIDTH_QUERY) || 0; // width or height may be NaN for empty data
	
	  var width = isNaN(rawLayout.width) ? Number.MAX_VALUE : Math.abs(rawLayout.width);
	  var height = isNaN(rawLayout.height) ? Number.MAX_VALUE : Math.abs(rawLayout.height);
	  return Math.min(lineWidth, width, height);
	}
	
	var LargePath = Path.extend({
	  type: 'largeBar',
	  shape: {
	    points: []
	  },
	  buildPath: function (ctx, shape) {
	    // Drawing lines is more efficient than drawing
	    // a whole line or drawing rects.
	    var points = shape.points;
	    var startPoint = this.__startPoint;
	    var baseDimIdx = this.__baseDimIdx;
	
	    for (var i = 0; i < points.length; i += 2) {
	      startPoint[baseDimIdx] = points[i + baseDimIdx];
	      ctx.moveTo(startPoint[0], startPoint[1]);
	      ctx.lineTo(points[i], points[i + 1]);
	    }
	  }
	});
	
	function createLarge(seriesModel, group, incremental) {
	  // TODO support polar
	  var data = seriesModel.getData();
	  var startPoint = [];
	  var baseDimIdx = data.getLayout('valueAxisHorizontal') ? 1 : 0;
	  startPoint[1 - baseDimIdx] = data.getLayout('valueAxisStart');
	  var largeDataIndices = data.getLayout('largeDataIndices');
	  var barWidth = data.getLayout('barWidth');
	  var backgroundModel = seriesModel.getModel('backgroundStyle');
	  var drawBackground = seriesModel.get('showBackground', true);
	
	  if (drawBackground) {
	    var points = data.getLayout('largeBackgroundPoints');
	    var backgroundStartPoint = [];
	    backgroundStartPoint[1 - baseDimIdx] = data.getLayout('backgroundStart');
	    var bgEl = new LargePath({
	      shape: {
	        points: points
	      },
	      incremental: !!incremental,
	      __startPoint: backgroundStartPoint,
	      __baseDimIdx: baseDimIdx,
	      __largeDataIndices: largeDataIndices,
	      __barWidth: barWidth,
	      silent: true,
	      z2: 0
	    });
	    setLargeBackgroundStyle(bgEl, backgroundModel, data);
	    group.add(bgEl);
	  }
	
	  var el = new LargePath({
	    shape: {
	      points: data.getLayout('largePoints')
	    },
	    incremental: !!incremental,
	    __startPoint: startPoint,
	    __baseDimIdx: baseDimIdx,
	    __largeDataIndices: largeDataIndices,
	    __barWidth: barWidth
	  });
	  group.add(el);
	  setLargeStyle(el, seriesModel, data); // Enable tooltip and user mouse/touch event handlers.
	
	  el.seriesIndex = seriesModel.seriesIndex;
	
	  if (!seriesModel.get('silent')) {
	    el.on('mousedown', largePathUpdateDataIndex);
	    el.on('mousemove', largePathUpdateDataIndex);
	  }
	} // Use throttle to avoid frequently traverse to find dataIndex.
	
	
	var largePathUpdateDataIndex = throttle(function (event) {
	  var largePath = this;
	  var dataIndex = largePathFindDataIndex(largePath, event.offsetX, event.offsetY);
	  largePath.dataIndex = dataIndex >= 0 ? dataIndex : null;
	}, 30, false);
	
	function largePathFindDataIndex(largePath, x, y) {
	  var baseDimIdx = largePath.__baseDimIdx;
	  var valueDimIdx = 1 - baseDimIdx;
	  var points = largePath.shape.points;
	  var largeDataIndices = largePath.__largeDataIndices;
	  var barWidthHalf = Math.abs(largePath.__barWidth / 2);
	  var startValueVal = largePath.__startPoint[valueDimIdx];
	  _eventPos[0] = x;
	  _eventPos[1] = y;
	  var pointerBaseVal = _eventPos[baseDimIdx];
	  var pointerValueVal = _eventPos[1 - baseDimIdx];
	  var baseLowerBound = pointerBaseVal - barWidthHalf;
	  var baseUpperBound = pointerBaseVal + barWidthHalf;
	
	  for (var i = 0, len = points.length / 2; i < len; i++) {
	    var ii = i * 2;
	    var barBaseVal = points[ii + baseDimIdx];
	    var barValueVal = points[ii + valueDimIdx];
	
	    if (barBaseVal >= baseLowerBound && barBaseVal <= baseUpperBound && (startValueVal <= barValueVal ? pointerValueVal >= startValueVal && pointerValueVal <= barValueVal : pointerValueVal >= barValueVal && pointerValueVal <= startValueVal)) {
	      return largeDataIndices[i];
	    }
	  }
	
	  return -1;
	}
	
	function setLargeStyle(el, seriesModel, data) {
	  var borderColor = data.getVisual('borderColor') || data.getVisual('color');
	  var itemStyle = seriesModel.getModel('itemStyle').getItemStyle(['color', 'borderColor']);
	  el.useStyle(itemStyle);
	  el.style.fill = null;
	  el.style.stroke = borderColor;
	  el.style.lineWidth = data.getLayout('barWidth');
	}
	
	function setLargeBackgroundStyle(el, backgroundModel, data) {
	  var borderColor = backgroundModel.get('borderColor') || backgroundModel.get('color');
	  var itemStyle = backgroundModel.getItemStyle(['color', 'borderColor']);
	  el.useStyle(itemStyle);
	  el.style.fill = null;
	  el.style.stroke = borderColor;
	  el.style.lineWidth = data.getLayout('barWidth');
	}
	
	function createBackgroundShape(isHorizontalOrRadial, layout, coord) {
	  var coordLayout;
	  var isPolar = coord.type === 'polar';
	
	  if (isPolar) {
	    coordLayout = coord.getArea();
	  } else {
	    coordLayout = coord.grid.getRect();
	  }
	
	  if (isPolar) {
	    return {
	      cx: coordLayout.cx,
	      cy: coordLayout.cy,
	      r0: isHorizontalOrRadial ? coordLayout.r0 : layout.r0,
	      r: isHorizontalOrRadial ? coordLayout.r : layout.r,
	      startAngle: isHorizontalOrRadial ? layout.startAngle : 0,
	      endAngle: isHorizontalOrRadial ? layout.endAngle : Math.PI * 2
	    };
	  } else {
	    return {
	      x: isHorizontalOrRadial ? layout.x : coordLayout.x,
	      y: isHorizontalOrRadial ? coordLayout.y : layout.y,
	      width: isHorizontalOrRadial ? layout.width : coordLayout.width,
	      height: isHorizontalOrRadial ? coordLayout.height : layout.height
	    };
	  }
	}
	
	function createBackgroundEl(coord, isHorizontalOrRadial, layout) {
	  var ElementClz = coord.type === 'polar' ? graphic.Sector : graphic.Rect;
	  return new ElementClz({
	    shape: createBackgroundShape(isHorizontalOrRadial, layout, coord),
	    silent: true,
	    z2: 0
	  });
	}
	
	module.exports = _default;

/***/ },
/* 1456 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var BaseBarSeries = __webpack_require__(696);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PictorialBarSeries = BaseBarSeries.extend({
	  type: 'series.pictorialBar',
	  dependencies: ['grid'],
	  defaultOption: {
	    symbol: 'circle',
	    // Customized bar shape
	    symbolSize: null,
	    // Can be ['100%', '100%'], null means auto.
	    symbolRotate: null,
	    symbolPosition: null,
	    // 'start' or 'end' or 'center', null means auto.
	    symbolOffset: null,
	    symbolMargin: null,
	    // start margin and end margin. Can be a number or a percent string.
	    // Auto margin by default.
	    symbolRepeat: false,
	    // false/null/undefined, means no repeat.
	    // Can be true, means auto calculate repeat times and cut by data.
	    // Can be a number, specifies repeat times, and do not cut by data.
	    // Can be 'fixed', means auto calculate repeat times but do not cut by data.
	    symbolRepeatDirection: 'end',
	    // 'end' means from 'start' to 'end'.
	    symbolClip: false,
	    symbolBoundingData: null,
	    // Can be 60 or -40 or [-40, 60]
	    symbolPatternSize: 400,
	    // 400 * 400 px
	    barGap: '-100%',
	    // In most case, overlap is needed.
	    // z can be set in data item, which is z2 actually.
	    // Disable progressive
	    progressive: 0,
	    hoverAnimation: false // Open only when needed.
	
	  },
	  getInitialData: function (option) {
	    // Disable stack.
	    option.stack = null;
	    return PictorialBarSeries.superApply(this, 'getInitialData', arguments);
	  }
	});
	var _default = PictorialBarSeries;
	module.exports = _default;

/***/ },
/* 1457 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var graphic = __webpack_require__(16);
	
	var _symbol = __webpack_require__(84);
	
	var createSymbol = _symbol.createSymbol;
	
	var _number = __webpack_require__(20);
	
	var parsePercent = _number.parsePercent;
	var isNumeric = _number.isNumeric;
	
	var _helper = __webpack_require__(697);
	
	var setLabel = _helper.setLabel;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var BAR_BORDER_WIDTH_QUERY = ['itemStyle', 'borderWidth']; // index: +isHorizontal
	
	var LAYOUT_ATTRS = [{
	  xy: 'x',
	  wh: 'width',
	  index: 0,
	  posDesc: ['left', 'right']
	}, {
	  xy: 'y',
	  wh: 'height',
	  index: 1,
	  posDesc: ['top', 'bottom']
	}];
	var pathForLineWidth = new graphic.Circle();
	var BarView = echarts.extendChartView({
	  type: 'pictorialBar',
	  render: function (seriesModel, ecModel, api) {
	    var group = this.group;
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var cartesian = seriesModel.coordinateSystem;
	    var baseAxis = cartesian.getBaseAxis();
	    var isHorizontal = !!baseAxis.isHorizontal();
	    var coordSysRect = cartesian.grid.getRect();
	    var opt = {
	      ecSize: {
	        width: api.getWidth(),
	        height: api.getHeight()
	      },
	      seriesModel: seriesModel,
	      coordSys: cartesian,
	      coordSysExtent: [[coordSysRect.x, coordSysRect.x + coordSysRect.width], [coordSysRect.y, coordSysRect.y + coordSysRect.height]],
	      isHorizontal: isHorizontal,
	      valueDim: LAYOUT_ATTRS[+isHorizontal],
	      categoryDim: LAYOUT_ATTRS[1 - isHorizontal]
	    };
	    data.diff(oldData).add(function (dataIndex) {
	      if (!data.hasValue(dataIndex)) {
	        return;
	      }
	
	      var itemModel = getItemModel(data, dataIndex);
	      var symbolMeta = getSymbolMeta(data, dataIndex, itemModel, opt);
	      var bar = createBar(data, opt, symbolMeta);
	      data.setItemGraphicEl(dataIndex, bar);
	      group.add(bar);
	      updateCommon(bar, opt, symbolMeta);
	    }).update(function (newIndex, oldIndex) {
	      var bar = oldData.getItemGraphicEl(oldIndex);
	
	      if (!data.hasValue(newIndex)) {
	        group.remove(bar);
	        return;
	      }
	
	      var itemModel = getItemModel(data, newIndex);
	      var symbolMeta = getSymbolMeta(data, newIndex, itemModel, opt);
	      var pictorialShapeStr = getShapeStr(data, symbolMeta);
	
	      if (bar && pictorialShapeStr !== bar.__pictorialShapeStr) {
	        group.remove(bar);
	        data.setItemGraphicEl(newIndex, null);
	        bar = null;
	      }
	
	      if (bar) {
	        updateBar(bar, opt, symbolMeta);
	      } else {
	        bar = createBar(data, opt, symbolMeta, true);
	      }
	
	      data.setItemGraphicEl(newIndex, bar);
	      bar.__pictorialSymbolMeta = symbolMeta; // Add back
	
	      group.add(bar);
	      updateCommon(bar, opt, symbolMeta);
	    }).remove(function (dataIndex) {
	      var bar = oldData.getItemGraphicEl(dataIndex);
	      bar && removeBar(oldData, dataIndex, bar.__pictorialSymbolMeta.animationModel, bar);
	    }).execute();
	    this._data = data;
	    return this.group;
	  },
	  dispose: zrUtil.noop,
	  remove: function (ecModel, api) {
	    var group = this.group;
	    var data = this._data;
	
	    if (ecModel.get('animation')) {
	      if (data) {
	        data.eachItemGraphicEl(function (bar) {
	          removeBar(data, bar.dataIndex, ecModel, bar);
	        });
	      }
	    } else {
	      group.removeAll();
	    }
	  }
	}); // Set or calculate default value about symbol, and calculate layout info.
	
	function getSymbolMeta(data, dataIndex, itemModel, opt) {
	  var layout = data.getItemLayout(dataIndex);
	  var symbolRepeat = itemModel.get('symbolRepeat');
	  var symbolClip = itemModel.get('symbolClip');
	  var symbolPosition = itemModel.get('symbolPosition') || 'start';
	  var symbolRotate = itemModel.get('symbolRotate');
	  var rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
	  var symbolPatternSize = itemModel.get('symbolPatternSize') || 2;
	  var isAnimationEnabled = itemModel.isAnimationEnabled();
	  var symbolMeta = {
	    dataIndex: dataIndex,
	    layout: layout,
	    itemModel: itemModel,
	    symbolType: data.getItemVisual(dataIndex, 'symbol') || 'circle',
	    color: data.getItemVisual(dataIndex, 'color'),
	    symbolClip: symbolClip,
	    symbolRepeat: symbolRepeat,
	    symbolRepeatDirection: itemModel.get('symbolRepeatDirection'),
	    symbolPatternSize: symbolPatternSize,
	    rotation: rotation,
	    animationModel: isAnimationEnabled ? itemModel : null,
	    hoverAnimation: isAnimationEnabled && itemModel.get('hoverAnimation'),
	    z2: itemModel.getShallow('z', true) || 0
	  };
	  prepareBarLength(itemModel, symbolRepeat, layout, opt, symbolMeta);
	  prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, symbolMeta.boundingLength, symbolMeta.pxSign, symbolPatternSize, opt, symbolMeta);
	  prepareLineWidth(itemModel, symbolMeta.symbolScale, rotation, opt, symbolMeta);
	  var symbolSize = symbolMeta.symbolSize;
	  var symbolOffset = itemModel.get('symbolOffset');
	
	  if (zrUtil.isArray(symbolOffset)) {
	    symbolOffset = [parsePercent(symbolOffset[0], symbolSize[0]), parsePercent(symbolOffset[1], symbolSize[1])];
	  }
	
	  prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, symbolMeta.valueLineWidth, symbolMeta.boundingLength, symbolMeta.repeatCutLength, opt, symbolMeta);
	  return symbolMeta;
	} // bar length can be negative.
	
	
	function prepareBarLength(itemModel, symbolRepeat, layout, opt, output) {
	  var valueDim = opt.valueDim;
	  var symbolBoundingData = itemModel.get('symbolBoundingData');
	  var valueAxis = opt.coordSys.getOtherAxis(opt.coordSys.getBaseAxis());
	  var zeroPx = valueAxis.toGlobalCoord(valueAxis.dataToCoord(0));
	  var pxSignIdx = 1 - +(layout[valueDim.wh] <= 0);
	  var boundingLength;
	
	  if (zrUtil.isArray(symbolBoundingData)) {
	    var symbolBoundingExtent = [convertToCoordOnAxis(valueAxis, symbolBoundingData[0]) - zeroPx, convertToCoordOnAxis(valueAxis, symbolBoundingData[1]) - zeroPx];
	    symbolBoundingExtent[1] < symbolBoundingExtent[0] && symbolBoundingExtent.reverse();
	    boundingLength = symbolBoundingExtent[pxSignIdx];
	  } else if (symbolBoundingData != null) {
	    boundingLength = convertToCoordOnAxis(valueAxis, symbolBoundingData) - zeroPx;
	  } else if (symbolRepeat) {
	    boundingLength = opt.coordSysExtent[valueDim.index][pxSignIdx] - zeroPx;
	  } else {
	    boundingLength = layout[valueDim.wh];
	  }
	
	  output.boundingLength = boundingLength;
	
	  if (symbolRepeat) {
	    output.repeatCutLength = layout[valueDim.wh];
	  }
	
	  output.pxSign = boundingLength > 0 ? 1 : boundingLength < 0 ? -1 : 0;
	}
	
	function convertToCoordOnAxis(axis, value) {
	  return axis.toGlobalCoord(axis.dataToCoord(axis.scale.parse(value)));
	} // Support ['100%', '100%']
	
	
	function prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, boundingLength, pxSign, symbolPatternSize, opt, output) {
	  var valueDim = opt.valueDim;
	  var categoryDim = opt.categoryDim;
	  var categorySize = Math.abs(layout[categoryDim.wh]);
	  var symbolSize = data.getItemVisual(dataIndex, 'symbolSize');
	
	  if (zrUtil.isArray(symbolSize)) {
	    symbolSize = symbolSize.slice();
	  } else {
	    if (symbolSize == null) {
	      symbolSize = '100%';
	    }
	
	    symbolSize = [symbolSize, symbolSize];
	  } // Note: percentage symbolSize (like '100%') do not consider lineWidth, because it is
	  // to complicated to calculate real percent value if considering scaled lineWidth.
	  // So the actual size will bigger than layout size if lineWidth is bigger than zero,
	  // which can be tolerated in pictorial chart.
	
	
	  symbolSize[categoryDim.index] = parsePercent(symbolSize[categoryDim.index], categorySize);
	  symbolSize[valueDim.index] = parsePercent(symbolSize[valueDim.index], symbolRepeat ? categorySize : Math.abs(boundingLength));
	  output.symbolSize = symbolSize; // If x or y is less than zero, show reversed shape.
	
	  var symbolScale = output.symbolScale = [symbolSize[0] / symbolPatternSize, symbolSize[1] / symbolPatternSize]; // Follow convention, 'right' and 'top' is the normal scale.
	
	  symbolScale[valueDim.index] *= (opt.isHorizontal ? -1 : 1) * pxSign;
	}
	
	function prepareLineWidth(itemModel, symbolScale, rotation, opt, output) {
	  // In symbols are drawn with scale, so do not need to care about the case that width
	  // or height are too small. But symbol use strokeNoScale, where acture lineWidth should
	  // be calculated.
	  var valueLineWidth = itemModel.get(BAR_BORDER_WIDTH_QUERY) || 0;
	
	  if (valueLineWidth) {
	    pathForLineWidth.attr({
	      scale: symbolScale.slice(),
	      rotation: rotation
	    });
	    pathForLineWidth.updateTransform();
	    valueLineWidth /= pathForLineWidth.getLineScale();
	    valueLineWidth *= symbolScale[opt.valueDim.index];
	  }
	
	  output.valueLineWidth = valueLineWidth;
	}
	
	function prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, valueLineWidth, boundingLength, repeatCutLength, opt, output) {
	  var categoryDim = opt.categoryDim;
	  var valueDim = opt.valueDim;
	  var pxSign = output.pxSign;
	  var unitLength = Math.max(symbolSize[valueDim.index] + valueLineWidth, 0);
	  var pathLen = unitLength; // Note: rotation will not effect the layout of symbols, because user may
	  // want symbols to rotate on its center, which should not be translated
	  // when rotating.
	
	  if (symbolRepeat) {
	    var absBoundingLength = Math.abs(boundingLength);
	    var symbolMargin = zrUtil.retrieve(itemModel.get('symbolMargin'), '15%') + '';
	    var hasEndGap = false;
	
	    if (symbolMargin.lastIndexOf('!') === symbolMargin.length - 1) {
	      hasEndGap = true;
	      symbolMargin = symbolMargin.slice(0, symbolMargin.length - 1);
	    }
	
	    symbolMargin = parsePercent(symbolMargin, symbolSize[valueDim.index]);
	    var uLenWithMargin = Math.max(unitLength + symbolMargin * 2, 0); // When symbol margin is less than 0, margin at both ends will be subtracted
	    // to ensure that all of the symbols will not be overflow the given area.
	
	    var endFix = hasEndGap ? 0 : symbolMargin * 2; // Both final repeatTimes and final symbolMargin area calculated based on
	    // boundingLength.
	
	    var repeatSpecified = isNumeric(symbolRepeat);
	    var repeatTimes = repeatSpecified ? symbolRepeat : toIntTimes((absBoundingLength + endFix) / uLenWithMargin); // Adjust calculate margin, to ensure each symbol is displayed
	    // entirely in the given layout area.
	
	    var mDiff = absBoundingLength - repeatTimes * unitLength;
	    symbolMargin = mDiff / 2 / (hasEndGap ? repeatTimes : repeatTimes - 1);
	    uLenWithMargin = unitLength + symbolMargin * 2;
	    endFix = hasEndGap ? 0 : symbolMargin * 2; // Update repeatTimes when not all symbol will be shown.
	
	    if (!repeatSpecified && symbolRepeat !== 'fixed') {
	      repeatTimes = repeatCutLength ? toIntTimes((Math.abs(repeatCutLength) + endFix) / uLenWithMargin) : 0;
	    }
	
	    pathLen = repeatTimes * uLenWithMargin - endFix;
	    output.repeatTimes = repeatTimes;
	    output.symbolMargin = symbolMargin;
	  }
	
	  var sizeFix = pxSign * (pathLen / 2);
	  var pathPosition = output.pathPosition = [];
	  pathPosition[categoryDim.index] = layout[categoryDim.wh] / 2;
	  pathPosition[valueDim.index] = symbolPosition === 'start' ? sizeFix : symbolPosition === 'end' ? boundingLength - sizeFix : boundingLength / 2; // 'center'
	
	  if (symbolOffset) {
	    pathPosition[0] += symbolOffset[0];
	    pathPosition[1] += symbolOffset[1];
	  }
	
	  var bundlePosition = output.bundlePosition = [];
	  bundlePosition[categoryDim.index] = layout[categoryDim.xy];
	  bundlePosition[valueDim.index] = layout[valueDim.xy];
	  var barRectShape = output.barRectShape = zrUtil.extend({}, layout);
	  barRectShape[valueDim.wh] = pxSign * Math.max(Math.abs(layout[valueDim.wh]), Math.abs(pathPosition[valueDim.index] + sizeFix));
	  barRectShape[categoryDim.wh] = layout[categoryDim.wh];
	  var clipShape = output.clipShape = {}; // Consider that symbol may be overflow layout rect.
	
	  clipShape[categoryDim.xy] = -layout[categoryDim.xy];
	  clipShape[categoryDim.wh] = opt.ecSize[categoryDim.wh];
	  clipShape[valueDim.xy] = 0;
	  clipShape[valueDim.wh] = layout[valueDim.wh];
	}
	
	function createPath(symbolMeta) {
	  var symbolPatternSize = symbolMeta.symbolPatternSize;
	  var path = createSymbol( // Consider texture img, make a big size.
	  symbolMeta.symbolType, -symbolPatternSize / 2, -symbolPatternSize / 2, symbolPatternSize, symbolPatternSize, symbolMeta.color);
	  path.attr({
	    culling: true
	  });
	  path.type !== 'image' && path.setStyle({
	    strokeNoScale: true
	  });
	  return path;
	}
	
	function createOrUpdateRepeatSymbols(bar, opt, symbolMeta, isUpdate) {
	  var bundle = bar.__pictorialBundle;
	  var symbolSize = symbolMeta.symbolSize;
	  var valueLineWidth = symbolMeta.valueLineWidth;
	  var pathPosition = symbolMeta.pathPosition;
	  var valueDim = opt.valueDim;
	  var repeatTimes = symbolMeta.repeatTimes || 0;
	  var index = 0;
	  var unit = symbolSize[opt.valueDim.index] + valueLineWidth + symbolMeta.symbolMargin * 2;
	  eachPath(bar, function (path) {
	    path.__pictorialAnimationIndex = index;
	    path.__pictorialRepeatTimes = repeatTimes;
	
	    if (index < repeatTimes) {
	      updateAttr(path, null, makeTarget(index), symbolMeta, isUpdate);
	    } else {
	      updateAttr(path, null, {
	        scale: [0, 0]
	      }, symbolMeta, isUpdate, function () {
	        bundle.remove(path);
	      });
	    }
	
	    updateHoverAnimation(path, symbolMeta);
	    index++;
	  });
	
	  for (; index < repeatTimes; index++) {
	    var path = createPath(symbolMeta);
	    path.__pictorialAnimationIndex = index;
	    path.__pictorialRepeatTimes = repeatTimes;
	    bundle.add(path);
	    var target = makeTarget(index);
	    updateAttr(path, {
	      position: target.position,
	      scale: [0, 0]
	    }, {
	      scale: target.scale,
	      rotation: target.rotation
	    }, symbolMeta, isUpdate); // FIXME
	    // If all emphasis/normal through action.
	
	    path.on('mouseover', onMouseOver).on('mouseout', onMouseOut);
	    updateHoverAnimation(path, symbolMeta);
	  }
	
	  function makeTarget(index) {
	    var position = pathPosition.slice(); // (start && pxSign > 0) || (end && pxSign < 0): i = repeatTimes - index
	    // Otherwise: i = index;
	
	    var pxSign = symbolMeta.pxSign;
	    var i = index;
	
	    if (symbolMeta.symbolRepeatDirection === 'start' ? pxSign > 0 : pxSign < 0) {
	      i = repeatTimes - 1 - index;
	    }
	
	    position[valueDim.index] = unit * (i - repeatTimes / 2 + 0.5) + pathPosition[valueDim.index];
	    return {
	      position: position,
	      scale: symbolMeta.symbolScale.slice(),
	      rotation: symbolMeta.rotation
	    };
	  }
	
	  function onMouseOver() {
	    eachPath(bar, function (path) {
	      path.trigger('emphasis');
	    });
	  }
	
	  function onMouseOut() {
	    eachPath(bar, function (path) {
	      path.trigger('normal');
	    });
	  }
	}
	
	function createOrUpdateSingleSymbol(bar, opt, symbolMeta, isUpdate) {
	  var bundle = bar.__pictorialBundle;
	  var mainPath = bar.__pictorialMainPath;
	
	  if (!mainPath) {
	    mainPath = bar.__pictorialMainPath = createPath(symbolMeta);
	    bundle.add(mainPath);
	    updateAttr(mainPath, {
	      position: symbolMeta.pathPosition.slice(),
	      scale: [0, 0],
	      rotation: symbolMeta.rotation
	    }, {
	      scale: symbolMeta.symbolScale.slice()
	    }, symbolMeta, isUpdate);
	    mainPath.on('mouseover', onMouseOver).on('mouseout', onMouseOut);
	  } else {
	    updateAttr(mainPath, null, {
	      position: symbolMeta.pathPosition.slice(),
	      scale: symbolMeta.symbolScale.slice(),
	      rotation: symbolMeta.rotation
	    }, symbolMeta, isUpdate);
	  }
	
	  updateHoverAnimation(mainPath, symbolMeta);
	
	  function onMouseOver() {
	    this.trigger('emphasis');
	  }
	
	  function onMouseOut() {
	    this.trigger('normal');
	  }
	} // bar rect is used for label.
	
	
	function createOrUpdateBarRect(bar, symbolMeta, isUpdate) {
	  var rectShape = zrUtil.extend({}, symbolMeta.barRectShape);
	  var barRect = bar.__pictorialBarRect;
	
	  if (!barRect) {
	    barRect = bar.__pictorialBarRect = new graphic.Rect({
	      z2: 2,
	      shape: rectShape,
	      silent: true,
	      style: {
	        stroke: 'transparent',
	        fill: 'transparent',
	        lineWidth: 0
	      }
	    });
	    bar.add(barRect);
	  } else {
	    updateAttr(barRect, null, {
	      shape: rectShape
	    }, symbolMeta, isUpdate);
	  }
	}
	
	function createOrUpdateClip(bar, opt, symbolMeta, isUpdate) {
	  // If not clip, symbol will be remove and rebuilt.
	  if (symbolMeta.symbolClip) {
	    var clipPath = bar.__pictorialClipPath;
	    var clipShape = zrUtil.extend({}, symbolMeta.clipShape);
	    var valueDim = opt.valueDim;
	    var animationModel = symbolMeta.animationModel;
	    var dataIndex = symbolMeta.dataIndex;
	
	    if (clipPath) {
	      graphic.updateProps(clipPath, {
	        shape: clipShape
	      }, animationModel, dataIndex);
	    } else {
	      clipShape[valueDim.wh] = 0;
	      clipPath = new graphic.Rect({
	        shape: clipShape
	      });
	
	      bar.__pictorialBundle.setClipPath(clipPath);
	
	      bar.__pictorialClipPath = clipPath;
	      var target = {};
	      target[valueDim.wh] = symbolMeta.clipShape[valueDim.wh];
	      graphic[isUpdate ? 'updateProps' : 'initProps'](clipPath, {
	        shape: target
	      }, animationModel, dataIndex);
	    }
	  }
	}
	
	function getItemModel(data, dataIndex) {
	  var itemModel = data.getItemModel(dataIndex);
	  itemModel.getAnimationDelayParams = getAnimationDelayParams;
	  itemModel.isAnimationEnabled = isAnimationEnabled;
	  return itemModel;
	}
	
	function getAnimationDelayParams(path) {
	  // The order is the same as the z-order, see `symbolRepeatDiretion`.
	  return {
	    index: path.__pictorialAnimationIndex,
	    count: path.__pictorialRepeatTimes
	  };
	}
	
	function isAnimationEnabled() {
	  // `animation` prop can be set on itemModel in pictorial bar chart.
	  return this.parentModel.isAnimationEnabled() && !!this.getShallow('animation');
	}
	
	function updateHoverAnimation(path, symbolMeta) {
	  path.off('emphasis').off('normal');
	  var scale = symbolMeta.symbolScale.slice();
	  symbolMeta.hoverAnimation && path.on('emphasis', function () {
	    this.animateTo({
	      scale: [scale[0] * 1.1, scale[1] * 1.1]
	    }, 400, 'elasticOut');
	  }).on('normal', function () {
	    this.animateTo({
	      scale: scale.slice()
	    }, 400, 'elasticOut');
	  });
	}
	
	function createBar(data, opt, symbolMeta, isUpdate) {
	  // bar is the main element for each data.
	  var bar = new graphic.Group(); // bundle is used for location and clip.
	
	  var bundle = new graphic.Group();
	  bar.add(bundle);
	  bar.__pictorialBundle = bundle;
	  bundle.attr('position', symbolMeta.bundlePosition.slice());
	
	  if (symbolMeta.symbolRepeat) {
	    createOrUpdateRepeatSymbols(bar, opt, symbolMeta);
	  } else {
	    createOrUpdateSingleSymbol(bar, opt, symbolMeta);
	  }
	
	  createOrUpdateBarRect(bar, symbolMeta, isUpdate);
	  createOrUpdateClip(bar, opt, symbolMeta, isUpdate);
	  bar.__pictorialShapeStr = getShapeStr(data, symbolMeta);
	  bar.__pictorialSymbolMeta = symbolMeta;
	  return bar;
	}
	
	function updateBar(bar, opt, symbolMeta) {
	  var animationModel = symbolMeta.animationModel;
	  var dataIndex = symbolMeta.dataIndex;
	  var bundle = bar.__pictorialBundle;
	  graphic.updateProps(bundle, {
	    position: symbolMeta.bundlePosition.slice()
	  }, animationModel, dataIndex);
	
	  if (symbolMeta.symbolRepeat) {
	    createOrUpdateRepeatSymbols(bar, opt, symbolMeta, true);
	  } else {
	    createOrUpdateSingleSymbol(bar, opt, symbolMeta, true);
	  }
	
	  createOrUpdateBarRect(bar, symbolMeta, true);
	  createOrUpdateClip(bar, opt, symbolMeta, true);
	}
	
	function removeBar(data, dataIndex, animationModel, bar) {
	  // Not show text when animating
	  var labelRect = bar.__pictorialBarRect;
	  labelRect && (labelRect.style.text = null);
	  var pathes = [];
	  eachPath(bar, function (path) {
	    pathes.push(path);
	  });
	  bar.__pictorialMainPath && pathes.push(bar.__pictorialMainPath); // I do not find proper remove animation for clip yet.
	
	  bar.__pictorialClipPath && (animationModel = null);
	  zrUtil.each(pathes, function (path) {
	    graphic.updateProps(path, {
	      scale: [0, 0]
	    }, animationModel, dataIndex, function () {
	      bar.parent && bar.parent.remove(bar);
	    });
	  });
	  data.setItemGraphicEl(dataIndex, null);
	}
	
	function getShapeStr(data, symbolMeta) {
	  return [data.getItemVisual(symbolMeta.dataIndex, 'symbol') || 'none', !!symbolMeta.symbolRepeat, !!symbolMeta.symbolClip].join(':');
	}
	
	function eachPath(bar, cb, context) {
	  // Do not use Group#eachChild, because it do not support remove.
	  zrUtil.each(bar.__pictorialBundle.children(), function (el) {
	    el !== bar.__pictorialBarRect && cb.call(context, el);
	  });
	}
	
	function updateAttr(el, immediateAttrs, animationAttrs, symbolMeta, isUpdate, cb) {
	  immediateAttrs && el.attr(immediateAttrs); // when symbolCip used, only clip path has init animation, otherwise it would be weird effect.
	
	  if (symbolMeta.symbolClip && !isUpdate) {
	    animationAttrs && el.attr(animationAttrs);
	  } else {
	    animationAttrs && graphic[isUpdate ? 'updateProps' : 'initProps'](el, animationAttrs, symbolMeta.animationModel, symbolMeta.dataIndex, cb);
	  }
	}
	
	function updateCommon(bar, opt, symbolMeta) {
	  var color = symbolMeta.color;
	  var dataIndex = symbolMeta.dataIndex;
	  var itemModel = symbolMeta.itemModel; // Color must be excluded.
	  // Because symbol provide setColor individually to set fill and stroke
	
	  var normalStyle = itemModel.getModel('itemStyle').getItemStyle(['color']);
	  var hoverStyle = itemModel.getModel('emphasis.itemStyle').getItemStyle();
	  var cursorStyle = itemModel.getShallow('cursor');
	  eachPath(bar, function (path) {
	    // PENDING setColor should be before setStyle!!!
	    path.setColor(color);
	    path.setStyle(zrUtil.defaults({
	      fill: color,
	      opacity: symbolMeta.opacity
	    }, normalStyle));
	    graphic.setHoverStyle(path, hoverStyle);
	    cursorStyle && (path.cursor = cursorStyle);
	    path.z2 = symbolMeta.z2;
	  });
	  var barRectHoverStyle = {};
	  var barPositionOutside = opt.valueDim.posDesc[+(symbolMeta.boundingLength > 0)];
	  var barRect = bar.__pictorialBarRect;
	  setLabel(barRect.style, barRectHoverStyle, itemModel, color, opt.seriesModel, dataIndex, barPositionOutside);
	  graphic.setHoverStyle(barRect, barRectHoverStyle);
	}
	
	function toIntTimes(times) {
	  var roundedTimes = Math.round(times); // Escapse accurate error
	
	  return Math.abs(times - roundedTimes) < 1e-4 ? roundedTimes : Math.ceil(times);
	}
	
	var _default = BarView;
	module.exports = _default;

/***/ },
/* 1458 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var makeStyleMapper = __webpack_require__(208);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var getBarItemStyle = makeStyleMapper([['fill', 'color'], ['stroke', 'borderColor'], ['lineWidth', 'borderWidth'], // Compatitable with 2
	['stroke', 'barBorderColor'], ['lineWidth', 'barBorderWidth'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor']]);
	var _default = {
	  getBarItemStyle: function (excludes) {
	    var style = getBarItemStyle(this, excludes);
	
	    if (this.getBorderLineDash) {
	      var lineDash = this.getBorderLineDash();
	      lineDash && (style.lineDash = lineDash);
	    }
	
	    return style;
	  }
	};
	module.exports = _default;

/***/ },
/* 1459 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	__webpack_require__(1460);
	
	__webpack_require__(1461);
	
	var boxplotVisual = __webpack_require__(1463);
	
	var boxplotLayout = __webpack_require__(1462);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(boxplotVisual);
	echarts.registerLayout(boxplotLayout);

/***/ },
/* 1460 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var SeriesModel = __webpack_require__(58);
	
	var _whiskerBoxCommon = __webpack_require__(704);
	
	var seriesModelMixin = _whiskerBoxCommon.seriesModelMixin;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var BoxplotSeries = SeriesModel.extend({
	  type: 'series.boxplot',
	  dependencies: ['xAxis', 'yAxis', 'grid'],
	  // TODO
	  // box width represents group size, so dimension should have 'size'.
	
	  /**
	   * @see <https://en.wikipedia.org/wiki/Box_plot>
	   * The meanings of 'min' and 'max' depend on user,
	   * and echarts do not need to know it.
	   * @readOnly
	   */
	  defaultValueDimensions: [{
	    name: 'min',
	    defaultTooltip: true
	  }, {
	    name: 'Q1',
	    defaultTooltip: true
	  }, {
	    name: 'median',
	    defaultTooltip: true
	  }, {
	    name: 'Q3',
	    defaultTooltip: true
	  }, {
	    name: 'max',
	    defaultTooltip: true
	  }],
	
	  /**
	   * @type {Array.<string>}
	   * @readOnly
	   */
	  dimensions: null,
	
	  /**
	   * @override
	   */
	  defaultOption: {
	    zlevel: 0,
	    // 一级层叠
	    z: 2,
	    // 二级层叠
	    coordinateSystem: 'cartesian2d',
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    layout: null,
	    // 'horizontal' or 'vertical'
	    boxWidth: [7, 50],
	    // [min, max] can be percent of band width.
	    itemStyle: {
	      color: '#fff',
	      borderWidth: 1
	    },
	    emphasis: {
	      itemStyle: {
	        borderWidth: 2,
	        shadowBlur: 5,
	        shadowOffsetX: 2,
	        shadowOffsetY: 2,
	        shadowColor: 'rgba(0,0,0,0.4)'
	      }
	    },
	    animationEasing: 'elasticOut',
	    animationDuration: 800
	  }
	});
	zrUtil.mixin(BoxplotSeries, seriesModelMixin, true);
	var _default = BoxplotSeries;
	module.exports = _default;

/***/ },
/* 1461 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var ChartView = __webpack_require__(106);
	
	var graphic = __webpack_require__(16);
	
	var Path = __webpack_require__(46);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Update common properties
	var NORMAL_ITEM_STYLE_PATH = ['itemStyle'];
	var EMPHASIS_ITEM_STYLE_PATH = ['emphasis', 'itemStyle'];
	var BoxplotView = ChartView.extend({
	  type: 'boxplot',
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    var group = this.group;
	    var oldData = this._data; // There is no old data only when first rendering or switching from
	    // stream mode to normal mode, where previous elements should be removed.
	
	    if (!this._data) {
	      group.removeAll();
	    }
	
	    var constDim = seriesModel.get('layout') === 'horizontal' ? 1 : 0;
	    data.diff(oldData).add(function (newIdx) {
	      if (data.hasValue(newIdx)) {
	        var itemLayout = data.getItemLayout(newIdx);
	        var symbolEl = createNormalBox(itemLayout, data, newIdx, constDim, true);
	        data.setItemGraphicEl(newIdx, symbolEl);
	        group.add(symbolEl);
	      }
	    }).update(function (newIdx, oldIdx) {
	      var symbolEl = oldData.getItemGraphicEl(oldIdx); // Empty data
	
	      if (!data.hasValue(newIdx)) {
	        group.remove(symbolEl);
	        return;
	      }
	
	      var itemLayout = data.getItemLayout(newIdx);
	
	      if (!symbolEl) {
	        symbolEl = createNormalBox(itemLayout, data, newIdx, constDim);
	      } else {
	        updateNormalBoxData(itemLayout, symbolEl, data, newIdx);
	      }
	
	      group.add(symbolEl);
	      data.setItemGraphicEl(newIdx, symbolEl);
	    }).remove(function (oldIdx) {
	      var el = oldData.getItemGraphicEl(oldIdx);
	      el && group.remove(el);
	    }).execute();
	    this._data = data;
	  },
	  remove: function (ecModel) {
	    var group = this.group;
	    var data = this._data;
	    this._data = null;
	    data && data.eachItemGraphicEl(function (el) {
	      el && group.remove(el);
	    });
	  },
	  dispose: zrUtil.noop
	});
	var BoxPath = Path.extend({
	  type: 'boxplotBoxPath',
	  shape: {},
	  buildPath: function (ctx, shape) {
	    var ends = shape.points;
	    var i = 0;
	    ctx.moveTo(ends[i][0], ends[i][1]);
	    i++;
	
	    for (; i < 4; i++) {
	      ctx.lineTo(ends[i][0], ends[i][1]);
	    }
	
	    ctx.closePath();
	
	    for (; i < ends.length; i++) {
	      ctx.moveTo(ends[i][0], ends[i][1]);
	      i++;
	      ctx.lineTo(ends[i][0], ends[i][1]);
	    }
	  }
	});
	
	function createNormalBox(itemLayout, data, dataIndex, constDim, isInit) {
	  var ends = itemLayout.ends;
	  var el = new BoxPath({
	    shape: {
	      points: isInit ? transInit(ends, constDim, itemLayout) : ends
	    }
	  });
	  updateNormalBoxData(itemLayout, el, data, dataIndex, isInit);
	  return el;
	}
	
	function updateNormalBoxData(itemLayout, el, data, dataIndex, isInit) {
	  var seriesModel = data.hostModel;
	  var updateMethod = graphic[isInit ? 'initProps' : 'updateProps'];
	  updateMethod(el, {
	    shape: {
	      points: itemLayout.ends
	    }
	  }, seriesModel, dataIndex);
	  var itemModel = data.getItemModel(dataIndex);
	  var normalItemStyleModel = itemModel.getModel(NORMAL_ITEM_STYLE_PATH);
	  var borderColor = data.getItemVisual(dataIndex, 'color'); // Exclude borderColor.
	
	  var itemStyle = normalItemStyleModel.getItemStyle(['borderColor']);
	  itemStyle.stroke = borderColor;
	  itemStyle.strokeNoScale = true;
	  el.useStyle(itemStyle);
	  el.z2 = 100;
	  var hoverStyle = itemModel.getModel(EMPHASIS_ITEM_STYLE_PATH).getItemStyle();
	  graphic.setHoverStyle(el, hoverStyle);
	}
	
	function transInit(points, dim, itemLayout) {
	  return zrUtil.map(points, function (point) {
	    point = point.slice();
	    point[dim] = itemLayout.initBaseline;
	    return point;
	  });
	}
	
	var _default = BoxplotView;
	module.exports = _default;

/***/ },
/* 1462 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var _number = __webpack_require__(20);
	
	var parsePercent = _number.parsePercent;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	
	function _default(ecModel) {
	  var groupResult = groupSeriesByAxis(ecModel);
	  each(groupResult, function (groupItem) {
	    var seriesModels = groupItem.seriesModels;
	
	    if (!seriesModels.length) {
	      return;
	    }
	
	    calculateBase(groupItem);
	    each(seriesModels, function (seriesModel, idx) {
	      layoutSingleSeries(seriesModel, groupItem.boxOffsetList[idx], groupItem.boxWidthList[idx]);
	    });
	  });
	}
	/**
	 * Group series by axis.
	 */
	
	
	function groupSeriesByAxis(ecModel) {
	  var result = [];
	  var axisList = [];
	  ecModel.eachSeriesByType('boxplot', function (seriesModel) {
	    var baseAxis = seriesModel.getBaseAxis();
	    var idx = zrUtil.indexOf(axisList, baseAxis);
	
	    if (idx < 0) {
	      idx = axisList.length;
	      axisList[idx] = baseAxis;
	      result[idx] = {
	        axis: baseAxis,
	        seriesModels: []
	      };
	    }
	
	    result[idx].seriesModels.push(seriesModel);
	  });
	  return result;
	}
	/**
	 * Calculate offset and box width for each series.
	 */
	
	
	function calculateBase(groupItem) {
	  var extent;
	  var baseAxis = groupItem.axis;
	  var seriesModels = groupItem.seriesModels;
	  var seriesCount = seriesModels.length;
	  var boxWidthList = groupItem.boxWidthList = [];
	  var boxOffsetList = groupItem.boxOffsetList = [];
	  var boundList = [];
	  var bandWidth;
	
	  if (baseAxis.type === 'category') {
	    bandWidth = baseAxis.getBandWidth();
	  } else {
	    var maxDataCount = 0;
	    each(seriesModels, function (seriesModel) {
	      maxDataCount = Math.max(maxDataCount, seriesModel.getData().count());
	    });
	    extent = baseAxis.getExtent(), Math.abs(extent[1] - extent[0]) / maxDataCount;
	  }
	
	  each(seriesModels, function (seriesModel) {
	    var boxWidthBound = seriesModel.get('boxWidth');
	
	    if (!zrUtil.isArray(boxWidthBound)) {
	      boxWidthBound = [boxWidthBound, boxWidthBound];
	    }
	
	    boundList.push([parsePercent(boxWidthBound[0], bandWidth) || 0, parsePercent(boxWidthBound[1], bandWidth) || 0]);
	  });
	  var availableWidth = bandWidth * 0.8 - 2;
	  var boxGap = availableWidth / seriesCount * 0.3;
	  var boxWidth = (availableWidth - boxGap * (seriesCount - 1)) / seriesCount;
	  var base = boxWidth / 2 - availableWidth / 2;
	  each(seriesModels, function (seriesModel, idx) {
	    boxOffsetList.push(base);
	    base += boxGap + boxWidth;
	    boxWidthList.push(Math.min(Math.max(boxWidth, boundList[idx][0]), boundList[idx][1]));
	  });
	}
	/**
	 * Calculate points location for each series.
	 */
	
	
	function layoutSingleSeries(seriesModel, offset, boxWidth) {
	  var coordSys = seriesModel.coordinateSystem;
	  var data = seriesModel.getData();
	  var halfWidth = boxWidth / 2;
	  var cDimIdx = seriesModel.get('layout') === 'horizontal' ? 0 : 1;
	  var vDimIdx = 1 - cDimIdx;
	  var coordDims = ['x', 'y'];
	  var cDim = data.mapDimension(coordDims[cDimIdx]);
	  var vDims = data.mapDimension(coordDims[vDimIdx], true);
	
	  if (cDim == null || vDims.length < 5) {
	    return;
	  }
	
	  for (var dataIndex = 0; dataIndex < data.count(); dataIndex++) {
	    var axisDimVal = data.get(cDim, dataIndex);
	    var median = getPoint(axisDimVal, vDims[2], dataIndex);
	    var end1 = getPoint(axisDimVal, vDims[0], dataIndex);
	    var end2 = getPoint(axisDimVal, vDims[1], dataIndex);
	    var end4 = getPoint(axisDimVal, vDims[3], dataIndex);
	    var end5 = getPoint(axisDimVal, vDims[4], dataIndex);
	    var ends = [];
	    addBodyEnd(ends, end2, 0);
	    addBodyEnd(ends, end4, 1);
	    ends.push(end1, end2, end5, end4);
	    layEndLine(ends, end1);
	    layEndLine(ends, end5);
	    layEndLine(ends, median);
	    data.setItemLayout(dataIndex, {
	      initBaseline: median[vDimIdx],
	      ends: ends
	    });
	  }
	
	  function getPoint(axisDimVal, dimIdx, dataIndex) {
	    var val = data.get(dimIdx, dataIndex);
	    var p = [];
	    p[cDimIdx] = axisDimVal;
	    p[vDimIdx] = val;
	    var point;
	
	    if (isNaN(axisDimVal) || isNaN(val)) {
	      point = [NaN, NaN];
	    } else {
	      point = coordSys.dataToPoint(p);
	      point[cDimIdx] += offset;
	    }
	
	    return point;
	  }
	
	  function addBodyEnd(ends, point, start) {
	    var point1 = point.slice();
	    var point2 = point.slice();
	    point1[cDimIdx] += halfWidth;
	    point2[cDimIdx] -= halfWidth;
	    start ? ends.push(point1, point2) : ends.push(point2, point1);
	  }
	
	  function layEndLine(ends, endCenter) {
	    var from = endCenter.slice();
	    var to = endCenter.slice();
	    from[cDimIdx] -= halfWidth;
	    to[cDimIdx] += halfWidth;
	    ends.push(from, to);
	  }
	}
	
	module.exports = _default;

/***/ },
/* 1463 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var borderColorQuery = ['itemStyle', 'borderColor'];
	
	function _default(ecModel, api) {
	  var globalColors = ecModel.get('color');
	  ecModel.eachRawSeriesByType('boxplot', function (seriesModel) {
	    var defaulColor = globalColors[seriesModel.seriesIndex % globalColors.length];
	    var data = seriesModel.getData();
	    data.setVisual({
	      legendSymbol: 'roundRect',
	      // Use name 'color' but not 'borderColor' for legend usage and
	      // visual coding from other component like dataRange.
	      color: seriesModel.get(borderColorQuery) || defaulColor
	    }); // Only visible series has each data be visual encoded
	
	    if (!ecModel.isSeriesFiltered(seriesModel)) {
	      data.each(function (idx) {
	        var itemModel = data.getItemModel(idx);
	        data.setItemVisual(idx, {
	          color: itemModel.get(borderColorQuery, true)
	        });
	      });
	    }
	  });
	}
	
	module.exports = _default;

/***/ },
/* 1464 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	__webpack_require__(1465);
	
	__webpack_require__(1466);
	
	var preprocessor = __webpack_require__(1469);
	
	var candlestickVisual = __webpack_require__(1468);
	
	var candlestickLayout = __webpack_require__(1467);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerPreprocessor(preprocessor);
	echarts.registerVisual(candlestickVisual);
	echarts.registerLayout(candlestickLayout);

/***/ },
/* 1465 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var SeriesModel = __webpack_require__(58);
	
	var _whiskerBoxCommon = __webpack_require__(704);
	
	var seriesModelMixin = _whiskerBoxCommon.seriesModelMixin;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var CandlestickSeries = SeriesModel.extend({
	  type: 'series.candlestick',
	  dependencies: ['xAxis', 'yAxis', 'grid'],
	
	  /**
	   * @readOnly
	   */
	  defaultValueDimensions: [{
	    name: 'open',
	    defaultTooltip: true
	  }, {
	    name: 'close',
	    defaultTooltip: true
	  }, {
	    name: 'lowest',
	    defaultTooltip: true
	  }, {
	    name: 'highest',
	    defaultTooltip: true
	  }],
	
	  /**
	   * @type {Array.<string>}
	   * @readOnly
	   */
	  dimensions: null,
	
	  /**
	   * @override
	   */
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'cartesian2d',
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    layout: null,
	    // 'horizontal' or 'vertical'
	    clip: true,
	    itemStyle: {
	      color: '#c23531',
	      // 阳线 positive
	      color0: '#314656',
	      // 阴线 negative     '#c23531', '#314656'
	      borderWidth: 1,
	      // FIXME
	      // ec2中使用的是lineStyle.color 和 lineStyle.color0
	      borderColor: '#c23531',
	      borderColor0: '#314656'
	    },
	    emphasis: {
	      itemStyle: {
	        borderWidth: 2
	      }
	    },
	    barMaxWidth: null,
	    barMinWidth: null,
	    barWidth: null,
	    large: true,
	    largeThreshold: 600,
	    progressive: 3e3,
	    progressiveThreshold: 1e4,
	    progressiveChunkMode: 'mod',
	    animationUpdate: false,
	    animationEasing: 'linear',
	    animationDuration: 300
	  },
	
	  /**
	   * Get dimension for shadow in dataZoom
	   * @return {string} dimension name
	   */
	  getShadowDim: function () {
	    return 'open';
	  },
	  brushSelector: function (dataIndex, data, selectors) {
	    var itemLayout = data.getItemLayout(dataIndex);
	    return itemLayout && selectors.rect(itemLayout.brushRect);
	  }
	});
	zrUtil.mixin(CandlestickSeries, seriesModelMixin, true);
	var _default = CandlestickSeries;
	module.exports = _default;

/***/ },
/* 1466 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var ChartView = __webpack_require__(106);
	
	var graphic = __webpack_require__(16);
	
	var Path = __webpack_require__(46);
	
	var _createClipPathFromCoordSys = __webpack_require__(259);
	
	var createClipPath = _createClipPathFromCoordSys.createClipPath;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var NORMAL_ITEM_STYLE_PATH = ['itemStyle'];
	var EMPHASIS_ITEM_STYLE_PATH = ['emphasis', 'itemStyle'];
	var SKIP_PROPS = ['color', 'color0', 'borderColor', 'borderColor0'];
	var CandlestickView = ChartView.extend({
	  type: 'candlestick',
	  render: function (seriesModel, ecModel, api) {
	    // If there is clipPath created in large mode. Remove it.
	    this.group.removeClipPath();
	
	    this._updateDrawMode(seriesModel);
	
	    this._isLargeDraw ? this._renderLarge(seriesModel) : this._renderNormal(seriesModel);
	  },
	  incrementalPrepareRender: function (seriesModel, ecModel, api) {
	    this._clear();
	
	    this._updateDrawMode(seriesModel);
	  },
	  incrementalRender: function (params, seriesModel, ecModel, api) {
	    this._isLargeDraw ? this._incrementalRenderLarge(params, seriesModel) : this._incrementalRenderNormal(params, seriesModel);
	  },
	  _updateDrawMode: function (seriesModel) {
	    var isLargeDraw = seriesModel.pipelineContext.large;
	
	    if (this._isLargeDraw == null || isLargeDraw ^ this._isLargeDraw) {
	      this._isLargeDraw = isLargeDraw;
	
	      this._clear();
	    }
	  },
	  _renderNormal: function (seriesModel) {
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var group = this.group;
	    var isSimpleBox = data.getLayout('isSimpleBox');
	    var needsClip = seriesModel.get('clip', true);
	    var coord = seriesModel.coordinateSystem;
	    var clipArea = coord.getArea && coord.getArea(); // There is no old data only when first rendering or switching from
	    // stream mode to normal mode, where previous elements should be removed.
	
	    if (!this._data) {
	      group.removeAll();
	    }
	
	    data.diff(oldData).add(function (newIdx) {
	      if (data.hasValue(newIdx)) {
	        var el;
	        var itemLayout = data.getItemLayout(newIdx);
	
	        if (needsClip && isNormalBoxClipped(clipArea, itemLayout)) {
	          return;
	        }
	
	        el = createNormalBox(itemLayout, newIdx, true);
	        graphic.initProps(el, {
	          shape: {
	            points: itemLayout.ends
	          }
	        }, seriesModel, newIdx);
	        setBoxCommon(el, data, newIdx, isSimpleBox);
	        group.add(el);
	        data.setItemGraphicEl(newIdx, el);
	      }
	    }).update(function (newIdx, oldIdx) {
	      var el = oldData.getItemGraphicEl(oldIdx); // Empty data
	
	      if (!data.hasValue(newIdx)) {
	        group.remove(el);
	        return;
	      }
	
	      var itemLayout = data.getItemLayout(newIdx);
	
	      if (needsClip && isNormalBoxClipped(clipArea, itemLayout)) {
	        group.remove(el);
	        return;
	      }
	
	      if (!el) {
	        el = createNormalBox(itemLayout, newIdx);
	      } else {
	        graphic.updateProps(el, {
	          shape: {
	            points: itemLayout.ends
	          }
	        }, seriesModel, newIdx);
	      }
	
	      setBoxCommon(el, data, newIdx, isSimpleBox);
	      group.add(el);
	      data.setItemGraphicEl(newIdx, el);
	    }).remove(function (oldIdx) {
	      var el = oldData.getItemGraphicEl(oldIdx);
	      el && group.remove(el);
	    }).execute();
	    this._data = data;
	  },
	  _renderLarge: function (seriesModel) {
	    this._clear();
	
	    createLarge(seriesModel, this.group);
	    var clipPath = seriesModel.get('clip', true) ? createClipPath(seriesModel.coordinateSystem, false, seriesModel) : null;
	
	    if (clipPath) {
	      this.group.setClipPath(clipPath);
	    } else {
	      this.group.removeClipPath();
	    }
	  },
	  _incrementalRenderNormal: function (params, seriesModel) {
	    var data = seriesModel.getData();
	    var isSimpleBox = data.getLayout('isSimpleBox');
	    var dataIndex;
	
	    while ((dataIndex = params.next()) != null) {
	      var el;
	      var itemLayout = data.getItemLayout(dataIndex);
	      el = createNormalBox(itemLayout, dataIndex);
	      setBoxCommon(el, data, dataIndex, isSimpleBox);
	      el.incremental = true;
	      this.group.add(el);
	    }
	  },
	  _incrementalRenderLarge: function (params, seriesModel) {
	    createLarge(seriesModel, this.group, true);
	  },
	  remove: function (ecModel) {
	    this._clear();
	  },
	  _clear: function () {
	    this.group.removeAll();
	    this._data = null;
	  },
	  dispose: zrUtil.noop
	});
	var NormalBoxPath = Path.extend({
	  type: 'normalCandlestickBox',
	  shape: {},
	  buildPath: function (ctx, shape) {
	    var ends = shape.points;
	
	    if (this.__simpleBox) {
	      ctx.moveTo(ends[4][0], ends[4][1]);
	      ctx.lineTo(ends[6][0], ends[6][1]);
	    } else {
	      ctx.moveTo(ends[0][0], ends[0][1]);
	      ctx.lineTo(ends[1][0], ends[1][1]);
	      ctx.lineTo(ends[2][0], ends[2][1]);
	      ctx.lineTo(ends[3][0], ends[3][1]);
	      ctx.closePath();
	      ctx.moveTo(ends[4][0], ends[4][1]);
	      ctx.lineTo(ends[5][0], ends[5][1]);
	      ctx.moveTo(ends[6][0], ends[6][1]);
	      ctx.lineTo(ends[7][0], ends[7][1]);
	    }
	  }
	});
	
	function createNormalBox(itemLayout, dataIndex, isInit) {
	  var ends = itemLayout.ends;
	  return new NormalBoxPath({
	    shape: {
	      points: isInit ? transInit(ends, itemLayout) : ends
	    },
	    z2: 100
	  });
	}
	
	function isNormalBoxClipped(clipArea, itemLayout) {
	  var clipped = true;
	
	  for (var i = 0; i < itemLayout.ends.length; i++) {
	    // If any point are in the region.
	    if (clipArea.contain(itemLayout.ends[i][0], itemLayout.ends[i][1])) {
	      clipped = false;
	      break;
	    }
	  }
	
	  return clipped;
	}
	
	function setBoxCommon(el, data, dataIndex, isSimpleBox) {
	  var itemModel = data.getItemModel(dataIndex);
	  var normalItemStyleModel = itemModel.getModel(NORMAL_ITEM_STYLE_PATH);
	  var color = data.getItemVisual(dataIndex, 'color');
	  var borderColor = data.getItemVisual(dataIndex, 'borderColor') || color; // Color must be excluded.
	  // Because symbol provide setColor individually to set fill and stroke
	
	  var itemStyle = normalItemStyleModel.getItemStyle(SKIP_PROPS);
	  el.useStyle(itemStyle);
	  el.style.strokeNoScale = true;
	  el.style.fill = color;
	  el.style.stroke = borderColor;
	  el.__simpleBox = isSimpleBox;
	  var hoverStyle = itemModel.getModel(EMPHASIS_ITEM_STYLE_PATH).getItemStyle();
	  graphic.setHoverStyle(el, hoverStyle);
	}
	
	function transInit(points, itemLayout) {
	  return zrUtil.map(points, function (point) {
	    point = point.slice();
	    point[1] = itemLayout.initBaseline;
	    return point;
	  });
	}
	
	var LargeBoxPath = Path.extend({
	  type: 'largeCandlestickBox',
	  shape: {},
	  buildPath: function (ctx, shape) {
	    // Drawing lines is more efficient than drawing
	    // a whole line or drawing rects.
	    var points = shape.points;
	
	    for (var i = 0; i < points.length;) {
	      if (this.__sign === points[i++]) {
	        var x = points[i++];
	        ctx.moveTo(x, points[i++]);
	        ctx.lineTo(x, points[i++]);
	      } else {
	        i += 3;
	      }
	    }
	  }
	});
	
	function createLarge(seriesModel, group, incremental) {
	  var data = seriesModel.getData();
	  var largePoints = data.getLayout('largePoints');
	  var elP = new LargeBoxPath({
	    shape: {
	      points: largePoints
	    },
	    __sign: 1
	  });
	  group.add(elP);
	  var elN = new LargeBoxPath({
	    shape: {
	      points: largePoints
	    },
	    __sign: -1
	  });
	  group.add(elN);
	  setLargeStyle(1, elP, seriesModel, data);
	  setLargeStyle(-1, elN, seriesModel, data);
	
	  if (incremental) {
	    elP.incremental = true;
	    elN.incremental = true;
	  }
	}
	
	function setLargeStyle(sign, el, seriesModel, data) {
	  var suffix = sign > 0 ? 'P' : 'N';
	  var borderColor = data.getVisual('borderColor' + suffix) || data.getVisual('color' + suffix); // Color must be excluded.
	  // Because symbol provide setColor individually to set fill and stroke
	
	  var itemStyle = seriesModel.getModel(NORMAL_ITEM_STYLE_PATH).getItemStyle(SKIP_PROPS);
	  el.useStyle(itemStyle);
	  el.style.fill = null;
	  el.style.stroke = borderColor; // No different
	  // el.style.lineWidth = .5;
	}
	
	var _default = CandlestickView;
	module.exports = _default;

/***/ },
/* 1467 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _graphic = __webpack_require__(16);
	
	var subPixelOptimize = _graphic.subPixelOptimize;
	
	var createRenderPlanner = __webpack_require__(202);
	
	var _number = __webpack_require__(20);
	
	var parsePercent = _number.parsePercent;
	
	var _util = __webpack_require__(3);
	
	var retrieve2 = _util.retrieve2;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Float32Array */
	var LargeArr = typeof Float32Array !== 'undefined' ? Float32Array : Array;
	var _default = {
	  seriesType: 'candlestick',
	  plan: createRenderPlanner(),
	  reset: function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	    var data = seriesModel.getData();
	    var candleWidth = calculateCandleWidth(seriesModel, data);
	    var cDimIdx = 0;
	    var vDimIdx = 1;
	    var coordDims = ['x', 'y'];
	    var cDim = data.mapDimension(coordDims[cDimIdx]);
	    var vDims = data.mapDimension(coordDims[vDimIdx], true);
	    var openDim = vDims[0];
	    var closeDim = vDims[1];
	    var lowestDim = vDims[2];
	    var highestDim = vDims[3];
	    data.setLayout({
	      candleWidth: candleWidth,
	      // The value is experimented visually.
	      isSimpleBox: candleWidth <= 1.3
	    });
	
	    if (cDim == null || vDims.length < 4) {
	      return;
	    }
	
	    return {
	      progress: seriesModel.pipelineContext.large ? largeProgress : normalProgress
	    };
	
	    function normalProgress(params, data) {
	      var dataIndex;
	
	      while ((dataIndex = params.next()) != null) {
	        var axisDimVal = data.get(cDim, dataIndex);
	        var openVal = data.get(openDim, dataIndex);
	        var closeVal = data.get(closeDim, dataIndex);
	        var lowestVal = data.get(lowestDim, dataIndex);
	        var highestVal = data.get(highestDim, dataIndex);
	        var ocLow = Math.min(openVal, closeVal);
	        var ocHigh = Math.max(openVal, closeVal);
	        var ocLowPoint = getPoint(ocLow, axisDimVal);
	        var ocHighPoint = getPoint(ocHigh, axisDimVal);
	        var lowestPoint = getPoint(lowestVal, axisDimVal);
	        var highestPoint = getPoint(highestVal, axisDimVal);
	        var ends = [];
	        addBodyEnd(ends, ocHighPoint, 0);
	        addBodyEnd(ends, ocLowPoint, 1);
	        ends.push(subPixelOptimizePoint(highestPoint), subPixelOptimizePoint(ocHighPoint), subPixelOptimizePoint(lowestPoint), subPixelOptimizePoint(ocLowPoint));
	        data.setItemLayout(dataIndex, {
	          sign: getSign(data, dataIndex, openVal, closeVal, closeDim),
	          initBaseline: openVal > closeVal ? ocHighPoint[vDimIdx] : ocLowPoint[vDimIdx],
	          // open point.
	          ends: ends,
	          brushRect: makeBrushRect(lowestVal, highestVal, axisDimVal)
	        });
	      }
	
	      function getPoint(val, axisDimVal) {
	        var p = [];
	        p[cDimIdx] = axisDimVal;
	        p[vDimIdx] = val;
	        return isNaN(axisDimVal) || isNaN(val) ? [NaN, NaN] : coordSys.dataToPoint(p);
	      }
	
	      function addBodyEnd(ends, point, start) {
	        var point1 = point.slice();
	        var point2 = point.slice();
	        point1[cDimIdx] = subPixelOptimize(point1[cDimIdx] + candleWidth / 2, 1, false);
	        point2[cDimIdx] = subPixelOptimize(point2[cDimIdx] - candleWidth / 2, 1, true);
	        start ? ends.push(point1, point2) : ends.push(point2, point1);
	      }
	
	      function makeBrushRect(lowestVal, highestVal, axisDimVal) {
	        var pmin = getPoint(lowestVal, axisDimVal);
	        var pmax = getPoint(highestVal, axisDimVal);
	        pmin[cDimIdx] -= candleWidth / 2;
	        pmax[cDimIdx] -= candleWidth / 2;
	        return {
	          x: pmin[0],
	          y: pmin[1],
	          width: vDimIdx ? candleWidth : pmax[0] - pmin[0],
	          height: vDimIdx ? pmax[1] - pmin[1] : candleWidth
	        };
	      }
	
	      function subPixelOptimizePoint(point) {
	        point[cDimIdx] = subPixelOptimize(point[cDimIdx], 1);
	        return point;
	      }
	    }
	
	    function largeProgress(params, data) {
	      // Structure: [sign, x, yhigh, ylow, sign, x, yhigh, ylow, ...]
	      var points = new LargeArr(params.count * 4);
	      var offset = 0;
	      var point;
	      var tmpIn = [];
	      var tmpOut = [];
	      var dataIndex;
	
	      while ((dataIndex = params.next()) != null) {
	        var axisDimVal = data.get(cDim, dataIndex);
	        var openVal = data.get(openDim, dataIndex);
	        var closeVal = data.get(closeDim, dataIndex);
	        var lowestVal = data.get(lowestDim, dataIndex);
	        var highestVal = data.get(highestDim, dataIndex);
	
	        if (isNaN(axisDimVal) || isNaN(lowestVal) || isNaN(highestVal)) {
	          points[offset++] = NaN;
	          offset += 3;
	          continue;
	        }
	
	        points[offset++] = getSign(data, dataIndex, openVal, closeVal, closeDim);
	        tmpIn[cDimIdx] = axisDimVal;
	        tmpIn[vDimIdx] = lowestVal;
	        point = coordSys.dataToPoint(tmpIn, null, tmpOut);
	        points[offset++] = point ? point[0] : NaN;
	        points[offset++] = point ? point[1] : NaN;
	        tmpIn[vDimIdx] = highestVal;
	        point = coordSys.dataToPoint(tmpIn, null, tmpOut);
	        points[offset++] = point ? point[1] : NaN;
	      }
	
	      data.setLayout('largePoints', points);
	    }
	  }
	};
	
	function getSign(data, dataIndex, openVal, closeVal, closeDim) {
	  var sign;
	
	  if (openVal > closeVal) {
	    sign = -1;
	  } else if (openVal < closeVal) {
	    sign = 1;
	  } else {
	    sign = dataIndex > 0 // If close === open, compare with close of last record
	    ? data.get(closeDim, dataIndex - 1) <= closeVal ? 1 : -1 : // No record of previous, set to be positive
	    1;
	  }
	
	  return sign;
	}
	
	function calculateCandleWidth(seriesModel, data) {
	  var baseAxis = seriesModel.getBaseAxis();
	  var extent;
	  var bandWidth = baseAxis.type === 'category' ? baseAxis.getBandWidth() : (extent = baseAxis.getExtent(), Math.abs(extent[1] - extent[0]) / data.count());
	  var barMaxWidth = parsePercent(retrieve2(seriesModel.get('barMaxWidth'), bandWidth), bandWidth);
	  var barMinWidth = parsePercent(retrieve2(seriesModel.get('barMinWidth'), 1), bandWidth);
	  var barWidth = seriesModel.get('barWidth');
	  return barWidth != null ? parsePercent(barWidth, bandWidth) // Put max outer to ensure bar visible in spite of overlap.
	  : Math.max(Math.min(bandWidth / 2, barMaxWidth), barMinWidth);
	}
	
	module.exports = _default;

/***/ },
/* 1468 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createRenderPlanner = __webpack_require__(202);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var positiveBorderColorQuery = ['itemStyle', 'borderColor'];
	var negativeBorderColorQuery = ['itemStyle', 'borderColor0'];
	var positiveColorQuery = ['itemStyle', 'color'];
	var negativeColorQuery = ['itemStyle', 'color0'];
	var _default = {
	  seriesType: 'candlestick',
	  plan: createRenderPlanner(),
	  // For legend.
	  performRawSeries: true,
	  reset: function (seriesModel, ecModel) {
	    var data = seriesModel.getData();
	    data.setVisual({
	      legendSymbol: 'roundRect',
	      colorP: getColor(1, seriesModel),
	      colorN: getColor(-1, seriesModel),
	      borderColorP: getBorderColor(1, seriesModel),
	      borderColorN: getBorderColor(-1, seriesModel)
	    }); // Only visible series has each data be visual encoded
	
	    if (ecModel.isSeriesFiltered(seriesModel)) {
	      return;
	    }
	
	    var isLargeRender = seriesModel.pipelineContext.large;
	    return !isLargeRender && {
	      progress: progress
	    };
	
	    function progress(params, data) {
	      var dataIndex;
	
	      while ((dataIndex = params.next()) != null) {
	        var itemModel = data.getItemModel(dataIndex);
	        var sign = data.getItemLayout(dataIndex).sign;
	        data.setItemVisual(dataIndex, {
	          color: getColor(sign, itemModel),
	          borderColor: getBorderColor(sign, itemModel)
	        });
	      }
	    }
	
	    function getColor(sign, model) {
	      return model.get(sign > 0 ? positiveColorQuery : negativeColorQuery);
	    }
	
	    function getBorderColor(sign, model) {
	      return model.get(sign > 0 ? positiveBorderColorQuery : negativeBorderColorQuery);
	    }
	  }
	};
	module.exports = _default;

/***/ },
/* 1469 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(option) {
	  if (!option || !zrUtil.isArray(option.series)) {
	    return;
	  } // Translate 'k' to 'candlestick'.
	
	
	  zrUtil.each(option.series, function (seriesItem) {
	    if (zrUtil.isObject(seriesItem) && seriesItem.type === 'k') {
	      seriesItem.type = 'candlestick';
	    }
	  });
	}
	
	module.exports = _default;

/***/ },
/* 1470 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(3);
	
	var graphicUtil = __webpack_require__(16);
	
	var _labelHelper = __webpack_require__(457);
	
	var getDefaultLabel = _labelHelper.getDefaultLabel;
	
	var createListFromArray = __webpack_require__(122);
	
	var _barGrid = __webpack_require__(337);
	
	var getLayoutOnAxis = _barGrid.getLayoutOnAxis;
	
	var DataDiffer = __webpack_require__(166);
	
	var SeriesModel = __webpack_require__(58);
	
	var Model = __webpack_require__(48);
	
	var ChartView = __webpack_require__(106);
	
	var _createClipPathFromCoordSys = __webpack_require__(259);
	
	var createClipPath = _createClipPathFromCoordSys.createClipPath;
	
	var prepareCartesian2d = __webpack_require__(1659);
	
	var prepareGeo = __webpack_require__(1668);
	
	var prepareSingleAxis = __webpack_require__(1686);
	
	var preparePolar = __webpack_require__(1679);
	
	var prepareCalendar = __webpack_require__(1654);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var CACHED_LABEL_STYLE_PROPERTIES = graphicUtil.CACHED_LABEL_STYLE_PROPERTIES;
	var ITEM_STYLE_NORMAL_PATH = ['itemStyle'];
	var ITEM_STYLE_EMPHASIS_PATH = ['emphasis', 'itemStyle'];
	var LABEL_NORMAL = ['label'];
	var LABEL_EMPHASIS = ['emphasis', 'label']; // Use prefix to avoid index to be the same as el.name,
	// which will cause weird udpate animation.
	
	var GROUP_DIFF_PREFIX = 'e\0\0';
	/**
	 * To reduce total package size of each coordinate systems, the modules `prepareCustom`
	 * of each coordinate systems are not required by each coordinate systems directly, but
	 * required by the module `custom`.
	 *
	 * prepareInfoForCustomSeries {Function}: optional
	 *     @return {Object} {coordSys: {...}, api: {
	 *         coord: function (data, clamp) {}, // return point in global.
	 *         size: function (dataSize, dataItem) {} // return size of each axis in coordSys.
	 *     }}
	 */
	
	var prepareCustoms = {
	  cartesian2d: prepareCartesian2d,
	  geo: prepareGeo,
	  singleAxis: prepareSingleAxis,
	  polar: preparePolar,
	  calendar: prepareCalendar
	}; // ------
	// Model
	// ------
	
	SeriesModel.extend({
	  type: 'series.custom',
	  dependencies: ['grid', 'polar', 'geo', 'singleAxis', 'calendar'],
	  defaultOption: {
	    coordinateSystem: 'cartesian2d',
	    // Can be set as 'none'
	    zlevel: 0,
	    z: 2,
	    legendHoverLink: true,
	    useTransform: true,
	    // Custom series will not clip by default.
	    // Some case will use custom series to draw label
	    // For example https://echarts.apache.org/examples/en/editor.html?c=custom-gantt-flight
	    // Only works on polar and cartesian2d coordinate system.
	    clip: false // Cartesian coordinate system
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // Polar coordinate system
	    // polarIndex: 0,
	    // Geo coordinate system
	    // geoIndex: 0,
	    // label: {}
	    // itemStyle: {}
	
	  },
	
	  /**
	   * @override
	   */
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(this.getSource(), this);
	  },
	
	  /**
	   * @override
	   */
	  getDataParams: function (dataIndex, dataType, el) {
	    var params = SeriesModel.prototype.getDataParams.apply(this, arguments);
	    el && (params.info = el.info);
	    return params;
	  }
	}); // -----
	// View
	// -----
	
	ChartView.extend({
	  type: 'custom',
	
	  /**
	   * @private
	   * @type {module:echarts/data/List}
	   */
	  _data: null,
	
	  /**
	   * @override
	   */
	  render: function (customSeries, ecModel, api, payload) {
	    var oldData = this._data;
	    var data = customSeries.getData();
	    var group = this.group;
	    var renderItem = makeRenderItem(customSeries, data, ecModel, api); // By default, merge mode is applied. In most cases, custom series is
	    // used in the scenario that data amount is not large but graphic elements
	    // is complicated, where merge mode is probably necessary for optimization.
	    // For example, reuse graphic elements and only update the transform when
	    // roam or data zoom according to `actionType`.
	
	    data.diff(oldData).add(function (newIdx) {
	      createOrUpdate(null, newIdx, renderItem(newIdx, payload), customSeries, group, data);
	    }).update(function (newIdx, oldIdx) {
	      var el = oldData.getItemGraphicEl(oldIdx);
	      createOrUpdate(el, newIdx, renderItem(newIdx, payload), customSeries, group, data);
	    }).remove(function (oldIdx) {
	      var el = oldData.getItemGraphicEl(oldIdx);
	      el && group.remove(el);
	    }).execute(); // Do clipping
	
	    var clipPath = customSeries.get('clip', true) ? createClipPath(customSeries.coordinateSystem, false, customSeries) : null;
	
	    if (clipPath) {
	      group.setClipPath(clipPath);
	    } else {
	      group.removeClipPath();
	    }
	
	    this._data = data;
	  },
	  incrementalPrepareRender: function (customSeries, ecModel, api) {
	    this.group.removeAll();
	    this._data = null;
	  },
	  incrementalRender: function (params, customSeries, ecModel, api, payload) {
	    var data = customSeries.getData();
	    var renderItem = makeRenderItem(customSeries, data, ecModel, api);
	
	    function setIncrementalAndHoverLayer(el) {
	      if (!el.isGroup) {
	        el.incremental = true;
	        el.useHoverLayer = true;
	      }
	    }
	
	    for (var idx = params.start; idx < params.end; idx++) {
	      var el = createOrUpdate(null, idx, renderItem(idx, payload), customSeries, this.group, data);
	      el.traverse(setIncrementalAndHoverLayer);
	    }
	  },
	
	  /**
	   * @override
	   */
	  dispose: zrUtil.noop,
	
	  /**
	   * @override
	   */
	  filterForExposedEvent: function (eventType, query, targetEl, packedEvent) {
	    var elementName = query.element;
	
	    if (elementName == null || targetEl.name === elementName) {
	      return true;
	    } // Enable to give a name on a group made by `renderItem`, and listen
	    // events that triggerd by its descendents.
	
	
	    while ((targetEl = targetEl.parent) && targetEl !== this.group) {
	      if (targetEl.name === elementName) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	});
	
	function createEl(elOption) {
	  var graphicType = elOption.type;
	  var el; // Those graphic elements are not shapes. They should not be
	  // overwritten by users, so do them first.
	
	  if (graphicType === 'path') {
	    var shape = elOption.shape; // Using pathRect brings convenience to users sacle svg path.
	
	    var pathRect = shape.width != null && shape.height != null ? {
	      x: shape.x || 0,
	      y: shape.y || 0,
	      width: shape.width,
	      height: shape.height
	    } : null;
	    var pathData = getPathData(shape); // Path is also used for icon, so layout 'center' by default.
	
	    el = graphicUtil.makePath(pathData, null, pathRect, shape.layout || 'center');
	    el.__customPathData = pathData;
	  } else if (graphicType === 'image') {
	    el = new graphicUtil.Image({});
	    el.__customImagePath = elOption.style.image;
	  } else if (graphicType === 'text') {
	    el = new graphicUtil.Text({});
	    el.__customText = elOption.style.text;
	  } else if (graphicType === 'group') {
	    el = new graphicUtil.Group();
	  } else if (graphicType === 'compoundPath') {
	    throw new Error('"compoundPath" is not supported yet.');
	  } else {
	    var Clz = graphicUtil.getShapeClass(graphicType);
	    el = new Clz();
	  }
	
	  el.__customGraphicType = graphicType;
	  el.name = elOption.name;
	  return el;
	}
	
	function updateEl(el, dataIndex, elOption, animatableModel, data, isInit, isRoot) {
	  var transitionProps = {};
	  var elOptionStyle = elOption.style || {};
	  elOption.shape && (transitionProps.shape = zrUtil.clone(elOption.shape));
	  elOption.position && (transitionProps.position = elOption.position.slice());
	  elOption.scale && (transitionProps.scale = elOption.scale.slice());
	  elOption.origin && (transitionProps.origin = elOption.origin.slice());
	  elOption.rotation && (transitionProps.rotation = elOption.rotation);
	
	  if (el.type === 'image' && elOption.style) {
	    var targetStyle = transitionProps.style = {};
	    zrUtil.each(['x', 'y', 'width', 'height'], function (prop) {
	      prepareStyleTransition(prop, targetStyle, elOptionStyle, el.style, isInit);
	    });
	  }
	
	  if (el.type === 'text' && elOption.style) {
	    var targetStyle = transitionProps.style = {};
	    zrUtil.each(['x', 'y'], function (prop) {
	      prepareStyleTransition(prop, targetStyle, elOptionStyle, el.style, isInit);
	    }); // Compatible with previous: both support
	    // textFill and fill, textStroke and stroke in 'text' element.
	
	    !elOptionStyle.hasOwnProperty('textFill') && elOptionStyle.fill && (elOptionStyle.textFill = elOptionStyle.fill);
	    !elOptionStyle.hasOwnProperty('textStroke') && elOptionStyle.stroke && (elOptionStyle.textStroke = elOptionStyle.stroke);
	  }
	
	  if (el.type !== 'group') {
	    el.useStyle(elOptionStyle); // Init animation.
	
	    if (isInit) {
	      el.style.opacity = 0;
	      var targetOpacity = elOptionStyle.opacity;
	      targetOpacity == null && (targetOpacity = 1);
	      graphicUtil.initProps(el, {
	        style: {
	          opacity: targetOpacity
	        }
	      }, animatableModel, dataIndex);
	    }
	  }
	
	  if (isInit) {
	    el.attr(transitionProps);
	  } else {
	    graphicUtil.updateProps(el, transitionProps, animatableModel, dataIndex);
	  } // Merge by default.
	  // z2 must not be null/undefined, otherwise sort error may occur.
	
	
	  elOption.hasOwnProperty('z2') && el.attr('z2', elOption.z2 || 0);
	  elOption.hasOwnProperty('silent') && el.attr('silent', elOption.silent);
	  elOption.hasOwnProperty('invisible') && el.attr('invisible', elOption.invisible);
	  elOption.hasOwnProperty('ignore') && el.attr('ignore', elOption.ignore); // `elOption.info` enables user to mount some info on
	  // elements and use them in event handlers.
	  // Update them only when user specified, otherwise, remain.
	
	  elOption.hasOwnProperty('info') && el.attr('info', elOption.info); // If `elOption.styleEmphasis` is `false`, remove hover style. The
	  // logic is ensured by `graphicUtil.setElementHoverStyle`.
	
	  var styleEmphasis = elOption.styleEmphasis; // hoverStyle should always be set here, because if the hover style
	  // may already be changed, where the inner cache should be reset.
	
	  graphicUtil.setElementHoverStyle(el, styleEmphasis);
	
	  if (isRoot) {
	    graphicUtil.setAsHighDownDispatcher(el, styleEmphasis !== false);
	  }
	}
	
	function prepareStyleTransition(prop, targetStyle, elOptionStyle, oldElStyle, isInit) {
	  if (elOptionStyle[prop] != null && !isInit) {
	    targetStyle[prop] = elOptionStyle[prop];
	    elOptionStyle[prop] = oldElStyle[prop];
	  }
	}
	
	function makeRenderItem(customSeries, data, ecModel, api) {
	  var renderItem = customSeries.get('renderItem');
	  var coordSys = customSeries.coordinateSystem;
	  var prepareResult = {};
	
	  if (coordSys) {
	    prepareResult = coordSys.prepareCustoms ? coordSys.prepareCustoms() : prepareCustoms[coordSys.type](coordSys);
	  }
	
	  var userAPI = zrUtil.defaults({
	    getWidth: api.getWidth,
	    getHeight: api.getHeight,
	    getZr: api.getZr,
	    getDevicePixelRatio: api.getDevicePixelRatio,
	    value: value,
	    style: style,
	    styleEmphasis: styleEmphasis,
	    visual: visual,
	    barLayout: barLayout,
	    currentSeriesIndices: currentSeriesIndices,
	    font: font
	  }, prepareResult.api || {});
	  var userParams = {
	    // The life cycle of context: current round of rendering.
	    // The global life cycle is probably not necessary, because
	    // user can store global status by themselves.
	    context: {},
	    seriesId: customSeries.id,
	    seriesName: customSeries.name,
	    seriesIndex: customSeries.seriesIndex,
	    coordSys: prepareResult.coordSys,
	    dataInsideLength: data.count(),
	    encode: wrapEncodeDef(customSeries.getData())
	  }; // Do not support call `api` asynchronously without dataIndexInside input.
	
	  var currDataIndexInside;
	  var currDirty = true;
	  var currItemModel;
	  var currLabelNormalModel;
	  var currLabelEmphasisModel;
	  var currVisualColor;
	  return function (dataIndexInside, payload) {
	    currDataIndexInside = dataIndexInside;
	    currDirty = true;
	    return renderItem && renderItem(zrUtil.defaults({
	      dataIndexInside: dataIndexInside,
	      dataIndex: data.getRawIndex(dataIndexInside),
	      // Can be used for optimization when zoom or roam.
	      actionType: payload ? payload.type : null
	    }, userParams), userAPI);
	  }; // Do not update cache until api called.
	
	  function updateCache(dataIndexInside) {
	    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	
	    if (currDirty) {
	      currItemModel = data.getItemModel(dataIndexInside);
	      currLabelNormalModel = currItemModel.getModel(LABEL_NORMAL);
	      currLabelEmphasisModel = currItemModel.getModel(LABEL_EMPHASIS);
	      currVisualColor = data.getItemVisual(dataIndexInside, 'color');
	      currDirty = false;
	    }
	  }
	  /**
	   * @public
	   * @param {number|string} dim
	   * @param {number} [dataIndexInside=currDataIndexInside]
	   * @return {number|string} value
	   */
	
	
	  function value(dim, dataIndexInside) {
	    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	    return data.get(data.getDimension(dim || 0), dataIndexInside);
	  }
	  /**
	   * By default, `visual` is applied to style (to support visualMap).
	   * `visual.color` is applied at `fill`. If user want apply visual.color on `stroke`,
	   * it can be implemented as:
	   * `api.style({stroke: api.visual('color'), fill: null})`;
	   * @public
	   * @param {Object} [extra]
	   * @param {number} [dataIndexInside=currDataIndexInside]
	   */
	
	
	  function style(extra, dataIndexInside) {
	    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	    updateCache(dataIndexInside);
	    var itemStyle = currItemModel.getModel(ITEM_STYLE_NORMAL_PATH).getItemStyle();
	    currVisualColor != null && (itemStyle.fill = currVisualColor);
	    var opacity = data.getItemVisual(dataIndexInside, 'opacity');
	    opacity != null && (itemStyle.opacity = opacity);
	    var labelModel = extra ? applyExtraBefore(extra, currLabelNormalModel) : currLabelNormalModel;
	    graphicUtil.setTextStyle(itemStyle, labelModel, null, {
	      autoColor: currVisualColor,
	      isRectText: true
	    });
	    itemStyle.text = labelModel.getShallow('show') ? zrUtil.retrieve2(customSeries.getFormattedLabel(dataIndexInside, 'normal'), getDefaultLabel(data, dataIndexInside)) : null;
	    extra && applyExtraAfter(itemStyle, extra);
	    return itemStyle;
	  }
	  /**
	   * @public
	   * @param {Object} [extra]
	   * @param {number} [dataIndexInside=currDataIndexInside]
	   */
	
	
	  function styleEmphasis(extra, dataIndexInside) {
	    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	    updateCache(dataIndexInside);
	    var itemStyle = currItemModel.getModel(ITEM_STYLE_EMPHASIS_PATH).getItemStyle();
	    var labelModel = extra ? applyExtraBefore(extra, currLabelEmphasisModel) : currLabelEmphasisModel;
	    graphicUtil.setTextStyle(itemStyle, labelModel, null, {
	      isRectText: true
	    }, true);
	    itemStyle.text = labelModel.getShallow('show') ? zrUtil.retrieve3(customSeries.getFormattedLabel(dataIndexInside, 'emphasis'), customSeries.getFormattedLabel(dataIndexInside, 'normal'), getDefaultLabel(data, dataIndexInside)) : null;
	    extra && applyExtraAfter(itemStyle, extra);
	    return itemStyle;
	  }
	  /**
	   * @public
	   * @param {string} visualType
	   * @param {number} [dataIndexInside=currDataIndexInside]
	   */
	
	
	  function visual(visualType, dataIndexInside) {
	    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	    return data.getItemVisual(dataIndexInside, visualType);
	  }
	  /**
	   * @public
	   * @param {number} opt.count Positive interger.
	   * @param {number} [opt.barWidth]
	   * @param {number} [opt.barMaxWidth]
	   * @param {number} [opt.barMinWidth]
	   * @param {number} [opt.barGap]
	   * @param {number} [opt.barCategoryGap]
	   * @return {Object} {width, offset, offsetCenter} is not support, return undefined.
	   */
	
	
	  function barLayout(opt) {
	    if (coordSys.getBaseAxis) {
	      var baseAxis = coordSys.getBaseAxis();
	      return getLayoutOnAxis(zrUtil.defaults({
	        axis: baseAxis
	      }, opt), api);
	    }
	  }
	  /**
	   * @public
	   * @return {Array.<number>}
	   */
	
	
	  function currentSeriesIndices() {
	    return ecModel.getCurrentSeriesIndices();
	  }
	  /**
	   * @public
	   * @param {Object} opt
	   * @param {string} [opt.fontStyle]
	   * @param {number} [opt.fontWeight]
	   * @param {number} [opt.fontSize]
	   * @param {string} [opt.fontFamily]
	   * @return {string} font string
	   */
	
	
	  function font(opt) {
	    return graphicUtil.getFont(opt, ecModel);
	  }
	}
	
	function wrapEncodeDef(data) {
	  var encodeDef = {};
	  zrUtil.each(data.dimensions, function (dimName, dataDimIndex) {
	    var dimInfo = data.getDimensionInfo(dimName);
	
	    if (!dimInfo.isExtraCoord) {
	      var coordDim = dimInfo.coordDim;
	      var dataDims = encodeDef[coordDim] = encodeDef[coordDim] || [];
	      dataDims[dimInfo.coordDimIndex] = dataDimIndex;
	    }
	  });
	  return encodeDef;
	}
	
	function createOrUpdate(el, dataIndex, elOption, animatableModel, group, data) {
	  el = doCreateOrUpdate(el, dataIndex, elOption, animatableModel, group, data, true);
	  el && data.setItemGraphicEl(dataIndex, el);
	  return el;
	}
	
	function doCreateOrUpdate(el, dataIndex, elOption, animatableModel, group, data, isRoot) {
	  // [Rule]
	  // By default, follow merge mode.
	  //     (It probably brings benifit for performance in some cases of large data, where
	  //     user program can be optimized to that only updated props needed to be re-calculated,
	  //     or according to `actionType` some calculation can be skipped.)
	  // If `renderItem` returns `null`/`undefined`/`false`, remove the previous el if existing.
	  //     (It seems that violate the "merge" principle, but most of users probably intuitively
	  //     regard "return;" as "show nothing element whatever", so make a exception to meet the
	  //     most cases.)
	  var simplyRemove = !elOption; // `null`/`undefined`/`false`
	
	  elOption = elOption || {};
	  var elOptionType = elOption.type;
	  var elOptionShape = elOption.shape;
	  var elOptionStyle = elOption.style;
	
	  if (el && (simplyRemove // || elOption.$merge === false
	  // If `elOptionType` is `null`, follow the merge principle.
	  || elOptionType != null && elOptionType !== el.__customGraphicType || elOptionType === 'path' && hasOwnPathData(elOptionShape) && getPathData(elOptionShape) !== el.__customPathData || elOptionType === 'image' && hasOwn(elOptionStyle, 'image') && elOptionStyle.image !== el.__customImagePath // FIXME test and remove this restriction?
	  || elOptionType === 'text' && hasOwn(elOptionShape, 'text') && elOptionStyle.text !== el.__customText)) {
	    group.remove(el);
	    el = null;
	  } // `elOption.type` is undefined when `renderItem` returns nothing.
	
	
	  if (simplyRemove) {
	    return;
	  }
	
	  var isInit = !el;
	  !el && (el = createEl(elOption));
	  updateEl(el, dataIndex, elOption, animatableModel, data, isInit, isRoot);
	
	  if (elOptionType === 'group') {
	    mergeChildren(el, dataIndex, elOption, animatableModel, data);
	  } // Always add whatever already added to ensure sequence.
	
	
	  group.add(el);
	  return el;
	} // Usage:
	// (1) By default, `elOption.$mergeChildren` is `'byIndex'`, which indicates that
	//     the existing children will not be removed, and enables the feature that
	//     update some of the props of some of the children simply by construct
	//     the returned children of `renderItem` like:
	//     `var children = group.children = []; children[3] = {opacity: 0.5};`
	// (2) If `elOption.$mergeChildren` is `'byName'`, add/update/remove children
	//     by child.name. But that might be lower performance.
	// (3) If `elOption.$mergeChildren` is `false`, the existing children will be
	//     replaced totally.
	// (4) If `!elOption.children`, following the "merge" principle, nothing will happen.
	//
	// For implementation simpleness, do not provide a direct way to remove sinlge
	// child (otherwise the total indicies of the children array have to be modified).
	// User can remove a single child by set its `ignore` as `true` or replace
	// it by another element, where its `$merge` can be set as `true` if necessary.
	
	
	function mergeChildren(el, dataIndex, elOption, animatableModel, data) {
	  var newChildren = elOption.children;
	  var newLen = newChildren ? newChildren.length : 0;
	  var mergeChildren = elOption.$mergeChildren; // `diffChildrenByName` has been deprecated.
	
	  var byName = mergeChildren === 'byName' || elOption.diffChildrenByName;
	  var notMerge = mergeChildren === false; // For better performance on roam update, only enter if necessary.
	
	  if (!newLen && !byName && !notMerge) {
	    return;
	  }
	
	  if (byName) {
	    diffGroupChildren({
	      oldChildren: el.children() || [],
	      newChildren: newChildren || [],
	      dataIndex: dataIndex,
	      animatableModel: animatableModel,
	      group: el,
	      data: data
	    });
	    return;
	  }
	
	  notMerge && el.removeAll(); // Mapping children of a group simply by index, which
	  // might be better performance.
	
	  var index = 0;
	
	  for (; index < newLen; index++) {
	    newChildren[index] && doCreateOrUpdate(el.childAt(index), dataIndex, newChildren[index], animatableModel, el, data);
	  }
	}
	
	function diffGroupChildren(context) {
	  new DataDiffer(context.oldChildren, context.newChildren, getKey, getKey, context).add(processAddUpdate).update(processAddUpdate).remove(processRemove).execute();
	}
	
	function getKey(item, idx) {
	  var name = item && item.name;
	  return name != null ? name : GROUP_DIFF_PREFIX + idx;
	}
	
	function processAddUpdate(newIndex, oldIndex) {
	  var context = this.context;
	  var childOption = newIndex != null ? context.newChildren[newIndex] : null;
	  var child = oldIndex != null ? context.oldChildren[oldIndex] : null;
	  doCreateOrUpdate(child, context.dataIndex, childOption, context.animatableModel, context.group, context.data);
	} // `graphic#applyDefaultTextStyle` will cache
	// textFill, textStroke, textStrokeWidth.
	// We have to do this trick.
	
	
	function applyExtraBefore(extra, model) {
	  var dummyModel = new Model({}, model);
	  zrUtil.each(CACHED_LABEL_STYLE_PROPERTIES, function (stylePropName, modelPropName) {
	    if (extra.hasOwnProperty(stylePropName)) {
	      dummyModel.option[modelPropName] = extra[stylePropName];
	    }
	  });
	  return dummyModel;
	}
	
	function applyExtraAfter(itemStyle, extra) {
	  for (var key in extra) {
	    if (extra.hasOwnProperty(key) || !CACHED_LABEL_STYLE_PROPERTIES.hasOwnProperty(key)) {
	      itemStyle[key] = extra[key];
	    }
	  }
	}
	
	function processRemove(oldIndex) {
	  var context = this.context;
	  var child = context.oldChildren[oldIndex];
	  child && context.group.remove(child);
	}
	
	function getPathData(shape) {
	  // "d" follows the SVG convention.
	  return shape && (shape.pathData || shape.d);
	}
	
	function hasOwnPathData(shape) {
	  return shape && (shape.hasOwnProperty('pathData') || shape.hasOwnProperty('d'));
	}
	
	function hasOwn(host, prop) {
	  return host && host.hasOwnProperty(prop);
	}

/***/ },
/* 1471 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	__webpack_require__(1472);
	
	__webpack_require__(1473);
	
	var visualSymbol = __webpack_require__(169);
	
	var layoutPoints = __webpack_require__(266);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(visualSymbol('effectScatter', 'circle'));
	echarts.registerLayout(layoutPoints('effectScatter'));

/***/ },
/* 1472 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createListFromArray = __webpack_require__(122);
	
	var SeriesModel = __webpack_require__(58);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.effectScatter',
	  dependencies: ['grid', 'polar'],
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(this.getSource(), this, {
	      useEncodeDefaulter: true
	    });
	  },
	  brushSelector: 'point',
	  defaultOption: {
	    coordinateSystem: 'cartesian2d',
	    zlevel: 0,
	    z: 2,
	    legendHoverLink: true,
	    effectType: 'ripple',
	    progressive: 0,
	    // When to show the effect, option: 'render'|'emphasis'
	    showEffectOn: 'render',
	    // Ripple effect config
	    rippleEffect: {
	      period: 4,
	      // Scale of ripple
	      scale: 2.5,
	      // Brush type can be fill or stroke
	      brushType: 'fill'
	    },
	    // Cartesian coordinate system
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // Polar coordinate system
	    // polarIndex: 0,
	    // Geo coordinate system
	    // geoIndex: 0,
	    // symbol: null,        // 图形类型
	    symbolSize: 10 // 图形大小，半宽（半径）参数，当图形为方向或菱形则总宽度为symbolSize * 2
	    // symbolRotate: null,  // 图形旋转控制
	    // large: false,
	    // Available when large is true
	    // largeThreshold: 2000,
	    // itemStyle: {
	    //     opacity: 1
	    // }
	
	  }
	});
	
	module.exports = _default;

/***/ },
/* 1473 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var SymbolDraw = __webpack_require__(258);
	
	var EffectSymbol = __webpack_require__(1500);
	
	var matrix = __webpack_require__(73);
	
	var pointsLayout = __webpack_require__(266);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendChartView({
	  type: 'effectScatter',
	  init: function () {
	    this._symbolDraw = new SymbolDraw(EffectSymbol);
	  },
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    var effectSymbolDraw = this._symbolDraw;
	    effectSymbolDraw.updateData(data);
	    this.group.add(effectSymbolDraw.group);
	  },
	  updateTransform: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    this.group.dirty();
	    var res = pointsLayout().reset(seriesModel);
	
	    if (res.progress) {
	      res.progress({
	        start: 0,
	        end: data.count()
	      }, data);
	    }
	
	    this._symbolDraw.updateLayout(data);
	  },
	  _updateGroupTransform: function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys && coordSys.getRoamTransform) {
	      this.group.transform = matrix.clone(coordSys.getRoamTransform());
	      this.group.decomposeTransform();
	    }
	  },
	  remove: function (ecModel, api) {
	    this._symbolDraw && this._symbolDraw.remove(api);
	  },
	  dispose: function () {}
	});
	
	module.exports = _default;

/***/ },
/* 1474 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	__webpack_require__(1475);
	
	__webpack_require__(1476);
	
	var dataColor = __webpack_require__(341);
	
	var funnelLayout = __webpack_require__(1477);
	
	var dataFilter = __webpack_require__(267);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(dataColor('funnel'));
	echarts.registerLayout(funnelLayout);
	echarts.registerProcessor(dataFilter('funnel'));

/***/ },
/* 1475 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var createListSimply = __webpack_require__(201);
	
	var _model = __webpack_require__(24);
	
	var defaultEmphasis = _model.defaultEmphasis;
	
	var _sourceHelper = __webpack_require__(123);
	
	var makeSeriesEncodeForNameBased = _sourceHelper.makeSeriesEncodeForNameBased;
	
	var LegendVisualProvider = __webpack_require__(269);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var FunnelSeries = echarts.extendSeriesModel({
	  type: 'series.funnel',
	  init: function (option) {
	    FunnelSeries.superApply(this, 'init', arguments); // Enable legend selection for each data item
	    // Use a function instead of direct access because data reference may changed
	
	    this.legendVisualProvider = new LegendVisualProvider(zrUtil.bind(this.getData, this), zrUtil.bind(this.getRawData, this)); // Extend labelLine emphasis
	
	    this._defaultLabelLine(option);
	  },
	  getInitialData: function (option, ecModel) {
	    return createListSimply(this, {
	      coordDimensions: ['value'],
	      encodeDefaulter: zrUtil.curry(makeSeriesEncodeForNameBased, this)
	    });
	  },
	  _defaultLabelLine: function (option) {
	    // Extend labelLine emphasis
	    defaultEmphasis(option, 'labelLine', ['show']);
	    var labelLineNormalOpt = option.labelLine;
	    var labelLineEmphasisOpt = option.emphasis.labelLine; // Not show label line if `label.normal.show = false`
	
	    labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
	    labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
	  },
	  // Overwrite
	  getDataParams: function (dataIndex) {
	    var data = this.getData();
	    var params = FunnelSeries.superCall(this, 'getDataParams', dataIndex);
	    var valueDim = data.mapDimension('value');
	    var sum = data.getSum(valueDim); // Percent is 0 if sum is 0
	
	    params.percent = !sum ? 0 : +(data.get(valueDim, dataIndex) / sum * 100).toFixed(2);
	    params.$vars.push('percent');
	    return params;
	  },
	  defaultOption: {
	    zlevel: 0,
	    // 一级层叠
	    z: 2,
	    // 二级层叠
	    legendHoverLink: true,
	    left: 80,
	    top: 60,
	    right: 80,
	    bottom: 60,
	    // width: {totalWidth} - left - right,
	    // height: {totalHeight} - top - bottom,
	    // 默认取数据最小最大值
	    // min: 0,
	    // max: 100,
	    minSize: '0%',
	    maxSize: '100%',
	    sort: 'descending',
	    // 'ascending', 'descending'
	    orient: 'vertical',
	    gap: 0,
	    funnelAlign: 'center',
	    label: {
	      show: true,
	      position: 'outer' // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
	
	    },
	    labelLine: {
	      show: true,
	      length: 20,
	      lineStyle: {
	        // color: 各异,
	        width: 1,
	        type: 'solid'
	      }
	    },
	    itemStyle: {
	      // color: 各异,
	      borderColor: '#fff',
	      borderWidth: 1
	    },
	    emphasis: {
	      label: {
	        show: true
	      }
	    }
	  }
	});
	var _default = FunnelSeries;
	module.exports = _default;

/***/ },
/* 1476 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(16);
	
	var zrUtil = __webpack_require__(3);
	
	var ChartView = __webpack_require__(106);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Piece of pie including Sector, Label, LabelLine
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 */
	function FunnelPiece(data, idx) {
	  graphic.Group.call(this);
	  var polygon = new graphic.Polygon();
	  var labelLine = new graphic.Polyline();
	  var text = new graphic.Text();
	  this.add(polygon);
	  this.add(labelLine);
	  this.add(text);
	
	  this.highDownOnUpdate = function (fromState, toState) {
	    if (toState === 'emphasis') {
	      labelLine.ignore = labelLine.hoverIgnore;
	      text.ignore = text.hoverIgnore;
	    } else {
	      labelLine.ignore = labelLine.normalIgnore;
	      text.ignore = text.normalIgnore;
	    }
	  };
	
	  this.updateData(data, idx, true);
	}
	
	var funnelPieceProto = FunnelPiece.prototype;
	var opacityAccessPath = ['itemStyle', 'opacity'];
	
	funnelPieceProto.updateData = function (data, idx, firstCreate) {
	  var polygon = this.childAt(0);
	  var seriesModel = data.hostModel;
	  var itemModel = data.getItemModel(idx);
	  var layout = data.getItemLayout(idx);
	  var opacity = data.getItemModel(idx).get(opacityAccessPath);
	  opacity = opacity == null ? 1 : opacity; // Reset style
	
	  polygon.useStyle({});
	
	  if (firstCreate) {
	    polygon.setShape({
	      points: layout.points
	    });
	    polygon.setStyle({
	      opacity: 0
	    });
	    graphic.initProps(polygon, {
	      style: {
	        opacity: opacity
	      }
	    }, seriesModel, idx);
	  } else {
	    graphic.updateProps(polygon, {
	      style: {
	        opacity: opacity
	      },
	      shape: {
	        points: layout.points
	      }
	    }, seriesModel, idx);
	  } // Update common style
	
	
	  var itemStyleModel = itemModel.getModel('itemStyle');
	  var visualColor = data.getItemVisual(idx, 'color');
	  polygon.setStyle(zrUtil.defaults({
	    lineJoin: 'round',
	    fill: visualColor
	  }, itemStyleModel.getItemStyle(['opacity'])));
	  polygon.hoverStyle = itemStyleModel.getModel('emphasis').getItemStyle();
	
	  this._updateLabel(data, idx);
	
	  graphic.setHoverStyle(this);
	};
	
	funnelPieceProto._updateLabel = function (data, idx) {
	  var labelLine = this.childAt(1);
	  var labelText = this.childAt(2);
	  var seriesModel = data.hostModel;
	  var itemModel = data.getItemModel(idx);
	  var layout = data.getItemLayout(idx);
	  var labelLayout = layout.label;
	  var visualColor = data.getItemVisual(idx, 'color');
	  graphic.updateProps(labelLine, {
	    shape: {
	      points: labelLayout.linePoints || labelLayout.linePoints
	    }
	  }, seriesModel, idx);
	  graphic.updateProps(labelText, {
	    style: {
	      x: labelLayout.x,
	      y: labelLayout.y
	    }
	  }, seriesModel, idx);
	  labelText.attr({
	    rotation: labelLayout.rotation,
	    origin: [labelLayout.x, labelLayout.y],
	    z2: 10
	  });
	  var labelModel = itemModel.getModel('label');
	  var labelHoverModel = itemModel.getModel('emphasis.label');
	  var labelLineModel = itemModel.getModel('labelLine');
	  var labelLineHoverModel = itemModel.getModel('emphasis.labelLine');
	  var visualColor = data.getItemVisual(idx, 'color');
	  graphic.setLabelStyle(labelText.style, labelText.hoverStyle = {}, labelModel, labelHoverModel, {
	    labelFetcher: data.hostModel,
	    labelDataIndex: idx,
	    defaultText: data.getName(idx),
	    autoColor: visualColor,
	    useInsideStyle: !!labelLayout.inside
	  }, {
	    textAlign: labelLayout.textAlign,
	    textVerticalAlign: labelLayout.verticalAlign
	  });
	  labelText.ignore = labelText.normalIgnore = !labelModel.get('show');
	  labelText.hoverIgnore = !labelHoverModel.get('show');
	  labelLine.ignore = labelLine.normalIgnore = !labelLineModel.get('show');
	  labelLine.hoverIgnore = !labelLineHoverModel.get('show'); // Default use item visual color
	
	  labelLine.setStyle({
	    stroke: visualColor
	  });
	  labelLine.setStyle(labelLineModel.getModel('lineStyle').getLineStyle());
	  labelLine.hoverStyle = labelLineHoverModel.getModel('lineStyle').getLineStyle();
	};
	
	zrUtil.inherits(FunnelPiece, graphic.Group);
	var FunnelView = ChartView.extend({
	  type: 'funnel',
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var group = this.group;
	    data.diff(oldData).add(function (idx) {
	      var funnelPiece = new FunnelPiece(data, idx);
	      data.setItemGraphicEl(idx, funnelPiece);
	      group.add(funnelPiece);
	    }).update(function (newIdx, oldIdx) {
	      var piePiece = oldData.getItemGraphicEl(oldIdx);
	      piePiece.updateData(data, newIdx);
	      group.add(piePiece);
	      data.setItemGraphicEl(newIdx, piePiece);
	    }).remove(function (idx) {
	      var piePiece = oldData.getItemGraphicEl(idx);
	      group.remove(piePiece);
	    }).execute();
	    this._data = data;
	  },
	  remove: function () {
	    this.group.removeAll();
	    this._data = null;
	  },
	  dispose: function () {}
	});
	var _default = FunnelView;
	module.exports = _default;

/***/ },
/* 1477 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	var layout = __webpack_require__(36);
	
	var _number = __webpack_require__(20);
	
	var parsePercent = _number.parsePercent;
	var linearMap = _number.linearMap;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function getViewRect(seriesModel, api) {
	  return layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
	    width: api.getWidth(),
	    height: api.getHeight()
	  });
	}
	
	function getSortedIndices(data, sort) {
	  var valueDim = data.mapDimension('value');
	  var valueArr = data.mapArray(valueDim, function (val) {
	    return val;
	  });
	  var indices = [];
	  var isAscending = sort === 'ascending';
	
	  for (var i = 0, len = data.count(); i < len; i++) {
	    indices[i] = i;
	  } // Add custom sortable function & none sortable opetion by "options.sort"
	
	
	  if (typeof sort === 'function') {
	    indices.sort(sort);
	  } else if (sort !== 'none') {
	    indices.sort(function (a, b) {
	      return isAscending ? valueArr[a] - valueArr[b] : valueArr[b] - valueArr[a];
	    });
	  }
	
	  return indices;
	}
	
	function labelLayout(data) {
	  data.each(function (idx) {
	    var itemModel = data.getItemModel(idx);
	    var labelModel = itemModel.getModel('label');
	    var labelPosition = labelModel.get('position');
	    var orient = itemModel.get('orient');
	    var labelLineModel = itemModel.getModel('labelLine');
	    var layout = data.getItemLayout(idx);
	    var points = layout.points;
	    var isLabelInside = labelPosition === 'inner' || labelPosition === 'inside' || labelPosition === 'center' || labelPosition === 'insideLeft' || labelPosition === 'insideRight';
	    var textAlign;
	    var textX;
	    var textY;
	    var linePoints;
	
	    if (isLabelInside) {
	      if (labelPosition === 'insideLeft') {
	        textX = (points[0][0] + points[3][0]) / 2 + 5;
	        textY = (points[0][1] + points[3][1]) / 2;
	        textAlign = 'left';
	      } else if (labelPosition === 'insideRight') {
	        textX = (points[1][0] + points[2][0]) / 2 - 5;
	        textY = (points[1][1] + points[2][1]) / 2;
	        textAlign = 'right';
	      } else {
	        textX = (points[0][0] + points[1][0] + points[2][0] + points[3][0]) / 4;
	        textY = (points[0][1] + points[1][1] + points[2][1] + points[3][1]) / 4;
	        textAlign = 'center';
	      }
	
	      linePoints = [[textX, textY], [textX, textY]];
	    } else {
	      var x1;
	      var y1;
	      var x2;
	      var y2;
	      var labelLineLen = labelLineModel.get('length');
	
	      if (labelPosition === 'left') {
	        // Left side
	        x1 = (points[3][0] + points[0][0]) / 2;
	        y1 = (points[3][1] + points[0][1]) / 2;
	        x2 = x1 - labelLineLen;
	        textX = x2 - 5;
	        textAlign = 'right';
	      } else if (labelPosition === 'right') {
	        // Right side
	        x1 = (points[1][0] + points[2][0]) / 2;
	        y1 = (points[1][1] + points[2][1]) / 2;
	        x2 = x1 + labelLineLen;
	        textX = x2 + 5;
	        textAlign = 'left';
	      } else if (labelPosition === 'top') {
	        // Top side
	        x1 = (points[3][0] + points[0][0]) / 2;
	        y1 = (points[3][1] + points[0][1]) / 2;
	        y2 = y1 - labelLineLen;
	        textY = y2 - 5;
	        textAlign = 'center';
	      } else if (labelPosition === 'bottom') {
	        // Bottom side
	        x1 = (points[1][0] + points[2][0]) / 2;
	        y1 = (points[1][1] + points[2][1]) / 2;
	        y2 = y1 + labelLineLen;
	        textY = y2 + 5;
	        textAlign = 'center';
	      } else if (labelPosition === 'rightTop') {
	        // RightTop side
	        x1 = orient === 'horizontal' ? points[3][0] : points[1][0];
	        y1 = orient === 'horizontal' ? points[3][1] : points[1][1];
	
	        if (orient === 'horizontal') {
	          y2 = y1 - labelLineLen;
	          textY = y2 - 5;
	          textAlign = 'center';
	        } else {
	          x2 = x1 + labelLineLen;
	          textX = x2 + 5;
	          textAlign = 'top';
	        }
	      } else if (labelPosition === 'rightBottom') {
	        // RightBottom side
	        x1 = points[2][0];
	        y1 = points[2][1];
	
	        if (orient === 'horizontal') {
	          y2 = y1 + labelLineLen;
	          textY = y2 + 5;
	          textAlign = 'center';
	        } else {
	          x2 = x1 + labelLineLen;
	          textX = x2 + 5;
	          textAlign = 'bottom';
	        }
	      } else if (labelPosition === 'leftTop') {
	        // LeftTop side
	        x1 = points[0][0];
	        y1 = orient === 'horizontal' ? points[0][1] : points[1][1];
	
	        if (orient === 'horizontal') {
	          y2 = y1 - labelLineLen;
	          textY = y2 - 5;
	          textAlign = 'center';
	        } else {
	          x2 = x1 - labelLineLen;
	          textX = x2 - 5;
	          textAlign = 'right';
	        }
	      } else if (labelPosition === 'leftBottom') {
	        // LeftBottom side
	        x1 = orient === 'horizontal' ? points[1][0] : points[3][0];
	        y1 = orient === 'horizontal' ? points[1][1] : points[2][1];
	
	        if (orient === 'horizontal') {
	          y2 = y1 + labelLineLen;
	          textY = y2 + 5;
	          textAlign = 'center';
	        } else {
	          x2 = x1 - labelLineLen;
	          textX = x2 - 5;
	          textAlign = 'right';
	        }
	      } else {
	        // Right side or Bottom side
	        x1 = (points[1][0] + points[2][0]) / 2;
	        y1 = (points[1][1] + points[2][1]) / 2;
	
	        if (orient === 'horizontal') {
	          y2 = y1 + labelLineLen;
	          textY = y2 + 5;
	          textAlign = 'center';
	        } else {
	          x2 = x1 + labelLineLen;
	          textX = x2 + 5;
	          textAlign = 'left';
	        }
	      }
	
	      if (orient === 'horizontal') {
	        x2 = x1;
	        textX = x2;
	      } else {
	        y2 = y1;
	        textY = y2;
	      }
	
	      linePoints = [[x1, y1], [x2, y2]];
	    }
	
	    layout.label = {
	      linePoints: linePoints,
	      x: textX,
	      y: textY,
	      verticalAlign: 'middle',
	      textAlign: textAlign,
	      inside: isLabelInside
	    };
	  });
	}
	
	function _default(ecModel, api, payload) {
	  ecModel.eachSeriesByType('funnel', function (seriesModel) {
	    var data = seriesModel.getData();
	    var valueDim = data.mapDimension('value');
	    var sort = seriesModel.get('sort');
	    var viewRect = getViewRect(seriesModel, api);
	    var indices = getSortedIndices(data, sort);
	    var orient = seriesModel.get('orient');
	    var viewWidth = viewRect.width;
	    var viewHeight = viewRect.height;
	    var x = viewRect.x;
	    var y = viewRect.y;
	    var sizeExtent = orient === 'horizontal' ? [parsePercent(seriesModel.get('minSize'), viewHeight), parsePercent(seriesModel.get('maxSize'), viewHeight)] : [parsePercent(seriesModel.get('minSize'), viewWidth), parsePercent(seriesModel.get('maxSize'), viewWidth)];
	    var dataExtent = data.getDataExtent(valueDim);
	    var min = seriesModel.get('min');
	    var max = seriesModel.get('max');
	
	    if (min == null) {
	      min = Math.min(dataExtent[0], 0);
	    }
	
	    if (max == null) {
	      max = dataExtent[1];
	    }
	
	    var funnelAlign = seriesModel.get('funnelAlign');
	    var gap = seriesModel.get('gap');
	    var viewSize = orient === 'horizontal' ? viewWidth : viewHeight;
	    var itemSize = (viewSize - gap * (data.count() - 1)) / data.count();
	
	    var getLinePoints = function (idx, offset) {
	      // End point index is data.count() and we assign it 0
	      if (orient === 'horizontal') {
	        var val = data.get(valueDim, idx) || 0;
	        var itemHeight = linearMap(val, [min, max], sizeExtent, true);
	        var y0;
	
	        switch (funnelAlign) {
	          case 'top':
	            y0 = y;
	            break;
	
	          case 'center':
	            y0 = y + (viewHeight - itemHeight) / 2;
	            break;
	
	          case 'bottom':
	            y0 = y + (viewHeight - itemHeight);
	            break;
	        }
	
	        return [[offset, y0], [offset, y0 + itemHeight]];
	      }
	
	      var val = data.get(valueDim, idx) || 0;
	      var itemWidth = linearMap(val, [min, max], sizeExtent, true);
	      var x0;
	
	      switch (funnelAlign) {
	        case 'left':
	          x0 = x;
	          break;
	
	        case 'center':
	          x0 = x + (viewWidth - itemWidth) / 2;
	          break;
	
	        case 'right':
	          x0 = x + viewWidth - itemWidth;
	          break;
	      }
	
	      return [[x0, offset], [x0 + itemWidth, offset]];
	    };
	
	    if (sort === 'ascending') {
	      // From bottom to top
	      itemSize = -itemSize;
	      gap = -gap;
	
	      if (orient === 'horizontal') {
	        x += viewWidth;
	      } else {
	        y += viewHeight;
	      }
	
	      indices = indices.reverse();
	    }
	
	    for (var i = 0; i < indices.length; i++) {
	      var idx = indices[i];
	      var nextIdx = indices[i + 1];
	      var itemModel = data.getItemModel(idx);
	
	      if (orient === 'horizontal') {
	        var width = itemModel.get('itemStyle.width');
	
	        if (width == null) {
	          width = itemSize;
	        } else {
	          width = parsePercent(width, viewWidth);
	
	          if (sort === 'ascending') {
	            width = -width;
	          }
	        }
	
	        var start = getLinePoints(idx, x);
	        var end = getLinePoints(nextIdx, x + width);
	        x += width + gap;
	        data.setItemLayout(idx, {
	          points: start.concat(end.slice().reverse())
	        });
	      } else {
	        var height = itemModel.get('itemStyle.height');
	
	        if (height == null) {
	          height = itemSize;
	        } else {
	          height = parsePercent(height, viewHeight);
	
	          if (sort === 'ascending') {
	            height = -height;
	          }
	        }
	
	        var start = orient === 'horizontal' ? getLinePoints(idx, x) : getLinePoints(idx, y);
	        var end = orient === 'horizontal' ? getLinePoints(nextIdx, x + width) : getLinePoints(nextIdx, y + height);
	        y += height + gap;
	        data.setItemLayout(idx, {
	          points: start.concat(end.slice().reverse())
	        });
	      }
	    }
	
	    labelLayout(data);
	  });
	}
	
	module.exports = _default;

/***/ },
/* 1478 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(1479);
	
	__webpack_require__(1480);

/***/ },
/* 1479 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createListSimply = __webpack_require__(201);
	
	var SeriesModel = __webpack_require__(58);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var GaugeSeries = SeriesModel.extend({
	  type: 'series.gauge',
	  getInitialData: function (option, ecModel) {
	    return createListSimply(this, ['value']);
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    // 默认全局居中
	    center: ['50%', '50%'],
	    legendHoverLink: true,
	    radius: '75%',
	    startAngle: 225,
	    endAngle: -45,
	    clockwise: true,
	    // 最小值
	    min: 0,
	    // 最大值
	    max: 100,
	    // 分割段数，默认为10
	    splitNumber: 10,
	    // 坐标轴线
	    axisLine: {
	      // 默认显示，属性show控制显示与否
	      show: true,
	      lineStyle: {
	        // 属性lineStyle控制线条样式
	        color: [[0.2, '#91c7ae'], [0.8, '#63869e'], [1, '#c23531']],
	        width: 30
	      }
	    },
	    // 分隔线
	    splitLine: {
	      // 默认显示，属性show控制显示与否
	      show: true,
	      // 属性length控制线长
	      length: 30,
	      // 属性lineStyle（详见lineStyle）控制线条样式
	      lineStyle: {
	        color: '#eee',
	        width: 2,
	        type: 'solid'
	      }
	    },
	    // 坐标轴小标记
	    axisTick: {
	      // 属性show控制显示与否，默认不显示
	      show: true,
	      // 每份split细分多少段
	      splitNumber: 5,
	      // 属性length控制线长
	      length: 8,
	      // 属性lineStyle控制线条样式
	      lineStyle: {
	        color: '#eee',
	        width: 1,
	        type: 'solid'
	      }
	    },
	    axisLabel: {
	      show: true,
	      distance: 5,
	      // formatter: null,
	      color: 'auto'
	    },
	    pointer: {
	      show: true,
	      length: '80%',
	      width: 8
	    },
	    itemStyle: {
	      color: 'auto'
	    },
	    title: {
	      show: true,
	      // x, y，单位px
	      offsetCenter: [0, '-40%'],
	      // 其余属性默认使用全局文本样式，详见TEXTSTYLE
	      color: '#333',
	      fontSize: 15
	    },
	    detail: {
	      show: true,
	      backgroundColor: 'rgba(0,0,0,0)',
	      borderWidth: 0,
	      borderColor: '#ccc',
	      width: 100,
	      height: null,
	      // self-adaption
	      padding: [5, 10],
	      // x, y，单位px
	      offsetCenter: [0, '40%'],
	      // formatter: null,
	      // 其余属性默认使用全局文本样式，详见TEXTSTYLE
	      color: 'auto',
	      fontSize: 30
	    }
	  }
	});
	var _default = GaugeSeries;
	module.exports = _default;

/***/ },
/* 1480 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var PointerPath = __webpack_require__(1481);
	
	var graphic = __webpack_require__(16);
	
	var ChartView = __webpack_require__(106);
	
	var _number = __webpack_require__(20);
	
	var parsePercent = _number.parsePercent;
	var round = _number.round;
	var linearMap = _number.linearMap;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function parsePosition(seriesModel, api) {
	  var center = seriesModel.get('center');
	  var width = api.getWidth();
	  var height = api.getHeight();
	  var size = Math.min(width, height);
	  var cx = parsePercent(center[0], api.getWidth());
	  var cy = parsePercent(center[1], api.getHeight());
	  var r = parsePercent(seriesModel.get('radius'), size / 2);
	  return {
	    cx: cx,
	    cy: cy,
	    r: r
	  };
	}
	
	function formatLabel(label, labelFormatter) {
	  if (labelFormatter) {
	    if (typeof labelFormatter === 'string') {
	      label = labelFormatter.replace('{value}', label != null ? label : '');
	    } else if (typeof labelFormatter === 'function') {
	      label = labelFormatter(label);
	    }
	  }
	
	  return label;
	}
	
	var PI2 = Math.PI * 2;
	var GaugeView = ChartView.extend({
	  type: 'gauge',
	  render: function (seriesModel, ecModel, api) {
	    this.group.removeAll();
	    var colorList = seriesModel.get('axisLine.lineStyle.color');
	    var posInfo = parsePosition(seriesModel, api);
	
	    this._renderMain(seriesModel, ecModel, api, colorList, posInfo);
	  },
	  dispose: function () {},
	  _renderMain: function (seriesModel, ecModel, api, colorList, posInfo) {
	    var group = this.group;
	    var axisLineModel = seriesModel.getModel('axisLine');
	    var lineStyleModel = axisLineModel.getModel('lineStyle');
	    var clockwise = seriesModel.get('clockwise');
	    var startAngle = -seriesModel.get('startAngle') / 180 * Math.PI;
	    var endAngle = -seriesModel.get('endAngle') / 180 * Math.PI;
	    var angleRangeSpan = (endAngle - startAngle) % PI2;
	    var prevEndAngle = startAngle;
	    var axisLineWidth = lineStyleModel.get('width');
	    var showAxis = axisLineModel.get('show');
	
	    for (var i = 0; showAxis && i < colorList.length; i++) {
	      // Clamp
	      var percent = Math.min(Math.max(colorList[i][0], 0), 1);
	      var endAngle = startAngle + angleRangeSpan * percent;
	      var sector = new graphic.Sector({
	        shape: {
	          startAngle: prevEndAngle,
	          endAngle: endAngle,
	          cx: posInfo.cx,
	          cy: posInfo.cy,
	          clockwise: clockwise,
	          r0: posInfo.r - axisLineWidth,
	          r: posInfo.r
	        },
	        silent: true
	      });
	      sector.setStyle({
	        fill: colorList[i][1]
	      });
	      sector.setStyle(lineStyleModel.getLineStyle( // Because we use sector to simulate arc
	      // so the properties for stroking are useless
	      ['color', 'borderWidth', 'borderColor']));
	      group.add(sector);
	      prevEndAngle = endAngle;
	    }
	
	    var getColor = function (percent) {
	      // Less than 0
	      if (percent <= 0) {
	        return colorList[0][1];
	      }
	
	      for (var i = 0; i < colorList.length; i++) {
	        if (colorList[i][0] >= percent && (i === 0 ? 0 : colorList[i - 1][0]) < percent) {
	          return colorList[i][1];
	        }
	      } // More than 1
	
	
	      return colorList[i - 1][1];
	    };
	
	    if (!clockwise) {
	      var tmp = startAngle;
	      startAngle = endAngle;
	      endAngle = tmp;
	    }
	
	    this._renderTicks(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise);
	
	    this._renderPointer(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise);
	
	    this._renderTitle(seriesModel, ecModel, api, getColor, posInfo);
	
	    this._renderDetail(seriesModel, ecModel, api, getColor, posInfo);
	  },
	  _renderTicks: function (seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise) {
	    var group = this.group;
	    var cx = posInfo.cx;
	    var cy = posInfo.cy;
	    var r = posInfo.r;
	    var minVal = +seriesModel.get('min');
	    var maxVal = +seriesModel.get('max');
	    var splitLineModel = seriesModel.getModel('splitLine');
	    var tickModel = seriesModel.getModel('axisTick');
	    var labelModel = seriesModel.getModel('axisLabel');
	    var splitNumber = seriesModel.get('splitNumber');
	    var subSplitNumber = tickModel.get('splitNumber');
	    var splitLineLen = parsePercent(splitLineModel.get('length'), r);
	    var tickLen = parsePercent(tickModel.get('length'), r);
	    var angle = startAngle;
	    var step = (endAngle - startAngle) / splitNumber;
	    var subStep = step / subSplitNumber;
	    var splitLineStyle = splitLineModel.getModel('lineStyle').getLineStyle();
	    var tickLineStyle = tickModel.getModel('lineStyle').getLineStyle();
	
	    for (var i = 0; i <= splitNumber; i++) {
	      var unitX = Math.cos(angle);
	      var unitY = Math.sin(angle); // Split line
	
	      if (splitLineModel.get('show')) {
	        var splitLine = new graphic.Line({
	          shape: {
	            x1: unitX * r + cx,
	            y1: unitY * r + cy,
	            x2: unitX * (r - splitLineLen) + cx,
	            y2: unitY * (r - splitLineLen) + cy
	          },
	          style: splitLineStyle,
	          silent: true
	        });
	
	        if (splitLineStyle.stroke === 'auto') {
	          splitLine.setStyle({
	            stroke: getColor(i / splitNumber)
	          });
	        }
	
	        group.add(splitLine);
	      } // Label
	
	
	      if (labelModel.get('show')) {
	        var label = formatLabel(round(i / splitNumber * (maxVal - minVal) + minVal), labelModel.get('formatter'));
	        var distance = labelModel.get('distance');
	        var autoColor = getColor(i / splitNumber);
	        group.add(new graphic.Text({
	          style: graphic.setTextStyle({}, labelModel, {
	            text: label,
	            x: unitX * (r - splitLineLen - distance) + cx,
	            y: unitY * (r - splitLineLen - distance) + cy,
	            textVerticalAlign: unitY < -0.4 ? 'top' : unitY > 0.4 ? 'bottom' : 'middle',
	            textAlign: unitX < -0.4 ? 'left' : unitX > 0.4 ? 'right' : 'center'
	          }, {
	            autoColor: autoColor
	          }),
	          silent: true
	        }));
	      } // Axis tick
	
	
	      if (tickModel.get('show') && i !== splitNumber) {
	        for (var j = 0; j <= subSplitNumber; j++) {
	          var unitX = Math.cos(angle);
	          var unitY = Math.sin(angle);
	          var tickLine = new graphic.Line({
	            shape: {
	              x1: unitX * r + cx,
	              y1: unitY * r + cy,
	              x2: unitX * (r - tickLen) + cx,
	              y2: unitY * (r - tickLen) + cy
	            },
	            silent: true,
	            style: tickLineStyle
	          });
	
	          if (tickLineStyle.stroke === 'auto') {
	            tickLine.setStyle({
	              stroke: getColor((i + j / subSplitNumber) / splitNumber)
	            });
	          }
	
	          group.add(tickLine);
	          angle += subStep;
	        }
	
	        angle -= subStep;
	      } else {
	        angle += step;
	      }
	    }
	  },
	  _renderPointer: function (seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise) {
	    var group = this.group;
	    var oldData = this._data;
	
	    if (!seriesModel.get('pointer.show')) {
	      // Remove old element
	      oldData && oldData.eachItemGraphicEl(function (el) {
	        group.remove(el);
	      });
	      return;
	    }
	
	    var valueExtent = [+seriesModel.get('min'), +seriesModel.get('max')];
	    var angleExtent = [startAngle, endAngle];
	    var data = seriesModel.getData();
	    var valueDim = data.mapDimension('value');
	    data.diff(oldData).add(function (idx) {
	      var pointer = new PointerPath({
	        shape: {
	          angle: startAngle
	        }
	      });
	      graphic.initProps(pointer, {
	        shape: {
	          angle: linearMap(data.get(valueDim, idx), valueExtent, angleExtent, true)
	        }
	      }, seriesModel);
	      group.add(pointer);
	      data.setItemGraphicEl(idx, pointer);
	    }).update(function (newIdx, oldIdx) {
	      var pointer = oldData.getItemGraphicEl(oldIdx);
	      graphic.updateProps(pointer, {
	        shape: {
	          angle: linearMap(data.get(valueDim, newIdx), valueExtent, angleExtent, true)
	        }
	      }, seriesModel);
	      group.add(pointer);
	      data.setItemGraphicEl(newIdx, pointer);
	    }).remove(function (idx) {
	      var pointer = oldData.getItemGraphicEl(idx);
	      group.remove(pointer);
	    }).execute();
	    data.eachItemGraphicEl(function (pointer, idx) {
	      var itemModel = data.getItemModel(idx);
	      var pointerModel = itemModel.getModel('pointer');
	      pointer.setShape({
	        x: posInfo.cx,
	        y: posInfo.cy,
	        width: parsePercent(pointerModel.get('width'), posInfo.r),
	        r: parsePercent(pointerModel.get('length'), posInfo.r)
	      });
	      pointer.useStyle(itemModel.getModel('itemStyle').getItemStyle());
	
	      if (pointer.style.fill === 'auto') {
	        pointer.setStyle('fill', getColor(linearMap(data.get(valueDim, idx), valueExtent, [0, 1], true)));
	      }
	
	      graphic.setHoverStyle(pointer, itemModel.getModel('emphasis.itemStyle').getItemStyle());
	    });
	    this._data = data;
	  },
	  _renderTitle: function (seriesModel, ecModel, api, getColor, posInfo) {
	    var data = seriesModel.getData();
	    var valueDim = data.mapDimension('value');
	    var titleModel = seriesModel.getModel('title');
	
	    if (titleModel.get('show')) {
	      var offsetCenter = titleModel.get('offsetCenter');
	      var x = posInfo.cx + parsePercent(offsetCenter[0], posInfo.r);
	      var y = posInfo.cy + parsePercent(offsetCenter[1], posInfo.r);
	      var minVal = +seriesModel.get('min');
	      var maxVal = +seriesModel.get('max');
	      var value = seriesModel.getData().get(valueDim, 0);
	      var autoColor = getColor(linearMap(value, [minVal, maxVal], [0, 1], true));
	      this.group.add(new graphic.Text({
	        silent: true,
	        style: graphic.setTextStyle({}, titleModel, {
	          x: x,
	          y: y,
	          // FIXME First data name ?
	          text: data.getName(0),
	          textAlign: 'center',
	          textVerticalAlign: 'middle'
	        }, {
	          autoColor: autoColor,
	          forceRich: true
	        })
	      }));
	    }
	  },
	  _renderDetail: function (seriesModel, ecModel, api, getColor, posInfo) {
	    var detailModel = seriesModel.getModel('detail');
	    var minVal = +seriesModel.get('min');
	    var maxVal = +seriesModel.get('max');
	
	    if (detailModel.get('show')) {
	      var offsetCenter = detailModel.get('offsetCenter');
	      var x = posInfo.cx + parsePercent(offsetCenter[0], posInfo.r);
	      var y = posInfo.cy + parsePercent(offsetCenter[1], posInfo.r);
	      var width = parsePercent(detailModel.get('width'), posInfo.r);
	      var height = parsePercent(detailModel.get('height'), posInfo.r);
	      var data = seriesModel.getData();
	      var value = data.get(data.mapDimension('value'), 0);
	      var autoColor = getColor(linearMap(value, [minVal, maxVal], [0, 1], true));
	      this.group.add(new graphic.Text({
	        silent: true,
	        style: graphic.setTextStyle({}, detailModel, {
	          x: x,
	          y: y,
	          text: formatLabel( // FIXME First data name ?
	          value, detailModel.get('formatter')),
	          textWidth: isNaN(width) ? null : width,
	          textHeight: isNaN(height) ? null : height,
	          textAlign: 'center',
	          textVerticalAlign: 'middle'
	        }, {
	          autoColor: autoColor,
	          forceRich: true
	        })
	      }));
	    }
	  }
	});
	var _default = GaugeView;
	module.exports = _default;

/***/ },
/* 1481 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Path = __webpack_require__(46);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = Path.extend({
	  type: 'echartsGaugePointer',
	  shape: {
	    angle: 0,
	    width: 10,
	    r: 10,
	    x: 0,
	    y: 0
	  },
	  buildPath: function (ctx, shape) {
	    var mathCos = Math.cos;
	    var mathSin = Math.sin;
	    var r = shape.r;
	    var width = shape.width;
	    var angle = shape.angle;
	    var x = shape.x - mathCos(angle) * width * (width >= r / 3 ? 1 : 2);
	    var y = shape.y - mathSin(angle) * width * (width >= r / 3 ? 1 : 2);
	    angle = shape.angle - Math.PI / 2;
	    ctx.moveTo(x, y);
	    ctx.lineTo(shape.x + mathCos(angle) * width, shape.y + mathSin(angle) * width);
	    ctx.lineTo(shape.x + mathCos(shape.angle) * r, shape.y + mathSin(shape.angle) * r);
	    ctx.lineTo(shape.x - mathCos(angle) * width, shape.y - mathSin(angle) * width);
	    ctx.lineTo(x, y);
	    return;
	  }
	});
	
	module.exports = _default;

/***/ },
/* 1482 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	__webpack_require__(1483);
	
	__webpack_require__(1484);
	
	__webpack_require__(1493);
	
	var categoryFilter = __webpack_require__(1486);
	
	var visualSymbol = __webpack_require__(169);
	
	var categoryVisual = __webpack_require__(1487);
	
	var edgeVisual = __webpack_require__(1490);
	
	var simpleLayout = __webpack_require__(1494);
	
	var circularLayout = __webpack_require__(1488);
	
	var forceLayout = __webpack_require__(1492);
	
	var createView = __webpack_require__(1489);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerProcessor(categoryFilter);
	echarts.registerVisual(visualSymbol('graph', 'circle', null));
	echarts.registerVisual(categoryVisual);
	echarts.registerVisual(edgeVisual);
	echarts.registerLayout(simpleLayout);
	echarts.registerLayout(echarts.PRIORITY.VISUAL.POST_CHART_LAYOUT, circularLayout);
	echarts.registerLayout(forceLayout); // Graph view coordinate system
	
	echarts.registerCoordinateSystem('graphView', {
	  create: createView
	});

/***/ },
/* 1483 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var List = __webpack_require__(83);
	
	var zrUtil = __webpack_require__(3);
	
	var _model = __webpack_require__(24);
	
	var defaultEmphasis = _model.defaultEmphasis;
	
	var Model = __webpack_require__(48);
	
	var _format = __webpack_require__(40);
	
	var encodeHTML = _format.encodeHTML;
	
	var createGraphFromNodeEdge = __webpack_require__(702);
	
	var LegendVisualProvider = __webpack_require__(269);
	
	var _multipleGraphEdgeHelper = __webpack_require__(331);
	
	var initCurvenessList = _multipleGraphEdgeHelper.initCurvenessList;
	var createEdgeMapForCurveness = _multipleGraphEdgeHelper.createEdgeMapForCurveness;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var GraphSeries = echarts.extendSeriesModel({
	  type: 'series.graph',
	  init: function (option) {
	    GraphSeries.superApply(this, 'init', arguments);
	    var self = this;
	
	    function getCategoriesData() {
	      return self._categoriesData;
	    } // Provide data for legend select
	
	
	    this.legendVisualProvider = new LegendVisualProvider(getCategoriesData, getCategoriesData);
	    this.fillDataTextStyle(option.edges || option.links);
	
	    this._updateCategoriesData();
	  },
	  mergeOption: function (option) {
	    GraphSeries.superApply(this, 'mergeOption', arguments);
	    this.fillDataTextStyle(option.edges || option.links);
	
	    this._updateCategoriesData();
	  },
	  mergeDefaultAndTheme: function (option) {
	    GraphSeries.superApply(this, 'mergeDefaultAndTheme', arguments);
	    defaultEmphasis(option, ['edgeLabel'], ['show']);
	  },
	  getInitialData: function (option, ecModel) {
	    var edges = option.edges || option.links || [];
	    var nodes = option.data || option.nodes || [];
	    var self = this;
	
	    if (nodes && edges) {
	      // auto curveness
	      initCurvenessList(this);
	      var graph = createGraphFromNodeEdge(nodes, edges, this, true, beforeLink);
	      zrUtil.each(graph.edges, function (edge) {
	        createEdgeMapForCurveness(edge.node1, edge.node2, this, edge.dataIndex);
	      }, this);
	      return graph.data;
	    }
	
	    function beforeLink(nodeData, edgeData) {
	      // Overwrite nodeData.getItemModel to
	      nodeData.wrapMethod('getItemModel', function (model) {
	        var categoriesModels = self._categoriesModels;
	        var categoryIdx = model.getShallow('category');
	        var categoryModel = categoriesModels[categoryIdx];
	
	        if (categoryModel) {
	          categoryModel.parentModel = model.parentModel;
	          model.parentModel = categoryModel;
	        }
	
	        return model;
	      });
	      var edgeLabelModel = self.getModel('edgeLabel'); // For option `edgeLabel` can be found by label.xxx.xxx on item mode.
	
	      var fakeSeriesModel = new Model({
	        label: edgeLabelModel.option
	      }, edgeLabelModel.parentModel, ecModel);
	      var emphasisEdgeLabelModel = self.getModel('emphasis.edgeLabel');
	      var emphasisFakeSeriesModel = new Model({
	        emphasis: {
	          label: emphasisEdgeLabelModel.option
	        }
	      }, emphasisEdgeLabelModel.parentModel, ecModel);
	      edgeData.wrapMethod('getItemModel', function (model) {
	        model.customizeGetParent(edgeGetParent);
	        return model;
	      });
	
	      function edgeGetParent(path) {
	        path = this.parsePath(path);
	        return path && path[0] === 'label' ? fakeSeriesModel : path && path[0] === 'emphasis' && path[1] === 'label' ? emphasisFakeSeriesModel : this.parentModel;
	      }
	    }
	  },
	
	  /**
	   * @return {module:echarts/data/Graph}
	   */
	  getGraph: function () {
	    return this.getData().graph;
	  },
	
	  /**
	   * @return {module:echarts/data/List}
	   */
	  getEdgeData: function () {
	    return this.getGraph().edgeData;
	  },
	
	  /**
	   * @return {module:echarts/data/List}
	   */
	  getCategoriesData: function () {
	    return this._categoriesData;
	  },
	
	  /**
	   * @override
	   */
	  formatTooltip: function (dataIndex, multipleSeries, dataType) {
	    if (dataType === 'edge') {
	      var nodeData = this.getData();
	      var params = this.getDataParams(dataIndex, dataType);
	      var edge = nodeData.graph.getEdgeByIndex(dataIndex);
	      var sourceName = nodeData.getName(edge.node1.dataIndex);
	      var targetName = nodeData.getName(edge.node2.dataIndex);
	      var html = [];
	      sourceName != null && html.push(sourceName);
	      targetName != null && html.push(targetName);
	      html = encodeHTML(html.join(' > '));
	
	      if (params.value) {
	        html += ' : ' + encodeHTML(params.value);
	      }
	
	      return html;
	    } else {
	      // dataType === 'node' or empty
	      return GraphSeries.superApply(this, 'formatTooltip', arguments);
	    }
	  },
	  _updateCategoriesData: function () {
	    var categories = zrUtil.map(this.option.categories || [], function (category) {
	      // Data must has value
	      return category.value != null ? category : zrUtil.extend({
	        value: 0
	      }, category);
	    });
	    var categoriesData = new List(['value'], this);
	    categoriesData.initData(categories);
	    this._categoriesData = categoriesData;
	    this._categoriesModels = categoriesData.mapArray(function (idx) {
	      return categoriesData.getItemModel(idx, true);
	    });
	  },
	  setZoom: function (zoom) {
	    this.option.zoom = zoom;
	  },
	  setCenter: function (center) {
	    this.option.center = center;
	  },
	  isAnimationEnabled: function () {
	    return GraphSeries.superCall(this, 'isAnimationEnabled') // Not enable animation when do force layout
	    && !(this.get('layout') === 'force' && this.get('force.layoutAnimation'));
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'view',
	    // Default option for all coordinate systems
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // polarIndex: 0,
	    // geoIndex: 0,
	    legendHoverLink: true,
	    hoverAnimation: true,
	    layout: null,
	    focusNodeAdjacency: false,
	    // Configuration of circular layout
	    circular: {
	      rotateLabel: false
	    },
	    // Configuration of force directed layout
	    force: {
	      initLayout: null,
	      // Node repulsion. Can be an array to represent range.
	      repulsion: [0, 50],
	      gravity: 0.1,
	      // Initial friction
	      friction: 0.6,
	      // Edge length. Can be an array to represent range.
	      edgeLength: 30,
	      layoutAnimation: true
	    },
	    left: 'center',
	    top: 'center',
	    // right: null,
	    // bottom: null,
	    // width: '80%',
	    // height: '80%',
	    symbol: 'circle',
	    symbolSize: 10,
	    edgeSymbol: ['none', 'none'],
	    edgeSymbolSize: 10,
	    edgeLabel: {
	      position: 'middle',
	      distance: 5
	    },
	    draggable: false,
	    roam: false,
	    // Default on center of graph
	    center: null,
	    zoom: 1,
	    // Symbol size scale ratio in roam
	    nodeScaleRatio: 0.6,
	    // cursor: null,
	    // categories: [],
	    // data: []
	    // Or
	    // nodes: []
	    //
	    // links: []
	    // Or
	    // edges: []
	    label: {
	      show: false,
	      formatter: '{b}'
	    },
	    itemStyle: {},
	    lineStyle: {
	      color: '#aaa',
	      width: 1,
	      opacity: 0.5
	    },
	    emphasis: {
	      label: {
	        show: true
	      }
	    }
	  }
	});
	var _default = GraphSeries;
	module.exports = _default;

/***/ },
/* 1484 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var SymbolDraw = __webpack_require__(258);
	
	var LineDraw = __webpack_require__(456);
	
	var RoamController = __webpack_require__(262);
	
	var roamHelper = __webpack_require__(464);
	
	var _cursorHelper = __webpack_require__(334);
	
	var onIrrelevantElement = _cursorHelper.onIrrelevantElement;
	
	var graphic = __webpack_require__(16);
	
	var adjustEdge = __webpack_require__(1485);
	
	var _graphHelper = __webpack_require__(454);
	
	var getNodeGlobalScale = _graphHelper.getNodeGlobalScale;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var FOCUS_ADJACENCY = '__focusNodeAdjacency';
	var UNFOCUS_ADJACENCY = '__unfocusNodeAdjacency';
	var nodeOpacityPath = ['itemStyle', 'opacity'];
	var lineOpacityPath = ['lineStyle', 'opacity'];
	
	function getItemOpacity(item, opacityPath) {
	  var opacity = item.getVisual('opacity');
	  return opacity != null ? opacity : item.getModel().get(opacityPath);
	}
	
	function fadeOutItem(item, opacityPath, opacityRatio) {
	  var el = item.getGraphicEl();
	  var opacity = getItemOpacity(item, opacityPath);
	
	  if (opacityRatio != null) {
	    opacity == null && (opacity = 1);
	    opacity *= opacityRatio;
	  }
	
	  el.downplay && el.downplay();
	  el.traverse(function (child) {
	    if (!child.isGroup) {
	      var opct = child.lineLabelOriginalOpacity;
	
	      if (opct == null || opacityRatio != null) {
	        opct = opacity;
	      }
	
	      child.setStyle('opacity', opct);
	    }
	  });
	}
	
	function fadeInItem(item, opacityPath) {
	  var opacity = getItemOpacity(item, opacityPath);
	  var el = item.getGraphicEl(); // Should go back to normal opacity first, consider hoverLayer,
	  // where current state is copied to elMirror, and support
	  // emphasis opacity here.
	
	  el.traverse(function (child) {
	    !child.isGroup && child.setStyle('opacity', opacity);
	  });
	  el.highlight && el.highlight();
	}
	
	var _default = echarts.extendChartView({
	  type: 'graph',
	  init: function (ecModel, api) {
	    var symbolDraw = new SymbolDraw();
	    var lineDraw = new LineDraw();
	    var group = this.group;
	    this._controller = new RoamController(api.getZr());
	    this._controllerHost = {
	      target: group
	    };
	    group.add(symbolDraw.group);
	    group.add(lineDraw.group);
	    this._symbolDraw = symbolDraw;
	    this._lineDraw = lineDraw;
	    this._firstRender = true;
	  },
	  render: function (seriesModel, ecModel, api) {
	    var graphView = this;
	    var coordSys = seriesModel.coordinateSystem;
	    this._model = seriesModel;
	    var symbolDraw = this._symbolDraw;
	    var lineDraw = this._lineDraw;
	    var group = this.group;
	
	    if (coordSys.type === 'view') {
	      var groupNewProp = {
	        position: coordSys.position,
	        scale: coordSys.scale
	      };
	
	      if (this._firstRender) {
	        group.attr(groupNewProp);
	      } else {
	        graphic.updateProps(group, groupNewProp, seriesModel);
	      }
	    } // Fix edge contact point with node
	
	
	    adjustEdge(seriesModel.getGraph(), getNodeGlobalScale(seriesModel));
	    var data = seriesModel.getData();
	    symbolDraw.updateData(data);
	    var edgeData = seriesModel.getEdgeData();
	    lineDraw.updateData(edgeData);
	
	    this._updateNodeAndLinkScale();
	
	    this._updateController(seriesModel, ecModel, api);
	
	    clearTimeout(this._layoutTimeout);
	    var forceLayout = seriesModel.forceLayout;
	    var layoutAnimation = seriesModel.get('force.layoutAnimation');
	
	    if (forceLayout) {
	      this._startForceLayoutIteration(forceLayout, layoutAnimation);
	    }
	
	    data.eachItemGraphicEl(function (el, idx) {
	      var itemModel = data.getItemModel(idx); // Update draggable
	
	      el.off('drag').off('dragend');
	      var draggable = itemModel.get('draggable');
	
	      if (draggable) {
	        el.on('drag', function () {
	          if (forceLayout) {
	            forceLayout.warmUp();
	            !this._layouting && this._startForceLayoutIteration(forceLayout, layoutAnimation);
	            forceLayout.setFixed(idx); // Write position back to layout
	
	            data.setItemLayout(idx, el.position);
	          }
	        }, this).on('dragend', function () {
	          if (forceLayout) {
	            forceLayout.setUnfixed(idx);
	          }
	        }, this);
	      }
	
	      el.setDraggable(draggable && forceLayout);
	      el[FOCUS_ADJACENCY] && el.off('mouseover', el[FOCUS_ADJACENCY]);
	      el[UNFOCUS_ADJACENCY] && el.off('mouseout', el[UNFOCUS_ADJACENCY]);
	
	      if (itemModel.get('focusNodeAdjacency')) {
	        el.on('mouseover', el[FOCUS_ADJACENCY] = function () {
	          graphView._clearTimer();
	
	          api.dispatchAction({
	            type: 'focusNodeAdjacency',
	            seriesId: seriesModel.id,
	            dataIndex: el.dataIndex
	          });
	        });
	        el.on('mouseout', el[UNFOCUS_ADJACENCY] = function () {
	          graphView._dispatchUnfocus(api);
	        });
	      }
	    }, this);
	    data.graph.eachEdge(function (edge) {
	      var el = edge.getGraphicEl();
	      el[FOCUS_ADJACENCY] && el.off('mouseover', el[FOCUS_ADJACENCY]);
	      el[UNFOCUS_ADJACENCY] && el.off('mouseout', el[UNFOCUS_ADJACENCY]);
	
	      if (edge.getModel().get('focusNodeAdjacency')) {
	        el.on('mouseover', el[FOCUS_ADJACENCY] = function () {
	          graphView._clearTimer();
	
	          api.dispatchAction({
	            type: 'focusNodeAdjacency',
	            seriesId: seriesModel.id,
	            edgeDataIndex: edge.dataIndex
	          });
	        });
	        el.on('mouseout', el[UNFOCUS_ADJACENCY] = function () {
	          graphView._dispatchUnfocus(api);
	        });
	      }
	    });
	    var circularRotateLabel = seriesModel.get('layout') === 'circular' && seriesModel.get('circular.rotateLabel');
	    var cx = data.getLayout('cx');
	    var cy = data.getLayout('cy');
	    data.eachItemGraphicEl(function (el, idx) {
	      var itemModel = data.getItemModel(idx);
	      var labelRotate = itemModel.get('label.rotate') || 0;
	      var symbolPath = el.getSymbolPath();
	
	      if (circularRotateLabel) {
	        var pos = data.getItemLayout(idx);
	        var rad = Math.atan2(pos[1] - cy, pos[0] - cx);
	
	        if (rad < 0) {
	          rad = Math.PI * 2 + rad;
	        }
	
	        var isLeft = pos[0] < cx;
	
	        if (isLeft) {
	          rad = rad - Math.PI;
	        }
	
	        var textPosition = isLeft ? 'left' : 'right';
	        graphic.modifyLabelStyle(symbolPath, {
	          textRotation: -rad,
	          textPosition: textPosition,
	          textOrigin: 'center'
	        }, {
	          textPosition: textPosition
	        });
	      } else {
	        graphic.modifyLabelStyle(symbolPath, {
	          textRotation: labelRotate *= Math.PI / 180
	        });
	      }
	    });
	    this._firstRender = false;
	  },
	  dispose: function () {
	    this._controller && this._controller.dispose();
	    this._controllerHost = {};
	
	    this._clearTimer();
	  },
	  _dispatchUnfocus: function (api, opt) {
	    var self = this;
	
	    this._clearTimer();
	
	    this._unfocusDelayTimer = setTimeout(function () {
	      self._unfocusDelayTimer = null;
	      api.dispatchAction({
	        type: 'unfocusNodeAdjacency',
	        seriesId: self._model.id
	      });
	    }, 500);
	  },
	  _clearTimer: function () {
	    if (this._unfocusDelayTimer) {
	      clearTimeout(this._unfocusDelayTimer);
	      this._unfocusDelayTimer = null;
	    }
	  },
	  focusNodeAdjacency: function (seriesModel, ecModel, api, payload) {
	    var data = seriesModel.getData();
	    var graph = data.graph;
	    var dataIndex = payload.dataIndex;
	    var edgeDataIndex = payload.edgeDataIndex;
	    var node = graph.getNodeByIndex(dataIndex);
	    var edge = graph.getEdgeByIndex(edgeDataIndex);
	
	    if (!node && !edge) {
	      return;
	    }
	
	    graph.eachNode(function (node) {
	      fadeOutItem(node, nodeOpacityPath, 0.1);
	    });
	    graph.eachEdge(function (edge) {
	      fadeOutItem(edge, lineOpacityPath, 0.1);
	    });
	
	    if (node) {
	      fadeInItem(node, nodeOpacityPath);
	      zrUtil.each(node.edges, function (adjacentEdge) {
	        if (adjacentEdge.dataIndex < 0) {
	          return;
	        }
	
	        fadeInItem(adjacentEdge, lineOpacityPath);
	        fadeInItem(adjacentEdge.node1, nodeOpacityPath);
	        fadeInItem(adjacentEdge.node2, nodeOpacityPath);
	      });
	    }
	
	    if (edge) {
	      fadeInItem(edge, lineOpacityPath);
	      fadeInItem(edge.node1, nodeOpacityPath);
	      fadeInItem(edge.node2, nodeOpacityPath);
	    }
	  },
	  unfocusNodeAdjacency: function (seriesModel, ecModel, api, payload) {
	    var graph = seriesModel.getData().graph;
	    graph.eachNode(function (node) {
	      fadeOutItem(node, nodeOpacityPath);
	    });
	    graph.eachEdge(function (edge) {
	      fadeOutItem(edge, lineOpacityPath);
	    });
	  },
	  _startForceLayoutIteration: function (forceLayout, layoutAnimation) {
	    var self = this;
	
	    (function step() {
	      forceLayout.step(function (stopped) {
	        self.updateLayout(self._model);
	        (self._layouting = !stopped) && (layoutAnimation ? self._layoutTimeout = setTimeout(step, 16) : step());
	      });
	    })();
	  },
	  _updateController: function (seriesModel, ecModel, api) {
	    var controller = this._controller;
	    var controllerHost = this._controllerHost;
	    var group = this.group;
	    controller.setPointerChecker(function (e, x, y) {
	      var rect = group.getBoundingRect();
	      rect.applyTransform(group.transform);
	      return rect.contain(x, y) && !onIrrelevantElement(e, api, seriesModel);
	    });
	
	    if (seriesModel.coordinateSystem.type !== 'view') {
	      controller.disable();
	      return;
	    }
	
	    controller.enable(seriesModel.get('roam'));
	    controllerHost.zoomLimit = seriesModel.get('scaleLimit');
	    controllerHost.zoom = seriesModel.coordinateSystem.getZoom();
	    controller.off('pan').off('zoom').on('pan', function (e) {
	      roamHelper.updateViewOnPan(controllerHost, e.dx, e.dy);
	      api.dispatchAction({
	        seriesId: seriesModel.id,
	        type: 'graphRoam',
	        dx: e.dx,
	        dy: e.dy
	      });
	    }).on('zoom', function (e) {
	      roamHelper.updateViewOnZoom(controllerHost, e.scale, e.originX, e.originY);
	      api.dispatchAction({
	        seriesId: seriesModel.id,
	        type: 'graphRoam',
	        zoom: e.scale,
	        originX: e.originX,
	        originY: e.originY
	      });
	
	      this._updateNodeAndLinkScale();
	
	      adjustEdge(seriesModel.getGraph(), getNodeGlobalScale(seriesModel));
	
	      this._lineDraw.updateLayout();
	    }, this);
	  },
	  _updateNodeAndLinkScale: function () {
	    var seriesModel = this._model;
	    var data = seriesModel.getData();
	    var nodeScale = getNodeGlobalScale(seriesModel);
	    var invScale = [nodeScale, nodeScale];
	    data.eachItemGraphicEl(function (el, idx) {
	      el.attr('scale', invScale);
	    });
	  },
	  updateLayout: function (seriesModel) {
	    adjustEdge(seriesModel.getGraph(), getNodeGlobalScale(seriesModel));
	
	    this._symbolDraw.updateLayout();
	
	    this._lineDraw.updateLayout();
	  },
	  remove: function (ecModel, api) {
	    this._symbolDraw && this._symbolDraw.remove();
	    this._lineDraw && this._lineDraw.remove();
	  }
	});
	
	module.exports = _default;

/***/ },
/* 1485 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var curveTool = __webpack_require__(152);
	
	var vec2 = __webpack_require__(41);
	
	var _graphHelper = __webpack_require__(454);
	
	var getSymbolSize = _graphHelper.getSymbolSize;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var v1 = [];
	var v2 = [];
	var v3 = [];
	var quadraticAt = curveTool.quadraticAt;
	var v2DistSquare = vec2.distSquare;
	var mathAbs = Math.abs;
	
	function intersectCurveCircle(curvePoints, center, radius) {
	  var p0 = curvePoints[0];
	  var p1 = curvePoints[1];
	  var p2 = curvePoints[2];
	  var d = Infinity;
	  var t;
	  var radiusSquare = radius * radius;
	  var interval = 0.1;
	
	  for (var _t = 0.1; _t <= 0.9; _t += 0.1) {
	    v1[0] = quadraticAt(p0[0], p1[0], p2[0], _t);
	    v1[1] = quadraticAt(p0[1], p1[1], p2[1], _t);
	    var diff = mathAbs(v2DistSquare(v1, center) - radiusSquare);
	
	    if (diff < d) {
	      d = diff;
	      t = _t;
	    }
	  } // Assume the segment is monotone，Find root through Bisection method
	  // At most 32 iteration
	
	
	  for (var i = 0; i < 32; i++) {
	    // var prev = t - interval;
	    var next = t + interval; // v1[0] = quadraticAt(p0[0], p1[0], p2[0], prev);
	    // v1[1] = quadraticAt(p0[1], p1[1], p2[1], prev);
	
	    v2[0] = quadraticAt(p0[0], p1[0], p2[0], t);
	    v2[1] = quadraticAt(p0[1], p1[1], p2[1], t);
	    v3[0] = quadraticAt(p0[0], p1[0], p2[0], next);
	    v3[1] = quadraticAt(p0[1], p1[1], p2[1], next);
	    var diff = v2DistSquare(v2, center) - radiusSquare;
	
	    if (mathAbs(diff) < 1e-2) {
	      break;
	    } // var prevDiff = v2DistSquare(v1, center) - radiusSquare;
	
	
	    var nextDiff = v2DistSquare(v3, center) - radiusSquare;
	    interval /= 2;
	
	    if (diff < 0) {
	      if (nextDiff >= 0) {
	        t = t + interval;
	      } else {
	        t = t - interval;
	      }
	    } else {
	      if (nextDiff >= 0) {
	        t = t - interval;
	      } else {
	        t = t + interval;
	      }
	    }
	  }
	
	  return t;
	} // Adjust edge to avoid
	
	
	function _default(graph, scale) {
	  var tmp0 = [];
	  var quadraticSubdivide = curveTool.quadraticSubdivide;
	  var pts = [[], [], []];
	  var pts2 = [[], []];
	  var v = [];
	  scale /= 2;
	  graph.eachEdge(function (edge, idx) {
	    var linePoints = edge.getLayout();
	    var fromSymbol = edge.getVisual('fromSymbol');
	    var toSymbol = edge.getVisual('toSymbol');
	
	    if (!linePoints.__original) {
	      linePoints.__original = [vec2.clone(linePoints[0]), vec2.clone(linePoints[1])];
	
	      if (linePoints[2]) {
	        linePoints.__original.push(vec2.clone(linePoints[2]));
	      }
	    }
	
	    var originalPoints = linePoints.__original; // Quadratic curve
	
	    if (linePoints[2] != null) {
	      vec2.copy(pts[0], originalPoints[0]);
	      vec2.copy(pts[1], originalPoints[2]);
	      vec2.copy(pts[2], originalPoints[1]);
	
	      if (fromSymbol && fromSymbol !== 'none') {
	        var symbolSize = getSymbolSize(edge.node1);
	        var t = intersectCurveCircle(pts, originalPoints[0], symbolSize * scale); // Subdivide and get the second
	
	        quadraticSubdivide(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
	        pts[0][0] = tmp0[3];
	        pts[1][0] = tmp0[4];
	        quadraticSubdivide(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
	        pts[0][1] = tmp0[3];
	        pts[1][1] = tmp0[4];
	      }
	
	      if (toSymbol && toSymbol !== 'none') {
	        var symbolSize = getSymbolSize(edge.node2);
	        var t = intersectCurveCircle(pts, originalPoints[1], symbolSize * scale); // Subdivide and get the first
	
	        quadraticSubdivide(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
	        pts[1][0] = tmp0[1];
	        pts[2][0] = tmp0[2];
	        quadraticSubdivide(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
	        pts[1][1] = tmp0[1];
	        pts[2][1] = tmp0[2];
	      } // Copy back to layout
	
	
	      vec2.copy(linePoints[0], pts[0]);
	      vec2.copy(linePoints[1], pts[2]);
	      vec2.copy(linePoints[2], pts[1]);
	    } // Line
	    else {
	        vec2.copy(pts2[0], originalPoints[0]);
	        vec2.copy(pts2[1], originalPoints[1]);
	        vec2.sub(v, pts2[1], pts2[0]);
	        vec2.normalize(v, v);
	
	        if (fromSymbol && fromSymbol !== 'none') {
	          var symbolSize = getSymbolSize(edge.node1);
	          vec2.scaleAndAdd(pts2[0], pts2[0], v, symbolSize * scale);
	        }
	
	        if (toSymbol && toSymbol !== 'none') {
	          var symbolSize = getSymbolSize(edge.node2);
	          vec2.scaleAndAdd(pts2[1], pts2[1], v, -symbolSize * scale);
	        }
	
	        vec2.copy(linePoints[0], pts2[0]);
	        vec2.copy(linePoints[1], pts2[1]);
	      }
	  });
	}
	
	module.exports = _default;

/***/ },
/* 1486 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  var legendModels = ecModel.findComponents({
	    mainType: 'legend'
	  });
	
	  if (!legendModels || !legendModels.length) {
	    return;
	  }
	
	  ecModel.eachSeriesByType('graph', function (graphSeries) {
	    var categoriesData = graphSeries.getCategoriesData();
	    var graph = graphSeries.getGraph();
	    var data = graph.data;
	    var categoryNames = categoriesData.mapArray(categoriesData.getName);
	    data.filterSelf(function (idx) {
	      var model = data.getItemModel(idx);
	      var category = model.getShallow('category');
	
	      if (category != null) {
	        if (typeof category === 'number') {
	          category = categoryNames[category];
	        } // If in any legend component the status is not selected.
	
	
	        for (var i = 0; i < legendModels.length; i++) {
	          if (!legendModels[i].isSelected(category)) {
	            return false;
	          }
	        }
	      }
	
	      return true;
	    });
	  }, this);
	}
	
	module.exports = _default;

/***/ },
/* 1487 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  var paletteScope = {};
	  ecModel.eachSeriesByType('graph', function (seriesModel) {
	    var categoriesData = seriesModel.getCategoriesData();
	    var data = seriesModel.getData();
	    var categoryNameIdxMap = {};
	    categoriesData.each(function (idx) {
	      var name = categoriesData.getName(idx); // Add prefix to avoid conflict with Object.prototype.
	
	      categoryNameIdxMap['ec-' + name] = idx;
	      var itemModel = categoriesData.getItemModel(idx);
	      var color = itemModel.get('itemStyle.color') || seriesModel.getColorFromPalette(name, paletteScope);
	      categoriesData.setItemVisual(idx, 'color', color);
	      var itemStyleList = ['opacity', 'symbol', 'symbolSize', 'symbolKeepAspect'];
	
	      for (var i = 0; i < itemStyleList.length; i++) {
	        var itemStyle = itemModel.getShallow(itemStyleList[i], true);
	
	        if (itemStyle != null) {
	          categoriesData.setItemVisual(idx, itemStyleList[i], itemStyle);
	        }
	      }
	    }); // Assign category color to visual
	
	    if (categoriesData.count()) {
	      data.each(function (idx) {
	        var model = data.getItemModel(idx);
	        var category = model.getShallow('category');
	
	        if (category != null) {
	          if (typeof category === 'string') {
	            category = categoryNameIdxMap['ec-' + category];
	          }
	
	          var itemStyleList = ['color', 'opacity', 'symbol', 'symbolSize', 'symbolKeepAspect'];
	
	          for (var i = 0; i < itemStyleList.length; i++) {
	            if (data.getItemVisual(idx, itemStyleList[i], true) == null) {
	              data.setItemVisual(idx, itemStyleList[i], categoriesData.getItemVisual(category, itemStyleList[i]));
	            }
	          }
	        }
	      });
	    }
	  });
	}
	
	module.exports = _default;

/***/ },
/* 1488 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _circularLayoutHelper = __webpack_require__(698);
	
	var circularLayout = _circularLayoutHelper.circularLayout;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  ecModel.eachSeriesByType('graph', function (seriesModel) {
	    if (seriesModel.get('layout') === 'circular') {
	      circularLayout(seriesModel, 'symbolSize');
	    }
	  });
	}
	
	module.exports = _default;

/***/ },
/* 1489 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var View = __webpack_require__(469);
	
	var _layout = __webpack_require__(36);
	
	var getLayoutRect = _layout.getLayoutRect;
	
	var bbox = __webpack_require__(292);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// FIXME Where to create the simple view coordinate system
	function getViewRect(seriesModel, api, aspect) {
	  var option = seriesModel.getBoxLayoutParams();
	  option.aspect = aspect;
	  return getLayoutRect(option, {
	    width: api.getWidth(),
	    height: api.getHeight()
	  });
	}
	
	function _default(ecModel, api) {
	  var viewList = [];
	  ecModel.eachSeriesByType('graph', function (seriesModel) {
	    var coordSysType = seriesModel.get('coordinateSystem');
	
	    if (!coordSysType || coordSysType === 'view') {
	      var data = seriesModel.getData();
	      var positions = data.mapArray(function (idx) {
	        var itemModel = data.getItemModel(idx);
	        return [+itemModel.get('x'), +itemModel.get('y')];
	      });
	      var min = [];
	      var max = [];
	      bbox.fromPoints(positions, min, max); // If width or height is 0
	
	      if (max[0] - min[0] === 0) {
	        max[0] += 1;
	        min[0] -= 1;
	      }
	
	      if (max[1] - min[1] === 0) {
	        max[1] += 1;
	        min[1] -= 1;
	      }
	
	      var aspect = (max[0] - min[0]) / (max[1] - min[1]); // FIXME If get view rect after data processed?
	
	      var viewRect = getViewRect(seriesModel, api, aspect); // Position may be NaN, use view rect instead
	
	      if (isNaN(aspect)) {
	        min = [viewRect.x, viewRect.y];
	        max = [viewRect.x + viewRect.width, viewRect.y + viewRect.height];
	      }
	
	      var bbWidth = max[0] - min[0];
	      var bbHeight = max[1] - min[1];
	      var viewWidth = viewRect.width;
	      var viewHeight = viewRect.height;
	      var viewCoordSys = seriesModel.coordinateSystem = new View();
	      viewCoordSys.zoomLimit = seriesModel.get('scaleLimit');
	      viewCoordSys.setBoundingRect(min[0], min[1], bbWidth, bbHeight);
	      viewCoordSys.setViewRect(viewRect.x, viewRect.y, viewWidth, viewHeight); // Update roam info
	
	      viewCoordSys.setCenter(seriesModel.get('center'));
	      viewCoordSys.setZoom(seriesModel.get('zoom'));
	      viewList.push(viewCoordSys);
	    }
	  });
	  return viewList;
	}
	
	module.exports = _default;

/***/ },
/* 1490 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function normalize(a) {
	  if (!(a instanceof Array)) {
	    a = [a, a];
	  }
	
	  return a;
	}
	
	function _default(ecModel) {
	  ecModel.eachSeriesByType('graph', function (seriesModel) {
	    var graph = seriesModel.getGraph();
	    var edgeData = seriesModel.getEdgeData();
	    var symbolType = normalize(seriesModel.get('edgeSymbol'));
	    var symbolSize = normalize(seriesModel.get('edgeSymbolSize'));
	    var colorQuery = 'lineStyle.color'.split('.');
	    var opacityQuery = 'lineStyle.opacity'.split('.');
	    edgeData.setVisual('fromSymbol', symbolType && symbolType[0]);
	    edgeData.setVisual('toSymbol', symbolType && symbolType[1]);
	    edgeData.setVisual('fromSymbolSize', symbolSize && symbolSize[0]);
	    edgeData.setVisual('toSymbolSize', symbolSize && symbolSize[1]);
	    edgeData.setVisual('color', seriesModel.get(colorQuery));
	    edgeData.setVisual('opacity', seriesModel.get(opacityQuery));
	    edgeData.each(function (idx) {
	      var itemModel = edgeData.getItemModel(idx);
	      var edge = graph.getEdgeByIndex(idx);
	      var symbolType = normalize(itemModel.getShallow('symbol', true));
	      var symbolSize = normalize(itemModel.getShallow('symbolSize', true)); // Edge visual must after node visual
	
	      var color = itemModel.get(colorQuery);
	      var opacity = itemModel.get(opacityQuery);
	
	      switch (color) {
	        case 'source':
	          color = edge.node1.getVisual('color');
	          break;
	
	        case 'target':
	          color = edge.node2.getVisual('color');
	          break;
	      }
	
	      symbolType[0] && edge.setVisual('fromSymbol', symbolType[0]);
	      symbolType[1] && edge.setVisual('toSymbol', symbolType[1]);
	      symbolSize[0] && edge.setVisual('fromSymbolSize', symbolSize[0]);
	      symbolSize[1] && edge.setVisual('toSymbolSize', symbolSize[1]);
	      edge.setVisual('color', color);
	      edge.setVisual('opacity', opacity);
	    });
	  });
	}
	
	module.exports = _default;

/***/ },
/* 1491 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var vec2 = __webpack_require__(41);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* A third-party license is embeded for some of the code in this file:
	* Some formulas were originally copied from "d3.js" with some
	* modifications made for this project.
	* (See more details in the comment of the method "step" below.)
	* The use of the source code of this file is also subject to the terms
	* and consitions of the license of "d3.js" (BSD-3Clause, see
	* </licenses/LICENSE-d3>).
	*/
	var scaleAndAdd = vec2.scaleAndAdd; // function adjacentNode(n, e) {
	//     return e.n1 === n ? e.n2 : e.n1;
	// }
	
	function forceLayout(nodes, edges, opts) {
	  var rect = opts.rect;
	  var width = rect.width;
	  var height = rect.height;
	  var center = [rect.x + width / 2, rect.y + height / 2]; // var scale = opts.scale || 1;
	
	  var gravity = opts.gravity == null ? 0.1 : opts.gravity; // for (var i = 0; i < edges.length; i++) {
	  //     var e = edges[i];
	  //     var n1 = e.n1;
	  //     var n2 = e.n2;
	  //     n1.edges = n1.edges || [];
	  //     n2.edges = n2.edges || [];
	  //     n1.edges.push(e);
	  //     n2.edges.push(e);
	  // }
	  // Init position
	
	  for (var i = 0; i < nodes.length; i++) {
	    var n = nodes[i];
	
	    if (!n.p) {
	      n.p = vec2.create(width * (Math.random() - 0.5) + center[0], height * (Math.random() - 0.5) + center[1]);
	    }
	
	    n.pp = vec2.clone(n.p);
	    n.edges = null;
	  } // Formula in 'Graph Drawing by Force-directed Placement'
	  // var k = scale * Math.sqrt(width * height / nodes.length);
	  // var k2 = k * k;
	
	
	  var initialFriction = opts.friction == null ? 0.6 : opts.friction;
	  var friction = initialFriction;
	  return {
	    warmUp: function () {
	      friction = initialFriction * 0.8;
	    },
	    setFixed: function (idx) {
	      nodes[idx].fixed = true;
	    },
	    setUnfixed: function (idx) {
	      nodes[idx].fixed = false;
	    },
	
	    /**
	     * Some formulas were originally copied from "d3.js"
	     * https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/layout/force.js
	     * with some modifications made for this project.
	     * See the license statement at the head of this file.
	     */
	    step: function (cb) {
	      var v12 = [];
	      var nLen = nodes.length;
	
	      for (var i = 0; i < edges.length; i++) {
	        var e = edges[i];
	
	        if (e.ignoreForceLayout) {
	          continue;
	        }
	
	        var n1 = e.n1;
	        var n2 = e.n2;
	        vec2.sub(v12, n2.p, n1.p);
	        var d = vec2.len(v12) - e.d;
	        var w = n2.w / (n1.w + n2.w);
	
	        if (isNaN(w)) {
	          w = 0;
	        }
	
	        vec2.normalize(v12, v12);
	        !n1.fixed && scaleAndAdd(n1.p, n1.p, v12, w * d * friction);
	        !n2.fixed && scaleAndAdd(n2.p, n2.p, v12, -(1 - w) * d * friction);
	      } // Gravity
	
	
	      for (var i = 0; i < nLen; i++) {
	        var n = nodes[i];
	
	        if (!n.fixed) {
	          vec2.sub(v12, center, n.p); // var d = vec2.len(v12);
	          // vec2.scale(v12, v12, 1 / d);
	          // var gravityFactor = gravity;
	
	          scaleAndAdd(n.p, n.p, v12, gravity * friction);
	        }
	      } // Repulsive
	      // PENDING
	
	
	      for (var i = 0; i < nLen; i++) {
	        var n1 = nodes[i];
	
	        for (var j = i + 1; j < nLen; j++) {
	          var n2 = nodes[j];
	          vec2.sub(v12, n2.p, n1.p);
	          var d = vec2.len(v12);
	
	          if (d === 0) {
	            // Random repulse
	            vec2.set(v12, Math.random() - 0.5, Math.random() - 0.5);
	            d = 1;
	          }
	
	          var repFact = (n1.rep + n2.rep) / d / d;
	          !n1.fixed && scaleAndAdd(n1.pp, n1.pp, v12, repFact);
	          !n2.fixed && scaleAndAdd(n2.pp, n2.pp, v12, -repFact);
	        }
	      }
	
	      var v = [];
	
	      for (var i = 0; i < nLen; i++) {
	        var n = nodes[i];
	
	        if (!n.fixed) {
	          vec2.sub(v, n.p, n.pp);
	          scaleAndAdd(n.p, n.p, v, friction);
	          vec2.copy(n.pp, n.p);
	        }
	      }
	
	      friction = friction * 0.992;
	      cb && cb(nodes, edges, friction < 0.01);
	    }
	  };
	}
	
	exports.forceLayout = forceLayout;

/***/ },
/* 1492 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _forceHelper = __webpack_require__(1491);
	
	var forceLayout = _forceHelper.forceLayout;
	
	var _simpleLayoutHelper = __webpack_require__(699);
	
	var simpleLayout = _simpleLayoutHelper.simpleLayout;
	
	var _circularLayoutHelper = __webpack_require__(698);
	
	var circularLayout = _circularLayoutHelper.circularLayout;
	
	var _number = __webpack_require__(20);
	
	var linearMap = _number.linearMap;
	
	var vec2 = __webpack_require__(41);
	
	var zrUtil = __webpack_require__(3);
	
	var _multipleGraphEdgeHelper = __webpack_require__(331);
	
	var getCurvenessForEdge = _multipleGraphEdgeHelper.getCurvenessForEdge;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  ecModel.eachSeriesByType('graph', function (graphSeries) {
	    var coordSys = graphSeries.coordinateSystem;
	
	    if (coordSys && coordSys.type !== 'view') {
	      return;
	    }
	
	    if (graphSeries.get('layout') === 'force') {
	      var preservedPoints = graphSeries.preservedPoints || {};
	      var graph = graphSeries.getGraph();
	      var nodeData = graph.data;
	      var edgeData = graph.edgeData;
	      var forceModel = graphSeries.getModel('force');
	      var initLayout = forceModel.get('initLayout');
	
	      if (graphSeries.preservedPoints) {
	        nodeData.each(function (idx) {
	          var id = nodeData.getId(idx);
	          nodeData.setItemLayout(idx, preservedPoints[id] || [NaN, NaN]);
	        });
	      } else if (!initLayout || initLayout === 'none') {
	        simpleLayout(graphSeries);
	      } else if (initLayout === 'circular') {
	        circularLayout(graphSeries, 'value');
	      }
	
	      var nodeDataExtent = nodeData.getDataExtent('value');
	      var edgeDataExtent = edgeData.getDataExtent('value'); // var edgeDataExtent = edgeData.getDataExtent('value');
	
	      var repulsion = forceModel.get('repulsion');
	      var edgeLength = forceModel.get('edgeLength');
	
	      if (!zrUtil.isArray(repulsion)) {
	        repulsion = [repulsion, repulsion];
	      }
	
	      if (!zrUtil.isArray(edgeLength)) {
	        edgeLength = [edgeLength, edgeLength];
	      } // Larger value has smaller length
	
	
	      edgeLength = [edgeLength[1], edgeLength[0]];
	      var nodes = nodeData.mapArray('value', function (value, idx) {
	        var point = nodeData.getItemLayout(idx);
	        var rep = linearMap(value, nodeDataExtent, repulsion);
	
	        if (isNaN(rep)) {
	          rep = (repulsion[0] + repulsion[1]) / 2;
	        }
	
	        return {
	          w: rep,
	          rep: rep,
	          fixed: nodeData.getItemModel(idx).get('fixed'),
	          p: !point || isNaN(point[0]) || isNaN(point[1]) ? null : point
	        };
	      });
	      var edges = edgeData.mapArray('value', function (value, idx) {
	        var edge = graph.getEdgeByIndex(idx);
	        var d = linearMap(value, edgeDataExtent, edgeLength);
	
	        if (isNaN(d)) {
	          d = (edgeLength[0] + edgeLength[1]) / 2;
	        }
	
	        var edgeModel = edge.getModel();
	        var curveness = zrUtil.retrieve3(edgeModel.get('lineStyle.curveness'), -getCurvenessForEdge(edge, graphSeries, idx, true), 0);
	        return {
	          n1: nodes[edge.node1.dataIndex],
	          n2: nodes[edge.node2.dataIndex],
	          d: d,
	          curveness: curveness,
	          ignoreForceLayout: edgeModel.get('ignoreForceLayout')
	        };
	      });
	      var coordSys = graphSeries.coordinateSystem;
	      var rect = coordSys.getBoundingRect();
	      var forceInstance = forceLayout(nodes, edges, {
	        rect: rect,
	        gravity: forceModel.get('gravity'),
	        friction: forceModel.get('friction')
	      });
	      var oldStep = forceInstance.step;
	
	      forceInstance.step = function (cb) {
	        for (var i = 0, l = nodes.length; i < l; i++) {
	          if (nodes[i].fixed) {
	            // Write back to layout instance
	            vec2.copy(nodes[i].p, graph.getNodeByIndex(i).getLayout());
	          }
	        }
	
	        oldStep(function (nodes, edges, stopped) {
	          for (var i = 0, l = nodes.length; i < l; i++) {
	            if (!nodes[i].fixed) {
	              graph.getNodeByIndex(i).setLayout(nodes[i].p);
	            }
	
	            preservedPoints[nodeData.getId(i)] = nodes[i].p;
	          }
	
	          for (var i = 0, l = edges.length; i < l; i++) {
	            var e = edges[i];
	            var edge = graph.getEdgeByIndex(i);
	            var p1 = e.n1.p;
	            var p2 = e.n2.p;
	            var points = edge.getLayout();
	            points = points ? points.slice() : [];
	            points[0] = points[0] || [];
	            points[1] = points[1] || [];
	            vec2.copy(points[0], p1);
	            vec2.copy(points[1], p2);
	
	            if (+e.curveness) {
	              points[2] = [(p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * e.curveness, (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * e.curveness];
	            }
	
	            edge.setLayout(points);
	          } // Update layout
	
	
	          cb && cb(stopped);
	        });
	      };
	
	      graphSeries.forceLayout = forceInstance;
	      graphSeries.preservedPoints = preservedPoints; // Step to get the layout
	
	      forceInstance.step();
	    } else {
	      // Remove prev injected forceLayout instance
	      graphSeries.forceLayout = null;
	    }
	  });
	}
	
	module.exports = _default;

/***/ },
/* 1493 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var _roamHelper = __webpack_require__(453);
	
	var updateCenterAndZoom = _roamHelper.updateCenterAndZoom;
	
	__webpack_require__(703);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var actionInfo = {
	  type: 'graphRoam',
	  event: 'graphRoam',
	  update: 'none'
	};
	/**
	 * @payload
	 * @property {string} name Series name
	 * @property {number} [dx]
	 * @property {number} [dy]
	 * @property {number} [zoom]
	 * @property {number} [originX]
	 * @property {number} [originY]
	 */
	
	echarts.registerAction(actionInfo, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    query: payload
	  }, function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	    var res = updateCenterAndZoom(coordSys, payload);
	    seriesModel.setCenter && seriesModel.setCenter(res.center);
	    seriesModel.setZoom && seriesModel.setZoom(res.zoom);
	  });
	});

/***/ },
/* 1494 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(3);
	
	var each = _util.each;
	
	var _simpleLayoutHelper = __webpack_require__(699);
	
	var simpleLayout = _simpleLayoutHelper.simpleLayout;
	var simpleLayoutEdge = _simpleLayoutHelper.simpleLayoutEdge;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel, api) {
	  ecModel.eachSeriesByType('graph', function (seriesModel) {
	    var layout = seriesModel.get('layout');
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys && coordSys.type !== 'view') {
	      var data = seriesModel.getData();
	      var dimensions = [];
	      each(coordSys.dimensions, function (coordDim) {
	        dimensions = dimensions.concat(data.mapDimension(coordDim, true));
	      });
	
	      for (var dataIndex = 0; dataIndex < data.count(); dataIndex++) {
	        var value = [];
	        var hasValue = false;
	
	        for (var i = 0; i < dimensions.length; i++) {
	          var val = data.get(dimensions[i], dataIndex);
	
	          if (!isNaN(val)) {
	            hasValue = true;
	          }
	
	          value.push(val);
	        }
	
	        if (hasValue) {
	          data.setItemLayout(dataIndex, coordSys.dataToPoint(value));
	        } else {
	          // Also {Array.<number>}, not undefined to avoid if...else... statement
	          data.setItemLayout(dataIndex, [NaN, NaN]);
	        }
	      }
	
	      simpleLayoutEdge(data.graph, seriesModel);
	    } else if (!layout || layout === 'none') {
	      simpleLayout(seriesModel);
	    }
	  });
	}
	
	module.exports = _default;

/***/ },
/* 1495 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(1497);
	
	__webpack_require__(1498);

/***/ },
/* 1496 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Uint8ClampedArray */
	var GRADIENT_LEVELS = 256;
	/**
	 * Heatmap Chart
	 *
	 * @class
	 */
	
	function Heatmap() {
	  var canvas = zrUtil.createCanvas();
	  this.canvas = canvas;
	  this.blurSize = 30;
	  this.pointSize = 20;
	  this.maxOpacity = 1;
	  this.minOpacity = 0;
	  this._gradientPixels = {};
	}
	
	Heatmap.prototype = {
	  /**
	   * Renders Heatmap and returns the rendered canvas
	   * @param {Array} data array of data, each has x, y, value
	   * @param {number} width canvas width
	   * @param {number} height canvas height
	   */
	  update: function (data, width, height, normalize, colorFunc, isInRange) {
	    var brush = this._getBrush();
	
	    var gradientInRange = this._getGradient(data, colorFunc, 'inRange');
	
	    var gradientOutOfRange = this._getGradient(data, colorFunc, 'outOfRange');
	
	    var r = this.pointSize + this.blurSize;
	    var canvas = this.canvas;
	    var ctx = canvas.getContext('2d');
	    var len = data.length;
	    canvas.width = width;
	    canvas.height = height;
	
	    for (var i = 0; i < len; ++i) {
	      var p = data[i];
	      var x = p[0];
	      var y = p[1];
	      var value = p[2]; // calculate alpha using value
	
	      var alpha = normalize(value); // draw with the circle brush with alpha
	
	      ctx.globalAlpha = alpha;
	      ctx.drawImage(brush, x - r, y - r);
	    }
	
	    if (!canvas.width || !canvas.height) {
	      // Avoid "Uncaught DOMException: Failed to execute 'getImageData' on
	      // 'CanvasRenderingContext2D': The source height is 0."
	      return canvas;
	    } // colorize the canvas using alpha value and set with gradient
	
	
	    var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
	    var pixels = imageData.data;
	    var offset = 0;
	    var pixelLen = pixels.length;
	    var minOpacity = this.minOpacity;
	    var maxOpacity = this.maxOpacity;
	    var diffOpacity = maxOpacity - minOpacity;
	
	    while (offset < pixelLen) {
	      var alpha = pixels[offset + 3] / 256;
	      var gradientOffset = Math.floor(alpha * (GRADIENT_LEVELS - 1)) * 4; // Simple optimize to ignore the empty data
	
	      if (alpha > 0) {
	        var gradient = isInRange(alpha) ? gradientInRange : gradientOutOfRange; // Any alpha > 0 will be mapped to [minOpacity, maxOpacity]
	
	        alpha > 0 && (alpha = alpha * diffOpacity + minOpacity);
	        pixels[offset++] = gradient[gradientOffset];
	        pixels[offset++] = gradient[gradientOffset + 1];
	        pixels[offset++] = gradient[gradientOffset + 2];
	        pixels[offset++] = gradient[gradientOffset + 3] * alpha * 256;
	      } else {
	        offset += 4;
	      }
	    }
	
	    ctx.putImageData(imageData, 0, 0);
	    return canvas;
	  },
	
	  /**
	   * get canvas of a black circle brush used for canvas to draw later
	   * @private
	   * @returns {Object} circle brush canvas
	   */
	  _getBrush: function () {
	    var brushCanvas = this._brushCanvas || (this._brushCanvas = zrUtil.createCanvas()); // set brush size
	
	    var r = this.pointSize + this.blurSize;
	    var d = r * 2;
	    brushCanvas.width = d;
	    brushCanvas.height = d;
	    var ctx = brushCanvas.getContext('2d');
	    ctx.clearRect(0, 0, d, d); // in order to render shadow without the distinct circle,
	    // draw the distinct circle in an invisible place,
	    // and use shadowOffset to draw shadow in the center of the canvas
	
	    ctx.shadowOffsetX = d;
	    ctx.shadowBlur = this.blurSize; // draw the shadow in black, and use alpha and shadow blur to generate
	    // color in color map
	
	    ctx.shadowColor = '#000'; // draw circle in the left to the canvas
	
	    ctx.beginPath();
	    ctx.arc(-r, r, this.pointSize, 0, Math.PI * 2, true);
	    ctx.closePath();
	    ctx.fill();
	    return brushCanvas;
	  },
	
	  /**
	   * get gradient color map
	   * @private
	   */
	  _getGradient: function (data, colorFunc, state) {
	    var gradientPixels = this._gradientPixels;
	    var pixelsSingleState = gradientPixels[state] || (gradientPixels[state] = new Uint8ClampedArray(256 * 4));
	    var color = [0, 0, 0, 0];
	    var off = 0;
	
	    for (var i = 0; i < 256; i++) {
	      colorFunc[state](i / 255, true, color);
	      pixelsSingleState[off++] = color[0];
	      pixelsSingleState[off++] = color[1];
	      pixelsSingleState[off++] = color[2];
	      pixelsSingleState[off++] = color[3];
	    }
	
	    return pixelsSingleState;
	  }
	};
	var _default = Heatmap;
	module.exports = _default;

/***/ },
/* 1497 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SeriesModel = __webpack_require__(58);
	
	var createListFromArray = __webpack_require__(122);
	
	var CoordinateSystem = __webpack_require__(92);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.heatmap',
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(this.getSource(), this, {
	      generateCoord: 'value'
	    });
	  },
	  preventIncremental: function () {
	    var coordSysCreator = CoordinateSystem.get(this.get('coordinateSystem'));
	
	    if (coordSysCreator && coordSysCreator.dimensions) {
	      return coordSysCreator.dimensions[0] === 'lng' && coordSysCreator.dimensions[1] === 'lat';
	    }
	  },
	  defaultOption: {
	    // Cartesian2D or geo
	    coordinateSystem: 'cartesian2d',
	    zlevel: 0,
	    z: 2,
	    // Cartesian coordinate system
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // Geo coordinate system
	    geoIndex: 0,
	    blurSize: 30,
	    pointSize: 20,
	    maxOpacity: 1,
	    minOpacity: 0
	  }
	});
	
	module.exports = _default;

/***/ },
/* 1498 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(13);
	
	var graphic = __webpack_require__(16);
	
	var HeatmapLayer = __webpack_require__(1496);
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function getIsInPiecewiseRange(dataExtent, pieceList, selected) {
	  var dataSpan = dataExtent[1] - dataExtent[0];
	  pieceList = zrUtil.map(pieceList, function (piece) {
	    return {
	      interval: [(piece.interval[0] - dataExtent[0]) / dataSpan, (piece.interval[1] - dataExtent[0]) / dataSpan]
	    };
	  });
	  var len = pieceList.length;
	  var lastIndex = 0;
	  return function (val) {
	    // Try to find in the location of the last found
	    for (var i = lastIndex; i < len; i++) {
	      var interval = pieceList[i].interval;
	
	      if (interval[0] <= val && val <= interval[1]) {
	        lastIndex = i;
	        break;
	      }
	    }
	
	    if (i === len) {
	      // Not found, back interation
	      for (var i = lastIndex - 1; i >= 0; i--) {
	        var interval = pieceList[i].interval;
	
	        if (interval[0] <= val && val <= interval[1]) {
	          lastIndex = i;
	          break;
	        }
	      }
	    }
	
	    return i >= 0 && i < len && selected[i];
	  };
	}
	
	function getIsInContinuousRange(dataExtent, range) {
	  var dataSpan = dataExtent[1] - dataExtent[0];
	  range = [(range[0] - dataExtent[0]) / dataSpan, (range[1] - dataExtent[0]) / dataSpan];
	  return function (val) {
	    return val >= range[0] && val <= range[1];
	  };
	}
	
	function isGeoCoordSys(coordSys) {
	  var dimensions = coordSys.dimensions; // Not use coorSys.type === 'geo' because coordSys maybe extended
	
	  return dimensions[0] === 'lng' && dimensions[1] === 'lat';
	}
	
	var _default = echarts.extendChartView({
	  type: 'heatmap',
	  render: function (seriesModel, ecModel, api) {
	    var visualMapOfThisSeries;
	    ecModel.eachComponent('visualMap', function (visualMap) {
	      visualMap.eachTargetSeries(function (targetSeries) {
	        if (targetSeries === seriesModel) {
	          visualMapOfThisSeries = visualMap;
	        }
	      });
	    });
	    this.group.removeAll();
	    this._incrementalDisplayable = null;
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys.type === 'cartesian2d' || coordSys.type === 'calendar') {
	      this._renderOnCartesianAndCalendar(seriesModel, api, 0, seriesModel.getData().count());
	    } else if (isGeoCoordSys(coordSys)) {
	      this._renderOnGeo(coordSys, seriesModel, visualMapOfThisSeries, api);
	    }
	  },
	  incrementalPrepareRender: function (seriesModel, ecModel, api) {
	    this.group.removeAll();
	  },
	  incrementalRender: function (params, seriesModel, ecModel, api) {
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys) {
	      this._renderOnCartesianAndCalendar(seriesModel, api, params.start, params.end, true);
	    }
	  },
	  _renderOnCartesianAndCalendar: function (seriesModel, api, start, end, incremental) {
	    var coordSys = seriesModel.coordinateSystem;
	    var width;
	    var height;
	
	    if (coordSys.type === 'cartesian2d') {
	      var xAxis = coordSys.getAxis('x');
	      var yAxis = coordSys.getAxis('y');
	      width = xAxis.getBandWidth();
	      height = yAxis.getBandWidth();
	    }
	
	    var group = this.group;
	    var data = seriesModel.getData();
	    var itemStyleQuery = 'itemStyle';
	    var hoverItemStyleQuery = 'emphasis.itemStyle';
	    var labelQuery = 'label';
	    var hoverLabelQuery = 'emphasis.label';
	    var style = seriesModel.getModel(itemStyleQuery).getItemStyle(['color']);
	    var hoverStl = seriesModel.getModel(hoverItemStyleQuery).getItemStyle();
	    var labelModel = seriesModel.getModel(labelQuery);
	    var hoverLabelModel = seriesModel.getModel(hoverLabelQuery);
	    var coordSysType = coordSys.type;
	    var dataDims = coordSysType === 'cartesian2d' ? [data.mapDimension('x'), data.mapDimension('y'), data.mapDimension('value')] : [data.mapDimension('time'), data.mapDimension('value')];
	
	    for (var idx = start; idx < end; idx++) {
	      var rect;
	
	      if (coordSysType === 'cartesian2d') {
	        // Ignore empty data
	        if (isNaN(data.get(dataDims[2], idx))) {
	          continue;
	        }
	
	        var point = coordSys.dataToPoint([data.get(dataDims[0], idx), data.get(dataDims[1], idx)]);
	        rect = new graphic.Rect({
	          shape: {
	            x: Math.floor(Math.round(point[0]) - width / 2),
	            y: Math.floor(Math.round(point[1]) - height / 2),
	            width: Math.ceil(width),
	            height: Math.ceil(height)
	          },
	          style: {
	            fill: data.getItemVisual(idx, 'color'),
	            opacity: data.getItemVisual(idx, 'opacity')
	          }
	        });
	      } else {
	        // Ignore empty data
	        if (isNaN(data.get(dataDims[1], idx))) {
	          continue;
	        }
	
	        rect = new graphic.Rect({
	          z2: 1,
	          shape: coordSys.dataToRect([data.get(dataDims[0], idx)]).contentShape,
	          style: {
	            fill: data.getItemVisual(idx, 'color'),
	            opacity: data.getItemVisual(idx, 'opacity')
	          }
	        });
	      }
	
	      var itemModel = data.getItemModel(idx); // Optimization for large datset
	
	      if (data.hasItemOption) {
	        style = itemModel.getModel(itemStyleQuery).getItemStyle(['color']);
	        hoverStl = itemModel.getModel(hoverItemStyleQuery).getItemStyle();
	        labelModel = itemModel.getModel(labelQuery);
	        hoverLabelModel = itemModel.getModel(hoverLabelQuery);
	      }
	
	      var rawValue = seriesModel.getRawValue(idx);
	      var defaultText = '-';
	
	      if (rawValue && rawValue[2] != null) {
	        defaultText = rawValue[2];
	      }
	
	      graphic.setLabelStyle(style, hoverStl, labelModel, hoverLabelModel, {
	        labelFetcher: seriesModel,
	        labelDataIndex: idx,
	        defaultText: defaultText,
	        isRectText: true
	      });
	      rect.setStyle(style);
	      graphic.setHoverStyle(rect, data.hasItemOption ? hoverStl : zrUtil.extend({}, hoverStl));
	      rect.incremental = incremental; // PENDING
	
	      if (incremental) {
	        // Rect must use hover layer if it's incremental.
	        rect.useHoverLayer = true;
	      }
	
	      group.add(rect);
	      data.setItemGraphicEl(idx, rect);
	    }
	  },
	  _renderOnGeo: function (geo, seriesModel, visualMapModel, api) {
	    var inRangeVisuals = visualMapModel.targetVisuals.inRange;
	    var outOfRangeVisuals = visualMapModel.targetVisuals.outOfRange; // if (!visualMapping) {
	    //     throw new Error('Data range must have color visuals');
	    // }
	
	    var data = seriesModel.getData();
	    var hmLayer = this._hmLayer || this._hmLayer || new HeatmapLayer();
	    hmLayer.blurSize = seriesModel.get('blurSize');
	    hmLayer.pointSize = seriesModel.get('pointSize');
	    hmLayer.minOpacity = seriesModel.get('minOpacity');
	    hmLayer.maxOpacity = seriesModel.get('maxOpacity');
	    var rect = geo.getViewRect().clone();
	    var roamTransform = geo.getRoamTransform();
	    rect.applyTransform(roamTransform); // Clamp on viewport
	
	    var x = Math.max(rect.x, 0);
	    var y = Math.max(rect.y, 0);
	    var x2 = Math.min(rect.width + rect.x, api.getWidth());
	    var y2 = Math.min(rect.height + rect.y, api.getHeight());
	    var width = x2 - x;
	    var height = y2 - y;
	    var dims = [data.mapDimension('lng'), data.mapDimension('lat'), data.mapDimension('value')];
	    var points = data.mapArray(dims, function (lng, lat, value) {
	      var pt = geo.dataToPoint([lng, lat]);
	      pt[0] -= x;
	      pt[1] -= y;
	      pt.push(value);
	      return pt;
	    });
	    var dataExtent = visualMapModel.getExtent();
	    var isInRange = visualMapModel.type === 'visualMap.continuous' ? getIsInContinuousRange(dataExtent, visualMapModel.option.range) : getIsInPiecewiseRange(dataExtent, visualMapModel.getPieceList(), visualMapModel.option.selected);
	    hmLayer.update(points, width, height, inRangeVisuals.color.getNormalizer(), {
	      inRange: inRangeVisuals.color.getColorMapper(),
	      outOfRange: outOfRangeVisuals.color.getColorMapper()
	    }, isInRange);
	    var img = new graphic.Image({
	      style: {
	        width: width,
	        height: height,
	        x: x,
	        y: y,
	        image: hmLayer.canvas
	      },
	      silent: true
	    });
	    this.group.add(img);
	  },
	  dispose: function () {}
	});
	
	module.exports = _default;

/***/ },
/* 1499 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Polyline = __webpack_require__(701);
	
	var zrUtil = __webpack_require__(3);
	
	var EffectLine = __webpack_require__(700);
	
	var vec2 = __webpack_require__(41);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Provide effect for line
	 * @module echarts/chart/helper/EffectLine
	 */
	
	/**
	 * @constructor
	 * @extends {module:echarts/chart/helper/EffectLine}
	 * @alias {module:echarts/chart/helper/Polyline}
	 */
	function EffectPolyline(lineData, idx, seriesScope) {
	  EffectLine.call(this, lineData, idx, seriesScope);
	  this._lastFrame = 0;
	  this._lastFramePercent = 0;
	}
	
	var effectPolylineProto = EffectPolyline.prototype; // Overwrite
	
	effectPolylineProto.createLine = function (lineData, idx, seriesScope) {
	  return new Polyline(lineData, idx, seriesScope);
	}; // Overwrite
	
	
	effectPolylineProto.updateAnimationPoints = function (symbol, points) {
	  this._points = points;
	  var accLenArr = [0];
	  var len = 0;
	
	  for (var i = 1; i < points.length; i++) {
	    var p1 = points[i - 1];
	    var p2 = points[i];
	    len += vec2.dist(p1, p2);
	    accLenArr.push(len);
	  }
	
	  if (len === 0) {
	    return;
	  }
	
	  for (var i = 0; i < accLenArr.length; i++) {
	    accLenArr[i] /= len;
	  }
	
	  this._offsets = accLenArr;
	  this._length = len;
	}; // Overwrite
	
	
	effectPolylineProto.getLineLength = function (symbol) {
	  return this._length;
	}; // Overwrite
	
	
	effectPolylineProto.updateSymbolPosition = function (symbol) {
	  var t = symbol.__t;
	  var points = this._points;
	  var offsets = this._offsets;
	  var len = points.length;
	
	  if (!offsets) {
	    // Has length 0
	    return;
	  }
	
	  var lastFrame = this._lastFrame;
	  var frame;
	
	  if (t < this._lastFramePercent) {
	    // Start from the next frame
	    // PENDING start from lastFrame ?
	    var start = Math.min(lastFrame + 1, len - 1);
	
	    for (frame = start; frame >= 0; frame--) {
	      if (offsets[frame] <= t) {
	        break;
	      }
	    } // PENDING really need to do this ?
	
	
	    frame = Math.min(frame, len - 2);
	  } else {
	    for (var frame = lastFrame; frame < len; frame++) {
	      if (offsets[frame] > t) {
	        break;
	      }
	    }
	
	    frame = Math.min(frame - 1, len - 2);
	  }
	
	  vec2.lerp(symbol.position, points[frame], points[frame + 1], (t - offsets[frame]) / (offsets[frame + 1] - offsets[frame]));
	  var tx = points[frame + 1][0] - points[frame][0];
	  var ty = points[frame + 1][1] - points[frame][1];
	  symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2;
	  this._lastFrame = frame;
	  this._lastFramePercent = t;
	  symbol.ignore = false;
	};
	
	zrUtil.inherits(EffectPolyline, EffectLine);
	var _default = EffectPolyline;
	module.exports = _default;

/***/ },
/* 1500 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var _symbol = __webpack_require__(84);
	
	var createSymbol = _symbol.createSymbol;
	
	var _graphic = __webpack_require__(16);
	
	var Group = _graphic.Group;
	
	var _number = __webpack_require__(20);
	
	var parsePercent = _number.parsePercent;
	
	var SymbolClz = __webpack_require__(330);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Symbol with ripple effect
	 * @module echarts/chart/helper/EffectSymbol
	 */
	var EFFECT_RIPPLE_NUMBER = 3;
	
	function normalizeSymbolSize(symbolSize) {
	  if (!zrUtil.isArray(symbolSize)) {
	    symbolSize = [+symbolSize, +symbolSize];
	  }
	
	  return symbolSize;
	}
	
	function updateRipplePath(rippleGroup, effectCfg) {
	  var color = effectCfg.rippleEffectColor || effectCfg.color;
	  rippleGroup.eachChild(function (ripplePath) {
	    ripplePath.attr({
	      z: effectCfg.z,
	      zlevel: effectCfg.zlevel,
	      style: {
	        stroke: effectCfg.brushType === 'stroke' ? color : null,
	        fill: effectCfg.brushType === 'fill' ? color : null
	      }
	    });
	  });
	}
	/**
	 * @constructor
	 * @param {module:echarts/data/List} data
	 * @param {number} idx
	 * @extends {module:zrender/graphic/Group}
	 */
	
	
	function EffectSymbol(data, idx) {
	  Group.call(this);
	  var symbol = new SymbolClz(data, idx);
	  var rippleGroup = new Group();
	  this.add(symbol);
	  this.add(rippleGroup);
	
	  rippleGroup.beforeUpdate = function () {
	    this.attr(symbol.getScale());
	  };
	
	  this.updateData(data, idx);
	}
	
	var effectSymbolProto = EffectSymbol.prototype;
	
	effectSymbolProto.stopEffectAnimation = function () {
	  this.childAt(1).removeAll();
	};
	
	effectSymbolProto.startEffectAnimation = function (effectCfg) {
	  var symbolType = effectCfg.symbolType;
	  var color = effectCfg.color;
	  var rippleGroup = this.childAt(1);
	
	  for (var i = 0; i < EFFECT_RIPPLE_NUMBER; i++) {
	    // If width/height are set too small (e.g., set to 1) on ios10
	    // and macOS Sierra, a circle stroke become a rect, no matter what
	    // the scale is set. So we set width/height as 2. See #4136.
	    var ripplePath = createSymbol(symbolType, -1, -1, 2, 2, color);
	    ripplePath.attr({
	      style: {
	        strokeNoScale: true
	      },
	      z2: 99,
	      silent: true,
	      scale: [0.5, 0.5]
	    });
	    var delay = -i / EFFECT_RIPPLE_NUMBER * effectCfg.period + effectCfg.effectOffset; // TODO Configurable effectCfg.period
	
	    ripplePath.animate('', true).when(effectCfg.period, {
	      scale: [effectCfg.rippleScale / 2, effectCfg.rippleScale / 2]
	    }).delay(delay).start();
	    ripplePath.animateStyle(true).when(effectCfg.period, {
	      opacity: 0
	    }).delay(delay).start();
	    rippleGroup.add(ripplePath);
	  }
	
	  updateRipplePath(rippleGroup, effectCfg);
	};
	/**
	 * Update effect symbol
	 */
	
	
	effectSymbolProto.updateEffectAnimation = function (effectCfg) {
	  var oldEffectCfg = this._effectCfg;
	  var rippleGroup = this.childAt(1); // Must reinitialize effect if following configuration changed
	
	  var DIFFICULT_PROPS = ['symbolType', 'period', 'rippleScale'];
	
	  for (var i = 0; i < DIFFICULT_PROPS.length; i++) {
	    var propName = DIFFICULT_PROPS[i];
	
	    if (oldEffectCfg[propName] !== effectCfg[propName]) {
	      this.stopEffectAnimation();
	      this.startEffectAnimation(effectCfg);
	      return;
	    }
	  }
	
	  updateRipplePath(rippleGroup, effectCfg);
	};
	/**
	 * Highlight symbol
	 */
	
	
	effectSymbolProto.highlight = function () {
	  this.trigger('emphasis');
	};
	/**
	 * Downplay symbol
	 */
	
	
	effectSymbolProto.downplay = function () {
	  this.trigger('normal');
	};
	/**
	 * Update symbol properties
	 * @param  {module:echarts/data/List} data
	 * @param  {number} idx
	 */
	
	
	effectSymbolProto.updateData = function (data, idx) {
	  var seriesModel = data.hostModel;
	  this.childAt(0).updateData(data, idx);
	  var rippleGroup = this.childAt(1);
	  var itemModel = data.getItemModel(idx);
	  var symbolType = data.getItemVisual(idx, 'symbol');
	  var symbolSize = normalizeSymbolSize(data.getItemVisual(idx, 'symbolSize'));
	  var color = data.getItemVisual(idx, 'color');
	  rippleGroup.attr('scale', symbolSize);
	  rippleGroup.traverse(function (ripplePath) {
	    ripplePath.attr({
	      fill: color
	    });
	  });
	  var symbolOffset = itemModel.getShallow('symbolOffset');
	
	  if (symbolOffset) {
	    var pos = rippleGroup.position;
	    pos[0] = parsePercent(symbolOffset[0], symbolSize[0]);
	    pos[1] = parsePercent(symbolOffset[1], symbolSize[1]);
	  }
	
	  var symbolRotate = data.getItemVisual(idx, 'symbolRotate');
	  rippleGroup.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
	  var effectCfg = {};
	  effectCfg.showEffectOn = seriesModel.get('showEffectOn');
	  effectCfg.rippleScale = itemModel.get('rippleEffect.scale');
	  effectCfg.brushType = itemModel.get('rippleEffect.brushType');
	  effectCfg.period = itemModel.get('rippleEffect.period') * 1000;
	  effectCfg.effectOffset = idx / data.count();
	  effectCfg.z = itemModel.getShallow('z') || 0;
	  effectCfg.zlevel = itemModel.getShallow('zlevel') || 0;
	  effectCfg.symbolType = symbolType;
	  effectCfg.color = color;
	  effectCfg.rippleEffectColor = itemModel.get('rippleEffect.color');
	  this.off('mouseover').off('mouseout').off('emphasis').off('normal');
	
	  if (effectCfg.showEffectOn === 'render') {
	    this._effectCfg ? this.updateEffectAnimation(effectCfg) : this.startEffectAnimation(effectCfg);
	    this._effectCfg = effectCfg;
	  } else {
	    // Not keep old effect config
	    this._effectCfg = null;
	    this.stopEffectAnimation();
	    var symbol = this.childAt(0);
	
	    var onEmphasis = function () {
	      symbol.highlight();
	
	      if (effectCfg.showEffectOn !== 'render') {
	        this.startEffectAnimation(effectCfg);
	      }
	    };
	
	    var onNormal = function () {
	      symbol.downplay();
	
	      if (effectCfg.showEffectOn !== 'render') {
	        this.stopEffectAnimation();
	      }
	    };
	
	    this.on('mouseover', onEmphasis, this).on('mouseout', onNormal, this).on('emphasis', onEmphasis, this).on('normal', onNormal, this);
	  }
	
	  this._effectCfg = effectCfg;
	};
	
	effectSymbolProto.fadeOut = function (cb) {
	  this.off('mouseover').off('mouseout').off('emphasis').off('normal');
	  cb && cb();
	};
	
	zrUtil.inherits(EffectSymbol, Group);
	var _default = EffectSymbol;
	module.exports = _default;

/***/ },
/* 1501 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(16);
	
	var IncrementalDisplayable = __webpack_require__(556);
	
	var lineContain = __webpack_require__(1079);
	
	var quadraticContain = __webpack_require__(1081);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// TODO Batch by color
	var LargeLineShape = graphic.extendShape({
	  shape: {
	    polyline: false,
	    curveness: 0,
	    segs: []
	  },
	  buildPath: function (path, shape) {
	    var segs = shape.segs;
	    var curveness = shape.curveness;
	
	    if (shape.polyline) {
	      for (var i = 0; i < segs.length;) {
	        var count = segs[i++];
	
	        if (count > 0) {
	          path.moveTo(segs[i++], segs[i++]);
	
	          for (var k = 1; k < count; k++) {
	            path.lineTo(segs[i++], segs[i++]);
	          }
	        }
	      }
	    } else {
	      for (var i = 0; i < segs.length;) {
	        var x0 = segs[i++];
	        var y0 = segs[i++];
	        var x1 = segs[i++];
	        var y1 = segs[i++];
	        path.moveTo(x0, y0);
	
	        if (curveness > 0) {
	          var x2 = (x0 + x1) / 2 - (y0 - y1) * curveness;
	          var y2 = (y0 + y1) / 2 - (x1 - x0) * curveness;
	          path.quadraticCurveTo(x2, y2, x1, y1);
	        } else {
	          path.lineTo(x1, y1);
	        }
	      }
	    }
	  },
	  findDataIndex: function (x, y) {
	    var shape = this.shape;
	    var segs = shape.segs;
	    var curveness = shape.curveness;
	
	    if (shape.polyline) {
	      var dataIndex = 0;
	
	      for (var i = 0; i < segs.length;) {
	        var count = segs[i++];
	
	        if (count > 0) {
	          var x0 = segs[i++];
	          var y0 = segs[i++];
	
	          for (var k = 1; k < count; k++) {
	            var x1 = segs[i++];
	            var y1 = segs[i++];
	
	            if (lineContain.containStroke(x0, y0, x1, y1)) {
	              return dataIndex;
	            }
	          }
	        }
	
	        dataIndex++;
	      }
	    } else {
	      var dataIndex = 0;
	
	      for (var i = 0; i < segs.length;) {
	        var x0 = segs[i++];
	        var y0 = segs[i++];
	        var x1 = segs[i++];
	        var y1 = segs[i++];
	
	        if (curveness > 0) {
	          var x2 = (x0 + x1) / 2 - (y0 - y1) * curveness;
	          var y2 = (y0 + y1) / 2 - (x1 - x0) * curveness;
	
	          if (quadraticContain.containStroke(x0, y0, x2, y2, x1, y1)) {
	            return dataIndex;
	          }
	        } else {
	          if (lineContain.containStroke(x0, y0, x1, y1)) {
	            return dataIndex;
	          }
	        }
	
	        dataIndex++;
	      }
	    }
	
	    return -1;
	  }
	});
	
	function LargeLineDraw() {
	  this.group = new graphic.Group();
	}
	
	var largeLineProto = LargeLineDraw.prototype;
	
	largeLineProto.isPersistent = function () {
	  return !this._incremental;
	};
	/**
	 * Update symbols draw by new data
	 * @param {module:echarts/data/List} data
	 */
	
	
	largeLineProto.updateData = function (data) {
	  this.group.removeAll();
	  var lineEl = new LargeLineShape({
	    rectHover: true,
	    cursor: 'default'
	  });
	  lineEl.setShape({
	    segs: data.getLayout('linesPoints')
	  });
	
	  this._setCommon(lineEl, data); // Add back
	
	
	  this.group.add(lineEl);
	  this._incremental = null;
	};
	/**
	 * @override
	 */
	
	
	largeLineProto.incrementalPrepareUpdate = function (data) {
	  this.group.removeAll();
	
	  this._clearIncremental();
	
	  if (data.count() > 5e5) {
	    if (!this._incremental) {
	      this._incremental = new IncrementalDisplayable({
	        silent: true
	      });
	    }
	
	    this.group.add(this._incremental);
	  } else {
	    this._incremental = null;
	  }
	};
	/**
	 * @override
	 */
	
	
	largeLineProto.incrementalUpdate = function (taskParams, data) {
	  var lineEl = new LargeLineShape();
	  lineEl.setShape({
	    segs: data.getLayout('linesPoints')
	  });
	
	  this._setCommon(lineEl, data, !!this._incremental);
	
	  if (!this._incremental) {
	    lineEl.rectHover = true;
	    lineEl.cursor = 'default';
	    lineEl.__startIndex = taskParams.start;
	    this.group.add(lineEl);
	  } else {
	    this._incremental.addDisplayable(lineEl, true);
	  }
	};
	/**
	 * @override
	 */
	
	
	largeLineProto.remove = function () {
	  this._clearIncremental();
	
	  this._incremental = null;
	  this.group.removeAll();
	};
	
	largeLineProto._setCommon = function (lineEl, data, isIncremental) {
	  var hostModel = data.hostModel;
	  lineEl.setShape({
	    polyline: hostModel.get('polyline'),
	    curveness: hostModel.get('lineStyle.curveness')
	  });
	  lineEl.useStyle(hostModel.getModel('lineStyle').getLineStyle());
	  lineEl.style.strokeNoScale = true;
	  var visualColor = data.getVisual('color');
	
	  if (visualColor) {
	    lineEl.setStyle('stroke', visualColor);
	  }
	
	  lineEl.setStyle('fill');
	
	  if (!isIncremental) {
	    // Enable tooltip
	    // PENDING May have performance issue when path is extremely large
	    lineEl.seriesIndex = hostModel.seriesIndex;
	    lineEl.on('mousemove', function (e) {
	      lineEl.dataIndex = null;
	      var dataIndex = lineEl.findDataIndex(e.offsetX, e.offsetY);
	
	      if (dataIndex > 0) {
	        // Provide dataIndex for tooltip
	        lineEl.dataIndex = dataIndex + lineEl.__startIndex;
	      }
	    });
	  }
	};
	
	largeLineProto._clearIncremental = function () {
	  var incremental = this._incremental;
	
	  if (incremental) {
	    incremental.clearDisplaybles();
	  }
	};
	
	var _default = LargeLineDraw;
	module.exports = _default;

/***/ },
/* 1502 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(16);
	
	var _symbol = __webpack_require__(84);
	
	var createSymbol = _symbol.createSymbol;
	
	var IncrementalDisplayable = __webpack_require__(556);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Float32Array */
	// TODO Batch by color
	var BOOST_SIZE_THRESHOLD = 4;
	var LargeSymbolPath = graphic.extendShape({
	  shape: {
	    points: null
	  },
	  symbolProxy: null,
	  softClipShape: null,
	  buildPath: function (path, shape) {
	    var points = shape.points;
	    var size = shape.size;
	    var symbolProxy = this.symbolProxy;
	    var symbolProxyShape = symbolProxy.shape;
	    var ctx = path.getContext ? path.getContext() : path;
	    var canBoost = ctx && size[0] < BOOST_SIZE_THRESHOLD; // Do draw in afterBrush.
	
	    if (canBoost) {
	      return;
	    }
	
	    for (var i = 0; i < points.length;) {
	      var x = points[i++];
	      var y = points[i++];
	
	      if (isNaN(x) || isNaN(y)) {
	        continue;
	      }
	
	      if (this.softClipShape && !this.softClipShape.contain(x, y)) {
	        continue;
	      }
	
	      symbolProxyShape.x = x - size[0] / 2;
	      symbolProxyShape.y = y - size[1] / 2;
	      symbolProxyShape.width = size[0];
	      symbolProxyShape.height = size[1];
	      symbolProxy.buildPath(path, symbolProxyShape, true);
	    }
	  },
	  afterBrush: function (ctx) {
	    var shape = this.shape;
	    var points = shape.points;
	    var size = shape.size;
	    var canBoost = size[0] < BOOST_SIZE_THRESHOLD;
	
	    if (!canBoost) {
	      return;
	    }
	
	    this.setTransform(ctx); // PENDING If style or other canvas status changed?
	
	    for (var i = 0; i < points.length;) {
	      var x = points[i++];
	      var y = points[i++];
	
	      if (isNaN(x) || isNaN(y)) {
	        continue;
	      }
	
	      if (this.softClipShape && !this.softClipShape.contain(x, y)) {
	        continue;
	      } // fillRect is faster than building a rect path and draw.
	      // And it support light globalCompositeOperation.
	
	
	      ctx.fillRect(x - size[0] / 2, y - size[1] / 2, size[0], size[1]);
	    }
	
	    this.restoreTransform(ctx);
	  },
	  findDataIndex: function (x, y) {
	    // TODO ???
	    // Consider transform
	    var shape = this.shape;
	    var points = shape.points;
	    var size = shape.size;
	    var w = Math.max(size[0], 4);
	    var h = Math.max(size[1], 4); // Not consider transform
	    // Treat each element as a rect
	    // top down traverse
	
	    for (var idx = points.length / 2 - 1; idx >= 0; idx--) {
	      var i = idx * 2;
	      var x0 = points[i] - w / 2;
	      var y0 = points[i + 1] - h / 2;
	
	      if (x >= x0 && y >= y0 && x <= x0 + w && y <= y0 + h) {
	        return idx;
	      }
	    }
	
	    return -1;
	  }
	});
	
	function LargeSymbolDraw() {
	  this.group = new graphic.Group();
	}
	
	var largeSymbolProto = LargeSymbolDraw.prototype;
	
	largeSymbolProto.isPersistent = function () {
	  return !this._incremental;
	};
	/**
	 * Update symbols draw by new data
	 * @param {module:echarts/data/List} data
	 * @param {Object} opt
	 * @param {Object} [opt.clipShape]
	 */
	
	
	largeSymbolProto.updateData = function (data, opt) {
	  this.group.removeAll();
	  var symbolEl = new LargeSymbolPath({
	    rectHover: true,
	    cursor: 'default'
	  });
	  symbolEl.setShape({
	    points: data.getLayout('symbolPoints')
	  });
	
	  this._setCommon(symbolEl, data, false, opt);
	
	  this.group.add(symbolEl);
	  this._incremental = null;
	};
	
	largeSymbolProto.updateLayout = function (data) {
	  if (this._incremental) {
	    return;
	  }
	
	  var points = data.getLayout('symbolPoints');
	  this.group.eachChild(function (child) {
	    if (child.startIndex != null) {
	      var len = (child.endIndex - child.startIndex) * 2;
	      var byteOffset = child.startIndex * 4 * 2;
	      points = new Float32Array(points.buffer, byteOffset, len);
	    }
	
	    child.setShape('points', points);
	  });
	};
	
	largeSymbolProto.incrementalPrepareUpdate = function (data) {
	  this.group.removeAll();
	
	  this._clearIncremental(); // Only use incremental displayables when data amount is larger than 2 million.
	  // PENDING Incremental data?
	
	
	  if (data.count() > 2e6) {
	    if (!this._incremental) {
	      this._incremental = new IncrementalDisplayable({
	        silent: true
	      });
	    }
	
	    this.group.add(this._incremental);
	  } else {
	    this._incremental = null;
	  }
	};
	
	largeSymbolProto.incrementalUpdate = function (taskParams, data, opt) {
	  var symbolEl;
	
	  if (this._incremental) {
	    symbolEl = new LargeSymbolPath();
	
	    this._incremental.addDisplayable(symbolEl, true);
	  } else {
	    symbolEl = new LargeSymbolPath({
	      rectHover: true,
	      cursor: 'default',
	      startIndex: taskParams.start,
	      endIndex: taskParams.end
	    });
	    symbolEl.incremental = true;
	    this.group.add(symbolEl);
	  }
	
	  symbolEl.setShape({
	    points: data.getLayout('symbolPoints')
	  });
	
	  this._setCommon(symbolEl, data, !!this._incremental, opt);
	};
	
	largeSymbolProto._setCommon = function (symbolEl, data, isIncremental, opt) {
	  var hostModel = data.hostModel;
	  opt = opt || {}; // TODO
	  // if (data.hasItemVisual.symbolSize) {
	  //     // TODO typed array?
	  //     symbolEl.setShape('sizes', data.mapArray(
	  //         function (idx) {
	  //             var size = data.getItemVisual(idx, 'symbolSize');
	  //             return (size instanceof Array) ? size : [size, size];
	  //         }
	  //     ));
	  // }
	  // else {
	
	  var size = data.getVisual('symbolSize');
	  symbolEl.setShape('size', size instanceof Array ? size : [size, size]); // }
	
	  symbolEl.softClipShape = opt.clipShape || null; // Create symbolProxy to build path for each data
	
	  symbolEl.symbolProxy = createSymbol(data.getVisual('symbol'), 0, 0, 0, 0); // Use symbolProxy setColor method
	
	  symbolEl.setColor = symbolEl.symbolProxy.setColor;
	  var extrudeShadow = symbolEl.shape.size[0] < BOOST_SIZE_THRESHOLD;
	  symbolEl.useStyle( // Draw shadow when doing fillRect is extremely slow.
	  hostModel.getModel('itemStyle').getItemStyle(extrudeShadow ? ['color', 'shadowBlur', 'shadowColor'] : ['color']));
	  var visualColor = data.getVisual('color');
	
	  if (visualColor) {
	    symbolEl.setColor(visualColor);
	  }
	
	  if (!isIncremental) {
	    // Enable tooltip
	    // PENDING May have performance issue when path is extremely large
	    symbolEl.seriesIndex = hostModel.seriesIndex;
	    symbolEl.on('mousemove', function (e) {
	      symbolEl.dataIndex = null;
	      var dataIndex = symbolEl.findDataIndex(e.offsetX, e.offsetY);
	
	      if (dataIndex >= 0) {
	        // Provide dataIndex for tooltip
	        symbolEl.dataIndex = dataIndex + (symbolEl.startIndex || 0);
	      }
	    });
	  }
	};
	
	largeSymbolProto.remove = function () {
	  this._clearIncremental();
	
	  this._incremental = null;
	  this.group.removeAll();
	};
	
	largeSymbolProto._clearIncremental = function () {
	  var incremental = this._incremental;
	
	  if (incremental) {
	    incremental.clearDisplaybles();
	  }
	};
	
	var _default = LargeSymbolDraw;
	module.exports = _default;

/***/ },
/* 1503 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(16);
	
	var vec2 = __webpack_require__(41);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Line path for bezier and straight line draw
	 */
	var straightLineProto = graphic.Line.prototype;
	var bezierCurveProto = graphic.BezierCurve.prototype;
	
	function isLine(shape) {
	  return isNaN(+shape.cpx1) || isNaN(+shape.cpy1);
	}
	
	var _default = graphic.extendShape({
	  type: 'ec-line',
	  style: {
	    stroke: '#000',
	    fill: null
	  },
	  shape: {
	    x1: 0,
	    y1: 0,
	    x2: 0,
	    y2: 0,
	    percent: 1,
	    cpx1: null,
	    cpy1: null
	  },
	  buildPath: function (ctx, shape) {
	    this[isLine(shape) ? '_buildPathLine' : '_buildPathCurve'](ctx, shape);
	  },
	  _buildPathLine: straightLineProto.buildPath,
	  _buildPathCurve: bezierCurveProto.buildPath,
	  pointAt: function (t) {
	    return this[isLine(this.shape) ? '_pointAtLine' : '_pointAtCurve'](t);
	  },
	  _pointAtLine: straightLineProto.pointAt,
	  _pointAtCurve: bezierCurveProto.pointAt,
	  tangentAt: function (t) {
	    var shape = this.shape;
	    var p = isLine(shape) ? [shape.x2 - shape.x1, shape.y2 - shape.y1] : this._tangentAtCurve(t);
	    return vec2.normalize(p, p);
	  },
	  _tangentAtCurve: bezierCurveProto.tangentAt
	});
	
	module.exports = _default;

/***/ },
/* 1504 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	__webpack_require__(1505);
	
	__webpack_require__(1506);
	
	var visualSymbol = __webpack_require__(169);
	
	var layoutPoints = __webpack_require__(266);
	
	var dataSample = __webpack_require__(1702);
	
	__webpack_require__(261);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// In case developer forget to include grid component
	echarts.registerVisual(visualSymbol('line', 'circle', 'line'));
	echarts.registerLayout(layoutPoints('line')); // Down sample after filter
	
	echarts.registerProcessor(echarts.PRIORITY.PROCESSOR.STATISTIC, dataSample('line'));

/***/ },
/* 1505 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	var createListFromArray = __webpack_require__(122);
	
	var SeriesModel = __webpack_require__(58);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.line',
	  dependencies: ['grid', 'polar'],
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(this.getSource(), this, {
	      useEncodeDefaulter: true
	    });
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'cartesian2d',
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // stack: null
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // polarIndex: 0,
	    // If clip the overflow value
	    clip: true,
	    // cursor: null,
	    label: {
	      position: 'top'
	    },
	    // itemStyle: {
	    // },
	    lineStyle: {
	      width: 2,
	      type: 'solid'
	    },
	    // areaStyle: {
	    // origin of areaStyle. Valid values:
	    // `'auto'/null/undefined`: from axisLine to data
	    // `'start'`: from min to data
	    // `'end'`: from data to max
	    // origin: 'auto'
	    // },
	    // false, 'start', 'end', 'middle'
	    step: false,
	    // Disabled if step is true
	    smooth: false,
	    smoothMonotone: null,
	    symbol: 'emptyCircle',
	    symbolSize: 4,
	    symbolRotate: null,
	    showSymbol: true,
	    // `false`: follow the label interval strategy.
	    // `true`: show all symbols.
	    // `'auto'`: If possible, show all symbols, otherwise
	    //           follow the label interval strategy.
	    showAllSymbol: 'auto',
	    // Whether to connect break point.
	    connectNulls: false,
	    // Sampling for large data. Can be: 'average', 'max', 'min', 'sum'.
	    sampling: 'none',
	    animationEasing: 'linear',
	    // Disable progressive
	    progressive: 0,
	    hoverLayerThreshold: Infinity
	  }
	});
	
	module.exports = _default;

/***/ },
/* 1506 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(3);
	
	var _bbox = __webpack_require__(292);
	
	var fromPoints = _bbox.fromPoints;
	
	var SymbolDraw = __webpack_require__(258);
	
	var SymbolClz = __webpack_require__(330);
	
	var lineAnimationDiff = __webpack_require__(1507);
	
	var graphic = __webpack_require__(16);
	
	var modelUtil = __webpack_require__(24);
	
	var _poly = __webpack_require__(706);
	
	var Polyline = _poly.Polyline;
	var Polygon = _poly.Polygon;
	
	var ChartView = __webpack_require__(106);
	
	var _helper = __webpack_require__(705);
	
	var prepareDataCoordInfo = _helper.prepareDataCoordInfo;
	var getStackedOnPoint = _helper.getStackedOnPoint;
	
	var _createClipPathFromCoordSys = __webpack_require__(259);
	
	var createGridClipPath = _createClipPathFromCoordSys.createGridClipPath;
	var createPolarClipPath = _createClipPathFromCoordSys.createPolarClipPath;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// FIXME step not support polar
	function isPointsSame(points1, points2) {
	  if (points1.length !== points2.length) {
	    return;
	  }
	
	  for (var i = 0; i < points1.length; i++) {
	    var p1 = points1[i];
	    var p2 = points2[i];
	
	    if (p1[0] !== p2[0] || p1[1] !== p2[1]) {
	      return;
	    }
	  }
	
	  return true;
	}
	
	function getBoundingDiff(points1, points2) {
	  var min1 = [];
	  var max1 = [];
	  var min2 = [];
	  var max2 = [];
	  fromPoints(points1, min1, max1);
	  fromPoints(points2, min2, max2); // Get a max value from each corner of two boundings.
	
	  return Math.max(Math.abs(min1[0] - min2[0]), Math.abs(min1[1] - min2[1]), Math.abs(max1[0] - max2[0]), Math.abs(max1[1] - max2[1]));
	}
	
	function getSmooth(smooth) {
	  return typeof smooth === 'number' ? smooth : smooth ? 0.5 : 0;
	}
	/**
	 * @param {module:echarts/coord/cartesian/Cartesian2D|module:echarts/coord/polar/Polar} coordSys
	 * @param {module:echarts/data/List} data
	 * @param {Object} dataCoordInfo
	 * @param {Array.<Array.<number>>} points
	 */
	
	
	function getStackedOnPoints(coordSys, data, dataCoordInfo) {
	  if (!dataCoordInfo.valueDim) {
	    return [];
	  }
	
	  var points = [];
	
	  for (var idx = 0, len = data.count(); idx < len; idx++) {
	    points.push(getStackedOnPoint(dataCoordInfo, coordSys, data, idx));
	  }
	
	  return points;
	}
	
	function turnPointsIntoStep(points, coordSys, stepTurnAt) {
	  var baseAxis = coordSys.getBaseAxis();
	  var baseIndex = baseAxis.dim === 'x' || baseAxis.dim === 'radius' ? 0 : 1;
	  var stepPoints = [];
	
	  for (var i = 0; i < points.length - 1; i++) {
	    var nextPt = points[i + 1];
	    var pt = points[i];
	    stepPoints.push(pt);
	    var stepPt = [];
	
	    switch (stepTurnAt) {
	      case 'end':
	        stepPt[baseIndex] = nextPt[baseIndex];
	        stepPt[1 - baseIndex] = pt[1 - baseIndex]; // default is start
	
	        stepPoints.push(stepPt);
	        break;
	
	      case 'middle':
	        // default is start
	        var middle = (pt[baseIndex] + nextPt[baseIndex]) / 2;
	        var stepPt2 = [];
	        stepPt[baseIndex] = stepPt2[baseIndex] = middle;
	        stepPt[1 - baseIndex] = pt[1 - baseIndex];
	        stepPt2[1 - baseIndex] = nextPt[1 - baseIndex];
	        stepPoints.push(stepPt);
	        stepPoints.push(stepPt2);
	        break;
	
	      default:
	        stepPt[baseIndex] = pt[baseIndex];
	        stepPt[1 - baseIndex] = nextPt[1 - baseIndex]; // default is start
	
	        stepPoints.push(stepPt);
	    }
	  } // Last points
	
	
	  points[i] && stepPoints.push(points[i]);
	  return stepPoints;
	}
	
	function getVisualGradient(data, coordSys) {
	  var visualMetaList = data.getVisual('visualMeta');
	
	  if (!visualMetaList || !visualMetaList.length || !data.count()) {
	    // When data.count() is 0, gradient range can not be calculated.
	    return;
	  }
	
	  if (coordSys.type !== 'cartesian2d') {
	    return;
	  }
	
	  var coordDim;
	  var visualMeta;
	
	  for (var i = visualMetaList.length - 1; i >= 0; i--) {
	    var dimIndex = visualMetaList[i].dimension;
	    var dimName = data.dimensions[dimIndex];
	    var dimInfo = data.getDimensionInfo(dimName);
	    coordDim = dimInfo && dimInfo.coordDim; // Can only be x or y
	
	    if (coordDim === 'x' || coordDim === 'y') {
	      visualMeta = visualMetaList[i];
	      break;
	    }
	  }
	
	  if (!visualMeta) {
	    return;
	  } // If the area to be rendered is bigger than area defined by LinearGradient,
	  // the canvas spec prescribes that the color of the first stop and the last
	  // stop should be used. But if two stops are added at offset 0, in effect
	  // browsers use the color of the second stop to render area outside
	  // LinearGradient. So we can only infinitesimally extend area defined in
	  // LinearGradient to render `outerColors`.
	
	
	  var axis = coordSys.getAxis(coordDim); // dataToCoor mapping may not be linear, but must be monotonic.
	
	  var colorStops = zrUtil.map(visualMeta.stops, function (stop) {
	    return {
	      coord: axis.toGlobalCoord(axis.dataToCoord(stop.value)),
	      color: stop.color
	    };
	  });
	  var stopLen = colorStops.length;
	  var outerColors = visualMeta.outerColors.slice();
	
	  if (stopLen && colorStops[0].coord > colorStops[stopLen - 1].coord) {
	    colorStops.reverse();
	    outerColors.reverse();
	  }
	
	  var tinyExtent = 10; // Arbitrary value: 10px
	
	  var minCoord = colorStops[0].coord - tinyExtent;
	  var maxCoord = colorStops[stopLen - 1].coord + tinyExtent;
	  var coordSpan = maxCoord - minCoord;
	
	  if (coordSpan < 1e-3) {
	    return 'transparent';
	  }
	
	  zrUtil.each(colorStops, function (stop) {
	    stop.offset = (stop.coord - minCoord) / coordSpan;
	  });
	  colorStops.push({
	    offset: stopLen ? colorStops[stopLen - 1].offset : 0.5,
	    color: outerColors[1] || 'transparent'
	  });
	  colorStops.unshift({
	    // notice colorStops.length have been changed.
	    offset: stopLen ? colorStops[0].offset : 0.5,
	    color: outerColors[0] || 'transparent'
	  }); // zrUtil.each(colorStops, function (colorStop) {
	  //     // Make sure each offset has rounded px to avoid not sharp edge
	  //     colorStop.offset = (Math.round(colorStop.offset * (end - start) + start) - start) / (end - start);
	  // });
	
	  var gradient = new graphic.LinearGradient(0, 0, 0, 0, colorStops, true);
	  gradient[coordDim] = minCoord;
	  gradient[coordDim + '2'] = maxCoord;
	  return gradient;
	}
	
	function getIsIgnoreFunc(seriesModel, data, coordSys) {
	  var showAllSymbol = seriesModel.get('showAllSymbol');
	  var isAuto = showAllSymbol === 'auto';
	
	  if (showAllSymbol && !isAuto) {
	    return;
	  }
	
	  var categoryAxis = coordSys.getAxesByScale('ordinal')[0];
	
	  if (!categoryAxis) {
	    return;
	  } // Note that category label interval strategy might bring some weird effect
	  // in some scenario: users may wonder why some of the symbols are not
	  // displayed. So we show all symbols as possible as we can.
	
	
	  if (isAuto // Simplify the logic, do not determine label overlap here.
	  && canShowAllSymbolForCategory(categoryAxis, data)) {
	    return;
	  } // Otherwise follow the label interval strategy on category axis.
	
	
	  var categoryDataDim = data.mapDimension(categoryAxis.dim);
	  var labelMap = {};
	  zrUtil.each(categoryAxis.getViewLabels(), function (labelItem) {
	    labelMap[labelItem.tickValue] = 1;
	  });
	  return function (dataIndex) {
	    return !labelMap.hasOwnProperty(data.get(categoryDataDim, dataIndex));
	  };
	}
	
	function canShowAllSymbolForCategory(categoryAxis, data) {
	  // In mose cases, line is monotonous on category axis, and the label size
	  // is close with each other. So we check the symbol size and some of the
	  // label size alone with the category axis to estimate whether all symbol
	  // can be shown without overlap.
	  var axisExtent = categoryAxis.getExtent();
	  var availSize = Math.abs(axisExtent[1] - axisExtent[0]) / categoryAxis.scale.count();
	  isNaN(availSize) && (availSize = 0); // 0/0 is NaN.
	  // Sampling some points, max 5.
	
	  var dataLen = data.count();
	  var step = Math.max(1, Math.round(dataLen / 5));
	
	  for (var dataIndex = 0; dataIndex < dataLen; dataIndex += step) {
	    if (SymbolClz.getSymbolSize(data, dataIndex // Only for cartesian, where `isHorizontal` exists.
	    )[categoryAxis.isHorizontal() ? 1 : 0] // Empirical number
	    * 1.5 > availSize) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function createLineClipPath(coordSys, hasAnimation, seriesModel) {
	  if (coordSys.type === 'cartesian2d') {
	    var isHorizontal = coordSys.getBaseAxis().isHorizontal();
	    var clipPath = createGridClipPath(coordSys, hasAnimation, seriesModel); // Expand clip shape to avoid clipping when line value exceeds axis
	
	    if (!seriesModel.get('clip', true)) {
	      var rectShape = clipPath.shape;
	      var expandSize = Math.max(rectShape.width, rectShape.height);
	
	      if (isHorizontal) {
	        rectShape.y -= expandSize;
	        rectShape.height += expandSize * 2;
	      } else {
	        rectShape.x -= expandSize;
	        rectShape.width += expandSize * 2;
	      }
	    }
	
	    return clipPath;
	  } else {
	    return createPolarClipPath(coordSys, hasAnimation, seriesModel);
	  }
	}
	
	var _default = ChartView.extend({
	  type: 'line',
	  init: function () {
	    var lineGroup = new graphic.Group();
	    var symbolDraw = new SymbolDraw();
	    this.group.add(symbolDraw.group);
	    this._symbolDraw = symbolDraw;
	    this._lineGroup = lineGroup;
	  },
	  render: function (seriesModel, ecModel, api) {
	    var coordSys = seriesModel.coordinateSystem;
	    var group = this.group;
	    var data = seriesModel.getData();
	    var lineStyleModel = seriesModel.getModel('lineStyle');
	    var areaStyleModel = seriesModel.getModel('areaStyle');
	    var points = data.mapArray(data.getItemLayout);
	    var isCoordSysPolar = coordSys.type === 'polar';
	    var prevCoordSys = this._coordSys;
	    var symbolDraw = this._symbolDraw;
	    var polyline = this._polyline;
	    var polygon = this._polygon;
	    var lineGroup = this._lineGroup;
	    var hasAnimation = seriesModel.get('animation');
	    var isAreaChart = !areaStyleModel.isEmpty();
	    var valueOrigin = areaStyleModel.get('origin');
	    var dataCoordInfo = prepareDataCoordInfo(coordSys, data, valueOrigin);
	    var stackedOnPoints = getStackedOnPoints(coordSys, data, dataCoordInfo);
	    var showSymbol = seriesModel.get('showSymbol');
	    var isIgnoreFunc = showSymbol && !isCoordSysPolar && getIsIgnoreFunc(seriesModel, data, coordSys); // Remove temporary symbols
	
	    var oldData = this._data;
	    oldData && oldData.eachItemGraphicEl(function (el, idx) {
	      if (el.__temp) {
	        group.remove(el);
	        oldData.setItemGraphicEl(idx, null);
	      }
	    }); // Remove previous created symbols if showSymbol changed to false
	
	    if (!showSymbol) {
	      symbolDraw.remove();
	    }
	
	    group.add(lineGroup); // FIXME step not support polar
	
	    var step = !isCoordSysPolar && seriesModel.get('step');
	    var clipShapeForSymbol;
	
	    if (coordSys && coordSys.getArea && seriesModel.get('clip', true)) {
	      clipShapeForSymbol = coordSys.getArea(); // Avoid float number rounding error for symbol on the edge of axis extent.
	      // See #7913 and `test/dataZoom-clip.html`.
	
	      if (clipShapeForSymbol.width != null) {
	        clipShapeForSymbol.x -= 0.1;
	        clipShapeForSymbol.y -= 0.1;
	        clipShapeForSymbol.width += 0.2;
	        clipShapeForSymbol.height += 0.2;
	      } else if (clipShapeForSymbol.r0) {
	        clipShapeForSymbol.r0 -= 0.5;
	        clipShapeForSymbol.r1 += 0.5;
	      }
	    }
	
	    this._clipShapeForSymbol = clipShapeForSymbol; // Initialization animation or coordinate system changed
	
	    if (!(polyline && prevCoordSys.type === coordSys.type && step === this._step)) {
	      showSymbol && symbolDraw.updateData(data, {
	        isIgnore: isIgnoreFunc,
	        clipShape: clipShapeForSymbol
	      });
	
	      if (step) {
	        // TODO If stacked series is not step
	        points = turnPointsIntoStep(points, coordSys, step);
	        stackedOnPoints = turnPointsIntoStep(stackedOnPoints, coordSys, step);
	      }
	
	      polyline = this._newPolyline(points, coordSys, hasAnimation);
	
	      if (isAreaChart) {
	        polygon = this._newPolygon(points, stackedOnPoints, coordSys, hasAnimation);
	      }
	
	      lineGroup.setClipPath(createLineClipPath(coordSys, true, seriesModel));
	    } else {
	      if (isAreaChart && !polygon) {
	        // If areaStyle is added
	        polygon = this._newPolygon(points, stackedOnPoints, coordSys, hasAnimation);
	      } else if (polygon && !isAreaChart) {
	        // If areaStyle is removed
	        lineGroup.remove(polygon);
	        polygon = this._polygon = null;
	      } // Update clipPath
	
	
	      lineGroup.setClipPath(createLineClipPath(coordSys, false, seriesModel)); // Always update, or it is wrong in the case turning on legend
	      // because points are not changed
	
	      showSymbol && symbolDraw.updateData(data, {
	        isIgnore: isIgnoreFunc,
	        clipShape: clipShapeForSymbol
	      }); // Stop symbol animation and sync with line points
	      // FIXME performance?
	
	      data.eachItemGraphicEl(function (el) {
	        el.stopAnimation(true);
	      }); // In the case data zoom triggerred refreshing frequently
	      // Data may not change if line has a category axis. So it should animate nothing
	
	      if (!isPointsSame(this._stackedOnPoints, stackedOnPoints) || !isPointsSame(this._points, points)) {
	        if (hasAnimation) {
	          this._updateAnimation(data, stackedOnPoints, coordSys, api, step, valueOrigin);
	        } else {
	          // Not do it in update with animation
	          if (step) {
	            // TODO If stacked series is not step
	            points = turnPointsIntoStep(points, coordSys, step);
	            stackedOnPoints = turnPointsIntoStep(stackedOnPoints, coordSys, step);
	          }
	
	          polyline.setShape({
	            points: points
	          });
	          polygon && polygon.setShape({
	            points: points,
	            stackedOnPoints: stackedOnPoints
	          });
	        }
	      }
	    }
	
	    var visualColor = getVisualGradient(data, coordSys) || data.getVisual('color');
	    polyline.useStyle(zrUtil.defaults( // Use color in lineStyle first
	    lineStyleModel.getLineStyle(), {
	      fill: 'none',
	      stroke: visualColor,
	      lineJoin: 'bevel'
	    }));
	    var smooth = seriesModel.get('smooth');
	    smooth = getSmooth(seriesModel.get('smooth'));
	    polyline.setShape({
	      smooth: smooth,
	      smoothMonotone: seriesModel.get('smoothMonotone'),
	      connectNulls: seriesModel.get('connectNulls')
	    });
	
	    if (polygon) {
	      var stackedOnSeries = data.getCalculationInfo('stackedOnSeries');
	      var stackedOnSmooth = 0;
	      polygon.useStyle(zrUtil.defaults(areaStyleModel.getAreaStyle(), {
	        fill: visualColor,
	        opacity: 0.7,
	        lineJoin: 'bevel'
	      }));
	
	      if (stackedOnSeries) {
	        stackedOnSmooth = getSmooth(stackedOnSeries.get('smooth'));
	      }
	
	      polygon.setShape({
	        smooth: smooth,
	        stackedOnSmooth: stackedOnSmooth,
	        smoothMonotone: seriesModel.get('smoothMonotone'),
	        connectNulls: seriesModel.get('connectNulls')
	      });
	    }
	
	    this._data = data; // Save the coordinate system for transition animation when data changed
	
	    this._coordSys = coordSys;
	    this._stackedOnPoints = stackedOnPoints;
	    this._points = points;
	    this._step = step;
	    this._valueOrigin = valueOrigin;
	  },
	  dispose: function () {},
	  highlight: function (seriesModel, ecModel, api, payload) {
	    var data = seriesModel.getData();
	    var dataIndex = modelUtil.queryDataIndex(data, payload);
	
	    if (!(dataIndex instanceof Array) && dataIndex != null && dataIndex >= 0) {
	      var symbol = data.getItemGraphicEl(dataIndex);
	
	      if (!symbol) {
	        // Create a temporary symbol if it is not exists
	        var pt = data.getItemLayout(dataIndex);
	
	        if (!pt) {
	          // Null data
	          return;
	        } // fix #11360: should't draw symbol outside clipShapeForSymbol
	
	
	        if (this._clipShapeForSymbol && !this._clipShapeForSymbol.contain(pt[0], pt[1])) {
	          return;
	        }
	
	        symbol = new SymbolClz(data, dataIndex);
	        symbol.position = pt;
	        symbol.setZ(seriesModel.get('zlevel'), seriesModel.get('z'));
	        symbol.ignore = isNaN(pt[0]) || isNaN(pt[1]);
	        symbol.__temp = true;
	        data.setItemGraphicEl(dataIndex, symbol); // Stop scale animation
	
	        symbol.stopSymbolAnimation(true);
	        this.group.add(symbol);
	      }
	
	      symbol.highlight();
	    } else {
	      // Highlight whole series
	      ChartView.prototype.highlight.call(this, seriesModel, ecModel, api, payload);
	    }
	  },
	  downplay: function (seriesModel, ecModel, api, payload) {
	    var data = seriesModel.getData();
	    var dataIndex = modelUtil.queryDataIndex(data, payload);
	
	    if (dataIndex != null && dataIndex >= 0) {
	      var symbol = data.getItemGraphicEl(dataIndex);
	
	      if (symbol) {
	        if (symbol.__temp) {
	          data.setItemGraphicEl(dataIndex, null);
	          this.group.remove(symbol);
	        } else {
	          symbol.downplay();
	        }
	      }
	    } else {
	      // FIXME
	      // can not downplay completely.
	      // Downplay whole series
	      ChartView.prototype.downplay.call(this, seriesModel, ecModel, api, payload);
	    }
	  },
	
	  /**
	   * @param {module:zrender/container/Group} group
	   * @param {Array.<Array.<number>>} points
	   * @private
	   */
	  _newPolyline: function (points) {
	    var polyline = this._polyline; // Remove previous created polyline
	
	    if (polyline) {
	      this._lineGroup.remove(polyline);
	    }
	
	    polyline = new Polyline({
	      shape: {
	        points: points
	      },
	      silent: true,
	      z2: 10
	    });
	
	    this._lineGroup.add(polyline);
	
	    this._polyline = polyline;
	    return polyline;
	  },
	
	  /**
	   * @param {module:zrender/container/Group} group
	   * @param {Array.<Array.<number>>} stackedOnPoints
	   * @param {Array.<Array.<number>>} points
	   * @private
	   */
	  _newPolygon: function (points, stackedOnPoints) {
	    var polygon = this._polygon; // Remove previous created polygon
	
	    if (polygon) {
	      this._lineGroup.remove(polygon);
	    }
	
	    polygon = new Polygon({
	      shape: {
	        points: points,
	        stackedOnPoints: stackedOnPoints
	      },
	      silent: true
	    });
	
	    this._lineGroup.add(polygon);
	
	    this._polygon = polygon;
	    return polygon;
	  },
	
	  /**
	   * @private
	   */
	  // FIXME Two value axis
	  _updateAnimation: function (data, stackedOnPoints, coordSys, api, step, valueOrigin) {
	    var polyline = this._polyline;
	    var polygon = this._polygon;
	    var seriesModel = data.hostModel;
	    var diff = lineAnimationDiff(this._data, data, this._stackedOnPoints, stackedOnPoints, this._coordSys, coordSys, this._valueOrigin, valueOrigin);
	    var current = diff.current;
	    var stackedOnCurrent = diff.stackedOnCurrent;
	    var next = diff.next;
	    var stackedOnNext = diff.stackedOnNext;
	
	    if (step) {
	      // TODO If stacked series is not step
	      current = turnPointsIntoStep(diff.current, coordSys, step);
	      stackedOnCurrent = turnPointsIntoStep(diff.stackedOnCurrent, coordSys, step);
	      next = turnPointsIntoStep(diff.next, coordSys, step);
	      stackedOnNext = turnPointsIntoStep(diff.stackedOnNext, coordSys, step);
	    } // Don't apply animation if diff is large.
	    // For better result and avoid memory explosion problems like
	    // https://github.com/apache/incubator-echarts/issues/12229
	
	
	    if (getBoundingDiff(current, next) > 3000 || polygon && getBoundingDiff(stackedOnCurrent, stackedOnNext) > 3000) {
	      polyline.setShape({
	        points: next
	      });
	
	      if (polygon) {
	        polygon.setShape({
	          points: next,
	          stackedOnPoints: stackedOnNext
	        });
	      }
	
	      return;
	    } // `diff.current` is subset of `current` (which should be ensured by
	    // turnPointsIntoStep), so points in `__points` can be updated when
	    // points in `current` are update during animation.
	
	
	    polyline.shape.__points = diff.current;
	    polyline.shape.points = current;
	    graphic.updateProps(polyline, {
	      shape: {
	        points: next
	      }
	    }, seriesModel);
	
	    if (polygon) {
	      polygon.setShape({
	        points: current,
	        stackedOnPoints: stackedOnCurrent
	      });
	      graphic.updateProps(polygon, {
	        shape: {
	          points: next,
	          stackedOnPoints: stackedOnNext
	        }
	      }, seriesModel);
	    }
	
	    var updatedDataInfo = [];
	    var diffStatus = diff.status;
	
	    for (var i = 0; i < diffStatus.length; i++) {
	      var cmd = diffStatus[i].cmd;
	
	      if (cmd === '=') {
	        var el = data.getItemGraphicEl(diffStatus[i].idx1);
	
	        if (el) {
	          updatedDataInfo.push({
	            el: el,
	            ptIdx: i // Index of points
	
	          });
	        }
	      }
	    }
	
	    if (polyline.animators && polyline.animators.length) {
	      polyline.animators[0].during(function () {
	        for (var i = 0; i < updatedDataInfo.length; i++) {
	          var el = updatedDataInfo[i].el;
	          el.attr('position', polyline.shape.__points[updatedDataInfo[i].ptIdx]);
	        }
	      });
	    }
	  },
	  remove: function (ecModel) {
	    var group = this.group;
	    var oldData = this._data;
	
	    this._lineGroup.removeAll();
	
	    this._symbolDraw.remove(true); // Remove temporary created elements when highlighting
	
	
	    oldData && oldData.eachItemGraphicEl(function (el, idx) {
	      if (el.__temp) {
	        group.remove(el);
	        oldData.setItemGraphicEl(idx, null);
	      }
	    });
	    this._polyline = this._polygon = this._coordSys = this._points = this._stackedOnPoints = this._data = null;
	  }
	});
	
	module.exports = _default;

/***/ },
/* 1507 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _helper = __webpack_require__(705);
	
	var prepareDataCoordInfo = _helper.prepareDataCoordInfo;
	var getStackedOnPoint = _helper.getStackedOnPoint;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// var arrayDiff = require('zrender/src/core/arrayDiff');
	// 'zrender/src/core/arrayDiff' has been used before, but it did
	// not do well in performance when roam with fixed dataZoom window.
	// function convertToIntId(newIdList, oldIdList) {
	//     // Generate int id instead of string id.
	//     // Compare string maybe slow in score function of arrDiff
	//     // Assume id in idList are all unique
	//     var idIndicesMap = {};
	//     var idx = 0;
	//     for (var i = 0; i < newIdList.length; i++) {
	//         idIndicesMap[newIdList[i]] = idx;
	//         newIdList[i] = idx++;
	//     }
	//     for (var i = 0; i < oldIdList.length; i++) {
	//         var oldId = oldIdList[i];
	//         // Same with newIdList
	//         if (idIndicesMap[oldId]) {
	//             oldIdList[i] = idIndicesMap[oldId];
	//         }
	//         else {
	//             oldIdList[i] = idx++;
	//         }
	//     }
	// }
	function diffData(oldData, newData) {
	  var diffResult = [];
	  newData.diff(oldData).add(function (idx) {
	    diffResult.push({
	      cmd: '+',
	      idx: idx
	    });
	  }).update(function (newIdx, oldIdx) {
	    diffResult.push({
	      cmd: '=',
	      idx: oldIdx,
	      idx1: newIdx
	    });
	  }).remove(function (idx) {
	    diffResult.push({
	      cmd: '-',
	      idx: idx
	    });
	  }).execute();
	  return diffResult;
	}
	
	function _default(oldData, newData, oldStackedOnPoints, newStackedOnPoints, oldCoordSys, newCoordSys, oldValueOrigin, newValueOrigin) {
	  var diff = diffData(oldData, newData); // var newIdList = newData.mapArray(newData.getId);
	  // var oldIdList = oldData.mapArray(oldData.getId);
	  // convertToIntId(newIdList, oldIdList);
	  // // FIXME One data ?
	  // diff = arrayDiff(oldIdList, newIdList);
	
	  var currPoints = [];
	  var nextPoints = []; // Points for stacking base line
	
	  var currStackedPoints = [];
	  var nextStackedPoints = [];
	  var status = [];
	  var sortedIndices = [];
	  var rawIndices = [];
	  var newDataOldCoordInfo = prepareDataCoordInfo(oldCoordSys, newData, oldValueOrigin);
	  var oldDataNewCoordInfo = prepareDataCoordInfo(newCoordSys, oldData, newValueOrigin);
	
	  for (var i = 0; i < diff.length; i++) {
	    var diffItem = diff[i];
	    var pointAdded = true; // FIXME, animation is not so perfect when dataZoom window moves fast
	    // Which is in case remvoing or add more than one data in the tail or head
	
	    switch (diffItem.cmd) {
	      case '=':
	        var currentPt = oldData.getItemLayout(diffItem.idx);
	        var nextPt = newData.getItemLayout(diffItem.idx1); // If previous data is NaN, use next point directly
	
	        if (isNaN(currentPt[0]) || isNaN(currentPt[1])) {
	          currentPt = nextPt.slice();
	        }
	
	        currPoints.push(currentPt);
	        nextPoints.push(nextPt);
	        currStackedPoints.push(oldStackedOnPoints[diffItem.idx]);
	        nextStackedPoints.push(newStackedOnPoints[diffItem.idx1]);
	        rawIndices.push(newData.getRawIndex(diffItem.idx1));
	        break;
	
	      case '+':
	        var idx = diffItem.idx;
	        currPoints.push(oldCoordSys.dataToPoint([newData.get(newDataOldCoordInfo.dataDimsForPoint[0], idx), newData.get(newDataOldCoordInfo.dataDimsForPoint[1], idx)]));
	        nextPoints.push(newData.getItemLayout(idx).slice());
	        currStackedPoints.push(getStackedOnPoint(newDataOldCoordInfo, oldCoordSys, newData, idx));
	        nextStackedPoints.push(newStackedOnPoints[idx]);
	        rawIndices.push(newData.getRawIndex(idx));
	        break;
	
	      case '-':
	        var idx = diffItem.idx;
	        var rawIndex = oldData.getRawIndex(idx); // Data is replaced. In the case of dynamic data queue
	        // FIXME FIXME FIXME
	
	        if (rawIndex !== idx) {
	          currPoints.push(oldData.getItemLayout(idx));
	          nextPoints.push(newCoordSys.dataToPoint([oldData.get(oldDataNewCoordInfo.dataDimsForPoint[0], idx), oldData.get(oldDataNewCoordInfo.dataDimsForPoint[1], idx)]));
	          currStackedPoints.push(oldStackedOnPoints[idx]);
	          nextStackedPoints.push(getStackedOnPoint(oldDataNewCoordInfo, newCoordSys, oldData, idx));
	          rawIndices.push(rawIndex);
	        } else {
	          pointAdded = false;
	        }
	
	    } // Original indices
	
	
	    if (pointAdded) {
	      status.push(diffItem);
	      sortedIndices.push(sortedIndices.length);
	    }
	  } // Diff result may be crossed if all items are changed
	  // Sort by data index
	
	
	  sortedIndices.sort(function (a, b) {
	    return rawIndices[a] - rawIndices[b];
	  });
	  var sortedCurrPoints = [];
	  var sortedNextPoints = [];
	  var sortedCurrStackedPoints = [];
	  var sortedNextStackedPoints = [];
	  var sortedStatus = [];
	
	  for (var i = 0; i < sortedIndices.length; i++) {
	    var idx = sortedIndices[i];
	    sortedCurrPoints[i] = currPoints[idx];
	    sortedNextPoints[i] = nextPoints[idx];
	    sortedCurrStackedPoints[i] = currStackedPoints[idx];
	    sortedNextStackedPoints[i] = nextStackedPoints[idx];
	    sortedStatus[i] = status[idx];
	  }
	
	  return {
	    current: sortedCurrPoints,
	    next: sortedNextPoints,
	    stackedOnCurrent: sortedCurrStackedPoints,
	    stackedOnNext: sortedNextStackedPoints,
	    status: sortedStatus
	  };
	}
	
	module.exports = _default;

/***/ },
/* 1508 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	__webpack_require__(1509);
	
	__webpack_require__(1510);
	
	var linesLayout = __webpack_require__(707);
	
	var linesVisual = __webpack_require__(1511);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerLayout(linesLayout);
	echarts.registerVisual(linesVisual);

/***/ },
/* 1509 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	var SeriesModel = __webpack_require__(58);
	
	var List = __webpack_require__(83);
	
	var _util = __webpack_require__(3);
	
	var concatArray = _util.concatArray;
	var mergeAll = _util.mergeAll;
	var map = _util.map;
	
	var _format = __webpack_require__(40);
	
	var encodeHTML = _format.encodeHTML;
	
	var CoordinateSystem = __webpack_require__(92);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Uint32Array, Float64Array, Float32Array */
	var Uint32Arr = typeof Uint32Array === 'undefined' ? Array : Uint32Array;
	var Float64Arr = typeof Float64Array === 'undefined' ? Array : Float64Array;
	
	function compatEc2(seriesOpt) {
	  var data = seriesOpt.data;
	
	  if (data && data[0] && data[0][0] && data[0][0].coord) {
	    seriesOpt.data = map(data, function (itemOpt) {
	      var coords = [itemOpt[0].coord, itemOpt[1].coord];
	      var target = {
	        coords: coords
	      };
	
	      if (itemOpt[0].name) {
	        target.fromName = itemOpt[0].name;
	      }
	
	      if (itemOpt[1].name) {
	        target.toName = itemOpt[1].name;
	      }
	
	      return mergeAll([target, itemOpt[0], itemOpt[1]]);
	    });
	  }
	}
	
	var LinesSeries = SeriesModel.extend({
	  type: 'series.lines',
	  dependencies: ['grid', 'polar'],
	  visualColorAccessPath: 'lineStyle.color',
	  init: function (option) {
	    // The input data may be null/undefined.
	    option.data = option.data || []; // Not using preprocessor because mergeOption may not have series.type
	
	    compatEc2(option);
	
	    var result = this._processFlatCoordsArray(option.data);
	
	    this._flatCoords = result.flatCoords;
	    this._flatCoordsOffset = result.flatCoordsOffset;
	
	    if (result.flatCoords) {
	      option.data = new Float32Array(result.count);
	    }
	
	    LinesSeries.superApply(this, 'init', arguments);
	  },
	  mergeOption: function (option) {
	    compatEc2(option);
	
	    if (option.data) {
	      // Only update when have option data to merge.
	      var result = this._processFlatCoordsArray(option.data);
	
	      this._flatCoords = result.flatCoords;
	      this._flatCoordsOffset = result.flatCoordsOffset;
	
	      if (result.flatCoords) {
	        option.data = new Float32Array(result.count);
	      }
	    }
	
	    LinesSeries.superApply(this, 'mergeOption', arguments);
	  },
	  appendData: function (params) {
	    var result = this._processFlatCoordsArray(params.data);
	
	    if (result.flatCoords) {
	      if (!this._flatCoords) {
	        this._flatCoords = result.flatCoords;
	        this._flatCoordsOffset = result.flatCoordsOffset;
	      } else {
	        this._flatCoords = concatArray(this._flatCoords, result.flatCoords);
	        this._flatCoordsOffset = concatArray(this._flatCoordsOffset, result.flatCoordsOffset);
	      }
	
	      params.data = new Float32Array(result.count);
	    }
	
	    this.getRawData().appendData(params.data);
	  },
	  _getCoordsFromItemModel: function (idx) {
	    var itemModel = this.getData().getItemModel(idx);
	    var coords = itemModel.option instanceof Array ? itemModel.option : itemModel.getShallow('coords');
	    return coords;
	  },
	  getLineCoordsCount: function (idx) {
	    if (this._flatCoordsOffset) {
	      return this._flatCoordsOffset[idx * 2 + 1];
	    } else {
	      return this._getCoordsFromItemModel(idx).length;
	    }
	  },
	  getLineCoords: function (idx, out) {
	    if (this._flatCoordsOffset) {
	      var offset = this._flatCoordsOffset[idx * 2];
	      var len = this._flatCoordsOffset[idx * 2 + 1];
	
	      for (var i = 0; i < len; i++) {
	        out[i] = out[i] || [];
	        out[i][0] = this._flatCoords[offset + i * 2];
	        out[i][1] = this._flatCoords[offset + i * 2 + 1];
	      }
	
	      return len;
	    } else {
	      var coords = this._getCoordsFromItemModel(idx);
	
	      for (var i = 0; i < coords.length; i++) {
	        out[i] = out[i] || [];
	        out[i][0] = coords[i][0];
	        out[i][1] = coords[i][1];
	      }
	
	      return coords.length;
	    }
	  },
	  _processFlatCoordsArray: function (data) {
	    var startOffset = 0;
	
	    if (this._flatCoords) {
	      startOffset = this._flatCoords.length;
	    } // Stored as a typed array. In format
	    // Points Count(2) | x | y | x | y | Points Count(3) | x |  y | x | y | x | y |
	
	
	    if (typeof data[0] === 'number') {
	      var len = data.length; // Store offset and len of each segment
	
	      var coordsOffsetAndLenStorage = new Uint32Arr(len);
	      var coordsStorage = new Float64Arr(len);
	      var coordsCursor = 0;
	      var offsetCursor = 0;
	      var dataCount = 0;
	
	      for (var i = 0; i < len;) {
	        dataCount++;
	        var count = data[i++]; // Offset
	
	        coordsOffsetAndLenStorage[offsetCursor++] = coordsCursor + startOffset; // Len
	
	        coordsOffsetAndLenStorage[offsetCursor++] = count;
	
	        for (var k = 0; k < count; k++) {
	          var x = data[i++];
	          var y = data[i++];
	          coordsStorage[coordsCursor++] = x;
	          coordsStorage[coordsCursor++] = y;
	
	          if (i > len) {}
	        }
	      }
	
	      return {
	        flatCoordsOffset: new Uint32Array(coordsOffsetAndLenStorage.buffer, 0, offsetCursor),
	        flatCoords: coordsStorage,
	        count: dataCount
	      };
	    }
	
	    return {
	      flatCoordsOffset: null,
	      flatCoords: null,
	      count: data.length
	    };
	  },
	  getInitialData: function (option, ecModel) {
	    var lineData = new List(['value'], this);
	    lineData.hasItemOption = false;
	    lineData.initData(option.data, [], function (dataItem, dimName, dataIndex, dimIndex) {
	      // dataItem is simply coords
	      if (dataItem instanceof Array) {
	        return NaN;
	      } else {
	        lineData.hasItemOption = true;
	        var value = dataItem.value;
	
	        if (value != null) {
	          return value instanceof Array ? value[dimIndex] : value;
	        }
	      }
	    });
	    return lineData;
	  },
	  formatTooltip: function (dataIndex) {
	    var data = this.getData();
	    var itemModel = data.getItemModel(dataIndex);
	    var name = itemModel.get('name');
	
	    if (name) {
	      return name;
	    }
	
	    var fromName = itemModel.get('fromName');
	    var toName = itemModel.get('toName');
	    var html = [];
	    fromName != null && html.push(fromName);
	    toName != null && html.push(toName);
	    return encodeHTML(html.join(' > '));
	  },
	  preventIncremental: function () {
	    return !!this.get('effect.show');
	  },
	  getProgressive: function () {
	    var progressive = this.option.progressive;
	
	    if (progressive == null) {
	      return this.option.large ? 1e4 : this.get('progressive');
	    }
	
	    return progressive;
	  },
	  getProgressiveThreshold: function () {
	    var progressiveThreshold = this.option.progressiveThreshold;
	
	    if (progressiveThreshold == null) {
	      return this.option.large ? 2e4 : this.get('progressiveThreshold');
	    }
	
	    return progressiveThreshold;
	  },
	  defaultOption: {
	    coordinateSystem: 'geo',
	    zlevel: 0,
	    z: 2,
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // Cartesian coordinate system
	    xAxisIndex: 0,
	    yAxisIndex: 0,
	    symbol: ['none', 'none'],
	    symbolSize: [10, 10],
	    // Geo coordinate system
	    geoIndex: 0,
	    effect: {
	      show: false,
	      period: 4,
	      // Animation delay. support callback
	      // delay: 0,
	      // If move with constant speed px/sec
	      // period will be ignored if this property is > 0,
	      constantSpeed: 0,
	      symbol: 'circle',
	      symbolSize: 3,
	      loop: true,
	      // Length of trail, 0 - 1
	      trailLength: 0.2 // Same with lineStyle.color
	      // color
	
	    },
	    large: false,
	    // Available when large is true
	    largeThreshold: 2000,
	    // If lines are polyline
	    // polyline not support curveness, label, animation
	    polyline: false,
	    // If clip the overflow.
	    // Available when coordinateSystem is cartesian or polar.
	    clip: true,
	    label: {
	      show: false,
	      position: 'end' // distance: 5,
	      // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
	
	    },
	    lineStyle: {
	      opacity: 0.5
	    }
	  }
	});
	var _default = LinesSeries;
	module.exports = _default;

/***/ },
/* 1510 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(13);
	
	var LineDraw = __webpack_require__(456);
	
	var EffectLine = __webpack_require__(700);
	
	var Line = __webpack_require__(455);
	
	var Polyline = __webpack_require__(701);
	
	var EffectPolyline = __webpack_require__(1499);
	
	var LargeLineDraw = __webpack_require__(1501);
	
	var linesLayout = __webpack_require__(707);
	
	var _createClipPathFromCoordSys = __webpack_require__(259);
	
	var createClipPath = _createClipPathFromCoordSys.createClipPath;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendChartView({
	  type: 'lines',
	  init: function () {},
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	
	    var lineDraw = this._updateLineDraw(data, seriesModel);
	
	    var zlevel = seriesModel.get('zlevel');
	    var trailLength = seriesModel.get('effect.trailLength');
	    var zr = api.getZr(); // Avoid the drag cause ghost shadow
	    // FIXME Better way ?
	    // SVG doesn't support
	
	    var isSvg = zr.painter.getType() === 'svg';
	
	    if (!isSvg) {
	      zr.painter.getLayer(zlevel).clear(true);
	    } // Config layer with motion blur
	
	
	    if (this._lastZlevel != null && !isSvg) {
	      zr.configLayer(this._lastZlevel, {
	        motionBlur: false
	      });
	    }
	
	    if (this._showEffect(seriesModel) && trailLength) {
	      if (!isSvg) {
	        zr.configLayer(zlevel, {
	          motionBlur: true,
	          lastFrameAlpha: Math.max(Math.min(trailLength / 10 + 0.9, 1), 0)
	        });
	      }
	    }
	
	    lineDraw.updateData(data);
	    var clipPath = seriesModel.get('clip', true) && createClipPath(seriesModel.coordinateSystem, false, seriesModel);
	
	    if (clipPath) {
	      this.group.setClipPath(clipPath);
	    } else {
	      this.group.removeClipPath();
	    }
	
	    this._lastZlevel = zlevel;
	    this._finished = true;
	  },
	  incrementalPrepareRender: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	
	    var lineDraw = this._updateLineDraw(data, seriesModel);
	
	    lineDraw.incrementalPrepareUpdate(data);
	
	    this._clearLayer(api);
	
	    this._finished = false;
	  },
	  incrementalRender: function (taskParams, seriesModel, ecModel) {
	    this._lineDraw.incrementalUpdate(taskParams, seriesModel.getData());
	
	    this._finished = taskParams.end === seriesModel.getData().count();
	  },
	  updateTransform: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    var pipelineContext = seriesModel.pipelineContext;
	
	    if (!this._finished || pipelineContext.large || pipelineContext.progressiveRender) {
	      // TODO Don't have to do update in large mode. Only do it when there are millions of data.
	      return {
	        update: true
	      };
	    } else {
	      // TODO Use same logic with ScatterView.
	      // Manually update layout
	      var res = linesLayout.reset(seriesModel);
	
	      if (res.progress) {
	        res.progress({
	          start: 0,
	          end: data.count()
	        }, data);
	      }
	
	      this._lineDraw.updateLayout();
	
	      this._clearLayer(api);
	    }
	  },
	  _updateLineDraw: function (data, seriesModel) {
	    var lineDraw = this._lineDraw;
	
	    var hasEffect = this._showEffect(seriesModel);
	
	    var isPolyline = !!seriesModel.get('polyline');
	    var pipelineContext = seriesModel.pipelineContext;
	    var isLargeDraw = pipelineContext.large;
	
	    if (!lineDraw || hasEffect !== this._hasEffet || isPolyline !== this._isPolyline || isLargeDraw !== this._isLargeDraw) {
	      if (lineDraw) {
	        lineDraw.remove();
	      }
	
	      lineDraw = this._lineDraw = isLargeDraw ? new LargeLineDraw() : new LineDraw(isPolyline ? hasEffect ? EffectPolyline : Polyline : hasEffect ? EffectLine : Line);
	      this._hasEffet = hasEffect;
	      this._isPolyline = isPolyline;
	      this._isLargeDraw = isLargeDraw;
	      this.group.removeAll();
	    }
	
	    this.group.add(lineDraw.group);
	    return lineDraw;
	  },
	  _showEffect: function (seriesModel) {
	    return !!seriesModel.get('effect.show');
	  },
	  _clearLayer: function (api) {
	    // Not use motion when dragging or zooming
	    var zr = api.getZr();
	    var isSvg = zr.painter.getType() === 'svg';
	
	    if (!isSvg && this._lastZlevel != null) {
	      zr.painter.getLayer(this._lastZlevel).clear(true);
	    }
	  },
	  remove: function (ecModel, api) {
	    this._lineDraw && this._lineDraw.remove();
	    this._lineDraw = null; // Clear motion when lineDraw is removed
	
	    this._clearLayer(api);
	  },
	  dispose: function () {}
	});
	
	module.exports = _default;

/***/ },
/* 1511 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function normalize(a) {
	  if (!(a instanceof Array)) {
	    a = [a, a];
	  }
	
	  return a;
	}
	
	var opacityQuery = 'lineStyle.opacity'.split('.');
	var _default = {
	  seriesType: 'lines',
	  reset: function (seriesModel, ecModel, api) {
	    var symbolType = normalize(seriesModel.get('symbol'));
	    var symbolSize = normalize(seriesModel.get('symbolSize'));
	    var data = seriesModel.getData();
	    data.setVisual('fromSymbol', symbolType && symbolType[0]);
	    data.setVisual('toSymbol', symbolType && symbolType[1]);
	    data.setVisual('fromSymbolSize', symbolSize && symbolSize[0]);
	    data.setVisual('toSymbolSize', symbolSize && symbolSize[1]);
	    data.setVisual('opacity', seriesModel.get(opacityQuery));
	
	    function dataEach(data, idx) {
	      var itemModel = data.getItemModel(idx);
	      var symbolType = normalize(itemModel.getShallow('symbol', true));
	      var symbolSize = normalize(itemModel.getShallow('symbolSize', true));
	      var opacity = itemModel.get(opacityQuery);
	      symbolType[0] && data.setItemVisual(idx, 'fromSymbol', symbolType[0]);
	      symbolType[1] && data.setItemVisual(idx, 'toSymbol', symbolType[1]);
	      symbolSize[0] && data.setItemVisual(idx, 'fromSymbolSize', symbolSize[0]);
	      symbolSize[1] && data.setItemVisual(idx, 'toSymbolSize', symbolSize[1]);
	      data.setItemVisual(idx, 'opacity', opacity);
	    }
	
	    return {
	      dataEach: data.hasItemOption ? dataEach : null
	    };
	  }
	};
	module.exports = _default;

/***/ },
/* 1512 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	__webpack_require__(1513);
	
	__webpack_require__(1514);
	
	__webpack_require__(695);
	
	__webpack_require__(471);
	
	var mapSymbolLayout = __webpack_require__(1517);
	
	var mapVisual = __webpack_require__(1518);
	
	var mapDataStatistic = __webpack_require__(1516);
	
	var backwardCompat = __webpack_require__(1515);
	
	var createDataSelectAction = __webpack_require__(694);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerLayout(mapSymbolLayout);
	echarts.registerVisual(mapVisual);
	echarts.registerProcessor(echarts.PRIORITY.PROCESSOR.STATISTIC, mapDataStatistic);
	echarts.registerPreprocessor(backwardCompat);
	createDataSelectAction('map', [{
	  type: 'mapToggleSelect',
	  event: 'mapselectchanged',
	  method: 'toggleSelected'
	}, {
	  type: 'mapSelect',
	  event: 'mapselected',
	  method: 'select'
	}, {
	  type: 'mapUnSelect',
	  event: 'mapunselected',
	  method: 'unSelect'
	}]);

/***/ },
/* 1513 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var createListSimply = __webpack_require__(201);
	
	var SeriesModel = __webpack_require__(58);
	
	var _format = __webpack_require__(40);
	
	var encodeHTML = _format.encodeHTML;
	var addCommas = _format.addCommas;
	
	var dataSelectableMixin = __webpack_require__(465);
	
	var _dataProvider = __webpack_require__(167);
	
	var retrieveRawAttr = _dataProvider.retrieveRawAttr;
	
	var geoSourceManager = __webpack_require__(336);
	
	var _sourceHelper = __webpack_require__(123);
	
	var makeSeriesEncodeForNameBased = _sourceHelper.makeSeriesEncodeForNameBased;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var MapSeries = SeriesModel.extend({
	  type: 'series.map',
	  dependencies: ['geo'],
	  layoutMode: 'box',
	
	  /**
	   * Only first map series of same mapType will drawMap
	   * @type {boolean}
	   */
	  needsDrawMap: false,
	
	  /**
	   * Group of all map series with same mapType
	   * @type {boolean}
	   */
	  seriesGroup: [],
	  getInitialData: function (option) {
	    var data = createListSimply(this, {
	      coordDimensions: ['value'],
	      encodeDefaulter: zrUtil.curry(makeSeriesEncodeForNameBased, this)
	    });
	    var valueDim = data.mapDimension('value');
	    var dataNameMap = zrUtil.createHashMap();
	    var selectTargetList = [];
	    var toAppendNames = [];
	
	    for (var i = 0, len = data.count(); i < len; i++) {
	      var name = data.getName(i);
	      dataNameMap.set(name, true);
	      selectTargetList.push({
	        name: name,
	        value: data.get(valueDim, i),
	        selected: retrieveRawAttr(data, i, 'selected')
	      });
	    }
	
	    var geoSource = geoSourceManager.load(this.getMapType(), this.option.nameMap, this.option.nameProperty);
	    zrUtil.each(geoSource.regions, function (region) {
	      var name = region.name;
	
	      if (!dataNameMap.get(name)) {
	        selectTargetList.push({
	          name: name
	        });
	        toAppendNames.push(name);
	      }
	    });
	    this.updateSelectedMap(selectTargetList); // Complete data with missing regions. The consequent processes (like visual
	    // map and render) can not be performed without a "full data". For example,
	    // find `dataIndex` by name.
	
	    data.appendValues([], toAppendNames);
	    return data;
	  },
	
	  /**
	   * If no host geo model, return null, which means using a
	   * inner exclusive geo model.
	   */
	  getHostGeoModel: function () {
	    var geoIndex = this.option.geoIndex;
	    return geoIndex != null ? this.dependentModels.geo[geoIndex] : null;
	  },
	  getMapType: function () {
	    return (this.getHostGeoModel() || this).option.map;
	  },
	  // _fillOption: function (option, mapName) {
	  // Shallow clone
	  // option = zrUtil.extend({}, option);
	  // option.data = geoCreator.getFilledRegions(option.data, mapName, option.nameMap);
	  // return option;
	  // },
	  getRawValue: function (dataIndex) {
	    // Use value stored in data instead because it is calculated from multiple series
	    // FIXME Provide all value of multiple series ?
	    var data = this.getData();
	    return data.get(data.mapDimension('value'), dataIndex);
	  },
	
	  /**
	   * Get model of region
	   * @param  {string} name
	   * @return {module:echarts/model/Model}
	   */
	  getRegionModel: function (regionName) {
	    var data = this.getData();
	    return data.getItemModel(data.indexOfName(regionName));
	  },
	
	  /**
	   * Map tooltip formatter
	   *
	   * @param {number} dataIndex
	   */
	  formatTooltip: function (dataIndex, multipleSeries, dataType, renderMode) {
	    // FIXME orignalData and data is a bit confusing
	    var data = this.getData();
	    var formattedValue = addCommas(this.getRawValue(dataIndex));
	    var name = data.getName(dataIndex);
	    var seriesGroup = this.seriesGroup;
	    var seriesNames = [];
	
	    for (var i = 0; i < seriesGroup.length; i++) {
	      var otherIndex = seriesGroup[i].originalData.indexOfName(name);
	      var valueDim = data.mapDimension('value');
	
	      if (!isNaN(seriesGroup[i].originalData.get(valueDim, otherIndex))) {
	        seriesNames.push(encodeHTML(seriesGroup[i].name));
	      }
	    }
	
	    var newLine = renderMode === 'html' ? '<br/>' : '\n';
	    return seriesNames.join(', ') + newLine + encodeHTML(name + ' : ' + formattedValue);
	  },
	
	  /**
	   * @implement
	   */
	  getTooltipPosition: function (dataIndex) {
	    if (dataIndex != null) {
	      var name = this.getData().getName(dataIndex);
	      var geo = this.coordinateSystem;
	      var region = geo.getRegion(name);
	      return region && geo.dataToPoint(region.center);
	    }
	  },
	  setZoom: function (zoom) {
	    this.option.zoom = zoom;
	  },
	  setCenter: function (center) {
	    this.option.center = center;
	  },
	  defaultOption: {
	    // 一级层叠
	    zlevel: 0,
	    // 二级层叠
	    z: 2,
	    coordinateSystem: 'geo',
	    // map should be explicitly specified since ec3.
	    map: '',
	    // If `geoIndex` is not specified, a exclusive geo will be
	    // created. Otherwise use the specified geo component, and
	    // `map` and `mapType` are ignored.
	    // geoIndex: 0,
	    // 'center' | 'left' | 'right' | 'x%' | {number}
	    left: 'center',
	    // 'center' | 'top' | 'bottom' | 'x%' | {number}
	    top: 'center',
	    // right
	    // bottom
	    // width:
	    // height
	    // Aspect is width / height. Inited to be geoJson bbox aspect
	    // This parameter is used for scale this aspect
	    aspectScale: 0.75,
	    ///// Layout with center and size
	    // If you wan't to put map in a fixed size box with right aspect ratio
	    // This two properties may more conveninet
	    // layoutCenter: [50%, 50%]
	    // layoutSize: 100
	    // 数值合并方式，默认加和，可选为：
	    // 'sum' | 'average' | 'max' | 'min'
	    // mapValueCalculation: 'sum',
	    // 地图数值计算结果小数精度
	    // mapValuePrecision: 0,
	    // 显示图例颜色标识（系列标识的小圆点），图例开启时有效
	    showLegendSymbol: true,
	    // 选择模式，默认关闭，可选single，multiple
	    // selectedMode: false,
	    dataRangeHoverLink: true,
	    // 是否开启缩放及漫游模式
	    // roam: false,
	    // Define left-top, right-bottom coords to control view
	    // For example, [ [180, 90], [-180, -90] ],
	    // higher priority than center and zoom
	    boundingCoords: null,
	    // Default on center of map
	    center: null,
	    zoom: 1,
	    scaleLimit: null,
	    label: {
	      show: false,
	      color: '#000'
	    },
	    // scaleLimit: null,
	    itemStyle: {
	      borderWidth: 0.5,
	      borderColor: '#444',
	      areaColor: '#eee'
	    },
	    emphasis: {
	      label: {
	        show: true,
	        color: 'rgb(100,0,0)'
	      },
	      itemStyle: {
	        areaColor: 'rgba(255,215,0,0.8)'
	      }
	    },
	    nameProperty: 'name'
	  }
	});
	zrUtil.mixin(MapSeries, dataSelectableMixin);
	var _default = MapSeries;
	module.exports = _default;

/***/ },
/* 1514 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var graphic = __webpack_require__(16);
	
	var MapDraw = __webpack_require__(719);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var HIGH_DOWN_PROP = '__seriesMapHighDown';
	var RECORD_VERSION_PROP = '__seriesMapCallKey';
	
	var _default = echarts.extendChartView({
	  type: 'map',
	  render: function (mapModel, ecModel, api, payload) {
	    // Not render if it is an toggleSelect action from self
	    if (payload && payload.type === 'mapToggleSelect' && payload.from === this.uid) {
	      return;
	    }
	
	    var group = this.group;
	    group.removeAll();
	
	    if (mapModel.getHostGeoModel()) {
	      return;
	    } // Not update map if it is an roam action from self
	
	
	    if (!(payload && payload.type === 'geoRoam' && payload.componentType === 'series' && payload.seriesId === mapModel.id)) {
	      if (mapModel.needsDrawMap) {
	        var mapDraw = this._mapDraw || new MapDraw(api, true);
	        group.add(mapDraw.group);
	        mapDraw.draw(mapModel, ecModel, api, this, payload);
	        this._mapDraw = mapDraw;
	      } else {
	        // Remove drawed map
	        this._mapDraw && this._mapDraw.remove();
	        this._mapDraw = null;
	      }
	    } else {
	      var mapDraw = this._mapDraw;
	      mapDraw && group.add(mapDraw.group);
	    }
	
	    mapModel.get('showLegendSymbol') && ecModel.getComponent('legend') && this._renderSymbols(mapModel, ecModel, api);
	  },
	  remove: function () {
	    this._mapDraw && this._mapDraw.remove();
	    this._mapDraw = null;
	    this.group.removeAll();
	  },
	  dispose: function () {
	    this._mapDraw && this._mapDraw.remove();
	    this._mapDraw = null;
	  },
	  _renderSymbols: function (mapModel, ecModel, api) {
	    var originalData = mapModel.originalData;
	    var group = this.group;
	    originalData.each(originalData.mapDimension('value'), function (value, originalDataIndex) {
	      if (isNaN(value)) {
	        return;
	      }
	
	      var layout = originalData.getItemLayout(originalDataIndex);
	
	      if (!layout || !layout.point) {
	        // Not exists in map
	        return;
	      }
	
	      var point = layout.point;
	      var offset = layout.offset;
	      var circle = new graphic.Circle({
	        style: {
	          // Because the special of map draw.
	          // Which needs statistic of multiple series and draw on one map.
	          // And each series also need a symbol with legend color
	          //
	          // Layout and visual are put one the different data
	          fill: mapModel.getData().getVisual('color')
	        },
	        shape: {
	          cx: point[0] + offset * 9,
	          cy: point[1],
	          r: 3
	        },
	        silent: true,
	        // Do not overlap the first series, on which labels are displayed.
	        z2: 8 + (!offset ? graphic.Z2_EMPHASIS_LIFT + 1 : 0)
	      }); // Only the series that has the first value on the same region is in charge of rendering the label.
	      // But consider the case:
	      // series: [
	      //     {id: 'X', type: 'map', map: 'm', {data: [{name: 'A', value: 11}, {name: 'B', {value: 22}]},
	      //     {id: 'Y', type: 'map', map: 'm', {data: [{name: 'A', value: 21}, {name: 'C', {value: 33}]}
	      // ]
	      // The offset `0` of item `A` is at series `X`, but of item `C` is at series `Y`.
	      // For backward compatibility, we follow the rule that render label `A` by the
	      // settings on series `X` but render label `C` by the settings on series `Y`.
	
	      if (!offset) {
	        var fullData = mapModel.mainSeries.getData();
	        var name = originalData.getName(originalDataIndex);
	        var fullIndex = fullData.indexOfName(name);
	        var itemModel = originalData.getItemModel(originalDataIndex);
	        var labelModel = itemModel.getModel('label');
	        var hoverLabelModel = itemModel.getModel('emphasis.label');
	        var regionGroup = fullData.getItemGraphicEl(fullIndex); // `getFormattedLabel` needs to use `getData` inside. Here
	        // `mapModel.getData()` is shallow cloned from `mainSeries.getData()`.
	        // FIXME
	        // If this is not the `mainSeries`, the item model (like label formatter)
	        // set on original data item will never get. But it has been working
	        // like that from the begining, and this scenario is rarely encountered.
	        // So it won't be fixed until have to.
	
	        var normalText = zrUtil.retrieve2(mapModel.getFormattedLabel(fullIndex, 'normal'), name);
	        var emphasisText = zrUtil.retrieve2(mapModel.getFormattedLabel(fullIndex, 'emphasis'), normalText);
	        var highDownRecord = regionGroup[HIGH_DOWN_PROP];
	        var recordVersion = Math.random(); // Prevent from register listeners duplicatedly when roaming.
	
	        if (!highDownRecord) {
	          highDownRecord = regionGroup[HIGH_DOWN_PROP] = {};
	          var onEmphasis = zrUtil.curry(onRegionHighDown, true);
	          var onNormal = zrUtil.curry(onRegionHighDown, false);
	          regionGroup.on('mouseover', onEmphasis).on('mouseout', onNormal).on('emphasis', onEmphasis).on('normal', onNormal);
	        } // Prevent removed regions effect current grapics.
	
	
	        regionGroup[RECORD_VERSION_PROP] = recordVersion;
	        zrUtil.extend(highDownRecord, {
	          recordVersion: recordVersion,
	          circle: circle,
	          labelModel: labelModel,
	          hoverLabelModel: hoverLabelModel,
	          emphasisText: emphasisText,
	          normalText: normalText
	        }); // FIXME
	        // Consider set option when emphasis.
	
	        enterRegionHighDown(highDownRecord, false);
	      }
	
	      group.add(circle);
	    });
	  }
	});
	
	function onRegionHighDown(toHighOrDown) {
	  var highDownRecord = this[HIGH_DOWN_PROP];
	
	  if (highDownRecord && highDownRecord.recordVersion === this[RECORD_VERSION_PROP]) {
	    enterRegionHighDown(highDownRecord, toHighOrDown);
	  }
	}
	
	function enterRegionHighDown(highDownRecord, toHighOrDown) {
	  var circle = highDownRecord.circle;
	  var labelModel = highDownRecord.labelModel;
	  var hoverLabelModel = highDownRecord.hoverLabelModel;
	  var emphasisText = highDownRecord.emphasisText;
	  var normalText = highDownRecord.normalText;
	
	  if (toHighOrDown) {
	    circle.style.extendFrom(graphic.setTextStyle({}, hoverLabelModel, {
	      text: hoverLabelModel.get('show') ? emphasisText : null
	    }, {
	      isRectText: true,
	      useInsideStyle: false
	    }, true)); // Make label upper than others if overlaps.
	
	    circle.__mapOriginalZ2 = circle.z2;
	    circle.z2 += graphic.Z2_EMPHASIS_LIFT;
	  } else {
	    graphic.setTextStyle(circle.style, labelModel, {
	      text: labelModel.get('show') ? normalText : null,
	      textPosition: labelModel.getShallow('position') || 'bottom'
	    }, {
	      isRectText: true,
	      useInsideStyle: false
	    }); // Trigger normalize style like padding.
	
	    circle.dirty(false);
	
	    if (circle.__mapOriginalZ2 != null) {
	      circle.z2 = circle.__mapOriginalZ2;
	      circle.__mapOriginalZ2 = null;
	    }
	  }
	}
	
	module.exports = _default;

/***/ },
/* 1515 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(option) {
	  // Save geoCoord
	  var mapSeries = [];
	  zrUtil.each(option.series, function (seriesOpt) {
	    if (seriesOpt && seriesOpt.type === 'map') {
	      mapSeries.push(seriesOpt);
	      seriesOpt.map = seriesOpt.map || seriesOpt.mapType; // Put x, y, width, height, x2, y2 in the top level
	
	      zrUtil.defaults(seriesOpt, seriesOpt.mapLocation);
	    }
	  });
	}
	
	module.exports = _default;

/***/ },
/* 1516 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// FIXME 公用？
	
	/**
	 * @param {Array.<module:echarts/data/List>} datas
	 * @param {string} statisticType 'average' 'sum'
	 * @inner
	 */
	function dataStatistics(datas, statisticType) {
	  var dataNameMap = {};
	  zrUtil.each(datas, function (data) {
	    data.each(data.mapDimension('value'), function (value, idx) {
	      // Add prefix to avoid conflict with Object.prototype.
	      var mapKey = 'ec-' + data.getName(idx);
	      dataNameMap[mapKey] = dataNameMap[mapKey] || [];
	
	      if (!isNaN(value)) {
	        dataNameMap[mapKey].push(value);
	      }
	    });
	  });
	  return datas[0].map(datas[0].mapDimension('value'), function (value, idx) {
	    var mapKey = 'ec-' + datas[0].getName(idx);
	    var sum = 0;
	    var min = Infinity;
	    var max = -Infinity;
	    var len = dataNameMap[mapKey].length;
	
	    for (var i = 0; i < len; i++) {
	      min = Math.min(min, dataNameMap[mapKey][i]);
	      max = Math.max(max, dataNameMap[mapKey][i]);
	      sum += dataNameMap[mapKey][i];
	    }
	
	    var result;
	
	    if (statisticType === 'min') {
	      result = min;
	    } else if (statisticType === 'max') {
	      result = max;
	    } else if (statisticType === 'average') {
	      result = sum / len;
	    } else {
	      result = sum;
	    }
	
	    return len === 0 ? NaN : result;
	  });
	}
	
	function _default(ecModel) {
	  var seriesGroups = {};
	  ecModel.eachSeriesByType('map', function (seriesModel) {
	    var hostGeoModel = seriesModel.getHostGeoModel();
	    var key = hostGeoModel ? 'o' + hostGeoModel.id : 'i' + seriesModel.getMapType();
	    (seriesGroups[key] = seriesGroups[key] || []).push(seriesModel);
	  });
	  zrUtil.each(seriesGroups, function (seriesList, key) {
	    var data = dataStatistics(zrUtil.map(seriesList, function (seriesModel) {
	      return seriesModel.getData();
	    }), seriesList[0].get('mapValueCalculation'));
	
	    for (var i = 0; i < seriesList.length; i++) {
	      seriesList[i].originalData = seriesList[i].getData();
	    } // FIXME Put where?
	
	
	    for (var i = 0; i < seriesList.length; i++) {
	      seriesList[i].seriesGroup = seriesList;
	      seriesList[i].needsDrawMap = i === 0 && !seriesList[i].getHostGeoModel();
	      seriesList[i].setData(data.cloneShallow());
	      seriesList[i].mainSeries = seriesList[0];
	    }
	  });
	}
	
	module.exports = _default;

/***/ },
/* 1517 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  var processedMapType = {};
	  ecModel.eachSeriesByType('map', function (mapSeries) {
	    var mapType = mapSeries.getMapType();
	
	    if (mapSeries.getHostGeoModel() || processedMapType[mapType]) {
	      return;
	    }
	
	    var mapSymbolOffsets = {};
	    zrUtil.each(mapSeries.seriesGroup, function (subMapSeries) {
	      var geo = subMapSeries.coordinateSystem;
	      var data = subMapSeries.originalData;
	
	      if (subMapSeries.get('showLegendSymbol') && ecModel.getComponent('legend')) {
	        data.each(data.mapDimension('value'), function (value, idx) {
	          var name = data.getName(idx);
	          var region = geo.getRegion(name); // If input series.data is [11, 22, '-'/null/undefined, 44],
	          // it will be filled with NaN: [11, 22, NaN, 44] and NaN will
	          // not be drawn. So here must validate if value is NaN.
	
	          if (!region || isNaN(value)) {
	            return;
	          }
	
	          var offset = mapSymbolOffsets[name] || 0;
	          var point = geo.dataToPoint(region.center);
	          mapSymbolOffsets[name] = offset + 1;
	          data.setItemLayout(idx, {
	            point: point,
	            offset: offset
	          });
	        });
	      }
	    }); // Show label of those region not has legendSymbol(which is offset 0)
	
	    var data = mapSeries.getData();
	    data.each(function (idx) {
	      var name = data.getName(idx);
	      var layout = data.getItemLayout(idx) || {};
	      layout.showLabel = !mapSymbolOffsets[name];
	      data.setItemLayout(idx, layout);
	    });
	    processedMapType[mapType] = true;
	  });
	}
	
	module.exports = _default;

/***/ },
/* 1518 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  ecModel.eachSeriesByType('map', function (seriesModel) {
	    var colorList = seriesModel.get('color');
	    var itemStyleModel = seriesModel.getModel('itemStyle');
	    var areaColor = itemStyleModel.get('areaColor');
	    var color = itemStyleModel.get('color') || colorList[seriesModel.seriesIndex % colorList.length];
	    seriesModel.getData().setVisual({
	      'areaColor': areaColor,
	      'color': color
	    });
	  });
	}
	
	module.exports = _default;

/***/ },
/* 1519 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	__webpack_require__(726);
	
	__webpack_require__(1520);
	
	__webpack_require__(1521);
	
	var parallelVisual = __webpack_require__(1522);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(parallelVisual);

/***/ },
/* 1520 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(3);
	
	var each = _util.each;
	var createHashMap = _util.createHashMap;
	
	var SeriesModel = __webpack_require__(58);
	
	var createListFromArray = __webpack_require__(122);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.parallel',
	  dependencies: ['parallel'],
	  visualColorAccessPath: 'lineStyle.color',
	  getInitialData: function (option, ecModel) {
	    var source = this.getSource();
	    setEncodeAndDimensions(source, this);
	    return createListFromArray(source, this);
	  },
	
	  /**
	   * User can get data raw indices on 'axisAreaSelected' event received.
	   *
	   * @public
	   * @param {string} activeState 'active' or 'inactive' or 'normal'
	   * @return {Array.<number>} Raw indices
	   */
	  getRawIndicesByActiveState: function (activeState) {
	    var coordSys = this.coordinateSystem;
	    var data = this.getData();
	    var indices = [];
	    coordSys.eachActiveState(data, function (theActiveState, dataIndex) {
	      if (activeState === theActiveState) {
	        indices.push(data.getRawIndex(dataIndex));
	      }
	    });
	    return indices;
	  },
	  defaultOption: {
	    zlevel: 0,
	    // 一级层叠
	    z: 2,
	    // 二级层叠
	    coordinateSystem: 'parallel',
	    parallelIndex: 0,
	    label: {
	      show: false
	    },
	    inactiveOpacity: 0.05,
	    activeOpacity: 1,
	    lineStyle: {
	      width: 1,
	      opacity: 0.45,
	      type: 'solid'
	    },
	    emphasis: {
	      label: {
	        show: false
	      }
	    },
	    progressive: 500,
	    smooth: false,
	    // true | false | number
	    animationEasing: 'linear'
	  }
	});
	
	function setEncodeAndDimensions(source, seriesModel) {
	  // The mapping of parallelAxis dimension to data dimension can
	  // be specified in parallelAxis.option.dim. For example, if
	  // parallelAxis.option.dim is 'dim3', it mapping to the third
	  // dimension of data. But `data.encode` has higher priority.
	  // Moreover, parallelModel.dimension should not be regarded as data
	  // dimensions. Consider dimensions = ['dim4', 'dim2', 'dim6'];
	  if (source.encodeDefine) {
	    return;
	  }
	
	  var parallelModel = seriesModel.ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));
	
	  if (!parallelModel) {
	    return;
	  }
	
	  var encodeDefine = source.encodeDefine = createHashMap();
	  each(parallelModel.dimensions, function (axisDim) {
	    var dataDimIndex = convertDimNameToNumber(axisDim);
	    encodeDefine.set(axisDim, dataDimIndex);
	  });
	}
	
	function convertDimNameToNumber(dimName) {
	  return +dimName.replace('dim', '');
	}
	
	module.exports = _default;

/***/ },
/* 1521 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(16);
	
	var ChartView = __webpack_require__(106);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var DEFAULT_SMOOTH = 0.3;
	var ParallelView = ChartView.extend({
	  type: 'parallel',
	  init: function () {
	    /**
	     * @type {module:zrender/container/Group}
	     * @private
	     */
	    this._dataGroup = new graphic.Group();
	    this.group.add(this._dataGroup);
	    /**
	     * @type {module:echarts/data/List}
	     */
	
	    this._data;
	    /**
	     * @type {boolean}
	     */
	
	    this._initialized;
	  },
	
	  /**
	   * @override
	   */
	  render: function (seriesModel, ecModel, api, payload) {
	    var dataGroup = this._dataGroup;
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var coordSys = seriesModel.coordinateSystem;
	    var dimensions = coordSys.dimensions;
	    var seriesScope = makeSeriesScope(seriesModel);
	    data.diff(oldData).add(add).update(update).remove(remove).execute();
	
	    function add(newDataIndex) {
	      var line = addEl(data, dataGroup, newDataIndex, dimensions, coordSys);
	      updateElCommon(line, data, newDataIndex, seriesScope);
	    }
	
	    function update(newDataIndex, oldDataIndex) {
	      var line = oldData.getItemGraphicEl(oldDataIndex);
	      var points = createLinePoints(data, newDataIndex, dimensions, coordSys);
	      data.setItemGraphicEl(newDataIndex, line);
	      var animationModel = payload && payload.animation === false ? null : seriesModel;
	      graphic.updateProps(line, {
	        shape: {
	          points: points
	        }
	      }, animationModel, newDataIndex);
	      updateElCommon(line, data, newDataIndex, seriesScope);
	    }
	
	    function remove(oldDataIndex) {
	      var line = oldData.getItemGraphicEl(oldDataIndex);
	      dataGroup.remove(line);
	    } // First create
	
	
	    if (!this._initialized) {
	      this._initialized = true;
	      var clipPath = createGridClipShape(coordSys, seriesModel, function () {
	        // Callback will be invoked immediately if there is no animation
	        setTimeout(function () {
	          dataGroup.removeClipPath();
	        });
	      });
	      dataGroup.setClipPath(clipPath);
	    }
	
	    this._data = data;
	  },
	  incrementalPrepareRender: function (seriesModel, ecModel, api) {
	    this._initialized = true;
	    this._data = null;
	
	    this._dataGroup.removeAll();
	  },
	  incrementalRender: function (taskParams, seriesModel, ecModel) {
	    var data = seriesModel.getData();
	    var coordSys = seriesModel.coordinateSystem;
	    var dimensions = coordSys.dimensions;
	    var seriesScope = makeSeriesScope(seriesModel);
	
	    for (var dataIndex = taskParams.start; dataIndex < taskParams.end; dataIndex++) {
	      var line = addEl(data, this._dataGroup, dataIndex, dimensions, coordSys);
	      line.incremental = true;
	      updateElCommon(line, data, dataIndex, seriesScope);
	    }
	  },
	  dispose: function () {},
	  // _renderForProgressive: function (seriesModel) {
	  //     var dataGroup = this._dataGroup;
	  //     var data = seriesModel.getData();
	  //     var oldData = this._data;
	  //     var coordSys = seriesModel.coordinateSystem;
	  //     var dimensions = coordSys.dimensions;
	  //     var option = seriesModel.option;
	  //     var progressive = option.progressive;
	  //     var smooth = option.smooth ? SMOOTH : null;
	  //     // In progressive animation is disabled, so use simple data diff,
	  //     // which effects performance less.
	  //     // (Typically performance for data with length 7000+ like:
	  //     // simpleDiff: 60ms, addEl: 184ms,
	  //     // in RMBP 2.4GHz intel i7, OSX 10.9 chrome 50.0.2661.102 (64-bit))
	  //     if (simpleDiff(oldData, data, dimensions)) {
	  //         dataGroup.removeAll();
	  //         data.each(function (dataIndex) {
	  //             addEl(data, dataGroup, dataIndex, dimensions, coordSys);
	  //         });
	  //     }
	  //     updateElCommon(data, progressive, smooth);
	  //     // Consider switch between progressive and not.
	  //     data.__plProgressive = true;
	  //     this._data = data;
	  // },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    this._dataGroup && this._dataGroup.removeAll();
	    this._data = null;
	  }
	});
	
	function createGridClipShape(coordSys, seriesModel, cb) {
	  var parallelModel = coordSys.model;
	  var rect = coordSys.getRect();
	  var rectEl = new graphic.Rect({
	    shape: {
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height
	    }
	  });
	  var dim = parallelModel.get('layout') === 'horizontal' ? 'width' : 'height';
	  rectEl.setShape(dim, 0);
	  graphic.initProps(rectEl, {
	    shape: {
	      width: rect.width,
	      height: rect.height
	    }
	  }, seriesModel, cb);
	  return rectEl;
	}
	
	function createLinePoints(data, dataIndex, dimensions, coordSys) {
	  var points = [];
	
	  for (var i = 0; i < dimensions.length; i++) {
	    var dimName = dimensions[i];
	    var value = data.get(data.mapDimension(dimName), dataIndex);
	
	    if (!isEmptyValue(value, coordSys.getAxis(dimName).type)) {
	      points.push(coordSys.dataToPoint(value, dimName));
	    }
	  }
	
	  return points;
	}
	
	function addEl(data, dataGroup, dataIndex, dimensions, coordSys) {
	  var points = createLinePoints(data, dataIndex, dimensions, coordSys);
	  var line = new graphic.Polyline({
	    shape: {
	      points: points
	    },
	    silent: true,
	    z2: 10
	  });
	  dataGroup.add(line);
	  data.setItemGraphicEl(dataIndex, line);
	  return line;
	}
	
	function makeSeriesScope(seriesModel) {
	  var smooth = seriesModel.get('smooth', true);
	  smooth === true && (smooth = DEFAULT_SMOOTH);
	  return {
	    lineStyle: seriesModel.getModel('lineStyle').getLineStyle(),
	    smooth: smooth != null ? smooth : DEFAULT_SMOOTH
	  };
	}
	
	function updateElCommon(el, data, dataIndex, seriesScope) {
	  var lineStyle = seriesScope.lineStyle;
	
	  if (data.hasItemOption) {
	    var lineStyleModel = data.getItemModel(dataIndex).getModel('lineStyle');
	    lineStyle = lineStyleModel.getLineStyle();
	  }
	
	  el.useStyle(lineStyle);
	  var elStyle = el.style;
	  elStyle.fill = null; // lineStyle.color have been set to itemVisual in module:echarts/visual/seriesColor.
	
	  elStyle.stroke = data.getItemVisual(dataIndex, 'color'); // lineStyle.opacity have been set to itemVisual in parallelVisual.
	
	  elStyle.opacity = data.getItemVisual(dataIndex, 'opacity');
	  seriesScope.smooth && (el.shape.smooth = seriesScope.smooth);
	} // function simpleDiff(oldData, newData, dimensions) {
	//     var oldLen;
	//     if (!oldData
	//         || !oldData.__plProgressive
	//         || (oldLen = oldData.count()) !== newData.count()
	//     ) {
	//         return true;
	//     }
	//     var dimLen = dimensions.length;
	//     for (var i = 0; i < oldLen; i++) {
	//         for (var j = 0; j < dimLen; j++) {
	//             if (oldData.get(dimensions[j], i) !== newData.get(dimensions[j], i)) {
	//                 return true;
	//             }
	//         }
	//     }
	//     return false;
	// }
	// FIXME
	// 公用方法?
	
	
	function isEmptyValue(val, axisType) {
	  return axisType === 'category' ? val == null : val == null || isNaN(val); // axisType === 'value'
	}
	
	var _default = ParallelView;
	module.exports = _default;

/***/ },
/* 1522 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var opacityAccessPath = ['lineStyle', 'normal', 'opacity'];
	var _default = {
	  seriesType: 'parallel',
	  reset: function (seriesModel, ecModel, api) {
	    var itemStyleModel = seriesModel.getModel('itemStyle');
	    var lineStyleModel = seriesModel.getModel('lineStyle');
	    var globalColors = ecModel.get('color');
	    var color = lineStyleModel.get('color') || itemStyleModel.get('color') || globalColors[seriesModel.seriesIndex % globalColors.length];
	    var inactiveOpacity = seriesModel.get('inactiveOpacity');
	    var activeOpacity = seriesModel.get('activeOpacity');
	    var lineStyle = seriesModel.getModel('lineStyle').getLineStyle();
	    var coordSys = seriesModel.coordinateSystem;
	    var data = seriesModel.getData();
	    var opacityMap = {
	      normal: lineStyle.opacity,
	      active: activeOpacity,
	      inactive: inactiveOpacity
	    };
	    data.setVisual('color', color);
	
	    function progress(params, data) {
	      coordSys.eachActiveState(data, function (activeState, dataIndex) {
	        var opacity = opacityMap[activeState];
	
	        if (activeState === 'normal' && data.hasItemOption) {
	          var itemOpacity = data.getItemModel(dataIndex).get(opacityAccessPath, true);
	          itemOpacity != null && (opacity = itemOpacity);
	        }
	
	        data.setItemVisual(dataIndex, 'opacity', opacity);
	      }, params.start, params.end);
	    }
	
	    return {
	      progress: progress
	    };
	  }
	};
	module.exports = _default;

/***/ },
/* 1523 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	__webpack_require__(470);
	
	__webpack_require__(1456);
	
	__webpack_require__(1457);
	
	var _barGrid = __webpack_require__(337);
	
	var layout = _barGrid.layout;
	
	var visualSymbol = __webpack_require__(169);
	
	__webpack_require__(261);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// In case developer forget to include grid component
	echarts.registerLayout(zrUtil.curry(layout, 'pictorialBar'));
	echarts.registerVisual(visualSymbol('pictorialBar', 'roundRect'));

/***/ },
/* 1524 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	__webpack_require__(1525);
	
	__webpack_require__(1526);
	
	var createDataSelectAction = __webpack_require__(694);
	
	var dataColor = __webpack_require__(341);
	
	var pieLayout = __webpack_require__(1528);
	
	var dataFilter = __webpack_require__(267);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	createDataSelectAction('pie', [{
	  type: 'pieToggleSelect',
	  event: 'pieselectchanged',
	  method: 'toggleSelected'
	}, {
	  type: 'pieSelect',
	  event: 'pieselected',
	  method: 'select'
	}, {
	  type: 'pieUnSelect',
	  event: 'pieunselected',
	  method: 'unSelect'
	}]);
	echarts.registerVisual(dataColor('pie'));
	echarts.registerLayout(zrUtil.curry(pieLayout, 'pie'));
	echarts.registerProcessor(dataFilter('pie'));

/***/ },
/* 1525 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var createListSimply = __webpack_require__(201);
	
	var zrUtil = __webpack_require__(3);
	
	var modelUtil = __webpack_require__(24);
	
	var _number = __webpack_require__(20);
	
	var getPercentWithPrecision = _number.getPercentWithPrecision;
	
	var dataSelectableMixin = __webpack_require__(465);
	
	var _dataProvider = __webpack_require__(167);
	
	var retrieveRawAttr = _dataProvider.retrieveRawAttr;
	
	var _sourceHelper = __webpack_require__(123);
	
	var makeSeriesEncodeForNameBased = _sourceHelper.makeSeriesEncodeForNameBased;
	
	var LegendVisualProvider = __webpack_require__(269);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PieSeries = echarts.extendSeriesModel({
	  type: 'series.pie',
	  // Overwrite
	  init: function (option) {
	    PieSeries.superApply(this, 'init', arguments); // Enable legend selection for each data item
	    // Use a function instead of direct access because data reference may changed
	
	    this.legendVisualProvider = new LegendVisualProvider(zrUtil.bind(this.getData, this), zrUtil.bind(this.getRawData, this));
	    this.updateSelectedMap(this._createSelectableList());
	
	    this._defaultLabelLine(option);
	  },
	  // Overwrite
	  mergeOption: function (newOption) {
	    PieSeries.superCall(this, 'mergeOption', newOption);
	    this.updateSelectedMap(this._createSelectableList());
	  },
	  getInitialData: function (option, ecModel) {
	    return createListSimply(this, {
	      coordDimensions: ['value'],
	      encodeDefaulter: zrUtil.curry(makeSeriesEncodeForNameBased, this)
	    });
	  },
	  _createSelectableList: function () {
	    var data = this.getRawData();
	    var valueDim = data.mapDimension('value');
	    var targetList = [];
	
	    for (var i = 0, len = data.count(); i < len; i++) {
	      targetList.push({
	        name: data.getName(i),
	        value: data.get(valueDim, i),
	        selected: retrieveRawAttr(data, i, 'selected')
	      });
	    }
	
	    return targetList;
	  },
	  // Overwrite
	  getDataParams: function (dataIndex) {
	    var data = this.getData();
	    var params = PieSeries.superCall(this, 'getDataParams', dataIndex); // FIXME toFixed?
	
	    var valueList = [];
	    data.each(data.mapDimension('value'), function (value) {
	      valueList.push(value);
	    });
	    params.percent = getPercentWithPrecision(valueList, dataIndex, data.hostModel.get('percentPrecision'));
	    params.$vars.push('percent');
	    return params;
	  },
	  _defaultLabelLine: function (option) {
	    // Extend labelLine emphasis
	    modelUtil.defaultEmphasis(option, 'labelLine', ['show']);
	    var labelLineNormalOpt = option.labelLine;
	    var labelLineEmphasisOpt = option.emphasis.labelLine; // Not show label line if `label.normal.show = false`
	
	    labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
	    labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // 默认全局居中
	    center: ['50%', '50%'],
	    radius: [0, '75%'],
	    // 默认顺时针
	    clockwise: true,
	    startAngle: 90,
	    // 最小角度改为0
	    minAngle: 0,
	    // If the angle of a sector less than `minShowLabelAngle`,
	    // the label will not be displayed.
	    minShowLabelAngle: 0,
	    // 选中时扇区偏移量
	    selectedOffset: 10,
	    // 高亮扇区偏移量
	    hoverOffset: 10,
	    // If use strategy to avoid label overlapping
	    avoidLabelOverlap: true,
	    // 选择模式，默认关闭，可选single，multiple
	    // selectedMode: false,
	    // 南丁格尔玫瑰图模式，'radius'（半径） | 'area'（面积）
	    // roseType: null,
	    percentPrecision: 2,
	    // If still show when all data zero.
	    stillShowZeroSum: true,
	    // cursor: null,
	    left: 0,
	    top: 0,
	    right: 0,
	    bottom: 0,
	    width: null,
	    height: null,
	    label: {
	      // If rotate around circle
	      rotate: false,
	      show: true,
	      // 'outer', 'inside', 'center'
	      position: 'outer',
	      // 'none', 'labelLine', 'edge'. Works only when position is 'outer'
	      alignTo: 'none',
	      // Closest distance between label and chart edge.
	      // Works only position is 'outer' and alignTo is 'edge'.
	      margin: '25%',
	      // Works only position is 'outer' and alignTo is not 'edge'.
	      bleedMargin: 10,
	      // Distance between text and label line.
	      distanceToLabelLine: 5 // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
	      // 默认使用全局文本样式，详见TEXTSTYLE
	      // distance: 当position为inner时有效，为label位置到圆心的距离与圆半径(环状图为内外半径和)的比例系数
	
	    },
	    // Enabled when label.normal.position is 'outer'
	    labelLine: {
	      show: true,
	      // 引导线两段中的第一段长度
	      length: 15,
	      // 引导线两段中的第二段长度
	      length2: 15,
	      smooth: false,
	      lineStyle: {
	        // color: 各异,
	        width: 1,
	        type: 'solid'
	      }
	    },
	    itemStyle: {
	      borderWidth: 1
	    },
	    // Animation type. Valid values: expansion, scale
	    animationType: 'expansion',
	    // Animation type when update. Valid values: transition, expansion
	    animationTypeUpdate: 'transition',
	    animationEasing: 'cubicOut'
	  }
	});
	zrUtil.mixin(PieSeries, dataSelectableMixin);
	var _default = PieSeries;
	module.exports = _default;

/***/ },
/* 1526 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var graphic = __webpack_require__(16);
	
	var ChartView = __webpack_require__(106);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {boolean} hasAnimation
	 * @inner
	 */
	function updateDataSelected(uid, seriesModel, hasAnimation, api) {
	  var data = seriesModel.getData();
	  var dataIndex = this.dataIndex;
	  var name = data.getName(dataIndex);
	  var selectedOffset = seriesModel.get('selectedOffset');
	  api.dispatchAction({
	    type: 'pieToggleSelect',
	    from: uid,
	    name: name,
	    seriesId: seriesModel.id
	  });
	  data.each(function (idx) {
	    toggleItemSelected(data.getItemGraphicEl(idx), data.getItemLayout(idx), seriesModel.isSelected(data.getName(idx)), selectedOffset, hasAnimation);
	  });
	}
	/**
	 * @param {module:zrender/graphic/Sector} el
	 * @param {Object} layout
	 * @param {boolean} isSelected
	 * @param {number} selectedOffset
	 * @param {boolean} hasAnimation
	 * @inner
	 */
	
	
	function toggleItemSelected(el, layout, isSelected, selectedOffset, hasAnimation) {
	  var midAngle = (layout.startAngle + layout.endAngle) / 2;
	  var dx = Math.cos(midAngle);
	  var dy = Math.sin(midAngle);
	  var offset = isSelected ? selectedOffset : 0;
	  var position = [dx * offset, dy * offset];
	  hasAnimation // animateTo will stop revious animation like update transition
	  ? el.animate().when(200, {
	    position: position
	  }).start('bounceOut') : el.attr('position', position);
	}
	/**
	 * Piece of pie including Sector, Label, LabelLine
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 */
	
	
	function PiePiece(data, idx) {
	  graphic.Group.call(this);
	  var sector = new graphic.Sector({
	    z2: 2
	  });
	  var polyline = new graphic.Polyline();
	  var text = new graphic.Text();
	  this.add(sector);
	  this.add(polyline);
	  this.add(text);
	  this.updateData(data, idx, true);
	}
	
	var piePieceProto = PiePiece.prototype;
	
	piePieceProto.updateData = function (data, idx, firstCreate) {
	  var sector = this.childAt(0);
	  var labelLine = this.childAt(1);
	  var labelText = this.childAt(2);
	  var seriesModel = data.hostModel;
	  var itemModel = data.getItemModel(idx);
	  var layout = data.getItemLayout(idx);
	  var sectorShape = zrUtil.extend({}, layout);
	  sectorShape.label = null;
	  var animationTypeUpdate = seriesModel.getShallow('animationTypeUpdate');
	
	  if (firstCreate) {
	    sector.setShape(sectorShape);
	    var animationType = seriesModel.getShallow('animationType');
	
	    if (animationType === 'scale') {
	      sector.shape.r = layout.r0;
	      graphic.initProps(sector, {
	        shape: {
	          r: layout.r
	        }
	      }, seriesModel, idx);
	    } // Expansion
	    else {
	        sector.shape.endAngle = layout.startAngle;
	        graphic.updateProps(sector, {
	          shape: {
	            endAngle: layout.endAngle
	          }
	        }, seriesModel, idx);
	      }
	  } else {
	    if (animationTypeUpdate === 'expansion') {
	      // Sectors are set to be target shape and an overlaying clipPath is used for animation
	      sector.setShape(sectorShape);
	    } else {
	      // Transition animation from the old shape
	      graphic.updateProps(sector, {
	        shape: sectorShape
	      }, seriesModel, idx);
	    }
	  } // Update common style
	
	
	  var visualColor = data.getItemVisual(idx, 'color');
	  sector.useStyle(zrUtil.defaults({
	    lineJoin: 'bevel',
	    fill: visualColor
	  }, itemModel.getModel('itemStyle').getItemStyle()));
	  sector.hoverStyle = itemModel.getModel('emphasis.itemStyle').getItemStyle();
	  var cursorStyle = itemModel.getShallow('cursor');
	  cursorStyle && sector.attr('cursor', cursorStyle); // Toggle selected
	
	  toggleItemSelected(this, data.getItemLayout(idx), seriesModel.isSelected(data.getName(idx)), seriesModel.get('selectedOffset'), seriesModel.get('animation')); // Label and text animation should be applied only for transition type animation when update
	
	  var withAnimation = !firstCreate && animationTypeUpdate === 'transition';
	
	  this._updateLabel(data, idx, withAnimation);
	
	  this.highDownOnUpdate = !seriesModel.get('silent') ? function (fromState, toState) {
	    var hasAnimation = seriesModel.isAnimationEnabled() && itemModel.get('hoverAnimation');
	
	    if (toState === 'emphasis') {
	      labelLine.ignore = labelLine.hoverIgnore;
	      labelText.ignore = labelText.hoverIgnore; // Sector may has animation of updating data. Force to move to the last frame
	      // Or it may stopped on the wrong shape
	
	      if (hasAnimation) {
	        sector.stopAnimation(true);
	        sector.animateTo({
	          shape: {
	            r: layout.r + seriesModel.get('hoverOffset')
	          }
	        }, 300, 'elasticOut');
	      }
	    } else {
	      labelLine.ignore = labelLine.normalIgnore;
	      labelText.ignore = labelText.normalIgnore;
	
	      if (hasAnimation) {
	        sector.stopAnimation(true);
	        sector.animateTo({
	          shape: {
	            r: layout.r
	          }
	        }, 300, 'elasticOut');
	      }
	    }
	  } : null;
	  graphic.setHoverStyle(this);
	};
	
	piePieceProto._updateLabel = function (data, idx, withAnimation) {
	  var labelLine = this.childAt(1);
	  var labelText = this.childAt(2);
	  var seriesModel = data.hostModel;
	  var itemModel = data.getItemModel(idx);
	  var layout = data.getItemLayout(idx);
	  var labelLayout = layout.label;
	  var visualColor = data.getItemVisual(idx, 'color');
	
	  if (!labelLayout || isNaN(labelLayout.x) || isNaN(labelLayout.y)) {
	    labelText.ignore = labelText.normalIgnore = labelText.hoverIgnore = labelLine.ignore = labelLine.normalIgnore = labelLine.hoverIgnore = true;
	    return;
	  }
	
	  var targetLineShape = {
	    points: labelLayout.linePoints || [[labelLayout.x, labelLayout.y], [labelLayout.x, labelLayout.y], [labelLayout.x, labelLayout.y]]
	  };
	  var targetTextStyle = {
	    x: labelLayout.x,
	    y: labelLayout.y
	  };
	
	  if (withAnimation) {
	    graphic.updateProps(labelLine, {
	      shape: targetLineShape
	    }, seriesModel, idx);
	    graphic.updateProps(labelText, {
	      style: targetTextStyle
	    }, seriesModel, idx);
	  } else {
	    labelLine.attr({
	      shape: targetLineShape
	    });
	    labelText.attr({
	      style: targetTextStyle
	    });
	  }
	
	  labelText.attr({
	    rotation: labelLayout.rotation,
	    origin: [labelLayout.x, labelLayout.y],
	    z2: 10
	  });
	  var labelModel = itemModel.getModel('label');
	  var labelHoverModel = itemModel.getModel('emphasis.label');
	  var labelLineModel = itemModel.getModel('labelLine');
	  var labelLineHoverModel = itemModel.getModel('emphasis.labelLine');
	  var visualColor = data.getItemVisual(idx, 'color');
	  graphic.setLabelStyle(labelText.style, labelText.hoverStyle = {}, labelModel, labelHoverModel, {
	    labelFetcher: data.hostModel,
	    labelDataIndex: idx,
	    defaultText: labelLayout.text,
	    autoColor: visualColor,
	    useInsideStyle: !!labelLayout.inside
	  }, {
	    textAlign: labelLayout.textAlign,
	    textVerticalAlign: labelLayout.verticalAlign,
	    opacity: data.getItemVisual(idx, 'opacity')
	  });
	  labelText.ignore = labelText.normalIgnore = !labelModel.get('show');
	  labelText.hoverIgnore = !labelHoverModel.get('show');
	  labelLine.ignore = labelLine.normalIgnore = !labelLineModel.get('show');
	  labelLine.hoverIgnore = !labelLineHoverModel.get('show'); // Default use item visual color
	
	  labelLine.setStyle({
	    stroke: visualColor,
	    opacity: data.getItemVisual(idx, 'opacity')
	  });
	  labelLine.setStyle(labelLineModel.getModel('lineStyle').getLineStyle());
	  labelLine.hoverStyle = labelLineHoverModel.getModel('lineStyle').getLineStyle();
	  var smooth = labelLineModel.get('smooth');
	
	  if (smooth && smooth === true) {
	    smooth = 0.4;
	  }
	
	  labelLine.setShape({
	    smooth: smooth
	  });
	};
	
	zrUtil.inherits(PiePiece, graphic.Group); // Pie view
	
	var PieView = ChartView.extend({
	  type: 'pie',
	  init: function () {
	    var sectorGroup = new graphic.Group();
	    this._sectorGroup = sectorGroup;
	  },
	  render: function (seriesModel, ecModel, api, payload) {
	    if (payload && payload.from === this.uid) {
	      return;
	    }
	
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var group = this.group;
	    var hasAnimation = ecModel.get('animation');
	    var isFirstRender = !oldData;
	    var animationType = seriesModel.get('animationType');
	    var animationTypeUpdate = seriesModel.get('animationTypeUpdate');
	    var onSectorClick = zrUtil.curry(updateDataSelected, this.uid, seriesModel, hasAnimation, api);
	    var selectedMode = seriesModel.get('selectedMode');
	    data.diff(oldData).add(function (idx) {
	      var piePiece = new PiePiece(data, idx); // Default expansion animation
	
	      if (isFirstRender && animationType !== 'scale') {
	        piePiece.eachChild(function (child) {
	          child.stopAnimation(true);
	        });
	      }
	
	      selectedMode && piePiece.on('click', onSectorClick);
	      data.setItemGraphicEl(idx, piePiece);
	      group.add(piePiece);
	    }).update(function (newIdx, oldIdx) {
	      var piePiece = oldData.getItemGraphicEl(oldIdx);
	
	      if (!isFirstRender && animationTypeUpdate !== 'transition') {
	        piePiece.eachChild(function (child) {
	          child.stopAnimation(true);
	        });
	      }
	
	      piePiece.updateData(data, newIdx);
	      piePiece.off('click');
	      selectedMode && piePiece.on('click', onSectorClick);
	      group.add(piePiece);
	      data.setItemGraphicEl(newIdx, piePiece);
	    }).remove(function (idx) {
	      var piePiece = oldData.getItemGraphicEl(idx);
	      group.remove(piePiece);
	    }).execute();
	
	    if (hasAnimation && data.count() > 0 && (isFirstRender ? animationType !== 'scale' : animationTypeUpdate !== 'transition')) {
	      var shape = data.getItemLayout(0);
	
	      for (var s = 1; isNaN(shape.startAngle) && s < data.count(); ++s) {
	        shape = data.getItemLayout(s);
	      }
	
	      var r = Math.max(api.getWidth(), api.getHeight()) / 2;
	      var removeClipPath = zrUtil.bind(group.removeClipPath, group);
	      group.setClipPath(this._createClipPath(shape.cx, shape.cy, r, shape.startAngle, shape.clockwise, removeClipPath, seriesModel, isFirstRender));
	    } else {
	      // clipPath is used in first-time animation, so remove it when otherwise. See: #8994
	      group.removeClipPath();
	    }
	
	    this._data = data;
	  },
	  dispose: function () {},
	  _createClipPath: function (cx, cy, r, startAngle, clockwise, cb, seriesModel, isFirstRender) {
	    var clipPath = new graphic.Sector({
	      shape: {
	        cx: cx,
	        cy: cy,
	        r0: 0,
	        r: r,
	        startAngle: startAngle,
	        endAngle: startAngle,
	        clockwise: clockwise
	      }
	    });
	    var initOrUpdate = isFirstRender ? graphic.initProps : graphic.updateProps;
	    initOrUpdate(clipPath, {
	      shape: {
	        endAngle: startAngle + (clockwise ? 1 : -1) * Math.PI * 2
	      }
	    }, seriesModel, cb);
	    return clipPath;
	  },
	
	  /**
	   * @implement
	   */
	  containPoint: function (point, seriesModel) {
	    var data = seriesModel.getData();
	    var itemLayout = data.getItemLayout(0);
	
	    if (itemLayout) {
	      var dx = point[0] - itemLayout.cx;
	      var dy = point[1] - itemLayout.cy;
	      var radius = Math.sqrt(dx * dx + dy * dy);
	      return radius <= itemLayout.r && radius >= itemLayout.r0;
	    }
	  }
	});
	var _default = PieView;
	module.exports = _default;

/***/ },
/* 1527 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var textContain = __webpack_require__(79);
	
	var _number = __webpack_require__(20);
	
	var parsePercent = _number.parsePercent;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// FIXME emphasis label position is not same with normal label position
	var RADIAN = Math.PI / 180;
	
	function adjustSingleSide(list, cx, cy, r, dir, viewWidth, viewHeight, viewLeft, viewTop, farthestX) {
	  list.sort(function (a, b) {
	    return a.y - b.y;
	  });
	
	  function shiftDown(start, end, delta, dir) {
	    for (var j = start; j < end; j++) {
	      if (list[j].y + delta > viewTop + viewHeight) {
	        break;
	      }
	
	      list[j].y += delta;
	
	      if (j > start && j + 1 < end && list[j + 1].y > list[j].y + list[j].height) {
	        shiftUp(j, delta / 2);
	        return;
	      }
	    }
	
	    shiftUp(end - 1, delta / 2);
	  }
	
	  function shiftUp(end, delta) {
	    for (var j = end; j >= 0; j--) {
	      if (list[j].y - delta < viewTop) {
	        break;
	      }
	
	      list[j].y -= delta;
	
	      if (j > 0 && list[j].y > list[j - 1].y + list[j - 1].height) {
	        break;
	      }
	    }
	  }
	
	  function changeX(list, isDownList, cx, cy, r, dir) {
	    var lastDeltaX = dir > 0 ? isDownList // right-side
	    ? Number.MAX_VALUE // down
	    : 0 // up
	    : isDownList // left-side
	    ? Number.MAX_VALUE // down
	    : 0; // up
	
	    for (var i = 0, l = list.length; i < l; i++) {
	      if (list[i].labelAlignTo !== 'none') {
	        continue;
	      }
	
	      var deltaY = Math.abs(list[i].y - cy);
	      var length = list[i].len;
	      var length2 = list[i].len2;
	      var deltaX = deltaY < r + length ? Math.sqrt((r + length + length2) * (r + length + length2) - deltaY * deltaY) : Math.abs(list[i].x - cx);
	
	      if (isDownList && deltaX >= lastDeltaX) {
	        // right-down, left-down
	        deltaX = lastDeltaX - 10;
	      }
	
	      if (!isDownList && deltaX <= lastDeltaX) {
	        // right-up, left-up
	        deltaX = lastDeltaX + 10;
	      }
	
	      list[i].x = cx + deltaX * dir;
	      lastDeltaX = deltaX;
	    }
	  }
	
	  var lastY = 0;
	  var delta;
	  var len = list.length;
	  var upList = [];
	  var downList = [];
	
	  for (var i = 0; i < len; i++) {
	    if (list[i].position === 'outer' && list[i].labelAlignTo === 'labelLine') {
	      var dx = list[i].x - farthestX;
	      list[i].linePoints[1][0] += dx;
	      list[i].x = farthestX;
	    }
	
	    delta = list[i].y - lastY;
	
	    if (delta < 0) {
	      shiftDown(i, len, -delta, dir);
	    }
	
	    lastY = list[i].y + list[i].height;
	  }
	
	  if (viewHeight - lastY < 0) {
	    shiftUp(len - 1, lastY - viewHeight);
	  }
	
	  for (var i = 0; i < len; i++) {
	    if (list[i].y >= cy) {
	      downList.push(list[i]);
	    } else {
	      upList.push(list[i]);
	    }
	  }
	
	  changeX(upList, false, cx, cy, r, dir);
	  changeX(downList, true, cx, cy, r, dir);
	}
	
	function avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop) {
	  var leftList = [];
	  var rightList = [];
	  var leftmostX = Number.MAX_VALUE;
	  var rightmostX = -Number.MAX_VALUE;
	
	  for (var i = 0; i < labelLayoutList.length; i++) {
	    if (isPositionCenter(labelLayoutList[i])) {
	      continue;
	    }
	
	    if (labelLayoutList[i].x < cx) {
	      leftmostX = Math.min(leftmostX, labelLayoutList[i].x);
	      leftList.push(labelLayoutList[i]);
	    } else {
	      rightmostX = Math.max(rightmostX, labelLayoutList[i].x);
	      rightList.push(labelLayoutList[i]);
	    }
	  }
	
	  adjustSingleSide(rightList, cx, cy, r, 1, viewWidth, viewHeight, viewLeft, viewTop, rightmostX);
	  adjustSingleSide(leftList, cx, cy, r, -1, viewWidth, viewHeight, viewLeft, viewTop, leftmostX);
	
	  for (var i = 0; i < labelLayoutList.length; i++) {
	    var layout = labelLayoutList[i];
	
	    if (isPositionCenter(layout)) {
	      continue;
	    }
	
	    var linePoints = layout.linePoints;
	
	    if (linePoints) {
	      var isAlignToEdge = layout.labelAlignTo === 'edge';
	      var realTextWidth = layout.textRect.width;
	      var targetTextWidth;
	
	      if (isAlignToEdge) {
	        if (layout.x < cx) {
	          targetTextWidth = linePoints[2][0] - layout.labelDistance - viewLeft - layout.labelMargin;
	        } else {
	          targetTextWidth = viewLeft + viewWidth - layout.labelMargin - linePoints[2][0] - layout.labelDistance;
	        }
	      } else {
	        if (layout.x < cx) {
	          targetTextWidth = layout.x - viewLeft - layout.bleedMargin;
	        } else {
	          targetTextWidth = viewLeft + viewWidth - layout.x - layout.bleedMargin;
	        }
	      }
	
	      if (targetTextWidth < layout.textRect.width) {
	        layout.text = textContain.truncateText(layout.text, targetTextWidth, layout.font);
	
	        if (layout.labelAlignTo === 'edge') {
	          realTextWidth = textContain.getWidth(layout.text, layout.font);
	        }
	      }
	
	      var dist = linePoints[1][0] - linePoints[2][0];
	
	      if (isAlignToEdge) {
	        if (layout.x < cx) {
	          linePoints[2][0] = viewLeft + layout.labelMargin + realTextWidth + layout.labelDistance;
	        } else {
	          linePoints[2][0] = viewLeft + viewWidth - layout.labelMargin - realTextWidth - layout.labelDistance;
	        }
	      } else {
	        if (layout.x < cx) {
	          linePoints[2][0] = layout.x + layout.labelDistance;
	        } else {
	          linePoints[2][0] = layout.x - layout.labelDistance;
	        }
	
	        linePoints[1][0] = linePoints[2][0] + dist;
	      }
	
	      linePoints[1][1] = linePoints[2][1] = layout.y;
	    }
	  }
	}
	
	function isPositionCenter(layout) {
	  // Not change x for center label
	  return layout.position === 'center';
	}
	
	function _default(seriesModel, r, viewWidth, viewHeight, viewLeft, viewTop) {
	  var data = seriesModel.getData();
	  var labelLayoutList = [];
	  var cx;
	  var cy;
	  var hasLabelRotate = false;
	  var minShowLabelRadian = (seriesModel.get('minShowLabelAngle') || 0) * RADIAN;
	  data.each(function (idx) {
	    var layout = data.getItemLayout(idx);
	    var itemModel = data.getItemModel(idx);
	    var labelModel = itemModel.getModel('label'); // Use position in normal or emphasis
	
	    var labelPosition = labelModel.get('position') || itemModel.get('emphasis.label.position');
	    var labelDistance = labelModel.get('distanceToLabelLine');
	    var labelAlignTo = labelModel.get('alignTo');
	    var labelMargin = parsePercent(labelModel.get('margin'), viewWidth);
	    var bleedMargin = labelModel.get('bleedMargin');
	    var font = labelModel.getFont();
	    var labelLineModel = itemModel.getModel('labelLine');
	    var labelLineLen = labelLineModel.get('length');
	    labelLineLen = parsePercent(labelLineLen, viewWidth);
	    var labelLineLen2 = labelLineModel.get('length2');
	    labelLineLen2 = parsePercent(labelLineLen2, viewWidth);
	
	    if (layout.angle < minShowLabelRadian) {
	      return;
	    }
	
	    var midAngle = (layout.startAngle + layout.endAngle) / 2;
	    var dx = Math.cos(midAngle);
	    var dy = Math.sin(midAngle);
	    var textX;
	    var textY;
	    var linePoints;
	    var textAlign;
	    cx = layout.cx;
	    cy = layout.cy;
	    var text = seriesModel.getFormattedLabel(idx, 'normal') || data.getName(idx);
	    var textRect = textContain.getBoundingRect(text, font, textAlign, 'top');
	    var isLabelInside = labelPosition === 'inside' || labelPosition === 'inner';
	
	    if (labelPosition === 'center') {
	      textX = layout.cx;
	      textY = layout.cy;
	      textAlign = 'center';
	    } else {
	      var x1 = (isLabelInside ? (layout.r + layout.r0) / 2 * dx : layout.r * dx) + cx;
	      var y1 = (isLabelInside ? (layout.r + layout.r0) / 2 * dy : layout.r * dy) + cy;
	      textX = x1 + dx * 3;
	      textY = y1 + dy * 3;
	
	      if (!isLabelInside) {
	        // For roseType
	        var x2 = x1 + dx * (labelLineLen + r - layout.r);
	        var y2 = y1 + dy * (labelLineLen + r - layout.r);
	        var x3 = x2 + (dx < 0 ? -1 : 1) * labelLineLen2;
	        var y3 = y2;
	
	        if (labelAlignTo === 'edge') {
	          // Adjust textX because text align of edge is opposite
	          textX = dx < 0 ? viewLeft + labelMargin : viewLeft + viewWidth - labelMargin;
	        } else {
	          textX = x3 + (dx < 0 ? -labelDistance : labelDistance);
	        }
	
	        textY = y3;
	        linePoints = [[x1, y1], [x2, y2], [x3, y3]];
	      }
	
	      textAlign = isLabelInside ? 'center' : labelAlignTo === 'edge' ? dx > 0 ? 'right' : 'left' : dx > 0 ? 'left' : 'right';
	    }
	
	    var labelRotate;
	    var rotate = labelModel.get('rotate');
	
	    if (typeof rotate === 'number') {
	      labelRotate = rotate * (Math.PI / 180);
	    } else {
	      labelRotate = rotate ? dx < 0 ? -midAngle + Math.PI : -midAngle : 0;
	    }
	
	    hasLabelRotate = !!labelRotate;
	    layout.label = {
	      x: textX,
	      y: textY,
	      position: labelPosition,
	      height: textRect.height,
	      len: labelLineLen,
	      len2: labelLineLen2,
	      linePoints: linePoints,
	      textAlign: textAlign,
	      verticalAlign: 'middle',
	      rotation: labelRotate,
	      inside: isLabelInside,
	      labelDistance: labelDistance,
	      labelAlignTo: labelAlignTo,
	      labelMargin: labelMargin,
	      bleedMargin: bleedMargin,
	      textRect: textRect,
	      text: text,
	      font: font
	    }; // Not layout the inside label
	
	    if (!isLabelInside) {
	      labelLayoutList.push(layout.label);
	    }
	  });
	
	  if (!hasLabelRotate && seriesModel.get('avoidLabelOverlap')) {
	    avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop);
	  }
	}
	
	module.exports = _default;

/***/ },
/* 1528 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _number = __webpack_require__(20);
	
	var parsePercent = _number.parsePercent;
	var linearMap = _number.linearMap;
	
	var layout = __webpack_require__(36);
	
	var labelLayout = __webpack_require__(1527);
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PI2 = Math.PI * 2;
	var RADIAN = Math.PI / 180;
	
	function getViewRect(seriesModel, api) {
	  return layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
	    width: api.getWidth(),
	    height: api.getHeight()
	  });
	}
	
	function _default(seriesType, ecModel, api, payload) {
	  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
	    var data = seriesModel.getData();
	    var valueDim = data.mapDimension('value');
	    var viewRect = getViewRect(seriesModel, api);
	    var center = seriesModel.get('center');
	    var radius = seriesModel.get('radius');
	
	    if (!zrUtil.isArray(radius)) {
	      radius = [0, radius];
	    }
	
	    if (!zrUtil.isArray(center)) {
	      center = [center, center];
	    }
	
	    var width = parsePercent(viewRect.width, api.getWidth());
	    var height = parsePercent(viewRect.height, api.getHeight());
	    var size = Math.min(width, height);
	    var cx = parsePercent(center[0], width) + viewRect.x;
	    var cy = parsePercent(center[1], height) + viewRect.y;
	    var r0 = parsePercent(radius[0], size / 2);
	    var r = parsePercent(radius[1], size / 2);
	    var startAngle = -seriesModel.get('startAngle') * RADIAN;
	    var minAngle = seriesModel.get('minAngle') * RADIAN;
	    var validDataCount = 0;
	    data.each(valueDim, function (value) {
	      !isNaN(value) && validDataCount++;
	    });
	    var sum = data.getSum(valueDim); // Sum may be 0
	
	    var unitRadian = Math.PI / (sum || validDataCount) * 2;
	    var clockwise = seriesModel.get('clockwise');
	    var roseType = seriesModel.get('roseType');
	    var stillShowZeroSum = seriesModel.get('stillShowZeroSum'); // [0...max]
	
	    var extent = data.getDataExtent(valueDim);
	    extent[0] = 0; // In the case some sector angle is smaller than minAngle
	
	    var restAngle = PI2;
	    var valueSumLargerThanMinAngle = 0;
	    var currentAngle = startAngle;
	    var dir = clockwise ? 1 : -1;
	    data.each(valueDim, function (value, idx) {
	      var angle;
	
	      if (isNaN(value)) {
	        data.setItemLayout(idx, {
	          angle: NaN,
	          startAngle: NaN,
	          endAngle: NaN,
	          clockwise: clockwise,
	          cx: cx,
	          cy: cy,
	          r0: r0,
	          r: roseType ? NaN : r,
	          viewRect: viewRect
	        });
	        return;
	      } // FIXME 兼容 2.0 但是 roseType 是 area 的时候才是这样？
	
	
	      if (roseType !== 'area') {
	        angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
	      } else {
	        angle = PI2 / validDataCount;
	      }
	
	      if (angle < minAngle) {
	        angle = minAngle;
	        restAngle -= minAngle;
	      } else {
	        valueSumLargerThanMinAngle += value;
	      }
	
	      var endAngle = currentAngle + dir * angle;
	      data.setItemLayout(idx, {
	        angle: angle,
	        startAngle: currentAngle,
	        endAngle: endAngle,
	        clockwise: clockwise,
	        cx: cx,
	        cy: cy,
	        r0: r0,
	        r: roseType ? linearMap(value, extent, [r0, r]) : r,
	        viewRect: viewRect
	      });
	      currentAngle = endAngle;
	    }); // Some sector is constrained by minAngle
	    // Rest sectors needs recalculate angle
	
	    if (restAngle < PI2 && validDataCount) {
	      // Average the angle if rest angle is not enough after all angles is
	      // Constrained by minAngle
	      if (restAngle <= 1e-3) {
	        var angle = PI2 / validDataCount;
	        data.each(valueDim, function (value, idx) {
	          if (!isNaN(value)) {
	            var layout = data.getItemLayout(idx);
	            layout.angle = angle;
	            layout.startAngle = startAngle + dir * idx * angle;
	            layout.endAngle = startAngle + dir * (idx + 1) * angle;
	          }
	        });
	      } else {
	        unitRadian = restAngle / valueSumLargerThanMinAngle;
	        currentAngle = startAngle;
	        data.each(valueDim, function (value, idx) {
	          if (!isNaN(value)) {
	            var layout = data.getItemLayout(idx);
	            var angle = layout.angle === minAngle ? minAngle : value * unitRadian;
	            layout.startAngle = currentAngle;
	            layout.endAngle = currentAngle + dir * angle;
	            currentAngle += dir * angle;
	          }
	        });
	      }
	    }
	
	    labelLayout(seriesModel, r, viewRect.width, viewRect.height, viewRect.x, viewRect.y);
	  });
	}
	
	module.exports = _default;

/***/ },
/* 1529 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	__webpack_require__(1619);
	
	__webpack_require__(1530);
	
	__webpack_require__(1531);
	
	var dataColor = __webpack_require__(341);
	
	var visualSymbol = __webpack_require__(169);
	
	var radarLayout = __webpack_require__(1533);
	
	var dataFilter = __webpack_require__(267);
	
	var backwardCompat = __webpack_require__(1532);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Must use radar component
	echarts.registerVisual(dataColor('radar'));
	echarts.registerVisual(visualSymbol('radar', 'circle'));
	echarts.registerLayout(radarLayout);
	echarts.registerProcessor(dataFilter('radar'));
	echarts.registerPreprocessor(backwardCompat);

/***/ },
/* 1530 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SeriesModel = __webpack_require__(58);
	
	var createListSimply = __webpack_require__(201);
	
	var zrUtil = __webpack_require__(3);
	
	var _format = __webpack_require__(40);
	
	var encodeHTML = _format.encodeHTML;
	
	var LegendVisualProvider = __webpack_require__(269);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var RadarSeries = SeriesModel.extend({
	  type: 'series.radar',
	  dependencies: ['radar'],
	  // Overwrite
	  init: function (option) {
	    RadarSeries.superApply(this, 'init', arguments); // Enable legend selection for each data item
	    // Use a function instead of direct access because data reference may changed
	
	    this.legendVisualProvider = new LegendVisualProvider(zrUtil.bind(this.getData, this), zrUtil.bind(this.getRawData, this));
	  },
	  getInitialData: function (option, ecModel) {
	    return createListSimply(this, {
	      generateCoord: 'indicator_',
	      generateCoordCount: Infinity
	    });
	  },
	  formatTooltip: function (dataIndex, multipleSeries, dataType, renderMode) {
	    var data = this.getData();
	    var coordSys = this.coordinateSystem;
	    var indicatorAxes = coordSys.getIndicatorAxes();
	    var name = this.getData().getName(dataIndex);
	    var newLine = renderMode === 'html' ? '<br/>' : '\n';
	    return encodeHTML(name === '' ? this.name : name) + newLine + zrUtil.map(indicatorAxes, function (axis, idx) {
	      var val = data.get(data.mapDimension(axis.dim), dataIndex);
	      return encodeHTML(axis.name + ' : ' + val);
	    }).join(newLine);
	  },
	
	  /**
	   * @implement
	   */
	  getTooltipPosition: function (dataIndex) {
	    if (dataIndex != null) {
	      var data = this.getData();
	      var coordSys = this.coordinateSystem;
	      var values = data.getValues(zrUtil.map(coordSys.dimensions, function (dim) {
	        return data.mapDimension(dim);
	      }), dataIndex, true);
	
	      for (var i = 0, len = values.length; i < len; i++) {
	        if (!isNaN(values[i])) {
	          var indicatorAxes = coordSys.getIndicatorAxes();
	          return coordSys.coordToPoint(indicatorAxes[i].dataToCoord(values[i]), i);
	        }
	      }
	    }
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'radar',
	    legendHoverLink: true,
	    radarIndex: 0,
	    lineStyle: {
	      width: 2,
	      type: 'solid'
	    },
	    label: {
	      position: 'top'
	    },
	    // areaStyle: {
	    // },
	    // itemStyle: {}
	    symbol: 'emptyCircle',
	    symbolSize: 4 // symbolRotate: null
	
	  }
	});
	var _default = RadarSeries;
	module.exports = _default;

/***/ },
/* 1531 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var graphic = __webpack_require__(16);
	
	var zrUtil = __webpack_require__(3);
	
	var symbolUtil = __webpack_require__(84);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function normalizeSymbolSize(symbolSize) {
	  if (!zrUtil.isArray(symbolSize)) {
	    symbolSize = [+symbolSize, +symbolSize];
	  }
	
	  return symbolSize;
	}
	
	var _default = echarts.extendChartView({
	  type: 'radar',
	  render: function (seriesModel, ecModel, api) {
	    var polar = seriesModel.coordinateSystem;
	    var group = this.group;
	    var data = seriesModel.getData();
	    var oldData = this._data;
	
	    function createSymbol(data, idx) {
	      var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';
	      var color = data.getItemVisual(idx, 'color');
	
	      if (symbolType === 'none') {
	        return;
	      }
	
	      var symbolSize = normalizeSymbolSize(data.getItemVisual(idx, 'symbolSize'));
	      var symbolPath = symbolUtil.createSymbol(symbolType, -1, -1, 2, 2, color);
	      var symbolRotate = data.getItemVisual(idx, 'symbolRotate') || 0;
	      symbolPath.attr({
	        style: {
	          strokeNoScale: true
	        },
	        z2: 100,
	        scale: [symbolSize[0] / 2, symbolSize[1] / 2],
	        rotation: symbolRotate * Math.PI / 180 || 0
	      });
	      return symbolPath;
	    }
	
	    function updateSymbols(oldPoints, newPoints, symbolGroup, data, idx, isInit) {
	      // Simply rerender all
	      symbolGroup.removeAll();
	
	      for (var i = 0; i < newPoints.length - 1; i++) {
	        var symbolPath = createSymbol(data, idx);
	
	        if (symbolPath) {
	          symbolPath.__dimIdx = i;
	
	          if (oldPoints[i]) {
	            symbolPath.attr('position', oldPoints[i]);
	            graphic[isInit ? 'initProps' : 'updateProps'](symbolPath, {
	              position: newPoints[i]
	            }, seriesModel, idx);
	          } else {
	            symbolPath.attr('position', newPoints[i]);
	          }
	
	          symbolGroup.add(symbolPath);
	        }
	      }
	    }
	
	    function getInitialPoints(points) {
	      return zrUtil.map(points, function (pt) {
	        return [polar.cx, polar.cy];
	      });
	    }
	
	    data.diff(oldData).add(function (idx) {
	      var points = data.getItemLayout(idx);
	
	      if (!points) {
	        return;
	      }
	
	      var polygon = new graphic.Polygon();
	      var polyline = new graphic.Polyline();
	      var target = {
	        shape: {
	          points: points
	        }
	      };
	      polygon.shape.points = getInitialPoints(points);
	      polyline.shape.points = getInitialPoints(points);
	      graphic.initProps(polygon, target, seriesModel, idx);
	      graphic.initProps(polyline, target, seriesModel, idx);
	      var itemGroup = new graphic.Group();
	      var symbolGroup = new graphic.Group();
	      itemGroup.add(polyline);
	      itemGroup.add(polygon);
	      itemGroup.add(symbolGroup);
	      updateSymbols(polyline.shape.points, points, symbolGroup, data, idx, true);
	      data.setItemGraphicEl(idx, itemGroup);
	    }).update(function (newIdx, oldIdx) {
	      var itemGroup = oldData.getItemGraphicEl(oldIdx);
	      var polyline = itemGroup.childAt(0);
	      var polygon = itemGroup.childAt(1);
	      var symbolGroup = itemGroup.childAt(2);
	      var target = {
	        shape: {
	          points: data.getItemLayout(newIdx)
	        }
	      };
	
	      if (!target.shape.points) {
	        return;
	      }
	
	      updateSymbols(polyline.shape.points, target.shape.points, symbolGroup, data, newIdx, false);
	      graphic.updateProps(polyline, target, seriesModel);
	      graphic.updateProps(polygon, target, seriesModel);
	      data.setItemGraphicEl(newIdx, itemGroup);
	    }).remove(function (idx) {
	      group.remove(oldData.getItemGraphicEl(idx));
	    }).execute();
	    data.eachItemGraphicEl(function (itemGroup, idx) {
	      var itemModel = data.getItemModel(idx);
	      var polyline = itemGroup.childAt(0);
	      var polygon = itemGroup.childAt(1);
	      var symbolGroup = itemGroup.childAt(2);
	      var color = data.getItemVisual(idx, 'color');
	      group.add(itemGroup);
	      polyline.useStyle(zrUtil.defaults(itemModel.getModel('lineStyle').getLineStyle(), {
	        fill: 'none',
	        stroke: color
	      }));
	      polyline.hoverStyle = itemModel.getModel('emphasis.lineStyle').getLineStyle();
	      var areaStyleModel = itemModel.getModel('areaStyle');
	      var hoverAreaStyleModel = itemModel.getModel('emphasis.areaStyle');
	      var polygonIgnore = areaStyleModel.isEmpty() && areaStyleModel.parentModel.isEmpty();
	      var hoverPolygonIgnore = hoverAreaStyleModel.isEmpty() && hoverAreaStyleModel.parentModel.isEmpty();
	      hoverPolygonIgnore = hoverPolygonIgnore && polygonIgnore;
	      polygon.ignore = polygonIgnore;
	      polygon.useStyle(zrUtil.defaults(areaStyleModel.getAreaStyle(), {
	        fill: color,
	        opacity: 0.7
	      }));
	      polygon.hoverStyle = hoverAreaStyleModel.getAreaStyle();
	      var itemStyle = itemModel.getModel('itemStyle').getItemStyle(['color']);
	      var itemHoverStyle = itemModel.getModel('emphasis.itemStyle').getItemStyle();
	      var labelModel = itemModel.getModel('label');
	      var labelHoverModel = itemModel.getModel('emphasis.label');
	      symbolGroup.eachChild(function (symbolPath) {
	        symbolPath.setStyle(itemStyle);
	        symbolPath.hoverStyle = zrUtil.clone(itemHoverStyle);
	        var defaultText = data.get(data.dimensions[symbolPath.__dimIdx], idx);
	        (defaultText == null || isNaN(defaultText)) && (defaultText = '');
	        graphic.setLabelStyle(symbolPath.style, symbolPath.hoverStyle, labelModel, labelHoverModel, {
	          labelFetcher: data.hostModel,
	          labelDataIndex: idx,
	          labelDimIndex: symbolPath.__dimIdx,
	          defaultText: defaultText,
	          autoColor: color,
	          isRectText: true
	        });
	      });
	
	      itemGroup.highDownOnUpdate = function (fromState, toState) {
	        polygon.attr('ignore', toState === 'emphasis' ? hoverPolygonIgnore : polygonIgnore);
	      };
	
	      graphic.setHoverStyle(itemGroup);
	    });
	    this._data = data;
	  },
	  remove: function () {
	    this.group.removeAll();
	    this._data = null;
	  },
	  dispose: function () {}
	});
	
	module.exports = _default;

/***/ },
/* 1532 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Backward compat for radar chart in 2
	function _default(option) {
	  var polarOptArr = option.polar;
	
	  if (polarOptArr) {
	    if (!zrUtil.isArray(polarOptArr)) {
	      polarOptArr = [polarOptArr];
	    }
	
	    var polarNotRadar = [];
	    zrUtil.each(polarOptArr, function (polarOpt, idx) {
	      if (polarOpt.indicator) {
	        if (polarOpt.type && !polarOpt.shape) {
	          polarOpt.shape = polarOpt.type;
	        }
	
	        option.radar = option.radar || [];
	
	        if (!zrUtil.isArray(option.radar)) {
	          option.radar = [option.radar];
	        }
	
	        option.radar.push(polarOpt);
	      } else {
	        polarNotRadar.push(polarOpt);
	      }
	    });
	    option.polar = polarNotRadar;
	  }
	
	  zrUtil.each(option.series, function (seriesOpt) {
	    if (seriesOpt && seriesOpt.type === 'radar' && seriesOpt.polarIndex) {
	      seriesOpt.radarIndex = seriesOpt.polarIndex;
	    }
	  });
	}
	
	module.exports = _default;

/***/ },
/* 1533 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  ecModel.eachSeriesByType('radar', function (seriesModel) {
	    var data = seriesModel.getData();
	    var points = [];
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (!coordSys) {
	      return;
	    }
	
	    var axes = coordSys.getIndicatorAxes();
	    zrUtil.each(axes, function (axis, axisIndex) {
	      data.each(data.mapDimension(axes[axisIndex].dim), function (val, dataIndex) {
	        points[dataIndex] = points[dataIndex] || [];
	        var point = coordSys.dataToPoint(val, axisIndex);
	        points[dataIndex][axisIndex] = isValidPoint(point) ? point : getValueMissingPoint(coordSys);
	      });
	    }); // Close polygon
	
	    data.each(function (idx) {
	      // TODO
	      // Is it appropriate to connect to the next data when some data is missing?
	      // Or, should trade it like `connectNull` in line chart?
	      var firstPoint = zrUtil.find(points[idx], function (point) {
	        return isValidPoint(point);
	      }) || getValueMissingPoint(coordSys); // Copy the first actual point to the end of the array
	
	      points[idx].push(firstPoint.slice());
	      data.setItemLayout(idx, points[idx]);
	    });
	  });
	}
	
	function isValidPoint(point) {
	  return !isNaN(point[0]) && !isNaN(point[1]);
	}
	
	function getValueMissingPoint(coordSys) {
	  // It is error-prone to input [NaN, NaN] into polygon, polygon.
	  // (probably cause problem when refreshing or animating)
	  return [coordSys.cx, coordSys.cy];
	}
	
	module.exports = _default;

/***/ },
/* 1534 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	__webpack_require__(1535);
	
	__webpack_require__(1536);
	
	__webpack_require__(1537);
	
	var sankeyLayout = __webpack_require__(1538);
	
	var sankeyVisual = __webpack_require__(1539);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerLayout(sankeyLayout);
	echarts.registerVisual(sankeyVisual);

/***/ },
/* 1535 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SeriesModel = __webpack_require__(58);
	
	var createGraphFromNodeEdge = __webpack_require__(702);
	
	var _format = __webpack_require__(40);
	
	var encodeHTML = _format.encodeHTML;
	
	var Model = __webpack_require__(48);
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var SankeySeries = SeriesModel.extend({
	  type: 'series.sankey',
	  layoutInfo: null,
	  levelModels: null,
	
	  /**
	   * Init a graph data structure from data in option series
	   *
	   * @param  {Object} option  the object used to config echarts view
	   * @return {module:echarts/data/List} storage initial data
	   */
	  getInitialData: function (option, ecModel) {
	    var links = option.edges || option.links;
	    var nodes = option.data || option.nodes;
	    var levels = option.levels;
	    var levelModels = this.levelModels = {};
	
	    for (var i = 0; i < levels.length; i++) {
	      if (levels[i].depth != null && levels[i].depth >= 0) {
	        levelModels[levels[i].depth] = new Model(levels[i], this, ecModel);
	      } else {}
	    }
	
	    if (nodes && links) {
	      var graph = createGraphFromNodeEdge(nodes, links, this, true, beforeLink);
	      return graph.data;
	    }
	
	    function beforeLink(nodeData, edgeData) {
	      nodeData.wrapMethod('getItemModel', function (model, idx) {
	        model.customizeGetParent(function (path) {
	          var parentModel = this.parentModel;
	          var nodeDepth = parentModel.getData().getItemLayout(idx).depth;
	          var levelModel = parentModel.levelModels[nodeDepth];
	          return levelModel || this.parentModel;
	        });
	        return model;
	      });
	      edgeData.wrapMethod('getItemModel', function (model, idx) {
	        model.customizeGetParent(function (path) {
	          var parentModel = this.parentModel;
	          var edge = parentModel.getGraph().getEdgeByIndex(idx);
	          var depth = edge.node1.getLayout().depth;
	          var levelModel = parentModel.levelModels[depth];
	          return levelModel || this.parentModel;
	        });
	        return model;
	      });
	    }
	  },
	  setNodePosition: function (dataIndex, localPosition) {
	    var dataItem = this.option.data[dataIndex];
	    dataItem.localX = localPosition[0];
	    dataItem.localY = localPosition[1];
	  },
	
	  /**
	   * Return the graphic data structure
	   *
	   * @return {module:echarts/data/Graph} graphic data structure
	   */
	  getGraph: function () {
	    return this.getData().graph;
	  },
	
	  /**
	   * Get edge data of graphic data structure
	   *
	   * @return {module:echarts/data/List} data structure of list
	   */
	  getEdgeData: function () {
	    return this.getGraph().edgeData;
	  },
	
	  /**
	   * @override
	   */
	  formatTooltip: function (dataIndex, multipleSeries, dataType) {
	    // dataType === 'node' or empty do not show tooltip by default
	    if (dataType === 'edge') {
	      var params = this.getDataParams(dataIndex, dataType);
	      var rawDataOpt = params.data;
	      var html = rawDataOpt.source + ' -- ' + rawDataOpt.target;
	
	      if (params.value) {
	        html += ' : ' + params.value;
	      }
	
	      return encodeHTML(html);
	    } else if (dataType === 'node') {
	      var node = this.getGraph().getNodeByIndex(dataIndex);
	      var value = node.getLayout().value;
	      var name = this.getDataParams(dataIndex, dataType).data.name;
	
	      if (value) {
	        var html = name + ' : ' + value;
	      }
	
	      return encodeHTML(html);
	    }
	
	    return SankeySeries.superCall(this, 'formatTooltip', dataIndex, multipleSeries);
	  },
	  optionUpdated: function () {
	    var option = this.option;
	
	    if (option.focusNodeAdjacency === true) {
	      option.focusNodeAdjacency = 'allEdges';
	    }
	  },
	  // Override Series.getDataParams()
	  getDataParams: function (dataIndex, dataType) {
	    var params = SankeySeries.superCall(this, 'getDataParams', dataIndex, dataType);
	
	    if (params.value == null && dataType === 'node') {
	      var node = this.getGraph().getNodeByIndex(dataIndex);
	      var nodeValue = node.getLayout().value;
	      params.value = nodeValue;
	    }
	
	    return params;
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'view',
	    layout: null,
	    // The position of the whole view
	    left: '5%',
	    top: '5%',
	    right: '20%',
	    bottom: '5%',
	    // Value can be 'vertical'
	    orient: 'horizontal',
	    // The dx of the node
	    nodeWidth: 20,
	    // The vertical distance between two nodes
	    nodeGap: 8,
	    // Control if the node can move or not
	    draggable: true,
	    // Value can be 'inEdges', 'outEdges', 'allEdges', true (the same as 'allEdges').
	    focusNodeAdjacency: false,
	    // The number of iterations to change the position of the node
	    layoutIterations: 32,
	    label: {
	      show: true,
	      position: 'right',
	      color: '#000',
	      fontSize: 12
	    },
	    levels: [],
	    // Value can be 'left' or 'right'
	    nodeAlign: 'justify',
	    itemStyle: {
	      borderWidth: 1,
	      borderColor: '#333'
	    },
	    lineStyle: {
	      color: '#314656',
	      opacity: 0.2,
	      curveness: 0.5
	    },
	    emphasis: {
	      label: {
	        show: true
	      },
	      lineStyle: {
	        opacity: 0.5
	      }
	    },
	    animationEasing: 'linear',
	    animationDuration: 1000
	  }
	});
	var _default = SankeySeries;
	module.exports = _default;

/***/ },
/* 1536 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(16);
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var nodeOpacityPath = ['itemStyle', 'opacity'];
	var hoverNodeOpacityPath = ['emphasis', 'itemStyle', 'opacity'];
	var lineOpacityPath = ['lineStyle', 'opacity'];
	var hoverLineOpacityPath = ['emphasis', 'lineStyle', 'opacity'];
	
	function getItemOpacity(item, opacityPath) {
	  return item.getVisual('opacity') || item.getModel().get(opacityPath);
	}
	
	function fadeOutItem(item, opacityPath, opacityRatio) {
	  var el = item.getGraphicEl();
	  var opacity = getItemOpacity(item, opacityPath);
	
	  if (opacityRatio != null) {
	    opacity == null && (opacity = 1);
	    opacity *= opacityRatio;
	  }
	
	  el.downplay && el.downplay();
	  el.traverse(function (child) {
	    if (child.type !== 'group') {
	      child.setStyle('opacity', opacity);
	    }
	  });
	}
	
	function fadeInItem(item, opacityPath) {
	  var opacity = getItemOpacity(item, opacityPath);
	  var el = item.getGraphicEl();
	  el.traverse(function (child) {
	    if (child.type !== 'group') {
	      child.setStyle('opacity', opacity);
	    }
	  }); // Support emphasis here.
	
	  el.highlight && el.highlight();
	}
	
	var SankeyShape = graphic.extendShape({
	  shape: {
	    x1: 0,
	    y1: 0,
	    x2: 0,
	    y2: 0,
	    cpx1: 0,
	    cpy1: 0,
	    cpx2: 0,
	    cpy2: 0,
	    extent: 0,
	    orient: ''
	  },
	  buildPath: function (ctx, shape) {
	    var extent = shape.extent;
	    ctx.moveTo(shape.x1, shape.y1);
	    ctx.bezierCurveTo(shape.cpx1, shape.cpy1, shape.cpx2, shape.cpy2, shape.x2, shape.y2);
	
	    if (shape.orient === 'vertical') {
	      ctx.lineTo(shape.x2 + extent, shape.y2);
	      ctx.bezierCurveTo(shape.cpx2 + extent, shape.cpy2, shape.cpx1 + extent, shape.cpy1, shape.x1 + extent, shape.y1);
	    } else {
	      ctx.lineTo(shape.x2, shape.y2 + extent);
	      ctx.bezierCurveTo(shape.cpx2, shape.cpy2 + extent, shape.cpx1, shape.cpy1 + extent, shape.x1, shape.y1 + extent);
	    }
	
	    ctx.closePath();
	  },
	  highlight: function () {
	    this.trigger('emphasis');
	  },
	  downplay: function () {
	    this.trigger('normal');
	  }
	});
	
	var _default = echarts.extendChartView({
	  type: 'sankey',
	
	  /**
	   * @private
	   * @type {module:echarts/chart/sankey/SankeySeries}
	   */
	  _model: null,
	
	  /**
	   * @private
	   * @type {boolean}
	   */
	  _focusAdjacencyDisabled: false,
	  render: function (seriesModel, ecModel, api) {
	    var sankeyView = this;
	    var graph = seriesModel.getGraph();
	    var group = this.group;
	    var layoutInfo = seriesModel.layoutInfo; // view width
	
	    var width = layoutInfo.width; // view height
	
	    var height = layoutInfo.height;
	    var nodeData = seriesModel.getData();
	    var edgeData = seriesModel.getData('edge');
	    var orient = seriesModel.get('orient');
	    this._model = seriesModel;
	    group.removeAll();
	    group.attr('position', [layoutInfo.x, layoutInfo.y]); // generate a bezire Curve for each edge
	
	    graph.eachEdge(function (edge) {
	      var curve = new SankeyShape();
	      curve.dataIndex = edge.dataIndex;
	      curve.seriesIndex = seriesModel.seriesIndex;
	      curve.dataType = 'edge';
	      var lineStyleModel = edge.getModel('lineStyle');
	      var curvature = lineStyleModel.get('curveness');
	      var n1Layout = edge.node1.getLayout();
	      var node1Model = edge.node1.getModel();
	      var dragX1 = node1Model.get('localX');
	      var dragY1 = node1Model.get('localY');
	      var n2Layout = edge.node2.getLayout();
	      var node2Model = edge.node2.getModel();
	      var dragX2 = node2Model.get('localX');
	      var dragY2 = node2Model.get('localY');
	      var edgeLayout = edge.getLayout();
	      var x1;
	      var y1;
	      var x2;
	      var y2;
	      var cpx1;
	      var cpy1;
	      var cpx2;
	      var cpy2;
	      curve.shape.extent = Math.max(1, edgeLayout.dy);
	      curve.shape.orient = orient;
	
	      if (orient === 'vertical') {
	        x1 = (dragX1 != null ? dragX1 * width : n1Layout.x) + edgeLayout.sy;
	        y1 = (dragY1 != null ? dragY1 * height : n1Layout.y) + n1Layout.dy;
	        x2 = (dragX2 != null ? dragX2 * width : n2Layout.x) + edgeLayout.ty;
	        y2 = dragY2 != null ? dragY2 * height : n2Layout.y;
	        cpx1 = x1;
	        cpy1 = y1 * (1 - curvature) + y2 * curvature;
	        cpx2 = x2;
	        cpy2 = y1 * curvature + y2 * (1 - curvature);
	      } else {
	        x1 = (dragX1 != null ? dragX1 * width : n1Layout.x) + n1Layout.dx;
	        y1 = (dragY1 != null ? dragY1 * height : n1Layout.y) + edgeLayout.sy;
	        x2 = dragX2 != null ? dragX2 * width : n2Layout.x;
	        y2 = (dragY2 != null ? dragY2 * height : n2Layout.y) + edgeLayout.ty;
	        cpx1 = x1 * (1 - curvature) + x2 * curvature;
	        cpy1 = y1;
	        cpx2 = x1 * curvature + x2 * (1 - curvature);
	        cpy2 = y2;
	      }
	
	      curve.setShape({
	        x1: x1,
	        y1: y1,
	        x2: x2,
	        y2: y2,
	        cpx1: cpx1,
	        cpy1: cpy1,
	        cpx2: cpx2,
	        cpy2: cpy2
	      });
	      curve.setStyle(lineStyleModel.getItemStyle()); // Special color, use source node color or target node color
	
	      switch (curve.style.fill) {
	        case 'source':
	          curve.style.fill = edge.node1.getVisual('color');
	          break;
	
	        case 'target':
	          curve.style.fill = edge.node2.getVisual('color');
	          break;
	      }
	
	      graphic.setHoverStyle(curve, edge.getModel('emphasis.lineStyle').getItemStyle());
	      group.add(curve);
	      edgeData.setItemGraphicEl(edge.dataIndex, curve);
	    }); // Generate a rect for each node
	
	    graph.eachNode(function (node) {
	      var layout = node.getLayout();
	      var itemModel = node.getModel();
	      var dragX = itemModel.get('localX');
	      var dragY = itemModel.get('localY');
	      var labelModel = itemModel.getModel('label');
	      var labelHoverModel = itemModel.getModel('emphasis.label');
	      var rect = new graphic.Rect({
	        shape: {
	          x: dragX != null ? dragX * width : layout.x,
	          y: dragY != null ? dragY * height : layout.y,
	          width: layout.dx,
	          height: layout.dy
	        },
	        style: itemModel.getModel('itemStyle').getItemStyle()
	      });
	      var hoverStyle = node.getModel('emphasis.itemStyle').getItemStyle();
	      graphic.setLabelStyle(rect.style, hoverStyle, labelModel, labelHoverModel, {
	        labelFetcher: seriesModel,
	        labelDataIndex: node.dataIndex,
	        defaultText: node.id,
	        isRectText: true
	      });
	      rect.setStyle('fill', node.getVisual('color'));
	      graphic.setHoverStyle(rect, hoverStyle);
	      group.add(rect);
	      nodeData.setItemGraphicEl(node.dataIndex, rect);
	      rect.dataType = 'node';
	    });
	    nodeData.eachItemGraphicEl(function (el, dataIndex) {
	      var itemModel = nodeData.getItemModel(dataIndex);
	
	      if (itemModel.get('draggable')) {
	        el.drift = function (dx, dy) {
	          sankeyView._focusAdjacencyDisabled = true;
	          this.shape.x += dx;
	          this.shape.y += dy;
	          this.dirty();
	          api.dispatchAction({
	            type: 'dragNode',
	            seriesId: seriesModel.id,
	            dataIndex: nodeData.getRawIndex(dataIndex),
	            localX: this.shape.x / width,
	            localY: this.shape.y / height
	          });
	        };
	
	        el.ondragend = function () {
	          sankeyView._focusAdjacencyDisabled = false;
	        };
	
	        el.draggable = true;
	        el.cursor = 'move';
	      }
	
	      el.highlight = function () {
	        this.trigger('emphasis');
	      };
	
	      el.downplay = function () {
	        this.trigger('normal');
	      };
	
	      el.focusNodeAdjHandler && el.off('mouseover', el.focusNodeAdjHandler);
	      el.unfocusNodeAdjHandler && el.off('mouseout', el.unfocusNodeAdjHandler);
	
	      if (itemModel.get('focusNodeAdjacency')) {
	        el.on('mouseover', el.focusNodeAdjHandler = function () {
	          if (!sankeyView._focusAdjacencyDisabled) {
	            sankeyView._clearTimer();
	
	            api.dispatchAction({
	              type: 'focusNodeAdjacency',
	              seriesId: seriesModel.id,
	              dataIndex: el.dataIndex
	            });
	          }
	        });
	        el.on('mouseout', el.unfocusNodeAdjHandler = function () {
	          if (!sankeyView._focusAdjacencyDisabled) {
	            sankeyView._dispatchUnfocus(api);
	          }
	        });
	      }
	    });
	    edgeData.eachItemGraphicEl(function (el, dataIndex) {
	      var edgeModel = edgeData.getItemModel(dataIndex);
	      el.focusNodeAdjHandler && el.off('mouseover', el.focusNodeAdjHandler);
	      el.unfocusNodeAdjHandler && el.off('mouseout', el.unfocusNodeAdjHandler);
	
	      if (edgeModel.get('focusNodeAdjacency')) {
	        el.on('mouseover', el.focusNodeAdjHandler = function () {
	          if (!sankeyView._focusAdjacencyDisabled) {
	            sankeyView._clearTimer();
	
	            api.dispatchAction({
	              type: 'focusNodeAdjacency',
	              seriesId: seriesModel.id,
	              edgeDataIndex: el.dataIndex
	            });
	          }
	        });
	        el.on('mouseout', el.unfocusNodeAdjHandler = function () {
	          if (!sankeyView._focusAdjacencyDisabled) {
	            sankeyView._dispatchUnfocus(api);
	          }
	        });
	      }
	    });
	
	    if (!this._data && seriesModel.get('animation')) {
	      group.setClipPath(createGridClipShape(group.getBoundingRect(), seriesModel, function () {
	        group.removeClipPath();
	      }));
	    }
	
	    this._data = seriesModel.getData();
	  },
	  dispose: function () {
	    this._clearTimer();
	  },
	  _dispatchUnfocus: function (api) {
	    var self = this;
	
	    this._clearTimer();
	
	    this._unfocusDelayTimer = setTimeout(function () {
	      self._unfocusDelayTimer = null;
	      api.dispatchAction({
	        type: 'unfocusNodeAdjacency',
	        seriesId: self._model.id
	      });
	    }, 500);
	  },
	  _clearTimer: function () {
	    if (this._unfocusDelayTimer) {
	      clearTimeout(this._unfocusDelayTimer);
	      this._unfocusDelayTimer = null;
	    }
	  },
	  focusNodeAdjacency: function (seriesModel, ecModel, api, payload) {
	    var data = seriesModel.getData();
	    var graph = data.graph;
	    var dataIndex = payload.dataIndex;
	    var itemModel = data.getItemModel(dataIndex);
	    var edgeDataIndex = payload.edgeDataIndex;
	
	    if (dataIndex == null && edgeDataIndex == null) {
	      return;
	    }
	
	    var node = graph.getNodeByIndex(dataIndex);
	    var edge = graph.getEdgeByIndex(edgeDataIndex);
	    graph.eachNode(function (node) {
	      fadeOutItem(node, nodeOpacityPath, 0.1);
	    });
	    graph.eachEdge(function (edge) {
	      fadeOutItem(edge, lineOpacityPath, 0.1);
	    });
	
	    if (node) {
	      fadeInItem(node, hoverNodeOpacityPath);
	      var focusNodeAdj = itemModel.get('focusNodeAdjacency');
	
	      if (focusNodeAdj === 'outEdges') {
	        zrUtil.each(node.outEdges, function (edge) {
	          if (edge.dataIndex < 0) {
	            return;
	          }
	
	          fadeInItem(edge, hoverLineOpacityPath);
	          fadeInItem(edge.node2, hoverNodeOpacityPath);
	        });
	      } else if (focusNodeAdj === 'inEdges') {
	        zrUtil.each(node.inEdges, function (edge) {
	          if (edge.dataIndex < 0) {
	            return;
	          }
	
	          fadeInItem(edge, hoverLineOpacityPath);
	          fadeInItem(edge.node1, hoverNodeOpacityPath);
	        });
	      } else if (focusNodeAdj === 'allEdges') {
	        zrUtil.each(node.edges, function (edge) {
	          if (edge.dataIndex < 0) {
	            return;
	          }
	
	          fadeInItem(edge, hoverLineOpacityPath);
	          edge.node1 !== node && fadeInItem(edge.node1, hoverNodeOpacityPath);
	          edge.node2 !== node && fadeInItem(edge.node2, hoverNodeOpacityPath);
	        });
	      }
	    }
	
	    if (edge) {
	      fadeInItem(edge, hoverLineOpacityPath);
	      fadeInItem(edge.node1, hoverNodeOpacityPath);
	      fadeInItem(edge.node2, hoverNodeOpacityPath);
	    }
	  },
	  unfocusNodeAdjacency: function (seriesModel, ecModel, api, payload) {
	    var graph = seriesModel.getGraph();
	    graph.eachNode(function (node) {
	      fadeOutItem(node, nodeOpacityPath);
	    });
	    graph.eachEdge(function (edge) {
	      fadeOutItem(edge, lineOpacityPath);
	    });
	  }
	}); // Add animation to the view
	
	
	function createGridClipShape(rect, seriesModel, cb) {
	  var rectEl = new graphic.Rect({
	    shape: {
	      x: rect.x - 10,
	      y: rect.y - 10,
	      width: 0,
	      height: rect.height + 20
	    }
	  });
	  graphic.initProps(rectEl, {
	    shape: {
	      width: rect.width + 20
	    }
	  }, seriesModel, cb);
	  return rectEl;
	}
	
	module.exports = _default;

/***/ },
/* 1537 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	__webpack_require__(703);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerAction({
	  type: 'dragNode',
	  event: 'dragnode',
	  // here can only use 'update' now, other value is not support in echarts.
	  update: 'update'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'sankey',
	    query: payload
	  }, function (seriesModel) {
	    seriesModel.setNodePosition(payload.dataIndex, [payload.localX, payload.localY]);
	  });
	});

/***/ },
/* 1538 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var layout = __webpack_require__(36);
	
	var zrUtil = __webpack_require__(3);
	
	var _model = __webpack_require__(24);
	
	var groupData = _model.groupData;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel, api, payload) {
	  ecModel.eachSeriesByType('sankey', function (seriesModel) {
	    var nodeWidth = seriesModel.get('nodeWidth');
	    var nodeGap = seriesModel.get('nodeGap');
	    var layoutInfo = getViewRect(seriesModel, api);
	    seriesModel.layoutInfo = layoutInfo;
	    var width = layoutInfo.width;
	    var height = layoutInfo.height;
	    var graph = seriesModel.getGraph();
	    var nodes = graph.nodes;
	    var edges = graph.edges;
	    computeNodeValues(nodes);
	    var filteredNodes = zrUtil.filter(nodes, function (node) {
	      return node.getLayout().value === 0;
	    });
	    var iterations = filteredNodes.length !== 0 ? 0 : seriesModel.get('layoutIterations');
	    var orient = seriesModel.get('orient');
	    var nodeAlign = seriesModel.get('nodeAlign');
	    layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations, orient, nodeAlign);
	  });
	}
	/**
	 * Get the layout position of the whole view
	 *
	 * @param {module:echarts/model/Series} seriesModel  the model object of sankey series
	 * @param {module:echarts/ExtensionAPI} api  provide the API list that the developer can call
	 * @return {module:zrender/core/BoundingRect}  size of rect to draw the sankey view
	 */
	
	
	function getViewRect(seriesModel, api) {
	  return layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
	    width: api.getWidth(),
	    height: api.getHeight()
	  });
	}
	
	function layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations, orient, nodeAlign) {
	  computeNodeBreadths(nodes, edges, nodeWidth, width, height, orient, nodeAlign);
	  computeNodeDepths(nodes, edges, height, width, nodeGap, iterations, orient);
	  computeEdgeDepths(nodes, orient);
	}
	/**
	 * Compute the value of each node by summing the associated edge's value
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 */
	
	
	function computeNodeValues(nodes) {
	  zrUtil.each(nodes, function (node) {
	    var value1 = sum(node.outEdges, getEdgeValue);
	    var value2 = sum(node.inEdges, getEdgeValue);
	    var nodeRawValue = node.getValue() || 0;
	    var value = Math.max(value1, value2, nodeRawValue);
	    node.setLayout({
	      value: value
	    }, true);
	  });
	}
	/**
	 * Compute the x-position for each node.
	 *
	 * Here we use Kahn algorithm to detect cycle when we traverse
	 * the node to computer the initial x position.
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 * @param  {number} nodeWidth  the dx of the node
	 * @param  {number} width  the whole width of the area to draw the view
	 */
	
	
	function computeNodeBreadths(nodes, edges, nodeWidth, width, height, orient, nodeAlign) {
	  // Used to mark whether the edge is deleted. if it is deleted,
	  // the value is 0, otherwise it is 1.
	  var remainEdges = []; // Storage each node's indegree.
	
	  var indegreeArr = []; //Used to storage the node with indegree is equal to 0.
	
	  var zeroIndegrees = [];
	  var nextTargetNode = [];
	  var x = 0;
	  var kx = 0;
	
	  for (var i = 0; i < edges.length; i++) {
	    remainEdges[i] = 1;
	  }
	
	  for (i = 0; i < nodes.length; i++) {
	    indegreeArr[i] = nodes[i].inEdges.length;
	
	    if (indegreeArr[i] === 0) {
	      zeroIndegrees.push(nodes[i]);
	    }
	  }
	
	  var maxNodeDepth = -1; // Traversing nodes using topological sorting to calculate the
	  // horizontal(if orient === 'horizontal') or vertical(if orient === 'vertical')
	  // position of the nodes.
	
	  while (zeroIndegrees.length) {
	    for (var idx = 0; idx < zeroIndegrees.length; idx++) {
	      var node = zeroIndegrees[idx];
	      var item = node.hostGraph.data.getRawDataItem(node.dataIndex);
	      var isItemDepth = item.depth != null && item.depth >= 0;
	
	      if (isItemDepth && item.depth > maxNodeDepth) {
	        maxNodeDepth = item.depth;
	      }
	
	      node.setLayout({
	        depth: isItemDepth ? item.depth : x
	      }, true);
	      orient === 'vertical' ? node.setLayout({
	        dy: nodeWidth
	      }, true) : node.setLayout({
	        dx: nodeWidth
	      }, true);
	
	      for (var edgeIdx = 0; edgeIdx < node.outEdges.length; edgeIdx++) {
	        var edge = node.outEdges[edgeIdx];
	        var indexEdge = edges.indexOf(edge);
	        remainEdges[indexEdge] = 0;
	        var targetNode = edge.node2;
	        var nodeIndex = nodes.indexOf(targetNode);
	
	        if (--indegreeArr[nodeIndex] === 0 && nextTargetNode.indexOf(targetNode) < 0) {
	          nextTargetNode.push(targetNode);
	        }
	      }
	    }
	
	    ++x;
	    zeroIndegrees = nextTargetNode;
	    nextTargetNode = [];
	  }
	
	  for (i = 0; i < remainEdges.length; i++) {
	    if (remainEdges[i] === 1) {
	      throw new Error('Sankey is a DAG, the original data has cycle!');
	    }
	  }
	
	  var maxDepth = maxNodeDepth > x - 1 ? maxNodeDepth : x - 1;
	
	  if (nodeAlign && nodeAlign !== 'left') {
	    adjustNodeWithNodeAlign(nodes, nodeAlign, orient, maxDepth);
	  }
	
	  var kx = orient === 'vertical' ? (height - nodeWidth) / maxDepth : (width - nodeWidth) / maxDepth;
	  scaleNodeBreadths(nodes, kx, orient);
	}
	
	function isNodeDepth(node) {
	  var item = node.hostGraph.data.getRawDataItem(node.dataIndex);
	  return item.depth != null && item.depth >= 0;
	}
	
	function adjustNodeWithNodeAlign(nodes, nodeAlign, orient, maxDepth) {
	  if (nodeAlign === 'right') {
	    var nextSourceNode = [];
	    var remainNodes = nodes;
	    var nodeHeight = 0;
	
	    while (remainNodes.length) {
	      for (var i = 0; i < remainNodes.length; i++) {
	        var node = remainNodes[i];
	        node.setLayout({
	          skNodeHeight: nodeHeight
	        }, true);
	
	        for (var j = 0; j < node.inEdges.length; j++) {
	          var edge = node.inEdges[j];
	
	          if (nextSourceNode.indexOf(edge.node1) < 0) {
	            nextSourceNode.push(edge.node1);
	          }
	        }
	      }
	
	      remainNodes = nextSourceNode;
	      nextSourceNode = [];
	      ++nodeHeight;
	    }
	
	    zrUtil.each(nodes, function (node) {
	      if (!isNodeDepth(node)) {
	        node.setLayout({
	          depth: Math.max(0, maxDepth - node.getLayout().skNodeHeight)
	        }, true);
	      }
	    });
	  } else if (nodeAlign === 'justify') {
	    moveSinksRight(nodes, maxDepth);
	  }
	}
	/**
	 * All the node without outEgdes are assigned maximum x-position and
	 *     be aligned in the last column.
	 *
	 * @param {module:echarts/data/Graph~Node} nodes.  node of sankey view.
	 * @param {number} maxDepth.  use to assign to node without outEdges as x-position.
	 */
	
	
	function moveSinksRight(nodes, maxDepth) {
	  zrUtil.each(nodes, function (node) {
	    if (!isNodeDepth(node) && !node.outEdges.length) {
	      node.setLayout({
	        depth: maxDepth
	      }, true);
	    }
	  });
	}
	/**
	 * Scale node x-position to the width
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 * @param {number} kx   multiple used to scale nodes
	 */
	
	
	function scaleNodeBreadths(nodes, kx, orient) {
	  zrUtil.each(nodes, function (node) {
	    var nodeDepth = node.getLayout().depth * kx;
	    orient === 'vertical' ? node.setLayout({
	      y: nodeDepth
	    }, true) : node.setLayout({
	      x: nodeDepth
	    }, true);
	  });
	}
	/**
	 * Using Gauss-Seidel iterations method to compute the node depth(y-position)
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 * @param {module:echarts/data/Graph~Edge} edges  edge of sankey view
	 * @param {number} height  the whole height of the area to draw the view
	 * @param {number} nodeGap  the vertical distance between two nodes
	 *     in the same column.
	 * @param {number} iterations  the number of iterations for the algorithm
	 */
	
	
	function computeNodeDepths(nodes, edges, height, width, nodeGap, iterations, orient) {
	  var nodesByBreadth = prepareNodesByBreadth(nodes, orient);
	  initializeNodeDepth(nodesByBreadth, edges, height, width, nodeGap, orient);
	  resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
	
	  for (var alpha = 1; iterations > 0; iterations--) {
	    // 0.99 is a experience parameter, ensure that each iterations of
	    // changes as small as possible.
	    alpha *= 0.99;
	    relaxRightToLeft(nodesByBreadth, alpha, orient);
	    resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
	    relaxLeftToRight(nodesByBreadth, alpha, orient);
	    resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
	  }
	}
	
	function prepareNodesByBreadth(nodes, orient) {
	  var nodesByBreadth = [];
	  var keyAttr = orient === 'vertical' ? 'y' : 'x';
	  var groupResult = groupData(nodes, function (node) {
	    return node.getLayout()[keyAttr];
	  });
	  groupResult.keys.sort(function (a, b) {
	    return a - b;
	  });
	  zrUtil.each(groupResult.keys, function (key) {
	    nodesByBreadth.push(groupResult.buckets.get(key));
	  });
	  return nodesByBreadth;
	}
	/**
	 * Compute the original y-position for each node
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
	 *     group by the array of all sankey nodes based on the nodes x-position.
	 * @param {module:echarts/data/Graph~Edge} edges  edge of sankey view
	 * @param {number} height  the whole height of the area to draw the view
	 * @param {number} nodeGap  the vertical distance between two nodes
	 */
	
	
	function initializeNodeDepth(nodesByBreadth, edges, height, width, nodeGap, orient) {
	  var minKy = Infinity;
	  zrUtil.each(nodesByBreadth, function (nodes) {
	    var n = nodes.length;
	    var sum = 0;
	    zrUtil.each(nodes, function (node) {
	      sum += node.getLayout().value;
	    });
	    var ky = orient === 'vertical' ? (width - (n - 1) * nodeGap) / sum : (height - (n - 1) * nodeGap) / sum;
	
	    if (ky < minKy) {
	      minKy = ky;
	    }
	  });
	  zrUtil.each(nodesByBreadth, function (nodes) {
	    zrUtil.each(nodes, function (node, i) {
	      var nodeDy = node.getLayout().value * minKy;
	
	      if (orient === 'vertical') {
	        node.setLayout({
	          x: i
	        }, true);
	        node.setLayout({
	          dx: nodeDy
	        }, true);
	      } else {
	        node.setLayout({
	          y: i
	        }, true);
	        node.setLayout({
	          dy: nodeDy
	        }, true);
	      }
	    });
	  });
	  zrUtil.each(edges, function (edge) {
	    var edgeDy = +edge.getValue() * minKy;
	    edge.setLayout({
	      dy: edgeDy
	    }, true);
	  });
	}
	/**
	 * Resolve the collision of initialized depth (y-position)
	 *
	 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
	 *     group by the array of all sankey nodes based on the nodes x-position.
	 * @param {number} nodeGap  the vertical distance between two nodes
	 * @param {number} height  the whole height of the area to draw the view
	 */
	
	
	function resolveCollisions(nodesByBreadth, nodeGap, height, width, orient) {
	  var keyAttr = orient === 'vertical' ? 'x' : 'y';
	  zrUtil.each(nodesByBreadth, function (nodes) {
	    nodes.sort(function (a, b) {
	      return a.getLayout()[keyAttr] - b.getLayout()[keyAttr];
	    });
	    var nodeX;
	    var node;
	    var dy;
	    var y0 = 0;
	    var n = nodes.length;
	    var nodeDyAttr = orient === 'vertical' ? 'dx' : 'dy';
	
	    for (var i = 0; i < n; i++) {
	      node = nodes[i];
	      dy = y0 - node.getLayout()[keyAttr];
	
	      if (dy > 0) {
	        nodeX = node.getLayout()[keyAttr] + dy;
	        orient === 'vertical' ? node.setLayout({
	          x: nodeX
	        }, true) : node.setLayout({
	          y: nodeX
	        }, true);
	      }
	
	      y0 = node.getLayout()[keyAttr] + node.getLayout()[nodeDyAttr] + nodeGap;
	    }
	
	    var viewWidth = orient === 'vertical' ? width : height; // If the bottommost node goes outside the bounds, push it back up
	
	    dy = y0 - nodeGap - viewWidth;
	
	    if (dy > 0) {
	      nodeX = node.getLayout()[keyAttr] - dy;
	      orient === 'vertical' ? node.setLayout({
	        x: nodeX
	      }, true) : node.setLayout({
	        y: nodeX
	      }, true);
	      y0 = nodeX;
	
	      for (i = n - 2; i >= 0; --i) {
	        node = nodes[i];
	        dy = node.getLayout()[keyAttr] + node.getLayout()[nodeDyAttr] + nodeGap - y0;
	
	        if (dy > 0) {
	          nodeX = node.getLayout()[keyAttr] - dy;
	          orient === 'vertical' ? node.setLayout({
	            x: nodeX
	          }, true) : node.setLayout({
	            y: nodeX
	          }, true);
	        }
	
	        y0 = node.getLayout()[keyAttr];
	      }
	    }
	  });
	}
	/**
	 * Change the y-position of the nodes, except most the right side nodes
	 *
	 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
	 *     group by the array of all sankey nodes based on the node x-position.
	 * @param {number} alpha  parameter used to adjust the nodes y-position
	 */
	
	
	function relaxRightToLeft(nodesByBreadth, alpha, orient) {
	  zrUtil.each(nodesByBreadth.slice().reverse(), function (nodes) {
	    zrUtil.each(nodes, function (node) {
	      if (node.outEdges.length) {
	        var y = sum(node.outEdges, weightedTarget, orient) / sum(node.outEdges, getEdgeValue, orient);
	
	        if (isNaN(y)) {
	          var len = node.outEdges.length;
	          y = len ? sum(node.outEdges, centerTarget, orient) / len : 0;
	        }
	
	        if (orient === 'vertical') {
	          var nodeX = node.getLayout().x + (y - center(node, orient)) * alpha;
	          node.setLayout({
	            x: nodeX
	          }, true);
	        } else {
	          var nodeY = node.getLayout().y + (y - center(node, orient)) * alpha;
	          node.setLayout({
	            y: nodeY
	          }, true);
	        }
	      }
	    });
	  });
	}
	
	function weightedTarget(edge, orient) {
	  return center(edge.node2, orient) * edge.getValue();
	}
	
	function centerTarget(edge, orient) {
	  return center(edge.node2, orient);
	}
	
	function weightedSource(edge, orient) {
	  return center(edge.node1, orient) * edge.getValue();
	}
	
	function centerSource(edge, orient) {
	  return center(edge.node1, orient);
	}
	
	function center(node, orient) {
	  return orient === 'vertical' ? node.getLayout().x + node.getLayout().dx / 2 : node.getLayout().y + node.getLayout().dy / 2;
	}
	
	function getEdgeValue(edge) {
	  return edge.getValue();
	}
	
	function sum(array, cb, orient) {
	  var sum = 0;
	  var len = array.length;
	  var i = -1;
	
	  while (++i < len) {
	    var value = +cb.call(array, array[i], orient);
	
	    if (!isNaN(value)) {
	      sum += value;
	    }
	  }
	
	  return sum;
	}
	/**
	 * Change the y-position of the nodes, except most the left side nodes
	 *
	 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
	 *     group by the array of all sankey nodes based on the node x-position.
	 * @param {number} alpha  parameter used to adjust the nodes y-position
	 */
	
	
	function relaxLeftToRight(nodesByBreadth, alpha, orient) {
	  zrUtil.each(nodesByBreadth, function (nodes) {
	    zrUtil.each(nodes, function (node) {
	      if (node.inEdges.length) {
	        var y = sum(node.inEdges, weightedSource, orient) / sum(node.inEdges, getEdgeValue, orient);
	
	        if (isNaN(y)) {
	          var len = node.inEdges.length;
	          y = len ? sum(node.inEdges, centerSource, orient) / len : 0;
	        }
	
	        if (orient === 'vertical') {
	          var nodeX = node.getLayout().x + (y - center(node, orient)) * alpha;
	          node.setLayout({
	            x: nodeX
	          }, true);
	        } else {
	          var nodeY = node.getLayout().y + (y - center(node, orient)) * alpha;
	          node.setLayout({
	            y: nodeY
	          }, true);
	        }
	      }
	    });
	  });
	}
	/**
	 * Compute the depth(y-position) of each edge
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 */
	
	
	function computeEdgeDepths(nodes, orient) {
	  var keyAttr = orient === 'vertical' ? 'x' : 'y';
	  zrUtil.each(nodes, function (node) {
	    node.outEdges.sort(function (a, b) {
	      return a.node2.getLayout()[keyAttr] - b.node2.getLayout()[keyAttr];
	    });
	    node.inEdges.sort(function (a, b) {
	      return a.node1.getLayout()[keyAttr] - b.node1.getLayout()[keyAttr];
	    });
	  });
	  zrUtil.each(nodes, function (node) {
	    var sy = 0;
	    var ty = 0;
	    zrUtil.each(node.outEdges, function (edge) {
	      edge.setLayout({
	        sy: sy
	      }, true);
	      sy += edge.getLayout().dy;
	    });
	    zrUtil.each(node.inEdges, function (edge) {
	      edge.setLayout({
	        ty: ty
	      }, true);
	      ty += edge.getLayout().dy;
	    });
	  });
	}
	
	module.exports = _default;

/***/ },
/* 1539 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var VisualMapping = __webpack_require__(168);
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel, payload) {
	  ecModel.eachSeriesByType('sankey', function (seriesModel) {
	    var graph = seriesModel.getGraph();
	    var nodes = graph.nodes;
	
	    if (nodes.length) {
	      var minValue = Infinity;
	      var maxValue = -Infinity;
	      zrUtil.each(nodes, function (node) {
	        var nodeValue = node.getLayout().value;
	
	        if (nodeValue < minValue) {
	          minValue = nodeValue;
	        }
	
	        if (nodeValue > maxValue) {
	          maxValue = nodeValue;
	        }
	      });
	      zrUtil.each(nodes, function (node) {
	        var mapping = new VisualMapping({
	          type: 'color',
	          mappingMethod: 'linear',
	          dataExtent: [minValue, maxValue],
	          visual: seriesModel.get('color')
	        });
	        var mapValueToColor = mapping.mapValueToVisual(node.getLayout().value);
	        var customColor = node.getModel().get('itemStyle.color');
	        customColor != null ? node.setVisual('color', customColor) : node.setVisual('color', mapValueToColor);
	      });
	    }
	  });
	}
	
	module.exports = _default;

/***/ },
/* 1540 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	__webpack_require__(1541);
	
	__webpack_require__(1542);
	
	var visualSymbol = __webpack_require__(169);
	
	var layoutPoints = __webpack_require__(266);
	
	__webpack_require__(261);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// import * as zrUtil from 'zrender/src/core/util';
	// In case developer forget to include grid component
	echarts.registerVisual(visualSymbol('scatter', 'circle'));
	echarts.registerLayout(layoutPoints('scatter')); // echarts.registerProcessor(function (ecModel, api) {
	//     ecModel.eachSeriesByType('scatter', function (seriesModel) {
	//         var data = seriesModel.getData();
	//         var coordSys = seriesModel.coordinateSystem;
	//         if (coordSys.type !== 'geo') {
	//             return;
	//         }
	//         var startPt = coordSys.pointToData([0, 0]);
	//         var endPt = coordSys.pointToData([api.getWidth(), api.getHeight()]);
	//         var dims = zrUtil.map(coordSys.dimensions, function (dim) {
	//             return data.mapDimension(dim);
	//         });
	//         var range = {};
	//         range[dims[0]] = [Math.min(startPt[0], endPt[0]), Math.max(startPt[0], endPt[0])];
	//         range[dims[1]] = [Math.min(startPt[1], endPt[1]), Math.max(startPt[1], endPt[1])];
	//         data.selectRange(range);
	//     });
	// });

/***/ },
/* 1541 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createListFromArray = __webpack_require__(122);
	
	var SeriesModel = __webpack_require__(58);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.scatter',
	  dependencies: ['grid', 'polar', 'geo', 'singleAxis', 'calendar'],
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(this.getSource(), this, {
	      useEncodeDefaulter: true
	    });
	  },
	  brushSelector: 'point',
	  getProgressive: function () {
	    var progressive = this.option.progressive;
	
	    if (progressive == null) {
	      // PENDING
	      return this.option.large ? 5e3 : this.get('progressive');
	    }
	
	    return progressive;
	  },
	  getProgressiveThreshold: function () {
	    var progressiveThreshold = this.option.progressiveThreshold;
	
	    if (progressiveThreshold == null) {
	      // PENDING
	      return this.option.large ? 1e4 : this.get('progressiveThreshold');
	    }
	
	    return progressiveThreshold;
	  },
	  defaultOption: {
	    coordinateSystem: 'cartesian2d',
	    zlevel: 0,
	    z: 2,
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // Cartesian coordinate system
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // Polar coordinate system
	    // polarIndex: 0,
	    // Geo coordinate system
	    // geoIndex: 0,
	    // symbol: null,        // 图形类型
	    symbolSize: 10,
	    // 图形大小，半宽（半径）参数，当图形为方向或菱形则总宽度为symbolSize * 2
	    // symbolRotate: null,  // 图形旋转控制
	    large: false,
	    // Available when large is true
	    largeThreshold: 2000,
	    // cursor: null,
	    // label: {
	    // show: false
	    // distance: 5,
	    // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
	    // position: 默认自适应，水平布局为'top'，垂直布局为'right'，可选为
	    //           'inside'|'left'|'right'|'top'|'bottom'
	    // 默认使用全局文本样式，详见TEXTSTYLE
	    // },
	    itemStyle: {
	      opacity: 0.8 // color: 各异
	
	    },
	    // If clip the overflow graphics
	    // Works on cartesian / polar series
	    clip: true // progressive: null
	
	  }
	});
	
	module.exports = _default;

/***/ },
/* 1542 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var SymbolDraw = __webpack_require__(258);
	
	var LargeSymbolDraw = __webpack_require__(1502);
	
	var pointsLayout = __webpack_require__(266);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.extendChartView({
	  type: 'scatter',
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	
	    var symbolDraw = this._updateSymbolDraw(data, seriesModel);
	
	    symbolDraw.updateData(data, {
	      // TODO
	      // If this parameter should be a shape or a bounding volume
	      // shape will be more general.
	      // But bounding volume like bounding rect will be much faster in the contain calculation
	      clipShape: this._getClipShape(seriesModel)
	    });
	    this._finished = true;
	  },
	  incrementalPrepareRender: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	
	    var symbolDraw = this._updateSymbolDraw(data, seriesModel);
	
	    symbolDraw.incrementalPrepareUpdate(data);
	    this._finished = false;
	  },
	  incrementalRender: function (taskParams, seriesModel, ecModel) {
	    this._symbolDraw.incrementalUpdate(taskParams, seriesModel.getData(), {
	      clipShape: this._getClipShape(seriesModel)
	    });
	
	    this._finished = taskParams.end === seriesModel.getData().count();
	  },
	  updateTransform: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData(); // Must mark group dirty and make sure the incremental layer will be cleared
	    // PENDING
	
	    this.group.dirty();
	
	    if (!this._finished || data.count() > 1e4 || !this._symbolDraw.isPersistent()) {
	      return {
	        update: true
	      };
	    } else {
	      var res = pointsLayout().reset(seriesModel);
	
	      if (res.progress) {
	        res.progress({
	          start: 0,
	          end: data.count()
	        }, data);
	      }
	
	      this._symbolDraw.updateLayout(data);
	    }
	  },
	  _getClipShape: function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	    var clipArea = coordSys && coordSys.getArea && coordSys.getArea();
	    return seriesModel.get('clip', true) ? clipArea : null;
	  },
	  _updateSymbolDraw: function (data, seriesModel) {
	    var symbolDraw = this._symbolDraw;
	    var pipelineContext = seriesModel.pipelineContext;
	    var isLargeDraw = pipelineContext.large;
	
	    if (!symbolDraw || isLargeDraw !== this._isLargeDraw) {
	      symbolDraw && symbolDraw.remove();
	      symbolDraw = this._symbolDraw = isLargeDraw ? new LargeSymbolDraw() : new SymbolDraw();
	      this._isLargeDraw = isLargeDraw;
	      this.group.removeAll();
	    }
	
	    this.group.add(symbolDraw.group);
	    return symbolDraw;
	  },
	  remove: function (ecModel, api) {
	    this._symbolDraw && this._symbolDraw.remove(true);
	    this._symbolDraw = null;
	  },
	  dispose: function () {}
	});

/***/ },
/* 1543 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	__webpack_require__(1545);
	
	__webpack_require__(1546);
	
	__webpack_require__(1547);
	
	var dataColor = __webpack_require__(341);
	
	var sunburstLayout = __webpack_require__(1548);
	
	var dataFilter = __webpack_require__(267);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(zrUtil.curry(dataColor, 'sunburst'));
	echarts.registerLayout(zrUtil.curry(sunburstLayout, 'sunburst'));
	echarts.registerProcessor(zrUtil.curry(dataFilter, 'sunburst'));

/***/ },
/* 1544 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var graphic = __webpack_require__(16);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var NodeHighlightPolicy = {
	  NONE: 'none',
	  // not downplay others
	  DESCENDANT: 'descendant',
	  ANCESTOR: 'ancestor',
	  SELF: 'self'
	};
	var DEFAULT_SECTOR_Z = 2;
	var DEFAULT_TEXT_Z = 4;
	/**
	 * Sunburstce of Sunburst including Sector, Label, LabelLine
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 */
	
	function SunburstPiece(node, seriesModel, ecModel) {
	  graphic.Group.call(this);
	  var sector = new graphic.Sector({
	    z2: DEFAULT_SECTOR_Z
	  });
	  sector.seriesIndex = seriesModel.seriesIndex;
	  var text = new graphic.Text({
	    z2: DEFAULT_TEXT_Z,
	    silent: node.getModel('label').get('silent')
	  });
	  this.add(sector);
	  this.add(text);
	  this.updateData(true, node, 'normal', seriesModel, ecModel); // Hover to change label and labelLine
	
	  function onEmphasis() {
	    text.ignore = text.hoverIgnore;
	  }
	
	  function onNormal() {
	    text.ignore = text.normalIgnore;
	  }
	
	  this.on('emphasis', onEmphasis).on('normal', onNormal).on('mouseover', onEmphasis).on('mouseout', onNormal);
	}
	
	var SunburstPieceProto = SunburstPiece.prototype;
	
	SunburstPieceProto.updateData = function (firstCreate, node, state, seriesModel, ecModel) {
	  this.node = node;
	  node.piece = this;
	  seriesModel = seriesModel || this._seriesModel;
	  ecModel = ecModel || this._ecModel;
	  var sector = this.childAt(0);
	  sector.dataIndex = node.dataIndex;
	  var itemModel = node.getModel();
	  var layout = node.getLayout(); // if (!layout) {
	  //     console.log(node.getLayout());
	  // }
	
	  var sectorShape = zrUtil.extend({}, layout);
	  sectorShape.label = null;
	  var visualColor = getNodeColor(node, seriesModel, ecModel);
	  fillDefaultColor(node, seriesModel, visualColor);
	  var normalStyle = itemModel.getModel('itemStyle').getItemStyle();
	  var style;
	
	  if (state === 'normal') {
	    style = normalStyle;
	  } else {
	    var stateStyle = itemModel.getModel(state + '.itemStyle').getItemStyle();
	    style = zrUtil.merge(stateStyle, normalStyle);
	  }
	
	  style = zrUtil.defaults({
	    lineJoin: 'bevel',
	    fill: style.fill || visualColor
	  }, style);
	
	  if (firstCreate) {
	    sector.setShape(sectorShape);
	    sector.shape.r = layout.r0;
	    graphic.updateProps(sector, {
	      shape: {
	        r: layout.r
	      }
	    }, seriesModel, node.dataIndex);
	    sector.useStyle(style);
	  } else if (typeof style.fill === 'object' && style.fill.type || typeof sector.style.fill === 'object' && sector.style.fill.type) {
	    // Disable animation for gradient since no interpolation method
	    // is supported for gradient
	    graphic.updateProps(sector, {
	      shape: sectorShape
	    }, seriesModel);
	    sector.useStyle(style);
	  } else {
	    graphic.updateProps(sector, {
	      shape: sectorShape,
	      style: style
	    }, seriesModel);
	  }
	
	  this._updateLabel(seriesModel, visualColor, state);
	
	  var cursorStyle = itemModel.getShallow('cursor');
	  cursorStyle && sector.attr('cursor', cursorStyle);
	
	  if (firstCreate) {
	    var highlightPolicy = seriesModel.getShallow('highlightPolicy');
	
	    this._initEvents(sector, node, seriesModel, highlightPolicy);
	  }
	
	  this._seriesModel = seriesModel || this._seriesModel;
	  this._ecModel = ecModel || this._ecModel;
	  graphic.setHoverStyle(this);
	};
	
	SunburstPieceProto.onEmphasis = function (highlightPolicy) {
	  var that = this;
	  this.node.hostTree.root.eachNode(function (n) {
	    if (n.piece) {
	      if (that.node === n) {
	        n.piece.updateData(false, n, 'emphasis');
	      } else if (isNodeHighlighted(n, that.node, highlightPolicy)) {
	        n.piece.childAt(0).trigger('highlight');
	      } else if (highlightPolicy !== NodeHighlightPolicy.NONE) {
	        n.piece.childAt(0).trigger('downplay');
	      }
	    }
	  });
	};
	
	SunburstPieceProto.onNormal = function () {
	  this.node.hostTree.root.eachNode(function (n) {
	    if (n.piece) {
	      n.piece.updateData(false, n, 'normal');
	    }
	  });
	};
	
	SunburstPieceProto.onHighlight = function () {
	  this.updateData(false, this.node, 'highlight');
	};
	
	SunburstPieceProto.onDownplay = function () {
	  this.updateData(false, this.node, 'downplay');
	};
	
	SunburstPieceProto._updateLabel = function (seriesModel, visualColor, state) {
	  var itemModel = this.node.getModel();
	  var normalModel = itemModel.getModel('label');
	  var labelModel = state === 'normal' || state === 'emphasis' ? normalModel : itemModel.getModel(state + '.label');
	  var labelHoverModel = itemModel.getModel('emphasis.label');
	  var labelFormatter = labelModel.get('formatter'); // Use normal formatter if no state formatter is defined
	
	  var labelState = labelFormatter ? state : 'normal';
	  var text = zrUtil.retrieve(seriesModel.getFormattedLabel(this.node.dataIndex, labelState, null, null, 'label'), this.node.name);
	
	  if (getLabelAttr('show') === false) {
	    text = '';
	  }
	
	  var layout = this.node.getLayout();
	  var labelMinAngle = labelModel.get('minAngle');
	
	  if (labelMinAngle == null) {
	    labelMinAngle = normalModel.get('minAngle');
	  }
	
	  labelMinAngle = labelMinAngle / 180 * Math.PI;
	  var angle = layout.endAngle - layout.startAngle;
	
	  if (labelMinAngle != null && Math.abs(angle) < labelMinAngle) {
	    // Not displaying text when angle is too small
	    text = '';
	  }
	
	  var label = this.childAt(1);
	  graphic.setLabelStyle(label.style, label.hoverStyle || {}, normalModel, labelHoverModel, {
	    defaultText: labelModel.getShallow('show') ? text : null,
	    autoColor: visualColor,
	    useInsideStyle: true
	  });
	  var midAngle = (layout.startAngle + layout.endAngle) / 2;
	  var dx = Math.cos(midAngle);
	  var dy = Math.sin(midAngle);
	  var r;
	  var labelPosition = getLabelAttr('position');
	  var labelPadding = getLabelAttr('distance') || 0;
	  var textAlign = getLabelAttr('align');
	
	  if (labelPosition === 'outside') {
	    r = layout.r + labelPadding;
	    textAlign = midAngle > Math.PI / 2 ? 'right' : 'left';
	  } else {
	    if (!textAlign || textAlign === 'center') {
	      r = (layout.r + layout.r0) / 2;
	      textAlign = 'center';
	    } else if (textAlign === 'left') {
	      r = layout.r0 + labelPadding;
	
	      if (midAngle > Math.PI / 2) {
	        textAlign = 'right';
	      }
	    } else if (textAlign === 'right') {
	      r = layout.r - labelPadding;
	
	      if (midAngle > Math.PI / 2) {
	        textAlign = 'left';
	      }
	    }
	  }
	
	  label.attr('style', {
	    text: text,
	    textAlign: textAlign,
	    textVerticalAlign: getLabelAttr('verticalAlign') || 'middle',
	    opacity: getLabelAttr('opacity')
	  });
	  var textX = r * dx + layout.cx;
	  var textY = r * dy + layout.cy;
	  label.attr('position', [textX, textY]);
	  var rotateType = getLabelAttr('rotate');
	  var rotate = 0;
	
	  if (rotateType === 'radial') {
	    rotate = -midAngle;
	
	    if (rotate < -Math.PI / 2) {
	      rotate += Math.PI;
	    }
	  } else if (rotateType === 'tangential') {
	    rotate = Math.PI / 2 - midAngle;
	
	    if (rotate > Math.PI / 2) {
	      rotate -= Math.PI;
	    } else if (rotate < -Math.PI / 2) {
	      rotate += Math.PI;
	    }
	  } else if (typeof rotateType === 'number') {
	    rotate = rotateType * Math.PI / 180;
	  }
	
	  label.attr('rotation', rotate);
	
	  function getLabelAttr(name) {
	    var stateAttr = labelModel.get(name);
	
	    if (stateAttr == null) {
	      return normalModel.get(name);
	    } else {
	      return stateAttr;
	    }
	  }
	};
	
	SunburstPieceProto._initEvents = function (sector, node, seriesModel, highlightPolicy) {
	  sector.off('mouseover').off('mouseout').off('emphasis').off('normal');
	  var that = this;
	
	  var onEmphasis = function () {
	    that.onEmphasis(highlightPolicy);
	  };
	
	  var onNormal = function () {
	    that.onNormal();
	  };
	
	  var onDownplay = function () {
	    that.onDownplay();
	  };
	
	  var onHighlight = function () {
	    that.onHighlight();
	  };
	
	  if (seriesModel.isAnimationEnabled()) {
	    sector.on('mouseover', onEmphasis).on('mouseout', onNormal).on('emphasis', onEmphasis).on('normal', onNormal).on('downplay', onDownplay).on('highlight', onHighlight);
	  }
	};
	
	zrUtil.inherits(SunburstPiece, graphic.Group);
	var _default = SunburstPiece;
	/**
	 * Get node color
	 *
	 * @param {TreeNode} node the node to get color
	 * @param {module:echarts/model/Series} seriesModel series
	 * @param {module:echarts/model/Global} ecModel echarts defaults
	 */
	
	function getNodeColor(node, seriesModel, ecModel) {
	  // Color from visualMap
	  var visualColor = node.getVisual('color');
	  var visualMetaList = node.getVisual('visualMeta');
	
	  if (!visualMetaList || visualMetaList.length === 0) {
	    // Use first-generation color if has no visualMap
	    visualColor = null;
	  } // Self color or level color
	
	
	  var color = node.getModel('itemStyle').get('color');
	
	  if (color) {
	    return color;
	  } else if (visualColor) {
	    // Color mapping
	    return visualColor;
	  } else if (node.depth === 0) {
	    // Virtual root node
	    return ecModel.option.color[0];
	  } else {
	    // First-generation color
	    var length = ecModel.option.color.length;
	    color = ecModel.option.color[getRootId(node) % length];
	  }
	
	  return color;
	}
	/**
	 * Get index of root in sorted order
	 *
	 * @param {TreeNode} node current node
	 * @return {number} index in root
	 */
	
	
	function getRootId(node) {
	  var ancestor = node;
	
	  while (ancestor.depth > 1) {
	    ancestor = ancestor.parentNode;
	  }
	
	  var virtualRoot = node.getAncestors()[0];
	  return zrUtil.indexOf(virtualRoot.children, ancestor);
	}
	
	function isNodeHighlighted(node, activeNode, policy) {
	  if (policy === NodeHighlightPolicy.NONE) {
	    return false;
	  } else if (policy === NodeHighlightPolicy.SELF) {
	    return node === activeNode;
	  } else if (policy === NodeHighlightPolicy.ANCESTOR) {
	    return node === activeNode || node.isAncestorOf(activeNode);
	  } else {
	    return node === activeNode || node.isDescendantOf(activeNode);
	  }
	} // Fix tooltip callback function params.color incorrect when pick a default color
	
	
	function fillDefaultColor(node, seriesModel, color) {
	  var data = seriesModel.getData();
	  data.setItemVisual(node.dataIndex, 'color', color);
	}
	
	module.exports = _default;

/***/ },
/* 1545 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var SeriesModel = __webpack_require__(58);
	
	var Tree = __webpack_require__(474);
	
	var Model = __webpack_require__(48);
	
	var _treeHelper = __webpack_require__(164);
	
	var wrapTreePathInfo = _treeHelper.wrapTreePathInfo;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.sunburst',
	
	  /**
	   * @type {module:echarts/data/Tree~Node}
	   */
	  _viewRoot: null,
	  getInitialData: function (option, ecModel) {
	    // Create a virtual root.
	    var root = {
	      name: option.name,
	      children: option.data
	    };
	    completeTreeValue(root);
	    var levelModels = zrUtil.map(option.levels || [], function (levelDefine) {
	      return new Model(levelDefine, this, ecModel);
	    }, this); // Make sure always a new tree is created when setOption,
	    // in TreemapView, we check whether oldTree === newTree
	    // to choose mappings approach among old shapes and new shapes.
	
	    var tree = Tree.createTree(root, this, beforeLink);
	
	    function beforeLink(nodeData) {
	      nodeData.wrapMethod('getItemModel', function (model, idx) {
	        var node = tree.getNodeByDataIndex(idx);
	        var levelModel = levelModels[node.depth];
	        levelModel && (model.parentModel = levelModel);
	        return model;
	      });
	    }
	
	    return tree.data;
	  },
	  optionUpdated: function () {
	    this.resetViewRoot();
	  },
	
	  /*
	   * @override
	   */
	  getDataParams: function (dataIndex) {
	    var params = SeriesModel.prototype.getDataParams.apply(this, arguments);
	    var node = this.getData().tree.getNodeByDataIndex(dataIndex);
	    params.treePathInfo = wrapTreePathInfo(node, this);
	    return params;
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    // 默认全局居中
	    center: ['50%', '50%'],
	    radius: [0, '75%'],
	    // 默认顺时针
	    clockwise: true,
	    startAngle: 90,
	    // 最小角度改为0
	    minAngle: 0,
	    percentPrecision: 2,
	    // If still show when all data zero.
	    stillShowZeroSum: true,
	    // Policy of highlighting pieces when hover on one
	    // Valid values: 'none' (for not downplay others), 'descendant',
	    // 'ancestor', 'self'
	    highlightPolicy: 'descendant',
	    // 'rootToNode', 'link', or false
	    nodeClick: 'rootToNode',
	    renderLabelForZeroData: false,
	    label: {
	      // could be: 'radial', 'tangential', or 'none'
	      rotate: 'radial',
	      show: true,
	      opacity: 1,
	      // 'left' is for inner side of inside, and 'right' is for outter
	      // side for inside
	      align: 'center',
	      position: 'inside',
	      distance: 5,
	      silent: true
	    },
	    itemStyle: {
	      borderWidth: 1,
	      borderColor: 'white',
	      borderType: 'solid',
	      shadowBlur: 0,
	      shadowColor: 'rgba(0, 0, 0, 0.2)',
	      shadowOffsetX: 0,
	      shadowOffsetY: 0,
	      opacity: 1
	    },
	    highlight: {
	      itemStyle: {
	        opacity: 1
	      }
	    },
	    downplay: {
	      itemStyle: {
	        opacity: 0.5
	      },
	      label: {
	        opacity: 0.6
	      }
	    },
	    // Animation type canbe expansion, scale
	    animationType: 'expansion',
	    animationDuration: 1000,
	    animationDurationUpdate: 500,
	    animationEasing: 'cubicOut',
	    data: [],
	    levels: [],
	
	    /**
	     * Sort order.
	     *
	     * Valid values: 'desc', 'asc', null, or callback function.
	     * 'desc' and 'asc' for descend and ascendant order;
	     * null for not sorting;
	     * example of callback function:
	     * function(nodeA, nodeB) {
	     *     return nodeA.getValue() - nodeB.getValue();
	     * }
	     */
	    sort: 'desc'
	  },
	  getViewRoot: function () {
	    return this._viewRoot;
	  },
	
	  /**
	   * @param {module:echarts/data/Tree~Node} [viewRoot]
	   */
	  resetViewRoot: function (viewRoot) {
	    viewRoot ? this._viewRoot = viewRoot : viewRoot = this._viewRoot;
	    var root = this.getRawData().tree.root;
	
	    if (!viewRoot || viewRoot !== root && !root.contains(viewRoot)) {
	      this._viewRoot = root;
	    }
	  }
	});
	/**
	 * @param {Object} dataNode
	 */
	
	
	function completeTreeValue(dataNode) {
	  // Postorder travel tree.
	  // If value of none-leaf node is not set,
	  // calculate it by suming up the value of all children.
	  var sum = 0;
	  zrUtil.each(dataNode.children, function (child) {
	    completeTreeValue(child);
	    var childValue = child.value;
	    zrUtil.isArray(childValue) && (childValue = childValue[0]);
	    sum += childValue;
	  });
	  var thisValue = dataNode.value;
	
	  if (zrUtil.isArray(thisValue)) {
	    thisValue = thisValue[0];
	  }
	
	  if (thisValue == null || isNaN(thisValue)) {
	    thisValue = sum;
	  } // Value should not less than 0.
	
	
	  if (thisValue < 0) {
	    thisValue = 0;
	  }
	
	  zrUtil.isArray(dataNode.value) ? dataNode.value[0] = thisValue : dataNode.value = thisValue;
	}
	
	module.exports = _default;

/***/ },
/* 1546 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var ChartView = __webpack_require__(106);
	
	var SunburstPiece = __webpack_require__(1544);
	
	var DataDiffer = __webpack_require__(166);
	
	var _format = __webpack_require__(40);
	
	var windowOpen = _format.windowOpen;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var ROOT_TO_NODE_ACTION = 'sunburstRootToNode';
	var SunburstView = ChartView.extend({
	  type: 'sunburst',
	  init: function () {},
	  render: function (seriesModel, ecModel, api, payload) {
	    var that = this;
	    this.seriesModel = seriesModel;
	    this.api = api;
	    this.ecModel = ecModel;
	    var data = seriesModel.getData();
	    var virtualRoot = data.tree.root;
	    var newRoot = seriesModel.getViewRoot();
	    var group = this.group;
	    var renderLabelForZeroData = seriesModel.get('renderLabelForZeroData');
	    var newChildren = [];
	    newRoot.eachNode(function (node) {
	      newChildren.push(node);
	    });
	    var oldChildren = this._oldChildren || [];
	    dualTravel(newChildren, oldChildren);
	    renderRollUp(virtualRoot, newRoot);
	
	    if (payload && payload.highlight && payload.highlight.piece) {
	      var highlightPolicy = seriesModel.getShallow('highlightPolicy');
	      payload.highlight.piece.onEmphasis(highlightPolicy);
	    } else if (payload && payload.unhighlight) {
	      var piece = this.virtualPiece;
	
	      if (!piece && virtualRoot.children.length) {
	        piece = virtualRoot.children[0].piece;
	      }
	
	      if (piece) {
	        piece.onNormal();
	      }
	    }
	
	    this._initEvents();
	
	    this._oldChildren = newChildren;
	
	    function dualTravel(newChildren, oldChildren) {
	      if (newChildren.length === 0 && oldChildren.length === 0) {
	        return;
	      }
	
	      new DataDiffer(oldChildren, newChildren, getKey, getKey).add(processNode).update(processNode).remove(zrUtil.curry(processNode, null)).execute();
	
	      function getKey(node) {
	        return node.getId();
	      }
	
	      function processNode(newId, oldId) {
	        var newNode = newId == null ? null : newChildren[newId];
	        var oldNode = oldId == null ? null : oldChildren[oldId];
	        doRenderNode(newNode, oldNode);
	      }
	    }
	
	    function doRenderNode(newNode, oldNode) {
	      if (!renderLabelForZeroData && newNode && !newNode.getValue()) {
	        // Not render data with value 0
	        newNode = null;
	      }
	
	      if (newNode !== virtualRoot && oldNode !== virtualRoot) {
	        if (oldNode && oldNode.piece) {
	          if (newNode) {
	            // Update
	            oldNode.piece.updateData(false, newNode, 'normal', seriesModel, ecModel); // For tooltip
	
	            data.setItemGraphicEl(newNode.dataIndex, oldNode.piece);
	          } else {
	            // Remove
	            removeNode(oldNode);
	          }
	        } else if (newNode) {
	          // Add
	          var piece = new SunburstPiece(newNode, seriesModel, ecModel);
	          group.add(piece); // For tooltip
	
	          data.setItemGraphicEl(newNode.dataIndex, piece);
	        }
	      }
	    }
	
	    function removeNode(node) {
	      if (!node) {
	        return;
	      }
	
	      if (node.piece) {
	        group.remove(node.piece);
	        node.piece = null;
	      }
	    }
	
	    function renderRollUp(virtualRoot, viewRoot) {
	      if (viewRoot.depth > 0) {
	        // Render
	        if (that.virtualPiece) {
	          // Update
	          that.virtualPiece.updateData(false, virtualRoot, 'normal', seriesModel, ecModel);
	        } else {
	          // Add
	          that.virtualPiece = new SunburstPiece(virtualRoot, seriesModel, ecModel);
	          group.add(that.virtualPiece);
	        }
	
	        if (viewRoot.piece._onclickEvent) {
	          viewRoot.piece.off('click', viewRoot.piece._onclickEvent);
	        }
	
	        var event = function (e) {
	          that._rootToNode(viewRoot.parentNode);
	        };
	
	        viewRoot.piece._onclickEvent = event;
	        that.virtualPiece.on('click', event);
	      } else if (that.virtualPiece) {
	        // Remove
	        group.remove(that.virtualPiece);
	        that.virtualPiece = null;
	      }
	    }
	  },
	  dispose: function () {},
	
	  /**
	   * @private
	   */
	  _initEvents: function () {
	    var that = this;
	
	    var event = function (e) {
	      var targetFound = false;
	      var viewRoot = that.seriesModel.getViewRoot();
	      viewRoot.eachNode(function (node) {
	        if (!targetFound && node.piece && node.piece.childAt(0) === e.target) {
	          var nodeClick = node.getModel().get('nodeClick');
	
	          if (nodeClick === 'rootToNode') {
	            that._rootToNode(node);
	          } else if (nodeClick === 'link') {
	            var itemModel = node.getModel();
	            var link = itemModel.get('link');
	
	            if (link) {
	              var linkTarget = itemModel.get('target', true) || '_blank';
	              windowOpen(link, linkTarget);
	            }
	          }
	
	          targetFound = true;
	        }
	      });
	    };
	
	    if (this.group._onclickEvent) {
	      this.group.off('click', this.group._onclickEvent);
	    }
	
	    this.group.on('click', event);
	    this.group._onclickEvent = event;
	  },
	
	  /**
	   * @private
	   */
	  _rootToNode: function (node) {
	    if (node !== this.seriesModel.getViewRoot()) {
	      this.api.dispatchAction({
	        type: ROOT_TO_NODE_ACTION,
	        from: this.uid,
	        seriesId: this.seriesModel.id,
	        targetNode: node
	      });
	    }
	  },
	
	  /**
	   * @implement
	   */
	  containPoint: function (point, seriesModel) {
	    var treeRoot = seriesModel.getData();
	    var itemLayout = treeRoot.getItemLayout(0);
	
	    if (itemLayout) {
	      var dx = point[0] - itemLayout.cx;
	      var dy = point[1] - itemLayout.cy;
	      var radius = Math.sqrt(dx * dx + dy * dy);
	      return radius <= itemLayout.r && radius >= itemLayout.r0;
	    }
	  }
	});
	var _default = SunburstView;
	module.exports = _default;

/***/ },
/* 1547 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var helper = __webpack_require__(164);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @file Sunburst action
	 */
	var ROOT_TO_NODE_ACTION = 'sunburstRootToNode';
	echarts.registerAction({
	  type: ROOT_TO_NODE_ACTION,
	  update: 'updateView'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'sunburst',
	    query: payload
	  }, handleRootToNode);
	
	  function handleRootToNode(model, index) {
	    var targetInfo = helper.retrieveTargetInfo(payload, [ROOT_TO_NODE_ACTION], model);
	
	    if (targetInfo) {
	      var originViewRoot = model.getViewRoot();
	
	      if (originViewRoot) {
	        payload.direction = helper.aboveViewRoot(originViewRoot, targetInfo.node) ? 'rollUp' : 'drillDown';
	      }
	
	      model.resetViewRoot(targetInfo.node);
	    }
	  }
	});
	var HIGHLIGHT_ACTION = 'sunburstHighlight';
	echarts.registerAction({
	  type: HIGHLIGHT_ACTION,
	  update: 'updateView'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'sunburst',
	    query: payload
	  }, handleHighlight);
	
	  function handleHighlight(model, index) {
	    var targetInfo = helper.retrieveTargetInfo(payload, [HIGHLIGHT_ACTION], model);
	
	    if (targetInfo) {
	      payload.highlight = targetInfo.node;
	    }
	  }
	});
	var UNHIGHLIGHT_ACTION = 'sunburstUnhighlight';
	echarts.registerAction({
	  type: UNHIGHLIGHT_ACTION,
	  update: 'updateView'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'sunburst',
	    query: payload
	  }, handleUnhighlight);
	
	  function handleUnhighlight(model, index) {
	    payload.unhighlight = true;
	  }
	});

/***/ },
/* 1548 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _number = __webpack_require__(20);
	
	var parsePercent = _number.parsePercent;
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// var PI2 = Math.PI * 2;
	var RADIAN = Math.PI / 180;
	
	function _default(seriesType, ecModel, api, payload) {
	  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
	    var center = seriesModel.get('center');
	    var radius = seriesModel.get('radius');
	
	    if (!zrUtil.isArray(radius)) {
	      radius = [0, radius];
	    }
	
	    if (!zrUtil.isArray(center)) {
	      center = [center, center];
	    }
	
	    var width = api.getWidth();
	    var height = api.getHeight();
	    var size = Math.min(width, height);
	    var cx = parsePercent(center[0], width);
	    var cy = parsePercent(center[1], height);
	    var r0 = parsePercent(radius[0], size / 2);
	    var r = parsePercent(radius[1], size / 2);
	    var startAngle = -seriesModel.get('startAngle') * RADIAN;
	    var minAngle = seriesModel.get('minAngle') * RADIAN;
	    var virtualRoot = seriesModel.getData().tree.root;
	    var treeRoot = seriesModel.getViewRoot();
	    var rootDepth = treeRoot.depth;
	    var sort = seriesModel.get('sort');
	
	    if (sort != null) {
	      initChildren(treeRoot, sort);
	    }
	
	    var validDataCount = 0;
	    zrUtil.each(treeRoot.children, function (child) {
	      !isNaN(child.getValue()) && validDataCount++;
	    });
	    var sum = treeRoot.getValue(); // Sum may be 0
	
	    var unitRadian = Math.PI / (sum || validDataCount) * 2;
	    var renderRollupNode = treeRoot.depth > 0;
	    var levels = treeRoot.height - (renderRollupNode ? -1 : 1);
	    var rPerLevel = (r - r0) / (levels || 1);
	    var clockwise = seriesModel.get('clockwise');
	    var stillShowZeroSum = seriesModel.get('stillShowZeroSum'); // In the case some sector angle is smaller than minAngle
	    // var restAngle = PI2;
	    // var valueSumLargerThanMinAngle = 0;
	
	    var dir = clockwise ? 1 : -1;
	    /**
	     * Render a tree
	     * @return increased angle
	     */
	
	    var renderNode = function (node, startAngle) {
	      if (!node) {
	        return;
	      }
	
	      var endAngle = startAngle; // Render self
	
	      if (node !== virtualRoot) {
	        // Tree node is virtual, so it doesn't need to be drawn
	        var value = node.getValue();
	        var angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
	
	        if (angle < minAngle) {
	          angle = minAngle; // restAngle -= minAngle;
	        } // else {
	        //     valueSumLargerThanMinAngle += value;
	        // }
	
	
	        endAngle = startAngle + dir * angle;
	        var depth = node.depth - rootDepth - (renderRollupNode ? -1 : 1);
	        var rStart = r0 + rPerLevel * depth;
	        var rEnd = r0 + rPerLevel * (depth + 1);
	        var itemModel = node.getModel();
	
	        if (itemModel.get('r0') != null) {
	          rStart = parsePercent(itemModel.get('r0'), size / 2);
	        }
	
	        if (itemModel.get('r') != null) {
	          rEnd = parsePercent(itemModel.get('r'), size / 2);
	        }
	
	        node.setLayout({
	          angle: angle,
	          startAngle: startAngle,
	          endAngle: endAngle,
	          clockwise: clockwise,
	          cx: cx,
	          cy: cy,
	          r0: rStart,
	          r: rEnd
	        });
	      } // Render children
	
	
	      if (node.children && node.children.length) {
	        // currentAngle = startAngle;
	        var siblingAngle = 0;
	        zrUtil.each(node.children, function (node) {
	          siblingAngle += renderNode(node, startAngle + siblingAngle);
	        });
	      }
	
	      return endAngle - startAngle;
	    }; // Virtual root node for roll up
	
	
	    if (renderRollupNode) {
	      var rStart = r0;
	      var rEnd = r0 + rPerLevel;
	      var angle = Math.PI * 2;
	      virtualRoot.setLayout({
	        angle: angle,
	        startAngle: startAngle,
	        endAngle: startAngle + angle,
	        clockwise: clockwise,
	        cx: cx,
	        cy: cy,
	        r0: rStart,
	        r: rEnd
	      });
	    }
	
	    renderNode(treeRoot, startAngle);
	  });
	}
	/**
	 * Init node children by order and update visual
	 *
	 * @param {TreeNode} node  root node
	 * @param {boolean}  isAsc if is in ascendant order
	 */
	
	
	function initChildren(node, isAsc) {
	  var children = node.children || [];
	  node.children = sort(children, isAsc); // Init children recursively
	
	  if (children.length) {
	    zrUtil.each(node.children, function (child) {
	      initChildren(child, isAsc);
	    });
	  }
	}
	/**
	 * Sort children nodes
	 *
	 * @param {TreeNode[]}               children children of node to be sorted
	 * @param {string | function | null} sort sort method
	 *                                   See SunburstSeries.js for details.
	 */
	
	
	function sort(children, sortOrder) {
	  if (typeof sortOrder === 'function') {
	    return children.sort(sortOrder);
	  } else {
	    var isAsc = sortOrder === 'asc';
	    return children.sort(function (a, b) {
	      var diff = (a.getValue() - b.getValue()) * (isAsc ? 1 : -1);
	      return diff === 0 ? (a.dataIndex - b.dataIndex) * (isAsc ? -1 : 1) : diff;
	    });
	  }
	}
	
	module.exports = _default;

/***/ },
/* 1549 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	__webpack_require__(727);
	
	__webpack_require__(1550);
	
	__webpack_require__(1551);
	
	var themeRiverLayout = __webpack_require__(1552);
	
	var themeRiverVisual = __webpack_require__(1553);
	
	var dataFilter = __webpack_require__(267);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerLayout(themeRiverLayout);
	echarts.registerVisual(themeRiverVisual);
	echarts.registerProcessor(dataFilter('themeRiver'));

/***/ },
/* 1550 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SeriesModel = __webpack_require__(58);
	
	var createDimensions = __webpack_require__(207);
	
	var _dimensionHelper = __webpack_require__(264);
	
	var getDimensionTypeByAxis = _dimensionHelper.getDimensionTypeByAxis;
	
	var List = __webpack_require__(83);
	
	var zrUtil = __webpack_require__(3);
	
	var _model = __webpack_require__(24);
	
	var groupData = _model.groupData;
	
	var _format = __webpack_require__(40);
	
	var encodeHTML = _format.encodeHTML;
	
	var LegendVisualProvider = __webpack_require__(269);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var DATA_NAME_INDEX = 2;
	var ThemeRiverSeries = SeriesModel.extend({
	  type: 'series.themeRiver',
	  dependencies: ['singleAxis'],
	
	  /**
	   * @readOnly
	   * @type {module:zrender/core/util#HashMap}
	   */
	  nameMap: null,
	
	  /**
	   * @override
	   */
	  init: function (option) {
	    // eslint-disable-next-line
	    ThemeRiverSeries.superApply(this, 'init', arguments); // Put this function here is for the sake of consistency of code style.
	    // Enable legend selection for each data item
	    // Use a function instead of direct access because data reference may changed
	
	    this.legendVisualProvider = new LegendVisualProvider(zrUtil.bind(this.getData, this), zrUtil.bind(this.getRawData, this));
	  },
	
	  /**
	   * If there is no value of a certain point in the time for some event,set it value to 0.
	   *
	   * @param {Array} data  initial data in the option
	   * @return {Array}
	   */
	  fixData: function (data) {
	    var rawDataLength = data.length;
	    /**
	     * Make sure every layer data get the same keys.
	     * The value index tells which layer has visited.
	     * {
	     *  2014/01/01: -1
	     * }
	     */
	
	    var timeValueKeys = {}; // grouped data by name
	
	    var groupResult = groupData(data, function (item) {
	      if (!timeValueKeys.hasOwnProperty(item[0])) {
	        timeValueKeys[item[0]] = -1;
	      }
	
	      return item[2];
	    });
	    var layData = [];
	    groupResult.buckets.each(function (items, key) {
	      layData.push({
	        name: key,
	        dataList: items
	      });
	    });
	    var layerNum = layData.length;
	
	    for (var k = 0; k < layerNum; ++k) {
	      var name = layData[k].name;
	
	      for (var j = 0; j < layData[k].dataList.length; ++j) {
	        var timeValue = layData[k].dataList[j][0];
	        timeValueKeys[timeValue] = k;
	      }
	
	      for (var timeValue in timeValueKeys) {
	        if (timeValueKeys.hasOwnProperty(timeValue) && timeValueKeys[timeValue] !== k) {
	          timeValueKeys[timeValue] = k;
	          data[rawDataLength] = [];
	          data[rawDataLength][0] = timeValue;
	          data[rawDataLength][1] = 0;
	          data[rawDataLength][2] = name;
	          rawDataLength++;
	        }
	      }
	    }
	
	    return data;
	  },
	
	  /**
	   * @override
	   * @param  {Object} option  the initial option that user gived
	   * @param  {module:echarts/model/Model} ecModel  the model object for themeRiver option
	   * @return {module:echarts/data/List}
	   */
	  getInitialData: function (option, ecModel) {
	    var singleAxisModel = ecModel.queryComponents({
	      mainType: 'singleAxis',
	      index: this.get('singleAxisIndex'),
	      id: this.get('singleAxisId')
	    })[0];
	    var axisType = singleAxisModel.get('type'); // filter the data item with the value of label is undefined
	
	    var filterData = zrUtil.filter(option.data, function (dataItem) {
	      return dataItem[2] !== undefined;
	    }); // ??? TODO design a stage to transfer data for themeRiver and lines?
	
	    var data = this.fixData(filterData || []);
	    var nameList = [];
	    var nameMap = this.nameMap = zrUtil.createHashMap();
	    var count = 0;
	
	    for (var i = 0; i < data.length; ++i) {
	      nameList.push(data[i][DATA_NAME_INDEX]);
	
	      if (!nameMap.get(data[i][DATA_NAME_INDEX])) {
	        nameMap.set(data[i][DATA_NAME_INDEX], count);
	        count++;
	      }
	    }
	
	    var dimensionsInfo = createDimensions(data, {
	      coordDimensions: ['single'],
	      dimensionsDefine: [{
	        name: 'time',
	        type: getDimensionTypeByAxis(axisType)
	      }, {
	        name: 'value',
	        type: 'float'
	      }, {
	        name: 'name',
	        type: 'ordinal'
	      }],
	      encodeDefine: {
	        single: 0,
	        value: 1,
	        itemName: 2
	      }
	    });
	    var list = new List(dimensionsInfo, this);
	    list.initData(data);
	    return list;
	  },
	
	  /**
	   * The raw data is divided into multiple layers and each layer
	   *     has same name.
	   *
	   * @return {Array.<Array.<number>>}
	   */
	  getLayerSeries: function () {
	    var data = this.getData();
	    var lenCount = data.count();
	    var indexArr = [];
	
	    for (var i = 0; i < lenCount; ++i) {
	      indexArr[i] = i;
	    }
	
	    var timeDim = data.mapDimension('single'); // data group by name
	
	    var groupResult = groupData(indexArr, function (index) {
	      return data.get('name', index);
	    });
	    var layerSeries = [];
	    groupResult.buckets.each(function (items, key) {
	      items.sort(function (index1, index2) {
	        return data.get(timeDim, index1) - data.get(timeDim, index2);
	      });
	      layerSeries.push({
	        name: key,
	        indices: items
	      });
	    });
	    return layerSeries;
	  },
	
	  /**
	   * Get data indices for show tooltip content
	    * @param {Array.<string>|string} dim  single coordinate dimension
	   * @param {number} value axis value
	   * @param {module:echarts/coord/single/SingleAxis} baseAxis  single Axis used
	   *     the themeRiver.
	   * @return {Object} {dataIndices, nestestValue}
	   */
	  getAxisTooltipData: function (dim, value, baseAxis) {
	    if (!zrUtil.isArray(dim)) {
	      dim = dim ? [dim] : [];
	    }
	
	    var data = this.getData();
	    var layerSeries = this.getLayerSeries();
	    var indices = [];
	    var layerNum = layerSeries.length;
	    var nestestValue;
	
	    for (var i = 0; i < layerNum; ++i) {
	      var minDist = Number.MAX_VALUE;
	      var nearestIdx = -1;
	      var pointNum = layerSeries[i].indices.length;
	
	      for (var j = 0; j < pointNum; ++j) {
	        var theValue = data.get(dim[0], layerSeries[i].indices[j]);
	        var dist = Math.abs(theValue - value);
	
	        if (dist <= minDist) {
	          nestestValue = theValue;
	          minDist = dist;
	          nearestIdx = layerSeries[i].indices[j];
	        }
	      }
	
	      indices.push(nearestIdx);
	    }
	
	    return {
	      dataIndices: indices,
	      nestestValue: nestestValue
	    };
	  },
	
	  /**
	   * @override
	   * @param {number} dataIndex  index of data
	   */
	  formatTooltip: function (dataIndex) {
	    var data = this.getData();
	    var htmlName = data.getName(dataIndex);
	    var htmlValue = data.get(data.mapDimension('value'), dataIndex);
	
	    if (isNaN(htmlValue) || htmlValue == null) {
	      htmlValue = '-';
	    }
	
	    return encodeHTML(htmlName + ' : ' + htmlValue);
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'singleAxis',
	    // gap in axis's orthogonal orientation
	    boundaryGap: ['10%', '10%'],
	    // legendHoverLink: true,
	    singleAxisIndex: 0,
	    animationEasing: 'linear',
	    label: {
	      margin: 4,
	      show: true,
	      position: 'left',
	      color: '#000',
	      fontSize: 11
	    },
	    emphasis: {
	      label: {
	        show: true
	      }
	    }
	  }
	});
	var _default = ThemeRiverSeries;
	module.exports = _default;

/***/ },
/* 1551 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var _poly = __webpack_require__(706);
	
	var Polygon = _poly.Polygon;
	
	var graphic = __webpack_require__(16);
	
	var _util = __webpack_require__(3);
	
	var bind = _util.bind;
	var extend = _util.extend;
	
	var DataDiffer = __webpack_require__(166);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendChartView({
	  type: 'themeRiver',
	  init: function () {
	    this._layers = [];
	  },
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    var group = this.group;
	    var layerSeries = seriesModel.getLayerSeries();
	    var layoutInfo = data.getLayout('layoutInfo');
	    var rect = layoutInfo.rect;
	    var boundaryGap = layoutInfo.boundaryGap;
	    group.attr('position', [0, rect.y + boundaryGap[0]]);
	
	    function keyGetter(item) {
	      return item.name;
	    }
	
	    var dataDiffer = new DataDiffer(this._layersSeries || [], layerSeries, keyGetter, keyGetter);
	    var newLayersGroups = {};
	    dataDiffer.add(bind(process, this, 'add')).update(bind(process, this, 'update')).remove(bind(process, this, 'remove')).execute();
	
	    function process(status, idx, oldIdx) {
	      var oldLayersGroups = this._layers;
	
	      if (status === 'remove') {
	        group.remove(oldLayersGroups[idx]);
	        return;
	      }
	
	      var points0 = [];
	      var points1 = [];
	      var color;
	      var indices = layerSeries[idx].indices;
	
	      for (var j = 0; j < indices.length; j++) {
	        var layout = data.getItemLayout(indices[j]);
	        var x = layout.x;
	        var y0 = layout.y0;
	        var y = layout.y;
	        points0.push([x, y0]);
	        points1.push([x, y0 + y]);
	        color = data.getItemVisual(indices[j], 'color');
	      }
	
	      var polygon;
	      var text;
	      var textLayout = data.getItemLayout(indices[0]);
	      var itemModel = data.getItemModel(indices[j - 1]);
	      var labelModel = itemModel.getModel('label');
	      var margin = labelModel.get('margin');
	
	      if (status === 'add') {
	        var layerGroup = newLayersGroups[idx] = new graphic.Group();
	        polygon = new Polygon({
	          shape: {
	            points: points0,
	            stackedOnPoints: points1,
	            smooth: 0.4,
	            stackedOnSmooth: 0.4,
	            smoothConstraint: false
	          },
	          z2: 0
	        });
	        text = new graphic.Text({
	          style: {
	            x: textLayout.x - margin,
	            y: textLayout.y0 + textLayout.y / 2
	          }
	        });
	        layerGroup.add(polygon);
	        layerGroup.add(text);
	        group.add(layerGroup);
	        polygon.setClipPath(createGridClipShape(polygon.getBoundingRect(), seriesModel, function () {
	          polygon.removeClipPath();
	        }));
	      } else {
	        var layerGroup = oldLayersGroups[oldIdx];
	        polygon = layerGroup.childAt(0);
	        text = layerGroup.childAt(1);
	        group.add(layerGroup);
	        newLayersGroups[idx] = layerGroup;
	        graphic.updateProps(polygon, {
	          shape: {
	            points: points0,
	            stackedOnPoints: points1
	          }
	        }, seriesModel);
	        graphic.updateProps(text, {
	          style: {
	            x: textLayout.x - margin,
	            y: textLayout.y0 + textLayout.y / 2
	          }
	        }, seriesModel);
	      }
	
	      var hoverItemStyleModel = itemModel.getModel('emphasis.itemStyle');
	      var itemStyleModel = itemModel.getModel('itemStyle');
	      graphic.setTextStyle(text.style, labelModel, {
	        text: labelModel.get('show') ? seriesModel.getFormattedLabel(indices[j - 1], 'normal') || data.getName(indices[j - 1]) : null,
	        textVerticalAlign: 'middle'
	      });
	      polygon.setStyle(extend({
	        fill: color
	      }, itemStyleModel.getItemStyle(['color'])));
	      graphic.setHoverStyle(polygon, hoverItemStyleModel.getItemStyle());
	    }
	
	    this._layersSeries = layerSeries;
	    this._layers = newLayersGroups;
	  },
	  dispose: function () {}
	}); // add animation to the view
	
	
	function createGridClipShape(rect, seriesModel, cb) {
	  var rectEl = new graphic.Rect({
	    shape: {
	      x: rect.x - 10,
	      y: rect.y - 10,
	      width: 0,
	      height: rect.height + 20
	    }
	  });
	  graphic.initProps(rectEl, {
	    shape: {
	      width: rect.width + 20,
	      height: rect.height + 20
	    }
	  }, seriesModel, cb);
	  return rectEl;
	}
	
	module.exports = _default;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(360)))

/***/ },
/* 1552 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var numberUtil = __webpack_require__(20);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel, api) {
	  ecModel.eachSeriesByType('themeRiver', function (seriesModel) {
	    var data = seriesModel.getData();
	    var single = seriesModel.coordinateSystem;
	    var layoutInfo = {}; // use the axis boundingRect for view
	
	    var rect = single.getRect();
	    layoutInfo.rect = rect;
	    var boundaryGap = seriesModel.get('boundaryGap');
	    var axis = single.getAxis();
	    layoutInfo.boundaryGap = boundaryGap;
	
	    if (axis.orient === 'horizontal') {
	      boundaryGap[0] = numberUtil.parsePercent(boundaryGap[0], rect.height);
	      boundaryGap[1] = numberUtil.parsePercent(boundaryGap[1], rect.height);
	      var height = rect.height - boundaryGap[0] - boundaryGap[1];
	      themeRiverLayout(data, seriesModel, height);
	    } else {
	      boundaryGap[0] = numberUtil.parsePercent(boundaryGap[0], rect.width);
	      boundaryGap[1] = numberUtil.parsePercent(boundaryGap[1], rect.width);
	      var width = rect.width - boundaryGap[0] - boundaryGap[1];
	      themeRiverLayout(data, seriesModel, width);
	    }
	
	    data.setLayout('layoutInfo', layoutInfo);
	  });
	}
	/**
	 * The layout information about themeriver
	 *
	 * @param {module:echarts/data/List} data  data in the series
	 * @param {module:echarts/model/Series} seriesModel  the model object of themeRiver series
	 * @param {number} height  value used to compute every series height
	 */
	
	
	function themeRiverLayout(data, seriesModel, height) {
	  if (!data.count()) {
	    return;
	  }
	
	  var coordSys = seriesModel.coordinateSystem; // the data in each layer are organized into a series.
	
	  var layerSeries = seriesModel.getLayerSeries(); // the points in each layer.
	
	  var timeDim = data.mapDimension('single');
	  var valueDim = data.mapDimension('value');
	  var layerPoints = zrUtil.map(layerSeries, function (singleLayer) {
	    return zrUtil.map(singleLayer.indices, function (idx) {
	      var pt = coordSys.dataToPoint(data.get(timeDim, idx));
	      pt[1] = data.get(valueDim, idx);
	      return pt;
	    });
	  });
	  var base = computeBaseline(layerPoints);
	  var baseLine = base.y0;
	  var ky = height / base.max; // set layout information for each item.
	
	  var n = layerSeries.length;
	  var m = layerSeries[0].indices.length;
	  var baseY0;
	
	  for (var j = 0; j < m; ++j) {
	    baseY0 = baseLine[j] * ky;
	    data.setItemLayout(layerSeries[0].indices[j], {
	      layerIndex: 0,
	      x: layerPoints[0][j][0],
	      y0: baseY0,
	      y: layerPoints[0][j][1] * ky
	    });
	
	    for (var i = 1; i < n; ++i) {
	      baseY0 += layerPoints[i - 1][j][1] * ky;
	      data.setItemLayout(layerSeries[i].indices[j], {
	        layerIndex: i,
	        x: layerPoints[i][j][0],
	        y0: baseY0,
	        y: layerPoints[i][j][1] * ky
	      });
	    }
	  }
	}
	/**
	 * Compute the baseLine of the rawdata
	 * Inspired by Lee Byron's paper Stacked Graphs - Geometry & Aesthetics
	 *
	 * @param  {Array.<Array>} data  the points in each layer
	 * @return {Object}
	 */
	
	
	function computeBaseline(data) {
	  var layerNum = data.length;
	  var pointNum = data[0].length;
	  var sums = [];
	  var y0 = [];
	  var max = 0;
	  var temp;
	  var base = {};
	
	  for (var i = 0; i < pointNum; ++i) {
	    for (var j = 0, temp = 0; j < layerNum; ++j) {
	      temp += data[j][i][1];
	    }
	
	    if (temp > max) {
	      max = temp;
	    }
	
	    sums.push(temp);
	  }
	
	  for (var k = 0; k < pointNum; ++k) {
	    y0[k] = (max - sums[k]) / 2;
	  }
	
	  max = 0;
	
	  for (var l = 0; l < pointNum; ++l) {
	    var sum = sums[l] + y0[l];
	
	    if (sum > max) {
	      max = sum;
	    }
	  }
	
	  base.y0 = y0;
	  base.max = max;
	  return base;
	}
	
	module.exports = _default;

/***/ },
/* 1553 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(3);
	
	var createHashMap = _util.createHashMap;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  ecModel.eachSeriesByType('themeRiver', function (seriesModel) {
	    var data = seriesModel.getData();
	    var rawData = seriesModel.getRawData();
	    var colorList = seriesModel.get('color');
	    var idxMap = createHashMap();
	    data.each(function (idx) {
	      idxMap.set(data.getRawIndex(idx), idx);
	    });
	    rawData.each(function (rawIndex) {
	      var name = rawData.getName(rawIndex);
	      var color = colorList[(seriesModel.nameMap.get(name) - 1) % colorList.length];
	      rawData.setItemVisual(rawIndex, 'color', color);
	      var idx = idxMap.get(rawIndex);
	
	      if (idx != null) {
	        data.setItemVisual(idx, 'color', color);
	      }
	    });
	  });
	}
	
	module.exports = _default;

/***/ },
/* 1554 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	__webpack_require__(1555);
	
	__webpack_require__(1556);
	
	__webpack_require__(1558);
	
	var visualSymbol = __webpack_require__(169);
	
	var treeLayout = __webpack_require__(1559);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(visualSymbol('tree', 'circle'));
	echarts.registerLayout(treeLayout);

/***/ },
/* 1555 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SeriesModel = __webpack_require__(58);
	
	var Tree = __webpack_require__(474);
	
	var _format = __webpack_require__(40);
	
	var encodeHTML = _format.encodeHTML;
	
	var Model = __webpack_require__(48);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.tree',
	  layoutInfo: null,
	  // can support the position parameters 'left', 'top','right','bottom', 'width',
	  // 'height' in the setOption() with 'merge' mode normal.
	  layoutMode: 'box',
	
	  /**
	   * Init a tree data structure from data in option series
	   * @param  {Object} option  the object used to config echarts view
	   * @return {module:echarts/data/List} storage initial data
	   */
	  getInitialData: function (option) {
	    //create an virtual root
	    var root = {
	      name: option.name,
	      children: option.data
	    };
	    var leaves = option.leaves || {};
	    var leavesModel = new Model(leaves, this, this.ecModel);
	    var tree = Tree.createTree(root, this, beforeLink);
	
	    function beforeLink(nodeData) {
	      nodeData.wrapMethod('getItemModel', function (model, idx) {
	        var node = tree.getNodeByDataIndex(idx);
	
	        if (!node.children.length || !node.isExpand) {
	          model.parentModel = leavesModel;
	        }
	
	        return model;
	      });
	    }
	
	    var treeDepth = 0;
	    tree.eachNode('preorder', function (node) {
	      if (node.depth > treeDepth) {
	        treeDepth = node.depth;
	      }
	    });
	    var expandAndCollapse = option.expandAndCollapse;
	    var expandTreeDepth = expandAndCollapse && option.initialTreeDepth >= 0 ? option.initialTreeDepth : treeDepth;
	    tree.root.eachNode('preorder', function (node) {
	      var item = node.hostTree.data.getRawDataItem(node.dataIndex); // Add item.collapsed != null, because users can collapse node original in the series.data.
	
	      node.isExpand = item && item.collapsed != null ? !item.collapsed : node.depth <= expandTreeDepth;
	    });
	    return tree.data;
	  },
	
	  /**
	   * Make the configuration 'orient' backward compatibly, with 'horizontal = LR', 'vertical = TB'.
	   * @returns {string} orient
	   */
	  getOrient: function () {
	    var orient = this.get('orient');
	
	    if (orient === 'horizontal') {
	      orient = 'LR';
	    } else if (orient === 'vertical') {
	      orient = 'TB';
	    }
	
	    return orient;
	  },
	  setZoom: function (zoom) {
	    this.option.zoom = zoom;
	  },
	  setCenter: function (center) {
	    this.option.center = center;
	  },
	
	  /**
	   * @override
	   * @param {number} dataIndex
	   */
	  formatTooltip: function (dataIndex) {
	    var tree = this.getData().tree;
	    var realRoot = tree.root.children[0];
	    var node = tree.getNodeByDataIndex(dataIndex);
	    var value = node.getValue();
	    var name = node.name;
	
	    while (node && node !== realRoot) {
	      name = node.parentNode.name + '.' + name;
	      node = node.parentNode;
	    }
	
	    return encodeHTML(name + (isNaN(value) || value == null ? '' : ' : ' + value));
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'view',
	    // the position of the whole view
	    left: '12%',
	    top: '12%',
	    right: '12%',
	    bottom: '12%',
	    // the layout of the tree, two value can be selected, 'orthogonal' or 'radial'
	    layout: 'orthogonal',
	    // value can be 'polyline'
	    edgeShape: 'curve',
	    edgeForkPosition: '50%',
	    // true | false | 'move' | 'scale', see module:component/helper/RoamController.
	    roam: false,
	    // Symbol size scale ratio in roam
	    nodeScaleRatio: 0.4,
	    // Default on center of graph
	    center: null,
	    zoom: 1,
	    // The orient of orthoginal layout, can be setted to 'LR', 'TB', 'RL', 'BT'.
	    // and the backward compatibility configuration 'horizontal = LR', 'vertical = TB'.
	    orient: 'LR',
	    symbol: 'emptyCircle',
	    symbolSize: 7,
	    expandAndCollapse: true,
	    initialTreeDepth: 2,
	    lineStyle: {
	      color: '#ccc',
	      width: 1.5,
	      curveness: 0.5
	    },
	    itemStyle: {
	      color: 'lightsteelblue',
	      borderColor: '#c23531',
	      borderWidth: 1.5
	    },
	    label: {
	      show: true,
	      color: '#555'
	    },
	    leaves: {
	      label: {
	        show: true
	      }
	    },
	    animationEasing: 'linear',
	    animationDuration: 700,
	    animationDurationUpdate: 1000
	  }
	});
	
	module.exports = _default;

/***/ },
/* 1556 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var graphic = __webpack_require__(16);
	
	var SymbolClz = __webpack_require__(330);
	
	var _layoutHelper = __webpack_require__(708);
	
	var radialCoordinate = _layoutHelper.radialCoordinate;
	
	var echarts = __webpack_require__(13);
	
	var bbox = __webpack_require__(292);
	
	var View = __webpack_require__(469);
	
	var roamHelper = __webpack_require__(464);
	
	var RoamController = __webpack_require__(262);
	
	var _cursorHelper = __webpack_require__(334);
	
	var onIrrelevantElement = _cursorHelper.onIrrelevantElement;
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	var _number = __webpack_require__(20);
	
	var parsePercent = _number.parsePercent;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var TreeShape = graphic.extendShape({
	  shape: {
	    parentPoint: [],
	    childPoints: [],
	    orient: '',
	    forkPosition: ''
	  },
	  style: {
	    stroke: '#000',
	    fill: null
	  },
	  buildPath: function (ctx, shape) {
	    var childPoints = shape.childPoints;
	    var childLen = childPoints.length;
	    var parentPoint = shape.parentPoint;
	    var firstChildPos = childPoints[0];
	    var lastChildPos = childPoints[childLen - 1];
	
	    if (childLen === 1) {
	      ctx.moveTo(parentPoint[0], parentPoint[1]);
	      ctx.lineTo(firstChildPos[0], firstChildPos[1]);
	      return;
	    }
	
	    var orient = shape.orient;
	    var forkDim = orient === 'TB' || orient === 'BT' ? 0 : 1;
	    var otherDim = 1 - forkDim;
	    var forkPosition = parsePercent(shape.forkPosition, 1);
	    var tmpPoint = [];
	    tmpPoint[forkDim] = parentPoint[forkDim];
	    tmpPoint[otherDim] = parentPoint[otherDim] + (lastChildPos[otherDim] - parentPoint[otherDim]) * forkPosition;
	    ctx.moveTo(parentPoint[0], parentPoint[1]);
	    ctx.lineTo(tmpPoint[0], tmpPoint[1]);
	    ctx.moveTo(firstChildPos[0], firstChildPos[1]);
	    tmpPoint[forkDim] = firstChildPos[forkDim];
	    ctx.lineTo(tmpPoint[0], tmpPoint[1]);
	    tmpPoint[forkDim] = lastChildPos[forkDim];
	    ctx.lineTo(tmpPoint[0], tmpPoint[1]);
	    ctx.lineTo(lastChildPos[0], lastChildPos[1]);
	
	    for (var i = 1; i < childLen - 1; i++) {
	      var point = childPoints[i];
	      ctx.moveTo(point[0], point[1]);
	      tmpPoint[forkDim] = point[forkDim];
	      ctx.lineTo(tmpPoint[0], tmpPoint[1]);
	    }
	  }
	});
	
	var _default = echarts.extendChartView({
	  type: 'tree',
	
	  /**
	   * Init the chart
	   * @override
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  init: function (ecModel, api) {
	    /**
	     * @private
	     * @type {module:echarts/data/Tree}
	     */
	    this._oldTree;
	    /**
	     * @private
	     * @type {module:zrender/container/Group}
	     */
	
	    this._mainGroup = new graphic.Group();
	    /**
	     * @private
	     * @type {module:echarts/componet/helper/RoamController}
	     */
	
	    this._controller = new RoamController(api.getZr());
	    this._controllerHost = {
	      target: this.group
	    };
	    this.group.add(this._mainGroup);
	  },
	  render: function (seriesModel, ecModel, api, payload) {
	    var data = seriesModel.getData();
	    var layoutInfo = seriesModel.layoutInfo;
	    var group = this._mainGroup;
	    var layout = seriesModel.get('layout');
	
	    if (layout === 'radial') {
	      group.attr('position', [layoutInfo.x + layoutInfo.width / 2, layoutInfo.y + layoutInfo.height / 2]);
	    } else {
	      group.attr('position', [layoutInfo.x, layoutInfo.y]);
	    }
	
	    this._updateViewCoordSys(seriesModel, layoutInfo, layout);
	
	    this._updateController(seriesModel, ecModel, api);
	
	    var oldData = this._data;
	    var seriesScope = {
	      expandAndCollapse: seriesModel.get('expandAndCollapse'),
	      layout: layout,
	      edgeShape: seriesModel.get('edgeShape'),
	      edgeForkPosition: seriesModel.get('edgeForkPosition'),
	      orient: seriesModel.getOrient(),
	      curvature: seriesModel.get('lineStyle.curveness'),
	      symbolRotate: seriesModel.get('symbolRotate'),
	      symbolOffset: seriesModel.get('symbolOffset'),
	      hoverAnimation: seriesModel.get('hoverAnimation'),
	      useNameLabel: true,
	      fadeIn: true
	    };
	    data.diff(oldData).add(function (newIdx) {
	      if (symbolNeedsDraw(data, newIdx)) {
	        // Create node and edge
	        updateNode(data, newIdx, null, group, seriesModel, seriesScope);
	      }
	    }).update(function (newIdx, oldIdx) {
	      var symbolEl = oldData.getItemGraphicEl(oldIdx);
	
	      if (!symbolNeedsDraw(data, newIdx)) {
	        symbolEl && removeNode(oldData, oldIdx, symbolEl, group, seriesModel, seriesScope);
	        return;
	      } // Update node and edge
	
	
	      updateNode(data, newIdx, symbolEl, group, seriesModel, seriesScope);
	    }).remove(function (oldIdx) {
	      var symbolEl = oldData.getItemGraphicEl(oldIdx); // When remove a collapsed node of subtree, since the collapsed
	      // node haven't been initialized with a symbol element,
	      // you can't found it's symbol element through index.
	      // so if we want to remove the symbol element we should insure
	      // that the symbol element is not null.
	
	      if (symbolEl) {
	        removeNode(oldData, oldIdx, symbolEl, group, seriesModel, seriesScope);
	      }
	    }).execute();
	    this._nodeScaleRatio = seriesModel.get('nodeScaleRatio');
	
	    this._updateNodeAndLinkScale(seriesModel);
	
	    if (seriesScope.expandAndCollapse === true) {
	      data.eachItemGraphicEl(function (el, dataIndex) {
	        el.off('click').on('click', function () {
	          api.dispatchAction({
	            type: 'treeExpandAndCollapse',
	            seriesId: seriesModel.id,
	            dataIndex: dataIndex
	          });
	        });
	      });
	    }
	
	    this._data = data;
	  },
	  _updateViewCoordSys: function (seriesModel) {
	    var data = seriesModel.getData();
	    var points = [];
	    data.each(function (idx) {
	      var layout = data.getItemLayout(idx);
	
	      if (layout && !isNaN(layout.x) && !isNaN(layout.y)) {
	        points.push([+layout.x, +layout.y]);
	      }
	    });
	    var min = [];
	    var max = [];
	    bbox.fromPoints(points, min, max); // If don't Store min max when collapse the root node after roam,
	    // the root node will disappear.
	
	    var oldMin = this._min;
	    var oldMax = this._max; // If width or height is 0
	
	    if (max[0] - min[0] === 0) {
	      min[0] = oldMin ? oldMin[0] : min[0] - 1;
	      max[0] = oldMax ? oldMax[0] : max[0] + 1;
	    }
	
	    if (max[1] - min[1] === 0) {
	      min[1] = oldMin ? oldMin[1] : min[1] - 1;
	      max[1] = oldMax ? oldMax[1] : max[1] + 1;
	    }
	
	    var viewCoordSys = seriesModel.coordinateSystem = new View();
	    viewCoordSys.zoomLimit = seriesModel.get('scaleLimit');
	    viewCoordSys.setBoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
	    viewCoordSys.setCenter(seriesModel.get('center'));
	    viewCoordSys.setZoom(seriesModel.get('zoom')); // Here we use viewCoordSys just for computing the 'position' and 'scale' of the group
	
	    this.group.attr({
	      position: viewCoordSys.position,
	      scale: viewCoordSys.scale
	    });
	    this._viewCoordSys = viewCoordSys;
	    this._min = min;
	    this._max = max;
	  },
	  _updateController: function (seriesModel, ecModel, api) {
	    var controller = this._controller;
	    var controllerHost = this._controllerHost;
	    var group = this.group;
	    controller.setPointerChecker(function (e, x, y) {
	      var rect = group.getBoundingRect();
	      rect.applyTransform(group.transform);
	      return rect.contain(x, y) && !onIrrelevantElement(e, api, seriesModel);
	    });
	    controller.enable(seriesModel.get('roam'));
	    controllerHost.zoomLimit = seriesModel.get('scaleLimit');
	    controllerHost.zoom = seriesModel.coordinateSystem.getZoom();
	    controller.off('pan').off('zoom').on('pan', function (e) {
	      roamHelper.updateViewOnPan(controllerHost, e.dx, e.dy);
	      api.dispatchAction({
	        seriesId: seriesModel.id,
	        type: 'treeRoam',
	        dx: e.dx,
	        dy: e.dy
	      });
	    }, this).on('zoom', function (e) {
	      roamHelper.updateViewOnZoom(controllerHost, e.scale, e.originX, e.originY);
	      api.dispatchAction({
	        seriesId: seriesModel.id,
	        type: 'treeRoam',
	        zoom: e.scale,
	        originX: e.originX,
	        originY: e.originY
	      });
	
	      this._updateNodeAndLinkScale(seriesModel);
	    }, this);
	  },
	  _updateNodeAndLinkScale: function (seriesModel) {
	    var data = seriesModel.getData();
	
	    var nodeScale = this._getNodeGlobalScale(seriesModel);
	
	    var invScale = [nodeScale, nodeScale];
	    data.eachItemGraphicEl(function (el, idx) {
	      el.attr('scale', invScale);
	    });
	  },
	  _getNodeGlobalScale: function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys.type !== 'view') {
	      return 1;
	    }
	
	    var nodeScaleRatio = this._nodeScaleRatio;
	    var groupScale = coordSys.scale;
	    var groupZoom = groupScale && groupScale[0] || 1; // Scale node when zoom changes
	
	    var roamZoom = coordSys.getZoom();
	    var nodeScale = (roamZoom - 1) * nodeScaleRatio + 1;
	    return nodeScale / groupZoom;
	  },
	  dispose: function () {
	    this._controller && this._controller.dispose();
	    this._controllerHost = {};
	  },
	  remove: function () {
	    this._mainGroup.removeAll();
	
	    this._data = null;
	  }
	});
	
	function symbolNeedsDraw(data, dataIndex) {
	  var layout = data.getItemLayout(dataIndex);
	  return layout && !isNaN(layout.x) && !isNaN(layout.y) && data.getItemVisual(dataIndex, 'symbol') !== 'none';
	}
	
	function getTreeNodeStyle(node, itemModel, seriesScope) {
	  seriesScope.itemModel = itemModel;
	  seriesScope.itemStyle = itemModel.getModel('itemStyle').getItemStyle();
	  seriesScope.hoverItemStyle = itemModel.getModel('emphasis.itemStyle').getItemStyle();
	  seriesScope.lineStyle = itemModel.getModel('lineStyle').getLineStyle();
	  seriesScope.labelModel = itemModel.getModel('label');
	  seriesScope.hoverLabelModel = itemModel.getModel('emphasis.label');
	
	  if (node.isExpand === false && node.children.length !== 0) {
	    seriesScope.symbolInnerColor = seriesScope.itemStyle.fill;
	  } else {
	    seriesScope.symbolInnerColor = '#fff';
	  }
	
	  return seriesScope;
	}
	
	function updateNode(data, dataIndex, symbolEl, group, seriesModel, seriesScope) {
	  var isInit = !symbolEl;
	  var node = data.tree.getNodeByDataIndex(dataIndex);
	  var itemModel = node.getModel();
	  var seriesScope = getTreeNodeStyle(node, itemModel, seriesScope);
	  var virtualRoot = data.tree.root;
	  var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
	  var sourceSymbolEl = data.getItemGraphicEl(source.dataIndex);
	  var sourceLayout = source.getLayout();
	  var sourceOldLayout = sourceSymbolEl ? {
	    x: sourceSymbolEl.position[0],
	    y: sourceSymbolEl.position[1],
	    rawX: sourceSymbolEl.__radialOldRawX,
	    rawY: sourceSymbolEl.__radialOldRawY
	  } : sourceLayout;
	  var targetLayout = node.getLayout();
	
	  if (isInit) {
	    symbolEl = new SymbolClz(data, dataIndex, seriesScope);
	    symbolEl.attr('position', [sourceOldLayout.x, sourceOldLayout.y]);
	  } else {
	    symbolEl.updateData(data, dataIndex, seriesScope);
	  }
	
	  symbolEl.__radialOldRawX = symbolEl.__radialRawX;
	  symbolEl.__radialOldRawY = symbolEl.__radialRawY;
	  symbolEl.__radialRawX = targetLayout.rawX;
	  symbolEl.__radialRawY = targetLayout.rawY;
	  group.add(symbolEl);
	  data.setItemGraphicEl(dataIndex, symbolEl);
	  graphic.updateProps(symbolEl, {
	    position: [targetLayout.x, targetLayout.y]
	  }, seriesModel);
	  var symbolPath = symbolEl.getSymbolPath();
	
	  if (seriesScope.layout === 'radial') {
	    var realRoot = virtualRoot.children[0];
	    var rootLayout = realRoot.getLayout();
	    var length = realRoot.children.length;
	    var rad;
	    var isLeft;
	
	    if (targetLayout.x === rootLayout.x && node.isExpand === true) {
	      var center = {};
	      center.x = (realRoot.children[0].getLayout().x + realRoot.children[length - 1].getLayout().x) / 2;
	      center.y = (realRoot.children[0].getLayout().y + realRoot.children[length - 1].getLayout().y) / 2;
	      rad = Math.atan2(center.y - rootLayout.y, center.x - rootLayout.x);
	
	      if (rad < 0) {
	        rad = Math.PI * 2 + rad;
	      }
	
	      isLeft = center.x < rootLayout.x;
	
	      if (isLeft) {
	        rad = rad - Math.PI;
	      }
	    } else {
	      rad = Math.atan2(targetLayout.y - rootLayout.y, targetLayout.x - rootLayout.x);
	
	      if (rad < 0) {
	        rad = Math.PI * 2 + rad;
	      }
	
	      if (node.children.length === 0 || node.children.length !== 0 && node.isExpand === false) {
	        isLeft = targetLayout.x < rootLayout.x;
	
	        if (isLeft) {
	          rad = rad - Math.PI;
	        }
	      } else {
	        isLeft = targetLayout.x > rootLayout.x;
	
	        if (!isLeft) {
	          rad = rad - Math.PI;
	        }
	      }
	    }
	
	    var textPosition = isLeft ? 'left' : 'right';
	    var rotate = seriesScope.labelModel.get('rotate');
	    var labelRotateRadian = rotate * (Math.PI / 180);
	    symbolPath.setStyle({
	      textPosition: seriesScope.labelModel.get('position') || textPosition,
	      textRotation: rotate == null ? -rad : labelRotateRadian,
	      textOrigin: 'center',
	      verticalAlign: 'middle'
	    });
	  }
	
	  drawEdge(seriesModel, node, virtualRoot, symbolEl, sourceOldLayout, sourceLayout, targetLayout, group, seriesScope);
	}
	
	function drawEdge(seriesModel, node, virtualRoot, symbolEl, sourceOldLayout, sourceLayout, targetLayout, group, seriesScope) {
	  var edgeShape = seriesScope.edgeShape;
	  var edge = symbolEl.__edge;
	
	  if (edgeShape === 'curve') {
	    if (node.parentNode && node.parentNode !== virtualRoot) {
	      if (!edge) {
	        edge = symbolEl.__edge = new graphic.BezierCurve({
	          shape: getEdgeShape(seriesScope, sourceOldLayout, sourceOldLayout),
	          style: zrUtil.defaults({
	            opacity: 0,
	            strokeNoScale: true
	          }, seriesScope.lineStyle)
	        });
	      }
	
	      graphic.updateProps(edge, {
	        shape: getEdgeShape(seriesScope, sourceLayout, targetLayout),
	        style: zrUtil.defaults({
	          opacity: 1
	        }, seriesScope.lineStyle)
	      }, seriesModel);
	    }
	  } else if (edgeShape === 'polyline') {
	    if (seriesScope.layout === 'orthogonal') {
	      if (node !== virtualRoot && node.children && node.children.length !== 0 && node.isExpand === true) {
	        var children = node.children;
	        var childPoints = [];
	
	        for (var i = 0; i < children.length; i++) {
	          var childLayout = children[i].getLayout();
	          childPoints.push([childLayout.x, childLayout.y]);
	        }
	
	        if (!edge) {
	          edge = symbolEl.__edge = new TreeShape({
	            shape: {
	              parentPoint: [targetLayout.x, targetLayout.y],
	              childPoints: [[targetLayout.x, targetLayout.y]],
	              orient: seriesScope.orient,
	              forkPosition: seriesScope.edgeForkPosition
	            },
	            style: zrUtil.defaults({
	              opacity: 0,
	              strokeNoScale: true
	            }, seriesScope.lineStyle)
	          });
	        }
	
	        graphic.updateProps(edge, {
	          shape: {
	            parentPoint: [targetLayout.x, targetLayout.y],
	            childPoints: childPoints
	          },
	          style: zrUtil.defaults({
	            opacity: 1
	          }, seriesScope.lineStyle)
	        }, seriesModel);
	      }
	    } else {}
	  }
	
	  group.add(edge);
	}
	
	function removeNode(data, dataIndex, symbolEl, group, seriesModel, seriesScope) {
	  var node = data.tree.getNodeByDataIndex(dataIndex);
	  var virtualRoot = data.tree.root;
	  var itemModel = node.getModel();
	  var seriesScope = getTreeNodeStyle(node, itemModel, seriesScope);
	  var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
	  var edgeShape = seriesScope.edgeShape;
	  var sourceLayout;
	
	  while (sourceLayout = source.getLayout(), sourceLayout == null) {
	    source = source.parentNode === virtualRoot ? source : source.parentNode || source;
	  }
	
	  graphic.updateProps(symbolEl, {
	    position: [sourceLayout.x + 1, sourceLayout.y + 1]
	  }, seriesModel, function () {
	    group.remove(symbolEl);
	    data.setItemGraphicEl(dataIndex, null);
	  });
	  symbolEl.fadeOut(null, {
	    keepLabel: true
	  });
	  var sourceSymbolEl = data.getItemGraphicEl(source.dataIndex);
	  var sourceEdge = sourceSymbolEl.__edge; // 1. when expand the sub tree, delete the children node should delete the edge of
	  // the source at the same time. because the polyline edge shape is only owned by the source.
	  // 2.when the node is the only children of the source, delete the node should delete the edge of
	  // the source at the same time. the same reason as above.
	
	  var edge = symbolEl.__edge || (source.isExpand === false || source.children.length === 1 ? sourceEdge : undefined);
	  var edgeShape = seriesScope.edgeShape;
	
	  if (edge) {
	    if (edgeShape === 'curve') {
	      graphic.updateProps(edge, {
	        shape: getEdgeShape(seriesScope, sourceLayout, sourceLayout),
	        style: {
	          opacity: 0
	        }
	      }, seriesModel, function () {
	        group.remove(edge);
	      });
	    } else if (edgeShape === 'polyline' && seriesScope.layout === 'orthogonal') {
	      graphic.updateProps(edge, {
	        shape: {
	          parentPoint: [sourceLayout.x, sourceLayout.y],
	          childPoints: [[sourceLayout.x, sourceLayout.y]]
	        },
	        style: {
	          opacity: 0
	        }
	      }, seriesModel, function () {
	        group.remove(edge);
	      });
	    }
	  }
	}
	
	function getEdgeShape(seriesScope, sourceLayout, targetLayout) {
	  var cpx1;
	  var cpy1;
	  var cpx2;
	  var cpy2;
	  var orient = seriesScope.orient;
	  var x1;
	  var x2;
	  var y1;
	  var y2;
	
	  if (seriesScope.layout === 'radial') {
	    x1 = sourceLayout.rawX;
	    y1 = sourceLayout.rawY;
	    x2 = targetLayout.rawX;
	    y2 = targetLayout.rawY;
	    var radialCoor1 = radialCoordinate(x1, y1);
	    var radialCoor2 = radialCoordinate(x1, y1 + (y2 - y1) * seriesScope.curvature);
	    var radialCoor3 = radialCoordinate(x2, y2 + (y1 - y2) * seriesScope.curvature);
	    var radialCoor4 = radialCoordinate(x2, y2);
	    return {
	      x1: radialCoor1.x,
	      y1: radialCoor1.y,
	      x2: radialCoor4.x,
	      y2: radialCoor4.y,
	      cpx1: radialCoor2.x,
	      cpy1: radialCoor2.y,
	      cpx2: radialCoor3.x,
	      cpy2: radialCoor3.y
	    };
	  } else {
	    x1 = sourceLayout.x;
	    y1 = sourceLayout.y;
	    x2 = targetLayout.x;
	    y2 = targetLayout.y;
	
	    if (orient === 'LR' || orient === 'RL') {
	      cpx1 = x1 + (x2 - x1) * seriesScope.curvature;
	      cpy1 = y1;
	      cpx2 = x2 + (x1 - x2) * seriesScope.curvature;
	      cpy2 = y2;
	    }
	
	    if (orient === 'TB' || orient === 'BT') {
	      cpx1 = x1;
	      cpy1 = y1 + (y2 - y1) * seriesScope.curvature;
	      cpx2 = x2;
	      cpy2 = y2 + (y1 - y2) * seriesScope.curvature;
	    }
	  }
	
	  return {
	    x1: x1,
	    y1: y1,
	    x2: x2,
	    y2: y2,
	    cpx1: cpx1,
	    cpy1: cpy1,
	    cpx2: cpx2,
	    cpy2: cpy2
	  };
	}
	
	module.exports = _default;

/***/ },
/* 1557 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Traverse the tree from bottom to top and do something
	 * @param  {module:echarts/data/Tree~TreeNode} root  The real root of the tree
	 * @param  {Function} callback
	 */
	function eachAfter(root, callback, separation) {
	  var nodes = [root];
	  var next = [];
	  var node;
	
	  while (node = nodes.pop()) {
	    // jshint ignore:line
	    next.push(node);
	
	    if (node.isExpand) {
	      var children = node.children;
	
	      if (children.length) {
	        for (var i = 0; i < children.length; i++) {
	          nodes.push(children[i]);
	        }
	      }
	    }
	  }
	
	  while (node = next.pop()) {
	    // jshint ignore:line
	    callback(node, separation);
	  }
	}
	/**
	 * Traverse the tree from top to bottom and do something
	 * @param  {module:echarts/data/Tree~TreeNode} root  The real root of the tree
	 * @param  {Function} callback
	 */
	
	
	function eachBefore(root, callback) {
	  var nodes = [root];
	  var node;
	
	  while (node = nodes.pop()) {
	    // jshint ignore:line
	    callback(node);
	
	    if (node.isExpand) {
	      var children = node.children;
	
	      if (children.length) {
	        for (var i = children.length - 1; i >= 0; i--) {
	          nodes.push(children[i]);
	        }
	      }
	    }
	  }
	}
	
	exports.eachAfter = eachAfter;
	exports.eachBefore = eachBefore;

/***/ },
/* 1558 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var _roamHelper = __webpack_require__(453);
	
	var updateCenterAndZoom = _roamHelper.updateCenterAndZoom;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerAction({
	  type: 'treeExpandAndCollapse',
	  event: 'treeExpandAndCollapse',
	  update: 'update'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'tree',
	    query: payload
	  }, function (seriesModel) {
	    var dataIndex = payload.dataIndex;
	    var tree = seriesModel.getData().tree;
	    var node = tree.getNodeByDataIndex(dataIndex);
	    node.isExpand = !node.isExpand;
	  });
	});
	echarts.registerAction({
	  type: 'treeRoam',
	  event: 'treeRoam',
	  // Here we set 'none' instead of 'update', because roam action
	  // just need to update the transform matrix without having to recalculate
	  // the layout. So don't need to go through the whole update process, such
	  // as 'dataPrcocess', 'coordSystemUpdate', 'layout' and so on.
	  update: 'none'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'tree',
	    query: payload
	  }, function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	    var res = updateCenterAndZoom(coordSys, payload);
	    seriesModel.setCenter && seriesModel.setCenter(res.center);
	    seriesModel.setZoom && seriesModel.setZoom(res.zoom);
	  });
	});

/***/ },
/* 1559 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _traversalHelper = __webpack_require__(1557);
	
	var eachAfter = _traversalHelper.eachAfter;
	var eachBefore = _traversalHelper.eachBefore;
	
	var _layoutHelper = __webpack_require__(708);
	
	var init = _layoutHelper.init;
	var firstWalk = _layoutHelper.firstWalk;
	var secondWalk = _layoutHelper.secondWalk;
	var sep = _layoutHelper.separation;
	var radialCoordinate = _layoutHelper.radialCoordinate;
	var getViewRect = _layoutHelper.getViewRect;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel, api) {
	  ecModel.eachSeriesByType('tree', function (seriesModel) {
	    commonLayout(seriesModel, api);
	  });
	}
	
	function commonLayout(seriesModel, api) {
	  var layoutInfo = getViewRect(seriesModel, api);
	  seriesModel.layoutInfo = layoutInfo;
	  var layout = seriesModel.get('layout');
	  var width = 0;
	  var height = 0;
	  var separation = null;
	
	  if (layout === 'radial') {
	    width = 2 * Math.PI;
	    height = Math.min(layoutInfo.height, layoutInfo.width) / 2;
	    separation = sep(function (node1, node2) {
	      return (node1.parentNode === node2.parentNode ? 1 : 2) / node1.depth;
	    });
	  } else {
	    width = layoutInfo.width;
	    height = layoutInfo.height;
	    separation = sep();
	  }
	
	  var virtualRoot = seriesModel.getData().tree.root;
	  var realRoot = virtualRoot.children[0];
	
	  if (realRoot) {
	    init(virtualRoot);
	    eachAfter(realRoot, firstWalk, separation);
	    virtualRoot.hierNode.modifier = -realRoot.hierNode.prelim;
	    eachBefore(realRoot, secondWalk);
	    var left = realRoot;
	    var right = realRoot;
	    var bottom = realRoot;
	    eachBefore(realRoot, function (node) {
	      var x = node.getLayout().x;
	
	      if (x < left.getLayout().x) {
	        left = node;
	      }
	
	      if (x > right.getLayout().x) {
	        right = node;
	      }
	
	      if (node.depth > bottom.depth) {
	        bottom = node;
	      }
	    });
	    var delta = left === right ? 1 : separation(left, right) / 2;
	    var tx = delta - left.getLayout().x;
	    var kx = 0;
	    var ky = 0;
	    var coorX = 0;
	    var coorY = 0;
	
	    if (layout === 'radial') {
	      kx = width / (right.getLayout().x + delta + tx); // here we use (node.depth - 1), bucause the real root's depth is 1
	
	      ky = height / (bottom.depth - 1 || 1);
	      eachBefore(realRoot, function (node) {
	        coorX = (node.getLayout().x + tx) * kx;
	        coorY = (node.depth - 1) * ky;
	        var finalCoor = radialCoordinate(coorX, coorY);
	        node.setLayout({
	          x: finalCoor.x,
	          y: finalCoor.y,
	          rawX: coorX,
	          rawY: coorY
	        }, true);
	      });
	    } else {
	      var orient = seriesModel.getOrient();
	
	      if (orient === 'RL' || orient === 'LR') {
	        ky = height / (right.getLayout().x + delta + tx);
	        kx = width / (bottom.depth - 1 || 1);
	        eachBefore(realRoot, function (node) {
	          coorY = (node.getLayout().x + tx) * ky;
	          coorX = orient === 'LR' ? (node.depth - 1) * kx : width - (node.depth - 1) * kx;
	          node.setLayout({
	            x: coorX,
	            y: coorY
	          }, true);
	        });
	      } else if (orient === 'TB' || orient === 'BT') {
	        kx = width / (right.getLayout().x + delta + tx);
	        ky = height / (bottom.depth - 1 || 1);
	        eachBefore(realRoot, function (node) {
	          coorX = (node.getLayout().x + tx) * kx;
	          coorY = orient === 'TB' ? (node.depth - 1) * ky : height - (node.depth - 1) * ky;
	          node.setLayout({
	            x: coorX,
	            y: coorY
	          }, true);
	        });
	      }
	    }
	  }
	}
	
	module.exports = _default;

/***/ },
/* 1560 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	__webpack_require__(1562);
	
	__webpack_require__(1563);
	
	__webpack_require__(1564);
	
	var treemapVisual = __webpack_require__(1566);
	
	var treemapLayout = __webpack_require__(1565);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(treemapVisual);
	echarts.registerLayout(treemapLayout);

/***/ },
/* 1561 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(16);
	
	var layout = __webpack_require__(36);
	
	var zrUtil = __webpack_require__(3);
	
	var _treeHelper = __webpack_require__(164);
	
	var wrapTreePathInfo = _treeHelper.wrapTreePathInfo;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var TEXT_PADDING = 8;
	var ITEM_GAP = 8;
	var ARRAY_LENGTH = 5;
	
	function Breadcrumb(containerGroup) {
	  /**
	   * @private
	   * @type {module:zrender/container/Group}
	   */
	  this.group = new graphic.Group();
	  containerGroup.add(this.group);
	}
	
	Breadcrumb.prototype = {
	  constructor: Breadcrumb,
	  render: function (seriesModel, api, targetNode, onSelect) {
	    var model = seriesModel.getModel('breadcrumb');
	    var thisGroup = this.group;
	    thisGroup.removeAll();
	
	    if (!model.get('show') || !targetNode) {
	      return;
	    }
	
	    var normalStyleModel = model.getModel('itemStyle'); // var emphasisStyleModel = model.getModel('emphasis.itemStyle');
	
	    var textStyleModel = normalStyleModel.getModel('textStyle');
	    var layoutParam = {
	      pos: {
	        left: model.get('left'),
	        right: model.get('right'),
	        top: model.get('top'),
	        bottom: model.get('bottom')
	      },
	      box: {
	        width: api.getWidth(),
	        height: api.getHeight()
	      },
	      emptyItemWidth: model.get('emptyItemWidth'),
	      totalWidth: 0,
	      renderList: []
	    };
	
	    this._prepare(targetNode, layoutParam, textStyleModel);
	
	    this._renderContent(seriesModel, layoutParam, normalStyleModel, textStyleModel, onSelect);
	
	    layout.positionElement(thisGroup, layoutParam.pos, layoutParam.box);
	  },
	
	  /**
	   * Prepare render list and total width
	   * @private
	   */
	  _prepare: function (targetNode, layoutParam, textStyleModel) {
	    for (var node = targetNode; node; node = node.parentNode) {
	      var text = node.getModel().get('name');
	      var textRect = textStyleModel.getTextRect(text);
	      var itemWidth = Math.max(textRect.width + TEXT_PADDING * 2, layoutParam.emptyItemWidth);
	      layoutParam.totalWidth += itemWidth + ITEM_GAP;
	      layoutParam.renderList.push({
	        node: node,
	        text: text,
	        width: itemWidth
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _renderContent: function (seriesModel, layoutParam, normalStyleModel, textStyleModel, onSelect) {
	    // Start rendering.
	    var lastX = 0;
	    var emptyItemWidth = layoutParam.emptyItemWidth;
	    var height = seriesModel.get('breadcrumb.height');
	    var availableSize = layout.getAvailableSize(layoutParam.pos, layoutParam.box);
	    var totalWidth = layoutParam.totalWidth;
	    var renderList = layoutParam.renderList;
	
	    for (var i = renderList.length - 1; i >= 0; i--) {
	      var item = renderList[i];
	      var itemNode = item.node;
	      var itemWidth = item.width;
	      var text = item.text; // Hdie text and shorten width if necessary.
	
	      if (totalWidth > availableSize.width) {
	        totalWidth -= itemWidth - emptyItemWidth;
	        itemWidth = emptyItemWidth;
	        text = null;
	      }
	
	      var el = new graphic.Polygon({
	        shape: {
	          points: makeItemPoints(lastX, 0, itemWidth, height, i === renderList.length - 1, i === 0)
	        },
	        style: zrUtil.defaults(normalStyleModel.getItemStyle(), {
	          lineJoin: 'bevel',
	          text: text,
	          textFill: textStyleModel.getTextColor(),
	          textFont: textStyleModel.getFont()
	        }),
	        z: 10,
	        onclick: zrUtil.curry(onSelect, itemNode)
	      });
	      this.group.add(el);
	      packEventData(el, seriesModel, itemNode);
	      lastX += itemWidth + ITEM_GAP;
	    }
	  },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    this.group.removeAll();
	  }
	};
	
	function makeItemPoints(x, y, itemWidth, itemHeight, head, tail) {
	  var points = [[head ? x : x - ARRAY_LENGTH, y], [x + itemWidth, y], [x + itemWidth, y + itemHeight], [head ? x : x - ARRAY_LENGTH, y + itemHeight]];
	  !tail && points.splice(2, 0, [x + itemWidth + ARRAY_LENGTH, y + itemHeight / 2]);
	  !head && points.push([x, y + itemHeight / 2]);
	  return points;
	} // Package custom mouse event.
	
	
	function packEventData(el, seriesModel, itemNode) {
	  el.eventData = {
	    componentType: 'series',
	    componentSubType: 'treemap',
	    componentIndex: seriesModel.componentIndex,
	    seriesIndex: seriesModel.componentIndex,
	    seriesName: seriesModel.name,
	    seriesType: 'treemap',
	    selfType: 'breadcrumb',
	    // Distinguish with click event on treemap node.
	    nodeData: {
	      dataIndex: itemNode && itemNode.dataIndex,
	      name: itemNode && itemNode.name
	    },
	    treePathInfo: itemNode && wrapTreePathInfo(itemNode, seriesModel)
	  };
	}
	
	var _default = Breadcrumb;
	module.exports = _default;

/***/ },
/* 1562 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var SeriesModel = __webpack_require__(58);
	
	var Tree = __webpack_require__(474);
	
	var Model = __webpack_require__(48);
	
	var _format = __webpack_require__(40);
	
	var encodeHTML = _format.encodeHTML;
	var addCommas = _format.addCommas;
	
	var _treeHelper = __webpack_require__(164);
	
	var wrapTreePathInfo = _treeHelper.wrapTreePathInfo;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.treemap',
	  layoutMode: 'box',
	  dependencies: ['grid', 'polar'],
	  preventUsingHoverLayer: true,
	
	  /**
	   * @type {module:echarts/data/Tree~Node}
	   */
	  _viewRoot: null,
	  defaultOption: {
	    // Disable progressive rendering
	    progressive: 0,
	    // center: ['50%', '50%'],          // not supported in ec3.
	    // size: ['80%', '80%'],            // deprecated, compatible with ec2.
	    left: 'center',
	    top: 'middle',
	    right: null,
	    bottom: null,
	    width: '80%',
	    height: '80%',
	    sort: true,
	    // Can be null or false or true
	    // (order by desc default, asc not supported yet (strange effect))
	    clipWindow: 'origin',
	    // Size of clipped window when zooming. 'origin' or 'fullscreen'
	    squareRatio: 0.5 * (1 + Math.sqrt(5)),
	    // golden ratio
	    leafDepth: null,
	    // Nodes on depth from root are regarded as leaves.
	    // Count from zero (zero represents only view root).
	    drillDownIcon: '▶',
	    // Use html character temporarily because it is complicated
	    // to align specialized icon. ▷▶❒❐▼✚
	    zoomToNodeRatio: 0.32 * 0.32,
	    // Be effective when using zoomToNode. Specify the proportion of the
	    // target node area in the view area.
	    roam: true,
	    // true, false, 'scale' or 'zoom', 'move'.
	    nodeClick: 'zoomToNode',
	    // Leaf node click behaviour: 'zoomToNode', 'link', false.
	    // If leafDepth is set and clicking a node which has children but
	    // be on left depth, the behaviour would be changing root. Otherwise
	    // use behavious defined above.
	    animation: true,
	    animationDurationUpdate: 900,
	    animationEasing: 'quinticInOut',
	    breadcrumb: {
	      show: true,
	      height: 22,
	      left: 'center',
	      top: 'bottom',
	      // right
	      // bottom
	      emptyItemWidth: 25,
	      // Width of empty node.
	      itemStyle: {
	        color: 'rgba(0,0,0,0.7)',
	        //'#5793f3',
	        borderColor: 'rgba(255,255,255,0.7)',
	        borderWidth: 1,
	        shadowColor: 'rgba(150,150,150,1)',
	        shadowBlur: 3,
	        shadowOffsetX: 0,
	        shadowOffsetY: 0,
	        textStyle: {
	          color: '#fff'
	        }
	      },
	      emphasis: {
	        textStyle: {}
	      }
	    },
	    label: {
	      show: true,
	      // Do not use textDistance, for ellipsis rect just the same as treemap node rect.
	      distance: 0,
	      padding: 5,
	      position: 'inside',
	      // Can be [5, '5%'] or position stirng like 'insideTopLeft', ...
	      // formatter: null,
	      color: '#fff',
	      ellipsis: true // align
	      // verticalAlign
	
	    },
	    upperLabel: {
	      // Label when node is parent.
	      show: false,
	      position: [0, '50%'],
	      height: 20,
	      // formatter: null,
	      color: '#fff',
	      ellipsis: true,
	      // align: null,
	      verticalAlign: 'middle'
	    },
	    itemStyle: {
	      color: null,
	      // Can be 'none' if not necessary.
	      colorAlpha: null,
	      // Can be 'none' if not necessary.
	      colorSaturation: null,
	      // Can be 'none' if not necessary.
	      borderWidth: 0,
	      gapWidth: 0,
	      borderColor: '#fff',
	      borderColorSaturation: null // If specified, borderColor will be ineffective, and the
	      // border color is evaluated by color of current node and
	      // borderColorSaturation.
	
	    },
	    emphasis: {
	      upperLabel: {
	        show: true,
	        position: [0, '50%'],
	        color: '#fff',
	        ellipsis: true,
	        verticalAlign: 'middle'
	      }
	    },
	    visualDimension: 0,
	    // Can be 0, 1, 2, 3.
	    visualMin: null,
	    visualMax: null,
	    color: [],
	    // + treemapSeries.color should not be modified. Please only modified
	    // level[n].color (if necessary).
	    // + Specify color list of each level. level[0].color would be global
	    // color list if not specified. (see method `setDefault`).
	    // + But set as a empty array to forbid fetch color from global palette
	    // when using nodeModel.get('color'), otherwise nodes on deep level
	    // will always has color palette set and are not able to inherit color
	    // from parent node.
	    // + TreemapSeries.color can not be set as 'none', otherwise effect
	    // legend color fetching (see seriesColor.js).
	    colorAlpha: null,
	    // Array. Specify color alpha range of each level, like [0.2, 0.8]
	    colorSaturation: null,
	    // Array. Specify color saturation of each level, like [0.2, 0.5]
	    colorMappingBy: 'index',
	    // 'value' or 'index' or 'id'.
	    visibleMin: 10,
	    // If area less than this threshold (unit: pixel^2), node will not
	    // be rendered. Only works when sort is 'asc' or 'desc'.
	    childrenVisibleMin: null,
	    // If area of a node less than this threshold (unit: pixel^2),
	    // grandchildren will not show.
	    // Why grandchildren? If not grandchildren but children,
	    // some siblings show children and some not,
	    // the appearance may be mess and not consistent,
	    levels: [] // Each item: {
	    //     visibleMin, itemStyle, visualDimension, label
	    // }
	    // data: {
	    //      value: [],
	    //      children: [],
	    //      link: 'http://xxx.xxx.xxx',
	    //      target: 'blank' or 'self'
	    // }
	
	  },
	
	  /**
	   * @override
	   */
	  getInitialData: function (option, ecModel) {
	    // Create a virtual root.
	    var root = {
	      name: option.name,
	      children: option.data
	    };
	    completeTreeValue(root);
	    var levels = option.levels || []; // Used in "visual priority" in `treemapVisual.js`.
	    // This way is a little tricky, must satisfy the precondition:
	    //   1. There is no `treeNode.getModel('itemStyle.xxx')` used.
	    //   2. The `Model.prototype.getModel()` will not use any clone-like way.
	
	    var designatedVisualItemStyle = this.designatedVisualItemStyle = {};
	    var designatedVisualModel = new Model({
	      itemStyle: designatedVisualItemStyle
	    }, this, ecModel);
	    levels = option.levels = setDefault(levels, ecModel);
	    var levelModels = zrUtil.map(levels || [], function (levelDefine) {
	      return new Model(levelDefine, designatedVisualModel, ecModel);
	    }, this); // Make sure always a new tree is created when setOption,
	    // in TreemapView, we check whether oldTree === newTree
	    // to choose mappings approach among old shapes and new shapes.
	
	    var tree = Tree.createTree(root, this, beforeLink);
	
	    function beforeLink(nodeData) {
	      nodeData.wrapMethod('getItemModel', function (model, idx) {
	        var node = tree.getNodeByDataIndex(idx);
	        var levelModel = levelModels[node.depth]; // If no levelModel, we also need `designatedVisualModel`.
	
	        model.parentModel = levelModel || designatedVisualModel;
	        return model;
	      });
	    }
	
	    return tree.data;
	  },
	  optionUpdated: function () {
	    this.resetViewRoot();
	  },
	
	  /**
	   * @override
	   * @param {number} dataIndex
	   * @param {boolean} [mutipleSeries=false]
	   */
	  formatTooltip: function (dataIndex) {
	    var data = this.getData();
	    var value = this.getRawValue(dataIndex);
	    var formattedValue = zrUtil.isArray(value) ? addCommas(value[0]) : addCommas(value);
	    var name = data.getName(dataIndex);
	    return encodeHTML(name + ': ' + formattedValue);
	  },
	
	  /**
	   * Add tree path to tooltip param
	   *
	   * @override
	   * @param {number} dataIndex
	   * @return {Object}
	   */
	  getDataParams: function (dataIndex) {
	    var params = SeriesModel.prototype.getDataParams.apply(this, arguments);
	    var node = this.getData().tree.getNodeByDataIndex(dataIndex);
	    params.treePathInfo = wrapTreePathInfo(node, this);
	    return params;
	  },
	
	  /**
	   * @public
	   * @param {Object} layoutInfo {
	   *                                x: containerGroup x
	   *                                y: containerGroup y
	   *                                width: containerGroup width
	   *                                height: containerGroup height
	   *                            }
	   */
	  setLayoutInfo: function (layoutInfo) {
	    /**
	     * @readOnly
	     * @type {Object}
	     */
	    this.layoutInfo = this.layoutInfo || {};
	    zrUtil.extend(this.layoutInfo, layoutInfo);
	  },
	
	  /**
	   * @param  {string} id
	   * @return {number} index
	   */
	  mapIdToIndex: function (id) {
	    // A feature is implemented:
	    // index is monotone increasing with the sequence of
	    // input id at the first time.
	    // This feature can make sure that each data item and its
	    // mapped color have the same index between data list and
	    // color list at the beginning, which is useful for user
	    // to adjust data-color mapping.
	
	    /**
	     * @private
	     * @type {Object}
	     */
	    var idIndexMap = this._idIndexMap;
	
	    if (!idIndexMap) {
	      idIndexMap = this._idIndexMap = zrUtil.createHashMap();
	      /**
	       * @private
	       * @type {number}
	       */
	
	      this._idIndexMapCount = 0;
	    }
	
	    var index = idIndexMap.get(id);
	
	    if (index == null) {
	      idIndexMap.set(id, index = this._idIndexMapCount++);
	    }
	
	    return index;
	  },
	  getViewRoot: function () {
	    return this._viewRoot;
	  },
	
	  /**
	   * @param {module:echarts/data/Tree~Node} [viewRoot]
	   */
	  resetViewRoot: function (viewRoot) {
	    viewRoot ? this._viewRoot = viewRoot : viewRoot = this._viewRoot;
	    var root = this.getRawData().tree.root;
	
	    if (!viewRoot || viewRoot !== root && !root.contains(viewRoot)) {
	      this._viewRoot = root;
	    }
	  }
	});
	/**
	 * @param {Object} dataNode
	 */
	
	
	function completeTreeValue(dataNode) {
	  // Postorder travel tree.
	  // If value of none-leaf node is not set,
	  // calculate it by suming up the value of all children.
	  var sum = 0;
	  zrUtil.each(dataNode.children, function (child) {
	    completeTreeValue(child);
	    var childValue = child.value;
	    zrUtil.isArray(childValue) && (childValue = childValue[0]);
	    sum += childValue;
	  });
	  var thisValue = dataNode.value;
	
	  if (zrUtil.isArray(thisValue)) {
	    thisValue = thisValue[0];
	  }
	
	  if (thisValue == null || isNaN(thisValue)) {
	    thisValue = sum;
	  } // Value should not less than 0.
	
	
	  if (thisValue < 0) {
	    thisValue = 0;
	  }
	
	  zrUtil.isArray(dataNode.value) ? dataNode.value[0] = thisValue : dataNode.value = thisValue;
	}
	/**
	 * set default to level configuration
	 */
	
	
	function setDefault(levels, ecModel) {
	  var globalColorList = ecModel.get('color');
	
	  if (!globalColorList) {
	    return;
	  }
	
	  levels = levels || [];
	  var hasColorDefine;
	  zrUtil.each(levels, function (levelDefine) {
	    var model = new Model(levelDefine);
	    var modelColor = model.get('color');
	
	    if (model.get('itemStyle.color') || modelColor && modelColor !== 'none') {
	      hasColorDefine = true;
	    }
	  });
	
	  if (!hasColorDefine) {
	    var level0 = levels[0] || (levels[0] = {});
	    level0.color = globalColorList.slice();
	  }
	
	  return levels;
	}
	
	module.exports = _default;

/***/ },
/* 1563 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var graphic = __webpack_require__(16);
	
	var DataDiffer = __webpack_require__(166);
	
	var helper = __webpack_require__(164);
	
	var Breadcrumb = __webpack_require__(1561);
	
	var RoamController = __webpack_require__(262);
	
	var BoundingRect = __webpack_require__(42);
	
	var matrix = __webpack_require__(73);
	
	var animationUtil = __webpack_require__(1709);
	
	var makeStyleMapper = __webpack_require__(208);
	
	var _format = __webpack_require__(40);
	
	var windowOpen = _format.windowOpen;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var bind = zrUtil.bind;
	var Group = graphic.Group;
	var Rect = graphic.Rect;
	var each = zrUtil.each;
	var DRAG_THRESHOLD = 3;
	var PATH_LABEL_NOAMAL = ['label'];
	var PATH_LABEL_EMPHASIS = ['emphasis', 'label'];
	var PATH_UPPERLABEL_NORMAL = ['upperLabel'];
	var PATH_UPPERLABEL_EMPHASIS = ['emphasis', 'upperLabel'];
	var Z_BASE = 10; // Should bigger than every z.
	
	var Z_BG = 1;
	var Z_CONTENT = 2;
	var getItemStyleEmphasis = makeStyleMapper([['fill', 'color'], // `borderColor` and `borderWidth` has been occupied,
	// so use `stroke` to indicate the stroke of the rect.
	['stroke', 'strokeColor'], ['lineWidth', 'strokeWidth'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor']]);
	
	var getItemStyleNormal = function (model) {
	  // Normal style props should include emphasis style props.
	  var itemStyle = getItemStyleEmphasis(model); // Clear styles set by emphasis.
	
	  itemStyle.stroke = itemStyle.fill = itemStyle.lineWidth = null;
	  return itemStyle;
	};
	
	var _default = echarts.extendChartView({
	  type: 'treemap',
	
	  /**
	   * @override
	   */
	  init: function (o, api) {
	    /**
	     * @private
	     * @type {module:zrender/container/Group}
	     */
	    this._containerGroup;
	    /**
	     * @private
	     * @type {Object.<string, Array.<module:zrender/container/Group>>}
	     */
	
	    this._storage = createStorage();
	    /**
	     * @private
	     * @type {module:echarts/data/Tree}
	     */
	
	    this._oldTree;
	    /**
	     * @private
	     * @type {module:echarts/chart/treemap/Breadcrumb}
	     */
	
	    this._breadcrumb;
	    /**
	     * @private
	     * @type {module:echarts/component/helper/RoamController}
	     */
	
	    this._controller;
	    /**
	     * 'ready', 'animating'
	     * @private
	     */
	
	    this._state = 'ready';
	  },
	
	  /**
	   * @override
	   */
	  render: function (seriesModel, ecModel, api, payload) {
	    var models = ecModel.findComponents({
	      mainType: 'series',
	      subType: 'treemap',
	      query: payload
	    });
	
	    if (zrUtil.indexOf(models, seriesModel) < 0) {
	      return;
	    }
	
	    this.seriesModel = seriesModel;
	    this.api = api;
	    this.ecModel = ecModel;
	    var types = ['treemapZoomToNode', 'treemapRootToNode'];
	    var targetInfo = helper.retrieveTargetInfo(payload, types, seriesModel);
	    var payloadType = payload && payload.type;
	    var layoutInfo = seriesModel.layoutInfo;
	    var isInit = !this._oldTree;
	    var thisStorage = this._storage; // Mark new root when action is treemapRootToNode.
	
	    var reRoot = payloadType === 'treemapRootToNode' && targetInfo && thisStorage ? {
	      rootNodeGroup: thisStorage.nodeGroup[targetInfo.node.getRawIndex()],
	      direction: payload.direction
	    } : null;
	
	    var containerGroup = this._giveContainerGroup(layoutInfo);
	
	    var renderResult = this._doRender(containerGroup, seriesModel, reRoot);
	
	    !isInit && (!payloadType || payloadType === 'treemapZoomToNode' || payloadType === 'treemapRootToNode') ? this._doAnimation(containerGroup, renderResult, seriesModel, reRoot) : renderResult.renderFinally();
	
	    this._resetController(api);
	
	    this._renderBreadcrumb(seriesModel, api, targetInfo);
	  },
	
	  /**
	   * @private
	   */
	  _giveContainerGroup: function (layoutInfo) {
	    var containerGroup = this._containerGroup;
	
	    if (!containerGroup) {
	      // FIXME
	      // 加一层containerGroup是为了clip，但是现在clip功能并没有实现。
	      containerGroup = this._containerGroup = new Group();
	
	      this._initEvents(containerGroup);
	
	      this.group.add(containerGroup);
	    }
	
	    containerGroup.attr('position', [layoutInfo.x, layoutInfo.y]);
	    return containerGroup;
	  },
	
	  /**
	   * @private
	   */
	  _doRender: function (containerGroup, seriesModel, reRoot) {
	    var thisTree = seriesModel.getData().tree;
	    var oldTree = this._oldTree; // Clear last shape records.
	
	    var lastsForAnimation = createStorage();
	    var thisStorage = createStorage();
	    var oldStorage = this._storage;
	    var willInvisibleEls = [];
	    var doRenderNode = zrUtil.curry(renderNode, seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls); // Notice: when thisTree and oldTree are the same tree (see list.cloneShallow),
	    // the oldTree is actually losted, so we can not find all of the old graphic
	    // elements from tree. So we use this stragegy: make element storage, move
	    // from old storage to new storage, clear old storage.
	
	    dualTravel(thisTree.root ? [thisTree.root] : [], oldTree && oldTree.root ? [oldTree.root] : [], containerGroup, thisTree === oldTree || !oldTree, 0); // Process all removing.
	
	    var willDeleteEls = clearStorage(oldStorage);
	    this._oldTree = thisTree;
	    this._storage = thisStorage;
	    return {
	      lastsForAnimation: lastsForAnimation,
	      willDeleteEls: willDeleteEls,
	      renderFinally: renderFinally
	    };
	
	    function dualTravel(thisViewChildren, oldViewChildren, parentGroup, sameTree, depth) {
	      // When 'render' is triggered by action,
	      // 'this' and 'old' may be the same tree,
	      // we use rawIndex in that case.
	      if (sameTree) {
	        oldViewChildren = thisViewChildren;
	        each(thisViewChildren, function (child, index) {
	          !child.isRemoved() && processNode(index, index);
	        });
	      } // Diff hierarchically (diff only in each subtree, but not whole).
	      // because, consistency of view is important.
	      else {
	          new DataDiffer(oldViewChildren, thisViewChildren, getKey, getKey).add(processNode).update(processNode).remove(zrUtil.curry(processNode, null)).execute();
	        }
	
	      function getKey(node) {
	        // Identify by name or raw index.
	        return node.getId();
	      }
	
	      function processNode(newIndex, oldIndex) {
	        var thisNode = newIndex != null ? thisViewChildren[newIndex] : null;
	        var oldNode = oldIndex != null ? oldViewChildren[oldIndex] : null;
	        var group = doRenderNode(thisNode, oldNode, parentGroup, depth);
	        group && dualTravel(thisNode && thisNode.viewChildren || [], oldNode && oldNode.viewChildren || [], group, sameTree, depth + 1);
	      }
	    }
	
	    function clearStorage(storage) {
	      var willDeleteEls = createStorage();
	      storage && each(storage, function (store, storageName) {
	        var delEls = willDeleteEls[storageName];
	        each(store, function (el) {
	          el && (delEls.push(el), el.__tmWillDelete = 1);
	        });
	      });
	      return willDeleteEls;
	    }
	
	    function renderFinally() {
	      each(willDeleteEls, function (els) {
	        each(els, function (el) {
	          el.parent && el.parent.remove(el);
	        });
	      });
	      each(willInvisibleEls, function (el) {
	        el.invisible = true; // Setting invisible is for optimizing, so no need to set dirty,
	        // just mark as invisible.
	
	        el.dirty();
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _doAnimation: function (containerGroup, renderResult, seriesModel, reRoot) {
	    if (!seriesModel.get('animation')) {
	      return;
	    }
	
	    var duration = seriesModel.get('animationDurationUpdate');
	    var easing = seriesModel.get('animationEasing');
	    var animationWrap = animationUtil.createWrap(); // Make delete animations.
	
	    each(renderResult.willDeleteEls, function (store, storageName) {
	      each(store, function (el, rawIndex) {
	        if (el.invisible) {
	          return;
	        }
	
	        var parent = el.parent; // Always has parent, and parent is nodeGroup.
	
	        var target;
	
	        if (reRoot && reRoot.direction === 'drillDown') {
	          target = parent === reRoot.rootNodeGroup // This is the content element of view root.
	          // Only `content` will enter this branch, because
	          // `background` and `nodeGroup` will not be deleted.
	          ? {
	            shape: {
	              x: 0,
	              y: 0,
	              width: parent.__tmNodeWidth,
	              height: parent.__tmNodeHeight
	            },
	            style: {
	              opacity: 0
	            } // Others.
	
	          } : {
	            style: {
	              opacity: 0
	            }
	          };
	        } else {
	          var targetX = 0;
	          var targetY = 0;
	
	          if (!parent.__tmWillDelete) {
	            // Let node animate to right-bottom corner, cooperating with fadeout,
	            // which is appropriate for user understanding.
	            // Divided by 2 for reRoot rolling up effect.
	            targetX = parent.__tmNodeWidth / 2;
	            targetY = parent.__tmNodeHeight / 2;
	          }
	
	          target = storageName === 'nodeGroup' ? {
	            position: [targetX, targetY],
	            style: {
	              opacity: 0
	            }
	          } : {
	            shape: {
	              x: targetX,
	              y: targetY,
	              width: 0,
	              height: 0
	            },
	            style: {
	              opacity: 0
	            }
	          };
	        }
	
	        target && animationWrap.add(el, target, duration, easing);
	      });
	    }); // Make other animations
	
	    each(this._storage, function (store, storageName) {
	      each(store, function (el, rawIndex) {
	        var last = renderResult.lastsForAnimation[storageName][rawIndex];
	        var target = {};
	
	        if (!last) {
	          return;
	        }
	
	        if (storageName === 'nodeGroup') {
	          if (last.old) {
	            target.position = el.position.slice();
	            el.attr('position', last.old);
	          }
	        } else {
	          if (last.old) {
	            target.shape = zrUtil.extend({}, el.shape);
	            el.setShape(last.old);
	          }
	
	          if (last.fadein) {
	            el.setStyle('opacity', 0);
	            target.style = {
	              opacity: 1
	            };
	          } // When animation is stopped for succedent animation starting,
	          // el.style.opacity might not be 1
	          else if (el.style.opacity !== 1) {
	              target.style = {
	                opacity: 1
	              };
	            }
	        }
	
	        animationWrap.add(el, target, duration, easing);
	      });
	    }, this);
	    this._state = 'animating';
	    animationWrap.done(bind(function () {
	      this._state = 'ready';
	      renderResult.renderFinally();
	    }, this)).start();
	  },
	
	  /**
	   * @private
	   */
	  _resetController: function (api) {
	    var controller = this._controller; // Init controller.
	
	    if (!controller) {
	      controller = this._controller = new RoamController(api.getZr());
	      controller.enable(this.seriesModel.get('roam'));
	      controller.on('pan', bind(this._onPan, this));
	      controller.on('zoom', bind(this._onZoom, this));
	    }
	
	    var rect = new BoundingRect(0, 0, api.getWidth(), api.getHeight());
	    controller.setPointerChecker(function (e, x, y) {
	      return rect.contain(x, y);
	    });
	  },
	
	  /**
	   * @private
	   */
	  _clearController: function () {
	    var controller = this._controller;
	
	    if (controller) {
	      controller.dispose();
	      controller = null;
	    }
	  },
	
	  /**
	   * @private
	   */
	  _onPan: function (e) {
	    if (this._state !== 'animating' && (Math.abs(e.dx) > DRAG_THRESHOLD || Math.abs(e.dy) > DRAG_THRESHOLD)) {
	      // These param must not be cached.
	      var root = this.seriesModel.getData().tree.root;
	
	      if (!root) {
	        return;
	      }
	
	      var rootLayout = root.getLayout();
	
	      if (!rootLayout) {
	        return;
	      }
	
	      this.api.dispatchAction({
	        type: 'treemapMove',
	        from: this.uid,
	        seriesId: this.seriesModel.id,
	        rootRect: {
	          x: rootLayout.x + e.dx,
	          y: rootLayout.y + e.dy,
	          width: rootLayout.width,
	          height: rootLayout.height
	        }
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _onZoom: function (e) {
	    var mouseX = e.originX;
	    var mouseY = e.originY;
	
	    if (this._state !== 'animating') {
	      // These param must not be cached.
	      var root = this.seriesModel.getData().tree.root;
	
	      if (!root) {
	        return;
	      }
	
	      var rootLayout = root.getLayout();
	
	      if (!rootLayout) {
	        return;
	      }
	
	      var rect = new BoundingRect(rootLayout.x, rootLayout.y, rootLayout.width, rootLayout.height);
	      var layoutInfo = this.seriesModel.layoutInfo; // Transform mouse coord from global to containerGroup.
	
	      mouseX -= layoutInfo.x;
	      mouseY -= layoutInfo.y; // Scale root bounding rect.
	
	      var m = matrix.create();
	      matrix.translate(m, m, [-mouseX, -mouseY]);
	      matrix.scale(m, m, [e.scale, e.scale]);
	      matrix.translate(m, m, [mouseX, mouseY]);
	      rect.applyTransform(m);
	      this.api.dispatchAction({
	        type: 'treemapRender',
	        from: this.uid,
	        seriesId: this.seriesModel.id,
	        rootRect: {
	          x: rect.x,
	          y: rect.y,
	          width: rect.width,
	          height: rect.height
	        }
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _initEvents: function (containerGroup) {
	    containerGroup.on('click', function (e) {
	      if (this._state !== 'ready') {
	        return;
	      }
	
	      var nodeClick = this.seriesModel.get('nodeClick', true);
	
	      if (!nodeClick) {
	        return;
	      }
	
	      var targetInfo = this.findTarget(e.offsetX, e.offsetY);
	
	      if (!targetInfo) {
	        return;
	      }
	
	      var node = targetInfo.node;
	
	      if (node.getLayout().isLeafRoot) {
	        this._rootToNode(targetInfo);
	      } else {
	        if (nodeClick === 'zoomToNode') {
	          this._zoomToNode(targetInfo);
	        } else if (nodeClick === 'link') {
	          var itemModel = node.hostTree.data.getItemModel(node.dataIndex);
	          var link = itemModel.get('link', true);
	          var linkTarget = itemModel.get('target', true) || 'blank';
	          link && windowOpen(link, linkTarget);
	        }
	      }
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _renderBreadcrumb: function (seriesModel, api, targetInfo) {
	    if (!targetInfo) {
	      targetInfo = seriesModel.get('leafDepth', true) != null ? {
	        node: seriesModel.getViewRoot() // FIXME
	        // better way?
	        // Find breadcrumb tail on center of containerGroup.
	
	      } : this.findTarget(api.getWidth() / 2, api.getHeight() / 2);
	
	      if (!targetInfo) {
	        targetInfo = {
	          node: seriesModel.getData().tree.root
	        };
	      }
	    }
	
	    (this._breadcrumb || (this._breadcrumb = new Breadcrumb(this.group))).render(seriesModel, api, targetInfo.node, bind(onSelect, this));
	
	    function onSelect(node) {
	      if (this._state !== 'animating') {
	        helper.aboveViewRoot(seriesModel.getViewRoot(), node) ? this._rootToNode({
	          node: node
	        }) : this._zoomToNode({
	          node: node
	        });
	      }
	    }
	  },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    this._clearController();
	
	    this._containerGroup && this._containerGroup.removeAll();
	    this._storage = createStorage();
	    this._state = 'ready';
	    this._breadcrumb && this._breadcrumb.remove();
	  },
	  dispose: function () {
	    this._clearController();
	  },
	
	  /**
	   * @private
	   */
	  _zoomToNode: function (targetInfo) {
	    this.api.dispatchAction({
	      type: 'treemapZoomToNode',
	      from: this.uid,
	      seriesId: this.seriesModel.id,
	      targetNode: targetInfo.node
	    });
	  },
	
	  /**
	   * @private
	   */
	  _rootToNode: function (targetInfo) {
	    this.api.dispatchAction({
	      type: 'treemapRootToNode',
	      from: this.uid,
	      seriesId: this.seriesModel.id,
	      targetNode: targetInfo.node
	    });
	  },
	
	  /**
	   * @public
	   * @param {number} x Global coord x.
	   * @param {number} y Global coord y.
	   * @return {Object} info If not found, return undefined;
	   * @return {number} info.node Target node.
	   * @return {number} info.offsetX x refer to target node.
	   * @return {number} info.offsetY y refer to target node.
	   */
	  findTarget: function (x, y) {
	    var targetInfo;
	    var viewRoot = this.seriesModel.getViewRoot();
	    viewRoot.eachNode({
	      attr: 'viewChildren',
	      order: 'preorder'
	    }, function (node) {
	      var bgEl = this._storage.background[node.getRawIndex()]; // If invisible, there might be no element.
	
	
	      if (bgEl) {
	        var point = bgEl.transformCoordToLocal(x, y);
	        var shape = bgEl.shape; // For performance consideration, dont use 'getBoundingRect'.
	
	        if (shape.x <= point[0] && point[0] <= shape.x + shape.width && shape.y <= point[1] && point[1] <= shape.y + shape.height) {
	          targetInfo = {
	            node: node,
	            offsetX: point[0],
	            offsetY: point[1]
	          };
	        } else {
	          return false; // Suppress visit subtree.
	        }
	      }
	    }, this);
	    return targetInfo;
	  }
	});
	/**
	 * @inner
	 */
	
	
	function createStorage() {
	  return {
	    nodeGroup: [],
	    background: [],
	    content: []
	  };
	}
	/**
	 * @inner
	 * @return Return undefined means do not travel further.
	 */
	
	
	function renderNode(seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls, thisNode, oldNode, parentGroup, depth) {
	  // Whether under viewRoot.
	  if (!thisNode) {
	    // Deleting nodes will be performed finally. This method just find
	    // element from old storage, or create new element, set them to new
	    // storage, and set styles.
	    return;
	  } // -------------------------------------------------------------------
	  // Start of closure variables available in "Procedures in renderNode".
	
	
	  var thisLayout = thisNode.getLayout();
	  var data = seriesModel.getData(); // Only for enabling highlight/downplay. Clear firstly.
	  // Because some node will not be rendered.
	
	  data.setItemGraphicEl(thisNode.dataIndex, null);
	
	  if (!thisLayout || !thisLayout.isInView) {
	    return;
	  }
	
	  var thisWidth = thisLayout.width;
	  var thisHeight = thisLayout.height;
	  var borderWidth = thisLayout.borderWidth;
	  var thisInvisible = thisLayout.invisible;
	  var thisRawIndex = thisNode.getRawIndex();
	  var oldRawIndex = oldNode && oldNode.getRawIndex();
	  var thisViewChildren = thisNode.viewChildren;
	  var upperHeight = thisLayout.upperHeight;
	  var isParent = thisViewChildren && thisViewChildren.length;
	  var itemStyleNormalModel = thisNode.getModel('itemStyle');
	  var itemStyleEmphasisModel = thisNode.getModel('emphasis.itemStyle'); // End of closure ariables available in "Procedures in renderNode".
	  // -----------------------------------------------------------------
	  // Node group
	
	  var group = giveGraphic('nodeGroup', Group);
	
	  if (!group) {
	    return;
	  }
	
	  parentGroup.add(group); // x,y are not set when el is above view root.
	
	  group.attr('position', [thisLayout.x || 0, thisLayout.y || 0]);
	  group.__tmNodeWidth = thisWidth;
	  group.__tmNodeHeight = thisHeight;
	
	  if (thisLayout.isAboveViewRoot) {
	    return group;
	  }
	
	  var nodeModel = thisNode.getModel(); // Background
	
	  var bg = giveGraphic('background', Rect, depth, Z_BG);
	  bg && renderBackground(group, bg, isParent && thisLayout.upperLabelHeight); // No children, render content.
	
	  if (isParent) {
	    // Because of the implementation about "traverse" in graphic hover style, we
	    // can not set hover listener on the "group" of non-leaf node. Otherwise the
	    // hover event from the descendents will be listenered.
	    if (graphic.isHighDownDispatcher(group)) {
	      graphic.setAsHighDownDispatcher(group, false);
	    }
	
	    if (bg) {
	      graphic.setAsHighDownDispatcher(bg, true); // Only for enabling highlight/downplay.
	
	      data.setItemGraphicEl(thisNode.dataIndex, bg);
	    }
	  } else {
	    var content = giveGraphic('content', Rect, depth, Z_CONTENT);
	    content && renderContent(group, content);
	
	    if (bg && graphic.isHighDownDispatcher(bg)) {
	      graphic.setAsHighDownDispatcher(bg, false);
	    }
	
	    graphic.setAsHighDownDispatcher(group, true); // Only for enabling highlight/downplay.
	
	    data.setItemGraphicEl(thisNode.dataIndex, group);
	  }
	
	  return group; // ----------------------------
	  // | Procedures in renderNode |
	  // ----------------------------
	
	  function renderBackground(group, bg, useUpperLabel) {
	    // For tooltip.
	    bg.dataIndex = thisNode.dataIndex;
	    bg.seriesIndex = seriesModel.seriesIndex;
	    bg.setShape({
	      x: 0,
	      y: 0,
	      width: thisWidth,
	      height: thisHeight
	    });
	
	    if (thisInvisible) {
	      // If invisible, do not set visual, otherwise the element will
	      // change immediately before animation. We think it is OK to
	      // remain its origin color when moving out of the view window.
	      processInvisible(bg);
	    } else {
	      bg.invisible = false;
	      var visualBorderColor = thisNode.getVisual('borderColor', true);
	      var emphasisBorderColor = itemStyleEmphasisModel.get('borderColor');
	      var normalStyle = getItemStyleNormal(itemStyleNormalModel);
	      normalStyle.fill = visualBorderColor;
	      var emphasisStyle = getItemStyleEmphasis(itemStyleEmphasisModel);
	      emphasisStyle.fill = emphasisBorderColor;
	
	      if (useUpperLabel) {
	        var upperLabelWidth = thisWidth - 2 * borderWidth;
	        prepareText(normalStyle, emphasisStyle, visualBorderColor, upperLabelWidth, upperHeight, {
	          x: borderWidth,
	          y: 0,
	          width: upperLabelWidth,
	          height: upperHeight
	        });
	      } // For old bg.
	      else {
	          normalStyle.text = emphasisStyle.text = null;
	        }
	
	      bg.setStyle(normalStyle);
	      graphic.setElementHoverStyle(bg, emphasisStyle);
	    }
	
	    group.add(bg);
	  }
	
	  function renderContent(group, content) {
	    // For tooltip.
	    content.dataIndex = thisNode.dataIndex;
	    content.seriesIndex = seriesModel.seriesIndex;
	    var contentWidth = Math.max(thisWidth - 2 * borderWidth, 0);
	    var contentHeight = Math.max(thisHeight - 2 * borderWidth, 0);
	    content.culling = true;
	    content.setShape({
	      x: borderWidth,
	      y: borderWidth,
	      width: contentWidth,
	      height: contentHeight
	    });
	
	    if (thisInvisible) {
	      // If invisible, do not set visual, otherwise the element will
	      // change immediately before animation. We think it is OK to
	      // remain its origin color when moving out of the view window.
	      processInvisible(content);
	    } else {
	      content.invisible = false;
	      var visualColor = thisNode.getVisual('color', true);
	      var normalStyle = getItemStyleNormal(itemStyleNormalModel);
	      normalStyle.fill = visualColor;
	      var emphasisStyle = getItemStyleEmphasis(itemStyleEmphasisModel);
	      prepareText(normalStyle, emphasisStyle, visualColor, contentWidth, contentHeight);
	      content.setStyle(normalStyle);
	      graphic.setElementHoverStyle(content, emphasisStyle);
	    }
	
	    group.add(content);
	  }
	
	  function processInvisible(element) {
	    // Delay invisible setting utill animation finished,
	    // avoid element vanish suddenly before animation.
	    !element.invisible && willInvisibleEls.push(element);
	  }
	
	  function prepareText(normalStyle, emphasisStyle, visualColor, width, height, upperLabelRect) {
	    var defaultText = nodeModel.get('name');
	    var normalLabelModel = nodeModel.getModel(upperLabelRect ? PATH_UPPERLABEL_NORMAL : PATH_LABEL_NOAMAL);
	    var emphasisLabelModel = nodeModel.getModel(upperLabelRect ? PATH_UPPERLABEL_EMPHASIS : PATH_LABEL_EMPHASIS);
	    var isShow = normalLabelModel.getShallow('show');
	    graphic.setLabelStyle(normalStyle, emphasisStyle, normalLabelModel, emphasisLabelModel, {
	      defaultText: isShow ? defaultText : null,
	      autoColor: visualColor,
	      isRectText: true,
	      labelFetcher: seriesModel,
	      labelDataIndex: thisNode.dataIndex,
	      labelProp: upperLabelRect ? 'upperLabel' : 'label'
	    });
	    addDrillDownIcon(normalStyle, upperLabelRect, thisLayout);
	    addDrillDownIcon(emphasisStyle, upperLabelRect, thisLayout);
	    upperLabelRect && (normalStyle.textRect = zrUtil.clone(upperLabelRect));
	    normalStyle.truncate = isShow && normalLabelModel.get('ellipsis') ? {
	      outerWidth: width,
	      outerHeight: height,
	      minChar: 2
	    } : null;
	  }
	
	  function addDrillDownIcon(style, upperLabelRect, thisLayout) {
	    var text = style.text;
	
	    if (!upperLabelRect && thisLayout.isLeafRoot && text != null) {
	      var iconChar = seriesModel.get('drillDownIcon', true);
	      style.text = iconChar ? iconChar + ' ' + text : text;
	    }
	  }
	
	  function giveGraphic(storageName, Ctor, depth, z) {
	    var element = oldRawIndex != null && oldStorage[storageName][oldRawIndex];
	    var lasts = lastsForAnimation[storageName];
	
	    if (element) {
	      // Remove from oldStorage
	      oldStorage[storageName][oldRawIndex] = null;
	      prepareAnimationWhenHasOld(lasts, element, storageName);
	    } // If invisible and no old element, do not create new element (for optimizing).
	    else if (!thisInvisible) {
	        element = new Ctor({
	          z: calculateZ(depth, z)
	        });
	        element.__tmDepth = depth;
	        element.__tmStorageName = storageName;
	        prepareAnimationWhenNoOld(lasts, element, storageName);
	      } // Set to thisStorage
	
	
	    return thisStorage[storageName][thisRawIndex] = element;
	  }
	
	  function prepareAnimationWhenHasOld(lasts, element, storageName) {
	    var lastCfg = lasts[thisRawIndex] = {};
	    lastCfg.old = storageName === 'nodeGroup' ? element.position.slice() : zrUtil.extend({}, element.shape);
	  } // If a element is new, we need to find the animation start point carefully,
	  // otherwise it will looks strange when 'zoomToNode'.
	
	
	  function prepareAnimationWhenNoOld(lasts, element, storageName) {
	    var lastCfg = lasts[thisRawIndex] = {};
	    var parentNode = thisNode.parentNode;
	
	    if (parentNode && (!reRoot || reRoot.direction === 'drillDown')) {
	      var parentOldX = 0;
	      var parentOldY = 0; // New nodes appear from right-bottom corner in 'zoomToNode' animation.
	      // For convenience, get old bounding rect from background.
	
	      var parentOldBg = lastsForAnimation.background[parentNode.getRawIndex()];
	
	      if (!reRoot && parentOldBg && parentOldBg.old) {
	        parentOldX = parentOldBg.old.width;
	        parentOldY = parentOldBg.old.height;
	      } // When no parent old shape found, its parent is new too,
	      // so we can just use {x:0, y:0}.
	
	
	      lastCfg.old = storageName === 'nodeGroup' ? [0, parentOldY] : {
	        x: parentOldX,
	        y: parentOldY,
	        width: 0,
	        height: 0
	      };
	    } // Fade in, user can be aware that these nodes are new.
	
	
	    lastCfg.fadein = storageName !== 'nodeGroup';
	  }
	} // We can not set all backgroud with the same z, Because the behaviour of
	// drill down and roll up differ background creation sequence from tree
	// hierarchy sequence, which cause that lowser background element overlap
	// upper ones. So we calculate z based on depth.
	// Moreover, we try to shrink down z interval to [0, 1] to avoid that
	// treemap with large z overlaps other components.
	
	
	function calculateZ(depth, zInLevel) {
	  var zb = depth * Z_BASE + zInLevel;
	  return (zb - 1) / zb;
	}
	
	module.exports = _default;

/***/ },
/* 1564 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var helper = __webpack_require__(164);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @file Treemap action
	 */
	var noop = function () {};
	
	var actionTypes = ['treemapZoomToNode', 'treemapRender', 'treemapMove'];
	
	for (var i = 0; i < actionTypes.length; i++) {
	  echarts.registerAction({
	    type: actionTypes[i],
	    update: 'updateView'
	  }, noop);
	}
	
	echarts.registerAction({
	  type: 'treemapRootToNode',
	  update: 'updateView'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'treemap',
	    query: payload
	  }, handleRootToNode);
	
	  function handleRootToNode(model, index) {
	    var types = ['treemapZoomToNode', 'treemapRootToNode'];
	    var targetInfo = helper.retrieveTargetInfo(payload, types, model);
	
	    if (targetInfo) {
	      var originViewRoot = model.getViewRoot();
	
	      if (originViewRoot) {
	        payload.direction = helper.aboveViewRoot(originViewRoot, targetInfo.node) ? 'rollUp' : 'drillDown';
	      }
	
	      model.resetViewRoot(targetInfo.node);
	    }
	  }
	});

/***/ },
/* 1565 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var BoundingRect = __webpack_require__(42);
	
	var _number = __webpack_require__(20);
	
	var parsePercent = _number.parsePercent;
	var MAX_SAFE_INTEGER = _number.MAX_SAFE_INTEGER;
	
	var layout = __webpack_require__(36);
	
	var helper = __webpack_require__(164);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* A third-party license is embeded for some of the code in this file:
	* The treemap layout implementation was originally copied from
	* "d3.js" with some modifications made for this project.
	* (See more details in the comment of the method "squarify" below.)
	* The use of the source code of this file is also subject to the terms
	* and consitions of the license of "d3.js" (BSD-3Clause, see
	* </licenses/LICENSE-d3>).
	*/
	var mathMax = Math.max;
	var mathMin = Math.min;
	var retrieveValue = zrUtil.retrieve;
	var each = zrUtil.each;
	var PATH_BORDER_WIDTH = ['itemStyle', 'borderWidth'];
	var PATH_GAP_WIDTH = ['itemStyle', 'gapWidth'];
	var PATH_UPPER_LABEL_SHOW = ['upperLabel', 'show'];
	var PATH_UPPER_LABEL_HEIGHT = ['upperLabel', 'height'];
	/**
	 * @public
	 */
	
	var _default = {
	  seriesType: 'treemap',
	  reset: function (seriesModel, ecModel, api, payload) {
	    // Layout result in each node:
	    // {x, y, width, height, area, borderWidth}
	    var ecWidth = api.getWidth();
	    var ecHeight = api.getHeight();
	    var seriesOption = seriesModel.option;
	    var layoutInfo = layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
	      width: api.getWidth(),
	      height: api.getHeight()
	    });
	    var size = seriesOption.size || []; // Compatible with ec2.
	
	    var containerWidth = parsePercent(retrieveValue(layoutInfo.width, size[0]), ecWidth);
	    var containerHeight = parsePercent(retrieveValue(layoutInfo.height, size[1]), ecHeight); // Fetch payload info.
	
	    var payloadType = payload && payload.type;
	    var types = ['treemapZoomToNode', 'treemapRootToNode'];
	    var targetInfo = helper.retrieveTargetInfo(payload, types, seriesModel);
	    var rootRect = payloadType === 'treemapRender' || payloadType === 'treemapMove' ? payload.rootRect : null;
	    var viewRoot = seriesModel.getViewRoot();
	    var viewAbovePath = helper.getPathToRoot(viewRoot);
	
	    if (payloadType !== 'treemapMove') {
	      var rootSize = payloadType === 'treemapZoomToNode' ? estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) : rootRect ? [rootRect.width, rootRect.height] : [containerWidth, containerHeight];
	      var sort = seriesOption.sort;
	
	      if (sort && sort !== 'asc' && sort !== 'desc') {
	        sort = 'desc';
	      }
	
	      var options = {
	        squareRatio: seriesOption.squareRatio,
	        sort: sort,
	        leafDepth: seriesOption.leafDepth
	      }; // layout should be cleared because using updateView but not update.
	
	      viewRoot.hostTree.clearLayouts(); // TODO
	      // optimize: if out of view clip, do not layout.
	      // But take care that if do not render node out of view clip,
	      // how to calculate start po
	
	      var viewRootLayout = {
	        x: 0,
	        y: 0,
	        width: rootSize[0],
	        height: rootSize[1],
	        area: rootSize[0] * rootSize[1]
	      };
	      viewRoot.setLayout(viewRootLayout);
	      squarify(viewRoot, options, false, 0); // Supplement layout.
	
	      var viewRootLayout = viewRoot.getLayout();
	      each(viewAbovePath, function (node, index) {
	        var childValue = (viewAbovePath[index + 1] || viewRoot).getValue();
	        node.setLayout(zrUtil.extend({
	          dataExtent: [childValue, childValue],
	          borderWidth: 0,
	          upperHeight: 0
	        }, viewRootLayout));
	      });
	    }
	
	    var treeRoot = seriesModel.getData().tree.root;
	    treeRoot.setLayout(calculateRootPosition(layoutInfo, rootRect, targetInfo), true);
	    seriesModel.setLayoutInfo(layoutInfo); // FIXME
	    // 现在没有clip功能，暂时取ec高宽。
	
	    prunning(treeRoot, // Transform to base element coordinate system.
	    new BoundingRect(-layoutInfo.x, -layoutInfo.y, ecWidth, ecHeight), viewAbovePath, viewRoot, 0);
	  }
	};
	/**
	 * Layout treemap with squarify algorithm.
	 * The original presentation of this algorithm
	 * was made by Mark Bruls, Kees Huizing, and Jarke J. van Wijk
	 * <https://graphics.ethz.ch/teaching/scivis_common/Literature/squarifiedTreeMaps.pdf>.
	 * The implementation of this algorithm was originally copied from "d3.js"
	 * <https://github.com/d3/d3/blob/9cc9a875e636a1dcf36cc1e07bdf77e1ad6e2c74/src/layout/treemap.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 *
	 * @protected
	 * @param {module:echarts/data/Tree~TreeNode} node
	 * @param {Object} options
	 * @param {string} options.sort 'asc' or 'desc'
	 * @param {number} options.squareRatio
	 * @param {boolean} hideChildren
	 * @param {number} depth
	 */
	
	function squarify(node, options, hideChildren, depth) {
	  var width;
	  var height;
	
	  if (node.isRemoved()) {
	    return;
	  }
	
	  var thisLayout = node.getLayout();
	  width = thisLayout.width;
	  height = thisLayout.height; // Considering border and gap
	
	  var nodeModel = node.getModel();
	  var borderWidth = nodeModel.get(PATH_BORDER_WIDTH);
	  var halfGapWidth = nodeModel.get(PATH_GAP_WIDTH) / 2;
	  var upperLabelHeight = getUpperLabelHeight(nodeModel);
	  var upperHeight = Math.max(borderWidth, upperLabelHeight);
	  var layoutOffset = borderWidth - halfGapWidth;
	  var layoutOffsetUpper = upperHeight - halfGapWidth;
	  var nodeModel = node.getModel();
	  node.setLayout({
	    borderWidth: borderWidth,
	    upperHeight: upperHeight,
	    upperLabelHeight: upperLabelHeight
	  }, true);
	  width = mathMax(width - 2 * layoutOffset, 0);
	  height = mathMax(height - layoutOffset - layoutOffsetUpper, 0);
	  var totalArea = width * height;
	  var viewChildren = initChildren(node, nodeModel, totalArea, options, hideChildren, depth);
	
	  if (!viewChildren.length) {
	    return;
	  }
	
	  var rect = {
	    x: layoutOffset,
	    y: layoutOffsetUpper,
	    width: width,
	    height: height
	  };
	  var rowFixedLength = mathMin(width, height);
	  var best = Infinity; // the best row score so far
	
	  var row = [];
	  row.area = 0;
	
	  for (var i = 0, len = viewChildren.length; i < len;) {
	    var child = viewChildren[i];
	    row.push(child);
	    row.area += child.getLayout().area;
	    var score = worst(row, rowFixedLength, options.squareRatio); // continue with this orientation
	
	    if (score <= best) {
	      i++;
	      best = score;
	    } // abort, and try a different orientation
	    else {
	        row.area -= row.pop().getLayout().area;
	        position(row, rowFixedLength, rect, halfGapWidth, false);
	        rowFixedLength = mathMin(rect.width, rect.height);
	        row.length = row.area = 0;
	        best = Infinity;
	      }
	  }
	
	  if (row.length) {
	    position(row, rowFixedLength, rect, halfGapWidth, true);
	  }
	
	  if (!hideChildren) {
	    var childrenVisibleMin = nodeModel.get('childrenVisibleMin');
	
	    if (childrenVisibleMin != null && totalArea < childrenVisibleMin) {
	      hideChildren = true;
	    }
	  }
	
	  for (var i = 0, len = viewChildren.length; i < len; i++) {
	    squarify(viewChildren[i], options, hideChildren, depth + 1);
	  }
	}
	/**
	 * Set area to each child, and calculate data extent for visual coding.
	 */
	
	
	function initChildren(node, nodeModel, totalArea, options, hideChildren, depth) {
	  var viewChildren = node.children || [];
	  var orderBy = options.sort;
	  orderBy !== 'asc' && orderBy !== 'desc' && (orderBy = null);
	  var overLeafDepth = options.leafDepth != null && options.leafDepth <= depth; // leafDepth has higher priority.
	
	  if (hideChildren && !overLeafDepth) {
	    return node.viewChildren = [];
	  } // Sort children, order by desc.
	
	
	  viewChildren = zrUtil.filter(viewChildren, function (child) {
	    return !child.isRemoved();
	  });
	  sort(viewChildren, orderBy);
	  var info = statistic(nodeModel, viewChildren, orderBy);
	
	  if (info.sum === 0) {
	    return node.viewChildren = [];
	  }
	
	  info.sum = filterByThreshold(nodeModel, totalArea, info.sum, orderBy, viewChildren);
	
	  if (info.sum === 0) {
	    return node.viewChildren = [];
	  } // Set area to each child.
	
	
	  for (var i = 0, len = viewChildren.length; i < len; i++) {
	    var area = viewChildren[i].getValue() / info.sum * totalArea; // Do not use setLayout({...}, true), because it is needed to clear last layout.
	
	    viewChildren[i].setLayout({
	      area: area
	    });
	  }
	
	  if (overLeafDepth) {
	    viewChildren.length && node.setLayout({
	      isLeafRoot: true
	    }, true);
	    viewChildren.length = 0;
	  }
	
	  node.viewChildren = viewChildren;
	  node.setLayout({
	    dataExtent: info.dataExtent
	  }, true);
	  return viewChildren;
	}
	/**
	 * Consider 'visibleMin'. Modify viewChildren and get new sum.
	 */
	
	
	function filterByThreshold(nodeModel, totalArea, sum, orderBy, orderedChildren) {
	  // visibleMin is not supported yet when no option.sort.
	  if (!orderBy) {
	    return sum;
	  }
	
	  var visibleMin = nodeModel.get('visibleMin');
	  var len = orderedChildren.length;
	  var deletePoint = len; // Always travel from little value to big value.
	
	  for (var i = len - 1; i >= 0; i--) {
	    var value = orderedChildren[orderBy === 'asc' ? len - i - 1 : i].getValue();
	
	    if (value / sum * totalArea < visibleMin) {
	      deletePoint = i;
	      sum -= value;
	    }
	  }
	
	  orderBy === 'asc' ? orderedChildren.splice(0, len - deletePoint) : orderedChildren.splice(deletePoint, len - deletePoint);
	  return sum;
	}
	/**
	 * Sort
	 */
	
	
	function sort(viewChildren, orderBy) {
	  if (orderBy) {
	    viewChildren.sort(function (a, b) {
	      var diff = orderBy === 'asc' ? a.getValue() - b.getValue() : b.getValue() - a.getValue();
	      return diff === 0 ? orderBy === 'asc' ? a.dataIndex - b.dataIndex : b.dataIndex - a.dataIndex : diff;
	    });
	  }
	
	  return viewChildren;
	}
	/**
	 * Statistic
	 */
	
	
	function statistic(nodeModel, children, orderBy) {
	  // Calculate sum.
	  var sum = 0;
	
	  for (var i = 0, len = children.length; i < len; i++) {
	    sum += children[i].getValue();
	  } // Statistic data extent for latter visual coding.
	  // Notice: data extent should be calculate based on raw children
	  // but not filtered view children, otherwise visual mapping will not
	  // be stable when zoom (where children is filtered by visibleMin).
	
	
	  var dimension = nodeModel.get('visualDimension');
	  var dataExtent; // The same as area dimension.
	
	  if (!children || !children.length) {
	    dataExtent = [NaN, NaN];
	  } else if (dimension === 'value' && orderBy) {
	    dataExtent = [children[children.length - 1].getValue(), children[0].getValue()];
	    orderBy === 'asc' && dataExtent.reverse();
	  } // Other dimension.
	  else {
	      var dataExtent = [Infinity, -Infinity];
	      each(children, function (child) {
	        var value = child.getValue(dimension);
	        value < dataExtent[0] && (dataExtent[0] = value);
	        value > dataExtent[1] && (dataExtent[1] = value);
	      });
	    }
	
	  return {
	    sum: sum,
	    dataExtent: dataExtent
	  };
	}
	/**
	 * Computes the score for the specified row,
	 * as the worst aspect ratio.
	 */
	
	
	function worst(row, rowFixedLength, ratio) {
	  var areaMax = 0;
	  var areaMin = Infinity;
	
	  for (var i = 0, area, len = row.length; i < len; i++) {
	    area = row[i].getLayout().area;
	
	    if (area) {
	      area < areaMin && (areaMin = area);
	      area > areaMax && (areaMax = area);
	    }
	  }
	
	  var squareArea = row.area * row.area;
	  var f = rowFixedLength * rowFixedLength * ratio;
	  return squareArea ? mathMax(f * areaMax / squareArea, squareArea / (f * areaMin)) : Infinity;
	}
	/**
	 * Positions the specified row of nodes. Modifies `rect`.
	 */
	
	
	function position(row, rowFixedLength, rect, halfGapWidth, flush) {
	  // When rowFixedLength === rect.width,
	  // it is horizontal subdivision,
	  // rowFixedLength is the width of the subdivision,
	  // rowOtherLength is the height of the subdivision,
	  // and nodes will be positioned from left to right.
	  // wh[idx0WhenH] means: when horizontal,
	  //      wh[idx0WhenH] => wh[0] => 'width'.
	  //      xy[idx1WhenH] => xy[1] => 'y'.
	  var idx0WhenH = rowFixedLength === rect.width ? 0 : 1;
	  var idx1WhenH = 1 - idx0WhenH;
	  var xy = ['x', 'y'];
	  var wh = ['width', 'height'];
	  var last = rect[xy[idx0WhenH]];
	  var rowOtherLength = rowFixedLength ? row.area / rowFixedLength : 0;
	
	  if (flush || rowOtherLength > rect[wh[idx1WhenH]]) {
	    rowOtherLength = rect[wh[idx1WhenH]]; // over+underflow
	  }
	
	  for (var i = 0, rowLen = row.length; i < rowLen; i++) {
	    var node = row[i];
	    var nodeLayout = {};
	    var step = rowOtherLength ? node.getLayout().area / rowOtherLength : 0;
	    var wh1 = nodeLayout[wh[idx1WhenH]] = mathMax(rowOtherLength - 2 * halfGapWidth, 0); // We use Math.max/min to avoid negative width/height when considering gap width.
	
	    var remain = rect[xy[idx0WhenH]] + rect[wh[idx0WhenH]] - last;
	    var modWH = i === rowLen - 1 || remain < step ? remain : step;
	    var wh0 = nodeLayout[wh[idx0WhenH]] = mathMax(modWH - 2 * halfGapWidth, 0);
	    nodeLayout[xy[idx1WhenH]] = rect[xy[idx1WhenH]] + mathMin(halfGapWidth, wh1 / 2);
	    nodeLayout[xy[idx0WhenH]] = last + mathMin(halfGapWidth, wh0 / 2);
	    last += modWH;
	    node.setLayout(nodeLayout, true);
	  }
	
	  rect[xy[idx1WhenH]] += rowOtherLength;
	  rect[wh[idx1WhenH]] -= rowOtherLength;
	} // Return [containerWidth, containerHeight] as default.
	
	
	function estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) {
	  // If targetInfo.node exists, we zoom to the node,
	  // so estimate whold width and heigth by target node.
	  var currNode = (targetInfo || {}).node;
	  var defaultSize = [containerWidth, containerHeight];
	
	  if (!currNode || currNode === viewRoot) {
	    return defaultSize;
	  }
	
	  var parent;
	  var viewArea = containerWidth * containerHeight;
	  var area = viewArea * seriesModel.option.zoomToNodeRatio;
	
	  while (parent = currNode.parentNode) {
	    // jshint ignore:line
	    var sum = 0;
	    var siblings = parent.children;
	
	    for (var i = 0, len = siblings.length; i < len; i++) {
	      sum += siblings[i].getValue();
	    }
	
	    var currNodeValue = currNode.getValue();
	
	    if (currNodeValue === 0) {
	      return defaultSize;
	    }
	
	    area *= sum / currNodeValue; // Considering border, suppose aspect ratio is 1.
	
	    var parentModel = parent.getModel();
	    var borderWidth = parentModel.get(PATH_BORDER_WIDTH);
	    var upperHeight = Math.max(borderWidth, getUpperLabelHeight(parentModel, borderWidth));
	    area += 4 * borderWidth * borderWidth + (3 * borderWidth + upperHeight) * Math.pow(area, 0.5);
	    area > MAX_SAFE_INTEGER && (area = MAX_SAFE_INTEGER);
	    currNode = parent;
	  }
	
	  area < viewArea && (area = viewArea);
	  var scale = Math.pow(area / viewArea, 0.5);
	  return [containerWidth * scale, containerHeight * scale];
	} // Root postion base on coord of containerGroup
	
	
	function calculateRootPosition(layoutInfo, rootRect, targetInfo) {
	  if (rootRect) {
	    return {
	      x: rootRect.x,
	      y: rootRect.y
	    };
	  }
	
	  var defaultPosition = {
	    x: 0,
	    y: 0
	  };
	
	  if (!targetInfo) {
	    return defaultPosition;
	  } // If targetInfo is fetched by 'retrieveTargetInfo',
	  // old tree and new tree are the same tree,
	  // so the node still exists and we can visit it.
	
	
	  var targetNode = targetInfo.node;
	  var layout = targetNode.getLayout();
	
	  if (!layout) {
	    return defaultPosition;
	  } // Transform coord from local to container.
	
	
	  var targetCenter = [layout.width / 2, layout.height / 2];
	  var node = targetNode;
	
	  while (node) {
	    var nodeLayout = node.getLayout();
	    targetCenter[0] += nodeLayout.x;
	    targetCenter[1] += nodeLayout.y;
	    node = node.parentNode;
	  }
	
	  return {
	    x: layoutInfo.width / 2 - targetCenter[0],
	    y: layoutInfo.height / 2 - targetCenter[1]
	  };
	} // Mark nodes visible for prunning when visual coding and rendering.
	// Prunning depends on layout and root position, so we have to do it after layout.
	
	
	function prunning(node, clipRect, viewAbovePath, viewRoot, depth) {
	  var nodeLayout = node.getLayout();
	  var nodeInViewAbovePath = viewAbovePath[depth];
	  var isAboveViewRoot = nodeInViewAbovePath && nodeInViewAbovePath === node;
	
	  if (nodeInViewAbovePath && !isAboveViewRoot || depth === viewAbovePath.length && node !== viewRoot) {
	    return;
	  }
	
	  node.setLayout({
	    // isInView means: viewRoot sub tree + viewAbovePath
	    isInView: true,
	    // invisible only means: outside view clip so that the node can not
	    // see but still layout for animation preparation but not render.
	    invisible: !isAboveViewRoot && !clipRect.intersect(nodeLayout),
	    isAboveViewRoot: isAboveViewRoot
	  }, true); // Transform to child coordinate.
	
	  var childClipRect = new BoundingRect(clipRect.x - nodeLayout.x, clipRect.y - nodeLayout.y, clipRect.width, clipRect.height);
	  each(node.viewChildren || [], function (child) {
	    prunning(child, childClipRect, viewAbovePath, viewRoot, depth + 1);
	  });
	}
	
	function getUpperLabelHeight(model) {
	  return model.get(PATH_UPPER_LABEL_SHOW) ? model.get(PATH_UPPER_LABEL_HEIGHT) : 0;
	}
	
	module.exports = _default;

/***/ },
/* 1566 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var VisualMapping = __webpack_require__(168);
	
	var zrColor = __webpack_require__(114);
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var isArray = zrUtil.isArray;
	var ITEM_STYLE_NORMAL = 'itemStyle';
	var _default = {
	  seriesType: 'treemap',
	  reset: function (seriesModel, ecModel, api, payload) {
	    var tree = seriesModel.getData().tree;
	    var root = tree.root;
	
	    if (root.isRemoved()) {
	      return;
	    }
	
	    travelTree(root, // Visual should calculate from tree root but not view root.
	    {}, seriesModel.getViewRoot().getAncestors(), seriesModel);
	  }
	};
	
	function travelTree(node, designatedVisual, viewRootAncestors, seriesModel) {
	  var nodeModel = node.getModel();
	  var nodeLayout = node.getLayout(); // Optimize
	
	  if (!nodeLayout || nodeLayout.invisible || !nodeLayout.isInView) {
	    return;
	  }
	
	  var nodeItemStyleModel = node.getModel(ITEM_STYLE_NORMAL);
	  var visuals = buildVisuals(nodeItemStyleModel, designatedVisual, seriesModel); // calculate border color
	
	  var borderColor = nodeItemStyleModel.get('borderColor');
	  var borderColorSaturation = nodeItemStyleModel.get('borderColorSaturation');
	  var thisNodeColor;
	
	  if (borderColorSaturation != null) {
	    // For performance, do not always execute 'calculateColor'.
	    thisNodeColor = calculateColor(visuals, node);
	    borderColor = calculateBorderColor(borderColorSaturation, thisNodeColor);
	  }
	
	  node.setVisual('borderColor', borderColor);
	  var viewChildren = node.viewChildren;
	
	  if (!viewChildren || !viewChildren.length) {
	    thisNodeColor = calculateColor(visuals, node); // Apply visual to this node.
	
	    node.setVisual('color', thisNodeColor);
	  } else {
	    var mapping = buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren); // Designate visual to children.
	
	    zrUtil.each(viewChildren, function (child, index) {
	      // If higher than viewRoot, only ancestors of viewRoot is needed to visit.
	      if (child.depth >= viewRootAncestors.length || child === viewRootAncestors[child.depth]) {
	        var childVisual = mapVisual(nodeModel, visuals, child, index, mapping, seriesModel);
	        travelTree(child, childVisual, viewRootAncestors, seriesModel);
	      }
	    });
	  }
	}
	
	function buildVisuals(nodeItemStyleModel, designatedVisual, seriesModel) {
	  var visuals = zrUtil.extend({}, designatedVisual);
	  var designatedVisualItemStyle = seriesModel.designatedVisualItemStyle;
	  zrUtil.each(['color', 'colorAlpha', 'colorSaturation'], function (visualName) {
	    // Priority: thisNode > thisLevel > parentNodeDesignated > seriesModel
	    designatedVisualItemStyle[visualName] = designatedVisual[visualName];
	    var val = nodeItemStyleModel.get(visualName);
	    designatedVisualItemStyle[visualName] = null;
	    val != null && (visuals[visualName] = val);
	  });
	  return visuals;
	}
	
	function calculateColor(visuals) {
	  var color = getValueVisualDefine(visuals, 'color');
	
	  if (color) {
	    var colorAlpha = getValueVisualDefine(visuals, 'colorAlpha');
	    var colorSaturation = getValueVisualDefine(visuals, 'colorSaturation');
	
	    if (colorSaturation) {
	      color = zrColor.modifyHSL(color, null, null, colorSaturation);
	    }
	
	    if (colorAlpha) {
	      color = zrColor.modifyAlpha(color, colorAlpha);
	    }
	
	    return color;
	  }
	}
	
	function calculateBorderColor(borderColorSaturation, thisNodeColor) {
	  return thisNodeColor != null ? zrColor.modifyHSL(thisNodeColor, null, null, borderColorSaturation) : null;
	}
	
	function getValueVisualDefine(visuals, name) {
	  var value = visuals[name];
	
	  if (value != null && value !== 'none') {
	    return value;
	  }
	}
	
	function buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren) {
	  if (!viewChildren || !viewChildren.length) {
	    return;
	  }
	
	  var rangeVisual = getRangeVisual(nodeModel, 'color') || visuals.color != null && visuals.color !== 'none' && (getRangeVisual(nodeModel, 'colorAlpha') || getRangeVisual(nodeModel, 'colorSaturation'));
	
	  if (!rangeVisual) {
	    return;
	  }
	
	  var visualMin = nodeModel.get('visualMin');
	  var visualMax = nodeModel.get('visualMax');
	  var dataExtent = nodeLayout.dataExtent.slice();
	  visualMin != null && visualMin < dataExtent[0] && (dataExtent[0] = visualMin);
	  visualMax != null && visualMax > dataExtent[1] && (dataExtent[1] = visualMax);
	  var colorMappingBy = nodeModel.get('colorMappingBy');
	  var opt = {
	    type: rangeVisual.name,
	    dataExtent: dataExtent,
	    visual: rangeVisual.range
	  };
	
	  if (opt.type === 'color' && (colorMappingBy === 'index' || colorMappingBy === 'id')) {
	    opt.mappingMethod = 'category';
	    opt.loop = true; // categories is ordinal, so do not set opt.categories.
	  } else {
	    opt.mappingMethod = 'linear';
	  }
	
	  var mapping = new VisualMapping(opt);
	  mapping.__drColorMappingBy = colorMappingBy;
	  return mapping;
	} // Notice: If we dont have the attribute 'colorRange', but only use
	// attribute 'color' to represent both concepts of 'colorRange' and 'color',
	// (It means 'colorRange' when 'color' is Array, means 'color' when not array),
	// this problem will be encountered:
	// If a level-1 node dont have children, and its siblings has children,
	// and colorRange is set on level-1, then the node can not be colored.
	// So we separate 'colorRange' and 'color' to different attributes.
	
	
	function getRangeVisual(nodeModel, name) {
	  // 'colorRange', 'colorARange', 'colorSRange'.
	  // If not exsits on this node, fetch from levels and series.
	  var range = nodeModel.get(name);
	  return isArray(range) && range.length ? {
	    name: name,
	    range: range
	  } : null;
	}
	
	function mapVisual(nodeModel, visuals, child, index, mapping, seriesModel) {
	  var childVisuals = zrUtil.extend({}, visuals);
	
	  if (mapping) {
	    var mappingType = mapping.type;
	    var colorMappingBy = mappingType === 'color' && mapping.__drColorMappingBy;
	    var value = colorMappingBy === 'index' ? index : colorMappingBy === 'id' ? seriesModel.mapIdToIndex(child.getId()) : child.getValue(nodeModel.get('visualDimension'));
	    childVisuals[mappingType] = mapping.mapValueToVisual(value);
	  }
	
	  return childVisuals;
	}
	
	module.exports = _default;

/***/ },
/* 1567 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(473);
	
	__webpack_require__(1569);

/***/ },
/* 1568 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(738);
	
	__webpack_require__(1570);

/***/ },
/* 1569 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var graphic = __webpack_require__(16);
	
	var Model = __webpack_require__(48);
	
	var AxisView = __webpack_require__(165);
	
	var AxisBuilder = __webpack_require__(138);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var elementList = ['axisLine', 'axisLabel', 'axisTick', 'minorTick', 'splitLine', 'minorSplitLine', 'splitArea'];
	
	function getAxisLineShape(polar, rExtent, angle) {
	  rExtent[1] > rExtent[0] && (rExtent = rExtent.slice().reverse());
	  var start = polar.coordToPoint([rExtent[0], angle]);
	  var end = polar.coordToPoint([rExtent[1], angle]);
	  return {
	    x1: start[0],
	    y1: start[1],
	    x2: end[0],
	    y2: end[1]
	  };
	}
	
	function getRadiusIdx(polar) {
	  var radiusAxis = polar.getRadiusAxis();
	  return radiusAxis.inverse ? 0 : 1;
	} // Remove the last tick which will overlap the first tick
	
	
	function fixAngleOverlap(list) {
	  var firstItem = list[0];
	  var lastItem = list[list.length - 1];
	
	  if (firstItem && lastItem && Math.abs(Math.abs(firstItem.coord - lastItem.coord) - 360) < 1e-4) {
	    list.pop();
	  }
	}
	
	var _default = AxisView.extend({
	  type: 'angleAxis',
	  axisPointerClass: 'PolarAxisPointer',
	  render: function (angleAxisModel, ecModel) {
	    this.group.removeAll();
	
	    if (!angleAxisModel.get('show')) {
	      return;
	    }
	
	    var angleAxis = angleAxisModel.axis;
	    var polar = angleAxis.polar;
	    var radiusExtent = polar.getRadiusAxis().getExtent();
	    var ticksAngles = angleAxis.getTicksCoords();
	    var minorTickAngles = angleAxis.getMinorTicksCoords();
	    var labels = zrUtil.map(angleAxis.getViewLabels(), function (labelItem) {
	      var labelItem = zrUtil.clone(labelItem);
	      labelItem.coord = angleAxis.dataToCoord(labelItem.tickValue);
	      return labelItem;
	    });
	    fixAngleOverlap(labels);
	    fixAngleOverlap(ticksAngles);
	    zrUtil.each(elementList, function (name) {
	      if (angleAxisModel.get(name + '.show') && (!angleAxis.scale.isBlank() || name === 'axisLine')) {
	        this['_' + name](angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent, labels);
	      }
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _axisLine: function (angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
	    var lineStyleModel = angleAxisModel.getModel('axisLine.lineStyle'); // extent id of the axis radius (r0 and r)
	
	    var rId = getRadiusIdx(polar);
	    var r0Id = rId ? 0 : 1;
	    var shape;
	
	    if (radiusExtent[r0Id] === 0) {
	      shape = new graphic.Circle({
	        shape: {
	          cx: polar.cx,
	          cy: polar.cy,
	          r: radiusExtent[rId]
	        },
	        style: lineStyleModel.getLineStyle(),
	        z2: 1,
	        silent: true
	      });
	    } else {
	      shape = new graphic.Ring({
	        shape: {
	          cx: polar.cx,
	          cy: polar.cy,
	          r: radiusExtent[rId],
	          r0: radiusExtent[r0Id]
	        },
	        style: lineStyleModel.getLineStyle(),
	        z2: 1,
	        silent: true
	      });
	    }
	
	    shape.style.fill = null;
	    this.group.add(shape);
	  },
	
	  /**
	   * @private
	   */
	  _axisTick: function (angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
	    var tickModel = angleAxisModel.getModel('axisTick');
	    var tickLen = (tickModel.get('inside') ? -1 : 1) * tickModel.get('length');
	    var radius = radiusExtent[getRadiusIdx(polar)];
	    var lines = zrUtil.map(ticksAngles, function (tickAngleItem) {
	      return new graphic.Line({
	        shape: getAxisLineShape(polar, [radius, radius + tickLen], tickAngleItem.coord)
	      });
	    });
	    this.group.add(graphic.mergePath(lines, {
	      style: zrUtil.defaults(tickModel.getModel('lineStyle').getLineStyle(), {
	        stroke: angleAxisModel.get('axisLine.lineStyle.color')
	      })
	    }));
	  },
	
	  /**
	   * @private
	   */
	  _minorTick: function (angleAxisModel, polar, tickAngles, minorTickAngles, radiusExtent) {
	    if (!minorTickAngles.length) {
	      return;
	    }
	
	    var tickModel = angleAxisModel.getModel('axisTick');
	    var minorTickModel = angleAxisModel.getModel('minorTick');
	    var tickLen = (tickModel.get('inside') ? -1 : 1) * minorTickModel.get('length');
	    var radius = radiusExtent[getRadiusIdx(polar)];
	    var lines = [];
	
	    for (var i = 0; i < minorTickAngles.length; i++) {
	      for (var k = 0; k < minorTickAngles[i].length; k++) {
	        lines.push(new graphic.Line({
	          shape: getAxisLineShape(polar, [radius, radius + tickLen], minorTickAngles[i][k].coord)
	        }));
	      }
	    }
	
	    this.group.add(graphic.mergePath(lines, {
	      style: zrUtil.defaults(minorTickModel.getModel('lineStyle').getLineStyle(), zrUtil.defaults(tickModel.getLineStyle(), {
	        stroke: angleAxisModel.get('axisLine.lineStyle.color')
	      }))
	    }));
	  },
	
	  /**
	   * @private
	   */
	  _axisLabel: function (angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent, labels) {
	    var rawCategoryData = angleAxisModel.getCategories(true);
	    var commonLabelModel = angleAxisModel.getModel('axisLabel');
	    var labelMargin = commonLabelModel.get('margin');
	    var triggerEvent = angleAxisModel.get('triggerEvent'); // Use length of ticksAngles because it may remove the last tick to avoid overlapping
	
	    zrUtil.each(labels, function (labelItem, idx) {
	      var labelModel = commonLabelModel;
	      var tickValue = labelItem.tickValue;
	      var r = radiusExtent[getRadiusIdx(polar)];
	      var p = polar.coordToPoint([r + labelMargin, labelItem.coord]);
	      var cx = polar.cx;
	      var cy = polar.cy;
	      var labelTextAlign = Math.abs(p[0] - cx) / r < 0.3 ? 'center' : p[0] > cx ? 'left' : 'right';
	      var labelTextVerticalAlign = Math.abs(p[1] - cy) / r < 0.3 ? 'middle' : p[1] > cy ? 'top' : 'bottom';
	
	      if (rawCategoryData && rawCategoryData[tickValue] && rawCategoryData[tickValue].textStyle) {
	        labelModel = new Model(rawCategoryData[tickValue].textStyle, commonLabelModel, commonLabelModel.ecModel);
	      }
	
	      var textEl = new graphic.Text({
	        silent: AxisBuilder.isLabelSilent(angleAxisModel)
	      });
	      this.group.add(textEl);
	      graphic.setTextStyle(textEl.style, labelModel, {
	        x: p[0],
	        y: p[1],
	        textFill: labelModel.getTextColor() || angleAxisModel.get('axisLine.lineStyle.color'),
	        text: labelItem.formattedLabel,
	        textAlign: labelTextAlign,
	        textVerticalAlign: labelTextVerticalAlign
	      }); // Pack data for mouse event
	
	      if (triggerEvent) {
	        textEl.eventData = AxisBuilder.makeAxisEventDataBase(angleAxisModel);
	        textEl.eventData.targetType = 'axisLabel';
	        textEl.eventData.value = labelItem.rawLabel;
	      }
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _splitLine: function (angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
	    var splitLineModel = angleAxisModel.getModel('splitLine');
	    var lineStyleModel = splitLineModel.getModel('lineStyle');
	    var lineColors = lineStyleModel.get('color');
	    var lineCount = 0;
	    lineColors = lineColors instanceof Array ? lineColors : [lineColors];
	    var splitLines = [];
	
	    for (var i = 0; i < ticksAngles.length; i++) {
	      var colorIndex = lineCount++ % lineColors.length;
	      splitLines[colorIndex] = splitLines[colorIndex] || [];
	      splitLines[colorIndex].push(new graphic.Line({
	        shape: getAxisLineShape(polar, radiusExtent, ticksAngles[i].coord)
	      }));
	    } // Simple optimization
	    // Batching the lines if color are the same
	
	
	    for (var i = 0; i < splitLines.length; i++) {
	      this.group.add(graphic.mergePath(splitLines[i], {
	        style: zrUtil.defaults({
	          stroke: lineColors[i % lineColors.length]
	        }, lineStyleModel.getLineStyle()),
	        silent: true,
	        z: angleAxisModel.get('z')
	      }));
	    }
	  },
	
	  /**
	   * @private
	   */
	  _minorSplitLine: function (angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
	    if (!minorTickAngles.length) {
	      return;
	    }
	
	    var minorSplitLineModel = angleAxisModel.getModel('minorSplitLine');
	    var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
	    var lines = [];
	
	    for (var i = 0; i < minorTickAngles.length; i++) {
	      for (var k = 0; k < minorTickAngles[i].length; k++) {
	        lines.push(new graphic.Line({
	          shape: getAxisLineShape(polar, radiusExtent, minorTickAngles[i][k].coord)
	        }));
	      }
	    }
	
	    this.group.add(graphic.mergePath(lines, {
	      style: lineStyleModel.getLineStyle(),
	      silent: true,
	      z: angleAxisModel.get('z')
	    }));
	  },
	
	  /**
	   * @private
	   */
	  _splitArea: function (angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
	    if (!ticksAngles.length) {
	      return;
	    }
	
	    var splitAreaModel = angleAxisModel.getModel('splitArea');
	    var areaStyleModel = splitAreaModel.getModel('areaStyle');
	    var areaColors = areaStyleModel.get('color');
	    var lineCount = 0;
	    areaColors = areaColors instanceof Array ? areaColors : [areaColors];
	    var splitAreas = [];
	    var RADIAN = Math.PI / 180;
	    var prevAngle = -ticksAngles[0].coord * RADIAN;
	    var r0 = Math.min(radiusExtent[0], radiusExtent[1]);
	    var r1 = Math.max(radiusExtent[0], radiusExtent[1]);
	    var clockwise = angleAxisModel.get('clockwise');
	
	    for (var i = 1; i < ticksAngles.length; i++) {
	      var colorIndex = lineCount++ % areaColors.length;
	      splitAreas[colorIndex] = splitAreas[colorIndex] || [];
	      splitAreas[colorIndex].push(new graphic.Sector({
	        shape: {
	          cx: polar.cx,
	          cy: polar.cy,
	          r0: r0,
	          r: r1,
	          startAngle: prevAngle,
	          endAngle: -ticksAngles[i].coord * RADIAN,
	          clockwise: clockwise
	        },
	        silent: true
	      }));
	      prevAngle = -ticksAngles[i].coord * RADIAN;
	    } // Simple optimization
	    // Batching the lines if color are the same
	
	
	    for (var i = 0; i < splitAreas.length; i++) {
	      this.group.add(graphic.mergePath(splitAreas[i], {
	        style: zrUtil.defaults({
	          fill: areaColors[i % areaColors.length]
	        }, areaStyleModel.getAreaStyle()),
	        silent: true
	      }));
	    }
	  }
	});
	
	module.exports = _default;

/***/ },
/* 1570 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var graphic = __webpack_require__(16);
	
	var AxisBuilder = __webpack_require__(138);
	
	var AxisView = __webpack_require__(165);
	
	var cartesianAxisHelper = __webpack_require__(739);
	
	var _axisSplitHelper = __webpack_require__(709);
	
	var rectCoordAxisBuildSplitArea = _axisSplitHelper.rectCoordAxisBuildSplitArea;
	var rectCoordAxisHandleRemove = _axisSplitHelper.rectCoordAxisHandleRemove;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
	var selfBuilderAttrs = ['splitArea', 'splitLine', 'minorSplitLine'];
	var CartesianAxisView = AxisView.extend({
	  type: 'cartesianAxis',
	  axisPointerClass: 'CartesianAxisPointer',
	
	  /**
	   * @override
	   */
	  render: function (axisModel, ecModel, api, payload) {
	    this.group.removeAll();
	    var oldAxisGroup = this._axisGroup;
	    this._axisGroup = new graphic.Group();
	    this.group.add(this._axisGroup);
	
	    if (!axisModel.get('show')) {
	      return;
	    }
	
	    var gridModel = axisModel.getCoordSysModel();
	    var layout = cartesianAxisHelper.layout(gridModel, axisModel);
	    var axisBuilder = new AxisBuilder(axisModel, layout);
	    zrUtil.each(axisBuilderAttrs, axisBuilder.add, axisBuilder);
	
	    this._axisGroup.add(axisBuilder.getGroup());
	
	    zrUtil.each(selfBuilderAttrs, function (name) {
	      if (axisModel.get(name + '.show')) {
	        this['_' + name](axisModel, gridModel);
	      }
	    }, this);
	    graphic.groupTransition(oldAxisGroup, this._axisGroup, axisModel);
	    CartesianAxisView.superCall(this, 'render', axisModel, ecModel, api, payload);
	  },
	  remove: function () {
	    rectCoordAxisHandleRemove(this);
	  },
	
	  /**
	   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
	   * @param {module:echarts/coord/cartesian/GridModel} gridModel
	   * @private
	   */
	  _splitLine: function (axisModel, gridModel) {
	    var axis = axisModel.axis;
	
	    if (axis.scale.isBlank()) {
	      return;
	    }
	
	    var splitLineModel = axisModel.getModel('splitLine');
	    var lineStyleModel = splitLineModel.getModel('lineStyle');
	    var lineColors = lineStyleModel.get('color');
	    lineColors = zrUtil.isArray(lineColors) ? lineColors : [lineColors];
	    var gridRect = gridModel.coordinateSystem.getRect();
	    var isHorizontal = axis.isHorizontal();
	    var lineCount = 0;
	    var ticksCoords = axis.getTicksCoords({
	      tickModel: splitLineModel
	    });
	    var p1 = [];
	    var p2 = [];
	    var lineStyle = lineStyleModel.getLineStyle();
	
	    for (var i = 0; i < ticksCoords.length; i++) {
	      var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
	
	      if (isHorizontal) {
	        p1[0] = tickCoord;
	        p1[1] = gridRect.y;
	        p2[0] = tickCoord;
	        p2[1] = gridRect.y + gridRect.height;
	      } else {
	        p1[0] = gridRect.x;
	        p1[1] = tickCoord;
	        p2[0] = gridRect.x + gridRect.width;
	        p2[1] = tickCoord;
	      }
	
	      var colorIndex = lineCount++ % lineColors.length;
	      var tickValue = ticksCoords[i].tickValue;
	
	      this._axisGroup.add(new graphic.Line({
	        anid: tickValue != null ? 'line_' + ticksCoords[i].tickValue : null,
	        subPixelOptimize: true,
	        shape: {
	          x1: p1[0],
	          y1: p1[1],
	          x2: p2[0],
	          y2: p2[1]
	        },
	        style: zrUtil.defaults({
	          stroke: lineColors[colorIndex]
	        }, lineStyle),
	        silent: true
	      }));
	    }
	  },
	
	  /**
	   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
	   * @param {module:echarts/coord/cartesian/GridModel} gridModel
	   * @private
	   */
	  _minorSplitLine: function (axisModel, gridModel) {
	    var axis = axisModel.axis;
	    var minorSplitLineModel = axisModel.getModel('minorSplitLine');
	    var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
	    var gridRect = gridModel.coordinateSystem.getRect();
	    var isHorizontal = axis.isHorizontal();
	    var minorTicksCoords = axis.getMinorTicksCoords();
	
	    if (!minorTicksCoords.length) {
	      return;
	    }
	
	    var p1 = [];
	    var p2 = [];
	    var lineStyle = lineStyleModel.getLineStyle();
	
	    for (var i = 0; i < minorTicksCoords.length; i++) {
	      for (var k = 0; k < minorTicksCoords[i].length; k++) {
	        var tickCoord = axis.toGlobalCoord(minorTicksCoords[i][k].coord);
	
	        if (isHorizontal) {
	          p1[0] = tickCoord;
	          p1[1] = gridRect.y;
	          p2[0] = tickCoord;
	          p2[1] = gridRect.y + gridRect.height;
	        } else {
	          p1[0] = gridRect.x;
	          p1[1] = tickCoord;
	          p2[0] = gridRect.x + gridRect.width;
	          p2[1] = tickCoord;
	        }
	
	        this._axisGroup.add(new graphic.Line({
	          anid: 'minor_line_' + minorTicksCoords[i][k].tickValue,
	          subPixelOptimize: true,
	          shape: {
	            x1: p1[0],
	            y1: p1[1],
	            x2: p2[0],
	            y2: p2[1]
	          },
	          style: lineStyle,
	          silent: true
	        }));
	      }
	    }
	  },
	
	  /**
	   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
	   * @param {module:echarts/coord/cartesian/GridModel} gridModel
	   * @private
	   */
	  _splitArea: function (axisModel, gridModel) {
	    rectCoordAxisBuildSplitArea(this, this._axisGroup, axisModel, gridModel);
	  }
	});
	CartesianAxisView.extend({
	  type: 'xAxis'
	});
	CartesianAxisView.extend({
	  type: 'yAxis'
	});

/***/ },
/* 1571 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var AxisBuilder = __webpack_require__(138);
	
	var BrushController = __webpack_require__(463);
	
	var brushHelper = __webpack_require__(720);
	
	var graphic = __webpack_require__(16);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var elementList = ['axisLine', 'axisTickLabel', 'axisName'];
	var AxisView = echarts.extendComponentView({
	  type: 'parallelAxis',
	
	  /**
	   * @override
	   */
	  init: function (ecModel, api) {
	    AxisView.superApply(this, 'init', arguments);
	    /**
	     * @type {module:echarts/component/helper/BrushController}
	     */
	
	    (this._brushController = new BrushController(api.getZr())).on('brush', zrUtil.bind(this._onBrush, this));
	  },
	
	  /**
	   * @override
	   */
	  render: function (axisModel, ecModel, api, payload) {
	    if (fromAxisAreaSelect(axisModel, ecModel, payload)) {
	      return;
	    }
	
	    this.axisModel = axisModel;
	    this.api = api;
	    this.group.removeAll();
	    var oldAxisGroup = this._axisGroup;
	    this._axisGroup = new graphic.Group();
	    this.group.add(this._axisGroup);
	
	    if (!axisModel.get('show')) {
	      return;
	    }
	
	    var coordSysModel = getCoordSysModel(axisModel, ecModel);
	    var coordSys = coordSysModel.coordinateSystem;
	    var areaSelectStyle = axisModel.getAreaSelectStyle();
	    var areaWidth = areaSelectStyle.width;
	    var dim = axisModel.axis.dim;
	    var axisLayout = coordSys.getAxisLayout(dim);
	    var builderOpt = zrUtil.extend({
	      strokeContainThreshold: areaWidth
	    }, axisLayout);
	    var axisBuilder = new AxisBuilder(axisModel, builderOpt);
	    zrUtil.each(elementList, axisBuilder.add, axisBuilder);
	
	    this._axisGroup.add(axisBuilder.getGroup());
	
	    this._refreshBrushController(builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api);
	
	    var animationModel = payload && payload.animation === false ? null : axisModel;
	    graphic.groupTransition(oldAxisGroup, this._axisGroup, animationModel);
	  },
	  // /**
	  //  * @override
	  //  */
	  // updateVisual: function (axisModel, ecModel, api, payload) {
	  //     this._brushController && this._brushController
	  //         .updateCovers(getCoverInfoList(axisModel));
	  // },
	  _refreshBrushController: function (builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api) {
	    // After filtering, axis may change, select area needs to be update.
	    var extent = axisModel.axis.getExtent();
	    var extentLen = extent[1] - extent[0];
	    var extra = Math.min(30, Math.abs(extentLen) * 0.1); // Arbitrary value.
	    // width/height might be negative, which will be
	    // normalized in BoundingRect.
	
	    var rect = graphic.BoundingRect.create({
	      x: extent[0],
	      y: -areaWidth / 2,
	      width: extentLen,
	      height: areaWidth
	    });
	    rect.x -= extra;
	    rect.width += 2 * extra;
	
	    this._brushController.mount({
	      enableGlobalPan: true,
	      rotation: builderOpt.rotation,
	      position: builderOpt.position
	    }).setPanels([{
	      panelId: 'pl',
	      clipPath: brushHelper.makeRectPanelClipPath(rect),
	      isTargetByCursor: brushHelper.makeRectIsTargetByCursor(rect, api, coordSysModel),
	      getLinearBrushOtherExtent: brushHelper.makeLinearBrushOtherExtent(rect, 0)
	    }]).enableBrush({
	      brushType: 'lineX',
	      brushStyle: areaSelectStyle,
	      removeOnClick: true
	    }).updateCovers(getCoverInfoList(axisModel));
	  },
	  _onBrush: function (coverInfoList, opt) {
	    // Do not cache these object, because the mey be changed.
	    var axisModel = this.axisModel;
	    var axis = axisModel.axis;
	    var intervals = zrUtil.map(coverInfoList, function (coverInfo) {
	      return [axis.coordToData(coverInfo.range[0], true), axis.coordToData(coverInfo.range[1], true)];
	    }); // If realtime is true, action is not dispatched on drag end, because
	    // the drag end emits the same params with the last drag move event,
	    // and may have some delay when using touch pad.
	
	    if (!axisModel.option.realtime === opt.isEnd || opt.removeOnClick) {
	      // jshint ignore:line
	      this.api.dispatchAction({
	        type: 'axisAreaSelect',
	        parallelAxisId: axisModel.id,
	        intervals: intervals
	      });
	    }
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    this._brushController.dispose();
	  }
	});
	
	function fromAxisAreaSelect(axisModel, ecModel, payload) {
	  return payload && payload.type === 'axisAreaSelect' && ecModel.findComponents({
	    mainType: 'parallelAxis',
	    query: payload
	  })[0] === axisModel;
	}
	
	function getCoverInfoList(axisModel) {
	  var axis = axisModel.axis;
	  return zrUtil.map(axisModel.activeIntervals, function (interval) {
	    return {
	      brushType: 'lineX',
	      panelId: 'pl',
	      range: [axis.dataToCoord(interval[0], true), axis.dataToCoord(interval[1], true)]
	    };
	  });
	}
	
	function getCoordSysModel(axisModel, ecModel) {
	  return ecModel.getComponent('parallel', axisModel.get('parallelIndex'));
	}
	
	var _default = AxisView;
	module.exports = _default;

/***/ },
/* 1572 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var graphic = __webpack_require__(16);
	
	var AxisBuilder = __webpack_require__(138);
	
	var AxisView = __webpack_require__(165);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
	var selfBuilderAttrs = ['splitLine', 'splitArea', 'minorSplitLine'];
	
	var _default = AxisView.extend({
	  type: 'radiusAxis',
	  axisPointerClass: 'PolarAxisPointer',
	  render: function (radiusAxisModel, ecModel) {
	    this.group.removeAll();
	
	    if (!radiusAxisModel.get('show')) {
	      return;
	    }
	
	    var radiusAxis = radiusAxisModel.axis;
	    var polar = radiusAxis.polar;
	    var angleAxis = polar.getAngleAxis();
	    var ticksCoords = radiusAxis.getTicksCoords();
	    var minorTicksCoords = radiusAxis.getMinorTicksCoords();
	    var axisAngle = angleAxis.getExtent()[0];
	    var radiusExtent = radiusAxis.getExtent();
	    var layout = layoutAxis(polar, radiusAxisModel, axisAngle);
	    var axisBuilder = new AxisBuilder(radiusAxisModel, layout);
	    zrUtil.each(axisBuilderAttrs, axisBuilder.add, axisBuilder);
	    this.group.add(axisBuilder.getGroup());
	    zrUtil.each(selfBuilderAttrs, function (name) {
	      if (radiusAxisModel.get(name + '.show') && !radiusAxis.scale.isBlank()) {
	        this['_' + name](radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords, minorTicksCoords);
	      }
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _splitLine: function (radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
	    var splitLineModel = radiusAxisModel.getModel('splitLine');
	    var lineStyleModel = splitLineModel.getModel('lineStyle');
	    var lineColors = lineStyleModel.get('color');
	    var lineCount = 0;
	    lineColors = lineColors instanceof Array ? lineColors : [lineColors];
	    var splitLines = [];
	
	    for (var i = 0; i < ticksCoords.length; i++) {
	      var colorIndex = lineCount++ % lineColors.length;
	      splitLines[colorIndex] = splitLines[colorIndex] || [];
	      splitLines[colorIndex].push(new graphic.Circle({
	        shape: {
	          cx: polar.cx,
	          cy: polar.cy,
	          r: ticksCoords[i].coord
	        }
	      }));
	    } // Simple optimization
	    // Batching the lines if color are the same
	
	
	    for (var i = 0; i < splitLines.length; i++) {
	      this.group.add(graphic.mergePath(splitLines[i], {
	        style: zrUtil.defaults({
	          stroke: lineColors[i % lineColors.length],
	          fill: null
	        }, lineStyleModel.getLineStyle()),
	        silent: true
	      }));
	    }
	  },
	
	  /**
	   * @private
	   */
	  _minorSplitLine: function (radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords, minorTicksCoords) {
	    if (!minorTicksCoords.length) {
	      return;
	    }
	
	    var minorSplitLineModel = radiusAxisModel.getModel('minorSplitLine');
	    var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
	    var lines = [];
	
	    for (var i = 0; i < minorTicksCoords.length; i++) {
	      for (var k = 0; k < minorTicksCoords[i].length; k++) {
	        lines.push(new graphic.Circle({
	          shape: {
	            cx: polar.cx,
	            cy: polar.cy,
	            r: minorTicksCoords[i][k].coord
	          }
	        }));
	      }
	    }
	
	    this.group.add(graphic.mergePath(lines, {
	      style: zrUtil.defaults({
	        fill: null
	      }, lineStyleModel.getLineStyle()),
	      silent: true
	    }));
	  },
	
	  /**
	   * @private
	   */
	  _splitArea: function (radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
	    if (!ticksCoords.length) {
	      return;
	    }
	
	    var splitAreaModel = radiusAxisModel.getModel('splitArea');
	    var areaStyleModel = splitAreaModel.getModel('areaStyle');
	    var areaColors = areaStyleModel.get('color');
	    var lineCount = 0;
	    areaColors = areaColors instanceof Array ? areaColors : [areaColors];
	    var splitAreas = [];
	    var prevRadius = ticksCoords[0].coord;
	
	    for (var i = 1; i < ticksCoords.length; i++) {
	      var colorIndex = lineCount++ % areaColors.length;
	      splitAreas[colorIndex] = splitAreas[colorIndex] || [];
	      splitAreas[colorIndex].push(new graphic.Sector({
	        shape: {
	          cx: polar.cx,
	          cy: polar.cy,
	          r0: prevRadius,
	          r: ticksCoords[i].coord,
	          startAngle: 0,
	          endAngle: Math.PI * 2
	        },
	        silent: true
	      }));
	      prevRadius = ticksCoords[i].coord;
	    } // Simple optimization
	    // Batching the lines if color are the same
	
	
	    for (var i = 0; i < splitAreas.length; i++) {
	      this.group.add(graphic.mergePath(splitAreas[i], {
	        style: zrUtil.defaults({
	          fill: areaColors[i % areaColors.length]
	        }, areaStyleModel.getAreaStyle()),
	        silent: true
	      }));
	    }
	  }
	});
	/**
	 * @inner
	 */
	
	
	function layoutAxis(polar, radiusAxisModel, axisAngle) {
	  return {
	    position: [polar.cx, polar.cy],
	    rotation: axisAngle / 180 * Math.PI,
	    labelDirection: -1,
	    tickDirection: -1,
	    nameDirection: 1,
	    labelRotate: radiusAxisModel.getModel('axisLabel').get('rotate'),
	    // Over splitLine and splitArea
	    z2: 1
	  };
	}
	
	module.exports = _default;

/***/ },
/* 1573 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var AxisBuilder = __webpack_require__(138);
	
	var graphic = __webpack_require__(16);
	
	var singleAxisHelper = __webpack_require__(743);
	
	var AxisView = __webpack_require__(165);
	
	var _axisSplitHelper = __webpack_require__(709);
	
	var rectCoordAxisBuildSplitArea = _axisSplitHelper.rectCoordAxisBuildSplitArea;
	var rectCoordAxisHandleRemove = _axisSplitHelper.rectCoordAxisHandleRemove;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
	var selfBuilderAttrs = ['splitArea', 'splitLine'];
	var SingleAxisView = AxisView.extend({
	  type: 'singleAxis',
	  axisPointerClass: 'SingleAxisPointer',
	  render: function (axisModel, ecModel, api, payload) {
	    var group = this.group;
	    group.removeAll();
	    var oldAxisGroup = this._axisGroup;
	    this._axisGroup = new graphic.Group();
	    var layout = singleAxisHelper.layout(axisModel);
	    var axisBuilder = new AxisBuilder(axisModel, layout);
	    zrUtil.each(axisBuilderAttrs, axisBuilder.add, axisBuilder);
	    group.add(this._axisGroup);
	    group.add(axisBuilder.getGroup());
	    zrUtil.each(selfBuilderAttrs, function (name) {
	      if (axisModel.get(name + '.show')) {
	        this['_' + name](axisModel);
	      }
	    }, this);
	    graphic.groupTransition(oldAxisGroup, this._axisGroup, axisModel);
	    SingleAxisView.superCall(this, 'render', axisModel, ecModel, api, payload);
	  },
	  remove: function () {
	    rectCoordAxisHandleRemove(this);
	  },
	  _splitLine: function (axisModel) {
	    var axis = axisModel.axis;
	
	    if (axis.scale.isBlank()) {
	      return;
	    }
	
	    var splitLineModel = axisModel.getModel('splitLine');
	    var lineStyleModel = splitLineModel.getModel('lineStyle');
	    var lineWidth = lineStyleModel.get('width');
	    var lineColors = lineStyleModel.get('color');
	    lineColors = lineColors instanceof Array ? lineColors : [lineColors];
	    var gridRect = axisModel.coordinateSystem.getRect();
	    var isHorizontal = axis.isHorizontal();
	    var splitLines = [];
	    var lineCount = 0;
	    var ticksCoords = axis.getTicksCoords({
	      tickModel: splitLineModel
	    });
	    var p1 = [];
	    var p2 = [];
	
	    for (var i = 0; i < ticksCoords.length; ++i) {
	      var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
	
	      if (isHorizontal) {
	        p1[0] = tickCoord;
	        p1[1] = gridRect.y;
	        p2[0] = tickCoord;
	        p2[1] = gridRect.y + gridRect.height;
	      } else {
	        p1[0] = gridRect.x;
	        p1[1] = tickCoord;
	        p2[0] = gridRect.x + gridRect.width;
	        p2[1] = tickCoord;
	      }
	
	      var colorIndex = lineCount++ % lineColors.length;
	      splitLines[colorIndex] = splitLines[colorIndex] || [];
	      splitLines[colorIndex].push(new graphic.Line({
	        subPixelOptimize: true,
	        shape: {
	          x1: p1[0],
	          y1: p1[1],
	          x2: p2[0],
	          y2: p2[1]
	        },
	        style: {
	          lineWidth: lineWidth
	        },
	        silent: true
	      }));
	    }
	
	    for (var i = 0; i < splitLines.length; ++i) {
	      this.group.add(graphic.mergePath(splitLines[i], {
	        style: {
	          stroke: lineColors[i % lineColors.length],
	          lineDash: lineStyleModel.getLineDash(lineWidth),
	          lineWidth: lineWidth
	        },
	        silent: true
	      }));
	    }
	  },
	  _splitArea: function (axisModel) {
	    rectCoordAxisBuildSplitArea(this, this._axisGroup, axisModel, axisModel);
	  }
	});
	var _default = SingleAxisView;
	module.exports = _default;

/***/ },
/* 1574 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @payload
	 * @property {string} parallelAxisId
	 * @property {Array.<Array.<number>>} intervals
	 */
	var actionInfo = {
	  type: 'axisAreaSelect',
	  event: 'axisAreaSelected' // update: 'updateVisual'
	
	};
	echarts.registerAction(actionInfo, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'parallelAxis',
	    query: payload
	  }, function (parallelAxisModel) {
	    parallelAxisModel.axis.model.setActiveIntervals(payload.intervals);
	  });
	});
	/**
	 * @payload
	 */
	
	echarts.registerAction('parallelAxisExpand', function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'parallel',
	    query: payload
	  }, function (parallelModel) {
	    parallelModel.setAxisExpand(payload);
	  });
	});

/***/ },
/* 1575 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var AxisPointerModel = echarts.extendComponentModel({
	  type: 'axisPointer',
	  coordSysAxesInfo: null,
	  defaultOption: {
	    // 'auto' means that show when triggered by tooltip or handle.
	    show: 'auto',
	    // 'click' | 'mousemove' | 'none'
	    triggerOn: null,
	    // set default in AxisPonterView.js
	    zlevel: 0,
	    z: 50,
	    type: 'line',
	    // 'line' 'shadow' 'cross' 'none'.
	    // axispointer triggered by tootip determine snap automatically,
	    // see `modelHelper`.
	    snap: false,
	    triggerTooltip: true,
	    value: null,
	    status: null,
	    // Init value depends on whether handle is used.
	    // [group0, group1, ...]
	    // Each group can be: {
	    //      mapper: function () {},
	    //      singleTooltip: 'multiple',  // 'multiple' or 'single'
	    //      xAxisId: ...,
	    //      yAxisName: ...,
	    //      angleAxisIndex: ...
	    // }
	    // mapper: can be ignored.
	    //      input: {axisInfo, value}
	    //      output: {axisInfo, value}
	    link: [],
	    // Do not set 'auto' here, otherwise global animation: false
	    // will not effect at this axispointer.
	    animation: null,
	    animationDurationUpdate: 200,
	    lineStyle: {
	      color: '#aaa',
	      width: 1,
	      type: 'solid'
	    },
	    shadowStyle: {
	      color: 'rgba(150,150,150,0.3)'
	    },
	    label: {
	      show: true,
	      formatter: null,
	      // string | Function
	      precision: 'auto',
	      // Or a number like 0, 1, 2 ...
	      margin: 3,
	      color: '#fff',
	      padding: [5, 7, 5, 7],
	      backgroundColor: 'auto',
	      // default: axis line color
	      borderColor: null,
	      borderWidth: 0,
	      shadowBlur: 3,
	      shadowColor: '#aaa' // Considering applicability, common style should
	      // better not have shadowOffset.
	      // shadowOffsetX: 0,
	      // shadowOffsetY: 2
	
	    },
	    handle: {
	      show: false,
	
	      /* eslint-disable */
	      icon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z',
	      // jshint ignore:line
	
	      /* eslint-enable */
	      size: 45,
	      // handle margin is from symbol center to axis, which is stable when circular move.
	      margin: 50,
	      // color: '#1b8bbd'
	      // color: '#2f4554'
	      color: '#333',
	      shadowBlur: 3,
	      shadowColor: '#aaa',
	      shadowOffsetX: 0,
	      shadowOffsetY: 2,
	      // For mobile performance
	      throttle: 40
	    }
	  }
	});
	var _default = AxisPointerModel;
	module.exports = _default;

/***/ },
/* 1576 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var globalListener = __webpack_require__(712);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var AxisPointerView = echarts.extendComponentView({
	  type: 'axisPointer',
	  render: function (globalAxisPointerModel, ecModel, api) {
	    var globalTooltipModel = ecModel.getComponent('tooltip');
	    var triggerOn = globalAxisPointerModel.get('triggerOn') || globalTooltipModel && globalTooltipModel.get('triggerOn') || 'mousemove|click'; // Register global listener in AxisPointerView to enable
	    // AxisPointerView to be independent to Tooltip.
	
	    globalListener.register('axisPointer', api, function (currTrigger, e, dispatchAction) {
	      // If 'none', it is not controlled by mouse totally.
	      if (triggerOn !== 'none' && (currTrigger === 'leave' || triggerOn.indexOf(currTrigger) >= 0)) {
	        dispatchAction({
	          type: 'updateAxisPointer',
	          currTrigger: currTrigger,
	          x: e && e.offsetX,
	          y: e && e.offsetY
	        });
	      }
	    });
	  },
	
	  /**
	   * @override
	   */
	  remove: function (ecModel, api) {
	    globalListener.unregister(api.getZr(), 'axisPointer');
	    AxisPointerView.superApply(this._model, 'remove', arguments);
	  },
	
	  /**
	   * @override
	   */
	  dispose: function (ecModel, api) {
	    globalListener.unregister('axisPointer', api);
	    AxisPointerView.superApply(this._model, 'dispose', arguments);
	  }
	});
	var _default = AxisPointerView;
	module.exports = _default;

/***/ },
/* 1577 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var formatUtil = __webpack_require__(40);
	
	var BaseAxisPointer = __webpack_require__(458);
	
	var graphic = __webpack_require__(16);
	
	var viewHelper = __webpack_require__(333);
	
	var matrix = __webpack_require__(73);
	
	var AxisBuilder = __webpack_require__(138);
	
	var AxisView = __webpack_require__(165);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PolarAxisPointer = BaseAxisPointer.extend({
	  /**
	   * @override
	   */
	  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {
	    var axis = axisModel.axis;
	
	    if (axis.dim === 'angle') {
	      this.animationThreshold = Math.PI / 18;
	    }
	
	    var polar = axis.polar;
	    var otherAxis = polar.getOtherAxis(axis);
	    var otherExtent = otherAxis.getExtent();
	    var coordValue;
	    coordValue = axis['dataTo' + formatUtil.capitalFirst(axis.dim)](value);
	    var axisPointerType = axisPointerModel.get('type');
	
	    if (axisPointerType && axisPointerType !== 'none') {
	      var elStyle = viewHelper.buildElStyle(axisPointerModel);
	      var pointerOption = pointerShapeBuilder[axisPointerType](axis, polar, coordValue, otherExtent, elStyle);
	      pointerOption.style = elStyle;
	      elOption.graphicKey = pointerOption.type;
	      elOption.pointer = pointerOption;
	    }
	
	    var labelMargin = axisPointerModel.get('label.margin');
	    var labelPos = getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin);
	    viewHelper.buildLabelElOption(elOption, axisModel, axisPointerModel, api, labelPos);
	  } // Do not support handle, utill any user requires it.
	
	});
	
	function getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin) {
	  var axis = axisModel.axis;
	  var coord = axis.dataToCoord(value);
	  var axisAngle = polar.getAngleAxis().getExtent()[0];
	  axisAngle = axisAngle / 180 * Math.PI;
	  var radiusExtent = polar.getRadiusAxis().getExtent();
	  var position;
	  var align;
	  var verticalAlign;
	
	  if (axis.dim === 'radius') {
	    var transform = matrix.create();
	    matrix.rotate(transform, transform, axisAngle);
	    matrix.translate(transform, transform, [polar.cx, polar.cy]);
	    position = graphic.applyTransform([coord, -labelMargin], transform);
	    var labelRotation = axisModel.getModel('axisLabel').get('rotate') || 0;
	    var labelLayout = AxisBuilder.innerTextLayout(axisAngle, labelRotation * Math.PI / 180, -1);
	    align = labelLayout.textAlign;
	    verticalAlign = labelLayout.textVerticalAlign;
	  } else {
	    // angle axis
	    var r = radiusExtent[1];
	    position = polar.coordToPoint([r + labelMargin, coord]);
	    var cx = polar.cx;
	    var cy = polar.cy;
	    align = Math.abs(position[0] - cx) / r < 0.3 ? 'center' : position[0] > cx ? 'left' : 'right';
	    verticalAlign = Math.abs(position[1] - cy) / r < 0.3 ? 'middle' : position[1] > cy ? 'top' : 'bottom';
	  }
	
	  return {
	    position: position,
	    align: align,
	    verticalAlign: verticalAlign
	  };
	}
	
	var pointerShapeBuilder = {
	  line: function (axis, polar, coordValue, otherExtent, elStyle) {
	    return axis.dim === 'angle' ? {
	      type: 'Line',
	      shape: viewHelper.makeLineShape(polar.coordToPoint([otherExtent[0], coordValue]), polar.coordToPoint([otherExtent[1], coordValue]))
	    } : {
	      type: 'Circle',
	      shape: {
	        cx: polar.cx,
	        cy: polar.cy,
	        r: coordValue
	      }
	    };
	  },
	  shadow: function (axis, polar, coordValue, otherExtent, elStyle) {
	    var bandWidth = Math.max(1, axis.getBandWidth());
	    var radian = Math.PI / 180;
	    return axis.dim === 'angle' ? {
	      type: 'Sector',
	      shape: viewHelper.makeSectorShape(polar.cx, polar.cy, otherExtent[0], otherExtent[1], // In ECharts y is negative if angle is positive
	      (-coordValue - bandWidth / 2) * radian, (-coordValue + bandWidth / 2) * radian)
	    } : {
	      type: 'Sector',
	      shape: viewHelper.makeSectorShape(polar.cx, polar.cy, coordValue - bandWidth / 2, coordValue + bandWidth / 2, 0, Math.PI * 2)
	    };
	  }
	};
	AxisView.registerAxisPointerClass('PolarAxisPointer', PolarAxisPointer);
	var _default = PolarAxisPointer;
	module.exports = _default;

/***/ },
/* 1578 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var BaseAxisPointer = __webpack_require__(458);
	
	var viewHelper = __webpack_require__(333);
	
	var singleAxisHelper = __webpack_require__(743);
	
	var AxisView = __webpack_require__(165);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var XY = ['x', 'y'];
	var WH = ['width', 'height'];
	var SingleAxisPointer = BaseAxisPointer.extend({
	  /**
	   * @override
	   */
	  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {
	    var axis = axisModel.axis;
	    var coordSys = axis.coordinateSystem;
	    var otherExtent = getGlobalExtent(coordSys, 1 - getPointDimIndex(axis));
	    var pixelValue = coordSys.dataToPoint(value)[0];
	    var axisPointerType = axisPointerModel.get('type');
	
	    if (axisPointerType && axisPointerType !== 'none') {
	      var elStyle = viewHelper.buildElStyle(axisPointerModel);
	      var pointerOption = pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
	      pointerOption.style = elStyle;
	      elOption.graphicKey = pointerOption.type;
	      elOption.pointer = pointerOption;
	    }
	
	    var layoutInfo = singleAxisHelper.layout(axisModel);
	    viewHelper.buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
	  },
	
	  /**
	   * @override
	   */
	  getHandleTransform: function (value, axisModel, axisPointerModel) {
	    var layoutInfo = singleAxisHelper.layout(axisModel, {
	      labelInside: false
	    });
	    layoutInfo.labelMargin = axisPointerModel.get('handle.margin');
	    return {
	      position: viewHelper.getTransformedPosition(axisModel.axis, value, layoutInfo),
	      rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
	    };
	  },
	
	  /**
	   * @override
	   */
	  updateHandleTransform: function (transform, delta, axisModel, axisPointerModel) {
	    var axis = axisModel.axis;
	    var coordSys = axis.coordinateSystem;
	    var dimIndex = getPointDimIndex(axis);
	    var axisExtent = getGlobalExtent(coordSys, dimIndex);
	    var currPosition = transform.position;
	    currPosition[dimIndex] += delta[dimIndex];
	    currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
	    currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
	    var otherExtent = getGlobalExtent(coordSys, 1 - dimIndex);
	    var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
	    var cursorPoint = [cursorOtherValue, cursorOtherValue];
	    cursorPoint[dimIndex] = currPosition[dimIndex];
	    return {
	      position: currPosition,
	      rotation: transform.rotation,
	      cursorPoint: cursorPoint,
	      tooltipOption: {
	        verticalAlign: 'middle'
	      }
	    };
	  }
	});
	var pointerShapeBuilder = {
	  line: function (axis, pixelValue, otherExtent) {
	    var targetShape = viewHelper.makeLineShape([pixelValue, otherExtent[0]], [pixelValue, otherExtent[1]], getPointDimIndex(axis));
	    return {
	      type: 'Line',
	      subPixelOptimize: true,
	      shape: targetShape
	    };
	  },
	  shadow: function (axis, pixelValue, otherExtent) {
	    var bandWidth = axis.getBandWidth();
	    var span = otherExtent[1] - otherExtent[0];
	    return {
	      type: 'Rect',
	      shape: viewHelper.makeRectShape([pixelValue - bandWidth / 2, otherExtent[0]], [bandWidth, span], getPointDimIndex(axis))
	    };
	  }
	};
	
	function getPointDimIndex(axis) {
	  return axis.isHorizontal() ? 0 : 1;
	}
	
	function getGlobalExtent(coordSys, dimIndex) {
	  var rect = coordSys.getRect();
	  return [rect[XY[dimIndex]], rect[XY[dimIndex]] + rect[WH[dimIndex]]];
	}
	
	AxisView.registerAxisPointerClass('SingleAxisPointer', SingleAxisPointer);
	var _default = SingleAxisPointer;
	module.exports = _default;

/***/ },
/* 1579 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var _model = __webpack_require__(24);
	
	var makeInner = _model.makeInner;
	
	var modelHelper = __webpack_require__(332);
	
	var findPointFromSeries = __webpack_require__(711);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var curry = zrUtil.curry;
	var inner = makeInner();
	/**
	 * Basic logic: check all axis, if they do not demand show/highlight,
	 * then hide/downplay them.
	 *
	 * @param {Object} coordSysAxesInfo
	 * @param {Object} payload
	 * @param {string} [payload.currTrigger] 'click' | 'mousemove' | 'leave'
	 * @param {Array.<number>} [payload.x] x and y, which are mandatory, specify a point to
	 *              trigger axisPointer and tooltip.
	 * @param {Array.<number>} [payload.y] x and y, which are mandatory, specify a point to
	 *              trigger axisPointer and tooltip.
	 * @param {Object} [payload.seriesIndex] finder, optional, restrict target axes.
	 * @param {Object} [payload.dataIndex] finder, restrict target axes.
	 * @param {Object} [payload.axesInfo] finder, restrict target axes.
	 *        [{
	 *          axisDim: 'x'|'y'|'angle'|...,
	 *          axisIndex: ...,
	 *          value: ...
	 *        }, ...]
	 * @param {Function} [payload.dispatchAction]
	 * @param {Object} [payload.tooltipOption]
	 * @param {Object|Array.<number>|Function} [payload.position] Tooltip position,
	 *        which can be specified in dispatchAction
	 * @param {module:echarts/model/Global} ecModel
	 * @param {module:echarts/ExtensionAPI} api
	 * @return {Object} content of event obj for echarts.connect.
	 */
	
	function _default(payload, ecModel, api) {
	  var currTrigger = payload.currTrigger;
	  var point = [payload.x, payload.y];
	  var finder = payload;
	  var dispatchAction = payload.dispatchAction || zrUtil.bind(api.dispatchAction, api);
	  var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo; // Pending
	  // See #6121. But we are not able to reproduce it yet.
	
	  if (!coordSysAxesInfo) {
	    return;
	  }
	
	  if (illegalPoint(point)) {
	    // Used in the default behavior of `connection`: use the sample seriesIndex
	    // and dataIndex. And also used in the tooltipView trigger.
	    point = findPointFromSeries({
	      seriesIndex: finder.seriesIndex,
	      // Do not use dataIndexInside from other ec instance.
	      // FIXME: auto detect it?
	      dataIndex: finder.dataIndex
	    }, ecModel).point;
	  }
	
	  var isIllegalPoint = illegalPoint(point); // Axis and value can be specified when calling dispatchAction({type: 'updateAxisPointer'}).
	  // Notice: In this case, it is difficult to get the `point` (which is necessary to show
	  // tooltip, so if point is not given, we just use the point found by sample seriesIndex
	  // and dataIndex.
	
	  var inputAxesInfo = finder.axesInfo;
	  var axesInfo = coordSysAxesInfo.axesInfo;
	  var shouldHide = currTrigger === 'leave' || illegalPoint(point);
	  var outputFinder = {};
	  var showValueMap = {};
	  var dataByCoordSys = {
	    list: [],
	    map: {}
	  };
	  var updaters = {
	    showPointer: curry(showPointer, showValueMap),
	    showTooltip: curry(showTooltip, dataByCoordSys)
	  }; // Process for triggered axes.
	
	  each(coordSysAxesInfo.coordSysMap, function (coordSys, coordSysKey) {
	    // If a point given, it must be contained by the coordinate system.
	    var coordSysContainsPoint = isIllegalPoint || coordSys.containPoint(point);
	    each(coordSysAxesInfo.coordSysAxesInfo[coordSysKey], function (axisInfo, key) {
	      var axis = axisInfo.axis;
	      var inputAxisInfo = findInputAxisInfo(inputAxesInfo, axisInfo); // If no inputAxesInfo, no axis is restricted.
	
	      if (!shouldHide && coordSysContainsPoint && (!inputAxesInfo || inputAxisInfo)) {
	        var val = inputAxisInfo && inputAxisInfo.value;
	
	        if (val == null && !isIllegalPoint) {
	          val = axis.pointToData(point);
	        }
	
	        val != null && processOnAxis(axisInfo, val, updaters, false, outputFinder);
	      }
	    });
	  }); // Process for linked axes.
	
	  var linkTriggers = {};
	  each(axesInfo, function (tarAxisInfo, tarKey) {
	    var linkGroup = tarAxisInfo.linkGroup; // If axis has been triggered in the previous stage, it should not be triggered by link.
	
	    if (linkGroup && !showValueMap[tarKey]) {
	      each(linkGroup.axesInfo, function (srcAxisInfo, srcKey) {
	        var srcValItem = showValueMap[srcKey]; // If srcValItem exist, source axis is triggered, so link to target axis.
	
	        if (srcAxisInfo !== tarAxisInfo && srcValItem) {
	          var val = srcValItem.value;
	          linkGroup.mapper && (val = tarAxisInfo.axis.scale.parse(linkGroup.mapper(val, makeMapperParam(srcAxisInfo), makeMapperParam(tarAxisInfo))));
	          linkTriggers[tarAxisInfo.key] = val;
	        }
	      });
	    }
	  });
	  each(linkTriggers, function (val, tarKey) {
	    processOnAxis(axesInfo[tarKey], val, updaters, true, outputFinder);
	  });
	  updateModelActually(showValueMap, axesInfo, outputFinder);
	  dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction);
	  dispatchHighDownActually(axesInfo, dispatchAction, api);
	  return outputFinder;
	}
	
	function processOnAxis(axisInfo, newValue, updaters, dontSnap, outputFinder) {
	  var axis = axisInfo.axis;
	
	  if (axis.scale.isBlank() || !axis.containData(newValue)) {
	    return;
	  }
	
	  if (!axisInfo.involveSeries) {
	    updaters.showPointer(axisInfo, newValue);
	    return;
	  } // Heavy calculation. So put it after axis.containData checking.
	
	
	  var payloadInfo = buildPayloadsBySeries(newValue, axisInfo);
	  var payloadBatch = payloadInfo.payloadBatch;
	  var snapToValue = payloadInfo.snapToValue; // Fill content of event obj for echarts.connect.
	  // By default use the first involved series data as a sample to connect.
	
	  if (payloadBatch[0] && outputFinder.seriesIndex == null) {
	    zrUtil.extend(outputFinder, payloadBatch[0]);
	  } // If no linkSource input, this process is for collecting link
	  // target, where snap should not be accepted.
	
	
	  if (!dontSnap && axisInfo.snap) {
	    if (axis.containData(snapToValue) && snapToValue != null) {
	      newValue = snapToValue;
	    }
	  }
	
	  updaters.showPointer(axisInfo, newValue, payloadBatch, outputFinder); // Tooltip should always be snapToValue, otherwise there will be
	  // incorrect "axis value ~ series value" mapping displayed in tooltip.
	
	  updaters.showTooltip(axisInfo, payloadInfo, snapToValue);
	}
	
	function buildPayloadsBySeries(value, axisInfo) {
	  var axis = axisInfo.axis;
	  var dim = axis.dim;
	  var snapToValue = value;
	  var payloadBatch = [];
	  var minDist = Number.MAX_VALUE;
	  var minDiff = -1;
	  each(axisInfo.seriesModels, function (series, idx) {
	    var dataDim = series.getData().mapDimension(dim, true);
	    var seriesNestestValue;
	    var dataIndices;
	
	    if (series.getAxisTooltipData) {
	      var result = series.getAxisTooltipData(dataDim, value, axis);
	      dataIndices = result.dataIndices;
	      seriesNestestValue = result.nestestValue;
	    } else {
	      dataIndices = series.getData().indicesOfNearest(dataDim[0], value, // Add a threshold to avoid find the wrong dataIndex
	      // when data length is not same.
	      // false,
	      axis.type === 'category' ? 0.5 : null);
	
	      if (!dataIndices.length) {
	        return;
	      }
	
	      seriesNestestValue = series.getData().get(dataDim[0], dataIndices[0]);
	    }
	
	    if (seriesNestestValue == null || !isFinite(seriesNestestValue)) {
	      return;
	    }
	
	    var diff = value - seriesNestestValue;
	    var dist = Math.abs(diff); // Consider category case
	
	    if (dist <= minDist) {
	      if (dist < minDist || diff >= 0 && minDiff < 0) {
	        minDist = dist;
	        minDiff = diff;
	        snapToValue = seriesNestestValue;
	        payloadBatch.length = 0;
	      }
	
	      each(dataIndices, function (dataIndex) {
	        payloadBatch.push({
	          seriesIndex: series.seriesIndex,
	          dataIndexInside: dataIndex,
	          dataIndex: series.getData().getRawIndex(dataIndex)
	        });
	      });
	    }
	  });
	  return {
	    payloadBatch: payloadBatch,
	    snapToValue: snapToValue
	  };
	}
	
	function showPointer(showValueMap, axisInfo, value, payloadBatch) {
	  showValueMap[axisInfo.key] = {
	    value: value,
	    payloadBatch: payloadBatch
	  };
	}
	
	function showTooltip(dataByCoordSys, axisInfo, payloadInfo, value) {
	  var payloadBatch = payloadInfo.payloadBatch;
	  var axis = axisInfo.axis;
	  var axisModel = axis.model;
	  var axisPointerModel = axisInfo.axisPointerModel; // If no data, do not create anything in dataByCoordSys,
	  // whose length will be used to judge whether dispatch action.
	
	  if (!axisInfo.triggerTooltip || !payloadBatch.length) {
	    return;
	  }
	
	  var coordSysModel = axisInfo.coordSys.model;
	  var coordSysKey = modelHelper.makeKey(coordSysModel);
	  var coordSysItem = dataByCoordSys.map[coordSysKey];
	
	  if (!coordSysItem) {
	    coordSysItem = dataByCoordSys.map[coordSysKey] = {
	      coordSysId: coordSysModel.id,
	      coordSysIndex: coordSysModel.componentIndex,
	      coordSysType: coordSysModel.type,
	      coordSysMainType: coordSysModel.mainType,
	      dataByAxis: []
	    };
	    dataByCoordSys.list.push(coordSysItem);
	  }
	
	  coordSysItem.dataByAxis.push({
	    axisDim: axis.dim,
	    axisIndex: axisModel.componentIndex,
	    axisType: axisModel.type,
	    axisId: axisModel.id,
	    value: value,
	    // Caustion: viewHelper.getValueLabel is actually on "view stage", which
	    // depends that all models have been updated. So it should not be performed
	    // here. Considering axisPointerModel used here is volatile, which is hard
	    // to be retrieve in TooltipView, we prepare parameters here.
	    valueLabelOpt: {
	      precision: axisPointerModel.get('label.precision'),
	      formatter: axisPointerModel.get('label.formatter')
	    },
	    seriesDataIndices: payloadBatch.slice()
	  });
	}
	
	function updateModelActually(showValueMap, axesInfo, outputFinder) {
	  var outputAxesInfo = outputFinder.axesInfo = []; // Basic logic: If no 'show' required, 'hide' this axisPointer.
	
	  each(axesInfo, function (axisInfo, key) {
	    var option = axisInfo.axisPointerModel.option;
	    var valItem = showValueMap[key];
	
	    if (valItem) {
	      !axisInfo.useHandle && (option.status = 'show');
	      option.value = valItem.value; // For label formatter param and highlight.
	
	      option.seriesDataIndices = (valItem.payloadBatch || []).slice();
	    } // When always show (e.g., handle used), remain
	    // original value and status.
	    else {
	        // If hide, value still need to be set, consider
	        // click legend to toggle axis blank.
	        !axisInfo.useHandle && (option.status = 'hide');
	      } // If status is 'hide', should be no info in payload.
	
	
	    option.status === 'show' && outputAxesInfo.push({
	      axisDim: axisInfo.axis.dim,
	      axisIndex: axisInfo.axis.model.componentIndex,
	      value: option.value
	    });
	  });
	}
	
	function dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction) {
	  // Basic logic: If no showTip required, hideTip will be dispatched.
	  if (illegalPoint(point) || !dataByCoordSys.list.length) {
	    dispatchAction({
	      type: 'hideTip'
	    });
	    return;
	  } // In most case only one axis (or event one series is used). It is
	  // convinient to fetch payload.seriesIndex and payload.dataIndex
	  // dirtectly. So put the first seriesIndex and dataIndex of the first
	  // axis on the payload.
	
	
	  var sampleItem = ((dataByCoordSys.list[0].dataByAxis[0] || {}).seriesDataIndices || [])[0] || {};
	  dispatchAction({
	    type: 'showTip',
	    escapeConnect: true,
	    x: point[0],
	    y: point[1],
	    tooltipOption: payload.tooltipOption,
	    position: payload.position,
	    dataIndexInside: sampleItem.dataIndexInside,
	    dataIndex: sampleItem.dataIndex,
	    seriesIndex: sampleItem.seriesIndex,
	    dataByCoordSys: dataByCoordSys.list
	  });
	}
	
	function dispatchHighDownActually(axesInfo, dispatchAction, api) {
	  // FIXME
	  // highlight status modification shoule be a stage of main process?
	  // (Consider confilct (e.g., legend and axisPointer) and setOption)
	  var zr = api.getZr();
	  var highDownKey = 'axisPointerLastHighlights';
	  var lastHighlights = inner(zr)[highDownKey] || {};
	  var newHighlights = inner(zr)[highDownKey] = {}; // Update highlight/downplay status according to axisPointer model.
	  // Build hash map and remove duplicate incidentally.
	
	  each(axesInfo, function (axisInfo, key) {
	    var option = axisInfo.axisPointerModel.option;
	    option.status === 'show' && each(option.seriesDataIndices, function (batchItem) {
	      var key = batchItem.seriesIndex + ' | ' + batchItem.dataIndex;
	      newHighlights[key] = batchItem;
	    });
	  }); // Diff.
	
	  var toHighlight = [];
	  var toDownplay = [];
	  zrUtil.each(lastHighlights, function (batchItem, key) {
	    !newHighlights[key] && toDownplay.push(batchItem);
	  });
	  zrUtil.each(newHighlights, function (batchItem, key) {
	    !lastHighlights[key] && toHighlight.push(batchItem);
	  });
	  toDownplay.length && api.dispatchAction({
	    type: 'downplay',
	    escapeConnect: true,
	    batch: toDownplay
	  });
	  toHighlight.length && api.dispatchAction({
	    type: 'highlight',
	    escapeConnect: true,
	    batch: toHighlight
	  });
	}
	
	function findInputAxisInfo(inputAxesInfo, axisInfo) {
	  for (var i = 0; i < (inputAxesInfo || []).length; i++) {
	    var inputAxisInfo = inputAxesInfo[i];
	
	    if (axisInfo.axis.dim === inputAxisInfo.axisDim && axisInfo.axis.model.componentIndex === inputAxisInfo.axisIndex) {
	      return inputAxisInfo;
	    }
	  }
	}
	
	function makeMapperParam(axisInfo) {
	  var axisModel = axisInfo.axis.model;
	  var item = {};
	  var dim = item.axisDim = axisInfo.axis.dim;
	  item.axisIndex = item[dim + 'AxisIndex'] = axisModel.componentIndex;
	  item.axisName = item[dim + 'AxisName'] = axisModel.name;
	  item.axisId = item[dim + 'AxisId'] = axisModel.id;
	  return item;
	}
	
	function illegalPoint(point) {
	  return !point || point[0] == null || isNaN(point[0]) || point[1] == null || isNaN(point[1]);
	}
	
	module.exports = _default;

/***/ },
/* 1580 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var preprocessor = __webpack_require__(1584);
	
	__webpack_require__(713);
	
	__webpack_require__(1581);
	
	__webpack_require__(1582);
	
	__webpack_require__(1583);
	
	__webpack_require__(1635);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Brush component entry
	 */
	echarts.registerPreprocessor(preprocessor);

/***/ },
/* 1581 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var visualSolution = __webpack_require__(342);
	
	var Model = __webpack_require__(48);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var DEFAULT_OUT_OF_BRUSH_COLOR = ['#ddd'];
	var BrushModel = echarts.extendComponentModel({
	  type: 'brush',
	  dependencies: ['geo', 'grid', 'xAxis', 'yAxis', 'parallel', 'series'],
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    // inBrush: null,
	    // outOfBrush: null,
	    toolbox: null,
	    // Default value see preprocessor.
	    brushLink: null,
	    // Series indices array, broadcast using dataIndex.
	    // or 'all', which means all series. 'none' or null means no series.
	    seriesIndex: 'all',
	    // seriesIndex array, specify series controlled by this brush component.
	    geoIndex: null,
	    //
	    xAxisIndex: null,
	    yAxisIndex: null,
	    brushType: 'rect',
	    // Default brushType, see BrushController.
	    brushMode: 'single',
	    // Default brushMode, 'single' or 'multiple'
	    transformable: true,
	    // Default transformable.
	    brushStyle: {
	      // Default brushStyle
	      borderWidth: 1,
	      color: 'rgba(120,140,180,0.3)',
	      borderColor: 'rgba(120,140,180,0.8)'
	    },
	    throttleType: 'fixRate',
	    // Throttle in brushSelected event. 'fixRate' or 'debounce'.
	    // If null, no throttle. Valid only in the first brush component
	    throttleDelay: 0,
	    // Unit: ms, 0 means every event will be triggered.
	    // FIXME
	    // 试验效果
	    removeOnClick: true,
	    z: 10000
	  },
	
	  /**
	   * @readOnly
	   * @type {Array.<Object>}
	   */
	  areas: [],
	
	  /**
	   * Current activated brush type.
	   * If null, brush is inactived.
	   * see module:echarts/component/helper/BrushController
	   * @readOnly
	   * @type {string}
	   */
	  brushType: null,
	
	  /**
	   * Current brush opt.
	   * see module:echarts/component/helper/BrushController
	   * @readOnly
	   * @type {Object}
	   */
	  brushOption: {},
	
	  /**
	   * @readOnly
	   * @type {Array.<Object>}
	   */
	  coordInfoList: [],
	  optionUpdated: function (newOption, isInit) {
	    var thisOption = this.option;
	    !isInit && visualSolution.replaceVisualOption(thisOption, newOption, ['inBrush', 'outOfBrush']);
	    var inBrush = thisOption.inBrush = thisOption.inBrush || {}; // Always give default visual, consider setOption at the second time.
	
	    thisOption.outOfBrush = thisOption.outOfBrush || {
	      color: DEFAULT_OUT_OF_BRUSH_COLOR
	    };
	
	    if (!inBrush.hasOwnProperty('liftZ')) {
	      // Bigger than the highlight z lift, otherwise it will
	      // be effected by the highlight z when brush.
	      inBrush.liftZ = 5;
	    }
	  },
	
	  /**
	   * If ranges is null/undefined, range state remain.
	   *
	   * @param {Array.<Object>} [ranges]
	   */
	  setAreas: function (areas) {
	    // If ranges is null/undefined, range state remain.
	    // This helps user to dispatchAction({type: 'brush'}) with no areas
	    // set but just want to get the current brush select info from a `brush` event.
	    if (!areas) {
	      return;
	    }
	
	    this.areas = zrUtil.map(areas, function (area) {
	      return generateBrushOption(this.option, area);
	    }, this);
	  },
	
	  /**
	   * see module:echarts/component/helper/BrushController
	   * @param {Object} brushOption
	   */
	  setBrushOption: function (brushOption) {
	    this.brushOption = generateBrushOption(this.option, brushOption);
	    this.brushType = this.brushOption.brushType;
	  }
	});
	
	function generateBrushOption(option, brushOption) {
	  return zrUtil.merge({
	    brushType: option.brushType,
	    brushMode: option.brushMode,
	    transformable: option.transformable,
	    brushStyle: new Model(option.brushStyle).getItemStyle(),
	    removeOnClick: option.removeOnClick,
	    z: option.z
	  }, brushOption, true);
	}
	
	var _default = BrushModel;
	module.exports = _default;

/***/ },
/* 1582 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var BrushController = __webpack_require__(463);
	
	var _visualEncoding = __webpack_require__(713);
	
	var layoutCovers = _visualEncoding.layoutCovers;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentView({
	  type: 'brush',
	  init: function (ecModel, api) {
	    /**
	     * @readOnly
	     * @type {module:echarts/model/Global}
	     */
	    this.ecModel = ecModel;
	    /**
	     * @readOnly
	     * @type {module:echarts/ExtensionAPI}
	     */
	
	    this.api = api;
	    /**
	     * @readOnly
	     * @type {module:echarts/component/brush/BrushModel}
	     */
	
	    this.model;
	    /**
	     * @private
	     * @type {module:echarts/component/helper/BrushController}
	     */
	
	    (this._brushController = new BrushController(api.getZr())).on('brush', zrUtil.bind(this._onBrush, this)).mount();
	  },
	
	  /**
	   * @override
	   */
	  render: function (brushModel) {
	    this.model = brushModel;
	    return updateController.apply(this, arguments);
	  },
	
	  /**
	   * @override
	   */
	  updateTransform: function (brushModel, ecModel) {
	    // PENDING: `updateTransform` is a little tricky, whose layout need
	    // to be calculate mandatorily and other stages will not be performed.
	    // Take care the correctness of the logic. See #11754 .
	    layoutCovers(ecModel);
	    return updateController.apply(this, arguments);
	  },
	
	  /**
	   * @override
	   */
	  updateView: updateController,
	  // /**
	  //  * @override
	  //  */
	  // updateLayout: updateController,
	  // /**
	  //  * @override
	  //  */
	  // updateVisual: updateController,
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    this._brushController.dispose();
	  },
	
	  /**
	   * @private
	   */
	  _onBrush: function (areas, opt) {
	    var modelId = this.model.id;
	    this.model.brushTargetManager.setOutputRanges(areas, this.ecModel); // Action is not dispatched on drag end, because the drag end
	    // emits the same params with the last drag move event, and
	    // may have some delay when using touch pad, which makes
	    // animation not smooth (when using debounce).
	
	    (!opt.isEnd || opt.removeOnClick) && this.api.dispatchAction({
	      type: 'brush',
	      brushId: modelId,
	      areas: zrUtil.clone(areas),
	      $from: modelId
	    });
	    opt.isEnd && this.api.dispatchAction({
	      type: 'brushEnd',
	      brushId: modelId,
	      areas: zrUtil.clone(areas),
	      $from: modelId
	    });
	  }
	});
	
	function updateController(brushModel, ecModel, api, payload) {
	  // Do not update controller when drawing.
	  (!payload || payload.$from !== brushModel.id) && this._brushController.setPanels(brushModel.brushTargetManager.makePanelOpts(api)).enableBrush(brushModel.brushOption).updateCovers(brushModel.areas.slice());
	}
	
	module.exports = _default;

/***/ },
/* 1583 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * payload: {
	 *      brushIndex: number, or,
	 *      brushId: string, or,
	 *      brushName: string,
	 *      globalRanges: Array
	 * }
	 */
	echarts.registerAction({
	  type: 'brush',
	  event: 'brush'
	  /*, update: 'updateView' */
	
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'brush',
	    query: payload
	  }, function (brushModel) {
	    brushModel.setAreas(payload.areas);
	  });
	});
	/**
	 * payload: {
	 *      brushComponents: [
	 *          {
	 *              brushId,
	 *              brushIndex,
	 *              brushName,
	 *              series: [
	 *                  {
	 *                      seriesId,
	 *                      seriesIndex,
	 *                      seriesName,
	 *                      rawIndices: [21, 34, ...]
	 *                  },
	 *                  ...
	 *              ]
	 *          },
	 *          ...
	 *      ]
	 * }
	 */
	
	echarts.registerAction({
	  type: 'brushSelect',
	  event: 'brushSelected',
	  update: 'none'
	}, function () {});
	echarts.registerAction({
	  type: 'brushEnd',
	  event: 'brushEnd',
	  update: 'none'
	}, function () {});

/***/ },
/* 1584 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var DEFAULT_TOOLBOX_BTNS = ['rect', 'polygon', 'keep', 'clear'];
	
	function _default(option, isNew) {
	  var brushComponents = option && option.brush;
	
	  if (!zrUtil.isArray(brushComponents)) {
	    brushComponents = brushComponents ? [brushComponents] : [];
	  }
	
	  if (!brushComponents.length) {
	    return;
	  }
	
	  var brushComponentSpecifiedBtns = [];
	  zrUtil.each(brushComponents, function (brushOpt) {
	    var tbs = brushOpt.hasOwnProperty('toolbox') ? brushOpt.toolbox : [];
	
	    if (tbs instanceof Array) {
	      brushComponentSpecifiedBtns = brushComponentSpecifiedBtns.concat(tbs);
	    }
	  });
	  var toolbox = option && option.toolbox;
	
	  if (zrUtil.isArray(toolbox)) {
	    toolbox = toolbox[0];
	  }
	
	  if (!toolbox) {
	    toolbox = {
	      feature: {}
	    };
	    option.toolbox = [toolbox];
	  }
	
	  var toolboxFeature = toolbox.feature || (toolbox.feature = {});
	  var toolboxBrush = toolboxFeature.brush || (toolboxFeature.brush = {});
	  var brushTypes = toolboxBrush.type || (toolboxBrush.type = []);
	  brushTypes.push.apply(brushTypes, brushComponentSpecifiedBtns);
	  removeDuplicate(brushTypes);
	
	  if (isNew && !brushTypes.length) {
	    brushTypes.push.apply(brushTypes, DEFAULT_TOOLBOX_BTNS);
	  }
	}
	
	function removeDuplicate(arr) {
	  var map = {};
	  zrUtil.each(arr, function (val) {
	    map[val] = 1;
	  });
	  arr.length = 0;
	  zrUtil.each(map, function (flag, val) {
	    arr.push(val);
	  });
	}
	
	module.exports = _default;

/***/ },
/* 1585 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var polygonContain = __webpack_require__(1080);
	
	var BoundingRect = __webpack_require__(42);
	
	var _graphic = __webpack_require__(16);
	
	var linePolygonIntersect = _graphic.linePolygonIntersect;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Key of the first level is brushType: `line`, `rect`, `polygon`.
	// Key of the second level is chart element type: `point`, `rect`.
	// See moudule:echarts/component/helper/BrushController
	// function param:
	//      {Object} itemLayout fetch from data.getItemLayout(dataIndex)
	//      {Object} selectors {point: selector, rect: selector, ...}
	//      {Object} area {range: [[], [], ..], boudingRect}
	// function return:
	//      {boolean} Whether in the given brush.
	var selector = {
	  lineX: getLineSelectors(0),
	  lineY: getLineSelectors(1),
	  rect: {
	    point: function (itemLayout, selectors, area) {
	      return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]);
	    },
	    rect: function (itemLayout, selectors, area) {
	      return itemLayout && area.boundingRect.intersect(itemLayout);
	    }
	  },
	  polygon: {
	    point: function (itemLayout, selectors, area) {
	      return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]) && polygonContain.contain(area.range, itemLayout[0], itemLayout[1]);
	    },
	    rect: function (itemLayout, selectors, area) {
	      var points = area.range;
	
	      if (!itemLayout || points.length <= 1) {
	        return false;
	      }
	
	      var x = itemLayout.x;
	      var y = itemLayout.y;
	      var width = itemLayout.width;
	      var height = itemLayout.height;
	      var p = points[0];
	
	      if (polygonContain.contain(points, x, y) || polygonContain.contain(points, x + width, y) || polygonContain.contain(points, x, y + height) || polygonContain.contain(points, x + width, y + height) || BoundingRect.create(itemLayout).contain(p[0], p[1]) || linePolygonIntersect(x, y, x + width, y, points) || linePolygonIntersect(x, y, x, y + height, points) || linePolygonIntersect(x + width, y, x + width, y + height, points) || linePolygonIntersect(x, y + height, x + width, y + height, points)) {
	        return true;
	      }
	    }
	  }
	};
	
	function getLineSelectors(xyIndex) {
	  var xy = ['x', 'y'];
	  var wh = ['width', 'height'];
	  return {
	    point: function (itemLayout, selectors, area) {
	      if (itemLayout) {
	        var range = area.range;
	        var p = itemLayout[xyIndex];
	        return inLineRange(p, range);
	      }
	    },
	    rect: function (itemLayout, selectors, area) {
	      if (itemLayout) {
	        var range = area.range;
	        var layoutRange = [itemLayout[xy[xyIndex]], itemLayout[xy[xyIndex]] + itemLayout[wh[xyIndex]]];
	        layoutRange[1] < layoutRange[0] && layoutRange.reverse();
	        return inLineRange(layoutRange[0], range) || inLineRange(layoutRange[1], range) || inLineRange(range[0], layoutRange) || inLineRange(range[1], layoutRange);
	      }
	    }
	  };
	}
	
	function inLineRange(p, range) {
	  return range[0] <= p && p <= range[1];
	}
	
	var _default = selector;
	module.exports = _default;

/***/ },
/* 1586 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(1652);
	
	__webpack_require__(1653);
	
	__webpack_require__(1587);

/***/ },
/* 1587 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var graphic = __webpack_require__(16);
	
	var formatUtil = __webpack_require__(40);
	
	var numberUtil = __webpack_require__(20);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var MONTH_TEXT = {
	  EN: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	  CN: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
	};
	var WEEK_TEXT = {
	  EN: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
	  CN: ['日', '一', '二', '三', '四', '五', '六']
	};
	
	var _default = echarts.extendComponentView({
	  type: 'calendar',
	
	  /**
	   * top/left line points
	   *  @private
	   */
	  _tlpoints: null,
	
	  /**
	   * bottom/right line points
	   *  @private
	   */
	  _blpoints: null,
	
	  /**
	   * first day of month
	   *  @private
	   */
	  _firstDayOfMonth: null,
	
	  /**
	   * first day point of month
	   *  @private
	   */
	  _firstDayPoints: null,
	  render: function (calendarModel, ecModel, api) {
	    var group = this.group;
	    group.removeAll();
	    var coordSys = calendarModel.coordinateSystem; // range info
	
	    var rangeData = coordSys.getRangeInfo();
	    var orient = coordSys.getOrient();
	
	    this._renderDayRect(calendarModel, rangeData, group); // _renderLines must be called prior to following function
	
	
	    this._renderLines(calendarModel, rangeData, orient, group);
	
	    this._renderYearText(calendarModel, rangeData, orient, group);
	
	    this._renderMonthText(calendarModel, orient, group);
	
	    this._renderWeekText(calendarModel, rangeData, orient, group);
	  },
	  // render day rect
	  _renderDayRect: function (calendarModel, rangeData, group) {
	    var coordSys = calendarModel.coordinateSystem;
	    var itemRectStyleModel = calendarModel.getModel('itemStyle').getItemStyle();
	    var sw = coordSys.getCellWidth();
	    var sh = coordSys.getCellHeight();
	
	    for (var i = rangeData.start.time; i <= rangeData.end.time; i = coordSys.getNextNDay(i, 1).time) {
	      var point = coordSys.dataToRect([i], false).tl; // every rect
	
	      var rect = new graphic.Rect({
	        shape: {
	          x: point[0],
	          y: point[1],
	          width: sw,
	          height: sh
	        },
	        cursor: 'default',
	        style: itemRectStyleModel
	      });
	      group.add(rect);
	    }
	  },
	  // render separate line
	  _renderLines: function (calendarModel, rangeData, orient, group) {
	    var self = this;
	    var coordSys = calendarModel.coordinateSystem;
	    var lineStyleModel = calendarModel.getModel('splitLine.lineStyle').getLineStyle();
	    var show = calendarModel.get('splitLine.show');
	    var lineWidth = lineStyleModel.lineWidth;
	    this._tlpoints = [];
	    this._blpoints = [];
	    this._firstDayOfMonth = [];
	    this._firstDayPoints = [];
	    var firstDay = rangeData.start;
	
	    for (var i = 0; firstDay.time <= rangeData.end.time; i++) {
	      addPoints(firstDay.formatedDate);
	
	      if (i === 0) {
	        firstDay = coordSys.getDateInfo(rangeData.start.y + '-' + rangeData.start.m);
	      }
	
	      var date = firstDay.date;
	      date.setMonth(date.getMonth() + 1);
	      firstDay = coordSys.getDateInfo(date);
	    }
	
	    addPoints(coordSys.getNextNDay(rangeData.end.time, 1).formatedDate);
	
	    function addPoints(date) {
	      self._firstDayOfMonth.push(coordSys.getDateInfo(date));
	
	      self._firstDayPoints.push(coordSys.dataToRect([date], false).tl);
	
	      var points = self._getLinePointsOfOneWeek(calendarModel, date, orient);
	
	      self._tlpoints.push(points[0]);
	
	      self._blpoints.push(points[points.length - 1]);
	
	      show && self._drawSplitline(points, lineStyleModel, group);
	    } // render top/left line
	
	
	    show && this._drawSplitline(self._getEdgesPoints(self._tlpoints, lineWidth, orient), lineStyleModel, group); // render bottom/right line
	
	    show && this._drawSplitline(self._getEdgesPoints(self._blpoints, lineWidth, orient), lineStyleModel, group);
	  },
	  // get points at both ends
	  _getEdgesPoints: function (points, lineWidth, orient) {
	    var rs = [points[0].slice(), points[points.length - 1].slice()];
	    var idx = orient === 'horizontal' ? 0 : 1; // both ends of the line are extend half lineWidth
	
	    rs[0][idx] = rs[0][idx] - lineWidth / 2;
	    rs[1][idx] = rs[1][idx] + lineWidth / 2;
	    return rs;
	  },
	  // render split line
	  _drawSplitline: function (points, lineStyleModel, group) {
	    var poyline = new graphic.Polyline({
	      z2: 20,
	      shape: {
	        points: points
	      },
	      style: lineStyleModel
	    });
	    group.add(poyline);
	  },
	  // render month line of one week points
	  _getLinePointsOfOneWeek: function (calendarModel, date, orient) {
	    var coordSys = calendarModel.coordinateSystem;
	    date = coordSys.getDateInfo(date);
	    var points = [];
	
	    for (var i = 0; i < 7; i++) {
	      var tmpD = coordSys.getNextNDay(date.time, i);
	      var point = coordSys.dataToRect([tmpD.time], false);
	      points[2 * tmpD.day] = point.tl;
	      points[2 * tmpD.day + 1] = point[orient === 'horizontal' ? 'bl' : 'tr'];
	    }
	
	    return points;
	  },
	  _formatterLabel: function (formatter, params) {
	    if (typeof formatter === 'string' && formatter) {
	      return formatUtil.formatTplSimple(formatter, params);
	    }
	
	    if (typeof formatter === 'function') {
	      return formatter(params);
	    }
	
	    return params.nameMap;
	  },
	  _yearTextPositionControl: function (textEl, point, orient, position, margin) {
	    point = point.slice();
	    var aligns = ['center', 'bottom'];
	
	    if (position === 'bottom') {
	      point[1] += margin;
	      aligns = ['center', 'top'];
	    } else if (position === 'left') {
	      point[0] -= margin;
	    } else if (position === 'right') {
	      point[0] += margin;
	      aligns = ['center', 'top'];
	    } else {
	      // top
	      point[1] -= margin;
	    }
	
	    var rotate = 0;
	
	    if (position === 'left' || position === 'right') {
	      rotate = Math.PI / 2;
	    }
	
	    return {
	      rotation: rotate,
	      position: point,
	      style: {
	        textAlign: aligns[0],
	        textVerticalAlign: aligns[1]
	      }
	    };
	  },
	  // render year
	  _renderYearText: function (calendarModel, rangeData, orient, group) {
	    var yearLabel = calendarModel.getModel('yearLabel');
	
	    if (!yearLabel.get('show')) {
	      return;
	    }
	
	    var margin = yearLabel.get('margin');
	    var pos = yearLabel.get('position');
	
	    if (!pos) {
	      pos = orient !== 'horizontal' ? 'top' : 'left';
	    }
	
	    var points = [this._tlpoints[this._tlpoints.length - 1], this._blpoints[0]];
	    var xc = (points[0][0] + points[1][0]) / 2;
	    var yc = (points[0][1] + points[1][1]) / 2;
	    var idx = orient === 'horizontal' ? 0 : 1;
	    var posPoints = {
	      top: [xc, points[idx][1]],
	      bottom: [xc, points[1 - idx][1]],
	      left: [points[1 - idx][0], yc],
	      right: [points[idx][0], yc]
	    };
	    var name = rangeData.start.y;
	
	    if (+rangeData.end.y > +rangeData.start.y) {
	      name = name + '-' + rangeData.end.y;
	    }
	
	    var formatter = yearLabel.get('formatter');
	    var params = {
	      start: rangeData.start.y,
	      end: rangeData.end.y,
	      nameMap: name
	    };
	
	    var content = this._formatterLabel(formatter, params);
	
	    var yearText = new graphic.Text({
	      z2: 30
	    });
	    graphic.setTextStyle(yearText.style, yearLabel, {
	      text: content
	    }), yearText.attr(this._yearTextPositionControl(yearText, posPoints[pos], orient, pos, margin));
	    group.add(yearText);
	  },
	  _monthTextPositionControl: function (point, isCenter, orient, position, margin) {
	    var align = 'left';
	    var vAlign = 'top';
	    var x = point[0];
	    var y = point[1];
	
	    if (orient === 'horizontal') {
	      y = y + margin;
	
	      if (isCenter) {
	        align = 'center';
	      }
	
	      if (position === 'start') {
	        vAlign = 'bottom';
	      }
	    } else {
	      x = x + margin;
	
	      if (isCenter) {
	        vAlign = 'middle';
	      }
	
	      if (position === 'start') {
	        align = 'right';
	      }
	    }
	
	    return {
	      x: x,
	      y: y,
	      textAlign: align,
	      textVerticalAlign: vAlign
	    };
	  },
	  // render month and year text
	  _renderMonthText: function (calendarModel, orient, group) {
	    var monthLabel = calendarModel.getModel('monthLabel');
	
	    if (!monthLabel.get('show')) {
	      return;
	    }
	
	    var nameMap = monthLabel.get('nameMap');
	    var margin = monthLabel.get('margin');
	    var pos = monthLabel.get('position');
	    var align = monthLabel.get('align');
	    var termPoints = [this._tlpoints, this._blpoints];
	
	    if (zrUtil.isString(nameMap)) {
	      nameMap = MONTH_TEXT[nameMap.toUpperCase()] || [];
	    }
	
	    var idx = pos === 'start' ? 0 : 1;
	    var axis = orient === 'horizontal' ? 0 : 1;
	    margin = pos === 'start' ? -margin : margin;
	    var isCenter = align === 'center';
	
	    for (var i = 0; i < termPoints[idx].length - 1; i++) {
	      var tmp = termPoints[idx][i].slice();
	      var firstDay = this._firstDayOfMonth[i];
	
	      if (isCenter) {
	        var firstDayPoints = this._firstDayPoints[i];
	        tmp[axis] = (firstDayPoints[axis] + termPoints[0][i + 1][axis]) / 2;
	      }
	
	      var formatter = monthLabel.get('formatter');
	      var name = nameMap[+firstDay.m - 1];
	      var params = {
	        yyyy: firstDay.y,
	        yy: (firstDay.y + '').slice(2),
	        MM: firstDay.m,
	        M: +firstDay.m,
	        nameMap: name
	      };
	
	      var content = this._formatterLabel(formatter, params);
	
	      var monthText = new graphic.Text({
	        z2: 30
	      });
	      zrUtil.extend(graphic.setTextStyle(monthText.style, monthLabel, {
	        text: content
	      }), this._monthTextPositionControl(tmp, isCenter, orient, pos, margin));
	      group.add(monthText);
	    }
	  },
	  _weekTextPositionControl: function (point, orient, position, margin, cellSize) {
	    var align = 'center';
	    var vAlign = 'middle';
	    var x = point[0];
	    var y = point[1];
	    var isStart = position === 'start';
	
	    if (orient === 'horizontal') {
	      x = x + margin + (isStart ? 1 : -1) * cellSize[0] / 2;
	      align = isStart ? 'right' : 'left';
	    } else {
	      y = y + margin + (isStart ? 1 : -1) * cellSize[1] / 2;
	      vAlign = isStart ? 'bottom' : 'top';
	    }
	
	    return {
	      x: x,
	      y: y,
	      textAlign: align,
	      textVerticalAlign: vAlign
	    };
	  },
	  // render weeks
	  _renderWeekText: function (calendarModel, rangeData, orient, group) {
	    var dayLabel = calendarModel.getModel('dayLabel');
	
	    if (!dayLabel.get('show')) {
	      return;
	    }
	
	    var coordSys = calendarModel.coordinateSystem;
	    var pos = dayLabel.get('position');
	    var nameMap = dayLabel.get('nameMap');
	    var margin = dayLabel.get('margin');
	    var firstDayOfWeek = coordSys.getFirstDayOfWeek();
	
	    if (zrUtil.isString(nameMap)) {
	      nameMap = WEEK_TEXT[nameMap.toUpperCase()] || [];
	    }
	
	    var start = coordSys.getNextNDay(rangeData.end.time, 7 - rangeData.lweek).time;
	    var cellSize = [coordSys.getCellWidth(), coordSys.getCellHeight()];
	    margin = numberUtil.parsePercent(margin, cellSize[orient === 'horizontal' ? 0 : 1]);
	
	    if (pos === 'start') {
	      start = coordSys.getNextNDay(rangeData.start.time, -(7 + rangeData.fweek)).time;
	      margin = -margin;
	    }
	
	    for (var i = 0; i < 7; i++) {
	      var tmpD = coordSys.getNextNDay(start, i);
	      var point = coordSys.dataToRect([tmpD.time], false).center;
	      var day = i;
	      day = Math.abs((i + firstDayOfWeek) % 7);
	      var weekText = new graphic.Text({
	        z2: 30
	      });
	      zrUtil.extend(graphic.setTextStyle(weekText.style, dayLabel, {
	        text: nameMap[day]
	      }), this._weekTextPositionControl(point, orient, pos, margin, cellSize));
	      group.add(weekText);
	    }
	  }
	});
	
	module.exports = _default;

/***/ },
/* 1588 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(716);
	
	__webpack_require__(715);

/***/ },
/* 1589 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var numberUtil = __webpack_require__(20);
	
	var helper = __webpack_require__(461);
	
	var sliderMove = __webpack_require__(205);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var asc = numberUtil.asc;
	/**
	 * Operate single axis.
	 * One axis can only operated by one axis operator.
	 * Different dataZoomModels may be defined to operate the same axis.
	 * (i.e. 'inside' data zoom and 'slider' data zoom components)
	 * So dataZoomModels share one axisProxy in that case.
	 *
	 * @class
	 */
	
	var AxisProxy = function (dimName, axisIndex, dataZoomModel, ecModel) {
	  /**
	   * @private
	   * @type {string}
	   */
	  this._dimName = dimName;
	  /**
	   * @private
	   */
	
	  this._axisIndex = axisIndex;
	  /**
	   * @private
	   * @type {Array.<number>}
	   */
	
	  this._valueWindow;
	  /**
	   * @private
	   * @type {Array.<number>}
	   */
	
	  this._percentWindow;
	  /**
	   * @private
	   * @type {Array.<number>}
	   */
	
	  this._dataExtent;
	  /**
	   * {minSpan, maxSpan, minValueSpan, maxValueSpan}
	   * @private
	   * @type {Object}
	   */
	
	  this._minMaxSpan;
	  /**
	   * @readOnly
	   * @type {module: echarts/model/Global}
	   */
	
	  this.ecModel = ecModel;
	  /**
	   * @private
	   * @type {module: echarts/component/dataZoom/DataZoomModel}
	   */
	
	  this._dataZoomModel = dataZoomModel; // /**
	  //  * @readOnly
	  //  * @private
	  //  */
	  // this.hasSeriesStacked;
	};
	
	AxisProxy.prototype = {
	  constructor: AxisProxy,
	
	  /**
	   * Whether the axisProxy is hosted by dataZoomModel.
	   *
	   * @public
	   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
	   * @return {boolean}
	   */
	  hostedBy: function (dataZoomModel) {
	    return this._dataZoomModel === dataZoomModel;
	  },
	
	  /**
	   * @return {Array.<number>} Value can only be NaN or finite value.
	   */
	  getDataValueWindow: function () {
	    return this._valueWindow.slice();
	  },
	
	  /**
	   * @return {Array.<number>}
	   */
	  getDataPercentWindow: function () {
	    return this._percentWindow.slice();
	  },
	
	  /**
	   * @public
	   * @param {number} axisIndex
	   * @return {Array} seriesModels
	   */
	  getTargetSeriesModels: function () {
	    var seriesModels = [];
	    var ecModel = this.ecModel;
	    ecModel.eachSeries(function (seriesModel) {
	      if (helper.isCoordSupported(seriesModel.get('coordinateSystem'))) {
	        var dimName = this._dimName;
	        var axisModel = ecModel.queryComponents({
	          mainType: dimName + 'Axis',
	          index: seriesModel.get(dimName + 'AxisIndex'),
	          id: seriesModel.get(dimName + 'AxisId')
	        })[0];
	
	        if (this._axisIndex === (axisModel && axisModel.componentIndex)) {
	          seriesModels.push(seriesModel);
	        }
	      }
	    }, this);
	    return seriesModels;
	  },
	  getAxisModel: function () {
	    return this.ecModel.getComponent(this._dimName + 'Axis', this._axisIndex);
	  },
	  getOtherAxisModel: function () {
	    var axisDim = this._dimName;
	    var ecModel = this.ecModel;
	    var axisModel = this.getAxisModel();
	    var isCartesian = axisDim === 'x' || axisDim === 'y';
	    var otherAxisDim;
	    var coordSysIndexName;
	
	    if (isCartesian) {
	      coordSysIndexName = 'gridIndex';
	      otherAxisDim = axisDim === 'x' ? 'y' : 'x';
	    } else {
	      coordSysIndexName = 'polarIndex';
	      otherAxisDim = axisDim === 'angle' ? 'radius' : 'angle';
	    }
	
	    var foundOtherAxisModel;
	    ecModel.eachComponent(otherAxisDim + 'Axis', function (otherAxisModel) {
	      if ((otherAxisModel.get(coordSysIndexName) || 0) === (axisModel.get(coordSysIndexName) || 0)) {
	        foundOtherAxisModel = otherAxisModel;
	      }
	    });
	    return foundOtherAxisModel;
	  },
	  getMinMaxSpan: function () {
	    return zrUtil.clone(this._minMaxSpan);
	  },
	
	  /**
	   * Only calculate by given range and this._dataExtent, do not change anything.
	   *
	   * @param {Object} opt
	   * @param {number} [opt.start]
	   * @param {number} [opt.end]
	   * @param {number} [opt.startValue]
	   * @param {number} [opt.endValue]
	   */
	  calculateDataWindow: function (opt) {
	    var dataExtent = this._dataExtent;
	    var axisModel = this.getAxisModel();
	    var scale = axisModel.axis.scale;
	
	    var rangePropMode = this._dataZoomModel.getRangePropMode();
	
	    var percentExtent = [0, 100];
	    var percentWindow = [];
	    var valueWindow = [];
	    var hasPropModeValue;
	    each(['start', 'end'], function (prop, idx) {
	      var boundPercent = opt[prop];
	      var boundValue = opt[prop + 'Value']; // Notice: dataZoom is based either on `percentProp` ('start', 'end') or
	      // on `valueProp` ('startValue', 'endValue'). (They are based on the data extent
	      // but not min/max of axis, which will be calculated by data window then).
	      // The former one is suitable for cases that a dataZoom component controls multiple
	      // axes with different unit or extent, and the latter one is suitable for accurate
	      // zoom by pixel (e.g., in dataZoomSelect).
	      // we use `getRangePropMode()` to mark which prop is used. `rangePropMode` is updated
	      // only when setOption or dispatchAction, otherwise it remains its original value.
	      // (Why not only record `percentProp` and always map to `valueProp`? Because
	      // the map `valueProp` -> `percentProp` -> `valueProp` probably not the original
	      // `valueProp`. consider two axes constrolled by one dataZoom. They have different
	      // data extent. All of values that are overflow the `dataExtent` will be calculated
	      // to percent '100%').
	
	      if (rangePropMode[idx] === 'percent') {
	        boundPercent == null && (boundPercent = percentExtent[idx]); // Use scale.parse to math round for category or time axis.
	
	        boundValue = scale.parse(numberUtil.linearMap(boundPercent, percentExtent, dataExtent));
	      } else {
	        hasPropModeValue = true;
	        boundValue = boundValue == null ? dataExtent[idx] : scale.parse(boundValue); // Calculating `percent` from `value` may be not accurate, because
	        // This calculation can not be inversed, because all of values that
	        // are overflow the `dataExtent` will be calculated to percent '100%'
	
	        boundPercent = numberUtil.linearMap(boundValue, dataExtent, percentExtent);
	      } // valueWindow[idx] = round(boundValue);
	      // percentWindow[idx] = round(boundPercent);
	
	
	      valueWindow[idx] = boundValue;
	      percentWindow[idx] = boundPercent;
	    });
	    asc(valueWindow);
	    asc(percentWindow); // The windows from user calling of `dispatchAction` might be out of the extent,
	    // or do not obey the `min/maxSpan`, `min/maxValueSpan`. But we dont restrict window
	    // by `zoomLock` here, because we see `zoomLock` just as a interaction constraint,
	    // where API is able to initialize/modify the window size even though `zoomLock`
	    // specified.
	
	    var spans = this._minMaxSpan;
	    hasPropModeValue ? restrictSet(valueWindow, percentWindow, dataExtent, percentExtent, false) : restrictSet(percentWindow, valueWindow, percentExtent, dataExtent, true);
	
	    function restrictSet(fromWindow, toWindow, fromExtent, toExtent, toValue) {
	      var suffix = toValue ? 'Span' : 'ValueSpan';
	      sliderMove(0, fromWindow, fromExtent, 'all', spans['min' + suffix], spans['max' + suffix]);
	
	      for (var i = 0; i < 2; i++) {
	        toWindow[i] = numberUtil.linearMap(fromWindow[i], fromExtent, toExtent, true);
	        toValue && (toWindow[i] = scale.parse(toWindow[i]));
	      }
	    }
	
	    return {
	      valueWindow: valueWindow,
	      percentWindow: percentWindow
	    };
	  },
	
	  /**
	   * Notice: reset should not be called before series.restoreData() called,
	   * so it is recommanded to be called in "process stage" but not "model init
	   * stage".
	   *
	   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
	   */
	  reset: function (dataZoomModel) {
	    if (dataZoomModel !== this._dataZoomModel) {
	      return;
	    }
	
	    var targetSeries = this.getTargetSeriesModels(); // Culculate data window and data extent, and record them.
	
	    this._dataExtent = calculateDataExtent(this, this._dimName, targetSeries); // this.hasSeriesStacked = false;
	    // each(targetSeries, function (series) {
	    // var data = series.getData();
	    // var dataDim = data.mapDimension(this._dimName);
	    // var stackedDimension = data.getCalculationInfo('stackedDimension');
	    // if (stackedDimension && stackedDimension === dataDim) {
	    // this.hasSeriesStacked = true;
	    // }
	    // }, this);
	    // `calculateDataWindow` uses min/maxSpan.
	
	    setMinMaxSpan(this);
	    var dataWindow = this.calculateDataWindow(dataZoomModel.settledOption);
	    this._valueWindow = dataWindow.valueWindow;
	    this._percentWindow = dataWindow.percentWindow; // Update axis setting then.
	
	    setAxisModel(this);
	  },
	
	  /**
	   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
	   */
	  restore: function (dataZoomModel) {
	    if (dataZoomModel !== this._dataZoomModel) {
	      return;
	    }
	
	    this._valueWindow = this._percentWindow = null;
	    setAxisModel(this, true);
	  },
	
	  /**
	   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
	   */
	  filterData: function (dataZoomModel, api) {
	    if (dataZoomModel !== this._dataZoomModel) {
	      return;
	    }
	
	    var axisDim = this._dimName;
	    var seriesModels = this.getTargetSeriesModels();
	    var filterMode = dataZoomModel.get('filterMode');
	    var valueWindow = this._valueWindow;
	
	    if (filterMode === 'none') {
	      return;
	    } // FIXME
	    // Toolbox may has dataZoom injected. And if there are stacked bar chart
	    // with NaN data, NaN will be filtered and stack will be wrong.
	    // So we need to force the mode to be set empty.
	    // In fect, it is not a big deal that do not support filterMode-'filter'
	    // when using toolbox#dataZoom, utill tooltip#dataZoom support "single axis
	    // selection" some day, which might need "adapt to data extent on the
	    // otherAxis", which is disabled by filterMode-'empty'.
	    // But currently, stack has been fixed to based on value but not index,
	    // so this is not an issue any more.
	    // var otherAxisModel = this.getOtherAxisModel();
	    // if (dataZoomModel.get('$fromToolbox')
	    //     && otherAxisModel
	    //     && otherAxisModel.hasSeriesStacked
	    // ) {
	    //     filterMode = 'empty';
	    // }
	    // TODO
	    // filterMode 'weakFilter' and 'empty' is not optimized for huge data yet.
	
	
	    each(seriesModels, function (seriesModel) {
	      var seriesData = seriesModel.getData();
	      var dataDims = seriesData.mapDimension(axisDim, true);
	
	      if (!dataDims.length) {
	        return;
	      }
	
	      if (filterMode === 'weakFilter') {
	        seriesData.filterSelf(function (dataIndex) {
	          var leftOut;
	          var rightOut;
	          var hasValue;
	
	          for (var i = 0; i < dataDims.length; i++) {
	            var value = seriesData.get(dataDims[i], dataIndex);
	            var thisHasValue = !isNaN(value);
	            var thisLeftOut = value < valueWindow[0];
	            var thisRightOut = value > valueWindow[1];
	
	            if (thisHasValue && !thisLeftOut && !thisRightOut) {
	              return true;
	            }
	
	            thisHasValue && (hasValue = true);
	            thisLeftOut && (leftOut = true);
	            thisRightOut && (rightOut = true);
	          } // If both left out and right out, do not filter.
	
	
	          return hasValue && leftOut && rightOut;
	        });
	      } else {
	        each(dataDims, function (dim) {
	          if (filterMode === 'empty') {
	            seriesModel.setData(seriesData = seriesData.map(dim, function (value) {
	              return !isInWindow(value) ? NaN : value;
	            }));
	          } else {
	            var range = {};
	            range[dim] = valueWindow; // console.time('select');
	
	            seriesData.selectRange(range); // console.timeEnd('select');
	          }
	        });
	      }
	
	      each(dataDims, function (dim) {
	        seriesData.setApproximateExtent(valueWindow, dim);
	      });
	    });
	
	    function isInWindow(value) {
	      return value >= valueWindow[0] && value <= valueWindow[1];
	    }
	  }
	};
	
	function calculateDataExtent(axisProxy, axisDim, seriesModels) {
	  var dataExtent = [Infinity, -Infinity];
	  each(seriesModels, function (seriesModel) {
	    var seriesData = seriesModel.getData();
	
	    if (seriesData) {
	      each(seriesData.mapDimension(axisDim, true), function (dim) {
	        var seriesExtent = seriesData.getApproximateExtent(dim);
	        seriesExtent[0] < dataExtent[0] && (dataExtent[0] = seriesExtent[0]);
	        seriesExtent[1] > dataExtent[1] && (dataExtent[1] = seriesExtent[1]);
	      });
	    }
	  });
	
	  if (dataExtent[1] < dataExtent[0]) {
	    dataExtent = [NaN, NaN];
	  } // It is important to get "consistent" extent when more then one axes is
	  // controlled by a `dataZoom`, otherwise those axes will not be synchronized
	  // when zooming. But it is difficult to know what is "consistent", considering
	  // axes have different type or even different meanings (For example, two
	  // time axes are used to compare data of the same date in different years).
	  // So basically dataZoom just obtains extent by series.data (in category axis
	  // extent can be obtained from axis.data).
	  // Nevertheless, user can set min/max/scale on axes to make extent of axes
	  // consistent.
	
	
	  fixExtentByAxis(axisProxy, dataExtent);
	  return dataExtent;
	}
	
	function fixExtentByAxis(axisProxy, dataExtent) {
	  var axisModel = axisProxy.getAxisModel();
	  var min = axisModel.getMin(true); // For category axis, if min/max/scale are not set, extent is determined
	  // by axis.data by default.
	
	  var isCategoryAxis = axisModel.get('type') === 'category';
	  var axisDataLen = isCategoryAxis && axisModel.getCategories().length;
	
	  if (min != null && min !== 'dataMin' && typeof min !== 'function') {
	    dataExtent[0] = min;
	  } else if (isCategoryAxis) {
	    dataExtent[0] = axisDataLen > 0 ? 0 : NaN;
	  }
	
	  var max = axisModel.getMax(true);
	
	  if (max != null && max !== 'dataMax' && typeof max !== 'function') {
	    dataExtent[1] = max;
	  } else if (isCategoryAxis) {
	    dataExtent[1] = axisDataLen > 0 ? axisDataLen - 1 : NaN;
	  }
	
	  if (!axisModel.get('scale', true)) {
	    dataExtent[0] > 0 && (dataExtent[0] = 0);
	    dataExtent[1] < 0 && (dataExtent[1] = 0);
	  } // For value axis, if min/max/scale are not set, we just use the extent obtained
	  // by series data, which may be a little different from the extent calculated by
	  // `axisHelper.getScaleExtent`. But the different just affects the experience a
	  // little when zooming. So it will not be fixed until some users require it strongly.
	
	
	  return dataExtent;
	}
	
	function setAxisModel(axisProxy, isRestore) {
	  var axisModel = axisProxy.getAxisModel();
	  var percentWindow = axisProxy._percentWindow;
	  var valueWindow = axisProxy._valueWindow;
	
	  if (!percentWindow) {
	    return;
	  } // [0, 500]: arbitrary value, guess axis extent.
	
	
	  var precision = numberUtil.getPixelPrecision(valueWindow, [0, 500]);
	  precision = Math.min(precision, 20); // isRestore or isFull
	
	  var useOrigin = isRestore || percentWindow[0] === 0 && percentWindow[1] === 100;
	  axisModel.setRange(useOrigin ? null : +valueWindow[0].toFixed(precision), useOrigin ? null : +valueWindow[1].toFixed(precision));
	}
	
	function setMinMaxSpan(axisProxy) {
	  var minMaxSpan = axisProxy._minMaxSpan = {};
	  var dataZoomModel = axisProxy._dataZoomModel;
	  var dataExtent = axisProxy._dataExtent;
	  each(['min', 'max'], function (minMax) {
	    var percentSpan = dataZoomModel.get(minMax + 'Span');
	    var valueSpan = dataZoomModel.get(minMax + 'ValueSpan');
	    valueSpan != null && (valueSpan = axisProxy.getAxisModel().axis.scale.parse(valueSpan)); // minValueSpan and maxValueSpan has higher priority than minSpan and maxSpan
	
	    if (valueSpan != null) {
	      percentSpan = numberUtil.linearMap(dataExtent[0] + valueSpan, dataExtent, [0, 100], true);
	    } else if (percentSpan != null) {
	      valueSpan = numberUtil.linearMap(percentSpan, [0, 100], dataExtent, true) - dataExtent[0];
	    }
	
	    minMaxSpan[minMax + 'Span'] = percentSpan;
	    minMaxSpan[minMax + 'ValueSpan'] = valueSpan;
	  });
	}
	
	var _default = AxisProxy;
	module.exports = _default;

/***/ },
/* 1590 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var DataZoomModel = __webpack_require__(203);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = DataZoomModel.extend({
	  type: 'dataZoom.inside',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    disabled: false,
	    // Whether disable this inside zoom.
	    zoomLock: false,
	    // Whether disable zoom but only pan.
	    zoomOnMouseWheel: true,
	    // Can be: true / false / 'shift' / 'ctrl' / 'alt'.
	    moveOnMouseMove: true,
	    // Can be: true / false / 'shift' / 'ctrl' / 'alt'.
	    moveOnMouseWheel: false,
	    // Can be: true / false / 'shift' / 'ctrl' / 'alt'.
	    preventDefaultMouseMove: true
	  }
	});
	
	module.exports = _default;

/***/ },
/* 1591 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var DataZoomView = __webpack_require__(204);
	
	var sliderMove = __webpack_require__(205);
	
	var roams = __webpack_require__(1596);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var bind = zrUtil.bind;
	var InsideZoomView = DataZoomView.extend({
	  type: 'dataZoom.inside',
	
	  /**
	   * @override
	   */
	  init: function (ecModel, api) {
	    /**
	     * 'throttle' is used in this.dispatchAction, so we save range
	     * to avoid missing some 'pan' info.
	     * @private
	     * @type {Array.<number>}
	     */
	    this._range;
	  },
	
	  /**
	   * @override
	   */
	  render: function (dataZoomModel, ecModel, api, payload) {
	    InsideZoomView.superApply(this, 'render', arguments); // Hence the `throttle` util ensures to preserve command order,
	    // here simply updating range all the time will not cause missing
	    // any of the the roam change.
	
	    this._range = dataZoomModel.getPercentRange(); // Reset controllers.
	
	    zrUtil.each(this.getTargetCoordInfo(), function (coordInfoList, coordSysName) {
	      var allCoordIds = zrUtil.map(coordInfoList, function (coordInfo) {
	        return roams.generateCoordId(coordInfo.model);
	      });
	      zrUtil.each(coordInfoList, function (coordInfo) {
	        var coordModel = coordInfo.model;
	        var getRange = {};
	        zrUtil.each(['pan', 'zoom', 'scrollMove'], function (eventName) {
	          getRange[eventName] = bind(roamHandlers[eventName], this, coordInfo, coordSysName);
	        }, this);
	        roams.register(api, {
	          coordId: roams.generateCoordId(coordModel),
	          allCoordIds: allCoordIds,
	          containsPoint: function (e, x, y) {
	            return coordModel.coordinateSystem.containPoint([x, y]);
	          },
	          dataZoomId: dataZoomModel.id,
	          dataZoomModel: dataZoomModel,
	          getRange: getRange
	        });
	      }, this);
	    }, this);
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    roams.unregister(this.api, this.dataZoomModel.id);
	    InsideZoomView.superApply(this, 'dispose', arguments);
	    this._range = null;
	  }
	});
	var roamHandlers = {
	  /**
	   * @this {module:echarts/component/dataZoom/InsideZoomView}
	   */
	  zoom: function (coordInfo, coordSysName, controller, e) {
	    var lastRange = this._range;
	    var range = lastRange.slice(); // Calculate transform by the first axis.
	
	    var axisModel = coordInfo.axisModels[0];
	
	    if (!axisModel) {
	      return;
	    }
	
	    var directionInfo = getDirectionInfo[coordSysName](null, [e.originX, e.originY], axisModel, controller, coordInfo);
	    var percentPoint = (directionInfo.signal > 0 ? directionInfo.pixelStart + directionInfo.pixelLength - directionInfo.pixel : directionInfo.pixel - directionInfo.pixelStart) / directionInfo.pixelLength * (range[1] - range[0]) + range[0];
	    var scale = Math.max(1 / e.scale, 0);
	    range[0] = (range[0] - percentPoint) * scale + percentPoint;
	    range[1] = (range[1] - percentPoint) * scale + percentPoint; // Restrict range.
	
	    var minMaxSpan = this.dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
	    sliderMove(0, range, [0, 100], 0, minMaxSpan.minSpan, minMaxSpan.maxSpan);
	    this._range = range;
	
	    if (lastRange[0] !== range[0] || lastRange[1] !== range[1]) {
	      return range;
	    }
	  },
	
	  /**
	   * @this {module:echarts/component/dataZoom/InsideZoomView}
	   */
	  pan: makeMover(function (range, axisModel, coordInfo, coordSysName, controller, e) {
	    var directionInfo = getDirectionInfo[coordSysName]([e.oldX, e.oldY], [e.newX, e.newY], axisModel, controller, coordInfo);
	    return directionInfo.signal * (range[1] - range[0]) * directionInfo.pixel / directionInfo.pixelLength;
	  }),
	
	  /**
	   * @this {module:echarts/component/dataZoom/InsideZoomView}
	   */
	  scrollMove: makeMover(function (range, axisModel, coordInfo, coordSysName, controller, e) {
	    var directionInfo = getDirectionInfo[coordSysName]([0, 0], [e.scrollDelta, e.scrollDelta], axisModel, controller, coordInfo);
	    return directionInfo.signal * (range[1] - range[0]) * e.scrollDelta;
	  })
	};
	
	function makeMover(getPercentDelta) {
	  return function (coordInfo, coordSysName, controller, e) {
	    var lastRange = this._range;
	    var range = lastRange.slice(); // Calculate transform by the first axis.
	
	    var axisModel = coordInfo.axisModels[0];
	
	    if (!axisModel) {
	      return;
	    }
	
	    var percentDelta = getPercentDelta(range, axisModel, coordInfo, coordSysName, controller, e);
	    sliderMove(percentDelta, range, [0, 100], 'all');
	    this._range = range;
	
	    if (lastRange[0] !== range[0] || lastRange[1] !== range[1]) {
	      return range;
	    }
	  };
	}
	
	var getDirectionInfo = {
	  grid: function (oldPoint, newPoint, axisModel, controller, coordInfo) {
	    var axis = axisModel.axis;
	    var ret = {};
	    var rect = coordInfo.model.coordinateSystem.getRect();
	    oldPoint = oldPoint || [0, 0];
	
	    if (axis.dim === 'x') {
	      ret.pixel = newPoint[0] - oldPoint[0];
	      ret.pixelLength = rect.width;
	      ret.pixelStart = rect.x;
	      ret.signal = axis.inverse ? 1 : -1;
	    } else {
	      // axis.dim === 'y'
	      ret.pixel = newPoint[1] - oldPoint[1];
	      ret.pixelLength = rect.height;
	      ret.pixelStart = rect.y;
	      ret.signal = axis.inverse ? -1 : 1;
	    }
	
	    return ret;
	  },
	  polar: function (oldPoint, newPoint, axisModel, controller, coordInfo) {
	    var axis = axisModel.axis;
	    var ret = {};
	    var polar = coordInfo.model.coordinateSystem;
	    var radiusExtent = polar.getRadiusAxis().getExtent();
	    var angleExtent = polar.getAngleAxis().getExtent();
	    oldPoint = oldPoint ? polar.pointToCoord(oldPoint) : [0, 0];
	    newPoint = polar.pointToCoord(newPoint);
	
	    if (axisModel.mainType === 'radiusAxis') {
	      ret.pixel = newPoint[0] - oldPoint[0]; // ret.pixelLength = Math.abs(radiusExtent[1] - radiusExtent[0]);
	      // ret.pixelStart = Math.min(radiusExtent[0], radiusExtent[1]);
	
	      ret.pixelLength = radiusExtent[1] - radiusExtent[0];
	      ret.pixelStart = radiusExtent[0];
	      ret.signal = axis.inverse ? 1 : -1;
	    } else {
	      // 'angleAxis'
	      ret.pixel = newPoint[1] - oldPoint[1]; // ret.pixelLength = Math.abs(angleExtent[1] - angleExtent[0]);
	      // ret.pixelStart = Math.min(angleExtent[0], angleExtent[1]);
	
	      ret.pixelLength = angleExtent[1] - angleExtent[0];
	      ret.pixelStart = angleExtent[0];
	      ret.signal = axis.inverse ? -1 : 1;
	    }
	
	    return ret;
	  },
	  singleAxis: function (oldPoint, newPoint, axisModel, controller, coordInfo) {
	    var axis = axisModel.axis;
	    var rect = coordInfo.model.coordinateSystem.getRect();
	    var ret = {};
	    oldPoint = oldPoint || [0, 0];
	
	    if (axis.orient === 'horizontal') {
	      ret.pixel = newPoint[0] - oldPoint[0];
	      ret.pixelLength = rect.width;
	      ret.pixelStart = rect.x;
	      ret.signal = axis.inverse ? 1 : -1;
	    } else {
	      // 'vertical'
	      ret.pixel = newPoint[1] - oldPoint[1];
	      ret.pixelLength = rect.height;
	      ret.pixelStart = rect.y;
	      ret.signal = axis.inverse ? -1 : 1;
	    }
	
	    return ret;
	  }
	};
	var _default = InsideZoomView;
	module.exports = _default;

/***/ },
/* 1592 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var DataZoomModel = __webpack_require__(203);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = DataZoomModel.extend({
	  type: 'dataZoom.select'
	});
	
	module.exports = _default;

/***/ },
/* 1593 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var DataZoomView = __webpack_require__(204);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = DataZoomView.extend({
	  type: 'dataZoom.select'
	});
	
	module.exports = _default;

/***/ },
/* 1594 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var DataZoomModel = __webpack_require__(203);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var SliderZoomModel = DataZoomModel.extend({
	  type: 'dataZoom.slider',
	  layoutMode: 'box',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    show: true,
	    // ph => placeholder. Using placehoder here because
	    // deault value can only be drived in view stage.
	    right: 'ph',
	    // Default align to grid rect.
	    top: 'ph',
	    // Default align to grid rect.
	    width: 'ph',
	    // Default align to grid rect.
	    height: 'ph',
	    // Default align to grid rect.
	    left: null,
	    // Default align to grid rect.
	    bottom: null,
	    // Default align to grid rect.
	    backgroundColor: 'rgba(47,69,84,0)',
	    // Background of slider zoom component.
	    // dataBackgroundColor: '#ddd',         // Background coor of data shadow and border of box,
	    // highest priority, remain for compatibility of
	    // previous version, but not recommended any more.
	    dataBackground: {
	      lineStyle: {
	        color: '#2f4554',
	        width: 0.5,
	        opacity: 0.3
	      },
	      areaStyle: {
	        color: 'rgba(47,69,84,0.3)',
	        opacity: 0.3
	      }
	    },
	    borderColor: '#ddd',
	    // border color of the box. For compatibility,
	    // if dataBackgroundColor is set, borderColor
	    // is ignored.
	    fillerColor: 'rgba(167,183,204,0.4)',
	    // Color of selected area.
	    // handleColor: 'rgba(89,170,216,0.95)',     // Color of handle.
	    // handleIcon: 'path://M4.9,17.8c0-1.4,4.5-10.5,5.5-12.4c0-0.1,0.6-1.1,0.9-1.1c0.4,0,0.9,1,0.9,1.1c1.1,2.2,5.4,11,5.4,12.4v17.8c0,1.5-0.6,2.1-1.3,2.1H6.1c-0.7,0-1.3-0.6-1.3-2.1V17.8z',
	
	    /* eslint-disable */
	    handleIcon: 'M8.2,13.6V3.9H6.3v9.7H3.1v14.9h3.3v9.7h1.8v-9.7h3.3V13.6H8.2z M9.7,24.4H4.8v-1.4h4.9V24.4z M9.7,19.1H4.8v-1.4h4.9V19.1z',
	
	    /* eslint-enable */
	    // Percent of the slider height
	    handleSize: '100%',
	    handleStyle: {
	      color: '#a7b7cc'
	    },
	    labelPrecision: null,
	    labelFormatter: null,
	    showDetail: true,
	    showDataShadow: 'auto',
	    // Default auto decision.
	    realtime: true,
	    zoomLock: false,
	    // Whether disable zoom.
	    textStyle: {
	      color: '#333'
	    }
	  }
	});
	var _default = SliderZoomModel;
	module.exports = _default;

/***/ },
/* 1595 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var eventTool = __webpack_require__(113);
	
	var graphic = __webpack_require__(16);
	
	var throttle = __webpack_require__(142);
	
	var DataZoomView = __webpack_require__(204);
	
	var numberUtil = __webpack_require__(20);
	
	var layout = __webpack_require__(36);
	
	var sliderMove = __webpack_require__(205);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var Rect = graphic.Rect;
	var linearMap = numberUtil.linearMap;
	var asc = numberUtil.asc;
	var bind = zrUtil.bind;
	var each = zrUtil.each; // Constants
	
	var DEFAULT_LOCATION_EDGE_GAP = 7;
	var DEFAULT_FRAME_BORDER_WIDTH = 1;
	var DEFAULT_FILLER_SIZE = 30;
	var HORIZONTAL = 'horizontal';
	var VERTICAL = 'vertical';
	var LABEL_GAP = 5;
	var SHOW_DATA_SHADOW_SERIES_TYPE = ['line', 'bar', 'candlestick', 'scatter'];
	var SliderZoomView = DataZoomView.extend({
	  type: 'dataZoom.slider',
	  init: function (ecModel, api) {
	    /**
	     * @private
	     * @type {Object}
	     */
	    this._displayables = {};
	    /**
	     * @private
	     * @type {string}
	     */
	
	    this._orient;
	    /**
	     * [0, 100]
	     * @private
	     */
	
	    this._range;
	    /**
	     * [coord of the first handle, coord of the second handle]
	     * @private
	     */
	
	    this._handleEnds;
	    /**
	     * [length, thick]
	     * @private
	     * @type {Array.<number>}
	     */
	
	    this._size;
	    /**
	     * @private
	     * @type {number}
	     */
	
	    this._handleWidth;
	    /**
	     * @private
	     * @type {number}
	     */
	
	    this._handleHeight;
	    /**
	     * @private
	     */
	
	    this._location;
	    /**
	     * @private
	     */
	
	    this._dragging;
	    /**
	     * @private
	     */
	
	    this._dataShadowInfo;
	    this.api = api;
	  },
	
	  /**
	   * @override
	   */
	  render: function (dataZoomModel, ecModel, api, payload) {
	    SliderZoomView.superApply(this, 'render', arguments);
	    throttle.createOrUpdate(this, '_dispatchZoomAction', this.dataZoomModel.get('throttle'), 'fixRate');
	    this._orient = dataZoomModel.get('orient');
	
	    if (this.dataZoomModel.get('show') === false) {
	      this.group.removeAll();
	      return;
	    } // Notice: this._resetInterval() should not be executed when payload.type
	    // is 'dataZoom', origin this._range should be maintained, otherwise 'pan'
	    // or 'zoom' info will be missed because of 'throttle' of this.dispatchAction,
	
	
	    if (!payload || payload.type !== 'dataZoom' || payload.from !== this.uid) {
	      this._buildView();
	    }
	
	    this._updateView();
	  },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    SliderZoomView.superApply(this, 'remove', arguments);
	    throttle.clear(this, '_dispatchZoomAction');
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    SliderZoomView.superApply(this, 'dispose', arguments);
	    throttle.clear(this, '_dispatchZoomAction');
	  },
	  _buildView: function () {
	    var thisGroup = this.group;
	    thisGroup.removeAll();
	
	    this._resetLocation();
	
	    this._resetInterval();
	
	    var barGroup = this._displayables.barGroup = new graphic.Group();
	
	    this._renderBackground();
	
	    this._renderHandle();
	
	    this._renderDataShadow();
	
	    thisGroup.add(barGroup);
	
	    this._positionGroup();
	  },
	
	  /**
	   * @private
	   */
	  _resetLocation: function () {
	    var dataZoomModel = this.dataZoomModel;
	    var api = this.api; // If some of x/y/width/height are not specified,
	    // auto-adapt according to target grid.
	
	    var coordRect = this._findCoordRect();
	
	    var ecSize = {
	      width: api.getWidth(),
	      height: api.getHeight()
	    }; // Default align by coordinate system rect.
	
	    var positionInfo = this._orient === HORIZONTAL ? {
	      // Why using 'right', because right should be used in vertical,
	      // and it is better to be consistent for dealing with position param merge.
	      right: ecSize.width - coordRect.x - coordRect.width,
	      top: ecSize.height - DEFAULT_FILLER_SIZE - DEFAULT_LOCATION_EDGE_GAP,
	      width: coordRect.width,
	      height: DEFAULT_FILLER_SIZE
	    } : {
	      // vertical
	      right: DEFAULT_LOCATION_EDGE_GAP,
	      top: coordRect.y,
	      width: DEFAULT_FILLER_SIZE,
	      height: coordRect.height
	    }; // Do not write back to option and replace value 'ph', because
	    // the 'ph' value should be recalculated when resize.
	
	    var layoutParams = layout.getLayoutParams(dataZoomModel.option); // Replace the placeholder value.
	
	    zrUtil.each(['right', 'top', 'width', 'height'], function (name) {
	      if (layoutParams[name] === 'ph') {
	        layoutParams[name] = positionInfo[name];
	      }
	    });
	    var layoutRect = layout.getLayoutRect(layoutParams, ecSize, dataZoomModel.padding);
	    this._location = {
	      x: layoutRect.x,
	      y: layoutRect.y
	    };
	    this._size = [layoutRect.width, layoutRect.height];
	    this._orient === VERTICAL && this._size.reverse();
	  },
	
	  /**
	   * @private
	   */
	  _positionGroup: function () {
	    var thisGroup = this.group;
	    var location = this._location;
	    var orient = this._orient; // Just use the first axis to determine mapping.
	
	    var targetAxisModel = this.dataZoomModel.getFirstTargetAxisModel();
	    var inverse = targetAxisModel && targetAxisModel.get('inverse');
	    var barGroup = this._displayables.barGroup;
	    var otherAxisInverse = (this._dataShadowInfo || {}).otherAxisInverse; // Transform barGroup.
	
	    barGroup.attr(orient === HORIZONTAL && !inverse ? {
	      scale: otherAxisInverse ? [1, 1] : [1, -1]
	    } : orient === HORIZONTAL && inverse ? {
	      scale: otherAxisInverse ? [-1, 1] : [-1, -1]
	    } : orient === VERTICAL && !inverse ? {
	      scale: otherAxisInverse ? [1, -1] : [1, 1],
	      rotation: Math.PI / 2 // Dont use Math.PI, considering shadow direction.
	
	    } : {
	      scale: otherAxisInverse ? [-1, -1] : [-1, 1],
	      rotation: Math.PI / 2
	    }); // Position barGroup
	
	    var rect = thisGroup.getBoundingRect([barGroup]);
	    thisGroup.attr('position', [location.x - rect.x, location.y - rect.y]);
	  },
	
	  /**
	   * @private
	   */
	  _getViewExtent: function () {
	    return [0, this._size[0]];
	  },
	  _renderBackground: function () {
	    var dataZoomModel = this.dataZoomModel;
	    var size = this._size;
	    var barGroup = this._displayables.barGroup;
	    barGroup.add(new Rect({
	      silent: true,
	      shape: {
	        x: 0,
	        y: 0,
	        width: size[0],
	        height: size[1]
	      },
	      style: {
	        fill: dataZoomModel.get('backgroundColor')
	      },
	      z2: -40
	    })); // Click panel, over shadow, below handles.
	
	    barGroup.add(new Rect({
	      shape: {
	        x: 0,
	        y: 0,
	        width: size[0],
	        height: size[1]
	      },
	      style: {
	        fill: 'transparent'
	      },
	      z2: 0,
	      onclick: zrUtil.bind(this._onClickPanelClick, this)
	    }));
	  },
	  _renderDataShadow: function () {
	    var info = this._dataShadowInfo = this._prepareDataShadowInfo();
	
	    if (!info) {
	      return;
	    }
	
	    var size = this._size;
	    var seriesModel = info.series;
	    var data = seriesModel.getRawData();
	    var otherDim = seriesModel.getShadowDim ? seriesModel.getShadowDim() // @see candlestick
	    : info.otherDim;
	
	    if (otherDim == null) {
	      return;
	    }
	
	    var otherDataExtent = data.getDataExtent(otherDim); // Nice extent.
	
	    var otherOffset = (otherDataExtent[1] - otherDataExtent[0]) * 0.3;
	    otherDataExtent = [otherDataExtent[0] - otherOffset, otherDataExtent[1] + otherOffset];
	    var otherShadowExtent = [0, size[1]];
	    var thisShadowExtent = [0, size[0]];
	    var areaPoints = [[size[0], 0], [0, 0]];
	    var linePoints = [];
	    var step = thisShadowExtent[1] / (data.count() - 1);
	    var thisCoord = 0; // Optimize for large data shadow
	
	    var stride = Math.round(data.count() / size[0]);
	    var lastIsEmpty;
	    data.each([otherDim], function (value, index) {
	      if (stride > 0 && index % stride) {
	        thisCoord += step;
	        return;
	      } // FIXME
	      // Should consider axis.min/axis.max when drawing dataShadow.
	      // FIXME
	      // 应该使用统一的空判断？还是在list里进行空判断？
	
	
	      var isEmpty = value == null || isNaN(value) || value === ''; // See #4235.
	
	      var otherCoord = isEmpty ? 0 : linearMap(value, otherDataExtent, otherShadowExtent, true); // Attempt to draw data shadow precisely when there are empty value.
	
	      if (isEmpty && !lastIsEmpty && index) {
	        areaPoints.push([areaPoints[areaPoints.length - 1][0], 0]);
	        linePoints.push([linePoints[linePoints.length - 1][0], 0]);
	      } else if (!isEmpty && lastIsEmpty) {
	        areaPoints.push([thisCoord, 0]);
	        linePoints.push([thisCoord, 0]);
	      }
	
	      areaPoints.push([thisCoord, otherCoord]);
	      linePoints.push([thisCoord, otherCoord]);
	      thisCoord += step;
	      lastIsEmpty = isEmpty;
	    });
	    var dataZoomModel = this.dataZoomModel; // var dataBackgroundModel = dataZoomModel.getModel('dataBackground');
	
	    this._displayables.barGroup.add(new graphic.Polygon({
	      shape: {
	        points: areaPoints
	      },
	      style: zrUtil.defaults({
	        fill: dataZoomModel.get('dataBackgroundColor')
	      }, dataZoomModel.getModel('dataBackground.areaStyle').getAreaStyle()),
	      silent: true,
	      z2: -20
	    }));
	
	    this._displayables.barGroup.add(new graphic.Polyline({
	      shape: {
	        points: linePoints
	      },
	      style: dataZoomModel.getModel('dataBackground.lineStyle').getLineStyle(),
	      silent: true,
	      z2: -19
	    }));
	  },
	  _prepareDataShadowInfo: function () {
	    var dataZoomModel = this.dataZoomModel;
	    var showDataShadow = dataZoomModel.get('showDataShadow');
	
	    if (showDataShadow === false) {
	      return;
	    } // Find a representative series.
	
	
	    var result;
	    var ecModel = this.ecModel;
	    dataZoomModel.eachTargetAxis(function (dimNames, axisIndex) {
	      var seriesModels = dataZoomModel.getAxisProxy(dimNames.name, axisIndex).getTargetSeriesModels();
	      zrUtil.each(seriesModels, function (seriesModel) {
	        if (result) {
	          return;
	        }
	
	        if (showDataShadow !== true && zrUtil.indexOf(SHOW_DATA_SHADOW_SERIES_TYPE, seriesModel.get('type')) < 0) {
	          return;
	        }
	
	        var thisAxis = ecModel.getComponent(dimNames.axis, axisIndex).axis;
	        var otherDim = getOtherDim(dimNames.name);
	        var otherAxisInverse;
	        var coordSys = seriesModel.coordinateSystem;
	
	        if (otherDim != null && coordSys.getOtherAxis) {
	          otherAxisInverse = coordSys.getOtherAxis(thisAxis).inverse;
	        }
	
	        otherDim = seriesModel.getData().mapDimension(otherDim);
	        result = {
	          thisAxis: thisAxis,
	          series: seriesModel,
	          thisDim: dimNames.name,
	          otherDim: otherDim,
	          otherAxisInverse: otherAxisInverse
	        };
	      }, this);
	    }, this);
	    return result;
	  },
	  _renderHandle: function () {
	    var displaybles = this._displayables;
	    var handles = displaybles.handles = [];
	    var handleLabels = displaybles.handleLabels = [];
	    var barGroup = this._displayables.barGroup;
	    var size = this._size;
	    var dataZoomModel = this.dataZoomModel;
	    barGroup.add(displaybles.filler = new Rect({
	      draggable: true,
	      cursor: getCursor(this._orient),
	      drift: bind(this._onDragMove, this, 'all'),
	      ondragstart: bind(this._showDataInfo, this, true),
	      ondragend: bind(this._onDragEnd, this),
	      onmouseover: bind(this._showDataInfo, this, true),
	      onmouseout: bind(this._showDataInfo, this, false),
	      style: {
	        fill: dataZoomModel.get('fillerColor'),
	        textPosition: 'inside'
	      }
	    })); // Frame border.
	
	    barGroup.add(new Rect({
	      silent: true,
	      subPixelOptimize: true,
	      shape: {
	        x: 0,
	        y: 0,
	        width: size[0],
	        height: size[1]
	      },
	      style: {
	        stroke: dataZoomModel.get('dataBackgroundColor') || dataZoomModel.get('borderColor'),
	        lineWidth: DEFAULT_FRAME_BORDER_WIDTH,
	        fill: 'rgba(0,0,0,0)'
	      }
	    }));
	    each([0, 1], function (handleIndex) {
	      var path = graphic.createIcon(dataZoomModel.get('handleIcon'), {
	        cursor: getCursor(this._orient),
	        draggable: true,
	        drift: bind(this._onDragMove, this, handleIndex),
	        ondragend: bind(this._onDragEnd, this),
	        onmouseover: bind(this._showDataInfo, this, true),
	        onmouseout: bind(this._showDataInfo, this, false)
	      }, {
	        x: -1,
	        y: 0,
	        width: 2,
	        height: 2
	      });
	      var bRect = path.getBoundingRect();
	      this._handleHeight = numberUtil.parsePercent(dataZoomModel.get('handleSize'), this._size[1]);
	      this._handleWidth = bRect.width / bRect.height * this._handleHeight;
	      path.setStyle(dataZoomModel.getModel('handleStyle').getItemStyle());
	      var handleColor = dataZoomModel.get('handleColor'); // Compatitable with previous version
	
	      if (handleColor != null) {
	        path.style.fill = handleColor;
	      }
	
	      barGroup.add(handles[handleIndex] = path);
	      var textStyleModel = dataZoomModel.textStyleModel;
	      this.group.add(handleLabels[handleIndex] = new graphic.Text({
	        silent: true,
	        invisible: true,
	        style: {
	          x: 0,
	          y: 0,
	          text: '',
	          textVerticalAlign: 'middle',
	          textAlign: 'center',
	          textFill: textStyleModel.getTextColor(),
	          textFont: textStyleModel.getFont()
	        },
	        z2: 10
	      }));
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _resetInterval: function () {
	    var range = this._range = this.dataZoomModel.getPercentRange();
	
	    var viewExtent = this._getViewExtent();
	
	    this._handleEnds = [linearMap(range[0], [0, 100], viewExtent, true), linearMap(range[1], [0, 100], viewExtent, true)];
	  },
	
	  /**
	   * @private
	   * @param {(number|string)} handleIndex 0 or 1 or 'all'
	   * @param {number} delta
	   * @return {boolean} changed
	   */
	  _updateInterval: function (handleIndex, delta) {
	    var dataZoomModel = this.dataZoomModel;
	    var handleEnds = this._handleEnds;
	
	    var viewExtend = this._getViewExtent();
	
	    var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
	    var percentExtent = [0, 100];
	    sliderMove(delta, handleEnds, viewExtend, dataZoomModel.get('zoomLock') ? 'all' : handleIndex, minMaxSpan.minSpan != null ? linearMap(minMaxSpan.minSpan, percentExtent, viewExtend, true) : null, minMaxSpan.maxSpan != null ? linearMap(minMaxSpan.maxSpan, percentExtent, viewExtend, true) : null);
	    var lastRange = this._range;
	    var range = this._range = asc([linearMap(handleEnds[0], viewExtend, percentExtent, true), linearMap(handleEnds[1], viewExtend, percentExtent, true)]);
	    return !lastRange || lastRange[0] !== range[0] || lastRange[1] !== range[1];
	  },
	
	  /**
	   * @private
	   */
	  _updateView: function (nonRealtime) {
	    var displaybles = this._displayables;
	    var handleEnds = this._handleEnds;
	    var handleInterval = asc(handleEnds.slice());
	    var size = this._size;
	    each([0, 1], function (handleIndex) {
	      // Handles
	      var handle = displaybles.handles[handleIndex];
	      var handleHeight = this._handleHeight;
	      handle.attr({
	        scale: [handleHeight / 2, handleHeight / 2],
	        position: [handleEnds[handleIndex], size[1] / 2 - handleHeight / 2]
	      });
	    }, this); // Filler
	
	    displaybles.filler.setShape({
	      x: handleInterval[0],
	      y: 0,
	      width: handleInterval[1] - handleInterval[0],
	      height: size[1]
	    });
	
	    this._updateDataInfo(nonRealtime);
	  },
	
	  /**
	   * @private
	   */
	  _updateDataInfo: function (nonRealtime) {
	    var dataZoomModel = this.dataZoomModel;
	    var displaybles = this._displayables;
	    var handleLabels = displaybles.handleLabels;
	    var orient = this._orient;
	    var labelTexts = ['', '']; // FIXME
	    // date型，支持formatter，autoformatter（ec2 date.getAutoFormatter）
	
	    if (dataZoomModel.get('showDetail')) {
	      var axisProxy = dataZoomModel.findRepresentativeAxisProxy();
	
	      if (axisProxy) {
	        var axis = axisProxy.getAxisModel().axis;
	        var range = this._range;
	        var dataInterval = nonRealtime // See #4434, data and axis are not processed and reset yet in non-realtime mode.
	        ? axisProxy.calculateDataWindow({
	          start: range[0],
	          end: range[1]
	        }).valueWindow : axisProxy.getDataValueWindow();
	        labelTexts = [this._formatLabel(dataInterval[0], axis), this._formatLabel(dataInterval[1], axis)];
	      }
	    }
	
	    var orderedHandleEnds = asc(this._handleEnds.slice());
	    setLabel.call(this, 0);
	    setLabel.call(this, 1);
	
	    function setLabel(handleIndex) {
	      // Label
	      // Text should not transform by barGroup.
	      // Ignore handlers transform
	      var barTransform = graphic.getTransform(displaybles.handles[handleIndex].parent, this.group);
	      var direction = graphic.transformDirection(handleIndex === 0 ? 'right' : 'left', barTransform);
	      var offset = this._handleWidth / 2 + LABEL_GAP;
	      var textPoint = graphic.applyTransform([orderedHandleEnds[handleIndex] + (handleIndex === 0 ? -offset : offset), this._size[1] / 2], barTransform);
	      handleLabels[handleIndex].setStyle({
	        x: textPoint[0],
	        y: textPoint[1],
	        textVerticalAlign: orient === HORIZONTAL ? 'middle' : direction,
	        textAlign: orient === HORIZONTAL ? direction : 'center',
	        text: labelTexts[handleIndex]
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _formatLabel: function (value, axis) {
	    var dataZoomModel = this.dataZoomModel;
	    var labelFormatter = dataZoomModel.get('labelFormatter');
	    var labelPrecision = dataZoomModel.get('labelPrecision');
	
	    if (labelPrecision == null || labelPrecision === 'auto') {
	      labelPrecision = axis.getPixelPrecision();
	    }
	
	    var valueStr = value == null || isNaN(value) ? '' // FIXME Glue code
	    : axis.type === 'category' || axis.type === 'time' ? axis.scale.getLabel(Math.round(value)) // param of toFixed should less then 20.
	    : value.toFixed(Math.min(labelPrecision, 20));
	    return zrUtil.isFunction(labelFormatter) ? labelFormatter(value, valueStr) : zrUtil.isString(labelFormatter) ? labelFormatter.replace('{value}', valueStr) : valueStr;
	  },
	
	  /**
	   * @private
	   * @param {boolean} showOrHide true: show, false: hide
	   */
	  _showDataInfo: function (showOrHide) {
	    // Always show when drgging.
	    showOrHide = this._dragging || showOrHide;
	    var handleLabels = this._displayables.handleLabels;
	    handleLabels[0].attr('invisible', !showOrHide);
	    handleLabels[1].attr('invisible', !showOrHide);
	  },
	  _onDragMove: function (handleIndex, dx, dy, event) {
	    this._dragging = true; // For mobile device, prevent screen slider on the button.
	
	    eventTool.stop(event.event); // Transform dx, dy to bar coordination.
	
	    var barTransform = this._displayables.barGroup.getLocalTransform();
	
	    var vertex = graphic.applyTransform([dx, dy], barTransform, true);
	
	    var changed = this._updateInterval(handleIndex, vertex[0]);
	
	    var realtime = this.dataZoomModel.get('realtime');
	
	    this._updateView(!realtime); // Avoid dispatch dataZoom repeatly but range not changed,
	    // which cause bad visual effect when progressive enabled.
	
	
	    changed && realtime && this._dispatchZoomAction();
	  },
	  _onDragEnd: function () {
	    this._dragging = false;
	
	    this._showDataInfo(false); // While in realtime mode and stream mode, dispatch action when
	    // drag end will cause the whole view rerender, which is unnecessary.
	
	
	    var realtime = this.dataZoomModel.get('realtime');
	    !realtime && this._dispatchZoomAction();
	  },
	  _onClickPanelClick: function (e) {
	    var size = this._size;
	
	    var localPoint = this._displayables.barGroup.transformCoordToLocal(e.offsetX, e.offsetY);
	
	    if (localPoint[0] < 0 || localPoint[0] > size[0] || localPoint[1] < 0 || localPoint[1] > size[1]) {
	      return;
	    }
	
	    var handleEnds = this._handleEnds;
	    var center = (handleEnds[0] + handleEnds[1]) / 2;
	
	    var changed = this._updateInterval('all', localPoint[0] - center);
	
	    this._updateView();
	
	    changed && this._dispatchZoomAction();
	  },
	
	  /**
	   * This action will be throttled.
	   * @private
	   */
	  _dispatchZoomAction: function () {
	    var range = this._range;
	    this.api.dispatchAction({
	      type: 'dataZoom',
	      from: this.uid,
	      dataZoomId: this.dataZoomModel.id,
	      start: range[0],
	      end: range[1]
	    });
	  },
	
	  /**
	   * @private
	   */
	  _findCoordRect: function () {
	    // Find the grid coresponding to the first axis referred by dataZoom.
	    var rect;
	    each(this.getTargetCoordInfo(), function (coordInfoList) {
	      if (!rect && coordInfoList.length) {
	        var coordSys = coordInfoList[0].model.coordinateSystem;
	        rect = coordSys.getRect && coordSys.getRect();
	      }
	    });
	
	    if (!rect) {
	      var width = this.api.getWidth();
	      var height = this.api.getHeight();
	      rect = {
	        x: width * 0.2,
	        y: height * 0.2,
	        width: width * 0.6,
	        height: height * 0.6
	      };
	    }
	
	    return rect;
	  }
	});
	
	function getOtherDim(thisDim) {
	  // FIXME
	  // 这个逻辑和getOtherAxis里一致，但是写在这里是否不好
	  var map = {
	    x: 'y',
	    y: 'x',
	    radius: 'angle',
	    angle: 'radius'
	  };
	  return map[thisDim];
	}
	
	function getCursor(orient) {
	  return orient === 'vertical' ? 'ns-resize' : 'ew-resize';
	}
	
	var _default = SliderZoomView;
	module.exports = _default;

/***/ },
/* 1596 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var RoamController = __webpack_require__(262);
	
	var throttleUtil = __webpack_require__(142);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Only create one roam controller for each coordinate system.
	// one roam controller might be refered by two inside data zoom
	// components (for example, one for x and one for y). When user
	// pan or zoom, only dispatch one action for those data zoom
	// components.
	var ATTR = '\0_ec_dataZoom_roams';
	/**
	 * @public
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {Object} dataZoomInfo
	 * @param {string} dataZoomInfo.coordId
	 * @param {Function} dataZoomInfo.containsPoint
	 * @param {Array.<string>} dataZoomInfo.allCoordIds
	 * @param {string} dataZoomInfo.dataZoomId
	 * @param {Object} dataZoomInfo.getRange
	 * @param {Function} dataZoomInfo.getRange.pan
	 * @param {Function} dataZoomInfo.getRange.zoom
	 * @param {Function} dataZoomInfo.getRange.scrollMove
	 * @param {boolean} dataZoomInfo.dataZoomModel
	 */
	
	function register(api, dataZoomInfo) {
	  var store = giveStore(api);
	  var theDataZoomId = dataZoomInfo.dataZoomId;
	  var theCoordId = dataZoomInfo.coordId; // Do clean when a dataZoom changes its target coordnate system.
	  // Avoid memory leak, dispose all not-used-registered.
	
	  zrUtil.each(store, function (record, coordId) {
	    var dataZoomInfos = record.dataZoomInfos;
	
	    if (dataZoomInfos[theDataZoomId] && zrUtil.indexOf(dataZoomInfo.allCoordIds, theCoordId) < 0) {
	      delete dataZoomInfos[theDataZoomId];
	      record.count--;
	    }
	  });
	  cleanStore(store);
	  var record = store[theCoordId]; // Create if needed.
	
	  if (!record) {
	    record = store[theCoordId] = {
	      coordId: theCoordId,
	      dataZoomInfos: {},
	      count: 0
	    };
	    record.controller = createController(api, record);
	    record.dispatchAction = zrUtil.curry(dispatchAction, api);
	  } // Update reference of dataZoom.
	
	
	  !record.dataZoomInfos[theDataZoomId] && record.count++;
	  record.dataZoomInfos[theDataZoomId] = dataZoomInfo;
	  var controllerParams = mergeControllerParams(record.dataZoomInfos);
	  record.controller.enable(controllerParams.controlType, controllerParams.opt); // Consider resize, area should be always updated.
	
	  record.controller.setPointerChecker(dataZoomInfo.containsPoint); // Update throttle.
	
	  throttleUtil.createOrUpdate(record, 'dispatchAction', dataZoomInfo.dataZoomModel.get('throttle', true), 'fixRate');
	}
	/**
	 * @public
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {string} dataZoomId
	 */
	
	
	function unregister(api, dataZoomId) {
	  var store = giveStore(api);
	  zrUtil.each(store, function (record) {
	    record.controller.dispose();
	    var dataZoomInfos = record.dataZoomInfos;
	
	    if (dataZoomInfos[dataZoomId]) {
	      delete dataZoomInfos[dataZoomId];
	      record.count--;
	    }
	  });
	  cleanStore(store);
	}
	/**
	 * @public
	 */
	
	
	function generateCoordId(coordModel) {
	  return coordModel.type + '\0_' + coordModel.id;
	}
	/**
	 * Key: coordId, value: {dataZoomInfos: [], count, controller}
	 * @type {Array.<Object>}
	 */
	
	
	function giveStore(api) {
	  // Mount store on zrender instance, so that we do not
	  // need to worry about dispose.
	  var zr = api.getZr();
	  return zr[ATTR] || (zr[ATTR] = {});
	}
	
	function createController(api, newRecord) {
	  var controller = new RoamController(api.getZr());
	  zrUtil.each(['pan', 'zoom', 'scrollMove'], function (eventName) {
	    controller.on(eventName, function (event) {
	      var batch = [];
	      zrUtil.each(newRecord.dataZoomInfos, function (info) {
	        // Check whether the behaviors (zoomOnMouseWheel, moveOnMouseMove,
	        // moveOnMouseWheel, ...) enabled.
	        if (!event.isAvailableBehavior(info.dataZoomModel.option)) {
	          return;
	        }
	
	        var method = (info.getRange || {})[eventName];
	        var range = method && method(newRecord.controller, event);
	        !info.dataZoomModel.get('disabled', true) && range && batch.push({
	          dataZoomId: info.dataZoomId,
	          start: range[0],
	          end: range[1]
	        });
	      });
	      batch.length && newRecord.dispatchAction(batch);
	    });
	  });
	  return controller;
	}
	
	function cleanStore(store) {
	  zrUtil.each(store, function (record, coordId) {
	    if (!record.count) {
	      record.controller.dispose();
	      delete store[coordId];
	    }
	  });
	}
	/**
	 * This action will be throttled.
	 */
	
	
	function dispatchAction(api, batch) {
	  api.dispatchAction({
	    type: 'dataZoom',
	    batch: batch
	  });
	}
	/**
	 * Merge roamController settings when multiple dataZooms share one roamController.
	 */
	
	
	function mergeControllerParams(dataZoomInfos) {
	  var controlType; // DO NOT use reserved word (true, false, undefined) as key literally. Even if encapsulated
	  // as string, it is probably revert to reserved word by compress tool. See #7411.
	
	  var prefix = 'type_';
	  var typePriority = {
	    'type_true': 2,
	    'type_move': 1,
	    'type_false': 0,
	    'type_undefined': -1
	  };
	  var preventDefaultMouseMove = true;
	  zrUtil.each(dataZoomInfos, function (dataZoomInfo) {
	    var dataZoomModel = dataZoomInfo.dataZoomModel;
	    var oneType = dataZoomModel.get('disabled', true) ? false : dataZoomModel.get('zoomLock', true) ? 'move' : true;
	
	    if (typePriority[prefix + oneType] > typePriority[prefix + controlType]) {
	      controlType = oneType;
	    } // Prevent default move event by default. If one false, do not prevent. Otherwise
	    // users may be confused why it does not work when multiple insideZooms exist.
	
	
	    preventDefaultMouseMove &= dataZoomModel.get('preventDefaultMouseMove', true);
	  });
	  return {
	    controlType: controlType,
	    opt: {
	      // RoamController will enable all of these functionalities,
	      // and the final behavior is determined by its event listener
	      // provided by each inside zoom.
	      zoomOnMouseWheel: true,
	      moveOnMouseMove: true,
	      moveOnMouseWheel: true,
	      preventDefaultMouseMove: !!preventDefaultMouseMove
	    }
	  };
	}
	
	exports.register = register;
	exports.unregister = unregister;
	exports.generateCoordId = generateCoordId;

/***/ },
/* 1597 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(462);
	
	__webpack_require__(203);
	
	__webpack_require__(204);
	
	__webpack_require__(1592);
	
	__webpack_require__(1593);
	
	__webpack_require__(460);
	
	__webpack_require__(459);

/***/ },
/* 1598 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	__webpack_require__(1661);
	
	__webpack_require__(471);
	
	__webpack_require__(1599);
	
	__webpack_require__(695);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function makeAction(method, actionInfo) {
	  actionInfo.update = 'updateView';
	  echarts.registerAction(actionInfo, function (payload, ecModel) {
	    var selected = {};
	    ecModel.eachComponent({
	      mainType: 'geo',
	      query: payload
	    }, function (geoModel) {
	      geoModel[method](payload.name);
	      var geo = geoModel.coordinateSystem;
	      zrUtil.each(geo.regions, function (region) {
	        selected[region.name] = geoModel.isSelected(region.name) || false;
	      });
	    });
	    return {
	      selected: selected,
	      name: payload.name
	    };
	  });
	}
	
	makeAction('toggleSelected', {
	  type: 'geoToggleSelect',
	  event: 'geoselectchanged'
	});
	makeAction('select', {
	  type: 'geoSelect',
	  event: 'geoselected'
	});
	makeAction('unSelect', {
	  type: 'geoUnSelect',
	  event: 'geounselected'
	});

/***/ },
/* 1599 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var MapDraw = __webpack_require__(719);
	
	var echarts = __webpack_require__(13);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentView({
	  type: 'geo',
	  init: function (ecModel, api) {
	    var mapDraw = new MapDraw(api, true);
	    this._mapDraw = mapDraw;
	    this.group.add(mapDraw.group);
	  },
	  render: function (geoModel, ecModel, api, payload) {
	    // Not render if it is an toggleSelect action from self
	    if (payload && payload.type === 'geoToggleSelect' && payload.from === this.uid) {
	      return;
	    }
	
	    var mapDraw = this._mapDraw;
	
	    if (geoModel.get('show')) {
	      mapDraw.draw(geoModel, ecModel, api, this, payload);
	    } else {
	      this._mapDraw.group.removeAll();
	    }
	
	    this.group.silent = geoModel.get('silent');
	  },
	  dispose: function () {
	    this._mapDraw && this._mapDraw.remove();
	  }
	});
	
	module.exports = _default;

/***/ },
/* 1600 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var modelUtil = __webpack_require__(24);
	
	var graphicUtil = __webpack_require__(16);
	
	var layoutUtil = __webpack_require__(36);
	
	var _number = __webpack_require__(20);
	
	var parsePercent = _number.parsePercent;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _nonShapeGraphicElements = {
	  // Reserved but not supported in graphic component.
	  path: null,
	  compoundPath: null,
	  // Supported in graphic component.
	  group: graphicUtil.Group,
	  image: graphicUtil.Image,
	  text: graphicUtil.Text
	}; // -------------
	// Preprocessor
	// -------------
	
	echarts.registerPreprocessor(function (option) {
	  var graphicOption = option.graphic; // Convert
	  // {graphic: [{left: 10, type: 'circle'}, ...]}
	  // or
	  // {graphic: {left: 10, type: 'circle'}}
	  // to
	  // {graphic: [{elements: [{left: 10, type: 'circle'}, ...]}]}
	
	  if (zrUtil.isArray(graphicOption)) {
	    if (!graphicOption[0] || !graphicOption[0].elements) {
	      option.graphic = [{
	        elements: graphicOption
	      }];
	    } else {
	      // Only one graphic instance can be instantiated. (We dont
	      // want that too many views are created in echarts._viewMap)
	      option.graphic = [option.graphic[0]];
	    }
	  } else if (graphicOption && !graphicOption.elements) {
	    option.graphic = [{
	      elements: [graphicOption]
	    }];
	  }
	}); // ------
	// Model
	// ------
	
	var GraphicModel = echarts.extendComponentModel({
	  type: 'graphic',
	  defaultOption: {
	    // Extra properties for each elements:
	    //
	    // left/right/top/bottom: (like 12, '22%', 'center', default undefined)
	    //      If left/rigth is set, shape.x/shape.cx/position will not be used.
	    //      If top/bottom is set, shape.y/shape.cy/position will not be used.
	    //      This mechanism is useful when you want to position a group/element
	    //      against the right side or the center of this container.
	    //
	    // width/height: (can only be pixel value, default 0)
	    //      Only be used to specify contianer(group) size, if needed. And
	    //      can not be percentage value (like '33%'). See the reason in the
	    //      layout algorithm below.
	    //
	    // bounding: (enum: 'all' (default) | 'raw')
	    //      Specify how to calculate boundingRect when locating.
	    //      'all': Get uioned and transformed boundingRect
	    //          from both itself and its descendants.
	    //          This mode simplies confining a group of elements in the bounding
	    //          of their ancester container (e.g., using 'right: 0').
	    //      'raw': Only use the boundingRect of itself and before transformed.
	    //          This mode is similar to css behavior, which is useful when you
	    //          want an element to be able to overflow its container. (Consider
	    //          a rotated circle needs to be located in a corner.)
	    // info: custom info. enables user to mount some info on elements and use them
	    //      in event handlers. Update them only when user specified, otherwise, remain.
	    // Note: elements is always behind its ancestors in this elements array.
	    elements: [],
	    parentId: null
	  },
	
	  /**
	   * Save el options for the sake of the performance (only update modified graphics).
	   * The order is the same as those in option. (ancesters -> descendants)
	   *
	   * @private
	   * @type {Array.<Object>}
	   */
	  _elOptionsToUpdate: null,
	
	  /**
	   * @override
	   */
	  mergeOption: function (option) {
	    // Prevent default merge to elements
	    var elements = this.option.elements;
	    this.option.elements = null;
	    GraphicModel.superApply(this, 'mergeOption', arguments);
	    this.option.elements = elements;
	  },
	
	  /**
	   * @override
	   */
	  optionUpdated: function (newOption, isInit) {
	    var thisOption = this.option;
	    var newList = (isInit ? thisOption : newOption).elements;
	    var existList = thisOption.elements = isInit ? [] : thisOption.elements;
	    var flattenedList = [];
	
	    this._flatten(newList, flattenedList);
	
	    var mappingResult = modelUtil.mappingToExists(existList, flattenedList);
	    modelUtil.makeIdAndName(mappingResult); // Clear elOptionsToUpdate
	
	    var elOptionsToUpdate = this._elOptionsToUpdate = [];
	    zrUtil.each(mappingResult, function (resultItem, index) {
	      var newElOption = resultItem.option;
	
	      if (!newElOption) {
	        return;
	      }
	
	      elOptionsToUpdate.push(newElOption);
	      setKeyInfoToNewElOption(resultItem, newElOption);
	      mergeNewElOptionToExist(existList, index, newElOption);
	      setLayoutInfoToExist(existList[index], newElOption);
	    }, this); // Clean
	
	    for (var i = existList.length - 1; i >= 0; i--) {
	      if (existList[i] == null) {
	        existList.splice(i, 1);
	      } else {
	        // $action should be volatile, otherwise option gotten from
	        // `getOption` will contain unexpected $action.
	        delete existList[i].$action;
	      }
	    }
	  },
	
	  /**
	   * Convert
	   * [{
	   *  type: 'group',
	   *  id: 'xx',
	   *  children: [{type: 'circle'}, {type: 'polygon'}]
	   * }]
	   * to
	   * [
	   *  {type: 'group', id: 'xx'},
	   *  {type: 'circle', parentId: 'xx'},
	   *  {type: 'polygon', parentId: 'xx'}
	   * ]
	   *
	   * @private
	   * @param {Array.<Object>} optionList option list
	   * @param {Array.<Object>} result result of flatten
	   * @param {Object} parentOption parent option
	   */
	  _flatten: function (optionList, result, parentOption) {
	    zrUtil.each(optionList, function (option) {
	      if (!option) {
	        return;
	      }
	
	      if (parentOption) {
	        option.parentOption = parentOption;
	      }
	
	      result.push(option);
	      var children = option.children;
	
	      if (option.type === 'group' && children) {
	        this._flatten(children, result, option);
	      } // Deleting for JSON output, and for not affecting group creation.
	
	
	      delete option.children;
	    }, this);
	  },
	  // FIXME
	  // Pass to view using payload? setOption has a payload?
	  useElOptionsToUpdate: function () {
	    var els = this._elOptionsToUpdate; // Clear to avoid render duplicately when zooming.
	
	    this._elOptionsToUpdate = null;
	    return els;
	  }
	}); // -----
	// View
	// -----
	
	echarts.extendComponentView({
	  type: 'graphic',
	
	  /**
	   * @override
	   */
	  init: function (ecModel, api) {
	    /**
	     * @private
	     * @type {module:zrender/core/util.HashMap}
	     */
	    this._elMap = zrUtil.createHashMap();
	    /**
	     * @private
	     * @type {module:echarts/graphic/GraphicModel}
	     */
	
	    this._lastGraphicModel;
	  },
	
	  /**
	   * @override
	   */
	  render: function (graphicModel, ecModel, api) {
	    // Having leveraged between use cases and algorithm complexity, a very
	    // simple layout mechanism is used:
	    // The size(width/height) can be determined by itself or its parent (not
	    // implemented yet), but can not by its children. (Top-down travel)
	    // The location(x/y) can be determined by the bounding rect of itself
	    // (can including its descendants or not) and the size of its parent.
	    // (Bottom-up travel)
	    // When `chart.clear()` or `chart.setOption({...}, true)` with the same id,
	    // view will be reused.
	    if (graphicModel !== this._lastGraphicModel) {
	      this._clear();
	    }
	
	    this._lastGraphicModel = graphicModel;
	
	    this._updateElements(graphicModel);
	
	    this._relocate(graphicModel, api);
	  },
	
	  /**
	   * Update graphic elements.
	   *
	   * @private
	   * @param {Object} graphicModel graphic model
	   */
	  _updateElements: function (graphicModel) {
	    var elOptionsToUpdate = graphicModel.useElOptionsToUpdate();
	
	    if (!elOptionsToUpdate) {
	      return;
	    }
	
	    var elMap = this._elMap;
	    var rootGroup = this.group; // Top-down tranverse to assign graphic settings to each elements.
	
	    zrUtil.each(elOptionsToUpdate, function (elOption) {
	      var $action = elOption.$action;
	      var id = elOption.id;
	      var existEl = elMap.get(id);
	      var parentId = elOption.parentId;
	      var targetElParent = parentId != null ? elMap.get(parentId) : rootGroup;
	      var elOptionStyle = elOption.style;
	
	      if (elOption.type === 'text' && elOptionStyle) {
	        // In top/bottom mode, textVerticalAlign should not be used, which cause
	        // inaccurately locating.
	        if (elOption.hv && elOption.hv[1]) {
	          elOptionStyle.textVerticalAlign = elOptionStyle.textBaseline = null;
	        } // Compatible with previous setting: both support fill and textFill,
	        // stroke and textStroke.
	
	
	        !elOptionStyle.hasOwnProperty('textFill') && elOptionStyle.fill && (elOptionStyle.textFill = elOptionStyle.fill);
	        !elOptionStyle.hasOwnProperty('textStroke') && elOptionStyle.stroke && (elOptionStyle.textStroke = elOptionStyle.stroke);
	      } // Remove unnecessary props to avoid potential problems.
	
	
	      var elOptionCleaned = getCleanedElOption(elOption); // For simple, do not support parent change, otherwise reorder is needed.
	
	      if (!$action || $action === 'merge') {
	        existEl ? existEl.attr(elOptionCleaned) : createEl(id, targetElParent, elOptionCleaned, elMap);
	      } else if ($action === 'replace') {
	        removeEl(existEl, elMap);
	        createEl(id, targetElParent, elOptionCleaned, elMap);
	      } else if ($action === 'remove') {
	        removeEl(existEl, elMap);
	      }
	
	      var el = elMap.get(id);
	
	      if (el) {
	        el.__ecGraphicWidthOption = elOption.width;
	        el.__ecGraphicHeightOption = elOption.height;
	        setEventData(el, graphicModel, elOption);
	      }
	    });
	  },
	
	  /**
	   * Locate graphic elements.
	   *
	   * @private
	   * @param {Object} graphicModel graphic model
	   * @param {module:echarts/ExtensionAPI} api extension API
	   */
	  _relocate: function (graphicModel, api) {
	    var elOptions = graphicModel.option.elements;
	    var rootGroup = this.group;
	    var elMap = this._elMap;
	    var apiWidth = api.getWidth();
	    var apiHeight = api.getHeight(); // Top-down to calculate percentage width/height of group
	
	    for (var i = 0; i < elOptions.length; i++) {
	      var elOption = elOptions[i];
	      var el = elMap.get(elOption.id);
	
	      if (!el || !el.isGroup) {
	        continue;
	      }
	
	      var parentEl = el.parent;
	      var isParentRoot = parentEl === rootGroup; // Like 'position:absolut' in css, default 0.
	
	      el.__ecGraphicWidth = parsePercent(el.__ecGraphicWidthOption, isParentRoot ? apiWidth : parentEl.__ecGraphicWidth) || 0;
	      el.__ecGraphicHeight = parsePercent(el.__ecGraphicHeightOption, isParentRoot ? apiHeight : parentEl.__ecGraphicHeight) || 0;
	    } // Bottom-up tranvese all elements (consider ec resize) to locate elements.
	
	
	    for (var i = elOptions.length - 1; i >= 0; i--) {
	      var elOption = elOptions[i];
	      var el = elMap.get(elOption.id);
	
	      if (!el) {
	        continue;
	      }
	
	      var parentEl = el.parent;
	      var containerInfo = parentEl === rootGroup ? {
	        width: apiWidth,
	        height: apiHeight
	      } : {
	        width: parentEl.__ecGraphicWidth,
	        height: parentEl.__ecGraphicHeight
	      }; // PENDING
	      // Currently, when `bounding: 'all'`, the union bounding rect of the group
	      // does not include the rect of [0, 0, group.width, group.height], which
	      // is probably weird for users. Should we make a break change for it?
	
	      layoutUtil.positionElement(el, elOption, containerInfo, null, {
	        hv: elOption.hv,
	        boundingMode: elOption.bounding
	      });
	    }
	  },
	
	  /**
	   * Clear all elements.
	   *
	   * @private
	   */
	  _clear: function () {
	    var elMap = this._elMap;
	    elMap.each(function (el) {
	      removeEl(el, elMap);
	    });
	    this._elMap = zrUtil.createHashMap();
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    this._clear();
	  }
	});
	
	function createEl(id, targetElParent, elOption, elMap) {
	  var graphicType = elOption.type;
	  var Clz = _nonShapeGraphicElements.hasOwnProperty(graphicType) // Those graphic elements are not shapes. They should not be
	  // overwritten by users, so do them first.
	  ? _nonShapeGraphicElements[graphicType] : graphicUtil.getShapeClass(graphicType);
	  var el = new Clz(elOption);
	  targetElParent.add(el);
	  elMap.set(id, el);
	  el.__ecGraphicId = id;
	}
	
	function removeEl(existEl, elMap) {
	  var existElParent = existEl && existEl.parent;
	
	  if (existElParent) {
	    existEl.type === 'group' && existEl.traverse(function (el) {
	      removeEl(el, elMap);
	    });
	    elMap.removeKey(existEl.__ecGraphicId);
	    existElParent.remove(existEl);
	  }
	} // Remove unnecessary props to avoid potential problems.
	
	
	function getCleanedElOption(elOption) {
	  elOption = zrUtil.extend({}, elOption);
	  zrUtil.each(['id', 'parentId', '$action', 'hv', 'bounding'].concat(layoutUtil.LOCATION_PARAMS), function (name) {
	    delete elOption[name];
	  });
	  return elOption;
	}
	
	function isSetLoc(obj, props) {
	  var isSet;
	  zrUtil.each(props, function (prop) {
	    obj[prop] != null && obj[prop] !== 'auto' && (isSet = true);
	  });
	  return isSet;
	}
	
	function setKeyInfoToNewElOption(resultItem, newElOption) {
	  var existElOption = resultItem.exist; // Set id and type after id assigned.
	
	  newElOption.id = resultItem.keyInfo.id;
	  !newElOption.type && existElOption && (newElOption.type = existElOption.type); // Set parent id if not specified
	
	  if (newElOption.parentId == null) {
	    var newElParentOption = newElOption.parentOption;
	
	    if (newElParentOption) {
	      newElOption.parentId = newElParentOption.id;
	    } else if (existElOption) {
	      newElOption.parentId = existElOption.parentId;
	    }
	  } // Clear
	
	
	  newElOption.parentOption = null;
	}
	
	function mergeNewElOptionToExist(existList, index, newElOption) {
	  // Update existing options, for `getOption` feature.
	  var newElOptCopy = zrUtil.extend({}, newElOption);
	  var existElOption = existList[index];
	  var $action = newElOption.$action || 'merge';
	
	  if ($action === 'merge') {
	    if (existElOption) {
	      // We can ensure that newElOptCopy and existElOption are not
	      // the same object, so `merge` will not change newElOptCopy.
	      zrUtil.merge(existElOption, newElOptCopy, true); // Rigid body, use ignoreSize.
	
	      layoutUtil.mergeLayoutParam(existElOption, newElOptCopy, {
	        ignoreSize: true
	      }); // Will be used in render.
	
	      layoutUtil.copyLayoutParams(newElOption, existElOption);
	    } else {
	      existList[index] = newElOptCopy;
	    }
	  } else if ($action === 'replace') {
	    existList[index] = newElOptCopy;
	  } else if ($action === 'remove') {
	    // null will be cleaned later.
	    existElOption && (existList[index] = null);
	  }
	}
	
	function setLayoutInfoToExist(existItem, newElOption) {
	  if (!existItem) {
	    return;
	  }
	
	  existItem.hv = newElOption.hv = [// Rigid body, dont care `width`.
	  isSetLoc(newElOption, ['left', 'right']), // Rigid body, dont care `height`.
	  isSetLoc(newElOption, ['top', 'bottom'])]; // Give default group size. Otherwise layout error may occur.
	
	  if (existItem.type === 'group') {
	    existItem.width == null && (existItem.width = newElOption.width = 0);
	    existItem.height == null && (existItem.height = newElOption.height = 0);
	  }
	}
	
	function setEventData(el, graphicModel, elOption) {
	  var eventData = el.eventData; // Simple optimize for large amount of elements that no need event.
	
	  if (!el.silent && !el.ignore && !eventData) {
	    eventData = el.eventData = {
	      componentType: 'graphic',
	      componentIndex: graphicModel.componentIndex,
	      name: el.name
	    };
	  } // `elOption.info` enables user to mount some info on
	  // elements and use them in event handlers.
	
	
	  if (eventData) {
	    eventData.info = el.info;
	  }
	}

/***/ },
/* 1601 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(261);
	
	__webpack_require__(710);
	
	__webpack_require__(260);

/***/ },
/* 1602 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var LegendModel = __webpack_require__(724);
	
	var _layout = __webpack_require__(36);
	
	var mergeLayoutParam = _layout.mergeLayoutParam;
	var getLayoutParams = _layout.getLayoutParams;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var ScrollableLegendModel = LegendModel.extend({
	  type: 'legend.scroll',
	
	  /**
	   * @param {number} scrollDataIndex
	   */
	  setScrollDataIndex: function (scrollDataIndex) {
	    this.option.scrollDataIndex = scrollDataIndex;
	  },
	  defaultOption: {
	    scrollDataIndex: 0,
	    pageButtonItemGap: 5,
	    pageButtonGap: null,
	    pageButtonPosition: 'end',
	    // 'start' or 'end'
	    pageFormatter: '{current}/{total}',
	    // If null/undefined, do not show page.
	    pageIcons: {
	      horizontal: ['M0,0L12,-10L12,10z', 'M0,0L-12,-10L-12,10z'],
	      vertical: ['M0,0L20,0L10,-20z', 'M0,0L20,0L10,20z']
	    },
	    pageIconColor: '#2f4554',
	    pageIconInactiveColor: '#aaa',
	    pageIconSize: 15,
	    // Can be [10, 3], which represents [width, height]
	    pageTextStyle: {
	      color: '#333'
	    },
	    animationDurationUpdate: 800
	  },
	
	  /**
	   * @override
	   */
	  init: function (option, parentModel, ecModel, extraOpt) {
	    var inputPositionParams = getLayoutParams(option);
	    ScrollableLegendModel.superCall(this, 'init', option, parentModel, ecModel, extraOpt);
	    mergeAndNormalizeLayoutParams(this, option, inputPositionParams);
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function (option, extraOpt) {
	    ScrollableLegendModel.superCall(this, 'mergeOption', option, extraOpt);
	    mergeAndNormalizeLayoutParams(this, this.option, option);
	  }
	}); // Do not `ignoreSize` to enable setting {left: 10, right: 10}.
	
	function mergeAndNormalizeLayoutParams(legendModel, target, raw) {
	  var orient = legendModel.getOrient();
	  var ignoreSize = [1, 1];
	  ignoreSize[orient.index] = 0;
	  mergeLayoutParam(target, raw, {
	    type: 'box',
	    ignoreSize: ignoreSize
	  });
	}
	
	var _default = ScrollableLegendModel;
	module.exports = _default;

/***/ },
/* 1603 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var graphic = __webpack_require__(16);
	
	var layoutUtil = __webpack_require__(36);
	
	var LegendView = __webpack_require__(725);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Separate legend and scrollable legend to reduce package size.
	 */
	var Group = graphic.Group;
	var WH = ['width', 'height'];
	var XY = ['x', 'y'];
	var ScrollableLegendView = LegendView.extend({
	  type: 'legend.scroll',
	  newlineDisabled: true,
	  init: function () {
	    ScrollableLegendView.superCall(this, 'init');
	    /**
	     * @private
	     * @type {number} For `scroll`.
	     */
	
	    this._currentIndex = 0;
	    /**
	     * @private
	     * @type {module:zrender/container/Group}
	     */
	
	    this.group.add(this._containerGroup = new Group());
	
	    this._containerGroup.add(this.getContentGroup());
	    /**
	     * @private
	     * @type {module:zrender/container/Group}
	     */
	
	
	    this.group.add(this._controllerGroup = new Group());
	    /**
	     *
	     * @private
	     */
	
	    this._showController;
	  },
	
	  /**
	   * @override
	   */
	  resetInner: function () {
	    ScrollableLegendView.superCall(this, 'resetInner');
	
	    this._controllerGroup.removeAll();
	
	    this._containerGroup.removeClipPath();
	
	    this._containerGroup.__rectSize = null;
	  },
	
	  /**
	   * @override
	   */
	  renderInner: function (itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
	    var me = this; // Render content items.
	
	    ScrollableLegendView.superCall(this, 'renderInner', itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition);
	    var controllerGroup = this._controllerGroup; // FIXME: support be 'auto' adapt to size number text length,
	    // e.g., '3/12345' should not overlap with the control arrow button.
	
	    var pageIconSize = legendModel.get('pageIconSize', true);
	
	    if (!zrUtil.isArray(pageIconSize)) {
	      pageIconSize = [pageIconSize, pageIconSize];
	    }
	
	    createPageButton('pagePrev', 0);
	    var pageTextStyleModel = legendModel.getModel('pageTextStyle');
	    controllerGroup.add(new graphic.Text({
	      name: 'pageText',
	      style: {
	        textFill: pageTextStyleModel.getTextColor(),
	        font: pageTextStyleModel.getFont(),
	        textVerticalAlign: 'middle',
	        textAlign: 'center'
	      },
	      silent: true
	    }));
	    createPageButton('pageNext', 1);
	
	    function createPageButton(name, iconIdx) {
	      var pageDataIndexName = name + 'DataIndex';
	      var icon = graphic.createIcon(legendModel.get('pageIcons', true)[legendModel.getOrient().name][iconIdx], {
	        // Buttons will be created in each render, so we do not need
	        // to worry about avoiding using legendModel kept in scope.
	        onclick: zrUtil.bind(me._pageGo, me, pageDataIndexName, legendModel, api)
	      }, {
	        x: -pageIconSize[0] / 2,
	        y: -pageIconSize[1] / 2,
	        width: pageIconSize[0],
	        height: pageIconSize[1]
	      });
	      icon.name = name;
	      controllerGroup.add(icon);
	    }
	  },
	
	  /**
	   * @override
	   */
	  layoutInner: function (legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
	    var selectorGroup = this.getSelectorGroup();
	    var orientIdx = legendModel.getOrient().index;
	    var wh = WH[orientIdx];
	    var xy = XY[orientIdx];
	    var hw = WH[1 - orientIdx];
	    var yx = XY[1 - orientIdx];
	    selector && layoutUtil.box( // Buttons in selectorGroup always layout horizontally
	    'horizontal', selectorGroup, legendModel.get('selectorItemGap', true));
	    var selectorButtonGap = legendModel.get('selectorButtonGap', true);
	    var selectorRect = selectorGroup.getBoundingRect();
	    var selectorPos = [-selectorRect.x, -selectorRect.y];
	    var processMaxSize = zrUtil.clone(maxSize);
	    selector && (processMaxSize[wh] = maxSize[wh] - selectorRect[wh] - selectorButtonGap);
	
	    var mainRect = this._layoutContentAndController(legendModel, isFirstRender, processMaxSize, orientIdx, wh, hw, yx);
	
	    if (selector) {
	      if (selectorPosition === 'end') {
	        selectorPos[orientIdx] += mainRect[wh] + selectorButtonGap;
	      } else {
	        var offset = selectorRect[wh] + selectorButtonGap;
	        selectorPos[orientIdx] -= offset;
	        mainRect[xy] -= offset;
	      }
	
	      mainRect[wh] += selectorRect[wh] + selectorButtonGap;
	      selectorPos[1 - orientIdx] += mainRect[yx] + mainRect[hw] / 2 - selectorRect[hw] / 2;
	      mainRect[hw] = Math.max(mainRect[hw], selectorRect[hw]);
	      mainRect[yx] = Math.min(mainRect[yx], selectorRect[yx] + selectorPos[1 - orientIdx]);
	      selectorGroup.attr('position', selectorPos);
	    }
	
	    return mainRect;
	  },
	  _layoutContentAndController: function (legendModel, isFirstRender, maxSize, orientIdx, wh, hw, yx) {
	    var contentGroup = this.getContentGroup();
	    var containerGroup = this._containerGroup;
	    var controllerGroup = this._controllerGroup; // Place items in contentGroup.
	
	    layoutUtil.box(legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), !orientIdx ? null : maxSize.width, orientIdx ? null : maxSize.height);
	    layoutUtil.box( // Buttons in controller are layout always horizontally.
	    'horizontal', controllerGroup, legendModel.get('pageButtonItemGap', true));
	    var contentRect = contentGroup.getBoundingRect();
	    var controllerRect = controllerGroup.getBoundingRect();
	    var showController = this._showController = contentRect[wh] > maxSize[wh];
	    var contentPos = [-contentRect.x, -contentRect.y]; // Remain contentPos when scroll animation perfroming.
	    // If first rendering, `contentGroup.position` is [0, 0], which
	    // does not make sense and may cause unexepcted animation if adopted.
	
	    if (!isFirstRender) {
	      contentPos[orientIdx] = contentGroup.position[orientIdx];
	    } // Layout container group based on 0.
	
	
	    var containerPos = [0, 0];
	    var controllerPos = [-controllerRect.x, -controllerRect.y];
	    var pageButtonGap = zrUtil.retrieve2(legendModel.get('pageButtonGap', true), legendModel.get('itemGap', true)); // Place containerGroup and controllerGroup and contentGroup.
	
	    if (showController) {
	      var pageButtonPosition = legendModel.get('pageButtonPosition', true); // controller is on the right / bottom.
	
	      if (pageButtonPosition === 'end') {
	        controllerPos[orientIdx] += maxSize[wh] - controllerRect[wh];
	      } // controller is on the left / top.
	      else {
	          containerPos[orientIdx] += controllerRect[wh] + pageButtonGap;
	        }
	    } // Always align controller to content as 'middle'.
	
	
	    controllerPos[1 - orientIdx] += contentRect[hw] / 2 - controllerRect[hw] / 2;
	    contentGroup.attr('position', contentPos);
	    containerGroup.attr('position', containerPos);
	    controllerGroup.attr('position', controllerPos); // Calculate `mainRect` and set `clipPath`.
	    // mainRect should not be calculated by `this.group.getBoundingRect()`
	    // for sake of the overflow.
	
	    var mainRect = {
	      x: 0,
	      y: 0
	    }; // Consider content may be overflow (should be clipped).
	
	    mainRect[wh] = showController ? maxSize[wh] : contentRect[wh];
	    mainRect[hw] = Math.max(contentRect[hw], controllerRect[hw]); // `containerRect[yx] + containerPos[1 - orientIdx]` is 0.
	
	    mainRect[yx] = Math.min(0, controllerRect[yx] + controllerPos[1 - orientIdx]);
	    containerGroup.__rectSize = maxSize[wh];
	
	    if (showController) {
	      var clipShape = {
	        x: 0,
	        y: 0
	      };
	      clipShape[wh] = Math.max(maxSize[wh] - controllerRect[wh] - pageButtonGap, 0);
	      clipShape[hw] = mainRect[hw];
	      containerGroup.setClipPath(new graphic.Rect({
	        shape: clipShape
	      })); // Consider content may be larger than container, container rect
	      // can not be obtained from `containerGroup.getBoundingRect()`.
	
	      containerGroup.__rectSize = clipShape[wh];
	    } else {
	      // Do not remove or ignore controller. Keep them set as placeholders.
	      controllerGroup.eachChild(function (child) {
	        child.attr({
	          invisible: true,
	          silent: true
	        });
	      });
	    } // Content translate animation.
	
	
	    var pageInfo = this._getPageInfo(legendModel);
	
	    pageInfo.pageIndex != null && graphic.updateProps(contentGroup, {
	      position: pageInfo.contentPosition
	    }, // When switch from "show controller" to "not show controller", view should be
	    // updated immediately without animation, otherwise causes weird effect.
	    showController ? legendModel : false);
	
	    this._updatePageInfoView(legendModel, pageInfo);
	
	    return mainRect;
	  },
	  _pageGo: function (to, legendModel, api) {
	    var scrollDataIndex = this._getPageInfo(legendModel)[to];
	
	    scrollDataIndex != null && api.dispatchAction({
	      type: 'legendScroll',
	      scrollDataIndex: scrollDataIndex,
	      legendId: legendModel.id
	    });
	  },
	  _updatePageInfoView: function (legendModel, pageInfo) {
	    var controllerGroup = this._controllerGroup;
	    zrUtil.each(['pagePrev', 'pageNext'], function (name) {
	      var canJump = pageInfo[name + 'DataIndex'] != null;
	      var icon = controllerGroup.childOfName(name);
	
	      if (icon) {
	        icon.setStyle('fill', canJump ? legendModel.get('pageIconColor', true) : legendModel.get('pageIconInactiveColor', true));
	        icon.cursor = canJump ? 'pointer' : 'default';
	      }
	    });
	    var pageText = controllerGroup.childOfName('pageText');
	    var pageFormatter = legendModel.get('pageFormatter');
	    var pageIndex = pageInfo.pageIndex;
	    var current = pageIndex != null ? pageIndex + 1 : 0;
	    var total = pageInfo.pageCount;
	    pageText && pageFormatter && pageText.setStyle('text', zrUtil.isString(pageFormatter) ? pageFormatter.replace('{current}', current).replace('{total}', total) : pageFormatter({
	      current: current,
	      total: total
	    }));
	  },
	
	  /**
	   * @param {module:echarts/model/Model} legendModel
	   * @return {Object} {
	   *  contentPosition: Array.<number>, null when data item not found.
	   *  pageIndex: number, null when data item not found.
	   *  pageCount: number, always be a number, can be 0.
	   *  pagePrevDataIndex: number, null when no previous page.
	   *  pageNextDataIndex: number, null when no next page.
	   * }
	   */
	  _getPageInfo: function (legendModel) {
	    var scrollDataIndex = legendModel.get('scrollDataIndex', true);
	    var contentGroup = this.getContentGroup();
	    var containerRectSize = this._containerGroup.__rectSize;
	    var orientIdx = legendModel.getOrient().index;
	    var wh = WH[orientIdx];
	    var xy = XY[orientIdx];
	
	    var targetItemIndex = this._findTargetItemIndex(scrollDataIndex);
	
	    var children = contentGroup.children();
	    var targetItem = children[targetItemIndex];
	    var itemCount = children.length;
	    var pCount = !itemCount ? 0 : 1;
	    var result = {
	      contentPosition: contentGroup.position.slice(),
	      pageCount: pCount,
	      pageIndex: pCount - 1,
	      pagePrevDataIndex: null,
	      pageNextDataIndex: null
	    };
	
	    if (!targetItem) {
	      return result;
	    }
	
	    var targetItemInfo = getItemInfo(targetItem);
	    result.contentPosition[orientIdx] = -targetItemInfo.s; // Strategy:
	    // (1) Always align based on the left/top most item.
	    // (2) It is user-friendly that the last item shown in the
	    // current window is shown at the begining of next window.
	    // Otherwise if half of the last item is cut by the window,
	    // it will have no chance to display entirely.
	    // (3) Consider that item size probably be different, we
	    // have calculate pageIndex by size rather than item index,
	    // and we can not get page index directly by division.
	    // (4) The window is to narrow to contain more than
	    // one item, we should make sure that the page can be fliped.
	
	    for (var i = targetItemIndex + 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i <= itemCount; ++i) {
	      currItemInfo = getItemInfo(children[i]);
	
	      if ( // Half of the last item is out of the window.
	      !currItemInfo && winEndItemInfo.e > winStartItemInfo.s + containerRectSize || // If the current item does not intersect with the window, the new page
	      // can be started at the current item or the last item.
	      currItemInfo && !intersect(currItemInfo, winStartItemInfo.s)) {
	        if (winEndItemInfo.i > winStartItemInfo.i) {
	          winStartItemInfo = winEndItemInfo;
	        } else {
	          // e.g., when page size is smaller than item size.
	          winStartItemInfo = currItemInfo;
	        }
	
	        if (winStartItemInfo) {
	          if (result.pageNextDataIndex == null) {
	            result.pageNextDataIndex = winStartItemInfo.i;
	          }
	
	          ++result.pageCount;
	        }
	      }
	
	      winEndItemInfo = currItemInfo;
	    }
	
	    for (var i = targetItemIndex - 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i >= -1; --i) {
	      currItemInfo = getItemInfo(children[i]);
	
	      if ( // If the the end item does not intersect with the window started
	      // from the current item, a page can be settled.
	      (!currItemInfo || !intersect(winEndItemInfo, currItemInfo.s)) && // e.g., when page size is smaller than item size.
	      winStartItemInfo.i < winEndItemInfo.i) {
	        winEndItemInfo = winStartItemInfo;
	
	        if (result.pagePrevDataIndex == null) {
	          result.pagePrevDataIndex = winStartItemInfo.i;
	        }
	
	        ++result.pageCount;
	        ++result.pageIndex;
	      }
	
	      winStartItemInfo = currItemInfo;
	    }
	
	    return result;
	
	    function getItemInfo(el) {
	      if (el) {
	        var itemRect = el.getBoundingRect();
	        var start = itemRect[xy] + el.position[orientIdx];
	        return {
	          s: start,
	          e: start + itemRect[wh],
	          i: el.__legendDataIndex
	        };
	      }
	    }
	
	    function intersect(itemInfo, winStart) {
	      return itemInfo.e >= winStart && itemInfo.s <= winStart + containerRectSize;
	    }
	  },
	  _findTargetItemIndex: function (targetDataIndex) {
	    if (!this._showController) {
	      return 0;
	    }
	
	    var index;
	    var contentGroup = this.getContentGroup();
	    var defaultIndex;
	    contentGroup.eachChild(function (child, idx) {
	      var legendDataIdx = child.__legendDataIndex; // FIXME
	      // If the given targetDataIndex (from model) is illegal,
	      // we use defaultIndex. But the index on the legend model and
	      // action payload is still illegal. That case will not be
	      // changed until some scenario requires.
	
	      if (defaultIndex == null && legendDataIdx != null) {
	        defaultIndex = idx;
	      }
	
	      if (legendDataIdx === targetDataIndex) {
	        index = idx;
	      }
	    });
	    return index != null ? index : defaultIndex;
	  }
	});
	var _default = ScrollableLegendView;
	module.exports = _default;

/***/ },
/* 1604 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function legendSelectActionHandler(methodName, payload, ecModel) {
	  var selectedMap = {};
	  var isToggleSelect = methodName === 'toggleSelected';
	  var isSelected; // Update all legend components
	
	  ecModel.eachComponent('legend', function (legendModel) {
	    if (isToggleSelect && isSelected != null) {
	      // Force other legend has same selected status
	      // Or the first is toggled to true and other are toggled to false
	      // In the case one legend has some item unSelected in option. And if other legend
	      // doesn't has the item, they will assume it is selected.
	      legendModel[isSelected ? 'select' : 'unSelect'](payload.name);
	    } else if (methodName === 'allSelect' || methodName === 'inverseSelect') {
	      legendModel[methodName]();
	    } else {
	      legendModel[methodName](payload.name);
	      isSelected = legendModel.isSelected(payload.name);
	    }
	
	    var legendData = legendModel.getData();
	    zrUtil.each(legendData, function (model) {
	      var name = model.get('name'); // Wrap element
	
	      if (name === '\n' || name === '') {
	        return;
	      }
	
	      var isItemSelected = legendModel.isSelected(name);
	
	      if (selectedMap.hasOwnProperty(name)) {
	        // Unselected if any legend is unselected
	        selectedMap[name] = selectedMap[name] && isItemSelected;
	      } else {
	        selectedMap[name] = isItemSelected;
	      }
	    });
	  }); // Return the event explicitly
	
	  return methodName === 'allSelect' || methodName === 'inverseSelect' ? {
	    selected: selectedMap
	  } : {
	    name: payload.name,
	    selected: selectedMap
	  };
	}
	/**
	 * @event legendToggleSelect
	 * @type {Object}
	 * @property {string} type 'legendToggleSelect'
	 * @property {string} [from]
	 * @property {string} name Series name or data item name
	 */
	
	
	echarts.registerAction('legendToggleSelect', 'legendselectchanged', zrUtil.curry(legendSelectActionHandler, 'toggleSelected'));
	echarts.registerAction('legendAllSelect', 'legendselectall', zrUtil.curry(legendSelectActionHandler, 'allSelect'));
	echarts.registerAction('legendInverseSelect', 'legendinverseselect', zrUtil.curry(legendSelectActionHandler, 'inverseSelect'));
	/**
	 * @event legendSelect
	 * @type {Object}
	 * @property {string} type 'legendSelect'
	 * @property {string} name Series name or data item name
	 */
	
	echarts.registerAction('legendSelect', 'legendselected', zrUtil.curry(legendSelectActionHandler, 'select'));
	/**
	 * @event legendUnSelect
	 * @type {Object}
	 * @property {string} type 'legendUnSelect'
	 * @property {string} name Series name or data item name
	 */
	
	echarts.registerAction('legendUnSelect', 'legendunselected', zrUtil.curry(legendSelectActionHandler, 'unSelect'));

/***/ },
/* 1605 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  var legendModels = ecModel.findComponents({
	    mainType: 'legend'
	  });
	
	  if (legendModels && legendModels.length) {
	    ecModel.filterSeries(function (series) {
	      // If in any legend component the status is not selected.
	      // Because in legend series is assumed selected when it is not in the legend data.
	      for (var i = 0; i < legendModels.length; i++) {
	        if (!legendModels[i].isSelected(series.name)) {
	          return false;
	        }
	      }
	
	      return true;
	    });
	  }
	}
	
	module.exports = _default;

/***/ },
/* 1606 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @event legendScroll
	 * @type {Object}
	 * @property {string} type 'legendScroll'
	 * @property {string} scrollDataIndex
	 */
	echarts.registerAction('legendScroll', 'legendscroll', function (payload, ecModel) {
	  var scrollDataIndex = payload.scrollDataIndex;
	  scrollDataIndex != null && ecModel.eachComponent({
	    mainType: 'legend',
	    subType: 'scroll',
	    query: payload
	  }, function (legendModel) {
	    legendModel.setScrollDataIndex(scrollDataIndex);
	  });
	});

/***/ },
/* 1607 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(723);
	
	__webpack_require__(1602);
	
	__webpack_require__(1603);
	
	__webpack_require__(1606);

/***/ },
/* 1608 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	__webpack_require__(1611);
	
	__webpack_require__(1612);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerPreprocessor(function (opt) {
	  // Make sure markArea component is enabled
	  opt.markArea = opt.markArea || {};
	});

/***/ },
/* 1609 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	__webpack_require__(1613);
	
	__webpack_require__(1614);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerPreprocessor(function (opt) {
	  // Make sure markLine component is enabled
	  opt.markLine = opt.markLine || {};
	});

/***/ },
/* 1610 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	__webpack_require__(1615);
	
	__webpack_require__(1616);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// HINT Markpoint can't be used too much
	echarts.registerPreprocessor(function (opt) {
	  // Make sure markPoint component is enabled
	  opt.markPoint = opt.markPoint || {};
	});

/***/ },
/* 1611 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var MarkerModel = __webpack_require__(466);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = MarkerModel.extend({
	  type: 'markArea',
	  defaultOption: {
	    zlevel: 0,
	    // PENDING
	    z: 1,
	    tooltip: {
	      trigger: 'item'
	    },
	    // markArea should fixed on the coordinate system
	    animation: false,
	    label: {
	      show: true,
	      position: 'top'
	    },
	    itemStyle: {
	      // color and borderColor default to use color from series
	      // color: 'auto'
	      // borderColor: 'auto'
	      borderWidth: 0
	    },
	    emphasis: {
	      label: {
	        show: true,
	        position: 'top'
	      }
	    }
	  }
	});
	
	module.exports = _default;

/***/ },
/* 1612 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var colorUtil = __webpack_require__(114);
	
	var List = __webpack_require__(83);
	
	var numberUtil = __webpack_require__(20);
	
	var graphic = __webpack_require__(16);
	
	var markerHelper = __webpack_require__(468);
	
	var MarkerView = __webpack_require__(467);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// TODO Better on polar
	var markAreaTransform = function (seriesModel, coordSys, maModel, item) {
	  var lt = markerHelper.dataTransform(seriesModel, item[0]);
	  var rb = markerHelper.dataTransform(seriesModel, item[1]);
	  var retrieve = zrUtil.retrieve; // FIXME make sure lt is less than rb
	
	  var ltCoord = lt.coord;
	  var rbCoord = rb.coord;
	  ltCoord[0] = retrieve(ltCoord[0], -Infinity);
	  ltCoord[1] = retrieve(ltCoord[1], -Infinity);
	  rbCoord[0] = retrieve(rbCoord[0], Infinity);
	  rbCoord[1] = retrieve(rbCoord[1], Infinity); // Merge option into one
	
	  var result = zrUtil.mergeAll([{}, lt, rb]);
	  result.coord = [lt.coord, rb.coord];
	  result.x0 = lt.x;
	  result.y0 = lt.y;
	  result.x1 = rb.x;
	  result.y1 = rb.y;
	  return result;
	};
	
	function isInifinity(val) {
	  return !isNaN(val) && !isFinite(val);
	} // If a markArea has one dim
	
	
	function ifMarkLineHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
	  var otherDimIndex = 1 - dimIndex;
	  return isInifinity(fromCoord[otherDimIndex]) && isInifinity(toCoord[otherDimIndex]);
	}
	
	function markAreaFilter(coordSys, item) {
	  var fromCoord = item.coord[0];
	  var toCoord = item.coord[1];
	
	  if (coordSys.type === 'cartesian2d') {
	    // In case
	    // {
	    //  markArea: {
	    //    data: [{ yAxis: 2 }]
	    //  }
	    // }
	    if (fromCoord && toCoord && (ifMarkLineHasOnlyDim(1, fromCoord, toCoord, coordSys) || ifMarkLineHasOnlyDim(0, fromCoord, toCoord, coordSys))) {
	      return true;
	    }
	  }
	
	  return markerHelper.dataFilter(coordSys, {
	    coord: fromCoord,
	    x: item.x0,
	    y: item.y0
	  }) || markerHelper.dataFilter(coordSys, {
	    coord: toCoord,
	    x: item.x1,
	    y: item.y1
	  });
	} // dims can be ['x0', 'y0'], ['x1', 'y1'], ['x0', 'y1'], ['x1', 'y0']
	
	
	function getSingleMarkerEndPoint(data, idx, dims, seriesModel, api) {
	  var coordSys = seriesModel.coordinateSystem;
	  var itemModel = data.getItemModel(idx);
	  var point;
	  var xPx = numberUtil.parsePercent(itemModel.get(dims[0]), api.getWidth());
	  var yPx = numberUtil.parsePercent(itemModel.get(dims[1]), api.getHeight());
	
	  if (!isNaN(xPx) && !isNaN(yPx)) {
	    point = [xPx, yPx];
	  } else {
	    // Chart like bar may have there own marker positioning logic
	    if (seriesModel.getMarkerPosition) {
	      // Use the getMarkerPoisition
	      point = seriesModel.getMarkerPosition(data.getValues(dims, idx));
	    } else {
	      var x = data.get(dims[0], idx);
	      var y = data.get(dims[1], idx);
	      var pt = [x, y];
	      coordSys.clampData && coordSys.clampData(pt, pt);
	      point = coordSys.dataToPoint(pt, true);
	    }
	
	    if (coordSys.type === 'cartesian2d') {
	      var xAxis = coordSys.getAxis('x');
	      var yAxis = coordSys.getAxis('y');
	      var x = data.get(dims[0], idx);
	      var y = data.get(dims[1], idx);
	
	      if (isInifinity(x)) {
	        point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[dims[0] === 'x0' ? 0 : 1]);
	      } else if (isInifinity(y)) {
	        point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[dims[1] === 'y0' ? 0 : 1]);
	      }
	    } // Use x, y if has any
	
	
	    if (!isNaN(xPx)) {
	      point[0] = xPx;
	    }
	
	    if (!isNaN(yPx)) {
	      point[1] = yPx;
	    }
	  }
	
	  return point;
	}
	
	var dimPermutations = [['x0', 'y0'], ['x1', 'y0'], ['x1', 'y1'], ['x0', 'y1']];
	MarkerView.extend({
	  type: 'markArea',
	  // updateLayout: function (markAreaModel, ecModel, api) {
	  //     ecModel.eachSeries(function (seriesModel) {
	  //         var maModel = seriesModel.markAreaModel;
	  //         if (maModel) {
	  //             var areaData = maModel.getData();
	  //             areaData.each(function (idx) {
	  //                 var points = zrUtil.map(dimPermutations, function (dim) {
	  //                     return getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
	  //                 });
	  //                 // Layout
	  //                 areaData.setItemLayout(idx, points);
	  //                 var el = areaData.getItemGraphicEl(idx);
	  //                 el.setShape('points', points);
	  //             });
	  //         }
	  //     }, this);
	  // },
	  updateTransform: function (markAreaModel, ecModel, api) {
	    ecModel.eachSeries(function (seriesModel) {
	      var maModel = seriesModel.markAreaModel;
	
	      if (maModel) {
	        var areaData = maModel.getData();
	        areaData.each(function (idx) {
	          var points = zrUtil.map(dimPermutations, function (dim) {
	            return getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
	          }); // Layout
	
	          areaData.setItemLayout(idx, points);
	          var el = areaData.getItemGraphicEl(idx);
	          el.setShape('points', points);
	        });
	      }
	    }, this);
	  },
	  renderSeries: function (seriesModel, maModel, ecModel, api) {
	    var coordSys = seriesModel.coordinateSystem;
	    var seriesId = seriesModel.id;
	    var seriesData = seriesModel.getData();
	    var areaGroupMap = this.markerGroupMap;
	    var polygonGroup = areaGroupMap.get(seriesId) || areaGroupMap.set(seriesId, {
	      group: new graphic.Group()
	    });
	    this.group.add(polygonGroup.group);
	    polygonGroup.__keep = true;
	    var areaData = createList(coordSys, seriesModel, maModel); // Line data for tooltip and formatter
	
	    maModel.setData(areaData); // Update visual and layout of line
	
	    areaData.each(function (idx) {
	      // Layout
	      var points = zrUtil.map(dimPermutations, function (dim) {
	        return getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
	      }); // If none of the area is inside coordSys, allClipped is set to be true
	      // in layout so that label will not be displayed. See #12591
	
	      var allClipped = true;
	      zrUtil.each(dimPermutations, function (dim) {
	        if (!allClipped) {
	          return;
	        }
	
	        var xValue = areaData.get(dim[0], idx);
	        var yValue = areaData.get(dim[1], idx); // If is infinity, the axis should be considered not clipped
	
	        if ((isInifinity(xValue) || coordSys.getAxis('x').containData(xValue)) && (isInifinity(yValue) || coordSys.getAxis('y').containData(yValue))) {
	          allClipped = false;
	        }
	      });
	      areaData.setItemLayout(idx, {
	        points: points,
	        allClipped: allClipped
	      }); // Visual
	
	      areaData.setItemVisual(idx, {
	        color: seriesData.getVisual('color')
	      });
	    });
	    areaData.diff(polygonGroup.__data).add(function (idx) {
	      var layout = areaData.getItemLayout(idx);
	
	      if (!layout.allClipped) {
	        var polygon = new graphic.Polygon({
	          shape: {
	            points: layout.points
	          }
	        });
	        areaData.setItemGraphicEl(idx, polygon);
	        polygonGroup.group.add(polygon);
	      }
	    }).update(function (newIdx, oldIdx) {
	      var polygon = polygonGroup.__data.getItemGraphicEl(oldIdx);
	
	      var layout = areaData.getItemLayout(newIdx);
	
	      if (!layout.allClipped) {
	        if (polygon) {
	          graphic.updateProps(polygon, {
	            shape: {
	              points: layout.points
	            }
	          }, maModel, newIdx);
	        } else {
	          polygon = new graphic.Polygon({
	            shape: {
	              points: layout.points
	            }
	          });
	        }
	
	        areaData.setItemGraphicEl(newIdx, polygon);
	        polygonGroup.group.add(polygon);
	      } else if (polygon) {
	        polygonGroup.group.remove(polygon);
	      }
	    }).remove(function (idx) {
	      var polygon = polygonGroup.__data.getItemGraphicEl(idx);
	
	      polygonGroup.group.remove(polygon);
	    }).execute();
	    areaData.eachItemGraphicEl(function (polygon, idx) {
	      var itemModel = areaData.getItemModel(idx);
	      var labelModel = itemModel.getModel('label');
	      var labelHoverModel = itemModel.getModel('emphasis.label');
	      var color = areaData.getItemVisual(idx, 'color');
	      polygon.useStyle(zrUtil.defaults(itemModel.getModel('itemStyle').getItemStyle(), {
	        fill: colorUtil.modifyAlpha(color, 0.4),
	        stroke: color
	      }));
	      polygon.hoverStyle = itemModel.getModel('emphasis.itemStyle').getItemStyle();
	      graphic.setLabelStyle(polygon.style, polygon.hoverStyle, labelModel, labelHoverModel, {
	        labelFetcher: maModel,
	        labelDataIndex: idx,
	        defaultText: areaData.getName(idx) || '',
	        isRectText: true,
	        autoColor: color
	      });
	      graphic.setHoverStyle(polygon, {});
	      polygon.dataModel = maModel;
	    });
	    polygonGroup.__data = areaData;
	    polygonGroup.group.silent = maModel.get('silent') || seriesModel.get('silent');
	  }
	});
	/**
	 * @inner
	 * @param {module:echarts/coord/*} coordSys
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {module:echarts/model/Model} mpModel
	 */
	
	function createList(coordSys, seriesModel, maModel) {
	  var coordDimsInfos;
	  var areaData;
	  var dims = ['x0', 'y0', 'x1', 'y1'];
	
	  if (coordSys) {
	    coordDimsInfos = zrUtil.map(coordSys && coordSys.dimensions, function (coordDim) {
	      var data = seriesModel.getData();
	      var info = data.getDimensionInfo(data.mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys
	
	      return zrUtil.defaults({
	        name: coordDim
	      }, info);
	    });
	    areaData = new List(zrUtil.map(dims, function (dim, idx) {
	      return {
	        name: dim,
	        type: coordDimsInfos[idx % 2].type
	      };
	    }), maModel);
	  } else {
	    coordDimsInfos = [{
	      name: 'value',
	      type: 'float'
	    }];
	    areaData = new List(coordDimsInfos, maModel);
	  }
	
	  var optData = zrUtil.map(maModel.get('data'), zrUtil.curry(markAreaTransform, seriesModel, coordSys, maModel));
	
	  if (coordSys) {
	    optData = zrUtil.filter(optData, zrUtil.curry(markAreaFilter, coordSys));
	  }
	
	  var dimValueGetter = coordSys ? function (item, dimName, dataIndex, dimIndex) {
	    return item.coord[Math.floor(dimIndex / 2)][dimIndex % 2];
	  } : function (item) {
	    return item.value;
	  };
	  areaData.initData(optData, null, dimValueGetter);
	  areaData.hasItemOption = true;
	  return areaData;
	}

/***/ },
/* 1613 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var MarkerModel = __webpack_require__(466);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = MarkerModel.extend({
	  type: 'markLine',
	  defaultOption: {
	    zlevel: 0,
	    z: 5,
	    symbol: ['circle', 'arrow'],
	    symbolSize: [8, 16],
	    //symbolRotate: 0,
	    precision: 2,
	    tooltip: {
	      trigger: 'item'
	    },
	    label: {
	      show: true,
	      position: 'end',
	      distance: 5
	    },
	    lineStyle: {
	      type: 'dashed'
	    },
	    emphasis: {
	      label: {
	        show: true
	      },
	      lineStyle: {
	        width: 3
	      }
	    },
	    animationEasing: 'linear'
	  }
	});
	
	module.exports = _default;

/***/ },
/* 1614 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var List = __webpack_require__(83);
	
	var numberUtil = __webpack_require__(20);
	
	var markerHelper = __webpack_require__(468);
	
	var LineDraw = __webpack_require__(456);
	
	var MarkerView = __webpack_require__(467);
	
	var _dataStackHelper = __webpack_require__(105);
	
	var getStackedDimension = _dataStackHelper.getStackedDimension;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var markLineTransform = function (seriesModel, coordSys, mlModel, item) {
	  var data = seriesModel.getData(); // Special type markLine like 'min', 'max', 'average', 'median'
	
	  var mlType = item.type;
	
	  if (!zrUtil.isArray(item) && (mlType === 'min' || mlType === 'max' || mlType === 'average' || mlType === 'median' // In case
	  // data: [{
	  //   yAxis: 10
	  // }]
	  || item.xAxis != null || item.yAxis != null)) {
	    var valueAxis;
	    var value;
	
	    if (item.yAxis != null || item.xAxis != null) {
	      valueAxis = coordSys.getAxis(item.yAxis != null ? 'y' : 'x');
	      value = zrUtil.retrieve(item.yAxis, item.xAxis);
	    } else {
	      var axisInfo = markerHelper.getAxisInfo(item, data, coordSys, seriesModel);
	      valueAxis = axisInfo.valueAxis;
	      var valueDataDim = getStackedDimension(data, axisInfo.valueDataDim);
	      value = markerHelper.numCalculate(data, valueDataDim, mlType);
	    }
	
	    var valueIndex = valueAxis.dim === 'x' ? 0 : 1;
	    var baseIndex = 1 - valueIndex;
	    var mlFrom = zrUtil.clone(item);
	    var mlTo = {};
	    mlFrom.type = null;
	    mlFrom.coord = [];
	    mlTo.coord = [];
	    mlFrom.coord[baseIndex] = -Infinity;
	    mlTo.coord[baseIndex] = Infinity;
	    var precision = mlModel.get('precision');
	
	    if (precision >= 0 && typeof value === 'number') {
	      value = +value.toFixed(Math.min(precision, 20));
	    }
	
	    mlFrom.coord[valueIndex] = mlTo.coord[valueIndex] = value;
	    item = [mlFrom, mlTo, {
	      // Extra option for tooltip and label
	      type: mlType,
	      valueIndex: item.valueIndex,
	      // Force to use the value of calculated value.
	      value: value
	    }];
	  }
	
	  item = [markerHelper.dataTransform(seriesModel, item[0]), markerHelper.dataTransform(seriesModel, item[1]), zrUtil.extend({}, item[2])]; // Avoid line data type is extended by from(to) data type
	
	  item[2].type = item[2].type || ''; // Merge from option and to option into line option
	
	  zrUtil.merge(item[2], item[0]);
	  zrUtil.merge(item[2], item[1]);
	  return item;
	};
	
	function isInifinity(val) {
	  return !isNaN(val) && !isFinite(val);
	} // If a markLine has one dim
	
	
	function ifMarkLineHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
	  var otherDimIndex = 1 - dimIndex;
	  var dimName = coordSys.dimensions[dimIndex];
	  return isInifinity(fromCoord[otherDimIndex]) && isInifinity(toCoord[otherDimIndex]) && fromCoord[dimIndex] === toCoord[dimIndex] && coordSys.getAxis(dimName).containData(fromCoord[dimIndex]);
	}
	
	function markLineFilter(coordSys, item) {
	  if (coordSys.type === 'cartesian2d') {
	    var fromCoord = item[0].coord;
	    var toCoord = item[1].coord; // In case
	    // {
	    //  markLine: {
	    //    data: [{ yAxis: 2 }]
	    //  }
	    // }
	
	    if (fromCoord && toCoord && (ifMarkLineHasOnlyDim(1, fromCoord, toCoord, coordSys) || ifMarkLineHasOnlyDim(0, fromCoord, toCoord, coordSys))) {
	      return true;
	    }
	  }
	
	  return markerHelper.dataFilter(coordSys, item[0]) && markerHelper.dataFilter(coordSys, item[1]);
	}
	
	function updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api) {
	  var coordSys = seriesModel.coordinateSystem;
	  var itemModel = data.getItemModel(idx);
	  var point;
	  var xPx = numberUtil.parsePercent(itemModel.get('x'), api.getWidth());
	  var yPx = numberUtil.parsePercent(itemModel.get('y'), api.getHeight());
	
	  if (!isNaN(xPx) && !isNaN(yPx)) {
	    point = [xPx, yPx];
	  } else {
	    // Chart like bar may have there own marker positioning logic
	    if (seriesModel.getMarkerPosition) {
	      // Use the getMarkerPoisition
	      point = seriesModel.getMarkerPosition(data.getValues(data.dimensions, idx));
	    } else {
	      var dims = coordSys.dimensions;
	      var x = data.get(dims[0], idx);
	      var y = data.get(dims[1], idx);
	      point = coordSys.dataToPoint([x, y]);
	    } // Expand line to the edge of grid if value on one axis is Inifnity
	    // In case
	    //  markLine: {
	    //    data: [{
	    //      yAxis: 2
	    //      // or
	    //      type: 'average'
	    //    }]
	    //  }
	
	
	    if (coordSys.type === 'cartesian2d') {
	      var xAxis = coordSys.getAxis('x');
	      var yAxis = coordSys.getAxis('y');
	      var dims = coordSys.dimensions;
	
	      if (isInifinity(data.get(dims[0], idx))) {
	        point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[isFrom ? 0 : 1]);
	      } else if (isInifinity(data.get(dims[1], idx))) {
	        point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[isFrom ? 0 : 1]);
	      }
	    } // Use x, y if has any
	
	
	    if (!isNaN(xPx)) {
	      point[0] = xPx;
	    }
	
	    if (!isNaN(yPx)) {
	      point[1] = yPx;
	    }
	  }
	
	  data.setItemLayout(idx, point);
	}
	
	var _default = MarkerView.extend({
	  type: 'markLine',
	  // updateLayout: function (markLineModel, ecModel, api) {
	  //     ecModel.eachSeries(function (seriesModel) {
	  //         var mlModel = seriesModel.markLineModel;
	  //         if (mlModel) {
	  //             var mlData = mlModel.getData();
	  //             var fromData = mlModel.__from;
	  //             var toData = mlModel.__to;
	  //             // Update visual and layout of from symbol and to symbol
	  //             fromData.each(function (idx) {
	  //                 updateSingleMarkerEndLayout(fromData, idx, true, seriesModel, api);
	  //                 updateSingleMarkerEndLayout(toData, idx, false, seriesModel, api);
	  //             });
	  //             // Update layout of line
	  //             mlData.each(function (idx) {
	  //                 mlData.setItemLayout(idx, [
	  //                     fromData.getItemLayout(idx),
	  //                     toData.getItemLayout(idx)
	  //                 ]);
	  //             });
	  //             this.markerGroupMap.get(seriesModel.id).updateLayout();
	  //         }
	  //     }, this);
	  // },
	  updateTransform: function (markLineModel, ecModel, api) {
	    ecModel.eachSeries(function (seriesModel) {
	      var mlModel = seriesModel.markLineModel;
	
	      if (mlModel) {
	        var mlData = mlModel.getData();
	        var fromData = mlModel.__from;
	        var toData = mlModel.__to; // Update visual and layout of from symbol and to symbol
	
	        fromData.each(function (idx) {
	          updateSingleMarkerEndLayout(fromData, idx, true, seriesModel, api);
	          updateSingleMarkerEndLayout(toData, idx, false, seriesModel, api);
	        }); // Update layout of line
	
	        mlData.each(function (idx) {
	          mlData.setItemLayout(idx, [fromData.getItemLayout(idx), toData.getItemLayout(idx)]);
	        });
	        this.markerGroupMap.get(seriesModel.id).updateLayout();
	      }
	    }, this);
	  },
	  renderSeries: function (seriesModel, mlModel, ecModel, api) {
	    var coordSys = seriesModel.coordinateSystem;
	    var seriesId = seriesModel.id;
	    var seriesData = seriesModel.getData();
	    var lineDrawMap = this.markerGroupMap;
	    var lineDraw = lineDrawMap.get(seriesId) || lineDrawMap.set(seriesId, new LineDraw());
	    this.group.add(lineDraw.group);
	    var mlData = createList(coordSys, seriesModel, mlModel);
	    var fromData = mlData.from;
	    var toData = mlData.to;
	    var lineData = mlData.line;
	    mlModel.__from = fromData;
	    mlModel.__to = toData; // Line data for tooltip and formatter
	
	    mlModel.setData(lineData);
	    var symbolType = mlModel.get('symbol');
	    var symbolSize = mlModel.get('symbolSize');
	
	    if (!zrUtil.isArray(symbolType)) {
	      symbolType = [symbolType, symbolType];
	    }
	
	    if (typeof symbolSize === 'number') {
	      symbolSize = [symbolSize, symbolSize];
	    } // Update visual and layout of from symbol and to symbol
	
	
	    mlData.from.each(function (idx) {
	      updateDataVisualAndLayout(fromData, idx, true);
	      updateDataVisualAndLayout(toData, idx, false);
	    }); // Update visual and layout of line
	
	    lineData.each(function (idx) {
	      var lineColor = lineData.getItemModel(idx).get('lineStyle.color');
	      lineData.setItemVisual(idx, {
	        color: lineColor || fromData.getItemVisual(idx, 'color')
	      });
	      lineData.setItemLayout(idx, [fromData.getItemLayout(idx), toData.getItemLayout(idx)]);
	      lineData.setItemVisual(idx, {
	        'fromSymbolRotate': fromData.getItemVisual(idx, 'symbolRotate'),
	        'fromSymbolSize': fromData.getItemVisual(idx, 'symbolSize'),
	        'fromSymbol': fromData.getItemVisual(idx, 'symbol'),
	        'toSymbolRotate': toData.getItemVisual(idx, 'symbolRotate'),
	        'toSymbolSize': toData.getItemVisual(idx, 'symbolSize'),
	        'toSymbol': toData.getItemVisual(idx, 'symbol')
	      });
	    });
	    lineDraw.updateData(lineData); // Set host model for tooltip
	    // FIXME
	
	    mlData.line.eachItemGraphicEl(function (el, idx) {
	      el.traverse(function (child) {
	        child.dataModel = mlModel;
	      });
	    });
	
	    function updateDataVisualAndLayout(data, idx, isFrom) {
	      var itemModel = data.getItemModel(idx);
	      updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api);
	      data.setItemVisual(idx, {
	        symbolRotate: itemModel.get('symbolRotate'),
	        symbolSize: itemModel.get('symbolSize') || symbolSize[isFrom ? 0 : 1],
	        symbol: itemModel.get('symbol', true) || symbolType[isFrom ? 0 : 1],
	        color: itemModel.get('itemStyle.color') || seriesData.getVisual('color')
	      });
	    }
	
	    lineDraw.__keep = true;
	    lineDraw.group.silent = mlModel.get('silent') || seriesModel.get('silent');
	  }
	});
	/**
	 * @inner
	 * @param {module:echarts/coord/*} coordSys
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {module:echarts/model/Model} mpModel
	 */
	
	
	function createList(coordSys, seriesModel, mlModel) {
	  var coordDimsInfos;
	
	  if (coordSys) {
	    coordDimsInfos = zrUtil.map(coordSys && coordSys.dimensions, function (coordDim) {
	      var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys
	
	      return zrUtil.defaults({
	        name: coordDim
	      }, info);
	    });
	  } else {
	    coordDimsInfos = [{
	      name: 'value',
	      type: 'float'
	    }];
	  }
	
	  var fromData = new List(coordDimsInfos, mlModel);
	  var toData = new List(coordDimsInfos, mlModel); // No dimensions
	
	  var lineData = new List([], mlModel);
	  var optData = zrUtil.map(mlModel.get('data'), zrUtil.curry(markLineTransform, seriesModel, coordSys, mlModel));
	
	  if (coordSys) {
	    optData = zrUtil.filter(optData, zrUtil.curry(markLineFilter, coordSys));
	  }
	
	  var dimValueGetter = coordSys ? markerHelper.dimValueGetter : function (item) {
	    return item.value;
	  };
	  fromData.initData(zrUtil.map(optData, function (item) {
	    return item[0];
	  }), null, dimValueGetter);
	  toData.initData(zrUtil.map(optData, function (item) {
	    return item[1];
	  }), null, dimValueGetter);
	  lineData.initData(zrUtil.map(optData, function (item) {
	    return item[2];
	  }));
	  lineData.hasItemOption = true;
	  return {
	    from: fromData,
	    to: toData,
	    line: lineData
	  };
	}
	
	module.exports = _default;

/***/ },
/* 1615 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var MarkerModel = __webpack_require__(466);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = MarkerModel.extend({
	  type: 'markPoint',
	  defaultOption: {
	    zlevel: 0,
	    z: 5,
	    symbol: 'pin',
	    symbolSize: 50,
	    //symbolRotate: 0,
	    //symbolOffset: [0, 0]
	    tooltip: {
	      trigger: 'item'
	    },
	    label: {
	      show: true,
	      position: 'inside'
	    },
	    itemStyle: {
	      borderWidth: 2
	    },
	    emphasis: {
	      label: {
	        show: true
	      }
	    }
	  }
	});
	
	module.exports = _default;

/***/ },
/* 1616 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var SymbolDraw = __webpack_require__(258);
	
	var numberUtil = __webpack_require__(20);
	
	var List = __webpack_require__(83);
	
	var markerHelper = __webpack_require__(468);
	
	var MarkerView = __webpack_require__(467);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function updateMarkerLayout(mpData, seriesModel, api) {
	  var coordSys = seriesModel.coordinateSystem;
	  mpData.each(function (idx) {
	    var itemModel = mpData.getItemModel(idx);
	    var point;
	    var xPx = numberUtil.parsePercent(itemModel.get('x'), api.getWidth());
	    var yPx = numberUtil.parsePercent(itemModel.get('y'), api.getHeight());
	
	    if (!isNaN(xPx) && !isNaN(yPx)) {
	      point = [xPx, yPx];
	    } // Chart like bar may have there own marker positioning logic
	    else if (seriesModel.getMarkerPosition) {
	        // Use the getMarkerPoisition
	        point = seriesModel.getMarkerPosition(mpData.getValues(mpData.dimensions, idx));
	      } else if (coordSys) {
	        var x = mpData.get(coordSys.dimensions[0], idx);
	        var y = mpData.get(coordSys.dimensions[1], idx);
	        point = coordSys.dataToPoint([x, y]);
	      } // Use x, y if has any
	
	
	    if (!isNaN(xPx)) {
	      point[0] = xPx;
	    }
	
	    if (!isNaN(yPx)) {
	      point[1] = yPx;
	    }
	
	    mpData.setItemLayout(idx, point);
	  });
	}
	
	var _default = MarkerView.extend({
	  type: 'markPoint',
	  // updateLayout: function (markPointModel, ecModel, api) {
	  //     ecModel.eachSeries(function (seriesModel) {
	  //         var mpModel = seriesModel.markPointModel;
	  //         if (mpModel) {
	  //             updateMarkerLayout(mpModel.getData(), seriesModel, api);
	  //             this.markerGroupMap.get(seriesModel.id).updateLayout(mpModel);
	  //         }
	  //     }, this);
	  // },
	  updateTransform: function (markPointModel, ecModel, api) {
	    ecModel.eachSeries(function (seriesModel) {
	      var mpModel = seriesModel.markPointModel;
	
	      if (mpModel) {
	        updateMarkerLayout(mpModel.getData(), seriesModel, api);
	        this.markerGroupMap.get(seriesModel.id).updateLayout(mpModel);
	      }
	    }, this);
	  },
	  renderSeries: function (seriesModel, mpModel, ecModel, api) {
	    var coordSys = seriesModel.coordinateSystem;
	    var seriesId = seriesModel.id;
	    var seriesData = seriesModel.getData();
	    var symbolDrawMap = this.markerGroupMap;
	    var symbolDraw = symbolDrawMap.get(seriesId) || symbolDrawMap.set(seriesId, new SymbolDraw());
	    var mpData = createList(coordSys, seriesModel, mpModel); // FIXME
	
	    mpModel.setData(mpData);
	    updateMarkerLayout(mpModel.getData(), seriesModel, api);
	    mpData.each(function (idx) {
	      var itemModel = mpData.getItemModel(idx);
	      var symbol = itemModel.getShallow('symbol');
	      var symbolSize = itemModel.getShallow('symbolSize');
	      var symbolRotate = itemModel.getShallow('symbolRotate');
	      var isFnSymbol = zrUtil.isFunction(symbol);
	      var isFnSymbolSize = zrUtil.isFunction(symbolSize);
	      var isFnSymbolRotate = zrUtil.isFunction(symbolRotate);
	
	      if (isFnSymbol || isFnSymbolSize || isFnSymbolRotate) {
	        var rawIdx = mpModel.getRawValue(idx);
	        var dataParams = mpModel.getDataParams(idx);
	
	        if (isFnSymbol) {
	          symbol = symbol(rawIdx, dataParams);
	        }
	
	        if (isFnSymbolSize) {
	          // FIXME 这里不兼容 ECharts 2.x，2.x 貌似参数是整个数据？
	          symbolSize = symbolSize(rawIdx, dataParams);
	        }
	
	        if (isFnSymbolRotate) {
	          symbolRotate = symbolRotate(rawIdx, dataParams);
	        }
	      }
	
	      mpData.setItemVisual(idx, {
	        symbol: symbol,
	        symbolSize: symbolSize,
	        symbolRotate: symbolRotate,
	        color: itemModel.get('itemStyle.color') || seriesData.getVisual('color')
	      });
	    }); // TODO Text are wrong
	
	    symbolDraw.updateData(mpData);
	    this.group.add(symbolDraw.group); // Set host model for tooltip
	    // FIXME
	
	    mpData.eachItemGraphicEl(function (el) {
	      el.traverse(function (child) {
	        child.dataModel = mpModel;
	      });
	    });
	    symbolDraw.__keep = true;
	    symbolDraw.group.silent = mpModel.get('silent') || seriesModel.get('silent');
	  }
	});
	/**
	 * @inner
	 * @param {module:echarts/coord/*} [coordSys]
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {module:echarts/model/Model} mpModel
	 */
	
	
	function createList(coordSys, seriesModel, mpModel) {
	  var coordDimsInfos;
	
	  if (coordSys) {
	    coordDimsInfos = zrUtil.map(coordSys && coordSys.dimensions, function (coordDim) {
	      var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys
	
	      return zrUtil.defaults({
	        name: coordDim
	      }, info);
	    });
	  } else {
	    coordDimsInfos = [{
	      name: 'value',
	      type: 'float'
	    }];
	  }
	
	  var mpData = new List(coordDimsInfos, mpModel);
	  var dataOpt = zrUtil.map(mpModel.get('data'), zrUtil.curry(markerHelper.dataTransform, seriesModel));
	
	  if (coordSys) {
	    dataOpt = zrUtil.filter(dataOpt, zrUtil.curry(markerHelper.dataFilter, coordSys));
	  }
	
	  mpData.initData(dataOpt, null, coordSys ? markerHelper.dimValueGetter : function (item) {
	    return item.value;
	  });
	  return mpData;
	}
	
	module.exports = _default;

/***/ },
/* 1617 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(742);
	
	__webpack_require__(1574);
	
	__webpack_require__(1571);

/***/ },
/* 1618 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var barPolar = __webpack_require__(1690);
	
	__webpack_require__(473);
	
	__webpack_require__(1567);
	
	__webpack_require__(1621);
	
	__webpack_require__(260);
	
	__webpack_require__(1577);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// For reducing size of echarts.min, barLayoutPolar is required by polar.
	echarts.registerLayout(zrUtil.curry(barPolar, 'bar')); // Polar view
	
	echarts.extendComponentView({
	  type: 'polar'
	});

/***/ },
/* 1619 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(1681);
	
	__webpack_require__(1682);
	
	__webpack_require__(1620);

/***/ },
/* 1620 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var AxisBuilder = __webpack_require__(138);
	
	var graphic = __webpack_require__(16);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
	
	var _default = echarts.extendComponentView({
	  type: 'radar',
	  render: function (radarModel, ecModel, api) {
	    var group = this.group;
	    group.removeAll();
	
	    this._buildAxes(radarModel);
	
	    this._buildSplitLineAndArea(radarModel);
	  },
	  _buildAxes: function (radarModel) {
	    var radar = radarModel.coordinateSystem;
	    var indicatorAxes = radar.getIndicatorAxes();
	    var axisBuilders = zrUtil.map(indicatorAxes, function (indicatorAxis) {
	      var axisBuilder = new AxisBuilder(indicatorAxis.model, {
	        position: [radar.cx, radar.cy],
	        rotation: indicatorAxis.angle,
	        labelDirection: -1,
	        tickDirection: -1,
	        nameDirection: 1
	      });
	      return axisBuilder;
	    });
	    zrUtil.each(axisBuilders, function (axisBuilder) {
	      zrUtil.each(axisBuilderAttrs, axisBuilder.add, axisBuilder);
	      this.group.add(axisBuilder.getGroup());
	    }, this);
	  },
	  _buildSplitLineAndArea: function (radarModel) {
	    var radar = radarModel.coordinateSystem;
	    var indicatorAxes = radar.getIndicatorAxes();
	
	    if (!indicatorAxes.length) {
	      return;
	    }
	
	    var shape = radarModel.get('shape');
	    var splitLineModel = radarModel.getModel('splitLine');
	    var splitAreaModel = radarModel.getModel('splitArea');
	    var lineStyleModel = splitLineModel.getModel('lineStyle');
	    var areaStyleModel = splitAreaModel.getModel('areaStyle');
	    var showSplitLine = splitLineModel.get('show');
	    var showSplitArea = splitAreaModel.get('show');
	    var splitLineColors = lineStyleModel.get('color');
	    var splitAreaColors = areaStyleModel.get('color');
	    splitLineColors = zrUtil.isArray(splitLineColors) ? splitLineColors : [splitLineColors];
	    splitAreaColors = zrUtil.isArray(splitAreaColors) ? splitAreaColors : [splitAreaColors];
	    var splitLines = [];
	    var splitAreas = [];
	
	    function getColorIndex(areaOrLine, areaOrLineColorList, idx) {
	      var colorIndex = idx % areaOrLineColorList.length;
	      areaOrLine[colorIndex] = areaOrLine[colorIndex] || [];
	      return colorIndex;
	    }
	
	    if (shape === 'circle') {
	      var ticksRadius = indicatorAxes[0].getTicksCoords();
	      var cx = radar.cx;
	      var cy = radar.cy;
	
	      for (var i = 0; i < ticksRadius.length; i++) {
	        if (showSplitLine) {
	          var colorIndex = getColorIndex(splitLines, splitLineColors, i);
	          splitLines[colorIndex].push(new graphic.Circle({
	            shape: {
	              cx: cx,
	              cy: cy,
	              r: ticksRadius[i].coord
	            }
	          }));
	        }
	
	        if (showSplitArea && i < ticksRadius.length - 1) {
	          var colorIndex = getColorIndex(splitAreas, splitAreaColors, i);
	          splitAreas[colorIndex].push(new graphic.Ring({
	            shape: {
	              cx: cx,
	              cy: cy,
	              r0: ticksRadius[i].coord,
	              r: ticksRadius[i + 1].coord
	            }
	          }));
	        }
	      }
	    } // Polyyon
	    else {
	        var realSplitNumber;
	        var axesTicksPoints = zrUtil.map(indicatorAxes, function (indicatorAxis, idx) {
	          var ticksCoords = indicatorAxis.getTicksCoords();
	          realSplitNumber = realSplitNumber == null ? ticksCoords.length - 1 : Math.min(ticksCoords.length - 1, realSplitNumber);
	          return zrUtil.map(ticksCoords, function (tickCoord) {
	            return radar.coordToPoint(tickCoord.coord, idx);
	          });
	        });
	        var prevPoints = [];
	
	        for (var i = 0; i <= realSplitNumber; i++) {
	          var points = [];
	
	          for (var j = 0; j < indicatorAxes.length; j++) {
	            points.push(axesTicksPoints[j][i]);
	          } // Close
	
	
	          if (points[0]) {
	            points.push(points[0].slice());
	          } else {}
	
	          if (showSplitLine) {
	            var colorIndex = getColorIndex(splitLines, splitLineColors, i);
	            splitLines[colorIndex].push(new graphic.Polyline({
	              shape: {
	                points: points
	              }
	            }));
	          }
	
	          if (showSplitArea && prevPoints) {
	            var colorIndex = getColorIndex(splitAreas, splitAreaColors, i - 1);
	            splitAreas[colorIndex].push(new graphic.Polygon({
	              shape: {
	                points: points.concat(prevPoints)
	              }
	            }));
	          }
	
	          prevPoints = points.slice().reverse();
	        }
	      }
	
	    var lineStyle = lineStyleModel.getLineStyle();
	    var areaStyle = areaStyleModel.getAreaStyle(); // Add splitArea before splitLine
	
	    zrUtil.each(splitAreas, function (splitAreas, idx) {
	      this.group.add(graphic.mergePath(splitAreas, {
	        style: zrUtil.defaults({
	          stroke: 'none',
	          fill: splitAreaColors[idx % splitAreaColors.length]
	        }, areaStyle),
	        silent: true
	      }));
	    }, this);
	    zrUtil.each(splitLines, function (splitLines, idx) {
	      this.group.add(graphic.mergePath(splitLines, {
	        style: zrUtil.defaults({
	          fill: 'none',
	          stroke: splitLineColors[idx % splitLineColors.length]
	        }, lineStyle),
	        silent: true
	      }));
	    }, this);
	  }
	});
	
	module.exports = _default;

/***/ },
/* 1621 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(473);
	
	__webpack_require__(1572);

/***/ },
/* 1622 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var preprocessor = __webpack_require__(1628);
	
	__webpack_require__(1630);
	
	__webpack_require__(1629);
	
	__webpack_require__(1623);
	
	__webpack_require__(1624);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * DataZoom component entry
	 */
	echarts.registerPreprocessor(preprocessor);

/***/ },
/* 1623 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var TimelineModel = __webpack_require__(1626);
	
	var dataFormatMixin = __webpack_require__(475);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var SliderTimelineModel = TimelineModel.extend({
	  type: 'timeline.slider',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    backgroundColor: 'rgba(0,0,0,0)',
	    // 时间轴背景颜色
	    borderColor: '#ccc',
	    // 时间轴边框颜色
	    borderWidth: 0,
	    // 时间轴边框线宽，单位px，默认为0（无边框）
	    orient: 'horizontal',
	    // 'vertical'
	    inverse: false,
	    tooltip: {
	      // boolean or Object
	      trigger: 'item' // data item may also have tootip attr.
	
	    },
	    symbol: 'emptyCircle',
	    symbolSize: 10,
	    lineStyle: {
	      show: true,
	      width: 2,
	      color: '#304654'
	    },
	    label: {
	      // 文本标签
	      position: 'auto',
	      // auto left right top bottom
	      // When using number, label position is not
	      // restricted by viewRect.
	      // positive: right/bottom, negative: left/top
	      show: true,
	      interval: 'auto',
	      rotate: 0,
	      // formatter: null,
	      // 其余属性默认使用全局文本样式，详见TEXTSTYLE
	      color: '#304654'
	    },
	    itemStyle: {
	      color: '#304654',
	      borderWidth: 1
	    },
	    checkpointStyle: {
	      symbol: 'circle',
	      symbolSize: 13,
	      color: '#c23531',
	      borderWidth: 5,
	      borderColor: 'rgba(194,53,49, 0.5)',
	      animation: true,
	      animationDuration: 300,
	      animationEasing: 'quinticInOut'
	    },
	    controlStyle: {
	      show: true,
	      showPlayBtn: true,
	      showPrevBtn: true,
	      showNextBtn: true,
	      itemSize: 22,
	      itemGap: 12,
	      position: 'left',
	      // 'left' 'right' 'top' 'bottom'
	      playIcon: 'path://M31.6,53C17.5,53,6,41.5,6,27.4S17.5,1.8,31.6,1.8C45.7,1.8,57.2,13.3,57.2,27.4S45.7,53,31.6,53z M31.6,3.3 C18.4,3.3,7.5,14.1,7.5,27.4c0,13.3,10.8,24.1,24.1,24.1C44.9,51.5,55.7,40.7,55.7,27.4C55.7,14.1,44.9,3.3,31.6,3.3z M24.9,21.3 c0-2.2,1.6-3.1,3.5-2l10.5,6.1c1.899,1.1,1.899,2.9,0,4l-10.5,6.1c-1.9,1.1-3.5,0.2-3.5-2V21.3z',
	      // jshint ignore:line
	      stopIcon: 'path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5C17.6,3.5,6.8,14.4,6.8,27.6c0,13.3,10.8,24.1,24.101,24.1C44.2,51.7,55,40.9,55,27.6C54.9,14.4,44.1,3.5,30.9,3.5z M36.9,35.8c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H36c0.5,0,0.9,0.4,0.9,1V35.8z M27.8,35.8 c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H27c0.5,0,0.9,0.4,0.9,1L27.8,35.8L27.8,35.8z',
	      // jshint ignore:line
	      nextIcon: 'path://M18.6,50.8l22.5-22.5c0.2-0.2,0.3-0.4,0.3-0.7c0-0.3-0.1-0.5-0.3-0.7L18.7,4.4c-0.1-0.1-0.2-0.3-0.2-0.5 c0-0.4,0.3-0.8,0.8-0.8c0.2,0,0.5,0.1,0.6,0.3l23.5,23.5l0,0c0.2,0.2,0.3,0.4,0.3,0.7c0,0.3-0.1,0.5-0.3,0.7l-0.1,0.1L19.7,52 c-0.1,0.1-0.3,0.2-0.5,0.2c-0.4,0-0.8-0.3-0.8-0.8C18.4,51.2,18.5,51,18.6,50.8z',
	      // jshint ignore:line
	      prevIcon: 'path://M43,52.8L20.4,30.3c-0.2-0.2-0.3-0.4-0.3-0.7c0-0.3,0.1-0.5,0.3-0.7L42.9,6.4c0.1-0.1,0.2-0.3,0.2-0.5 c0-0.4-0.3-0.8-0.8-0.8c-0.2,0-0.5,0.1-0.6,0.3L18.3,28.8l0,0c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.3,0.1,0.5,0.3,0.7l0.1,0.1L41.9,54 c0.1,0.1,0.3,0.2,0.5,0.2c0.4,0,0.8-0.3,0.8-0.8C43.2,53.2,43.1,53,43,52.8z',
	      // jshint ignore:line
	      color: '#304654',
	      borderColor: '#304654',
	      borderWidth: 1
	    },
	    emphasis: {
	      label: {
	        show: true,
	        // 其余属性默认使用全局文本样式，详见TEXTSTYLE
	        color: '#c23531'
	      },
	      itemStyle: {
	        color: '#c23531'
	      },
	      controlStyle: {
	        color: '#c23531',
	        borderColor: '#c23531',
	        borderWidth: 2
	      }
	    },
	    data: []
	  }
	});
	zrUtil.mixin(SliderTimelineModel, dataFormatMixin);
	var _default = SliderTimelineModel;
	module.exports = _default;

/***/ },
/* 1624 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var BoundingRect = __webpack_require__(42);
	
	var matrix = __webpack_require__(73);
	
	var graphic = __webpack_require__(16);
	
	var layout = __webpack_require__(36);
	
	var TimelineView = __webpack_require__(1627);
	
	var TimelineAxis = __webpack_require__(1625);
	
	var _symbol = __webpack_require__(84);
	
	var createSymbol = _symbol.createSymbol;
	
	var axisHelper = __webpack_require__(93);
	
	var numberUtil = __webpack_require__(20);
	
	var _format = __webpack_require__(40);
	
	var encodeHTML = _format.encodeHTML;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var bind = zrUtil.bind;
	var each = zrUtil.each;
	var PI = Math.PI;
	
	var _default = TimelineView.extend({
	  type: 'timeline.slider',
	  init: function (ecModel, api) {
	    this.api = api;
	    /**
	     * @private
	     * @type {module:echarts/component/timeline/TimelineAxis}
	     */
	
	    this._axis;
	    /**
	     * @private
	     * @type {module:zrender/core/BoundingRect}
	     */
	
	    this._viewRect;
	    /**
	     * @type {number}
	     */
	
	    this._timer;
	    /**
	     * @type {module:zrender/Element}
	     */
	
	    this._currentPointer;
	    /**
	     * @type {module:zrender/container/Group}
	     */
	
	    this._mainGroup;
	    /**
	     * @type {module:zrender/container/Group}
	     */
	
	    this._labelGroup;
	  },
	
	  /**
	   * @override
	   */
	  render: function (timelineModel, ecModel, api, payload) {
	    this.model = timelineModel;
	    this.api = api;
	    this.ecModel = ecModel;
	    this.group.removeAll();
	
	    if (timelineModel.get('show', true)) {
	      var layoutInfo = this._layout(timelineModel, api);
	
	      var mainGroup = this._createGroup('mainGroup');
	
	      var labelGroup = this._createGroup('labelGroup');
	      /**
	       * @private
	       * @type {module:echarts/component/timeline/TimelineAxis}
	       */
	
	
	      var axis = this._axis = this._createAxis(layoutInfo, timelineModel);
	
	      timelineModel.formatTooltip = function (dataIndex) {
	        return encodeHTML(axis.scale.getLabel(dataIndex));
	      };
	
	      each(['AxisLine', 'AxisTick', 'Control', 'CurrentPointer'], function (name) {
	        this['_render' + name](layoutInfo, mainGroup, axis, timelineModel);
	      }, this);
	
	      this._renderAxisLabel(layoutInfo, labelGroup, axis, timelineModel);
	
	      this._position(layoutInfo, timelineModel);
	    }
	
	    this._doPlayStop();
	  },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    this._clearTimer();
	
	    this.group.removeAll();
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    this._clearTimer();
	  },
	  _layout: function (timelineModel, api) {
	    var labelPosOpt = timelineModel.get('label.position');
	    var orient = timelineModel.get('orient');
	    var viewRect = getViewRect(timelineModel, api); // Auto label offset.
	
	    if (labelPosOpt == null || labelPosOpt === 'auto') {
	      labelPosOpt = orient === 'horizontal' ? viewRect.y + viewRect.height / 2 < api.getHeight() / 2 ? '-' : '+' : viewRect.x + viewRect.width / 2 < api.getWidth() / 2 ? '+' : '-';
	    } else if (isNaN(labelPosOpt)) {
	      labelPosOpt = {
	        horizontal: {
	          top: '-',
	          bottom: '+'
	        },
	        vertical: {
	          left: '-',
	          right: '+'
	        }
	      }[orient][labelPosOpt];
	    }
	
	    var labelAlignMap = {
	      horizontal: 'center',
	      vertical: labelPosOpt >= 0 || labelPosOpt === '+' ? 'left' : 'right'
	    };
	    var labelBaselineMap = {
	      horizontal: labelPosOpt >= 0 || labelPosOpt === '+' ? 'top' : 'bottom',
	      vertical: 'middle'
	    };
	    var rotationMap = {
	      horizontal: 0,
	      vertical: PI / 2
	    }; // Position
	
	    var mainLength = orient === 'vertical' ? viewRect.height : viewRect.width;
	    var controlModel = timelineModel.getModel('controlStyle');
	    var showControl = controlModel.get('show', true);
	    var controlSize = showControl ? controlModel.get('itemSize') : 0;
	    var controlGap = showControl ? controlModel.get('itemGap') : 0;
	    var sizePlusGap = controlSize + controlGap; // Special label rotate.
	
	    var labelRotation = timelineModel.get('label.rotate') || 0;
	    labelRotation = labelRotation * PI / 180; // To radian.
	
	    var playPosition;
	    var prevBtnPosition;
	    var nextBtnPosition;
	    var axisExtent;
	    var controlPosition = controlModel.get('position', true);
	    var showPlayBtn = showControl && controlModel.get('showPlayBtn', true);
	    var showPrevBtn = showControl && controlModel.get('showPrevBtn', true);
	    var showNextBtn = showControl && controlModel.get('showNextBtn', true);
	    var xLeft = 0;
	    var xRight = mainLength; // position[0] means left, position[1] means middle.
	
	    if (controlPosition === 'left' || controlPosition === 'bottom') {
	      showPlayBtn && (playPosition = [0, 0], xLeft += sizePlusGap);
	      showPrevBtn && (prevBtnPosition = [xLeft, 0], xLeft += sizePlusGap);
	      showNextBtn && (nextBtnPosition = [xRight - controlSize, 0], xRight -= sizePlusGap);
	    } else {
	      // 'top' 'right'
	      showPlayBtn && (playPosition = [xRight - controlSize, 0], xRight -= sizePlusGap);
	      showPrevBtn && (prevBtnPosition = [0, 0], xLeft += sizePlusGap);
	      showNextBtn && (nextBtnPosition = [xRight - controlSize, 0], xRight -= sizePlusGap);
	    }
	
	    axisExtent = [xLeft, xRight];
	
	    if (timelineModel.get('inverse')) {
	      axisExtent.reverse();
	    }
	
	    return {
	      viewRect: viewRect,
	      mainLength: mainLength,
	      orient: orient,
	      rotation: rotationMap[orient],
	      labelRotation: labelRotation,
	      labelPosOpt: labelPosOpt,
	      labelAlign: timelineModel.get('label.align') || labelAlignMap[orient],
	      labelBaseline: timelineModel.get('label.verticalAlign') || timelineModel.get('label.baseline') || labelBaselineMap[orient],
	      // Based on mainGroup.
	      playPosition: playPosition,
	      prevBtnPosition: prevBtnPosition,
	      nextBtnPosition: nextBtnPosition,
	      axisExtent: axisExtent,
	      controlSize: controlSize,
	      controlGap: controlGap
	    };
	  },
	  _position: function (layoutInfo, timelineModel) {
	    // Position is be called finally, because bounding rect is needed for
	    // adapt content to fill viewRect (auto adapt offset).
	    // Timeline may be not all in the viewRect when 'offset' is specified
	    // as a number, because it is more appropriate that label aligns at
	    // 'offset' but not the other edge defined by viewRect.
	    var mainGroup = this._mainGroup;
	    var labelGroup = this._labelGroup;
	    var viewRect = layoutInfo.viewRect;
	
	    if (layoutInfo.orient === 'vertical') {
	      // transform to horizontal, inverse rotate by left-top point.
	      var m = matrix.create();
	      var rotateOriginX = viewRect.x;
	      var rotateOriginY = viewRect.y + viewRect.height;
	      matrix.translate(m, m, [-rotateOriginX, -rotateOriginY]);
	      matrix.rotate(m, m, -PI / 2);
	      matrix.translate(m, m, [rotateOriginX, rotateOriginY]);
	      viewRect = viewRect.clone();
	      viewRect.applyTransform(m);
	    }
	
	    var viewBound = getBound(viewRect);
	    var mainBound = getBound(mainGroup.getBoundingRect());
	    var labelBound = getBound(labelGroup.getBoundingRect());
	    var mainPosition = mainGroup.position;
	    var labelsPosition = labelGroup.position;
	    labelsPosition[0] = mainPosition[0] = viewBound[0][0];
	    var labelPosOpt = layoutInfo.labelPosOpt;
	
	    if (isNaN(labelPosOpt)) {
	      // '+' or '-'
	      var mainBoundIdx = labelPosOpt === '+' ? 0 : 1;
	      toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
	      toBound(labelsPosition, labelBound, viewBound, 1, 1 - mainBoundIdx);
	    } else {
	      var mainBoundIdx = labelPosOpt >= 0 ? 0 : 1;
	      toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
	      labelsPosition[1] = mainPosition[1] + labelPosOpt;
	    }
	
	    mainGroup.attr('position', mainPosition);
	    labelGroup.attr('position', labelsPosition);
	    mainGroup.rotation = labelGroup.rotation = layoutInfo.rotation;
	    setOrigin(mainGroup);
	    setOrigin(labelGroup);
	
	    function setOrigin(targetGroup) {
	      var pos = targetGroup.position;
	      targetGroup.origin = [viewBound[0][0] - pos[0], viewBound[1][0] - pos[1]];
	    }
	
	    function getBound(rect) {
	      // [[xmin, xmax], [ymin, ymax]]
	      return [[rect.x, rect.x + rect.width], [rect.y, rect.y + rect.height]];
	    }
	
	    function toBound(fromPos, from, to, dimIdx, boundIdx) {
	      fromPos[dimIdx] += to[dimIdx][boundIdx] - from[dimIdx][boundIdx];
	    }
	  },
	  _createAxis: function (layoutInfo, timelineModel) {
	    var data = timelineModel.getData();
	    var axisType = timelineModel.get('axisType');
	    var scale = axisHelper.createScaleByModel(timelineModel, axisType); // Customize scale. The `tickValue` is `dataIndex`.
	
	    scale.getTicks = function () {
	      return data.mapArray(['value'], function (value) {
	        return value;
	      });
	    };
	
	    var dataExtent = data.getDataExtent('value');
	    scale.setExtent(dataExtent[0], dataExtent[1]);
	    scale.niceTicks();
	    var axis = new TimelineAxis('value', scale, layoutInfo.axisExtent, axisType);
	    axis.model = timelineModel;
	    return axis;
	  },
	  _createGroup: function (name) {
	    var newGroup = this['_' + name] = new graphic.Group();
	    this.group.add(newGroup);
	    return newGroup;
	  },
	  _renderAxisLine: function (layoutInfo, group, axis, timelineModel) {
	    var axisExtent = axis.getExtent();
	
	    if (!timelineModel.get('lineStyle.show')) {
	      return;
	    }
	
	    group.add(new graphic.Line({
	      shape: {
	        x1: axisExtent[0],
	        y1: 0,
	        x2: axisExtent[1],
	        y2: 0
	      },
	      style: zrUtil.extend({
	        lineCap: 'round'
	      }, timelineModel.getModel('lineStyle').getLineStyle()),
	      silent: true,
	      z2: 1
	    }));
	  },
	
	  /**
	   * @private
	   */
	  _renderAxisTick: function (layoutInfo, group, axis, timelineModel) {
	    var data = timelineModel.getData(); // Show all ticks, despite ignoring strategy.
	
	    var ticks = axis.scale.getTicks(); // The value is dataIndex, see the costomized scale.
	
	    each(ticks, function (value) {
	      var tickCoord = axis.dataToCoord(value);
	      var itemModel = data.getItemModel(value);
	      var itemStyleModel = itemModel.getModel('itemStyle');
	      var hoverStyleModel = itemModel.getModel('emphasis.itemStyle');
	      var symbolOpt = {
	        position: [tickCoord, 0],
	        onclick: bind(this._changeTimeline, this, value)
	      };
	      var el = giveSymbol(itemModel, itemStyleModel, group, symbolOpt);
	      graphic.setHoverStyle(el, hoverStyleModel.getItemStyle());
	
	      if (itemModel.get('tooltip')) {
	        el.dataIndex = value;
	        el.dataModel = timelineModel;
	      } else {
	        el.dataIndex = el.dataModel = null;
	      }
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _renderAxisLabel: function (layoutInfo, group, axis, timelineModel) {
	    var labelModel = axis.getLabelModel();
	
	    if (!labelModel.get('show')) {
	      return;
	    }
	
	    var data = timelineModel.getData();
	    var labels = axis.getViewLabels();
	    each(labels, function (labelItem) {
	      // The tickValue is dataIndex, see the costomized scale.
	      var dataIndex = labelItem.tickValue;
	      var itemModel = data.getItemModel(dataIndex);
	      var normalLabelModel = itemModel.getModel('label');
	      var hoverLabelModel = itemModel.getModel('emphasis.label');
	      var tickCoord = axis.dataToCoord(labelItem.tickValue);
	      var textEl = new graphic.Text({
	        position: [tickCoord, 0],
	        rotation: layoutInfo.labelRotation - layoutInfo.rotation,
	        onclick: bind(this._changeTimeline, this, dataIndex),
	        silent: false
	      });
	      graphic.setTextStyle(textEl.style, normalLabelModel, {
	        text: labelItem.formattedLabel,
	        textAlign: layoutInfo.labelAlign,
	        textVerticalAlign: layoutInfo.labelBaseline
	      });
	      group.add(textEl);
	      graphic.setHoverStyle(textEl, graphic.setTextStyle({}, hoverLabelModel));
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _renderControl: function (layoutInfo, group, axis, timelineModel) {
	    var controlSize = layoutInfo.controlSize;
	    var rotation = layoutInfo.rotation;
	    var itemStyle = timelineModel.getModel('controlStyle').getItemStyle();
	    var hoverStyle = timelineModel.getModel('emphasis.controlStyle').getItemStyle();
	    var rect = [0, -controlSize / 2, controlSize, controlSize];
	    var playState = timelineModel.getPlayState();
	    var inverse = timelineModel.get('inverse', true);
	    makeBtn(layoutInfo.nextBtnPosition, 'controlStyle.nextIcon', bind(this._changeTimeline, this, inverse ? '-' : '+'));
	    makeBtn(layoutInfo.prevBtnPosition, 'controlStyle.prevIcon', bind(this._changeTimeline, this, inverse ? '+' : '-'));
	    makeBtn(layoutInfo.playPosition, 'controlStyle.' + (playState ? 'stopIcon' : 'playIcon'), bind(this._handlePlayClick, this, !playState), true);
	
	    function makeBtn(position, iconPath, onclick, willRotate) {
	      if (!position) {
	        return;
	      }
	
	      var opt = {
	        position: position,
	        origin: [controlSize / 2, 0],
	        rotation: willRotate ? -rotation : 0,
	        rectHover: true,
	        style: itemStyle,
	        onclick: onclick
	      };
	      var btn = makeIcon(timelineModel, iconPath, rect, opt);
	      group.add(btn);
	      graphic.setHoverStyle(btn, hoverStyle);
	    }
	  },
	  _renderCurrentPointer: function (layoutInfo, group, axis, timelineModel) {
	    var data = timelineModel.getData();
	    var currentIndex = timelineModel.getCurrentIndex();
	    var pointerModel = data.getItemModel(currentIndex).getModel('checkpointStyle');
	    var me = this;
	    var callback = {
	      onCreate: function (pointer) {
	        pointer.draggable = true;
	        pointer.drift = bind(me._handlePointerDrag, me);
	        pointer.ondragend = bind(me._handlePointerDragend, me);
	        pointerMoveTo(pointer, currentIndex, axis, timelineModel, true);
	      },
	      onUpdate: function (pointer) {
	        pointerMoveTo(pointer, currentIndex, axis, timelineModel);
	      }
	    }; // Reuse when exists, for animation and drag.
	
	    this._currentPointer = giveSymbol(pointerModel, pointerModel, this._mainGroup, {}, this._currentPointer, callback);
	  },
	  _handlePlayClick: function (nextState) {
	    this._clearTimer();
	
	    this.api.dispatchAction({
	      type: 'timelinePlayChange',
	      playState: nextState,
	      from: this.uid
	    });
	  },
	  _handlePointerDrag: function (dx, dy, e) {
	    this._clearTimer();
	
	    this._pointerChangeTimeline([e.offsetX, e.offsetY]);
	  },
	  _handlePointerDragend: function (e) {
	    this._pointerChangeTimeline([e.offsetX, e.offsetY], true);
	  },
	  _pointerChangeTimeline: function (mousePos, trigger) {
	    var toCoord = this._toAxisCoord(mousePos)[0];
	
	    var axis = this._axis;
	    var axisExtent = numberUtil.asc(axis.getExtent().slice());
	    toCoord > axisExtent[1] && (toCoord = axisExtent[1]);
	    toCoord < axisExtent[0] && (toCoord = axisExtent[0]);
	    this._currentPointer.position[0] = toCoord;
	
	    this._currentPointer.dirty();
	
	    var targetDataIndex = this._findNearestTick(toCoord);
	
	    var timelineModel = this.model;
	
	    if (trigger || targetDataIndex !== timelineModel.getCurrentIndex() && timelineModel.get('realtime')) {
	      this._changeTimeline(targetDataIndex);
	    }
	  },
	  _doPlayStop: function () {
	    this._clearTimer();
	
	    if (this.model.getPlayState()) {
	      this._timer = setTimeout(bind(handleFrame, this), this.model.get('playInterval'));
	    }
	
	    function handleFrame() {
	      // Do not cache
	      var timelineModel = this.model;
	
	      this._changeTimeline(timelineModel.getCurrentIndex() + (timelineModel.get('rewind', true) ? -1 : 1));
	    }
	  },
	  _toAxisCoord: function (vertex) {
	    var trans = this._mainGroup.getLocalTransform();
	
	    return graphic.applyTransform(vertex, trans, true);
	  },
	  _findNearestTick: function (axisCoord) {
	    var data = this.model.getData();
	    var dist = Infinity;
	    var targetDataIndex;
	    var axis = this._axis;
	    data.each(['value'], function (value, dataIndex) {
	      var coord = axis.dataToCoord(value);
	      var d = Math.abs(coord - axisCoord);
	
	      if (d < dist) {
	        dist = d;
	        targetDataIndex = dataIndex;
	      }
	    });
	    return targetDataIndex;
	  },
	  _clearTimer: function () {
	    if (this._timer) {
	      clearTimeout(this._timer);
	      this._timer = null;
	    }
	  },
	  _changeTimeline: function (nextIndex) {
	    var currentIndex = this.model.getCurrentIndex();
	
	    if (nextIndex === '+') {
	      nextIndex = currentIndex + 1;
	    } else if (nextIndex === '-') {
	      nextIndex = currentIndex - 1;
	    }
	
	    this.api.dispatchAction({
	      type: 'timelineChange',
	      currentIndex: nextIndex,
	      from: this.uid
	    });
	  }
	});
	
	function getViewRect(model, api) {
	  return layout.getLayoutRect(model.getBoxLayoutParams(), {
	    width: api.getWidth(),
	    height: api.getHeight()
	  }, model.get('padding'));
	}
	
	function makeIcon(timelineModel, objPath, rect, opts) {
	  var style = opts.style;
	  var icon = graphic.createIcon(timelineModel.get(objPath), opts || {}, new BoundingRect(rect[0], rect[1], rect[2], rect[3])); // TODO createIcon won't use style in opt.
	
	  if (style) {
	    icon.setStyle(style);
	  }
	
	  return icon;
	}
	/**
	 * Create symbol or update symbol
	 * opt: basic position and event handlers
	 */
	
	
	function giveSymbol(hostModel, itemStyleModel, group, opt, symbol, callback) {
	  var color = itemStyleModel.get('color');
	
	  if (!symbol) {
	    var symbolType = hostModel.get('symbol');
	    symbol = createSymbol(symbolType, -1, -1, 2, 2, color);
	    symbol.setStyle('strokeNoScale', true);
	    group.add(symbol);
	    callback && callback.onCreate(symbol);
	  } else {
	    symbol.setColor(color);
	    group.add(symbol); // Group may be new, also need to add.
	
	    callback && callback.onUpdate(symbol);
	  } // Style
	
	
	  var itemStyle = itemStyleModel.getItemStyle(['color', 'symbol', 'symbolSize']);
	  symbol.setStyle(itemStyle); // Transform and events.
	
	  opt = zrUtil.merge({
	    rectHover: true,
	    z2: 100
	  }, opt, true);
	  var symbolSize = hostModel.get('symbolSize');
	  symbolSize = symbolSize instanceof Array ? symbolSize.slice() : [+symbolSize, +symbolSize];
	  symbolSize[0] /= 2;
	  symbolSize[1] /= 2;
	  opt.scale = symbolSize;
	  var symbolOffset = hostModel.get('symbolOffset');
	
	  if (symbolOffset) {
	    var pos = opt.position = opt.position || [0, 0];
	    pos[0] += numberUtil.parsePercent(symbolOffset[0], symbolSize[0]);
	    pos[1] += numberUtil.parsePercent(symbolOffset[1], symbolSize[1]);
	  }
	
	  var symbolRotate = hostModel.get('symbolRotate');
	  opt.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
	  symbol.attr(opt); // FIXME
	  // (1) When symbol.style.strokeNoScale is true and updateTransform is not performed,
	  // getBoundingRect will return wrong result.
	  // (This is supposed to be resolved in zrender, but it is a little difficult to
	  // leverage performance and auto updateTransform)
	  // (2) All of ancesters of symbol do not scale, so we can just updateTransform symbol.
	
	  symbol.updateTransform();
	  return symbol;
	}
	
	function pointerMoveTo(pointer, dataIndex, axis, timelineModel, noAnimation) {
	  if (pointer.dragging) {
	    return;
	  }
	
	  var pointerModel = timelineModel.getModel('checkpointStyle');
	  var toCoord = axis.dataToCoord(timelineModel.getData().get(['value'], dataIndex));
	
	  if (noAnimation || !pointerModel.get('animation', true)) {
	    pointer.attr({
	      position: [toCoord, 0]
	    });
	  } else {
	    pointer.stopAnimation(true);
	    pointer.animateTo({
	      position: [toCoord, 0]
	    }, pointerModel.get('animationDuration', true), pointerModel.get('animationEasing', true));
	  }
	}
	
	module.exports = _default;

/***/ },
/* 1625 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var Axis = __webpack_require__(140);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Extend axis 2d
	 * @constructor module:echarts/coord/cartesian/Axis2D
	 * @extends {module:echarts/coord/cartesian/Axis}
	 * @param {string} dim
	 * @param {*} scale
	 * @param {Array.<number>} coordExtent
	 * @param {string} axisType
	 * @param {string} position
	 */
	var TimelineAxis = function (dim, scale, coordExtent, axisType) {
	  Axis.call(this, dim, scale, coordExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = axisType || 'value';
	  /**
	   * Axis model
	   * @param {module:echarts/component/TimelineModel}
	   */
	
	  this.model = null;
	};
	
	TimelineAxis.prototype = {
	  constructor: TimelineAxis,
	
	  /**
	   * @override
	   */
	  getLabelModel: function () {
	    return this.model.getModel('label');
	  },
	
	  /**
	   * @override
	   */
	  isHorizontal: function () {
	    return this.model.get('orient') === 'horizontal';
	  }
	};
	zrUtil.inherits(TimelineAxis, Axis);
	var _default = TimelineAxis;
	module.exports = _default;

/***/ },
/* 1626 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var ComponentModel = __webpack_require__(57);
	
	var List = __webpack_require__(83);
	
	var modelUtil = __webpack_require__(24);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var TimelineModel = ComponentModel.extend({
	  type: 'timeline',
	  layoutMode: 'box',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    zlevel: 0,
	    // 一级层叠
	    z: 4,
	    // 二级层叠
	    show: true,
	    axisType: 'time',
	    // 模式是时间类型，支持 value, category
	    realtime: true,
	    left: '20%',
	    top: null,
	    right: '20%',
	    bottom: 0,
	    width: null,
	    height: 40,
	    padding: 5,
	    controlPosition: 'left',
	    // 'left' 'right' 'top' 'bottom' 'none'
	    autoPlay: false,
	    rewind: false,
	    // 反向播放
	    loop: true,
	    playInterval: 2000,
	    // 播放时间间隔，单位ms
	    currentIndex: 0,
	    itemStyle: {},
	    label: {
	      color: '#000'
	    },
	    data: []
	  },
	
	  /**
	   * @override
	   */
	  init: function (option, parentModel, ecModel) {
	    /**
	     * @private
	     * @type {module:echarts/data/List}
	     */
	    this._data;
	    /**
	     * @private
	     * @type {Array.<string>}
	     */
	
	    this._names;
	    this.mergeDefaultAndTheme(option, ecModel);
	
	    this._initData();
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function (option) {
	    TimelineModel.superApply(this, 'mergeOption', arguments);
	
	    this._initData();
	  },
	
	  /**
	   * @param {number} [currentIndex]
	   */
	  setCurrentIndex: function (currentIndex) {
	    if (currentIndex == null) {
	      currentIndex = this.option.currentIndex;
	    }
	
	    var count = this._data.count();
	
	    if (this.option.loop) {
	      currentIndex = (currentIndex % count + count) % count;
	    } else {
	      currentIndex >= count && (currentIndex = count - 1);
	      currentIndex < 0 && (currentIndex = 0);
	    }
	
	    this.option.currentIndex = currentIndex;
	  },
	
	  /**
	   * @return {number} currentIndex
	   */
	  getCurrentIndex: function () {
	    return this.option.currentIndex;
	  },
	
	  /**
	   * @return {boolean}
	   */
	  isIndexMax: function () {
	    return this.getCurrentIndex() >= this._data.count() - 1;
	  },
	
	  /**
	   * @param {boolean} state true: play, false: stop
	   */
	  setPlayState: function (state) {
	    this.option.autoPlay = !!state;
	  },
	
	  /**
	   * @return {boolean} true: play, false: stop
	   */
	  getPlayState: function () {
	    return !!this.option.autoPlay;
	  },
	
	  /**
	   * @private
	   */
	  _initData: function () {
	    var thisOption = this.option;
	    var dataArr = thisOption.data || [];
	    var axisType = thisOption.axisType;
	    var names = this._names = [];
	
	    if (axisType === 'category') {
	      var idxArr = [];
	      zrUtil.each(dataArr, function (item, index) {
	        var value = modelUtil.getDataItemValue(item);
	        var newItem;
	
	        if (zrUtil.isObject(item)) {
	          newItem = zrUtil.clone(item);
	          newItem.value = index;
	        } else {
	          newItem = index;
	        }
	
	        idxArr.push(newItem);
	
	        if (!zrUtil.isString(value) && (value == null || isNaN(value))) {
	          value = '';
	        }
	
	        names.push(value + '');
	      });
	      dataArr = idxArr;
	    }
	
	    var dimType = {
	      category: 'ordinal',
	      time: 'time'
	    }[axisType] || 'number';
	    var data = this._data = new List([{
	      name: 'value',
	      type: dimType
	    }], this);
	    data.initData(dataArr, names);
	  },
	  getData: function () {
	    return this._data;
	  },
	
	  /**
	   * @public
	   * @return {Array.<string>} categoreis
	   */
	  getCategories: function () {
	    if (this.get('axisType') === 'category') {
	      return this._names.slice();
	    }
	  }
	});
	var _default = TimelineModel;
	module.exports = _default;

/***/ },
/* 1627 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var ComponentView = __webpack_require__(340);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = ComponentView.extend({
	  type: 'timeline'
	});
	
	module.exports = _default;

/***/ },
/* 1628 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(option) {
	  var timelineOpt = option && option.timeline;
	
	  if (!zrUtil.isArray(timelineOpt)) {
	    timelineOpt = timelineOpt ? [timelineOpt] : [];
	  }
	
	  zrUtil.each(timelineOpt, function (opt) {
	    if (!opt) {
	      return;
	    }
	
	    compatibleEC2(opt);
	  });
	}
	
	function compatibleEC2(opt) {
	  var type = opt.type;
	  var ec2Types = {
	    'number': 'value',
	    'time': 'time'
	  }; // Compatible with ec2
	
	  if (ec2Types[type]) {
	    opt.axisType = ec2Types[type];
	    delete opt.type;
	  }
	
	  transferItem(opt);
	
	  if (has(opt, 'controlPosition')) {
	    var controlStyle = opt.controlStyle || (opt.controlStyle = {});
	
	    if (!has(controlStyle, 'position')) {
	      controlStyle.position = opt.controlPosition;
	    }
	
	    if (controlStyle.position === 'none' && !has(controlStyle, 'show')) {
	      controlStyle.show = false;
	      delete controlStyle.position;
	    }
	
	    delete opt.controlPosition;
	  }
	
	  zrUtil.each(opt.data || [], function (dataItem) {
	    if (zrUtil.isObject(dataItem) && !zrUtil.isArray(dataItem)) {
	      if (!has(dataItem, 'value') && has(dataItem, 'name')) {
	        // In ec2, using name as value.
	        dataItem.value = dataItem.name;
	      }
	
	      transferItem(dataItem);
	    }
	  });
	}
	
	function transferItem(opt) {
	  var itemStyle = opt.itemStyle || (opt.itemStyle = {});
	  var itemStyleEmphasis = itemStyle.emphasis || (itemStyle.emphasis = {}); // Transfer label out
	
	  var label = opt.label || opt.label || {};
	  var labelNormal = label.normal || (label.normal = {});
	  var excludeLabelAttr = {
	    normal: 1,
	    emphasis: 1
	  };
	  zrUtil.each(label, function (value, name) {
	    if (!excludeLabelAttr[name] && !has(labelNormal, name)) {
	      labelNormal[name] = value;
	    }
	  });
	
	  if (itemStyleEmphasis.label && !has(label, 'emphasis')) {
	    label.emphasis = itemStyleEmphasis.label;
	    delete itemStyleEmphasis.label;
	  }
	}
	
	function has(obj, attr) {
	  return obj.hasOwnProperty(attr);
	}
	
	module.exports = _default;

/***/ },
/* 1629 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerAction({
	  type: 'timelineChange',
	  event: 'timelineChanged',
	  update: 'prepareAndUpdate'
	}, function (payload, ecModel) {
	  var timelineModel = ecModel.getComponent('timeline');
	
	  if (timelineModel && payload.currentIndex != null) {
	    timelineModel.setCurrentIndex(payload.currentIndex);
	
	    if (!timelineModel.get('loop', true) && timelineModel.isIndexMax()) {
	      timelineModel.setPlayState(false);
	    }
	  } // Set normalized currentIndex to payload.
	
	
	  ecModel.resetOption('timeline');
	  return zrUtil.defaults({
	    currentIndex: timelineModel.option.currentIndex
	  }, payload);
	});
	echarts.registerAction({
	  type: 'timelinePlayChange',
	  event: 'timelinePlayChanged',
	  update: 'update'
	}, function (payload, ecModel) {
	  var timelineModel = ecModel.getComponent('timeline');
	
	  if (timelineModel && payload.playState != null) {
	    timelineModel.setPlayState(payload.playState);
	  }
	});

/***/ },
/* 1630 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Component = __webpack_require__(57);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	Component.registerSubTypeDefaulter('timeline', function () {
	  // Only slider now.
	  return 'slider';
	});

/***/ },
/* 1631 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var echarts = __webpack_require__(13);
	
	var graphic = __webpack_require__(16);
	
	var _layout = __webpack_require__(36);
	
	var getLayoutRect = _layout.getLayoutRect;
	
	var _format = __webpack_require__(40);
	
	var windowOpen = _format.windowOpen;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Model
	echarts.extendComponentModel({
	  type: 'title',
	  layoutMode: {
	    type: 'box',
	    ignoreSize: true
	  },
	  defaultOption: {
	    // 一级层叠
	    zlevel: 0,
	    // 二级层叠
	    z: 6,
	    show: true,
	    text: '',
	    // 超链接跳转
	    // link: null,
	    // 仅支持self | blank
	    target: 'blank',
	    subtext: '',
	    // 超链接跳转
	    // sublink: null,
	    // 仅支持self | blank
	    subtarget: 'blank',
	    // 'center' ¦ 'left' ¦ 'right'
	    // ¦ {number}（x坐标，单位px）
	    left: 0,
	    // 'top' ¦ 'bottom' ¦ 'center'
	    // ¦ {number}（y坐标，单位px）
	    top: 0,
	    // 水平对齐
	    // 'auto' | 'left' | 'right' | 'center'
	    // 默认根据 left 的位置判断是左对齐还是右对齐
	    // textAlign: null
	    //
	    // 垂直对齐
	    // 'auto' | 'top' | 'bottom' | 'middle'
	    // 默认根据 top 位置判断是上对齐还是下对齐
	    // textVerticalAlign: null
	    // textBaseline: null // The same as textVerticalAlign.
	    backgroundColor: 'rgba(0,0,0,0)',
	    // 标题边框颜色
	    borderColor: '#ccc',
	    // 标题边框线宽，单位px，默认为0（无边框）
	    borderWidth: 0,
	    // 标题内边距，单位px，默认各方向内边距为5，
	    // 接受数组分别设定上右下左边距，同css
	    padding: 5,
	    // 主副标题纵向间隔，单位px，默认为10，
	    itemGap: 10,
	    textStyle: {
	      fontSize: 18,
	      fontWeight: 'bolder',
	      color: '#333'
	    },
	    subtextStyle: {
	      color: '#aaa'
	    }
	  }
	}); // View
	
	echarts.extendComponentView({
	  type: 'title',
	  render: function (titleModel, ecModel, api) {
	    this.group.removeAll();
	
	    if (!titleModel.get('show')) {
	      return;
	    }
	
	    var group = this.group;
	    var textStyleModel = titleModel.getModel('textStyle');
	    var subtextStyleModel = titleModel.getModel('subtextStyle');
	    var textAlign = titleModel.get('textAlign');
	    var textVerticalAlign = zrUtil.retrieve2(titleModel.get('textBaseline'), titleModel.get('textVerticalAlign'));
	    var textEl = new graphic.Text({
	      style: graphic.setTextStyle({}, textStyleModel, {
	        text: titleModel.get('text'),
	        textFill: textStyleModel.getTextColor()
	      }, {
	        disableBox: true
	      }),
	      z2: 10
	    });
	    var textRect = textEl.getBoundingRect();
	    var subText = titleModel.get('subtext');
	    var subTextEl = new graphic.Text({
	      style: graphic.setTextStyle({}, subtextStyleModel, {
	        text: subText,
	        textFill: subtextStyleModel.getTextColor(),
	        y: textRect.height + titleModel.get('itemGap'),
	        textVerticalAlign: 'top'
	      }, {
	        disableBox: true
	      }),
	      z2: 10
	    });
	    var link = titleModel.get('link');
	    var sublink = titleModel.get('sublink');
	    var triggerEvent = titleModel.get('triggerEvent', true);
	    textEl.silent = !link && !triggerEvent;
	    subTextEl.silent = !sublink && !triggerEvent;
	
	    if (link) {
	      textEl.on('click', function () {
	        windowOpen(link, '_' + titleModel.get('target'));
	      });
	    }
	
	    if (sublink) {
	      subTextEl.on('click', function () {
	        windowOpen(sublink, '_' + titleModel.get('subtarget'));
	      });
	    }
	
	    textEl.eventData = subTextEl.eventData = triggerEvent ? {
	      componentType: 'title',
	      componentIndex: titleModel.componentIndex
	    } : null;
	    group.add(textEl);
	    subText && group.add(subTextEl); // If no subText, but add subTextEl, there will be an empty line.
	
	    var groupRect = group.getBoundingRect();
	    var layoutOption = titleModel.getBoxLayoutParams();
	    layoutOption.width = groupRect.width;
	    layoutOption.height = groupRect.height;
	    var layoutRect = getLayoutRect(layoutOption, {
	      width: api.getWidth(),
	      height: api.getHeight()
	    }, titleModel.get('padding')); // Adjust text align based on position
	
	    if (!textAlign) {
	      // Align left if title is on the left. center and right is same
	      textAlign = titleModel.get('left') || titleModel.get('right');
	
	      if (textAlign === 'middle') {
	        textAlign = 'center';
	      } // Adjust layout by text align
	
	
	      if (textAlign === 'right') {
	        layoutRect.x += layoutRect.width;
	      } else if (textAlign === 'center') {
	        layoutRect.x += layoutRect.width / 2;
	      }
	    }
	
	    if (!textVerticalAlign) {
	      textVerticalAlign = titleModel.get('top') || titleModel.get('bottom');
	
	      if (textVerticalAlign === 'center') {
	        textVerticalAlign = 'middle';
	      }
	
	      if (textVerticalAlign === 'bottom') {
	        layoutRect.y += layoutRect.height;
	      } else if (textVerticalAlign === 'middle') {
	        layoutRect.y += layoutRect.height / 2;
	      }
	
	      textVerticalAlign = textVerticalAlign || 'top';
	    }
	
	    group.attr('position', [layoutRect.x, layoutRect.y]);
	    var alignStyle = {
	      textAlign: textAlign,
	      textVerticalAlign: textVerticalAlign
	    };
	    textEl.setStyle(alignStyle);
	    subTextEl.setStyle(alignStyle); // Render background
	    // Get groupRect again because textAlign has been changed
	
	    groupRect = group.getBoundingRect();
	    var padding = layoutRect.margin;
	    var style = titleModel.getItemStyle(['color', 'opacity']);
	    style.fill = titleModel.get('backgroundColor');
	    var rect = new graphic.Rect({
	      shape: {
	        x: groupRect.x - padding[3],
	        y: groupRect.y - padding[0],
	        width: groupRect.width + padding[1] + padding[3],
	        height: groupRect.height + padding[0] + padding[2],
	        r: titleModel.get('borderRadius')
	      },
	      style: style,
	      subPixelOptimize: true,
	      silent: true
	    });
	    group.add(rect);
	  }
	});

/***/ },
/* 1632 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(1633);
	
	__webpack_require__(1634);
	
	__webpack_require__(1640);
	
	__webpack_require__(1638);
	
	__webpack_require__(1636);
	
	__webpack_require__(1637);
	
	__webpack_require__(1639);

/***/ },
/* 1633 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var featureManager = __webpack_require__(139);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var ToolboxModel = echarts.extendComponentModel({
	  type: 'toolbox',
	  layoutMode: {
	    type: 'box',
	    ignoreSize: true
	  },
	  optionUpdated: function () {
	    ToolboxModel.superApply(this, 'optionUpdated', arguments);
	    zrUtil.each(this.option.feature, function (featureOpt, featureName) {
	      var Feature = featureManager.get(featureName);
	      Feature && zrUtil.merge(featureOpt, Feature.defaultOption);
	    });
	  },
	  defaultOption: {
	    show: true,
	    z: 6,
	    zlevel: 0,
	    orient: 'horizontal',
	    left: 'right',
	    top: 'top',
	    // right
	    // bottom
	    backgroundColor: 'transparent',
	    borderColor: '#ccc',
	    borderRadius: 0,
	    borderWidth: 0,
	    padding: 5,
	    itemSize: 15,
	    itemGap: 8,
	    showTitle: true,
	    iconStyle: {
	      borderColor: '#666',
	      color: 'none'
	    },
	    emphasis: {
	      iconStyle: {
	        borderColor: '#3E98C5'
	      }
	    },
	    // textStyle: {},
	    // feature
	    tooltip: {
	      show: false
	    }
	  }
	});
	var _default = ToolboxModel;
	module.exports = _default;

/***/ },
/* 1634 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var textContain = __webpack_require__(79);
	
	var featureManager = __webpack_require__(139);
	
	var graphic = __webpack_require__(16);
	
	var Model = __webpack_require__(48);
	
	var DataDiffer = __webpack_require__(166);
	
	var listComponentHelper = __webpack_require__(722);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentView({
	  type: 'toolbox',
	  render: function (toolboxModel, ecModel, api, payload) {
	    var group = this.group;
	    group.removeAll();
	
	    if (!toolboxModel.get('show')) {
	      return;
	    }
	
	    var itemSize = +toolboxModel.get('itemSize');
	    var featureOpts = toolboxModel.get('feature') || {};
	    var features = this._features || (this._features = {});
	    var featureNames = [];
	    zrUtil.each(featureOpts, function (opt, name) {
	      featureNames.push(name);
	    });
	    new DataDiffer(this._featureNames || [], featureNames).add(processFeature).update(processFeature).remove(zrUtil.curry(processFeature, null)).execute(); // Keep for diff.
	
	    this._featureNames = featureNames;
	
	    function processFeature(newIndex, oldIndex) {
	      var featureName = featureNames[newIndex];
	      var oldName = featureNames[oldIndex];
	      var featureOpt = featureOpts[featureName];
	      var featureModel = new Model(featureOpt, toolboxModel, toolboxModel.ecModel);
	      var feature; // FIX#11236, merge feature title from MagicType newOption. TODO: consider seriesIndex ?
	
	      if (payload && payload.newTitle != null && payload.featureName === featureName) {
	        featureOpt.title = payload.newTitle;
	      }
	
	      if (featureName && !oldName) {
	        // Create
	        if (isUserFeatureName(featureName)) {
	          feature = {
	            model: featureModel,
	            onclick: featureModel.option.onclick,
	            featureName: featureName
	          };
	        } else {
	          var Feature = featureManager.get(featureName);
	
	          if (!Feature) {
	            return;
	          }
	
	          feature = new Feature(featureModel, ecModel, api);
	        }
	
	        features[featureName] = feature;
	      } else {
	        feature = features[oldName]; // If feature does not exsit.
	
	        if (!feature) {
	          return;
	        }
	
	        feature.model = featureModel;
	        feature.ecModel = ecModel;
	        feature.api = api;
	      }
	
	      if (!featureName && oldName) {
	        feature.dispose && feature.dispose(ecModel, api);
	        return;
	      }
	
	      if (!featureModel.get('show') || feature.unusable) {
	        feature.remove && feature.remove(ecModel, api);
	        return;
	      }
	
	      createIconPaths(featureModel, feature, featureName);
	
	      featureModel.setIconStatus = function (iconName, status) {
	        var option = this.option;
	        var iconPaths = this.iconPaths;
	        option.iconStatus = option.iconStatus || {};
	        option.iconStatus[iconName] = status; // FIXME
	
	        iconPaths[iconName] && iconPaths[iconName].trigger(status);
	      };
	
	      if (feature.render) {
	        feature.render(featureModel, ecModel, api, payload);
	      }
	    }
	
	    function createIconPaths(featureModel, feature, featureName) {
	      var iconStyleModel = featureModel.getModel('iconStyle');
	      var iconStyleEmphasisModel = featureModel.getModel('emphasis.iconStyle'); // If one feature has mutiple icon. they are orginaized as
	      // {
	      //     icon: {
	      //         foo: '',
	      //         bar: ''
	      //     },
	      //     title: {
	      //         foo: '',
	      //         bar: ''
	      //     }
	      // }
	
	      var icons = feature.getIcons ? feature.getIcons() : featureModel.get('icon');
	      var titles = featureModel.get('title') || {};
	
	      if (typeof icons === 'string') {
	        var icon = icons;
	        var title = titles;
	        icons = {};
	        titles = {};
	        icons[featureName] = icon;
	        titles[featureName] = title;
	      }
	
	      var iconPaths = featureModel.iconPaths = {};
	      zrUtil.each(icons, function (iconStr, iconName) {
	        var path = graphic.createIcon(iconStr, {}, {
	          x: -itemSize / 2,
	          y: -itemSize / 2,
	          width: itemSize,
	          height: itemSize
	        });
	        path.setStyle(iconStyleModel.getItemStyle());
	        path.hoverStyle = iconStyleEmphasisModel.getItemStyle(); // Text position calculation
	
	        path.setStyle({
	          text: titles[iconName],
	          textAlign: iconStyleEmphasisModel.get('textAlign'),
	          textBorderRadius: iconStyleEmphasisModel.get('textBorderRadius'),
	          textPadding: iconStyleEmphasisModel.get('textPadding'),
	          textFill: null
	        });
	        var tooltipModel = toolboxModel.getModel('tooltip');
	
	        if (tooltipModel && tooltipModel.get('show')) {
	          path.attr('tooltip', zrUtil.extend({
	            content: titles[iconName],
	            formatter: tooltipModel.get('formatter', true) || function () {
	              return titles[iconName];
	            },
	            formatterParams: {
	              componentType: 'toolbox',
	              name: iconName,
	              title: titles[iconName],
	              $vars: ['name', 'title']
	            },
	            position: tooltipModel.get('position', true) || 'bottom'
	          }, tooltipModel.option));
	        }
	
	        graphic.setHoverStyle(path);
	
	        if (toolboxModel.get('showTitle')) {
	          path.__title = titles[iconName];
	          path.on('mouseover', function () {
	            // Should not reuse above hoverStyle, which might be modified.
	            var hoverStyle = iconStyleEmphasisModel.getItemStyle();
	            var defaultTextPosition = toolboxModel.get('orient') === 'vertical' ? toolboxModel.get('right') == null ? 'right' : 'left' : toolboxModel.get('bottom') == null ? 'bottom' : 'top';
	            path.setStyle({
	              textFill: iconStyleEmphasisModel.get('textFill') || hoverStyle.fill || hoverStyle.stroke || '#000',
	              textBackgroundColor: iconStyleEmphasisModel.get('textBackgroundColor'),
	              textPosition: iconStyleEmphasisModel.get('textPosition') || defaultTextPosition
	            });
	          }).on('mouseout', function () {
	            path.setStyle({
	              textFill: null,
	              textBackgroundColor: null
	            });
	          });
	        }
	
	        path.trigger(featureModel.get('iconStatus.' + iconName) || 'normal');
	        group.add(path);
	        path.on('click', zrUtil.bind(feature.onclick, feature, ecModel, api, iconName));
	        iconPaths[iconName] = path;
	      });
	    }
	
	    listComponentHelper.layout(group, toolboxModel, api); // Render background after group is layout
	    // FIXME
	
	    group.add(listComponentHelper.makeBackground(group.getBoundingRect(), toolboxModel)); // Adjust icon title positions to avoid them out of screen
	
	    group.eachChild(function (icon) {
	      var titleText = icon.__title;
	      var hoverStyle = icon.hoverStyle; // May be background element
	
	      if (hoverStyle && titleText) {
	        var rect = textContain.getBoundingRect(titleText, textContain.makeFont(hoverStyle));
	        var offsetX = icon.position[0] + group.position[0];
	        var offsetY = icon.position[1] + group.position[1] + itemSize;
	        var needPutOnTop = false;
	
	        if (offsetY + rect.height > api.getHeight()) {
	          hoverStyle.textPosition = 'top';
	          needPutOnTop = true;
	        }
	
	        var topOffset = needPutOnTop ? -5 - rect.height : itemSize + 8;
	
	        if (offsetX + rect.width / 2 > api.getWidth()) {
	          hoverStyle.textPosition = ['100%', topOffset];
	          hoverStyle.textAlign = 'right';
	        } else if (offsetX - rect.width / 2 < 0) {
	          hoverStyle.textPosition = [0, topOffset];
	          hoverStyle.textAlign = 'left';
	        }
	      }
	    });
	  },
	  updateView: function (toolboxModel, ecModel, api, payload) {
	    zrUtil.each(this._features, function (feature) {
	      feature.updateView && feature.updateView(feature.model, ecModel, api, payload);
	    });
	  },
	  // updateLayout: function (toolboxModel, ecModel, api, payload) {
	  //     zrUtil.each(this._features, function (feature) {
	  //         feature.updateLayout && feature.updateLayout(feature.model, ecModel, api, payload);
	  //     });
	  // },
	  remove: function (ecModel, api) {
	    zrUtil.each(this._features, function (feature) {
	      feature.remove && feature.remove(ecModel, api);
	    });
	    this.group.removeAll();
	  },
	  dispose: function (ecModel, api) {
	    zrUtil.each(this._features, function (feature) {
	      feature.dispose && feature.dispose(ecModel, api);
	    });
	  }
	});
	
	function isUserFeatureName(featureName) {
	  return featureName.indexOf('my') === 0;
	}
	
	module.exports = _default;

/***/ },
/* 1635 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var featureManager = __webpack_require__(139);
	
	var lang = __webpack_require__(141);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var brushLang = lang.toolbox.brush;
	
	function Brush(model, ecModel, api) {
	  this.model = model;
	  this.ecModel = ecModel;
	  this.api = api;
	  /**
	   * @private
	   * @type {string}
	   */
	
	  this._brushType;
	  /**
	   * @private
	   * @type {string}
	   */
	
	  this._brushMode;
	}
	
	Brush.defaultOption = {
	  show: true,
	  type: ['rect', 'polygon', 'lineX', 'lineY', 'keep', 'clear'],
	  icon: {
	    /* eslint-disable */
	    rect: 'M7.3,34.7 M0.4,10V-0.2h9.8 M89.6,10V-0.2h-9.8 M0.4,60v10.2h9.8 M89.6,60v10.2h-9.8 M12.3,22.4V10.5h13.1 M33.6,10.5h7.8 M49.1,10.5h7.8 M77.5,22.4V10.5h-13 M12.3,31.1v8.2 M77.7,31.1v8.2 M12.3,47.6v11.9h13.1 M33.6,59.5h7.6 M49.1,59.5 h7.7 M77.5,47.6v11.9h-13',
	    // jshint ignore:line
	    polygon: 'M55.2,34.9c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1 s-3.1-1.4-3.1-3.1S53.5,34.9,55.2,34.9z M50.4,51c1.7,0,3.1,1.4,3.1,3.1c0,1.7-1.4,3.1-3.1,3.1c-1.7,0-3.1-1.4-3.1-3.1 C47.3,52.4,48.7,51,50.4,51z M55.6,37.1l1.5-7.8 M60.1,13.5l1.6-8.7l-7.8,4 M59,19l-1,5.3 M24,16.1l6.4,4.9l6.4-3.3 M48.5,11.6 l-5.9,3.1 M19.1,12.8L9.7,5.1l1.1,7.7 M13.4,29.8l1,7.3l6.6,1.6 M11.6,18.4l1,6.1 M32.8,41.9 M26.6,40.4 M27.3,40.2l6.1,1.6 M49.9,52.1l-5.6-7.6l-4.9-1.2',
	    // jshint ignore:line
	    lineX: 'M15.2,30 M19.7,15.6V1.9H29 M34.8,1.9H40.4 M55.3,15.6V1.9H45.9 M19.7,44.4V58.1H29 M34.8,58.1H40.4 M55.3,44.4 V58.1H45.9 M12.5,20.3l-9.4,9.6l9.6,9.8 M3.1,29.9h16.5 M62.5,20.3l9.4,9.6L62.3,39.7 M71.9,29.9H55.4',
	    // jshint ignore:line
	    lineY: 'M38.8,7.7 M52.7,12h13.2v9 M65.9,26.6V32 M52.7,46.3h13.2v-9 M24.9,12H11.8v9 M11.8,26.6V32 M24.9,46.3H11.8v-9 M48.2,5.1l-9.3-9l-9.4,9.2 M38.9-3.9V12 M48.2,53.3l-9.3,9l-9.4-9.2 M38.9,62.3V46.4',
	    // jshint ignore:line
	    keep: 'M4,10.5V1h10.3 M20.7,1h6.1 M33,1h6.1 M55.4,10.5V1H45.2 M4,17.3v6.6 M55.6,17.3v6.6 M4,30.5V40h10.3 M20.7,40 h6.1 M33,40h6.1 M55.4,30.5V40H45.2 M21,18.9h62.9v48.6H21V18.9z',
	    // jshint ignore:line
	    clear: 'M22,14.7l30.9,31 M52.9,14.7L22,45.7 M4.7,16.8V4.2h13.1 M26,4.2h7.8 M41.6,4.2h7.8 M70.3,16.8V4.2H57.2 M4.7,25.9v8.6 M70.3,25.9v8.6 M4.7,43.2v12.6h13.1 M26,55.8h7.8 M41.6,55.8h7.8 M70.3,43.2v12.6H57.2' // jshint ignore:line
	
	    /* eslint-enable */
	
	  },
	  // `rect`, `polygon`, `lineX`, `lineY`, `keep`, `clear`
	  title: zrUtil.clone(brushLang.title)
	};
	var proto = Brush.prototype; // proto.updateLayout = function (featureModel, ecModel, api) {
	
	/* eslint-disable */
	
	proto.render =
	/* eslint-enable */
	proto.updateView = function (featureModel, ecModel, api) {
	  var brushType;
	  var brushMode;
	  var isBrushed;
	  ecModel.eachComponent({
	    mainType: 'brush'
	  }, function (brushModel) {
	    brushType = brushModel.brushType;
	    brushMode = brushModel.brushOption.brushMode || 'single';
	    isBrushed |= brushModel.areas.length;
	  });
	  this._brushType = brushType;
	  this._brushMode = brushMode;
	  zrUtil.each(featureModel.get('type', true), function (type) {
	    featureModel.setIconStatus(type, (type === 'keep' ? brushMode === 'multiple' : type === 'clear' ? isBrushed : type === brushType) ? 'emphasis' : 'normal');
	  });
	};
	
	proto.getIcons = function () {
	  var model = this.model;
	  var availableIcons = model.get('icon', true);
	  var icons = {};
	  zrUtil.each(model.get('type', true), function (type) {
	    if (availableIcons[type]) {
	      icons[type] = availableIcons[type];
	    }
	  });
	  return icons;
	};
	
	proto.onclick = function (ecModel, api, type) {
	  var brushType = this._brushType;
	  var brushMode = this._brushMode;
	
	  if (type === 'clear') {
	    // Trigger parallel action firstly
	    api.dispatchAction({
	      type: 'axisAreaSelect',
	      intervals: []
	    });
	    api.dispatchAction({
	      type: 'brush',
	      command: 'clear',
	      // Clear all areas of all brush components.
	      areas: []
	    });
	  } else {
	    api.dispatchAction({
	      type: 'takeGlobalCursor',
	      key: 'brush',
	      brushOption: {
	        brushType: type === 'keep' ? brushType : brushType === type ? false : type,
	        brushMode: type === 'keep' ? brushMode === 'multiple' ? 'single' : 'multiple' : brushMode
	      }
	    });
	  }
	};
	
	featureManager.register('brush', Brush);
	var _default = Brush;
	module.exports = _default;

/***/ },
/* 1636 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var eventTool = __webpack_require__(113);
	
	var lang = __webpack_require__(141);
	
	var featureManager = __webpack_require__(139);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var dataViewLang = lang.toolbox.dataView;
	var BLOCK_SPLITER = new Array(60).join('-');
	var ITEM_SPLITER = '\t';
	/**
	 * Group series into two types
	 *  1. on category axis, like line, bar
	 *  2. others, like scatter, pie
	 * @param {module:echarts/model/Global} ecModel
	 * @return {Object}
	 * @inner
	 */
	
	function groupSeries(ecModel) {
	  var seriesGroupByCategoryAxis = {};
	  var otherSeries = [];
	  var meta = [];
	  ecModel.eachRawSeries(function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys && (coordSys.type === 'cartesian2d' || coordSys.type === 'polar')) {
	      var baseAxis = coordSys.getBaseAxis();
	
	      if (baseAxis.type === 'category') {
	        var key = baseAxis.dim + '_' + baseAxis.index;
	
	        if (!seriesGroupByCategoryAxis[key]) {
	          seriesGroupByCategoryAxis[key] = {
	            categoryAxis: baseAxis,
	            valueAxis: coordSys.getOtherAxis(baseAxis),
	            series: []
	          };
	          meta.push({
	            axisDim: baseAxis.dim,
	            axisIndex: baseAxis.index
	          });
	        }
	
	        seriesGroupByCategoryAxis[key].series.push(seriesModel);
	      } else {
	        otherSeries.push(seriesModel);
	      }
	    } else {
	      otherSeries.push(seriesModel);
	    }
	  });
	  return {
	    seriesGroupByCategoryAxis: seriesGroupByCategoryAxis,
	    other: otherSeries,
	    meta: meta
	  };
	}
	/**
	 * Assemble content of series on cateogory axis
	 * @param {Array.<module:echarts/model/Series>} series
	 * @return {string}
	 * @inner
	 */
	
	
	function assembleSeriesWithCategoryAxis(series) {
	  var tables = [];
	  zrUtil.each(series, function (group, key) {
	    var categoryAxis = group.categoryAxis;
	    var valueAxis = group.valueAxis;
	    var valueAxisDim = valueAxis.dim;
	    var headers = [' '].concat(zrUtil.map(group.series, function (series) {
	      return series.name;
	    }));
	    var columns = [categoryAxis.model.getCategories()];
	    zrUtil.each(group.series, function (series) {
	      var rawData = series.getRawData();
	      columns.push(series.getRawData().mapArray(rawData.mapDimension(valueAxisDim), function (val) {
	        return val;
	      }));
	    }); // Assemble table content
	
	    var lines = [headers.join(ITEM_SPLITER)];
	
	    for (var i = 0; i < columns[0].length; i++) {
	      var items = [];
	
	      for (var j = 0; j < columns.length; j++) {
	        items.push(columns[j][i]);
	      }
	
	      lines.push(items.join(ITEM_SPLITER));
	    }
	
	    tables.push(lines.join('\n'));
	  });
	  return tables.join('\n\n' + BLOCK_SPLITER + '\n\n');
	}
	/**
	 * Assemble content of other series
	 * @param {Array.<module:echarts/model/Series>} series
	 * @return {string}
	 * @inner
	 */
	
	
	function assembleOtherSeries(series) {
	  return zrUtil.map(series, function (series) {
	    var data = series.getRawData();
	    var lines = [series.name];
	    var vals = [];
	    data.each(data.dimensions, function () {
	      var argLen = arguments.length;
	      var dataIndex = arguments[argLen - 1];
	      var name = data.getName(dataIndex);
	
	      for (var i = 0; i < argLen - 1; i++) {
	        vals[i] = arguments[i];
	      }
	
	      lines.push((name ? name + ITEM_SPLITER : '') + vals.join(ITEM_SPLITER));
	    });
	    return lines.join('\n');
	  }).join('\n\n' + BLOCK_SPLITER + '\n\n');
	}
	/**
	 * @param {module:echarts/model/Global}
	 * @return {Object}
	 * @inner
	 */
	
	
	function getContentFromModel(ecModel) {
	  var result = groupSeries(ecModel);
	  return {
	    value: zrUtil.filter([assembleSeriesWithCategoryAxis(result.seriesGroupByCategoryAxis), assembleOtherSeries(result.other)], function (str) {
	      return str.replace(/[\n\t\s]/g, '');
	    }).join('\n\n' + BLOCK_SPLITER + '\n\n'),
	    meta: result.meta
	  };
	}
	
	function trim(str) {
	  return str.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	}
	/**
	 * If a block is tsv format
	 */
	
	
	function isTSVFormat(block) {
	  // Simple method to find out if a block is tsv format
	  var firstLine = block.slice(0, block.indexOf('\n'));
	
	  if (firstLine.indexOf(ITEM_SPLITER) >= 0) {
	    return true;
	  }
	}
	
	var itemSplitRegex = new RegExp('[' + ITEM_SPLITER + ']+', 'g');
	/**
	 * @param {string} tsv
	 * @return {Object}
	 */
	
	function parseTSVContents(tsv) {
	  var tsvLines = tsv.split(/\n+/g);
	  var headers = trim(tsvLines.shift()).split(itemSplitRegex);
	  var categories = [];
	  var series = zrUtil.map(headers, function (header) {
	    return {
	      name: header,
	      data: []
	    };
	  });
	
	  for (var i = 0; i < tsvLines.length; i++) {
	    var items = trim(tsvLines[i]).split(itemSplitRegex);
	    categories.push(items.shift());
	
	    for (var j = 0; j < items.length; j++) {
	      series[j] && (series[j].data[i] = items[j]);
	    }
	  }
	
	  return {
	    series: series,
	    categories: categories
	  };
	}
	/**
	 * @param {string} str
	 * @return {Array.<Object>}
	 * @inner
	 */
	
	
	function parseListContents(str) {
	  var lines = str.split(/\n+/g);
	  var seriesName = trim(lines.shift());
	  var data = [];
	
	  for (var i = 0; i < lines.length; i++) {
	    // if line is empty, ignore it.
	    // there is a case that a user forgot to delete `\n`.
	    var line = trim(lines[i]);
	
	    if (!line) {
	      continue;
	    }
	
	    var items = line.split(itemSplitRegex);
	    var name = '';
	    var value;
	    var hasName = false;
	
	    if (isNaN(items[0])) {
	      // First item is name
	      hasName = true;
	      name = items[0];
	      items = items.slice(1);
	      data[i] = {
	        name: name,
	        value: []
	      };
	      value = data[i].value;
	    } else {
	      value = data[i] = [];
	    }
	
	    for (var j = 0; j < items.length; j++) {
	      value.push(+items[j]);
	    }
	
	    if (value.length === 1) {
	      hasName ? data[i].value = value[0] : data[i] = value[0];
	    }
	  }
	
	  return {
	    name: seriesName,
	    data: data
	  };
	}
	/**
	 * @param {string} str
	 * @param {Array.<Object>} blockMetaList
	 * @return {Object}
	 * @inner
	 */
	
	
	function parseContents(str, blockMetaList) {
	  var blocks = str.split(new RegExp('\n*' + BLOCK_SPLITER + '\n*', 'g'));
	  var newOption = {
	    series: []
	  };
	  zrUtil.each(blocks, function (block, idx) {
	    if (isTSVFormat(block)) {
	      var result = parseTSVContents(block);
	      var blockMeta = blockMetaList[idx];
	      var axisKey = blockMeta.axisDim + 'Axis';
	
	      if (blockMeta) {
	        newOption[axisKey] = newOption[axisKey] || [];
	        newOption[axisKey][blockMeta.axisIndex] = {
	          data: result.categories
	        };
	        newOption.series = newOption.series.concat(result.series);
	      }
	    } else {
	      var result = parseListContents(block);
	      newOption.series.push(result);
	    }
	  });
	  return newOption;
	}
	/**
	 * @alias {module:echarts/component/toolbox/feature/DataView}
	 * @constructor
	 * @param {module:echarts/model/Model} model
	 */
	
	
	function DataView(model) {
	  this._dom = null;
	  this.model = model;
	}
	
	DataView.defaultOption = {
	  show: true,
	  readOnly: false,
	  optionToContent: null,
	  contentToOption: null,
	  icon: 'M17.5,17.3H33 M17.5,17.3H33 M45.4,29.5h-28 M11.5,2v56H51V14.8L38.4,2H11.5z M38.4,2.2v12.7H51 M45.4,41.7h-28',
	  title: zrUtil.clone(dataViewLang.title),
	  lang: zrUtil.clone(dataViewLang.lang),
	  backgroundColor: '#fff',
	  textColor: '#000',
	  textareaColor: '#fff',
	  textareaBorderColor: '#333',
	  buttonColor: '#c23531',
	  buttonTextColor: '#fff'
	};
	
	DataView.prototype.onclick = function (ecModel, api) {
	  var container = api.getDom();
	  var model = this.model;
	
	  if (this._dom) {
	    container.removeChild(this._dom);
	  }
	
	  var root = document.createElement('div');
	  root.style.cssText = 'position:absolute;left:5px;top:5px;bottom:5px;right:5px;';
	  root.style.backgroundColor = model.get('backgroundColor') || '#fff'; // Create elements
	
	  var header = document.createElement('h4');
	  var lang = model.get('lang') || [];
	  header.innerHTML = lang[0] || model.get('title');
	  header.style.cssText = 'margin: 10px 20px;';
	  header.style.color = model.get('textColor');
	  var viewMain = document.createElement('div');
	  var textarea = document.createElement('textarea');
	  viewMain.style.cssText = 'display:block;width:100%;overflow:auto;';
	  var optionToContent = model.get('optionToContent');
	  var contentToOption = model.get('contentToOption');
	  var result = getContentFromModel(ecModel);
	
	  if (typeof optionToContent === 'function') {
	    var htmlOrDom = optionToContent(api.getOption());
	
	    if (typeof htmlOrDom === 'string') {
	      viewMain.innerHTML = htmlOrDom;
	    } else if (zrUtil.isDom(htmlOrDom)) {
	      viewMain.appendChild(htmlOrDom);
	    }
	  } else {
	    // Use default textarea
	    viewMain.appendChild(textarea);
	    textarea.readOnly = model.get('readOnly');
	    textarea.style.cssText = 'width:100%;height:100%;font-family:monospace;font-size:14px;line-height:1.6rem;';
	    textarea.style.color = model.get('textColor');
	    textarea.style.borderColor = model.get('textareaBorderColor');
	    textarea.style.backgroundColor = model.get('textareaColor');
	    textarea.value = result.value;
	  }
	
	  var blockMetaList = result.meta;
	  var buttonContainer = document.createElement('div');
	  buttonContainer.style.cssText = 'position:absolute;bottom:0;left:0;right:0;';
	  var buttonStyle = 'float:right;margin-right:20px;border:none;' + 'cursor:pointer;padding:2px 5px;font-size:12px;border-radius:3px';
	  var closeButton = document.createElement('div');
	  var refreshButton = document.createElement('div');
	  buttonStyle += ';background-color:' + model.get('buttonColor');
	  buttonStyle += ';color:' + model.get('buttonTextColor');
	  var self = this;
	
	  function close() {
	    container.removeChild(root);
	    self._dom = null;
	  }
	
	  eventTool.addEventListener(closeButton, 'click', close);
	  eventTool.addEventListener(refreshButton, 'click', function () {
	    var newOption;
	
	    try {
	      if (typeof contentToOption === 'function') {
	        newOption = contentToOption(viewMain, api.getOption());
	      } else {
	        newOption = parseContents(textarea.value, blockMetaList);
	      }
	    } catch (e) {
	      close();
	      throw new Error('Data view format error ' + e);
	    }
	
	    if (newOption) {
	      api.dispatchAction({
	        type: 'changeDataView',
	        newOption: newOption
	      });
	    }
	
	    close();
	  });
	  closeButton.innerHTML = lang[1];
	  refreshButton.innerHTML = lang[2];
	  refreshButton.style.cssText = buttonStyle;
	  closeButton.style.cssText = buttonStyle;
	  !model.get('readOnly') && buttonContainer.appendChild(refreshButton);
	  buttonContainer.appendChild(closeButton);
	  root.appendChild(header);
	  root.appendChild(viewMain);
	  root.appendChild(buttonContainer);
	  viewMain.style.height = container.clientHeight - 80 + 'px';
	  container.appendChild(root);
	  this._dom = root;
	};
	
	DataView.prototype.remove = function (ecModel, api) {
	  this._dom && api.getDom().removeChild(this._dom);
	};
	
	DataView.prototype.dispose = function (ecModel, api) {
	  this.remove(ecModel, api);
	};
	/**
	 * @inner
	 */
	
	
	function tryMergeDataOption(newData, originalData) {
	  return zrUtil.map(newData, function (newVal, idx) {
	    var original = originalData && originalData[idx];
	
	    if (zrUtil.isObject(original) && !zrUtil.isArray(original)) {
	      var newValIsObject = zrUtil.isObject(newVal) && !zrUtil.isArray(newVal);
	
	      if (!newValIsObject) {
	        newVal = {
	          value: newVal
	        };
	      } // original data has name but new data has no name
	
	
	      var shouldDeleteName = original.name != null && newVal.name == null; // Original data has option
	
	      newVal = zrUtil.defaults(newVal, original);
	      shouldDeleteName && delete newVal.name;
	      return newVal;
	    } else {
	      return newVal;
	    }
	  });
	}
	
	featureManager.register('dataView', DataView);
	echarts.registerAction({
	  type: 'changeDataView',
	  event: 'dataViewChanged',
	  update: 'prepareAndUpdate'
	}, function (payload, ecModel) {
	  var newSeriesOptList = [];
	  zrUtil.each(payload.newOption.series, function (seriesOpt) {
	    var seriesModel = ecModel.getSeriesByName(seriesOpt.name)[0];
	
	    if (!seriesModel) {
	      // New created series
	      // Geuss the series type
	      newSeriesOptList.push(zrUtil.extend({
	        // Default is scatter
	        type: 'scatter'
	      }, seriesOpt));
	    } else {
	      var originalData = seriesModel.get('data');
	      newSeriesOptList.push({
	        name: seriesOpt.name,
	        data: tryMergeDataOption(seriesOpt.data, originalData)
	      });
	    }
	  });
	  ecModel.mergeOption(zrUtil.defaults({
	    series: newSeriesOptList
	  }, payload.newOption));
	});
	var _default = DataView;
	module.exports = _default;

/***/ },
/* 1637 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var BrushController = __webpack_require__(463);
	
	var BrushTargetManager = __webpack_require__(718);
	
	var history = __webpack_require__(714);
	
	var sliderMove = __webpack_require__(205);
	
	var lang = __webpack_require__(141);
	
	var featureManager = __webpack_require__(139);
	
	__webpack_require__(1597);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Use dataZoomSelect
	var dataZoomLang = lang.toolbox.dataZoom;
	var each = zrUtil.each; // Spectial component id start with \0ec\0, see echarts/model/Global.js~hasInnerId
	
	var DATA_ZOOM_ID_BASE = '\0_ec_\0toolbox-dataZoom_';
	
	function DataZoom(model, ecModel, api) {
	  /**
	   * @private
	   * @type {module:echarts/component/helper/BrushController}
	   */
	  (this._brushController = new BrushController(api.getZr())).on('brush', zrUtil.bind(this._onBrush, this)).mount();
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._isZoomActive;
	}
	
	DataZoom.defaultOption = {
	  show: true,
	  filterMode: 'filter',
	  // Icon group
	  icon: {
	    zoom: 'M0,13.5h26.9 M13.5,26.9V0 M32.1,13.5H58V58H13.5 V32.1',
	    back: 'M22,1.4L9.9,13.5l12.3,12.3 M10.3,13.5H54.9v44.6 H10.3v-26'
	  },
	  // `zoom`, `back`
	  title: zrUtil.clone(dataZoomLang.title),
	  brushStyle: {
	    borderWidth: 0,
	    color: 'rgba(0,0,0,0.2)'
	  }
	};
	var proto = DataZoom.prototype;
	
	proto.render = function (featureModel, ecModel, api, payload) {
	  this.model = featureModel;
	  this.ecModel = ecModel;
	  this.api = api;
	  updateZoomBtnStatus(featureModel, ecModel, this, payload, api);
	  updateBackBtnStatus(featureModel, ecModel);
	};
	
	proto.onclick = function (ecModel, api, type) {
	  handlers[type].call(this);
	};
	
	proto.remove = function (ecModel, api) {
	  this._brushController.unmount();
	};
	
	proto.dispose = function (ecModel, api) {
	  this._brushController.dispose();
	};
	/**
	 * @private
	 */
	
	
	var handlers = {
	  zoom: function () {
	    var nextActive = !this._isZoomActive;
	    this.api.dispatchAction({
	      type: 'takeGlobalCursor',
	      key: 'dataZoomSelect',
	      dataZoomSelectActive: nextActive
	    });
	  },
	  back: function () {
	    this._dispatchZoomAction(history.pop(this.ecModel));
	  }
	};
	/**
	 * @private
	 */
	
	proto._onBrush = function (areas, opt) {
	  if (!opt.isEnd || !areas.length) {
	    return;
	  }
	
	  var snapshot = {};
	  var ecModel = this.ecModel;
	
	  this._brushController.updateCovers([]); // remove cover
	
	
	  var brushTargetManager = new BrushTargetManager(retrieveAxisSetting(this.model.option), ecModel, {
	    include: ['grid']
	  });
	  brushTargetManager.matchOutputRanges(areas, ecModel, function (area, coordRange, coordSys) {
	    if (coordSys.type !== 'cartesian2d') {
	      return;
	    }
	
	    var brushType = area.brushType;
	
	    if (brushType === 'rect') {
	      setBatch('x', coordSys, coordRange[0]);
	      setBatch('y', coordSys, coordRange[1]);
	    } else {
	      setBatch({
	        lineX: 'x',
	        lineY: 'y'
	      }[brushType], coordSys, coordRange);
	    }
	  });
	  history.push(ecModel, snapshot);
	
	  this._dispatchZoomAction(snapshot);
	
	  function setBatch(dimName, coordSys, minMax) {
	    var axis = coordSys.getAxis(dimName);
	    var axisModel = axis.model;
	    var dataZoomModel = findDataZoom(dimName, axisModel, ecModel); // Restrict range.
	
	    var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy(axisModel).getMinMaxSpan();
	
	    if (minMaxSpan.minValueSpan != null || minMaxSpan.maxValueSpan != null) {
	      minMax = sliderMove(0, minMax.slice(), axis.scale.getExtent(), 0, minMaxSpan.minValueSpan, minMaxSpan.maxValueSpan);
	    }
	
	    dataZoomModel && (snapshot[dataZoomModel.id] = {
	      dataZoomId: dataZoomModel.id,
	      startValue: minMax[0],
	      endValue: minMax[1]
	    });
	  }
	
	  function findDataZoom(dimName, axisModel, ecModel) {
	    var found;
	    ecModel.eachComponent({
	      mainType: 'dataZoom',
	      subType: 'select'
	    }, function (dzModel) {
	      var has = dzModel.getAxisModel(dimName, axisModel.componentIndex);
	      has && (found = dzModel);
	    });
	    return found;
	  }
	};
	/**
	 * @private
	 */
	
	
	proto._dispatchZoomAction = function (snapshot) {
	  var batch = []; // Convert from hash map to array.
	
	  each(snapshot, function (batchItem, dataZoomId) {
	    batch.push(zrUtil.clone(batchItem));
	  });
	  batch.length && this.api.dispatchAction({
	    type: 'dataZoom',
	    from: this.uid,
	    batch: batch
	  });
	};
	
	function retrieveAxisSetting(option) {
	  var setting = {}; // Compatible with previous setting: null => all axis, false => no axis.
	
	  zrUtil.each(['xAxisIndex', 'yAxisIndex'], function (name) {
	    setting[name] = option[name];
	    setting[name] == null && (setting[name] = 'all');
	    (setting[name] === false || setting[name] === 'none') && (setting[name] = []);
	  });
	  return setting;
	}
	
	function updateBackBtnStatus(featureModel, ecModel) {
	  featureModel.setIconStatus('back', history.count(ecModel) > 1 ? 'emphasis' : 'normal');
	}
	
	function updateZoomBtnStatus(featureModel, ecModel, view, payload, api) {
	  var zoomActive = view._isZoomActive;
	
	  if (payload && payload.type === 'takeGlobalCursor') {
	    zoomActive = payload.key === 'dataZoomSelect' ? payload.dataZoomSelectActive : false;
	  }
	
	  view._isZoomActive = zoomActive;
	  featureModel.setIconStatus('zoom', zoomActive ? 'emphasis' : 'normal');
	  var brushTargetManager = new BrushTargetManager(retrieveAxisSetting(featureModel.option), ecModel, {
	    include: ['grid']
	  });
	
	  view._brushController.setPanels(brushTargetManager.makePanelOpts(api, function (targetInfo) {
	    return targetInfo.xAxisDeclared && !targetInfo.yAxisDeclared ? 'lineX' : !targetInfo.xAxisDeclared && targetInfo.yAxisDeclared ? 'lineY' : 'rect';
	  })).enableBrush(zoomActive ? {
	    brushType: 'auto',
	    brushStyle: featureModel.getModel('brushStyle').getItemStyle()
	  } : false);
	}
	
	featureManager.register('dataZoom', DataZoom); // Create special dataZoom option for select
	// FIXME consider the case of merge option, where axes options are not exists.
	
	echarts.registerPreprocessor(function (option) {
	  if (!option) {
	    return;
	  }
	
	  var dataZoomOpts = option.dataZoom || (option.dataZoom = []);
	
	  if (!zrUtil.isArray(dataZoomOpts)) {
	    option.dataZoom = dataZoomOpts = [dataZoomOpts];
	  }
	
	  var toolboxOpt = option.toolbox;
	
	  if (toolboxOpt) {
	    // Assume there is only one toolbox
	    if (zrUtil.isArray(toolboxOpt)) {
	      toolboxOpt = toolboxOpt[0];
	    }
	
	    if (toolboxOpt && toolboxOpt.feature) {
	      var dataZoomOpt = toolboxOpt.feature.dataZoom; // FIXME: If add dataZoom when setOption in merge mode,
	      // no axis info to be added. See `test/dataZoom-extreme.html`
	
	      addForAxis('xAxis', dataZoomOpt);
	      addForAxis('yAxis', dataZoomOpt);
	    }
	  }
	
	  function addForAxis(axisName, dataZoomOpt) {
	    if (!dataZoomOpt) {
	      return;
	    } // Try not to modify model, because it is not merged yet.
	
	
	    var axisIndicesName = axisName + 'Index';
	    var givenAxisIndices = dataZoomOpt[axisIndicesName];
	
	    if (givenAxisIndices != null && givenAxisIndices !== 'all' && !zrUtil.isArray(givenAxisIndices)) {
	      givenAxisIndices = givenAxisIndices === false || givenAxisIndices === 'none' ? [] : [givenAxisIndices];
	    }
	
	    forEachComponent(axisName, function (axisOpt, axisIndex) {
	      if (givenAxisIndices != null && givenAxisIndices !== 'all' && zrUtil.indexOf(givenAxisIndices, axisIndex) === -1) {
	        return;
	      }
	
	      var newOpt = {
	        type: 'select',
	        $fromToolbox: true,
	        // Default to be filter
	        filterMode: dataZoomOpt.filterMode || 'filter',
	        // Id for merge mapping.
	        id: DATA_ZOOM_ID_BASE + axisName + axisIndex
	      }; // FIXME
	      // Only support one axis now.
	
	      newOpt[axisIndicesName] = axisIndex;
	      dataZoomOpts.push(newOpt);
	    });
	  }
	
	  function forEachComponent(mainType, cb) {
	    var opts = option[mainType];
	
	    if (!zrUtil.isArray(opts)) {
	      opts = opts ? [opts] : [];
	    }
	
	    each(opts, cb);
	  }
	});
	var _default = DataZoom;
	module.exports = _default;

/***/ },
/* 1638 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var lang = __webpack_require__(141);
	
	var featureManager = __webpack_require__(139);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var magicTypeLang = lang.toolbox.magicType;
	var INNER_STACK_KEYWORD = '__ec_magicType_stack__';
	
	function MagicType(model) {
	  this.model = model;
	}
	
	MagicType.defaultOption = {
	  show: true,
	  type: [],
	  // Icon group
	  icon: {
	    /* eslint-disable */
	    line: 'M4.1,28.9h7.1l9.3-22l7.4,38l9.7-19.7l3,12.8h14.9M4.1,58h51.4',
	    bar: 'M6.7,22.9h10V48h-10V22.9zM24.9,13h10v35h-10V13zM43.2,2h10v46h-10V2zM3.1,58h53.7',
	    stack: 'M8.2,38.4l-8.4,4.1l30.6,15.3L60,42.5l-8.1-4.1l-21.5,11L8.2,38.4z M51.9,30l-8.1,4.2l-13.4,6.9l-13.9-6.9L8.2,30l-8.4,4.2l8.4,4.2l22.2,11l21.5-11l8.1-4.2L51.9,30z M51.9,21.7l-8.1,4.2L35.7,30l-5.3,2.8L24.9,30l-8.4-4.1l-8.3-4.2l-8.4,4.2L8.2,30l8.3,4.2l13.9,6.9l13.4-6.9l8.1-4.2l8.1-4.1L51.9,21.7zM30.4,2.2L-0.2,17.5l8.4,4.1l8.3,4.2l8.4,4.2l5.5,2.7l5.3-2.7l8.1-4.2l8.1-4.2l8.1-4.1L30.4,2.2z' // jshint ignore:line
	
	    /* eslint-enable */
	
	  },
	  // `line`, `bar`, `stack`, `tiled`
	  title: zrUtil.clone(magicTypeLang.title),
	  option: {},
	  seriesIndex: {}
	};
	var proto = MagicType.prototype;
	
	proto.getIcons = function () {
	  var model = this.model;
	  var availableIcons = model.get('icon');
	  var icons = {};
	  zrUtil.each(model.get('type'), function (type) {
	    if (availableIcons[type]) {
	      icons[type] = availableIcons[type];
	    }
	  });
	  return icons;
	};
	
	var seriesOptGenreator = {
	  'line': function (seriesType, seriesId, seriesModel, model) {
	    if (seriesType === 'bar') {
	      return zrUtil.merge({
	        id: seriesId,
	        type: 'line',
	        // Preserve data related option
	        data: seriesModel.get('data'),
	        stack: seriesModel.get('stack'),
	        markPoint: seriesModel.get('markPoint'),
	        markLine: seriesModel.get('markLine')
	      }, model.get('option.line') || {}, true);
	    }
	  },
	  'bar': function (seriesType, seriesId, seriesModel, model) {
	    if (seriesType === 'line') {
	      return zrUtil.merge({
	        id: seriesId,
	        type: 'bar',
	        // Preserve data related option
	        data: seriesModel.get('data'),
	        stack: seriesModel.get('stack'),
	        markPoint: seriesModel.get('markPoint'),
	        markLine: seriesModel.get('markLine')
	      }, model.get('option.bar') || {}, true);
	    }
	  },
	  'stack': function (seriesType, seriesId, seriesModel, model) {
	    var isStack = seriesModel.get('stack') === INNER_STACK_KEYWORD;
	
	    if (seriesType === 'line' || seriesType === 'bar') {
	      model.setIconStatus('stack', isStack ? 'normal' : 'emphasis');
	      return zrUtil.merge({
	        id: seriesId,
	        stack: isStack ? '' : INNER_STACK_KEYWORD
	      }, model.get('option.stack') || {}, true);
	    }
	  }
	};
	var radioTypes = [['line', 'bar'], ['stack']];
	
	proto.onclick = function (ecModel, api, type) {
	  var model = this.model;
	  var seriesIndex = model.get('seriesIndex.' + type); // Not supported magicType
	
	  if (!seriesOptGenreator[type]) {
	    return;
	  }
	
	  var newOption = {
	    series: []
	  };
	
	  var generateNewSeriesTypes = function (seriesModel) {
	    var seriesType = seriesModel.subType;
	    var seriesId = seriesModel.id;
	    var newSeriesOpt = seriesOptGenreator[type](seriesType, seriesId, seriesModel, model);
	
	    if (newSeriesOpt) {
	      // PENDING If merge original option?
	      zrUtil.defaults(newSeriesOpt, seriesModel.option);
	      newOption.series.push(newSeriesOpt);
	    } // Modify boundaryGap
	
	
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys && coordSys.type === 'cartesian2d' && (type === 'line' || type === 'bar')) {
	      var categoryAxis = coordSys.getAxesByScale('ordinal')[0];
	
	      if (categoryAxis) {
	        var axisDim = categoryAxis.dim;
	        var axisType = axisDim + 'Axis';
	        var axisModel = ecModel.queryComponents({
	          mainType: axisType,
	          index: seriesModel.get(name + 'Index'),
	          id: seriesModel.get(name + 'Id')
	        })[0];
	        var axisIndex = axisModel.componentIndex;
	        newOption[axisType] = newOption[axisType] || [];
	
	        for (var i = 0; i <= axisIndex; i++) {
	          newOption[axisType][axisIndex] = newOption[axisType][axisIndex] || {};
	        }
	
	        newOption[axisType][axisIndex].boundaryGap = type === 'bar';
	      }
	    }
	  };
	
	  zrUtil.each(radioTypes, function (radio) {
	    if (zrUtil.indexOf(radio, type) >= 0) {
	      zrUtil.each(radio, function (item) {
	        model.setIconStatus(item, 'normal');
	      });
	    }
	  });
	  model.setIconStatus(type, 'emphasis');
	  ecModel.eachComponent({
	    mainType: 'series',
	    query: seriesIndex == null ? null : {
	      seriesIndex: seriesIndex
	    }
	  }, generateNewSeriesTypes);
	  var newTitle; // Change title of stack
	
	  if (type === 'stack') {
	    var isStack = newOption.series && newOption.series[0] && newOption.series[0].stack === INNER_STACK_KEYWORD;
	    newTitle = isStack ? zrUtil.merge({
	      stack: magicTypeLang.title.tiled
	    }, magicTypeLang.title) : zrUtil.clone(magicTypeLang.title);
	  }
	
	  api.dispatchAction({
	    type: 'changeMagicType',
	    currentType: type,
	    newOption: newOption,
	    newTitle: newTitle,
	    featureName: 'magicType'
	  });
	};
	
	echarts.registerAction({
	  type: 'changeMagicType',
	  event: 'magicTypeChanged',
	  update: 'prepareAndUpdate'
	}, function (payload, ecModel) {
	  ecModel.mergeOption(payload.newOption);
	});
	featureManager.register('magicType', MagicType);
	var _default = MagicType;
	module.exports = _default;

/***/ },
/* 1639 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var history = __webpack_require__(714);
	
	var lang = __webpack_require__(141);
	
	var featureManager = __webpack_require__(139);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var restoreLang = lang.toolbox.restore;
	
	function Restore(model) {
	  this.model = model;
	}
	
	Restore.defaultOption = {
	  show: true,
	
	  /* eslint-disable */
	  icon: 'M3.8,33.4 M47,18.9h9.8V8.7 M56.3,20.1 C52.1,9,40.5,0.6,26.8,2.1C12.6,3.7,1.6,16.2,2.1,30.6 M13,41.1H3.1v10.2 M3.7,39.9c4.2,11.1,15.8,19.5,29.5,18 c14.2-1.6,25.2-14.1,24.7-28.5',
	
	  /* eslint-enable */
	  title: restoreLang.title
	};
	var proto = Restore.prototype;
	
	proto.onclick = function (ecModel, api, type) {
	  history.clear(ecModel);
	  api.dispatchAction({
	    type: 'restore',
	    from: this.uid
	  });
	};
	
	featureManager.register('restore', Restore);
	echarts.registerAction({
	  type: 'restore',
	  event: 'restore',
	  update: 'prepareAndUpdate'
	}, function (payload, ecModel) {
	  ecModel.resetOption('recreate');
	});
	var _default = Restore;
	module.exports = _default;

/***/ },
/* 1640 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var env = __webpack_require__(55);
	
	var lang = __webpack_require__(141);
	
	var featureManager = __webpack_require__(139);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Uint8Array */
	var saveAsImageLang = lang.toolbox.saveAsImage;
	
	function SaveAsImage(model) {
	  this.model = model;
	}
	
	SaveAsImage.defaultOption = {
	  show: true,
	  icon: 'M4.7,22.9L29.3,45.5L54.7,23.4M4.6,43.6L4.6,58L53.8,58L53.8,43.6M29.2,45.1L29.2,0',
	  title: saveAsImageLang.title,
	  type: 'png',
	  // Default use option.backgroundColor
	  // backgroundColor: '#fff',
	  connectedBackgroundColor: '#fff',
	  name: '',
	  excludeComponents: ['toolbox'],
	  pixelRatio: 1,
	  lang: saveAsImageLang.lang.slice()
	};
	SaveAsImage.prototype.unusable = !env.canvasSupported;
	var proto = SaveAsImage.prototype;
	
	proto.onclick = function (ecModel, api) {
	  var model = this.model;
	  var title = model.get('name') || ecModel.get('title.0.text') || 'echarts';
	  var isSvg = api.getZr().painter.getType() === 'svg';
	  var type = isSvg ? 'svg' : model.get('type', true) || 'png';
	  var url = api.getConnectedDataURL({
	    type: type,
	    backgroundColor: model.get('backgroundColor', true) || ecModel.get('backgroundColor') || '#fff',
	    connectedBackgroundColor: model.get('connectedBackgroundColor'),
	    excludeComponents: model.get('excludeComponents'),
	    pixelRatio: model.get('pixelRatio')
	  }); // Chrome and Firefox
	
	  if (typeof MouseEvent === 'function' && !env.browser.ie && !env.browser.edge) {
	    var $a = document.createElement('a');
	    $a.download = title + '.' + type;
	    $a.target = '_blank';
	    $a.href = url;
	    var evt = new MouseEvent('click', {
	      // some micro front-end framework， window maybe is a Proxy
	      view: document.defaultView,
	      bubbles: true,
	      cancelable: false
	    });
	    $a.dispatchEvent(evt);
	  } // IE
	  else {
	      if (window.navigator.msSaveOrOpenBlob) {
	        var bstr = atob(url.split(',')[1]);
	        var n = bstr.length;
	        var u8arr = new Uint8Array(n);
	
	        while (n--) {
	          u8arr[n] = bstr.charCodeAt(n);
	        }
	
	        var blob = new Blob([u8arr]);
	        window.navigator.msSaveOrOpenBlob(blob, title + '.' + type);
	      } else {
	        var lang = model.get('lang');
	        var html = '' + '<body style="margin:0;">' + '<img src="' + url + '" style="max-width:100%;" title="' + (lang && lang[0] || '') + '" />' + '</body>';
	        var tab = window.open();
	        tab.document.write(html);
	      }
	    }
	};
	
	featureManager.register('saveAsImage', SaveAsImage);
	var _default = SaveAsImage;
	module.exports = _default;

/***/ },
/* 1641 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	__webpack_require__(260);
	
	__webpack_require__(1643);
	
	__webpack_require__(1645);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// FIXME Better way to pack data in graphic element
	
	/**
	 * @action
	 * @property {string} type
	 * @property {number} seriesIndex
	 * @property {number} dataIndex
	 * @property {number} [x]
	 * @property {number} [y]
	 */
	echarts.registerAction({
	  type: 'showTip',
	  event: 'showTip',
	  update: 'tooltip:manuallyShowTip'
	}, // noop
	function () {});
	echarts.registerAction({
	  type: 'hideTip',
	  event: 'hideTip',
	  update: 'tooltip:manuallyHideTip'
	}, // noop
	function () {});

/***/ },
/* 1642 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var zrColor = __webpack_require__(114);
	
	var eventUtil = __webpack_require__(113);
	
	var domUtil = __webpack_require__(1085);
	
	var env = __webpack_require__(55);
	
	var formatUtil = __webpack_require__(40);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var toCamelCase = formatUtil.toCamelCase;
	var vendors = ['', '-webkit-', '-moz-', '-o-'];
	var gCssText = 'position:absolute;display:block;border-style:solid;white-space:nowrap;z-index:9999999;';
	/**
	 * @param {number} duration
	 * @return {string}
	 * @inner
	 */
	
	function assembleTransition(duration) {
	  var transitionCurve = 'cubic-bezier(0.23, 1, 0.32, 1)';
	  var transitionText = 'left ' + duration + 's ' + transitionCurve + ',' + 'top ' + duration + 's ' + transitionCurve;
	  return zrUtil.map(vendors, function (vendorPrefix) {
	    return vendorPrefix + 'transition:' + transitionText;
	  }).join(';');
	}
	/**
	 * @param {Object} textStyle
	 * @return {string}
	 * @inner
	 */
	
	
	function assembleFont(textStyleModel) {
	  var cssText = [];
	  var fontSize = textStyleModel.get('fontSize');
	  var color = textStyleModel.getTextColor();
	  color && cssText.push('color:' + color);
	  cssText.push('font:' + textStyleModel.getFont());
	  var lineHeight = textStyleModel.get('lineHeight');
	
	  if (lineHeight == null) {
	    lineHeight = Math.round(fontSize * 3 / 2);
	  }
	
	  fontSize && cssText.push('line-height:' + lineHeight + 'px');
	  var shadowColor = textStyleModel.get('textShadowColor');
	  var shadowBlur = textStyleModel.get('textShadowBlur') || 0;
	  var shadowOffsetX = textStyleModel.get('textShadowOffsetX') || 0;
	  var shadowOffsetY = textStyleModel.get('textShadowOffsetY') || 0;
	  shadowBlur && cssText.push('text-shadow:' + shadowOffsetX + 'px ' + shadowOffsetY + 'px ' + shadowBlur + 'px ' + shadowColor);
	  each(['decoration', 'align'], function (name) {
	    var val = textStyleModel.get(name);
	    val && cssText.push('text-' + name + ':' + val);
	  });
	  return cssText.join(';');
	}
	/**
	 * @param {Object} tooltipModel
	 * @return {string}
	 * @inner
	 */
	
	
	function assembleCssText(tooltipModel) {
	  var cssText = [];
	  var transitionDuration = tooltipModel.get('transitionDuration');
	  var backgroundColor = tooltipModel.get('backgroundColor');
	  var textStyleModel = tooltipModel.getModel('textStyle');
	  var padding = tooltipModel.get('padding'); // Animation transition. Do not animate when transitionDuration is 0.
	
	  transitionDuration && cssText.push(assembleTransition(transitionDuration));
	
	  if (backgroundColor) {
	    if (env.canvasSupported) {
	      cssText.push('background-Color:' + backgroundColor);
	    } else {
	      // for ie
	      cssText.push('background-Color:#' + zrColor.toHex(backgroundColor));
	      cssText.push('filter:alpha(opacity=70)');
	    }
	  } // Border style
	
	
	  each(['width', 'color', 'radius'], function (name) {
	    var borderName = 'border-' + name;
	    var camelCase = toCamelCase(borderName);
	    var val = tooltipModel.get(camelCase);
	    val != null && cssText.push(borderName + ':' + val + (name === 'color' ? '' : 'px'));
	  }); // Text style
	
	  cssText.push(assembleFont(textStyleModel)); // Padding
	
	  if (padding != null) {
	    cssText.push('padding:' + formatUtil.normalizeCssArray(padding).join('px ') + 'px');
	  }
	
	  return cssText.join(';') + ';';
	} // If not able to make, do not modify the input `out`.
	
	
	function makeStyleCoord(out, zr, appendToBody, zrX, zrY) {
	  var zrPainter = zr && zr.painter;
	
	  if (appendToBody) {
	    var zrViewportRoot = zrPainter && zrPainter.getViewportRoot();
	
	    if (zrViewportRoot) {
	      // Some APPs might use scale on body, so we support CSS transform here.
	      domUtil.transformLocalCoord(out, zrViewportRoot, document.body, zrX, zrY);
	    }
	  } else {
	    out[0] = zrX;
	    out[1] = zrY; // xy should be based on canvas root. But tooltipContent is
	    // the sibling of canvas root. So padding of ec container
	    // should be considered here.
	
	    var viewportRootOffset = zrPainter && zrPainter.getViewportRootOffset();
	
	    if (viewportRootOffset) {
	      out[0] += viewportRootOffset.offsetLeft;
	      out[1] += viewportRootOffset.offsetTop;
	    }
	  }
	
	  out[2] = out[0] / zr.getWidth(); // The ratio of left to width
	
	  out[3] = out[1] / zr.getHeight(); // The ratio of top to height
	}
	/**
	 * @alias module:echarts/component/tooltip/TooltipContent
	 * @param {HTMLElement} container
	 * @param {ExtensionAPI} api
	 * @param {Object} [opt]
	 * @param {boolean} [opt.appendToBody]
	 *        `false`: the DOM element will be inside the container. Default value.
	 *        `true`: the DOM element will be appended to HTML body, which avoid
	 *                some overflow clip but intrude outside of the container.
	 * @constructor
	 */
	
	
	function TooltipContent(container, api, opt) {
	  if (env.wxa) {
	    return null;
	  }
	
	  var el = document.createElement('div');
	  el.domBelongToZr = true;
	  this.el = el;
	  var zr = this._zr = api.getZr();
	  var appendToBody = this._appendToBody = opt && opt.appendToBody;
	  this._styleCoord = [0, 0, 0, 0]; // [left, top, left/width, top/height]
	
	  makeStyleCoord(this._styleCoord, zr, appendToBody, api.getWidth() / 2, api.getHeight() / 2);
	
	  if (appendToBody) {
	    document.body.appendChild(el);
	  } else {
	    container.appendChild(el);
	  }
	
	  this._container = container;
	  this._show = false;
	  /**
	   * @private
	   */
	
	  this._hideTimeout; // FIXME
	  // Is it needed to trigger zr event manually if
	  // the browser do not support `pointer-events: none`.
	
	  var self = this;
	
	  el.onmouseenter = function () {
	    // clear the timeout in hideLater and keep showing tooltip
	    if (self._enterable) {
	      clearTimeout(self._hideTimeout);
	      self._show = true;
	    }
	
	    self._inContent = true;
	  };
	
	  el.onmousemove = function (e) {
	    e = e || window.event;
	
	    if (!self._enterable) {
	      // `pointer-events: none` is set to tooltip content div
	      // if `enterable` is set as `false`, and `el.onmousemove`
	      // can not be triggered. But in browser that do not
	      // support `pointer-events`, we need to do this:
	      // Try trigger zrender event to avoid mouse
	      // in and out shape too frequently
	      var handler = zr.handler;
	      var zrViewportRoot = zr.painter.getViewportRoot();
	      eventUtil.normalizeEvent(zrViewportRoot, e, true);
	      handler.dispatch('mousemove', e);
	    }
	  };
	
	  el.onmouseleave = function () {
	    if (self._enterable) {
	      if (self._show) {
	        self.hideLater(self._hideDelay);
	      }
	    }
	
	    self._inContent = false;
	  };
	}
	
	TooltipContent.prototype = {
	  constructor: TooltipContent,
	
	  /**
	   * @private
	   * @type {boolean}
	   */
	  _enterable: true,
	
	  /**
	   * Update when tooltip is rendered
	   */
	  update: function (tooltipModel) {
	    // FIXME
	    // Move this logic to ec main?
	    var container = this._container;
	    var stl = container.currentStyle || document.defaultView.getComputedStyle(container);
	    var domStyle = container.style;
	
	    if (domStyle.position !== 'absolute' && stl.position !== 'absolute') {
	      domStyle.position = 'relative';
	    }
	
	    var alwaysShowContent = tooltipModel.get('alwaysShowContent');
	    alwaysShowContent && this._moveTooltipIfResized(); // Hide the tooltip
	    // PENDING
	    // this.hide();
	  },
	
	  /**
	   * when `alwaysShowContent` is true,
	   * we should move the tooltip after chart resized
	   */
	  _moveTooltipIfResized: function () {
	    var ratioX = this._styleCoord[2]; // The ratio of left to width
	
	    var ratioY = this._styleCoord[3]; // The ratio of top to height
	
	    var realX = ratioX * this._zr.getWidth();
	
	    var realY = ratioY * this._zr.getHeight();
	
	    this.moveTo(realX, realY);
	  },
	  show: function (tooltipModel) {
	    clearTimeout(this._hideTimeout);
	    var el = this.el;
	    var styleCoord = this._styleCoord;
	    el.style.cssText = gCssText + assembleCssText(tooltipModel) // Because of the reason described in:
	    // http://stackoverflow.com/questions/21125587/css3-transition-not-working-in-chrome-anymore
	    // we should set initial value to `left` and `top`.
	    + ';left:' + styleCoord[0] + 'px;top:' + styleCoord[1] + 'px;' + (tooltipModel.get('extraCssText') || '');
	    el.style.display = el.innerHTML ? 'block' : 'none'; // If mouse occasionally move over the tooltip, a mouseout event will be
	    // triggered by canvas, and cause some unexpectable result like dragging
	    // stop, "unfocusAdjacency". Here `pointer-events: none` is used to solve
	    // it. Although it is not supported by IE8~IE10, fortunately it is a rare
	    // scenario.
	
	    el.style.pointerEvents = this._enterable ? 'auto' : 'none';
	    this._show = true;
	  },
	  setContent: function (content) {
	    this.el.innerHTML = content == null ? '' : content;
	  },
	  setEnterable: function (enterable) {
	    this._enterable = enterable;
	  },
	  getSize: function () {
	    var el = this.el;
	    return [el.clientWidth, el.clientHeight];
	  },
	  moveTo: function (zrX, zrY) {
	    var styleCoord = this._styleCoord;
	    makeStyleCoord(styleCoord, this._zr, this._appendToBody, zrX, zrY);
	    var style = this.el.style;
	    style.left = styleCoord[0] + 'px';
	    style.top = styleCoord[1] + 'px';
	  },
	  hide: function () {
	    this.el.style.display = 'none';
	    this._show = false;
	  },
	  hideLater: function (time) {
	    if (this._show && !(this._inContent && this._enterable)) {
	      if (time) {
	        this._hideDelay = time; // Set show false to avoid invoke hideLater multiple times
	
	        this._show = false;
	        this._hideTimeout = setTimeout(zrUtil.bind(this.hide, this), time);
	      } else {
	        this.hide();
	      }
	    }
	  },
	  isShow: function () {
	    return this._show;
	  },
	  dispose: function () {
	    this.el.parentNode.removeChild(this.el);
	  },
	  getOuterSize: function () {
	    var width = this.el.clientWidth;
	    var height = this.el.clientHeight; // Consider browser compatibility.
	    // IE8 does not support getComputedStyle.
	
	    if (document.defaultView && document.defaultView.getComputedStyle) {
	      var stl = document.defaultView.getComputedStyle(this.el);
	
	      if (stl) {
	        width += parseInt(stl.borderLeftWidth, 10) + parseInt(stl.borderRightWidth, 10);
	        height += parseInt(stl.borderTopWidth, 10) + parseInt(stl.borderBottomWidth, 10);
	      }
	    }
	
	    return {
	      width: width,
	      height: height
	    };
	  }
	};
	var _default = TooltipContent;
	module.exports = _default;

/***/ },
/* 1643 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentModel({
	  type: 'tooltip',
	  dependencies: ['axisPointer'],
	  defaultOption: {
	    zlevel: 0,
	    z: 60,
	    show: true,
	    // tooltip主体内容
	    showContent: true,
	    // 'trigger' only works on coordinate system.
	    // 'item' | 'axis' | 'none'
	    trigger: 'item',
	    // 'click' | 'mousemove' | 'none'
	    triggerOn: 'mousemove|click',
	    alwaysShowContent: false,
	    displayMode: 'single',
	    // 'single' | 'multipleByCoordSys'
	    renderMode: 'auto',
	    // 'auto' | 'html' | 'richText'
	    // 'auto': use html by default, and use non-html if `document` is not defined
	    // 'html': use html for tooltip
	    // 'richText': use canvas, svg, and etc. for tooltip
	    // 位置 {Array} | {Function}
	    // position: null
	    // Consider triggered from axisPointer handle, verticalAlign should be 'middle'
	    // align: null,
	    // verticalAlign: null,
	    // 是否约束 content 在 viewRect 中。默认 false 是为了兼容以前版本。
	    confine: false,
	    // 内容格式器：{string}（Template） ¦ {Function}
	    // formatter: null
	    showDelay: 0,
	    // 隐藏延迟，单位ms
	    hideDelay: 100,
	    // 动画变换时间，单位s
	    transitionDuration: 0.4,
	    enterable: false,
	    // 提示背景颜色，默认为透明度为0.7的黑色
	    backgroundColor: 'rgba(50,50,50,0.7)',
	    // 提示边框颜色
	    borderColor: '#333',
	    // 提示边框圆角，单位px，默认为4
	    borderRadius: 4,
	    // 提示边框线宽，单位px，默认为0（无边框）
	    borderWidth: 0,
	    // 提示内边距，单位px，默认各方向内边距为5，
	    // 接受数组分别设定上右下左边距，同css
	    padding: 5,
	    // Extra css text
	    extraCssText: '',
	    // 坐标轴指示器，坐标轴触发有效
	    axisPointer: {
	      // 默认为直线
	      // 可选为：'line' | 'shadow' | 'cross'
	      type: 'line',
	      // type 为 line 的时候有效，指定 tooltip line 所在的轴，可选
	      // 可选 'x' | 'y' | 'angle' | 'radius' | 'auto'
	      // 默认 'auto'，会选择类型为 category 的轴，对于双数值轴，笛卡尔坐标系会默认选择 x 轴
	      // 极坐标系会默认选择 angle 轴
	      axis: 'auto',
	      animation: 'auto',
	      animationDurationUpdate: 200,
	      animationEasingUpdate: 'exponentialOut',
	      crossStyle: {
	        color: '#999',
	        width: 1,
	        type: 'dashed',
	        // TODO formatter
	        textStyle: {} // lineStyle and shadowStyle should not be specified here,
	        // otherwise it will always override those styles on option.axisPointer.
	
	      }
	    },
	    textStyle: {
	      color: '#fff',
	      fontSize: 14
	    }
	  }
	});
	
	module.exports = _default;

/***/ },
/* 1644 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var Text = __webpack_require__(188);
	
	var graphicUtil = __webpack_require__(16);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// import Group from 'zrender/src/container/Group';
	function makeStyleCoord(out, zr, zrX, zrY) {
	  out[0] = zrX;
	  out[1] = zrY;
	  out[2] = out[0] / zr.getWidth(); // The ratio of left to width
	
	  out[3] = out[1] / zr.getHeight(); // The ratio of top to height
	}
	/**
	 * @alias module:echarts/component/tooltip/TooltipRichContent
	 * @constructor
	 */
	
	
	function TooltipRichContent(api) {
	  var zr = this._zr = api.getZr();
	  this._styleCoord = [0, 0, 0, 0]; // [left, top, left/width, top/height]
	
	  makeStyleCoord(this._styleCoord, zr, api.getWidth() / 2, api.getHeight() / 2);
	  this._show = false;
	  /**
	   * @private
	   */
	
	  this._hideTimeout;
	}
	
	TooltipRichContent.prototype = {
	  constructor: TooltipRichContent,
	
	  /**
	   * @private
	   * @type {boolean}
	   */
	  _enterable: true,
	
	  /**
	   * Update when tooltip is rendered
	   */
	  update: function (tooltipModel) {
	    var alwaysShowContent = tooltipModel.get('alwaysShowContent');
	    alwaysShowContent && this._moveTooltipIfResized();
	  },
	
	  /**
	   * when `alwaysShowContent` is true,
	   * we should move the tooltip after chart resized
	   */
	  _moveTooltipIfResized: function () {
	    var ratioX = this._styleCoord[2]; // The ratio of left to width
	
	    var ratioY = this._styleCoord[3]; // The ratio of top to height
	
	    var realX = ratioX * this._zr.getWidth();
	
	    var realY = ratioY * this._zr.getHeight();
	
	    this.moveTo(realX, realY);
	  },
	  show: function (tooltipModel) {
	    if (this._hideTimeout) {
	      clearTimeout(this._hideTimeout);
	    }
	
	    this.el.attr('show', true);
	    this._show = true;
	  },
	
	  /**
	   * Set tooltip content
	   *
	   * @param {string} content rich text string of content
	   * @param {Object} markerRich rich text style
	   * @param {Object} tooltipModel tooltip model
	   */
	  setContent: function (content, markerRich, tooltipModel) {
	    if (this.el) {
	      this._zr.remove(this.el);
	    }
	
	    var markers = {};
	    var text = content;
	    var prefix = '{marker';
	    var suffix = '|}';
	    var startId = text.indexOf(prefix);
	
	    while (startId >= 0) {
	      var endId = text.indexOf(suffix);
	      var name = text.substr(startId + prefix.length, endId - startId - prefix.length);
	
	      if (name.indexOf('sub') > -1) {
	        markers['marker' + name] = {
	          textWidth: 4,
	          textHeight: 4,
	          textBorderRadius: 2,
	          textBackgroundColor: markerRich[name],
	          // TODO: textOffset is not implemented for rich text
	          textOffset: [3, 0]
	        };
	      } else {
	        markers['marker' + name] = {
	          textWidth: 10,
	          textHeight: 10,
	          textBorderRadius: 5,
	          textBackgroundColor: markerRich[name]
	        };
	      }
	
	      text = text.substr(endId + 1);
	      startId = text.indexOf('{marker');
	    }
	
	    var textStyleModel = tooltipModel.getModel('textStyle');
	    var fontSize = textStyleModel.get('fontSize');
	    var lineHeight = tooltipModel.get('textLineHeight');
	
	    if (lineHeight == null) {
	      lineHeight = Math.round(fontSize * 3 / 2);
	    }
	
	    this.el = new Text({
	      style: graphicUtil.setTextStyle({}, textStyleModel, {
	        rich: markers,
	        text: content,
	        textBackgroundColor: tooltipModel.get('backgroundColor'),
	        textBorderRadius: tooltipModel.get('borderRadius'),
	        textFill: tooltipModel.get('textStyle.color'),
	        textPadding: tooltipModel.get('padding'),
	        textLineHeight: lineHeight
	      }),
	      z: tooltipModel.get('z')
	    });
	
	    this._zr.add(this.el);
	
	    var self = this;
	    this.el.on('mouseover', function () {
	      // clear the timeout in hideLater and keep showing tooltip
	      if (self._enterable) {
	        clearTimeout(self._hideTimeout);
	        self._show = true;
	      }
	
	      self._inContent = true;
	    });
	    this.el.on('mouseout', function () {
	      if (self._enterable) {
	        if (self._show) {
	          self.hideLater(self._hideDelay);
	        }
	      }
	
	      self._inContent = false;
	    });
	  },
	  setEnterable: function (enterable) {
	    this._enterable = enterable;
	  },
	  getSize: function () {
	    var bounding = this.el.getBoundingRect();
	    return [bounding.width, bounding.height];
	  },
	  moveTo: function (x, y) {
	    if (this.el) {
	      var styleCoord = this._styleCoord;
	      makeStyleCoord(styleCoord, this._zr, x, y);
	      this.el.attr('position', [styleCoord[0], styleCoord[1]]);
	    }
	  },
	  hide: function () {
	    if (this.el) {
	      this.el.hide();
	    }
	
	    this._show = false;
	  },
	  hideLater: function (time) {
	    if (this._show && !(this._inContent && this._enterable)) {
	      if (time) {
	        this._hideDelay = time; // Set show false to avoid invoke hideLater multiple times
	
	        this._show = false;
	        this._hideTimeout = setTimeout(zrUtil.bind(this.hide, this), time);
	      } else {
	        this.hide();
	      }
	    }
	  },
	  isShow: function () {
	    return this._show;
	  },
	  dispose: function () {
	    clearTimeout(this._hideTimeout);
	
	    if (this.el) {
	      this._zr.remove(this.el);
	    }
	  },
	  getOuterSize: function () {
	    var size = this.getSize();
	    return {
	      width: size[0],
	      height: size[1]
	    };
	  }
	};
	var _default = TooltipRichContent;
	module.exports = _default;

/***/ },
/* 1645 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var env = __webpack_require__(55);
	
	var TooltipContent = __webpack_require__(1642);
	
	var TooltipRichContent = __webpack_require__(1644);
	
	var formatUtil = __webpack_require__(40);
	
	var numberUtil = __webpack_require__(20);
	
	var graphic = __webpack_require__(16);
	
	var findPointFromSeries = __webpack_require__(711);
	
	var layoutUtil = __webpack_require__(36);
	
	var Model = __webpack_require__(48);
	
	var globalListener = __webpack_require__(712);
	
	var axisHelper = __webpack_require__(93);
	
	var axisPointerViewHelper = __webpack_require__(333);
	
	var _model = __webpack_require__(24);
	
	var getTooltipRenderMode = _model.getTooltipRenderMode;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var bind = zrUtil.bind;
	var each = zrUtil.each;
	var parsePercent = numberUtil.parsePercent;
	var proxyRect = new graphic.Rect({
	  shape: {
	    x: -1,
	    y: -1,
	    width: 2,
	    height: 2
	  }
	});
	
	var _default = echarts.extendComponentView({
	  type: 'tooltip',
	  init: function (ecModel, api) {
	    if (env.node) {
	      return;
	    }
	
	    var tooltipModel = ecModel.getComponent('tooltip');
	    var renderMode = tooltipModel.get('renderMode');
	    this._renderMode = getTooltipRenderMode(renderMode);
	    var tooltipContent;
	
	    if (this._renderMode === 'html') {
	      tooltipContent = new TooltipContent(api.getDom(), api, {
	        appendToBody: tooltipModel.get('appendToBody', true)
	      });
	      this._newLine = '<br/>';
	    } else {
	      tooltipContent = new TooltipRichContent(api);
	      this._newLine = '\n';
	    }
	
	    this._tooltipContent = tooltipContent;
	  },
	  render: function (tooltipModel, ecModel, api) {
	    if (env.node) {
	      return;
	    } // Reset
	
	
	    this.group.removeAll();
	    /**
	     * @private
	     * @type {module:echarts/component/tooltip/TooltipModel}
	     */
	
	    this._tooltipModel = tooltipModel;
	    /**
	     * @private
	     * @type {module:echarts/model/Global}
	     */
	
	    this._ecModel = ecModel;
	    /**
	     * @private
	     * @type {module:echarts/ExtensionAPI}
	     */
	
	    this._api = api;
	    /**
	     * Should be cleaned when render.
	     * @private
	     * @type {Array.<Array.<Object>>}
	     */
	
	    this._lastDataByCoordSys = null;
	    /**
	     * @private
	     * @type {boolean}
	     */
	
	    this._alwaysShowContent = tooltipModel.get('alwaysShowContent');
	    var tooltipContent = this._tooltipContent;
	    tooltipContent.update(tooltipModel);
	    tooltipContent.setEnterable(tooltipModel.get('enterable'));
	
	    this._initGlobalListener();
	
	    this._keepShow();
	  },
	  _initGlobalListener: function () {
	    var tooltipModel = this._tooltipModel;
	    var triggerOn = tooltipModel.get('triggerOn');
	    globalListener.register('itemTooltip', this._api, bind(function (currTrigger, e, dispatchAction) {
	      // If 'none', it is not controlled by mouse totally.
	      if (triggerOn !== 'none') {
	        if (triggerOn.indexOf(currTrigger) >= 0) {
	          this._tryShow(e, dispatchAction);
	        } else if (currTrigger === 'leave') {
	          this._hide(dispatchAction);
	        }
	      }
	    }, this));
	  },
	  _keepShow: function () {
	    var tooltipModel = this._tooltipModel;
	    var ecModel = this._ecModel;
	    var api = this._api; // Try to keep the tooltip show when refreshing
	
	    if (this._lastX != null && this._lastY != null // When user is willing to control tooltip totally using API,
	    // self.manuallyShowTip({x, y}) might cause tooltip hide,
	    // which is not expected.
	    && tooltipModel.get('triggerOn') !== 'none') {
	      var self = this;
	      clearTimeout(this._refreshUpdateTimeout);
	      this._refreshUpdateTimeout = setTimeout(function () {
	        // Show tip next tick after other charts are rendered
	        // In case highlight action has wrong result
	        // FIXME
	        !api.isDisposed() && self.manuallyShowTip(tooltipModel, ecModel, api, {
	          x: self._lastX,
	          y: self._lastY
	        });
	      });
	    }
	  },
	
	  /**
	   * Show tip manually by
	   * dispatchAction({
	   *     type: 'showTip',
	   *     x: 10,
	   *     y: 10
	   * });
	   * Or
	   * dispatchAction({
	   *      type: 'showTip',
	   *      seriesIndex: 0,
	   *      dataIndex or dataIndexInside or name
	   * });
	   *
	   *  TODO Batch
	   */
	  manuallyShowTip: function (tooltipModel, ecModel, api, payload) {
	    if (payload.from === this.uid || env.node) {
	      return;
	    }
	
	    var dispatchAction = makeDispatchAction(payload, api); // Reset ticket
	
	    this._ticket = ''; // When triggered from axisPointer.
	
	    var dataByCoordSys = payload.dataByCoordSys;
	
	    if (payload.tooltip && payload.x != null && payload.y != null) {
	      var el = proxyRect;
	      el.position = [payload.x, payload.y];
	      el.update();
	      el.tooltip = payload.tooltip; // Manually show tooltip while view is not using zrender elements.
	
	      this._tryShow({
	        offsetX: payload.x,
	        offsetY: payload.y,
	        target: el
	      }, dispatchAction);
	    } else if (dataByCoordSys) {
	      this._tryShow({
	        offsetX: payload.x,
	        offsetY: payload.y,
	        position: payload.position,
	        dataByCoordSys: payload.dataByCoordSys,
	        tooltipOption: payload.tooltipOption
	      }, dispatchAction);
	    } else if (payload.seriesIndex != null) {
	      if (this._manuallyAxisShowTip(tooltipModel, ecModel, api, payload)) {
	        return;
	      }
	
	      var pointInfo = findPointFromSeries(payload, ecModel);
	      var cx = pointInfo.point[0];
	      var cy = pointInfo.point[1];
	
	      if (cx != null && cy != null) {
	        this._tryShow({
	          offsetX: cx,
	          offsetY: cy,
	          position: payload.position,
	          target: pointInfo.el
	        }, dispatchAction);
	      }
	    } else if (payload.x != null && payload.y != null) {
	      // FIXME
	      // should wrap dispatchAction like `axisPointer/globalListener` ?
	      api.dispatchAction({
	        type: 'updateAxisPointer',
	        x: payload.x,
	        y: payload.y
	      });
	
	      this._tryShow({
	        offsetX: payload.x,
	        offsetY: payload.y,
	        position: payload.position,
	        target: api.getZr().findHover(payload.x, payload.y).target
	      }, dispatchAction);
	    }
	  },
	  manuallyHideTip: function (tooltipModel, ecModel, api, payload) {
	    var tooltipContent = this._tooltipContent;
	
	    if (!this._alwaysShowContent && this._tooltipModel) {
	      tooltipContent.hideLater(this._tooltipModel.get('hideDelay'));
	    }
	
	    this._lastX = this._lastY = null;
	
	    if (payload.from !== this.uid) {
	      this._hide(makeDispatchAction(payload, api));
	    }
	  },
	  // Be compatible with previous design, that is, when tooltip.type is 'axis' and
	  // dispatchAction 'showTip' with seriesIndex and dataIndex will trigger axis pointer
	  // and tooltip.
	  _manuallyAxisShowTip: function (tooltipModel, ecModel, api, payload) {
	    var seriesIndex = payload.seriesIndex;
	    var dataIndex = payload.dataIndex;
	    var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo;
	
	    if (seriesIndex == null || dataIndex == null || coordSysAxesInfo == null) {
	      return;
	    }
	
	    var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
	
	    if (!seriesModel) {
	      return;
	    }
	
	    var data = seriesModel.getData();
	    var tooltipModel = buildTooltipModel([data.getItemModel(dataIndex), seriesModel, (seriesModel.coordinateSystem || {}).model, tooltipModel]);
	
	    if (tooltipModel.get('trigger') !== 'axis') {
	      return;
	    }
	
	    api.dispatchAction({
	      type: 'updateAxisPointer',
	      seriesIndex: seriesIndex,
	      dataIndex: dataIndex,
	      position: payload.position
	    });
	    return true;
	  },
	  _tryShow: function (e, dispatchAction) {
	    var el = e.target;
	    var tooltipModel = this._tooltipModel;
	
	    if (!tooltipModel) {
	      return;
	    } // Save mouse x, mouse y. So we can try to keep showing the tip if chart is refreshed
	
	
	    this._lastX = e.offsetX;
	    this._lastY = e.offsetY;
	    var dataByCoordSys = e.dataByCoordSys;
	
	    if (dataByCoordSys && dataByCoordSys.length) {
	      this._showAxisTooltip(dataByCoordSys, e);
	    } // Always show item tooltip if mouse is on the element with dataIndex
	    else if (el && el.dataIndex != null) {
	        this._lastDataByCoordSys = null;
	
	        this._showSeriesItemTooltip(e, el, dispatchAction);
	      } // Tooltip provided directly. Like legend.
	      else if (el && el.tooltip) {
	          this._lastDataByCoordSys = null;
	
	          this._showComponentItemTooltip(e, el, dispatchAction);
	        } else {
	          this._lastDataByCoordSys = null;
	
	          this._hide(dispatchAction);
	        }
	  },
	  _showOrMove: function (tooltipModel, cb) {
	    // showDelay is used in this case: tooltip.enterable is set
	    // as true. User intent to move mouse into tooltip and click
	    // something. `showDelay` makes it easier to enter the content
	    // but tooltip do not move immediately.
	    var delay = tooltipModel.get('showDelay');
	    cb = zrUtil.bind(cb, this);
	    clearTimeout(this._showTimout);
	    delay > 0 ? this._showTimout = setTimeout(cb, delay) : cb();
	  },
	  _showAxisTooltip: function (dataByCoordSys, e) {
	    var ecModel = this._ecModel;
	    var globalTooltipModel = this._tooltipModel;
	    var point = [e.offsetX, e.offsetY];
	    var singleDefaultHTML = [];
	    var singleParamsList = [];
	    var singleTooltipModel = buildTooltipModel([e.tooltipOption, globalTooltipModel]);
	    var renderMode = this._renderMode;
	    var newLine = this._newLine;
	    var markers = {};
	    each(dataByCoordSys, function (itemCoordSys) {
	      // var coordParamList = [];
	      // var coordDefaultHTML = [];
	      // var coordTooltipModel = buildTooltipModel([
	      //     e.tooltipOption,
	      //     itemCoordSys.tooltipOption,
	      //     ecModel.getComponent(itemCoordSys.coordSysMainType, itemCoordSys.coordSysIndex),
	      //     globalTooltipModel
	      // ]);
	      // var displayMode = coordTooltipModel.get('displayMode');
	      // var paramsList = displayMode === 'single' ? singleParamsList : [];
	      each(itemCoordSys.dataByAxis, function (item) {
	        var axisModel = ecModel.getComponent(item.axisDim + 'Axis', item.axisIndex);
	        var axisValue = item.value;
	        var seriesDefaultHTML = [];
	
	        if (!axisModel || axisValue == null) {
	          return;
	        }
	
	        var valueLabel = axisPointerViewHelper.getValueLabel(axisValue, axisModel.axis, ecModel, item.seriesDataIndices, item.valueLabelOpt);
	        zrUtil.each(item.seriesDataIndices, function (idxItem) {
	          var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
	          var dataIndex = idxItem.dataIndexInside;
	          var dataParams = series && series.getDataParams(dataIndex);
	          dataParams.axisDim = item.axisDim;
	          dataParams.axisIndex = item.axisIndex;
	          dataParams.axisType = item.axisType;
	          dataParams.axisId = item.axisId;
	          dataParams.axisValue = axisHelper.getAxisRawValue(axisModel.axis, axisValue);
	          dataParams.axisValueLabel = valueLabel;
	
	          if (dataParams) {
	            singleParamsList.push(dataParams);
	            var seriesTooltip = series.formatTooltip(dataIndex, true, null, renderMode);
	            var html;
	
	            if (zrUtil.isObject(seriesTooltip)) {
	              html = seriesTooltip.html;
	              var newMarkers = seriesTooltip.markers;
	              zrUtil.merge(markers, newMarkers);
	            } else {
	              html = seriesTooltip;
	            }
	
	            seriesDefaultHTML.push(html);
	          }
	        }); // Default tooltip content
	        // FIXME
	        // (1) should be the first data which has name?
	        // (2) themeRiver, firstDataIndex is array, and first line is unnecessary.
	
	        var firstLine = valueLabel;
	
	        if (renderMode !== 'html') {
	          singleDefaultHTML.push(seriesDefaultHTML.join(newLine));
	        } else {
	          singleDefaultHTML.push((firstLine ? formatUtil.encodeHTML(firstLine) + newLine : '') + seriesDefaultHTML.join(newLine));
	        }
	      });
	    }, this); // In most case, the second axis is shown upper than the first one.
	
	    singleDefaultHTML.reverse();
	    singleDefaultHTML = singleDefaultHTML.join(this._newLine + this._newLine);
	    var positionExpr = e.position;
	
	    this._showOrMove(singleTooltipModel, function () {
	      if (this._updateContentNotChangedOnAxis(dataByCoordSys)) {
	        this._updatePosition(singleTooltipModel, positionExpr, point[0], point[1], this._tooltipContent, singleParamsList);
	      } else {
	        this._showTooltipContent(singleTooltipModel, singleDefaultHTML, singleParamsList, Math.random(), point[0], point[1], positionExpr, undefined, markers);
	      }
	    }); // Do not trigger events here, because this branch only be entered
	    // from dispatchAction.
	
	  },
	  _showSeriesItemTooltip: function (e, el, dispatchAction) {
	    var ecModel = this._ecModel; // Use dataModel in element if possible
	    // Used when mouseover on a element like markPoint or edge
	    // In which case, the data is not main data in series.
	
	    var seriesIndex = el.seriesIndex;
	    var seriesModel = ecModel.getSeriesByIndex(seriesIndex); // For example, graph link.
	
	    var dataModel = el.dataModel || seriesModel;
	    var dataIndex = el.dataIndex;
	    var dataType = el.dataType;
	    var data = dataModel.getData(dataType);
	    var tooltipModel = buildTooltipModel([data.getItemModel(dataIndex), dataModel, seriesModel && (seriesModel.coordinateSystem || {}).model, this._tooltipModel]);
	    var tooltipTrigger = tooltipModel.get('trigger');
	
	    if (tooltipTrigger != null && tooltipTrigger !== 'item') {
	      return;
	    }
	
	    var params = dataModel.getDataParams(dataIndex, dataType);
	    var seriesTooltip = dataModel.formatTooltip(dataIndex, false, dataType, this._renderMode);
	    var defaultHtml;
	    var markers;
	
	    if (zrUtil.isObject(seriesTooltip)) {
	      defaultHtml = seriesTooltip.html;
	      markers = seriesTooltip.markers;
	    } else {
	      defaultHtml = seriesTooltip;
	      markers = null;
	    }
	
	    var asyncTicket = 'item_' + dataModel.name + '_' + dataIndex;
	
	    this._showOrMove(tooltipModel, function () {
	      this._showTooltipContent(tooltipModel, defaultHtml, params, asyncTicket, e.offsetX, e.offsetY, e.position, e.target, markers);
	    }); // FIXME
	    // duplicated showtip if manuallyShowTip is called from dispatchAction.
	
	
	    dispatchAction({
	      type: 'showTip',
	      dataIndexInside: dataIndex,
	      dataIndex: data.getRawIndex(dataIndex),
	      seriesIndex: seriesIndex,
	      from: this.uid
	    });
	  },
	  _showComponentItemTooltip: function (e, el, dispatchAction) {
	    var tooltipOpt = el.tooltip;
	
	    if (typeof tooltipOpt === 'string') {
	      var content = tooltipOpt;
	      tooltipOpt = {
	        content: content,
	        // Fixed formatter
	        formatter: content
	      };
	    }
	
	    var subTooltipModel = new Model(tooltipOpt, this._tooltipModel, this._ecModel);
	    var defaultHtml = subTooltipModel.get('content');
	    var asyncTicket = Math.random(); // Do not check whether `trigger` is 'none' here, because `trigger`
	    // only works on coordinate system. In fact, we have not found case
	    // that requires setting `trigger` nothing on component yet.
	
	    this._showOrMove(subTooltipModel, function () {
	      this._showTooltipContent(subTooltipModel, defaultHtml, subTooltipModel.get('formatterParams') || {}, asyncTicket, e.offsetX, e.offsetY, e.position, el);
	    }); // If not dispatch showTip, tip may be hide triggered by axis.
	
	
	    dispatchAction({
	      type: 'showTip',
	      from: this.uid
	    });
	  },
	  _showTooltipContent: function (tooltipModel, defaultHtml, params, asyncTicket, x, y, positionExpr, el, markers) {
	    // Reset ticket
	    this._ticket = '';
	
	    if (!tooltipModel.get('showContent') || !tooltipModel.get('show')) {
	      return;
	    }
	
	    var tooltipContent = this._tooltipContent;
	    var formatter = tooltipModel.get('formatter');
	    positionExpr = positionExpr || tooltipModel.get('position');
	    var html = defaultHtml;
	
	    if (formatter && typeof formatter === 'string') {
	      html = formatUtil.formatTpl(formatter, params, true);
	    } else if (typeof formatter === 'function') {
	      var callback = bind(function (cbTicket, html) {
	        if (cbTicket === this._ticket) {
	          tooltipContent.setContent(html, markers, tooltipModel);
	
	          this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
	        }
	      }, this);
	      this._ticket = asyncTicket;
	      html = formatter(params, asyncTicket, callback);
	    }
	
	    tooltipContent.setContent(html, markers, tooltipModel);
	    tooltipContent.show(tooltipModel);
	
	    this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
	  },
	
	  /**
	   * @param  {string|Function|Array.<number>|Object} positionExpr
	   * @param  {number} x Mouse x
	   * @param  {number} y Mouse y
	   * @param  {boolean} confine Whether confine tooltip content in view rect.
	   * @param  {Object|<Array.<Object>} params
	   * @param  {module:zrender/Element} el target element
	   * @param  {module:echarts/ExtensionAPI} api
	   * @return {Array.<number>}
	   */
	  _updatePosition: function (tooltipModel, positionExpr, x, y, content, params, el) {
	    var viewWidth = this._api.getWidth();
	
	    var viewHeight = this._api.getHeight();
	
	    positionExpr = positionExpr || tooltipModel.get('position');
	    var contentSize = content.getSize();
	    var align = tooltipModel.get('align');
	    var vAlign = tooltipModel.get('verticalAlign');
	    var rect = el && el.getBoundingRect().clone();
	    el && rect.applyTransform(el.transform);
	
	    if (typeof positionExpr === 'function') {
	      // Callback of position can be an array or a string specify the position
	      positionExpr = positionExpr([x, y], params, content.el, rect, {
	        viewSize: [viewWidth, viewHeight],
	        contentSize: contentSize.slice()
	      });
	    }
	
	    if (zrUtil.isArray(positionExpr)) {
	      x = parsePercent(positionExpr[0], viewWidth);
	      y = parsePercent(positionExpr[1], viewHeight);
	    } else if (zrUtil.isObject(positionExpr)) {
	      positionExpr.width = contentSize[0];
	      positionExpr.height = contentSize[1];
	      var layoutRect = layoutUtil.getLayoutRect(positionExpr, {
	        width: viewWidth,
	        height: viewHeight
	      });
	      x = layoutRect.x;
	      y = layoutRect.y;
	      align = null; // When positionExpr is left/top/right/bottom,
	      // align and verticalAlign will not work.
	
	      vAlign = null;
	    } // Specify tooltip position by string 'top' 'bottom' 'left' 'right' around graphic element
	    else if (typeof positionExpr === 'string' && el) {
	        var pos = calcTooltipPosition(positionExpr, rect, contentSize);
	        x = pos[0];
	        y = pos[1];
	      } else {
	        var pos = refixTooltipPosition(x, y, content, viewWidth, viewHeight, align ? null : 20, vAlign ? null : 20);
	        x = pos[0];
	        y = pos[1];
	      }
	
	    align && (x -= isCenterAlign(align) ? contentSize[0] / 2 : align === 'right' ? contentSize[0] : 0);
	    vAlign && (y -= isCenterAlign(vAlign) ? contentSize[1] / 2 : vAlign === 'bottom' ? contentSize[1] : 0);
	
	    if (tooltipModel.get('confine')) {
	      var pos = confineTooltipPosition(x, y, content, viewWidth, viewHeight);
	      x = pos[0];
	      y = pos[1];
	    }
	
	    content.moveTo(x, y);
	  },
	  // FIXME
	  // Should we remove this but leave this to user?
	  _updateContentNotChangedOnAxis: function (dataByCoordSys) {
	    var lastCoordSys = this._lastDataByCoordSys;
	    var contentNotChanged = !!lastCoordSys && lastCoordSys.length === dataByCoordSys.length;
	    contentNotChanged && each(lastCoordSys, function (lastItemCoordSys, indexCoordSys) {
	      var lastDataByAxis = lastItemCoordSys.dataByAxis || {};
	      var thisItemCoordSys = dataByCoordSys[indexCoordSys] || {};
	      var thisDataByAxis = thisItemCoordSys.dataByAxis || [];
	      contentNotChanged &= lastDataByAxis.length === thisDataByAxis.length;
	      contentNotChanged && each(lastDataByAxis, function (lastItem, indexAxis) {
	        var thisItem = thisDataByAxis[indexAxis] || {};
	        var lastIndices = lastItem.seriesDataIndices || [];
	        var newIndices = thisItem.seriesDataIndices || [];
	        contentNotChanged &= lastItem.value === thisItem.value && lastItem.axisType === thisItem.axisType && lastItem.axisId === thisItem.axisId && lastIndices.length === newIndices.length;
	        contentNotChanged && each(lastIndices, function (lastIdxItem, j) {
	          var newIdxItem = newIndices[j];
	          contentNotChanged &= lastIdxItem.seriesIndex === newIdxItem.seriesIndex && lastIdxItem.dataIndex === newIdxItem.dataIndex;
	        });
	      });
	    });
	    this._lastDataByCoordSys = dataByCoordSys;
	    return !!contentNotChanged;
	  },
	  _hide: function (dispatchAction) {
	    // Do not directly hideLater here, because this behavior may be prevented
	    // in dispatchAction when showTip is dispatched.
	    // FIXME
	    // duplicated hideTip if manuallyHideTip is called from dispatchAction.
	    this._lastDataByCoordSys = null;
	    dispatchAction({
	      type: 'hideTip',
	      from: this.uid
	    });
	  },
	  dispose: function (ecModel, api) {
	    if (env.node) {
	      return;
	    }
	
	    this._tooltipContent.dispose();
	
	    globalListener.unregister('itemTooltip', api);
	  }
	});
	/**
	 * @param {Array.<Object|module:echarts/model/Model>} modelCascade
	 * From top to bottom. (the last one should be globalTooltipModel);
	 */
	
	
	function buildTooltipModel(modelCascade) {
	  var resultModel = modelCascade.pop();
	
	  while (modelCascade.length) {
	    var tooltipOpt = modelCascade.pop();
	
	    if (tooltipOpt) {
	      if (Model.isInstance(tooltipOpt)) {
	        tooltipOpt = tooltipOpt.get('tooltip', true);
	      } // In each data item tooltip can be simply write:
	      // {
	      //  value: 10,
	      //  tooltip: 'Something you need to know'
	      // }
	
	
	      if (typeof tooltipOpt === 'string') {
	        tooltipOpt = {
	          formatter: tooltipOpt
	        };
	      }
	
	      resultModel = new Model(tooltipOpt, resultModel, resultModel.ecModel);
	    }
	  }
	
	  return resultModel;
	}
	
	function makeDispatchAction(payload, api) {
	  return payload.dispatchAction || zrUtil.bind(api.dispatchAction, api);
	}
	
	function refixTooltipPosition(x, y, content, viewWidth, viewHeight, gapH, gapV) {
	  var size = content.getOuterSize();
	  var width = size.width;
	  var height = size.height;
	
	  if (gapH != null) {
	    if (x + width + gapH > viewWidth) {
	      x -= width + gapH;
	    } else {
	      x += gapH;
	    }
	  }
	
	  if (gapV != null) {
	    if (y + height + gapV > viewHeight) {
	      y -= height + gapV;
	    } else {
	      y += gapV;
	    }
	  }
	
	  return [x, y];
	}
	
	function confineTooltipPosition(x, y, content, viewWidth, viewHeight) {
	  var size = content.getOuterSize();
	  var width = size.width;
	  var height = size.height;
	  x = Math.min(x + width, viewWidth) - width;
	  y = Math.min(y + height, viewHeight) - height;
	  x = Math.max(x, 0);
	  y = Math.max(y, 0);
	  return [x, y];
	}
	
	function calcTooltipPosition(position, rect, contentSize) {
	  var domWidth = contentSize[0];
	  var domHeight = contentSize[1];
	  var gap = 5;
	  var x = 0;
	  var y = 0;
	  var rectWidth = rect.width;
	  var rectHeight = rect.height;
	
	  switch (position) {
	    case 'inside':
	      x = rect.x + rectWidth / 2 - domWidth / 2;
	      y = rect.y + rectHeight / 2 - domHeight / 2;
	      break;
	
	    case 'top':
	      x = rect.x + rectWidth / 2 - domWidth / 2;
	      y = rect.y - domHeight - gap;
	      break;
	
	    case 'bottom':
	      x = rect.x + rectWidth / 2 - domWidth / 2;
	      y = rect.y + rectHeight + gap;
	      break;
	
	    case 'left':
	      x = rect.x - domWidth - gap;
	      y = rect.y + rectHeight / 2 - domHeight / 2;
	      break;
	
	    case 'right':
	      x = rect.x + rectWidth + gap;
	      y = rect.y + rectHeight / 2 - domHeight / 2;
	  }
	
	  return [x, y];
	}
	
	function isCenterAlign(align) {
	  return align === 'center' || align === 'middle';
	}
	
	module.exports = _default;

/***/ },
/* 1646 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(735);
	
	__webpack_require__(736);

/***/ },
/* 1647 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var VisualMapModel = __webpack_require__(728);
	
	var numberUtil = __webpack_require__(20);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Constant
	var DEFAULT_BAR_BOUND = [20, 140];
	var ContinuousModel = VisualMapModel.extend({
	  type: 'visualMap.continuous',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    align: 'auto',
	    // 'auto', 'left', 'right', 'top', 'bottom'
	    calculable: false,
	    // This prop effect default component type determine,
	    // See echarts/component/visualMap/typeDefaulter.
	    range: null,
	    // selected range. In default case `range` is [min, max]
	    // and can auto change along with modification of min max,
	    // util use specifid a range.
	    realtime: true,
	    // Whether realtime update.
	    itemHeight: null,
	    // The length of the range control edge.
	    itemWidth: null,
	    // The length of the other side.
	    hoverLink: true,
	    // Enable hover highlight.
	    hoverLinkDataSize: null,
	    // The size of hovered data.
	    hoverLinkOnHandle: null // Whether trigger hoverLink when hover handle.
	    // If not specified, follow the value of `realtime`.
	
	  },
	
	  /**
	   * @override
	   */
	  optionUpdated: function (newOption, isInit) {
	    ContinuousModel.superApply(this, 'optionUpdated', arguments);
	    this.resetExtent();
	    this.resetVisual(function (mappingOption) {
	      mappingOption.mappingMethod = 'linear';
	      mappingOption.dataExtent = this.getExtent();
	    });
	
	    this._resetRange();
	  },
	
	  /**
	   * @protected
	   * @override
	   */
	  resetItemSize: function () {
	    ContinuousModel.superApply(this, 'resetItemSize', arguments);
	    var itemSize = this.itemSize;
	    this._orient === 'horizontal' && itemSize.reverse();
	    (itemSize[0] == null || isNaN(itemSize[0])) && (itemSize[0] = DEFAULT_BAR_BOUND[0]);
	    (itemSize[1] == null || isNaN(itemSize[1])) && (itemSize[1] = DEFAULT_BAR_BOUND[1]);
	  },
	
	  /**
	   * @private
	   */
	  _resetRange: function () {
	    var dataExtent = this.getExtent();
	    var range = this.option.range;
	
	    if (!range || range.auto) {
	      // `range` should always be array (so we dont use other
	      // value like 'auto') for user-friend. (consider getOption).
	      dataExtent.auto = 1;
	      this.option.range = dataExtent;
	    } else if (zrUtil.isArray(range)) {
	      if (range[0] > range[1]) {
	        range.reverse();
	      }
	
	      range[0] = Math.max(range[0], dataExtent[0]);
	      range[1] = Math.min(range[1], dataExtent[1]);
	    }
	  },
	
	  /**
	   * @protected
	   * @override
	   */
	  completeVisualOption: function () {
	    VisualMapModel.prototype.completeVisualOption.apply(this, arguments);
	    zrUtil.each(this.stateList, function (state) {
	      var symbolSize = this.option.controller[state].symbolSize;
	
	      if (symbolSize && symbolSize[0] !== symbolSize[1]) {
	        symbolSize[0] = 0; // For good looking.
	      }
	    }, this);
	  },
	
	  /**
	   * @override
	   */
	  setSelected: function (selected) {
	    this.option.range = selected.slice();
	
	    this._resetRange();
	  },
	
	  /**
	   * @public
	   */
	  getSelected: function () {
	    var dataExtent = this.getExtent();
	    var dataInterval = numberUtil.asc((this.get('range') || []).slice()); // Clamp
	
	    dataInterval[0] > dataExtent[1] && (dataInterval[0] = dataExtent[1]);
	    dataInterval[1] > dataExtent[1] && (dataInterval[1] = dataExtent[1]);
	    dataInterval[0] < dataExtent[0] && (dataInterval[0] = dataExtent[0]);
	    dataInterval[1] < dataExtent[0] && (dataInterval[1] = dataExtent[0]);
	    return dataInterval;
	  },
	
	  /**
	   * @override
	   */
	  getValueState: function (value) {
	    var range = this.option.range;
	    var dataExtent = this.getExtent(); // When range[0] === dataExtent[0], any value larger than dataExtent[0] maps to 'inRange'.
	    // range[1] is processed likewise.
	
	    return (range[0] <= dataExtent[0] || range[0] <= value) && (range[1] >= dataExtent[1] || value <= range[1]) ? 'inRange' : 'outOfRange';
	  },
	
	  /**
	   * @params {Array.<number>} range target value: range[0] <= value && value <= range[1]
	   * @return {Array.<Object>} [{seriesId, dataIndices: <Array.<number>>}, ...]
	   */
	  findTargetDataIndices: function (range) {
	    var result = [];
	    this.eachTargetSeries(function (seriesModel) {
	      var dataIndices = [];
	      var data = seriesModel.getData();
	      data.each(this.getDataDimension(data), function (value, dataIndex) {
	        range[0] <= value && value <= range[1] && dataIndices.push(dataIndex);
	      }, this);
	      result.push({
	        seriesId: seriesModel.id,
	        dataIndex: dataIndices
	      });
	    }, this);
	    return result;
	  },
	
	  /**
	   * @implement
	   */
	  getVisualMeta: function (getColorVisual) {
	    var oVals = getColorStopValues(this, 'outOfRange', this.getExtent());
	    var iVals = getColorStopValues(this, 'inRange', this.option.range.slice());
	    var stops = [];
	
	    function setStop(value, valueState) {
	      stops.push({
	        value: value,
	        color: getColorVisual(value, valueState)
	      });
	    } // Format to: outOfRange -- inRange -- outOfRange.
	
	
	    var iIdx = 0;
	    var oIdx = 0;
	    var iLen = iVals.length;
	    var oLen = oVals.length;
	
	    for (; oIdx < oLen && (!iVals.length || oVals[oIdx] <= iVals[0]); oIdx++) {
	      // If oVal[oIdx] === iVals[iIdx], oVal[oIdx] should be ignored.
	      if (oVals[oIdx] < iVals[iIdx]) {
	        setStop(oVals[oIdx], 'outOfRange');
	      }
	    }
	
	    for (var first = 1; iIdx < iLen; iIdx++, first = 0) {
	      // If range is full, value beyond min, max will be clamped.
	      // make a singularity
	      first && stops.length && setStop(iVals[iIdx], 'outOfRange');
	      setStop(iVals[iIdx], 'inRange');
	    }
	
	    for (var first = 1; oIdx < oLen; oIdx++) {
	      if (!iVals.length || iVals[iVals.length - 1] < oVals[oIdx]) {
	        // make a singularity
	        if (first) {
	          stops.length && setStop(stops[stops.length - 1].value, 'outOfRange');
	          first = 0;
	        }
	
	        setStop(oVals[oIdx], 'outOfRange');
	      }
	    }
	
	    var stopsLen = stops.length;
	    return {
	      stops: stops,
	      outerColors: [stopsLen ? stops[0].color : 'transparent', stopsLen ? stops[stopsLen - 1].color : 'transparent']
	    };
	  }
	});
	
	function getColorStopValues(visualMapModel, valueState, dataExtent) {
	  if (dataExtent[0] === dataExtent[1]) {
	    return dataExtent.slice();
	  } // When using colorHue mapping, it is not linear color any more.
	  // Moreover, canvas gradient seems not to be accurate linear.
	  // FIXME
	  // Should be arbitrary value 100? or based on pixel size?
	
	
	  var count = 200;
	  var step = (dataExtent[1] - dataExtent[0]) / count;
	  var value = dataExtent[0];
	  var stopValues = [];
	
	  for (var i = 0; i <= count && value < dataExtent[1]; i++) {
	    stopValues.push(value);
	    value += step;
	  }
	
	  stopValues.push(dataExtent[1]);
	  return stopValues;
	}
	
	var _default = ContinuousModel;
	module.exports = _default;

/***/ },
/* 1648 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var LinearGradient = __webpack_require__(557);
	
	var eventTool = __webpack_require__(113);
	
	var VisualMapView = __webpack_require__(729);
	
	var graphic = __webpack_require__(16);
	
	var numberUtil = __webpack_require__(20);
	
	var sliderMove = __webpack_require__(205);
	
	var helper = __webpack_require__(730);
	
	var modelUtil = __webpack_require__(24);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var linearMap = numberUtil.linearMap;
	var each = zrUtil.each;
	var mathMin = Math.min;
	var mathMax = Math.max; // Arbitrary value
	
	var HOVER_LINK_SIZE = 12;
	var HOVER_LINK_OUT = 6; // Notice:
	// Any "interval" should be by the order of [low, high].
	// "handle0" (handleIndex === 0) maps to
	// low data value: this._dataInterval[0] and has low coord.
	// "handle1" (handleIndex === 1) maps to
	// high data value: this._dataInterval[1] and has high coord.
	// The logic of transform is implemented in this._createBarGroup.
	
	var ContinuousView = VisualMapView.extend({
	  type: 'visualMap.continuous',
	
	  /**
	   * @override
	   */
	  init: function () {
	    ContinuousView.superApply(this, 'init', arguments);
	    /**
	     * @private
	     */
	
	    this._shapes = {};
	    /**
	     * @private
	     */
	
	    this._dataInterval = [];
	    /**
	     * @private
	     */
	
	    this._handleEnds = [];
	    /**
	     * @private
	     */
	
	    this._orient;
	    /**
	     * @private
	     */
	
	    this._useHandle;
	    /**
	     * @private
	     */
	
	    this._hoverLinkDataIndices = [];
	    /**
	     * @private
	     */
	
	    this._dragging;
	    /**
	     * @private
	     */
	
	    this._hovering;
	  },
	
	  /**
	   * @protected
	   * @override
	   */
	  doRender: function (visualMapModel, ecModel, api, payload) {
	    if (!payload || payload.type !== 'selectDataRange' || payload.from !== this.uid) {
	      this._buildView();
	    }
	  },
	
	  /**
	   * @private
	   */
	  _buildView: function () {
	    this.group.removeAll();
	    var visualMapModel = this.visualMapModel;
	    var thisGroup = this.group;
	    this._orient = visualMapModel.get('orient');
	    this._useHandle = visualMapModel.get('calculable');
	
	    this._resetInterval();
	
	    this._renderBar(thisGroup);
	
	    var dataRangeText = visualMapModel.get('text');
	
	    this._renderEndsText(thisGroup, dataRangeText, 0);
	
	    this._renderEndsText(thisGroup, dataRangeText, 1); // Do this for background size calculation.
	
	
	    this._updateView(true); // After updating view, inner shapes is built completely,
	    // and then background can be rendered.
	
	
	    this.renderBackground(thisGroup); // Real update view
	
	    this._updateView();
	
	    this._enableHoverLinkToSeries();
	
	    this._enableHoverLinkFromSeries();
	
	    this.positionGroup(thisGroup);
	  },
	
	  /**
	   * @private
	   */
	  _renderEndsText: function (group, dataRangeText, endsIndex) {
	    if (!dataRangeText) {
	      return;
	    } // Compatible with ec2, text[0] map to high value, text[1] map low value.
	
	
	    var text = dataRangeText[1 - endsIndex];
	    text = text != null ? text + '' : '';
	    var visualMapModel = this.visualMapModel;
	    var textGap = visualMapModel.get('textGap');
	    var itemSize = visualMapModel.itemSize;
	    var barGroup = this._shapes.barGroup;
	
	    var position = this._applyTransform([itemSize[0] / 2, endsIndex === 0 ? -textGap : itemSize[1] + textGap], barGroup);
	
	    var align = this._applyTransform(endsIndex === 0 ? 'bottom' : 'top', barGroup);
	
	    var orient = this._orient;
	    var textStyleModel = this.visualMapModel.textStyleModel;
	    this.group.add(new graphic.Text({
	      style: {
	        x: position[0],
	        y: position[1],
	        textVerticalAlign: orient === 'horizontal' ? 'middle' : align,
	        textAlign: orient === 'horizontal' ? align : 'center',
	        text: text,
	        textFont: textStyleModel.getFont(),
	        textFill: textStyleModel.getTextColor()
	      }
	    }));
	  },
	
	  /**
	   * @private
	   */
	  _renderBar: function (targetGroup) {
	    var visualMapModel = this.visualMapModel;
	    var shapes = this._shapes;
	    var itemSize = visualMapModel.itemSize;
	    var orient = this._orient;
	    var useHandle = this._useHandle;
	    var itemAlign = helper.getItemAlign(visualMapModel, this.api, itemSize);
	
	    var barGroup = shapes.barGroup = this._createBarGroup(itemAlign); // Bar
	
	
	    barGroup.add(shapes.outOfRange = createPolygon());
	    barGroup.add(shapes.inRange = createPolygon(null, useHandle ? getCursor(this._orient) : null, zrUtil.bind(this._dragHandle, this, 'all', false), zrUtil.bind(this._dragHandle, this, 'all', true)));
	    var textRect = visualMapModel.textStyleModel.getTextRect('国');
	    var textSize = mathMax(textRect.width, textRect.height); // Handle
	
	    if (useHandle) {
	      shapes.handleThumbs = [];
	      shapes.handleLabels = [];
	      shapes.handleLabelPoints = [];
	
	      this._createHandle(barGroup, 0, itemSize, textSize, orient, itemAlign);
	
	      this._createHandle(barGroup, 1, itemSize, textSize, orient, itemAlign);
	    }
	
	    this._createIndicator(barGroup, itemSize, textSize, orient);
	
	    targetGroup.add(barGroup);
	  },
	
	  /**
	   * @private
	   */
	  _createHandle: function (barGroup, handleIndex, itemSize, textSize, orient) {
	    var onDrift = zrUtil.bind(this._dragHandle, this, handleIndex, false);
	    var onDragEnd = zrUtil.bind(this._dragHandle, this, handleIndex, true);
	    var handleThumb = createPolygon(createHandlePoints(handleIndex, textSize), getCursor(this._orient), onDrift, onDragEnd);
	    handleThumb.position[0] = itemSize[0];
	    barGroup.add(handleThumb); // Text is always horizontal layout but should not be effected by
	    // transform (orient/inverse). So label is built separately but not
	    // use zrender/graphic/helper/RectText, and is located based on view
	    // group (according to handleLabelPoint) but not barGroup.
	
	    var textStyleModel = this.visualMapModel.textStyleModel;
	    var handleLabel = new graphic.Text({
	      draggable: true,
	      drift: onDrift,
	      onmousemove: function (e) {
	        // Fot mobile devicem, prevent screen slider on the button.
	        eventTool.stop(e.event);
	      },
	      ondragend: onDragEnd,
	      style: {
	        x: 0,
	        y: 0,
	        text: '',
	        textFont: textStyleModel.getFont(),
	        textFill: textStyleModel.getTextColor()
	      }
	    });
	    this.group.add(handleLabel);
	    var handleLabelPoint = [orient === 'horizontal' ? textSize / 2 : textSize * 1.5, orient === 'horizontal' ? handleIndex === 0 ? -(textSize * 1.5) : textSize * 1.5 : handleIndex === 0 ? -textSize / 2 : textSize / 2];
	    var shapes = this._shapes;
	    shapes.handleThumbs[handleIndex] = handleThumb;
	    shapes.handleLabelPoints[handleIndex] = handleLabelPoint;
	    shapes.handleLabels[handleIndex] = handleLabel;
	  },
	
	  /**
	   * @private
	   */
	  _createIndicator: function (barGroup, itemSize, textSize, orient) {
	    var indicator = createPolygon([[0, 0]], 'move');
	    indicator.position[0] = itemSize[0];
	    indicator.attr({
	      invisible: true,
	      silent: true
	    });
	    barGroup.add(indicator);
	    var textStyleModel = this.visualMapModel.textStyleModel;
	    var indicatorLabel = new graphic.Text({
	      silent: true,
	      invisible: true,
	      style: {
	        x: 0,
	        y: 0,
	        text: '',
	        textFont: textStyleModel.getFont(),
	        textFill: textStyleModel.getTextColor()
	      }
	    });
	    this.group.add(indicatorLabel);
	    var indicatorLabelPoint = [orient === 'horizontal' ? textSize / 2 : HOVER_LINK_OUT + 3, 0];
	    var shapes = this._shapes;
	    shapes.indicator = indicator;
	    shapes.indicatorLabel = indicatorLabel;
	    shapes.indicatorLabelPoint = indicatorLabelPoint;
	  },
	
	  /**
	   * @private
	   */
	  _dragHandle: function (handleIndex, isEnd, dx, dy) {
	    if (!this._useHandle) {
	      return;
	    }
	
	    this._dragging = !isEnd;
	
	    if (!isEnd) {
	      // Transform dx, dy to bar coordination.
	      var vertex = this._applyTransform([dx, dy], this._shapes.barGroup, true);
	
	      this._updateInterval(handleIndex, vertex[1]); // Considering realtime, update view should be executed
	      // before dispatch action.
	
	
	      this._updateView();
	    } // dragEnd do not dispatch action when realtime.
	
	
	    if (isEnd === !this.visualMapModel.get('realtime')) {
	      // jshint ignore:line
	      this.api.dispatchAction({
	        type: 'selectDataRange',
	        from: this.uid,
	        visualMapId: this.visualMapModel.id,
	        selected: this._dataInterval.slice()
	      });
	    }
	
	    if (isEnd) {
	      !this._hovering && this._clearHoverLinkToSeries();
	    } else if (useHoverLinkOnHandle(this.visualMapModel)) {
	      this._doHoverLinkToSeries(this._handleEnds[handleIndex], false);
	    }
	  },
	
	  /**
	   * @private
	   */
	  _resetInterval: function () {
	    var visualMapModel = this.visualMapModel;
	    var dataInterval = this._dataInterval = visualMapModel.getSelected();
	    var dataExtent = visualMapModel.getExtent();
	    var sizeExtent = [0, visualMapModel.itemSize[1]];
	    this._handleEnds = [linearMap(dataInterval[0], dataExtent, sizeExtent, true), linearMap(dataInterval[1], dataExtent, sizeExtent, true)];
	  },
	
	  /**
	   * @private
	   * @param {(number|string)} handleIndex 0 or 1 or 'all'
	   * @param {number} dx
	   * @param {number} dy
	   */
	  _updateInterval: function (handleIndex, delta) {
	    delta = delta || 0;
	    var visualMapModel = this.visualMapModel;
	    var handleEnds = this._handleEnds;
	    var sizeExtent = [0, visualMapModel.itemSize[1]];
	    sliderMove(delta, handleEnds, sizeExtent, handleIndex, // cross is forbiden
	    0);
	    var dataExtent = visualMapModel.getExtent(); // Update data interval.
	
	    this._dataInterval = [linearMap(handleEnds[0], sizeExtent, dataExtent, true), linearMap(handleEnds[1], sizeExtent, dataExtent, true)];
	  },
	
	  /**
	   * @private
	   */
	  _updateView: function (forSketch) {
	    var visualMapModel = this.visualMapModel;
	    var dataExtent = visualMapModel.getExtent();
	    var shapes = this._shapes;
	    var outOfRangeHandleEnds = [0, visualMapModel.itemSize[1]];
	    var inRangeHandleEnds = forSketch ? outOfRangeHandleEnds : this._handleEnds;
	
	    var visualInRange = this._createBarVisual(this._dataInterval, dataExtent, inRangeHandleEnds, 'inRange');
	
	    var visualOutOfRange = this._createBarVisual(dataExtent, dataExtent, outOfRangeHandleEnds, 'outOfRange');
	
	    shapes.inRange.setStyle({
	      fill: visualInRange.barColor,
	      opacity: visualInRange.opacity
	    }).setShape('points', visualInRange.barPoints);
	    shapes.outOfRange.setStyle({
	      fill: visualOutOfRange.barColor,
	      opacity: visualOutOfRange.opacity
	    }).setShape('points', visualOutOfRange.barPoints);
	
	    this._updateHandle(inRangeHandleEnds, visualInRange);
	  },
	
	  /**
	   * @private
	   */
	  _createBarVisual: function (dataInterval, dataExtent, handleEnds, forceState) {
	    var opts = {
	      forceState: forceState,
	      convertOpacityToAlpha: true
	    };
	
	    var colorStops = this._makeColorGradient(dataInterval, opts);
	
	    var symbolSizes = [this.getControllerVisual(dataInterval[0], 'symbolSize', opts), this.getControllerVisual(dataInterval[1], 'symbolSize', opts)];
	
	    var barPoints = this._createBarPoints(handleEnds, symbolSizes);
	
	    return {
	      barColor: new LinearGradient(0, 0, 0, 1, colorStops),
	      barPoints: barPoints,
	      handlesColor: [colorStops[0].color, colorStops[colorStops.length - 1].color]
	    };
	  },
	
	  /**
	   * @private
	   */
	  _makeColorGradient: function (dataInterval, opts) {
	    // Considering colorHue, which is not linear, so we have to sample
	    // to calculate gradient color stops, but not only caculate head
	    // and tail.
	    var sampleNumber = 100; // Arbitrary value.
	
	    var colorStops = [];
	    var step = (dataInterval[1] - dataInterval[0]) / sampleNumber;
	    colorStops.push({
	      color: this.getControllerVisual(dataInterval[0], 'color', opts),
	      offset: 0
	    });
	
	    for (var i = 1; i < sampleNumber; i++) {
	      var currValue = dataInterval[0] + step * i;
	
	      if (currValue > dataInterval[1]) {
	        break;
	      }
	
	      colorStops.push({
	        color: this.getControllerVisual(currValue, 'color', opts),
	        offset: i / sampleNumber
	      });
	    }
	
	    colorStops.push({
	      color: this.getControllerVisual(dataInterval[1], 'color', opts),
	      offset: 1
	    });
	    return colorStops;
	  },
	
	  /**
	   * @private
	   */
	  _createBarPoints: function (handleEnds, symbolSizes) {
	    var itemSize = this.visualMapModel.itemSize;
	    return [[itemSize[0] - symbolSizes[0], handleEnds[0]], [itemSize[0], handleEnds[0]], [itemSize[0], handleEnds[1]], [itemSize[0] - symbolSizes[1], handleEnds[1]]];
	  },
	
	  /**
	   * @private
	   */
	  _createBarGroup: function (itemAlign) {
	    var orient = this._orient;
	    var inverse = this.visualMapModel.get('inverse');
	    return new graphic.Group(orient === 'horizontal' && !inverse ? {
	      scale: itemAlign === 'bottom' ? [1, 1] : [-1, 1],
	      rotation: Math.PI / 2
	    } : orient === 'horizontal' && inverse ? {
	      scale: itemAlign === 'bottom' ? [-1, 1] : [1, 1],
	      rotation: -Math.PI / 2
	    } : orient === 'vertical' && !inverse ? {
	      scale: itemAlign === 'left' ? [1, -1] : [-1, -1]
	    } : {
	      scale: itemAlign === 'left' ? [1, 1] : [-1, 1]
	    });
	  },
	
	  /**
	   * @private
	   */
	  _updateHandle: function (handleEnds, visualInRange) {
	    if (!this._useHandle) {
	      return;
	    }
	
	    var shapes = this._shapes;
	    var visualMapModel = this.visualMapModel;
	    var handleThumbs = shapes.handleThumbs;
	    var handleLabels = shapes.handleLabels;
	    each([0, 1], function (handleIndex) {
	      var handleThumb = handleThumbs[handleIndex];
	      handleThumb.setStyle('fill', visualInRange.handlesColor[handleIndex]);
	      handleThumb.position[1] = handleEnds[handleIndex]; // Update handle label position.
	
	      var textPoint = graphic.applyTransform(shapes.handleLabelPoints[handleIndex], graphic.getTransform(handleThumb, this.group));
	      handleLabels[handleIndex].setStyle({
	        x: textPoint[0],
	        y: textPoint[1],
	        text: visualMapModel.formatValueText(this._dataInterval[handleIndex]),
	        textVerticalAlign: 'middle',
	        textAlign: this._applyTransform(this._orient === 'horizontal' ? handleIndex === 0 ? 'bottom' : 'top' : 'left', shapes.barGroup)
	      });
	    }, this);
	  },
	
	  /**
	   * @private
	   * @param {number} cursorValue
	   * @param {number} textValue
	   * @param {string} [rangeSymbol]
	   * @param {number} [halfHoverLinkSize]
	   */
	  _showIndicator: function (cursorValue, textValue, rangeSymbol, halfHoverLinkSize) {
	    var visualMapModel = this.visualMapModel;
	    var dataExtent = visualMapModel.getExtent();
	    var itemSize = visualMapModel.itemSize;
	    var sizeExtent = [0, itemSize[1]];
	    var pos = linearMap(cursorValue, dataExtent, sizeExtent, true);
	    var shapes = this._shapes;
	    var indicator = shapes.indicator;
	
	    if (!indicator) {
	      return;
	    }
	
	    indicator.position[1] = pos;
	    indicator.attr('invisible', false);
	    indicator.setShape('points', createIndicatorPoints(!!rangeSymbol, halfHoverLinkSize, pos, itemSize[1]));
	    var opts = {
	      convertOpacityToAlpha: true
	    };
	    var color = this.getControllerVisual(cursorValue, 'color', opts);
	    indicator.setStyle('fill', color); // Update handle label position.
	
	    var textPoint = graphic.applyTransform(shapes.indicatorLabelPoint, graphic.getTransform(indicator, this.group));
	    var indicatorLabel = shapes.indicatorLabel;
	    indicatorLabel.attr('invisible', false);
	
	    var align = this._applyTransform('left', shapes.barGroup);
	
	    var orient = this._orient;
	    indicatorLabel.setStyle({
	      text: (rangeSymbol ? rangeSymbol : '') + visualMapModel.formatValueText(textValue),
	      textVerticalAlign: orient === 'horizontal' ? align : 'middle',
	      textAlign: orient === 'horizontal' ? 'center' : align,
	      x: textPoint[0],
	      y: textPoint[1]
	    });
	  },
	
	  /**
	   * @private
	   */
	  _enableHoverLinkToSeries: function () {
	    var self = this;
	
	    this._shapes.barGroup.on('mousemove', function (e) {
	      self._hovering = true;
	
	      if (!self._dragging) {
	        var itemSize = self.visualMapModel.itemSize;
	
	        var pos = self._applyTransform([e.offsetX, e.offsetY], self._shapes.barGroup, true, true); // For hover link show when hover handle, which might be
	        // below or upper than sizeExtent.
	
	
	        pos[1] = mathMin(mathMax(0, pos[1]), itemSize[1]);
	
	        self._doHoverLinkToSeries(pos[1], 0 <= pos[0] && pos[0] <= itemSize[0]);
	      }
	    }).on('mouseout', function () {
	      // When mouse is out of handle, hoverLink still need
	      // to be displayed when realtime is set as false.
	      self._hovering = false;
	      !self._dragging && self._clearHoverLinkToSeries();
	    });
	  },
	
	  /**
	   * @private
	   */
	  _enableHoverLinkFromSeries: function () {
	    var zr = this.api.getZr();
	
	    if (this.visualMapModel.option.hoverLink) {
	      zr.on('mouseover', this._hoverLinkFromSeriesMouseOver, this);
	      zr.on('mouseout', this._hideIndicator, this);
	    } else {
	      this._clearHoverLinkFromSeries();
	    }
	  },
	
	  /**
	   * @private
	   */
	  _doHoverLinkToSeries: function (cursorPos, hoverOnBar) {
	    var visualMapModel = this.visualMapModel;
	    var itemSize = visualMapModel.itemSize;
	
	    if (!visualMapModel.option.hoverLink) {
	      return;
	    }
	
	    var sizeExtent = [0, itemSize[1]];
	    var dataExtent = visualMapModel.getExtent(); // For hover link show when hover handle, which might be below or upper than sizeExtent.
	
	    cursorPos = mathMin(mathMax(sizeExtent[0], cursorPos), sizeExtent[1]);
	    var halfHoverLinkSize = getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent);
	    var hoverRange = [cursorPos - halfHoverLinkSize, cursorPos + halfHoverLinkSize];
	    var cursorValue = linearMap(cursorPos, sizeExtent, dataExtent, true);
	    var valueRange = [linearMap(hoverRange[0], sizeExtent, dataExtent, true), linearMap(hoverRange[1], sizeExtent, dataExtent, true)]; // Consider data range is out of visualMap range, see test/visualMap-continuous.html,
	    // where china and india has very large population.
	
	    hoverRange[0] < sizeExtent[0] && (valueRange[0] = -Infinity);
	    hoverRange[1] > sizeExtent[1] && (valueRange[1] = Infinity); // Do not show indicator when mouse is over handle,
	    // otherwise labels overlap, especially when dragging.
	
	    if (hoverOnBar) {
	      if (valueRange[0] === -Infinity) {
	        this._showIndicator(cursorValue, valueRange[1], '< ', halfHoverLinkSize);
	      } else if (valueRange[1] === Infinity) {
	        this._showIndicator(cursorValue, valueRange[0], '> ', halfHoverLinkSize);
	      } else {
	        this._showIndicator(cursorValue, cursorValue, '≈ ', halfHoverLinkSize);
	      }
	    } // When realtime is set as false, handles, which are in barGroup,
	    // also trigger hoverLink, which help user to realize where they
	    // focus on when dragging. (see test/heatmap-large.html)
	    // When realtime is set as true, highlight will not show when hover
	    // handle, because the label on handle, which displays a exact value
	    // but not range, might mislead users.
	
	
	    var oldBatch = this._hoverLinkDataIndices;
	    var newBatch = [];
	
	    if (hoverOnBar || useHoverLinkOnHandle(visualMapModel)) {
	      newBatch = this._hoverLinkDataIndices = visualMapModel.findTargetDataIndices(valueRange);
	    }
	
	    var resultBatches = modelUtil.compressBatches(oldBatch, newBatch);
	
	    this._dispatchHighDown('downplay', helper.makeHighDownBatch(resultBatches[0], visualMapModel));
	
	    this._dispatchHighDown('highlight', helper.makeHighDownBatch(resultBatches[1], visualMapModel));
	  },
	
	  /**
	   * @private
	   */
	  _hoverLinkFromSeriesMouseOver: function (e) {
	    var el = e.target;
	    var visualMapModel = this.visualMapModel;
	
	    if (!el || el.dataIndex == null) {
	      return;
	    }
	
	    var dataModel = this.ecModel.getSeriesByIndex(el.seriesIndex);
	
	    if (!visualMapModel.isTargetSeries(dataModel)) {
	      return;
	    }
	
	    var data = dataModel.getData(el.dataType);
	    var value = data.get(visualMapModel.getDataDimension(data), el.dataIndex, true);
	
	    if (!isNaN(value)) {
	      this._showIndicator(value, value);
	    }
	  },
	
	  /**
	   * @private
	   */
	  _hideIndicator: function () {
	    var shapes = this._shapes;
	    shapes.indicator && shapes.indicator.attr('invisible', true);
	    shapes.indicatorLabel && shapes.indicatorLabel.attr('invisible', true);
	  },
	
	  /**
	   * @private
	   */
	  _clearHoverLinkToSeries: function () {
	    this._hideIndicator();
	
	    var indices = this._hoverLinkDataIndices;
	
	    this._dispatchHighDown('downplay', helper.makeHighDownBatch(indices, this.visualMapModel));
	
	    indices.length = 0;
	  },
	
	  /**
	   * @private
	   */
	  _clearHoverLinkFromSeries: function () {
	    this._hideIndicator();
	
	    var zr = this.api.getZr();
	    zr.off('mouseover', this._hoverLinkFromSeriesMouseOver);
	    zr.off('mouseout', this._hideIndicator);
	  },
	
	  /**
	   * @private
	   */
	  _applyTransform: function (vertex, element, inverse, global) {
	    var transform = graphic.getTransform(element, global ? null : this.group);
	    return graphic[zrUtil.isArray(vertex) ? 'applyTransform' : 'transformDirection'](vertex, transform, inverse);
	  },
	
	  /**
	   * @private
	   */
	  _dispatchHighDown: function (type, batch) {
	    batch && batch.length && this.api.dispatchAction({
	      type: type,
	      batch: batch
	    });
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    this._clearHoverLinkFromSeries();
	
	    this._clearHoverLinkToSeries();
	  },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    this._clearHoverLinkFromSeries();
	
	    this._clearHoverLinkToSeries();
	  }
	});
	
	function createPolygon(points, cursor, onDrift, onDragEnd) {
	  return new graphic.Polygon({
	    shape: {
	      points: points
	    },
	    draggable: !!onDrift,
	    cursor: cursor,
	    drift: onDrift,
	    onmousemove: function (e) {
	      // Fot mobile devicem, prevent screen slider on the button.
	      eventTool.stop(e.event);
	    },
	    ondragend: onDragEnd
	  });
	}
	
	function createHandlePoints(handleIndex, textSize) {
	  return handleIndex === 0 ? [[0, 0], [textSize, 0], [textSize, -textSize]] : [[0, 0], [textSize, 0], [textSize, textSize]];
	}
	
	function createIndicatorPoints(isRange, halfHoverLinkSize, pos, extentMax) {
	  return isRange ? [// indicate range
	  [0, -mathMin(halfHoverLinkSize, mathMax(pos, 0))], [HOVER_LINK_OUT, 0], [0, mathMin(halfHoverLinkSize, mathMax(extentMax - pos, 0))]] : [// indicate single value
	  [0, 0], [5, -5], [5, 5]];
	}
	
	function getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent) {
	  var halfHoverLinkSize = HOVER_LINK_SIZE / 2;
	  var hoverLinkDataSize = visualMapModel.get('hoverLinkDataSize');
	
	  if (hoverLinkDataSize) {
	    halfHoverLinkSize = linearMap(hoverLinkDataSize, dataExtent, sizeExtent, true) / 2;
	  }
	
	  return halfHoverLinkSize;
	}
	
	function useHoverLinkOnHandle(visualMapModel) {
	  var hoverLinkOnHandle = visualMapModel.get('hoverLinkOnHandle');
	  return !!(hoverLinkOnHandle == null ? visualMapModel.get('realtime') : hoverLinkOnHandle);
	}
	
	function getCursor(orient) {
	  return orient === 'vertical' ? 'ns-resize' : 'ew-resize';
	}
	
	var _default = ContinuousView;
	module.exports = _default;

/***/ },
/* 1649 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(3);
	
	var VisualMapModel = __webpack_require__(728);
	
	var VisualMapping = __webpack_require__(168);
	
	var visualDefault = __webpack_require__(753);
	
	var _number = __webpack_require__(20);
	
	var reformIntervals = _number.reformIntervals;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PiecewiseModel = VisualMapModel.extend({
	  type: 'visualMap.piecewise',
	
	  /**
	   * Order Rule:
	   *
	   * option.categories / option.pieces / option.text / option.selected:
	   *     If !option.inverse,
	   *     Order when vertical: ['top', ..., 'bottom'].
	   *     Order when horizontal: ['left', ..., 'right'].
	   *     If option.inverse, the meaning of
	   *     the order should be reversed.
	   *
	   * this._pieceList:
	   *     The order is always [low, ..., high].
	   *
	   * Mapping from location to low-high:
	   *     If !option.inverse
	   *     When vertical, top is high.
	   *     When horizontal, right is high.
	   *     If option.inverse, reverse.
	   */
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    selected: null,
	    // Object. If not specified, means selected.
	    // When pieces and splitNumber: {'0': true, '5': true}
	    // When categories: {'cate1': false, 'cate3': true}
	    // When selected === false, means all unselected.
	    minOpen: false,
	    // Whether include values that smaller than `min`.
	    maxOpen: false,
	    // Whether include values that bigger than `max`.
	    align: 'auto',
	    // 'auto', 'left', 'right'
	    itemWidth: 20,
	    // When put the controller vertically, it is the length of
	    // horizontal side of each item. Otherwise, vertical side.
	    itemHeight: 14,
	    // When put the controller vertically, it is the length of
	    // vertical side of each item. Otherwise, horizontal side.
	    itemSymbol: 'roundRect',
	    pieceList: null,
	    // Each item is Object, with some of those attrs:
	    // {min, max, lt, gt, lte, gte, value,
	    // color, colorSaturation, colorAlpha, opacity,
	    // symbol, symbolSize}, which customize the range or visual
	    // coding of the certain piece. Besides, see "Order Rule".
	    categories: null,
	    // category names, like: ['some1', 'some2', 'some3'].
	    // Attr min/max are ignored when categories set. See "Order Rule"
	    splitNumber: 5,
	    // If set to 5, auto split five pieces equally.
	    // If set to 0 and component type not set, component type will be
	    // determined as "continuous". (It is less reasonable but for ec2
	    // compatibility, see echarts/component/visualMap/typeDefaulter)
	    selectedMode: 'multiple',
	    // Can be 'multiple' or 'single'.
	    itemGap: 10,
	    // The gap between two items, in px.
	    hoverLink: true,
	    // Enable hover highlight.
	    showLabel: null // By default, when text is used, label will hide (the logic
	    // is remained for compatibility reason)
	
	  },
	
	  /**
	   * @override
	   */
	  optionUpdated: function (newOption, isInit) {
	    PiecewiseModel.superApply(this, 'optionUpdated', arguments);
	    /**
	     * The order is always [low, ..., high].
	     * [{text: string, interval: Array.<number>}, ...]
	     * @private
	     * @type {Array.<Object>}
	     */
	
	    this._pieceList = [];
	    this.resetExtent();
	    /**
	     * 'pieces', 'categories', 'splitNumber'
	     * @type {string}
	     */
	
	    var mode = this._mode = this._determineMode();
	
	    resetMethods[this._mode].call(this);
	
	    this._resetSelected(newOption, isInit);
	
	    var categories = this.option.categories;
	    this.resetVisual(function (mappingOption, state) {
	      if (mode === 'categories') {
	        mappingOption.mappingMethod = 'category';
	        mappingOption.categories = zrUtil.clone(categories);
	      } else {
	        mappingOption.dataExtent = this.getExtent();
	        mappingOption.mappingMethod = 'piecewise';
	        mappingOption.pieceList = zrUtil.map(this._pieceList, function (piece) {
	          var piece = zrUtil.clone(piece);
	
	          if (state !== 'inRange') {
	            // FIXME
	            // outOfRange do not support special visual in pieces.
	            piece.visual = null;
	          }
	
	          return piece;
	        });
	      }
	    });
	  },
	
	  /**
	   * @protected
	   * @override
	   */
	  completeVisualOption: function () {
	    // Consider this case:
	    // visualMap: {
	    //      pieces: [{symbol: 'circle', lt: 0}, {symbol: 'rect', gte: 0}]
	    // }
	    // where no inRange/outOfRange set but only pieces. So we should make
	    // default inRange/outOfRange for this case, otherwise visuals that only
	    // appear in `pieces` will not be taken into account in visual encoding.
	    var option = this.option;
	    var visualTypesInPieces = {};
	    var visualTypes = VisualMapping.listVisualTypes();
	    var isCategory = this.isCategory();
	    zrUtil.each(option.pieces, function (piece) {
	      zrUtil.each(visualTypes, function (visualType) {
	        if (piece.hasOwnProperty(visualType)) {
	          visualTypesInPieces[visualType] = 1;
	        }
	      });
	    });
	    zrUtil.each(visualTypesInPieces, function (v, visualType) {
	      var exists = 0;
	      zrUtil.each(this.stateList, function (state) {
	        exists |= has(option, state, visualType) || has(option.target, state, visualType);
	      }, this);
	      !exists && zrUtil.each(this.stateList, function (state) {
	        (option[state] || (option[state] = {}))[visualType] = visualDefault.get(visualType, state === 'inRange' ? 'active' : 'inactive', isCategory);
	      });
	    }, this);
	
	    function has(obj, state, visualType) {
	      return obj && obj[state] && (zrUtil.isObject(obj[state]) ? obj[state].hasOwnProperty(visualType) : obj[state] === visualType // e.g., inRange: 'symbol'
	      );
	    }
	
	    VisualMapModel.prototype.completeVisualOption.apply(this, arguments);
	  },
	  _resetSelected: function (newOption, isInit) {
	    var thisOption = this.option;
	    var pieceList = this._pieceList; // Selected do not merge but all override.
	
	    var selected = (isInit ? thisOption : newOption).selected || {};
	    thisOption.selected = selected; // Consider 'not specified' means true.
	
	    zrUtil.each(pieceList, function (piece, index) {
	      var key = this.getSelectedMapKey(piece);
	
	      if (!selected.hasOwnProperty(key)) {
	        selected[key] = true;
	      }
	    }, this);
	
	    if (thisOption.selectedMode === 'single') {
	      // Ensure there is only one selected.
	      var hasSel = false;
	      zrUtil.each(pieceList, function (piece, index) {
	        var key = this.getSelectedMapKey(piece);
	
	        if (selected[key]) {
	          hasSel ? selected[key] = false : hasSel = true;
	        }
	      }, this);
	    } // thisOption.selectedMode === 'multiple', default: all selected.
	
	  },
	
	  /**
	   * @public
	   */
	  getSelectedMapKey: function (piece) {
	    return this._mode === 'categories' ? piece.value + '' : piece.index + '';
	  },
	
	  /**
	   * @public
	   */
	  getPieceList: function () {
	    return this._pieceList;
	  },
	
	  /**
	   * @private
	   * @return {string}
	   */
	  _determineMode: function () {
	    var option = this.option;
	    return option.pieces && option.pieces.length > 0 ? 'pieces' : this.option.categories ? 'categories' : 'splitNumber';
	  },
	
	  /**
	   * @public
	   * @override
	   */
	  setSelected: function (selected) {
	    this.option.selected = zrUtil.clone(selected);
	  },
	
	  /**
	   * @public
	   * @override
	   */
	  getValueState: function (value) {
	    var index = VisualMapping.findPieceIndex(value, this._pieceList);
	    return index != null ? this.option.selected[this.getSelectedMapKey(this._pieceList[index])] ? 'inRange' : 'outOfRange' : 'outOfRange';
	  },
	
	  /**
	   * @public
	   * @params {number} pieceIndex piece index in visualMapModel.getPieceList()
	   * @return {Array.<Object>} [{seriesId, dataIndex: <Array.<number>>}, ...]
	   */
	  findTargetDataIndices: function (pieceIndex) {
	    var result = [];
	    this.eachTargetSeries(function (seriesModel) {
	      var dataIndices = [];
	      var data = seriesModel.getData();
	      data.each(this.getDataDimension(data), function (value, dataIndex) {
	        // Should always base on model pieceList, because it is order sensitive.
	        var pIdx = VisualMapping.findPieceIndex(value, this._pieceList);
	        pIdx === pieceIndex && dataIndices.push(dataIndex);
	      }, this);
	      result.push({
	        seriesId: seriesModel.id,
	        dataIndex: dataIndices
	      });
	    }, this);
	    return result;
	  },
	
	  /**
	   * @private
	   * @param {Object} piece piece.value or piece.interval is required.
	   * @return {number} Can be Infinity or -Infinity
	   */
	  getRepresentValue: function (piece) {
	    var representValue;
	
	    if (this.isCategory()) {
	      representValue = piece.value;
	    } else {
	      if (piece.value != null) {
	        representValue = piece.value;
	      } else {
	        var pieceInterval = piece.interval || [];
	        representValue = pieceInterval[0] === -Infinity && pieceInterval[1] === Infinity ? 0 : (pieceInterval[0] + pieceInterval[1]) / 2;
	      }
	    }
	
	    return representValue;
	  },
	  getVisualMeta: function (getColorVisual) {
	    // Do not support category. (category axis is ordinal, numerical)
	    if (this.isCategory()) {
	      return;
	    }
	
	    var stops = [];
	    var outerColors = [];
	    var visualMapModel = this;
	
	    function setStop(interval, valueState) {
	      var representValue = visualMapModel.getRepresentValue({
	        interval: interval
	      });
	
	      if (!valueState) {
	        valueState = visualMapModel.getValueState(representValue);
	      }
	
	      var color = getColorVisual(representValue, valueState);
	
	      if (interval[0] === -Infinity) {
	        outerColors[0] = color;
	      } else if (interval[1] === Infinity) {
	        outerColors[1] = color;
	      } else {
	        stops.push({
	          value: interval[0],
	          color: color
	        }, {
	          value: interval[1],
	          color: color
	        });
	      }
	    } // Suplement
	
	
	    var pieceList = this._pieceList.slice();
	
	    if (!pieceList.length) {
	      pieceList.push({
	        interval: [-Infinity, Infinity]
	      });
	    } else {
	      var edge = pieceList[0].interval[0];
	      edge !== -Infinity && pieceList.unshift({
	        interval: [-Infinity, edge]
	      });
	      edge = pieceList[pieceList.length - 1].interval[1];
	      edge !== Infinity && pieceList.push({
	        interval: [edge, Infinity]
	      });
	    }
	
	    var curr = -Infinity;
	    zrUtil.each(pieceList, function (piece) {
	      var interval = piece.interval;
	
	      if (interval) {
	        // Fulfill gap.
	        interval[0] > curr && setStop([curr, interval[0]], 'outOfRange');
	        setStop(interval.slice());
	        curr = interval[1];
	      }
	    }, this);
	    return {
	      stops: stops,
	      outerColors: outerColors
	    };
	  }
	});
	/**
	 * Key is this._mode
	 * @type {Object}
	 * @this {module:echarts/component/viusalMap/PiecewiseMode}
	 */
	
	var resetMethods = {
	  splitNumber: function () {
	    var thisOption = this.option;
	    var pieceList = this._pieceList;
	    var precision = Math.min(thisOption.precision, 20);
	    var dataExtent = this.getExtent();
	    var splitNumber = thisOption.splitNumber;
	    splitNumber = Math.max(parseInt(splitNumber, 10), 1);
	    thisOption.splitNumber = splitNumber;
	    var splitStep = (dataExtent[1] - dataExtent[0]) / splitNumber; // Precision auto-adaption
	
	    while (+splitStep.toFixed(precision) !== splitStep && precision < 5) {
	      precision++;
	    }
	
	    thisOption.precision = precision;
	    splitStep = +splitStep.toFixed(precision);
	
	    if (thisOption.minOpen) {
	      pieceList.push({
	        interval: [-Infinity, dataExtent[0]],
	        close: [0, 0]
	      });
	    }
	
	    for (var index = 0, curr = dataExtent[0]; index < splitNumber; curr += splitStep, index++) {
	      var max = index === splitNumber - 1 ? dataExtent[1] : curr + splitStep;
	      pieceList.push({
	        interval: [curr, max],
	        close: [1, 1]
	      });
	    }
	
	    if (thisOption.maxOpen) {
	      pieceList.push({
	        interval: [dataExtent[1], Infinity],
	        close: [0, 0]
	      });
	    }
	
	    reformIntervals(pieceList);
	    zrUtil.each(pieceList, function (piece, index) {
	      piece.index = index;
	      piece.text = this.formatValueText(piece.interval);
	    }, this);
	  },
	  categories: function () {
	    var thisOption = this.option;
	    zrUtil.each(thisOption.categories, function (cate) {
	      // FIXME category模式也使用pieceList，但在visualMapping中不是使用pieceList。
	      // 是否改一致。
	      this._pieceList.push({
	        text: this.formatValueText(cate, true),
	        value: cate
	      });
	    }, this); // See "Order Rule".
	
	    normalizeReverse(thisOption, this._pieceList);
	  },
	  pieces: function () {
	    var thisOption = this.option;
	    var pieceList = this._pieceList;
	    zrUtil.each(thisOption.pieces, function (pieceListItem, index) {
	      if (!zrUtil.isObject(pieceListItem)) {
	        pieceListItem = {
	          value: pieceListItem
	        };
	      }
	
	      var item = {
	        text: '',
	        index: index
	      };
	
	      if (pieceListItem.label != null) {
	        item.text = pieceListItem.label;
	      }
	
	      if (pieceListItem.hasOwnProperty('value')) {
	        var value = item.value = pieceListItem.value;
	        item.interval = [value, value];
	        item.close = [1, 1];
	      } else {
	        // `min` `max` is legacy option.
	        // `lt` `gt` `lte` `gte` is recommanded.
	        var interval = item.interval = [];
	        var close = item.close = [0, 0];
	        var closeList = [1, 0, 1];
	        var infinityList = [-Infinity, Infinity];
	        var useMinMax = [];
	
	        for (var lg = 0; lg < 2; lg++) {
	          var names = [['gte', 'gt', 'min'], ['lte', 'lt', 'max']][lg];
	
	          for (var i = 0; i < 3 && interval[lg] == null; i++) {
	            interval[lg] = pieceListItem[names[i]];
	            close[lg] = closeList[i];
	            useMinMax[lg] = i === 2;
	          }
	
	          interval[lg] == null && (interval[lg] = infinityList[lg]);
	        }
	
	        useMinMax[0] && interval[1] === Infinity && (close[0] = 0);
	        useMinMax[1] && interval[0] === -Infinity && (close[1] = 0);
	
	        if (interval[0] === interval[1] && close[0] && close[1]) {
	          // Consider: [{min: 5, max: 5, visual: {...}}, {min: 0, max: 5}],
	          // we use value to lift the priority when min === max
	          item.value = interval[0];
	        }
	      }
	
	      item.visual = VisualMapping.retrieveVisuals(pieceListItem);
	      pieceList.push(item);
	    }, this); // See "Order Rule".
	
	    normalizeReverse(thisOption, pieceList); // Only pieces
	
	    reformIntervals(pieceList);
	    zrUtil.each(pieceList, function (piece) {
	      var close = piece.close;
	      var edgeSymbols = [['<', '≤'][close[1]], ['>', '≥'][close[0]]];
	      piece.text = piece.text || this.formatValueText(piece.value != null ? piece.value : piece.interval, false, edgeSymbols);
	    }, this);
	  }
	};
	
	function normalizeReverse(thisOption, pieceList) {
	  var inverse = thisOption.inverse;
	
	  if (thisOption.orient === 'vertical' ? !inverse : inverse) {
	    pieceList.reverse();
	  }
	}
	
	var _default = PiecewiseModel;
	module.exports = _default;

/***/ },
/* 1650 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var VisualMapView = __webpack_require__(729);
	
	var graphic = __webpack_require__(16);
	
	var _symbol = __webpack_require__(84);
	
	var createSymbol = _symbol.createSymbol;
	
	var layout = __webpack_require__(36);
	
	var helper = __webpack_require__(730);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PiecewiseVisualMapView = VisualMapView.extend({
	  type: 'visualMap.piecewise',
	
	  /**
	   * @protected
	   * @override
	   */
	  doRender: function () {
	    var thisGroup = this.group;
	    thisGroup.removeAll();
	    var visualMapModel = this.visualMapModel;
	    var textGap = visualMapModel.get('textGap');
	    var textStyleModel = visualMapModel.textStyleModel;
	    var textFont = textStyleModel.getFont();
	    var textFill = textStyleModel.getTextColor();
	
	    var itemAlign = this._getItemAlign();
	
	    var itemSize = visualMapModel.itemSize;
	
	    var viewData = this._getViewData();
	
	    var endsText = viewData.endsText;
	    var showLabel = zrUtil.retrieve(visualMapModel.get('showLabel', true), !endsText);
	    endsText && this._renderEndsText(thisGroup, endsText[0], itemSize, showLabel, itemAlign);
	    zrUtil.each(viewData.viewPieceList, renderItem, this);
	    endsText && this._renderEndsText(thisGroup, endsText[1], itemSize, showLabel, itemAlign);
	    layout.box(visualMapModel.get('orient'), thisGroup, visualMapModel.get('itemGap'));
	    this.renderBackground(thisGroup);
	    this.positionGroup(thisGroup);
	
	    function renderItem(item) {
	      var piece = item.piece;
	      var itemGroup = new graphic.Group();
	      itemGroup.onclick = zrUtil.bind(this._onItemClick, this, piece);
	
	      this._enableHoverLink(itemGroup, item.indexInModelPieceList);
	
	      var representValue = visualMapModel.getRepresentValue(piece);
	
	      this._createItemSymbol(itemGroup, representValue, [0, 0, itemSize[0], itemSize[1]]);
	
	      if (showLabel) {
	        var visualState = this.visualMapModel.getValueState(representValue);
	        itemGroup.add(new graphic.Text({
	          style: {
	            x: itemAlign === 'right' ? -textGap : itemSize[0] + textGap,
	            y: itemSize[1] / 2,
	            text: piece.text,
	            textVerticalAlign: 'middle',
	            textAlign: itemAlign,
	            textFont: textFont,
	            textFill: textFill,
	            opacity: visualState === 'outOfRange' ? 0.5 : 1
	          }
	        }));
	      }
	
	      thisGroup.add(itemGroup);
	    }
	  },
	
	  /**
	   * @private
	   */
	  _enableHoverLink: function (itemGroup, pieceIndex) {
	    itemGroup.on('mouseover', zrUtil.bind(onHoverLink, this, 'highlight')).on('mouseout', zrUtil.bind(onHoverLink, this, 'downplay'));
	
	    function onHoverLink(method) {
	      var visualMapModel = this.visualMapModel;
	      visualMapModel.option.hoverLink && this.api.dispatchAction({
	        type: method,
	        batch: helper.makeHighDownBatch(visualMapModel.findTargetDataIndices(pieceIndex), visualMapModel)
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _getItemAlign: function () {
	    var visualMapModel = this.visualMapModel;
	    var modelOption = visualMapModel.option;
	
	    if (modelOption.orient === 'vertical') {
	      return helper.getItemAlign(visualMapModel, this.api, visualMapModel.itemSize);
	    } else {
	      // horizontal, most case left unless specifying right.
	      var align = modelOption.align;
	
	      if (!align || align === 'auto') {
	        align = 'left';
	      }
	
	      return align;
	    }
	  },
	
	  /**
	   * @private
	   */
	  _renderEndsText: function (group, text, itemSize, showLabel, itemAlign) {
	    if (!text) {
	      return;
	    }
	
	    var itemGroup = new graphic.Group();
	    var textStyleModel = this.visualMapModel.textStyleModel;
	    itemGroup.add(new graphic.Text({
	      style: {
	        x: showLabel ? itemAlign === 'right' ? itemSize[0] : 0 : itemSize[0] / 2,
	        y: itemSize[1] / 2,
	        textVerticalAlign: 'middle',
	        textAlign: showLabel ? itemAlign : 'center',
	        text: text,
	        textFont: textStyleModel.getFont(),
	        textFill: textStyleModel.getTextColor()
	      }
	    }));
	    group.add(itemGroup);
	  },
	
	  /**
	   * @private
	   * @return {Object} {peiceList, endsText} The order is the same as screen pixel order.
	   */
	  _getViewData: function () {
	    var visualMapModel = this.visualMapModel;
	    var viewPieceList = zrUtil.map(visualMapModel.getPieceList(), function (piece, index) {
	      return {
	        piece: piece,
	        indexInModelPieceList: index
	      };
	    });
	    var endsText = visualMapModel.get('text'); // Consider orient and inverse.
	
	    var orient = visualMapModel.get('orient');
	    var inverse = visualMapModel.get('inverse'); // Order of model pieceList is always [low, ..., high]
	
	    if (orient === 'horizontal' ? inverse : !inverse) {
	      viewPieceList.reverse();
	    } // Origin order of endsText is [high, low]
	    else if (endsText) {
	        endsText = endsText.slice().reverse();
	      }
	
	    return {
	      viewPieceList: viewPieceList,
	      endsText: endsText
	    };
	  },
	
	  /**
	   * @private
	   */
	  _createItemSymbol: function (group, representValue, shapeParam) {
	    group.add(createSymbol(this.getControllerVisual(representValue, 'symbol'), shapeParam[0], shapeParam[1], shapeParam[2], shapeParam[3], this.getControllerVisual(representValue, 'color')));
	  },
	
	  /**
	   * @private
	   */
	  _onItemClick: function (piece) {
	    var visualMapModel = this.visualMapModel;
	    var option = visualMapModel.option;
	    var selected = zrUtil.clone(option.selected);
	    var newKey = visualMapModel.getSelectedMapKey(piece);
	
	    if (option.selectedMode === 'single') {
	      selected[newKey] = true;
	      zrUtil.each(selected, function (o, key) {
	        selected[key] = key === newKey;
	      });
	    } else {
	      selected[newKey] = !selected[newKey];
	    }
	
	    this.api.dispatchAction({
	      type: 'selectDataRange',
	      from: this.uid,
	      visualMapId: this.visualMapModel.id,
	      selected: selected
	    });
	  }
	});
	var _default = PiecewiseVisualMapView;
	module.exports = _default;

/***/ },
/* 1651 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var textContain = __webpack_require__(79);
	
	var _model = __webpack_require__(24);
	
	var makeInner = _model.makeInner;
	
	var _axisHelper = __webpack_require__(93);
	
	var makeLabelFormatter = _axisHelper.makeLabelFormatter;
	var getOptionCategoryInterval = _axisHelper.getOptionCategoryInterval;
	var shouldShowAllLabels = _axisHelper.shouldShowAllLabels;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = makeInner();
	/**
	 * @param {module:echats/coord/Axis} axis
	 * @return {Object} {
	 *     labels: [{
	 *         formattedLabel: string,
	 *         rawLabel: string,
	 *         tickValue: number
	 *     }, ...],
	 *     labelCategoryInterval: number
	 * }
	 */
	
	function createAxisLabels(axis) {
	  // Only ordinal scale support tick interval
	  return axis.type === 'category' ? makeCategoryLabels(axis) : makeRealNumberLabels(axis);
	}
	/**
	 * @param {module:echats/coord/Axis} axis
	 * @param {module:echarts/model/Model} tickModel For example, can be axisTick, splitLine, splitArea.
	 * @return {Object} {
	 *     ticks: Array.<number>
	 *     tickCategoryInterval: number
	 * }
	 */
	
	
	function createAxisTicks(axis, tickModel) {
	  // Only ordinal scale support tick interval
	  return axis.type === 'category' ? makeCategoryTicks(axis, tickModel) : {
	    ticks: axis.scale.getTicks()
	  };
	}
	
	function makeCategoryLabels(axis) {
	  var labelModel = axis.getLabelModel();
	  var result = makeCategoryLabelsActually(axis, labelModel);
	  return !labelModel.get('show') || axis.scale.isBlank() ? {
	    labels: [],
	    labelCategoryInterval: result.labelCategoryInterval
	  } : result;
	}
	
	function makeCategoryLabelsActually(axis, labelModel) {
	  var labelsCache = getListCache(axis, 'labels');
	  var optionLabelInterval = getOptionCategoryInterval(labelModel);
	  var result = listCacheGet(labelsCache, optionLabelInterval);
	
	  if (result) {
	    return result;
	  }
	
	  var labels;
	  var numericLabelInterval;
	
	  if (zrUtil.isFunction(optionLabelInterval)) {
	    labels = makeLabelsByCustomizedCategoryInterval(axis, optionLabelInterval);
	  } else {
	    numericLabelInterval = optionLabelInterval === 'auto' ? makeAutoCategoryInterval(axis) : optionLabelInterval;
	    labels = makeLabelsByNumericCategoryInterval(axis, numericLabelInterval);
	  } // Cache to avoid calling interval function repeatly.
	
	
	  return listCacheSet(labelsCache, optionLabelInterval, {
	    labels: labels,
	    labelCategoryInterval: numericLabelInterval
	  });
	}
	
	function makeCategoryTicks(axis, tickModel) {
	  var ticksCache = getListCache(axis, 'ticks');
	  var optionTickInterval = getOptionCategoryInterval(tickModel);
	  var result = listCacheGet(ticksCache, optionTickInterval);
	
	  if (result) {
	    return result;
	  }
	
	  var ticks;
	  var tickCategoryInterval; // Optimize for the case that large category data and no label displayed,
	  // we should not return all ticks.
	
	  if (!tickModel.get('show') || axis.scale.isBlank()) {
	    ticks = [];
	  }
	
	  if (zrUtil.isFunction(optionTickInterval)) {
	    ticks = makeLabelsByCustomizedCategoryInterval(axis, optionTickInterval, true);
	  } // Always use label interval by default despite label show. Consider this
	  // scenario, Use multiple grid with the xAxis sync, and only one xAxis shows
	  // labels. `splitLine` and `axisTick` should be consistent in this case.
	  else if (optionTickInterval === 'auto') {
	      var labelsResult = makeCategoryLabelsActually(axis, axis.getLabelModel());
	      tickCategoryInterval = labelsResult.labelCategoryInterval;
	      ticks = zrUtil.map(labelsResult.labels, function (labelItem) {
	        return labelItem.tickValue;
	      });
	    } else {
	      tickCategoryInterval = optionTickInterval;
	      ticks = makeLabelsByNumericCategoryInterval(axis, tickCategoryInterval, true);
	    } // Cache to avoid calling interval function repeatly.
	
	
	  return listCacheSet(ticksCache, optionTickInterval, {
	    ticks: ticks,
	    tickCategoryInterval: tickCategoryInterval
	  });
	}
	
	function makeRealNumberLabels(axis) {
	  var ticks = axis.scale.getTicks();
	  var labelFormatter = makeLabelFormatter(axis);
	  return {
	    labels: zrUtil.map(ticks, function (tickValue, idx) {
	      return {
	        formattedLabel: labelFormatter(tickValue, idx),
	        rawLabel: axis.scale.getLabel(tickValue),
	        tickValue: tickValue
	      };
	    })
	  };
	} // Large category data calculation is performence sensitive, and ticks and label
	// probably be fetched by multiple times. So we cache the result.
	// axis is created each time during a ec process, so we do not need to clear cache.
	
	
	function getListCache(axis, prop) {
	  // Because key can be funciton, and cache size always be small, we use array cache.
	  return inner(axis)[prop] || (inner(axis)[prop] = []);
	}
	
	function listCacheGet(cache, key) {
	  for (var i = 0; i < cache.length; i++) {
	    if (cache[i].key === key) {
	      return cache[i].value;
	    }
	  }
	}
	
	function listCacheSet(cache, key, value) {
	  cache.push({
	    key: key,
	    value: value
	  });
	  return value;
	}
	
	function makeAutoCategoryInterval(axis) {
	  var result = inner(axis).autoInterval;
	  return result != null ? result : inner(axis).autoInterval = axis.calculateCategoryInterval();
	}
	/**
	 * Calculate interval for category axis ticks and labels.
	 * To get precise result, at least one of `getRotate` and `isHorizontal`
	 * should be implemented in axis.
	 */
	
	
	function calculateCategoryInterval(axis) {
	  var params = fetchAutoCategoryIntervalCalculationParams(axis);
	  var labelFormatter = makeLabelFormatter(axis);
	  var rotation = (params.axisRotate - params.labelRotate) / 180 * Math.PI;
	  var ordinalScale = axis.scale;
	  var ordinalExtent = ordinalScale.getExtent(); // Providing this method is for optimization:
	  // avoid generating a long array by `getTicks`
	  // in large category data case.
	
	  var tickCount = ordinalScale.count();
	
	  if (ordinalExtent[1] - ordinalExtent[0] < 1) {
	    return 0;
	  }
	
	  var step = 1; // Simple optimization. Empirical value: tick count should less than 40.
	
	  if (tickCount > 40) {
	    step = Math.max(1, Math.floor(tickCount / 40));
	  }
	
	  var tickValue = ordinalExtent[0];
	  var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
	  var unitW = Math.abs(unitSpan * Math.cos(rotation));
	  var unitH = Math.abs(unitSpan * Math.sin(rotation));
	  var maxW = 0;
	  var maxH = 0; // Caution: Performance sensitive for large category data.
	  // Consider dataZoom, we should make appropriate step to avoid O(n) loop.
	
	  for (; tickValue <= ordinalExtent[1]; tickValue += step) {
	    var width = 0;
	    var height = 0; // Not precise, do not consider align and vertical align
	    // and each distance from axis line yet.
	
	    var rect = textContain.getBoundingRect(labelFormatter(tickValue), params.font, 'center', 'top'); // Magic number
	
	    width = rect.width * 1.3;
	    height = rect.height * 1.3; // Min size, void long loop.
	
	    maxW = Math.max(maxW, width, 7);
	    maxH = Math.max(maxH, height, 7);
	  }
	
	  var dw = maxW / unitW;
	  var dh = maxH / unitH; // 0/0 is NaN, 1/0 is Infinity.
	
	  isNaN(dw) && (dw = Infinity);
	  isNaN(dh) && (dh = Infinity);
	  var interval = Math.max(0, Math.floor(Math.min(dw, dh)));
	  var cache = inner(axis.model);
	  var axisExtent = axis.getExtent();
	  var lastAutoInterval = cache.lastAutoInterval;
	  var lastTickCount = cache.lastTickCount; // Use cache to keep interval stable while moving zoom window,
	  // otherwise the calculated interval might jitter when the zoom
	  // window size is close to the interval-changing size.
	  // For example, if all of the axis labels are `a, b, c, d, e, f, g`.
	  // The jitter will cause that sometimes the displayed labels are
	  // `a, d, g` (interval: 2) sometimes `a, c, e`(interval: 1).
	
	  if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 // Always choose the bigger one, otherwise the critical
	  // point is not the same when zooming in or zooming out.
	  && lastAutoInterval > interval // If the axis change is caused by chart resize, the cache should not
	  // be used. Otherwise some hiden labels might not be shown again.
	  && cache.axisExtend0 === axisExtent[0] && cache.axisExtend1 === axisExtent[1]) {
	    interval = lastAutoInterval;
	  } // Only update cache if cache not used, otherwise the
	  // changing of interval is too insensitive.
	  else {
	      cache.lastTickCount = tickCount;
	      cache.lastAutoInterval = interval;
	      cache.axisExtend0 = axisExtent[0];
	      cache.axisExtend1 = axisExtent[1];
	    }
	
	  return interval;
	}
	
	function fetchAutoCategoryIntervalCalculationParams(axis) {
	  var labelModel = axis.getLabelModel();
	  return {
	    axisRotate: axis.getRotate ? axis.getRotate() : axis.isHorizontal && !axis.isHorizontal() ? 90 : 0,
	    labelRotate: labelModel.get('rotate') || 0,
	    font: labelModel.getFont()
	  };
	}
	
	function makeLabelsByNumericCategoryInterval(axis, categoryInterval, onlyTick) {
	  var labelFormatter = makeLabelFormatter(axis);
	  var ordinalScale = axis.scale;
	  var ordinalExtent = ordinalScale.getExtent();
	  var labelModel = axis.getLabelModel();
	  var result = []; // TODO: axisType: ordinalTime, pick the tick from each month/day/year/...
	
	  var step = Math.max((categoryInterval || 0) + 1, 1);
	  var startTick = ordinalExtent[0];
	  var tickCount = ordinalScale.count(); // Calculate start tick based on zero if possible to keep label consistent
	  // while zooming and moving while interval > 0. Otherwise the selection
	  // of displayable ticks and symbols probably keep changing.
	  // 3 is empirical value.
	
	  if (startTick !== 0 && step > 1 && tickCount / step > 2) {
	    startTick = Math.round(Math.ceil(startTick / step) * step);
	  } // (1) Only add min max label here but leave overlap checking
	  // to render stage, which also ensure the returned list
	  // suitable for splitLine and splitArea rendering.
	  // (2) Scales except category always contain min max label so
	  // do not need to perform this process.
	
	
	  var showAllLabel = shouldShowAllLabels(axis);
	  var includeMinLabel = labelModel.get('showMinLabel') || showAllLabel;
	  var includeMaxLabel = labelModel.get('showMaxLabel') || showAllLabel;
	
	  if (includeMinLabel && startTick !== ordinalExtent[0]) {
	    addItem(ordinalExtent[0]);
	  } // Optimize: avoid generating large array by `ordinalScale.getTicks()`.
	
	
	  var tickValue = startTick;
	
	  for (; tickValue <= ordinalExtent[1]; tickValue += step) {
	    addItem(tickValue);
	  }
	
	  if (includeMaxLabel && tickValue - step !== ordinalExtent[1]) {
	    addItem(ordinalExtent[1]);
	  }
	
	  function addItem(tVal) {
	    result.push(onlyTick ? tVal : {
	      formattedLabel: labelFormatter(tVal),
	      rawLabel: ordinalScale.getLabel(tVal),
	      tickValue: tVal
	    });
	  }
	
	  return result;
	} // When interval is function, the result `false` means ignore the tick.
	// It is time consuming for large category data.
	
	
	function makeLabelsByCustomizedCategoryInterval(axis, categoryInterval, onlyTick) {
	  var ordinalScale = axis.scale;
	  var labelFormatter = makeLabelFormatter(axis);
	  var result = [];
	  zrUtil.each(ordinalScale.getTicks(), function (tickValue) {
	    var rawLabel = ordinalScale.getLabel(tickValue);
	
	    if (categoryInterval(tickValue, rawLabel)) {
	      result.push(onlyTick ? tickValue : {
	        formattedLabel: labelFormatter(tickValue),
	        rawLabel: rawLabel,
	        tickValue: tickValue
	      });
	    }
	  });
	  return result;
	}
	
	exports.createAxisLabels = createAxisLabels;
	exports.createAxisTicks = createAxisTicks;
	exports.calculateCategoryInterval = calculateCategoryInterval;

/***/ },
/* 1652 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var layout = __webpack_require__(36);
	
	var numberUtil = __webpack_require__(20);
	
	var CoordinateSystem = __webpack_require__(92);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// (24*60*60*1000)
	var PROXIMATE_ONE_DAY = 86400000;
	/**
	 * Calendar
	 *
	 * @constructor
	 *
	 * @param {Object} calendarModel calendarModel
	 * @param {Object} ecModel       ecModel
	 * @param {Object} api           api
	 */
	
	function Calendar(calendarModel, ecModel, api) {
	  this._model = calendarModel;
	}
	
	Calendar.prototype = {
	  constructor: Calendar,
	  type: 'calendar',
	  dimensions: ['time', 'value'],
	  // Required in createListFromData
	  getDimensionsInfo: function () {
	    return [{
	      name: 'time',
	      type: 'time'
	    }, 'value'];
	  },
	  getRangeInfo: function () {
	    return this._rangeInfo;
	  },
	  getModel: function () {
	    return this._model;
	  },
	  getRect: function () {
	    return this._rect;
	  },
	  getCellWidth: function () {
	    return this._sw;
	  },
	  getCellHeight: function () {
	    return this._sh;
	  },
	  getOrient: function () {
	    return this._orient;
	  },
	
	  /**
	   * getFirstDayOfWeek
	   *
	   * @example
	   *     0 : start at Sunday
	   *     1 : start at Monday
	   *
	   * @return {number}
	   */
	  getFirstDayOfWeek: function () {
	    return this._firstDayOfWeek;
	  },
	
	  /**
	   * get date info
	   *
	   * @param  {string|number} date date
	   * @return {Object}
	   * {
	   *      y: string, local full year, eg., '1940',
	   *      m: string, local month, from '01' ot '12',
	   *      d: string, local date, from '01' to '31' (if exists),
	   *      day: It is not date.getDay(). It is the location of the cell in a week, from 0 to 6,
	   *      time: timestamp,
	   *      formatedDate: string, yyyy-MM-dd,
	   *      date: original date object.
	   * }
	   */
	  getDateInfo: function (date) {
	    date = numberUtil.parseDate(date);
	    var y = date.getFullYear();
	    var m = date.getMonth() + 1;
	    m = m < 10 ? '0' + m : m;
	    var d = date.getDate();
	    d = d < 10 ? '0' + d : d;
	    var day = date.getDay();
	    day = Math.abs((day + 7 - this.getFirstDayOfWeek()) % 7);
	    return {
	      y: y,
	      m: m,
	      d: d,
	      day: day,
	      time: date.getTime(),
	      formatedDate: y + '-' + m + '-' + d,
	      date: date
	    };
	  },
	  getNextNDay: function (date, n) {
	    n = n || 0;
	
	    if (n === 0) {
	      return this.getDateInfo(date);
	    }
	
	    date = new Date(this.getDateInfo(date).time);
	    date.setDate(date.getDate() + n);
	    return this.getDateInfo(date);
	  },
	  update: function (ecModel, api) {
	    this._firstDayOfWeek = +this._model.getModel('dayLabel').get('firstDay');
	    this._orient = this._model.get('orient');
	    this._lineWidth = this._model.getModel('itemStyle').getItemStyle().lineWidth || 0;
	    this._rangeInfo = this._getRangeInfo(this._initRangeOption());
	    var weeks = this._rangeInfo.weeks || 1;
	    var whNames = ['width', 'height'];
	
	    var cellSize = this._model.get('cellSize').slice();
	
	    var layoutParams = this._model.getBoxLayoutParams();
	
	    var cellNumbers = this._orient === 'horizontal' ? [weeks, 7] : [7, weeks];
	    zrUtil.each([0, 1], function (idx) {
	      if (cellSizeSpecified(cellSize, idx)) {
	        layoutParams[whNames[idx]] = cellSize[idx] * cellNumbers[idx];
	      }
	    });
	    var whGlobal = {
	      width: api.getWidth(),
	      height: api.getHeight()
	    };
	    var calendarRect = this._rect = layout.getLayoutRect(layoutParams, whGlobal);
	    zrUtil.each([0, 1], function (idx) {
	      if (!cellSizeSpecified(cellSize, idx)) {
	        cellSize[idx] = calendarRect[whNames[idx]] / cellNumbers[idx];
	      }
	    });
	
	    function cellSizeSpecified(cellSize, idx) {
	      return cellSize[idx] != null && cellSize[idx] !== 'auto';
	    }
	
	    this._sw = cellSize[0];
	    this._sh = cellSize[1];
	  },
	
	  /**
	   * Convert a time data(time, value) item to (x, y) point.
	   *
	   * @override
	   * @param  {Array|number} data data
	   * @param  {boolean} [clamp=true] out of range
	   * @return {Array} point
	   */
	  dataToPoint: function (data, clamp) {
	    zrUtil.isArray(data) && (data = data[0]);
	    clamp == null && (clamp = true);
	    var dayInfo = this.getDateInfo(data);
	    var range = this._rangeInfo;
	    var date = dayInfo.formatedDate; // if not in range return [NaN, NaN]
	
	    if (clamp && !(dayInfo.time >= range.start.time && dayInfo.time < range.end.time + PROXIMATE_ONE_DAY)) {
	      return [NaN, NaN];
	    }
	
	    var week = dayInfo.day;
	
	    var nthWeek = this._getRangeInfo([range.start.time, date]).nthWeek;
	
	    if (this._orient === 'vertical') {
	      return [this._rect.x + week * this._sw + this._sw / 2, this._rect.y + nthWeek * this._sh + this._sh / 2];
	    }
	
	    return [this._rect.x + nthWeek * this._sw + this._sw / 2, this._rect.y + week * this._sh + this._sh / 2];
	  },
	
	  /**
	   * Convert a (x, y) point to time data
	   *
	   * @override
	   * @param  {string} point point
	   * @return {string}       data
	   */
	  pointToData: function (point) {
	    var date = this.pointToDate(point);
	    return date && date.time;
	  },
	
	  /**
	   * Convert a time date item to (x, y) four point.
	   *
	   * @param  {Array} data  date[0] is date
	   * @param  {boolean} [clamp=true]  out of range
	   * @return {Object}       point
	   */
	  dataToRect: function (data, clamp) {
	    var point = this.dataToPoint(data, clamp);
	    return {
	      contentShape: {
	        x: point[0] - (this._sw - this._lineWidth) / 2,
	        y: point[1] - (this._sh - this._lineWidth) / 2,
	        width: this._sw - this._lineWidth,
	        height: this._sh - this._lineWidth
	      },
	      center: point,
	      tl: [point[0] - this._sw / 2, point[1] - this._sh / 2],
	      tr: [point[0] + this._sw / 2, point[1] - this._sh / 2],
	      br: [point[0] + this._sw / 2, point[1] + this._sh / 2],
	      bl: [point[0] - this._sw / 2, point[1] + this._sh / 2]
	    };
	  },
	
	  /**
	   * Convert a (x, y) point to time date
	   *
	   * @param  {Array} point point
	   * @return {Object}       date
	   */
	  pointToDate: function (point) {
	    var nthX = Math.floor((point[0] - this._rect.x) / this._sw) + 1;
	    var nthY = Math.floor((point[1] - this._rect.y) / this._sh) + 1;
	    var range = this._rangeInfo.range;
	
	    if (this._orient === 'vertical') {
	      return this._getDateByWeeksAndDay(nthY, nthX - 1, range);
	    }
	
	    return this._getDateByWeeksAndDay(nthX, nthY - 1, range);
	  },
	
	  /**
	   * @inheritDoc
	   */
	  convertToPixel: zrUtil.curry(doConvert, 'dataToPoint'),
	
	  /**
	   * @inheritDoc
	   */
	  convertFromPixel: zrUtil.curry(doConvert, 'pointToData'),
	
	  /**
	   * initRange
	   *
	   * @private
	   * @return {Array} [start, end]
	   */
	  _initRangeOption: function () {
	    var range = this._model.get('range');
	
	    var rg = range;
	
	    if (zrUtil.isArray(rg) && rg.length === 1) {
	      rg = rg[0];
	    }
	
	    if (/^\d{4}$/.test(rg)) {
	      range = [rg + '-01-01', rg + '-12-31'];
	    }
	
	    if (/^\d{4}[\/|-]\d{1,2}$/.test(rg)) {
	      var start = this.getDateInfo(rg);
	      var firstDay = start.date;
	      firstDay.setMonth(firstDay.getMonth() + 1);
	      var end = this.getNextNDay(firstDay, -1);
	      range = [start.formatedDate, end.formatedDate];
	    }
	
	    if (/^\d{4}[\/|-]\d{1,2}[\/|-]\d{1,2}$/.test(rg)) {
	      range = [rg, rg];
	    }
	
	    var tmp = this._getRangeInfo(range);
	
	    if (tmp.start.time > tmp.end.time) {
	      range.reverse();
	    }
	
	    return range;
	  },
	
	  /**
	   * range info
	   *
	   * @private
	   * @param  {Array} range range ['2017-01-01', '2017-07-08']
	   *  If range[0] > range[1], they will not be reversed.
	   * @return {Object}       obj
	   */
	  _getRangeInfo: function (range) {
	    range = [this.getDateInfo(range[0]), this.getDateInfo(range[1])];
	    var reversed;
	
	    if (range[0].time > range[1].time) {
	      reversed = true;
	      range.reverse();
	    }
	
	    var allDay = Math.floor(range[1].time / PROXIMATE_ONE_DAY) - Math.floor(range[0].time / PROXIMATE_ONE_DAY) + 1; // Consider case1 (#11677 #10430):
	    // Set the system timezone as "UK", set the range to `['2016-07-01', '2016-12-31']`
	    // Consider case2:
	    // Firstly set system timezone as "Time Zone: America/Toronto",
	    // ```
	    // var first = new Date(1478412000000 - 3600 * 1000 * 2.5);
	    // var second = new Date(1478412000000);
	    // var allDays = Math.floor(second / ONE_DAY) - Math.floor(first / ONE_DAY) + 1;
	    // ```
	    // will get wrong result because of DST. So we should fix it.
	
	    var date = new Date(range[0].time);
	    var startDateNum = date.getDate();
	    var endDateNum = range[1].date.getDate();
	    date.setDate(startDateNum + allDay - 1); // The bias can not over a month, so just compare date.
	
	    var dateNum = date.getDate();
	
	    if (dateNum !== endDateNum) {
	      var sign = date.getTime() - range[1].time > 0 ? 1 : -1;
	
	      while ((dateNum = date.getDate()) !== endDateNum && (date.getTime() - range[1].time) * sign > 0) {
	        allDay -= sign;
	        date.setDate(dateNum - sign);
	      }
	    }
	
	    var weeks = Math.floor((allDay + range[0].day + 6) / 7);
	    var nthWeek = reversed ? -weeks + 1 : weeks - 1;
	    reversed && range.reverse();
	    return {
	      range: [range[0].formatedDate, range[1].formatedDate],
	      start: range[0],
	      end: range[1],
	      allDay: allDay,
	      weeks: weeks,
	      // From 0.
	      nthWeek: nthWeek,
	      fweek: range[0].day,
	      lweek: range[1].day
	    };
	  },
	
	  /**
	   * get date by nthWeeks and week day in range
	   *
	   * @private
	   * @param  {number} nthWeek the week
	   * @param  {number} day   the week day
	   * @param  {Array} range [d1, d2]
	   * @return {Object}
	   */
	  _getDateByWeeksAndDay: function (nthWeek, day, range) {
	    var rangeInfo = this._getRangeInfo(range);
	
	    if (nthWeek > rangeInfo.weeks || nthWeek === 0 && day < rangeInfo.fweek || nthWeek === rangeInfo.weeks && day > rangeInfo.lweek) {
	      return false;
	    }
	
	    var nthDay = (nthWeek - 1) * 7 - rangeInfo.fweek + day;
	    var date = new Date(rangeInfo.start.time);
	    date.setDate(rangeInfo.start.d + nthDay);
	    return this.getDateInfo(date);
	  }
	};
	Calendar.dimensions = Calendar.prototype.dimensions;
	Calendar.getDimensionsInfo = Calendar.prototype.getDimensionsInfo;
	
	Calendar.create = function (ecModel, api) {
	  var calendarList = [];
	  ecModel.eachComponent('calendar', function (calendarModel) {
	    var calendar = new Calendar(calendarModel, ecModel, api);
	    calendarList.push(calendar);
	    calendarModel.coordinateSystem = calendar;
	  });
	  ecModel.eachSeries(function (calendarSeries) {
	    if (calendarSeries.get('coordinateSystem') === 'calendar') {
	      // Inject coordinate system
	      calendarSeries.coordinateSystem = calendarList[calendarSeries.get('calendarIndex') || 0];
	    }
	  });
	  return calendarList;
	};
	
	function doConvert(methodName, ecModel, finder, value) {
	  var calendarModel = finder.calendarModel;
	  var seriesModel = finder.seriesModel;
	  var coordSys = calendarModel ? calendarModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem : null;
	  return coordSys === this ? coordSys[methodName](value) : null;
	}
	
	CoordinateSystem.register('calendar', Calendar);
	var _default = Calendar;
	module.exports = _default;

/***/ },
/* 1653 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var ComponentModel = __webpack_require__(57);
	
	var _layout = __webpack_require__(36);
	
	var getLayoutParams = _layout.getLayoutParams;
	var sizeCalculable = _layout.sizeCalculable;
	var mergeLayoutParam = _layout.mergeLayoutParam;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var CalendarModel = ComponentModel.extend({
	  type: 'calendar',
	
	  /**
	   * @type {module:echarts/coord/calendar/Calendar}
	   */
	  coordinateSystem: null,
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    left: 80,
	    top: 60,
	    cellSize: 20,
	    // horizontal vertical
	    orient: 'horizontal',
	    // month separate line style
	    splitLine: {
	      show: true,
	      lineStyle: {
	        color: '#000',
	        width: 1,
	        type: 'solid'
	      }
	    },
	    // rect style  temporarily unused emphasis
	    itemStyle: {
	      color: '#fff',
	      borderWidth: 1,
	      borderColor: '#ccc'
	    },
	    // week text style
	    dayLabel: {
	      show: true,
	      // a week first day
	      firstDay: 0,
	      // start end
	      position: 'start',
	      margin: '50%',
	      // 50% of cellSize
	      nameMap: 'en',
	      color: '#000'
	    },
	    // month text style
	    monthLabel: {
	      show: true,
	      // start end
	      position: 'start',
	      margin: 5,
	      // center or left
	      align: 'center',
	      // cn en []
	      nameMap: 'en',
	      formatter: null,
	      color: '#000'
	    },
	    // year text style
	    yearLabel: {
	      show: true,
	      // top bottom left right
	      position: null,
	      margin: 30,
	      formatter: null,
	      color: '#ccc',
	      fontFamily: 'sans-serif',
	      fontWeight: 'bolder',
	      fontSize: 20
	    }
	  },
	
	  /**
	   * @override
	   */
	  init: function (option, parentModel, ecModel, extraOpt) {
	    var inputPositionParams = getLayoutParams(option);
	    CalendarModel.superApply(this, 'init', arguments);
	    mergeAndNormalizeLayoutParams(option, inputPositionParams);
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function (option, extraOpt) {
	    CalendarModel.superApply(this, 'mergeOption', arguments);
	    mergeAndNormalizeLayoutParams(this.option, option);
	  }
	});
	
	function mergeAndNormalizeLayoutParams(target, raw) {
	  // Normalize cellSize
	  var cellSize = target.cellSize;
	
	  if (!zrUtil.isArray(cellSize)) {
	    cellSize = target.cellSize = [cellSize, cellSize];
	  } else if (cellSize.length === 1) {
	    cellSize[1] = cellSize[0];
	  }
	
	  var ignoreSize = zrUtil.map([0, 1], function (hvIdx) {
	    // If user have set `width` or both `left` and `right`, cellSize
	    // will be automatically set to 'auto', otherwise the default
	    // setting of cellSize will make `width` setting not work.
	    if (sizeCalculable(raw, hvIdx)) {
	      cellSize[hvIdx] = 'auto';
	    }
	
	    return cellSize[hvIdx] != null && cellSize[hvIdx] !== 'auto';
	  });
	  mergeLayoutParam(target, raw, {
	    type: 'box',
	    ignoreSize: ignoreSize
	  });
	}
	
	var _default = CalendarModel;
	module.exports = _default;

/***/ },
/* 1654 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(coordSys) {
	  var rect = coordSys.getRect();
	  var rangeInfo = coordSys.getRangeInfo();
	  return {
	    coordSys: {
	      type: 'calendar',
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height,
	      cellWidth: coordSys.getCellWidth(),
	      cellHeight: coordSys.getCellHeight(),
	      rangeInfo: {
	        start: rangeInfo.start,
	        end: rangeInfo.end,
	        weeks: rangeInfo.weeks,
	        dayCount: rangeInfo.allDay
	      }
	    },
	    api: {
	      coord: function (data, clamp) {
	        return coordSys.dataToPoint(data, clamp);
	      }
	    }
	  };
	}
	
	module.exports = _default;

/***/ },
/* 1655 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var Axis = __webpack_require__(140);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Extend axis 2d
	 * @constructor module:echarts/coord/cartesian/Axis2D
	 * @extends {module:echarts/coord/cartesian/Axis}
	 * @param {string} dim
	 * @param {*} scale
	 * @param {Array.<number>} coordExtent
	 * @param {string} axisType
	 * @param {string} position
	 */
	var Axis2D = function (dim, scale, coordExtent, axisType, position) {
	  Axis.call(this, dim, scale, coordExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = axisType || 'value';
	  /**
	   * Axis position
	   *  - 'top'
	   *  - 'bottom'
	   *  - 'left'
	   *  - 'right'
	   */
	
	  this.position = position || 'bottom';
	};
	
	Axis2D.prototype = {
	  constructor: Axis2D,
	
	  /**
	   * Index of axis, can be used as key
	   */
	  index: 0,
	
	  /**
	   * Implemented in <module:echarts/coord/cartesian/Grid>.
	   * @return {Array.<module:echarts/coord/cartesian/Axis2D>}
	   *         If not on zero of other axis, return null/undefined.
	   *         If no axes, return an empty array.
	   */
	  getAxesOnZeroOf: null,
	
	  /**
	   * Axis model
	   * @param {module:echarts/coord/cartesian/AxisModel}
	   */
	  model: null,
	  isHorizontal: function () {
	    var position = this.position;
	    return position === 'top' || position === 'bottom';
	  },
	
	  /**
	   * Each item cooresponds to this.getExtent(), which
	   * means globalExtent[0] may greater than globalExtent[1],
	   * unless `asc` is input.
	   *
	   * @param {boolean} [asc]
	   * @return {Array.<number>}
	   */
	  getGlobalExtent: function (asc) {
	    var ret = this.getExtent();
	    ret[0] = this.toGlobalCoord(ret[0]);
	    ret[1] = this.toGlobalCoord(ret[1]);
	    asc && ret[0] > ret[1] && ret.reverse();
	    return ret;
	  },
	  getOtherAxis: function () {
	    this.grid.getOtherAxis();
	  },
	
	  /**
	   * @override
	   */
	  pointToData: function (point, clamp) {
	    return this.coordToData(this.toLocalCoord(point[this.dim === 'x' ? 0 : 1]), clamp);
	  },
	
	  /**
	   * Transform global coord to local coord,
	   * i.e. var localCoord = axis.toLocalCoord(80);
	   * designate by module:echarts/coord/cartesian/Grid.
	   * @type {Function}
	   */
	  toLocalCoord: null,
	
	  /**
	   * Transform global coord to local coord,
	   * i.e. var globalCoord = axis.toLocalCoord(40);
	   * designate by module:echarts/coord/cartesian/Grid.
	   * @type {Function}
	   */
	  toGlobalCoord: null
	};
	zrUtil.inherits(Axis2D, Axis);
	var _default = Axis2D;
	module.exports = _default;

/***/ },
/* 1656 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Cartesian coordinate system
	 * @module  echarts/coord/Cartesian
	 *
	 */
	function dimAxisMapper(dim) {
	  return this._axes[dim];
	}
	/**
	 * @alias module:echarts/coord/Cartesian
	 * @constructor
	 */
	
	
	var Cartesian = function (name) {
	  this._axes = {};
	  this._dimList = [];
	  /**
	   * @type {string}
	   */
	
	  this.name = name || '';
	};
	
	Cartesian.prototype = {
	  constructor: Cartesian,
	  type: 'cartesian',
	
	  /**
	   * Get axis
	   * @param  {number|string} dim
	   * @return {module:echarts/coord/Cartesian~Axis}
	   */
	  getAxis: function (dim) {
	    return this._axes[dim];
	  },
	
	  /**
	   * Get axes list
	   * @return {Array.<module:echarts/coord/Cartesian~Axis>}
	   */
	  getAxes: function () {
	    return zrUtil.map(this._dimList, dimAxisMapper, this);
	  },
	
	  /**
	   * Get axes list by given scale type
	   */
	  getAxesByScale: function (scaleType) {
	    scaleType = scaleType.toLowerCase();
	    return zrUtil.filter(this.getAxes(), function (axis) {
	      return axis.scale.type === scaleType;
	    });
	  },
	
	  /**
	   * Add axis
	   * @param {module:echarts/coord/Cartesian.Axis}
	   */
	  addAxis: function (axis) {
	    var dim = axis.dim;
	    this._axes[dim] = axis;
	
	    this._dimList.push(dim);
	  },
	
	  /**
	   * Convert data to coord in nd space
	   * @param {Array.<number>|Object.<string, number>} val
	   * @return {Array.<number>|Object.<string, number>}
	   */
	  dataToCoord: function (val) {
	    return this._dataCoordConvert(val, 'dataToCoord');
	  },
	
	  /**
	   * Convert coord in nd space to data
	   * @param  {Array.<number>|Object.<string, number>} val
	   * @return {Array.<number>|Object.<string, number>}
	   */
	  coordToData: function (val) {
	    return this._dataCoordConvert(val, 'coordToData');
	  },
	  _dataCoordConvert: function (input, method) {
	    var dimList = this._dimList;
	    var output = input instanceof Array ? [] : {};
	
	    for (var i = 0; i < dimList.length; i++) {
	      var dim = dimList[i];
	      var axis = this._axes[dim];
	      output[dim] = axis[method](input[dim]);
	    }
	
	    return output;
	  }
	};
	var _default = Cartesian;
	module.exports = _default;

/***/ },
/* 1657 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var BoundingRect = __webpack_require__(42);
	
	var Cartesian = __webpack_require__(1656);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function Cartesian2D(name) {
	  Cartesian.call(this, name);
	}
	
	Cartesian2D.prototype = {
	  constructor: Cartesian2D,
	  type: 'cartesian2d',
	
	  /**
	   * @type {Array.<string>}
	   * @readOnly
	   */
	  dimensions: ['x', 'y'],
	
	  /**
	   * Base axis will be used on stacking.
	   *
	   * @return {module:echarts/coord/cartesian/Axis2D}
	   */
	  getBaseAxis: function () {
	    return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAxis('x');
	  },
	
	  /**
	   * If contain point
	   * @param {Array.<number>} point
	   * @return {boolean}
	   */
	  containPoint: function (point) {
	    var axisX = this.getAxis('x');
	    var axisY = this.getAxis('y');
	    return axisX.contain(axisX.toLocalCoord(point[0])) && axisY.contain(axisY.toLocalCoord(point[1]));
	  },
	
	  /**
	   * If contain data
	   * @param {Array.<number>} data
	   * @return {boolean}
	   */
	  containData: function (data) {
	    return this.getAxis('x').containData(data[0]) && this.getAxis('y').containData(data[1]);
	  },
	
	  /**
	   * @param {Array.<number>} data
	   * @param {Array.<number>} out
	   * @return {Array.<number>}
	   */
	  dataToPoint: function (data, reserved, out) {
	    var xAxis = this.getAxis('x');
	    var yAxis = this.getAxis('y');
	    out = out || [];
	    out[0] = xAxis.toGlobalCoord(xAxis.dataToCoord(data[0]));
	    out[1] = yAxis.toGlobalCoord(yAxis.dataToCoord(data[1]));
	    return out;
	  },
	
	  /**
	   * @param {Array.<number>} data
	   * @param {Array.<number>} out
	   * @return {Array.<number>}
	   */
	  clampData: function (data, out) {
	    var xScale = this.getAxis('x').scale;
	    var yScale = this.getAxis('y').scale;
	    var xAxisExtent = xScale.getExtent();
	    var yAxisExtent = yScale.getExtent();
	    var x = xScale.parse(data[0]);
	    var y = yScale.parse(data[1]);
	    out = out || [];
	    out[0] = Math.min(Math.max(Math.min(xAxisExtent[0], xAxisExtent[1]), x), Math.max(xAxisExtent[0], xAxisExtent[1]));
	    out[1] = Math.min(Math.max(Math.min(yAxisExtent[0], yAxisExtent[1]), y), Math.max(yAxisExtent[0], yAxisExtent[1]));
	    return out;
	  },
	
	  /**
	   * @param {Array.<number>} point
	   * @param {Array.<number>} out
	   * @return {Array.<number>}
	   */
	  pointToData: function (point, out) {
	    var xAxis = this.getAxis('x');
	    var yAxis = this.getAxis('y');
	    out = out || [];
	    out[0] = xAxis.coordToData(xAxis.toLocalCoord(point[0]));
	    out[1] = yAxis.coordToData(yAxis.toLocalCoord(point[1]));
	    return out;
	  },
	
	  /**
	   * Get other axis
	   * @param {module:echarts/coord/cartesian/Axis2D} axis
	   */
	  getOtherAxis: function (axis) {
	    return this.getAxis(axis.dim === 'x' ? 'y' : 'x');
	  },
	
	  /**
	   * Get rect area of cartesian.
	   * Area will have a contain function to determine if a point is in the coordinate system.
	   * @return {BoundingRect}
	   */
	  getArea: function () {
	    var xExtent = this.getAxis('x').getGlobalExtent();
	    var yExtent = this.getAxis('y').getGlobalExtent();
	    var x = Math.min(xExtent[0], xExtent[1]);
	    var y = Math.min(yExtent[0], yExtent[1]);
	    var width = Math.max(xExtent[0], xExtent[1]) - x;
	    var height = Math.max(yExtent[0], yExtent[1]) - y;
	    var rect = new BoundingRect(x, y, width, height);
	    return rect;
	  }
	};
	zrUtil.inherits(Cartesian2D, Cartesian);
	var _default = Cartesian2D;
	module.exports = _default;

/***/ },
/* 1658 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(738);
	
	var ComponentModel = __webpack_require__(57);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Grid 是在有直角坐标系的时候必须要存在的
	// 所以这里也要被 Cartesian2D 依赖
	var _default = ComponentModel.extend({
	  type: 'grid',
	  dependencies: ['xAxis', 'yAxis'],
	  layoutMode: 'box',
	
	  /**
	   * @type {module:echarts/coord/cartesian/Grid}
	   */
	  coordinateSystem: null,
	  defaultOption: {
	    show: false,
	    zlevel: 0,
	    z: 0,
	    left: '10%',
	    top: 60,
	    right: '10%',
	    bottom: 60,
	    // If grid size contain label
	    containLabel: false,
	    // width: {totalWidth} - left - right,
	    // height: {totalHeight} - top - bottom,
	    backgroundColor: 'rgba(0,0,0,0)',
	    borderWidth: 1,
	    borderColor: '#ccc'
	  }
	});
	
	module.exports = _default;

/***/ },
/* 1659 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function dataToCoordSize(dataSize, dataItem) {
	  // dataItem is necessary in log axis.
	  dataItem = dataItem || [0, 0];
	  return zrUtil.map(['x', 'y'], function (dim, dimIdx) {
	    var axis = this.getAxis(dim);
	    var val = dataItem[dimIdx];
	    var halfSize = dataSize[dimIdx] / 2;
	    return axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
	  }, this);
	}
	
	function _default(coordSys) {
	  var rect = coordSys.grid.getRect();
	  return {
	    coordSys: {
	      // The name exposed to user is always 'cartesian2d' but not 'grid'.
	      type: 'cartesian2d',
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height
	    },
	    api: {
	      coord: function (data) {
	        // do not provide "out" param
	        return coordSys.dataToPoint(data);
	      },
	      size: zrUtil.bind(dataToCoordSize, coordSys)
	    }
	  };
	}
	
	module.exports = _default;

/***/ },
/* 1660 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var BoundingRect = __webpack_require__(42);
	
	var View = __webpack_require__(469);
	
	var geoSourceManager = __webpack_require__(336);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * [Geo description]
	 * For backward compatibility, the orginal interface:
	 * `name, map, geoJson, specialAreas, nameMap` is kept.
	 *
	 * @param {string|Object} name
	 * @param {string} map Map type
	 *        Specify the positioned areas by left, top, width, height
	 * @param {Object.<string, string>} [nameMap]
	 *        Specify name alias
	 * @param {boolean} [invertLongitute=true]
	 */
	function Geo(name, map, nameMap, invertLongitute) {
	  View.call(this, name);
	  /**
	   * Map type
	   * @type {string}
	   */
	
	  this.map = map;
	  var source = geoSourceManager.load(map, nameMap);
	  this._nameCoordMap = source.nameCoordMap;
	  this._regionsMap = source.regionsMap;
	  this._invertLongitute = invertLongitute == null ? true : invertLongitute;
	  /**
	   * @readOnly
	   */
	
	  this.regions = source.regions;
	  /**
	   * @type {module:zrender/src/core/BoundingRect}
	   */
	
	  this._rect = source.boundingRect;
	}
	
	Geo.prototype = {
	  constructor: Geo,
	  type: 'geo',
	
	  /**
	   * @param {Array.<string>}
	   * @readOnly
	   */
	  dimensions: ['lng', 'lat'],
	
	  /**
	   * If contain given lng,lat coord
	   * @param {Array.<number>}
	   * @readOnly
	   */
	  containCoord: function (coord) {
	    var regions = this.regions;
	
	    for (var i = 0; i < regions.length; i++) {
	      if (regions[i].contain(coord)) {
	        return true;
	      }
	    }
	
	    return false;
	  },
	
	  /**
	   * @override
	   */
	  transformTo: function (x, y, width, height) {
	    var rect = this.getBoundingRect();
	    var invertLongitute = this._invertLongitute;
	    rect = rect.clone();
	
	    if (invertLongitute) {
	      // Longitute is inverted
	      rect.y = -rect.y - rect.height;
	    }
	
	    var rawTransformable = this._rawTransformable;
	    rawTransformable.transform = rect.calculateTransform(new BoundingRect(x, y, width, height));
	    rawTransformable.decomposeTransform();
	
	    if (invertLongitute) {
	      var scale = rawTransformable.scale;
	      scale[1] = -scale[1];
	    }
	
	    rawTransformable.updateTransform();
	
	    this._updateTransform();
	  },
	
	  /**
	   * @param {string} name
	   * @return {module:echarts/coord/geo/Region}
	   */
	  getRegion: function (name) {
	    return this._regionsMap.get(name);
	  },
	  getRegionByCoord: function (coord) {
	    var regions = this.regions;
	
	    for (var i = 0; i < regions.length; i++) {
	      if (regions[i].contain(coord)) {
	        return regions[i];
	      }
	    }
	  },
	
	  /**
	   * Add geoCoord for indexing by name
	   * @param {string} name
	   * @param {Array.<number>} geoCoord
	   */
	  addGeoCoord: function (name, geoCoord) {
	    this._nameCoordMap.set(name, geoCoord);
	  },
	
	  /**
	   * Get geoCoord by name
	   * @param {string} name
	   * @return {Array.<number>}
	   */
	  getGeoCoord: function (name) {
	    return this._nameCoordMap.get(name);
	  },
	
	  /**
	   * @override
	   */
	  getBoundingRect: function () {
	    return this._rect;
	  },
	
	  /**
	   * @param {string|Array.<number>} data
	   * @param {boolean} noRoam
	   * @param {Array.<number>} [out]
	   * @return {Array.<number>}
	   */
	  dataToPoint: function (data, noRoam, out) {
	    if (typeof data === 'string') {
	      // Map area name to geoCoord
	      data = this.getGeoCoord(data);
	    }
	
	    if (data) {
	      return View.prototype.dataToPoint.call(this, data, noRoam, out);
	    }
	  },
	
	  /**
	   * @override
	   */
	  convertToPixel: zrUtil.curry(doConvert, 'dataToPoint'),
	
	  /**
	   * @override
	   */
	  convertFromPixel: zrUtil.curry(doConvert, 'pointToData')
	};
	zrUtil.mixin(Geo, View);
	
	function doConvert(methodName, ecModel, finder, value) {
	  var geoModel = finder.geoModel;
	  var seriesModel = finder.seriesModel;
	  var coordSys = geoModel ? geoModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem // For map.
	  || (seriesModel.getReferringComponents('geo')[0] || {}).coordinateSystem : null;
	  return coordSys === this ? coordSys[methodName](value) : null;
	}
	
	var _default = Geo;
	module.exports = _default;

/***/ },
/* 1661 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var modelUtil = __webpack_require__(24);
	
	var ComponentModel = __webpack_require__(57);
	
	var Model = __webpack_require__(48);
	
	var selectableMixin = __webpack_require__(465);
	
	var geoCreator = __webpack_require__(471);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var GeoModel = ComponentModel.extend({
	  type: 'geo',
	
	  /**
	   * @type {module:echarts/coord/geo/Geo}
	   */
	  coordinateSystem: null,
	  layoutMode: 'box',
	  init: function (option) {
	    ComponentModel.prototype.init.apply(this, arguments); // Default label emphasis `show`
	
	    modelUtil.defaultEmphasis(option, 'label', ['show']);
	  },
	  optionUpdated: function () {
	    var option = this.option;
	    var self = this;
	    option.regions = geoCreator.getFilledRegions(option.regions, option.map, option.nameMap);
	    this._optionModelMap = zrUtil.reduce(option.regions || [], function (optionModelMap, regionOpt) {
	      if (regionOpt.name) {
	        optionModelMap.set(regionOpt.name, new Model(regionOpt, self));
	      }
	
	      return optionModelMap;
	    }, zrUtil.createHashMap());
	    this.updateSelectedMap(option.regions);
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 0,
	    show: true,
	    left: 'center',
	    top: 'center',
	    // width:,
	    // height:,
	    // right
	    // bottom
	    // Aspect is width / height. Inited to be geoJson bbox aspect
	    // This parameter is used for scale this aspect
	    // If svg used, aspectScale is 1 by default.
	    // aspectScale: 0.75,
	    aspectScale: null,
	    ///// Layout with center and size
	    // If you wan't to put map in a fixed size box with right aspect ratio
	    // This two properties may more conveninet
	    // layoutCenter: [50%, 50%]
	    // layoutSize: 100
	    silent: false,
	    // Map type
	    map: '',
	    // Define left-top, right-bottom coords to control view
	    // For example, [ [180, 90], [-180, -90] ]
	    boundingCoords: null,
	    // Default on center of map
	    center: null,
	    zoom: 1,
	    scaleLimit: null,
	    // selectedMode: false
	    label: {
	      show: false,
	      color: '#000'
	    },
	    itemStyle: {
	      // color: 各异,
	      borderWidth: 0.5,
	      borderColor: '#444',
	      color: '#eee'
	    },
	    emphasis: {
	      label: {
	        show: true,
	        color: 'rgb(100,0,0)'
	      },
	      itemStyle: {
	        color: 'rgba(255,215,0,0.8)'
	      }
	    },
	    regions: []
	  },
	
	  /**
	   * Get model of region
	   * @param  {string} name
	   * @return {module:echarts/model/Model}
	   */
	  getRegionModel: function (name) {
	    return this._optionModelMap.get(name) || new Model(null, this, this.ecModel);
	  },
	
	  /**
	   * Format label
	   * @param {string} name Region name
	   * @param {string} [status='normal'] 'normal' or 'emphasis'
	   * @return {string}
	   */
	  getFormattedLabel: function (name, status) {
	    status = status || 'normal';
	    var regionModel = this.getRegionModel(name);
	    var formatter = regionModel.get((status === 'normal' ? '' : status + '.') + 'label.formatter');
	    var params = {
	      name: name
	    };
	
	    if (typeof formatter === 'function') {
	      params.status = status;
	      return formatter(params);
	    } else if (typeof formatter === 'string') {
	      return formatter.replace('{a}', name != null ? name : '');
	    }
	  },
	  setZoom: function (zoom) {
	    this.option.zoom = zoom;
	  },
	  setCenter: function (center) {
	    this.option.center = center;
	  }
	});
	zrUtil.mixin(GeoModel, selectableMixin);
	var _default = GeoModel;
	module.exports = _default;

/***/ },
/* 1662 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Fix for 钓鱼岛
	// var Region = require('../Region');
	// var zrUtil = require('zrender/src/core/util');
	// var geoCoord = [126, 25];
	var points = [[[123.45165252685547, 25.73527164402261], [123.49731445312499, 25.73527164402261], [123.49731445312499, 25.750734064600884], [123.45165252685547, 25.750734064600884], [123.45165252685547, 25.73527164402261]]];
	
	function _default(mapType, region) {
	  if (mapType === 'china' && region.name === '台湾') {
	    region.geometries.push({
	      type: 'polygon',
	      exterior: points[0]
	    });
	  }
	}
	
	module.exports = _default;

/***/ },
/* 1663 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var geoCoordMap = {
	  'Russia': [100, 60],
	  'United States': [-99, 38],
	  'United States of America': [-99, 38]
	};
	
	function _default(mapType, region) {
	  if (mapType === 'world') {
	    var geoCoord = geoCoordMap[region.name];
	
	    if (geoCoord) {
	      var cp = region.center;
	      cp[0] = geoCoord[0];
	      cp[1] = geoCoord[1];
	    }
	  }
	}
	
	module.exports = _default;

/***/ },
/* 1664 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var Region = __webpack_require__(740);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Fix for 南海诸岛
	var geoCoord = [126, 25];
	var points = [[[0, 3.5], [7, 11.2], [15, 11.9], [30, 7], [42, 0.7], [52, 0.7], [56, 7.7], [59, 0.7], [64, 0.7], [64, 0], [5, 0], [0, 3.5]], [[13, 16.1], [19, 14.7], [16, 21.7], [11, 23.1], [13, 16.1]], [[12, 32.2], [14, 38.5], [15, 38.5], [13, 32.2], [12, 32.2]], [[16, 47.6], [12, 53.2], [13, 53.2], [18, 47.6], [16, 47.6]], [[6, 64.4], [8, 70], [9, 70], [8, 64.4], [6, 64.4]], [[23, 82.6], [29, 79.8], [30, 79.8], [25, 82.6], [23, 82.6]], [[37, 70.7], [43, 62.3], [44, 62.3], [39, 70.7], [37, 70.7]], [[48, 51.1], [51, 45.5], [53, 45.5], [50, 51.1], [48, 51.1]], [[51, 35], [51, 28.7], [53, 28.7], [53, 35], [51, 35]], [[52, 22.4], [55, 17.5], [56, 17.5], [53, 22.4], [52, 22.4]], [[58, 12.6], [62, 7], [63, 7], [60, 12.6], [58, 12.6]], [[0, 3.5], [0, 93.1], [64, 93.1], [64, 0], [63, 0], [63, 92.4], [1, 92.4], [1, 3.5], [0, 3.5]]];
	
	for (var i = 0; i < points.length; i++) {
	  for (var k = 0; k < points[i].length; k++) {
	    points[i][k][0] /= 10.5;
	    points[i][k][1] /= -10.5 / 0.75;
	    points[i][k][0] += geoCoord[0];
	    points[i][k][1] += geoCoord[1];
	  }
	}
	
	function _default(mapType, regions) {
	  if (mapType === 'china') {
	    regions.push(new Region('南海诸岛', zrUtil.map(points, function (exterior) {
	      return {
	        type: 'polygon',
	        exterior: exterior
	      };
	    }), geoCoord));
	  }
	}
	
	module.exports = _default;

/***/ },
/* 1665 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var coordsOffsetMap = {
	  '南海诸岛': [32, 80],
	  // 全国
	  '广东': [0, -10],
	  '香港': [10, 5],
	  '澳门': [-10, 10],
	  //'北京': [-10, 0],
	  '天津': [5, 5]
	};
	
	function _default(mapType, region) {
	  if (mapType === 'china') {
	    var coordFix = coordsOffsetMap[region.name];
	
	    if (coordFix) {
	      var cp = region.center;
	      cp[0] += coordFix[0] / 10.5;
	      cp[1] += -coordFix[1] / (10.5 / 0.75);
	    }
	  }
	}
	
	module.exports = _default;

/***/ },
/* 1666 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(3);
	
	var each = _util.each;
	
	var parseGeoJson = __webpack_require__(741);
	
	var _model = __webpack_require__(24);
	
	var makeInner = _model.makeInner;
	
	var fixNanhai = __webpack_require__(1664);
	
	var fixTextCoord = __webpack_require__(1665);
	
	var fixGeoCoord = __webpack_require__(1663);
	
	var fixDiaoyuIsland = __webpack_require__(1662);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Built-in GEO fixer.
	var inner = makeInner();
	var _default = {
	  /**
	   * @param {string} mapName
	   * @param {Object} mapRecord {specialAreas, geoJSON}
	   * @param {string} nameProperty
	   * @return {Object} {regions, boundingRect}
	   */
	  load: function (mapName, mapRecord, nameProperty) {
	    var parsed = inner(mapRecord).parsed;
	
	    if (parsed) {
	      return parsed;
	    }
	
	    var specialAreas = mapRecord.specialAreas || {};
	    var geoJSON = mapRecord.geoJSON;
	    var regions; // https://jsperf.com/try-catch-performance-overhead
	
	    try {
	      regions = geoJSON ? parseGeoJson(geoJSON, nameProperty) : [];
	    } catch (e) {
	      throw new Error('Invalid geoJson format\n' + e.message);
	    }
	
	    fixNanhai(mapName, regions);
	    each(regions, function (region) {
	      var regionName = region.name;
	      fixTextCoord(mapName, region);
	      fixGeoCoord(mapName, region);
	      fixDiaoyuIsland(mapName, region); // Some area like Alaska in USA map needs to be tansformed
	      // to look better
	
	      var specialArea = specialAreas[regionName];
	
	      if (specialArea) {
	        region.transformTo(specialArea.left, specialArea.top, specialArea.width, specialArea.height);
	      }
	    });
	    return inner(mapRecord).parsed = {
	      regions: regions,
	      boundingRect: getBoundingRect(regions)
	    };
	  }
	};
	
	function getBoundingRect(regions) {
	  var rect;
	
	  for (var i = 0; i < regions.length; i++) {
	    var regionRect = regions[i].getBoundingRect();
	    rect = rect || regionRect.clone();
	    rect.union(regionRect);
	  }
	
	  return rect;
	}
	
	module.exports = _default;

/***/ },
/* 1667 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _parseSVG = __webpack_require__(1097);
	
	var parseSVG = _parseSVG.parseSVG;
	var makeViewBoxTransform = _parseSVG.makeViewBoxTransform;
	
	var Group = __webpack_require__(187);
	
	var Rect = __webpack_require__(561);
	
	var _util = __webpack_require__(3);
	
	var assert = _util.assert;
	var createHashMap = _util.createHashMap;
	
	var BoundingRect = __webpack_require__(42);
	
	var _model = __webpack_require__(24);
	
	var makeInner = _model.makeInner;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = makeInner();
	var _default = {
	  /**
	   * @param {string} mapName
	   * @param {Object} mapRecord {specialAreas, geoJSON}
	   * @return {Object} {root, boundingRect}
	   */
	  load: function (mapName, mapRecord) {
	    var originRoot = inner(mapRecord).originRoot;
	
	    if (originRoot) {
	      return {
	        root: originRoot,
	        boundingRect: inner(mapRecord).boundingRect
	      };
	    }
	
	    var graphic = buildGraphic(mapRecord);
	    inner(mapRecord).originRoot = graphic.root;
	    inner(mapRecord).boundingRect = graphic.boundingRect;
	    return graphic;
	  },
	  makeGraphic: function (mapName, mapRecord, hostKey) {
	    // For performance consideration (in large SVG), graphic only maked
	    // when necessary and reuse them according to hostKey.
	    var field = inner(mapRecord);
	    var rootMap = field.rootMap || (field.rootMap = createHashMap());
	    var root = rootMap.get(hostKey);
	
	    if (root) {
	      return root;
	    }
	
	    var originRoot = field.originRoot;
	    var boundingRect = field.boundingRect; // For performance, if originRoot is not used by a view,
	    // assign it to a view, but not reproduce graphic elements.
	
	    if (!field.originRootHostKey) {
	      field.originRootHostKey = hostKey;
	      root = originRoot;
	    } else {
	      root = buildGraphic(mapRecord, boundingRect).root;
	    }
	
	    return rootMap.set(hostKey, root);
	  },
	  removeGraphic: function (mapName, mapRecord, hostKey) {
	    var field = inner(mapRecord);
	    var rootMap = field.rootMap;
	    rootMap && rootMap.removeKey(hostKey);
	
	    if (hostKey === field.originRootHostKey) {
	      field.originRootHostKey = null;
	    }
	  }
	};
	
	function buildGraphic(mapRecord, boundingRect) {
	  var svgXML = mapRecord.svgXML;
	  var result;
	  var root;
	
	  try {
	    result = svgXML && parseSVG(svgXML, {
	      ignoreViewBox: true,
	      ignoreRootClip: true
	    }) || {};
	    root = result.root;
	    assert(root != null);
	  } catch (e) {
	    throw new Error('Invalid svg format\n' + e.message);
	  }
	
	  var svgWidth = result.width;
	  var svgHeight = result.height;
	  var viewBoxRect = result.viewBoxRect;
	
	  if (!boundingRect) {
	    boundingRect = svgWidth == null || svgHeight == null ? // If svg width / height not specified, calculate
	    // bounding rect as the width / height
	    root.getBoundingRect() : new BoundingRect(0, 0, 0, 0);
	
	    if (svgWidth != null) {
	      boundingRect.width = svgWidth;
	    }
	
	    if (svgHeight != null) {
	      boundingRect.height = svgHeight;
	    }
	  }
	
	  if (viewBoxRect) {
	    var viewBoxTransform = makeViewBoxTransform(viewBoxRect, boundingRect.width, boundingRect.height);
	    var elRoot = root;
	    root = new Group();
	    root.add(elRoot);
	    elRoot.scale = viewBoxTransform.scale;
	    elRoot.position = viewBoxTransform.position;
	  }
	
	  root.setClipPath(new Rect({
	    shape: boundingRect.plain()
	  }));
	  return {
	    root: root,
	    boundingRect: boundingRect
	  };
	}
	
	module.exports = _default;

/***/ },
/* 1668 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function dataToCoordSize(dataSize, dataItem) {
	  dataItem = dataItem || [0, 0];
	  return zrUtil.map([0, 1], function (dimIdx) {
	    var val = dataItem[dimIdx];
	    var halfSize = dataSize[dimIdx] / 2;
	    var p1 = [];
	    var p2 = [];
	    p1[dimIdx] = val - halfSize;
	    p2[dimIdx] = val + halfSize;
	    p1[1 - dimIdx] = p2[1 - dimIdx] = dataItem[1 - dimIdx];
	    return Math.abs(this.dataToPoint(p1)[dimIdx] - this.dataToPoint(p2)[dimIdx]);
	  }, this);
	}
	
	function _default(coordSys) {
	  var rect = coordSys.getBoundingRect();
	  return {
	    coordSys: {
	      type: 'geo',
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height,
	      zoom: coordSys.getZoom()
	    },
	    api: {
	      coord: function (data) {
	        // do not provide "out" and noRoam param,
	        // Compatible with this usage:
	        // echarts.util.map(item.points, api.coord)
	        return coordSys.dataToPoint(data);
	      },
	      size: zrUtil.bind(dataToCoordSize, coordSys)
	    }
	  };
	}
	
	module.exports = _default;

/***/ },
/* 1669 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var ComponentModel = __webpack_require__(57);
	
	var makeStyleMapper = __webpack_require__(208);
	
	var axisModelCreator = __webpack_require__(335);
	
	var numberUtil = __webpack_require__(20);
	
	var axisModelCommonMixin = __webpack_require__(206);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var AxisModel = ComponentModel.extend({
	  type: 'baseParallelAxis',
	
	  /**
	   * @type {module:echarts/coord/parallel/Axis}
	   */
	  axis: null,
	
	  /**
	   * @type {Array.<Array.<number>}
	   * @readOnly
	   */
	  activeIntervals: [],
	
	  /**
	   * @return {Object}
	   */
	  getAreaSelectStyle: function () {
	    return makeStyleMapper([['fill', 'color'], ['lineWidth', 'borderWidth'], ['stroke', 'borderColor'], ['width', 'width'], ['opacity', 'opacity']])(this.getModel('areaSelectStyle'));
	  },
	
	  /**
	   * The code of this feature is put on AxisModel but not ParallelAxis,
	   * because axisModel can be alive after echarts updating but instance of
	   * ParallelAxis having been disposed. this._activeInterval should be kept
	   * when action dispatched (i.e. legend click).
	   *
	   * @param {Array.<Array<number>>} intervals interval.length === 0
	   *                                          means set all active.
	   * @public
	   */
	  setActiveIntervals: function (intervals) {
	    var activeIntervals = this.activeIntervals = zrUtil.clone(intervals); // Normalize
	
	    if (activeIntervals) {
	      for (var i = activeIntervals.length - 1; i >= 0; i--) {
	        numberUtil.asc(activeIntervals[i]);
	      }
	    }
	  },
	
	  /**
	   * @param {number|string} [value] When attempting to detect 'no activeIntervals set',
	   *                         value can not be input.
	   * @return {string} 'normal': no activeIntervals set,
	   *                  'active',
	   *                  'inactive'.
	   * @public
	   */
	  getActiveState: function (value) {
	    var activeIntervals = this.activeIntervals;
	
	    if (!activeIntervals.length) {
	      return 'normal';
	    }
	
	    if (value == null || isNaN(value)) {
	      return 'inactive';
	    } // Simple optimization
	
	
	    if (activeIntervals.length === 1) {
	      var interval = activeIntervals[0];
	
	      if (interval[0] <= value && value <= interval[1]) {
	        return 'active';
	      }
	    } else {
	      for (var i = 0, len = activeIntervals.length; i < len; i++) {
	        if (activeIntervals[i][0] <= value && value <= activeIntervals[i][1]) {
	          return 'active';
	        }
	      }
	    }
	
	    return 'inactive';
	  }
	});
	var defaultOption = {
	  type: 'value',
	
	  /**
	   * @type {Array.<number>}
	   */
	  dim: null,
	  // 0, 1, 2, ...
	  // parallelIndex: null,
	  areaSelectStyle: {
	    width: 20,
	    borderWidth: 1,
	    borderColor: 'rgba(160,197,232)',
	    color: 'rgba(160,197,232)',
	    opacity: 0.3
	  },
	  realtime: true,
	  // Whether realtime update view when select.
	  z: 10
	};
	zrUtil.merge(AxisModel.prototype, axisModelCommonMixin);
	
	function getAxisType(axisName, option) {
	  return option.type || (option.data ? 'category' : 'value');
	}
	
	axisModelCreator('parallel', AxisModel, getAxisType, defaultOption);
	var _default = AxisModel;
	module.exports = _default;

/***/ },
/* 1670 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var matrix = __webpack_require__(73);
	
	var layoutUtil = __webpack_require__(36);
	
	var axisHelper = __webpack_require__(93);
	
	var ParallelAxis = __webpack_require__(1671);
	
	var graphic = __webpack_require__(16);
	
	var numberUtil = __webpack_require__(20);
	
	var sliderMove = __webpack_require__(205);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Parallel Coordinates
	 * <https://en.wikipedia.org/wiki/Parallel_coordinates>
	 */
	var each = zrUtil.each;
	var mathMin = Math.min;
	var mathMax = Math.max;
	var mathFloor = Math.floor;
	var mathCeil = Math.ceil;
	var round = numberUtil.round;
	var PI = Math.PI;
	
	function Parallel(parallelModel, ecModel, api) {
	  /**
	   * key: dimension
	   * @type {Object.<string, module:echarts/coord/parallel/Axis>}
	   * @private
	   */
	  this._axesMap = zrUtil.createHashMap();
	  /**
	   * key: dimension
	   * value: {position: [], rotation, }
	   * @type {Object.<string, Object>}
	   * @private
	   */
	
	  this._axesLayout = {};
	  /**
	   * Always follow axis order.
	   * @type {Array.<string>}
	   * @readOnly
	   */
	
	  this.dimensions = parallelModel.dimensions;
	  /**
	   * @type {module:zrender/core/BoundingRect}
	   */
	
	  this._rect;
	  /**
	   * @type {module:echarts/coord/parallel/ParallelModel}
	   */
	
	  this._model = parallelModel;
	
	  this._init(parallelModel, ecModel, api);
	}
	
	Parallel.prototype = {
	  type: 'parallel',
	  constructor: Parallel,
	
	  /**
	   * Initialize cartesian coordinate systems
	   * @private
	   */
	  _init: function (parallelModel, ecModel, api) {
	    var dimensions = parallelModel.dimensions;
	    var parallelAxisIndex = parallelModel.parallelAxisIndex;
	    each(dimensions, function (dim, idx) {
	      var axisIndex = parallelAxisIndex[idx];
	      var axisModel = ecModel.getComponent('parallelAxis', axisIndex);
	
	      var axis = this._axesMap.set(dim, new ParallelAxis(dim, axisHelper.createScaleByModel(axisModel), [0, 0], axisModel.get('type'), axisIndex));
	
	      var isCategory = axis.type === 'category';
	      axis.onBand = isCategory && axisModel.get('boundaryGap');
	      axis.inverse = axisModel.get('inverse'); // Injection
	
	      axisModel.axis = axis;
	      axis.model = axisModel;
	      axis.coordinateSystem = axisModel.coordinateSystem = this;
	    }, this);
	  },
	
	  /**
	   * Update axis scale after data processed
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  update: function (ecModel, api) {
	    this._updateAxesFromSeries(this._model, ecModel);
	  },
	
	  /**
	   * @override
	   */
	  containPoint: function (point) {
	    var layoutInfo = this._makeLayoutInfo();
	
	    var axisBase = layoutInfo.axisBase;
	    var layoutBase = layoutInfo.layoutBase;
	    var pixelDimIndex = layoutInfo.pixelDimIndex;
	    var pAxis = point[1 - pixelDimIndex];
	    var pLayout = point[pixelDimIndex];
	    return pAxis >= axisBase && pAxis <= axisBase + layoutInfo.axisLength && pLayout >= layoutBase && pLayout <= layoutBase + layoutInfo.layoutLength;
	  },
	  getModel: function () {
	    return this._model;
	  },
	
	  /**
	   * Update properties from series
	   * @private
	   */
	  _updateAxesFromSeries: function (parallelModel, ecModel) {
	    ecModel.eachSeries(function (seriesModel) {
	      if (!parallelModel.contains(seriesModel, ecModel)) {
	        return;
	      }
	
	      var data = seriesModel.getData();
	      each(this.dimensions, function (dim) {
	        var axis = this._axesMap.get(dim);
	
	        axis.scale.unionExtentFromData(data, data.mapDimension(dim));
	        axisHelper.niceScaleExtent(axis.scale, axis.model);
	      }, this);
	    }, this);
	  },
	
	  /**
	   * Resize the parallel coordinate system.
	   * @param {module:echarts/coord/parallel/ParallelModel} parallelModel
	   * @param {module:echarts/ExtensionAPI} api
	   */
	  resize: function (parallelModel, api) {
	    this._rect = layoutUtil.getLayoutRect(parallelModel.getBoxLayoutParams(), {
	      width: api.getWidth(),
	      height: api.getHeight()
	    });
	
	    this._layoutAxes();
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getRect: function () {
	    return this._rect;
	  },
	
	  /**
	   * @private
	   */
	  _makeLayoutInfo: function () {
	    var parallelModel = this._model;
	    var rect = this._rect;
	    var xy = ['x', 'y'];
	    var wh = ['width', 'height'];
	    var layout = parallelModel.get('layout');
	    var pixelDimIndex = layout === 'horizontal' ? 0 : 1;
	    var layoutLength = rect[wh[pixelDimIndex]];
	    var layoutExtent = [0, layoutLength];
	    var axisCount = this.dimensions.length;
	    var axisExpandWidth = restrict(parallelModel.get('axisExpandWidth'), layoutExtent);
	    var axisExpandCount = restrict(parallelModel.get('axisExpandCount') || 0, [0, axisCount]);
	    var axisExpandable = parallelModel.get('axisExpandable') && axisCount > 3 && axisCount > axisExpandCount && axisExpandCount > 1 && axisExpandWidth > 0 && layoutLength > 0; // `axisExpandWindow` is According to the coordinates of [0, axisExpandLength],
	    // for sake of consider the case that axisCollapseWidth is 0 (when screen is narrow),
	    // where collapsed axes should be overlapped.
	
	    var axisExpandWindow = parallelModel.get('axisExpandWindow');
	    var winSize;
	
	    if (!axisExpandWindow) {
	      winSize = restrict(axisExpandWidth * (axisExpandCount - 1), layoutExtent);
	      var axisExpandCenter = parallelModel.get('axisExpandCenter') || mathFloor(axisCount / 2);
	      axisExpandWindow = [axisExpandWidth * axisExpandCenter - winSize / 2];
	      axisExpandWindow[1] = axisExpandWindow[0] + winSize;
	    } else {
	      winSize = restrict(axisExpandWindow[1] - axisExpandWindow[0], layoutExtent);
	      axisExpandWindow[1] = axisExpandWindow[0] + winSize;
	    }
	
	    var axisCollapseWidth = (layoutLength - winSize) / (axisCount - axisExpandCount); // Avoid axisCollapseWidth is too small.
	
	    axisCollapseWidth < 3 && (axisCollapseWidth = 0); // Find the first and last indices > ewin[0] and < ewin[1].
	
	    var winInnerIndices = [mathFloor(round(axisExpandWindow[0] / axisExpandWidth, 1)) + 1, mathCeil(round(axisExpandWindow[1] / axisExpandWidth, 1)) - 1]; // Pos in ec coordinates.
	
	    var axisExpandWindow0Pos = axisCollapseWidth / axisExpandWidth * axisExpandWindow[0];
	    return {
	      layout: layout,
	      pixelDimIndex: pixelDimIndex,
	      layoutBase: rect[xy[pixelDimIndex]],
	      layoutLength: layoutLength,
	      axisBase: rect[xy[1 - pixelDimIndex]],
	      axisLength: rect[wh[1 - pixelDimIndex]],
	      axisExpandable: axisExpandable,
	      axisExpandWidth: axisExpandWidth,
	      axisCollapseWidth: axisCollapseWidth,
	      axisExpandWindow: axisExpandWindow,
	      axisCount: axisCount,
	      winInnerIndices: winInnerIndices,
	      axisExpandWindow0Pos: axisExpandWindow0Pos
	    };
	  },
	
	  /**
	   * @private
	   */
	  _layoutAxes: function () {
	    var rect = this._rect;
	    var axes = this._axesMap;
	    var dimensions = this.dimensions;
	
	    var layoutInfo = this._makeLayoutInfo();
	
	    var layout = layoutInfo.layout;
	    axes.each(function (axis) {
	      var axisExtent = [0, layoutInfo.axisLength];
	      var idx = axis.inverse ? 1 : 0;
	      axis.setExtent(axisExtent[idx], axisExtent[1 - idx]);
	    });
	    each(dimensions, function (dim, idx) {
	      var posInfo = (layoutInfo.axisExpandable ? layoutAxisWithExpand : layoutAxisWithoutExpand)(idx, layoutInfo);
	      var positionTable = {
	        horizontal: {
	          x: posInfo.position,
	          y: layoutInfo.axisLength
	        },
	        vertical: {
	          x: 0,
	          y: posInfo.position
	        }
	      };
	      var rotationTable = {
	        horizontal: PI / 2,
	        vertical: 0
	      };
	      var position = [positionTable[layout].x + rect.x, positionTable[layout].y + rect.y];
	      var rotation = rotationTable[layout];
	      var transform = matrix.create();
	      matrix.rotate(transform, transform, rotation);
	      matrix.translate(transform, transform, position); // TODO
	      // tick等排布信息。
	      // TODO
	      // 根据axis order 更新 dimensions顺序。
	
	      this._axesLayout[dim] = {
	        position: position,
	        rotation: rotation,
	        transform: transform,
	        axisNameAvailableWidth: posInfo.axisNameAvailableWidth,
	        axisLabelShow: posInfo.axisLabelShow,
	        nameTruncateMaxWidth: posInfo.nameTruncateMaxWidth,
	        tickDirection: 1,
	        labelDirection: 1
	      };
	    }, this);
	  },
	
	  /**
	   * Get axis by dim.
	   * @param {string} dim
	   * @return {module:echarts/coord/parallel/ParallelAxis} [description]
	   */
	  getAxis: function (dim) {
	    return this._axesMap.get(dim);
	  },
	
	  /**
	   * Convert a dim value of a single item of series data to Point.
	   * @param {*} value
	   * @param {string} dim
	   * @return {Array}
	   */
	  dataToPoint: function (value, dim) {
	    return this.axisCoordToPoint(this._axesMap.get(dim).dataToCoord(value), dim);
	  },
	
	  /**
	   * Travel data for one time, get activeState of each data item.
	   * @param {module:echarts/data/List} data
	   * @param {Functio} cb param: {string} activeState 'active' or 'inactive' or 'normal'
	   *                            {number} dataIndex
	   * @param {number} [start=0] the start dataIndex that travel from.
	   * @param {number} [end=data.count()] the next dataIndex of the last dataIndex will be travel.
	   */
	  eachActiveState: function (data, callback, start, end) {
	    start == null && (start = 0);
	    end == null && (end = data.count());
	    var axesMap = this._axesMap;
	    var dimensions = this.dimensions;
	    var dataDimensions = [];
	    var axisModels = [];
	    zrUtil.each(dimensions, function (axisDim) {
	      dataDimensions.push(data.mapDimension(axisDim));
	      axisModels.push(axesMap.get(axisDim).model);
	    });
	    var hasActiveSet = this.hasAxisBrushed();
	
	    for (var dataIndex = start; dataIndex < end; dataIndex++) {
	      var activeState;
	
	      if (!hasActiveSet) {
	        activeState = 'normal';
	      } else {
	        activeState = 'active';
	        var values = data.getValues(dataDimensions, dataIndex);
	
	        for (var j = 0, lenj = dimensions.length; j < lenj; j++) {
	          var state = axisModels[j].getActiveState(values[j]);
	
	          if (state === 'inactive') {
	            activeState = 'inactive';
	            break;
	          }
	        }
	      }
	
	      callback(activeState, dataIndex);
	    }
	  },
	
	  /**
	   * Whether has any activeSet.
	   * @return {boolean}
	   */
	  hasAxisBrushed: function () {
	    var dimensions = this.dimensions;
	    var axesMap = this._axesMap;
	    var hasActiveSet = false;
	
	    for (var j = 0, lenj = dimensions.length; j < lenj; j++) {
	      if (axesMap.get(dimensions[j]).model.getActiveState() !== 'normal') {
	        hasActiveSet = true;
	      }
	    }
	
	    return hasActiveSet;
	  },
	
	  /**
	   * Convert coords of each axis to Point.
	   *  Return point. For example: [10, 20]
	   * @param {Array.<number>} coords
	   * @param {string} dim
	   * @return {Array.<number>}
	   */
	  axisCoordToPoint: function (coord, dim) {
	    var axisLayout = this._axesLayout[dim];
	    return graphic.applyTransform([coord, 0], axisLayout.transform);
	  },
	
	  /**
	   * Get axis layout.
	   */
	  getAxisLayout: function (dim) {
	    return zrUtil.clone(this._axesLayout[dim]);
	  },
	
	  /**
	   * @param {Array.<number>} point
	   * @return {Object} {axisExpandWindow, delta, behavior: 'jump' | 'slide' | 'none'}.
	   */
	  getSlidedAxisExpandWindow: function (point) {
	    var layoutInfo = this._makeLayoutInfo();
	
	    var pixelDimIndex = layoutInfo.pixelDimIndex;
	    var axisExpandWindow = layoutInfo.axisExpandWindow.slice();
	    var winSize = axisExpandWindow[1] - axisExpandWindow[0];
	    var extent = [0, layoutInfo.axisExpandWidth * (layoutInfo.axisCount - 1)]; // Out of the area of coordinate system.
	
	    if (!this.containPoint(point)) {
	      return {
	        behavior: 'none',
	        axisExpandWindow: axisExpandWindow
	      };
	    } // Conver the point from global to expand coordinates.
	
	
	    var pointCoord = point[pixelDimIndex] - layoutInfo.layoutBase - layoutInfo.axisExpandWindow0Pos; // For dragging operation convenience, the window should not be
	    // slided when mouse is the center area of the window.
	
	    var delta;
	    var behavior = 'slide';
	    var axisCollapseWidth = layoutInfo.axisCollapseWidth;
	
	    var triggerArea = this._model.get('axisExpandSlideTriggerArea'); // But consider touch device, jump is necessary.
	
	
	    var useJump = triggerArea[0] != null;
	
	    if (axisCollapseWidth) {
	      if (useJump && axisCollapseWidth && pointCoord < winSize * triggerArea[0]) {
	        behavior = 'jump';
	        delta = pointCoord - winSize * triggerArea[2];
	      } else if (useJump && axisCollapseWidth && pointCoord > winSize * (1 - triggerArea[0])) {
	        behavior = 'jump';
	        delta = pointCoord - winSize * (1 - triggerArea[2]);
	      } else {
	        (delta = pointCoord - winSize * triggerArea[1]) >= 0 && (delta = pointCoord - winSize * (1 - triggerArea[1])) <= 0 && (delta = 0);
	      }
	
	      delta *= layoutInfo.axisExpandWidth / axisCollapseWidth;
	      delta ? sliderMove(delta, axisExpandWindow, extent, 'all') // Avoid nonsense triger on mousemove.
	      : behavior = 'none';
	    } // When screen is too narrow, make it visible and slidable, although it is hard to interact.
	    else {
	        var winSize = axisExpandWindow[1] - axisExpandWindow[0];
	        var pos = extent[1] * pointCoord / winSize;
	        axisExpandWindow = [mathMax(0, pos - winSize / 2)];
	        axisExpandWindow[1] = mathMin(extent[1], axisExpandWindow[0] + winSize);
	        axisExpandWindow[0] = axisExpandWindow[1] - winSize;
	      }
	
	    return {
	      axisExpandWindow: axisExpandWindow,
	      behavior: behavior
	    };
	  }
	};
	
	function restrict(len, extent) {
	  return mathMin(mathMax(len, extent[0]), extent[1]);
	}
	
	function layoutAxisWithoutExpand(axisIndex, layoutInfo) {
	  var step = layoutInfo.layoutLength / (layoutInfo.axisCount - 1);
	  return {
	    position: step * axisIndex,
	    axisNameAvailableWidth: step,
	    axisLabelShow: true
	  };
	}
	
	function layoutAxisWithExpand(axisIndex, layoutInfo) {
	  var layoutLength = layoutInfo.layoutLength;
	  var axisExpandWidth = layoutInfo.axisExpandWidth;
	  var axisCount = layoutInfo.axisCount;
	  var axisCollapseWidth = layoutInfo.axisCollapseWidth;
	  var winInnerIndices = layoutInfo.winInnerIndices;
	  var position;
	  var axisNameAvailableWidth = axisCollapseWidth;
	  var axisLabelShow = false;
	  var nameTruncateMaxWidth;
	
	  if (axisIndex < winInnerIndices[0]) {
	    position = axisIndex * axisCollapseWidth;
	    nameTruncateMaxWidth = axisCollapseWidth;
	  } else if (axisIndex <= winInnerIndices[1]) {
	    position = layoutInfo.axisExpandWindow0Pos + axisIndex * axisExpandWidth - layoutInfo.axisExpandWindow[0];
	    axisNameAvailableWidth = axisExpandWidth;
	    axisLabelShow = true;
	  } else {
	    position = layoutLength - (axisCount - 1 - axisIndex) * axisCollapseWidth;
	    nameTruncateMaxWidth = axisCollapseWidth;
	  }
	
	  return {
	    position: position,
	    axisNameAvailableWidth: axisNameAvailableWidth,
	    axisLabelShow: axisLabelShow,
	    nameTruncateMaxWidth: nameTruncateMaxWidth
	  };
	}
	
	var _default = Parallel;
	module.exports = _default;

/***/ },
/* 1671 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var Axis = __webpack_require__(140);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @constructor module:echarts/coord/parallel/ParallelAxis
	 * @extends {module:echarts/coord/Axis}
	 * @param {string} dim
	 * @param {*} scale
	 * @param {Array.<number>} coordExtent
	 * @param {string} axisType
	 */
	var ParallelAxis = function (dim, scale, coordExtent, axisType, axisIndex) {
	  Axis.call(this, dim, scale, coordExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = axisType || 'value';
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.axisIndex = axisIndex;
	};
	
	ParallelAxis.prototype = {
	  constructor: ParallelAxis,
	
	  /**
	   * Axis model
	   * @param {module:echarts/coord/parallel/AxisModel}
	   */
	  model: null,
	
	  /**
	   * @override
	   */
	  isHorizontal: function () {
	    return this.coordinateSystem.getModel().get('layout') !== 'horizontal';
	  }
	};
	zrUtil.inherits(ParallelAxis, Axis);
	var _default = ParallelAxis;
	module.exports = _default;

/***/ },
/* 1672 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var Component = __webpack_require__(57);
	
	__webpack_require__(1669);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = Component.extend({
	  type: 'parallel',
	  dependencies: ['parallelAxis'],
	
	  /**
	   * @type {module:echarts/coord/parallel/Parallel}
	   */
	  coordinateSystem: null,
	
	  /**
	   * Each item like: 'dim0', 'dim1', 'dim2', ...
	   * @type {Array.<string>}
	   * @readOnly
	   */
	  dimensions: null,
	
	  /**
	   * Coresponding to dimensions.
	   * @type {Array.<number>}
	   * @readOnly
	   */
	  parallelAxisIndex: null,
	  layoutMode: 'box',
	  defaultOption: {
	    zlevel: 0,
	    z: 0,
	    left: 80,
	    top: 60,
	    right: 80,
	    bottom: 60,
	    // width: {totalWidth} - left - right,
	    // height: {totalHeight} - top - bottom,
	    layout: 'horizontal',
	    // 'horizontal' or 'vertical'
	    // FIXME
	    // naming?
	    axisExpandable: false,
	    axisExpandCenter: null,
	    axisExpandCount: 0,
	    axisExpandWidth: 50,
	    // FIXME '10%' ?
	    axisExpandRate: 17,
	    axisExpandDebounce: 50,
	    // [out, in, jumpTarget]. In percentage. If use [null, 0.05], null means full.
	    // Do not doc to user until necessary.
	    axisExpandSlideTriggerArea: [-0.15, 0.05, 0.4],
	    axisExpandTriggerOn: 'click',
	    // 'mousemove' or 'click'
	    parallelAxisDefault: null
	  },
	
	  /**
	   * @override
	   */
	  init: function () {
	    Component.prototype.init.apply(this, arguments);
	    this.mergeOption({});
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function (newOption) {
	    var thisOption = this.option;
	    newOption && zrUtil.merge(thisOption, newOption, true);
	
	    this._initDimensions();
	  },
	
	  /**
	   * Whether series or axis is in this coordinate system.
	   * @param {module:echarts/model/Series|module:echarts/coord/parallel/AxisModel} model
	   * @param {module:echarts/model/Global} ecModel
	   */
	  contains: function (model, ecModel) {
	    var parallelIndex = model.get('parallelIndex');
	    return parallelIndex != null && ecModel.getComponent('parallel', parallelIndex) === this;
	  },
	  setAxisExpand: function (opt) {
	    zrUtil.each(['axisExpandable', 'axisExpandCenter', 'axisExpandCount', 'axisExpandWidth', 'axisExpandWindow'], function (name) {
	      if (opt.hasOwnProperty(name)) {
	        this.option[name] = opt[name];
	      }
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _initDimensions: function () {
	    var dimensions = this.dimensions = [];
	    var parallelAxisIndex = this.parallelAxisIndex = [];
	    var axisModels = zrUtil.filter(this.dependentModels.parallelAxis, function (axisModel) {
	      // Can not use this.contains here, because
	      // initialization has not been completed yet.
	      return (axisModel.get('parallelIndex') || 0) === this.componentIndex;
	    }, this);
	    zrUtil.each(axisModels, function (axisModel) {
	      dimensions.push('dim' + axisModel.get('dim'));
	      parallelAxisIndex.push(axisModel.componentIndex);
	    });
	  }
	});
	
	module.exports = _default;

/***/ },
/* 1673 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var modelUtil = __webpack_require__(24);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(option) {
	  createParallelIfNeeded(option);
	  mergeAxisOptionFromParallel(option);
	}
	/**
	 * Create a parallel coordinate if not exists.
	 * @inner
	 */
	
	
	function createParallelIfNeeded(option) {
	  if (option.parallel) {
	    return;
	  }
	
	  var hasParallelSeries = false;
	  zrUtil.each(option.series, function (seriesOpt) {
	    if (seriesOpt && seriesOpt.type === 'parallel') {
	      hasParallelSeries = true;
	    }
	  });
	
	  if (hasParallelSeries) {
	    option.parallel = [{}];
	  }
	}
	/**
	 * Merge aixs definition from parallel option (if exists) to axis option.
	 * @inner
	 */
	
	
	function mergeAxisOptionFromParallel(option) {
	  var axes = modelUtil.normalizeToArray(option.parallelAxis);
	  zrUtil.each(axes, function (axisOption) {
	    if (!zrUtil.isObject(axisOption)) {
	      return;
	    }
	
	    var parallelIndex = axisOption.parallelIndex || 0;
	    var parallelOption = modelUtil.normalizeToArray(option.parallel)[parallelIndex];
	
	    if (parallelOption && parallelOption.parallelAxisDefault) {
	      zrUtil.merge(axisOption, parallelOption.parallelAxisDefault, false);
	    }
	  });
	}
	
	module.exports = _default;

/***/ },
/* 1674 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var textContain = __webpack_require__(79);
	
	var Axis = __webpack_require__(140);
	
	var _model = __webpack_require__(24);
	
	var makeInner = _model.makeInner;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = makeInner();
	
	function AngleAxis(scale, angleExtent) {
	  angleExtent = angleExtent || [0, 360];
	  Axis.call(this, 'angle', scale, angleExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = 'category';
	}
	
	AngleAxis.prototype = {
	  constructor: AngleAxis,
	
	  /**
	   * @override
	   */
	  pointToData: function (point, clamp) {
	    return this.polar.pointToData(point, clamp)[this.dim === 'radius' ? 0 : 1];
	  },
	  dataToAngle: Axis.prototype.dataToCoord,
	  angleToData: Axis.prototype.coordToData,
	
	  /**
	   * Only be called in category axis.
	   * Angle axis uses text height to decide interval
	   *
	   * @override
	   * @return {number} Auto interval for cateogry axis tick and label
	   */
	  calculateCategoryInterval: function () {
	    var axis = this;
	    var labelModel = axis.getLabelModel();
	    var ordinalScale = axis.scale;
	    var ordinalExtent = ordinalScale.getExtent(); // Providing this method is for optimization:
	    // avoid generating a long array by `getTicks`
	    // in large category data case.
	
	    var tickCount = ordinalScale.count();
	
	    if (ordinalExtent[1] - ordinalExtent[0] < 1) {
	      return 0;
	    }
	
	    var tickValue = ordinalExtent[0];
	    var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
	    var unitH = Math.abs(unitSpan); // Not precise, just use height as text width
	    // and each distance from axis line yet.
	
	    var rect = textContain.getBoundingRect(tickValue, labelModel.getFont(), 'center', 'top');
	    var maxH = Math.max(rect.height, 7);
	    var dh = maxH / unitH; // 0/0 is NaN, 1/0 is Infinity.
	
	    isNaN(dh) && (dh = Infinity);
	    var interval = Math.max(0, Math.floor(dh));
	    var cache = inner(axis.model);
	    var lastAutoInterval = cache.lastAutoInterval;
	    var lastTickCount = cache.lastTickCount; // Use cache to keep interval stable while moving zoom window,
	    // otherwise the calculated interval might jitter when the zoom
	    // window size is close to the interval-changing size.
	
	    if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 // Always choose the bigger one, otherwise the critical
	    // point is not the same when zooming in or zooming out.
	    && lastAutoInterval > interval) {
	      interval = lastAutoInterval;
	    } // Only update cache if cache not used, otherwise the
	    // changing of interval is too insensitive.
	    else {
	        cache.lastTickCount = tickCount;
	        cache.lastAutoInterval = interval;
	      }
	
	    return interval;
	  }
	};
	zrUtil.inherits(AngleAxis, Axis);
	var _default = AngleAxis;
	module.exports = _default;

/***/ },
/* 1675 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var ComponentModel = __webpack_require__(57);
	
	var axisModelCreator = __webpack_require__(335);
	
	var axisModelCommonMixin = __webpack_require__(206);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PolarAxisModel = ComponentModel.extend({
	  type: 'polarAxis',
	
	  /**
	   * @type {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
	   */
	  axis: null,
	
	  /**
	   * @override
	   */
	  getCoordSysModel: function () {
	    return this.ecModel.queryComponents({
	      mainType: 'polar',
	      index: this.option.polarIndex,
	      id: this.option.polarId
	    })[0];
	  }
	});
	zrUtil.merge(PolarAxisModel.prototype, axisModelCommonMixin);
	var polarAxisDefaultExtendedOption = {
	  angle: {
	    // polarIndex: 0,
	    // polarId: '',
	    startAngle: 90,
	    clockwise: true,
	    splitNumber: 12,
	    axisLabel: {
	      rotate: false
	    }
	  },
	  radius: {
	    // polarIndex: 0,
	    // polarId: '',
	    splitNumber: 5
	  }
	};
	
	function getAxisType(axisDim, option) {
	  // Default axis with data is category axis
	  return option.type || (option.data ? 'category' : 'value');
	}
	
	axisModelCreator('angle', PolarAxisModel, getAxisType, polarAxisDefaultExtendedOption.angle);
	axisModelCreator('radius', PolarAxisModel, getAxisType, polarAxisDefaultExtendedOption.radius);

/***/ },
/* 1676 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var RadiusAxis = __webpack_require__(1678);
	
	var AngleAxis = __webpack_require__(1674);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/coord/polar/Polar
	 */
	
	/**
	 * @alias {module:echarts/coord/polar/Polar}
	 * @constructor
	 * @param {string} name
	 */
	var Polar = function (name) {
	  /**
	   * @type {string}
	   */
	  this.name = name || '';
	  /**
	   * x of polar center
	   * @type {number}
	   */
	
	  this.cx = 0;
	  /**
	   * y of polar center
	   * @type {number}
	   */
	
	  this.cy = 0;
	  /**
	   * @type {module:echarts/coord/polar/RadiusAxis}
	   * @private
	   */
	
	  this._radiusAxis = new RadiusAxis();
	  /**
	   * @type {module:echarts/coord/polar/AngleAxis}
	   * @private
	   */
	
	  this._angleAxis = new AngleAxis();
	  this._radiusAxis.polar = this._angleAxis.polar = this;
	};
	
	Polar.prototype = {
	  type: 'polar',
	  axisPointerEnabled: true,
	  constructor: Polar,
	
	  /**
	   * @param {Array.<string>}
	   * @readOnly
	   */
	  dimensions: ['radius', 'angle'],
	
	  /**
	   * @type {module:echarts/coord/PolarModel}
	   */
	  model: null,
	
	  /**
	   * If contain coord
	   * @param {Array.<number>} point
	   * @return {boolean}
	   */
	  containPoint: function (point) {
	    var coord = this.pointToCoord(point);
	    return this._radiusAxis.contain(coord[0]) && this._angleAxis.contain(coord[1]);
	  },
	
	  /**
	   * If contain data
	   * @param {Array.<number>} data
	   * @return {boolean}
	   */
	  containData: function (data) {
	    return this._radiusAxis.containData(data[0]) && this._angleAxis.containData(data[1]);
	  },
	
	  /**
	   * @param {string} dim
	   * @return {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
	   */
	  getAxis: function (dim) {
	    return this['_' + dim + 'Axis'];
	  },
	
	  /**
	   * @return {Array.<module:echarts/coord/Axis>}
	   */
	  getAxes: function () {
	    return [this._radiusAxis, this._angleAxis];
	  },
	
	  /**
	   * Get axes by type of scale
	   * @param {string} scaleType
	   * @return {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
	   */
	  getAxesByScale: function (scaleType) {
	    var axes = [];
	    var angleAxis = this._angleAxis;
	    var radiusAxis = this._radiusAxis;
	    angleAxis.scale.type === scaleType && axes.push(angleAxis);
	    radiusAxis.scale.type === scaleType && axes.push(radiusAxis);
	    return axes;
	  },
	
	  /**
	   * @return {module:echarts/coord/polar/AngleAxis}
	   */
	  getAngleAxis: function () {
	    return this._angleAxis;
	  },
	
	  /**
	   * @return {module:echarts/coord/polar/RadiusAxis}
	   */
	  getRadiusAxis: function () {
	    return this._radiusAxis;
	  },
	
	  /**
	   * @param {module:echarts/coord/polar/Axis}
	   * @return {module:echarts/coord/polar/Axis}
	   */
	  getOtherAxis: function (axis) {
	    var angleAxis = this._angleAxis;
	    return axis === angleAxis ? this._radiusAxis : angleAxis;
	  },
	
	  /**
	   * Base axis will be used on stacking.
	   *
	   * @return {module:echarts/coord/polar/Axis}
	   */
	  getBaseAxis: function () {
	    return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAngleAxis();
	  },
	
	  /**
	   * @param {string} [dim] 'radius' or 'angle' or 'auto' or null/undefined
	   * @return {Object} {baseAxes: [], otherAxes: []}
	   */
	  getTooltipAxes: function (dim) {
	    var baseAxis = dim != null && dim !== 'auto' ? this.getAxis(dim) : this.getBaseAxis();
	    return {
	      baseAxes: [baseAxis],
	      otherAxes: [this.getOtherAxis(baseAxis)]
	    };
	  },
	
	  /**
	   * Convert a single data item to (x, y) point.
	   * Parameter data is an array which the first element is radius and the second is angle
	   * @param {Array.<number>} data
	   * @param {boolean} [clamp=false]
	   * @return {Array.<number>}
	   */
	  dataToPoint: function (data, clamp) {
	    return this.coordToPoint([this._radiusAxis.dataToRadius(data[0], clamp), this._angleAxis.dataToAngle(data[1], clamp)]);
	  },
	
	  /**
	   * Convert a (x, y) point to data
	   * @param {Array.<number>} point
	   * @param {boolean} [clamp=false]
	   * @return {Array.<number>}
	   */
	  pointToData: function (point, clamp) {
	    var coord = this.pointToCoord(point);
	    return [this._radiusAxis.radiusToData(coord[0], clamp), this._angleAxis.angleToData(coord[1], clamp)];
	  },
	
	  /**
	   * Convert a (x, y) point to (radius, angle) coord
	   * @param {Array.<number>} point
	   * @return {Array.<number>}
	   */
	  pointToCoord: function (point) {
	    var dx = point[0] - this.cx;
	    var dy = point[1] - this.cy;
	    var angleAxis = this.getAngleAxis();
	    var extent = angleAxis.getExtent();
	    var minAngle = Math.min(extent[0], extent[1]);
	    var maxAngle = Math.max(extent[0], extent[1]); // Fix fixed extent in polarCreator
	    // FIXME
	
	    angleAxis.inverse ? minAngle = maxAngle - 360 : maxAngle = minAngle + 360;
	    var radius = Math.sqrt(dx * dx + dy * dy);
	    dx /= radius;
	    dy /= radius;
	    var radian = Math.atan2(-dy, dx) / Math.PI * 180; // move to angleExtent
	
	    var dir = radian < minAngle ? 1 : -1;
	
	    while (radian < minAngle || radian > maxAngle) {
	      radian += dir * 360;
	    }
	
	    return [radius, radian];
	  },
	
	  /**
	   * Convert a (radius, angle) coord to (x, y) point
	   * @param {Array.<number>} coord
	   * @return {Array.<number>}
	   */
	  coordToPoint: function (coord) {
	    var radius = coord[0];
	    var radian = coord[1] / 180 * Math.PI;
	    var x = Math.cos(radian) * radius + this.cx; // Inverse the y
	
	    var y = -Math.sin(radian) * radius + this.cy;
	    return [x, y];
	  },
	
	  /**
	   * Get ring area of cartesian.
	   * Area will have a contain function to determine if a point is in the coordinate system.
	   * @return {Ring}
	   */
	  getArea: function () {
	    var angleAxis = this.getAngleAxis();
	    var radiusAxis = this.getRadiusAxis();
	    var radiusExtent = radiusAxis.getExtent().slice();
	    radiusExtent[0] > radiusExtent[1] && radiusExtent.reverse();
	    var angleExtent = angleAxis.getExtent();
	    var RADIAN = Math.PI / 180;
	    return {
	      cx: this.cx,
	      cy: this.cy,
	      r0: radiusExtent[0],
	      r: radiusExtent[1],
	      startAngle: -angleExtent[0] * RADIAN,
	      endAngle: -angleExtent[1] * RADIAN,
	      clockwise: angleAxis.inverse,
	      contain: function (x, y) {
	        // It's a ring shape.
	        // Start angle and end angle don't matter
	        var dx = x - this.cx;
	        var dy = y - this.cy;
	        var d2 = dx * dx + dy * dy;
	        var r = this.r;
	        var r0 = this.r0;
	        return d2 <= r * r && d2 >= r0 * r0;
	      }
	    };
	  }
	};
	var _default = Polar;
	module.exports = _default;

/***/ },
/* 1677 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	__webpack_require__(1675);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentModel({
	  type: 'polar',
	  dependencies: ['polarAxis', 'angleAxis'],
	
	  /**
	   * @type {module:echarts/coord/polar/Polar}
	   */
	  coordinateSystem: null,
	
	  /**
	   * @param {string} axisType
	   * @return {module:echarts/coord/polar/AxisModel}
	   */
	  findAxisModel: function (axisType) {
	    var foundAxisModel;
	    var ecModel = this.ecModel;
	    ecModel.eachComponent(axisType, function (axisModel) {
	      if (axisModel.getCoordSysModel() === this) {
	        foundAxisModel = axisModel;
	      }
	    }, this);
	    return foundAxisModel;
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 0,
	    center: ['50%', '50%'],
	    radius: '80%'
	  }
	});
	
	module.exports = _default;

/***/ },
/* 1678 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var Axis = __webpack_require__(140);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function RadiusAxis(scale, radiusExtent) {
	  Axis.call(this, 'radius', scale, radiusExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = 'category';
	}
	
	RadiusAxis.prototype = {
	  constructor: RadiusAxis,
	
	  /**
	   * @override
	   */
	  pointToData: function (point, clamp) {
	    return this.polar.pointToData(point, clamp)[this.dim === 'radius' ? 0 : 1];
	  },
	  dataToRadius: Axis.prototype.dataToCoord,
	  radiusToData: Axis.prototype.coordToData
	};
	zrUtil.inherits(RadiusAxis, Axis);
	var _default = RadiusAxis;
	module.exports = _default;

/***/ },
/* 1679 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function dataToCoordSize(dataSize, dataItem) {
	  // dataItem is necessary in log axis.
	  return zrUtil.map(['Radius', 'Angle'], function (dim, dimIdx) {
	    var axis = this['get' + dim + 'Axis']();
	    var val = dataItem[dimIdx];
	    var halfSize = dataSize[dimIdx] / 2;
	    var method = 'dataTo' + dim;
	    var result = axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis[method](val - halfSize) - axis[method](val + halfSize));
	
	    if (dim === 'Angle') {
	      result = result * Math.PI / 180;
	    }
	
	    return result;
	  }, this);
	}
	
	function _default(coordSys) {
	  var radiusAxis = coordSys.getRadiusAxis();
	  var angleAxis = coordSys.getAngleAxis();
	  var radius = radiusAxis.getExtent();
	  radius[0] > radius[1] && radius.reverse();
	  return {
	    coordSys: {
	      type: 'polar',
	      cx: coordSys.cx,
	      cy: coordSys.cy,
	      r: radius[1],
	      r0: radius[0]
	    },
	    api: {
	      coord: zrUtil.bind(function (data) {
	        var radius = radiusAxis.dataToRadius(data[0]);
	        var angle = angleAxis.dataToAngle(data[1]);
	        var coord = coordSys.coordToPoint([radius, angle]);
	        coord.push(radius, angle * Math.PI / 180);
	        return coord;
	      }),
	      size: zrUtil.bind(dataToCoordSize, coordSys)
	    }
	  };
	}
	
	module.exports = _default;

/***/ },
/* 1680 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var Axis = __webpack_require__(140);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function IndicatorAxis(dim, scale, radiusExtent) {
	  Axis.call(this, dim, scale, radiusExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = 'value';
	  this.angle = 0;
	  /**
	   * Indicator name
	   * @type {string}
	   */
	
	  this.name = '';
	  /**
	   * @type {module:echarts/model/Model}
	   */
	
	  this.model;
	}
	
	zrUtil.inherits(IndicatorAxis, Axis);
	var _default = IndicatorAxis;
	module.exports = _default;

/***/ },
/* 1681 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var IndicatorAxis = __webpack_require__(1680);
	
	var IntervalScale = __webpack_require__(338);
	
	var numberUtil = __webpack_require__(20);
	
	var _axisHelper = __webpack_require__(93);
	
	var getScaleExtent = _axisHelper.getScaleExtent;
	var niceScaleExtent = _axisHelper.niceScaleExtent;
	
	var CoordinateSystem = __webpack_require__(92);
	
	var LogScale = __webpack_require__(751);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// TODO clockwise
	function Radar(radarModel, ecModel, api) {
	  this._model = radarModel;
	  /**
	   * Radar dimensions
	   * @type {Array.<string>}
	   */
	
	  this.dimensions = [];
	  this._indicatorAxes = zrUtil.map(radarModel.getIndicatorModels(), function (indicatorModel, idx) {
	    var dim = 'indicator_' + idx;
	    var indicatorAxis = new IndicatorAxis(dim, indicatorModel.get('axisType') === 'log' ? new LogScale() : new IntervalScale());
	    indicatorAxis.name = indicatorModel.get('name'); // Inject model and axis
	
	    indicatorAxis.model = indicatorModel;
	    indicatorModel.axis = indicatorAxis;
	    this.dimensions.push(dim);
	    return indicatorAxis;
	  }, this);
	  this.resize(radarModel, api);
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.cx;
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.cy;
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.r;
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.r0;
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.startAngle;
	}
	
	Radar.prototype.getIndicatorAxes = function () {
	  return this._indicatorAxes;
	};
	
	Radar.prototype.dataToPoint = function (value, indicatorIndex) {
	  var indicatorAxis = this._indicatorAxes[indicatorIndex];
	  return this.coordToPoint(indicatorAxis.dataToCoord(value), indicatorIndex);
	};
	
	Radar.prototype.coordToPoint = function (coord, indicatorIndex) {
	  var indicatorAxis = this._indicatorAxes[indicatorIndex];
	  var angle = indicatorAxis.angle;
	  var x = this.cx + coord * Math.cos(angle);
	  var y = this.cy - coord * Math.sin(angle);
	  return [x, y];
	};
	
	Radar.prototype.pointToData = function (pt) {
	  var dx = pt[0] - this.cx;
	  var dy = pt[1] - this.cy;
	  var radius = Math.sqrt(dx * dx + dy * dy);
	  dx /= radius;
	  dy /= radius;
	  var radian = Math.atan2(-dy, dx); // Find the closest angle
	  // FIXME index can calculated directly
	
	  var minRadianDiff = Infinity;
	  var closestAxis;
	  var closestAxisIdx = -1;
	
	  for (var i = 0; i < this._indicatorAxes.length; i++) {
	    var indicatorAxis = this._indicatorAxes[i];
	    var diff = Math.abs(radian - indicatorAxis.angle);
	
	    if (diff < minRadianDiff) {
	      closestAxis = indicatorAxis;
	      closestAxisIdx = i;
	      minRadianDiff = diff;
	    }
	  }
	
	  return [closestAxisIdx, +(closestAxis && closestAxis.coordToData(radius))];
	};
	
	Radar.prototype.resize = function (radarModel, api) {
	  var center = radarModel.get('center');
	  var viewWidth = api.getWidth();
	  var viewHeight = api.getHeight();
	  var viewSize = Math.min(viewWidth, viewHeight) / 2;
	  this.cx = numberUtil.parsePercent(center[0], viewWidth);
	  this.cy = numberUtil.parsePercent(center[1], viewHeight);
	  this.startAngle = radarModel.get('startAngle') * Math.PI / 180; // radius may be single value like `20`, `'80%'`, or array like `[10, '80%']`
	
	  var radius = radarModel.get('radius');
	
	  if (typeof radius === 'string' || typeof radius === 'number') {
	    radius = [0, radius];
	  }
	
	  this.r0 = numberUtil.parsePercent(radius[0], viewSize);
	  this.r = numberUtil.parsePercent(radius[1], viewSize);
	  zrUtil.each(this._indicatorAxes, function (indicatorAxis, idx) {
	    indicatorAxis.setExtent(this.r0, this.r);
	    var angle = this.startAngle + idx * Math.PI * 2 / this._indicatorAxes.length; // Normalize to [-PI, PI]
	
	    angle = Math.atan2(Math.sin(angle), Math.cos(angle));
	    indicatorAxis.angle = angle;
	  }, this);
	};
	
	Radar.prototype.update = function (ecModel, api) {
	  var indicatorAxes = this._indicatorAxes;
	  var radarModel = this._model;
	  zrUtil.each(indicatorAxes, function (indicatorAxis) {
	    indicatorAxis.scale.setExtent(Infinity, -Infinity);
	  });
	  ecModel.eachSeriesByType('radar', function (radarSeries, idx) {
	    if (radarSeries.get('coordinateSystem') !== 'radar' || ecModel.getComponent('radar', radarSeries.get('radarIndex')) !== radarModel) {
	      return;
	    }
	
	    var data = radarSeries.getData();
	    zrUtil.each(indicatorAxes, function (indicatorAxis) {
	      indicatorAxis.scale.unionExtentFromData(data, data.mapDimension(indicatorAxis.dim));
	    });
	  }, this);
	  var splitNumber = radarModel.get('splitNumber');
	
	  function increaseInterval(interval) {
	    var exp10 = Math.pow(10, Math.floor(Math.log(interval) / Math.LN10)); // Increase interval
	
	    var f = interval / exp10;
	
	    if (f === 2) {
	      f = 5;
	    } else {
	      // f is 2 or 5
	      f *= 2;
	    }
	
	    return f * exp10;
	  } // Force all the axis fixing the maxSplitNumber.
	
	
	  zrUtil.each(indicatorAxes, function (indicatorAxis, idx) {
	    var rawExtent = getScaleExtent(indicatorAxis.scale, indicatorAxis.model).extent;
	    niceScaleExtent(indicatorAxis.scale, indicatorAxis.model);
	    var axisModel = indicatorAxis.model;
	    var scale = indicatorAxis.scale;
	    var fixedMin = axisModel.getMin();
	    var fixedMax = axisModel.getMax();
	    var interval = scale.getInterval();
	
	    if (fixedMin != null && fixedMax != null) {
	      // User set min, max, divide to get new interval
	      scale.setExtent(+fixedMin, +fixedMax);
	      scale.setInterval((fixedMax - fixedMin) / splitNumber);
	    } else if (fixedMin != null) {
	      var max; // User set min, expand extent on the other side
	
	      do {
	        max = fixedMin + interval * splitNumber;
	        scale.setExtent(+fixedMin, max); // Interval must been set after extent
	        // FIXME
	
	        scale.setInterval(interval);
	        interval = increaseInterval(interval);
	      } while (max < rawExtent[1] && isFinite(max) && isFinite(rawExtent[1]));
	    } else if (fixedMax != null) {
	      var min; // User set min, expand extent on the other side
	
	      do {
	        min = fixedMax - interval * splitNumber;
	        scale.setExtent(min, +fixedMax);
	        scale.setInterval(interval);
	        interval = increaseInterval(interval);
	      } while (min > rawExtent[0] && isFinite(min) && isFinite(rawExtent[0]));
	    } else {
	      var nicedSplitNumber = scale.getTicks().length - 1;
	
	      if (nicedSplitNumber > splitNumber) {
	        interval = increaseInterval(interval);
	      } // TODO
	
	
	      var max = Math.ceil(rawExtent[1] / interval) * interval;
	      var min = numberUtil.round(max - interval * splitNumber);
	      scale.setExtent(min, max);
	      scale.setInterval(interval);
	    }
	  });
	};
	/**
	 * Radar dimensions is based on the data
	 * @type {Array}
	 */
	
	
	Radar.dimensions = [];
	
	Radar.create = function (ecModel, api) {
	  var radarList = [];
	  ecModel.eachComponent('radar', function (radarModel) {
	    var radar = new Radar(radarModel, ecModel, api);
	    radarList.push(radar);
	    radarModel.coordinateSystem = radar;
	  });
	  ecModel.eachSeriesByType('radar', function (radarSeries) {
	    if (radarSeries.get('coordinateSystem') === 'radar') {
	      // Inject coordinate system
	      radarSeries.coordinateSystem = radarList[radarSeries.get('radarIndex') || 0];
	    }
	  });
	  return radarList;
	};
	
	CoordinateSystem.register('radar', Radar);
	var _default = Radar;
	module.exports = _default;

/***/ },
/* 1682 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(13);
	
	var zrUtil = __webpack_require__(3);
	
	var axisDefault = __webpack_require__(737);
	
	var Model = __webpack_require__(48);
	
	var axisModelCommonMixin = __webpack_require__(206);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var valueAxisDefault = axisDefault.valueAxis;
	
	function defaultsShow(opt, show) {
	  return zrUtil.defaults({
	    show: show
	  }, opt);
	}
	
	var RadarModel = echarts.extendComponentModel({
	  type: 'radar',
	  optionUpdated: function () {
	    var boundaryGap = this.get('boundaryGap');
	    var splitNumber = this.get('splitNumber');
	    var scale = this.get('scale');
	    var axisLine = this.get('axisLine');
	    var axisTick = this.get('axisTick');
	    var axisType = this.get('axisType');
	    var axisLabel = this.get('axisLabel');
	    var nameTextStyle = this.get('name');
	    var showName = this.get('name.show');
	    var nameFormatter = this.get('name.formatter');
	    var nameGap = this.get('nameGap');
	    var triggerEvent = this.get('triggerEvent');
	    var indicatorModels = zrUtil.map(this.get('indicator') || [], function (indicatorOpt) {
	      // PENDING
	      if (indicatorOpt.max != null && indicatorOpt.max > 0 && !indicatorOpt.min) {
	        indicatorOpt.min = 0;
	      } else if (indicatorOpt.min != null && indicatorOpt.min < 0 && !indicatorOpt.max) {
	        indicatorOpt.max = 0;
	      }
	
	      var iNameTextStyle = nameTextStyle;
	
	      if (indicatorOpt.color != null) {
	        iNameTextStyle = zrUtil.defaults({
	          color: indicatorOpt.color
	        }, nameTextStyle);
	      } // Use same configuration
	
	
	      indicatorOpt = zrUtil.merge(zrUtil.clone(indicatorOpt), {
	        boundaryGap: boundaryGap,
	        splitNumber: splitNumber,
	        scale: scale,
	        axisLine: axisLine,
	        axisTick: axisTick,
	        axisType: axisType,
	        axisLabel: axisLabel,
	        // Compatible with 2 and use text
	        name: indicatorOpt.text,
	        nameLocation: 'end',
	        nameGap: nameGap,
	        // min: 0,
	        nameTextStyle: iNameTextStyle,
	        triggerEvent: triggerEvent
	      }, false);
	
	      if (!showName) {
	        indicatorOpt.name = '';
	      }
	
	      if (typeof nameFormatter === 'string') {
	        var indName = indicatorOpt.name;
	        indicatorOpt.name = nameFormatter.replace('{value}', indName != null ? indName : '');
	      } else if (typeof nameFormatter === 'function') {
	        indicatorOpt.name = nameFormatter(indicatorOpt.name, indicatorOpt);
	      }
	
	      var model = zrUtil.extend(new Model(indicatorOpt, null, this.ecModel), axisModelCommonMixin); // For triggerEvent.
	
	      model.mainType = 'radar';
	      model.componentIndex = this.componentIndex;
	      return model;
	    }, this);
	
	    this.getIndicatorModels = function () {
	      return indicatorModels;
	    };
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 0,
	    center: ['50%', '50%'],
	    radius: '75%',
	    startAngle: 90,
	    name: {
	      show: true // formatter: null
	      // textStyle: {}
	
	    },
	    boundaryGap: [0, 0],
	    splitNumber: 5,
	    nameGap: 15,
	    scale: false,
	    // Polygon or circle
	    shape: 'polygon',
	    axisLine: zrUtil.merge({
	      lineStyle: {
	        color: '#bbb'
	      }
	    }, valueAxisDefault.axisLine),
	    axisLabel: defaultsShow(valueAxisDefault.axisLabel, false),
	    axisTick: defaultsShow(valueAxisDefault.axisTick, false),
	    axisType: 'interval',
	    splitLine: defaultsShow(valueAxisDefault.splitLine, true),
	    splitArea: defaultsShow(valueAxisDefault.splitArea, true),
	    // {text, min, max}
	    indicator: []
	  }
	});
	var _default = RadarModel;
	module.exports = _default;

/***/ },
/* 1683 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var ComponentModel = __webpack_require__(57);
	
	var axisModelCreator = __webpack_require__(335);
	
	var axisModelCommonMixin = __webpack_require__(206);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var AxisModel = ComponentModel.extend({
	  type: 'singleAxis',
	  layoutMode: 'box',
	
	  /**
	   * @type {module:echarts/coord/single/SingleAxis}
	   */
	  axis: null,
	
	  /**
	   * @type {module:echarts/coord/single/Single}
	   */
	  coordinateSystem: null,
	
	  /**
	   * @override
	   */
	  getCoordSysModel: function () {
	    return this;
	  }
	});
	var defaultOption = {
	  left: '5%',
	  top: '5%',
	  right: '5%',
	  bottom: '5%',
	  type: 'value',
	  position: 'bottom',
	  orient: 'horizontal',
	  axisLine: {
	    show: true,
	    lineStyle: {
	      width: 1,
	      type: 'solid'
	    }
	  },
	  // Single coordinate system and single axis is the,
	  // which is used as the parent tooltip model.
	  // same model, so we set default tooltip show as true.
	  tooltip: {
	    show: true
	  },
	  axisTick: {
	    show: true,
	    length: 6,
	    lineStyle: {
	      width: 1
	    }
	  },
	  axisLabel: {
	    show: true,
	    interval: 'auto'
	  },
	  splitLine: {
	    show: true,
	    lineStyle: {
	      type: 'dashed',
	      opacity: 0.2
	    }
	  }
	};
	
	function getAxisType(axisName, option) {
	  return option.type || (option.data ? 'category' : 'value');
	}
	
	zrUtil.merge(AxisModel.prototype, axisModelCommonMixin);
	axisModelCreator('single', AxisModel, getAxisType, defaultOption);
	var _default = AxisModel;
	module.exports = _default;

/***/ },
/* 1684 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SingleAxis = __webpack_require__(1685);
	
	var axisHelper = __webpack_require__(93);
	
	var _layout = __webpack_require__(36);
	
	var getLayoutRect = _layout.getLayoutRect;
	
	var _util = __webpack_require__(3);
	
	var each = _util.each;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Single coordinates system.
	 */
	
	/**
	 * Create a single coordinates system.
	 *
	 * @param {module:echarts/coord/single/AxisModel} axisModel
	 * @param {module:echarts/model/Global} ecModel
	 * @param {module:echarts/ExtensionAPI} api
	 */
	function Single(axisModel, ecModel, api) {
	  /**
	   * @type {string}
	   * @readOnly
	   */
	  this.dimension = 'single';
	  /**
	   * Add it just for draw tooltip.
	   *
	   * @type {Array.<string>}
	   * @readOnly
	   */
	
	  this.dimensions = ['single'];
	  /**
	   * @private
	   * @type {module:echarts/coord/single/SingleAxis}.
	   */
	
	  this._axis = null;
	  /**
	   * @private
	   * @type {module:zrender/core/BoundingRect}
	   */
	
	  this._rect;
	
	  this._init(axisModel, ecModel, api);
	  /**
	   * @type {module:echarts/coord/single/AxisModel}
	   */
	
	
	  this.model = axisModel;
	}
	
	Single.prototype = {
	  type: 'singleAxis',
	  axisPointerEnabled: true,
	  constructor: Single,
	
	  /**
	   * Initialize single coordinate system.
	   *
	   * @param  {module:echarts/coord/single/AxisModel} axisModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @private
	   */
	  _init: function (axisModel, ecModel, api) {
	    var dim = this.dimension;
	    var axis = new SingleAxis(dim, axisHelper.createScaleByModel(axisModel), [0, 0], axisModel.get('type'), axisModel.get('position'));
	    var isCategory = axis.type === 'category';
	    axis.onBand = isCategory && axisModel.get('boundaryGap');
	    axis.inverse = axisModel.get('inverse');
	    axis.orient = axisModel.get('orient');
	    axisModel.axis = axis;
	    axis.model = axisModel;
	    axis.coordinateSystem = this;
	    this._axis = axis;
	  },
	
	  /**
	   * Update axis scale after data processed
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  update: function (ecModel, api) {
	    ecModel.eachSeries(function (seriesModel) {
	      if (seriesModel.coordinateSystem === this) {
	        var data = seriesModel.getData();
	        each(data.mapDimension(this.dimension, true), function (dim) {
	          this._axis.scale.unionExtentFromData(data, dim);
	        }, this);
	        axisHelper.niceScaleExtent(this._axis.scale, this._axis.model);
	      }
	    }, this);
	  },
	
	  /**
	   * Resize the single coordinate system.
	   *
	   * @param  {module:echarts/coord/single/AxisModel} axisModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  resize: function (axisModel, api) {
	    this._rect = getLayoutRect({
	      left: axisModel.get('left'),
	      top: axisModel.get('top'),
	      right: axisModel.get('right'),
	      bottom: axisModel.get('bottom'),
	      width: axisModel.get('width'),
	      height: axisModel.get('height')
	    }, {
	      width: api.getWidth(),
	      height: api.getHeight()
	    });
	
	    this._adjustAxis();
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getRect: function () {
	    return this._rect;
	  },
	
	  /**
	   * @private
	   */
	  _adjustAxis: function () {
	    var rect = this._rect;
	    var axis = this._axis;
	    var isHorizontal = axis.isHorizontal();
	    var extent = isHorizontal ? [0, rect.width] : [0, rect.height];
	    var idx = axis.reverse ? 1 : 0;
	    axis.setExtent(extent[idx], extent[1 - idx]);
	
	    this._updateAxisTransform(axis, isHorizontal ? rect.x : rect.y);
	  },
	
	  /**
	   * @param  {module:echarts/coord/single/SingleAxis} axis
	   * @param  {number} coordBase
	   */
	  _updateAxisTransform: function (axis, coordBase) {
	    var axisExtent = axis.getExtent();
	    var extentSum = axisExtent[0] + axisExtent[1];
	    var isHorizontal = axis.isHorizontal();
	    axis.toGlobalCoord = isHorizontal ? function (coord) {
	      return coord + coordBase;
	    } : function (coord) {
	      return extentSum - coord + coordBase;
	    };
	    axis.toLocalCoord = isHorizontal ? function (coord) {
	      return coord - coordBase;
	    } : function (coord) {
	      return extentSum - coord + coordBase;
	    };
	  },
	
	  /**
	   * Get axis.
	   *
	   * @return {module:echarts/coord/single/SingleAxis}
	   */
	  getAxis: function () {
	    return this._axis;
	  },
	
	  /**
	   * Get axis, add it just for draw tooltip.
	   *
	   * @return {[type]} [description]
	   */
	  getBaseAxis: function () {
	    return this._axis;
	  },
	
	  /**
	   * @return {Array.<module:echarts/coord/Axis>}
	   */
	  getAxes: function () {
	    return [this._axis];
	  },
	
	  /**
	   * @return {Object} {baseAxes: [], otherAxes: []}
	   */
	  getTooltipAxes: function () {
	    return {
	      baseAxes: [this.getAxis()]
	    };
	  },
	
	  /**
	   * If contain point.
	   *
	   * @param  {Array.<number>} point
	   * @return {boolean}
	   */
	  containPoint: function (point) {
	    var rect = this.getRect();
	    var axis = this.getAxis();
	    var orient = axis.orient;
	
	    if (orient === 'horizontal') {
	      return axis.contain(axis.toLocalCoord(point[0])) && point[1] >= rect.y && point[1] <= rect.y + rect.height;
	    } else {
	      return axis.contain(axis.toLocalCoord(point[1])) && point[0] >= rect.y && point[0] <= rect.y + rect.height;
	    }
	  },
	
	  /**
	   * @param {Array.<number>} point
	   * @return {Array.<number>}
	   */
	  pointToData: function (point) {
	    var axis = this.getAxis();
	    return [axis.coordToData(axis.toLocalCoord(point[axis.orient === 'horizontal' ? 0 : 1]))];
	  },
	
	  /**
	   * Convert the series data to concrete point.
	   *
	   * @param  {number|Array.<number>} val
	   * @return {Array.<number>}
	   */
	  dataToPoint: function (val) {
	    var axis = this.getAxis();
	    var rect = this.getRect();
	    var pt = [];
	    var idx = axis.orient === 'horizontal' ? 0 : 1;
	
	    if (val instanceof Array) {
	      val = val[0];
	    }
	
	    pt[idx] = axis.toGlobalCoord(axis.dataToCoord(+val));
	    pt[1 - idx] = idx === 0 ? rect.y + rect.height / 2 : rect.x + rect.width / 2;
	    return pt;
	  }
	};
	var _default = Single;
	module.exports = _default;

/***/ },
/* 1685 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var Axis = __webpack_require__(140);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @constructor  module:echarts/coord/single/SingleAxis
	 * @extends {module:echarts/coord/Axis}
	 * @param {string} dim
	 * @param {*} scale
	 * @param {Array.<number>} coordExtent
	 * @param {string} axisType
	 * @param {string} position
	 */
	var SingleAxis = function (dim, scale, coordExtent, axisType, position) {
	  Axis.call(this, dim, scale, coordExtent);
	  /**
	   * Axis type
	   * - 'category'
	   * - 'value'
	   * - 'time'
	   * - 'log'
	   * @type {string}
	   */
	
	  this.type = axisType || 'value';
	  /**
	   * Axis position
	   *  - 'top'
	   *  - 'bottom'
	   *  - 'left'
	   *  - 'right'
	   *  @type {string}
	   */
	
	  this.position = position || 'bottom';
	  /**
	   * Axis orient
	   *  - 'horizontal'
	   *  - 'vertical'
	   * @type {[type]}
	   */
	
	  this.orient = null;
	};
	
	SingleAxis.prototype = {
	  constructor: SingleAxis,
	
	  /**
	   * Axis model
	   * @type {module:echarts/coord/single/AxisModel}
	   */
	  model: null,
	
	  /**
	   * Judge the orient of the axis.
	   * @return {boolean}
	   */
	  isHorizontal: function () {
	    var position = this.position;
	    return position === 'top' || position === 'bottom';
	  },
	
	  /**
	   * @override
	   */
	  pointToData: function (point, clamp) {
	    return this.coordinateSystem.pointToData(point, clamp)[0];
	  },
	
	  /**
	   * Convert the local coord(processed by dataToCoord())
	   * to global coord(concrete pixel coord).
	   * designated by module:echarts/coord/single/Single.
	   * @type {Function}
	   */
	  toGlobalCoord: null,
	
	  /**
	   * Convert the global coord to local coord.
	   * designated by module:echarts/coord/single/Single.
	   * @type {Function}
	   */
	  toLocalCoord: null
	};
	zrUtil.inherits(SingleAxis, Axis);
	var _default = SingleAxis;
	module.exports = _default;

/***/ },
/* 1686 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function dataToCoordSize(dataSize, dataItem) {
	  // dataItem is necessary in log axis.
	  var axis = this.getAxis();
	  var val = dataItem instanceof Array ? dataItem[0] : dataItem;
	  var halfSize = (dataSize instanceof Array ? dataSize[0] : dataSize) / 2;
	  return axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
	}
	
	function _default(coordSys) {
	  var rect = coordSys.getRect();
	  return {
	    coordSys: {
	      type: 'singleAxis',
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height
	    },
	    api: {
	      coord: function (val) {
	        // do not provide "out" param
	        return coordSys.dataToPoint(val);
	      },
	      size: zrUtil.bind(dataToCoordSize, coordSys)
	    }
	  };
	}
	
	module.exports = _default;

/***/ },
/* 1687 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Single = __webpack_require__(1684);
	
	var CoordinateSystem = __webpack_require__(92);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Single coordinate system creator.
	 */
	
	/**
	 * Create single coordinate system and inject it into seriesModel.
	 *
	 * @param {module:echarts/model/Global} ecModel
	 * @param {module:echarts/ExtensionAPI} api
	 * @return {Array.<module:echarts/coord/single/Single>}
	 */
	function create(ecModel, api) {
	  var singles = [];
	  ecModel.eachComponent('singleAxis', function (axisModel, idx) {
	    var single = new Single(axisModel, ecModel, api);
	    single.name = 'single_' + idx;
	    single.resize(axisModel, api);
	    axisModel.coordinateSystem = single;
	    singles.push(single);
	  });
	  ecModel.eachSeries(function (seriesModel) {
	    if (seriesModel.get('coordinateSystem') === 'singleAxis') {
	      var singleAxisModel = ecModel.queryComponents({
	        mainType: 'singleAxis',
	        index: seriesModel.get('singleAxisIndex'),
	        id: seriesModel.get('singleAxisId')
	      })[0];
	      seriesModel.coordinateSystem = singleAxisModel && singleAxisModel.coordinateSystem;
	    }
	  });
	  return singles;
	}
	
	CoordinateSystem.register('single', {
	  create: create,
	  dimensions: Single.prototype.dimensions
	});

/***/ },
/* 1688 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(3);
	
	var _clazz = __webpack_require__(124);
	
	var enableClassCheck = _clazz.enableClassCheck;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// id may be function name of Object, add a prefix to avoid this problem.
	function generateNodeKey(id) {
	  return '_EC_' + id;
	}
	/**
	 * @alias module:echarts/data/Graph
	 * @constructor
	 * @param {boolean} directed
	 */
	
	
	var Graph = function (directed) {
	  /**
	   * 是否是有向图
	   * @type {boolean}
	   * @private
	   */
	  this._directed = directed || false;
	  /**
	   * @type {Array.<module:echarts/data/Graph.Node>}
	   * @readOnly
	   */
	
	  this.nodes = [];
	  /**
	   * @type {Array.<module:echarts/data/Graph.Edge>}
	   * @readOnly
	   */
	
	  this.edges = [];
	  /**
	   * @type {Object.<string, module:echarts/data/Graph.Node>}
	   * @private
	   */
	
	  this._nodesMap = {};
	  /**
	   * @type {Object.<string, module:echarts/data/Graph.Edge>}
	   * @private
	   */
	
	  this._edgesMap = {};
	  /**
	   * @type {module:echarts/data/List}
	   * @readOnly
	   */
	
	  this.data;
	  /**
	   * @type {module:echarts/data/List}
	   * @readOnly
	   */
	
	  this.edgeData;
	};
	
	var graphProto = Graph.prototype;
	/**
	 * @type {string}
	 */
	
	graphProto.type = 'graph';
	/**
	 * If is directed graph
	 * @return {boolean}
	 */
	
	graphProto.isDirected = function () {
	  return this._directed;
	};
	/**
	 * Add a new node
	 * @param {string} id
	 * @param {number} [dataIndex]
	 */
	
	
	graphProto.addNode = function (id, dataIndex) {
	  id = id == null ? '' + dataIndex : '' + id;
	  var nodesMap = this._nodesMap;
	
	  if (nodesMap[generateNodeKey(id)]) {
	    return;
	  }
	
	  var node = new Node(id, dataIndex);
	  node.hostGraph = this;
	  this.nodes.push(node);
	  nodesMap[generateNodeKey(id)] = node;
	  return node;
	};
	/**
	 * Get node by data index
	 * @param  {number} dataIndex
	 * @return {module:echarts/data/Graph~Node}
	 */
	
	
	graphProto.getNodeByIndex = function (dataIndex) {
	  var rawIdx = this.data.getRawIndex(dataIndex);
	  return this.nodes[rawIdx];
	};
	/**
	 * Get node by id
	 * @param  {string} id
	 * @return {module:echarts/data/Graph.Node}
	 */
	
	
	graphProto.getNodeById = function (id) {
	  return this._nodesMap[generateNodeKey(id)];
	};
	/**
	 * Add a new edge
	 * @param {number|string|module:echarts/data/Graph.Node} n1
	 * @param {number|string|module:echarts/data/Graph.Node} n2
	 * @param {number} [dataIndex=-1]
	 * @return {module:echarts/data/Graph.Edge}
	 */
	
	
	graphProto.addEdge = function (n1, n2, dataIndex) {
	  var nodesMap = this._nodesMap;
	  var edgesMap = this._edgesMap; // PNEDING
	
	  if (typeof n1 === 'number') {
	    n1 = this.nodes[n1];
	  }
	
	  if (typeof n2 === 'number') {
	    n2 = this.nodes[n2];
	  }
	
	  if (!Node.isInstance(n1)) {
	    n1 = nodesMap[generateNodeKey(n1)];
	  }
	
	  if (!Node.isInstance(n2)) {
	    n2 = nodesMap[generateNodeKey(n2)];
	  }
	
	  if (!n1 || !n2) {
	    return;
	  }
	
	  var key = n1.id + '-' + n2.id;
	  var edge = new Edge(n1, n2, dataIndex);
	  edge.hostGraph = this;
	
	  if (this._directed) {
	    n1.outEdges.push(edge);
	    n2.inEdges.push(edge);
	  }
	
	  n1.edges.push(edge);
	
	  if (n1 !== n2) {
	    n2.edges.push(edge);
	  }
	
	  this.edges.push(edge);
	  edgesMap[key] = edge;
	  return edge;
	};
	/**
	 * Get edge by data index
	 * @param  {number} dataIndex
	 * @return {module:echarts/data/Graph~Node}
	 */
	
	
	graphProto.getEdgeByIndex = function (dataIndex) {
	  var rawIdx = this.edgeData.getRawIndex(dataIndex);
	  return this.edges[rawIdx];
	};
	/**
	 * Get edge by two linked nodes
	 * @param  {module:echarts/data/Graph.Node|string} n1
	 * @param  {module:echarts/data/Graph.Node|string} n2
	 * @return {module:echarts/data/Graph.Edge}
	 */
	
	
	graphProto.getEdge = function (n1, n2) {
	  if (Node.isInstance(n1)) {
	    n1 = n1.id;
	  }
	
	  if (Node.isInstance(n2)) {
	    n2 = n2.id;
	  }
	
	  var edgesMap = this._edgesMap;
	
	  if (this._directed) {
	    return edgesMap[n1 + '-' + n2];
	  } else {
	    return edgesMap[n1 + '-' + n2] || edgesMap[n2 + '-' + n1];
	  }
	};
	/**
	 * Iterate all nodes
	 * @param  {Function} cb
	 * @param  {*} [context]
	 */
	
	
	graphProto.eachNode = function (cb, context) {
	  var nodes = this.nodes;
	  var len = nodes.length;
	
	  for (var i = 0; i < len; i++) {
	    if (nodes[i].dataIndex >= 0) {
	      cb.call(context, nodes[i], i);
	    }
	  }
	};
	/**
	 * Iterate all edges
	 * @param  {Function} cb
	 * @param  {*} [context]
	 */
	
	
	graphProto.eachEdge = function (cb, context) {
	  var edges = this.edges;
	  var len = edges.length;
	
	  for (var i = 0; i < len; i++) {
	    if (edges[i].dataIndex >= 0 && edges[i].node1.dataIndex >= 0 && edges[i].node2.dataIndex >= 0) {
	      cb.call(context, edges[i], i);
	    }
	  }
	};
	/**
	 * Breadth first traverse
	 * @param {Function} cb
	 * @param {module:echarts/data/Graph.Node} startNode
	 * @param {string} [direction='none'] 'none'|'in'|'out'
	 * @param {*} [context]
	 */
	
	
	graphProto.breadthFirstTraverse = function (cb, startNode, direction, context) {
	  if (!Node.isInstance(startNode)) {
	    startNode = this._nodesMap[generateNodeKey(startNode)];
	  }
	
	  if (!startNode) {
	    return;
	  }
	
	  var edgeType = direction === 'out' ? 'outEdges' : direction === 'in' ? 'inEdges' : 'edges';
	
	  for (var i = 0; i < this.nodes.length; i++) {
	    this.nodes[i].__visited = false;
	  }
	
	  if (cb.call(context, startNode, null)) {
	    return;
	  }
	
	  var queue = [startNode];
	
	  while (queue.length) {
	    var currentNode = queue.shift();
	    var edges = currentNode[edgeType];
	
	    for (var i = 0; i < edges.length; i++) {
	      var e = edges[i];
	      var otherNode = e.node1 === currentNode ? e.node2 : e.node1;
	
	      if (!otherNode.__visited) {
	        if (cb.call(context, otherNode, currentNode)) {
	          // Stop traversing
	          return;
	        }
	
	        queue.push(otherNode);
	        otherNode.__visited = true;
	      }
	    }
	  }
	}; // TODO
	// graphProto.depthFirstTraverse = function (
	//     cb, startNode, direction, context
	// ) {
	// };
	// Filter update
	
	
	graphProto.update = function () {
	  var data = this.data;
	  var edgeData = this.edgeData;
	  var nodes = this.nodes;
	  var edges = this.edges;
	
	  for (var i = 0, len = nodes.length; i < len; i++) {
	    nodes[i].dataIndex = -1;
	  }
	
	  for (var i = 0, len = data.count(); i < len; i++) {
	    nodes[data.getRawIndex(i)].dataIndex = i;
	  }
	
	  edgeData.filterSelf(function (idx) {
	    var edge = edges[edgeData.getRawIndex(idx)];
	    return edge.node1.dataIndex >= 0 && edge.node2.dataIndex >= 0;
	  }); // Update edge
	
	  for (var i = 0, len = edges.length; i < len; i++) {
	    edges[i].dataIndex = -1;
	  }
	
	  for (var i = 0, len = edgeData.count(); i < len; i++) {
	    edges[edgeData.getRawIndex(i)].dataIndex = i;
	  }
	};
	/**
	 * @return {module:echarts/data/Graph}
	 */
	
	
	graphProto.clone = function () {
	  var graph = new Graph(this._directed);
	  var nodes = this.nodes;
	  var edges = this.edges;
	
	  for (var i = 0; i < nodes.length; i++) {
	    graph.addNode(nodes[i].id, nodes[i].dataIndex);
	  }
	
	  for (var i = 0; i < edges.length; i++) {
	    var e = edges[i];
	    graph.addEdge(e.node1.id, e.node2.id, e.dataIndex);
	  }
	
	  return graph;
	};
	/**
	 * @alias module:echarts/data/Graph.Node
	 */
	
	
	function Node(id, dataIndex) {
	  /**
	  * @type {string}
	  */
	  this.id = id == null ? '' : id;
	  /**
	  * @type {Array.<module:echarts/data/Graph.Edge>}
	  */
	
	  this.inEdges = [];
	  /**
	  * @type {Array.<module:echarts/data/Graph.Edge>}
	  */
	
	  this.outEdges = [];
	  /**
	  * @type {Array.<module:echarts/data/Graph.Edge>}
	  */
	
	  this.edges = [];
	  /**
	   * @type {module:echarts/data/Graph}
	   */
	
	  this.hostGraph;
	  /**
	   * @type {number}
	   */
	
	  this.dataIndex = dataIndex == null ? -1 : dataIndex;
	}
	
	Node.prototype = {
	  constructor: Node,
	
	  /**
	   * @return {number}
	   */
	  degree: function () {
	    return this.edges.length;
	  },
	
	  /**
	   * @return {number}
	   */
	  inDegree: function () {
	    return this.inEdges.length;
	  },
	
	  /**
	  * @return {number}
	  */
	  outDegree: function () {
	    return this.outEdges.length;
	  },
	
	  /**
	   * @param {string} [path]
	   * @return {module:echarts/model/Model}
	   */
	  getModel: function (path) {
	    if (this.dataIndex < 0) {
	      return;
	    }
	
	    var graph = this.hostGraph;
	    var itemModel = graph.data.getItemModel(this.dataIndex);
	    return itemModel.getModel(path);
	  }
	};
	/**
	 * 图边
	 * @alias module:echarts/data/Graph.Edge
	 * @param {module:echarts/data/Graph.Node} n1
	 * @param {module:echarts/data/Graph.Node} n2
	 * @param {number} [dataIndex=-1]
	 */
	
	function Edge(n1, n2, dataIndex) {
	  /**
	   * 节点1，如果是有向图则为源节点
	   * @type {module:echarts/data/Graph.Node}
	   */
	  this.node1 = n1;
	  /**
	   * 节点2，如果是有向图则为目标节点
	   * @type {module:echarts/data/Graph.Node}
	   */
	
	  this.node2 = n2;
	  this.dataIndex = dataIndex == null ? -1 : dataIndex;
	}
	/**
	 * @param {string} [path]
	 * @return {module:echarts/model/Model}
	 */
	
	
	Edge.prototype.getModel = function (path) {
	  if (this.dataIndex < 0) {
	    return;
	  }
	
	  var graph = this.hostGraph;
	  var itemModel = graph.edgeData.getItemModel(this.dataIndex);
	  return itemModel.getModel(path);
	};
	
	var createGraphDataProxyMixin = function (hostName, dataName) {
	  return {
	    /**
	     * @param {string=} [dimension='value'] Default 'value'. can be 'a', 'b', 'c', 'd', 'e'.
	     * @return {number}
	     */
	    getValue: function (dimension) {
	      var data = this[hostName][dataName];
	      return data.get(data.getDimension(dimension || 'value'), this.dataIndex);
	    },
	
	    /**
	     * @param {Object|string} key
	     * @param {*} [value]
	     */
	    setVisual: function (key, value) {
	      this.dataIndex >= 0 && this[hostName][dataName].setItemVisual(this.dataIndex, key, value);
	    },
	
	    /**
	     * @param {string} key
	     * @return {boolean}
	     */
	    getVisual: function (key, ignoreParent) {
	      return this[hostName][dataName].getItemVisual(this.dataIndex, key, ignoreParent);
	    },
	
	    /**
	     * @param {Object} layout
	     * @return {boolean} [merge=false]
	     */
	    setLayout: function (layout, merge) {
	      this.dataIndex >= 0 && this[hostName][dataName].setItemLayout(this.dataIndex, layout, merge);
	    },
	
	    /**
	     * @return {Object}
	     */
	    getLayout: function () {
	      return this[hostName][dataName].getItemLayout(this.dataIndex);
	    },
	
	    /**
	     * @return {module:zrender/Element}
	     */
	    getGraphicEl: function () {
	      return this[hostName][dataName].getItemGraphicEl(this.dataIndex);
	    },
	
	    /**
	     * @return {number}
	     */
	    getRawIndex: function () {
	      return this[hostName][dataName].getRawIndex(this.dataIndex);
	    }
	  };
	};
	
	zrUtil.mixin(Node, createGraphDataProxyMixin('hostGraph', 'data'));
	zrUtil.mixin(Edge, createGraphDataProxyMixin('hostGraph', 'edgeData'));
	Graph.Node = Node;
	Graph.Edge = Edge;
	enableClassCheck(Node);
	enableClassCheck(Edge);
	var _default = Graph;
	module.exports = _default;

/***/ },
/* 1689 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var createListFromArray = __webpack_require__(122);
	
	var axisHelper = __webpack_require__(93);
	
	var axisModelCommonMixin = __webpack_require__(206);
	
	var Model = __webpack_require__(48);
	
	var _layout = __webpack_require__(36);
	
	var getLayoutRect = _layout.getLayoutRect;
	exports.getLayoutRect = _layout.getLayoutRect;
	
	var _dataStackHelper = __webpack_require__(105);
	
	var enableDataStack = _dataStackHelper.enableDataStack;
	var isDimensionStacked = _dataStackHelper.isDimensionStacked;
	var getStackedDimension = _dataStackHelper.getStackedDimension;
	
	var _completeDimensions = __webpack_require__(746);
	
	exports.completeDimensions = _completeDimensions;
	
	var _createDimensions = __webpack_require__(207);
	
	exports.createDimensions = _createDimensions;
	
	var _symbol = __webpack_require__(84);
	
	exports.createSymbol = _symbol.createSymbol;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// import createGraphFromNodeEdge from './chart/helper/createGraphFromNodeEdge';
	
	/**
	 * Create a muti dimension List structure from seriesModel.
	 * @param  {module:echarts/model/Model} seriesModel
	 * @return {module:echarts/data/List} list
	 */
	function createList(seriesModel) {
	  return createListFromArray(seriesModel.getSource(), seriesModel);
	} // export function createGraph(seriesModel) {
	//     var nodes = seriesModel.get('data');
	//     var links = seriesModel.get('links');
	//     return createGraphFromNodeEdge(nodes, links, seriesModel);
	// }
	
	
	var dataStack = {
	  isDimensionStacked: isDimensionStacked,
	  enableDataStack: enableDataStack,
	  getStackedDimension: getStackedDimension
	};
	/**
	 * Create a symbol element with given symbol configuration: shape, x, y, width, height, color
	 * @param {string} symbolDesc
	 * @param {number} x
	 * @param {number} y
	 * @param {number} w
	 * @param {number} h
	 * @param {string} color
	 */
	
	/**
	 * Create scale
	 * @param {Array.<number>} dataExtent
	 * @param {Object|module:echarts/Model} option
	 */
	function createScale(dataExtent, option) {
	  var axisModel = option;
	
	  if (!Model.isInstance(option)) {
	    axisModel = new Model(option);
	    zrUtil.mixin(axisModel, axisModelCommonMixin);
	  }
	
	  var scale = axisHelper.createScaleByModel(axisModel);
	  scale.setExtent(dataExtent[0], dataExtent[1]);
	  axisHelper.niceScaleExtent(scale, axisModel);
	  return scale;
	}
	/**
	 * Mixin common methods to axis model,
	 *
	 * Inlcude methods
	 * `getFormattedLabels() => Array.<string>`
	 * `getCategories() => Array.<string>`
	 * `getMin(origin: boolean) => number`
	 * `getMax(origin: boolean) => number`
	 * `getNeedCrossZero() => boolean`
	 * `setRange(start: number, end: number)`
	 * `resetRange()`
	 */
	
	
	function mixinAxisModelCommonMethods(Model) {
	  zrUtil.mixin(Model, axisModelCommonMixin);
	}
	
	exports.createList = createList;
	exports.dataStack = dataStack;
	exports.createScale = createScale;
	exports.mixinAxisModelCommonMethods = mixinAxisModelCommonMethods;

/***/ },
/* 1690 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var _number = __webpack_require__(20);
	
	var parsePercent = _number.parsePercent;
	
	var _dataStackHelper = __webpack_require__(105);
	
	var isDimensionStacked = _dataStackHelper.isDimensionStacked;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function getSeriesStackId(seriesModel) {
	  return seriesModel.get('stack') || '__ec_stack_' + seriesModel.seriesIndex;
	}
	
	function getAxisKey(polar, axis) {
	  return axis.dim + polar.model.componentIndex;
	}
	/**
	 * @param {string} seriesType
	 * @param {module:echarts/model/Global} ecModel
	 * @param {module:echarts/ExtensionAPI} api
	 */
	
	
	function barLayoutPolar(seriesType, ecModel, api) {
	  var lastStackCoords = {};
	  var barWidthAndOffset = calRadialBar(zrUtil.filter(ecModel.getSeriesByType(seriesType), function (seriesModel) {
	    return !ecModel.isSeriesFiltered(seriesModel) && seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'polar';
	  }));
	  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
	    // Check series coordinate, do layout for polar only
	    if (seriesModel.coordinateSystem.type !== 'polar') {
	      return;
	    }
	
	    var data = seriesModel.getData();
	    var polar = seriesModel.coordinateSystem;
	    var baseAxis = polar.getBaseAxis();
	    var axisKey = getAxisKey(polar, baseAxis);
	    var stackId = getSeriesStackId(seriesModel);
	    var columnLayoutInfo = barWidthAndOffset[axisKey][stackId];
	    var columnOffset = columnLayoutInfo.offset;
	    var columnWidth = columnLayoutInfo.width;
	    var valueAxis = polar.getOtherAxis(baseAxis);
	    var cx = seriesModel.coordinateSystem.cx;
	    var cy = seriesModel.coordinateSystem.cy;
	    var barMinHeight = seriesModel.get('barMinHeight') || 0;
	    var barMinAngle = seriesModel.get('barMinAngle') || 0;
	    lastStackCoords[stackId] = lastStackCoords[stackId] || [];
	    var valueDim = data.mapDimension(valueAxis.dim);
	    var baseDim = data.mapDimension(baseAxis.dim);
	    var stacked = isDimensionStacked(data, valueDim
	    /*, baseDim*/
	    );
	    var clampLayout = baseAxis.dim !== 'radius' || !seriesModel.get('roundCap', true);
	    var valueAxisStart = valueAxis.dim === 'radius' ? valueAxis.dataToRadius(0) : valueAxis.dataToAngle(0);
	
	    for (var idx = 0, len = data.count(); idx < len; idx++) {
	      var value = data.get(valueDim, idx);
	      var baseValue = data.get(baseDim, idx);
	      var sign = value >= 0 ? 'p' : 'n';
	      var baseCoord = valueAxisStart; // Because of the barMinHeight, we can not use the value in
	      // stackResultDimension directly.
	      // Only ordinal axis can be stacked.
	
	      if (stacked) {
	        if (!lastStackCoords[stackId][baseValue]) {
	          lastStackCoords[stackId][baseValue] = {
	            p: valueAxisStart,
	            // Positive stack
	            n: valueAxisStart // Negative stack
	
	          };
	        } // Should also consider #4243
	
	
	        baseCoord = lastStackCoords[stackId][baseValue][sign];
	      }
	
	      var r0;
	      var r;
	      var startAngle;
	      var endAngle; // radial sector
	
	      if (valueAxis.dim === 'radius') {
	        var radiusSpan = valueAxis.dataToRadius(value) - valueAxisStart;
	        var angle = baseAxis.dataToAngle(baseValue);
	
	        if (Math.abs(radiusSpan) < barMinHeight) {
	          radiusSpan = (radiusSpan < 0 ? -1 : 1) * barMinHeight;
	        }
	
	        r0 = baseCoord;
	        r = baseCoord + radiusSpan;
	        startAngle = angle - columnOffset;
	        endAngle = startAngle - columnWidth;
	        stacked && (lastStackCoords[stackId][baseValue][sign] = r);
	      } // tangential sector
	      else {
	          var angleSpan = valueAxis.dataToAngle(value, clampLayout) - valueAxisStart;
	          var radius = baseAxis.dataToRadius(baseValue);
	
	          if (Math.abs(angleSpan) < barMinAngle) {
	            angleSpan = (angleSpan < 0 ? -1 : 1) * barMinAngle;
	          }
	
	          r0 = radius + columnOffset;
	          r = r0 + columnWidth;
	          startAngle = baseCoord;
	          endAngle = baseCoord + angleSpan; // if the previous stack is at the end of the ring,
	          // add a round to differentiate it from origin
	          // var extent = angleAxis.getExtent();
	          // var stackCoord = angle;
	          // if (stackCoord === extent[0] && value > 0) {
	          //     stackCoord = extent[1];
	          // }
	          // else if (stackCoord === extent[1] && value < 0) {
	          //     stackCoord = extent[0];
	          // }
	
	          stacked && (lastStackCoords[stackId][baseValue][sign] = endAngle);
	        }
	
	      data.setItemLayout(idx, {
	        cx: cx,
	        cy: cy,
	        r0: r0,
	        r: r,
	        // Consider that positive angle is anti-clockwise,
	        // while positive radian of sector is clockwise
	        startAngle: -startAngle * Math.PI / 180,
	        endAngle: -endAngle * Math.PI / 180
	      });
	    }
	  }, this);
	}
	/**
	 * Calculate bar width and offset for radial bar charts
	 */
	
	
	function calRadialBar(barSeries, api) {
	  // Columns info on each category axis. Key is polar name
	  var columnsMap = {};
	  zrUtil.each(barSeries, function (seriesModel, idx) {
	    var data = seriesModel.getData();
	    var polar = seriesModel.coordinateSystem;
	    var baseAxis = polar.getBaseAxis();
	    var axisKey = getAxisKey(polar, baseAxis);
	    var axisExtent = baseAxis.getExtent();
	    var bandWidth = baseAxis.type === 'category' ? baseAxis.getBandWidth() : Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
	    var columnsOnAxis = columnsMap[axisKey] || {
	      bandWidth: bandWidth,
	      remainedWidth: bandWidth,
	      autoWidthCount: 0,
	      categoryGap: '20%',
	      gap: '30%',
	      stacks: {}
	    };
	    var stacks = columnsOnAxis.stacks;
	    columnsMap[axisKey] = columnsOnAxis;
	    var stackId = getSeriesStackId(seriesModel);
	
	    if (!stacks[stackId]) {
	      columnsOnAxis.autoWidthCount++;
	    }
	
	    stacks[stackId] = stacks[stackId] || {
	      width: 0,
	      maxWidth: 0
	    };
	    var barWidth = parsePercent(seriesModel.get('barWidth'), bandWidth);
	    var barMaxWidth = parsePercent(seriesModel.get('barMaxWidth'), bandWidth);
	    var barGap = seriesModel.get('barGap');
	    var barCategoryGap = seriesModel.get('barCategoryGap');
	
	    if (barWidth && !stacks[stackId].width) {
	      barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
	      stacks[stackId].width = barWidth;
	      columnsOnAxis.remainedWidth -= barWidth;
	    }
	
	    barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
	    barGap != null && (columnsOnAxis.gap = barGap);
	    barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
	  });
	  var result = {};
	  zrUtil.each(columnsMap, function (columnsOnAxis, coordSysName) {
	    result[coordSysName] = {};
	    var stacks = columnsOnAxis.stacks;
	    var bandWidth = columnsOnAxis.bandWidth;
	    var categoryGap = parsePercent(columnsOnAxis.categoryGap, bandWidth);
	    var barGapPercent = parsePercent(columnsOnAxis.gap, 1);
	    var remainedWidth = columnsOnAxis.remainedWidth;
	    var autoWidthCount = columnsOnAxis.autoWidthCount;
	    var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
	    autoWidth = Math.max(autoWidth, 0); // Find if any auto calculated bar exceeded maxBarWidth
	
	    zrUtil.each(stacks, function (column, stack) {
	      var maxWidth = column.maxWidth;
	
	      if (maxWidth && maxWidth < autoWidth) {
	        maxWidth = Math.min(maxWidth, remainedWidth);
	
	        if (column.width) {
	          maxWidth = Math.min(maxWidth, column.width);
	        }
	
	        remainedWidth -= maxWidth;
	        column.width = maxWidth;
	        autoWidthCount--;
	      }
	    }); // Recalculate width again
	
	    autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
	    autoWidth = Math.max(autoWidth, 0);
	    var widthSum = 0;
	    var lastColumn;
	    zrUtil.each(stacks, function (column, idx) {
	      if (!column.width) {
	        column.width = autoWidth;
	      }
	
	      lastColumn = column;
	      widthSum += column.width * (1 + barGapPercent);
	    });
	
	    if (lastColumn) {
	      widthSum -= lastColumn.width * barGapPercent;
	    }
	
	    var offset = -widthSum / 2;
	    zrUtil.each(stacks, function (column, stackId) {
	      result[coordSysName][stackId] = result[coordSysName][stackId] || {
	        offset: offset,
	        width: column.width
	      };
	      offset += column.width * (1 + barGapPercent);
	    });
	  });
	  return result;
	}
	
	var _default = barLayoutPolar;
	module.exports = _default;

/***/ },
/* 1691 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var graphic = __webpack_require__(16);
	
	var textContain = __webpack_require__(79);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PI = Math.PI;
	/**
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {Object} [opts]
	 * @param {string} [opts.text]
	 * @param {string} [opts.color]
	 * @param {string} [opts.textColor]
	 * @return {module:zrender/Element}
	 */
	
	function _default(api, opts) {
	  opts = opts || {};
	  zrUtil.defaults(opts, {
	    text: 'loading',
	    textColor: '#000',
	    fontSize: '12px',
	    maskColor: 'rgba(255, 255, 255, 0.8)',
	    showSpinner: true,
	    color: '#c23531',
	    spinnerRadius: 10,
	    lineWidth: 5,
	    zlevel: 0
	  });
	  var group = new graphic.Group();
	  var mask = new graphic.Rect({
	    style: {
	      fill: opts.maskColor
	    },
	    zlevel: opts.zlevel,
	    z: 10000
	  });
	  group.add(mask);
	  var font = opts.fontSize + ' sans-serif';
	  var labelRect = new graphic.Rect({
	    style: {
	      fill: 'none',
	      text: opts.text,
	      font: font,
	      textPosition: 'right',
	      textDistance: 10,
	      textFill: opts.textColor
	    },
	    zlevel: opts.zlevel,
	    z: 10001
	  });
	  group.add(labelRect);
	
	  if (opts.showSpinner) {
	    var arc = new graphic.Arc({
	      shape: {
	        startAngle: -PI / 2,
	        endAngle: -PI / 2 + 0.1,
	        r: opts.spinnerRadius
	      },
	      style: {
	        stroke: opts.color,
	        lineCap: 'round',
	        lineWidth: opts.lineWidth
	      },
	      zlevel: opts.zlevel,
	      z: 10001
	    });
	    arc.animateShape(true).when(1000, {
	      endAngle: PI * 3 / 2
	    }).start('circularInOut');
	    arc.animateShape(true).when(1000, {
	      startAngle: PI * 3 / 2
	    }).delay(300).start('circularInOut');
	    group.add(arc);
	  } // Inject resize
	
	
	  group.resize = function () {
	    var textWidth = textContain.getWidth(opts.text, font);
	    var r = opts.showSpinner ? opts.spinnerRadius : 0; // cx = (containerWidth - arcDiameter - textDistance - textWidth) / 2
	    // textDistance needs to be calculated when both animation and text exist
	
	    var cx = (api.getWidth() - r * 2 - (opts.showSpinner && textWidth ? 10 : 0) - textWidth) / 2 // only show the text
	    - (opts.showSpinner ? 0 : textWidth / 2);
	    var cy = api.getHeight() / 2;
	    opts.showSpinner && arc.setShape({
	      cx: cx,
	      cy: cy
	    });
	    labelRect.setShape({
	      x: cx - r,
	      y: cy - r,
	      width: r * 2,
	      height: r * 2
	    });
	    mask.setShape({
	      x: 0,
	      y: 0,
	      width: api.getWidth(),
	      height: api.getHeight()
	    });
	  };
	
	  group.resize();
	  return group;
	}
	
	module.exports = _default;

/***/ },
/* 1692 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var modelUtil = __webpack_require__(24);
	
	var ComponentModel = __webpack_require__(57);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * ECharts option manager
	 *
	 * @module {echarts/model/OptionManager}
	 */
	var each = zrUtil.each;
	var clone = zrUtil.clone;
	var map = zrUtil.map;
	var merge = zrUtil.merge;
	var QUERY_REG = /^(min|max)?(.+)$/;
	/**
	 * TERM EXPLANATIONS:
	 *
	 * [option]:
	 *
	 *     An object that contains definitions of components. For example:
	 *     var option = {
	 *         title: {...},
	 *         legend: {...},
	 *         visualMap: {...},
	 *         series: [
	 *             {data: [...]},
	 *             {data: [...]},
	 *             ...
	 *         ]
	 *     };
	 *
	 * [rawOption]:
	 *
	 *     An object input to echarts.setOption. 'rawOption' may be an
	 *     'option', or may be an object contains multi-options. For example:
	 *     var option = {
	 *         baseOption: {
	 *             title: {...},
	 *             legend: {...},
	 *             series: [
	 *                 {data: [...]},
	 *                 {data: [...]},
	 *                 ...
	 *             ]
	 *         },
	 *         timeline: {...},
	 *         options: [
	 *             {title: {...}, series: {data: [...]}},
	 *             {title: {...}, series: {data: [...]}},
	 *             ...
	 *         ],
	 *         media: [
	 *             {
	 *                 query: {maxWidth: 320},
	 *                 option: {series: {x: 20}, visualMap: {show: false}}
	 *             },
	 *             {
	 *                 query: {minWidth: 320, maxWidth: 720},
	 *                 option: {series: {x: 500}, visualMap: {show: true}}
	 *             },
	 *             {
	 *                 option: {series: {x: 1200}, visualMap: {show: true}}
	 *             }
	 *         ]
	 *     };
	 *
	 * @alias module:echarts/model/OptionManager
	 * @param {module:echarts/ExtensionAPI} api
	 */
	
	function OptionManager(api) {
	  /**
	   * @private
	   * @type {module:echarts/ExtensionAPI}
	   */
	  this._api = api;
	  /**
	   * @private
	   * @type {Array.<number>}
	   */
	
	  this._timelineOptions = [];
	  /**
	   * @private
	   * @type {Array.<Object>}
	   */
	
	  this._mediaList = [];
	  /**
	   * @private
	   * @type {Object}
	   */
	
	  this._mediaDefault;
	  /**
	   * -1, means default.
	   * empty means no media.
	   * @private
	   * @type {Array.<number>}
	   */
	
	  this._currentMediaIndices = [];
	  /**
	   * @private
	   * @type {Object}
	   */
	
	  this._optionBackup;
	  /**
	   * @private
	   * @type {Object}
	   */
	
	  this._newBaseOption;
	} // timeline.notMerge is not supported in ec3. Firstly there is rearly
	// case that notMerge is needed. Secondly supporting 'notMerge' requires
	// rawOption cloned and backuped when timeline changed, which does no
	// good to performance. What's more, that both timeline and setOption
	// method supply 'notMerge' brings complex and some problems.
	// Consider this case:
	// (step1) chart.setOption({timeline: {notMerge: false}, ...}, false);
	// (step2) chart.setOption({timeline: {notMerge: true}, ...}, false);
	
	
	OptionManager.prototype = {
	  constructor: OptionManager,
	
	  /**
	   * @public
	   * @param {Object} rawOption Raw option.
	   * @param {module:echarts/model/Global} ecModel
	   * @param {Array.<Function>} optionPreprocessorFuncs
	   * @return {Object} Init option
	   */
	  setOption: function (rawOption, optionPreprocessorFuncs) {
	    if (rawOption) {
	      // That set dat primitive is dangerous if user reuse the data when setOption again.
	      zrUtil.each(modelUtil.normalizeToArray(rawOption.series), function (series) {
	        series && series.data && zrUtil.isTypedArray(series.data) && zrUtil.setAsPrimitive(series.data);
	      });
	    } // Caution: some series modify option data, if do not clone,
	    // it should ensure that the repeat modify correctly
	    // (create a new object when modify itself).
	
	
	    rawOption = clone(rawOption); // FIXME
	    // 如果 timeline options 或者 media 中设置了某个属性，而baseOption中没有设置，则进行警告。
	
	    var oldOptionBackup = this._optionBackup;
	    var newParsedOption = parseRawOption.call(this, rawOption, optionPreprocessorFuncs, !oldOptionBackup);
	    this._newBaseOption = newParsedOption.baseOption; // For setOption at second time (using merge mode);
	
	    if (oldOptionBackup) {
	      // Only baseOption can be merged.
	      mergeOption(oldOptionBackup.baseOption, newParsedOption.baseOption); // For simplicity, timeline options and media options do not support merge,
	      // that is, if you `setOption` twice and both has timeline options, the latter
	      // timeline opitons will not be merged to the formers, but just substitude them.
	
	      if (newParsedOption.timelineOptions.length) {
	        oldOptionBackup.timelineOptions = newParsedOption.timelineOptions;
	      }
	
	      if (newParsedOption.mediaList.length) {
	        oldOptionBackup.mediaList = newParsedOption.mediaList;
	      }
	
	      if (newParsedOption.mediaDefault) {
	        oldOptionBackup.mediaDefault = newParsedOption.mediaDefault;
	      }
	    } else {
	      this._optionBackup = newParsedOption;
	    }
	  },
	
	  /**
	   * @param {boolean} isRecreate
	   * @return {Object}
	   */
	  mountOption: function (isRecreate) {
	    var optionBackup = this._optionBackup; // TODO
	    // 如果没有reset功能则不clone。
	
	    this._timelineOptions = map(optionBackup.timelineOptions, clone);
	    this._mediaList = map(optionBackup.mediaList, clone);
	    this._mediaDefault = clone(optionBackup.mediaDefault);
	    this._currentMediaIndices = [];
	    return clone(isRecreate // this._optionBackup.baseOption, which is created at the first `setOption`
	    // called, and is merged into every new option by inner method `mergeOption`
	    // each time `setOption` called, can be only used in `isRecreate`, because
	    // its reliability is under suspicion. In other cases option merge is
	    // performed by `model.mergeOption`.
	    ? optionBackup.baseOption : this._newBaseOption);
	  },
	
	  /**
	   * @param {module:echarts/model/Global} ecModel
	   * @return {Object}
	   */
	  getTimelineOption: function (ecModel) {
	    var option;
	    var timelineOptions = this._timelineOptions;
	
	    if (timelineOptions.length) {
	      // getTimelineOption can only be called after ecModel inited,
	      // so we can get currentIndex from timelineModel.
	      var timelineModel = ecModel.getComponent('timeline');
	
	      if (timelineModel) {
	        option = clone(timelineOptions[timelineModel.getCurrentIndex()], true);
	      }
	    }
	
	    return option;
	  },
	
	  /**
	   * @param {module:echarts/model/Global} ecModel
	   * @return {Array.<Object>}
	   */
	  getMediaOption: function (ecModel) {
	    var ecWidth = this._api.getWidth();
	
	    var ecHeight = this._api.getHeight();
	
	    var mediaList = this._mediaList;
	    var mediaDefault = this._mediaDefault;
	    var indices = [];
	    var result = []; // No media defined.
	
	    if (!mediaList.length && !mediaDefault) {
	      return result;
	    } // Multi media may be applied, the latter defined media has higher priority.
	
	
	    for (var i = 0, len = mediaList.length; i < len; i++) {
	      if (applyMediaQuery(mediaList[i].query, ecWidth, ecHeight)) {
	        indices.push(i);
	      }
	    } // FIXME
	    // 是否mediaDefault应该强制用户设置，否则可能修改不能回归。
	
	
	    if (!indices.length && mediaDefault) {
	      indices = [-1];
	    }
	
	    if (indices.length && !indicesEquals(indices, this._currentMediaIndices)) {
	      result = map(indices, function (index) {
	        return clone(index === -1 ? mediaDefault.option : mediaList[index].option);
	      });
	    } // Otherwise return nothing.
	
	
	    this._currentMediaIndices = indices;
	    return result;
	  }
	};
	
	function parseRawOption(rawOption, optionPreprocessorFuncs, isNew) {
	  var timelineOptions = [];
	  var mediaList = [];
	  var mediaDefault;
	  var baseOption; // Compatible with ec2.
	
	  var timelineOpt = rawOption.timeline;
	
	  if (rawOption.baseOption) {
	    baseOption = rawOption.baseOption;
	  } // For timeline
	
	
	  if (timelineOpt || rawOption.options) {
	    baseOption = baseOption || {};
	    timelineOptions = (rawOption.options || []).slice();
	  } // For media query
	
	
	  if (rawOption.media) {
	    baseOption = baseOption || {};
	    var media = rawOption.media;
	    each(media, function (singleMedia) {
	      if (singleMedia && singleMedia.option) {
	        if (singleMedia.query) {
	          mediaList.push(singleMedia);
	        } else if (!mediaDefault) {
	          // Use the first media default.
	          mediaDefault = singleMedia;
	        }
	      }
	    });
	  } // For normal option
	
	
	  if (!baseOption) {
	    baseOption = rawOption;
	  } // Set timelineOpt to baseOption in ec3,
	  // which is convenient for merge option.
	
	
	  if (!baseOption.timeline) {
	    baseOption.timeline = timelineOpt;
	  } // Preprocess.
	
	
	  each([baseOption].concat(timelineOptions).concat(zrUtil.map(mediaList, function (media) {
	    return media.option;
	  })), function (option) {
	    each(optionPreprocessorFuncs, function (preProcess) {
	      preProcess(option, isNew);
	    });
	  });
	  return {
	    baseOption: baseOption,
	    timelineOptions: timelineOptions,
	    mediaDefault: mediaDefault,
	    mediaList: mediaList
	  };
	}
	/**
	 * @see <http://www.w3.org/TR/css3-mediaqueries/#media1>
	 * Support: width, height, aspectRatio
	 * Can use max or min as prefix.
	 */
	
	
	function applyMediaQuery(query, ecWidth, ecHeight) {
	  var realMap = {
	    width: ecWidth,
	    height: ecHeight,
	    aspectratio: ecWidth / ecHeight // lowser case for convenientce.
	
	  };
	  var applicatable = true;
	  zrUtil.each(query, function (value, attr) {
	    var matched = attr.match(QUERY_REG);
	
	    if (!matched || !matched[1] || !matched[2]) {
	      return;
	    }
	
	    var operator = matched[1];
	    var realAttr = matched[2].toLowerCase();
	
	    if (!compare(realMap[realAttr], value, operator)) {
	      applicatable = false;
	    }
	  });
	  return applicatable;
	}
	
	function compare(real, expect, operator) {
	  if (operator === 'min') {
	    return real >= expect;
	  } else if (operator === 'max') {
	    return real <= expect;
	  } else {
	    // Equals
	    return real === expect;
	  }
	}
	
	function indicesEquals(indices1, indices2) {
	  // indices is always order by asc and has only finite number.
	  return indices1.join(',') === indices2.join(',');
	}
	/**
	 * Consider case:
	 * `chart.setOption(opt1);`
	 * Then user do some interaction like dataZoom, dataView changing.
	 * `chart.setOption(opt2);`
	 * Then user press 'reset button' in toolbox.
	 *
	 * After doing that all of the interaction effects should be reset, the
	 * chart should be the same as the result of invoke
	 * `chart.setOption(opt1); chart.setOption(opt2);`.
	 *
	 * Although it is not able ensure that
	 * `chart.setOption(opt1); chart.setOption(opt2);` is equivalents to
	 * `chart.setOption(merge(opt1, opt2));` exactly,
	 * this might be the only simple way to implement that feature.
	 *
	 * MEMO: We've considered some other approaches:
	 * 1. Each model handle its self restoration but not uniform treatment.
	 *     (Too complex in logic and error-prone)
	 * 2. Use a shadow ecModel. (Performace expensive)
	 */
	
	
	function mergeOption(oldOption, newOption) {
	  newOption = newOption || {};
	  each(newOption, function (newCptOpt, mainType) {
	    if (newCptOpt == null) {
	      return;
	    }
	
	    var oldCptOpt = oldOption[mainType];
	
	    if (!ComponentModel.hasClass(mainType)) {
	      oldOption[mainType] = merge(oldCptOpt, newCptOpt, true);
	    } else {
	      newCptOpt = modelUtil.normalizeToArray(newCptOpt);
	      oldCptOpt = modelUtil.normalizeToArray(oldCptOpt);
	      var mapResult = modelUtil.mappingToExists(oldCptOpt, newCptOpt);
	      oldOption[mainType] = map(mapResult, function (item) {
	        return item.option && item.exist ? merge(item.exist, item.option, true) : item.exist || item.option;
	      });
	    }
	  });
	}
	
	var _default = OptionManager;
	module.exports = _default;

/***/ },
/* 1693 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var platform = ''; // Navigator not exists in node
	
	if (typeof navigator !== 'undefined') {
	  platform = navigator.platform || '';
	}
	
	var _default = {
	  // backgroundColor: 'rgba(0,0,0,0)',
	  // https://dribbble.com/shots/1065960-Infographic-Pie-chart-visualization
	  // color: ['#5793f3', '#d14a61', '#fd9c35', '#675bba', '#fec42c', '#dd4444', '#d4df5a', '#cd4870'],
	  // Light colors:
	  // color: ['#bcd3bb', '#e88f70', '#edc1a5', '#9dc5c8', '#e1e8c8', '#7b7c68', '#e5b5b5', '#f0b489', '#928ea8', '#bda29a'],
	  // color: ['#cc5664', '#9bd6ec', '#ea946e', '#8acaaa', '#f1ec64', '#ee8686', '#a48dc1', '#5da6bc', '#b9dcae'],
	  // Dark colors:
	  color: ['#c23531', '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'],
	  gradientColor: ['#f6efa6', '#d88273', '#bf444c'],
	  // If xAxis and yAxis declared, grid is created by default.
	  // grid: {},
	  textStyle: {
	    // color: '#000',
	    // decoration: 'none',
	    // PENDING
	    fontFamily: platform.match(/^Win/) ? 'Microsoft YaHei' : 'sans-serif',
	    // fontFamily: 'Arial, Verdana, sans-serif',
	    fontSize: 12,
	    fontStyle: 'normal',
	    fontWeight: 'normal'
	  },
	  // http://blogs.adobe.com/webplatform/2014/02/24/using-blend-modes-in-html-canvas/
	  // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
	  // Default is source-over
	  blendMode: null,
	  animation: 'auto',
	  animationDuration: 1000,
	  animationDurationUpdate: 300,
	  animationEasing: 'exponentialOut',
	  animationEasingUpdate: 'cubicOut',
	  animationThreshold: 2000,
	  // Configuration for progressive/incremental rendering
	  progressiveThreshold: 3000,
	  progressive: 400,
	  // Threshold of if use single hover layer to optimize.
	  // It is recommended that `hoverLayerThreshold` is equivalent to or less than
	  // `progressiveThreshold`, otherwise hover will cause restart of progressive,
	  // which is unexpected.
	  // see example <echarts/test/heatmap-large.html>.
	  hoverLayerThreshold: 3000,
	  // See: module:echarts/scale/Time
	  useUTC: false
	};
	module.exports = _default;

/***/ },
/* 1694 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var makeStyleMapper = __webpack_require__(208);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var getAreaStyle = makeStyleMapper([['fill', 'color'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['opacity'], ['shadowColor']]);
	var _default = {
	  getAreaStyle: function (excludes, includes) {
	    return getAreaStyle(this, excludes, includes);
	  }
	};
	module.exports = _default;

/***/ },
/* 1695 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = {
	  getBoxLayoutParams: function () {
	    return {
	      left: this.get('left'),
	      top: this.get('top'),
	      right: this.get('right'),
	      bottom: this.get('bottom'),
	      width: this.get('width'),
	      height: this.get('height')
	    };
	  }
	};
	module.exports = _default;

/***/ },
/* 1696 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var makeStyleMapper = __webpack_require__(208);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var getItemStyle = makeStyleMapper([['fill', 'color'], ['stroke', 'borderColor'], ['lineWidth', 'borderWidth'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor'], ['textPosition'], ['textAlign']]);
	var _default = {
	  getItemStyle: function (excludes, includes) {
	    var style = getItemStyle(this, excludes, includes);
	    var lineDash = this.getBorderLineDash();
	    lineDash && (style.lineDash = lineDash);
	    return style;
	  },
	  getBorderLineDash: function () {
	    var lineType = this.get('borderType');
	    return lineType === 'solid' || lineType == null ? null : lineType === 'dashed' ? [5, 5] : [1, 1];
	  }
	};
	module.exports = _default;

/***/ },
/* 1697 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var makeStyleMapper = __webpack_require__(208);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var getLineStyle = makeStyleMapper([['lineWidth', 'width'], ['stroke', 'color'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor']]);
	var _default = {
	  getLineStyle: function (excludes) {
	    var style = getLineStyle(this, excludes); // Always set lineDash whether dashed, otherwise we can not
	    // erase the previous style when assigning to el.style.
	
	    style.lineDash = this.getLineDash(style.lineWidth);
	    return style;
	  },
	  getLineDash: function (lineWidth) {
	    if (lineWidth == null) {
	      lineWidth = 1;
	    }
	
	    var lineType = this.get('type');
	    var dotSize = Math.max(lineWidth, 2);
	    var dashSize = lineWidth * 4;
	    return lineType === 'solid' || lineType == null ? // Use `false` but not `null` for the solid line here, because `null` might be
	    // ignored when assigning to `el.style`. e.g., when setting `lineStyle.type` as
	    // `'dashed'` and `emphasis.lineStyle.type` as `'solid'` in graph series, the
	    // `lineDash` gotten form the latter one is not able to erase that from the former
	    // one if using `null` here according to the emhpsis strategy in `util/graphic.js`.
	    false : lineType === 'dashed' ? [dashSize, dashSize] : [dotSize, dotSize];
	  }
	};
	module.exports = _default;

/***/ },
/* 1698 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var textContain = __webpack_require__(79);
	
	var graphicUtil = __webpack_require__(16);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PATH_COLOR = ['textStyle', 'color'];
	var _default = {
	  /**
	   * Get color property or get color from option.textStyle.color
	   * @param {boolean} [isEmphasis]
	   * @return {string}
	   */
	  getTextColor: function (isEmphasis) {
	    var ecModel = this.ecModel;
	    return this.getShallow('color') || (!isEmphasis && ecModel ? ecModel.get(PATH_COLOR) : null);
	  },
	
	  /**
	   * Create font string from fontStyle, fontWeight, fontSize, fontFamily
	   * @return {string}
	   */
	  getFont: function () {
	    return graphicUtil.getFont({
	      fontStyle: this.getShallow('fontStyle'),
	      fontWeight: this.getShallow('fontWeight'),
	      fontSize: this.getShallow('fontSize'),
	      fontFamily: this.getShallow('fontFamily')
	    }, this.ecModel);
	  },
	  getTextRect: function (text) {
	    return textContain.getBoundingRect(text, this.getFont(), this.getShallow('align'), this.getShallow('verticalAlign') || this.getShallow('baseline'), this.getShallow('padding'), this.getShallow('lineHeight'), this.getShallow('rich'), this.getShallow('truncateText'));
	  }
	};
	module.exports = _default;

/***/ },
/* 1699 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(27);
	
	var __DEV__ = _config.__DEV__;
	
	var _util = __webpack_require__(3);
	
	var createHashMap = _util.createHashMap;
	var retrieve = _util.retrieve;
	var each = _util.each;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Helper for model references.
	 * There are many manners to refer axis/coordSys.
	 */
	// TODO
	// merge relevant logic to this file?
	// check: "modelHelper" of tooltip and "BrushTargetManager".
	
	/**
	 * @class
	 * For example:
	 * {
	 *     coordSysName: 'cartesian2d',
	 *     coordSysDims: ['x', 'y', ...],
	 *     axisMap: HashMap({
	 *         x: xAxisModel,
	 *         y: yAxisModel
	 *     }),
	 *     categoryAxisMap: HashMap({
	 *         x: xAxisModel,
	 *         y: undefined
	 *     }),
	 *     // The index of the first category axis in `coordSysDims`.
	 *     // `null/undefined` means no category axis exists.
	 *     firstCategoryDimIndex: 1,
	 *     // To replace user specified encode.
	 * }
	 */
	function CoordSysInfo(coordSysName) {
	  /**
	   * @type {string}
	   */
	  this.coordSysName = coordSysName;
	  /**
	   * @type {Array.<string>}
	   */
	
	  this.coordSysDims = [];
	  /**
	   * @type {module:zrender/core/util#HashMap}
	   */
	
	  this.axisMap = createHashMap();
	  /**
	   * @type {module:zrender/core/util#HashMap}
	   */
	
	  this.categoryAxisMap = createHashMap();
	  /**
	   * @type {number}
	   */
	
	  this.firstCategoryDimIndex = null;
	}
	/**
	 * @return {module:model/referHelper#CoordSysInfo}
	 */
	
	
	function getCoordSysInfoBySeries(seriesModel) {
	  var coordSysName = seriesModel.get('coordinateSystem');
	  var result = new CoordSysInfo(coordSysName);
	  var fetch = fetchers[coordSysName];
	
	  if (fetch) {
	    fetch(seriesModel, result, result.axisMap, result.categoryAxisMap);
	    return result;
	  }
	}
	
	var fetchers = {
	  cartesian2d: function (seriesModel, result, axisMap, categoryAxisMap) {
	    var xAxisModel = seriesModel.getReferringComponents('xAxis')[0];
	    var yAxisModel = seriesModel.getReferringComponents('yAxis')[0];
	    result.coordSysDims = ['x', 'y'];
	    axisMap.set('x', xAxisModel);
	    axisMap.set('y', yAxisModel);
	
	    if (isCategory(xAxisModel)) {
	      categoryAxisMap.set('x', xAxisModel);
	      result.firstCategoryDimIndex = 0;
	    }
	
	    if (isCategory(yAxisModel)) {
	      categoryAxisMap.set('y', yAxisModel);
	      result.firstCategoryDimIndex == null & (result.firstCategoryDimIndex = 1);
	    }
	  },
	  singleAxis: function (seriesModel, result, axisMap, categoryAxisMap) {
	    var singleAxisModel = seriesModel.getReferringComponents('singleAxis')[0];
	    result.coordSysDims = ['single'];
	    axisMap.set('single', singleAxisModel);
	
	    if (isCategory(singleAxisModel)) {
	      categoryAxisMap.set('single', singleAxisModel);
	      result.firstCategoryDimIndex = 0;
	    }
	  },
	  polar: function (seriesModel, result, axisMap, categoryAxisMap) {
	    var polarModel = seriesModel.getReferringComponents('polar')[0];
	    var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
	    var angleAxisModel = polarModel.findAxisModel('angleAxis');
	    result.coordSysDims = ['radius', 'angle'];
	    axisMap.set('radius', radiusAxisModel);
	    axisMap.set('angle', angleAxisModel);
	
	    if (isCategory(radiusAxisModel)) {
	      categoryAxisMap.set('radius', radiusAxisModel);
	      result.firstCategoryDimIndex = 0;
	    }
	
	    if (isCategory(angleAxisModel)) {
	      categoryAxisMap.set('angle', angleAxisModel);
	      result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
	    }
	  },
	  geo: function (seriesModel, result, axisMap, categoryAxisMap) {
	    result.coordSysDims = ['lng', 'lat'];
	  },
	  parallel: function (seriesModel, result, axisMap, categoryAxisMap) {
	    var ecModel = seriesModel.ecModel;
	    var parallelModel = ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));
	    var coordSysDims = result.coordSysDims = parallelModel.dimensions.slice();
	    each(parallelModel.parallelAxisIndex, function (axisIndex, index) {
	      var axisModel = ecModel.getComponent('parallelAxis', axisIndex);
	      var axisDim = coordSysDims[index];
	      axisMap.set(axisDim, axisModel);
	
	      if (isCategory(axisModel) && result.firstCategoryDimIndex == null) {
	        categoryAxisMap.set(axisDim, axisModel);
	        result.firstCategoryDimIndex = index;
	      }
	    });
	  }
	};
	
	function isCategory(axisModel) {
	  return axisModel.get('type') === 'category';
	}
	
	exports.getCoordSysInfoBySeries = getCoordSysInfoBySeries;

/***/ },
/* 1700 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(3);
	
	var each = _util.each;
	var isArray = _util.isArray;
	var isObject = _util.isObject;
	
	var compatStyle = __webpack_require__(1701);
	
	var _model = __webpack_require__(24);
	
	var normalizeToArray = _model.normalizeToArray;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Compatitable with 2.0
	function get(opt, path) {
	  path = path.split(',');
	  var obj = opt;
	
	  for (var i = 0; i < path.length; i++) {
	    obj = obj && obj[path[i]];
	
	    if (obj == null) {
	      break;
	    }
	  }
	
	  return obj;
	}
	
	function set(opt, path, val, overwrite) {
	  path = path.split(',');
	  var obj = opt;
	  var key;
	
	  for (var i = 0; i < path.length - 1; i++) {
	    key = path[i];
	
	    if (obj[key] == null) {
	      obj[key] = {};
	    }
	
	    obj = obj[key];
	  }
	
	  if (overwrite || obj[path[i]] == null) {
	    obj[path[i]] = val;
	  }
	}
	
	function compatLayoutProperties(option) {
	  each(LAYOUT_PROPERTIES, function (prop) {
	    if (prop[0] in option && !(prop[1] in option)) {
	      option[prop[1]] = option[prop[0]];
	    }
	  });
	}
	
	var LAYOUT_PROPERTIES = [['x', 'left'], ['y', 'top'], ['x2', 'right'], ['y2', 'bottom']];
	var COMPATITABLE_COMPONENTS = ['grid', 'geo', 'parallel', 'legend', 'toolbox', 'title', 'visualMap', 'dataZoom', 'timeline'];
	
	function _default(option, isTheme) {
	  compatStyle(option, isTheme); // Make sure series array for model initialization.
	
	  option.series = normalizeToArray(option.series);
	  each(option.series, function (seriesOpt) {
	    if (!isObject(seriesOpt)) {
	      return;
	    }
	
	    var seriesType = seriesOpt.type;
	
	    if (seriesType === 'line') {
	      if (seriesOpt.clipOverflow != null) {
	        seriesOpt.clip = seriesOpt.clipOverflow;
	      }
	    } else if (seriesType === 'pie' || seriesType === 'gauge') {
	      if (seriesOpt.clockWise != null) {
	        seriesOpt.clockwise = seriesOpt.clockWise;
	      }
	    } else if (seriesType === 'gauge') {
	      var pointerColor = get(seriesOpt, 'pointer.color');
	      pointerColor != null && set(seriesOpt, 'itemStyle.color', pointerColor);
	    }
	
	    compatLayoutProperties(seriesOpt);
	  }); // dataRange has changed to visualMap
	
	  if (option.dataRange) {
	    option.visualMap = option.dataRange;
	  }
	
	  each(COMPATITABLE_COMPONENTS, function (componentName) {
	    var options = option[componentName];
	
	    if (options) {
	      if (!isArray(options)) {
	        options = [options];
	      }
	
	      each(options, function (option) {
	        compatLayoutProperties(option);
	      });
	    }
	  });
	}
	
	module.exports = _default;

/***/ },
/* 1701 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var modelUtil = __webpack_require__(24);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var isObject = zrUtil.isObject;
	var POSSIBLE_STYLES = ['areaStyle', 'lineStyle', 'nodeStyle', 'linkStyle', 'chordStyle', 'label', 'labelLine'];
	
	function compatEC2ItemStyle(opt) {
	  var itemStyleOpt = opt && opt.itemStyle;
	
	  if (!itemStyleOpt) {
	    return;
	  }
	
	  for (var i = 0, len = POSSIBLE_STYLES.length; i < len; i++) {
	    var styleName = POSSIBLE_STYLES[i];
	    var normalItemStyleOpt = itemStyleOpt.normal;
	    var emphasisItemStyleOpt = itemStyleOpt.emphasis;
	
	    if (normalItemStyleOpt && normalItemStyleOpt[styleName]) {
	      opt[styleName] = opt[styleName] || {};
	
	      if (!opt[styleName].normal) {
	        opt[styleName].normal = normalItemStyleOpt[styleName];
	      } else {
	        zrUtil.merge(opt[styleName].normal, normalItemStyleOpt[styleName]);
	      }
	
	      normalItemStyleOpt[styleName] = null;
	    }
	
	    if (emphasisItemStyleOpt && emphasisItemStyleOpt[styleName]) {
	      opt[styleName] = opt[styleName] || {};
	
	      if (!opt[styleName].emphasis) {
	        opt[styleName].emphasis = emphasisItemStyleOpt[styleName];
	      } else {
	        zrUtil.merge(opt[styleName].emphasis, emphasisItemStyleOpt[styleName]);
	      }
	
	      emphasisItemStyleOpt[styleName] = null;
	    }
	  }
	}
	
	function convertNormalEmphasis(opt, optType, useExtend) {
	  if (opt && opt[optType] && (opt[optType].normal || opt[optType].emphasis)) {
	    var normalOpt = opt[optType].normal;
	    var emphasisOpt = opt[optType].emphasis;
	
	    if (normalOpt) {
	      // Timeline controlStyle has other properties besides normal and emphasis
	      if (useExtend) {
	        opt[optType].normal = opt[optType].emphasis = null;
	        zrUtil.defaults(opt[optType], normalOpt);
	      } else {
	        opt[optType] = normalOpt;
	      }
	    }
	
	    if (emphasisOpt) {
	      opt.emphasis = opt.emphasis || {};
	      opt.emphasis[optType] = emphasisOpt;
	    }
	  }
	}
	
	function removeEC3NormalStatus(opt) {
	  convertNormalEmphasis(opt, 'itemStyle');
	  convertNormalEmphasis(opt, 'lineStyle');
	  convertNormalEmphasis(opt, 'areaStyle');
	  convertNormalEmphasis(opt, 'label');
	  convertNormalEmphasis(opt, 'labelLine'); // treemap
	
	  convertNormalEmphasis(opt, 'upperLabel'); // graph
	
	  convertNormalEmphasis(opt, 'edgeLabel');
	}
	
	function compatTextStyle(opt, propName) {
	  // Check whether is not object (string\null\undefined ...)
	  var labelOptSingle = isObject(opt) && opt[propName];
	  var textStyle = isObject(labelOptSingle) && labelOptSingle.textStyle;
	
	  if (textStyle) {
	    for (var i = 0, len = modelUtil.TEXT_STYLE_OPTIONS.length; i < len; i++) {
	      var propName = modelUtil.TEXT_STYLE_OPTIONS[i];
	
	      if (textStyle.hasOwnProperty(propName)) {
	        labelOptSingle[propName] = textStyle[propName];
	      }
	    }
	  }
	}
	
	function compatEC3CommonStyles(opt) {
	  if (opt) {
	    removeEC3NormalStatus(opt);
	    compatTextStyle(opt, 'label');
	    opt.emphasis && compatTextStyle(opt.emphasis, 'label');
	  }
	}
	
	function processSeries(seriesOpt) {
	  if (!isObject(seriesOpt)) {
	    return;
	  }
	
	  compatEC2ItemStyle(seriesOpt);
	  removeEC3NormalStatus(seriesOpt);
	  compatTextStyle(seriesOpt, 'label'); // treemap
	
	  compatTextStyle(seriesOpt, 'upperLabel'); // graph
	
	  compatTextStyle(seriesOpt, 'edgeLabel');
	
	  if (seriesOpt.emphasis) {
	    compatTextStyle(seriesOpt.emphasis, 'label'); // treemap
	
	    compatTextStyle(seriesOpt.emphasis, 'upperLabel'); // graph
	
	    compatTextStyle(seriesOpt.emphasis, 'edgeLabel');
	  }
	
	  var markPoint = seriesOpt.markPoint;
	
	  if (markPoint) {
	    compatEC2ItemStyle(markPoint);
	    compatEC3CommonStyles(markPoint);
	  }
	
	  var markLine = seriesOpt.markLine;
	
	  if (markLine) {
	    compatEC2ItemStyle(markLine);
	    compatEC3CommonStyles(markLine);
	  }
	
	  var markArea = seriesOpt.markArea;
	
	  if (markArea) {
	    compatEC3CommonStyles(markArea);
	  }
	
	  var data = seriesOpt.data; // Break with ec3: if `setOption` again, there may be no `type` in option,
	  // then the backward compat based on option type will not be performed.
	
	  if (seriesOpt.type === 'graph') {
	    data = data || seriesOpt.nodes;
	    var edgeData = seriesOpt.links || seriesOpt.edges;
	
	    if (edgeData && !zrUtil.isTypedArray(edgeData)) {
	      for (var i = 0; i < edgeData.length; i++) {
	        compatEC3CommonStyles(edgeData[i]);
	      }
	    }
	
	    zrUtil.each(seriesOpt.categories, function (opt) {
	      removeEC3NormalStatus(opt);
	    });
	  }
	
	  if (data && !zrUtil.isTypedArray(data)) {
	    for (var i = 0; i < data.length; i++) {
	      compatEC3CommonStyles(data[i]);
	    }
	  } // mark point data
	
	
	  var markPoint = seriesOpt.markPoint;
	
	  if (markPoint && markPoint.data) {
	    var mpData = markPoint.data;
	
	    for (var i = 0; i < mpData.length; i++) {
	      compatEC3CommonStyles(mpData[i]);
	    }
	  } // mark line data
	
	
	  var markLine = seriesOpt.markLine;
	
	  if (markLine && markLine.data) {
	    var mlData = markLine.data;
	
	    for (var i = 0; i < mlData.length; i++) {
	      if (zrUtil.isArray(mlData[i])) {
	        compatEC3CommonStyles(mlData[i][0]);
	        compatEC3CommonStyles(mlData[i][1]);
	      } else {
	        compatEC3CommonStyles(mlData[i]);
	      }
	    }
	  } // Series
	
	
	  if (seriesOpt.type === 'gauge') {
	    compatTextStyle(seriesOpt, 'axisLabel');
	    compatTextStyle(seriesOpt, 'title');
	    compatTextStyle(seriesOpt, 'detail');
	  } else if (seriesOpt.type === 'treemap') {
	    convertNormalEmphasis(seriesOpt.breadcrumb, 'itemStyle');
	    zrUtil.each(seriesOpt.levels, function (opt) {
	      removeEC3NormalStatus(opt);
	    });
	  } else if (seriesOpt.type === 'tree') {
	    removeEC3NormalStatus(seriesOpt.leaves);
	  } // sunburst starts from ec4, so it does not need to compat levels.
	
	}
	
	function toArr(o) {
	  return zrUtil.isArray(o) ? o : o ? [o] : [];
	}
	
	function toObj(o) {
	  return (zrUtil.isArray(o) ? o[0] : o) || {};
	}
	
	function _default(option, isTheme) {
	  each(toArr(option.series), function (seriesOpt) {
	    isObject(seriesOpt) && processSeries(seriesOpt);
	  });
	  var axes = ['xAxis', 'yAxis', 'radiusAxis', 'angleAxis', 'singleAxis', 'parallelAxis', 'radar'];
	  isTheme && axes.push('valueAxis', 'categoryAxis', 'logAxis', 'timeAxis');
	  each(axes, function (axisName) {
	    each(toArr(option[axisName]), function (axisOpt) {
	      if (axisOpt) {
	        compatTextStyle(axisOpt, 'axisLabel');
	        compatTextStyle(axisOpt.axisPointer, 'label');
	      }
	    });
	  });
	  each(toArr(option.parallel), function (parallelOpt) {
	    var parallelAxisDefault = parallelOpt && parallelOpt.parallelAxisDefault;
	    compatTextStyle(parallelAxisDefault, 'axisLabel');
	    compatTextStyle(parallelAxisDefault && parallelAxisDefault.axisPointer, 'label');
	  });
	  each(toArr(option.calendar), function (calendarOpt) {
	    convertNormalEmphasis(calendarOpt, 'itemStyle');
	    compatTextStyle(calendarOpt, 'dayLabel');
	    compatTextStyle(calendarOpt, 'monthLabel');
	    compatTextStyle(calendarOpt, 'yearLabel');
	  }); // radar.name.textStyle
	
	  each(toArr(option.radar), function (radarOpt) {
	    compatTextStyle(radarOpt, 'name');
	  });
	  each(toArr(option.geo), function (geoOpt) {
	    if (isObject(geoOpt)) {
	      compatEC3CommonStyles(geoOpt);
	      each(toArr(geoOpt.regions), function (regionObj) {
	        compatEC3CommonStyles(regionObj);
	      });
	    }
	  });
	  each(toArr(option.timeline), function (timelineOpt) {
	    compatEC3CommonStyles(timelineOpt);
	    convertNormalEmphasis(timelineOpt, 'label');
	    convertNormalEmphasis(timelineOpt, 'itemStyle');
	    convertNormalEmphasis(timelineOpt, 'controlStyle', true);
	    var data = timelineOpt.data;
	    zrUtil.isArray(data) && zrUtil.each(data, function (item) {
	      if (zrUtil.isObject(item)) {
	        convertNormalEmphasis(item, 'label');
	        convertNormalEmphasis(item, 'itemStyle');
	      }
	    });
	  });
	  each(toArr(option.toolbox), function (toolboxOpt) {
	    convertNormalEmphasis(toolboxOpt, 'iconStyle');
	    each(toolboxOpt.feature, function (featureOpt) {
	      convertNormalEmphasis(featureOpt, 'iconStyle');
	    });
	  });
	  compatTextStyle(toObj(option.axisPointer), 'label');
	  compatTextStyle(toObj(option.tooltip).axisPointer, 'label');
	}
	
	module.exports = _default;

/***/ },
/* 1702 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var samplers = {
	  average: function (frame) {
	    var sum = 0;
	    var count = 0;
	
	    for (var i = 0; i < frame.length; i++) {
	      if (!isNaN(frame[i])) {
	        sum += frame[i];
	        count++;
	      }
	    } // Return NaN if count is 0
	
	
	    return count === 0 ? NaN : sum / count;
	  },
	  sum: function (frame) {
	    var sum = 0;
	
	    for (var i = 0; i < frame.length; i++) {
	      // Ignore NaN
	      sum += frame[i] || 0;
	    }
	
	    return sum;
	  },
	  max: function (frame) {
	    var max = -Infinity;
	
	    for (var i = 0; i < frame.length; i++) {
	      frame[i] > max && (max = frame[i]);
	    } // NaN will cause illegal axis extent.
	
	
	    return isFinite(max) ? max : NaN;
	  },
	  min: function (frame) {
	    var min = Infinity;
	
	    for (var i = 0; i < frame.length; i++) {
	      frame[i] < min && (min = frame[i]);
	    } // NaN will cause illegal axis extent.
	
	
	    return isFinite(min) ? min : NaN;
	  },
	  // TODO
	  // Median
	  nearest: function (frame) {
	    return frame[0];
	  }
	};
	
	var indexSampler = function (frame, value) {
	  return Math.round(frame.length / 2);
	};
	
	function _default(seriesType) {
	  return {
	    seriesType: seriesType,
	    modifyOutputEnd: true,
	    reset: function (seriesModel, ecModel, api) {
	      var data = seriesModel.getData();
	      var sampling = seriesModel.get('sampling');
	      var coordSys = seriesModel.coordinateSystem; // Only cartesian2d support down sampling
	
	      if (coordSys.type === 'cartesian2d' && sampling) {
	        var baseAxis = coordSys.getBaseAxis();
	        var valueAxis = coordSys.getOtherAxis(baseAxis);
	        var extent = baseAxis.getExtent(); // Coordinste system has been resized
	
	        var size = Math.abs(extent[1] - extent[0]);
	        var rate = Math.round(data.count() / size);
	
	        if (rate > 1) {
	          var sampler;
	
	          if (typeof sampling === 'string') {
	            sampler = samplers[sampling];
	          } else if (typeof sampling === 'function') {
	            sampler = sampling;
	          }
	
	          if (sampler) {
	            // Only support sample the first dim mapped from value axis.
	            seriesModel.setData(data.downSample(data.mapDimension(valueAxis.dim), 1 / rate, sampler, indexSampler));
	          }
	        }
	      }
	    }
	  };
	}
	
	module.exports = _default;

/***/ },
/* 1703 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(3);
	
	var createHashMap = _util.createHashMap;
	var each = _util.each;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// (1) [Caution]: the logic is correct based on the premises:
	//     data processing stage is blocked in stream.
	//     See <module:echarts/stream/Scheduler#performDataProcessorTasks>
	// (2) Only register once when import repeatly.
	//     Should be executed after series filtered and before stack calculation.
	function _default(ecModel) {
	  var stackInfoMap = createHashMap();
	  ecModel.eachSeries(function (seriesModel) {
	    var stack = seriesModel.get('stack'); // Compatibal: when `stack` is set as '', do not stack.
	
	    if (stack) {
	      var stackInfoList = stackInfoMap.get(stack) || stackInfoMap.set(stack, []);
	      var data = seriesModel.getData();
	      var stackInfo = {
	        // Used for calculate axis extent automatically.
	        stackResultDimension: data.getCalculationInfo('stackResultDimension'),
	        stackedOverDimension: data.getCalculationInfo('stackedOverDimension'),
	        stackedDimension: data.getCalculationInfo('stackedDimension'),
	        stackedByDimension: data.getCalculationInfo('stackedByDimension'),
	        isStackedByIndex: data.getCalculationInfo('isStackedByIndex'),
	        data: data,
	        seriesModel: seriesModel
	      }; // If stacked on axis that do not support data stack.
	
	      if (!stackInfo.stackedDimension || !(stackInfo.isStackedByIndex || stackInfo.stackedByDimension)) {
	        return;
	      }
	
	      stackInfoList.length && data.setCalculationInfo('stackedOnSeries', stackInfoList[stackInfoList.length - 1].seriesModel);
	      stackInfoList.push(stackInfo);
	    }
	  });
	  stackInfoMap.each(calculateStack);
	}
	
	function calculateStack(stackInfoList) {
	  each(stackInfoList, function (targetStackInfo, idxInStack) {
	    var resultVal = [];
	    var resultNaN = [NaN, NaN];
	    var dims = [targetStackInfo.stackResultDimension, targetStackInfo.stackedOverDimension];
	    var targetData = targetStackInfo.data;
	    var isStackedByIndex = targetStackInfo.isStackedByIndex; // Should not write on raw data, because stack series model list changes
	    // depending on legend selection.
	
	    var newData = targetData.map(dims, function (v0, v1, dataIndex) {
	      var sum = targetData.get(targetStackInfo.stackedDimension, dataIndex); // Consider `connectNulls` of line area, if value is NaN, stackedOver
	      // should also be NaN, to draw a appropriate belt area.
	
	      if (isNaN(sum)) {
	        return resultNaN;
	      }
	
	      var byValue;
	      var stackedDataRawIndex;
	
	      if (isStackedByIndex) {
	        stackedDataRawIndex = targetData.getRawIndex(dataIndex);
	      } else {
	        byValue = targetData.get(targetStackInfo.stackedByDimension, dataIndex);
	      } // If stackOver is NaN, chart view will render point on value start.
	
	
	      var stackedOver = NaN;
	
	      for (var j = idxInStack - 1; j >= 0; j--) {
	        var stackInfo = stackInfoList[j]; // Has been optimized by inverted indices on `stackedByDimension`.
	
	        if (!isStackedByIndex) {
	          stackedDataRawIndex = stackInfo.data.rawIndexOf(stackInfo.stackedByDimension, byValue);
	        }
	
	        if (stackedDataRawIndex >= 0) {
	          var val = stackInfo.data.getByRawIndex(stackInfo.stackResultDimension, stackedDataRawIndex); // Considering positive stack, negative stack and empty data
	
	          if (sum >= 0 && val > 0 || // Positive stack
	          sum <= 0 && val < 0 // Negative stack
	          ) {
	              sum += val;
	              stackedOver = val;
	              break;
	            }
	        }
	      }
	
	      resultVal[0] = sum;
	      resultVal[1] = stackedOver;
	      return resultVal;
	    });
	    targetData.hostModel.setData(newData); // Update for consequent calculation
	
	    targetStackInfo.data = newData;
	  });
	}
	
	module.exports = _default;

/***/ },
/* 1704 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var Scale = __webpack_require__(339);
	
	var OrdinalMeta = __webpack_require__(745);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Linear continuous scale
	 * @module echarts/coord/scale/Ordinal
	 *
	 * http://en.wikipedia.org/wiki/Level_of_measurement
	 */
	// FIXME only one data
	var scaleProto = Scale.prototype;
	var OrdinalScale = Scale.extend({
	  type: 'ordinal',
	
	  /**
	   * @param {module:echarts/data/OrdianlMeta|Array.<string>} ordinalMeta
	   */
	  init: function (ordinalMeta, extent) {
	    // Caution: Should not use instanceof, consider ec-extensions using
	    // import approach to get OrdinalMeta class.
	    if (!ordinalMeta || zrUtil.isArray(ordinalMeta)) {
	      ordinalMeta = new OrdinalMeta({
	        categories: ordinalMeta
	      });
	    }
	
	    this._ordinalMeta = ordinalMeta;
	    this._extent = extent || [0, ordinalMeta.categories.length - 1];
	  },
	  parse: function (val) {
	    return typeof val === 'string' ? this._ordinalMeta.getOrdinal(val) // val might be float.
	    : Math.round(val);
	  },
	  contain: function (rank) {
	    rank = this.parse(rank);
	    return scaleProto.contain.call(this, rank) && this._ordinalMeta.categories[rank] != null;
	  },
	
	  /**
	   * Normalize given rank or name to linear [0, 1]
	   * @param {number|string} [val]
	   * @return {number}
	   */
	  normalize: function (val) {
	    return scaleProto.normalize.call(this, this.parse(val));
	  },
	  scale: function (val) {
	    return Math.round(scaleProto.scale.call(this, val));
	  },
	
	  /**
	   * @return {Array}
	   */
	  getTicks: function () {
	    var ticks = [];
	    var extent = this._extent;
	    var rank = extent[0];
	
	    while (rank <= extent[1]) {
	      ticks.push(rank);
	      rank++;
	    }
	
	    return ticks;
	  },
	
	  /**
	   * Get item on rank n
	   * @param {number} n
	   * @return {string}
	   */
	  getLabel: function (n) {
	    if (!this.isBlank()) {
	      // Note that if no data, ordinalMeta.categories is an empty array.
	      return this._ordinalMeta.categories[n];
	    }
	  },
	
	  /**
	   * @return {number}
	   */
	  count: function () {
	    return this._extent[1] - this._extent[0] + 1;
	  },
	
	  /**
	   * @override
	   */
	  unionExtentFromData: function (data, dim) {
	    this.unionExtent(data.getApproximateExtent(dim));
	  },
	  getOrdinalMeta: function () {
	    return this._ordinalMeta;
	  },
	  niceTicks: zrUtil.noop,
	  niceExtent: zrUtil.noop
	});
	/**
	 * @return {module:echarts/scale/Time}
	 */
	
	OrdinalScale.create = function () {
	  return new OrdinalScale();
	};
	
	var _default = OrdinalScale;
	module.exports = _default;

/***/ },
/* 1705 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var numberUtil = __webpack_require__(20);
	
	var formatUtil = __webpack_require__(40);
	
	var scaleHelper = __webpack_require__(752);
	
	var IntervalScale = __webpack_require__(338);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* A third-party license is embeded for some of the code in this file:
	* The "scaleLevels" was originally copied from "d3.js" with some
	* modifications made for this project.
	* (See more details in the comment on the definition of "scaleLevels" below.)
	* The use of the source code of this file is also subject to the terms
	* and consitions of the license of "d3.js" (BSD-3Clause, see
	* </licenses/LICENSE-d3>).
	*/
	// [About UTC and local time zone]:
	// In most cases, `number.parseDate` will treat input data string as local time
	// (except time zone is specified in time string). And `format.formateTime` returns
	// local time by default. option.useUTC is false by default. This design have
	// concidered these common case:
	// (1) Time that is persistent in server is in UTC, but it is needed to be diplayed
	// in local time by default.
	// (2) By default, the input data string (e.g., '2011-01-02') should be displayed
	// as its original time, without any time difference.
	var intervalScaleProto = IntervalScale.prototype;
	var mathCeil = Math.ceil;
	var mathFloor = Math.floor;
	var ONE_SECOND = 1000;
	var ONE_MINUTE = ONE_SECOND * 60;
	var ONE_HOUR = ONE_MINUTE * 60;
	var ONE_DAY = ONE_HOUR * 24; // FIXME 公用？
	
	var bisect = function (a, x, lo, hi) {
	  while (lo < hi) {
	    var mid = lo + hi >>> 1;
	
	    if (a[mid][1] < x) {
	      lo = mid + 1;
	    } else {
	      hi = mid;
	    }
	  }
	
	  return lo;
	};
	/**
	 * @alias module:echarts/coord/scale/Time
	 * @constructor
	 */
	
	
	var TimeScale = IntervalScale.extend({
	  type: 'time',
	
	  /**
	   * @override
	   */
	  getLabel: function (val) {
	    var stepLvl = this._stepLvl;
	    var date = new Date(val);
	    return formatUtil.formatTime(stepLvl[0], date, this.getSetting('useUTC'));
	  },
	
	  /**
	   * @override
	   */
	  niceExtent: function (opt) {
	    var extent = this._extent; // If extent start and end are same, expand them
	
	    if (extent[0] === extent[1]) {
	      // Expand extent
	      extent[0] -= ONE_DAY;
	      extent[1] += ONE_DAY;
	    } // If there are no data and extent are [Infinity, -Infinity]
	
	
	    if (extent[1] === -Infinity && extent[0] === Infinity) {
	      var d = new Date();
	      extent[1] = +new Date(d.getFullYear(), d.getMonth(), d.getDate());
	      extent[0] = extent[1] - ONE_DAY;
	    }
	
	    this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval); // var extent = this._extent;
	
	    var interval = this._interval;
	
	    if (!opt.fixMin) {
	      extent[0] = numberUtil.round(mathFloor(extent[0] / interval) * interval);
	    }
	
	    if (!opt.fixMax) {
	      extent[1] = numberUtil.round(mathCeil(extent[1] / interval) * interval);
	    }
	  },
	
	  /**
	   * @override
	   */
	  niceTicks: function (approxTickNum, minInterval, maxInterval) {
	    approxTickNum = approxTickNum || 10;
	    var extent = this._extent;
	    var span = extent[1] - extent[0];
	    var approxInterval = span / approxTickNum;
	
	    if (minInterval != null && approxInterval < minInterval) {
	      approxInterval = minInterval;
	    }
	
	    if (maxInterval != null && approxInterval > maxInterval) {
	      approxInterval = maxInterval;
	    }
	
	    var scaleLevelsLen = scaleLevels.length;
	    var idx = bisect(scaleLevels, approxInterval, 0, scaleLevelsLen);
	    var level = scaleLevels[Math.min(idx, scaleLevelsLen - 1)];
	    var interval = level[1]; // Same with interval scale if span is much larger than 1 year
	
	    if (level[0] === 'year') {
	      var yearSpan = span / interval; // From "Nice Numbers for Graph Labels" of Graphic Gems
	      // var niceYearSpan = numberUtil.nice(yearSpan, false);
	
	      var yearStep = numberUtil.nice(yearSpan / approxTickNum, true);
	      interval *= yearStep;
	    }
	
	    var timezoneOffset = this.getSetting('useUTC') ? 0 : new Date(+extent[0] || +extent[1]).getTimezoneOffset() * 60 * 1000;
	    var niceExtent = [Math.round(mathCeil((extent[0] - timezoneOffset) / interval) * interval + timezoneOffset), Math.round(mathFloor((extent[1] - timezoneOffset) / interval) * interval + timezoneOffset)];
	    scaleHelper.fixExtent(niceExtent, extent);
	    this._stepLvl = level; // Interval will be used in getTicks
	
	    this._interval = interval;
	    this._niceExtent = niceExtent;
	  },
	  parse: function (val) {
	    // val might be float.
	    return +numberUtil.parseDate(val);
	  }
	});
	zrUtil.each(['contain', 'normalize'], function (methodName) {
	  TimeScale.prototype[methodName] = function (val) {
	    return intervalScaleProto[methodName].call(this, this.parse(val));
	  };
	});
	/**
	 * This implementation was originally copied from "d3.js"
	 * <https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/time/scale.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 */
	
	var scaleLevels = [// Format              interval
	['hh:mm:ss', ONE_SECOND], // 1s
	['hh:mm:ss', ONE_SECOND * 5], // 5s
	['hh:mm:ss', ONE_SECOND * 10], // 10s
	['hh:mm:ss', ONE_SECOND * 15], // 15s
	['hh:mm:ss', ONE_SECOND * 30], // 30s
	['hh:mm\nMM-dd', ONE_MINUTE], // 1m
	['hh:mm\nMM-dd', ONE_MINUTE * 5], // 5m
	['hh:mm\nMM-dd', ONE_MINUTE * 10], // 10m
	['hh:mm\nMM-dd', ONE_MINUTE * 15], // 15m
	['hh:mm\nMM-dd', ONE_MINUTE * 30], // 30m
	['hh:mm\nMM-dd', ONE_HOUR], // 1h
	['hh:mm\nMM-dd', ONE_HOUR * 2], // 2h
	['hh:mm\nMM-dd', ONE_HOUR * 6], // 6h
	['hh:mm\nMM-dd', ONE_HOUR * 12], // 12h
	['MM-dd\nyyyy', ONE_DAY], // 1d
	['MM-dd\nyyyy', ONE_DAY * 2], // 2d
	['MM-dd\nyyyy', ONE_DAY * 3], // 3d
	['MM-dd\nyyyy', ONE_DAY * 4], // 4d
	['MM-dd\nyyyy', ONE_DAY * 5], // 5d
	['MM-dd\nyyyy', ONE_DAY * 6], // 6d
	['week', ONE_DAY * 7], // 7d
	['MM-dd\nyyyy', ONE_DAY * 10], // 10d
	['week', ONE_DAY * 14], // 2w
	['week', ONE_DAY * 21], // 3w
	['month', ONE_DAY * 31], // 1M
	['week', ONE_DAY * 42], // 6w
	['month', ONE_DAY * 62], // 2M
	['week', ONE_DAY * 70], // 10w
	['quarter', ONE_DAY * 95], // 3M
	['month', ONE_DAY * 31 * 4], // 4M
	['month', ONE_DAY * 31 * 5], // 5M
	['half-year', ONE_DAY * 380 / 2], // 6M
	['month', ONE_DAY * 31 * 8], // 8M
	['month', ONE_DAY * 31 * 10], // 10M
	['year', ONE_DAY * 380] // 1Y
	];
	/**
	 * @param {module:echarts/model/Model}
	 * @return {module:echarts/scale/Time}
	 */
	
	TimeScale.create = function (model) {
	  return new TimeScale({
	    useUTC: model.ecModel.get('useUTC')
	  });
	};
	
	var _default = TimeScale;
	module.exports = _default;

/***/ },
/* 1706 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(3);
	
	var each = _util.each;
	var map = _util.map;
	var isFunction = _util.isFunction;
	var createHashMap = _util.createHashMap;
	var noop = _util.noop;
	
	var _task = __webpack_require__(476);
	
	var createTask = _task.createTask;
	
	var _component = __webpack_require__(268);
	
	var getUID = _component.getUID;
	
	var GlobalModel = __webpack_require__(749);
	
	var ExtensionAPI = __webpack_require__(693);
	
	var _model = __webpack_require__(24);
	
	var normalizeToArray = _model.normalizeToArray;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/stream/Scheduler
	 */
	
	/**
	 * @constructor
	 */
	function Scheduler(ecInstance, api, dataProcessorHandlers, visualHandlers) {
	  this.ecInstance = ecInstance;
	  this.api = api;
	  this.unfinished; // Fix current processors in case that in some rear cases that
	  // processors might be registered after echarts instance created.
	  // Register processors incrementally for a echarts instance is
	  // not supported by this stream architecture.
	
	  var dataProcessorHandlers = this._dataProcessorHandlers = dataProcessorHandlers.slice();
	  var visualHandlers = this._visualHandlers = visualHandlers.slice();
	  this._allHandlers = dataProcessorHandlers.concat(visualHandlers);
	  /**
	   * @private
	   * @type {
	   *     [handlerUID: string]: {
	   *         seriesTaskMap?: {
	   *             [seriesUID: string]: Task
	   *         },
	   *         overallTask?: Task
	   *     }
	   * }
	   */
	
	  this._stageTaskMap = createHashMap();
	}
	
	var proto = Scheduler.prototype;
	/**
	 * @param {module:echarts/model/Global} ecModel
	 * @param {Object} payload
	 */
	
	proto.restoreData = function (ecModel, payload) {
	  // TODO: Only restore needed series and components, but not all components.
	  // Currently `restoreData` of all of the series and component will be called.
	  // But some independent components like `title`, `legend`, `graphic`, `toolbox`,
	  // `tooltip`, `axisPointer`, etc, do not need series refresh when `setOption`,
	  // and some components like coordinate system, axes, dataZoom, visualMap only
	  // need their target series refresh.
	  // (1) If we are implementing this feature some day, we should consider these cases:
	  // if a data processor depends on a component (e.g., dataZoomProcessor depends
	  // on the settings of `dataZoom`), it should be re-performed if the component
	  // is modified by `setOption`.
	  // (2) If a processor depends on sevral series, speicified by its `getTargetSeries`,
	  // it should be re-performed when the result array of `getTargetSeries` changed.
	  // We use `dependencies` to cover these issues.
	  // (3) How to update target series when coordinate system related components modified.
	  // TODO: simply the dirty mechanism? Check whether only the case here can set tasks dirty,
	  // and this case all of the tasks will be set as dirty.
	  ecModel.restoreData(payload); // Theoretically an overall task not only depends on each of its target series, but also
	  // depends on all of the series.
	  // The overall task is not in pipeline, and `ecModel.restoreData` only set pipeline tasks
	  // dirty. If `getTargetSeries` of an overall task returns nothing, we should also ensure
	  // that the overall task is set as dirty and to be performed, otherwise it probably cause
	  // state chaos. So we have to set dirty of all of the overall tasks manually, otherwise it
	  // probably cause state chaos (consider `dataZoomProcessor`).
	
	  this._stageTaskMap.each(function (taskRecord) {
	    var overallTask = taskRecord.overallTask;
	    overallTask && overallTask.dirty();
	  });
	}; // If seriesModel provided, incremental threshold is check by series data.
	
	
	proto.getPerformArgs = function (task, isBlock) {
	  // For overall task
	  if (!task.__pipeline) {
	    return;
	  }
	
	  var pipeline = this._pipelineMap.get(task.__pipeline.id);
	
	  var pCtx = pipeline.context;
	  var incremental = !isBlock && pipeline.progressiveEnabled && (!pCtx || pCtx.progressiveRender) && task.__idxInPipeline > pipeline.blockIndex;
	  var step = incremental ? pipeline.step : null;
	  var modDataCount = pCtx && pCtx.modDataCount;
	  var modBy = modDataCount != null ? Math.ceil(modDataCount / step) : null;
	  return {
	    step: step,
	    modBy: modBy,
	    modDataCount: modDataCount
	  };
	};
	
	proto.getPipeline = function (pipelineId) {
	  return this._pipelineMap.get(pipelineId);
	};
	/**
	 * Current, progressive rendering starts from visual and layout.
	 * Always detect render mode in the same stage, avoiding that incorrect
	 * detection caused by data filtering.
	 * Caution:
	 * `updateStreamModes` use `seriesModel.getData()`.
	 */
	
	
	proto.updateStreamModes = function (seriesModel, view) {
	  var pipeline = this._pipelineMap.get(seriesModel.uid);
	
	  var data = seriesModel.getData();
	  var dataLen = data.count(); // `progressiveRender` means that can render progressively in each
	  // animation frame. Note that some types of series do not provide
	  // `view.incrementalPrepareRender` but support `chart.appendData`. We
	  // use the term `incremental` but not `progressive` to describe the
	  // case that `chart.appendData`.
	
	  var progressiveRender = pipeline.progressiveEnabled && view.incrementalPrepareRender && dataLen >= pipeline.threshold;
	  var large = seriesModel.get('large') && dataLen >= seriesModel.get('largeThreshold'); // TODO: modDataCount should not updated if `appendData`, otherwise cause whole repaint.
	  // see `test/candlestick-large3.html`
	
	  var modDataCount = seriesModel.get('progressiveChunkMode') === 'mod' ? dataLen : null;
	  seriesModel.pipelineContext = pipeline.context = {
	    progressiveRender: progressiveRender,
	    modDataCount: modDataCount,
	    large: large
	  };
	};
	
	proto.restorePipelines = function (ecModel) {
	  var scheduler = this;
	  var pipelineMap = scheduler._pipelineMap = createHashMap();
	  ecModel.eachSeries(function (seriesModel) {
	    var progressive = seriesModel.getProgressive();
	    var pipelineId = seriesModel.uid;
	    pipelineMap.set(pipelineId, {
	      id: pipelineId,
	      head: null,
	      tail: null,
	      threshold: seriesModel.getProgressiveThreshold(),
	      progressiveEnabled: progressive && !(seriesModel.preventIncremental && seriesModel.preventIncremental()),
	      blockIndex: -1,
	      step: Math.round(progressive || 700),
	      count: 0
	    });
	    pipe(scheduler, seriesModel, seriesModel.dataTask);
	  });
	};
	
	proto.prepareStageTasks = function () {
	  var stageTaskMap = this._stageTaskMap;
	  var ecModel = this.ecInstance.getModel();
	  var api = this.api;
	  each(this._allHandlers, function (handler) {
	    var record = stageTaskMap.get(handler.uid) || stageTaskMap.set(handler.uid, []);
	    handler.reset && createSeriesStageTask(this, handler, record, ecModel, api);
	    handler.overallReset && createOverallStageTask(this, handler, record, ecModel, api);
	  }, this);
	};
	
	proto.prepareView = function (view, model, ecModel, api) {
	  var renderTask = view.renderTask;
	  var context = renderTask.context;
	  context.model = model;
	  context.ecModel = ecModel;
	  context.api = api;
	  renderTask.__block = !view.incrementalPrepareRender;
	  pipe(this, model, renderTask);
	};
	
	proto.performDataProcessorTasks = function (ecModel, payload) {
	  // If we do not use `block` here, it should be considered when to update modes.
	  performStageTasks(this, this._dataProcessorHandlers, ecModel, payload, {
	    block: true
	  });
	}; // opt
	// opt.visualType: 'visual' or 'layout'
	// opt.setDirty
	
	
	proto.performVisualTasks = function (ecModel, payload, opt) {
	  performStageTasks(this, this._visualHandlers, ecModel, payload, opt);
	};
	
	function performStageTasks(scheduler, stageHandlers, ecModel, payload, opt) {
	  opt = opt || {};
	  var unfinished;
	  each(stageHandlers, function (stageHandler, idx) {
	    if (opt.visualType && opt.visualType !== stageHandler.visualType) {
	      return;
	    }
	
	    var stageHandlerRecord = scheduler._stageTaskMap.get(stageHandler.uid);
	
	    var seriesTaskMap = stageHandlerRecord.seriesTaskMap;
	    var overallTask = stageHandlerRecord.overallTask;
	
	    if (overallTask) {
	      var overallNeedDirty;
	      var agentStubMap = overallTask.agentStubMap;
	      agentStubMap.each(function (stub) {
	        if (needSetDirty(opt, stub)) {
	          stub.dirty();
	          overallNeedDirty = true;
	        }
	      });
	      overallNeedDirty && overallTask.dirty();
	      updatePayload(overallTask, payload);
	      var performArgs = scheduler.getPerformArgs(overallTask, opt.block); // Execute stubs firstly, which may set the overall task dirty,
	      // then execute the overall task. And stub will call seriesModel.setData,
	      // which ensures that in the overallTask seriesModel.getData() will not
	      // return incorrect data.
	
	      agentStubMap.each(function (stub) {
	        stub.perform(performArgs);
	      });
	      unfinished |= overallTask.perform(performArgs);
	    } else if (seriesTaskMap) {
	      seriesTaskMap.each(function (task, pipelineId) {
	        if (needSetDirty(opt, task)) {
	          task.dirty();
	        }
	
	        var performArgs = scheduler.getPerformArgs(task, opt.block); // FIXME
	        // if intending to decalare `performRawSeries` in handlers, only
	        // stream-independent (specifically, data item independent) operations can be
	        // performed. Because is a series is filtered, most of the tasks will not
	        // be performed. A stream-dependent operation probably cause wrong biz logic.
	        // Perhaps we should not provide a separate callback for this case instead
	        // of providing the config `performRawSeries`. The stream-dependent operaions
	        // and stream-independent operations should better not be mixed.
	
	        performArgs.skip = !stageHandler.performRawSeries && ecModel.isSeriesFiltered(task.context.model);
	        updatePayload(task, payload);
	        unfinished |= task.perform(performArgs);
	      });
	    }
	  });
	
	  function needSetDirty(opt, task) {
	    return opt.setDirty && (!opt.dirtyMap || opt.dirtyMap.get(task.__pipeline.id));
	  }
	
	  scheduler.unfinished |= unfinished;
	}
	
	proto.performSeriesTasks = function (ecModel) {
	  var unfinished;
	  ecModel.eachSeries(function (seriesModel) {
	    // Progress to the end for dataInit and dataRestore.
	    unfinished |= seriesModel.dataTask.perform();
	  });
	  this.unfinished |= unfinished;
	};
	
	proto.plan = function () {
	  // Travel pipelines, check block.
	  this._pipelineMap.each(function (pipeline) {
	    var task = pipeline.tail;
	
	    do {
	      if (task.__block) {
	        pipeline.blockIndex = task.__idxInPipeline;
	        break;
	      }
	
	      task = task.getUpstream();
	    } while (task);
	  });
	};
	
	var updatePayload = proto.updatePayload = function (task, payload) {
	  payload !== 'remain' && (task.context.payload = payload);
	};
	
	function createSeriesStageTask(scheduler, stageHandler, stageHandlerRecord, ecModel, api) {
	  var seriesTaskMap = stageHandlerRecord.seriesTaskMap || (stageHandlerRecord.seriesTaskMap = createHashMap());
	  var seriesType = stageHandler.seriesType;
	  var getTargetSeries = stageHandler.getTargetSeries; // If a stageHandler should cover all series, `createOnAllSeries` should be declared mandatorily,
	  // to avoid some typo or abuse. Otherwise if an extension do not specify a `seriesType`,
	  // it works but it may cause other irrelevant charts blocked.
	
	  if (stageHandler.createOnAllSeries) {
	    ecModel.eachRawSeries(create);
	  } else if (seriesType) {
	    ecModel.eachRawSeriesByType(seriesType, create);
	  } else if (getTargetSeries) {
	    getTargetSeries(ecModel, api).each(create);
	  }
	
	  function create(seriesModel) {
	    var pipelineId = seriesModel.uid; // Init tasks for each seriesModel only once.
	    // Reuse original task instance.
	
	    var task = seriesTaskMap.get(pipelineId) || seriesTaskMap.set(pipelineId, createTask({
	      plan: seriesTaskPlan,
	      reset: seriesTaskReset,
	      count: seriesTaskCount
	    }));
	    task.context = {
	      model: seriesModel,
	      ecModel: ecModel,
	      api: api,
	      useClearVisual: stageHandler.isVisual && !stageHandler.isLayout,
	      plan: stageHandler.plan,
	      reset: stageHandler.reset,
	      scheduler: scheduler
	    };
	    pipe(scheduler, seriesModel, task);
	  } // Clear unused series tasks.
	
	
	  var pipelineMap = scheduler._pipelineMap;
	  seriesTaskMap.each(function (task, pipelineId) {
	    if (!pipelineMap.get(pipelineId)) {
	      task.dispose();
	      seriesTaskMap.removeKey(pipelineId);
	    }
	  });
	}
	
	function createOverallStageTask(scheduler, stageHandler, stageHandlerRecord, ecModel, api) {
	  var overallTask = stageHandlerRecord.overallTask = stageHandlerRecord.overallTask // For overall task, the function only be called on reset stage.
	  || createTask({
	    reset: overallTaskReset
	  });
	  overallTask.context = {
	    ecModel: ecModel,
	    api: api,
	    overallReset: stageHandler.overallReset,
	    scheduler: scheduler
	  }; // Reuse orignal stubs.
	
	  var agentStubMap = overallTask.agentStubMap = overallTask.agentStubMap || createHashMap();
	  var seriesType = stageHandler.seriesType;
	  var getTargetSeries = stageHandler.getTargetSeries;
	  var overallProgress = true;
	  var modifyOutputEnd = stageHandler.modifyOutputEnd; // An overall task with seriesType detected or has `getTargetSeries`, we add
	  // stub in each pipelines, it will set the overall task dirty when the pipeline
	  // progress. Moreover, to avoid call the overall task each frame (too frequent),
	  // we set the pipeline block.
	
	  if (seriesType) {
	    ecModel.eachRawSeriesByType(seriesType, createStub);
	  } else if (getTargetSeries) {
	    getTargetSeries(ecModel, api).each(createStub);
	  } // Otherwise, (usually it is legancy case), the overall task will only be
	  // executed when upstream dirty. Otherwise the progressive rendering of all
	  // pipelines will be disabled unexpectedly. But it still needs stubs to receive
	  // dirty info from upsteam.
	  else {
	      overallProgress = false;
	      each(ecModel.getSeries(), createStub);
	    }
	
	  function createStub(seriesModel) {
	    var pipelineId = seriesModel.uid;
	    var stub = agentStubMap.get(pipelineId);
	
	    if (!stub) {
	      stub = agentStubMap.set(pipelineId, createTask({
	        reset: stubReset,
	        onDirty: stubOnDirty
	      })); // When the result of `getTargetSeries` changed, the overallTask
	      // should be set as dirty and re-performed.
	
	      overallTask.dirty();
	    }
	
	    stub.context = {
	      model: seriesModel,
	      overallProgress: overallProgress,
	      modifyOutputEnd: modifyOutputEnd
	    };
	    stub.agent = overallTask;
	    stub.__block = overallProgress;
	    pipe(scheduler, seriesModel, stub);
	  } // Clear unused stubs.
	
	
	  var pipelineMap = scheduler._pipelineMap;
	  agentStubMap.each(function (stub, pipelineId) {
	    if (!pipelineMap.get(pipelineId)) {
	      stub.dispose(); // When the result of `getTargetSeries` changed, the overallTask
	      // should be set as dirty and re-performed.
	
	      overallTask.dirty();
	      agentStubMap.removeKey(pipelineId);
	    }
	  });
	}
	
	function overallTaskReset(context) {
	  context.overallReset(context.ecModel, context.api, context.payload);
	}
	
	function stubReset(context, upstreamContext) {
	  return context.overallProgress && stubProgress;
	}
	
	function stubProgress() {
	  this.agent.dirty();
	  this.getDownstream().dirty();
	}
	
	function stubOnDirty() {
	  this.agent && this.agent.dirty();
	}
	
	function seriesTaskPlan(context) {
	  return context.plan && context.plan(context.model, context.ecModel, context.api, context.payload);
	}
	
	function seriesTaskReset(context) {
	  if (context.useClearVisual) {
	    context.data.clearAllVisual();
	  }
	
	  var resetDefines = context.resetDefines = normalizeToArray(context.reset(context.model, context.ecModel, context.api, context.payload));
	  return resetDefines.length > 1 ? map(resetDefines, function (v, idx) {
	    return makeSeriesTaskProgress(idx);
	  }) : singleSeriesTaskProgress;
	}
	
	var singleSeriesTaskProgress = makeSeriesTaskProgress(0);
	
	function makeSeriesTaskProgress(resetDefineIdx) {
	  return function (params, context) {
	    var data = context.data;
	    var resetDefine = context.resetDefines[resetDefineIdx];
	
	    if (resetDefine && resetDefine.dataEach) {
	      for (var i = params.start; i < params.end; i++) {
	        resetDefine.dataEach(data, i);
	      }
	    } else if (resetDefine && resetDefine.progress) {
	      resetDefine.progress(params, data);
	    }
	  };
	}
	
	function seriesTaskCount(context) {
	  return context.data.count();
	}
	
	function pipe(scheduler, seriesModel, task) {
	  var pipelineId = seriesModel.uid;
	
	  var pipeline = scheduler._pipelineMap.get(pipelineId);
	
	  !pipeline.head && (pipeline.head = task);
	  pipeline.tail && pipeline.tail.pipe(task);
	  pipeline.tail = task;
	  task.__idxInPipeline = pipeline.count++;
	  task.__pipeline = pipeline;
	}
	
	Scheduler.wrapStageHandler = function (stageHandler, visualType) {
	  if (isFunction(stageHandler)) {
	    stageHandler = {
	      overallReset: stageHandler,
	      seriesType: detectSeriseType(stageHandler)
	    };
	  }
	
	  stageHandler.uid = getUID('stageHandler');
	  visualType && (stageHandler.visualType = visualType);
	  return stageHandler;
	};
	/**
	 * Only some legacy stage handlers (usually in echarts extensions) are pure function.
	 * To ensure that they can work normally, they should work in block mode, that is,
	 * they should not be started util the previous tasks finished. So they cause the
	 * progressive rendering disabled. We try to detect the series type, to narrow down
	 * the block range to only the series type they concern, but not all series.
	 */
	
	
	function detectSeriseType(legacyFunc) {
	  seriesType = null;
	
	  try {
	    // Assume there is no async when calling `eachSeriesByType`.
	    legacyFunc(ecModelMock, apiMock);
	  } catch (e) {}
	
	  return seriesType;
	}
	
	var ecModelMock = {};
	var apiMock = {};
	var seriesType;
	mockMethods(ecModelMock, GlobalModel);
	mockMethods(apiMock, ExtensionAPI);
	
	ecModelMock.eachSeriesByType = ecModelMock.eachRawSeriesByType = function (type) {
	  seriesType = type;
	};
	
	ecModelMock.eachComponent = function (cond) {
	  if (cond.mainType === 'series' && cond.subType) {
	    seriesType = cond.subType;
	  }
	};
	
	function mockMethods(target, Clz) {
	  /* eslint-disable */
	  for (var name in Clz.prototype) {
	    // Do not use hasOwnProperty
	    target[name] = noop;
	  }
	  /* eslint-enable */
	
	}
	
	var _default = Scheduler;
	module.exports = _default;

/***/ },
/* 1707 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var contrastColor = '#eee';
	
	var axisCommon = function () {
	  return {
	    axisLine: {
	      lineStyle: {
	        color: contrastColor
	      }
	    },
	    axisTick: {
	      lineStyle: {
	        color: contrastColor
	      }
	    },
	    axisLabel: {
	      textStyle: {
	        color: contrastColor
	      }
	    },
	    splitLine: {
	      lineStyle: {
	        type: 'dashed',
	        color: '#aaa'
	      }
	    },
	    splitArea: {
	      areaStyle: {
	        color: contrastColor
	      }
	    }
	  };
	};
	
	var colorPalette = ['#dd6b66', '#759aa0', '#e69d87', '#8dc1a9', '#ea7e53', '#eedd78', '#73a373', '#73b9bc', '#7289ab', '#91ca8c', '#f49f42'];
	var theme = {
	  color: colorPalette,
	  backgroundColor: '#333',
	  tooltip: {
	    axisPointer: {
	      lineStyle: {
	        color: contrastColor
	      },
	      crossStyle: {
	        color: contrastColor
	      },
	      label: {
	        color: '#000'
	      }
	    }
	  },
	  legend: {
	    textStyle: {
	      color: contrastColor
	    }
	  },
	  textStyle: {
	    color: contrastColor
	  },
	  title: {
	    textStyle: {
	      color: contrastColor
	    }
	  },
	  toolbox: {
	    iconStyle: {
	      normal: {
	        borderColor: contrastColor
	      }
	    }
	  },
	  dataZoom: {
	    textStyle: {
	      color: contrastColor
	    }
	  },
	  visualMap: {
	    textStyle: {
	      color: contrastColor
	    }
	  },
	  timeline: {
	    lineStyle: {
	      color: contrastColor
	    },
	    itemStyle: {
	      normal: {
	        color: colorPalette[1]
	      }
	    },
	    label: {
	      normal: {
	        textStyle: {
	          color: contrastColor
	        }
	      }
	    },
	    controlStyle: {
	      normal: {
	        color: contrastColor,
	        borderColor: contrastColor
	      }
	    }
	  },
	  timeAxis: axisCommon(),
	  logAxis: axisCommon(),
	  valueAxis: axisCommon(),
	  categoryAxis: axisCommon(),
	  line: {
	    symbol: 'circle'
	  },
	  graph: {
	    color: colorPalette
	  },
	  gauge: {
	    title: {
	      textStyle: {
	        color: contrastColor
	      }
	    }
	  },
	  candlestick: {
	    itemStyle: {
	      normal: {
	        color: '#FD1050',
	        color0: '#0CF49B',
	        borderColor: '#FD1050',
	        borderColor0: '#0CF49B'
	      }
	    }
	  }
	};
	theme.categoryAxis.splitLine.show = false;
	var _default = theme;
	module.exports = _default;

/***/ },
/* 1708 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var colorAll = ['#37A2DA', '#32C5E9', '#67E0E3', '#9FE6B8', '#FFDB5C', '#ff9f7f', '#fb7293', '#E062AE', '#E690D1', '#e7bcf3', '#9d96f5', '#8378EA', '#96BFFF'];
	var _default = {
	  color: colorAll,
	  colorLayer: [['#37A2DA', '#ffd85c', '#fd7b5f'], ['#37A2DA', '#67E0E3', '#FFDB5C', '#ff9f7f', '#E062AE', '#9d96f5'], ['#37A2DA', '#32C5E9', '#9FE6B8', '#FFDB5C', '#ff9f7f', '#fb7293', '#e7bcf3', '#8378EA', '#96BFFF'], colorAll]
	};
	module.exports = _default;

/***/ },
/* 1709 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {number} [time=500] Time in ms
	 * @param {string} [easing='linear']
	 * @param {number} [delay=0]
	 * @param {Function} [callback]
	 *
	 * @example
	 *  // Animate position
	 *  animation
	 *      .createWrap()
	 *      .add(el1, {position: [10, 10]})
	 *      .add(el2, {shape: {width: 500}, style: {fill: 'red'}}, 400)
	 *      .done(function () { // done })
	 *      .start('cubicOut');
	 */
	function createWrap() {
	  var storage = [];
	  var elExistsMap = {};
	  var doneCallback;
	  return {
	    /**
	     * Caution: a el can only be added once, otherwise 'done'
	     * might not be called. This method checks this (by el.id),
	     * suppresses adding and returns false when existing el found.
	     *
	     * @param {modele:zrender/Element} el
	     * @param {Object} target
	     * @param {number} [time=500]
	     * @param {number} [delay=0]
	     * @param {string} [easing='linear']
	     * @return {boolean} Whether adding succeeded.
	     *
	     * @example
	     *     add(el, target, time, delay, easing);
	     *     add(el, target, time, easing);
	     *     add(el, target, time);
	     *     add(el, target);
	     */
	    add: function (el, target, time, delay, easing) {
	      if (zrUtil.isString(delay)) {
	        easing = delay;
	        delay = 0;
	      }
	
	      if (elExistsMap[el.id]) {
	        return false;
	      }
	
	      elExistsMap[el.id] = 1;
	      storage.push({
	        el: el,
	        target: target,
	        time: time,
	        delay: delay,
	        easing: easing
	      });
	      return true;
	    },
	
	    /**
	     * Only execute when animation finished. Will not execute when any
	     * of 'stop' or 'stopAnimation' called.
	     *
	     * @param {Function} callback
	     */
	    done: function (callback) {
	      doneCallback = callback;
	      return this;
	    },
	
	    /**
	     * Will stop exist animation firstly.
	     */
	    start: function () {
	      var count = storage.length;
	
	      for (var i = 0, len = storage.length; i < len; i++) {
	        var item = storage[i];
	        item.el.animateTo(item.target, item.time, item.delay, item.easing, done);
	      }
	
	      return this;
	
	      function done() {
	        count--;
	
	        if (!count) {
	          storage.length = 0;
	          elExistsMap = {};
	          doneCallback && doneCallback();
	        }
	      }
	    }
	  };
	}
	
	exports.createWrap = createWrap;

/***/ },
/* 1710 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _graphic = __webpack_require__(16);
	
	var extendShape = _graphic.extendShape;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Sausage: similar to sector, but have half circle on both sides
	 * @public
	 */
	var _default = extendShape({
	  type: 'sausage',
	  shape: {
	    cx: 0,
	    cy: 0,
	    r0: 0,
	    r: 0,
	    startAngle: 0,
	    endAngle: Math.PI * 2,
	    clockwise: true
	  },
	  buildPath: function (ctx, shape) {
	    var x = shape.cx;
	    var y = shape.cy;
	    var r0 = Math.max(shape.r0 || 0, 0);
	    var r = Math.max(shape.r, 0);
	    var dr = (r - r0) * 0.5;
	    var rCenter = r0 + dr;
	    var startAngle = shape.startAngle;
	    var endAngle = shape.endAngle;
	    var clockwise = shape.clockwise;
	    var unitStartX = Math.cos(startAngle);
	    var unitStartY = Math.sin(startAngle);
	    var unitEndX = Math.cos(endAngle);
	    var unitEndY = Math.sin(endAngle);
	    var lessThanCircle = clockwise ? endAngle - startAngle < Math.PI * 2 : startAngle - endAngle < Math.PI * 2;
	
	    if (lessThanCircle) {
	      ctx.moveTo(unitStartX * r0 + x, unitStartY * r0 + y);
	      ctx.arc(unitStartX * rCenter + x, unitStartY * rCenter + y, dr, -Math.PI + startAngle, startAngle, !clockwise);
	    }
	
	    ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
	    ctx.moveTo(unitEndX * r + x, unitEndY * r + y);
	    ctx.arc(unitEndX * rCenter + x, unitEndY * rCenter + y, dr, endAngle - Math.PI * 2, endAngle - Math.PI, !clockwise);
	
	    if (r0 !== 0) {
	      ctx.arc(x, y, r0, endAngle, startAngle, clockwise);
	      ctx.moveTo(unitStartX * r0 + x, unitEndY * r0 + y);
	    }
	
	    ctx.closePath();
	  }
	});
	
	module.exports = _default;

/***/ },
/* 1711 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(3);
	
	var lang = __webpack_require__(141);
	
	var _dataProvider = __webpack_require__(167);
	
	var retrieveRawValue = _dataProvider.retrieveRawValue;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(dom, ecModel) {
	  var ariaModel = ecModel.getModel('aria');
	
	  if (!ariaModel.get('show')) {
	    return;
	  } else if (ariaModel.get('description')) {
	    dom.setAttribute('aria-label', ariaModel.get('description'));
	    return;
	  }
	
	  var seriesCnt = 0;
	  ecModel.eachSeries(function (seriesModel, idx) {
	    ++seriesCnt;
	  }, this);
	  var maxDataCnt = ariaModel.get('data.maxCount') || 10;
	  var maxSeriesCnt = ariaModel.get('series.maxCount') || 10;
	  var displaySeriesCnt = Math.min(seriesCnt, maxSeriesCnt);
	  var ariaLabel;
	
	  if (seriesCnt < 1) {
	    // No series, no aria label
	    return;
	  } else {
	    var title = getTitle();
	
	    if (title) {
	      ariaLabel = replace(getConfig('general.withTitle'), {
	        title: title
	      });
	    } else {
	      ariaLabel = getConfig('general.withoutTitle');
	    }
	
	    var seriesLabels = [];
	    var prefix = seriesCnt > 1 ? 'series.multiple.prefix' : 'series.single.prefix';
	    ariaLabel += replace(getConfig(prefix), {
	      seriesCount: seriesCnt
	    });
	    ecModel.eachSeries(function (seriesModel, idx) {
	      if (idx < displaySeriesCnt) {
	        var seriesLabel;
	        var seriesName = seriesModel.get('name');
	        var seriesTpl = 'series.' + (seriesCnt > 1 ? 'multiple' : 'single') + '.';
	        seriesLabel = getConfig(seriesName ? seriesTpl + 'withName' : seriesTpl + 'withoutName');
	        seriesLabel = replace(seriesLabel, {
	          seriesId: seriesModel.seriesIndex,
	          seriesName: seriesModel.get('name'),
	          seriesType: getSeriesTypeName(seriesModel.subType)
	        });
	        var data = seriesModel.getData();
	        window.data = data;
	
	        if (data.count() > maxDataCnt) {
	          // Show part of data
	          seriesLabel += replace(getConfig('data.partialData'), {
	            displayCnt: maxDataCnt
	          });
	        } else {
	          seriesLabel += getConfig('data.allData');
	        }
	
	        var dataLabels = [];
	
	        for (var i = 0; i < data.count(); i++) {
	          if (i < maxDataCnt) {
	            var name = data.getName(i);
	            var value = retrieveRawValue(data, i);
	            dataLabels.push(replace(name ? getConfig('data.withName') : getConfig('data.withoutName'), {
	              name: name,
	              value: value
	            }));
	          }
	        }
	
	        seriesLabel += dataLabels.join(getConfig('data.separator.middle')) + getConfig('data.separator.end');
	        seriesLabels.push(seriesLabel);
	      }
	    });
	    ariaLabel += seriesLabels.join(getConfig('series.multiple.separator.middle')) + getConfig('series.multiple.separator.end');
	    dom.setAttribute('aria-label', ariaLabel);
	  }
	
	  function replace(str, keyValues) {
	    if (typeof str !== 'string') {
	      return str;
	    }
	
	    var result = str;
	    zrUtil.each(keyValues, function (value, key) {
	      result = result.replace(new RegExp('\\{\\s*' + key + '\\s*\\}', 'g'), value);
	    });
	    return result;
	  }
	
	  function getConfig(path) {
	    var userConfig = ariaModel.get(path);
	
	    if (userConfig == null) {
	      var pathArr = path.split('.');
	      var result = lang.aria;
	
	      for (var i = 0; i < pathArr.length; ++i) {
	        result = result[pathArr[i]];
	      }
	
	      return result;
	    } else {
	      return userConfig;
	    }
	  }
	
	  function getTitle() {
	    var title = ecModel.getModel('title').option;
	
	    if (title && title.length) {
	      title = title[0];
	    }
	
	    return title && title.text;
	  }
	
	  function getSeriesTypeName(type) {
	    return lang.series.typeNames[type] || '自定义图';
	  }
	}
	
	module.exports = _default;

/***/ },
/* 1712 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Gradient = __webpack_require__(386);
	
	var _util = __webpack_require__(3);
	
	var isFunction = _util.isFunction;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = {
	  createOnAllSeries: true,
	  performRawSeries: true,
	  reset: function (seriesModel, ecModel) {
	    var data = seriesModel.getData();
	    var colorAccessPath = (seriesModel.visualColorAccessPath || 'itemStyle.color').split('.'); // Set in itemStyle
	
	    var color = seriesModel.get(colorAccessPath);
	    var colorCallback = isFunction(color) && !(color instanceof Gradient) ? color : null; // Default color
	
	    if (!color || colorCallback) {
	      color = seriesModel.getColorFromPalette( // TODO series count changed.
	      seriesModel.name, null, ecModel.getSeriesCount());
	    }
	
	    data.setVisual('color', color);
	    var borderColorAccessPath = (seriesModel.visualBorderColorAccessPath || 'itemStyle.borderColor').split('.');
	    var borderColor = seriesModel.get(borderColorAccessPath);
	    data.setVisual('borderColor', borderColor); // Only visible series has each data be visual encoded
	
	    if (!ecModel.isSeriesFiltered(seriesModel)) {
	      if (colorCallback) {
	        data.each(function (idx) {
	          data.setItemVisual(idx, 'color', colorCallback(seriesModel.getDataParams(idx)));
	        });
	      } // itemStyle in each data item
	
	
	      var dataEach = function (data, idx) {
	        var itemModel = data.getItemModel(idx);
	        var color = itemModel.get(colorAccessPath, true);
	        var borderColor = itemModel.get(borderColorAccessPath, true);
	
	        if (color != null) {
	          data.setItemVisual(idx, 'color', color);
	        }
	
	        if (borderColor != null) {
	          data.setItemVisual(idx, 'borderColor', borderColor);
	        }
	      };
	
	      return {
	        dataEach: data.hasItemOption ? dataEach : null
	      };
	    }
	  }
	};
	module.exports = _default;

/***/ },
/* 1713 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1714 */
1713,
/* 1715 */
1713,
/* 1716 */
1713,
/* 1717 */
1713,
/* 1718 */
1713,
/* 1719 */
1713,
/* 1720 */
1713,
/* 1721 */
1713,
/* 1722 */
1713,
/* 1723 */
1713,
/* 1724 */
1713,
/* 1725 */
1713,
/* 1726 */
1713,
/* 1727 */
1713,
/* 1728 */
1713,
/* 1729 */
/***/ function(module, exports) {

	'use strict';
	
	var isArray = Array.isArray;
	var keyList = Object.keys;
	var hasProp = Object.prototype.hasOwnProperty;
	
	module.exports = function equal(a, b) {
	  if (a === b) return true;
	
	  if (a && b && typeof a == 'object' && typeof b == 'object') {
	    var arrA = isArray(a)
	      , arrB = isArray(b)
	      , i
	      , length
	      , key;
	
	    if (arrA && arrB) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (!equal(a[i], b[i])) return false;
	      return true;
	    }
	
	    if (arrA != arrB) return false;
	
	    var dateA = a instanceof Date
	      , dateB = b instanceof Date;
	    if (dateA != dateB) return false;
	    if (dateA && dateB) return a.getTime() == b.getTime();
	
	    var regexpA = a instanceof RegExp
	      , regexpB = b instanceof RegExp;
	    if (regexpA != regexpB) return false;
	    if (regexpA && regexpB) return a.toString() == b.toString();
	
	    var keys = keyList(a);
	    length = keys.length;
	
	    if (length !== keyList(b).length)
	      return false;
	
	    for (i = length; i-- !== 0;)
	      if (!hasProp.call(b, keys[i])) return false;
	
	    for (i = length; i-- !== 0;) {
	      key = keys[i];
	      if (!equal(a[key], b[key])) return false;
	    }
	
	    return true;
	  }
	
	  return a!==a && b!==b;
	};


/***/ },
/* 1730 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 1731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(1738);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 1732 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(28);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 1733 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(74);
	
	var createArrayFromMixed = __webpack_require__(1732);
	var getMarkupWrap = __webpack_require__(1734);
	var invariant = __webpack_require__(28);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 1734 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(74);
	
	var invariant = __webpack_require__(28);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 1735 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 1736 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 1737 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 1738 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(1737);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 1739 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var slice = Array.prototype.slice;
	var toStr = Object.prototype.toString;
	var funcType = '[object Function]';
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slice.call(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                args.concat(slice.call(arguments))
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        } else {
	            return target.apply(
	                that,
	                args.concat(slice.call(arguments))
	            );
	        }
	    };
	
	    var boundLength = Math.max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs.push('$' + i);
	    }
	
	    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ },
/* 1740 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSProperty
	 */
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowStart: true,
	  gridRowEnd: true,
	  gridColumn: true,
	  gridColumnStart: true,
	  gridColumnEnd: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	
	  /**
	   * @param {string} prefix vendor-specific prefix, eg: Webkit
	   * @param {string} key style name, eg: transitionDuration
	   * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	   * WebkitTransitionDuration
	   */
	};function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	exports.default = CSSProperty;

/***/ },
/* 1741 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CSSProperty = __webpack_require__(1740);
	
	var _CSSProperty2 = _interopRequireDefault(_CSSProperty);
	
	var _warning = __webpack_require__(34);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule dangerousStyleValue
	 */
	
	var isUnitlessNumber = _CSSProperty2.default.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	exports.default = dangerousStyleValue;

/***/ },
/* 1742 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = clean;
	// Returns true for null, false, undefined and {}
	function isFalsy(value) {
	  return value === null || value === undefined || value === false || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && Object.keys(value).length === 0;
	}
	
	function cleanObject(object) {
	  if (isFalsy(object)) return null;
	  if ((typeof object === 'undefined' ? 'undefined' : _typeof(object)) !== 'object') return object;
	
	  var acc = {},
	      keys = Object.keys(object),
	      hasFalsy = false;
	  for (var i = 0; i < keys.length; i++) {
	    var value = object[keys[i]];
	    var filteredValue = clean(value);
	    if (filteredValue === null || filteredValue !== value) {
	      hasFalsy = true;
	    }
	    if (filteredValue !== null) {
	      acc[keys[i]] = filteredValue;
	    }
	  }
	  return Object.keys(acc).length === 0 ? null : hasFalsy ? acc : object;
	}
	
	function cleanArray(rules) {
	  var hasFalsy = false;
	  var filtered = [];
	  rules.forEach(function (rule) {
	    var filteredRule = clean(rule);
	    if (filteredRule === null || filteredRule !== rule) {
	      hasFalsy = true;
	    }
	    if (filteredRule !== null) {
	      filtered.push(filteredRule);
	    }
	  });
	  return filtered.length == 0 ? null : hasFalsy ? filtered : rules;
	}
	
	// Takes style array or object provided by user and clears all the falsy data 
	// If there is no styles left after filtration returns null
	function clean(input) {
	  return Array.isArray(input) ? cleanArray(input) : cleanObject(input);
	}

/***/ },
/* 1743 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = doHash;
	// murmurhash2 via https://gist.github.com/raycmorgan/588423
	
	function doHash(str, seed) {
	  var m = 0x5bd1e995;
	  var r = 24;
	  var h = seed ^ str.length;
	  var length = str.length;
	  var currentIndex = 0;
	
	  while (length >= 4) {
	    var k = UInt32(str, currentIndex);
	
	    k = Umul32(k, m);
	    k ^= k >>> r;
	    k = Umul32(k, m);
	
	    h = Umul32(h, m);
	    h ^= k;
	
	    currentIndex += 4;
	    length -= 4;
	  }
	
	  switch (length) {
	    case 3:
	      h ^= UInt16(str, currentIndex);
	      h ^= str.charCodeAt(currentIndex + 2) << 16;
	      h = Umul32(h, m);
	      break;
	
	    case 2:
	      h ^= UInt16(str, currentIndex);
	      h = Umul32(h, m);
	      break;
	
	    case 1:
	      h ^= str.charCodeAt(currentIndex);
	      h = Umul32(h, m);
	      break;
	  }
	
	  h ^= h >>> 13;
	  h = Umul32(h, m);
	  h ^= h >>> 15;
	
	  return h >>> 0;
	}
	
	function UInt32(str, pos) {
	  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8) + (str.charCodeAt(pos++) << 16) + (str.charCodeAt(pos) << 24);
	}
	
	function UInt16(str, pos) {
	  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8);
	}
	
	function Umul32(n, m) {
	  n = n | 0;
	  m = m | 0;
	  var nlo = n & 0xffff;
	  var nhi = n >>> 16;
	  var res = nlo * m + ((nhi * m & 0xffff) << 16) | 0;
	  return res;
	}

/***/ },
/* 1744 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.PluginSet = PluginSet;
	exports.fallbacks = fallbacks;
	exports.contentWrap = contentWrap;
	exports.prefixes = prefixes;
	
	var _objectAssign = __webpack_require__(32);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _CSSPropertyOperations = __webpack_require__(761);
	
	var _prefixer = __webpack_require__(1745);
	
	var _prefixer2 = _interopRequireDefault(_prefixer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isDev = function (x) {
	  return x === 'development' || !x;
	}(("production"));
	
	function PluginSet(initial) {
	  this.fns = initial || [];
	}
	
	(0, _objectAssign2.default)(PluginSet.prototype, {
	  add: function add() {
	    var _this = this;
	
	    for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
	      fns[_key] = arguments[_key];
	    }
	
	    fns.forEach(function (fn) {
	      if (_this.fns.indexOf(fn) >= 0) {
	        if (isDev) {
	          console.warn('adding the same plugin again, ignoring'); //eslint-disable-line no-console
	        }
	      } else {
	        _this.fns = [fn].concat(_this.fns);
	      }
	    });
	  },
	  remove: function remove(fn) {
	    this.fns = this.fns.filter(function (x) {
	      return x !== fn;
	    });
	  },
	  clear: function clear() {
	    this.fns = [];
	  },
	  transform: function transform(o) {
	    return this.fns.reduce(function (o, fn) {
	      return fn(o);
	    }, o);
	  }
	});
	
	function fallbacks(node) {
	  var hasArray = Object.keys(node.style).map(function (x) {
	    return Array.isArray(node.style[x]);
	  }).indexOf(true) >= 0;
	  if (hasArray) {
	    var style = node.style;
	
	    var flattened = Object.keys(style).reduce(function (o, key) {
	      o[key] = Array.isArray(style[key]) ? style[key].join('; ' + (0, _CSSPropertyOperations.processStyleName)(key) + ': ') : style[key];
	      return o;
	    }, {});
	    // todo - 
	    // flatten arrays which haven't been flattened yet 
	    return (0, _objectAssign2.default)({}, node, { style: flattened });
	  }
	  return node;
	}
	
	var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit'];
	
	function contentWrap(node) {
	  if (node.style.content) {
	    var cont = node.style.content;
	    if (contentValues.indexOf(cont) >= 0) {
	      return node;
	    }
	    if (/^(attr|calc|counters?|url)\(/.test(cont)) {
	      return node;
	    }
	    if (cont.charAt(0) === cont.charAt(cont.length - 1) && (cont.charAt(0) === '"' || cont.charAt(0) === "'")) {
	      return node;
	    }
	    return _extends({}, node, { style: _extends({}, node.style, { content: '"' + cont + '"' }) });
	  }
	  return node;
	}
	
	function prefixes(node) {
	  return (0, _objectAssign2.default)({}, node, { style: (0, _prefixer2.default)(_extends({}, node.style)) });
	}

/***/ },
/* 1745 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixer;
	
	var _staticData = __webpack_require__(1762);
	
	var _staticData2 = _interopRequireDefault(_staticData);
	
	var _prefixProperty = __webpack_require__(1763);
	
	var _prefixProperty2 = _interopRequireDefault(_prefixProperty);
	
	var _prefixValue = __webpack_require__(1764);
	
	var _prefixValue2 = _interopRequireDefault(_prefixValue);
	
	var _cursor = __webpack_require__(1753);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _crossFade = __webpack_require__(1752);
	
	var _crossFade2 = _interopRequireDefault(_crossFade);
	
	var _filter = __webpack_require__(1754);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _flex = __webpack_require__(1755);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _flexboxOld = __webpack_require__(1756);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	var _gradient = __webpack_require__(1757);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _imageSet = __webpack_require__(1758);
	
	var _imageSet2 = _interopRequireDefault(_imageSet);
	
	var _position = __webpack_require__(1759);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _sizing = __webpack_require__(1760);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _transition = __webpack_require__(1761);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var plugins = [_crossFade2.default, _cursor2.default, _filter2.default, _flexboxOld2.default, _gradient2.default, _imageSet2.default, _position2.default, _sizing2.default, _transition2.default, _flex2.default]; // custom facade for inline-style-prefixer
	
	var prefixMap = _staticData2.default.prefixMap;
	
	function prefixer(style) {
	  for (var property in style) {
	    var value = style[property];
	
	    var processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);
	
	    // only modify the value if it was touched
	    // by any plugin to prevent unnecessary mutations
	    if (processedValue) {
	      style[property] = processedValue;
	    }
	
	    (0, _prefixProperty2.default)(prefixMap, property, style);
	  }
	  return style;
	}

/***/ },
/* 1746 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StyleSheet = StyleSheet;
	
	var _objectAssign = __webpack_require__(32);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/* 
	
	high performance StyleSheet for css-in-js systems 
	
	- uses multiple style tags behind the scenes for millions of rules 
	- uses `insertRule` for appending in production for *much* faster performance
	- 'polyfills' on server side 
	
	
	// usage
	
	import StyleSheet from 'glamor/lib/sheet'
	let styleSheet = new StyleSheet()
	
	styleSheet.inject() 
	- 'injects' the stylesheet into the page (or into memory if on server)
	
	styleSheet.insert('#box { border: 1px solid red; }') 
	- appends a css rule into the stylesheet 
	
	styleSheet.flush() 
	- empties the stylesheet of all its contents
	
	
	*/
	
	function last(arr) {
	  return arr[arr.length - 1];
	}
	
	function sheetForTag(tag) {
	  if (tag.sheet) {
	    return tag.sheet;
	  }
	
	  // this weirdness brought to you by firefox 
	  for (var i = 0; i < document.styleSheets.length; i++) {
	    if (document.styleSheets[i].ownerNode === tag) {
	      return document.styleSheets[i];
	    }
	  }
	}
	
	var isBrowser = typeof window !== 'undefined';
	var isDev = ("production") === 'development' || !("production"); //(x => (x === 'development') || !x)(process.env.NODE_ENV)
	var isTest = ("production") === 'test';
	
	var oldIE = function () {
	  if (isBrowser) {
	    var div = document.createElement('div');
	    div.innerHTML = '<!--[if lt IE 10]><i></i><![endif]-->';
	    return div.getElementsByTagName('i').length === 1;
	  }
	}();
	
	function makeStyleTag() {
	  var tag = document.createElement('style');
	  tag.type = 'text/css';
	  tag.setAttribute('data-glamor', '');
	  tag.appendChild(document.createTextNode(''));
	  (document.head || document.getElementsByTagName('head')[0]).appendChild(tag);
	  return tag;
	}
	
	function StyleSheet() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$speedy = _ref.speedy,
	      speedy = _ref$speedy === undefined ? !isDev && !isTest : _ref$speedy,
	      _ref$maxLength = _ref.maxLength,
	      maxLength = _ref$maxLength === undefined ? isBrowser && oldIE ? 4000 : 65000 : _ref$maxLength;
	
	  this.isSpeedy = speedy; // the big drawback here is that the css won't be editable in devtools
	  this.sheet = undefined;
	  this.tags = [];
	  this.maxLength = maxLength;
	  this.ctr = 0;
	}
	
	(0, _objectAssign2.default)(StyleSheet.prototype, {
	  getSheet: function getSheet() {
	    return sheetForTag(last(this.tags));
	  },
	  inject: function inject() {
	    var _this = this;
	
	    if (this.injected) {
	      throw new Error('already injected stylesheet!');
	    }
	    if (isBrowser) {
	      this.tags[0] = makeStyleTag();
	    } else {
	      // server side 'polyfill'. just enough behavior to be useful.
	      this.sheet = {
	        cssRules: [],
	        insertRule: function insertRule(rule) {
	          // enough 'spec compliance' to be able to extract the rules later  
	          // in other words, just the cssText field 
	          _this.sheet.cssRules.push({ cssText: rule });
	        }
	      };
	    }
	    this.injected = true;
	  },
	  speedy: function speedy(bool) {
	    if (this.ctr !== 0) {
	      throw new Error('cannot change speedy mode after inserting any rule to sheet. Either call speedy(' + bool + ') earlier in your app, or call flush() before speedy(' + bool + ')');
	    }
	    this.isSpeedy = !!bool;
	  },
	  _insert: function _insert(rule) {
	    // this weirdness for perf, and chrome's weird bug 
	    // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
	    try {
	      var sheet = this.getSheet();
	      sheet.insertRule(rule, rule.indexOf('@import') !== -1 ? 0 : sheet.cssRules.length);
	    } catch (e) {
	      if (isDev) {
	        // might need beter dx for this 
	        console.warn('whoops, illegal rule inserted', rule); //eslint-disable-line no-console
	      }
	    }
	  },
	  insert: function insert(rule) {
	
	    if (isBrowser) {
	      // this is the ultrafast version, works across browsers 
	      if (this.isSpeedy && this.getSheet().insertRule) {
	        this._insert(rule);
	      }
	      // more browser weirdness. I don't even know    
	      // else if(this.tags.length > 0 && this.tags::last().styleSheet) {      
	      //   this.tags::last().styleSheet.cssText+= rule
	      // }
	      else {
	          if (rule.indexOf('@import') !== -1) {
	            var tag = last(this.tags);
	            tag.insertBefore(document.createTextNode(rule), tag.firstChild);
	          } else {
	            last(this.tags).appendChild(document.createTextNode(rule));
	          }
	        }
	    } else {
	      // server side is pretty simple         
	      this.sheet.insertRule(rule, rule.indexOf('@import') !== -1 ? 0 : this.sheet.cssRules.length);
	    }
	
	    this.ctr++;
	    if (isBrowser && this.ctr % this.maxLength === 0) {
	      this.tags.push(makeStyleTag());
	    }
	    return this.ctr - 1;
	  },
	
	  // commenting this out till we decide on v3's decision 
	  // _replace(index, rule) {
	  //   // this weirdness for perf, and chrome's weird bug 
	  //   // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
	  //   try {  
	  //     let sheet = this.getSheet()        
	  //     sheet.deleteRule(index) // todo - correct index here     
	  //     sheet.insertRule(rule, index)
	  //   }
	  //   catch(e) {
	  //     if(isDev) {
	  //       // might need beter dx for this 
	  //       console.warn('whoops, problem replacing rule', rule) //eslint-disable-line no-console
	  //     }          
	  //   }          
	
	  // }
	  // replace(index, rule) {
	  //   if(isBrowser) {
	  //     if(this.isSpeedy && this.getSheet().insertRule) {
	  //       this._replace(index, rule)
	  //     }
	  //     else {
	  //       let _slot = Math.floor((index  + this.maxLength) / this.maxLength) - 1        
	  //       let _index = (index % this.maxLength) + 1
	  //       let tag = this.tags[_slot]
	  //       tag.replaceChild(document.createTextNode(rule), tag.childNodes[_index])
	  //     }
	  //   }
	  //   else {
	  //     let rules = this.sheet.cssRules
	  //     this.sheet.cssRules = [ ...rules.slice(0, index), { cssText: rule }, ...rules.slice(index + 1) ]
	  //   }
	  // }
	  delete: function _delete(index) {
	    // we insert a blank rule when 'deleting' so previously returned indexes remain stable
	    return this.replace(index, '');
	  },
	  flush: function flush() {
	    if (isBrowser) {
	      this.tags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	      });
	      this.tags = [];
	      this.sheet = null;
	      this.ctr = 0;
	      // todo - look for remnants in document.styleSheets
	    } else {
	      // simpler on server 
	      this.sheet.cssRules = [];
	    }
	    this.injected = false;
	  },
	  rules: function rules() {
	    if (!isBrowser) {
	      return this.sheet.cssRules;
	    }
	    var arr = [];
	    this.tags.forEach(function (tag) {
	      return arr.splice.apply(arr, [arr.length, 0].concat(_toConsumableArray(Array.from(sheetForTag(tag).cssRules))));
	    });
	    return arr;
	  }
	});

/***/ },
/* 1747 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint complexity: [2, 18], max-statements: [2, 33] */
	module.exports = function hasSymbols() {
		if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
		if (typeof Symbol.iterator === 'symbol') { return true; }
	
		var obj = {};
		var sym = Symbol('test');
		var symObj = Object(sym);
		if (typeof sym === 'string') { return false; }
	
		if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
		if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }
	
		// temp disabled per https://github.com/ljharb/object.assign/issues/17
		// if (sym instanceof Symbol) { return false; }
		// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
		// if (!(symObj instanceof Symbol)) { return false; }
	
		// if (typeof Symbol.prototype.toString !== 'function') { return false; }
		// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
	
		var symVal = 42;
		obj[sym] = symVal;
		for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax
		if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }
	
		if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }
	
		var syms = Object.getOwnPropertySymbols(obj);
		if (syms.length !== 1 || syms[0] !== sym) { return false; }
	
		if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }
	
		if (typeof Object.getOwnPropertyDescriptor === 'function') {
			var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
			if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
		}
	
		return true;
	};


/***/ },
/* 1748 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var _slice = Array.prototype.slice;
	exports.loopAsync = loopAsync;
	
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = undefined;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(_slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}

/***/ },
/* 1749 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(209);
	
	var _PathUtils = __webpack_require__(171);
	
	var _ExecutionEnvironment = __webpack_require__(344);
	
	var _DOMUtils = __webpack_require__(480);
	
	var _DOMStateStorage = __webpack_require__(762);
	
	var _createDOMHistory = __webpack_require__(763);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve URLs.
	 */
	function createBrowserHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var forceRefresh = options.forceRefresh;
	
	  var isSupported = _DOMUtils.supportsHistory();
	  var useRefresh = !isSupported || forceRefresh;
	
	  function getCurrentLocation(historyState) {
	    try {
	      historyState = historyState || window.history.state || {};
	    } catch (e) {
	      historyState = {};
	    }
	
	    var path = _DOMUtils.getWindowPath();
	    var _historyState = historyState;
	    var key = _historyState.key;
	
	    var state = undefined;
	    if (key) {
	      state = _DOMStateStorage.readState(key);
	    } else {
	      state = null;
	      key = history.createKey();
	
	      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null);
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startPopStateListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function popStateListener(event) {
	      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.
	
	      transitionTo(getCurrentLocation(event.state));
	    }
	
	    _DOMUtils.addEventListener(window, 'popstate', popStateListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    _DOMStateStorage.saveState(key, state);
	
	    var path = (basename || '') + pathname + search + hash;
	    var historyState = {
	      key: key
	    };
	
	    if (action === _Actions.PUSH) {
	      if (useRefresh) {
	        window.location.href = path;
	        return false; // Prevent location update.
	      } else {
	          window.history.pushState(historyState, null, path);
	        }
	    } else {
	      // REPLACE
	      if (useRefresh) {
	        window.location.replace(path);
	        return false; // Prevent location update.
	      } else {
	          window.history.replaceState(historyState, null, path);
	        }
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopPopStateListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopPopStateListener();
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    registerTransitionHook: registerTransitionHook,
	    unregisterTransitionHook: unregisterTransitionHook
	  });
	}
	
	exports['default'] = createBrowserHistory;
	module.exports = exports['default'];

/***/ },
/* 1750 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(108);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Actions = __webpack_require__(209);
	
	var _PathUtils = __webpack_require__(171);
	
	function createLocation() {
	  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
	  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	
	  if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	  if (typeof action === 'object') {
	     false ? _warning2['default'](false, 'The state (2nd) argument to createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	    location = _extends({}, location, { state: action });
	
	    action = key || _Actions.POP;
	    key = _fourthArg;
	  }
	
	  var pathname = location.pathname || '/';
	  var search = location.search || '';
	  var hash = location.hash || '';
	  var state = location.state || null;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	}
	
	exports['default'] = createLocation;
	module.exports = exports['default'];

/***/ },
/* 1751 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(108);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PathUtils = __webpack_require__(171);
	
	var _Actions = __webpack_require__(209);
	
	var _createHistory = __webpack_require__(765);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	}
	
	function createMemoryHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var history = _createHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: saveState,
	    go: go
	  }));
	
	  var _options = options;
	  var entries = _options.entries;
	  var current = _options.current;
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    var key = history.createKey();
	
	    if (typeof entry === 'string') return { pathname: entry, key: key };
	
	    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });
	
	     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
	  }
	
	  var storage = createStateStorage(entries);
	
	  function saveState(key, state) {
	    storage[key] = state;
	  }
	
	  function readState(key) {
	    return storage[key];
	  }
	
	  function getCurrentLocation() {
	    var entry = entries[current];
	    var basename = entry.basename;
	    var pathname = entry.pathname;
	    var search = entry.search;
	
	    var path = (basename || '') + pathname + (search || '');
	
	    var key = undefined,
	        state = undefined;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    } else {
	      key = history.createKey();
	      state = null;
	      entry.key = key;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  }
	
	  function go(n) {
	    if (n) {
	      if (!canGo(n)) {
	         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
	        return;
	      }
	
	      current += n;
	
	      var currentLocation = getCurrentLocation();
	
	      // change action to POP
	      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	    }
	  }
	
	  function finishTransition(location) {
	    switch (location.action) {
	      case _Actions.PUSH:
	        current += 1;
	
	        // if we are not on the top of stack
	        // remove rest and push new
	        if (current < entries.length) entries.splice(current);
	
	        entries.push(location);
	        saveState(location.key, location.state);
	        break;
	      case _Actions.REPLACE:
	        entries[current] = location;
	        saveState(location.key, location.state);
	        break;
	    }
	  }
	
	  return history;
	}
	
	exports['default'] = createMemoryHistory;
	module.exports = exports['default'];

/***/ },
/* 1752 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = crossFade;
	
	var _isPrefixedValue = __webpack_require__(256);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://caniuse.com/#search=cross-fade
	var prefixes = ['-webkit-', ''];
	function crossFade(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('cross-fade(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/cross-fade\(/g, prefix + 'cross-fade(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1753 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cursor;
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var values = {
	  'zoom-in': true,
	  'zoom-out': true,
	  grab: true,
	  grabbing: true
	};
	
	function cursor(property, value) {
	  if (property === 'cursor' && values.hasOwnProperty(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1754 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = filter;
	
	var _isPrefixedValue = __webpack_require__(256);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://caniuse.com/#feat=css-filter-function
	var prefixes = ['-webkit-', ''];
	function filter(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('filter(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/filter\(/g, prefix + 'filter(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1755 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	var values = {
	  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
	  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
	};
	
	function flex(property, value) {
	  if (property === 'display' && values.hasOwnProperty(value)) {
	    return values[value];
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1756 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	function flexboxOld(property, value, style) {
	  if (property === 'flexDirection' && typeof value === 'string') {
	    if (value.indexOf('column') > -1) {
	      style.WebkitBoxOrient = 'vertical';
	    } else {
	      style.WebkitBoxOrient = 'horizontal';
	    }
	    if (value.indexOf('reverse') > -1) {
	      style.WebkitBoxDirection = 'reverse';
	    } else {
	      style.WebkitBoxDirection = 'normal';
	    }
	  }
	  if (alternativeProps.hasOwnProperty(property)) {
	    style[alternativeProps[property]] = alternativeValues[value] || value;
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1757 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _isPrefixedValue = __webpack_require__(256);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1758 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = imageSet;
	
	var _isPrefixedValue = __webpack_require__(256);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://caniuse.com/#feat=css-image-set
	var prefixes = ['-webkit-', ''];
	function imageSet(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('image-set(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/image-set\(/g, prefix + 'image-set(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1759 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = position;
	function position(property, value) {
	  if (property === 'position' && value === 'sticky') {
	    return ['-webkit-sticky', 'sticky'];
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1760 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(property, value) {
	  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1761 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateProperty = __webpack_require__(1427);
	
	var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);
	
	var _isPrefixedValue = __webpack_require__(256);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	var _capitalizeString = __webpack_require__(768);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true,
	  MozTransition: true,
	  MozTransitionProperty: true
	};
	
	
	var prefixMapping = {
	  Webkit: '-webkit-',
	  Moz: '-moz-',
	  ms: '-ms-'
	};
	
	function prefixValue(value, propertyPrefixMap) {
	  if ((0, _isPrefixedValue2.default)(value)) {
	    return value;
	  }
	
	  // only split multi values, not cubic beziers
	  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	  for (var i = 0, len = multipleValues.length; i < len; ++i) {
	    var singleValue = multipleValues[i];
	    var values = [singleValue];
	    for (var property in propertyPrefixMap) {
	      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);
	
	      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
	        var prefixes = propertyPrefixMap[property];
	        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
	          // join all prefixes and create a new value
	          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
	        }
	      }
	    }
	
	    multipleValues[i] = values.join(',');
	  }
	
	  return multipleValues.join(',');
	}
	
	function transition(property, value, style, propertyPrefixMap) {
	  // also check for already prefixed transitions
	  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
	    var outputValue = prefixValue(value, propertyPrefixMap);
	    // if the property is already prefixed
	    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
	      return !/-moz-|-ms-/.test(val);
	    }).join(',');
	
	    if (property.indexOf('Webkit') > -1) {
	      return webkitOutput;
	    }
	
	    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
	      return !/-webkit-|-ms-/.test(val);
	    }).join(',');
	
	    if (property.indexOf('Moz') > -1) {
	      return mozOutput;
	    }
	
	    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
	    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
	    return outputValue;
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1762 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var w = ["Webkit"];
	var m = ["Moz"];
	var ms = ["ms"];
	var wm = ["Webkit", "Moz"];
	var wms = ["Webkit", "ms"];
	var wmms = ["Webkit", "Moz", "ms"];
	
	exports.default = {
	  plugins: [],
	  prefixMap: { "appearance": wm, "userSelect": wmms, "textEmphasisPosition": w, "textEmphasis": w, "textEmphasisStyle": w, "textEmphasisColor": w, "boxDecorationBreak": w, "clipPath": w, "maskImage": w, "maskMode": w, "maskRepeat": w, "maskPosition": w, "maskClip": w, "maskOrigin": w, "maskSize": w, "maskComposite": w, "mask": w, "maskBorderSource": w, "maskBorderMode": w, "maskBorderSlice": w, "maskBorderWidth": w, "maskBorderOutset": w, "maskBorderRepeat": w, "maskBorder": w, "maskType": w, "textDecorationStyle": w, "textDecorationSkip": w, "textDecorationLine": w, "textDecorationColor": w, "filter": w, "fontFeatureSettings": w, "breakAfter": wmms, "breakBefore": wmms, "breakInside": wmms, "columnCount": wm, "columnFill": wm, "columnGap": wm, "columnRule": wm, "columnRuleColor": wm, "columnRuleStyle": wm, "columnRuleWidth": wm, "columns": wm, "columnSpan": wm, "columnWidth": wm, "writingMode": wms, "flex": w, "flexBasis": w, "flexDirection": w, "flexGrow": w, "flexFlow": w, "flexShrink": w, "flexWrap": w, "alignContent": w, "alignItems": w, "alignSelf": w, "justifyContent": w, "order": w, "transform": w, "transformOrigin": w, "transformOriginX": w, "transformOriginY": w, "backfaceVisibility": w, "perspective": w, "perspectiveOrigin": w, "transformStyle": w, "transformOriginZ": w, "animation": w, "animationDelay": w, "animationDirection": w, "animationFillMode": w, "animationDuration": w, "animationIterationCount": w, "animationName": w, "animationPlayState": w, "animationTimingFunction": w, "backdropFilter": w, "fontKerning": w, "scrollSnapType": wms, "scrollSnapPointsX": wms, "scrollSnapPointsY": wms, "scrollSnapDestination": wms, "scrollSnapCoordinate": wms, "shapeImageThreshold": w, "shapeImageMargin": w, "shapeImageOutside": w, "hyphens": wmms, "flowInto": wms, "flowFrom": wms, "regionFragment": wms, "textAlignLast": m, "tabSize": m, "wrapFlow": ms, "wrapThrough": ms, "wrapMargin": ms, "gridTemplateColumns": ms, "gridTemplateRows": ms, "gridTemplateAreas": ms, "gridTemplate": ms, "gridAutoColumns": ms, "gridAutoRows": ms, "gridAutoFlow": ms, "grid": ms, "gridRowStart": ms, "gridColumnStart": ms, "gridRowEnd": ms, "gridRow": ms, "gridColumn": ms, "gridColumnEnd": ms, "gridColumnGap": ms, "gridRowGap": ms, "gridArea": ms, "gridGap": ms, "textSizeAdjust": wms, "borderImage": w, "borderImageOutset": w, "borderImageRepeat": w, "borderImageSlice": w, "borderImageSource": w, "borderImageWidth": w, "transitionDelay": w, "transitionDuration": w, "transitionProperty": w, "transitionTimingFunction": w }
	};
	module.exports = exports["default"];

/***/ },
/* 1763 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixProperty;
	
	var _capitalizeString = __webpack_require__(768);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function prefixProperty(prefixProperties, property, style) {
	  if (prefixProperties.hasOwnProperty(property)) {
	    var requiredPrefixes = prefixProperties[property];
	    for (var i = 0, len = requiredPrefixes.length; i < len; ++i) {
	      style[requiredPrefixes[i] + (0, _capitalizeString2.default)(property)] = style[property];
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1764 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixValue;
	function prefixValue(plugins, property, value, style, metaData) {
	  for (var i = 0, len = plugins.length; i < len; ++i) {
	    var processedValue = plugins[i](property, value, style, metaData);
	
	    // we can stop processing if a value is returned
	    // as all plugin criteria are unique
	    if (processedValue) {
	      return processedValue;
	    }
	  }
	}
	module.exports = exports["default"];

/***/ },
/* 1765 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	var callBound = __webpack_require__(1424);
	
	var $toString = callBound('Object.prototype.toString');
	
	var isStandardArguments = function isArguments(value) {
		if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
			return false;
		}
		return $toString(value) === '[object Arguments]';
	};
	
	var isLegacyArguments = function isArguments(value) {
		if (isStandardArguments(value)) {
			return true;
		}
		return value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			$toString(value) !== '[object Array]' &&
			$toString(value.callee) === '[object Function]';
	};
	
	var supportsStandardArguments = (function () {
		return isStandardArguments(arguments);
	}());
	
	isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests
	
	module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ },
/* 1766 */
/***/ function(module, exports) {

	'use strict';
	
	var getDay = Date.prototype.getDay;
	var tryDateObject = function tryDateGetDayCall(value) {
		try {
			getDay.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	
	var toStr = Object.prototype.toString;
	var dateClass = '[object Date]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isDateObject(value) {
		if (typeof value !== 'object' || value === null) {
			return false;
		}
		return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
	};


/***/ },
/* 1767 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasSymbols = __webpack_require__(343)();
	var hasToStringTag = hasSymbols && typeof Symbol.toStringTag === 'symbol';
	var hasOwnProperty;
	var regexExec;
	var isRegexMarker;
	var badStringifier;
	
	if (hasToStringTag) {
		hasOwnProperty = Function.call.bind(Object.prototype.hasOwnProperty);
		regexExec = Function.call.bind(RegExp.prototype.exec);
		isRegexMarker = {};
	
		var throwRegexMarker = function () {
			throw isRegexMarker;
		};
		badStringifier = {
			toString: throwRegexMarker,
			valueOf: throwRegexMarker
		};
	
		if (typeof Symbol.toPrimitive === 'symbol') {
			badStringifier[Symbol.toPrimitive] = throwRegexMarker;
		}
	}
	
	var toStr = Object.prototype.toString;
	var gOPD = Object.getOwnPropertyDescriptor;
	var regexClass = '[object RegExp]';
	
	module.exports = hasToStringTag
		// eslint-disable-next-line consistent-return
		? function isRegex(value) {
			if (!value || typeof value !== 'object') {
				return false;
			}
	
			var descriptor = gOPD(value, 'lastIndex');
			var hasLastIndexDataProperty = descriptor && hasOwnProperty(descriptor, 'value');
			if (!hasLastIndexDataProperty) {
				return false;
			}
	
			try {
				regexExec(value, badStringifier);
			} catch (e) {
				return e === isRegexMarker;
			}
		}
		: function isRegex(value) {
			// In older browsers, typeof regex incorrectly returns 'function'
			if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
				return false;
			}
	
			return toStr.call(value) === regexClass;
		};


/***/ },
/* 1768 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var hyphenate = __webpack_require__(767);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var hyphenate__default = /*#__PURE__*/_interopDefaultLegacy(hyphenate);
	
	/**
	 * Convert camel cased property names to dash separated.
	 *
	 * @param {Object} style
	 * @return {Object}
	 */
	
	function convertCase(style) {
	  var converted = {};
	
	  for (var prop in style) {
	    var key = prop.indexOf('--') === 0 ? prop : hyphenate__default['default'](prop);
	    converted[key] = style[prop];
	  }
	
	  if (style.fallbacks) {
	    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
	  }
	
	  return converted;
	}
	/**
	 * Allow camel cased property names by converting them back to dasherized.
	 *
	 * @param {Rule} rule
	 */
	
	
	function camelCase() {
	  function onProcessStyle(style) {
	    if (Array.isArray(style)) {
	      // Handle rules like @font-face, which can have multiple styles in an array
	      for (var index = 0; index < style.length; index++) {
	        style[index] = convertCase(style[index]);
	      }
	
	      return style;
	    }
	
	    return convertCase(style);
	  }
	
	  function onChangeValue(value, prop, rule) {
	    if (prop.indexOf('--') === 0) {
	      return value;
	    }
	
	    var hyphenatedProp = hyphenate__default['default'](prop); // There was no camel case in place
	
	    if (prop === hyphenatedProp) return value;
	    rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
	
	    return null;
	  }
	
	  return {
	    onProcessStyle: onProcessStyle,
	    onChangeValue: onChangeValue
	  };
	}
	
	exports.default = camelCase;


/***/ },
/* 1769 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var jss = __webpack_require__(172);
	
	var px = jss.hasCSSTOMSupport && CSS ? CSS.px : 'px';
	var ms = jss.hasCSSTOMSupport && CSS ? CSS.ms : 'ms';
	var percent = jss.hasCSSTOMSupport && CSS ? CSS.percent : '%';
	/**
	 * Generated jss-plugin-default-unit CSS property units
	 *
	 * @type object
	 */
	
	var defaultUnits = {
	  // Animation properties
	  'animation-delay': ms,
	  'animation-duration': ms,
	  // Background properties
	  'background-position': px,
	  'background-position-x': px,
	  'background-position-y': px,
	  'background-size': px,
	  // Border Properties
	  border: px,
	  'border-bottom': px,
	  'border-bottom-left-radius': px,
	  'border-bottom-right-radius': px,
	  'border-bottom-width': px,
	  'border-left': px,
	  'border-left-width': px,
	  'border-radius': px,
	  'border-right': px,
	  'border-right-width': px,
	  'border-top': px,
	  'border-top-left-radius': px,
	  'border-top-right-radius': px,
	  'border-top-width': px,
	  'border-width': px,
	  'border-block': px,
	  'border-block-end': px,
	  'border-block-end-width': px,
	  'border-block-start': px,
	  'border-block-start-width': px,
	  'border-block-width': px,
	  'border-inline': px,
	  'border-inline-end': px,
	  'border-inline-end-width': px,
	  'border-inline-start': px,
	  'border-inline-start-width': px,
	  'border-inline-width': px,
	  'border-start-start-radius': px,
	  'border-start-end-radius': px,
	  'border-end-start-radius': px,
	  'border-end-end-radius': px,
	  // Margin properties
	  margin: px,
	  'margin-bottom': px,
	  'margin-left': px,
	  'margin-right': px,
	  'margin-top': px,
	  'margin-block': px,
	  'margin-block-end': px,
	  'margin-block-start': px,
	  'margin-inline': px,
	  'margin-inline-end': px,
	  'margin-inline-start': px,
	  // Padding properties
	  padding: px,
	  'padding-bottom': px,
	  'padding-left': px,
	  'padding-right': px,
	  'padding-top': px,
	  'padding-block': px,
	  'padding-block-end': px,
	  'padding-block-start': px,
	  'padding-inline': px,
	  'padding-inline-end': px,
	  'padding-inline-start': px,
	  // Mask properties
	  'mask-position-x': px,
	  'mask-position-y': px,
	  'mask-size': px,
	  // Width and height properties
	  height: px,
	  width: px,
	  'min-height': px,
	  'max-height': px,
	  'min-width': px,
	  'max-width': px,
	  // Position properties
	  bottom: px,
	  left: px,
	  top: px,
	  right: px,
	  inset: px,
	  'inset-block': px,
	  'inset-block-end': px,
	  'inset-block-start': px,
	  'inset-inline': px,
	  'inset-inline-end': px,
	  'inset-inline-start': px,
	  // Shadow properties
	  'box-shadow': px,
	  'text-shadow': px,
	  // Column properties
	  'column-gap': px,
	  'column-rule': px,
	  'column-rule-width': px,
	  'column-width': px,
	  // Font and text properties
	  'font-size': px,
	  'font-size-delta': px,
	  'letter-spacing': px,
	  'text-indent': px,
	  'text-stroke': px,
	  'text-stroke-width': px,
	  'word-spacing': px,
	  // Motion properties
	  motion: px,
	  'motion-offset': px,
	  // Outline properties
	  outline: px,
	  'outline-offset': px,
	  'outline-width': px,
	  // Perspective properties
	  perspective: px,
	  'perspective-origin-x': percent,
	  'perspective-origin-y': percent,
	  // Transform properties
	  'transform-origin': percent,
	  'transform-origin-x': percent,
	  'transform-origin-y': percent,
	  'transform-origin-z': percent,
	  // Transition properties
	  'transition-delay': ms,
	  'transition-duration': ms,
	  // Alignment properties
	  'vertical-align': px,
	  'flex-basis': px,
	  // Some random properties
	  'shape-margin': px,
	  size: px,
	  gap: px,
	  // Grid properties
	  grid: px,
	  'grid-gap': px,
	  'grid-row-gap': px,
	  'grid-column-gap': px,
	  'grid-template-rows': px,
	  'grid-template-columns': px,
	  'grid-auto-rows': px,
	  'grid-auto-columns': px,
	  // Not existing properties.
	  // Used to avoid issues with jss-plugin-expand integration.
	  'box-shadow-x': px,
	  'box-shadow-y': px,
	  'box-shadow-blur': px,
	  'box-shadow-spread': px,
	  'font-line-height': px,
	  'text-shadow-x': px,
	  'text-shadow-y': px,
	  'text-shadow-blur': px
	};
	
	/**
	 * Clones the object and adds a camel cased property version.
	 */
	function addCamelCasedVersion(obj) {
	  var regExp = /(-[a-z])/g;
	
	  var replace = function replace(str) {
	    return str[1].toUpperCase();
	  };
	
	  var newObj = {};
	
	  for (var _key in obj) {
	    newObj[_key] = obj[_key];
	    newObj[_key.replace(regExp, replace)] = obj[_key];
	  }
	
	  return newObj;
	}
	
	var units = addCamelCasedVersion(defaultUnits);
	/**
	 * Recursive deep style passing function
	 */
	
	function iterate(prop, value, options) {
	  if (value == null) return value;
	
	  if (Array.isArray(value)) {
	    for (var i = 0; i < value.length; i++) {
	      value[i] = iterate(prop, value[i], options);
	    }
	  } else if (typeof value === 'object') {
	    if (prop === 'fallbacks') {
	      for (var innerProp in value) {
	        value[innerProp] = iterate(innerProp, value[innerProp], options);
	      }
	    } else {
	      for (var _innerProp in value) {
	        value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
	      }
	    }
	  } else if (typeof value === 'number') {
	    var unit = options[prop] || units[prop]; // Add the unit if available, except for the special case of 0px.
	
	    if (unit && !(value === 0 && unit === px)) {
	      return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
	    }
	
	    return value.toString();
	  }
	
	  return value;
	}
	/**
	 * Add unit to numeric values.
	 */
	
	
	function defaultUnit(options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var camelCasedOptions = addCamelCasedVersion(options);
	
	  function onProcessStyle(style, rule) {
	    if (rule.type !== 'style') return style;
	
	    for (var prop in style) {
	      style[prop] = iterate(prop, style[prop], camelCasedOptions);
	    }
	
	    return style;
	  }
	
	  function onChangeValue(value, prop) {
	    return iterate(prop, value, camelCasedOptions);
	  }
	
	  return {
	    onProcessStyle: onProcessStyle,
	    onChangeValue: onChangeValue
	  };
	}
	
	exports.default = defaultUnit;


/***/ },
/* 1770 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var _extends = __webpack_require__(6);
	var jss = __webpack_require__(172);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
	
	var at = '@global';
	var atPrefix = '@global ';
	
	var GlobalContainerRule =
	/*#__PURE__*/
	function () {
	  function GlobalContainerRule(key, styles, options) {
	    this.type = 'global';
	    this.at = at;
	    this.rules = void 0;
	    this.options = void 0;
	    this.key = void 0;
	    this.isProcessed = false;
	    this.key = key;
	    this.options = options;
	    this.rules = new jss.RuleList(_extends__default['default']({}, options, {
	      parent: this
	    }));
	
	    for (var selector in styles) {
	      this.rules.add(selector, styles[selector]);
	    }
	
	    this.rules.process();
	  }
	  /**
	   * Get a rule.
	   */
	
	
	  var _proto = GlobalContainerRule.prototype;
	
	  _proto.getRule = function getRule(name) {
	    return this.rules.get(name);
	  }
	  /**
	   * Create and register rule, run plugins.
	   */
	  ;
	
	  _proto.addRule = function addRule(name, style, options) {
	    var rule = this.rules.add(name, style, options);
	    if (rule) this.options.jss.plugins.onProcessRule(rule);
	    return rule;
	  }
	  /**
	   * Get index of a rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(rule) {
	    return this.rules.indexOf(rule);
	  }
	  /**
	   * Generates a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString() {
	    return this.rules.toString();
	  };
	
	  return GlobalContainerRule;
	}();
	
	var GlobalPrefixedRule =
	/*#__PURE__*/
	function () {
	  function GlobalPrefixedRule(key, style, options) {
	    this.type = 'global';
	    this.at = at;
	    this.options = void 0;
	    this.rule = void 0;
	    this.isProcessed = false;
	    this.key = void 0;
	    this.key = key;
	    this.options = options;
	    var selector = key.substr(atPrefix.length);
	    this.rule = options.jss.createRule(selector, style, _extends__default['default']({}, options, {
	      parent: this
	    }));
	  }
	
	  var _proto2 = GlobalPrefixedRule.prototype;
	
	  _proto2.toString = function toString(options) {
	    return this.rule ? this.rule.toString(options) : '';
	  };
	
	  return GlobalPrefixedRule;
	}();
	
	var separatorRegExp = /\s*,\s*/g;
	
	function addScope(selector, scope) {
	  var parts = selector.split(separatorRegExp);
	  var scoped = '';
	
	  for (var i = 0; i < parts.length; i++) {
	    scoped += scope + " " + parts[i].trim();
	    if (parts[i + 1]) scoped += ', ';
	  }
	
	  return scoped;
	}
	
	function handleNestedGlobalContainerRule(rule, sheet) {
	  var options = rule.options,
	      style = rule.style;
	  var rules = style ? style[at] : null;
	  if (!rules) return;
	
	  for (var name in rules) {
	    sheet.addRule(name, rules[name], _extends__default['default']({}, options, {
	      selector: addScope(name, rule.selector)
	    }));
	  }
	
	  delete style[at];
	}
	
	function handlePrefixedGlobalRule(rule, sheet) {
	  var options = rule.options,
	      style = rule.style;
	
	  for (var prop in style) {
	    if (prop[0] !== '@' || prop.substr(0, at.length) !== at) continue;
	    var selector = addScope(prop.substr(at.length), rule.selector);
	    sheet.addRule(selector, style[prop], _extends__default['default']({}, options, {
	      selector: selector
	    }));
	    delete style[prop];
	  }
	}
	/**
	 * Convert nested rules to separate, remove them from original styles.
	 *
	 * @param {Rule} rule
	 * @api public
	 */
	
	
	function jssGlobal() {
	  function onCreateRule(name, styles, options) {
	    if (!name) return null;
	
	    if (name === at) {
	      return new GlobalContainerRule(name, styles, options);
	    }
	
	    if (name[0] === '@' && name.substr(0, atPrefix.length) === atPrefix) {
	      return new GlobalPrefixedRule(name, styles, options);
	    }
	
	    var parent = options.parent;
	
	    if (parent) {
	      if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') {
	        options.scoped = false;
	      }
	    }
	
	    if (options.scoped === false) {
	      options.selector = name;
	    }
	
	    return null;
	  }
	
	  function onProcessRule(rule, sheet) {
	    if (rule.type !== 'style' || !sheet) return;
	    handleNestedGlobalContainerRule(rule, sheet);
	    handlePrefixedGlobalRule(rule, sheet);
	  }
	
	  return {
	    onCreateRule: onCreateRule,
	    onProcessRule: onProcessRule
	  };
	}
	
	exports.default = jssGlobal;


/***/ },
/* 1771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var _extends = __webpack_require__(6);
	var warning = __webpack_require__(554);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
	var warning__default = /*#__PURE__*/_interopDefaultLegacy(warning);
	
	var separatorRegExp = /\s*,\s*/g;
	var parentRegExp = /&/g;
	var refRegExp = /\$([\w-]+)/g;
	/**
	 * Convert nested rules to separate, remove them from original styles.
	 *
	 * @param {Rule} rule
	 * @api public
	 */
	
	function jssNested() {
	  // Get a function to be used for $ref replacement.
	  function getReplaceRef(container, sheet) {
	    return function (match, key) {
	      var rule = container.getRule(key) || sheet && sheet.getRule(key);
	
	      if (rule) {
	        rule = rule;
	        return rule.selector;
	      }
	
	       false ? warning__default['default'](false, "[JSS] Could not find the referenced rule \"" + key + "\" in \"" + (container.options.meta || container.toString()) + "\".") : void 0;
	      return key;
	    };
	  }
	
	  function replaceParentRefs(nestedProp, parentProp) {
	    var parentSelectors = parentProp.split(separatorRegExp);
	    var nestedSelectors = nestedProp.split(separatorRegExp);
	    var result = '';
	
	    for (var i = 0; i < parentSelectors.length; i++) {
	      var parent = parentSelectors[i];
	
	      for (var j = 0; j < nestedSelectors.length; j++) {
	        var nested = nestedSelectors[j];
	        if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.
	
	        result += nested.indexOf('&') !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
	      }
	    }
	
	    return result;
	  }
	
	  function getOptions(rule, container, prevOptions) {
	    // Options has been already created, now we only increase index.
	    if (prevOptions) return _extends__default['default']({}, prevOptions, {
	      index: prevOptions.index + 1 // $FlowFixMe[prop-missing]
	
	    });
	    var nestingLevel = rule.options.nestingLevel;
	    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
	
	    var options = _extends__default['default']({}, rule.options, {
	      nestingLevel: nestingLevel,
	      index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
	
	    });
	
	    delete options.name;
	    return options;
	  }
	
	  function onProcessStyle(style, rule, sheet) {
	    if (rule.type !== 'style') return style;
	    var styleRule = rule;
	    var container = styleRule.options.parent;
	    var options;
	    var replaceRef;
	
	    for (var prop in style) {
	      var isNested = prop.indexOf('&') !== -1;
	      var isNestedConditional = prop[0] === '@';
	      if (!isNested && !isNestedConditional) continue;
	      options = getOptions(styleRule, container, options);
	
	      if (isNested) {
	        var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
	        // all nested rules within the sheet.
	
	        if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
	
	        selector = selector.replace(refRegExp, replaceRef);
	        container.addRule(selector, style[prop], _extends__default['default']({}, options, {
	          selector: selector
	        }));
	      } else if (isNestedConditional) {
	        // Place conditional right after the parent rule to ensure right ordering.
	        container.addRule(prop, {}, options) // Flow expects more options but they aren't required
	        // And flow doesn't know this will always be a StyleRule which has the addRule method
	        // $FlowFixMe[incompatible-use]
	        // $FlowFixMe[prop-missing]
	        .addRule(styleRule.key, style[prop], {
	          selector: styleRule.selector
	        });
	      }
	
	      delete style[prop];
	    }
	
	    return style;
	  }
	
	  return {
	    onProcessStyle: onProcessStyle
	  };
	}
	
	exports.default = jssNested;


/***/ },
/* 1772 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Sort props by length.
	 */
	function jssPropsSort() {
	  var sort = function sort(prop0, prop1) {
	    if (prop0.length === prop1.length) {
	      return prop0 > prop1 ? 1 : -1;
	    }
	
	    return prop0.length - prop1.length;
	  };
	
	  return {
	    onProcessStyle: function onProcessStyle(style, rule) {
	      if (rule.type !== 'style') return style;
	      var newStyle = {};
	      var props = Object.keys(style).sort(sort);
	
	      for (var i = 0; i < props.length; i++) {
	        newStyle[props[i]] = style[props[i]];
	      }
	
	      return newStyle;
	    }
	  };
	}
	
	exports.default = jssPropsSort;


/***/ },
/* 1773 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var warning = __webpack_require__(554);
	var jss = __webpack_require__(172);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var warning__default = /*#__PURE__*/_interopDefaultLegacy(warning);
	
	var now = Date.now();
	var fnValuesNs = "fnValues" + now;
	var fnRuleNs = "fnStyle" + ++now;
	
	var functionPlugin = function functionPlugin() {
	  return {
	    onCreateRule: function onCreateRule(name, decl, options) {
	      if (typeof decl !== 'function') return null;
	      var rule = jss.createRule(name, {}, options);
	      rule[fnRuleNs] = decl;
	      return rule;
	    },
	    onProcessStyle: function onProcessStyle(style, rule) {
	      // We need to extract function values from the declaration, so that we can keep core unaware of them.
	      // We need to do that only once.
	      // We don't need to extract functions on each style update, since this can happen only once.
	      // We don't support function values inside of function rules.
	      if (fnValuesNs in rule || fnRuleNs in rule) return style;
	      var fnValues = {};
	
	      for (var prop in style) {
	        var value = style[prop];
	        if (typeof value !== 'function') continue;
	        delete style[prop];
	        fnValues[prop] = value;
	      } // $FlowFixMe[prop-missing]
	
	
	      rule[fnValuesNs] = fnValues;
	      return style;
	    },
	    onUpdate: function onUpdate(data, rule, sheet, options) {
	      var styleRule = rule; // $FlowFixMe[prop-missing]
	
	      var fnRule = styleRule[fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
	      // will be returned from that function.
	
	      if (fnRule) {
	        // Empty object will remove all currently defined props
	        // in case function rule returns a falsy value.
	        styleRule.style = fnRule(data) || {};
	
	        if (false) {
	          for (var prop in styleRule.style) {
	            if (typeof styleRule.style[prop] === 'function') {
	              process.env.NODE_ENV !== "production" ? warning__default['default'](false, '[JSS] Function values inside function rules are not supported.') : void 0;
	              break;
	            }
	          }
	        }
	      } // $FlowFixMe[prop-missing]
	
	
	      var fnValues = styleRule[fnValuesNs]; // If we have a fn values map, it is a rule with function values.
	
	      if (fnValues) {
	        for (var _prop in fnValues) {
	          styleRule.prop(_prop, fnValues[_prop](data), options);
	        }
	      }
	    }
	  };
	};
	
	exports.default = functionPlugin;


/***/ },
/* 1774 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var vendor = __webpack_require__(1428);
	var jss = __webpack_require__(172);
	
	/**
	 * Add vendor prefix to a property name when needed.
	 *
	 * @api public
	 */
	
	function jssVendorPrefixer() {
	  function onProcessRule(rule) {
	    if (rule.type === 'keyframes') {
	      var atRule = rule;
	      atRule.at = vendor.supportedKeyframes(atRule.at);
	    }
	  }
	
	  function prefixStyle(style) {
	    for (var prop in style) {
	      var value = style[prop];
	
	      if (prop === 'fallbacks' && Array.isArray(value)) {
	        style[prop] = value.map(prefixStyle);
	        continue;
	      }
	
	      var changeProp = false;
	      var supportedProp = vendor.supportedProperty(prop);
	      if (supportedProp && supportedProp !== prop) changeProp = true;
	      var changeValue = false;
	      var supportedValue = vendor.supportedValue(supportedProp, jss.toCssValue(value));
	      if (supportedValue && supportedValue !== value) changeValue = true;
	
	      if (changeProp || changeValue) {
	        if (changeProp) delete style[prop];
	        style[supportedProp || prop] = supportedValue || value;
	      }
	    }
	
	    return style;
	  }
	
	  function onProcessStyle(style, rule) {
	    if (rule.type !== 'style') return style;
	    return prefixStyle(style);
	  }
	
	  function onChangeValue(value, prop) {
	    return vendor.supportedValue(prop, jss.toCssValue(value)) || value;
	  }
	
	  return {
	    onProcessRule: onProcessRule,
	    onProcessStyle: onProcessStyle,
	    onChangeValue: onChangeValue
	  };
	}
	
	exports.default = jssVendorPrefixer;


/***/ },
/* 1775 */
/***/ function(module, exports) {

	(function ($) {
	
	  var divs = {
	    'ball-pulse': 3,
	    'ball-grid-pulse': 9,
	    'ball-clip-rotate': 1,
	    'ball-clip-rotate-pulse': 2,
	    'square-spin': 1,
	    'ball-clip-rotate-multiple': 2,
	    'ball-pulse-rise': 5,
	    'ball-rotate': 1,
	    'cube-transition': 2,
	    'ball-zig-zag': 2,
	    'ball-zig-zag-deflect': 2,
	    'ball-triangle-path': 3,
	    'ball-scale': 1,
	    'line-scale': 5,
	    'line-scale-party': 4,
	    'ball-scale-multiple': 3,
	    'ball-pulse-sync': 3,
	    'ball-beat': 3,
	    'line-scale-pulse-out': 5,
	    'line-scale-pulse-out-rapid': 5,
	    'ball-scale-ripple': 1,
	    'ball-scale-ripple-multiple': 3,
	    'ball-spin-fade-loader': 8,
	    'line-spin-fade-loader': 8,
	    'triangle-skew-spin': 1,
	    'pacman': 5,
	    'ball-grid-beat': 9,
	    'semi-circle-spin': 1,
	    'ball-scale-random': 3
	  };
	
	  var addDivs = function(n) {
	    var arr = [];
	    for (i = 1; i <= n; i++) {
	      arr.push('<div></div>');
	    }
	    return arr;
	  };
	
	  $.fn.loaders = function() {
	    return this.each(function() {
	      var elem = $(this);
	      $.each(divs, function(key, value) {
	        if (elem.hasClass(key))
	          elem.html(addDivs(value))
	      })
	    });
	  };
	
	  $(function() {
	    $.each(divs, function(key, value) {
	      $('.loader-inner.' + key).html(addDivs(value));
	    })
	  });
	
	}).call(window, window.$ || window.jQuery || window.Zepto);


/***/ },
/* 1776 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(176),
	    root = __webpack_require__(125);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 1777 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(1836),
	    hashDelete = __webpack_require__(1837),
	    hashGet = __webpack_require__(1838),
	    hashHas = __webpack_require__(1839),
	    hashSet = __webpack_require__(1840);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 1778 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(176),
	    root = __webpack_require__(125);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 1779 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(125);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 1780 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(176),
	    root = __webpack_require__(125);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 1781 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `baseAggregator` for arrays.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function arrayAggregator(array, setter, iteratee, accumulator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    var value = array[index];
	    setter(accumulator, value, iteratee(value), array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayAggregator;


/***/ },
/* 1782 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 1783 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEachRight` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEachRight(array, iteratee) {
	  var length = array == null ? 0 : array.length;
	
	  while (length--) {
	    if (iteratee(array[length], length, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEachRight;


/***/ },
/* 1784 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.every` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 */
	function arrayEvery(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (!predicate(array[index], index, array)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = arrayEvery;


/***/ },
/* 1785 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ },
/* 1786 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.reduceRight` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the last element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	  var length = array == null ? 0 : array.length;
	  if (initAccum && length) {
	    accumulator = array[--length];
	  }
	  while (length--) {
	    accumulator = iteratee(accumulator, array[length], length, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduceRight;


/***/ },
/* 1787 */
/***/ function(module, exports, __webpack_require__) {

	var baseClamp = __webpack_require__(776),
	    copyArray = __webpack_require__(789),
	    shuffleSelf = __webpack_require__(356);
	
	/**
	 * A specialized version of `_.sampleSize` for arrays.
	 *
	 * @private
	 * @param {Array} array The array to sample.
	 * @param {number} n The number of elements to sample.
	 * @returns {Array} Returns the random elements.
	 */
	function arraySampleSize(array, n) {
	  return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	}
	
	module.exports = arraySampleSize;


/***/ },
/* 1788 */
/***/ function(module, exports, __webpack_require__) {

	var copyArray = __webpack_require__(789),
	    shuffleSelf = __webpack_require__(356);
	
	/**
	 * A specialized version of `_.shuffle` for arrays.
	 *
	 * @private
	 * @param {Array} array The array to shuffle.
	 * @returns {Array} Returns the new shuffled array.
	 */
	function arrayShuffle(array) {
	  return shuffleSelf(copyArray(array));
	}
	
	module.exports = arrayShuffle;


/***/ },
/* 1789 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(785);
	
	/**
	 * Gets the size of an ASCII `string`.
	 *
	 * @private
	 * @param {string} string The string inspect.
	 * @returns {number} Returns the string size.
	 */
	var asciiSize = baseProperty('length');
	
	module.exports = asciiSize;


/***/ },
/* 1790 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(144);
	
	/**
	 * Aggregates elements of `collection` on `accumulator` with keys transformed
	 * by `iteratee` and values set by `setter`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function baseAggregator(collection, setter, iteratee, accumulator) {
	  baseEach(collection, function(value, key, collection) {
	    setter(accumulator, value, iteratee(value), collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseAggregator;


/***/ },
/* 1791 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(144);
	
	/**
	 * The base implementation of `_.every` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`
	 */
	function baseEvery(collection, predicate) {
	  var result = true;
	  baseEach(collection, function(value, index, collection) {
	    result = !!predicate(value, index, collection);
	    return result;
	  });
	  return result;
	}
	
	module.exports = baseEvery;


/***/ },
/* 1792 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(791);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 1793 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(1792),
	    keys = __webpack_require__(211);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 1794 */
/***/ function(module, exports, __webpack_require__) {

	var baseForRight = __webpack_require__(1795),
	    keys = __webpack_require__(211);
	
	/**
	 * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwnRight(object, iteratee) {
	  return object && baseForRight(object, iteratee, keys);
	}
	
	module.exports = baseForOwnRight;


/***/ },
/* 1795 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(791);
	
	/**
	 * This function is like `baseFor` except that it iterates over properties
	 * in the opposite order.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseForRight = createBaseFor(true);
	
	module.exports = baseForRight;


/***/ },
/* 1796 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(773),
	    isArray = __webpack_require__(35);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 1797 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 1798 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(347),
	    arrayIncludes = __webpack_require__(486),
	    arrayIncludesWith = __webpack_require__(487),
	    arrayMap = __webpack_require__(173),
	    baseUnary = __webpack_require__(351),
	    cacheHas = __webpack_require__(352);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * The base implementation of methods like `_.intersection`, without support
	 * for iteratee shorthands, that accepts an array of arrays to inspect.
	 *
	 * @private
	 * @param {Array} arrays The arrays to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of shared values.
	 */
	function baseIntersection(arrays, iteratee, comparator) {
	  var includes = comparator ? arrayIncludesWith : arrayIncludes,
	      length = arrays[0].length,
	      othLength = arrays.length,
	      othIndex = othLength,
	      caches = Array(othLength),
	      maxLength = Infinity,
	      result = [];
	
	  while (othIndex--) {
	    var array = arrays[othIndex];
	    if (othIndex && iteratee) {
	      array = arrayMap(array, baseUnary(iteratee));
	    }
	    maxLength = nativeMin(array.length, maxLength);
	    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	      ? new SetCache(othIndex && array)
	      : undefined;
	  }
	  array = arrays[0];
	
	  var index = -1,
	      seen = caches[0];
	
	  outer:
	  while (++index < length && result.length < maxLength) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (!(seen
	          ? cacheHas(seen, computed)
	          : includes(result, computed, comparator)
	        )) {
	      othIndex = othLength;
	      while (--othIndex) {
	        var cache = caches[othIndex];
	        if (!(cache
	              ? cacheHas(cache, computed)
	              : includes(arrays[othIndex], computed, comparator))
	            ) {
	          continue outer;
	        }
	      }
	      if (seen) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseIntersection;


/***/ },
/* 1799 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(485),
	    castPath = __webpack_require__(491),
	    last = __webpack_require__(810),
	    parent = __webpack_require__(1861),
	    toKey = __webpack_require__(272);
	
	/**
	 * The base implementation of `_.invoke` without support for individual
	 * method arguments.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the method to invoke.
	 * @param {Array} args The arguments to invoke the method with.
	 * @returns {*} Returns the result of the invoked method.
	 */
	function baseInvoke(object, path, args) {
	  path = castPath(path, object);
	  object = parent(object, path);
	  var func = object == null ? object : object[toKey(last(path))];
	  return func == null ? undefined : apply(func, object, args);
	}
	
	module.exports = baseInvoke;


/***/ },
/* 1800 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(175),
	    isObjectLike = __webpack_require__(146);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 1801 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(771),
	    equalArrays = __webpack_require__(794),
	    equalByTag = __webpack_require__(1826),
	    equalObjects = __webpack_require__(1827),
	    getTag = __webpack_require__(796),
	    isArray = __webpack_require__(35),
	    isBuffer = __webpack_require__(806),
	    isTypedArray = __webpack_require__(809);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 1802 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(771),
	    baseIsEqual = __webpack_require__(781);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 1803 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ },
/* 1804 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(807),
	    isMasked = __webpack_require__(1843),
	    isObject = __webpack_require__(177),
	    toSource = __webpack_require__(801);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 1805 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(175),
	    isLength = __webpack_require__(496),
	    isObjectLike = __webpack_require__(146);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 1806 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(177),
	    isPrototype = __webpack_require__(797),
	    nativeKeysIn = __webpack_require__(1857);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 1807 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(1802),
	    getMatchData = __webpack_require__(1829),
	    matchesStrictComparable = __webpack_require__(799);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 1808 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(781),
	    get = __webpack_require__(1888),
	    hasIn = __webpack_require__(1890),
	    isKey = __webpack_require__(493),
	    isStrictComparable = __webpack_require__(798),
	    matchesStrictComparable = __webpack_require__(799),
	    toKey = __webpack_require__(272);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 1809 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(350);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 1810 */
/***/ function(module, exports, __webpack_require__) {

	var arraySample = __webpack_require__(774),
	    values = __webpack_require__(359);
	
	/**
	 * The base implementation of `_.sample`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to sample.
	 * @returns {*} Returns the random element.
	 */
	function baseSample(collection) {
	  return arraySample(values(collection));
	}
	
	module.exports = baseSample;


/***/ },
/* 1811 */
/***/ function(module, exports, __webpack_require__) {

	var baseClamp = __webpack_require__(776),
	    shuffleSelf = __webpack_require__(356),
	    values = __webpack_require__(359);
	
	/**
	 * The base implementation of `_.sampleSize` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to sample.
	 * @param {number} n The number of elements to sample.
	 * @returns {Array} Returns the random elements.
	 */
	function baseSampleSize(collection, n) {
	  var array = values(collection);
	  return shuffleSelf(array, baseClamp(n, 0, array.length));
	}
	
	module.exports = baseSampleSize;


/***/ },
/* 1812 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(1876),
	    defineProperty = __webpack_require__(793),
	    identity = __webpack_require__(273);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },
/* 1813 */
/***/ function(module, exports, __webpack_require__) {

	var shuffleSelf = __webpack_require__(356),
	    values = __webpack_require__(359);
	
	/**
	 * The base implementation of `_.shuffle`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to shuffle.
	 * @returns {Array} Returns the new shuffled array.
	 */
	function baseShuffle(collection) {
	  return shuffleSelf(values(collection));
	}
	
	module.exports = baseShuffle;


/***/ },
/* 1814 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ },
/* 1815 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(144);
	
	/**
	 * The base implementation of `_.some` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function baseSome(collection, predicate) {
	  var result;
	
	  baseEach(collection, function(value, index, collection) {
	    result = predicate(value, index, collection);
	    return !result;
	  });
	  return !!result;
	}
	
	module.exports = baseSome;


/***/ },
/* 1816 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ },
/* 1817 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 1818 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(270),
	    arrayMap = __webpack_require__(173),
	    isArray = __webpack_require__(35),
	    isSymbol = __webpack_require__(275);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 1819 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(173);
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	module.exports = baseValues;


/***/ },
/* 1820 */
/***/ function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(777),
	    baseFlatten = __webpack_require__(174),
	    baseUniq = __webpack_require__(490);
	
	/**
	 * The base implementation of methods like `_.xor`, without support for
	 * iteratee shorthands, that accepts an array of arrays to inspect.
	 *
	 * @private
	 * @param {Array} arrays The arrays to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of values.
	 */
	function baseXor(arrays, iteratee, comparator) {
	  var length = arrays.length;
	  if (length < 2) {
	    return length ? baseUniq(arrays[0]) : [];
	  }
	  var index = -1,
	      result = Array(length);
	
	  while (++index < length) {
	    var array = arrays[index],
	        othIndex = -1;
	
	    while (++othIndex < length) {
	      if (othIndex != index) {
	        result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	      }
	    }
	  }
	  return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	}
	
	module.exports = baseXor;


/***/ },
/* 1821 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLikeObject = __webpack_require__(274);
	
	/**
	 * Casts `value` to an empty array if it's not an array like object.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array|Object} Returns the cast array-like object.
	 */
	function castArrayLikeObject(value) {
	  return isArrayLikeObject(value) ? value : [];
	}
	
	module.exports = castArrayLikeObject;


/***/ },
/* 1822 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(275);
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ },
/* 1823 */
/***/ function(module, exports, __webpack_require__) {

	var compareAscending = __webpack_require__(1822);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ },
/* 1824 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(125);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 1825 */
/***/ function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(770),
	    noop = __webpack_require__(812),
	    setToArray = __webpack_require__(494);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Creates a set object of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	  return new Set(values);
	};
	
	module.exports = createSet;


/***/ },
/* 1826 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(270),
	    Uint8Array = __webpack_require__(1779),
	    eq = __webpack_require__(357),
	    equalArrays = __webpack_require__(794),
	    mapToArray = __webpack_require__(1854),
	    setToArray = __webpack_require__(494);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 1827 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(1828);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Check that cyclic values are equal.
	  var objStacked = stack.get(object);
	  var othStacked = stack.get(other);
	  if (objStacked && othStacked) {
	    return objStacked == other && othStacked == object;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 1828 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(1796),
	    getSymbols = __webpack_require__(1832),
	    keys = __webpack_require__(211);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 1829 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(798),
	    keys = __webpack_require__(211);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 1830 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(800);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 1831 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(270);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 1832 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(348),
	    stubArray = __webpack_require__(1908);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 1833 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 1834 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(491),
	    isArguments = __webpack_require__(495),
	    isArray = __webpack_require__(35),
	    isIndex = __webpack_require__(492),
	    isLength = __webpack_require__(496),
	    toKey = __webpack_require__(272);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 1835 */
/***/ function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsZWJ = '\\u200d';
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	/**
	 * Checks if `string` contains Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	 */
	function hasUnicode(string) {
	  return reHasUnicode.test(string);
	}
	
	module.exports = hasUnicode;


/***/ },
/* 1836 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(355);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 1837 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 1838 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(355);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 1839 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(355);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 1840 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(355);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 1841 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(270),
	    isArguments = __webpack_require__(495),
	    isArray = __webpack_require__(35);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ },
/* 1842 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 1843 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(1824);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 1844 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 1845 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(349);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 1846 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(349);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 1847 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(349);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 1848 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(349);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 1849 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(1777),
	    ListCache = __webpack_require__(346),
	    Map = __webpack_require__(483);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 1850 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(354);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 1851 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(354);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 1852 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(354);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 1853 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(354);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 1854 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 1855 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(811);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 1856 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(800);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 1857 */
/***/ function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ },
/* 1858 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(795);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(291)(module)))

/***/ },
/* 1859 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 1860 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(485);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },
/* 1861 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(350),
	    baseSlice = __webpack_require__(1814);
	
	/**
	 * Gets the parent value at `path` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path to get the parent value of.
	 * @returns {*} Returns the parent value.
	 */
	function parent(object, path) {
	  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	}
	
	module.exports = parent;


/***/ },
/* 1862 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 1863 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 1864 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(1812),
	    shortOut = __webpack_require__(1865);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ },
/* 1865 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 1866 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(346);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 1867 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 1868 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 1869 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 1870 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(346),
	    Map = __webpack_require__(483),
	    MapCache = __webpack_require__(484);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 1871 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ },
/* 1872 */
/***/ function(module, exports, __webpack_require__) {

	var asciiSize = __webpack_require__(1789),
	    hasUnicode = __webpack_require__(1835),
	    unicodeSize = __webpack_require__(1874);
	
	/**
	 * Gets the number of symbols in `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the string size.
	 */
	function stringSize(string) {
	  return hasUnicode(string)
	    ? unicodeSize(string)
	    : asciiSize(string);
	}
	
	module.exports = stringSize;


/***/ },
/* 1873 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(1855);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 1874 */
/***/ function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Gets the size of a Unicode `string`.
	 *
	 * @private
	 * @param {string} string The string inspect.
	 * @returns {number} Returns the string size.
	 */
	function unicodeSize(string) {
	  var result = reUnicode.lastIndex = 0;
	  while (reUnicode.test(string)) {
	    ++result;
	  }
	  return result;
	}
	
	module.exports = unicodeSize;


/***/ },
/* 1875 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  'countBy': __webpack_require__(1877),
	  'each': __webpack_require__(1879),
	  'eachRight': __webpack_require__(1880),
	  'every': __webpack_require__(1881),
	  'filter': __webpack_require__(802),
	  'find': __webpack_require__(1882),
	  'findLast': __webpack_require__(1884),
	  'flatMap': __webpack_require__(803),
	  'flatMapDeep': __webpack_require__(1886),
	  'flatMapDepth': __webpack_require__(1887),
	  'forEach': __webpack_require__(804),
	  'forEachRight': __webpack_require__(805),
	  'groupBy': __webpack_require__(1889),
	  'includes': __webpack_require__(1891),
	  'invokeMap': __webpack_require__(1893),
	  'keyBy': __webpack_require__(1894),
	  'map': __webpack_require__(358),
	  'orderBy': __webpack_require__(1897),
	  'partition': __webpack_require__(1898),
	  'reduce': __webpack_require__(813),
	  'reduceRight': __webpack_require__(1900),
	  'reject': __webpack_require__(1901),
	  'sample': __webpack_require__(1902),
	  'sampleSize': __webpack_require__(1903),
	  'shuffle': __webpack_require__(1904),
	  'size': __webpack_require__(1905),
	  'some': __webpack_require__(1906),
	  'sortBy': __webpack_require__(1907)
	};


/***/ },
/* 1876 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 1877 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(488),
	    createAggregator = __webpack_require__(353);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an object composed of keys generated from the results of running
	 * each element of `collection` thru `iteratee`. The corresponding value of
	 * each key is the number of times the key was returned by `iteratee`. The
	 * iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	 * @returns {Object} Returns the composed aggregate object.
	 * @example
	 *
	 * _.countBy([6.1, 4.2, 6.3], Math.floor);
	 * // => { '4': 1, '6': 2 }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.countBy(['one', 'two', 'three'], 'length');
	 * // => { '3': 2, '5': 1 }
	 */
	var countBy = createAggregator(function(result, value, key) {
	  if (hasOwnProperty.call(result, key)) {
	    ++result[key];
	  } else {
	    baseAssignValue(result, key, 1);
	  }
	});
	
	module.exports = countBy;


/***/ },
/* 1878 */
/***/ function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(145),
	    eq = __webpack_require__(357),
	    isIterateeCall = __webpack_require__(271),
	    keysIn = __webpack_require__(1895);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns own and inherited enumerable string keyed properties of source
	 * objects to the destination object for all destination properties that
	 * resolve to `undefined`. Source objects are applied from left to right.
	 * Once a property is set, additional values of the same property are ignored.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.defaultsDeep
	 * @example
	 *
	 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var defaults = baseRest(function(object, sources) {
	  object = Object(object);
	
	  var index = -1;
	  var length = sources.length;
	  var guard = length > 2 ? sources[2] : undefined;
	
	  if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	    length = 1;
	  }
	
	  while (++index < length) {
	    var source = sources[index];
	    var props = keysIn(source);
	    var propsIndex = -1;
	    var propsLength = props.length;
	
	    while (++propsIndex < propsLength) {
	      var key = props[propsIndex];
	      var value = object[key];
	
	      if (value === undefined ||
	          (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        object[key] = source[key];
	      }
	    }
	  }
	
	  return object;
	});
	
	module.exports = defaults;


/***/ },
/* 1879 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(804);


/***/ },
/* 1880 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(805);


/***/ },
/* 1881 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEvery = __webpack_require__(1784),
	    baseEvery = __webpack_require__(1791),
	    baseIteratee = __webpack_require__(85),
	    isArray = __webpack_require__(35),
	    isIterateeCall = __webpack_require__(271);
	
	/**
	 * Checks if `predicate` returns truthy for **all** elements of `collection`.
	 * Iteration is stopped once `predicate` returns falsey. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * **Note:** This method returns `true` for
	 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	 * elements of empty collections.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.every([true, 1, null, 'yes'], Boolean);
	 * // => false
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': false },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.every(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.every(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.every(users, 'active');
	 * // => false
	 */
	function every(collection, predicate, guard) {
	  var func = isArray(collection) ? arrayEvery : baseEvery;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = every;


/***/ },
/* 1882 */
/***/ function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(792),
	    findIndex = __webpack_require__(1883);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ },
/* 1883 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(489),
	    baseIteratee = __webpack_require__(85),
	    toInteger = __webpack_require__(276);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ },
/* 1884 */
/***/ function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(792),
	    findLastIndex = __webpack_require__(1885);
	
	/**
	 * This method is like `_.find` except that it iterates over elements of
	 * `collection` from right to left.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=collection.length-1] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * _.findLast([1, 2, 3, 4], function(n) {
	 *   return n % 2 == 1;
	 * });
	 * // => 3
	 */
	var findLast = createFind(findLastIndex);
	
	module.exports = findLast;


/***/ },
/* 1885 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(489),
	    baseIteratee = __webpack_require__(85),
	    toInteger = __webpack_require__(276);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * This method is like `_.findIndex` except that it iterates over elements
	 * of `collection` from right to left.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=array.length-1] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': true },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': false }
	 * ];
	 *
	 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	 * // => 2
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	 * // => 0
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findLastIndex(users, ['active', false]);
	 * // => 2
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findLastIndex(users, 'active');
	 * // => 0
	 */
	function findLastIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = length - 1;
	  if (fromIndex !== undefined) {
	    index = toInteger(fromIndex);
	    index = fromIndex < 0
	      ? nativeMax(length + index, 0)
	      : nativeMin(index, length - 1);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index, true);
	}
	
	module.exports = findLastIndex;


/***/ },
/* 1886 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(174),
	    map = __webpack_require__(358);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * This method is like `_.flatMap` except that it recursively flattens the
	 * mapped results.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.7.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * function duplicate(n) {
	 *   return [[[n, n]]];
	 * }
	 *
	 * _.flatMapDeep([1, 2], duplicate);
	 * // => [1, 1, 2, 2]
	 */
	function flatMapDeep(collection, iteratee) {
	  return baseFlatten(map(collection, iteratee), INFINITY);
	}
	
	module.exports = flatMapDeep;


/***/ },
/* 1887 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(174),
	    map = __webpack_require__(358),
	    toInteger = __webpack_require__(276);
	
	/**
	 * This method is like `_.flatMap` except that it recursively flattens the
	 * mapped results up to `depth` times.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.7.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {number} [depth=1] The maximum recursion depth.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * function duplicate(n) {
	 *   return [[[n, n]]];
	 * }
	 *
	 * _.flatMapDepth([1, 2], duplicate, 2);
	 * // => [[1, 1], [2, 2]]
	 */
	function flatMapDepth(collection, iteratee, depth) {
	  depth = depth === undefined ? 1 : toInteger(depth);
	  return baseFlatten(map(collection, iteratee), depth);
	}
	
	module.exports = flatMapDepth;


/***/ },
/* 1888 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(350);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 1889 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(488),
	    createAggregator = __webpack_require__(353);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an object composed of keys generated from the results of running
	 * each element of `collection` thru `iteratee`. The order of grouped values
	 * is determined by the order they occur in `collection`. The corresponding
	 * value of each key is an array of elements responsible for generating the
	 * key. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	 * @returns {Object} Returns the composed aggregate object.
	 * @example
	 *
	 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	 * // => { '4': [4.2], '6': [6.1, 6.3] }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.groupBy(['one', 'two', 'three'], 'length');
	 * // => { '3': ['one', 'two'], '5': ['three'] }
	 */
	var groupBy = createAggregator(function(result, value, key) {
	  if (hasOwnProperty.call(result, key)) {
	    result[key].push(value);
	  } else {
	    baseAssignValue(result, key, [value]);
	  }
	});
	
	module.exports = groupBy;


/***/ },
/* 1890 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(1797),
	    hasPath = __webpack_require__(1834);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 1891 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(780),
	    isArrayLike = __webpack_require__(109),
	    isString = __webpack_require__(808),
	    toInteger = __webpack_require__(276),
	    values = __webpack_require__(359);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Checks if `value` is in `collection`. If `collection` is a string, it's
	 * checked for a substring of `value`, otherwise
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * is used for equality comparisons. If `fromIndex` is negative, it's used as
	 * the offset from the end of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {boolean} Returns `true` if `value` is found, else `false`.
	 * @example
	 *
	 * _.includes([1, 2, 3], 1);
	 * // => true
	 *
	 * _.includes([1, 2, 3], 1, 2);
	 * // => false
	 *
	 * _.includes({ 'a': 1, 'b': 2 }, 1);
	 * // => true
	 *
	 * _.includes('abcd', 'bc');
	 * // => true
	 */
	function includes(collection, value, fromIndex, guard) {
	  collection = isArrayLike(collection) ? collection : values(collection);
	  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	  var length = collection.length;
	  if (fromIndex < 0) {
	    fromIndex = nativeMax(length + fromIndex, 0);
	  }
	  return isString(collection)
	    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	}
	
	module.exports = includes;


/***/ },
/* 1892 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(173),
	    baseIntersection = __webpack_require__(1798),
	    baseRest = __webpack_require__(145),
	    castArrayLikeObject = __webpack_require__(1821);
	
	/**
	 * Creates an array of unique values that are included in all given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of intersecting values.
	 * @example
	 *
	 * _.intersection([2, 1], [2, 3]);
	 * // => [2]
	 */
	var intersection = baseRest(function(arrays) {
	  var mapped = arrayMap(arrays, castArrayLikeObject);
	  return (mapped.length && mapped[0] === arrays[0])
	    ? baseIntersection(mapped)
	    : [];
	});
	
	module.exports = intersection;


/***/ },
/* 1893 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(485),
	    baseEach = __webpack_require__(144),
	    baseInvoke = __webpack_require__(1799),
	    baseRest = __webpack_require__(145),
	    isArrayLike = __webpack_require__(109);
	
	/**
	 * Invokes the method at `path` of each element in `collection`, returning
	 * an array of the results of each invoked method. Any additional arguments
	 * are provided to each invoked method. If `path` is a function, it's invoked
	 * for, and `this` bound to, each element in `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Array|Function|string} path The path of the method to invoke or
	 *  the function invoked per iteration.
	 * @param {...*} [args] The arguments to invoke each method with.
	 * @returns {Array} Returns the array of results.
	 * @example
	 *
	 * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	 * // => [[1, 5, 7], [1, 2, 3]]
	 *
	 * _.invokeMap([123, 456], String.prototype.split, '');
	 * // => [['1', '2', '3'], ['4', '5', '6']]
	 */
	var invokeMap = baseRest(function(collection, path, args) {
	  var index = -1,
	      isFunc = typeof path == 'function',
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value) {
	    result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	  });
	  return result;
	});
	
	module.exports = invokeMap;


/***/ },
/* 1894 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(488),
	    createAggregator = __webpack_require__(353);
	
	/**
	 * Creates an object composed of keys generated from the results of running
	 * each element of `collection` thru `iteratee`. The corresponding value of
	 * each key is the last element responsible for generating the key. The
	 * iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	 * @returns {Object} Returns the composed aggregate object.
	 * @example
	 *
	 * var array = [
	 *   { 'dir': 'left', 'code': 97 },
	 *   { 'dir': 'right', 'code': 100 }
	 * ];
	 *
	 * _.keyBy(array, function(o) {
	 *   return String.fromCharCode(o.code);
	 * });
	 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	 *
	 * _.keyBy(array, 'dir');
	 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	 */
	var keyBy = createAggregator(function(result, value, key) {
	  baseAssignValue(result, key, value);
	});
	
	module.exports = keyBy;


/***/ },
/* 1895 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(772),
	    baseKeysIn = __webpack_require__(1806),
	    isArrayLike = __webpack_require__(109);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ },
/* 1896 */
/***/ function(module, exports) {

	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that negates the result of the predicate `func`. The
	 * `func` predicate is invoked with the `this` binding and arguments of the
	 * created function.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {Function} predicate The predicate to negate.
	 * @returns {Function} Returns the new negated function.
	 * @example
	 *
	 * function isEven(n) {
	 *   return n % 2 == 0;
	 * }
	 *
	 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	 * // => [1, 3, 5]
	 */
	function negate(predicate) {
	  if (typeof predicate != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  return function() {
	    var args = arguments;
	    switch (args.length) {
	      case 0: return !predicate.call(this);
	      case 1: return !predicate.call(this, args[0]);
	      case 2: return !predicate.call(this, args[0], args[1]);
	      case 3: return !predicate.call(this, args[0], args[1], args[2]);
	    }
	    return !predicate.apply(this, args);
	  };
	}
	
	module.exports = negate;


/***/ },
/* 1897 */
/***/ function(module, exports, __webpack_require__) {

	var baseOrderBy = __webpack_require__(784),
	    isArray = __webpack_require__(35);
	
	/**
	 * This method is like `_.sortBy` except that it allows specifying the sort
	 * orders of the iteratees to sort by. If `orders` is unspecified, all values
	 * are sorted in ascending order. Otherwise, specify an order of "desc" for
	 * descending or "asc" for ascending sort order of corresponding values.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @param {string[]} [orders] The sort orders of `iteratees`.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 34 },
	 *   { 'user': 'fred',   'age': 40 },
	 *   { 'user': 'barney', 'age': 36 }
	 * ];
	 *
	 * // Sort by `user` in ascending order and by `age` in descending order.
	 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	 */
	function orderBy(collection, iteratees, orders, guard) {
	  if (collection == null) {
	    return [];
	  }
	  if (!isArray(iteratees)) {
	    iteratees = iteratees == null ? [] : [iteratees];
	  }
	  orders = guard ? undefined : orders;
	  if (!isArray(orders)) {
	    orders = orders == null ? [] : [orders];
	  }
	  return baseOrderBy(collection, iteratees, orders);
	}
	
	module.exports = orderBy;


/***/ },
/* 1898 */
/***/ function(module, exports, __webpack_require__) {

	var createAggregator = __webpack_require__(353);
	
	/**
	 * Creates an array of elements split into two groups, the first of which
	 * contains elements `predicate` returns truthy for, the second of which
	 * contains elements `predicate` returns falsey for. The predicate is
	 * invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the array of grouped elements.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': false },
	 *   { 'user': 'fred',    'age': 40, 'active': true },
	 *   { 'user': 'pebbles', 'age': 1,  'active': false }
	 * ];
	 *
	 * _.partition(users, function(o) { return o.active; });
	 * // => objects for [['fred'], ['barney', 'pebbles']]
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.partition(users, { 'age': 1, 'active': false });
	 * // => objects for [['pebbles'], ['barney', 'fred']]
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.partition(users, ['active', false]);
	 * // => objects for [['barney', 'pebbles'], ['fred']]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.partition(users, 'active');
	 * // => objects for [['fred'], ['barney', 'pebbles']]
	 */
	var partition = createAggregator(function(result, value, key) {
	  result[key ? 0 : 1].push(value);
	}, function() { return [[], []]; });
	
	module.exports = partition;


/***/ },
/* 1899 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(785),
	    basePropertyDeep = __webpack_require__(1809),
	    isKey = __webpack_require__(493),
	    toKey = __webpack_require__(272);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 1900 */
/***/ function(module, exports, __webpack_require__) {

	var arrayReduceRight = __webpack_require__(1786),
	    baseEachRight = __webpack_require__(778),
	    baseIteratee = __webpack_require__(85),
	    baseReduce = __webpack_require__(787),
	    isArray = __webpack_require__(35);
	
	/**
	 * This method is like `_.reduce` except that it iterates over elements of
	 * `collection` from right to left.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @returns {*} Returns the accumulated value.
	 * @see _.reduce
	 * @example
	 *
	 * var array = [[0, 1], [2, 3], [4, 5]];
	 *
	 * _.reduceRight(array, function(flattened, other) {
	 *   return flattened.concat(other);
	 * }, []);
	 * // => [4, 5, 2, 3, 0, 1]
	 */
	function reduceRight(collection, iteratee, accumulator) {
	  var func = isArray(collection) ? arrayReduceRight : baseReduce,
	      initAccum = arguments.length < 3;
	
	  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	}
	
	module.exports = reduceRight;


/***/ },
/* 1901 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(348),
	    baseFilter = __webpack_require__(779),
	    baseIteratee = __webpack_require__(85),
	    isArray = __webpack_require__(35),
	    negate = __webpack_require__(1896);
	
	/**
	 * The opposite of `_.filter`; this method returns the elements of `collection`
	 * that `predicate` does **not** return truthy for.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.filter
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': false },
	 *   { 'user': 'fred',   'age': 40, 'active': true }
	 * ];
	 *
	 * _.reject(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.reject(users, { 'age': 40, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.reject(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.reject(users, 'active');
	 * // => objects for ['barney']
	 */
	function reject(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, negate(baseIteratee(predicate, 3)));
	}
	
	module.exports = reject;


/***/ },
/* 1902 */
/***/ function(module, exports, __webpack_require__) {

	var arraySample = __webpack_require__(774),
	    baseSample = __webpack_require__(1810),
	    isArray = __webpack_require__(35);
	
	/**
	 * Gets a random element from `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to sample.
	 * @returns {*} Returns the random element.
	 * @example
	 *
	 * _.sample([1, 2, 3, 4]);
	 * // => 2
	 */
	function sample(collection) {
	  var func = isArray(collection) ? arraySample : baseSample;
	  return func(collection);
	}
	
	module.exports = sample;


/***/ },
/* 1903 */
/***/ function(module, exports, __webpack_require__) {

	var arraySampleSize = __webpack_require__(1787),
	    baseSampleSize = __webpack_require__(1811),
	    isArray = __webpack_require__(35),
	    isIterateeCall = __webpack_require__(271),
	    toInteger = __webpack_require__(276);
	
	/**
	 * Gets `n` random elements at unique keys from `collection` up to the
	 * size of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to sample.
	 * @param {number} [n=1] The number of elements to sample.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the random elements.
	 * @example
	 *
	 * _.sampleSize([1, 2, 3], 2);
	 * // => [3, 1]
	 *
	 * _.sampleSize([1, 2, 3], 4);
	 * // => [2, 3, 1]
	 */
	function sampleSize(collection, n, guard) {
	  if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	    n = 1;
	  } else {
	    n = toInteger(n);
	  }
	  var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	  return func(collection, n);
	}
	
	module.exports = sampleSize;


/***/ },
/* 1904 */
/***/ function(module, exports, __webpack_require__) {

	var arrayShuffle = __webpack_require__(1788),
	    baseShuffle = __webpack_require__(1813),
	    isArray = __webpack_require__(35);
	
	/**
	 * Creates an array of shuffled values, using a version of the
	 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to shuffle.
	 * @returns {Array} Returns the new shuffled array.
	 * @example
	 *
	 * _.shuffle([1, 2, 3, 4]);
	 * // => [4, 1, 3, 2]
	 */
	function shuffle(collection) {
	  var func = isArray(collection) ? arrayShuffle : baseShuffle;
	  return func(collection);
	}
	
	module.exports = shuffle;


/***/ },
/* 1905 */
/***/ function(module, exports, __webpack_require__) {

	var baseKeys = __webpack_require__(782),
	    getTag = __webpack_require__(796),
	    isArrayLike = __webpack_require__(109),
	    isString = __webpack_require__(808),
	    stringSize = __webpack_require__(1872);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/**
	 * Gets the size of `collection` by returning its length for array-like
	 * values or the number of own enumerable string keyed properties for objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @returns {number} Returns the collection size.
	 * @example
	 *
	 * _.size([1, 2, 3]);
	 * // => 3
	 *
	 * _.size({ 'a': 1, 'b': 2 });
	 * // => 2
	 *
	 * _.size('pebbles');
	 * // => 7
	 */
	function size(collection) {
	  if (collection == null) {
	    return 0;
	  }
	  if (isArrayLike(collection)) {
	    return isString(collection) ? stringSize(collection) : collection.length;
	  }
	  var tag = getTag(collection);
	  if (tag == mapTag || tag == setTag) {
	    return collection.size;
	  }
	  return baseKeys(collection).length;
	}
	
	module.exports = size;


/***/ },
/* 1906 */
/***/ function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(775),
	    baseIteratee = __webpack_require__(85),
	    baseSome = __webpack_require__(1815),
	    isArray = __webpack_require__(35),
	    isIterateeCall = __webpack_require__(271);
	
	/**
	 * Checks if `predicate` returns truthy for **any** element of `collection`.
	 * Iteration is stopped once `predicate` returns truthy. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.some([null, 0, 'yes', false], Boolean);
	 * // => true
	 *
	 * var users = [
	 *   { 'user': 'barney', 'active': true },
	 *   { 'user': 'fred',   'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.some(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.some(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.some(users, 'active');
	 * // => true
	 */
	function some(collection, predicate, guard) {
	  var func = isArray(collection) ? arraySome : baseSome;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = some;


/***/ },
/* 1907 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(174),
	    baseOrderBy = __webpack_require__(784),
	    baseRest = __webpack_require__(145),
	    isIterateeCall = __webpack_require__(271);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection thru each iteratee. This method
	 * performs a stable sort, that is, it preserves the original sort order of
	 * equal elements. The iteratees are invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {...(Function|Function[])} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 30 },
	 *   { 'user': 'barney', 'age': 34 }
	 * ];
	 *
	 * _.sortBy(users, [function(o) { return o.user; }]);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	 *
	 * _.sortBy(users, ['user', 'age']);
	 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	 */
	var sortBy = baseRest(function(collection, iteratees) {
	  if (collection == null) {
	    return [];
	  }
	  var length = iteratees.length;
	  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	    iteratees = [];
	  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	    iteratees = [iteratees[0]];
	  }
	  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	});
	
	module.exports = sortBy;


/***/ },
/* 1908 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 1909 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 1910 */
/***/ function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(1911);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ },
/* 1911 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(177),
	    isSymbol = __webpack_require__(275);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 1912 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(1818);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 1913 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(174),
	    baseRest = __webpack_require__(145),
	    baseUniq = __webpack_require__(490),
	    isArrayLikeObject = __webpack_require__(274);
	
	/**
	 * Creates an array of unique values, in order, from all given arrays using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of combined values.
	 * @example
	 *
	 * _.union([2], [1, 2]);
	 * // => [2, 1]
	 */
	var union = baseRest(function(arrays) {
	  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	});
	
	module.exports = union;


/***/ },
/* 1914 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(174),
	    baseRest = __webpack_require__(145),
	    baseUniq = __webpack_require__(490),
	    isArrayLikeObject = __webpack_require__(274),
	    last = __webpack_require__(810);
	
	/**
	 * This method is like `_.union` except that it accepts `comparator` which
	 * is invoked to compare elements of `arrays`. Result values are chosen from
	 * the first array in which the value occurs. The comparator is invoked
	 * with two arguments: (arrVal, othVal).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of combined values.
	 * @example
	 *
	 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	 *
	 * _.unionWith(objects, others, _.isEqual);
	 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	 */
	var unionWith = baseRest(function(arrays) {
	  var comparator = last(arrays);
	  comparator = typeof comparator == 'function' ? comparator : undefined;
	  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	});
	
	module.exports = unionWith;


/***/ },
/* 1915 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(348),
	    baseRest = __webpack_require__(145),
	    baseXor = __webpack_require__(1820),
	    isArrayLikeObject = __webpack_require__(274);
	
	/**
	 * Creates an array of unique values that is the
	 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	 * of the given arrays. The order of result values is determined by the order
	 * they occur in the arrays.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.difference, _.without
	 * @example
	 *
	 * _.xor([2, 1], [2, 3]);
	 * // => [1, 3]
	 */
	var xor = baseRest(function(arrays) {
	  return baseXor(arrayFilter(arrays, isArrayLikeObject));
	});
	
	module.exports = xor;


/***/ },
/* 1916 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Usage
	 *
	 * var MailChecker = require('mailchecker/platform/node')
	 * MailChecker.isValid(String email);
	 * @return {Boolean} true is the specified email is valid, false otherwise
	 */
	'use strict';
	
	var range = __webpack_require__(1918);
	
	var blacklist        = ["0-00.usa.cc","0-attorney.com","0-mail.com","00.msk.ru","000777.info","001.igg.biz","0033.pl","0039.cf","0039.ga","0039.gq","0039.ml","007game.ru","00b2bcr51qv59xst2.cf","00b2bcr51qv59xst2.ga","00b2bcr51qv59xst2.gq","00b2bcr51qv59xst2.ml","00b2bcr51qv59xst2.tk","01bktwi2lzvg05.cf","01bktwi2lzvg05.ga","01bktwi2lzvg05.gq","01bktwi2lzvg05.ml","01bktwi2lzvg05.tk","01hosting.biz","02.pl","020yiren.com","020zlgc.com","02466.cf","02466.ga","02466.gq","02466.ml","027168.com","03-genkzmail.ga","0317123.cn","0530fk.com","0543sh.com","0662dq.com","07819.cf","07819.ga","07819.gq","07819.ml","07819.tk","079i080nhj.info","080mail.com","0815.ru","0815.su","0845.ru","09ojsdhad.info","0accounts.com","0ak.org","0box.eu","0celot.com","0cindcywrokv.cf","0cindcywrokv.ga","0cindcywrokv.gq","0cindcywrokv.ml","0cindcywrokv.tk","0clickemail.com","0clock.net","0clock.org","0costofivf.com","0cv23qjrvmcpt.cf","0cv23qjrvmcpt.ga","0cv23qjrvmcpt.gq","0cv23qjrvmcpt.ml","0cv23qjrvmcpt.tk","0ehtkltu0sgd.ga","0ehtkltu0sgd.ml","0ehtkltu0sgd.tk","0f590da1.bounceme.net","0fru8te0xkgfptti.cf","0fru8te0xkgfptti.ga","0fru8te0xkgfptti.gq","0fru8te0xkgfptti.ml","0fru8te0xkgfptti.tk","0h26le75d.pl","0hboy.com","0hcow.com","0hdear.com","0hio.net","0hio.org","0hiolce.com","0hioln.com","0ils.net","0ils.org","0ioi.net","0jralz2qipvmr3n.ga","0jralz2qipvmr3n.ml","0jralz2qipvmr3n.tk","0jylaegwalss9m6ilvq.cf","0jylaegwalss9m6ilvq.ga","0jylaegwalss9m6ilvq.gq","0jylaegwalss9m6ilvq.ml","0jylaegwalss9m6ilvq.tk","0kok.net","0kok.org","0ld0ak.com","0ld0x.com","0live.org","0ll2au4c8.pl","0mel.com","0mfs0mxufjpcfc.cf","0mfs0mxufjpcfc.ga","0mfs0mxufjpcfc.gq","0mfs0mxufjpcfc.ml","0mfs0mxufjpcfc.tk","0mixmail.info","0n0ff.net","0nb9zti01sgz8u2a.cf","0nb9zti01sgz8u2a.ga","0nb9zti01sgz8u2a.gq","0nb9zti01sgz8u2a.ml","0nb9zti01sgz8u2a.tk","0nce.net","0ne0ak.com","0ne0ut.com","0nedrive.cf","0nedrive.ga","0nedrive.gq","0nedrive.ml","0nedrive.tk","0nelce.com","0nes.net","0nes.org","0nly.org","0oxgvfdufyydergd.cf","0oxgvfdufyydergd.ga","0oxgvfdufyydergd.gq","0oxgvfdufyydergd.ml","0oxgvfdufyydergd.tk","0r0wfuwfteqwmbt.cf","0r0wfuwfteqwmbt.ga","0r0wfuwfteqwmbt.gq","0r0wfuwfteqwmbt.ml","0r0wfuwfteqwmbt.tk","0rdered.com","0rdering.com","0regon.net","0regon.org","0sg.net","0sx.ru","0tinak9zyvf.cf","0tinak9zyvf.ga","0tinak9zyvf.gq","0tinak9zyvf.ml","0tinak9zyvf.tk","0to6oiry4ghhscmlokt.cf","0to6oiry4ghhscmlokt.ga","0to6oiry4ghhscmlokt.gq","0to6oiry4ghhscmlokt.ml","0to6oiry4ghhscmlokt.tk","0u.ro","0ulook.com","0utln.com","0uxpgdvol9n.cf","0uxpgdvol9n.ga","0uxpgdvol9n.gq","0uxpgdvol9n.ml","0uxpgdvol9n.tk","0v.ro","0w.ro","0wn3d.pl","0wnd.net","0wnd.org","0wos8czt469.ga","0wos8czt469.gq","0wos8czt469.tk","0x00.name","0x000.cf","0x000.ga","0x000.gq","0x000.ml","0x01.gq","0x01.tk","0x02.cf","0x02.ga","0x02.gq","0x02.ml","0x02.tk","0x03.cf","0x03.ga","0x03.gq","0x03.ml","0x03.tk","0x207.info","0za7vhxzpkd.cf","0za7vhxzpkd.ga","0za7vhxzpkd.gq","0za7vhxzpkd.ml","0za7vhxzpkd.tk","0zc7eznv3rsiswlohu.cf","0zc7eznv3rsiswlohu.ml","0zc7eznv3rsiswlohu.tk","0zspgifzbo.cf","0zspgifzbo.ga","0zspgifzbo.gq","0zspgifzbo.ml","0zspgifzbo.tk","1-8.biz","1-million-rubley.xyz","1-up.cf","1-up.ga","1-up.gq","1-up.ml","1-up.tk","1.atm-mi.cf","1.atm-mi.ga","1.atm-mi.gq","1.atm-mi.ml","1.atm-mi.tk","1.batikbantul.com","1.emaile.org","1.emailfake.ml","1.fackme.gq","1.kerl.cf","10-tube.ru","10.dns-cloud.net","10000websites.miasta.pl","1000kti.xyz","1000mail.com","1000mail.tk","1000rebates.stream","100kti.xyz","100lat.com.pl","100likers.com","100lvl.com","100m.hl.cninfo.net","100ss.ru","100tb-porno.ru","10100.ml","101peoplesearches.com","101pl.us","101price.co","1020pay.com","1050.gq","1056windtreetrace.com","105kg.ru","10bir.com","10host.top","10launcheds.com","10m.email","10mail.com","10mail.org","10minut.com.pl","10minut.xyz","10minute-email.com","10minute.cf","10minutemail.be","10minutemail.cf","10minutemail.co.uk","10minutemail.co.za","10minutemail.com","10minutemail.de","10minutemail.ga","10minutemail.gq","10minutemail.info","10minutemail.ml","10minutemail.net","10minutemail.nl","10minutemail.org","10minutemail.pl","10minutemail.pro","10minutemail.ru","10minutemail.us","10minutemailbox.com","10minutemails.in","10minutenemail.de","10minutesmail.com","10minutesmail.fr","10minutesmail.net","10minutesmail.ru","10minutetempemail.com","10minutmail.pl","10pmdesign.com","10vpn.info","10x.es","10x9.com","11-32.cf","11-32.ga","11-32.gq","11-32.ml","11-32.tk","110202.com","110mail.net","1111.ru","111222.pl","11163.com","115mail.net","117.yyolf.net","11a-klass.ru","11b-klass.ru","11booting.com","11lu.org","11top.xyz","11xz.com","12-znakov.ru","120mail.com","1221locust.com","123-m.com","123.dns-cloud.net","123321asedad.info","1236456.com","123amateucam.com","123anddone.com","123box.org","123coupons.com","123gmail.com","123hummer.com","123mail.ml","123market.com","123salesreps.com","126.com.com","126sell.com","129aastersisyii.info","12ab.info","12blogwonders.com","12hosting.net","12houremail.com","12minutemail.com","12minutemail.net","12monthsloan1.co.uk","12shoe.com","12storage.com","12ur8rat.pl","12wqeza.com","1337.email","1369.ru","139.com","13dk.net","13sasytkgb0qobwxat.cf","13sasytkgb0qobwxat.ga","13sasytkgb0qobwxat.gq","13sasytkgb0qobwxat.ml","13sasytkgb0qobwxat.tk","140unichars.com","147.cl","147gmail.com","1490wntj.com","14n.co.uk","14p.in","1500klass.ru","15qm-mail.red","15qm.com","163fy.com","164qq.com","167mail.com","1688daogou.com","168cyg.com","16ik7egctrkxpn9okr.ga","16ik7egctrkxpn9okr.ml","16ik7egctrkxpn9okr.tk","1701host.com","172tuan.com","1758indianway.com","1766258.com","17tgo.com","17tgy.com","17upay.com","18-19.cf","18-19.ga","18-19.gq","18-19.ml","18-19.tk","18-9-2.cf","18-9-2.ga","18-9-2.gq","18-9-2.ml","18-9-2.tk","1800-americas.info","1800endo.net","1866sailobx.com","188.com","189.cn","18a8q82bc.pl","18chiks.com","18ladies.com","1919-2009ch.pl","1985abc.com","1985ken.net","19922.cf","19922.ga","19922.gq","19922.ml","19quotes.com","1a-flashgames.info","1afbwqtl8bcimxioz.cf","1afbwqtl8bcimxioz.ga","1afbwqtl8bcimxioz.gq","1afbwqtl8bcimxioz.ml","1afbwqtl8bcimxioz.tk","1ank6cw.gmina.pl","1aolmail.com","1asdasd.com","1automovers.info","1ayj8yi7lpiksxawav.cf","1ayj8yi7lpiksxawav.ga","1ayj8yi7lpiksxawav.gq","1ayj8yi7lpiksxawav.ml","1ayj8yi7lpiksxawav.tk","1blackmoon.com","1blueymail.gq","1ce.us","1chsdjk7f.pl","1chuan.com","1clck2.com","1click-me.info","1cocosmail.co.cc","1cw1mszn.pl","1datingintheusa.com","1dds23.com","1dmedical.com","1dne.com","1drive.cf","1drive.ga","1drive.gq","1e72.com","1e80.com","1errz9femsvhqao6.cf","1errz9femsvhqao6.ga","1errz9femsvhqao6.gq","1errz9femsvhqao6.ml","1errz9femsvhqao6.tk","1euqhmw9xmzn.cf","1euqhmw9xmzn.ga","1euqhmw9xmzn.gq","1euqhmw9xmzn.ml","1euqhmw9xmzn.tk","1f3t.com","1fsdfdsfsdf.tk","1gatwickaccommodation.info","1gmail.com","1googlemail.com","1hermesbirkin0.com","1hmoxs72qd.cf","1hmoxs72qd.ga","1hmoxs72qd.ml","1hmoxs72qd.tk","1hotmail.com","1hsoagca2euowj3ktc.ga","1hsoagca2euowj3ktc.gq","1hsoagca2euowj3ktc.ml","1hsoagca2euowj3ktc.tk","1jypg93t.orge.pl","1liqu1d.gq","1load-fiiliiies.ru","1lv.in","1mail.ml","1mail.uk.to","1mail.x24hr.com","1milliondollars.xyz","1mojadieta.ru","1moresurvey.com","1mspkvfntkn9vxs1oit.cf","1mspkvfntkn9vxs1oit.ga","1mspkvfntkn9vxs1oit.gq","1mspkvfntkn9vxs1oit.ml","1mspkvfntkn9vxs1oit.tk","1nppx7ykw.pl","1nut.com","1ouboutinshoes.com","1ouisvuitton1.com","1ouisvuittonborseit.com","1ouisvuittonfr.com","1pad.de","1penceauction.co.uk","1qpatglchm1.cf","1qpatglchm1.ga","1qpatglchm1.gq","1qpatglchm1.ml","1qpatglchm1.tk","1qwezaa.com","1rentcar.top","1riladg.mil.pl","1rmgqwfno8wplt.cf","1rmgqwfno8wplt.ga","1rmgqwfno8wplt.gq","1rmgqwfno8wplt.ml","1rmgqwfno8wplt.tk","1rnydobtxcgijcfgl.cf","1rnydobtxcgijcfgl.ga","1rnydobtxcgijcfgl.gq","1rnydobtxcgijcfgl.ml","1rnydobtxcgijcfgl.tk","1rumk9woxp1.pl","1rzk1ufcirxtg.ga","1rzk1ufcirxtg.ml","1rzk1ufcirxtg.tk","1rzpdv6y4a5cf5rcmxg.cf","1rzpdv6y4a5cf5rcmxg.ga","1rzpdv6y4a5cf5rcmxg.gq","1rzpdv6y4a5cf5rcmxg.ml","1rzpdv6y4a5cf5rcmxg.tk","1s.fr","1s1uasxaqhm9.cf","1s1uasxaqhm9.ga","1s1uasxaqhm9.gq","1s1uasxaqhm9.ml","1s1uasxaqhm9.tk","1secmail.com","1secmail.net","1secmail.org","1secmail.xyz","1shivom.com","1sj2003.com","1spcziorgtfpqdo.cf","1spcziorgtfpqdo.ga","1spcziorgtfpqdo.gq","1spcziorgtfpqdo.ml","1spcziorgtfpqdo.tk","1ss.noip.me","1st-forms.com","1stbest.info","1stpatrol.info","1syn.info","1thecity.biz","1tmail.ltd","1to1mail.org","1turkeyfarmlane.com","1up.orangotango.gq","1usemail.com","1vitsitoufficiale.com","1vsitoit.com","1webmail.info","1website.net","1x1zsv9or.pl","1xkfe3oimup4gpuop.cf","1xkfe3oimup4gpuop.ga","1xkfe3oimup4gpuop.gq","1xkfe3oimup4gpuop.ml","1xkfe3oimup4gpuop.tk","1xy86py.top","1zhuan.com","1zxzhoonfaia3.cf","1zxzhoonfaia3.ga","1zxzhoonfaia3.gq","1zxzhoonfaia3.ml","1zxzhoonfaia3.tk","2-attorney.com","2-bee.tk","2-ch.space","2.0-00.usa.cc","2.batikbantul.com","2.emailfake.ml","2.fackme.gq","2.kerl.cf","2.safemail.cf","2.safemail.tk","2.sexymail.ooo","2.tebwinsoi.ooo","2.vvsmail.com","20-20pathways.com","20.dns-cloud.net","20.gov","2000-plus.pl","2000rebates.stream","200555.com","2008firecode.info","2008radiochat.info","2010tour.info","2011cleanermail.info","2011rollover.info","2012-2016.ru","2012ajanda.com","2012burberryhandbagsjp.com","2012casquebeatsbydre.info","2012moncleroutletjacketssale.com","2012nflnews.com","2012pandoracharms.net","2013-ddrvers.ru","2013-lloadboxxx.ru","2013cheapnikeairjordan.org","2013dietsfromoz.com","2013fitflopoutlet.com","2013longchamppaschere.com","2013louboutinoutlets.com","2013mercurialshoeusa.com","2013nikeairmaxv.com","2014mail.ru","2018-12-23.ga","2019x.cf","2019x.ga","2019x.gq","2019x.ml","2019y.cf","2019y.ga","2019y.gq","2019y.ml","2019z.cf","2019z.ga","2019z.gq","2019z.ml","2019z.tk","20520.com","20boxme.org","20email.eu","20email.it","20mail.eu","20mail.in","20mail.it","20minute.email","20minutemail.com","20minutemail.it","20mm.eu","20twelvedubstep.com","2120001.net","212staff.com","2166tow6.mil.pl","21cn.com","21daysugardetoxreview.org","21email4now.info","21lr12.cf","21yearsofblood.com","220w.net","225522.ml","22ffnrxk11oog.cf","22ffnrxk11oog.ga","22ffnrxk11oog.gq","22ffnrxk11oog.tk","22meds.com","22office.com","22ov17gzgebhrl.cf","22ov17gzgebhrl.gq","22ov17gzgebhrl.ml","22ov17gzgebhrl.tk","22zollmonitor.com","23-february-posdrav.ru","2323bryanstreet.com","234.pl","234asdadsxz.info","235francisco.com","23fanofknives.com","23sfeqazx.com","23thingstodoxz.com","24-7-demolition-adelaide.com","24-7-fencer-brisbane.com","24-7-plumber-brisbane.com","24-7-retaining-walls-brisbane.com","246hltwog9utrzsfmj.cf","246hltwog9utrzsfmj.ga","246hltwog9utrzsfmj.gq","246hltwog9utrzsfmj.ml","246hltwog9utrzsfmj.tk","247gmail.com","247jockey.com","247web.net","24cheapdrugsonline.ru","24ddw6hy4ltg.cf","24ddw6hy4ltg.ga","24ddw6hy4ltg.gq","24ddw6hy4ltg.ml","24ddw6hy4ltg.tk","24facet.com","24fm.org","24hbanner.com","24hinbox.com","24hotesl.com","24hourfitness.com","24hourloans.us","24hourmail.com","24hourmail.net","24hrsofsales.com","24mail.top","24mail.xyz","24meds.com","25mails.com","26evbkf6n.aid.pl","26llxdhttjb.cf","26llxdhttjb.ga","26llxdhttjb.gq","26llxdhttjb.ml","26llxdhttjb.tk","26pg.com","27hotesl.com","2820666hyby.com","28onnae92bleuiennc1.cf","28onnae92bleuiennc1.ga","28onnae92bleuiennc1.gq","28onnae92bleuiennc1.ml","28onnae92bleuiennc1.tk","291.usa.cc","2911.net","29wrzesnia.pl","2aitycnhnno6.cf","2aitycnhnno6.ga","2aitycnhnno6.gq","2aitycnhnno6.ml","2aitycnhnno6.tk","2and2mail.tk","2anom.com","2brutus.com","2ch.coms.hk","2ch.daemon.asia","2ch.orgs.hk","2cny2bstqhouldn.cf","2cny2bstqhouldn.ga","2cny2bstqhouldn.gq","2cny2bstqhouldn.ml","2cny2bstqhouldn.tk","2coolchops.info","2cor9.com","2ctech.net","2dfmail.ga","2dfmail.ml","2dfmail.tk","2dsectv.ru","2edgklfs9o5i.cf","2edgklfs9o5i.ga","2edgklfs9o5i.gq","2edgklfs9o5i.ml","2edgklfs9o5i.tk","2emea.com","2eq8eaj32sxi.cf","2eq8eaj32sxi.ga","2eq8eaj32sxi.gq","2eq8eaj32sxi.ml","2eq8eaj32sxi.tk","2ether.net","2ez6l4oxx.pl","2f2tisxv.bij.pl","2fdgdfgdfgdf.tk","2gep2ipnuno4oc.cf","2gep2ipnuno4oc.ga","2gep2ipnuno4oc.gq","2gep2ipnuno4oc.ml","2gep2ipnuno4oc.tk","2gufaxhuzqt2g1h.cf","2gufaxhuzqt2g1h.ga","2gufaxhuzqt2g1h.gq","2gufaxhuzqt2g1h.ml","2gufaxhuzqt2g1h.tk","2hermesbirkin0.com","2hotmail.com","2iikwltxabbkofa.cf","2iikwltxabbkofa.ga","2iikwltxabbkofa.gq","2iikwltxabbkofa.ml","2iuzngbdujnf3e.cf","2iuzngbdujnf3e.ga","2iuzngbdujnf3e.gq","2iuzngbdujnf3e.ml","2iuzngbdujnf3e.tk","2k18.mailr.eu","2kcr.win","2kpda46zg.ml","2kwebserverus.info","2listen.ru","2lyvui3rlbx9.cf","2lyvui3rlbx9.ga","2lyvui3rlbx9.gq","2lyvui3rlbx9.ml","2mail.2waky.com","2mailnext.com","2mailnext.top","2nd-mail.xyz","2ndamendmenttactical.com","2nf.org","2o3ffrm7pm.cf","2o3ffrm7pm.ga","2o3ffrm7pm.gq","2o3ffrm7pm.ml","2o3ffrm7pm.tk","2odem.com","2oqqouxuruvik6zzw9.cf","2oqqouxuruvik6zzw9.ga","2oqqouxuruvik6zzw9.gq","2oqqouxuruvik6zzw9.ml","2oqqouxuruvik6zzw9.tk","2p-mail.com","2p7u8ukr6pksiu.cf","2p7u8ukr6pksiu.ga","2p7u8ukr6pksiu.gq","2p7u8ukr6pksiu.ml","2p7u8ukr6pksiu.tk","2prong.com","2ptech.info","2sea.org","2sea.xyz","2skjqy.pl","2tl2qamiivskdcz.cf","2tl2qamiivskdcz.ga","2tl2qamiivskdcz.gq","2tl2qamiivskdcz.ml","2tl2qamiivskdcz.tk","2umail.org","2ursxg0dbka.cf","2ursxg0dbka.ga","2ursxg0dbka.gq","2ursxg0dbka.ml","2ursxg0dbka.tk","2v3vjqapd6itot8g4z.cf","2v3vjqapd6itot8g4z.ga","2v3vjqapd6itot8g4z.gq","2v3vjqapd6itot8g4z.ml","2v3vjqapd6itot8g4z.tk","2viewerl.com","2vznqascgnfgvwogy.cf","2vznqascgnfgvwogy.ga","2vznqascgnfgvwogy.gq","2vznqascgnfgvwogy.ml","2vznqascgnfgvwogy.tk","2wc.info","2web.com.pl","2wjxak4a4te.cf","2wjxak4a4te.ga","2wjxak4a4te.gq","2wjxak4a4te.ml","2wjxak4a4te.tk","2wm3yhacf4fvts.ga","2wm3yhacf4fvts.gq","2wm3yhacf4fvts.ml","2wm3yhacf4fvts.tk","2world.pl","2yh6uz.bee.pl","2yigoqolrmfjoh.gq","2yigoqolrmfjoh.ml","2yigoqolrmfjoh.tk","2zozbzcohz3sde.cf","2zozbzcohz3sde.gq","2zozbzcohz3sde.ml","2zozbzcohz3sde.tk","2zpph1mgg70hhub.cf","2zpph1mgg70hhub.ga","2zpph1mgg70hhub.gq","2zpph1mgg70hhub.ml","2zpph1mgg70hhub.tk","3-attorney.com","3-debt.com","3.batikbantul.com","3.emailfake.ml","3.fackme.gq","3.kerl.cf","3.vvsmail.com","30.dns-cloud.net","300book.info","301er.com","301url.info","30daycycle.com","30daygoldmine.com","30daystothinreview.org","30mail.ir","30minutemail.com","30minutenmail.eu","30secondsmile-review.info","30wave.com","318tuan.com","31k.it","31lossweibox.com","32.biz","3202.com","321-email.com","321dasdjioadoi.info","326herry.com","328herry.com","328hetty.com","32inchledtvreviews.com","331main.com","333.igg.biz","33m.co","33mail.com","345.pl","345v345t34t.cf","345v345t34t.ga","345v345t34t.gq","345v345t34t.ml","345v345t34t.tk","348es7arsy2.cf","348es7arsy2.ga","348es7arsy2.gq","348es7arsy2.ml","348es7arsy2.tk","34rf6y.as","34rfwef2sdf.co.pl","357merry.com","35yuan.com","360discountgames.info","360shopat.com","360spel.se","363.net","365jjs.com","365live7m.com","365me.info","3675.mooo.com","368herry.com","368hetty.com","369hetty.com","36ru.com","374kj.com","3782wqk.targi.pl","38528.com","386herry.com","386hetty.com","396hetty.com","3agg8gojyj.ga","3agg8gojyj.gq","3agg8gojyj.ml","3bo1grwl36e9q.cf","3bo1grwl36e9q.ga","3bo1grwl36e9q.gq","3bo1grwl36e9q.ml","3bo1grwl36e9q.tk","3c0zpnrhdv78n.ga","3c0zpnrhdv78n.gq","3c0zpnrhdv78n.ml","3c0zpnrhdv78n.tk","3ce5jbjog.pl","3d-films.ru","3d-painting.com","3d180.com","3darchitekci.com.pl","3dheadsets.net","3diifwl.mil.pl","3dmail.top","3dnevvs.ru","3drugs.com","3dsgateway.eu","3dwstudios.net","3etvi1zbiuv9n.cf","3etvi1zbiuv9n.ga","3etvi1zbiuv9n.gq","3etvi1zbiuv9n.ml","3etvi1zbiuv9n.tk","3ew.usa.cc","3fhjcewk.pl","3fy1rcwevwm4y.cf","3fy1rcwevwm4y.ga","3fy1rcwevwm4y.gq","3fy1rcwevwm4y.ml","3fy1rcwevwm4y.tk","3g24.pl","3g2bpbxdrbyieuv9n.cf","3g2bpbxdrbyieuv9n.ga","3g2bpbxdrbyieuv9n.gq","3g2bpbxdrbyieuv9n.ml","3g2bpbxdrbyieuv9n.tk","3gauto.co.uk","3gk2yftgot.cf","3gk2yftgot.ga","3gk2yftgot.gq","3gk2yftgot.ml","3gk2yftgot.tk","3gmtlalvfggbl3mxm.cf","3gmtlalvfggbl3mxm.ga","3gmtlalvfggbl3mxm.gq","3gmtlalvfggbl3mxm.ml","3gmtlalvfggbl3mxm.tk","3hermesbirkin0.com","3j4rnelenwrlvni1t.ga","3j4rnelenwrlvni1t.gq","3j4rnelenwrlvni1t.ml","3j4rnelenwrlvni1t.tk","3kbyueliyjkrfhsg.ga","3kbyueliyjkrfhsg.gq","3kbyueliyjkrfhsg.ml","3kbyueliyjkrfhsg.tk","3ker23i7vpgxt2hp.cf","3ker23i7vpgxt2hp.ga","3ker23i7vpgxt2hp.gq","3ker23i7vpgxt2hp.ml","3ker23i7vpgxt2hp.tk","3kh990rrox.cf","3kh990rrox.ml","3kh990rrox.tk","3knloiai.mil.pl","3kqvns1s1ft7kenhdv8.cf","3kqvns1s1ft7kenhdv8.ga","3kqvns1s1ft7kenhdv8.gq","3kqvns1s1ft7kenhdv8.ml","3kqvns1s1ft7kenhdv8.tk","3krtqc2fr7e.cf","3krtqc2fr7e.ga","3krtqc2fr7e.gq","3krtqc2fr7e.ml","3krtqc2fr7e.tk","3l6.com","3m4i1s.pl","3mail.ga","3mail.gq","3mail.rocks","3mailapp.net","3million3.com","3mir4osvd.pl","3monthloanseveryday.co.uk","3ntongm4il.ga","3ntxtrts3g4eko.cf","3ntxtrts3g4eko.ga","3ntxtrts3g4eko.gq","3ntxtrts3g4eko.ml","3ntxtrts3g4eko.tk","3pleasantgentlemen.com","3pscsr94r3dct1a7.cf","3pscsr94r3dct1a7.ga","3pscsr94r3dct1a7.gq","3pscsr94r3dct1a7.ml","3pscsr94r3dct1a7.tk","3pxsport.com","3qp6a6d.media.pl","3qpplo4avtreo4k.cf","3qpplo4avtreo4k.ga","3qpplo4avtreo4k.gq","3qpplo4avtreo4k.ml","3qpplo4avtreo4k.tk","3raspberryketonemonster.com","3ssfif.pl","3trtretgfrfe.tk","3utasmqjcv.cf","3utasmqjcv.ga","3utasmqjcv.gq","3utasmqjcv.ml","3utasmqjcv.tk","3wmnivgb8ng6d.cf","3wmnivgb8ng6d.ga","3wmnivgb8ng6d.gq","3wmnivgb8ng6d.ml","3wmnivgb8ng6d.tk","3wxoiia16pb9ck4o.cf","3wxoiia16pb9ck4o.ga","3wxoiia16pb9ck4o.ml","3wxoiia16pb9ck4o.tk","3x0ex1x2yx0.cf","3x0ex1x2yx0.ga","3x0ex1x2yx0.gq","3x0ex1x2yx0.ml","3x0ex1x2yx0.tk","3xophlbc5k3s2d6tb.cf","3xophlbc5k3s2d6tb.ga","3xophlbc5k3s2d6tb.gq","3xophlbc5k3s2d6tb.ml","3xophlbc5k3s2d6tb.tk","3zumchngf2t.cf","3zumchngf2t.ga","3zumchngf2t.gq","3zumchngf2t.ml","3zumchngf2t.tk","4-boy.com","4-credit.com","4-debt.com","4-n.us","4.batikbantul.com","4.emailfake.ml","4.fackme.gq","40.volvo-xc.ml","40.volvo-xc.tk","4006444444.com","4006633333.com","4006677777.com","404box.com","4057.com","4059.com","411reversedirectory.com","418.dk","41uno.com","41uno.net","41v1relaxn.com","420blaze.it","420pure.com","42o.org","43adsdzxcz.info","43sdvs.com","44556677.igg.biz","445t6454545ty4.cf","445t6454545ty4.ga","445t6454545ty4.gq","445t6454545ty4.ml","445t6454545ty4.tk","4545.a.hostable.me","456.dns-cloud.net","456b4564.cf","456b4564.ga","456b4564.gq","456b4564.ml","456b4564ev4.ga","456b4564ev4.gq","456b4564ev4.ml","456b4564ev4.tk","45hotesl.com","45kti.xyz","45up.com","466453.usa.cc","467uph4b5eezvbzdx.cf","467uph4b5eezvbzdx.ga","467uph4b5eezvbzdx.gq","467uph4b5eezvbzdx.ml","46lclee29x6m02kz.cf","46lclee29x6m02kz.ga","46lclee29x6m02kz.gq","46lclee29x6m02kz.ml","46lclee29x6m02kz.tk","475829487mail.net","47t.de","487.nut.cc","48m.info","49ersproteamshop.com","49erssuperbowlproshop.com","49ersuperbowlshop.com","49qoyzl.aid.pl","49xq.com","4alphapro.com","4b5yt45b4.cf","4b5yt45b4.ga","4b5yt45b4.gq","4b5yt45b4.ml","4b5yt45b4.tk","4bettergolf.com","4blogers.com","4bver2tkysutf.cf","4bver2tkysutf.ga","4bver2tkysutf.gq","4bver2tkysutf.ml","4bver2tkysutf.tk","4bvm5o8wc.pl","4c1jydiuy.pl","4c5kzxhdbozk1sxeww.cf","4c5kzxhdbozk1sxeww.gq","4c5kzxhdbozk1sxeww.ml","4c5kzxhdbozk1sxeww.tk","4cheaplaptops.com","4chnan.org","4easyemail.com","4eofbxcphifsma.cf","4eofbxcphifsma.ga","4eofbxcphifsma.gq","4eofbxcphifsma.ml","4eofbxcphifsma.tk","4fly.ga","4fly.ml","4free.li","4freemail.org","4gei7vonq5buvdvsd8y.cf","4gei7vonq5buvdvsd8y.ga","4gei7vonq5buvdvsd8y.gq","4gei7vonq5buvdvsd8y.ml","4gei7vonq5buvdvsd8y.tk","4gfdsgfdgfd.tk","4gwpencfprnmehx.cf","4gwpencfprnmehx.ga","4gwpencfprnmehx.gq","4gwpencfprnmehx.ml","4gwpencfprnmehx.tk","4hd8zutuircto.cf","4hd8zutuircto.ga","4hd8zutuircto.gq","4hd8zutuircto.ml","4hd8zutuircto.tk","4hsxniz4fpiuwoma.ga","4hsxniz4fpiuwoma.ml","4hsxniz4fpiuwoma.tk","4kqk58d4y.pl","4mail.cf","4mail.ga","4mail.top","4mispc8ou3helz3sjh.cf","4mispc8ou3helz3sjh.ga","4mispc8ou3helz3sjh.gq","4mispc8ou3helz3sjh.ml","4mispc8ou3helz3sjh.tk","4mnsuaaluts.cf","4mnsuaaluts.ga","4mnsuaaluts.gq","4mnsuaaluts.ml","4mnsuaaluts.tk","4mnvi.ru","4mobile.pw","4mwgfceokw83x1y7o.cf","4mwgfceokw83x1y7o.ga","4mwgfceokw83x1y7o.gq","4mwgfceokw83x1y7o.ml","4mwgfceokw83x1y7o.tk","4na3.pl","4nextmail.com","4nmv.ru","4ocmmk87.pl","4of671adx.pl","4ofqb4hq.pc.pl","4orty.com","4padpnhp5hs7k5no.cf","4padpnhp5hs7k5no.ga","4padpnhp5hs7k5no.gq","4padpnhp5hs7k5no.ml","4padpnhp5hs7k5no.tk","4pet.ro","4pkr15vtrpwha.cf","4pkr15vtrpwha.ga","4pkr15vtrpwha.gq","4pkr15vtrpwha.ml","4pkr15vtrpwha.tk","4prkrmmail.net","4rfv6qn1jwvl.cf","4rfv6qn1jwvl.ga","4rfv6qn1jwvl.gq","4rfv6qn1jwvl.ml","4rfv6qn1jwvl.tk","4senditnow.com","4shizzleyo.com","4simpleemail.com","4softsite.info","4starmaids.com","4stroy.info","4stroy.pl","4struga.com","4suf6rohbfglzrlte.cf","4suf6rohbfglzrlte.ga","4suf6rohbfglzrlte.gq","4suf6rohbfglzrlte.ml","4suf6rohbfglzrlte.tk","4sumki.org.ua","4tb.host","4timesover.com","4tmail.net","4tphy5m.pl","4up3vtaxujpdm2.cf","4up3vtaxujpdm2.ga","4up3vtaxujpdm2.gq","4up3vtaxujpdm2.ml","4up3vtaxujpdm2.tk","4vlasti.net","4vq19hhmxgaruka.cf","4vq19hhmxgaruka.ga","4vq19hhmxgaruka.gq","4vq19hhmxgaruka.ml","4vq19hhmxgaruka.tk","4w.io","4warding.com","4warding.net","4warding.org","4x4-team-usm.pl","4x4man.com","4x4n.ru","4x5aecxibj4.cf","4x5aecxibj4.ga","4x5aecxibj4.gq","4x5aecxibj4.ml","4x5aecxibj4.tk","4xzotgbunzq.cf","4xzotgbunzq.ga","4xzotgbunzq.gq","4xzotgbunzq.ml","4xzotgbunzq.tk","4you.de","4zbt9rqmvqf.cf","4zbt9rqmvqf.ga","4zbt9rqmvqf.gq","4zbt9rqmvqf.ml","4zbt9rqmvqf.tk","4ze1hnq6jjok.cf","4ze1hnq6jjok.ga","4ze1hnq6jjok.gq","4ze1hnq6jjok.ml","4ze1hnq6jjok.tk","4zhens.info","4zm1fjk8hpn.cf","4zm1fjk8hpn.ga","4zm1fjk8hpn.gq","4zm1fjk8hpn.ml","4zm1fjk8hpn.tk","5-attorney.com","5-mail.info","5.emailfake.ml","5.fackme.gq","500loan-payday.com","50c0bnui7wh.cf","50c0bnui7wh.ga","50c0bnui7wh.gq","50c0bnui7wh.ml","50c0bnui7wh.tk","50mb.ml","50sale.club","50saleclub.com","50set.ru","51.com","510520.org","510md.com","510sc.com","517dnf.com","519art.com","51icq.com","51jiaju.net","51ttkx.com","51xh.fun","51xoyo.com","5200001.top","525kou.com","52gmail.com","52subg.org","52tbao.com","52tour.com","53vtbcwxf91gcar.cf","53vtbcwxf91gcar.ga","53vtbcwxf91gcar.gq","53vtbcwxf91gcar.ml","53vtbcwxf91gcar.tk","543dsadsdawq.info","54np.club","54tiljt6dz9tcdryc2g.cf","54tiljt6dz9tcdryc2g.ga","54tiljt6dz9tcdryc2g.gq","54tiljt6dz9tcdryc2g.ml","54tiljt6dz9tcdryc2g.tk","555gmail.com","55hosting.net","56787.com","57up.com","58h.de","58k.ru","597j.com","5a58wijv3fxctgputir.cf","5a58wijv3fxctgputir.ga","5a58wijv3fxctgputir.gq","5a58wijv3fxctgputir.ml","5a58wijv3fxctgputir.tk","5acmkg8cgud5ky.cf","5acmkg8cgud5ky.ga","5acmkg8cgud5ky.gq","5acmkg8cgud5ky.ml","5acmkg8cgud5ky.tk","5am5ung.cf","5am5ung.ga","5am5ung.gq","5am5ung.ml","5am5ung.tk","5biya2otdnpkd7llam.cf","5biya2otdnpkd7llam.ga","5biya2otdnpkd7llam.gq","5biya2otdnpkd7llam.ml","5btxankuqtlmpg5.cf","5btxankuqtlmpg5.ga","5btxankuqtlmpg5.gq","5btxankuqtlmpg5.ml","5btxankuqtlmpg5.tk","5cbc.com","5ddgrmk3f2dxcoqa3.cf","5ddgrmk3f2dxcoqa3.ga","5ddgrmk3f2dxcoqa3.gq","5ddgrmk3f2dxcoqa3.ml","5ddgrmk3f2dxcoqa3.tk","5dsmartstore.com","5el5nhjf.pl","5fingershoesoutlet.com","5ghgfhfghfgh.tk","5gr6v4inzp8l.cf","5gr6v4inzp8l.ga","5gr6v4inzp8l.gq","5gr6v4inzp8l.ml","5gramos.com","5hcc9hnrpqpe.cf","5hcc9hnrpqpe.ga","5hcc9hnrpqpe.gq","5hcc9hnrpqpe.ml","5hcc9hnrpqpe.tk","5hfmczghlkmuiduha8t.cf","5hfmczghlkmuiduha8t.ga","5hfmczghlkmuiduha8t.gq","5hfmczghlkmuiduha8t.ml","5hfmczghlkmuiduha8t.tk","5iznnnr6sabq0b6.cf","5iznnnr6sabq0b6.ga","5iznnnr6sabq0b6.gq","5iznnnr6sabq0b6.ml","5iznnnr6sabq0b6.tk","5jir9r4j.pl","5july.org","5ketonemastery.com","5mail.cf","5mail.ga","5mail.xyz","5music.info","5music.top","5nqkxprvoctdc0.cf","5nqkxprvoctdc0.ga","5nqkxprvoctdc0.gq","5nqkxprvoctdc0.ml","5nqkxprvoctdc0.tk","5osjrktwc5pzxzn.cf","5osjrktwc5pzxzn.ga","5osjrktwc5pzxzn.gq","5osjrktwc5pzxzn.ml","5osjrktwc5pzxzn.tk","5ouhkf8v4vr6ii1fh.cf","5ouhkf8v4vr6ii1fh.ga","5ouhkf8v4vr6ii1fh.gq","5ouhkf8v4vr6ii1fh.ml","5ouhkf8v4vr6ii1fh.tk","5oz.ru","5quq5vbtzswx.cf","5quq5vbtzswx.ga","5quq5vbtzswx.gq","5quq5vbtzswx.ml","5quq5vbtzswx.tk","5r6atirlv.pl","5rof.cf","5so1mammwlf8c.cf","5so1mammwlf8c.ga","5so1mammwlf8c.gq","5so1mammwlf8c.ml","5so1mammwlf8c.tk","5tb-pix.ru","5tb-video.ru","5uet4izbel.cf","5uet4izbel.ga","5uet4izbel.gq","5uet4izbel.ml","5uet4izbel.tk","5vcxwmwtq62t5.cf","5vcxwmwtq62t5.ga","5vcxwmwtq62t5.gq","5vcxwmwtq62t5.ml","5vcxwmwtq62t5.tk","5vlimcrvbyurmmllcw0.cf","5vlimcrvbyurmmllcw0.ga","5vlimcrvbyurmmllcw0.gq","5vlimcrvbyurmmllcw0.ml","5vlimcrvbyurmmllcw0.tk","5x25.com","5yi9xi9.mil.pl","5yk.idea-makers.tk","5ymail.com","5ytff56753kkk.cf","5ytff56753kkk.ga","5ytff56753kkk.gq","5ytff56753kkk.ml","5ytff56753kkk.tk","6-6-6.cf","6-6-6.ga","6-6-6.igg.biz","6-6-6.ml","6-6-6.nut.cc","6-6-6.usa.cc","6-attorney.com","6-debt.com","6.emailfake.ml","6.fackme.gq","60-minuten-mail.de","60.volvo-xc.ml","60.volvo-xc.tk","600pro.com","609k23.pl","60dayworkoutdvd.info","60minutemail.com","60paydayloans.co.uk","65nryny6y7.cf","65nryny6y7.ga","65nryny6y7.gq","65nryny6y7.ml","65nryny6y7.tk","65uwtobxcok66.cf","65uwtobxcok66.ga","65uwtobxcok66.gq","65uwtobxcok66.ml","65uwtobxcok66.tk","666-evil.com","666-satan.cf","666-satan.ga","666-satan.gq","666-satan.ml","666-satan.tk","666mai.com","666zagrusssski.ru","672643.net","675hosting.com","675hosting.net","675hosting.org","67832.cf","67832.ga","67832.ml","67832.tk","67azck3y6zgtxfoybdm.cf","67azck3y6zgtxfoybdm.ga","67azck3y6zgtxfoybdm.gq","67azck3y6zgtxfoybdm.ml","67azck3y6zgtxfoybdm.tk","67rzpjb2im3fuehh9gp.cf","67rzpjb2im3fuehh9gp.ga","67rzpjb2im3fuehh9gp.gq","67rzpjb2im3fuehh9gp.ml","67rzpjb2im3fuehh9gp.tk","67xxzwhzv5fr.cf","67xxzwhzv5fr.ga","67xxzwhzv5fr.gq","67xxzwhzv5fr.tk","688as.org","68azpqh.pl","68mail.com","69-ew.tk","69postix.info","69t03rpsl4.cf","69t03rpsl4.ga","69t03rpsl4.gq","69t03rpsl4.ml","69t03rpsl4.tk","6a24bzvvu.pl","6a81fostts.cf","6a81fostts.ga","6a81fostts.gq","6a81fostts.ml","6a81fostts.tk","6brmwv.cf","6brmwv.ga","6brmwv.gq","6brmwv.ml","6brmwv.tk","6ceqs4enix.co19.kr","6cq9epnn.edu.pl","6ed9cit4qpxrcngbq.cf","6ed9cit4qpxrcngbq.ga","6ed9cit4qpxrcngbq.gq","6ed9cit4qpxrcngbq.ml","6ed9cit4qpxrcngbq.tk","6elkf86.pl","6en9mail2.ga","6eng-zma1lz.ga","6eogvwbma.pl","6f.pl","6hermesbirkin0.com","6hjgjhgkilkj.tk","6ip.us","6j.j6.org","6kg8ddf6mtlyzzi5mm.cf","6kg8ddf6mtlyzzi5mm.ga","6kg8ddf6mtlyzzi5mm.gq","6kg8ddf6mtlyzzi5mm.ml","6kg8ddf6mtlyzzi5mm.tk","6lhp5tembvpl.cf","6lhp5tembvpl.ga","6lhp5tembvpl.gq","6lhp5tembvpl.ml","6lhp5tembvpl.tk","6mail.cf","6mail.ga","6mail.ml","6mail.top","6monthscarinsurance.co.uk","6nns09jw.bee.pl","6paq.com","6q70sdpgjzm2irltn.cf","6q70sdpgjzm2irltn.ga","6q70sdpgjzm2irltn.gq","6q70sdpgjzm2irltn.ml","6q70sdpgjzm2irltn.tk","6qssmefkx.pl","6qstz1fsm8hquzz.cf","6qstz1fsm8hquzz.ga","6qstz1fsm8hquzz.gq","6qstz1fsm8hquzz.ml","6qstz1fsm8hquzz.tk","6qwkvhcedxo85fni.cf","6qwkvhcedxo85fni.ga","6qwkvhcedxo85fni.gq","6qwkvhcedxo85fni.ml","6qwkvhcedxo85fni.tk","6ra8wqulh.pl","6rndtguzgeajcce.cf","6rndtguzgeajcce.ga","6rndtguzgeajcce.gq","6rndtguzgeajcce.ml","6rndtguzgeajcce.tk","6rrtk52.mil.pl","6s5z.com","6scwis5lamcv.gq","6somok.ru","6twkd1jggp9emimfya8.cf","6twkd1jggp9emimfya8.ga","6twkd1jggp9emimfya8.gq","6twkd1jggp9emimfya8.ml","6twkd1jggp9emimfya8.tk","6ugzob6xpyzwt.cf","6ugzob6xpyzwt.ga","6ugzob6xpyzwt.gq","6ugzob6xpyzwt.ml","6ugzob6xpyzwt.tk","6url.com","6v9haqno4e.cf","6v9haqno4e.ga","6v9haqno4e.gq","6v9haqno4e.ml","6v9haqno4e.tk","6vgflujwsc.cf","6vgflujwsc.ga","6vgflujwsc.gq","6vgflujwsc.ml","7-attorney.com","7.emailfake.ml","7.fackme.gq","703xanmf2tk5lny.cf","703xanmf2tk5lny.ga","703xanmf2tk5lny.gq","703xanmf2tk5lny.ml","703xanmf2tk5lny.tk","708ugg-boots.com","70k6ylzl2aumii.cf","70k6ylzl2aumii.ga","70k6ylzl2aumii.gq","70k6ylzl2aumii.ml","70k6ylzl2aumii.tk","7119.net","719x.com","71btdutk.blogrtui.ru","71compete.com","726xhknin96v9oxdqa.cf","726xhknin96v9oxdqa.gq","726xhknin96v9oxdqa.ml","726xhknin96v9oxdqa.tk","72w.com","73up.com","73wire.com","73xk2p39p.pl","7567fdcvvghw2.cf","7567fdcvvghw2.ga","7567fdcvvghw2.gq","7567fdcvvghw2.ml","7567fdcvvghw2.tk","75happy.com","75hosting.com","75hosting.net","75hosting.org","76jdafbnde38cd.cf","76jdafbnde38cd.ga","76jdafbnde38cd.gq","76jdafbnde38cd.ml","76jdafbnde38cd.tk","76up.com","777-university.ru","777.net.cn","777slots-online.com","787y849s.bij.pl","789.dns-cloud.net","789456123mail.ml","799fu.com","79mail.com","7ag83mwrabz.ga","7ag83mwrabz.ml","7ag83mwrabz.tk","7bafilmy.ru","7bhmsthext.cf","7bhmsthext.ga","7bhmsthext.gq","7bhmsthext.ml","7bhmsthext.tk","7bhtm0suwklftwx7.cf","7bhtm0suwklftwx7.ga","7bhtm0suwklftwx7.gq","7bhtm0suwklftwx7.ml","7bhtm0suwklftwx7.tk","7d7ebci63.pl","7days-printing.com","7ddf32e.info","7dmail.com","7go.info","7gpvegspglb8x8bczws.cf","7gpvegspglb8x8bczws.ga","7gpvegspglb8x8bczws.gq","7gpvegspglb8x8bczws.ml","7gpvegspglb8x8bczws.tk","7gr.pl","7ihd9vh6.edu.pl","7ijabi.com","7kuiqff4ay.cf","7kuiqff4ay.ga","7kuiqff4ay.gq","7kuiqff4ay.ml","7kuiqff4ay.tk","7m3aq2e9chlicm.cf","7m3aq2e9chlicm.ga","7m3aq2e9chlicm.gq","7m3aq2e9chlicm.ml","7m3aq2e9chlicm.tk","7mail.ga","7mail.io","7mail.ml","7mail.xyz","7mail7.com","7med24.co.uk","7nglhuzdtv.cf","7nglhuzdtv.ga","7nglhuzdtv.gq","7nglhuzdtv.ml","7nglhuzdtv.tk","7oicpwgcc8trzcvvfww.cf","7oicpwgcc8trzcvvfww.ga","7oicpwgcc8trzcvvfww.gq","7oicpwgcc8trzcvvfww.ml","7oicpwgcc8trzcvvfww.tk","7opp2romngiww8vto.cf","7opp2romngiww8vto.ga","7opp2romngiww8vto.gq","7opp2romngiww8vto.ml","7opp2romngiww8vto.tk","7p6kz0omk2kb6fs8lst.cf","7p6kz0omk2kb6fs8lst.ga","7p6kz0omk2kb6fs8lst.gq","7p6kz0omk2kb6fs8lst.ml","7p6kz0omk2kb6fs8lst.tk","7pccf.cf","7pccf.ga","7pccf.gq","7pccf.ml","7pccf.tk","7pdqpb96.pl","7qrtbew5cigi.cf","7qrtbew5cigi.ga","7qrtbew5cigi.gq","7qrtbew5cigi.ml","7qrtbew5cigi.tk","7rent.top","7rtay.info","7rx24.com","7seatercarsz.com","7startruckdrivingschool.com","7tags.com","7tiqqxsfmd2qx5.cf","7tiqqxsfmd2qx5.ga","7tiqqxsfmd2qx5.gq","7tiqqxsfmd2qx5.ml","7tiqqxsfmd2qx5.tk","7tsrslgtclz.pl","7twlev.bij.pl","7u7rdldlbvcnklclnpx.cf","7u7rdldlbvcnklclnpx.ga","7u7rdldlbvcnklclnpx.gq","7u7rdldlbvcnklclnpx.ml","7u7rdldlbvcnklclnpx.tk","7uy35p.cf","7uy35p.ga","7uy35p.gq","7uy35p.ml","7uy35p.tk","7vcntir8vyufqzuqvri.cf","7vcntir8vyufqzuqvri.ga","7vcntir8vyufqzuqvri.gq","7vcntir8vyufqzuqvri.ml","7vcntir8vyufqzuqvri.tk","7wd45do5l.pl","7wzctlngbx6fawlv.cf","7wzctlngbx6fawlv.ga","7wzctlngbx6fawlv.gq","7wzctlngbx6fawlv.ml","7wzctlngbx6fawlv.tk","7xnk9kv.pl","8-mail.com","8.emailfake.ml","8.fackme.gq","800hotspots.info","800sacramento.tk","804m66.pl","806.flu.cc","80665.com","808app.com","80pu.info","80r0zc5fxpmuwczzxl.cf","80r0zc5fxpmuwczzxl.ga","80r0zc5fxpmuwczzxl.gq","80r0zc5fxpmuwczzxl.ml","80r0zc5fxpmuwczzxl.tk","80ro.eu","80zooiwpz1nglieuad8.cf","80zooiwpz1nglieuad8.ga","80zooiwpz1nglieuad8.gq","80zooiwpz1nglieuad8.ml","80zooiwpz1nglieuad8.tk","8127ep.com","81519gcu.orge.pl","8191.at","819978f0-0b0f-11e2-892e-0800200c9a66.com","8290.com","82c8.com","82j2we.pl","83gd90qriawwf.cf","83gd90qriawwf.ga","83gd90qriawwf.gq","83gd90qriawwf.ml","83gd90qriawwf.tk","84mce5gufev8.cf","84mce5gufev8.ga","84mce5gufev8.gq","84mce5gufev8.ml","84mce5gufev8.tk","84rhilv8mm3xut2.cf","84rhilv8mm3xut2.ga","84rhilv8mm3xut2.gq","84rhilv8mm3xut2.ml","84rhilv8mm3xut2.tk","86d14866fx.ml","87gjgsdre2sv.cf","87gjgsdre2sv.ga","87gjgsdre2sv.gq","87gjgsdre2sv.ml","87gjgsdre2sv.tk","87mmwdtf63b.cf","87mmwdtf63b.ga","87mmwdtf63b.gq","87mmwdtf63b.ml","87mmwdtf63b.tk","87yhasdasdmail.ru","8808go.com","8848.net","888.gen.in","888z5.cf","888z5.ga","888z5.gq","888z5.ml","888z5.tk","88998.com","88chaye.com","88clean.pro","88cot.info","88urtyzty.pl","89ghferrq.com","89yliughdo89tly.com","8chan.co","8e6d9wk7a19vedntm35.cf","8e6d9wk7a19vedntm35.ga","8e6d9wk7a19vedntm35.gq","8e6d9wk7a19vedntm35.ml","8eoqovels2mxnxzwn7a.cf","8eoqovels2mxnxzwn7a.ga","8eoqovels2mxnxzwn7a.gq","8eoqovels2mxnxzwn7a.ml","8eoqovels2mxnxzwn7a.tk","8ev9nir3ilwuw95zp.cf","8ev9nir3ilwuw95zp.ga","8ev9nir3ilwuw95zp.gq","8ev9nir3ilwuw95zp.ml","8ev9nir3ilwuw95zp.tk","8ffn7qixgk3vq4z.cf","8ffn7qixgk3vq4z.ga","8ffn7qixgk3vq4z.gq","8ffn7qixgk3vq4z.ml","8ffn7qixgk3vq4z.tk","8fuur0zzvo8otsk.cf","8fuur0zzvo8otsk.ga","8fuur0zzvo8otsk.gq","8fuur0zzvo8otsk.ml","8fuur0zzvo8otsk.tk","8gnkb3b.sos.pl","8hadrm28w.pl","8hermesbirkin0.com","8hfzqpstkqux.cf","8hfzqpstkqux.ga","8hfzqpstkqux.gq","8hfzqpstkqux.ml","8hfzqpstkqux.tk","8hj3rdieaek.cf","8hj3rdieaek.ga","8hj3rdieaek.gq","8hj3rdieaek.ml","8hj3rdieaek.tk","8imefdzddci.cf","8imefdzddci.ga","8imefdzddci.gq","8imefdzddci.ml","8imefdzddci.tk","8kcpfcer6keqqm.cf","8kcpfcer6keqqm.ml","8kcpfcer6keqqm.tk","8klddrkdxoibtasn3g.cf","8klddrkdxoibtasn3g.ga","8klddrkdxoibtasn3g.gq","8klddrkdxoibtasn3g.ml","8klddrkdxoibtasn3g.tk","8liffwp16.pl","8mail.cf","8mail.ga","8mail.ml","8mnqpys1n.pl","8oboi80bcv1.cf","8oboi80bcv1.ga","8oboi80bcv1.gq","8ouyuy5.ce.ms","8pc2ztkr6.pl","8pukcddnthjql.cf","8pukcddnthjql.ga","8pukcddnthjql.gq","8pukcddnthjql.ml","8pukcddnthjql.tk","8qdw3jexxncwd.cf","8qdw3jexxncwd.ga","8qdw3jexxncwd.gq","8qdw3jexxncwd.ml","8qdw3jexxncwd.tk","8qwh37kibb6ut7.cf","8qwh37kibb6ut7.ga","8qwh37kibb6ut7.gq","8qwh37kibb6ut7.ml","8qwh37kibb6ut7.tk","8rskf3xpyq.cf","8rskf3xpyq.ga","8rskf3xpyq.gq","8rskf3xpyq.ml","8rskf3xpyq.tk","8t0sznngp6aowxsrj.cf","8t0sznngp6aowxsrj.ga","8t0sznngp6aowxsrj.gq","8t0sznngp6aowxsrj.ml","8t0sznngp6aowxsrj.tk","8u4e3qqbu.pl","8usmwuqxh1s1pw.cf","8usmwuqxh1s1pw.ga","8usmwuqxh1s1pw.gq","8usmwuqxh1s1pw.ml","8usmwuqxh1s1pw.tk","8verxcdkrfal61pfag.cf","8verxcdkrfal61pfag.ga","8verxcdkrfal61pfag.gq","8verxcdkrfal61pfag.ml","8verxcdkrfal61pfag.tk","8wehgc2atizw.cf","8wehgc2atizw.ga","8wehgc2atizw.gq","8wehgc2atizw.ml","8wehgc2atizw.tk","8wkkrizxpphbm3c.cf","8wkkrizxpphbm3c.ga","8wkkrizxpphbm3c.gq","8wkkrizxpphbm3c.ml","8wkkrizxpphbm3c.tk","8wwxmcyntfrf.cf","8wwxmcyntfrf.ga","8wwxmcyntfrf.gq","8wwxmcyntfrf.ml","8xcdzvxgnfztticc.cf","8xcdzvxgnfztticc.ga","8xcdzvxgnfztticc.gq","8xcdzvxgnfztticc.tk","8xyz8.dynu.net","8ythwpz.pl","8zbpmvhxvue.cf","8zbpmvhxvue.ga","8zbpmvhxvue.gq","8zbpmvhxvue.ml","8zbpmvhxvue.tk","9.emailfake.ml","9.fackme.gq","90.volvo-xc.ml","90.volvo-xc.tk","900k.es","91000.com","926tao.com","9310.ru","933j.com","93k0ldakr6uzqe.cf","93k0ldakr6uzqe.ga","93k0ldakr6uzqe.gq","93k0ldakr6uzqe.ml","93k0ldakr6uzqe.tk","94xtyktqtgsw7c7ljxx.co.cc","97so1ubz7g5unsqgt6.cf","97so1ubz7g5unsqgt6.ga","97so1ubz7g5unsqgt6.gq","97so1ubz7g5unsqgt6.ml","97so1ubz7g5unsqgt6.tk","98usd.com","99.com","990.net","999bjw.com","999intheshade.net","99cows.com","99depressionlists.com","99experts.com","99hacks.us","99mail.cf","99price.co","99pubblicita.com","99publicita.com","99x99.com","9ate.com","9cvlhwqrdivi04.cf","9cvlhwqrdivi04.ga","9cvlhwqrdivi04.gq","9cvlhwqrdivi04.ml","9cvlhwqrdivi04.tk","9daqunfzk4x0elwf5k.cf","9daqunfzk4x0elwf5k.ga","9daqunfzk4x0elwf5k.gq","9daqunfzk4x0elwf5k.ml","9daqunfzk4x0elwf5k.tk","9ebrklpoy3h.cf","9ebrklpoy3h.ga","9ebrklpoy3h.gq","9ebrklpoy3h.ml","9ebrklpoy3h.tk","9en6mail2.ga","9et1spj7br1ugxrlaa3.cf","9et1spj7br1ugxrlaa3.ga","9et1spj7br1ugxrlaa3.gq","9et1spj7br1ugxrlaa3.ml","9et1spj7br1ugxrlaa3.tk","9fdy8vi.mil.pl","9gals.com","9jw5zdja5nu.pl","9k27djbip0.cf","9k27djbip0.ga","9k27djbip0.gq","9k27djbip0.ml","9k27djbip0.tk","9kfifc2x.pl","9klsh2kz9.pl","9mail.cf","9mail9.cf","9me.site","9mot.ru","9nteria.pl","9o04xk8chf7iaspralb.cf","9o04xk8chf7iaspralb.ga","9o04xk8chf7iaspralb.gq","9o04xk8chf7iaspralb.ml","9oul.com","9ox.net","9q.ro","9q8eriqhxvep50vuh3.cf","9q8eriqhxvep50vuh3.ga","9q8eriqhxvep50vuh3.gq","9q8eriqhxvep50vuh3.ml","9q8eriqhxvep50vuh3.tk","9rok.info","9rtkerditoy.info","9rtn5qjmug.cf","9rtn5qjmug.ga","9rtn5qjmug.gq","9rtn5qjmug.ml","9rtn5qjmug.tk","9skcqddzppe4.cf","9skcqddzppe4.ga","9skcqddzppe4.gq","9skcqddzppe4.ml","9skcqddzppe4.tk","9t7xuzoxmnwhw.cf","9t7xuzoxmnwhw.ga","9t7xuzoxmnwhw.gq","9t7xuzoxmnwhw.ml","9t7xuzoxmnwhw.tk","9times.club","9toplay.com","9ufveewn5bc6kqzm.cf","9ufveewn5bc6kqzm.ga","9ufveewn5bc6kqzm.gq","9ufveewn5bc6kqzm.ml","9ufveewn5bc6kqzm.tk","9w93z8ul4e.cf","9w93z8ul4e.ga","9w93z8ul4e.gq","9w93z8ul4e.ml","9w93z8ul4e.tk","9xmail.xyz","9ya.de","9ziqmkpzz3aif.cf","9ziqmkpzz3aif.ga","9ziqmkpzz3aif.gq","9ziqmkpzz3aif.ml","9ziqmkpzz3aif.tk","9zjz7suyl.pl","emailmiser.com","putthisinyourspamdatabase.com","sendspamhere.com","spamherelots.com","spamhereplease.com","tempemail.net","a-b.co.za","a-bc.net","a-glittering-gem-is-not-enough.top","a-kinofilm.ru","a-mule.cf","a-mule.ga","a-mule.gq","a-mule.ml","a-mule.tk","a-nd.info","a-rodadmitssteroids.in","a-vot-i-ya.net","a.a.fbmail.usa.cc","a.betr.co","a.com","a.hido.tech","a.kerl.gq","a.mailcker.com","a.polosburberry.com","a.sach.ir","a.safe-mail.gq","a.uditt.cf","a.vztc.com","a.wxnw.net","a.yertxenor.tk","a0.igg.biz","a02sjv3e4e8jk4liat.cf","a02sjv3e4e8jk4liat.ga","a02sjv3e4e8jk4liat.gq","a02sjv3e4e8jk4liat.ml","a02sjv3e4e8jk4liat.tk","a0f7ukc.com","a0reklama.pl","a1.usa.cc","a1aemail.win","a1b2.cf","a1b2.gq","a1b2.ml","a2.flu.cc","a24hourpharmacy.com","a2mail.com","a2zculinary.com","a3.bigpurses.org","a333yuio.uni.cc","a3ho7tlmfjxxgy4.cf","a3ho7tlmfjxxgy4.ga","a3ho7tlmfjxxgy4.gq","a3ho7tlmfjxxgy4.ml","a3ho7tlmfjxxgy4.tk","a41odgz7jh.com","a41odgz7jh.com.com","a45.in","a458a534na4.cf","a4h4wtikqcamsg.cf","a4h4wtikqcamsg.ga","a4h4wtikqcamsg.gq","a4hk3s5ntw1fisgam.cf","a4hk3s5ntw1fisgam.ga","a4hk3s5ntw1fisgam.gq","a4hk3s5ntw1fisgam.ml","a4hk3s5ntw1fisgam.tk","a4rpeoila5ekgoux.cf","a4rpeoila5ekgoux.ga","a4rpeoila5ekgoux.gq","a4rpeoila5ekgoux.ml","a4rpeoila5ekgoux.tk","a4zerwak0d.cf","a4zerwak0d.ga","a4zerwak0d.gq","a4zerwak0d.ml","a4zerwak0d.tk","a53qgfpde.pl","a54pd15op.com","a5m9aorfccfofd.cf","a5m9aorfccfofd.ga","a5m9aorfccfofd.gq","a5m9aorfccfofd.ml","a6a.nl","a6lrssupliskva8tbrm.cf","a6lrssupliskva8tbrm.ga","a6lrssupliskva8tbrm.gq","a6lrssupliskva8tbrm.ml","a6lrssupliskva8tbrm.tk","a78tuztfsh.cf","a78tuztfsh.ga","a78tuztfsh.gq","a78tuztfsh.ml","a78tuztfsh.tk","a7996.com","a84doctor.com","a99999.ce.ms","a9jcqnufsawccmtj.cf","a9jcqnufsawccmtj.ga","a9jcqnufsawccmtj.gq","a9jcqnufsawccmtj.ml","a9jcqnufsawccmtj.tk","aa.da.mail-temp.com","aa5j3uktdeb2gknqx99.ga","aa5j3uktdeb2gknqx99.ml","aa5j3uktdeb2gknqx99.tk","aa5zy64.com","aaa117.com","aaa4.pl","aaa5.pl","aaa6.pl","aaaaa1.pl","aaaaa2.pl","aaaaa3.pl","aaaaa4.pl","aaaaa5.pl","aaaaa6.pl","aaaaa7.pl","aaaaa8.pl","aaaaa9.pl","aaaf.ru","aaathats3as.com","aaaw45e.com","aabagfdgks.net","aacxb.xyz","aad9qcuezeb2e0b.cf","aad9qcuezeb2e0b.ga","aad9qcuezeb2e0b.gq","aad9qcuezeb2e0b.ml","aad9qcuezeb2e0b.tk","aadidassoccershoes.com","aaewr.com","aafddz.ltd","aahs.co.pl","aaliyah.sydnie.livemailbox.top","aalna.org","aals.co.pl","aamail.co","aamail.com","aamanah.cf","aaphace.ml","aaphace1.ga","aaphace2.cf","aaphace3.ml","aaphace4.ga","aaphace5.cf","aaphace6.ml","aaphace7.ga","aaphace8.cf","aaphace9.ml","aaronboydarts.com","aarons-cause.org","aaronson.cf","aaronson1.onedumb.com","aaronson2.qpoe.com","aaronson3.sendsmtp.com","aaronson4.my03.com","aaronson6.authorizeddns.org","aasgashashashajh.cf","aasgashashashajh.ga","aasgashashashajh.gq","aateam.pl","aazzn.com","ab-coaster.info","ab-volvo.cf","ab-volvo.ga","ab-volvo.gq","ab-volvo.ml","ab-volvo.tk","ab0.igg.biz","ab1.pl","ababmail.ga","abacuswe.us","abakiss.com","abanksat.us","abarth.ga","abarth.gq","abarth.tk","abb.dns-cloud.net","abb.dnsabr.com","abba.co.pl","abbelt.com","abbeyrose.info","abc-payday-loans.co.uk","abc1.ch","abc2018.ru","abcda.tech","abciarum.info","abcmail.email","abcmail.men","abcnetworkingu.pl","abcpaydayloans.co.uk","abcremonty.com.pl","abcv.info","abcz.info.tm","abegegr0hl.cf","abegegr0hl.ga","abegegr0hl.gq","abegegr0hl.ml","abegegr0hl.tk","abem.info","abendkleidergunstig.net","abercrombieepascheresyffr.info","abercrombiefitch-shop.com","abercrombiefitch-store.com","abercrombiefpacherfr.com","abercrombiepascherefrance.fr","abercrombieppascher.com","abercrombiesalejp.com","aberfeldy.pl","abg.nikeshoesoutletforsale.com","abg0i9jbyd.cf","abg0i9jbyd.ga","abg0i9jbyd.gq","abg0i9jbyd.ml","abg0i9jbyd.tk","abiasa.online","abigail11halligan.ga","abigail69.sexy","abikmail.com","abilityskillup.info","abilitywe.us","abista.space","ablacja-nie-zawsze.info","ablacja-nie-zawsze.info.pl","ably.co.pl","abmr.waw.pl","abnamro.usa.cc","abogadanotariapr.com","abogados-divorcio.info","aboh913i2.pl","abonc.com","abos.co.pl","abot5fiilie.ru","abot5zagruz.ru","abot8fffile.ru","about.com-posted.org","aboutbothann.org","aboutgta.x10.mx","abovewe.us","abqenvironmentalstory.org","abqkravku4x36unnhgu9.co.cc","abri.co.pl","abrighterfutureday.com","abroadedu.ru","abscessedtoothhomeremedy.com","absensidikjari.com","absolutelyecigs.com","absolutesuccess.win","absolutewe.us","absorbenty.pl","absorbuj.pl","abstraction-is-often-one-floor-above-you.top","abstruses.com","abstruses.net","abundantwe.us","abunprodvors.xyz","abuselist.com","abusemail.de","abuser.eu","abut.co.pl","abyssemail.com","abyssmail.com","ac-nation.club","ac20mail.in","ac3d64b9a4n07.cf","ac3d64b9a4n07.ga","ac3d64b9a4n07.gq","ac3d64b9a4n07.tk","ac895.cf","ac895.ga","ac895.gq","ac895.ml","ac9fqq0qh6ucct.cf","ac9fqq0qh6ucct.ga","ac9fqq0qh6ucct.gq","ac9fqq0qh6ucct.ml","ac9fqq0qh6ucct.tk","aca5.com","academiccommunity.com","academmail.info","academywe.us","acadteh.ru","acai-berry.es","acaihelp.com","acanadianpharmacy.com","acasabianca.com","acc2t9qnrt.cf","acc2t9qnrt.ga","acc2t9qnrt.gq","acc2t9qnrt.ml","acc2t9qnrt.tk","accademiadiscanto.org","accebay.site","acceleratewe.us","accent.home.pl","accentwe.us","acceptbadcredit.ru","acceptwe.us","accesorii.info","access.com-posted.org","accesshigh.win","accesslivingllc.net","accessoriesjewelry.co.cc","accionambiente.org","acclaimwe.us","accmt-servicefundsprefer.com","accordwe.us","accountantruth.cf","accounting11-tw.org","accountingintaylor.com","accounts-login.ga","accountsadtracker.com","accreditedwe.us","accuracyis.com","accurateto.com","accurbrinue.biz","accutaneonlinesure.com","ace-mail.net","ace.ace.gy","aced.co.pl","acemail.info","acentri.com","acequickloans.co.uk","acetonic.info","acfddy.ltd","acgapp.hk","achatairjordansfrance.com","achatairjordansfrshop.com","achatjordansfrshop.com","achatz.ga","ache.co.pl","acheterairmaxs.com","achetertshirt.com","achievementwe.us","achievewe.us","achy.co.pl","acidrefluxdiseasecure.com","acike.com","acmail.com","acmeco.tk","acmilanbangilan.cf","acmimail.com","acne.co.pl","acne.com","acnebrufolirime43.eu","acnemethods.com","acnenomorereviewed.info","acnonline.com","acofmail.com","acontenle.eu","acornsbristol.com","acornwe.us","acoukr.pw","acousticlive.net","acqm38bmz5atkh3.cf","acqm38bmz5atkh3.ga","acqm38bmz5atkh3.gq","acqm38bmz5atkh3.ml","acqm38bmz5atkh3.tk","acres.asia","acrilicoemosasco.ml","acrilicosemosasco.ml","acrilworld.ml","acroexch.us","acrylicchairs.org","acrylicwe.us","acsisa.net","acta.co.pl","acting-guide.info","activatewe.us","active.au-burn.net","activitysports.ru","activitywe.us","acts.co.pl","acucre.com","acuitywe.us","acumenwe.us","acupuncturenews.org","acyl.co.pl","ad-seo.com","ada-duit.ga","ada-janda.ga","adacalabuig.com","adachiu.me","adadass.cf","adadass.ga","adadass.gq","adadass.ml","adadass.tk","adamastore.co","adamtraffic.com","adapdev.com","adapromo.com","adaptivewe.us","adaptwe.us","adashev.ru","adastars333.com","adastralflying.com","adazmail.com","adbet.co","adcloud.us","add3000.pp.ua","add6site.tk","addictingtrailers.com","additionaledu.ru","addtocurrentlist.com","adel.asia","adelaide.bike","adelaideoutsideblinds.com.au","adelinabubulina.com","adenose.info","adentaltechnician.com","adeptwe.us","aderispharm.com","adesktop.com","adfly.comx.cf","adgento.com","adgloselche.esmtp.biz","adidas-fitness.eu","adidas-porsche-design-shoes.com","adidasasoccershoes.com","adidasshoesshop.com","adidasto.com","adipex7z.com","adiq.eu","adit.co.pl","aditus.info","adjun.info","adleep.org","admail.com","administrativo.world","admiralwe.us","admmo.com","adnc7mcvmqj0qrb.cf","adnc7mcvmqj0qrb.ga","adnc7mcvmqj0qrb.gq","adnc7mcvmqj0qrb.ml","adnc7mcvmqj0qrb.tk","ado888.biz","adobeccepdm.com","adolf-hitler.cf","adolf-hitler.ga","adolf-hitler.gq","adolf-hitler.ml","adolfhitlerspeeches.com","adonisgoldenratioreviews.info","adoniswe.us","adorable.org","adpmfxh0ta29xp8.cf","adpmfxh0ta29xp8.ga","adpmfxh0ta29xp8.gq","adpmfxh0ta29xp8.ml","adpmfxh0ta29xp8.tk","adprojnante.xyz","adpromot.net","adpugh.org","adrespocztowy.pl","adresseemailtemporaire.com","adrianneblackvideo.com","adrianou.gq","adrinks.ru","adrmwn.me","adroit.asia","adsd.org","adstreet.es","adtemps.org","adubandar.com","adubiz.info","adukmail.com","adulktrsvp.com","adult-db.net","adult-free.info","adultcamzlive.com","adultchat67.uni.cc","adultesex.net","adultfacebookinfo.info","adultmagsfinder.info","adulttoy20117.co.tv","adulttoys.com","adultvidlite.com","aduski.info","advancedwebstrategiesinc.com","advantagesofsocialnetworking.com","advantagewe.us","advantimal.com","advantimals.com","advantimo.com","advdesignss.info","adventurewe.us","adventwe.us","adverstudio.com","advertforyou.info","advertiseall.com","advertisingmarketingfuture.info","advextreme.com","advisorwe.us","adviva-odsz.com","advocatewe.us","advorta.com","adwaterandstir.com","adwordsopus.com","adx-telecom.com","adze.co.pl","adzillastudio.com","ae-mail.pl","ae.pureskn.com","aeacides.info","aeai.com","aebfish.com","aed5lzkevb.cf","aed5lzkevb.ga","aed5lzkevb.gq","aed5lzkevb.ml","aed5lzkevb.tk","aegde.com","aegia.net","aegis-conference.eu","aegiscorp.net","aegiswe.us","aegoneinsurance.cf","aelo.es","aenterprise.ru","aeon.tk","aeonpsi.com","aeorierewrewt.co.tv","aerectiledysfunction.com","aero-files.net","aero.ilawa.pl","aero1.co.tv","aero2.co.tv","aerobicaerobic.info","aerochart.co.uk","aeroponics.edu","aeroport78.co.tv","aeroshack.com","aerteur73.co.tv","aertewurtiorie.co.cc","aesamedayloans.co.uk","aesopsfables.net","aestrony6.com","aestyria.com","aetorieutur.tk","aev333.cz.cc","aewh.info","aewituerit893.co.cc","aewn.info","aewutyrweot.co.tv","aewy.info","aexa.info","aexd.info","aexf.info","aexg.info","aexk.ru","aexw.info","aexy.info","aeyq.info","aeze0qhwergah70.cf","aeze0qhwergah70.ga","aeze0qhwergah70.gq","aeze0qhwergah70.ml","aeze0qhwergah70.tk","aezl.info","af2przusu74mjzlkzuk.cf","af2przusu74mjzlkzuk.ga","af2przusu74mjzlkzuk.gq","af2przusu74mjzlkzuk.ml","af2przusu74mjzlkzuk.tk","afaracuspurcatiidintara.com","afat1loaadz.ru","afat2fiilie.ru","afat3sagruz.ru","afat9faiili.ru","afatt3fiilie.ru","afatt7faiili.ru","afcgroup40.com","aff-marketing-company.info","affgrinder.com","affilialogy.com","affiliate-marketing2012.com","affiliate-nebenjob.info","affiliatedwe.us","affiliateseeking.biz","affiliatesonline.info","affiliatez.net","affilikingz.de","affinitywe.us","affluentwe.us","affordablescrapbook.com","affordablevoiceguy.com","affordablewe.us","affricca.com","afganbaba.com","afisha.biz.ua","afishaonline.info","afmail.com","afopmail.com","aforyzmy.biz","afr564646emails.com","afre676007mails.com","afre67677mails.com","afremails.com","africanamerican-hairstyles.org","africanmangoactives.com","afriendship.ru","afro.com-posted.org","afrobacon.com","afteir.com","aftereight.pl","afterhourswe.us","afterpeg.com","afterthediagnosisthebook.com","aftnfeyuwtzm.cf","aftnfeyuwtzm.ga","aftnfeyuwtzm.gq","aftnfeyuwtzm.ml","aftnfeyuwtzm.tk","aftttrwwza.com","afunthingtodo.com","ag.us.to","ag02dnk.slask.pl","ag163.top","ag95.cf","ag95.ga","ag95.gq","ag95.ml","ag95.tk","agagmail.com","agamail.com","agapetus.info","agar.co.pl","agartstudio.com.pl","agdrtv.com","agedlist.com","agedmail.com","agenbola.com","agenbola9.com","agencabo.com","agencjaatrakcji.pl","agencjainteraktywna.com","agencjareklamowanestor.pl","agendawe.us","agendka.mielno.pl","agentogelasia.com","agentshipping.com","agentsosmed.com","agenzieinvestigativetorino.it","agfdgks.com","agger.ro","agget5fiilie.ru","agget6fiilie.ru","agget6loaadz.ru","agha.co.pl","agibdd.ru","agilewe.us","agilityforeigntrade.com","agistore.co","aglobetony.pl","agma.co.pl","agmail.com","agnxbhpzizxgt1vp.cf","agnxbhpzizxgt1vp.ga","agnxbhpzizxgt1vp.gq","agnxbhpzizxgt1vp.ml","agnxbhpzizxgt1vp.tk","agoda.lk","agorawe.us","agpforum.com","agramas.cf","agramas.ml","agreeone.ga","agri.agriturismopavi.it","agri.com-posted.org","agriokss.com","agristyleapparel.us","agrofort.com","agrolaw.ru","agrostor.com","agtx.net","aguablancasbr.com","aguamail.com","aguamexico.com.mx","aguardhome.com","aguarios1000.com.mx","aguastinacos.com","ague.co.pl","agustaa.top","agustusmp3.xyz","agwbyfaaskcq.cf","agwbyfaaskcq.ga","agwbyfaaskcq.gq","agwbyfaaskcq.ml","agwbyfaaskcq.tk","agxazvn.pl","agxngcxklmahntob.cf","agxngcxklmahntob.ga","agxngcxklmahntob.gq","agxngcxklmahntob.ml","agxngcxklmahntob.tk","ahaappy0faiili.ru","ahajusthere.com","ahappycfffile.ru","ahcsolicitors.co.uk","aheadwe.us","ahem.email","ahgae-crews.us.to","ahhmail.info","ahhos.com","ahk.jp","ahketevfn4zx4zwka.cf","ahketevfn4zx4zwka.ga","ahketevfn4zx4zwka.gq","ahketevfn4zx4zwka.ml","ahketevfn4zx4zwka.tk","ahmadidik.cf","ahmadidik.ga","ahmadidik.gq","ahmadidik.ml","ahoj.co.uk","ahojmail.pl","ahomework.ru","ahopmail.com","ahoxavccj.pl","ahrr59qtdff98asg5k.cf","ahrr59qtdff98asg5k.ga","ahrr59qtdff98asg5k.gq","ahrr59qtdff98asg5k.ml","ahrr59qtdff98asg5k.tk","ahsozph.tm.pl","ahtubabar.ru","ahyars.site","ai.aax.cloudns.asia","ai.hsfz.info","ai.vcss.eu.org","ai4trade.info","ai6188.com","aide.co.pl","aiduisoi3456ta.tk","aifmhymvug7n4.ga","aifmhymvug7n4.gq","aifmhymvug7n4.ml","aifmhymvug7n4.tk","aiiots.net","ailme.pw","aimboss.ru","aims.co.pl","ains.co.pl","aiot.aiphone.eu.org","aiot.creo.site","aiot.creou.dev","aiot.dmtc.dev","aiot.ptcu.dev","aiot.vuforia.us","aiot.ze.cx","aipmail.ga","aipuma.com","air-blog.com","air-bubble.bedzin.pl","air-maxshoesonline.com","air2token.com","aircapitol.net","aircargomax.us","aircolehaan.com","airconditionermaxsale.us","airfiltersmax.us","airforceonebuy.net","airforceonesbuy.com","airideas.us","airj0ranpascher.com","airj0ranpascher2.com","airjodanpasfranceshoes.com","airjodansshoespascherefr.com","airjoranpasachere.com","airjordan-france-1.com","airjordanacheter.com","airjordanafrance.com","airjordanapascher.com","airjordanapascherfrance.com","airjordanaustraliasale.com","airjordancchaussure.com","airjordaneenlignefr.com","airjordanffemme.com","airjordanfranceeee.com","airjordannpascherr.com","airjordannsoldes.com","airjordanochaussure.com","airjordanoutletcenter.us","airjordanoutletclub.us","airjordanoutletdesign.us","airjordanoutletgroup.us","airjordanoutlethomes.us","airjordanoutletinc.us","airjordanoutletmall.us","airjordanoutletonline.us","airjordanoutletshop.us","airjordanoutletsite.us","airjordanoutletstore.us","airjordanoutletusa.us","airjordanoutletwork.us","airjordanpaschefr.com","airjordanpascher1.com","airjordanpaschereshoes.com","airjordanpascherjordana.com","airjordanpaschermagasinn.com","airjordanpascherrfr.com","airjordanpascherrr.com","airjordanpascherrssoldes.com","airjordanpaschersfr.com","airjordanpaschersoldesjordanfr.com","airjordanpasschemagasin.com","airjordanpasscher.com","airjordanretro2013.org","airjordanscollection.com","airjordanshoesfrfrancepascher.com","airjordansofficiellefrshop.com","airjordanspascher1.com","airjordansshoes2014.com","airjordansstocker.com","airknox.com","airmail.cc","airmail.tech","airmailhub.com","airmax-sale2013club.us","airmax1s.com","airmaxdesignusa.us","airmaxgroupusa.us","airmaxhomessale2013.us","airmaxnlinesaleinc.us","airmaxonlineoutlet.us","airmaxonlinesaleinc.us","airmaxpower.us","airmaxprooutlet2013.us","airmaxrealtythesale.us","airmaxsaleonlineblog.us","airmaxschuhev.com","airmaxsde.com","airmaxshoessite.com","airmaxshopnike.us","airmaxslocker.com","airmaxsmart.com","airmaxsneaker.us","airmaxspascherfrance.com","airmaxsproshop.com","airmaxsstocker.com","airmaxstoresale2013.us","airmaxstyles.com","airmaxtn1-90paschers.com","airmaxtnmagasin.com","airmaxukproshop.com","airn.co.pl","airold.net","airparkmax.us","airplay.elk.pl","airpriority.com","airpurifiermax.us","airriveroutlet.us","airshowmax.us","airsi.de","airsoftshooters.com","airsport.top","airtravelmaxblog.us","airturbine.pl","airuc.com","airwayy.us","airxr.ru","aisaelectronics.com","aistis.xyz","aiv.pl","aivtxkvmzl29cm4gr.cf","aivtxkvmzl29cm4gr.ga","aivtxkvmzl29cm4gr.gq","aivtxkvmzl29cm4gr.ml","aivtxkvmzl29cm4gr.tk","aizennsasuke.cf","aizennsasuke.ga","aizennsasuke.gq","aizennsasuke.ml","aizennsasuke.tk","ajarnow.com","ajaxapp.net","ajbsoftware.com","ajeroportvakansii20126.co.tv","aji.kr","ajiagustian.com","ajjdf.com","ajmail.com","ajobabroad.ru","ajobfind.ru","ajoxmail.com","ajpapa.net","ajrf.in","ajruqjxdj.pl","aju.onlysext.com","aka2.pl","akademiyauspexa.xyz","akainventorysystem.com","akamaized.cf","akamaized.ga","akamaized.gq","akamarkharris.com","akapost.com","akash9.gq","akazq33.cn","akb007.com","akbqvkffqefksf.cf","akbqvkffqefksf.ga","akbqvkffqefksf.gq","akbqvkffqefksf.ml","akbqvkffqefksf.tk","akcesoria-dolazienki.pl","akcesoria-telefoniczne.pl","akee.co.pl","akerd.com","akfioixtf.pl","akgq701.com","akhmadi.cf","akhost.trade","akinesis.info","akiol555.vv.cc","akiowrertutrrewa.co.tv","akjewelery-kr.info","akkecuwa.ga","aklqo.com","akmail.com","akmaila.org","akmandken.tk","akorde.al","akryn4rbbm8v.cf","akryn4rbbm8v.ga","akryn4rbbm8v.gq","akryn4rbbm8v.tk","aksarat.eu","aksearches.com","aksesorisa.com","aktiefmail.nl","akula012.vv.cc","akumulatorysamochodowe.com","akumulatoryszczecin.top","akunamatata.site","akusayyangkamusangat.ga","akusayyangkamusangat.ml","akusayyangkamusangat.tk","akustyka2012.pl","akutamvan.com","akuudahlelah.com","akvaristlerdunyasi.com","akxugua0hbednc.cf","akxugua0hbednc.ga","akxugua0hbednc.gq","akxugua0hbednc.ml","akxugua0hbednc.tk","akzwayynl.pl","al-qaeda.us","alabama-get.loan","alabama-nedv.ru","alabapestenoi.com","alainazaisvoyance.com","alaki.ga","alannahtriggs.ga","alanwilliams2008.com","alapage.ru","alarmydoowectv.com","alaska-nedv.ru","albamail.ga","alban-nedv.ru","albayan-magazine.net","albionwe.us","alchemywe.us","alcohol-rehab-costs.com","alcoholicsanonymoushotline.com","alcyonoid.info","aldemimea.xyz","aldeyaa.ae","ale35anner.ga","aleagustina724.cf","aleaisyah710.ml","aleamanda606.cf","aleanna704.cf","aleanwisa439.cf","alebutar-butar369.cf","alec.co.pl","aledestrya671.tk","aledrioroots.youdontcare.com","alee.co.pl","aleelma686.ml","aleepapalae.gq","alefachria854.ml","alefika98.ga","alegrabrasil.com","alegracia623.cf","aleherlin351.tk","alekikhmah967.tk","alemalakra.com","alemaureen164.ga","alemeutia520.cf","alenina729.tk","aleno.com","alenoor903.tk","alenovita373.tk","aleomailo.com","aleqodriyah730.ga","alesapto153.ga","aleshiami275.ml","alessi9093.co.cc","alessia1818.site","alesulalah854.tk","aletasya616.ml","alexa-ranks.com","alexadomain.info","alexbox.online","alexbrowne.info","alexdrivers00.ru","alexdrivers2013.ru","alexecristina.com","alexpeattie.com","alfa-romeo.cf","alfa-romeo.ga","alfa-romeo.gq","alfa-romeo.ml","alfa.papa.wollomail.top","alfa.tricks.pw","alfamailr.org","alfaomega24.ru","alfaromeo.igg.biz","alfaromeo147.cf","alfaromeo147.gq","alfaromeo147.ml","alfaromeo147.tk","alfasigma.spithamail.top","alga.co.pl","algeria-nedv.ru","algicidal.info","aliases.tk","aliasnetworks.info","aliaswe.us","alibabor.com","alibirelax.ru","aliblue.top","alic.info","alicemchard.com","alidioa.tk","aliefeince.com","alienware13.com","aliex.co","alif.co.pl","alifestyle.ru","aligamel.com","aligreen.top","alihkan.com","alimail.bid","alimunjaya.xyz","alioka759.vv.cc","aliorbaank.pl","alired.top","alisoftued.com","alisongamel.com","alistantravellinert.com","alittle.website","alivance.com","alivewe.us","aliwegwpvd.ga","aliwegwpvd.gq","aliwegwpvd.ml","aliwegwpvd.tk","aliwhite.top","alizof.com","alkoholeupominki.pl","alky.co.pl","all-about-cars.co.tv","all-about-health-and-wellness.com","all-cats.ru","all-knowledge.ru","all-mail.net","all4mail.cn.pn","all4me.info","all4oneseo.com","allaboutebay2012.com","allaboutemarketing.info","allaboutlabyrinths.com","allaccesswe.us","alladyn.unixstorm.org","allairjordanoutlet.us","allairmaxsaleoutlet.us","allamericanmiss.com","allamericanwe.us","allanimal.ru","allapparel.biz","allaroundwe.us","allbest-games.ru","allchristianlouboutinshoesusa.us","allclown.com","alldavirdaresinithesjy.com","alldelhiescort.com","alldirectbuy.com","allegiancewe.us","allegro.rzemien.d2.pl","allegrowe.us","allemailyou.com","allemaling.com","allen.nom.za","allenrothclosetorganizer.com","allerguxfpoq.com","allergypeanut.com","allesgutezumgeburtstag.info","allfactory.com","allfamus.com","allgaiermogensen.com","allgamemods.name","allgoodwe.us","alliancewe.us","allinonewe.us","alliscasual.org.ua","allmarkshare.info","allmmogames.com","allmp3stars.com","allofthem.net","alloggia.de","alloutwe.us","allowed.org","alloywe.us","allpaydayloans.info","allpickuplines.info","allprowe.us","allroundawesome.com","allroundnews.com","allseasonswe.us","allsoftreviews.com","allstarwe.us","allsuperinfo.com","alltempmail.com","allthegoodnamesaretaken.org","allthetimeyoudisappear.com","allthingswoodworking.com","alltopmail.com","alltopmovies.biz","alltrozmail.club","allukschools.com","allurewe.us","allute.com","ally.co.pl","allyourcheats.com","almail.com","almajedy.com","alme.co.pl","almondwe.us","almubaroktigaraksa.com","alohaziom.pl","aloimail.com","alonetry.com","alonzo1121.club","alormbf88nd.cf","alormbf88nd.ga","alormbf88nd.gq","alormbf88nd.ml","alormbf88nd.tk","alovobasweer.co.tv","alph.wtf","alpha-web.net","alpha.uniform.livemailbox.top","alphaconquista.com","alphafrau.de","alphaomegawe.us","alphaphalpha74.com","alphaupsilon.thefreemail.top","alphonsebathrick.com","alpinewe.us","alqy5wctzmjjzbeeb7s.cf","alqy5wctzmjjzbeeb7s.ga","alqy5wctzmjjzbeeb7s.gq","alqy5wctzmjjzbeeb7s.ml","alqy5wctzmjjzbeeb7s.tk","alsfw5.bee.pl","alsheim.no-ip.org","altairwe.us","altdesign.info","alternavox.net","altitudewe.us","altmails.com","altrmed.ru","altuswe.us","altwow.ru","alufelgenprs.de","alumix.cf","alumni.com","alumnimp3.xyz","alunord.com","alunord.pl","alwernia.co.pl","alykpa.biz.st","alyssa.allie.wollomail.top","am2g.com","ama-trade.de","ama-trans.de","amadamus.com","amadeuswe.us","amail.club","amail.com","amail.gq","amail.men","amail3.com","amail4.me","amaill.ml","amantapkun.com","amatblog.eu","amateur69.info","amateurspot.net","amatriceporno.eu","amav.ro","amazingbagsuk.info","amazingchristmasgiftideas.com","amazinghandbagsoutlet.info","amazingrem.uni.me","amazingself.net","amazon-aws.org","amazon.coms.hk","ambassadorwe.us","amberofoka.org","amberwe.us","ambiancewe.us","ambitiouswe.us","amdxgybwyy.pl","amelabs.com","ameraldmail.com","america-sp.com.br","american-image.com","americanawe.us","americanwindowsglassrepair.com","americasbestwe.us","americasmorningnews.mobi","americaswe.us","amex-online.ga","amex-online.gq","amex-online.ml","amex-online.tk","ameyprice.com","amhar.asia","amharem.katowice.pl","amharow.cieszyn.pl","amicuswe.us","amid.co.pl","amiga-life.ru","amigowe.us","amiksingh.com","amilegit.com","amimail.com","amin.co.pl","aminois.ga","aminoprimereview.info","aminudin.me","amiri.net","amiriindustries.com","amitywe.us","ammazzatempo.com","amokqidwvb630.ga","amoksystems.com","amovies.in","amoxilonlineatonce.com","ampicillinpills.net","amplewe.us","amplifiedwe.us","amplifywe.us","ampoules-economie-energie.fr","amprb.com","ampsylike.com","amsalebridesmaid.com","amseller.ru","amsgkmzvhc6.cf","amsgkmzvhc6.ga","amsgkmzvhc6.gq","amsgkmzvhc6.tk","amsspecialist.com","amt3security.com","amthuc24.net","amthucvn.net","amule.cf","amule.ga","amule.gq","amule.ml","amymary.us","amyotonic.info","amysink.com","amyxrolest.com","an-uong.net","an.id.au","anacronym.info","anafentos.com","anakjalanan.ga","anakjembutad.cf","anakjembutad.ga","anakjembutad.gq","anakjembutad.ml","anakjembutad.tk","anal.accesscam.org","anal.com","analenfo111.eu","analogekameras.com","analogwe.us","analysan.ru","analysiswe.us","analyticalwe.us","analyticswe.us","analyticwe.us","anansou.com","anaploxo.cf","anaploxo.ga","anaploxo.gq","anaploxo.ml","anaploxo.tk","anappfor.com","anappthat.com","anaptanium.com","anayikt.cf","anayikt.ga","anayikt.gq","anayikt.ml","anchrisbaton.acmetoy.com","ancientart.co","and.celebrities-duels.com","andetne.win","andhani.ml","andorra-nedv.ru","andreagilardi.me","andreams.ru","andreay.codes","andreihusanu.ro","android-quartet.com","androidinstagram.org","androidmobile.mobi","androidsapps.co","androidworld.tw","andthen.us","andy1mail.host","andynugraha.net","andyyxc45.biz","aneaproducciones.com","anemiom.kobierzyce.pl","aneuch.info","anew-news.ru","angelabacks.com","angelicablog.com","angesti.tech","angielski.edu","angielskie.synonimy.com","angioblast.info","angola-nedv.ru","angoplengop.cf","angrybirdsforpc.info","angularcheilitisguide.info","anhthu.org","anibym.gniezno.pl","animalads.co.uk","animalextract.com","animalright21.com","animalsneakers.com","animation-studios.com","animatorzywarszawa.pl","animesos.com","anit.ro","anitadarkvideos.net","aniub.com","anjing.cool","anjingkokditolak.cf","anjingkokditolak.ga","anjingkokditolak.gq","anjingkokditolak.ml","anjingkokditolak.tk","ankankan.com","ankoninc.pw","anmail.com","ann.jackeline.101livemail.top","anna-tut.ru","annabless.co.cc","annafathir.cf","annalusi.cf","annamike.org","annanakal.ga","annapayday.net","annarahimah.ml","annasblog.info","annazahra.cf","anneholdenlcsw.com","anniversarygiftideasnow.com","anno90.nl","ano-mail.net","anomail.com","anomail.us","anon-mail.de","anon.leemail.me","anonbox.net","anonemailbox.com","anonimous-email.bid","anonimousemail.bid","anonimousemail.trade","anonimousemail.win","anonmail.top","anonmail.xyz","anonmails.de","anonymail.dk","anonymbox.com","anonymize.com","anonymized.org","anonymous-email.net","anonymousfeedback.net","anonymousmail.org","anonymousness.com","anonymousspeech.com","anonymstermail.com","another-1drivvers.ru","anotherblast2013.com","anotherdomaincyka.tk","anpolitics.ru","ansaldo.cf","ansaldo.ga","ansaldo.gq","ansaldo.ml","ansaldobreda.cf","ansaldobreda.ga","ansaldobreda.gq","ansaldobreda.ml","ansaldobreda.tk","ansbanks.ru","anschool.ru","anselme.edu","ansgjypcd.pl","ansibleemail.com","anstravel.ru","answerauto.ru","answersfortrivia.ml","answersworld.ru","antalyaescortkizlar.com","antegame.com","anthagine.cf","anthagine.ga","anthagine.gq","anthagine.ml","antherdihen.eu","anthony-junkmail.com","anthropologycommunity.com","anti-ronflement.info","antiageingsecrets.net","antiagingserumreview.net","antibioticgeneric.com","antichef.com","antichef.net","antichef.org","antigua-nedv.ru","antiguabars.com","antimalware360.co.uk","antiquerestorationwork.com","antiquestores.us","antireg.com","antireg.ru","antisnoringdevicesupdate.com","antispam.de","antispam24.de","antispammail.de","antistream.cf","antistream.ga","antistream.gq","antistream.ml","antistream.tk","antiviruswiz.com","antonietta1818.site","antonveneta.cf","antonveneta.ga","antonveneta.gq","antonveneta.ml","antonveneta.tk","antykoncepcjabytom.pl","antylichwa.pl","antywirusyonline.pl","anuan.tk","anultrasoundtechnician.com","anunciacos.net","anuong24h.info","anuong360.com","anuonghanoi.net","anut7gcs.atm.pl","anwintersport.ru","anxietydisorders.biz","anxietyeliminators.com","anxietymeter.com","anxmalls.com","any-gsm-network.top","anyalias.com","anyett.com","anypen.accountant","anytimejob.ru","anywhere.pw","ao4ffqty.com","aoalelgl64shf.ga","aocdoha.com","aoeiualk36g.ml","aoeuhtns.com","aol.edu","aolimail.com","aolinemail.cf","aolinemail.ga","aoll.com","aolmail.pw","aolo.com","aoltimewarner.cf","aoltimewarner.ga","aoltimewarner.gq","aoltimewarner.ml","aoltimewarner.tk","aomejl.pl","aomvnab.pl","aonbola.biz","aonbola.club","aonbola.org","aonbola.store","aopconsultants.com","apagitu.chickenkiller.com","apakahandasiap.com","apalo.tk","apaymail.com","apcleaningjservice.org","apcm29te8vgxwrcqq.cf","apcm29te8vgxwrcqq.ga","apcm29te8vgxwrcqq.gq","apcm29te8vgxwrcqq.ml","apcm29te8vgxwrcqq.tk","apebkxcqxbtk.cf","apebkxcqxbtk.ga","apebkxcqxbtk.gq","apebkxcqxbtk.ml","apemail.com","apfelkorps.de","aphlog.com","apimail.com","apkmd.com","aplikacje.com","apocztaz.com.pl","apoimail.com","apoimail.net","apotekerid.com","apown.com","apoyrwyr.gq","apozemail.com","app-expert.com","app-inc-vol.ml","app-lex-acc.com","app-mailer.com","appbotbsxddf.com","appc.se","appdev.science","appdollars.com","appfund.biz","appinventor.nl","appixie.com","appl3.cf","appl3.ga","appl3.gq","appl3.ml","appl3.tk","apple-account.app","apple.dnsabr.com","appleaccount.app","appledress.net","applphone.ru","apply4more.com","applynow0.com","applytome.com","appmail.top","appmail24.com","appmaillist.com","appmobile-documentneedtoupload.com","appnowl.ml","apprendrelepiano.com","approve-thankgenerous.com","apps.dj","apptalker.com","apptip.net","apqw.info","apranakikitoto.pw","aprice.co","apriles.ru","aprinta.com","aproangler.com","aprosti.ru","aprutana.ru","apssdc.ml","aptcha.com","apteka-medyczna.waw.pl","aptel.org","aputmail.com","apuymail.com","aqazstnvw1v.cf","aqazstnvw1v.ga","aqazstnvw1v.gq","aqazstnvw1v.ml","aqazstnvw1v.tk","aqgi0vyb98izymp.cf","aqgi0vyb98izymp.ga","aqgi0vyb98izymp.gq","aqgi0vyb98izymp.ml","aqgi0vyb98izymp.tk","aqomail.com","aquarians.co.uk","aquashieldroofingcorporate.com","ar.a2gl.in","ar.szcdn.pl","ar0dc0qrkla.cf","ar0dc0qrkla.ga","ar0dc0qrkla.gq","ar0dc0qrkla.ml","ar0dc0qrkla.tk","ar6j5llqj.pl","arabdemocracy.info","arak.ml","arakcarpet.ir","aramamotor.net","arcadespecialist.com","arcelormittal-construction.pl","archeage-gold.co.uk","archeage-gold.de","archeage-gold.us","archeagegoldshop.com","archex.pl","architektwarszawaa.pl","arcticside.com","ardavin.ir","arduino.hk","area-thinking.de","aremania.cf","aremanita.cf","arenda-s-vykupom.info","aresanob.cf","aresanob.ga","aresanob.gq","aresanob.ml","aresanob.tk","aresting.com","areyouthere.org","arfamed.com","argand.nl","argentin-nedv.ru","arhx1qkhnsirq.cf","arhx1qkhnsirq.ga","arhx1qkhnsirq.gq","arhx1qkhnsirq.ml","arhx1qkhnsirq.tk","ariana.keeley.wollomail.top","ariasexy.tk","ariaz.jetzt","aribeth.ru","aridasarip.ru","arimlog.co.uk","aristino.co.uk","ariston.ml","arizona-nedv.ru","arizonablogging.com","arkanzas-nedv.ru","arkonnide.cf","arkotronic.pl","armail.com","armail.in","armandwii.me","armatny.augustow.pl","armiasrodek.pl","armind.com","army.gov","armyan-nedv.ru","armylaw.ru","armyspy.com","arno.fi","arnoldohollingermail.org","aro.stargard.pl","arockee.com","aromat-best.ru","aron.us","arormail.com","arowmail.com","arristm502g.com","arroisijewellery.com","art-en-ligne.pro","artaho.net","artan.fr","artbellrules.info","artdrip.com","artemmel.info","arteol.pl","artgmilos.de","articlearistrocat.info","articlebase.net","articlebigshot.info","articlechief.info","articlejaw.com","articlemagnate.info","articlemogul.info","articlenag.com","articlenewsflasher.com","articlerose.com","articles4women.com","articlesearchenginemarketing.com","articleslive191.com","articleswebsite.net","articletarget.com","articlewicked.com","articlewritingguidelines.info","artificialintelligenceseo.com","artisanbooth.com","artlover.shop","artman-conception.com","artmix.net.pl","artmweb.pl","artofhypnosis.net","artquery.info","arttica.com","arturremonty.pl","artwitra.pl","artykuly-na-temat.pl","aruanimeporni20104.cz.cc","aruguy20103.co.tv","arumail.com","aruqmail.com","arur01.tk","arurgitu.gq","arurimport.ml","arvato-community.de","arybebekganteng.cf","arybebekganteng.ga","arybebekganteng.gq","arybebekganteng.ml","arybebekganteng.tk","arylabs.co","arypro.tk","arysc.ooo","as.onlysext.com","asa-dea.com","asahi.cf","asahi.ga","asana.biz","asapbox.com","asas1.co.tv","asb-mail.info","asbestoslawyersguide.com","ascendventures.cf","aschenbrandt.net","ascotairporlinks.co.uk","ascotairporltinks.co.uk","ascotairportlinks.co.uk","ascotchauffeurs.co.uk","asculpture.ru","asd323.com","asd654.uboxi.com","asdadw.com","asdasd.co","asdasd.nl","asdasd.ru","asdasd1231.info","asdasdd.com","asdasdfds.com","asdasdweqee.com","asdawqa.com","asddddmail.org","asdeqwqborex.com","asdewqrf.com","asdf.pl","asdfasd.co","asdfasdf.co","asdfasdfmail.com","asdfasdfmail.net","asdfghmail.com","asdfmail.net","asdfmailk.com","asdfooff.org","asdfsdf.co","asdfsdfjrmail.com","asdfsdfjrmail.net","asdhgsad.com","asdjioj31223.info","asdjjrmaikl.com","asdjmail.org","asdkwasasasaa.ce.ms","asdogksd.com","asdooeemail.com","asdooeemail.net","asdqwee213.info","asdqwevfsd.com","asdrxzaa.com","asdsd.co","asdversd.com","asdvewq.com","aseewr1tryhtu.co.cc","aseq.com","aserookadion.uni.cc","aserrpp.com","asertol1.co.tv","ases.info","asewrggerrra.ce.ms","aseyreirtiruyewire.co.tv","asfdasd.com","asfedass.uni.me","asgaccse-pt.cf","asgaccse-pt.ga","asgaccse-pt.gq","asgaccse-pt.ml","asgaccse-pt.tk","asgardia-space.tk","asgasgasgasggasg.ga","asgasgasgasggasg.ml","asgasghashashas.cf","asgasghashashas.ga","asgasghashashas.gq","asgasghashashas.ml","asghashasdhasjhashag.ml","ashik2in.com","ashishsingla.com","ashleyandrew.com","ashotmail.com","asi72.ru","asia-pasifikacces.com","asiahot.jp","asian-handicap.org.uk","asianeggdonor.info","asianflushtips.info","asiangangsta.site","asiapmail.club","asiarap.usa.cc","asics.com","asicshoesmall.com","asicsonshop.org","asicsrunningsale.com","asicsshoes.com","asicsshoes005.com","asicsshoesforsale.com","asicsshoeskutu.com","asicsshoesonsale.com","asicsshoessale.com","asicsshoessite.net","asicsshoesworld.com","asifboot.com","asik2in.biz","asik2in.com","asiki2in.com","asikmainbola.com","asikmainbola.org","ask-bo.co.uk","ask-mail.com","ask-zuraya.com.au","askandhire700.info","askddoor.org","askot.org","askpirate.com","asl13.cf","asl13.ga","asl13.gq","asl13.ml","asl13.tk","asls.ml","asm.snapwet.com","asmail.com","asmailproject.info","asmailz1.pl","asmwebsitesi.info","asnieceila.xyz","asoes.tk","asokevli.xyz","asooemail.com","asooemail.net","asopenhrs.com","asorent.com","asouses.ru","asperorotutmail.com","asportsa.ru","aspotgmail.org","ass.pp.ua","assomail.com","asspoo.com","assuranceprops.fun","assurancespourmoi.eu","astaghfirulloh.cf","astaghfirulloh.ga","astaghfirulloh.gq","astaghfirulloh.ml","astanca.pl","asterhostingg.com","astermebel.com.pl","astheiss.gr","astonut.cf","astonut.ga","astonut.ml","astonut.tk","astonvpshostelx.com","astoredu.com","astralcars.com","astramail.ml","astrevoyance.com","astrkkd.org.ua","astroempires.info","astrology.host","astropharm.com","astropink.com","astrowave.ru","astxixi.com","asu.mx","asu.su","asub1.bace.wroclaw.pl","aswatna-eg.net","aswertyuifwe.cz.cc","at.hm","at0mik.org","atar-dinami.com","atech5.com","atemail.com","ateng.ml","atengtom.cf","atenk99.ml","atfshminm.pl","athens5.com","athleticsupplement.xyz","athomewealth.net","atinvestment.pl","atisecuritysystems.us","atka.info","atlantafalconsproteamshop.com","atlantaweb-design.com","atlanticyu.com","atm-mi.cf","atm-mi.ga","atm-mi.gq","atm-mi.ml","atm-mi.tk","atmospheremaxhomes.us","atnextmail.com","atoyot.cf","atoyot.ga","atoyot.gq","atoyot.ml","atoyot.tk","atozbangladesh.com","atozcashsystem.net","atozconference.com","atrais-kredits24.com","atrakcje-nestor.pl","atrakcjedladziecii.pl","atrakcjenaimprezki.pl","atrakcjenawesele.pl","atrakcyjneimprezki.pl","atrezje.radom.pl","atriushealth.info","att-warner.cf","att-warner.ga","att-warner.gq","att-warner.ml","att-warner.tk","attack11.com","attake0fffile.ru","attnetwork.com","attractionmarketing.net.nz","atuyutyruti.ce.ms","atvclub.msk.ru","atwankbe3wcnngp.ga","atwankbe3wcnngp.ml","atwankbe3wcnngp.tk","atwellpublishing.com","aubootfans.co.uk","aubootfans.com","aubootsoutlet.co.uk","auchandirekt.pl","audi-r8.cf","audi-r8.ga","audi-r8.gq","audi-r8.ml","audi-r8.tk","audi-tt.cf","audi-tt.ga","audi-tt.gq","audi-tt.ml","audi-tt.tk","audi.igg.biz","audiobookmonster.com","audiobrush.com","audioequipmentstores.info","audioswitch.info","audrey11reveley.ga","audytwfirmie.pl","auelite.ru","auey1wtgcnucwr.cf","auey1wtgcnucwr.ga","auey1wtgcnucwr.gq","auey1wtgcnucwr.ml","auey1wtgcnucwr.tk","augmentationtechnology.com","auguridibuonapasqua.info","auguryans.ru","augustone.ru","aumentarpenis.net","aumento-de-mama.es","auoi53la.ga","auoie.com","auolethtgsra.uni.cc","auon.org","auralfix.com","aus.schwarzmail.ga","ausgefallen.info","austimail.com","australiaasicsgel.com","australianmail.gdn","australiasunglassesonline.net","autaogloszenia.pl","authentic-guccipurses.com","authenticchanelsbags.com","authenticsportsshop.com","authorizedoffr.com","auti.st","autisminfo.com","autisticsociety.info","autlook.com","autlook.es","autluok.com","auto-consilidation-settlements.com","auto-correlator.biz","auto-glass-houston.com","auto-lab.com.pl","auto-mobille.com","auto-zapchast.info","autoairjordanoutlet.us","autobodyspecials.com","autobroker.tv","autocoverage.ru","autognz.com","autogradka.pl","autograph34.ru","autohotline.us","autoimmunedisorderblog.info","autoknowledge.ru","autolicious.info","autoloan.org","autoloans.org","autoloans.us","autoloansonline.us","automaticforextrader.info","automobilerugs.com","automotivesort.com","autoodzaraz.com.pl","autoodzaraz.pl","autoonlineairmax.us","autoplusinsurance.world","autorobotica.com","autosdis.ru","autoshake.ru","autosouvenir39.ru","autotest.ml","autotwollow.com","autowb.com","autozestanow.pl","auxifyboosting.ga","av.jp","availablemail.igg.biz","avanafilprime.com","avaphpnet.com","avaphpnet.net","avast.ml","avasts.net","avcc.tk","avengersfanboygirlongirl.com","avenuesilver.com","aver.com","averdov.com","avery.jocelyn.thefreemail.top","avganrmkfd.pl","avia-sex.com","avia-tonic.fr","aviani.com","aviatorrayban.com","avikd.tk","avinsurance2018.top","avio.cf","avio.ga","avio.gq","avio.ml","avioaero.cf","avioaero.ga","avioaero.gq","avioaero.ml","avioaero.tk","avls.pt","avorybonds.com","avp1brunupzs8ipef.cf","avp1brunupzs8ipef.ga","avp1brunupzs8ipef.gq","avp1brunupzs8ipef.ml","avp1brunupzs8ipef.tk","avr.ze.cx","avr1.org","avslenjlu.pl","avstria-nedv.ru","avtomationline.net","avtopark.men","avtovukup.ru","avuimkgtbgccejft901.cf","avuimkgtbgccejft901.ga","avuimkgtbgccejft901.gq","avuimkgtbgccejft901.ml","avuimkgtbgccejft901.tk","avumail.com","avvmail.com","avxrja.com","aw.kikwet.com","awahal0vk1o7gbyzf0.cf","awahal0vk1o7gbyzf0.ga","awahal0vk1o7gbyzf0.gq","awahal0vk1o7gbyzf0.ml","awahal0vk1o7gbyzf0.tk","awatum.de","awca.eu","awdrt.com","awdrt.org","awdrt.net","aweather.ru","aweightlossguide.com","awemail.com","awesome4you.ru","awesomebikejp.com","awesomeemail.com","awesomeofferings.com","awiki.org","awionka.info","awloywro.co.cc","awngqe4qb3qvuohvuh.cf","awngqe4qb3qvuohvuh.ga","awngqe4qb3qvuohvuh.gq","awngqe4qb3qvuohvuh.ml","awngqe4qb3qvuohvuh.tk","awrp3laot.cf","aws.creo.site","aws910.com","awsoo.com","awumail.com","ax80mail.com","axeprim.eu","axiz.org","axmail.com","axmluf8osv0h.cf","axmluf8osv0h.ga","axmluf8osv0h.gq","axmluf8osv0h.ml","axmluf8osv0h.tk","axmodine.tk","axon7zte.com","axsup.net","axuwv6wnveqhwilbzer.cf","axuwv6wnveqhwilbzer.ga","axuwv6wnveqhwilbzer.gq","axuwv6wnveqhwilbzer.ml","axuwv6wnveqhwilbzer.tk","axwel.in","ay33rs.flu.cc","ayabozz.com","ayalamail.men","ayblieufuav.cf","ayblieufuav.ga","ayblieufuav.gq","ayblieufuav.ml","ayblieufuav.tk","ayecapta.in","ayimail.com","ayizkufailhjr.cf","ayizkufailhjr.ga","ayizkufailhjr.gq","ayizkufailhjr.ml","ayizkufailhjr.tk","ayomail.com","ayotech.com","ayron-shirli.ru","ayuh.myvnc.com","ayumail.com","ayurvedayogashram.com","az.com","az.usto.in","azacmail.com","azazazatashkent.tk","azcomputerworks.com","azemail.com","azer-nedv.ru","azest.us","azfvbwa.pl","azhour.fr","aziamail.com","azjuggalos.com","azmeil.tk","aznayra.co.tv","azon-review.com","azosmail.com","azote.cf","azote.ga","azote.gq","azpuma.com","azrvdvazg.pl","azulaomarine.com","azumail.com","azure.cloudns.asia","azurny.mazowsze.pl","azxddgvcy.pl","azxhzkohzjwvt6lcx.cf","azxhzkohzjwvt6lcx.ga","azxhzkohzjwvt6lcx.gq","azxhzkohzjwvt6lcx.ml","azxhzkohzjwvt6lcx.tk","b-geamuritermopan-p.com","b-geamuritermopane-p.com","b-preturitermopane-p.com","b-preturitermopane.com","b-sky-b.cf","b-sky-b.ga","b-sky-b.gq","b-sky-b.ml","b-sky-b.tk","b-termopanepreturi-p.com","b.cr.cloudns.asia","b.kerl.gq","b.polosburberry.com","b.reed.to","b.royal-syrup.tk","b.yertxenor.tk","b0.nut.cc","b057bf.pl","b1gmail.epicgamer.org","b1of96u.com","b1p5xtrngklaukff.cf","b1p5xtrngklaukff.ga","b1p5xtrngklaukff.gq","b1p5xtrngklaukff.tk","b2bmail.bid","b2bmail.download","b2bmail.men","b2bmail.stream","b2bmail.trade","b2bx.net","b2cmail.de","b2email.win","b2g6anmfxkt2t.cf","b2g6anmfxkt2t.ga","b2g6anmfxkt2t.gq","b2g6anmfxkt2t.ml","b2g6anmfxkt2t.tk","b3nxdx6dhq.cf","b3nxdx6dhq.ga","b3nxdx6dhq.gq","b3nxdx6dhq.ml","b55b56.cf","b55b56.ga","b55b56.gq","b55b56.ml","b55b56.tk","b5r5wsdr6.pl","b5safaria.com","b602mq.pl","b6o7vt32yz.cf","b6o7vt32yz.ga","b6o7vt32yz.gq","b6o7vt32yz.ml","b6o7vt32yz.tk","b6vscarmen.com","b6xh2n3p7ywli01.cf","b6xh2n3p7ywli01.ga","b6xh2n3p7ywli01.gq","b6xufbtfpqco.cf","b6xufbtfpqco.ga","b6xufbtfpqco.gq","b6xufbtfpqco.ml","b6xufbtfpqco.tk","b7ba4ef3a8f6.ga","b7t98zhdrtsckm.ga","b7t98zhdrtsckm.ml","b7t98zhdrtsckm.tk","b83gritty1eoavex.cf","b83gritty1eoavex.ga","b83gritty1eoavex.gq","b83gritty1eoavex.ml","b83gritty1eoavex.tk","b9adiv5a1ecqabrpg.cf","b9adiv5a1ecqabrpg.ga","b9adiv5a1ecqabrpg.gq","b9adiv5a1ecqabrpg.ml","b9adiv5a1ecqabrpg.tk","b9x45v1m.com","b9x45v1m.com.com","baalism.info","baang.co.uk","baasdomains.info","bababox.info","baban.ml","babassu.info","babau.cf","babau.flu.cc","babau.ga","babau.gq","babau.igg.biz","babau.ml","babau.mywire.org","babau.nut.cc","babau.usa.cc","babe-idol.com","babe-store.com","babehealth.ru","babei-idol.com","babesstore.com","babiczka.az.pl","babimost.co.pl","babinski.info","babirousa.ml","babirusa.info","babiszoni.pl","babraja.kutno.pl","babroc.az.pl","babski.az.pl","babtisa.com","baby-mat.com","babyb1og.ru","babycounter.com","babyk.gq","babylissshoponline.org","babylissstore.com","babylonize.com","babymails.com","babymattress.me","babyrezensionen.com","babyroomdecorations.net","babyrousa.info","babysheets.com","babytrainers.info","babyvideoemail.com","babywalker.me","babywalzgutschein.com","bacaberitabola.com","bacai70.net","bacapedia.web.id","bacfonline.org","bachelorette.com","bacheloretteparty.com","bachelorpartyprank.info","bachkhoatoancau.com","bachus-dava.com","back2barack.info","back2bsback.com","backalleybowling.info","backalleydesigns.org","backflip.cf","backlesslady.com","backlesslady.net","backlink.mygbiz.com","backlinkaufbauservice.de","backlinkcity.info","backlinkhorsepower.com","backlinks.we.bs","backlinkscheduler.com","backlinkservice.me","backlinkskopen.net","backlinksparser.com","backmail.ml","backpackestore.com","backpainadvice.info","backyardduty.com","backyardgardenblog.com","bacninhmail.us","baconporker.com","baconsoi.tk","badabingfor1.com","badaboommail.xyz","badamm.us","badatorreadorr.com","badboygirlpowa.com","badcreditloans.elang.org","badcreditloanss.co.uk","badgerland.eu","badgettingnurdsusa.com","badhus.org","badixort.eu","badmili.com","badnewsol.com","badoo.live","badoop.com","badpotato.tk","badumtssboy.com","badumtxolo.com","badutquinza.com","bae-systems.tk","bafrem3456ails.com","bag2.ga","bag2.gq","bagam-nedv.ru","bagfdgks.com","bagfdgks.net","bagivideos.com","bagonsalejp.com","bagoutletjp.com","bagpaclag.com","bagscheaplvvuitton.com","bagscheaps.org","bagscoachoutleonlinestore.com","bagsguccisaleukonliness.co.uk","bagslouisvuitton2012.com","bagsofficer.info","bagsshopjp.com","baidubaidu123123.info","bailbondsdirect.com","bainesbathrooms.co.uk","bajardepesoahora.org","bajarpeso24.es","bajery-na-imprezy.pl","bajerydladzieci.pl","bajerynaimprezy.pl","bajyma.ru","bakamail.info","bakar.bid","bakecakecake.com","bakkenoil.org","balabush.ru","balacavaloldoi.com","balanc3r.com","balenciagabag.co.uk","balibestresorts.com","balimeloveyoulongtime.com","ballaratsteinerprep.in","ballmails.xyz","ballsofsteel.net","ballustra.net.pl","ballysale.com","baloszyce-elektroluminescencja-nadpilicki.top","baltimore2.freeddns.com","baltimore4.ygto.com","bambee.tk","bambis.cat","bananamails.info","bananashakem.com","bandai.nom.co","bandsoap.com","bangilan.ga","bangilan.ml","bangkok-mega.com","bangladesh-nedv.ru","banglamusic.co","banglanatok.co","bangsat.in","banhbeovodich.vn","banhga.cf","banhga.ga","banhga.ml","banit.club","banit.me","banjarworo.ga","banjarworo.ml","banjarworocity.cf","bank-konstancin.pl","bank-opros1.ru","bankaccountexpert.tk","bankionline.info","bankparibas.pl","bankrobbersindicators.com","bankrupt1.com","bankruptcycopies.com","bannedpls.online","banner4traffic.com","bannerstandpros.com","banubadaeraceva.com","bao160.com","baomoi.site","baothoitrang.org","baphled.com","bapu.gq","bapu.ml","bapumoj.cf","bapumoj.ga","bapumoj.gq","bapumoj.ml","bapumoj.tk","baracudapoolcleaner.com","barafa.gs","barajasmail.bid","barbados-nedv.ru","barbarra-com.pl","barbarrianking.com","barbieoyungamesoyna.com","barcakana.tk","barcalovers.club","barcin.co.pl","barclays-plc.cf","barclays-plc.ga","barclays-plc.gq","barclays-plc.ml","barclays-plc.tk","bareck.net","bareed.ws","baridasari.ru","barkito.se","barkochicomail.com","barnesandnoble-couponcodes.com","barosuefoarteprost.com","barrabravaz.com","barrhq.com","barrieevans.co.uk","barryogorman.com","barrypov.com","barryspov.com","bartdevos.be","bartoparcadecabinet.com","baruchcc.edu","barzan.mielno.pl","basakgidapetrol.com","base-all.ru","base-weight.com","baseballboycott.com","baseny-mat.com.pl","basgoo.com","bashmak.info","bashnya.info","basicbusinessinfo.com","basicinstinct.com.us","basicskillssheep.com","basingbase.com","basketball2in.com","basketballcite.com","basketballvoice.com","basketinfo.net","baskinoco.ru","basscode.org","basssi.today","bastamail.cf","bastauop.info","bastore.co","bastwisp.ru","basurtest55ckr.tk","basy.cf","batanik-mir.ru","batches.info","batesmail.men","bath-slime.com","bathandbodyworksoutlettest.org","bathroomsbristol.com","bathworks.info","batpeer.site","battelknight.pl","battricks.com","bau-peler.business","bau-peler.com","bauimail.ga","bauwerke-online.com","baxomale.ht.cx","baxymfyz.pl","bayanarkadas.info","baylead.com","bayrjnf.pl","bayshore.edu","baytrilfordogs.org","bazaaboom.com","bazavashdom.info","bazmool.com","bazoocam.co","bazybgumui.pl","bb-system.pl","bb2.ru","bbabyswing.com","bbadcreditloan.com","bbb.hexsite.pl","bbbbyyzz.info","bbbest.com","bbblanket.com","bbcbbc.com","bbcok.com","bbdownz.com","bbestssafd.com","bbetweenj.com","bbhost.us","bblounge.co.za","bbmail.win","bbox.com","bboysd.com","bbreghodogx83cuh.ml","bbs.edu","bbtop.com","bbugblanket.com","bburberryoutletufficialeit.com","bc4mails.com","bca1fb56.servemp3.com","bcaoo.com","bcast.ws","bcb.ro","bcbgblog.org","bccto.me","bcdmail.date","bcg-adwokaci.pl","bchatz.ga","bcompiled3.com","bcxaiws58b1sa03dz.cf","bcxaiws58b1sa03dz.ga","bcxaiws58b1sa03dz.gq","bcxaiws58b1sa03dz.ml","bcxaiws58b1sa03dz.tk","bczwy6j7q.pl","bd.dns-cloud.net","bd.if.ua","bdf343rhe.de","bdmuzic.pw","bdvsthpev.pl","beachbodysucces.net","beaniemania.net","beanlignt.com","bearegone.pro","bearsarefuzzy.com","beastrapleaks.blogspot.com","beatelse.com","beats-rock.com","beatsaheadphones.com","beatsbudredrkk.com","beatsbydre18.com","beatsbydredk.com","beatsdr-dreheadphones.com","beatsdre.info","beatsdydr.com","beatskicks.com","beatsportsbetting.com","beautifulinteriors.info","beautifulonez.com","beautifulsmile.info","beauty-pro.info","beautyfashionnews.com","beautyiwona.pl","beautyjewelery.com","beautynewsforyou.com","beautyothers.ru","beautypromdresses.net","beautypromdresses.org","beautyskincarefinder.com","beautytesterin.de","beautywelldress.com","beautywelldress.org","beaverboob.info","beaverbreast.info","beaverhooters.info","beaverknokers.info","beavertits.info","bebasmovie.com","bebemeuescumpfoc.com","becausethenight.cf","becausethenight.ml","becausethenight.tk","becaxklo.info","bechtac.pomorze.pl","beck-it.net","beckygri.pw","bedatsky.agencja-csk.pl","bedbathandbeyond-couponcodes.com","beddly.com","bedstyle2015.com","beechatz.ga","beechatzz.ga","beed.ml","beefmilk.com","beenfiles.com","beerolympics.se","beeviee.cf","beeviee.ga","beeviee.gq","beeviee1.cf","beeviee1.ga","beeviee1.gq","beeviee1.ml","beeviee1.tk","begnthp.tk","begoz.com","behax.net","bei.kr","beihoffer.com","beijinhuixin.com","bel.kr","belamail.org","belanjaonlineku.web.id","belarus-nedv.ru","belastingdienst.pw","belediyeevleri2noluasm.com","belence.cf","belence.ga","belence.gq","belence.ml","belence.tk","belgia-nedv.ru","beliefnet.com","belieti.com","believesex.com","belisatu.net","beliz-nedv.ru","bellanotte.cf","bellavanireview.net","belleairjordanoutlet.us","belleairmaxingthe.us","bellingham-ma.us","belljonestax.com","beluckygame.com","belujah.com","ben10benten.com","benchjacken.info","benchsbeauty.info","benefitsquitsmoking.com","benfrey.com","bengkelseo.com","benipaula.org","bensinstantloans.co.uk","bentoboxmusic.com","benwola.pl","beo.kr","bepdientugiare.net","beremkredit.info","beresleting.cf","beresleting.ga","beresleting.gq","beresleting.ml","beresleting.tk","beribase.ru","beribaza.ru","berirabotay.ru","berlusconi.cf","berlusconi.ga","berlusconi.gq","berlusconi.ml","bermr.org","berodomoko.be","berracom.ph","berryblitzreview.com","berrymail.men","berryslawn.com","bershka-terim.space","beruka.org","besplatnie-conspecti.ru","best-advert-for-your-site.info","best-airmaxusa.us","best-carpetcleanerreviews.com","best-cruiselines.com","best-day.pw","best-detroit-doctors.info","best-electric-cigarettes.co.uk","best-email.bid","best-fiverr-gigs.com","best-mail.net","best-market-search.com","best-paydayloan24h7.com","best-store.me.uk","best-things.ru","best-ugg-canada.com","bestadvertisingsolutions.info","bestats.top","bestattach.gq","bestbuy-couponcodes.com","bestbuyvips.com","bestcarpetcleanerreview.org","bestcastlevillecheats.info","bestchannelstv.info","bestcharm.net","bestcheapdeals.org","bestcheapshoesformenwomen.com","bestchoiceofweb.club","bestchoiceusedcar.com","bestcigarettemarket.net","bestcityinformation.com","bestcpacompany.com","bestcraftsshop.com","bestcreditcart-v.com","bestcustomlogo.com","bestdarkspotcorrector.org","bestday.pw","bestdealsdiscounts.co.in","bestdickpills.info","bestdiningarea.com","bestdownjackets.com","bestdvdblurayplayer.com","bestemail.bid","bestemail.stream","bestemail.top","bestemail2014.info","bestemail24.info","bestenuhren.com","bestescort4u.com","bestexerciseequipmentguide.com","bestfakenews.xyz","bestfinancecenter.org","bestfuture.pw","bestgames.ch","bestgames4fun.com","bestglockner.com","bestguccibags.com","bestgunsafereviews.org","besthostever.xyz","bestjerseysforu.com","bestkeylogger.org","bestkitchens.fun","bestlawyerinhouston.com","bestloot.tk","bestlordsmobilehack.eu","bestlovesms.com","bestlucky.pw","bestmail-host.info","bestmail2016.club","bestmail365.eu","bestmailer.gq","bestmailer.tk","bestmails.tk","bestmailtoday.com","bestmarksites.info","bestmedicinedaily.net","bestmedicinehat.net","bestmemory.net","bestmitel.tk","bestmlmleadsmarketing.com","bestmogensen.com","bestmonopoly.ru","bestn4box.ru","bestnecklacessale.info","bestnews365.info","bestofbest.biz","bestofprice.co","bestoilchangeinmichigan.com","bestonlinecasinosworld.com","bestonlineusapharmacy.ru","bestoption25.club","bestphonecasesshop.com","bestpieter.com","bestpochtampt.ga","bestpokerlinks.net","bestposta.cf","bestpressgazette.info","bestregardsmate.com","bestrestaurantguides.com","bestreviewsonproducts.com","bestring.org","bestseojobs.com","bestseomail.cn","bestserviceforwebtraffic.info","bestshopcoupon.net","bestshoppingmallonline.info","bestshopsoffer.com","bestsmesolutions.com","bestsnowgear.com","bestsoundeffects.com","bestspmall.com","bestsunshine.org","besttandberg.com","bestteethwhiteningstripss.com","besttempmail.com","besttoggery.com","besttopbeat.com","besttopbeatssale.com","besttrialpacksmik.com","besttrommler.com","besttwoo1.info","bestuggbootsoutletshop.com","bestvalentinedayideas.com","bestvaluehomeappliances.com","bestvideogamesevermade.com","bestvpn.top","bestvpshostings.com","bestwatches.com","bestways.ga","bestweightlossfitness.com","bestwesternpromotioncode.org","bestwindows7key.net","bestwish.biz","bestwishes.pw","bestworldcasino.com","bestwrinklecreamnow.com","bestyoumail.co.cc","besun.cf","bet-fi.info","beta.tyrex.cf","betabhp.pl","betaforcemusclereview.com","betaprice.co","beteajah.ga","beteajah.gq","beteajah.ml","beteajah.tk","betemail.cf","betermalvps.com","betfafa.com","bethere4mj4ever.com","bethguimitchie.xyz","betnaste.tk","betonoweszambo.com.pl","betr.co","bets-spor.com","bets-ten.com","better-place.pl","betterlink.info","bettermail24.eu","bettermail384.biz","bettershop.biz","bettersunbath.co.uk","beupmore.win","beutyfz.com","beverlytx.com","beymail.com","bezblednik.pl","bezique.info","bezlimitu.waw.pl","bf3hacker.com","bfat7fiilie.ru","bfhgh.com","bfitcpupt.pl","bfo.kr","bfre675456mails.com","bfremails.com","bftoyforpiti.com","bfuz8.pl","bg4llrhznrom.cf","bg4llrhznrom.ga","bg4llrhznrom.gq","bg4llrhznrom.ml","bg4llrhznrom.tk","bgboad.ga","bgboad.ml","bgchan.net","bget0loaadz.ru","bget3sagruz.ru","bgget2zagruska.ru","bgget4fajli.ru","bgget8sagruz.ru","bgi-sfr-i.pw","bgisfri.pw","bgoy24.pl","bgsaddrmwn.me","bgtedbcd.com","bgtmail.com","bgx.ro","bhaappy0faiili.ru","bhaappy1loadzzz.ru","bhadoomail.com","bhappy0sagruz.ru","bhappy1fajli.ru","bhappy2loaadz.ru","bhappy3zagruz.ru","bhapy1fffile.ru","bhapy2fiilie.ru","bhapy3fajli.ru","bharatpatel.org","bhddmwuabqtd.cf","bhddmwuabqtd.ga","bhddmwuabqtd.gq","bhddmwuabqtd.ml","bhddmwuabqtd.tk","bhebhemuiegigi.com","bhgm7.club","bhmhtaecer.pl","bho.hu","bho.kr","bhpdariuszpanczak.pl","bhringraj.net","bhrpsck8oraayj.cf","bhrpsck8oraayj.ga","bhrpsck8oraayj.gq","bhrpsck8oraayj.ml","bhrpsck8oraayj.tk","bhs70s.com","bhuyarey.ga","bhuyarey.ml","bialy.agencja-csk.pl","bialystokkabury.pl","bibbiasary.info","bibicaba.cf","bibicaba.ga","bibicaba.gq","bibicaba.ml","bibucabi.cf","bibucabi.ga","bibucabi.gq","bibucabi.ml","bidly.pw","bidoubidou.com","bidourlnks.com","bidu.cf","bidu.gq","bidvmail.cf","bieberclub.net","biedra.pl","biegamsobie.pl","bielizna.com","bieliznasklep.net","bieszczadyija.info.pl","big-max24.info","big-post.com","big-sales.ru","big1.us","bigatel.info","bigbang-1.com","bigbangfairy.com","bigbowltexas.info","bigbreast-nl.eu","bigcrop.pro","bigdresses.pw","bigfastmail.com","bigfatmail.info","bigg.pw","biggerbuttsecretsreview.com","biggestdeception.com","biggestresourcelink.info","biggestresourceplanning.info","biggestresourcereview.info","biggestresourcetrek.info","biggestyellowpages.info","bighost.bid","bighost.download","bigimages.pl","biginfoarticles.info","bigjoes.co.cc","biglinks.me","biglive.asia","bigmail.info","bigmon.ru","bigorbust.net","bigpicnic.ru","bigprofessor.so","bigseopro.co.za","bigsizetrend.com","bigsocalfestival.info","bigstart.us","bigstring.com","bigtetek.cf","bigtetek.ga","bigtetek.gq","bigtetek.ml","bigtetek.tk","bigtokenican2.hmail.us","bigtokenican3.hmail.us","bigtuyul.me","bigua.info","bigwhoop.co.za","bigwiki.xyz","bij.pl","bikerbrat.com","bikingwithevidence.info","bilans-bydgoszcz.pl","bilderbergmeetings.org","biletsavia.ru","biliberdovich.ru","bill-consolidation.info","bill.pikapiq.com","billkros.net.pl","billyjoellivetix.com","bimgir.net","bin.8191.at","binary-bonus.net","binarytrendprofits.com","bindrup62954.co.pl","bingakilo.ga","bingakilo.ml","binge.com","bingotonight.co.uk","binka.me","binkmail.com","binnary.com","binnerbox.info","binoculars-rating.com","bio-muesli.info","bio-muesli.net","bioauto.info","biodieselrevealed.com","biofuelsmarketalert.info","biometicsliquidvitamins.com","bione.co","biorezonans-warszawa.com.pl","biorosen1981.ru","biosor.cf","birbakmobilya.com","bird-gifts.net","birdlover.com","birdsfly.press","birecruit.com","birkinbags.info","birkinhermese.com","birminghamfans.com","biro.gq","biro.ml","biro.tk","birtattantuni.com","birthday-gifts.info","birthday-party.info","biruni.cc.marun.edu.tr","biruni.cc.mdfrun.edu.tr","biscutt.us","biser.woa.org.ua","bishoptimon74.com","biskampus.ga","biskvitus.ru","bissabiss.com","bistonplin.com","bit-degree.com","bit-tehnika.in.ua","bit2tube.com","bitchmail.ga","bitcoin2014.pl","bitcoinbet.us","bitlly.xyz","bitpost.site","bitsslto.xyz","bitterpanther.info","bitwerke.com","bitwhites.top","bitx.nl","bitymails.us","biuro-naprawcze.pl","biz.st","bizalem.com","bizalon.com","bizax.org","bizbiz.tk","bizfests.com","bizimails.com","bizimalem-support.de","bizplace.info","bizsearch.info","bizsportsnews.com","bizsportsonlinenews.com","bizuteriazklasa.pl","bizzinfos.info","bjbekhmej.pl","bjdhrtri09mxn.ml","bjf3dwm.345.pl","bjjj.ru","bjmd.cf","bkbgzsrxt.pl","bkegfwkh.agro.pl","bki7rt6yufyiguio.ze.am","bkijhtphb.pl","bkkmaps.com","bkkpkht.cf","bkkpkht.ga","bkkpkht.gq","bkkpkht.ml","bko.kr","bky168.com","bl.ctu.edu.gr","bl5ic2ywfn7bo.cf","bl5ic2ywfn7bo.ga","bl5ic2ywfn7bo.gq","bl5ic2ywfn7bo.ml","bl5ic2ywfn7bo.tk","blablaboiboi.com","blablaboyzs.com","blabladoizece.com","blablo2fosho.com","blablop.com","blaboyhahayo.com","black-stones.ru","blackbird.ws","blackbookdate.info","blackdragonfireworks.com","blackdrebeats.info","blacked-com.ru","blackfridayadvice2011.cc","blackgate.tk","blackgoldagency.ru","blackhat-seo-blog.com","blackhole.djurby.se","blackhole.targeter.nl","blackinbox.com","blackinbox.org","blackmagicblog.com","blackmagicspells.co.cc","blackmail.ml","blackmarket.to","blackrockasfaew.com","blacksarecooleryo.com","blackseo.top","blackshipping.com","blacktopscream.com","bladeandsoul-gold.us","bladesmail.net","blak.net","blakasuthaz52mom.tk","blakemail.men","blan.tech","blangbling784yy.tk","blarakfight67dhr.ga","blarneytones.com","blastmail.biz","blastxlreview.com","blatopgunfox.com","blavixm.ie","bleblebless.pl","blerg.com","bleubers.com","blexx.eu","blinkmatrix.com","blinkster.info","blinkweb.bid","blinkweb.top","blinkweb.trade","blinkweb.win","blip.ch","blitzed.space","blitzprogripthatshizz.com","bljekdzhekkazino.org","blnkt.net","bloatbox.com","blockbusterhits.info","blockdigichain.com","blockthatmagefcjer.com","bloconprescong.xyz","blog-1.ru","blog-galaxy.com","blog.annayake.pl","blog.metal-med.pl","blog.net.gr","blog.quirkymeme.com","blog.sjinks.pro","blog.yourelection.net","blog4us.eu","blogav.ru","blogdiary.live","blogerus.ru","bloggermailinfo.info","bloggermania.info","bloggersxmi.com","bloggg.de","blogging.com","bloggingargentina.com.ar","bloggingnow.club","bloggingnow.pw","bloggingpro.fun","bloggingpro.host","bloggingpro.info","bloggingpro.pw","bloggorextorex.com","bloghangbags.com","blogmastercom.net","blogmyway.org","blogneproseo.ru","blogoagdrtv.pl","blogomaiaidefacut.com","blogonews2015.ru","blogos.com","blogos.net","blogox.net","blogpentruprostisicurve.com","blogroll.com","blogrtui.ru","blogs.com","blogschool.edu","blogshoponline.com","blogspam.ro","blogster.host","blogster.info","blogthis.com","blogwithbloggy.net","blogxxx.biz","blolohaibabydot.com","blolololbox.com","blomail.com","blomail.info","blonnik1.az.pl","blood-pressure.tipsinformationandsolutions.com","bloodonyouboy.com","bloog-24.com","bloog.me","bloomning.com","bloomning.net","bloq.ro","bloszone.com","blow-job.nut.cc","blox.eu","bloxter.cu.cc","blqthexqfmmcsjc6hy.cf","blqthexqfmmcsjc6hy.ga","blqthexqfmmcsjc6hy.gq","blqthexqfmmcsjc6hy.ml","blqthexqfmmcsjc6hy.tk","blst.gov","blue-mail.org","blue-rain.org","bluebottle.com","bluechipinvestments.com","bluedumpling.info","bluejansportbackpacks.com","bluejaysjerseysmart.com","bluelawllp.com","blueoceanrecruiting.com","bluepills.pp.ua","blueright.net","bluesmail.pw","bluetoothbuys.com","bluewerks.com","blueyi.com","bluffersguidetoit.com","blulapka.pl","blurp.tk","blurpemailgun.bid","blutig.me","bm0371.com","bm2grihwz.pl","bmaker.net","bmgm.info","bmonlinebanking.com","bmpk.org","bmsojon4d.pl","bmw-ag.cf","bmw-ag.ga","bmw-ag.gq","bmw-ag.ml","bmw-ag.tk","bmw-i8.gq","bmw-mini.cf","bmw-mini.ga","bmw-mini.gq","bmw-mini.ml","bmw-mini.tk","bmw-rollsroyce.cf","bmw-rollsroyce.ga","bmw-rollsroyce.gq","bmw-rollsroyce.ml","bmw-rollsroyce.tk","bmw-service-mazpol.pl","bmw-x5.cf","bmw-x5.ga","bmw-x5.gq","bmw-x5.ml","bmw-x5.tk","bmw-x6.ga","bmw-x6.gq","bmw-x6.ml","bmw-x6.tk","bmw-z4.cf","bmw-z4.ga","bmw-z4.gq","bmw-z4.ml","bmw-z4.tk","bmw4life.com","bmw4life.edu","bmwgroup.cf","bmwgroup.ga","bmwgroup.gq","bmwgroup.ml","bmwmail.pw","bnckms.cf","bnckms.ga","bnckms.gq","bnckms.ml","bncoastal.com","bnfgtyert.com","bnghdg545gdd.gq","bnm612.com","bnoko.com","bnote.com","bnuis.com","bnv0qx4df0quwiuletg.cf","bnv0qx4df0quwiuletg.ga","bnv0qx4df0quwiuletg.gq","bnv0qx4df0quwiuletg.ml","bnv0qx4df0quwiuletg.tk","bnyzw.info","bo7uolokjt7fm4rq.cf","bo7uolokjt7fm4rq.ga","bo7uolokjt7fm4rq.gq","bo7uolokjt7fm4rq.ml","bo7uolokjt7fm4rq.tk","boacreditcard.org","boastfullaces.top","boastfusion.com","boatcoersdirect.net","boatmail.us","bob.email4edu.com","bob.inkandtonercartridge.co.uk","bobablast.com","bobandvikki.club","bobbydcrook.com","bobfilmclub.ru","bobmail.info","bobmurchison.com","bobohieu.tk","boborobocobo.com","bobq.com","bocaneyobalac.com","bocav.com","bocba.com","boccelmicsipitic.com","boceuncacanar.com","bocigesro.xyz","bocil.tk","bocldp7le.pl","bocps.biz","bodachina.com","bodhi.lawlita.com","bodmod.ga","bodog-asia.net","bodog-poker.net","bodog180.net","bodog198.net","body55.info","bodybuildingdieta.co.uk","bodybuildings24.com","bodydiamond.com","bodyplanes.com","bodyscrubrecipes.com","boeutyeriterasa.cz.cc","bofrateyolele.com","bofthew.com","bog3m9ars.edu.pl","bogneronline.ru","bogotadc.info","bogotaredetot.com","bohani.cf","bohani.ga","bohani.gq","bohani.ml","bohani.tk","bohemiantoo.com","boimail.com","boinkmas.top","boiserockssocks.com","bojogalax.ga","bokllhbehgw9.cf","bokllhbehgw9.ga","bokllhbehgw9.gq","bokllhbehgw9.ml","bokllhbehgw9.tk","boks4u.gq","bokstone.com","bold.ovh","bolg-nedv.ru","boliviya-nedv.ru","bollouisvuittont.info","bolomycarsiscute.com","bommails.ml","bondmail.men","bondrewd.cf","bongo.gq","bongobongo.cf","bongobongo.flu.cc","bongobongo.ga","bongobongo.gq","bongobongo.igg.biz","bongobongo.ml","bongobongo.nut.cc","bongobongo.tk","bongobongo.usa.cc","boningly.com","bonobo.email","boogiejunction.com","booglecn.com","bookkeepr.ca","bookliop.xyz","bookmarks.edu.pl","bookoneem.ga","books-bestsellers.info","books-for-kindle.info","booksohu.com","bookthemmore.com","booktoplady.com","bookyah.com","booleserver.mobi","boombeachgenerator.cf","boombeats.info","boomerinternet.com","boomsaer.com","boomykqhw.pl","booooble.com","boopmail.com","boopmail.info","bootcampmania.co.uk","bootdeal.com","bootiebeer.com","bootkp8fnp6t7dh.cf","bootkp8fnp6t7dh.ga","bootkp8fnp6t7dh.gq","bootkp8fnp6t7dh.ml","bootkp8fnp6t7dh.tk","boots-eshopping.com","bootsaletojp.com","bootscanadaonline.info","bootsformail.com","bootsgos.com","bootshoes-shop.info","bootshoeshop.info","bootson-sale.info","bootsosale.com","bootsoutletsale.com","bootssale-uk.info","bootssheepshin.com","bootstringer.com","bootsukksaleofficial1.com","bootsvalue.com","bootybay.de","boow.cf","boow.ga","boow.gq","boow.ml","boow.tk","booyabiachiyo.com","bopra.xyz","bopunkten.se","borderflowerydivergentqueen.top","borefestoman.com","borexedetreaba.com","borged.com","borged.net","borged.org","borgish.com","borguccioutlet1.com","boris4x4.com","bornboring.com","boromirismyherobro.com","borsebbysolds.com","borseburberryoutletitt.com","borseburbery1.com","borseburberyoutlet.com","borsebvrberry.com","borsechan1.com","borsechane11.com","borsechaneloutletonline.com","borsechaneloutletufficialeit.com","borsechanemodaitaly.com","borsechanlit.com","borsechanlit1.com","borsechanlit2.com","borsechanuomomini1.com","borsechanuomomini2.com","borsechelzou.com","borseeguccioutlet.com","borseelouisvuittonsitoufficiale.com","borsegucc1outletitaly.com","borsegucciitalia3.com","borseguccimoda.com","borsegucciufficialeitt.com","borseitaliavendere.com","borseitalychane.com","borseitguccioutletsito4.com","borselouisvuitton-italy.com","borselouisvuitton5y.com","borselouisvuittonitalyoutlet.com","borselouvutonit9u.com","borselvittonit3.com","borselvoutletufficiale.com","borsemiumiuoutlet.com","borsesvuitton-it.com","borsevuittonborse.com","borsevuittonit1.com","bos-ger-nedv.ru","bosahek.com","boss.cf","bossmail.de","bot.nu","botasuggm.com","botasuggsc.com","botox-central.com","bottesuggds.com","botz.online","boun.cr","bouncr.com","bountifulgrace.org","bourdeniss.gr","boursiha.com","bouss.net","boutiqueenlignefr.info","bovinaisd.net","bowamaranth.website","bowlinglawn.com","bowtrolcolontreatment.com","box-email.ru","box-emaill.info","box-mail.ru","box.comx.cf","box.ra.pe","box.yadavnaresh.com.np","boxa.host","boxermail.info","boxformail.in","boximail.com","boxlogas.com","boxloges.com","boxlogos.com","boxmail.co","boxmailers.com","boxsmoke.com","boxtemp.com.br","boxtwos.com","boy-scout-slayer.com","boyalovemyniga.com","boyfargeorgica.com","boyoboygirl.com","boythatescaldqckly.com","boyztomenlove4eva.com","bozenarodzenia.pl","bp3xxqejba.cf","bp3xxqejba.ga","bp3xxqejba.gq","bp3xxqejba.ml","bp3xxqejba.tk","bpda1.com","bper.cf","bper.ga","bper.gq","bper.tk","bplinlhunfagmasiv.com","bpmsound.com","bpornd.com","bpvi.cf","bpvi.ga","bpvi.gq","bpvi.ml","bpvi.tk","bqc4tpsla73fn.cf","bqc4tpsla73fn.ga","bqc4tpsla73fn.gq","bqc4tpsla73fn.ml","bqc4tpsla73fn.tk","bqhost.top","bqm2dyl.com","bqmjotloa.pl","br.mintemail.com","br6qtmllquoxwa.cf","br6qtmllquoxwa.ga","br6qtmllquoxwa.gq","br6qtmllquoxwa.ml","br6qtmllquoxwa.tk","brainboostingsupplements.org","brainfoodmagazine.info","brainhard.net","brainonfire.net","brainworm.ru","brainysoftware.net","bralbrol.com","brand8usa.com","brandallday.net","branden1121.club","brandi.eden.aolmail.top","branding.goodluckwith.us","brandnamewallet.com","brandshoeshunter.com","brandupl.com","brank.io","bras-bramy.pl","brasil-nedv.ru","brasillimousine.com","brassband2.com","brasx.org","bratsey.com","bratwurst.dnsabr.com","braun4email.com","bravecoward.com","bravohotel.webmailious.top","brazza.ru","breadboardpies.com","breadtimes.press","breakloose.pl","breaktheall.org.ua","breakthru.com","brealynnvideos.com","breanna.kennedi.livemailbox.top","breathestime.org.ua","breedaboslos.xyz","breeze.eu.org","breezyflight.info","brefmail.com","bregerter.org","breitlingsale.org","brendonweston.info","brennendesreich.de","brevn.net","brewstudy.com","brflix.com","brflk.com","brickoll.tk","bricomedical.info","briefcase4u.com","briefcaseoffice.info","briefkasten2go.de","briggsmarcus.com","brightadult.com","brighterbroome.org","bring-luck.pw","bringluck.pw","bringmea.org.ua","brinkvideo.win","britainst.com","britemail.info","british-leyland.cf","british-leyland.ga","british-leyland.gq","british-leyland.ml","british-leyland.tk","britishintelligence.co.uk","britneybicz.pl","brixmail.info","brizzolari.com","brmailing.com","broadbandninja.com","broadway-west.com","brodzikowsosnowiec.pl","broilone.com","bromailservice.xyz","bromtedlicyc.xyz","broncomower.xyz","bronxcountylawyerinfo.com","brostream.net","broszreforhoes.com","brothercs6000ireview.org","browndecorationlights.com","browniesgoreng.com","brownieslumer.com","browsechat.eu","browseforinfo.com","browselounge.pl","brrmail.gdn","brrvpuitu8hr.cf","brrvpuitu8hr.ga","brrvpuitu8hr.gq","brrvpuitu8hr.ml","brrvpuitu8hr.tk","brunhilde.ml","brunomarsconcert2014.com","brutaldate.com","bruzdownice-v.pl","bs6bjf8wwr6ry.cf","bs6bjf8wwr6ry.ga","bs6bjf8wwr6ry.gq","bs6bjf8wwr6ry.ml","bsbhz1zbbff6dccbia.cf","bsbhz1zbbff6dccbia.ga","bsbhz1zbbff6dccbia.ml","bsbhz1zbbff6dccbia.tk","bsc.anglik.org","bsderqwe.com","bseomail.com","bsezjuhsloctjq.cf","bsezjuhsloctjq.ga","bsezjuhsloctjq.gq","bsezjuhsloctjq.ml","bsezjuhsloctjq.tk","bskvzhgskrn6a9f1b.cf","bskvzhgskrn6a9f1b.ga","bskvzhgskrn6a9f1b.gq","bskvzhgskrn6a9f1b.ml","bskvzhgskrn6a9f1b.tk","bskyb.cf","bskyb.ga","bskyb.gq","bskyb.ml","bsnow.net","bspamfree.org","bspooky.com","bsquochoai.ga","bst-72.com","bsuakrqwbd.cf","bsuakrqwbd.ga","bsuakrqwbd.gq","bsuakrqwbd.ml","bsuakrqwbd.tk","bt0zvsvcqqid8.cf","bt0zvsvcqqid8.ga","bt0zvsvcqqid8.gq","bt0zvsvcqqid8.ml","bt0zvsvcqqid8.tk","bt3019k.com","btb-notes.com","btc.email","btcmail.pw","btcmail.pwguerrillamail.net","btd4p9gt21a.cf","btd4p9gt21a.ga","btd4p9gt21a.gq","btd4p9gt21a.ml","btd4p9gt21a.tk","btgmka0hhwn1t6.cf","btgmka0hhwn1t6.ga","btgmka0hhwn1t6.ml","btgmka0hhwn1t6.tk","btizet.pl","btj.pl","btj2uxrfv.pl","btukskkzw8z.cf","btukskkzw8z.ga","btukskkzw8z.gq","btukskkzw8z.ml","btukskkzw8z.tk","btxfovhnqh.pl","btz3kqeo4bfpqrt.cf","btz3kqeo4bfpqrt.ga","btz3kqeo4bfpqrt.ml","btz3kqeo4bfpqrt.tk","bu.mintemail.com","buatwini.tk","bucbdlbniz.cf","bucbdlbniz.ga","bucbdlbniz.gq","bucbdlbniz.ml","bucbdlbniz.tk","buccalmassage.ru","buchach.info","buchananinbox.com","buchhandlung24.com","buckrubs.us","buday.htsail.pl","budaya-tionghoa.com","budayationghoa.com","budgetblankets.com","budgjhdh73ctr.gq","budin.men","budowa-domu-rodzinnego.pl","budowadomuwpolsce.info","budowlaneusrem.com","budrem.com","buefkp11.edu.pl","buffalo-poland.pl","buffemail.com","buford.us.to","bugmenever.com","bugmenot.com","bugmenot.ml","buildabsnow.com","buildingfastmuscles.com","buildsrepair.ru","buildyourbizataafcu.com","builtindishwasher.org","bukq.in.ua","bukwos7fp2glo4i30.cf","bukwos7fp2glo4i30.ga","bukwos7fp2glo4i30.gq","bukwos7fp2glo4i30.ml","bukwos7fp2glo4i30.tk","bulahxnix.pl","bulkbacklinks.in","bulkcleancheap.com","bulkemailregistry.com","bulksmsad.net","bullbeer.net","bullbeer.org","bullet1960.info","bullstore.net","buloo.com","bulrushpress.com","bum.net","bumppack.com","bumpymail.com","bunchofidiots.com","bund.us","bundes-li.ga","bungabunga.cf","bunkbedsforsale.info","bunkstoremad.info","bunsenhoneydew.com","buntuty.cf","buntuty.ga","buntuty.ml","buon.club","burberry-australia.info","burberry-blog.com","burberry4u.net","burberrybagsjapan.com","burberryoutlet-uk.info","burberryoutletmodauomoit.info","burberryoutletsalezt.co.uk","burberryoutletsscarf.net","burberryoutletsshop.net","burberryoutletstore-online.com","burberryoutletukzt.co.uk","burberryoutletzt.co.uk","burberryukzt.co.uk","burberrywebsite.com","burcopsg.org","burgercentral.us","burgoscatchphrase.com","burjanet.ru","burjnet.ru","burnacidgerd.com","burner-email.com","burnermail.io","burniawa.pl","burnmail.ca","burnthespam.info","burobedarfrezensionen.com","bursa303.wang","bursa303.win","burstmail.info","bus9alizaxuzupeq3rs.cf","bus9alizaxuzupeq3rs.ga","bus9alizaxuzupeq3rs.gq","bus9alizaxuzupeq3rs.ml","bus9alizaxuzupeq3rs.tk","buscarlibros.info","buscarltd.com","businesideas.ru","business-agent.info","business-intelligence-vendor.com","business-sfsds-advice.com","business1300numbers.com","businessagent.email","businessbackend.com","businesscardcases.info","businesscredit.xyz","businessfinancetutorial.com","businesshowtobooks.com","businesshowtomakemoney.com","businessideasformoms.com","businessinfo.com","businessinfoservicess.com","businessinfoservicess.info","businessneo.com","businesssource.net","businesssuccessislifesuccess.com","businessthankyougift.info","businesstutorialsonline.org","buspad.org","bussinessmail.info","bussitussi.com","bussitussi.net","busy-do-holandii24.pl","busyresourcebroker.info","butbetterthanham.com","butter9x.com","buttliza.info","buttonfans.com","buttonrulesall.com","buxap.com","buy-bags-online.com","buy-caliplus.com","buy-canadagoose-outlet.com","buy-clarisonicmia.com","buy-clarisonicmia2.com","buy-mail.eu","buy-nikefreerunonline.com","buy-viagracheap.info","buy003.com","buy6more2.info","buyairjordan.com","buyamoxilonline24h.com","buyandsmoke.net","buyanessaycheape.top","buybacklinkshq.com","buycanadagoose-ca.com","buycaverta12pills.com","buycheapbeatsbydre-outlet.com","buycheapcipro.com","buycheapfacebooklikes.net","buycheapfireworks.com","buycialis-usa.com","buycialisusa.com","buycialisusa.org","buyclarisonicmiaoutlet.com","buyclarisonicmiasale.com","buycow.org","buycultureboxes.com","buycustompaper.review","buydeltasoneonlinenow.com","buydfcat9893lk.cf","buydiabloaccounts.com","buydiablogear.com","buydiabloitem.com","buyeriacta10pills.com","buyessays-nice.org","buyfacebooklikeslive.com","buyfcbkfans.com","buyfollowers247.com","buyfollowers365.co.uk","buygapfashion.com","buygenericswithoutprescription.com","buygolfmall.com","buygoods.com","buygoodshoe.com","buygooes.com","buygsalist.com","buyhairstraighteners.org","buyhardwares.com","buyhegotgame13.net","buyhegotgame13.org","buyhegotgame13s.net","buyhenryhoover.co.uk","buyhermeshere.com","buyintagra100mg.com","buyjoker.com","buykarenmillendress-uk.com","buykdsc.info","buylaptopsunder300.com","buylevitra-us.com","buylikes247.com","buylouisvuittonbagsjp.com","buymichaelkorsoutletca.ca","buymileycyrustickets.com","buymoreplays.com","buynewmakeshub.info","buynexiumpills.com","buynolvadexonlineone.com","buynowandgo.info","buyonlinestratterapills.com","buyordie.info","buypill-rx.info","buyprice.co","buyprotopic.name","buyproxies.info","buyraybansuk.com","buyreliablezithromaxonline.com","buyrenovaonlinemeds.com","buyreplicastore.com","buyresourcelink.info","buyrocaltrol.name","buyrx-pill.info","buyrxclomid.com","buysellonline.in","buysellsignaturelinks.com","buysomething.me","buysspecialsocks.info","buysteroids365.com","buytwitterfollowersreviews.org","buyusabooks.com","buyusedlibrarybooks.org","buyviagracheapmailorder.us","buyviagraonline-us.com","buywinstrol.xyz","buywithoutrxpills.com","buyxanaxonlinemedz.com","buyyoutubviews.com","buzlin.club","buzzcluby.com","buzzcompact.com","buzzdating.info","buzzuoso.com","buzzvirale.xyz","buzzzyaskz.site","bvmvbmg.co","bvngf.com","bvqjwzeugmk.pl","bwa33.net","bwwsrvvff3wrmctx.cf","bwwsrvvff3wrmctx.ga","bwwsrvvff3wrmctx.gq","bwwsrvvff3wrmctx.ml","bwwsrvvff3wrmctx.tk","bx6r9q41bciv.cf","bx6r9q41bciv.ga","bx6r9q41bciv.gq","bx6r9q41bciv.ml","bx6r9q41bciv.tk","bx8.pl","bx9puvmxfp5vdjzmk.cf","bx9puvmxfp5vdjzmk.ga","bx9puvmxfp5vdjzmk.gq","bx9puvmxfp5vdjzmk.ml","bx9puvmxfp5vdjzmk.tk","bxbofvufe.pl","bxfmtktkpxfkobzssqw.cf","bxfmtktkpxfkobzssqw.ga","bxfmtktkpxfkobzssqw.gq","bxfmtktkpxfkobzssqw.ml","bxfmtktkpxfkobzssqw.tk","bxm2bg2zgtvw5e2eztl.cf","bxm2bg2zgtvw5e2eztl.ga","bxm2bg2zgtvw5e2eztl.gq","bxm2bg2zgtvw5e2eztl.ml","bxm2bg2zgtvw5e2eztl.tk","bxs1yqk9tggwokzfd.cf","bxs1yqk9tggwokzfd.ga","bxs1yqk9tggwokzfd.ml","bxs1yqk9tggwokzfd.tk","by-simply7.tk","by8006l.com","bybklfn.info","byd686.com","byebyemail.com","byespm.com","byggcheapabootscouk1.com","byj53bbd4.pl","byom.de","bypass-captcha.com","byqv.ru","bysky.ru","bytesundbeats.de","bytom-antyraddary.pl","bywuicsfn.pl","bzidohaoc3k.cf","bzidohaoc3k.ga","bzidohaoc3k.gq","bzidohaoc3k.ml","bzidohaoc3k.tk","bzmt6ujofxe3.cf","bzmt6ujofxe3.ga","bzmt6ujofxe3.gq","bzmt6ujofxe3.ml","bzmt6ujofxe3.tk","bztf1kqptryfudz.cf","bztf1kqptryfudz.ga","bztf1kqptryfudz.gq","bztf1kqptryfudz.ml","bztf1kqptryfudz.tk","bzymail.top","c-14.cf","c-14.ga","c-14.gq","c-14.ml","c-mail.cf","c-mail.gq","c-n-shop.com","c.andreihusanu.ro","c.hcac.net","c.kadag.ir","c.kerl.gq","c.nut.emailfake.nut.cc","c.polosburberry.com","c.theplug.org","c.wlist.ro","c0ach-outlet.com","c0ach-outlet1.com","c0achoutletonlinesaleus.com","c0achoutletusa.com","c0achoutletusa2.com","c0rtana.cf","c0rtana.ga","c0rtana.gq","c0rtana.ml","c0rtana.tk","c0sau0gpflgqv0uw2sg.cf","c0sau0gpflgqv0uw2sg.ga","c0sau0gpflgqv0uw2sg.gq","c0sau0gpflgqv0uw2sg.ml","c0sau0gpflgqv0uw2sg.tk","c1oramn.com","c2.hu","c20vussj1j4glaxcat.cf","c20vussj1j4glaxcat.ga","c20vussj1j4glaxcat.gq","c20vussj1j4glaxcat.ml","c20vussj1j4glaxcat.tk","c2ayq83dk.pl","c2clover.info","c3e3r7qeuu.cf","c3e3r7qeuu.ga","c3e3r7qeuu.gq","c3e3r7qeuu.ml","c3e3r7qeuu.tk","c3email.win","c4anec0wemilckzp42.ga","c4anec0wemilckzp42.ml","c4anec0wemilckzp42.tk","c4ster.gq","c4utar.cf","c4utar.ga","c4utar.gq","c4utar.ml","c4utar.tk","c51vsgq.com","c58n67481.pl","c5ccwcteb76fac.cf","c5ccwcteb76fac.ga","c5ccwcteb76fac.gq","c5ccwcteb76fac.ml","c5ccwcteb76fac.tk","c5qawa6iqcjs5czqw.cf","c5qawa6iqcjs5czqw.ga","c5qawa6iqcjs5czqw.gq","c5qawa6iqcjs5czqw.ml","c5qawa6iqcjs5czqw.tk","c686q2fx.pl","c6h12o6.cf","c6h12o6.ga","c6h12o6.gq","c6h12o6.ml","c6h12o6.tk","c6loaadz.ru","c7fk799.com","c81hofab1ay9ka.cf","c81hofab1ay9ka.ga","c81hofab1ay9ka.gq","c81hofab1ay9ka.ml","c81hofab1ay9ka.tk","c99.me","c9gbrnsxc.pl","ca-canadagoose-jacets.com","ca-canadagoose-outlet.com","ca.verisign.cf","ca.verisign.ga","ca.verisign.gq","cabal72750.co.pl","cabekeriting99.com","cabezonoro.cl","cabinets-chicago.com","cabonmania.ga","cabonmania.tk","cacanhbaoloc.com","cachedot.net","cachlamdep247.com","cad.edu.gr","caddelll12819.info","cadillac-ats.tk","cadomoingay.info","cadsaf.us","caerwyn.com","cafebacke.com","cafebacke.net","cafecar.xyz","cafrem3456ails.com","cageymail.info","cahayasenja.online","cahkerjo.tk","cahsintru.cf","caidadepeloyal26.eu","caiwenhao.cn","cajacket.com","cakk.us","calcm8m9b.pl","calculatord.com","caldwellbanker.in","calgarymortgagebroker.info","calibex.com","california-nedv.ru","californiabloglog.com","californiacolleges.edu","californiafitnessdeals.com","caligulux.co","callcentreit.com","calnam.com","caloriesandwghtlift.co.uk","calvinkleinbragas.com","calypsoservice.com","cam4you.cc","cambridge-satchel.com","camcei.dynamic-dns.net","camerabuy.info","camerabuy.ru","camerachoicetips.info","camgirls.de","camionesrd.com","camisetashollisterbrasil.com","cammk.com","camnangdoisong.com","campano.cl","campcuts.com","camping-grill.info","camthaigirls.com","canadacoachhandbags.ca","canadafamilypharm.com","canadafreedatingsite.info","canadagoosecashop.com","canadagoosedoudounepascher.com","canadagoosejakkerrno.com","canadagoosets.info","canadan-pharmacy.info","canadaonline.biz","canadaonline.pw","canadapharm.email","canadapharmaciesonlinebsl.bid","canadawebmail.ca.vu","canadian-onlinep-harmacy.com","canadian-pharmacy.xyz","canadian-pharmacys.com","canadianhackers.com","canadianonline.email","canadianpharmaciesbnt.com","canadianpharmacymim.com","canadianpharmacyseo.us","canadians.biz","canadlan-pharmacy.info","canadph.com","canallow.com","canborrowhot.com","candida-remedy24.com","candidteenagers.com","candlesticks.org","candokyear.com","candy-blog-adult.ru","candy-private-blog.ru","candyloans.com","candymail.de","candywrapperbag.com","candywrapperbag.info","candyyxc45.biz","cane.pw","canggih.net","canhac.vn","canhacaz.com","canhacvn.net","canhcvn.net","canhoehome4.info","canie.assassins-creed.org","canitta.icu","canmorenews.com","cannn.com","cannoncrew.com","canonlensmanual.com","canonwirelessprinters.com","canpha.com","canrelnud.com","cantate-gospel.de","cantikmanja.online","canvasshoeswholesalestoress.info","canyouhearmenow.cf","caonima.gq","capebretonpost.com","capitalizable.one","capkakitiga.pw","cappriccio.ru","capturehisheartreviews.info","car-and-girls.co.cc","car-wik.com","car-wik.tk","car101.pro","caraalami.xyz","caramail.pro","caraudiomarket.ru","carbbackloadingreviews.org","carbo-boks.pl","carbtc.net","card.zp.ua","cardetailerchicago.com","cardiae.info","cardsexpert.ru","careerladder.org","careermans.ru","careersschool.com","careerupper.ru","carefreefloor.com","careless-whisper.com","cargobalikpapan.com","cargoships.net","carins.io","carinsurance2018.top","carinsurancebymonth.co.uk","caritashouse.org","carleasingdeals.info","carloansbadcredit.ca","carmail.com","carmit.info","carnalo.info","carolinarecords.net","carpaltunnelguide.info","carpet-cleaner-northampton.co.uk","carpet-oriental.org","carpetcleaningventura.net","carrnelpartners.com","cars2.club","carsencyclopedia.com","carslon.info","carte3ds.org","cartelera.org","cartelrevolution.co.uk","cartelrevolution.com","cartelrevolution.de","cartelrevolution.net","cartelrevolution.org","cartelrevolutions.com","carthagen.edu","cartone.fun","cartsoonalbumsales.info","cartuningshop.co.uk","carubull.com","casa-versicherung.de","casa.myz.info","casavincentia.org","case4pads.com","caseedu.tk","casetnibo.xyz","cash.org","cash4nothing.de","cashadvance.com","cashadvance.us","cashadvancer.net","cashadvances.us","cashhloanss.com","cashlinesreview.info","cashloan.org","cashloan.us","cashloannetwork.org","cashloannetwork.us","cashloans.com","cashloans.org","cashloans.us","cashloansnetwork.com","cashmons.net","cashstroked.com","casino-bingo.nl","casino-bonus-kod.com","casino-x.co.uk","casinoaustralia-best.com","casinogreat.club","casinos4winners.com","casio-edu.cf","casio-edu.ga","casio-edu.gq","casio-edu.ml","casio-edu.tk","casoron.info","caspianfan.ir","casquebeatsdrefrance.com","cassidony.info","castillodepavones.com","castlebranchlogin.com","castromail.bid","casualdx.com","cat.pp.ua","catalinaloves.com","catalystwms.com","catch.everton.com","catch12345.tk","catchall.fr","catchemail1.xyz","catchemail5.xyz","catchmeifyoucan.xyz","catchonline.ooo","catering.com","cath17.com","catindiamonds.com","catnipcat.net","catson.us","caugiay.tech","causesofheadaches.net","cavi.mx","cawxrsgbo.pl","cayrdzhfo.pl","cazino777.pro","cazis.fr","cazzo.cf","cazzo.ga","cazzo.gq","cbair.com","cbaweqz.com","cbdlandia.pl","cbdw.pl","cbes.net","cbgh.ddns.me","cbjunkie.com","cbot1fajli.ru","cbreviewproduct.com","cbzmail.tk","cc-cc.usa.cc","cc-s3x.cf","cc-s3x.ga","cc-s3x.gq","cc-s3x.ml","cc-s3x.tk","cc.mailboxxx.net","cc2ilplyg77e.cf","cc2ilplyg77e.ga","cc2ilplyg77e.gq","cc2ilplyg77e.ml","cc2ilplyg77e.tk","ccat.cf","ccat.ga","ccat.gq","ccbd.com","ccbilled.com","cccc.com","ccgtoxu3wtyhgmgg6.cf","ccgtoxu3wtyhgmgg6.ga","ccgtoxu3wtyhgmgg6.gq","ccgtoxu3wtyhgmgg6.ml","ccgtoxu3wtyhgmgg6.tk","cchatz.ga","cciatori.com","ccmail.men","ccn35.com","ccxpnthu2.pw","cd.mintemail.com","cd.usto.in","cd2in.com","cdcmail.date","cdcovers.icu","cdkey.com","cdnqa.com","cdofutlook.com","cdpa.cc","cdressesea.com","cdrhealthcare.com","cdrmovies.com","cdsshv.info","cdvig.com","ce.mintemail.com","cebolsarep.ga","cebong.cf","cebong.ga","cebong.gq","cebong.ml","cebong.tk","ceco3kvloj5s3.cf","ceco3kvloj5s3.ga","ceco3kvloj5s3.gq","ceco3kvloj5s3.ml","ceco3kvloj5s3.tk","ceed.se","ceefax.co","ceftvhxs7nln9.cf","ceftvhxs7nln9.ga","ceftvhxs7nln9.gq","ceftvhxs7nln9.ml","ceftvhxs7nln9.tk","cek.pm","cekajahhs.tk","ceklaww.ml","cele.ro","celebans.ru","celebfap.net","celebrinudes.com","celebriporn.net","celebslive.net","celebwank.com","celerto.tk","celinea.info","celinebags2012.sg","celinehandbagjp.com","celinehandbagsjp.com","celinejp.com","celinesoldes.com","celinestores.com","celinevaska.com","cellphonegpstracking.info","cellphoneparts.tk","cellphonespysoftware2012.info","cellularispia.info","cellularispiaeconomici.info","celluliteremovalmethods.com","cellurl.com","cem.net","cemailes.com","cenanatovar.ru","ceneio.pl","center-kredit.de","centermail.com","centermail.net","centleadetai.eu","centnetploggbu.eu","centol.us","central-cargo.co.uk","central-servers.xyz","centraldecomunicacion.es","centrale.waw.pl","centralheatingproblems.net","centrallosana.ga","centralplatforms.com","centralux.org","centralwisconsinfasteners.com","centroone.com","ceoll.com","ceramicsouvenirs.com","ceramictile-outlet.com","ceremonydress.net","ceremonydress.org","ceremonydresses.com","ceremonydresses.net","ceremonyparty.com","certifiedtgp.com","cervejeiromestre.com.br","cesknurs69.de","cestdudigital.info","cesur.pp.ua","cetpass.com","cetta.com","ceweknakal.cf","ceweknakal.ga","ceweknakal.ml","cewtrte555.cz.cc","cex1z9qo.cf","cexkg50j6e.cf","cexkg50j6e.ga","cexkg50j6e.gq","cexkg50j6e.ml","cexkg50j6e.tk","cfat9fajli.ru","cfat9loadzzz.ru","cfatt6loadzzz.ru","cfe21.com","cfifa.net","cfllx7ix9.pl","cfo2go.ro","cfoto24.pl","cfremails.com","cfskrxfnsuqck.cf","cfskrxfnsuqck.ga","cfskrxfnsuqck.gq","cfskrxfnsuqck.ml","cfskrxfnsuqck.tk","cfyawstoqo.pl","cget0faiili.ru","cget3zaggruz.ru","cget4fiilie.ru","cget6zagruska.ru","cgfrinfo.info","cgfrredi.info","cgget5zaggruz.ru","cgget5zagruz.ru","cghdgh4e56fg.ga","cgilogistics.com","cgnz7xtjzllot9oc.cf","cgnz7xtjzllot9oc.ga","cgnz7xtjzllot9oc.gq","cgnz7xtjzllot9oc.ml","cgnz7xtjzllot9oc.tk","cgredi.info","cgrtstm0x4px.cf","cgrtstm0x4px.ga","cgrtstm0x4px.gq","cgrtstm0x4px.ml","cgrtstm0x4px.tk","ch.tc","cha-cha.org.pl","chaamtravel.org","chaappy9zagruska.ru","chachia.net","chachupa.com","chacuo.net","chaichuang.com","chainlinkthemovie.com","chajnik-bokal.info","chalupaurybnicku.cz","chammakchallo.com","chammy.info","champmails.com","chamsocdavn.com","chamsocvungkin.vn","chancemorris.co.uk","chaneborseoutletmodaitaly.com","chanel-bag.co","chanel-outletbags.com","chanelbagguzu.com","chanelcheapbagsoutlett.com","chanelforsalejp.org","chanelhandbagjp.com","chaneloutlettbagsuus.com","chanelstore-online.com","chaneoutletcheapbags.com","chaneoutletuomoitmini1.com","chaneoutletuomoitmini2.com","changemail.cf","changeofname.net","changesmile.org.ua","changetheway.org.ua","changingemail.com","chanluuuk.com","channel9.cf","channel9.ga","channel9.gq","channel9.ml","chaonamdinh.com","chaosi0t.com","chapar.cf","chaparmail.tk","chappy1faiili.ru","chappy9sagruz.ru","charityforpoorregions.com","charlesjordan.com","charlie.mike.spithamail.top","charlie.omega.webmailious.top","charlielainevideo.com","charminggirl.net","charmlessons.com","chatfap.info","chatjunky.com","chatlines.club","chatlines.wiki","chaussure-air-max.com","chaussure-air-maxs.com","chaussure-airmaxfr.com","chaussure-airmaxs.com","chaussureairmaxshop.com","chaussuresadaptees.com","chaussuresairjordansoldes.com","chaussuresllouboutinpascherfr.com","chaussureslouboutinmagasinffr.com","chaussureslouboutinpascherfrance.com","chaussureslouboutinpascherparis.com","chaussuresslouboutinpascherfrance.com","chaussuresslouboutinppascher.com","chaussurs1ouboutinffrance.com","cheap-beatsbydre-online.com","cheap-carinsurancecanada.info","cheap-carinsuranceuk.info","cheap-carinsuranceusa.info","cheap-coachpurses.us","cheap-ghdaustraliastraightener.com","cheap-inflatables.com","cheap-monsterbeatsdre-headphones.com","cheap-nikefreerunonline.com","cheap-tadacip.info","cheap2trip.com","cheap3ddigitalcameras.com","cheap5831bootsukonsale.co.uk","cheapabeatsheadphones.com","cheapabercrombieuk.com","cheapadidasashoes.com","cheapairjordan.org","cheapairmaxukv.com","cheapantivirussoftwaress.info","cheapbacklink.net","cheapbagsblog.org","cheapbagsmlberryuksale.co.uk","cheapbarbourok.com","cheapbeatsbuynow.com","cheapbedroomsets.info","cheapbootsonuksale1.co.uk","cheapcar.com","cheapcarinsurancerus.co.uk","cheapcarrentalparis.info","cheapchaneljp.com","cheapcheapppes.org","cheapchristianllouboutinshoes.info","cheapchristianlouboutindiscount.com","cheapchristinlouboutinshoesusa.com","cheapcoacbagsoutletusa.com","cheapcoachbagsonlineoutletusa.com","cheapcoachfactoryyonlineus.com","cheapcoachotletstore.com","cheapcoachoutletonlinestoreusa.com","cheapcoachstoreonlinesale.com","cheapcoahoutletstoreonline.com","cheapcoahusa.com","cheapdsgames.org","cheapeffexoronline.net","cheapelectronicreviews.info","cheaperredbottoms.com","cheapessaywriting.top","cheapestnewdriverinsurance.co.uk","cheapestnikeairmaxtz.co.uk","cheapestnikeairmaxzt.co.uk","cheapfacebooklikes.net","cheapfashionbootsa.com","cheapfashionshoesbc.com","cheapfashionshoesbd.com","cheapfashionshoesbg.com","cheapfashionshoesbu.com","cheapfootwear-sale.info","cheapforexrobot.com","cheapgenericciprosure.com","cheapgenericdiflucansure.com","cheapgenericdostinexsure.com","cheapgenericlexaprosure.com","cheapgenericlipitorsure.com","cheapgenericnexiumsure.com","cheapgenericnorvascsure.com","cheapgenericpropeciasure.com","cheapgenericvaltrexsure.com","cheapgenericxenicalsure.com","cheapgenericzoviraxsure.com","cheapggbootsuksale1.com","cheapghdahairstraighteneraghduksale.co.uk","cheapghddssaleukonlinestraighteners.co.uk","cheapghdsaleaustralia.co.uk","cheapghdstraightenerghdsale.co.uk","cheapghdstraighteneruk.co.uk","cheapghduksalee.co.uk","cheapgraphicscards.info","cheapgreenteabags.com","cheapgucchandbags.com","cheapgucchandbas.com","cheapgucchandsbags.com","cheapguccoutlet.com","cheaph.com","cheaphandbagssite.net","cheaphatswholesaleus.com","cheaphorde.com","cheaphub.net","cheapisabelmarantsneakerss.info","cheapjerseysprostore.com","cheapjerseysstoreusa.com","cheapkidstoystore.com","cheapkitchens-direct.co.uk","cheaplinksoflondoncharms.net","cheapllvoutlet.com","cheaplouboutinshoesuksale.co.uk","cheaplouisvuitton-handbags.info","cheaplouisvuittonaubags.com","cheaplouisvuittonukzt.co.uk","cheaplouisvuittoonusoutletusa.com","cheaplvbags.net","cheaplvbagss.com","cheapmenssuitsus.com","cheapmichaelkorsonsaleuus.com","cheapminibootssonsaleuk.co.uk","cheapminibootssonsaleuk1.co.uk","cheapminibootssonsaleuk2.co.uk","cheapmlberryuksalebags.co.uk","cheapmonster098.com","cheapmulberrysalebagsuk.co.uk","cheapn1keshoes.com","cheapnamedeals.info","cheapnetbooksunder200.net","cheapnfjacketsusvip.com","cheapnicedress.net","cheapnikeairmax1shoes.co.uk","cheapnikeairmax1ukvip.co.uk","cheapnikeairmax1vip.co.uk","cheapnikeairmax90shoes.co.uk","cheapnikeairmax90zu.co.uk","cheapnikeairmax95uk.co.uk","cheapnikeairmax95zt.co.uk","cheapnikeairmaxmvp.co.uk","cheapnikeairmaxshoesus.com","cheapnikeairmaxuktz.co.uk","cheapniketrainersuksale.co.uk","cheapnorthfacejacketsoutlet.net","cheapoakley-storeus.com","cheapoakleyoutletvip.com","cheapoakleystoreus.com","cheapoakleysunglasseshotsale.com","cheapoakleysunglassesoutlet.org","cheapoakleysunglasseszt.co.uk","cheapoakleyvipa.com","cheapoakleyzt.co.uk","cheapoksunglassesstore.com","cheapooakleysunglassesussale.com","cheapoutlet10.com","cheapoutlet11.com","cheapoutlet12.com","cheapoutlet3.com","cheapoutlet6.com","cheapoutlet9.com","cheapoutletonlinecoachstore.com","cheappbootsuksale.com","cheappghdstraightenersoutlet1.co.uk","cheappradabagau.com","cheappradaoutlet.us","cheapprescriptionspectacles.in","cheappropeciaonlinepills.com","cheapraybanswayfarersunglassesoutlet.com","cheapraybanukoutlett.com","cheaps5.com","cheapscript.net","cheapshoeslouboutinsale.co.uk","cheapsnowbootsus.com","cheapstomshoesoutlet.com","cheapthelouboutinshoesusa1.com","cheapthenorthfacesalee.com","cheapthermalpaper.com","cheaptheuksaleface.com","cheaptiffanyandcoclub.co.uk","cheaptomshoesoutlet.com","cheaptomshoesoutlet.net","cheaptoothpicks.com","cheaptraineruk.com","cheaptravelguide.net","cheapuggbootonsaleus.com","cheapuggbootsslippers.com","cheapuggbootsuk-store.info","cheapuggoutletmall.com","cheapuggoutletonsale.com","cheapukbootsbuy.com","cheapuknikeairmaxsale.co.uk","cheapukniketrainers.co.uk","cheapukniketrainerssale.co.uk","cheapuksalehandbagsoutletlv.co.uk","cheapukstraightenerssale.info","cheapusbspeakers.info","cheapweekendgetawaysforcouples.com","cheatautomation.com","cheaterboy.com","cheatmail.de","cheatsgenerator.online","cheatsorigin.com","cheattuts.com","chechnya.conf.work","checkbesthosting.com","checkemail.biz","checkmatemail.info","checknew.pw","checknowmail.com","cheerclass.com","cheesepin.info","chef.asana.biz","chekist.info","cheliped.info","chellup.info","chelyab-nedv.ru","chemeng-masdar.com","chemiaakwariowabytom.pl","chemiahurt.eu","chemodanymos.com","chemolysis.info","chemonite.info","chemosorb.info","chengshinv.com","chengshiso.com","chenteraz.flu.cc","cherchesalope.eu","chernogory-nedv.ru","cheska-nedv.ru","chevachi.com","chewcow.com","chewiemail.com","chexsystemsaccount.com","chi-news.ru","chiasehoctap.net","chibakenma.ml","chicagobears-jersey.us","chicasdesnudas69.com","chicasticas.info","chicco.com.es","chicco.org.es","chicha.net","chichichichi.com","chicken-girl.com","chickenadobo.org","chickenkiller.com","chicomaps.com","chiefyagan.com","chielo.com","chihairstraightenerv.com","childsavetrust.org","chilelinks.cl","chilepro.cc","chili-nedv.ru","chilkat.com","china-mattress.org","china-nedv.ru","china183.com","china1mail.com","chinagold.com","chinalww.com","chinanew.com","chinatov.com","chinchillaspam.com","chinese-opportunity.com","chineseclothes12345678.net","chipbankasi.com","chipekii.cf","chipekii.ga","chipkolik.com","chipmunkbox.com","chiragra.pl","chithi.xyz","chithinh.com","chivasso.cf","chivasso.ga","chivasso.gq","chivasso.ml","chivasso.tk","chivvying.2f0s.com","chivvying.luk0.com","chlamydeous.2f0s.com","chloral.2f0s.com","chloral.luk0.com","chlorate.luk0.com","chlordane.luk0.com","chloride.luk0.com","chmail.cf","cho.com","chocklet.us","choco.la","chocolategiftschoice.info","chocolato39mail.biz","chodas.com","chogmail.com","choicecomputertechnologies.com","choicefoods.ru","choicemail1.com","choiceoneem.ga","chokiwnl.men","choladhisdoctor.com","chong-mail.com","chong-mail.net","chong-mail.org","chong-soft.net","chongblog.com","chongseo.cn","chongsoft.cn","chongsoft.com","chongsoft.org","choqr6r4.com","chordguitar.us","chort.eu","chratechbeest.club","chris.burgercentral.us","chrisgomabouna.eu","christian-louboutin.com","christian-louboutin4u.com","christian-louboutinsaleclearance.com","christianlouboutin-uk.info","christianlouboutinaustralia.info","christianlouboutincanada.info","christianlouboutinccmagasin.com","christianlouboutinmagasinffr.com","christianlouboutinmagasinffrance1.com","christianlouboutinmagasinfra.com","christianlouboutinnoutlet.com","christianlouboutinnreplica.com","christianlouboutinopascherfr.com","christianlouboutinoutletstores.info","christianlouboutinpascherenligne.com","christianlouboutinpascherffr.com","christianlouboutinpascherr.com","christianlouboutinportugal.com","christianlouboutinppascher.com","christianlouboutinppaschers.com","christianlouboutinrfrance.com","christianlouboutinsale-shoes.info","christianlouboutinsaleshoes.info","christianlouboutinshoe4sale.com","christianlouboutinsuk.net","christianlouboutinukshoes.info","christianlouboutsshoes.com","christopherfretz.com","chroeppel.com","chromail.info","chubbyteenmodels.com","chukenpro.tk","chumpstakingdumps.com","chuongtrinhcanhac.com","chvtqkb.pl","chwilowkiibezbik.pl","chwilowkiionlinebezbik.pl","chwytyczestochowa.pl","cia-spa.com","cialis-20.com","cialis20mgrxp.us","cialiscouponss.com","cialisgeneric-us.com","cialisgeneric-usa.com","cialisgenericx.us","cialisietwdffjj.com","cialiskjsh.us","cialisonline-20mg.com","cialisonlinenopresx.us","cialisonlinerxp.us","cialispills-usa.com","cialissuperactivesure.com","cialiswithoutadoctorprescriptions.com","cialisy.info","ciaoitaliano.info","cicie.club","cid.kr","ciekawa-strona-internetowa.pl","ciekawastronainternetowa.pl","ciekawostkii.eu","ciekawostkilol.eu","ciensun.co.pl","cigar-auctions.com","cigarshark.com","cilemail.ga","cilo.us","cinderblast.top","cindygarcie.com","cinemalive.info","cioin.pl","ciproonlinesure.com","ciprorxpharma.com","ciqv53tgu.pl","ciromarina.net","cirrushdsite.com","cishanghaimassage.com","cities-countries.ru","citiinter.com.sg","citizencheck.com","citizenlaw.ru","city-girls.org","cityanswer.ru","civilengineertop.com","civilizationdesign.xyz","civilroom.com","civvic.ro","civx.org","ciweltrust33deep.tk","cj2v45a.pl","cjck.eu","cjpeg.com","cjuprf2tcgnhslvpe.cf","cjuprf2tcgnhslvpe.ga","cjuprf2tcgnhslvpe.gq","cjuprf2tcgnhslvpe.ml","cjuprf2tcgnhslvpe.tk","ck12.cf","ck12.ga","ck12.gq","ck12.ml","ck12.tk","ckaazaza.tk","ckatalog.pl","ckdvjizln.pl","ckfibyvz1nzwqrmp.cf","ckfibyvz1nzwqrmp.ga","ckfibyvz1nzwqrmp.gq","ckfibyvz1nzwqrmp.ml","ckfibyvz1nzwqrmp.tk","ckfirmy.pl","ckfsunwwtlhwkclxjah.cf","ckfsunwwtlhwkclxjah.ga","ckfsunwwtlhwkclxjah.gq","ckfsunwwtlhwkclxjah.ml","ckfsunwwtlhwkclxjah.tk","ckiso.com","ckme1c0id1.cf","ckme1c0id1.ga","ckme1c0id1.gq","ckme1c0id1.ml","ckme1c0id1.tk","cko.kr","ckoie.com","ckyxtcva19vejq.cf","ckyxtcva19vejq.ga","ckyxtcva19vejq.gq","ckyxtcva19vejq.ml","ckyxtcva19vejq.tk","cl-cl.org","cl-outletonline.info","cl-pumps.info","cl-pumpsonsale.info","cl.gl","cl0ne.net","cl2004.com","claimab.com","clan.emailies.com","clandest.in","clarkgriswald.net","clarkown.com","clashatclintonemail.com","clashgems2016.tk","classesmail.com","classgess.com","classibooster.com","classicdvdtv.com","classichandbagsforsale.info","classiclouisvuittonsale.com","classicnfljersey.com","classictiffany.com","classicweightloss.org","classiestefanatosmail.net","classificadosdourados.com","classificadosdourados.org","classydeveloper.com","classywebsite.co","claudiabest.com","claus.tk","clay.xyz","clean-calc.de","clean.adriaticmail.com","clean.pro","cleaningcompanybristol.com","cleaningtalk.com","cleansafemail.com","cleantalkorg2.ru","clearancebooth.com","clearmail.online","clearwaterarizona.com","clearwatermail.info","clendere.asia","click-email.com","click-mail.net","click-mail.top","clickanerd.net","clickdeal.co","clickmail.info","clickmenetwork.com","clicks2you.com","clicktrack.xyz","clientesftp55.info","clikhere.net","climate-changing.info","climbing-dancing.info","clinicatbf.com","cliniquedarkspotcorrector.com","clintonemailhearing.com","clipmail.cf","clipmail.eu","clipmail.ga","clipmail.gq","clipmail.ml","clipmail.tk","clipmails.com","cliptik.net","clitor-tube.com","clixser.com","clm-blog.pl","clomid.info","clomidonlinesure.com","clonefbtmc1.club","cloneviptmc1.club","closetonyc.info","clothingbrands2012.info","cloud-mail.net","cloud99.pro","cloud99.top","cloudeflare.com","cloudemail.xyz","cloudhosting.info","cloudmail.gq","cloudmail.tk","cloudmarriage.com","cloudns.asia","cloudns.cc","cloudns.cf","cloudns.cx","cloudns.gq","cloudservicesproviders.net","cloudstat.top","cloudstreaming.info","cloudt12server01.com","cloutlet-vips.com","clpuqprtxtxanx.cf","clpuqprtxtxanx.ga","clpuqprtxtxanx.gq","clpuqprtxtxanx.ml","clpuqprtxtxanx.tk","clrmail.com","cls-audio.club","clubcaterham.co.uk","clubdetirlefaucon.com","clubfanshd.com","clubfier.com","clublife.ga","clubmercedes.net","clubnew.uni.me","clubnews.ru","clubsanswers.ru","clubstt.com","clubuggboots.com","clubzmail.club","clue-1.com","clue.bthow.com","clutchbagsguide.info","clutthob.com","clutunpodli.ddns.info","clwellsale.com","cmail.club","cmail.com","cmail.host","cmail.net","cmail.org","cmawfxtdbt89snz9w.cf","cmawfxtdbt89snz9w.ga","cmawfxtdbt89snz9w.gq","cmawfxtdbt89snz9w.ml","cmawfxtdbt89snz9w.tk","cmc88.tk","cmmgtuicmbff.ga","cmmgtuicmbff.ml","cmmgtuicmbff.tk","cmoki.pl","cmtcenter.org","cn-chivalry.com","cn9n22nyt.pl","cnamed.com","cndps.com","cnew.ir","cnewsgroup.com","cnh.industrial.ga","cnh.industrial.gq","cnhindustrial.cf","cnhindustrial.ga","cnhindustrial.gq","cnhindustrial.ml","cnhindustrial.tk","cnmsg.net","cnn.coms.hk","cnnglory.com","cnovelhu.com","cnsa.biz","cnsds.de","cnshosti.in","co.cc","co.mailboxxx.net","co.uk.com","co1vgedispvpjbpugf.cf","co1vgedispvpjbpugf.ga","co1vgedispvpjbpugf.gq","co1vgedispvpjbpugf.ml","co1vgedispvpjbpugf.tk","coach-outletonlinestores.info","coach-purses.info","coachartbagoutlet.com","coachbagoutletjp.org","coachbagsforsalejp.com","coachbagsonlinesale.com","coachbagsonsalesjp.com","coachbagssalesjp.com","coachbagsshopjp.com","coachcheapjp.com","coachchoooutlet.com","coachfactorybagsjp.com","coachfactorystore-online.us","coachfactorystoreonline.us","coachhandbags-trends.us","coachhandbagsjp.net","coachnewoutlets.com","coachonlinejp.com","coachonlinepurse.com","coachoutletbagscaoutlet.ca","coachoutletlocations.com","coachoutletonline-stores.us","coachoutletonlinestores.info","coachoutletpop.org","coachoutletstore.biz","coachoutletstore9.com","coachoutletvv.net","coachsalejp.com","coachsalestore.net","coachseriesoutlet.com","coachstorejp.net","coachstoresjp.com","coachupoutlet.com","coagro.net","coalhollow.org","coapp.net","coastmagician.com","coatsnicejp.com","cobarekyo1.ml","cobete.cf","cobin2hood.com","cobin2hood.company","cocaine.ninja","coccx1ajbpsz.cf","coccx1ajbpsz.ga","coccx1ajbpsz.gq","coccx1ajbpsz.ml","coccx1ajbpsz.tk","cochatz.ga","cochranmail.men","cock.email","cock.li","cock.lu","coclaims.com","coco.be","cocochaneljapan.com","cocodani.cf","cocoidprzodu.be","cocovpn.com","code-mail.com","codeandscotch.com","coderoutemaroc.com","codeuoso.com","codivide.com","codupmyspace.com","codyfosterandco.com","codyting.com","coepoe.cf","coepoe.ga","coepoe.tk","coepoebete.ga","coepoekorea.ml","coffeelovers.life","coffeepancakewafflebacon.com","coffeeshipping.com","cognata.com","cognitiveways.xyz","coieo.com","coin-host.net","coin-link.com","coin-one.com","coinbroker.club","coincal.org","coindie.com","coinlink.club","coinnews.ru","coino.eu","coiosidkry57hg.gq","cojita.com","cok.3utilities.com","cokeley84406.co.pl","colafanta.cf","colde-mail.com","coldemail.info","coldmail.ga","coldmail.gq","coldmail.ml","coldmail.tk","coleure.com","colinrofe.co.uk","collapse3b.com","collectionmvp.com","collegee.net","collegefornurse.com","colloware.com","coloc.venez.fr","coloncleanse.club","coloncleansereview1.org","coloncleansingplan.com","coloninsta.tk","colorado-nedv.ru","colorweb.cf","com-posted.org","comagrilsa.com","comantra.net","combrotech77rel.gq","combustore.co","combyo.com","come-on-day.pw","come-to-win.com","comececerto.com","comedimagrire24.it","comella54173.co.pl","comenow.info","comeonday.pw","comeonfind.me","comeporon.ga","comespiaresms.info","comespiareuncellulare.info","comespiareuncellularedalpc.info","cometoclmall.com","comfortableshoejp.com","comfytrait.xyz","comilzilla.org","comm.craigslist.org","comments2g.com","communityans.ru","communitybuildingworks.xyz","communityforumcourse.com","comoestudarsozinho.com.br","comohacerunmillon.com","comolohacenpr.com","companytitles.com","compaq.com","compare-carinsurancecanada.info","compare-carinsuranceusa.info","comparedigitalcamerassidebyside.org","comparegoodshoes.com","comparepetinsurance.biz","compareshippingrates.org","compartedata.com.ar","comparteinformacion.com.ar","complete-hometheater.com","completegolfswing.com","compraresteroides.xyz","compscorerric.eu","comptophone.net","comptravel.ru","compuhelper.org","computations.me","computer-service-in-heidelberg.de","computer-service-in-heilbronn.de","computer-service-sinsheim.de","computercrown.com","computerengineering4u.com","computerhardware2012.info","computerinformation4u.com","computerlookup.com","computerrepairinfosite.com","computerrepairredlands.com","computersoftware2012.info","computerspeakers22.com","coms.hk","comsafe-mail.net","comspotsforsale.info","comwest.de","concealed.company","concetomou.eu","conciergenb.pl","concretepolishinghq.com","condating.info","condovallarta.info","conf.work","conferencecallfree.net","confidential.life","config.work","confirm.live","congthongtin247.net","connectdeshi.com","connecticut-nedv.ru","connectmail.online","connriver.net","conone.ru","consfant.com","consimail.com","conspicuousmichaelkors.com","conspiracyfreak.com","constantinsbakery.com","constellational.com","constright.ru","consultant.com","consultingcorp.org","consumerriot.com","contabilitate.ws","contacterpro.com","contactmanagersuccess.com","contactout1000.ga","containergroup.com.au","contbay.com","contentwanted.com","continumail.com","contmy.info","contopo.com","contracommunications.com","contractor.net","contrasto.cu.cc","controlinbox.com","controllerblog.com","contumail.com","conventionpreview.com","conventionstrategy.win","conversejapan.com","convert-five.ru","convexmirrortop.com","coobz0gobeptmb7vewo.cf","coobz0gobeptmb7vewo.ga","coobz0gobeptmb7vewo.gq","coobz0gobeptmb7vewo.ml","coobz0gobeptmb7vewo.tk","coofy.net","cookiealwayscrumbles.co.uk","cookiecooker.de","cookiepuss.info","cool-your.pw","cool.fr.nf","coolandwacky.us","coolbikejp.com","coolcarsnews.net","coolemailer.info","coolemails.info","coolimpool.org","cooljordanshoesale.com","coolmail.com","coolmail.ooo","coolmailcool.com","coolmailer.info","coolmanuals.com","coolprototyping.com","coolstyleusa.com","coolvesti.ru","coolyarddecorations.com","coolyour.pw","copastore.co","copd.edu","copjlix.de.vc","copperemail.com","copycashvalve.com","copymanprintshop.com","copyright-gratuit.net","coqmail.com","cora.marketdoors.info","coreclip.com","coronachurch.org","coronacoffee.com","corp.ereality.org","correo.blogos.net","cortex.kicks-ass.net","coslots.gdn","cosmeticsurgery.com","cosmicart.ru","cosmorph.com","cosmos.com","costinluis.com","cosynookoftheworld.com","cotocheetothecat12.com","cottagein.ru","cottonsleepingbags.com","cotynet.pl","couchtv.biz","countmoney.ru","countryhotel.org","coupon-reviewz.com","couponhouse.info","couponm.net","couponmoz.org","couponsgod.in","couponslauncher.info","courriel.fr.nf","courrieltemporaire.com","course-fitness.com","course.nl","courseair.com","coursesall.ru","courtrf.com","cousinit.mooo.com","covermygodfromsummer.com","coveryourpills.org","covfefe-mail.gq","covfefe-mail.tk","cowabungamail.com","cowaway.com","cowcell.com","cowgirljules.com","cowokbete.ga","cowokbete.ml","cowstore.net","cowstore.org","coxbete.cf","coxbete99.cf","coxnet.cf","coxnet.ga","coxnet.gq","coxnet.ml","coza.ro","cpaoz.com","cpmail.life","cpmm.ru","cpolp.com","cpsystems.ru","cpt-emilie.org","cpuk3zsorllc.cf","cpuk3zsorllc.ga","cpuk3zsorllc.gq","cpuk3zsorllc.ml","cpuk3zsorllc.tk","cqutssntx9356oug.cf","cqutssntx9356oug.ga","cqutssntx9356oug.gq","cqutssntx9356oug.ml","cqutssntx9356oug.tk","cr.cloudns.asia","cr219.com","cr3wmail.sytes.net","cr3wxmail.servequake.com","cr97mt49.com","crablove.in","crackingaccounts.ga","craet.top","crankengine.net","crankhole.com","crankmails.com","crap.kakadua.net","crapmail.org","crashkiller.ovh","crastination.de","crator.com","crayonseo.com","crazespaces.pw","crazy-xxx.ru","crazyclothes.ru","crazydoll.us","crazydomains.com","crazyijustcantseelol.com","crazykids.info","crazymail.info","crazymail.online","crazymailing.com","crazyshitxszxsa.com","crazyt.tk","cre8to6blf2gtluuf.cf","cre8to6blf2gtluuf.ga","cre8to6blf2gtluuf.gq","cre8to6blf2gtluuf.ml","cre8to6blf2gtluuf.tk","cream.pink","creamail.info","creamcheesefruitdipps.com","creativethemeday.com","creazionisa.com","credit-alaconsommation.com","credit-finder.info","credit-line.pl","credit-online.mcdir.ru","creditcardconsolidation.cc","creditcardg.com","creditorexchange.com","creditreportreviewblog.com","creekbottomfarm.com","creo.cloudns.cc","creo.nctu.me","crescendu.com","cretalscowad.xyz","crezjumevakansii20121.cz.cc","cribafmasu.co.tv","criminal-lawyer-attorney.biz","criminal-lawyer-texas.net","criminalattorneyhouston.info","criminalattorneyinhouston.info","criminalattorneyinhouston.org","criminalisticsdegree.com","criminallawyersinhoustontexas.com","criminalsearch1a.com","crimright.ru","crisiscrisis.co.uk","crmlands.net","crmrc.us","croatia-nedv.ru","crobinkson.hu","cronicasdepicnic.com","cropuv.info","cropyloc.com","crosmereta.eu","cross-law.ga","cross-law.gq","crossfirecheats.org","crossmail.bid","crossroadsmail.com","crossyroadhacks.com","crotslep.ml","crotslep.tk","croudmails.info","crow.gq","crow.ml","crowd-mail.com","crowity.com","crub.cf","crub.ga","crub.gq","crub.ml","crub.tk","crublowjob20127.co.tv","crublowjob20127.com","crublowjob20129.co.tv","crufreevideo20123.cz.cc","crushdv.com","crushes.com","crusthost.com","crutenssi20125.co.tv","cruxmail.info","crydeck.com","crymail2.com","cryp.email","crypemail.info","crypstats.top","crypto-net.club","crypto-nox.com","crypto.tyrex.cf","cryptolist.cf","cryptonet.top","cryptontrade.ga","cryptoszone.ga","cs-murzyn.pl","cs4h4nbou3xtbsn.cf","cs4h4nbou3xtbsn.ga","cs4h4nbou3xtbsn.gq","cs4h4nbou3xtbsn.ml","cs4h4nbou3xtbsn.tk","cs5xugkcirf07jk.cf","cs5xugkcirf07jk.ga","cs5xugkcirf07jk.gq","cs5xugkcirf07jk.ml","cs5xugkcirf07jk.tk","cs6688.com","cs715a3o1vfb73sdekp.cf","cs715a3o1vfb73sdekp.ga","cs715a3o1vfb73sdekp.gq","cs715a3o1vfb73sdekp.ml","cs715a3o1vfb73sdekp.tk","csdinterpretingonline.com","csfav4mmkizt3n.cf","csfav4mmkizt3n.ga","csfav4mmkizt3n.gq","csfav4mmkizt3n.ml","csfav4mmkizt3n.tk","csh.ro","csi-miami.cf","csi-miami.ga","csi-miami.gq","csi-miami.ml","csi-miami.tk","csi-newyork.cf","csi-newyork.ga","csi-newyork.gq","csi-newyork.ml","csi-newyork.tk","csiplanet.com","csoftmail.cn","cspointblank.com","cssu.edu","csuzetas.com","cszbl.com","ct345fgvaw.cf","ct345fgvaw.ga","ct345fgvaw.gq","ct345fgvaw.ml","ct345fgvaw.tk","ctmailing.us","ctos.ch","ctrobo.com","cts-lk-i.cf","cts-lk-i.ga","cts-lk-i.gq","cts-lk-i.ml","cts-lk-i.tk","ctshp.org","cttake1fiilie.ru","ctycter.com","ctyctr.com","ctypark.com","ctznqsowm18ke50.cf","ctznqsowm18ke50.ga","ctznqsowm18ke50.gq","ctznqsowm18ke50.ml","ctznqsowm18ke50.tk","cu.cc","cu8wzkanv7.cf","cu8wzkanv7.gq","cu8wzkanv7.ml","cu8wzkanv7.tk","cuarl.com","cuasotrithuc.com","cubb6mmwtzbosij.cf","cubb6mmwtzbosij.ga","cubb6mmwtzbosij.gq","cubb6mmwtzbosij.ml","cubb6mmwtzbosij.tk","cubiclink.com","cuckmere.org.uk","cucummail.com","cuddleflirt.com","cuelmail.info","cuirushi.org","cuisine-recette.biz","cul0.cf","cul0.ga","cul0.gq","cul0.ml","cul0.tk","culdemamie.com","cult-reno.ru","cultmovie.com","cum.sborra.tk","cumallover.me","cumangeblog.net","cumanuallyo.com","cumbeeclan.com","cumonfeet.org","cungmua.vn","cungmuachung.net","cungmuachungnhom.com","cungsuyngam.com","cungtam.com","cuoiz.com","cuoly.com","cuongvumarketingseo.com","cupf6mdhtujxytdcoxh.cf","cupf6mdhtujxytdcoxh.ga","cupf6mdhtujxytdcoxh.gq","cupf6mdhtujxytdcoxh.ml","cupf6mdhtujxytdcoxh.tk","cuponhostgator.org","curinglymedisease.com","curiousitivity.com","curletter.com","curlhph.tk","currencymeter.com","currentmortgageratescentral.com","currymail.bid","currymail.men","curryworld.de","curso.tech","cursoconsertodecelular.top","cursodemicropigmentacao.us","curtinicheme-sc.com","cushingsdisease.in","cust.in","custom-wp.com","custom12.tk","customersupportdepartment.ga","customeyeslasik.com","customiseyourpc.xyz","customizedfatlossreviews.info","customlogogolf-balls.com","customs2g3.com","customsnapbackcap.com","cuteblanketdolls.com","cuteboyo.com","cutemailbox.com","cutey.com","cutout.club","cuvox.de","cvd8idprbewh1zr.cf","cvd8idprbewh1zr.ga","cvd8idprbewh1zr.gq","cvd8idprbewh1zr.ml","cvd8idprbewh1zr.tk","cveiguulymquns4m.cf","cveiguulymquns4m.ga","cveiguulymquns4m.gq","cveiguulymquns4m.ml","cveiguulymquns4m.tk","cvelbar.com","cvijqth6if8txrdt.cf","cvijqth6if8txrdt.ga","cvijqth6if8txrdt.gq","cvijqth6if8txrdt.ml","cvijqth6if8txrdt.tk","cvndr.com","cvs-couponcodes.com","cvurb5g2t8.cf","cvurb5g2t8.ga","cvurb5g2t8.gq","cvurb5g2t8.ml","cvurb5g2t8.tk","cvwvxewkyw.pl","cw8xkyw4wepqd3.cf","cw8xkyw4wepqd3.ga","cw8xkyw4wepqd3.gq","cw8xkyw4wepqd3.ml","cw8xkyw4wepqd3.tk","cw9bwf5wgh4hp.cf","cw9bwf5wgh4hp.ga","cw9bwf5wgh4hp.gq","cw9bwf5wgh4hp.ml","cw9bwf5wgh4hp.tk","cwdt5owssi.cf","cwdt5owssi.ga","cwdt5owssi.gq","cwdt5owssi.ml","cwdt5owssi.tk","cwerwer.net","cwkdx3gi90zut3vkxg5.cf","cwkdx3gi90zut3vkxg5.ga","cwkdx3gi90zut3vkxg5.gq","cwkdx3gi90zut3vkxg5.ml","cwkdx3gi90zut3vkxg5.tk","cx.de-a.org","cx4div2.pl","cxboxcompone20121.cx.cc","cxcc.cf","cxcc.gq","cxcc.ml","cxcc.tk","cxpcgwodagut.cf","cxpcgwodagut.ga","cxpcgwodagut.gq","cxpcgwodagut.ml","cxpcgwodagut.tk","cxvixs.com","cxvxcv8098dv90si.ru","cxvxecobi.pl","cyber-host.net","cyber-innovation.club","cyber-phone.eu","cyberhohol.tk","cyberian.net","cybersex.com","cylab.org","cyng.com","czarny.agencja-csk.pl","czblog.info","czeescibialystok.pl","czeta.wegrow.pl","czpanda.cn","czqjii8.com","czuj-czuj.pl","czyjtonumer.com","czystydywan.elk.pl","d-link.cf","d-link.ga","d-link.gq","d-link.ml","d-link.tk","d.megafon.org.ua","d.polosburberry.com","d.seoestore.us","d10.michaelkorssaleoutlet.com","d123.com","d154cehtp3po.cf","d154cehtp3po.ga","d154cehtp3po.gq","d154cehtp3po.ml","d154cehtp3po.tk","d1rt.net","d1yun.com","d2pwqdcon5x5k.cf","d2pwqdcon5x5k.ga","d2pwqdcon5x5k.gq","d2pwqdcon5x5k.ml","d2pwqdcon5x5k.tk","d2v3yznophac3e2tta.cf","d2v3yznophac3e2tta.ga","d2v3yznophac3e2tta.gq","d2v3yznophac3e2tta.ml","d2v3yznophac3e2tta.tk","d32ba9ffff4d.servebeer.com","d3account.com","d3gears.com","d3p.dk","d4eclvewyzylpg7ig.cf","d4eclvewyzylpg7ig.ga","d4eclvewyzylpg7ig.gq","d4eclvewyzylpg7ig.ml","d4eclvewyzylpg7ig.tk","d58pb91.com","d5fffile.ru","d5ipveksro9oqo.cf","d5ipveksro9oqo.ga","d5ipveksro9oqo.gq","d5ipveksro9oqo.ml","d5ipveksro9oqo.tk","d5wwjwry.com.pl","d75d8ntsa0crxshlih.cf","d75d8ntsa0crxshlih.ga","d75d8ntsa0crxshlih.gq","d75d8ntsa0crxshlih.ml","d75d8ntsa0crxshlih.tk","d7bpgql2irobgx.cf","d7bpgql2irobgx.ga","d7bpgql2irobgx.gq","d7bpgql2irobgx.ml","d8u.us","d8wjpw3kd.pl","d8zzxvrpj4qqp.cf","d8zzxvrpj4qqp.ga","d8zzxvrpj4qqp.gq","d8zzxvrpj4qqp.ml","d8zzxvrpj4qqp.tk","d9faiili.ru","d9jdnvyk1m6audwkgm.cf","d9jdnvyk1m6audwkgm.ga","d9jdnvyk1m6audwkgm.gq","d9jdnvyk1m6audwkgm.ml","d9jdnvyk1m6audwkgm.tk","d9tl8drfwnffa.cf","d9tl8drfwnffa.ga","d9tl8drfwnffa.gq","d9tl8drfwnffa.ml","d9tl8drfwnffa.tk","d9wow.com","da-da-da.cf","da-da-da.ga","da-da-da.gq","da-da-da.ml","da-da-da.tk","daabox.com","daaiyurongfu.com","daawah.info","dab.ro","dabestizshirls.com","dabjam.com","dabrigs.review","dacarirato.com.my","dacha-24.ru","daciasandero.cf","daciasandero.ga","daciasandero.gq","daciasandero.ml","daciasandero.tk","dacoolest.com","dad.biprep.com","dadbgspxd.pl","dadd.kikwet.com","daditrade.com","daemoniac.info","daemsteam.com","daewoo.gq","daewoo.ml","dafardoi1.com","dafgtddf.com","dafinally.com","dafrem3456ails.com","daftarjudimixparlay.com","dagagd.pl","dahongying.net","daibond.info","daiettodorinku.com","daiklinh.com","daily-email.com","dailyautoapprovedlist.blogmyspot.com","dailyhealthclinic.com","dailyquinoa.com","dailysocialpro.com","daimlerag.cf","daimlerag.ga","daimlerag.gq","daimlerag.ml","daimlerag.tk","daimlerchrysler.cf","daimlerchrysler.gq","daimlerchrysler.ml","dainaothiencung.vn","daintly.com","daisapodatafrate.com","dait.cf","dait.ga","dait.gq","dait.ml","dait.tk","dakgunaqsn.pl","dalatvirginia.com","daleloan.com","dalevillevfw.com","daliamodels.pl","dalins.com","dallas.gov","dallascowboysjersey.us","daly.malbork.pl","damai.webcam","damail.ga","damanik.ga","damanik.tk","dammexe.net","damnser.co.pl","damnthespam.com","damptus.co.pl","danamail.com","dance-king-man.com","dancemanual.com","danceml.win","dancethis.org.ua","dandanmail.com","dandantwo.com","dandikmail.com","dandinoo.com","danica1121.club","danirafsanjani.com","daniya-nedv.ru","dankrangan77jui.ga","danns.cf","dannyhosting.com","dantri.com","danzeralla.com","daolemi.com","daotaolamseo.com","daphnee1818.site","daricadishastanesi.com","dark-tempmail.zapto.org","dark.lc","darkestday.tk","darkharvestfilms.com","darknode.org","darkstone.com","darkwulu79jkl.ga","darlinggoodsjp.com","darmowedzwonki.waw.pl","daryxfox.net","dasarip.ru","dasdasdascyka.tk","dash-pads.com","dashaustralia.com","dashoffer.com","dasymeter.info","daszyfrkfup.targi.pl","dataarca.com","datab.info","datafres.ru","datarca.com","dataretrievalharddrive.net","datasoma.com","datauoso.com","datawurld.com","datazo.ca","datchka.ru","datingbio.info","datingbit.info","datingcloud.info","datingcomputer.info","datingcon.info","datingeco.info","datingfood.info","datinggeo.info","datinggreen.info","datinghyper.info","datinginternet.info","datingphotos.info","datingpix.info","datingplaces.ru","datingreal.info","datingshare.info","datingstores.info","datingsun.info","datingtruck.info","datingwebs.info","datingworld.com","datrr.gq","datum2.com","daughertymail.bid","davecooke.eu","davesdadismyhero.com","davidkoh.net","davidlcreative.com","daviiart.com","dawetgress72njx.cf","dawin.com","day-one.pw","dayibiao.com","dayloo.com","daymail.cf","daymail.ga","daymail.gq","daymail.life","daymail.men","daymail.ml","daymail.tk","daymailonline.com","dayone.pw","dayrep.com","daysofourlivesrecap.com","daytondonations.com","db214.com","db2zudcqgacqt.cf","db2zudcqgacqt.ga","db2zudcqgacqt.gq","db2zudcqgacqt.ml","db4t534.cf","db4t534.ga","db4t534.gq","db4t534.ml","db4t534.tk","db4t5e4b.cf","db4t5e4b.ga","db4t5e4b.gq","db4t5e4b.ml","db4t5e4b.tk","db4t5tes4.cf","db4t5tes4.ga","db4t5tes4.gq","db4t5tes4.ml","db4t5tes4.tk","dbataturkioo.com","dbawgrvxewgn3.cf","dbawgrvxewgn3.ga","dbawgrvxewgn3.gq","dbawgrvxewgn3.ml","dbawgrvxewgn3.tk","dbo.kr","dbook.pl","dboss3r.info","dbot2zaggruz.ru","dbrflk.com","dbunker.com","dbz5mchild.com","dc-business.com","dccsvbtvs32vqytbpun.ga","dccsvbtvs32vqytbpun.ml","dccsvbtvs32vqytbpun.tk","dcemail.com","dcemail.men","dcndiox5sxtegbevz.cf","dcndiox5sxtegbevz.ga","dcndiox5sxtegbevz.gq","dcndiox5sxtegbevz.ml","dcndiox5sxtegbevz.tk","ddboxdexter.com","ddcrew.com","dddoudounee.com","ddi-solutions.com","ddinternational.net","ddividegs.com","ddmail.win","ddn.kz","ddnsfree.com","ddosed.us","ddoudounemonclerboutiquefr.com","de-a.org","de-fake.instafly.cf","de-farmacia.com","de.introverted.ninja","de.newhorizons.gq","de.sytes.net","de.vipqq.eu.org","de4ce.gq","de5.pl","de5m7y56n5.cf","de5m7y56n5.ga","de5m7y56n5.gq","de5m7y56n5.ml","de5m7y56n5.tk","dea-love.net","dea.soon.it","deadaddress.com","deadchildren.org","deadfake.cf","deadfake.ga","deadfake.ml","deadfake.tk","deadsmooth.info","deadspam.com","deagot.com","dealcungmua.info","dealerlms.com","dealgiare.info","dealja.com","dealmuachung.info","dealpop.us","dealrek.com","dealsontheweb.org","dealsplace.info","dealsway.org","dealzing.info","deathfilm.com","deathward.info","debatetayo.com","debonnehumeur.com","deborahosullivan.com","debsbluemoon.com","debthelp.biz","debtloans.org","debtrelief.us","debutter.com","decacerata.info","decginfo.info","deckerniles.com","deco-rator.edu","decoratefor.com","decoratinglfe.info","decoymail.mx","dedmail.com","deedinvesting.info","deekayen.us","deepcleanac.com","deepstaysm.org.ua","deerecord.org.ua","deermokosmetyki-a.pl","defeatmyticket.com","defebox.com","definingjtl.com","defomail.com","defqon.ru","degradedfun.net","deisanvu.gov","deishmann.pl","deiter.merkez34.com","dejamedia.com","dejavafurniture.com","dejtinggranska.com","dekatri.cf","dekatri.ga","dekatri.gq","dekatri.ml","dekaufen.com","dekoracjeholajda.pl","del58.com","delaware-nedv.ru","delayload.com","delayload.net","delicacybags.com","delikkt.de","deliverme.top","dell-couponcodes.com","delorieas.cf","delorieas.ml","delta.xray.thefreemail.top","deltabeta.livefreemail.top","deltacplus.info","deltakilo.ezbunko.top","deltaoscar.livefreemail.top","demandfull.date","demandsxz.com","demen.ml","demesmaeker.fr","deminyx.eu","demirprenses.com","demmail.com","demonclerredi.info","demotivatorru.info","demotywator.com","dena.ga","dena.ml","denarcteel.com","denbaker.com","dendride.ru","dengekibunko.cf","dengekibunko.ga","dengekibunko.gq","dengekibunko.ml","denizenation.info","denizlisayfasi.com","denniscoltpackaging.com","dennisss.top","dennmail.win","dennymail.host","density2v.com","denstudio.pl","dental-and-spa.pl","dentaljazz.info","denverareadirectory.com","denverbroncosproshoponline.com","denverbroncosproteamjerseys.com","denyfromall.org","deo.edu","depadua.eu","depaduahootspad.eu","der-kombi.de","der.madhuratri.com","derbydales.co.uk","derder.net","derisuherlan.info","derkombi.de","derliforniast.com","derluxuswagen.de","dermacareguide.com","dermacoat.com","dermalmedsblog.com","dermatendreview.net","dermatitistreatmentx.com","dermatologistcliniclondon.com","dermpurereview.com","deromise.tk","dertul.xyz","des-law.com","desaptoh07yey.gq","descher.ml","descrive.info","desertdigest.com","deshivideos.com","design199.com","designerbagsoutletstores.info","designerhandbagstrends.info","designersadda.com","designerwatches-tips.info","designerwatchestips.info","designwigs.info","desksonline.com.au","desmo.cf","desmo.ga","desmo.gq","desocupa.org","desoz.com","despam.it","despammed.com","destructiveblog.com","deszn1d5wl8iv0q.cf","deszn1d5wl8iv0q.ga","deszn1d5wl8iv0q.gq","deszn1d5wl8iv0q.ml","deszn1d5wl8iv0q.tk","detabur.com","detektywenigma.pl","detexx.com","detroitlionsjerseysstore.us","detrude.info","dettol.cf","dettol.ga","dettol.gq","dettol.ml","dettol.tk","deucemail.com","deutsch-nedv.ru","dev-null.cf","dev-null.ga","dev-null.gq","dev-null.ml","devax.pl","devdating.info","developan.ru","developfuel.com","developmentwebsite.co.uk","devicefoods.ru","devinmariam.coayako.top","devnullmail.com","devset.space","devushka-fo.com","dew.com","dew007.com","deworconssoft.xyz","dextm.ro","deyom.com","dfagsfdasfdga.com","dfat0fiilie.ru","dfat0zagruz.ru","dfat1zagruska.ru","dfatt6zagruz.ru","dfdfdfdf.com","dfdgfsdfdgf.ga","dfet356ads1.cf","dfet356ads1.ga","dfet356ads1.gq","dfet356ads1.ml","dfet356ads1.tk","dff55.dynu.net","dfg456ery.ga","dfg6.kozow.com","dfgds.in","dfgeqws.com","dfgggg.org","dfgh.net","dfghj.ml","dfgtbolotropo.com","dfigeea.com","dfjunkmail.co.uk","dfoofmail.com","dfoofmail.net","dfooshjqt.pl","dfremails.com","dftrekp.com","dfworld.net","dfy2413negmmzg1.ml","dfy2413negmmzg1.tk","dfyxmwmyda.pl","dg8899.com","dg9.org","dgbhhdbocz.pl","dgd.mail-temp.com","dgdbmhwyr76vz6q3.cf","dgdbmhwyr76vz6q3.ga","dgdbmhwyr76vz6q3.gq","dgdbmhwyr76vz6q3.ml","dgdbmhwyr76vz6q3.tk","dget1fajli.ru","dget8fajli.ru","dgfghgj.com.us","dgget0zaggruz.ru","dgget1loaadz.ru","dgjhg.com","dgjhg.net","dgnghjr5ghjr4h.cf","dgpqdpxzaw.cf","dgpqdpxzaw.ga","dgpqdpxzaw.gq","dgpqdpxzaw.ml","dgpqdpxzaw.tk","dhapy7loadzzz.ru","dharmatel.net","dhbusinesstrade.info","dhead3r.info","dhgbeauty.info","dhl-uk.cf","dhl-uk.ga","dhl-uk.gq","dhl-uk.ml","dhl-uk.tk","dhlkurier.pl","dhm.ro","dhmu5ae2y7d11d.cf","dhmu5ae2y7d11d.ga","dhmu5ae2y7d11d.gq","dhmu5ae2y7d11d.ml","dhmu5ae2y7d11d.tk","dhruvseth.com","dhsjyy.com","dhy.cc","diablo3character.com","diablo3goldsite.com","diablo3goldsupplier.com","diabloaccounts.net","diablocharacter.com","diablogears.com","diablogold.net","diacamelia.online","diademail.com","diadiemquanan.com","diadisolmi.xyz","diafporidde.xyz","dialogus.com","dialysis-attorney.com","dialysis-injury.com","dialysis-lawyer.com","dialysisattorney.info","dialysislawyer.info","diamantservis.ru","diamondfacade.net","diane35.pl","dianetaylor.pop3mail.top","dianhabis.ml","diapaulpainting.com","diaperbagbackpacks.info","diaryofsthewholesales.info","dibbler1.pl","dibbler2.pl","dibbler3.pl","dibbler4.pl","dibbler5.pl","dibbler6.pl","dibbler7.pl","dichalorli.xyz","dichvuseothue.com","dicksinhisan.us","dicksinmyan.us","dicountsoccerjerseys.com","dicyemail.com","didarcrm.com","didikselowcoffee.cf","didikselowcoffee.ga","didikselowcoffee.gq","didikselowcoffee.ml","diegewerbeseiten.com","diendanhocseo.com","diennuocnghiahue.com","dietamedia.ru","dietingadvise.club","dietpill-onlineshop.com","dietsecrets.edu","dietsolutions.com","dietysuplementy.pl","dieukydieuophonggiamso7.com","diffamr.com","diflucanrxmeds.com","digdown.xyz","diggmail.club","digibeat.pl","digicures.com","digier365.pl","digimusics.com","digiprice.co","digital-email.com","digital-frame-review.com","digital-ground.info","digital-message.com","digital-work.net","digitalesbusiness.info","digitalfocuses.com","digitalmail.info","digitalmariachis.com","digitalobscure.info","digitalsanctuary.com","digitalsc.edu","digitalseopackages.com","digitex.ga","digitex.gq","digiuoso.com","diigo.club","dikixty.gr","dikriemangasu.cf","dikriemangasu.ga","dikriemangasu.gq","dikriemangasu.ml","dikriemangasu.tk","dildosfromspace.com","dilherute.pl","dililimail.com","dilts.ru","dim-coin.com","dimimail.ga","diminbox.info","dindon4u.gq","dingbone.com","dinkmail.com","dinksai.ga","dinksai.ml","dinogam.com","dinorc.com","dinotek.top","dinoza.pro","dinozy.net","dinteria.pl","diornz.com","diosasdelatierra.com","dioscolwedddas.3-a.net","dipes.com","diplomnaya-rabota.com","diqalaciga.warszawa.pl","dir43.org","direct-mail.info","direct-mail.top","directmail.top","directmail24.net","directmonitor.nl","directoryblog.info","directpmail.info","direktorysubcep.com","direugg.cc","diromail29.biz","dirtmail.ga","dirtymailer.cf","dirtymailer.ga","dirtymailer.gq","dirtymailer.ml","dirtymailer.tk","dirtymax.com","dirtysex.top","disaq.com","disario.info","disbox.net","disbox.org","discard-email.cf","discard.cf","discard.email","discard.ga","discard.gq","discard.ml","discard.tk","discardmail.com","discardmail.de","discofan.com","disconorma.pl","discopied.com","discoplus.ca","discord.ml","discordmail.com","discos4.com","discountappledeals.com","discountbuyreviews.org","discountcouponcodes2013.com","discountnikejerseysonline.com","discountoakleysunglassesokvip.com","discounts5.com","discountsmbtshoes.com","discountsplace.info","discovercheats.com","discoverwatch.com","discoverylanguages.com","discreetfuck.top","discussmusic.ru","dish-tvsatellite.com","dishtvpackage.com","disign-concept.eu","disign-revelation.com","dislike.cf","disneyfox.cf","displaylightbox.com","displays2go.com","displaystar.com","dispmailproject.info","dispo.in","dispomail.eu","dispomail.xyz","disposable-email.ml","disposable-mail.com","disposable.cf","disposable.dhc-app.com","disposable.ga","disposable.ml","disposableaddress.com","disposableemail.org","disposableemailaddresses.com","disposableemailaddresses.emailmiser.com","disposableinbox.com","disposablemail.space","disposablemail.top","disposablemails.com","dispose.it","disposeamail.com","disposemail.com","dispostable.com","disputespecialists.com","distdurchbrumi.xyz","diujungsenja.online","divad.ga","divan-matras.info","diveexpeditions.com","divermail.com","diverseness.ru","diversify.us","divestops.com","dividendxk.com","divinois.com","divismail.ru","divorsing.ru","diwaq.com","diy-seol.net","diyombrehair.com","djdwzaty3tok.cf","djdwzaty3tok.ga","djdwzaty3tok.gq","djdwzaty3tok.ml","djdwzaty3tok.tk","djerseys.com","djmftaggb.pl","djnkkout.tk","djrobbo.net","dk3vokzvucxolit.cf","dk3vokzvucxolit.ga","dk3vokzvucxolit.gq","dk3vokzvucxolit.ml","dk3vokzvucxolit.tk","dkert2mdi7sainoz.cf","dkert2mdi7sainoz.ga","dkert2mdi7sainoz.gq","dkert2mdi7sainoz.ml","dkert2mdi7sainoz.tk","dkinodrom20133.cx.cc","dkkffmail.com","dkljdf.eu","dkmont.dk","dko.kr","dkpnpmfo2ep4z6gl.cf","dkpnpmfo2ep4z6gl.ga","dkpnpmfo2ep4z6gl.gq","dkpnpmfo2ep4z6gl.ml","dkpnpmfo2ep4z6gl.tk","dkqqpccgp.pl","dksureveggie.com","dkywquw.pl","dl163.com","dl812pqedqw.cf","dl812pqedqw.ga","dl812pqedqw.gq","dl812pqedqw.ml","dl812pqedqw.tk","dle.funerate.xyz","dlemail.ru","dlfiles.ru","dliiv71z1.mil.pl","dlink.cf","dlink.gq","dlj6pdw4fjvi.cf","dlj6pdw4fjvi.ga","dlj6pdw4fjvi.gq","dlj6pdw4fjvi.ml","dlj6pdw4fjvi.tk","dll32.ru","dlmkme.ga","dlmkme.ml","dlpt7ksggv.cf","dlpt7ksggv.ga","dlpt7ksggv.gq","dlpt7ksggv.ml","dlpt7ksggv.tk","dlwdudtwlt557.ga","dlzltyfsg.pl","dm.w3internet.co.uk","dm.w3internet.co.ukexample.com","dm9bqwkt9i2adyev.ga","dm9bqwkt9i2adyev.ml","dm9bqwkt9i2adyev.tk","dma.in-ulm.de","dma2x7s5w96nw5soo.cf","dma2x7s5w96nw5soo.ga","dma2x7s5w96nw5soo.gq","dma2x7s5w96nw5soo.ml","dma2x7s5w96nw5soo.tk","dmail.kyty.net","dmail.unrivaledtechnologies.com","dmaildd.com","dmailpro.net","dmailx.com","dmaji.ddns.net","dmaji.ml","dmarc.ro","dmc-12.cf","dmc-12.ga","dmc-12.gq","dmc-12.ml","dmc-12.tk","dmcd.ctu.edu.gr","dmfjrgl.turystyka.pl","dmftfc.com","dmitext.net","dmmhosting.co.uk","dmoffers.co","dmosi.com","dmslovakiat.com","dmtc.edu.pl","dmtu.ctu.edu.gr","dnabgwev.pl","dnatechgroup.com","dndbs.net","dndent.com","dns-cloud.net","dns-privacy.com","dns123.org","dnsabr.com","dnsdeer.com","dnses.ro","doanart.com","doatre.com","dob.jp","dobitocudeponta.com","dobleveta.com","dobrainspiracja.pl","dobramama.pl","dobrapoczta.com","dobroinatura.pl","dobry-procent-lokaty.com.pl","dobrytata.pl","doc-mail.net","docent.ml","docmail.com","docmail.cz","docs.coms.hk","doctordieu.xyz","doctorlane.info","doctorsmb.info","doctovc.com","docu.me","docx-expert.online","dodachachayo.com","dodgeit.com","dodgemail.de","dodgit.com","dodgit.org","dodgitti.com","dodnitues.gr","dodsi.com","dofuskamasgenerateurz.fr","dofutlook.com","dog.coino.pl","dogcrate01.com","dogfishmail.com","doggy-lovers-email.bid","doggyloversemail.bid","doghairprotector.com","dogiloveniggababydoll.com","dogsupplies4sale.com","dohmail.info","doibaietisiofatafoxy.com","doiea.com","doimmn.com","dokifriends.info","dokisaweer.cz.cc","doktoremail.eu","dollargiftcards.com","dollscountry.ru","dolnaa.asia","dolphinmail.org","dolphinnet.net","dom-okna.com","domain1dolar.com","domainaing.cf","domainaing.ga","domainaing.gq","domainaing.ml","domainaing.tk","domainnamemobile.com","domainploxkty.com","domainscan.ro","domainseoforum.com","domainwizard.win","domajabro.ga","domdomsanaltam.com","domeerer.com","domen.4pu.com","domenkaa.com","domforfb1.tk","domforfb18.tk","domforfb19.tk","domforfb2.tk","domforfb23.tk","domforfb27.tk","domforfb29.tk","domforfb3.tk","domforfb4.tk","domforfb5.tk","domforfb6.tk","domforfb7.tk","domforfb8.tk","domforfb9.tk","dominatingg.top","dominikan-nedv.ru","domozmail.com","domy-balik.pl","domywokolicy.com.pl","domywokolicy.pl","domyz-drewna.pl","donaldduckmall.com","donate-car-to-charity.net","donations.com","donbas.in","donemail.ru","dongqing365.com","dongru.top","donkey.com","donlg.top","donmail.mooo.com","donmaill.com","donot-reply.com","dons.com","dontreg.com","dontsendmespam.de","dooboop.com","doodooexpress.com","dooglecn.com","doom.com.pl","doommail.com","doorandwindowrepairs.com","doorsteploansfast24h7.co.uk","dopisivanje.in.rs","doquier.tk","doradztwo-pracy.com","dorkalicious.co.uk","dorywalski.pl","doscobal.com","dostatniapraca.pl","dot-mail.top","dot-ml.ml","dot-ml.tk","dota2bets.net","dotfixed.com","dotlvay3bkdlvlax2da.cf","dotlvay3bkdlvlax2da.ga","dotlvay3bkdlvlax2da.gq","dotlvay3bkdlvlax2da.ml","dotlvay3bkdlvlax2da.tk","dotmail.cf","dotman.de","dotmsg.com","dotslashrage.com","dotspe.info","doublebellybuster.com","doublemail.de","doublemoda.com","douchelounge.com","doudoune-ralphlauren.com","doudounecanadagoosesoldesfrance.com","doudouneemonclermagasinfr.com","doudounemoncledoudounefr.com","doudounemoncleenligne2012.com","doudounemoncler.com","doudounemonclerbouituque.com","doudounemonclerdoudounefemmepascher.com","doudounemonclerdoudounefrance.com","doudounemonclerdoudounespascher.com","doudounemonclerenlignepascherfra.com","doudounemonclerfemmefr.com","doudounemonclermagasinenfrance.com","doudounemonclerpascherfra.com","doudounemonclerrpaschera.com","doudounemonclerrpaschera1.com","doudounemonclersiteofficielfrance.com","doudounepaschermonclerpascher1.com","doudounesmonclerfemmepascherfrance.com","doudounesmonclerhommefr.com","doudounesmonclerrpascher.com","doudounmonclefrance.com","doudounmonclepascher1.com","doughmaine.xyz","dourdneis.gr","dov86hacn9vxau.ga","dov86hacn9vxau.ml","dov86hacn9vxau.tk","dovusoyun.com","dowesync.com","dowlex.co.uk","download-master.net","download-software.biz","download-warez.com","downloadarea.net","downloadbaixarpdf.com","downloadeguide.mywire.org","downloadmortgage.com","downloadmoviefilm.net","downportal.tk","downsmail.bid","downtowncoldwater.com","dowohiho.ostrowiec.pl","doxcity.net","doxy124.com","doxy77.com","doy.kr","doyouneedrenovation.id","doyouneedrenovation.net","dozvon-spb.ru","dp76.com","dp84vl63fg.cf","dp84vl63fg.ga","dp84vl63fg.gq","dp84vl63fg.ml","dp84vl63fg.tk","dpbbo5bdvmxnyznsnq.ga","dpbbo5bdvmxnyznsnq.ml","dpbbo5bdvmxnyznsnq.tk","dpp7q4941.pl","dprinceton.edu","dpttso8dag0.cf","dpttso8dag0.ga","dpttso8dag0.gq","dpttso8dag0.ml","dpttso8dag0.tk","dpwlvktkq.pl","dpxqczknda.pl","dqkerui.com","dqnwara.com","dqpw7gdmaux1u4t.cf","dqpw7gdmaux1u4t.ga","dqpw7gdmaux1u4t.gq","dqpw7gdmaux1u4t.ml","dqpw7gdmaux1u4t.tk","dr0pb0x.ga","dr69.site","draduationdresses.com","dragcok2.cf","dragcok2.gq","dragcok2.ml","dragcok2.tk","dragonballxenoversecrack.com","dragons-spirit.org","drama.tw","dramashow.ru","dramor.com","draviero.info","drawing-new.ru","drawinginfo.ru","drdrb.com","drdrb.net","drdreoutletstores.co.uk","dreambangla.com","dreambooker.ru","dreamcatcher.email","dreamhostcp.info","dreamleaguesoccer2016.gq","dreamsale.info","dreamweddingplanning.com","dred.ru","dremixd.com","dreric-es.com","dress9x.com","dresscinderella.com","dresselegant.net","dressesbubble.com","dressesbubble.net","dressescelebrity.net","dressesflower.com","dressesflower.net","dressesgrecian.com","dressesgrecian.net","dresseshappy.com","dresseshappy.net","dressesmodern.com","dressesmodern.net","dressesnoble.com","dressesnoble.net","dressesromantic.com","dressesromantic.net","dressesunusual.com","dressesunusual.net","dressmail.com","dresssmall.com","dressswholesalestores.info","dressupsummer.com","drevo.si","drewna24.pl","drewnianachata.com.pl","drf.email","drid1gs.com","driems.org","drigez.com","drill8ing.com","drinkbride.com","drinkingcoffee.info","drishvod.ru","drivecompanies.com","driversgood.ru","driverstorage-bokaxude.tk","drivesotp7.com","drivetagdev.com","drivingjobsinindiana.com","drixmail.info","drlexus.com","drmail.pw","drobosucks.info","drobosucks.net","drobosucks.org","droid3.net","droidemail.projectmy.in","droider.name","dron.mooo.com","droolingfanboy.de","drop-max.info","drop.ekholm.org","dropcake.de","drope.ml","dropfresh.net","dropjar.com","droplar.com","droplister.com","dropmail.cf","dropmail.ga","dropmail.gq","dropmail.me","dropmail.ml","dropmail.tk","dropshippingrich.com","drorevsm.com","drovi.cf","drovi.ga","drovi.gq","drovi.ml","drovi.tk","drthedf.org","drthst4wsw.tk","drublowjob20138.cx.cc","drugca.com","drugnorx.com","drugordr.com","drugsellr.com","drugvvokrug.ru","drukarniarecept.pl","drupaladdons.brainhard.net","drupalek.pl","drupaler.org","drupalmails.com","druz.cf","drvcognito.com","drxdvdn.pl","drxepingcosmeticsurgery.com","drynic.com","dryoneone.com","drzwi.edu","drzwi.turek.pl","ds-3.cf","ds-3.ga","ds-3.gq","ds-3.ml","ds-3.tk","dsafsa.ch","dsajdhjgbgf.info","dsapoponarfag.com","dsejfbh.com","dsfdeemail.com","dsfgasdewq.com","dsfgdsgmail.com","dsfgdsgmail.net","dsfgerqwexx.com","dsgawerqw.com","dshqughcoin9nazl.cf","dshqughcoin9nazl.ga","dshqughcoin9nazl.gq","dshqughcoin9nazl.ml","dshqughcoin9nazl.tk","dsiay.com","dsleeping09.com","dspwebservices.com","dsresearchins.org","dstchicago.com","dstefaniak.pl","dsvgfdsfss.tk","dszg2aot8s3c.cf","dszg2aot8s3c.ga","dszg2aot8s3c.gq","dszg2aot8s3c.ml","dszg2aot8s3c.tk","dt3456346734.ga","dtcuawg6h0fmilxbq.ml","dtcuawg6h0fmilxbq.tk","dtdns.us","dte3fseuxm9bj4oz0n.cf","dte3fseuxm9bj4oz0n.ga","dte3fseuxm9bj4oz0n.gq","dte3fseuxm9bj4oz0n.ml","dte3fseuxm9bj4oz0n.tk","dteesud.com","dthlxnt5qdshyikvly.cf","dthlxnt5qdshyikvly.ga","dthlxnt5qdshyikvly.gq","dthlxnt5qdshyikvly.ml","dthlxnt5qdshyikvly.tk","dtools.info","dtrspypkxaso.cf","dtrspypkxaso.ga","dtrspypkxaso.gq","dtrspypkxaso.ml","dtrspypkxaso.tk","dtspf8pbtlm4.cf","dtspf8pbtlm4.ga","dtspf8pbtlm4.gq","dtspf8pbtlm4.ml","dtspf8pbtlm4.tk","dttt9egmi7bveq58bi.cf","dttt9egmi7bveq58bi.ga","dttt9egmi7bveq58bi.gq","dttt9egmi7bveq58bi.ml","dttt9egmi7bveq58bi.tk","dtv42wlb76cgz.cf","dtv42wlb76cgz.ga","dtv42wlb76cgz.gq","dtv42wlb76cgz.ml","dtv42wlb76cgz.tk","duacgel.info","dualscreenplayer.com","duam.net","duanehar.pw","dubstepthis.com","duck2.club","ducruet.it","ducutuan.cn","ducvdante.pl","dudleymail.bid","dudmail.com","duivavlb.pl","duk33.com","dukedish.com","dulei.ml","dumail.com","dumbdroid.info","dumbledore.cf","dumbledore.ga","dumbledore.gq","dumbledore.ml","dumbrepublican.info","dumoac.net","dump-email.info","dumpandjunk.com","dumpmail.de","dumpyemail.com","duncancorp.usa.cc","dundeeusedcars.co.uk","dundo.tk","duo-alta.com","duoduo.cafe","dupaemailk.com.uk","dupazsau2f.cf","dupazsau2f.ga","dupazsau2f.gq","dupazsau2f.ml","dupazsau2f.tk","dupontmails.com","durandinterstellar.com","duskmail.com","dusnedesigns.ml","dutchconnie.com","dutchfemales.info","dutchmail.com","dutiesu0.com","dutybux.info","duzybillboard.pl","dv6w2z28obi.pl","dvakansiisochi20139.cx.cc","dvd.dns-cloud.net","dvd.dnsabr.com","dvdallnews.com","dvdcloset.net","dvdexperts.info","dvdjapanesehome.com","dvdkrnbooling.com","dvdnewshome.com","dvdnewsonline.com","dvdrezensionen.com","dvdxpress.biz","dverishpon.ru","dvfdsigni.com","dvi-hdmi.net","dviuvbmda.pl","dvlotterygreencard.com","dvsdg34t6ewt.ga","dvspitfuh434.cf","dvspitfuh434.ga","dvspitfuh434.gq","dvspitfuh434.ml","dvspitfuh434.tk","dvx.dnsabr.com","dw.now.im","dwa.wiadomosc.pisz.pl","dwango.cf","dwango.ga","dwango.gq","dwango.ml","dwango.tk","dwdpoisk.info","dweezlemail.crabdance.com","dwipalinggantengyanglainlewat.cf","dwipalinggantengyanglainlewat.ga","dwipalinggantengyanglainlewat.gq","dwipalinggantengyanglainlewat.ml","dwipalinggantengyanglainlewat.tk","dwn2ubltpov.cf","dwn2ubltpov.ga","dwn2ubltpov.gq","dwn2ubltpov.ml","dwn2ubltpov.tk","dwse.edu.pl","dwswd8ufd2tfscu.cf","dwswd8ufd2tfscu.ga","dwswd8ufd2tfscu.gq","dwswd8ufd2tfscu.ml","dwswd8ufd2tfscu.tk","dwt-damenwaeschetraeger.org","dwukwiat4.pl","dwukwiat5.pl","dwukwiat6.pl","dwutuemzudvcb.cf","dwutuemzudvcb.ga","dwutuemzudvcb.gq","dwutuemzudvcb.ml","dwutuemzudvcb.tk","dwyj.com","dx.abuser.eu","dx.allowed.org","dx.awiki.org","dx.ez.lv","dx.sly.io","dxdblog.com","dxmk148pvn.cf","dxmk148pvn.ga","dxmk148pvn.gq","dxmk148pvn.ml","dxmk148pvn.tk","dy7fpcmwck.cf","dy7fpcmwck.ga","dy7fpcmwck.gq","dy7fpcmwck.ml","dy7fpcmwck.tk","dyceroprojects.com","dymnawynos.pl","dynabird.com","dynainbox.com","dynastyantique.com","dynofusion-developments.com","dynu.net","dyskretna-pomoc.pl","dyx9th0o1t5f.cf","dyx9th0o1t5f.ga","dyx9th0o1t5f.gq","dyx9th0o1t5f.ml","dyx9th0o1t5f.tk","dz-geek.org","dz.usto.in","dz0371.com","dz17.net","dz4ahrt79.pl","dz57taerst4574.ga","dzewa6nnvt9fte.cf","dzewa6nnvt9fte.ga","dzewa6nnvt9fte.gq","dzewa6nnvt9fte.ml","dzewa6nnvt9fte.tk","dzfphcn47xg.ga","dzfphcn47xg.gq","dzfphcn47xg.ml","dzfphcn47xg.tk","dzhinsy-platja.info","dziecio-land.pl","dziekan1.pl","dziekan2.pl","dziekan3.pl","dziekan4.pl","dziekan5.pl","dziekan6.pl","dziekan7.pl","dziesiec.akika.pl","dzimbabwegq.com","dzinoy58w12.ga","dzinoy58w12.gq","dzinoy58w12.ml","dzinoy58w12.tk","dzsyr.com","e-b-s.pp.ua","e-bhpkursy.pl","e-cigarette-x.com","e-clip.info","e-drapaki.eu","e-factorystyle.pl","e-filme.net","e-horoskopdzienny.pl","e-jaroslawiec.pl","e-mail.com","e-mail.comx.cf","e-mail.igg.biz","e-mail.net","e-mail.org","e-mail365.eu","e-mailbox.comx.cf","e-mailbox.ga","e-marketstore.ru","e-mbtshoes.com","e-mule.cf","e-mule.ga","e-mule.gq","e-mule.ml","e-mule.tk","e-news.org","e-numizmatyka.pl","e-pierdoly.pl","e-poradnikowo24.pl","e-postkasten.com","e-postkasten.de","e-postkasten.eu","e-postkasten.info","e-prima.com.pl","e-swieradow.pl","e-swojswiat.pl","e-tomarigi.com","e-torrent.ru","e-trend.pl","e-vents2009.info","e.4pet.ro","e.amav.ro","e.arno.fi","e.benlotus.com","e.blogspam.ro","e.discard-email.cf","e.l5.ca","e.milavitsaromania.ro","e.nodie.cc","e.polosburberry.com","e.seoestore.us","e.shapoo.ch","e.socialcampaigns.org","e.wupics.com","e0yk-mail.ml","e13100d7e234b6.noip.me","e1y4anp6d5kikv.cf","e1y4anp6d5kikv.ga","e1y4anp6d5kikv.gq","e1y4anp6d5kikv.ml","e1y4anp6d5kikv.tk","e2qoitlrzw6yqg.cf","e2qoitlrzw6yqg.ga","e2qoitlrzw6yqg.gq","e2qoitlrzw6yqg.ml","e2qoitlrzw6yqg.tk","e2trg8d4.priv.pl","e3b.org","e3z.de","e4ivstampk.com","e4t5exw6aauecg.ga","e4t5exw6aauecg.ml","e4t5exw6aauecg.tk","e4ward.com","e4wfnv7ay0hawl3rz.cf","e4wfnv7ay0hawl3rz.ga","e4wfnv7ay0hawl3rz.gq","e4wfnv7ay0hawl3rz.ml","e4wfnv7ay0hawl3rz.tk","e501eyc1m4tktem067.cf","e501eyc1m4tktem067.ga","e501eyc1m4tktem067.ml","e501eyc1m4tktem067.tk","e56r5b6r56r5b.cf","e56r5b6r56r5b.ga","e56r5b6r56r5b.gq","e56r5b6r56r5b.ml","e57.pl","e5by64r56y45.cf","e5by64r56y45.ga","e5by64r56y45.gq","e5by64r56y45.ml","e5by64r56y45.tk","e5ki3ssbvt.cf","e5ki3ssbvt.ga","e5ki3ssbvt.gq","e5ki3ssbvt.ml","e5ki3ssbvt.tk","e5r6ynr5.cf","e5r6ynr5.ga","e5r6ynr5.gq","e5r6ynr5.ml","e5r6ynr5.tk","e5v7tp.pl","e6hq33h9o.pl","e7n06wz.com","e84ywua9hxr5q.cf","e84ywua9hxr5q.ga","e84ywua9hxr5q.gq","e84ywua9hxr5q.ml","e84ywua9hxr5q.tk","e89fi5kt8tuev6nl.cf","e89fi5kt8tuev6nl.ga","e89fi5kt8tuev6nl.gq","e89fi5kt8tuev6nl.ml","e89fi5kt8tuev6nl.tk","e8dymnn9k.pl","e8g93s9zfo.com","e90.biz","ea.luk2.com","eaa620.org","eabockers.com","eadvertsyst.com","eafrem3456ails.com","eagledigitizing.net","eaglehandbags.com","eagleinbox.com","eaglemail.top","eagleracingengines.com","eajfciwvbohrdbhyi.cf","eajfciwvbohrdbhyi.ga","eajfciwvbohrdbhyi.gq","eajfciwvbohrdbhyi.ml","eajfciwvbohrdbhyi.tk","eamail.com","eami85nt.atm.pl","eanok.com","eaqso209ak.cf","eaqso209ak.ga","eaqso209ak.gq","eaqso209ak.ml","earnlink.ooo","earpitchtraining.info","earth.doesntexist.org","earthworksyar.cf","earthworksyar.ml","easiestcollegestogetinto.com","easilyremovewrinkles.com","eastwan.net","easy-apps.info","easy-link.org","easy-mail.top","easy-trash-mail.com","easy2ride.com","easybedb.site","easyblogs.biz","easybuygos.com","easydinnerrecipes.org","easydirectory.tk","easyemail.info","easyfbcommissions.com","easyguitarlessonsworld.com","easyiphoneunlock.top","easyjimmy.cz.cc","easyjiujitsu.com","easymail.ga","easymail.igg.biz","easymail.top","easymailing.top","easymbtshoes.com","easynetwork.info","easypaperplanes.com","easytrashmail.com","eatlikeahuman.com","eatlogs.com","eatme69.top","eatmea2z.club","eatmea2z.top","eatreplicashop.com","eatrnet.com","eatstopeatdiscount.org","eatthegarden.co.uk","eautofsm.com","eautoskup.net","eay.jp","eazeemail.info","eb-dk.biz","eb46r5r5e.cf","eb46r5r5e.ga","eb46r5r5e.gq","eb46r5r5e.ml","eb46r5r5e.tk","eb4te5.cf","eb4te5.ga","eb4te5.gq","eb4te5.ml","eb4te5.tk","eb56b45.cf","eb56b45.ga","eb56b45.gq","eb56b45.ml","eb56b45.tk","eb609s25w.com","eb655b5.cf","eb655b5.ga","eb655b5.gq","eb655b5.ml","eb655b5.tk","eb655et4.cf","eb655et4.ga","eb655et4.gq","eb655et4.ml","eb7gxqtsoyj.cf","eb7gxqtsoyj.ga","eb7gxqtsoyj.gq","eb7gxqtsoyj.ml","eb7gxqtsoyj.tk","ebano.campano.cl","ebaymail.com","ebbob.com","ebctc.com","ebdbuuxxy.pl","ebeschlussbuch.de","ebestaudiobooks.com","ebignews.com","ebing.com","ebmail.com","ebnaoqle657.cf","ebnaoqle657.ga","ebnaoqle657.gq","ebnaoqle657.ml","ebnaoqle657.tk","ebnevelde.org","ebocmail.com","eboise.com","ebookway.us","ebrker.pl","ebs.com.ar","ebtukukxnn.cf","ebtukukxnn.ga","ebtukukxnn.gq","ebtukukxnn.ml","ebtukukxnn.tk","ebuyfree.com","ebv9rtbhseeto0.cf","ebv9rtbhseeto0.ga","ebv9rtbhseeto0.gq","ebv9rtbhseeto0.ml","ebv9rtbhseeto0.tk","ec97.cf","ec97.ga","ec97.gq","ec97.ml","ec97.tk","ecallheandi.com","eccfilms.com","echeaplawnmowers.com","echt-mail.de","echtzeit.website","ecigarettereviewonline.net","ecimail.com","eclipseye.com","ecmail.com","eco.ilmale.it","ecocap.cf","ecocap.ga","ecocap.gq","ecocap.ml","ecocap.tk","ecodark.com","ecolaundrysystems.com","ecolo-online.fr","ecomail.com","ecomediahosting.net","ecommerceservice.cc","econvention2007.info","ecopressmail.us","ecoright.ru","ecowisehome.com","ecpsscardshopping.com","ecsspay.com","ecudeju.olkusz.pl","ecuwmyp.pl","ecybqsu.pl","ed-hardybrand.com","ed-pillole.it","ed1crhaka8u4.cf","ed1crhaka8u4.ga","ed1crhaka8u4.gq","ed1crhaka8u4.ml","ed1crhaka8u4.tk","edalist.ru","edcar-sacz.pl","edf.ca.pn","edfast-medrx.com","edfromcali.info","edgex.ru","edhardy-onsale.com","edhardy886.com","edhardyfeel.com","edhardyown.com","edhardypurchase.com","edhardyuser.com","edifice.ga","edikmail.com","edimail.com","edinburgh-airporthotels.com","editicon.info","edkvq9wrizni8.cf","edkvq9wrizni8.ga","edkvq9wrizni8.gq","edkvq9wrizni8.ml","edkvq9wrizni8.tk","edmail.com","edomail.com","edotzxdsfnjvluhtg.cf","edotzxdsfnjvluhtg.ga","edotzxdsfnjvluhtg.gq","edotzxdsfnjvluhtg.ml","edotzxdsfnjvluhtg.tk","edovqsnb.pl","edpillsrx.us","edrishn.xyz","edu-paper.com","edu.aiot.ze.cx","edu.auction","edu.dmtc.dev","edu.hstu.eu.org","eduanswer.ru","education.eu","educationleaders-ksa.com","educationvn.cf","educationvn.ga","educationvn.gq","educationvn.ml","educationvn.tk","edukacyjny.biz","edunk.com","edupost.pl","edurealistic.ru","edv.to","ee-papieros.pl","ee.anglik.org","ee1.pl","ee2.pl","eeeeeeee.pl","eeemail.pl","eeemail.win","eegxvaanji.pl","eehfmail.org","eelmail.com","eezojq3zq264gk.cf","eezojq3zq264gk.ga","eezojq3zq264gk.gq","eezojq3zq264gk.ml","eezojq3zq264gk.tk","ef2qohn1l4ctqvh.cf","ef2qohn1l4ctqvh.ga","ef2qohn1l4ctqvh.gq","ef2qohn1l4ctqvh.ml","ef2qohn1l4ctqvh.tk","ef9ppjrzqcza.cf","ef9ppjrzqcza.ga","ef9ppjrzqcza.gq","ef9ppjrzqcza.ml","ef9ppjrzqcza.tk","efacs.net","efasttrackwatches.com","efatt2fiilie.ru","efepala.kazimierz-dolny.pl","efetusomgx.pl","efhuxvwd.pl","efmsts.xyz","efo.kr","efreaknet.com","efremails.com","efxs.ca","egames20.com","egames4girl.com","eget1loadzzz.ru","eget9loaadz.ru","egget4fffile.ru","egget8zagruz.ru","eggnova.com","egipet-nedv.ru","eglft.in","egodmail.com","egofan.ru","eguccibag-sales.com","egzmail.top","ehhxbsbbdhxcsvzbdv.ml","ehhxbsbbdhxcsvzbdv.tk","ehmail.com","ehmwi6oixa6mar7c.cf","ehmwi6oixa6mar7c.ga","ehmwi6oixa6mar7c.gq","ehmwi6oixa6mar7c.ml","ehmwi6oixa6mar7c.tk","eho.kr","ehoie03og3acq3us6.cf","ehoie03og3acq3us6.ga","ehoie03og3acq3us6.gq","ehoie03og3acq3us6.ml","ehoie03og3acq3us6.tk","ehowtobuildafireplace.com","ehvgfwayspsfwukntpi.cf","ehvgfwayspsfwukntpi.ga","ehvgfwayspsfwukntpi.gq","ehvgfwayspsfwukntpi.ml","ehvgfwayspsfwukntpi.tk","eiakr.com","eidumail.com","eight.emailfake.ml","eight.fackme.gq","eik3jeha7dt1as.cf","eik3jeha7dt1as.ga","eik3jeha7dt1as.gq","eik3jeha7dt1as.ml","eik3jeha7dt1as.tk","eik8a.avr.ze.cx","eimadness.com","eimail.com","einfach.to","einmalmail.de","einrot.com","einrot.de","eins-zwei.cf","eins-zwei.ga","eins-zwei.gq","eins-zwei.ml","eins-zwei.tk","einsteino.com","einsteino.net","eintagsmail.de","eircjj.com","eirtsdfgs.co.cc","ejaculationbycommandreviewed.org","ejaculationprecoce911.com","ejaculationtrainerreviewed.com","ejajmail.com","ejdy1hr9b.pl","ejh3ztqvlw.cf","ejh3ztqvlw.ga","ejh3ztqvlw.gq","ejh3ztqvlw.ml","ejh3ztqvlw.tk","ejkovev.org","ejmcuv7.com.pl","ejrt.co.cc","ejrtug.co.cc","ek8wqatxer5.cf","ek8wqatxer5.ga","ek8wqatxer5.gq","ek8wqatxer5.ml","ek8wqatxer5.tk","ekatalogstron.ovh","ekb-nedv.ru","ekii.cf","ekiiajah.ga","ekiibete.ml","ekiibeteaja.cf","ekiibetekorea.tk","ekiikorea99.cf","ekiikorea99.ga","ekiilinkinpark.ga","ekkoboss.com.ua","eko-europa.com","ekredyt.org","eksprespedycja.pl","ekstra.pl","ekumail.com","el.efast.in","elancreditcards.net","elavilonlinenow.com","elavmail.com","elearningjournal.org","eleccionesath.com","electriccarvehicle.com","electricistaurgente.net","electricswitch.info","electro.mn","electrofunds.com","electromax.us","electronic-smoke.com","electronic-stores.org","electronicearprotection.net","electronicmail.us","electroproluxex.eu","elegantthemes.top","elektrische-auto.info","elektro-grobgerate.com","elementaltraderforex.com","elenafuriase.com","elenotoneshop.com","elerrisgroup.com","elevatorshoes-wholesalestores.info","elex-net.ru","elfox.net","elftraff.com","elhammam.com","eli.hekko24.pl","elilogan.us","elinbox.com","elinore1818.site","elisione.pl","elite-altay.ru","elite-seo-marketing.com","elite12.mygbiz.com","eliteavangers.pl","eliteesig.org","elitemotions.com","elitescortistanbul.net","elitevipatlantamodels.com","elitokna.com","elizabethroberts.org","elki-mkzn.ru","ellisontraffic.com","elloboxlolongti.com","elly.email4edu.com","elmarquesbanquetes.com","elmiracap.com","elmoscow.ru","elokalna.pl","elpatevskiy.com","els396lgxa6krq1ijkl.cf","els396lgxa6krq1ijkl.ga","els396lgxa6krq1ijkl.gq","els396lgxa6krq1ijkl.ml","els396lgxa6krq1ijkl.tk","elsdrivingschool.net","elsexo.ru","elteh.me","eltombis.pl","eluxurycoat.com","ely.kr","elysium.ml","em-meblekuchenne.pl","emagrecerdevezbr.com","emaiden.com","email-24x7.com","email-4-everybody.bid","email-bomber.info","email-boxes.ru","email-fake.cf","email-fake.com","email-fake.ga","email-fake.gq","email-fake.ml","email-fake.tk","email-host.info","email-jetable.fr","email-lab.com","email-list.online","email-me.bid","email-server.info","email-sms.com","email-sms.net","email-t.cf","email-t.ga","email-t.gq","email-t.ml","email-t.tk","email-temp.com","email-wizard.com","email.cbes.net","email.comx.cf","email.cykldrzewa.pl","email.freecrypt.org","email.infokehilangan.com","email.net","email.org","email.pozycjonowanie8.pl","email.wassusf.online","email.zyz5.com","email0.cf","email0.ga","email0.gq","email0.ml","email0.tk","email1.gq","email2.cf","email2.gq","email2.ml","email2.tk","email2an.ga","email2twitter.info","email3.cf","email3.ga","email3.gq","email3.ml","email3.tk","email4all.info","email4everybody.bid","email4everyone.co.uk","email4everyone.com","email60.com","emailage.cf","emailage.ga","emailage.gq","emailage.ml","emailage.tk","emailanto.com","emailappp.com","emailapps.in","emailapps.info","emailate.com","emailbaruku.com","emailber.com","emailboot.com","emailbot.org","emailbox.comx.cf","emailchepas.cf","emailchepas.ga","emailchepas.gq","emailchepas.ml","emailchepas.tk","emailcom.org","emailcoordinator.info","emailcu.icu","emaildfga.com","emaildienst.de","emaildrop.io","emaildublog.com","emailed.com","emaileen.com","emailertr.com","emailfake.cf","emailfake.com","emailfake.ga","emailfake.gq","emailfake.ml","emailfake.nut.cc","emailfake.usa.cc","emailfalsa.cf","emailfalsa.ga","emailfalsa.gq","emailfalsa.ml","emailfalsa.tk","emailforme.pl","emailforyounow.com","emailfowarding.com","emailfreedom.ml","emailgap.com","emailgenerator.de","emailgo.de","emailgratis.info","emailgsio.us","emailhearing.com","emailhosts.org","emailhot.com","emailias.com","emailigo.de","emailinbox.xyz","emailinfive.com","emailirani.ir","emailismy.com","emailist.tk","emailisvalid.com","emailjonny.net","emailket.online","emailkjff.com","emailko.in","emailkoe.com","emailkoe.xyz","emaill.host","emaillalala.org","emaillime.com","emailll.org","emailmc2.com","emailme.accountant","emailme.bid","emailme.men","emailme.racing","emailme.win","emailmenow.info","emailmobile.net","emailmynn.com","emailmysr.com","emailna.co","emailna.life","emailno.in","emailnode.net","emailnope.com","emailo.pro","emailofnd.cf","emailondeck.com","emailonlinefree.com","emailonn.in","emailoo.cf","emailpalbuddy.com","emailpops.cz.cc","emailportal.info","emailpro.cf","emailproxsy.com","emailr.win","emailrambler.co.tv","emailrecup.info","emailreg.org","emailresort.com","emailreviews.info","emailrii.com","emailrtg.org","emails-like-snails.bid","emails.ga","emails92x.pl","emailsalestoday.info","emailsecurer.com","emailsensei.com","emailsforall.com","emailsingularity.net","emailsky.info","emailslikesnails.bid","emailsolutions.xyz","emailspam.cf","emailspam.ga","emailspam.gq","emailspam.ml","emailspam.tk","emailspot.org","emailspro.com","emailsteel.com","emailswhois.com","emailsy.info","emailsys.co.cc","emailtea.com","emailtech.info","emailtemporanea.com","emailtemporanea.net","emailtemporar.ro","emailtemporario.com.br","emailtex.com","emailthe.net","emailtmp.com","emailto.de","emailtoo.ml","emailure.net","emailvenue.com","emailwarden.com","emailworldwide.info","emailworth.com","emailx.at.hm","emailx.org","emailxfer.com","emailxpress.co.cc","emailz.cf","emailz.ga","emailz.gq","emailz.ml","emakmintadomain.co","emall.ml","emaomail.com","emapmail.com","embalaje.us","embergone.cf","embergone.ga","embergone.gq","embergone.ml","embergone.tk","embergonebro.cf","embergonebro.ga","embergonebro.gq","embergonebro.ml","embergonebro.tk","emblemail.com","embrapamail.pw","emcinfo.pl","emdwgsnxatla1.cf","emdwgsnxatla1.ga","emdwgsnxatla1.gq","emdwgsnxatla1.ml","emdwgsnxatla1.tk","emedia.nl","emeil.cf","emeil.in","emeil.ir","emeraldcluster.com","emeraldwebmail.com","emeyle.com","emil.com","eminilathe.info","emirati-nedv.ru","emirmail.ga","emka3.vv.cc","emkei.cf","emkei.ga","emkei.gq","emkei.ml","emkei.tk","eml.pp.ua","emlhub.com","emlpro.com","emltmp.com","emmail.com","emmail.info","emmailoon.com","emmasart.com","emohawk.xyz","emoreforworkx.com","emoreno.tk","emozoro.de","emp4lbr3wox.ga","empaltahu24best.gq","empek.tk","empireanime.ga","empireapp.org","empiremail.de","empireofbeauty.co.uk","empowering.zapto.org","empresagloriasamotderoman.com","emptylousersstop.com","emran.cf","emstjzh.com","emtelrilan.xyz","emtrn9cyvg0a.cf","emtrn9cyvg0a.ga","emtrn9cyvg0a.gq","emtrn9cyvg0a.ml","emtrn9cyvg0a.tk","emule.cf","emule.ga","emule.gq","emunmail.com","emy.kr","emz.net","en565n6yt4be5.cf","en565n6yt4be5.ga","en565n6yt4be5.gq","en565n6yt4be5.ml","en565n6yt4be5.tk","en5ew4r53c4.cf","en5ew4r53c4.ga","en5ew4r53c4.gq","en5ew4r53c4.ml","en5ew4r53c4.tk","enaksekali.ga","enayu.com","encrot.uk.ht","encryptedmail.xyz","encryptedonion.com","endergraph.com","endrix.org","enercranyr.eu","energetus.pl","energymail.co.cc","energymails.com","energymonitor.pl","enestmep.com","enewheretm.tk","eneyatokar12.com","enforkatoere.com","enfsmq2wel.cf","enfsmq2wel.ga","enfsmq2wel.gq","enfsmq2wel.ml","enfsmq2wel.tk","enggalman.ga","enggalman.ml","engineemail.com","engineering-ai.com","enginemail.co.cc","enginwork.com","englishlearn.org","englishteachingfriends.com","enhancemalepotency.com","enlargement-xl.com","enlargementz.com","enlerama.eu","enmail.com","enmtuxjil7tjoh.cf","enmtuxjil7tjoh.ga","enmtuxjil7tjoh.gq","enmtuxjil7tjoh.ml","enmtuxjil7tjoh.tk","ennemail.ga","enron.cf","enron.ga","enron.gq","enron.ml","enroncorp.cf","enroncorp.ga","enroncorp.gq","enroncorp.ml","enroncorp.tk","ensudgesef.com","enteremail.us","enterprise-secure-registration.com","enterto.com","entirelynl.nl","entregandobiblia.com.br","enu.kr","envelop2.tk","envirophoenix.com","envy17.com","envysa.com","envywork.ru","enwi7gpptiqee5slpxt.cf","enwi7gpptiqee5slpxt.ga","enwi7gpptiqee5slpxt.gq","enwi7gpptiqee5slpxt.ml","enwi7gpptiqee5slpxt.tk","eny.kr","eo-z.com","eoffice.top","eomail.com","eonmech.com","eoopy.com","eorbs.com","eos2mail.com","eotoplenie.ru","eovdfezpdto8ekb.cf","eovdfezpdto8ekb.ga","eovdfezpdto8ekb.gq","eovdfezpdto8ekb.ml","eovdfezpdto8ekb.tk","eozxzcbqm.pl","epam-hellas.org","eparis.pl","epb.ro","epenpoker.com","epewmail.com","ephemail.net","ephemeral.email","epic.swat.rip","epicgamers.mooo.com","epictv.pl","epicwebdesigners.com","epit.info","epitom.com","epizmail.com","epmail.com","epomail.com","eporadnictwo.pl","eposredniak.pl","epostmail.comx.cf","epot.ga","epr49y5b.bee.pl","eprofitacademy.net","epsilonzulu.webmailious.top","epwwrestling.com","eq2shs5rva7nkwibh6.cf","eq2shs5rva7nkwibh6.ga","eq2shs5rva7nkwibh6.gq","eq2shs5rva7nkwibh6.ml","eq2shs5rva7nkwibh6.tk","eqador-nedv.ru","eqasmail.com","eqbo62qzu2r8i0vl.cf","eqbo62qzu2r8i0vl.ga","eqbo62qzu2r8i0vl.gq","eqbo62qzu2r8i0vl.ml","eqbo62qzu2r8i0vl.tk","eqeqeqeqe.tk","eqiluxspam.ga","eqimail.com","eqr.luk2.com","eqrsxitx.pl","eqstqbh7hotkm.cf","eqstqbh7hotkm.ga","eqstqbh7hotkm.gq","eqstqbh7hotkm.ml","eqstqbh7hotkm.tk","equiapp.men","equiemail.com","equinemania.com","equipcare.ru","equonecredite.com","erailcomms.net","eramis.ga","erasedebt.gq","eraseo.com","erasf.com","ereaderreviewcentral.com","erec-dysf.com","erectiledysf.com","erectiledysfunctionpillsest.com","erectiledysfunctionpillsonx.com","erection-us.com","erermail.com","erersaju.xyz","erertmail.com","erexcolbart.eu","erexcolbart.xyz","erfoer.com","ergo-design.com.pl","ergopsycholog.pl","ericjohnson.ml","ericsreviews.com","erinnfrechette.com","erjit.in","erk7oorgaxejvu.cf","erk7oorgaxejvu.ga","erk7oorgaxejvu.gq","erk7oorgaxejvu.ml","erk7oorgaxejvu.tk","ermail.cf","ermail.ga","ermail.gq","ermail.ml","ermail.tk","ermeson.tk","ero-host.ru","ero-tube.org","erodate.com","erodate.fr","eroererwa.vv.cc","eroker.pl","eromail.com","eroticadultdvds.com","erotyczna.eu","erotyka.pl","erpin.org","erreemail.com","ersatzs.com","erssuperbowlshop.com","ersxdmzzua.pl","ertemaik.com","ertewurtiorie.co.cc","ertki.online","ertuet5.tk","ertyuio.pl","eruj33y5g1a8isg95.cf","eruj33y5g1a8isg95.ga","eruj33y5g1a8isg95.gq","eruj33y5g1a8isg95.ml","eruj33y5g1a8isg95.tk","erun.2nightgz.com","erw.com","erx.mobi","eryoritwd1.cf","eryoritwd1.ga","eryoritwd1.gq","eryoritwd1.ml","eryoritwd1.tk","esanmail.com","esbano-ru.ru","esc.la","escanor99.com","escapehatchapp.com","escholcreations.com","escholgroup.com.au","escoltesiguies.net","escortankara06.com","escortbayanport.com","escortcumbria.co.uk","escorthatti.com","escorts-in-prague.com","escortsaati.com","escortsdudley.com","escortvitrinim.com","ese.kr","esemay.com","esender18.com","eseoconsultant.org","eset.t28.net","esgame.pl","esgeneri.com","eskile.com","esm.com","esmaczki.pl","esmuse.me","esotericans.ru","espamted3kepu.cf","espamted3kepu.ga","espamted3kepu.gq","espamted3kepu.ml","espamted3kepu.tk","espana-official.com","espanatabs.com","espil-place-zabaw.pl","espinozamail.men","esportenanet.com","espritblog.org","esprity.com","essaouira.xyz","essay-introduction-buy.xyz","essay-top.biz","essayhelp.top","esseriod.com","essh.ca","est.une.victime.ninja","estate-invest.fr","esteembpo.com","estonia-nedv.ru","estress.net","estudent.edu.pl","esxgrntq.pl","esy.es","et4veh6lg86bq5atox.cf","et4veh6lg86bq5atox.ga","et4veh6lg86bq5atox.gq","et4veh6lg86bq5atox.tk","etaalpha.spithamail.top","etabox.info","etaetae46gaf.ga","etalase1.com","etang.com","etaxmail.com","etbclwlt.priv.pl","etdcr5arsu3.cf","etdcr5arsu3.ga","etdcr5arsu3.gq","etdcr5arsu3.ml","etdcr5arsu3.tk","eternalist.ru","etgdev.de","eth2btc.info","ether123.net","etherbackup.com","ethereal.email","etherealplunderer.com","ethereum1.top","ethersports.org","ethersportz.info","ethicalencounters.org.uk","ethiccouch.xyz","ethiopia-nedv.ru","etlgr.com","etmail.com","etmail.top","etoic.com","etonracingboats.co.uk","etotvibor.ru","etovar.net.ua","etranquil.com","etranquil.net","etranquil.org","etrytmbkcq.pl","etszys.com","etwienmf7hs.cf","etwienmf7hs.ga","etwienmf7hs.gq","etwienmf7hs.ml","etxm.gq","etzdnetx.com","eu.dlink.cf","eu.dlink.gq","eu.igg.biz","eu6genetic.com","euabds.com","euaqa.com","eubicgjm.pl","eue51chyzfil0.cf","eue51chyzfil0.ga","eue51chyzfil0.gq","eue51chyzfil0.ml","eue51chyzfil0.tk","eur-sec1.cf","eur-sec1.ga","eur-sec1.gq","eur-sec1.ml","eur-sec1.tk","eur0.cf","eur0.ga","eur0.gq","eur0.ml","eurocuisine2012.info","eurodmain.com","euromail.tk","euromillionsresults.be","europesmail.gdn","euroweb.email","eurox.eu","euwbvkhuqwdrcp8m.cf","euwbvkhuqwdrcp8m.ml","euwbvkhuqwdrcp8m.tk","eva.bigmail.info","evacarstens.fr","evamail.com","evanfox.info","evansville.com","evcmail.com","evcr8twoxifpaw.cf","evcr8twoxifpaw.ga","evcr8twoxifpaw.gq","evcr8twoxifpaw.ml","evcr8twoxifpaw.tk","evdnbppeodp.mil.pl","evdy5rwtsh.cf","evdy5rwtsh.ga","evdy5rwtsh.gq","evdy5rwtsh.ml","evdy5rwtsh.tk","eveadamsinteriors.com","eveav.com","eveb5t5.cf","eveb5t5.ga","eveb5t5.gq","eveb5t5.ml","eveb5t5.tk","evergo.igg.biz","everifies.com","evertime-revolution.biz","everto.us","everybes.tk","everybodyone.org.ua","everynewr.tk","everytg.ml","everythingisnothing.com","everythinglifehouse.com","evidenceintoaction.org","evilbruce.com","evilcomputer.com","evliyaogluotel.com","evmail.com","evoaled091h.cf","evoaled091h.ga","evoaled091h.gq","evoaled091h.ml","evoaled091h.tk","evobmail.com","evopo.com","evoro.eu","evortal.eu","evropost.top","evropost.trade","evt5et4.cf","evt5et4.ga","evt5et4.gq","evt5et4.ml","evt5et4.tk","evuwbapau3.cf","evuwbapau3.ga","evuwbapau3.gq","evuwbapau3.ml","evyush.com","ew-purse.com","ewa.kr","ewarjkit.in","ewatchesnow.com","ewebpills.com","eweemail.com","ewer.ml","ewofjweooqwiocifus.ru","ewroteed.com","ewt35ttwant35.tk","ewumail.com","ewuobxpz47ck7xaw.cf","ewuobxpz47ck7xaw.ga","ewuobxpz47ck7xaw.gq","ewuobxpz47ck7xaw.ml","ewuobxpz47ck7xaw.tk","eww.ro","ewwq.eu","ex-you.com","exactmail.com","exaltatio.com","example.com","examplefirem.org.ua","exampleforall.org.ua","exboxlivecodes.com","exbte.com","exbts.com","excavatea.com","excellx.com","excelwfinansach.pl","exchangefinancebroker.org","excitedchat.com","excitingsupreme.info","exclusivewebhosting.co.uk","exdisplaykitchens1.co.uk","exems.net","exercisetrainer.net","exertwheen.com","exi.kr","exi8tlxuyrbyif5.cf","exi8tlxuyrbyif5.ga","exi8tlxuyrbyif5.gq","exi8tlxuyrbyif5.ml","eximail.com","exiq0air0ndsqbx2.cf","exiq0air0ndsqbx2.ga","exiq0air0ndsqbx2.ml","existiert.net","exitstageleft.net","exo-eco-photo.net","exoly.com","exoticcloth.net","expanda.net","experienceamg.com","experiencesegment.com","expertadnt.com","expertadvisormt4ea.com","expertroofingbrisbane.com","expirebox.com","expirebox.email","expirebox.me","expirebox.net","expirebox.org","expl0rer.cf","expl0rer.ga","expl0rer.gq","expl0rer.ml","expl0rer.tk","explodemail.com","exporthailand.com","express-mail.info","express.net.ua","expressbuy2011.info","expressbuynow.com","expresscafe.info","expressemail.org","expressgopher.com","expresslan24.eu","extanewsmi.zzux.com","extenzereview1.net","extra-breast.info","extra-penis-enlargement.info","extra.oscarr.nl","extraaaa.tk","extraaaa2.ga","extraaaa2.tk","extraam.loan","extracccolorrfull.com","extracoloorfull.com","extradingsystems.com","extradouchebag.tk","extrasize.biz","extrasize.info","extravagandideas.com","extravagant.pl","extremail.ru","extremcase.com","extreme-trax.com","extremebacklinks.info","exxon-mobil.tk","ey5kg8zm.mil.pl","eyal-golan.com","eyelidsflorida.com","eyepaste.com","eyimail.com","eymail.com","eysoe.com","ez.lv","ezaklady.net.pl","ezanalytics.info","ezehe.com","ezen43.pl","ezen74.pl","ezfill.club","ezfill.com","ezgaga.com","ezhandui.com","ezhulenev.fvds.ru","ezimail.com","ezlo.co","ezmailbox.info","ezmails.info","ezprice.co","ezprvcxickyq.cf","ezprvcxickyq.ga","ezprvcxickyq.gq","ezprvcxickyq.ml","ezprvcxickyq.tk","ezstest.com","ezy2buy.info","ezz.bid","ezzzi.com","f-aq.info","f-best.net","f-best.org","f-hanayoshi.com","f.moza.pl","f.polosburberry.com","f.seoestore.us","f0205.trustcombat.com","f0d1rdk5t.pl","f1kzc0d3.cf","f1kzc0d3.ga","f1kzc0d3.gq","f1kzc0d3.ml","f1kzc0d3.tk","f2ksirhlrgdkvwa.cf","f2ksirhlrgdkvwa.ga","f2ksirhlrgdkvwa.gq","f2ksirhlrgdkvwa.ml","f2ksirhlrgdkvwa.tk","f39mltl5qyhyfx.cf","f39mltl5qyhyfx.ga","f39mltl5qyhyfx.gq","f39mltl5qyhyfx.ml","f3a2kpufnyxgau2kd.cf","f3a2kpufnyxgau2kd.ga","f3a2kpufnyxgau2kd.gq","f3a2kpufnyxgau2kd.ml","f3a2kpufnyxgau2kd.tk","f3osyumu.pl","f4k.es","f5.si","f53tuxm9btcr.cf","f53tuxm9btcr.ga","f53tuxm9btcr.gq","f53tuxm9btcr.ml","f53tuxm9btcr.tk","f5foster.com","f6w0tu0skwdz.cf","f6w0tu0skwdz.ga","f6w0tu0skwdz.gq","f6w0tu0skwdz.ml","f6w0tu0skwdz.tk","f7scene.com","f97vfopz932slpak.cf","f97vfopz932slpak.ga","f97vfopz932slpak.gq","f97vfopz932slpak.ml","f97vfopz932slpak.tk","fa23d12wsd.com","fa23dfvmlp.com","faaakb000ktai.ga","fabioscapella.com","fabricsukproperty.com","fabricsvelvet.com","fabricsxla.com","fabricszarin.com","fabrykakadru.pl","fabrykakoronek.pl","facebook-egy.com","facebook-email.cf","facebook-email.ga","facebook-email.ml","facebookmail.gq","facebookmail.ml","faceepicentre.com","faceimagebook.com","facenewsk.fun","faceporn.me","facialboook.site","facilesend.com","fackme.gq","factopedia.pl","factoryburberryoutlet.com","factorydrugs.com","fadingemail.com","fae412wdfjjklpp.com","fae42wsdf.com","fae45223wed23.com","fae4523edf.com","fae452we334fvbmaa.com","fae4dew2vb.com","faea2223dddfvb.com","faea22wsb.com","faea2wsxv.com","faeaswwdf.com","faecesmail.me","fafacheng.com","fafamai.com","fafrem3456ails.com","fag.wf","fagbxy1iioa3ue.cf","fagbxy1iioa3ue.ga","fagbxy1iioa3ue.gq","fagbxy1iioa3ue.ml","fagbxy1iioa3ue.tk","fahmi-amirudin.tech","failbone.com","failinga.nl","fair-paski.pl","fairandcostly.com","fairleigh15733.co.pl","fairymails.net","faithin.org","faithkills.com","faithkills.org","faithmail.org","fajnadomena.pl","fake-box.com","fake-email.pp.ua","fake-foakleys.org","fake-mail.cf","fake-mail.ga","fake-mail.gq","fake-mail.ml","fake-mail.tk","fake-raybans.org","fake.i-3gk.cf","fake.i-3gk.ga","fake.i-3gk.gq","fake.i-3gk.ml","fakedemail.com","fakedoctorsnote.net","fakeemail.de","fakeemail.tk","fakeinbox.cf","fakeinbox.com","fakeinbox.ga","fakeinbox.info","fakeinbox.ml","fakeinbox.tk","fakeinformation.com","fakelouisvuittonrun.com","fakemail.com","fakemail.fr","fakemail.intimsex.de","fakemail.net","fakemail.win","fakemail93.info","fakemailgenerator.com","fakemailgenerator.net","fakemails.cf","fakemails.ga","fakemails.gq","fakemails.ml","fakemailz.com","fakemyinbox.com","fakeoakleys.net","fakeoakleysreal.us","faketemp.email","fakiralio.ga","fakiralio.ml","fakyah.ga","fakyah.ml","falazone.com","falconsportsshop.com","falconsproteamjerseys.com","falconsproteamsshop.com","falconssportshoponline.com","fallin1.ddns.me.uk","fallin2.dyndns.pro","fallinlove.info","fallloveinlv.com","falrxnryfqio.cf","falrxnryfqio.ga","falrxnryfqio.gq","falrxnryfqio.ml","falrxnryfqio.tk","famail.win","familiekersten.tk","famillet.com","familylist.ru","familyright.ru","familytoday.us","fammix.com","fancycarnavalmasks.com","fandamtastic.info","fangoh.com","fannny.cf","fannny.ga","fannny.gq","fannny.ml","fanqiegu.cn","fans2fans.info","fansworldwide.de","fantasymail.de","fantomail.tk","fanz.info","fapa.com","fapfap.7c.org","fapfap.8x.biz","fapzo.com","fapzy.com","faraon.biz.pl","farewqessz.com","farfurmail.tk","fargus.eu","farma-shop.tk","farmaciaporvera.com","farmamail.pw","farmatsept.com","farmer.are.nom.co","farmerlife.us","farmtoday.us","farrse.co.uk","fartwallet.com","farwqevovox.com","fashion-hairistyle.org","fashion-handbagsoutlet.us","fashionactivist.com","fashionans.ru","fashiondesignclothing.info","fashiondesignershoes.info","fashionfwd.net","fashionhandbagsgirls.info","fashionhandbagsonsale.info","fashionshoestrends.info","fashionsportsnews.com","fashionvogueoutlet.com","fashionwallets2012.info","fashionwatches2012.info","fashionwomenaccessories.com","fashionzone69.com","fasigula.name","fassagforpresident.ga","fast-breast-augmentation.info","fast-coin.com","fast-content-producer.com","fast-email.info","fast-isotretinoin.com","fast-loans-uk.all.co.uk","fast-mail.fr","fast-mail.one","fast-max.ovh","fast-sildenafil.com","fast-slimming.info","fast-weightloss-methods.com","fast4me.info","fastacura.com","fastair.info","fastbigfiles.ru","fastcash.net","fastcash.org","fastcash.us","fastcashloannetwork.us","fastcashloans.us","fastcashloansbadcredit.com","fastcdn.cc","fastchevy.com","fastchrysler.com","fastdeal.com.br","fastdownloadcloud.ru","fastee.edu","fastemails.us","fastermail.com","fastermand.com","fasternet.biz","fastestsmtp.com","fastestwayto-losebellyfat.com","fastfitnessroutine.com","fastfoodrecord.com","fastgetsoft.tk","fastgotomail.com","fastkawasaki.com","fastloans.org","fastloans.us","fastloans1080.co.uk","fastmailer.cf","fastmailforyou.net","fastmailnode.com","fastmailnow.com","fastmailplus.com","fastmailservice.info","fastmazda.com","fastmessaging.com","fastmitsubishi.com","fastmobileemail.win","fastmoney.pro","fastnissan.com","fastoutlook.ga","fastpayday-loanscanada.info","fastpaydayloan.us","fastpaydayloans.com","fastpaydayloans.org","fastpaydayloans.us","fastpochta.cf","fastpochta.ga","fastpochta.gq","fastpochta.ml","fastpochta.tk","fastsent.gq","fastservice.com","fastshipcialis.com","fastslimming.info","fastsubaru.com","fastsuzuki.com","fasttoyota.com","fastweightlossplantips.com","fasty.site","fasty.xyz","fastyamaha.com","fatalisto.tk","fatflap.com","fatguys.pl","fathir.cf","fatloss9.com","fatlossdietreviews.com","fatlossfactorfacts.com","fatlossspecialist.com","fatmagulun-sucu-ne.com","fatmize.com","favsin.com","fawwaz.cf","fawwaz.ga","fawwaz.gq","fawwaz.ml","fax.dix.asia","faze.biz","fazer-site.net","fbckyqxfn.pl","fbi.coms.hk","fbma.tk","fbmail.usa.cc","fbmail1.ml","fboss3r.info","fbq4diavo0xs.cf","fbq4diavo0xs.ga","fbq4diavo0xs.gq","fbq4diavo0xs.ml","fbq4diavo0xs.tk","fbshirt.com","fbstigmes.gr","fc66998.com","fca-nv.cf","fca-nv.ga","fca-nv.gq","fca-nv.ml","fca-nv.tk","fcgfdsts.ga","fchief3r.info","fckgoogle.pl","fcml.mx","fcrpg.org","fcwnfqdy.pc.pl","fd21.com","fd99nhm5l4lsk.cf","fd99nhm5l4lsk.ga","fd99nhm5l4lsk.gq","fd99nhm5l4lsk.ml","fd99nhm5l4lsk.tk","fdaswmail.com","fddns.ml","fdev.info","fdfdsfds.com","fdgdfgdfgf.ml","fdkgf.com","fdmail.net","fdn1if5e.pl","fdownload.net","fdtntbwjaf.pl","fea2fa9.servebeer.com","feaethplrsmel.cf","feaethplrsmel.ga","feaethplrsmel.gq","feaethplrsmel.ml","feaethplrsmel.tk","feamail.com","febbraio.cf","febbraio.gq","febmail.com","fecupgwfd.pl","federal-rewards.com","federal.us","federalcash.com","federalcash.us","federalcashagency.com","federalcashloannetwork.com","federalcashloans.com","federalloans.com","federalloans.us","feedspot.com","feedspotmailer.com","feeladult.com","feelgoodsite.tk","feelitall.org.ua","fegdemye.ru","fehuje.ru","feistyfemales.com","fejm.pl","felipecorp.com","felixkanar.ru","felixkanar1.ru","felixkanar2.ru","fellow-me.pw","fellowme.pw","femail.com","femalefemale.com","femalepayday.net","fenceve.com","fengting01.mygbiz.com","fengyun.net","fenionline.com","fenixmail.pw","fer-gabon.org","ferastya.cf","ferastya.ga","ferastya.gq","ferastya.ml","ferastya.tk","ferencikks.org","fergley.com","fermaxxi.ru","fernl.pw","feroxo.com","ferragamobagsjp.com","ferragamoshoesjp.com","ferragamoshopjp.com","fervex-lek.pl","fervex-stosowanie.pl","fesabok.ru","festivuswine.com","festoolrus.ru","fet8gh7.mil.pl","fetchnet.co.uk","fetko.pl","fettometern.com","fewdaysmoney.com","fewfwefwef.com","fewminor.men","ffdeee.co.cc","ffssddcc.com","fgfstore.info","fggjghkgjkgkgkghk.ml","fghmail.net","fgsradffd.com","fhead3r.info","fhqtmsk.pl","fi-pdl.cf","fi-pdl.ga","fi-pdl.gq","fi-pdl.ml","fi-pdl.tk","fianance4all.com","fiat-chrysler.cf","fiat-chrysler.ga","fiat-chrysler.gq","fiat-chrysler.ml","fiat-chrysler.tk","fiat500.cf","fiat500.ga","fiat500.gq","fiat500.ml","fiat500.tk","fiatgroup.cf","fiatgroup.ga","fiatgroup.gq","fiatgroup.ml","fiberglassshowerunits.biz","fibimail.com","fica.ga","fica.gq","fica.ml","fica.tk","ficken.de","fickfotzen.mobi","fictionsite.com","fidelium10.com","fidesrodzinna.pl","fido.be","fierymeets.xyz","fifacity.info","fifecars.co.uk","fightallspam.com","fightwrinkles.edu","figjs.com","figmail.me","figshot.com","figurescoin.com","fihcana.net","fiifke.de","fiji-nedv.ru","fikrihidayah.cf","fikrihidayah.ga","fikrihidayah.gq","fikrihidayah.ml","fikrihidayah.tk","fikrinhdyh.cf","fikrinhdyh.ga","fikrinhdyh.gq","fikrinhdyh.ml","fikrinhdyh.tk","fikumik97.ddns.info","filbert4u.com","filberts4u.com","filcowanie.net","file-load-free.ru","filebuffer.org","fileprotect.org","filerpost.xyz","files-host-box.info","files-usb-drive.info","files.vipgod.ru","filipinoweather.info","film-blog.biz","film-tv-box.ru","filmak.pl","filmbak.com","filmemack.com","filmenstreaming.esy.es","filmharatis.xyz","filmhd720p.co","filmporno2013.com","filmyerotyczne.pl","filmym.pl","filzmail.com","finaljudgedomain.com","finaljudgeplace.com","finaljudgesite.com","finaljudgewebsite.com","finalndcasinoonline.com","finance.uni.me","financehowtolearn.com","financeideas.org","financeland.com","financetutorial.org","find-me-watch.com","find.cy","findbesthgh.com","findcoatswomen.com","findemail.info","findhotmilfstonight.com","findingcomputerrepairsanbernardino.com","findlocalusjobs.com","findmovingboxes.net","findu.pl","finek.net","finery.pl","fingermouse.org","finioios.gr","finland-nedv.ru","finnahappen.com","fir.hk","firamax.club","firecookie.ml","fireden.net","firef0x.cf","firef0x.ga","firef0x.gq","firef0x.ml","firef0x.tk","fireflies.edu","firemail.cc","firemail.org.ua","firemail.uz.ua","firematchvn.cf","firematchvn.ga","firematchvn.gq","firematchvn.ml","firematchvn.tk","firemymail.co.cc","firestore.pl","firestylemail.tk","firewallremoval.com","firma-frugtordning.dk","firma-remonty-warszawa.pl","firmaa.pl","firmaogrodniczanestor.pl","firmfinancecompany.org","first-email.net","first-mail.info","first.baburn.com","firstaidtrainingmelbournecbd.com.au","firstcapitalfibers.com","firstclassarticle.com","firstclassemail.online","firstexpertise.com","firstin.ca","firstinforestry.com","firstk.co.cc","firstpaydayloanuk.co.uk","firstpuneproperties.com","firststopmusic.com","firsttimes.in","firsttradelimited.info","fish.skytale.net","fishfortomorrow.xyz","fishingleisure.info","fishtropic.com","fishyes.info","fitflopsandals-us.com","fitflopsandalsonline.com","fitfopsaleonline.com","fitnesrezink.ru","fitness-exercise-machine.com","fitness-weight-loss.net","fitness-wolke.de","fitnessjockey.org","fitnessmojo.org","fitnessreviewsonline.com","fitnesszbyszko.pl","fitschool.be","fitschool.space","fittinggeeks.pl","fitzgeraldforjudge.com","five-club.com","five-plus.net","five.emailfake.ml","five.fackme.gq","fivefineshine.org","fivemail.de","fivesmail.org.ua","fivestarclt.com","fixmail.tk","fixthiserror.com","fixyourbrokenrelationships.com","fizjozel.pl","fizmail.com","fizmail.win","fizo.edu.com","fj1971.com","fjkwerhfui.com","fjqbdg5g9fycb37tqtv.cf","fjqbdg5g9fycb37tqtv.ga","fjqbdg5g9fycb37tqtv.gq","fjqbdg5g9fycb37tqtv.ml","fjqbdg5g9fycb37tqtv.tk","fjradvisors.net","fjumlcgpcad9qya.cf","fjumlcgpcad9qya.ga","fjumlcgpcad9qya.gq","fjumlcgpcad9qya.ml","fjumlcgpcad9qya.tk","fkdsloweqwemncasd.ru","fkfgmailer.com","fkksol.com","fklbiy3ehlbu7j.cf","fklbiy3ehlbu7j.ga","fklbiy3ehlbu7j.gq","fklbiy3ehlbu7j.ml","fklbiy3ehlbu7j.tk","fknblqfoet475.cf","fkoljpuwhwm97.cf","fkoljpuwhwm97.ga","fkoljpuwhwm97.gq","fkoljpuwhwm97.ml","fkrcdwtuykc9sgwlut.cf","fkrcdwtuykc9sgwlut.ga","fkrcdwtuykc9sgwlut.gq","fkrcdwtuykc9sgwlut.ml","fkrcdwtuykc9sgwlut.tk","fkughosck.pl","fkuih.com","flageob.info","flamonis.tk","flarmail.ga","flash-mail.pro","flash-mail.xyz","flashbox.5july.org","flashgoto.com","flashingboards.net","flashmail.co","flashmail.pro","flashonlinematrix.com","flashu.nazwa.pl","flat-whose.win","flatidfa.org.ua","flatoledtvs.com","flaxx.ru","flcarpetcleaningguide.org","fleckens.hu","fleetcommercialfinance.org","flemail.com","flemail.ru","flester.igg.biz","fleuristeshwmckenna.com","flexbeltcoupon.net","flexrosboti.xyz","flickshot.id","flighttogoa.com","flirtey.pw","flitafir.de","flixluv.com","flnm1bkkrfxah.cf","flnm1bkkrfxah.ga","flnm1bkkrfxah.gq","flnm1bkkrfxah.ml","flnm1bkkrfxah.tk","floodbrother.com","flooringbestoptions.com","floorlampinfo.com","floranswer.ru","florida-nedv.ru","floridafleeman.com","floridastatevision.info","floridavacationsrentals.org","flossuggboots.com","flotprom.ru","flowercouponsz.com","flowermerry.com","flowermerry.net","flowerss.website","flowerwyz.com","flowmeterfaq.com","flowu.com","floyd-mayweather.info","floyd-mayweather2011.info","floydmayweathermarcosmaidana.com","fls4.gleeze.com","flskdfrr.com","flu-cc.flu.cc","flu.cc","flucas.eu","flucassodergacxzren.eu","flucc.flu.cc","fluidforce.net","fluidsoft.us","flurostation.com","flurre.com","flurred.com","fly-ts.de","flyernyc.com","flyfrv.tk","flyinggeek.net","flyingjersey.info","flypicks.com","flyrics.ru","flyspam.com","flyxnet.pw","fm365.com","fm69.cf","fm69.ga","fm69.gq","fm69.ml","fm69.tk","fmail.ooo","fmail.party","fmail.pw","fmail10.de","fmailx.tk","fmailxc.com","fmailxc.com.com","fmfmk.com","fmgroup-jacek.pl","fmv13ahtmbvklgvhsc.cf","fmv13ahtmbvklgvhsc.ga","fmv13ahtmbvklgvhsc.gq","fmv13ahtmbvklgvhsc.ml","fmv13ahtmbvklgvhsc.tk","fnnus3bzo6eox0.cf","fnnus3bzo6eox0.ga","fnnus3bzo6eox0.gq","fnnus3bzo6eox0.ml","fnnus3bzo6eox0.tk","fnord.me","fnzm.net","fo9t34g3wlpb0.cf","fo9t34g3wlpb0.ga","fo9t34g3wlpb0.gq","fo9t34g3wlpb0.ml","fo9t34g3wlpb0.tk","foakleyscheap.net","fobsos.ml","focolare.org.pl","fogkkmail.com","foliaapple.pl","folianokia.pl","folifirvi.net","foobarbot.net","food4kid.ru","foodbooto.com","foodrestores.com","foodslosebellyfat.com","foodtherapy.top","foopets.pl","footard.com","footballan.ru","foothillsurology.com","foquita.com","for-all.pl","for1mail.tk","for4.com","for4mail.com","forecastertests.com","foreclosurefest.com","foreskin.cf","foreskin.ga","foreskin.gq","foreskin.ml","foreskin.tk","forestar.edu","forestcrab.com","forestermail.info","foresthope.com","foreverall.org.ua","forex-for-u.net","forexbudni.ru","forexjobing.ml","forexpro.re","forexsite.info","forextradingsystemsreviews.info","forextrendtrade.com","forgetmail.com","forklift.edu","formail22.dlinkddns.com","formatpoll.net","formdmail.com","formdmail.net","formserwis.pl","fornow.eu","forore.ru","forotenis.com","forprice.co","forrealnetworks.com","forspam.net","forthebestsend.com","fortunatelady.com","fortunatelady.net","fortune-free.com","forum.defqon.ru","forum.minecraftplayers.pl","forum.multi.pl","forumbacklinks.net","forumoxy.com","forward.cat","forzataraji.com","fossimaila.info","fossimailb.info","fossimailh.info","foto-videotrak.pl","foto-znamenitostei31.ru","fotoespacio.net","fotografiaslubnawarszawa.pl","fotoksiazkafotoalbum.pl","fotoliegestuhl.net","fotoplik.pl","fotorezensionen.info","fouddas.gr","foundationbay.com","four.emailfake.ml","four.fackme.gq","fouristic.us","fourth.bgchan.net","foxja.com","foxnetwork.com","foxschool.edu","foxtrotter.info","foxwoods.com","foy.kr","fozmail.info","fphiulmdt3utkkbs.cf","fphiulmdt3utkkbs.ga","fphiulmdt3utkkbs.gq","fphiulmdt3utkkbs.ml","fphiulmdt3utkkbs.tk","fq1my2c.com","fq8sfvpt0spc3kghlb.cf","fq8sfvpt0spc3kghlb.ga","fq8sfvpt0spc3kghlb.gq","fq8sfvpt0spc3kghlb.ml","fq8sfvpt0spc3kghlb.tk","fqtxjxmtsenq8.cf","fqtxjxmtsenq8.ga","fqtxjxmtsenq8.gq","fqtxjxmtsenq8.ml","fqtxjxmtsenq8.tk","fr-air-max.org","fr-air-maxs.com","fr-airmaxs.com","fr.nf","fr33mail.info","fr3546ruuyuy.cf","fr3546ruuyuy.ga","fr3546ruuyuy.gq","fr3546ruuyuy.ml","fr3546ruuyuy.tk","fr4nk3nst3inersenuke22.com","fr4nk3nst3inerweb20.com","fraddyz.ru","fragolina2.tk","framemail.cf","francanet.com.br","france-monclers.com","france-nedv.ru","francemonclerpascherdoudoune1.com","francepoloralphlaurenzsgpascher.com","franco.com","frank-girls.com","franksunter.ml","frapmail.com","frappina.tk","frappina99.tk","frason.eu","freakmail.co.cc","freclockmail.co.cc","freddymail.com","fredperrycoolsale.com","free-4-everybody.bid","free-chat-emails.bid","free-classifiedads.info","free-dl.com","free-email-address.info","free-email.cf","free-email.ga","free-episode.com","free-ipad-deals.com","free-mail.bid","free-mails.bid","free-max-base.info","free-names.info","free-server.bid","free-softer.cu.cc","free-temp.net","free-web-mails.com","free-webmail1.info","free.mail52.cf","free.mail52.ga","free.mail52.gq","free.mail52.ml","free.mail52.tk","free123mail.com","free4everybody.bid","freeaccnt.ga","freealtgen.com","freebabysittercam.com","freebee.com","freeblackbootytube.com","freeblogger.ru","freebullets.net","freebusinessdomains.info","freecams4u.com","freecat.net","freechargevn.cf","freechargevn.ga","freechargevn.gq","freechargevn.ml","freechargevn.tk","freechatemails.bid","freechatemails.men","freechristianbookstore.com","freeclassifiedsonline.in","freecodebox.com","freecontests.xyz","freecontractorfinder.com","freedgiftcards.com","freedivorcelawyers.net","freedom-mail.ga","freedom.casa","freedom4you.info","freedompop.us","freedownloadmedicalbooks.com","freeeducationvn.cf","freeeducationvn.ga","freeeducationvn.gq","freeeducationvn.ml","freeeducationvn.tk","freeemail4u.org","freeemailnow.info","freeemailproviders.info","freeemails.ce.ms","freeemails.racing","freeemailservice.info","freefattymovies.com","freeforall.site","freegetvpn.com","freehealthadvising.info","freehosting.men","freehosting2010.com","freehotmail.net","freeimeicheck.com","freeimtips.info","freeinbox.email","freeindexer.com","freeinvestoradvice.com","freeipadnowz.com","freelail.com","freelance-france.eu","freelance-france.euposta.store","freelancejobreport.com","freelasvegasshowtickets.net","freeletter.me","freelibraries.info","freelivesex1.info","freelymail.com","freemail-host.info","freemail.bid","freemail.co.pl","freemail.hu","freemail.men","freemail.ms","freemail.nx.cninfo.net","freemail.online.tj.cn","freemail.trade","freemail.trankery.net","freemail.tweakly.net","freemail.waw.pl","freemail000.pl","freemail3949.info","freemail4.info","freemailboxy.com","freemaillink.com","freemailmail.com","freemailnow.net","freemails.bid","freemails.cf","freemails.download","freemails.ga","freemails.men","freemails.ml","freemails.stream","freemailservice.tk","freemailsrv.info","freemailto.cz.cc","freemeil.ga","freemeil.gq","freemeil.ml","freemeil.tk","freemommyvids.com","freemoney.pw","freemymail.org","freemyworld.cf","freemyworld.ga","freemyworld.gq","freemyworld.ml","freemyworld.tk","freenfulldownloads.net","freeo.pl","freeoffers123.com","freeolamail.com","freeonlineke.com","freephonenumbers.us","freephotoretouch.com","freeplumpervideos.com","freepoincz.net","freepop3.co.cc","freeprice.co","freeread.co.uk","freeringers.in","freeroid.com","freerubli.ru","freerunproshop.com","freerunprostore.com","freesamplesuk2014.co.uk","freeschoolgirlvids.com","freeserver.bid","freesexchats24.com","freesexshows.us","freeshemaledvds.com","freesistercam.com","freesistervids.com","freesmsvoip.com","freestuffonline.info","freetds.net","freeteenbums.com","freethought.ml","freetmail.in","freetmail.net","freetubearchive.com","freeunlimitedebooks.com","freevipbonuses.com","freeweb.email","freewebmaile.com","freewebpages.bid","freewebpages.stream","freewebpages.top","freexms.com","freexrumer.com","freezeast.co.uk","freezzzm.site","fremails.com","frenchbedsonline777.co.uk","frenchcuff.org","frequential.info","fresclear.com","freshattempt.com","freshautonews.ru","freshbreadcrumbs.com","freshmail.com","freshsmokereview.com","freshviralnewz.club","fressmind.us","freunde.ru","freundin.ru","frexmail.co.cc","frgviana-nedv.ru","friedfriedfrogs.info","friendlymail.co.uk","friscaa.cf","friscaa.ga","friscaa.gq","friscaa.ml","friscaa.tk","friteuseelectrique.net","frizbi.fr","frmonclerinfo.info","from.onmypc.info","front14.org","frontiers.com","frooogle.com","frouse.ru","frozen.com","frozenfund.com","frpascherbottes.com","fruertwe.com","frugalpens.com","fruitandvegetable.xyz","frutti-tutti.name","frycowe.pl","fryzury-krotkie.pl","fs-fitzgerald.cf","fs-fitzgerald.ga","fs-fitzgerald.gq","fs-fitzgerald.ml","fs-fitzgerald.tk","fs16dubzzn0.cf","fs16dubzzn0.ga","fs16dubzzn0.gq","fs16dubzzn0.ml","fs16dubzzn0.tk","fsagc.xyz","fsfsdf.org","fskk.pl","fsmilitary.com","fsociety.org","fsrfwwsugeo.cf","fsrfwwsugeo.ga","fsrfwwsugeo.gq","fsrfwwsugeo.ml","fsrfwwsugeo.tk","fsxflightsimulator.net","ft0wqci95.pl","ftg8aep4l4r5u.cf","ftg8aep4l4r5u.ga","ftg8aep4l4r5u.gq","ftg8aep4l4r5u.ml","ftg8aep4l4r5u.tk","ftgb2pko2h1eyql8xbu.cf","ftgb2pko2h1eyql8xbu.ga","ftgb2pko2h1eyql8xbu.gq","ftgb2pko2h1eyql8xbu.ml","ftgb2pko2h1eyql8xbu.tk","ftnupdatecatalog.ru","ftoflqad9urqp0zth3.cf","ftoflqad9urqp0zth3.ga","ftoflqad9urqp0zth3.gq","ftoflqad9urqp0zth3.ml","ftoflqad9urqp0zth3.tk","ftp.sh","ftpbd.com","ftpinc.ca","fu6znogwntq.cf","fu6znogwntq.ga","fu6znogwntq.gq","fu6znogwntq.ml","fu6znogwntq.tk","fubkdjkyv.pl","fubuki.shp7.cn","fuckedupload.com","fuckingduh.com","fuckinhome.com","fuckme69.club","fucknloveme.top","fuckoramor.ru","fuckrosoft.com","fucktuber.info","fuckxxme.top","fuckzy.com","fudanwang.com","fudgerub.com","fuelesssapi.xyz","fufrh4xatmh1hazl.cf","fufrh4xatmh1hazl.ga","fufrh4xatmh1hazl.gq","fufrh4xatmh1hazl.ml","fufrh4xatmh1hazl.tk","fufuf.bee.pl","fuhoy.com","fuirio.com","fujitv.cf","fujitv.ga","fujitv.gq","fukolpza.com.pl","fuktard.co.in","fullalts.cf","fulledu.ru","fullen.in","fullepisodesnow.com","fullermail.men","fullhomepacks.info","fullsoftdownload.info","fulvie.com","fumw7idckt3bo2xt.ga","fumw7idckt3bo2xt.ml","fumw7idckt3bo2xt.tk","fun2.biz","fun2night.club","fun64.com","fun64.net","funandrun.waw.pl","fundraisingtactics.com","funeemail.info","funfar.pl","funfoodmachines.co.uk","funktales.com","funkyjerseysof.com","funniestonlinevideos.org","funnycodesnippets.com","funnyfrog.com.pl","funnymail.de","funnyrabbit.icu","funnysmell.info","funxmail.ga","fuqus.com","furnitureinfoguide.com","furniturm.com","further-details.com","furthermail.com","furusato.tokyo","furzauflunge.de","fus-ro-dah.ru","fuse-vision.com","fusixgasvv1gbjrbc.cf","fusixgasvv1gbjrbc.ga","fusixgasvv1gbjrbc.gq","fusixgasvv1gbjrbc.ml","fusixgasvv1gbjrbc.tk","futuramarketing.we.bs","futuraseoservices.com","futuredvd.info","futuregenesplicing.in","futuregood.pw","futuremail.info","futureof2019.info","futuresoundcloud.info","futuresports.ru","futuristicplanemodels.com","fuvptgcriva78tmnyn.cf","fuvptgcriva78tmnyn.ga","fuvptgcriva78tmnyn.gq","fuvptgcriva78tmnyn.ml","fuw65d.cf","fuw65d.ga","fuw65d.gq","fuw65d.ml","fuw65d.tk","fuwa.be","fuwa.li","fuwamofu.com","fux0ringduh.com","fuzmail.info","fvhnqf7zbixgtgdimpn.cf","fvhnqf7zbixgtgdimpn.ga","fvhnqf7zbixgtgdimpn.gq","fvhnqf7zbixgtgdimpn.ml","fvhnqf7zbixgtgdimpn.tk","fvqpejsutbhtm0ldssl.ga","fvqpejsutbhtm0ldssl.ml","fvqpejsutbhtm0ldssl.tk","fvsxedx6emkg5eq.gq","fvsxedx6emkg5eq.ml","fvsxedx6emkg5eq.tk","fvuch7vvuluqowup.cf","fvuch7vvuluqowup.ga","fvuch7vvuluqowup.gq","fvuch7vvuluqowup.ml","fvuch7vvuluqowup.tk","fvurtzuz9s.cf","fvurtzuz9s.ga","fvurtzuz9s.gq","fvurtzuz9s.ml","fvurtzuz9s.tk","fw-nietzsche.cf","fw-nietzsche.ga","fw-nietzsche.gq","fw-nietzsche.ml","fw-nietzsche.tk","fw.moza.pl","fw2.me","fw6m0bd.com","fwmuqvfkr.pl","fws.fr","fwxzvubxmo.pl","fx-banking.com","fx-brokers.review","fxnxs.com","fxprix.com","fyii.de","fynuas6a64z2mvwv.cf","fynuas6a64z2mvwv.ga","fynuas6a64z2mvwv.gq","fynuas6a64z2mvwv.ml","fynuas6a64z2mvwv.tk","fyromtre.tk","fys2zdn1o.pl","fyvznloeal8.cf","fyvznloeal8.ga","fyvznloeal8.gq","fyvznloeal8.ml","fyvznloeal8.tk","fztvgltjbddlnj3nph6.cf","fztvgltjbddlnj3nph6.ga","fztvgltjbddlnj3nph6.gq","fztvgltjbddlnj3nph6.ml","fzyutqwy3aqmxnd.cf","fzyutqwy3aqmxnd.ga","fzyutqwy3aqmxnd.gq","fzyutqwy3aqmxnd.ml","fzyutqwy3aqmxnd.tk","g-mailix.com","g-meil.com","g-o-o-g-l-e.cf","g-o-o-g-l-e.ga","g-o-o-g-l-e.gq","g-o-o-g-l-e.ml","g-starblog.org","g-timyoot.ga","g.hmail.us","g.polosburberry.com","g.seoestore.us","g.ycn.ro","g00g.cf","g00g.ga","g00g.gq","g00g.ml","g00gl3.gq","g00gl3.ml","g00glechr0me.cf","g00glechr0me.ga","g00glechr0me.gq","g00glechr0me.ml","g00glechr0me.tk","g00gledrive.ga","g00qle.ru","g05zeg9i.com","g0mail.com","g0zr2ynshlth0lu4.cf","g0zr2ynshlth0lu4.ga","g0zr2ynshlth0lu4.gq","g0zr2ynshlth0lu4.ml","g0zr2ynshlth0lu4.tk","g14l71lb.com","g1kolvex1.pl","g1xmail.top","g2.brassneckbrewing.com","g212dnk5.com","g2tpv9tpk8de2dl.cf","g2tpv9tpk8de2dl.ga","g2tpv9tpk8de2dl.gq","g2tpv9tpk8de2dl.ml","g2tpv9tpk8de2dl.tk","g2xmail.top","g3nk2m41ls.ga","g3nkz-m4ils.ga","g3nkzmailone.ga","g3xmail.top","g4hdrop.us","g4rm1nsu.com","g4zk7mis.mil.pl","g50hlortigd2.ga","g50hlortigd2.ml","g50hlortigd2.tk","g7kgmjr3.pl","g7lkrfzl7t0rb9oq.cf","g7lkrfzl7t0rb9oq.ga","g7lkrfzl7t0rb9oq.gq","g7lkrfzl7t0rb9oq.ml","g7lkrfzl7t0rb9oq.tk","gaanerbhubon.net","gabon-nedv.ru","gabox.store","gachupa.com","gadget-space.com","gadgetreviews.net","gadgetsfair.com","gaf.oseanografi.id","gafrem3456ails.com","gafy.net","gag16dotw7t.cf","gag16dotw7t.ga","gag16dotw7t.gq","gag16dotw7t.ml","gag16dotw7t.tk","gaggle.net","gaiti-nedv.ru","gajesajflk.cf","gajesajflk.gq","gakbec.us","gakkurang.com","galablogaza.com","galaxy-s9.cf","galaxy-s9.ga","galaxy-s9.gq","galaxy-s9.ml","galaxy-s9.tk","galaxy-tip.com","galaxy.tv","galaxyarmy.tech","galaxys8giveaway.us","galerielarochelle.com","galismarda.com","gallowaybell.com","gally.jp","galvanmail.men","gamail.com","gamail.top","gamamail.tk","game-world.pro","game.com","gamecheatfree.xyz","gamecodebox.com","gamecodesfree.com","gamedaytshirt.com","gamegregious.com","gameme.men","gamercosplay.pl","gamerentalreview.co.uk","games-online24.co.uk","games-zubehor.com","games0.co.uk","games4free.flu.cc","games4free.info","gamesbrands.space","gamesonlinefree.ru","gamesonlinez.co.uk","gamesoonline.com","gamesportal.me","gamevillage.org","gamewedota.co.cc","gamgling.com","gamil.com","gaminators.org","gamma.org.pl","gammafoxtrot.ezbunko.top","gamno.config.work","gamora274ey.cf","gamora274ey.ga","gamora274ey.gq","gamora274ey.ml","gamora274ey.tk","gamuci.com","gamutimaging.com","gan.lubin.pl","gangu.cf","gangu.gq","gangu.ml","ganihomes.com","ganoderme.ru","ganslodot.top","gaolrer.com","gapemail.ga","gappk89.pl","gaqa.com","garage46.com","garagedoormonkey.com","garagedoorschina.com","garasikita.pw","garaze-wiaty.pl","garbagecollector.org","garbagemail.org","garciniacambogiaextracts.net","garden-plant.ru","gardenans.ru","gardenscape.ca","gardercrm.ru","garibomail2893.biz","garillias22.net","garingsin.cf","garingsin.ga","garingsin.gq","garingsin.ml","garizo.com","garlanddusekmail.net","garliclife.com","garnett.us","garnettmailer.com","garnous.com","garrifulio.mailexpire.com","garrymccooey.com","garrynacov.cf","gartenarbeiten-muenchen.ovh","garudaesports.com","garyschollmeier.com","gas-avto.com","gas-spark-plugs.pp.ua","gaselectricrange.com","gasocin.pl","gassfey.com","gasssboss.club","gasto.com","gaterremeds1975.eu","gateway3ds.eu","gathelabuc.almostmy.com","gav0.com","gawab.com","gawai-nedv.ru","gawmail.com","gayana-nedv.ru","gaymoviedome.in","gazebostoday.com","gazetapracapl.pl","gazetawww.pl","gazettenews.info","gbcmail.win","gberos-makos.com","gbf48123.com","gbmail.top","gbpartners.net","gbs7yitcj.pl","gbtxtloan.co.uk","gcfleh.com","gchatz.ga","gcmail.top","gcordobaguerrero.com","gcznu5lyiuzbudokn.ml","gcznu5lyiuzbudokn.tk","gd6ubc0xilchpozgpg.cf","gd6ubc0xilchpozgpg.ga","gd6ubc0xilchpozgpg.gq","gd6ubc0xilchpozgpg.ml","gd6ubc0xilchpozgpg.tk","gdb.armageddon.org","gdfretertwer.com","gdf.it","gdmail.top","gdradr.com","gdsutzghr.pl","gdziearchitektura.biz","geail.com","geararticles.com","geardos.net","geargum.com","gears4camping.com","geartower.com","geaviation.cf","geaviation.ga","geaviation.gq","geaviation.ml","geaviation.tk","gebaeudereinigungsfirma.com","geburtstags.info","geburtstagsgruesse.club","geburtstagsspruche24.info","gecotspeed04flash.ml","ged34.com","gedhemu.ru","gedmail.win","gedsmail.com","geekemailfreak.bid","geekforex.com","geew.ru","geezmail.ga","gefriergerate.info","geggos673.com","gehensiemirnichtaufdensack.de","gekk.edu","gekury4221mk.cf","gekury4221mk.ga","gekury4221mk.gq","gekury4221mk.ml","gekury4221mk.tk","gelatoprizes.com","geldwaschmaschine.de","gelitik.in","geludkita.cf","geludkita.ga","geludkita.gq","geludkita.ml","geludkita.tk","gemail.com","gen.uu.gl","gen16.me","genderfuck.net","general-electric.cf","general-electric.ga","general-electric.gq","general-electric.ml","general-motors.tk","generatoa.com","generator.email","genericaccutanesure.com","genericcialis-usa.net","genericcialissure.com","genericcialisusa.net","genericclomidsure.com","genericdiflucansure.com","genericflagylonline24h.com","genericlasixsure.com","genericlevitra-usa.com","genericprednisonesure.com","genericpropeciaonlinepills.com","genericpropeciasure.com","genericretinaonlinesure.com","genericretinasure.com","genericsingulairsure.com","genericviagra-onlineusa.com","genericviagra-usa.com","genericviagra69.bid","genericviagraonline-usa.com","genericwithoutaprescription.com","genericzithromaxonline.com","genericzoviraxsure.com","genericzyprexasure.com","genf20plus.com","genf20review1.com","genk5mail2.ga","gennox.com","genotropin.in","genoutdo.eu","genrephotos.ru","genteymac.net","genturi.it","genuinemicrosoftkeyclub.com","genvia01.com","geo-crypto.com","geoclsbjevtxkdant92.cf","geoclsbjevtxkdant92.ga","geoclsbjevtxkdant92.gq","geoclsbjevtxkdant92.ml","geoclsbjevtxkdant92.tk","geodezjab.com","geoglobe.com","geoinbox.info","geolocalroadmap.com","geomail.win","geometricescape.com","georights.net","gepatitu-c.net","geraldlover.org","geremail.info","germainarena.com","germanmail.de.pn","germanmails.biz","germanyxon.com","gero.us","geroev.net","geronra.com","gerovarnlo.com","gerties.com.au","geschent.biz","get-bitcoins.club","get-bitcoins.online","get-dental-implants.com","get-mail.cf","get-mail.ga","get-mail.ml","get-mail.tk","get.pp.ua","get1mail.com","get2mail.fr","get30daychange.com","get365.pw","get42.info","getahairstyle.com","getairmail.cf","getairmail.com","getairmail.ga","getairmail.gq","getairmail.ml","getairmail.tk","getamailbox.org","getapet.net","getasolarpanel.co.uk","getaviciitickets.com","getbackinthe.kitchen","getbusinessontop.com","getcleanskin.info","getcoolmail.info","getcoolstufffree.com","geteit.com","getfreecoupons.org","getfreefollowers.org","getfun.men","getgymbags.com","gethimbackforeverreviews.com","getinboxes.com","getinharvard.com","getinsuranceforyou.com","getitfast.com","getjar.pl","getjulia.com","getladiescoats.com","getmails.eu","getmails.pw","getmailsonline.com","getmoziki.com","getnada.cf","getnada.com","getnada.ga","getnada.gq","getnada.ml","getnada.tk","getnewnecklaces.com","getnowdirect.com","getnowtoday.cf","getocity.com","getonemail.com","getonemail.net","getpaulsmithget.com","getqueenbedsheets.com","getridofacnecure.com","getridofherpesreview.org","getsimpleemail.com","getstructuredsettlement.com","getsuz.com","gett.icu","getvmail.net","getwomenfor.me","gewqsza.com","gf-roofing-contractors.co.uk","gf.wlot.in","gfcom.com","gfdrwqwex.com","gffcqpqrvlps.cf","gffcqpqrvlps.ga","gffcqpqrvlps.gq","gffcqpqrvlps.tk","gfgfgf.org","gfh522xz.com","gfhjk.com","gflwpmvasautt.cf","gflwpmvasautt.ga","gflwpmvasautt.gq","gflwpmvasautt.ml","gflwpmvasautt.tk","gfmail.cf","gfmail.ga","gfmail.gq","gfmail.tk","gfmewrsf.com","gfounder.org","gfremail4u3.org","gfvgr2.pl","gg-byron.cf","gg-byron.ga","gg-byron.gq","gg-byron.ml","gg-byron.tk","gg-squad.ml","gg-zma1lz.ga","ggbags.info","ggfutsal.cf","ggg.pp.ua","gggmail.pl","gggmarketingmail.com","gghfjjgt.com","ggmail.com","ggmail.guru","gmailnator.com","ggmob-us.fun","ggooglecn.com","ggrreds.com","ggtoll.com","ggxx.com","gh-stroy.ru","gh.wlot.in","gh2xuwenobsz.cf","gh2xuwenobsz.ga","gh2xuwenobsz.gq","gh2xuwenobsz.ml","gh2xuwenobsz.tk","ghcptmvqa.pl","ghcrublowjob20127.com","ghdfinestore.com","ghdhairstraighteneraq.com","ghdhairstraightenersuk.info","ghdpascheresfrfrance.com","ghdsaleukstore.com","ghdshopnow.com","ghdshopuk.com","ghdstraightenersukshop.com","ghdstraightenersz.com","ghea.ml","ghgluiis.tk","ghid-afaceri.com","ghkoyee.com.uk","ghost-squad.eu","ghostadduser.info","ghosttexter.de","ghtreihfgh.xyz","ghymail.com","gi-pro.org","giacmosuaviet.info","giaiphapmuasam.com","gianna1121.club","giantmail.de","giantwebs2010.info","giaoisgla35ta.cf","gibit.us","giblpyqhb.pl","gibsonmail.men","gicua.com","gieldatfi.pl","giessdorf.eu.org","gifmehard.ru","gift-link.com","gifto12.com","gifts4homes.com","giftscrafts2012.info","giftwatches.info","giftyello.ga","gigantix.co.uk","gigauoso.com","gigs.craigslist.org","gikmail.com","gilababi1.ml","gilray.net","gimail.com","gimel.net","gimesson.pe.hu","gimmehits.com","gindatng.ga","gine.com","ginn.cf","ginn.gq","ginn.ml","ginn.tk","ginxmail.com","ginzi.be","ginzi.co.uk","ginzi.es","ginzi.eu","ginzi.net","ginzy.co.uk","ginzy.eu","ginzy.org","giochi0.it","giochiz.com","giofiodl.gr","giogio.cf","giogio.gq","giogio.ml","giooig.cf","giooig.ga","giooig.gq","giooig.ml","giooig.tk","giorgio.ga","giplwsaoozgmmp.ga","giplwsaoozgmmp.gq","giplwsaoozgmmp.ml","giplwsaoozgmmp.tk","gipsowe.waw.pl","girl-beautiful.com","girl-cute.com","girl-nice.com","girlcosmetic.info","girleasy.com","girlemail.org","girlmail.win","girlncool.com","girls-stars.ru","girls-xs.ru","girlsforfun.tk","girlsindetention.com","girlsu.com","girlsundertheinfluence.com","giromail.info","gishpuppy.com","gispgeph6qefd.cf","gispgeph6qefd.ga","gispgeph6qefd.gq","gispgeph6qefd.ml","gispgeph6qefd.tk","gitpost.icu","gitumau.ga","gitumau.ml","gitumau.tk","giuras.club","giuypaiw8.com","giveh2o.info","givethefalconslight.com","givmail.com","givmy.com","giwwoljvhj.pl","giyam.com","gjgjg.pw","gkjeee.com","gkorii.com","gkuaisyrsib8fru.cf","gkuaisyrsib8fru.ga","gkuaisyrsib8fru.gq","gkuaisyrsib8fru.ml","gkuaisyrsib8fru.tk","gkwerto4wndl3ls.cf","gkwerto4wndl3ls.ga","gkwerto4wndl3ls.gq","gkwerto4wndl3ls.ml","gkwerto4wndl3ls.tk","gkyyepqno.pl","gladysh.com","glamourbeauty.org","glamourcow.com","glamurr-club.ru","glasgowmotors.co.uk","glassaas.site","glasscanisterheaven.com","glasses88.com","glassesoutletsaleuk.co.uk","glassesoutletuksale.co.uk","glassworks.cf","glavsg.ru","gleeze.com","glennvhalado.tech","glick.tk","glitch.sx","gliwicemetkownice.pl","glmail.ga","glmail.top","glmux.com","globalcarinsurance.top","globaleuro.net","globalpuff.org","globaltouron.com","glockneronline.com","glocknershop.com","gloom.org","gloria-tours.com","gloriousfuturedays.com","glovesprotection.info","glowinbox.info","glqbsobn8adzzh.cf","glqbsobn8adzzh.ga","glqbsobn8adzzh.gq","glqbsobn8adzzh.ml","glqbsobn8adzzh.tk","glubex.com","glucosegrin.com","gma2il.com","gmaeil.com","gmai.com","gmaieredd.com","gmaiil.com","gmaiil.ml","gmaiilll.cf","gmaiilll.gq","gmaik.com","gmail-box.com","gmail-fiji.gq","gmail.ax","gmail.com.co","gmail.com.pl","gmail.cu.uk","gmail.gm9.com","gmail.gr.com","gmail.net","gmail.pp.ua","gmail4u.eu","gmailas.com","gmailasdf.com","gmailasdf.net","gmailasdfas.com","gmailasdfas.net","gmailbete.cf","gmailcomcom.com","gmaildd.com","gmaildd.net","gmaildfklf.com","gmaildfklf.net","gmaildll.com","gmaildort.com","gmaildottrick.com","gmailere.com","gmailere.net","gmaileria.com","gmailerttl.com","gmailerttl.net","gmailertyq.com","gmailfe.com","gmailgirl.net","gmailhost.net","gmailhre.com","gmailhre.net","gmailjj.com","gmaill.com","gmailldfdefk.com","gmailldfdefk.net","gmailll.cf","gmailll.ga","gmailll.gq","gmaillll.ga","gmaillll.ml","gmailllll.ga","gmaills.eu","gmailmail.ga","gmailmarina.com","gmailner.com","gmailnew.com","gmailom.co","gmailpop.ml","gmailpopnew.com","gmailppwld.com","gmailppwld.net","gmailr.com","gmails.com","gmailsdfd.com","gmailsdfd.net","gmailsdfsd.com","gmailsdfsd.net","gmailsdfskdf.com","gmailsdfskdf.net","gmailskm.com","gmailssdf.com","gmailu.ru","gmailweerr.com","gmailweerr.net","gmaily.tk","gmailzdfsdfds.com","gmailzdfsdfds.net","gmal.com","gmall.com","gmasil.com","gmatch.org","gmcsklep.pl","gmdabuwp64oprljs3f.ga","gmdabuwp64oprljs3f.ml","gmdabuwp64oprljs3f.tk","gmeail.com","gmeeail.com","gmeil.me","gmial.com","gmixi.com","gmmails.com","gmmaojin.com","gmmx.com","gmojl.com","gmsdfhail.com","gmssail.com","gmx.dns-cloud.net","gmx.dnsabr.com","gmx.es","gmx.fr.nf","gmx1mail.top","gmxip8vet5glx2n9ld.cf","gmxip8vet5glx2n9ld.ga","gmxip8vet5glx2n9ld.gq","gmxip8vet5glx2n9ld.ml","gmxip8vet5glx2n9ld.tk","gmxk.net","gmxmail.cf","gmxmail.gq","gmxmail.tk","gmxmail.top","gmxmail.win","gn8.cc","gnail.com","gnajuk.me","gnctr-calgary.com","gnetnagiwd.xyz","gnipgykdv94fu1hol.cf","gnipgykdv94fu1hol.ga","gnipgykdv94fu1hol.gq","gnipgykdv94fu1hol.ml","gnipgykdv94fu1hol.tk","gnlk3sxza3.net","gnom.com","gnplls.info","gnsk6gdzatu8cu8hmvu.cf","gnsk6gdzatu8cu8hmvu.ga","gnsk6gdzatu8cu8hmvu.gq","gnsk6gdzatu8cu8hmvu.ml","gnsk6gdzatu8cu8hmvu.tk","gnumail.com","gnwpwkha.pl","go-blogger.ru","go.irc.so","go1.site","go2arizona.info","go2site.info","go2usa.info","go2vpn.net","goasfer.com","goashmail.com","goat.si","gobet889.online","gobet889bola.com","gobet889skor.com","goc0knoi.tk","gochicagoroofing.com","god-mail.com","godaddyrenewalcoupon.net","godataflow.xyz","godlike.us","godmail.gq","godsofguns.com","godut.com","goeasyhost.net","goemailgo.com","goerieblog.com","gofuckporn.com","gog4dww762tc4l.cf","gog4dww762tc4l.ga","gog4dww762tc4l.gq","gog4dww762tc4l.ml","gog4dww762tc4l.tk","goglemail.cf","goglemail.ga","goglemail.ml","gogogays.com","gogogmail.com","gogogorils.com","gogomail.org.ua","gogreeninc.ga","gohappybuy.com","gohappytobuy.net","gok.kr","goldclassicstylerau.info","goldenbola.com","goldenepsilon.info","goldengo.com","goldengoosesneakers13.com","goldenswamp.com","goldinbox.net","goldringsstore.net","goldvote.org","goldwarez.org","golemico.com","golems.tk","golenia-base.pl","golf4blog.com","golfblogjapan.com","golfilla.info","golfjapanesehome.com","golfnewshome.com","golfnewsonlinejp.com","golfonblog.com","golfsports.info","golidi.net","golimar.com","goliokao.cf","goliokao.ga","goliokao.gq","goliokao.ml","golivejasmin.com","gomail.in","gomail.pgojual.com","gomailbox.info","gomaile.com","gomailstar.xyz","gomessage.ml","gondskumis69.me","gonduras-nedv.ru","gonotebook.info","gontek.pl","goo-gl2012.info","gooajmaid.com","good-autoskup.pl","good-college.ru","good-digitalcamera.info","good-electronicals.edu","good-ladies.com","good-names.info","good-teens.com","good007.net","gooday.pw","goodbead.biz","goodchange.org.ua","goodemail.top","goodfitness.us","goodhealthbenefits.info","goodinternetmoney.com","goodjab.club","goodluckforu.cn.com","goodqualityjerseysshop.com","goodresultsduke.com","goodreviews.tk","goods.com","goodseller.co","goodsmart.pw","goodstartup.biz","goodymail.men","googdad.tk","google-email.ml","google-mail.me","google-mail.ooo","google-visit-me.com","google2u.com","googleappmail.com","googlebox.com","googlecn.com","googledottrick.com","googlefind.com","googlemail.press","googlemarket.com","googlet.com","googli.com","googmail.gdn","googole.com.pl","goohle.co.ua","goood-mail.com","goood-mail.net","goood-mail.org","goooogle.flu.cc","goooogle.igg.biz","goooogle.nut.cc","goooogle.usa.cc","goooomail.com","goopianazwa.com","goosebox.net","gophermail.info","goplaygame.ru","goplaytech.com.au","gopldropbox1.tk","goplf1.cf","goplf1.ga","goplmega.tk","goplmega1.tk","goproaccessories.us","goprovs.com","goranko.ga","gordon.prometheusx.pl","gordon1121.club","gordpizza.ru","gorilla-zoe.net","gorillaswithdirtyarmpits.com","gorizontiznaniy.ru","gornostroyalt.ru","goromail.ga","gorommasala.com","goround.info","gorskie-noclegi.pl","gosearchcity.us","goseep.com","goshoppingpants.com","gosne.com","gospel-deals.info","gosuslugg.ru","gosuslugi-spravka.ru","gothentai.com","gothere.biz","gothicdarkness.pl","gotimes.xyz","gotmail.com","gotmail.net","gotmail.org","gotmail.waw.pl","gotobag.info","gotoinbox.bid","gotopbests.com","gotowkowy.eu","gotspoiler.com","gotti.otherinbox.com","gouwu116.com","gouwu98.com","gov-mail.com","gov.en.com","goverloe.com","governmentcomplianceservices.com","governo.ml","govnomail.xyz","gowikibooks.com","gowikicampus.com","gowikicars.com","gowikifilms.com","gowikigames.com","gowikimusic.com","gowikimusic.great-host.in","gowikinetwork.com","gowikitravel.com","gowikitv.com","gox2lfyi3z9.ga","gox2lfyi3z9.gq","gox2lfyi3z9.ml","gox2lfyi3z9.tk","gp5611.com","gp6786.com","gpcharlie.com","gpi8eipc5cntckx2s8.cf","gpi8eipc5cntckx2s8.ga","gpi8eipc5cntckx2s8.gq","gpi8eipc5cntckx2s8.ml","gpi8eipc5cntckx2s8.tk","gplvuka4fcw9ggegje.cf","gplvuka4fcw9ggegje.ga","gplvuka4fcw9ggegje.gq","gplvuka4fcw9ggegje.ml","gplvuka4fcw9ggegje.tk","gpmvsvpj.pl","gpoczt.net.pl","gpscellphonetracking.info","gpsmobilephonetracking.info","gpstrackerandroid.com","gpstrackingreviews.net","gpwdrbqak.pl","gqioxnibvgxou.cf","gqioxnibvgxou.ga","gqioxnibvgxou.gq","gqioxnibvgxou.ml","gqioxnibvgxou.tk","gqlsryi.xyz","gqtyojzzqhlpd5ri5s.cf","gqtyojzzqhlpd5ri5s.ga","gqtyojzzqhlpd5ri5s.gq","gqtyojzzqhlpd5ri5s.ml","gqtyojzzqhlpd5ri5s.tk","gr5kfhihqa3y.cf","gr5kfhihqa3y.ga","gr5kfhihqa3y.gq","gr5kfhihqa3y.ml","gr5kfhihqa3y.tk","grabdealstoday.info","grabitfast.co","gracefilledblog.com","gracia.bheckintocash-here.com","gragonissx.com","gramail.ga","gramail.net","gramail.org","gramy24.waw.pl","gramyonlinee.pl","grand-slots.net","grandmamail.com","grandmasmail.com","grangmi.cf","grangmi.ga","grangmi.gq","grangmi.ml","granufloclassaction.info","granuflolawsuits.info","granuflolawyer.info","graphic14.catchydrift.com","graphinasdx.com","graphtech.ru","gratis-gratis.com","gratislink.net","gratislose.de","gratisneuke.be","gratosmail.fr.nf","graymail.ga","great-host.in","great-names.info","greatcellphonedeals.info","greatedhardy.com","greatemail.net","greatemailfree.com","greatersalez.com","greatestfish.com","greatfish.com","greatloanscompany.co.uk","greatloansonline.co.uk","greatmedicineman.net","greattimes.ga","greattomeetyou.com","greatwebcontent.info","grederter.org","gree.gq","greekstatues.net","green-coffe-extra.info","green.jino.ru","greenbandhu.com","greenbaypackersjerseysshop.us","greenbaypackerssale.com","greencoepoe.cf","greencoffeebeanextractfaq.com","greencoffeebeanfaq.com","greenekiikoreabete.cf","greenforce.cf","greenforce.tk","greenfree.ru","greenhousemail.com","greeninbox.org","greenlivingutopia.com","greenplanetfruit.com","greenrocketemail.com","greensloth.com","greenslots2017.co","greenst.info","greensticky.info","greentech5.com","greenwarez.org","greggamel.com","greggamel.net","gregoria1818.site","gregorsky.zone","gregorygamel.com","gregorygamel.net","grek-nedv.ru","grek1.ru","grenada-nedv.ru","grencex.cf","grenn24.com","grepekhyo65hfr.tk","gresyuip.com.uk","greyjack.com","griffeyjrshoesstore.com","griffeyshoesoutletsale.com","grimjjowjager.cf","grimjjowjager.ga","grimjjowjager.gq","grimjjowjager.ml","grimjjowjager.tk","grimoiresandmore.com","grinn.in","grish.de","griuc.schule","griusa.com","grizzlyfruit.gq","grn.cc","grnermail.info","grobmail.com","grodins.ml","grommail.fr","gronn.pl","groobox.info","grossiste-ambre.net","group-llc.cf","group-llc.ga","group-llc.gq","group-llc.ml","group-llc.tk","groupbuff.com","groupd-mail.net","groupe-psa.cf","groupe-psa.gq","groupe-psa.ml","groupe-psa.tk","grow-mail.com","growlcombine.com","growxlreview.com","grr.la","grruprkfj.pl","grubybenekrayskiego.pl","grubymail.com","grupatworczapik.pl","gruz-m.ru","gry-logiczne-i-liczbowe.pl","grycjanosmail.com","grydladziewczynek.com.pl","grylogiczneiliczbowe.pl","gryonlinew.pl","gryplaystation3-fr.pl","gs-arc.org","gs-tube-x.ru","gsa.yesweadvice.com","gsaemail.com","gsasearchengineranker.top","gsasearchengineranker.xyz","gsaseoemail.com","gsaverifiedlist.download","gsdwertos.com","gsibiliaali1.xsl.pt","gsmmodem.org","gsmseti.ru","gsmwndcir.pl","gspam.mooo.com","gsredcross.org","gsrv.co.uk","gstore96.ru","gsxstring.ga","gt446443ads.cf","gt446443ads.ga","gt446443ads.gq","gt446443ads.ml","gt446443ads.tk","gta4etw4twtan53.gq","gtcmnt.pl","gterebaled.com","gthpprhtql.pl","gtime.com","gtrcinmdgzhzei.cf","gtrcinmdgzhzei.ga","gtrcinmdgzhzei.gq","gtrcinmdgzhzei.ml","gtrcinmdgzhzei.tk","gtrrrn.com","gtthnp.com","gtymj2pd5yazcbffg.cf","gtymj2pd5yazcbffg.ga","gtymj2pd5yazcbffg.gq","gtymj2pd5yazcbffg.ml","gtymj2pd5yazcbffg.tk","gu.luk2.com","gu3x7o717ca5wg3ili.cf","gu3x7o717ca5wg3ili.ga","gu3x7o717ca5wg3ili.gq","gu3x7o717ca5wg3ili.ml","gu3x7o717ca5wg3ili.tk","gu4wecv3.bij.pl","guarchibao-fest.ru","gubkiss.com","gucc1-magasin.com","gucci-ebagoutlet.com","gucci-eoutlet.net","guccibagshere.com","guccibagsuksale.info","gucciborseitalyoutletbags.com","guccicheapjp.com","guccihandbagjp.com","guccihandbags-australia.info","guccihandbags-onsale.us","guccihandbags-shop.info","guccihandbagsonsale.info","guccihandbagsonsaleoo.com","gucciinstockshop.com","gucciocchiali.net","gucciofficialwebsitebags.com","gucciofficialwebsitebags.com.com","guccionsalejp.com","guccioutlet-online.info","guccioutlet-onlinestore.info","guccioutlet-store.info","guccioutletmallsjp.com","guccioutletonline.info","guccioutletonlinestores.info","guccisacochepaschere.com","guccishoessale.com","guccitripwell.com","gudanglowongan.com","gudodaj-sie.pl","guehomo.top","guerillamail.biz","guerillamail.com","guerillamail.de","guerillamail.info","guerillamail.net","guerillamail.org","guerillamailblock.com","guerrillamail.biz","guerrillamail.com","guerrillamail.de","guerrillamail.info","guerrillamail.net","guerrillamail.org","guerrillamailblock.com","guesschaussurespascher.com","guglator.com","gugoumail.com","gugulelelel.com","guhtr.org","guide2host.net","guide3.net","guidejpshop.com","guidemails.gdn","guildwars-2-gold.co.uk","guildwars-2-gold.de","guitarjustforyou.com","guitarsxltd.com","gujckksusww.com","gujika.org","gummymail.info","gunalizy.mazury.pl","guqoo.com","gurubooks.ru","gurulegal.ru","gustavocata.org","gustidharya.com","gustore.co","gustr.com","gutierrezmail.bid","guus02.guccisacsite.com","guvewfmn7j1dmp.cf","guvewfmn7j1dmp.ga","guvewfmn7j1dmp.gq","guvewfmn7j1dmp.ml","guvewfmn7j1dmp.tk","guybox.info","guzqrwroil.pl","gvatemala-nedv.ru","gwahtb.pl","gwfh.cf","gwfh.ga","gwfh.gq","gwfh.ml","gwfh.tk","gwindorseobacklink.com","gwok.info","gwsdev4.info","gwspt71.com","gwzjoaquinito01.cf","gx2k24xs49672.cf","gx2k24xs49672.ga","gx2k24xs49672.gq","gx2k24xs49672.ml","gx2k24xs49672.tk","gx7v4s7oa5e.cf","gx7v4s7oa5e.ga","gx7v4s7oa5e.gq","gx7v4s7oa5e.ml","gx7v4s7oa5e.tk","gxbnaloxcn.ga","gxbnaloxcn.ml","gxbnaloxcn.tk","gxcpaydayloans.org","gxemail.men","gxg07.com","gxglixaxlzc9lqfp.cf","gxglixaxlzc9lqfp.ga","gxglixaxlzc9lqfp.gq","gxglixaxlzc9lqfp.ml","gxglixaxlzc9lqfp.tk","gxhy1ywutbst.cf","gxhy1ywutbst.ga","gxhy1ywutbst.gq","gxhy1ywutbst.ml","gxhy1ywutbst.tk","gxmail.ga","gyhunter.org","gyigfoisnp560.ml","gyikgmm.pl","gymlesstrainingsystem.com","gynzi.co.uk","gynzi.com","gynzi.es","gynzi.nl","gynzi.org","gynzy.at","gynzy.es","gynzy.eu","gynzy.gr","gynzy.info","gynzy.lt","gynzy.mobi","gynzy.pl","gynzy.ro","gynzy.ru","gynzy.sk","gyqa.com","gyrosramzes.pl","gz168.net","gzb.ro","gzc868.com","gzesiek84bb.pl","gzk2sjhj9.pl","gzvmwiqwycv8topg6zx.cf","gzvmwiqwycv8topg6zx.ga","gzvmwiqwycv8topg6zx.gq","gzvmwiqwycv8topg6zx.ml","gzvmwiqwycv8topg6zx.tk","gzxb120.com","gzyp21.net","h.mintemail.com","h.polosburberry.com","h.thc.lv","h0116.top","h0tmail.top","h1hecsjvlh1m0ajq7qm.cf","h1hecsjvlh1m0ajq7qm.ga","h1hecsjvlh1m0ajq7qm.gq","h1hecsjvlh1m0ajq7qm.ml","h1hecsjvlh1m0ajq7qm.tk","h1tler.cf","h1tler.ga","h1tler.gq","h1tler.ml","h1tler.tk","h1z8ckvz.com","h2-yy.nut.cc","h20solucaca.com","h2o-web.cf","h2o-web.ga","h2o-web.gq","h2o-web.ml","h2o-web.tk","h2ocn8f78h0d0p.cf","h2ocn8f78h0d0p.ga","h2ocn8f78h0d0p.gq","h2ocn8f78h0d0p.ml","h2ocn8f78h0d0p.tk","h2wefrnqrststqtip.cf","h2wefrnqrststqtip.ga","h2wefrnqrststqtip.gq","h2wefrnqrststqtip.ml","h2wefrnqrststqtip.tk","h333.cf","h333.ga","h333.gq","h333.ml","h333.tk","h3ssk4p86gh4r4.cf","h3ssk4p86gh4r4.ga","h3ssk4p86gh4r4.gq","h3ssk4p86gh4r4.ml","h3ssk4p86gh4r4.tk","h467etrsf.cf","h467etrsf.gq","h467etrsf.ml","h467etrsf.tk","h546ns6jaii.cf","h546ns6jaii.ga","h546ns6jaii.gq","h546ns6jaii.ml","h546ns6jaii.tk","h5dslznisdric3dle0.cf","h5dslznisdric3dle0.ga","h5dslznisdric3dle0.gq","h5dslznisdric3dle0.ml","h5dslznisdric3dle0.tk","h5jiin8z.pl","h5srocpjtrfovj.cf","h5srocpjtrfovj.ga","h5srocpjtrfovj.gq","h5srocpjtrfovj.ml","h5srocpjtrfovj.tk","h65syz4lqztfrg1.cf","h65syz4lqztfrg1.ga","h65syz4lqztfrg1.gq","h65syz4lqztfrg1.ml","h65syz4lqztfrg1.tk","h7vpvodrtkfifq35z.cf","h7vpvodrtkfifq35z.ga","h7vpvodrtkfifq35z.gq","h7vpvodrtkfifq35z.ml","h7vpvodrtkfifq35z.tk","h7xbkl9glkh.cf","h7xbkl9glkh.ga","h7xbkl9glkh.gq","h7xbkl9glkh.ml","h7xbkl9glkh.tk","h8s.org","h8usp9cxtftf.cf","h8usp9cxtftf.ga","h8usp9cxtftf.gq","h8usp9cxtftf.ml","h8usp9cxtftf.tk","h9js8y6.com","habboftpcheat.com","haberci.com","habitue.net","habrew.de","hacccc.com","hack-seo.com","hackcheat.co","hacked.jp","hackerious.com","hackerndgiveaway.ml","hackersquad.tk","hackrz.xyz","hackthatbit.ch","hackwifi.org","hackzone.club","hactzayvgqfhpd.cf","hactzayvgqfhpd.ga","hactzayvgqfhpd.gq","hactzayvgqfhpd.ml","hactzayvgqfhpd.tk","had.twoja-pozycja.biz","hadal.net","haddo.eu","hadigel.net","hadmins.com","hafin2.pl","hafnia.biz","hafrem3456ails.com","hafzo.net","hagglebeddle.com","hagiasophiagroup.com","hagiasophiaonline.com","hahalla.com","hahawrong.com","haiapoteker.com","haida-edu.cn","haifashaikh.com","haihan.vn","haihantnc.xyz","hair-stylestrends.com","hairagainreviews.org","haircaresalonstips.info","hairgrowth.cf","hairgrowth.ml","hairlossshop.info","hairoo.com","hairremovalplus.org","hairrenvennen.com","hairs24.ru","hairsideas.ru","hairstraighteneraustralia.info","hairstraightenercheapaustralia.info","hairstraightenernv.com","hairstyles360.com","hairwizard.in","haitmail.ga","hajckiey2.pl","hale-namiotowe.net.pl","halil.ml","halkasor.com","halofarmasi.com","haltospam.com","hamakdupajasia.com","hammerdin.com","hamsing.com","hamtwer.biz","hamusoku.cf","hamusoku.ga","hamusoku.gq","hamusoku.ml","hamusoku.tk","hamzayousfi.tk","handans.ru","handans.rufood4kid.ru","handbagscanadastores.com","handbagscharming.info","handbagsfox.com","handbagslovers.info","handbagsluis.net","handbagsonlinebuy.com","handbagsoutlet-trends.info","handbagsshowing.com","handbagsshowingk.com","handbagsstoreslove.com","handbagstips2012.info","handbagwee.com","handelo.com.pl","handrfabrics.com","hanging-drop-plates.com","hangover-over.tk","hangxomcuatoilatotoro.cf","hangxomcuatoilatotoro.ga","hangxomcuatoilatotoro.gq","hangxomcuatoilatotoro.ml","hangxomcuatoilatotoro.tk","haniuil.com","haniv.ignorelist.com","hanmama.zz.am","hanoimail.us","hansblbno.ustka.pl","hanson4.dynamicdns.me.uk","hanson6.25u.com","hanson7.dns-dns.com","hantem.bid","hanul.com","haodewang.com","haogltoqdifqq.cf","haogltoqdifqq.ga","haogltoqdifqq.gq","haogltoqdifqq.ml","haogltoqdifqq.tk","haom7.com","happyalmostfriday.com","happybirthdaywishes1.info","happydomik.ru","happyedhardy.com","happygoluckyclub.com","happyhealthyveggie.com","happykorea.club","happykoreas.xyz","happymail.guru","happymoments.com.pl","happysinner.co.uk","happytools72.ru","happyyou.pw","hapsomail.info","haqed.com","harakirimail.com","hard-life.online","hard-life.org","hardanswer.ru","hardenend.com","hardingpost.com","hardmail.info","hardstylex.com","hardvard.edu","hardwaretech.info","harfordpi.com","hargaku.org","haribu.com","haribu.net","harkincap.com","harleymoj.pl","harlowgirls.org","harmani.info","harmonyst.xyz","harpix.info","harrinbox.info","hartbot.de","harvard-ac-uk.tk","harvard.ac.uk","harvesttmaster.com","hasanmail.ml","hasegawa.cf","hasegawa.gq","hasehow.com","hash.pp.ua","hashg.com","hat-geld.de","hate.cf","hatespam.org","hatitton.com.pl","hatiyangpatah.online","hatmail.com","hatmail.ir","hats-wholesaler.com","hats4sale.net","hauvuong.com.vn","hauvuong.net","havelock4.pl","havelock5.pl","havelock6.pl","haventop.tk","hawrong.com","hax0r.id","hayait.com","hayastana.com","haydoo.com","hays.ml","haysantiago.com","hazelnut4u.com","hazelnuts4u.com","hazmatshipping.org","hbccreditcard.net","hbdya.info","hbo.dns-cloud.net","hbo.dnsabr.com","hbontqv90dsmvko9ss.cf","hbontqv90dsmvko9ss.ga","hbontqv90dsmvko9ss.gq","hbontqv90dsmvko9ss.ml","hbontqv90dsmvko9ss.tk","hbxrlg4sae.cf","hbxrlg4sae.ga","hbxrlg4sae.gq","hbxrlg4sae.ml","hbxrlg4sae.tk","hc1118.com","hcac.net","hccmail.win","hceap.info","hclrizav2a.cf","hclrizav2a.ga","hclrizav2a.gq","hclrizav2a.ml","hclrizav2a.tk","hcoupledp.com","hd-boot.info","hd-camera-rentals.com","hd-mail.com","hd3vmbtcputteig.cf","hd3vmbtcputteig.ga","hd3vmbtcputteig.gq","hd3vmbtcputteig.ml","hd3vmbtcputteig.tk","hdbaset.pl","hdctjaso.pl","hdczu7uhu0gbx.cf","hdczu7uhu0gbx.ga","hdczu7uhu0gbx.gq","hdczu7uhu0gbx.ml","hdczu7uhu0gbx.tk","hddvdguide.info","hdf6ibwmredx.cf","hdf6ibwmredx.ga","hdf6ibwmredx.gq","hdf6ibwmredx.ml","hdf6ibwmredx.tk","hdfgh45gfjdgf.tk","hdfshsh.stream","hdhkmbu.ga","hdhkmbu.ml","hdmail.com","hdmovie.info","hdmovieshouse.biz","hdmoviestore.us","hdorg.ru","hdorg1.ru","hdprice.co","hdqputlockers.com","hdrecording-al.info","hdseriionline.ru","hdstream247.com","hdtvsounds.com","he2duk.net","he8801.com","headachetreatment.net","headpack.org.ua","headset5pl.com","headsetwholesalestores.info","headstrong.de","healbutty.info","healsy.life","health.edu","healthandbeautyimage.com","healthandfitnessnewsletter.info","healthbeautynatural.site","healthbreezy.com","healthcheckmate.co.nz","healthcorp.edu","healthcureview.com","healthdelivery.info","healthinsuranceforindividual.co.uk","healthinsurancespecialtis.org","healthinsurancestats.com","healthlifes.ru","healthmeals.com","healthnewsapps.com","healthnewsfortoday.com","healthpull.com","healthtutorials.info","healthyliving.tk","healthysnackfood.info","healthywelk.com","healyourself.xyz","hearingaiddoctor.net","heartburnnomorereview.info","hearthandhomechimneys.co.uk","hearthealthy.co.uk","heartrate.com","heartratemonitorstoday.com","heartter.tk","hearttoheart.edu","heat-scape.co.uk","heathenhammer.com","heathenhero.com","heathenhq.com","heatingcoldinc.info","hecat.es","hedgefundnews.info","hedy.gq","heeco.me","hefrent.tk","hehesou.com","hehmail.pl","heihamail.com","helamakbeszesc.com","hello.nl","hello123.com","hellodream.mobi","hellohitech.com","hellokittyjewelrystore.com","helloricky.com","hellow-man.pw","hellowman.pw","hellowperson.pw","helm.ml","helmade.xyz","help33.cu.cc","help4entrepreneurs.co.uk","helpcustomerdepartment.ga","helpinghandtaxcenter.org","helpjobs.ru","helpmail.cf","helpmedigit.com","helpwesearch.com","helrey.cf","helrey.ga","helrey.gq","helrey.ml","hemorrhoidmiraclereviews.info","hemotoploloboy.com","hempseed.pl","henamail.com","hendrikarifqiariza.cf","hendrikarifqiariza.ga","hendrikarifqiariza.gq","hendrikarifqiariza.ml","hendrikarifqiariza.tk","hengshinv.com","hengyutrade2000.com","herbalanda.com","herbalsumbersehat.com","herbert1818.site","herbertgrnemeyer.in","heresh.info","herestoreonsale.org","hergrteyye8877.cf","hergrteyye8877.ga","hergrteyye8877.gq","hergrteyye8877.ml","hergrteyye8877.tk","hermes-uk.info","hermesbirkin-outlet.info","hermesbirkin0.com","hermeshandbags-hq.com","hermesonlinejp.com","hermessalebagjp.com","hermestashenshop.org","hermeswebsite.com","hermitcraft.cf","heroine-cruhser.cf","heros3.com","herostartup.com","herp.in","herpderp.nl","herpes9.com","heryogasecretsexposed.com","hessrohmercpa.com","hestermail.men","hewke.xyz","hexagonmail.com","hexapi.ga","heximail.com","hexqr84x7ppietd.cf","hexqr84x7ppietd.ga","hexqr84x7ppietd.gq","hexqr84x7ppietd.ml","hexqr84x7ppietd.tk","heyjuegos.com","hezemail.ga","hezll.com","hfdh7y458ohgsdf.tk","hfmf.cf","hfmf.ga","hfmf.gq","hfmf.ml","hfmf.tk","hg8n415.com","hgggypz.pl","hgh.net","hghenergizersale.com","hgrmnh.cf","hgrmnh.ga","hgrmnh.gq","hgrmnh.ml","hgsygsgdtre57kl.tk","hgtabeq4i.pl","hgtt674s.pl","hhcqldn00euyfpqugpn.cf","hhcqldn00euyfpqugpn.ga","hhcqldn00euyfpqugpn.gq","hhcqldn00euyfpqugpn.ml","hhcqldn00euyfpqugpn.tk","hhh.sytes.net","hhjqahmf3.pl","hhjqnces.com.pl","hhopy.com","hhyrnvpbmbw.atm.pl","hi07zggwdwdhnzugz.cf","hi07zggwdwdhnzugz.ga","hi07zggwdwdhnzugz.gq","hi07zggwdwdhnzugz.ml","hi07zggwdwdhnzugz.tk","hi1dcthgby5.cf","hi1dcthgby5.ga","hi1dcthgby5.gq","hi1dcthgby5.ml","hi1dcthgby5.tk","hi2.in","hi5.si","hi6547mue.com","hichristianlouboutinukdiscount.co.uk","hichristianlouboutinuksale.co.uk","hiddencorner.xyz","hiddentombstone.info","hiddentragedy.com","hide-mail.net","hidebox.org","hidebusiness.xyz","hideemail.net","hidemail.de","hidemail.pro","hidemail.us","hideme.be","hidemyass.com","hideweb.xyz","hidheadlightconversion.com","hidjuhxanx9ga6afdia.cf","hidjuhxanx9ga6afdia.ga","hidjuhxanx9ga6afdia.gq","hidjuhxanx9ga6afdia.ml","hidjuhxanx9ga6afdia.tk","hidzz.com","highbros.org","higheducation.ru","highground.store","highheelcl.com","highiqsearch.info","highlevel.store","highlevelcoder.cf","highlevelcoder.ga","highlevelcoder.gq","highlevelcoder.ml","highlevelcoder.tk","highlevelgamer.cf","highlevelgamer.ga","highlevelgamer.gq","highlevelgamer.ml","highlevelgamer.tk","highme.store","highonline.store","highprice.store","highsite.store","highspace.store","hightechmailer.com","hightri.net","highweb.store","higiena-pracy.pl","hii5pdqcebe.cf","hii5pdqcebe.ga","hii5pdqcebe.gq","hii5pdqcebe.ml","hii5pdqcebe.tk","hiirimatot.com","hikingshoejp.com","hilandtoyota.net","hildredcomputers.com","hillary-email.com","hillmail.men","hilltoptreefarms.com","hiltonvr.com","himail.online","hinokio-movie.com","hinolist.com","hipermail.co.pl","hiphopmoviez.com","hippobox.info","hirekuq.tk","hirschsaeure.info","hiru-dea.com","hisalotk.cf","hisalotk.ga","hisalotk.gq","hisalotk.ml","hishyau.cf","hishyau.ga","hishyau.gq","hishyau.ml","hissfuse.com","hitachirail.cf","hitachirail.ga","hitachirail.gq","hitachirail.ml","hitachirail.tk","hitbts.com","hitechnew.ru","hitler-adolf.cf","hitler-adolf.ga","hitler-adolf.gq","hitler-adolf.ml","hitler-adolf.tk","hitler.rocks","hitlerbehna.com","hitprice.co","hitthatne.org.ua","hiusas.co.cc","hix.kr","hiyrey.cf","hiyrey.ga","hiyrey.gq","hiyrey.ml","hiytdlokz.pl","hiz.kr","hiz76er.priv.pl","hizemail.com","hj9ll8spk3co.cf","hj9ll8spk3co.ga","hj9ll8spk3co.gq","hj9ll8spk3co.ml","hj9ll8spk3co.tk","hjdosage.com","hjdzrqdwz.pl","hjfgyjhfyjfytujty.ml","hjgh545rghf5thfg.gq","hjirnbt56g.xyz","hjkcfa3o.com","hjkgkgkk.com","hjkhgh6ghkjfg.ga","hk188188.com","hkd6ewtremdf88.cf","hkft7pttuc7hdbnu.cf","hkft7pttuc7hdbnu.ga","hkft7pttuc7hdbnu.ml","hkllooekh.pl","hkmbqmubyx5kbk9t6.cf","hkmbqmubyx5kbk9t6.ga","hkmbqmubyx5kbk9t6.gq","hkmbqmubyx5kbk9t6.ml","hkmbqmubyx5kbk9t6.tk","hku.us.to","hl-blocker.site","hlf333.com","hlooy.com","hlx02x0in.pl","hlxpiiyk8.pl","hmail.top","hmail.us","hmamail.com","hmh.ro","hmhrvmtgmwi.cf","hmhrvmtgmwi.ga","hmhrvmtgmwi.gq","hmhrvmtgmwi.ml","hmhrvmtgmwi.tk","hmmbswlt5ts.cf","hmmbswlt5ts.ga","hmmbswlt5ts.gq","hmmbswlt5ts.ml","hmmbswlt5ts.tk","hmsale.org","hmxmizjcs.pl","hn-skincare.com","hndard.com","hngwrb7ztl.ga","hngwrb7ztl.gq","hngwrb7ztl.ml","hngwrb7ztl.tk","hnlmtoxaxgu.cf","hnlmtoxaxgu.ga","hnlmtoxaxgu.gq","hnlmtoxaxgu.tk","hntr93vhdv.uy.to","ho2.com","ho3twwn.com","hoangdz11.tk","hoanggiaanh.com","hoanglong.tech","hobbitthedesolationofsmaug.com","hobbsye.com","hobby-society.com","hobbydiscuss.ru","hoboc.com","hobosale.com","hochsitze.com","hockeyan.ru","hockeydrills.info","hockeyskates.info","hocseohieuqua.com","hocseonangcao.com","hocseotructuyen.com","hocseowebsite.com","hoer.pw","hoesshoponline.info","hofap.com","hoganoutletsiteuomomini.com","hoganrebelitalian.com","hogansitaly.com","hogansitaly1.com","hogansitoufficialeshopiit.com","hojfccubvv.ml","holdup.me","holidayinc.com","holidayloans.com","holidayloans.uk","holidayloans.us","holl.ga","holland-nedv.ru","hollandmail.men","hollisterclothingzt.co.uk","hollisteroutletuk4u.co.uk","hollisteroutletukvip.co.uk","hollisteroutletukzt.co.uk","hollisteroutletzt.co.uk","hollistersalezt.co.uk","hollisteruk4s.co.uk","hollisteruk4u.co.uk","hollisterukoutlet4u.co.uk","hollywooddreamcorset.com","hollywooddress.net","holms.098.pl","holy-lands-tours.com","homail.com","homal.com","home-businessreviews.com","home-tech.fun","home.glasstopdiningtable.org","homeandhouse.website","homedecorsaleoffus.com","homeequityloanlive.com","homefauna.ru","homemadecoloncleanse.in","homemail.gr.vu","homemailpro.com","homemortgageloan-refinance.com","homeremediesforacne.com","homeremediesfortoenailfungus.net","homerepairguy.org","homerezioktaya.com","homesforsaleinwausau.com","hometheate.com","hominidviews.com","homlee.com","homlee.mygbiz.com","honeydresses.com","honeydresses.net","hongfany.com","hongpress.com","honkimailc.info","honkimailh.info","honkimailj.info","honl2isilcdyckg8.cf","honl2isilcdyckg8.ga","honl2isilcdyckg8.gq","honl2isilcdyckg8.ml","honl2isilcdyckg8.tk","honmme.com","honor-8.com","honot1.co","hooahartspace.org","hookerkillernels.com","hootspad.eu","hootspaddepadua.eu","hooverexpress.net","hop2.xyz","hopemail.biz","hopoverview.com","hopto.org","hornet.ie","hornyalwary.top","horoskopde.com","horsebarninfo.com","horsefucker.org","horsepoops.info","horvathurtablahoz.ml","host-info.com","host15.ru","hostb.xyz","hostbymax.com","hostcalls.com","hostchief.net","hostelschool.edu","hostgatorgenie.com","hostguard.co.fi","hostguru.info","hostguru.top","hosting.ipiurl.net","hosting4608537.az.pl","hostingandserver.com","hostingarif.me","hostingcape.com","hostingdating.info","hostingninja.bid","hostingninja.men","hostingninja.top","hostingpagessmallworld.info","hostlaba.com","hostload.com.br","hostmail.cc","hostmailmonster.com","hostmaster.bid","hostmein.top","hostmonitor.net","hostnow.bid","hostnow.men","hostpector.com","hostseo1.hekko.pl","hot-leads.pro","hot-mail.cf","hot-mail.ga","hot-mail.gq","hot-mail.ml","hot-mail.tk","hot14.info","hotaasgrcil.com","hotail.com","hotakama.tk","hotamil.com","hotblogers.com","hotbox.com","hotbrandsonsales1.com","hotchristianlouboutinsalefr.com","hotel-orbita.pl","hotel-zk.lviv.ua","hotel.upsilon.webmailious.top","hotelbochum.de-info.eu","hotelbookingthailand.biz","hotelfocus.com.pl","hotelnextmail.com","hoteloferty.pl","hotelsatparis.com","hotelvet.com","hotermail.org","hotesell.com","hotfile24h.net","hotlinemail.tk","hotlowcost.com","hotlunches.ga","hotmai.com","hotmail.biz","hotmail.co.com","hotmail.red","hotmail.work","hotmail4.com","hotmailboxlive.com","hotmailer.info","hotmailer3000.org","hotmailforever.com","hotmaill.com","hotmailpro.info","hotmailproduct.com","hotmails.com","hotmails.eu","hotmailse.com","hotmailspot.co.cc","hotmal.com","hotmali.com","hotmanpariz.com","hotmeal.com","hotmediamail.com","hotmessage.info","hotmial.com","hotmichaelkorsoutletca.ca","hotmobilephoneoffers.com","hotmodel.nl","hotmulberrybags2uk.com","hotmzcil.com","hotoffmypress.info","hotonlinesalejerseys.com","hotpennystockstowatchfor.com","hotpop.com","hotpradabagsoutlet.us","hotprice.co","hotroactive.tk","hotrodsbydean.com","hotsale.com","hotsalesbracelets.info","hotsdwswgrcil.com","hotsdwwgrcil.com","hotsnapbackcap.com","hotspotmails.com","hotspots300.info","hotstyleus.com","hottyfling.com","hotwwgrcil.com","hous.craigslist.org","housat.com","housebuyerbureau.co.uk","housecleaningguides.com","householdshopping.org","housemail.ga","housenord99.de","houseofgrizzly.pl","housesforcashuk.co.uk","housetechics.ru","housewifeporn.info","housing.are.nom.co","houston-criminal-defense-lawyer.info","houstonembroideryservice.online","houstonlawyerscriminallaw.com","houstonlocksmithpro.com","houtil.com","how-to-offshore.com","howellcomputerrepair.com","howgetpokecoins.com","howicandoit.com","howmakeall.tk","howmuchall.org.ua","howmuchdowemake.com","howtd.xyz","howtinzr189muat0ad.cf","howtinzr189muat0ad.ga","howtinzr189muat0ad.gq","howtinzr189muat0ad.ml","howtinzr189muat0ad.tk","howtodraw2.com","howtofood.ru","howtogetmyboyfriendback.net","howtogetridof-acnescarsfast.org","howtokissvideos.com","howtoknow.us","howtolastlongerinbedinstantly.com","howtolearnplaygitar.info","howtolosefatfast.org","howtolosefatonthighs.tk","howtomake-jello-shots.com","hp.laohost.net","hpc.tw","hpotter7.com","hprehf28r8dtn1i.cf","hprehf28r8dtn1i.ga","hprehf28r8dtn1i.gq","hprehf28r8dtn1i.ml","hprehf28r8dtn1i.tk","hpxwhjzik.pl","hq-porner.net","hqautoinsurance.com","hqcatbgr356z.ga","hqjzb9shnuk3k0u48.cf","hqjzb9shnuk3k0u48.ga","hqjzb9shnuk3k0u48.gq","hqjzb9shnuk3k0u48.ml","hqjzb9shnuk3k0u48.tk","hqnmhr.com","hqsecmail.com","hqv8grv8dxdkt1b.cf","hqv8grv8dxdkt1b.ga","hqv8grv8dxdkt1b.gq","hqv8grv8dxdkt1b.ml","hqv8grv8dxdkt1b.tk","hqypdokcv.pl","hrb67.cf","hrb67.ga","hrb67.gq","hrb67.ml","hrb67.tk","hrcub.ru","href.re","hrgmgka.cf","hrgmgka.ga","hrgmgka.gq","hrgmgka.ml","hrgy12.com","hrma4a4hhs5.gq","hrommail.net","hronopoulos.com","hroundb.com","hrtgr.cf","hrtgr.ga","hrtgr.gq","hrtgr.ml","hrtgr.tk","hrtgre4.cf","hrtgre4.ga","hrtgre4.gq","hrtgre4.ml","hrtgre4.tk","hruwcwooq.pl","hs.vc","hs130.com","hsbc.coms.hk","hsjhjsjhbags.com","hsls5guu0cv.cf","hsls5guu0cv.ga","hsls5guu0cv.gq","hsls5guu0cv.ml","hsls5guu0cv.tk","hstermail.com","hstutunsue7dd.ml","ht.cx","htaae8jvikgd3imrphl.ga","htaae8jvikgd3imrphl.gq","htaae8jvikgd3imrphl.ml","htaae8jvikgd3imrphl.tk","htc-mozart.pl","htery.com","hteysy5yys66.cf","htgamin.com","htmail.com","htndeglwdlm.pl","htstar.tk","http.e-abrakadabra.pl","httpboks.gq","httpdindon.ml","httpimbox.gq","httpoutmail.cf","httpqwik.ga","httpvkporn.ru","htwergbrvysqs.cf","htwergbrvysqs.ga","htwergbrvysqs.gq","htwergbrvysqs.ml","htwergbrvysqs.tk","htzmqucnm.info","hu4ht.com","huachichi.info","huajiachem.cn","huangniu8.com","huationgjk888.info","hubii-network.com","hubmail.info","hubspotmails.com","hubwebsite.tk","huck.ml","huckepackel.com","hugbenefits.ga","hugesale.in","hugohost.pl","huiledargane.com","huj.pl","hujike.org","hukkmu.tk","hukmdy92apdht2f.cf","hukmdy92apdht2f.ga","hukmdy92apdht2f.gq","hukmdy92apdht2f.ml","hukmdy92apdht2f.tk","hulapla.de","hulksales.com","hull-escorts.com","hulujams.org","hum9n4a.org.pl","humac5.ru","humaility.com","humanstudy.ru","hummarus24.biz","hummer-h3.ml","humn.ws.gy","hungpackage.com","hunny1.com","hunrap.usa.cc","hunterhouse.pl","huntersfishers.ru","huntingmastery.com","hurify1.com","hurramm.us","hurrijian.us","hush.ai","hush.com","hushclouds.com","hushmail.cf","huskion.net","huskysteals.com","huston.edu","hustq7tbd6v2xov.cf","hustq7tbd6v2xov.ga","hustq7tbd6v2xov.gq","hustq7tbd6v2xov.ml","hustq7tbd6v2xov.tk","hutchankhonghcm.com","hvastudiesucces.nl","hvh.pl","hvhcksxb.mil.pl","hvtechnical.com","hvzoi.com","hwa7niu2il.com","hwa7niuil.com","hwkaaa.besaba.com","hwkvsvfwddeti.cf","hwkvsvfwddeti.ga","hwkvsvfwddeti.gq","hwkvsvfwddeti.ml","hwkvsvfwddeti.tk","hwsye.net","hwxist3vgzky14fw2.cf","hwxist3vgzky14fw2.ga","hwxist3vgzky14fw2.gq","hwxist3vgzky14fw2.ml","hwxist3vgzky14fw2.tk","hx39i08gxvtxt6.cf","hx39i08gxvtxt6.ga","hx39i08gxvtxt6.gq","hx39i08gxvtxt6.ml","hx39i08gxvtxt6.tk","hxck8inljlr.cf","hxck8inljlr.ga","hxck8inljlr.gq","hxck8inljlr.tk","hxdjswzzy.pl","hxhbnqhlwtbr.ga","hxhbnqhlwtbr.ml","hxhbnqhlwtbr.tk","hxvxxo1v8mfbt.cf","hxvxxo1v8mfbt.ga","hxvxxo1v8mfbt.gq","hxvxxo1v8mfbt.ml","hxvxxo1v8mfbt.tk","hxzf.biz","hybridmc.net","hydrogenrichwaterstick.org","hydroxide-studio.com","hyipbook.com","hyperemail.top","hyperfastnet.info","hypermail.top","hypermailbox.com","hyperpigmentationtreatment.eu","hyphemail.com","hypori.us","hypotekyonline.cz","hysaryop8.pl","hyt45763ff.cf","hyt45763ff.ga","hyt45763ff.gq","hyt45763ff.ml","hyt45763ff.tk","hyteqwqs.com","hyvuokmhrtkucn5.cf","hyvuokmhrtkucn5.ga","hyvuokmhrtkucn5.gq","hyvuokmhrtkucn5.ml","hyyysde.com","hz2046.com","hzx3mqob77fpeibxomc.cf","hzx3mqob77fpeibxomc.ga","hzx3mqob77fpeibxomc.ml","hzx3mqob77fpeibxomc.tk","i-3gk.cf","i-3gk.ga","i-3gk.gq","i-3gk.ml","i-am-tiredofallthehype.com","i-booking.us","i-emailbox.info","i-konkursy.pl","i-love-credit.ru","i-phone.nut.cc","i-phones.shop","i-sp.cf","i-sp.ga","i-sp.gq","i-sp.ml","i-sp.tk","i-taiwan.tv","i.e-tpc.online","i.iskba.com","i.istii.ro","i.klipp.su","i.polosburberry.com","i.ryanb.com","i.wawi.es","i.xcode.ro","i03hoaobufu3nzs.cf","i03hoaobufu3nzs.ga","i03hoaobufu3nzs.gq","i03hoaobufu3nzs.ml","i03hoaobufu3nzs.tk","i11e5k1h6ch.cf","i11e5k1h6ch.ga","i11e5k1h6ch.gq","i11e5k1h6ch.ml","i11e5k1h6ch.tk","i1oaus.pl","i1uc44vhqhqpgqx.cf","i1uc44vhqhqpgqx.ga","i1uc44vhqhqpgqx.gq","i1uc44vhqhqpgqx.ml","i1uc44vhqhqpgqx.tk","i1xslq9jgp9b.ga","i1xslq9jgp9b.ml","i1xslq9jgp9b.tk","i201zzf8x.com","i2pmail.org","i301.info","i35t0a5.com","i3pv1hrpnytow.cf","i3pv1hrpnytow.ga","i3pv1hrpnytow.gq","i3pv1hrpnytow.ml","i3pv1hrpnytow.tk","i4j0j3iz0.com","i4racpzge8.cf","i4racpzge8.ga","i4racpzge8.gq","i4racpzge8.ml","i4racpzge8.tk","i4unlock.com","i537244.cf","i537244.ga","i537244.ml","i54o8oiqdr.cf","i54o8oiqdr.ga","i54o8oiqdr.gq","i54o8oiqdr.ml","i54o8oiqdr.tk","i6.cloudns.cc","i6.cloudns.cx","i61qoiaet.pl","i66g2i2w.com","i6appears.com","i75rwe24vcdc.cf","i75rwe24vcdc.ga","i75rwe24vcdc.gq","i75rwe24vcdc.ml","i75rwe24vcdc.tk","i774uhrksolqvthjbr.cf","i774uhrksolqvthjbr.ga","i774uhrksolqvthjbr.gq","i774uhrksolqvthjbr.ml","i774uhrksolqvthjbr.tk","i8e2lnq34xjg.cf","i8e2lnq34xjg.ga","i8e2lnq34xjg.gq","i8e2lnq34xjg.ml","i8e2lnq34xjg.tk","i8tvebwrpgz.cf","i8tvebwrpgz.ga","i8tvebwrpgz.gq","i8tvebwrpgz.ml","i8tvebwrpgz.tk","ia4stypglismiks.cf","ia4stypglismiks.ga","ia4stypglismiks.gq","ia4stypglismiks.ml","ia4stypglismiks.tk","iacjpeoqdy.pl","iamail.com","iaoss.com","iaptkapkl53.tk","iattach.gq","iaynqjcrz.pl","ib5dy8b0tip3dd4qb.cf","ib5dy8b0tip3dd4qb.ga","ib5dy8b0tip3dd4qb.gq","ib5dy8b0tip3dd4qb.ml","ib5dy8b0tip3dd4qb.tk","ibaxdiqyauevzf9.cf","ibaxdiqyauevzf9.ga","ibaxdiqyauevzf9.gq","ibaxdiqyauevzf9.ml","ibaxdiqyauevzf9.tk","ibel-resource.com","ibibo.com","ibiza-villas-spain.com","ibizaholidays.com","ibm.coms.hk","ibmail.com","ibmmails.com","ibmpc.cf","ibmpc.ga","ibmpc.gq","ibmpc.ml","ibnuh.bz","ibookstore.co","ibreeding.ru","ibsats.com","ibsyahoo.com","ibt7tv8tv7.cf","ibt7tv8tv7.ga","ibt7tv8tv7.gq","ibt7tv8tv7.ml","ibt7tv8tv7.tk","icantbelieveineedtoexplainthisshit.com","iccmail.men","iccmail.ml","iceburgsf.com","iceland-is-ace.com","icemail.club","icemovie.link","icetmail.ga","icfu.mooo.com","ichatz.ga","ichbinvollcool.de","ichichich.faith","ichigo.me","icloud.do","icloudbusiness.net","icmocozsm.pl","icon.foundation","iconedit.info","iconfile.info","iconsultant.me","icotype.info","icraftx.net","icrr2011symp.pl","ict0crp6ocptyrplcr.cf","ict0crp6ocptyrplcr.ga","ict0crp6ocptyrplcr.gq","ict0crp6ocptyrplcr.ml","ict0crp6ocptyrplcr.tk","ictuber.info","icunet.icu","icx.in","icx.ro","id.pl","id10tproof.com","idea-mail.com","idea.bothtook.com","ideagmjzs.pl","ideasplace.ru","ideepmind.pw","ideer.msk.ru","ideer.pro","idesigncg.com","idigo.org","idihgabo.cf","idihgabo.gq","idmail.com","idn.vn","idnkil.cf","idnkil.ga","idnkil.gq","idnkil.ml","idnpoker.link","idobrestrony.pl","idolsystems.info","idomail.com","idomain24.pl","idotem.cf","idotem.ga","idotem.gq","idotem.ml","idpoker99.org","idrotherapyreview.net","idt8wwaohfiru7.cf","idt8wwaohfiru7.ga","idt8wwaohfiru7.gq","idt8wwaohfiru7.ml","idt8wwaohfiru7.tk","idtv.site","iduitype.info","idvdclubs.com","idx4.com","idxue.com","ieatspam.eu","ieatspam.info","ieattach.ml","iecrater.com","iedindon.ml","iefbcieuf.cf","iefbcieuf.ml","iefbcieuf.tk","ieh-mail.de","ieit9sgwshbuvq9a.cf","ieit9sgwshbuvq9a.ga","ieit9sgwshbuvq9a.gq","ieit9sgwshbuvq9a.ml","ieit9sgwshbuvq9a.tk","iemitel.gq","iencm.com","iennfdd.com","iephonam.cf","ieremiasfounttas.gr","ieryweuyeqio.tk","ierywoeiwura.tk","ies76uhwpfly.cf","ies76uhwpfly.ga","ies76uhwpfly.gq","ies76uhwpfly.ml","ies76uhwpfly.tk","iexh1ybpbly8ky.cf","iexh1ybpbly8ky.ga","iexh1ybpbly8ky.gq","iexh1ybpbly8ky.ml","iexh1ybpbly8ky.tk","if58.cf","if58.ga","if58.gq","if58.ml","if58.tk","ifastmail.pl","ifd8tclgtg.cf","ifd8tclgtg.ga","ifd8tclgtg.gq","ifd8tclgtg.ml","ifd8tclgtg.tk","iffymedia.com","ifly.cf","ifmail.com","ifneick22qpbft.cf","ifneick22qpbft.ga","ifneick22qpbft.gq","ifneick22qpbft.ml","ifneick22qpbft.tk","ifomail.com","ifoodpe19.ml","ifwda.co.cc","ig9kxv6omkmxsnw6rd.cf","ig9kxv6omkmxsnw6rd.ga","ig9kxv6omkmxsnw6rd.gq","ig9kxv6omkmxsnw6rd.ml","ig9kxv6omkmxsnw6rd.tk","igcl5axr9t7eduxkwm.cf","igcl5axr9t7eduxkwm.gq","igcl5axr9t7eduxkwm.ml","igcl5axr9t7eduxkwm.tk","ige.es","igelonline.de","igg.biz","iggqnporwjz9k33o.ga","iggqnporwjz9k33o.ml","ighjbhdf890fg.cf","igimail.com","igintang.ga","iginting.cf","igiveu.win","igmail.com","ignoremail.com","igoodmail.pl","igqtrustee.com","igrovieavtomati.org","igvaku.cf","igvaku.ga","igvaku.gq","igvaku.ml","igvaku.tk","igwnsiojm.pl","igxppre7xeqgp3.cf","igxppre7xeqgp3.ga","igxppre7xeqgp3.gq","igxppre7xeqgp3.ml","igxppre7xeqgp3.tk","ih2vvamet4sqoph.cf","ih2vvamet4sqoph.ga","ih2vvamet4sqoph.gq","ih2vvamet4sqoph.ml","ih2vvamet4sqoph.tk","ihairbeauty.us","ihamail.com","ihappytime.com","ihateyoualot.info","ihavedildo.tk","ihavenomouthandimustspeak.com","ihaxyour.info","ihazspam.ca","iheartspam.org","ihehmail.com","ihhjomblo.online","ihocmail.com","ihomail.com","iidiscounts.com","iidiscounts.org","iidzlfals.pl","iigmail.com","iigtzic3kesgq8c8.cf","iigtzic3kesgq8c8.ga","iigtzic3kesgq8c8.gq","iigtzic3kesgq8c8.ml","iigtzic3kesgq8c8.tk","iihonfqwg.pl","iill.cf","iimbox.cf","iiron.us","iitdmefoq9z6vswzzua.cf","iitdmefoq9z6vswzzua.ga","iitdmefoq9z6vswzzua.gq","iitdmefoq9z6vswzzua.ml","iitdmefoq9z6vswzzua.tk","iiunited.pl","iiwumail.com","ij3zvea4ctirtmr2.cf","ij3zvea4ctirtmr2.ga","ij3zvea4ctirtmr2.gq","ij3zvea4ctirtmr2.ml","ij3zvea4ctirtmr2.tk","ijerj.co.cc","ijmafjas.com","ijmail.com","ijmxty3.atm.pl","ijsdiofjsaqweq.ru","ik7gzqu2gved2g5wr.cf","ik7gzqu2gved2g5wr.ga","ik7gzqu2gved2g5wr.gq","ik7gzqu2gved2g5wr.ml","ik7gzqu2gved2g5wr.tk","ikaza.info","ikbenspamvrij.nl","ikelsik.cf","ikelsik.ga","ikelsik.gq","ikelsik.ml","ikhyebajv.pl","iki.kr","ikingbin.com","ikke.win","ikkjacket.com","ikmail.com","ikoplak.cf","ikoplak.ga","ikoplak.gq","ikoplak.ml","ikpz6l.pl","iku.us","ikuzus.cf","ikuzus.ga","ikuzus.gq","ikuzus.ml","ikuzus.tk","il.edu.pl","ilencorporationsap.com","ileqmail.com","ilikespam.com","iliketndnl.com","ilikeyoustore.org","ilinkelink.com","ilinkelink.org","iljmail.com","illistnoise.com","illnessans.ru","ilmale.it","ilmiogenerico.it","ilnostrogrossograssomatrimoniomolisano.com","ilobi.info","iloplr.com","ilopopolp.com","ilove.com","iloveearthtunes.com","iloveiandex.ru","ilovemail.fr","ilovemyniggers.club","ilovespam.com","ilt.ctu.edu.gr","iltmail.com","ilumail.com","im-irsyad.tech","im4ever.com","imabandgeek.com","imacpro.ml","imagehostfile.eu","images.novodigs.com","imail.seomail.eu","imail8.net","imailbox.org","imails.info","imajl.pl","imallas.com","imamail1928.cf","imamsrabbis.org","imankul.com","imap.pozycjonowanie8.pl","imasser.info","imd044u68tcc4.cf","imd044u68tcc4.ga","imd044u68tcc4.gq","imd044u68tcc4.ml","imd044u68tcc4.tk","imdbplus.com","imedgers.com","imeil.tk","imgjar.com","imgof.com","imgrpost.xyz","imgsources.com","imgv.de","imhtcut.xyz","iminimalm.com","imitrex.info","immail.com","immail.ml","immigrationfriendmail.com","immo-gerance.info","immry.ru","imosowka.pl","imouto.pro","imovie.link","imozmail.com","impastore.co","imperfectron.com","impi.com.mx","implosblog.ru","imported.livefyre.com","impostore.co","impotens.pp.ua","impresapuliziesea.com","imprezowy-dj.pl","improvedtt.com","imsave.com","imstations.com","imsuhyang.com","imul.info","in-fund.ru","in-their-words.com","in.mailsac.com","in.vipmail.in","inaby.com","inamail.com","inapplicable.org","inappmail.com","inaremar.eu","inaytedodet.tk","inbaca.com","inbax.ga","inbax.ml","inbax.tk","inbidato.ddns.net","inbilling.be","inbound.plus","inbox.comx.cf","inbox.loseyourip.com","inbox.si","inbox2.info","inboxalias.com","inboxbear.com","inboxclean.com","inboxclean.org","inboxdesign.me","inboxed.im","inboxed.pw","inboxhub.net","inboxkitten.com","inboxmail.world","inboxmails.co","inboxmails.net","inboxproxy.com","inboxstore.me","incarnal.pl","incestry.co.uk","inclusiveprogress.com","incognitomail.com","incognitomail.net","incognitomail.org","incorian.ru","incq.com","increase5f.com","incredibility.info","incrediemail.com","ind.st","indeedlebeans.com","indeedtime.us","indefathe.xyz","indelc.pw","independentsucks.twilightparadox.com","indi-nedv.ru","india.whiskey.thefreemail.top","india2in.com","indiacentral.in","indieclad.com","indiego.pw","indigomail.info","indirect.ws","indirindir.net","indobet.com","indogame.site","indoliqueur.com","indomaed.pw","indomina.cf","indomovie21.me","indonesianherbalmedicine.com","indoserver.stream","indosukses.press","indtredust.com","ineec.net","ineeddoshfast.co.uk","ineedmoney.com","inemaling.com","inet4.info","inexpensivejerseyofferd.com","infalled.com","inferno4.pl","infest.org","infideles.nu","infilddrilemail.com","infinityclippingpath.com","info-radio.ml","info7.eus","infoaccount-team.news","infochartsdeal.info","infochinesenyc.info","infocom.zp.ua","infogeneral.com","infokehilangan.com","infomedia.ga","infoprice.tech","informasikuyuk.com","information-account.net","information-blog.xyz","informatykbiurowy.pl","informedexistence.com","infosdating.info","infosnet24.info","infossbusiness.com","infotech.info","infotoursnyc.info","infouoso.com","ingcoachepursesoutletusaaonline.com","inggo.org","ingilterevize.eu","inhomelife.ru","inibuatkhoirul.cf","inibuatsgb.cf","inibuatsgb.ga","inibuatsgb.gq","inibuatsgb.ml","inibuatsgb.tk","inikehere.com","inikita.online","inipunyakitasemua.cf","inipunyakitasemua.ga","inipunyakitasemua.gq","inipunyakitasemua.ml","inipunyakitasemua.tk","inji4voqbbmr.cf","inji4voqbbmr.ga","inji4voqbbmr.gq","inji4voqbbmr.ml","inji4voqbbmr.tk","injir.top","inlovevk.net","inmail.com","inmail.site","inmail.xyz","inmailing.com","inmailwetrust.com","inmouncela.xyz","inmyd.ru","inmynetwork.cf","inmynetwork.ga","inmynetwork.gq","inmynetwork.ml","inmynetwork.tk","inni-com.pl","inoakley.com","inonezia-nedv.ru","inoutmail.de","inoutmail.eu","inoutmail.info","inoutmail.net","inox.org.pl","inpowiki.xyz","inppares.org.pe","inrelations.ru","inrim.cf","inrim.ga","inrim.gq","inrim.ml","inrim.tk","insane.nq.pl","insanity-workoutdvds.info","insanitydvdonline.info","insanityworkout13dvd.us","insanityworkout65.us","insanityworkoutcheap.us","insanityworkoutdvds.us","insanityworkoutinstores.us","insanumingeniumhomebrew.com","insidegpus.com","insidershq.info","insischildpank.xyz","insomniade.org.ua","insorg-mail.info","inspiracjatwoja.pl","instad4you.info","instafun.men","instaindofree.com","instaku-media.com","instambox.com","instance-email.com","instant-job.com","instant-mail.de","instantblingmail.info","instantemailaddress.com","instantgiveaway.xyz","instantinsurancequote.co.uk","instantloans960.co.uk","instantlove.pl","instantlyemail.com","instantmail.fr","instantmailaddress.com","instantonlinepayday.co.uk","instaprice.co","instylerreviews.info","insurance-co-op.com","insurance-company-service.com","insurancenew.org","insuranceonlinequotes.info","insurancing.ru","intadvert.com","intandtel.com","intdesign.edu","intel.coms.hk","intempmail.com","interactio.ch","interans.ru","interceptor.waw.pl","interceptorfordogs.info","interceramicvpsx.com","interiorimages.in","interiorin.ru","intermax.com","intermedia-ag-limited.com","internationalseo-org.numisdaddy.com","internet-search-machine.com","internet-v-stavropole.ru","internet-w-domu.tk","internetallure.com","internetmail.cf","internetmail.ga","internetmail.gq","internetmail.ml","internetmail.tk","internetoftags.com","internettrends.us","internetwplusie.pl","interserver.ga","interstats.org","intersteller.com","inthebox.pw","inthelocalfortwortharea.com","intimacly.com","intimeontime.info","intomail.bid","intomail.info","intothenight1243.com","intrested12.uk","intrxi6ti6f0w1fm3.cf","intrxi6ti6f0w1fm3.ga","intrxi6ti6f0w1fm3.gq","intrxi6ti6f0w1fm3.ml","intrxi6ti6f0w1fm3.tk","intuthewoo.com.my","inunglove.cf","invert.us","investering-solenergi.dk","investfxlearning.com","investore.co","invictawatch.net","inwebmail.com","iodizc3krahzsn.cf","iodizc3krahzsn.ga","iodizc3krahzsn.gq","iodizc3krahzsn.ml","iodizc3krahzsn.tk","ioemail.win","ioio.eu","iolkjk.cf","iolkjk.ga","iolkjk.gq","iolkjk.ml","iolokdi.ga","iolokdi.ml","iomail.com","ionazara.co.cc","ionb1ect2iark1ae1.cf","ionb1ect2iark1ae1.ga","ionb1ect2iark1ae1.gq","ionb1ect2iark1ae1.ml","ionb1ect2iark1ae1.tk","ionemail.net","ionot.xyz","ioplo.com","iordan-nedv.ru","iot.aiphone.eu.org","iot.ptcu.dev","iot.vuforia.us","iotatheta.wollomail.top","iotrh5667.cf","iotrh5667.ga","iotrh5667.gq","iotrh5667.ml","iotu.creo.site","iotu.de.vipqq.eu.org","iotu.nctu.me","iouiwoerw32.info","iouy67cgfss.cf","iouy67cgfss.ga","iouy67cgfss.gq","iouy67cgfss.ml","iouy67cgfss.tk","iozak.com","ip.webkrasotka.com","ip23xr.ru","ip3qc6qs2.pl","ip4.pp.ua","ip6.li","ip6.pp.ua","ip7.win","ipad2preis.de","ipad3.co","ipad3.net","ipad3release.com","ipaddlez.info","ipadhd3.co","ipadzzz.com","ipan.info","ipdeer.com","ipemail.win","iphone-ipad-mac.xyz","iphoneaccount.com","iphoneandroids.com","iphonemail.cf","iphonemail.ga","iphonemail.gq","iphonemail.tk","iphonemsk.com","iphoneonandroid.com","ipimail.com","ipiranga.dynu.com","ipiurl.net","ipjckpsv.pl","iplusplusmail.com","ipochta.gq","ipoczta.waw.pl","ipod-app-reviews.com","ipolopol.com","ipoo.org","iposta.ml","ippandansei.tk","ippexmail.pw","ipsur.org","ipswell.com","ipuccidresses.com","iq2kq5bfdw2a6.cf","iq2kq5bfdw2a6.ga","iq2kq5bfdw2a6.gq","iq2kq5bfdw2a6.ml","iqamail.com","iqazmail.com","iqcfpcrdahtqrx7d.cf","iqcfpcrdahtqrx7d.ga","iqcfpcrdahtqrx7d.gq","iqcfpcrdahtqrx7d.ml","iqcfpcrdahtqrx7d.tk","iqemail.win","iqmail.com","iqsfu65qbbkrioew.cf","iqsfu65qbbkrioew.ga","iqsfu65qbbkrioew.gq","iqsfu65qbbkrioew.ml","iqsfu65qbbkrioew.tk","iqumail.com","iqzzfdids.pl","ir101.net","irabops.com","iran-nedv.ru","iranbourse.co","iraq-nedv.ru","irc.so","ircbox.xyz","iredirect.info","iremail.com","irinaeunbebescump.com","irish2me.com","irishspringrealty.com","irland-nedv.ru","irlmail.com","irmail.com","iroid.com","irolpccc.com","irolpo.com","ironiebehindert.de","ironmantriathlons.net","irovonopo.com","irpanenjin.com","irper.com","irr.kr","irsanalysis.com","irssi.tv","irti.info","irydoidy.pl","is-zero.info","is.af","isabelmarant-sneaker.us","isabelmarants-neakers.us","isabelmarantshoes.us","isabelmarantsneakerssonline.info","isac-hermes.com","isachermeskelly.com","isaclongchamp.com","isamy.wodzislaw.pl","isbjct4e.com","isdaq.com","ise4mqle13.o-r.kr","isemail.com","isen.pl","isf4e2tshuveu8vahhz.cf","isf4e2tshuveu8vahhz.ga","isf4e2tshuveu8vahhz.gq","isf4e2tshuveu8vahhz.ml","isf4e2tshuveu8vahhz.tk","isi-tube.com","islam.igg.biz","islamm.cf","islamm.gq","islandi-nedv.ru","isncwoqga.pl","isophadal.xyz","isosq.com","isotretinoinacnenomore.net","ispeshel.com","ispuntheweb.com","ispyco.ru","israel-nedv.ru","israelserver2.com","israelserver3.com","israelserver4.com","issamartinez.com","isslab.ru","issthnu7p9rqzaew.cf","issthnu7p9rqzaew.ga","issthnu7p9rqzaew.gq","issthnu7p9rqzaew.ml","issthnu7p9rqzaew.tk","ist-genial.at","ist-genial.info","ist-genial.net","istakalisa.club","istanbulescorthatti.com","istanbulnights.eu","istii.ro","istlecker.de","istmail.tk","istreamingtoday.com","isukrainestillacountry.com","isxuldi8gazx1.ga","isxuldi8gazx1.ml","isxuldi8gazx1.tk","iszkft.hu","it-everyday.com","it-italy.cf","it-italy.ga","it-italy.gq","it-italy.ml","it-italy.tk","it-service-in-heidelberg.de","it-service-sinsheim.de","it-simple.net","it-vopros.ru","it2-mail.tk","it2sale.com","it7.ovh","italia.flu.cc","italia.igg.biz","italianspirit.pl","italpostall.com","italy-mail.com","italy-nedv.ru","italyborselvoutlet.com","itclub-smanera.tech","itdesi.com","itech-versicherung.de","itemailing.com","itemp.email","itempmail.tk","itfast.net","itibmail.com","itis0k.com","itjustmail.tk","itks6xvn.gq","itmailbox.info","itmailing.com","itmtx.com","itoup.com","itoxwehnbpwgr.cf","itoxwehnbpwgr.ga","itoxwehnbpwgr.gq","itoxwehnbpwgr.ml","itoxwehnbpwgr.tk","itregi.com","its0k.com","itsdoton.org","itsecpackets.com","itsgood2berich.com","itsme.edu.pl","itue33ubht.ga","itue33ubht.gq","itue33ubht.tk","itunesgiftcodegenerator.com","itxsector.ru","itymail.com","iu54edgfh.cf","iu54edgfh.ga","iu54edgfh.gq","iu54edgfh.ml","iu54edgfh.tk","iu66sqrqprm.cf","iu66sqrqprm.ga","iu66sqrqprm.gq","iu66sqrqprm.ml","iu66sqrqprm.tk","iuemail.men","iumail.com","iuporno.info","ivans.me","ivecotrucks.cf","ivecotrucks.ga","ivecotrucks.gq","ivecotrucks.ml","ivecotrucks.tk","ivii.ml","iviruseries3.ru","ivizx.com","ivmail.com","ivoiviv.com","ivosimilieraucute.com","ivuhmail.com","ivybotreviews.net","iw409uttadn.cf","iw409uttadn.ga","iw409uttadn.gq","iw409uttadn.ml","iw409uttadn.tk","iwanbanjarworo.cf","iwancorp.cf","iwankopi.cf","iwanttoms.com","iwantumake.us","iwi.net","iwin.ga","iwishiwereyoubabygirl.com","iwmfuldckw5rdew.cf","iwmfuldckw5rdew.ga","iwmfuldckw5rdew.gq","iwmfuldckw5rdew.ml","iwmfuldckw5rdew.tk","iwv06uutxic3r.cf","iwv06uutxic3r.ga","iwv06uutxic3r.gq","iwv06uutxic3r.ml","iwv06uutxic3r.tk","iwykop.pl","ixaks.com","ixkrofnxk.pl","ixkxirzvu10sybu.cf","ixkxirzvu10sybu.ga","ixkxirzvu10sybu.gq","ixkxirzvu10sybu.ml","ixkxirzvu10sybu.tk","ixtwhjqz4a992xj.cf","ixtwhjqz4a992xj.ga","ixtwhjqz4a992xj.gq","ixtwhjqz4a992xj.ml","ixtwhjqz4a992xj.tk","ixvfhtq1f3uuadlas.cf","ixvfhtq1f3uuadlas.ga","ixvfhtq1f3uuadlas.gq","ixvfhtq1f3uuadlas.ml","ixvfhtq1f3uuadlas.tk","ixx.io","ixxnqyl.pl","ixxycatmpklhnf6eo.cf","ixxycatmpklhnf6eo.ga","ixxycatmpklhnf6eo.gq","ixzcgeaad.pl","iy47wwmfi6rl5bargd.cf","iy47wwmfi6rl5bargd.ga","iy47wwmfi6rl5bargd.gq","iy47wwmfi6rl5bargd.ml","iy47wwmfi6rl5bargd.tk","iyaomail.com","iymail.com","iyomail.com","iytyicvta.pl","iyumail.com","iz0tvkxu43buk04rx.cf","iz0tvkxu43buk04rx.ga","iz0tvkxu43buk04rx.gq","iz0tvkxu43buk04rx.ml","iz0tvkxu43buk04rx.tk","iz3oht8hagzdp.cf","iz3oht8hagzdp.ga","iz3oht8hagzdp.gq","iz3oht8hagzdp.ml","iz3oht8hagzdp.tk","iz4acijhcxq9i30r.cf","iz4acijhcxq9i30r.ga","iz4acijhcxq9i30r.gq","iz4acijhcxq9i30r.ml","iz4acijhcxq9i30r.tk","izbe.info","izemail.com","izeqmail.com","izmail.net","iznai.ru","izolacja-budynku.info.pl","izoli9afsktfu4mmf1.cf","izoli9afsktfu4mmf1.ga","izoli9afsktfu4mmf1.gq","izoli9afsktfu4mmf1.ml","izoli9afsktfu4mmf1.tk","j-jacobs-cugrad.info","j-keats.cf","j-keats.ga","j-keats.gq","j-keats.ml","j-keats.tk","j-labo.com","j-p.us","j.aq.si","j.polosburberry.com","j.rvb.ro","j275xaw4h.pl","j2anellschild.ga","j3j.org","j3rqt89ez.com","j4rang0y4nk.ga","j5vhmmbdfl.cf","j5vhmmbdfl.ga","j5vhmmbdfl.gq","j5vhmmbdfl.ml","j5vhmmbdfl.tk","j7.cloudns.cx","j7cnw81.net.pl","j8-freemail.cf","j8k2.usa.cc","j9rxmxma.pl","jaaj.cf","jaanv.com","jabberflash.info","jabpid.com","jacckpot.site","jack762.info","jackaoutlet.com","jackets-monclers-sale.com","jacketwarm.com","jackleg.info","jackmailer.com","jackqueline.com","jackreviews.com","jacksonsshop.com","jackymail.top","jacquelx.com","jad32.cf","jad32.ga","jad32.gq","jadeschoice.com","jadopado.com","jadotech.com","jaelyn.amina.wollomail.top","jafps.com","jafrem3456ails.com","jaggernaut-email.bid","jaggernautemail.bid","jaggernautemail.trade","jaggernautemail.win","jagongan.ml","jaguar-landrover.cf","jaguar-landrover.ga","jaguar-landrover.gq","jaguar-landrover.ml","jaguar-landrover.tk","jaguar-xj.ml","jaguar-xj.tk","jaheen.info","jajomail.com","jajsus.com","jajxz.com","jak-szybko-schudnac.com","jakjtavvtva8ob2.cf","jakjtavvtva8ob2.ga","jakjtavvtva8ob2.gq","jakjtavvtva8ob2.ml","jakjtavvtva8ob2.tk","jakschudnac.org","jakubos.yourtrap.com","jalicodojo.com","jalynntaliyah.coayako.top","jam4d.asia","jam4d.biz","jam4d.store","jama.trenet.eu","jamaicarealestateclassifieds.com","jambuseh.info","jamcatering.ru","jamel.com","jamesbond.flu.cc","jamesbond.igg.biz","jamesbond.nut.cc","jamesbond.usa.cc","jamesejoneslovevader.com","jamiecantsingbroo.com","jamieisprouknowit.com","jamiesnewsite.com","jamieziggers.nl","jamikait.cf","jamikait.ga","jamikait.gq","jamikait.ml","jamit.com.au","jancok.in","jancokancene.cf","jancokancene.ga","jancokancene.gq","jancokancene.ml","jancuk.tech","janekimmy.com","janewsonline.com","janganjadiabu1.tk","janganjadiabu10.gq","janganjadiabu2.ml","janganjadiabu3.ga","janganjadiabu4.cf","janganjadiabu5.gq","janganjadiabu6.tk","janganjadiabu7.ml","janganjadiabu8.ga","janganjadiabu9.cf","janproz.com","jantyworld.pl","japan-monclerdown.com","japanesenewshome.com","japanesetoryburch.com","japanyn7ys.com","japjap.com","jaqis.com","jaqueline1121.club","jar-opener.info","jasabacklinkmurah.com","jasaseomurahin.com","jasinski-doradztwo.pl","jasmierodgers.ga","jatmikav.top","jauhari.cf","jauhari.ga","jauhari.gq","jav8.cc","javamail.org","javmail.tech","javmaniac.co","jaxworks.eu","jaya125.com","jayz-tickets.com","jb73bq0savfcp7kl8q0.ga","jb73bq0savfcp7kl8q0.ml","jb73bq0savfcp7kl8q0.tk","jbnote.com","jc56owsby.pl","jcdmail.men","jceffi8f.pl","jcpclothing.ga","jdas-mail.net","jdasdhj.cf","jdasdhj.ga","jdasdhj.gq","jdasdhj.ml","jdasdhj.tk","jdbzcblg.pl","jde53sfxxbbd.cf","jde53sfxxbbd.ga","jde53sfxxbbd.gq","jde53sfxxbbd.ml","jde53sfxxbbd.tk","jdeeedwards.com","jdl5wt6kptrwgqga.cf","jdl5wt6kptrwgqga.ga","jdl5wt6kptrwgqga.gq","jdl5wt6kptrwgqga.ml","jdl5wt6kptrwgqga.tk","jdmadventures.com","jdnjraaxg.pl","jdtfdf55ghd.ml","jdvmail.com","jdz.ro","je-recycle.info","je7f7muegqi.ga","je7f7muegqi.gq","je7f7muegqi.ml","je7f7muegqi.tk","jeansname.com","jeansoutlet2013.com","jeddahtravels.com","jeden.akika.pl","jedrnybiust.pl","jeenza.com","jeep-official.cf","jeep-official.ga","jeep-official.gq","jeep-official.ml","jeep-official.tk","jeffersonbox.com","jeie.igg.biz","jellow.ml","jelly-life.com","jellyrollpan.net","jellyrolls.com","jembotbrodol.com","jembud.icu","jembulan.bounceme.net","jembut142.cf","jembut142.ga","jembut142.gq","jembut142.ml","jembut142.tk","jemmctldpk.pl","jennie.club","jensden.co.uk","jensenbeachfishingcharters.com","jeodumifi.ns3.name","jepijopiijo.cf","jepijopiijo.ga","jepijopiijo.gq","jepijopiijo.ml","jepijopiijo.tk","jeramywebb.com","jerapah993r.gq","jere.biz","jerseymallusa.com","jerseyonsalestorehere.com","jerseysonlinenews.com","jerseysonlinesshop.com","jerseysshopps.com","jerseysyoulikestore.com","jerseyzone4u.com","jesien-zima.com.pl","jessejames.net","jestemkoniem.com.pl","jesusmail.com.br","jesusstatue.net","jet-renovation.fr","jetable.com","jetable.fr.nf","jetable.net","jetable.org","jetable.pp.ua","jetableemail.com","jetableemails.com","jetconvo.com","jetqunrb.pl","jeu3ds.com","jeux-gratuits.us","jeux-online0.com","jeux3ds.org","jeuxds.fr","jewel.ie","jewellrydo.com","jex-mail.pl","jezykoweradio.pl","jffabrics85038.com","jfgfgfgdfdder545yy.ml","jfiee.tk","jftruyrfghd8867.cf","jftruyrfghd8867.ga","jftruyrfghd8867.gq","jftruyrfghd8867.ml","jftruyrfghd8867.tk","jgaweou32tg.com","jgerbn4576aq.cf","jgerbn4576aq.ga","jgerbn4576aq.gq","jgerbn4576aq.ml","jgerbn4576aq.tk","jgi21rz.nom.pl","jglopez.net","jgmkgxr83.pl","jhhgcv54367.cf","jhhgcv54367.ga","jhhgcv54367.ml","jhhgcv54367.tk","jhjty56rrdd.cf","jhjty56rrdd.ga","jhjty56rrdd.gq","jhjty56rrdd.ml","jhjty56rrdd.tk","jhow.cf","jhow.ga","jhow.gq","jhow.ml","jhsss.biz","jialefujialed.info","jiancok.cf","jiancok.ga","jiancok.gq","jiancokowe.cf","jiancokowe.ga","jiancokowe.gq","jiancokowe.ml","jiaotongyinhang.net","jiapai.org","jiatou123jiua.info","jiaxin8736.com","jibjabprocode.com","jieber.net","jiez00veud9z.cf","jiez00veud9z.ga","jiez00veud9z.gq","jiez00veud9z.ml","jiez00veud9z.tk","jigglypuff.com","jigsawdigitalmarketing.com","jikadeco.com","jil.kr","jilossesq.com","jimjaagua.com","jimmychooshoesuksale.info","jimmychoowedges.us","jinggakop.ga","jinggakop.gq","jinggakq.ml","jining2321.info","jinsguaranteedpaydayloans.co.uk","jir.su","jiskhdgbgsytre43vh.ga","jitsuni.net","jiuere.com","jiujitsuappreviews.com","jiujitsushop.biz","jiujitsushop.com","jj456.com","jjdjshoes.com","jjjiii.ml","jjkgrtteee098.cf","jjkgrtteee098.ga","jjkgrtteee098.gq","jjkgrtteee098.ml","jjkgrtteee098.tk","jjmsb.eu.org","jkcntadia.cf","jkcntadia.ga","jkcntadia.gq","jkcntadia.ml","jkcntadia.tk","jkiohiuhi32.info","jkjsrdtr35r67.cf","jkjsrdtr35r67.ga","jkjsrdtr35r67.gq","jkjsrdtr35r67.ml","jkjsrdtr35r67.tk","jklasdf.com","jkljkl.cf","jkljkl.ga","jklsssf.com","jklthg.co.uk","jkmechanical.com","jkrowlg.cf","jkrowlg.ga","jkrowlg.gq","jkrowlg.ml","jkyvznnqlrc.gq","jkyvznnqlrc.ml","jkyvznnqlrc.tk","jlzxjeuhe.pl","jmail.fr.nf","jmail.ovh","jmail.ro","jmqtop.pl","jmy829.com","jmymy.com","jndu8934a.pl","jnfengli.com","jnggachoc.cf","jnggachoc.gq","jnpayy.com","jnthn39vr4zlohuac.cf","jnthn39vr4zlohuac.ga","jnthn39vr4zlohuac.gq","jnthn39vr4zlohuac.ml","jnthn39vr4zlohuac.tk","jnxjn.com","jnyfyxdhrx85f0rrf.cf","jnyfyxdhrx85f0rrf.ga","jnyfyxdhrx85f0rrf.gq","jnyfyxdhrx85f0rrf.ml","jnyfyxdhrx85f0rrf.tk","jo-mail.com","jo8otki4rtnaf.cf","jo8otki4rtnaf.ga","jo8otki4rtnaf.gq","jo8otki4rtnaf.ml","jo8otki4rtnaf.tk","joakarond.tk","joannfabricsad.com","joaquinito01.servehttp.com","joasantos.ga","job.craigslist.org","jobbikszimpatizans.hu","jobcheetah.com","jobeksuche.com","jobkim.com","jobku.id","jobo.me","jobposts.net","jobs-to-be-done.net","jobsforsmartpeople.com","jobslao.com","jocksturges.in","joelpet.com","joetestalot.com","joey.com","jofap.com","johanaeden.spithamail.top","john-doe.cf","john-doe.ga","john-doe.gq","john-doe.ml","johnnycarsons.info","johnpo.cf","johnpo.ga","johnpo.gq","johnpo.ml","johnpo.tk","johnsonmotors.com","join-4-free.bid","joinemonend.com","jointcradle.xyz","jointolouisvuitton.com","jointtime.xyz","jojolouisvuittonshops.com","joke24x.ru","jokenaka.press","jollymove.xyz","jombase.com","jomie.club","jonathanyeosg.com","jonerumpf.co.cc","jonnyanna.com","jonnyjonny.com","jonrepoza.ml","joomla-support.com","joomla.co.pl","joomlaemails.com","jopho.com","joq7slph8uqu.cf","joq7slph8uqu.ga","joq7slph8uqu.gq","joq7slph8uqu.ml","joq7slph8uqu.tk","jordanflight45.com","jordanfr5.com","jordanfrancepascher.com","jordanknight.info","jordanmass.com","jordanretronikesjordans.com","jordanretrooutlet.com","jordanshoesusonline.com","jordanstore.xyz","jorja344cc.tk","jorosc.cf","jorosc.ga","jorosc.gq","jorosc.ml","jorosc.tk","josadelia100.tk","josalita95.ml","josalyani102.ml","josamadea480.ga","josamanda777.tk","josangel381.ml","josasjari494.ml","josdita632.ml","josefadventures.org","joseihorumon.info","josephsu.com","josfitrawati410.ga","josfrisca409.tk","josgishella681.cf","joshendriyawati219.tk","josivangkia341.tk","josjihaan541.cf","josjismail.com","josnarendra746.tk","josnurul491.ga","josontim2011.com","josprayugo291.tk","josresa306.tk","josrustam128.cf","josse.ltd","josyahya751.tk","jotyaduolchaeol2fu.cf","jotyaduolchaeol2fu.ga","jotyaduolchaeol2fu.gq","jotyaduolchaeol2fu.ml","jotyaduolchaeol2fu.tk","journalistuk.com","jourrapide.com","joy-sharks.ru","jp-morgan.cf","jp-morgan.ga","jp-morgan.gq","jp-morgan.ml","jp.com","jp.ftp.sh","jp.hopto.org","jp6188.com","jpco.org","jpcoachoutletvip.com","jpggh76ygh0v5don1f.cf","jpggh76ygh0v5don1f.ga","jpggh76ygh0v5don1f.gq","jpggh76ygh0v5don1f.ml","jpggh76ygh0v5don1f.tk","jpinvest.ml","jpkparishandbags.info","jpnar8q.pl","jpo48jb.pl","jppradatoyou.com","jptb2motzaoa30nsxjb.cf","jptb2motzaoa30nsxjb.ga","jptb2motzaoa30nsxjb.gq","jptb2motzaoa30nsxjb.ml","jptb2motzaoa30nsxjb.tk","jptunyhmy.pl","jpuggoutlet.com","jqgnxcnr.pl","jquerys.net","jqweblogs.com","jqwgmzw73tnjjm.cf","jqwgmzw73tnjjm.ga","jqwgmzw73tnjjm.gq","jqwgmzw73tnjjm.ml","jqwgmzw73tnjjm.tk","jr46wqsdqdq.cf","jr46wqsdqdq.ga","jr46wqsdqdq.gq","jr46wqsdqdq.ml","jr46wqsdqdq.tk","jralalk263.tk","jrcs61ho6xiiktrfztl.cf","jrcs61ho6xiiktrfztl.ga","jrcs61ho6xiiktrfztl.gq","jrcs61ho6xiiktrfztl.ml","jrcs61ho6xiiktrfztl.tk","jredm.com","jri863g.rel.pl","jrinkkang97oye.cf","jrjrj4551wqe.cf","jrjrj4551wqe.ga","jrjrj4551wqe.gq","jrjrj4551wqe.ml","jrjrj4551wqe.tk","jryt7555ou9m.cf","jryt7555ou9m.ga","jryt7555ou9m.gq","jryt7555ou9m.ml","jryt7555ou9m.tk","jsdginfo.com","jsellsvfx.com","jsonp.ro","jsrsolutions.com","jsvojfgs.pl","jswfdb48z.com","jszuofang.com","jtabusschedule.info","jtjmtcolk.pl","jtkgatwunk.cf","jtkgatwunk.ga","jtkgatwunk.gq","jtkgatwunk.ml","jtkgatwunk.tk","jtmalwkpcvpvo55.cf","jtmalwkpcvpvo55.ga","jtmalwkpcvpvo55.gq","jtmalwkpcvpvo55.ml","jtmalwkpcvpvo55.tk","jto.kr","jtw-re.com","jualherbal.top","judimag.com","jue12s.pl","juegos13.es","jugglepile.com","jugqsguozevoiuhzvgdd.com","juicermachinesreview.com","juicervital.com","juicerx.co","juicy-couturedaily.com","juicyvogue.com","juiupsnmgb4t09zy.cf","juiupsnmgb4t09zy.ga","juiupsnmgb4t09zy.gq","juiupsnmgb4t09zy.ml","juiupsnmgb4t09zy.tk","jujinbox.info","jujitsushop.biz","jujitsushop.com","jujj6.com","jujucheng.com","jujuinbox.info","jujuso.com","jujusou.com","juliett.november.webmailious.top","juliustothecoinventor.com","jumaelda4846.ml","jumanindya8240.cf","jumaprilia4191.cf","jumbogumbo.in","jumbotime.xyz","jumbunga3502.cf","jumgita6884.tk","jumlamail.ml","jumlatifani8910.tk","jummario7296.ml","jummayang1472.ml","jumnia4726.ga","jumnoor4036.ga","jumnugroho6243.cf","jumonji.tk","jumossi51.ml","jumpman23-shop.com","jumpy5678.cf","jumpy5678.ga","jumpy5678.gq","jumpy5678.ml","jumpy5678.tk","jumrestia9994.ga","jumreynard5211.ml","jumreza258.tk","jumveronica8959.tk","jun8yt.cf","jun8yt.ga","jun8yt.gq","jun8yt.ml","jun8yt.tk","junasboyx1.com","junclutabud.xyz","junetwo.ru","jungkamushukum.com","junk.beats.org","junk.ihmehl.com","junk.to","junk1e.com","junkgrid.com","junklessmaildaemon.info","junkmail.com","junkmail.ga","junkmail.gq","jupimail.com","jurts.online","just-email.com","just4spam.com","justafou.com","justbegood.pw","justbestmail.co.cc","justbigbox.com","justclean.co.uk","justdoit132.cf","justdoit132.ga","justdoit132.gq","justdoit132.ml","justdoit132.tk","justdomain84.ru","justemail.ml","justfreemails.com","justinbiebershoesforsale.com","justintrend.com","justiphonewallpapers.com","justmailservice.info","justnope.com","justnowmail.com","justonemail.net","justpoleznoe.ru","justrbonlinea.co.uk","justshoes.gq","justtick.it","juusecamenerdarbun.com","juyouxi.com","jv6hgh1.com","jv7ykxi7t5383ntrhf.cf","jv7ykxi7t5383ntrhf.ga","jv7ykxi7t5383ntrhf.gq","jv7ykxi7t5383ntrhf.ml","jv7ykxi7t5383ntrhf.tk","jvhclpv42gvfjyup.cf","jvhclpv42gvfjyup.ml","jvhclpv42gvfjyup.tk","jwk4227ufn.com","jwl3uabanm0ypzpxsq.cf","jwl3uabanm0ypzpxsq.ga","jwl3uabanm0ypzpxsq.gq","jwork.ru","jwoug2rht98plm3ce.cf","jwoug2rht98plm3ce.ga","jwoug2rht98plm3ce.ml","jwoug2rht98plm3ce.tk","jwtukew1xb1q.cf","jwtukew1xb1q.ga","jwtukew1xb1q.gq","jwtukew1xb1q.ml","jwtukew1xb1q.tk","jxgrc.com","jyfc88.com","jyliananderik.com","jymfit.info","jynmxdj4.biz.pl","jytewwzz.com","jziad5qrcege9.cf","jziad5qrcege9.ga","jziad5qrcege9.gq","jziad5qrcege9.ml","jziad5qrcege9.tk","jzzxbcidt.pl","k-mail.top","k.fido.be","k.polosburberry.com","k0vaux7h.345.pl","k101.hosteko.ru","k1q4fqra2kf.pl","k2dfcgbld4.cf","k2dfcgbld4.ga","k2dfcgbld4.gq","k2dfcgbld4.ml","k2dfcgbld4.tk","k2eztto1yij4c.cf","k2eztto1yij4c.ga","k2eztto1yij4c.gq","k2eztto1yij4c.ml","k2eztto1yij4c.tk","k2idacuhgo3vzskgss.cf","k2idacuhgo3vzskgss.ga","k2idacuhgo3vzskgss.gq","k2idacuhgo3vzskgss.ml","k2idacuhgo3vzskgss.tk","k3663a40w.com","k3opticsf.com","k3zaraxg9t7e1f.cf","k3zaraxg9t7e1f.ga","k3zaraxg9t7e1f.gq","k3zaraxg9t7e1f.ml","k3zaraxg9t7e1f.tk","k4ds.org","k4tbtqa7ag5m.cf","k4tbtqa7ag5m.ga","k4tbtqa7ag5m.gq","k4tbtqa7ag5m.ml","k4tbtqa7ag5m.tk","k9ifse3ueyx5zcvmqmw.cf","k9ifse3ueyx5zcvmqmw.ga","k9ifse3ueyx5zcvmqmw.ml","k9ifse3ueyx5zcvmqmw.tk","k9wc559.pl","kaaw39hiawtiv1.ga","kaaw39hiawtiv1.gq","kaaw39hiawtiv1.ml","kaaw39hiawtiv1.tk","kabareciak.pl","kabiny-prysznicowe-in.pl","kabiny-prysznicowe.ovh","kabo-verde-nedv.ru","kaciekenya.webmailious.top","kacose.xyz","kadag.ir","kademen.com","kadokawa.cf","kadokawa.ga","kadokawa.gq","kadokawa.ml","kadokawa.tk","kadokawa.top","kafrem3456ails.com","kaguya.tk","kah.pw","kaijenwan.com","kaixinpet.com","kaj3goluy2q.cf","kaj3goluy2q.ga","kaj3goluy2q.gq","kaj3goluy2q.ml","kaj3goluy2q.tk","kakadua.net","kakaofrucht.de","kakashi1223e.cf","kakashi1223e.ga","kakashi1223e.ml","kakashi1223e.tk","kakismotors.net","kaksmail.com","kalapi.org","kalemproje.com","kamagra-lovegra.com.pl","kamagra.com","kamagra.org","kamagra100mgoraljelly.today","kamagraonlinesure.com","kamagrasklep.com.pl","kamax57564.co.tv","kamen-market.ru","kamgorstroy.ru","kamien-naturalny.eu","kamizellki-info.pl","kammmo.com","kammmo12.com","kampoeng3d.club","kamryn.ayana.thefreemail.top","kamsg.com","kamucerdas.com","kanada-nedv.ru","kanarian-nedv.ru","kanbin.info","kanciang.faith","kandymail.com","kangkunk44lur.cf","kankankankan.com","kanker.website","kansascitystreetmaps.com","kanzanishop.com","kaovo.com","kapieli-szczecin.pl","kapikapi.info","kappala.info","karateslawno.pl","karatraman.ml","karcherparts.info","karement.com","karenmillendress-au.com","karenmillenoutletea.co.uk","karenmillenoutleter.co.uk","karenmillenuk4s.co.uk","karenmillenuker.co.uk","karina-strim.ru","kariplan.com","karitas.com.br","karridea.com","karta-kykyruza.ru","kartvelo.com","kartvelo.me","kartykredytowepl.info","kartyusb.pl","kasandraava.livefreemail.top","kasdewhtewhrfasaea.vv.cc","kashi-sale.com","kasmail.com","kasper.uni.me","kaspop.com","kasthouse.com","kat-777.com","kat-net.com","katalogstronstron.pl","katanyoobattery.com","katcang.tk","kate.1bd.pl","katergizmo.de","katespade-factory.com","katie11muramats.ga","katipa.pl","katomcoupon.com","katonoma.com","katsfastpaydayloans.co.uk","katyperrytourblog.com","katztube.com","kauinginpergi.cf","kauinginpergi.ga","kauinginpergi.gq","kauinginpergi.ml","kavbc6fzisxzh.cf","kavbc6fzisxzh.ga","kavbc6fzisxzh.gq","kavbc6fzisxzh.ml","kavbc6fzisxzh.tk","kaws4u.com","kawy-4.pl","kaxks55ofhkzt5245n.cf","kaxks55ofhkzt5245n.ga","kaxks55ofhkzt5245n.gq","kaxks55ofhkzt5245n.ml","kaxks55ofhkzt5245n.tk","kaye.ooo","kazan-nedv.ru","kazelink.ml","kazinoblackjack.com","kazper.net","kbakvkwvsu857.cf","kbbxowpdcpvkxmalz.cf","kbbxowpdcpvkxmalz.ga","kbbxowpdcpvkxmalz.gq","kbbxowpdcpvkxmalz.ml","kbbxowpdcpvkxmalz.tk","kbdjvgznhslz.ga","kbdjvgznhslz.ml","kbdjvgznhslz.tk","kc-kenes.kz","kc8pnm1p9.pl","kchkch.com","kcrw.de","kdfgedrdf57mmj.ga","kdjhemail.com","kdjngsdgsd.tk","kdl8zp0zdh33ltp.ga","kdl8zp0zdh33ltp.gq","kdl8zp0zdh33ltp.ml","kdl8zp0zdh33ltp.tk","kdublinstj.com","kebl0bogzma.ga","kebmail.com","kecambahijo89klp.ml","keepactivated.com","keeperhouse.ru","keeplucky.pw","keepmymail.com","keepmyshitprivate.com","keepyourshitprivate.com","kehangatan.ga","kein.hk","keinhirn.de","keinpardon.de","keipino.de","keirron31.are.nom.co","kejenx.com","kekecog.com","kekita.com","kellybagonline.com","keluruk.fun","kemail.com","kemampuan.me","kembangpasir.website","kemfra.com","kemonkoreeitaholoto.tk","kemptvillebaseball.com","kemska.pw","kemulastalk.https443.org","kenal-saya.ga","kenbaby.com","kenberry.com","kendallmarshallfans.info","kendalraven.webmailious.top","kenecrehand.port25.biz","kengriffeyoutlet.com","kenmorestoveparts.com","kennedy808.com","kennie.club","kent1.rebatesrule.net","kent2.ns02.info","kent4.ftp1.biz","kent5.qpoe.com","kent7.3-a.net","kentg.co.cc","keobzmvii.pl","keort.in","kepler.uni.me","kepqs.ovh","keratinhairtherapy.com","keratosispilarisguide.info","kerrmail.men","kerupukmlempem.ml","kerupukmlempem.tk","kerupukmlempem1.cf","kerupukmlempem1.ga","kerupukmlempem2.cf","kerupukmlempem3.cf","kerupukmlempem3.ml","kerupukmlempem4.cf","kerupukmlempem4.ml","kerupukmlempem5.cf","kerupukmlempem6.cf","kerupukmlempem6.ml","kerupukmlempem7.cf","kerupukmlempem7.ga","kerupukmlempem8.ga","kerupukmlempem9.cf","kethough51.tk","ketiksms.club","ketodiet.info","kettlebellfatburning.info","kev.com","kev7.com","kevin7.com","kevintrankt.com","kewkece.com","kewl-offers.com","kewlmail.info","kexukexu.xyz","key-mail.net","key-windows-7.us","keyesrealtors.tk","keykeykelyns.cf","keykeykelyns.ga","keykeykelyns.gq","keykeykelyns.ml","keykeykelyns.tk","keykeykelynss.cf","keykeykelynss.ga","keykeykelynss.gq","keykeykelynss.ml","keykeykelynss.tk","keykeykelynsss.cf","keykeykelynsss.ga","keykeykelynsss.gq","keykeykelynsss.ml","keykeykelynsss.tk","keykeykelynz.cf","keykeykelynz.ga","keykeykelynz.gq","keykeykelynz.ml","keykeykelynz.tk","keypreview.com","keywordstudy.pl","kf2ddmce7w.cf","kf2ddmce7w.ga","kf2ddmce7w.gq","kf2ddmce7w.ml","kf2ddmce7w.tk","kfamilii2011.co.cc","kfark.net","kfhgrftcvd.cf","kfhgrftcvd.ga","kfhgrftcvd.gq","kfhgrftcvd.ml","kfhgrftcvd.tk","kftcrveyr.pl","kg1cz7xyfmps.cf","kg1cz7xyfmps.gq","kg1cz7xyfmps.tk","kgduw2umqafqw.ga","kgduw2umqafqw.ml","kgduw2umqafqw.tk","kghfmqzke.pl","kgohjniyrrgjp.cf","kgohjniyrrgjp.ga","kgohjniyrrgjp.gq","kgohjniyrrgjp.ml","kgohjniyrrgjp.tk","kgxz6o3bs09c.cf","kgxz6o3bs09c.ga","kgxz6o3bs09c.gq","kgxz6o3bs09c.ml","kgxz6o3bs09c.tk","kh0hskve1sstn2lzqvm.ga","kh0hskve1sstn2lzqvm.gq","kh0hskve1sstn2lzqvm.ml","kh0hskve1sstn2lzqvm.tk","khakiskinnypants.info","khalifahallah.com","khan007.cf","khbfzlhayttg.cf","khbfzlhayttg.ga","khbfzlhayttg.gq","khbfzlhayttg.ml","khbfzlhayttg.tk","khoabung.com","khoahocseopro.com","khoahocseoweb.com","khoi-fm.org","khongsocho.xyz","khpkufk.pl","khtyler.com","khujenao.net","ki7hrs5qsl.cf","ki7hrs5qsl.ga","ki7hrs5qsl.gq","ki7hrs5qsl.ml","ki7hrs5qsl.tk","kiani.com","kibristime.com","kickers-world.be","kickit.ga","kickmark.com","kickmarx.net","kickskshoes.com","kickstartbradford.com","kidalylose.pl","kidworksacademy.com","kigwa.com","kiham.club","kikie.club","kikihu.com","kikoxltd.com","kil58225o.pl","kiliosios.gr","kill-me.tk","killarbyte.ru","killdred99.uk.com","killerelephants.com","killgmail.com","killmail.com","killmail.net","kilo.kappa.livefreemail.top","kilo.sigma.aolmail.top","kim-tape.com","kimbral.umiesc.pl","kimsdisk.com","king-yaseen.cf","king2003.ml","kingdomhearts.cf","kingofmails.com","kingpol.eu","kingsq.ga","kingyslmail.com","kingyslmail.top","kinkz.com","kino-100.ru","kinofan-online.ru","kinoggo.ru","kinogokinogo.ru","kinogomegogo.ru","kinogomyhit.ru","kinokradkinokrad.ru","kinolublin.pl","kinopoisckhd.ru","kinoz.pl","kinsil.co.uk","kinx.cf","kinx.gq","kinx.ml","kinx.tk","kio-mail.com","kiois.com","kiolisios.gr","kipmail.xyz","kipomail.com","kipr-nedv.ru","kir.ch.tc","kirt.er","kiryubox.cu.cc","kisiihft2hka.cf","kisiihft2hka.ga","kisiihft2hka.gq","kisiihft2hka.ml","kisiihft2hka.tk","kismail.com","kismail.ru","kissadulttoys.com","kisshq.com","kissmoncler.com","kisstwink.com","kitchendesign1.co.uk","kitchenettereviews.com","kitchenlean.fun","kitesurfinguonline.pl","kithjiut.cf","kithjiut.ga","kithjiut.gq","kithjiut.ml","kitnastar.com","kitooes.com","kitten-mittons.com","kittiza.com","kiustdz.com","kiuyutre.ga","kiuyutre.ml","kivoid.blog","kiwsz.com","kjdghdj.co.cc","kjdo9rcqnfhiryi.cf","kjdo9rcqnfhiryi.ga","kjdo9rcqnfhiryi.ml","kjdo9rcqnfhiryi.tk","kjhjgyht6ghghngh.ml","kjjeggoxrm820.gq","kjncascoiaf.ru","kjoiewrt.in","kjwyfs.com","kkjef655grg.cf","kkjef655grg.ga","kkjef655grg.gq","kkjef655grg.ml","kkjef655grg.tk","kkkzzz.cz.cc","kkr47748fgfbef.cf","kkr47748fgfbef.ga","kkr47748fgfbef.gq","kkr47748fgfbef.ml","kkr47748fgfbef.tk","kkreatorzyimprez.pl","kkredyt.pl","kkredyttonline.pl","kksm.be","kktt32s.net.pl","kkvmdfjnvfd.dx.am","klabuk.pl","klaky.net","klammlose.org","klarasaty25rest.cf","klarasfree09net.ml","klassmaster.com","klassmaster.net","klasyczne.info","klembaxh23oy.gq","klemon.ru","klerom.in","kles.info","klhaeeseee.pl","klick-tipp.us","klimatyzacjaa.pl","klinika-zdrowotna.pl","klipp.su","klipschx12.com","klo.com","kloap.com","klodrter.pl","klone0rz.be","klopsjot.ch","klubnikatv.com","kludgemush.com","klvm.gq","klytreuk.com.uk","klzlk.com","klzmedia.com","km4fsd6.pl","kmail.mooo.com","kmail.wnetz.pl","kmeuktpmh.pl","kmhow.com","kmonlinestore.co.uk","kmrx1hloufghqcx0c3.cf","kmrx1hloufghqcx0c3.ga","kmrx1hloufghqcx0c3.gq","kmrx1hloufghqcx0c3.ml","kmrx1hloufghqcx0c3.tk","kmwtevepdp178.gq","kn7il8fp1.pl","kniffel-online.info","knol-power.nl","knolselder.cf","knolselder.ga","knolselder.gq","knolselder.ml","knolselder.tk","knowledge-from-0.com","knptest.com","kntl.me","knw4maauci3njqa.cf","knw4maauci3njqa.gq","knw4maauci3njqa.ml","knw4maauci3njqa.tk","ko76nh.com","koalaltd.net","kobessa.com","koch.ml","kochkurse-online.info","kod-emailing.com","kod-maling.com","kodaka.cf","kodaka.ga","kodaka.gq","kodaka.ml","kodaka.tk","kodemail.ga","kodemailing.com","kodmailing.com","kodorsex.cf","koewrt.in","kogojet.net","kohlsprintablecouponshub.com","kohz5gxm.pl","koiqe.com","koismwnndnbfcswte.cf","koismwnndnbfcswte.ga","koismwnndnbfcswte.gq","koismwnndnbfcswte.ml","koismwnndnbfcswte.tk","kojon6ki.cy","kojonki.cy","kojsaef.ga","kokinus.ro","kokorot.cf","kokorot.ga","kokorot.gq","kokorot.ml","kokorot.tk","kolagenanaturalny.eu","kolczynka.pl","kolekcjazegarkow.com","koloekmail.com","koloekmail.net","kolovers.com","kolumb-nedv.ru","kolyasski.com","kommunity.biz","kommv.cc.be","kompakteruss.cf","komper.info","kon42.com","konferencja-partnerstwo-publiczno-prywatne.pl","kongzted.net","konno.tk","konsalt-proekt.ru","kontagion.pl","kontakt.imagehostfile.eu","kontaktbloxx.com","konto-w-banku.net","kontol.city","kontol.co.uk","konultant-jurist.ru","konveksigue.com","koochmail.info","koofy.net","kook.ml","kookabungaro.com","kopagas.com","kopaka.net","kopiacehgayo15701806.cf","kopiacehgayo15701806.ga","kopiacehgayo15701806.ml","kopiacehgayo15701806.tk","kopibajawapunya15711640.cf","kopibajawapunya15711640.ga","kopibajawapunya15711640.ml","kopibajawapunya15711640.tk","kopikapalapi11821901.cf","kopikapalapi11821901.ga","kopikapalapi11821901.ml","kopikapalapi11821901.tk","kopipahit.ga","kopqi.com","korcznerwowy.com","kore-tv.com","koreamail.cf","koreamail.ml","koreautara.cf","koreautara.ga","korelmail.com","korika.com","kormail.xyz","korona-nedvizhimosti.ru","korozy.de","korsakov-crb.ru","korutbete.cf","kosgcg0y5cd9.cf","kosgcg0y5cd9.ga","kosgcg0y5cd9.gq","kosgcg0y5cd9.ml","kosgcg0y5cd9.tk","koshu.ru","kosiarszkont.com","kosla.pl","kosmetik-obatkuat.com","kosmetika-kr.info","kosmetika-pro.in.ua","kosolar.pl","kosta-rika-nedv.ru","kostenlos-web.com","kostenlosemailadresse.de","kostestas.co.pl","kosze-na-smieciok.pl","koszmail.pl","koszulki-swiat.pl","kotiki.pw","kotruyerwrwyrtyuio.co.tv","kotsu01.info","kouattre38t.cf","kouattre38t.ga","kouattre38t.gq","kouattre38t.ml","kouattre38t.tk","kovezero.com","koweancenjancok.cf","koweancenjancok.ga","koweancenjancok.gq","koweancenjancok.ml","kowert.in","koyocah.ml","koyunum.com","koyunum.net","kozacki.pl","kozow.com","kpooa.com","kpost.be","kpxnxpkst.pl","kqhs4jbhptlt0.cf","kqhs4jbhptlt0.ga","kqhs4jbhptlt0.gq","kqhs4jbhptlt0.ml","kqhs4jbhptlt0.tk","kqo0p9vzzrj.ga","kqo0p9vzzrj.gq","kqo0p9vzzrj.ml","kqo0p9vzzrj.tk","kqwyqzjvrvdewth81.cf","kqwyqzjvrvdewth81.ga","kqwyqzjvrvdewth81.gq","kqwyqzjvrvdewth81.ml","kqwyqzjvrvdewth81.tk","kraftdairymail.info","krakowpost.pl","krakowskiadresvps.com","kramatjegu.com","krankenversicherungvergleich24.com","krapaonarak.com","krasavtsev-ua.pp.ua","krd.ag","kre8ivelance.com","kreacja.info","kreacjainfo.net","kreatorzyiimprez.pl","kreatorzyimprez.pl","kredit-beamten.de","kreditmindi.org","kredytsamochodowy9.pl","kreines71790.co.pl","krem-maslo.info","krentery.tk","kresla-stulia.info","kreuiema.com","krgyui7svgomjhso.cf","krgyui7svgomjhso.ga","krgyui7svgomjhso.gq","krgyui7svgomjhso.ml","krgyui7svgomjhso.tk","krhr.co.cc","krnuqysd.pl","krodnd2a.pl","krompakan.xyz","krondon.com","krovanaliz.ru","krovatka.su","krsw.sonshi.cf","krsw.tk","krte3562nfds.cf","krte3562nfds.ga","krte3562nfds.gq","krte3562nfds.ml","krte3562nfds.tk","krtjrzdt1cg2br.cf","krtjrzdt1cg2br.ga","krtjrzdt1cg2br.gq","krtjrzdt1cg2br.ml","krtjrzdt1cg2br.tk","krupp.cf","krupp.ga","krupp.ml","krupukhslide86bze.gq","krushinem.net","krxr.ru","krypton.tk","krystallettings.co.uk","krystalresidential.co.uk","krzysztofpiotrowski.com","ks87.igg.biz","ks87.usa.cc","kserokopiarki-gliwice.com.pl","kserokopiarki.pl","ksframem.com","ksiegapozycjonera.priv.pl","ksignnews.com","ksiskdiwey.cf","ksmtrck.cf","ksmtrck.ga","ksmtrck.rf.gd","ksmtrck.tk","ksqpmcw8ucm.cf","ksqpmcw8ucm.ga","ksqpmcw8ucm.gq","ksqpmcw8ucm.ml","ksqpmcw8ucm.tk","ktajnnwkzhp9fh.cf","ktajnnwkzhp9fh.ga","ktajnnwkzhp9fh.gq","ktajnnwkzhp9fh.ml","ktajnnwkzhp9fh.tk","ktds.co.uk","ktotey6.mil.pl","ku1hgckmasms6884.cf","ku1hgckmasms6884.ga","ku1hgckmasms6884.gq","ku1hgckmasms6884.ml","ku1hgckmasms6884.tk","kuai909.com","kuaijenwan.com","kuaixueapp01.mygbiz.com","kuantumdusunce.tk","kuatcak.cf","kuatcak.tk","kuatkanakun.com","kuatmail.gq","kuatmail.tk","kuatocokjaran.cf","kuatocokjaran.ga","kuatocokjaran.gq","kuatocokjaran.ml","kuatocokjaran.tk","kuba-nedv.ru","kuba.rzemien.xon.pl","kuchenmobel-berlin.ovh","kuchniee.eu","kucingarong.cf","kucingarong.ga","kucingarong.gq","kucingarong.ml","kucinge.site","kucoba.ml","kudaponiea.cf","kudaponiea.ga","kudaponiea.ml","kudaponiea.tk","kudaterbang.gq","kudzu.info.pl","kue747rfvg.cf","kue747rfvg.ga","kue747rfvg.gq","kue747rfvg.ml","kue747rfvg.tk","kuemail.men","kufrrygq.info","kugorze.com.pl","kuhlgefrierkombinationen.info","kuhninazakaz.info","kuhrap.com","kuikytut.review","kuiljunyu69lio.cf","kuingin.ml","kuiqa.com","kujztpbtb.pl","kukowski.eu","kukowskikukowski.eu","kukuite.ch","kulepszejprzyszlosci.pl","kulitlumpia.ml","kulitlumpia1.ga","kulitlumpia2.cf","kulitlumpia3.ml","kulitlumpia4.ga","kulitlumpia5.cf","kulitlumpia6.ml","kulitlumpia7.ga","kulitlumpia8.cf","kulksttt.com","kulmeo.com","kulpik.club","kulturalneokazje.pl","kulturbetrieb.info","kum38p0dfgxz.cf","kum38p0dfgxz.ga","kum38p0dfgxz.gq","kum38p0dfgxz.ml","kum38p0dfgxz.tk","kumail8.info","kumisgonds69.me","kungfuseo.info","kungfuseo.net","kungfuseo.org","kuni-liz.ru","kunimedesu.com","kuoogle.com","kupakupa.waw.pl","kupiru.net","kupoklub.ru","kupsstubirfag.xyz","kurkumazin.shn-host.ru","kursovaya-rabota.com","kurz-abendkleider.com","kurzepost.de","kusam.ga","kusrc.com","kusyuvalari.com","kut-mail1.com","kutakbisadekatdekat.cf","kutakbisadekatdekat.ml","kutakbisadekatdekat.tk","kutakbisajauhjauh.cf","kutakbisajauhjauh.ga","kutakbisajauhjauh.gq","kutakbisajauhjauh.ml","kutakbisajauhjauh.tk","kuteotieu111.cz.cc","kuucrechf.pl","kuugyomgol.pl","kuyberuntung.com","kv8v0bhfrepkozn4.cf","kv8v0bhfrepkozn4.ga","kv8v0bhfrepkozn4.gq","kv8v0bhfrepkozn4.ml","kv8v0bhfrepkozn4.tk","kw9gnq7zvnoos620.cf","kw9gnq7zvnoos620.ga","kw9gnq7zvnoos620.gq","kw9gnq7zvnoos620.ml","kw9gnq7zvnoos620.tk","kwadratowamaskar.pl","kwalidd.cf","kweci.com","kwertueitrweo.co.tv","kwestor4.pl","kwestor5.pl","kwestor6.pl","kwestor7.pl","kwestor8.pl","kwiatownik.pl","kwiatyikrzewy.pl","kwift.net","kwilco.net","kxliooiycl.pl","kxmnbhm.gsm.pl","kxzaten9tboaumyvh.cf","kxzaten9tboaumyvh.ga","kxzaten9tboaumyvh.gq","kxzaten9tboaumyvh.ml","kxzaten9tboaumyvh.tk","ky-ky-ky.ru","kyal.pl","kyfeapd.pl","kyois.com","kz64vewn44jl79zbb.cf","kz64vewn44jl79zbb.ga","kz64vewn44jl79zbb.gq","kz64vewn44jl79zbb.ml","kz64vewn44jl79zbb.tk","kzq6zi1o09d.cf","kzq6zi1o09d.ga","kzq6zi1o09d.gq","kzq6zi1o09d.ml","kzq6zi1o09d.tk","kzw1miaisea8.cf","kzw1miaisea8.ga","kzw1miaisea8.gq","kzw1miaisea8.ml","kzw1miaisea8.tk","l-c-a.us","l.bgsaddrmwn.me","l.polosburberry.com","l.r3-r4.tk","l.safdv.com","l0.l0l0.xyz","l00s9ukoyitq.cf","l00s9ukoyitq.ga","l00s9ukoyitq.gq","l00s9ukoyitq.ml","l00s9ukoyitq.tk","l0l.l1l.ink","l0llbtp8yr.cf","l0llbtp8yr.ga","l0llbtp8yr.gq","l0llbtp8yr.ml","l0llbtp8yr.tk","l0real.net","l1rwscpeq6.cf","l1rwscpeq6.ga","l1rwscpeq6.gq","l1rwscpeq6.ml","l1rwscpeq6.tk","l2n5h8c7rh.com","l33r.eu","l48zzrj7j.pl","l4usikhtuueveiybp.cf","l4usikhtuueveiybp.gq","l4usikhtuueveiybp.ml","l4usikhtuueveiybp.tk","l5.ca","l5prefixm.com","l6factors.com","l73x2sf.mil.pl","l745pejqus6b8ww.cf","l745pejqus6b8ww.ga","l745pejqus6b8ww.gq","l745pejqus6b8ww.ml","l745pejqus6b8ww.tk","l7b2l47k.com","l8oaypr.com","l9qwduemkpqffiw8q.cf","l9qwduemkpqffiw8q.ga","l9qwduemkpqffiw8q.gq","l9qwduemkpqffiw8q.ml","l9qwduemkpqffiw8q.tk","l9tmlcrz2nmdnppabik.cf","l9tmlcrz2nmdnppabik.ga","l9tmlcrz2nmdnppabik.gq","l9tmlcrz2nmdnppabik.ml","l9tmlcrz2nmdnppabik.tk","la0u56qawzrvu.cf","la0u56qawzrvu.ga","la2imperial.vrozetke.com","la5ralo.345.pl","labas.com","labetteraverouge.at","labfortyone.tk","labo.ch","laboratortehnicadentara.ro","laboriously.com","labum.com","lacedmail.com","lacercadecandi.ml","lackmail.net","lackmail.ru","laconicoco.net","lacosteshoesfree.com","lacto.info","laden3.com","ladiabetessitienecura.com","ladrop.ru","lady-jisel.pl","ladycosmetics.ru","ladydressnow.com","ladyfleece.com","ladylovable.com","ladymacbeth.tk","ladyvictory-vlg.ru","lafrem3456ails.com","lagiapa.online","lagicantiik.com","lagify.com","lags.us","lagugratis.net","lagushare.me","lahamnakam.me","lahta9qru6rgd.cf","lahta9qru6rgd.ga","lahta9qru6rgd.gq","lahta9qru6rgd.ml","lahta9qru6rgd.tk","laika999.ml","laikacyber.cf","laikacyber.ga","laikacyber.gq","laikacyber.ml","laikacyber.tk","lain.ch","lajoska.pe.hu","lak.pp.ua","lakarstwo.info","lakarunyha65jjh.ga","lakefishingadvet.net","lakelivingstonrealestate.com","lakeplacid2009.info","laketahoe-realestate.info","lakngin.ga","lakngin.ml","lakqs.com","lal.kr","lala-mailbox.club","lala-mailbox.online","lalala-family.com","lalala.fun","lalala.site","lalalaanna.com","lalalamail.net","lalalapayday.net","lalamailbox.com","lam0k.com","lambadarew90bb.gq","lambda.uniform.thefreemail.top","lambdaecho.webmailious.top","lambdasu.com","lamdep.net","lamdx.com","lami4you.info","lamongan.cf","lamongan.gq","lamongan.ml","lamore.com","lampadaire.cf","lamseochuan.com","lan-utan-uc-se.com","lancasterpainfo.com","lancasterplumbing.co.uk","lancego.space","lancelsacspascherefr.com","lancia.ga","lancia.gq","lancourt.com","lancsvt.co.uk","landans.ru","landaugo.com","landmail.co","landmark.io","landonbrafford.com","langabendkleider.com","langanswers.ru","langitserver.biz","laoeq.com","laoho.com","laonanrenj.com","laotmail.com","laparbgt.cf","laparbgt.ga","laparbgt.gq","laparbgt.ml","laporinaja.com","lapptoposse99.com","laptopbeddesk.net","laptopcooler.me","laptoptechie.com","laputs.co.pl","laraes.pl","laramail.io","largeformatprintonline.com","largo.laohost.net","larisia.com","larjem.com","laroadsigns.info","larryblair.me","lasde.xyz","laserfratetatuaj.com","laserowe-ciecie.pl","laserremovalreviews.com","lasertypes.net","lasixonlineatonce.com","lasixonlinesure.com","lasixonlinetablets.com","lasixprime.com","lasojcyjrcwi8gv.cf","lasojcyjrcwi8gv.ga","lasojcyjrcwi8gv.gq","lasojcyjrcwi8gv.ml","lasojcyjrcwi8gv.tk","last-chance.pro","laste.ml","lastmail.co","lastmail.com","lastmail.ga","lastrwasy.co.cc","laszki.info","lat-nedv.ru","latemail.tech","latestgadgets.com","latinchat.com","latinmail.com","launchjackings.com","laurenbt.com","lavabit.com","laverneste.com","lawenforcementcanada.ca","lawfinancial.ru","lawhead79840.co.pl","lawlita.com","lawlz.net","lawrence1121.club","lawsocial.ru","lawsocietyfindasolicitor.net","lawsocietyfindasolicitor.org","lawson.cf","lawson.ga","lawson.gq","lawyers2016.info","laychuatrenxa.ga","lazarskipl.com","lazdmzmgke.mil.pl","lazyarticle.com","lazyinbox.com","lazyinbox.us","lazymail.me","lazymail.ooo","lbe.kr","lbhuxcywcxjnh.cf","lbhuxcywcxjnh.ga","lbhuxcywcxjnh.gq","lbhuxcywcxjnh.ml","lbhuxcywcxjnh.tk","lbitly.com","lbjmail.com","lbn10.com","lbn11.com","lbn12.com","lbn13.com","lbn14.com","lboinhomment.info","lbx0qp.pl","lcamywkvs.pl","lcebull.com","lceland.net","lceland.org","lcelander.com","lcelandic.com","lcshjgg.com","lcyxfg.com","ldaho.biz","ldaho.net","ldaho0ak.com","ldaholce.com","ldebaat9jp8x3xd6.cf","ldebaat9jp8x3xd6.ga","ldebaat9jp8x3xd6.gq","ldebaat9jp8x3xd6.ml","ldebaat9jp8x3xd6.tk","ldefsyc936cux7p3.cf","ldefsyc936cux7p3.ga","ldefsyc936cux7p3.gq","ldefsyc936cux7p3.ml","ldefsyc936cux7p3.tk","ldnplaces.com","ldokfgfmail.com","ldokfgfmail.net","ldop.com","ldovehxbuehf.cf","ldovehxbuehf.ga","ldovehxbuehf.gq","ldovehxbuehf.ml","ldovehxbuehf.tk","ldtp.com","le-asi-yyyo-ooiue.com","le-tim.ru","le.monchu.fr","lea-0-09ssiue.org","lea-ss-ws-33.org","leaddogstats.com","leadingemail.com","leadlovers.site","leagueofdefenders.gq","leagueoflegendscodesgratuit.fr","leakydisc.com","leapradius.com","learnaffiliatemarketingbusiness.org","learnhowtobehappy.info","learntofly.me","leasecarsuk.info","leasswsiue.org","leave-notes.com","lebronjamessale.com","lecsaljuk.club","lecz6s2swj1kio.cf","lecz6s2swj1kio.ga","lecz6s2swj1kio.gq","lecz6s2swj1kio.ml","lecz6s2swj1kio.tk","leczycanie.pl","led-best.ru","ledgardenlighting.info","ledoktre.com","lee.mx","leeching.net","leemail.me","leerling.ml","lefmail.com","left-mail.com","leftsydethoughts.com","legacymode2011.info","legalalien.net","legalizamei.com","legalrc.loan","legalresourcenow.com","legalsentences.com","legalsteroidsstore.info","legcramps.in","legitimateonline.info","lehman.cf","lehman.ga","lehman.gq","lehman.ml","lehman.tk","lei.kr","leknawypadaniewlosow.pl","leks.me","lellno.gq","lelucoon.net","lembarancerita.ga","lembarancerita.ml","lemonadeka.org.ua","lemondresses.com","lemondresses.net","lemper.cf","lemurhost.net","leniences.com","lenlusiana5967.ga","lenmawarni5581.ml","lennurfitria2852.ml","lenovo120s.cf","lenovo120s.gq","lenovo120s.ml","lenovo120s.tk","lenovog4.com","lenprayoga2653.ml","lenputrima5494.cf","lensdunyasi.com","lensmarket.com","leonelahmad.cf","leonmail.men","leos.org.uk","leparfait.net","lequitywk.com","lequydononline.net","lerch.ovh","lesbugs.com","lesmail.top","lesotho-nedv.ru","lespassant.com","lestnicy.in.ua","lesy.pl","letgo99.com","letmeinonthis.com","letmymail.com","letsgo.co.pl","letsgoalep.net","letsmail9.com","letthemeatspam.com","letup.com","leufhozu.com","level-3.cf","level-3.ga","level-3.gq","level-3.ml","level-3.tk","level3.flu.cc","level3.igg.biz","level3.nut.cc","level3.usa.cc","levisdaily.com","levothyroxinedosage.com","levtbox.com","levtov.net","levy.ml","lew2sv9bgq4a.cf","lew2sv9bgq4a.ga","lew2sv9bgq4a.gq","lew2sv9bgq4a.ml","lew2sv9bgq4a.tk","lexisense.com","lexoxasnj.pl","leysatuhell.sendsmtp.com","lez.se","lfifet19ax5lzawu.ga","lfifet19ax5lzawu.gq","lfifet19ax5lzawu.ml","lfifet19ax5lzawu.tk","lfsvddwij.pl","lg-g7.cf","lg-g7.ga","lg-g7.gq","lg-g7.ml","lg-g7.tk","lgfvh9hdvqwx8.cf","lgfvh9hdvqwx8.ga","lgfvh9hdvqwx8.gq","lgfvh9hdvqwx8.ml","lgfvh9hdvqwx8.tk","lghjgbh89xcfg.cf","lgjiw1iaif.gq","lgjiw1iaif.ml","lgjiw1iaif.tk","lgloo.net","lgloos.com","lgmail.com","lgt8pq4p4x.cf","lgt8pq4p4x.ga","lgt8pq4p4x.gq","lgt8pq4p4x.ml","lgt8pq4p4x.tk","lgx2t3iq.pl","lgxscreen.com","lgyimi5g4wm.cf","lgyimi5g4wm.ga","lgyimi5g4wm.gq","lgyimi5g4wm.ml","lgyimi5g4wm.tk","lh-properties.co.uk","lh2ulobnit5ixjmzmc.cf","lh2ulobnit5ixjmzmc.ga","lh2ulobnit5ixjmzmc.gq","lh2ulobnit5ixjmzmc.ml","lh2ulobnit5ixjmzmc.tk","lh451.cf","lh451.ga","lh451.gq","lh451.ml","lh451.tk","lhkjfg45bnvg.gq","lhrnferne.mil.pl","lhsdv.com","liamcyrus.com","liamekaens.com","lianhe.in","libertymail.info","libox.fr","librans.co.uk","libriumprices.com","licencja.host-001.eu","lichten-nedv.ru","licytuj.net.pl","lienminhnuthan.vn","lifebyfood.com","lifeforchanges.com","lifeguru.online","lifestyle4u.ru","lifestylemagazine.co","lifetimefriends.info","lifetotech.com","liffoberi.com","liftandglow.net","ligagnb.pl","lightengroups.com","lighting-us.info","lightpower.pw","ligirls.ru","ligsb.com","lihuafeng.com","lijeuki.co","likelystory.net","likeorunlike.info","likesv.com","likesyouback.com","likevipfb.cf","lilin.pl","lillemap.net","lilnx.net","lilo.me","lilylee.com","limahfjdhn89nb.tk","limamail.ml","limaquebec.webmailious.top","limsoohyang.com","limuzyny-hummer.pl","lin.lingeriemaid.com","lin889.com","lindaknujon.info","lindenbaumjapan.com","lineofequitycredit.net","lines12.com","lingdlinjewva.xyz","linguistic.ml","linguisticlast.com","linind.ru","linjianhui.me","link-assistant.com","link-protector.biz","link.cloudns.asia","link2mail.net","linkadulttoys.com","linkauthorityreview.info","linkedintuts2016.pw","linki321.pl","linkjewellery.com","linksdown.net","linku.in","linkusupng.com","linop.online","linshiyouxiang.net","linshuhang.com","linux.7m.ro","linuxmail.so","linuxmail.tk","linuxpl.eu","linx.email","lioasdero.tk","lioplpac.com","liopolo.com","liopolop.com","lipitorprime.com","lipo13blogs.com","liposuctionofmiami.com","lippystick.info","lipskydeen.ga","liquidation-specialists.com","liquidmail.de","lirikkuy.cf","lisamadison.cf","lisseurghdpascherefr.com","lisseurghdstylers.com","lissseurghdstylers.com","list-here.com","list.elk.pl","listallmystuff.info","listdating.info","listtoolseo.info","litbnno874tak6nc2oh.cf","litbnno874tak6nc2oh.ga","litbnno874tak6nc2oh.ml","litbnno874tak6nc2oh.tk","litedrop.com","littlebiggift.com","littlemail.org.ua","littlepc.ru","littlestpeopletoysfans.com","litva-nedv.ru","livan-nedv.ru","live.encyclopedia.tw","live1994.com","livecam.edu","livecam24.cc","livecur.info","livedebtfree.co.uk","livedecors.com","liveemail.xyz","livejournali.com","livemail.bid","livemail.download","livemail.men","livemail.stream","livemail.top","livemail.trade","livemaill.com","livemails.info","liveoctober2012.info","livepharma.org","liveproxies.info","liveradio.tk","livercirrhosishelp.info","livern.eu","liveset100.info","liveset200.info","liveset300.info","liveset404.info","liveset505.info","liveset600.info","liveset700.info","liveset880.info","livesex-camgirls.info","livesilk.info","liveskiff.us","livingsalty.us","livingwater.net","livingwealthyhealthy.com","livinwuater.com","livzadsz.com","lixo.loxot.eu","ljgcdxozj.pl","ljhjhkrt.cf","ljhjhkrt.ga","ljhjhkrt.ml","ljkjouinujhi.info","ljogfbqga.pl","lkfeybv43ws2.cf","lkfeybv43ws2.ga","lkfeybv43ws2.gq","lkfeybv43ws2.ml","lkfeybv43ws2.tk","lkgn.se","lkhcdiug.pl","lkim1wlvpl.com","lkiopooo.com","lkjhjkuio.info","lkjhljkink.info","lkjjikl2.info","lko.co.kr","lko.kr","lkoqmcvtjbq.cf","lkoqmcvtjbq.ga","lkoqmcvtjbq.gq","lkoqmcvtjbq.ml","lkoqmcvtjbq.tk","lkscedrowice.pl","lkxloans.com","ll47.net","llaen.net","llfilmshere.tk","llil.info","llj59i.kr.ua","llogin.ru","llzali3sdj6.cf","llzali3sdj6.ga","llzali3sdj6.gq","llzali3sdj6.ml","llzali3sdj6.tk","lm0k.com","lmcudh4h.com","lmialovo.com","ln0hio.com","ln0rder.com","ln0ut.com","ln0ut.net","lndex.net","lndex.org","lnongqmafdr7vbrhk.cf","lnongqmafdr7vbrhk.ga","lnongqmafdr7vbrhk.gq","lnongqmafdr7vbrhk.ml","lnongqmafdr7vbrhk.tk","lnvoke.net","lnvoke.org","lnwhosting.com","lo.guapo.ro","loa22ttdnx.cf","loa22ttdnx.ga","loa22ttdnx.gq","loa22ttdnx.ml","loa22ttdnx.tk","loadby.us","loadingsite.info","loan101.pro","loancash.us","loanfast.com","loanins.org","loans.com","loaoa.com","loaphatthanh.com","loapq.com","loblaw.twilightparadox.com","local-classifiedads.info","local.tv","localbreweryhouse.info","localsape.com","localserv.no-ip.org","localslots.co","localss.com","localtenniscourt.com","localtopography.com","localwomen-meet.cf","localwomen-meet.ga","localwomen-meet.gq","localwomen-meet.ml","locanto1.club","locantofuck.top","locantospot.top","locantowsite.club","locarlsts.com","located6j.com","locateme10.com","locationans.ru","loccomail.host","lockedsyz.com","locomodev.net","lodon.cc","loehkgjftuu.aid.pl","lofi-untd.info","logaelda603.ml","loganairportbostonlimo.com","loganisha253.ga","logardha605.ml","logartika465.ml","logatarita892.cf","logatarita947.tk","logavrilla544.ml","logdewi370.ga","logdufay341.ml","logefrinda237.ml","logertasari851.cf","logesra202.cf","logeva564.ga","logfauziyah838.tk","logfika450.cf","logfitriani914.ml","logfrisaha808.ml","loghermawaty297.ga","loghermawaty297.ml","loghermawaty297.tk","loghning469.cf","loghusnah2.cf","logike708.cf","login-email.cf","login-email.ga","login-email.ml","login-email.tk","loginadulttoys.com","logingar.cf","logingar.ga","logingar.gq","logingar.ml","loginpage-documentneedtoupload.com","loginz.net","logismi227.ml","logiteech.com","logmardhiyah828.ml","logmaureen141.tk","logmoerdiati40.tk","lognadiya556.ml","lognoor487.cf","logoktafiyanti477.cf","logopitop.com","logpabrela551.ml","logrialdhie62.ga","logrialdhie707.cf","logrozi350.tk","logsharifa965.ml","logsinuka803.ga","logstefanny934.cf","logsutanti589.tk","logsyarifah77.tk","logtanuwijaya670.tk","logtheresia637.cf","logtiara884.ml","logular.com","logutomo880.ml","logvirgina229.tk","logw735.ml","logwan245.ml","logwibisono870.ml","logwulan9.ml","logyanti412.ga","loh.pp.ua","loin.in","lokaperuss.com","lokata-w-banku.com.pl","lokd.com","lokerupdate.me","loketa.com","lokka.net","lokmynghf.com","lokum.nu","lol.it","lol.ovpn.to","lolemails.pl","lolfhxvoiw8qfk.cf","lolfhxvoiw8qfk.ga","lolfhxvoiw8qfk.gq","lolfhxvoiw8qfk.ml","lolfhxvoiw8qfk.tk","lolfreak.net","lolidze.top","lolio.com","lolioa.com","lolior.com","lolitka.cf","lolitka.ga","lolitka.gq","lolito.tk","lolllipop.stream","lolmail.biz","lolo1.dk","lolokakedoiy.com","lolusa.ru","lolwegotbumedlol.com","lom.kr","london2.space","londonescortsbabes.co","londonlocalbiz.com","long-eveningdresses.com","long.idn.vn","longchamponlinesale.com","longio.org","longlongcheng.com","longmonkey.info","lonker.net","lonrahtritrammail.com","lonthe.ml","looklemsun.uni.me","lookmail.ml","lookthesun.tk","lookugly.com","loonycoupon.com","loopemail.online","loopy-deals.com","lopeure.com","lopivolop.com","lopl.co.cc","lordmobilehackonline.eu","lordsofts.com","lordvold.cf","lordvold.ga","lordvold.gq","lordvold.ml","lorencic.ro","lorotzeliothavershcha.info","lortemail.dk","losa.tr","losangeles-realestate.info","lose20pounds.info","losebellyfatau.com","losemymail.com","loseweight-advice.info","loseweightnow.tk","loskmail.com","losowynet.com","lostfilmhd1080.ru","lostpositive.xyz","lottoresults.ph","lottosend.ro","louboinhomment.info","louboutinemart.com","louboutinkutsutenpojp.com","louboutinpascher1.com","louboutinpascher2.com","louboutinpascher3.com","louboutinpascher4.com","louboutinpascheshoes.com","louboutinshoesfr.com","louboutinshoessalejp.com","louboutinshoesstoresjp.com","louboutinshoesus.com","louder1.bid","louis-vuitton-onlinestore.com","louis-vuitton-outlet.com","louis-vuitton-outletenter.com","louis-vuitton-outletsell.com","louis-vuittonbags.info","louis-vuittonbagsoutlet.info","louis-vuittonoutlet.info","louis-vuittonoutletonline.info","louis-vuittonsac.com","louisvillestudio.com","louisvuitton-handbagsonsale.info","louisvuitton-handbagsuk.info","louisvuitton-outletstore.info","louisvuitton-replica.info","louisvuitton-uk.info","louisvuittonallstore.com","louisvuittonbagsforcheap.info","louisvuittonbagsjp.org","louisvuittonbagsuk-cheap.info","louisvuittonbagsukzt.co.uk","louisvuittonbeltstore.com","louisvuittoncanadaonline.info","louisvuittonchoooutlet.com","louisvuittondesignerbags.info","louisvuittonfactory-outlet.us","louisvuittonffr1.com","louisvuittonforsalejp.com","louisvuittonhandbags-ca.info","louisvuittonhandbagsboutique.us","louisvuittonhandbagsoutlet.us","louisvuittonhandbagsprices.info","louisvuittonjpbag.com","louisvuittonjpbags.org","louisvuittonjpsale.com","louisvuittonmenwallet.info","louisvuittonmonogramgm.com","louisvuittonnfr.com","louisvuittonnicebag.com","louisvuittonofficielstore.com","louisvuittononlinejp.com","louisvuittonoutlet-store.info","louisvuittonoutlet-storeonline.info","louisvuittonoutlet-storesonline.info","louisvuittonoutlet-usa.us","louisvuittonoutletborseitaly.com","louisvuittonoutletborseiy.com","louisvuittonoutletjan.net","louisvuittonoutletonlinestore.info","louisvuittonoutletrich.net","louisvuittonoutletrt.com","louisvuittonoutletstoregifts.us","louisvuittonoutletstores-online.info","louisvuittonoutletstores-us.info","louisvuittonoutletstoresonline.us","louisvuittonoutletsworld.net","louisvuittonoutletwe.com","louisvuittonoutletzt.co.uk","louisvuittonpursesstore.info","louisvuittonreplica-outlet.info","louisvuittonreplica.us","louisvuittonreplica2u.com","louisvuittonreplicapurse.info","louisvuittonreplicapurses.us","louisvuittonretailstore.com","louisvuittonrreplicahandbagsus.com","louisvuittonsac-fr.info","louisvuittonsavestore.com","louisvuittonsbags8.com","louisvuittonshopjapan.com","louisvuittonshopjp.com","louisvuittonshopjp.org","louisvuittonshopoutletjp.com","louisvuittonsjapan.com","louisvuittonsjp.org","louisvuittonsmodaitaly1.com","louisvuittonspascherfrance1.com","louisvuittonstoresonline.com","louisvuittontoteshops.com","louisvuittonukbags.info","louisvuittonukofficially.com","louisvuittonukzt.co.uk","louisvuittonused.info","louisvuittonwholesale.info","louisvuittonworldtour.com","louisvunttonworldtour.com","louivuittoutletuksalehandbags.co.uk","loux5.universallightkeys.com","love-fuck.ru","love.info","love4writing.info","loveabledress.com","loveabledress.net","loveablelady.com","loveablelady.net","lovebitco.in","lovecuirinamea.com","lovediscuss.ru","lovefall.ml","lovelemk.tk","lovelybabygirl.com","lovelybabygirl.net","lovelybabylady.com","lovelybabylady.net","lovelyhotmail.com","lovelyladygirl.com","lovelyshoes.net","loveme.com","lovemeet.faith","lovemeleaveme.com","lovemue.com","loves.dicksinhisan.us","loves.dicksinmyan.us","lovesea.gq","lovesoftware.net","lovesunglasses.info","lovesystemsdates.com","lovetests99.com","lovingnessday.com","lovingnessday.net","lovingr3co.ga","lovisvuittonsjapan.com","lovitolp.com","lovxwyzpfzb2i4m8w9n.cf","lovxwyzpfzb2i4m8w9n.ga","lovxwyzpfzb2i4m8w9n.gq","lovxwyzpfzb2i4m8w9n.tk","low.pixymix.com","lowcypromocji.com.pl","lowerrightabdominalpain.org","lowestpricesonthenet.com","loy.kr","loyalherceghalom.ml","loyalnfljerseys.com","lpfmgmtltd.com","lpi1iyi7m3zfb0i.cf","lpi1iyi7m3zfb0i.ga","lpi1iyi7m3zfb0i.gq","lpi1iyi7m3zfb0i.ml","lpi1iyi7m3zfb0i.tk","lpnnurseprograms.net","lpo.ddnsfree.com","lprssvflg.pl","lpurm5.orge.pl","lpva5vjmrzqaa.cf","lpva5vjmrzqaa.ga","lpva5vjmrzqaa.gq","lpva5vjmrzqaa.ml","lpva5vjmrzqaa.tk","lqghzkal4gr.cf","lqghzkal4gr.ga","lqghzkal4gr.gq","lqghzkal4gr.ml","lqlz8snkse08zypf.cf","lqlz8snkse08zypf.ga","lqlz8snkse08zypf.gq","lqlz8snkse08zypf.ml","lqlz8snkse08zypf.tk","lqonrq7extetu.cf","lqonrq7extetu.ga","lqonrq7extetu.gq","lqonrq7extetu.ml","lqonrq7extetu.tk","lr7.us","lr78.com","lrelsqkgga4.cf","lrelsqkgga4.ml","lrelsqkgga4.tk","lrfjubbpdp.pl","lrland.net","lroid.com","lron0re.com","lrtptf0s50vpf.cf","lrtptf0s50vpf.ga","lrtptf0s50vpf.gq","lrtptf0s50vpf.ml","lrtptf0s50vpf.tk","lru.me","ls-server.ru","lsrtsgjsygjs34.gq","lss176.com","lsxprelk6ixr.cf","lsxprelk6ixr.ga","lsxprelk6ixr.gq","lsxprelk6ixr.ml","lsxprelk6ixr.tk","ltcorp.org","ltdtab9ejhei18ze6ui.cf","ltdtab9ejhei18ze6ui.ga","ltdtab9ejhei18ze6ui.gq","ltdtab9ejhei18ze6ui.ml","ltdtab9ejhei18ze6ui.tk","ltfg92mrmi.cf","ltfg92mrmi.ga","ltfg92mrmi.gq","ltfg92mrmi.ml","ltfg92mrmi.tk","ltt0zgz9wtu.cf","ltt0zgz9wtu.gq","ltt0zgz9wtu.ml","ltt0zgz9wtu.tk","ltuc.edu.eu.org","lubie-placki.com.pl","lubisbukalapak.tk","lucaz.com","lucidmation.com","luckboy.pw","luckindustry.ru","luckjob.pw","luckmail.us","luckyladydress.com","luckyladydress.net","luckylooking.com","luckymail.org","lucyu.com","ludovodka.com","ludziepalikota.pl","lufaf.com","luggagetravelling.info","luilkkgtq43q1a6mtl.cf","luilkkgtq43q1a6mtl.ga","luilkkgtq43q1a6mtl.gq","luilkkgtq43q1a6mtl.ml","luilkkgtq43q1a6mtl.tk","luisgiisjsk.tk","luispedro.xyz","lukasfloor.com.pl","lukaszmitula.pl","lukecarriere.com","lukemail.info","lukop.dk","lulumelulu.org","lump.pa","lunarmail.info","lunatos.eu","lunchdinnerrestaurantmuncieindiana.com","luo.kr","lupabapak.org","lusianna.ml","lustlonelygirls.com","lutherhild.ga","luutrudulieu.net","luutrudulieu.online","luv2.us","luxembug-nedv.ru","luxor-sklep-online.pl","luxuriousdress.net","luxury-handbagsonsale.info","luxurychanel.com","luxuryoutletonline.us","luxuryshomemn.com","luxuryshopforpants.com","luxusmail.gq","luxusmail.tk","luxusmail.uk","lv-bags-outlet.com","lv-magasin.com","lv-outlet-online.org","lv2buy.net","lvbag.info","lvbag11.com","lvbags001.com","lvbagsjapan.com","lvbagsshopjp.com","lvbq5bc1f3eydgfasn.cf","lvbq5bc1f3eydgfasn.ga","lvbq5bc1f3eydgfasn.gq","lvbq5bc1f3eydgfasn.ml","lvbq5bc1f3eydgfasn.tk","lvc2txcxuota.cf","lvc2txcxuota.ga","lvc2txcxuota.gq","lvc2txcxuota.ml","lvc2txcxuota.tk","lvcheapsua.com","lvcheapusa.com","lvfityou.com","lvfiyou.com","lvforyouonlynow.com","lvhan.net","lvhandbags.info","lvheremeetyou.com","lvhotstyle.com","lvoulet.com","lvoutlet.com","lvoutletonlineour.com","lvpascher1.com","lvsaleforyou.com","lvtimeshow.com","lvxutizc6sh8egn9.cf","lvxutizc6sh8egn9.ga","lvxutizc6sh8egn9.gq","lvxutizc6sh8egn9.ml","lvxutizc6sh8egn9.tk","lwbmarkerting.info","lwmaxkyo3a.cf","lwmaxkyo3a.ga","lwmaxkyo3a.gq","lwmaxkyo3a.ml","lwmaxkyo3a.tk","lwmhcka58cbwi.cf","lwmhcka58cbwi.ga","lwmhcka58cbwi.gq","lwmhcka58cbwi.ml","lwmhcka58cbwi.tk","lwwz3zzp4pvfle5vz9q.cf","lwwz3zzp4pvfle5vz9q.ga","lwwz3zzp4pvfle5vz9q.gq","lwwz3zzp4pvfle5vz9q.ml","lwwz3zzp4pvfle5vz9q.tk","lxlxdtskm.pl","lxupukiw4dr277kay.cf","lxupukiw4dr277kay.ga","lxupukiw4dr277kay.gq","lxupukiw4dr277kay.ml","lxupukiw4dr277kay.tk","lycos.comx.cf","lyfestylecreditsolutions.com","lyjnhkmpe1no.cf","lyjnhkmpe1no.ga","lyjnhkmpe1no.gq","lyjnhkmpe1no.ml","lyjnhkmpe1no.tk","lylilupuzy.pl","lyrics-lagu.me","lyustra-bra.info","lyzj.org","lzcxssxirzj.cf","lzcxssxirzj.ga","lzcxssxirzj.gq","lzcxssxirzj.ml","lzcxssxirzj.tk","lzfkvktj5arne.cf","lzfkvktj5arne.ga","lzfkvktj5arne.gq","lzfkvktj5arne.tk","lzgyigfwf2.cf","lzgyigfwf2.ga","lzgyigfwf2.gq","lzgyigfwf2.ml","lzgyigfwf2.tk","lzoaq.com","lzpooigjgwp.pl","lzs94f5.pl","m-drugs.com","m-mail.cf","m-mail.ga","m-mail.gq","m-mail.ml","m-myth.com","m-p-s.cf","m-p-s.ga","m-p-s.gq","m.bccto.me","m.beedham.org","m.c-n-shop.com","m.codng.com","m.convulse.net","m.ddcrew.com","m.nosuchdoma.in","m.polosburberry.com","m.svlp.net","m.u-torrent.cf","m.u-torrent.ga","m.u-torrent.gq","m0.guardmail.cf","m00b2sryh2dt8.cf","m00b2sryh2dt8.ga","m00b2sryh2dt8.gq","m00b2sryh2dt8.ml","m00b2sryh2dt8.tk","m015j4ohwxtb7t.cf","m015j4ohwxtb7t.ga","m015j4ohwxtb7t.gq","m015j4ohwxtb7t.ml","m015j4ohwxtb7t.tk","m0lot0k.ru","m0y1mqvqegwfvnth.cf","m0y1mqvqegwfvnth.ga","m0y1mqvqegwfvnth.gq","m0y1mqvqegwfvnth.ml","m0y1mqvqegwfvnth.tk","m1.blogrtui.ru","m1.guardmail.cf","m2.guardmail.cf","m2.trekr.tk","m21.cc","m2project.xyz","m2r60ff.com","m3.guardmail.cf","m3u5dkjyz.pl","m4il5.pl","m4ilweb.info","m5s.flu.cc","m5s.igg.biz","m5s.nut.cc","m6c718i7i.pl","m8g8.com","m8gj8lsd0i0jwdno7l.cf","m8gj8lsd0i0jwdno7l.ga","m8gj8lsd0i0jwdno7l.gq","m8gj8lsd0i0jwdno7l.ml","m8gj8lsd0i0jwdno7l.tk","m8h63kgpngwo.cf","m8h63kgpngwo.ga","m8h63kgpngwo.gq","m8h63kgpngwo.ml","m8h63kgpngwo.tk","m8r.davidfuhr.de","m8r.mcasal.com","m8r8ltmoluqtxjvzbev.cf","m8r8ltmoluqtxjvzbev.ga","m8r8ltmoluqtxjvzbev.gq","m8r8ltmoluqtxjvzbev.ml","m8r8ltmoluqtxjvzbev.tk","m9enrvdxuhc.cf","m9enrvdxuhc.ga","m9enrvdxuhc.gq","m9enrvdxuhc.ml","m9enrvdxuhc.tk","m9so.ru","ma-boite-aux-lettres.infos.st","ma1l.bij.pl","ma1lgen622.ga","ma2limited.com","maaill.com","maart.ml","mabermail.com","mabh65.ga","maboard.com","mabuklagi.ga","mac.hush.com","macaniuo235.cf","macbookpro13.com","macdell.com","macpconline.com","macr2.com","macromaid.com","macromice.info","macslim.com","madagaskar-nedv.ru","maddison.allison.spithamail.top","madelhocin.xyz","madnter.com","madridmuseumsmap.info","madurahoki.com","maelcerkciks.com","mafiaa.cf","mafiaa.ga","mafiaa.gq","mafiaa.ml","mafrem3456ails.com","mag.su","magamail.com","magazin-biciclete.info","magazin20000.ru","magetrust.com","maggotymeat.ga","magia-malarska.pl","magicbeep.com","magicbox.ro","magicbroadcast.com","magicedhardy.com","magicmail.com","magiconly.ru","magicsubmitter.biz","magneticmessagingbobby.com","magnetik.com.ua","magnomsolutions.com","magspam.net","mahdevip.com","mahiidev.site","mai1bx.ovh","mai1campzero.net.com","maia.aniyah.coayako.top","maidlow.info","mail-2-you.com","mail-4-you.bid","mail-4server.com","mail-9g.pl","mail-address.live","mail-apps.com","mail-apps.net","mail-box.ml","mail-boxes.ru","mail-c.cf","mail-c.ga","mail-c.gq","mail-c.ml","mail-c.tk","mail-card.com","mail-card.net","mail-cart.com","mail-click.net","mail-demon.bid","mail-easy.fr","mail-fake.com","mail-filter.com","mail-finder.net","mail-fix.com","mail-group.net","mail-hub.info","mail-hub.online","mail-j.cf","mail-j.ga","mail-j.gq","mail-j.ml","mail-j.tk","mail-jim.gq","mail-jim.ml","mail-list.top","mail-miu.ml","mail-neo.gq","mail-owl.com","mail-point.net","mail-pro.info","mail-register.com","mail-s01.pl","mail-searches.com","mail-send.ru","mail-server.bid","mail-share.com","mail-space.net","mail-temp.com","mail-temporaire.com","mail-temporaire.fr","mail-tester.com","mail-vix.ml","mail-w.cf","mail-w.ga","mail-w.gq","mail-w.ml","mail-w.tk","mail-x91.pl","mail-z.gq","mail-z.ml","mail-z.tk","mail-zone.pp.ua","mail.anhthu.org","mail.ankokufs.us","mail.aws910.com","mail.backflip.cf","mail.bccto.com","mail.bccto.me","mail.bentrask.com","mail.bestoption25.club","mail.by","mail.c-n-shop.com","mail.chatfunny.com","mail.comx.cf","mail.crowdpress.it","mail.defaultdomain.ml","mail.effektiveerganzungen.de","mail.fast10s.design","mail.fettometern.com","mail.free-emailz.com","mail.gokir.eu","mail.grupogdm.com","mail.guokse.net","mail.hanungofficial.club","mail.health-ua.com","mail.hh1.pl","mail.hotxx.in","mail.illistnoise.com","mail.info","mail.johnscaffee.com","mail.jopasfo.net","mail.jpgames.net","mail.koalaltd.net","mail.libivan.com","mail.lindstromenterprises.com","mail.lowestpricesonthenet.com","mail.mailinator.com","mail.me","mail.mezimages.net","mail.mixhd.xyz","mail.mnisjk.com","mail.myde.ml","mail.myserv.info","mail.neynt.ca","mail.omahsimbah.com","mail.partskyline.com","mail.piaa.me","mail.pozycjonowanie8.pl","mail.przyklad-domeny.pl","mail.qmeta.net","mail.rthyde.com","mail.stars19.xyz","mail.tggmall.com","mail.ticket-please.ga","mail.to","mail.tomsoutletw.com","mail.toprevenue.net","mail.unionpay.pl","mail.vuforia.us","mail.wnetz.pl","mail.wtf","mail.wvwvw.tech","mail.yauuuss.net","mail.zp.ua","mail0.cf","mail0.ga","mail0.gq","mail0.ml","mail01.ns01.info","mail1.cf","mail1.drama.tw","mail1.ftp1.biz","mail1.hacked.jp","mail1.i-taiwan.tv","mail1.ismoke.hk","mail1.kaohsiung.tv","mail1.kein.hk","mail10.cf","mail10.ga","mail10.gq","mail10.ml","mail11.cf","mail11.gq","mail11.ml","mail114.net","mail14.pl","mail15.com","mail1999.cf","mail1999.ga","mail1999.gq","mail1999.ml","mail1999.tk","mail1a.de","mail2.cf","mail2.drama.tw","mail2.info.tm","mail2.ntuz.me","mail2.space","mail2.vot.pl","mail2.waw.pl","mail2.worksmobile.ml","mail2000.cf","mail2000.ga","mail2000.gq","mail2000.ml","mail2000.ru","mail2000.tk","mail2001.cf","mail2001.ga","mail2001.gq","mail2001.ml","mail2001.tk","mail21.cc","mail22.club","mail22.space","mail24.club","mail24.gdn","mail24h.top","mail2k.bid","mail2k.trade","mail2k.win","mail2nowhere.cf","mail2nowhere.ga","mail2nowhere.gq","mail2nowhere.ml","mail2nowhere.tk","mail2rss.org","mail2tor.com","mail2world.com","mail3.activelyblogging.com","mail3.drama.tw","mail333.com","mail3s.pl","mail4-us.org","mail4.com","mail4.drama.tw","mail4.online","mail48.top","mail4all.jp.pn","mail4biz.pl","mail4biz.sejny.pl","mail4free.waw.pl","mail4gmail.com","mail4trash.com","mail4used.com","mail4you.bid","mail4you.men","mail4you.racing","mail4you.stream","mail4you.trade","mail4you.usa.cc","mail4you.win","mail4you24.net","mail5.drama.tw","mail52.cf","mail52.ga","mail52.gq","mail52.ml","mail52.tk","mail56.me","mail666.ru","mail7.cf","mail7.ga","mail7.gq","mail7.vot.pl","mail707.com","mail72.com","mail77.top","mail777.cf","mail8.ga","mail8.gq","mail8.vot.pl","mail998.com","mailabconline.com","mailaccount.de.pn","mailadadad.org","mailadda.cf","mailadda.ga","mailadda.gq","mailadda.ml","mailadresim.site","mailairport.com","mailapi.ru","mailapps.online","mailapso.com","mailasdkr.com","mailasdkr.net","mailb.tk","mailback.com","mailbehance.info","mailbidon.com","mailbiz.biz","mailblocks.com","mailblog.biz","mailbonus.fr","mailbookstore.com","mailbosi.com","mailbox.blognet.in","mailbox.com.cn","mailbox.comx.cf","mailbox.r2.dns-cloud.net","mailbox1.gdn","mailbox2go.de","mailbox52.ga","mailbox72.biz","mailbox80.biz","mailbox82.biz","mailbox87.de","mailbox92.biz","mailboxheaven.info","mailboxint.info","mailboxlife.net","mailboxonline.org","mailboxok.club","mailboxrental.org","mailboxxx.net","mailboxy.fun","mailbrazilnet.space","mailbros1.info","mailbros2.info","mailbros3.info","mailbros4.info","mailbros5.info","mailbucket.org","mailbusstop.com","mailbyemail.com","mailbyus.com","mailc.cf","mailc.gq","mailc.tk","mailcat.biz","mailcatch.com","mailcatch.xyz","mailcc.cf","mailcc.ga","mailcc.gq","mailcc.ml","mailcc.tk","mailcdn.ml","mailchop.com","mailcker.com","mailclubs.info","mailcom.cf","mailcom.ga","mailcom.gq","mailcom.ml","mailconect.info","mailconn.com","mailcool45.us","mailcx.cf","mailcx.ga","mailcx.gq","mailcx.ml","mailcx.tk","mailde.de","mailde.info","maildeluxehost.com","maildemon.bid","maildfga.com","maildgsp.com","maildomain.com","maildonna.space","maildot.xyz","maildrop.cc","maildrop.cf","maildrop.ga","maildrop.gq","maildrop.ml","maildu.de","maildump.tk","maildx.com","maile.com","maile2email.com","maileater.com","mailed.in","mailed.ro","maileder.com","maileere.com","maileimer.de","mailelectronic.com","mailelix.space","maileme101.com","mailer.net","mailer.onmypc.info","mailer2.cf","mailer2.ga","mailerforus.com","mailermails.info","mailerowavc.com","mailerraas.com","mailerrtts.com","mailert.ru","maileto.com","mailex.pw","mailexpire.com","mailf5.com","mailfa.cf","mailfa.tk","mailfall.com","mailfasfe.com","mailfavorite.com","mailfirst.icu","mailfish.de","mailfnmng.org","mailfob.com","mailforall.pl","mailformail.com","mailforspam.com","mailforthemeak.info","mailfree.ga","mailfree.gq","mailfree.ml","mailfreehosters.com","mailfreeonline.com","mailfs.com","mailgc.com","mailgen.biz","mailglobalnet.space","mailgoogle.com","mailgov.info","mailguard.me","mailgui.pw","mailgutter.com","mailhaven.com","mailhazard.com","mailhazard.us","mailhero.io","mailhex.com","mailhost.top","mailhound.com","mailhub.online","mailhub.pw","mailhub.top","mailhub24.com","mailhulk.info","mailhz.me","mailicon.info","mailimails.patzleiner.net","mailimate.com","mailin8r.com","mailinatar.com","mailinater.com","mailinator.cf","mailinator.co","mailinator.co.uk","mailinator.com","mailinator.ga","mailinator.gq","mailinator.info","mailinator.net","mailinator.org","mailinator.pl","mailinator.us","mailinator.usa.cc","mailinator0.com","mailinator1.com","mailinator2.com","mailinator2.net","mailinator3.com","mailinator4.com","mailinator5.com","mailinator6.com","mailinator7.com","mailinator8.com","mailinator9.com","mailinatorzz.mooo.com","mailinbox.cf","mailinbox.co","mailinbox.ga","mailinbox.gq","mailinbox.ml","mailincubator.com","mailindexer.com","mailinfo8.pro","mailing.one","mailing.serveblog.net","mailismagic.com","mailita.tk","mailj.tk","mailjonny.org","mailjunk.cf","mailjunk.ga","mailjunk.gq","mailjunk.ml","mailjunk.tk","mailjuose.ga","mailkor.xyz","mailksders.com","mailkuatjku2.ga","mailkutusu.site","mailline.net","mailling.ru","maillink.info","maillink.live","maillink.top","maillist.in","mailllc.download","mailllc.top","mailloading.com","maillotdefoot.com","mailly.xyz","mailman.com","mailmassa.info","mailmate.com","mailme.gq","mailme.ir","mailme.judis.me","mailme.lv","mailme24.com","mailmeanyti.me","mailmedo.com","mailmefast.info","mailmeking.com","mailmerk.info","mailmetrash.com","mailmetrash.comilzilla.org","mailmix.pl","mailmoat.com","mailmonster.bid","mailmonster.download","mailmonster.stream","mailmonster.top","mailmonster.trade","mailmoth.com","mailms.com","mailmuffta.info","mailmy.co.cc","mailn.pl","mailn.tk","mailna.biz","mailna.co","mailna.in","mailna.me","mailna.us","mailnator.com","mailnesia.com","mailnetter.co.uk","mailnow2.com","mailnowapp.com","mailnull.com","mailo.cf","mailo.tk","mailonaut.com","mailondandan.com","mailone.es.vu","mailontherail.net","mailonxh.pl","mailor.com","mailorc.com","mailorg.org","mailowanovaroc.com","mailowowo.com","mailox.biz","mailox.fun","mailpay.co.uk","mailphar.com","mailpick.biz","mailplus.pl","mailpm.live","mailpooch.com","mailpost.comx.cf","mailpost.gq","mailpremium.net","mailpress.gq","mailpro5.club","mailprohub.com","mailprotech.com","mailproxsy.com","mailproxy.gm9.com","mailpts.com","mailpuppet.tk","mailquack.com","mailraccoon.com","mailrard01.ga","mailrazer.com","mailrc.biz","mailref.net","mailrerrs.com","mailretor.com","mailretrer.com","mailrock.biz","mailrrpost.com","mails-4-mails.bid","mails.com","mails4mails.bid","mailsac.cf","mailsac.com","mailsac.ga","mailsac.gq","mailsac.ml","mailsac.tk","mailsadf.com","mailsadf.net","mailsall.com","mailscdn.com","mailschain.com","mailscheap.us","mailscrap.com","mailsdfd.com","mailsdfd.net","mailsdfeer.com","mailsdfeer.net","mailsdfsdf.com","mailsdfsdf.net","mailseal.de","mailsearch.net","mailseo.net","mailserv95.com","mailserver.bid","mailserver.men","mailserver2.cf","mailserver2.ga","mailserver2.ml","mailserver2.tk","mailshell.com","mailshiv.com","mailsinabox.bid","mailsinabox.info","mailsinthebox.co","mailsiphon.com","mailsister1.info","mailsister2.info","mailsister3.info","mailsister4.info","mailsister5.info","mailslapping.com","mailslite.com","mailsmart.info","mailsnails.com","mailsor.com","mailsource.info","mailspam.me","mailspam.xyz","mailspeed.ru","mailspirit.info","mailspru.cz.cc","mailsrv.ru","mailssents.com","mailsuckbro.cf","mailsuckbro.ga","mailsuckbro.gq","mailsuckbro.ml","mailsuckbro.tk","mailsuckbrother.cf","mailsuckbrother.ga","mailsuckbrother.gq","mailsuckbrother.ml","mailsuckbrother.tk","mailsucker.net","mailsucker1.cf","mailsucker1.ga","mailsucker1.gq","mailsucker1.ml","mailsucker1.tk","mailsucker11.cf","mailsucker11.ga","mailsucker11.gq","mailsucker11.ml","mailsucker11.tk","mailsucker14.cf","mailsucker14.ga","mailsucker14.gq","mailsucker14.ml","mailsucker14.tk","mailsucker2.cf","mailsucker2.ga","mailsucker2.gq","mailsucker2.ml","mailsucker2.tk","mailsucker34.cf","mailsucker34.ga","mailsucker34.gq","mailsucker34.ml","mailsucker34.tk","mailsup.net","mailtanpakaudisini.com","mailtechx.com","mailtemp.info","mailtemp.net","mailtemp.org","mailtempmha.tk","mailtemporaire.com","mailtemporaire.fr","mailthunder.ml","mailtimail.co.tv","mailtime.com","mailtmk.com","mailtod.com","mailtome.de","mailtomeinfo.info","mailtop.ga","mailtothis.com","mailtoyou.top","mailtraps.com","mailtrash.net","mailtrix.net","mailtv.net","mailtv.tv","mailu.cf","mailu.gq","mailu.ml","mailur.com","mailusivip.xyz","mailw.cf","mailw.ga","mailw.gq","mailw.info","mailw.ml","mailw.tk","mailwebsite.info","mailwithyou.com","mailwriting.com","mailxtr.eu","mailyes.co.cc","mailymail.co.cc","mailyouspacce.net","mailz.info","mailz.info.tm","mailzen.win","mailzi.ru","mailzilla.com","mailzilla.org","mailzilla.orgmbx.cc","mailzxc.pl","maimobis.com","main-tube.com","mainerfolg.info","mainlandortho.com","mainphp.cf","mainphp.ga","mainphp.gq","mainphp.ml","maisondesjeux.com","maiu.tk","majnmail.pl","major-jobs.com","major.clarized.com","majorleaguemail.com","makasarpost.cf","make-bootable-disks.com","makebootabledisk.com","makedon-nedv.ru","makemenaughty.club","makemetheking.com","makemoney.com","makemoneyscams.org","makemydisk.com","makepleasure.club","makerains.tk","makeshopping.pp.ua","makinadigital.com","makingfreebasecocaine.in","makmadness.info","maks.com","makumba.justdied.com","malahov.de","malaizy-nedv.ru","malakies.tk","malapo.ovh","malarz-mieszkaniowy.pl","malarz-remonciarz.pl","malarz-remonty-warszawa.pl","malarz-remonty.pl","malarzmieszkaniowy.pl","malayalamdtp.com","malboxe.com","malcolmdriling.com","maldimix.com","maldonadomail.men","male-pillsrx.info","malecigarettestore.net","maleenhancement.club","maleenhancement24.net","malegirl.com","mali-nedv.ru","malibubright.org","malibucoding.com","mall.tko.co.kr","mallinator.com","mallinco.com","malove.site","malpracticeboard.com","malta-nedv.ru","mama.com","mamail.cf","mamail.com","mamamintaemail.com","mamba.ru","mambaru.in","mamber.net","mami000.com","mami999.net","mamulenok.ru","manabisagan.com","manage-11.com","managelaw.ru","manantial20.mx","manantialwatermx2.com.mx","manatialagua.com.mx","manatialxm.com.mx","manderich.com","mandraghen.cf","mandynmore.com","mangtinnhanh.com","manifestgenerator.com","manipurbjp.org","maniskata.online","mankyrecords.com","mannbdinfo.org","mannerladies.com","mansilverinsdier.com","mansiondev.com","mantap.com","mantestosterone.com","manuka.com","manybrain.com","manyme.com","mao.igg.biz","maokeba.com","maomaocheng.com","mapa-polskii.pl","mapleemail.com","mapolace.xyz","mapycyfrowe-bydgoszcz.pl","mara.jessica.webmailious.top","marathonkit.com","marbau-hydro.pl","marbleorbmail.bid","marcbymarcjacobsjapan.com","marciszewski.pl","marcjacobshandbags.info","marcpfitzer.com","mareczkowy.pl","maret-genkzmail.ga","marezindex.com","margarette1818.site","margolotta4.pl","margolotta5.pl","margolotta6.pl","marib5ethmay.ga","mariela1121.club","marijuana-delight.com","marijuana-delight.info","marijuana-delight.net","marimastu98huye.cf","marimastu98huye.gq","marinad.org","marinajohn.org","marinarlism.com","marizing.com","mark-compressoren.ru","mark-sanchez2011.info","mark234.info","marketconow.com","markethealthreviews.info","marketingagency.net","marketingsolutions.info","marketlink.info","markhutchins.info","markinternet.co.uk","markmurfin.com","marlboro-ez-cigarettes.com","marloni.com.pl","maroonsea.com","marriedchat.co.uk","marrocomail.gdn","marryznakomstv.ru","marthaloans.co.uk","martin.securehost.com.es","martyvole.ml","marukushino.co.jp","maryjanehq.com","maryjanehq.info","maryjanehq.net","masafiagrofood.com","masafigroupbd.com","masaindah.online","masasih.loan","masdo88.top","mashkrush.info","mashy.com","mask03.ru","maskedmails.com","maskmail.net","maslicov.biz","masok.lflinkup.com","masonline.info","masrku.online","massagetissue.com","masseymail.men","massmedios.ru","massrewardgiveaway.gq","mastahype.net","master-mail.net","mastercard-3d.cf","mastermail24.gq","masterofwarcraft.net","maswae.world","maszynkiwaw.pl","maszyny-rolnicze.net.pl","matamuasu.cf","matamuasu.ga","matamuasu.gq","matamuasu.ml","matchpol.net","matchsticktown.com","materiali.ml","matka.host-001.eu","matra.site","matra.top","matriv.hu","mattersjf8.com","mattmason.xyz","mattress-mattress-usa.com","mattwoodrealty.com","matydezynfekcyjne.com.pl","matzxcv.org","mauriss.xyz","mavriki-nedv.ru","mawpinkow.konin.pl","max-adv.pl","max-direct.com","max-mail.com","max-mail.info","max-mirnyi.com","max88.club","maxbetspinz.co","maxcasi.xyz","maxflo.com","maximalbonus.de","maximum10review.com","maxivern.com","maxmail.in","maxmail.info","maxpedia.ro","maxprice.co","maxrollspins.co","maxxdrv.ru","mayaaaa.cf","mayaaaa.ga","mayaaaa.gq","mayaaaa.ml","mayaaaa.tk","maybe.eu","maymetalfest.info","maysunsaluki.com","maytree.ru","mb69.cf","mb69.ga","mb69.gq","mb69.ml","mb69.tk","mb7y5hkrof.cf","mb7y5hkrof.ga","mb7y5hkrof.gq","mb7y5hkrof.ml","mb7y5hkrof.tk","mbangilan.ga","mbap.ml","mbdnsmail.mooo.com","mbe.kr","mbfc6ynhc0a.cf","mbfc6ynhc0a.ga","mbfc6ynhc0a.gq","mbfc6ynhc0a.ml","mbfc6ynhc0a.tk","mblsglobal.com","mboled.ml","mbox.0x01.tk","mbox.re","mbt-shoeshq.com","mbt01.cf","mbt01.ga","mbt01.gq","mbt01.ml","mbtjpjp.com","mbtsalesnow.com","mbtshoeclearancesale.com","mbtshoes-buy.com","mbtshoes-z.com","mbtshoes32.com","mbtshoesbetter.com","mbtshoesclear.com","mbtshoesclearancehq.com","mbtshoesdepot.co.uk","mbtshoesfinder.com","mbtshoeslive.com","mbtshoesmallhq.com","mbtshoeson-deal.com","mbtshoesondeal.co.uk","mbtshoesonline-clearance.net","mbtshoespod.com","mbtshoessellbest.com","mbtshoeswarehouse.com","mbutm4xjem.ga","mbx.cc","mc-freedom.net","mc-ij2frasww-ettg.com","mc-s789-nuyyug.com","mc8xbx5m65trpt3gs.ga","mc8xbx5m65trpt3gs.ml","mc8xbx5m65trpt3gs.tk","mcache.net","mcb64dfwtw.cf","mcb64dfwtw.ga","mcb64dfwtw.gq","mcb64dfwtw.ml","mcb64dfwtw.tk","mcbslqxtf.pl","mccee.org","mccluremail.bid","mcde.com","mcde1.com","mcdonald.cf","mcdonald.gq","mcdoudounefemmefr.com","mcelderry.eu","mcelderryrodiquez.eu","mciek.com","mcjassenonlinenl.com","mcjazz.pl","mckaymail.bid","mckinleymail.net","mcmbulgaria.info","mcmmobile.co.uk","mcytaooo0099-0.com","mcyvkf6y7.pl","md5hashing.net","md7eh7bao.pl","mddwgs.mil.pl","mdhc.tk","mdt.creo.site","mdu.edu.rs","me-angel.net","me2.cuteboyo.com","meachlekorskicks.com","mealcash.com","meangel.net","meantinc.com","mebel-atlas.com","mebelnu.info","meble-biurowe.com","meble-biurowe.eu","mebleikea.com.pl","meblevps24x.com","mecbuc.cf","mecbuc.ga","mecbuc.gq","mecbuc.ml","mecbuc.tk","mechanicalresumes.com","mechpromo.com","meconomic.ru","mediapulsetech.com","mediastyaa.tk","mediawebhost.de","medicalschooly.com","medicationforyou.info","medications-shop.com","mediciine.site","medicinepea.com","medicineworldportal.net","mediosbase.com","medkabinet-uzi.ru","medod6m.pl","medsheet.com","medyczne-odchudzanie.com","meepsheep.eu","meesterlijkmoederschap.nl","meethornygirls.top","meetlocalhorny.top","mega-buy.vn","mega-dating-directory.com","mega.zik.dj","megahost.l6.org","megaklassniki.net","megalearn.ru","megalovers.ru","megamail.pl","megamailhost.com","meganscott.xyz","megape.in","megapuppies.com","megastar.com","megatraffictoyourwebsite.info","megatraherhd.ru","megavigor.info","megogonett.ru","meibaishu.com","meihuajun76.com","meil4me.pl","meiler.co.pl","meimeimail.cf","meimeimail.gq","meimeimail.ml","meimeimail.tk","meinspamschutz.de","meintick.com","mejjang.xyz","mejlnastopro.pl","mejlowy1.pl","mejlowy2.pl","mejlowy3.pl","mejlowy4.pl","mejlowy5.pl","mejlowy6.pl","mejlowy7.pl","mejlowy8.pl","meksika-nedv.ru","melatoninsideeffects.org","melcow.com","melhor.ws","melifestyle.ru","melodysouvenir.com","meloman.in","meltedbrownies.com","meltmail.com","melzmail.co.uk","memailme.co.uk","memberheality.ga","memecituenakganasli.cf","memecituenakganasli.ga","memecituenakganasli.gq","memecituenakganasli.ml","memecituenakganasli.tk","memeil.top","memem.uni.me","memeware.net","memkottawaprofilebacks.com","memorygalore.com","memp.net","memsg.site","mendoan.uu.gl","mendoanmail.club","menherbalenhancement.com","menidsx.com","menkououtlet-france.com","menopozbelirtileri.com","mensdivorcelaw.com","menshoeswholesalestores.info","meooovspjv.pl","mepf1zygtuxz7t4.cf","mepf1zygtuxz7t4.ga","mepf1zygtuxz7t4.gq","mepf1zygtuxz7t4.ml","mepf1zygtuxz7t4.tk","mephilosophy.ru","mephistore.co","mepost.pw","meprice.co","merantikk.cf","merantikk.ga","merantikk.gq","merantikk.ml","merantikk.tk","mercedes.co.id","mercurials2013.com","mercurialshoesus.com","mercygirl.com","merda.cf","merda.ga","merda.gq","merda.ml","merfwotoer.com","merfwotoertest.com","mergame.info","meriam.edu","meridensoccerclub.com","meridiaonlinesale.net","merkez34.com","merlemckinnellmail.com","mermail.info","merrellshoesale.com","merrittnils.ga","merry.pink","merrydresses.com","merrydresses.net","merryflower.net","merrygoround.com","mesotheliomasrates.ml","mesrt.online","messaeg.gq","messagea.gq","messagebeamer.de","messageden.net","messageme.ga","messageovations.com","messageproof.gq","messageproof.ml","messager.cf","messagesafe.co","messagesenff.com","messwiththebestdielikethe.rest","met-sex.com","met5fercj18.cf","met5fercj18.ga","met5fercj18.gq","met5fercj18.ml","met5fercj18.tk","metaboliccookingpdf.com","metalrika.club","metaprice.co","metin1.pl","metrika-hd.ru","metroset.net","mettamarketingsolutions.com","metuwar.tk","mexicanonlinepharmacyhq.com","mexicolindo.com.mx","mexicomail.com","mezimages.net","mfbh.cf","mfghrtdf5bgfhj7hh.tk","mfil4v88vc1e.cf","mfil4v88vc1e.ga","mfil4v88vc1e.gq","mfil4v88vc1e.ml","mfil4v88vc1e.tk","mfsa.info","mfsa.ru","mg-rover.cf","mg-rover.ga","mg-rover.gq","mg-rover.ml","mg-rover.tk","mgabratzboys.info","mgmblog.com","mh3fypksyifllpfdo.cf","mh3fypksyifllpfdo.ga","mh3fypksyifllpfdo.gq","mh3fypksyifllpfdo.ml","mh3fypksyifllpfdo.tk","mhdpower.me","mhdsl.cf","mhdsl.ddns.net","mhdsl.dynamic-dns.net","mhdsl.ga","mhdsl.gq","mhdsl.ml","mhdsl.tk","mhere.info","mhmmmkumen.cf","mhmmmkumen.ga","mhmmmkumen.gq","mhmmmkumen.ml","mhorhet.ru","mhschool.info","mhwolf.net","mi-fucker-ss.ru","mi-mails.com","mi.meon.be","mi.orgz.in","mia6ben90uriobp.cf","mia6ben90uriobp.ga","mia6ben90uriobp.gq","mia6ben90uriobp.ml","mia6ben90uriobp.tk","miaferrari.com","mial.cf","mial.tk","mialbox.info","miam.kd2.org","miamovies.com","miamovies.net","miauj.com","mic3eggekteqil8.cf","mic3eggekteqil8.ga","mic3eggekteqil8.gq","mic3eggekteqil8.ml","mic3eggekteqil8.tk","michaelkors4ssalestore.com","michaelkorsborsa.it","michaelkorshandbags-uk.info","michaelkorss.com","michaelkorstote.org","michelinpilotsupersport.com","michigan-nedv.ru","michigan-rv-sales.com","michigan-web-design.com","micicubereptvoi.com","mickey-discount.info","micksbignightout.info","microcenter.io","microfibers.info","microsoftt.biz","micsocks.net","mid6mwm.pc.pl","midascmail.com","midcoastcustoms.com","midcoastcustoms.net","midcoastmowerandsaw.com","midcoastsolutions.com","midcoastsolutions.net","midlertidig.com","midlertidig.net","midlertidig.org","miegrg.ga","miegrg.ml","mierdamail.com","miesedap.pw","migmail.net","migmail.pl","migranthealthworkers.org.uk","migro.co.uk","migserver2.gq","migserver2.ml","migumail.com","mihanmail.ir","mihep.com","miim.org","mijnhva.nl","mikaela.kaylin.webmailious.top","mike.designterrarium.de","mikeblogmanager.info","mikeformat.org","milandwi.cf","milavitsaromania.ro","milbox.info","mildin.org.ua","milfaces.com","miliancis.net","milionkart.pl","milk.gage.ga","millionairesocietyfree.com","millionairesweetheart.com","millionstars1.com","miltonfava.com","mimail.info","mimicooo.com","mimomail.info","mimpaharpur.cf","mimpaharpur.ga","mimpaharpur.gq","mimpaharpur.ml","mimpaharpur.tk","min.edu.gov","minamail.info","minamitoyama.info","mindless.com","mindmail.ga","mindpowerup.com","mindsetup.us","mindthe.biz","mindyrose.online","mine-epic.ru","minecraft-survival-servers.com","minecraftrabbithole.com","minegiftcode.pl","mineralnie.com.pl","mineralshealth.com","minex-coin.com","minhazfb.cf","minhazfb.ga","minhazfb.ml","minhazfb.tk","mini-mail.net","mini.pixymix.com","minifieur.com","minikuchen.info","miniotls.gr","minipaydayloansuk.co.uk","minishop.site","miniskirtswholesalestores.info","ministry-of-silly-walks.de","miniwowo.com","minnesotavikings-jerseys.us","minskysoft.ru","minsmail.com","mint-space.info","mintadomaindong.cf","mintadomaindong.ga","mintadomaindong.gq","mintadomaindong.ml","mintadomaindong.tk","mintconditionin.ga","mintemail.cf","mintemail.com","mintemail.ga","mintemail.gq","mintemail.ml","mintemail.tk","minyoracle.ru","miodonski.ch","miodymanuka.com","mionavi2012.info","miopaaswod.jino.ru","mior.in","mipodon.ga","miraclegarciniareview.com","miraigames.net","miranda1121.club","mirbeauty.ru","mirenaclaimevaluation.com","mirmirchi.site","mirrorrr.asia","mirrror.asia","mirstyle.ru","miscritscheats.info","missi.fun","mississaugaseo.com","misslawyers.com","missright.co.uk","missthegame.com","misteacher.com","misterpinball.de","mistressnatasha.net","mite.tk","mithiten.com","mitsubishi-asx.cf","mitsubishi-asx.ga","mitsubishi-asx.gq","mitsubishi-asx.ml","mitsubishi-asx.tk","mitsubishi-pajero.cf","mitsubishi-pajero.ga","mitsubishi-pajero.gq","mitsubishi-pajero.ml","mitsubishi-pajero.tk","mitsubishi2.cf","mitsubishi2.ga","mitsubishi2.gq","mitsubishi2.ml","mitsubishi2.tk","mituvn.com","miucline.com","miumiubagjp.com","miumiubagsjp.com","miumiuhandbagsjp.com","miumiushopjp.com","miur.cf","miur.ga","miur.gq","miur.ml","miur.tk","mix-good.com","mixbox.pl","mixchains.win","mixcoupons.com","mixflosay.org.ua","mixi.gq","mizapol.net","mizugiq2efhd.cf","mizugiq2efhd.ga","mizugiq2efhd.gq","mizugiq2efhd.ml","mizugiq2efhd.tk","mjfitness.com","mji.ro","mjjqgbfgzqup.info","mjolkdailies.com","mjuifg5878xcbvg.ga","mjukglass.nu","mjut.ml","mjxfghdfe54bnf.cf","mk24.at","mk2u.eu","mkathleen.com","mkbw3iv5vqreks2r.ga","mkbw3iv5vqreks2r.ml","mkbw3iv5vqreks2r.tk","mkdshhdtry546bn.ga","mkfactoryshops.com","mkk83.top","mkk84.top","mkljyurffdg987.cf","mkljyurffdg987.ga","mkljyurffdg987.gq","mkljyurffdg987.ml","mkljyurffdg987.tk","mkmove.tk","mko.kr","mkpfilm.com","mkshake.tk","ml8.ca","mldl3rt.pl","mlj101.com","mlkancelaria.com.pl","mlleczkaweb.pl","mlmtips.org","mlo.kr","mlodyziemniak.katowice.pl","mlogicali.com","mlq6wylqe3.cf","mlq6wylqe3.ga","mlq6wylqe3.gq","mlq6wylqe3.ml","mlq6wylqe3.tk","mlsix.ovh","mlsix.xyz","mlsmodels.com","mlx.ooo","mm.my","mm5.se","mmach.ru","mmail.com","mmail.igg.biz","mmail.men","mmail.org","mmail.trade","mmailinater.com","mmcdoutpwg.pl","mmclobau.top","mmlaaxhsczxizscj.cf","mmlaaxhsczxizscj.ga","mmlaaxhsczxizscj.gq","mmlaaxhsczxizscj.tk","mmm-invest.biz","mmm.2eat.com","mmmail.pl","mmmmail.com","mmo365.co.uk","mmobackyard.com","mmoexchange.org","mmogames.in","mmomismqs.biz","mmoonz.faith","mmsilrlo.com","mn.curppa.com","mn.j0s.eu","mn.riaki.com","mnage-ctrl-aplex.com","mnbvcxz10.info","mnbvcxz2.info","mnbvcxz5.info","mnbvcxz6.info","mnbvcxz8.info","mng2gq.pl","mnode.me","mntwincitieshomeloans.com","moakt.co","moakt.com","moakt.ws","moanalyst.com","moathrababah.com","mobanswer.ru","mobaratopcinq.life","mobelej3nm4.ga","mobi.web.id","mobilebuysellgold.com","mobileninja.co.uk","mobilephonecarholder.net","mobilephonelocationtracking.info","mobilephonespysoftware.info","mobilephonetrackingsoftware.info","mobileshopdeals.info","mobilespyphone.info","mobilevpn.top","mobilhondasidoarjo.com","mobilnaja-versiya.ru","moboinfo.xyz","mobotap.net","moburl.com","mocanh.info","mocg.co.cc","mochkamieniarz.pl","mockmyid.co","mockmyid.com","mocnyy-katalog-wp.pl","modaborsechane2.com","modaborseguccioutletonline.com","modaborseprezzi.com","modachane1borsee.com","modapeuterey2012.com","modapeutereyuomo.com","moddema.ga","modejudnct4432x.cf","modeperfect3.fr","moderatex.com","moderatex.net","modernbiznes.pl","modernfs.pl","modernsailorclothes.com","modernsocialuse.co.uk","moderntransfers.info","moebelhersteller.top","moeri.org","mofu.be","mogcheats.com","mogensenonline.com","mohmal.com","mohmal.im","mohmal.in","mohmal.tech","mohsenfb.com","moijkh.com.uk","mojastr.pl","mojblogg.com","mojewiki.com","mojezarobki.com.pl","mojiphone.pl","moldova-nedv.ru","molecadamail.pw","molms.com","molot.01898.com","molten-wow.com","momalls.com","momentics.ru","mommsssrl.com","momo365.net","momonono.info","momswithfm.com","mon-entrepreneur.com","monachat.tk","monaco-nedv.ru","monadi.ml","monawerka.pl","moncker.com","monclerboutiquesenligne.com","monclercoupon.org","monclerdeinfo.info","monclerderedi.info","monclerdoudounemagasinfra.com","monclerdoudouneparis.com","monclerdoudounepascherfrance1.com","monclerfrredi.info","monclermagasinfrances.com","moncleroutwearstore.com","monclerpascherboutiquefr.com","monclerpascherrsodles.com","monclerppascherenlignefra.com","monclerredi.info","monclersakstop.com","monclersoldespascherfra.com","monclersonlinesale.com","moncourrier.fr.nf","monctonlife.com","mone15.ru","monemail.fr.nf","money-drives.com","money-trade.info","money-vopros.ru","moneyandcents.com","moneyboxtvc.com","moneyhome.com","moneypipe.net","monica.org","monipozeo8igox.cf","monipozeo8igox.ga","monipozeo8igox.gq","monipozeo8igox.ml","monipozeo8igox.tk","monir.eu","monisee.com","monkeemail.info","monkey4u.org","monmail.fr.nf","monorailnigeria.com","monporn.net","monsterabeatsbydre.com","monsterbeatsbydre-x.com","monta-ellis.info","monta-ellis2011.info","montana-nedv.ru","montanaweddingdjs.com","montefino.cf","montepaschi.cf","montepaschi.ga","montepaschi.gq","montepaschi.ml","montepaschi.tk","monterra.tk","monthlyseopackage.com","montokop.pw","montre-geek.fr","monumentmail.com","monvoyantperso.com","mooblan.ml","mooecofficail.club","moolooku.com","moonm.review","moonwake.com","moose-mail.com","moot.es","moozique.musicbooksreviews.com","moparayes.site","mopyrkv.pl","mor19.uu.gl","morahdsl.cf","moreawesomethanyou.com","morecoolstuff.net","morefunmart.com","moregrafftsfrou.com","moreorcs.com","moretrend.xyz","morielasd.ovh","mornhfas.org.ua","morriesworld.ml","morsin.com","morteinateb.xyz","mortgagecalculatorwithtaxess.com","mortgagemotors.com","mortmesttesre.wikaba.com","mortystore.cf","moruzza.com","moscow-nedv.ru","moscowmail.ru","mosertelor.ga","mosheperetz.bet","mosheperetz.net","mosspointhotelsdirect.com","most-wanted-stuff.com","mostofit.com","mot1zb3cxdul.cf","mot1zb3cxdul.ga","mot1zb3cxdul.gq","mot1zb3cxdul.ml","mot1zb3cxdul.tk","motique.de","motivationalsites.com","moto-gosz.pl","moto4you.pl","motorcycleserivce.info","motorisation.ga","mottel.fr","mottenarten.ga","mouadim.tk","moukrest.ru","moulybrien.cf","moulybrien.tk","mountainregionallibrary.net","mountainviewbandb.net","mountainviewwiki.info","mountathoss.gr","moustache-media.com","mouthube0t.com","movanfj.ml","movedto.info","movie-ru-film.ru","movie-ru-girls.ru","movieblocking.com","movies4youfree.com","movies69.xyz","moviesclab.net","moviesdirectoryplus.com","moviesonlinehere.com","moviflix.tk","mowgli.jungleheart.com","mowoo.net","mowspace.co.za","mox.pp.ua","moxinbox.info","moy-elektrik.ru","moydom12.tk","moyy.net","moza.pl","mozej.com","mozillafirefox.cf","mozillafirefox.ga","mozillafirefox.gq","mozillafirefox.ml","mozillafirefox.tk","mozmail.com","mozmail.info","mp-j.cf","mp-j.ga","mp-j.gq","mp-j.igg.biz","mp-j.ml","mp-j.tk","mp.igg.biz","mp3-world.us","mp3geulis.net","mp3granie.pl","mp3hungama.xyz","mp3nt.net","mp3sa.my.to","mp3skull.com","mp4-base.ru","mpaaf.cf","mpaaf.ga","mpaaf.gq","mpaaf.ml","mpaaf.tk","mpbtodayofficialsite.com","mpdacrylics.com","mpictureb.com","mpjgqu8owv2.pl","mpm-motors.cf","mpmps160.tk","mptncvtx0zd.cf","mptncvtx0zd.ga","mptncvtx0zd.gq","mptncvtx0zd.ml","mptncvtx0zd.tk","mptrance.com","mpvnvwvflt.cf","mpvnvwvflt.ga","mpvnvwvflt.gq","mpvnvwvflt.ml","mpvnvwvflt.tk","mpystsgituckx4g.cf","mpystsgituckx4g.gq","mq.orgz.in","mqg77378.cf","mqg77378.ga","mqg77378.ml","mqg77378.tk","mqhtukftvzcvhl2ri.cf","mqhtukftvzcvhl2ri.ga","mqhtukftvzcvhl2ri.gq","mqhtukftvzcvhl2ri.ml","mqhtukftvzcvhl2ri.tk","mqkivwkhyfz9v4.cf","mqkivwkhyfz9v4.ga","mqkivwkhyfz9v4.gq","mqkivwkhyfz9v4.ml","mqkivwkhyfz9v4.tk","mr-manandvanlondon.co.uk","mr24.co","mr907tazaxe436h.cf","mr907tazaxe436h.ga","mr907tazaxe436h.gq","mr907tazaxe436h.tk","mrblacklist.gq","mrchinh.com","mrecphoogh.pl","mrepair.com","mrflibble.icu","mrichacrown39dust.tk","mrjgyxffpa.pl","mrmail.info","mrmail.mrbasic.com","mrmal.ru","mrmanie.com","mroneeye.com","mrossi.cf","mrossi.ga","mrossi.gq","mrossi.ml","mrresourcepacks.tk","mrrob.net","mrsands.org","mrsikitjoefxsqo8qi.cf","mrsikitjoefxsqo8qi.ga","mrsikitjoefxsqo8qi.gq","mrsikitjoefxsqo8qi.ml","mrsikitjoefxsqo8qi.tk","ms365.ml","ms9.mailslite.com","msa.minsmail.com","msb.minsmail.com","mscbestforever.com","mscdex.com.au.pn","msendback.com","mseo.ehost.pl","msft.cloudns.asia","msgden.com","msgos.com","msgsafe.ninja","msgwire.com","msiofke.com","msiwkzihkqifdsp3mzz.cf","msiwkzihkqifdsp3mzz.ga","msiwkzihkqifdsp3mzz.gq","msiwkzihkqifdsp3mzz.ml","msiwkzihkqifdsp3mzz.tk","msk-intim-dosug.ru","msk.ru","mskey.co","msm.com","msmail.bid","msmail.trade","msmail.win","msn.edu","msnai.com","msnblogs.info","msnt007.com","msoft.com","mson.com","mspeciosa.com","msrc.ml","mssfpboly.pl","mssn.com","mstyfdrydz57h6.cf","msu69gm2qwk.pl","msvvscs6lkkrlftt.cf","msvvscs6lkkrlftt.ga","msvvscs6lkkrlftt.gq","mswebapp.com","mswork.ru","msxd.com","mt2009.com","mt2014.com","mt2015.com","mt2016.com","mt2017.com","mt66ippw8f3tc.gq","mtgmogwysw.pl","mtjoy.org","mtmdev.com","mtrucqthtco.cf","mtrucqthtco.ga","mtrucqthtco.gq","mtrucqthtco.ml","mtrucqthtco.tk","mtyju.com","mu3dtzsmcvw.cf","mu3dtzsmcvw.ga","mu3dtzsmcvw.gq","mu3dtzsmcvw.ml","mu3dtzsmcvw.tk","muamuawrtcxv7.cf","muamuawrtcxv7.ga","muamuawrtcxv7.gq","muamuawrtcxv7.ml","muamuawrtcxv7.tk","muathegame.com","muchomail.com","muchovale.com","mucincanon.com","mudbox.ml","muehlacker.tk","muell.email","muellemail.com","muellmail.com","muellpost.de","muffinbasketap.com","mufux.com","mugglenet.org","mughftg5rtgfx.gq","muhabbetkusufiyatlari.com","muhamadnurdin.us","muhammadafandi.com","muhdioso8abts2yy.cf","muhdioso8abts2yy.ga","muhdioso8abts2yy.gq","muhdioso8abts2yy.ml","muhdioso8abts2yy.tk","muhoy.com","muimail.com","mulberry.de","mulberry.eu","mulberrybags-outlet.info","mulberrybagsgroup.us","mulberrybagsoutletonlineuk.com","mulberrymarts.com","mulberrysmall.co.uk","mullerd.gq","multi-car-insurance.net","multiplayerwiigames.com","multireha.pl","mundocripto.com","mundodigital.me","mundopregunta.com","mundri.tk","muni-kuni-tube.ru","muniado.waw.pl","municiamailbox.com","munoubengoshi.gq","mupload.nl","muq.orangotango.tk","muqwftsjuonmc2s.cf","muqwftsjuonmc2s.ga","muqwftsjuonmc2s.gq","muqwftsjuonmc2s.ml","muqwftsjuonmc2s.tk","murticans.com","mus-max.info","mus.email","musclebuilding.club","musclefactorxreviewfacts.com","musclemailbox.com","musclemaximizerreviews.info","musclesorenesstop.com","museboost.com","musialowski.pl","music-feels-great.com","music4buck.pl","music896.are.nom.co","musicalinstruments2012.info","musicdrom.com","musicmakes.us","musicproducersi.com","musicresearch.edu","musicsdating.info","musicsoap.com","musict.net","musicwiki.com","muskgrow.com","mustbe.ignorelist.com","mustbedestroyed.org","mustmails.cf","musttufa.site","mutant.me","mutechcs.com","muti.site","muttvomit.com","muttwalker.net","mutualmetarial.org","mutualwork.com","muuyharold.com","muyrte4dfjk.cf","muyrte4dfjk.ga","muyrte4dfjk.gq","muyrte4dfjk.ml","muyrte4dfjk.tk","mv1951.cf","mv1951.ga","mv1951.gq","mv1951.ml","mv1951.tk","mvlnjnh.pl","mvo.pl","mvoudzz34rn.cf","mvoudzz34rn.ga","mvoudzz34rn.gq","mvoudzz34rn.ml","mvoudzz34rn.tk","mvpdream.com","mvrh.com","mvrht.com","mvrht.net","mvswydnps.pl","mw.orgz.in","mwarner.org","mwdsgtsth1q24nnzaa3.cf","mwdsgtsth1q24nnzaa3.ga","mwdsgtsth1q24nnzaa3.gq","mwdsgtsth1q24nnzaa3.ml","mwdsgtsth1q24nnzaa3.tk","mwkancelaria.com.pl","mwp4wcqnqh7t.cf","mwp4wcqnqh7t.ga","mwp4wcqnqh7t.gq","mwp4wcqnqh7t.ml","mwp4wcqnqh7t.tk","mx.dysaniac.net","mx0.wwwnew.eu","mx18.mailr.eu","mx19.mailr.eu","mx8168.net","mxbin.net","mxfuel.com","mxg.mayloy.org","mxheesfgh38tlk.cf","mxheesfgh38tlk.ga","mxheesfgh38tlk.gq","mxheesfgh38tlk.ml","mxheesfgh38tlk.tk","mxp.dns-cloud.net","mxp.dnsabr.com","mxzvbzdrjz5orbw6eg.cf","mxzvbzdrjz5orbw6eg.ga","mxzvbzdrjz5orbw6eg.gq","mxzvbzdrjz5orbw6eg.ml","mxzvbzdrjz5orbw6eg.tk","my-aunt.com","my-blog.ovh","my-email.gq","my-free-tickets.com","my-google-mail.de","my-link.cf","my-points.info","my-pomsies.ru","my-server-online.gq","my-teddyy.ru","my-top-shop.com","my-webmail.cf","my-webmail.ga","my-webmail.gq","my-webmail.ml","my-webmail.tk","my.efxs.ca","my.longaid.net","my.safe-mail.gq","my.vondata.com.ar","my10minutemail.com","my301.info","my301.pl","my365.tw","my365office.pro","my3mail.cf","my3mail.ga","my3mail.gq","my3mail.ml","my3mail.tk","my6mail.com","my7km.com","myabccompany.info","myalias.pw","myallergiesstory.com","myallgaiermogensen.com","myautoinfo.ru","mybackend.com","mybada.net","mybaegsa.xyz","mybanglaspace.net","mybathtubs.co.cc","mybestmailbox.biz","mybestmailbox.com","mybiginbox.info","mybikinibellyplan.com","mybisnis.online","mybitti.de","myblogpage.com","mybuycosmetics.com","mybx.site","mycard.net.ua","mycasualclothing.com","mycasualclothing.net","mycasualtshirt.com","myccscollection.com","mycellphonespysoft.info","mychicagoheatingandairconditioning.com","mycityvillecheat.com","mycleaninbox.net","mycloudmail.tech","mycompanigonj.com","mycontentbuilder.com","mycoolemail.xyz","mycorneroftheinter.net","mycrazyemail.com","mycrazynotes.com","myde.ml","mydemo.equipment","mydesign-studio.com","mydexter.info","mydoaesad.com","mydogspotsa.com","myecho.es","myedhardyonline.com","myemail1.cf","myemail1.ga","myemail1.ml","myemailaddress.co.uk","myemailboxmail.com","myemailboxy.com","myemaill.com","myemailmail.com","myemailonline.info","myfaceb00k.cf","myfaceb00k.ga","myfaceb00k.gq","myfaceb00k.ml","myfaceb00k.tk","myfake.cf","myfake.ga","myfake.gq","myfake.ml","myfake.tk","myfakemail.cf","myfakemail.ga","myfakemail.gq","myfakemail.tk","myfavmailbox.info","myfavorite.info","myfbprofiles.info","myfoldingshoppingcart.com","myfreemail.bid","myfreemail.download","myfreemail.space","myfreeola.uk","myfreeserver.bid","myfreeserver.download","myfullstore.fun","mygeoweb.info","myggemail.com","myglockner.com","myglocknergroup.com","myglockneronline.com","mygoldenmail.co","mygoldenmail.com","mygoldenmail.online","mygourmetcoffee.net","mygrammarly.co","mygreatarticles.info","mygsalife.xyz","mygsalove.xyz","myhagiasophia.com","myhandbagsuk.com","myhealthanswers.com","myhealthbusiness.info","myhiteswebsite.website","myhitorg.ru","myhost.bid","myimail.bid","myimail.men","myinboxmail.co.uk","myindohome.services","myinterserver.ml","myjhccvdp.pl","myjordanshoes.us","myjuicycouturesoutletonline.com","myjustmail.co.cc","myk-pyk.eu","mykickassideas.com","mylaguna.ru","mylameexcuses.com","mylapak.info","mylcdscreens.com","mylenecholy.com","myletter.online","myloans.space","mylongemail.info","mylongemail2015.info","mylovelyfeed.info","mymail-in.net","mymail.hopto.org","mymail13.com","mymail90.com","mymailbest.com","mymailbox.pw","mymailbox.top","mymailboxpro.org","mymailjos.cf","mymailjos.ga","mymailjos.tk","mymailoasis.com","mymailsrv.info","mymailsystem.co.cc","mymailto.cf","mymailto.ga","mymarketinguniversity.com","mymitel.ml","mymogensen.com","mymogensenonline.com","mymonies.info","mymulberrybags.com","mymulberrybags.us","mymy.cf","mymymymail.com","mymymymail.net","myn4s.ddns.net","myneocards.cz","mynetsolutions.bid","mynetsolutions.men","mynetstore.de","mynetwork.cf","mynewemail.info","mynewmail.info","myntu5.pw","myonline-services.net","myonlinetarots.com","myonlinetoday.info","myopang.com","myoverlandtandberg.com","mypacks.net","mypandoramails.com","mypartyclip.de","mypensionchain.cf","myphantomemail.com","myphonam.gq","myphpbbhost.com","mypieter.com","mypietergroup.com","mypieteronline.com","mypop3.bid","mypop3.trade","mypop3.win","myproximity.us","myqrops.net","myqwik.cf","myr2d.com","myrandomthoughts.info","myraybansunglasses-sale.com","myredirect.info","myrice.com","mysafe.ml","mysafemail.cf","mysafemail.ga","mysafemail.gq","mysafemail.ml","mysafemail.tk","mysaitenew.ru","mysamp.de","mysans.tk","mysecretnsa.net","mysecurebox.online","myself.com","mysend-mailer.ru","mysent.ml","myseotraining.org","mysermail1.xyz","mysermail2.xyz","mysermail3.xyz","mysex4me.com","mysexgames.org","mysistersvids.com","mysophiaonline.com","myspaceave.info","myspacedown.info","myspaceinc.com","myspaceinc.net","myspaceinc.org","myspacepimpedup.com","myspamless.com","mysqlbox.com","mystartupweekendpitch.info","mystiknetworks.com","mystufffb.fun","mystvpn.com","mysugartime.ru","mysuperwebhost.com","mytandberg.com","mytandbergonline.com","mytechhelper.info","mytechsquare.com","mytemp.email","mytempdomain.tk","mytempemail.com","mytempmail.com","mythnick.club","mythoughtsexactly.info","mytmail.in","mytools-ipkzone.gq","mytopwebhosting.com","mytownusa.info","mytrashmail.com","mytrashmail.net","mytrashmailer.com","mytrashmailr.com","mytravelstips.com","mytrommler.com","mytrommlergroup.com","mytrommleronline.com","mytuttifruitygsa.xyz","myugg-trade.com","myumail.bid","myumail.stream","myvapepages.com","myvaultsophia.com","myvensys.com","myvtools.com","mywarnernet.net","mywikitree.com","myworld.edu","mywrld.site","mywrld.top","myybloogs.com","myzat.com","myzone.press","myzx.com","myzxseo.net","mzagency.pl","mzbysdi.pl","mzigg6wjms3prrbe.cf","mzigg6wjms3prrbe.ga","mzigg6wjms3prrbe.gq","mzigg6wjms3prrbe.ml","mzigg6wjms3prrbe.tk","mziqo.com","mztiqdmrw.pl","mzwallacepurses.info","mull.email","mullemail.com","mullmail.com","n-system.com","n.polosburberry.com","n.ra3.us","n.spamtrap.co","n.zavio.nl","n00btajima.ga","n0qyrwqgmm.cf","n0qyrwqgmm.ga","n0qyrwqgmm.gq","n0qyrwqgmm.ml","n0qyrwqgmm.tk","n0te.tk","n1buy.com","n1c.info","n1nja.org","n2fnvtx7vgc.cf","n2fnvtx7vgc.ga","n2fnvtx7vgc.gq","n2fnvtx7vgc.ml","n2fnvtx7vgc.tk","n4e7etw.mil.pl","n4paml3ifvoi.cf","n4paml3ifvoi.ga","n4paml3ifvoi.gq","n4paml3ifvoi.ml","n4paml3ifvoi.tk","n59fock.pl","n659xnjpo.pl","n7program.nut.cc","n7s5udd.pl","n8.gs","n8he49dnzyg.cf","n8he49dnzyg.ga","n8he49dnzyg.ml","n8he49dnzyg.tk","n8tini3imx15qc6mt.cf","n8tini3imx15qc6mt.ga","n8tini3imx15qc6mt.gq","n8tini3imx15qc6mt.ml","n8tini3imx15qc6mt.tk","naaag6ex6jnnbmt.ga","naaag6ex6jnnbmt.ml","naaag6ex6jnnbmt.tk","naabiztehas.xyz","naaughty.club","nabuma.com","nacho.pw","nacion.com.mx","nada.email","nada.ltd","nadalaktywne.pl","nadcpexexw.pl","nadmorzem.com","nadrektor4.pl","nadrektor5.pl","nadrektor6.pl","nadrektor7.pl","nadrektor8.pl","nafko.cf","nafrem3456ails.com","nagamems.com","nagapkqq.biz","nagapkqq.info","naghini.cf","naghini.ga","naghini.gq","naghini.ml","nailsmasters.ru","naim.mk","najlepszehotelepl.net.pl","najlepszeprzeprowadzki.pl","najpierw-masa.pl","najstyl.com","nakam.xyz","nakammoleb.xyz","nakedtruth.biz","nalim.shn-host.ru","namail.com","nambi-nedv.ru","nameaaa.myddns.rocks","namefake.com","namemerfo.co.pl","namemerfo.com","nameofname.pw","nameofpic.org.ua","nameprediction.com","nameshirt.xyz","namilu.com","namnerbca.com","namunathapa.com.np","nan.us.to","nando1.com","nanofielznan3s5bsvp.cf","nanofielznan3s5bsvp.ga","nanofielznan3s5bsvp.gq","nanofielznan3s5bsvp.ml","nanofielznan3s5bsvp.tk","nanonym.ch","naogaon.gq","napalm51.cf","napalm51.flu.cc","napalm51.ga","napalm51.gq","napalm51.igg.biz","napalm51.ml","napalm51.nut.cc","napalm51.tk","napalm51.usa.cc","naprawa-wroclaw.xaa.pl","narjwoosyn.pl","nash.ml","nasinyang.cf","nasinyang.ga","nasinyang.gq","nasinyang.ml","naskotk.cf","naskotk.ga","naskotk.ml","naslazhdai.ru","naszelato.pl","nat4.us","natachasteven.com","nate.co.kr","national-escorts.co.uk","national.shitposting.agency","nationalchampionshiplivestream.com","nationalgardeningclub.com","nationalsalesmultiplier.com","nationalspeedwaystadium.co","nationwidedebtconsultants.co.uk","nativityans.ru","naturalious.com","naturalstudy.ru","naturalwebmedicine.net","natureglobe.pw","naturewild.ru","naudau.com","naughty-blog.com","naughtyrevenue.com","nauka999.pl","navientlogin.net","naviosun-ca.info","navmanwirelessoem.com","nawforum.ru","nawideti.ru","nawmin.info","nawny.com","naxamll.com","nayobok.net","nazimail.cf","nazimail.ga","nazimail.gq","nazimail.ml","nazimail.tk","nb8qadcdnsqxel.cf","nb8qadcdnsqxel.ga","nb8qadcdnsqxel.gq","nb8qadcdnsqxel.ml","nb8qadcdnsqxel.tk","nbabasketball.info","nbacheap.com","nbalakerskidstshirt.info","nbhsssib.fun","nbox.notif.me","nboxwebli.eu","nbpwvtkjke.pl","nbrst7e.top","nbseomail.com","nbvojcesai5vtzkontf.cf","nbzmr.com","nc.webkrasotka.com","nce2x8j4cg5klgpupt.cf","nce2x8j4cg5klgpupt.ga","nce2x8j4cg5klgpupt.gq","nce2x8j4cg5klgpupt.ml","nce2x8j4cg5klgpupt.tk","ncedetrfr8989.cf","ncedetrfr8989.ga","ncedetrfr8989.gq","ncedetrfr8989.ml","ncedetrfr8989.tk","ncewy646eyqq1.cf","ncewy646eyqq1.ga","ncewy646eyqq1.gq","ncewy646eyqq1.ml","ncewy646eyqq1.tk","ncinema3d.ru","nctuiem.xyz","nddgxslntg3ogv.cf","nddgxslntg3ogv.ga","nddgxslntg3ogv.gq","nddgxslntg3ogv.ml","nddgxslntg3ogv.tk","ndek4g0h62b.cf","ndek4g0h62b.ga","ndek4g0h62b.gq","ndek4g0h62b.ml","ndek4g0h62b.tk","ndemail.ga","ndfakemail.ga","ndfbmail.ga","ndif8wuumk26gv5.cf","ndif8wuumk26gv5.ga","ndif8wuumk26gv5.gq","ndif8wuumk26gv5.ml","ndif8wuumk26gv5.tk","ndinstamail.ga","ndmail.cf","nds8ufik2kfxku.cf","nds8ufik2kfxku.ga","nds8ufik2kfxku.gq","nds8ufik2kfxku.ml","nds8ufik2kfxku.tk","ndxgokuye98hh.ga","ne-neon.info","neajazzmasters.com","nebltiten0p.cf","nebltiten0p.gq","nebltiten0p.ml","nebltiten0p.tk","necesce.info","necessaryengagements.info","necklacebeautiful.com","necklacesbracelets.com","nedevit1.icu","nedt.com","nedt.net","need-mail.com","needaprint.co.uk","needidoo.org.ua","neewho.pl","neffsnapback.com","negated.com","negociosyempresas.info","negrocavallo.pl","negrofilio.com","nehi.info","nehzlyqjmgv.auto.pl","neibu306.com","neibu963.com","neic.com","nejamaiscesser.com","neko2.net","nemhgjujdj76kj.tk","nenengsaja.cf","neobkhodimoe.ru","neocorp2000.com","neomailbox.com","neon.waw.pl","neopetcheats.org","neotlozhniy-zaim.ru","nepal-nedv.ru","nephisandeanpanflute.com","nepnut.com","nepwk.com","nerds4u.com.au","neremail.com","nerfgunstore.com","nerimosaja.cf","nervmich.net","nervtmich.net","nestle-usa.cf","nestle-usa.ga","nestle-usa.gq","nestle-usa.ml","nestle-usa.tk","nestor99.co.uk","nesy.pl","net-led.com.pl","net-list.com","net-solution.info","net191.com","net1mail.com","net3mail.com","netaccessman.com","netgas.info","netguide.com","nethermon4ik.ru","nethotmail.com","netkiff.info","netmail-pro.com","netmail3.net","netmail8.com","netmails.com","netmails.info","netmails.net","netolsteem.ru","netprfit.com","netricity.nl","netris.net","netsolutions.top","nettmail.com","netviewer-france.com","network-loans.co.uk","network-source.com","networkapps.info","networkcabletracker.com","networkofemail.com","networksmail.gdn","netzidiot.de","neujahrsgruesse.info","neusp.loan","neutronmail.gdn","nevada-nedv.ru","nevadasunshine.info","neverbox.com","neverbox.net","neverbox.org","neverit.tk","nevermail.de","nevermorsss1.ru","nevermorsss3.ru","nevermorsss5.ru","nevermosss7.ru","nevernverfsa.org.ua","neverthisqq.org.ua","nevertmail.cf","nevertoolate.org.ua","neverttasd.org.ua","new-beats-by-dr-dre.com","new-belstaff-jackets.com","new-paulsmithjp.com","new-purse.com","newairmail.com","newbalanceretail.com","newbelstaff-jackets.com","newbpotato.tk","newburlingtoncoatfactorycoupons.com","newcanada-goose-outlet.com","newchristianlouboutinoutletfr.com","newchristianlouboutinshoesusa.us","newdawnnm.xyz","newdaykg.tk","newdesigner-watches.info","newdigitalmediainc.com","newdrw.com","newestnike.com","newestpumpshoes.info","newfilm24.ru","newfishingaccessories.com","newgmaill.com","newgmailruner.com","newhdblog.com","newhomemaintenanceinfo.com","newhorizons.gq","newideasfornewpeople.info","newjordanshoes.us","newkarmalooppromocodes.com","newleafwriters.com","newlove.com","newmailsc.com","newmailss.co.cc","newmarketingcomapny.info","newmedicforum.com","newmesotheliomalaywers.com","newmonsteroutlet2014.co.uk","newness.info","newnxnsupport.ru","newones.com","newpk.com","newportrelo.com","newroc.info","news3.edu","newsairjordansales.com","newscenterdecatur.com","newscoin.club","newscorp.cf","newscorp.gq","newscorp.ml","newscorpcentral.com","newsdvdjapan.com","newsforhouse.com","newsforus24.info","newsgolfjapan.com","newshourly.net","newshubz.tk","newsinhouse.com","newsitems.com","newsmag.us","newsms.pl","newsonlinejapan.com","newsonlinejp.com","newsouting.com","newspro.fun","newssites.com","newsslimming.info","newssportsjapan.com","newstarescorts.com","newstyle-handbags.info","newstylecamera.info","newstylehandbags.info","newstylescarves.info","newsusfun.com","newswimwear2012.info","newtakemail.ml","newtempmail.com","newtestik.co.cc","newtimespop.com","newtmail.com","newuggoutlet-shop.com","newviral.fun","newx6.info","newyork-divorce.org","newyorkinjurynews.com","newyorkskyride.net","newzbling.com","newzeroemail.com","next-mail.info","next-mail.online","next.ovh","next.umy.kr","next2cloud.info","nextag.com","nextemail.in","nextemail.net","nextfash.com","nextgenmail.cf","nextmail.in","nextmail.info","nextstopvalhalla.com","nexttonorm.com","nezdiro.org","nezzart.com","nf2v9tc4iqazwkl9sg.cf","nf2v9tc4iqazwkl9sg.ga","nf2v9tc4iqazwkl9sg.ml","nf2v9tc4iqazwkl9sg.tk","nf38.pl","nf5pxgobv3zfsmo.cf","nf5pxgobv3zfsmo.ga","nf5pxgobv3zfsmo.gq","nf5pxgobv3zfsmo.ml","nf5pxgobv3zfsmo.tk","nfaca.org","nfamilii2011.co.cc","nfast.net","nfhtbcwuc.pl","nfirmemail.com","nfl49erssuperbowlshop.com","nflbettings.info","nflfootballonlineforyou.com","nfljerseyscool.com","nfljerseysussupplier.com","nflnewsforfun.com","nflravenssuperbowl.com","nflravenssuperbowlshop.com","nflshop112.com","nfnorthfaceoutlet.co.uk","nfnov28y9r7pxox.ga","nfnov28y9r7pxox.gq","nfnov28y9r7pxox.ml","nfnov28y9r7pxox.tk","nfovhqwrto1hwktbup.cf","nfovhqwrto1hwktbup.ga","nfovhqwrto1hwktbup.gq","nfovhqwrto1hwktbup.ml","nfovhqwrto1hwktbup.tk","ng9rcmxkhbpnvn4jis.cf","ng9rcmxkhbpnvn4jis.ga","ng9rcmxkhbpnvn4jis.gq","ng9rcmxkhbpnvn4jis.ml","ng9rcmxkhbpnvn4jis.tk","ngeme.me","ngentodgan-awewe.club","ngentot.info","ngg1bxl0xby16ze.cf","ngg1bxl0xby16ze.ga","ngg1bxl0xby16ze.gq","ngg1bxl0xby16ze.ml","ngg1bxl0xby16ze.tk","nghacks.com","nginbox.tk","nginxphp.com","ngolearning.info","ngowscf.pl","ngt7nm4pii0qezwpm.cf","ngt7nm4pii0qezwpm.ml","ngt7nm4pii0qezwpm.tk","ngtierlkexzmibhv.ga","ngtierlkexzmibhv.ml","ngtierlkexzmibhv.tk","nguyenduyphong.tk","nguyenusedcars.com","nh3.ro","nhatdinhmuaduocxe.info","nhaucungtui.com","nhdental.co","nhi9ti90tq5lowtih.cf","nhi9ti90tq5lowtih.ga","nhi9ti90tq5lowtih.gq","nhi9ti90tq5lowtih.tk","nhifswkaidn4hr0dwf4.cf","nhifswkaidn4hr0dwf4.ga","nhifswkaidn4hr0dwf4.gq","nhifswkaidn4hr0dwf4.ml","nhifswkaidn4hr0dwf4.tk","nhisystem1.org","nhjxwhpyg.pl","nhs0armheivn.cf","nhs0armheivn.ga","nhs0armheivn.gq","nhs0armheivn.ml","nhs0armheivn.tk","nic.aupet.it","nice-4u.com","nice-tits.info","nicebeads.biz","nicegarden.us","nicejoke.ru","nicemail.pro","nicemebel.pl","nicemotorcyclepart.com","niceroom2.eu","nicewoodenbaskets.com","nichenetwork.net","nichess.cf","nichess.ga","nichess.gq","nichess.ml","nichole.essence.webmailious.top","nickbizimisimiz.ml","nickloswebdesign.com","nicknassar.com","nickrizos.com","nickrosario.com","nicolabs.info","nicolaseo.fr","nie-podam.pl","niemozesz.pl","niepodam.pl","nifone.ru","nigdynieodpuszczaj.pl","nigeria-nedv.ru","nigge.rs","nihongames.pl","nijakvpsx.com","nijmail.com","nike-air-rift-shoes.com","nike-airmax-chaussures.com","nike-airmaxformen.com","nike-nfljerseys.org","nike.coms.hk","nikeairjordansfrance.com","nikeairjp.com","nikeairmax1zt.co.uk","nikeairmax90sales.co.uk","nikeairmax90ukzt.co.uk","nikeairmax90usa.com","nikeairmax90zr.co.uk","nikeairmax90zt.co.uk","nikeairmax90zu.co.uk","nikeairmaxonline.net","nikeairmaxskyline.co.uk","nikeairmaxvipus.com","nikeairmaxzt.co.uk","nikefreerunshoesuk.com","nikehhhh.com","nikehigh-heels.info","nikejashoes.com","nikejordansppascher.com","nikepopjp.com","nikerunningjp.com","nikesalejp.com","nikesalejpjapan.com","nikeshoejapan.com","nikeshoejp.org","nikeshoesoutletforsale.com","nikeshoesphilippines.com","nikeshox4sale.com","nikeskosalg.com","niketexanshome.com","niketrainersukzt.co.uk","nikihiklios.gr","nikiliosiufe.de","nikoiios.gr","nikon-coolpixl810.info","nikoncamerabag.info","nikosiasio.gr","nikossf.gr","nilocaserool.tk","nimfa.info","nincsmail.com","nincsmail.hu","nine.emailfake.ml","nine.fackme.gq","ninewestbootsca.com","ninja0p0v3spa.ga","ninjabinger.com","nipponian.com","niskaratka.eu","niskopodwozia.pl","nissan370zparts.com","nitricoxidesupplementshq.com","nitricpowerreview.org","nitza.ga","niwalireview.net","niwl.net","nixonbox.com","njc65c15z.com","njelarubangilan.cf","njelarucity.cf","njetzisz.ga","njpsepynnv.pl","nkcs.ru","nkhfmnt.xyz","nkiehjhct76hfa.ga","nkjdgidtri89oye.gq","nknq65.pl","nko.kr","nkqgpngvzg.pl","nkshdkjshtri24pp.ml","nktltpoeroe.cf","nkvtkioz.pl","nl.edu.pl","nl.szucsati.net","nlbassociates.com","nm.beardedcollie.pl","nm5905.com","nm7.cc","nmail.cf","nmailtop.ga","nmarticles.com","nmbbmnm2.info","nmfrvry.cf","nmfrvry.ga","nmfrvry.gq","nmfrvry.ml","nmpkkr.cf","nmpkkr.ga","nmpkkr.gq","nmpkkr.ml","nmqyasvra.pl","nmsy83s5b.pl","nmxjvsbhnli6dyllex.cf","nmxjvsbhnli6dyllex.ga","nmxjvsbhnli6dyllex.gq","nmxjvsbhnli6dyllex.ml","nmxjvsbhnli6dyllex.tk","nn2.pl","nn46gvcnc84m8f646fdy544.tk","nn5ty85.cf","nn5ty85.ga","nn5ty85.gq","nn5ty85.tk","nnejakrtd.pl","nnggffxdd.com","nnh.com","nnot.net","nnoway.ru","no-dysfonction.com","no-more-hangover.tk","no-spam.ws","no-spammers.com","no-ux.com","no-vax.cf","no-vax.ga","no-vax.gq","no-vax.ml","no-vax.tk","no.tap.tru.io","no2maximusreview.org","noblelord.com","noblemail.bid","nobleperfume.info","noblepioneer.com","nobugmail.com","nobulk.com","nobuma.com","noc0szetvvrdmed.cf","noc0szetvvrdmed.ga","noc0szetvvrdmed.gq","noc0szetvvrdmed.ml","noc0szetvvrdmed.tk","noc1tb4bfw.cf","noc1tb4bfw.ga","noc1tb4bfw.gq","noc1tb4bfw.ml","noc1tb4bfw.tk","noclegi0.pl","noclegiwsieci.com.pl","noclickemail.com","nocujunas.com.pl","nod03.ru","nod9d7ri.aid.pl","nodemon.peacled.xyz","nodeoppmatte.com","nodepositecasinous.com","nodezine.com","nodie.cc","nodnor.club","noe.prometheusx.pl","noedgetest.space","noelia.meghan.ezbunko.top","nofakeipods.info","nofaxpaydayloansin24hrs.com","nofbi.com","nofocodobrasil.tk","nogmailspam.info","noicd.com","noifeelings.com","noiuihg2erjkzxhf.cf","noiuihg2erjkzxhf.ga","noiuihg2erjkzxhf.gq","noiuihg2erjkzxhf.ml","noiuihg2erjkzxhf.tk","nokatmaroc.com","nokiahere.cf","nokiahere.ga","nokiahere.gq","nokiahere.ml","nokiahere.tk","nokiamail.cf","nokiamail.com","nokiamail.ga","nokiamail.gq","nokiamail.ml","noklike.info","nolemail.ga","nolimemail.com.ua","nom.za","nomail.cf","nomail.ch","nomail.ga","nomail.net","nomail.nodns.xyz","nomail.pw","nomail.xl.cx","nomail2me.com","nomailthankyou.com","nomeucu.ga","nomoremail.net","nomorespam.kz","nomorespamemails.com","nomotor247.info","nonameex.com","nongzaa.cf","nongzaa.gq","nongzaa.ml","nongzaa.tk","nonohairremovalonline.com","nonspam.eu","nonspammer.de","nonstop-traffic-formula.com","nonze.ro","nootopics.tulane.edu","norcalenergy.edu","noref.in","norih.com","norkinaart.net","normandys.com","norseforce.com","northandsouth.pl","northemquest.com","northernbets.co","northface-down.us","northfaceeccheap.co.uk","northfaceonlineclearance.com","northfacesalejacketscouk.com","northfacesky.com","northfaceuka.com","northfaceusonline.com","norules.zone","norvasconlineatonce.com","norveg-nedv.ru","noscabies.org","nosemail.com","noseycrazysumrfs5.com","nosh.ml","nospam.allensw.com","nospam.barbees.net","nospam.sparticus.com","nospam.thurstons.us","nospam.today","nospam.wins.com.br","nospam.ze.tc","nospam2me.com","nospam4.us","nospamdb.com","nospamfor.us","nospammail.bz.cm","nospammail.net","nospamme.com","nospammer.ovh","nospamthanks.info","nostockui.com","nostrajewellery.xyz","not0k.com","notasitseems.com","notbooknotbuk.com","notchbox.info","notebookercenter.info","notherone.ca","nothingtoseehere.ca","notif.me","notion.work","notivsjt0uknexw6lcl.ga","notivsjt0uknexw6lcl.gq","notivsjt0uknexw6lcl.ml","notivsjt0uknexw6lcl.tk","notmail.ga","notmail.gq","notmail.ml","notmailinator.com","notregmail.com","notrnailinator.com","notsharingmy.info","novagun.com","novartismails.com","novelbowl.xyz","novemberdelta.myverizonmail.top","novembervictor.webmailious.top","novencolor.otsoft.pl","novensys.pl","novgorod-nedv.ru","novosib-nedv.ru","now.im","now.mefound.com","now4you.biz","noway.pw","noways.ddns.net","nowemail.ga","nowemailbox.com","nowhere.org","nowmymail.com","nowmymail.net","nownaw.ml","nowoczesne-samochody.pl","nowoczesnesamochody.pl","noyabrsk.me","noyten.info","npajjgsp.pl","nphcsfz.pl","npv.kr","npwfnvfdqogrug9oanq.cf","npwfnvfdqogrug9oanq.ga","npwfnvfdqogrug9oanq.gq","npwfnvfdqogrug9oanq.ml","npwfnvfdqogrug9oanq.tk","nqav95zj0p.kro.kr","nqeq3ibwys0t2egfr.cf","nqeq3ibwys0t2egfr.ga","nqeq3ibwys0t2egfr.gq","nqeq3ibwys0t2egfr.ml","nqeq3ibwys0t2egfr.tk","nqrk.luk2.com","nrhskhmb6nwmpu5hii.cf","nrhskhmb6nwmpu5hii.ga","nrhskhmb6nwmpu5hii.gq","nrhskhmb6nwmpu5hii.ml","nrhskhmb6nwmpu5hii.tk","nroc2mdfziukz3acnf.cf","nroc2mdfziukz3acnf.ga","nroc2mdfziukz3acnf.gq","nroc2mdfziukz3acnf.ml","nroc2mdfziukz3acnf.tk","ns2.vipmail.in","nsaking.de","nsbwsgctktocba.cf","nsbwsgctktocba.ga","nsbwsgctktocba.gq","nsbwsgctktocba.ml","nsbwsgctktocba.tk","nscream.com","nsddourdneis.gr","nsk1vbz.cf","nsk1vbz.ga","nsk1vbz.gq","nsk1vbz.ml","nsk1vbz.tk","nsserver.org","ntb9oco3otj3lzskfbm.cf","ntb9oco3otj3lzskfbm.ga","ntb9oco3otj3lzskfbm.gq","ntb9oco3otj3lzskfbm.ml","ntb9oco3otj3lzskfbm.tk","nthmail.com","nthmessage.com","ntirrirbgf.pl","ntlhelp.net","ntllma3vn6qz.cf","ntllma3vn6qz.ga","ntllma3vn6qz.gq","ntllma3vn6qz.ml","ntllma3vn6qz.tk","ntt.gotdns.ch","ntub.cf","ntudofutluxmeoa.cf","ntudofutluxmeoa.ga","ntudofutluxmeoa.gq","ntudofutluxmeoa.ml","ntudofutluxmeoa.tk","ntutnvootgse.cf","ntutnvootgse.ga","ntutnvootgse.gq","ntutnvootgse.ml","ntutnvootgse.tk","ntuv4sit2ai.cf","ntuv4sit2ai.ga","ntuv4sit2ai.gq","ntuv4sit2ai.ml","ntuv4sit2ai.tk","nty5upcqq52u3lk.cf","nty5upcqq52u3lk.ga","nty5upcqq52u3lk.gq","nty5upcqq52u3lk.ml","nty5upcqq52u3lk.tk","nub3zoorzrhomclef.cf","nub3zoorzrhomclef.ga","nub3zoorzrhomclef.gq","nub3zoorzrhomclef.ml","nub3zoorzrhomclef.tk","nubescontrol.com","nuctrans.org","nude-vista.ru","nuke.africa","nullbox.info","numanavale.com","numweb.ru","nunung.cf","nunungcantik.ga","nunungnakal.ga","nunungsaja.cf","nuo.co.kr","nuo.kr","nuprice.co","nuqhvb1lltlznw.cf","nuqhvb1lltlznw.ga","nuqhvb1lltlznw.gq","nuqhvb1lltlznw.ml","nuqhvb1lltlznw.tk","nuqypepalopy.rawa-maz.pl","nurdea.biz","nurdea.com","nurdea.net","nurdead.biz","nurdeal.biz","nurdeal.com","nurdeas.biz","nurdeas.com","nurdintv.com","nurdsgetbad2015.com","nurfuerspam.de","nurkowania-base.pl","nurseryschool.ru","nus.edu.sg","nut-cc.nut.cc","nut.cc","nutcc.nut.cc","nutpa.net","nutritiondrill.com","nutropin.in","nuts2trade.com","nvb467sgs.cf","nvb467sgs.ga","nvb467sgs.gq","nvb467sgs.ml","nvb467sgs.tk","nvc-e.com","nvfpp47.pl","nvgf3r56raaa.cf","nvgf3r56raaa.ga","nvgf3r56raaa.gq","nvgf3r56raaa.ml","nvgf3r56raaa.tk","nvision2011.co.cc","nvmetal.pl","nvtelecom.info","nvtmail.bid","nvv1vcfigpobobmxl.cf","nvv1vcfigpobobmxl.gq","nvv1vcfigpobobmxl.ml","nw7cxrref2hjukvwcl.cf","nw7cxrref2hjukvwcl.ga","nw7cxrref2hjukvwcl.gq","nw7cxrref2hjukvwcl.ml","nw7cxrref2hjukvwcl.tk","nwd6f3d.net.pl","nwldx.com","nwldx.net","nwufewum9kpj.gq","nwytg.com","nwytg.net","nwyzoctpa.pl","nxbrasil.net","nxdgrll3wtohaxqncsm.cf","nxdgrll3wtohaxqncsm.gq","nxdgrll3wtohaxqncsm.ml","nxdgrll3wtohaxqncsm.tk","nxeswavyk6zk.cf","nxeswavyk6zk.ga","nxeswavyk6zk.gq","nxeswavyk6zk.ml","nxeswavyk6zk.tk","nxgwr24fdqwe2.cf","nxgwr24fdqwe2.ga","nxgwr24fdqwe2.gq","nxgwr24fdqwe2.ml","nxgwr24fdqwe2.tk","nxmwzlvux.pl","nxpeakfzp5qud6aslxg.cf","nxpeakfzp5qud6aslxg.ga","nxpeakfzp5qud6aslxg.gq","nxpeakfzp5qud6aslxg.ml","nxpeakfzp5qud6aslxg.tk","nxraarbso.pl","ny7.me","nyanime.gq","nyc-pets.info","nyccommunity.info","nyflcigarettes.net","nymopyda.kalisz.pl","nyoregan09brex.ml","nypato.com","nyrmusic.com","nyumail.com","nyusul.com","nywcmiftn8hwhj.cf","nywcmiftn8hwhj.ga","nywcmiftn8hwhj.gq","nywcmiftn8hwhj.ml","nywcmiftn8hwhj.tk","nzhkmnxlv.pl","nzmymg9aazw2.cf","nzmymg9aazw2.ga","nzmymg9aazw2.gq","nzmymg9aazw2.ml","nzmymg9aazw2.tk","nzntdc4dkdp.cf","nzntdc4dkdp.ga","nzntdc4dkdp.gq","nzntdc4dkdp.ml","nzntdc4dkdp.tk","nzttrial.xyz","o-pizda.info","o.cfo2go.ro","o.idigo.org","o.muti.ro","o.oai.asia","o.opendns.ro","o.polosburberry.com","o.spamtrap.ro","o029o.ru","o060bgr3qg.com","o13mbldrwqwhcjik.cf","o13mbldrwqwhcjik.ga","o13mbldrwqwhcjik.gq","o13mbldrwqwhcjik.ml","o13mbldrwqwhcjik.tk","o2.co.com","o22.com","o22.info","o2stk.org","o3enzyme.com","o3vgl9prgkptldqoua.cf","o3vgl9prgkptldqoua.ga","o3vgl9prgkptldqoua.gq","o3vgl9prgkptldqoua.ml","o3vgl9prgkptldqoua.tk","o473ufpdtd.ml","o473ufpdtd.tk","o4tnggdn.mil.pl","o4zkthf48e46bly.cf","o4zkthf48e46bly.ga","o4zkthf48e46bly.gq","o4zkthf48e46bly.ml","o4zkthf48e46bly.tk","o6.com.pl","o7edqb.pl","o7i.net","o7t2auk8msryc.cf","o7t2auk8msryc.ga","o7t2auk8msryc.gq","o7t2auk8msryc.ml","o7t2auk8msryc.tk","o8t30wd3pin6.cf","o8t30wd3pin6.ga","o8t30wd3pin6.gq","o8t30wd3pin6.ml","o8t30wd3pin6.tk","o90.org","oafrem3456ails.com","oai.asia","oakleglausseskic.com","oakley-solbriller.com","oakleyoutlet.com","oakleysaleonline.net","oakleysaleonline.org","oakleysalezt.co.uk","oakleysonlinestore.net","oakleysonlinestore.org","oakleysoutletonline.com","oakleysoutletstore.net","oakleysoutletstore.org","oakleystorevip.com","oakleysunglasses-online.co.uk","oakleysunglassescheapest.org","oakleysunglassescheapsale.us","oakleysunglassesdiscountusw.com","oakleysunglassesoutletok.com","oakleysunglassesoutletstore.org","oakleysunglassesoutletstore.us","oakleysunglassesoutletzt.co.uk","oakleysunglassessoldes.com","oakleysunglasseszt.co.uk","oakleyusvip.com","oaksw.com","oalegro.pl","oalsp.com","oamail.com","oaudienceij.com","oaxmail.com","ob5d31gf3whzcoo.cf","ob5d31gf3whzcoo.ga","ob5d31gf3whzcoo.gq","ob5d31gf3whzcoo.ml","ob5d31gf3whzcoo.tk","ob7eskwerzh.cf","ob7eskwerzh.ga","ob7eskwerzh.gq","ob7eskwerzh.ml","ob7eskwerzh.tk","obamaiscool.com","obelisk4000.cf","obelisk4000.ga","obelisk4000.gq","obermail.com","obet889.online","obfusko.com","obibike.net","obibok.de","objectmail.com","objectuoso.com","obmail.com","obo.kr","obobbo.com","oborudovanieizturcii.ru","oboymail.ga","obserwatorbankowy.pl","obtqadqunonkk1kgh.cf","obtqadqunonkk1kgh.ga","obtqadqunonkk1kgh.gq","obtqadqunonkk1kgh.ml","obtqadqunonkk1kgh.tk","obuv-poisk.info","obviousdistraction.com","obxpestcontrol.com","obymbszpul.pl","oceancares.xyz","oceanicmail.gdn","ochupella.ru","ocigaht4.pc.pl","ocotbukanmain.club","octa-sex.com","oczyszczalnie-sciekow24.pl","od21gwnkte.cf","od21gwnkte.ga","od21gwnkte.gq","od21gwnkte.ml","od21gwnkte.tk","od9b0vegxj.cf","od9b0vegxj.ga","od9b0vegxj.gq","od9b0vegxj.ml","od9b0vegxj.tk","odaymail.com","odbiormieszkania.waw.pl","odchudzanienit.mil.pl","odchudzedsfanie.pl","oddhat.com","oddiyanadharmasanctuary.org","odegda-optom.biz","odem.com","odemail.com","odinaklassnepi.net","odixer.rzeszow.pl","odkrywcy.com","odnorazovoe.ru","odqykmt.pl","odqznam.wirt11.biznes-host.pl","odseo.ru","odsniezanienieruchomosci.pl","odszkodowanie-w-anglii.eu","odu-tube.ru","odulmail.com","odzyskiwaniedanych.com","oe1f42q.com","oemkoreabrand.com","oemkoreafactory.com","oemsale.org","oemsoftware.eu","oemzpa.cf","oeoqzf.pl","oepia.com","oerfa.org","oerpub.org","oertefae.tk","oeu4sdyoe7llqew0bnr.cf","oeu4sdyoe7llqew0bnr.ga","oeu4sdyoe7llqew0bnr.gq","oeu4sdyoe7llqew0bnr.ml","oeu4sdyoe7llqew0bnr.tk","ofacchecking.com","oferta.pl","oferty-domiporta.pl","oferty-kredytowe.com.pl","oferty-warszawa.pl","offerall.biz","offersale.info","office.ms365.ml","officebuhgaltera.pp.ua","officeking.pl","officemanagementinfo.com","officepoland.com.pl","officetechno.ru","official-colehaan.com","official-louisvuitton.com","official-saints.com","official-tomsshoes.net","official.site","official49erssportshop.com","officialairmaxprostore.com","officialairmaxsproshop.com","officialairmaxuksshop.com","officialfreerun.com","officialltoms-shoes.com","officialltoms-shoes.org","officialmailsites.com","officialmulberry.com","officialmulberryonline.com","officialnflbears.com","officialnflbearsshop.com","officialnflcoltsstore.com","officialnfldenverbroncoshop.com","officialnflfalconshoponline.com","officialnflgiantspromart.com","officialnflpackerspromart.com","officialnflsf49ershop.com","officialnflsteelersprostore.com","officialngentot.cf","officialngentot.ga","officialngentot.gq","officialngentot.ml","officialngentot.tk","officialouisvuittonsmart.com","officialpatriotssportshop.com","officialravenssportshop.com","officialravensuperbowlshop.com","officialredbottomsshop.com","officialreversephonelookupsites.com","officialsf49erssuperbowlshop.com","officialsf49ersteamshop.com","officialtiffanycoproshop.com","officialtolol.ga","officieel-airmaxs.com","officieelairmaxshop.com","officiel-jordans.com","officiel-tnrequin.com","officielairmaxfr.com","officielairmaxfrance.com","officielairmaxpascher.com","officielairmaxsshop.com","officielchaussurestore.com","officiellairmaxsshop.com","officielle-jordans.com","officielleairmax.com","officiellejordan.com","officielmaxshop.com","officielnikeairmas.org","officieltnrequinfr.com","officieltnrequinfrshop.com","offsetmail.com","offshore-company.tk","offshore-proxies.net","offthechainfishing.com","oficinasjorgevelasquez.com","ofmail.com","ofmf.co.cc","ofojwzmyg.pl","ofth3crumrhuw.cf","ofth3crumrhuw.ga","ofth3crumrhuw.gq","ofth3crumrhuw.ml","ofth3crumrhuw.tk","ogemail.com","ogladajonlinezadarmo.pl","ogloszeniadladzieci.pl","ogmail.com","ogremail.net","ogrodzenia.pl","ogu188.com","ogu7777.net","ohaaa.de","ohamail.com","ohdomain.xyz","ohi-design.pl","ohi.tw","ohio-riverland.info","ohioticketpayments.xyz","ohkogtsh.ga","ohkogtsh.ml","ohmail.com","ohtheprice.com","ohxmail.com","ohyesjysuis.fr","oidzc1zgxrktxdwdkxm.cf","oidzc1zgxrktxdwdkxm.ga","oidzc1zgxrktxdwdkxm.gq","oidzc1zgxrktxdwdkxm.ml","oidzc1zgxrktxdwdkxm.tk","oigmail.com","oiizz.com","oilofolay.in","oilpaintingsale.net","oilpaintingvalue.info","oilrepairs.com","oimail.com","oing.cf","oink8jwx7sgra5dz.cf","oink8jwx7sgra5dz.ga","oink8jwx7sgra5dz.gq","oink8jwx7sgra5dz.ml","oink8jwx7sgra5dz.tk","oinkboinku.com","oioinb.com","oioio.club","oiplikai.ml","oipmail.com","oipplo.com","oiqas.com","oiwke.com","oizxwhddxji.cf","oizxwhddxji.ga","oizxwhddxji.gq","oizxwhddxji.ml","oizxwhddxji.tk","ojamail.com","ojdh71ltl0hsbid2.cf","ojdh71ltl0hsbid2.ga","ojdh71ltl0hsbid2.gq","ojdh71ltl0hsbid2.ml","ojdh71ltl0hsbid2.tk","ojemail.com","ojimail.com","ojobmail.com","ojosambat.cf","ojosambat.ml","ojpvym3oarf3njddpz2.cf","ojpvym3oarf3njddpz2.ga","ojpvym3oarf3njddpz2.gq","ojpvym3oarf3njddpz2.ml","ojpvym3oarf3njddpz2.tk","ok-body.pw","okbeatsdrdre1.com","okbody.pw","okclprojects.com","okdiane35.pl","okeoceapasajaoke.com","okezone.bid","okgmail.com","okinotv.ru","okkokshop.com","okledslights.com","oklho.com","oklkfu.com","okmail.com","okna2005.ru","okndrt2ebpshx5tw.cf","okndrt2ebpshx5tw.ga","okndrt2ebpshx5tw.gq","okndrt2ebpshx5tw.ml","okndrt2ebpshx5tw.tk","oknokurierskie.pl","okrent.us","okryszardkowalski.pl","okstorytye.com","oksunglassecool.com","oktoberfest2012singapore.com","okulistykakaszubska.pl","okzk.com","ol.telz.in","olahoo.com","olaytacx.top","oldcelebrities.net","olden.com.pl","oldhatseo.co","oldnavycouponsbox.com","oldscheme.org","oldschoolnewbodyreviews.org","olechnowicz.com.pl","olegfemale.org","olegmike.org","olgis.ru","olgt6etnrcxh3.cf","olgt6etnrcxh3.ga","olgt6etnrcxh3.gq","olgt6etnrcxh3.ml","olgt6etnrcxh3.tk","olimp-case.ru","olinbzt.ga","olisadebe.org","olivegardencouponshub.com","oljdsjncat80kld.gq","ollisterpascheremagasinfrance.com","olmail.com","olo4lol.uni.me","ololomail.in","olplq6kzeeksozx59m.cf","olplq6kzeeksozx59m.ga","olplq6kzeeksozx59m.gq","olplq6kzeeksozx59m.ml","olplq6kzeeksozx59m.tk","olsenmail.men","olvqnr7h1ssrm55q.cf","olvqnr7h1ssrm55q.ga","olvqnr7h1ssrm55q.gq","olvqnr7h1ssrm55q.ml","olvqnr7h1ssrm55q.tk","olypmall.ru","olyztnoblq.pl","omahsimbah.com","omail.pro","omca.info","omdo.xyz","omeaaa124.ddns.net","omega-3-foods.com","omega.omicron.spithamail.top","omegafive.net","omegasale.org","omegaxray.thefreemail.top","omesped7.net","omessage.gq","omi4.net","omicron.omega.myverizonmail.top","omicrongamma.coayako.top","omicronlambda.ezbunko.top","omicronwhiskey.coayako.top","ommail.com","omnievents.org","omsk-nedv.ru","omsshoesonline4.com","omtamvan.com","omumail.com","omxvfuaeg.pl","omzae.com","omzg5sbnulo1lro.cf","omzg5sbnulo1lro.ga","omzg5sbnulo1lro.gq","omzg5sbnulo1lro.ml","omzg5sbnulo1lro.tk","on-review.com","onbf.org","oncesex.com","oncult.ru","ondemandmap.com","one-college.ru","one-time.email","one.emailfake.ml","one.fackme.gq","one.pl","one.raikas77.eu","one2mail.info","onebiginbox.com","onebucktwobuckthree.com","onebyoneboyzooole.com","onecitymail.com","onedaymail.cf","onedaymail.ga","oneindex.in.net","onelegalplan.com","onemail.host","onemail1.com","onemoremail.net","onemoretimes.info","onenime.ga","oneoffemail.com","oneoffmail.com","oneonfka.org.ua","onepiecetalkblog.com","onestepmail.com","onestop21.com","onet.com","onetouchedu.com","onewaylinkcep.com","onewaymail.com","ongc.ga","onhrrzqsubu.pl","oninmail.com","onit.com","onkyo1.com","onlatedotcom.info","onlimail.com","online-business-advertising.com","online-casino24.us","online-dartt.pl","online-dating-bible.com","online-dating-service-sg.com","online-geld-verdienen.gq","online-pills.xyz","online-std.com","online-stream.biz","online.ms","onlineaccutaneworldpills.com","onlineautoloanrates.com","onlineavtomati.net","onlinebankingcibc.com","onlinebankingpartner.com","onlinecanada.biz","onlinecarinsuranceexpert.com","onlinechristianlouboutinshoesusa.us","onlinecollegemail.com","onlinedatingsiteshub.com","onlinedeals.pro","onlinedeals.trade","onlinedutyfreeeshop.com","onlinedutyfreeshop.com","onlineee.com","onlinefunnynews.com","onlineguccibags.com","onlinegun.com","onlinehackland.com","onlinehealthreports.com","onlinehunter.ml","onlineidea.info","onlineinsurancequotescar.net","onlinejerseysnews.com","onlinejordanretro2013.org","onlinemail.press","onlinemail.pw","onlinemailfree.com","onlinemedic.biz","onlinemoneyfan.com","onlinemoneymaking.org","onlinenet.info","onlinenewsfootball.com","onlinepaydayloansvip.com","onlinepharmacy-order.com","onlinepharmacy.name","onlineplayers.ru","onlinepokiesau.com.au","onlineprofessionalorganizer.com","onlineshoesboots.com","onlineshop24h.pl","onlineshoppingcoupons24.com","onlineshopsinformation.com","onlinestodays.info","onlinetomshoeoutletsale.com","onlinewcm.com","onlinexploits.com","only-bag.com","onlyapps.info","onlyme.pl","onlysext.com","onlysingleparentsdating.co.uk","onlysolars.com","onlyways.ru","onlywedding.ru","onmagic.ru","onmail.win","onmailzone.com","onmuscletissue.uk","onnormal.com","onofmail.com","onplayagain.net","onprice.co","onqin.com","onsaleadult.com","onsalemall.top","onshop5.com","onsitetrainingcourses.com","ontalk.biz","ontyne.biz","onumail.com","oo.pl","ooapmail.com","oob8q2rnk.pl","ooeawtppmznovo.cf","ooeawtppmznovo.ga","ooeawtppmznovo.gq","ooeawtppmznovo.ml","ooeawtppmznovo.tk","oofmail.tk","oogmail.com","oohioo.com","oohlaleche.com","oohotmail.club","oohotmail.com","oohotmail.online","ookfmail.com","oolmail.com","oolong.ro","oolus.com","oonies-shoprus.ru","oopi.org","oopsify.com","oou.us","opalroom.com","opayq.com","opelmail.com","open-domains.info","open-sites.info","open.brainonfire.net","opende.de","opendns.ro","openfront.com","openingforex.com","openmailbox.tk","openmindedzone.club","opennames.info","opentrash.com","operabrow.com","operacjezeza.pl","operenetow.com","opilon.com","oplaskit.ml","opljggr.org","opmail.com","opmmail.com","opmmedia.ga","opna.me","opno.life","opojare.org","opole-bhp.pl","opowlitowe53.tk","opp24.com","oppein.pl","oppobitty-myphen375.com","opsmkyfoa.pl","optician.com","optimalstackreview.net","optimalstackreviews.net","optimaweb.me","optimumnutritionseriousmass.net","optimuslinks.com","optiplex.com","optykslepvps.com","optymalizacja.com.pl","opulent-fx.com","or.orgz.in","oracruicat.xyz","oralreply.com","oranek.com","orange-bonplan.com","orangeinbox.org","orangesticky.info","orangotango.cf","orangotango.ga","orangotango.gq","orangotango.ml","orangotango.tk","orbitnew.net","order84.gmailmirror.com","orderbagsonline.handbagsluis.net","ordershoes.com","ordinaryamerican.net","ordinaryyz1.com","oregon-nedv.ru","oreidresume.com","orfea.pl","orfeaskios.com","organiccoffeeplace.com","organicfarming101.com","organicgreencoffeereview.com","organicmedinc.com","orgcity.info","orgiiusisk.gr","orgiosdos.gr","orgmbx.cc","orgogiogiris.gr","oriete.cf","orikamset.de","oringame.com","orinmail.com","oriogiosi.gr","orion.tr","oriondertest.it","orlandoroofreplacement.com","orleasi.com","ormtalk.com","oroki.de","orotab.com","orpxp547tsuy6g.cf","orpxp547tsuy6g.ga","orpxp547tsuy6g.gq","orpxp547tsuy6g.ml","orpxp547tsuy6g.tk","orq1ip6tlq.cf","orq1ip6tlq.ga","orq1ip6tlq.gq","orq1ip6tlq.ml","orq1ip6tlq.tk","orumail.com","orvnr2ed.pl","oryx.hr","osa.pl","osakawiduerr.cf","osakawiduerr.gq","osakawiduerr.ml","osamail.com","oscar.delta.livefreemail.top","oscarpostlethwaite.com","osdfsew.tk","osendingwr.com","osfujhtwrblkigbsqeo.cf","osfujhtwrblkigbsqeo.ga","osfujhtwrblkigbsqeo.gq","osfujhtwrblkigbsqeo.ml","osfujhtwrblkigbsqeo.tk","oshietechan.link","oskadonpancenoye.com","osmom.justdied.com","osmqgmam5ez8iz.cf","osmqgmam5ez8iz.ga","osmqgmam5ez8iz.gq","osmqgmam5ez8iz.ml","osmqgmam5ez8iz.tk","osormail.com","osporno-x.info","osrypdxpv.pl","osteopath-enfield.co.uk","osuedc.org","osuvpto.com","oswietlenieogrodow.pl","oswo.net","othedsordeddy.info","otheranimals.ru","otherdog.net","othergoods.ru","otherinbox.codupmyspace.com","otherinbox.com","otlook.es","otmail.com","otnasus.xyz","otoeqis66avqtj.cf","otoeqis66avqtj.ga","otoeqis66avqtj.gq","otoeqis66avqtj.ml","otoeqis66avqtj.tk","otomax-pro.com","otonmail.ga","ottawaprofilebacks.com","otu1txngoitczl7fo.cf","otu1txngoitczl7fo.ga","otu1txngoitczl7fo.gq","otu1txngoitczl7fo.ml","otu1txngoitczl7fo.tk","otvetinavoprosi.com","ouhihu.cf","ouhihu.ga","ouhihu.gq","ouhihu.ml","oulook.com","oup3kcpiyuhjbxn.cf","oup3kcpiyuhjbxn.ga","oup3kcpiyuhjbxn.gq","oup3kcpiyuhjbxn.ml","oup3kcpiyuhjbxn.tk","ourawesome.life","ourawesome.online","ourbox.info","ourcocktaildress.com","ourcocktaildress.net","ourdietpills.org","ourgraduationdress.com","ourgraduationdress.net","ourklips.com","ourlouisvuittonfr.com","ourmonclerdoudounefr.com","ourmonclerpaschere.com","ourpreviewdomain.com","oursblog.com","ourstorereviews.org","out-email.com","out-mail.com","out-mail.net","out-sourcing.com.pl","outbacksteakhousecouponshub.com","outdoorproductsupplies.com","outdoorslifestyle.com","outfu.com","outlawmma.co.uk","outlawspam.com","outlddook.com","outlet-michaelkorshandbags.com","outletcoachfactorystoreus.com","outletcoachonlinen.com","outletcoachonliner.com","outletgucciitaly.com","outletjacketsstore.com","outletkarenmillener.co.uk","outletlouisvuittonborseiitaly.com","outletlouisvuittonborseitaly.com","outletlouisvuittonborseoutletitaly.com","outletlouisvuittonsbag.co.uk","outletmichaelkorssales.com","outletmonclerpiuminiit.com","outletomszt.com","outletpiuminimoncleritaly.com","outletpiuminimoncleritaly1.com","outletraybans.com","outlets5.com","outletstores.info","outlettcoachstore.com","outlettomsonlinevip.com","outlettomsonlinezt.com","outlettomszt.com","outlettoryburchjpzt.com","outlok.com","outlok.net","outloo.com","outlook.com.hotpusssy69.host","outlook.twitpost.info","outlook2.gq","outlookkk.online","outlookpro.net","outloomail.gdn","outlouk.com","outluk.com","outluo.com","outluok.com","outmail.win","outmail4u.ml","outrageousbus.com","outsidestructures.com","outstandingtrendy.info","outuok.com","ouwrmail.com","ov3u841.com","ovaclockas24.net","ovaqmail.com","ovefagofceaw.com","over-you-24.com","overkill4.pl","overkill5.pl","overkill6.pl","overwholesale.com","ovi.usa.cc","ovimail.cf","ovimail.ga","ovimail.gq","ovimail.ml","ovimail.tk","ovipmail.com","ovlov.cf","ovlov.ga","ovlov.gq","ovlov.ml","ovlov.tk","ovmail.com","ovorowo.com","ovpn.to","ovvee.com","ovwfzpwz.pc.pl","owa.kr","owawkrmnpx876.tk","owbot.com","oweiidfjjif.cf","oweiidfjjif.ga","oweiidfjjif.gq","oweiidfjjif.ml","oweiidfjjif.tk","owemolexi.swiebodzin.pl","owfcbxqhv.pl","owh.ooo","owlpic.com","owlymail.com","own-tube.com","ownerbanking.org","ownersimho.info","ownsyou.de","owrdonjk6quftraqj.cf","owrdonjk6quftraqj.ga","owrdonjk6quftraqj.gq","owrdonjk6quftraqj.ml","owrdonjk6quftraqj.tk","owsz.edu.pl","oxfarm1.com","oxford.gov","oxkvj25a11ymcmbj.cf","oxkvj25a11ymcmbj.ga","oxkvj25a11ymcmbj.gq","oxkvj25a11ymcmbj.tk","oxmail.com","oxopoha.com","oxudvqstjaxc.info","oyalmail.com","oyekgaring.ml","oylstze9ow7vwpq8vt.cf","oylstze9ow7vwpq8vt.ga","oylstze9ow7vwpq8vt.gq","oylstze9ow7vwpq8vt.ml","oylstze9ow7vwpq8vt.tk","oymail.com","oyu.kr","oyuhfer.cf","oyuhfer.ga","oyuhfer.gq","oyuhfer.ml","ozijmail.com","ozlaq.com","ozmail.com","oznmtwkng.pl","ozost.com","ozozwd2p.com","ozqn1it6h5hzzxfht0.cf","ozqn1it6h5hzzxfht0.ga","ozqn1it6h5hzzxfht0.gq","ozqn1it6h5hzzxfht0.ml","ozqn1it6h5hzzxfht0.tk","ozumz.com","ozyl.de","ozyumail.com","p-a-y.biz","p-banlis.ru","p-gdl.cf","p-gdl.ga","p-gdl.gq","p-gdl.ml","p-gdl.tk","p-value.ga","p-value.tk","p.9q.ro","p.k4ds.org","p.mrrobotemail.com","p.new-mgmt.ga","p.polosburberry.com","p180.cf","p180.ga","p180.gq","p180.ml","p180.tk","p1c.us","p1nhompdgwn.cf","p1nhompdgwn.ga","p1nhompdgwn.gq","p1nhompdgwn.ml","p1nhompdgwn.tk","p2zyvhmrf3eyfparxgt.cf","p2zyvhmrf3eyfparxgt.ga","p2zyvhmrf3eyfparxgt.gq","p2zyvhmrf3eyfparxgt.ml","p2zyvhmrf3eyfparxgt.tk","p33.org","p4tnv5u.pl","p58fgvjeidsg12.cf","p58fgvjeidsg12.ga","p58fgvjeidsg12.gq","p58fgvjeidsg12.ml","p58fgvjeidsg12.tk","p6halnnpk.pl","p71ce1m.com","p8oan2gwrpbpvbh.cf","p8oan2gwrpbpvbh.ga","p8oan2gwrpbpvbh.gq","p8oan2gwrpbpvbh.ml","p8oan2gwrpbpvbh.tk","p8y56fvvbk.cf","p8y56fvvbk.ga","p8y56fvvbk.gq","p8y56fvvbk.ml","p8y56fvvbk.tk","p90x-dvd.us","p90xdvds60days.us","p90xdvdsale.info","p90xlifeshow.com","p90xstrong.com","p9fnveiol8f5r.cf","p9fnveiol8f5r.ga","p9fnveiol8f5r.gq","p9fnveiol8f5r.ml","p9fnveiol8f5r.tk","pa9e.com","pacdoitreiunu.com","pachilly.com","pacific-ocean.com","packersandmovers-pune.in","packersproteamsshop.com","packerssportstore.com","pacnoisivoi.com","padanghijau.online","padcasesaling.com","paddlepanel.com","pafrem3456ails.com","pagamenti.tk","paharpurmim.cf","paharpurmim.ga","paharpurmim.gq","paharpurmim.ml","paharpurmim.tk","paharpurtitas.cf","paharpurtitas.ga","paharpurtitas.gq","paharpurtitas.ml","paharpurtitas.tk","paherpur.ga","paherpur.gq","paherpur.ml","pahrumptourism.com","paidattorney.com","paiindustries.com","paintballpoints.com","paintyourarboxers.com","pakadebu.ga","paketliburantourwisata.com","pakolokoemail.com.uk","pakwork.com","palau-nedv.ru","paleorecipebookreviews.org","palingbaru.tech","paller.cf","palm-bay.info","palmettospecialtytransfer.com","palosdonar.com","palpialula.gq","pals-pay54.cf","pamapamo.com","pamposhtrophy.com","panama-nedv.ru","panama-real-estate.cf","panasonicgf1.net","pancakemail.com","pancosj.cf","pancosj.ga","pancosj.gq","pancosj.ml","pancreaticprofessionals.com","pandamail.tk","pandarastore.top","pandoradeals.com","pandoraonsalestore.com","pandostore.co","panel-admin.0rg.us","panelpros.gq","panelssd.com","pankujvats.com","pankx.cf","pankx.ga","pankx.ml","pankx.tk","panlvzhong.com","panopticsites.com","pantheonclub.info","pantheonstructures.com","paohetao.com","paosk.com","papa.foxtrot.ezbunko.top","papai.cf","papai.ga","papai.gq","papai.ml","papai.tk","papaparororo.com","papasha.net","papermakers.ml","papierkorb.me","paplease.com","papua-nedv.ru","papubar.pl","para2019.ru","parabellum.us","paradigmplumbing.com","paragvai-nedv.ru","paralet.info","paramail.cf","parampampam.com","parcel4.net","parelay.org","pareton.info","parfum-sell.ru","parfum-uray.ru","paridisa.cf","paridisa.ga","paridisa.gq","paridisa.ml","paridisa.tk","parisannonce.com","parisdentists.com","parisvipescorts.com","parkcrestlakewood.xyz","parkingaffiliateprogram.com","parkpulrulfland.xyz","parleasalwebp.zyns.com","parlimentpetitioner.tk","parolonboycomerun.com","parqueadero.work","partenariat.ru","partskyline.com","party4you.me","partyearrings.com","partyweddingdress.net","pascherairjordanchaussuresafr.com","pascherairjordanssoldes.com","pasenraaghous.xyz","passas7.com","passionhd18.info","passionwear.us","passive-income.tk","passives-einkommen.ga","passport11.com","passportholder.me","passthecpcexam.com","passtown.com","passw0rd.cf","passw0rd.ga","passw0rd.gq","passw0rd.ml","passw0rd.tk","password.colafanta.cf","password.nafko.cf","passwort.schwarzmail.ga","pastcraze.xyz","pastebinn.com","pastebitch.com","pastycarse.pl","pasukanganas.tk","patandlornaontwitter.com","pathtoig.com","patonce.com","patorodzina.pl","patriotsjersey-shop.com","patriotsprofanshop.com","patriotsproteamsshop.com","patriotssportshoponline.com","patzwccsmo.pl","pauikolas.tk","paulblogs.com","paulfucksallthebitches.com","paulkippes.com","paulsmithgift.com","paulsmithnihonn.com","paulsmithpresent.com","pavilionx2.com","pay-mon.com","pay-pal48996.ml","pay-pal55424.ml","pay-pal63.tk","pay-pal8585.ml","pay-pal8978746.tk","pay-pals.cf","pay-pals.ga","pay-pals.ml","pay-pals54647.cf","pay-pals5467.ml","payday-loans-since-1997.co.uk","paydayadvanceworld.co.uk","paydaycash750.com.co","paydaycic2013.co.uk","paydayinstantly.net","paydayjonny.net","paydaylaons.org","paydayloan.us","paydayloanaffiliate.com","paydayloanmoney.us","paydayloans.com","paydayloans.org","paydayloans.us","paydayloansab123.co.uk","paydayloansangely.co.uk","paydayloansbc123.co.uk","paydayloansonline1min.com","paydayloansonlinebro.com","paydayloansproviders.co.uk","paydayloanyes.biz","paydayoansangely.co.uk","paydaypoll.org","paydayquiduk.co.uk","payforclick.net","payforclick.org","payforpost.net","payforpost.org","payinapp.com","paylessclinic.com","paypal.comx.cf","payperex2.com","payspun.com","pazarlamadahisi.com","pb-shelley.cf","pb-shelley.ga","pb-shelley.gq","pb-shelley.ml","pb-shelley.tk","pb5g.com","pc-service-in-heidelberg.de","pc1520.com","pcaccessoriesshops.info","pcapsi.com","pcc.mailboxxx.net","pccareit.com","pccomputergames.info","pcfastkomp.com","pcgameans.ru","pcgamemart.com","pchatz.ga","pcijztufv1s4lqs.cf","pcijztufv1s4lqs.ga","pcijztufv1s4lqs.gq","pcijztufv1s4lqs.ml","pcijztufv1s4lqs.tk","pcixemftp.pl","pclaptopsandnetbooks.info","pcmylife.com","pcpccompik91.ru","pcusers.otherinbox.com","pd6badzx7q8y0.cf","pd6badzx7q8y0.ga","pd6badzx7q8y0.gq","pd6badzx7q8y0.ml","pd6badzx7q8y0.tk","pd7a42u46.pl","pdazllto0nc8.cf","pdazllto0nc8.ga","pdazllto0nc8.gq","pdazllto0nc8.ml","pdazllto0nc8.tk","pdcqvirgifc3brkm.cf","pdcqvirgifc3brkm.ga","pdcqvirgifc3brkm.gq","pdcqvirgifc3brkm.ml","pdcqvirgifc3brkm.tk","pddauto.ru","pdfpool.com","pdjkyczlq.pl","pdold.com","pdtdevelopment.com","pe.hu","pe19et59mqcm39z.cf","pe19et59mqcm39z.ga","pe19et59mqcm39z.gq","pe19et59mqcm39z.ml","pe19et59mqcm39z.tk","peace.mielno.pl","peacebuyeriacta10pills.com","peachcalories.net","peakkutsutenpojp.com","peaksneakerjapan.com","peapz.com","pearly-papules.com","pearlypenilepapulesremovalreview.com","pebkit.ga","pecdo.com","pecinan.com","pecinan.net","pecinan.org","pecmail.gq","pecmail.tk","pectcandtive.gettrials.com","pedalpatchcommunity.org","pedimed-szczecin.pl","peemanlamp.info","peepto.me","pegasus.metro.twitpost.info","pegellinux.ga","pegweuwffz.cf","pegweuwffz.ga","pegweuwffz.gq","pegweuwffz.ml","pegweuwffz.tk","pejovideomaker.tk","pekimail.com","pelecandesign.com","pelor.ga","pelor.tk","pemail.com","pencalc.xyz","pencap.info","pendokngana.cf","pendokngana.ga","pendokngana.gq","pendokngana.ml","pendokngana.tk","penest.bid","pengangguran.me","pengelan123.com","penguincreationdate.pw","penis.computer","penisenlargementbiblereview.org","penisenlargementshop.info","penisgoes.in","penisuzvetseni.com","pennyauctionsonlinereview.com","penoto.tk","penraker.com","pens4t.pl","pensjonatyprojekty.pl","penspam.com","penyewaanmobiljakarta.com","peopledrivecompanies.com","peoplehavethepower.cf","peoplehavethepower.ga","peoplehavethepower.gq","peoplehavethepower.ml","peoplehavethepower.tk","peoplepoint.ru","peoplepoliticallyright.com","pepbot.com","peppe.usa.cc","pepsi.coms.hk","perance.com","perasut.us","perdoklassniki.net","perdredupoids24.fr","perelinkovka.ipiurl.net","peresvetov.ru","perevozim78spb.ru","perfect-teen.com","perfect-u.pw","perfectcreamshop.com","perfectnetworksbd.com","perfectskinclub.com","perfectu.pw","perfromance.net","perillorollsroyce.com","peritusauto.pl","perjalanandinas.cf","perjalanandinas.ga","perjalanandinas.gq","perjalanandinas.ml","perjalanandinas.tk","perl.mil","permanentans.ru","pers.craigslist.org","persebaya1981.cf","persebaya1999.cf","personal-email.ml","personal-fitness.tk","personalcok.cf","personalcok.ga","personalcok.gq","personalcok.ml","personalcok.tk","personalenvelop.cf","personalinjuryclaimsadvice.com","personalizedussbsales.info","personalmailer.cf","perthusedcars.co.uk","peru-nedv.ru","perverl.co.cc","pesowuwzdyapml.cf","pesowuwzdyapml.ga","pesowuwzdyapml.gq","pesowuwzdyapml.ml","pesowuwzdyapml.tk","pet-care.com","peterdethier.com","peterschoice.info","petertijj.com","petitlien.fr","petrolgames.com","petronas.cf","petronas.gq","petrzilka.net","peugeot-club.org","peugeot206.cf","peugeot206.ga","peugeot206.gq","peugeot206.ml","pewnealarmy.pl","pexda.co.uk","peyzag.ru","pezhub.org","pezmail.biz","pfgvreg.com","pfui.ru","pg59tvomq.pl","pgazhyawd.pl","pgdln.cf","pgdln.ga","pgdln.gq","pgdln.ml","pgioa4ta46.ga","pgqudxz5tr4a9r.cf","pgqudxz5tr4a9r.ga","pgqudxz5tr4a9r.gq","pgqudxz5tr4a9r.ml","pgqudxz5tr4a9r.tk","pguar-t.com","phaantm.de","pharm-france.com","pharma-pillen.in","pharmacy-city.com","pharmacy-generic.org","pharmacy-online.bid","pharmacyshop.top","pharmasiana.com","pharmshop-online.com","phd-com.ml","phd-com.tk","phecrex.cf","phecrex.ga","phecrex.gq","phecrex.ml","phecrex.tk","phen375-help1.com","phen375.tv","phh6k4ob9.pl","philadelphiaflyerjerseyshop.com","philatelierevolutionfrancaise.com","philipsmails.pw","phillipsandtemro.com","philosophyquotes.org","phim68vn.com","phimg.org","phonam4u.tk","phone-elkey.ru","phoneaccessoriestips.info","phonearea.us","phonecalltracking.info","phonecasesforiphone.com","phonecasesforiphonestore.com","phongchongvirus.com","photo-impact.eu","photomark.net","phpbb.uu.gl","phpieso.com","phqobvrsyh.pl","phrase-we-had-to-coin.com","phuked.net","phuongblue1507.xyz","phuongpt9.tk","phuongsimonlazy.ga","phus8kajuspa.cu.cc","phymail.info","phymix.de","physicaltherapydegree.info","physicaltherapysalary.info","pi.vu","piaa.me","piaggio.cf","piaggio.ga","piaggio.gq","piaggio.ml","piaggioaero.cf","piaggioaero.ga","piaggioaero.gq","piaggioaero.ml","piaggioaero.tk","pianoxltd.com","piba.info","picandcomment.com","picfame.com","pichosti.info","pickadulttoys.com","picklez.org","picknameme.fun","pickyourmail.info","picture-movies.com","pictureframe1.com","pid.mx","pidmail.com","pieknybiust.com.pl","pietergroup.com","pietershop.com","piewish.com","pig.pp.ua","pigeon-mail.bid","pigeonmail.bid","piggywiggy22.info","pii.at","pika.pc486.net","piki.si","pikirkumu.cf","pikirkumu.ga","pikirkumu.gq","pikirkumu.ml","pikos.online","pilazzo.ru","pilios.com","pillen-fun-shop.com","pillole-blu.com","pillole-it.com","pillsbreast.info","pillsellr.com","pillsshop.info","pillsvigra.info","pilpres2018.ga","pilpres2018.ml","pilpres2018.tk","pimpedupmyspace.com","pimples.com","pimpmystic.com","pin-fitness.com","pinafh.ml","pinamail.com","pinbookmark.com","pincoffee.com","pinehill-seattle.org","pinemaile.com","pingbloggereidan.com","pingextreme.com","pingir.com","pingxtreme.com","pinkfrosting.com.au","pinkgifts.ru","pinkinbox.org","pinknbo.cf","pinknbo.ga","pinknbo.gq","pinknbo.ml","pinsmigiterdisp.xyz","pintermail.com","pio21.pl","piocvxasd321.info","pipi.net","pippop.cf","pippopmig33.cf","pippopmigme.cf","pippuzzo.gq","piratedgiveaway.ml","piromail.com","pisakii.pl","pisceans.co.uk","pisdapoolamoe.com","piseliger.xyz","pisls.com","pisqopli.com","pitamail.info","pitaniezdorovie.ru","piter-nedv.ru","pitkern-nedv.ru","piuminimoncler2013italia.com","piuminimoncler2013spaccio.com","piusmbleee49hs.cf","piusmbleee49hs.ga","piusmbleee49hs.gq","piusmbleee49hs.ml","piusmbleee49hs.tk","pivo-bar.ru","pixdoudounemoncler.com","pixelrate.info","pizzanadiapro.website","pizzanewcas.eu","pj12l3paornl.cf","pj12l3paornl.ga","pj12l3paornl.gq","pj12l3paornl.ml","pj12l3paornl.tk","pjbals.co.pl","pjbpro.com","pji40o094c2abrdx.cf","pji40o094c2abrdx.ga","pji40o094c2abrdx.gq","pji40o094c2abrdx.ml","pji40o094c2abrdx.tk","pjjkp.com","pjmanufacturing.com","pkcabyr.cf","pkcabyr.ml","pkwccarbnd.pl","pkwreifen.org","pkwt.luk2.com","pkykcqrruw.pl","pl-praca.com","pl85s5iyhxltk.cf","pl85s5iyhxltk.ga","pl85s5iyhxltk.gq","pl85s5iyhxltk.ml","pl85s5iyhxltk.tk","placebod.com","placemail.online","placeright.ru","planchas-ghd.org","planchasghdy.com","plancul2013.com","planet-travel.club","planowaniewakacji.pl","plastikmed.com","plateapanama.com","plates4skates2.info","platinumalerts.com","plavixprime.com","playcard-semi.com","player-midi.info","players501.info","playtell.us","pleasegoheretofinish.com","pleasenoham.org","plecmail.ml","plesniaks.com.pl","plexolan.de","plez.org","plgbgus.ga","plgbgus.ml","plhk.ru","plhosting.pl","plitkagranit.com","ploae.com","plollpy.edu","plotwin.xyz","plrdn.com","pluggedinsocial.net","plumberjerseycity.info","plumberplainfieldnj.info","plumbingpackages.com","plumblandconsulting.co.uk","plus-size-promdresses.com","plusgmail.ru","plusmail.cf","plusonefactory.com","plussizecorsets4sale.com","plutocow.com","plutofox.com","plw.me","plymouthrotarynh.org","plyty-betonowe.com.pl","pmlep.de","pmriverside.com","pmsvs.com","pmtmails.com","pndan.com","pnew-purse.com","pnpbiz.com","pnvp7zmuexbqvv.cf","pnvp7zmuexbqvv.ga","pnvp7zmuexbqvv.gq","pnvp7zmuexbqvv.ml","pnvp7zmuexbqvv.tk","po-telefonu.net","po.bot.nu","po.com","poalmail.ga","pob9.pl","pochta2018.ru","pochtamt.ru","pochtar.men","pochtar.top","pocketslotz.co","poclickcassx.com","poczta.pl","pocztaaonet.pl","pocztex.ovh","poczxneolinka.info","poczxneolinkc.info","podam.pl","podarbuke.ru","podatnik.info","podgladaczgoogle.pl","podkarczowka.pl","poegal.ru","poehali-otdihat.ru","poers.com","poesie-de-nuit.com","poetrysms.in","poetrysms.org","poh.pp.ua","poioijnkjb.cf","poioijnkjb.ml","poiopuoi568.info","poisontech.net","poiuweqw2.info","pojok.ml","pokeett.site","pokegofast.com","pokemail.net","pokemonbattles.science","poker-texas.com.pl","pokerbonuswithoutdeposit.com","pokercash.org","pokersdating.info","pokesmail.xyz","pokeymoms.org","pokiemobile.com","pokrowcede.pl","poky.ro","polacy-dungannon.tk","polameaangurata.com","poland-nedv.ru","polaris-280.com","polarkingxx.ml","polatalemdar.com","polen-ostsee-ferienhaus.de","polezno2012.com","polimatsportsp.com","polimi.ml","polioneis-reborb.com","polishbs.pl","polishxwyb.com","politikerclub.de","poliusraas.tk","polkadot.tk","polkaidot.ml","pollgirl.org","polljonny.org","polobacolono.com","polohommefemmee2.com","polol.com","polopasdcheres.com","polopashcheres.com","polopasqchere7.com","poloralphlaurenjacket.org","poloralphlaurenpascheresfrancefr.com","poloralphlaurenpascherfr1.com","polosburberry.com","polosiekatowice.pl","polres-aeknabara.cf","poltawa.ru","poly-swarm.com","polyace.ru","polyfaust.com","polygami.pl","polymnestore.co","polyswarms.com","pomorscyprzedsiebiorcy.pl","pompanette.maroonsea.com","pomyslnaatrakcjedladzieci.pl","pomysloneo.net","pomyslynabiznes.net","ponp.be","pooae.com","pooasdod.com","poofy.org","pookmail.com","poolameafrate.com","poolemail.men","poopiebutt.club","pop-newpurse.com","pop.pozycjonowanie8.pl","pop2011email.co.tv","pop3.xyz","pop3email.cz.cc","pop3mail.cz.cc","popa-mopa.ru","popcanadagooseoutlet.com","popconn.party","popemailwe.com","popesodomy.com","popgx.com","popherveleger.com","popmail.io","popmaildf.com","popmailserv.org","popmailset.com","popmailset.org","popolo.waw.pl","poppell.eu","poppellsimsdsaon.eu","poppunk.pl","popso.cf","popso.ga","popso.gq","popso.ml","popso.tk","popsok.cf","popsok.ga","popsok.gq","popsok.ml","popsok.tk","popteen4u.com","popularbagblog.com","popularjackets.info","popularmotorcycle.info","popularswimwear.info","popuza.net","porarriba.com","porchauhodi.org","porco.cf","porco.ga","porco.gq","porco.ml","poreglot.ru","porevoorevo.co.cc","porilo.com","porkinjector.info","porn-movies.club","pornfreefiles.com","pornizletr.com","porno-man.com","porno-prosto.ru","porno-sex-video.net","pornoclipskostenlos.net","pornomors.info","pornopopki.com","pornoseti.com","pornosexe.biz","pornosiske.com","porororebus.top","porsh.net","porta.loyalherceghalom.ml","portablespins.co","portal-finansowy.com.pl","portal-internetowo-marketingowy.pl","portal-marketingowy.pl","portal-ogloszeniowy-24.pl","portalsehat.com","portalvideo.info","portalweb.icu","porterbraces.com","portigalconsulting.com","portocalamecanicalor.com","portocalelele.com","portu-nedv.ru","posdz.com","posicionamientowebmadrid.com.es","post-box.in","post-box.xyz","post-mail-server.com","post.melkfl.es","post.mydc.in.ua","post0.profimedia.net","posta.store","posta2015.ml","postacin.com","postalmail.biz","postcardsfromukraine.crowdpress.it","postemail.net","postermanderson.com","postfach2go.de","posthectomie.info","postnasaldripbadbreath.com","postonline.me","postupstand.com","posurl.ga","posvabotma.x24hr.com","potarveris.xyz","potrawka.eu","pottattemail.xyz","pouet.xyz","poutineyourface.com","povorotov.ru","power-leveling-service.com","powerdast.ru","powered.name","powerencry.com","powerlink.com.np","powerml.racing","powers-balances.ru","powiekszaniepenisaxxl.pl","powlearn.com","poy.kr","poyrtsrxve.pl","pozitifff.com","pozycja-w-google.com","pozycjanusz.pl","pozycjonowanie-2015.pl","pozycjonowanie-jest-ok.pl","pozycjonowanie-stron-szczecin.top","pozycjonowanie.com","pozycjonowanie.com.pl","pozycjonowanie56.pl","pozycjonowaniekielce.pl","pozycjonowanieopole.net","pozyczka-provident.info","pozyczkabezbik24.com.pl","pozyczkasms24.com.pl","pozyczkigotowkowewuk.com.pl","pozyczkiinternetowechwilowki.com.pl","pozyczkiprywatne24.net","pozyczkiwuk.com.pl","pozyjo.eu","pp.ua","pp98.cf","pp98.ga","pp98.gq","pp98.ml","pp98.tk","ppabldwzsrdfr.cf","ppabldwzsrdfr.ga","ppabldwzsrdfr.gq","ppabldwzsrdfr.ml","ppabldwzsrdfr.tk","ppbanr.com","ppbk.ru","ppbomail.com","ppc-e.com","ppetw.com","ppgu8mqxrmjebc.ga","ppgu8mqxrmjebc.gq","ppgu8mqxrmjebc.ml","ppgu8mqxrmjebc.tk","ppmoazqnoip2s.cf","ppmoazqnoip2s.ga","ppmoazqnoip2s.gq","ppmoazqnoip2s.ml","ppymail.win","ppz.pl","pq6fbq3r0bapdaq.cf","pq6fbq3r0bapdaq.ga","pq6fbq3r0bapdaq.gq","pq6fbq3r0bapdaq.ml","pq6fbq3r0bapdaq.tk","pqoia.com","pqoss.com","pqtoxevetjoh6tk.cf","pqtoxevetjoh6tk.ga","pqtoxevetjoh6tk.gq","pqtoxevetjoh6tk.ml","pqtoxevetjoh6tk.tk","pr1ngsil4nmu.ga","prada-bags-outlet.org","prada-shoes.info","pradabagsalejp.com","pradabagshopjp.com","pradabagstorejp.com","pradabagstorejp.org","pradabuyjp.com","pradahandbagsrjp.com","pradahotonsale.com","pradajapan.com","pradajapan.org","pradajapan.orgpradajapan.orgpradajapan.orgpradajapan.orgpradajapan.orgpradajapan.orgpradajapan.orgpradajapan.orgpradajapan.org","pradanewjp.com","pradanewjp.org","pradanewstyle.com","pradaoutletonline.us","pradaoutletpop.com","pradaoutletshopjp.com","pradaoutletus.us","pradapursejp.com","pradapursejp.org","pramolcroonmant.xyz","pravorobotov.ru","pray.agencja-csk.pl","prayersa3.com","prazdnik-37.ru","predatorrat.cf","predatorrat.ga","predatorrat.gq","predatorrat.ml","predatorrat.tk","prediksibola88.com","prednestr-nedv.ru","prefood.ru","pregnan.ru","pregnancymiraclereviewnow.org","pregnancymiraclereviews.info","preklady-polstina.cz","prekuldown47mmi.ml","premierpainandwellness.com","premiertrafficservices.com","premium-mail.fr","premium4pets.info","premiumail.ml","premiumgreencoffeereview.com","premiumperson.website","premiumseoservices.net","preorderdiablo3.com","preparee.top","prescription-swimming-goggles.info","preseven.com","presidency.com","preskot.info","prespa.mochkamieniarz.pl","prespaprespa.e90.biz","pressbypresser.info","pressreleasedispatcher.com","prestamospersonales.nom.es","prestore.co","pretans.com","prethlah907huir.cf","prettyishlady.com","prettyishlady.net","previos.com","pricebit.co","priceblog.co","priceio.co","pricenew.co","pricenow.co","priceonline.co","pricepage.co","priceworld.co","pride.nafko.cf","priest.com","priligyonlineatonce.com","priligyonlinesure.com","priligyprime.com","primabananen.net","primalburnkenburge.com","primecialisonline.com","primelocationlets.co.uk","primerka.co.cc","primonet.pl","prin.be","prince-khan.tk","princeroyal.net","princesscutengagementringsinfo.info","princeton-edu.com","princeton.edu.pl","principlez.com","pringlang.cf","pringlang.ga","pringlang.gq","pringlang.ml","printersni.co.uk","printf.cf","printf.ga","printf.ml","printphotos.ru","priokfl.gr","prioritypaydayloans.com","priorityxn5.com","prisessifor.xyz","prismlasers.tk","priv.beastemail.com","privacy.net","privacymailshh.com","privatdemail.net","private.kubuntu.myhomenetwork.info","private33.com","privatebag.ml","privateclosets.com","privateinvest.me","privatemail.in","privatemailinator.nl","privatemitel.cf","privatemitel.ml","privatesent.tk","privmag.com","privy-mail.com","privy-mail.de","privymail.de","prlinkjuicer.info","prmail.top","pro-expert.online","pro-files.ru","pro-tag.org","pro.cloudns.asia","pro.iskba.com","pro100sp.ru","pro2mail.net","probaseballfans.net","probbox.com","probizemail.com","probowlvoting.info","probowlvoting2011.info","procrackers.com","prodaza-avto.kiev.ua","prodigysolutionsgroup.net","productdealsonline.info","productemails.info","producti-online-pro.com","production4you.ru","proeasyweb.com","proefhhnwtw.pl","proexpertonline.ru","profast.top","profcsn.eu","profeocn.pl","profeocnn.pl","profesjonalne-pozycjonowanie.com","professionalseoservicesuk.com","professionneldumail.com","profile3786.info","profilelinkservices.com","profilific.com","profit-kopiarki.com","profit-pozycjonowanie.pl","profit.idea-profit.pl","profitcheetah.com","profitindex.ru","profitxtreme.com","progem.pl","progetti.rs","progiftstore.org","progonrumarket.ru","progps.rs","programacomoemagrecer.org","programmaperspiarecellulari.info","programmeimmobilier-neuf.org","programmerov.net","programmingant.com","programmiperspiarecellulari.info","programmispiapercellulari.info","programpit2013rok.pl","programtv.edu.pl","progrespolska.net","project-xhabbo.com","projectcl.com","projectgold.ru","projectmike.pl","projector-replacement-lamp.info","projectred.ru","projectsam.net","projekty.com","projektysamochodowe.pl","prolagu.pro","prolifepowerup.com","promail.net","promail.site","promails.xyz","promdresses-short.com","promenadahotel.pl","promkat.info","promocjawnecie.pl","promotime.com","promotion-seo.net","promotionalcoder.com","promotzy.com","promptly700.com","promyscandlines.pl","proofcamping.com","propcleaners.com","propeciaonlinesure.com","propeciaonlinesureone.com","propertyhotspot.co.uk","propgenie.com","propoker.vn","proprice.co","proprietativalcea.ro","propscore.com","prorefit.eu","proscaronlinesure.com","proscarprime.com","proseriesm.info","proshopnflfalcons.com","proshopnflravens.com","proshopsf49ers.com","proslowo.home.pl","prosmail.info","prosolutiongelreview.net","prosolutionpillsreviews.org","proste-przetargi.pl","prostitutki-s-p-b.ru","protection-0ffice365.com","protectthechildsman.com","protectyourhealthandwealth.com","protempmail.com","protestant.com","protestore.co","protipsters.net","protivirus.ru","proto2mail.com","protonemach.waw.pl","protrendcolorshop.com","provident-pl.info","providentwniosek.info","providentwnioski.pl","providier.com","provmail.net","prow.cf","prow.ga","prow.gq","prow.ml","prowessed.com","prowickbaskk.com","proxivino.com","proxsei.com","proxy.dreamhost.com","proxy1.pro","proxymail.eu","proxyparking.com","prplunder.com","prs7.xyz","prtnews.com","prtnx.com","prtxw.com","prtz.eu","prumrstef.pl","prwmqbfoxdnlh8p4z.cf","prwmqbfoxdnlh8p4z.ga","prwmqbfoxdnlh8p4z.gq","prwmqbfoxdnlh8p4z.ml","prwmqbfoxdnlh8p4z.tk","prxnzb4zpztlv.cf","prxnzb4zpztlv.ga","prxnzb4zpztlv.gq","prxnzb4zpztlv.ml","prxnzb4zpztlv.tk","pryeqfqsf.pl","prywatnebiuro.pl","przeciski.ovh","przepis-na-pizze.pl","przeprowadzam.eu","przezsms.waw.pl","przyklad-domeny.pl","ps160.mpm-motors.cf","ps2emulatorforpc.co.cc","psacake.me","psccodefree.com","psettinge5.com","pseudoname.io","psh.me","psicanalisi.org","psiek.com","psikus.pl","psirens.icu","psles.com","psncodegeneratorsn.com","pso2rmt.com","psoriasisfreeforlifediscount.org","psoxs.com","pspinup.com","pspvitagames.info","psyans.ru","psychedelicwarrior.xyz","psychiatragabinet.pl","psycho.com","psychodeli.co.uk","psyiszkolenie.com","psymedic.ru","psymejsc.pl","ptc.vuforia.us","ptcassino.com","ptcks1ribhvupd3ixg.cf","ptcks1ribhvupd3ixg.ga","ptcks1ribhvupd3ixg.gq","ptcks1ribhvupd3ixg.ml","ptcks1ribhvupd3ixg.tk","ptcsites.in","pterodactyl.email","ptgtar7lslnpomx.ga","ptgtar7lslnpomx.ml","ptgtar7lslnpomx.tk","ptimesmail.com","ptjdthlu.pl","ptpigeaz0uorsrygsz.cf","ptpigeaz0uorsrygsz.ga","ptpigeaz0uorsrygsz.gq","ptpigeaz0uorsrygsz.ml","ptpigeaz0uorsrygsz.tk","ptpomorze.com.pl","puapickuptricksfanboy.com","puaqbqpru.pl","pub-mail.com","puberties.com","puberties.net","pubgeresnrpxsab.cf","pubgeresnrpxsab.ga","pubgeresnrpxsab.gq","pubgeresnrpxsab.ml","pubgeresnrpxsab.tk","pubgm.website","publi.innovatio.es","publicadjusterinfo.com","pubmail886.com","pubs.ga","pubwarez.com","puchmlt0mt.ga","puchmlt0mt.gq","puchmlt0mt.tk","pudel.in","puds5k7lca9zq.cf","puds5k7lca9zq.ga","puds5k7lca9zq.gq","puds5k7lca9zq.ml","puds5k7lca9zq.tk","puebloareaihn.org","puegauj.pl","puerto-nedv.ru","puglieisi.com","puh4iigs4w.cf","puh4iigs4w.ga","puh4iigs4w.gq","puh4iigs4w.ml","puh4iigs4w.tk","puibagajunportbagaj.com","puikusmases.info","puji.pro","puk.us.to","pukimay.cf","pukimay.ga","pukimay.gq","pukimay.ml","pukimay.tk","pullcombine.com","pulpmail.us","pulwarm.net","pumail.com","pumamaning.cf","pumamaning.ml","pumapumayes.cf","pumapumayes.ml","pumasale-uk.com","pumashopkutujp.com","pump-ltd.ru","pumps-fashion.com","pumpwearil.com","puncakyuk.com","punchyandspike.com","punggur.tk","pungkiparamitasari.com","punishly.com","punkass.com","punkexpo.com","punto24.com.pl","puouadtq.pl","purcell.email","purecollagenreviews.net","puregreencleaning.com.au","puregreencoffeefacts.com","purelogistics.org","puremuscleproblogs.com","puressancereview.com","purewhitekidneyx.org","purificadorasmex1.com.mx","puritronicde.com.mx","puritronicdemexico.com.mx","puritronicmexicano.com.mx","puritronicmexico.com.mx","puritronicmx.com.mx","puritronicmx2.com.mx","puritronicmxococo2.com.mx","puritunic.com","purixmx2000.com","purixmx2012.com","purple.flu.cc","purple.igg.biz","purple.nut.cc","purple.usa.cc","purplemail.ga","purplemail.gq","purplemail.ml","purplemail.tk","purselongchamp.net","purseorganizer.me","pursesoutletsale.com","pursesoutletstores.info","purseva11ey.co","purtunic.com","pushmojo.com","put2.net","putdomainhere.com","putfs6fbkicck.cf","putfs6fbkicck.ga","putfs6fbkicck.gq","putfs6fbkicck.ml","putfs6fbkicck.tk","puttana.cf","puttana.ga","puttana.gq","puttana.ml","puttana.tk","puttanamaiala.tk","putzmail.pw","puyenkgel50ccb.ml","pvcstreifen-vorhang.de","pvdprohunter.info","pw-mail.cf","pw-mail.ga","pw-mail.gq","pw-mail.ml","pw-mail.tk","pw.epac.to","pw.flu.cc","pw.igg.biz","pw.islam.igg.biz","pw.j7.cloudns.cx","pw.loyalherceghalom.ml","pw.mymy.cf","pw.mysafe.ml","pw.nut.cc","pw.r4.dns-cloud.net","pwfwtgoxs.pl","pwjsdgofya4rwc.cf","pwjsdgofya4rwc.ga","pwjsdgofya4rwc.gq","pwjsdgofya4rwc.ml","pwjsdgofya4rwc.tk","pwkosz.pl","pwodskdf.com","pwodskdf.net","pwp.lv","pwrby.com","pwt9azutcao7mi6.ga","pwt9azutcao7mi6.ml","pwt9azutcao7mi6.tk","pwvoyhajg.pl","pwy.pl","px0dqqkyiii9g4fwb.cf","px0dqqkyiii9g4fwb.ga","px0dqqkyiii9g4fwb.gq","px0dqqkyiii9g4fwb.ml","px0dqqkyiii9g4fwb.tk","px1.pl","px9ixql4c.pl","pxddcpf59hkr6mwb.cf","pxddcpf59hkr6mwb.ga","pxddcpf59hkr6mwb.gq","pxddcpf59hkr6mwb.ml","pxddcpf59hkr6mwb.tk","pyffqzkqe.pl","pyiauje42dysm.cf","pyiauje42dysm.ga","pyiauje42dysm.gq","pyiauje42dysm.ml","pyiauje42dysm.tk","pylehome.com","pymehosting.es","pyrokiwi.xyz","pyroleech.com","pyromail.info","pzu.bz","q.new-mgmt.ga","q.polosburberry.com","q.xtc.yt","q0bcg1druy.ga","q0bcg1druy.ml","q0bcg1druy.tk","q2gfiqsi4szzf54xe.cf","q2gfiqsi4szzf54xe.ga","q2gfiqsi4szzf54xe.gq","q2gfiqsi4szzf54xe.ml","q2gfiqsi4szzf54xe.tk","q2lofok6s06n6fqm.cf","q2lofok6s06n6fqm.ga","q2lofok6s06n6fqm.gq","q2lofok6s06n6fqm.ml","q2lofok6s06n6fqm.tk","q314.net","q4heo7ooauboanqh3xm.cf","q4heo7ooauboanqh3xm.ga","q4heo7ooauboanqh3xm.gq","q4heo7ooauboanqh3xm.ml","q4heo7ooauboanqh3xm.tk","q5prxncteag.cf","q5prxncteag.ga","q5prxncteag.gq","q5prxncteag.ml","q5prxncteag.tk","q5vm7pi9.com","q65pk6ii.targi.pl","q6suiq1aob.cf","q6suiq1aob.ga","q6suiq1aob.gq","q6suiq1aob.ml","q6suiq1aob.tk","q7t43q92.com","q7t43q92.com.com","q8cbwendy.com","q8ec97sr791.cf","q8ec97sr791.ga","q8ec97sr791.gq","q8ec97sr791.ml","q8ec97sr791.tk","q8fqrwlxehnu.cf","q8fqrwlxehnu.ga","q8fqrwlxehnu.gq","q8fqrwlxehnu.ml","q8fqrwlxehnu.tk","q8i4v1dvlsg.ga","q8i4v1dvlsg.ml","q8i4v1dvlsg.tk","q8z.ru","qa.team","qablackops.com","qacquirep.com","qaetaldkgl64ygdds.gq","qafatwallet.com","qafrem3456ails.com","qaioz.com","qasd2qgznggjrl.cf","qasd2qgznggjrl.ga","qasd2qgznggjrl.ml","qasd2qgznggjrl.tk","qasti.com","qatqxsify.pl","qazulbaauct.cf","qazulbaauct.ga","qazulbaauct.gq","qazulbaauct.ml","qazulbaauct.tk","qb04x4.badcreditcreditcheckpaydayloansloansloanskjc.co.uk","qb23c60behoymdve6xf.cf","qb23c60behoymdve6xf.ga","qb23c60behoymdve6xf.gq","qb23c60behoymdve6xf.ml","qb23c60behoymdve6xf.tk","qbaydx2cpv8.cf","qbaydx2cpv8.ga","qbaydx2cpv8.gq","qbaydx2cpv8.ml","qbaydx2cpv8.tk","qbex.pl","qbfree.us","qbgmvwojc.pl","qbi.kr","qbikgcncshkyspoo.cf","qbikgcncshkyspoo.ga","qbikgcncshkyspoo.gq","qbikgcncshkyspoo.ml","qbikgcncshkyspoo.tk","qbmail.bid","qbqbtf4trnycocdg4c.cf","qbqbtf4trnycocdg4c.ga","qbqbtf4trnycocdg4c.gq","qbqbtf4trnycocdg4c.ml","qbuog1cbktcy.cf","qbuog1cbktcy.ga","qbuog1cbktcy.gq","qbuog1cbktcy.ml","qbuog1cbktcy.tk","qc.to","qc0lipw1ux.cf","qc0lipw1ux.ga","qc0lipw1ux.ml","qc0lipw1ux.tk","qcmail.qc.to","qcvsziiymzp.edu.pl","qdrwriterx.com","qe41hqboe4qixqlfe.gq","qe41hqboe4qixqlfe.ml","qe41hqboe4qixqlfe.tk","qeabluqwlfk.agro.pl","qeaxluhpit.pl","qedwardr.com","qefmail.com","qeispacesq.com","qeotxmwotu.cf","qeotxmwotu.ga","qeotxmwotu.gq","qeotxmwotu.ml","qeotxmwotu.tk","qepn5bbl5.pl","qeqrtc.ovh","qewaz21.eu","qewzaqw.com","qf1tqu1x124p4tlxkq.cf","qf1tqu1x124p4tlxkq.ga","qf1tqu1x124p4tlxkq.gq","qf1tqu1x124p4tlxkq.ml","qf1tqu1x124p4tlxkq.tk","qfhh3mmirhvhhdi3b.cf","qfhh3mmirhvhhdi3b.ga","qfhh3mmirhvhhdi3b.gq","qfhh3mmirhvhhdi3b.ml","qfhh3mmirhvhhdi3b.tk","qfrsxco1mkgl.ga","qfrsxco1mkgl.gq","qfrsxco1mkgl.ml","qg8zn7nj8prrt4z3.cf","qg8zn7nj8prrt4z3.ga","qg8zn7nj8prrt4z3.gq","qg8zn7nj8prrt4z3.ml","qg8zn7nj8prrt4z3.tk","qgfkslkd1ztf.cf","qgfkslkd1ztf.ga","qgfkslkd1ztf.gq","qgfkslkd1ztf.ml","qhexkgvyv.pl","qhrgzdqthrqocrge922.cf","qhrgzdqthrqocrge922.ga","qhrgzdqthrqocrge922.gq","qhrgzdqthrqocrge922.ml","qhrgzdqthrqocrge922.tk","qhstreetr.com","qhwclmql.pl","qianaseres.com","qiaua.com","qibl.at","qinicial.ru","qip-file.tk","qipmail.net","qiq.us","qirzgl53rik0t0hheo.cf","qirzgl53rik0t0hheo.ga","qirzgl53rik0t0hheo.gq","qirzgl53rik0t0hheo.ml","qirzgl53rik0t0hheo.tk","qisdo.com","qisoa.com","qiviamd.pl","qj97r73md7v5.com","qjnnbimvvmsk1s.cf","qjnnbimvvmsk1s.ga","qjnnbimvvmsk1s.gq","qjnnbimvvmsk1s.ml","qjnnbimvvmsk1s.tk","qjuhpjsrv.pl","qkbzptliqpdgeg.cf","qkbzptliqpdgeg.ga","qkbzptliqpdgeg.gq","qkbzptliqpdgeg.ml","qkbzptliqpdgeg.tk","qkw4ck7cs1hktfba.cf","qkw4ck7cs1hktfba.ga","qkw4ck7cs1hktfba.gq","qkw4ck7cs1hktfba.ml","qkw4ck7cs1hktfba.tk","ql2qs7dem.pl","ql9yzen3h.pl","qlhnu526.com","qlijgyvtf.pl","qluiwa5wuctfmsjpju.cf","qluiwa5wuctfmsjpju.ga","qluiwa5wuctfmsjpju.gq","qluiwa5wuctfmsjpju.ml","qmail.com","qmails.loan","qmails.online","qmails.pw","qmails.services","qmails.website","qmails.world","qmails.xyz","qmailtgs.com","qmoil.com","qmperehpsthiu9j91c.ga","qmperehpsthiu9j91c.ml","qmperehpsthiu9j91c.tk","qmtvchannel.co.uk","qmwparouoeq0sc.cf","qmwparouoeq0sc.ga","qmwparouoeq0sc.gq","qmwparouoeq0sc.ml","qmwparouoeq0sc.tk","qn5egoikcwoxfif2g.cf","qn5egoikcwoxfif2g.ga","qn5egoikcwoxfif2g.gq","qn5egoikcwoxfif2g.ml","qn5egoikcwoxfif2g.tk","qnb.io","qnkznwsrwu3.cf","qnkznwsrwu3.ga","qnkznwsrwu3.gq","qnkznwsrwu3.ml","qnkznwsrwu3.tk","qnuqgrfujukl2e8kh3o.cf","qnuqgrfujukl2e8kh3o.ga","qnuqgrfujukl2e8kh3o.gq","qnuqgrfujukl2e8kh3o.ml","qnuqgrfujukl2e8kh3o.tk","qnzkugh2dhiq.cf","qnzkugh2dhiq.ga","qnzkugh2dhiq.gq","qnzkugh2dhiq.ml","qnzkugh2dhiq.tk","qocya.com","qoika.com","qoiolo.com","qonmprtxz.pl","qoo-10.id","qopmail.com","qopxlox.com","qorikan.com","qp-tube.ru","qpalong.com","qpi8iqrh8wtfpee3p.ga","qpi8iqrh8wtfpee3p.ml","qpi8iqrh8wtfpee3p.tk","qpptplypblyp052.cf","qpulsa.com","qq.my","qq152.com","qq163.com","qq164.com","qq234.com","qq323.com","qq568.top","qq8hc1f9g.pl","qqaa.com","qqaa.zza.biz","qqipgthtrlm.cf","qqipgthtrlm.ga","qqipgthtrlm.gq","qqipgthtrlm.ml","qqipgthtrlm.tk","qqqwwwil.men","qqwtrnsqdhb.edu.pl","qqzymail.win","qropspensionadvice.com","qropspensiontransfers.com","qrudh.win","qrvdkrfpu.pl","qs.dp76.com","qs1986.com","qs2k.com","qsdqsdqd.com","qsdt.com","qsl.ro","qt1.ddns.net","qtc.org","qtfxtbxudvfvx04.cf","qtfxtbxudvfvx04.ga","qtfxtbxudvfvx04.gq","qtfxtbxudvfvx04.ml","qtfxtbxudvfvx04.tk","qtlhkpfx3bgdxan.cf","qtlhkpfx3bgdxan.ga","qtlhkpfx3bgdxan.gq","qtlhkpfx3bgdxan.ml","qtlhkpfx3bgdxan.tk","qtmail.org","qtmtxzl.pl","qtpxsvwifkc.cf","qtpxsvwifkc.ga","qtpxsvwifkc.gq","qtpxsvwifkc.ml","qtpxsvwifkc.tk","qtum-ico.com","quadrafit.com","quaestore.co","qualityimpres.com","qualityservice.com","quanaothethao.com","quangcaoso1.net","quanthax.com","quantsoftware.com","qubecorp.tk","quebec.alpha.webmailious.top","quebec.victor.webmailious.top","quebecdelta.101livemail.top","quebecgolf.livemailbox.top","quebecupsilon.thefreemail.top","queeejkdfg7790.cf","queeejkdfg7790.ga","queeejkdfg7790.gq","queeejkdfg7790.ml","queeejkdfg7790.tk","queensbags.com","quequeremos.com","querydirect.com","questore.co","queuem.com","qui-mail.com","qui2-mail.com","quiba.pl","quichebedext.freetcp.com","quick-mail.club","quick-mail.info","quick-mail.online","quickbookstampa.com","quickcash.us","quickemail.info","quickemail.top","quickestloans.co.uk","quickinbox.com","quickloans.com","quickloans.us","quickloans560.co.uk","quicklymail.info","quickmail.best","quickmail.in","quickmail.nl","quickmail.rocks","quickpaydayloansuk34.co.uk","quickreport.it","quickresponsecanada.info","quid4pro.com","quintalaescondida.com","quintania.top","quitsmokinghelpfulguide.net","quitsmokingmanyguides.net","ququb.com","quuradminb.com","quxppnmrn.pl","qvap.ru","qvarqip.ru","qvestmail.com","qvy.me","qwarmingu.com","qweazcc.com","qweewqrtr.info","qwefaswee.com","qwefewtata.com","qwekssxt6624.cf","qwekssxt6624.ga","qwekssxt6624.gq","qwekssxt6624.ml","qwekssxt6624.tk","qwereed.eu","qwerqwerty.ga","qwerqwerty.ml","qwerqwerty.tk","qwertaz.com","qwertymail.cf","qwertymail.ga","qwertymail.gq","qwertymail.ml","qwertymail.tk","qwertyuiop.tk","qwerytr978.info","qwexaqwe.com","qwezxsa.co.uk","qwfox.com","qwickmail.com","qwkcmail.com","qwkcmail.net","qwqrwsf.date","qwrezasw.com","qwsa.ga","qwtof1c6gewti.cf","qwtof1c6gewti.ga","qwtof1c6gewti.gq","qwtof1c6gewti.ml","qwtof1c6gewti.tk","qxlvqptiudxbp5.cf","qxlvqptiudxbp5.ga","qxlvqptiudxbp5.gq","qxlvqptiudxbp5.ml","qxlvqptiudxbp5.tk","qxpaperk.com","qyx.pl","qzbdlapps.shop.pl","qzdynxhzj71khns.cf","qzdynxhzj71khns.gq","qzdynxhzj71khns.ml","qzdynxhzj71khns.tk","qztc.edu","qzvbxqe5dx.cf","qzvbxqe5dx.ga","qzvbxqe5dx.gq","qzvbxqe5dx.ml","qzvbxqe5dx.tk","r-mail.cf","r-mail.ga","r-mail.gq","r-mail.ml","r.polosburberry.com","r.yasser.ru","r0.igg.biz","r0ywhqmv359i9cawktw.cf","r0ywhqmv359i9cawktw.ga","r0ywhqmv359i9cawktw.gq","r0ywhqmv359i9cawktw.ml","r0ywhqmv359i9cawktw.tk","r115pwhzofguwog.cf","r115pwhzofguwog.ga","r115pwhzofguwog.gq","r115pwhzofguwog.ml","r115pwhzofguwog.tk","r18udogyl.pl","r1qaihnn9wb.cf","r1qaihnn9wb.ga","r1qaihnn9wb.gq","r1qaihnn9wb.ml","r1qaihnn9wb.tk","r2cakes.com","r2vw8nlia9goqce.cf","r2vw8nlia9goqce.ga","r2vw8nlia9goqce.gq","r2vw8nlia9goqce.ml","r2vw8nlia9goqce.tk","r2vxkpb2nrw.cf","r2vxkpb2nrw.ga","r2vxkpb2nrw.gq","r2vxkpb2nrw.ml","r2vxkpb2nrw.tk","r3-r4.tk","r31s4fo.com","r3hyegd84yhf.cf","r3hyegd84yhf.ga","r3hyegd84yhf.gq","r3hyegd84yhf.ml","r3hyegd84yhf.tk","r4-3ds.ca","r4.dns-cloud.net","r4carta.eu","r4carte3ds.com","r4carte3ds.fr","r4ds-ds.com","r4ds.com","r4dscarte.fr","r4gmw5fk5udod2q.cf","r4gmw5fk5udod2q.ga","r4gmw5fk5udod2q.gq","r4gmw5fk5udod2q.ml","r4gmw5fk5udod2q.tk","r4ifr.com","r4nd0m.de","r4ntwsd0fe58xtdp.cf","r4ntwsd0fe58xtdp.ga","r4ntwsd0fe58xtdp.gq","r4ntwsd0fe58xtdp.ml","r4ntwsd0fe58xtdp.tk","r4unxengsekp.cf","r4unxengsekp.ga","r4unxengsekp.gq","r4unxengsekp.ml","r4unxengsekp.tk","r56r564b.cf","r56r564b.ga","r56r564b.gq","r56r564b.ml","r56r564b.tk","r57u.co.cc","r6cnjv0uxgdc05lehvs.cf","r6cnjv0uxgdc05lehvs.ga","r6cnjv0uxgdc05lehvs.gq","r6cnjv0uxgdc05lehvs.ml","r6cnjv0uxgdc05lehvs.tk","r6q9vpi.shop.pl","r7m8z7.pl","r8lirhrgxggthhh.cf","r8lirhrgxggthhh.ga","r8lirhrgxggthhh.ml","r8lirhrgxggthhh.tk","r8r4p0cb.com","r9jebqouashturp.cf","r9jebqouashturp.ga","r9jebqouashturp.gq","r9jebqouashturp.ml","r9jebqouashturp.tk","r9ycfn3nou.cf","r9ycfn3nou.ga","r9ycfn3nou.gq","r9ycfn3nou.ml","r9ycfn3nou.tk","ra3.us","rabaz.org","rabidsammich.com","rabin.ca","rabiot.reisen","rabotnikibest.ru","rabuberkah.cf","race-karts.com","rachelsreelreviews.com","racquetballnut.com","radardetectorhunt.com","radecoratingltd.com","radiku.ye.vc","radio-crazy.pl","radiodale.com","radiosiriushduser.info","rady24.waw.pl","raetp9.com","raf-store.com","rafalrudnik.pl","raffles.gg","rafmail.cf","rafmix.site","rafrem3456ails.com","rag-tube.com","ragel.me","ragzwtna4ozrbf.cf","ragzwtna4ozrbf.ga","ragzwtna4ozrbf.gq","ragzwtna4ozrbf.ml","ragzwtna4ozrbf.tk","raiasu.cf","raiasu.ga","raiasu.gq","raiasu.ml","raiasu.tk","raikas77.eu","railroad-gifts.com","raimu.cf","raimucok.cf","raimucok.ga","raimucok.gq","raimucok.ml","raimuwedos.cf","raimuwedos.ga","raimuwedos.gq","raimuwedos.ml","rain.laohost.net","rainbowforgottenscorpion.info","rainbowly.ml","raindaydress.com","raindaydress.net","rainmail.biz","rainmail.top","rainmail.win","rainstormes.com","rainwaterstudios.org","raiplay.cf","raiplay.ga","raiplay.gq","raiplay.ml","raiplay.tk","raitbox.com","raiway.cf","raiway.ga","raiway.gq","raiway.ml","raiway.tk","raj-stopki.pl","rajabioskop.com","rajarajut.co","rajasoal.online","rajawaliindo.co.id","rajdnocny.pl","rajemail.tk","rajeshcon.cf","rajetempmail.com","raketenmann.de","rakietyssniezne.pl","ralala.com","ralph-laurensoldes.com","ralphlauren51.com","ralphlaurenfemme3.com","ralphlaurenoutletzt.co.uk","ralphlaurenpascherfr1.com","ralphlaurenpaschersfrance.com","ralphlaurenpolo5.com","ralphlaurenpolozt.co.uk","ralphlaurenshirtszt.co.uk","ralphlaurensoldes1.com","ralphlaurensoldes2.com","ralphlaurensoldes3.com","ralphlaurensoldes4.com","ralphlaurenteejp.com","ralphlaurenukzt.co.uk","ralree.com","rambakcor44bwd.ga","ramgoformacion.com","ramireschat.com","ramjane.mooo.com","rampas.ml","rampasboya.ml","ramseymail.men","rancidhome.net","rand1.info","randkiuk.com","rando-nature.com","randomail.net","randomfever.com","randomusnet.com","randykalbach.info","rangerjerseysproshop.com","rankingweightgaintablets.info","rankmagix.net","ranmoi.net","rao-network.com","rao.kr","rap-master.ru","rape.lol","rapenakyodilakoni.cf","rapid-guaranteed-payday-loans.co.uk","rapidcontentwizardofficial.com","rapidmail.com","rapik.online","rapt.be","raqid.com","rarame.club","rarsato.xyz","rascvetit.ru","raskhin54swert.ml","raspberrypi123.ddns.net","rastrofiel.com","ratesforrefinance.net","ratesiteonline.com","rating-slimming.info","ratingslimmingpills.info","ratsukellari.info","ratta.cf","ratta.ga","ratta.gq","ratta.ml","ratta.tk","rattlearray.com","rattlecore.com","rauxa.seny.cat","rav-4.cf","rav-4.ga","rav-4.gq","rav-4.ml","rav-4.tk","rav4.tk","ravensproteamsshop.com","ravenssportshoponline.com","ravenssuperbowlonline.com","ravensuperbowlshop.com","rawhidefc.org","rawizywax.com","rawmails.com","rawrr.ga","rax.la","raxtest.com","raybanpascher2013.com","raybanspascherfr.com","raybanssunglasses.info","raybansunglassesdiscount.us","raybansunglassessalev.net","raybansunglasseswayfarer.us","rayong.mobi","razemail.com","razinrocks.me","razorbackfans.net","rbb.org","rbfxecclw.pl","rbjkoko.com","rblx.site","rbmail.co.uk","rbpc6x9gprl.cf","rbpc6x9gprl.ga","rbpc6x9gprl.gq","rbpc6x9gprl.ml","rbpc6x9gprl.tk","rbteratuk.co.uk","rc6bcdak6.pl","rcasd.com","rcbdeposits.com","rcinvn408nrpwax3iyu.cf","rcinvn408nrpwax3iyu.ga","rcinvn408nrpwax3iyu.gq","rcinvn408nrpwax3iyu.ml","rcinvn408nrpwax3iyu.tk","rcpt.at","rcs.gaggle.net","rcs7.xyz","rdahb3lrpjquq.cf","rdahb3lrpjquq.ga","rdahb3lrpjquq.gq","rdahb3lrpjquq.ml","rdahb3lrpjquq.tk","rdklcrv.xyz","rdlocksmith.com","rdset.com","rdvx.tv","rdyn171d60tswq0hs8.cf","rdyn171d60tswq0hs8.ga","rdyn171d60tswq0hs8.gq","rdyn171d60tswq0hs8.ml","rdyn171d60tswq0hs8.tk","re-gister.com","reachout.pw","readissue.com","readtoyou.info","readycoast.xyz","readyforyou.cf","readyforyou.ga","readyforyou.gq","readyforyou.ml","real2realmiami.info","realacnetreatments.com","realantispam.com","realestatearticles.us","realestatedating.info","realestateinfosource.com","reality-concept.club","realjordansforsale.xyz","really.istrash.com","reallyfast.info","reallymymail.com","realpharmacytechnician.com","realtyalerts.ca","realwebcontent.info","rebates.stream","rebeca.kelsey.ezbunko.top","rebeccasfriends.info","rebeccavena.com","rebekamail.com","rebelrodeoteam.us","rebhornyocool.com","recargaaextintores.com","recdubmmp.org.ua","receiveee.chickenkiller.com","receiveee.com","receptiki.woa.org.ua","rechtsbox.com","recipeforfailure.com","recode.me","recognised.win","reconmail.com","recordboo.org.ua","recordstimes.org.ua","recruitaware.com","recupemail.info","recursor.net","recyclemail.dk","red-mail.info","red-mail.top","redacciones.net","redanumchurch.org","redarrow.uni.me","redbottomheels4cheap.com","redbottomshoesdiscounted.com","redbottomsshoesroom.com","redbottomsstores.com","redchan.it","reddcoin2.com","reddit.usa.cc","reddithub.com","redeo.net","redfeathercrow.com","rediffmail.net","redmail.tech","redondobeachwomansclub.org","redpeanut.com","redpen.trade","redtube-video.info","reduxe.jino.ru","redwinegoblet.info","redwinelady.com","redwinelady.net","reedbusiness.nl","reeducaremagrece.com","refer.methode-casino.com","referalu.ru","reftoken.net","refurhost.com","reg.xmlhgyjx.com","reg19.ml","regaloregamicudz.org","regalsz.com","regbypass.com","regbypass.comsafe-mail.net","regencyop.com","reggaestarz.com","regiopost.top","regiopost.trade","regmailproject.info","regpp7arln7bhpwq1.cf","regpp7arln7bhpwq1.ga","regpp7arln7bhpwq1.gq","regpp7arln7bhpwq1.ml","regpp7arln7bhpwq1.tk","regspaces.tk","regularlydress.net","reignict.com","rejectmail.com","rejo.technology","rejuvenexreviews.com","reklama.com","reklamowaagencjawarszawa.pl","reksareksy78oy.ml","rekt.ml","rekthosting.ml","relationship-cure.com","relationshiping.ru","relativegifts.com","relaxabroad.ru","relaxall.ru","relaxcafes.ru","relaxgamesan.ru","relaxplaces.ru","relaxrussia.ru","relaxself.ru","relaxyplace.ru","relay-bossku3.com","relay-bossku4.com","reliable-mail.com","reliableproxies.com","reliefsmokedeter.com","religionguru.ru","religioussearch.com","relleano.com","remail.cf","remail.ga","remailer.tk","remarkable.rocks","rembaongoc.com","remehan.ga","remehan.ml","remingtonaustin.com","remium4pets.info","remonciarz-malarz.pl","remont-dvigateley-inomarok.ru","remonty-firma.pl","remonty-malarz.pl","remontyartur.pl","remontyfirma.pl","remontymalarz.pl","remontynestor.pl","remote.li","remotepcrepair.com","removingmoldtop.com","remyqneen.com","renault-sa.cf","renault-sa.ga","renault-sa.gq","renault-sa.ml","renault-sa.tk","renaulttmail.pw","renaulttrucks.cf","renaulttrucks.ga","renaulttrucks.gq","renaulttrucks.ml","renaulttrucks.tk","rendymail.com","renegade-hair-studio.com","rengginangred95btw.cf","renotravels.com","renouweb.fr","renovasibangun-rumah.com","renraku.in","rentacarpool.com","rentalmobiljakarta.com","rentasig.com","rentierklub.pl","rentonom.net","rentshot.pl","repaemail.bz.cm","reparacionbatres.com","repatecus.pl","replicalouisvuittonukoutlets.com","replicasunglassesonline.org","replicasunglasseswholesaler.com","replicawatchesusa.net","repolusi.com","repomega4u.co.uk","reportes.ml","reports-here.com","reptilegenetics.com","republiktycoon.com","requestmeds.com","rerajut.com","rertimail.org","rerttymail.com","res.craigslist.org","researchobservatories.org.uk","resellermurah.me","resepku.site","reservationforum.com","reservelp.de","resgedvgfed.tk","residencerewards.com","resistore.co","resolution4print.info","resort-in-asia.com","rest-lux.ru","restauranteosasco.ml","resthomejobs.com","restumail.com","resultevent.ru","resumeworks4u.com","resumewrite.ru","ret35363ddfk.cf","ret35363ddfk.ga","ret35363ddfk.gq","ret35363ddfk.ml","ret35363ddfk.tk","retailtopmail.cz.cc","rethmail.ga","retinaonlinesure.com","retinaprime.com","retireddatinguk.co.uk","retkesbusz.nut.cc","retractablebannerstands.interstatecontracting.net","retractablebannerstands.us","retragmail.com","retrmailse.com","retrojordansforsale.xyz","retrt.org","rettmail.com","return0.ga","return0.gq","return0.ml","reubidium.com","rev-zone.net","revealeal.com","revealeal.net","revenueads.net","reverbnationpromotions.com","reversehairloss.net","reverseyourdiabetestodayreview.org","reverze.ru","review4forex.co.uk","reviewtable.gov","reviveherdriveprogram.com","revolvingdoorhoax.org","rewas-app-lex.com","rewolt.pl","rewqweqweq.info","rex-app-lexc.com","rexagod-freeaccount.cf","rexagod-freeaccount.ga","rexagod-freeaccount.gq","rexagod-freeaccount.ml","rexagod-freeaccount.tk","rexagod.cf","rexagod.ga","rexagod.gq","rexagod.ml","rexagod.tk","rexhuntress.com","rezumenajob.ru","rf7gc7.orge.pl","rfactorf1.pl","rfavy2lxsllh5.cf","rfavy2lxsllh5.ga","rfavy2lxsllh5.gq","rfavy2lxsllh5.ml","rfc822.org","rfirewallj.com","rfreedomj.com","rgb9000.net","rgphotos.net","rgrocks.com","rgtvtnxvci8dnwy8dfe.cf","rgtvtnxvci8dnwy8dfe.ga","rgtvtnxvci8dnwy8dfe.gq","rgtvtnxvci8dnwy8dfe.ml","rgtvtnxvci8dnwy8dfe.tk","rgwfagbc9ufthnkmvu.cf","rgwfagbc9ufthnkmvu.ml","rgwfagbc9ufthnkmvu.tk","rh3qqqmfamt3ccdgfa.cf","rh3qqqmfamt3ccdgfa.ga","rh3qqqmfamt3ccdgfa.gq","rh3qqqmfamt3ccdgfa.ml","rh3qqqmfamt3ccdgfa.tk","rhause.com","rheank.com","rhizoma.com","rhombushorizons.com","rhpzrwl4znync9f4f.cf","rhpzrwl4znync9f4f.ga","rhpzrwl4znync9f4f.gq","rhpzrwl4znync9f4f.ml","rhpzrwl4znync9f4f.tk","rhyta.com","rhzla.com","riamof.club","riaucyberart.ga","ribo.com","riboflavin.com","rich-money.pw","richfinances.pw","richfunds.pw","richinssuresh.ga","richlyscentedcandle.in","richmoney.pw","richonedai.pw","richsmart.pw","rickifoodpatrocina.tk","ricret.com","ricrk.com","riddermark.de","ride-tube.ru","ridebali.com","ridingonthemoon.info","riffcat.eu","rifkian.cf","rifkian.ga","rifkian.gq","rifkian.ml","rifkian.tk","rightclaims.org","rigtmail.com","rijschoolcosma-nijmegen.nl","rillamail.info","rim7lth8moct0o8edoe.cf","rim7lth8moct0o8edoe.ga","rim7lth8moct0o8edoe.gq","rim7lth8moct0o8edoe.ml","rim7lth8moct0o8edoe.tk","rincewind4.pl","rincewind5.pl","rincewind6.pl","ring123.com","ringtoneculture.com","ringwormadvice.info","rippedabs.info","ririe.club","risencraft.ru","risingbengal.com","risingsuntouch.com","riski.cf","ristoranteparodi.com","risu.be","riteros.top","riujnivuvbxe94zsp4.ga","riujnivuvbxe94zsp4.ml","riujnivuvbxe94zsp4.tk","rivaz24.ru","riveramail.men","rivermarine.org","riversidecapm.com","riw1twkw.pl","rixop.secure24mail.pl","rizamail.com","rizet.in","rj-11.cf","rj-11.ga","rj-11.gq","rj-11.ml","rj-11.tk","rj11.cf","rj11.ga","rj11.gq","rj11.ml","rj11.tk","rjxewz2hqmdshqtrs6n.cf","rjxewz2hqmdshqtrs6n.ga","rjxewz2hqmdshqtrs6n.gq","rjxewz2hqmdshqtrs6n.ml","rjxewz2hqmdshqtrs6n.tk","rk03.xyz","rk4vgbhzidd0sf7hth.cf","rk4vgbhzidd0sf7hth.ga","rk4vgbhzidd0sf7hth.gq","rk4vgbhzidd0sf7hth.ml","rk4vgbhzidd0sf7hth.tk","rk9.chickenkiller.com","rklips.com","rko.kr","rkofgttrb0.cf","rkofgttrb0.ga","rkofgttrb0.gq","rkofgttrb0.ml","rkofgttrb0.tk","rkomo.com","rls-log.net","rm88.edu.bz","rma.ec","rmail.cf","rmailcloud.com","rmailgroup.in","rmcp.cf","rmcp.ga","rmcp.gq","rmcp.ml","rmcp.tk","rmqkr.net","rms-sotex.pp.ua","rmtvip.jp","rmtvipbladesoul.jp","rmtvipredstone.jp","rnailinator.com","rnakmail.com","rnc69szk1i0u.cf","rnc69szk1i0u.ga","rnc69szk1i0u.gq","rnc69szk1i0u.ml","rnc69szk1i0u.tk","rnd-nedv.ru","rnjc8wc2uxixjylcfl.cf","rnjc8wc2uxixjylcfl.ga","rnjc8wc2uxixjylcfl.gq","rnjc8wc2uxixjylcfl.ml","rnjc8wc2uxixjylcfl.tk","rnzcomesth.com","ro.lt","roaringteam.com","roastedtastyfood.com","roastscreen.com","robedesoiree-longue.com","robertspcrepair.com","robo.epool.pl","robo3.club","robo3.co","robo3.me","robo3.site","robot-mail.com","robot2.club","robot2.me","robox.agency","roccoshmokko.com","rocketmail.cf","rocketmail.ga","rocketmail.gq","rocketslotsnow.co","rocketspinz.co","rockingchair.com","rockkes.us","rockmail.top","rockmailapp.com","rockmailgroup.com","rockwithyouallnight23.com","rockyoujit.icu","rocoiran.com","rodiquez.eu","rodiquezmcelderry.eu","rodneystudios.com","rodsupersale.com","rodtookjing.com","rodzinnie.org","roewe.cf","roewe.ga","roewe.gq","roewe.ml","roger-leads.com","rogerin.space","rogjf.com","rogowiec.com.pl","rohingga.xyz","rojay.fr","rokko-rzeszow.com","roko-koko.com","rolexdaily.com","rolexok.com","rolexreplicainc.com","rolexreplicawatchs.com","rollagodno.ru","rollindo.agency","rollingboxjapan.com","rollsroyce-plc.cf","rollsroyce-plc.ga","rollsroyce-plc.gq","rollsroyce-plc.ml","rollsroyce-plc.tk","rolndedip.cf","rolndedip.ga","rolndedip.gq","rolndedip.ml","rolndedip.tk","rolne.seo-host.pl","romagnabeach.com","romania-nedv.ru","romanstatues.net","romantyczka.pl","rondecuir.us","ronnierage.net","roofing4.expresshomecash.com","rooftest.net","room369.red","rooseveltmail.com","rootfest.net","ropolo.com","rosebearmylove.ru","rosechina.com","rosmillo.com","rossa-art.pl","rossmail.ru","rotaniliam.com","rotate.pw","rotermail.com","rotmanventurelab.com","roujpjbxeem.agro.pl","roulettecash.org","roundclap.fun","roundlayout.com","routine4me.ru","rover100.cf","rover100.ga","rover100.gq","rover100.ml","rover100.tk","rover400.cf","rover400.ga","rover400.gq","rover400.ml","rover400.tk","rover75.cf","rover75.ga","rover75.gq","rover75.ml","rover75.tk","rovianconspiracy.com","rovolowo.com","row.kr","rowe-solutions.com","rowmoja6a6d9z4ou.cf","rowmoja6a6d9z4ou.ga","rowmoja6a6d9z4ou.gq","rowmoja6a6d9z4ou.ml","rowmoja6a6d9z4ou.tk","roxmail.co.cc","roxmail.tk","royal-soft.net","royal.net","royaldoodles.org","royalgifts.info","royalhost.info","royalmail.top","royalmarket.club","royalmarket.life","royalmarket.online","royalweb.email","royaumedesjeux.fr","roys.ml","rpaowpro3l5ha.tk","rpgitxp6tkhtasxho.cf","rpgitxp6tkhtasxho.ga","rpgitxp6tkhtasxho.gq","rpgitxp6tkhtasxho.ml","rpgitxp6tkhtasxho.tk","rphqakgrba.pl","rpkxsgenm.pl","rpl-id.com","rplid.com","rppkn.com","rps-msk.ru","rpvduuvqh.pl","rq1.in","rq1h27n291puvzd.cf","rq1h27n291puvzd.ga","rq1h27n291puvzd.gq","rq1h27n291puvzd.ml","rq1h27n291puvzd.tk","rq3i7gcp.345.pl","rq6668f.com","rqzuelby.pl","rr-0.cu.cc","rr-1.cu.cc","rr-2.cu.cc","rr-3.cu.cc","rr-ghost.cf","rr-ghost.ga","rr-ghost.gq","rr-ghost.ml","rr-ghost.tk","rr-group.cf","rr-group.ga","rr-group.gq","rr-group.ml","rr-group.tk","rr.0x01.gq","rr.ccs.pl","rraybanwayfarersaleukyj.co.uk","rremontywarszawa.pl","rrqkd9t5fhvo5bgh.cf","rrqkd9t5fhvo5bgh.ga","rrqkd9t5fhvo5bgh.gq","rrqkd9t5fhvo5bgh.ml","rrqkd9t5fhvo5bgh.tk","rrrcat.com","rrwbltw.xyz","rs311e8.com","rsbysdmxi9.cf","rsbysdmxi9.ga","rsbysdmxi9.gq","rsbysdmxi9.ml","rsbysdmxi9.tk","rsfdgtv4664.cf","rsfdgtv4664.ga","rsfdgtv4664.gq","rsfdgtv4664.ml","rsfdgtv4664.tk","rsnfoopuc0fs.cf","rsnfoopuc0fs.ga","rsnfoopuc0fs.gq","rsnfoopuc0fs.ml","rsnfoopuc0fs.tk","rsqqz6xrl.pl","rssblog.pl","rssfwu9zteqfpwrodq.ga","rssfwu9zteqfpwrodq.gq","rssfwu9zteqfpwrodq.ml","rssfwu9zteqfpwrodq.tk","rsvhr.com","rtert.org","rthjr.co.cc","rtotlmail.com","rtotlmail.net","rtrtr.com","rts6ypzvt8.ga","rts6ypzvt8.gq","rts6ypzvt8.ml","rts6ypzvt8.tk","rtskiya.xyz","rtstyna111.ru","rtstyna112.ru","ruafdulw9otmsknf.cf","ruafdulw9otmsknf.ga","ruafdulw9otmsknf.ml","ruafdulw9otmsknf.tk","ruasspornisn4.uni.cc","rubiro.ru","rudelyawakenme.com","ruditnugnab.xyz","rudymail.ml","ruedeschaus.com","ruffrey.com","ruggedinbox.com","ruhshe5uet547.tk","ruinnyrurrendmail.com","rumbu.com","rumgel.com","rumpelhumpel.com","rumpelkammer.com","runalone.uni.me","rundablage.com","runi.ca","running-mushi.com","runrunrun.net","ruozhi.cn","rupayamail.com","ruru.be","rus-black-blog.ru","rus-sale.pro","rush.ovh","ruslanneck.de","russ2004.ru","russellconstructionca.com","russellmail.men","russia-nedv.ru","russia-vk-mi.ru","rustarticle.com","rustydoor.com","ruu.kr","ruzsbpyo1ifdw4hx.cf","ruzsbpyo1ifdw4hx.ga","ruzsbpyo1ifdw4hx.gq","ruzsbpyo1ifdw4hx.ml","ruzsbpyo1ifdw4hx.tk","ruzzinbox.info","rvb.ro","rvjtudarhs.cf","rvjtudarhs.ga","rvjtudarhs.gq","rvjtudarhs.ml","rvjtudarhs.tk","rvrsemortage.bid","rwbktdmbyly.auto.pl","rwhhbpwfcrp6.cf","rwhhbpwfcrp6.ga","rwhhbpwfcrp6.gq","rwhhbpwfcrp6.ml","rwhhbpwfcrp6.tk","rwhpr33ki.pl","rx.dred.ru","rx.qc.to","rxbuy-pills.info","rxdoc.biz","rxdrugsreview.info","rxdtlfzrlbrle.cf","rxdtlfzrlbrle.ga","rxdtlfzrlbrle.gq","rxdtlfzrlbrle.ml","rxlur.net","rxmail.us","rxmail.xyz","rxmaof5wma.cf","rxmaof5wma.ga","rxmaof5wma.gq","rxmaof5wma.ml","rxmaof5wma.tk","rxmedic.biz","rxnts2daplyd0d.cf","rxnts2daplyd0d.ga","rxnts2daplyd0d.gq","rxnts2daplyd0d.tk","rxpil.fr","rxpiller.com","rxr6gydmanpltey.cf","rxr6gydmanpltey.ml","rxr6gydmanpltey.tk","rxtx.us","ryanandkellywedding.com","ryanb.com","ryanreynolds.info","rycz2fd2iictop.cf","rycz2fd2iictop.ga","rycz2fd2iictop.gq","rycz2fd2iictop.ml","rycz2fd2iictop.tk","ryen15ypoxe.ga","ryen15ypoxe.ml","ryen15ypoxe.tk","ryjewo.com.pl","ryldnwp4rgrcqzt.cf","ryldnwp4rgrcqzt.ga","ryldnwp4rgrcqzt.gq","ryldnwp4rgrcqzt.ml","ryldnwp4rgrcqzt.tk","ryszardkowalski.pl","ryumail.net","ryumail.ooo","ryzdgwkhkmsdikmkc.cf","ryzdgwkhkmsdikmkc.ga","ryzdgwkhkmsdikmkc.gq","ryzdgwkhkmsdikmkc.tk","rzaca.com","rzdxpnzipvpgdjwo.cf","rzdxpnzipvpgdjwo.ga","rzdxpnzipvpgdjwo.gq","rzdxpnzipvpgdjwo.ml","rzdxpnzipvpgdjwo.tk","rzemien1.iswift.eu","rzn.host","rzuduuuaxbqt.cf","rzuduuuaxbqt.ga","rzuduuuaxbqt.gq","rzuduuuaxbqt.ml","rzuduuuaxbqt.tk","s-e-arch.com","s-mail.ga","s-mail.gq","s-port.pl","s-potencial.ru","s-s.flu.cc","s-s.igg.biz","s-s.nut.cc","s-s.usa.cc","s-zx.info","s.0x01.gq","s.bloq.ro","s.bungabunga.cf","s.dextm.ro","s.ea.vu","s.polosburberry.com","s.proprietativalcea.ro","s.sa.igg.biz","s.vdig.com","s.wkeller.net","s0.at","s00.orangotango.ga","s0nny.com","s0ny.cf","s0ny.flu.cc","s0ny.ga","s0ny.gq","s0ny.igg.biz","s0ny.ml","s0ny.net","s0ny.nut.cc","s0ny.usa.cc","s0ojarg3uousn.cf","s0ojarg3uousn.ga","s0ojarg3uousn.gq","s0ojarg3uousn.ml","s0ojarg3uousn.tk","s1nj8nx8xf5s1z.cf","s1nj8nx8xf5s1z.ga","s1nj8nx8xf5s1z.gq","s1nj8nx8xf5s1z.ml","s1nj8nx8xf5s1z.tk","s1xssanlgkgc.cf","s1xssanlgkgc.ga","s1xssanlgkgc.gq","s1xssanlgkgc.ml","s1xssanlgkgc.tk","s33db0x.com","s37ukqtwy2sfxwpwj.cf","s37ukqtwy2sfxwpwj.ga","s37ukqtwy2sfxwpwj.gq","s37ukqtwy2sfxwpwj.ml","s3rttar9hrvh9e.cf","s3rttar9hrvh9e.ga","s3rttar9hrvh9e.gq","s3rttar9hrvh9e.ml","s3rttar9hrvh9e.tk","s3s4.tk","s3wrtgnn17k.cf","s3wrtgnn17k.ga","s3wrtgnn17k.gq","s3wrtgnn17k.ml","s3wrtgnn17k.tk","s42n6w7pryve3bpnbn.cf","s42n6w7pryve3bpnbn.ga","s42n6w7pryve3bpnbn.gq","s42n6w7pryve3bpnbn.ml","s42n6w7pryve3bpnbn.tk","s48aaxtoa3afw5edw0.cf","s48aaxtoa3afw5edw0.ga","s48aaxtoa3afw5edw0.gq","s48aaxtoa3afw5edw0.ml","s48aaxtoa3afw5edw0.tk","s51zdw001.com","s6.weprof.it","s64hedik2.tk","s6a5ssdgjhg99.cf","s6a5ssdgjhg99.ga","s6a5ssdgjhg99.gq","s6a5ssdgjhg99.ml","s6a5ssdgjhg99.tk","s6qjunpz9es.ga","s6qjunpz9es.ml","s6qjunpz9es.tk","s80aaanan86hidoik.cf","s80aaanan86hidoik.ga","s80aaanan86hidoik.gq","s80aaanan86hidoik.ml","s8sigmao.com","s96lkyx8lpnsbuikz4i.cf","s96lkyx8lpnsbuikz4i.ga","s96lkyx8lpnsbuikz4i.ml","s96lkyx8lpnsbuikz4i.tk","sa.igg.biz","saab9-3.cf","saab9-3.ga","saab9-3.gq","saab9-3.ml","saab9-3.tk","saab9-4x.cf","saab9-4x.ga","saab9-4x.gq","saab9-4x.ml","saab9-4x.tk","saab9-5.cf","saab9-5.ga","saab9-5.gq","saab9-5.ml","saab9-5.tk","saab9-7x.cf","saab9-7x.ga","saab9-7x.gq","saab9-7x.ml","saab9-7x.tk","saab900.cf","saab900.ga","saab900.gq","saab900.ml","saab900.tk","saabaru.cf","saabaru.ga","saabaru.gq","saabaru.ml","saabaru.tk","saabcars.cf","saabcars.ga","saabcars.gq","saabcars.ml","saabcars.tk","saabgroup.cf","saabgroup.ga","saabgroup.gq","saabgroup.ml","saabgroup.tk","saabscania.cf","saabscania.ga","saabscania.gq","saabscania.ml","saabscania.tk","saarcxfp.priv.pl","sabbati.it","sabrestlouis.com","sabrgist.com","sac-chane1.com","sac-louisvuittonpascher.info","sac-prada.info","sac2013louisvuittonsoldes.com","sacamain2013louisvuittonpascher.com","sacamainlouisvuitton2013pascher.info","sacamainlouisvuittonsac.com","sacburberrypascher.info","saccatalyst.com","sacchanelpascherefr.fr","sacchanelsac.com","sacgucc1-magasin.com","sacgucci-fr.info","sach.ir","sachermes.info","sachermespascher6.com","sachermskellyprix.com","sachiepvien.net","sacil.xyz","sackboii.com","saclancelbb.net","saclancelbbpaschers1.com","saclanceldpaschers.com","saclancelpascheresfrance.com","saclavuitonpaschermagasinfrance.com","saclchanppascheresfr.com","saclongchampapascherefrance.com","saclongchampdefrance.com","saclouisvuitton-fr.info","saclouisvuittonapaschere.com","saclouisvuittonboutiquefrance.com","saclouisvuittonenfrance.com","saclouisvuittonnpascher.com","saclouisvuittonpascherenligne.com","saclouisvuittonsoldesfrance.com","saclovutonsfr9u.com","sacramentoreal-estate.info","sacslancelpascherfrance.com","sacslouisvuittonpascher-fr.com","sacsmagasinffr.com","sacsmagasinffrance.com","sacsmagasinfr9.com","sacsmagasinsfrance.com","sadwertopc.com","saerfiles.ru","safaat.cf","safariseo.com","safe-buy-cialis.com","safe-file.ru","safe-mail.ga","safe-mail.gq","safe-mail.net","safe-planet.com","safemail.cf","safemail.tk","safemaildesk.info","safemailweb.com","safenord.com","safeonlinedata.info","safepaydayloans365.co.uk","safer.gq","safermail.info","safersignup.com","safersignup.de","safeshate.com","safetempmail.com","safetymail.info","safetypost.de","safewebmail.net","safirahome.com","safrem3456ails.com","sagd33.co.uk","saglobe.com","sagmail.ru","saharanightstempe.com","sahdisus.online","sahrulselow.cf","sahrulselow.ga","sahrulselow.gq","sahrulselow.ml","saigonmaigoinhaubangcung.com","saigonmail.us","saint-philip.com","saiting.tw1.ru","sakamail.net","sakarmain.com","saktiemel.com","saladchef.me","saladsanwer.ru","salahkahaku.cf","salahkahaku.ga","salahkahaku.gq","salahkahaku.ml","salaopm.ml","sale-nike-jordans.org","sale.craigslist.org","salecheaphot.com","salechristianlouboutinukshoess.co.uk","salemail.com","salemen.com","salesbeachhats.info","salescheapsepilators.info","salescoupleshirts.info","salesfashionnecklaces.info","saleshtcphoness.info","saleskf.com","salesperson.net","salesscushion.info","salessmenbelt.info","salessuccessconsulting.com","salesunglassesonline.net","saleswallclock.info","saleuggsbootsclearance.com","salewebmail.com","salle-poker-en-ligne.com","salmeow.tk","salon-chaumont.com","salon3377.com","salonyfryzjerskie.info","saltysushi.com","salvador-nedv.ru","salvatore1818.site","samaki.com","samantha17.com","samaoyfxy.pl","samara-nedv.ru","samatante.ml","samauil.com","sambalenak.com","samblad.ga","samblad.ml","sambuzh.com","sameaccountmanage765.com","samedayloans118.co.uk","samerooteigelonline.co","saminiran.com","samisdaem.ru","samjaxcoolguy.com","samoe-samoe.info","samolocik.com.pl","samowarvps24.pl","samscashloans.co.uk","samsclass.info","samsinstantcashloans.co.uk","samsquickloans.co.uk","samsshorttermloans.co.uk","samstelevsionbeds.co.uk","samsunggalaxys9.cf","samsunggalaxys9.ga","samsunggalaxys9.gq","samsunggalaxys9.ml","samsunggalaxys9.tk","samsungmails.pw","samsunk.pl","san-marino-nedv.ru","sanchof1.info","sanchom1.info","sanchom2.info","sanchom3.info","sanchom4.info","sanchom5.info","sanchom6.info","sanchom7.info","sanchom8.info","sandalsresortssale.com","sandar.almostmy.com","sandcars.net","sandelf.de","sandiegochargersjerseys.us","sandiegocontractors.org","sandiegoreal-estate.info","sandiegospectrum.com","sandoronyn.com","sandre.cf","sandre.ga","sandre.gq","sandre.ml","sandre.tk","sandwhichvideo.com","sanfinder.com","sanfrancisco49ersproteamjerseys.com","sanfranflowersinhair.com","sangaritink09gkgk.tk","sanibelwaterfrontproperty.com","saniki.pl","sanim.net","sanjaricacrohr.com","sanjati.com","sanjoseareahomes.net","sankakucomplex.com","sanporeta.ddns.name","sansarincel.com","sanstr.com","santa.waw.pl","santamonica.com","santhia.cf","santhia.ga","santhia.gq","santhia.ml","santhia.tk","santikadyandra.cf","santikadyandra.ga","santikadyandra.gq","santikadyandra.ml","santikadyandra.tk","santingiamgia.com","sanvekhuyenmai.com","sanvetetre.com","sapbox.bid","sapi2.com","sapya.com","sarahdavisonsblog.com","sarapanakun.com","sarcoidosisdiseasetreatment.com","sargrip.asia","sarinaaduhay.com","sarkisozudeposu.com","sasa22.usa.cc","sasha.compress.to","saskia.com","sassy.com","sast.ro","satabmail.com","satan.gq","satana.cf","satana.ga","satana.gq","satcom.cf","satcom.ga","satcom.gq","satcom.ml","satellitefirms.com","satisfyme.club","satservizi.net","satukosong.com","saturniusz.info","satusatu.online","saudealternativa.org","saukute.me","sausen.com","saveboxmail.ga","savebrain.com","savelife.ml","savesausd.com","savetimeerr.fun","savevid.ga","sawoe.com","saxfun.party","saxophonexltd.com","saxsawigg.biz","say.buzzcluby.com","sayitsme.com","saynotospams.com","sayonara.gq","sayonara.ml","saytren.tk","sayyesyes.com","sazhimail.ooo","sborra.tk","sburningk.com","sbuttone.com","sc-racing.pl","sc91pbmljtunkthdt.cf","sc91pbmljtunkthdt.ga","sc91pbmljtunkthdt.gq","sc91pbmljtunkthdt.ml","sc91pbmljtunkthdt.tk","scabiesguide.info","scandiskmails.gdn","scanf.ga","scanf.gq","scania.gq","scania.tk","scanitxtr.com","scanmail.us","scannerchip.com","scatmail.com","scay.net","scbox.one.pl","schachrol.com","schackmail.com","schafmail.de","schaufell.pl","schlankefigur24.de","schluesseldienst-stflorian.at","schlump.com","schmeissweg.tk","schmid.cf","schmid.ga","schnell-geld-verdienen.cf","schnell-geld-verdienen.ga","schnell-geld-verdienen.gq","schnippschnappschnupp.com","scholarsed.com","scholarshippro.com","scholarshipsusa.net","scholarshipzon3.com","school-essay.org","school-good.ru","schrott-email.de","schticky.tv","schufafreier-kredit.at","schulweis.com","schwarzmail.ga","scianypoznan.pl","science-full.ru","sciencelive.ru","scizee.com","scj.edu","scmail.cf","scmbnpoem.pl","scootmail.info","scottrenshaw.com","scrambleground.com","scrap-cars-4-cash-coventry.com","scrapebox.in","scrapper.us","screamfused.com","screechcontrol.com","screenvel.com","scrmnto.cf","scrmnto.ga","scrmnto.gq","scrmnto.ml","scroomail.info","scrumexperts.com","scsmalls.com","sctbmkxmh0xwt3.cf","sctbmkxmh0xwt3.ga","sctbmkxmh0xwt3.gq","sctbmkxmh0xwt3.ml","sctbmkxmh0xwt3.tk","sctcwe1qet6rktdd.cf","sctcwe1qet6rktdd.ga","sctcwe1qet6rktdd.gq","sctcwe1qet6rktdd.ml","sctcwe1qet6rktdd.tk","scussymail.info","scxt1wis2wekv7b8b.cf","scxt1wis2wekv7b8b.ga","scxt1wis2wekv7b8b.gq","scxt1wis2wekv7b8b.ml","scxt1wis2wekv7b8b.tk","sd-exports.org","sd3.in","sdagds.com","sdd2q.com","sddfpop.com","sdelkanaraz.com","sdf.org","sdf44.com","sdfbd.com","sdferwwe.com","sdfgd.in","sdfggf.co.cc","sdfghyj.tk","sdfgsdrfgf.org","sdfgukl.com","sdfgwsfgs.org","sdfiresquad.info","sdfklsadkflsdkl.com","sdfqwetfv.com","sdfsdf.co","sdfuggs.com","sdg34563yer.ga","sdg4643ty34.ga","sdgewrt43terdsgt.ga","sdgsdfgsfgsdg.pl","sdirfemail.com","sdkfkrorkg.com","sdnr.it","sdsdaas231.org","sdsdwab.com","sdsigns.com","sdy21.com","se-cure.com","se.xt-size.info","seahawksportsshop.com","seahawksproteamsshop.com","seal-concepts.com","search-usa.ws","searmail.com","searsgaragedoor.org","searzh.com","seasideorient.com","seattleovariancancerresearch.org","seattlerealestate4you.com","seblog.cz.cc","secbadger.info","secencode.xyz","secfiz99.com","secknow.info","secmail.ga","secmail.gq","secmail.ml","secmail.pro","secmail.pw","secmeeting.com","second-chancechecking.com","secret-area.tk","secretdev.co.uk","secretdiet.com","secretemail.de","secretfashionstore.com","secretluxurystore.com","secretmystic.ru","secretsurveyreviews.info","sector2.org","secure-box.info","secure-box.online","secure-fb.com","secure-mail.biz","secure-mail.cc","secure-mail.cn","secureapay.com","secured-link.net","securehost.com.es","secureinvox.com","securemail.flu.cc","securemail.gq","securemail.igg.biz","securemail.nut.cc","securemail.usa.cc","securemailserver.cf","securemailserver.ga","securemailserver.gq","securemailserver.ml","securemailserver.tk","secureserver.rogers.ca","secureserver.usa.cc","securesmtp.bid","securesmtp.download","securesmtp.stream","securesmtp.trade","securesmtp.win","securesys.cf","securesys.ga","securesys.gq","securesys.ml","securesys.tk","securesystems-corp.cf","securesystems-corp.ga","securesystems-corp.gq","securesystems-corp.ml","securesystems-corp.tk","sedasagreen01try.tk","sedric.ru","sedv4ph.com","seed.ml","seekapps.com","seekfindask.com","seekintertech.info","seekjobs4u.com","seeksupply.com","seekusjobs.com","seemail.info","seevideoemail.com","segabandemcross74new.ml","segundamanozi.net","seierra.com","seishel-nedv.ru","sejaa.lv","sekcjajudo.pl","sekoeuropa.pl","selectam.ru","selectraindustries.com","selectyourinfo.com","selfarticle.com","selfdestructingmail.com","selfdestructingmail.org","selfmadesuccesstoday.com","selfrestaurant.com","selfretro.net","selfstoragefind.net","sellcow.net","sellim.site","sellinganti-virussoftwares.info","sells.com","selowcoffee.cf","selowcoffee.ga","selowcoffee.gq","selowcoffee.ml","selowhellboy.cf","selowhellboy.ga","selowhellboy.gq","selowhellboy.ml","sem9.com","semail.us","semangat99.cf","semarcomputama.tk","semarhouse.ga","semarhouse.ml","semarhouse.tk","semenaxreviews.net","semi-mile.com","semidesigns.com","seminary-777.ru","semitrailersnearme.com","semogaderes.com","sempuranadi.cf","sempuranadi.ga","sempuranadi.ml","sempuranadi.tk","semsei.co.uk","semusimbersama.online","semut-kecil.com","semutkecil.com","send-email.org","send22u.info","sendbananas.website","senderelasem.tk","sendfree.org","sendingspecialflyers.com","sendto.cf","senegal-nedv.ru","senfgad.com","sengi.top","sennbox.cf","sennbox.ga","sennbox.gq","sennbox.ml","sennbox.tk","senseless-entertainment.com","sensualerotics.date","senttmail.ga","senukexcrreview.in","seo-for-pussies.pl","seo-turn.ru","seo.beefirst.pl","seo.bytom.pl","seo.viplink.eu","seo1-miguel75.xyz","seo11.mygbiz.com","seo21.pl","seo3.pl","seo39.pl","seo8.co.uk","seoartguruman.com","seobacklinks.edu","seobest.website","seoblasters.com","seoblog.com","seobrizz.com","seobungbinh.com","seobuzzvine.com","seocdvig.ru","seocompany.edu","seocu.gen.tr","seodating.info","seoenterprises.com.au","seoestore.us","seoforum.com","seogawd.com","seohoan.com","seoimpressions.com","seojuice.info","seokings.biz","seoknock.com","seolite.net.pl","seolondon.co.uk","seolondon24.co.uk","seolove.fr","seomaomao.net","seomarketingservices.nl","seomarketleaders.com","seomoz.org","seonuke-x.com","seonuke.info","seoo-czestochowa.pl","seoofindia.com","seopapese.club","seopot.biz","seopowa.com","seopress.me","seoprorankings.com","seoquorankings.com","seoranker.pro","seorj.cn","seosavants.com","seosc.pl","seosecretservice.top","seoseoseo.mygbiz.com","seoserwer.com","seoskyline.com","seostatic.pl","seostudio.co","seoteen.com","seoverr.com","seovps.com","seowy.eu","seoyo.com","sepatusupeng.gq","sepoisk.ru","septeberuare.ru","seputarti.com","serbian-nedv.ru","serenalaila.com","sergeymavrodi.org","sergeypetrov.nanolv.com","sergw.com","serialkinogoru.ru","serialkinopoisk.ru","serials-only.ru","series-online.info","seriousalts.de","seriyaserial.ru","seron.top","serpshooter.top","serv.craigslist.org","server.ms","servermaps.net","servermuoihaikhongbon.com","serverpro.cf","service4.ml","servicegulino.com","servicemercedes.biz","services.pancingqueen.com","services391.com","servicing-ca.info","serwervps232x.com","serwervps24.pl","serwis-agd-warszawa.pl","serwisapple.pl","serwpcneel99.com","setefi.tk","setiabudihitz.com","settingsizable.info","seven.emailfake.ml","seven.fackme.gq","seven6s.com","sevensjsa.org.ua","sevensmail.org.ua","sewafotocopy-xerox.com","sewamobilharian.com","sex-chicken.com","sex-guru.net","sex-mobile-blog.ru","sex-ru.net","sex-vox.info","sex.dns-cloud.net","sex.si","sexactive18.info","sexakt.org","sexboxx.cf","sexboxx.ga","sexboxx.gq","sexboxx.ml","sexboxx.tk","sexcamsex.org","sexe-pad.com","sexe-pas-cher.net","sexemamie.com","sexforswingers.com","sexfotka.com","sexical.com","sexini.com","sexioisoriog.gr","sexsation.ru","sexshop.com","sexsmi.org","sextoyth.com","sexxfun69.site","sexyalwasmi.top","sexyalwax.online","sexyfashionswimwear.info","sexyjobs.net","sexylingeriegarte.com","sexymail.gq","sexymail.ooo","sexypleasuregirl.com","sexysleepwear.info","seylifegr.gr","seyretbi.com","sezet.com","sf49ersshoponline.com","sf49erssuperbowlonline.com","sf49ersteamsshop.com","sfa59e1.mil.pl","sfamo.com","sfdgdmail.com","sfdjg.in","sfgov.net","sfmail.top","sforamseadif.xyz","sfrty.ru","sfxmailbox.com","sgb-itu-anjeng.cf","sgb-itu-anjeng.ga","sgb-itu-anjeng.gq","sgb-itu-anjeng.ml","sgb-itu-anjeng.tk","sgb-itu-bangsat.cf","sgb-itu-bangsat.ga","sgb-itu-bangsat.gq","sgb-itu-bangsat.ml","sgb-itu-bangsat.tk","sgbteam.hostingarif.me","sgbtukangsuntik.club","sgep0o70lh.cf","sgep0o70lh.ga","sgep0o70lh.gq","sgep0o70lh.ml","sgep0o70lh.tk","sgesvcdasd.com","sgiochi.it","sgizdkbck4n8deph59.cf","sgizdkbck4n8deph59.gq","sgtt.ovh","sgw186.com","sgxboe1ctru.cf","sgxboe1ctru.ga","sgxboe1ctru.gq","sgxboe1ctru.ml","sgxboe1ctru.tk","sh.soim.com","shahimul.tk","shakemain.com","shalar.net","shamanimports.com","shandongji232.info","shannonyaindgkil.com","shaonianpaideqihuanpiaoliu.com","shapoo.ch","sharedmailbox.org","sharing-storage.com","sharklasers.com","sharkliveroil.in","sharksteammop.in","sharpmail.com","shats.com","shattersense.com","shaw.pl","shaylarenx.com","shayzam.net","shbg.info","shedik2.tk","shedplan.info","shejumps.org","shenji.info","shepherds-house.com","sheytg56.ga","shhmail.com","shhuut.org","shieldedmail.com","shieldemail.com","shiftmail.com","shinglestreatmentx.com","shininglight.us","shinnemo.com","shinsplintsguide.info","ship-from-to.com","shipfromto.com","shiphang.club","shiphangmy.club","shiphazmat.org","shipping-regulations.com","shippingterms.org","shiprol.com","shirleylogan.com","shiroinime.ga","shironime.ga","shironime.ml","shironime.tk","shishish.cf","shishish.ga","shishish.gq","shishish.ml","shit.dns-cloud.net","shit.dnsabr.com","shitaway.cf","shitaway.flu.cc","shitaway.ga","shitaway.gq","shitaway.igg.biz","shitaway.ml","shitaway.nut.cc","shitaway.tk","shitaway.usa.cc","shitmail.cf","shitmail.de","shitmail.ga","shitmail.gq","shitmail.me","shitmail.ml","shitmail.org","shitmail.tk","shitposting.agency","shittymail.cf","shittymail.ga","shittymail.gq","shittymail.ml","shittymail.tk","shitware.nl","shiyakila.cf","shiyakila.ga","shiyakila.gq","shiyakila.ml","shjto.us","shmeriously.com","shockinmytown.cu.cc","shockmail.win","shoeonlineblog.com","shoes-market.cf","shoes.com","shoes.net","shoesbrandsdesigner.info","shoesclouboupascher.com","shoeskicks.com","shoeslouboutinoutlet.com","shoesonline2014.com","shoesonline4sale.com","shoesshoponline.info","shoklin.cf","shoklin.ga","shoklin.gq","shoklin.ml","shonky.info","shop.winestains.org","shop4mail.net","shopbaby.me","shopbagsjp.org","shopburberryjp.com","shopcelinejapan.com","shopdigital.info","shopdoker.ru","shopfalconsteamjerseys.com","shophall.net","shopjpguide.com","shoplouisvuittonoutlets.com","shopmoza.com","shopmp3.org","shopmulberryonline.com","shopmystore.org","shopnflnewyorkjetsjersey.com","shopnflravenjerseys.com","shoponlinemallus.com","shoppinglove.org","shoppinguggboots.com","shoppiny.com","shoppradabagsjp.com","shopravensteamjerseys.com","shoproyal.net","shopseahawksteamjerseys.com","shopshoes.co.cc","shopshowlv.com","shopsuperbowl49ers.com","shopsuperbowlravens.com","shopussy.com","shorten.tempm.ml","shorterurl.biz","shortmail.net","shorttermloans90.co.uk","shoshaa.in","shotarou.com","shotmail.ru","shotsdwwgrcil.com","shoulderlengthhairstyles.biz","shouldpjr.com","showartcenter.com","showbusians.ru","showcoachfactory.com","showlogin.com","showme.social","showslow.de","showup.us","showyoursteeze.com","shrib.com","shroudofturin2011.info","shuffle.email","shufuni.cn","shuoshuotao.com","shurs.xyz","shut.name","shut.ws","shvedian-nedv.ru","siapaitu.online","siasat.pl","siatkiogrodzeniowenet.pl","sibelor.pw","siberask.com","sibigkostbil.xyz","sibmail.com","sicamail.ga","sickseo.co.uk","sidamail.ga","siddhacademy.com","sidedeaths.co.cc","sidelka-mytischi.ru","sidmail.com","sieczki.com.pl","sienna12bourne.ga","siennamail.com","siftportal.ru","sify.com","sign-up.website","signaturefencecompany.com","signings.ru","sikdar.site","sikis18.org","sikomo.cf","sikomo.ga","sikomo.gq","sikomo.ml","sikomo.tk","sikuder.me","sikux.com","silda8vv1p6qem.cf","silda8vv1p6qem.ga","silda8vv1p6qem.gq","silda8vv1p6qem.ml","silda8vv1p6qem.tk","silencei.org.ua","siliwangi.ga","silkroadproxy.com","silosta.co.cc","silsilah.life","silvercoin.life","silxioskj.com","sim-simka.ru","simails.info","simcity.hirsemeier.de","simoka73.vv.cc","simple-mail-server.bid","simplebox.email","simpleemail.in","simpleemail.info","simpleitsecurity.info","simplemail.in","simplemail.top","simplemailserver.bid","simplemerchantcapital.com","simpleseniorliving.com","simplesport.ru","simply-email.bid","simplyemail.bid","simplyemail.men","simplyemail.racing","simplyemail.trade","simplyemail.win","simscity.cf","simsdsaon.eu","simsdsaonflucas.eu","simsmail.ga","simulink.cf","simulink.ga","simulink.gq","simulink.ml","sin-mailing.com","sin.cl","sina.toh.info","sinasina.com","sinasinaqq123.info","sinda.club","sindu.org","sinema.ml","sinemail.info","sinemailing.com","sinfiltro.cl","singapore-nedv.ru","singlecoffeecupmaker.com","singlesearch12.info","singlespride.com","singletravel.ru","singonline.net","singssungg.faith","singtelmails.com","sink.fblay.com","sinmailing.com","sinnlos-mail.de","sino.tw","sinyomail.gq","siolence.com","sir1ddnkurzmg4.cf","sir1ddnkurzmg4.ga","sir1ddnkurzmg4.gq","sir1ddnkurzmg4.ml","sir1ddnkurzmg4.tk","sirgoo.com","sirver.ru","sisari.ru","sisemazamkov.com","sistewep.online","sitdown.com","sitdown.info","sitdown.us","site-games.ru","sitemap.uk","siteposter.net","sitestyt.ru","siteuvelirki.info","siux3aph7ght7.cf","siux3aph7ght7.ga","siux3aph7ght7.gq","siux3aph7ght7.ml","siux3aph7ght7.tk","sivtmwumqz6fqtieicx.ga","sivtmwumqz6fqtieicx.gq","sivtmwumqz6fqtieicx.ml","sivtmwumqz6fqtieicx.tk","six-six-six.cf","six-six-six.ga","six-six-six.gq","six-six-six.ml","six-six-six.tk","six.emailfake.ml","six.fackme.gq","sixtptsw6f.cf","sixtptsw6f.ga","sixtptsw6f.gq","sixtptsw6f.ml","sixtptsw6f.tk","sixxx.ga","sizableonline.info","sizzlemctwizzle.com","sjadhasdhj3423.info","sjpvvp.org","sjrajufhwlb.cf","sjrajufhwlb.ga","sjrajufhwlb.gq","sjrajufhwlb.ml","sjrajufhwlb.tk","sjsfztvbvk.pl","sjuaq.com","skachat-1c.org","skachatfilm.com","skafunderz.com","skakuntv.com","skateboardingcourses.com","skdjfmail.com","skeefmail.com","skg3qvpntq.cf","skg3qvpntq.ga","skg3qvpntq.ml","skg3qvpntq.tk","skhnlm.cf","skhnlm.ga","skhnlm.gq","skhnlm.ml","skillfare.com","skimcss.com","skinacneremedytreatmentproduct.com","skincareonlinereviews.net","skincareproductoffers.com","skinid.info","skintagfix.com","skinwhiteningforeverreview.org","skipopiasc.info","skipspot.eu","skkk.edu.my","sklad.progonrumarket.ru","skladchina.pro","skldfsldkfklsd.com","sklep-nestor.pl","sklepsante.com","skodaauto.cf","skrx.tk","skrzynka.waw.pl","sksfullskin.ga","sky-inbox.com","sky-isite.com","sky-mail.ga","sky-movie.com","sky-ts.de","sky.dnsabr.com","skybarlex.xyz","skydragon112.cf","skydragon112.ga","skydragon112.gq","skydragon112.ml","skydragon112.tk","skydrive.tk","skymail.gq","skymailapp.com","skymailgroup.com","skymemy.com","skypaluten.de","skypewebui.eu","skysmail.gdn","skz.us","skzokgmueb3gfvu.cf","skzokgmueb3gfvu.ga","skzokgmueb3gfvu.gq","skzokgmueb3gfvu.ml","skzokgmueb3gfvu.tk","sladko-ebet-rakom.ru","sladko-milo.ru","slapsfromlastnight.com","slarmail.com","slashpills.com","slaskpost.rymdprojekt.se","slaskpost.se","slave-auctions.net","slavens.eu","slavenspoppell.eu","slawbud.eu","sledzikor.az.pl","sleepfjfas.org.ua","slekepeth78njir.ga","slendex.co","slexports.com","slimail.info","slimimport.com","slimming-fast.info","slimming-premium.info","slimmingtabletsranking.info","slimurl.pw","slippery.email","slipry.net","slkfewkkfgt.pl","slmshf.cf","slobruspop.co.cc","slomail.info","slonmail.com","sloppyworst.co","slopsbox.com","slothmail.net","slovabegomua.ru","slovac-nedv.ru","sloven-nedv.ru","slowcooker-reviews.com","slowdeer.com","slowfoodfoothills.xyz","slowslow.de","sls.us","slson.com","slsrs.ru","sltmail.com","slu21svky.com","slugmail.ga","slushmail.com","slut-o-meter.com","sluteen.com","slutty.horse","sly.io","smailpost.info","smailpostin.net","smailpro.com","smajok.ru","smallanawanginbeach.com","smallker.tk","sman14kabtangerang.site","smap.4nmv.ru","smap4.me","smapfree24.com","smapfree24.de","smapfree24.eu","smapfree24.info","smapfree24.org","smaretboy.pw","smart-email.me","smart-host.org","smart-mail.info","smart-mail.top","smartbusiness.me","smartgrid.com","smartpaydayonline.com","smartsass.com","smarttalent.pw","smartx.sytes.net","smarty123.info","smashmail.de","smcleaningbydesign.com","smellfear.com","smellrear.com","smellypotato.tk","smesthai.com","smi.ooo","smileair.org","smilebalance.com","smilefastcashloans.co.uk","smilequickcashloans.co.uk","smiletransport.com","smileyet.tk","smirnoffprices.info","smirusn6t7.cf","smirusn6t7.ga","smirusn6t7.gq","smirusn6t7.ml","smirusn6t7.tk","smith.com","smithgroupinternet.com","smithwright.edu","smmok-700nm.ru","smokefreesheffield.co.uk","smoken.com","smokingpipescheap.info","smoothtakers.net","smoothunit.us","smotretonline2015.ru","smoug.net","smsbaka.ml","smsblue.com","smsbuds.in","smsdash.com","smsenmasse.eu","smsforum.ro","smsjokes.org","smsmint.com","smsraag.com","smsturkey.com","smtp.docs.edu.vn","smtp3.cz.cc","smtp33.com","smtp99.com","smtponestop.info","smuse.me","smwg.info","sn3bochroifalv.cf","sn3bochroifalv.ga","sn3bochroifalv.gq","sn3bochroifalv.ml","sn3bochroifalv.tk","sn55nys5.cf","sn55nys5.ga","sn55nys5.gq","sn55nys5.ml","sn55nys5.tk","snad1faxohwm.cf","snad1faxohwm.ga","snad1faxohwm.gq","snad1faxohwm.ml","snad1faxohwm.tk","snail-mail.bid","snailmail.bid","snailmail.download","snailmail.men","snakebite.com","snakemail.com","snaknoc.cf","snaknoc.ga","snaknoc.gq","snaknoc.ml","snam.cf","snam.ga","snam.gq","snam.tk","snapbackbay.com","snapbackcapcustom.com","snapbackcustom.com","snapbackdiscount.com","snapbackgaga.com","snapbackhatscustom.com","snapbackhatuk.com","snapunit.com","snapwet.com","sneakemail.com","sneaker-friends.com","sneaker-mag.com","sneaker-shops.com","sneakerbunko.cf","sneakerbunko.ga","sneakerbunko.gq","sneakerbunko.ml","sneakerbunko.tk","sneakers-blog.com","sneakersisabel-marant.com","sneakmail.de","sneakyreviews.com","snipe-mail.bid","snipemail4u.bid","snipemail4u.men","snkmail.com","snkml.com","snl9lhtzuvotv.cf","snl9lhtzuvotv.ga","snl9lhtzuvotv.gq","snl9lhtzuvotv.ml","snl9lhtzuvotv.tk","snowboots4usa.com","snowmail.xyz","snowsweepusa.com","snowthrowers-reviews.com","snpsex.ga","so-com.tk","so-net.cf","so-net.ga","so-net.gq","so-net.ml","sobeatsdrdreheadphones1.com","sobecoupon.com","sobeessentialenergy.com","socalgamers5.info","socalnflfans.info","socalu2fans.info","socgazeta.com","sochi.shn-host.ru","sochihosting.info","social-mailer.tk","socialcampaigns.org","socialeum.com","socialfurry.org","socialhubmail.info","socialmailbox.info","socialpreppers99.com","socialtheme.ru","socialviplata.club","socialxbounty.info","socjaliscidopiekla.pl","sockfoj.pl","socmail.net","socoolglasses.com","socrazy.club","socrazy.online","socsety.com","socusa.ru","soczewek-b.pl","soczewki.com","sodapoppinecoolbro.com","sodergacxzren.eu","sodergacxzrenslavens.eu","soeasytop.ru","soeo4am81j.cf","soeo4am81j.ga","soeo4am81j.gq","soeo4am81j.ml","soeo4am81j.tk","sofaoceco.pl","sofimail.com","sofme.com","sofort-mail.de","sofortmail.de","soft-cheap-oem.net","softanswer.ru","softbank.tk","softdesk.net","softkey-office.ru","softmails.info","softpls.asia","softportald.tk","softtoiletpaper.com","softwarespiacellulari.info","softwarespiapercellulari.info","sogetthis.com","sohai.ml","sohu.com","sohu.net","sohu.ro","sohus.cn","soioa.com","soisz.com","sokratit.ru","solar-impact.pro","solarino.pl","soldesburbery.com","soldierreport.com","soliaflatirons.in","soliahairstyling.in","solidseovps.com","solihulllandscapes.com","soloner.ru","solowtech.com","solpowcont.info","soltur.bogatynia.net.pl","solu.gq","solution-finders.com","solvemail.info","solventtrap.wiki","somdhosting.com","someadulttoys.com","somechoice.ga","somedd.com","somepornsite.com","somerandomdomains.com","somniasound.com","songgallery.info","songlists.info","songlyricser.com","songsblog.info","soniconsultants.com","sonmoi356.com","sonshi.cf","sonshi.pl","sonyedu.com","sonymails.gdn","sonyymail.com","soodmail.com","soodomail.com","soodonims.com","soon.it","soopr.info","soozoop.com","sorteeemail.com","soslouisville.com","sosmanga.com","sotahmailz.ga","sotayonline.com","soulfire.pl","soulinluv.com","soumail.info","soundclouddownloader.info","sounditems.com","soupans.ru","sourcl.club","sourcreammail.info","sousousousou.com","southafrica-nedv.ru","southamericacruises.net","sowhatilovedabici.com","soxrazstex.com","soyou.net","sozdaem-diety.ru","sp.woot.at","spa.com","spacebazzar.ru","spacecas.ru","spacemail.info","spacewalker.cf","spacewalker.ga","spacewalker.gq","spacewalker.ml","spacibbacmo.lflink.com","spaereplease.com","spain-nedv.ru","spainholidays2012.info","spam-be-gone.com","spam-en.de","spam-nicht.de","spam.0x01.tk","spam.2012-2016.ru","spam.care","spam.coroiu.com","spam.deluser.net","spam.dexter0.xyz","spam.dhsf.net","spam.dnsx.xyz","spam.fassagforpresident.ga","spam.flu.cc","spam.igg.biz","spam.janlugt.nl","spam.jasonpearce.com","spam.la","spam.loldongs.org","spam.lucatnt.com","spam.netpirates.net","spam.nut.cc","spam.org.es","spam.ozh.org","spam.pyphus.org","spam.rogers.us.com","spam.shep.pw","spam.su","spam.trajano.net","spam.usa.cc","spam.visuao.net","spam.wtf.at","spam.wulczer.org","spam4.me","spamail.de","spamama.uk.to","spamarrest.com","spamavert.com","spambob.com","spambob.net","spambob.org","spambog.com","spambog.de","spambog.net","spambog.ru","spambooger.com","spambox.info","spambox.irishspringrealty.com","spambox.me","spambox.org","spambox.us","spambox.win","spambox.xyz","spamcannon.com","spamcannon.net","spamcero.com","spamcon.org","spamcorptastic.com","spamcowboy.com","spamcowboy.net","spamcowboy.org","spamday.com","spamdecoy.net","spameater.org","spamelka.com","spamex.com","spamfighter.cf","spamfighter.ga","spamfighter.gq","spamfighter.ml","spamfighter.tk","spamfree.eu","spamfree24.com","spamfree24.de","spamfree24.eu","spamfree24.info","spamfree24.net","spamfree24.org","spamgoes.in","spamgourmet.com","spamgourmet.net","spamgourmet.org","spamhole.com","spamify.com","spaminator.de","spamkill.info","spaml.com","spaml.de","spamlot.net","spammail.me","spammedic.com","spammehere.com","spammehere.net","spammingemail.com","spammotel.com","spamobox.com","spamoff.de","spamsalad.in","spamserver.cf","spamserver.ga","spamserver.gq","spamserver.ml","spamserver.tk","spamserver2.cf","spamserver2.ga","spamserver2.gq","spamserver2.ml","spamserver2.tk","spamslicer.com","spamspameverywhere.org","spamsphere.com","spamspot.com","spamstack.net","spamthis.co.uk","spamthisplease.com","spamtrail.com","spamtrap.co","spamtrap.ro","spamtroll.net","spamwc.cf","spamwc.de","spamwc.ga","spamwc.gq","spamwc.ml","spandamail.info","spararam.ru","sparramail.info","spartan-fitness-blog.info","sparxbox.info","spasalonsan.ru","spaso.it","spbdyet.ru","spduszniki.pl","spearsmail.men","spec7rum.me","specialmail.com","specialsshorts.info","spectro.icu","speed.1s.fr","speed.hexhost.pl","speeddategirls.com","speedgaus.net","speedkill.pl","speedyhostpost.net","speemail.info","sperma.cf","sperma.gq","spfence.net","spikio.com","spinacz99.ru","spindl-e.com","spinmail.info","spiriti.tk","spiritjerseysattracting.com","spiritwarlord.com","splendacoupons.org","splendyrwrinkles.com","splishsplash.ru","spm.laohost.net","spmy.netpage.dk","spoksy.info","spoofmail.de","sporexbet.com","sport-polit.com","sport-portalos.com.uk","sport4me.info","sportanswers.ru","sportmiet.ru","sportsa.ovh","sportsallnews.com","sportscape.tv","sportsdeer.com","sportsextreme.ru","sportsfunnyjerseys.com","sportsgames2watch.com","sportsinjapan.com","sportsjapanesehome.com","sportsnewsforfun.com","sportsnflnews.com","sportsshopsnews.com","sportylife.us","spotlightgossip.com","spr.io","sprawdzlokatybankowe.com.pl","spreaddashboard.com","sprin.tf","springcitychronicle.com","spritzzone.de","sprzet.med.com","sps-visualisierung.de","spudiuzdsm.cf","spudiuzdsm.ga","spudiuzdsm.gq","spudiuzdsm.ml","spudiuzdsm.tk","spura2.com.mz","spuramexico2.mx","spuramexico20.com.mx","spuramexico20.mx","spuramexico20012.com","spuramexico20012.com.mx","spuramexico2012.com","spuramexico2012.info","spuramexico2012.net","spuramexico2012.org","spybox.de","spycellphonesoftware.info","spyderskiwearjp.com","spymobilephone.info","spymobilesoftware.info","spyphonemobile.info","spysoftwareformobile.info","sq9999.com","sqiiwzfk.mil.pl","sqoai.com","squirtsnap.com","squizzy.de","squizzy.eu","squizzy.net","sqwtmail.com","sqxx.net","sr.ro.lt","sraka.xyz","srancypancy.net","srenon.com","srestod.net","srhfdhs.com","srku7ktpd4kfa5m.cf","srku7ktpd4kfa5m.ga","srku7ktpd4kfa5m.gq","srku7ktpd4kfa5m.ml","srku7ktpd4kfa5m.tk","sroff.com","srrowuvqlcbfrls4ej9.cf","srrowuvqlcbfrls4ej9.ga","srrowuvqlcbfrls4ej9.gq","srrowuvqlcbfrls4ej9.ml","srrvy25q.atm.pl","srugiel.eu","sry.li","ss-deai.info","ss-hitler.cf","ss-hitler.ga","ss-hitler.gq","ss-hitler.ml","ss-hitler.tk","ss.0x01.tk","ss.undo.it","ss00.cf","ss00.ga","ss00.gq","ss00.ml","ss01.ga","ss01.gq","ss02.cf","ss02.ga","ss02.gq","ss02.ml","ss02.tk","ssacslancelbbfrance2.com","ssangyong.cf","ssangyong.ga","ssangyong.gq","ssangyong.ml","ssanphones.com","ssaofurr.com","sschmid.ml","ssdcgk.com","ssddfxcj.net","ssdfxcc.com","ssdhfh7bexp0xiqhy.cf","ssdhfh7bexp0xiqhy.ga","ssdhfh7bexp0xiqhy.gq","ssdhfh7bexp0xiqhy.ml","ssdhfh7bexp0xiqhy.tk","ssdijcii.com","ssds.com","ssfccxew.com","ssfehtjoiv7wj.cf","ssfehtjoiv7wj.ga","ssfehtjoiv7wj.gq","ssfehtjoiv7wj.ml","ssfehtjoiv7wj.tk","ssgjylc1013.com","sshid.com","sskmail.top","ssl.tls.cloudns.asia","sslglobalnetwork.com","sslporno.ru","sslsecurecert.com","sslsmtp.bid","sslsmtp.download","sslsmtp.racing","sslsmtp.trade","sslsmtp.win","ssnp5bjcawdoby.cf","ssnp5bjcawdoby.ga","ssnp5bjcawdoby.gq","ssnp5bjcawdoby.ml","ssnp5bjcawdoby.tk","sso-demo-okta.com","ssoia.com","ssongs34f.com","sspecialscomputerparts.info","sssdccxc.com","sssppua.cf","sssppua.ga","sssppua.gq","sssppua.ml","sssppua.tk","ssteermail.com","ssunz.cricket","sswinalarm.com","ssxueyhnef01.pl","st-m.cf","st-m.ga","st-m.gq","st-m.ml","st-m.tk","st1.vvsmail.com","stablemail.igg.biz","stacklance.com","stagedandconfused.com","stainlessevil.com","staircraft5.com","stalbud2.com.pl","stalbudd22.pl","stalloy.com","stalos.pl","stampsprint.com","stanbondsa.com.au","standrewswide.co.uk","stanford-edu.tk","stanfordujjain.com","stanleykitchens-zp.in","stanovanjskeprevare.com","starcira.com","stargate1.com","starikmail.in","starlight-breaker.net","starpolyrubber.com","starpower.space","starslots.bid","startation.net","startemail.tk","starterplansmo.info","startfu.com","startkeys.com","startsgreat.ga","startwithone.ga","startymedia.com","stashemail.info","stat.org.pl","statdvr.com","stathost.net","staticintime.de","statiix.com","stationatprominence.com","statloan.info","stattech.info","statusers.com","statuspage.ga","statx.ga","stayfitforever.org","stealbest.com","stealthapps.org","stealthypost.org","steam-area.ru","steambot.net","steamlite.in","steamprank.com","steamreal.ru","steamth.com","steauaeomizerie.com","steauaosuge.com","steemail.ga","steeplion.info","stefhf.nl","steinheart.com.au","stelkendh00.ga","stelliteop.info","steorn.cf","steorn.ga","steorn.gq","steorn.ml","steorn.tk","stepbystepwoodworkingplans.com","steplingdor.com","steplingor.com","stepoffstepbro.com","sterlingsilverflatwareset.net","stermail.flu.cc","steroidi-anaboli.org","steueetxznd.media.pl","stexsy.com","stg.malibucoding.com","stick-tube.com","stiffbook.xyz","stinkefinger.net","stiqx.in","stixinbox.info","stlfasola.com","stokportal.ru","stomach4m.com","stomatolog.pl","stonesmails.cz.cc","stonvpshostelx.com","stop-my-spam.cf","stop-my-spam.com","stop-my-spam.ga","stop-my-spam.ml","stop-my-spam.pp.ua","stop-my-spam.tk","stop-nail-biting.tk","stopbitingyournailsnow.info","stopblackmoldnow.com","stopcheater.com","stopforumforum.com","stopforumspam.info","stopforumspamcom.ru","stopgrowreview.org","stophabbos.tk","stopspamservis.eu","storagehouse.net","storageplacesusa.info","storal.co","storant.co","store.hellomotow.net","store4files.com","storeamnos.co","storechaneljp.org","storeclsrn.xyz","storectic.co","storective.co","storeferragamo.com","storegmail.com","storeillet.co","storellin.co","storendite.co","storenia.co","storent.co","storeodon.co","storeodont.co","storeodoxa.co","storeortyx.co","storeotragus.co","storepradabagsjp.com","storepradajp.com","storereplica.net","storero.co","storestean.co","storesteia.co","storeutics.co","storeweed.co","storewood.co","storeyee.com","storiqax.com","storiqax.top","storist.co","storj99.com","storj99.top","stormynights.org","storrent.net","stovepartes1.com","stpetersandstpauls.xyz","stqffouerchjwho0.cf","stqffouerchjwho0.ga","stqffouerchjwho0.gq","stqffouerchjwho0.ml","stqffouerchjwho0.tk","str1.doramm.com.pl","straightenersaustralia.info","straightenerstylesaustralia.info","straightenerstylescheapuk.info","straightenerstylessaustralia.info","straightenhaircare.com","strapworkout.com","strasbergorganic.com","strawhat.design","stream.gg","streamfly.biz","streamfly.link","streamtv2pc.com","streerd.com","streetwisemail.com","strenmail.tk","stresser.tk","strideritecouponsbox.com","stroitel-ru.com","stromox.com","strona1.pl","stronawww.eu","strongviagra.net","stronnaa.pl","stronnica.pila.pl","strontmail.men","stronywww-na-plus.com.pl","stroutell.ru","stroytehn.com","sts.ansaldo.cf","sts.ansaldo.ga","sts.ansaldo.gq","sts.ansaldo.ml","sts.hitachirail.cf","sts.hitachirail.ga","sts.hitachirail.gq","sts.hitachirail.ml","sts.hitachirail.tk","sts9d93ie3b.cf","sts9d93ie3b.ga","sts9d93ie3b.gq","sts9d93ie3b.ml","sts9d93ie3b.tk","stsfsdf.se","stuckhere.ml","stuckmail.com","studentloaninterestdeduction.info","studentmail.me","students-class1.ml","studiakrakow.eu","studiodesain.me","studiokadr.pl","studiokadrr.pl","studiopolka.tokyo","studioro.review","study-good.ru","stuff.munrohk.com","stuffagent.ru","stuffmail.de","stumblemanage.com","stumpfwerk.com","stwirt.com","styledesigner.co.uk","stylemail.cz.cc","stylepositive.com","stylesmail.org.ua","stylesshets.com","stylishcombatboots.com","stylishdesignerhandbags.info","stylishmichaelkorshandbags.info","stylist-volos.ru","styliste.pro","suamiistribahagia.com","suavietly.com","subaru-brz.cf","subaru-brz.ga","subaru-brz.gq","subaru-brz.ml","subaru-brz.tk","subaru-wrx.cf","subaru-wrx.ga","subaru-wrx.gq","subaru-wrx.ml","subaru-wrx.tk","subaru-xv.cf","subaru-xv.ga","subaru-xv.gq","subaru-xv.ml","subaru-xv.tk","sublingualvitamins.info","subpastore.co","substate.info","suburbanthug.com","succeedabw.com","succeedx.com","successforu.org","successforu.pw","successlocation.work","sucess16.com","suckmyd.com","sucknfuck.date","sucknfuck.site","sudan-nedv.ru","sudaneseoverline.com","sudolife.me","sudolife.net","sudomail.biz","sudomail.com","sudomail.net","sudoverse.com","sudoverse.net","sudoweb.net","sudoworld.com","sudoworld.net","sudurr.mobi","sufit.waw.pl","suhuempek.cf","suhuempek.ga","suhuempek.gq","suhuempek.ml","suhuempek.tk","suhugatel.cf","suhugatel.ga","suhugatel.gq","suhugatel.ml","suhugatel.tk","suhusangar.ml","suioe.com","suitcasesjapan.com","suittrends.com","suiyoutalkblog.com","sujjn9qz.pc.pl","sukaalkuma.com","sukasukasuka.me","sukenjp.com","sull.ga","sullivanscafe.com","sumarymary.xyz","sumberkadalnya.com","sumitra.ga","sumitra.tk","summerswimwear.info","sunbuh.asia","sunburning.ru","sundaysuspense.space","sunerb.pw","sunglassescheapoutlets.com","sunglassespa.com","sunglassesreplica.org","sunglassestory.com","suningsuguo123.info","sunmail.ga","sunmail.ml","sunnysamedayloans.co.uk","sunriver4you.com","sunsamail.info","sunsetclub.pl","sunsetsigns.org","sunsggcvj7hx0ocm.cf","sunsggcvj7hx0ocm.ga","sunsggcvj7hx0ocm.gq","sunsggcvj7hx0ocm.ml","sunsggcvj7hx0ocm.tk","sunshineautocenter.com","sunshineskilled.info","sunsol300.com","suntory.ga","suntory.gq","suoox.com","supappl.me","super-auswahl.de","super-fast-email.bid","super-szkola.pl","superalts.gq","superbemediamail.com","superbmedicines.com","superbowl500.info","superbowlnflravens.com","superbowlravenshop.com","superbwebhost.de","supercheapwow.com","supercoinmail.com","superdieta.ddns.net","supere.ml","superfanta.net","superfastemail.bid","superfinancejobs.org","superforumb.ga","supergreatmail.com","supergreen.com","superintim.com","superior-seo.com","superiormarketers.com","superiorwholesaleblinds.com","supermail.cf","supermail.tk","supermailer.jp","supermails.pl","supermediamail.com","supernews245.de","superpene.com","superplatyna.com","superpsychics.org","superrito.com","superrmail.biz","supersentai.space","superserver.site","supersolarpanelsuk.co.uk","superstachel.de","supervk.net","suples.pl","suppdiwaren.ddns.me.uk","supperdryface-fr.com","supplements.gov","supplywebmail.net","support.com","support22services.com","supra-hot-sale.com","supraoutlet256.com","suprasalestore.com","suprashoesite.com","suprasmail.gdn","suprememarketingcompany.info","suprhost.net","supxmail.info","suratku.dynu.net","surdaqwv.priv.pl","suremail.info","suremail.ml","surfact.eu","surfmail.tk","surfomania.pl","surga.ga","surgerylaser.net","surigaodigitalservices.net","surinam-nedv.ru","surpa1995.info","surrogate-mothers.info","surrogatemothercost.com","surveyrnonkey.net","survivalgears.net","suscm.co.uk","sushiseeker.com","susi.ml","suskapark.com","sussin99gold.co.uk","sususegarcoy.tk","sutann.us","sute.jp","sutenerlubvi.fav.cc","sutiami.cf","sutiami.ga","sutiami.gq","sutiami.ml","sutmail.com","suuyydadb.com","suxt3eifou1eo5plgv.cf","suxt3eifou1eo5plgv.ga","suxt3eifou1eo5plgv.gq","suxt3eifou1eo5plgv.ml","suxt3eifou1eo5plgv.tk","suz99i.it","suzroot.com","suzukilab.net","svadba-talk.com","sverta.ru","svigrxpills.us","svil.net","svip520.cn","svk.jp","svlpackersandmovers.com","svoi-format.ru","svxr.org","svywkabolml.pc.pl","swaidaindustry.org","swapfinancebroker.org","swapinsta.com","swatch.com","sweetheartdress.net","sweetmessage.ga","sweetnessrice.com","sweetnessrice.net","sweetpotato.ml","sweetsfood.ru","sweetsilence.org.ua","sweetville.net","sweetxxx.de","sweetyfoods.ru","swfwbqfqa.pl","swiat-atrakcji.pl","swiatdejwa.pl","swiatimprezek.pl","swiatlemmalowane.pl","swift10minutemail.com","swiftmail.xyz","swimail.info","swinbox.info","swinginggame.com","swissglobalonline.com","swizeland-nedv.ru","swq213567mm.cf","swq213567mm.ga","swq213567mm.gq","swq213567mm.ml","swq213567mm.tk","swqqfktgl.pl","swskrgg4m9tt.cf","swskrgg4m9tt.ga","swskrgg4m9tt.gq","swskrgg4m9tt.ml","swskrgg4m9tt.tk","swtorbots.net","sxrop.com","sxxx.ga","sxxx.gq","sxxx.ml","sxylc113.com","sxzevvhpmitlc64k9.cf","sxzevvhpmitlc64k9.ga","sxzevvhpmitlc64k9.gq","sxzevvhpmitlc64k9.ml","sxzevvhpmitlc64k9.tk","syadouchebag.com","syerqrx14.pl","sykvjdvjko.pl","sylkskinreview.net","sylvannet.com","sylwester.podhale.pl","symphonyresume.com","sympleks.pl","symptoms-diabetes.info","synchtradlibac.xyz","syndicatemortgages.com","synergie.tk","synonyme.email","syosetu.gq","system-2123.com","system-2125.com","system-765.com","system-765.info","system-962.com","system-962.org","systemsflash.net","systemy-call-contact-center.pl","systemyrezerwacji.pl","syujob.accountants","sz13l7k9ic5v9wsg.cf","sz13l7k9ic5v9wsg.ga","sz13l7k9ic5v9wsg.gq","sz13l7k9ic5v9wsg.ml","sz13l7k9ic5v9wsg.tk","szczecin-termoosy.pl","szczepanik14581.co.pl","szef.cn","szeptem.pl","szerz.com","szesc.wiadomosc.pisz.pl","szi4edl0wnab3w6inc.cf","szi4edl0wnab3w6inc.ga","szi4edl0wnab3w6inc.gq","szi4edl0wnab3w6inc.ml","szi4edl0wnab3w6inc.tk","szkolapolicealna.com","szok.xcl.pl","szponki.pl","sztucznapochwa.org.pl","sztyweta46.ga","szucsati.net","szukaj-pracy.info","szxshopping.com","szybki-remoncik.pl","t-shirtcasual.com","t-student.cf","t-student.ga","t-student.gq","t-student.ml","t-student.tk","t.polosburberry.com","t.psh.me","t099.tk","t0fp3r49b.pl","t16nmspsizvh.cf","t16nmspsizvh.ga","t16nmspsizvh.gq","t16nmspsizvh.ml","t16nmspsizvh.tk","t1bkooepcd.cf","t1bkooepcd.ga","t1bkooepcd.gq","t1bkooepcd.ml","t1bkooepcd.tk","t24e4p7.com","t30.cn","t3mtxgg11nt.cf","t3mtxgg11nt.ga","t3mtxgg11nt.gq","t3mtxgg11nt.ml","t3mtxgg11nt.tk","t3t97d1d.com","t4tmb2ph6.pl","t5h65t54etttr.cf","t5h65t54etttr.ga","t5h65t54etttr.gq","t5h65t54etttr.ml","t5h65t54etttr.tk","t5sxp5p.pl","t5vbxkpdsckyrdrp.cf","t5vbxkpdsckyrdrp.ga","t5vbxkpdsckyrdrp.gq","t5vbxkpdsckyrdrp.ml","t5vbxkpdsckyrdrp.tk","t6khsozjnhqr.cf","t6khsozjnhqr.ga","t6khsozjnhqr.gq","t6khsozjnhqr.ml","t6khsozjnhqr.tk","t6qdua.bee.pl","t6xeiavxss1fetmawb.ga","t6xeiavxss1fetmawb.ml","t6xeiavxss1fetmawb.tk","t76o11m.mil.pl","t77eim.mil.pl","t7qriqe0vjfmqb.ga","t7qriqe0vjfmqb.ml","t7qriqe0vjfmqb.tk","t8kco4lsmbeeb.cf","t8kco4lsmbeeb.ga","t8kco4lsmbeeb.gq","t8kco4lsmbeeb.ml","t8kco4lsmbeeb.tk","ta-6.com","tab-24.pl","tabithaanaya.livefreemail.top","tabletas.top","tabletdiscountdeals.com","tabletki-lysienie.pl","tabletki.org","tabletkinaodchudzanie.biz.pl","tabletkinapamiec.xyz","tabletrafflez.info","tabletstoextendthepenis.info","tablighat24.com","tac0hlfp0pqqawn.cf","tac0hlfp0pqqawn.ga","tac0hlfp0pqqawn.ml","tac0hlfp0pqqawn.tk","tacomacardiology.com","tadacipprime.com","tafmail.com","tafoi.gr","tafrem3456ails.com","tafrlzg.pl","tagcams.com","taglead.com","tagmymedia.com","tagyourself.com","tahmin.info","tahnaforbie.xyz","tahutex.online","tai-asu.cf","tai-asu.ga","tai-asu.gq","tai-asu.ml","tai-nedv.ru","taidar.ru","taikhoanao.tk","takashishimizu.com","takatato.pl","takeawaythis.org.ua","takedowns.org","takeitme.site","takeitsocial.com","takenews.com","takepeak.xyz","takeshobo.cf","takeshobo.ga","takeshobo.gq","takeshobo.ml","takeshobo.tk","takesonetoknowone.com","takmailing.com","takmemberi.cf","takmemberi.gq","talahicc.com","talkinator.com","talkmises.com","tamail.com","tamanhodopenis.biz","tamanhodopenis.info","tambahlagi.online","tambakrejo.cf","tambakrejo.ga","tambakrejo.tk","tamera.eu","tammega.com","tampa-seo.us","tampaflcomputerrepair.com","tampasurveys.com","tampatailor.com","tamuhost.me","tandberggroup.com","tandbergonline.com","tandy.co","tangarinefun.com","tangocharlie.101livemail.top","tanihosting.net.pl","taniiepozyczki.pl","taninsider.com","tansmail.ga","tantedewi.ml","tanukis.org","tao399.com","taokhienfacebook.com","taosjw.com","tapchicuoihoi.com","tapetoland.pl","tapety-download.pl","taphear.com","tapsitoaktl353t.ga","tar00ih60tpt2h7.cf","tar00ih60tpt2h7.ga","tar00ih60tpt2h7.gq","tar00ih60tpt2h7.ml","tar00ih60tpt2h7.tk","tarciano.com","tarcuttgige.eu","tarlancapital.com","tarma.cf","tarma.ga","tarma.ml","tarma.tk","tarzanmail.cf","tarzanmail.ml","taskforcetech.com","taskscbo.com","tasmakarta.pl","tastaravalli.tk","tastyarabicacoffee.com","tastyemail.xyz","tatapeta.pl","tatbuffremfastgo.com","tatersik.eu","tattoopeace.com","taucoindo.site","taufik.sytes.net","taufikrt.ddns.net","tauttjar3r46.cf","tawagnadirect.us","tawny.roastedtastyfood.com","taxfreeemail.com","taxi-france.com","taxi-vovrema.info","taylorventuresllc.com","tayo.ooo","tayohei-official.com","tazpkrzkq.pl","tb-on-line.net","tbrfky.com","tbwzidal06zba1gb.cf","tbwzidal06zba1gb.ga","tbwzidal06zba1gb.gq","tbwzidal06zba1gb.ml","tbwzidal06zba1gb.tk","tbxmakazxsoyltu.cf","tbxmakazxsoyltu.ga","tbxmakazxsoyltu.gq","tbxmakazxsoyltu.ml","tbxmakazxsoyltu.tk","tbxqzbm9omc.cf","tbxqzbm9omc.ga","tbxqzbm9omc.gq","tbxqzbm9omc.ml","tbxqzbm9omc.tk","tc4q7muwemzq9ls.ml","tc4q7muwemzq9ls.tk","tcases.com","tcfr2ulcl9cs.cf","tcfr2ulcl9cs.ga","tcfr2ulcl9cs.gq","tcfr2ulcl9cs.ml","tcfr2ulcl9cs.tk","tchatroulette.eu","tchvn.tk","tcnmistakes.com","tcsqzc04ipp9u.cf","tcsqzc04ipp9u.ga","tcsqzc04ipp9u.gq","tcsqzc04ipp9u.ml","tcsqzc04ipp9u.tk","tcua9bnaq30uk.cf","tcua9bnaq30uk.ga","tcua9bnaq30uk.gq","tcua9bnaq30uk.ml","tcua9bnaq30uk.tk","tdf-illustration.com","tdfwld7e7z.cf","tdfwld7e7z.ga","tdfwld7e7z.gq","tdfwld7e7z.ml","tdfwld7e7z.tk","tdovk626l.pl","te.caseedu.tk","te2jrvxlmn8wetfs.gq","te2jrvxlmn8wetfs.ml","te2jrvxlmn8wetfs.tk","te5s5t56ts.ga","tea-tins.com","teachingjobshelp.com","teamandclub.ga","teambogor.online","teamkg.tk","teamrnd.win","teamspeak3.ga","teamviewerindirsene.com","teaparty-news.com","tebwinsoi.ooo","tecemail.top","tech.edu","tech5group.com","tech69.com","techcenter.biz","techemail.com","techfevo.info","techgroup.me","techgroup.top","techindo.web.id","techlabreviews.com","techloveer.com","techmail.info","technicolor.cf","technicolor.ga","technicolor.gq","technicolor.ml","technicsan.ru","technidem.fr","technikue.men","techno5.club","technocape.com","technoinsights.info","technoproxy.ru","techstat.net","techuppy.com","tecninja.xyz","tecnosmail.com","tedswoodworking.science","teemia.com","teemoloveulongtime.com","teenanaltubes.com","teerest.com","teewars.org","tefer.gov","tefl.ro","tegifehurez.glogow.pl","tegnabrapal.me","tehdini.cf","tehdini.ga","tehdini.gq","tehdini.ml","tehoopcut.info","tehs8ce9f9ibpskvg.cf","tehs8ce9f9ibpskvg.ga","tehs8ce9f9ibpskvg.gq","tehs8ce9f9ibpskvg.ml","tehs8ce9f9ibpskvg.tk","tehsusu.cf","tehsusu.ga","tehsusu.gq","tehsusu.ml","teimur.com","tejmail.pl","telecharger-films-megaupload.com","telechargerpiratertricher.info","telechargervideosyoutube.fr","telecomix.pl","telefony-opinie.pl","telekbird.com.cn","telekgaring.cf","telekgaring.ga","telekgaring.gq","telekgaring.ml","telekteles.cf","telekteles.ga","telekteles.gq","telekteles.ml","telekucing.cf","telekucing.ga","telekucing.gq","telekucing.ml","teleosaurs.xyz","telephoneportableoccasion.eu","teleuoso.com","teleworm.com","teleworm.us","tellos.xyz","telmail.top","telukmeong1.ga","telukmeong2.cf","telukmeong3.ml","temail.com","teman-bangsa.com","temasekmail.com","temasparawordpress.es","temengaming.com","temp-email.ru","temp-emails.com","temp-link.net","temp-mail.com","temp-mail.de","temp-mail.info","temp-mail.live","temp-mail.ml","temp-mail.net","temp-mail.org","temp-mail.pp.ua","temp-mail.ru","temp-mails.com","temp.aogoen.com","temp.bartdevos.be","temp.cloudns.asia","temp.emeraldwebmail.com","temp.headstrong.de","temp.mail.y59.jp","temp.wheezer.net","temp1.club","temp15qm.com","temp2.club","tempail.com","tempalias.com","tempcloud.info","tempe-mail.com","tempekmuta.cf","tempekmuta.ga","tempekmuta.gq","tempekmuta.ml","tempemail.biz","tempemail.co","tempemail.co.za","tempemail.com","tempemail.info","tempemail.org","tempemail.pro","tempemailaddress.com","tempemails.io","tempinbox.co.uk","tempinbox.com","tempinbox.xyz","tempm.cf","tempm.com","tempm.ga","tempm.gq","tempm.ml","tempmail.co","tempmail.de","tempmail.eu","tempmail.io","tempmail.it","tempmail.net","tempmail.pp.ua","tempmail.pro","tempmail.space","tempmail.sytes.net","tempmail.top","tempmail.us","tempmail.website","tempmail.win","tempmail.ws","tempmail2.com","tempmailapp.com","tempmaildemo.com","tempmailer.com","tempmailer.de","tempmailid.com","tempmailid.net","tempmailid.org","tempmailo.com","tempmails.cf","tempmails.gq","tempmails.org","tempomail.fr","tempomail.org","temporamail.com","temporarily.de","temporarioemail.com.br","temporary-email.com","temporary-email.world","temporary-mail.net","temporaryemail.net","temporaryemail.us","temporaryforwarding.com","temporaryinbox.com","temporarymail.ga","temporarymail.org","temporarymailaddress.com","tempr.email","tempremail.cf","tempremail.tk","tempsky.com","tempthe.net","tempymail.com","tempzo.info","temr0520cr4kqcsxw.cf","temr0520cr4kqcsxw.ga","temr0520cr4kqcsxw.gq","temr0520cr4kqcsxw.ml","temr0520cr4kqcsxw.tk","tenesu.tk","tennesseeinssaver.com","tennisan.ru","tenniselbowguide.info","tennisnews4ever.info","tepos12.eu","tepzo.com","terahack.com","teraz.artykulostrada.pl","terika.net","termail.com","terminalerror.com","terminate.tech","ternaklele.ga","terra7.com","tert353ayre6tw.ml","tesiov.info","tessen.info","test.actess.fr","test.com","test.crowdpress.it","test.de","teste445k.ga","tester-games.ru","testerino.tk","testforcextremereviews.com","testoforcereview.net","testoh.cf","testoh.ga","testoh.gq","testoh.ml","testoh.tk","testore.co","testosterone-tablets.com","testosteroneforman.com","testoweprv.pl","testsmails.tk","testudine.com","tethjdt.com","teufelsweb.com","texac0.cf","texac0.ga","texac0.gq","texac0.ml","texac0.tk","texansportsshop.com","texansproteamsshop.com","texas-nedv.ru","textad.us","textmedude.cf","textmedude.ga","textmedude.gq","textmedude.ml","textmedude.tk","textwebs.info","textyourexbackreviewed.org","tezdbz8aovezbbcg3.cf","tezdbz8aovezbbcg3.ga","tezdbz8aovezbbcg3.gq","tezdbz8aovezbbcg3.ml","tezdbz8aovezbbcg3.tk","tezzmail.host","tf5bh7wqi0zcus.cf","tf5bh7wqi0zcus.ga","tf5bh7wqi0zcus.gq","tf5bh7wqi0zcus.ml","tf5bh7wqi0zcus.tk","tf7nzhw.com","tfgphjqzkc.pl","tfwno.gf","tfzav6iptxcbqviv.cf","tfzav6iptxcbqviv.ga","tfzav6iptxcbqviv.gq","tfzav6iptxcbqviv.ml","tfzav6iptxcbqviv.tk","tggmalls.com","tgiq9zwj6ttmq.cf","tgiq9zwj6ttmq.ga","tgiq9zwj6ttmq.gq","tgiq9zwj6ttmq.ml","tgiq9zwj6ttmq.tk","tgntcexya.pl","tgpix.net","tgszgot72lu.cf","tgszgot72lu.ga","tgszgot72lu.gq","tgszgot72lu.ml","tgszgot72lu.tk","tgxvhp5fp9.cf","tgxvhp5fp9.ga","tgxvhp5fp9.gq","tgxvhp5fp9.ml","tgxvhp5fp9.tk","th3ts2zurnr.cf","th3ts2zurnr.ga","th3ts2zurnr.gq","th3ts2zurnr.ml","th3ts2zurnr.tk","thaiedvisa.com","thailaaa.org.ua","thailand-mega.com","thailandresort.asia","thailandstayeasy.com","thailongstayjapanese.com","thaivisa.cc","thaivisa.es","thaki8ksz.info","thangberus.net","thangmay.biz","thangmay.com","thangmay.com.vn","thangmay.net","thangmay.org","thangmay.vn","thangmaydaiphong.com","thangmaygiadinh.com","thangmayhaiduong.com","thangmaythoitrang.vn","thanksnospam.info","thankyou2010.com","thankyou2014.com","thatim.info","thc.st","the-boots-ugg.com","the-classifiedads-online.info","the-dating-jerk.com","the-first.email","the-louis-vuitton-outlet.com","the-popa.ru","the-source.co.il","the.celebrities-duels.com","the2012riots.info","theacneblog.com","theairfilters.com","theallgaiermogensen.com","theangelwings.com","theaperturelabs.com","theaperturescience.com","thearunsounds.org","theaviors.com","thebat.client.blognet.in","thebearshark.com","thebeatlesbogota.com","thebest4ever.com","thebestarticles.org","thebestmoneymakingtips.info","thebestremont.ru","thebestrolexreplicawatches.com","thebestwebtrafficservices.info","thebluffersguidetoit.com","thebytehouse.info","thechemwiki.org","thecity.biz","thecloudindex.com","thecoalblog.com","theconsumerclub.org","thecontainergroup.com.au","thedarkmaster097.sytes.net","thedealsvillage.com","thedepression.com","thediamants.org","thedietsolutionprogramreview.com","thedigitalphotoframe.com","thedimcafe.com","thedirhq.info","thedocerosa.com","theeasymail.com","theemailaccount.com","theemailadress.com","theexitgroup.com","thefactsproject.org","thefalconsshop.com","thefatloss4idiotsreview.org","thefatlossfactorreview.info","thefatlossfactorreviews.co","thefatlossfactorreviews.com","thefirstticket.com","thefitnessgeek.com","thefitnessguru.org","thefitnesstrail.com","theflexbelt.info","theforgotten-soldiers.com","thega.ga","thegatefirm.com","theghdstraighteners.com","theglockner.com","theglockneronline.com","thehagiasophia.com","thehosh.com","thehypothyroidismrevolutionreview.com","theindiaphile.com","theinfomarketing.info","theinsuranceinfo.org","theinternetpower.info","theittechblog.com","thejoaocarlosblog.tk","thekamasutrabooks.com","thekitchenfairypc.com","thekittensmurf.com","thelavalamp.info","thelifeguardonline.com","thelightningmail.net","thelimestones.com","themagicofmakingupreview.info","themail.krd.ag","themailemail.com","themailmall.com","themailpro.net","themarketingsolutions.info","thematicworld.pl","thembones.com.au","themedicinehat.net","themeg.co","themegreview.com","themogensen.com","themoneysinthelist.com","themoon.co.uk","themostemail.com","themulberrybags.us","themulberrybagsuksale.com","themule.net","thenewsdhhayy.com","thenflpatriotshop.com","thenflravenshop.com","thenoftime.org.ua","thenorth-face-shop.com","thenorthfaceoutletb.com","thenorthfaceoutletk.com","thenumberonemattress.com","theodore1818.site","theone-blue.com","theone2017.us","theopposition.club","theorlandoguide.net","theothermail.com","theoverlandtandberg.com","thepaleoburnsystem.com","theparryscope.com","thepascher.com","thepieter.com","thepieteronline.com","thepillsforcellulite.info","thepinkbee.com","thepit.ml","thepitujk79mgh.tk","theplug.org","thepsoft.org","thequickreview.com","thequickstuff.info","theravensshop.com","therealdealblogs.com","thereareemails.xyz","thereddoors.online","thermoconsulting.pl","thermoplasticelastomer.net","thermostatreviews.org","theroyalweb.club","thescrappermovie.com","theseodude.co.uk","theskymail.com","theslatch.com","thesophiaonline.com","thespawningpool.com","thestats.top","thesunshinecrew.com","theta.whiskey.webmailious.top","thetaoofbadassreviews.info","thetayankee.webmailious.top","theteastory.info","thetechpeople.net","thetechteamuk.com","thetrash.email","thetrommler.com","thetruthaboutfatburningfoodsreview.org","theugg-outletshop.com","thevibram-fivefingers.com","thewaterenhancer.com","thewebbusinessresearch.com","thewhitebunkbed.co.uk","thewickerbasket.net","thewoodenstoragebeds.co.uk","thex.ro","thexgenmarketing.info","thextracool.info","thidthid.cf","thidthid.ga","thidthid.gq","thidthid.ml","thiet-ke-web.org","thietbivanphong.asia","thinkbigholdings.com","thinkingus24.com","this-is-a-free-domain.usa.cc","thisismyemail.xyz","thisisnotmyrealemail.com","thismail.net","thistime.uni.me","thistimedd.tk","thistimenow.org.ua","thisurl.website","thnikka.com","thoas.ru","thodetading.xyz","thoitrang.vn","thoitrangcongso.vn","thoitrangthudong.vn","thomasedisonlightbulb.net","thomsonmail.us.pn","thongtinchung.com","thousandoakscarpetcleaning.net","thqdiviaddnef.com","thqdivinef.com","thraml.com","three.emailfake.ml","three.fackme.gq","threecreditscoresreview.com","thrma.com","throam.com","thrott.com","throwam.com","throwawayemail.com","throwawayemailaddress.com","throwawaymail.com","throwawaymail.pp.ua","throwawaymail.uu.gl","throya.com","thrubay.com","thsideskisbrown.com","thtt.us","thug.pw","thuguimomo.ga","thund.cf","thund.ga","thund.gq","thund.ml","thund.tk","thunderballs.net","thunderbolt.science","thunkinator.org","thurstoncounty.biz","thuthuatlamseo.com","thxmate.com","thyfre.cf","thyfre.ga","thyfre.gq","thyfre.ml","thyroidtips.info","thzhhe5l.ml","ti.igg.biz","tiapz.com","tic.ec","ticket-please.ga","ticketb.com","ticketkick.com","ticketwipe.com","ticklecontrol.com","tieungoc.life","tiguanreview.com","tijdelijke-email.nl","tijdelijkmailadres.nl","tilien.com","tillerrakes.com","tillion.com","timail.ml","timberlandboot4sale.com","timberlandf4you.com","timberlandfordonline.com","time4areview.com","timeavenue.fr","timecomp.pl","timecritics.com","timegv.com","timekr.xyz","timgiarevn.com","timgmail.com","timkassouf.com","tinmail.tk","tinnitusmiraclereviews.org","tinnitusremediesforyou.com","tinoza.org","tintremovals.com","tiny.itemxyz.com","tinyurl24.com","tioforsellhotch.xyz","tipidfranchise.com","tipsb.com","tipsonhowtogetridofacne.com","tipsshortsleeve.com","tirixix.pl","tirreno.cf","tirreno.ga","tirreno.gq","tirreno.ml","tirreno.tk","tirsmail.info","tirupatitemple.net","tissernet.com","titan-host.cf","titan-host.ga","titan-host.gq","titan-host.ml","titan-host.tk","titanemail.info","titas.cf","titaskotom.cf","titaskotom.ga","titaskotom.gq","titaskotom.ml","titaskotom.tk","titaspaharpur.cf","titaspaharpur.ga","titaspaharpur.gq","titaspaharpur.ml","titaspaharpur.tk","titaspaharpur1.cf","titaspaharpur1.ga","titaspaharpur1.gq","titaspaharpur1.ml","titaspaharpur1.tk","titaspaharpur2.cf","titaspaharpur2.ga","titaspaharpur2.gq","titaspaharpur2.ml","titaspaharpur2.tk","titaspaharpur3.cf","titaspaharpur3.ga","titaspaharpur3.gq","titaspaharpur3.ml","titaspaharpur3.tk","titaspaharpur4.cf","titaspaharpur4.ga","titaspaharpur4.gq","titaspaharpur4.ml","titaspaharpur4.tk","titaspaharpur5.cf","titaspaharpur5.ga","titaspaharpur5.gq","titaspaharpur5.ml","titaspaharpur5.tk","titkiprokla.tk","titmail.com","tittbit.in","tiv.cc","tivowxl7nohtdkoza.cf","tivowxl7nohtdkoza.ga","tivowxl7nohtdkoza.gq","tivowxl7nohtdkoza.ml","tivowxl7nohtdkoza.tk","tizi.com","tjjlkctec.pl","tjuew56d0xqmt.cf","tjuew56d0xqmt.ga","tjuew56d0xqmt.gq","tjuew56d0xqmt.ml","tjuew56d0xqmt.tk","tk-poker.com","tk3od4c3sr1feq.cf","tk3od4c3sr1feq.ga","tk3od4c3sr1feq.gq","tk3od4c3sr1feq.ml","tk3od4c3sr1feq.tk","tk4535z.pl","tk8phblcr2ct0ktmk3.ga","tk8phblcr2ct0ktmk3.gq","tk8phblcr2ct0ktmk3.ml","tk8phblcr2ct0ktmk3.tk","tkaniny.com","tkaninymaxwell.pl","tkeiyaku.cf","tkhaetgsf.pl","tkitc.de","tkjngulik.com","tkmy88m.com","tko.co.kr","tko.kr","tkzumbsbottzmnr.cf","tkzumbsbottzmnr.ga","tkzumbsbottzmnr.gq","tkzumbsbottzmnr.ml","tkzumbsbottzmnr.tk","tl8dlokbouj8s.cf","tl8dlokbouj8s.gq","tl8dlokbouj8s.ml","tl8dlokbouj8s.tk","tldoe8nil4tbq.cf","tldoe8nil4tbq.ga","tldoe8nil4tbq.gq","tldoe8nil4tbq.ml","tldoe8nil4tbq.tk","tlgpwzmqe.pl","tlpn.org","tls.cloudns.asia","tlumaczeniawaw.com.pl","tlvl8l66amwbe6.cf","tlvl8l66amwbe6.ga","tlvl8l66amwbe6.gq","tlvl8l66amwbe6.ml","tlvl8l66amwbe6.tk","tlvsmbdy.cf","tlvsmbdy.ga","tlvsmbdy.gq","tlvsmbdy.ml","tlvsmbdy.tk","tm.in-ulm.de","tm.slsrs.ru","tm.tosunkaya.com","tm2mail.com","tm42.gq","tm95xeijmzoxiul.cf","tm95xeijmzoxiul.ga","tm95xeijmzoxiul.gq","tm95xeijmzoxiul.ml","tm95xeijmzoxiul.tk","tmail.com","tmail.org","tmail.run","tmail.ws","tmail1.tk","tmail2.tk","tmail3.tk","tmail4.tk","tmail5.tk","tmailcloud.net","tmaildir.com","tmailffrt.com","tmailhost.com","tmailinator.com","tmails.net","tmailservices.com","tmnuuq6.mil.pl","tmo.kr","tmp.k3a.me","tmp.refi64.com","tmpeml.info","tmpjr.me","tmpmail.net","tmpmail.org","tmtfdpxpmm12ehv0e.cf","tmtfdpxpmm12ehv0e.ga","tmtfdpxpmm12ehv0e.gq","tmtfdpxpmm12ehv0e.ml","tmtfdpxpmm12ehv0e.tk","tmzh8pcp.agro.pl","tnnairmaxpasch.com","tnrequinacheter.com","tnrequinboutinpascheresfrance.com","tnrequinpascherboutiquenlignefr.com","tnrequinpaschertnfr.com","tnrequinpaschertnfrance.com","tnrequinstocker.com","tntitans.club","tnvrtqjhqvbwcr3u91.cf","tnvrtqjhqvbwcr3u91.ga","tnvrtqjhqvbwcr3u91.gq","tnvrtqjhqvbwcr3u91.ml","tnvrtqjhqvbwcr3u91.tk","tnwvhaiqd.pl","to-boys.com","toal.com","toastmatrix.com","toastsum.com","tobeluckys.com","tobycarveryvouchers.com","tobyye.com","tocheif.com","todayemail.ga","todaygroup.us","todayinstantpaydayloans.co.uk","todays-web-deal.com","toddsbighug.com","todogestorias.es","todongromau.com","todoprestamos.com","todoprestamos.es","toenailmail.info","toerkmail.com","toerkmail.net","togelprediksi.com","togetaloan.co.uk","togetheragain.org.ua","tohetheragain.org.ua","tohurt.me","toi.kr","toiea.com","toihocseo.com","tokatta.org","tokeishops.jp","tokem.co","tokenmail.de","tokkabanshop.com","tokoinduk.com","tokuriders.club","tol.ooo","tolls.com","tolongsaya.me","tolufan.ru","tomageek.com","tomatonn.com","tomehi.com","tomejl.pl","tommymorris.com","tomshoesonline.net","tomshoesonlinestore.com","tomshoesoutletonline.net","tomshoesoutletus.com","tomsoutletsalezt.com","tomsoutletw.com","tomsoutletzt.com","tomsshoeoutletzt.com","tomsshoesonline4.com","tomsshoesonsale4.com","tomsshoesonsale7.com","tomsshoesoutlet2u.com","tomthen.org.ua","tomymailpost.com","tonermix.ru","tonngokhong.vn","tonno.cf","tonno.gq","tonno.ml","tonno.tk","tonymanso.com","tonyplace.com","too879many.info","tool-9-you.com","tool.pp.ua","toolsfly.com","toolyoareboyy.com","toomail.biz","toomail.net","toon.ml","tooslowtodoanything.com","toothandmail.com","top-mailer.net","top-mails.net","top-shop-tovar.ru","top100mail.com","top101.de","top10movies.info","top1mail.ru","top1post.ru","top3chwilowki.pl","top4th.in","top5news.fun","top9appz.info","topazpro.xyz","topbagsforsale.info","topbananamarketing.co.uk","topbuysteroids.com","topbuysteroids365.com","topclassemail.online","topdiane35.pl","topdrivers.top","topeducationvn.cf","topeducationvn.ga","topeducationvn.gq","topeducationvn.ml","topeducationvn.tk","topemail24.info","toperhophy.xyz","topfivestars.fun","tophandbagsbrands.info","tophealthinsuranceproviders.com","topikt.com","topinbox.info","topinrock.cf","toplessbucksbabes.us","topmail.bid","topmail.net","topmail.org","topmail24.ru","topmail4u.eu","topmailer.info","topmailings.com","topmailmantra.net","topmall.com","topmall.info","topmall.org","topmumbaiproperties.com","topofertasdehoy.com","toposterclippers.com","toppartners.cf","toppartners.ga","toppartners.gq","toppartners.ml","toppartners.tk","toppieter.com","topplayers.fun","topqualityjewelry.info","topranklist.de","toprumours.com","topsecretvn.cf","topsecretvn.ga","topsecretvn.gq","topsecretvn.ml","topsecretvn.tk","topseos.com","topshoppingmalls.info","topsourcemedia5.info","topstorewearing.com","toptextloans.co.uk","toptransfer.cf","toptransfer.ga","toptransfer.gq","toptransfer.ml","toptransfer.tk","toptravelbg.pl","topwebinfos.info","topwebplacement.com","topwm.org","tora1.info","torbecouples.org","torbenetwork.net","torch.yi.org","tordamyco.xyz","toreandrebalic.com","torgoviy-dom.com","tori.ru","torm.xyz","tormail.net","tormail.org","tornbanner.com","torneomail.ga","tornovi.net","torontogooseoutlet.com","torrentinos.net","tory-burch-brand.com","toryburch-outletsonline.us","toryburchjanpanzt.com","toryburchjapaneses.com","toryburchjapans.com","toss.pw","tosunkaya.com","total-research.com","totalhealthy.fun","totalhentai.net","totalpoolservice.com","totalvista.com","totelouisvuittonshops.com","toteshops.com","totesmail.com","totoan.info","totobet.club","totolotoki.pl","totse1voqoqoad.cf","totse1voqoqoad.ga","totse1voqoqoad.gq","totse1voqoqoad.ml","totse1voqoqoad.tk","toughness.org","touoejiz.pl","tourbalitravel.com","tourcatalyst.com","tourmalinehairdryerz.com","tournament-challenge.com","tourtripbali.com","tovhtjd2lcp41mxs2.cf","tovhtjd2lcp41mxs2.ga","tovhtjd2lcp41mxs2.gq","tovhtjd2lcp41mxs2.ml","tovhtjd2lcp41mxs2.tk","tovip.net","towb.cf","towb.ga","towb.gq","towb.ml","towb.tk","towndewerap23.eu","toy-coupons.org","toy-guitars.com","toy68n55b5o8neze.cf","toy68n55b5o8neze.ga","toy68n55b5o8neze.gq","toy68n55b5o8neze.ml","toy68n55b5o8neze.tk","toyhiosl.com","toyiosk.gr","toyota-rav-4.cf","toyota-rav-4.ga","toyota-rav-4.gq","toyota-rav-4.ml","toyota-rav-4.tk","toyota-rav4.cf","toyota-rav4.ga","toyota-rav4.gq","toyota-rav4.ml","toyota-rav4.tk","toyota-yaris.tk","toyota.cellica.com","toyotacelica.com","toyotalife22.org","toys-r-us-coupon-codes.com","toys.dogsupplies4sale.com","toys.ie","toysfortots2007.com","toysgifts.info","toysikio.gr","tp-qa-mail.com","tp54lxfshhwik5xuam.cf","tp54lxfshhwik5xuam.ga","tp54lxfshhwik5xuam.gq","tp54lxfshhwik5xuam.ml","tp54lxfshhwik5xuam.tk","tpaglucerne.dnset.com","tpbank.gq","tpfqxbot4qrtiv9h.cf","tpfqxbot4qrtiv9h.ga","tpfqxbot4qrtiv9h.gq","tpfqxbot4qrtiv9h.ml","tpfqxbot4qrtiv9h.tk","tpg24.com","tpmail.top","tpobaba.com","tpsdq0kdwnnk5qhsh.ml","tpsdq0kdwnnk5qhsh.tk","tpte.org","tpyy57aq.pl","tq3.pl","tq84vt9teyh.cf","tq84vt9teyh.ga","tq84vt9teyh.gq","tq84vt9teyh.ml","tq84vt9teyh.tk","tql4swk9wqhqg.gq","tqoai.com","tqophzxzixlxf3uq0i.cf","tqophzxzixlxf3uq0i.ga","tqophzxzixlxf3uq0i.gq","tqophzxzixlxf3uq0i.ml","tqophzxzixlxf3uq0i.tk","tqosi.com","tqwagwknnm.pl","tr.pozycjonowanie8.pl","tr2k.cf","tr2k.ga","tr2k.gq","tr2k.ml","tr2k.tk","tr32qweq.com","tracciabi.li","tracker.peacled.xyz","tradaswacbo.eu","trade-finance-broker.org","tradefinanceagent.org","tradefinancebroker.org","tradefinancedealer.org","tradeinvestmentbroker.org","tradermail.info","tradex.gb","trading-courses.org","trafficreviews.org","trafik.co.pl","tragaver.ga","trainingcamera.com","trainingpedia.online","tralalajos.ga","tralalajos.gq","tralalajos.ml","tralalajos.tk","trallal.com","tramecpolska.com.pl","tranceversal.com","trangmuon.com","transfaraga.co.in","transgenicorganism.com","transistore.co","transitionsllc.com","translationserviceonline.com","transmissioncleaner.com","transportationfreightbroker.com","trash-amil.com","trash-mail.at","trash-mail.cf","trash-mail.com","trash-mail.de","trash-mail.ga","trash-mail.gq","trash-mail.ml","trash-mail.net","trash-mail.tk","trash-me.com","trash2009.com","trash2010.com","trash2011.com","trash247.com","trash4.me","trashbox.eu","trashcanmail.com","trashdevil.com","trashdevil.de","trashemail.de","trashemails.de","trashimail.de","trashinbox.com","trashinbox.net","trashmail.app","trashmail.at","trashmail.com","trashmail.de","trashmail.ga","trashmail.gq","trashmail.io","trashmail.me","trashmail.net","trashmail.org","trashmail.pw","trashmail.ws","trashmailer.com","trashmails.com","trashspam.com","trashymail.com","trashymail.net","trasz.com","travala10.com","travel-e-store.com","travel-singapore-with-me.com","travelingcome.com","travelparka.pl","travelsaroundasia.com","travelsdoc.ru","travelsta.tk","travelstep.ru","travelua.ru","travissharpe.net","trayna.com","trazimdevojku.in.rs","trbvm.com","trbvn.com","trbvo.com","trcprebsw.pl","treasuregem.info","treatmentans.ru","treatmented.info","treatmentsforherpes.com","trebusinde.cf","trebusinde.ml","tredinghiahs.com","treecon.pl","treehouseburning.com","treeremovalmichigan.com","trend-maker.ru","trendbettor.com","trendingtopic.cl","trendstomright.com","trenerfitness.ru","trenord.cf","trenord.ga","trenord.gq","trenord.ml","trenord.tk","tressicolli.com","tretinoincream-05.com","tretmuhle.com","trg.pw","trgovinanaveliko.info","tri-es.ru","triadelta.com","trialmail.de","trialseparationtop.com","tribesascendhackdownload.com","tribonox79llr.tk","tricdistsiher.xyz","trickmail.net","trickminds.com","trickphotographyreviews.net","trickupdaily.com","trickupdaily.net","tricoulesmecher.com","tridalinbox.info","triedbook.xyz","trillianpro.com","trimsj.com","triparish.net","tripolis.com","tristanabestolaf.com","tristarasdfdk1parse.net","triteksolution.info","trixtrux1.ru","trobertqs.com","trojanmail.ga","trol.com","trollproject.com","trommlergroup.com","trommleronline.com","trommlershop.com","tron.pl","tropicalbass.info","tropicpvp.ml","trssdgajw.pl","truckaccidentlawyerpennsylvania.org","truckmetalworks.com","trucmai.cf","trucmai.ml","trucmai.tk","true-religion.cc","trueedhardy.com","truereligionbrandmart.com","truereligionjeansdublin.eu","trulli.pl","trumanpost.com","trumgamevn.ml","trump.flu.cc","trump.igg.biz","trumpmail.cf","trumpmail.ga","trumpmail.gq","trumpmail.ml","trumpmail.tk","trung.name.vn","trungtamtoeic.com","trungthu.ga","trushsymptomstreatment.com","trustablehosts.com","trusted-canadian-online-pharmacy.com","trustedproducts.info","trustingfunds.ltd","truthaboutcellulitereviews.com","truvisagereview.com","trxsuspension.us","trxubcfbyu73vbg.ga","trxubcfbyu73vbg.ml","trxubcfbyu73vbg.tk","try-rx.com","tryalert.com","trymail.tk","tryninja.io","tryprice.co","tryuf5m9hzusis8i.cf","tryuf5m9hzusis8i.ga","tryuf5m9hzusis8i.gq","tryuf5m9hzusis8i.ml","tryuf5m9hzusis8i.tk","tryzoe.com","ts-by-tashkent.cf","ts-by-tashkent.ga","ts-by-tashkent.gq","ts-by-tashkent.ml","ts-by-tashkent.tk","ts93crz8fo5lnf.cf","ts93crz8fo5lnf.ga","ts93crz8fo5lnf.gq","ts93crz8fo5lnf.ml","ts93crz8fo5lnf.tk","tsamoncler.info","tsas.tr","tshirtformens.com","tsj.com.pl","tsk.tk","tsmc.mx","tsnmw.com","tspace.net","tspzeoypw35.ml","tsukushiakihito.gq","tt2dx90.com","ttbbc.com","ttdfytdd.ml","ttirv.com","ttirv.net","ttirv.org","ttoubdzlowecm7i2ua8.cf","ttoubdzlowecm7i2ua8.ga","ttoubdzlowecm7i2ua8.gq","ttoubdzlowecm7i2ua8.ml","ttoubdzlowecm7i2ua8.tk","ttrzgbpu9t6drgdus.cf","ttrzgbpu9t6drgdus.ga","ttrzgbpu9t6drgdus.gq","ttrzgbpu9t6drgdus.ml","ttrzgbpu9t6drgdus.tk","ttszuo.xyz","ttt72pfc0g.cf","ttt72pfc0g.ga","ttt72pfc0g.gq","ttt72pfc0g.ml","ttt72pfc0g.tk","tttttyrewrw.xyz","ttusrgpdfs.pl","ttxcom.info","ttytgyh56hngh.cf","ttyuhjk.co.uk","tu6oiu4mbcj.cf","tu6oiu4mbcj.ga","tu6oiu4mbcj.gq","tu6oiu4mbcj.ml","tu6oiu4mbcj.tk","tualias.com","tubanmentol.ml","tube-dns.ru","tube-ff.com","tube-lot.ru","tube-over-hd.ru","tube-rita.ru","tubeadulte.biz","tubebob.ru","tubeftw.com","tubegain.com","tubeteen.ru","tubodamagnifica.com","tubruk.trade","tubzesk.org","tucboxy.com","tucineestiba.com","tucumcaritonite.com","tug.minecraftrabbithole.com","tuhsuhtzk.pl","tuimail.ml","tujimastr09lioj.ml","tukudawet.tk","tukulyagan.com","tukupedia.co","tulnl.xyz","tulsa.gov","tumjsnceh.pl","tunacrispy.com","tuncpersonel.com","tunezja-przewodnik.pl","tungsten-carbide.info","tunis-nedv.ru","tunmanageservers.com","tunningmail.gdn","tuofs.com","tuongtactot.tk","tuphmail.com","tuposti.net","tupuduku.pw","turbobania.com","turbomail.ovh","turbospinz.co","turkey-nedv.ru","turknet.com","turoid.com","turual.com","tusitiowebgratis.com.ar","tusitowebserver.com","tut-zaycev.net","tutis.me","tutsport.ru","tutushop.com","tutusweetshop.com","tutye.com","tuugo.com","tuvimoingay.us","tuyulmokad.ml","tuyulmokad.tk","tvchd.com","tvcs.co","tvelef2khzg79i.cf","tvelef2khzg79i.ga","tvelef2khzg79i.gq","tvelef2khzg79i.ml","tvelef2khzg79i.tk","tverya.com","tvi72tuyxvd.cf","tvi72tuyxvd.ga","tvi72tuyxvd.gq","tvi72tuyxvd.ml","tvi72tuyxvd.tk","tvonlayn2.ru","twddos.net","tweakacapun.wwwhost.biz","tweakly.net","twelvee.us","twinklegalaxy.com","twinmail.de","twinsbrand.com","twinzero.net","twirlygirl.info","twitt3r.cf","twitt3r.ga","twitt3r.gq","twitt3r.ml","twitt3r.tk","twitteraddersoft.com","twitterfree.com","twitterparty.ru","twitterreviewer.tk","twkly.ml","twlcd4i6jad6.cf","twlcd4i6jad6.ga","twlcd4i6jad6.gq","twlcd4i6jad6.ml","twlcd4i6jad6.tk","two.emailfake.ml","two.fackme.gq","two.haddo.eu","two0aks.com","twocowmail.net","twojalawenda.pl","twojapozyczka.online","twoje-nowe-biuro.pl","twojekonto.pl","tworcyatrakcji.pl","tworcyimprez.pl","tworzenieserwisow.com","twoweirdtricks.com","twsexy66.info","txmovingquotes.com","txpwg.usa.cc","txrsvu8dhhh2znppii.cf","txrsvu8dhhh2znppii.ga","txrsvu8dhhh2znppii.gq","txrsvu8dhhh2znppii.ml","txrsvu8dhhh2znppii.tk","txt.flu.cc","txt10xqa7atssvbrf.cf","txt10xqa7atssvbrf.ga","txt10xqa7atssvbrf.gq","txt10xqa7atssvbrf.ml","txt10xqa7atssvbrf.tk","txt7e99.com","txtadvertise.com","txv4lq0i8.pl","ty.ceed.se","ty.squirtsnap.com","ty12umail.com","tyclonecuongsach.site","tyeo.ga","tyhe.ro","tyhrf.jino.ru","tyldd.com","tylerexpress.com","tylko-dobre-lokaty.com.pl","tymail.top","tympe.net","tynkowanie-cktynki.pl","typepoker.com","typesoforchids.info","typlrqbhn.pl","tyskali.org","tytfhcghb.ga","tyuitu.com","tyuty.net","tz.tz","tzarmail.info","tzqmirpz0ifacncarg.cf","tzqmirpz0ifacncarg.gq","tzqmirpz0ifacncarg.tk","tzrtrapzaekdcgxuq.cf","tzrtrapzaekdcgxuq.ga","tzrtrapzaekdcgxuq.gq","tzrtrapzaekdcgxuq.ml","tzrtrapzaekdcgxuq.tk","u-torrent.cf","u-torrent.ga","u-torrent.gq","u-wills-uc.pw","u.0u.ro","u.10x.es","u.2sea.org","u.900k.es","u.civvic.ro","u.dmarc.ro","u.labo.ch","u.qvap.ru","u03.gmailmirror.com","u0qbtllqtk.cf","u0qbtllqtk.ga","u0qbtllqtk.gq","u0qbtllqtk.ml","u0qbtllqtk.tk","u1.myftp.name","u14269.gq","u14269.ml","u1gdt8ixy86u.cf","u1gdt8ixy86u.ga","u1gdt8ixy86u.gq","u1gdt8ixy86u.ml","u1gdt8ixy86u.tk","u2.net.pl","u2b.comx.cf","u336.com","u3t9cb3j9zzmfqnea.cf","u3t9cb3j9zzmfqnea.ga","u3t9cb3j9zzmfqnea.gq","u3t9cb3j9zzmfqnea.ml","u3t9cb3j9zzmfqnea.tk","u4iiaqinc365grsh.cf","u4iiaqinc365grsh.ga","u4iiaqinc365grsh.gq","u4iiaqinc365grsh.ml","u4iiaqinc365grsh.tk","u4jhrqebfodr.cf","u4jhrqebfodr.ml","u4jhrqebfodr.tk","u4nzbr5q3.com","u5tbrlz3wq.cf","u5tbrlz3wq.ga","u5tbrlz3wq.gq","u5tbrlz3wq.ml","u5tbrlz3wq.tk","u6lvty2.com","u7vt7vt.cf","u7vt7vt.ga","u7vt7vt.gq","u7vt7vt.ml","u7vt7vt.tk","u8mpjsx0xz5whz.cf","u8mpjsx0xz5whz.ga","u8mpjsx0xz5whz.gq","u8mpjsx0xz5whz.ml","u8mpjsx0xz5whz.tk","ua3jx7n0w3.com","ua6htwfwqu6wj.cf","ua6htwfwqu6wj.ga","ua6htwfwqu6wj.gq","ua6htwfwqu6wj.ml","ua6htwfwqu6wj.tk","uacro.com","uacrossad.com","uaemail.com","uafebox.com","uafusjnwa.pl","uajgqhgug.pl","uamail.com","uapproves.com","uarara5ryura46.ga","uat6m3.pl","uatop.in","uautfgdu35e71m.cf","uautfgdu35e71m.ga","uautfgdu35e71m.gq","uautfgdu35e71m.ml","uautfgdu35e71m.tk","ubamail.com","ubcategories.com","ubdeexu2ozqnoykoqn8.ml","ubdeexu2ozqnoykoqn8.tk","uber-mail.com","uberdriver-taxi.ru","ubermail.info","ubermail39.info","ubermember.com","ubfre2956mails.com","ubismail.net","ublomail.com","ubm.md","ubmail.com","ubumail.com","ubuntu.dns-cloud.net","ubuntu.dnsabr.com","ubuntu.org","ubwerrr.com","ubwerrrd.com","ubziemail.info","ucandobest.pw","ucansuc.pw","ucavlq9q3ov.cf","ucavlq9q3ov.ga","ucavlq9q3ov.gq","ucavlq9q3ov.ml","ucavlq9q3ov.tk","ucche.us","ucemail.com","ucgbc.org","ucho.top","ucimail.com","ucir.org","ucmamail.com","ucq9vbhc9mhvp3bmge6.cf","ucq9vbhc9mhvp3bmge6.ga","ucq9vbhc9mhvp3bmge6.gq","ucq9vbhc9mhvp3bmge6.ml","ucupdong.ml","ucw8rp2fnq6raxxm.cf","ucw8rp2fnq6raxxm.ga","ucw8rp2fnq6raxxm.gq","ucw8rp2fnq6raxxm.ml","ucw8rp2fnq6raxxm.tk","ucylu.com","udbaccount.com","udec.edu","udemail.com","udmail.com","udns.cf","udns.gq","udns.tk","udoiswell.pw","udozmail.com","udruzenjejez.info","udsc.edu","uduomail.com","ue90x.com","uegumail.com","ueiaco100.info","ueig2phoenix.info","ueimultimeter.info","uemail99.com","uenct2012.info","ueno-kojun.com","uewryweqiwuea.tk","ufa-decor.ru","ufa-nedv.ru","ufacturing.com","ufbpq9hinepu9k2fnd.cf","ufbpq9hinepu9k2fnd.ga","ufbpq9hinepu9k2fnd.gq","ufbpq9hinepu9k2fnd.ml","ufbpq9hinepu9k2fnd.tk","ufcboxingfight.info","ufficialeairmax.com","ufgqgrid.xyz","ufhuheduf.com","ufi9tsftk3a.pl","ufibmail.com","ufk3rtwyb.pl","ufmncvmrz.pl","ufrbox.net","ufxcnboh4hvtu4.cf","ufxcnboh4hvtu4.ga","ufxcnboh4hvtu4.gq","ufxcnboh4hvtu4.ml","ufxcnboh4hvtu4.tk","ugf1xh8.info.pl","ugg-bootsoutletclearance.info","uggboos-online.com","uggbootoutletonline.com","uggboots-uksale.info","uggboots.com","uggbootscom.com","uggbootsever.com","uggbootsins.com","uggbootsonlinecheap.com","uggbootssale-discount.us","uggbootssale.com","uggbootssales.com","uggbuystorejp.com","uggjimmystores.com","uggpaschermz.com","uggs-canadaonline.info","uggs-outletstores.info","uggs.co.uk","uggsale-uk.info","uggsart.com","uggsguide.org","uggshopsite.org","uggsiteus.com","uggsnowbootsoline.com","uggsoutlet-online.info","uggsrock.com","ughsalecc.com","ugimail.com","ugimail.net","ugipmail.com","uglewmail.pw","ugmail.com","ugonnamoveit.info","ugreatejob.pw","uguuchantele.com","uha.kr","uhds.tk","uhefmail.com","uhhu.ru","uhjyzglhrs.pl","uhmail.com","uho1nhelxmk.ga","uho1nhelxmk.gq","uho1nhelxmk.ml","uho1nhelxmk.tk","ui-feed.com","uigfruk8.com","uighugugui.com","uikd.com","uilfemcjsn.pl","uiqaourlu.pl","uiu.us","ujafmail.com","ujames3nh.com","ujapbk1aiau4qwfu.cf","ujapbk1aiau4qwfu.ga","ujapbk1aiau4qwfu.gq","ujapbk1aiau4qwfu.ml","ujapbk1aiau4qwfu.tk","ujijima1129.gq","ujmail.com","ujrmail.com","ujuzesyz.swiebodzin.pl","ujxspots.com","uk-beauty.co.uk","uk-nedv.ru","uk-tvshow.com","uk-unitedkingdom.cf","uk-unitedkingdom.ga","uk-unitedkingdom.gq","uk-unitedkingdom.ml","uk-unitedkingdom.tk","uk.flu.cc","uk.igg.biz","uk.nut.cc","uk.org","uk.slowdeer.com","uk.to","ukairmax4cheap.com","ukairmaxshoe.com","ukboer.cc","ukbootsugg.co.uk","ukcompanies.org","ukddamip.co","ukdressessale.com","ukescortdirectories.com","ukeveningdresses.com","ukexample.com","ukfreeisp.co.uk","ukhollisterer.co.uk","ukhollisteroutlet4s.co.uk","ukhollisteroutlet4u.co.uk","ukhollisteroutletlondon.co.uk","ukhost-uk.co.uk","ukimail.com","ukjton.cf","ukjton.ga","ukjton.gq","ukjton.ml","ukjton.tk","ukleadingb2b.info","uklouboutinuk.com","uklouboutinuksale.com","uklouisvuittonoutletzt.co.uk","ukmail.com","ukmuvkddo.pl","ukniketrainerssale.com","uknowmyname.info","uko.kr","ukolhgfr.mns.uk","ukoutletkarenmillendresses.org","ukpayday24.com","ukpensionsadvisor.tk","ukpostmail.com","ukr-nedv.ru","ukr-po-v.co.cc","ukrainaharnagay.shn-host.ru","ukrtovar.ru","uks5.com","uksnapback.com","uksnapbackcap.com","uksnapbackcaps.com","uksnapbackhat.com","uksnapbacks.com","uksurveyors.org","uktaxrefund.info","uktrainers4sale.com","uktrainersale.com","uktrainerssale.com","ukyfemfwc.pl","ukymail.com","ulahadigung.cf","ulahadigung.ga","ulahadigung.gq","ulahadigung.ml","ulahadigung.tk","ulahadigungproject.cf","ulahadigungproject.ga","ulahadigungproject.gq","ulahadigungproject.ml","ulahadigungproject.tk","ulaptopsn.com","ulemail.com","ulmich.edu","ulqoirraschifer.cf","ulqoirraschifer.ga","ulqoirraschifer.gq","ulqoirraschifer.ml","ulqoirraschifer.tk","ultimatebusinessservices.com","ultra-nyc.com","ultra.fyi","ultrada.ru","ultradrugbuy.com","ultrafitnessguide.com","ultramoviestreams.com","ultraste.ml","ultraxmail.pw","ultrtime.org.ua","ulumdocab.xyz","ulzlemwzyx.pl","umail.net","umail2.com","umail4less.bid","umail4less.men","umbrellascolors.info","umehlunua.pl","umessage.cf","umgewichtzuverlieren.com","ummail.com","umniy-zavod.ru","umrn.ga","umrn.gq","umrn.ml","umrohdulu.com","umscoltd.com","umumwqrb9.pl","umy.kr","unclebobscoupons.com","uncond.us","undeadforum.com","undersky.org.ua","undeva.net","undo.it","undoubtedchanelforsale.com","uneppwqi.pl","unevideox.fr","unfilmx.fr","ungolfclubs.com","unheatedgems.net","unicredit.tk","unids.com","unif8nthemsmnp.cf","unif8nthemsmnp.ga","unif8nthemsmnp.gq","unif8nthemsmnp.ml","unif8nthemsmnp.tk","uniform.november.aolmail.top","uniformpapa.wollomail.top","unijnedotacje.info.pl","unimail.com","unimark.org","uniquebedroom-au.com","uniquebrand.pl","uniqueseo.pl","unireaurzicenikaput.com","unisexjewelry.org","unit7lahaina.com","unite.cloudns.asia","unitedbullionexchange.com","unitymail.me","unitymail.pro","universallightkeys.com","universityincanada.info","universityla.edu","unjouruncercueil.com","unkn0wn.ws","unlimit.com","unlimitedfullmoviedownload.tk","unlimitedreviews.com","unlimpokecoins.org","unmail.com","unmail.ru","unomail.com","unopol-bis.pl","unot.in","unpastore.co","unrealsoft.tk","unseen.eu","unsy3woc.aid.pl","uny.kr","uo8fylspuwh9c.cf","uo8fylspuwh9c.ga","uo8fylspuwh9c.gq","uo8fylspuwh9c.ml","uo8fylspuwh9c.tk","uo93a1bg7.pl","uoadoausa.pl","uoft.edu.com","uogimail.com","uojjhyhih.cf","uojjhyhih.ga","uojjhyhih.gq","uojjhyhih.ml","uonyc.org","uotluok.com","uouweoq132.info","upamail.com","updates9z.com","upelmail.com","upf7qtcvyeev.cf","upf7qtcvyeev.ga","upf7qtcvyeev.gq","upf7qtcvyeev.tk","upgcsjy.com","uphomail.ga","upimage.net","upimail.com","upliftnow.com","uplipht.com","uploadnolimit.com","upmail.com","upmedio.com","upozowac.info","upppc.com","upsidetelemanagementinc.biz","upskirtscr.com","uptimebee.com","uptodate.tech","uptuber.info","upumail.com","upurfiles.com","upy.kr","uqcgga04i1gfbqf.cf","uqcgga04i1gfbqf.ga","uqcgga04i1gfbqf.gq","uqcgga04i1gfbqf.ml","uqcgga04i1gfbqf.tk","uqdxyoij.auto.pl","uqemail.com","uqghq6tvq1p8c56.cf","uqghq6tvq1p8c56.ga","uqghq6tvq1p8c56.gq","uqghq6tvq1p8c56.ml","uqghq6tvq1p8c56.tk","uqmail.com","uqopmail.com","uqxcmcjdvvvx32.cf","uqxcmcjdvvvx32.ga","uqxcmcjdvvvx32.gq","uqxcmcjdvvvx32.ml","uqxcmcjdvvvx32.tk","uralplay.ru","urbanbreaks.com","urbanchickencoop.com","urbanstudios.online","urbsound.com","urcemxrmd.pl","urchatz.ga","uredemail.com","ureee.us","uremail.com","urfey.com","urfunktion.se","urhen.com","urid-answer.ru","urirmail.com","url.gen.in","urleur.com","urltc.com","urlwave.org","urodzinydlaadzieci.pl","uroetueptriwe.cz.cc","uroid.com","uronva.com","uruarurqup5ri9s28ki.cf","uruarurqup5ri9s28ki.ga","uruarurqup5ri9s28ki.gq","uruarurqup5ri9s28ki.ml","uruarurqup5ri9s28ki.tk","urugvai-nedv.ru","urx7.com","us-uggboots.com","us.af","us.dlink.cf","us.dlink.gq","us.to","usa-cc.usa.cc","usa-gov.cf","usa-gov.ga","usa-gov.gq","usa-gov.ml","usa-gov.tk","usa-nedv.ru","usa-tooday.biz","usa.cc","usa.isgre.at","usa623.gq","usachan.cf","usachan.gq","usachan.ml","usaf.dmtc.press","usagoodloan.com","usahandbagsonlinestorecoach.com","usajacketoutletsale.com","usako.be","usako.net","usalol.ru","usalvmalls.com","usamail.com","usaonline.biz","usapurse.com","usareplicawatch.com","usbdirect.ca","usbgadgetsusage.info","usbmicrophone.org.uk","uscalfgu.biz","uscaves.com","uscoachoutletstoreonlinezt.com","uscosplay.com","used-product.fr","usedcarsinpl.eu","usedcarsjacksonms.xyz","usenergypro.com","usenetmail.tk","useplace.ru","user.bottesuggds.com","user.peoplesocialspace.com","userdrivvers.ru","username.e4ward.com","userseo.ga","usharingk.com","ushijima1129.cf","ushijima1129.ga","ushijima1129.gq","ushijima1129.ml","ushijima1129.tk","usiaj.com","usiportal.ru","usitv.ga","uslouisvuittondamier.com","uslugi-i-tovary.ru","uslugiseo.warszawa.pl","uslyn.com","usmailstar.com","ussv.club","ut6jlkt9.pl","ut6rtiy1ajr.ga","ut6rtiy1ajr.gq","ut6rtiy1ajr.ml","ut6rtiy1ajr.tk","utahmail.com","utangsss.online","utc7xrlttynuhc.cf","utc7xrlttynuhc.ga","utc7xrlttynuhc.gq","utc7xrlttynuhc.ml","utc7xrlttynuhc.tk","utiket.us","utilities-online.info","utilsans.ru","utmail.com","utoi.cu.uk","utoo.email","utooemail.com","uttoymdkyokix6b3.cf","uttoymdkyokix6b3.ga","uttoymdkyokix6b3.gq","uttoymdkyokix6b3.ml","uttoymdkyokix6b3.tk","uttvgar633r.cf","uttvgar633r.ga","uttvgar633r.gq","uttvgar633r.ml","uttvgar633r.tk","utwevq886bwc.cf","utwevq886bwc.ga","utwevq886bwc.gq","utwevq886bwc.ml","utwevq886bwc.tk","uu.gl","uu1.pl","uu2.ovh","uudimail.com","uugmail.com","uukx.info","uul.pl","uumail.com","uumjdnff.pl","uunifonykrakow.pl","uurksjb7guo0.cf","uurksjb7guo0.ga","uurksjb7guo0.gq","uurksjb7guo0.ml","uurksjb7guo0.tk","uuroalaldoadkgk058.cf","uuups.ru","uvamail.com","uvdi.net","uvmail.com","uvomail.com","uvoofiwy.pl","uvvc.info","uvy.kr","uvyuviyopi.cf","uvyuviyopi.ga","uvyuviyopi.gq","uvyuviyopi.ml","uvyuviyopi.tk","uw5t6ds54.com","uwamail.com","uwemail.com","uwillsuc.pw","uwimail.com","uwmail.com","uwomail.com","uwork4.us","ux.dob.jp","ux.uk.to","uxlxpc2df3s.pl","uxs14gvxcmzu.cf","uxs14gvxcmzu.ga","uxs14gvxcmzu.gq","uxs14gvxcmzu.ml","uxs14gvxcmzu.tk","uxzicou.pl","uydagdmzsc.cf","uydagdmzsc.ga","uydagdmzsc.gq","uydagdmzsc.ml","uydagdmzsc.tk","uyemail.com","uyhip.com","uymail.com","uyp5qbqidg.cf","uyp5qbqidg.ga","uyp5qbqidg.gq","uyp5qbqidg.ml","uyp5qbqidg.tk","uyu.kr","uyx3rqgaghtlqe.cf","uyx3rqgaghtlqe.ga","uyx3rqgaghtlqe.gq","uyx3rqgaghtlqe.ml","uyx3rqgaghtlqe.tk","uz6tgwk.com","uzbekistan-nedv.ru","uzgrthjrfr4hdyy.gq","uzmail.com","uzrip.com","uzxia.cf","uzxia.com","uzxia.ga","uzxia.gq","uzxia.ml","uzxia.tk","uzy8wdijuzm.pl","v-bucks.money","v-dosuge.ru","v-kirove.ru","v-mail.xyz","v-science.ru","v-soc.ru","v.0v.ro","v.jsonp.ro","v.olvos90.tk","v.polosburberry.com","v00qy9qx4hfmbbqf.cf","v00qy9qx4hfmbbqf.ga","v00qy9qx4hfmbbqf.gq","v00qy9qx4hfmbbqf.ml","v00qy9qx4hfmbbqf.tk","v0domwwkbyzh1vkgz.cf","v0domwwkbyzh1vkgz.ga","v0domwwkbyzh1vkgz.gq","v0domwwkbyzh1vkgz.ml","v0domwwkbyzh1vkgz.tk","v21.me.uk","v27hb4zrfc.cf","v27hb4zrfc.ga","v27hb4zrfc.gq","v27hb4zrfc.ml","v27hb4zrfc.tk","v3bsb9rs4blktoj.cf","v3bsb9rs4blktoj.ga","v3bsb9rs4blktoj.gq","v3bsb9rs4blktoj.ml","v3bsb9rs4blktoj.tk","v4gdm4ipndpsk.cf","v4gdm4ipndpsk.ga","v4gdm4ipndpsk.gq","v4gdm4ipndpsk.ml","v4gdm4ipndpsk.tk","v58tk1r6kp2ft01.cf","v58tk1r6kp2ft01.ga","v58tk1r6kp2ft01.gq","v58tk1r6kp2ft01.ml","v58tk1r6kp2ft01.tk","v6iexwlhb6n2hf.ga","v6iexwlhb6n2hf.gq","v6iexwlhb6n2hf.ml","v6iexwlhb6n2hf.tk","v7brxqo.pl","v7ecub.com","v7g2w7z76.pl","v7px49yk.pl","va5vsqerkpmsgibyk.cf","va5vsqerkpmsgibyk.ga","va5vsqerkpmsgibyk.gq","va5vsqerkpmsgibyk.ml","va5vsqerkpmsgibyk.tk","vaasfc4.tk","vaati.org","vacancies-job.info","vacationrentalshawaii.info","vacwdlenws604.ml","vadlag.xyz","vaffanculo.gq","vafleklassniki.ru","vafrem3456ails.com","vaginkos.com","vagmag.com","vagsuerokgxim1inh.cf","vagsuerokgxim1inh.ga","vagsuerokgxim1inh.gq","vagsuerokgxim1inh.ml","vagsuerokgxim1inh.tk","vagus.com","vaik.cf","vaik.ga","vaik.gq","vaik.ml","vaik.tk","vajq8t6aiul.cf","vajq8t6aiul.ga","vajq8t6aiul.gq","vajq8t6aiul.ml","vajq8t6aiul.tk","valdezmail.men","valemail.net","valhalladev.com","valleyinnmistake.info","valtresttranach.website","valtrexprime.com","valtrexrxonline.com","valuablegyan.com","vanacken.xyz","vanbil.tk","vancemail.men","vandorrenn.com","vanhoangtn1.ga","vanhoangtn1.ooo","vanhoangtn1.us","vanilkin.ru","vankin.de","vanmail.com","vantaxi.pl","vanuatu-nedv.ru","vanvalu.linuxpl.info","varialomail.biz","vaudit.ru","vaultoffer.info","vaultpoint.us","vaultsophia.com","vaultsophiaonline.com","vay.kr","vaycongso.vn","vaymail.com","vayme.com","vba.kr","vba.rzeszow.pl","vbdwreca.com","vbha0moqoig.ga","vbha0moqoig.ml","vbha0moqoig.tk","vcbmail.ga","vcbox.pro","vcghv0eyf3fr.cf","vcghv0eyf3fr.ga","vcghv0eyf3fr.gq","vcghv0eyf3fr.ml","vcghv0eyf3fr.tk","vctel.com","vcticngsh5.ml","vda.ro","vdig.com","vdmmhozx5kxeh.cf","vdmmhozx5kxeh.ga","vdmmhozx5kxeh.gq","vdmmhozx5kxeh.ml","vdmmhozx5kxeh.tk","vdnetmail.gdn","vdp8ehmf.edu.pl","vdy.itx.mybluehost.me","ve8zum01pfgqvm.cf","ve8zum01pfgqvm.ga","ve8zum01pfgqvm.gq","ve8zum01pfgqvm.ml","ve8zum01pfgqvm.tk","ve9xvwsmhks8wxpqst.cf","ve9xvwsmhks8wxpqst.ga","ve9xvwsmhks8wxpqst.gq","ve9xvwsmhks8wxpqst.ml","ve9xvwsmhks8wxpqst.tk","veanlo.com","vedid.com","vedioo.com","vedmail.com","vedula.com","veebee.cf","veebee.ga","veebee.gq","veebee.ml","veebee.tk","vefspchlzs2qblgoodf.ga","vefspchlzs2qblgoodf.ml","vefspchlzs2qblgoodf.tk","vegasworlds.com","vegsthetime.org.ua","vehicleowners.tk","vektik.com","veldmail.ga","velourareview.net","velourclothes.com","velourclothes.net","veloxmail.pw","vemaybaygiare.com","vemaybaytetgiare.com","vemomail.win","vendorbrands.com","venesuela-nedv.ru","vengr-nedv.ru","venompen.com","venturacarpetcleaning.net","ventureschedule.com","ventureuoso.com","venue-ars.com","venuears.com","venusandmarssextoys.com","venusfactorreviews.co","veo.kr","vepa.info","vepklvbuy.com","ver0.cf","ver0.ga","ver0.gq","ver0.ml","ver0.tk","vercelli.cf","vercelli.ga","vercelli.gq","vercelli.ml","verdejo.com","verfisigca.xyz","verifymail.cf","verifymail.ga","verifymail.gq","verifymail.ml","verifymail.win","verisign.cf","verisign.ga","verisign.gq","veritybusinesscenter.pl","verizondw.com","vermutlich.net","verniprava.com","vernz.cf","vernz.ga","vernz.gq","vernz.ml","vernz.tk","veromodaonlineshop.com","verrabahu.xyz","verterygiep.com","vertiuoso.com","verybad.co.uk","veryday.ch","veryday.eu","veryday.info","verydrunk.co.uk","verymit.com","veryprice.co","veryrealemail.com","veryrude.co.uk","verywise.co.uk","vesa.pw","veska.pl","vettery.cf","vettery.gq","vettery.ml","vettery.tk","veve.decisivetalk.com","vex4.top","veyera.tk","vfemail.net","vfienvtua2dlahfi7.cf","vfienvtua2dlahfi7.ga","vfienvtua2dlahfi7.gq","vfienvtua2dlahfi7.ml","vfienvtua2dlahfi7.tk","vfj9g3vcnj7kadtty.cf","vfj9g3vcnj7kadtty.ga","vfj9g3vcnj7kadtty.gq","vfj9g3vcnj7kadtty.ml","vfj9g3vcnj7kadtty.tk","vgamers.win","vgatodviadapter.com","vgfjj85.pl","vggboutiqueenlignefr1.com","vgsreqqr564.cf","vgsreqqr564.ga","vgsreqqr564.gq","vgsreqqr564.ml","vgsreqqr564.tk","vgxwhriet.pl","vhan.tech","vhglvi6o.com","vhntp15yadrtz0.cf","vhntp15yadrtz0.ga","vhntp15yadrtz0.gq","vhntp15yadrtz0.ml","vhntp15yadrtz0.tk","via-paypal.com","via.tokyo.jp","viagra-cheap.org","viagra-withoutadoctorprescription.com","viagra.com","viagracy.com","viagrageneric-usa.com","viagranowdirect.com","viagraonlineedshop.com","viagrasy.com","viagrawithoutadoctorprescription777.bid","viajando.net","viano.com","viantakte.ru","vibi4f1pc2xjk.cf","vibi4f1pc2xjk.ga","vibi4f1pc2xjk.gq","vibi4f1pc2xjk.ml","vibi4f1pc2xjk.tk","vices.biz","vickaentb.cf","vickaentb.ga","vickaentb.gq","vickaentb.ml","vickaentb.tk","victime.ninja","victor.whiskey.coayako.top","victoriantwins.com","victoriazakopane.pl","victorsierra.spithamail.top","vidchart.com","video-16porno.fr","video-insanity.com","video-tube-club.ru","video.ddnsking.com","video35.com","videogamefeed.info","videophotos.ru","videos.mothere.com","videos.zonerig.com","videotubegames.ru","videoxx-francais.fr","viditag.com","vidssa.com","vieebee.cf","vieebee.ga","vieebee.gq","vieebee.tk","vienna.cf","vietnam-nedv.ru","vietvoters.org","viewcastmedia.com","viewcastmedia.net","viewcastmedia.org","vigil4synod.org","vigra-tadacip.info","vigratadacip.info","vigrxpills.us","vihost.ml","vihost.tk","vijayanchor.com","vikingglass-kr.info","vikingsonly.com","viktminskningsnabbt.net","villabhj.com","villadipuncak.com","villapuncak.org","villarrealmail.men","vilnapresa.com","vimail24.com","vincenza1818.site","vinerabazar.com","vinernet.com","vinhsu.info","vinsmoke.tech","vintagefashionblog.org","vip-dress.net","vip-intim-dosug.ru","vip-mail.ml","vip-mail.tk","vip-payday-loans.com","vip-replica1.eu","vip-watches.ru","vip-watches1.eu","vip.188.com","vip.aiot.eu.org","vip.cool","vip.dmtc.press","vip.hstu.eu.org","vip.sohu.com","vip.sohu.net","vip.tom.com","vipchristianlouboutindiscount.com","vipcodes.info","vipepe.com","vipfon.ru","vipgod.ru","viphomeljjljk658.info","viphone.eu.org","viplvoutlet.com","vipmail.in","vipmail.name","vipmail.net","vipmail.pw","vipnikeairmax.co.uk","vipraybanuk.co.uk","vipsmail.us","vipsohu.net","vipxm.net","vir.waw.pl","viral-science.fun","viralhits.org","viralplays.com","viralvideosf.com","virarproperty.co.in","virgilio.ga","virgilio.gq","virgilio.ml","virgiliomail.cf","virgiliomail.ga","virgiliomail.gq","virgiliomail.ml","virgiliomail.tk","virginsrus.xyz","virgoans.co.uk","viroleni.cu.cc","virtual-email.com","virtualemail.info","virtualtags.co","virtuf.info","virusfreeemail.com","visa-securepay.cf","visa-securepay.ga","visa-securepay.gq","visa-securepay.ml","visa-securepay.tk","visa.coms.hk","visa.dns-cloud.net","visa.dnsabr.com","visal007.tk","visal168.cf","visal168.ga","visal168.gq","visal168.ml","visal168.tk","visalaw.ru","visalus.com","visaua.ru","visiondating.info","visionwithoutglassesscam.org","visitinbox.com","visitnorwayusa.com","visitorratings.com","visitxhot.org","visitxx.com","vista-tube.ru","vistarto.co.cc","vistomail.com","vistore.co","visualfx.com","visualimpactreviews.com","vitalyzereview.com","vitamin-water.net","vitamins.com","vitaminsdiscounter.com","vividbase.xyz","vivie.club","viwsala.com","vixletdev.com","vixmalls.com","vizi-forum.com","vizi-soft.com","vizstar.net","vjr.luk2.com","vk-app-online.ru","vk-appication.ru","vk-apps-online.ru","vk-com-application.ru","vk-fb-ok.ru","vk-goog.ru","vk-nejno-sladko.ru","vk-net-app.ru","vk-net-application.ru","vk-russkoe.ru","vk-tvoe.ru","vkcode.ru","vkdmtzzgsx.pl","vkdmtzzgsxa.pl","vkilotakte.ru","vkontakteemail.co.cc","vkoxtakte.ru","vkoztakte.ru","vkpornoprivate.ru","vkusno-vse.ru","vl2ivlyuzopeawoepx.cf","vl2ivlyuzopeawoepx.ga","vl2ivlyuzopeawoepx.gq","vl2ivlyuzopeawoepx.ml","vl2ivlyuzopeawoepx.tk","vlipbttm9p37te.cf","vlipbttm9p37te.ga","vlipbttm9p37te.gq","vlipbttm9p37te.ml","vlipbttm9p37te.tk","vlote.ru","vlsca8nrtwpcmp2fe.cf","vlsca8nrtwpcmp2fe.ga","vlsca8nrtwpcmp2fe.gq","vlsca8nrtwpcmp2fe.ml","vlsca8nrtwpcmp2fe.tk","vlstwoclbfqip.cf","vlstwoclbfqip.ga","vlstwoclbfqip.gq","vlstwoclbfqip.ml","vlstwoclbfqip.tk","vlwomhm.xyz","vmail.me","vmail.tech","vmailcloud.com","vmailing.info","vmailpro.net","vmani.com","vmentorgk.com","vmhdisfgxxqoejwhsu.cf","vmhdisfgxxqoejwhsu.ga","vmhdisfgxxqoejwhsu.gq","vmhdisfgxxqoejwhsu.ml","vmhdisfgxxqoejwhsu.tk","vmlfwgjgdw2mqlpc.cf","vmlfwgjgdw2mqlpc.ga","vmlfwgjgdw2mqlpc.ml","vmlfwgjgdw2mqlpc.tk","vmpanda.com","vn92wutocpclwugc.cf","vn92wutocpclwugc.ga","vn92wutocpclwugc.gq","vn92wutocpclwugc.ml","vn92wutocpclwugc.tk","vncoders.net","vncwyesfy.pl","vndfgtte.com","vnedu.me","vnhojkhdkla.info","vnshare.info","vodka.in","voemail.com","vogrxtwas.pl","void.maride.cc","voidbay.com","voiture.cf","volgograd-nedv.ru","volkswagen-ag.cf","volkswagen-ag.ga","volkswagen-ag.gq","volkswagen-ag.ml","volkswagen-ag.tk","volkswagenamenageoccasion.fr","voltaer.com","volvo-ab.cf","volvo-ab.ga","volvo-ab.gq","volvo-ab.ml","volvo-ab.tk","volvo-s60.cf","volvo-s60.ga","volvo-s60.gq","volvo-s60.ml","volvo-s60.tk","volvo-v40.ml","volvo-v40.tk","volvo-xc.ml","volvo-xc.tk","volvogroup.ga","volvogroup.gq","volvogroup.ml","volvogroup.tk","volvopenta.tk","vomoto.com","vonbe.tk","vorga.org","vorscorp.mooo.com","votedb.info","voteforhot.net","votenogeorgia.com","votenonov6.com","votenoonnov6.com","votesoregon2006.info","vothiquynhyen.info","votingportland07.info","votiputox.org","vouchergeek.com","vouk.cf","vouk.gq","vouk.ml","vouk.tk","vovin.gdn","vovin.life","voxelcore.com","voyagebirmanie.net","voyancegratuite10min.com","voyeurseite.info","vozmivtop.ru","vp.com","vp.ycare.de","vpanel.ru","vpc608a0.pl","vperdolil.com","vpfbattle.com","vphnfuu2sd85w.cf","vphnfuu2sd85w.ga","vphnfuu2sd85w.gq","vphnfuu2sd85w.ml","vphnfuu2sd85w.tk","vpidcvzfhfgxou.cf","vpidcvzfhfgxou.ga","vpidcvzfhfgxou.gq","vpidcvzfhfgxou.ml","vpidcvzfhfgxou.tk","vpmsl.com","vpn.st","vpn33.top","vprice.co","vps001.net","vps004.net","vps005.net","vps30.com","vps911.bet","vps911.net","vpsadminn.com","vpscloudvntoday.com","vpsjqgkkn.pl","vpslists.com","vpsmobilecloudkb.com","vpsorg.pro","vpsorg.top","vpstraffic.com","vpstrk.com","vr5gpowerv.com","vradportal.com","vraskrutke.biz","vreeland.agencja-csk.pl","vreemail.com","vremonte24-store.ru","vrender.ru","vrgwkwab2kj5.cf","vrgwkwab2kj5.ga","vrgwkwab2kj5.gq","vrgwkwab2kj5.ml","vrgwkwab2kj5.tk","vrify.org","vrloco.com","vrmtr.com","vrou.cf","vrou.ga","vrou.gq","vrou.ml","vrou.tk","vrpitch.com","vrsim.ir","vs3ir4zvtgm.cf","vs3ir4zvtgm.ga","vs3ir4zvtgm.gq","vs3ir4zvtgm.ml","vs3ir4zvtgm.tk","vs904a6.com","vscarymazegame.com","vseoforexe.ru","vseokmoz.org.ua","vshisugg.pl","vsimcard.com","vssms.com","vstartup4q.com","vstoremisc.com","vt0uhhsb0kh.cf","vt0uhhsb0kh.ga","vt0uhhsb0kh.gq","vt0uhhsb0kh.ml","vt0uhhsb0kh.tk","vt8khiiu9xneq.cf","vt8khiiu9xneq.ga","vt8khiiu9xneq.gq","vt8khiiu9xneq.ml","vt8khiiu9xneq.tk","vt8zilugrvejbs.tk","vteachesb.com","vtoasik.ru","vtopeklassniki.ru","vtoroum2.co.tv","vtrue.org","vtxmail.us","vu981s5cexvp.cf","vu981s5cexvp.ga","vu981s5cexvp.gq","vu981s5cexvp.ml","vuabai.info","vubby.com","vuiy.pw","vumurt.org","vutdrenaf56aq9zj68.cf","vutdrenaf56aq9zj68.ga","vutdrenaf56aq9zj68.gq","vutdrenaf56aq9zj68.ml","vutdrenaf56aq9zj68.tk","vuv9hhstrxnjkr.cf","vuv9hhstrxnjkr.ga","vuv9hhstrxnjkr.gq","vuv9hhstrxnjkr.ml","vuv9hhstrxnjkr.tk","vuzimir.cf","vvb3sh5ie0kgujv3u7n.cf","vvb3sh5ie0kgujv3u7n.ga","vvb3sh5ie0kgujv3u7n.gq","vvb3sh5ie0kgujv3u7n.ml","vvb3sh5ie0kgujv3u7n.tk","vvgmail.com","vvlvmrutenfi1udh.ga","vvlvmrutenfi1udh.ml","vvlvmrutenfi1udh.tk","vvng8xzmv2.cf","vvng8xzmv2.ga","vvng8xzmv2.gq","vvng8xzmv2.ml","vvng8xzmv2.tk","vvv.7c.org","vvvnagar.org","vvvpondo.info","vvvvv.n8.biz","vvvvv.uni.me","vvx046q.com","vw-ag.tk","vw-audi.ml","vw-cc.cf","vw-cc.ga","vw-cc.gq","vw-cc.ml","vw-cc.tk","vw-eos.cf","vw-eos.ga","vw-eos.gq","vw-eos.ml","vw-eos.tk","vw-seat.ml","vw-skoda.ml","vworangecounty.com","vwtedx7d7f.cf","vwtedx7d7f.ga","vwtedx7d7f.gq","vwtedx7d7f.ml","vwtedx7d7f.tk","vwwape.com","vxeqzvrgg.pl","vxmlcmyde.pl","vxqt4uv19oiwo7p.cf","vxqt4uv19oiwo7p.ga","vxqt4uv19oiwo7p.gq","vxqt4uv19oiwo7p.ml","vxqt4uv19oiwo7p.tk","vxvcvcv.com","vyhade3z.gq","vyrski4nwr5.cf","vyrski4nwr5.ga","vyrski4nwr5.gq","vyrski4nwr5.ml","vyrski4nwr5.tk","vzlom4ik.tk","vzrxr.ru","vztc.com","w-asertun.ru","w.0w.ro","w.comeddingwhoesaleusa.com","w.polosburberry.com","w22fe21.com","w3fun.com","w3internet.co.uk","w3mailbox.com","w3windsor.com","w45k6k.pl","w4f.com","w4i3em6r.com","w4ms.ga","w4ms.ml","w5gpurn002.cf","w5gpurn002.ga","w5gpurn002.gq","w5gpurn002.ml","w5gpurn002.tk","w634634.ga","w656n4564.cf","w656n4564.ga","w656n4564.gq","w656n4564.ml","w656n4564.tk","w6mail.com","w70ptee1vxi40folt.cf","w70ptee1vxi40folt.ga","w70ptee1vxi40folt.gq","w70ptee1vxi40folt.ml","w70ptee1vxi40folt.tk","w7wdhuw9acdwy.cf","w7wdhuw9acdwy.ga","w7wdhuw9acdwy.gq","w7wdhuw9acdwy.ml","w7wdhuw9acdwy.tk","w7zmjk2g.bij.pl","w918bsq.com","w9f.de","w9y9640c.com","wa.itsminelove.com","wa010.com","waelectrician.com","wafflebrigadecaptain.net","wafrem3456ails.com","wagfused.com","waggadistrict.com","wahab.com","wahch-movies.net","waifu.club","waitingjwo.com","wajikethanh96ger.gq","wakacje-e.pl","wakacjeznami.com.pl","wake-up-from-the-lies.com","wakescene.com","wakingupesther.com","walala.org","walkmail.net","walkmail.ru","walkritefootclinic.com","wall-street.uni.me","walletsshopjp.com","wallm.com","wallsmail.men","walter01.ru","waltoncomp.com","wampsetupserver.com","wanadoo.com","wanko.be","wanoptimization.info","want2lov.us","wantplay.site","wants.dicksinhisan.us","wants.dicksinmyan.us","wapl.ga","wapsportsmedicine.net","waratishou.us","warau-kadoni.com","wardarabando.com","warezbborg.ru","wargot.ru","warjungle.com","warmnessgirl.com","warmnessgirl.net","warmthday.com","warmthday.net","warnednl2.com","warungku.me","wasd.10mail.org","wasd.dropmail.me","wasdfgh.cf","wasdfgh.ga","wasdfgh.gq","wasdfgh.ml","wasdfgh.tk","washingmachines2012.info","washingtongarricklawyers.com","wasistforex.net","waskitacorp.cf","waskitacorp.ga","waskitacorp.gq","waskitacorp.ml","waskitacorp.tk","wasteland.rfc822.org","watacukrowaa.pl","watashiyuo.cf","watashiyuo.ga","watashiyuo.gq","watashiyuo.ml","watashiyuo.tk","watch-harry-potter.com","watch-tv-series.tk","watchclubonline.com","watchcontrabandonline.net","watches-mallhq.com","watchesbuys.com","watcheset.com","watchesforsale.org.uk","watcheshq.net","watchesju.com","watchesnow.info","watchestiny.com","watchever.biz","watchfree.org","watchfull.net","watchheaven.us","watchironman3onlinefreefullmovie.com","watchmanonaledgeonline.net","watchmoviesonline-4-free.com","watchmoviesonlinefree0.com","watchmtv.co","watchnowfree.com","watchnsfw.com","watchreplica.org","watchsdt.tk","watchthedevilinsideonline.net","watchtruebloodseason5episode3online.com","watchunderworldawakeningonline.net","waterlifetmx.com.mx","waterlifetmx2.com.mx","watersportsmegastore.com","watertec1.com","watertinacos.com","waterus2a.com","waterusa.com","watkacukrowa.pl","watkinsmail.bid","wattpad.pl","wawa990.pl","wawan.org","wawi.es","wawinfauzani.com","wawstudent.pl","ways2getback.info","ways2lays.info","wazabi.club","wazow.com","waztempe.com","wb-master.ru","wbdev.tech","wbfre2956mails.com","wbml.net","wbnckidmxh.pl","wbqhurlzxuq.edu.pl","wbryfeb.mil.pl","wca.cn.com","wcddvezl974tnfpa7.cf","wcddvezl974tnfpa7.ga","wcddvezl974tnfpa7.gq","wcddvezl974tnfpa7.ml","wcddvezl974tnfpa7.tk","wchatz.ga","wczasy.com","wczasy.nad.morzem.pl","wczasy.nom.pl","wd0payo12t8o1dqp.cf","wd0payo12t8o1dqp.ga","wd0payo12t8o1dqp.gq","wd0payo12t8o1dqp.ml","wd0payo12t8o1dqp.tk","wd5vxqb27.pl","wdsfbghfg77hj.gq","wdxgc.com","we-dwoje.com.pl","we-love-life.com","we.lovebitco.in","we.qq.my","wealthbargains.com","wealthymoney.pw","weammo.xyz","wearinguniforms.info","weave.email","web-contact.info","web-design-malta.com","web-design-ni.co.uk","web-email.eu","web-emailbox.eu","web-experts.net","web-ideal.fr","web-inc.net","web-mail.pp.ua","web-mail1.com","web-maill.com","web-mailz.com","web-model.info","web-site-sale.ru","web-sites-sale.ru","web.discard-email.cf","web.id","web2mailco.com","web2web.bid","web2web.stream","web2web.top","web3411.de","web3437.de","web3453.de","web3561.de","webandgraphicdesignbyphil.com","webarnak.fr.eu.org","webaward.online","webbear.ru","webbusinessanalysts.com","webcamjobslive.com","webcamsex.de","webcontact-france.eu","webcool.club","webdesign-guide.info","webdesign-romania.net","webdesignspecialist.com.au","webdesigrsbio.gr","webdespro.ru","webdev-pro.ru","webeditonline.info","webemail.me","webemailtop.com","webgmail.info","webhane.com","webhocseo.com","webhostingdomain.ga","webhostingjoin.com","webhostingwebsite.info","webide.ga","webkatalog1.org","webkiff.info","weblovein.ru","webm4il.in","webm4il.info","webmail.flu.cc","webmail.igg.biz","webmail.kolmpuu.net","webmail24.to","webmail24.top","webmail360.eu","webmail4.club","webmailforall.info","webmailn7program.tld.cc","webmails.top","webmails24.com","webmeetme.com","weboka.info","webonofos.com","webpix.ch","webpoets.info","webserverwst.com","websitebod.com","websitebody.com","websitebooty.com","websitehostingservices.info","websiterank.com","websterinc.com","webtasarimi.com","webtechmarketing.we.bs","webtempmail.online","webting-net.com","webtrip.ch","webuser.in","webyzonerz.com","wecmail.cz.cc","weddingcrawler.com","weddingdating.info","weddingdressaccessory.com","weddingdressparty.net","weddinginsurancereviews.info","weddingsontheocean.com","weddingvenuexs.com","wednesburydirect.info","wedooos.cf","wedooos.ga","wedooos.gq","wedooos.ml","wee.my","weebsterboi.com","weedseedsforsale.com","weekendemail.com","wef.gr","wefeelgood.tk","wefjo.grn.cc","weg-beschlussbuch.de","weg-werf-email.de","wegas.ru","wegwerf-email-addressen.de","wegwerf-email-adressen.de","wegwerf-email.at","wegwerf-email.de","wegwerf-email.net","wegwerf-emails.de","wegwerfadresse.de","wegwerfemail.com","wegwerfemail.de","wegwerfemail.info","wegwerfemail.net","wegwerfemail.org","wegwerfemailadresse.com","wegwerfmail.de","wegwerfmail.info","wegwerfmail.net","wegwerfmail.org","wegwerpmailadres.nl","wegwrfmail.de","wegwrfmail.net","wegwrfmail.org","weibomail.net","weightbalance.ru","weightloss.info","weightlossshort.info","weightlossworld.net","weightoffforgood.com","weightrating.com","weihnachts-gruesse.info","weil4feet.com","weird3.eu","weirdcups.com","wejr.in","weldir.cf","welikecookies.com","well.brainhard.net","wellcelebritydress.com","wellcelebritydress.net","wellensstarts.com","welleveningdress.com","welleveningdress.net","welleveningdresses.com","welleveningdresses.net","wellhungup.dynu.net","wellnessintexas.info","wellpromdresses.com","wellpromdresses.net","welshpoultrycentre.co.uk","wem.com","wemel.site","wemel.top","weontheworks.bid","weprof.it","wer.ez.lv","wer34276869j.ga","wer34276869j.gq","wer34276869j.ml","wer34276869j.tk","wereviewbiz.com","werj.in","werparacinasx.com","werrmai.com","wersumer.us","wertaret.com","wertxdn253eg.cf","wertxdn253eg.ga","wertxdn253eg.gq","wertxdn253eg.ml","wertxdn253eg.tk","wertyu.com","werw436526.cf","werw436526.ga","werw436526.gq","werw436526.ml","werw436526.tk","werwe.in","wesandrianto241.ml","wesatikah407.cf","wesatikah407.ml","wesayt.tk","wesazalia927.ga","wescabiescream.cu.cc","weselne.livenet.pl","weselvina200.tk","weseni427.tk","wesfajria37.tk","wesfajriah489.ml","wesgaluh852.ga","weshasni356.ml","weshutahaean910.ga","wesjuliyanto744.ga","weskusumawardhani993.ga","wesmailer.com","wesmailer.comdmaildd.com","wesmubasyiroh167.ml","wesmuharia897.ga","wesnadya714.tk","wesnurullah701.tk","wesruslian738.cf","wessastra497.tk","westjordanshoes.us","westmailer.com","wesw881.ml","weswibowo593.cf","weswidihastuti191.ml","wesyuliyansih469.tk","weszwestyningrum767.cf","wet-fish.com","wetrainbayarea.com","wetrainbayarea.org","wetvibes.com","wewintheylose.com","wewtmail.com","weyuoi.com","wezuwio.com","wfacommunity.com","wfgdfhj.tk","wfmarion.com","wfought0o.com","wfrijgt4ke.cf","wfrijgt4ke.ga","wfrijgt4ke.gq","wfrijgt4ke.ml","wfrijgt4ke.tk","wfxegkfrmfvyvzcwjb.cf","wfxegkfrmfvyvzcwjb.ga","wfxegkfrmfvyvzcwjb.gq","wfxegkfrmfvyvzcwjb.ml","wfxegkfrmfvyvzcwjb.tk","wg0.com","wgetcu0qg9kxmr9yi.ga","wgetcu0qg9kxmr9yi.ml","wgetcu0qg9kxmr9yi.tk","wgw365.com","wgztc71ae.pl","wh4f.org","whaaso.tk","whackyourboss.info","whadadeal.com","whale-mail.com","whatiaas.com","whatifanalytics.com","whatmailer.com","whatnametogivesite.com","whatowhatboyx.com","whatpaas.com","whatsaas.com","wheatbright.com","wheatbright.net","wheatsunny.com","wheatsunny.net","wheeldown.com","wheelemail.com","wheelie-machine.pl","whenstert.tk","whentake.org.ua","wherecanibuythe.biz","wherenever.tk","wheretoget-backlinks.com","which-code.com","whiffles.org","whiplashh.com","whiskey.xray.ezbunko.top","whiskeyalpha.webmailious.top","whiskeygolf.wollomail.top","whiskeyiota.webmailious.top","whiskonzin.edu","whiskygame.com","whisperfocus.com","whispersum.com","white-legion.ru","white-teeth-premium.info","whitebot.ru","whitehall-dress.ru","whitekazino.com","whitekidneybeanreview.com","whitemail.ga","whiteprofile.tk","whiteseoromania.tk","whiteshagrug.net","whiteshirtlady.com","whiteshirtlady.net","whitetrait.xyz","whj1wwre4ctaj.ml","whj1wwre4ctaj.tk","whlevb.com","wholecustomdesign.com","wholelifetermlifeinsurance.com","wholesale-belts.com","wholesale-cheapjewelrys.com","wholesalebag.info","wholesalecheap-hats.com","wholesalediscountshirts.info","wholesalediscountsshoes.info","wholesaleelec.tk","wholesalejordans.xyz","wholesalelove.org","wholesaleshtcphones.info","wholey.browndecorationlights.com","whoox.com","whopy.com","whose-is-this-phone-number.com","whtjddn.33mail.com","why.edu.pl","whydoihaveacne.com","whydrinktea.info","whyitthis.org.ua","whyspam.me","wiadomosc.pisz.pl","wibb.ru","wibblesmith.com","wibu.online","wicked-game.cf","wicked-game.ga","wicked-game.gq","wicked-game.ml","wicked-game.tk","wicked.cricket","wickmail.net","widaryanto.info","wides.co","widget.gg","wielkanocne-dekoracje.pl","wierie.tk","wificon.eu","wig-catering.com.pl","wiibundledeals.us","wiipointsgen.com","wiki.8191.at","wiki24.ga","wiki24.ml","wikiacne.com","wikidocuslava.ru","wikifortunes.com","wikilibhub.ru","wikipedi.biz","wikipedia-inc.cf","wikipedia-inc.ga","wikipedia-inc.gq","wikipedia-inc.ml","wikipedia-inc.tk","wikipedia-llc.cf","wikipedia-llc.ga","wikipedia-llc.gq","wikipedia-llc.ml","wikipedia-llc.tk","wikisite.co","wikiswearia.info","wil.kr","wilburn.prometheusx.pl","wildstar-gold.co.uk","wildstar-gold.us","wildthingsbap.org.uk","wilemail.com","willakarmazym.pl","willette.com","willhackforfood.biz","williamcastillo.me","willselfdestruct.com","wilsonbuilddirect.jp","wilsonexpress.org","wimsg.com","win11bet.org","winanipadtips.info","windlady.com","windlady.net","window-55.net","windowoffice7.com","windows.sos.pl","windows8hosting.info","windows8service.info","windowsicon.info","windycityui.com","windykacjawpraktyce.pl","winebagohire.org","winemaven.in","winemaven.info","winevacuumpump.info","winfreegifts.xyz","wingslacrosse.com","winie.club","wink-versicherung.de","winmail.org","winning365.com","winningeleven365.com","winnweb.win","wins-await.net","wins.com.br","winsomedress.com","winsomedress.net","winspins.party","winter-solstice.info","winter-solstice2011.info","winterabootsboutique.info","winterafootwearonline.info","wintersbootsonline.info","winxmail.com","wip.com","wirasempana.com","wirawan.cf","wirawanakhmadi.cf","wire-shelving.info","wirefreeemail.com","wireless-alarm-system.info","wirelesspreviews.com","wirp.xyz","wisans.ru","wisconsincomedy.com","wiseideas.com","wisepromo.com","wisfkzmitgxim.cf","wisfkzmitgxim.ga","wisfkzmitgxim.gq","wisfkzmitgxim.ml","wisfkzmitgxim.tk","wishan.net","wishlack.com","with-u.us","wix.creou.dev","wix.ptcu.dev","wixcmm.com","wiz2.site","wizaz.com","wizseoservicesaustralia.com","wj7qzenox9.cf","wj7qzenox9.ga","wj7qzenox9.gq","wj7qzenox9.ml","wj7qzenox9.tk","wjhndxn.xyz","wkhaiii.cf","wkhaiii.ga","wkhaiii.gq","wkhaiii.ml","wkhaiii.tk","wkime.pl","wkjrj.com","wkschemesx.com","wla9c4em.com","wlist.ro","wlk.com","wmail.cf","wmail.club","wmail.tk","wmaill.site","wmbadszand2varyb7.cf","wmbadszand2varyb7.ga","wmbadszand2varyb7.gq","wmbadszand2varyb7.ml","wmbadszand2varyb7.tk","wmlorgana.com","wmrmail.com","wmwha0sgkg4.ga","wmwha0sgkg4.ml","wmwha0sgkg4.tk","wmzgjewtfudm.cf","wmzgjewtfudm.ga","wmzgjewtfudm.gq","wmzgjewtfudm.ml","wmzgjewtfudm.tk","wn3wq9irtag62.cf","wn3wq9irtag62.ga","wn3wq9irtag62.gq","wn3wq9irtag62.ml","wn3wq9irtag62.tk","wn8c38i.com","wnmail.top","wnsocjnhz.pl","wo295ttsarx6uqbo.cf","wo295ttsarx6uqbo.ga","wo295ttsarx6uqbo.gq","wo295ttsarx6uqbo.ml","wo295ttsarx6uqbo.tk","woa.org.ua","wocall.com","woe.com","woermawoerma1.info","wofsrm6ty26tt.cf","wofsrm6ty26tt.ga","wofsrm6ty26tt.gq","wofsrm6ty26tt.ml","wofsrm6ty26tt.tk","wokcy.com","wolfmail.ml","wolfmission.com","wolfsmail.ml","wolfsmail.tk","wolfsmails.tk","wollan.info","wolukieh89gkj.tk","wolukiyeh88jik.ga","women999.com","womenblazerstoday.com","womencosmetic.info","womendressinfo.com","womenhealthcare.ooo","womentopsclothing.com","womentopswear.com","wonderfulblogthemes.info","wonderfulfitnessstores.com","wonderlog.com","wongndeso.gq","woodsmail.bid","woolrich-italy.com","woolrichhoutlet.com","woolrichoutlet-itley.com","woolticharticparkaoutlet.com","wooolrichitaly.com","wop.ro","wopc.cf","woppler.ru","wordme.stream","wordmix.pl","wordpressmails.com","work.obask.com","work24h.eu","work4uber.us","workflowy.club","workflowy.cn","workflowy.top","workflowy.work","workout-onlinedvd.info","workoutsupplements.com","workright.ru","worksmail.cf","worksmail.ga","worksmail.gq","worksmail.ml","worksmail.tk","world-many.ru","world-travel.online","worlddonation.org","worldfridge.com","worldmail.com","worldofemail.info","worldpetcare.cf","worldshealth.org","worldsonlineradios.com","worldspace.link","worldsreversephonelookups.com","worldwidebusinesscards.com","worldwite.com","worldwite.net","worldzip.info","worlipca.com","wormseo.cn","worryabothings.com","worstcoversever.com","wosenow.com","wosipaskbc.info","wovz.cu.cc","wow-hack.com","wow.royalbrandco.tk","wowauctionguide.com","wowcemafacfutpe.com","wowgoldy.cz","wowhackgold.com","wowin.pl","wowmail.gq","wowmailing.com","wowthis.tk","wowxv.com","woxvf3xsid13.cf","woxvf3xsid13.ga","woxvf3xsid13.gq","woxvf3xsid13.ml","woxvf3xsid13.tk","wp-viralclick.com","wp2romantic.com","wpbinaq3w7zj5b0.cf","wpbinaq3w7zj5b0.ga","wpbinaq3w7zj5b0.ml","wpbinaq3w7zj5b0.tk","wpcommentservices.info","wpdfs.com","wpeopwfp099.tk","wpg.im","wpmail.org","wpms9sus.pl","wpower.info","wqnbilqgz.pl","wqwwdhjij.pl","wqxhasgkbx88.cf","wqxhasgkbx88.ga","wqxhasgkbx88.gq","wqxhasgkbx88.ml","wqxhasgkbx88.tk","wr.moeri.org","wr9v6at7.com","wralawfirm.com","wrangler-sale.com","wrinklecareproduct.com","writeme-lifestyle.com","writeme.com","writeme.us","writeme.xyz","writers.com","writersarticles.be","writersefx.com","writinghelper.top","writingservice.cf","written4you.info","wrjadeszd.pl","wrlnewstops.space","wroclaw-tenis-stolowy.pl","wroglass.br","wronghead.com","wrysutgst57.ga","wrzuta.com","ws.gy","ws1i0rh.pl","wscu73sazlccqsir.cf","wscu73sazlccqsir.ga","wscu73sazlccqsir.gq","wscu73sazlccqsir.ml","wscu73sazlccqsir.tk","wsfr.luk2.com","wsh72eonlzb5swa22.cf","wsh72eonlzb5swa22.ga","wsh72eonlzb5swa22.gq","wsh72eonlzb5swa22.ml","wsh72eonlzb5swa22.tk","wsoparty.com","wsse.us","wsuart.com","wsvnsbtgq.pl","wszystkoolokatach.com.pl","wt0vkmg1ppm.cf","wt0vkmg1ppm.ga","wt0vkmg1ppm.gq","wt0vkmg1ppm.ml","wt0vkmg1ppm.tk","wt2.orangotango.cf","wtbone.com","wtdmugimlyfgto13b.cf","wtdmugimlyfgto13b.ga","wtdmugimlyfgto13b.gq","wtdmugimlyfgto13b.ml","wtdmugimlyfgto13b.tk","wteoq7vewcy5rl.cf","wteoq7vewcy5rl.ga","wteoq7vewcy5rl.gq","wteoq7vewcy5rl.ml","wteoq7vewcy5rl.tk","wto.com","wu138.club","wu138.top","wu158.club","wu158.top","wu189.top","wu8vx48hyxst.cf","wu8vx48hyxst.ga","wu8vx48hyxst.gq","wu8vx48hyxst.ml","wu8vx48hyxst.tk","wudet.men","wuespdj.xyz","wugxxqrov.pl","wumail.com","wupics.com","wuyc41hgrf.cf","wuyc41hgrf.ga","wuyc41hgrf.gq","wuyc41hgrf.ml","wuyc41hgrf.tk","wuzhizheng.mygbiz.com","wuzup.net","wuzupmail.net","wvckgenbx.pl","wvclibrary.com","wvl238skmf.com","wvppz7myufwmmgh.cf","wvppz7myufwmmgh.ga","wvppz7myufwmmgh.gq","wvppz7myufwmmgh.ml","wvppz7myufwmmgh.tk","wvpzbsx0bli.cf","wvpzbsx0bli.ga","wvpzbsx0bli.gq","wvpzbsx0bli.ml","wvpzbsx0bli.tk","wvrdwomer3arxsc4n.cf","wvrdwomer3arxsc4n.ga","wvrdwomer3arxsc4n.gq","wvrdwomer3arxsc4n.tk","wvruralhealthpolicy.org","wwatme7tpmkn4.cf","wwatme7tpmkn4.ga","wwatme7tpmkn4.gq","wwatme7tpmkn4.tk","wwatrakcje.pl","wweeerraz.com","wwf.az.pl","wwjltnotun30qfczaae.cf","wwjltnotun30qfczaae.ga","wwjltnotun30qfczaae.gq","wwjltnotun30qfczaae.ml","wwjltnotun30qfczaae.tk","wwpshop.com","www-email.bid","www.barryogorman.com","www.bccto.com","www.bccto.me","www.dmtc.edu.pl","www.e4ward.com","www.eairmail.com","www.gameaaholic.com","www.gishpuppy.com","www.hotmobilephoneoffers.com","www.live.co.kr.beo.kr","www.mailinator.com","www.mykak.us","www.nak-nordhorn.de","www.redpeanut.com","www1.hotmobilephoneoffers.com","www10.ru","www2.htruckzk.biz","wwwatrakcje.pl","wwwbox.tk","wwwdindon.ga","wwweb.cf","wwweb.ga","wwwemail.bid","wwwemail.racing","wwwemail.stream","wwwemail.trade","wwwemail.win","wwwfotowltaika.pl","wwwfotowoltaika.pl","wwwkreatorzyimprez.pl","wwwmail.gq","wwwmitel.ga","wwwnew.eu","wwwoutmail.cf","wwwtworcyimprez.pl","wxmail263.com","wxnw.net","wybory.edu.pl","wychw.pl","wymarzonesluby.pl","wynajemaauta.pl","wynajemmikolajawarszawa.pl","wyoming-nedv.ru","wyomingou.com","wyszukiwaramp3.pl","wyvernia.net","wzeabtfzyd.pl","wzeabtfzyda.pl","wzorymatematyka.pl","wzukltd.com","wzxmtb3stvuavbx9hfu.cf","wzxmtb3stvuavbx9hfu.ga","wzxmtb3stvuavbx9hfu.gq","wzxmtb3stvuavbx9hfu.ml","wzxmtb3stvuavbx9hfu.tk","x-bases.ru","x-fuck.info","x-instruments.edu","x-mail.cf","x-ms.info","x-mule.cf","x-mule.ga","x-mule.gq","x-mule.ml","x-mule.tk","x-musor.ru","x-porno-away.info","x-today-x.info","x.0x01.tk","x.agriturismopavi.it","x.bigpurses.org","x.emailfake.ml","x.fackme.gq","x.host-001.eu","x.ip6.li","x.nadazero.net","x.polosburberry.com","x.puk.ro","x.tonno.cf","x.tonno.gq","x.tonno.ml","x.tonno.tk","x.yeastinfectionnomorenow.com","x0w4twkj0.pl","x13x13x13.com","x1bkskmuf4.cf","x1bkskmuf4.ga","x1bkskmuf4.gq","x1bkskmuf4.ml","x1bkskmuf4.tk","x1x.spb.ru","x1x22716.com","x24.com","x263.net","x2ewzd983ene0ijo8.cf","x2ewzd983ene0ijo8.ga","x2ewzd983ene0ijo8.gq","x2ewzd983ene0ijo8.ml","x2ewzd983ene0ijo8.tk","x2fsqundvczas.cf","x2fsqundvczas.ga","x2fsqundvczas.gq","x2fsqundvczas.ml","x2fsqundvczas.tk","x3gsbkpu7wnqg.cf","x3gsbkpu7wnqg.ga","x3gsbkpu7wnqg.gq","x3gsbkpu7wnqg.ml","x4y.club","x5a9m8ugq.com","x5bj6zb5fsvbmqa.ga","x5bj6zb5fsvbmqa.ml","x5bj6zb5fsvbmqa.tk","x5lyq2xr.osa.pl","x6dqh5d5u.pl","x7tzhbikutpaulpb9.cf","x7tzhbikutpaulpb9.ga","x7tzhbikutpaulpb9.gq","x7tzhbikutpaulpb9.ml","x8h8x941l.com","x8vplxtmrbegkoyms.cf","x8vplxtmrbegkoyms.ga","x8vplxtmrbegkoyms.gq","x8vplxtmrbegkoyms.ml","x8vplxtmrbegkoyms.tk","x9dofwvspm9ll.cf","x9dofwvspm9ll.ga","x9dofwvspm9ll.gq","x9dofwvspm9ll.ml","x9dofwvspm9ll.tk","x9vl67yw.edu.pl","xa9f9hbrttiof1ftean.cf","xa9f9hbrttiof1ftean.ga","xa9f9hbrttiof1ftean.gq","xa9f9hbrttiof1ftean.ml","xa9f9hbrttiof1ftean.tk","xablogowicz.com","xadi.ru","xafrem3456ails.com","xagloo.co","xagloo.com","xak3qyaso.pl","xakalutu.com","xamog.com","xandermemo.info","xartis89.co.uk","xas04oo56df2scl.cf","xas04oo56df2scl.ga","xas04oo56df2scl.gq","xas04oo56df2scl.ml","xas04oo56df2scl.tk","xasdrugshop.com","xatovzzgb.pl","xaxugen.org","xaxx.ml","xaynetsss.ddns.net","xb-eco.info","xbaby69.top","xbestwebdesigners.com","xbm7bx391sm5owt6xe.cf","xbm7bx391sm5owt6xe.ga","xbm7bx391sm5owt6xe.gq","xbm7bx391sm5owt6xe.ml","xbm7bx391sm5owt6xe.tk","xbmyv8qyga0j9.cf","xbmyv8qyga0j9.ga","xbmyv8qyga0j9.gq","xbmyv8qyga0j9.ml","xbmyv8qyga0j9.tk","xboxbeta20117.co.tv","xboxformoney.com","xbtravel.com","xbvrfy45g.ga","xbz0412.uu.me","xbziv2krqg7h6.cf","xbziv2krqg7h6.ga","xbziv2krqg7h6.gq","xbziv2krqg7h6.ml","xbziv2krqg7h6.tk","xc05fypuj.com","xc40.cf","xc40.ga","xc40.gq","xc40.ml","xc40.tk","xc60.cf","xc60.ga","xc60.gq","xc60.ml","xc60.tk","xc90.cf","xc90.ga","xc90.gq","xc90.ml","xc90.tk","xcekh6p.pl","xcheesemail.info","xcisade129.ru","xcmitm3ve.pl","xcnmarketingcompany.com","xcode.ro","xcodes.net","xcompress.com","xcpy.com","xcremail.com","xctrade.info","xcufrmogj.pl","xcvlolonyancat.com","xcvrtasdqwe.com","xcxqtsfd0ih2l.cf","xcxqtsfd0ih2l.ga","xcxqtsfd0ih2l.gq","xcxqtsfd0ih2l.ml","xcxqtsfd0ih2l.tk","xczffumdemvoi23ugfs.cf","xczffumdemvoi23ugfs.ga","xczffumdemvoi23ugfs.gq","xczffumdemvoi23ugfs.ml","xczffumdemvoi23ugfs.tk","xd2i8lq18.pl","xdavpzaizawbqnivzs0.cf","xdavpzaizawbqnivzs0.ga","xdavpzaizawbqnivzs0.gq","xdavpzaizawbqnivzs0.ml","xdavpzaizawbqnivzs0.tk","xdvsagsdg4we.ga","xe2g.com","xeames.net","xeb9xwp7.tk","xedmi.com","xemaps.com","xemne.com","xenacareholdings.com","xengthreview.com","xenicalprime.com","xenocountryses.com","xenodio.gr","xenofon.gr","xenonheadlightsale.com","xenopharmacophilia.com","xents.com","xeosa9gvyb5fv.cf","xeosa9gvyb5fv.ga","xeosa9gvyb5fv.gq","xeosa9gvyb5fv.ml","xeosa9gvyb5fv.tk","xermo.info","xeuja98.pl","xf.sluteen.com","xfamiliar9.com","xfashionset.com","xfcjfsfep.pl","xffbe2l8xiwnw.cf","xffbe2l8xiwnw.ga","xffbe2l8xiwnw.gq","xffbe2l8xiwnw.ml","xffbe2l8xiwnw.tk","xfghzdff75zdfhb.ml","xfuze.com","xgaming.ca","xgenas.com","xgk6dy3eodx9kwqvn.cf","xgk6dy3eodx9kwqvn.ga","xgk6dy3eodx9kwqvn.gq","xgk6dy3eodx9kwqvn.tk","xglrcflghzt.pl","xgmailoo.com","xgnowherei.com","xgrxsuldeu.cf","xgrxsuldeu.ga","xgrxsuldeu.gq","xgrxsuldeu.ml","xgrxsuldeu.tk","xh1118.com","xh9z2af.pl","xhhanndifng.info","xhkss.net","xijjfjoo.turystyka.pl","xilopro.com","xilor.com","ximtyl.com","xinbo.info","xinbox.info","xinfi.com.pl","xing886.uu.gl","xinmail.info","xinzk1ul.com","xio7s7zsx8arq.cf","xio7s7zsx8arq.ga","xio7s7zsx8arq.gq","xio7s7zsx8arq.ml","xio7s7zsx8arq.tk","xioplop.com","xipcj6uovohr.cf","xipcj6uovohr.ga","xipcj6uovohr.gq","xipcj6uovohr.ml","xipcj6uovohr.tk","xitimail.com","xiuptwzcv.pl","xiyaopin.cn","xjin.xyz","xjkbrsi.pl","xjoi.com","xjzodqqhb.pl","xklt4qdifrivcw.cf","xklt4qdifrivcw.ga","xklt4qdifrivcw.gq","xklt4qdifrivcw.ml","xklt4qdifrivcw.tk","xktyr5.pl","xl.cx","xlekskpwcvl.pl","xlgaokao.com","xloveme.top","xlqndaij.pl","xlra5cuttko5.cf","xlra5cuttko5.ga","xlra5cuttko5.gq","xlra5cuttko5.ml","xlra5cuttko5.tk","xltbz8eudlfi6bdb6ru.cf","xltbz8eudlfi6bdb6ru.ga","xltbz8eudlfi6bdb6ru.gq","xltbz8eudlfi6bdb6ru.ml","xltbz8eudlfi6bdb6ru.tk","xlxe.pl","xlzdroj.ru","xmail.com","xmail.edu","xmail.org","xmaill.com","xmailweb.com","xmailxz.com","xmaily.com","xmailz.ru","xmasloans.us","xmcybgfd.pl","xmerwdauq.pl","xmgczdjvx.pl","xmmail.ru","xmrecoveryblogs.info","xmule.cf","xmule.ga","xmule.gq","xmule.ml","xn--4dbceig1b7e.com","xn--53h1310o.ws","xn--9kq967o.com","xn--aufsteckbrsten-kaufen-hic.de","xn--b-dga.vn","xn--bei.cf","xn--bei.ga","xn--bei.gq","xn--bei.ml","xn--bei.tk","xn--bluewn-7va.cf","xn--d-bga.net","xn--iloveand-5z9m0a.gq","xn--j6h.ml","xn--kabeldurchfhrung-tzb.info","xn--mgbgvi3fi.com","xn--mll-hoa.email","xn--mllemail-65a.com","xn--mllmail-n2a.com","xn--namnh-7ya4834c.net","xn--odszkodowania-usugi-lgd.waw.pl","xn--qei8618m9qa.ws","xn--sd-pla.elk.pl","xn--wkr.cf","xn--wkr.gq","xn--z8hxwp135i.ws","xne2jaw.pl","xnefa7dpydciob6wu9.cf","xnefa7dpydciob6wu9.ga","xnefa7dpydciob6wu9.gq","xnefa7dpydciob6wu9.ml","xnefa7dpydciob6wu9.tk","xneopocza.xyz","xneopoczb.xyz","xneopoczc.xyz","xnmail.mooo.com","xnzmlyhwgi.pl","xoixa.com","xomawmiux.pl","xooit.fr","xorpaopl.com","xoru.ga","xost.us","xowxdd4w4h.cf","xowxdd4w4h.ga","xowxdd4w4h.gq","xowxdd4w4h.ml","xowxdd4w4h.tk","xoxo-2012.info","xoxox.cc","xoxy.net","xoxy.uk","xoxy.work","xp6tq6vet4tzphy6b0n.cf","xp6tq6vet4tzphy6b0n.ga","xp6tq6vet4tzphy6b0n.gq","xp6tq6vet4tzphy6b0n.ml","xp6tq6vet4tzphy6b0n.tk","xpasystems.com","xpee.tk","xperiae5.com","xpoowivo.pl","xpornclub.com","xposenet.ooo","xprice.co","xps-dl.xyz","xpsatnzenyljpozi.cf","xpsatnzenyljpozi.ga","xpsatnzenyljpozi.gq","xpsatnzenyljpozi.ml","xpsatnzenyljpozi.tk","xpywg888.com","xr.ftpserver.biz","xr158a.com","xr160.com","xr160.info","xr3.elk.pl","xray.lambda.livefreemail.top","xrg7vtiwfeluwk.cf","xrg7vtiwfeluwk.ga","xrg7vtiwfeluwk.gq","xrg7vtiwfeluwk.ml","xrg7vtiwfeluwk.tk","xrho.com","xrilop.com","xrmail.xyz","xrmailbox.net","xronmyer.info","xrum.xyz","xrumail.com","xrumer.warszawa.pl","xrumercracked.com","xrumerdownload.com","xs-foto.org","xscdouzan.pl","xsdfgh.ru","xsellize.xyz","xsil43fw5fgzito.cf","xsil43fw5fgzito.ga","xsil43fw5fgzito.gq","xsil43fw5fgzito.ml","xsil43fw5fgzito.tk","xsmega.com","xsmega645.com","xt-size.info","xt.net.pl","xtc94az.pl","xtds.net","xtmail.win","xtnr2cd464ivdj6exro.cf","xtnr2cd464ivdj6exro.ga","xtnr2cd464ivdj6exro.gq","xtnr2cd464ivdj6exro.ml","xtnr2cd464ivdj6exro.tk","xtq6mk2swxuf0kr.cf","xtq6mk2swxuf0kr.ga","xtq6mk2swxuf0kr.gq","xtq6mk2swxuf0kr.ml","xtq6mk2swxuf0kr.tk","xtrars.ga","xtrars.ml","xtrasize-funziona-opinioni-blog.it","xtremewebtraffic.net","xtrstudios.com","xtwgtpfzxo.pl","xtxfdwe03zhnmrte0e.ga","xtxfdwe03zhnmrte0e.ml","xtxfdwe03zhnmrte0e.tk","xtzqytswu.pl","xubqgqyuq98c.cf","xubqgqyuq98c.ga","xubqgqyuq98c.gq","xubqgqyuq98c.ml","xubqgqyuq98c.tk","xudttnik4n.cf","xudttnik4n.ga","xudttnik4n.gq","xudttnik4n.ml","xudttnik4n.tk","xumail.cf","xumail.ga","xumail.gq","xumail.ml","xumail.tk","xuniyxa.ru","xuogcbcxw.pl","xutemail.info","xuubu.com","xuuxmo1lvrth.cf","xuuxmo1lvrth.ga","xuuxmo1lvrth.gq","xuuxmo1lvrth.ml","xuuxmo1lvrth.tk","xuwphq72clob.cf","xuwphq72clob.ga","xuwphq72clob.gq","xuwphq72clob.ml","xuwphq72clob.tk","xuxx.gq","xuyalter.ru","xuyushuai.com","xv9u9m.com","xvcezxodtqzbvvcfw4a.cf","xvcezxodtqzbvvcfw4a.ga","xvcezxodtqzbvvcfw4a.gq","xvcezxodtqzbvvcfw4a.ml","xvcezxodtqzbvvcfw4a.tk","xvx.us","xwaretech.com","xwaretech.info","xwaretech.net","xwaretech.tk","xwgpzgajlpw.cf","xwgpzgajlpw.ga","xwgpzgajlpw.gq","xwgpzgajlpw.ml","xwgpzgajlpw.tk","xwpet8imjuihrlgs.cf","xwpet8imjuihrlgs.ga","xwpet8imjuihrlgs.gq","xwpet8imjuihrlgs.ml","xwpet8imjuihrlgs.tk","xww.ro","xwyzperlkx.cf","xwyzperlkx.ga","xwyzperlkx.gq","xwyzperlkx.ml","xwyzperlkx.tk","xwzowgfnuuwcpvm.cf","xwzowgfnuuwcpvm.ga","xwzowgfnuuwcpvm.gq","xwzowgfnuuwcpvm.ml","xwzowgfnuuwcpvm.tk","xx-9.tk","xxgkhlbqi.pl","xxgmaail.com","xxgmail.com","xxgry.pl","xxhamsterxx.ga","xxi2.com","xxl.rzeszow.pl","xxlocanto.us","xxlxx.com","xxme.me","xxolocanto.us","xxpm12pzxpom6p.cf","xxpm12pzxpom6p.ga","xxpm12pzxpom6p.gq","xxpm12pzxpom6p.ml","xxpm12pzxpom6p.tk","xxqx3802.com","xxvcongresodeasem.org","xxx-ios.ru","xxx-jino.ru","xxx-movies-tube.ru","xxx-movs-online.ru","xxx-mx.ru","xxx.sytes.net","xxxxilo.com","xxzyr.com","xy1qrgqv3a.cf","xy1qrgqv3a.ga","xy1qrgqv3a.gq","xy1qrgqv3a.ml","xy1qrgqv3a.tk","xy9ce.tk","xycassino.com","xytjjucfljt.atm.pl","xytojios.com","xyz-drive.info","xyzfree.net","xyzmail.men","xz5qwrfu7.pl","xz8syw3ymc.cf","xz8syw3ymc.ga","xz8syw3ymc.gq","xz8syw3ymc.ml","xz8syw3ymc.tk","xzavier1121.club","xzcameras.com","xzjwtsohya3.cf","xzjwtsohya3.ga","xzjwtsohya3.gq","xzjwtsohya3.ml","xzjwtsohya3.tk","xzotokoah.pl","xzqrepurlrre7.cf","xzqrepurlrre7.ga","xzqrepurlrre7.gq","xzqrepurlrre7.ml","xzqrepurlrre7.tk","xzsok.com","xzxgo.com","xzymoe.edu.pl","xzzy.info","y.bcb.ro","y.lochou.fr","y.polosburberry.com","y0brainx6.com","y0ituhabqwjpnua.cf","y0ituhabqwjpnua.ga","y0ituhabqwjpnua.gq","y0ituhabqwjpnua.ml","y0ituhabqwjpnua.tk","y0rkhm246kd0.cf","y0rkhm246kd0.ga","y0rkhm246kd0.gq","y0rkhm246kd0.ml","y0rkhm246kd0.tk","y0up0rn.cf","y0up0rn.ga","y0up0rn.gq","y0up0rn.ml","y0up0rn.tk","y1vmis713bucmc.cf","y1vmis713bucmc.ga","y1vmis713bucmc.gq","y1vmis713bucmc.ml","y1vmis713bucmc.tk","y2b.comx.cf","y2kpz7mstrj.cf","y2kpz7mstrj.ga","y2kpz7mstrj.gq","y2kpz7mstrj.ml","y2kpz7mstrj.tk","y2ube.comx.cf","y2y4.com","y3dvb0bw947k.cf","y3dvb0bw947k.ga","y3dvb0bw947k.gq","y3dvb0bw947k.ml","y3dvb0bw947k.tk","y59.jp","y5artmb3.pl","y7bbbbbbbbbbt8.ga","y8fr9vbap.pl","y97dtdiwf.pl","ya.yomail.info","yabai-oppai.tk","yabba-dabba-dashery.co.uk","yabingu.com","yabumail.com","yacxrz.pl","yadavnaresh.com.np","yadkincounty.org","yadoo.ru","yaelahrid.net","yaelahtodkokgitu.cf","yaelahtodkokgitu.ga","yaelahtodkokgitu.gq","yaelahtodkokgitu.ml","yaelahtodkokgitu.tk","yafrem3456ails.com","yagg.com","yahaoo.co.uk","yahho.jino.ru","yahmail.top","yahnmtntxwhxtymrs.cf","yahnmtntxwhxtymrs.ga","yahnmtntxwhxtymrs.gq","yahnmtntxwhxtymrs.ml","yahnmtntxwhxtymrs.tk","yaho.co.uk","yaho.com","yahobi.com","yahomail.gdn","yahomail.top","yahoo-mail.ga","yahoo.co.au","yahoo.comx.cf","yahoo.cu.uk","yahoo.us","yahoodashtrick.com","yahooi.aol","yahoon.com","yahooo.com","yahooo.com.mx","yahooproduct.com","yahooproduct.net","yahooz.com","yahu.com","yahuu.com.uk","yalamail.com","yalild.tk","yalta.krim.ws","yamaika-nedv.ru","yamail.win","yamandex.com","yammyshop.com","yandere.cu.cc","yandex.ca","yandex.comx.cf","yandex.net","yandexmail.cf","yandexmail.ga","yandexmail.gq","yandexmailserv.com","yanet.me","yankee.epsilon.coayako.top","yankeeecho.wollomail.top","yannmail.win","yanseti.net","yapan-nedv.ru","yapped.net","yaqp.com","yaraon.cf","yaraon.ga","yaraon.gq","yaraon.ml","yaraon.tk","yarnpedia.cf","yarnpedia.ga","yarnpedia.gq","yarnpedia.ml","yarnpedia.tk","yarnsandtails.com","yarpnetb.com","yasewzgmax.pl","yashwantdedcollege.com","yasiotio.com","yasser.ru","yatesmail.men","yausmail.com","yawemail.com","yaxoo.com","yazobo.com","yb45tyvn8945.cf","yb45tyvn8945.ga","yb45tyvn8945.gq","yb45tyvn8945.ml","yb45tyvn8945.tk","yb78oim.cf","yb78oim.ga","yb78oim.gq","yb78oim.ml","yb78oim.tk","ybpxbqt.pl","ybymlcbfwql.pl","yc9obkmthnla2owe.cf","yc9obkmthnla2owe.ga","yc9obkmthnla2owe.gq","yc9obkmthnla2owe.ml","yc9obkmthnla2owe.tk","ycare.de","ycarpet.com","yccyds.com","ychatz.ga","ycm813ebx.pl","ycn.ro","ycxrd1hlf.pl","ycykly.com","ydeclinegv.com","ydlmkoutletjackets9us.com","ye.vc","yeah.net","yeah.net.com","yeahdresses.com","yeamail.info","yeastinfectionnomorenow.com","yedi.org","yeeeou.org.ua","yejdnp45ie1to.cf","yejdnp45ie1to.ga","yejdnp45ie1to.gq","yejdnp45ie1to.ml","yejdnp45ie1to.tk","yellnbmv766.cf","yellnbmv766.ga","yellnbmv766.gq","yellnbmv766.ml","yellnbmv766.tk","yellow.flu.cc","yellow.hotakama.tk","yellow.igg.biz","yellowbook.com.pl","yelloww.ga","yelloww.gq","yelloww.ml","yelloww.tk","yemailme.com","yenimail.site","yentzscholarship.xyz","yep.it","yepbd.com","yepnews.com","yeppee.net","yepwprntw.pl","yert.ye.vc","yertxenon.tk","yes100.com","yesaccounts.net","yesnauk.com","yesnews.info","yesterday2010.info","yeswecanevents.info","yeswetoys.com","yetmail.net","yeupmail.cf","yevme.com","yeweuqwtru.tk","yewma46eta.ml","yewmail.com","yewtyigrhtyu.co.cc","yfdaqxglnz.pl","yfpoloralphlaurenpascher.com","yfqkryxpygz.pl","ygfwhcpaqf.pl","ygmail.pl","ygnzqh2f97sv.cf","ygnzqh2f97sv.ga","ygnzqh2f97sv.gq","ygnzqh2f97sv.ml","ygnzqh2f97sv.tk","ygroupvideoarchive.com","ygroupvideoarchive.net","yh08c6abpfm17g8cqds.cf","yh08c6abpfm17g8cqds.ga","yh08c6abpfm17g8cqds.gq","yh08c6abpfm17g8cqds.ml","yh08c6abpfm17g8cqds.tk","yhcaturkl79jk.tk","yhcaturxc69ol.ml","yhg.biz","yhjgh65hghgfj.tk","yhldqhvie.pl","yifan.net","yikwvmovcj.pl","yinbox.net","yippamail.info","yipsymail.info","yj3nas.cf","yj3nas.ga","yj3nas.gq","yj3nas.ml","yj3nas.tk","yjnkteez.pl","yk20.com","yliuetcxaf405.tk","ylouisvuittonoutlet.net","yltemvfak.pl","yluxuryshomemn.com","ymai.com","ymail.edu","ymail.net","ymail.org","ymail.site","ymail4.com","ymails.pw","ymcswjdzmx.pl","ymdeeil.com","ymdeiel.com","ymdeil.com","ymedeil.com","ymeeil.com","ymggs.tk","ymrnvjjgu.pl","ymt198.com","ymvosiwly.pl","yn8jnfb0cwr8.cf","yn8jnfb0cwr8.ga","yn8jnfb0cwr8.gq","yn8jnfb0cwr8.ml","yn8jnfb0cwr8.tk","yndrinks.com","ynmrealty.com","ynskleboots.com","yobe.pl","yodx.ro","yogamaven.com","yogod.com","yogurtcereal.com","yohomail.ga","yohomail.ml","yokmpqg.pl","yoloisforgagsnoob.com","yolooo.top","yomail.com","yomail.info","yoo.ro","yood.org","yop.0x01.gq","yop.email","yop.emersion.fr","yop.itram.es","yop.profmusique.com","yop.ze.cx","yopail.com","yopmai.com","yopmail.biz.st","yopmail.cf","yopmail.co","yopmail.com","yopmail.fr","yopmail.fr.nf","yopmail.gq","yopmail.info","yopmail.ml","yopmail.net","yopmail.org","yopmail.pp.ua","yopmail.usa.cc","yopmail.xxi2.com","yordanmail.cf","yormanwhite.ml","yoru-dea.com","yoseek.de","yotmail.com","you-qi.com","you-spam.com","you.e4ward.com","youbestone.pw","youcankeepit.info","youchat.ooo","youdealonline.org","youfffgo.tk","yougotgoated.com","youknowscafftowrsz.com","youmail.ga","youmailr.com","youmails.online","youneedmore.info","young-app-lexacc.com","youngcrew.ga","youporn.flu.cc","youporn.igg.biz","youporn.usa.cc","youpymail.com","youquwa.cn","your-free-mail.bid","your-ugg-boots.com","youractors24.com","youraquatics.com","yourbesthvac1.com","yourbonus.win","yourbusinesstips.biz","yourdemowebsite.info","yourdomain.com","youremail.cf","youremail.info","youremail.top","youremaillist.com","yourewronghereswhy.com","yourfastcashloans.co.uk","yourfastmail.com","yourfilm.pl","yourfilmsite.com","yourfitnessguide.org","yourfreemail.bid","yourfreemail.stream","yourfreemail.streammmail.men","yourfreemailbox.co","yourhealthguide.co.uk","yourhighness5.info","yourimail.bid","yourimail.download","yourimbox.cf","yourinbox.co","youripost.bid","youripost.download","yourlms.biz","yourmail.work","yourmailbox.co","yourmailpro.bid","yourmailpro.stream","yourmedicinecenter.net","yourmoode.info","yournetsolutions.bid","yournetsolutions.stream","yournogtrue.top","youroldemail.com","youropinion.ooo","yourphen375.com","yourphoto.pl","yourpochta.tk","yourquickcashloans.co.uk","yourqwik.cf","yoursent.gq","yourseo.name","yourshoesandhandbags.com","yoursmileava.info","yoursmileirea.info","yoursmilejulia.info","yoursmilekylie.info","yoursmilelily.info","yoursmilemia.info","yoursmileriley.info","yourspamgoesto.space","yourstat.com","yourtube.ml","yourweb.email","youthexchange.club","youtjube.waw.pl","youtube.comx.cf","youtube2vimeo.info","youveo.ch","youwatchmovie.com","youzend.net","ypmail.webarnak.fr.eu.org","yppm0z5sjif.ga","yppm0z5sjif.gq","yppm0z5sjif.ml","yppm0z5sjif.tk","yprbcxde1cux.cf","yprbcxde1cux.ga","yprbcxde1cux.gq","yprbcxde1cux.ml","yprbcxde1cux.tk","yq6iki8l5xa.cf","yq6iki8l5xa.ga","yq6iki8l5xa.gq","yq6iki8l5xa.ml","yq6iki8l5xa.tk","yquhnhipm.pl","yqww14gpadey.cf","yqww14gpadey.ga","yqww14gpadey.ml","yqww14gpadey.tk","yraj46a46an43.tk","yreilof.xyz","yrmno5cxjkcp9qlen8t.cf","yrmno5cxjkcp9qlen8t.ga","yrmno5cxjkcp9qlen8t.gq","yrmno5cxjkcp9qlen8t.ml","yrmno5cxjkcp9qlen8t.tk","yroid.com","yrt74748944.cf","yrt74748944.ga","yrt74748944.gq","yrt74748944.ml","yrt74748944.tk","yrxwvnaovm.pl","yslonsale.com","yspend.com","yt-creator.com","yt-google.com","yt6erya4646yf.gq","ytg456hjkjh.cf","ytg456hjkjh.ga","ytg456hjkjh.gq","ytg456hjkjh.ml","ytg456hjkjh.tk","ytpayy.com","yttrevdfd.pl","ytutrl.co.uk","yueluqu.cn","yugasandrika.com","yugfbjghbvh8v67.ml","yughfdjg67ff.ga","yui.it","yuirz.com","yukiji.org","yungkashsk.com","yunik.in","yunpanke.com","yuoia.com","yuslamail.com","yut.com","yuurok.com","yuuywil.date","yuweioaso.tk","yuxuan.mobi","yvessaintlaurentshoesuk.com","yvgalgu7zt.cf","yvgalgu7zt.ga","yvgalgu7zt.gq","yvgalgu7zt.ml","yvgalgu7zt.tk","ywamarts.org","yx.dns-cloud.net","yx48bxdv.ga","yxbv0bipacuhtq4f6z.ga","yxbv0bipacuhtq4f6z.gq","yxbv0bipacuhtq4f6z.ml","yxbv0bipacuhtq4f6z.tk","yxjump.ru","yxzx.net","yy-h2.nut.cc","yy2h.info","yyhmail.com","yyj295r31.com","yyolf.net","yyt.resolution4print.info","yytv.ddns.net","yyymail.pl","yz2wbef.pl","yzhz78hvsxm3zuuod.cf","yzhz78hvsxm3zuuod.ga","yzhz78hvsxm3zuuod.ml","yzidaxqyt.pl","yznakandex.ru","z-mail.cf","z-mail.ga","z-mail.gq","z-mild.ga","z-o-e-v-a.ru","z.polosburberry.com","z.thepinkbee.com","z0210.gmailmirror.com","z0d.eu","z18wgfafghatddm.cf","z18wgfafghatddm.ga","z18wgfafghatddm.gq","z18wgfafghatddm.ml","z18wgfafghatddm.tk","z1p.biz","z1tiixjk7juqix94.ga","z1tiixjk7juqix94.ml","z1tiixjk7juqix94.tk","z3pbtvrxv76flacp4f.cf","z3pbtvrxv76flacp4f.ga","z3pbtvrxv76flacp4f.gq","z3pbtvrxv76flacp4f.ml","z3pbtvrxv76flacp4f.tk","z48bk5tvl.pl","z5cpw9pg8oiiuwylva.cf","z5cpw9pg8oiiuwylva.ga","z5cpw9pg8oiiuwylva.gq","z5cpw9pg8oiiuwylva.ml","z5cpw9pg8oiiuwylva.tk","z6z7tosg9.pl","z7az14m.com","z7az14m.com.com","z86.ru","z870wfurpwxadxrk.ga","z870wfurpwxadxrk.gq","z870wfurpwxadxrk.ml","z870wfurpwxadxrk.tk","z8zcx3gpit2kzo.gq","z8zcx3gpit2kzo.ml","z8zcx3gpit2kzo.tk","za.com","zaa.org","zabawki.edu.pl","zabbabox.info","zadowolony-klient.org","zaebbalo.info","zaednoschools.org","zaerapremiumbar.com","zafrem3456ails.com","zaftneqz2xsg87.cf","zaftneqz2xsg87.ga","zaftneqz2xsg87.gq","zaftneqz2xsg87.ml","zaftneqz2xsg87.tk","zagorski-artstudios.com","zagrajse.pl","zagvxqywjw.pl","zahuy.site","zaim-fart.ru","zain.site","zainmax.net","zakachaisya.org","zakl.org","zaktouni.fr","zakzsvpgxu.pl","zalmem.com","zalopner87.com","zalotti.com","zalvisual.us","zambia-nedv.ru","zamge.com","zamiana-domu.pl","zamojskie.com.pl","zamownie.pl","zane.prometheusx.pl","zane.rocks","zanemail.info","zanichelli.cf","zanichelli.ga","zanichelli.gq","zanichelli.ml","zanichelli.tk","zanmei5.com","zanzedalo.com","zaoonline.com","zap2q0drhxu.cf","zap2q0drhxu.ga","zap2q0drhxu.gq","zap2q0drhxu.ml","zap2q0drhxu.tk","zapak.com","zapak.in","zapbox.fr","zapchasti-orig.ru","zapchati-a.ru","zapstibliri.xyz","zarabotokdoma11.ru","zarada7.co","zaragozatoros.es","zaromias24.net","zarweek.cf","zarweek.ga","zarweek.tk","zasod.com","zasve.info","zatopplomi.xyz","zavio.com.pl","zavio.nl","zaym-zaym.ru","zbestcheaphostingforyou.info","zbiznes.ru","zbl43.pl","zbl74.pl","zbpefn95saft.cf","zbpefn95saft.ga","zbpefn95saft.gq","zbpefn95saft.ml","zbpefn95saft.tk","zbpu84wf.edu.pl","zbtxx4iblkgp0qh.cf","zbtxx4iblkgp0qh.ga","zbtxx4iblkgp0qh.gq","zbtxx4iblkgp0qh.ml","zbtxx4iblkgp0qh.tk","zcash-cloud.com","zchatz.ga","zcqrgaogm.pl","zdanisphotography.com","zdenka.net","zdesyaigri.ru","zdfpost.net","zdgvxposc.pl","zdrajcy.xyz","zdrowewlosy.info","zdrowystyl.net","ze.cx","ze.gally.jp","ze.tc","zealouste.com","zealouste.net","zebins.com","zebins.eu","zebra.email","zebua.cf","zebuaboy.cf","zebuasadis.ml","zehnminuten.de","zehnminutenmail.de","zeinconsulting.info","zelras.ru","zemail.ga","zemail.ml","zen.nieok.com","zen43.com.pl","zen74.com.pl","zenarz.esmtp.biz","zenblogpoczta.com.pl","zencart-web.com","zenek-poczta.com.pl","zenekpoczta.com.pl","zenithcalendars.info","zenocoomniki.ru","zenpocza.com.pl","zenpoczb.com.pl","zenpoczc.com.pl","zenrz.itemdb.com","zensolutions.info","zentrumbox.com","zep-hyr.com","zephrmail.info","zepp.dk","zepter-moscow.biz","zer-0.cf","zer-0.ga","zer-0.gq","zer-0.ml","zerodog.icu","zerograv.top","zeroknow.ga","zeromail.ga","zerotohero-1.com","zertigo.org","zest.me.uk","zesta.cf","zesta.gq","zestroy.info","zeta-telecom.com","zetfilmy.pl","zetia.in","zetmail.com","zettransport.pl","zeveyuse.com","zeveyuse.net","zexeet9i5l49ocke.cf","zexeet9i5l49ocke.ga","zexeet9i5l49ocke.gq","zexeet9i5l49ocke.ml","zexeet9i5l49ocke.tk","zf4r34ie.com","zfilm6.ru","zfymail.com","zgame.zapto.org","zggbzlw.net","zgu5la23tngr2molii.cf","zgu5la23tngr2molii.ga","zgu5la23tngr2molii.gq","zgu5la23tngr2molii.ml","zgu5la23tngr2molii.tk","zgxxt.com","zh.ax","zhaohishu.com","zhaoyuanedu.cn","zhcne.com","zhengjiatpou34.info","zhewei88.com","zhongchengtz.com","zhongy.in","zhorachu.com","zhouemail.510520.org","ziahask.ru","zibiz.me","zibox.info","zidu.pw","zielonadioda.com","zielonyjeczmiennaodchudzanie.xyz","ziggurattemple.info","zik.dj","zil4czsdz3mvauc2.cf","zil4czsdz3mvauc2.ga","zil4czsdz3mvauc2.gq","zil4czsdz3mvauc2.ml","zil4czsdz3mvauc2.tk","zillionsofdollars.info","zilmail.cf","zilmail.ga","zilmail.gq","zilmail.ml","zilmail.tk","zimail.com","zimail.ga","zimbabwe-nedv.ru","zimbail.me","zimbocrowd.info","zimmermail.info","zimowapomoc.pl","zinany.com","zinfighkildo.ftpserver.biz","zinmail.cf","zinmail.ga","zinmail.gq","zinmail.ml","zinmail.tk","zipbox.info","zipcad.com","zipo1.cf","zipo1.ga","zipo1.gq","zipo1.ml","zippiex.com","zippydownl.eu","zippymail.in","zippymail.info","ziprol.com","zipsendtest.com","ziptracker49062.info","ziptracker56123.info","ziptracker67311.info","ziptracker67451.info","ziptracker75121.info","ziptracker87612.info","ziptracker90211.info","ziptracker90513.info","zipzaprap.beerolympics.se","zipzaps.de","zita-blog-xxx.ru","zithromaxonlinesure.com","zithromaxprime.com","ziuta.com","zixoa.com","ziyap.com","ziza.pl","zizhuxizhu888.info","zjhonda.com","zkcckwvt5j.cf","zkcckwvt5j.ga","zkcckwvt5j.gq","zkcckwvt5j.ml","zkcckwvt5j.tk","zkgdtarov.pl","zl0irltxrb2c.cf","zl0irltxrb2c.ga","zl0irltxrb2c.gq","zl0irltxrb2c.ml","zl0irltxrb2c.tk","zlebyqd34.pl","zledscsuobre9adudxm.cf","zledscsuobre9adudxm.ga","zledscsuobre9adudxm.gq","zledscsuobre9adudxm.ml","zledscsuobre9adudxm.tk","zleohkaqpt5.cf","zleohkaqpt5.ga","zleohkaqpt5.gq","zleohkaqpt5.ml","zleohkaqpt5.tk","zlmsl0rkw0232hph.cf","zlmsl0rkw0232hph.ga","zlmsl0rkw0232hph.gq","zlmsl0rkw0232hph.ml","zlmsl0rkw0232hph.tk","zltcsmym9xyns1eq.cf","zltcsmym9xyns1eq.tk","zmail.info.tm","zmailonline.info","zmiev.ru","zmilkofthecow.info","zmtbbyqcr.pl","zmti6x70hdop.cf","zmti6x70hdop.ga","zmti6x70hdop.gq","zmti6x70hdop.ml","zmti6x70hdop.tk","zmylf33tompym.cf","zmylf33tompym.ga","zmylf33tompym.gq","zmylf33tompym.ml","zmylf33tompym.tk","zmywarkilodz.pl","zn4chyguz9rz2gvjcq.cf","zn4chyguz9rz2gvjcq.ga","zn4chyguz9rz2gvjcq.gq","zn4chyguz9rz2gvjcq.ml","zn4chyguz9rz2gvjcq.tk","znatb25xbul30ui.cf","znatb25xbul30ui.ga","znatb25xbul30ui.gq","znatb25xbul30ui.ml","znatb25xbul30ui.tk","zncqtumbkq.cf","zncqtumbkq.ga","zncqtumbkq.gq","zncqtumbkq.ml","zncqtumbkq.tk","zni1d2bs6fx4lp.cf","zni1d2bs6fx4lp.ga","zni1d2bs6fx4lp.gq","zni1d2bs6fx4lp.ml","zni1d2bs6fx4lp.tk","znkzhidpasdp32423.info","znthe6ggfbh6d0mn2f.cf","znthe6ggfbh6d0mn2f.ga","znthe6ggfbh6d0mn2f.gq","znthe6ggfbh6d0mn2f.ml","znthe6ggfbh6d0mn2f.tk","zoaxe.com","zocial.ru","zoemail.com","zoemail.net","zoemail.org","zoetropes.org","zomail.org","zombie-hive.com","zombo.flu.cc","zombo.igg.biz","zombo.nut.cc","zomg.info","zonamail.ga","zonedating.info","zonemail.info","zontero.top","zoomafoo.info","zoombbearhota.xyz","zoomial.info","zoonti.pl","zoqqa.com","zoroasterdomain.com","zoroasterplace.com","zoroastersite.com","zoroasterwebsite.com","zoutlook.com","zoviraxprime.com","zpcaf8dhq.pl","zpkdqkozdopc3mnta.cf","zpkdqkozdopc3mnta.ga","zpkdqkozdopc3mnta.gq","zpkdqkozdopc3mnta.ml","zpkdqkozdopc3mnta.tk","zpvozwsri4aryzatr.cf","zpvozwsri4aryzatr.ga","zpvozwsri4aryzatr.gq","zpvozwsri4aryzatr.ml","zpvozwsri4aryzatr.tk","zqw.pl","zran5yxefwrcpqtcq.cf","zran5yxefwrcpqtcq.ga","zran5yxefwrcpqtcq.gq","zran5yxefwrcpqtcq.ml","zran5yxefwrcpqtcq.tk","zrczefgjv.pl","zre3i49lnsv6qt.cf","zre3i49lnsv6qt.ga","zre3i49lnsv6qt.gq","zre3i49lnsv6qt.ml","zre3i49lnsv6qt.tk","zrmail.ga","zrmail.ml","zrpurhxql.pl","zsccyccxea.pl","zsero.com","zslsz.com","zssgsexdqd.pl","zsvrqrmkr.pl","ztd5af7qo1drt8.cf","ztd5af7qo1drt8.ga","ztd5af7qo1drt8.gq","ztd5af7qo1drt8.ml","ztd5af7qo1drt8.tk","ztdgrucjg92piejmx.cf","ztdgrucjg92piejmx.ga","ztdgrucjg92piejmx.gq","ztdgrucjg92piejmx.ml","ztdgrucjg92piejmx.tk","zualikhakk.cf","zualikhakk.ga","zualikhakk.gq","zualikhakk.ml","zualikhakk.tk","zubacteriax.com","zudrm1dxjnikm.cf","zudrm1dxjnikm.ga","zudrm1dxjnikm.gq","zudrm1dxjnikm.ml","zudrm1dxjnikm.tk","zuhouse.ru","zukmail.cf","zukmail.ga","zukmail.ml","zukmail.tk","zumail.net","zumpul.com","zumrotin.ml","zupka.anglik.org","zuppyezof.info","zurtel.cf","zurtel.ga","zurtel.gq","zurtel.ml","zurtel.tk","zv68.com","zw6provider.com","zwiedzaniebrowaru.com.pl","zwiekszsile.pl","zwiknm.ru","zwoho.com","zwpqjsnpkdjbtu2soc.ga","zwpqjsnpkdjbtu2soc.ml","zwpqjsnpkdjbtu2soc.tk","zwwnhmmcec57ziwux.cf","zwwnhmmcec57ziwux.ga","zwwnhmmcec57ziwux.gq","zwwnhmmcec57ziwux.ml","zwwnhmmcec57ziwux.tk","zx81.ovh","zxcv.com","zxcvbn.in","zxcvbnm.cf","zxcvbnm.com","zxcvbnm.tk","zxcxc.com","zxcxcva.com","zxgsd4gydfg.ga","zxonkcw91bjdojkn.cf","zxonkcw91bjdojkn.ga","zxonkcw91bjdojkn.gq","zxonkcw91bjdojkn.ml","zxonkcw91bjdojkn.tk","zxpasystems.com","zxusnkn0ahscvuk0v.cf","zxusnkn0ahscvuk0v.ga","zxusnkn0ahscvuk0v.gq","zxusnkn0ahscvuk0v.ml","zxusnkn0ahscvuk0v.tk","zyczeniurodzinow.pl","zylpu4cm6hrwrgrqxb.cf","zylpu4cm6hrwrgrqxb.ga","zylpu4cm6hrwrgrqxb.gq","zylpu4cm6hrwrgrqxb.ml","zylpu4cm6hrwrgrqxb.tk","zymail.men","zymuying.com","zynga-email.com","zzrgg.com","zyseo.com","zyyu6mute9qn.cf","zyyu6mute9qn.ga","zyyu6mute9qn.gq","zyyu6mute9qn.ml","zyyu6mute9qn.tk","zz.beststudentloansx.org","zzi.us","zzuwnakb.pl","zzv2bfja5.pl","zzz.com","zzzmail.pl","zzzzzzzzzzzzz.com","emailmonkey.club","loufad.com","gomaild.com"];
	var isValidEmail     = /^(?!(?:(?:\x22?\x5C[\x00-\x7E]\x22?)|(?:\x22?[^\x5C\x22]\x22?)){255,})(?!(?:(?:\x22?\x5C[\x00-\x7E]\x22?)|(?:\x22?[^\x5C\x22]\x22?)){65,}@)(?:(?:[\x21\x23-\x27\x2A\x2B\x2D\x2F-\x39\x3D\x3F\x5E-\x7E]+)|(?:\x22(?:[\x01-\x08\x0B\x0C\x0E-\x1F\x21\x23-\x5B\x5D-\x7F]|(?:\x5C[\x00-\x7F]))*\x22))(?:\.(?:(?:[\x21\x23-\x27\x2A\x2B\x2D\x2F-\x39\x3D\x3F\x5E-\x7E]+)|(?:\x22(?:[\x01-\x08\x0B\x0C\x0E-\x1F\x21\x23-\x5B\x5D-\x7F]|(?:\x5C[\x00-\x7F]))*\x22)))*@(?:(?:(?!.*[^.]{64,})(?:(?:(?:xn--)?[a-z0-9]+(?:-[a-z0-9]+)*\.){1,126}){1,}(?:(?:[a-z][a-z0-9]*)|(?:(?:xn--)[a-z0-9]+))(?:-[a-z0-9]+)*)|(?:\[(?:(?:IPv6:(?:(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){7})|(?:(?!(?:.*[a-f0-9][:\]]){7,})(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,5})?::(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,5})?)))|(?:(?:IPv6:(?:(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){5}:)|(?:(?!(?:.*[a-f0-9]:){5,})(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,3})?::(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,3}:)?)))?(?:(?:25[0-5])|(?:2[0-4][0-9])|(?:1[0-9]{2})|(?:[1-9]?[0-9]))(?:\.(?:(?:25[0-5])|(?:2[0-4][0-9])|(?:1[0-9]{2})|(?:[1-9]?[0-9]))){3}))\]))$/;
	
	function allDomainSuffixes(email) {
	  var domainComponents = email.split('@')[1].split('.');
	
	  return range(0, domainComponents.length).map(function (n) {
	    return domainComponents.slice(n).join('.');
	  });
	}
	
	function isBlacklisted(email) {
	  function suffixIsBlacklisted(domainSuffix) {
	    return blacklist.indexOf(domainSuffix) >= 0;
	  }
	
	  return allDomainSuffixes(email).some(suffixIsBlacklisted);
	};
	
	module.exports = {
	  isValid: function (email){
	    if (typeof(email) !== 'string') {
	      return false;
	    }
	    email = email.toLowerCase();
	    if (!isValidEmail.test(email)) {
	      return false;
	    }
	    return !isBlacklisted(email);
	  },
	  blacklist: function () {
	    return blacklist;
	  }
	};


/***/ },
/* 1917 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 815,
		"./af.js": 815,
		"./ar": 822,
		"./ar-dz": 816,
		"./ar-dz.js": 816,
		"./ar-kw": 817,
		"./ar-kw.js": 817,
		"./ar-ly": 818,
		"./ar-ly.js": 818,
		"./ar-ma": 819,
		"./ar-ma.js": 819,
		"./ar-sa": 820,
		"./ar-sa.js": 820,
		"./ar-tn": 821,
		"./ar-tn.js": 821,
		"./ar.js": 822,
		"./az": 823,
		"./az.js": 823,
		"./be": 824,
		"./be.js": 824,
		"./bg": 825,
		"./bg.js": 825,
		"./bm": 826,
		"./bm.js": 826,
		"./bn": 828,
		"./bn-bd": 827,
		"./bn-bd.js": 827,
		"./bn.js": 828,
		"./bo": 829,
		"./bo.js": 829,
		"./br": 830,
		"./br.js": 830,
		"./bs": 831,
		"./bs.js": 831,
		"./ca": 832,
		"./ca.js": 832,
		"./cs": 833,
		"./cs.js": 833,
		"./cv": 834,
		"./cv.js": 834,
		"./cy": 835,
		"./cy.js": 835,
		"./da": 836,
		"./da.js": 836,
		"./de": 839,
		"./de-at": 837,
		"./de-at.js": 837,
		"./de-ch": 838,
		"./de-ch.js": 838,
		"./de.js": 839,
		"./dv": 840,
		"./dv.js": 840,
		"./el": 841,
		"./el.js": 841,
		"./en-au": 842,
		"./en-au.js": 842,
		"./en-ca": 843,
		"./en-ca.js": 843,
		"./en-gb": 844,
		"./en-gb.js": 844,
		"./en-ie": 845,
		"./en-ie.js": 845,
		"./en-il": 846,
		"./en-il.js": 846,
		"./en-in": 847,
		"./en-in.js": 847,
		"./en-nz": 848,
		"./en-nz.js": 848,
		"./en-sg": 849,
		"./en-sg.js": 849,
		"./eo": 850,
		"./eo.js": 850,
		"./es": 854,
		"./es-do": 851,
		"./es-do.js": 851,
		"./es-mx": 852,
		"./es-mx.js": 852,
		"./es-us": 853,
		"./es-us.js": 853,
		"./es.js": 854,
		"./et": 855,
		"./et.js": 855,
		"./eu": 856,
		"./eu.js": 856,
		"./fa": 857,
		"./fa.js": 857,
		"./fi": 858,
		"./fi.js": 858,
		"./fil": 859,
		"./fil.js": 859,
		"./fo": 860,
		"./fo.js": 860,
		"./fr": 863,
		"./fr-ca": 861,
		"./fr-ca.js": 861,
		"./fr-ch": 862,
		"./fr-ch.js": 862,
		"./fr.js": 863,
		"./fy": 864,
		"./fy.js": 864,
		"./ga": 865,
		"./ga.js": 865,
		"./gd": 866,
		"./gd.js": 866,
		"./gl": 867,
		"./gl.js": 867,
		"./gom-deva": 868,
		"./gom-deva.js": 868,
		"./gom-latn": 869,
		"./gom-latn.js": 869,
		"./gu": 870,
		"./gu.js": 870,
		"./he": 871,
		"./he.js": 871,
		"./hi": 872,
		"./hi.js": 872,
		"./hr": 873,
		"./hr.js": 873,
		"./hu": 874,
		"./hu.js": 874,
		"./hy-am": 875,
		"./hy-am.js": 875,
		"./id": 876,
		"./id.js": 876,
		"./is": 877,
		"./is.js": 877,
		"./it": 879,
		"./it-ch": 878,
		"./it-ch.js": 878,
		"./it.js": 879,
		"./ja": 880,
		"./ja.js": 880,
		"./jv": 881,
		"./jv.js": 881,
		"./ka": 882,
		"./ka.js": 882,
		"./kk": 883,
		"./kk.js": 883,
		"./km": 884,
		"./km.js": 884,
		"./kn": 885,
		"./kn.js": 885,
		"./ko": 886,
		"./ko.js": 886,
		"./ku": 887,
		"./ku.js": 887,
		"./ky": 888,
		"./ky.js": 888,
		"./lb": 889,
		"./lb.js": 889,
		"./lo": 890,
		"./lo.js": 890,
		"./lt": 891,
		"./lt.js": 891,
		"./lv": 892,
		"./lv.js": 892,
		"./me": 893,
		"./me.js": 893,
		"./mi": 894,
		"./mi.js": 894,
		"./mk": 895,
		"./mk.js": 895,
		"./ml": 896,
		"./ml.js": 896,
		"./mn": 897,
		"./mn.js": 897,
		"./mr": 898,
		"./mr.js": 898,
		"./ms": 900,
		"./ms-my": 899,
		"./ms-my.js": 899,
		"./ms.js": 900,
		"./mt": 901,
		"./mt.js": 901,
		"./my": 902,
		"./my.js": 902,
		"./nb": 903,
		"./nb.js": 903,
		"./ne": 904,
		"./ne.js": 904,
		"./nl": 906,
		"./nl-be": 905,
		"./nl-be.js": 905,
		"./nl.js": 906,
		"./nn": 907,
		"./nn.js": 907,
		"./oc-lnc": 908,
		"./oc-lnc.js": 908,
		"./pa-in": 909,
		"./pa-in.js": 909,
		"./pl": 910,
		"./pl.js": 910,
		"./pt": 912,
		"./pt-br": 911,
		"./pt-br.js": 911,
		"./pt.js": 912,
		"./ro": 913,
		"./ro.js": 913,
		"./ru": 914,
		"./ru.js": 914,
		"./sd": 915,
		"./sd.js": 915,
		"./se": 916,
		"./se.js": 916,
		"./si": 917,
		"./si.js": 917,
		"./sk": 918,
		"./sk.js": 918,
		"./sl": 919,
		"./sl.js": 919,
		"./sq": 920,
		"./sq.js": 920,
		"./sr": 922,
		"./sr-cyrl": 921,
		"./sr-cyrl.js": 921,
		"./sr.js": 922,
		"./ss": 923,
		"./ss.js": 923,
		"./sv": 924,
		"./sv.js": 924,
		"./sw": 925,
		"./sw.js": 925,
		"./ta": 926,
		"./ta.js": 926,
		"./te": 927,
		"./te.js": 927,
		"./tet": 928,
		"./tet.js": 928,
		"./tg": 929,
		"./tg.js": 929,
		"./th": 930,
		"./th.js": 930,
		"./tk": 931,
		"./tk.js": 931,
		"./tl-ph": 932,
		"./tl-ph.js": 932,
		"./tlh": 933,
		"./tlh.js": 933,
		"./tr": 934,
		"./tr.js": 934,
		"./tzl": 935,
		"./tzl.js": 935,
		"./tzm": 937,
		"./tzm-latn": 936,
		"./tzm-latn.js": 936,
		"./tzm.js": 937,
		"./ug-cn": 938,
		"./ug-cn.js": 938,
		"./uk": 939,
		"./uk.js": 939,
		"./ur": 940,
		"./ur.js": 940,
		"./uz": 942,
		"./uz-latn": 941,
		"./uz-latn.js": 941,
		"./uz.js": 942,
		"./vi": 943,
		"./vi.js": 943,
		"./x-pseudo": 944,
		"./x-pseudo.js": 944,
		"./yo": 945,
		"./yo.js": 945,
		"./zh-cn": 946,
		"./zh-cn.js": 946,
		"./zh-hk": 947,
		"./zh-hk.js": 947,
		"./zh-mo": 948,
		"./zh-mo.js": 948,
		"./zh-tw": 949,
		"./zh-tw.js": 949
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1917;


/***/ },
/* 1918 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {module.exports = function range(a, b, isInclusive) {
	    function untilB(i, b) {
	        return isInclusive ? i<=b : i<b; 
	    }
	    return { 
		map: function map(func) {
		    var arr = []
		    for (var i=a; untilB(i, b); i++) {
			arr.push(func(i))
		    }
		    return arr;
		},
		toArray: function toArray() {
		    var arr = [];
		    for (var i=a; untilB(i, b); i++) {
			arr.push(i);
		    }
		    return arr;
		},
		forEach: function forEach(func) {
		    for(var i=a; untilB(i, b); i++){
			func(i);
		    }
		    return undefined;
		},
		forEachAsync: function forEachAsync(func) {
		    for (var i=a; untilB(i, b); i++) {
			process.nextTick(func.bind(null, i))
		    }
		}
	    }
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(360)))

/***/ },
/* 1919 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(257);
	var callBind = __webpack_require__(1920);
	
	var implementation = __webpack_require__(950);
	var getPolyfill = __webpack_require__(951);
	var shim = __webpack_require__(1922);
	
	var polyfill = callBind(getPolyfill(), Object);
	
	define(polyfill, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = polyfill;


/***/ },
/* 1920 */
[2305, 1921],
/* 1921 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var undefined;
	
	var $SyntaxError = SyntaxError;
	var $Function = Function;
	var $TypeError = TypeError;
	
	// eslint-disable-next-line consistent-return
	var getEvalledConstructor = function (expressionSyntax) {
		try {
			return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
		} catch (e) {}
	};
	
	var $gOPD = Object.getOwnPropertyDescriptor;
	if ($gOPD) {
		try {
			$gOPD({}, '');
		} catch (e) {
			$gOPD = null; // this is IE 8, which has a broken gOPD
		}
	}
	
	var throwTypeError = function () {
		throw new $TypeError();
	};
	var ThrowTypeError = $gOPD
		? (function () {
			try {
				// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
				arguments.callee; // IE 8 does not throw here
				return throwTypeError;
			} catch (calleeThrows) {
				try {
					// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
					return $gOPD(arguments, 'callee').get;
				} catch (gOPDthrows) {
					return throwTypeError;
				}
			}
		}())
		: throwTypeError;
	
	var hasSymbols = __webpack_require__(343)();
	
	var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto
	
	var needsEval = {};
	
	var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);
	
	var INTRINSICS = {
		'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
		'%Array%': Array,
		'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
		'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
		'%AsyncFromSyncIteratorPrototype%': undefined,
		'%AsyncFunction%': needsEval,
		'%AsyncGenerator%': needsEval,
		'%AsyncGeneratorFunction%': needsEval,
		'%AsyncIteratorPrototype%': needsEval,
		'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
		'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
		'%Boolean%': Boolean,
		'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
		'%Date%': Date,
		'%decodeURI%': decodeURI,
		'%decodeURIComponent%': decodeURIComponent,
		'%encodeURI%': encodeURI,
		'%encodeURIComponent%': encodeURIComponent,
		'%Error%': Error,
		'%eval%': eval, // eslint-disable-line no-eval
		'%EvalError%': EvalError,
		'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
		'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
		'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
		'%Function%': $Function,
		'%GeneratorFunction%': needsEval,
		'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
		'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
		'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
		'%isFinite%': isFinite,
		'%isNaN%': isNaN,
		'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
		'%JSON%': typeof JSON === 'object' ? JSON : undefined,
		'%Map%': typeof Map === 'undefined' ? undefined : Map,
		'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
		'%Math%': Math,
		'%Number%': Number,
		'%Object%': Object,
		'%parseFloat%': parseFloat,
		'%parseInt%': parseInt,
		'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
		'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
		'%RangeError%': RangeError,
		'%ReferenceError%': ReferenceError,
		'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
		'%RegExp%': RegExp,
		'%Set%': typeof Set === 'undefined' ? undefined : Set,
		'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
		'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
		'%String%': String,
		'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
		'%Symbol%': hasSymbols ? Symbol : undefined,
		'%SyntaxError%': $SyntaxError,
		'%ThrowTypeError%': ThrowTypeError,
		'%TypedArray%': TypedArray,
		'%TypeError%': $TypeError,
		'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
		'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
		'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
		'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
		'%URIError%': URIError,
		'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
		'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
		'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
	};
	
	var doEval = function doEval(name) {
		var value;
		if (name === '%AsyncFunction%') {
			value = getEvalledConstructor('async function () {}');
		} else if (name === '%GeneratorFunction%') {
			value = getEvalledConstructor('function* () {}');
		} else if (name === '%AsyncGeneratorFunction%') {
			value = getEvalledConstructor('async function* () {}');
		} else if (name === '%AsyncGenerator%') {
			var fn = doEval('%AsyncGeneratorFunction%');
			if (fn) {
				value = fn.prototype;
			}
		} else if (name === '%AsyncIteratorPrototype%') {
			var gen = doEval('%AsyncGenerator%');
			if (gen) {
				value = getProto(gen.prototype);
			}
		}
	
		INTRINSICS[name] = value;
	
		return value;
	};
	
	var LEGACY_ALIASES = {
		'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
		'%ArrayPrototype%': ['Array', 'prototype'],
		'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
		'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
		'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
		'%ArrayProto_values%': ['Array', 'prototype', 'values'],
		'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
		'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
		'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
		'%BooleanPrototype%': ['Boolean', 'prototype'],
		'%DataViewPrototype%': ['DataView', 'prototype'],
		'%DatePrototype%': ['Date', 'prototype'],
		'%ErrorPrototype%': ['Error', 'prototype'],
		'%EvalErrorPrototype%': ['EvalError', 'prototype'],
		'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
		'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
		'%FunctionPrototype%': ['Function', 'prototype'],
		'%Generator%': ['GeneratorFunction', 'prototype'],
		'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
		'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
		'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
		'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
		'%JSONParse%': ['JSON', 'parse'],
		'%JSONStringify%': ['JSON', 'stringify'],
		'%MapPrototype%': ['Map', 'prototype'],
		'%NumberPrototype%': ['Number', 'prototype'],
		'%ObjectPrototype%': ['Object', 'prototype'],
		'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
		'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
		'%PromisePrototype%': ['Promise', 'prototype'],
		'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
		'%Promise_all%': ['Promise', 'all'],
		'%Promise_reject%': ['Promise', 'reject'],
		'%Promise_resolve%': ['Promise', 'resolve'],
		'%RangeErrorPrototype%': ['RangeError', 'prototype'],
		'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
		'%RegExpPrototype%': ['RegExp', 'prototype'],
		'%SetPrototype%': ['Set', 'prototype'],
		'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
		'%StringPrototype%': ['String', 'prototype'],
		'%SymbolPrototype%': ['Symbol', 'prototype'],
		'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
		'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
		'%TypeErrorPrototype%': ['TypeError', 'prototype'],
		'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
		'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
		'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
		'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
		'%URIErrorPrototype%': ['URIError', 'prototype'],
		'%WeakMapPrototype%': ['WeakMap', 'prototype'],
		'%WeakSetPrototype%': ['WeakSet', 'prototype']
	};
	
	var bind = __webpack_require__(170);
	var hasOwn = __webpack_require__(479);
	var $concat = bind.call(Function.call, Array.prototype.concat);
	var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
	var $replace = bind.call(Function.call, String.prototype.replace);
	var $strSlice = bind.call(Function.call, String.prototype.slice);
	
	/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
	var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
	var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
	var stringToPath = function stringToPath(string) {
		var first = $strSlice(string, 0, 1);
		var last = $strSlice(string, -1);
		if (first === '%' && last !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
		} else if (last === '%' && first !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
		}
		var result = [];
		$replace(string, rePropName, function (match, number, quote, subString) {
			result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
		});
		return result;
	};
	/* end adaptation */
	
	var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
		var intrinsicName = name;
		var alias;
		if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
			alias = LEGACY_ALIASES[intrinsicName];
			intrinsicName = '%' + alias[0] + '%';
		}
	
		if (hasOwn(INTRINSICS, intrinsicName)) {
			var value = INTRINSICS[intrinsicName];
			if (value === needsEval) {
				value = doEval(intrinsicName);
			}
			if (typeof value === 'undefined' && !allowMissing) {
				throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
			}
	
			return {
				alias: alias,
				name: intrinsicName,
				value: value
			};
		}
	
		throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
	};
	
	module.exports = function GetIntrinsic(name, allowMissing) {
		if (typeof name !== 'string' || name.length === 0) {
			throw new $TypeError('intrinsic name must be a non-empty string');
		}
		if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
			throw new $TypeError('"allowMissing" argument must be a boolean');
		}
	
		var parts = stringToPath(name);
		var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
	
		var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
		var intrinsicRealName = intrinsic.name;
		var value = intrinsic.value;
		var skipFurtherCaching = false;
	
		var alias = intrinsic.alias;
		if (alias) {
			intrinsicBaseName = alias[0];
			$spliceApply(parts, $concat([0, 1], alias));
		}
	
		for (var i = 1, isOwn = true; i < parts.length; i += 1) {
			var part = parts[i];
			var first = $strSlice(part, 0, 1);
			var last = $strSlice(part, -1);
			if (
				(
					(first === '"' || first === "'" || first === '`')
					|| (last === '"' || last === "'" || last === '`')
				)
				&& first !== last
			) {
				throw new $SyntaxError('property names with quotes must have matching quotes');
			}
			if (part === 'constructor' || !isOwn) {
				skipFurtherCaching = true;
			}
	
			intrinsicBaseName += '.' + part;
			intrinsicRealName = '%' + intrinsicBaseName + '%';
	
			if (hasOwn(INTRINSICS, intrinsicRealName)) {
				value = INTRINSICS[intrinsicRealName];
			} else if (value != null) {
				if (!(part in value)) {
					if (!allowMissing) {
						throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
					}
					return void undefined;
				}
				if ($gOPD && (i + 1) >= parts.length) {
					var desc = $gOPD(value, part);
					isOwn = !!desc;
	
					// By convention, when a data property is converted to an accessor
					// property to emulate a data property that does not suffer from
					// the override mistake, that accessor's getter is marked with
					// an `originalValue` property. Here, when we detect this, we
					// uphold the illusion by pretending to see that original data
					// property, i.e., returning the value rather than the getter
					// itself.
					if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
						value = desc.get;
					} else {
						value = value[part];
					}
				} else {
					isOwn = hasOwn(value, part);
					value = value[part];
				}
	
				if (isOwn && !skipFurtherCaching) {
					INTRINSICS[intrinsicRealName] = value;
				}
			}
		}
		return value;
	};


/***/ },
/* 1922 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var getPolyfill = __webpack_require__(951);
	var define = __webpack_require__(257);
	
	module.exports = function shimObjectIs() {
		var polyfill = getPolyfill();
		define(Object, { is: polyfill }, {
			is: function testObjectIs() {
				return Object.is !== polyfill;
			}
		});
		return polyfill;
	};


/***/ },
/* 1923 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keysShim;
	if (!Object.keys) {
		// modified from https://github.com/es-shims/es5-shim
		var has = Object.prototype.hasOwnProperty;
		var toStr = Object.prototype.toString;
		var isArgs = __webpack_require__(953); // eslint-disable-line global-require
		var isEnumerable = Object.prototype.propertyIsEnumerable;
		var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
		var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
		var dontEnums = [
			'toString',
			'toLocaleString',
			'valueOf',
			'hasOwnProperty',
			'isPrototypeOf',
			'propertyIsEnumerable',
			'constructor'
		];
		var equalsConstructorPrototype = function (o) {
			var ctor = o.constructor;
			return ctor && ctor.prototype === o;
		};
		var excludedKeys = {
			$applicationCache: true,
			$console: true,
			$external: true,
			$frame: true,
			$frameElement: true,
			$frames: true,
			$innerHeight: true,
			$innerWidth: true,
			$onmozfullscreenchange: true,
			$onmozfullscreenerror: true,
			$outerHeight: true,
			$outerWidth: true,
			$pageXOffset: true,
			$pageYOffset: true,
			$parent: true,
			$scrollLeft: true,
			$scrollTop: true,
			$scrollX: true,
			$scrollY: true,
			$self: true,
			$webkitIndexedDB: true,
			$webkitStorageInfo: true,
			$window: true
		};
		var hasAutomationEqualityBug = (function () {
			/* global window */
			if (typeof window === 'undefined') { return false; }
			for (var k in window) {
				try {
					if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
						try {
							equalsConstructorPrototype(window[k]);
						} catch (e) {
							return true;
						}
					}
				} catch (e) {
					return true;
				}
			}
			return false;
		}());
		var equalsConstructorPrototypeIfNotBuggy = function (o) {
			/* global window */
			if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
				return equalsConstructorPrototype(o);
			}
			try {
				return equalsConstructorPrototype(o);
			} catch (e) {
				return false;
			}
		};
	
		keysShim = function keys(object) {
			var isObject = object !== null && typeof object === 'object';
			var isFunction = toStr.call(object) === '[object Function]';
			var isArguments = isArgs(object);
			var isString = isObject && toStr.call(object) === '[object String]';
			var theKeys = [];
	
			if (!isObject && !isFunction && !isArguments) {
				throw new TypeError('Object.keys called on a non-object');
			}
	
			var skipProto = hasProtoEnumBug && isFunction;
			if (isString && object.length > 0 && !has.call(object, 0)) {
				for (var i = 0; i < object.length; ++i) {
					theKeys.push(String(i));
				}
			}
	
			if (isArguments && object.length > 0) {
				for (var j = 0; j < object.length; ++j) {
					theKeys.push(String(j));
				}
			} else {
				for (var name in object) {
					if (!(skipProto && name === 'prototype') && has.call(object, name)) {
						theKeys.push(String(name));
					}
				}
			}
	
			if (hasDontEnumBug) {
				var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
				for (var k = 0; k < dontEnums.length; ++k) {
					if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
						theKeys.push(dontEnums[k]);
					}
				}
			}
			return theKeys;
		};
	}
	module.exports = keysShim;


/***/ },
/* 1924 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.16.1-lts
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
	
	var timeoutDuration = function () {
	  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	      return 1;
	    }
	  }
	  return 0;
	}();
	
	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	var supportsMicroTasks = isBrowser && window.Promise;
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var window = element.ownerDocument.defaultView;
	  var css = window.getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }
	
	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	/**
	 * Returns the reference node of the reference object, or the reference object itself.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
	 * @returns {Element} parent
	 */
	function getReferenceNode(reference) {
	  return reference && reference.referenceNode ? reference.referenceNode : reference;
	}
	
	var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
	
	/**
	 * Determines if the browser is Internet Explorer
	 * @method
	 * @memberof Popper.Utils
	 * @param {Number} version to check
	 * @returns {Boolean} isIE
	 */
	function isIE(version) {
	  if (version === 11) {
	    return isIE11;
	  }
	  if (version === 10) {
	    return isIE10;
	  }
	  return isIE11 || isIE10;
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  if (!element) {
	    return document.documentElement;
	  }
	
	  var noOffsetParent = isIE(10) ? document.body : null;
	
	  // NOTE: 1 DOM access here
	  var offsetParent = element.offsetParent || null;
	  // Skip hidden elements which don't have an offsetParent
	  while (offsetParent === noOffsetParent && element.nextElementSibling) {
	    offsetParent = (element = element.nextElementSibling).offsetParent;
	  }
	
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    return element ? element.ownerDocument.documentElement : document.documentElement;
	  }
	
	  // .offsetParent will return the closest TH, TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
	}
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
	}
	
	function getWindowSizes(document) {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE(10) && getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  try {
	    if (isIE(10)) {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } else {
	      rect = element.getBoundingClientRect();
	    }
	  } catch (e) {}
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
	  var width = sizes.width || element.clientWidth || result.width;
	  var height = sizes.height || element.clientHeight || result.height;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var isIE10 = isIE(10);
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth);
	
	  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	  if (fixedPosition && isHTML) {
	    parentRect.top = Math.max(parentRect.top, 0);
	    parentRect.left = Math.max(parentRect.left, 0);
	  }
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop);
	    var marginLeft = parseFloat(styles.marginLeft);
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = !excludeScroll ? getScroll(html) : 0;
	  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  var parentNode = getParentNode(element);
	  if (!parentNode) {
	    return false;
	  }
	  return isFixed(parentNode);
	}
	
	/**
	 * Finds the first parent of an element that has a transformed property defined
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} first transformed parent or documentElement
	 */
	
	function getFixedPositionOffsetParent(element) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element || !element.parentElement || isIE()) {
	    return document.documentElement;
	  }
	  var el = element.parentElement;
	  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	    el = el.parentElement;
	  }
	  return el || document.documentElement;
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @param {Boolean} fixedPosition - Is in fixed position mode
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // NOTE: 1 DOM access here
	
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  padding = padding || 0;
	  var isPaddingNumber = typeof padding === 'number';
	  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
	  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
	  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
	  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @param {Element} fixedPosition - is in fixed position mode
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var window = element.ownerDocument.defaultView;
	  var styles = window.getComputedStyle(element);
	  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
	  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  data.positionFixed = this.options.positionFixed;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	
	  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Destroys the popper.
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style.left = '';
	    this.popper.style.right = '';
	    this.popper.style.bottom = '';
	    this.popper.style.willChange = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicitly asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
	 * @returns {Object} The popper's position offsets rounded
	 *
	 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
	 * good as it can be within reason.
	 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
	 *
	 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
	 * as well on High DPI screens).
	 *
	 * Firefox prefers no rounding for positioning and does not have blurriness on
	 * high DPI screens.
	 *
	 * Only horizontal placement and left/right values need to be considered.
	 */
	function getRoundedOffsets(data, shouldRound) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	  var round = Math.round,
	      floor = Math.floor;
	
	  var noRound = function noRound(v) {
	    return v;
	  };
	
	  var referenceWidth = round(reference.width);
	  var popperWidth = round(popper.width);
	
	  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
	  var isVariation = data.placement.indexOf('-') !== -1;
	  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
	  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
	
	  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
	  var verticalToInteger = !shouldRound ? noRound : round;
	
	  return {
	    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
	    top: verticalToInteger(popper.top),
	    bottom: verticalToInteger(popper.bottom),
	    right: horizontalToInteger(popper.right)
	  };
	}
	
	var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
	    // and not the bottom of the html element
	    if (offsetParent.nodeName === 'HTML') {
	      top = -offsetParent.clientHeight + offsets.bottom;
	    } else {
	      top = -offsetParentRect.height + offsets.bottom;
	    }
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    if (offsetParent.nodeName === 'HTML') {
	      left = -offsetParent.clientWidth + offsets.right;
	    } else {
	      left = -offsetParentRect.width + offsets.right;
	    }
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;
	
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjunction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-end` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	
	    // flips variation if reference element overflows boundaries
	    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    // flips variation if popper content overflows boundaries
	    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
	
	    var flippedVariation = flippedVariationByRef || flippedVariationByContent;
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  // NOTE: DOM access here
	  // resets the popper's position so that the document size can be calculated excluding
	  // the size of the popper element itself
	  var transformProp = getSupportedPropertyName('transform');
	  var popperStyles = data.instance.popper.style; // assignment to help minification
	  var top = popperStyles.top,
	      left = popperStyles.left,
	      transform = popperStyles[transformProp];
	
	  popperStyles.top = '';
	  popperStyles.left = '';
	  popperStyles[transformProp] = '';
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
	
	  // NOTE: DOM access here
	  // restores the original style properties after the offsets have been computed
	  popperStyles.top = top;
	  popperStyles.left = left;
	  popperStyles[transformProp] = transform;
	
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unit-less, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the `height`.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * A scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper. This makes sure the popper always has a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near each other
	   * without leaving any gap between the two. Especially useful when the arrow is
	   * enabled and you want to ensure that it points to its reference element.
	   * It cares only about the first axis. You can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjunction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations)
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position.
	     * The popper will never be placed outside of the defined boundaries
	     * (except if `keepTogether` is enabled)
	     */
	    boundariesElement: 'viewport',
	    /**
	     * @prop {Boolean} flipVariations=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the reference element overlaps its boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariations: false,
	    /**
	     * @prop {Boolean} flipVariationsByContent=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the popper element overlaps its reference boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariationsByContent: false
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define your own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the information used by Popper.js.
	 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overridden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass an object with the same
	 * structure of the `options` object, as the 3rd argument. For example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement.
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Set this to true if you want popper to position it self in 'fixed' mode
	   * @prop {Boolean} positionFixed=false
	   */
	  positionFixed: false,
	
	  /**
	   * Whether events (resize, scroll) are initially enabled.
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated. This callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js.
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Creates a new Popper.js instance.
	   * @class Popper
	   * @param {Element|referenceObject} reference - The reference element used to position the popper
	   * @param {Element} popper - The HTML / XML element used as the popper
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedules an update. It will run on the next UI update available.
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10.
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1925 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.proj4 = factory());
	}(this, (function () { 'use strict';
	
	    var globals = function(defs) {
	      defs('EPSG:4326', "+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees");
	      defs('EPSG:4269', "+title=NAD83 (long/lat) +proj=longlat +a=6378137.0 +b=6356752.31414036 +ellps=GRS80 +datum=NAD83 +units=degrees");
	      defs('EPSG:3857', "+title=WGS 84 / Pseudo-Mercator +proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +no_defs");
	
	      defs.WGS84 = defs['EPSG:4326'];
	      defs['EPSG:3785'] = defs['EPSG:3857']; // maintain backward compat, official code is 3857
	      defs.GOOGLE = defs['EPSG:3857'];
	      defs['EPSG:900913'] = defs['EPSG:3857'];
	      defs['EPSG:102113'] = defs['EPSG:3857'];
	    };
	
	    var PJD_3PARAM = 1;
	    var PJD_7PARAM = 2;
	    var PJD_GRIDSHIFT = 3;
	    var PJD_WGS84 = 4; // WGS84 or equivalent
	    var PJD_NODATUM = 5; // WGS84 or equivalent
	    var SRS_WGS84_SEMIMAJOR = 6378137.0;  // only used in grid shift transforms
	    var SRS_WGS84_SEMIMINOR = 6356752.314;  // only used in grid shift transforms
	    var SRS_WGS84_ESQUARED = 0.0066943799901413165; // only used in grid shift transforms
	    var SEC_TO_RAD = 4.84813681109535993589914102357e-6;
	    var HALF_PI = Math.PI/2;
	    // ellipoid pj_set_ell.c
	    var SIXTH = 0.1666666666666666667;
	    /* 1/6 */
	    var RA4 = 0.04722222222222222222;
	    /* 17/360 */
	    var RA6 = 0.02215608465608465608;
	    var EPSLN = 1.0e-10;
	    // you'd think you could use Number.EPSILON above but that makes
	    // Mollweide get into an infinate loop.
	
	    var D2R = 0.01745329251994329577;
	    var R2D = 57.29577951308232088;
	    var FORTPI = Math.PI/4;
	    var TWO_PI = Math.PI * 2;
	    // SPI is slightly greater than Math.PI, so values that exceed the -180..180
	    // degree range by a tiny amount don't get wrapped. This prevents points that
	    // have drifted from their original location along the 180th meridian (due to
	    // floating point error) from changing their sign.
	    var SPI = 3.14159265359;
	
	    var exports$1 = {};
	    exports$1.greenwich = 0.0; //"0dE",
	    exports$1.lisbon = -9.131906111111; //"9d07'54.862\"W",
	    exports$1.paris = 2.337229166667; //"2d20'14.025\"E",
	    exports$1.bogota = -74.080916666667; //"74d04'51.3\"W",
	    exports$1.madrid = -3.687938888889; //"3d41'16.58\"W",
	    exports$1.rome = 12.452333333333; //"12d27'8.4\"E",
	    exports$1.bern = 7.439583333333; //"7d26'22.5\"E",
	    exports$1.jakarta = 106.807719444444; //"106d48'27.79\"E",
	    exports$1.ferro = -17.666666666667; //"17d40'W",
	    exports$1.brussels = 4.367975; //"4d22'4.71\"E",
	    exports$1.stockholm = 18.058277777778; //"18d3'29.8\"E",
	    exports$1.athens = 23.7163375; //"23d42'58.815\"E",
	    exports$1.oslo = 10.722916666667; //"10d43'22.5\"E"
	
	    var units = {
	      ft: {to_meter: 0.3048},
	      'us-ft': {to_meter: 1200 / 3937}
	    };
	
	    var ignoredChar = /[\s_\-\/\(\)]/g;
	    function match(obj, key) {
	      if (obj[key]) {
	        return obj[key];
	      }
	      var keys = Object.keys(obj);
	      var lkey = key.toLowerCase().replace(ignoredChar, '');
	      var i = -1;
	      var testkey, processedKey;
	      while (++i < keys.length) {
	        testkey = keys[i];
	        processedKey = testkey.toLowerCase().replace(ignoredChar, '');
	        if (processedKey === lkey) {
	          return obj[testkey];
	        }
	      }
	    }
	
	    var parseProj = function(defData) {
	      var self = {};
	      var paramObj = defData.split('+').map(function(v) {
	        return v.trim();
	      }).filter(function(a) {
	        return a;
	      }).reduce(function(p, a) {
	        var split = a.split('=');
	        split.push(true);
	        p[split[0].toLowerCase()] = split[1];
	        return p;
	      }, {});
	      var paramName, paramVal, paramOutname;
	      var params = {
	        proj: 'projName',
	        datum: 'datumCode',
	        rf: function(v) {
	          self.rf = parseFloat(v);
	        },
	        lat_0: function(v) {
	          self.lat0 = v * D2R;
	        },
	        lat_1: function(v) {
	          self.lat1 = v * D2R;
	        },
	        lat_2: function(v) {
	          self.lat2 = v * D2R;
	        },
	        lat_ts: function(v) {
	          self.lat_ts = v * D2R;
	        },
	        lon_0: function(v) {
	          self.long0 = v * D2R;
	        },
	        lon_1: function(v) {
	          self.long1 = v * D2R;
	        },
	        lon_2: function(v) {
	          self.long2 = v * D2R;
	        },
	        alpha: function(v) {
	          self.alpha = parseFloat(v) * D2R;
	        },
	        gamma: function(v) {
	          self.rectified_grid_angle = parseFloat(v);
	        },
	        lonc: function(v) {
	          self.longc = v * D2R;
	        },
	        x_0: function(v) {
	          self.x0 = parseFloat(v);
	        },
	        y_0: function(v) {
	          self.y0 = parseFloat(v);
	        },
	        k_0: function(v) {
	          self.k0 = parseFloat(v);
	        },
	        k: function(v) {
	          self.k0 = parseFloat(v);
	        },
	        a: function(v) {
	          self.a = parseFloat(v);
	        },
	        b: function(v) {
	          self.b = parseFloat(v);
	        },
	        r_a: function() {
	          self.R_A = true;
	        },
	        zone: function(v) {
	          self.zone = parseInt(v, 10);
	        },
	        south: function() {
	          self.utmSouth = true;
	        },
	        towgs84: function(v) {
	          self.datum_params = v.split(",").map(function(a) {
	            return parseFloat(a);
	          });
	        },
	        to_meter: function(v) {
	          self.to_meter = parseFloat(v);
	        },
	        units: function(v) {
	          self.units = v;
	          var unit = match(units, v);
	          if (unit) {
	            self.to_meter = unit.to_meter;
	          }
	        },
	        from_greenwich: function(v) {
	          self.from_greenwich = v * D2R;
	        },
	        pm: function(v) {
	          var pm = match(exports$1, v);
	          self.from_greenwich = (pm ? pm : parseFloat(v)) * D2R;
	        },
	        nadgrids: function(v) {
	          if (v === '@null') {
	            self.datumCode = 'none';
	          }
	          else {
	            self.nadgrids = v;
	          }
	        },
	        axis: function(v) {
	          var legalAxis = "ewnsud";
	          if (v.length === 3 && legalAxis.indexOf(v.substr(0, 1)) !== -1 && legalAxis.indexOf(v.substr(1, 1)) !== -1 && legalAxis.indexOf(v.substr(2, 1)) !== -1) {
	            self.axis = v;
	          }
	        },
	        approx: function() {
	          self.approx = true;
	        }
	      };
	      for (paramName in paramObj) {
	        paramVal = paramObj[paramName];
	        if (paramName in params) {
	          paramOutname = params[paramName];
	          if (typeof paramOutname === 'function') {
	            paramOutname(paramVal);
	          }
	          else {
	            self[paramOutname] = paramVal;
	          }
	        }
	        else {
	          self[paramName] = paramVal;
	        }
	      }
	      if(typeof self.datumCode === 'string' && self.datumCode !== "WGS84"){
	        self.datumCode = self.datumCode.toLowerCase();
	      }
	      return self;
	    };
	
	    var NEUTRAL = 1;
	    var KEYWORD = 2;
	    var NUMBER = 3;
	    var QUOTED = 4;
	    var AFTERQUOTE = 5;
	    var ENDED = -1;
	    var whitespace = /\s/;
	    var latin = /[A-Za-z]/;
	    var keyword = /[A-Za-z84]/;
	    var endThings = /[,\]]/;
	    var digets = /[\d\.E\-\+]/;
	    // const ignoredChar = /[\s_\-\/\(\)]/g;
	    function Parser(text) {
	      if (typeof text !== 'string') {
	        throw new Error('not a string');
	      }
	      this.text = text.trim();
	      this.level = 0;
	      this.place = 0;
	      this.root = null;
	      this.stack = [];
	      this.currentObject = null;
	      this.state = NEUTRAL;
	    }
	    Parser.prototype.readCharicter = function() {
	      var char = this.text[this.place++];
	      if (this.state !== QUOTED) {
	        while (whitespace.test(char)) {
	          if (this.place >= this.text.length) {
	            return;
	          }
	          char = this.text[this.place++];
	        }
	      }
	      switch (this.state) {
	        case NEUTRAL:
	          return this.neutral(char);
	        case KEYWORD:
	          return this.keyword(char)
	        case QUOTED:
	          return this.quoted(char);
	        case AFTERQUOTE:
	          return this.afterquote(char);
	        case NUMBER:
	          return this.number(char);
	        case ENDED:
	          return;
	      }
	    };
	    Parser.prototype.afterquote = function(char) {
	      if (char === '"') {
	        this.word += '"';
	        this.state = QUOTED;
	        return;
	      }
	      if (endThings.test(char)) {
	        this.word = this.word.trim();
	        this.afterItem(char);
	        return;
	      }
	      throw new Error('havn\'t handled "' +char + '" in afterquote yet, index ' + this.place);
	    };
	    Parser.prototype.afterItem = function(char) {
	      if (char === ',') {
	        if (this.word !== null) {
	          this.currentObject.push(this.word);
	        }
	        this.word = null;
	        this.state = NEUTRAL;
	        return;
	      }
	      if (char === ']') {
	        this.level--;
	        if (this.word !== null) {
	          this.currentObject.push(this.word);
	          this.word = null;
	        }
	        this.state = NEUTRAL;
	        this.currentObject = this.stack.pop();
	        if (!this.currentObject) {
	          this.state = ENDED;
	        }
	
	        return;
	      }
	    };
	    Parser.prototype.number = function(char) {
	      if (digets.test(char)) {
	        this.word += char;
	        return;
	      }
	      if (endThings.test(char)) {
	        this.word = parseFloat(this.word);
	        this.afterItem(char);
	        return;
	      }
	      throw new Error('havn\'t handled "' +char + '" in number yet, index ' + this.place);
	    };
	    Parser.prototype.quoted = function(char) {
	      if (char === '"') {
	        this.state = AFTERQUOTE;
	        return;
	      }
	      this.word += char;
	      return;
	    };
	    Parser.prototype.keyword = function(char) {
	      if (keyword.test(char)) {
	        this.word += char;
	        return;
	      }
	      if (char === '[') {
	        var newObjects = [];
	        newObjects.push(this.word);
	        this.level++;
	        if (this.root === null) {
	          this.root = newObjects;
	        } else {
	          this.currentObject.push(newObjects);
	        }
	        this.stack.push(this.currentObject);
	        this.currentObject = newObjects;
	        this.state = NEUTRAL;
	        return;
	      }
	      if (endThings.test(char)) {
	        this.afterItem(char);
	        return;
	      }
	      throw new Error('havn\'t handled "' +char + '" in keyword yet, index ' + this.place);
	    };
	    Parser.prototype.neutral = function(char) {
	      if (latin.test(char)) {
	        this.word = char;
	        this.state = KEYWORD;
	        return;
	      }
	      if (char === '"') {
	        this.word = '';
	        this.state = QUOTED;
	        return;
	      }
	      if (digets.test(char)) {
	        this.word = char;
	        this.state = NUMBER;
	        return;
	      }
	      if (endThings.test(char)) {
	        this.afterItem(char);
	        return;
	      }
	      throw new Error('havn\'t handled "' +char + '" in neutral yet, index ' + this.place);
	    };
	    Parser.prototype.output = function() {
	      while (this.place < this.text.length) {
	        this.readCharicter();
	      }
	      if (this.state === ENDED) {
	        return this.root;
	      }
	      throw new Error('unable to parse string "' +this.text + '". State is ' + this.state);
	    };
	
	    function parseString(txt) {
	      var parser = new Parser(txt);
	      return parser.output();
	    }
	
	    function mapit(obj, key, value) {
	      if (Array.isArray(key)) {
	        value.unshift(key);
	        key = null;
	      }
	      var thing = key ? {} : obj;
	
	      var out = value.reduce(function(newObj, item) {
	        sExpr(item, newObj);
	        return newObj
	      }, thing);
	      if (key) {
	        obj[key] = out;
	      }
	    }
	
	    function sExpr(v, obj) {
	      if (!Array.isArray(v)) {
	        obj[v] = true;
	        return;
	      }
	      var key = v.shift();
	      if (key === 'PARAMETER') {
	        key = v.shift();
	      }
	      if (v.length === 1) {
	        if (Array.isArray(v[0])) {
	          obj[key] = {};
	          sExpr(v[0], obj[key]);
	          return;
	        }
	        obj[key] = v[0];
	        return;
	      }
	      if (!v.length) {
	        obj[key] = true;
	        return;
	      }
	      if (key === 'TOWGS84') {
	        obj[key] = v;
	        return;
	      }
	      if (key === 'AXIS') {
	        if (!(key in obj)) {
	          obj[key] = [];
	        }
	        obj[key].push(v);
	        return;
	      }
	      if (!Array.isArray(key)) {
	        obj[key] = {};
	      }
	
	      var i;
	      switch (key) {
	        case 'UNIT':
	        case 'PRIMEM':
	        case 'VERT_DATUM':
	          obj[key] = {
	            name: v[0].toLowerCase(),
	            convert: v[1]
	          };
	          if (v.length === 3) {
	            sExpr(v[2], obj[key]);
	          }
	          return;
	        case 'SPHEROID':
	        case 'ELLIPSOID':
	          obj[key] = {
	            name: v[0],
	            a: v[1],
	            rf: v[2]
	          };
	          if (v.length === 4) {
	            sExpr(v[3], obj[key]);
	          }
	          return;
	        case 'PROJECTEDCRS':
	        case 'PROJCRS':
	        case 'GEOGCS':
	        case 'GEOCCS':
	        case 'PROJCS':
	        case 'LOCAL_CS':
	        case 'GEODCRS':
	        case 'GEODETICCRS':
	        case 'GEODETICDATUM':
	        case 'EDATUM':
	        case 'ENGINEERINGDATUM':
	        case 'VERT_CS':
	        case 'VERTCRS':
	        case 'VERTICALCRS':
	        case 'COMPD_CS':
	        case 'COMPOUNDCRS':
	        case 'ENGINEERINGCRS':
	        case 'ENGCRS':
	        case 'FITTED_CS':
	        case 'LOCAL_DATUM':
	        case 'DATUM':
	          v[0] = ['name', v[0]];
	          mapit(obj, key, v);
	          return;
	        default:
	          i = -1;
	          while (++i < v.length) {
	            if (!Array.isArray(v[i])) {
	              return sExpr(v, obj[key]);
	            }
	          }
	          return mapit(obj, key, v);
	      }
	    }
	
	    var D2R$1 = 0.01745329251994329577;
	    function rename(obj, params) {
	      var outName = params[0];
	      var inName = params[1];
	      if (!(outName in obj) && (inName in obj)) {
	        obj[outName] = obj[inName];
	        if (params.length === 3) {
	          obj[outName] = params[2](obj[outName]);
	        }
	      }
	    }
	
	    function d2r(input) {
	      return input * D2R$1;
	    }
	
	    function cleanWKT(wkt) {
	      if (wkt.type === 'GEOGCS') {
	        wkt.projName = 'longlat';
	      } else if (wkt.type === 'LOCAL_CS') {
	        wkt.projName = 'identity';
	        wkt.local = true;
	      } else {
	        if (typeof wkt.PROJECTION === 'object') {
	          wkt.projName = Object.keys(wkt.PROJECTION)[0];
	        } else {
	          wkt.projName = wkt.PROJECTION;
	        }
	      }
	      if (wkt.AXIS) {
	        var axisOrder = '';
	        for (var i = 0, ii = wkt.AXIS.length; i < ii; ++i) {
	          var axis = wkt.AXIS[i];
	          var descriptor = axis[0].toLowerCase();
	          if (descriptor.indexOf('north') !== -1) {
	            axisOrder += 'n';
	          } else if (descriptor.indexOf('south') !== -1) {
	            axisOrder += 's';
	          } else if (descriptor.indexOf('east') !== -1) {
	            axisOrder += 'e';
	          } else if (descriptor.indexOf('west') !== -1) {
	            axisOrder += 'w';
	          }
	        }
	        if (axisOrder.length === 2) {
	          axisOrder += 'u';
	        }
	        if (axisOrder.length === 3) {
	          wkt.axis = axisOrder;
	        }
	      }
	      if (wkt.UNIT) {
	        wkt.units = wkt.UNIT.name.toLowerCase();
	        if (wkt.units === 'metre') {
	          wkt.units = 'meter';
	        }
	        if (wkt.UNIT.convert) {
	          if (wkt.type === 'GEOGCS') {
	            if (wkt.DATUM && wkt.DATUM.SPHEROID) {
	              wkt.to_meter = wkt.UNIT.convert*wkt.DATUM.SPHEROID.a;
	            }
	          } else {
	            wkt.to_meter = wkt.UNIT.convert;
	          }
	        }
	      }
	      var geogcs = wkt.GEOGCS;
	      if (wkt.type === 'GEOGCS') {
	        geogcs = wkt;
	      }
	      if (geogcs) {
	        //if(wkt.GEOGCS.PRIMEM&&wkt.GEOGCS.PRIMEM.convert){
	        //  wkt.from_greenwich=wkt.GEOGCS.PRIMEM.convert*D2R;
	        //}
	        if (geogcs.DATUM) {
	          wkt.datumCode = geogcs.DATUM.name.toLowerCase();
	        } else {
	          wkt.datumCode = geogcs.name.toLowerCase();
	        }
	        if (wkt.datumCode.slice(0, 2) === 'd_') {
	          wkt.datumCode = wkt.datumCode.slice(2);
	        }
	        if (wkt.datumCode === 'new_zealand_geodetic_datum_1949' || wkt.datumCode === 'new_zealand_1949') {
	          wkt.datumCode = 'nzgd49';
	        }
	        if (wkt.datumCode === 'wgs_1984' || wkt.datumCode === 'world_geodetic_system_1984') {
	          if (wkt.PROJECTION === 'Mercator_Auxiliary_Sphere') {
	            wkt.sphere = true;
	          }
	          wkt.datumCode = 'wgs84';
	        }
	        if (wkt.datumCode.slice(-6) === '_ferro') {
	          wkt.datumCode = wkt.datumCode.slice(0, - 6);
	        }
	        if (wkt.datumCode.slice(-8) === '_jakarta') {
	          wkt.datumCode = wkt.datumCode.slice(0, - 8);
	        }
	        if (~wkt.datumCode.indexOf('belge')) {
	          wkt.datumCode = 'rnb72';
	        }
	        if (geogcs.DATUM && geogcs.DATUM.SPHEROID) {
	          wkt.ellps = geogcs.DATUM.SPHEROID.name.replace('_19', '').replace(/[Cc]larke\_18/, 'clrk');
	          if (wkt.ellps.toLowerCase().slice(0, 13) === 'international') {
	            wkt.ellps = 'intl';
	          }
	
	          wkt.a = geogcs.DATUM.SPHEROID.a;
	          wkt.rf = parseFloat(geogcs.DATUM.SPHEROID.rf, 10);
	        }
	
	        if (geogcs.DATUM && geogcs.DATUM.TOWGS84) {
	          wkt.datum_params = geogcs.DATUM.TOWGS84;
	        }
	        if (~wkt.datumCode.indexOf('osgb_1936')) {
	          wkt.datumCode = 'osgb36';
	        }
	        if (~wkt.datumCode.indexOf('osni_1952')) {
	          wkt.datumCode = 'osni52';
	        }
	        if (~wkt.datumCode.indexOf('tm65')
	          || ~wkt.datumCode.indexOf('geodetic_datum_of_1965')) {
	          wkt.datumCode = 'ire65';
	        }
	        if (wkt.datumCode === 'ch1903+') {
	          wkt.datumCode = 'ch1903';
	        }
	        if (~wkt.datumCode.indexOf('israel')) {
	          wkt.datumCode = 'isr93';
	        }
	      }
	      if (wkt.b && !isFinite(wkt.b)) {
	        wkt.b = wkt.a;
	      }
	
	      function toMeter(input) {
	        var ratio = wkt.to_meter || 1;
	        return input * ratio;
	      }
	      var renamer = function(a) {
	        return rename(wkt, a);
	      };
	      var list = [
	        ['standard_parallel_1', 'Standard_Parallel_1'],
	        ['standard_parallel_2', 'Standard_Parallel_2'],
	        ['false_easting', 'False_Easting'],
	        ['false_northing', 'False_Northing'],
	        ['central_meridian', 'Central_Meridian'],
	        ['latitude_of_origin', 'Latitude_Of_Origin'],
	        ['latitude_of_origin', 'Central_Parallel'],
	        ['scale_factor', 'Scale_Factor'],
	        ['k0', 'scale_factor'],
	        ['latitude_of_center', 'Latitude_Of_Center'],
	        ['latitude_of_center', 'Latitude_of_center'],
	        ['lat0', 'latitude_of_center', d2r],
	        ['longitude_of_center', 'Longitude_Of_Center'],
	        ['longitude_of_center', 'Longitude_of_center'],
	        ['longc', 'longitude_of_center', d2r],
	        ['x0', 'false_easting', toMeter],
	        ['y0', 'false_northing', toMeter],
	        ['long0', 'central_meridian', d2r],
	        ['lat0', 'latitude_of_origin', d2r],
	        ['lat0', 'standard_parallel_1', d2r],
	        ['lat1', 'standard_parallel_1', d2r],
	        ['lat2', 'standard_parallel_2', d2r],
	        ['azimuth', 'Azimuth'],
	        ['alpha', 'azimuth', d2r],
	        ['srsCode', 'name']
	      ];
	      list.forEach(renamer);
	      if (!wkt.long0 && wkt.longc && (wkt.projName === 'Albers_Conic_Equal_Area' || wkt.projName === 'Lambert_Azimuthal_Equal_Area')) {
	        wkt.long0 = wkt.longc;
	      }
	      if (!wkt.lat_ts && wkt.lat1 && (wkt.projName === 'Stereographic_South_Pole' || wkt.projName === 'Polar Stereographic (variant B)')) {
	        wkt.lat0 = d2r(wkt.lat1 > 0 ? 90 : -90);
	        wkt.lat_ts = wkt.lat1;
	      }
	    }
	    var wkt = function(wkt) {
	      var lisp = parseString(wkt);
	      var type = lisp.shift();
	      var name = lisp.shift();
	      lisp.unshift(['name', name]);
	      lisp.unshift(['type', type]);
	      var obj = {};
	      sExpr(lisp, obj);
	      cleanWKT(obj);
	      return obj;
	    };
	
	    function defs(name) {
	      /*global console*/
	      var that = this;
	      if (arguments.length === 2) {
	        var def = arguments[1];
	        if (typeof def === 'string') {
	          if (def.charAt(0) === '+') {
	            defs[name] = parseProj(arguments[1]);
	          }
	          else {
	            defs[name] = wkt(arguments[1]);
	          }
	        } else {
	          defs[name] = def;
	        }
	      }
	      else if (arguments.length === 1) {
	        if (Array.isArray(name)) {
	          return name.map(function(v) {
	            if (Array.isArray(v)) {
	              defs.apply(that, v);
	            }
	            else {
	              defs(v);
	            }
	          });
	        }
	        else if (typeof name === 'string') {
	          if (name in defs) {
	            return defs[name];
	          }
	        }
	        else if ('EPSG' in name) {
	          defs['EPSG:' + name.EPSG] = name;
	        }
	        else if ('ESRI' in name) {
	          defs['ESRI:' + name.ESRI] = name;
	        }
	        else if ('IAU2000' in name) {
	          defs['IAU2000:' + name.IAU2000] = name;
	        }
	        else {
	          console.log(name);
	        }
	        return;
	      }
	
	
	    }
	    globals(defs);
	
	    function testObj(code){
	      return typeof code === 'string';
	    }
	    function testDef(code){
	      return code in defs;
	    }
	    var codeWords = ['PROJECTEDCRS', 'PROJCRS', 'GEOGCS','GEOCCS','PROJCS','LOCAL_CS', 'GEODCRS', 'GEODETICCRS', 'GEODETICDATUM', 'ENGCRS', 'ENGINEERINGCRS'];
	    function testWKT(code){
	      return codeWords.some(function (word) {
	        return code.indexOf(word) > -1;
	      });
	    }
	    var codes = ['3857', '900913', '3785', '102113'];
	    function checkMercator(item) {
	      var auth = match(item, 'authority');
	      if (!auth) {
	        return;
	      }
	      var code = match(auth, 'epsg');
	      return code && codes.indexOf(code) > -1;
	    }
	    function checkProjStr(item) {
	      var ext = match(item, 'extension');
	      if (!ext) {
	        return;
	      }
	      return match(ext, 'proj4');
	    }
	    function testProj(code){
	      return code[0] === '+';
	    }
	    function parse(code){
	      if (testObj(code)) {
	        //check to see if this is a WKT string
	        if (testDef(code)) {
	          return defs[code];
	        }
	        if (testWKT(code)) {
	          var out = wkt(code);
	          // test of spetial case, due to this being a very common and often malformed
	          if (checkMercator(out)) {
	            return defs['EPSG:3857'];
	          }
	          var maybeProjStr = checkProjStr(out);
	          if (maybeProjStr) {
	            return parseProj(maybeProjStr);
	          }
	          return out;
	        }
	        if (testProj(code)) {
	          return parseProj(code);
	        }
	      }else{
	        return code;
	      }
	    }
	
	    var extend = function(destination, source) {
	      destination = destination || {};
	      var value, property;
	      if (!source) {
	        return destination;
	      }
	      for (property in source) {
	        value = source[property];
	        if (value !== undefined) {
	          destination[property] = value;
	        }
	      }
	      return destination;
	    };
	
	    var msfnz = function(eccent, sinphi, cosphi) {
	      var con = eccent * sinphi;
	      return cosphi / (Math.sqrt(1 - con * con));
	    };
	
	    var sign = function(x) {
	      return x<0 ? -1 : 1;
	    };
	
	    var adjust_lon = function(x) {
	      return (Math.abs(x) <= SPI) ? x : (x - (sign(x) * TWO_PI));
	    };
	
	    var tsfnz = function(eccent, phi, sinphi) {
	      var con = eccent * sinphi;
	      var com = 0.5 * eccent;
	      con = Math.pow(((1 - con) / (1 + con)), com);
	      return (Math.tan(0.5 * (HALF_PI - phi)) / con);
	    };
	
	    var phi2z = function(eccent, ts) {
	      var eccnth = 0.5 * eccent;
	      var con, dphi;
	      var phi = HALF_PI - 2 * Math.atan(ts);
	      for (var i = 0; i <= 15; i++) {
	        con = eccent * Math.sin(phi);
	        dphi = HALF_PI - 2 * Math.atan(ts * (Math.pow(((1 - con) / (1 + con)), eccnth))) - phi;
	        phi += dphi;
	        if (Math.abs(dphi) <= 0.0000000001) {
	          return phi;
	        }
	      }
	      //console.log("phi2z has NoConvergence");
	      return -9999;
	    };
	
	    function init() {
	      var con = this.b / this.a;
	      this.es = 1 - con * con;
	      if(!('x0' in this)){
	        this.x0 = 0;
	      }
	      if(!('y0' in this)){
	        this.y0 = 0;
	      }
	      this.e = Math.sqrt(this.es);
	      if (this.lat_ts) {
	        if (this.sphere) {
	          this.k0 = Math.cos(this.lat_ts);
	        }
	        else {
	          this.k0 = msfnz(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
	        }
	      }
	      else {
	        if (!this.k0) {
	          if (this.k) {
	            this.k0 = this.k;
	          }
	          else {
	            this.k0 = 1;
	          }
	        }
	      }
	    }
	
	    /* Mercator forward equations--mapping lat,long to x,y
	      --------------------------------------------------*/
	
	    function forward(p) {
	      var lon = p.x;
	      var lat = p.y;
	      // convert to radians
	      if (lat * R2D > 90 && lat * R2D < -90 && lon * R2D > 180 && lon * R2D < -180) {
	        return null;
	      }
	
	      var x, y;
	      if (Math.abs(Math.abs(lat) - HALF_PI) <= EPSLN) {
	        return null;
	      }
	      else {
	        if (this.sphere) {
	          x = this.x0 + this.a * this.k0 * adjust_lon(lon - this.long0);
	          y = this.y0 + this.a * this.k0 * Math.log(Math.tan(FORTPI + 0.5 * lat));
	        }
	        else {
	          var sinphi = Math.sin(lat);
	          var ts = tsfnz(this.e, lat, sinphi);
	          x = this.x0 + this.a * this.k0 * adjust_lon(lon - this.long0);
	          y = this.y0 - this.a * this.k0 * Math.log(ts);
	        }
	        p.x = x;
	        p.y = y;
	        return p;
	      }
	    }
	
	    /* Mercator inverse equations--mapping x,y to lat/long
	      --------------------------------------------------*/
	    function inverse(p) {
	
	      var x = p.x - this.x0;
	      var y = p.y - this.y0;
	      var lon, lat;
	
	      if (this.sphere) {
	        lat = HALF_PI - 2 * Math.atan(Math.exp(-y / (this.a * this.k0)));
	      }
	      else {
	        var ts = Math.exp(-y / (this.a * this.k0));
	        lat = phi2z(this.e, ts);
	        if (lat === -9999) {
	          return null;
	        }
	      }
	      lon = adjust_lon(this.long0 + x / (this.a * this.k0));
	
	      p.x = lon;
	      p.y = lat;
	      return p;
	    }
	
	    var names$1 = ["Mercator", "Popular Visualisation Pseudo Mercator", "Mercator_1SP", "Mercator_Auxiliary_Sphere", "merc"];
	    var merc = {
	      init: init,
	      forward: forward,
	      inverse: inverse,
	      names: names$1
	    };
	
	    function init$1() {
	      //no-op for longlat
	    }
	
	    function identity(pt) {
	      return pt;
	    }
	    var names$2 = ["longlat", "identity"];
	    var longlat = {
	      init: init$1,
	      forward: identity,
	      inverse: identity,
	      names: names$2
	    };
	
	    var projs = [merc, longlat];
	    var names = {};
	    var projStore = [];
	
	    function add(proj, i) {
	      var len = projStore.length;
	      if (!proj.names) {
	        console.log(i);
	        return true;
	      }
	      projStore[len] = proj;
	      proj.names.forEach(function(n) {
	        names[n.toLowerCase()] = len;
	      });
	      return this;
	    }
	
	    function get(name) {
	      if (!name) {
	        return false;
	      }
	      var n = name.toLowerCase();
	      if (typeof names[n] !== 'undefined' && projStore[names[n]]) {
	        return projStore[names[n]];
	      }
	    }
	
	    function start() {
	      projs.forEach(add);
	    }
	    var projections = {
	      start: start,
	      add: add,
	      get: get
	    };
	
	    var exports$2 = {};
	    exports$2.MERIT = {
	      a: 6378137.0,
	      rf: 298.257,
	      ellipseName: "MERIT 1983"
	    };
	
	    exports$2.SGS85 = {
	      a: 6378136.0,
	      rf: 298.257,
	      ellipseName: "Soviet Geodetic System 85"
	    };
	
	    exports$2.GRS80 = {
	      a: 6378137.0,
	      rf: 298.257222101,
	      ellipseName: "GRS 1980(IUGG, 1980)"
	    };
	
	    exports$2.IAU76 = {
	      a: 6378140.0,
	      rf: 298.257,
	      ellipseName: "IAU 1976"
	    };
	
	    exports$2.airy = {
	      a: 6377563.396,
	      b: 6356256.910,
	      ellipseName: "Airy 1830"
	    };
	
	    exports$2.APL4 = {
	      a: 6378137,
	      rf: 298.25,
	      ellipseName: "Appl. Physics. 1965"
	    };
	
	    exports$2.NWL9D = {
	      a: 6378145.0,
	      rf: 298.25,
	      ellipseName: "Naval Weapons Lab., 1965"
	    };
	
	    exports$2.mod_airy = {
	      a: 6377340.189,
	      b: 6356034.446,
	      ellipseName: "Modified Airy"
	    };
	
	    exports$2.andrae = {
	      a: 6377104.43,
	      rf: 300.0,
	      ellipseName: "Andrae 1876 (Den., Iclnd.)"
	    };
	
	    exports$2.aust_SA = {
	      a: 6378160.0,
	      rf: 298.25,
	      ellipseName: "Australian Natl & S. Amer. 1969"
	    };
	
	    exports$2.GRS67 = {
	      a: 6378160.0,
	      rf: 298.2471674270,
	      ellipseName: "GRS 67(IUGG 1967)"
	    };
	
	    exports$2.bessel = {
	      a: 6377397.155,
	      rf: 299.1528128,
	      ellipseName: "Bessel 1841"
	    };
	
	    exports$2.bess_nam = {
	      a: 6377483.865,
	      rf: 299.1528128,
	      ellipseName: "Bessel 1841 (Namibia)"
	    };
	
	    exports$2.clrk66 = {
	      a: 6378206.4,
	      b: 6356583.8,
	      ellipseName: "Clarke 1866"
	    };
	
	    exports$2.clrk80 = {
	      a: 6378249.145,
	      rf: 293.4663,
	      ellipseName: "Clarke 1880 mod."
	    };
	
	    exports$2.clrk58 = {
	      a: 6378293.645208759,
	      rf: 294.2606763692654,
	      ellipseName: "Clarke 1858"
	    };
	
	    exports$2.CPM = {
	      a: 6375738.7,
	      rf: 334.29,
	      ellipseName: "Comm. des Poids et Mesures 1799"
	    };
	
	    exports$2.delmbr = {
	      a: 6376428.0,
	      rf: 311.5,
	      ellipseName: "Delambre 1810 (Belgium)"
	    };
	
	    exports$2.engelis = {
	      a: 6378136.05,
	      rf: 298.2566,
	      ellipseName: "Engelis 1985"
	    };
	
	    exports$2.evrst30 = {
	      a: 6377276.345,
	      rf: 300.8017,
	      ellipseName: "Everest 1830"
	    };
	
	    exports$2.evrst48 = {
	      a: 6377304.063,
	      rf: 300.8017,
	      ellipseName: "Everest 1948"
	    };
	
	    exports$2.evrst56 = {
	      a: 6377301.243,
	      rf: 300.8017,
	      ellipseName: "Everest 1956"
	    };
	
	    exports$2.evrst69 = {
	      a: 6377295.664,
	      rf: 300.8017,
	      ellipseName: "Everest 1969"
	    };
	
	    exports$2.evrstSS = {
	      a: 6377298.556,
	      rf: 300.8017,
	      ellipseName: "Everest (Sabah & Sarawak)"
	    };
	
	    exports$2.fschr60 = {
	      a: 6378166.0,
	      rf: 298.3,
	      ellipseName: "Fischer (Mercury Datum) 1960"
	    };
	
	    exports$2.fschr60m = {
	      a: 6378155.0,
	      rf: 298.3,
	      ellipseName: "Fischer 1960"
	    };
	
	    exports$2.fschr68 = {
	      a: 6378150.0,
	      rf: 298.3,
	      ellipseName: "Fischer 1968"
	    };
	
	    exports$2.helmert = {
	      a: 6378200.0,
	      rf: 298.3,
	      ellipseName: "Helmert 1906"
	    };
	
	    exports$2.hough = {
	      a: 6378270.0,
	      rf: 297.0,
	      ellipseName: "Hough"
	    };
	
	    exports$2.intl = {
	      a: 6378388.0,
	      rf: 297.0,
	      ellipseName: "International 1909 (Hayford)"
	    };
	
	    exports$2.kaula = {
	      a: 6378163.0,
	      rf: 298.24,
	      ellipseName: "Kaula 1961"
	    };
	
	    exports$2.lerch = {
	      a: 6378139.0,
	      rf: 298.257,
	      ellipseName: "Lerch 1979"
	    };
	
	    exports$2.mprts = {
	      a: 6397300.0,
	      rf: 191.0,
	      ellipseName: "Maupertius 1738"
	    };
	
	    exports$2.new_intl = {
	      a: 6378157.5,
	      b: 6356772.2,
	      ellipseName: "New International 1967"
	    };
	
	    exports$2.plessis = {
	      a: 6376523.0,
	      rf: 6355863.0,
	      ellipseName: "Plessis 1817 (France)"
	    };
	
	    exports$2.krass = {
	      a: 6378245.0,
	      rf: 298.3,
	      ellipseName: "Krassovsky, 1942"
	    };
	
	    exports$2.SEasia = {
	      a: 6378155.0,
	      b: 6356773.3205,
	      ellipseName: "Southeast Asia"
	    };
	
	    exports$2.walbeck = {
	      a: 6376896.0,
	      b: 6355834.8467,
	      ellipseName: "Walbeck"
	    };
	
	    exports$2.WGS60 = {
	      a: 6378165.0,
	      rf: 298.3,
	      ellipseName: "WGS 60"
	    };
	
	    exports$2.WGS66 = {
	      a: 6378145.0,
	      rf: 298.25,
	      ellipseName: "WGS 66"
	    };
	
	    exports$2.WGS7 = {
	      a: 6378135.0,
	      rf: 298.26,
	      ellipseName: "WGS 72"
	    };
	
	    var WGS84 = exports$2.WGS84 = {
	      a: 6378137.0,
	      rf: 298.257223563,
	      ellipseName: "WGS 84"
	    };
	
	    exports$2.sphere = {
	      a: 6370997.0,
	      b: 6370997.0,
	      ellipseName: "Normal Sphere (r=6370997)"
	    };
	
	    function eccentricity(a, b, rf, R_A) {
	      var a2 = a * a; // used in geocentric
	      var b2 = b * b; // used in geocentric
	      var es = (a2 - b2) / a2; // e ^ 2
	      var e = 0;
	      if (R_A) {
	        a *= 1 - es * (SIXTH + es * (RA4 + es * RA6));
	        a2 = a * a;
	        es = 0;
	      } else {
	        e = Math.sqrt(es); // eccentricity
	      }
	      var ep2 = (a2 - b2) / b2; // used in geocentric
	      return {
	        es: es,
	        e: e,
	        ep2: ep2
	      };
	    }
	    function sphere(a, b, rf, ellps, sphere) {
	      if (!a) { // do we have an ellipsoid?
	        var ellipse = match(exports$2, ellps);
	        if (!ellipse) {
	          ellipse = WGS84;
	        }
	        a = ellipse.a;
	        b = ellipse.b;
	        rf = ellipse.rf;
	      }
	
	      if (rf && !b) {
	        b = (1.0 - 1.0 / rf) * a;
	      }
	      if (rf === 0 || Math.abs(a - b) < EPSLN) {
	        sphere = true;
	        b = a;
	      }
	      return {
	        a: a,
	        b: b,
	        rf: rf,
	        sphere: sphere
	      };
	    }
	
	    var exports$3 = {};
	    exports$3.wgs84 = {
	      towgs84: "0,0,0",
	      ellipse: "WGS84",
	      datumName: "WGS84"
	    };
	
	    exports$3.ch1903 = {
	      towgs84: "674.374,15.056,405.346",
	      ellipse: "bessel",
	      datumName: "swiss"
	    };
	
	    exports$3.ggrs87 = {
	      towgs84: "-199.87,74.79,246.62",
	      ellipse: "GRS80",
	      datumName: "Greek_Geodetic_Reference_System_1987"
	    };
	
	    exports$3.nad83 = {
	      towgs84: "0,0,0",
	      ellipse: "GRS80",
	      datumName: "North_American_Datum_1983"
	    };
	
	    exports$3.nad27 = {
	      nadgrids: "@conus,@alaska,@ntv2_0.gsb,@ntv1_can.dat",
	      ellipse: "clrk66",
	      datumName: "North_American_Datum_1927"
	    };
	
	    exports$3.potsdam = {
	      towgs84: "606.0,23.0,413.0",
	      ellipse: "bessel",
	      datumName: "Potsdam Rauenberg 1950 DHDN"
	    };
	
	    exports$3.carthage = {
	      towgs84: "-263.0,6.0,431.0",
	      ellipse: "clark80",
	      datumName: "Carthage 1934 Tunisia"
	    };
	
	    exports$3.hermannskogel = {
	      towgs84: "653.0,-212.0,449.0",
	      ellipse: "bessel",
	      datumName: "Hermannskogel"
	    };
	
	    exports$3.osni52 = {
	      towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
	      ellipse: "airy",
	      datumName: "Irish National"
	    };
	
	    exports$3.ire65 = {
	      towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
	      ellipse: "mod_airy",
	      datumName: "Ireland 1965"
	    };
	
	    exports$3.rassadiran = {
	      towgs84: "-133.63,-157.5,-158.62",
	      ellipse: "intl",
	      datumName: "Rassadiran"
	    };
	
	    exports$3.nzgd49 = {
	      towgs84: "59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993",
	      ellipse: "intl",
	      datumName: "New Zealand Geodetic Datum 1949"
	    };
	
	    exports$3.osgb36 = {
	      towgs84: "446.448,-125.157,542.060,0.1502,0.2470,0.8421,-20.4894",
	      ellipse: "airy",
	      datumName: "Airy 1830"
	    };
	
	    exports$3.s_jtsk = {
	      towgs84: "589,76,480",
	      ellipse: 'bessel',
	      datumName: 'S-JTSK (Ferro)'
	    };
	
	    exports$3.beduaram = {
	      towgs84: '-106,-87,188',
	      ellipse: 'clrk80',
	      datumName: 'Beduaram'
	    };
	
	    exports$3.gunung_segara = {
	      towgs84: '-403,684,41',
	      ellipse: 'bessel',
	      datumName: 'Gunung Segara Jakarta'
	    };
	
	    exports$3.rnb72 = {
	      towgs84: "106.869,-52.2978,103.724,-0.33657,0.456955,-1.84218,1",
	      ellipse: "intl",
	      datumName: "Reseau National Belge 1972"
	    };
	
	    function datum(datumCode, datum_params, a, b, es, ep2, nadgrids) {
	      var out = {};
	
	      if (datumCode === undefined || datumCode === 'none') {
	        out.datum_type = PJD_NODATUM;
	      } else {
	        out.datum_type = PJD_WGS84;
	      }
	
	      if (datum_params) {
	        out.datum_params = datum_params.map(parseFloat);
	        if (out.datum_params[0] !== 0 || out.datum_params[1] !== 0 || out.datum_params[2] !== 0) {
	          out.datum_type = PJD_3PARAM;
	        }
	        if (out.datum_params.length > 3) {
	          if (out.datum_params[3] !== 0 || out.datum_params[4] !== 0 || out.datum_params[5] !== 0 || out.datum_params[6] !== 0) {
	            out.datum_type = PJD_7PARAM;
	            out.datum_params[3] *= SEC_TO_RAD;
	            out.datum_params[4] *= SEC_TO_RAD;
	            out.datum_params[5] *= SEC_TO_RAD;
	            out.datum_params[6] = (out.datum_params[6] / 1000000.0) + 1.0;
	          }
	        }
	      }
	
	      if (nadgrids) {
	        out.datum_type = PJD_GRIDSHIFT;
	        out.grids = nadgrids;
	      }
	      out.a = a; //datum object also uses these values
	      out.b = b;
	      out.es = es;
	      out.ep2 = ep2;
	      return out;
	    }
	
	    /**
	     * Resources for details of NTv2 file formats:
	     * - https://web.archive.org/web/20140127204822if_/http://www.mgs.gov.on.ca:80/stdprodconsume/groups/content/@mgs/@iandit/documents/resourcelist/stel02_047447.pdf
	     * - http://mimaka.com/help/gs/html/004_NTV2%20Data%20Format.htm
	     */
	
	    var loadedNadgrids = {};
	
	    /**
	     * Load a binary NTv2 file (.gsb) to a key that can be used in a proj string like +nadgrids=<key>. Pass the NTv2 file
	     * as an ArrayBuffer.
	     */
	    function nadgrid(key, data) {
	      var view = new DataView(data);
	      var isLittleEndian = detectLittleEndian(view);
	      var header = readHeader(view, isLittleEndian);
	      if (header.nSubgrids > 1) {
	        console.log('Only single NTv2 subgrids are currently supported, subsequent sub grids are ignored');
	      }
	      var subgrids = readSubgrids(view, header, isLittleEndian);
	      var nadgrid = {header: header, subgrids: subgrids};
	      loadedNadgrids[key] = nadgrid;
	      return nadgrid;
	    }
	
	    /**
	     * Given a proj4 value for nadgrids, return an array of loaded grids
	     */
	    function getNadgrids(nadgrids) {
	      // Format details: http://proj.maptools.org/gen_parms.html
	      if (nadgrids === undefined) { return null; }
	      var grids = nadgrids.split(',');
	      return grids.map(parseNadgridString);
	    }
	
	    function parseNadgridString(value) {
	      if (value.length === 0) {
	        return null;
	      }
	      var optional = value[0] === '@';
	      if (optional) {
	        value = value.slice(1);
	      }
	      if (value === 'null') {
	        return {name: 'null', mandatory: !optional, grid: null, isNull: true};
	      }
	      return {
	        name: value,
	        mandatory: !optional,
	        grid: loadedNadgrids[value] || null,
	        isNull: false
	      };
	    }
	
	    function secondsToRadians(seconds) {
	      return (seconds / 3600) * Math.PI / 180;
	    }
	
	    function detectLittleEndian(view) {
	      var nFields = view.getInt32(8, false);
	      if (nFields === 11) {
	        return false;
	      }
	      nFields = view.getInt32(8, true);
	      if (nFields !== 11) {
	        console.warn('Failed to detect nadgrid endian-ness, defaulting to little-endian');
	      }
	      return true;
	    }
	
	    function readHeader(view, isLittleEndian) {
	      return {
	        nFields: view.getInt32(8, isLittleEndian),
	        nSubgridFields: view.getInt32(24, isLittleEndian),
	        nSubgrids: view.getInt32(40, isLittleEndian),
	        shiftType: decodeString(view, 56, 56 + 8).trim(),
	        fromSemiMajorAxis: view.getFloat64(120, isLittleEndian),
	        fromSemiMinorAxis: view.getFloat64(136, isLittleEndian),
	        toSemiMajorAxis: view.getFloat64(152, isLittleEndian),
	        toSemiMinorAxis: view.getFloat64(168, isLittleEndian),
	      };
	    }
	
	    function decodeString(view, start, end) {
	      return String.fromCharCode.apply(null, new Uint8Array(view.buffer.slice(start, end)));
	    }
	
	    function readSubgrids(view, header, isLittleEndian) {
	      var gridOffset = 176;
	      var grids = [];
	      for (var i = 0; i < header.nSubgrids; i++) {
	        var subHeader = readGridHeader(view, gridOffset, isLittleEndian);
	        var nodes = readGridNodes(view, gridOffset, subHeader, isLittleEndian);
	        var lngColumnCount = Math.round(
	          1 + (subHeader.upperLongitude - subHeader.lowerLongitude) / subHeader.longitudeInterval);
	        var latColumnCount = Math.round(
	          1 + (subHeader.upperLatitude - subHeader.lowerLatitude) / subHeader.latitudeInterval);
	        // Proj4 operates on radians whereas the coordinates are in seconds in the grid
	        grids.push({
	          ll: [secondsToRadians(subHeader.lowerLongitude), secondsToRadians(subHeader.lowerLatitude)],
	          del: [secondsToRadians(subHeader.longitudeInterval), secondsToRadians(subHeader.latitudeInterval)],
	          lim: [lngColumnCount, latColumnCount],
	          count: subHeader.gridNodeCount,
	          cvs: mapNodes(nodes)
	        });
	      }
	      return grids;
	    }
	
	    function mapNodes(nodes) {
	      return nodes.map(function (r) {return [secondsToRadians(r.longitudeShift), secondsToRadians(r.latitudeShift)];});
	    }
	
	    function readGridHeader(view, offset, isLittleEndian) {
	      return {
	        name: decodeString(view, offset + 8, offset + 16).trim(),
	        parent: decodeString(view, offset + 24, offset + 24 + 8).trim(),
	        lowerLatitude: view.getFloat64(offset + 72, isLittleEndian),
	        upperLatitude: view.getFloat64(offset + 88, isLittleEndian),
	        lowerLongitude: view.getFloat64(offset + 104, isLittleEndian),
	        upperLongitude: view.getFloat64(offset + 120, isLittleEndian),
	        latitudeInterval: view.getFloat64(offset + 136, isLittleEndian),
	        longitudeInterval: view.getFloat64(offset + 152, isLittleEndian),
	        gridNodeCount: view.getInt32(offset + 168, isLittleEndian)
	      };
	    }
	
	    function readGridNodes(view, offset, gridHeader, isLittleEndian) {
	      var nodesOffset = offset + 176;
	      var gridRecordLength = 16;
	      var gridShiftRecords = [];
	      for (var i = 0; i < gridHeader.gridNodeCount; i++) {
	        var record = {
	          latitudeShift: view.getFloat32(nodesOffset + i * gridRecordLength, isLittleEndian),
	          longitudeShift: view.getFloat32(nodesOffset + i * gridRecordLength + 4, isLittleEndian),
	          latitudeAccuracy: view.getFloat32(nodesOffset + i * gridRecordLength + 8, isLittleEndian),
	          longitudeAccuracy: view.getFloat32(nodesOffset + i * gridRecordLength + 12, isLittleEndian),
	        };
	        gridShiftRecords.push(record);
	      }
	      return gridShiftRecords;
	    }
	
	    function Projection(srsCode,callback) {
	      if (!(this instanceof Projection)) {
	        return new Projection(srsCode);
	      }
	      callback = callback || function(error){
	        if(error){
	          throw error;
	        }
	      };
	      var json = parse(srsCode);
	      if(typeof json !== 'object'){
	        callback(srsCode);
	        return;
	      }
	      var ourProj = Projection.projections.get(json.projName);
	      if(!ourProj){
	        callback(srsCode);
	        return;
	      }
	      if (json.datumCode && json.datumCode !== 'none') {
	        var datumDef = match(exports$3, json.datumCode);
	        if (datumDef) {
	          json.datum_params = json.datum_params || (datumDef.towgs84 ? datumDef.towgs84.split(',') : null);
	          json.ellps = datumDef.ellipse;
	          json.datumName = datumDef.datumName ? datumDef.datumName : json.datumCode;
	        }
	      }
	      json.k0 = json.k0 || 1.0;
	      json.axis = json.axis || 'enu';
	      json.ellps = json.ellps || 'wgs84';
	      json.lat1 = json.lat1 || json.lat0; // Lambert_Conformal_Conic_1SP, for example, needs this
	
	      var sphere_ = sphere(json.a, json.b, json.rf, json.ellps, json.sphere);
	      var ecc = eccentricity(sphere_.a, sphere_.b, sphere_.rf, json.R_A);
	      var nadgrids = getNadgrids(json.nadgrids);
	      var datumObj = json.datum || datum(json.datumCode, json.datum_params, sphere_.a, sphere_.b, ecc.es, ecc.ep2,
	        nadgrids);
	
	      extend(this, json); // transfer everything over from the projection because we don't know what we'll need
	      extend(this, ourProj); // transfer all the methods from the projection
	
	      // copy the 4 things over we calulated in deriveConstants.sphere
	      this.a = sphere_.a;
	      this.b = sphere_.b;
	      this.rf = sphere_.rf;
	      this.sphere = sphere_.sphere;
	
	      // copy the 3 things we calculated in deriveConstants.eccentricity
	      this.es = ecc.es;
	      this.e = ecc.e;
	      this.ep2 = ecc.ep2;
	
	      // add in the datum object
	      this.datum = datumObj;
	
	      // init the projection
	      this.init();
	
	      // legecy callback from back in the day when it went to spatialreference.org
	      callback(null, this);
	
	    }
	    Projection.projections = projections;
	    Projection.projections.start();
	
	    'use strict';
	    function compareDatums(source, dest) {
	      if (source.datum_type !== dest.datum_type) {
	        return false; // false, datums are not equal
	      } else if (source.a !== dest.a || Math.abs(source.es - dest.es) > 0.000000000050) {
	        // the tolerance for es is to ensure that GRS80 and WGS84
	        // are considered identical
	        return false;
	      } else if (source.datum_type === PJD_3PARAM) {
	        return (source.datum_params[0] === dest.datum_params[0] && source.datum_params[1] === dest.datum_params[1] && source.datum_params[2] === dest.datum_params[2]);
	      } else if (source.datum_type === PJD_7PARAM) {
	        return (source.datum_params[0] === dest.datum_params[0] && source.datum_params[1] === dest.datum_params[1] && source.datum_params[2] === dest.datum_params[2] && source.datum_params[3] === dest.datum_params[3] && source.datum_params[4] === dest.datum_params[4] && source.datum_params[5] === dest.datum_params[5] && source.datum_params[6] === dest.datum_params[6]);
	      } else {
	        return true; // datums are equal
	      }
	    } // cs_compare_datums()
	
	    /*
	     * The function Convert_Geodetic_To_Geocentric converts geodetic coordinates
	     * (latitude, longitude, and height) to geocentric coordinates (X, Y, Z),
	     * according to the current ellipsoid parameters.
	     *
	     *    Latitude  : Geodetic latitude in radians                     (input)
	     *    Longitude : Geodetic longitude in radians                    (input)
	     *    Height    : Geodetic height, in meters                       (input)
	     *    X         : Calculated Geocentric X coordinate, in meters    (output)
	     *    Y         : Calculated Geocentric Y coordinate, in meters    (output)
	     *    Z         : Calculated Geocentric Z coordinate, in meters    (output)
	     *
	     */
	    function geodeticToGeocentric(p, es, a) {
	      var Longitude = p.x;
	      var Latitude = p.y;
	      var Height = p.z ? p.z : 0; //Z value not always supplied
	
	      var Rn; /*  Earth radius at location  */
	      var Sin_Lat; /*  Math.sin(Latitude)  */
	      var Sin2_Lat; /*  Square of Math.sin(Latitude)  */
	      var Cos_Lat; /*  Math.cos(Latitude)  */
	
	      /*
	       ** Don't blow up if Latitude is just a little out of the value
	       ** range as it may just be a rounding issue.  Also removed longitude
	       ** test, it should be wrapped by Math.cos() and Math.sin().  NFW for PROJ.4, Sep/2001.
	       */
	      if (Latitude < -HALF_PI && Latitude > -1.001 * HALF_PI) {
	        Latitude = -HALF_PI;
	      } else if (Latitude > HALF_PI && Latitude < 1.001 * HALF_PI) {
	        Latitude = HALF_PI;
	      } else if (Latitude < -HALF_PI) {
	        /* Latitude out of range */
	        //..reportError('geocent:lat out of range:' + Latitude);
	        return { x: -Infinity, y: -Infinity, z: p.z };
	      } else if (Latitude > HALF_PI) {
	        /* Latitude out of range */
	        return { x: Infinity, y: Infinity, z: p.z };
	      }
	
	      if (Longitude > Math.PI) {
	        Longitude -= (2 * Math.PI);
	      }
	      Sin_Lat = Math.sin(Latitude);
	      Cos_Lat = Math.cos(Latitude);
	      Sin2_Lat = Sin_Lat * Sin_Lat;
	      Rn = a / (Math.sqrt(1.0e0 - es * Sin2_Lat));
	      return {
	        x: (Rn + Height) * Cos_Lat * Math.cos(Longitude),
	        y: (Rn + Height) * Cos_Lat * Math.sin(Longitude),
	        z: ((Rn * (1 - es)) + Height) * Sin_Lat
	      };
	    } // cs_geodetic_to_geocentric()
	
	    function geocentricToGeodetic(p, es, a, b) {
	      /* local defintions and variables */
	      /* end-criterium of loop, accuracy of sin(Latitude) */
	      var genau = 1e-12;
	      var genau2 = (genau * genau);
	      var maxiter = 30;
	
	      var P; /* distance between semi-minor axis and location */
	      var RR; /* distance between center and location */
	      var CT; /* sin of geocentric latitude */
	      var ST; /* cos of geocentric latitude */
	      var RX;
	      var RK;
	      var RN; /* Earth radius at location */
	      var CPHI0; /* cos of start or old geodetic latitude in iterations */
	      var SPHI0; /* sin of start or old geodetic latitude in iterations */
	      var CPHI; /* cos of searched geodetic latitude */
	      var SPHI; /* sin of searched geodetic latitude */
	      var SDPHI; /* end-criterium: addition-theorem of sin(Latitude(iter)-Latitude(iter-1)) */
	      var iter; /* # of continous iteration, max. 30 is always enough (s.a.) */
	
	      var X = p.x;
	      var Y = p.y;
	      var Z = p.z ? p.z : 0.0; //Z value not always supplied
	      var Longitude;
	      var Latitude;
	      var Height;
	
	      P = Math.sqrt(X * X + Y * Y);
	      RR = Math.sqrt(X * X + Y * Y + Z * Z);
	
	      /*      special cases for latitude and longitude */
	      if (P / a < genau) {
	
	        /*  special case, if P=0. (X=0., Y=0.) */
	        Longitude = 0.0;
	
	        /*  if (X,Y,Z)=(0.,0.,0.) then Height becomes semi-minor axis
	         *  of ellipsoid (=center of mass), Latitude becomes PI/2 */
	        if (RR / a < genau) {
	          Latitude = HALF_PI;
	          Height = -b;
	          return {
	            x: p.x,
	            y: p.y,
	            z: p.z
	          };
	        }
	      } else {
	        /*  ellipsoidal (geodetic) longitude
	         *  interval: -PI < Longitude <= +PI */
	        Longitude = Math.atan2(Y, X);
	      }
	
	      /* --------------------------------------------------------------
	       * Following iterative algorithm was developped by
	       * "Institut for Erdmessung", University of Hannover, July 1988.
	       * Internet: www.ife.uni-hannover.de
	       * Iterative computation of CPHI,SPHI and Height.
	       * Iteration of CPHI and SPHI to 10**-12 radian resp.
	       * 2*10**-7 arcsec.
	       * --------------------------------------------------------------
	       */
	      CT = Z / RR;
	      ST = P / RR;
	      RX = 1.0 / Math.sqrt(1.0 - es * (2.0 - es) * ST * ST);
	      CPHI0 = ST * (1.0 - es) * RX;
	      SPHI0 = CT * RX;
	      iter = 0;
	
	      /* loop to find sin(Latitude) resp. Latitude
	       * until |sin(Latitude(iter)-Latitude(iter-1))| < genau */
	      do {
	        iter++;
	        RN = a / Math.sqrt(1.0 - es * SPHI0 * SPHI0);
	
	        /*  ellipsoidal (geodetic) height */
	        Height = P * CPHI0 + Z * SPHI0 - RN * (1.0 - es * SPHI0 * SPHI0);
	
	        RK = es * RN / (RN + Height);
	        RX = 1.0 / Math.sqrt(1.0 - RK * (2.0 - RK) * ST * ST);
	        CPHI = ST * (1.0 - RK) * RX;
	        SPHI = CT * RX;
	        SDPHI = SPHI * CPHI0 - CPHI * SPHI0;
	        CPHI0 = CPHI;
	        SPHI0 = SPHI;
	      }
	      while (SDPHI * SDPHI > genau2 && iter < maxiter);
	
	      /*      ellipsoidal (geodetic) latitude */
	      Latitude = Math.atan(SPHI / Math.abs(CPHI));
	      return {
	        x: Longitude,
	        y: Latitude,
	        z: Height
	      };
	    } // cs_geocentric_to_geodetic()
	
	    /****************************************************************/
	    // pj_geocentic_to_wgs84( p )
	    //  p = point to transform in geocentric coordinates (x,y,z)
	
	
	    /** point object, nothing fancy, just allows values to be
	        passed back and forth by reference rather than by value.
	        Other point classes may be used as long as they have
	        x and y properties, which will get modified in the transform method.
	    */
	    function geocentricToWgs84(p, datum_type, datum_params) {
	
	      if (datum_type === PJD_3PARAM) {
	        // if( x[io] === HUGE_VAL )
	        //    continue;
	        return {
	          x: p.x + datum_params[0],
	          y: p.y + datum_params[1],
	          z: p.z + datum_params[2],
	        };
	      } else if (datum_type === PJD_7PARAM) {
	        var Dx_BF = datum_params[0];
	        var Dy_BF = datum_params[1];
	        var Dz_BF = datum_params[2];
	        var Rx_BF = datum_params[3];
	        var Ry_BF = datum_params[4];
	        var Rz_BF = datum_params[5];
	        var M_BF = datum_params[6];
	        // if( x[io] === HUGE_VAL )
	        //    continue;
	        return {
	          x: M_BF * (p.x - Rz_BF * p.y + Ry_BF * p.z) + Dx_BF,
	          y: M_BF * (Rz_BF * p.x + p.y - Rx_BF * p.z) + Dy_BF,
	          z: M_BF * (-Ry_BF * p.x + Rx_BF * p.y + p.z) + Dz_BF
	        };
	      }
	    } // cs_geocentric_to_wgs84
	
	    /****************************************************************/
	    // pj_geocentic_from_wgs84()
	    //  coordinate system definition,
	    //  point to transform in geocentric coordinates (x,y,z)
	    function geocentricFromWgs84(p, datum_type, datum_params) {
	
	      if (datum_type === PJD_3PARAM) {
	        //if( x[io] === HUGE_VAL )
	        //    continue;
	        return {
	          x: p.x - datum_params[0],
	          y: p.y - datum_params[1],
	          z: p.z - datum_params[2],
	        };
	
	      } else if (datum_type === PJD_7PARAM) {
	        var Dx_BF = datum_params[0];
	        var Dy_BF = datum_params[1];
	        var Dz_BF = datum_params[2];
	        var Rx_BF = datum_params[3];
	        var Ry_BF = datum_params[4];
	        var Rz_BF = datum_params[5];
	        var M_BF = datum_params[6];
	        var x_tmp = (p.x - Dx_BF) / M_BF;
	        var y_tmp = (p.y - Dy_BF) / M_BF;
	        var z_tmp = (p.z - Dz_BF) / M_BF;
	        //if( x[io] === HUGE_VAL )
	        //    continue;
	
	        return {
	          x: x_tmp + Rz_BF * y_tmp - Ry_BF * z_tmp,
	          y: -Rz_BF * x_tmp + y_tmp + Rx_BF * z_tmp,
	          z: Ry_BF * x_tmp - Rx_BF * y_tmp + z_tmp
	        };
	      } //cs_geocentric_from_wgs84()
	    }
	
	    function checkParams(type) {
	      return (type === PJD_3PARAM || type === PJD_7PARAM);
	    }
	
	    var datum_transform = function(source, dest, point) {
	      // Short cut if the datums are identical.
	      if (compareDatums(source, dest)) {
	        return point; // in this case, zero is sucess,
	        // whereas cs_compare_datums returns 1 to indicate TRUE
	        // confusing, should fix this
	      }
	
	      // Explicitly skip datum transform by setting 'datum=none' as parameter for either source or dest
	      if (source.datum_type === PJD_NODATUM || dest.datum_type === PJD_NODATUM) {
	        return point;
	      }
	
	      // If this datum requires grid shifts, then apply it to geodetic coordinates.
	      var source_a = source.a;
	      var source_es = source.es;
	      if (source.datum_type === PJD_GRIDSHIFT) {
	        var gridShiftCode = applyGridShift(source, false, point);
	        if (gridShiftCode !== 0) {
	          return undefined;
	        }
	        source_a = SRS_WGS84_SEMIMAJOR;
	        source_es = SRS_WGS84_ESQUARED;
	      }
	
	      var dest_a = dest.a;
	      var dest_b = dest.b;
	      var dest_es = dest.es;
	      if (dest.datum_type === PJD_GRIDSHIFT) {
	        dest_a = SRS_WGS84_SEMIMAJOR;
	        dest_b = SRS_WGS84_SEMIMINOR;
	        dest_es = SRS_WGS84_ESQUARED;
	      }
	
	      // Do we need to go through geocentric coordinates?
	      if (source_es === dest_es && source_a === dest_a && !checkParams(source.datum_type) &&  !checkParams(dest.datum_type)) {
	        return point;
	      }
	
	      // Convert to geocentric coordinates.
	      point = geodeticToGeocentric(point, source_es, source_a);
	      // Convert between datums
	      if (checkParams(source.datum_type)) {
	        point = geocentricToWgs84(point, source.datum_type, source.datum_params);
	      }
	      if (checkParams(dest.datum_type)) {
	        point = geocentricFromWgs84(point, dest.datum_type, dest.datum_params);
	      }
	      point = geocentricToGeodetic(point, dest_es, dest_a, dest_b);
	
	      if (dest.datum_type === PJD_GRIDSHIFT) {
	        var destGridShiftResult = applyGridShift(dest, true, point);
	        if (destGridShiftResult !== 0) {
	          return undefined;
	        }
	      }
	
	      return point;
	    };
	
	    function applyGridShift(source, inverse, point) {
	      if (source.grids === null || source.grids.length === 0) {
	        console.log('Grid shift grids not found');
	        return -1;
	      }
	      var input = {x: -point.x, y: point.y};
	      var output = {x: Number.NaN, y: Number.NaN};
	      var attemptedGrids = [];
	      for (var i = 0; i < source.grids.length; i++) {
	        var grid = source.grids[i];
	        attemptedGrids.push(grid.name);
	        if (grid.isNull) {
	          output = input;
	          break;
	        }
	        if (grid.grid === null) {
	          if (grid.mandatory) {
	            console.log("Unable to find mandatory grid '" + grid.name + "'");
	            return -1;
	          }
	          continue;
	        }
	        var subgrid = grid.grid.subgrids[0];
	        // skip tables that don't match our point at all
	        var epsilon = (Math.abs(subgrid.del[1]) + Math.abs(subgrid.del[0])) / 10000.0;
	        var minX = subgrid.ll[0] - epsilon;
	        var minY = subgrid.ll[1] - epsilon;
	        var maxX = subgrid.ll[0] + (subgrid.lim[0] - 1) * subgrid.del[0] + epsilon;
	        var maxY = subgrid.ll[1] + (subgrid.lim[1] - 1) * subgrid.del[1] + epsilon;
	        if (minY > input.y || minX > input.x || maxY < input.y || maxX < input.x ) {
	          continue;
	        }
	        output = applySubgridShift(input, inverse, subgrid);
	        if (!isNaN(output.x)) {
	          break;
	        }
	      }
	      if (isNaN(output.x)) {
	        console.log("Failed to find a grid shift table for location '"+
	          -input.x * R2D + " " + input.y * R2D + " tried: '" + attemptedGrids + "'");
	        return -1;
	      }
	      point.x = -output.x;
	      point.y = output.y;
	      return 0;
	    }
	
	    function applySubgridShift(pin, inverse, ct) {
	      var val = {x: Number.NaN, y: Number.NaN};
	      if (isNaN(pin.x)) { return val; }
	      var tb = {x: pin.x, y: pin.y};
	      tb.x -= ct.ll[0];
	      tb.y -= ct.ll[1];
	      tb.x = adjust_lon(tb.x - Math.PI) + Math.PI;
	      var t = nadInterpolate(tb, ct);
	      if (inverse) {
	        if (isNaN(t.x)) {
	          return val;
	        }
	        t.x = tb.x - t.x;
	        t.y = tb.y - t.y;
	        var i = 9, tol = 1e-12;
	        var dif, del;
	        do {
	          del = nadInterpolate(t, ct);
	          if (isNaN(del.x)) {
	            console.log("Inverse grid shift iteration failed, presumably at grid edge.  Using first approximation.");
	            break;
	          }
	          dif = {x: tb.x - (del.x + t.x), y: tb.y - (del.y + t.y)};
	          t.x += dif.x;
	          t.y += dif.y;
	        } while (i-- && Math.abs(dif.x) > tol && Math.abs(dif.y) > tol);
	        if (i < 0) {
	          console.log("Inverse grid shift iterator failed to converge.");
	          return val;
	        }
	        val.x = adjust_lon(t.x + ct.ll[0]);
	        val.y = t.y + ct.ll[1];
	      } else {
	        if (!isNaN(t.x)) {
	          val.x = pin.x + t.x;
	          val.y = pin.y + t.y;
	        }
	      }
	      return val;
	    }
	
	    function nadInterpolate(pin, ct) {
	      var t = {x: pin.x / ct.del[0], y: pin.y / ct.del[1]};
	      var indx = {x: Math.floor(t.x), y: Math.floor(t.y)};
	      var frct = {x: t.x - 1.0 * indx.x, y: t.y - 1.0 * indx.y};
	      var val= {x: Number.NaN, y: Number.NaN};
	      var inx;
	      if (indx.x < 0 || indx.x >= ct.lim[0]) {
	        return val;
	      }
	      if (indx.y < 0 || indx.y >= ct.lim[1]) {
	        return val;
	      }
	      inx = (indx.y * ct.lim[0]) + indx.x;
	      var f00 = {x: ct.cvs[inx][0], y: ct.cvs[inx][1]};
	      inx++;
	      var f10= {x: ct.cvs[inx][0], y: ct.cvs[inx][1]};
	      inx += ct.lim[0];
	      var f11 = {x: ct.cvs[inx][0], y: ct.cvs[inx][1]};
	      inx--;
	      var f01 = {x: ct.cvs[inx][0], y: ct.cvs[inx][1]};
	      var m11 = frct.x * frct.y, m10 = frct.x * (1.0 - frct.y),
	        m00 = (1.0 - frct.x) * (1.0 - frct.y), m01 = (1.0 - frct.x) * frct.y;
	      val.x = (m00 * f00.x + m10 * f10.x + m01 * f01.x + m11 * f11.x);
	      val.y = (m00 * f00.y + m10 * f10.y + m01 * f01.y + m11 * f11.y);
	      return val;
	    }
	
	    var adjust_axis = function(crs, denorm, point) {
	      var xin = point.x,
	        yin = point.y,
	        zin = point.z || 0.0;
	      var v, t, i;
	      var out = {};
	      for (i = 0; i < 3; i++) {
	        if (denorm && i === 2 && point.z === undefined) {
	          continue;
	        }
	        if (i === 0) {
	          v = xin;
	          if ("ew".indexOf(crs.axis[i]) !== -1) {
	            t = 'x';
	          } else {
	            t = 'y';
	          }
	
	        }
	        else if (i === 1) {
	          v = yin;
	          if ("ns".indexOf(crs.axis[i]) !== -1) {
	            t = 'y';
	          } else {
	            t = 'x';
	          }
	        }
	        else {
	          v = zin;
	          t = 'z';
	        }
	        switch (crs.axis[i]) {
	        case 'e':
	          out[t] = v;
	          break;
	        case 'w':
	          out[t] = -v;
	          break;
	        case 'n':
	          out[t] = v;
	          break;
	        case 's':
	          out[t] = -v;
	          break;
	        case 'u':
	          if (point[t] !== undefined) {
	            out.z = v;
	          }
	          break;
	        case 'd':
	          if (point[t] !== undefined) {
	            out.z = -v;
	          }
	          break;
	        default:
	          //console.log("ERROR: unknow axis ("+crs.axis[i]+") - check definition of "+crs.projName);
	          return null;
	        }
	      }
	      return out;
	    };
	
	    var toPoint = function (array){
	      var out = {
	        x: array[0],
	        y: array[1]
	      };
	      if (array.length>2) {
	        out.z = array[2];
	      }
	      if (array.length>3) {
	        out.m = array[3];
	      }
	      return out;
	    };
	
	    var checkSanity = function (point) {
	      checkCoord(point.x);
	      checkCoord(point.y);
	    };
	    function checkCoord(num) {
	      if (typeof Number.isFinite === 'function') {
	        if (Number.isFinite(num)) {
	          return;
	        }
	        throw new TypeError('coordinates must be finite numbers');
	      }
	      if (typeof num !== 'number' || num !== num || !isFinite(num)) {
	        throw new TypeError('coordinates must be finite numbers');
	      }
	    }
	
	    function checkNotWGS(source, dest) {
	      return ((source.datum.datum_type === PJD_3PARAM || source.datum.datum_type === PJD_7PARAM) && dest.datumCode !== 'WGS84') || ((dest.datum.datum_type === PJD_3PARAM || dest.datum.datum_type === PJD_7PARAM) && source.datumCode !== 'WGS84');
	    }
	
	    function transform(source, dest, point) {
	      var wgs84;
	      if (Array.isArray(point)) {
	        point = toPoint(point);
	      }
	      checkSanity(point);
	      // Workaround for datum shifts towgs84, if either source or destination projection is not wgs84
	      if (source.datum && dest.datum && checkNotWGS(source, dest)) {
	        wgs84 = new Projection('WGS84');
	        point = transform(source, wgs84, point);
	        source = wgs84;
	      }
	      // DGR, 2010/11/12
	      if (source.axis !== 'enu') {
	        point = adjust_axis(source, false, point);
	      }
	      // Transform source points to long/lat, if they aren't already.
	      if (source.projName === 'longlat') {
	        point = {
	          x: point.x * D2R,
	          y: point.y * D2R,
	          z: point.z || 0
	        };
	      } else {
	        if (source.to_meter) {
	          point = {
	            x: point.x * source.to_meter,
	            y: point.y * source.to_meter,
	            z: point.z || 0
	          };
	        }
	        point = source.inverse(point); // Convert Cartesian to longlat
	        if (!point) {
	          return;
	        }
	      }
	      // Adjust for the prime meridian if necessary
	      if (source.from_greenwich) {
	        point.x += source.from_greenwich;
	      }
	
	      // Convert datums if needed, and if possible.
	      point = datum_transform(source.datum, dest.datum, point);
	      if (!point) {
	        return;
	      }
	
	      // Adjust for the prime meridian if necessary
	      if (dest.from_greenwich) {
	        point = {
	          x: point.x - dest.from_greenwich,
	          y: point.y,
	          z: point.z || 0
	        };
	      }
	
	      if (dest.projName === 'longlat') {
	        // convert radians to decimal degrees
	        point = {
	          x: point.x * R2D,
	          y: point.y * R2D,
	          z: point.z || 0
	        };
	      } else { // else project
	        point = dest.forward(point);
	        if (dest.to_meter) {
	          point = {
	            x: point.x / dest.to_meter,
	            y: point.y / dest.to_meter,
	            z: point.z || 0
	          };
	        }
	      }
	
	      // DGR, 2010/11/12
	      if (dest.axis !== 'enu') {
	        return adjust_axis(dest, true, point);
	      }
	
	      return point;
	    }
	
	    var wgs84 = Projection('WGS84');
	
	    function transformer(from, to, coords) {
	      var transformedArray, out, keys;
	      if (Array.isArray(coords)) {
	        transformedArray = transform(from, to, coords) || {x: NaN, y: NaN};
	        if (coords.length > 2) {
	          if ((typeof from.name !== 'undefined' && from.name === 'geocent') || (typeof to.name !== 'undefined' && to.name === 'geocent')) {
	            if (typeof transformedArray.z === 'number') {
	              return [transformedArray.x, transformedArray.y, transformedArray.z].concat(coords.splice(3));
	            } else {
	              return [transformedArray.x, transformedArray.y, coords[2]].concat(coords.splice(3));
	            }
	          } else {
	            return [transformedArray.x, transformedArray.y].concat(coords.splice(2));
	          }
	        } else {
	          return [transformedArray.x, transformedArray.y];
	        }
	      } else {
	        out = transform(from, to, coords);
	        keys = Object.keys(coords);
	        if (keys.length === 2) {
	          return out;
	        }
	        keys.forEach(function (key) {
	          if ((typeof from.name !== 'undefined' && from.name === 'geocent') || (typeof to.name !== 'undefined' && to.name === 'geocent')) {
	            if (key === 'x' || key === 'y' || key === 'z') {
	              return;
	            }
	          } else {
	            if (key === 'x' || key === 'y') {
	              return;
	            }
	          }
	          out[key] = coords[key];
	        });
	        return out;
	      }
	    }
	
	    function checkProj(item) {
	      if (item instanceof Projection) {
	        return item;
	      }
	      if (item.oProj) {
	        return item.oProj;
	      }
	      return Projection(item);
	    }
	
	    function proj4$1(fromProj, toProj, coord) {
	      fromProj = checkProj(fromProj);
	      var single = false;
	      var obj;
	      if (typeof toProj === 'undefined') {
	        toProj = fromProj;
	        fromProj = wgs84;
	        single = true;
	      } else if (typeof toProj.x !== 'undefined' || Array.isArray(toProj)) {
	        coord = toProj;
	        toProj = fromProj;
	        fromProj = wgs84;
	        single = true;
	      }
	      toProj = checkProj(toProj);
	      if (coord) {
	        return transformer(fromProj, toProj, coord);
	      } else {
	        obj = {
	          forward: function (coords) {
	            return transformer(fromProj, toProj, coords);
	          },
	          inverse: function (coords) {
	            return transformer(toProj, fromProj, coords);
	          }
	        };
	        if (single) {
	          obj.oProj = toProj;
	        }
	        return obj;
	      }
	    }
	
	    /**
	     * UTM zones are grouped, and assigned to one of a group of 6
	     * sets.
	     *
	     * {int} @private
	     */
	    var NUM_100K_SETS = 6;
	
	    /**
	     * The column letters (for easting) of the lower left value, per
	     * set.
	     *
	     * {string} @private
	     */
	    var SET_ORIGIN_COLUMN_LETTERS = 'AJSAJS';
	
	    /**
	     * The row letters (for northing) of the lower left value, per
	     * set.
	     *
	     * {string} @private
	     */
	    var SET_ORIGIN_ROW_LETTERS = 'AFAFAF';
	
	    var A = 65; // A
	    var I = 73; // I
	    var O = 79; // O
	    var V = 86; // V
	    var Z = 90; // Z
	    var mgrs = {
	      forward: forward$1,
	      inverse: inverse$1,
	      toPoint: toPoint$1
	    };
	    /**
	     * Conversion of lat/lon to MGRS.
	     *
	     * @param {object} ll Object literal with lat and lon properties on a
	     *     WGS84 ellipsoid.
	     * @param {int} accuracy Accuracy in digits (5 for 1 m, 4 for 10 m, 3 for
	     *      100 m, 2 for 1000 m or 1 for 10000 m). Optional, default is 5.
	     * @return {string} the MGRS string for the given location and accuracy.
	     */
	    function forward$1(ll, accuracy) {
	      accuracy = accuracy || 5; // default accuracy 1m
	      return encode(LLtoUTM({
	        lat: ll[1],
	        lon: ll[0]
	      }), accuracy);
	    }
	
	    /**
	     * Conversion of MGRS to lat/lon.
	     *
	     * @param {string} mgrs MGRS string.
	     * @return {array} An array with left (longitude), bottom (latitude), right
	     *     (longitude) and top (latitude) values in WGS84, representing the
	     *     bounding box for the provided MGRS reference.
	     */
	    function inverse$1(mgrs) {
	      var bbox = UTMtoLL(decode(mgrs.toUpperCase()));
	      if (bbox.lat && bbox.lon) {
	        return [bbox.lon, bbox.lat, bbox.lon, bbox.lat];
	      }
	      return [bbox.left, bbox.bottom, bbox.right, bbox.top];
	    }
	
	    function toPoint$1(mgrs) {
	      var bbox = UTMtoLL(decode(mgrs.toUpperCase()));
	      if (bbox.lat && bbox.lon) {
	        return [bbox.lon, bbox.lat];
	      }
	      return [(bbox.left + bbox.right) / 2, (bbox.top + bbox.bottom) / 2];
	    }
	    /**
	     * Conversion from degrees to radians.
	     *
	     * @private
	     * @param {number} deg the angle in degrees.
	     * @return {number} the angle in radians.
	     */
	    function degToRad(deg) {
	      return (deg * (Math.PI / 180.0));
	    }
	
	    /**
	     * Conversion from radians to degrees.
	     *
	     * @private
	     * @param {number} rad the angle in radians.
	     * @return {number} the angle in degrees.
	     */
	    function radToDeg(rad) {
	      return (180.0 * (rad / Math.PI));
	    }
	
	    /**
	     * Converts a set of Longitude and Latitude co-ordinates to UTM
	     * using the WGS84 ellipsoid.
	     *
	     * @private
	     * @param {object} ll Object literal with lat and lon properties
	     *     representing the WGS84 coordinate to be converted.
	     * @return {object} Object literal containing the UTM value with easting,
	     *     northing, zoneNumber and zoneLetter properties, and an optional
	     *     accuracy property in digits. Returns null if the conversion failed.
	     */
	    function LLtoUTM(ll) {
	      var Lat = ll.lat;
	      var Long = ll.lon;
	      var a = 6378137.0; //ellip.radius;
	      var eccSquared = 0.00669438; //ellip.eccsq;
	      var k0 = 0.9996;
	      var LongOrigin;
	      var eccPrimeSquared;
	      var N, T, C, A, M;
	      var LatRad = degToRad(Lat);
	      var LongRad = degToRad(Long);
	      var LongOriginRad;
	      var ZoneNumber;
	      // (int)
	      ZoneNumber = Math.floor((Long + 180) / 6) + 1;
	
	      //Make sure the longitude 180.00 is in Zone 60
	      if (Long === 180) {
	        ZoneNumber = 60;
	      }
	
	      // Special zone for Norway
	      if (Lat >= 56.0 && Lat < 64.0 && Long >= 3.0 && Long < 12.0) {
	        ZoneNumber = 32;
	      }
	
	      // Special zones for Svalbard
	      if (Lat >= 72.0 && Lat < 84.0) {
	        if (Long >= 0.0 && Long < 9.0) {
	          ZoneNumber = 31;
	        }
	        else if (Long >= 9.0 && Long < 21.0) {
	          ZoneNumber = 33;
	        }
	        else if (Long >= 21.0 && Long < 33.0) {
	          ZoneNumber = 35;
	        }
	        else if (Long >= 33.0 && Long < 42.0) {
	          ZoneNumber = 37;
	        }
	      }
	
	      LongOrigin = (ZoneNumber - 1) * 6 - 180 + 3; //+3 puts origin
	      // in middle of
	      // zone
	      LongOriginRad = degToRad(LongOrigin);
	
	      eccPrimeSquared = (eccSquared) / (1 - eccSquared);
	
	      N = a / Math.sqrt(1 - eccSquared * Math.sin(LatRad) * Math.sin(LatRad));
	      T = Math.tan(LatRad) * Math.tan(LatRad);
	      C = eccPrimeSquared * Math.cos(LatRad) * Math.cos(LatRad);
	      A = Math.cos(LatRad) * (LongRad - LongOriginRad);
	
	      M = a * ((1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256) * LatRad - (3 * eccSquared / 8 + 3 * eccSquared * eccSquared / 32 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(2 * LatRad) + (15 * eccSquared * eccSquared / 256 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(4 * LatRad) - (35 * eccSquared * eccSquared * eccSquared / 3072) * Math.sin(6 * LatRad));
	
	      var UTMEasting = (k0 * N * (A + (1 - T + C) * A * A * A / 6.0 + (5 - 18 * T + T * T + 72 * C - 58 * eccPrimeSquared) * A * A * A * A * A / 120.0) + 500000.0);
	
	      var UTMNorthing = (k0 * (M + N * Math.tan(LatRad) * (A * A / 2 + (5 - T + 9 * C + 4 * C * C) * A * A * A * A / 24.0 + (61 - 58 * T + T * T + 600 * C - 330 * eccPrimeSquared) * A * A * A * A * A * A / 720.0)));
	      if (Lat < 0.0) {
	        UTMNorthing += 10000000.0; //10000000 meter offset for
	        // southern hemisphere
	      }
	
	      return {
	        northing: Math.round(UTMNorthing),
	        easting: Math.round(UTMEasting),
	        zoneNumber: ZoneNumber,
	        zoneLetter: getLetterDesignator(Lat)
	      };
	    }
	
	    /**
	     * Converts UTM coords to lat/long, using the WGS84 ellipsoid. This is a convenience
	     * class where the Zone can be specified as a single string eg."60N" which
	     * is then broken down into the ZoneNumber and ZoneLetter.
	     *
	     * @private
	     * @param {object} utm An object literal with northing, easting, zoneNumber
	     *     and zoneLetter properties. If an optional accuracy property is
	     *     provided (in meters), a bounding box will be returned instead of
	     *     latitude and longitude.
	     * @return {object} An object literal containing either lat and lon values
	     *     (if no accuracy was provided), or top, right, bottom and left values
	     *     for the bounding box calculated according to the provided accuracy.
	     *     Returns null if the conversion failed.
	     */
	    function UTMtoLL(utm) {
	
	      var UTMNorthing = utm.northing;
	      var UTMEasting = utm.easting;
	      var zoneLetter = utm.zoneLetter;
	      var zoneNumber = utm.zoneNumber;
	      // check the ZoneNummber is valid
	      if (zoneNumber < 0 || zoneNumber > 60) {
	        return null;
	      }
	
	      var k0 = 0.9996;
	      var a = 6378137.0; //ellip.radius;
	      var eccSquared = 0.00669438; //ellip.eccsq;
	      var eccPrimeSquared;
	      var e1 = (1 - Math.sqrt(1 - eccSquared)) / (1 + Math.sqrt(1 - eccSquared));
	      var N1, T1, C1, R1, D, M;
	      var LongOrigin;
	      var mu, phi1Rad;
	
	      // remove 500,000 meter offset for longitude
	      var x = UTMEasting - 500000.0;
	      var y = UTMNorthing;
	
	      // We must know somehow if we are in the Northern or Southern
	      // hemisphere, this is the only time we use the letter So even
	      // if the Zone letter isn't exactly correct it should indicate
	      // the hemisphere correctly
	      if (zoneLetter < 'N') {
	        y -= 10000000.0; // remove 10,000,000 meter offset used
	        // for southern hemisphere
	      }
	
	      // There are 60 zones with zone 1 being at West -180 to -174
	      LongOrigin = (zoneNumber - 1) * 6 - 180 + 3; // +3 puts origin
	      // in middle of
	      // zone
	
	      eccPrimeSquared = (eccSquared) / (1 - eccSquared);
	
	      M = y / k0;
	      mu = M / (a * (1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256));
	
	      phi1Rad = mu + (3 * e1 / 2 - 27 * e1 * e1 * e1 / 32) * Math.sin(2 * mu) + (21 * e1 * e1 / 16 - 55 * e1 * e1 * e1 * e1 / 32) * Math.sin(4 * mu) + (151 * e1 * e1 * e1 / 96) * Math.sin(6 * mu);
	      // double phi1 = ProjMath.radToDeg(phi1Rad);
	
	      N1 = a / Math.sqrt(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad));
	      T1 = Math.tan(phi1Rad) * Math.tan(phi1Rad);
	      C1 = eccPrimeSquared * Math.cos(phi1Rad) * Math.cos(phi1Rad);
	      R1 = a * (1 - eccSquared) / Math.pow(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad), 1.5);
	      D = x / (N1 * k0);
	
	      var lat = phi1Rad - (N1 * Math.tan(phi1Rad) / R1) * (D * D / 2 - (5 + 3 * T1 + 10 * C1 - 4 * C1 * C1 - 9 * eccPrimeSquared) * D * D * D * D / 24 + (61 + 90 * T1 + 298 * C1 + 45 * T1 * T1 - 252 * eccPrimeSquared - 3 * C1 * C1) * D * D * D * D * D * D / 720);
	      lat = radToDeg(lat);
	
	      var lon = (D - (1 + 2 * T1 + C1) * D * D * D / 6 + (5 - 2 * C1 + 28 * T1 - 3 * C1 * C1 + 8 * eccPrimeSquared + 24 * T1 * T1) * D * D * D * D * D / 120) / Math.cos(phi1Rad);
	      lon = LongOrigin + radToDeg(lon);
	
	      var result;
	      if (utm.accuracy) {
	        var topRight = UTMtoLL({
	          northing: utm.northing + utm.accuracy,
	          easting: utm.easting + utm.accuracy,
	          zoneLetter: utm.zoneLetter,
	          zoneNumber: utm.zoneNumber
	        });
	        result = {
	          top: topRight.lat,
	          right: topRight.lon,
	          bottom: lat,
	          left: lon
	        };
	      }
	      else {
	        result = {
	          lat: lat,
	          lon: lon
	        };
	      }
	      return result;
	    }
	
	    /**
	     * Calculates the MGRS letter designator for the given latitude.
	     *
	     * @private
	     * @param {number} lat The latitude in WGS84 to get the letter designator
	     *     for.
	     * @return {char} The letter designator.
	     */
	    function getLetterDesignator(lat) {
	      //This is here as an error flag to show that the Latitude is
	      //outside MGRS limits
	      var LetterDesignator = 'Z';
	
	      if ((84 >= lat) && (lat >= 72)) {
	        LetterDesignator = 'X';
	      }
	      else if ((72 > lat) && (lat >= 64)) {
	        LetterDesignator = 'W';
	      }
	      else if ((64 > lat) && (lat >= 56)) {
	        LetterDesignator = 'V';
	      }
	      else if ((56 > lat) && (lat >= 48)) {
	        LetterDesignator = 'U';
	      }
	      else if ((48 > lat) && (lat >= 40)) {
	        LetterDesignator = 'T';
	      }
	      else if ((40 > lat) && (lat >= 32)) {
	        LetterDesignator = 'S';
	      }
	      else if ((32 > lat) && (lat >= 24)) {
	        LetterDesignator = 'R';
	      }
	      else if ((24 > lat) && (lat >= 16)) {
	        LetterDesignator = 'Q';
	      }
	      else if ((16 > lat) && (lat >= 8)) {
	        LetterDesignator = 'P';
	      }
	      else if ((8 > lat) && (lat >= 0)) {
	        LetterDesignator = 'N';
	      }
	      else if ((0 > lat) && (lat >= -8)) {
	        LetterDesignator = 'M';
	      }
	      else if ((-8 > lat) && (lat >= -16)) {
	        LetterDesignator = 'L';
	      }
	      else if ((-16 > lat) && (lat >= -24)) {
	        LetterDesignator = 'K';
	      }
	      else if ((-24 > lat) && (lat >= -32)) {
	        LetterDesignator = 'J';
	      }
	      else if ((-32 > lat) && (lat >= -40)) {
	        LetterDesignator = 'H';
	      }
	      else if ((-40 > lat) && (lat >= -48)) {
	        LetterDesignator = 'G';
	      }
	      else if ((-48 > lat) && (lat >= -56)) {
	        LetterDesignator = 'F';
	      }
	      else if ((-56 > lat) && (lat >= -64)) {
	        LetterDesignator = 'E';
	      }
	      else if ((-64 > lat) && (lat >= -72)) {
	        LetterDesignator = 'D';
	      }
	      else if ((-72 > lat) && (lat >= -80)) {
	        LetterDesignator = 'C';
	      }
	      return LetterDesignator;
	    }
	
	    /**
	     * Encodes a UTM location as MGRS string.
	     *
	     * @private
	     * @param {object} utm An object literal with easting, northing,
	     *     zoneLetter, zoneNumber
	     * @param {number} accuracy Accuracy in digits (1-5).
	     * @return {string} MGRS string for the given UTM location.
	     */
	    function encode(utm, accuracy) {
	      // prepend with leading zeroes
	      var seasting = "00000" + utm.easting,
	        snorthing = "00000" + utm.northing;
	
	      return utm.zoneNumber + utm.zoneLetter + get100kID(utm.easting, utm.northing, utm.zoneNumber) + seasting.substr(seasting.length - 5, accuracy) + snorthing.substr(snorthing.length - 5, accuracy);
	    }
	
	    /**
	     * Get the two letter 100k designator for a given UTM easting,
	     * northing and zone number value.
	     *
	     * @private
	     * @param {number} easting
	     * @param {number} northing
	     * @param {number} zoneNumber
	     * @return the two letter 100k designator for the given UTM location.
	     */
	    function get100kID(easting, northing, zoneNumber) {
	      var setParm = get100kSetForZone(zoneNumber);
	      var setColumn = Math.floor(easting / 100000);
	      var setRow = Math.floor(northing / 100000) % 20;
	      return getLetter100kID(setColumn, setRow, setParm);
	    }
	
	    /**
	     * Given a UTM zone number, figure out the MGRS 100K set it is in.
	     *
	     * @private
	     * @param {number} i An UTM zone number.
	     * @return {number} the 100k set the UTM zone is in.
	     */
	    function get100kSetForZone(i) {
	      var setParm = i % NUM_100K_SETS;
	      if (setParm === 0) {
	        setParm = NUM_100K_SETS;
	      }
	
	      return setParm;
	    }
	
	    /**
	     * Get the two-letter MGRS 100k designator given information
	     * translated from the UTM northing, easting and zone number.
	     *
	     * @private
	     * @param {number} column the column index as it relates to the MGRS
	     *        100k set spreadsheet, created from the UTM easting.
	     *        Values are 1-8.
	     * @param {number} row the row index as it relates to the MGRS 100k set
	     *        spreadsheet, created from the UTM northing value. Values
	     *        are from 0-19.
	     * @param {number} parm the set block, as it relates to the MGRS 100k set
	     *        spreadsheet, created from the UTM zone. Values are from
	     *        1-60.
	     * @return two letter MGRS 100k code.
	     */
	    function getLetter100kID(column, row, parm) {
	      // colOrigin and rowOrigin are the letters at the origin of the set
	      var index = parm - 1;
	      var colOrigin = SET_ORIGIN_COLUMN_LETTERS.charCodeAt(index);
	      var rowOrigin = SET_ORIGIN_ROW_LETTERS.charCodeAt(index);
	
	      // colInt and rowInt are the letters to build to return
	      var colInt = colOrigin + column - 1;
	      var rowInt = rowOrigin + row;
	      var rollover = false;
	
	      if (colInt > Z) {
	        colInt = colInt - Z + A - 1;
	        rollover = true;
	      }
	
	      if (colInt === I || (colOrigin < I && colInt > I) || ((colInt > I || colOrigin < I) && rollover)) {
	        colInt++;
	      }
	
	      if (colInt === O || (colOrigin < O && colInt > O) || ((colInt > O || colOrigin < O) && rollover)) {
	        colInt++;
	
	        if (colInt === I) {
	          colInt++;
	        }
	      }
	
	      if (colInt > Z) {
	        colInt = colInt - Z + A - 1;
	      }
	
	      if (rowInt > V) {
	        rowInt = rowInt - V + A - 1;
	        rollover = true;
	      }
	      else {
	        rollover = false;
	      }
	
	      if (((rowInt === I) || ((rowOrigin < I) && (rowInt > I))) || (((rowInt > I) || (rowOrigin < I)) && rollover)) {
	        rowInt++;
	      }
	
	      if (((rowInt === O) || ((rowOrigin < O) && (rowInt > O))) || (((rowInt > O) || (rowOrigin < O)) && rollover)) {
	        rowInt++;
	
	        if (rowInt === I) {
	          rowInt++;
	        }
	      }
	
	      if (rowInt > V) {
	        rowInt = rowInt - V + A - 1;
	      }
	
	      var twoLetter = String.fromCharCode(colInt) + String.fromCharCode(rowInt);
	      return twoLetter;
	    }
	
	    /**
	     * Decode the UTM parameters from a MGRS string.
	     *
	     * @private
	     * @param {string} mgrsString an UPPERCASE coordinate string is expected.
	     * @return {object} An object literal with easting, northing, zoneLetter,
	     *     zoneNumber and accuracy (in meters) properties.
	     */
	    function decode(mgrsString) {
	
	      if (mgrsString && mgrsString.length === 0) {
	        throw ("MGRSPoint coverting from nothing");
	      }
	
	      var length = mgrsString.length;
	
	      var hunK = null;
	      var sb = "";
	      var testChar;
	      var i = 0;
	
	      // get Zone number
	      while (!(/[A-Z]/).test(testChar = mgrsString.charAt(i))) {
	        if (i >= 2) {
	          throw ("MGRSPoint bad conversion from: " + mgrsString);
	        }
	        sb += testChar;
	        i++;
	      }
	
	      var zoneNumber = parseInt(sb, 10);
	
	      if (i === 0 || i + 3 > length) {
	        // A good MGRS string has to be 4-5 digits long,
	        // ##AAA/#AAA at least.
	        throw ("MGRSPoint bad conversion from: " + mgrsString);
	      }
	
	      var zoneLetter = mgrsString.charAt(i++);
	
	      // Should we check the zone letter here? Why not.
	      if (zoneLetter <= 'A' || zoneLetter === 'B' || zoneLetter === 'Y' || zoneLetter >= 'Z' || zoneLetter === 'I' || zoneLetter === 'O') {
	        throw ("MGRSPoint zone letter " + zoneLetter + " not handled: " + mgrsString);
	      }
	
	      hunK = mgrsString.substring(i, i += 2);
	
	      var set = get100kSetForZone(zoneNumber);
	
	      var east100k = getEastingFromChar(hunK.charAt(0), set);
	      var north100k = getNorthingFromChar(hunK.charAt(1), set);
	
	      // We have a bug where the northing may be 2000000 too low.
	      // How
	      // do we know when to roll over?
	
	      while (north100k < getMinNorthing(zoneLetter)) {
	        north100k += 2000000;
	      }
	
	      // calculate the char index for easting/northing separator
	      var remainder = length - i;
	
	      if (remainder % 2 !== 0) {
	        throw ("MGRSPoint has to have an even number \nof digits after the zone letter and two 100km letters - front \nhalf for easting meters, second half for \nnorthing meters" + mgrsString);
	      }
	
	      var sep = remainder / 2;
	
	      var sepEasting = 0.0;
	      var sepNorthing = 0.0;
	      var accuracyBonus, sepEastingString, sepNorthingString, easting, northing;
	      if (sep > 0) {
	        accuracyBonus = 100000.0 / Math.pow(10, sep);
	        sepEastingString = mgrsString.substring(i, i + sep);
	        sepEasting = parseFloat(sepEastingString) * accuracyBonus;
	        sepNorthingString = mgrsString.substring(i + sep);
	        sepNorthing = parseFloat(sepNorthingString) * accuracyBonus;
	      }
	
	      easting = sepEasting + east100k;
	      northing = sepNorthing + north100k;
	
	      return {
	        easting: easting,
	        northing: northing,
	        zoneLetter: zoneLetter,
	        zoneNumber: zoneNumber,
	        accuracy: accuracyBonus
	      };
	    }
	
	    /**
	     * Given the first letter from a two-letter MGRS 100k zone, and given the
	     * MGRS table set for the zone number, figure out the easting value that
	     * should be added to the other, secondary easting value.
	     *
	     * @private
	     * @param {char} e The first letter from a two-letter MGRS 100´k zone.
	     * @param {number} set The MGRS table set for the zone number.
	     * @return {number} The easting value for the given letter and set.
	     */
	    function getEastingFromChar(e, set) {
	      // colOrigin is the letter at the origin of the set for the
	      // column
	      var curCol = SET_ORIGIN_COLUMN_LETTERS.charCodeAt(set - 1);
	      var eastingValue = 100000.0;
	      var rewindMarker = false;
	
	      while (curCol !== e.charCodeAt(0)) {
	        curCol++;
	        if (curCol === I) {
	          curCol++;
	        }
	        if (curCol === O) {
	          curCol++;
	        }
	        if (curCol > Z) {
	          if (rewindMarker) {
	            throw ("Bad character: " + e);
	          }
	          curCol = A;
	          rewindMarker = true;
	        }
	        eastingValue += 100000.0;
	      }
	
	      return eastingValue;
	    }
	
	    /**
	     * Given the second letter from a two-letter MGRS 100k zone, and given the
	     * MGRS table set for the zone number, figure out the northing value that
	     * should be added to the other, secondary northing value. You have to
	     * remember that Northings are determined from the equator, and the vertical
	     * cycle of letters mean a 2000000 additional northing meters. This happens
	     * approx. every 18 degrees of latitude. This method does *NOT* count any
	     * additional northings. You have to figure out how many 2000000 meters need
	     * to be added for the zone letter of the MGRS coordinate.
	     *
	     * @private
	     * @param {char} n Second letter of the MGRS 100k zone
	     * @param {number} set The MGRS table set number, which is dependent on the
	     *     UTM zone number.
	     * @return {number} The northing value for the given letter and set.
	     */
	    function getNorthingFromChar(n, set) {
	
	      if (n > 'V') {
	        throw ("MGRSPoint given invalid Northing " + n);
	      }
	
	      // rowOrigin is the letter at the origin of the set for the
	      // column
	      var curRow = SET_ORIGIN_ROW_LETTERS.charCodeAt(set - 1);
	      var northingValue = 0.0;
	      var rewindMarker = false;
	
	      while (curRow !== n.charCodeAt(0)) {
	        curRow++;
	        if (curRow === I) {
	          curRow++;
	        }
	        if (curRow === O) {
	          curRow++;
	        }
	        // fixing a bug making whole application hang in this loop
	        // when 'n' is a wrong character
	        if (curRow > V) {
	          if (rewindMarker) { // making sure that this loop ends
	            throw ("Bad character: " + n);
	          }
	          curRow = A;
	          rewindMarker = true;
	        }
	        northingValue += 100000.0;
	      }
	
	      return northingValue;
	    }
	
	    /**
	     * The function getMinNorthing returns the minimum northing value of a MGRS
	     * zone.
	     *
	     * Ported from Geotrans' c Lattitude_Band_Value structure table.
	     *
	     * @private
	     * @param {char} zoneLetter The MGRS zone to get the min northing for.
	     * @return {number}
	     */
	    function getMinNorthing(zoneLetter) {
	      var northing;
	      switch (zoneLetter) {
	      case 'C':
	        northing = 1100000.0;
	        break;
	      case 'D':
	        northing = 2000000.0;
	        break;
	      case 'E':
	        northing = 2800000.0;
	        break;
	      case 'F':
	        northing = 3700000.0;
	        break;
	      case 'G':
	        northing = 4600000.0;
	        break;
	      case 'H':
	        northing = 5500000.0;
	        break;
	      case 'J':
	        northing = 6400000.0;
	        break;
	      case 'K':
	        northing = 7300000.0;
	        break;
	      case 'L':
	        northing = 8200000.0;
	        break;
	      case 'M':
	        northing = 9100000.0;
	        break;
	      case 'N':
	        northing = 0.0;
	        break;
	      case 'P':
	        northing = 800000.0;
	        break;
	      case 'Q':
	        northing = 1700000.0;
	        break;
	      case 'R':
	        northing = 2600000.0;
	        break;
	      case 'S':
	        northing = 3500000.0;
	        break;
	      case 'T':
	        northing = 4400000.0;
	        break;
	      case 'U':
	        northing = 5300000.0;
	        break;
	      case 'V':
	        northing = 6200000.0;
	        break;
	      case 'W':
	        northing = 7000000.0;
	        break;
	      case 'X':
	        northing = 7900000.0;
	        break;
	      default:
	        northing = -1.0;
	      }
	      if (northing >= 0.0) {
	        return northing;
	      }
	      else {
	        throw ("Invalid zone letter: " + zoneLetter);
	      }
	
	    }
	
	    function Point(x, y, z) {
	      if (!(this instanceof Point)) {
	        return new Point(x, y, z);
	      }
	      if (Array.isArray(x)) {
	        this.x = x[0];
	        this.y = x[1];
	        this.z = x[2] || 0.0;
	      } else if(typeof x === 'object') {
	        this.x = x.x;
	        this.y = x.y;
	        this.z = x.z || 0.0;
	      } else if (typeof x === 'string' && typeof y === 'undefined') {
	        var coords = x.split(',');
	        this.x = parseFloat(coords[0], 10);
	        this.y = parseFloat(coords[1], 10);
	        this.z = parseFloat(coords[2], 10) || 0.0;
	      } else {
	        this.x = x;
	        this.y = y;
	        this.z = z || 0.0;
	      }
	      console.warn('proj4.Point will be removed in version 3, use proj4.toPoint');
	    }
	
	    Point.fromMGRS = function(mgrsStr) {
	      return new Point(toPoint$1(mgrsStr));
	    };
	    Point.prototype.toMGRS = function(accuracy) {
	      return forward$1([this.x, this.y], accuracy);
	    };
	
	    var C00 = 1;
	    var C02 = 0.25;
	    var C04 = 0.046875;
	    var C06 = 0.01953125;
	    var C08 = 0.01068115234375;
	    var C22 = 0.75;
	    var C44 = 0.46875;
	    var C46 = 0.01302083333333333333;
	    var C48 = 0.00712076822916666666;
	    var C66 = 0.36458333333333333333;
	    var C68 = 0.00569661458333333333;
	    var C88 = 0.3076171875;
	
	    var pj_enfn = function(es) {
	      var en = [];
	      en[0] = C00 - es * (C02 + es * (C04 + es * (C06 + es * C08)));
	      en[1] = es * (C22 - es * (C04 + es * (C06 + es * C08)));
	      var t = es * es;
	      en[2] = t * (C44 - es * (C46 + es * C48));
	      t *= es;
	      en[3] = t * (C66 - es * C68);
	      en[4] = t * es * C88;
	      return en;
	    };
	
	    var pj_mlfn = function(phi, sphi, cphi, en) {
	      cphi *= sphi;
	      sphi *= sphi;
	      return (en[0] * phi - cphi * (en[1] + sphi * (en[2] + sphi * (en[3] + sphi * en[4]))));
	    };
	
	    var MAX_ITER = 20;
	
	    var pj_inv_mlfn = function(arg, es, en) {
	      var k = 1 / (1 - es);
	      var phi = arg;
	      for (var i = MAX_ITER; i; --i) { /* rarely goes over 2 iterations */
	        var s = Math.sin(phi);
	        var t = 1 - es * s * s;
	        //t = this.pj_mlfn(phi, s, Math.cos(phi), en) - arg;
	        //phi -= t * (t * Math.sqrt(t)) * k;
	        t = (pj_mlfn(phi, s, Math.cos(phi), en) - arg) * (t * Math.sqrt(t)) * k;
	        phi -= t;
	        if (Math.abs(t) < EPSLN) {
	          return phi;
	        }
	      }
	      //..reportError("cass:pj_inv_mlfn: Convergence error");
	      return phi;
	    };
	
	    // Heavily based on this tmerc projection implementation
	    // https://github.com/mbloch/mapshaper-proj/blob/master/src/projections/tmerc.js
	
	    function init$2() {
	      this.x0 = this.x0 !== undefined ? this.x0 : 0;
	      this.y0 = this.y0 !== undefined ? this.y0 : 0;
	      this.long0 = this.long0 !== undefined ? this.long0 : 0;
	      this.lat0 = this.lat0 !== undefined ? this.lat0 : 0;
	
	      if (this.es) {
	        this.en = pj_enfn(this.es);
	        this.ml0 = pj_mlfn(this.lat0, Math.sin(this.lat0), Math.cos(this.lat0), this.en);
	      }
	    }
	
	    /**
	        Transverse Mercator Forward  - long/lat to x/y
	        long/lat in radians
	      */
	    function forward$2(p) {
	      var lon = p.x;
	      var lat = p.y;
	
	      var delta_lon = adjust_lon(lon - this.long0);
	      var con;
	      var x, y;
	      var sin_phi = Math.sin(lat);
	      var cos_phi = Math.cos(lat);
	
	      if (!this.es) {
	        var b = cos_phi * Math.sin(delta_lon);
	
	        if ((Math.abs(Math.abs(b) - 1)) < EPSLN) {
	          return (93);
	        }
	        else {
	          x = 0.5 * this.a * this.k0 * Math.log((1 + b) / (1 - b)) + this.x0;
	          y = cos_phi * Math.cos(delta_lon) / Math.sqrt(1 - Math.pow(b, 2));
	          b = Math.abs(y);
	
	          if (b >= 1) {
	            if ((b - 1) > EPSLN) {
	              return (93);
	            }
	            else {
	              y = 0;
	            }
	          }
	          else {
	            y = Math.acos(y);
	          }
	
	          if (lat < 0) {
	            y = -y;
	          }
	
	          y = this.a * this.k0 * (y - this.lat0) + this.y0;
	        }
	      }
	      else {
	        var al = cos_phi * delta_lon;
	        var als = Math.pow(al, 2);
	        var c = this.ep2 * Math.pow(cos_phi, 2);
	        var cs = Math.pow(c, 2);
	        var tq = Math.abs(cos_phi) > EPSLN ? Math.tan(lat) : 0;
	        var t = Math.pow(tq, 2);
	        var ts = Math.pow(t, 2);
	        con = 1 - this.es * Math.pow(sin_phi, 2);
	        al = al / Math.sqrt(con);
	        var ml = pj_mlfn(lat, sin_phi, cos_phi, this.en);
	
	        x = this.a * (this.k0 * al * (1 +
	          als / 6 * (1 - t + c +
	          als / 20 * (5 - 18 * t + ts + 14 * c - 58 * t * c +
	          als / 42 * (61 + 179 * ts - ts * t - 479 * t))))) +
	          this.x0;
	
	        y = this.a * (this.k0 * (ml - this.ml0 +
	          sin_phi * delta_lon * al / 2 * (1 +
	          als / 12 * (5 - t + 9 * c + 4 * cs +
	          als / 30 * (61 + ts - 58 * t + 270 * c - 330 * t * c +
	          als / 56 * (1385 + 543 * ts - ts * t - 3111 * t)))))) +
	          this.y0;
	      }
	
	      p.x = x;
	      p.y = y;
	
	      return p;
	    }
	
	    /**
	        Transverse Mercator Inverse  -  x/y to long/lat
	      */
	    function inverse$2(p) {
	      var con, phi;
	      var lat, lon;
	      var x = (p.x - this.x0) * (1 / this.a);
	      var y = (p.y - this.y0) * (1 / this.a);
	
	      if (!this.es) {
	        var f = Math.exp(x / this.k0);
	        var g = 0.5 * (f - 1 / f);
	        var temp = this.lat0 + y / this.k0;
	        var h = Math.cos(temp);
	        con = Math.sqrt((1 - Math.pow(h, 2)) / (1 + Math.pow(g, 2)));
	        lat = Math.asin(con);
	
	        if (y < 0) {
	          lat = -lat;
	        }
	
	        if ((g === 0) && (h === 0)) {
	          lon = 0;
	        }
	        else {
	          lon = adjust_lon(Math.atan2(g, h) + this.long0);
	        }
	      }
	      else { // ellipsoidal form
	        con = this.ml0 + y / this.k0;
	        phi = pj_inv_mlfn(con, this.es, this.en);
	
	        if (Math.abs(phi) < HALF_PI) {
	          var sin_phi = Math.sin(phi);
	          var cos_phi = Math.cos(phi);
	          var tan_phi = Math.abs(cos_phi) > EPSLN ? Math.tan(phi) : 0;
	          var c = this.ep2 * Math.pow(cos_phi, 2);
	          var cs = Math.pow(c, 2);
	          var t = Math.pow(tan_phi, 2);
	          var ts = Math.pow(t, 2);
	          con = 1 - this.es * Math.pow(sin_phi, 2);
	          var d = x * Math.sqrt(con) / this.k0;
	          var ds = Math.pow(d, 2);
	          con = con * tan_phi;
	
	          lat = phi - (con * ds / (1 - this.es)) * 0.5 * (1 -
	            ds / 12 * (5 + 3 * t - 9 * c * t + c - 4 * cs -
	            ds / 30 * (61 + 90 * t - 252 * c * t + 45 * ts + 46 * c -
	            ds / 56 * (1385 + 3633 * t + 4095 * ts + 1574 * ts * t))));
	
	          lon = adjust_lon(this.long0 + (d * (1 -
	            ds / 6 * (1 + 2 * t + c -
	            ds / 20 * (5 + 28 * t + 24 * ts + 8 * c * t + 6 * c -
	            ds / 42 * (61 + 662 * t + 1320 * ts + 720 * ts * t)))) / cos_phi));
	        }
	        else {
	          lat = HALF_PI * sign(y);
	          lon = 0;
	        }
	      }
	
	      p.x = lon;
	      p.y = lat;
	
	      return p;
	    }
	
	    var names$3 = ["Fast_Transverse_Mercator", "Fast Transverse Mercator"];
	    var tmerc = {
	      init: init$2,
	      forward: forward$2,
	      inverse: inverse$2,
	      names: names$3
	    };
	
	    var sinh = function(x) {
	      var r = Math.exp(x);
	      r = (r - 1 / r) / 2;
	      return r;
	    };
	
	    var hypot = function(x, y) {
	      x = Math.abs(x);
	      y = Math.abs(y);
	      var a = Math.max(x, y);
	      var b = Math.min(x, y) / (a ? a : 1);
	
	      return a * Math.sqrt(1 + Math.pow(b, 2));
	    };
	
	    var log1py = function(x) {
	      var y = 1 + x;
	      var z = y - 1;
	
	      return z === 0 ? x : x * Math.log(y) / z;
	    };
	
	    var asinhy = function(x) {
	      var y = Math.abs(x);
	      y = log1py(y * (1 + y / (hypot(1, y) + 1)));
	
	      return x < 0 ? -y : y;
	    };
	
	    var gatg = function(pp, B) {
	      var cos_2B = 2 * Math.cos(2 * B);
	      var i = pp.length - 1;
	      var h1 = pp[i];
	      var h2 = 0;
	      var h;
	
	      while (--i >= 0) {
	        h = -h2 + cos_2B * h1 + pp[i];
	        h2 = h1;
	        h1 = h;
	      }
	
	      return (B + h * Math.sin(2 * B));
	    };
	
	    var clens = function(pp, arg_r) {
	      var r = 2 * Math.cos(arg_r);
	      var i = pp.length - 1;
	      var hr1 = pp[i];
	      var hr2 = 0;
	      var hr;
	
	      while (--i >= 0) {
	        hr = -hr2 + r * hr1 + pp[i];
	        hr2 = hr1;
	        hr1 = hr;
	      }
	
	      return Math.sin(arg_r) * hr;
	    };
	
	    var cosh = function(x) {
	      var r = Math.exp(x);
	      r = (r + 1 / r) / 2;
	      return r;
	    };
	
	    var clens_cmplx = function(pp, arg_r, arg_i) {
	      var sin_arg_r = Math.sin(arg_r);
	      var cos_arg_r = Math.cos(arg_r);
	      var sinh_arg_i = sinh(arg_i);
	      var cosh_arg_i = cosh(arg_i);
	      var r = 2 * cos_arg_r * cosh_arg_i;
	      var i = -2 * sin_arg_r * sinh_arg_i;
	      var j = pp.length - 1;
	      var hr = pp[j];
	      var hi1 = 0;
	      var hr1 = 0;
	      var hi = 0;
	      var hr2;
	      var hi2;
	
	      while (--j >= 0) {
	        hr2 = hr1;
	        hi2 = hi1;
	        hr1 = hr;
	        hi1 = hi;
	        hr = -hr2 + r * hr1 - i * hi1 + pp[j];
	        hi = -hi2 + i * hr1 + r * hi1;
	      }
	
	      r = sin_arg_r * cosh_arg_i;
	      i = cos_arg_r * sinh_arg_i;
	
	      return [r * hr - i * hi, r * hi + i * hr];
	    };
	
	    // Heavily based on this etmerc projection implementation
	    // https://github.com/mbloch/mapshaper-proj/blob/master/src/projections/etmerc.js
	
	    function init$3() {
	      if (!this.approx && (isNaN(this.es) || this.es <= 0)) {
	        throw new Error('Incorrect elliptical usage. Try using the +approx option in the proj string, or PROJECTION["Fast_Transverse_Mercator"] in the WKT.');
	      }
	      if (this.approx) {
	        // When '+approx' is set, use tmerc instead
	        tmerc.init.apply(this);
	        this.forward = tmerc.forward;
	        this.inverse = tmerc.inverse;
	      }
	
	      this.x0 = this.x0 !== undefined ? this.x0 : 0;
	      this.y0 = this.y0 !== undefined ? this.y0 : 0;
	      this.long0 = this.long0 !== undefined ? this.long0 : 0;
	      this.lat0 = this.lat0 !== undefined ? this.lat0 : 0;
	
	      this.cgb = [];
	      this.cbg = [];
	      this.utg = [];
	      this.gtu = [];
	
	      var f = this.es / (1 + Math.sqrt(1 - this.es));
	      var n = f / (2 - f);
	      var np = n;
	
	      this.cgb[0] = n * (2 + n * (-2 / 3 + n * (-2 + n * (116 / 45 + n * (26 / 45 + n * (-2854 / 675 ))))));
	      this.cbg[0] = n * (-2 + n * ( 2 / 3 + n * ( 4 / 3 + n * (-82 / 45 + n * (32 / 45 + n * (4642 / 4725))))));
	
	      np = np * n;
	      this.cgb[1] = np * (7 / 3 + n * (-8 / 5 + n * (-227 / 45 + n * (2704 / 315 + n * (2323 / 945)))));
	      this.cbg[1] = np * (5 / 3 + n * (-16 / 15 + n * ( -13 / 9 + n * (904 / 315 + n * (-1522 / 945)))));
	
	      np = np * n;
	      this.cgb[2] = np * (56 / 15 + n * (-136 / 35 + n * (-1262 / 105 + n * (73814 / 2835))));
	      this.cbg[2] = np * (-26 / 15 + n * (34 / 21 + n * (8 / 5 + n * (-12686 / 2835))));
	
	      np = np * n;
	      this.cgb[3] = np * (4279 / 630 + n * (-332 / 35 + n * (-399572 / 14175)));
	      this.cbg[3] = np * (1237 / 630 + n * (-12 / 5 + n * ( -24832 / 14175)));
	
	      np = np * n;
	      this.cgb[4] = np * (4174 / 315 + n * (-144838 / 6237));
	      this.cbg[4] = np * (-734 / 315 + n * (109598 / 31185));
	
	      np = np * n;
	      this.cgb[5] = np * (601676 / 22275);
	      this.cbg[5] = np * (444337 / 155925);
	
	      np = Math.pow(n, 2);
	      this.Qn = this.k0 / (1 + n) * (1 + np * (1 / 4 + np * (1 / 64 + np / 256)));
	
	      this.utg[0] = n * (-0.5 + n * ( 2 / 3 + n * (-37 / 96 + n * ( 1 / 360 + n * (81 / 512 + n * (-96199 / 604800))))));
	      this.gtu[0] = n * (0.5 + n * (-2 / 3 + n * (5 / 16 + n * (41 / 180 + n * (-127 / 288 + n * (7891 / 37800))))));
	
	      this.utg[1] = np * (-1 / 48 + n * (-1 / 15 + n * (437 / 1440 + n * (-46 / 105 + n * (1118711 / 3870720)))));
	      this.gtu[1] = np * (13 / 48 + n * (-3 / 5 + n * (557 / 1440 + n * (281 / 630 + n * (-1983433 / 1935360)))));
	
	      np = np * n;
	      this.utg[2] = np * (-17 / 480 + n * (37 / 840 + n * (209 / 4480 + n * (-5569 / 90720 ))));
	      this.gtu[2] = np * (61 / 240 + n * (-103 / 140 + n * (15061 / 26880 + n * (167603 / 181440))));
	
	      np = np * n;
	      this.utg[3] = np * (-4397 / 161280 + n * (11 / 504 + n * (830251 / 7257600)));
	      this.gtu[3] = np * (49561 / 161280 + n * (-179 / 168 + n * (6601661 / 7257600)));
	
	      np = np * n;
	      this.utg[4] = np * (-4583 / 161280 + n * (108847 / 3991680));
	      this.gtu[4] = np * (34729 / 80640 + n * (-3418889 / 1995840));
	
	      np = np * n;
	      this.utg[5] = np * (-20648693 / 638668800);
	      this.gtu[5] = np * (212378941 / 319334400);
	
	      var Z = gatg(this.cbg, this.lat0);
	      this.Zb = -this.Qn * (Z + clens(this.gtu, 2 * Z));
	    }
	
	    function forward$3(p) {
	      var Ce = adjust_lon(p.x - this.long0);
	      var Cn = p.y;
	
	      Cn = gatg(this.cbg, Cn);
	      var sin_Cn = Math.sin(Cn);
	      var cos_Cn = Math.cos(Cn);
	      var sin_Ce = Math.sin(Ce);
	      var cos_Ce = Math.cos(Ce);
	
	      Cn = Math.atan2(sin_Cn, cos_Ce * cos_Cn);
	      Ce = Math.atan2(sin_Ce * cos_Cn, hypot(sin_Cn, cos_Cn * cos_Ce));
	      Ce = asinhy(Math.tan(Ce));
	
	      var tmp = clens_cmplx(this.gtu, 2 * Cn, 2 * Ce);
	
	      Cn = Cn + tmp[0];
	      Ce = Ce + tmp[1];
	
	      var x;
	      var y;
	
	      if (Math.abs(Ce) <= 2.623395162778) {
	        x = this.a * (this.Qn * Ce) + this.x0;
	        y = this.a * (this.Qn * Cn + this.Zb) + this.y0;
	      }
	      else {
	        x = Infinity;
	        y = Infinity;
	      }
	
	      p.x = x;
	      p.y = y;
	
	      return p;
	    }
	
	    function inverse$3(p) {
	      var Ce = (p.x - this.x0) * (1 / this.a);
	      var Cn = (p.y - this.y0) * (1 / this.a);
	
	      Cn = (Cn - this.Zb) / this.Qn;
	      Ce = Ce / this.Qn;
	
	      var lon;
	      var lat;
	
	      if (Math.abs(Ce) <= 2.623395162778) {
	        var tmp = clens_cmplx(this.utg, 2 * Cn, 2 * Ce);
	
	        Cn = Cn + tmp[0];
	        Ce = Ce + tmp[1];
	        Ce = Math.atan(sinh(Ce));
	
	        var sin_Cn = Math.sin(Cn);
	        var cos_Cn = Math.cos(Cn);
	        var sin_Ce = Math.sin(Ce);
	        var cos_Ce = Math.cos(Ce);
	
	        Cn = Math.atan2(sin_Cn * cos_Ce, hypot(sin_Ce, cos_Ce * cos_Cn));
	        Ce = Math.atan2(sin_Ce, cos_Ce * cos_Cn);
	
	        lon = adjust_lon(Ce + this.long0);
	        lat = gatg(this.cgb, Cn);
	      }
	      else {
	        lon = Infinity;
	        lat = Infinity;
	      }
	
	      p.x = lon;
	      p.y = lat;
	
	      return p;
	    }
	
	    var names$4 = ["Extended_Transverse_Mercator", "Extended Transverse Mercator", "etmerc", "Transverse_Mercator", "Transverse Mercator", "tmerc"];
	    var etmerc = {
	      init: init$3,
	      forward: forward$3,
	      inverse: inverse$3,
	      names: names$4
	    };
	
	    var adjust_zone = function(zone, lon) {
	      if (zone === undefined) {
	        zone = Math.floor((adjust_lon(lon) + Math.PI) * 30 / Math.PI) + 1;
	
	        if (zone < 0) {
	          return 0;
	        } else if (zone > 60) {
	          return 60;
	        }
	      }
	      return zone;
	    };
	
	    var dependsOn = 'etmerc';
	    function init$4() {
	      var zone = adjust_zone(this.zone, this.long0);
	      if (zone === undefined) {
	        throw new Error('unknown utm zone');
	      }
	      this.lat0 = 0;
	      this.long0 =  ((6 * Math.abs(zone)) - 183) * D2R;
	      this.x0 = 500000;
	      this.y0 = this.utmSouth ? 10000000 : 0;
	      this.k0 = 0.9996;
	
	      etmerc.init.apply(this);
	      this.forward = etmerc.forward;
	      this.inverse = etmerc.inverse;
	    }
	
	    var names$5 = ["Universal Transverse Mercator System", "utm"];
	    var utm = {
	      init: init$4,
	      names: names$5,
	      dependsOn: dependsOn
	    };
	
	    var srat = function(esinp, exp) {
	      return (Math.pow((1 - esinp) / (1 + esinp), exp));
	    };
	
	    var MAX_ITER$1 = 20;
	    function init$6() {
	      var sphi = Math.sin(this.lat0);
	      var cphi = Math.cos(this.lat0);
	      cphi *= cphi;
	      this.rc = Math.sqrt(1 - this.es) / (1 - this.es * sphi * sphi);
	      this.C = Math.sqrt(1 + this.es * cphi * cphi / (1 - this.es));
	      this.phic0 = Math.asin(sphi / this.C);
	      this.ratexp = 0.5 * this.C * this.e;
	      this.K = Math.tan(0.5 * this.phic0 + FORTPI) / (Math.pow(Math.tan(0.5 * this.lat0 + FORTPI), this.C) * srat(this.e * sphi, this.ratexp));
	    }
	
	    function forward$5(p) {
	      var lon = p.x;
	      var lat = p.y;
	
	      p.y = 2 * Math.atan(this.K * Math.pow(Math.tan(0.5 * lat + FORTPI), this.C) * srat(this.e * Math.sin(lat), this.ratexp)) - HALF_PI;
	      p.x = this.C * lon;
	      return p;
	    }
	
	    function inverse$5(p) {
	      var DEL_TOL = 1e-14;
	      var lon = p.x / this.C;
	      var lat = p.y;
	      var num = Math.pow(Math.tan(0.5 * lat + FORTPI) / this.K, 1 / this.C);
	      for (var i = MAX_ITER$1; i > 0; --i) {
	        lat = 2 * Math.atan(num * srat(this.e * Math.sin(p.y), - 0.5 * this.e)) - HALF_PI;
	        if (Math.abs(lat - p.y) < DEL_TOL) {
	          break;
	        }
	        p.y = lat;
	      }
	      /* convergence failed */
	      if (!i) {
	        return null;
	      }
	      p.x = lon;
	      p.y = lat;
	      return p;
	    }
	
	    var names$7 = ["gauss"];
	    var gauss = {
	      init: init$6,
	      forward: forward$5,
	      inverse: inverse$5,
	      names: names$7
	    };
	
	    function init$5() {
	      gauss.init.apply(this);
	      if (!this.rc) {
	        return;
	      }
	      this.sinc0 = Math.sin(this.phic0);
	      this.cosc0 = Math.cos(this.phic0);
	      this.R2 = 2 * this.rc;
	      if (!this.title) {
	        this.title = "Oblique Stereographic Alternative";
	      }
	    }
	
	    function forward$4(p) {
	      var sinc, cosc, cosl, k;
	      p.x = adjust_lon(p.x - this.long0);
	      gauss.forward.apply(this, [p]);
	      sinc = Math.sin(p.y);
	      cosc = Math.cos(p.y);
	      cosl = Math.cos(p.x);
	      k = this.k0 * this.R2 / (1 + this.sinc0 * sinc + this.cosc0 * cosc * cosl);
	      p.x = k * cosc * Math.sin(p.x);
	      p.y = k * (this.cosc0 * sinc - this.sinc0 * cosc * cosl);
	      p.x = this.a * p.x + this.x0;
	      p.y = this.a * p.y + this.y0;
	      return p;
	    }
	
	    function inverse$4(p) {
	      var sinc, cosc, lon, lat, rho;
	      p.x = (p.x - this.x0) / this.a;
	      p.y = (p.y - this.y0) / this.a;
	
	      p.x /= this.k0;
	      p.y /= this.k0;
	      if ((rho = Math.sqrt(p.x * p.x + p.y * p.y))) {
	        var c = 2 * Math.atan2(rho, this.R2);
	        sinc = Math.sin(c);
	        cosc = Math.cos(c);
	        lat = Math.asin(cosc * this.sinc0 + p.y * sinc * this.cosc0 / rho);
	        lon = Math.atan2(p.x * sinc, rho * this.cosc0 * cosc - p.y * this.sinc0 * sinc);
	      }
	      else {
	        lat = this.phic0;
	        lon = 0;
	      }
	
	      p.x = lon;
	      p.y = lat;
	      gauss.inverse.apply(this, [p]);
	      p.x = adjust_lon(p.x + this.long0);
	      return p;
	    }
	
	    var names$6 = ["Stereographic_North_Pole", "Oblique_Stereographic", "Polar_Stereographic", "sterea","Oblique Stereographic Alternative","Double_Stereographic"];
	    var sterea = {
	      init: init$5,
	      forward: forward$4,
	      inverse: inverse$4,
	      names: names$6
	    };
	
	    function ssfn_(phit, sinphi, eccen) {
	      sinphi *= eccen;
	      return (Math.tan(0.5 * (HALF_PI + phit)) * Math.pow((1 - sinphi) / (1 + sinphi), 0.5 * eccen));
	    }
	
	    function init$7() {
	      this.coslat0 = Math.cos(this.lat0);
	      this.sinlat0 = Math.sin(this.lat0);
	      if (this.sphere) {
	        if (this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= EPSLN) {
	          this.k0 = 0.5 * (1 + sign(this.lat0) * Math.sin(this.lat_ts));
	        }
	      }
	      else {
	        if (Math.abs(this.coslat0) <= EPSLN) {
	          if (this.lat0 > 0) {
	            //North pole
	            //trace('stere:north pole');
	            this.con = 1;
	          }
	          else {
	            //South pole
	            //trace('stere:south pole');
	            this.con = -1;
	          }
	        }
	        this.cons = Math.sqrt(Math.pow(1 + this.e, 1 + this.e) * Math.pow(1 - this.e, 1 - this.e));
	        if (this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= EPSLN) {
	          this.k0 = 0.5 * this.cons * msfnz(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)) / tsfnz(this.e, this.con * this.lat_ts, this.con * Math.sin(this.lat_ts));
	        }
	        this.ms1 = msfnz(this.e, this.sinlat0, this.coslat0);
	        this.X0 = 2 * Math.atan(this.ssfn_(this.lat0, this.sinlat0, this.e)) - HALF_PI;
	        this.cosX0 = Math.cos(this.X0);
	        this.sinX0 = Math.sin(this.X0);
	      }
	    }
	
	    // Stereographic forward equations--mapping lat,long to x,y
	    function forward$6(p) {
	      var lon = p.x;
	      var lat = p.y;
	      var sinlat = Math.sin(lat);
	      var coslat = Math.cos(lat);
	      var A, X, sinX, cosX, ts, rh;
	      var dlon = adjust_lon(lon - this.long0);
	
	      if (Math.abs(Math.abs(lon - this.long0) - Math.PI) <= EPSLN && Math.abs(lat + this.lat0) <= EPSLN) {
	        //case of the origine point
	        //trace('stere:this is the origin point');
	        p.x = NaN;
	        p.y = NaN;
	        return p;
	      }
	      if (this.sphere) {
	        //trace('stere:sphere case');
	        A = 2 * this.k0 / (1 + this.sinlat0 * sinlat + this.coslat0 * coslat * Math.cos(dlon));
	        p.x = this.a * A * coslat * Math.sin(dlon) + this.x0;
	        p.y = this.a * A * (this.coslat0 * sinlat - this.sinlat0 * coslat * Math.cos(dlon)) + this.y0;
	        return p;
	      }
	      else {
	        X = 2 * Math.atan(this.ssfn_(lat, sinlat, this.e)) - HALF_PI;
	        cosX = Math.cos(X);
	        sinX = Math.sin(X);
	        if (Math.abs(this.coslat0) <= EPSLN) {
	          ts = tsfnz(this.e, lat * this.con, this.con * sinlat);
	          rh = 2 * this.a * this.k0 * ts / this.cons;
	          p.x = this.x0 + rh * Math.sin(lon - this.long0);
	          p.y = this.y0 - this.con * rh * Math.cos(lon - this.long0);
	          //trace(p.toString());
	          return p;
	        }
	        else if (Math.abs(this.sinlat0) < EPSLN) {
	          //Eq
	          //trace('stere:equateur');
	          A = 2 * this.a * this.k0 / (1 + cosX * Math.cos(dlon));
	          p.y = A * sinX;
	        }
	        else {
	          //other case
	          //trace('stere:normal case');
	          A = 2 * this.a * this.k0 * this.ms1 / (this.cosX0 * (1 + this.sinX0 * sinX + this.cosX0 * cosX * Math.cos(dlon)));
	          p.y = A * (this.cosX0 * sinX - this.sinX0 * cosX * Math.cos(dlon)) + this.y0;
	        }
	        p.x = A * cosX * Math.sin(dlon) + this.x0;
	      }
	      //trace(p.toString());
	      return p;
	    }
	
	    //* Stereographic inverse equations--mapping x,y to lat/long
	    function inverse$6(p) {
	      p.x -= this.x0;
	      p.y -= this.y0;
	      var lon, lat, ts, ce, Chi;
	      var rh = Math.sqrt(p.x * p.x + p.y * p.y);
	      if (this.sphere) {
	        var c = 2 * Math.atan(rh / (2 * this.a * this.k0));
	        lon = this.long0;
	        lat = this.lat0;
	        if (rh <= EPSLN) {
	          p.x = lon;
	          p.y = lat;
	          return p;
	        }
	        lat = Math.asin(Math.cos(c) * this.sinlat0 + p.y * Math.sin(c) * this.coslat0 / rh);
	        if (Math.abs(this.coslat0) < EPSLN) {
	          if (this.lat0 > 0) {
	            lon = adjust_lon(this.long0 + Math.atan2(p.x, - 1 * p.y));
	          }
	          else {
	            lon = adjust_lon(this.long0 + Math.atan2(p.x, p.y));
	          }
	        }
	        else {
	          lon = adjust_lon(this.long0 + Math.atan2(p.x * Math.sin(c), rh * this.coslat0 * Math.cos(c) - p.y * this.sinlat0 * Math.sin(c)));
	        }
	        p.x = lon;
	        p.y = lat;
	        return p;
	      }
	      else {
	        if (Math.abs(this.coslat0) <= EPSLN) {
	          if (rh <= EPSLN) {
	            lat = this.lat0;
	            lon = this.long0;
	            p.x = lon;
	            p.y = lat;
	            //trace(p.toString());
	            return p;
	          }
	          p.x *= this.con;
	          p.y *= this.con;
	          ts = rh * this.cons / (2 * this.a * this.k0);
	          lat = this.con * phi2z(this.e, ts);
	          lon = this.con * adjust_lon(this.con * this.long0 + Math.atan2(p.x, - 1 * p.y));
	        }
	        else {
	          ce = 2 * Math.atan(rh * this.cosX0 / (2 * this.a * this.k0 * this.ms1));
	          lon = this.long0;
	          if (rh <= EPSLN) {
	            Chi = this.X0;
	          }
	          else {
	            Chi = Math.asin(Math.cos(ce) * this.sinX0 + p.y * Math.sin(ce) * this.cosX0 / rh);
	            lon = adjust_lon(this.long0 + Math.atan2(p.x * Math.sin(ce), rh * this.cosX0 * Math.cos(ce) - p.y * this.sinX0 * Math.sin(ce)));
	          }
	          lat = -1 * phi2z(this.e, Math.tan(0.5 * (HALF_PI + Chi)));
	        }
	      }
	      p.x = lon;
	      p.y = lat;
	
	      //trace(p.toString());
	      return p;
	
	    }
	
	    var names$8 = ["stere", "Stereographic_South_Pole", "Polar Stereographic (variant B)"];
	    var stere = {
	      init: init$7,
	      forward: forward$6,
	      inverse: inverse$6,
	      names: names$8,
	      ssfn_: ssfn_
	    };
	
	    /*
	      references:
	        Formules et constantes pour le Calcul pour la
	        projection cylindrique conforme à axe oblique et pour la transformation entre
	        des systèmes de référence.
	        http://www.swisstopo.admin.ch/internet/swisstopo/fr/home/topics/survey/sys/refsys/switzerland.parsysrelated1.31216.downloadList.77004.DownloadFile.tmp/swissprojectionfr.pdf
	      */
	
	    function init$8() {
	      var phy0 = this.lat0;
	      this.lambda0 = this.long0;
	      var sinPhy0 = Math.sin(phy0);
	      var semiMajorAxis = this.a;
	      var invF = this.rf;
	      var flattening = 1 / invF;
	      var e2 = 2 * flattening - Math.pow(flattening, 2);
	      var e = this.e = Math.sqrt(e2);
	      this.R = this.k0 * semiMajorAxis * Math.sqrt(1 - e2) / (1 - e2 * Math.pow(sinPhy0, 2));
	      this.alpha = Math.sqrt(1 + e2 / (1 - e2) * Math.pow(Math.cos(phy0), 4));
	      this.b0 = Math.asin(sinPhy0 / this.alpha);
	      var k1 = Math.log(Math.tan(Math.PI / 4 + this.b0 / 2));
	      var k2 = Math.log(Math.tan(Math.PI / 4 + phy0 / 2));
	      var k3 = Math.log((1 + e * sinPhy0) / (1 - e * sinPhy0));
	      this.K = k1 - this.alpha * k2 + this.alpha * e / 2 * k3;
	    }
	
	    function forward$7(p) {
	      var Sa1 = Math.log(Math.tan(Math.PI / 4 - p.y / 2));
	      var Sa2 = this.e / 2 * Math.log((1 + this.e * Math.sin(p.y)) / (1 - this.e * Math.sin(p.y)));
	      var S = -this.alpha * (Sa1 + Sa2) + this.K;
	
	      // spheric latitude
	      var b = 2 * (Math.atan(Math.exp(S)) - Math.PI / 4);
	
	      // spheric longitude
	      var I = this.alpha * (p.x - this.lambda0);
	
	      // psoeudo equatorial rotation
	      var rotI = Math.atan(Math.sin(I) / (Math.sin(this.b0) * Math.tan(b) + Math.cos(this.b0) * Math.cos(I)));
	
	      var rotB = Math.asin(Math.cos(this.b0) * Math.sin(b) - Math.sin(this.b0) * Math.cos(b) * Math.cos(I));
	
	      p.y = this.R / 2 * Math.log((1 + Math.sin(rotB)) / (1 - Math.sin(rotB))) + this.y0;
	      p.x = this.R * rotI + this.x0;
	      return p;
	    }
	
	    function inverse$7(p) {
	      var Y = p.x - this.x0;
	      var X = p.y - this.y0;
	
	      var rotI = Y / this.R;
	      var rotB = 2 * (Math.atan(Math.exp(X / this.R)) - Math.PI / 4);
	
	      var b = Math.asin(Math.cos(this.b0) * Math.sin(rotB) + Math.sin(this.b0) * Math.cos(rotB) * Math.cos(rotI));
	      var I = Math.atan(Math.sin(rotI) / (Math.cos(this.b0) * Math.cos(rotI) - Math.sin(this.b0) * Math.tan(rotB)));
	
	      var lambda = this.lambda0 + I / this.alpha;
	
	      var S = 0;
	      var phy = b;
	      var prevPhy = -1000;
	      var iteration = 0;
	      while (Math.abs(phy - prevPhy) > 0.0000001) {
	        if (++iteration > 20) {
	          //...reportError("omercFwdInfinity");
	          return;
	        }
	        //S = Math.log(Math.tan(Math.PI / 4 + phy / 2));
	        S = 1 / this.alpha * (Math.log(Math.tan(Math.PI / 4 + b / 2)) - this.K) + this.e * Math.log(Math.tan(Math.PI / 4 + Math.asin(this.e * Math.sin(phy)) / 2));
	        prevPhy = phy;
	        phy = 2 * Math.atan(Math.exp(S)) - Math.PI / 2;
	      }
	
	      p.x = lambda;
	      p.y = phy;
	      return p;
	    }
	
	    var names$9 = ["somerc"];
	    var somerc = {
	      init: init$8,
	      forward: forward$7,
	      inverse: inverse$7,
	      names: names$9
	    };
	
	    var TOL = 1e-7;
	
	    function isTypeA(P) {
	      var typeAProjections = ['Hotine_Oblique_Mercator','Hotine_Oblique_Mercator_Azimuth_Natural_Origin'];
	      var projectionName = typeof P.PROJECTION === "object" ? Object.keys(P.PROJECTION)[0] : P.PROJECTION;
	      
	      return 'no_uoff' in P || 'no_off' in P || typeAProjections.indexOf(projectionName) !== -1;
	    }
	
	
	    /* Initialize the Oblique Mercator  projection
	        ------------------------------------------*/
	    function init$9() {  
	      var con, com, cosph0, D, F, H, L, sinph0, p, J, gamma = 0,
	        gamma0, lamc = 0, lam1 = 0, lam2 = 0, phi1 = 0, phi2 = 0, alpha_c = 0;
	      
	      // only Type A uses the no_off or no_uoff property
	      // https://github.com/OSGeo/proj.4/issues/104
	      this.no_off = isTypeA(this);
	      this.no_rot = 'no_rot' in this;
	      
	      var alp = false;
	      if ("alpha" in this) {
	        alp = true;
	      }
	
	      var gam = false;
	      if ("rectified_grid_angle" in this) {
	        gam = true;
	      }
	
	      if (alp) {
	        alpha_c = this.alpha;
	      }
	      
	      if (gam) {
	        gamma = (this.rectified_grid_angle * D2R);
	      }
	      
	      if (alp || gam) {
	        lamc = this.longc;
	      } else {
	        lam1 = this.long1;
	        phi1 = this.lat1;
	        lam2 = this.long2;
	        phi2 = this.lat2;
	        
	        if (Math.abs(phi1 - phi2) <= TOL || (con = Math.abs(phi1)) <= TOL ||
	            Math.abs(con - HALF_PI) <= TOL || Math.abs(Math.abs(this.lat0) - HALF_PI) <= TOL ||
	            Math.abs(Math.abs(phi2) - HALF_PI) <= TOL) {
	          throw new Error();
	        }
	      }
	      
	      var one_es = 1.0 - this.es;
	      com = Math.sqrt(one_es);
	      
	      if (Math.abs(this.lat0) > EPSLN) {
	        sinph0 = Math.sin(this.lat0);
	        cosph0 = Math.cos(this.lat0);
	        con = 1 - this.es * sinph0 * sinph0;
	        this.B = cosph0 * cosph0;
	        this.B = Math.sqrt(1 + this.es * this.B * this.B / one_es);
	        this.A = this.B * this.k0 * com / con;
	        D = this.B * com / (cosph0 * Math.sqrt(con));
	        F = D * D -1;
	        
	        if (F <= 0) {
	          F = 0;
	        } else {
	          F = Math.sqrt(F);
	          if (this.lat0 < 0) {
	            F = -F;
	          }
	        }
	        
	        this.E = F += D;
	        this.E *= Math.pow(tsfnz(this.e, this.lat0, sinph0), this.B);
	      } else {
	        this.B = 1 / com;
	        this.A = this.k0;
	        this.E = D = F = 1;
	      }
	      
	      if (alp || gam) {
	        if (alp) {
	          gamma0 = Math.asin(Math.sin(alpha_c) / D);
	          if (!gam) {
	            gamma = alpha_c;
	          }
	        } else {
	          gamma0 = gamma;
	          alpha_c = Math.asin(D * Math.sin(gamma0));
	        }
	        this.lam0 = lamc - Math.asin(0.5 * (F - 1 / F) * Math.tan(gamma0)) / this.B;
	      } else {
	        H = Math.pow(tsfnz(this.e, phi1, Math.sin(phi1)), this.B);
	        L = Math.pow(tsfnz(this.e, phi2, Math.sin(phi2)), this.B);
	        F = this.E / H;
	        p = (L - H) / (L + H);
	        J = this.E * this.E;
	        J = (J - L * H) / (J + L * H);
	        con = lam1 - lam2;
	        
	        if (con < -Math.pi) {
	          lam2 -=TWO_PI;
	        } else if (con > Math.pi) {
	          lam2 += TWO_PI;
	        }
	        
	        this.lam0 = adjust_lon(0.5 * (lam1 + lam2) - Math.atan(J * Math.tan(0.5 * this.B * (lam1 - lam2)) / p) / this.B);
	        gamma0 = Math.atan(2 * Math.sin(this.B * adjust_lon(lam1 - this.lam0)) / (F - 1 / F));
	        gamma = alpha_c = Math.asin(D * Math.sin(gamma0));
	      }
	      
	      this.singam = Math.sin(gamma0);
	      this.cosgam = Math.cos(gamma0);
	      this.sinrot = Math.sin(gamma);
	      this.cosrot = Math.cos(gamma);
	      
	      this.rB = 1 / this.B;
	      this.ArB = this.A * this.rB;
	      this.BrA = 1 / this.ArB;
	      if (this.no_off) {
	        this.u_0 = 0;
	      } else {
	        this.u_0 = Math.abs(this.ArB * Math.atan(Math.sqrt(D * D - 1) / Math.cos(alpha_c)));
	        
	        if (this.lat0 < 0) {
	          this.u_0 = - this.u_0;
	        }  
	      }
	        
	      F = 0.5 * gamma0;
	      this.v_pole_n = this.ArB * Math.log(Math.tan(FORTPI - F));
	      this.v_pole_s = this.ArB * Math.log(Math.tan(FORTPI + F));
	    }
	
	
	    /* Oblique Mercator forward equations--mapping lat,long to x,y
	        ----------------------------------------------------------*/
	    function forward$8(p) {
	      var coords = {};
	      var S, T, U, V, W, temp, u, v;
	      p.x = p.x - this.lam0;
	      
	      if (Math.abs(Math.abs(p.y) - HALF_PI) > EPSLN) {
	        W = this.E / Math.pow(tsfnz(this.e, p.y, Math.sin(p.y)), this.B);
	        
	        temp = 1 / W;
	        S = 0.5 * (W - temp);
	        T = 0.5 * (W + temp);
	        V = Math.sin(this.B * p.x);
	        U = (S * this.singam - V * this.cosgam) / T;
	            
	        if (Math.abs(Math.abs(U) - 1.0) < EPSLN) {
	          throw new Error();
	        }
	        
	        v = 0.5 * this.ArB * Math.log((1 - U)/(1 + U));
	        temp = Math.cos(this.B * p.x);
	        
	        if (Math.abs(temp) < TOL) {
	          u = this.A * p.x;
	        } else {
	          u = this.ArB * Math.atan2((S * this.cosgam + V * this.singam), temp);
	        }    
	      } else {
	        v = p.y > 0 ? this.v_pole_n : this.v_pole_s;
	        u = this.ArB * p.y;
	      }
	         
	      if (this.no_rot) {
	        coords.x = u;
	        coords.y = v;
	      } else {
	        u -= this.u_0;
	        coords.x = v * this.cosrot + u * this.sinrot;
	        coords.y = u * this.cosrot - v * this.sinrot;
	      }
	      
	      coords.x = (this.a * coords.x + this.x0);
	      coords.y = (this.a * coords.y + this.y0);
	      
	      return coords;
	    }
	
	    function inverse$8(p) {
	      var u, v, Qp, Sp, Tp, Vp, Up;
	      var coords = {};
	      
	      p.x = (p.x - this.x0) * (1.0 / this.a);
	      p.y = (p.y - this.y0) * (1.0 / this.a);
	
	      if (this.no_rot) {
	        v = p.y;
	        u = p.x;
	      } else {
	        v = p.x * this.cosrot - p.y * this.sinrot;
	        u = p.y * this.cosrot + p.x * this.sinrot + this.u_0;
	      }
	      
	      Qp = Math.exp(-this.BrA * v);
	      Sp = 0.5 * (Qp - 1 / Qp);
	      Tp = 0.5 * (Qp + 1 / Qp);
	      Vp = Math.sin(this.BrA * u);
	      Up = (Vp * this.cosgam + Sp * this.singam) / Tp;
	      
	      if (Math.abs(Math.abs(Up) - 1) < EPSLN) {
	        coords.x = 0;
	        coords.y = Up < 0 ? -HALF_PI : HALF_PI;
	      } else {
	        coords.y = this.E / Math.sqrt((1 + Up) / (1 - Up));
	        coords.y = phi2z(this.e, Math.pow(coords.y, 1 / this.B));
	        
	        if (coords.y === Infinity) {
	          throw new Error();
	        }
	            
	        coords.x = -this.rB * Math.atan2((Sp * this.cosgam - Vp * this.singam), Math.cos(this.BrA * u));
	      }
	      
	      coords.x += this.lam0;
	      
	      return coords;
	    }
	
	    var names$10 = ["Hotine_Oblique_Mercator", "Hotine Oblique Mercator", "Hotine_Oblique_Mercator_Azimuth_Natural_Origin", "Hotine_Oblique_Mercator_Two_Point_Natural_Origin", "Hotine_Oblique_Mercator_Azimuth_Center", "Oblique_Mercator", "omerc"];
	    var omerc = {
	      init: init$9,
	      forward: forward$8,
	      inverse: inverse$8,
	      names: names$10
	    };
	
	    function init$10() {
	
	      // array of:  r_maj,r_min,lat1,lat2,c_lon,c_lat,false_east,false_north
	      //double c_lat;                   /* center latitude                      */
	      //double c_lon;                   /* center longitude                     */
	      //double lat1;                    /* first standard parallel              */
	      //double lat2;                    /* second standard parallel             */
	      //double r_maj;                   /* major axis                           */
	      //double r_min;                   /* minor axis                           */
	      //double false_east;              /* x offset in meters                   */
	      //double false_north;             /* y offset in meters                   */
	
	      if (!this.lat2) {
	        this.lat2 = this.lat1;
	      } //if lat2 is not defined
	      if (!this.k0) {
	        this.k0 = 1;
	      }
	      this.x0 = this.x0 || 0;
	      this.y0 = this.y0 || 0;
	      // Standard Parallels cannot be equal and on opposite sides of the equator
	      if (Math.abs(this.lat1 + this.lat2) < EPSLN) {
	        return;
	      }
	
	      var temp = this.b / this.a;
	      this.e = Math.sqrt(1 - temp * temp);
	
	      var sin1 = Math.sin(this.lat1);
	      var cos1 = Math.cos(this.lat1);
	      var ms1 = msfnz(this.e, sin1, cos1);
	      var ts1 = tsfnz(this.e, this.lat1, sin1);
	
	      var sin2 = Math.sin(this.lat2);
	      var cos2 = Math.cos(this.lat2);
	      var ms2 = msfnz(this.e, sin2, cos2);
	      var ts2 = tsfnz(this.e, this.lat2, sin2);
	
	      var ts0 = tsfnz(this.e, this.lat0, Math.sin(this.lat0));
	
	      if (Math.abs(this.lat1 - this.lat2) > EPSLN) {
	        this.ns = Math.log(ms1 / ms2) / Math.log(ts1 / ts2);
	      }
	      else {
	        this.ns = sin1;
	      }
	      if (isNaN(this.ns)) {
	        this.ns = sin1;
	      }
	      this.f0 = ms1 / (this.ns * Math.pow(ts1, this.ns));
	      this.rh = this.a * this.f0 * Math.pow(ts0, this.ns);
	      if (!this.title) {
	        this.title = "Lambert Conformal Conic";
	      }
	    }
	
	    // Lambert Conformal conic forward equations--mapping lat,long to x,y
	    // -----------------------------------------------------------------
	    function forward$9(p) {
	
	      var lon = p.x;
	      var lat = p.y;
	
	      // singular cases :
	      if (Math.abs(2 * Math.abs(lat) - Math.PI) <= EPSLN) {
	        lat = sign(lat) * (HALF_PI - 2 * EPSLN);
	      }
	
	      var con = Math.abs(Math.abs(lat) - HALF_PI);
	      var ts, rh1;
	      if (con > EPSLN) {
	        ts = tsfnz(this.e, lat, Math.sin(lat));
	        rh1 = this.a * this.f0 * Math.pow(ts, this.ns);
	      }
	      else {
	        con = lat * this.ns;
	        if (con <= 0) {
	          return null;
	        }
	        rh1 = 0;
	      }
	      var theta = this.ns * adjust_lon(lon - this.long0);
	      p.x = this.k0 * (rh1 * Math.sin(theta)) + this.x0;
	      p.y = this.k0 * (this.rh - rh1 * Math.cos(theta)) + this.y0;
	
	      return p;
	    }
	
	    // Lambert Conformal Conic inverse equations--mapping x,y to lat/long
	    // -----------------------------------------------------------------
	    function inverse$9(p) {
	
	      var rh1, con, ts;
	      var lat, lon;
	      var x = (p.x - this.x0) / this.k0;
	      var y = (this.rh - (p.y - this.y0) / this.k0);
	      if (this.ns > 0) {
	        rh1 = Math.sqrt(x * x + y * y);
	        con = 1;
	      }
	      else {
	        rh1 = -Math.sqrt(x * x + y * y);
	        con = -1;
	      }
	      var theta = 0;
	      if (rh1 !== 0) {
	        theta = Math.atan2((con * x), (con * y));
	      }
	      if ((rh1 !== 0) || (this.ns > 0)) {
	        con = 1 / this.ns;
	        ts = Math.pow((rh1 / (this.a * this.f0)), con);
	        lat = phi2z(this.e, ts);
	        if (lat === -9999) {
	          return null;
	        }
	      }
	      else {
	        lat = -HALF_PI;
	      }
	      lon = adjust_lon(theta / this.ns + this.long0);
	
	      p.x = lon;
	      p.y = lat;
	      return p;
	    }
	
	    var names$11 = [
	      "Lambert Tangential Conformal Conic Projection",
	      "Lambert_Conformal_Conic",
	      "Lambert_Conformal_Conic_1SP",
	      "Lambert_Conformal_Conic_2SP",
	      "lcc"
	    ];
	
	    var lcc = {
	      init: init$10,
	      forward: forward$9,
	      inverse: inverse$9,
	      names: names$11
	    };
	
	    function init$11() {
	      this.a = 6377397.155;
	      this.es = 0.006674372230614;
	      this.e = Math.sqrt(this.es);
	      if (!this.lat0) {
	        this.lat0 = 0.863937979737193;
	      }
	      if (!this.long0) {
	        this.long0 = 0.7417649320975901 - 0.308341501185665;
	      }
	      /* if scale not set default to 0.9999 */
	      if (!this.k0) {
	        this.k0 = 0.9999;
	      }
	      this.s45 = 0.785398163397448; /* 45 */
	      this.s90 = 2 * this.s45;
	      this.fi0 = this.lat0;
	      this.e2 = this.es;
	      this.e = Math.sqrt(this.e2);
	      this.alfa = Math.sqrt(1 + (this.e2 * Math.pow(Math.cos(this.fi0), 4)) / (1 - this.e2));
	      this.uq = 1.04216856380474;
	      this.u0 = Math.asin(Math.sin(this.fi0) / this.alfa);
	      this.g = Math.pow((1 + this.e * Math.sin(this.fi0)) / (1 - this.e * Math.sin(this.fi0)), this.alfa * this.e / 2);
	      this.k = Math.tan(this.u0 / 2 + this.s45) / Math.pow(Math.tan(this.fi0 / 2 + this.s45), this.alfa) * this.g;
	      this.k1 = this.k0;
	      this.n0 = this.a * Math.sqrt(1 - this.e2) / (1 - this.e2 * Math.pow(Math.sin(this.fi0), 2));
	      this.s0 = 1.37008346281555;
	      this.n = Math.sin(this.s0);
	      this.ro0 = this.k1 * this.n0 / Math.tan(this.s0);
	      this.ad = this.s90 - this.uq;
	    }
	
	    /* ellipsoid */
	    /* calculate xy from lat/lon */
	    /* Constants, identical to inverse transform function */
	    function forward$10(p) {
	      var gfi, u, deltav, s, d, eps, ro;
	      var lon = p.x;
	      var lat = p.y;
	      var delta_lon = adjust_lon(lon - this.long0);
	      /* Transformation */
	      gfi = Math.pow(((1 + this.e * Math.sin(lat)) / (1 - this.e * Math.sin(lat))), (this.alfa * this.e / 2));
	      u = 2 * (Math.atan(this.k * Math.pow(Math.tan(lat / 2 + this.s45), this.alfa) / gfi) - this.s45);
	      deltav = -delta_lon * this.alfa;
	      s = Math.asin(Math.cos(this.ad) * Math.sin(u) + Math.sin(this.ad) * Math.cos(u) * Math.cos(deltav));
	      d = Math.asin(Math.cos(u) * Math.sin(deltav) / Math.cos(s));
	      eps = this.n * d;
	      ro = this.ro0 * Math.pow(Math.tan(this.s0 / 2 + this.s45), this.n) / Math.pow(Math.tan(s / 2 + this.s45), this.n);
	      p.y = ro * Math.cos(eps) / 1;
	      p.x = ro * Math.sin(eps) / 1;
	
	      if (!this.czech) {
	        p.y *= -1;
	        p.x *= -1;
	      }
	      return (p);
	    }
	
	    /* calculate lat/lon from xy */
	    function inverse$10(p) {
	      var u, deltav, s, d, eps, ro, fi1;
	      var ok;
	
	      /* Transformation */
	      /* revert y, x*/
	      var tmp = p.x;
	      p.x = p.y;
	      p.y = tmp;
	      if (!this.czech) {
	        p.y *= -1;
	        p.x *= -1;
	      }
	      ro = Math.sqrt(p.x * p.x + p.y * p.y);
	      eps = Math.atan2(p.y, p.x);
	      d = eps / Math.sin(this.s0);
	      s = 2 * (Math.atan(Math.pow(this.ro0 / ro, 1 / this.n) * Math.tan(this.s0 / 2 + this.s45)) - this.s45);
	      u = Math.asin(Math.cos(this.ad) * Math.sin(s) - Math.sin(this.ad) * Math.cos(s) * Math.cos(d));
	      deltav = Math.asin(Math.cos(s) * Math.sin(d) / Math.cos(u));
	      p.x = this.long0 - deltav / this.alfa;
	      fi1 = u;
	      ok = 0;
	      var iter = 0;
	      do {
	        p.y = 2 * (Math.atan(Math.pow(this.k, - 1 / this.alfa) * Math.pow(Math.tan(u / 2 + this.s45), 1 / this.alfa) * Math.pow((1 + this.e * Math.sin(fi1)) / (1 - this.e * Math.sin(fi1)), this.e / 2)) - this.s45);
	        if (Math.abs(fi1 - p.y) < 0.0000000001) {
	          ok = 1;
	        }
	        fi1 = p.y;
	        iter += 1;
	      } while (ok === 0 && iter < 15);
	      if (iter >= 15) {
	        return null;
	      }
	
	      return (p);
	    }
	
	    var names$12 = ["Krovak", "krovak"];
	    var krovak = {
	      init: init$11,
	      forward: forward$10,
	      inverse: inverse$10,
	      names: names$12
	    };
	
	    var mlfn = function(e0, e1, e2, e3, phi) {
	      return (e0 * phi - e1 * Math.sin(2 * phi) + e2 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi));
	    };
	
	    var e0fn = function(x) {
	      return (1 - 0.25 * x * (1 + x / 16 * (3 + 1.25 * x)));
	    };
	
	    var e1fn = function(x) {
	      return (0.375 * x * (1 + 0.25 * x * (1 + 0.46875 * x)));
	    };
	
	    var e2fn = function(x) {
	      return (0.05859375 * x * x * (1 + 0.75 * x));
	    };
	
	    var e3fn = function(x) {
	      return (x * x * x * (35 / 3072));
	    };
	
	    var gN = function(a, e, sinphi) {
	      var temp = e * sinphi;
	      return a / Math.sqrt(1 - temp * temp);
	    };
	
	    var adjust_lat = function(x) {
	      return (Math.abs(x) < HALF_PI) ? x : (x - (sign(x) * Math.PI));
	    };
	
	    var imlfn = function(ml, e0, e1, e2, e3) {
	      var phi;
	      var dphi;
	
	      phi = ml / e0;
	      for (var i = 0; i < 15; i++) {
	        dphi = (ml - (e0 * phi - e1 * Math.sin(2 * phi) + e2 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi))) / (e0 - 2 * e1 * Math.cos(2 * phi) + 4 * e2 * Math.cos(4 * phi) - 6 * e3 * Math.cos(6 * phi));
	        phi += dphi;
	        if (Math.abs(dphi) <= 0.0000000001) {
	          return phi;
	        }
	      }
	
	      //..reportError("IMLFN-CONV:Latitude failed to converge after 15 iterations");
	      return NaN;
	    };
	
	    function init$12() {
	      if (!this.sphere) {
	        this.e0 = e0fn(this.es);
	        this.e1 = e1fn(this.es);
	        this.e2 = e2fn(this.es);
	        this.e3 = e3fn(this.es);
	        this.ml0 = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, this.lat0);
	      }
	    }
	
	    /* Cassini forward equations--mapping lat,long to x,y
	      -----------------------------------------------------------------------*/
	    function forward$11(p) {
	
	      /* Forward equations
	          -----------------*/
	      var x, y;
	      var lam = p.x;
	      var phi = p.y;
	      lam = adjust_lon(lam - this.long0);
	
	      if (this.sphere) {
	        x = this.a * Math.asin(Math.cos(phi) * Math.sin(lam));
	        y = this.a * (Math.atan2(Math.tan(phi), Math.cos(lam)) - this.lat0);
	      }
	      else {
	        //ellipsoid
	        var sinphi = Math.sin(phi);
	        var cosphi = Math.cos(phi);
	        var nl = gN(this.a, this.e, sinphi);
	        var tl = Math.tan(phi) * Math.tan(phi);
	        var al = lam * Math.cos(phi);
	        var asq = al * al;
	        var cl = this.es * cosphi * cosphi / (1 - this.es);
	        var ml = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, phi);
	
	        x = nl * al * (1 - asq * tl * (1 / 6 - (8 - tl + 8 * cl) * asq / 120));
	        y = ml - this.ml0 + nl * sinphi / cosphi * asq * (0.5 + (5 - tl + 6 * cl) * asq / 24);
	
	
	      }
	
	      p.x = x + this.x0;
	      p.y = y + this.y0;
	      return p;
	    }
	
	    /* Inverse equations
	      -----------------*/
	    function inverse$11(p) {
	      p.x -= this.x0;
	      p.y -= this.y0;
	      var x = p.x / this.a;
	      var y = p.y / this.a;
	      var phi, lam;
	
	      if (this.sphere) {
	        var dd = y + this.lat0;
	        phi = Math.asin(Math.sin(dd) * Math.cos(x));
	        lam = Math.atan2(Math.tan(x), Math.cos(dd));
	      }
	      else {
	        /* ellipsoid */
	        var ml1 = this.ml0 / this.a + y;
	        var phi1 = imlfn(ml1, this.e0, this.e1, this.e2, this.e3);
	        if (Math.abs(Math.abs(phi1) - HALF_PI) <= EPSLN) {
	          p.x = this.long0;
	          p.y = HALF_PI;
	          if (y < 0) {
	            p.y *= -1;
	          }
	          return p;
	        }
	        var nl1 = gN(this.a, this.e, Math.sin(phi1));
	
	        var rl1 = nl1 * nl1 * nl1 / this.a / this.a * (1 - this.es);
	        var tl1 = Math.pow(Math.tan(phi1), 2);
	        var dl = x * this.a / nl1;
	        var dsq = dl * dl;
	        phi = phi1 - nl1 * Math.tan(phi1) / rl1 * dl * dl * (0.5 - (1 + 3 * tl1) * dl * dl / 24);
	        lam = dl * (1 - dsq * (tl1 / 3 + (1 + 3 * tl1) * tl1 * dsq / 15)) / Math.cos(phi1);
	
	      }
	
	      p.x = adjust_lon(lam + this.long0);
	      p.y = adjust_lat(phi);
	      return p;
	
	    }
	
	    var names$13 = ["Cassini", "Cassini_Soldner", "cass"];
	    var cass = {
	      init: init$12,
	      forward: forward$11,
	      inverse: inverse$11,
	      names: names$13
	    };
	
	    var qsfnz = function(eccent, sinphi) {
	      var con;
	      if (eccent > 1.0e-7) {
	        con = eccent * sinphi;
	        return ((1 - eccent * eccent) * (sinphi / (1 - con * con) - (0.5 / eccent) * Math.log((1 - con) / (1 + con))));
	      }
	      else {
	        return (2 * sinphi);
	      }
	    };
	
	    /*
	      reference
	        "New Equal-Area Map Projections for Noncircular Regions", John P. Snyder,
	        The American Cartographer, Vol 15, No. 4, October 1988, pp. 341-355.
	      */
	
	    var S_POLE = 1;
	
	    var N_POLE = 2;
	    var EQUIT = 3;
	    var OBLIQ = 4;
	
	    /* Initialize the Lambert Azimuthal Equal Area projection
	      ------------------------------------------------------*/
	    function init$13() {
	      var t = Math.abs(this.lat0);
	      if (Math.abs(t - HALF_PI) < EPSLN) {
	        this.mode = this.lat0 < 0 ? this.S_POLE : this.N_POLE;
	      }
	      else if (Math.abs(t) < EPSLN) {
	        this.mode = this.EQUIT;
	      }
	      else {
	        this.mode = this.OBLIQ;
	      }
	      if (this.es > 0) {
	        var sinphi;
	
	        this.qp = qsfnz(this.e, 1);
	        this.mmf = 0.5 / (1 - this.es);
	        this.apa = authset(this.es);
	        switch (this.mode) {
	        case this.N_POLE:
	          this.dd = 1;
	          break;
	        case this.S_POLE:
	          this.dd = 1;
	          break;
	        case this.EQUIT:
	          this.rq = Math.sqrt(0.5 * this.qp);
	          this.dd = 1 / this.rq;
	          this.xmf = 1;
	          this.ymf = 0.5 * this.qp;
	          break;
	        case this.OBLIQ:
	          this.rq = Math.sqrt(0.5 * this.qp);
	          sinphi = Math.sin(this.lat0);
	          this.sinb1 = qsfnz(this.e, sinphi) / this.qp;
	          this.cosb1 = Math.sqrt(1 - this.sinb1 * this.sinb1);
	          this.dd = Math.cos(this.lat0) / (Math.sqrt(1 - this.es * sinphi * sinphi) * this.rq * this.cosb1);
	          this.ymf = (this.xmf = this.rq) / this.dd;
	          this.xmf *= this.dd;
	          break;
	        }
	      }
	      else {
	        if (this.mode === this.OBLIQ) {
	          this.sinph0 = Math.sin(this.lat0);
	          this.cosph0 = Math.cos(this.lat0);
	        }
	      }
	    }
	
	    /* Lambert Azimuthal Equal Area forward equations--mapping lat,long to x,y
	      -----------------------------------------------------------------------*/
	    function forward$12(p) {
	
	      /* Forward equations
	          -----------------*/
	      var x, y, coslam, sinlam, sinphi, q, sinb, cosb, b, cosphi;
	      var lam = p.x;
	      var phi = p.y;
	
	      lam = adjust_lon(lam - this.long0);
	      if (this.sphere) {
	        sinphi = Math.sin(phi);
	        cosphi = Math.cos(phi);
	        coslam = Math.cos(lam);
	        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
	          y = (this.mode === this.EQUIT) ? 1 + cosphi * coslam : 1 + this.sinph0 * sinphi + this.cosph0 * cosphi * coslam;
	          if (y <= EPSLN) {
	            return null;
	          }
	          y = Math.sqrt(2 / y);
	          x = y * cosphi * Math.sin(lam);
	          y *= (this.mode === this.EQUIT) ? sinphi : this.cosph0 * sinphi - this.sinph0 * cosphi * coslam;
	        }
	        else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
	          if (this.mode === this.N_POLE) {
	            coslam = -coslam;
	          }
	          if (Math.abs(phi + this.lat0) < EPSLN) {
	            return null;
	          }
	          y = FORTPI - phi * 0.5;
	          y = 2 * ((this.mode === this.S_POLE) ? Math.cos(y) : Math.sin(y));
	          x = y * Math.sin(lam);
	          y *= coslam;
	        }
	      }
	      else {
	        sinb = 0;
	        cosb = 0;
	        b = 0;
	        coslam = Math.cos(lam);
	        sinlam = Math.sin(lam);
	        sinphi = Math.sin(phi);
	        q = qsfnz(this.e, sinphi);
	        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
	          sinb = q / this.qp;
	          cosb = Math.sqrt(1 - sinb * sinb);
	        }
	        switch (this.mode) {
	        case this.OBLIQ:
	          b = 1 + this.sinb1 * sinb + this.cosb1 * cosb * coslam;
	          break;
	        case this.EQUIT:
	          b = 1 + cosb * coslam;
	          break;
	        case this.N_POLE:
	          b = HALF_PI + phi;
	          q = this.qp - q;
	          break;
	        case this.S_POLE:
	          b = phi - HALF_PI;
	          q = this.qp + q;
	          break;
	        }
	        if (Math.abs(b) < EPSLN) {
	          return null;
	        }
	        switch (this.mode) {
	        case this.OBLIQ:
	        case this.EQUIT:
	          b = Math.sqrt(2 / b);
	          if (this.mode === this.OBLIQ) {
	            y = this.ymf * b * (this.cosb1 * sinb - this.sinb1 * cosb * coslam);
	          }
	          else {
	            y = (b = Math.sqrt(2 / (1 + cosb * coslam))) * sinb * this.ymf;
	          }
	          x = this.xmf * b * cosb * sinlam;
	          break;
	        case this.N_POLE:
	        case this.S_POLE:
	          if (q >= 0) {
	            x = (b = Math.sqrt(q)) * sinlam;
	            y = coslam * ((this.mode === this.S_POLE) ? b : -b);
	          }
	          else {
	            x = y = 0;
	          }
	          break;
	        }
	      }
	
	      p.x = this.a * x + this.x0;
	      p.y = this.a * y + this.y0;
	      return p;
	    }
	
	    /* Inverse equations
	      -----------------*/
	    function inverse$12(p) {
	      p.x -= this.x0;
	      p.y -= this.y0;
	      var x = p.x / this.a;
	      var y = p.y / this.a;
	      var lam, phi, cCe, sCe, q, rho, ab;
	      if (this.sphere) {
	        var cosz = 0,
	          rh, sinz = 0;
	
	        rh = Math.sqrt(x * x + y * y);
	        phi = rh * 0.5;
	        if (phi > 1) {
	          return null;
	        }
	        phi = 2 * Math.asin(phi);
	        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
	          sinz = Math.sin(phi);
	          cosz = Math.cos(phi);
	        }
	        switch (this.mode) {
	        case this.EQUIT:
	          phi = (Math.abs(rh) <= EPSLN) ? 0 : Math.asin(y * sinz / rh);
	          x *= sinz;
	          y = cosz * rh;
	          break;
	        case this.OBLIQ:
	          phi = (Math.abs(rh) <= EPSLN) ? this.lat0 : Math.asin(cosz * this.sinph0 + y * sinz * this.cosph0 / rh);
	          x *= sinz * this.cosph0;
	          y = (cosz - Math.sin(phi) * this.sinph0) * rh;
	          break;
	        case this.N_POLE:
	          y = -y;
	          phi = HALF_PI - phi;
	          break;
	        case this.S_POLE:
	          phi -= HALF_PI;
	          break;
	        }
	        lam = (y === 0 && (this.mode === this.EQUIT || this.mode === this.OBLIQ)) ? 0 : Math.atan2(x, y);
	      }
	      else {
	        ab = 0;
	        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
	          x /= this.dd;
	          y *= this.dd;
	          rho = Math.sqrt(x * x + y * y);
	          if (rho < EPSLN) {
	            p.x = this.long0;
	            p.y = this.lat0;
	            return p;
	          }
	          sCe = 2 * Math.asin(0.5 * rho / this.rq);
	          cCe = Math.cos(sCe);
	          x *= (sCe = Math.sin(sCe));
	          if (this.mode === this.OBLIQ) {
	            ab = cCe * this.sinb1 + y * sCe * this.cosb1 / rho;
	            q = this.qp * ab;
	            y = rho * this.cosb1 * cCe - y * this.sinb1 * sCe;
	          }
	          else {
	            ab = y * sCe / rho;
	            q = this.qp * ab;
	            y = rho * cCe;
	          }
	        }
	        else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
	          if (this.mode === this.N_POLE) {
	            y = -y;
	          }
	          q = (x * x + y * y);
	          if (!q) {
	            p.x = this.long0;
	            p.y = this.lat0;
	            return p;
	          }
	          ab = 1 - q / this.qp;
	          if (this.mode === this.S_POLE) {
	            ab = -ab;
	          }
	        }
	        lam = Math.atan2(x, y);
	        phi = authlat(Math.asin(ab), this.apa);
	      }
	
	      p.x = adjust_lon(this.long0 + lam);
	      p.y = phi;
	      return p;
	    }
	
	    /* determine latitude from authalic latitude */
	    var P00 = 0.33333333333333333333;
	
	    var P01 = 0.17222222222222222222;
	    var P02 = 0.10257936507936507936;
	    var P10 = 0.06388888888888888888;
	    var P11 = 0.06640211640211640211;
	    var P20 = 0.01641501294219154443;
	
	    function authset(es) {
	      var t;
	      var APA = [];
	      APA[0] = es * P00;
	      t = es * es;
	      APA[0] += t * P01;
	      APA[1] = t * P10;
	      t *= es;
	      APA[0] += t * P02;
	      APA[1] += t * P11;
	      APA[2] = t * P20;
	      return APA;
	    }
	
	    function authlat(beta, APA) {
	      var t = beta + beta;
	      return (beta + APA[0] * Math.sin(t) + APA[1] * Math.sin(t + t) + APA[2] * Math.sin(t + t + t));
	    }
	
	    var names$14 = ["Lambert Azimuthal Equal Area", "Lambert_Azimuthal_Equal_Area", "laea"];
	    var laea = {
	      init: init$13,
	      forward: forward$12,
	      inverse: inverse$12,
	      names: names$14,
	      S_POLE: S_POLE,
	      N_POLE: N_POLE,
	      EQUIT: EQUIT,
	      OBLIQ: OBLIQ
	    };
	
	    var asinz = function(x) {
	      if (Math.abs(x) > 1) {
	        x = (x > 1) ? 1 : -1;
	      }
	      return Math.asin(x);
	    };
	
	    function init$14() {
	
	      if (Math.abs(this.lat1 + this.lat2) < EPSLN) {
	        return;
	      }
	      this.temp = this.b / this.a;
	      this.es = 1 - Math.pow(this.temp, 2);
	      this.e3 = Math.sqrt(this.es);
	
	      this.sin_po = Math.sin(this.lat1);
	      this.cos_po = Math.cos(this.lat1);
	      this.t1 = this.sin_po;
	      this.con = this.sin_po;
	      this.ms1 = msfnz(this.e3, this.sin_po, this.cos_po);
	      this.qs1 = qsfnz(this.e3, this.sin_po, this.cos_po);
	
	      this.sin_po = Math.sin(this.lat2);
	      this.cos_po = Math.cos(this.lat2);
	      this.t2 = this.sin_po;
	      this.ms2 = msfnz(this.e3, this.sin_po, this.cos_po);
	      this.qs2 = qsfnz(this.e3, this.sin_po, this.cos_po);
	
	      this.sin_po = Math.sin(this.lat0);
	      this.cos_po = Math.cos(this.lat0);
	      this.t3 = this.sin_po;
	      this.qs0 = qsfnz(this.e3, this.sin_po, this.cos_po);
	
	      if (Math.abs(this.lat1 - this.lat2) > EPSLN) {
	        this.ns0 = (this.ms1 * this.ms1 - this.ms2 * this.ms2) / (this.qs2 - this.qs1);
	      }
	      else {
	        this.ns0 = this.con;
	      }
	      this.c = this.ms1 * this.ms1 + this.ns0 * this.qs1;
	      this.rh = this.a * Math.sqrt(this.c - this.ns0 * this.qs0) / this.ns0;
	    }
	
	    /* Albers Conical Equal Area forward equations--mapping lat,long to x,y
	      -------------------------------------------------------------------*/
	    function forward$13(p) {
	
	      var lon = p.x;
	      var lat = p.y;
	
	      this.sin_phi = Math.sin(lat);
	      this.cos_phi = Math.cos(lat);
	
	      var qs = qsfnz(this.e3, this.sin_phi, this.cos_phi);
	      var rh1 = this.a * Math.sqrt(this.c - this.ns0 * qs) / this.ns0;
	      var theta = this.ns0 * adjust_lon(lon - this.long0);
	      var x = rh1 * Math.sin(theta) + this.x0;
	      var y = this.rh - rh1 * Math.cos(theta) + this.y0;
	
	      p.x = x;
	      p.y = y;
	      return p;
	    }
	
	    function inverse$13(p) {
	      var rh1, qs, con, theta, lon, lat;
	
	      p.x -= this.x0;
	      p.y = this.rh - p.y + this.y0;
	      if (this.ns0 >= 0) {
	        rh1 = Math.sqrt(p.x * p.x + p.y * p.y);
	        con = 1;
	      }
	      else {
	        rh1 = -Math.sqrt(p.x * p.x + p.y * p.y);
	        con = -1;
	      }
	      theta = 0;
	      if (rh1 !== 0) {
	        theta = Math.atan2(con * p.x, con * p.y);
	      }
	      con = rh1 * this.ns0 / this.a;
	      if (this.sphere) {
	        lat = Math.asin((this.c - con * con) / (2 * this.ns0));
	      }
	      else {
	        qs = (this.c - con * con) / this.ns0;
	        lat = this.phi1z(this.e3, qs);
	      }
	
	      lon = adjust_lon(theta / this.ns0 + this.long0);
	      p.x = lon;
	      p.y = lat;
	      return p;
	    }
	
	    /* Function to compute phi1, the latitude for the inverse of the
	       Albers Conical Equal-Area projection.
	    -------------------------------------------*/
	    function phi1z(eccent, qs) {
	      var sinphi, cosphi, con, com, dphi;
	      var phi = asinz(0.5 * qs);
	      if (eccent < EPSLN) {
	        return phi;
	      }
	
	      var eccnts = eccent * eccent;
	      for (var i = 1; i <= 25; i++) {
	        sinphi = Math.sin(phi);
	        cosphi = Math.cos(phi);
	        con = eccent * sinphi;
	        com = 1 - con * con;
	        dphi = 0.5 * com * com / cosphi * (qs / (1 - eccnts) - sinphi / com + 0.5 / eccent * Math.log((1 - con) / (1 + con)));
	        phi = phi + dphi;
	        if (Math.abs(dphi) <= 1e-7) {
	          return phi;
	        }
	      }
	      return null;
	    }
	
	    var names$15 = ["Albers_Conic_Equal_Area", "Albers", "aea"];
	    var aea = {
	      init: init$14,
	      forward: forward$13,
	      inverse: inverse$13,
	      names: names$15,
	      phi1z: phi1z
	    };
	
	    /*
	      reference:
	        Wolfram Mathworld "Gnomonic Projection"
	        http://mathworld.wolfram.com/GnomonicProjection.html
	        Accessed: 12th November 2009
	      */
	    function init$15() {
	
	      /* Place parameters in static storage for common use
	          -------------------------------------------------*/
	      this.sin_p14 = Math.sin(this.lat0);
	      this.cos_p14 = Math.cos(this.lat0);
	      // Approximation for projecting points to the horizon (infinity)
	      this.infinity_dist = 1000 * this.a;
	      this.rc = 1;
	    }
	
	    /* Gnomonic forward equations--mapping lat,long to x,y
	        ---------------------------------------------------*/
	    function forward$14(p) {
	      var sinphi, cosphi; /* sin and cos value        */
	      var dlon; /* delta longitude value      */
	      var coslon; /* cos of longitude        */
	      var ksp; /* scale factor          */
	      var g;
	      var x, y;
	      var lon = p.x;
	      var lat = p.y;
	      /* Forward equations
	          -----------------*/
	      dlon = adjust_lon(lon - this.long0);
	
	      sinphi = Math.sin(lat);
	      cosphi = Math.cos(lat);
	
	      coslon = Math.cos(dlon);
	      g = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
	      ksp = 1;
	      if ((g > 0) || (Math.abs(g) <= EPSLN)) {
	        x = this.x0 + this.a * ksp * cosphi * Math.sin(dlon) / g;
	        y = this.y0 + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon) / g;
	      }
	      else {
	
	        // Point is in the opposing hemisphere and is unprojectable
	        // We still need to return a reasonable point, so we project
	        // to infinity, on a bearing
	        // equivalent to the northern hemisphere equivalent
	        // This is a reasonable approximation for short shapes and lines that
	        // straddle the horizon.
	
	        x = this.x0 + this.infinity_dist * cosphi * Math.sin(dlon);
	        y = this.y0 + this.infinity_dist * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);
	
	      }
	      p.x = x;
	      p.y = y;
	      return p;
	    }
	
	    function inverse$14(p) {
	      var rh; /* Rho */
	      var sinc, cosc;
	      var c;
	      var lon, lat;
	
	      /* Inverse equations
	          -----------------*/
	      p.x = (p.x - this.x0) / this.a;
	      p.y = (p.y - this.y0) / this.a;
	
	      p.x /= this.k0;
	      p.y /= this.k0;
	
	      if ((rh = Math.sqrt(p.x * p.x + p.y * p.y))) {
	        c = Math.atan2(rh, this.rc);
	        sinc = Math.sin(c);
	        cosc = Math.cos(c);
	
	        lat = asinz(cosc * this.sin_p14 + (p.y * sinc * this.cos_p14) / rh);
	        lon = Math.atan2(p.x * sinc, rh * this.cos_p14 * cosc - p.y * this.sin_p14 * sinc);
	        lon = adjust_lon(this.long0 + lon);
	      }
	      else {
	        lat = this.phic0;
	        lon = 0;
	      }
	
	      p.x = lon;
	      p.y = lat;
	      return p;
	    }
	
	    var names$16 = ["gnom"];
	    var gnom = {
	      init: init$15,
	      forward: forward$14,
	      inverse: inverse$14,
	      names: names$16
	    };
	
	    var iqsfnz = function(eccent, q) {
	      var temp = 1 - (1 - eccent * eccent) / (2 * eccent) * Math.log((1 - eccent) / (1 + eccent));
	      if (Math.abs(Math.abs(q) - temp) < 1.0E-6) {
	        if (q < 0) {
	          return (-1 * HALF_PI);
	        }
	        else {
	          return HALF_PI;
	        }
	      }
	      //var phi = 0.5* q/(1-eccent*eccent);
	      var phi = Math.asin(0.5 * q);
	      var dphi;
	      var sin_phi;
	      var cos_phi;
	      var con;
	      for (var i = 0; i < 30; i++) {
	        sin_phi = Math.sin(phi);
	        cos_phi = Math.cos(phi);
	        con = eccent * sin_phi;
	        dphi = Math.pow(1 - con * con, 2) / (2 * cos_phi) * (q / (1 - eccent * eccent) - sin_phi / (1 - con * con) + 0.5 / eccent * Math.log((1 - con) / (1 + con)));
	        phi += dphi;
	        if (Math.abs(dphi) <= 0.0000000001) {
	          return phi;
	        }
	      }
	
	      //console.log("IQSFN-CONV:Latitude failed to converge after 30 iterations");
	      return NaN;
	    };
	
	    /*
	      reference:
	        "Cartographic Projection Procedures for the UNIX Environment-
	        A User's Manual" by Gerald I. Evenden,
	        USGS Open File Report 90-284and Release 4 Interim Reports (2003)
	    */
	    function init$16() {
	      //no-op
	      if (!this.sphere) {
	        this.k0 = msfnz(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
	      }
	    }
	
	    /* Cylindrical Equal Area forward equations--mapping lat,long to x,y
	        ------------------------------------------------------------*/
	    function forward$15(p) {
	      var lon = p.x;
	      var lat = p.y;
	      var x, y;
	      /* Forward equations
	          -----------------*/
	      var dlon = adjust_lon(lon - this.long0);
	      if (this.sphere) {
	        x = this.x0 + this.a * dlon * Math.cos(this.lat_ts);
	        y = this.y0 + this.a * Math.sin(lat) / Math.cos(this.lat_ts);
	      }
	      else {
	        var qs = qsfnz(this.e, Math.sin(lat));
	        x = this.x0 + this.a * this.k0 * dlon;
	        y = this.y0 + this.a * qs * 0.5 / this.k0;
	      }
	
	      p.x = x;
	      p.y = y;
	      return p;
	    }
	
	    /* Cylindrical Equal Area inverse equations--mapping x,y to lat/long
	        ------------------------------------------------------------*/
	    function inverse$15(p) {
	      p.x -= this.x0;
	      p.y -= this.y0;
	      var lon, lat;
	
	      if (this.sphere) {
	        lon = adjust_lon(this.long0 + (p.x / this.a) / Math.cos(this.lat_ts));
	        lat = Math.asin((p.y / this.a) * Math.cos(this.lat_ts));
	      }
	      else {
	        lat = iqsfnz(this.e, 2 * p.y * this.k0 / this.a);
	        lon = adjust_lon(this.long0 + p.x / (this.a * this.k0));
	      }
	
	      p.x = lon;
	      p.y = lat;
	      return p;
	    }
	
	    var names$17 = ["cea"];
	    var cea = {
	      init: init$16,
	      forward: forward$15,
	      inverse: inverse$15,
	      names: names$17
	    };
	
	    function init$17() {
	
	      this.x0 = this.x0 || 0;
	      this.y0 = this.y0 || 0;
	      this.lat0 = this.lat0 || 0;
	      this.long0 = this.long0 || 0;
	      this.lat_ts = this.lat_ts || 0;
	      this.title = this.title || "Equidistant Cylindrical (Plate Carre)";
	
	      this.rc = Math.cos(this.lat_ts);
	    }
	
	    // forward equations--mapping lat,long to x,y
	    // -----------------------------------------------------------------
	    function forward$16(p) {
	
	      var lon = p.x;
	      var lat = p.y;
	
	      var dlon = adjust_lon(lon - this.long0);
	      var dlat = adjust_lat(lat - this.lat0);
	      p.x = this.x0 + (this.a * dlon * this.rc);
	      p.y = this.y0 + (this.a * dlat);
	      return p;
	    }
	
	    // inverse equations--mapping x,y to lat/long
	    // -----------------------------------------------------------------
	    function inverse$16(p) {
	
	      var x = p.x;
	      var y = p.y;
	
	      p.x = adjust_lon(this.long0 + ((x - this.x0) / (this.a * this.rc)));
	      p.y = adjust_lat(this.lat0 + ((y - this.y0) / (this.a)));
	      return p;
	    }
	
	    var names$18 = ["Equirectangular", "Equidistant_Cylindrical", "eqc"];
	    var eqc = {
	      init: init$17,
	      forward: forward$16,
	      inverse: inverse$16,
	      names: names$18
	    };
	
	    var MAX_ITER$2 = 20;
	
	    function init$18() {
	      /* Place parameters in static storage for common use
	          -------------------------------------------------*/
	      this.temp = this.b / this.a;
	      this.es = 1 - Math.pow(this.temp, 2); // devait etre dans tmerc.js mais n y est pas donc je commente sinon retour de valeurs nulles
	      this.e = Math.sqrt(this.es);
	      this.e0 = e0fn(this.es);
	      this.e1 = e1fn(this.es);
	      this.e2 = e2fn(this.es);
	      this.e3 = e3fn(this.es);
	      this.ml0 = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, this.lat0); //si que des zeros le calcul ne se fait pas
	    }
	
	    /* Polyconic forward equations--mapping lat,long to x,y
	        ---------------------------------------------------*/
	    function forward$17(p) {
	      var lon = p.x;
	      var lat = p.y;
	      var x, y, el;
	      var dlon = adjust_lon(lon - this.long0);
	      el = dlon * Math.sin(lat);
	      if (this.sphere) {
	        if (Math.abs(lat) <= EPSLN) {
	          x = this.a * dlon;
	          y = -1 * this.a * this.lat0;
	        }
	        else {
	          x = this.a * Math.sin(el) / Math.tan(lat);
	          y = this.a * (adjust_lat(lat - this.lat0) + (1 - Math.cos(el)) / Math.tan(lat));
	        }
	      }
	      else {
	        if (Math.abs(lat) <= EPSLN) {
	          x = this.a * dlon;
	          y = -1 * this.ml0;
	        }
	        else {
	          var nl = gN(this.a, this.e, Math.sin(lat)) / Math.tan(lat);
	          x = nl * Math.sin(el);
	          y = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, lat) - this.ml0 + nl * (1 - Math.cos(el));
	        }
	
	      }
	      p.x = x + this.x0;
	      p.y = y + this.y0;
	      return p;
	    }
	
	    /* Inverse equations
	      -----------------*/
	    function inverse$17(p) {
	      var lon, lat, x, y, i;
	      var al, bl;
	      var phi, dphi;
	      x = p.x - this.x0;
	      y = p.y - this.y0;
	
	      if (this.sphere) {
	        if (Math.abs(y + this.a * this.lat0) <= EPSLN) {
	          lon = adjust_lon(x / this.a + this.long0);
	          lat = 0;
	        }
	        else {
	          al = this.lat0 + y / this.a;
	          bl = x * x / this.a / this.a + al * al;
	          phi = al;
	          var tanphi;
	          for (i = MAX_ITER$2; i; --i) {
	            tanphi = Math.tan(phi);
	            dphi = -1 * (al * (phi * tanphi + 1) - phi - 0.5 * (phi * phi + bl) * tanphi) / ((phi - al) / tanphi - 1);
	            phi += dphi;
	            if (Math.abs(dphi) <= EPSLN) {
	              lat = phi;
	              break;
	            }
	          }
	          lon = adjust_lon(this.long0 + (Math.asin(x * Math.tan(phi) / this.a)) / Math.sin(lat));
	        }
	      }
	      else {
	        if (Math.abs(y + this.ml0) <= EPSLN) {
	          lat = 0;
	          lon = adjust_lon(this.long0 + x / this.a);
	        }
	        else {
	
	          al = (this.ml0 + y) / this.a;
	          bl = x * x / this.a / this.a + al * al;
	          phi = al;
	          var cl, mln, mlnp, ma;
	          var con;
	          for (i = MAX_ITER$2; i; --i) {
	            con = this.e * Math.sin(phi);
	            cl = Math.sqrt(1 - con * con) * Math.tan(phi);
	            mln = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, phi);
	            mlnp = this.e0 - 2 * this.e1 * Math.cos(2 * phi) + 4 * this.e2 * Math.cos(4 * phi) - 6 * this.e3 * Math.cos(6 * phi);
	            ma = mln / this.a;
	            dphi = (al * (cl * ma + 1) - ma - 0.5 * cl * (ma * ma + bl)) / (this.es * Math.sin(2 * phi) * (ma * ma + bl - 2 * al * ma) / (4 * cl) + (al - ma) * (cl * mlnp - 2 / Math.sin(2 * phi)) - mlnp);
	            phi -= dphi;
	            if (Math.abs(dphi) <= EPSLN) {
	              lat = phi;
	              break;
	            }
	          }
	
	          //lat=phi4z(this.e,this.e0,this.e1,this.e2,this.e3,al,bl,0,0);
	          cl = Math.sqrt(1 - this.es * Math.pow(Math.sin(lat), 2)) * Math.tan(lat);
	          lon = adjust_lon(this.long0 + Math.asin(x * cl / this.a) / Math.sin(lat));
	        }
	      }
	
	      p.x = lon;
	      p.y = lat;
	      return p;
	    }
	
	    var names$19 = ["Polyconic", "poly"];
	    var poly = {
	      init: init$18,
	      forward: forward$17,
	      inverse: inverse$17,
	      names: names$19
	    };
	
	    /*
	      reference
	        Department of Land and Survey Technical Circular 1973/32
	          http://www.linz.govt.nz/docs/miscellaneous/nz-map-definition.pdf
	        OSG Technical Report 4.1
	          http://www.linz.govt.nz/docs/miscellaneous/nzmg.pdf
	      */
	
	    /**
	     * iterations: Number of iterations to refine inverse transform.
	     *     0 -> km accuracy
	     *     1 -> m accuracy -- suitable for most mapping applications
	     *     2 -> mm accuracy
	     */
	
	
	    function init$19() {
	      this.A = [];
	      this.A[1] = 0.6399175073;
	      this.A[2] = -0.1358797613;
	      this.A[3] = 0.063294409;
	      this.A[4] = -0.02526853;
	      this.A[5] = 0.0117879;
	      this.A[6] = -0.0055161;
	      this.A[7] = 0.0026906;
	      this.A[8] = -0.001333;
	      this.A[9] = 0.00067;
	      this.A[10] = -0.00034;
	
	      this.B_re = [];
	      this.B_im = [];
	      this.B_re[1] = 0.7557853228;
	      this.B_im[1] = 0;
	      this.B_re[2] = 0.249204646;
	      this.B_im[2] = 0.003371507;
	      this.B_re[3] = -0.001541739;
	      this.B_im[3] = 0.041058560;
	      this.B_re[4] = -0.10162907;
	      this.B_im[4] = 0.01727609;
	      this.B_re[5] = -0.26623489;
	      this.B_im[5] = -0.36249218;
	      this.B_re[6] = -0.6870983;
	      this.B_im[6] = -1.1651967;
	
	      this.C_re = [];
	      this.C_im = [];
	      this.C_re[1] = 1.3231270439;
	      this.C_im[1] = 0;
	      this.C_re[2] = -0.577245789;
	      this.C_im[2] = -0.007809598;
	      this.C_re[3] = 0.508307513;
	      this.C_im[3] = -0.112208952;
	      this.C_re[4] = -0.15094762;
	      this.C_im[4] = 0.18200602;
	      this.C_re[5] = 1.01418179;
	      this.C_im[5] = 1.64497696;
	      this.C_re[6] = 1.9660549;
	      this.C_im[6] = 2.5127645;
	
	      this.D = [];
	      this.D[1] = 1.5627014243;
	      this.D[2] = 0.5185406398;
	      this.D[3] = -0.03333098;
	      this.D[4] = -0.1052906;
	      this.D[5] = -0.0368594;
	      this.D[6] = 0.007317;
	      this.D[7] = 0.01220;
	      this.D[8] = 0.00394;
	      this.D[9] = -0.0013;
	    }
	
	    /**
	        New Zealand Map Grid Forward  - long/lat to x/y
	        long/lat in radians
	      */
	    function forward$18(p) {
	      var n;
	      var lon = p.x;
	      var lat = p.y;
	
	      var delta_lat = lat - this.lat0;
	      var delta_lon = lon - this.long0;
	
	      // 1. Calculate d_phi and d_psi    ...                          // and d_lambda
	      // For this algorithm, delta_latitude is in seconds of arc x 10-5, so we need to scale to those units. Longitude is radians.
	      var d_phi = delta_lat / SEC_TO_RAD * 1E-5;
	      var d_lambda = delta_lon;
	      var d_phi_n = 1; // d_phi^0
	
	      var d_psi = 0;
	      for (n = 1; n <= 10; n++) {
	        d_phi_n = d_phi_n * d_phi;
	        d_psi = d_psi + this.A[n] * d_phi_n;
	      }
	
	      // 2. Calculate theta
	      var th_re = d_psi;
	      var th_im = d_lambda;
	
	      // 3. Calculate z
	      var th_n_re = 1;
	      var th_n_im = 0; // theta^0
	      var th_n_re1;
	      var th_n_im1;
	
	      var z_re = 0;
	      var z_im = 0;
	      for (n = 1; n <= 6; n++) {
	        th_n_re1 = th_n_re * th_re - th_n_im * th_im;
	        th_n_im1 = th_n_im * th_re + th_n_re * th_im;
	        th_n_re = th_n_re1;
	        th_n_im = th_n_im1;
	        z_re = z_re + this.B_re[n] * th_n_re - this.B_im[n] * th_n_im;
	        z_im = z_im + this.B_im[n] * th_n_re + this.B_re[n] * th_n_im;
	      }
	
	      // 4. Calculate easting and northing
	      p.x = (z_im * this.a) + this.x0;
	      p.y = (z_re * this.a) + this.y0;
	
	      return p;
	    }
	
	    /**
	        New Zealand Map Grid Inverse  -  x/y to long/lat
	      */
	    function inverse$18(p) {
	      var n;
	      var x = p.x;
	      var y = p.y;
	
	      var delta_x = x - this.x0;
	      var delta_y = y - this.y0;
	
	      // 1. Calculate z
	      var z_re = delta_y / this.a;
	      var z_im = delta_x / this.a;
	
	      // 2a. Calculate theta - first approximation gives km accuracy
	      var z_n_re = 1;
	      var z_n_im = 0; // z^0
	      var z_n_re1;
	      var z_n_im1;
	
	      var th_re = 0;
	      var th_im = 0;
	      for (n = 1; n <= 6; n++) {
	        z_n_re1 = z_n_re * z_re - z_n_im * z_im;
	        z_n_im1 = z_n_im * z_re + z_n_re * z_im;
	        z_n_re = z_n_re1;
	        z_n_im = z_n_im1;
	        th_re = th_re + this.C_re[n] * z_n_re - this.C_im[n] * z_n_im;
	        th_im = th_im + this.C_im[n] * z_n_re + this.C_re[n] * z_n_im;
	      }
	
	      // 2b. Iterate to refine the accuracy of the calculation
	      //        0 iterations gives km accuracy
	      //        1 iteration gives m accuracy -- good enough for most mapping applications
	      //        2 iterations bives mm accuracy
	      for (var i = 0; i < this.iterations; i++) {
	        var th_n_re = th_re;
	        var th_n_im = th_im;
	        var th_n_re1;
	        var th_n_im1;
	
	        var num_re = z_re;
	        var num_im = z_im;
	        for (n = 2; n <= 6; n++) {
	          th_n_re1 = th_n_re * th_re - th_n_im * th_im;
	          th_n_im1 = th_n_im * th_re + th_n_re * th_im;
	          th_n_re = th_n_re1;
	          th_n_im = th_n_im1;
	          num_re = num_re + (n - 1) * (this.B_re[n] * th_n_re - this.B_im[n] * th_n_im);
	          num_im = num_im + (n - 1) * (this.B_im[n] * th_n_re + this.B_re[n] * th_n_im);
	        }
	
	        th_n_re = 1;
	        th_n_im = 0;
	        var den_re = this.B_re[1];
	        var den_im = this.B_im[1];
	        for (n = 2; n <= 6; n++) {
	          th_n_re1 = th_n_re * th_re - th_n_im * th_im;
	          th_n_im1 = th_n_im * th_re + th_n_re * th_im;
	          th_n_re = th_n_re1;
	          th_n_im = th_n_im1;
	          den_re = den_re + n * (this.B_re[n] * th_n_re - this.B_im[n] * th_n_im);
	          den_im = den_im + n * (this.B_im[n] * th_n_re + this.B_re[n] * th_n_im);
	        }
	
	        // Complex division
	        var den2 = den_re * den_re + den_im * den_im;
	        th_re = (num_re * den_re + num_im * den_im) / den2;
	        th_im = (num_im * den_re - num_re * den_im) / den2;
	      }
	
	      // 3. Calculate d_phi              ...                                    // and d_lambda
	      var d_psi = th_re;
	      var d_lambda = th_im;
	      var d_psi_n = 1; // d_psi^0
	
	      var d_phi = 0;
	      for (n = 1; n <= 9; n++) {
	        d_psi_n = d_psi_n * d_psi;
	        d_phi = d_phi + this.D[n] * d_psi_n;
	      }
	
	      // 4. Calculate latitude and longitude
	      // d_phi is calcuated in second of arc * 10^-5, so we need to scale back to radians. d_lambda is in radians.
	      var lat = this.lat0 + (d_phi * SEC_TO_RAD * 1E5);
	      var lon = this.long0 + d_lambda;
	
	      p.x = lon;
	      p.y = lat;
	
	      return p;
	    }
	
	    var names$20 = ["New_Zealand_Map_Grid", "nzmg"];
	    var nzmg = {
	      init: init$19,
	      forward: forward$18,
	      inverse: inverse$18,
	      names: names$20
	    };
	
	    /*
	      reference
	        "New Equal-Area Map Projections for Noncircular Regions", John P. Snyder,
	        The American Cartographer, Vol 15, No. 4, October 1988, pp. 341-355.
	      */
	
	
	    /* Initialize the Miller Cylindrical projection
	      -------------------------------------------*/
	    function init$20() {
	      //no-op
	    }
	
	    /* Miller Cylindrical forward equations--mapping lat,long to x,y
	        ------------------------------------------------------------*/
	    function forward$19(p) {
	      var lon = p.x;
	      var lat = p.y;
	      /* Forward equations
	          -----------------*/
	      var dlon = adjust_lon(lon - this.long0);
	      var x = this.x0 + this.a * dlon;
	      var y = this.y0 + this.a * Math.log(Math.tan((Math.PI / 4) + (lat / 2.5))) * 1.25;
	
	      p.x = x;
	      p.y = y;
	      return p;
	    }
	
	    /* Miller Cylindrical inverse equations--mapping x,y to lat/long
	        ------------------------------------------------------------*/
	    function inverse$19(p) {
	      p.x -= this.x0;
	      p.y -= this.y0;
	
	      var lon = adjust_lon(this.long0 + p.x / this.a);
	      var lat = 2.5 * (Math.atan(Math.exp(0.8 * p.y / this.a)) - Math.PI / 4);
	
	      p.x = lon;
	      p.y = lat;
	      return p;
	    }
	
	    var names$21 = ["Miller_Cylindrical", "mill"];
	    var mill = {
	      init: init$20,
	      forward: forward$19,
	      inverse: inverse$19,
	      names: names$21
	    };
	
	    var MAX_ITER$3 = 20;
	    function init$21() {
	      /* Place parameters in static storage for common use
	        -------------------------------------------------*/
	
	
	      if (!this.sphere) {
	        this.en = pj_enfn(this.es);
	      }
	      else {
	        this.n = 1;
	        this.m = 0;
	        this.es = 0;
	        this.C_y = Math.sqrt((this.m + 1) / this.n);
	        this.C_x = this.C_y / (this.m + 1);
	      }
	
	    }
	
	    /* Sinusoidal forward equations--mapping lat,long to x,y
	      -----------------------------------------------------*/
	    function forward$20(p) {
	      var x, y;
	      var lon = p.x;
	      var lat = p.y;
	      /* Forward equations
	        -----------------*/
	      lon = adjust_lon(lon - this.long0);
	
	      if (this.sphere) {
	        if (!this.m) {
	          lat = this.n !== 1 ? Math.asin(this.n * Math.sin(lat)) : lat;
	        }
	        else {
	          var k = this.n * Math.sin(lat);
	          for (var i = MAX_ITER$3; i; --i) {
	            var V = (this.m * lat + Math.sin(lat) - k) / (this.m + Math.cos(lat));
	            lat -= V;
	            if (Math.abs(V) < EPSLN) {
	              break;
	            }
	          }
	        }
	        x = this.a * this.C_x * lon * (this.m + Math.cos(lat));
	        y = this.a * this.C_y * lat;
	
	      }
	      else {
	
	        var s = Math.sin(lat);
	        var c = Math.cos(lat);
	        y = this.a * pj_mlfn(lat, s, c, this.en);
	        x = this.a * lon * c / Math.sqrt(1 - this.es * s * s);
	      }
	
	      p.x = x;
	      p.y = y;
	      return p;
	    }
	
	    function inverse$20(p) {
	      var lat, temp, lon, s;
	
	      p.x -= this.x0;
	      lon = p.x / this.a;
	      p.y -= this.y0;
	      lat = p.y / this.a;
	
	      if (this.sphere) {
	        lat /= this.C_y;
	        lon = lon / (this.C_x * (this.m + Math.cos(lat)));
	        if (this.m) {
	          lat = asinz((this.m * lat + Math.sin(lat)) / this.n);
	        }
	        else if (this.n !== 1) {
	          lat = asinz(Math.sin(lat) / this.n);
	        }
	        lon = adjust_lon(lon + this.long0);
	        lat = adjust_lat(lat);
	      }
	      else {
	        lat = pj_inv_mlfn(p.y / this.a, this.es, this.en);
	        s = Math.abs(lat);
	        if (s < HALF_PI) {
	          s = Math.sin(lat);
	          temp = this.long0 + p.x * Math.sqrt(1 - this.es * s * s) / (this.a * Math.cos(lat));
	          //temp = this.long0 + p.x / (this.a * Math.cos(lat));
	          lon = adjust_lon(temp);
	        }
	        else if ((s - EPSLN) < HALF_PI) {
	          lon = this.long0;
	        }
	      }
	      p.x = lon;
	      p.y = lat;
	      return p;
	    }
	
	    var names$22 = ["Sinusoidal", "sinu"];
	    var sinu = {
	      init: init$21,
	      forward: forward$20,
	      inverse: inverse$20,
	      names: names$22
	    };
	
	    function init$22() {}
	    /* Mollweide forward equations--mapping lat,long to x,y
	        ----------------------------------------------------*/
	    function forward$21(p) {
	
	      /* Forward equations
	          -----------------*/
	      var lon = p.x;
	      var lat = p.y;
	
	      var delta_lon = adjust_lon(lon - this.long0);
	      var theta = lat;
	      var con = Math.PI * Math.sin(lat);
	
	      /* Iterate using the Newton-Raphson method to find theta
	          -----------------------------------------------------*/
	      while (true) {
	        var delta_theta = -(theta + Math.sin(theta) - con) / (1 + Math.cos(theta));
	        theta += delta_theta;
	        if (Math.abs(delta_theta) < EPSLN) {
	          break;
	        }
	      }
	      theta /= 2;
	
	      /* If the latitude is 90 deg, force the x coordinate to be "0 + false easting"
	           this is done here because of precision problems with "cos(theta)"
	           --------------------------------------------------------------------------*/
	      if (Math.PI / 2 - Math.abs(lat) < EPSLN) {
	        delta_lon = 0;
	      }
	      var x = 0.900316316158 * this.a * delta_lon * Math.cos(theta) + this.x0;
	      var y = 1.4142135623731 * this.a * Math.sin(theta) + this.y0;
	
	      p.x = x;
	      p.y = y;
	      return p;
	    }
	
	    function inverse$21(p) {
	      var theta;
	      var arg;
	
	      /* Inverse equations
	          -----------------*/
	      p.x -= this.x0;
	      p.y -= this.y0;
	      arg = p.y / (1.4142135623731 * this.a);
	
	      /* Because of division by zero problems, 'arg' can not be 1.  Therefore
	           a number very close to one is used instead.
	           -------------------------------------------------------------------*/
	      if (Math.abs(arg) > 0.999999999999) {
	        arg = 0.999999999999;
	      }
	      theta = Math.asin(arg);
	      var lon = adjust_lon(this.long0 + (p.x / (0.900316316158 * this.a * Math.cos(theta))));
	      if (lon < (-Math.PI)) {
	        lon = -Math.PI;
	      }
	      if (lon > Math.PI) {
	        lon = Math.PI;
	      }
	      arg = (2 * theta + Math.sin(2 * theta)) / Math.PI;
	      if (Math.abs(arg) > 1) {
	        arg = 1;
	      }
	      var lat = Math.asin(arg);
	
	      p.x = lon;
	      p.y = lat;
	      return p;
	    }
	
	    var names$23 = ["Mollweide", "moll"];
	    var moll = {
	      init: init$22,
	      forward: forward$21,
	      inverse: inverse$21,
	      names: names$23
	    };
	
	    function init$23() {
	
	      /* Place parameters in static storage for common use
	          -------------------------------------------------*/
	      // Standard Parallels cannot be equal and on opposite sides of the equator
	      if (Math.abs(this.lat1 + this.lat2) < EPSLN) {
	        return;
	      }
	      this.lat2 = this.lat2 || this.lat1;
	      this.temp = this.b / this.a;
	      this.es = 1 - Math.pow(this.temp, 2);
	      this.e = Math.sqrt(this.es);
	      this.e0 = e0fn(this.es);
	      this.e1 = e1fn(this.es);
	      this.e2 = e2fn(this.es);
	      this.e3 = e3fn(this.es);
	
	      this.sinphi = Math.sin(this.lat1);
	      this.cosphi = Math.cos(this.lat1);
	
	      this.ms1 = msfnz(this.e, this.sinphi, this.cosphi);
	      this.ml1 = mlfn(this.e0, this.e1, this.e2, this.e3, this.lat1);
	
	      if (Math.abs(this.lat1 - this.lat2) < EPSLN) {
	        this.ns = this.sinphi;
	      }
	      else {
	        this.sinphi = Math.sin(this.lat2);
	        this.cosphi = Math.cos(this.lat2);
	        this.ms2 = msfnz(this.e, this.sinphi, this.cosphi);
	        this.ml2 = mlfn(this.e0, this.e1, this.e2, this.e3, this.lat2);
	        this.ns = (this.ms1 - this.ms2) / (this.ml2 - this.ml1);
	      }
	      this.g = this.ml1 + this.ms1 / this.ns;
	      this.ml0 = mlfn(this.e0, this.e1, this.e2, this.e3, this.lat0);
	      this.rh = this.a * (this.g - this.ml0);
	    }
	
	    /* Equidistant Conic forward equations--mapping lat,long to x,y
	      -----------------------------------------------------------*/
	    function forward$22(p) {
	      var lon = p.x;
	      var lat = p.y;
	      var rh1;
	
	      /* Forward equations
	          -----------------*/
	      if (this.sphere) {
	        rh1 = this.a * (this.g - lat);
	      }
	      else {
	        var ml = mlfn(this.e0, this.e1, this.e2, this.e3, lat);
	        rh1 = this.a * (this.g - ml);
	      }
	      var theta = this.ns * adjust_lon(lon - this.long0);
	      var x = this.x0 + rh1 * Math.sin(theta);
	      var y = this.y0 + this.rh - rh1 * Math.cos(theta);
	      p.x = x;
	      p.y = y;
	      return p;
	    }
	
	    /* Inverse equations
	      -----------------*/
	    function inverse$22(p) {
	      p.x -= this.x0;
	      p.y = this.rh - p.y + this.y0;
	      var con, rh1, lat, lon;
	      if (this.ns >= 0) {
	        rh1 = Math.sqrt(p.x * p.x + p.y * p.y);
	        con = 1;
	      }
	      else {
	        rh1 = -Math.sqrt(p.x * p.x + p.y * p.y);
	        con = -1;
	      }
	      var theta = 0;
	      if (rh1 !== 0) {
	        theta = Math.atan2(con * p.x, con * p.y);
	      }
	
	      if (this.sphere) {
	        lon = adjust_lon(this.long0 + theta / this.ns);
	        lat = adjust_lat(this.g - rh1 / this.a);
	        p.x = lon;
	        p.y = lat;
	        return p;
	      }
	      else {
	        var ml = this.g - rh1 / this.a;
	        lat = imlfn(ml, this.e0, this.e1, this.e2, this.e3);
	        lon = adjust_lon(this.long0 + theta / this.ns);
	        p.x = lon;
	        p.y = lat;
	        return p;
	      }
	
	    }
	
	    var names$24 = ["Equidistant_Conic", "eqdc"];
	    var eqdc = {
	      init: init$23,
	      forward: forward$22,
	      inverse: inverse$22,
	      names: names$24
	    };
	
	    /* Initialize the Van Der Grinten projection
	      ----------------------------------------*/
	    function init$24() {
	      //this.R = 6370997; //Radius of earth
	      this.R = this.a;
	    }
	
	    function forward$23(p) {
	
	      var lon = p.x;
	      var lat = p.y;
	
	      /* Forward equations
	        -----------------*/
	      var dlon = adjust_lon(lon - this.long0);
	      var x, y;
	
	      if (Math.abs(lat) <= EPSLN) {
	        x = this.x0 + this.R * dlon;
	        y = this.y0;
	      }
	      var theta = asinz(2 * Math.abs(lat / Math.PI));
	      if ((Math.abs(dlon) <= EPSLN) || (Math.abs(Math.abs(lat) - HALF_PI) <= EPSLN)) {
	        x = this.x0;
	        if (lat >= 0) {
	          y = this.y0 + Math.PI * this.R * Math.tan(0.5 * theta);
	        }
	        else {
	          y = this.y0 + Math.PI * this.R * -Math.tan(0.5 * theta);
	        }
	        //  return(OK);
	      }
	      var al = 0.5 * Math.abs((Math.PI / dlon) - (dlon / Math.PI));
	      var asq = al * al;
	      var sinth = Math.sin(theta);
	      var costh = Math.cos(theta);
	
	      var g = costh / (sinth + costh - 1);
	      var gsq = g * g;
	      var m = g * (2 / sinth - 1);
	      var msq = m * m;
	      var con = Math.PI * this.R * (al * (g - msq) + Math.sqrt(asq * (g - msq) * (g - msq) - (msq + asq) * (gsq - msq))) / (msq + asq);
	      if (dlon < 0) {
	        con = -con;
	      }
	      x = this.x0 + con;
	      //con = Math.abs(con / (Math.PI * this.R));
	      var q = asq + g;
	      con = Math.PI * this.R * (m * q - al * Math.sqrt((msq + asq) * (asq + 1) - q * q)) / (msq + asq);
	      if (lat >= 0) {
	        //y = this.y0 + Math.PI * this.R * Math.sqrt(1 - con * con - 2 * al * con);
	        y = this.y0 + con;
	      }
	      else {
	        //y = this.y0 - Math.PI * this.R * Math.sqrt(1 - con * con - 2 * al * con);
	        y = this.y0 - con;
	      }
	      p.x = x;
	      p.y = y;
	      return p;
	    }
	
	    /* Van Der Grinten inverse equations--mapping x,y to lat/long
	      ---------------------------------------------------------*/
	    function inverse$23(p) {
	      var lon, lat;
	      var xx, yy, xys, c1, c2, c3;
	      var a1;
	      var m1;
	      var con;
	      var th1;
	      var d;
	
	      /* inverse equations
	        -----------------*/
	      p.x -= this.x0;
	      p.y -= this.y0;
	      con = Math.PI * this.R;
	      xx = p.x / con;
	      yy = p.y / con;
	      xys = xx * xx + yy * yy;
	      c1 = -Math.abs(yy) * (1 + xys);
	      c2 = c1 - 2 * yy * yy + xx * xx;
	      c3 = -2 * c1 + 1 + 2 * yy * yy + xys * xys;
	      d = yy * yy / c3 + (2 * c2 * c2 * c2 / c3 / c3 / c3 - 9 * c1 * c2 / c3 / c3) / 27;
	      a1 = (c1 - c2 * c2 / 3 / c3) / c3;
	      m1 = 2 * Math.sqrt(-a1 / 3);
	      con = ((3 * d) / a1) / m1;
	      if (Math.abs(con) > 1) {
	        if (con >= 0) {
	          con = 1;
	        }
	        else {
	          con = -1;
	        }
	      }
	      th1 = Math.acos(con) / 3;
	      if (p.y >= 0) {
	        lat = (-m1 * Math.cos(th1 + Math.PI / 3) - c2 / 3 / c3) * Math.PI;
	      }
	      else {
	        lat = -(-m1 * Math.cos(th1 + Math.PI / 3) - c2 / 3 / c3) * Math.PI;
	      }
	
	      if (Math.abs(xx) < EPSLN) {
	        lon = this.long0;
	      }
	      else {
	        lon = adjust_lon(this.long0 + Math.PI * (xys - 1 + Math.sqrt(1 + 2 * (xx * xx - yy * yy) + xys * xys)) / 2 / xx);
	      }
	
	      p.x = lon;
	      p.y = lat;
	      return p;
	    }
	
	    var names$25 = ["Van_der_Grinten_I", "VanDerGrinten", "vandg"];
	    var vandg = {
	      init: init$24,
	      forward: forward$23,
	      inverse: inverse$23,
	      names: names$25
	    };
	
	    function init$25() {
	      this.sin_p12 = Math.sin(this.lat0);
	      this.cos_p12 = Math.cos(this.lat0);
	    }
	
	    function forward$24(p) {
	      var lon = p.x;
	      var lat = p.y;
	      var sinphi = Math.sin(p.y);
	      var cosphi = Math.cos(p.y);
	      var dlon = adjust_lon(lon - this.long0);
	      var e0, e1, e2, e3, Mlp, Ml, tanphi, Nl1, Nl, psi, Az, G, H, GH, Hs, c, kp, cos_c, s, s2, s3, s4, s5;
	      if (this.sphere) {
	        if (Math.abs(this.sin_p12 - 1) <= EPSLN) {
	          //North Pole case
	          p.x = this.x0 + this.a * (HALF_PI - lat) * Math.sin(dlon);
	          p.y = this.y0 - this.a * (HALF_PI - lat) * Math.cos(dlon);
	          return p;
	        }
	        else if (Math.abs(this.sin_p12 + 1) <= EPSLN) {
	          //South Pole case
	          p.x = this.x0 + this.a * (HALF_PI + lat) * Math.sin(dlon);
	          p.y = this.y0 + this.a * (HALF_PI + lat) * Math.cos(dlon);
	          return p;
	        }
	        else {
	          //default case
	          cos_c = this.sin_p12 * sinphi + this.cos_p12 * cosphi * Math.cos(dlon);
	          c = Math.acos(cos_c);
	          kp = c ? c / Math.sin(c) : 1;
	          p.x = this.x0 + this.a * kp * cosphi * Math.sin(dlon);
	          p.y = this.y0 + this.a * kp * (this.cos_p12 * sinphi - this.sin_p12 * cosphi * Math.cos(dlon));
	          return p;
	        }
	      }
	      else {
	        e0 = e0fn(this.es);
	        e1 = e1fn(this.es);
	        e2 = e2fn(this.es);
	        e3 = e3fn(this.es);
	        if (Math.abs(this.sin_p12 - 1) <= EPSLN) {
	          //North Pole case
	          Mlp = this.a * mlfn(e0, e1, e2, e3, HALF_PI);
	          Ml = this.a * mlfn(e0, e1, e2, e3, lat);
	          p.x = this.x0 + (Mlp - Ml) * Math.sin(dlon);
	          p.y = this.y0 - (Mlp - Ml) * Math.cos(dlon);
	          return p;
	        }
	        else if (Math.abs(this.sin_p12 + 1) <= EPSLN) {
	          //South Pole case
	          Mlp = this.a * mlfn(e0, e1, e2, e3, HALF_PI);
	          Ml = this.a * mlfn(e0, e1, e2, e3, lat);
	          p.x = this.x0 + (Mlp + Ml) * Math.sin(dlon);
	          p.y = this.y0 + (Mlp + Ml) * Math.cos(dlon);
	          return p;
	        }
	        else {
	          //Default case
	          tanphi = sinphi / cosphi;
	          Nl1 = gN(this.a, this.e, this.sin_p12);
	          Nl = gN(this.a, this.e, sinphi);
	          psi = Math.atan((1 - this.es) * tanphi + this.es * Nl1 * this.sin_p12 / (Nl * cosphi));
	          Az = Math.atan2(Math.sin(dlon), this.cos_p12 * Math.tan(psi) - this.sin_p12 * Math.cos(dlon));
	          if (Az === 0) {
	            s = Math.asin(this.cos_p12 * Math.sin(psi) - this.sin_p12 * Math.cos(psi));
	          }
	          else if (Math.abs(Math.abs(Az) - Math.PI) <= EPSLN) {
	            s = -Math.asin(this.cos_p12 * Math.sin(psi) - this.sin_p12 * Math.cos(psi));
	          }
	          else {
	            s = Math.asin(Math.sin(dlon) * Math.cos(psi) / Math.sin(Az));
	          }
	          G = this.e * this.sin_p12 / Math.sqrt(1 - this.es);
	          H = this.e * this.cos_p12 * Math.cos(Az) / Math.sqrt(1 - this.es);
	          GH = G * H;
	          Hs = H * H;
	          s2 = s * s;
	          s3 = s2 * s;
	          s4 = s3 * s;
	          s5 = s4 * s;
	          c = Nl1 * s * (1 - s2 * Hs * (1 - Hs) / 6 + s3 / 8 * GH * (1 - 2 * Hs) + s4 / 120 * (Hs * (4 - 7 * Hs) - 3 * G * G * (1 - 7 * Hs)) - s5 / 48 * GH);
	          p.x = this.x0 + c * Math.sin(Az);
	          p.y = this.y0 + c * Math.cos(Az);
	          return p;
	        }
	      }
	
	
	    }
	
	    function inverse$24(p) {
	      p.x -= this.x0;
	      p.y -= this.y0;
	      var rh, z, sinz, cosz, lon, lat, con, e0, e1, e2, e3, Mlp, M, N1, psi, Az, cosAz, tmp, A, B, D, Ee, F, sinpsi;
	      if (this.sphere) {
	        rh = Math.sqrt(p.x * p.x + p.y * p.y);
	        if (rh > (2 * HALF_PI * this.a)) {
	          return;
	        }
	        z = rh / this.a;
	
	        sinz = Math.sin(z);
	        cosz = Math.cos(z);
	
	        lon = this.long0;
	        if (Math.abs(rh) <= EPSLN) {
	          lat = this.lat0;
	        }
	        else {
	          lat = asinz(cosz * this.sin_p12 + (p.y * sinz * this.cos_p12) / rh);
	          con = Math.abs(this.lat0) - HALF_PI;
	          if (Math.abs(con) <= EPSLN) {
	            if (this.lat0 >= 0) {
	              lon = adjust_lon(this.long0 + Math.atan2(p.x, - p.y));
	            }
	            else {
	              lon = adjust_lon(this.long0 - Math.atan2(-p.x, p.y));
	            }
	          }
	          else {
	            /*con = cosz - this.sin_p12 * Math.sin(lat);
	            if ((Math.abs(con) < EPSLN) && (Math.abs(p.x) < EPSLN)) {
	              //no-op, just keep the lon value as is
	            } else {
	              var temp = Math.atan2((p.x * sinz * this.cos_p12), (con * rh));
	              lon = adjust_lon(this.long0 + Math.atan2((p.x * sinz * this.cos_p12), (con * rh)));
	            }*/
	            lon = adjust_lon(this.long0 + Math.atan2(p.x * sinz, rh * this.cos_p12 * cosz - p.y * this.sin_p12 * sinz));
	          }
	        }
	
	        p.x = lon;
	        p.y = lat;
	        return p;
	      }
	      else {
	        e0 = e0fn(this.es);
	        e1 = e1fn(this.es);
	        e2 = e2fn(this.es);
	        e3 = e3fn(this.es);
	        if (Math.abs(this.sin_p12 - 1) <= EPSLN) {
	          //North pole case
	          Mlp = this.a * mlfn(e0, e1, e2, e3, HALF_PI);
	          rh = Math.sqrt(p.x * p.x + p.y * p.y);
	          M = Mlp - rh;
	          lat = imlfn(M / this.a, e0, e1, e2, e3);
	          lon = adjust_lon(this.long0 + Math.atan2(p.x, - 1 * p.y));
	          p.x = lon;
	          p.y = lat;
	          return p;
	        }
	        else if (Math.abs(this.sin_p12 + 1) <= EPSLN) {
	          //South pole case
	          Mlp = this.a * mlfn(e0, e1, e2, e3, HALF_PI);
	          rh = Math.sqrt(p.x * p.x + p.y * p.y);
	          M = rh - Mlp;
	
	          lat = imlfn(M / this.a, e0, e1, e2, e3);
	          lon = adjust_lon(this.long0 + Math.atan2(p.x, p.y));
	          p.x = lon;
	          p.y = lat;
	          return p;
	        }
	        else {
	          //default case
	          rh = Math.sqrt(p.x * p.x + p.y * p.y);
	          Az = Math.atan2(p.x, p.y);
	          N1 = gN(this.a, this.e, this.sin_p12);
	          cosAz = Math.cos(Az);
	          tmp = this.e * this.cos_p12 * cosAz;
	          A = -tmp * tmp / (1 - this.es);
	          B = 3 * this.es * (1 - A) * this.sin_p12 * this.cos_p12 * cosAz / (1 - this.es);
	          D = rh / N1;
	          Ee = D - A * (1 + A) * Math.pow(D, 3) / 6 - B * (1 + 3 * A) * Math.pow(D, 4) / 24;
	          F = 1 - A * Ee * Ee / 2 - D * Ee * Ee * Ee / 6;
	          psi = Math.asin(this.sin_p12 * Math.cos(Ee) + this.cos_p12 * Math.sin(Ee) * cosAz);
	          lon = adjust_lon(this.long0 + Math.asin(Math.sin(Az) * Math.sin(Ee) / Math.cos(psi)));
	          sinpsi = Math.sin(psi);
	          lat = Math.atan2((sinpsi - this.es * F * this.sin_p12) * Math.tan(psi), sinpsi * (1 - this.es));
	          p.x = lon;
	          p.y = lat;
	          return p;
	        }
	      }
	
	    }
	
	    var names$26 = ["Azimuthal_Equidistant", "aeqd"];
	    var aeqd = {
	      init: init$25,
	      forward: forward$24,
	      inverse: inverse$24,
	      names: names$26
	    };
	
	    function init$26() {
	      //double temp;      /* temporary variable    */
	
	      /* Place parameters in static storage for common use
	          -------------------------------------------------*/
	      this.sin_p14 = Math.sin(this.lat0);
	      this.cos_p14 = Math.cos(this.lat0);
	    }
	
	    /* Orthographic forward equations--mapping lat,long to x,y
	        ---------------------------------------------------*/
	    function forward$25(p) {
	      var sinphi, cosphi; /* sin and cos value        */
	      var dlon; /* delta longitude value      */
	      var coslon; /* cos of longitude        */
	      var ksp; /* scale factor          */
	      var g, x, y;
	      var lon = p.x;
	      var lat = p.y;
	      /* Forward equations
	          -----------------*/
	      dlon = adjust_lon(lon - this.long0);
	
	      sinphi = Math.sin(lat);
	      cosphi = Math.cos(lat);
	
	      coslon = Math.cos(dlon);
	      g = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
	      ksp = 1;
	      if ((g > 0) || (Math.abs(g) <= EPSLN)) {
	        x = this.a * ksp * cosphi * Math.sin(dlon);
	        y = this.y0 + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);
	      }
	      p.x = x;
	      p.y = y;
	      return p;
	    }
	
	    function inverse$25(p) {
	      var rh; /* height above ellipsoid      */
	      var z; /* angle          */
	      var sinz, cosz; /* sin of z and cos of z      */
	      var con;
	      var lon, lat;
	      /* Inverse equations
	          -----------------*/
	      p.x -= this.x0;
	      p.y -= this.y0;
	      rh = Math.sqrt(p.x * p.x + p.y * p.y);
	      z = asinz(rh / this.a);
	
	      sinz = Math.sin(z);
	      cosz = Math.cos(z);
	
	      lon = this.long0;
	      if (Math.abs(rh) <= EPSLN) {
	        lat = this.lat0;
	        p.x = lon;
	        p.y = lat;
	        return p;
	      }
	      lat = asinz(cosz * this.sin_p14 + (p.y * sinz * this.cos_p14) / rh);
	      con = Math.abs(this.lat0) - HALF_PI;
	      if (Math.abs(con) <= EPSLN) {
	        if (this.lat0 >= 0) {
	          lon = adjust_lon(this.long0 + Math.atan2(p.x, - p.y));
	        }
	        else {
	          lon = adjust_lon(this.long0 - Math.atan2(-p.x, p.y));
	        }
	        p.x = lon;
	        p.y = lat;
	        return p;
	      }
	      lon = adjust_lon(this.long0 + Math.atan2((p.x * sinz), rh * this.cos_p14 * cosz - p.y * this.sin_p14 * sinz));
	      p.x = lon;
	      p.y = lat;
	      return p;
	    }
	
	    var names$27 = ["ortho"];
	    var ortho = {
	      init: init$26,
	      forward: forward$25,
	      inverse: inverse$25,
	      names: names$27
	    };
	
	    // QSC projection rewritten from the original PROJ4
	    // https://github.com/OSGeo/proj.4/blob/master/src/PJ_qsc.c
	
	    /* constants */
	    var FACE_ENUM = {
	        FRONT: 1,
	        RIGHT: 2,
	        BACK: 3,
	        LEFT: 4,
	        TOP: 5,
	        BOTTOM: 6
	    };
	
	    var AREA_ENUM = {
	        AREA_0: 1,
	        AREA_1: 2,
	        AREA_2: 3,
	        AREA_3: 4
	    };
	
	    function init$27() {
	
	      this.x0 = this.x0 || 0;
	      this.y0 = this.y0 || 0;
	      this.lat0 = this.lat0 || 0;
	      this.long0 = this.long0 || 0;
	      this.lat_ts = this.lat_ts || 0;
	      this.title = this.title || "Quadrilateralized Spherical Cube";
	
	      /* Determine the cube face from the center of projection. */
	      if (this.lat0 >= HALF_PI - FORTPI / 2.0) {
	        this.face = FACE_ENUM.TOP;
	      } else if (this.lat0 <= -(HALF_PI - FORTPI / 2.0)) {
	        this.face = FACE_ENUM.BOTTOM;
	      } else if (Math.abs(this.long0) <= FORTPI) {
	        this.face = FACE_ENUM.FRONT;
	      } else if (Math.abs(this.long0) <= HALF_PI + FORTPI) {
	        this.face = this.long0 > 0.0 ? FACE_ENUM.RIGHT : FACE_ENUM.LEFT;
	      } else {
	        this.face = FACE_ENUM.BACK;
	      }
	
	      /* Fill in useful values for the ellipsoid <-> sphere shift
	       * described in [LK12]. */
	      if (this.es !== 0) {
	        this.one_minus_f = 1 - (this.a - this.b) / this.a;
	        this.one_minus_f_squared = this.one_minus_f * this.one_minus_f;
	      }
	    }
	
	    // QSC forward equations--mapping lat,long to x,y
	    // -----------------------------------------------------------------
	    function forward$26(p) {
	      var xy = {x: 0, y: 0};
	      var lat, lon;
	      var theta, phi;
	      var t, mu;
	      /* nu; */
	      var area = {value: 0};
	
	      // move lon according to projection's lon
	      p.x -= this.long0;
	
	      /* Convert the geodetic latitude to a geocentric latitude.
	       * This corresponds to the shift from the ellipsoid to the sphere
	       * described in [LK12]. */
	      if (this.es !== 0) {//if (P->es != 0) {
	        lat = Math.atan(this.one_minus_f_squared * Math.tan(p.y));
	      } else {
	        lat = p.y;
	      }
	
	      /* Convert the input lat, lon into theta, phi as used by QSC.
	       * This depends on the cube face and the area on it.
	       * For the top and bottom face, we can compute theta and phi
	       * directly from phi, lam. For the other faces, we must use
	       * unit sphere cartesian coordinates as an intermediate step. */
	      lon = p.x; //lon = lp.lam;
	      if (this.face === FACE_ENUM.TOP) {
	        phi = HALF_PI - lat;
	        if (lon >= FORTPI && lon <= HALF_PI + FORTPI) {
	          area.value = AREA_ENUM.AREA_0;
	          theta = lon - HALF_PI;
	        } else if (lon > HALF_PI + FORTPI || lon <= -(HALF_PI + FORTPI)) {
	          area.value = AREA_ENUM.AREA_1;
	          theta = (lon > 0.0 ? lon - SPI : lon + SPI);
	        } else if (lon > -(HALF_PI + FORTPI) && lon <= -FORTPI) {
	          area.value = AREA_ENUM.AREA_2;
	          theta = lon + HALF_PI;
	        } else {
	          area.value = AREA_ENUM.AREA_3;
	          theta = lon;
	        }
	      } else if (this.face === FACE_ENUM.BOTTOM) {
	        phi = HALF_PI + lat;
	        if (lon >= FORTPI && lon <= HALF_PI + FORTPI) {
	          area.value = AREA_ENUM.AREA_0;
	          theta = -lon + HALF_PI;
	        } else if (lon < FORTPI && lon >= -FORTPI) {
	          area.value = AREA_ENUM.AREA_1;
	          theta = -lon;
	        } else if (lon < -FORTPI && lon >= -(HALF_PI + FORTPI)) {
	          area.value = AREA_ENUM.AREA_2;
	          theta = -lon - HALF_PI;
	        } else {
	          area.value = AREA_ENUM.AREA_3;
	          theta = (lon > 0.0 ? -lon + SPI : -lon - SPI);
	        }
	      } else {
	        var q, r, s;
	        var sinlat, coslat;
	        var sinlon, coslon;
	
	        if (this.face === FACE_ENUM.RIGHT) {
	          lon = qsc_shift_lon_origin(lon, +HALF_PI);
	        } else if (this.face === FACE_ENUM.BACK) {
	          lon = qsc_shift_lon_origin(lon, +SPI);
	        } else if (this.face === FACE_ENUM.LEFT) {
	          lon = qsc_shift_lon_origin(lon, -HALF_PI);
	        }
	        sinlat = Math.sin(lat);
	        coslat = Math.cos(lat);
	        sinlon = Math.sin(lon);
	        coslon = Math.cos(lon);
	        q = coslat * coslon;
	        r = coslat * sinlon;
	        s = sinlat;
	
	        if (this.face === FACE_ENUM.FRONT) {
	          phi = Math.acos(q);
	          theta = qsc_fwd_equat_face_theta(phi, s, r, area);
	        } else if (this.face === FACE_ENUM.RIGHT) {
	          phi = Math.acos(r);
	          theta = qsc_fwd_equat_face_theta(phi, s, -q, area);
	        } else if (this.face === FACE_ENUM.BACK) {
	          phi = Math.acos(-q);
	          theta = qsc_fwd_equat_face_theta(phi, s, -r, area);
	        } else if (this.face === FACE_ENUM.LEFT) {
	          phi = Math.acos(-r);
	          theta = qsc_fwd_equat_face_theta(phi, s, q, area);
	        } else {
	          /* Impossible */
	          phi = theta = 0;
	          area.value = AREA_ENUM.AREA_0;
	        }
	      }
	
	      /* Compute mu and nu for the area of definition.
	       * For mu, see Eq. (3-21) in [OL76], but note the typos:
	       * compare with Eq. (3-14). For nu, see Eq. (3-38). */
	      mu = Math.atan((12 / SPI) * (theta + Math.acos(Math.sin(theta) * Math.cos(FORTPI)) - HALF_PI));
	      t = Math.sqrt((1 - Math.cos(phi)) / (Math.cos(mu) * Math.cos(mu)) / (1 - Math.cos(Math.atan(1 / Math.cos(theta)))));
	
	      /* Apply the result to the real area. */
	      if (area.value === AREA_ENUM.AREA_1) {
	        mu += HALF_PI;
	      } else if (area.value === AREA_ENUM.AREA_2) {
	        mu += SPI;
	      } else if (area.value === AREA_ENUM.AREA_3) {
	        mu += 1.5 * SPI;
	      }
	
	      /* Now compute x, y from mu and nu */
	      xy.x = t * Math.cos(mu);
	      xy.y = t * Math.sin(mu);
	      xy.x = xy.x * this.a + this.x0;
	      xy.y = xy.y * this.a + this.y0;
	
	      p.x = xy.x;
	      p.y = xy.y;
	      return p;
	    }
	
	    // QSC inverse equations--mapping x,y to lat/long
	    // -----------------------------------------------------------------
	    function inverse$26(p) {
	      var lp = {lam: 0, phi: 0};
	      var mu, nu, cosmu, tannu;
	      var tantheta, theta, cosphi, phi;
	      var t;
	      var area = {value: 0};
	
	      /* de-offset */
	      p.x = (p.x - this.x0) / this.a;
	      p.y = (p.y - this.y0) / this.a;
	
	      /* Convert the input x, y to the mu and nu angles as used by QSC.
	       * This depends on the area of the cube face. */
	      nu = Math.atan(Math.sqrt(p.x * p.x + p.y * p.y));
	      mu = Math.atan2(p.y, p.x);
	      if (p.x >= 0.0 && p.x >= Math.abs(p.y)) {
	        area.value = AREA_ENUM.AREA_0;
	      } else if (p.y >= 0.0 && p.y >= Math.abs(p.x)) {
	        area.value = AREA_ENUM.AREA_1;
	        mu -= HALF_PI;
	      } else if (p.x < 0.0 && -p.x >= Math.abs(p.y)) {
	        area.value = AREA_ENUM.AREA_2;
	        mu = (mu < 0.0 ? mu + SPI : mu - SPI);
	      } else {
	        area.value = AREA_ENUM.AREA_3;
	        mu += HALF_PI;
	      }
	
	      /* Compute phi and theta for the area of definition.
	       * The inverse projection is not described in the original paper, but some
	       * good hints can be found here (as of 2011-12-14):
	       * http://fits.gsfc.nasa.gov/fitsbits/saf.93/saf.9302
	       * (search for "Message-Id: <9302181759.AA25477 at fits.cv.nrao.edu>") */
	      t = (SPI / 12) * Math.tan(mu);
	      tantheta = Math.sin(t) / (Math.cos(t) - (1 / Math.sqrt(2)));
	      theta = Math.atan(tantheta);
	      cosmu = Math.cos(mu);
	      tannu = Math.tan(nu);
	      cosphi = 1 - cosmu * cosmu * tannu * tannu * (1 - Math.cos(Math.atan(1 / Math.cos(theta))));
	      if (cosphi < -1) {
	        cosphi = -1;
	      } else if (cosphi > +1) {
	        cosphi = +1;
	      }
	
	      /* Apply the result to the real area on the cube face.
	       * For the top and bottom face, we can compute phi and lam directly.
	       * For the other faces, we must use unit sphere cartesian coordinates
	       * as an intermediate step. */
	      if (this.face === FACE_ENUM.TOP) {
	        phi = Math.acos(cosphi);
	        lp.phi = HALF_PI - phi;
	        if (area.value === AREA_ENUM.AREA_0) {
	          lp.lam = theta + HALF_PI;
	        } else if (area.value === AREA_ENUM.AREA_1) {
	          lp.lam = (theta < 0.0 ? theta + SPI : theta - SPI);
	        } else if (area.value === AREA_ENUM.AREA_2) {
	          lp.lam = theta - HALF_PI;
	        } else /* area.value == AREA_ENUM.AREA_3 */ {
	          lp.lam = theta;
	        }
	      } else if (this.face === FACE_ENUM.BOTTOM) {
	        phi = Math.acos(cosphi);
	        lp.phi = phi - HALF_PI;
	        if (area.value === AREA_ENUM.AREA_0) {
	          lp.lam = -theta + HALF_PI;
	        } else if (area.value === AREA_ENUM.AREA_1) {
	          lp.lam = -theta;
	        } else if (area.value === AREA_ENUM.AREA_2) {
	          lp.lam = -theta - HALF_PI;
	        } else /* area.value == AREA_ENUM.AREA_3 */ {
	          lp.lam = (theta < 0.0 ? -theta - SPI : -theta + SPI);
	        }
	      } else {
	        /* Compute phi and lam via cartesian unit sphere coordinates. */
	        var q, r, s;
	        q = cosphi;
	        t = q * q;
	        if (t >= 1) {
	          s = 0;
	        } else {
	          s = Math.sqrt(1 - t) * Math.sin(theta);
	        }
	        t += s * s;
	        if (t >= 1) {
	          r = 0;
	        } else {
	          r = Math.sqrt(1 - t);
	        }
	        /* Rotate q,r,s into the correct area. */
	        if (area.value === AREA_ENUM.AREA_1) {
	          t = r;
	          r = -s;
	          s = t;
	        } else if (area.value === AREA_ENUM.AREA_2) {
	          r = -r;
	          s = -s;
	        } else if (area.value === AREA_ENUM.AREA_3) {
	          t = r;
	          r = s;
	          s = -t;
	        }
	        /* Rotate q,r,s into the correct cube face. */
	        if (this.face === FACE_ENUM.RIGHT) {
	          t = q;
	          q = -r;
	          r = t;
	        } else if (this.face === FACE_ENUM.BACK) {
	          q = -q;
	          r = -r;
	        } else if (this.face === FACE_ENUM.LEFT) {
	          t = q;
	          q = r;
	          r = -t;
	        }
	        /* Now compute phi and lam from the unit sphere coordinates. */
	        lp.phi = Math.acos(-s) - HALF_PI;
	        lp.lam = Math.atan2(r, q);
	        if (this.face === FACE_ENUM.RIGHT) {
	          lp.lam = qsc_shift_lon_origin(lp.lam, -HALF_PI);
	        } else if (this.face === FACE_ENUM.BACK) {
	          lp.lam = qsc_shift_lon_origin(lp.lam, -SPI);
	        } else if (this.face === FACE_ENUM.LEFT) {
	          lp.lam = qsc_shift_lon_origin(lp.lam, +HALF_PI);
	        }
	      }
	
	      /* Apply the shift from the sphere to the ellipsoid as described
	       * in [LK12]. */
	      if (this.es !== 0) {
	        var invert_sign;
	        var tanphi, xa;
	        invert_sign = (lp.phi < 0 ? 1 : 0);
	        tanphi = Math.tan(lp.phi);
	        xa = this.b / Math.sqrt(tanphi * tanphi + this.one_minus_f_squared);
	        lp.phi = Math.atan(Math.sqrt(this.a * this.a - xa * xa) / (this.one_minus_f * xa));
	        if (invert_sign) {
	          lp.phi = -lp.phi;
	        }
	      }
	
	      lp.lam += this.long0;
	      p.x = lp.lam;
	      p.y = lp.phi;
	      return p;
	    }
	
	    /* Helper function for forward projection: compute the theta angle
	     * and determine the area number. */
	    function qsc_fwd_equat_face_theta(phi, y, x, area) {
	      var theta;
	      if (phi < EPSLN) {
	        area.value = AREA_ENUM.AREA_0;
	        theta = 0.0;
	      } else {
	        theta = Math.atan2(y, x);
	        if (Math.abs(theta) <= FORTPI) {
	          area.value = AREA_ENUM.AREA_0;
	        } else if (theta > FORTPI && theta <= HALF_PI + FORTPI) {
	          area.value = AREA_ENUM.AREA_1;
	          theta -= HALF_PI;
	        } else if (theta > HALF_PI + FORTPI || theta <= -(HALF_PI + FORTPI)) {
	          area.value = AREA_ENUM.AREA_2;
	          theta = (theta >= 0.0 ? theta - SPI : theta + SPI);
	        } else {
	          area.value = AREA_ENUM.AREA_3;
	          theta += HALF_PI;
	        }
	      }
	      return theta;
	    }
	
	    /* Helper function: shift the longitude. */
	    function qsc_shift_lon_origin(lon, offset) {
	      var slon = lon + offset;
	      if (slon < -SPI) {
	        slon += TWO_PI;
	      } else if (slon > +SPI) {
	        slon -= TWO_PI;
	      }
	      return slon;
	    }
	
	    var names$28 = ["Quadrilateralized Spherical Cube", "Quadrilateralized_Spherical_Cube", "qsc"];
	    var qsc = {
	      init: init$27,
	      forward: forward$26,
	      inverse: inverse$26,
	      names: names$28
	    };
	
	    // Robinson projection
	    // Based on https://github.com/OSGeo/proj.4/blob/master/src/PJ_robin.c
	    // Polynomial coeficients from http://article.gmane.org/gmane.comp.gis.proj-4.devel/6039
	
	    var COEFS_X = [
	        [1.0000, 2.2199e-17, -7.15515e-05, 3.1103e-06],
	        [0.9986, -0.000482243, -2.4897e-05, -1.3309e-06],
	        [0.9954, -0.00083103, -4.48605e-05, -9.86701e-07],
	        [0.9900, -0.00135364, -5.9661e-05, 3.6777e-06],
	        [0.9822, -0.00167442, -4.49547e-06, -5.72411e-06],
	        [0.9730, -0.00214868, -9.03571e-05, 1.8736e-08],
	        [0.9600, -0.00305085, -9.00761e-05, 1.64917e-06],
	        [0.9427, -0.00382792, -6.53386e-05, -2.6154e-06],
	        [0.9216, -0.00467746, -0.00010457, 4.81243e-06],
	        [0.8962, -0.00536223, -3.23831e-05, -5.43432e-06],
	        [0.8679, -0.00609363, -0.000113898, 3.32484e-06],
	        [0.8350, -0.00698325, -6.40253e-05, 9.34959e-07],
	        [0.7986, -0.00755338, -5.00009e-05, 9.35324e-07],
	        [0.7597, -0.00798324, -3.5971e-05, -2.27626e-06],
	        [0.7186, -0.00851367, -7.01149e-05, -8.6303e-06],
	        [0.6732, -0.00986209, -0.000199569, 1.91974e-05],
	        [0.6213, -0.010418, 8.83923e-05, 6.24051e-06],
	        [0.5722, -0.00906601, 0.000182, 6.24051e-06],
	        [0.5322, -0.00677797, 0.000275608, 6.24051e-06]
	    ];
	
	    var COEFS_Y = [
	        [-5.20417e-18, 0.0124, 1.21431e-18, -8.45284e-11],
	        [0.0620, 0.0124, -1.26793e-09, 4.22642e-10],
	        [0.1240, 0.0124, 5.07171e-09, -1.60604e-09],
	        [0.1860, 0.0123999, -1.90189e-08, 6.00152e-09],
	        [0.2480, 0.0124002, 7.10039e-08, -2.24e-08],
	        [0.3100, 0.0123992, -2.64997e-07, 8.35986e-08],
	        [0.3720, 0.0124029, 9.88983e-07, -3.11994e-07],
	        [0.4340, 0.0123893, -3.69093e-06, -4.35621e-07],
	        [0.4958, 0.0123198, -1.02252e-05, -3.45523e-07],
	        [0.5571, 0.0121916, -1.54081e-05, -5.82288e-07],
	        [0.6176, 0.0119938, -2.41424e-05, -5.25327e-07],
	        [0.6769, 0.011713, -3.20223e-05, -5.16405e-07],
	        [0.7346, 0.0113541, -3.97684e-05, -6.09052e-07],
	        [0.7903, 0.0109107, -4.89042e-05, -1.04739e-06],
	        [0.8435, 0.0103431, -6.4615e-05, -1.40374e-09],
	        [0.8936, 0.00969686, -6.4636e-05, -8.547e-06],
	        [0.9394, 0.00840947, -0.000192841, -4.2106e-06],
	        [0.9761, 0.00616527, -0.000256, -4.2106e-06],
	        [1.0000, 0.00328947, -0.000319159, -4.2106e-06]
	    ];
	
	    var FXC = 0.8487;
	    var FYC = 1.3523;
	    var C1 = R2D/5; // rad to 5-degree interval
	    var RC1 = 1/C1;
	    var NODES = 18;
	
	    var poly3_val = function(coefs, x) {
	        return coefs[0] + x * (coefs[1] + x * (coefs[2] + x * coefs[3]));
	    };
	
	    var poly3_der = function(coefs, x) {
	        return coefs[1] + x * (2 * coefs[2] + x * 3 * coefs[3]);
	    };
	
	    function newton_rapshon(f_df, start, max_err, iters) {
	        var x = start;
	        for (; iters; --iters) {
	            var upd = f_df(x);
	            x -= upd;
	            if (Math.abs(upd) < max_err) {
	                break;
	            }
	        }
	        return x;
	    }
	
	    function init$28() {
	        this.x0 = this.x0 || 0;
	        this.y0 = this.y0 || 0;
	        this.long0 = this.long0 || 0;
	        this.es = 0;
	        this.title = this.title || "Robinson";
	    }
	
	    function forward$27(ll) {
	        var lon = adjust_lon(ll.x - this.long0);
	
	        var dphi = Math.abs(ll.y);
	        var i = Math.floor(dphi * C1);
	        if (i < 0) {
	            i = 0;
	        } else if (i >= NODES) {
	            i = NODES - 1;
	        }
	        dphi = R2D * (dphi - RC1 * i);
	        var xy = {
	            x: poly3_val(COEFS_X[i], dphi) * lon,
	            y: poly3_val(COEFS_Y[i], dphi)
	        };
	        if (ll.y < 0) {
	            xy.y = -xy.y;
	        }
	
	        xy.x = xy.x * this.a * FXC + this.x0;
	        xy.y = xy.y * this.a * FYC + this.y0;
	        return xy;
	    }
	
	    function inverse$27(xy) {
	        var ll = {
	            x: (xy.x - this.x0) / (this.a * FXC),
	            y: Math.abs(xy.y - this.y0) / (this.a * FYC)
	        };
	
	        if (ll.y >= 1) { // pathologic case
	            ll.x /= COEFS_X[NODES][0];
	            ll.y = xy.y < 0 ? -HALF_PI : HALF_PI;
	        } else {
	            // find table interval
	            var i = Math.floor(ll.y * NODES);
	            if (i < 0) {
	                i = 0;
	            } else if (i >= NODES) {
	                i = NODES - 1;
	            }
	            for (;;) {
	                if (COEFS_Y[i][0] > ll.y) {
	                    --i;
	                } else if (COEFS_Y[i+1][0] <= ll.y) {
	                    ++i;
	                } else {
	                    break;
	                }
	            }
	            // linear interpolation in 5 degree interval
	            var coefs = COEFS_Y[i];
	            var t = 5 * (ll.y - coefs[0]) / (COEFS_Y[i+1][0] - coefs[0]);
	            // find t so that poly3_val(coefs, t) = ll.y
	            t = newton_rapshon(function(x) {
	                return (poly3_val(coefs, x) - ll.y) / poly3_der(coefs, x);
	            }, t, EPSLN, 100);
	
	            ll.x /= poly3_val(COEFS_X[i], t);
	            ll.y = (5 * i + t) * D2R;
	            if (xy.y < 0) {
	                ll.y = -ll.y;
	            }
	        }
	
	        ll.x = adjust_lon(ll.x + this.long0);
	        return ll;
	    }
	
	    var names$29 = ["Robinson", "robin"];
	    var robin = {
	      init: init$28,
	      forward: forward$27,
	      inverse: inverse$27,
	      names: names$29
	    };
	
	    function init$29() {
	        this.name = 'geocent';
	
	    }
	
	    function forward$28(p) {
	        var point = geodeticToGeocentric(p, this.es, this.a);
	        return point;
	    }
	
	    function inverse$28(p) {
	        var point = geocentricToGeodetic(p, this.es, this.a, this.b);
	        return point;
	    }
	
	    var names$30 = ["Geocentric", 'geocentric', "geocent", "Geocent"];
	    var geocent = {
	        init: init$29,
	        forward: forward$28,
	        inverse: inverse$28,
	        names: names$30
	    };
	
	    var mode = {
	      N_POLE: 0,
	      S_POLE: 1,
	      EQUIT: 2,
	      OBLIQ: 3
	    };
	
	    var params = {
	      h:     { def: 100000, num: true },           // default is Karman line, no default in PROJ.7
	      azi:   { def: 0, num: true, degrees: true }, // default is North
	      tilt:  { def: 0, num: true, degrees: true }, // default is Nadir
	      long0: { def: 0, num: true },                // default is Greenwich, conversion to rad is automatic
	      lat0:  { def: 0, num: true }                 // default is Equator, conversion to rad is automatic
	    };
	
	    function init$30() {
	      Object.keys(params).forEach(function (p) {
	        if (typeof this[p] === "undefined") {
	          this[p] = params[p].def;
	        } else if (params[p].num && isNaN(this[p])) {
	          throw new Error("Invalid parameter value, must be numeric " + p + " = " + this[p]);
	        } else if (params[p].num) {
	          this[p] = parseFloat(this[p]);
	        }
	        if (params[p].degrees) {
	          this[p] = this[p] * D2R;
	        }
	      }.bind(this));
	
	      if (Math.abs((Math.abs(this.lat0) - HALF_PI)) < EPSLN) {
	        this.mode = this.lat0 < 0 ? mode.S_POLE : mode.N_POLE;
	      } else if (Math.abs(this.lat0) < EPSLN) {
	        this.mode = mode.EQUIT;
	      } else {
	        this.mode = mode.OBLIQ;
	        this.sinph0 = Math.sin(this.lat0);
	        this.cosph0 = Math.cos(this.lat0);
	      }
	
	      this.pn1 = this.h / this.a;  // Normalize relative to the Earth's radius
	
	      if (this.pn1 <= 0 || this.pn1 > 1e10) {
	        throw new Error("Invalid height");
	      }
	      
	      this.p = 1 + this.pn1;
	      this.rp = 1 / this.p;
	      this.h1 = 1 / this.pn1;
	      this.pfact = (this.p + 1) * this.h1;
	      this.es = 0;
	
	      var omega = this.tilt;
	      var gamma = this.azi;
	      this.cg = Math.cos(gamma);
	      this.sg = Math.sin(gamma);
	      this.cw = Math.cos(omega);
	      this.sw = Math.sin(omega);
	    }
	
	    function forward$29(p) {
	      p.x -= this.long0;
	      var sinphi = Math.sin(p.y);
	      var cosphi = Math.cos(p.y);
	      var coslam = Math.cos(p.x);
	      var x, y;
	      switch (this.mode) {
	        case mode.OBLIQ:
	          y = this.sinph0 * sinphi + this.cosph0 * cosphi * coslam;
	          break;
	        case mode.EQUIT:
	          y = cosphi * coslam;
	          break;
	        case mode.S_POLE:
	          y = -sinphi;
	          break;
	        case mode.N_POLE:
	          y = sinphi;
	          break;
	      }
	      y = this.pn1 / (this.p - y);
	      x = y * cosphi * Math.sin(p.x);
	
	      switch (this.mode) {
	        case mode.OBLIQ:
	          y *= this.cosph0 * sinphi - this.sinph0 * cosphi * coslam;
	          break;
	        case mode.EQUIT:
	          y *= sinphi;
	          break;
	        case mode.N_POLE:
	          y *= -(cosphi * coslam);
	          break;
	        case mode.S_POLE:
	          y *= cosphi * coslam;
	          break;
	      }
	
	      // Tilt 
	      var yt, ba;
	      yt = y * this.cg + x * this.sg;
	      ba = 1 / (yt * this.sw * this.h1 + this.cw);
	      x = (x * this.cg - y * this.sg) * this.cw * ba;
	      y = yt * ba;
	
	      p.x = x * this.a;
	      p.y = y * this.a;
	      return p;
	    }
	
	    function inverse$29(p) {
	      p.x /= this.a;
	      p.y /= this.a;
	      var r = { x: p.x, y: p.y };
	
	      // Un-Tilt
	      var bm, bq, yt;
	      yt = 1 / (this.pn1 - p.y * this.sw);
	      bm = this.pn1 * p.x * yt;
	      bq = this.pn1 * p.y * this.cw * yt;
	      p.x = bm * this.cg + bq * this.sg;
	      p.y = bq * this.cg - bm * this.sg;
	
	      var rh = hypot(p.x, p.y);
	      if (Math.abs(rh) < EPSLN) {
	        r.x = 0;
	        r.y = p.y;
	      } else {
	        var cosz, sinz;
	        sinz = 1 - rh * rh * this.pfact;
	        sinz = (this.p - Math.sqrt(sinz)) / (this.pn1 / rh + rh / this.pn1);
	        cosz = Math.sqrt(1 - sinz * sinz);
	        switch (this.mode) {
	          case mode.OBLIQ:
	            r.y = Math.asin(cosz * this.sinph0 + p.y * sinz * this.cosph0 / rh);
	            p.y = (cosz - this.sinph0 * Math.sin(r.y)) * rh;
	            p.x *= sinz * this.cosph0;
	            break;
	          case mode.EQUIT:
	            r.y = Math.asin(p.y * sinz / rh);
	            p.y = cosz * rh;
	            p.x *= sinz;
	            break;
	          case mode.N_POLE:
	            r.y = Math.asin(cosz);
	            p.y = -p.y;
	            break;
	          case mode.S_POLE:
	            r.y = -Math.asin(cosz);
	            break;
	        }
	        r.x = Math.atan2(p.x, p.y);
	      }
	
	      p.x = r.x + this.long0;
	      p.y = r.y;
	      return p;
	    }
	
	    var names$31 = ["Tilted_Perspective", "tpers"];
	    var tpers = {
	      init: init$30,
	      forward: forward$29,
	      inverse: inverse$29,
	      names: names$31
	    };
	
	    var includedProjections = function(proj4){
	      proj4.Proj.projections.add(tmerc);
	      proj4.Proj.projections.add(etmerc);
	      proj4.Proj.projections.add(utm);
	      proj4.Proj.projections.add(sterea);
	      proj4.Proj.projections.add(stere);
	      proj4.Proj.projections.add(somerc);
	      proj4.Proj.projections.add(omerc);
	      proj4.Proj.projections.add(lcc);
	      proj4.Proj.projections.add(krovak);
	      proj4.Proj.projections.add(cass);
	      proj4.Proj.projections.add(laea);
	      proj4.Proj.projections.add(aea);
	      proj4.Proj.projections.add(gnom);
	      proj4.Proj.projections.add(cea);
	      proj4.Proj.projections.add(eqc);
	      proj4.Proj.projections.add(poly);
	      proj4.Proj.projections.add(nzmg);
	      proj4.Proj.projections.add(mill);
	      proj4.Proj.projections.add(sinu);
	      proj4.Proj.projections.add(moll);
	      proj4.Proj.projections.add(eqdc);
	      proj4.Proj.projections.add(vandg);
	      proj4.Proj.projections.add(aeqd);
	      proj4.Proj.projections.add(ortho);
	      proj4.Proj.projections.add(qsc);
	      proj4.Proj.projections.add(robin);
	      proj4.Proj.projections.add(geocent);
	      proj4.Proj.projections.add(tpers);
	    };
	
	    proj4$1.defaultDatum = 'WGS84'; //default datum
	    proj4$1.Proj = Projection;
	    proj4$1.WGS84 = new proj4$1.Proj('WGS84');
	    proj4$1.Point = Point;
	    proj4$1.toPoint = toPoint;
	    proj4$1.defs = defs;
	    proj4$1.nadgrid = nadgrid;
	    proj4$1.transform = transform;
	    proj4$1.mgrs = mgrs;
	    proj4$1.version = '2.7.2';
	    includedProjections(proj4$1);
	
	    return proj4$1;
	
	})));


/***/ },
/* 1926 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	  var has = Function.call.bind(Object.prototype.hasOwnProperty);
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (false) {
	    loggedTypeFailures = {};
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 1927 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(955);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1928 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactIs = __webpack_require__(72);
	var assign = __webpack_require__(32);
	
	var ReactPropTypesSecret = __webpack_require__(955);
	var checkPropTypes = __webpack_require__(1926);
	
	var has = Function.call.bind(Object.prototype.hasOwnProperty);
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (false) {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1929 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(1073);
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		if (typeof str !== 'string') {
			return {};
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return {};
		}
	
		return str.split('&').reduce(function (ret, param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (!ret.hasOwnProperty(key)) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
	
			return ret;
		}, {});
	};
	
	exports.stringify = function (obj) {
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return key;
			}
	
			if (Array.isArray(val)) {
				return val.slice().sort().map(function (val2) {
					return strictUriEncode(key) + '=' + strictUriEncode(val2);
				}).join('&');
			}
	
			return strictUriEncode(key) + '=' + strictUriEncode(val);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 1930 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 1931 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1945);


/***/ },
/* 1932 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 1933 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(50);
	
	var focusNode = __webpack_require__(756);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 1934 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(278);
	var ExecutionEnvironment = __webpack_require__(74);
	var FallbackCompositionState = __webpack_require__(1940);
	var SyntheticCompositionEvent = __webpack_require__(1977);
	var SyntheticInputEvent = __webpack_require__(1980);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 1935 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(956);
	var ExecutionEnvironment = __webpack_require__(74);
	var ReactInstrumentation = __webpack_require__(94);
	
	var camelizeStyleName = __webpack_require__(755);
	var dangerousStyleValue = __webpack_require__(1986);
	var hyphenateStyleName = __webpack_require__(758);
	var memoizeStringOnly = __webpack_require__(759);
	var warning = __webpack_require__(34);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 1936 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(277);
	var EventPropagators = __webpack_require__(278);
	var ExecutionEnvironment = __webpack_require__(74);
	var ReactDOMComponentTree = __webpack_require__(50);
	var ReactUpdates = __webpack_require__(111);
	var SyntheticEvent = __webpack_require__(127);
	
	var inputValueTracking = __webpack_require__(972);
	var getEventTarget = __webpack_require__(509);
	var isEventSupported = __webpack_require__(510);
	var isTextInputElement = __webpack_require__(974);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 1937 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var DOMLazyTree = __webpack_require__(212);
	var ExecutionEnvironment = __webpack_require__(74);
	
	var createNodesFromMarkup = __webpack_require__(1733);
	var emptyFunction = __webpack_require__(107);
	var invariant = __webpack_require__(28);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ },
/* 1938 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 1939 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(278);
	var ReactDOMComponentTree = __webpack_require__(50);
	var SyntheticMouseEvent = __webpack_require__(362);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 1940 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(32);
	
	var PooledClass = __webpack_require__(178);
	
	var getTextContentAccessor = __webpack_require__(971);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 1941 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(213);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 1942 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(214);
	
	var instantiateReactComponent = __webpack_require__(973);
	var KeyEscapeUtils = __webpack_require__(501);
	var shouldUpdateReactComponent = __webpack_require__(511);
	var traverseAllChildren = __webpack_require__(976);
	var warning = __webpack_require__(34);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"."}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(985);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(360)))

/***/ },
/* 1943 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(497);
	var ReactDOMIDOperations = __webpack_require__(1950);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 1944 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37),
	    _assign = __webpack_require__(32);
	
	var React = __webpack_require__(216);
	var ReactComponentEnvironment = __webpack_require__(503);
	var ReactCurrentOwner = __webpack_require__(128);
	var ReactErrorUtils = __webpack_require__(504);
	var ReactInstanceMap = __webpack_require__(279);
	var ReactInstrumentation = __webpack_require__(94);
	var ReactNodeTypes = __webpack_require__(966);
	var ReactReconciler = __webpack_require__(214);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(477);
	var invariant = __webpack_require__(28);
	var shallowEqual = __webpack_require__(478);
	var shouldUpdateReactComponent = __webpack_require__(511);
	var warning = __webpack_require__(34);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 1945 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(50);
	var ReactDefaultInjection = __webpack_require__(1958);
	var ReactMount = __webpack_require__(965);
	var ReactReconciler = __webpack_require__(214);
	var ReactUpdates = __webpack_require__(111);
	var ReactVersion = __webpack_require__(1971);
	
	var findDOMNode = __webpack_require__(1987);
	var getHostComponentFromComposite = __webpack_require__(970);
	var renderSubtreeIntoContainer = __webpack_require__(1994);
	var warning = __webpack_require__(34);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 1946 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37),
	    _assign = __webpack_require__(32);
	
	var AutoFocusUtils = __webpack_require__(1933);
	var CSSPropertyOperations = __webpack_require__(1935);
	var DOMLazyTree = __webpack_require__(212);
	var DOMNamespaces = __webpack_require__(498);
	var DOMProperty = __webpack_require__(213);
	var DOMPropertyOperations = __webpack_require__(958);
	var EventPluginHub = __webpack_require__(277);
	var EventPluginRegistry = __webpack_require__(499);
	var ReactBrowserEventEmitter = __webpack_require__(361);
	var ReactDOMComponentFlags = __webpack_require__(959);
	var ReactDOMComponentTree = __webpack_require__(50);
	var ReactDOMInput = __webpack_require__(1951);
	var ReactDOMOption = __webpack_require__(1952);
	var ReactDOMSelect = __webpack_require__(960);
	var ReactDOMTextarea = __webpack_require__(1955);
	var ReactInstrumentation = __webpack_require__(94);
	var ReactMultiChild = __webpack_require__(1964);
	var ReactServerRenderingTransaction = __webpack_require__(1969);
	
	var emptyFunction = __webpack_require__(107);
	var escapeTextContentForBrowser = __webpack_require__(364);
	var invariant = __webpack_require__(28);
	var isEventSupported = __webpack_require__(510);
	var shallowEqual = __webpack_require__(478);
	var inputValueTracking = __webpack_require__(972);
	var validateDOMNesting = __webpack_require__(512);
	var warning = __webpack_require__(34);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 1947 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(512);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 1948 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(32);
	
	var DOMLazyTree = __webpack_require__(212);
	var ReactDOMComponentTree = __webpack_require__(50);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 1949 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 1950 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(497);
	var ReactDOMComponentTree = __webpack_require__(50);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 1951 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37),
	    _assign = __webpack_require__(32);
	
	var DOMPropertyOperations = __webpack_require__(958);
	var LinkedValueUtils = __webpack_require__(502);
	var ReactDOMComponentTree = __webpack_require__(50);
	var ReactUpdates = __webpack_require__(111);
	
	var invariant = __webpack_require__(28);
	var warning = __webpack_require__(34);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 1952 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(32);
	
	var React = __webpack_require__(216);
	var ReactDOMComponentTree = __webpack_require__(50);
	var ReactDOMSelect = __webpack_require__(960);
	
	var warning = __webpack_require__(34);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 1953 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(74);
	
	var getNodeForCharacterOffset = __webpack_require__(1991);
	var getTextContentAccessor = __webpack_require__(971);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 1954 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37),
	    _assign = __webpack_require__(32);
	
	var DOMChildrenOperations = __webpack_require__(497);
	var DOMLazyTree = __webpack_require__(212);
	var ReactDOMComponentTree = __webpack_require__(50);
	
	var escapeTextContentForBrowser = __webpack_require__(364);
	var invariant = __webpack_require__(28);
	var validateDOMNesting = __webpack_require__(512);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 1955 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37),
	    _assign = __webpack_require__(32);
	
	var LinkedValueUtils = __webpack_require__(502);
	var ReactDOMComponentTree = __webpack_require__(50);
	var ReactUpdates = __webpack_require__(111);
	
	var invariant = __webpack_require__(28);
	var warning = __webpack_require__(34);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 1956 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var invariant = __webpack_require__(28);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 1957 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(32);
	
	var ReactUpdates = __webpack_require__(111);
	var Transaction = __webpack_require__(363);
	
	var emptyFunction = __webpack_require__(107);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 1958 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(1932);
	var BeforeInputEventPlugin = __webpack_require__(1934);
	var ChangeEventPlugin = __webpack_require__(1936);
	var DefaultEventPluginOrder = __webpack_require__(1938);
	var EnterLeaveEventPlugin = __webpack_require__(1939);
	var HTMLDOMPropertyConfig = __webpack_require__(1941);
	var ReactComponentBrowserEnvironment = __webpack_require__(1943);
	var ReactDOMComponent = __webpack_require__(1946);
	var ReactDOMComponentTree = __webpack_require__(50);
	var ReactDOMEmptyComponent = __webpack_require__(1948);
	var ReactDOMTreeTraversal = __webpack_require__(1956);
	var ReactDOMTextComponent = __webpack_require__(1954);
	var ReactDefaultBatchingStrategy = __webpack_require__(1957);
	var ReactEventListener = __webpack_require__(1961);
	var ReactInjection = __webpack_require__(1962);
	var ReactReconcileTransaction = __webpack_require__(1967);
	var SVGDOMPropertyConfig = __webpack_require__(1972);
	var SelectEventPlugin = __webpack_require__(1973);
	var SimpleEventPlugin = __webpack_require__(1974);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 1959 */
986,
/* 1960 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(277);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 1961 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(32);
	
	var EventListener = __webpack_require__(754);
	var ExecutionEnvironment = __webpack_require__(74);
	var PooledClass = __webpack_require__(178);
	var ReactDOMComponentTree = __webpack_require__(50);
	var ReactUpdates = __webpack_require__(111);
	
	var getEventTarget = __webpack_require__(509);
	var getUnboundedScrollPosition = __webpack_require__(1735);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 1962 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(213);
	var EventPluginHub = __webpack_require__(277);
	var EventPluginUtils = __webpack_require__(500);
	var ReactComponentEnvironment = __webpack_require__(503);
	var ReactEmptyComponent = __webpack_require__(961);
	var ReactBrowserEventEmitter = __webpack_require__(361);
	var ReactHostComponent = __webpack_require__(963);
	var ReactUpdates = __webpack_require__(111);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 1963 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(1985);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 1964 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var ReactComponentEnvironment = __webpack_require__(503);
	var ReactInstanceMap = __webpack_require__(279);
	var ReactInstrumentation = __webpack_require__(94);
	
	var ReactCurrentOwner = __webpack_require__(128);
	var ReactReconciler = __webpack_require__(214);
	var ReactChildReconciler = __webpack_require__(1942);
	
	var emptyFunction = __webpack_require__(107);
	var flattenChildren = __webpack_require__(1988);
	var invariant = __webpack_require__(28);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 1965 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var invariant = __webpack_require__(28);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ },
/* 1966 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 1967 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(32);
	
	var CallbackQueue = __webpack_require__(957);
	var PooledClass = __webpack_require__(178);
	var ReactBrowserEventEmitter = __webpack_require__(361);
	var ReactInputSelection = __webpack_require__(964);
	var ReactInstrumentation = __webpack_require__(94);
	var Transaction = __webpack_require__(363);
	var ReactUpdateQueue = __webpack_require__(505);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 1968 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(1965);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 1969 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(32);
	
	var PooledClass = __webpack_require__(178);
	var Transaction = __webpack_require__(363);
	var ReactInstrumentation = __webpack_require__(94);
	var ReactServerUpdateQueue = __webpack_require__(1970);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 1970 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(505);
	
	var warning = __webpack_require__(34);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 1971 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ },
/* 1972 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 1973 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(278);
	var ExecutionEnvironment = __webpack_require__(74);
	var ReactDOMComponentTree = __webpack_require__(50);
	var ReactInputSelection = __webpack_require__(964);
	var SyntheticEvent = __webpack_require__(127);
	
	var getActiveElement = __webpack_require__(757);
	var isTextInputElement = __webpack_require__(974);
	var shallowEqual = __webpack_require__(478);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 1974 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var EventListener = __webpack_require__(754);
	var EventPropagators = __webpack_require__(278);
	var ReactDOMComponentTree = __webpack_require__(50);
	var SyntheticAnimationEvent = __webpack_require__(1975);
	var SyntheticClipboardEvent = __webpack_require__(1976);
	var SyntheticEvent = __webpack_require__(127);
	var SyntheticFocusEvent = __webpack_require__(1979);
	var SyntheticKeyboardEvent = __webpack_require__(1981);
	var SyntheticMouseEvent = __webpack_require__(362);
	var SyntheticDragEvent = __webpack_require__(1978);
	var SyntheticTouchEvent = __webpack_require__(1982);
	var SyntheticTransitionEvent = __webpack_require__(1983);
	var SyntheticUIEvent = __webpack_require__(280);
	var SyntheticWheelEvent = __webpack_require__(1984);
	
	var emptyFunction = __webpack_require__(107);
	var getEventCharCode = __webpack_require__(507);
	var invariant = __webpack_require__(28);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 1975 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(127);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 1976 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(127);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 1977 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(127);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 1978 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(362);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 1979 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(280);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 1980 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(127);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 1981 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(280);
	
	var getEventCharCode = __webpack_require__(507);
	var getEventKey = __webpack_require__(1989);
	var getEventModifierState = __webpack_require__(508);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 1982 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(280);
	
	var getEventModifierState = __webpack_require__(508);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 1983 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(127);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 1984 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(362);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 1985 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 1986 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(956);
	var warning = __webpack_require__(34);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 1987 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var ReactCurrentOwner = __webpack_require__(128);
	var ReactDOMComponentTree = __webpack_require__(50);
	var ReactInstanceMap = __webpack_require__(279);
	
	var getHostComponentFromComposite = __webpack_require__(970);
	var invariant = __webpack_require__(28);
	var warning = __webpack_require__(34);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 1988 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(501);
	var traverseAllChildren = __webpack_require__(976);
	var warning = __webpack_require__(34);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"."}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(985);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(360)))

/***/ },
/* 1989 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(507);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 1990 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 1991 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 1992 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(74);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 1993 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(364);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 1994 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(965);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 1995 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(64);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _InternalPropTypes = __webpack_require__(179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A mixin that adds the "history" instance variable to components.
	 */
	var History = {
	
	  contextTypes: {
	    history: _InternalPropTypes.history
	  },
	
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `History` mixin is deprecated, please access `context.router` with your own `contextTypes`. http://tiny.cc/router-historymixin') : void 0;
	    this.history = this.context.history;
	  }
	};
	
	exports.default = History;
	module.exports = exports['default'];

/***/ },
/* 1996 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(60);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(977);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = _react2.default.createClass({
	  displayName: 'IndexLink',
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 1997 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(60);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(64);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(978);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	
	var IndexRedirect = _react2.default.createClass({
	  displayName: 'IndexRedirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 1998 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(60);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(64);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(147);
	
	var _InternalPropTypes = __webpack_require__(179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react2.default.PropTypes.func;
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	
	var IndexRoute = _react2.default.createClass({
	  displayName: 'IndexRoute',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 1999 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(64);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(60);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The Lifecycle mixin adds the routerWillLeave lifecycle method to a
	 * component that may be used to cancel a transition or prompt the user
	 * for confirmation.
	 *
	 * On standard transitions, routerWillLeave receives a single argument: the
	 * location we're transitioning to. To cancel the transition, return false.
	 * To prompt the user for confirmation, return a prompt message (string).
	 *
	 * During the beforeunload event (assuming you're using the useBeforeUnload
	 * history enhancer), routerWillLeave does not receive a location object
	 * because it isn't possible for us to know the location we're transitioning
	 * to. In this case routerWillLeave must return a prompt message to prevent
	 * the user from closing the window/tab.
	 */
	
	var Lifecycle = {
	
	  contextTypes: {
	    history: object.isRequired,
	    // Nested children receive the route as context, either
	    // set by the route component using the RouteContext mixin
	    // or by some other ancestor.
	    route: object
	  },
	
	  propTypes: {
	    // Route components receive the route object as a prop.
	    route: object
	  },
	
	  componentDidMount: function componentDidMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `Lifecycle` mixin is deprecated, please use `context.router.setRouteLeaveHook(route, hook)`. http://tiny.cc/router-lifecyclemixin') : void 0;
	    !this.routerWillLeave ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin requires you to define a routerWillLeave method') : (0, _invariant2.default)(false) : void 0;
	
	    var route = this.props.route || this.context.route;
	
	    !route ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin must be used on either a) a <Route component> or ' + 'b) a descendant of a <Route component> that uses the RouteContext mixin') : (0, _invariant2.default)(false) : void 0;
	
	    this._unlistenBeforeLeavingRoute = this.context.history.listenBeforeLeavingRoute(route, this.routerWillLeave);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlistenBeforeLeavingRoute) this._unlistenBeforeLeavingRoute();
	  }
	};
	
	exports.default = Lifecycle;
	module.exports = exports['default'];

/***/ },
/* 2000 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(60);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(147);
	
	var _InternalPropTypes = __webpack_require__(179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	
	var Route = _react2.default.createClass({
	  displayName: 'Route',
	
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 2001 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(64);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(60);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The RouteContext mixin provides a convenient way for route
	 * components to set the route in context. This is needed for
	 * routes that render elements that want to use the Lifecycle
	 * mixin to prevent transitions.
	 */
	
	var RouteContext = {
	
	  propTypes: {
	    route: object.isRequired
	  },
	
	  childContextTypes: {
	    route: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      route: this.props.route
	    };
	  },
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'The `RouteContext` mixin is deprecated. You can provide `this.props.route` on context with your own `contextTypes`. http://tiny.cc/router-routecontextmixin') : void 0;
	  }
	};
	
	exports.default = RouteContext;
	module.exports = exports['default'];

/***/ },
/* 2002 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createHashHistory = __webpack_require__(764);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _useQueries = __webpack_require__(345);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(60);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createTransitionManager = __webpack_require__(515);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _InternalPropTypes = __webpack_require__(179);
	
	var _RouterContext = __webpack_require__(366);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(147);
	
	var _RouterUtils = __webpack_require__(979);
	
	var _routerWarning = __webpack_require__(64);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isDeprecatedHistory(history) {
	  return !history || !history.__v2_compatible__;
	}
	
	/* istanbul ignore next: sanity check */
	function isUnsupportedHistory(history) {
	  // v3 histories expose getCurrentLocation, but aren't currently supported.
	  return history && history.getCurrentLocation;
	}
	
	var _React$PropTypes = _react2.default.PropTypes;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	
	var Router = _react2.default.createClass({
	  displayName: 'Router',
	
	
	  propTypes: {
	    history: object,
	    children: _InternalPropTypes.routes,
	    routes: _InternalPropTypes.routes, // alias for children
	    render: func,
	    createElement: func,
	    onError: func,
	    onUpdate: func,
	
	    // Deprecated:
	    parseQueryString: func,
	    stringifyQuery: func,
	
	    // PRIVATE: For client-side rehydration of server match.
	    matchContext: object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    var _props = this.props;
	    var parseQueryString = _props.parseQueryString;
	    var stringifyQuery = _props.stringifyQuery;
	
	     false ? (0, _routerWarning2.default)(!(parseQueryString || stringifyQuery), '`parseQueryString` and `stringifyQuery` are deprecated. Please create a custom history. http://tiny.cc/router-customquerystring') : void 0;
	
	    var _createRouterObjects = this.createRouterObjects();
	
	    var history = _createRouterObjects.history;
	    var transitionManager = _createRouterObjects.transitionManager;
	    var router = _createRouterObjects.router;
	
	
	    this._unlisten = transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	
	    this.history = history;
	    this.router = router;
	  },
	  createRouterObjects: function createRouterObjects() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext;
	    }
	
	    var history = this.props.history;
	    var _props2 = this.props;
	    var routes = _props2.routes;
	    var children = _props2.children;
	
	
	    !!isUnsupportedHistory(history) ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v3.x. ' + 'This version of React Router is not compatible with v3 history ' + 'objects. Please use history v2.x instead.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isDeprecatedHistory(history)) {
	      history = this.wrapDeprecatedHistory(history);
	    }
	
	    var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	    var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	    var routingHistory = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	    return { history: routingHistory, transitionManager: transitionManager, router: router };
	  },
	  wrapDeprecatedHistory: function wrapDeprecatedHistory(history) {
	    var _props3 = this.props;
	    var parseQueryString = _props3.parseQueryString;
	    var stringifyQuery = _props3.stringifyQuery;
	
	
	    var createHistory = void 0;
	    if (history) {
	       false ? (0, _routerWarning2.default)(false, 'It appears you have provided a deprecated history object to `<Router/>`, please use a history provided by ' + 'React Router with `import { browserHistory } from \'react-router\'` or `import { hashHistory } from \'react-router\'`. ' + 'If you are using a custom history please create it with `useRouterHistory`, see http://tiny.cc/router-usinghistory for details.') : void 0;
	      createHistory = function createHistory() {
	        return history;
	      };
	    } else {
	       false ? (0, _routerWarning2.default)(false, '`Router` no longer defaults the history prop to hash history. Please use the `hashHistory` singleton instead. http://tiny.cc/router-defaulthistory') : void 0;
	      createHistory = _createHashHistory2.default;
	    }
	
	    return (0, _useQueries2.default)(createHistory)({ parseQueryString: parseQueryString, stringifyQuery: stringifyQuery });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state;
	    var location = _state.location;
	    var routes = _state.routes;
	    var params = _state.params;
	    var components = _state.components;
	    var _props4 = this.props;
	    var createElement = _props4.createElement;
	    var render = _props4.render;
	
	    var props = _objectWithoutProperties(_props4, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(Router.propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      history: this.history,
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 2003 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(60);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(366);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(64);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RoutingContext = _react2.default.createClass({
	  displayName: 'RoutingContext',
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, '`RoutingContext` has been renamed to `RouterContext`. Please use `import { RouterContext } from \'react-router\'`. http://tiny.cc/router-routercontext') : void 0;
	  },
	  render: function render() {
	    return _react2.default.createElement(_RouterContext2.default, this.props);
	  }
	});
	
	exports.default = RoutingContext;
	module.exports = exports['default'];

/***/ },
/* 2004 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runEnterHooks = runEnterHooks;
	exports.runChangeHooks = runChangeHooks;
	exports.runLeaveHooks = runLeaveHooks;
	
	var _AsyncUtils = __webpack_require__(513);
	
	var _routerWarning = __webpack_require__(64);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createTransitionHook(hook, route, asyncArity) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    hook.apply(route, args);
	
	    if (hook.length < asyncArity) {
	      var callback = args[args.length - 1];
	      // Assume hook executes synchronously and
	      // automatically call the callback.
	      callback();
	    }
	  };
	}
	
	function getEnterHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3));
	
	    return hooks;
	  }, []);
	}
	
	function getChangeHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4));
	    return hooks;
	  }, []);
	}
	
	function runTransitionHooks(length, iter, callback) {
	  if (!length) {
	    callback();
	    return;
	  }
	
	  var redirectInfo = void 0;
	  function replace(location, deprecatedPathname, deprecatedQuery) {
	    if (deprecatedPathname) {
	       false ? (0, _routerWarning2.default)(false, '`replaceState(state, pathname, query) is deprecated; use `replace(location)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      redirectInfo = {
	        pathname: deprecatedPathname,
	        query: deprecatedQuery,
	        state: location
	      };
	
	      return;
	    }
	
	    redirectInfo = location;
	  }
	
	  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	    iter(index, replace, function (error) {
	      if (error || redirectInfo) {
	        done(error, redirectInfo); // No need to continue.
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	
	/**
	 * Runs all onEnter hooks in the given array of routes in order
	 * with onEnter(nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runEnterHooks(routes, nextState, callback) {
	  var hooks = getEnterHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onChange hooks in the given array of routes in order
	 * with onChange(prevState, nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runChangeHooks(routes, state, nextState, callback) {
	  var hooks = getChangeHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](state, nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onLeave hooks in the given array of routes in order.
	 */
	function runLeaveHooks(routes, prevState) {
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	  }
	}

/***/ },
/* 2005 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(60);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(366);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(64);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length <= 0 || arguments[0] === undefined ? _react.createElement : arguments[0];
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 2006 */
[2308, 1749, 981],
/* 2007 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(215);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    (function () {
	      var parentIsLeaving = false;
	      leaveRoutes = prevRoutes.filter(function (route) {
	        if (parentIsLeaving) {
	          return true;
	        } else {
	          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	          if (isLeaving) parentIsLeaving = true;
	          return isLeaving;
	        }
	      });
	
	      // onLeave hooks start at the leaf route.
	      leaveRoutes.reverse();
	
	      enterRoutes = [];
	      changeRoutes = [];
	
	      nextRoutes.forEach(function (route) {
	        var isNew = prevRoutes.indexOf(route) === -1;
	        var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	      });
	    })();
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 2008 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(513);
	
	var _makeStateWithLocation = __webpack_require__(982);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (!getComponent) {
	    callback();
	    return;
	  }
	
	  var location = nextState.location;
	
	  var nextStateWithLocation = (0, _makeStateWithLocation2.default)(nextState, location);
	
	  getComponent.call(route, nextStateWithLocation, callback);
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 2009 */
[2309, 215],
/* 2010 */
[2310, 764, 981],
/* 2011 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.PropTypes = exports.RoutingContext = exports.RouterContext = exports.createRoutes = exports.useRoutes = exports.RouteContext = exports.Lifecycle = exports.History = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(147);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes2 = __webpack_require__(514);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(215);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(2002);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(977);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(1996);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(2016);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(1997);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(1998);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(978);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(2000);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _History2 = __webpack_require__(1995);
	
	var _History3 = _interopRequireDefault(_History2);
	
	var _Lifecycle2 = __webpack_require__(1999);
	
	var _Lifecycle3 = _interopRequireDefault(_Lifecycle2);
	
	var _RouteContext2 = __webpack_require__(2001);
	
	var _RouteContext3 = _interopRequireDefault(_RouteContext2);
	
	var _useRoutes2 = __webpack_require__(2015);
	
	var _useRoutes3 = _interopRequireDefault(_useRoutes2);
	
	var _RouterContext2 = __webpack_require__(366);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _RoutingContext2 = __webpack_require__(2003);
	
	var _RoutingContext3 = _interopRequireDefault(_RoutingContext2);
	
	var _PropTypes3 = _interopRequireDefault(_PropTypes2);
	
	var _match2 = __webpack_require__(2013);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(983);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(2005);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(2006);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(2010);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(980);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* mixins */
	
	exports.History = _History3.default;
	exports.Lifecycle = _Lifecycle3.default;
	exports.RouteContext = _RouteContext3.default;
	
	/* utils */
	
	exports.useRoutes = _useRoutes3.default;
	exports.RouterContext = _RouterContext3.default;
	exports.RoutingContext = _RoutingContext3.default;
	exports.PropTypes = _PropTypes3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 2012 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(215);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname;
	  var query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 2013 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(209);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(980);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(515);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(147);
	
	var _RouterUtils = __webpack_require__(979);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history;
	  var routes = _ref.routes;
	  var location = _ref.location;
	
	  var options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  var unlisten = void 0;
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    // Pick up the location from the history via synchronous history.listen
	    // call if needed.
	    unlisten = history.listen(function (historyLocation) {
	      location = historyLocation;
	    });
	  }
	
	  var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	  history = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    callback(error, redirectLocation && router.createLocation(redirectLocation, _Actions.REPLACE), nextState && _extends({}, nextState, {
	      history: history,
	      router: router,
	      matchContext: { history: history, transitionManager: transitionManager, router: router }
	    }));
	
	    // Defer removing the listener to here to prevent DOM histories from having
	    // to unwind DOM event listeners unnecessarily, in case callback renders a
	    // <Router> and attaches another history listener.
	    if (unlisten) {
	      unlisten();
	    }
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 2014 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(513);
	
	var _makeStateWithLocation = __webpack_require__(982);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	var _PatternUtils = __webpack_require__(215);
	
	var _routerWarning = __webpack_require__(64);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(147);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	  route.getChildRoutes(partialNextStateWithLocation, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	    route.getIndexRoute(partialNextStateWithLocation, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	  } else if (route.childRoutes) {
	    (function () {
	      var pathless = route.childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    })();
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var _ret2 = function () {
	        var match = {
	          routes: [route],
	          params: createParams(paramNames, paramValues)
	        };
	
	        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	          if (error) {
	            callback(error);
	          } else {
	            if (Array.isArray(indexRoute)) {
	              var _match$routes;
	
	               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	                return !route.path;
	              }), 'Index routes should not have paths') : void 0;
	              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	            } else if (indexRoute) {
	               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	              match.routes.push(indexRoute);
	            }
	
	            callback(null, match);
	          }
	        });
	
	        return {
	          v: void 0
	        };
	      }();
	
	      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
	  var paramValues = arguments.length <= 5 || arguments[5] === undefined ? [] : arguments[5];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 2015 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _useQueries = __webpack_require__(345);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _createTransitionManager = __webpack_require__(515);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _routerWarning = __webpack_require__(64);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know about routing.
	 *
	 * Enhances history objects with the following methods:
	 *
	 * - listen((error, nextState) => {})
	 * - listenBeforeLeavingRoute(route, (nextLocation) => {})
	 * - match(location, (error, redirectLocation, nextState) => {})
	 * - isActive(pathname, query, indexOnly=false)
	 */
	function useRoutes(createHistory) {
	   false ? (0, _routerWarning2.default)(false, '`useRoutes` is deprecated. Please use `createTransitionManager` instead.') : void 0;
	
	  return function () {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var routes = _ref.routes;
	
	    var options = _objectWithoutProperties(_ref, ['routes']);
	
	    var history = (0, _useQueries2.default)(createHistory)(options);
	    var transitionManager = (0, _createTransitionManager2.default)(history, routes);
	    return _extends({}, history, transitionManager);
	  };
	}
	
	exports.default = useRoutes;
	module.exports = exports['default'];

/***/ },
/* 2016 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(60);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(1930);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _PropTypes = __webpack_require__(514);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = _react2.default.createClass({
	    displayName: 'WithRouter',
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      var props = _extends({}, this.props, { router: router });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 2017 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(60);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1426);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _objectAssign = __webpack_require__(32);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _spinners = __webpack_require__(2018);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line import/no-extraneous-dependencies
	
	
	if (!({"NODE_ENV":"production","PUBLIC_URL":"."}).REACT_SPINKIT_NO_STYLES) {
	  /* eslint-disable global-require */
	  __webpack_require__(1775);
	  __webpack_require__(1715);
	  __webpack_require__(1722);
	  __webpack_require__(1720);
	  __webpack_require__(1716);
	  __webpack_require__(1717);
	  __webpack_require__(1718);
	  __webpack_require__(1719);
	  __webpack_require__(1721);
	  __webpack_require__(1723);
	  __webpack_require__(1724);
	  __webpack_require__(1725);
	  __webpack_require__(1726);
	  __webpack_require__(1727);
	  __webpack_require__(1728);
	  /* eslint-enable global-require */
	}
	
	var noFadeInWarning = "Deprecation Warning (react-spinkit): noFadeIn prop should be replaced with fadeIn='none'";
	
	var Spinner = function (_React$Component) {
	  _inherits(Spinner, _React$Component);
	
	  function Spinner(props) {
	    _classCallCheck(this, Spinner);
	
	    if (props.noFadeIn) {
	      console.warn(noFadeInWarning); // eslint-disable-line no-console
	    }
	
	    var _this = _possibleConstructorReturn(this, (Spinner.__proto__ || Object.getPrototypeOf(Spinner)).call(this, props));
	
	    _this.displayName = 'SpinKit';
	    return _this;
	  }
	
	  _createClass(Spinner, [{
	    key: 'render',
	    value: function render() {
	      var _cx;
	
	      var spinnerInfo = _spinners.allSpinners[this.props.name] || _spinners.allSpinners['three-bounce'];
	      var classes = (0, _classnames2.default)((_cx = {
	        'sk-fade-in': this.props.fadeIn === 'full' && !this.props.noFadeIn,
	        'sk-fade-in-half-second': this.props.fadeIn === 'half' && !this.props.noFadeIn,
	        'sk-fade-in-quarter-second': this.props.fadeIn === 'quarter' && !this.props.noFadeIn,
	        'sk-spinner': !this.props.overrideSpinnerClassName
	      }, _defineProperty(_cx, this.props.overrideSpinnerClassName, !!this.props.overrideSpinnerClassName), _defineProperty(_cx, this.props.className, !!this.props.className), _defineProperty(_cx, spinnerInfo.className || this.props.name, true), _cx));
	
	      var props = (0, _objectAssign2.default)({}, this.props);
	      delete props.name;
	      delete props.fadeIn;
	      delete props.noFadeIn;
	      delete props.overrideSpinnerClassName;
	      delete props.className;
	
	      if (this.props.color) {
	        props.style = props.style ? _extends({}, props.style, { color: this.props.color }) : { color: this.props.color };
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, props, { className: classes }),
	        [].concat(_toConsumableArray(Array(spinnerInfo.divCount))).map(function (_, idx) {
	          return _react2.default.createElement('div', { key: idx });
	        })
	      );
	    }
	  }]);
	
	  return Spinner;
	}(_react2.default.Component);
	
	Spinner.propTypes = {
	  name: _propTypes2.default.string.isRequired,
	  noFadeIn: _propTypes2.default.bool,
	  fadeIn: _propTypes2.default.oneOf(['full', 'half', 'quarter', 'none']),
	  overrideSpinnerClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  color: _propTypes2.default.string
	};
	
	Spinner.defaultProps = {
	  name: 'three-bounce',
	  noFadeIn: false,
	  fadeIn: 'full',
	  overrideSpinnerClassName: ''
	};
	
	module.exports = Spinner;

/***/ },
/* 2018 */
/***/ function(module, exports) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var spinkitSpinners = {
	  circle: { className: 'sk-circle', divCount: 12 },
	  'cube-grid': { className: 'sk-cube-grid', divCount: 9 },
	  wave: { className: 'sk-wave', divCount: 5 },
	  'folding-cube': { className: 'sk-folding-cube', divCount: 4 },
	  'three-bounce': { className: 'sk-three-bounce', divCount: 3 },
	  'double-bounce': { className: 'sk-double-bounce', divCount: 2 },
	  'wandering-cubes': { className: 'sk-wandering-cubes', divCount: 2 },
	  'chasing-dots': { className: 'sk-chasing-dots', divCount: 2 },
	  'rotating-plane': { className: 'sk-rotating-plane', divCount: 1 },
	  pulse: { className: 'sk-pulse', divCount: 1 },
	  wordpress: { className: 'sk-wordpress', divCount: 1 }
	};
	
	var loadersCssSpinners = {
	  'ball-grid-beat': { divCount: 9 },
	  'ball-grid-pulse': { divCount: 9 },
	  'line-spin-fade-loader': { divCount: 8 },
	  'ball-spin-fade-loader': { divCount: 8 },
	  'ball-pulse-rise': { divCount: 5 },
	  'line-scale': { divCount: 5 },
	  'line-scale-pulse-out': { divCount: 5 },
	  'line-scale-pulse-out-rapid': { divCount: 5 },
	  pacman: { divCount: 5 },
	  'line-scale-party': { divCount: 4 },
	  'ball-triangle-path': { divCount: 3 },
	  'ball-scale-multiple': { divCount: 3 },
	  'ball-scale-ripple-multiple': { divCount: 3 },
	  'ball-pulse-sync': { divCount: 3 },
	  'ball-beat': { divCount: 3 },
	  'ball-zig-zag': { divCount: 2 },
	  'ball-zig-zag-deflect': { divCount: 2 },
	  'ball-clip-rotate-pulse': { divCount: 2 },
	  'ball-clip-rotate-multiple': { divCount: 2 },
	  'ball-clip-rotate': { divCount: 1 },
	  'ball-scale-ripple': { divCount: 1 },
	  'triangle-skew-spin': { divCount: 1 }
	};
	
	module.exports = {
	  spinkitSpinners: spinkitSpinners,
	  loadersCssSpinners: loadersCssSpinners,
	  allSpinners: _extends({}, spinkitSpinners, loadersCssSpinners)
	};

/***/ },
/* 2019 */
501,
/* 2020 */
[2306, 281],
/* 2021 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(2020);
	var ReactElement = __webpack_require__(217);
	
	var emptyFunction = __webpack_require__(107);
	var traverseAllChildren = __webpack_require__(2030);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 2022 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(217);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 2023 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(217),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(954);
	
	module.exports = factory(isValidElement);

/***/ },
/* 2024 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.7.0';


/***/ },
/* 2025 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(984),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(217),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(987);
	var factory = __webpack_require__(688);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ },
/* 2026 */
1990,
/* 2027 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 2028 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ },
/* 2029 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(281);
	
	var ReactElement = __webpack_require__(217);
	
	var invariant = __webpack_require__(28);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 2030 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(281);
	
	var ReactCurrentOwner = __webpack_require__(128);
	var REACT_ELEMENT_TYPE = __webpack_require__(986);
	
	var getIteratorFn = __webpack_require__(2026);
	var invariant = __webpack_require__(28);
	var KeyEscapeUtils = __webpack_require__(2019);
	var warning = __webpack_require__(34);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 2031 */
/***/ function(module, exports) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	__webpack_require__(1);
	
	var jsonObj = {};
	var jsonArr = [];
	
	var foundLang = function foundLang(jsonObj, lang) {
		var t = jsonObj.find(function (el) {
			return el.lang[0] === lang[0] && el.lang[1] === lang[1];
		});
		if (t) return t;else return jsonObj.find(function (el) {
			return el.lang[0] === lang[0];
		});
	};
	
	var register = function register(json, lang) {
		var jsonFound = jsonArr.find(function (j) {
			return j.lang.toString() == lang.toString();
		});
		if (jsonFound) {
			jsonArr.splice(jsonArr.indexOf(jsonFound), 1);
			jsonFound.json = Object.assign({}, jsonFound.json, json);
			jsonArr.push(jsonFound);
		} else {
			jsonArr.push({
				"lang": lang,
				"json": json
			});
		}
	};
	
	var init = function init() {
		var userLg = (navigator.language || navigator.userLanguage).match(/([A-z]){2}/g);
		jsonObj = function () {
			var jsonlg = foundLang(jsonArr, userLg);
			var defaut = jsonArr.find(function (element) {
				return element.lang == "default";
			});
			if (!!jsonlg) {
				return jsonlg.json;
			} else if (!!defaut) {
				return defaut.json;
			} else {
				throw new Error("Cannot found lang");
			}
		}();
	};
	
	var clear = function clear() {
		jsonArr = [];
		jsonObj = {};
	};
	module.exports = new Proxy({}, {
		get: function get(cible, nom) {
			if (nom === 'import' || nom === 'addLang') return register;else if (nom === 'init') return init;else if (nom === '__esModule') return false;else if (nom === "clear") return clear;else if (nom in jsonObj) return jsonObj[nom];else throw new Error("[i18n] Cannot found " + nom + " property");
		}
	});
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process, global) {/*
	 * Copyright 2016 Google Inc. All rights reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not
	 * use this file except in compliance with the License. You may obtain a copy of
	 * the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
	 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
	 * License for the specific language governing permissions and limitations under
	 * the License.
	 */
	
	
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	(function (scope) {
	  if (scope['Proxy']) {
	    return;
	  }
	  var lastRevokeFn = null;
	
	  /**
	   * @param {*} o
	   * @return {boolean} whether this is probably a (non-null) Object
	   */
	  function isObject(o) {
	    return o ? (typeof o === 'undefined' ? 'undefined' : _typeof(o)) == 'object' || typeof o == 'function' : false;
	  }
	
	  /**
	   * @constructor
	   * @param {!Object} target
	   * @param {{apply, construct, get, set}} handler
	   */
	  scope.Proxy = function (target, handler) {
	    if (!isObject(target) || !isObject(handler)) {
	      throw new TypeError('Cannot create proxy with a non-object as target or handler');
	    }
	
	    // Construct revoke function, and set lastRevokeFn so that Proxy.revocable can steal it.
	    // The caller might get the wrong revoke function if a user replaces or wraps scope.Proxy
	    // to call itself, but that seems unlikely especially when using the polyfill.
	    var throwRevoked = function throwRevoked() {};
	    lastRevokeFn = function lastRevokeFn() {
	      throwRevoked = function throwRevoked(trap) {
	        throw new TypeError('Cannot perform \'' + trap + '\' on a proxy that has been revoked');
	      };
	    };
	
	    // Fail on unsupported traps: Chrome doesn't do this, but ensure that users of the polyfill
	    // are a bit more careful. Copy the internal parts of handler to prevent user changes.
	    var unsafeHandler = handler;
	    handler = { 'get': null, 'set': null, 'apply': null, 'construct': null };
	    for (var k in unsafeHandler) {
	      if (!(k in handler)) {
	        throw new TypeError('Proxy polyfill does not support trap \'' + k + '\'');
	      }
	      handler[k] = unsafeHandler[k];
	    }
	    if (typeof unsafeHandler == 'function') {
	      // Allow handler to be a function (which has an 'apply' method). This matches what is
	      // probably a bug in native versions. It treats the apply call as a trap to be configured.
	      handler.apply = unsafeHandler.apply.bind(unsafeHandler);
	    }
	
	    // Define proxy as this, or a Function (if either it's callable, or apply is set).
	    // TODO(samthor): Closure compiler doesn't know about 'construct', attempts to rename it.
	    var proxy = this;
	    var isMethod = false;
	    var targetIsFunction = typeof target == 'function';
	    if (handler.apply || handler['construct'] || targetIsFunction) {
	      proxy = function Proxy() {
	        var usingNew = this && this.constructor === proxy;
	        var args = Array.prototype.slice.call(arguments);
	        throwRevoked(usingNew ? 'construct' : 'apply');
	
	        if (usingNew && handler['construct']) {
	          return handler['construct'].call(this, target, args);
	        } else if (!usingNew && handler.apply) {
	          return handler.apply(target, this, args);
	        } else if (targetIsFunction) {
	          // since the target was a function, fallback to calling it directly.
	          if (usingNew) {
	            // inspired by answers to https://stackoverflow.com/q/1606797
	            args.unshift(target); // pass class as first arg to constructor, although irrelevant
	            // nb. cast to convince Closure compiler that this is a constructor
	            var f = /** @type {!Function} */target.bind.apply(target, args);
	            return new f();
	          }
	          return target.apply(this, args);
	        }
	        throw new TypeError(usingNew ? 'not a constructor' : 'not a function');
	      };
	      isMethod = true;
	    }
	
	    // Create default getters/setters. Create different code paths as handler.get/handler.set can't
	    // change after creation.
	    var getter = handler.get ? function (prop) {
	      throwRevoked('get');
	      return handler.get(this, prop, proxy);
	    } : function (prop) {
	      throwRevoked('get');
	      return this[prop];
	    };
	    var setter = handler.set ? function (prop, value) {
	      throwRevoked('set');
	      var status = handler.set(this, prop, value, proxy);
	      if (!status) {
	        // TODO(samthor): If the calling code is in strict mode, throw TypeError.
	        // It's (sometimes) possible to work this out, if this code isn't strict- try to load the
	        // callee, and if it's available, that code is non-strict. However, this isn't exhaustive.
	      }
	    } : function (prop, value) {
	      throwRevoked('set');
	      this[prop] = value;
	    };
	
	    // Clone direct properties (i.e., not part of a prototype).
	    var propertyNames = Object.getOwnPropertyNames(target);
	    var propertyMap = {};
	    propertyNames.forEach(function (prop) {
	      if (isMethod && prop in proxy) {
	        return; // ignore properties already here, e.g. 'bind', 'prototype' etc
	      }
	      var real = Object.getOwnPropertyDescriptor(target, prop);
	      var desc = {
	        enumerable: !!real.enumerable,
	        get: getter.bind(target, prop),
	        set: setter.bind(target, prop)
	      };
	      Object.defineProperty(proxy, prop, desc);
	      propertyMap[prop] = true;
	    });
	
	    // Set the prototype, or clone all prototype methods (always required if a getter is provided).
	    // TODO(samthor): We don't allow prototype methods to be set. It's (even more) awkward.
	    // An alternative here would be to _just_ clone methods to keep behavior consistent.
	    var prototypeOk = true;
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(proxy, Object.getPrototypeOf(target));
	    } else if (proxy.__proto__) {
	      proxy.__proto__ = target.__proto__;
	    } else {
	      prototypeOk = false;
	    }
	    if (handler.get || !prototypeOk) {
	      for (var _k in target) {
	        if (propertyMap[_k]) {
	          continue;
	        }
	        Object.defineProperty(proxy, _k, { get: getter.bind(target, _k) });
	      }
	    }
	
	    // The Proxy polyfill cannot handle adding new properties. Seal the target and proxy.
	    Object.seal(target);
	    Object.seal(proxy);
	
	    return proxy; // nb. if isMethod is true, proxy != this
	  };
	
	  scope.Proxy.revocable = function (target, handler) {
	    var p = new scope.Proxy(target, handler);
	    return { 'proxy': p, 'revoke': lastRevokeFn };
	  };
	
	  scope.Proxy['revocable'] = scope.Proxy.revocable;
	  scope['Proxy'] = scope.Proxy;
	})(typeof process !== 'undefined' && {}.toString.call(process) == '[object process]' ? global : self);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(3)))
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };
	
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
	var g;
	
	// This works in non-strict mode
	g = (function() {
		return this;
	})();
	
	try {
		// This works if eval is allowed (see CSP)
		g = g || Function("return this")() || (1,eval)("this");
	} catch(e) {
		// This works if the window reference is available
		if(typeof window === "object")
			g = window;
	}
	
	// g can still be undefined, but nothing to do about it...
	// We return undefined, instead of nothing here, so it's
	// easier to handle this case. if(!global) { ...}
	
	module.exports = g;
	
	
	/***/ })
	/******/ ]);
	//# sourceMappingURL=index.js.map

/***/ },
/* 2032 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _union = __webpack_require__(1913);
	
	var _union2 = _interopRequireDefault(_union);
	
	var _without = __webpack_require__(814);
	
	var _without2 = _interopRequireDefault(_without);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EnterLeaveCounter = function () {
		function EnterLeaveCounter() {
			_classCallCheck(this, EnterLeaveCounter);
	
			this.entered = [];
		}
	
		_createClass(EnterLeaveCounter, [{
			key: 'enter',
			value: function enter(enteringNode) {
				var previousLength = this.entered.length;
	
				var isNodeEntered = function isNodeEntered(node) {
					return document.documentElement.contains(node) && (!node.contains || node.contains(enteringNode));
				};
	
				this.entered = (0, _union2.default)(this.entered.filter(isNodeEntered), [enteringNode]);
	
				return previousLength === 0 && this.entered.length > 0;
			}
		}, {
			key: 'leave',
			value: function leave(leavingNode) {
				var previousLength = this.entered.length;
	
				this.entered = (0, _without2.default)(this.entered.filter(function (node) {
					return document.documentElement.contains(node);
				}), leavingNode);
	
				return previousLength > 0 && this.entered.length === 0;
			}
		}, {
			key: 'reset',
			value: function reset() {
				this.entered = [];
			}
		}]);
	
		return EnterLeaveCounter;
	}();
	
	exports.default = EnterLeaveCounter;

/***/ },
/* 2033 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable no-underscore-dangle */
	
	
	var _defaults = __webpack_require__(1878);
	
	var _defaults2 = _interopRequireDefault(_defaults);
	
	var _shallowEqual = __webpack_require__(2038);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _EnterLeaveCounter = __webpack_require__(2032);
	
	var _EnterLeaveCounter2 = _interopRequireDefault(_EnterLeaveCounter);
	
	var _BrowserDetector = __webpack_require__(990);
	
	var _OffsetUtils = __webpack_require__(2036);
	
	var _NativeDragSources = __webpack_require__(2035);
	
	var _NativeTypes = __webpack_require__(516);
	
	var NativeTypes = _interopRequireWildcard(_NativeTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HTML5Backend = function () {
		function HTML5Backend(manager) {
			_classCallCheck(this, HTML5Backend);
	
			this.actions = manager.getActions();
			this.monitor = manager.getMonitor();
			this.registry = manager.getRegistry();
			this.context = manager.getContext();
	
			this.sourcePreviewNodes = {};
			this.sourcePreviewNodeOptions = {};
			this.sourceNodes = {};
			this.sourceNodeOptions = {};
			this.enterLeaveCounter = new _EnterLeaveCounter2.default();
	
			this.dragStartSourceIds = [];
			this.dropTargetIds = [];
			this.dragEnterTargetIds = [];
			this.currentNativeSource = null;
			this.currentNativeHandle = null;
			this.currentDragSourceNode = null;
			this.currentDragSourceNodeOffset = null;
			this.currentDragSourceNodeOffsetChanged = false;
			this.altKeyPressed = false;
			this.mouseMoveTimeoutTimer = null;
	
			this.getSourceClientOffset = this.getSourceClientOffset.bind(this);
			this.handleTopDragStart = this.handleTopDragStart.bind(this);
			this.handleTopDragStartCapture = this.handleTopDragStartCapture.bind(this);
			this.handleTopDragEndCapture = this.handleTopDragEndCapture.bind(this);
			this.handleTopDragEnter = this.handleTopDragEnter.bind(this);
			this.handleTopDragEnterCapture = this.handleTopDragEnterCapture.bind(this);
			this.handleTopDragLeaveCapture = this.handleTopDragLeaveCapture.bind(this);
			this.handleTopDragOver = this.handleTopDragOver.bind(this);
			this.handleTopDragOverCapture = this.handleTopDragOverCapture.bind(this);
			this.handleTopDrop = this.handleTopDrop.bind(this);
			this.handleTopDropCapture = this.handleTopDropCapture.bind(this);
			this.handleSelectStart = this.handleSelectStart.bind(this);
			this.endDragIfSourceWasRemovedFromDOM = this.endDragIfSourceWasRemovedFromDOM.bind(this);
			this.endDragNativeItem = this.endDragNativeItem.bind(this);
			this.asyncEndDragNativeItem = this.asyncEndDragNativeItem.bind(this);
			this.isNodeInDocument = this.isNodeInDocument.bind(this);
		}
	
		_createClass(HTML5Backend, [{
			key: 'setup',
			value: function setup() {
				if (this.window === undefined) {
					return;
				}
	
				if (this.window.__isReactDndBackendSetUp) {
					throw new Error('Cannot have two HTML5 backends at the same time.');
				}
				this.window.__isReactDndBackendSetUp = true;
				this.addEventListeners(this.window);
			}
		}, {
			key: 'teardown',
			value: function teardown() {
				if (this.window === undefined) {
					return;
				}
	
				this.window.__isReactDndBackendSetUp = false;
				this.removeEventListeners(this.window);
				this.clearCurrentDragSourceNode();
				if (this.asyncEndDragFrameId) {
					this.window.cancelAnimationFrame(this.asyncEndDragFrameId);
				}
			}
		}, {
			key: 'addEventListeners',
			value: function addEventListeners(target) {
				// SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
				if (!target.addEventListener) {
					return;
				}
				target.addEventListener('dragstart', this.handleTopDragStart);
				target.addEventListener('dragstart', this.handleTopDragStartCapture, true);
				target.addEventListener('dragend', this.handleTopDragEndCapture, true);
				target.addEventListener('dragenter', this.handleTopDragEnter);
				target.addEventListener('dragenter', this.handleTopDragEnterCapture, true);
				target.addEventListener('dragleave', this.handleTopDragLeaveCapture, true);
				target.addEventListener('dragover', this.handleTopDragOver);
				target.addEventListener('dragover', this.handleTopDragOverCapture, true);
				target.addEventListener('drop', this.handleTopDrop);
				target.addEventListener('drop', this.handleTopDropCapture, true);
			}
		}, {
			key: 'removeEventListeners',
			value: function removeEventListeners(target) {
				// SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
				if (!target.removeEventListener) {
					return;
				}
				target.removeEventListener('dragstart', this.handleTopDragStart);
				target.removeEventListener('dragstart', this.handleTopDragStartCapture, true);
				target.removeEventListener('dragend', this.handleTopDragEndCapture, true);
				target.removeEventListener('dragenter', this.handleTopDragEnter);
				target.removeEventListener('dragenter', this.handleTopDragEnterCapture, true);
				target.removeEventListener('dragleave', this.handleTopDragLeaveCapture, true);
				target.removeEventListener('dragover', this.handleTopDragOver);
				target.removeEventListener('dragover', this.handleTopDragOverCapture, true);
				target.removeEventListener('drop', this.handleTopDrop);
				target.removeEventListener('drop', this.handleTopDropCapture, true);
			}
		}, {
			key: 'connectDragPreview',
			value: function connectDragPreview(sourceId, node, options) {
				var _this = this;
	
				this.sourcePreviewNodeOptions[sourceId] = options;
				this.sourcePreviewNodes[sourceId] = node;
	
				return function () {
					delete _this.sourcePreviewNodes[sourceId];
					delete _this.sourcePreviewNodeOptions[sourceId];
				};
			}
		}, {
			key: 'connectDragSource',
			value: function connectDragSource(sourceId, node, options) {
				var _this2 = this;
	
				this.sourceNodes[sourceId] = node;
				this.sourceNodeOptions[sourceId] = options;
	
				var handleDragStart = function handleDragStart(e) {
					return _this2.handleDragStart(e, sourceId);
				};
				var handleSelectStart = function handleSelectStart(e) {
					return _this2.handleSelectStart(e, sourceId);
				};
	
				node.setAttribute('draggable', true);
				node.addEventListener('dragstart', handleDragStart);
				node.addEventListener('selectstart', handleSelectStart);
	
				return function () {
					delete _this2.sourceNodes[sourceId];
					delete _this2.sourceNodeOptions[sourceId];
	
					node.removeEventListener('dragstart', handleDragStart);
					node.removeEventListener('selectstart', handleSelectStart);
					node.setAttribute('draggable', false);
				};
			}
		}, {
			key: 'connectDropTarget',
			value: function connectDropTarget(targetId, node) {
				var _this3 = this;
	
				var handleDragEnter = function handleDragEnter(e) {
					return _this3.handleDragEnter(e, targetId);
				};
				var handleDragOver = function handleDragOver(e) {
					return _this3.handleDragOver(e, targetId);
				};
				var handleDrop = function handleDrop(e) {
					return _this3.handleDrop(e, targetId);
				};
	
				node.addEventListener('dragenter', handleDragEnter);
				node.addEventListener('dragover', handleDragOver);
				node.addEventListener('drop', handleDrop);
	
				return function () {
					node.removeEventListener('dragenter', handleDragEnter);
					node.removeEventListener('dragover', handleDragOver);
					node.removeEventListener('drop', handleDrop);
				};
			}
		}, {
			key: 'getCurrentSourceNodeOptions',
			value: function getCurrentSourceNodeOptions() {
				var sourceId = this.monitor.getSourceId();
				var sourceNodeOptions = this.sourceNodeOptions[sourceId];
	
				return (0, _defaults2.default)(sourceNodeOptions || {}, {
					dropEffect: this.altKeyPressed ? 'copy' : 'move'
				});
			}
		}, {
			key: 'getCurrentDropEffect',
			value: function getCurrentDropEffect() {
				if (this.isDraggingNativeItem()) {
					// It makes more sense to default to 'copy' for native resources
					return 'copy';
				}
	
				return this.getCurrentSourceNodeOptions().dropEffect;
			}
		}, {
			key: 'getCurrentSourcePreviewNodeOptions',
			value: function getCurrentSourcePreviewNodeOptions() {
				var sourceId = this.monitor.getSourceId();
				var sourcePreviewNodeOptions = this.sourcePreviewNodeOptions[sourceId];
	
				return (0, _defaults2.default)(sourcePreviewNodeOptions || {}, {
					anchorX: 0.5,
					anchorY: 0.5,
					captureDraggingState: false
				});
			}
		}, {
			key: 'getSourceClientOffset',
			value: function getSourceClientOffset(sourceId) {
				return (0, _OffsetUtils.getNodeClientOffset)(this.sourceNodes[sourceId]);
			}
		}, {
			key: 'isDraggingNativeItem',
			value: function isDraggingNativeItem() {
				var itemType = this.monitor.getItemType();
				return Object.keys(NativeTypes).some(function (key) {
					return NativeTypes[key] === itemType;
				});
			}
		}, {
			key: 'beginDragNativeItem',
			value: function beginDragNativeItem(type) {
				this.clearCurrentDragSourceNode();
	
				var SourceType = (0, _NativeDragSources.createNativeDragSource)(type);
				this.currentNativeSource = new SourceType();
				this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
				this.actions.beginDrag([this.currentNativeHandle]);
			}
		}, {
			key: 'asyncEndDragNativeItem',
			value: function asyncEndDragNativeItem() {
				this.asyncEndDragFrameId = this.window.requestAnimationFrame(this.endDragNativeItem);
			}
		}, {
			key: 'endDragNativeItem',
			value: function endDragNativeItem() {
				if (!this.isDraggingNativeItem()) {
					return;
				}
	
				this.actions.endDrag();
				this.registry.removeSource(this.currentNativeHandle);
				this.currentNativeHandle = null;
				this.currentNativeSource = null;
			}
		}, {
			key: 'isNodeInDocument',
			value: function isNodeInDocument(node) {
				// Check the node either in the main document or in the current context
				return document.body.contains(node) || this.window ? this.window.document.body.contains(node) : false;
			}
		}, {
			key: 'endDragIfSourceWasRemovedFromDOM',
			value: function endDragIfSourceWasRemovedFromDOM() {
				var node = this.currentDragSourceNode;
				if (this.isNodeInDocument(node)) {
					return;
				}
	
				if (this.clearCurrentDragSourceNode()) {
					this.actions.endDrag();
				}
			}
		}, {
			key: 'setCurrentDragSourceNode',
			value: function setCurrentDragSourceNode(node) {
				var _this4 = this;
	
				this.clearCurrentDragSourceNode();
				this.currentDragSourceNode = node;
				this.currentDragSourceNodeOffset = (0, _OffsetUtils.getNodeClientOffset)(node);
				this.currentDragSourceNodeOffsetChanged = false;
	
				// A timeout of > 0 is necessary to resolve Firefox issue referenced
				// See:
				//   * https://github.com/react-dnd/react-dnd/pull/928
				//   * https://github.com/react-dnd/react-dnd/issues/869
				var MOUSE_MOVE_TIMEOUT = 1000;
	
				// Receiving a mouse event in the middle of a dragging operation
				// means it has ended and the drag source node disappeared from DOM,
				// so the browser didn't dispatch the dragend event.
				//
				// We need to wait before we start listening for mousemove events.
				// This is needed because the drag preview needs to be drawn or else it fires an 'mousemove' event
				// immediately in some browsers.
				//
				// See:
				//   * https://github.com/react-dnd/react-dnd/pull/928
				//   * https://github.com/react-dnd/react-dnd/issues/869
				//
				this.mouseMoveTimeoutTimer = setTimeout(function () {
					_this4.mouseMoveTimeoutId = null;
					return _this4.window.addEventListener('mousemove', _this4.endDragIfSourceWasRemovedFromDOM, true);
				}, MOUSE_MOVE_TIMEOUT);
			}
		}, {
			key: 'clearCurrentDragSourceNode',
			value: function clearCurrentDragSourceNode() {
				if (this.currentDragSourceNode) {
					this.currentDragSourceNode = null;
					this.currentDragSourceNodeOffset = null;
					this.currentDragSourceNodeOffsetChanged = false;
					this.window.clearTimeout(this.mouseMoveTimeoutTimer);
					this.window.removeEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
					this.mouseMoveTimeoutTimer = null;
					return true;
				}
	
				return false;
			}
		}, {
			key: 'checkIfCurrentDragSourceRectChanged',
			value: function checkIfCurrentDragSourceRectChanged() {
				var node = this.currentDragSourceNode;
				if (!node) {
					return false;
				}
	
				if (this.currentDragSourceNodeOffsetChanged) {
					return true;
				}
	
				this.currentDragSourceNodeOffsetChanged = !(0, _shallowEqual2.default)((0, _OffsetUtils.getNodeClientOffset)(node), this.currentDragSourceNodeOffset);
	
				return this.currentDragSourceNodeOffsetChanged;
			}
		}, {
			key: 'handleTopDragStartCapture',
			value: function handleTopDragStartCapture() {
				this.clearCurrentDragSourceNode();
				this.dragStartSourceIds = [];
			}
		}, {
			key: 'handleDragStart',
			value: function handleDragStart(e, sourceId) {
				this.dragStartSourceIds.unshift(sourceId);
			}
		}, {
			key: 'handleTopDragStart',
			value: function handleTopDragStart(e) {
				var _this5 = this;
	
				var dragStartSourceIds = this.dragStartSourceIds;
	
				this.dragStartSourceIds = null;
	
				var clientOffset = (0, _OffsetUtils.getEventClientOffset)(e);
	
				// Avoid crashing if we missed a drop event or our previous drag died
				if (this.monitor.isDragging()) {
					this.actions.endDrag();
				}
	
				// Don't publish the source just yet (see why below)
				this.actions.beginDrag(dragStartSourceIds, {
					publishSource: false,
					getSourceClientOffset: this.getSourceClientOffset,
					clientOffset: clientOffset
				});
	
				var dataTransfer = e.dataTransfer;
	
				var nativeType = (0, _NativeDragSources.matchNativeItemType)(dataTransfer);
	
				if (this.monitor.isDragging()) {
					if (typeof dataTransfer.setDragImage === 'function') {
						// Use custom drag image if user specifies it.
						// If child drag source refuses drag but parent agrees,
						// use parent's node as drag image. Neither works in IE though.
						var sourceId = this.monitor.getSourceId();
						var sourceNode = this.sourceNodes[sourceId];
						var dragPreview = this.sourcePreviewNodes[sourceId] || sourceNode;
	
						var _getCurrentSourcePrev = this.getCurrentSourcePreviewNodeOptions(),
						    anchorX = _getCurrentSourcePrev.anchorX,
						    anchorY = _getCurrentSourcePrev.anchorY,
						    offsetX = _getCurrentSourcePrev.offsetX,
						    offsetY = _getCurrentSourcePrev.offsetY;
	
						var anchorPoint = { anchorX: anchorX, anchorY: anchorY };
						var offsetPoint = { offsetX: offsetX, offsetY: offsetY };
						var dragPreviewOffset = (0, _OffsetUtils.getDragPreviewOffset)(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);
	
						dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
					}
	
					try {
						// Firefox won't drag without setting data
						dataTransfer.setData('application/json', {});
					} catch (err) {}
					// IE doesn't support MIME types in setData
	
	
					// Store drag source node so we can check whether
					// it is removed from DOM and trigger endDrag manually.
					this.setCurrentDragSourceNode(e.target);
	
					// Now we are ready to publish the drag source.. or are we not?
	
					var _getCurrentSourcePrev2 = this.getCurrentSourcePreviewNodeOptions(),
					    captureDraggingState = _getCurrentSourcePrev2.captureDraggingState;
	
					if (!captureDraggingState) {
						// Usually we want to publish it in the next tick so that browser
						// is able to screenshot the current (not yet dragging) state.
						//
						// It also neatly avoids a situation where render() returns null
						// in the same tick for the source element, and browser freaks out.
						setTimeout(function () {
							return _this5.actions.publishDragSource();
						});
					} else {
						// In some cases the user may want to override this behavior, e.g.
						// to work around IE not supporting custom drag previews.
						//
						// When using a custom drag layer, the only way to prevent
						// the default drag preview from drawing in IE is to screenshot
						// the dragging state in which the node itself has zero opacity
						// and height. In this case, though, returning null from render()
						// will abruptly end the dragging, which is not obvious.
						//
						// This is the reason such behavior is strictly opt-in.
						this.actions.publishDragSource();
					}
				} else if (nativeType) {
					// A native item (such as URL) dragged from inside the document
					this.beginDragNativeItem(nativeType);
				} else if (!dataTransfer.types && (!e.target.hasAttribute || !e.target.hasAttribute('draggable'))) {
					// Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
					// Just let it drag. It's a native type (URL or text) and will be picked up in
					// dragenter handler.
					return; // eslint-disable-line no-useless-return
				} else {
					// If by this time no drag source reacted, tell browser not to drag.
					e.preventDefault();
				}
			}
		}, {
			key: 'handleTopDragEndCapture',
			value: function handleTopDragEndCapture() {
				if (this.clearCurrentDragSourceNode()) {
					// Firefox can dispatch this event in an infinite loop
					// if dragend handler does something like showing an alert.
					// Only proceed if we have not handled it already.
					this.actions.endDrag();
				}
			}
		}, {
			key: 'handleTopDragEnterCapture',
			value: function handleTopDragEnterCapture(e) {
				this.dragEnterTargetIds = [];
	
				var isFirstEnter = this.enterLeaveCounter.enter(e.target);
				if (!isFirstEnter || this.monitor.isDragging()) {
					return;
				}
	
				var dataTransfer = e.dataTransfer;
	
				var nativeType = (0, _NativeDragSources.matchNativeItemType)(dataTransfer);
	
				if (nativeType) {
					// A native item (such as file or URL) dragged from outside the document
					this.beginDragNativeItem(nativeType);
				}
			}
		}, {
			key: 'handleDragEnter',
			value: function handleDragEnter(e, targetId) {
				this.dragEnterTargetIds.unshift(targetId);
			}
		}, {
			key: 'handleTopDragEnter',
			value: function handleTopDragEnter(e) {
				var _this6 = this;
	
				var dragEnterTargetIds = this.dragEnterTargetIds;
	
				this.dragEnterTargetIds = [];
	
				if (!this.monitor.isDragging()) {
					// This is probably a native item type we don't understand.
					return;
				}
	
				this.altKeyPressed = e.altKey;
	
				if (!(0, _BrowserDetector.isFirefox)()) {
					// Don't emit hover in `dragenter` on Firefox due to an edge case.
					// If the target changes position as the result of `dragenter`, Firefox
					// will still happily dispatch `dragover` despite target being no longer
					// there. The easy solution is to only fire `hover` in `dragover` on FF.
					this.actions.hover(dragEnterTargetIds, {
						clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
					});
				}
	
				var canDrop = dragEnterTargetIds.some(function (targetId) {
					return _this6.monitor.canDropOnTarget(targetId);
				});
	
				if (canDrop) {
					// IE requires this to fire dragover events
					e.preventDefault();
					e.dataTransfer.dropEffect = this.getCurrentDropEffect();
				}
			}
		}, {
			key: 'handleTopDragOverCapture',
			value: function handleTopDragOverCapture() {
				this.dragOverTargetIds = [];
			}
		}, {
			key: 'handleDragOver',
			value: function handleDragOver(e, targetId) {
				this.dragOverTargetIds.unshift(targetId);
			}
		}, {
			key: 'handleTopDragOver',
			value: function handleTopDragOver(e) {
				var _this7 = this;
	
				var dragOverTargetIds = this.dragOverTargetIds;
	
				this.dragOverTargetIds = [];
	
				if (!this.monitor.isDragging()) {
					// This is probably a native item type we don't understand.
					// Prevent default "drop and blow away the whole document" action.
					e.preventDefault();
					e.dataTransfer.dropEffect = 'none';
					return;
				}
	
				this.altKeyPressed = e.altKey;
	
				this.actions.hover(dragOverTargetIds, {
					clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
				});
	
				var canDrop = dragOverTargetIds.some(function (targetId) {
					return _this7.monitor.canDropOnTarget(targetId);
				});
	
				if (canDrop) {
					// Show user-specified drop effect.
					e.preventDefault();
					e.dataTransfer.dropEffect = this.getCurrentDropEffect();
				} else if (this.isDraggingNativeItem()) {
					// Don't show a nice cursor but still prevent default
					// "drop and blow away the whole document" action.
					e.preventDefault();
					e.dataTransfer.dropEffect = 'none';
				} else if (this.checkIfCurrentDragSourceRectChanged()) {
					// Prevent animating to incorrect position.
					// Drop effect must be other than 'none' to prevent animation.
					e.preventDefault();
					e.dataTransfer.dropEffect = 'move';
				}
			}
		}, {
			key: 'handleTopDragLeaveCapture',
			value: function handleTopDragLeaveCapture(e) {
				if (this.isDraggingNativeItem()) {
					e.preventDefault();
				}
	
				var isLastLeave = this.enterLeaveCounter.leave(e.target);
				if (!isLastLeave) {
					return;
				}
	
				if (this.isDraggingNativeItem()) {
					this.endDragNativeItem();
				}
			}
		}, {
			key: 'handleTopDropCapture',
			value: function handleTopDropCapture(e) {
				this.dropTargetIds = [];
				e.preventDefault();
	
				if (this.isDraggingNativeItem()) {
					this.currentNativeSource.mutateItemByReadingDataTransfer(e.dataTransfer);
				}
	
				this.enterLeaveCounter.reset();
			}
		}, {
			key: 'handleDrop',
			value: function handleDrop(e, targetId) {
				this.dropTargetIds.unshift(targetId);
			}
		}, {
			key: 'handleTopDrop',
			value: function handleTopDrop(e) {
				var dropTargetIds = this.dropTargetIds;
	
				this.dropTargetIds = [];
	
				this.actions.hover(dropTargetIds, {
					clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
				});
				this.actions.drop({ dropEffect: this.getCurrentDropEffect() });
	
				if (this.isDraggingNativeItem()) {
					this.endDragNativeItem();
				} else {
					this.endDragIfSourceWasRemovedFromDOM();
				}
			}
		}, {
			key: 'handleSelectStart',
			value: function handleSelectStart(e) {
				var target = e.target;
	
				// Only IE requires us to explicitly say
				// we want drag drop operation to start
	
				if (typeof target.dragDrop !== 'function') {
					return;
				}
	
				// Inputs and textareas should be selectable
				if (target.tagName === 'INPUT' || target.tagName === 'SELECT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
					return;
				}
	
				// For other targets, ask IE
				// to enable drag and drop
				e.preventDefault();
				target.dragDrop();
			}
		}, {
			key: 'window',
			get: function get() {
				if (this.context && this.context.window) {
					return this.context.window;
				} else if (typeof window !== 'undefined') {
					return window;
				}
				return undefined;
			}
		}]);
	
		return HTML5Backend;
	}();
	
	exports.default = HTML5Backend;

/***/ },
/* 2034 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* eslint
	   no-plusplus: off,
	   no-mixed-operators: off
	*/
	var MonotonicInterpolant = function () {
		function MonotonicInterpolant(xs, ys) {
			_classCallCheck(this, MonotonicInterpolant);
	
			var length = xs.length;
	
			// Rearrange xs and ys so that xs is sorted
			var indexes = [];
			for (var i = 0; i < length; i++) {
				indexes.push(i);
			}
			indexes.sort(function (a, b) {
				return xs[a] < xs[b] ? -1 : 1;
			});
	
			// Get consecutive differences and slopes
			var dys = [];
			var dxs = [];
			var ms = [];
			var dx = void 0;
			var dy = void 0;
			for (var _i = 0; _i < length - 1; _i++) {
				dx = xs[_i + 1] - xs[_i];
				dy = ys[_i + 1] - ys[_i];
				dxs.push(dx);
				dys.push(dy);
				ms.push(dy / dx);
			}
	
			// Get degree-1 coefficients
			var c1s = [ms[0]];
			for (var _i2 = 0; _i2 < dxs.length - 1; _i2++) {
				var _m = ms[_i2];
				var mNext = ms[_i2 + 1];
				if (_m * mNext <= 0) {
					c1s.push(0);
				} else {
					dx = dxs[_i2];
					var dxNext = dxs[_i2 + 1];
					var common = dx + dxNext;
					c1s.push(3 * common / ((common + dxNext) / _m + (common + dx) / mNext));
				}
			}
			c1s.push(ms[ms.length - 1]);
	
			// Get degree-2 and degree-3 coefficients
			var c2s = [];
			var c3s = [];
			var m = void 0;
			for (var _i3 = 0; _i3 < c1s.length - 1; _i3++) {
				m = ms[_i3];
				var c1 = c1s[_i3];
				var invDx = 1 / dxs[_i3];
				var _common = c1 + c1s[_i3 + 1] - m - m;
				c2s.push((m - c1 - _common) * invDx);
				c3s.push(_common * invDx * invDx);
			}
	
			this.xs = xs;
			this.ys = ys;
			this.c1s = c1s;
			this.c2s = c2s;
			this.c3s = c3s;
		}
	
		_createClass(MonotonicInterpolant, [{
			key: "interpolate",
			value: function interpolate(x) {
				var xs = this.xs,
				    ys = this.ys,
				    c1s = this.c1s,
				    c2s = this.c2s,
				    c3s = this.c3s;
	
				// The rightmost point in the dataset should give an exact result
	
				var i = xs.length - 1;
				if (x === xs[i]) {
					return ys[i];
				}
	
				// Search for the interval x is in, returning the corresponding y if x is one of the original xs
				var low = 0;
				var high = c3s.length - 1;
				var mid = void 0;
				while (low <= high) {
					mid = Math.floor(0.5 * (low + high));
					var xHere = xs[mid];
					if (xHere < x) {
						low = mid + 1;
					} else if (xHere > x) {
						high = mid - 1;
					} else {
						return ys[mid];
					}
				}
				i = Math.max(0, high);
	
				// Interpolate
				var diff = x - xs[i];
				var diffSq = diff * diff;
				return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
			}
		}]);
	
		return MonotonicInterpolant;
	}();
	
	exports.default = MonotonicInterpolant;

/***/ },
/* 2035 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _nativeTypesConfig;
	
	exports.createNativeDragSource = createNativeDragSource;
	exports.matchNativeItemType = matchNativeItemType;
	
	var _NativeTypes = __webpack_require__(516);
	
	var NativeTypes = _interopRequireWildcard(_NativeTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
		var result = typesToTry.reduce(function (resultSoFar, typeToTry) {
			return resultSoFar || dataTransfer.getData(typeToTry);
		}, null);
	
		return result != null // eslint-disable-line eqeqeq
		? result : defaultValue;
	}
	
	var nativeTypesConfig = (_nativeTypesConfig = {}, _defineProperty(_nativeTypesConfig, NativeTypes.FILE, {
		exposeProperty: 'files',
		matchesTypes: ['Files'],
		getData: function getData(dataTransfer) {
			return Array.prototype.slice.call(dataTransfer.files);
		}
	}), _defineProperty(_nativeTypesConfig, NativeTypes.URL, {
		exposeProperty: 'urls',
		matchesTypes: ['Url', 'text/uri-list'],
		getData: function getData(dataTransfer, matchesTypes) {
			return getDataFromDataTransfer(dataTransfer, matchesTypes, '').split('\n');
		}
	}), _defineProperty(_nativeTypesConfig, NativeTypes.TEXT, {
		exposeProperty: 'text',
		matchesTypes: ['Text', 'text/plain'],
		getData: function getData(dataTransfer, matchesTypes) {
			return getDataFromDataTransfer(dataTransfer, matchesTypes, '');
		}
	}), _nativeTypesConfig);
	
	function createNativeDragSource(type) {
		var _nativeTypesConfig$ty = nativeTypesConfig[type],
		    exposeProperty = _nativeTypesConfig$ty.exposeProperty,
		    matchesTypes = _nativeTypesConfig$ty.matchesTypes,
		    getData = _nativeTypesConfig$ty.getData;
	
	
		return function () {
			function NativeDragSource() {
				var _item, _mutatorMap;
	
				_classCallCheck(this, NativeDragSource);
	
				this.item = (_item = {}, _mutatorMap = {}, _mutatorMap[exposeProperty] = _mutatorMap[exposeProperty] || {}, _mutatorMap[exposeProperty].get = function () {
					// eslint-disable-next-line no-console
					console.warn('Browser doesn\'t allow reading "' + exposeProperty + '" until the drop event.');
					return null;
				}, _defineEnumerableProperties(_item, _mutatorMap), _item);
			}
	
			_createClass(NativeDragSource, [{
				key: 'mutateItemByReadingDataTransfer',
				value: function mutateItemByReadingDataTransfer(dataTransfer) {
					delete this.item[exposeProperty];
					this.item[exposeProperty] = getData(dataTransfer, matchesTypes);
				}
			}, {
				key: 'canDrag',
				value: function canDrag() {
					return true;
				}
			}, {
				key: 'beginDrag',
				value: function beginDrag() {
					return this.item;
				}
			}, {
				key: 'isDragging',
				value: function isDragging(monitor, handle) {
					return handle === monitor.getSourceId();
				}
			}, {
				key: 'endDrag',
				value: function endDrag() {}
			}]);
	
			return NativeDragSource;
		}();
	}
	
	function matchNativeItemType(dataTransfer) {
		var dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
	
		return Object.keys(nativeTypesConfig).filter(function (nativeItemType) {
			var matchesTypes = nativeTypesConfig[nativeItemType].matchesTypes;
	
			return matchesTypes.some(function (t) {
				return dataTransferTypes.indexOf(t) > -1;
			});
		})[0] || null;
	}

/***/ },
/* 2036 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getNodeClientOffset = getNodeClientOffset;
	exports.getEventClientOffset = getEventClientOffset;
	exports.getDragPreviewOffset = getDragPreviewOffset;
	
	var _BrowserDetector = __webpack_require__(990);
	
	var _MonotonicInterpolant = __webpack_require__(2034);
	
	var _MonotonicInterpolant2 = _interopRequireDefault(_MonotonicInterpolant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint
	   no-mixed-operators: off
	*/
	var ELEMENT_NODE = 1;
	
	function getNodeClientOffset(node) {
		var el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;
	
		if (!el) {
			return null;
		}
	
		var _el$getBoundingClient = el.getBoundingClientRect(),
		    top = _el$getBoundingClient.top,
		    left = _el$getBoundingClient.left;
	
		return { x: left, y: top };
	}
	
	function getEventClientOffset(e) {
		return {
			x: e.clientX,
			y: e.clientY
		};
	}
	
	function isImageNode(node) {
		return node.nodeName === 'IMG' && ((0, _BrowserDetector.isFirefox)() || !document.documentElement.contains(node));
	}
	
	function getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight) {
		var dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
		var dragPreviewHeight = isImage ? dragPreview.height : sourceHeight;
	
		// Work around @2x coordinate discrepancies in browsers
		if ((0, _BrowserDetector.isSafari)() && isImage) {
			dragPreviewHeight /= window.devicePixelRatio;
			dragPreviewWidth /= window.devicePixelRatio;
		}
		return { dragPreviewWidth: dragPreviewWidth, dragPreviewHeight: dragPreviewHeight };
	}
	
	function getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
		// The browsers will use the image intrinsic size under different conditions.
		// Firefox only cares if it's an image, but WebKit also wants it to be detached.
		var isImage = isImageNode(dragPreview);
		var dragPreviewNode = isImage ? sourceNode : dragPreview;
		var dragPreviewNodeOffsetFromClient = getNodeClientOffset(dragPreviewNode);
		var offsetFromDragPreview = {
			x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
			y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
		};
		var sourceWidth = sourceNode.offsetWidth,
		    sourceHeight = sourceNode.offsetHeight;
		var anchorX = anchorPoint.anchorX,
		    anchorY = anchorPoint.anchorY;
	
		var _getDragPreviewSize = getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight),
		    dragPreviewWidth = _getDragPreviewSize.dragPreviewWidth,
		    dragPreviewHeight = _getDragPreviewSize.dragPreviewHeight;
	
		var calculateYOffset = function calculateYOffset() {
			var interpolantY = new _MonotonicInterpolant2.default([0, 0.5, 1], [
			// Dock to the top
			offsetFromDragPreview.y,
			// Align at the center
			offsetFromDragPreview.y / sourceHeight * dragPreviewHeight,
			// Dock to the bottom
			offsetFromDragPreview.y + dragPreviewHeight - sourceHeight]);
			var y = interpolantY.interpolate(anchorY);
			// Work around Safari 8 positioning bug
			if ((0, _BrowserDetector.isSafari)() && isImage) {
				// We'll have to wait for @3x to see if this is entirely correct
				y += (window.devicePixelRatio - 1) * dragPreviewHeight;
			}
			return y;
		};
	
		var calculateXOffset = function calculateXOffset() {
			// Interpolate coordinates depending on anchor point
			// If you know a simpler way to do this, let me know
			var interpolantX = new _MonotonicInterpolant2.default([0, 0.5, 1], [
			// Dock to the left
			offsetFromDragPreview.x,
			// Align at the center
			offsetFromDragPreview.x / sourceWidth * dragPreviewWidth,
			// Dock to the right
			offsetFromDragPreview.x + dragPreviewWidth - sourceWidth]);
			return interpolantX.interpolate(anchorX);
		};
	
		// Force offsets if specified in the options.
		var offsetX = offsetPoint.offsetX,
		    offsetY = offsetPoint.offsetY;
	
		var isManualOffsetX = offsetX === 0 || offsetX;
		var isManualOffsetY = offsetY === 0 || offsetY;
		return {
			x: isManualOffsetX ? offsetX : calculateXOffset(),
			y: isManualOffsetY ? offsetY : calculateYOffset()
		};
	}

/***/ },
/* 2037 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = getEmptyImage;
	var emptyImage = void 0;
	function getEmptyImage() {
		if (!emptyImage) {
			emptyImage = new Image();
			emptyImage.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
		}
	
		return emptyImage;
	}

/***/ },
/* 2038 */
517,
/* 2039 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(2);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DragDropContext = __webpack_require__(992);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This class is a React-Component based version of the DragDropContext.
	 * This is an alternative to decorating an application component with an ES7 decorator.
	 */
	var DragDropContextProvider = (_temp = _class = function (_Component) {
		_inherits(DragDropContextProvider, _Component);
	
		function DragDropContextProvider(props, context) {
			_classCallCheck(this, DragDropContextProvider);
	
			/**
	   * This property determines which window global to use for creating the DragDropManager.
	   * If a window has been injected explicitly via props, that is used first. If it is available
	   * as a context value, then use that, otherwise use the browser global.
	   */
			var _this = _possibleConstructorReturn(this, (DragDropContextProvider.__proto__ || Object.getPrototypeOf(DragDropContextProvider)).call(this, props, context));
	
			var getWindow = function getWindow() {
				if (props && props.window) {
					return props.window;
				} else if (context && context.window) {
					return context.window;
				} else if (typeof window !== 'undefined') {
					return window;
				}
				return undefined;
			};
	
			_this.backend = (0, _DragDropContext.unpackBackendForEs5Users)(props.backend);
			_this.childContext = (0, _DragDropContext.createChildContext)(_this.backend, {
				window: getWindow()
			});
			return _this;
		}
	
		_createClass(DragDropContextProvider, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.backend !== this.props.backend || nextProps.window !== this.props.window) {
					throw new Error('DragDropContextProvider backend and window props must not change.');
				}
			}
		}, {
			key: 'getChildContext',
			value: function getChildContext() {
				return this.childContext;
			}
		}, {
			key: 'render',
			value: function render() {
				return _react.Children.only(this.props.children);
			}
		}]);
	
		return DragDropContextProvider;
	}(_react.Component), _class.propTypes = {
		backend: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]).isRequired,
		children: _propTypes2.default.element.isRequired,
		window: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types
	}, _class.defaultProps = {
		window: undefined
	}, _class.childContextTypes = _DragDropContext.CHILD_CONTEXT_TYPES, _class.displayName = 'DragDropContextProvider', _class.contextTypes = {
		window: _propTypes2.default.object
	}, _temp);
	exports.default = DragDropContextProvider;

/***/ },
/* 2040 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = DragLayer;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(518);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _isPlainObject = __webpack_require__(126);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _shallowEqual = __webpack_require__(517);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _shallowEqualScalar = __webpack_require__(996);
	
	var _shallowEqualScalar2 = _interopRequireDefault(_shallowEqualScalar);
	
	var _checkDecoratorArguments = __webpack_require__(368);
	
	var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function DragLayer(collect) {
		var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		_checkDecoratorArguments2.default.apply(undefined, ['DragLayer', 'collect[, options]'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params
		(0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the first argument to DragLayer to be a function that collects props to inject into the component. ', 'Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drag-layer.html', collect);
		(0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the second argument to DragLayer to be a plain object when specified. ' + 'Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drag-layer.html', options);
	
		return function decorateLayer(DecoratedComponent) {
			var _class, _temp;
	
			var _options$arePropsEqua = options.arePropsEqual,
			    arePropsEqual = _options$arePropsEqua === undefined ? _shallowEqualScalar2.default : _options$arePropsEqua;
	
			var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
	
			var DragLayerContainer = (_temp = _class = function (_Component) {
				_inherits(DragLayerContainer, _Component);
	
				_createClass(DragLayerContainer, [{
					key: 'getDecoratedComponentInstance',
					value: function getDecoratedComponentInstance() {
						(0, _invariant2.default)(this.child, 'In order to access an instance of the decorated component it can not be a stateless component.');
						return this.child;
					}
				}, {
					key: 'shouldComponentUpdate',
					value: function shouldComponentUpdate(nextProps, nextState) {
						return !arePropsEqual(nextProps, this.props) || !(0, _shallowEqual2.default)(nextState, this.state);
					}
				}]);
	
				function DragLayerContainer(props, context) {
					_classCallCheck(this, DragLayerContainer);
	
					var _this = _possibleConstructorReturn(this, (DragLayerContainer.__proto__ || Object.getPrototypeOf(DragLayerContainer)).call(this, props));
	
					_this.handleChange = _this.handleChange.bind(_this);
	
					_this.manager = context.dragDropManager;
					(0, _invariant2.default)(_typeof(_this.manager) === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to wrap the top-level component of your app with DragDropContext. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);
	
					_this.state = _this.getCurrentState();
					return _this;
				}
	
				_createClass(DragLayerContainer, [{
					key: 'componentDidMount',
					value: function componentDidMount() {
						this.isCurrentlyMounted = true;
	
						var monitor = this.manager.getMonitor();
						this.unsubscribeFromOffsetChange = monitor.subscribeToOffsetChange(this.handleChange);
						this.unsubscribeFromStateChange = monitor.subscribeToStateChange(this.handleChange);
	
						this.handleChange();
					}
				}, {
					key: 'componentWillUnmount',
					value: function componentWillUnmount() {
						this.isCurrentlyMounted = false;
	
						this.unsubscribeFromOffsetChange();
						this.unsubscribeFromStateChange();
					}
				}, {
					key: 'handleChange',
					value: function handleChange() {
						if (!this.isCurrentlyMounted) {
							return;
						}
	
						var nextState = this.getCurrentState();
						if (!(0, _shallowEqual2.default)(nextState, this.state)) {
							this.setState(nextState);
						}
					}
				}, {
					key: 'getCurrentState',
					value: function getCurrentState() {
						var monitor = this.manager.getMonitor();
						return collect(monitor, this.props);
					}
				}, {
					key: 'render',
					value: function render() {
						var _this2 = this;
	
						return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, this.state, {
							ref: function ref(child) {
								_this2.child = child;
							}
						}));
					}
				}]);
	
				return DragLayerContainer;
			}(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = 'DragLayer(' + displayName + ')', _class.contextTypes = {
				dragDropManager: _propTypes2.default.object.isRequired
			}, _temp);
	
	
			return (0, _hoistNonReactStatics2.default)(DragLayerContainer, DecoratedComponent);
		};
	}

/***/ },
/* 2041 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = DragSource;
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isPlainObject = __webpack_require__(126);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _checkDecoratorArguments = __webpack_require__(368);
	
	var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
	
	var _decorateHandler = __webpack_require__(994);
	
	var _decorateHandler2 = _interopRequireDefault(_decorateHandler);
	
	var _registerSource = __webpack_require__(2049);
	
	var _registerSource2 = _interopRequireDefault(_registerSource);
	
	var _createSourceFactory = __webpack_require__(2044);
	
	var _createSourceFactory2 = _interopRequireDefault(_createSourceFactory);
	
	var _createSourceMonitor = __webpack_require__(2045);
	
	var _createSourceMonitor2 = _interopRequireDefault(_createSourceMonitor);
	
	var _createSourceConnector = __webpack_require__(2043);
	
	var _createSourceConnector2 = _interopRequireDefault(_createSourceConnector);
	
	var _isValidType = __webpack_require__(995);
	
	var _isValidType2 = _interopRequireDefault(_isValidType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DragSource(type, spec, collect) {
		var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
		_checkDecoratorArguments2.default.apply(undefined, ['DragSource', 'type, spec, collect[, options]'].concat(Array.prototype.slice.call(arguments)));
		var getType = type;
		if (typeof type !== 'function') {
			(0, _invariant2.default)((0, _isValidType2.default)(type), 'Expected "type" provided as the first argument to DragSource to be ' + 'a string, or a function that returns a string given the current props. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', type);
			getType = function getType() {
				return type;
			};
		}
		(0, _invariant2.default)((0, _isPlainObject2.default)(spec), 'Expected "spec" provided as the second argument to DragSource to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', spec);
		var createSource = (0, _createSourceFactory2.default)(spec);
		(0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the third argument to DragSource to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', collect);
		(0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the fourth argument to DragSource to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', collect);
	
		return function decorateSource(DecoratedComponent) {
			return (0, _decorateHandler2.default)({
				connectBackend: function connectBackend(backend, sourceId) {
					return backend.connectDragSource(sourceId);
				},
				containerDisplayName: 'DragSource',
				createHandler: createSource,
				registerHandler: _registerSource2.default,
				createMonitor: _createSourceMonitor2.default,
				createConnector: _createSourceConnector2.default,
				DecoratedComponent: DecoratedComponent,
				getType: getType,
				collect: collect,
				options: options
			});
		};
	}

/***/ },
/* 2042 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = DropTarget;
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isPlainObject = __webpack_require__(126);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _checkDecoratorArguments = __webpack_require__(368);
	
	var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
	
	var _decorateHandler = __webpack_require__(994);
	
	var _decorateHandler2 = _interopRequireDefault(_decorateHandler);
	
	var _registerTarget = __webpack_require__(2050);
	
	var _registerTarget2 = _interopRequireDefault(_registerTarget);
	
	var _createTargetFactory = __webpack_require__(2047);
	
	var _createTargetFactory2 = _interopRequireDefault(_createTargetFactory);
	
	var _createTargetMonitor = __webpack_require__(2048);
	
	var _createTargetMonitor2 = _interopRequireDefault(_createTargetMonitor);
	
	var _createTargetConnector = __webpack_require__(2046);
	
	var _createTargetConnector2 = _interopRequireDefault(_createTargetConnector);
	
	var _isValidType = __webpack_require__(995);
	
	var _isValidType2 = _interopRequireDefault(_isValidType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DropTarget(type, spec, collect) {
		var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
		_checkDecoratorArguments2.default.apply(undefined, ['DropTarget', 'type, spec, collect[, options]'].concat(Array.prototype.slice.call(arguments)));
		var getType = type;
		if (typeof type !== 'function') {
			(0, _invariant2.default)((0, _isValidType2.default)(type, true), 'Expected "type" provided as the first argument to DropTarget to be ' + 'a string, an array of strings, or a function that returns either given ' + 'the current props. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', type);
			getType = function getType() {
				return type;
			};
		}
		(0, _invariant2.default)((0, _isPlainObject2.default)(spec), 'Expected "spec" provided as the second argument to DropTarget to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', spec);
		var createTarget = (0, _createTargetFactory2.default)(spec);
		(0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the third argument to DropTarget to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', collect);
		(0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the fourth argument to DropTarget to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', collect);
	
		return function decorateTarget(DecoratedComponent) {
			return (0, _decorateHandler2.default)({
				connectBackend: function connectBackend(backend, targetId) {
					return backend.connectDropTarget(targetId);
				},
				containerDisplayName: 'DropTarget',
				createHandler: createTarget,
				registerHandler: _registerTarget2.default,
				createMonitor: _createTargetMonitor2.default,
				createConnector: _createTargetConnector2.default,
				DecoratedComponent: DecoratedComponent,
				getType: getType,
				collect: collect,
				options: options
			});
		};
	}

/***/ },
/* 2043 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = createSourceConnector;
	
	var _wrapConnectorHooks = __webpack_require__(997);
	
	var _wrapConnectorHooks2 = _interopRequireDefault(_wrapConnectorHooks);
	
	var _areOptionsEqual = __webpack_require__(993);
	
	var _areOptionsEqual2 = _interopRequireDefault(_areOptionsEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createSourceConnector(backend) {
		var currentHandlerId = void 0;
	
		var currentDragSourceNode = void 0;
		var currentDragSourceOptions = void 0;
		var disconnectCurrentDragSource = void 0;
	
		var currentDragPreviewNode = void 0;
		var currentDragPreviewOptions = void 0;
		var disconnectCurrentDragPreview = void 0;
	
		function reconnectDragSource() {
			if (disconnectCurrentDragSource) {
				disconnectCurrentDragSource();
				disconnectCurrentDragSource = null;
			}
	
			if (currentHandlerId && currentDragSourceNode) {
				disconnectCurrentDragSource = backend.connectDragSource(currentHandlerId, currentDragSourceNode, currentDragSourceOptions);
			}
		}
	
		function reconnectDragPreview() {
			if (disconnectCurrentDragPreview) {
				disconnectCurrentDragPreview();
				disconnectCurrentDragPreview = null;
			}
	
			if (currentHandlerId && currentDragPreviewNode) {
				disconnectCurrentDragPreview = backend.connectDragPreview(currentHandlerId, currentDragPreviewNode, currentDragPreviewOptions);
			}
		}
	
		function receiveHandlerId(handlerId) {
			if (handlerId === currentHandlerId) {
				return;
			}
	
			currentHandlerId = handlerId;
			reconnectDragSource();
			reconnectDragPreview();
		}
	
		var hooks = (0, _wrapConnectorHooks2.default)({
			dragSource: function connectDragSource(node, options) {
				if (node === currentDragSourceNode && (0, _areOptionsEqual2.default)(options, currentDragSourceOptions)) {
					return;
				}
	
				currentDragSourceNode = node;
				currentDragSourceOptions = options;
	
				reconnectDragSource();
			},
	
			dragPreview: function connectDragPreview(node, options) {
				if (node === currentDragPreviewNode && (0, _areOptionsEqual2.default)(options, currentDragPreviewOptions)) {
					return;
				}
	
				currentDragPreviewNode = node;
				currentDragPreviewOptions = options;
	
				reconnectDragPreview();
			}
		});
	
		return {
			receiveHandlerId: receiveHandlerId,
			hooks: hooks
		};
	}

/***/ },
/* 2044 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createSourceFactory;
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isPlainObject = __webpack_require__(126);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ALLOWED_SPEC_METHODS = ['canDrag', 'beginDrag', 'isDragging', 'endDrag'];
	var REQUIRED_SPEC_METHODS = ['beginDrag'];
	
	function createSourceFactory(spec) {
		Object.keys(spec).forEach(function (key) {
			(0, _invariant2.default)(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drag source specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', ALLOWED_SPEC_METHODS.join(', '), key);
			(0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', key, key, spec[key]);
		});
		REQUIRED_SPEC_METHODS.forEach(function (key) {
			(0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', key, key, spec[key]);
		});
	
		var Source = function () {
			function Source(monitor) {
				_classCallCheck(this, Source);
	
				this.monitor = monitor;
				this.props = null;
				this.component = null;
			}
	
			_createClass(Source, [{
				key: 'receiveProps',
				value: function receiveProps(props) {
					this.props = props;
				}
			}, {
				key: 'receiveComponent',
				value: function receiveComponent(component) {
					this.component = component;
				}
			}, {
				key: 'canDrag',
				value: function canDrag() {
					if (!spec.canDrag) {
						return true;
					}
	
					return spec.canDrag(this.props, this.monitor);
				}
			}, {
				key: 'isDragging',
				value: function isDragging(globalMonitor, sourceId) {
					if (!spec.isDragging) {
						return sourceId === globalMonitor.getSourceId();
					}
	
					return spec.isDragging(this.props, this.monitor);
				}
			}, {
				key: 'beginDrag',
				value: function beginDrag() {
					var item = spec.beginDrag(this.props, this.monitor, this.component);
					if (false) {
						(0, _invariant2.default)((0, _isPlainObject2.default)(item), 'beginDrag() must return a plain object that represents the dragged item. ' + 'Instead received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', item);
					}
					return item;
				}
			}, {
				key: 'endDrag',
				value: function endDrag() {
					if (!spec.endDrag) {
						return;
					}
	
					spec.endDrag(this.props, this.monitor, this.component);
				}
			}]);
	
			return Source;
		}();
	
		return function createSource(monitor) {
			return new Source(monitor);
		};
	}

/***/ },
/* 2045 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createSourceMonitor;
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var isCallingCanDrag = false;
	var isCallingIsDragging = false;
	
	var SourceMonitor = function () {
		function SourceMonitor(manager) {
			_classCallCheck(this, SourceMonitor);
	
			this.internalMonitor = manager.getMonitor();
		}
	
		_createClass(SourceMonitor, [{
			key: 'receiveHandlerId',
			value: function receiveHandlerId(sourceId) {
				this.sourceId = sourceId;
			}
		}, {
			key: 'canDrag',
			value: function canDrag() {
				(0, _invariant2.default)(!isCallingCanDrag, 'You may not call monitor.canDrag() inside your canDrag() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source-monitor.html');
	
				try {
					isCallingCanDrag = true;
					return this.internalMonitor.canDragSource(this.sourceId);
				} finally {
					isCallingCanDrag = false;
				}
			}
		}, {
			key: 'isDragging',
			value: function isDragging() {
				(0, _invariant2.default)(!isCallingIsDragging, 'You may not call monitor.isDragging() inside your isDragging() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source-monitor.html');
	
				try {
					isCallingIsDragging = true;
					return this.internalMonitor.isDraggingSource(this.sourceId);
				} finally {
					isCallingIsDragging = false;
				}
			}
		}, {
			key: 'getItemType',
			value: function getItemType() {
				return this.internalMonitor.getItemType();
			}
		}, {
			key: 'getItem',
			value: function getItem() {
				return this.internalMonitor.getItem();
			}
		}, {
			key: 'getDropResult',
			value: function getDropResult() {
				return this.internalMonitor.getDropResult();
			}
		}, {
			key: 'didDrop',
			value: function didDrop() {
				return this.internalMonitor.didDrop();
			}
		}, {
			key: 'getInitialClientOffset',
			value: function getInitialClientOffset() {
				return this.internalMonitor.getInitialClientOffset();
			}
		}, {
			key: 'getInitialSourceClientOffset',
			value: function getInitialSourceClientOffset() {
				return this.internalMonitor.getInitialSourceClientOffset();
			}
		}, {
			key: 'getSourceClientOffset',
			value: function getSourceClientOffset() {
				return this.internalMonitor.getSourceClientOffset();
			}
		}, {
			key: 'getClientOffset',
			value: function getClientOffset() {
				return this.internalMonitor.getClientOffset();
			}
		}, {
			key: 'getDifferenceFromInitialOffset',
			value: function getDifferenceFromInitialOffset() {
				return this.internalMonitor.getDifferenceFromInitialOffset();
			}
		}]);
	
		return SourceMonitor;
	}();
	
	function createSourceMonitor(manager) {
		return new SourceMonitor(manager);
	}

/***/ },
/* 2046 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = createTargetConnector;
	
	var _wrapConnectorHooks = __webpack_require__(997);
	
	var _wrapConnectorHooks2 = _interopRequireDefault(_wrapConnectorHooks);
	
	var _areOptionsEqual = __webpack_require__(993);
	
	var _areOptionsEqual2 = _interopRequireDefault(_areOptionsEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createTargetConnector(backend) {
		var currentHandlerId = void 0;
	
		var currentDropTargetNode = void 0;
		var currentDropTargetOptions = void 0;
		var disconnectCurrentDropTarget = void 0;
	
		function reconnectDropTarget() {
			if (disconnectCurrentDropTarget) {
				disconnectCurrentDropTarget();
				disconnectCurrentDropTarget = null;
			}
	
			if (currentHandlerId && currentDropTargetNode) {
				disconnectCurrentDropTarget = backend.connectDropTarget(currentHandlerId, currentDropTargetNode, currentDropTargetOptions);
			}
		}
	
		function receiveHandlerId(handlerId) {
			if (handlerId === currentHandlerId) {
				return;
			}
	
			currentHandlerId = handlerId;
			reconnectDropTarget();
		}
	
		var hooks = (0, _wrapConnectorHooks2.default)({
			dropTarget: function connectDropTarget(node, options) {
				if (node === currentDropTargetNode && (0, _areOptionsEqual2.default)(options, currentDropTargetOptions)) {
					return;
				}
	
				currentDropTargetNode = node;
				currentDropTargetOptions = options;
	
				reconnectDropTarget();
			}
		});
	
		return {
			receiveHandlerId: receiveHandlerId,
			hooks: hooks
		};
	}

/***/ },
/* 2047 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createTargetFactory;
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isPlainObject = __webpack_require__(126);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ALLOWED_SPEC_METHODS = ['canDrop', 'hover', 'drop'];
	
	function createTargetFactory(spec) {
		Object.keys(spec).forEach(function (key) {
			(0, _invariant2.default)(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drop target specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', ALLOWED_SPEC_METHODS.join(', '), key);
			(0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drop target specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', key, key, spec[key]);
		});
	
		var Target = function () {
			function Target(monitor) {
				_classCallCheck(this, Target);
	
				this.monitor = monitor;
				this.props = null;
				this.component = null;
			}
	
			_createClass(Target, [{
				key: 'receiveProps',
				value: function receiveProps(props) {
					this.props = props;
				}
			}, {
				key: 'receiveMonitor',
				value: function receiveMonitor(monitor) {
					this.monitor = monitor;
				}
			}, {
				key: 'receiveComponent',
				value: function receiveComponent(component) {
					this.component = component;
				}
			}, {
				key: 'canDrop',
				value: function canDrop() {
					if (!spec.canDrop) {
						return true;
					}
	
					return spec.canDrop(this.props, this.monitor);
				}
			}, {
				key: 'hover',
				value: function hover() {
					if (!spec.hover) {
						return;
					}
	
					spec.hover(this.props, this.monitor, this.component);
				}
			}, {
				key: 'drop',
				value: function drop() {
					if (!spec.drop) {
						return undefined;
					}
	
					var dropResult = spec.drop(this.props, this.monitor, this.component);
					if (false) {
						(0, _invariant2.default)(typeof dropResult === 'undefined' || (0, _isPlainObject2.default)(dropResult), 'drop() must either return undefined, or an object that represents the drop result. ' + 'Instead received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', dropResult);
					}
					return dropResult;
				}
			}]);
	
			return Target;
		}();
	
		return function createTarget(monitor) {
			return new Target(monitor);
		};
	}

/***/ },
/* 2048 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createTargetMonitor;
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var isCallingCanDrop = false;
	
	var TargetMonitor = function () {
		function TargetMonitor(manager) {
			_classCallCheck(this, TargetMonitor);
	
			this.internalMonitor = manager.getMonitor();
		}
	
		_createClass(TargetMonitor, [{
			key: 'receiveHandlerId',
			value: function receiveHandlerId(targetId) {
				this.targetId = targetId;
			}
		}, {
			key: 'canDrop',
			value: function canDrop() {
				(0, _invariant2.default)(!isCallingCanDrop, 'You may not call monitor.canDrop() inside your canDrop() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target-monitor.html');
	
				try {
					isCallingCanDrop = true;
					return this.internalMonitor.canDropOnTarget(this.targetId);
				} finally {
					isCallingCanDrop = false;
				}
			}
		}, {
			key: 'isOver',
			value: function isOver(options) {
				return this.internalMonitor.isOverTarget(this.targetId, options);
			}
		}, {
			key: 'getItemType',
			value: function getItemType() {
				return this.internalMonitor.getItemType();
			}
		}, {
			key: 'getItem',
			value: function getItem() {
				return this.internalMonitor.getItem();
			}
		}, {
			key: 'getDropResult',
			value: function getDropResult() {
				return this.internalMonitor.getDropResult();
			}
		}, {
			key: 'didDrop',
			value: function didDrop() {
				return this.internalMonitor.didDrop();
			}
		}, {
			key: 'getInitialClientOffset',
			value: function getInitialClientOffset() {
				return this.internalMonitor.getInitialClientOffset();
			}
		}, {
			key: 'getInitialSourceClientOffset',
			value: function getInitialSourceClientOffset() {
				return this.internalMonitor.getInitialSourceClientOffset();
			}
		}, {
			key: 'getSourceClientOffset',
			value: function getSourceClientOffset() {
				return this.internalMonitor.getSourceClientOffset();
			}
		}, {
			key: 'getClientOffset',
			value: function getClientOffset() {
				return this.internalMonitor.getClientOffset();
			}
		}, {
			key: 'getDifferenceFromInitialOffset',
			value: function getDifferenceFromInitialOffset() {
				return this.internalMonitor.getDifferenceFromInitialOffset();
			}
		}]);
	
		return TargetMonitor;
	}();
	
	function createTargetMonitor(manager) {
		return new TargetMonitor(manager);
	}

/***/ },
/* 2049 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = registerSource;
	function registerSource(type, source, manager) {
		var registry = manager.getRegistry();
		var sourceId = registry.addSource(type, source);
	
		function unregisterSource() {
			registry.removeSource(sourceId);
		}
	
		return {
			handlerId: sourceId,
			unregister: unregisterSource
		};
	}

/***/ },
/* 2050 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = registerTarget;
	function registerTarget(type, target, manager) {
		var registry = manager.getRegistry();
		var targetId = registry.addTarget(type, target);
	
		function unregisterTarget() {
			registry.removeTarget(targetId);
		}
	
		return {
			handlerId: targetId,
			unregister: unregisterTarget
		};
	}

/***/ },
/* 2051 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = cloneWithRef;
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function cloneWithRef(element, newRef) {
		var previousRef = element.ref;
		(0, _invariant2.default)(typeof previousRef !== 'string', 'Cannot connect React DnD to an element with an existing string ref. ' + 'Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. ' + 'Read more: https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute');
	
		if (!previousRef) {
			// When there is no ref on the element, use the new ref directly
			return (0, _react.cloneElement)(element, {
				ref: newRef
			});
		}
	
		return (0, _react.cloneElement)(element, {
			ref: function ref(node) {
				newRef(node);
	
				if (previousRef) {
					previousRef(node);
				}
			}
		});
	}

/***/ },
/* 2052 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.14.0
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(2),n=__webpack_require__(32),r=__webpack_require__(2259);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
	function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
	function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
	function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
	function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
	function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
	function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
	function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
	["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
	Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
	C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
	function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
	60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
	function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
	"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
	function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
	function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
	function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
	function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
	function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
	ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
	var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
	function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
	function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
	c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
	function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
	function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
	function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
	function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
	ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
	var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
	function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
	function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
	function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
	function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
	function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
	function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
	var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
	"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
	ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
	ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
	var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
	function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
	function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
	var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
	floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
	function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
	function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
	function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
	function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
	function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
	function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
	function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
	function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
	function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
	function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
	b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
	function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
	function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
	function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
	n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
	b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
	function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
	var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
	function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
	function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
	var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
	b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
	var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
	function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
	var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
	Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
	var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
	var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
	dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
	a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
	k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
	function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
	var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
	function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
	var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
	case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
	a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
	a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
	Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
	We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
	function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
	function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
	function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
	var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
	function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
	function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
	function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
	function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
	function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
	function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
	function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
	ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
	(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
	function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
	var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
	c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
	function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
	function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
	(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
	function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
	function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
	function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
	c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
	nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
	a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
	m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
	if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
	q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
	k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
	d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
	function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
	function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
	var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
	function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
	function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
	function vh(a,b){return"function"===typeof b?b(a):b}
	function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
	(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
	function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
	function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
	function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
	function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
	function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
	function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
	d)}}
	var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
	b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
	c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
	wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
	b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
	function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
	function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
	function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
	function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
	function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
	function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
	function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
	"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
	typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
	typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
	x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
	("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
	function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
	var ii={dehydrated:null,retryTime:0};
	function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
	b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
	c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
	function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
	function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
	null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
	function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
	ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
	pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
	h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
	c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
	qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
	function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
	return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
	{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
	(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
	a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
	d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
	break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
	c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
	e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
	64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
	e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
	b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
	b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
	var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
	function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
	function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
	function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
	case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
	function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
	function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
	function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
	if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
	function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
	function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
	function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
	f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
	function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
	case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
	d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
	f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
	var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
	function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
	var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
	function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
	function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
	function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
	function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
	function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
	b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
	function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
	c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
	d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
	Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
	function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
	function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
	function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
	function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
	null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
	break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
	jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
	function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
	function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
	a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
	function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
	d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
	m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
	null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
	-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
	(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
	top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
	null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
	function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
	function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
	function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
	Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
	if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
	b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
	null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
	case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
	null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
	b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
	k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
	g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
	b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
	function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
	function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
	function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
	firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
	function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
	10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
	function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
	function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
	function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
	function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
	function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
	d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
	function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
	function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
	function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
	za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
	Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
	(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
	rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
	exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
	exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
	exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ },
/* 2053 */
/***/ function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ },
/* 2054 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(2);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _storeShape = __webpack_require__(998);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(999);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    return _react.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _propTypes2["default"].element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};

/***/ },
/* 2055 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = connect;
	
	var _react = __webpack_require__(2);
	
	var _storeShape = __webpack_require__(998);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(2056);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(2057);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__(999);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__(126);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(210);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = void 0;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure,
	      pure = _options$pure === undefined ? true : _options$pure,
	      _options$withRef = options.withRef,
	      withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (false) {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (false) {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (false) {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged,
	            hasStoreStateChanged = this.hasStoreStateChanged,
	            haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
	            statePropsPrecalculationError = this.statePropsPrecalculationError,
	            renderedElement = this.renderedElement;
	
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 2056 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 2057 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(553);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ },
/* 2058 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = routerMiddleware;
	
	var _actions = __webpack_require__(1000);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
	 * provided history object. This will prevent these actions from reaching your
	 * reducer or any middleware that comes after this one.
	 */
	function routerMiddleware(history) {
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (action.type !== _actions.CALL_HISTORY_METHOD) {
	          return next(action);
	        }
	
	        var _action$payload = action.payload,
	            method = _action$payload.method,
	            args = _action$payload.args;
	
	        history[method].apply(history, _toConsumableArray(args));
	      };
	    };
	  };
	}

/***/ },
/* 2059 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = syncHistoryWithStore;
	
	var _reducer = __webpack_require__(1001);
	
	var defaultSelectLocationState = function defaultSelectLocationState(state) {
	  return state.routing;
	};
	
	/**
	 * This function synchronizes your history state with the Redux store.
	 * Location changes flow from history to the store. An enhanced history is
	 * returned with a listen method that responds to store updates for location.
	 *
	 * When this history is provided to the router, this means the location data
	 * will flow like this:
	 * history.push -> store.dispatch -> enhancedHistory.listen -> router
	 * This ensures that when the store state changes due to a replay or other
	 * event, the router will be updated appropriately and can transition to the
	 * correct router state.
	 */
	function syncHistoryWithStore(history, store) {
	  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      _ref$selectLocationSt = _ref.selectLocationState,
	      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
	      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
	      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;
	
	  // Ensure that the reducer is mounted on the store and functioning properly.
	  if (typeof selectLocationState(store.getState()) === 'undefined') {
	    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
	  }
	
	  var initialLocation = void 0;
	  var isTimeTraveling = void 0;
	  var unsubscribeFromStore = void 0;
	  var unsubscribeFromHistory = void 0;
	  var currentLocation = void 0;
	
	  // What does the store say about current location?
	  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
	    var locationState = selectLocationState(store.getState());
	    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
	  };
	
	  // Init initialLocation with potential location in store
	  initialLocation = getLocationInStore();
	
	  // If the store is replayed, update the URL in the browser to match.
	  if (adjustUrlOnReplay) {
	    var handleStoreChange = function handleStoreChange() {
	      var locationInStore = getLocationInStore(true);
	      if (currentLocation === locationInStore || initialLocation === locationInStore) {
	        return;
	      }
	
	      // Update address bar to reflect store state
	      isTimeTraveling = true;
	      currentLocation = locationInStore;
	      history.transitionTo(_extends({}, locationInStore, {
	        action: 'PUSH'
	      }));
	      isTimeTraveling = false;
	    };
	
	    unsubscribeFromStore = store.subscribe(handleStoreChange);
	    handleStoreChange();
	  }
	
	  // Whenever location changes, dispatch an action to get it in the store
	  var handleLocationChange = function handleLocationChange(location) {
	    // ... unless we just caused that location change
	    if (isTimeTraveling) {
	      return;
	    }
	
	    // Remember where we are
	    currentLocation = location;
	
	    // Are we being called for the first time?
	    if (!initialLocation) {
	      // Remember as a fallback in case state is reset
	      initialLocation = location;
	
	      // Respect persisted location, if any
	      if (getLocationInStore()) {
	        return;
	      }
	    }
	
	    // Tell the store to update by dispatching an action
	    store.dispatch({
	      type: _reducer.LOCATION_CHANGE,
	      payload: location
	    });
	  };
	  unsubscribeFromHistory = history.listen(handleLocationChange);
	
	  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
	  if (history.getCurrentLocation) {
	    handleLocationChange(history.getCurrentLocation());
	  }
	
	  // The enhanced history uses store as source of truth
	  return _extends({}, history, {
	    // The listeners are subscribed to the store instead of history
	    listen: function listen(listener) {
	      // Copy of last location.
	      var lastPublishedLocation = getLocationInStore(true);
	
	      // Keep track of whether we unsubscribed, as Redux store
	      // only applies changes in subscriptions on next dispatch
	      var unsubscribed = false;
	      var unsubscribeFromStore = store.subscribe(function () {
	        var currentLocation = getLocationInStore(true);
	        if (currentLocation === lastPublishedLocation) {
	          return;
	        }
	        lastPublishedLocation = currentLocation;
	        if (!unsubscribed) {
	          listener(lastPublishedLocation);
	        }
	      });
	
	      // History 2.x listeners expect a synchronous call. Make the first call to the
	      // listener after subscribing to the store, in case the listener causes a
	      // location change (e.g. when it redirects)
	      if (!history.getCurrentLocation) {
	        listener(lastPublishedLocation);
	      }
	
	      // Let user unsubscribe later
	      return function () {
	        unsubscribed = true;
	        unsubscribeFromStore();
	      };
	    },
	
	
	    // It also provides a way to destroy internal listeners
	    unsubscribe: function unsubscribe() {
	      if (adjustUrlOnReplay) {
	        unsubscribeFromStore();
	      }
	      unsubscribeFromHistory();
	    }
	  });
	}

/***/ },
/* 2060 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(104);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _Link = __webpack_require__(1002);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = (0, _createReactClass2.default)({
	  displayName: 'IndexLink',
	
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 2061 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(104);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(4);
	
	var _routerWarning = __webpack_require__(220);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(1004);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(282);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRedirect = (0, _createReactClass2.default)({
	  displayName: 'IndexRedirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 2062 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(104);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(4);
	
	var _routerWarning = __webpack_require__(220);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(148);
	
	var _InternalPropTypes = __webpack_require__(282);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRoute = (0, _createReactClass2.default)({
	  displayName: 'IndexRoute',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 2063 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(104);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(4);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(148);
	
	var _InternalPropTypes = __webpack_require__(282);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	/* eslint-disable react/require-render-return */
	var Route = (0, _createReactClass2.default)({
	  displayName: 'Route',
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 2064 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(104);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(4);
	
	var _createTransitionManager2 = __webpack_require__(1008);
	
	var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);
	
	var _InternalPropTypes = __webpack_require__(282);
	
	var _RouterContext = __webpack_require__(522);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(148);
	
	var _RouterUtils = __webpack_require__(1005);
	
	var _routerWarning = __webpack_require__(220);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  history: _propTypes.object,
	  children: _InternalPropTypes.routes,
	  routes: _InternalPropTypes.routes, // alias for children
	  render: _propTypes.func,
	  createElement: _propTypes.func,
	  onError: _propTypes.func,
	  onUpdate: _propTypes.func,
	
	  // PRIVATE: For client-side rehydration of server match.
	  matchContext: _propTypes.object
	};
	
	var prefixUnsafeLifecycleMethods = typeof _react2.default.forwardRef !== 'undefined';
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	var Router = (0, _createReactClass2.default)({
	  displayName: 'Router',
	
	  propTypes: propTypes,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  createRouterObject: function createRouterObject(state) {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.router;
	    }
	
	    var history = this.props.history;
	
	    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
	  },
	  createTransitionManager: function createTransitionManager() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.transitionManager;
	    }
	
	    var history = this.props.history;
	    var _props = this.props,
	        routes = _props.routes,
	        children = _props.children;
	
	
	    !history.getCurrentLocation ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : (0, _invariant2.default)(false) : void 0;
	
	    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	  },
	
	
	  // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.transitionManager = this.createTransitionManager();
	    this.router = this.createRouterObject(this.state);
	
	    this._unlisten = this.transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        // Keep the identity of this.router because of a caveat in ContextUtils:
	        // they only work if the object identity is preserved.
	        (0, _RouterUtils.assignRouterState)(_this.router, state);
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	  },
	
	
	  // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state,
	        location = _state.location,
	        routes = _state.routes,
	        params = _state.params,
	        components = _state.components;
	
	    var _props2 = this.props,
	        createElement = _props2.createElement,
	        render = _props2.render,
	        props = _objectWithoutProperties(_props2, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	if (prefixUnsafeLifecycleMethods) {
	  Router.prototype.UNSAFE_componentWillReceiveProps = Router.prototype.componentWillReceiveProps;
	  Router.prototype.UNSAFE_componentWillMount = Router.prototype.componentWillMount;
	  delete Router.prototype.componentWillReceiveProps;
	  delete Router.prototype.componentWillMount;
	}
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 2065 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getTransitionUtils;
	
	var _AsyncUtils = __webpack_require__(519);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PendingHooks = function PendingHooks() {
	  var _this = this;
	
	  _classCallCheck(this, PendingHooks);
	
	  this.hooks = [];
	
	  this.add = function (hook) {
	    return _this.hooks.push(hook);
	  };
	
	  this.remove = function (hook) {
	    return _this.hooks = _this.hooks.filter(function (h) {
	      return h !== hook;
	    });
	  };
	
	  this.has = function (hook) {
	    return _this.hooks.indexOf(hook) !== -1;
	  };
	
	  this.clear = function () {
	    return _this.hooks = [];
	  };
	};
	
	function getTransitionUtils() {
	  var enterHooks = new PendingHooks();
	  var changeHooks = new PendingHooks();
	
	  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
	    var isSync = hook.length < asyncArity;
	
	    var transitionHook = function transitionHook() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      hook.apply(route, args);
	
	      if (isSync) {
	        var callback = args[args.length - 1];
	        // Assume hook executes synchronously and
	        // automatically call the callback.
	        callback();
	      }
	    };
	
	    pendingHooks.add(transitionHook);
	
	    return transitionHook;
	  }
	
	  function getEnterHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
	      return hooks;
	    }, []);
	  }
	
	  function getChangeHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
	      return hooks;
	    }, []);
	  }
	
	  function runTransitionHooks(length, iter, callback) {
	    if (!length) {
	      callback();
	      return;
	    }
	
	    var redirectInfo = void 0;
	    function replace(location) {
	      redirectInfo = location;
	    }
	
	    (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	      iter(index, replace, function (error) {
	        if (error || redirectInfo) {
	          done(error, redirectInfo); // No need to continue.
	        } else {
	          next();
	        }
	      });
	    }, callback);
	  }
	
	  /**
	   * Runs all onEnter hooks in the given array of routes in order
	   * with onEnter(nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runEnterHooks(routes, nextState, callback) {
	    enterHooks.clear();
	    var hooks = getEnterHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (enterHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          enterHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onChange hooks in the given array of routes in order
	   * with onChange(prevState, nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runChangeHooks(routes, state, nextState, callback) {
	    changeHooks.clear();
	    var hooks = getChangeHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (changeHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          changeHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](state, nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onLeave hooks in the given array of routes in order.
	   */
	  function runLeaveHooks(routes, prevState) {
	    for (var i = 0, len = routes.length; i < len; ++i) {
	      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	    }
	  }
	
	  return {
	    runEnterHooks: runEnterHooks,
	    runChangeHooks: runChangeHooks,
	    runLeaveHooks: runLeaveHooks
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 2066 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(522);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(220);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.createElement;
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 2067 */
[2308, 2079, 1007],
/* 2068 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(219);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    var parentIsLeaving = false;
	    leaveRoutes = prevRoutes.filter(function (route) {
	      if (parentIsLeaving) {
	        return true;
	      } else {
	        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	        if (isLeaving) parentIsLeaving = true;
	        return isLeaving;
	      }
	    });
	
	    // onLeave hooks start at the leaf route.
	    leaveRoutes.reverse();
	
	    enterRoutes = [];
	    changeRoutes = [];
	
	    nextRoutes.forEach(function (route) {
	      var isNew = prevRoutes.indexOf(route) === -1;
	      var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	    });
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 2069 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(519);
	
	var _PromiseUtils = __webpack_require__(1003);
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (getComponent) {
	    var componentReturn = getComponent.call(route, nextState, callback);
	    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
	      return callback(null, component);
	    }, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 2070 */
[2309, 219],
/* 2071 */
[2310, 2080, 1007],
/* 2072 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(219);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname,
	      query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 2073 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(370);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(1006);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(1008);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(148);
	
	var _RouterUtils = __webpack_require__(1005);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history,
	      routes = _ref.routes,
	      location = _ref.location,
	      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    location = history.getCurrentLocation();
	  }
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    var renderProps = void 0;
	
	    if (nextState) {
	      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
	      renderProps = _extends({}, nextState, {
	        router: router,
	        matchContext: { transitionManager: transitionManager, router: router }
	      });
	    }
	
	    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 2074 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(519);
	
	var _PromiseUtils = __webpack_require__(1003);
	
	var _PatternUtils = __webpack_require__(219);
	
	var _routerWarning = __webpack_require__(220);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(148);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
	    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
	  }, callback);
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	
	    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
	      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    }, callback);
	  } else if (route.childRoutes || route.getChildRoutes) {
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	        return;
	      }
	
	      var pathless = childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var match = {
	        routes: [route],
	        params: createParams(paramNames, paramValues)
	      };
	
	      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	        if (error) {
	          callback(error);
	        } else {
	          if (Array.isArray(indexRoute)) {
	            var _match$routes;
	
	             false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	              return !route.path;
	            }), 'Index routes should not have paths') : void 0;
	            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	          } else if (indexRoute) {
	             false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	            match.routes.push(indexRoute);
	          }
	
	          callback(null, match);
	        }
	      });
	
	      return;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 2075 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(104);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _hoistNonReactStatics = __webpack_require__(210);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ContextUtils = __webpack_require__(520);
	
	var _PropTypes = __webpack_require__(521);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = (0, _createReactClass2.default)({
	    displayName: 'WithRouter',
	
	    mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      if (!router) {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      }
	
	      var params = router.params,
	          location = router.location,
	          routes = router.routes;
	
	      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 2076 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var isSync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  var done = function done() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    isDone = true;
	
	    if (isSync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = args;
	      return;
	    }
	
	    callback.apply(undefined, args);
	  };
	
	  var next = function next() {
	    if (isDone) return;
	
	    hasNext = true;
	
	    if (isSync) return; // Iterate instead of recursing if possible.
	
	    isSync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work(currentTurn++, next, done);
	    }
	
	    isSync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(undefined, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  };
	
	  next();
	};

/***/ },
/* 2077 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(523);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _warning = __webpack_require__(132);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _LocationUtils = __webpack_require__(221);
	
	var _DOMUtils = __webpack_require__(371);
	
	var _DOMStateStorage = __webpack_require__(1011);
	
	var _PathUtils = __webpack_require__(149);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
	  var path = pathCoder.decodePath(getHashPath());
	  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);
	
	  var state = void 0;
	  if (key) {
	    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
	    state = (0, _DOMStateStorage.readState)(key);
	  }
	
	  var init = (0, _PathUtils.parsePath)(path);
	  init.state = state;
	
	  return (0, _LocationUtils.createLocation)(init, undefined, key);
	};
	
	var prevLocation = void 0;
	
	var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = pathCoder.encodePath(path);
	
	    if (path !== encodedPath) {
	      // Always be sure we have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var currentLocation = getCurrentLocation(pathCoder, queryKey);
	
	      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events
	
	      prevLocation = currentLocation;
	
	      listener(currentLocation);
	    }
	  };
	
	  // Ensure the hash is encoded properly.
	  var path = getHashPath();
	  var encodedPath = pathCoder.encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	  };
	};
	
	var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
	  var state = location.state,
	      key = location.key;
	
	
	  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));
	
	  if (state !== undefined) {
	    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
	    (0, _DOMStateStorage.saveState)(key, state);
	  }
	
	  prevLocation = location;
	
	  updateHash(path);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) {
	      pushHashPath(path);
	    } else {
	       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
	    }
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) replaceHashPath(path);
	  });
	};

/***/ },
/* 2078 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(523);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _LocationUtils = __webpack_require__(221);
	
	var _PathUtils = __webpack_require__(149);
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  return (0, _LocationUtils.createLocation)(window.location);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  window.location.href = (0, _PathUtils.createPath)(location);
	  return false; // Don't update location
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  window.location.replace((0, _PathUtils.createPath)(location));
	  return false; // Don't update location
	};

/***/ },
/* 2079 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(524);
	
	var _BrowserProtocol = __webpack_require__(523);
	
	var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);
	
	var _RefreshProtocol = __webpack_require__(2078);
	
	var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);
	
	var _DOMUtils = __webpack_require__(371);
	
	var _createHistory = __webpack_require__(525);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve clean URLs. You can force this
	 * behavior using { forceRefresh: true } in options.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
	  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;
	
	  var getUserConfirmation = Protocol.getUserConfirmation,
	      getCurrentLocation = Protocol.getCurrentLocation,
	      pushLocation = Protocol.pushLocation,
	      replaceLocation = Protocol.replaceLocation,
	      go = Protocol.go;
	
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen
	  });
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 2080 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(132);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(524);
	
	var _DOMUtils = __webpack_require__(371);
	
	var _HashProtocol = __webpack_require__(2077);
	
	var HashProtocol = _interopRequireWildcard(_HashProtocol);
	
	var _createHistory = __webpack_require__(525);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultQueryKey = '_k';
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!' + path;
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substring(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '/' ? path.substring(1) : path;
	    },
	    decodePath: addLeadingSlash
	  },
	  slash: {
	    encodePath: addLeadingSlash,
	    decodePath: addLeadingSlash
	  }
	};
	
	var createHashHistory = function createHashHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var queryKey = options.queryKey,
	      hashType = options.hashType;
	
	
	   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;
	
	  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;
	
	  if (hashType == null) hashType = 'slash';
	
	  if (!(hashType in HashPathCoders)) {
	     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;
	
	    hashType = 'slash';
	  }
	
	  var pathCoder = HashPathCoders[hashType];
	
	  var getUserConfirmation = HashProtocol.getUserConfirmation;
	
	
	  var getCurrentLocation = function getCurrentLocation() {
	    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
	  };
	
	  var pushLocation = function pushLocation(location) {
	    return HashProtocol.pushLocation(location, pathCoder, queryKey);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: HashProtocol.go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var go = function go(n) {
	     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
	
	    history.go(n);
	  };
	
	  var createHref = function createHref(path) {
	    return '#' + pathCoder.encodePath(history.createHref(path));
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    go: go,
	    createHref: createHref
	  });
	};
	
	exports.default = createHashHistory;

/***/ },
/* 2081 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(132);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(221);
	
	var _PathUtils = __webpack_require__(149);
	
	var _createHistory = __webpack_require__(525);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _Actions = __webpack_require__(370);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStateStorage = function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	};
	
	var createMemoryHistory = function createMemoryHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var getCurrentLocation = function getCurrentLocation() {
	    var entry = entries[current];
	    var path = (0, _PathUtils.createPath)(entry);
	
	    var key = void 0,
	        state = void 0;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    }
	
	    var init = (0, _PathUtils.parsePath)(path);
	
	    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
	  };
	
	  var canGo = function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  };
	
	  var go = function go(n) {
	    if (!n) return;
	
	    if (!canGo(n)) {
	       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;
	
	      return;
	    }
	
	    current += n;
	    var currentLocation = getCurrentLocation();
	
	    // Change action to POP
	    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	  };
	
	  var pushLocation = function pushLocation(location) {
	    current += 1;
	
	    if (current < entries.length) entries.splice(current);
	
	    entries.push(location);
	
	    saveState(location.key, location.state);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    entries[current] = location;
	    saveState(location.key, location.state);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var _options = options,
	      entries = _options.entries,
	      current = _options.current;
	
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    return (0, _LocationUtils.createLocation)(entry);
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
	  }
	
	  var storage = createStateStorage(entries);
	
	  var saveState = function saveState(key, state) {
	    return storage[key] = state;
	  };
	
	  var readState = function readState(key) {
	    return storage[key];
	  };
	
	  return _extends({}, history, {
	    canGo: canGo
	  });
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 2082 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(1073);
	var objectAssign = __webpack_require__(32);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 2083 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(2222).enable();
	  window.Promise = __webpack_require__(2221);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(2242);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(32);


/***/ },
/* 2084 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DtoUser = __webpack_require__(54);
	
	var _DtoUser2 = _interopRequireDefault(_DtoUser);
	
	var _HomeConstants = __webpack_require__(53);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _reactRouterRedux = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdministrationApp = function (_Component) {
		_inherits(AdministrationApp, _Component);
	
		function AdministrationApp(props) {
			_classCallCheck(this, AdministrationApp);
	
			var _this = _possibleConstructorReturn(this, (AdministrationApp.__proto__ || Object.getPrototypeOf(AdministrationApp)).call(this, props));
	
			_this.state = {
				links: [{
					href: _HomeConstants.PATH_ADMINISTRATION_ACCOUNT,
					icons: 'person',
					name: _simpleReactI18n2.default.myAccount
				}, {
					href: _HomeConstants.PATH_ADMINISTRATION_CREDIT,
					icons: 'euro_symbol',
					name: _simpleReactI18n2.default.credits
				}, {
					href: _HomeConstants.PATH_ADMINISTRATION_THEME,
					icons: 'view_quilt',
					name: _simpleReactI18n2.default.themes
				}]
			};
			return _this;
		}
	
		_createClass(AdministrationApp, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				if (!this.props.isLogged) {
					_AppStore2.default.dispatch((0, _reactRouterRedux.push)(_HomeConstants.PATH_HOME));
				}
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin' },
					_react2.default.createElement(
						'div',
						{ className: 'col s12' },
						this.props.children
					)
				);
			}
		}]);
	
		return AdministrationApp;
	}(_react.Component);
	
	AdministrationApp.propTypes = {
		user: _propTypes2.default.objectOf(_DtoUser2.default),
		login: _propTypes2.default.string,
		children: _propTypes2.default.element,
		isLogged: _propTypes2.default.bool
	};
	
	AdministrationApp.defaultProps = {
		user: {
			address: '',
			administrator: false,
			administratorUser: '',
			city: '',
			email: '',
			firstName: '',
			fixNumber: '',
			lastName: '',
			latitude: '',
			login: '',
			longitude: '',
			mobileNumber: '',
			zoom: ''
		}
	};
	
	exports.default = AdministrationApp;

/***/ },
/* 2085 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _AdministrationAction = __webpack_require__(61);
	
	var _AdministrationAction2 = _interopRequireDefault(_AdministrationAction);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _mailchecker = __webpack_require__(1916);
	
	var _mailchecker2 = _interopRequireDefault(_mailchecker);
	
	var _HomeAction = __webpack_require__(52);
	
	var _HomeAction2 = _interopRequireDefault(_HomeAction);
	
	var _reactRedux = __webpack_require__(18);
	
	var _DtoUser = __webpack_require__(54);
	
	var _DtoUser2 = _interopRequireDefault(_DtoUser);
	
	var _uuid = __webpack_require__(44);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _ActionComponent2 = __webpack_require__(283);
	
	var _ActionComponent3 = _interopRequireDefault(_ActionComponent2);
	
	var _ApplicationUtils = __webpack_require__(186);
	
	var _OSM = __webpack_require__(290);
	
	var _OSM2 = _interopRequireDefault(_OSM);
	
	var _ToastrAction = __webpack_require__(66);
	
	var _ToastrAction2 = _interopRequireDefault(_ToastrAction);
	
	var _TextField = __webpack_require__(406);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountInformationsPanel = function (_ActionComponent) {
		_inherits(AccountInformationsPanel, _ActionComponent);
	
		function AccountInformationsPanel(props) {
			_classCallCheck(this, AccountInformationsPanel);
	
			var _this = _possibleConstructorReturn(this, (AccountInformationsPanel.__proto__ || Object.getPrototypeOf(AccountInformationsPanel)).call(this, props));
	
			_this.onSubmit = function () {
				if (!_mailchecker2.default.isValid(_this.state.user.email)) {
					_AppStore2.default.dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.error.incorrectEmail));
				} else if (!_this.state.user.mobileNumber) {
					_AppStore2.default.dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.error.pleasePhoneInform));
				} else if (!_this.state.user.lastName) {
					_AppStore2.default.dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.error.pleaseNameInform));
				} else {
					_AppStore2.default.dispatch(_AdministrationAction2.default.updateUser(_this.props.user.login, _this.state.user));
				}
			};
	
			_this.handleChange = function (value, event) {
				var user = Object.assign({}, _this.state.user, {});
				user[value] = event.target.value.toString();
				_this.setState({
					user: user
				});
			};
	
			_this.getEvent = function (point, zoom) {
				var user = Object.assign({}, _this.state.user, {});
				user.longitude = point[1].toString();
				user.latitude = point[0].toString();
				user.zoom = zoom.toFixed(0).toString();
				_this.setState({
					user: user,
					center: [point[0], point[1]],
					zoom: zoom.toFixed(0)
				});
			};
	
			_this.getloginAvatar = function () {
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin' },
					_react2.default.createElement(
						'div',
						{ className: 'col s12 center-align' },
						_react2.default.createElement(
							'i',
							{ className: 'material-icons responsive-img accountIcon' },
							'account_circle'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'col s12 center-align' },
						_react2.default.createElement(
							'div',
							{ className: 'row no-margin ' },
							_react2.default.createElement(
								'span',
								null,
								_this.props.user.login
							)
						)
					)
				);
			};
	
			_this.state = {
				user: _this.props.user,
				layers: [(0, _OSM2.default)()],
				mapConf: {
					size: 450,
					center: (0, _ApplicationUtils.getDefaultMapCenter)(_this.props.user),
					zoom: (0, _ApplicationUtils.getDefaultZoom)(_this.props.user)
				}
			};
			return _this;
		}
	
		_createClass(AccountInformationsPanel, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				_AppStore2.default.dispatch(_HomeAction2.default.setTitle(_simpleReactI18n2.default.accountInformations));
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextprops) {
				this.setState({
					user: nextprops.user,
					mapConf: {
						center: (0, _ApplicationUtils.getDefaultMapCenter)(nextprops.user),
						zoom: (0, _ApplicationUtils.getDefaultZoom)(nextprops.user)
					}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'form',
					null,
					_react2.default.createElement(
						'div',
						{ className: 'row card', ref: _uuid2.default.v4() },
						_react2.default.createElement(
							'div',
							{ className: 'col s2' },
							this.getloginAvatar()
						),
						_react2.default.createElement(
							'div',
							{ className: 'col s8 ' },
							_react2.default.createElement(
								'div',
								{ className: 'row no-margin' },
								_react2.default.createElement(
									'div',
									{ className: 'col s6' },
									_react2.default.createElement(_TextField2.default, {
										margin: 'normal',
										required: true,
										fullWidth: true,
										id: _simpleReactI18n2.default.name,
										value: this.state.user.lastName,
										label: _simpleReactI18n2.default.name,
										onChange: function onChange(e) {
											return _this2.handleChange('lastName', e);
										}
									})
								),
								_react2.default.createElement(
									'div',
									{ className: 'col s6' },
									_react2.default.createElement(_TextField2.default, {
										margin: 'normal',
										fullWidth: true,
										id: _simpleReactI18n2.default.firstname,
										value: this.state.user.firstName,
										label: _simpleReactI18n2.default.firstname,
										onChange: function onChange(e) {
											return _this2.handleChange('firstName', e);
										}
									})
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row no-margin' },
								_react2.default.createElement(
									'div',
									{ className: 'col s6' },
									_react2.default.createElement(_TextField2.default, {
										margin: 'normal',
										fullWidth: true,
										id: _simpleReactI18n2.default.mobile,
										value: this.state.user.mobileNumber,
										label: _simpleReactI18n2.default.mobile,
										onChange: function onChange(e) {
											return _this2.handleChange('mobileNumber', e);
										}
									})
								),
								_react2.default.createElement(
									'div',
									{ className: 'col s6' },
									_react2.default.createElement(_TextField2.default, {
										margin: 'normal',
										fullWidth: true,
										id: _simpleReactI18n2.default.phone,
										value: this.state.user.fixNumber,
										label: _simpleReactI18n2.default.phone,
										onChange: function onChange(e) {
											return _this2.handleChange('fixNumber', e);
										}
									})
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row no-margin' },
								_react2.default.createElement(
									'div',
									{ className: 'col s12' },
									_react2.default.createElement(_TextField2.default, {
										margin: 'normal',
										fullWidth: true,
										required: true,
										type: 'email',
										id: _simpleReactI18n2.default.mail,
										value: this.state.user.email,
										label: _simpleReactI18n2.default.mail,
										onChange: function onChange(e) {
											return _this2.handleChange('email', e);
										}
									})
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row no-margin' },
								_react2.default.createElement(
									'div',
									{ className: 'col s6' },
									_react2.default.createElement(_TextField2.default, {
										margin: 'normal',
										fullWidth: true,
										id: _simpleReactI18n2.default.address,
										value: this.state.user.address,
										label: _simpleReactI18n2.default.address,
										onChange: function onChange(e) {
											return _this2.handleChange('address', e);
										}
									})
								),
								_react2.default.createElement(
									'div',
									{ className: 'col s6' },
									_react2.default.createElement(_TextField2.default, {
										margin: 'normal',
										fullWidth: true,
										id: _simpleReactI18n2.default.city,
										value: this.state.user.city,
										label: _simpleReactI18n2.default.city,
										onChange: function onChange(e) {
											return _this2.handleChange('city', e);
										}
									})
								)
							)
						)
					)
				);
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this3 = this;
	
				this.setAction([{
					fn: function fn() {
						return _this3.onSubmit();
					},
					icon: 'save',
					title: _simpleReactI18n2.default.save
				}]);
			}
		}]);
	
		return AccountInformationsPanel;
	}(_ActionComponent3.default);
	
	AccountInformationsPanel.propTypes = {
		user: _propTypes2.default.instanceOf(_DtoUser2.default)
	};
	var mapStateToProps = function mapStateToProps(store) {
		return {
			user: store.HomeReducer.user
		};
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(AccountInformationsPanel);

/***/ },
/* 2086 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _core = __webpack_require__(116);
	
	var _lodash = __webpack_require__(15);
	
	var _CreditAction = __webpack_require__(376);
	
	var _CreditAction2 = _interopRequireDefault(_CreditAction);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _HomeAction = __webpack_require__(52);
	
	var _HomeAction2 = _interopRequireDefault(_HomeAction);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _ListItem = __webpack_require__(304);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _ListItemAvatar = __webpack_require__(305);
	
	var _ListItemAvatar2 = _interopRequireDefault(_ListItemAvatar);
	
	var _ListItemText = __webpack_require__(306);
	
	var _ListItemText2 = _interopRequireDefault(_ListItemText);
	
	var _List = __webpack_require__(303);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _DtoUserCredit = __webpack_require__(284);
	
	var _DtoUserCredit2 = _interopRequireDefault(_DtoUserCredit);
	
	var _DtoUser = __webpack_require__(54);
	
	var _DtoUser2 = _interopRequireDefault(_DtoUser);
	
	var _DtoUserCreditHistory = __webpack_require__(1033);
	
	var _DtoUserCreditHistory2 = _interopRequireDefault(_DtoUserCreditHistory);
	
	var _DtoCreditType = __webpack_require__(533);
	
	var _DtoCreditType2 = _interopRequireDefault(_DtoCreditType);
	
	var _DtoSelection = __webpack_require__(181);
	
	var _DtoSelection2 = _interopRequireDefault(_DtoSelection);
	
	var _NumberUtils = __webpack_require__(151);
	
	var _DateUtil = __webpack_require__(67);
	
	var _collection = __webpack_require__(1875);
	
	var _reactRedux = __webpack_require__(18);
	
	var _glamor = __webpack_require__(143);
	
	var _Tooltip = __webpack_require__(240);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreditInformationPanel = function (_Component) {
		_inherits(CreditInformationPanel, _Component);
	
		function CreditInformationPanel(props) {
			_classCallCheck(this, CreditInformationPanel);
	
			var _this = _possibleConstructorReturn(this, (CreditInformationPanel.__proto__ || Object.getPrototypeOf(CreditInformationPanel)).call(this, props));
	
			_this.getType = function (creditHistory) {
				if (_this.props.creditTypes.length) {
					var creditType = (0, _lodash.find)(_this.props.creditTypes, function (o) {
						return o.id == creditHistory.creditTypeId;
					});
					if (creditType) {
						return creditType;
					}
					return '';
				}
				return '';
			};
	
			_this.createIcon = function (iconName, color) {
				return _react2.default.createElement(
					_core.Avatar,
					null,
					_react2.default.createElement(
						_core.Icon,
						Object.assign({ className: 'material-icons' }, (0, _glamor.css)({ color: color })),
						iconName
					)
				);
			};
	
			_this.createCreditIcon = function (credit, creditTypes) {
				var numberFormatted = (0, _NumberUtils.formatNumber)(credit);
				var finalText = function () {
					switch (creditTypes.action) {
						case 'ADD':
							return [_simpleReactI18n2.default.addCredit, '+' + numberFormatted];
						case 'SUBSTRACT':
							return [_simpleReactI18n2.default.selectionExportCredit, '-' + numberFormatted];
						default:
							return ['', numberFormatted];
					}
				}();
				return _react2.default.createElement(
					_core.Avatar,
					(0, _glamor.css)({ fontSize: '10px !important' }),
					_react2.default.createElement(
						_Tooltip2.default,
						{ title: finalText[0], 'aria-label': finalText[0] },
						_react2.default.createElement(
							'span',
							null,
							finalText[1]
						)
					)
				);
			};
	
			_this.getIcon = function (creditTypes) {
				if (creditTypes) {
					switch (creditTypes.action) {
						case 'ADD':
							return _this.createIcon('arrow_upward', 'green');
						case 'SUBSTRACT':
							return _this.createIcon('arrow_downward', 'red');
						case 'REQUEST':
							return _this.createIcon('info_outline', 'gray');
						default:
							return null;
					}
				}
				return '';
			};
	
			_this.getSelection = function (selectionId) {
				if (_this.props.selections.length) {
					var selection = (0, _lodash.find)(_this.props.selections, function (o) {
						return o.id == selectionId;
					});
					if (selection) {
						return selection.title;
					}
					return '';
				}
				return '';
			};
	
			_this.getCreditInformation = function () {
				if (_this.props.userCredit) {
					var title = function () {
						if (_this.props.userCredit.credit > 2) {
							return _simpleReactI18n2.default.availableCredits;
						}
						return _simpleReactI18n2.default.availableCredit;
					}();
					return _react2.default.createElement(
						'span',
						null,
						title,
						' : ',
						_this.props.userCredit.credit
					);
				}
				return null;
			};
	
			_this.change = function (event) {
				event.preventDefault();
				_this.setState({
					creditNumber: Number(_this.refs.creditNumber.value)
				});
			};
	
			_this.creditRequest = function () {
				_this.setState({
					creditNumber: 0
				});
				_AppStore2.default.dispatch(_CreditAction2.default.fetchCreditRequest(_this.props.user.login, _this.state.creditNumber));
			};
	
			_this.getCreditRequestPanel = function () {
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin' },
					_react2.default.createElement(
						'div',
						{ className: 'col s12 no-padding' },
						_react2.default.createElement(
							'fieldset',
							null,
							_react2.default.createElement(
								'legend',
								null,
								'Demande de cr\xE9dits'
							),
							_react2.default.createElement(
								'div',
								{ className: 'row no-margin' },
								_react2.default.createElement(
									'div',
									{ className: 'col s4 offset-s2' },
									_react2.default.createElement('label', { htmlFor: 'creditNumber' }),
									_react2.default.createElement('input', { ref: 'creditNumber', id: 'creditNumber', type: 'number', className: 'validate',
										onChange: function onChange(event) {
											return _this.change(event);
										}, defaultValue: _this.state.creditNumber, style: { height: '2rem !important' } })
								),
								_react2.default.createElement(
									'div',
									{ className: 'col s2 offset-s1' },
									_react2.default.createElement(
										'a',
										{ className: 'modal-action btn margin-right-10', onClick: function onClick() {
												return _this.creditRequest();
											} },
										_simpleReactI18n2.default.ask
									)
								)
							)
						)
					)
				);
			};
	
			_this.getContent = function () {
				if (_this.props.userCreditHistory.length) {
					return _react2.default.createElement(
						'div',
						{ className: 'row no-margin' },
						_react2.default.createElement(
							'div',
							{ className: 'col s12' },
							_react2.default.createElement(
								'div',
								{ className: 'card-content' },
								_react2.default.createElement(
									'div',
									{ className: 'row' },
									_this.getCreditRequestPanel()
								),
								_react2.default.createElement(
									'div',
									{ className: 'row' },
									_this.getCreditInformation(),
									_react2.default.createElement(
										_List2.default,
										null,
										_this.getCreditHistory()
									)
								)
							)
						)
					);
				}
				return _react2.default.createElement(
					'div',
					{ className: 'col s12' },
					_react2.default.createElement(
						'div',
						{ className: 'row no-margin card' },
						_react2.default.createElement(
							'div',
							{ className: 'col s12' },
							_react2.default.createElement(
								'div',
								{ className: 'card-content' },
								_react2.default.createElement(
									'div',
									{ className: 'row' },
									_simpleReactI18n2.default.information.contactAddCredit
								)
							)
						)
					),
					_this.getCreditRequestPanel()
				);
			};
	
			_this.state = {
				creditNumber: 0
			};
			return _this;
		}
	
		_createClass(CreditInformationPanel, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				if (!this.props.creditTypes.length) {
					_AppStore2.default.dispatch(_CreditAction2.default.fetchCreditTypes());
				}
				_AppStore2.default.dispatch(_HomeAction2.default.setTitle(_simpleReactI18n2.default.credits));
			}
		}, {
			key: 'getCreditHistory',
			value: function getCreditHistory() {
				var _this2 = this;
	
				if (this.props.userCreditHistory.length) {
					return (0, _collection.orderBy)(this.props.userCreditHistory, 'date', 'desc').map(function (creditHistory) {
						var date = (0, _DateUtil.getDate)(creditHistory.date);
						var creditTypes = _this2.getType(creditHistory);
						var creditTypeLibelle = function () {
							if (creditTypes) {
								return creditTypes.libelle;
							}
							return '';
						}();
	
						var selectionTitle = function () {
							if (creditHistory.selectionId) {
								return _this2.getSelection(creditHistory.selectionId);
							}
							return '';
						}();
	
						var secondaryText = function () {
							if (selectionTitle) {
								return date + ' - ' + selectionTitle;
							}
							return date;
						}();
	
						return _react2.default.createElement(
							_ListItem2.default,
							{ alignItems: 'flex-start' },
							_react2.default.createElement(
								_ListItemAvatar2.default,
								null,
								_this2.getIcon(creditTypes)
							),
							_react2.default.createElement(_ListItemText2.default, {
								primary: creditTypeLibelle,
								secondary: secondaryText
							}),
							_react2.default.createElement(
								_ListItemAvatar2.default,
								null,
								_this2.createCreditIcon(creditHistory.credit, creditTypes)
							)
						);
					});
				}
				return null;
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'row' },
					_react2.default.createElement(
						'div',
						{ className: 'col s6 offset-s3' },
						_react2.default.createElement(
							'div',
							{ className: 'row card' },
							this.getContent()
						)
					)
				);
			}
		}]);
	
		return CreditInformationPanel;
	}(_react.Component);
	
	CreditInformationPanel.propTypes = {
		user: _propTypes2.default.instanceOf(_DtoUser2.default),
		userCredit: _propTypes2.default.instanceOf(_DtoUserCredit2.default),
		userCreditHistory: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoUserCreditHistory2.default)),
		creditTypes: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoCreditType2.default)),
		selections: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoSelection2.default))
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			userCredit: store.CreditReducer.userCredit,
			userCreditHistory: store.CreditReducer.userCreditHistory,
			creditTypes: store.CreditReducer.creditTypes,
			selections: store.SelectionReducer.selections,
			user: store.HomeReducer.user
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(CreditInformationPanel);

/***/ },
/* 2087 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _OSM = __webpack_require__(290);
	
	var _OSM2 = _interopRequireDefault(_OSM);
	
	var _Map = __webpack_require__(289);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _HomeAction = __webpack_require__(52);
	
	var _HomeAction2 = _interopRequireDefault(_HomeAction);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _AdministrationAction = __webpack_require__(61);
	
	var _AdministrationAction2 = _interopRequireDefault(_AdministrationAction);
	
	var _DtoUser = __webpack_require__(54);
	
	var _DtoUser2 = _interopRequireDefault(_DtoUser);
	
	var _reactRedux = __webpack_require__(18);
	
	var _ApplicationUtils = __webpack_require__(186);
	
	var _ActionComponent2 = __webpack_require__(283);
	
	var _ActionComponent3 = _interopRequireDefault(_ActionComponent2);
	
	var _uuid = __webpack_require__(44);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _TextField = __webpack_require__(406);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapInformationsPanel = function (_ActionComponent) {
		_inherits(MapInformationsPanel, _ActionComponent);
	
		function MapInformationsPanel(props) {
			_classCallCheck(this, MapInformationsPanel);
	
			var _this = _possibleConstructorReturn(this, (MapInformationsPanel.__proto__ || Object.getPrototypeOf(MapInformationsPanel)).call(this, props));
	
			_this.onSubmit = function () {
				var user = Object.assign({}, _this.props.user, {
					latitude: _this.state.latitude.toString(),
					longitude: _this.state.longitude.toString(),
					zoom: _this.state.zoom.toString()
				});
				_AppStore2.default.dispatch(_AdministrationAction2.default.updateUser(_this.props.user.login, user));
			};
	
			_this.onTodoChange = function (key, event) {
				var user = {};
				user[key] = event.target.value;
				_this.setState(user);
			};
	
			_this.getEvent = function (point, zoom) {
				_this.setState({
					longitude: point[1],
					latitude: point[0],
					zoom: zoom.toFixed(0),
					mapConf: {
						center: [point[0], point[1]],
						zoom: zoom.toFixed(0)
					}
				});
			};
	
			_this.state = {
				latitude: _this.props.user.latitude,
				longitude: _this.props.user.longitude,
				zoom: _this.props.user.zoom,
				layers: [(0, _OSM2.default)()],
				mapConf: {
					size: 600,
					center: (0, _ApplicationUtils.getDefaultMapCenter)(_this.props.user),
					zoom: (0, _ApplicationUtils.getDefaultZoom)(_this.props.user)
				}
			};
			return _this;
		}
	
		_createClass(MapInformationsPanel, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				_AppStore2.default.dispatch(_HomeAction2.default.setTitle(_simpleReactI18n2.default.map));
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextprops) {
				this.setState({
					latitude: nextprops.user.latitude,
					longitude: nextprops.user.longitude,
					zoom: nextprops.user.zoom,
					mapConf: {
						size: 600,
						center: (0, _ApplicationUtils.getDefaultMapCenter)(nextprops.user),
						zoom: (0, _ApplicationUtils.getDefaultZoom)(nextprops.user)
					}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'row card' },
					_react2.default.createElement(
						'form',
						{ className: 'col s12', onSubmit: this.onSubmit },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col s4' },
								_react2.default.createElement(_TextField2.default, {
									fullWidth: true,
									type: 'text',
									id: _uuid2.default.v4(),
									value: this.state.longitude,
									floatingLabelText: _simpleReactI18n2.default.longitude,
									onChange: function onChange(e) {
										return _this2.handleChange('longitude', e);
									}
								})
							),
							_react2.default.createElement(
								'div',
								{ className: 'col s4' },
								_react2.default.createElement(_TextField2.default, {
									fullWidth: true,
									type: 'text',
									id: _uuid2.default.v4(),
									value: this.state.latitude,
									floatingLabelText: _simpleReactI18n2.default.latitude,
									onChange: function onChange(e) {
										return _this2.handleChange('latitude', e);
									}
								})
							),
							_react2.default.createElement(
								'div',
								{ className: 'col s4' },
								_react2.default.createElement(_TextField2.default, {
									fullWidth: true,
									type: 'number',
									id: _uuid2.default.v4(),
									value: this.state.zoom,
									floatingLabelText: _simpleReactI18n2.default.zoom,
									onChange: function onChange(e) {
										return _this2.onTodoChange('zoom', e);
									}
								})
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col s12' },
								_react2.default.createElement(_Map2.default, { mapConf: this.state.mapConf, layers: this.state.layers, event: this.getEvent })
							)
						)
					)
				);
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this3 = this;
	
				this.setAction([{
					fn: function fn() {
						return _this3.onSubmit();
					},
					icon: 'save'
				}]);
			}
		}]);
	
		return MapInformationsPanel;
	}(_ActionComponent3.default);
	
	MapInformationsPanel.propTypes = {
		user: _propTypes2.default.objectOf(_DtoUser2.default)
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			user: store.HomeReducer.user
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(MapInformationsPanel);

/***/ },
/* 2088 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _reactRedux = __webpack_require__(18);
	
	var _DtoSource = __webpack_require__(222);
	
	var _DtoSource2 = _interopRequireDefault(_DtoSource);
	
	var _Divider = __webpack_require__(578);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _List = __webpack_require__(303);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ListItem = __webpack_require__(304);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _lodash = __webpack_require__(15);
	
	var _HomeAction = __webpack_require__(52);
	
	var _HomeAction2 = _interopRequireDefault(_HomeAction);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _uuid = __webpack_require__(44);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _AdministrationAction = __webpack_require__(61);
	
	var _AdministrationAction2 = _interopRequireDefault(_AdministrationAction);
	
	var _ListItemText = __webpack_require__(306);
	
	var _ListItemText2 = _interopRequireDefault(_ListItemText);
	
	var _ListItemAvatar = __webpack_require__(305);
	
	var _ListItemAvatar2 = _interopRequireDefault(_ListItemAvatar);
	
	var _core = __webpack_require__(116);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SourceInformationsPanel = function (_Component) {
		_inherits(SourceInformationsPanel, _Component);
	
		function SourceInformationsPanel(props) {
			_classCallCheck(this, SourceInformationsPanel);
	
			var _this = _possibleConstructorReturn(this, (SourceInformationsPanel.__proto__ || Object.getPrototypeOf(SourceInformationsPanel)).call(this, props));
	
			_this.openUrl = function (url) {
				window.open(url, '_blank');
			};
	
			_this.createItem = function (source, classes) {
				return _react2.default.createElement(
					'div',
					{ key: _uuid2.default.v4() },
					_react2.default.createElement(
						_ListItem2.default,
						{ alignItems: 'flex-start', onClick: function onClick() {
								return _this.openUrl(source.url);
							} },
						_react2.default.createElement(
							_ListItemAvatar2.default,
							null,
							_react2.default.createElement(
								'div',
								{ className: 'valign-wrapper' },
								_react2.default.createElement('img', { src: source.logo, className: 'width-40' })
							)
						),
						_react2.default.createElement(_ListItemText2.default, {
							className: classes.itemStyle,
							primary: source.name,
							secondary: _react2.default.createElement(
								'p',
								null,
								source.comment
							)
						})
					),
					_react2.default.createElement(_Divider2.default, { variant: 'inset', component: 'li' })
				);
			};
	
			_this.getSources = function (classes) {
				if (_this.props.sources.length) {
					var aquasysName = 'Aquasys';
					var listWithoutAquasys = (0, _lodash.filter)(_this.props.sources, function (o) {
						return o.name !== aquasysName;
					});
					var list = (0, _lodash.orderBy)(listWithoutAquasys, ['name'], ['asc']).map(function (source) {
						return _this.createItem(source, classes);
					});
	
					return _react2.default.createElement(
						_List2.default,
						null,
						list
					);
				}
				return null;
			};
	
			_this.getAquasysSource = function (classes) {
				if (_this.props.sources.length) {
					var aquasysName = _simpleReactI18n2.default.aquasys;
					var aquasysSource = (0, _lodash.find)(_this.props.sources, function (o) {
						return o.name === aquasysName;
					});
					return _react2.default.createElement(
						_List2.default,
						null,
						_this.createItem(aquasysSource, classes)
					);
				}
				return null;
			};
	
			return _this;
		}
	
		_createClass(SourceInformationsPanel, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				_AppStore2.default.dispatch(_HomeAction2.default.setTitle(_simpleReactI18n2.default.sources));
				if (!this.props.sources.length) {
					_AppStore2.default.dispatch(_AdministrationAction2.default.fetchSources());
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var classes = (0, _core.makeStyles)(function () {
					return {
						itemStyle: {
							fontSize: '25px',
							fontWeight: 'bold'
						}
					};
				});
				return _react2.default.createElement(
					'div',
					{ className: 'row' },
					_react2.default.createElement(
						'div',
						{ className: 'col s10 offset-s1' },
						_react2.default.createElement(
							'div',
							{ className: 'row card' },
							this.getAquasysSource(classes)
						),
						_react2.default.createElement(
							'div',
							{ className: 'row card' },
							this.getSources(classes)
						)
					)
				);
			}
		}]);
	
		return SourceInformationsPanel;
	}(_react.Component);
	
	SourceInformationsPanel.propTypes = {
		sources: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoSource2.default))
	};
	var mapStateToProps = function mapStateToProps(store) {
		return {
			sources: store.AdministrationReducer.sources
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(SourceInformationsPanel);

/***/ },
/* 2089 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FamilyCard = function (_Component) {
		_inherits(FamilyCard, _Component);
	
		function FamilyCard() {
			_classCallCheck(this, FamilyCard);
	
			return _possibleConstructorReturn(this, (FamilyCard.__proto__ || Object.getPrototypeOf(FamilyCard)).apply(this, arguments));
		}
	
		_createClass(FamilyCard, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'theme-card card no-margin', onClick: this.props.onClick },
					_react2.default.createElement(
						'div',
						{ className: 'card-image valign-wrapper', style: { backgroundImage: 'url(\'' + this.props.image + '\')' } },
						_react2.default.createElement('div', { className: 'theme-bg', style: { backgroundColor: 'rgb(' + this.props.color + ')' } }),
						_react2.default.createElement(
							'span',
							{ className: 'theme-title no-margin' },
							this.props.title
						),
						_react2.default.createElement(
							'div',
							{ className: 'theme-content right-align' },
							this.props.children
						)
					)
				);
			}
		}]);
	
		return FamilyCard;
	}(_react.Component);
	
	FamilyCard.propTypes = {
		image: _propTypes2.default.string.isRequired,
		color: _propTypes2.default.string.isRequired,
		title: _propTypes2.default.string.isRequired,
		children: _propTypes2.default.element,
		onClick: _propTypes2.default.func
	};
	
	FamilyCard.defaultProps = {
		image: '',
		color: '',
		title: null,
		children: null,
		onClick: function onClick() {}
	};
	
	exports.default = FamilyCard;

/***/ },
/* 2090 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _uuid = __webpack_require__(44);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _reactRedux = __webpack_require__(18);
	
	var _ThemePanel = __webpack_require__(2092);
	
	var _ThemePanel2 = _interopRequireDefault(_ThemePanel);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DtoSource = __webpack_require__(222);
	
	var _DtoSource2 = _interopRequireDefault(_DtoSource);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _DtoUser = __webpack_require__(54);
	
	var _DtoUser2 = _interopRequireDefault(_DtoUser);
	
	var _HomeAction = __webpack_require__(52);
	
	var _HomeAction2 = _interopRequireDefault(_HomeAction);
	
	var _AdministrationAction = __webpack_require__(61);
	
	var _AdministrationAction2 = _interopRequireDefault(_AdministrationAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = window.$;
	
	var FamilyComponent = function (_Component) {
		_inherits(FamilyComponent, _Component);
	
		function FamilyComponent(props) {
			_classCallCheck(this, FamilyComponent);
	
			var _this = _possibleConstructorReturn(this, (FamilyComponent.__proto__ || Object.getPrototypeOf(FamilyComponent)).call(this, props));
	
			_this.setTabs = function () {
				$('ul.tabs').tabs();
			};
	
			_this.handleChange = function (event, newValue) {
				_this.setState({ selected: newValue });
			};
	
			_this.state = {
				selected: 0
			};
			return _this;
		}
	
		_createClass(FamilyComponent, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.setTitle();
				if (this.props.sources && !this.props.sources.length) {
					_AppStore2.default.dispatch(_AdministrationAction2.default.fetchSources());
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.setTabs();
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				this.setTabs();
				this.setTitle();
			}
		}, {
			key: 'setTitle',
			value: function setTitle() {
				var title = _react2.default.createElement(
					'span',
					null,
					_react2.default.createElement(
						'a',
						{ className: 'breadcrumb', onClick: this.props.homeFunction },
						_simpleReactI18n2.default.sources
					),
					_react2.default.createElement(
						'a',
						{ className: 'breadcrumb' },
						this.props.theme.title
					)
				);
				_AppStore2.default.dispatch(_HomeAction2.default.setTitle(title));
			}
		}, {
			key: 'render',
			value: function render() {
				var tabs = [];
				var themes = this.props.theme.themes.map(function (t) {
					var id = _uuid2.default.v4();
					var inDevelop = t.disable ? _react2.default.createElement(
						'i',
						{ className: 'material-icons' },
						'visibility_off'
					) : null;
					tabs.push(_react2.default.createElement(
						'li',
						{ className: 'tab', key: id },
						_react2.default.createElement(
							'a',
							{ href: '#' + id },
							t.title,
							' ',
							inDevelop
						)
					));
					return _react2.default.createElement(
						'div',
						{ key: id + '-panel', id: id, className: 'col s12 no-padding theme-panel' },
						_react2.default.createElement(_ThemePanel2.default, { theme: t, id: id })
					);
				});
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin' },
					_react2.default.createElement(
						'div',
						{ className: 'col s12 no-padding' },
						_react2.default.createElement(
							'ul',
							{ className: 'tabs tabs-fixed-width' },
							tabs
						)
					),
					themes
				);
			}
		}]);
	
		return FamilyComponent;
	}(_react.Component);
	
	FamilyComponent.propTypes = {
		theme: _propTypes2.default.object,
		user: _propTypes2.default.objectOf(_DtoUser2.default),
		sources: _propTypes2.default.objectOf(_DtoSource2.default),
		dataTypeStatistics: _propTypes2.default.object,
		homeFunction: _propTypes2.default.func
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			user: store.HomeReducer.user,
			sources: store.AdministrationReducer.sources,
			dataTypeStatistics: store.AdministrationReducer.dataTypeStatistics
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(FamilyComponent);

/***/ },
/* 2091 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactRedux = __webpack_require__(18);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AdministrationAction = __webpack_require__(61);
	
	var _AdministrationAction2 = _interopRequireDefault(_AdministrationAction);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _MasterThemeDto = __webpack_require__(527);
	
	var _MasterThemeDto2 = _interopRequireDefault(_MasterThemeDto);
	
	var _HomeAction = __webpack_require__(52);
	
	var _HomeAction2 = _interopRequireDefault(_HomeAction);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _FamilyCard = __webpack_require__(2089);
	
	var _FamilyCard2 = _interopRequireDefault(_FamilyCard);
	
	var _FamilyComponent = __webpack_require__(2090);
	
	var _FamilyComponent2 = _interopRequireDefault(_FamilyComponent);
	
	var _lodash = __webpack_require__(15);
	
	var _SourceInformationsPanel = __webpack_require__(2088);
	
	var _SourceInformationsPanel2 = _interopRequireDefault(_SourceInformationsPanel);
	
	var _Icon = __webpack_require__(300);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _StringUtils = __webpack_require__(131);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ThemeInformationPanel = function (_Component) {
		_inherits(ThemeInformationPanel, _Component);
	
		function ThemeInformationPanel(props) {
			_classCallCheck(this, ThemeInformationPanel);
	
			var _this = _possibleConstructorReturn(this, (ThemeInformationPanel.__proto__ || Object.getPrototypeOf(ThemeInformationPanel)).call(this, props));
	
			_this.getSiteTypesNbSites = function (theme) {
				var listOfSiteTypes = theme.siteTypes.map(function (o) {
					var nbSites = function () {
						var findData = (0, _lodash.find)(_this.props.dataTypeStatistics, function (b) {
							return b.typeParameter === o.type;
						});
						return findData ? findData.nbSites : 0;
					}();
					return Object.assign({}, o, {
						nbSites: nbSites
					});
				});
				return listOfSiteTypes;
			};
	
			_this.state = {
				theme: null
			};
			return _this;
		}
	
		_createClass(ThemeInformationPanel, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				if (this.props.dataTypeStatistics && !this.props.dataTypeStatistics.length) {
					_AppStore2.default.dispatch(_AdministrationAction2.default.fetchDataTypeStatistics());
				}
				_AppStore2.default.dispatch(_AdministrationAction2.default.fetchThemes());
				_AppStore2.default.dispatch(_HomeAction2.default.setTitle(_simpleReactI18n2.default.themes));
			}
		}, {
			key: 'getThemeList',
			value: function getThemeList() {
				var _this2 = this;
	
				return this.props.themes.map(function (f, i) {
					var finalTheme = f.themes.map(function (t) {
						return Object.assign({}, t, {
							siteTypes: _this2.getSiteTypesNbSites(t)
						});
					});
					var theme = Object.assign({}, f, {
						themes: finalTheme
					});
					var familyDatas = theme.themes.reduce(function (acc, v) {
						acc.layers.push(v.layers.map(function (l) {
							return l.id;
						}));
						acc.types.push(v.siteTypes.map(function (s) {
							return s.type;
						}));
						return acc;
					}, {
						layers: [],
						types: []
					});
					var nbData = (0, _lodash.flatten)(theme.themes).reduce(function (acc, v) {
						return acc + (0, _lodash.sumBy)(v.siteTypes, 'nbSites');
					}, 0);
					var content = _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'b',
								null,
								(0, _lodash.uniq)((0, _lodash.flatten)(familyDatas.layers)).length,
								' '
							),
							_simpleReactI18n2.default.layersAvailable
						),
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'b',
								null,
								(0, _lodash.uniq)((0, _lodash.flatten)(familyDatas.types)).length,
								' '
							),
							_simpleReactI18n2.default.siteTypesAvailable
						),
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'b',
								null,
								nbData,
								' '
							),
							(0, _StringUtils.getPlurialWithNumber)(_simpleReactI18n2.default.availablePoint, _simpleReactI18n2.default.availablePoints, nbData)
						)
					);
					return _react2.default.createElement(
						_FamilyCard2.default,
						{ key: i, image: theme.image, color: theme.color, title: theme.title,
							onClick: function onClick() {
								return _this2.setState({ theme: theme });
							} },
						content
					);
				});
			}
		}, {
			key: 'splitLabel',
			value: function splitLabel(label) {
				return label.split(' ').join('\n');
			}
		}, {
			key: 'getMainContent',
			value: function getMainContent() {
				var _this3 = this;
	
				return this.state.theme ? _react2.default.createElement(_FamilyComponent2.default, { theme: this.state.theme, homeFunction: function homeFunction() {
						return _this3.setState({ theme: null });
					} }) : _react2.default.createElement(_SourceInformationsPanel2.default, null);
			}
		}, {
			key: 'getHomeButton',
			value: function getHomeButton() {
				var _this4 = this;
	
				if (this.state.theme) {
					return _react2.default.createElement(
						'div',
						{ className: 'row no-margin' },
						_react2.default.createElement(
							'div',
							{ className: 'no-margin card col s12 no-padding center-align',
								onClick: function onClick() {
									return _this4.setState({ theme: null });
								} },
							_react2.default.createElement(
								'div',
								{ className: 'home-theme' },
								_react2.default.createElement(
									_Icon2.default,
									{ className: 'material-icons' },
									'home'
								)
							)
						)
					);
				}
				return null;
			}
		}, {
			key: 'render',
			value: function render() {
				var actif = this.state.theme ? 'theme-actif' : '';
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin themes-page ' + actif },
					_react2.default.createElement(
						'div',
						{ className: 'col s4 no-padding' },
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'div',
								{ className: 'row no-margin' },
								this.getHomeButton(),
								this.getThemeList()
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'col s8 margin-top-10' },
						_react2.default.createElement(
							'div',
							{ className: 'card no-margin' },
							this.getMainContent()
						)
					)
				);
			}
		}]);
	
		return ThemeInformationPanel;
	}(_react.Component);
	
	ThemeInformationPanel.propTypes = {
		themes: _propTypes2.default.arrayOf(_MasterThemeDto2.default),
		dataTypeStatistics: _propTypes2.default.object
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			themes: store.AdministrationReducer.themes,
			dataTypeStatistics: store.AdministrationReducer.dataTypeStatistics
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ThemeInformationPanel);

/***/ },
/* 2092 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _lodash = __webpack_require__(15);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DtoSource = __webpack_require__(222);
	
	var _DtoSource2 = _interopRequireDefault(_DtoSource);
	
	var _DtoUser = __webpack_require__(54);
	
	var _DtoUser2 = _interopRequireDefault(_DtoUser);
	
	var _SiteTypes = __webpack_require__(56);
	
	var _SiteTypes2 = _interopRequireDefault(_SiteTypes);
	
	var _LegendUtils = __webpack_require__(1059);
	
	var _NumberUtils = __webpack_require__(151);
	
	var _Avatar = __webpack_require__(573);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Icon = __webpack_require__(300);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Chip = __webpack_require__(234);
	
	var _Chip2 = _interopRequireDefault(_Chip);
	
	var _Card = __webpack_require__(574);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _CardHeader = __webpack_require__(575);
	
	var _CardHeader2 = _interopRequireDefault(_CardHeader);
	
	var _reactRedux = __webpack_require__(18);
	
	var _DtoDataTypeStatistics = __webpack_require__(1015);
	
	var _DtoDataTypeStatistics2 = _interopRequireDefault(_DtoDataTypeStatistics);
	
	var _StringUtils = __webpack_require__(131);
	
	var _core = __webpack_require__(116);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ThemePanel = function (_Component) {
		_inherits(ThemePanel, _Component);
	
		function ThemePanel(props) {
			_classCallCheck(this, ThemePanel);
	
			var _this = _possibleConstructorReturn(this, (ThemePanel.__proto__ || Object.getPrototypeOf(ThemePanel)).call(this, props));
	
			_initialiseProps.call(_this);
	
			_this.state = {
				height: 0,
				layers: _this.getLayers(props)
			};
			_this.toggleLayer = _this.toggleLayer.bind(_this);
			_this.openMap = _this.openMap.bind(_this);
			return _this;
		}
	
		_createClass(ThemePanel, [{
			key: 'openMap',
			value: function openMap() {
				if (this.state.height === 0) {
					this.setState({ height: 400 });
				}
			}
		}, {
			key: 'toggleLayer',
			value: function toggleLayer(layer) {
				this.setState(function (prevState) {
					var layers = Object.assign([], prevState.layers);
					return {
						layers: layers.map(function (l) {
							if (layer.id === l.id) {
								l.visibility = !l.visibility;
							}
							return l;
						})
					};
				});
			}
		}, {
			key: 'getSource',
			value: function getSource(id) {
				var _this2 = this;
	
				var source = (0, _lodash.find)(this.props.sources, function (s) {
					return s.id === id;
				});
				if (source) {
					return _react2.default.createElement(
						'div',
						{ className: 'row no-margin valign-wrapper cursor-pointer', onClick: function onClick() {
								return _this2.openUrl(source.url);
							} },
						_react2.default.createElement(
							'div',
							{ className: 'col s3 no-padding' },
							_react2.default.createElement(_Avatar2.default, { src: source.logo, className: 'MuiAvatar-root-source' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'col s9 no-padding' },
							source.name
						)
					);
				}
				return null;
			}
		}, {
			key: 'getSiteTypeComponent',
			value: function getSiteTypeComponent(theme) {
				var _this3 = this;
	
				var siteTypes = theme.siteTypes.map(function (s) {
					var site = _SiteTypes2.default[s.type];
					var icon = function () {
						if (site.icon) {
							return _react2.default.createElement('img', { src: site.icon, className: 'responsive-img theme-icon center-align' });
						}
						return null;
					}();
					var nbData = _this3.getNbDataComponent(s);
					return _this3.getDetail(site.title, _this3.getSource(s.source), icon, nbData, [10, 2]);
				});
				return this.getComponent(siteTypes);
			}
		}, {
			key: 'getLayerDetails',
			value: function getLayerDetails(l, id, legendUrl) {
				var title = l.name + ' - ' + l.type;
				var url = (0, _LegendUtils.getLegendUrl)(legendUrl);
				var legend = this.getPopupComponent(url, id, title, _react2.default.createElement(
					_core.Tooltip,
					{ title: _simpleReactI18n2.default.legend, 'aria-label': _simpleReactI18n2.default.legend },
					_react2.default.createElement(
						_Icon2.default,
						{ className: 'material-icons font-size-15', color: '#48a1ff' },
						'info'
					)
				));
				var informations = _react2.default.createElement(
					'div',
					{ className: 'row no-margin valign-wrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'col s5 font-size-12' },
						l.updateDate
					),
					_react2.default.createElement(
						'div',
						{ className: 'col s5 font-size-12 ' },
						_react2.default.createElement(
							'span',
							null,
							l.zoom
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'col s2 left-align' },
						legend
					)
				);
				return this.getDetail(title, this.getSource(l.source), null, informations, [10, 2]);
			}
		}, {
			key: 'getLayersComponent',
			value: function getLayersComponent(theme, id) {
				var _this4 = this;
	
				var layers = (0, _lodash.flatten)(theme.layers.map(function (l) {
					return _this4.getLayerDetails(l, id, l);
				}));
				return _react2.default.createElement(
					'div',
					null,
					this.getComponent(layers, 4.5)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var t = this.props.theme;
				var id = this.props.id;
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_Card2.default,
						null,
						_react2.default.createElement(_CardHeader2.default, {
							title: _simpleReactI18n2.default.stationTypes + ' (' + t.siteTypes.length + ')',
							className: 'no-padding font-size-15'
						}),
						this.getSiteTypeComponent(t)
					),
					_react2.default.createElement(
						_Card2.default,
						null,
						_react2.default.createElement(_CardHeader2.default, {
							title: _simpleReactI18n2.default.cartographicLayers + ' (' + t.layers.length + ')',
							className: 'no-padding font-size-15'
						}),
						this.getLayersComponent(t, id)
					)
				);
			}
		}]);
	
		return ThemePanel;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
		this.getLayers = function (props) {
			return props.theme.layers.map(function (l) {
				return Object.assign({}, l, {
					visibility: true
				});
			});
		};
	
		this.getCollectionLegend = function (firstColName) {
			var ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [6, 6];
	
			return _react2.default.createElement(
				'div',
				{ className: 'row no-margin' },
				_react2.default.createElement(
					'div',
					{ className: 'collection-legend valign-wrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'col s' + ratio[0] + ' center-align' },
						firstColName
					),
					_react2.default.createElement(
						'div',
						{ className: 'col s' + ratio[0] + ' center-align' },
						_simpleReactI18n2.default.sources
					)
				)
			);
		};
	
		this.getPopupComponent = function (picture, index, title, content) {
			if (picture) {
				var gallery = 'gallery_' + index;
				return _react2.default.createElement(
					'div',
					{ className: 'col s1 theme-icon-column valign-wrapper icon-img no-padding' },
					_react2.default.createElement(
						'a',
						{ 'data-fancybox': gallery, href: picture, 'data-caption': title },
						content
					)
				);
			}
			return null;
		};
	
		this.getDetail = function (title) {
			var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
			var before = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
			var after = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
			var ratio = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [6, 6];
	
			return _react2.default.createElement(
				'div',
				{ className: 'row no-margin valign-wrapper theme-icon-column' },
				_react2.default.createElement(
					'div',
					{ className: 'col s' + ratio[0] + ' no-padding' },
					_react2.default.createElement(
						'div',
						{ className: 'row no-margin valign-wrapper' },
						_react2.default.createElement(
							'div',
							{ className: 'col s1' },
							before
						),
						_react2.default.createElement(
							'div',
							{ className: 'col s8 margin-left-10 no-padding' },
							_react2.default.createElement(
								'span',
								{ className: 'title' },
								title
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'col s3 left-align no-padding' },
							after
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'col s' + ratio[1] },
					source
				)
			);
		};
	
		this.getComponent = function (component) {
			return _react2.default.createElement(
				'div',
				null,
				component
			);
		};
	
		this.openUrl = function (url) {
			window.open(url, '_blank');
		};
	
		this.getNbDataComponent = function (siteType) {
			var nbData = siteType.nbSites;
			if (nbData) {
				return _react2.default.createElement(_Chip2.default, {
					size: 'small',
					label: (0, _NumberUtils.nFormatter)(nbData) + ' ' + (0, _StringUtils.getPlurialWithNumber)(_simpleReactI18n2.default.availablePoint, _simpleReactI18n2.default.availablePoints, nbData)
				});
			}
			return _react2.default.createElement(_Chip2.default, {
				size: 'small',
				label: _simpleReactI18n2.default.noSites
			});
		};
	};
	
	ThemePanel.propTypes = {
		theme: _propTypes2.default.object,
		id: _propTypes2.default.string,
		user: _propTypes2.default.objectOf(_DtoUser2.default),
		sources: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoSource2.default)),
		dataTypeStatistics: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoDataTypeStatistics2.default))
	};
	var mapStateToProps = function mapStateToProps(store) {
		return {
			user: store.HomeReducer.user,
			sources: store.AdministrationReducer.sources,
			dataTypeStatistics: store.AdministrationReducer.dataTypeStatistics
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ThemePanel);

/***/ },
/* 2093 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
		MASTER_THEMES: [{
			id: '0',
			title: 'Ressource en eau',
			comment: 'Thème ressource en eau',
			image: 'https://www.aquasys.fr/wp-content/uploads/2018/01/ressource-en-eau.jpg',
			color: '28, 189, 200'
		}, {
			id: '1',
			title: 'Qualité des hydrosystèmes',
			comment: 'Gestion de Qualité des eaux',
			image: 'https://www.aquasys.fr/wp-content/uploads/2018/01/qualite-des-hydrosystemes.jpg',
			color: '17, 133, 138'
		}, {
			id: '2',
			title: 'Pression',
			comment: 'Thème pression',
			image: 'http://www.aquasys.fr/wp-content/uploads/2017/10/Eau-potable.jpeg',
			color: '118, 135, 136'
		}, {
			id: '3',
			title: 'Territoire',
			comment: 'Thème territoire',
			image: 'https://www.aquasys.fr/wp-content/uploads/2017/12/yulian.jpg',
			color: '68, 122, 60'
		}],
		THEMES: [{
			id: '0',
			title: 'Piézométrie',
			masterTheme: '0',
			pic: 'https://www.aquasys.fr/wp-content/uploads/2018/01/piezo.jpg',
			color: '28, 189, 200',
			disable: false
		}, {
			id: '1',
			title: 'Hydrométrie',
			masterTheme: '0',
			pic: 'https://www.aquasys.fr/wp-content/uploads/2018/01/hydro.jpg',
			color: '44, 62, 109',
			disable: false
		}, {
			id: '2',
			title: 'Météorologie',
			masterTheme: '0',
			pic: 'https://www.aquasys.fr/wp-content/uploads/2018/01/meteo.jpg',
			color: '118, 135, 136',
			disable: false
		}, {
			id: '5',
			title: 'Physico-chimie',
			masterTheme: '1',
			pic: 'https://www.aquasys.fr/wp-content/uploads/2018/01/pc.jpg',
			color: '196, 22, 99',
			disable: false
		}, {
			id: '4',
			title: 'Hydrobiologie',
			masterTheme: '1',
			pic: 'https://www.aquasys.fr/wp-content/uploads/2018/01/hydrobio.jpg',
			color: '17, 133, 138',
			supports: ['4'],
			disable: false
		}, {
			id: '3',
			title: 'Hydromorphologie',
			masterTheme: '1',
			pic: 'https://www.aquasys.fr/wp-content/uploads/2018/01/hydromorpho.jpg',
			color: '18, 84, 153',
			disable: false
		}, {
			id: '8',
			title: 'Services de l\'eau',
			masterTheme: '2',
			pic: 'https://www.aquasys.fr/wp-content/uploads/2017/10/Eau-potable.jpeg',
			color: '44, 62, 109',
			disable: false
		}, {
			id: '7',
			title: 'Industrie',
			masterTheme: '2',
			pic: 'https://www.aquasys.fr/wp-content/uploads/2018/01/industrie.jpg',
			color: '118, 135, 136',
			disable: false
		}, {
			id: '6',
			title: 'Agriculture',
			masterTheme: '2',
			pic: 'https://www.aquasys.fr/wp-content/uploads/2018/01/agri.jpg',
			color: '129, 168, 69',
			disable: true
		}, {
			id: '10',
			title: 'Nature & Paysage',
			masterTheme: '3',
			pic: 'https://www.aquasys.fr/wp-content/uploads/2018/01/nature.jpg',
			color: '68, 122, 60',
			disable: true
		}, {
			id: '11',
			title: 'Sol & Sous-sol',
			masterTheme: '3',
			pic: 'https://www.aquasys.fr/wp-content/uploads/2018/01/sols.jpg',
			color: '118, 135, 136',
			disable: false
		}, {
			id: '9',
			title: 'Administration',
			masterTheme: '3',
			pic: 'https://www.aquasys.fr/wp-content/uploads/2018/01/admin.jpg',
			color: '12, 84, 153',
			disable: false
		}],
		LAYERS: [{
			id: '0',
			name: 'Zones sensibles aux remontées de nappes',
			type: 'WMS',
			url: 'http://geoservices.brgm.fr/risques?',
			layer: 'REMNAPPE_FIAB',
			visibility: false,
			themes: ['0'],
			source: 196608,
			zoom: '<= 5km',
			updateDate: 'Inconnu'
		}, {
			id: '2',
			name: 'Entités hydrogéologiques affleurantes niveau 1',
			type: 'WMS',
			url: 'http://www.reseau.eaufrance.fr/geotraitements/bdlisa/services/carto/?',
			layer: 'ENTITES_O1_NV1',
			opacity: 1,
			visibility: false,
			themes: ['0', '5'],
			source: 32769,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		}, {
			id: '3',
			name: 'Entités hydrogéologiques affleurantes niveau 2',
			type: 'WMS',
			url: 'http://www.reseau.eaufrance.fr/geotraitements/bdlisa/services/carto/?',
			layer: 'ENTITES_O1_NV2',
			opacity: 1,
			visibility: false,
			themes: ['0', '5'],
			source: 32769,
			zoom: '<5km',
			updateDate: 'Inconnu'
		}, {
			id: '4',
			name: 'Entités hydrogéologiques affleurantes niveau 3',
			type: 'WMS',
			url: 'http://www.reseau.eaufrance.fr/geotraitements/bdlisa/services/carto/?',
			layer: 'ENTITES_O1_NV3',
			opacity: 1,
			visibility: false,
			themes: ['0', '5'],
			source: 32769,
			zoom: '<2km',
			updateDate: 'Inconnu'
		}, {
			id: '5',
			name: 'Plan d\'eau',
			type: 'WMS',
			url: 'http://services.sandre.eaufrance.fr/geo/eth_FXX?',
			layer: 'PlanEau',
			opacity: 1,
			visibility: false,
			themes: ['9'],
			source: 6,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		}, {
			id: '8',
			name: 'Hydroecorégions de niveau 2 (HER-2)',
			type: 'WMS',
			url: 'http://services.sandre.eaufrance.fr/geo/mdo_FXX?',
			layer: 'Hydroecoregion2',
			opacity: 1,
			visibility: false,
			themes: ['4'],
			source: 6,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		}, {
			id: '9',
			name: 'Tronçons élémentaires de masse d\'eau cours d\'eau - 2016',
			type: 'WMS',
			url: 'http://services.sandre.eaufrance.fr/geo/MasseDEau_VRAP2016?',
			layer: 'TronconElemMasseDEauRiviere_FXX',
			opacity: 1,
			visibility: false,
			themes: ['9'],
			source: 6,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		}, {
			id: '10',
			name: 'Aires d\'Alimentation de Captage (AAC)',
			type: 'WMS',
			url: 'http://services.sandre.eaufrance.fr/geo/aac_FRA?',
			layer: 'AiresAlimCaptage_FRA',
			opacity: 1,
			visibility: false,
			themes: ['8'],
			source: 6,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		}, {
			id: '11',
			name: 'Schémas d\'Aménagement et de Gestion des Eaux (SAGE) - Métropole',
			type: 'WMS',
			url: 'http://services.sandre.eaufrance.fr/geo/zon_FXX?',
			layer: 'Sage',
			opacity: 1,
			visibility: false,
			themes: ['9'],
			source: 6,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		}, {
			id: '12',
			name: 'Contrats de milieu - Métropole',
			type: 'WMS',
			url: 'http://services.sandre.eaufrance.fr/geo/zon_FXX?',
			layer: 'ContratMilieu',
			opacity: 1,
			visibility: false,
			themes: ['9'],
			source: 6,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		}, {
			id: '13',
			name: 'Zones sensibles - Métropole',
			type: 'WMS',
			url: 'http://services.sandre.eaufrance.fr/geo/zs_FRA?',
			layer: 'ZoneSensibleFXX',
			opacity: 1,
			visibility: false,
			themes: [],
			source: 6,
			zoom: '<5km',
			updateDate: 'Inconnu'
		}, {
			id: '14',
			name: 'Zones de répartition des eaux (ZRE) - Métropole',
			type: 'WMS',
			url: 'http://services.sandre.eaufrance.fr/geo/zon_FXX?',
			layer: 'ZRE',
			opacity: 1,
			visibility: false,
			themes: ['9'],
			source: 6,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		}, {
			id: '15',
			name: 'Périmètre de Gestion Collective (PGC) - Métropole',
			type: 'WMS',
			url: 'http://services.sandre.eaufrance.fr/geo/PGC?',
			layer: 'PGC_FXX',
			opacity: 1,
			visibility: false,
			themes: ['9'],
			source: 6,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		}, {
			id: '16',
			name: 'Segments du Domaine Public Fluvial (DPF) - Métropole',
			type: 'WMS',
			url: 'http://services.sandre.eaufrance.fr/geo/zon_FXX?',
			layer: 'SegDPF',
			opacity: 1,
			visibility: false,
			themes: ['9'],
			source: 6,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		}, {
			id: '21',
			name: 'Territoires à Risques d\'Inondation (TRI)',
			type: 'WMS',
			url: 'http://carto.sigloire.fr/cgi-bin/mapserv?',
			layer: 'n_tri_nant2014_inondable_s_044,n_tri_snaz2014_inondable_s_044,n_tri_aigu2014_carte_inond_s_085,n_tri_noir2015_inondable_s_085,n_tri_ange2013_carte_inond_s_049,n_tri_mans_inondable_s_072',
			opacity: 1,
			visibility: false,
			themes: [],
			source: 'TO DO',
			zoom: '?',
			updateDate: 'Inconnu'
		}, {
			id: '22',
			name: 'Cartes géologiques 1/50 000ième',
			type: 'WMS',
			url: 'http://geoservices.brgm.fr/geologie',
			layer: 'SCAN_D_GEOL50',
			opacity: 1,
			visibility: false,
			themes: ['11'],
			source: 196608,
			zoom: '<5km',
			updateDate: 'Inconnu'
		}, {
			id: '23',
			name: 'Indice de Développement et de Persistance des Réseaux',
			type: 'WMS',
			url: 'http://geoservices.brgm.fr/geologie',
			layer: 'IDPR',
			opacity: 1,
			visibility: false,
			themes: ['0', '1'],
			source: 196608,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		}, {
			id: '24',
			name: 'Classification 2016',
			type: 'WMS',
			url: 'http://cyan.ups-tlse.fr:8080/geoserver/Theia_OSO/wms?',
			layer: 'Theia_OSO:S2_2016_AllFeatures',
			opacity: 1,
			visibility: false,
			themes: ['6'],
			source: 'TO DO',
			zoom: '?',
			updateDate: 'Inconnu'
		}, {
			id: '25',
			name: 'Classification 2016 20m',
			type: 'WMS',
			url: 'http://cyan.ups-tlse.fr:8080/geoserver/Theia_OSO/wms?',
			layer: 'Theia_OSO:S2_2016_AllFeatures_20m',
			opacity: 1,
			visibility: false,
			themes: ['6'],
			source: 'TO DO',
			zoom: '?',
			updateDate: 'Inconnu'
		}, {
			id: '26',
			name: 'Validité 2016',
			type: 'WMS',
			url: 'http://cyan.ups-tlse.fr:8080/geoserver/Theia_OSO/wms?',
			layer: 'Theia_OSO:PixelsValidity_ColorIndexed_S2_2016_AllFeatures',
			opacity: 1,
			visibility: false,
			themes: ['6'],
			source: 'TO DO',
			zoom: '?',
			updateDate: 'Inconnu'
		}, {
			id: '27',
			name: 'Confiance 2016',
			type: 'WMS',
			url: 'http://cyan.ups-tlse.fr:8080/geoserver/Theia_OSO/wms?',
			layer: 'Theia_OSO:Confidence_ColorIndexed_S2_2016_AllFeatures',
			opacity: 1,
			visibility: false,
			themes: ['6'],
			source: 'TO DO',
			zoom: '?',
			updateDate: 'Inconnu'
		}, {
			id: '28',
			name: 'Canalisations de transport de matières dangereuses : Gaz naturel',
			type: 'WMS',
			url: 'http://georisques.gouv.fr/services?',
			layer: 'C_GAZ',
			opacity: 1,
			visibility: false,
			themes: ['7'],
			source: 32771,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		}, {
			id: '29',
			name: 'Canalisations de transport de matières dangereuses : Hydrocarbures',
			type: 'WMS',
			url: 'http://georisques.gouv.fr/services?',
			layer: 'C_HYDROCARBURES',
			opacity: 1,
			visibility: false,
			themes: ['7'],
			source: 32771,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		}, {
			id: '30',
			name: 'Canalisations de transport de matières dangereuses : Produits chimiques',
			type: 'WMS',
			url: 'http://georisques.gouv.fr/services?',
			layer: 'C_PRODUITS_CHIM',
			opacity: 1,
			visibility: false,
			themes: ['7'],
			source: 32771,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		}, {
			id: '31',
			name: 'Masse d\'eau souterraine Métropole',
			type: 'WMS',
			url: 'http://services.sandre.eaufrance.fr/geo/mdo_FXX?',
			layer: 'MasseDEauSouterraine',
			opacity: 1,
			visibility: false,
			themes: ['0', '5'],
			source: 6,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		}, {
			id: '33',
			name: 'Régions biogéographiques',
			type: 'WMS',
			url: 'http://ws.carmencarto.fr/WMS/119/fxx_ref?',
			layer: 'MNHN___INPN___Metropole',
			opacity: 1,
			visibility: false,
			themes: ['2'],
			source: 163841,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		}, {
			id: '36',
			name: 'Réseau éléctrique',
			type: 'WMS',
			url: 'https://carto.atlasante.fr/cgi-bin/mapserv?',
			layer: 'MetropoleReseauelectriqueBDTop',
			opacity: 1,
			visibility: false,
			themes: ['7'],
			source: 163840,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		}, {
			id: '37',
			name: 'Territoires à Risques Importants d\'Inondation',
			type: 'WMS',
			url: 'http://ws.carmen.developpement-durable.gouv.fr/WMS/203/communes_tri?',
			layer: 'Territoires_a_Risques_Importants_d_Inondation',
			opacity: 1,
			visibility: false,
			themes: ['9'],
			source: 163841,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		}, {
			id: '38',
			name: 'Communes concernées par un PPR Inondation approuvé',
			type: 'WMS',
			url: 'http://georisques.gouv.fr/services?',
			layer: 'PPRN_COMMUNE_RISQINOND_APPROUV',
			opacity: 1,
			visibility: false,
			themes: ['9'],
			source: 32771,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		}, {
			id: '39',
			name: 'Communes concernées par un PPR Risque industriel approuvé',
			type: 'WMS',
			url: 'http://georisques.gouv.fr/services?',
			layer: 'PPRT_COMMUNE_RISQIND_APPROUV',
			opacity: 1,
			visibility: false,
			themes: ['9'],
			source: 32771,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		}, {
			id: '40',
			name: 'Communes concernées par un PPR technologiques',
			type: 'WMS',
			url: 'http://georisques.gouv.fr/services?',
			layer: 'PPRT_COMMUNE_GASPAR',
			opacity: 1,
			visibility: false,
			themes: ['9'],
			source: 32771,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		}, {
			id: '41',
			name: 'Population communale dans l\'EAIP cours d\'eau',
			type: 'WMS',
			url: 'http://ws.carmen.developpement-durable.gouv.fr/WMS/281/EnjeuxInondation?',
			layer: 'POP_EAIP_CE',
			opacity: 1,
			visibility: false,
			themes: ['1'],
			source: 163841,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		}, {
			id: '42',
			name: 'Population communale dans l\'EAIP submersion marine',
			type: 'WMS',
			url: 'http://ws.carmen.developpement-durable.gouv.fr/WMS/281/EnjeuxInondation?',
			layer: 'POP_EAIP_SM',
			opacity: 1,
			visibility: false,
			themes: ['1'],
			source: 163841,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		}, {
			id: '43',
			name: 'Emprise totale des bâtiments dans l\'EAIP submersion marine (en m²)',
			type: 'WMS',
			url: 'http://ws.carmen.developpement-durable.gouv.fr/WMS/281/EnjeuxInondation?',
			layer: 'BAT_TOT_EAIP_SM',
			opacity: 1,
			visibility: false,
			themes: ['1'],
			source: 163841,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		}, {
			id: '44',
			name: 'Emprise totale des bâtiments dans l\'EAIP cours d\'eau (en m²)',
			type: 'WMS',
			url: 'http://ws.carmen.developpement-durable.gouv.fr/WMS/281/EnjeuxInondation?',
			layer: 'BAT_TOT_EAIP_CE',
			opacity: 1,
			visibility: false,
			themes: ['1'],
			source: 163841,
			zoom: '<= 100km',
			updateDate: 'Inconnu'
		}, {
			id: '45',
			name: 'Hydrographie',
			type: 'WMS',
			url: 'http://ws.carmen.developpement-durable.gouv.fr/WMS/281/sinistralite_inondation_test?',
			layer: 'Hydrographie',
			opacity: 1,
			visibility: false,
			themes: ['1'],
			source: 163841,
			zoom: '<= 5km',
			updateDate: 'Inconnu'
		}],
		SITE_TYPES: [{
			type: 'INDUSTRIAL_SITE',
			themes: ['7'],
			source: 32771
		}, {
			type: 'POLLUTED_SOIL',
			themes: ['7'],
			source: 32771
		}, {
			type: 'QUALITOMETER',
			themes: ['5'],
			source: 1
		}, {
			type: 'QUALITOMETER_SURFACE',
			themes: ['3', '4', '5'],
			source: 5
		}, {
			type: 'PIEZOMETER',
			themes: ['0'],
			source: 1
		}, {
			type: 'PIEZOMETER_REFERENCE',
			themes: ['0'],
			source: 1
		}, {
			type: 'PLUVIOMETER',
			themes: ['2'],
			source: 7
		}, {
			type: 'SEAPORT',
			themes: ['1'],
			source: 32776
		}, {
			type: 'HYDROLOGICAL_STATION',
			themes: ['1'],
			source: 3
		}, {
			type: 'TREATMENT_STATION',
			themes: ['8'],
			source: 6
		}, {
			type: 'OBSTACLE_FLOW',
			themes: ['3'],
			source: 6
		}, {
			type: 'HYDROLOGICAL_SITE',
			themes: ['1'],
			source: 3
		}, {
			type: 'HYDROLOGICAL_INDICATOR',
			themes: ['1'],
			source: 3
		}, {
			type: 'CITY',
			themes: ['8', '9'],
			source: 32774
		}, {
			type: 'FISHING_PLACE',
			themes: ['4'],
			source: 65536
		}, {
			type: 'CAVITY',
			themes: ['11'],
			source: 32771
		}],
		NEWS: [{
			id: 0,
			link: 'https://aquasys.fr/',
			title: 'Sécheresse record sur tout le territoire',
			content: 'Cet été 84 départements ont mis en œuvre des arrêtés de restriction des usages de l’eau !',
			status: 1,
			date: 1535118421954
		}, {
			id: 1,
			link: 'https://aquasys.fr/',
			title: 'Confiance renouvelée par le BRGM',
			content: 'Le BRGM vient de prolonger de 4 ans notre prestation de gestion et maintenance de leur SIE',
			status: 1,
			date: 1425118421954
		}]
	};

/***/ },
/* 2094 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.store = undefined;
	exports.AdministrationReducer = AdministrationReducer;
	
	var _AdministrationConstants = __webpack_require__(1014);
	
	var _MasterThemeDto = __webpack_require__(527);
	
	var _MasterThemeDto2 = _interopRequireDefault(_MasterThemeDto);
	
	var _DtoSource = __webpack_require__(222);
	
	var _DtoSource2 = _interopRequireDefault(_DtoSource);
	
	var _LegendDto = __webpack_require__(373);
	
	var _LegendDto2 = _interopRequireDefault(_LegendDto);
	
	var _NewsDto = __webpack_require__(1016);
	
	var _NewsDto2 = _interopRequireDefault(_NewsDto);
	
	var _lodash = __webpack_require__(15);
	
	var _DtoDataTypeStatistics = __webpack_require__(1015);
	
	var _DtoDataTypeStatistics2 = _interopRequireDefault(_DtoDataTypeStatistics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var store = exports.store = {
		themes: [],
		selectedThemes: [],
		selectedFilters: [],
		filterEntry: '',
		sources: [],
		dataTypeStatistics: [],
		legends: [],
		news: []
	};
	
	function AdministrationReducer() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		var action = arguments[1];
	
		switch (action.type) {
			case _AdministrationConstants.RECEIVE_THEMES:
				return Object.assign({}, state, {
					themes: action.themes.map(function (t) {
						return new _MasterThemeDto2.default(t);
					})
				});
			case _AdministrationConstants.SELECTED_THEMES:
				return Object.assign({}, state, {
					selectedThemes: action.selectedThemes
				});
			case _AdministrationConstants.SELECTED_FILTERS:
				return Object.assign({}, state, {
					selectedFilters: action.selectedFilters
				});
			case _AdministrationConstants.ENTRY_FILTER:
				return Object.assign({}, state, {
					filterEntry: action.filterEntry
				});
			case _AdministrationConstants.RESET_SELECTED_THEMES:
				return Object.assign({}, state, {
					selectedThemes: []
				});
			case _AdministrationConstants.RESET_SELECTED_FILTERS:
				return Object.assign({}, state, {
					selectedFilters: []
				});
			case _AdministrationConstants.RESET_ENTRY_FILTER:
				return Object.assign({}, state, {
					filterEntry: ''
				});
			case _AdministrationConstants.RECEIVE_ALL_SOURCES:
				return Object.assign({}, state, {
					sources: action.sources.map(function (t) {
						return new _DtoSource2.default(t);
					})
				});
			case _AdministrationConstants.RECEIVE_DATA_TYPE_STATISTICS:
				return Object.assign({}, state, {
					dataTypeStatistics: action.dataTypeStatistics.map(function (o) {
						return new _DtoDataTypeStatistics2.default(o);
					})
				});
			case _AdministrationConstants.RECEIVE_LEGENDS:
				return Object.assign({}, state, {
					legends: action.legends.map(function (o) {
						return new _LegendDto2.default(o);
					})
				});
			case _AdministrationConstants.RECEIVE_NEWS:
				var difference = (0, _lodash.differenceBy)(action.news, state.news, 'id').map(function (o) {
					return new _NewsDto2.default(o);
				});
				return Object.assign({}, state, {
					news: [].concat(difference, state.news).sort(function (a, b) {
						return b.date - a.date;
					})
				});
			case _AdministrationConstants.READ_NEWS:
				return Object.assign({}, state, {
					news: action.news.map(function (o) {
						return new _NewsDto2.default(Object.assign({}, o, { status: 0 }));
					})
				});
			case _AdministrationConstants.ADD_LEGEND:
				if (action.legend.content) {
					var _boxes = state.legends.slice();
					var nbBoxes = _boxes.length;
					var left = nbBoxes ? _boxes[nbBoxes - 1].left + 5 : 5;
					var top = nbBoxes ? _boxes[nbBoxes - 1].top + 5 : 300;
					var legend = Object.assign({}, action.legend, {
						left: left,
						top: top
					});
					_boxes.push(legend);
					return Object.assign({}, state, {
						legends: (0, _lodash.uniq)(_boxes)
					});
				}
				return Object.assign({}, state, {
					legends: state.legends
				});
			case _AdministrationConstants.REMOVE_LEGEND:
				var boxes = state.legends.slice();
				var result = (0, _lodash.filter)(boxes, function (o) {
					return o.id !== action.legendId;
				});
				return Object.assign({}, state, {
					legends: result
				});
			case _AdministrationConstants.RESET_ADMINISTRATION_STORE:
				return Object.assign({}, state, store);
			default:
				return state;
		}
	}

/***/ },
/* 2095 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _IAction2 = __webpack_require__(1018);
	
	var _IAction3 = _interopRequireDefault(_IAction2);
	
	var _uuid = __webpack_require__(44);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = window.$;
	
	var Notif = function (_IAction) {
	    _inherits(Notif, _IAction);
	
	    function Notif(props) {
	        _classCallCheck(this, Notif);
	
	        var _this = _possibleConstructorReturn(this, (Notif.__proto__ || Object.getPrototypeOf(Notif)).call(this, props));
	
	        _this.fn = function () {
	            return _this.props.onClick;
	        };
	
	        _this.icon = function () {
	            return _this.props.icon;
	        };
	
	        _this.label = function () {
	            return _this.props.label || _this.title();
	        };
	
	        _this.title = function () {
	            return _this.props.title;
	        };
	
	        _this.state = { key: _uuid2.default.v4() };
	        return _this;
	    }
	
	    _createClass(Notif, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            $('.dropdown-button.' + this.state.key).dropdown();
	        }
	    }, {
	        key: 'getColor',
	        value: function getColor() {
	            return this.props.color ? { backgroundColor: this.props.color } : {};
	        }
	    }, {
	        key: 'notifs',
	        value: function notifs() {
	            if (this.props.notifs > 0) {
	                return _react2.default.createElement(
	                    'span',
	                    { className: 'new badge', style: this.getColor() },
	                    this.props.notifs
	                );
	            }
	            return null;
	        }
	    }, {
	        key: 'dropdown',
	        value: function dropdown() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'dropdown-content row no-margin ' + this.state.key, id: this.title() },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col s12 no-padding title' },
	                    _react2.default.createElement(
	                        'h6',
	                        { className: 'center-align' },
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            this.label()
	                        )
	                    ),
	                    _react2.default.createElement('p', { className: 'no-margin no-padding divider' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col s12 no-padding' },
	                    this.props.content
	                )
	            );
	        }
	    }]);
	
	    return Notif;
	}(_IAction3.default);
	
	Notif.propTypes = {
	    onClick: _propTypes2.default.func,
	    icon: _propTypes2.default.string.isRequired,
	    label: _propTypes2.default.string,
	    color: _propTypes2.default.string,
	    content: _propTypes2.default.element,
	    notifs: _propTypes2.default.number
	};
	
	Notif.defaultProps = {
	    onClick: function onClick() {},
	    icon: 'ICON Not specified',
	    label: '',
	    color: '',
	    content: '',
	    notifs: 0
	};
	
	exports.default = Notif;

/***/ },
/* 2096 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	    NOTIF: 'NOTIF'
	};

/***/ },
/* 2097 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _AdministrationAction = __webpack_require__(61);
	
	var _AdministrationAction2 = _interopRequireDefault(_AdministrationAction);
	
	var _reactRedux = __webpack_require__(18);
	
	var _AutocompleteList = __webpack_require__(2098);
	
	var _AutocompleteList2 = _interopRequireDefault(_AutocompleteList);
	
	var _DtoCity = __webpack_require__(87);
	
	var _DtoCity2 = _interopRequireDefault(_DtoCity);
	
	var _DtoWatershed = __webpack_require__(183);
	
	var _DtoWatershed2 = _interopRequireDefault(_DtoWatershed);
	
	var _ResearchTypes = __webpack_require__(288);
	
	var _ResearchTypes2 = _interopRequireDefault(_ResearchTypes);
	
	var _DtoSimpleStation = __webpack_require__(382);
	
	var _DtoSimpleStation2 = _interopRequireDefault(_DtoSimpleStation);
	
	var _DtoManagementWater = __webpack_require__(223);
	
	var _DtoManagementWater2 = _interopRequireDefault(_DtoManagementWater);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _lodash = __webpack_require__(15);
	
	var _SiteTypes = __webpack_require__(56);
	
	var _SiteTypes2 = _interopRequireDefault(_SiteTypes);
	
	var _reactTimeout = __webpack_require__(2245);
	
	var _reactTimeout2 = _interopRequireDefault(_reactTimeout);
	
	var _FilterUtils = __webpack_require__(1054);
	
	var _DtoStation = __webpack_require__(88);
	
	var _DtoStation2 = _interopRequireDefault(_DtoStation);
	
	var _DtoDepartment = __webpack_require__(381);
	
	var _DtoDepartment2 = _interopRequireDefault(_DtoDepartment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WAIT_INTERVAL = 500;
	
	var AutoComplete = function (_Component) {
		_inherits(AutoComplete, _Component);
	
		function AutoComplete(props) {
			_classCallCheck(this, AutoComplete);
	
			var _this = _possibleConstructorReturn(this, (AutoComplete.__proto__ || Object.getPrototypeOf(AutoComplete)).call(this, props));
	
			_this.removeEntry = function () {
				_this.setState({ filterEntry: '' });
			};
	
			_this.handleChange = function (e) {
				_this.props.setTimeout(_this.setState({ filterEntry: e.target.value }), WAIT_INTERVAL);
			};
	
			_this.getCitiesRef = function () {
				return (0, _FilterUtils.filterList)(_this.props.cities, _this.state.filterEntry, _this.props.cities.length).map(function (o) {
					var postalCode = o.postalCode ? o.postalCode : o.code;
					return {
						label: '[' + o.code + '] - ' + o.name + ' - ' + postalCode,
						value: o
					};
				});
			};
	
			_this.getDepartmentsRef = function () {
				return (0, _FilterUtils.filterList)(_this.props.departments, _this.state.filterEntry, _this.props.cities.length).map(function (o) {
					var code = o.code ? '[' + o.code + ']' : '';
					return {
						label: code + ' - ' + o.name,
						value: o
					};
				});
			};
	
			_this.getWaterShedRef = function () {
				return (0, _FilterUtils.filterList)(_this.props.watersheds, _this.state.filterEntry, _this.props.cities.length).map(function (o) {
					var code = o.code ? '[' + o.code + ']' : '';
					return {
						label: code + ' - ' + o.name,
						value: o
					};
				});
			};
	
			_this.getManagementWaterRef = function () {
				return (0, _FilterUtils.filterList)(_this.props.managementWaters, _this.state.filterEntry, _this.props.cities.length).map(function (o) {
					var code = o.code ? '[' + o.code + ']' : '';
					return {
						label: code + ' - ' + o.name,
						value: o
					};
				});
			};
	
			_this.getStationRef = function () {
				var selectedTypes = (0, _lodash.uniq)((0, _lodash.flattenDeep)(_this.props.selectedThemes.map(function (t) {
					return t.value.siteTypes.map(function (o) {
						return o.type;
					});
				})));
				return (0, _FilterUtils.filterList)(_this.props.stations, _this.state.filterEntry, _this.props.cities.length).filter(function (o) {
					if (o.isPiezometer === '1' && o.isQualitometer === '1') {
						return (0, _lodash.find)(selectedTypes, function (t) {
							return t === _SiteTypes2.default.PIEZOMETER.type || t === _SiteTypes2.default.QUALITOMETER.type;
						});
					}
					return (0, _lodash.find)(selectedTypes, function (t) {
						return t === o.typeParameter;
					});
				}).map(function (o) {
					var code = o.code ? '[' + o.code + ']' : '';
					return {
						label: code + ' - ' + o.name,
						value: o
					};
				});
			};
	
			_this.getFilterResult = function () {
				if (_this.state.filterEntry.length >= 3) {
					var minWidth = function () {
						if (_this.props.isResearchMap) {
							return '60vw';
						}
						return '1280px';
					}();
					var justifyContent = function () {
						if (_this.props.isResearchMap) {
							return 'flex-start';
						}
						return 'center';
					}();
					var style = {
						zIndex: 1000,
						position: 'absolute',
						minWidth: minWidth,
						maxWidth: '80vw',
						margin: '3.5rem auto 0',
						right: 0,
						left: 0
					};
					var moreStyle = {
						borderRadius: '2px',
						overflow: 'hidden',
						display: 'flex',
						justifyContent: justifyContent,
						flexWrap: 'wrap'
					};
					return _react2.default.createElement(
						'div',
						{ className: 'col s12 no-padding', style: style },
						_react2.default.createElement(
							'div',
							{ className: 'row no-margin', style: moreStyle },
							_react2.default.createElement(_AutocompleteList2.default, { key: 'city', list: _this.getCitiesRef(), type: _ResearchTypes2.default.CITY,
								isFirst: true, icon: 'location_city', isResearchMap: _this.props.isResearchMap,
								singularTitle: _simpleReactI18n2.default.town, plurialTitle: _simpleReactI18n2.default.towns,
								removeEntry: _this.removeEntry }),
							_react2.default.createElement(_AutocompleteList2.default, { key: 'watershed', list: _this.getWaterShedRef(),
								type: _ResearchTypes2.default.WATERSHED, isMiddle: true, icon: 'texture',
								isResearchMap: _this.props.isResearchMap,
								singularTitle: _simpleReactI18n2.default.watershedArea, plurialTitle: _simpleReactI18n2.default.watersheds,
								removeEntry: _this.removeEntry }),
							_react2.default.createElement(_AutocompleteList2.default, { key: 'stations', list: _this.getStationRef(),
								type: _ResearchTypes2.default.STATION, isMiddle: true,
								icon: 'location_on', isResearchMap: _this.props.isResearchMap,
								singularTitle: _simpleReactI18n2.default.station, plurialTitle: _simpleReactI18n2.default.stations,
								removeEntry: _this.removeEntry }),
							_react2.default.createElement(_AutocompleteList2.default, { key: 'departments', list: _this.getDepartmentsRef(),
								type: _ResearchTypes2.default.DEPARTMENT, isEnd: true,
								icon: 'location_on', isResearchMap: _this.props.isResearchMap,
								singularTitle: _simpleReactI18n2.default.department, plurialTitle: _simpleReactI18n2.default.departments,
								removeEntry: _this.removeEntry })
						)
					);
				}
				return null;
			};
	
			_this.state = {
				filterEntry: ''
			};
			return _this;
		}
	
		_createClass(AutoComplete, [{
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				_AppStore2.default.dispatch(_AdministrationAction2.default.resetEntry());
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin' },
					_react2.default.createElement(
						'div',
						{ className: 'input-field col s12 no-margin' },
						_react2.default.createElement('input', { ref: 'filterInput', id: 'research', type: 'text',
							className: 'no-margin validate input-research-input',
							onChange: this.handleChange,
							defaultValue: this.state.filterEntry,
							value: this.state.filterEntry,
							placeholder: _simpleReactI18n2.default.geographicalCriteriaResearch }),
						_react2.default.createElement('label', { htmlFor: 'research' })
					),
					this.getFilterResult()
				);
			}
		}]);
	
		return AutoComplete;
	}(_react.Component);
	
	AutoComplete.propTypes = {
		selectedFilters: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			label: _propTypes2.default.string,
			value: _propTypes2.default.object
		})),
		isResearchMap: _propTypes2.default.bool,
		cities: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoCity2.default)),
		departments: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoDepartment2.default)),
		watersheds: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoWatershed2.default)),
		stations: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoSimpleStation2.default)),
		managementWaters: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoManagementWater2.default)),
		selectedThemes: _propTypes2.default.arrayOf(_propTypes2.default.object),
		setTimeout: _propTypes2.default.func,
		selectedStations: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoStation2.default))
	};
	var mapStateToProps = function mapStateToProps(store) {
		return {
			selectedFilters: store.AdministrationReducer.selectedFilters,
			cities: store.ReferentialReducer.cities,
			departments: store.ReferentialReducer.departments,
			watersheds: store.ReferentialReducer.watersheds,
			managementWaters: store.ReferentialReducer.managementWaters,
			stations: store.ReferentialReducer.stations,
			selectedThemes: store.AdministrationReducer.selectedThemes,
			selectedStations: store.SitesReducer.selectedStations
		};
	};
	
	var autoCompleteTimeOut = (0, _reactTimeout2.default)(AutoComplete);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(autoCompleteTimeOut);

/***/ },
/* 2098 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _reactRedux = __webpack_require__(18);
	
	var _DtoCity = __webpack_require__(87);
	
	var _DtoCity2 = _interopRequireDefault(_DtoCity);
	
	var _FilterUtils = __webpack_require__(1054);
	
	var _AdministrationAction = __webpack_require__(61);
	
	var _AdministrationAction2 = _interopRequireDefault(_AdministrationAction);
	
	var _lodash = __webpack_require__(15);
	
	var _StringUtils = __webpack_require__(131);
	
	var _uuid = __webpack_require__(44);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _Tooltip = __webpack_require__(240);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _core = __webpack_require__(116);
	
	var _glamor = __webpack_require__(143);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AutocompleteList = function (_Component) {
		_inherits(AutocompleteList, _Component);
	
		function AutocompleteList(props) {
			_classCallCheck(this, AutocompleteList);
	
			var _this = _possibleConstructorReturn(this, (AutocompleteList.__proto__ || Object.getPrototypeOf(AutocompleteList)).call(this, props));
	
			_this.select = function (value) {
				return function () {
					var assignValue = Object.assign({}, value, {
						type: _this.props.type
					});
					var tmp = _this.props.selectedFilters.slice();
					tmp.push(assignValue);
					var resultToAdd = (0, _lodash.uniqWith)(tmp, _lodash.isEqual);
					$('.tooltipped_research').tooltip('remove');
					_AppStore2.default.dispatch(_AdministrationAction2.default.selectedFilters(resultToAdd));
					_this.props.removeEntry();
				};
			};
	
			_this.getMoreBtn = function () {
				var color = '#161832';
				if (_this.props.list.length > _this.state.filterLength) {
					return _react2.default.createElement(
						'div',
						{ className: 'collection-more' },
						_react2.default.createElement(
							_Tooltip2.default,
							{ title: _simpleReactI18n2.default.displayMore },
							_react2.default.createElement(
								_core.Icon,
								Object.assign({ className: 'material-icons' }, (0, _glamor.css)({
									width: 36,
									height: 36,
									color: color,
									fontSize: '2rem !important',
									margin: '7px !important'
								}), { onClick: function onClick() {
										return _this.increaseFilterLength();
									} }),
								' add '
							)
						),
						_react2.default.createElement(
							'span',
							{ onClick: function onClick() {
									return _this.increaseFilterLength();
								} },
							_simpleReactI18n2.default.display,
							' ',
							_this.increaseLength(),
							' ',
							_simpleReactI18n2.default.more
						)
					);
				}
				return null;
			};
	
			_this.getData = function (listSelected) {
				var result = listSelected.map(function (o) {
					var className = function () {
						var resultClass = 'row no-margin collection-item tooltipped_research';
						if (_this.props.isResearchMap) {
							return resultClass + ' autocomplete-item-dark';
						}
						return resultClass + ' autocomplete-item';
					}();
					var label = function () {
						if (_this.props.isResearchMap) {
							return (0, _StringUtils.substringText)(o.label, 35);
						}
						return (0, _StringUtils.substringText)(o.label);
					}();
					return _react2.default.createElement(
						'div',
						{ key: _uuid2.default.v4(), 'data-position': 'top', 'data-delay': '20', 'data-tooltip': o.label,
							className: className,
							onClick: _this.select(o), style: { borderBottom: '0px', fontSize: '12px' } },
						label
					);
				});
				var title = listSelected.length === 0 || listSelected.length === 1 ? _this.props.singularTitle : _this.props.plurialTitle;
				return _react2.default.createElement(
					'div',
					{ className: 'collection with-header', style: { borderRadius: '0px' } },
					_react2.default.createElement(
						'div',
						{ className: 'collection-header no-margin filter-header' },
						_react2.default.createElement(
							'div',
							{ className: 'valign-wrapper' },
							_react2.default.createElement(
								'i',
								{ className: 'material-icons margin-right-10' },
								_this.props.icon
							),
							_react2.default.createElement(
								'b',
								{ className: 'font-size-15' },
								title,
								' ( ',
								_this.props.list.length,
								' )'
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'collection-list' },
						result
					),
					_this.getMoreBtn()
				);
			};
	
			_this.state = { filterLength: 20 };
			return _this;
		}
	
		_createClass(AutocompleteList, [{
			key: 'render',
			value: function render() {
				var listSelected = (0, _FilterUtils.getResult)(this.props.list, this.state.filterLength);
				if (listSelected.length) {
					return _react2.default.createElement(
						'div',
						{ className: 'col s3 no-padding no-margin', style: { minWidth: '277px' } },
						_react2.default.createElement(
							'div',
							{ className: 'row no-margin autocomplete-list' },
							_react2.default.createElement(
								'div',
								{ className: 'col s12 no-padding' },
								this.getData(listSelected)
							)
						)
					);
				}
				return null;
			}
		}, {
			key: 'componentWillUpdate',
			value: function componentWillUpdate() {
				$('.tooltipped_research').tooltip('remove');
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				$('.tooltipped_research').tooltip('remove');
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				$('.tooltipped_research').tooltip({ delay: 20 });
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				$('.tooltipped_research').tooltip({ delay: 20 });
			}
		}, {
			key: 'increaseFilterLength',
			value: function increaseFilterLength() {
				var filterLength = this.state.filterLength + Math.min(20, Math.max(0, this.props.list.length - this.state.filterLength));
				this.setState({ filterLength: filterLength });
			}
		}, {
			key: 'increaseLength',
			value: function increaseLength() {
				return Math.min(20, Math.max(0, this.props.list.length - this.state.filterLength));
			}
		}]);
	
		return AutocompleteList;
	}(_react.Component);
	
	AutocompleteList.propTypes = {
		list: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoCity2.default)).isRequired,
		type: _propTypes2.default.object.isRequired,
		selectedFilters: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			label: _propTypes2.default.string,
			value: _propTypes2.default.object
		})),
		isResearchMap: _propTypes2.default.string,
		icon: _propTypes2.default.string,
		isFirst: _propTypes2.default.boolean,
		isMiddle: _propTypes2.default.boolean,
		isEnd: _propTypes2.default.boolean,
		singularTitle: _propTypes2.default.string,
		plurialTitle: _propTypes2.default.string,
		removeEntry: _propTypes2.default.func
	};
	
	AutocompleteList.defaultProps = {
		list: [],
		title: '',
		isFirst: false,
		isMiddle: false,
		isEnd: false
	};
	var mapStateToProps = function mapStateToProps(store) {
		return {
			selectedFilters: store.AdministrationReducer.selectedFilters
		};
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(AutocompleteList);

/***/ },
/* 2099 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _AdministrationAction = __webpack_require__(61);
	
	var _AdministrationAction2 = _interopRequireDefault(_AdministrationAction);
	
	var _reactRedux = __webpack_require__(18);
	
	var _lodash = __webpack_require__(15);
	
	var _DtoWatershed = __webpack_require__(183);
	
	var _DtoWatershed2 = _interopRequireDefault(_DtoWatershed);
	
	var _SitesAction = __webpack_require__(97);
	
	var _SitesAction2 = _interopRequireDefault(_SitesAction);
	
	var _DtoStation = __webpack_require__(88);
	
	var _DtoStation2 = _interopRequireDefault(_DtoStation);
	
	var _DtoFilterType = __webpack_require__(130);
	
	var _DtoFilterType2 = _interopRequireDefault(_DtoFilterType);
	
	var _ThemeDto = __webpack_require__(129);
	
	var _ThemeDto2 = _interopRequireDefault(_ThemeDto);
	
	var _uuid = __webpack_require__(44);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _ResearchTypesUtils = __webpack_require__(228);
	
	var _Chip = __webpack_require__(234);
	
	var _Chip2 = _interopRequireDefault(_Chip);
	
	var _glamor = __webpack_require__(143);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AutoCompleteChips = function (_Component) {
		_inherits(AutoCompleteChips, _Component);
	
		function AutoCompleteChips(props) {
			_classCallCheck(this, AutoCompleteChips);
	
			var _this = _possibleConstructorReturn(this, (AutoCompleteChips.__proto__ || Object.getPrototypeOf(AutoCompleteChips)).call(this, props));
	
			_this.getChips = function () {
				return _this.props.selectedFilters.map(function (o, index) {
					var rgba = function () {
						if (o.type && o.type.color) {
							return (0, _ResearchTypesUtils.getRgba)(o.type.color, 1);
						}
						return (0, _ResearchTypesUtils.getRgba)('3, 169, 244');
					}();
					return _react2.default.createElement(
						'div',
						{ className: 'col chipsCol' },
						_react2.default.createElement(_Chip2.default, Object.assign({
							key: index,
							label: o.label,
							onDelete: function onDelete() {
								return _this.onRequestDelete(index);
							}
						}, (0, _glamor.css)({ backgroundColor: rgba + ' !important', color: 'white !important' })))
					);
				});
			};
	
			return _this;
		}
	
		_createClass(AutoCompleteChips, [{
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps) {
				return !(0, _lodash.isEqual)(this.props.selectedFilters, nextProps.selectedFilters);
			}
		}, {
			key: 'onRequestDelete',
			value: function onRequestDelete(index) {
				$('.tooltipped_chips').tooltip('remove');
				var tmp = this.props.selectedFilters.slice();
				(0, _lodash.pullAt)(tmp, [index]);
				_AppStore2.default.dispatch(_AdministrationAction2.default.selectedFilters(tmp));
				if (this.props.stations.length) {
					_AppStore2.default.dispatch(_SitesAction2.default.reset());
					_AppStore2.default.dispatch(_SitesAction2.default.fetchResearchTypes());
				}
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ key: _uuid2.default.v4(), className: 'row no-margin' },
					_react2.default.createElement(
						'div',
						{ className: 'col s12 no-padding' },
						_react2.default.createElement(
							'div',
							{ className: 'row no-margin' },
							this.getChips()
						)
					)
				);
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				$('.tooltipped_chips').tooltip({ delay: 20 });
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				$('.tooltipped_chips').tooltip({ delay: 20 });
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				$('.tooltipped_chips').tooltip('remove');
			}
		}]);
	
		return AutoCompleteChips;
	}(_react.Component);
	
	AutoCompleteChips.propTypes = {
		selectedFilters: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			label: _propTypes2.default.string,
			value: _propTypes2.default.object
		})),
		filterEntry: _propTypes2.default.string,
		stations: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoStation2.default)),
		selectedThemes: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			label: _propTypes2.default.string,
			value: _propTypes2.default.instanceOf(_ThemeDto2.default)
		})),
		filterTypes: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoFilterType2.default)),
		themes: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_ThemeDto2.default)),
		watershedSelected: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoWatershed2.default))
	};
	var mapStateToProps = function mapStateToProps(store) {
		return {
			selectedFilters: store.AdministrationReducer.selectedFilters,
			filterEntry: store.AdministrationReducer.filterEntry,
			stations: store.SitesReducer.stations,
			filterTypes: store.ReferentialReducer.filterTypes,
			selectedThemes: store.AdministrationReducer.selectedThemes,
			themes: store.AdministrationReducer.themes,
			watershedSelected: store.SitesReducer.watershedSelected
		};
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(AutoCompleteChips);

/***/ },
/* 2100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BetaBanner = function BetaBanner(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'beta-banner-wrapper' },
	        _react2.default.createElement('img', Object.assign({ src: 'pictures/beta/' + (props.color == 'blue' ? 'blue' : 'grey') + '-banner.svg' }, props))
	    );
	};
	
	BetaBanner.propTypes = {
	    color: _propTypes2.default.string
	};
	
	exports.default = BetaBanner;

/***/ },
/* 2101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _agGridReact = __webpack_require__(1422);
	
	__webpack_require__(1713);
	
	__webpack_require__(1714);
	
	var _uuid = __webpack_require__(44);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _DateUtil = __webpack_require__(67);
	
	var _TypesConstants = __webpack_require__(1056);
	
	var _TypesUtils = __webpack_require__(2210);
	
	var _HtmlRenderer = __webpack_require__(2102);
	
	var _HtmlRenderer2 = _interopRequireDefault(_HtmlRenderer);
	
	var _lodash = __webpack_require__(15);
	
	var lodash = _interopRequireWildcard(_lodash);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ActionComponent2 = __webpack_require__(283);
	
	var _ActionComponent3 = _interopRequireDefault(_ActionComponent2);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _SelectionAction = __webpack_require__(95);
	
	var _SelectionAction2 = _interopRequireDefault(_SelectionAction);
	
	var _reactRedux = __webpack_require__(18);
	
	var _DtoSelection = __webpack_require__(181);
	
	var _DtoSelection2 = _interopRequireDefault(_DtoSelection);
	
	var _DtoUser = __webpack_require__(54);
	
	var _DtoUser2 = _interopRequireDefault(_DtoUser);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AgGridTable = function (_ActionComponent) {
		_inherits(AgGridTable, _ActionComponent);
	
		_createClass(AgGridTable, [{
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps) {
				return !(0, _lodash.isEqual)(nextProps.type, this.props.type) || !(0, _lodash.isEqual)(nextProps.datas, this.props.datas) || !(0, _lodash.isEqual)(nextProps.cellHeight, this.props.cellHeight);
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.selectedExportSelections.length && !(0, _lodash.isEqual)(nextProps.selectedExportSelections, this.props.selectedExportSelections)) {
					this.setAction([this.getExportActions(), this.getExportSelectedSelections(nextProps)]);
				} else {
					this.checkRemoveSelected(nextProps.selectedExportSelections);
					this.setAction([this.getExportActions()]);
				}
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.setAction([this.getExportActions()]);
			}
		}]);
	
		function AgGridTable(props) {
			_classCallCheck(this, AgGridTable);
	
			var _this = _possibleConstructorReturn(this, (AgGridTable.__proto__ || Object.getPrototypeOf(AgGridTable)).call(this, props));
	
			_initialiseProps.call(_this);
	
			_this.state = {
				key: _uuid2.default.v4()
			};
			return _this;
		}
	
		_createClass(AgGridTable, [{
			key: 'render',
			value: function render() {
				var allTopologiesCopy = lodash.cloneDeep(this.props.datas);
				return _react2.default.createElement(
					'div',
					{ key: this.state.key, className: 'ag-theme-material', id: this.state.key },
					_react2.default.createElement(
						'div',
						{ style: { height: this.props.datas.length * this.props.cellHeight + 70 + 'px' } },
						_react2.default.createElement(_agGridReact.AgGridReact, {
							columnDefs: this.getHeaders(),
							rowData: allTopologiesCopy,
							rowSelection: 'multiple',
							getRowHeight: this.getCellHeight,
							onGridReady: this.onGridReady,
							animateRows: true,
							enableSorting: true,
							enableFilter: true,
							accentedSort: true,
							suppressRowClickSelection: true,
							onSelectionChanged: this.onSelectionChanged.bind(this),
							frameworkComponents: { htmlRenderer: _HtmlRenderer2.default }
						})
					)
				);
			}
		}]);
	
		return AgGridTable;
	}(_ActionComponent3.default);
	
	var _initialiseProps = function _initialiseProps() {
		var _this2 = this;
	
		this.checkRemoveSelected = function (selectedExportSelections) {
			if (!selectedExportSelections.length) {
				if (_this2.gridApi.getSelectedRows().length) {
					_this2.gridApi.deselectAll();
				}
			}
		};
	
		this.getExportActions = function () {
			return {
				fn: function fn() {
					return _this2.exportCsvFunction(_this2.gridApi);
				},
				icon: 'file_download',
				title: _simpleReactI18n2.default.csvExport
			};
		};
	
		this.getExportSelectedSelections = function (props) {
			return {
				fn: function fn() {
					return _AppStore2.default.dispatch(_SelectionAction2.default.exportSelections(props.user.login, props.selectedExportSelections));
				},
				icon: 'file_download',
				title: _simpleReactI18n2.default.download
			};
		};
	
		this.exportCsvFunction = function (agGrid) {
			var params = {
				skipHeader: false,
				columnGroups: false,
				skipFooters: false,
				skipGroups: true,
				skipPinnedTop: false,
				skipPinnedBottom: false,
				allColumns: true,
				onlySelected: false,
				suppressQuotes: false,
				fileName: 'export_researchs_' + (0, _moment2.default)().format('YYYYMMDDhhmmss'),
				columnSeparator: ';'
			};
			params.columnKeys = ['isUpdateData', 'title', 'nbTheme', 'nbWatershed', 'nbStation', 'creationDate', 'updateDate', 'lastExecutionDate', 'favoriteFunction'];
			params.processCellCallback = function (t) {
				if (t.column.getColDef().field === 'favoriteFunction') {
					return !!t.node.data.favorite;
				} else if (t.column.getColDef().parameter === _TypesConstants.DATE) {
					return (0, _DateUtil.getDate)((0, _moment2.default)(t.value));
				}
				return t.value;
			};
			params.processHeaderCallback = function (t) {
				if (t.column.colId === 'isUpdateData') {
					return _simpleReactI18n2.default.dataAvailable;
				} else if (t.column.getColDef().field === 'favoriteFunction') {
					return _simpleReactI18n2.default.favorite;
				}
				return t.column.getColDef().headerName;
			};
			agGrid.exportDataAsCsv(params);
		};
	
		this.getDateDefinition = function (field) {
			return Object.assign({}, field, {
				type: ['dateColumn', 'nonEditableColumn'],
				filter: 'agDateColumnFilter',
				valueFormatter: function valueFormatter(data) {
					return (0, _DateUtil.getDate)(data.value);
				},
				width: 100,
				parameter: _TypesConstants.DATE
			});
		};
	
		this.getNumberDefinition = function (field) {
			return Object.assign({}, field, {
				type: ['numericColumn', 'nonEditableColumn'],
				filter: 'agNumberColumnFilter',
				width: 100,
				parameter: _TypesConstants.NUMBER
			});
		};
	
		this.getTextDefinition = function (field) {
			var withCheckbox = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
			var result = Object.assign({}, field, {
				type: 'nonEditableColumn',
				filter: 'agTextColumnFilter'
			});
			if (withCheckbox) {
				return Object.assign({}, result, {
					cellRenderer: 'agGroupCellRenderer',
					cellRendererParams: { checkbox: true }
				});
			}
			return result;
		};
	
		this.getCellColor = function (field) {
			return Object.assign({}, field, {
				width: 5,
				cellClass: function cellClass(params) {
					return params.value ? ['updateColorBackground', 'padding-right-10', 'padding-left-0'] : ['padding-right-10', 'padding-left-0'];
				},
				cellRenderer: function cellRenderer() {
					return '';
				}
			});
		};
	
		this.getFunctionDefinition = function (field) {
			return Object.assign({}, field, {
				filter: true,
				suppressMenu: true,
				sortable: true,
				suppressCellSelection: true,
				resizable: false,
				enableStatusBar: false,
				suppressPadding: true,
				width: 50,
				maxWidth: 50,
				minWidth: 50,
				cellRenderer: 'htmlRenderer',
				headerName: '',
				cellClass: ['no-padding']
			});
		};
	
		this.getDefaultInitialization = function (header) {
			return {
				field: header,
				headerName: _simpleReactI18n2.default[header],
				cellStyle: function cellStyle() {
					return {
						fontSize: '18px'
					};
				}
			};
		};
	
		this.getHeaders = function () {
			return _this2.props.type.headers.map(function (o) {
				var fieldType = (0, _TypesUtils.getFieldType)(o);
				var field = _this2.getDefaultInitialization(o);
				switch (fieldType) {
					case _TypesConstants.DATE:
						return _this2.getDateDefinition(field);
					case _TypesConstants.NUMBER:
						return _this2.getNumberDefinition(field);
					case _TypesConstants.FUNCTION:
						return _this2.getFunctionDefinition(field);
					case _TypesConstants.BOOLEAN:
						return _this2.getCellColor(field);
					default:
						return _this2.getTextDefinition(field, o === 'title');
				}
			});
		};
	
		this.getCellHeight = function () {
			return _this2.props.cellHeight;
		};
	
		this.onGridReady = function (params) {
			_this2.gridApi = params.api;
			_this2.gridApi.sizeColumnsToFit();
			_this2.gridApi.doLayout();
		};
	
		this.onSelectionChanged = function () {
			_AppStore2.default.dispatch(_SelectionAction2.default.receiveSelectedExportSelection(_this2.gridApi.getSelectedRows()));
		};
	};
	
	AgGridTable.propTypes = {
		user: _propTypes2.default.instanceOf(_DtoUser2.default),
		type: _propTypes2.default.object,
		datas: _propTypes2.default.arrayOf(_propTypes2.default.object),
		cellHeight: _propTypes2.default.number,
		selectedExportSelections: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoSelection2.default))
	};
	AgGridTable.defaultProps = {
		cellHeight: 40,
		datas: []
	};
	var mapStateToProps = function mapStateToProps(store) {
		return {
			user: store.HomeReducer.user,
			selectedExportSelections: store.SelectionReducer.selectedExportSelections
		};
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(AgGridTable);

/***/ },
/* 2102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _uuid = __webpack_require__(44);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HtmlRenderer = function (_Component) {
		_inherits(HtmlRenderer, _Component);
	
		function HtmlRenderer(props) {
			_classCallCheck(this, HtmlRenderer);
	
			return _possibleConstructorReturn(this, (HtmlRenderer.__proto__ || Object.getPrototypeOf(HtmlRenderer)).call(this, props));
		}
	
		_createClass(HtmlRenderer, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ key: _uuid2.default.v4() },
					this.props.value
				);
			}
		}]);
	
		return HtmlRenderer;
	}(_react.Component);
	
	HtmlRenderer.propTypes = {
		value: _propTypes2.default.object
	};
	
	HtmlRenderer.defaultProps = {
		value: ''
	};
	
	exports.default = HtmlRenderer;

/***/ },
/* 2103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDnd = __webpack_require__(218);
	
	var _ItemTypes = __webpack_require__(374);
	
	var _ItemTypes2 = _interopRequireDefault(_ItemTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var style = {
		cursor: 'move'
	};
	
	var Box = function (_Component) {
		_inherits(Box, _Component);
	
		function Box() {
			_classCallCheck(this, Box);
	
			return _possibleConstructorReturn(this, (Box.__proto__ || Object.getPrototypeOf(Box)).apply(this, arguments));
		}
	
		_createClass(Box, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    hideSourceOnDrag = _props.hideSourceOnDrag,
				    left = _props.left,
				    top = _props.top,
				    connectDragSource = _props.connectDragSource,
				    isDragging = _props.isDragging,
				    children = _props.children;
	
				if (isDragging && hideSourceOnDrag) {
					return null;
				}
	
				return connectDragSource(_react2.default.createElement(
					'div',
					{ style: Object.assign({}, style, { left: left, top: top }) },
					children
				));
			}
		}]);
	
		return Box;
	}(_react.Component);
	
	Box.propTypes = {
		connectDragSource: _propTypes2.default.func.isRequired,
		isDragging: _propTypes2.default.bool.isRequired,
		id: _propTypes2.default.any.isRequired,
		left: _propTypes2.default.number.isRequired,
		top: _propTypes2.default.number.isRequired,
		hideSourceOnDrag: _propTypes2.default.bool.isRequired,
		children: _propTypes2.default.node,
		onDrag: _propTypes2.default.func.isRequired
	};
	
	var boxSource = {
		beginDrag: function beginDrag(props) {
			var id = props.id,
			    left = props.left,
			    top = props.top,
			    children = props.children;
	
			return {
				boxes: [{ id: id, left: left, top: top, children: children }]
			};
		},
		endDrag: function endDrag(props) {
			props.onDrag(props.id);
		}
	};
	
	var collect = function collect(connect, monitor) {
		return {
			connectDragSource: connect.dragSource(),
			isDragging: monitor.isDragging()
		};
	};
	
	exports.default = (0, _reactDnd.DragSource)(_ItemTypes2.default.BOX, boxSource, collect)(Box);

/***/ },
/* 2104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDnd = __webpack_require__(218);
	
	var _ItemTypes = __webpack_require__(374);
	
	var _ItemTypes2 = _interopRequireDefault(_ItemTypes);
	
	var _Dustbin = __webpack_require__(2105);
	
	var _Dustbin2 = _interopRequireDefault(_Dustbin);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _AdministrationAction = __webpack_require__(61);
	
	var _AdministrationAction2 = _interopRequireDefault(_AdministrationAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var style = {
		position: 'absolute',
		cursor: 'move',
		zIndex: 7
	};
	
	var BoxDustbin = function (_Component) {
		_inherits(BoxDustbin, _Component);
	
		function BoxDustbin(props) {
			_classCallCheck(this, BoxDustbin);
	
			var _this = _possibleConstructorReturn(this, (BoxDustbin.__proto__ || Object.getPrototypeOf(BoxDustbin)).call(this, props));
	
			var box = { id: props.id, children: props.children, left: props.left, top: props.top };
			_this.state = {
				boxes: [box]
			};
			_this.addBox = _this.addBox.bind(_this);
			_this.removeBox = _this.removeBox.bind(_this);
			return _this;
		}
	
		_createClass(BoxDustbin, [{
			key: 'addBox',
			value: function addBox(box) {
				this.setState(function (prevState) {
					return Object.assign({}, prevState, {
						boxes: prevState.boxes.concat([box])
					});
				});
			}
		}, {
			key: 'removeBox',
			value: function removeBox(id) {
				_AppStore2.default.dispatch(_AdministrationAction2.default.removeLegend(id));
				this.setState(function (prevState) {
					return Object.assign({}, prevState, {
						boxes: prevState.boxes.filter(function (b) {
							return b.id !== id;
						})
					});
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    hideSourceOnDrag = _props.hideSourceOnDrag,
				    left = _props.left,
				    top = _props.top,
				    connectDragSource = _props.connectDragSource,
				    isDragging = _props.isDragging;
	
				if (isDragging && hideSourceOnDrag) {
					return null;
				}
	
				return connectDragSource(_react2.default.createElement(
					'div',
					{ style: Object.assign({}, style, { left: left, top: top }) },
					_react2.default.createElement(_Dustbin2.default, { onAddBox: this.addBox, onRemoveBox: this.removeBox, boxes: this.state.boxes,
						left: left, top: top })
				));
			}
		}]);
	
		return BoxDustbin;
	}(_react.Component);
	
	BoxDustbin.propTypes = {
		connectDragSource: _propTypes2.default.func.isRequired,
		isDragging: _propTypes2.default.bool.isRequired,
		id: _propTypes2.default.any.isRequired,
		left: _propTypes2.default.number.isRequired,
		top: _propTypes2.default.number.isRequired,
		hideSourceOnDrag: _propTypes2.default.bool.isRequired,
		children: _propTypes2.default.node
	};
	
	var boxSource = {
		beginDrag: function beginDrag(props, monitor, component) {
			var boxes = component.state.boxes;
			var id = props.id,
			    left = props.left,
			    top = props.top;
	
			return { id: id, left: left, top: top, boxes: boxes };
		}
	};
	
	var collect = function collect(connect, monitor) {
		return {
			connectDragSource: connect.dragSource(),
			isDragging: monitor.isDragging()
		};
	};
	
	exports.default = (0, _reactDnd.DragSource)(_ItemTypes2.default.DUSTBIN_BOX, boxSource, collect)(BoxDustbin);

/***/ },
/* 2105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDnd = __webpack_require__(218);
	
	var _ItemTypes = __webpack_require__(374);
	
	var _ItemTypes2 = _interopRequireDefault(_ItemTypes);
	
	var _Box = __webpack_require__(2103);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _LegendDto = __webpack_require__(373);
	
	var _LegendDto2 = _interopRequireDefault(_LegendDto);
	
	var _reactRedux = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Dustbin = function (_Component) {
		_inherits(Dustbin, _Component);
	
		function Dustbin(props) {
			_classCallCheck(this, Dustbin);
	
			var _this = _possibleConstructorReturn(this, (Dustbin.__proto__ || Object.getPrototypeOf(Dustbin)).call(this, props));
	
			_this.getButtonStyle = function () {
				return {
					position: 'relative',
					top: 20,
					zIndex: '10'
				};
			};
	
			return _this;
		}
	
		_createClass(Dustbin, [{
			key: 'getBox',
			value: function getBox(box) {
				return _react2.default.createElement(
					_Box2.default,
					{ key: 'box' + box.id, id: box.id, hideSourceOnDrag: true, top: this.props.top,
						left: this.props.left, onDrag: this.props.onRemoveBox },
					box.children
				);
			}
		}, {
			key: 'getContent',
			value: function getContent(boxes) {
				var _this2 = this;
	
				return boxes.map(function (o) {
					return _react2.default.createElement(
						'div',
						{ className: 'no-padding no-margin' },
						_react2.default.createElement(
							'div',
							{ className: 'right-align', style: _this2.getButtonStyle() },
							_react2.default.createElement(
								'i',
								{ className: 'material-icons', style: { color: 'red' },
									onClick: function onClick() {
										return _this2.props.onRemoveBox(o.id);
									} },
								'clear'
							)
						),
						_this2.getBox(o)
					);
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    connectDropTarget = _props.connectDropTarget,
				    boxes = _props.boxes;
	
				if (boxes.length) {
					return connectDropTarget(_react2.default.createElement(
						'div',
						null,
						this.getContent(boxes)
					));
				}
				return null;
			}
		}]);
	
		return Dustbin;
	}(_react.Component);
	
	Dustbin.propTypes = {
		connectDropTarget: _propTypes2.default.func.isRequired,
		isOver: _propTypes2.default.bool.isRequired,
		canDrop: _propTypes2.default.bool.isRequired,
		onAddBox: _propTypes2.default.func.isRequired,
		onRemoveBox: _propTypes2.default.func.isRequired,
		boxes: _propTypes2.default.node.isRequired,
		left: _propTypes2.default.number.isRequired,
		top: _propTypes2.default.number.isRequired,
		legends: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_LegendDto2.default))
	};
	var mapStateToProps = function mapStateToProps(store) {
		return {
			legends: store.AdministrationReducer.legends
		};
	};
	var dustbinTarget = {
		drop: function drop(props, monitor) {
			var boxes = monitor.getItem().boxes;
			if (boxes && boxes.length) {
				boxes.forEach(function (b) {
					return props.onAddBox(b);
				});
			}
			props.onDrop(monitor.getItem());
		}
	};
	
	var collect = function collect(connectDrag, monitor) {
		return {
			connectDropTarget: connectDrag.dropTarget(),
			isOver: monitor.isOver(),
			canDrop: monitor.canDrop()
		};
	};
	var dropTarget = (0, _reactDnd.DropTarget)([_ItemTypes2.default.DUSTBIN_BOX, _ItemTypes2.default.BOX], dustbinTarget, collect)(Dustbin);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(dropTarget);

/***/ },
/* 2106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Snackbar = __webpack_require__(192);
	
	var _Snackbar2 = _interopRequireDefault(_Snackbar);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _lodash = __webpack_require__(15);
	
	var _InformationAction = __webpack_require__(1030);
	
	var _InformationAction2 = _interopRequireDefault(_InformationAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InformationPanel = function (_Component) {
		_inherits(InformationPanel, _Component);
	
		function InformationPanel(props) {
			_classCallCheck(this, InformationPanel);
	
			var _this = _possibleConstructorReturn(this, (InformationPanel.__proto__ || Object.getPrototypeOf(InformationPanel)).call(this, props));
	
			_this.close = function (event, reason) {
				if (reason && reason !== 'clickaway') {
					_this.props.reset();
				}
			};
	
			return _this;
		}
	
		_createClass(InformationPanel, [{
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps) {
				return !(0, _lodash.isEqual)(this.props.message, nextProps.message) || !(0, _lodash.isEqual)(this.props.open, nextProps.open);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_Snackbar2.default, {
						open: this.props.open,
						onClose: this.close,
						autoHideDuration: 4000,
						ContentProps: {
							'aria-describedby': 'information-panel'
						},
						message: _react2.default.createElement(
							'span',
							{ id: 'information-panel' },
							this.props.message
						)
					})
				);
			}
		}]);
	
		return InformationPanel;
	}(_react.Component);
	
	InformationPanel.propTypes = {
		message: _propTypes2.default.string,
		open: _propTypes2.default.bool,
		reset: _propTypes2.default.func
	};
	InformationPanel.defaultProps = {
		message: '',
		open: false
	};
	var mapStateToProps = function mapStateToProps(store) {
		return {
			message: store.InformationReducer.message,
			open: store.InformationReducer.open
		};
	};
	var mapDispatchToProps = {
		reset: _InformationAction2.default.reset
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(InformationPanel);

/***/ },
/* 2107 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.ListStation = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(15);
	
	var _ArrowBack = __webpack_require__(629);
	
	var _ArrowBack2 = _interopRequireDefault(_ArrowBack);
	
	var _ArrowForward = __webpack_require__(630);
	
	var _ArrowForward2 = _interopRequireDefault(_ArrowForward);
	
	var _Fab = __webpack_require__(396);
	
	var _Fab2 = _interopRequireDefault(_Fab);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ListStation = exports.ListStation = function (_Component) {
		_inherits(ListStation, _Component);
	
		function ListStation(props) {
			_classCallCheck(this, ListStation);
	
			var _this = _possibleConstructorReturn(this, (ListStation.__proto__ || Object.getPrototypeOf(ListStation)).call(this, props));
	
			_this.state = { page: 0 };
			return _this;
		}
	
		_createClass(ListStation, [{
			key: "render",
			value: function render() {
				var _this2 = this;
	
				if (this.props.stations.length <= 10) {
					return _react2.default.createElement(
						"div",
						{ className: "collapsible-body no-padding no-margin" },
						this.props.stations
					);
				}
				var groups = (0, _lodash.chunk)(this.props.stations, 10);
				return _react2.default.createElement(
					"div",
					{ className: "collapsible-body no-padding no-margin" },
					groups[this.state.page],
					_react2.default.createElement(
						"div",
						{ style: { display: 'flex', justifyContent: 'space-between' } },
						_react2.default.createElement(_Fab2.default, { style: { margin: '8px' }, children: _react2.default.createElement(_ArrowBack2.default, null), size: "small", disabled: this.state.page === 0, color: "primary", onClick: function onClick() {
								return _this2.setState({ page: _this2.state.page - 1 });
							} }),
						_react2.default.createElement(
							"div",
							null,
							_simpleReactI18n2.default.page + ' ' + (this.state.page + 1) + ' / ' + groups.length
						),
						_react2.default.createElement(_Fab2.default, { style: { margin: '8px' }, children: _react2.default.createElement(_ArrowForward2.default, null), size: "small", disabled: this.state.page >= groups.length - 1, color: "primary", onClick: function onClick() {
								return _this2.setState({ page: _this2.state.page + 1 });
							} })
					)
				);
			}
		}]);
	
		return ListStation;
	}(_react.Component);
	
	ListStation.propTypes = {
		stations: _propTypes2.default.any
	};
	
	ListStation.defaultProps = {
		stations: []
	};

/***/ },
/* 2108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = window.$;
	
	var ConfirmationModal = function (_Component) {
		_inherits(ConfirmationModal, _Component);
	
		function ConfirmationModal(props) {
			_classCallCheck(this, ConfirmationModal);
	
			var _this = _possibleConstructorReturn(this, (ConfirmationModal.__proto__ || Object.getPrototypeOf(ConfirmationModal)).call(this, props));
	
			_this.validate = function () {
				if (_this.props.values) {
					_this.props.store.dispatch(_this.props.actionOnValid(_this.props.values));
				} else {
					_this.props.store.dispatch(_this.props.actionOnValid);
				}
			};
	
			return _this;
		}
	
		_createClass(ConfirmationModal, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				$('.modal-confirmation').modal({
					dismissible: true,
					opacity: 0.7,
					inDuration: 300,
					outDuration: 200,
					startingTop: '4%',
					endingTop: '10%',
					size: 'small'
				});
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ id: this.props.id, className: 'modal-confirmation modal small-modal' },
					_react2.default.createElement(
						'div',
						{ className: 'modal-content' },
						_react2.default.createElement(
							'h4',
							null,
							this.props.title
						),
						_react2.default.createElement(
							'p',
							null,
							this.props.content
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'modal-footer' },
						_react2.default.createElement(
							'a',
							{ className: 'modal-action modal-close btn margin-right-10', onClick: this.validate },
							_simpleReactI18n2.default.validate
						),
						_react2.default.createElement(
							'a',
							{ className: 'modal-action modal-close waves-effect waves-green btn red' },
							_simpleReactI18n2.default.cancel
						)
					)
				);
			}
		}]);
	
		return ConfirmationModal;
	}(_react.Component);
	
	ConfirmationModal.propTypes = {
		id: _propTypes2.default.string.isRequired,
		content: _propTypes2.default.string.isRequired,
		title: _propTypes2.default.string.isRequired,
		store: _propTypes2.default.object,
		actionOnValid: _propTypes2.default.func,
		values: _propTypes2.default.object
	};
	
	ConfirmationModal.defaultProps = {
		id: '',
		content: '',
		title: ''
	};
	
	exports.default = ConfirmationModal;

/***/ },
/* 2109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _DtoUser = __webpack_require__(54);
	
	var _DtoUser2 = _interopRequireDefault(_DtoUser);
	
	var _SelectionAction = __webpack_require__(95);
	
	var _SelectionAction2 = _interopRequireDefault(_SelectionAction);
	
	var _reactRedux = __webpack_require__(18);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _DtoSelectionRow = __webpack_require__(182);
	
	var _DtoSelectionRow2 = _interopRequireDefault(_DtoSelectionRow);
	
	var _Dialog = __webpack_require__(190);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Slide = __webpack_require__(155);
	
	var _Slide2 = _interopRequireDefault(_Slide);
	
	var _DialogActions = __webpack_require__(297);
	
	var _DialogActions2 = _interopRequireDefault(_DialogActions);
	
	var _Button = __webpack_require__(233);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _DialogTitle = __webpack_require__(235);
	
	var _DialogTitle2 = _interopRequireDefault(_DialogTitle);
	
	var _glamor = __webpack_require__(143);
	
	var _ToastrAction = __webpack_require__(66);
	
	var _ToastrAction2 = _interopRequireDefault(_ToastrAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Transition = _react2.default.forwardRef(function Transition(props, ref) {
		return _react2.default.createElement(_Slide2.default, Object.assign({ direction: 'up', ref: ref }, props));
	});
	
	var SelectionDeleteModal = function (_Component) {
		_inherits(SelectionDeleteModal, _Component);
	
		function SelectionDeleteModal(props) {
			_classCallCheck(this, SelectionDeleteModal);
	
			var _this = _possibleConstructorReturn(this, (SelectionDeleteModal.__proto__ || Object.getPrototypeOf(SelectionDeleteModal)).call(this, props));
	
			_this.handleClose = function () {
				_AppStore2.default.dispatch(_SelectionAction2.default.closeModalSelectionDelete());
			};
	
			_this.validate = function () {
				if (_this.props.selectedSelectionInformation.id) {
					_AppStore2.default.dispatch(_SelectionAction2.default.deleteSelection(_this.props.user.login, _this.props.selectedSelectionInformation.id));
				} else {
					_AppStore2.default.dispatch(_ToastrAction2.default.warning(_simpleReactI18n2.default.warning.noSelectionDeletion));
				}
			};
	
			_this.getContent = function () {
				if (_this.props.selectedSelectionInformation && _this.props.modalSelectionDelete) {
					return _react2.default.createElement(
						'div',
						{ className: 'row' },
						_simpleReactI18n2.default.question.deleteSelection
					);
				}
				return null;
			};
	
			_this.getTitle = function () {
				if (_this.props.selectedSelectionInformation && _this.props.modalSelectionDelete) {
					return _react2.default.createElement(
						_DialogTitle2.default,
						{ id: 'alert-dialog-slide-title' },
						_simpleReactI18n2.default.deleteSelection,
						' : ',
						_this.props.selectedSelectionInformation.title
					);
				}
				return null;
			};
	
			return _this;
		}
	
		_createClass(SelectionDeleteModal, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_Dialog2.default,
					{
						maxWidth: 'sm',
						fullWidth: true,
						TransitionComponent: Transition,
						modal: false,
						keepMounted: true,
						open: this.props.modalSelectionDelete,
						onClose: this.handleClose
					},
					this.getTitle(),
					this.getContent(),
					_react2.default.createElement(
						_DialogActions2.default,
						null,
						_react2.default.createElement(
							_Button2.default,
							Object.assign({ onClick: this.handleClose }, (0, _glamor.css)({ backgroundColor: 'red !important', color: 'white !important' })),
							_simpleReactI18n2.default.cancel
						),
						_react2.default.createElement(
							_Button2.default,
							Object.assign({ onClick: this.validate }, (0, _glamor.css)({ backgroundColor: '#53A1FF !important', color: 'white !important' }), { autoFocus: true }),
							_simpleReactI18n2.default.deleteFunction
						)
					)
				);
			}
		}]);
	
		return SelectionDeleteModal;
	}(_react.Component);
	
	SelectionDeleteModal.propTypes = {
		selectedSelectionInformation: _propTypes2.default.instanceOf(_DtoSelectionRow2.default),
		modalSelectionDelete: _propTypes2.default.bool,
		user: _propTypes2.default.instanceOf(_DtoUser2.default)
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			user: store.HomeReducer.user,
			selectedSelectionInformation: store.SelectionReducer.selectedSelectionInformation,
			modalSelectionDelete: store.SelectionReducer.modalSelectionDelete
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(SelectionDeleteModal);

/***/ },
/* 2110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(15);
	
	var _ResearchTypesUtils = __webpack_require__(228);
	
	var _ResearchTypes = __webpack_require__(288);
	
	var _ResearchTypes2 = _interopRequireDefault(_ResearchTypes);
	
	var _StringUtils = __webpack_require__(131);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _DtoFilterType = __webpack_require__(130);
	
	var _DtoFilterType2 = _interopRequireDefault(_DtoFilterType);
	
	var _reactRedux = __webpack_require__(18);
	
	var _DateUtil = __webpack_require__(67);
	
	var _DtoSiteType = __webpack_require__(96);
	
	var _DtoSiteType2 = _interopRequireDefault(_DtoSiteType);
	
	var _ThemeDto = __webpack_require__(129);
	
	var _ThemeDto2 = _interopRequireDefault(_ThemeDto);
	
	var _DtoSelectionDetailSite = __webpack_require__(538);
	
	var _DtoSelectionDetailSite2 = _interopRequireDefault(_DtoSelectionDetailSite);
	
	var _DtoSelectionRow = __webpack_require__(182);
	
	var _DtoSelectionRow2 = _interopRequireDefault(_DtoSelectionRow);
	
	var _SiteTypes = __webpack_require__(56);
	
	var _SiteTypes2 = _interopRequireDefault(_SiteTypes);
	
	var _uuid = __webpack_require__(44);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _core = __webpack_require__(116);
	
	var _DtoCity = __webpack_require__(87);
	
	var _DtoCity2 = _interopRequireDefault(_DtoCity);
	
	var _DtoWatershed = __webpack_require__(183);
	
	var _DtoWatershed2 = _interopRequireDefault(_DtoWatershed);
	
	var _DtoKeyFigures = __webpack_require__(98);
	
	var _DtoKeyFigures2 = _interopRequireDefault(_DtoKeyFigures);
	
	var _NumberUtils = __webpack_require__(151);
	
	var _DtoSelectionExportHistory = __webpack_require__(531);
	
	var _DtoSelectionExportHistory2 = _interopRequireDefault(_DtoSelectionExportHistory);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _basepath = __webpack_require__(180);
	
	var _ApplicationUtil = __webpack_require__(544);
	
	var _ApplicationConstants = __webpack_require__(1053);
	
	var _DtoManagementWater = __webpack_require__(223);
	
	var _DtoManagementWater2 = _interopRequireDefault(_DtoManagementWater);
	
	var _Dialog = __webpack_require__(190);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Slide = __webpack_require__(155);
	
	var _Slide2 = _interopRequireDefault(_Slide);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _SelectionAction = __webpack_require__(95);
	
	var _SelectionAction2 = _interopRequireDefault(_SelectionAction);
	
	var _DialogTitle = __webpack_require__(235);
	
	var _DialogTitle2 = _interopRequireDefault(_DialogTitle);
	
	var _DialogContent = __webpack_require__(577);
	
	var _DialogContent2 = _interopRequireDefault(_DialogContent);
	
	var _Tabs = __webpack_require__(607);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _Typography = __webpack_require__(75);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _ListItemAvatar = __webpack_require__(305);
	
	var _ListItemAvatar2 = _interopRequireDefault(_ListItemAvatar);
	
	var _ListItemText = __webpack_require__(306);
	
	var _ListItemText2 = _interopRequireDefault(_ListItemText);
	
	var _glamor = __webpack_require__(143);
	
	var _ListSubheader = __webpack_require__(588);
	
	var _ListSubheader2 = _interopRequireDefault(_ListSubheader);
	
	var _DtoSimpleStation = __webpack_require__(382);
	
	var _DtoSimpleStation2 = _interopRequireDefault(_DtoSimpleStation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Transition = _react2.default.forwardRef(function Transition(props, ref) {
		return _react2.default.createElement(_Slide2.default, Object.assign({ direction: 'up', ref: ref }, props));
	});
	
	var SelectionInformationModal = function (_Component) {
		_inherits(SelectionInformationModal, _Component);
	
		function SelectionInformationModal(props) {
			_classCallCheck(this, SelectionInformationModal);
	
			var _this = _possibleConstructorReturn(this, (SelectionInformationModal.__proto__ || Object.getPrototypeOf(SelectionInformationModal)).call(this, props));
	
			_this.createInformation = function (title, information) {
				return _react2.default.createElement(
					'div',
					{ key: _uuid2.default.v4(), className: 'row no-margin' },
					_react2.default.createElement(
						'div',
						{ className: 'col s6 no-padding' },
						_react2.default.createElement(
							'b',
							null,
							title,
							' : '
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'col s6 no-padding left-align' },
						information
					)
				);
			};
	
			_this.getFilterType = function (id) {
				return (0, _lodash.find)(_this.props.filterTypes, function (o) {
					return o.id == id;
				});
			};
	
			_this.getItem = function (primaryText, icon, colorRgb) {
				var secondaryText = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	
				return _react2.default.createElement(
					_core.ListItem,
					{ className: 'col s6 no-padding' },
					_react2.default.createElement(
						_ListItemAvatar2.default,
						null,
						_react2.default.createElement(
							_core.Avatar,
							(0, _glamor.css)({ backgroundColor: 'transparent !important' }),
							_react2.default.createElement(
								_core.Icon,
								Object.assign({ className: 'material-icons' }, (0, _glamor.css)({ color: colorRgb })),
								icon
							)
						)
					),
					_react2.default.createElement(_ListItemText2.default, { primary: primaryText, secondary: secondaryText })
				);
			};
	
			_this.getCitiesInformations = function (data) {
				return data.map(function (o) {
					var ref = (0, _lodash.find)(_this.props.cities, function (b) {
						return b.code == o.value;
					});
					if (ref) {
						var primaryText = ref.name + ' [' + ref.code + ']';
						var secondaryText = _simpleReactI18n2.default.zip + ' : ' + ref.postalCode;
						var icon = 'location_city';
						var color = (0, _ResearchTypesUtils.getColorRgb)(_ResearchTypes2.default.CITY, true, '0.6');
						return _this.getItem(primaryText, icon, color, secondaryText);
					}
					return null;
				});
			};
	
			_this.getWatershedInformatons = function (data) {
				return data.map(function (o) {
					var ref = (0, _lodash.find)(_this.props.watersheds, function (b) {
						return b.id == o.value;
					});
					if (ref) {
						var primaryText = ref.name + ' [' + ref.code + ']';
						var icon = 'texture';
						var color = (0, _ResearchTypesUtils.getColorRgb)(_ResearchTypes2.default.WATERSHED, true, '0.6');
						return _this.getItem(primaryText, icon, color);
					}
					return null;
				});
			};
	
			_this.getManagementWaterInformatons = function (data) {
				return data.map(function (o) {
					var ref = (0, _lodash.find)(_this.props.managementWaters, function (b) {
						return b.id == o.value;
					});
					if (ref) {
						var primaryText = ref.name + ' [' + ref.code + ']';
						var icon = 'texture';
						var color = (0, _ResearchTypesUtils.getColorRgb)(_ResearchTypes2.default.MANAGEMENT_WATER, true, '0.6');
						return _this.getItem(primaryText, icon, color);
					}
					return null;
				});
			};
	
			_this.getStationInformatons = function (data) {
				return data.map(function (o) {
					var ref = (0, _lodash.find)(_this.props.stations, function (b) {
						return b.id == o.value;
					});
					if (ref) {
						var primaryText = ref.name + ' [' + ref.code + ']';
						var icon = 'add_location';
						var color = (0, _ResearchTypesUtils.getColorRgb)(_ResearchTypes2.default.STATION, true, '0.6');
						return _this.getItem(primaryText, icon, color);
					}
					return null;
				});
			};
	
			_this.getRadiusInformations = function (data) {
				return data.map(function (o) {
					var jsonObject = JSON.parse(o.value);
					if (jsonObject) {
						var primaryText = Object.keys(jsonObject).map(function (key) {
							return _react2.default.createElement(
								'div',
								{ key: _uuid2.default.v4(), className: 'row no-margin line-height-1' },
								_react2.default.createElement(
									'h6',
									{ className: 'no-margin' },
									_simpleReactI18n2.default[key],
									': ',
									(0, _StringUtils.substringNumber)(jsonObject[key], 2)
								),
								_react2.default.createElement('br', null)
							);
						});
						var icon = 'zoom_in';
						var color = (0, _ResearchTypesUtils.getColorRgb)(_ResearchTypes2.default.RADIUS, true, '0.6');
						return _this.getItem(primaryText, icon, color);
					}
					return null;
				});
			};
	
			_this.getListInformations = function (data, filterType) {
				var resultList = function () {
					switch (filterType.type) {
						case _ResearchTypes2.default.CITY.type:
							return _this.getCitiesInformations(data);
						case _ResearchTypes2.default.RADIUS.type:
							return _this.getRadiusInformations(data);
						case _ResearchTypes2.default.WATERSHED.type:
							return _this.getWatershedInformatons(data);
						case _ResearchTypes2.default.STATION.type:
							return _this.getStationInformatons(data);
						case _ResearchTypes2.default.MANAGEMENT_WATER.type:
							return _this.getManagementWaterInformatons(data);
						default:
							return null;
					}
				}();
				return _react2.default.createElement(
					'div',
					{ key: _uuid2.default.v4(), className: 'col s6 no-padding' },
					_react2.default.createElement(
						_core.List,
						{ className: 'col s12 no-padding', subheader: _react2.default.createElement('li', null) },
						_react2.default.createElement(
							_ListSubheader2.default,
							null,
							_simpleReactI18n2.default[filterType.i18n]
						),
						resultList
					)
				);
			};
	
			_this.getInformations = function (selection) {
				var listOfFilters = selection.filters;
				if (listOfFilters && listOfFilters.length) {
					var reduceFilterTypes = (0, _lodash.reduce)(listOfFilters, function (a, b) {
						if (b.filterTypeId) {
							(a[b.filterTypeId.toString()] || (a[b.filterTypeId.toString()] = [])).push(b);
						}
						return a;
					}, {});
					return Object.keys(reduceFilterTypes).map(function (o) {
						var filterType = _this.getFilterType(o);
						var parameters = (0, _ResearchTypesUtils.getFilterTypeConstant)(filterType.filter);
						if (parameters) {
							return _this.getListInformations(reduceFilterTypes[o], parameters);
						}
						return null;
					});
				}
				return null;
			};
	
			_this.getSum = function (idType, type, reduceKeyFigures) {
				switch (type.type) {
					case _SiteTypes2.default.QUALITOMETER.type:
					case _SiteTypes2.default.QUALITOMETER_SURFACE.type:
						return (0, _NumberUtils.formatNumber)((0, _lodash.sumBy)(reduceKeyFigures[idType], function (o) {
							return o.nbAnalysis;
						}));
					case _SiteTypes2.default.PIEZOMETER.type:
						return (0, _NumberUtils.formatNumber)((0, _lodash.sumBy)(reduceKeyFigures[idType], function (o) {
							return o.nbMeasure;
						}));
					case _SiteTypes2.default.PLUVIOMETER.type:
						return (0, _NumberUtils.formatNumber)((0, _lodash.sumBy)(reduceKeyFigures[idType], function (o) {
							return o.nbMeasure;
						}));
					default:
						return _simpleReactI18n2.default.noData;
				}
			};
	
			_this.getTitleKeyFigures = function (type, totalSum) {
				if (totalSum) {
					switch (type.type) {
						case _SiteTypes2.default.QUALITOMETER.type:
						case _SiteTypes2.default.QUALITOMETER_SURFACE.type:
							return (0, _StringUtils.getPlurialWithNumber)(_simpleReactI18n2.default.numberAnalysis, _simpleReactI18n2.default.numberAnalysis, totalSum) + ': ';
						case _SiteTypes2.default.PIEZOMETER.type:
						case _SiteTypes2.default.PLUVIOMETER.type:
							return (0, _StringUtils.getPlurialWithNumber)(_simpleReactI18n2.default.numberMeasure, _simpleReactI18n2.default.numberMeasure, totalSum) + ': ';
						default:
							return ' ';
					}
				}
				return '';
			};
	
			_this.isUpdate = function (idType, reduceKeyFigures, exportHistory) {
				if (exportHistory.length) {
					return (0, _lodash.filter)(reduceKeyFigures[idType], function (a) {
						return (0, _moment2.default)(a.endDate) >= (0, _moment2.default)(exportHistory[0].beginDate);
					});
				}
				return [];
			};
	
			_this.getStations = function (selection) {
				var stations = selection.stations;
				var exportHistory = selection.exportHistory;
				var reduceStationType = (0, _lodash.reduce)(stations, function (a, b) {
					if (a[b.typeId]) {
						a[b.typeId] = a[b.typeId] + 1;
					} else {
						a[b.typeId] = 1;
					}
					return a;
				}, {});
				var reduceKeyFigures = (0, _lodash.reduce)(selection.keyFigures, function (a, b) {
					(a[b.typeId] || (a[b.typeId] = [])).push(b);
					return a;
				}, {});
				var list = (0, _lodash.orderBy)(Object.keys(reduceStationType).map(function (o) {
					return {
						id: o,
						nbStation: reduceStationType[o]
					};
				}), ['nbStation'], ['desc']);
				return list.map(function (o) {
					var referenceType = _SiteTypes2.default.getType(o.id, _this.props.siteTypes);
					var totalSum = _this.getSum(o.id, referenceType, reduceKeyFigures);
					var isUpdate = _this.isUpdate(o.id, reduceKeyFigures, exportHistory);
					var secondaryTitle = _this.getTitleKeyFigures(referenceType, totalSum);
					var leftAvatar = function () {
						if (isUpdate.length) {
							return _react2.default.createElement(
								_core.Badge,
								{ badgeContent: _react2.default.createElement(
										_core.Icon,
										Object.assign({ className: 'material-icons' }, (0, _glamor.css)({ color: 'vert', fontSize: '30px' })),
										'error_outline'
									) },
								_react2.default.createElement(_core.Avatar, Object.assign({ className: 'MuiAvatar-root_selection_informations' }, (0, _glamor.css)({ backgroundColor: 'transparent !important' }), { src: referenceType.icon }))
							);
						}
						return _react2.default.createElement(_core.Avatar, Object.assign({ className: 'MuiAvatar-root_selection_informations' }, (0, _glamor.css)({ backgroundColor: 'transparent !important' }), { src: referenceType.icon }));
					}();
					return _react2.default.createElement(
						_core.ListItem,
						{ className: 'col s6 no-padding' },
						_react2.default.createElement(
							_ListItemAvatar2.default,
							null,
							leftAvatar
						),
						_react2.default.createElement(_ListItemText2.default, { primary: referenceType.title, secondary: secondaryTitle + '' + totalSum }),
						_react2.default.createElement(
							_ListItemAvatar2.default,
							null,
							_react2.default.createElement(
								_core.Avatar,
								(0, _glamor.css)({ fontSize: '0.9rem !important' }),
								(0, _NumberUtils.formatNumber)(o.nbStation)
							)
						)
					);
				});
			};
	
			_this.getLastExecution = function (exportHistory) {
				if (exportHistory.length) {
					var lastExport = exportHistory[0];
					return _react2.default.createElement(
						'div',
						{ className: 'col s4 no-padding' },
						_this.createInformation(_simpleReactI18n2.default.lastExport, (0, _DateUtil.getDate)(lastExport.beginDate))
					);
				}
				return null;
			};
	
			_this.getExports = function (selection) {
				var exportHistory = selection.exportHistory;
				if (exportHistory.length) {
					return exportHistory.map(function (o) {
						var beginDate = o.beginDate;
						var endDate = o.endDate;
	
						var title = function () {
							if (o.error) {
								return (0, _DateUtil.getDate)(beginDate) + ' : ' + _simpleReactI18n2.default.error.errorDuringExport;
							} else if (o.filename) {
								return (0, _DateUtil.getDate)(beginDate) + ' : ' + o.filename;
							} else if (o.beginDate && !o.terminated) {
								return (0, _DateUtil.getDate)(beginDate) + ' : ' + _simpleReactI18n2.default.exportInProgress;
							}
							return _simpleReactI18n2.default.error.errorDuringExport;
						}();
	
						var executionTime = function () {
							if (beginDate && endDate) {
								var diff = _moment2.default.duration((0, _moment2.default)(endDate).diff((0, _moment2.default)(beginDate)));
								if (diff.isValid()) {
									var nbSeconds = diff.get('second');
									return _simpleReactI18n2.default.executionTime + ' : ' + nbSeconds + ' ' + (0, _StringUtils.getPlurialWithNumber)(_simpleReactI18n2.default.seconde, _simpleReactI18n2.default.secondes, nbSeconds);
								}
								return '';
							}
							return '';
						}();
						var leftAvatar = function () {
							if (o.error) {
								return _react2.default.createElement(
									_core.Avatar,
									(0, _glamor.css)({ backgroundColor: 'transparent !important' }),
									_react2.default.createElement(
										_core.Icon,
										Object.assign({ className: 'material-icons' }, (0, _glamor.css)({ color: 'red', fontSize: '30px' })),
										'error'
									)
								);
							} else if (o.filename) {
								return _react2.default.createElement(
									_core.Avatar,
									(0, _glamor.css)({ backgroundColor: 'transparent !important' }),
									_react2.default.createElement(
										_core.Icon,
										Object.assign({ className: 'material-icons' }, (0, _glamor.css)({ color: 'green', fontSize: '30px' })),
										'done '
									)
								);
							} else if (o.beginDate && !o.terminated) {
								return _react2.default.createElement(
									_core.Avatar,
									(0, _glamor.css)({ backgroundColor: 'transparent !important' }),
									_react2.default.createElement(_core.CircularProgress, null)
								);
							}
							return _react2.default.createElement(
								_core.Avatar,
								(0, _glamor.css)({ backgroundColor: 'none' }),
								_react2.default.createElement(
									_core.Icon,
									Object.assign({ className: 'material-icons' }, (0, _glamor.css)({ color: 'green', fontSize: '30px' })),
									'done '
								)
							);
						}();
	
						var dateDiff = function () {
							if (beginDate) {
								var diffNow = _moment2.default.duration((0, _moment2.default)().diff((0, _moment2.default)(beginDate)));
								if (diffNow.isValid()) {
									return diffNow.get('days');
								}
								return null;
							}
							return null;
						}();
	
						var rightAvatar = function () {
							if (o.error) {
								return null;
							} else if (executionTime && (dateDiff || dateDiff == '0') && dateDiff < 3) {
								return _react2.default.createElement(
									_core.IconButton,
									{ onClick: function onClick() {
											return _ApplicationUtil.ApplicationUtil.sumbitRegister(_ApplicationConstants.CATEGORY_EXPORT, _ApplicationConstants.ACTION_EXPORT, o.filename);
										}, href: _basepath.appPath + 'exports/' + o.filename },
									_react2.default.createElement(
										_core.Icon,
										Object.assign({ className: 'material-icons' }, (0, _glamor.css)({ color: 'blue', fontSize: '30px' })),
										'file_download'
									)
								);
							} else if (o.beginDate && !o.terminated) {
								return null;
							}
							return _react2.default.createElement(_core.Chip, { label: _simpleReactI18n2.default.expiredDownload });
						}();
						return _react2.default.createElement(
							_core.ListItem,
							{ className: 'col s12 no-padding' },
							_react2.default.createElement(
								_ListItemAvatar2.default,
								null,
								leftAvatar
							),
							_react2.default.createElement(_ListItemText2.default, { primary: title, secondary: executionTime }),
							_react2.default.createElement(
								_ListItemAvatar2.default,
								null,
								rightAvatar
							)
						);
					});
				}
				return null;
			};
	
			_this.handleClose = function () {
				_this.setState({ selectedTabs: 0 });
				_AppStore2.default.dispatch(_SelectionAction2.default.closeModalSelectionInformation());
			};
	
			_this.a11yProps = function (index) {
				return {
					id: 'full-width-tab-' + index,
					'aria-controls': 'full-width-tabpanel-' + index
				};
			};
	
			_this.changeTabs = function (event, newValue) {
				_this.setState({
					selectedTabs: newValue
				});
			};
	
			_this.getKeyFigures = function (selection) {
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin' },
					_react2.default.createElement(
						'div',
						{ className: 'col s12 no-padding' },
						_react2.default.createElement(
							'div',
							{ className: 'row no-margin' },
							_react2.default.createElement(
								'div',
								{ className: 'col s3 no-padding' },
								_this.createInformation(_simpleReactI18n2.default.creation, (0, _DateUtil.getDate)(selection.creationDate))
							),
							_react2.default.createElement(
								'div',
								{ className: 'col s3 no-padding' },
								_this.createInformation(_simpleReactI18n2.default.update, (0, _DateUtil.getDate)(selection.updateDate))
							),
							_react2.default.createElement(
								'div',
								{ className: 'col s3 no-padding' },
								_this.createInformation(_simpleReactI18n2.default.lastExecution, (0, _DateUtil.getDate)(selection.lastExecutionDate))
							),
							_react2.default.createElement(
								'div',
								{ className: 'col s3 no-padding' },
								_this.createInformation(_simpleReactI18n2.default.numberExport, selection.exportHistory.length)
							),
							_this.getLastExecution(selection.exportHistory)
						)
					)
				);
			};
	
			_this.getThemes = function (selection) {
				var referencialThemes = (0, _lodash.flatten)(_this.props.themes.map(function (o) {
					return o.themes;
				}));
				var intersectionSelectionThemes = (0, _lodash.intersectionWith)(referencialThemes, selection.themes, function (a, b) {
					return a.id == b.value;
				});
				return intersectionSelectionThemes.map(function (o) {
					var masterThemes = (0, _lodash.find)(_this.props.themes, function (a) {
						return a.id == o.masterTheme;
					});
					return _react2.default.createElement(
						_core.ListItem,
						{ className: 'col s6 no-padding' },
						_react2.default.createElement(
							_ListItemAvatar2.default,
							null,
							_react2.default.createElement(_core.Avatar, { src: o.pic })
						),
						_react2.default.createElement(_ListItemText2.default, { primary: o.title, secondary: masterThemes.title })
					);
				});
			};
	
			_this.createTabContent = function (index, content) {
				return _react2.default.createElement(
					_Typography2.default,
					{
						key: index,
						component: 'div',
						role: 'tabpanel',
						hidden: _this.state.selectedTabs !== index,
						id: 'scrollable-auto-tabpanel-' + index,
						'aria-labelledby': 'scrollable-auto-tab-' + index
					},
					_react2.default.createElement(
						'div',
						{ className: 'row no-margin modalTabInformation' },
						content
					)
				);
			};
	
			_this.getTabContents = function (selection) {
				return _react2.default.createElement(
					'div',
					null,
					_this.createTabContent(0, _this.getThemes(selection)),
					_this.createTabContent(1, _this.getInformations(selection)),
					_this.createTabContent(2, _this.getStations(selection)),
					_this.createTabContent(3, _this.getExports(selection))
				);
			};
	
			_this.getExportTabs = function (exportHistory) {
				if (exportHistory.length) {
					return _react2.default.createElement(_core.Tab, { key: 'header_3', label: (0, _StringUtils.getPlurial)(_simpleReactI18n2.default.export, _simpleReactI18n2.default.exports, exportHistory) + ' (' + exportHistory.length + ')', className: _this.a11yProps(3) });
				}
				return null;
			};
	
			_this.getTabs = function (selection) {
				return _react2.default.createElement(
					_Tabs2.default,
					{
						value: _this.state.selectedTabs,
						onChange: _this.changeTabs,
						indicatorColor: 'primary',
						textColor: 'primary',
						variant: 'fullWidth',
						'aria-label': 'full width tabs example'
					},
					_react2.default.createElement(_core.Tab, { key: 'header_0', label: (0, _StringUtils.getPlurial)(_simpleReactI18n2.default.theme, _simpleReactI18n2.default.themes, selection.themes) + ' (' + selection.nbTheme + ')', className: _this.a11yProps(0) }),
					_react2.default.createElement(_core.Tab, { key: 'header_1', label: (0, _StringUtils.getPlurial)(_simpleReactI18n2.default.filter, _simpleReactI18n2.default.filters, selection.filters) + ' (' + selection.nbFilter + ')', className: _this.a11yProps(1) }),
					_react2.default.createElement(_core.Tab, { key: 'header_2', label: (0, _StringUtils.getPlurial)(_simpleReactI18n2.default.station, _simpleReactI18n2.default.stations, selection.stations) + ' (' + selection.nbStation + ')', className: _this.a11yProps(2) }),
					_this.getExportTabs(selection.exportHistory)
				);
			};
	
			_this.getContent = function () {
				if (_this.props.selectedSelectionInformation && _this.props.modalSelectionInformation) {
					var selection = _this.props.selectedSelectionInformation;
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							_DialogTitle2.default,
							{ id: 'alert-dialog-title' },
							_react2.default.createElement(
								'div',
								{ style: { 'background-image': 'url(\'' + selection.picture + '\')' },
									className: 'col s12 modalHeaderPicture no-padding' },
								_react2.default.createElement(
									'div',
									{ className: 'header-filter' },
									_react2.default.createElement(
										'div',
										{ className: 'row no-margin' },
										_react2.default.createElement(
											'div',
											{ className: 'col s12 header-title center-align', style: { paddingTop: '3rem' } },
											_react2.default.createElement(
												'h3',
												{ className: 'no-margin white-text' },
												selection.title
											)
										)
									),
									_react2.default.createElement(
										'i',
										{ className: 'material-icons white-text clickable font-size-30',
											onClick: function onClick() {
												return _this.close();
											},
											style: { position: 'absolute', right: 0, top: 0 } },
										'close'
									)
								)
							)
						),
						_react2.default.createElement(
							_DialogContent2.default,
							null,
							_this.getKeyFigures(selection),
							_this.getTabs(selection),
							_this.getTabContents(selection)
						)
					);
				}
				return null;
			};
	
			_this.state = {
				selectedTabs: 0
			};
			return _this;
		}
	
		_createClass(SelectionInformationModal, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_Dialog2.default,
					{
						maxWidth: 'lg',
						fullWidth: true,
						TransitionComponent: Transition,
						modal: false,
						keepMounted: true,
						open: this.props.modalSelectionInformation,
						onClose: this.handleClose
					},
					this.getContent()
				);
			}
		}]);
	
		return SelectionInformationModal;
	}(_react.Component);
	
	SelectionInformationModal.propTypes = {
		selectedSelectionInformation: _propTypes2.default.instanceOf(_DtoSelectionRow2.default),
		modalSelectionInformation: _propTypes2.default.bool,
		id: _propTypes2.default.string,
		filterTypes: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoFilterType2.default)),
		selectionDetailsSites: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoSelectionDetailSite2.default)),
		siteTypes: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoSiteType2.default)),
		themes: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_ThemeDto2.default)),
		cities: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoCity2.default)),
		stations: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoSimpleStation2.default)),
		watersheds: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoWatershed2.default)),
		managementWaters: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoManagementWater2.default)),
		selectionKeyFigures: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoKeyFigures2.default)),
		selectionExportsHistory: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoSelectionExportHistory2.default))
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			selectedSelectionInformation: store.SelectionReducer.selectedSelectionInformation,
			modalSelectionInformation: store.SelectionReducer.modalSelectionInformation,
			filterTypes: store.ReferentialReducer.filterTypes,
			siteTypes: store.ReferentialReducer.siteTypes,
			cities: store.ReferentialReducer.cities,
			stations: store.ReferentialReducer.stations,
			watersheds: store.ReferentialReducer.watersheds,
			managementWaters: store.ReferentialReducer.managementWaters,
			selectionDetailsSites: store.SelectionReducer.selectionDetailsSites,
			themes: store.AdministrationReducer.themes,
			selectionKeyFigures: store.SelectionReducer.selectionKeyFigures,
			selectionExportsHistory: store.SelectionReducer.selectionExportsHistory
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(SelectionInformationModal);

/***/ },
/* 2111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _DtoUser = __webpack_require__(54);
	
	var _DtoUser2 = _interopRequireDefault(_DtoUser);
	
	var _ResearchTypesUtils = __webpack_require__(228);
	
	var _DtoFilterType = __webpack_require__(130);
	
	var _DtoFilterType2 = _interopRequireDefault(_DtoFilterType);
	
	var _reactRedux = __webpack_require__(18);
	
	var _DtoStation = __webpack_require__(88);
	
	var _DtoStation2 = _interopRequireDefault(_DtoStation);
	
	var _SelectionAction = __webpack_require__(95);
	
	var _SelectionAction2 = _interopRequireDefault(_SelectionAction);
	
	var _DtoSelectionRow = __webpack_require__(182);
	
	var _DtoSelectionRow2 = _interopRequireDefault(_DtoSelectionRow);
	
	var _DtoUserCredit = __webpack_require__(284);
	
	var _DtoUserCredit2 = _interopRequireDefault(_DtoUserCredit);
	
	var _DtoLayer = __webpack_require__(372);
	
	var _DtoLayer2 = _interopRequireDefault(_DtoLayer);
	
	var _lodash = __webpack_require__(15);
	
	var _Chip = __webpack_require__(234);
	
	var _Chip2 = _interopRequireDefault(_Chip);
	
	var _DialogActions = __webpack_require__(297);
	
	var _DialogActions2 = _interopRequireDefault(_DialogActions);
	
	var _Button = __webpack_require__(233);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _glamor = __webpack_require__(143);
	
	var _Dialog = __webpack_require__(190);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _DialogTitle = __webpack_require__(235);
	
	var _DialogTitle2 = _interopRequireDefault(_DialogTitle);
	
	var _Slide = __webpack_require__(155);
	
	var _Slide2 = _interopRequireDefault(_Slide);
	
	var _ToastrAction = __webpack_require__(66);
	
	var _ToastrAction2 = _interopRequireDefault(_ToastrAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Transition = _react2.default.forwardRef(function Transition(props, ref) {
		return _react2.default.createElement(_Slide2.default, Object.assign({ direction: 'up', ref: ref }, props));
	});
	
	var SelectionSaveModal = function (_Component) {
		_inherits(SelectionSaveModal, _Component);
	
		function SelectionSaveModal(props) {
			_classCallCheck(this, SelectionSaveModal);
	
			var _this = _possibleConstructorReturn(this, (SelectionSaveModal.__proto__ || Object.getPrototypeOf(SelectionSaveModal)).call(this, props));
	
			_this.validate = function () {
				var title = _this.refs.titleSelection.value;
				var finalWaterShed = function () {
					return (0, _lodash.intersectionWith)(_this.props.watershedSelected, (0, _lodash.filter)(_this.props.watershedLayers, function (o) {
						return o.visibility;
					}), function (a, b) {
						return a.id == b.id;
					});
				}();
				if (!title) {
					_AppStore2.default.dispatch(_ToastrAction2.default.warning(_simpleReactI18n2.default.warning.pleaseTitleInform));
				} else if (!_this.props.selectedStations.length) {
					_AppStore2.default.dispatch(_ToastrAction2.default.warning(_simpleReactI18n2.default.warning.pleaseSiteSelection));
				} else {
					var filtersResearch = _this.props.selectedFilters.map(function (o) {
						return (0, _ResearchTypesUtils.createDtoFilter)(_this.props.filterTypes, o);
					});
					var filtersTheme = _this.props.selectedThemes.map(function (o) {
						return (0, _ResearchTypesUtils.createDtoFilterTheme)(_this.props.filterTypes, o);
					});
					var filters = [].concat(filtersResearch, filtersTheme);
					if (_this.props.selectedSelection) {
						_AppStore2.default.dispatch(_SelectionAction2.default.updateSelection(_this.props.selectedSelection.id, _this.props.user.login, title, filters, _this.props.selectedStations, finalWaterShed));
					} else {
						_AppStore2.default.dispatch(_SelectionAction2.default.saveSelection(_this.props.user.login, title, filters, _this.props.selectedStations, finalWaterShed));
					}
					_AppStore2.default.dispatch(_SelectionAction2.default.closeModalSelectionSave());
				}
			};
	
			_this.creditAccount = function () {
				_AppStore2.default.dispatch(_ToastrAction2.default.warning(_simpleReactI18n2.default.warning.pleaseRecreditAccount));
			};
	
			_this.getInput = function () {
				if (_this.props.selectedSelection) {
					return _react2.default.createElement('input', { id: 'titleSelection', type: 'text', ref: 'titleSelection',
						placeholder: _simpleReactI18n2.default.saveSelectionPlaceholder,
						defaultValue: _this.props.selectedSelection.title });
				}
				return _react2.default.createElement('input', { id: 'titleSelection', type: 'text', ref: 'titleSelection', placeholder: _simpleReactI18n2.default.saveSelectionPlaceholder,
					required: true });
			};
	
			_this.getCredit = function (totalCredit, isAvailable) {
				var creditTitle = function () {
					if (totalCredit > 1) {
						return _simpleReactI18n2.default.simplePlurialCredit;
					}
					return _simpleReactI18n2.default.simpleCredit;
				}();
	
				var titleTotalCredit = _react2.default.createElement(
					'span',
					null,
					_simpleReactI18n2.default.selectionCost,
					' : ',
					totalCredit,
					' ',
					creditTitle
				);
				var insufficientCredit = function () {
					if (!isAvailable) {
						return _react2.default.createElement(
							_Chip2.default,
							null,
							_simpleReactI18n2.default.insufficientCreditExport
						);
					}
					return null;
				}();
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin' },
					_react2.default.createElement(
						'div',
						{ className: 'col s8 no-padding' },
						titleTotalCredit
					),
					_react2.default.createElement(
						'div',
						{ className: 'col s2 no-padding' },
						insufficientCredit
					)
				);
			};
	
			_this.getTitle = function () {
				if (_this.props.modalSelectionSave) {
					return _react2.default.createElement(
						_DialogTitle2.default,
						{ id: 'alert-dialog-slide-title' },
						_simpleReactI18n2.default.saveTheSelection
					);
				}
				return null;
			};
	
			_this.getContent = function () {
				if (_this.props.modalSelectionSave) {
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ className: 'row no-margin' },
							_react2.default.createElement(
								'div',
								{ className: 'col l12 no-padding' },
								_react2.default.createElement(
									'div',
									{ className: 'input-field col s12' },
									_this.getInput()
								)
							)
						)
					);
				}
				return null;
			};
	
			_this.handleClose = function () {
				_AppStore2.default.dispatch(_SelectionAction2.default.closeModalSelectionSave());
			};
	
			_this.getDialogAction = function () {
				if (_this.props.modalSelectionSave) {
					return _react2.default.createElement(
						_DialogActions2.default,
						null,
						_react2.default.createElement(
							_Button2.default,
							Object.assign({ onClick: _this.handleClose }, (0, _glamor.css)({ backgroundColor: 'red !important', color: 'white !important' })),
							_simpleReactI18n2.default.cancel
						),
						_react2.default.createElement(
							_Button2.default,
							Object.assign({ onClick: _this.validate }, (0, _glamor.css)({ backgroundColor: '#53A1FF !important', color: 'white !important' }), { autoFocus: true }),
							_simpleReactI18n2.default.save
						)
					);
				}
				return null;
			};
	
			return _this;
		}
	
		_createClass(SelectionSaveModal, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_Dialog2.default,
					{
						maxWidth: 'sm',
						fullWidth: true,
						TransitionComponent: Transition,
						modal: false,
						keepMounted: true,
						open: this.props.modalSelectionSave,
						onClose: this.handleClose
					},
					this.getTitle(),
					this.getContent(),
					this.getDialogAction()
				);
			}
		}]);
	
		return SelectionSaveModal;
	}(_react.Component);
	
	SelectionSaveModal.propTypes = {
		user: _propTypes2.default.objectOf(_DtoUser2.default),
		selectedFilters: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			label: _propTypes2.default.string,
			value: _propTypes2.default.object
		})),
		selectedThemes: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			label: _propTypes2.default.string,
			value: _propTypes2.default.object
		})),
		filterTypes: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoFilterType2.default)),
		selectedStations: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoStation2.default)),
		selectedSelection: _propTypes2.default.instanceOf(_DtoSelectionRow2.default),
		watershedSelected: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoStation2.default)),
		watershedLayers: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoLayer2.default)),
		userCredit: _propTypes2.default.instanceOf(_DtoUserCredit2.default),
		modalSelectionSave: _propTypes2.default.bool
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			user: store.HomeReducer.user,
			selectedFilters: store.AdministrationReducer.selectedFilters,
			selectedThemes: store.AdministrationReducer.selectedThemes,
			filterTypes: store.ReferentialReducer.filterTypes,
			selectedStations: store.SitesReducer.selectedStations,
			selectedSelection: store.SelectionReducer.selectedSelection,
			modalSelectionSave: store.SelectionReducer.modalSelectionSave,
			watershedSelected: store.SitesReducer.watershedSelected,
			watershedLayers: store.SitesReducer.watershedLayers,
			userCredit: store.CreditReducer.userCredit
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(SelectionSaveModal);

/***/ },
/* 2112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = window.$;
	
	var TabsSideBar = function (_Component) {
		_inherits(TabsSideBar, _Component);
	
		function TabsSideBar(props) {
			_classCallCheck(this, TabsSideBar);
	
			var _this = _possibleConstructorReturn(this, (TabsSideBar.__proto__ || Object.getPrototypeOf(TabsSideBar)).call(this, props));
	
			_this.state = {
				haveClick: false,
				defaultActive: true
			};
			return _this;
		}
	
		_createClass(TabsSideBar, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this2 = this;
	
				var sideComponent = $('.side-component');
				$('.side-tabs > ul').tabs();
				if (!this.state.defaultActive) {
					$('.side-tabs .tab > a').removeClass('active');
				}
				$('.close').click(function () {
					sideComponent.removeClass('open');
					_this2.setState({ haveClick: true });
				});
				$('.side-tabs .tab > a').click(function (e) {
					if (sideComponent.hasClass('open') && $(e.currentTarget).hasClass('active')) {
						sideComponent.removeClass('open');
					} else {
						sideComponent.addClass('open');
					}
					_this2.setState({ haveClick: true, defaultActive: false });
				});
				this.setHeight();
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				this.setHeight();
				var sideComponent = $('.side-component');
				if (this.props.isOpen && !this.state.haveClick) {
					sideComponent.addClass('open');
				}
			}
		}, {
			key: 'setHeight',
			value: function setHeight() {
				var ribbonTop = ($('.ribbon').offset() || $('body').offset()).top;
				var top = ribbonTop > 63 ? ribbonTop : 63;
				var height = document.body.clientHeight - top;
				$('.side-component').css({ 'height': height + 'px', 'top': top + 'px' });
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var tabs = this.props.tabs.map(function (t, i) {
					var className = function () {
						if (t.defaultActive && _this3.state.defaultActive) {
							return 'active';
						}
						return '';
					}();
					return _react2.default.createElement(
						'li',
						{ key: i, className: 'tab tooltipped', 'data-position': 'bottom', 'data-tooltip': t.title || '' },
						_react2.default.createElement(
							'a',
							{ href: '#sidetab' + i, className: className },
							_react2.default.createElement(
								'i',
								{ className: 'material-icons' },
								t.icon
							)
						)
					);
				});
				var tabsContent = this.props.tabs.map(function (t, i) {
					return _react2.default.createElement(
						'div',
						{ key: i, id: 'sidetab' + i },
						_react2.default.createElement(
							'h5',
							null,
							_react2.default.createElement(
								'b',
								null,
								t.title
							)
						),
						t.content
					);
				});
				return _react2.default.createElement(
					'div',
					{ className: 'side-component' },
					_react2.default.createElement(
						'div',
						{ className: 'side-tabs' },
						_react2.default.createElement(
							'ul',
							null,
							tabs
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'content side-content' },
						tabsContent
					)
				);
			}
		}]);
	
		return TabsSideBar;
	}(_react.Component);
	
	TabsSideBar.propTypes = {
		tabs: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			icon: _propTypes2.default.string,
			title: _propTypes2.default.string,
			content: _propTypes2.default.element,
			defaultActive: _propTypes2.default.boolean
		})),
		isOpen: _propTypes2.default.boolean
	};
	
	TabsSideBar.defaultProps = {
		tabs: [],
		isOpen: false
	};
	
	exports.default = TabsSideBar;

/***/ },
/* 2113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _uuid = __webpack_require__(44);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _reactRouterRedux = __webpack_require__(43);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SwitchPanel = function (_Component) {
		_inherits(SwitchPanel, _Component);
	
		function SwitchPanel(props) {
			_classCallCheck(this, SwitchPanel);
	
			var _this = _possibleConstructorReturn(this, (SwitchPanel.__proto__ || Object.getPrototypeOf(SwitchPanel)).call(this, props));
	
			_this.state = {
				checked: props.checked
			};
			_this.toggleCheck = _this.toggleCheck.bind(_this);
			_this.onClick = _this.onClick.bind(_this);
			return _this;
		}
	
		_createClass(SwitchPanel, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.checked !== this.state.checked) {
					this.setState({
						checked: nextProps.checked
					});
				}
			}
		}, {
			key: 'toggleCheck',
			value: function toggleCheck() {
				this.props.onToggleCheck();
				this.setState({
					checked: !this.state.checked
				});
			}
		}, {
			key: 'onClick',
			value: function onClick() {
				if (this.props.link) {
					_AppStore2.default.dispatch((0, _reactRouterRedux.push)('/' + this.props.link));
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var id = _uuid2.default.v4();
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin' },
					_react2.default.createElement(
						'div',
						{ className: 'col s12' },
						_react2.default.createElement(
							'div',
							{ className: 'row no-margin valign-wrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'col s1 no-padding ' },
								_react2.default.createElement(
									'div',
									{ className: 'switch' },
									_react2.default.createElement(
										'label',
										{ htmlFor: id },
										_react2.default.createElement('input', { checked: this.state.checked, onChange: this.toggleCheck, type: 'checkbox',
											id: id }),
										_react2.default.createElement('span', { className: 'lever' })
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'col s11 padding-left-20', onClick: this.onClick },
								this.props.children
							)
						)
					)
				);
			}
		}]);
	
		return SwitchPanel;
	}(_react.Component);
	
	SwitchPanel.propTypes = {
		onToggleCheck: _propTypes2.default.func,
		children: _propTypes2.default.element,
		checked: _propTypes2.default.bool,
		link: _propTypes2.default.string
	};
	
	SwitchPanel.defaultProps = {
		onToggleCheck: function onToggleCheck() {},
		children: '',
		checked: true,
		link: ''
	};
	
	exports.default = SwitchPanel;

/***/ },
/* 2114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = window.$;
	
	var Select = function (_Component) {
		_inherits(Select, _Component);
	
		function Select() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, Select);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Select.__proto__ || Object.getPrototypeOf(Select)).call.apply(_ref, [this].concat(args))), _this), _this.getOptions = function () {
				return _this.props.values.map(function (o) {
					var attr = function () {
						if (o.selected) {
							return { 'selected': 'selected' };
						}
						return {};
					}();
					return _react2.default.createElement(
						'option',
						Object.assign({ value: o.id ? o.id : o.label }, attr),
						' ',
						o.label,
						' '
					);
				});
			}, _this.initialiseWidgets = function () {
				var self = _this;
				$('select').on('change', function () {
					self.props.change($(this).val());
				}).material_select();
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(Select, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.initialiseWidgets();
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				this.initialiseWidgets();
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.props.disabled) {
					return _react2.default.createElement(
						'div',
						{ className: 'input-field col s12' },
						_react2.default.createElement(
							'select',
							{ disabled: true },
							this.getOptions()
						)
					);
				}
				return _react2.default.createElement(
					'div',
					{ className: 'input-field col s12' },
					_react2.default.createElement(
						'select',
						null,
						this.getOptions()
					)
				);
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				$('select').material_select('destroy');
			}
		}]);
	
		return Select;
	}(_react.Component);
	
	Select.propTypes = {
		values: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			label: _propTypes2.default.string,
			selected: _propTypes2.default.bool
		})),
		title: _propTypes2.default.string,
		change: _propTypes2.default.function,
		disabled: _propTypes2.default.bool
	};
	Select.defaultProps = {
		values: [{
			label: '',
			selected: false
		}],
		title: '',
		change: '',
		disabled: false
	};
	
	exports.default = Select;

/***/ },
/* 2115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Snackbar = __webpack_require__(192);
	
	var _Snackbar2 = _interopRequireDefault(_Snackbar);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _ToastrAction = __webpack_require__(66);
	
	var _ToastrAction2 = _interopRequireDefault(_ToastrAction);
	
	var _lodash = __webpack_require__(15);
	
	var _ToastrConstants = __webpack_require__(377);
	
	var _SnackbarContent = __webpack_require__(404);
	
	var _SnackbarContent2 = _interopRequireDefault(_SnackbarContent);
	
	var _Icon = __webpack_require__(300);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ToastrPanel = function (_Component) {
		_inherits(ToastrPanel, _Component);
	
		function ToastrPanel(props) {
			_classCallCheck(this, ToastrPanel);
	
			var _this = _possibleConstructorReturn(this, (ToastrPanel.__proto__ || Object.getPrototypeOf(ToastrPanel)).call(this, props));
	
			_this.close = function (event, reason) {
				if (reason && reason !== 'clickaway') {
					_this.props.reset();
				}
			};
	
			_this.getIcon = function () {
				switch (_this.props.messageType) {
					case _ToastrConstants.ERROR:
						{
							return 'error';
						}
					case _ToastrConstants.INFO:
						{
							return 'info';
						}
					case _ToastrConstants.SUCCESS:
						{
							return 'error';
						}
					case _ToastrConstants.WARNING:
						{
							return 'error';
						}
					default:
						return 'error';
				}
			};
	
			_this.getStyle = function () {
				switch (_this.props.messageType) {
					case _ToastrConstants.ERROR:
						{
							return {
								backgroundColor: 'red'
							};
						}
					case _ToastrConstants.INFO:
						{
							return {
								backgroundColor: 'blue'
							};
						}
					case _ToastrConstants.SUCCESS:
						{
							return {
								backgroundColor: 'green'
							};
						}
					case _ToastrConstants.WARNING:
						{
							return {
								backgroundColor: 'orange'
							};
						}
					default:
						{
							return {
								backgroundColor: 'blue'
							};
						}
				}
			};
	
			_this.getContent = function () {
				return _react2.default.createElement(_SnackbarContent2.default, {
					style: _this.getStyle(),
					'aria-describedby': 'client-snackbar',
					message: _react2.default.createElement(
						'span',
						{ id: 'client-snackbar', style: {
								display: 'flex',
								alignItems: 'center'
							} },
						_react2.default.createElement(
							_Icon2.default,
							{ className: 'material-icons' },
							_this.getIcon()
						),
						_this.props.message
					)
				});
			};
	
			return _this;
		}
	
		_createClass(ToastrPanel, [{
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps) {
				return !(0, _lodash.isEqual)(this.props.messageType, nextProps.messageType) || !(0, _lodash.isEqual)(this.props.message, nextProps.message) || !(0, _lodash.isEqual)(this.props.open, nextProps.open);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_Snackbar2.default,
					{
						anchorOrigin: {
							vertical: 'top',
							horizontal: 'right'
						},
						open: this.props.open,
						autoHideDuration: 4000,
						onClose: this.close,
						ContentProps: {
							'aria-describedby': 'message-id'
						}
					},
					this.getContent()
				);
			}
		}]);
	
		return ToastrPanel;
	}(_react.Component);
	
	ToastrPanel.propTypes = {
		messageType: _propTypes2.default.string,
		message: _propTypes2.default.string,
		open: _propTypes2.default.bool,
		reset: _propTypes2.default.func
	};
	ToastrPanel.defaultProps = {
		messageType: '',
		message: '',
		open: false
	};
	var mapStateToProps = function mapStateToProps(store) {
		return {
			messageType: store.ToastrReducer.messageType,
			message: store.ToastrReducer.message,
			open: store.ToastrReducer.open
		};
	};
	var mapDispatchToProps = {
		reset: _ToastrAction2.default.reset
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ToastrPanel);

/***/ },
/* 2116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _DashboardConstants = __webpack_require__(1024);
	
	var _HomeConstants = __webpack_require__(53);
	
	var _isomorphicFetch = __webpack_require__(78);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _ActionUtils = __webpack_require__(112);
	
	var _downloadjs = __webpack_require__(692);
	
	var _downloadjs2 = _interopRequireDefault(_downloadjs);
	
	var _lodash = __webpack_require__(15);
	
	var _reactAquasys = __webpack_require__(49);
	
	var _reactRouterRedux = __webpack_require__(43);
	
	var _SiteTypes = __webpack_require__(56);
	
	var _SiteTypes2 = _interopRequireDefault(_SiteTypes);
	
	var _ApplicationConf = __webpack_require__(65);
	
	var _ApplicationConf2 = _interopRequireDefault(_ApplicationConf);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _ToastrAction = __webpack_require__(66);
	
	var _ToastrAction2 = _interopRequireDefault(_ToastrAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DashboardAction = {
	
		errorOnFetch: function errorOnFetch(content) {
			return {
				type: _HomeConstants.TOASTR_ERROR,
				message: content
			};
		},
	
		receivePiezometer: function receivePiezometer(piezometers) {
			return {
				type: _DashboardConstants.RECEIVE_PIEZOMETER,
				piezometers: piezometers
			};
		},
		fetchPiezometer: function fetchPiezometer(login) {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.site.getSiteOfType(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: (0, _ActionUtils.getBody)(login, _SiteTypes2.default.PIEZOMETER.type)
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(DashboardAction.receivePiezometer(json));
					return json;
				}).then(function (jsonResult) {
					var allPiezometer = jsonResult.map(function (result) {
						return DashboardAction.fetchPiezoKeyFigure(result.idstation);
					});
					Promise.all(allPiezometer).then(function (values) {
						var piezometerMeasure = (0, _lodash.flatten)(values);
						dispatch(DashboardAction.receivePiezometerKeyFigure(piezometerMeasure));
					});
					return jsonResult;
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
		receiveQualitometer: function receiveQualitometer(qualitometers) {
			return {
				type: _DashboardConstants.RECEIVE_QUALITOMETER,
				qualitometers: qualitometers
			};
		},
		fetchQualitometer: function fetchQualitometer(login) {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.site.getSiteOfType(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: (0, _ActionUtils.getBody)(login, _SiteTypes2.default.QUALITOMETER.type)
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(DashboardAction.receiveQualitometer(json));
					return json;
				}).then(function (jsonResult) {
					var result = jsonResult.map(function (o) {
						return DashboardAction.fetchQualitometerKeyFigure(o.idstation);
					});
					Promise.all(result).then(function (values) {
						var pickupOperations = (0, _lodash.flatten)(values);
						dispatch(DashboardAction.receiveQualitometerKeyFigure(pickupOperations));
					});
					var allPiezometer = jsonResult.map(function (x) {
						return DashboardAction.fetchPiezoKeyFigure(x.idstation);
					});
					Promise.all(allPiezometer).then(function (values) {
						var piezometerMeasure = (0, _lodash.flatten)(values);
						dispatch(DashboardAction.receivePiezometerKeyFigure(piezometerMeasure));
					});
					return jsonResult;
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
		receiveSurfaceQualitometer: function receiveSurfaceQualitometer(qualitometers) {
			return {
				type: _DashboardConstants.RECEIVE_SURFACE_QUALITOMETER,
				qualitometersSurface: qualitometers
			};
		},
		fetchSurfaceQualitometer: function fetchSurfaceQualitometer(login) {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.site.getSiteOfType(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: (0, _ActionUtils.getBody)(login, _SiteTypes2.default.QUALITOMETER_SURFACE.type)
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(DashboardAction.receiveSurfaceQualitometer(json));
					return json;
				}).then(function (jsonResult) {
					var result = jsonResult.map(function (o) {
						return DashboardAction.fetchQualitometerKeyFigure(o.idstation);
					});
					Promise.all(result).then(function (values) {
						var pickupOperations = (0, _lodash.flatten)(values);
						dispatch(DashboardAction.receiveQualitometerKeyFigure(pickupOperations));
					});
					return jsonResult;
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
		receivePiezometerMeasure: function receivePiezometerMeasure(measures) {
			return {
				type: _DashboardConstants.ADD_PIEZOMETER_MEASURE,
				piezometerMeasures: measures
			};
		},
		fetchPiezoMeasures: function fetchPiezoMeasures(piezometerId) {
			return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.piezo.getPiezometerMeasure(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					piezometerid: piezometerId
				})
			}).then(function (response) {
				return (0, _ActionUtils.checkStatus)({
					200: function _(rep) {
						return rep.json();
					},
					204: function _() {
						return [];
					}
				}, response);
			}).then(function () {
				var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
				if (!json.error) {
					return json;
				}
				return [];
			});
		},
	
		receiveQualitometerKeyFigure: function receiveQualitometerKeyFigure(keyfigures) {
			return {
				type: _DashboardConstants.ADD_QUALITOMETER_KEY_FIGURE,
				qualitometerKeyFigures: keyfigures
			};
		},
		fetchQualitometerKeyFigure: function fetchQualitometerKeyFigure(qualitometerId) {
			return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.qualito.getQualitometerKeyFigure(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					idstation: qualitometerId
				})
			}).then(function (response) {
				return (0, _ActionUtils.checkStatus)({
					200: function _(rep) {
						return rep.json();
					},
					204: function _() {
						return [];
					}
				}, response);
			}).then(function () {
				var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
				if (!json.error) {
					return json;
				}
				return [];
			});
		},
		receivePiezometerKeyFigure: function receivePiezometerKeyFigure(keyfigures) {
			return {
				type: _DashboardConstants.ADD_PIEZOMETER_KEY_FIGURE,
				piezometerKeyFigures: keyfigures
			};
		},
		fetchPiezoKeyFigure: function fetchPiezoKeyFigure(piezometerId) {
			return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.piezo.getPiezometerKeyFigure(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					idstation: piezometerId
				})
			}).then(function (response) {
				return (0, _ActionUtils.checkStatus)({
					200: function _(rep) {
						return rep.json();
					},
					204: function _() {
						return [];
					}
				}, response);
			}).then(function () {
				var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
				if (!json.error) {
					return json;
				}
				return [];
			});
		},
	
		receivePickupOperations: function receivePickupOperations(operations) {
			return {
				type: _DashboardConstants.ADD_PICKUP_OPERATION,
				pickupoperations: operations
			};
		},
		fetchPickupOperation: function fetchPickupOperation(qualitometerId) {
			return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.qualito.getPickupOperation(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					idstation: qualitometerId
				})
			}).then(function (response) {
				return (0, _ActionUtils.checkStatus)({
					200: function _(rep) {
						return rep.json();
					},
					204: function _() {
						return [];
					}
				}, response);
			}).then(function () {
				var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
				if (!json.error) {
					return json;
				}
				return [];
			});
		},
		receiveAnalysis: function receiveAnalysis(analysis) {
			return {
				type: _DashboardConstants.ADD_QUALITOMETER_ANALYSIS,
				analysis: analysis
			};
		},
		fetchAnalysis: function fetchAnalysis(operationId) {
			return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.qualito.getAnalysis(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					idoperation: operationId
				})
			}).then(function (response) {
				return (0, _ActionUtils.checkStatus)({
					200: function _(rep) {
						return rep.json();
					},
					204: function _() {
						return [];
					}
				}, response);
			}).then(function () {
				var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
				if (!json.error) {
					return json;
				}
				return [];
			});
		},
	
		receivePollutedSoil: function receivePollutedSoil(pollutedSoil) {
			return {
				type: _DashboardConstants.RECEIVE_POLLUTED_SOIL,
				pollutedSoil: pollutedSoil
			};
		},
	
		fetchPollutedSoil: function fetchPollutedSoil(login) {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.site.getSiteOfType(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: (0, _ActionUtils.getBody)(login, _SiteTypes2.default.POLLUTED_SOIL.type)
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(DashboardAction.receivePollutedSoil(json));
					return json;
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
		receiveIndustrialSites: function receiveIndustrialSites(industrialSites) {
			return {
				type: _DashboardConstants.RECEIVE_INDUSTRIAL_SITE,
				industrialSites: industrialSites
			};
		},
	
		fetchIndustrialSites: function fetchIndustrialSites(login) {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.site.getSiteOfType(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: (0, _ActionUtils.getBody)(login, _SiteTypes2.default.INDUSTRIAL_SITE.type)
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(DashboardAction.receiveIndustrialSites(json));
					return json;
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
	
		deleteSites: function deleteSites(ids) {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.sites.addOrRemoveSites(), {
					method: 'DELETE',
					headers: { authorization: btoa('Basic ' + atob(sessionStorage.getItem('TOKEN'))) },
					body: JSON.stringify({ sites: ids })
				}).then(function () {
					dispatch(DashboardAction.resetStation());
				}).then(function () {
					dispatch(DashboardAction.fetchUserStation());
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				}).then(function () {
					dispatch(_ToastrAction2.default.success(_simpleReactI18n2.default.multi.your + ' ' + ids.length + ' ' + _simpleReactI18n2.default.deletedSites));
				}).then(function () {
					dispatch((0, _reactRouterRedux.push)(_HomeConstants.PATH_HOME));
				}).catch(function (err) {
					dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.cannotDeleteSite + err));
				});
			};
		},
	
		resetStation: function resetStation() {
			return {
				type: _DashboardConstants.RESET_USER_STATION
			};
		},
	
		fetchUserStation: function fetchUserStation() {
			var login = atob(sessionStorage.getItem('TOKEN'));
			return function (dispatch) {
				dispatch(DashboardAction.fetchPiezometer(login));
				dispatch(DashboardAction.fetchQualitometer(login));
				dispatch(DashboardAction.fetchSurfaceQualitometer(login));
				dispatch(DashboardAction.fetchPollutedSoil(login));
				dispatch(DashboardAction.fetchIndustrialSites(login));
			};
		},
	
		exportStations: function exportStations() {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.station.export(), {
					method: 'GET',
					headers: { authorization: btoa('Basic ' + atob(sessionStorage.getItem('TOKEN'))) }
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.blob();
						}
					}, response);
				}).then(function (blob) {
					(0, _downloadjs2.default)(blob, 'stations.zip', blob.type);
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				}).catch(function (err) {
					dispatch(DashboardAction.errorOnFetch(err));
				});
			};
		}
	};
	
	exports.default = DashboardAction;

/***/ },
/* 2117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _DtoUser = __webpack_require__(54);
	
	var _DtoUser2 = _interopRequireDefault(_DtoUser);
	
	var _HomeAction = __webpack_require__(52);
	
	var _HomeAction2 = _interopRequireDefault(_HomeAction);
	
	var _HomeConstants = __webpack_require__(53);
	
	var _basepath = __webpack_require__(180);
	
	var _reactGa = __webpack_require__(369);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _ResearchPanel = __webpack_require__(2119);
	
	var _ResearchPanel2 = _interopRequireDefault(_ResearchPanel);
	
	var _reactRouterRedux = __webpack_require__(43);
	
	var _lodash = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DashboardApp = function (_Component) {
		_inherits(DashboardApp, _Component);
	
		function DashboardApp(props) {
			_classCallCheck(this, DashboardApp);
	
			var _this = _possibleConstructorReturn(this, (DashboardApp.__proto__ || Object.getPrototypeOf(DashboardApp)).call(this, props));
	
			_initialiseProps.call(_this);
	
			_this.state = {
				panel: 'stations',
				error: ''
			};
			return _this;
		}
	
		_createClass(DashboardApp, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.putTitle();
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (!(0, _lodash.isEqual)(nextProps.isLogged, this.props.isLogged)) {
					this.putTitle(nextProps);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				_reactGa2.default.set({ userId: this.props.user.login });
				var style = {
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					minHeight: 'calc(100vh - 64px)',
					fontFamily: ['Myriad Pro', 'sans-serif']
				};
				return _react2.default.createElement(
					'div',
					{ className: 'aqua-db-bg', style: style },
					_react2.default.createElement(
						'div',
						{ className: 'col s12' },
						_react2.default.createElement(
							'div',
							{ className: 'row', style: { marginBottom: '0', marginTop: '30px' } },
							_react2.default.createElement(
								'div',
								{ className: 'col s2 offset-s2 padding-right-20', style: { width: '15%' } },
								_react2.default.createElement('img', { style: { height: '100px', width: 'auto' }, src: _basepath.aquasysPath + '/wp-content/uploads/2022/07/logo aQuaDB Def_Plan de travail 1.png' })
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'row', style: { marginBottom: '0', textShadow: '0px 2px 5px black' } },
							_react2.default.createElement('div', { className: 'col s2' }),
							_react2.default.createElement(
								'div',
								{ className: 'col s7' },
								_react2.default.createElement(
									'h2',
									{ className: 'font-white strong', style: { fontWeight: 'bold' } },
									_simpleReactI18n2.default.aquadbTitle
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(_ResearchPanel2.default, { isResearchMap: false, isLogged: this.props.isLogged })
						),
						_react2.default.createElement(
							'div',
							{ className: 'row', style: { marginTop: '5px' } },
							_react2.default.createElement('div', { className: 'col s2' }),
							_react2.default.createElement(
								'div',
								{ className: 'col s6 font-white valign-wrapper' },
								_simpleReactI18n2.default.aquadbDevelopedBy,
								_react2.default.createElement('img', { className: 'responsive-img', style: { maxWidth: '15%', height: 'auto', marginLeft: '0.5em' }, src: _basepath.aquasysPath + '/wp-content/uploads/2022/07/Logo aQuasys_blanc.svg' })
							),
							_react2.default.createElement('div', { className: 'col s2' })
						)
					)
				);
			}
		}]);
	
		return DashboardApp;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
		var _this2 = this;
	
		this.putTitle = function () {
			var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.props;
	
			if (props.isLogged) {
				_AppStore2.default.dispatch(_HomeAction2.default.setTitle(_simpleReactI18n2.default.home));
				_AppStore2.default.dispatch(_HomeAction2.default.setBackPath(_HomeConstants.PATH_HOME));
			} else {
				_AppStore2.default.dispatch(_HomeAction2.default.setTitle(undefined));
			}
		};
	
		this.openSelectionPage = function () {
			_AppStore2.default.dispatch((0, _reactRouterRedux.push)(_HomeConstants.PATH_SELECTION));
		};
	
		this.getMySelectionLink = function () {
			if (_this2.props.isLogged) {
				_AppStore2.default.dispatch((0, _reactRouterRedux.push)(_HomeConstants.PATH_SELECTION));
			} else {
				//TO DO
				_AppStore2.default.dispatch(_HomeAction2.default.updateLoginModalActions([_this2.openSelectionPage]));
				_AppStore2.default.dispatch(_HomeAction2.default.updateLoginModalState(true));
			}
		};
	};
	
	DashboardApp.propTypes = {
		isLogged: _propTypes2.default.bool,
		login: _propTypes2.default.string,
		user: _propTypes2.default.objectOf(_DtoUser2.default)
	};
	
	exports.default = DashboardApp;

/***/ },
/* 2118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _uuid = __webpack_require__(44);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _NumberUtils = __webpack_require__(151);
	
	var _PositionConstants = __webpack_require__(1055);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndicatorTile = function (_Component) {
		_inherits(IndicatorTile, _Component);
	
		function IndicatorTile() {
			_classCallCheck(this, IndicatorTile);
	
			return _possibleConstructorReturn(this, (IndicatorTile.__proto__ || Object.getPrototypeOf(IndicatorTile)).apply(this, arguments));
		}
	
		_createClass(IndicatorTile, [{
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				$('.tooltipped.tile-tooltip').tooltip({ delay: 50 });
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var value = function () {
					if (_this2.props.text) {
						return _react2.default.createElement(
							'span',
							{ className: 'timer white-numbers' },
							_this2.props.text
						);
					}
					return _react2.default.createElement(
						'span',
						{ className: 'timer white-numbers tooltipped tile-tooltip', 'data-position': 'top',
							'data-tooltip': (0, _NumberUtils.formatNumber)(_this2.props.number) },
						(0, _NumberUtils.nFormatter)(_this2.props.number)
					);
				}();
				var position = function () {
					if (_this2.props.titlePosition) {
						return _this2.props.titlePosition;
					}
					return _PositionConstants.LEFT_POSITION;
				}();
				var title = _react2.default.createElement(
					'span',
					{ className: 'blue-title light' },
					this.props.title
				);
				var tabValue = function () {
					switch (position) {
						case _PositionConstants.LEFT_POSITION:
							return [title, value];
						default:
							return [value, title];
					}
				}();
				return _react2.default.createElement(
					'div',
					{ key: _uuid2.default.v4(), className: 'col s4 blue-card-light no-padding center-align' },
					tabValue[0],
					' \xA0 ',
					tabValue[1]
				);
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				$('.tooltipped.tile-tooltip').tooltip('remove');
			}
		}]);
	
		return IndicatorTile;
	}(_react.Component);
	
	IndicatorTile.propTypes = {
		title: _propTypes2.default.string,
		titlePosition: _propTypes2.default.string,
		number: _propTypes2.default.number,
		text: _propTypes2.default.string
	};
	
	IndicatorTile.defaultProps = {
		title: '',
		titlePosition: _PositionConstants.LEFT_POSITION,
		number: 0,
		text: ''
	};
	
	exports.default = IndicatorTile;

/***/ },
/* 2119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactRouterRedux = __webpack_require__(43);
	
	var _ThemeDto = __webpack_require__(129);
	
	var _ThemeDto2 = _interopRequireDefault(_ThemeDto);
	
	var _AdministrationAction = __webpack_require__(61);
	
	var _AdministrationAction2 = _interopRequireDefault(_AdministrationAction);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _HomeConstants = __webpack_require__(53);
	
	var _DtoFilterType = __webpack_require__(130);
	
	var _DtoFilterType2 = _interopRequireDefault(_DtoFilterType);
	
	var _SitesAction = __webpack_require__(97);
	
	var _SitesAction2 = _interopRequireDefault(_SitesAction);
	
	var _DtoUser = __webpack_require__(54);
	
	var _DtoUser2 = _interopRequireDefault(_DtoUser);
	
	var _ApplicationUtil = __webpack_require__(544);
	
	var _ApplicationConstants = __webpack_require__(1053);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _lodash = __webpack_require__(15);
	
	var _ResearchBarPanel = __webpack_require__(1040);
	
	var _ResearchBarPanel2 = _interopRequireDefault(_ResearchBarPanel);
	
	var _SitesConstants = __webpack_require__(226);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResearchPanel = function (_Component) {
		_inherits(ResearchPanel, _Component);
	
		function ResearchPanel() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, ResearchPanel);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ResearchPanel.__proto__ || Object.getPrototypeOf(ResearchPanel)).call.apply(_ref, [this].concat(args))), _this), _this.getDefaultTheme = function (allReferencialThemes) {
				var allThemes = (0, _lodash.flatten)(allReferencialThemes.map(function (o) {
					return o.themes;
				}));
				var filterTheme = (0, _lodash.filter)(allThemes, function (o) {
					return !o.disable;
				});
				return filterTheme.map(function (o) {
					return {
						label: o.title,
						value: o
					};
				});
			}, _this.researchClick = function () {
				if (_this.props.selectedFilters.length) {
					_ApplicationUtil.ApplicationUtil.sumbitRegister(_ApplicationConstants.CATEGORY_RESEARCH, _ApplicationConstants.ACTION_RESEARCH, _simpleReactI18n2.default.searchLaunch);
					_SitesAction2.default.launchResearch(_this.props.selectedFilters, _this.props.selectedThemes, _this.props.filterTypes);
				} else {
					_ApplicationUtil.ApplicationUtil.sumbitRegister(_ApplicationConstants.CATEGORY_RESEARCH, _ApplicationConstants.ACTION_ADVANCED_RESEARCH, _simpleReactI18n2.default.advancedSearch);
					_AppStore2.default.dispatch((0, _reactRouterRedux.push)(_HomeConstants.PATH_RESEARCH + '/open'));
				}
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(ResearchPanel, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				_AppStore2.default.dispatch(_AdministrationAction2.default.fetchThemes());
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nexprops) {
				if (!nexprops.selectedThemes.length && nexprops.themes.length) {
					var initDefaultTheme = this.getDefaultTheme(nexprops.themes);
					_AppStore2.default.dispatch(_AdministrationAction2.default.selectedThemes(initDefaultTheme));
				}
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'col s12 center-align' },
					_react2.default.createElement(
						'div',
						{ className: 'row no-margin valign-wrapper' },
						_react2.default.createElement(
							'div',
							{ className: 'col s8 offset-s2 center-align no-padding' },
							_react2.default.createElement(
								'div',
								{ className: 'row no-margin valign-wrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'col s12 no-padding' },
									_react2.default.createElement(_ResearchBarPanel2.default, { isResearchMap: this.props.isResearchMap,
										researchClick: this.researchClick,
										isLogged: this.props.isLogged, page: _SitesConstants.HOME_PAGE_RESEARCH })
								)
							)
						)
					)
				);
			}
		}]);
	
		return ResearchPanel;
	}(_react.Component);
	
	ResearchPanel.propTypes = {
		isLogged: _propTypes2.default.bool,
		selectedFilters: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			label: _propTypes2.default.string,
			value: _propTypes2.default.object
		})),
		selectedThemes: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			label: _propTypes2.default.string,
			value: _propTypes2.default.instanceOf(_ThemeDto2.default)
		})),
		isResearchMap: _propTypes2.default.bool,
		themes: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_ThemeDto2.default)),
		filterTypes: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoFilterType2.default)),
		user: _propTypes2.default.instanceOf(_DtoUser2.default)
	};
	ResearchPanel.defaultProps = {
		isResearchMap: false
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			selectedFilters: store.AdministrationReducer.selectedFilters,
			selectedThemes: store.AdministrationReducer.selectedThemes,
			themes: store.AdministrationReducer.themes,
			filterTypes: store.ReferentialReducer.filterTypes,
			user: store.HomeReducer.user
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ResearchPanel);

/***/ },
/* 2120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouterRedux = __webpack_require__(43);
	
	var _HomeConstants = __webpack_require__(53);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _uuid = __webpack_require__(44);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewSelectionPanel = function (_Component) {
		_inherits(NewSelectionPanel, _Component);
	
		function NewSelectionPanel(props) {
			_classCallCheck(this, NewSelectionPanel);
	
			var _this = _possibleConstructorReturn(this, (NewSelectionPanel.__proto__ || Object.getPrototypeOf(NewSelectionPanel)).call(this, props));
	
			_this.redirect = function () {
				_AppStore2.default.dispatch((0, _reactRouterRedux.push)(_HomeConstants.PATH_RESEARCH + '/open'));
			};
	
			return _this;
		}
	
		_createClass(NewSelectionPanel, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'div',
					{ key: _uuid2.default.v4(), id: this.props.id, className: 'col s2 ', onClick: function onClick() {
							return _this2.redirect();
						} },
					_react2.default.createElement(
						'div',
						{ className: 'card newSelectionPanel valign-wrapper center center-align z-depth-2 clickable hoverable' },
						_react2.default.createElement(
							'div',
							{ className: 'fullWidth' },
							_react2.default.createElement(
								'h5',
								null,
								_simpleReactI18n2.default.addNewSelection
							),
							_react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									'i',
									{ className: 'material-icons' },
									'add_circle_outline'
								)
							)
						)
					)
				);
			}
		}]);
	
		return NewSelectionPanel;
	}(_react.Component);
	
	NewSelectionPanel.propTypes = {
		id: _propTypes2.default.number
	};
	NewSelectionPanel.defaultProps = {
		id: 0
	};
	exports.default = NewSelectionPanel;

/***/ },
/* 2121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(15);
	
	var _reactRedux = __webpack_require__(18);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _SelectionsPanel = __webpack_require__(2122);
	
	var _SelectionsPanel2 = _interopRequireDefault(_SelectionsPanel);
	
	var _DtoSelection = __webpack_require__(181);
	
	var _DtoSelection2 = _interopRequireDefault(_DtoSelection);
	
	var _HomeAction = __webpack_require__(52);
	
	var _HomeAction2 = _interopRequireDefault(_HomeAction);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _NewSelectionPanel = __webpack_require__(2120);
	
	var _NewSelectionPanel2 = _interopRequireDefault(_NewSelectionPanel);
	
	var _HomeConstants = __webpack_require__(53);
	
	var _reactRouterRedux = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectionApp = function (_Component) {
		_inherits(SelectionApp, _Component);
	
		function SelectionApp() {
			_classCallCheck(this, SelectionApp);
	
			return _possibleConstructorReturn(this, (SelectionApp.__proto__ || Object.getPrototypeOf(SelectionApp)).apply(this, arguments));
		}
	
		_createClass(SelectionApp, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				if (this.props.isLogged) {
					_AppStore2.default.dispatch(_HomeAction2.default.setTitle(_simpleReactI18n2.default.myResearch));
				} else {
					_AppStore2.default.dispatch((0, _reactRouterRedux.push)(_HomeConstants.PATH_HOME));
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var selections = function () {
					if (_this2.props.selections.length) {
						var select = (0, _lodash.filter)(_this2.props.selections, function (o) {
							return !o.close;
						});
						if (select.length) {
							return select;
						}
						return [];
					}
					return [];
				}();
				if (selections.length) {
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ className: 'row no-margin' },
							_react2.default.createElement(
								'div',
								{ className: 'col s12 m12 no-padding' },
								_react2.default.createElement(_SelectionsPanel2.default, { selections: selections })
							)
						)
					);
				}
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin' },
					_react2.default.createElement(
						'div',
						{ className: 'col s12' },
						_react2.default.createElement(_NewSelectionPanel2.default, null)
					)
				);
			}
		}]);
	
		return SelectionApp;
	}(_react.Component);
	
	SelectionApp.propTypes = {
		login: _propTypes2.default.string,
		isLogged: _propTypes2.default.bool,
		selections: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoSelection2.default))
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			selections: store.SelectionReducer.selections
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(SelectionApp);

/***/ },
/* 2122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _uuid = __webpack_require__(44);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _DtoSelection = __webpack_require__(181);
	
	var _DtoSelection2 = _interopRequireDefault(_DtoSelection);
	
	var _DtoSelectionSite = __webpack_require__(1027);
	
	var _DtoSelectionSite2 = _interopRequireDefault(_DtoSelectionSite);
	
	var _DtoSelectionFilter = __webpack_require__(1026);
	
	var _DtoSelectionFilter2 = _interopRequireDefault(_DtoSelectionFilter);
	
	var _lodash = __webpack_require__(15);
	
	var _SelectionDeleteModal = __webpack_require__(2109);
	
	var _SelectionDeleteModal2 = _interopRequireDefault(_SelectionDeleteModal);
	
	var _DtoFilter = __webpack_require__(530);
	
	var _DtoFilter2 = _interopRequireDefault(_DtoFilter);
	
	var _DtoFilterType = __webpack_require__(130);
	
	var _DtoFilterType2 = _interopRequireDefault(_DtoFilterType);
	
	var _ResearchTypes = __webpack_require__(288);
	
	var _ResearchTypes2 = _interopRequireDefault(_ResearchTypes);
	
	var _DtoSelectionDetailSite = __webpack_require__(538);
	
	var _DtoSelectionDetailSite2 = _interopRequireDefault(_DtoSelectionDetailSite);
	
	var _DtoSiteType = __webpack_require__(96);
	
	var _DtoSiteType2 = _interopRequireDefault(_DtoSiteType);
	
	var _ThemeDto = __webpack_require__(129);
	
	var _ThemeDto2 = _interopRequireDefault(_ThemeDto);
	
	var _DtoSelectionRow = __webpack_require__(182);
	
	var _DtoSelectionRow2 = _interopRequireDefault(_DtoSelectionRow);
	
	var _AgGridTable = __webpack_require__(2101);
	
	var _AgGridTable2 = _interopRequireDefault(_AgGridTable);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _DateUtil = __webpack_require__(67);
	
	var _SelectionInformationModal = __webpack_require__(2110);
	
	var _SelectionInformationModal2 = _interopRequireDefault(_SelectionInformationModal);
	
	var _NumberUtils = __webpack_require__(151);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DtoKeyFigures = __webpack_require__(98);
	
	var _DtoKeyFigures2 = _interopRequireDefault(_DtoKeyFigures);
	
	var _DtoSelectionExportHistory = __webpack_require__(531);
	
	var _DtoSelectionExportHistory2 = _interopRequireDefault(_DtoSelectionExportHistory);
	
	var _DtoSelectionWatershed = __webpack_require__(1028);
	
	var _DtoSelectionWatershed2 = _interopRequireDefault(_DtoSelectionWatershed);
	
	var _LoadingPanel = __webpack_require__(1020);
	
	var _LoadingPanel2 = _interopRequireDefault(_LoadingPanel);
	
	var _IndicatorPanel = __webpack_require__(1023);
	
	var _IndicatorPanel2 = _interopRequireDefault(_IndicatorPanel);
	
	var _StringUtils = __webpack_require__(131);
	
	var _SelectionAction = __webpack_require__(95);
	
	var _SelectionAction2 = _interopRequireDefault(_SelectionAction);
	
	var _SitesAction = __webpack_require__(97);
	
	var _SitesAction2 = _interopRequireDefault(_SitesAction);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _DtoCity = __webpack_require__(87);
	
	var _DtoCity2 = _interopRequireDefault(_DtoCity);
	
	var _DtoWatershed = __webpack_require__(183);
	
	var _DtoWatershed2 = _interopRequireDefault(_DtoWatershed);
	
	var _DtoManagementWater = __webpack_require__(223);
	
	var _DtoManagementWater2 = _interopRequireDefault(_DtoManagementWater);
	
	var _DtoSelectionStatus = __webpack_require__(532);
	
	var _DtoSelectionStatus2 = _interopRequireDefault(_DtoSelectionStatus);
	
	var _LinearProgress = __webpack_require__(302);
	
	var _LinearProgress2 = _interopRequireDefault(_LinearProgress);
	
	var _glamor = __webpack_require__(143);
	
	var _core = __webpack_require__(116);
	
	var _SelectionExportModal = __webpack_require__(1021);
	
	var _SelectionExportModal2 = _interopRequireDefault(_SelectionExportModal);
	
	var _Tooltip = __webpack_require__(240);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _DtoDepartment = __webpack_require__(381);
	
	var _DtoDepartment2 = _interopRequireDefault(_DtoDepartment);
	
	var _SiteTypes = __webpack_require__(56);
	
	var _SiteTypes2 = _interopRequireDefault(_SiteTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = window.$;
	
	var SelectionsPanel = function (_Component) {
		_inherits(SelectionsPanel, _Component);
	
		function SelectionsPanel(props) {
			_classCallCheck(this, SelectionsPanel);
	
			var _this = _possibleConstructorReturn(this, (SelectionsPanel.__proto__ || Object.getPrototypeOf(SelectionsPanel)).call(this, props));
	
			_this.createInformation = function (title, information) {
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin' },
					_react2.default.createElement(
						'div',
						{ className: 'col s6 no-padding' },
						title
					),
					_react2.default.createElement(
						'div',
						{ className: 'col s6 no-padding' },
						information
					)
				);
			};
	
			_this.getInformations = function (list, id) {
				if (list.length > 0) {
					return (0, _lodash.filter)(list, function (o) {
						return o.selectionId == id;
					});
				}
				return [];
			};
	
			_this.getFilterSiteByTypes = function (listOfSelectionSite, selectedSiteTypes) {
				var listOfStations = (0, _lodash.intersectionWith)(_this.props.selectionDetailsSites, listOfSelectionSite, function (a, b) {
					return a.id == b.siteId;
				});
				var piezometerToIntegrate = function () {
					var piezometerParameterPresent = (0, _lodash.find)(selectedSiteTypes, function (o) {
						return o.parameter == _SiteTypes2.default.PIEZOMETER.type;
					});
					if (piezometerParameterPresent) {
						var filterPiezometerStation = (0, _lodash.filter)(listOfStations, function (o) {
							return o.isPiezometer === '1';
						});
						var listOfPiezometers = filterPiezometerStation.map(function (o) {
							return Object.assign({}, o, {
								typeId: piezometerParameterPresent.id
							});
						});
						return listOfPiezometers;
					}
					return [];
				}();
				return [].concat(listOfStations, piezometerToIntegrate);
			};
	
			_this.getStations = function (list, id, selectedSiteTypes) {
				if (list.length > 0) {
					var listOfSelectionSite = (0, _lodash.filter)(list, function (o) {
						return o.selectionId == id;
					});
					return _this.getFilterSiteByTypes(listOfSelectionSite, selectedSiteTypes);
				}
				return [];
			};
	
			_this.getThemeId = function () {
				if (_this.props.filterTypes.length) {
					var resultFilter = (0, _lodash.find)(_this.props.filterTypes, function (o) {
						return o.filter == _ResearchTypes2.default.THEME.type;
					});
					if (resultFilter) {
						return resultFilter.id;
					}
					return null;
				}
				return null;
			};
	
			_this.getThemes = function (filterValues, filters, themeId) {
				if (themeId || themeId == '0' && filterValues.length && filters.length) {
					var intersections = (0, _lodash.intersectionWith)(filterValues, filters, function (a, b) {
						return a.id == b.filterId;
					});
					if (intersections.length) {
						return (0, _lodash.filter)(intersections, function (o) {
							return o.filterTypeId == themeId;
						});
					}
					return [];
				}
				return [];
			};
	
			_this.getFiltersWithoutThemes = function (filterValues, allFilters, themes) {
				if (themes && themes.length && filterValues && filterValues.length) {
					var diff = (0, _lodash.differenceWith)(allFilters, themes, function (a, b) {
						return a.id == b.id;
					});
					return (0, _lodash.intersectionWith)(filterValues, diff, function (a, b) {
						return a.id == b.filterId;
					});
				}
				return allFilters;
			};
	
			_this.setModalSelectionInformation = function (selection) {
				_AppStore2.default.dispatch(_SelectionAction2.default.openModalSelectionInformation(selection));
			};
	
			_this.setModalSelectionDelete = function (selection) {
				_AppStore2.default.dispatch(_SelectionAction2.default.openModalSelectionDelete(selection));
			};
	
			_this.setModalSelectionExport = function (selection) {
				_AppStore2.default.dispatch(_SelectionAction2.default.openModalSelectionExport(selection));
			};
	
			_this.setFavoriteFunction = function (selection) {
				if (selection.favorite) {
					_AppStore2.default.dispatch(_SelectionAction2.default.removeFavoriteSelection(selection));
				} else {
					_AppStore2.default.dispatch(_SelectionAction2.default.setFavoriteSelection(selection));
				}
			};
	
			_this.createDtoRadius = function (table) {
				return table.map(function (o) {
					var jsonValue = JSON.parse(o.value);
					return {
						label: 'x: ' + (0, _StringUtils.substringNumber)(jsonValue.longi) + ' y: ' + (0, _StringUtils.substringNumber)(jsonValue.lati) + ' radius: ' + parseFloat(jsonValue.radius),
						type: _ResearchTypes2.default.RADIUS,
						value: jsonValue
					};
				});
			};
	
			_this.createDtoCity = function (table) {
				return table.map(function (o) {
					var city = (0, _lodash.find)(_this.props.cities, function (b) {
						return b.code == o.value;
					});
					var postalCode = city.postalCode ? city.postalCode : city.code;
					return {
						label: city.name + ' - ' + postalCode + ' [' + city.code + ']',
						type: _ResearchTypes2.default.CITY,
						value: {
							code: o.value
						}
					};
				});
			};
	
			_this.createDtoDepartment = function (table) {
				return table.map(function (o) {
					var department = (0, _lodash.find)(_this.props.departments, function (b) {
						return b.code == o.value;
					});
					return {
						label: department.name + ' [' + department.code + ']',
						type: _ResearchTypes2.default.DEPARTMENT,
						value: {
							code: o.value
						}
					};
				});
			};
	
			_this.createDtoWatershed = function (table) {
				return table.map(function (o) {
					var watershed = (0, _lodash.find)(_this.props.watersheds, function (b) {
						return b.id == o.value;
					});
					return {
						label: watershed.name + ' [' + watershed.code + ']',
						type: _ResearchTypes2.default.WATERSHED,
						value: {
							code: o.value
						}
					};
				});
			};
	
			_this.createDtoManagementWater = function (table) {
				return table.map(function (o) {
					var managementWater = (0, _lodash.find)(_this.props.managementWaters, function (b) {
						return b.id == o.value;
					});
					return {
						label: managementWater.name + ' [' + managementWater.code + ']',
						type: _ResearchTypes2.default.MANAGEMENT_WATER,
						value: {
							id: o.value
						}
					};
				});
			};
	
			_this.createDtoStation = function (table) {
				return table.map(function (o) {
					var station = (0, _lodash.find)(_this.props.selectionDetailsSites, function (stat) {
						return stat.id == o.value;
					});
					return {
						label: station.name + ' [' + station.code + ']',
						type: _ResearchTypes2.default.STATION,
						value: {
							id: o.value
						}
					};
				});
			};
	
			_this.lauchResearch = function (selection) {
				var reduceFilters = (0, _lodash.reduce)(selection.filters, function (a, b) {
					(a[b.filterTypeId] || (a[b.filterTypeId] = [])).push(b);
					return a;
				}, {});
				var selectedFilters = (0, _lodash.flatten)(Object.keys(reduceFilters).map(function (o) {
					var tabValue = reduceFilters[o];
					var filterTypeReference = (0, _lodash.find)(_this.props.filterTypes, function (b) {
						return b.id == o;
					});
					switch (filterTypeReference.filter) {
						case _ResearchTypes2.default.RADIUS.type:
							return _this.createDtoRadius(tabValue);
						case _ResearchTypes2.default.CITY.type:
							return _this.createDtoCity(tabValue);
						case _ResearchTypes2.default.STATION.type:
							return _this.createDtoStation(tabValue);
						case _ResearchTypes2.default.WATERSHED.type:
							return _this.createDtoWatershed(tabValue, _ResearchTypes2.default.WATERSHED);
						case _ResearchTypes2.default.MANAGEMENT_WATER.type:
							return _this.createDtoManagementWater(tabValue, _ResearchTypes2.default.MANAGEMENT_WATER);
						case _ResearchTypes2.default.DEPARTMENT.type:
							return _this.createDtoDepartment(tabValue, _ResearchTypes2.default.DEPARTMENT);
						default:
							return null;
					}
				}));
				var allThemes = (0, _lodash.flatten)(_this.props.themes.map(function (o) {
					return o.themes;
				}));
				var selectedThemes = (0, _lodash.uniqBy)(selection.themes, 'value').map(function (o) {
					var theme = (0, _lodash.find)(allThemes, function (b) {
						return b.id == o.value;
					});
					return {
						label: theme.title,
						value: theme
					};
				});
				_SitesAction2.default.launchResearch(selectedFilters, selectedThemes, _this.props.filterTypes, selection);
			};
	
			_this.getPictures = function () {
				var urlPicture = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
				if (urlPicture) {
					return urlPicture;
				}
				return 'http://www.aquasys.fr/wp-content/uploads/2017/12/paul-gilmore-325220.jpg?id=1618';
			};
	
			_this.getPicture = function (themes, filters, stations) {
				if (stations.length && _this.props.selectionDetailsSites.length && _this.props.themes) {
					var selectedSites = (0, _lodash.intersectionWith)(_this.props.selectionDetailsSites, stations, function (a, b) {
						return a.id == b.siteId;
					});
					var reduceTypeId = (0, _lodash.reduce)(selectedSites, function (a, b) {
						if (a[b.typeId]) {
							a[b.typeId] = a[b.typeId] + 1;
						} else {
							a[b.typeId] = 1;
						}
						return a;
					}, {});
					var siteTypeParameters = Object.keys(reduceTypeId).map(function (o) {
						var type = (0, _lodash.find)(_this.props.siteTypes, function (a) {
							return a.id == o;
						});
						return {
							filter: type.parameter,
							count: reduceTypeId[o]
						};
					});
					var referencialTheme = (0, _lodash.intersectionWith)(_this.props.themes, themes, function (a, b) {
						return (0, _lodash.find)(a.themes, function (c) {
							return c.id == b.value;
						});
					});
					if (referencialTheme && referencialTheme.length) {
						if (referencialTheme.length > 1) {
							var resultThemes = (0, _lodash.reduce)(referencialTheme, function (a, b) {
								var siteTypes = b.siteTypes;
								var intersection = (0, _lodash.intersectionWith)(siteTypeParameters, siteTypes, function (c, d) {
									return c.filter == d.type;
								});
								a[b.id] = (0, _lodash.maxBy)(intersection, function (o) {
									return o.count;
								});
								return a;
							}, {});
							var resultCount = Object.keys(resultThemes).map(function (o) {
								if (resultThemes[o]) {
									return {
										id: o,
										count: resultThemes[o].count
									};
								}
								return undefined;
							}).filter(function (n) {
								return n;
							});
							var order = (0, _lodash.orderBy)(resultCount, ['count'], ['desc']);
							if (order.length) {
								var themeSelected = (0, _lodash.find)(_this.props.themes, function (o) {
									return o.id == order[0].id;
								});
								return _this.getPictures(themeSelected.image);
							}
	
							return _this.getPictures(referencialTheme[0].image);
						}
						return _this.getPictures(referencialTheme[0].image);
					}
					return _this.getPictures();
				}
				return _this.getPictures();
			};
	
			_this.getDeleteFunction = function (selection) {
				var minimize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
				var color = '#F44336';
				if (minimize) {
					return _react2.default.createElement(
						_Tooltip2.default,
						{ title: _simpleReactI18n2.default.deleteFunction },
						_react2.default.createElement(
							_core.Icon,
							Object.assign({ className: 'material-icons' }, (0, _glamor.css)({
								width: 36,
								height: 36,
								color: color,
								fontSize: '2rem !important',
								margin: '7px !important'
							}), { onClick: function onClick() {
									return _this.setModalSelectionDelete(selection);
								} }),
							' delete '
						)
					);
				}
				return _react2.default.createElement(
					_Tooltip2.default,
					{ title: _simpleReactI18n2.default.deleteFunction },
					_react2.default.createElement(
						'a',
						{ className: 'btn-floating waves-effect waves-light z-depth-4 activator ',
							style: {
								backgroundColor: color,
								width: 36,
								height: 36
							},
							onClick: function onClick() {
								return _this.setModalSelectionDelete(selection);
							} },
						_react2.default.createElement(
							'i',
							{ className: 'material-icons activator btn-function-card' },
							'delete'
						)
					)
				);
			};
	
			_this.getExecutionFunction = function (selection) {
				var minimize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
				var color = '#2196F3';
				if (minimize) {
					return _react2.default.createElement(
						_Tooltip2.default,
						{ title: _simpleReactI18n2.default.reflate },
						_react2.default.createElement(
							_core.Icon,
							Object.assign({ className: 'material-icons' }, (0, _glamor.css)({
								width: 36,
								height: 36,
								color: color,
								fontSize: '2rem !important',
								margin: '7px !important'
							}), { onClick: function onClick() {
									return _this.lauchResearch(selection);
								} }),
							' autorenew '
						)
					);
				}
				return _react2.default.createElement(
					_Tooltip2.default,
					{ title: _simpleReactI18n2.default.reflate },
					_react2.default.createElement(
						'a',
						{ className: 'btn-floating waves-effect waves-light z-depth-4 activator ',
							style: {
								backgroundColor: color,
								width: 36,
								height: 36
							},
							onClick: function onClick() {
								return _this.lauchResearch(selection);
							} },
						_react2.default.createElement(
							'i',
							{ className: 'material-icons activator btn-function-card' },
							'autorenew'
						)
					)
				);
			};
	
			_this.getInformationsFunction = function (selection) {
				var minimize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
				var color = '#161832';
				if (minimize) {
					return _react2.default.createElement(
						_Tooltip2.default,
						{ title: _simpleReactI18n2.default.informationFunction },
						_react2.default.createElement(
							_core.Icon,
							Object.assign({ className: 'material-icons' }, (0, _glamor.css)({
								width: 36,
								height: 36,
								color: color,
								fontSize: '2rem !important',
								margin: '7px !important'
							}), { onClick: function onClick() {
									return _this.setModalSelectionInformation(selection);
								} }),
							' info '
						)
					);
				}
				return _react2.default.createElement(
					_Tooltip2.default,
					{ title: _simpleReactI18n2.default.informationFunction },
					_react2.default.createElement(
						'a',
						{ className: 'btn-floating waves-effect waves-light z-depth-4 activator ',
							style: {
								backgroundColor: color,
								width: 36,
								height: 36
							},
							onClick: function onClick() {
								return _this.setModalSelectionInformation(selection);
							} },
						_react2.default.createElement(
							'i',
							{ className: 'material-icons activator btn-function-card' },
							'info'
						)
					)
				);
			};
	
			_this.getExportFunction = function (selection) {
				var minimize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
				var color = '#4CAF50';
				if (minimize) {
					return _react2.default.createElement(
						_Tooltip2.default,
						{ title: _simpleReactI18n2.default.exportFunction },
						_react2.default.createElement(
							_core.Icon,
							Object.assign({ className: 'material-icons' }, (0, _glamor.css)({
								width: 36,
								height: 36,
								color: color,
								fontSize: '2rem !important',
								margin: '7px !important'
							}), { onClick: function onClick() {
									return _this.setModalSelectionExport(selection);
								} }),
							' file_download '
						)
					);
				}
				return _react2.default.createElement(
					_Tooltip2.default,
					{ title: _simpleReactI18n2.default.exportFunction },
					_react2.default.createElement(
						'a',
						{ className: 'btn-floating waves-effect waves-light z-depth-4 activator ',
							style: {
								backgroundColor: color,
								width: 36,
								height: 36
							},
							onClick: function onClick() {
								return _this.setModalSelectionExport(selection);
							} },
						_react2.default.createElement(
							'i',
							{ className: 'material-icons activator btn-function-card' },
							'file_download'
						)
					)
				);
			};
	
			_this.getFavoriteFunction = function (selection) {
				var minimize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
				var isFavorite = selection.favorite;
				var color = isFavorite ? 'rgb(242, 161, 69) !important' : '';
				var backgroundColor = isFavorite ? 'rgba(0,0,255,0.6)' : '';
				var icon = isFavorite ? 'start' : 'star_border';
				var className = isFavorite ? 'favorit-color' : '';
				if (minimize) {
					return _react2.default.createElement(
						_Tooltip2.default,
						{ title: _simpleReactI18n2.default.favorite },
						_react2.default.createElement(
							_core.Icon,
							Object.assign({ className: 'material-icons' }, (0, _glamor.css)({
								width: 36,
								height: 36,
								color: color,
								fontSize: '2rem !important',
								margin: '7px !important'
							}), { onClick: function onClick() {
									return _this.setFavoriteFunction(selection);
								} }),
							' ',
							icon,
							' '
						)
					);
				}
				return _react2.default.createElement(
					_Tooltip2.default,
					{ title: _simpleReactI18n2.default.favorite },
					_react2.default.createElement(
						'a',
						{ className: 'btn-floating waves-effect waves-light z-depth-4 activator ',
							style: {
								backgroundColor: backgroundColor,
								paddingLeft: color ? '8px' : 0,
								color: color,
								width: 36,
								height: 36
							},
							onClick: function onClick() {
								return _this.setFavoriteFunction(selection);
							} },
						_react2.default.createElement(
							'i',
							{ className: 'material-icons activator btn-function-card ' + className },
							icon
						)
					)
				);
			};
	
			_this.getSelectionsPanel = function (favoritSelection) {
				var returnTable = [];
				var resultFavorits = favoritSelection.map(function (o) {
					var isUpdate = function () {
						if (o.isUpdateData) {
							return _react2.default.createElement(
								'div',
								{ className: 'card-content no-padding no-margin center-align' },
								_react2.default.createElement(
									'div',
									{
										className: 'row no-margin updateColorBackground panelUpdate' },
									_simpleReactI18n2.default.dataAvailable
								)
							);
						} else if (o.state) {
							var statusSelection = (0, _lodash.find)(_this.props.selectionStatus, function (a) {
								return o.state == a.id;
							});
							if (statusSelection && statusSelection.id === 1) {
								return _react2.default.createElement(
									'div',
									{ className: 'card-content no-padding no-margin center-align' },
									_react2.default.createElement(
										'div',
										{
											className: 'row no-margin downloadColorBackground panelDownload' },
										statusSelection.name
									),
									_react2.default.createElement(_LinearProgress2.default, { className: 'white-filter', mode: 'indeterminate',
										style: { height: '5px' } })
								);
							}
							return _react2.default.createElement('div', { className: 'card-content no-padding no-margin', style: { height: '25px' } });
						}
						return _react2.default.createElement('div', { className: 'card-content no-padding no-margin', style: { height: '25px' } });
					}();
					return _react2.default.createElement(
						'div',
						{ className: 'col s2', key: o.id },
						_react2.default.createElement(
							'div',
							{ className: 'card' },
							_react2.default.createElement(
								'div',
								{ className: 'card-image' },
								_react2.default.createElement('img', { className: 'selectionPicturePanel', src: o.picture }),
								_react2.default.createElement(
									'span',
									{ className: 'card-title padding-bottom-0 padding-right-0 padding-top-0 padding-left-10', style: { top: 0 } },
									o.title
								),
								_react2.default.createElement(
									'ul',
									{ className: 'card-action-buttons right', style: { margin: '-20px 10px 0 0' } },
									_react2.default.createElement(
										'li',
										{ style: { display: 'inline-block', paddingLeft: '5px' } },
										_this.getInformationsFunction(o)
									),
									_react2.default.createElement(
										'li',
										{ style: { display: 'inline-block', paddingLeft: '5px' } },
										_this.getExecutionFunction(o)
									),
									_react2.default.createElement(
										'li',
										{ style: { display: 'inline-block', paddingLeft: '5px' } },
										_this.getExportFunction(o)
									),
									_react2.default.createElement(
										'li',
										{ style: { display: 'inline-block', paddingLeft: '5px' } },
										_this.getDeleteFunction(o)
									),
									_react2.default.createElement(
										'li',
										{ style: { display: 'inline-block', paddingLeft: '5px' } },
										_this.getFavoriteFunction(o)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'card-content' },
								_react2.default.createElement(
									'div',
									{ className: 'row no-margin' },
									_react2.default.createElement(
										'div',
										{ className: 'col s12 no-padding' },
										_this.createInformation(_simpleReactI18n2.default.creation, (0, _DateUtil.getDate)(o.creationDate)),
										_this.createInformation(_simpleReactI18n2.default.update, (0, _DateUtil.getDate)(o.updateDate)),
										_this.createInformation(_simpleReactI18n2.default.lastExecutionDate, (0, _DateUtil.getDate)(o.lastExecutionDate)),
										_this.createInformation(_simpleReactI18n2.default.themes, (0, _NumberUtils.formatNumber)(o.nbTheme)),
										_this.createInformation(_simpleReactI18n2.default.watersheds, (0, _NumberUtils.formatNumber)(o.nbWatershed)),
										_this.createInformation(_simpleReactI18n2.default.stations, (0, _NumberUtils.formatNumber)(o.nbStation))
									)
								)
							),
							isUpdate
						)
					);
				});
				returnTable.unshift(resultFavorits);
				return returnTable;
			};
	
			_this.isUpdate = function (selection, stations, keyFigures, exportHistory) {
				if (exportHistory.length) {
					return (0, _lodash.filter)(keyFigures, function (a) {
						return (0, _moment2.default)(a.endDate) >= (0, _moment2.default)(exportHistory[0].beginDate);
					}).length > 0;
				}
				return true;
			};
	
			_this.getExportHistory = function (selection) {
				if (_this.props.selectionExportsHistory && _this.props.selectionExportsHistory.length) {
					var result = (0, _lodash.filter)(_this.props.selectionExportsHistory, function (o) {
						return o.selectionId == selection.id;
					});
					if (result.length) {
						return (0, _lodash.orderBy)(result, ['beginDate'], ['desc']);
					}
					return [];
				}
				return [];
			};
	
			_this.getSelectionWatershed = function (selection) {
				if (_this.props.selectionWatershed && _this.props.selectionWatershed.length) {
					return (0, _lodash.filter)(_this.props.selectionWatershed, function (o) {
						return o.selectionId == selection.id;
					});
				}
				return [];
			};
	
			_this.getSelectionKeyfigure = function (stations) {
				return (0, _lodash.filter)(_this.props.selectionKeyFigures, function (o) {
					return (0, _lodash.find)(stations, function (s) {
						return o.stationId == s.id && o.typeId == s.typeId;
					});
				});
			};
	
			_this.getThemesWithSiteTypes = function () {
				var listOfThemesWithSiteType = (0, _lodash.flatten)(_this.props.themes.map(function (o) {
					return o.themes;
				}));
				return listOfThemesWithSiteType.map(function (o) {
					var siteTypes = (0, _lodash.filter)(_this.props.siteTypes, function (si) {
						return (0, _lodash.find)(o.siteTypes, function (tmp) {
							return tmp.type == si.parameter;
						});
					});
					return {
						themeId: o.id,
						siteTypes: siteTypes
					};
				});
			};
	
			_this.getSelectionSiteTypes = function (themes, referentialThemeSiteTypeIds) {
				return (0, _lodash.flatten)((0, _lodash.filter)(referentialThemeSiteTypeIds, function (o) {
					return (0, _lodash.find)(themes, function (t) {
						return t.value == o.themeId;
					});
				}).map(function (o) {
					return o.siteTypes;
				}));
			};
	
			_this.getSelections = function () {
				if (_this.props.selections.length) {
					var themeId = _this.getThemeId();
					var referentialThemeSiteTypeIds = _this.getThemesWithSiteTypes();
					return (0, _lodash.orderBy)((0, _lodash.filter)(_this.props.selections, function (o) {
						return !o.close;
					}), ['lastExecution'], ['desc']).map(function (o) {
						var allFilters = _this.getInformations(_this.props.selectionFilters, o.id);
						var themes = _this.getThemes(_this.props.filterValues, allFilters, themeId);
						var selectedSiteTypes = _this.getSelectionSiteTypes(themes, referentialThemeSiteTypeIds);
						var stations = _this.getStations(_this.props.selectionSites, o.id, selectedSiteTypes);
						var filters = _this.getFiltersWithoutThemes(_this.props.filterValues, allFilters, themes);
						var keyFigures = _this.getSelectionKeyfigure(stations);
						var deleteFunction = _this.getDeleteFunction(o, true);
						var favoriteFunction = _this.getFavoriteFunction(o, true);
						var picture = _this.getPicture(themes, filters, stations);
						var exportHistory = _this.getExportHistory(o);
						var isUpdate = _this.isUpdate(o, stations, keyFigures, exportHistory);
						var selectionWatershed = _this.getSelectionWatershed(o);
						return new _DtoSelectionRow2.default(o, stations, filters, themes, picture, favoriteFunction, undefined, deleteFunction, undefined, undefined, isUpdate, exportHistory, selectionWatershed, keyFigures);
					}).map(function (o) {
						return Object.assign({}, o, {
							executionFunction: _this.getExecutionFunction(o, true),
							informationFunction: _this.getInformationsFunction(o, true),
							exportFunction: _this.getExportFunction(o, true)
						});
					});
				}
				return [];
			};
	
			_this.getAllInformations = function () {
				if (_this.props.selections.length) {
					if (_this.props.filterValues.length) {
						if (_this.props.selectionDetailsSites.length) {
							if (_this.props.watersheds.length) {
								if (_this.props.cities.length) {
									return '100';
								}
								return _simpleReactI18n2.default.loadingCities;
							}
							return _simpleReactI18n2.default.loadingWatershed;
						}
						return _simpleReactI18n2.default.loadingSelectedStations;
					}
					return _simpleReactI18n2.default.loadingYourFilters;
				}
				return _simpleReactI18n2.default.selectionLoading;
			};
	
			_this.getKeyfigures = function () {
				var selections = _this.props.selections ? _this.props.selections : [];
				var nbSelection = selections.length;
				var selectionSites = function () {
					if (nbSelection) {
						return (0, _lodash.flatten)(selections.map(function (o) {
							return (0, _lodash.filter)(_this.props.selectionSites, function (b) {
								return b.selectionId === o.id;
							});
						}));
					}
					return [];
				}();
				var nbSite = selectionSites.length;
				var keyFigures = function () {
					if (nbSite) {
						return (0, _lodash.flatten)(selectionSites.map(function (o) {
							return (0, _lodash.filter)(_this.props.selectionKeyFigures, function (b) {
								return b.stationId === o.siteId;
							});
						}));
					}
					return [];
				}();
				var nbAnalysis = function () {
					if (keyFigures.length) {
						return (0, _lodash.sumBy)((0, _lodash.filter)(keyFigures, function (o) {
							return o.nbAnalysis;
						}), function (o) {
							return o.nbAnalysis;
						});
					}
					return 0;
				}();
				var nbMeasure = function () {
					if (keyFigures.length) {
						(0, _lodash.sumBy)((0, _lodash.filter)(keyFigures, function (o) {
							return o.nbMeasure;
						}), function (o) {
							return o.nbMeasure;
						});
					}
					return 0;
				}();
				var nbData = nbAnalysis + nbMeasure;
				return [{
					title: (0, _StringUtils.getPlurialWithNumber)(_simpleReactI18n2.default.selection, _simpleReactI18n2.default.selections, nbSelection),
					number: nbSelection
				}, {
					title: (0, _StringUtils.getPlurialWithNumber)(_simpleReactI18n2.default.station, _simpleReactI18n2.default.stations, nbSite),
					number: nbSite
				}, {
					title: (0, _StringUtils.getPlurialWithNumber)(_simpleReactI18n2.default.data, _simpleReactI18n2.default.datas, nbData),
					number: nbData
				}];
			};
	
			_this.getFavoritResearchPanel = function (selections) {
				var favoriteResearch = (0, _lodash.filter)(selections, function (o) {
					return o.favorite;
				});
				if (favoriteResearch.length) {
					var lastSelectionTitle = (0, _StringUtils.getPlurial)(_simpleReactI18n2.default.favoriteResearch, _simpleReactI18n2.default.favoriteResearchs, favoriteResearch);
					if (favoriteResearch.length > 5) {
						return _react2.default.createElement(
							'div',
							{ className: 'col s12 no-padding' },
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col s12 center-align white-filter-fill' },
									_react2.default.createElement(
										'h4',
										null,
										_react2.default.createElement(
											'span',
											null,
											lastSelectionTitle
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ id: 'favoritSelection', className: 'col s12 no-padding white-filter' },
									_react2.default.createElement(
										'div',
										{ className: 'col s12 no-padding' },
										_react2.default.createElement(
											'div',
											{ className: 'row' },
											_react2.default.createElement(_AgGridTable2.default, { datas: favoriteResearch, type: new _DtoSelectionRow2.default({}),
												cellHeight: 45 })
										)
									)
								)
							)
						);
					}
					return _react2.default.createElement(
						'div',
						{ className: 'col s12 no-padding' },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col s12 center-align white-filter-fill' },
								_react2.default.createElement(
									'h4',
									null,
									_react2.default.createElement(
										'span',
										null,
										lastSelectionTitle
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: 'favoritSelection', className: 'col s12 no-padding white-filter' },
								_react2.default.createElement(
									'div',
									{ className: 'row no-margin' },
									_react2.default.createElement(
										'div',
										{ className: 'col s12 offset-s1 no-padding ' },
										_react2.default.createElement(
											'div',
											{ className: 'row no-margin ' },
											_this.getSelectionsPanel(favoriteResearch)
										)
									)
								)
							)
						)
					);
				}
				return null;
			};
	
			_this.state = {
				selectedValues: [],
				idModal: _uuid2.default.v4()
			};
			return _this;
		}
	
		_createClass(SelectionsPanel, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				if (!this.props.selectionStatus.length) {
					_AppStore2.default.dispatch(_SelectionAction2.default.fetchSelectionStatus());
				}
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps) {
				return !(0, _lodash.isEqual)(this.props.selections, nextProps.selections) || !(0, _lodash.isEqual)(this.props.selectionSites, nextProps.selectionSites) || !(0, _lodash.isEqual)(this.props.selectionFilters, nextProps.selectionFilters) || !(0, _lodash.isEqual)(this.props.filterValues, nextProps.filterValues) || !(0, _lodash.isEqual)(this.props.filterTypes, nextProps.filterTypes) || !(0, _lodash.isEqual)(this.props.selectionDetailsSites, nextProps.selectionDetailsSites) || !(0, _lodash.isEqual)(this.props.siteTypes, nextProps.siteTypes) || !(0, _lodash.isEqual)(this.props.themes, nextProps.themes) || !(0, _lodash.isEqual)(this.props.selectionKeyFigures, nextProps.selectionKeyFigures) || !(0, _lodash.isEqual)(this.props.selectionExportsHistory, nextProps.selectionExportsHistory) || !(0, _lodash.isEqual)(this.props.selectionWatershed, nextProps.selectionWatershed) || !(0, _lodash.isEqual)(this.props.selectionStatus, nextProps.selectionStatus) || !(0, _lodash.isEqual)(this.props.cities, nextProps.cities) || !(0, _lodash.isEqual)(this.props.watersheds, nextProps.watersheds) || !(0, _lodash.isEqual)(this.props.managementWaters, nextProps.managementWaters);
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				$('.tooltipped').tooltip({ delay: 50 });
			}
		}, {
			key: 'render',
			value: function render() {
				var loadingValue = this.getAllInformations();
				if (loadingValue === '100') {
					var selections = this.getSelections();
					var saveSelectionTitle = (0, _StringUtils.getPlurial)(_simpleReactI18n2.default.saveResearch, _simpleReactI18n2.default.saveResearchs, selections);
					if (selections && selections.length) {
						return _react2.default.createElement(
							'div',
							{ className: 'row no-margin' },
							_react2.default.createElement(_SelectionInformationModal2.default, null),
							_react2.default.createElement(_SelectionDeleteModal2.default, null),
							_react2.default.createElement(_SelectionExportModal2.default, null),
							this.getFavoritResearchPanel(selections),
							_react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'div',
									{ className: 'col s12 center-align white-filter-fill' },
									_react2.default.createElement(
										'h4',
										null,
										_react2.default.createElement(
											'span',
											null,
											saveSelectionTitle
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col s12 z-depth-3 white-filter', style: { marginBottom: '6rem' } },
									_react2.default.createElement(
										'div',
										{ className: 'row no-margin' },
										_react2.default.createElement(
											'div',
											{ className: 'col s12 no-padding', style: { marginBottom: '10px' } },
											_react2.default.createElement(_IndicatorPanel2.default, { datas: this.getKeyfigures() })
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'row no-margin' },
										_react2.default.createElement(_AgGridTable2.default, { datas: selections, type: new _DtoSelectionRow2.default({}),
											cellHeight: 45 })
									)
								)
							)
						);
					}
				}
				return _react2.default.createElement(_LoadingPanel2.default, { title: loadingValue });
			}
		}]);
	
		return SelectionsPanel;
	}(_react.Component);
	
	SelectionsPanel.propTypes = {
		selections: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoSelection2.default)),
		selectionSites: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoSelectionSite2.default)),
		selectionFilters: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoSelectionFilter2.default)),
		filterValues: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoFilter2.default)),
		filterTypes: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoFilterType2.default)),
		selectionDetailsSites: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoSelectionDetailSite2.default)),
		siteTypes: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoSiteType2.default)),
		themes: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_ThemeDto2.default)),
		selectionKeyFigures: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoKeyFigures2.default)),
		selectionExportsHistory: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoSelectionExportHistory2.default)),
		selectionWatershed: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoSelectionWatershed2.default)),
		selectionStatus: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoSelectionStatus2.default)),
		cities: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoCity2.default)),
		departments: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoDepartment2.default)),
		watersheds: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoWatershed2.default)),
		managementWaters: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoManagementWater2.default))
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			selectionSites: store.SelectionReducer.selectionSites,
			selectionFilters: store.SelectionReducer.selectionFilters,
			filterValues: store.SelectionReducer.filterValues,
			filterTypes: store.ReferentialReducer.filterTypes,
			siteTypes: store.ReferentialReducer.siteTypes,
			selectionDetailsSites: store.SelectionReducer.selectionDetailsSites,
			themes: store.AdministrationReducer.themes,
			selectionKeyFigures: store.SelectionReducer.selectionKeyFigures,
			selectionExportsHistory: store.SelectionReducer.selectionExportsHistory,
			selectionWatershed: store.SelectionReducer.selectionWatershed,
			selectionStatus: store.SelectionReducer.selectionStatus,
			cities: store.ReferentialReducer.cities,
			departments: store.ReferentialReducer.departments,
			watersheds: store.ReferentialReducer.watersheds,
			managementWaters: store.ReferentialReducer.managementWaters
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(SelectionsPanel);

/***/ },
/* 2123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _DtoDashboardSite2 = __webpack_require__(375);
	
	var _DtoDashboardSite3 = _interopRequireDefault(_DtoDashboardSite2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DtoPollutedSoil = function (_DtoDashboardSite) {
		_inherits(DtoPollutedSoil, _DtoDashboardSite);
	
		function DtoPollutedSoil(obj) {
			_classCallCheck(this, DtoPollutedSoil);
	
			var _this = _possibleConstructorReturn(this, (DtoPollutedSoil.__proto__ || Object.getPrototypeOf(DtoPollutedSoil)).call(this, obj));
	
			_this.headers = ['code', 'name', 'city'];
			return _this;
		}
	
		return DtoPollutedSoil;
	}(_DtoDashboardSite3.default);
	
	exports.default = DtoPollutedSoil;

/***/ },
/* 2124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _DtoDashboardSite2 = __webpack_require__(375);
	
	var _DtoDashboardSite3 = _interopRequireDefault(_DtoDashboardSite2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DtoPiezometer = function (_DtoDashboardSite) {
		_inherits(DtoPiezometer, _DtoDashboardSite);
	
		function DtoPiezometer(obj) {
			_classCallCheck(this, DtoPiezometer);
	
			var _this = _possibleConstructorReturn(this, (DtoPiezometer.__proto__ || Object.getPrototypeOf(DtoPiezometer)).call(this, obj));
	
			_this.numberOfMeasure = '';
			_this.firstDate = '';
			_this.lastDate = '';
			_this.lastMeasure = '';
			_this.headers = ['code', 'name', 'city', 'numberOfMeasure', 'firstDate', 'lastDate', 'lastMeasure'];
			return _this;
		}
	
		return DtoPiezometer;
	}(_DtoDashboardSite3.default);
	
	exports.default = DtoPiezometer;

/***/ },
/* 2125 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DtoPiezometerKeyFigure = function DtoPiezometerKeyFigure(obj) {
		_classCallCheck(this, DtoPiezometerKeyFigure);
	
		this.piezometerId = obj.stationid;
		this.nbmeasure = obj.nbmeasure;
		this.lastdate = obj.lastdate;
		this.firstdate = obj.firstdate;
		this.lastvalue = obj.lastvalue;
	};
	
	exports.default = DtoPiezometerKeyFigure;

/***/ },
/* 2126 */
2123,
/* 2127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _DtoDashboardSite2 = __webpack_require__(375);
	
	var _DtoDashboardSite3 = _interopRequireDefault(_DtoDashboardSite2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DtoQualitometer = function (_DtoDashboardSite) {
		_inherits(DtoQualitometer, _DtoDashboardSite);
	
		function DtoQualitometer(obj) {
			_classCallCheck(this, DtoQualitometer);
	
			var _this = _possibleConstructorReturn(this, (DtoQualitometer.__proto__ || Object.getPrototypeOf(DtoQualitometer)).call(this, obj));
	
			_this.nbOperation = '';
			_this.nbAnalysis = '';
			_this.firstDate = '';
			_this.lastDate = '';
			_this.headers = ['code', 'name', 'city', 'nbOperation', 'nbAnalysis', 'firstDate', 'lastDate'];
			return _this;
		}
	
		return DtoQualitometer;
	}(_DtoDashboardSite3.default);
	
	exports.default = DtoQualitometer;

/***/ },
/* 2128 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DtoPiezometerKeyFigure = function DtoPiezometerKeyFigure(obj) {
		_classCallCheck(this, DtoPiezometerKeyFigure);
	
		this.qualitometerId = obj.stationid;
		this.nbAnalysis = obj.nbanalysis;
		this.analysisFirstDate = obj.analysisfirstdate;
		this.analysisLastDate = obj.analysislastdate;
		this.nbOperation = obj.nboperations;
		this.operationFirstDate = obj.operationfirstdate;
		this.operationLastDate = obj.operationlastdate;
	};
	
	exports.default = DtoPiezometerKeyFigure;

/***/ },
/* 2129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.store = undefined;
	exports.DashboardReducer = DashboardReducer;
	
	var _DashboardConstants = __webpack_require__(1024);
	
	var _DtoPiezometer = __webpack_require__(2124);
	
	var _DtoPiezometer2 = _interopRequireDefault(_DtoPiezometer);
	
	var _DtoQualitometer = __webpack_require__(2127);
	
	var _DtoQualitometer2 = _interopRequireDefault(_DtoQualitometer);
	
	var _DtoPollutedSoil = __webpack_require__(2126);
	
	var _DtoPollutedSoil2 = _interopRequireDefault(_DtoPollutedSoil);
	
	var _DtoIndustrialSite = __webpack_require__(2123);
	
	var _DtoIndustrialSite2 = _interopRequireDefault(_DtoIndustrialSite);
	
	var _lodash = __webpack_require__(15);
	
	var _DtoPiezometerKeyFigure = __webpack_require__(2125);
	
	var _DtoPiezometerKeyFigure2 = _interopRequireDefault(_DtoPiezometerKeyFigure);
	
	var _DtoQualitometerKeyFigure = __webpack_require__(2128);
	
	var _DtoQualitometerKeyFigure2 = _interopRequireDefault(_DtoQualitometerKeyFigure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DashboardReducer() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		var action = arguments[1];
	
		switch (action.type) {
			case _DashboardConstants.RECEIVE_PIEZOMETER:
				{
					return Object.assign({}, state, {
						piezometers: action.piezometers.map(function (el) {
							return new _DtoPiezometer2.default(el);
						}),
						userSite: (0, _lodash.uniqWith)([].concat(action.piezometers.map(function (el) {
							return { id: el.idstation };
						}), state.userSite), _lodash.isEqual)
					});
				}
			case _DashboardConstants.RECEIVE_QUALITOMETER:
				{
					return Object.assign({}, state, {
						qualitometers: action.qualitometers.map(function (el) {
							return new _DtoQualitometer2.default(el);
						}),
						userSite: (0, _lodash.uniqWith)([].concat(action.qualitometers.map(function (el) {
							return { id: el.idstation };
						}), state.userSite), _lodash.isEqual)
					});
				}
			case _DashboardConstants.RECEIVE_SURFACE_QUALITOMETER:
				{
					return Object.assign({}, state, {
						qualitometersSurface: action.qualitometersSurface.map(function (el) {
							return new _DtoQualitometer2.default(el);
						}),
						userSite: (0, _lodash.uniqWith)([].concat(action.qualitometersSurface.map(function (el) {
							return { id: el.idstation };
						}), state.userSite), _lodash.isEqual)
					});
				}
			case _DashboardConstants.RECEIVE_POLLUTED_SOIL:
				{
					return Object.assign({}, state, {
						pollutedSoil: action.pollutedSoil.map(function (el) {
							return new _DtoPollutedSoil2.default(el);
						}),
						userSite: (0, _lodash.uniqWith)([].concat(action.pollutedSoil.map(function (el) {
							return { id: el.idstation };
						}), state.userSite), _lodash.isEqual)
					});
				}
			case _DashboardConstants.RECEIVE_INDUSTRIAL_SITE:
				{
					return Object.assign({}, state, {
						industrialSites: action.industrialSites.map(function (el) {
							return new _DtoIndustrialSite2.default(el);
						}),
						userSite: (0, _lodash.uniqWith)([].concat(action.industrialSites.map(function (el) {
							return { id: el.idstation };
						}), state.userSite), _lodash.isEqual)
					});
				}
			case _DashboardConstants.ADD_PIEZOMETER_KEY_FIGURE:
				{
					return Object.assign({}, state, {
						piezometerKeyFigures: (0, _lodash.uniqWith)([].concat(action.piezometerKeyFigures.map(function (el) {
							return new _DtoPiezometerKeyFigure2.default(el);
						}), state.piezometerKeyFigures), _lodash.isEqual)
					});
				}
			case _DashboardConstants.ADD_QUALITOMETER_KEY_FIGURE:
				{
					return Object.assign({}, state, {
						qualitometerKeyFigures: (0, _lodash.uniqWith)([].concat(action.qualitometerKeyFigures.map(function (el) {
							return new _DtoQualitometerKeyFigure2.default(el);
						}), state.qualitometerKeyFigures), _lodash.isEqual)
					});
				}
			case _DashboardConstants.RESET_USER_STATION:
				{
					return Object.assign({}, state, {
						qualitometers: [],
						piezometers: [],
						hydrometrics: [],
						pluviometers: [],
						pickupoperations: [],
						pluvioMeasures: [],
						piezometerMeasures: [],
						qualitometersSurface: [],
						hydroMeasures: [],
						pollutedSoil: [],
						industrialSites: [],
						analysis: [],
						cities: [],
						piezometerKeyFigures: [],
						qualitometerKeyFigures: [],
						userSite: []
					});
				}
			default:
				return state;
		}
	}
	
	var store = exports.store = {
		qualitometers: [],
		piezometers: [],
		hydrometrics: [],
		pluviometers: [],
		pickupoperations: [],
		pluvioMeasures: [],
		piezometerMeasures: [],
		qualitometersSurface: [],
		hydroMeasures: [],
		pollutedSoil: [],
		industrialSites: [],
		analysis: [],
		piezometerKeyFigures: [],
		qualitometerKeyFigures: [],
		userSite: []
	};

/***/ },
/* 2130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.store = undefined;
	exports.SelectionReducer = SelectionReducer;
	
	var _SelectionConstants = __webpack_require__(529);
	
	var _DtoSelection = __webpack_require__(181);
	
	var _DtoSelection2 = _interopRequireDefault(_DtoSelection);
	
	var _DtoSelectionSite = __webpack_require__(1027);
	
	var _DtoSelectionSite2 = _interopRequireDefault(_DtoSelectionSite);
	
	var _DtoSelectionFilter = __webpack_require__(1026);
	
	var _DtoSelectionFilter2 = _interopRequireDefault(_DtoSelectionFilter);
	
	var _DtoFilter = __webpack_require__(530);
	
	var _DtoFilter2 = _interopRequireDefault(_DtoFilter);
	
	var _lodash = __webpack_require__(15);
	
	var _DtoSelectionDetailSite = __webpack_require__(538);
	
	var _DtoSelectionDetailSite2 = _interopRequireDefault(_DtoSelectionDetailSite);
	
	var _DtoKeyFigures = __webpack_require__(98);
	
	var _DtoKeyFigures2 = _interopRequireDefault(_DtoKeyFigures);
	
	var _DtoSelectionExportHistory = __webpack_require__(531);
	
	var _DtoSelectionExportHistory2 = _interopRequireDefault(_DtoSelectionExportHistory);
	
	var _DtoSelectionWatershed = __webpack_require__(1028);
	
	var _DtoSelectionWatershed2 = _interopRequireDefault(_DtoSelectionWatershed);
	
	var _DtoSelectionStatus = __webpack_require__(532);
	
	var _DtoSelectionStatus2 = _interopRequireDefault(_DtoSelectionStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var store = exports.store = {
		selections: [],
		selectionSites: [],
		selectionFilters: [],
		filterValues: [],
		selectionDetailsSites: [],
		selectedSelection: undefined,
		selectionKeyFigures: [],
		selectionExportsHistory: [],
		selectionWatershed: [],
		selectionStatus: [],
		selectedSelectionInformation: undefined,
		modalSelectionInformation: false,
		modalSelectionDelete: false,
		modalSelectionExport: false,
		modalSelectionSave: false,
		selectedExportSelections: []
	};
	
	function SelectionReducer() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		var action = arguments[1];
	
		switch (action.type) {
			case _SelectionConstants.RECEIVE_ALL_SELECTIONS:
				{
					return Object.assign({}, state, {
						selections: (0, _lodash.uniqWith)([].concat(action.selections.map(function (el) {
							return new _DtoSelection2.default(el);
						}), state.selections), function (a, b) {
							return a.id === b.id;
						})
					});
				}
			case _SelectionConstants.RECEIVE_SELECTIONS_SITES:
				{
					return Object.assign({}, state, {
						selectionSites: (0, _lodash.uniqWith)([].concat(action.selectionSites.map(function (el) {
							return new _DtoSelectionSite2.default(el);
						}), state.selectionSites), function (a, b) {
							return a.selectionId === b.selectionId && a.siteId === b.siteId;
						})
					});
				}
			case _SelectionConstants.RECEIVE_SELECTIONS_FILTERS:
				{
					return Object.assign({}, state, {
						selectionFilters: (0, _lodash.uniqWith)([].concat(action.selectionFilters.map(function (el) {
							return new _DtoSelectionFilter2.default(el);
						}), state.selectionFilters), function (a, b) {
							return a.filterId === b.filterId && a.selectionId === b.selectionId;
						})
					});
				}
			case _SelectionConstants.RECEIVE_FILTERS_VALUES:
				{
					return Object.assign({}, state, {
						filterValues: (0, _lodash.uniqWith)([].concat(action.filterValues.map(function (el) {
							return new _DtoFilter2.default(el);
						}), state.filterValues), function (a, b) {
							return a.id === b.id;
						})
					});
				}
			case _SelectionConstants.RECEIVE_SELECTIONS_DETAIL_SITES:
				{
					return Object.assign({}, state, {
						selectionDetailsSites: (0, _lodash.uniqWith)([].concat(action.selectionDetailsSites.map(function (el) {
							return new _DtoSelectionDetailSite2.default(el);
						}), state.selectionDetailsSites), function (a, b) {
							return a.id === b.id;
						})
					});
				}
			case _SelectionConstants.SELECTED_SELECTION:
				{
					return Object.assign({}, state, {
						selectedSelection: action.selectedSelection
					});
				}
			case _SelectionConstants.RECEIVE_SELECTIONS_KEY_FIGURES:
				{
					return Object.assign({}, state, {
						selectionKeyFigures: (0, _lodash.uniqWith)([].concat(action.selectionKeyFigures.map(function (el) {
							return new _DtoKeyFigures2.default(el);
						}), state.selectionKeyFigures), function (a, b) {
							return a.id === b.id && a.typeId === b.typeId;
						})
					});
				}
			case _SelectionConstants.RECEIVE_SELECTIONS_EXPORT_HISTORY:
				{
					return Object.assign({}, state, {
						selectionExportsHistory: (0, _lodash.uniqWith)([].concat(action.selectionExportsHistory.map(function (el) {
							return new _DtoSelectionExportHistory2.default(el);
						}), state.selectionExportsHistory), function (a, b) {
							return a.id === b.id;
						})
					});
				}
			case _SelectionConstants.RECEIVE_SELECTIONS_WATERSHED:
				{
					return Object.assign({}, state, {
						selectionWatershed: (0, _lodash.uniqWith)([].concat(action.selectionWatershed.map(function (el) {
							return new _DtoSelectionWatershed2.default(el);
						}), state.selectionWatershed), function (a, b) {
							return a.selectionId === b.selectionId && a.watershedId === b.watershedId;
						})
					});
				}
			case _SelectionConstants.RECEIVE_SELECTIONS_STATUS:
				{
					return Object.assign({}, state, {
						selectionStatus: action.selectionStatus.map(function (el) {
							return new _DtoSelectionStatus2.default(el);
						})
					});
				}
			case _SelectionConstants.RECEIVE_SELECTED_EXPORT_SELECTIONS:
				{
					return Object.assign({}, state, {
						selectedExportSelections: action.selectedExportSelections
					});
				}
			case _SelectionConstants.RESET_SELECTED_EXPORT_SELECTIONS:
				{
					return Object.assign({}, state, {
						selectedExportSelections: []
					});
				}
			case _SelectionConstants.RECEIVE_DELETE_SELECTION:
				{
					var selectionId = action.selectionId;
					var selections = state.selections.map(function (o) {
						if (o.id === selectionId) {
							return Object.assign({}, o, {
								close: true
							});
						}
						return o;
					});
					return Object.assign({}, state, {
						selections: selections
					});
				}
			case _SelectionConstants.RECEIVE_FAVORITE_SELECTION:
				{
					var _selectionId = action.selectionId;
					var copySelection = state.selections.slice();
					var _selections = copySelection.map(function (o) {
						if (o.id === _selectionId) {
							return Object.assign({}, o, {
								favorite: true
							});
						}
						return o;
					});
					return Object.assign({}, state, {
						selections: _selections
					});
				}
			case _SelectionConstants.RECEIVE_REMOVE_FAVORITE_SELECTION:
				{
					var _selectionId2 = action.selectionId;
					var _copySelection = state.selections.slice();
					var _selections2 = _copySelection.map(function (o) {
						if (o.id === _selectionId2) {
							return Object.assign({}, o, {
								favorite: false
							});
						}
						return o;
					});
					return Object.assign({}, state, {
						selections: _selections2
					});
				}
			case _SelectionConstants.RESET_SELECTED_SELECTION:
				{
					return Object.assign({}, state, {
						selectedSelection: undefined
					});
				}
			case _SelectionConstants.RESET_USER_SELECTION:
				{
					return Object.assign({}, state, store);
				}
			case _SelectionConstants.RECEIVE_AND_SELECT_SELECTION:
				{
					var selection = new _DtoSelection2.default(Object.assign({}, action.selection));
					var _selections3 = state.selections.slice();
					var i = _selections3.findIndex(function (s) {
						return s.id === selection.id;
					});
					if (i === -1) {
						_selections3.push(selection);
					} else {
						_selections3[i] = selection;
					}
					return Object.assign({}, {
						selections: _selections3
					}, state);
				}
			case _SelectionConstants.RESET_SELECTION_INFORMATIONS:
				{
					var _selectionId3 = action.selection;
					var copyOfSelectionSites = (0, _lodash.remove)(state.selectionSites, function (o) {
						return o.selectionId === _selectionId3;
					});
					var copyOfSelectionFilters = (0, _lodash.remove)(state.selectionFilters, function (o) {
						return o.selectionId === _selectionId3;
					});
	
					return Object.assign({}, state, {
						selectionSites: copyOfSelectionSites,
						selectionFilters: copyOfSelectionFilters
					});
				}
			case _SelectionConstants.SELECTED_SELECTION_INFORMATION:
				{
					return Object.assign({}, state, {
						selectedSelectionInformation: action.selectedSelectionInformation
					});
				}
			case _SelectionConstants.RESET_SELECTED_SELECTION_INFORMATION:
				{
					return Object.assign({}, state, {
						selectedSelectionInformation: undefined,
						modalSelectionInformation: false,
						modalSelectionDelete: false
					});
				}
			case _SelectionConstants.OPEN_MODAL_SELECTED_SELECTION_INFORMATION:
				{
					return Object.assign({}, state, {
						modalSelectionInformation: true,
						selectedSelectionInformation: action.selectedSelectionInformation
					});
				}
			case _SelectionConstants.OPEN_MODAL_SELECTED_SELECTION_DELETE:
				{
					return Object.assign({}, state, {
						selectedSelectionInformation: action.selectedSelectionInformation,
						modalSelectionDelete: true
					});
				}
			case _SelectionConstants.OPEN_MODAL_SELECTED_SELECTION_EXPORT:
				{
					return Object.assign({}, state, {
						modalSelectionExport: true,
						selectedSelectionInformation: action.selectedSelectionInformation
					});
				}
			case _SelectionConstants.OPEN_MODAL_SELECTED_SELECTION_SAVE:
				{
					return Object.assign({}, state, {
						selectedSelectionInformation: action.selectedSelectionInformation,
						modalSelectionSave: true
					});
				}
			case _SelectionConstants.CLOSE_MODAL_SELECTED_SELECTION_INFORMATION:
				{
					return Object.assign({}, state, {
						modalSelectionInformation: false,
						selectedSelectionInformation: undefined
					});
				}
			case _SelectionConstants.CLOSE_MODAL_SELECTED_SELECTION_DELETE:
				{
					return Object.assign({}, state, {
						modalSelectionDelete: false,
						selectedSelectionInformation: undefined
					});
				}
			case _SelectionConstants.CLOSE_MODAL_SELECTED_SELECTION_EXPORT:
				{
					return Object.assign({}, state, {
						modalSelectionExport: false,
						selectedSelectionInformation: undefined
					});
				}
			case _SelectionConstants.CLOSE_MODAL_SELECTED_SELECTION_SAVE:
				{
					return Object.assign({}, state, {
						modalSelectionSave: false,
						selectedSelectionInformation: undefined
					});
				}
			default:
				return state;
		}
	}

/***/ },
/* 2131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _findPasswordPanel = __webpack_require__(2132);
	
	var _findPasswordPanel2 = _interopRequireDefault(_findPasswordPanel);
	
	var _reactAquasys = __webpack_require__(49);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _reactRedux = __webpack_require__(18);
	
	var _findPasswordAction = __webpack_require__(1029);
	
	var _findPasswordAction2 = _interopRequireDefault(_findPasswordAction);
	
	var _Snackbar = __webpack_require__(192);
	
	var _Snackbar2 = _interopRequireDefault(_Snackbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FindPasswordApp = function (_Component) {
		_inherits(FindPasswordApp, _Component);
	
		function FindPasswordApp(props) {
			_classCallCheck(this, FindPasswordApp);
	
			var _this = _possibleConstructorReturn(this, (FindPasswordApp.__proto__ || Object.getPrototypeOf(FindPasswordApp)).call(this, props));
	
			_this.putMessage = function (value) {
				_AppStore2.default.dispatch(_findPasswordAction2.default.addMessage(value));
			};
	
			_this.handleRequestClose = function () {
				_AppStore2.default.dispatch(_findPasswordAction2.default.resetMessage());
			};
	
			return _this;
		}
	
		_createClass(FindPasswordApp, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ id: 'find-email-page' },
					_react2.default.createElement(
						'div',
						{ className: 'container-div valign-wrapper' },
						_react2.default.createElement(
							'div',
							{ className: 'container-panel' },
							_react2.default.createElement(
								'div',
								{ className: 'container' },
								_react2.default.createElement(
									'div',
									{ className: 'row' },
									_react2.default.createElement(
										'div',
										{ className: 'col s8 m8 l6 offset-m3 offset-l4' },
										_react2.default.createElement(
											'div',
											{ className: 'row' },
											_react2.default.createElement(_findPasswordPanel2.default, { putMessage: this.putMessage })
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(_reactAquasys.Toastr, { store: _AppStore2.default }),
					_react2.default.createElement(_Snackbar2.default, {
						open: this.props.open,
						message: this.props.message,
						autoHideDuration: 2000,
						onRequestClose: this.handleRequestClose,
						bodyStyle: { backgroundColor: '#FF0000', color: 'white' },
						style: { backgroundColor: '#FF0000', color: 'white' },
						contentStyle: { backgroundColor: '#FF0000', color: 'white' }
					}),
					_react2.default.createElement(_reactAquasys.Wait, null)
				);
			}
		}]);
	
		return FindPasswordApp;
	}(_react.Component);
	
	FindPasswordApp.propTypes = {
		open: _propTypes2.default.bool,
		message: _propTypes2.default.string
	};
	var mapStateToProps = function mapStateToProps(props) {
		return {
			open: props.InitPasswordReducer.open,
			message: props.InitPasswordReducer.message,
			error: props.InitPasswordReducer.error
		};
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(FindPasswordApp);

/***/ },
/* 2132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterRedux = __webpack_require__(43);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _findPasswordAction = __webpack_require__(1029);
	
	var _findPasswordAction2 = _interopRequireDefault(_findPasswordAction);
	
	var _reactRedux = __webpack_require__(18);
	
	var _HomeConstants = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var findPasswordPanel = function (_Component) {
		_inherits(findPasswordPanel, _Component);
	
		function findPasswordPanel(props) {
			_classCallCheck(this, findPasswordPanel);
	
			var _this = _possibleConstructorReturn(this, (findPasswordPanel.__proto__ || Object.getPrototypeOf(findPasswordPanel)).call(this, props));
	
			_this.onValid = function () {
				if (!_this.state.email) {
					_this.props.putMessage(_simpleReactI18n2.default.error.mail);
				} else {
					_AppStore2.default.dispatch(_findPasswordAction2.default.findemail(_this.state));
					_this.props.putMessage(_simpleReactI18n2.default.findEmailSuccess);
				}
			};
	
			_this.onChangeValue = function (key, value) {
				var actualState = Object.assign({}, _this.state);
				actualState[key] = value.trim();
				_this.setState(actualState);
			};
	
			_this.disableCopyPaste = function (event) {
				event.preventDefault();
			};
	
			_this.getContactPanel = function () {
				if (_this.props.error) {
					return _react2.default.createElement(
						'div',
						{ id: 'notfind', className: 'col l12 m10 s10 offset-m1 offset-s1 padding-bottom-10 center-align ' },
						_react2.default.createElement(
							'a',
							{ onClick: function onClick() {
									return _AppStore2.default.dispatch((0, _reactRouterRedux.push)(_HomeConstants.PATH_HOME));
								} },
							_simpleReactI18n2.default.error.notRegister
						)
					);
				}
				return null;
			};
	
			_this.state = {
				email: ''
			};
			return _this;
		}
	
		_createClass(findPasswordPanel, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement('script', { src: 'https://www.google.com/recaptcha/enterprise.js?render=6LcTYUgfAAAAAA9q3nt1a0dqplRNZOXX7Z5oVcfy' }),
					_react2.default.createElement(
						'script',
						null,
						'function onSubmit(token) ',
						this.onValid()
					),
					_react2.default.createElement(
						'div',
						{ className: 'card no-margin z-depth-1 radius10' },
						_react2.default.createElement(
							'div',
							{ className: 'card-content no-padding row no-margin cardLogin' },
							_react2.default.createElement(
								'form',
								{ id: 'myform' },
								_react2.default.createElement(
									'div',
									{ className: 'row no-margin' },
									_react2.default.createElement(
										'div',
										{ className: 'input-field col s12 center' },
										_react2.default.createElement('img', { src: 'https://www.aquasys.fr/wp-content/uploads/2017/10/AquaDB-grand.png',
											alt: 'logo AquaDB',
											width: '70px', className: 'z-depth-1' })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'row no-margin' },
									_react2.default.createElement(
										'div',
										{ className: 'col s12' },
										_react2.default.createElement(
											'label',
											{ htmlFor: 'mail', className: 'valign-wrapper black-text' },
											_react2.default.createElement(
												'i',
												{ className: 'material-icons' },
												'person'
											),
											_simpleReactI18n2.default.mail
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col s12' },
										_react2.default.createElement('input', { ref: 'email', id: 'mail', type: 'text', className: 'validate', required: true,
											value: this.state.login,
											onChange: function onChange(e) {
												return _this2.onChangeValue('email', e.target.value);
											} })
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'col l12 m10 s10 offset-m1 offset-s1 padding-bottom-10' },
								_react2.default.createElement(
									'button',
									{ 'data-sitekey': 'site_key', 'data-callback': 'onSubmit', 'data-action': 'submit',
										className: 'g-recaptcha waves-effect col l12 m12 s12 waves-light btn' },
									_simpleReactI18n2.default.validate
								)
							),
							_react2.default.createElement(
								'div',
								null,
								this.getContactPanel()
							)
						)
					)
				);
			}
		}]);
	
		return findPasswordPanel;
	}(_react.Component);
	
	findPasswordPanel.propTypes = {
		putMessage: _propTypes2.default.func,
		error: _propTypes2.default.bool
	};
	
	var mapStateToProps = function mapStateToProps(props) {
		return {
			error: props.InitPasswordReducer.error
		};
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(findPasswordPanel);

/***/ },
/* 2133 */
1035,
/* 2134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _HomeAction = __webpack_require__(52);
	
	var _HomeAction2 = _interopRequireDefault(_HomeAction);
	
	var _SideNav = __webpack_require__(2138);
	
	var _SideNav2 = _interopRequireDefault(_SideNav);
	
	var _Header = __webpack_require__(2135);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Help = __webpack_require__(2136);
	
	var _Help2 = _interopRequireDefault(_Help);
	
	var _reactAquasys = __webpack_require__(49);
	
	var _DtoUnit = __webpack_require__(383);
	
	var _DtoUnit2 = _interopRequireDefault(_DtoUnit);
	
	var _DtoSiteType = __webpack_require__(96);
	
	var _DtoSiteType2 = _interopRequireDefault(_DtoSiteType);
	
	var _DtoFilterType = __webpack_require__(130);
	
	var _DtoFilterType2 = _interopRequireDefault(_DtoFilterType);
	
	var _DtoCity = __webpack_require__(87);
	
	var _DtoCity2 = _interopRequireDefault(_DtoCity);
	
	var _DtoParameter = __webpack_require__(224);
	
	var _DtoParameter2 = _interopRequireDefault(_DtoParameter);
	
	var _DtoStandardCodification = __webpack_require__(225);
	
	var _DtoStandardCodification2 = _interopRequireDefault(_DtoStandardCodification);
	
	var _DtoSupport = __webpack_require__(150);
	
	var _DtoSupport2 = _interopRequireDefault(_DtoSupport);
	
	var _DtoRemark = __webpack_require__(285);
	
	var _DtoRemark2 = _interopRequireDefault(_DtoRemark);
	
	var _ReferentialAction = __webpack_require__(380);
	
	var _ReferentialAction2 = _interopRequireDefault(_ReferentialAction);
	
	var _DtoWatershed = __webpack_require__(183);
	
	var _DtoWatershed2 = _interopRequireDefault(_DtoWatershed);
	
	var _DtoSimpleStation = __webpack_require__(382);
	
	var _DtoSimpleStation2 = _interopRequireDefault(_DtoSimpleStation);
	
	var _CreditAction = __webpack_require__(376);
	
	var _CreditAction2 = _interopRequireDefault(_CreditAction);
	
	var _DtoCreditType = __webpack_require__(533);
	
	var _DtoCreditType2 = _interopRequireDefault(_DtoCreditType);
	
	var _DtoUserCredit = __webpack_require__(284);
	
	var _DtoUserCredit2 = _interopRequireDefault(_DtoUserCredit);
	
	var _DtoUser = __webpack_require__(54);
	
	var _DtoUser2 = _interopRequireDefault(_DtoUser);
	
	var _SelectionAction = __webpack_require__(95);
	
	var _SelectionAction2 = _interopRequireDefault(_SelectionAction);
	
	var _DtoSelection = __webpack_require__(181);
	
	var _DtoSelection2 = _interopRequireDefault(_DtoSelection);
	
	var _DtoIndicatorType = __webpack_require__(537);
	
	var _DtoIndicatorType2 = _interopRequireDefault(_DtoIndicatorType);
	
	var _DtoIndicator = __webpack_require__(536);
	
	var _DtoIndicator2 = _interopRequireDefault(_DtoIndicator);
	
	var _Tutorial = __webpack_require__(2139);
	
	var _Tutorial2 = _interopRequireDefault(_Tutorial);
	
	var _DtoManagementWater = __webpack_require__(223);
	
	var _DtoManagementWater2 = _interopRequireDefault(_DtoManagementWater);
	
	var _MasterThemeDto = __webpack_require__(527);
	
	var _MasterThemeDto2 = _interopRequireDefault(_MasterThemeDto);
	
	var _AdministrationAction = __webpack_require__(61);
	
	var _AdministrationAction2 = _interopRequireDefault(_AdministrationAction);
	
	var _lodash = __webpack_require__(15);
	
	var _DtoSource = __webpack_require__(222);
	
	var _DtoSource2 = _interopRequireDefault(_DtoSource);
	
	var _DtoSelectionStatus = __webpack_require__(532);
	
	var _DtoSelectionStatus2 = _interopRequireDefault(_DtoSelectionStatus);
	
	var _CookiePanel = __webpack_require__(1019);
	
	var _CookiePanel2 = _interopRequireDefault(_CookiePanel);
	
	var _CookieUtils = __webpack_require__(545);
	
	var _LoginModal = __webpack_require__(2150);
	
	var _LoginModal2 = _interopRequireDefault(_LoginModal);
	
	var _DtoDepartment = __webpack_require__(381);
	
	var _DtoDepartment2 = _interopRequireDefault(_DtoDepartment);
	
	var _ToastrPanel = __webpack_require__(2115);
	
	var _ToastrPanel2 = _interopRequireDefault(_ToastrPanel);
	
	var _InformationPanel = __webpack_require__(2106);
	
	var _InformationPanel2 = _interopRequireDefault(_InformationPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = window.$;
	
	var AquadbApp = function (_Component) {
		_inherits(AquadbApp, _Component);
	
		function AquadbApp(props) {
			_classCallCheck(this, AquadbApp);
	
			var _this = _possibleConstructorReturn(this, (AquadbApp.__proto__ || Object.getPrototypeOf(AquadbApp)).call(this, props));
	
			_this.getLogged = function () {
				var token = sessionStorage.getItem('TOKEN');
				return !(!token || !atob(token));
			};
	
			_this.state = {
				login: '',
				header: 'Tableau de bord'
			};
			return _this;
		}
	
		_createClass(AquadbApp, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				_AppStore2.default.dispatch(_AdministrationAction2.default.fetchThemes());
				if (this.props.units.length === 0) {
					_AppStore2.default.dispatch(_ReferentialAction2.default.fetchUnits());
				}
				if (this.props.remarks.length === 0) {
					_AppStore2.default.dispatch(_ReferentialAction2.default.fetchRemarks());
				}
				if (this.props.standardCodifications.length === 0) {
					_AppStore2.default.dispatch(_ReferentialAction2.default.fetchStandardCodifications());
				}
				if (this.props.parameters.length === 0) {
					_AppStore2.default.dispatch(_ReferentialAction2.default.fetchParameters());
				}
				if (this.props.supports.length === 0) {
					_AppStore2.default.dispatch(_ReferentialAction2.default.fetchSupports());
				}
				if (this.props.cities.length === 0) {
					_AppStore2.default.dispatch(_ReferentialAction2.default.fetchCities());
				}
				if (this.props.departments.length === 0) {
					_AppStore2.default.dispatch(_ReferentialAction2.default.fetchDepartments());
				}
				if (this.props.filterTypes.length === 0) {
					_AppStore2.default.dispatch(_ReferentialAction2.default.fetchFilterTypes());
				}
				if (this.props.siteTypes.length === 0) {
					_AppStore2.default.dispatch(_ReferentialAction2.default.fetchSiteTypes());
				}
				if (this.props.indicatorTypes.length === 0) {
					_AppStore2.default.dispatch(_ReferentialAction2.default.fetchIndicatorTypes());
				}
				if (this.props.indicators.length === 0) {
					_AppStore2.default.dispatch(_ReferentialAction2.default.fetchIndicators());
				}
				if (!this.props.watersheds.length) {
					_AppStore2.default.dispatch(_ReferentialAction2.default.fetchWatersheds());
				}
				if (!this.props.stations.length && this.props.families.length) {
					var types = (0, _lodash.uniq)((0, _lodash.flattenDeep)(this.props.families.map(function (f) {
						var themes = f.themes.filter(function (t) {
							return !t.disable;
						});
						return themes.map(function (t) {
							return t.siteTypes.map(function (o) {
								return o.type;
							});
						});
					})));
					_AppStore2.default.dispatch(_ReferentialAction2.default.fetchSimpleStations(types));
				}
				if (!this.props.managementWaters.length) {
					_AppStore2.default.dispatch(_ReferentialAction2.default.fetchManagementWaters());
				}
				if (!this.props.creditTypes.length) {
					_AppStore2.default.dispatch(_CreditAction2.default.fetchCreditTypes());
				}
				if (!this.props.sources.length) {
					_AppStore2.default.dispatch(_AdministrationAction2.default.fetchSources());
				}
				if (!this.props.selectionStatus.length) {
					_AppStore2.default.dispatch(_SelectionAction2.default.fetchSelectionStatus());
				}
				if (this.getLogged()) {
					var token = sessionStorage.getItem('TOKEN');
					var login = atob(token);
					this.setState({ login: login });
					_AppStore2.default.dispatch(_HomeAction2.default.fetchUser(login));
					if (!this.props.selections.length) {
						_AppStore2.default.dispatch(_SelectionAction2.default.fetchSelections(login));
					}
					if (!this.props.userCredit.id) {
						_AppStore2.default.dispatch(_CreditAction2.default.fetchUserInitCredit(login));
					}
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (!this.props.stations.length && nextProps.families.length !== this.props.families.length && nextProps.families.length) {
					var types = (0, _lodash.uniq)((0, _lodash.flattenDeep)(nextProps.families.map(function (f) {
						var themes = f.themes.filter(function (t) {
							return !t.disable;
						});
						return themes.map(function (t) {
							return t.siteTypes.map(function (o) {
								return o.type;
							});
						});
					})));
					_AppStore2.default.dispatch(_ReferentialAction2.default.fetchSimpleStations(types));
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				$('.button-collapse').sideNav();
			}
		}, {
			key: 'render',
			value: function render() {
				var isLogged = this.getLogged();
				(0, _CookieUtils.putAnalyticsCookieUser)(this.props.user.login);
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'header',
						null,
						_react2.default.createElement(_Header2.default, { isLogged: isLogged }),
						_react2.default.createElement(_SideNav2.default, { isLogged: isLogged })
					),
					_react2.default.createElement(
						'main',
						null,
						this.props.children && _react2.default.cloneElement(this.props.children, {
							login: this.state.login, user: this.props.user, typeId: this.props.typeId, isLogged: isLogged
						}),
						_react2.default.createElement(_Help2.default, null)
					),
					_react2.default.createElement(_reactAquasys.Wait, null),
					_react2.default.createElement(_Tutorial2.default, { open: this.props.user.firstConnection }),
					_react2.default.createElement(_CookiePanel2.default, { user: this.props.user.login }),
					_react2.default.createElement(_LoginModal2.default, null),
					_react2.default.createElement(_ToastrPanel2.default, null),
					_react2.default.createElement(_InformationPanel2.default, null)
				);
			}
		}]);
	
		return AquadbApp;
	}(_react.Component);
	
	AquadbApp.propTypes = {
		children: _propTypes2.default.element,
		success: _propTypes2.default.string,
		error: _propTypes2.default.string,
		wait: _propTypes2.default.bool,
		typeId: _propTypes2.default.number,
		user: _propTypes2.default.instanceOf(_DtoUser2.default),
		units: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoUnit2.default)),
		remarks: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoRemark2.default)),
		supports: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoSupport2.default)),
		standardCodifications: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoStandardCodification2.default)),
		parameters: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoParameter2.default)),
		cities: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoCity2.default)),
		departments: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoDepartment2.default)),
		filterTypes: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoFilterType2.default)),
		siteTypes: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoSiteType2.default)),
		watersheds: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoWatershed2.default)),
		stations: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoSimpleStation2.default)),
		userCredit: _propTypes2.default.instanceOf(_DtoUserCredit2.default),
		creditTypes: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoCreditType2.default)),
		selections: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoSelection2.default)),
		indicatorTypes: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoIndicatorType2.default)),
		indicators: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoIndicator2.default)),
		managementWaters: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoManagementWater2.default)),
		families: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_MasterThemeDto2.default)),
		sources: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoSource2.default)),
		selectionStatus: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoSelectionStatus2.default))
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			success: store.HomeReducer.success,
			error: store.HomeReducer.error,
			wait: store.HomeReducer.wait,
			user: store.HomeReducer.user,
			units: store.ReferentialReducer.units,
			remarks: store.ReferentialReducer.remarks,
			supports: store.ReferentialReducer.supports,
			standardCodifications: store.ReferentialReducer.standardCodifications,
			parameters: store.ReferentialReducer.parameters,
			cities: store.ReferentialReducer.cities,
			departments: store.ReferentialReducer.departments,
			filterTypes: store.ReferentialReducer.filterTypes,
			siteTypes: store.ReferentialReducer.siteTypes,
			watersheds: store.ReferentialReducer.watersheds,
			stations: store.ReferentialReducer.stations,
			userCredit: store.CreditReducer.userCredit,
			creditTypes: store.CreditReducer.creditTypes,
			selections: store.SelectionReducer.selections,
			selectionStatus: store.SelectionReducer.selectionStatus,
			indicatorTypes: store.ReferentialReducer.indicatorTypes,
			indicators: store.ReferentialReducer.indicators,
			managementWaters: store.ReferentialReducer.managementWaters,
			families: store.AdministrationReducer.themes,
			sources: store.AdministrationReducer.sources
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(AquadbApp);

/***/ },
/* 2135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _DtoStation = __webpack_require__(88);
	
	var _DtoStation2 = _interopRequireDefault(_DtoStation);
	
	var _HomeConstants = __webpack_require__(53);
	
	var _reactRouterRedux = __webpack_require__(43);
	
	var _DtoPoint = __webpack_require__(86);
	
	var _DtoPoint2 = _interopRequireDefault(_DtoPoint);
	
	var _DtoUserRole = __webpack_require__(378);
	
	var _DtoUserRole2 = _interopRequireDefault(_DtoUserRole);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _HomeAction = __webpack_require__(52);
	
	var _HomeAction2 = _interopRequireDefault(_HomeAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = window.$;
	
	var Header = function (_Component) {
		_inherits(Header, _Component);
	
		function Header(props) {
			_classCallCheck(this, Header);
	
			var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));
	
			_this.goBack = function () {
				if (_this.props.backPath) {
					_AppStore2.default.dispatch((0, _reactRouterRedux.push)(_this.props.backPath));
				} else {
					_AppStore2.default.dispatch((0, _reactRouterRedux.push)(_HomeConstants.PATH_HOME));
				}
			};
	
			_this.getActions = function () {
				if (_this.props.isLogged) {
					if (_this.props.actions && _this.props.actions.length) {
						return _this.props.actions.map(function (action, i) {
							return _react2.default.createElement(
								'li',
								{ key: i },
								action
							);
						});
					}
					return null;
				}
				return _react2.default.createElement(
					'li',
					{ key: 'logger' },
					_react2.default.createElement(
						'a',
						{ onClick: function onClick() {
								return _this.openLoginModal();
							} },
						_react2.default.createElement(
							'div',
							{ className: 'row no-margin' },
							_react2.default.createElement(
								'div',
								{ className: 'col s10 no-padding' },
								_react2.default.createElement(
									'span',
									null,
									'Se connecter'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'col s2 no-padding' },
								_react2.default.createElement(
									'i',
									{ className: 'material-icons font-size-40' },
									'person'
								)
							)
						)
					)
				);
			};
	
			_this.openLoginModal = function () {
				_AppStore2.default.dispatch(_HomeAction2.default.updateLoginModalState(true));
			};
	
			_this.state = {
				open: true
			};
			return _this;
		}
	
		_createClass(Header, [{
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				$('.button-collapse').sideNav({
					closeOnClick: true
				});
			}
		}, {
			key: 'getNav',
			value: function getNav() {
				var _this2 = this;
	
				if (this.props.isLogged) {
					if (this.props.point && this.props.point.code) {
						return _react2.default.createElement(
							'span',
							{ onClick: function onClick() {
									return _this2.goBack();
								} },
							_react2.default.createElement(
								'i',
								{ className: 'material-icons font-size-40 brand-logo' },
								'navigate_before'
							)
						);
					}
					return _react2.default.createElement(
						'a',
						{ 'data-activates': 'slide-out', className: 'button-collapse show-on-large brand-logo left truncate' },
						_react2.default.createElement(
							'i',
							{ className: 'material-icons' },
							'menu'
						)
					);
				} else if (this.props.title === _simpleReactI18n2.default.stationResearch) {
					return _react2.default.createElement(
						'span',
						{ onClick: function onClick() {
								return _this2.goBack();
							} },
						_react2.default.createElement(
							'i',
							{ className: 'material-icons font-size-40 brand-logo' },
							'navigate_before'
						)
					);
				}
				return null;
			}
		}, {
			key: 'getLink',
			value: function getLink() {
				var _this3 = this;
	
				var classTitle = function () {
					if (_this3.props.isLogged) {
						return 'left truncate margin-left-60 font-size-20';
					}
					return 'left truncate margin-left-40 font-size-20';
				}();
				return _react2.default.createElement(
					'div',
					{ className: 'show-on-large left clickable' },
					this.getNav(),
					_react2.default.createElement(
						'span',
						{ className: classTitle },
						this.props.title
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'navbar-fixed' },
					_react2.default.createElement(
						'nav',
						{ className: 'top-nav ' },
						_react2.default.createElement(
							'div',
							{ className: 'nav-wrapper ' },
							this.getLink(),
							_react2.default.createElement(
								'ul',
								{ className: 'right hide-on-med-and-down' },
								this.getActions()
							)
						)
					)
				);
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				$('.button-collapse').sideNav({
					closeOnClick: true
				});
			}
		}]);
	
		return Header;
	}(_react.Component);
	
	Header.propTypes = {
		title: _propTypes2.default.string,
		stations: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoStation2.default)),
		actions: _propTypes2.default.arrayOf(_propTypes2.default.element),
		station: _propTypes2.default.instanceOf(_DtoStation2.default),
		point: _propTypes2.default.instanceOf(_DtoPoint2.default),
		userRoles: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoUserRole2.default)),
		backPath: _propTypes2.default.string,
		isLogged: _propTypes2.default.bool
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			title: store.HomeReducer.title,
			stations: store.SitesReducer.stations,
			actions: store.HomeReducer.actions,
			station: store.DetailStationReducer.station,
			backPath: store.HomeReducer.backPath,
			userRoles: store.HomeReducer.userRoles,
			point: store.PointReducer.point
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Header);

/***/ },
/* 2136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _reactRedux = __webpack_require__(18);
	
	var _basepath = __webpack_require__(180);
	
	var _DtoUser = __webpack_require__(54);
	
	var _DtoUser2 = _interopRequireDefault(_DtoUser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = window.$;
	
	var Help = function (_Component) {
		_inherits(Help, _Component);
	
		function Help() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, Help);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Help.__proto__ || Object.getPrototypeOf(Help)).call.apply(_ref, [this].concat(args))), _this), _this.open = function (e) {
				e.preventDefault();
				$('div.tap-target').tapTarget('open');
				$('.tap-target-wrapper.open').css('bottom', '-349px');
			}, _this.close = function (e) {
				e.preventDefault();
				$('div.tap-target').tapTarget('close');
			}, _this.getUserParams = function () {
				if (_this.props.user) {
					return '?email=' + _this.props.user.email + '&lastname=' + _this.props.user.lastName + '&firstname=' + _this.props.user.firstName;
				}
				return '';
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(Help, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'div',
						{ className: 'fixed-action-btn' },
						_react2.default.createElement(
							'a',
							{ id: 'menu', className: 'btn btn-floating btn-large secondary-color-back', onClick: this.open },
							_react2.default.createElement(
								'i',
								{ className: 'material-icons' },
								'help'
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'tap-target ', 'data-activates': 'menu' },
						_react2.default.createElement(
							'div',
							{ className: 'tap-target-content tap-target-utils' },
							_react2.default.createElement(
								'div',
								{ className: 'margin-top-10' },
								_react2.default.createElement(
									'div',
									{ className: 'row' },
									_react2.default.createElement(
										'div',
										{ className: 'col offset-s5 center' },
										_react2.default.createElement(
											'a',
											{ className: 'btn btn-small modal-trigger', href: '#tutorial' },
											_simpleReactI18n2.default.tutorial
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'row' },
									_react2.default.createElement(
										'div',
										{ className: 'col offset-s3 center' },
										_react2.default.createElement(
											'a',
											{ className: 'btn btn-small center', target: '_blank',
												href: _basepath.aquasysPath + '/aquadb/contact/' + this.getUserParams() },
											_simpleReactI18n2.default.contactUs
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row no-margin' },
								_react2.default.createElement(
									'div',
									{ className: 'col s9 center margin-top-10' },
									_react2.default.createElement(
										'a',
										{ href: _basepath.aquasysPath + '/legal', target: '_blank',
											className: 'font-white' },
										_simpleReactI18n2.default.legalNotice
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return Help;
	}(_react.Component);
	
	Help.propTypes = {
		user: _propTypes2.default.objectOf(_DtoUser2.default)
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			user: store.HomeReducer.user
		};
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Help);

/***/ },
/* 2137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DtoUser = __webpack_require__(54);
	
	var _DtoUser2 = _interopRequireDefault(_DtoUser);
	
	var _ActionComponent2 = __webpack_require__(283);
	
	var _ActionComponent3 = _interopRequireDefault(_ActionComponent2);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _AdministrationAction = __webpack_require__(61);
	
	var _AdministrationAction2 = _interopRequireDefault(_AdministrationAction);
	
	var _NewsDto = __webpack_require__(1016);
	
	var _NewsDto2 = _interopRequireDefault(_NewsDto);
	
	var _reactRedux = __webpack_require__(18);
	
	var _lodash = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { NOTIF } from '../../components/actions/constants/ActionConstants'
	//import i18n from 'simple-react-i18n'
	
	//import NotifNewsComponent from '../../administration/components/notifs/NotifNewsComponent'
	
	
	var $ = window.$;
	
	var MainApp = function (_ActionComponent) {
		_inherits(MainApp, _ActionComponent);
	
		function MainApp(props) {
			_classCallCheck(this, MainApp);
	
			var _this = _possibleConstructorReturn(this, (MainApp.__proto__ || Object.getPrototypeOf(MainApp)).call(this, props));
	
			_this.readNews = function (news, notifs) {
				if (notifs) {
					_AppStore2.default.dispatch(_AdministrationAction2.default.readNews(news));
				}
			};
	
			_this.createOrUpdateActions = function () /*news*/{
				/*const notifs = news.filter(o => o.status).length
	         this.setAction([
	       {
	         type: NOTIF,
	                 notifs,
	                 title: i18n.news,
	                 fn: () => this.readNews(news, notifs),
	                 icon: 'event',
	                 content: <NotifNewsComponent key='notif-news-list' news={ news }/>
	       }
	     ])*/
			};
	
			_AppStore2.default.dispatch(_AdministrationAction2.default.fetchNews());
			return _this;
		}
	
		_createClass(MainApp, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.createOrUpdateActions(this.props.news);
				$('body').css({
					/*'background-image': 'url(https://www.aquasys.fr/wp-content/uploads/2022/07/Illustration%20aQuaDB%20DEF-01.jpg)',*/
					'background-image': 'url(https://www.aquasys.fr/wp-content/uploads/2018/01/Visuel-inscription-beta-test-sans-texte.png)',
					'background-repeat': 'no-repeat',
					'background-attachment': 'fixed',
					'background-size': '100% 125%'
				});
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextprops) {
				var diff = (0, _lodash.differenceWith)(nextprops.news, this.props.news, _lodash.isEqual);
				if (diff.length) {
					this.createOrUpdateActions(nextprops.news);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					this.props.children && _react2.default.cloneElement(this.props.children, {
						login: this.props.login, user: this.props.user, typeId: this.props.typeId, isLogged: this.props.isLogged
					})
				);
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				$('body').removeAttr('style');
				this.setAction([]);
			}
		}]);
	
		return MainApp;
	}(_ActionComponent3.default);
	
	MainApp.propTypes = {
		children: _propTypes2.default.element,
		isLogged: _propTypes2.default.bool,
		typeId: _propTypes2.default.number,
		user: _propTypes2.default.instanceOf(_DtoUser2.default),
		login: _propTypes2.default.string,
		news: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_NewsDto2.default))
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			news: store.AdministrationReducer.news
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(MainApp);

/***/ },
/* 2138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _reactRouterRedux = __webpack_require__(43);
	
	var _HomeConstants = __webpack_require__(53);
	
	var _SitesAction = __webpack_require__(97);
	
	var _SitesAction2 = _interopRequireDefault(_SitesAction);
	
	var _basepath = __webpack_require__(180);
	
	var _DtoUser = __webpack_require__(54);
	
	var _DtoUser2 = _interopRequireDefault(_DtoUser);
	
	var _HomeAction = __webpack_require__(52);
	
	var _HomeAction2 = _interopRequireDefault(_HomeAction);
	
	var _reactRedux = __webpack_require__(18);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SideNav = function (_Component) {
		_inherits(SideNav, _Component);
	
		function SideNav() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, SideNav);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SideNav.__proto__ || Object.getPrototypeOf(SideNav)).call.apply(_ref, [this].concat(args))), _this), _this.getEmail = function () {
				if (_this.props.user && _this.props.user.email) {
					return _react2.default.createElement(
						'span',
						{ className: 'white-text email' },
						_this.props.user.email
					);
				}
				return '';
			}, _this.logout = function () {
				_AppStore2.default.dispatch(_HomeAction2.default.logout());
			}, _this.goTo = function (path) {
				_AppStore2.default.dispatch(_SitesAction2.default.reset());
				_AppStore2.default.dispatch((0, _reactRouterRedux.push)(path));
			}, _this.goToExternalLink = function (path) {
				window.open(path, '_blank');
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(SideNav, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				if (this.props.isLogged) {
					return _react2.default.createElement(
						'ul',
						{ id: 'slide-out', className: 'side-nav' },
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'div',
								{ className: 'userView' },
								_react2.default.createElement('div', { className: 'background' }),
								_react2.default.createElement(
									'div',
									{ className: 'center-align' },
									_react2.default.createElement('img', { className: 'logo ', src: _basepath.aquasysPath + '/wp-content/uploads/2018/01/7-1.png', onClick: function onClick() {
											return _this2.goTo(_HomeConstants.PATH_HOME);
										} })
								),
								_react2.default.createElement(
									'span',
									{ className: 'white-text name' },
									this.props.user.login
								),
								this.getEmail()
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'collection' },
							_react2.default.createElement(
								'a',
								{ className: 'collection-item text-icon-align', onClick: function onClick() {
										return _this2.goTo(_HomeConstants.PATH_HOME);
									} },
								_react2.default.createElement(
									'i',
									{ className: 'material-icons font-grey padding-right-20' },
									'home'
								),
								_simpleReactI18n2.default.home
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'collection' },
							_react2.default.createElement(
								'a',
								{ className: 'collection-item text-icon-align', onClick: function onClick() {
										return _this2.goTo(_HomeConstants.PATH_RESEARCH + '/open');
									} },
								_react2.default.createElement(
									'i',
									{ className: 'material-icons font-grey padding-right-20' },
									'map'
								),
								_simpleReactI18n2.default.map
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'collection' },
							_react2.default.createElement(
								'a',
								{ className: 'collection-item text-icon-align', onClick: function onClick() {
										return _this2.goTo(_HomeConstants.PATH_SELECTION);
									} },
								_react2.default.createElement(
									'i',
									{ className: 'material-icons font-grey padding-right-20' },
									'list'
								),
								_simpleReactI18n2.default.myResearch
							)
						),
						_react2.default.createElement('div', { className: 'divider' }),
						_react2.default.createElement(
							'div',
							{ className: 'collection' },
							_react2.default.createElement(
								'a',
								{ className: 'collection-item text-icon-align', onClick: function onClick() {
										return _this2.goTo(_HomeConstants.PATH_ADMINISTRATION_ACCOUNT);
									} },
								_react2.default.createElement(
									'i',
									{ className: 'material-icons font-grey padding-right-20' },
									'person'
								),
								_simpleReactI18n2.default.myAccount
							)
						),
						_react2.default.createElement('div', { className: 'divider' }),
						_react2.default.createElement(
							'div',
							{ className: 'collection' },
							_react2.default.createElement(
								'a',
								{ className: 'collection-item text-icon-align', onClick: function onClick() {
										return _this2.goTo(_HomeConstants.PATH_ADMINISTRATION_THEME);
									} },
								_react2.default.createElement(
									'i',
									{ className: 'material-icons font-grey padding-right-20' },
									'view_quilt'
								),
								_simpleReactI18n2.default.dataSource
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'collection' },
							_react2.default.createElement(
								'a',
								{ className: 'collection-item text-icon-align', onClick: function onClick() {
										return _this2.goToExternalLink(_basepath.aquasysPath + '/legal');
									} },
								_react2.default.createElement(
									'i',
									{ className: 'material-icons font-grey padding-right-20' },
									'help'
								),
								_simpleReactI18n2.default.legalNotice
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'collection' },
							_react2.default.createElement(
								'a',
								{ className: 'collection-item text-icon-align', onClick: function onClick() {
										return _this2.goToExternalLink(_basepath.aquasysPath + '/legal');
									} },
								_react2.default.createElement(
									'i',
									{ className: 'material-icons font-grey padding-right-20' },
									'help'
								),
								_simpleReactI18n2.default.cglu
							)
						),
						_react2.default.createElement('div', { className: 'divider' }),
						_react2.default.createElement(
							'div',
							{ className: 'collection' },
							_react2.default.createElement(
								'a',
								{ className: 'collection-item text-icon-align', onClick: function onClick() {
										return _this2.logout();
									} },
								_react2.default.createElement(
									'i',
									{ className: 'material-icons font-grey padding-right-20' },
									'power_settings_new'
								),
								_simpleReactI18n2.default.signOut
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'bottom-nav', style: { marginTop: '100%' } },
							_react2.default.createElement(
								'div',
								{ className: 'link no-margin center-align', style: { paddingTop: '15%' } },
								_react2.default.createElement(
									'a',
									{ href: 'http://www.aquasys.fr/actualites/', target: '_blank', className: 'no-style' },
									_simpleReactI18n2.default.news
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row no-margin' },
								_react2.default.createElement(
									'div',
									{ className: 'col s4 offset-s2 center-align' },
									_react2.default.createElement(
										'a',
										{ href: 'http://www.ademe.fr', target: '_blank' },
										_react2.default.createElement('img', { src: _basepath.aquasysPath + '/wp-content/uploads/2018/01/1-2.png', alt: 'logo ADEME', width: '50px', className: 'z-depth-1' })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col s4 center-align padding-bottom-10' },
									_react2.default.createElement('img', { src: _basepath.aquasysPath + '/wp-content/uploads/2018/01/4-2.png', alt: 'logo PIA', width: '50px' })
								)
							)
						)
					);
				}
				return null;
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				$('.collapsible').collapsible();
			}
		}]);
	
		return SideNav;
	}(_react.Component);
	
	SideNav.propTypes = {
		user: _propTypes2.default.objectOf(_DtoUser2.default),
		isLogged: _propTypes2.default.bool
	};
	SideNav.defaultProps = {
		isLogged: false
	};
	var mapStateToProps = function mapStateToProps(store) {
		return {
			user: store.HomeReducer.user
		};
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(SideNav);

/***/ },
/* 2139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Stepper = __webpack_require__(603);
	
	var _Stepper2 = _interopRequireDefault(_Stepper);
	
	var _Step = __webpack_require__(600);
	
	var _Step2 = _interopRequireDefault(_Step);
	
	var _StepLabel = __webpack_require__(405);
	
	var _StepLabel2 = _interopRequireDefault(_StepLabel);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _HomeAction = __webpack_require__(52);
	
	var _HomeAction2 = _interopRequireDefault(_HomeAction);
	
	var _DtoUser = __webpack_require__(54);
	
	var _DtoUser2 = _interopRequireDefault(_DtoUser);
	
	var _reactRedux = __webpack_require__(18);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _TutorialStep = __webpack_require__(2140);
	
	var _TutorialStep2 = _interopRequireDefault(_TutorialStep);
	
	var _Step3 = __webpack_require__(2235);
	
	var _Step4 = _interopRequireDefault(_Step3);
	
	var _Step5 = __webpack_require__(2236);
	
	var _Step6 = _interopRequireDefault(_Step5);
	
	var _Step7 = __webpack_require__(2237);
	
	var _Step8 = _interopRequireDefault(_Step7);
	
	var _Step9 = __webpack_require__(2238);
	
	var _Step10 = _interopRequireDefault(_Step9);
	
	var _Step11 = __webpack_require__(2239);
	
	var _Step12 = _interopRequireDefault(_Step11);
	
	var _Step13 = __webpack_require__(2241);
	
	var _Step14 = _interopRequireDefault(_Step13);
	
	var _Step6Bg = __webpack_require__(2240);
	
	var _Step6Bg2 = _interopRequireDefault(_Step6Bg);
	
	var _Fab = __webpack_require__(396);
	
	var _Fab2 = _interopRequireDefault(_Fab);
	
	var _Close = __webpack_require__(1333);
	
	var _Close2 = _interopRequireDefault(_Close);
	
	var _ArrowBack = __webpack_require__(629);
	
	var _ArrowBack2 = _interopRequireDefault(_ArrowBack);
	
	var _ArrowForward = __webpack_require__(630);
	
	var _ArrowForward2 = _interopRequireDefault(_ArrowForward);
	
	var _Done = __webpack_require__(1334);
	
	var _Done2 = _interopRequireDefault(_Done);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = window.$;
	
	var initialState = {
		finished: false,
		stepIndex: 0,
		nbSteps: 5,
		stopDisplaying: false
	};
	
	var Tutorial = function (_Component) {
		_inherits(Tutorial, _Component);
	
		function Tutorial(props) {
			_classCallCheck(this, Tutorial);
	
			var _this = _possibleConstructorReturn(this, (Tutorial.__proto__ || Object.getPrototypeOf(Tutorial)).call(this, props));
	
			_this.handleNext = function () {
				var _this$state = _this.state,
				    nbSteps = _this$state.nbSteps,
				    finished = _this$state.finished,
				    stepIndex = _this$state.stepIndex;
	
				if (!finished) {
					_this.setState({
						stepIndex: stepIndex + 1,
						finished: stepIndex + 1 >= nbSteps
					});
				} else {
					_this.close();
					var _this$props$user = _this.props.user,
					    firstConnection = _this$props$user.firstConnection,
					    login = _this$props$user.login;
	
					if (firstConnection && _this.state.stopDisplaying) {
						_AppStore2.default.dispatch(_HomeAction2.default.updateFirstConnection(login));
						_this.createModal(true);
					}
				}
			};
	
			_this.handleStopDisplaying = function () {
				_this.setState({ stopDisplaying: !_this.state.stopDisplaying });
			};
	
			_this.close = function () {
				$('#tutorial').modal('close');
			};
	
			_this.handlePrev = function () {
				var _this$state2 = _this.state,
				    nbSteps = _this$state2.nbSteps,
				    stepIndex = _this$state2.stepIndex;
	
				if (stepIndex > 0) {
					_this.setState({
						stepIndex: stepIndex - 1,
						finished: stepIndex - 1 >= nbSteps
					});
				}
			};
	
			_this.createModal = function (dismissible) {
				$('#tutorial').modal({
					dismissible: dismissible,
					complete: function complete() {
						return _this.setState(initialState);
					}
				});
			};
	
			_this.state = initialState;
			return _this;
		}
	
		_createClass(Tutorial, [{
			key: 'getStepContent',
			value: function getStepContent(stepIndex) {
				switch (stepIndex) {
					case 0:
						return _react2.default.createElement(_TutorialStep2.default, { img: _Step4.default, background: '#00204c' });
					case 1:
						return _react2.default.createElement(_TutorialStep2.default, { img: _Step6.default, background: '#88999A' });
					case 2:
						return _react2.default.createElement(_TutorialStep2.default, { img: _Step8.default, background: '#0EC7D2' });
					case 3:
						return _react2.default.createElement(_TutorialStep2.default, { img: _Step10.default, background: '#395080' });
					case 4:
						return _react2.default.createElement(_TutorialStep2.default, { img: _Step12.default, background: '#548A4D' });
					default:
						return _react2.default.createElement(_TutorialStep2.default, { img: _Step14.default, background: 'url(' + _Step6Bg2.default + ')' });
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.createModal(!this.props.user.firstConnection);
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps) {
				if (prevProps.open !== this.props.open && this.props.open === true) {
					$('#tutorial').modal('open');
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _state = this.state,
				    finished = _state.finished,
				    stepIndex = _state.stepIndex;
	
				return _react2.default.createElement(
					'div',
					{ id: 'tutorial', className: 'modal fullscreen-modal modal-fixed-footer' },
					_react2.default.createElement(
						'div',
						{ className: 'modal-content' },
						_react2.default.createElement(
							'div',
							{ className: 'modal-header' },
							_react2.default.createElement(
								_Stepper2.default,
								{ activeStep: stepIndex },
								_react2.default.createElement(
									_Step2.default,
									null,
									_react2.default.createElement(
										_StepLabel2.default,
										null,
										_simpleReactI18n2.default.aquaDB
									)
								),
								_react2.default.createElement(
									_Step2.default,
									null,
									_react2.default.createElement(
										_StepLabel2.default,
										null,
										_simpleReactI18n2.default.themes
									)
								),
								_react2.default.createElement(
									_Step2.default,
									null,
									_react2.default.createElement(
										_StepLabel2.default,
										null,
										_simpleReactI18n2.default.research
									)
								),
								_react2.default.createElement(
									_Step2.default,
									null,
									_react2.default.createElement(
										_StepLabel2.default,
										null,
										_simpleReactI18n2.default.selection
									)
								),
								_react2.default.createElement(
									_Step2.default,
									null,
									_react2.default.createElement(
										_StepLabel2.default,
										null,
										_simpleReactI18n2.default.download
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal-c' },
							this.getStepContent(stepIndex)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'modal-footer valign-wrapper row', style: { marginBottom: '4px' } },
						!this.props.user.firstConnection && _react2.default.createElement(
							'div',
							{ className: 'col s4' },
							_react2.default.createElement(_Fab2.default, { children: _react2.default.createElement(_Close2.default, null), size: 'small', color: 'primary', onClick: this.close, className: 'left' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'col s8' },
							_react2.default.createElement(
								'div',
								{ className: 'right' },
								_react2.default.createElement(_Fab2.default, { children: _react2.default.createElement(_ArrowBack2.default, null), size: 'small', disabled: stepIndex === 0, color: 'primary', onClick: this.handlePrev }),
								_react2.default.createElement('span', { style: { width: '24px', display: 'inline-block' } }),
								_react2.default.createElement(_Fab2.default, { children: finished ? _react2.default.createElement(_Done2.default, null) : _react2.default.createElement(_ArrowForward2.default, null), size: 'small', color: 'primary', primary: true, onClick: this.handleNext })
							),
							this.props.user.firstConnection && _react2.default.createElement(
								'div',
								{ className: 'margin-top-5 right' },
								_react2.default.createElement('input', { checked: this.state.stopDisplaying, className: 'filled-in', onChange: this.handleStopDisplaying, type: 'checkbox', id: 'stop' }),
								_react2.default.createElement(
									'label',
									{ htmlFor: 'stop' },
									_simpleReactI18n2.default.stopDisplaying
								)
							)
						)
					)
				);
			}
		}]);
	
		return Tutorial;
	}(_react.Component);
	
	Tutorial.propTypes = {
		open: _propTypes2.default.bool,
		user: _propTypes2.default.instanceOf(_DtoUser2.default)
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			user: store.HomeReducer.user
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Tutorial);

/***/ },
/* 2140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TutorialStep = function (_Component) {
	    _inherits(TutorialStep, _Component);
	
	    function TutorialStep() {
	        _classCallCheck(this, TutorialStep);
	
	        return _possibleConstructorReturn(this, (TutorialStep.__proto__ || Object.getPrototypeOf(TutorialStep)).apply(this, arguments));
	    }
	
	    _createClass(TutorialStep, [{
	        key: 'getContent',
	        value: function getContent(props) {
	            if (props.img) {
	                return _react2.default.createElement('img', { className: 'responsive-img', src: props.img });
	            }
	            return props.children;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var bg = { background: this.props.background };
	            return _react2.default.createElement(
	                'div',
	                { style: bg },
	                this.getContent(this.props)
	            );
	        }
	    }]);
	
	    return TutorialStep;
	}(_react.Component);
	
	TutorialStep.propTypes = {
	    img: _propTypes2.default.string.required,
	    children: _propTypes2.default.element,
	    background: _propTypes2.default.string
	};
	
	exports.default = TutorialStep;

/***/ },
/* 2141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.store = undefined;
	exports.CreditReducer = CreditReducer;
	
	var _CreditConstants = __webpack_require__(1031);
	
	var _DtoUserCredit = __webpack_require__(284);
	
	var _DtoUserCredit2 = _interopRequireDefault(_DtoUserCredit);
	
	var _DtoCreditType = __webpack_require__(533);
	
	var _DtoCreditType2 = _interopRequireDefault(_DtoCreditType);
	
	var _DtoUserCreditHistory = __webpack_require__(1033);
	
	var _DtoUserCreditHistory2 = _interopRequireDefault(_DtoUserCreditHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var store = exports.store = {
		userCredit: {},
		userCreditHistory: [],
		creditTypes: []
	};
	
	function CreditReducer() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		var action = arguments[1];
	
		switch (action.type) {
			case _CreditConstants.RECEIVE_USER_CREDIT:
				{
					if (action.userCredit && action.userCredit.length) {
						return Object.assign({}, state, {
							userCredit: new _DtoUserCredit2.default(action.userCredit[0])
						});
					}
					return Object.assign({}, state, {
						userCredit: {}
					});
				}
			case _CreditConstants.RECEIVE_USER_CREDIT_HISTORY:
				{
					return Object.assign({}, state, {
						userCreditHistory: action.userCreditHistory.map(function (o) {
							return new _DtoUserCreditHistory2.default(o);
						})
					});
				}
			case _CreditConstants.RECEIVE_ALL_CREDIT_TYPE:
				return Object.assign({}, state, {
					creditTypes: action.creditTypes.map(function (o) {
						return new _DtoCreditType2.default(o);
					})
				});
			case _CreditConstants.RESET_CREDITS_INFORMATION:
				return Object.assign({}, state, store);
			default:
				return state;
		}
	}

/***/ },
/* 2142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.store = undefined;
	exports.HomeReducer = HomeReducer;
	
	var _HomeConstants = __webpack_require__(53);
	
	var _DtoUser = __webpack_require__(54);
	
	var _DtoUser2 = _interopRequireDefault(_DtoUser);
	
	var _DtoUserRole = __webpack_require__(378);
	
	var _DtoUserRole2 = _interopRequireDefault(_DtoUserRole);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var store = exports.store = {
		error: '',
		actions: [],
		success: '',
		backPath: _HomeConstants.PATH_HOME,
		wait: false,
		user: {
			address: '',
			administrator: false,
			administratorUser: '',
			city: '',
			email: '',
			firstName: '',
			fixNumber: '',
			lastName: '',
			latitude: '',
			login: '',
			longitude: '',
			mobileNumber: '',
			zoom: ''
		},
		title: '',
		userRoles: [],
		loginModalState: false,
		modalActions: []
	};
	
	function HomeReducer() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		var action = arguments[1];
	
		switch (action.type) {
			case _HomeConstants.TOASTR_ERROR:
				{
					return Object.assign({}, state, {
						error: action.message
					});
				}
			case _HomeConstants.TOASTR_SUCCESS:
				{
					return Object.assign({}, state, {
						success: action.message
					});
				}
			case _HomeConstants.TOASTR_RESET:
				{
					return Object.assign({}, state, {
						success: '',
						error: ''
					});
				}
			case _HomeConstants.WAIT:
				{
					return Object.assign({}, state, {
						wait: action.wait
					});
				}
			case _HomeConstants.RECEIVE_USER_INFORMATIONS:
				{
					return Object.assign({}, state, {
						user: new _DtoUser2.default(action.user)
					});
				}
			case _HomeConstants.RECEIVE_USER_ROLES:
				{
					return Object.assign({}, state, {
						userRoles: action.roles.map(function (el) {
							return new _DtoUserRole2.default(el);
						})
					});
				}
			case _HomeConstants.TITLE:
				{
					return Object.assign({}, state, {
						title: action.title
					});
				}
			case _HomeConstants.SET_BACKPATH:
				{
					var backPath = action.backPath ? action.backPath : _HomeConstants.PATH_HOME;
					return Object.assign({}, state, {
						backPath: backPath
					});
				}
			case _HomeConstants.ACTIONS:
				return Object.assign({}, state, {
					actions: action.actions
				});
			case _HomeConstants.RECEIVE_MODAL_LOGIN_STATE:
				return Object.assign({}, state, {
					loginModalState: action.loginModalState
				});
			case _HomeConstants.RECEIVE_MODAL_ACTIONS:
				return Object.assign({}, state, {
					modalActions: action.modalActions
				});
			default:
				return state;
		}
	}

/***/ },
/* 2143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.store = undefined;
	exports.InformationReducer = InformationReducer;
	
	var _InformationConstants = __webpack_require__(1032);
	
	var store = exports.store = {
		message: '',
		open: false
	};
	
	function InformationReducer() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		var action = arguments[1];
	
		switch (action.type) {
			case _InformationConstants.RESET_INFORMATION:
				{
					return Object.assign({}, state, store);
				}
			case _InformationConstants.MESSAGE:
				{
					return Object.assign({}, state, {
						message: action.message,
						open: true
					});
				}
			default:
				return state;
		}
	}

/***/ },
/* 2144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.store = undefined;
	exports.ToastrReducer = ToastrReducer;
	
	var _ToastrConstants = __webpack_require__(377);
	
	var store = exports.store = {
		messageType: '',
		message: '',
		open: false
	};
	
	function ToastrReducer() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		var action = arguments[1];
	
		switch (action.type) {
			case _ToastrConstants.RESET_MODAL:
				{
					return Object.assign({}, state, store);
				}
			case _ToastrConstants.ERROR:
			case _ToastrConstants.INFO:
			case _ToastrConstants.SUCCESS:
				{
					return Object.assign({}, state, {
						messageType: action.type,
						message: action.message,
						open: true
					});
				}
			default:
				return state;
		}
	}

/***/ },
/* 2145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(1009);
	
	var _reactDom = __webpack_require__(51);
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactRouterRedux = __webpack_require__(43);
	
	var _AdministrationApp = __webpack_require__(2084);
	
	var _AdministrationApp2 = _interopRequireDefault(_AdministrationApp);
	
	var _AccountInformationsPanel = __webpack_require__(2085);
	
	var _AccountInformationsPanel2 = _interopRequireDefault(_AccountInformationsPanel);
	
	var _MapInformationsPanel = __webpack_require__(2087);
	
	var _MapInformationsPanel2 = _interopRequireDefault(_MapInformationsPanel);
	
	var _ThemeInformationPanel = __webpack_require__(2091);
	
	var _ThemeInformationPanel2 = _interopRequireDefault(_ThemeInformationPanel);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _properties_fr = __webpack_require__(2220);
	
	var _properties_fr2 = _interopRequireDefault(_properties_fr);
	
	var _properties_en = __webpack_require__(2219);
	
	var _properties_en2 = _interopRequireDefault(_properties_en);
	
	var _properties = __webpack_require__(2218);
	
	var _properties2 = _interopRequireDefault(_properties);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _DetailStationApp = __webpack_require__(2183);
	
	var _DetailStationApp2 = _interopRequireDefault(_DetailStationApp);
	
	var _HomeConstants = __webpack_require__(53);
	
	var _DashboardApp = __webpack_require__(2117);
	
	var _DashboardApp2 = _interopRequireDefault(_DashboardApp);
	
	var _SelectionApp = __webpack_require__(2121);
	
	var _SelectionApp2 = _interopRequireDefault(_SelectionApp);
	
	var _CreditInformationPanel = __webpack_require__(2086);
	
	var _CreditInformationPanel2 = _interopRequireDefault(_CreditInformationPanel);
	
	var _PointApp = __webpack_require__(2154);
	
	var _PointApp2 = _interopRequireDefault(_PointApp);
	
	var _AquadbApp = __webpack_require__(2134);
	
	var _AquadbApp2 = _interopRequireDefault(_AquadbApp);
	
	var _MainApp = __webpack_require__(2137);
	
	var _MainApp2 = _interopRequireDefault(_MainApp);
	
	var _CookieUtils = __webpack_require__(545);
	
	var _SitesApp = __webpack_require__(2174);
	
	var _SitesApp2 = _interopRequireDefault(_SitesApp);
	
	var _SignUpValidationApp = __webpack_require__(2172);
	
	var _SignUpValidationApp2 = _interopRequireDefault(_SignUpValidationApp);
	
	var _InitPasswordApp = __webpack_require__(2146);
	
	var _InitPasswordApp2 = _interopRequireDefault(_InitPasswordApp);
	
	var _LoginApp = __webpack_require__(2149);
	
	var _LoginApp2 = _interopRequireDefault(_LoginApp);
	
	var _FindPasswordApp = __webpack_require__(2131);
	
	var _FindPasswordApp2 = _interopRequireDefault(_FindPasswordApp);
	
	var _ResetPasswordApp = __webpack_require__(2168);
	
	var _ResetPasswordApp2 = _interopRequireDefault(_ResetPasswordApp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_simpleReactI18n2.default.addLang(_properties_fr2.default, ['fr', 'FR']);
	_simpleReactI18n2.default.addLang(_properties_en2.default, ['en', 'EN']);
	_simpleReactI18n2.default.addLang(_properties2.default, 'default');
	_simpleReactI18n2.default.init();
	
	var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.hashHistory, _AppStore2.default);
	(0, _reactDom.render)(_react2.default.createElement(
		_reactRedux.Provider,
		{ store: _AppStore2.default },
		_react2.default.createElement(
			_reactRouter.Router,
			{ history: history, onUpdate: function onUpdate() {
					return (0, _CookieUtils.getPageViewAnalytics)(window.location.hash);
				} },
			_react2.default.createElement(
				_reactRouter.Route,
				{ path: _HomeConstants.PATH_HOME, component: _AquadbApp2.default },
				_react2.default.createElement(_reactRouter.IndexRedirect, { to: _HomeConstants.PATH_MAIN }),
				_react2.default.createElement(
					_reactRouter.Route,
					{ path: _HomeConstants.PATH_MAIN, component: _MainApp2.default },
					_react2.default.createElement(_reactRouter.IndexRoute, { component: _DashboardApp2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: _HomeConstants.PATH_SELECTION, component: _SelectionApp2.default })
				),
				_react2.default.createElement(_reactRouter.Route, { path: _HomeConstants.PATH_STATION, component: _DetailStationApp2.default }),
				_react2.default.createElement(_reactRouter.Route, { path: _HomeConstants.PATH_POINT_ID, component: _PointApp2.default }),
				_react2.default.createElement(
					_reactRouter.Route,
					{ path: _HomeConstants.PATH_ADMINISTRATION, component: _AdministrationApp2.default },
					_react2.default.createElement(_reactRouter.IndexRedirect, { to: _HomeConstants.PATH_ADMINISTRATION_ACCOUNT }),
					_react2.default.createElement(_reactRouter.Route, { path: _HomeConstants.PATH_ADMINISTRATION_ACCOUNT, component: _AccountInformationsPanel2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: _HomeConstants.PATH_ADMINISTRATION_MAP, component: _MapInformationsPanel2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: _HomeConstants.PATH_ADMINISTRATION_THEME, component: _ThemeInformationPanel2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: _HomeConstants.PATH_ADMINISTRATION_CREDIT, component: _CreditInformationPanel2.default })
				),
				_react2.default.createElement(_reactRouter.Route, { path: _HomeConstants.PATH_RESEARCH, component: _SitesApp2.default }),
				_react2.default.createElement(_reactRouter.Route, { path: _HomeConstants.PATH_RESEARCH + '/:isOpen', component: _SitesApp2.default })
			),
			_react2.default.createElement(_reactRouter.Route, { path: _HomeConstants.PATH_LOGIN, component: _LoginApp2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: _HomeConstants.PATH_FIND_EMAIL, component: _FindPasswordApp2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: _HomeConstants.PATH_RESET_PWD, component: _ResetPasswordApp2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: _HomeConstants.PATH_SIGNUP, component: _SignUpValidationApp2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: _HomeConstants.PATH_INIT_ACCOUNT, component: _InitPasswordApp2.default })
		)
	), document.getElementById('app'));

/***/ },
/* 2146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _InitPasswordPanel = __webpack_require__(2147);
	
	var _InitPasswordPanel2 = _interopRequireDefault(_InitPasswordPanel);
	
	var _reactAquasys = __webpack_require__(49);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _reactRedux = __webpack_require__(18);
	
	var _InitPasswordAction = __webpack_require__(1034);
	
	var _InitPasswordAction2 = _interopRequireDefault(_InitPasswordAction);
	
	var _Snackbar = __webpack_require__(192);
	
	var _Snackbar2 = _interopRequireDefault(_Snackbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InitPasswordApp = function (_Component) {
		_inherits(InitPasswordApp, _Component);
	
		function InitPasswordApp(props) {
			_classCallCheck(this, InitPasswordApp);
	
			var _this = _possibleConstructorReturn(this, (InitPasswordApp.__proto__ || Object.getPrototypeOf(InitPasswordApp)).call(this, props));
	
			_this.putMessage = function (value) {
				_AppStore2.default.dispatch(_InitPasswordAction2.default.addMessage(value));
			};
	
			_this.handleRequestClose = function () {
				_AppStore2.default.dispatch(_InitPasswordAction2.default.resetMessage());
			};
	
			return _this;
		}
	
		_createClass(InitPasswordApp, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ id: 'login-page' },
					_react2.default.createElement(
						'div',
						{ className: 'container-div valign-wrapper' },
						_react2.default.createElement(
							'div',
							{ className: 'container-panel' },
							_react2.default.createElement(
								'div',
								{ className: 'container' },
								_react2.default.createElement(
									'div',
									{ className: 'row' },
									_react2.default.createElement(
										'div',
										{ className: 'col s6 m6 l4 offset-m3 offset-l4' },
										_react2.default.createElement(
											'div',
											{ className: 'row' },
											_react2.default.createElement(_InitPasswordPanel2.default, { putMessage: this.putMessage })
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(_reactAquasys.Toastr, { store: _AppStore2.default }),
					_react2.default.createElement(_Snackbar2.default, {
						open: this.props.open,
						message: this.props.message,
						autoHideDuration: 2000,
						onRequestClose: this.handleRequestClose,
						bodyStyle: { backgroundColor: '#FF0000', color: 'white' },
						style: { backgroundColor: '#FF0000', color: 'white' },
						contentStyle: { backgroundColor: '#FF0000', color: 'white' }
					}),
					_react2.default.createElement(_reactAquasys.Wait, null)
				);
			}
		}]);
	
		return InitPasswordApp;
	}(_react.Component);
	
	InitPasswordApp.propTypes = {
		open: _propTypes2.default.bool,
		message: _propTypes2.default.string
	};
	var mapStateToProps = function mapStateToProps(props) {
		return {
			open: props.InitPasswordReducer.open,
			message: props.InitPasswordReducer.message,
			error: props.InitPasswordReducer.error
		};
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(InitPasswordApp);

/***/ },
/* 2147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterRedux = __webpack_require__(43);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _lodash = __webpack_require__(15);
	
	var _InitPasswordAction = __webpack_require__(1034);
	
	var _InitPasswordAction2 = _interopRequireDefault(_InitPasswordAction);
	
	var _reactRedux = __webpack_require__(18);
	
	var _basepath = __webpack_require__(180);
	
	var _HomeConstants = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InitPasswordPanel = function (_Component) {
		_inherits(InitPasswordPanel, _Component);
	
		function InitPasswordPanel(props) {
			_classCallCheck(this, InitPasswordPanel);
	
			var _this = _possibleConstructorReturn(this, (InitPasswordPanel.__proto__ || Object.getPrototypeOf(InitPasswordPanel)).call(this, props));
	
			_this.onValid = function () {
				if (!_this.state.login) {
					_this.props.putMessage(_simpleReactI18n2.default.error.login);
				} else if (!_this.state.password) {
					_this.props.putMessage(_simpleReactI18n2.default.error.password);
				} else if (!_this.state.confirmPassword) {
					_this.props.putMessage(_simpleReactI18n2.default.error.confirmPassword);
				} else {
					if (!(0, _lodash.isEqual)(_this.state.password, _this.state.confirmPassword)) {
						_this.props.putMessage(_simpleReactI18n2.default.error.samePassword);
					} else {
						_AppStore2.default.dispatch(_InitPasswordAction2.default.initPassword(_this.state));
					}
				}
			};
	
			_this.onChangeValue = function (key, value) {
				var actualState = Object.assign({}, _this.state);
				actualState[key] = value.trim();
				_this.setState(actualState);
			};
	
			_this.disableCopyPaste = function (event) {
				event.preventDefault();
			};
	
			_this.getContactPanel = function () {
				if (_this.props.error) {
					return _react2.default.createElement(
						'div',
						{ className: 'row no-margin center-align padding-top-10' },
						_react2.default.createElement(
							'div',
							{ className: 'col s12' },
							_react2.default.createElement(
								'a',
								{ className: 'accountActivationContactUs', href: _basepath.aquadbSupport,
									target: '_blank' },
								' ',
								_simpleReactI18n2.default.needHelp
							)
						)
					);
				}
				return null;
			};
	
			_this.state = {
				login: '',
				password: '',
				confirmPassword: ''
			};
			return _this;
		}
	
		_createClass(InitPasswordPanel, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'div',
						{ className: 'card no-margin z-depth-1 radius10' },
						_react2.default.createElement(
							'div',
							{ className: 'card-content no-padding row no-margin cardLogin' },
							_react2.default.createElement(
								'form',
								null,
								_react2.default.createElement(
									'div',
									{ className: 'row no-margin' },
									_react2.default.createElement(
										'div',
										{ className: 'input-field col s12 center' },
										_react2.default.createElement('img', { src: 'https://www.aquasys.fr/wp-content/uploads/2017/10/AquaDB-grand.png',
											alt: 'logo AquaDB',
											width: '70px', className: 'z-depth-1' })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'row no-margin' },
									_react2.default.createElement(
										'div',
										{ className: 'col s12' },
										_react2.default.createElement(
											'label',
											{ htmlFor: 'login', className: 'valign-wrapper black-text' },
											_react2.default.createElement(
												'i',
												{ className: 'material-icons' },
												'person'
											),
											_simpleReactI18n2.default.login
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col s12' },
										_react2.default.createElement('input', { ref: 'login', id: 'login', type: 'text', className: 'validate', required: true,
											value: this.state.login,
											onChange: function onChange(e) {
												return _this2.onChangeValue('login', e.target.value);
											} })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'row no-margin' },
									_react2.default.createElement(
										'div',
										{ className: 'col s12' },
										_react2.default.createElement(
											'label',
											{ htmlFor: 'password', className: 'valign-wrapper black-text' },
											_react2.default.createElement(
												'i',
												{ className: 'material-icons' },
												'lock_outline'
											),
											_simpleReactI18n2.default.password
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col s12' },
										_react2.default.createElement('input', { ref: 'password', id: 'password', type: 'password', className: 'validate', required: true,
											value: this.state.password,
											onChange: function onChange(e) {
												return _this2.onChangeValue('password', e.target.value);
											} })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'row no-margin' },
									_react2.default.createElement(
										'div',
										{ className: 'col s12' },
										_react2.default.createElement(
											'label',
											{ htmlFor: 'confirmPassword', className: 'valign-wrapper black-text' },
											_react2.default.createElement(
												'i',
												{ className: 'material-icons' },
												'lock_outline'
											),
											_simpleReactI18n2.default.confirmPassword
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col s12' },
										_react2.default.createElement('input', { ref: 'confirmPassword', id: 'confirmPassword', type: 'password',
											className: 'validate',
											value: this.state.confirmPassword,
											onCopy: function onCopy(e) {
												return _this2.disableCopyPaste(e);
											},
											onPaste: function onPaste(e) {
												return _this2.disableCopyPaste(e);
											},
											onChange: function onChange(e) {
												return _this2.onChangeValue('confirmPassword', e.target.value);
											},
											required: true })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'row no-margin' },
									_react2.default.createElement(
										'div',
										{ className: 'col s10 offset-s1' },
										_react2.default.createElement('script', { src: 'https://www.google.com/recaptcha/enterprise.js?render=6LcTYUgfAAAAAA9q3nt1a0dqplRNZOXX7Z5oVcfy' })
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'col l12 m10 s10 offset-m1 offset-s1 padding-bottom-10  ' },
								_react2.default.createElement(
									'button',
									{ onClick: function onClick() {
											return _this2.onValid();
										},
										className: 'waves-effect col l12 m12 s12 waves-light btn' },
									_simpleReactI18n2.default.validate
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'col l12 m10 s10 offset-m1 offset-s1 padding-bottom-10 center-align  ' },
								_react2.default.createElement(
									'a',
									{ onClick: function onClick() {
											return _AppStore2.default.dispatch((0, _reactRouterRedux.push)(_HomeConstants.PATH_HOME));
										} },
									_simpleReactI18n2.default.alreadyRegistered
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						null,
						this.getContactPanel()
					)
				);
			}
		}]);
	
		return InitPasswordPanel;
	}(_react.Component);
	
	InitPasswordPanel.propTypes = {
		putMessage: _propTypes2.default.func,
		error: _propTypes2.default.bool
	};
	
	var mapStateToProps = function mapStateToProps(props) {
		return {
			error: props.InitPasswordReducer.error
		};
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(InitPasswordPanel);

/***/ },
/* 2148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.store = undefined;
	exports.InitPasswordReducer = InitPasswordReducer;
	
	var _InitPasswordConstants = __webpack_require__(1035);
	
	var store = exports.store = {
		open: false,
		error: false,
		message: ''
	};
	
	function InitPasswordReducer() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		var action = arguments[1];
	
		switch (action.type) {
			case _InitPasswordConstants.ADD_MESSAGE:
				{
					return Object.assign({}, state, {
						open: true,
						message: action.message
					});
				}
			case _InitPasswordConstants.RESET_MESSAGE:
				{
					return Object.assign({}, state, {
						open: false,
						message: ''
					});
				}
			case _InitPasswordConstants.ERROR:
				{
					return Object.assign({}, state, {
						error: true
					});
				}
			default:
				return state;
		}
	}

/***/ },
/* 2149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _reactRouterRedux = __webpack_require__(43);
	
	var _reactAquasys = __webpack_require__(49);
	
	var _HomeConstants = __webpack_require__(53);
	
	var _SignIn = __webpack_require__(1036);
	
	var _SignIn2 = _interopRequireDefault(_SignIn);
	
	var _CookiePanel = __webpack_require__(1019);
	
	var _CookiePanel2 = _interopRequireDefault(_CookiePanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoginApp = function (_Component) {
		_inherits(LoginApp, _Component);
	
		function LoginApp() {
			_classCallCheck(this, LoginApp);
	
			return _possibleConstructorReturn(this, (LoginApp.__proto__ || Object.getPrototypeOf(LoginApp)).apply(this, arguments));
		}
	
		_createClass(LoginApp, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var token = sessionStorage.getItem('TOKEN');
				if (token && atob(token)) {
					_AppStore2.default.dispatch((0, _reactRouterRedux.push)(_HomeConstants.PATH_HOME));
				}
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ id: 'login-page' },
					_react2.default.createElement(
						'div',
						{ className: 'container-div valign-wrapper' },
						_react2.default.createElement(
							'div',
							{ className: 'container-panel' },
							_react2.default.createElement(
								'div',
								{ className: 'container' },
								_react2.default.createElement(
									'div',
									{ className: 'row' },
									_react2.default.createElement(
										'div',
										{ className: 'col s6 m6 l4 offset-m3 offset-l4' },
										_react2.default.createElement(
											'div',
											{ className: 'row' },
											_react2.default.createElement(_SignIn2.default, null),
											_react2.default.createElement(_CookiePanel2.default, null)
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(_reactAquasys.Toastr, { store: _AppStore2.default })
				);
			}
		}]);
	
		return LoginApp;
	}(_react.Component);
	
	LoginApp.propTypes = {
		error: _propTypes2.default.string,
		success: _propTypes2.default.string
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			error: store.LoginReducer.error,
			success: store.LoginReducer.success
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(LoginApp);

/***/ },
/* 2150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _SignIn = __webpack_require__(1036);
	
	var _SignIn2 = _interopRequireDefault(_SignIn);
	
	var _HomeAction = __webpack_require__(52);
	
	var _HomeAction2 = _interopRequireDefault(_HomeAction);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _Dialog = __webpack_require__(190);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Slide = __webpack_require__(155);
	
	var _Slide2 = _interopRequireDefault(_Slide);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Transition = _react2.default.forwardRef(function Transition(props, ref) {
		return _react2.default.createElement(_Slide2.default, Object.assign({ direction: 'up', ref: ref }, props));
	});
	
	var LoginModal = function (_Component) {
		_inherits(LoginModal, _Component);
	
		function LoginModal() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, LoginModal);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LoginModal.__proto__ || Object.getPrototypeOf(LoginModal)).call.apply(_ref, [this].concat(args))), _this), _this.handleClose = function () {
				_AppStore2.default.dispatch(_HomeAction2.default.updateLoginModalState(false));
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(LoginModal, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_Dialog2.default,
					{
						maxWidth: 'xs',
						TransitionComponent: Transition,
						modal: false,
						keepMounted: true,
						open: this.props.loginModalState,
						onClose: this.handleClose
					},
					_react2.default.createElement(_SignIn2.default, { actions: this.props.modalActions })
				);
			}
		}]);
	
		return LoginModal;
	}(_react.Component);
	
	LoginModal.propTypes = {
		loginModalState: _propTypes2.default.bool,
		modalActions: _propTypes2.default.func
	};
	var mapStateToProps = function mapStateToProps(store) {
		return {
			loginModalState: store.HomeReducer.loginModalState,
			modalActions: store.HomeReducer.modalActions
		};
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(LoginModal);

/***/ },
/* 2151 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
		LICENCE_KEY: "AquaDBBEBeta"
	};

/***/ },
/* 2152 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = LoginReducer;
	function LoginReducer() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		var action = arguments[1];
	
		switch (action.type) {
			default:
				return state;
		}
	}

/***/ },
/* 2153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _reactAquasys = __webpack_require__(49);
	
	var _isomorphicFetch = __webpack_require__(78);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _ActionUtils = __webpack_require__(112);
	
	var _ApplicationConf = __webpack_require__(65);
	
	var _ApplicationConf2 = _interopRequireDefault(_ApplicationConf);
	
	var _PointConstants = __webpack_require__(535);
	
	var _SiteTypes = __webpack_require__(56);
	
	var _SiteTypes2 = _interopRequireDefault(_SiteTypes);
	
	var _ApplicationUtils = __webpack_require__(186);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _ToastrAction = __webpack_require__(66);
	
	var _ToastrAction2 = _interopRequireDefault(_ToastrAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PointAction = {
	
		receivePoint: function receivePoint(point) {
			return {
				type: _PointConstants.RECEIVE_POINT,
				point: point
			};
		},
		fetchPoint: function fetchPoint(id) {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.point.getDetailPoint(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						idpoint: id
					})
				}).then(_ActionUtils.getJson).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					if (!json.error && json.length) {
						dispatch(PointAction.receivePoint(json[0]));
						dispatch(PointAction.fetchPointKeyFigures(json[0].id));
						dispatch(PointAction.fetchPointNetworks(json[0].id));
						return json;
					}
					return undefined;
				}).then(function (json) {
					dispatch(PointAction.prepareFetchType(json));
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
		receivePointKeyFigures: function receivePointKeyFigures(pointKeyFigures) {
			return {
				type: _PointConstants.RECEIVE_POINT_KEY_FIGURES,
				pointKeyFigures: pointKeyFigures
			};
		},
		fetchPointKeyFigures: function fetchPointKeyFigures(id) {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.sites.getKeyFigures(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						stationids: (0, _ApplicationUtils.getFetchSiteIds)([id])
					})
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							return [];
						},
						404: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					if (json.length) {
						dispatch(PointAction.receivePointKeyFigures(json));
					}
					return [];
				});
			};
		},
	
		receivePointNetworks: function receivePointNetworks(pointNetworks) {
			return {
				type: _PointConstants.RECEIVE_POINT_NETWORKS,
				pointNetworks: pointNetworks
			};
		},
	
		fetchPointNetworks: function fetchPointNetworks(id) {
			return function (dispatch) {
				dispatch(_reactAquasys.WaitAction.waitStart());
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.station.getNetworks(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						idstation: id
					})
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							return [];
						},
						404: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(PointAction.receivePointNetworks(json));
				}).then(function () {
					dispatch(_reactAquasys.WaitAction.waitStop());
				}).catch(function () {
					dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.error.errorLoadingData));
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
		prepareFetchType: function prepareFetchType(json) {
			if (json) {
				var point = json[0];
				return function (dispatch) {
					switch (point.typeparameter) {
						case _SiteTypes2.default.QUALITOMETER.type:
						case _SiteTypes2.default.QUALITOMETER_SURFACE.type:
							return dispatch(PointAction.fetchQualitometer(point.id));
						default:
							return '';
					}
				};
			}
			return '';
		},
	
		fetchQualitometer: function fetchQualitometer(id) {
			return function (dispatch) {
				dispatch(PointAction.fetchSamplingSurfacePoint(id));
			};
		},
		receiveSamplingSurfacePoint: function receiveSamplingSurfacePoint(samplingSurfacePoints) {
			return {
				type: _PointConstants.RECEIVE_SAMPLING_SURFACE_POINT,
				samplingSurfacePoints: samplingSurfacePoints
			};
		},
		fetchSamplingSurfacePoint: function fetchSamplingSurfacePoint(id) {
			return function (dispatch) {
				return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.station.getSamplingSurfacePoints(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						idpoint: id
					})
				}).then(function (response) {
					return (0, _ActionUtils.checkStatus)({
						200: function _(rep) {
							return rep.json();
						},
						204: function _() {
							return [];
						},
						404: function _() {
							return [];
						}
					}, response);
				}).then(function () {
					var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
					dispatch(PointAction.receiveSamplingSurfacePoint(json));
				}).catch(function () {
					dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.error.errorLoadingData));
					dispatch(_reactAquasys.WaitAction.waitStop());
				});
			};
		},
		reset: function reset() {
			return {
				type: _PointConstants.RESET_POINT_INFORMATIONS
			};
		}
	};
	exports.default = PointAction;

/***/ },
/* 2154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _PointAction = __webpack_require__(2153);
	
	var _PointAction2 = _interopRequireDefault(_PointAction);
	
	var _DtoPoint = __webpack_require__(86);
	
	var _DtoPoint2 = _interopRequireDefault(_DtoPoint);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _LoadingPanel = __webpack_require__(1020);
	
	var _LoadingPanel2 = _interopRequireDefault(_LoadingPanel);
	
	var _PointDescriptionPanel = __webpack_require__(2155);
	
	var _PointDescriptionPanel2 = _interopRequireDefault(_PointDescriptionPanel);
	
	var _HomeAction = __webpack_require__(52);
	
	var _HomeAction2 = _interopRequireDefault(_HomeAction);
	
	var _DtoKeyFigures = __webpack_require__(98);
	
	var _DtoKeyFigures2 = _interopRequireDefault(_DtoKeyFigures);
	
	var _TypePointPanel = __webpack_require__(2158);
	
	var _TypePointPanel2 = _interopRequireDefault(_TypePointPanel);
	
	var _HomeConstants = __webpack_require__(53);
	
	var _PointMap = __webpack_require__(2157);
	
	var _PointMap2 = _interopRequireDefault(_PointMap);
	
	var _PointKeyFiguresPanel = __webpack_require__(2156);
	
	var _PointKeyFiguresPanel2 = _interopRequireDefault(_PointKeyFiguresPanel);
	
	var _reactRouterRedux = __webpack_require__(43);
	
	var _DtoSiteType = __webpack_require__(96);
	
	var _DtoSiteType2 = _interopRequireDefault(_DtoSiteType);
	
	var _lodash = __webpack_require__(15);
	
	var _PointProximityChart = __webpack_require__(2163);
	
	var _PointProximityChart2 = _interopRequireDefault(_PointProximityChart);
	
	var _DistanceUtils = __webpack_require__(2208);
	
	var _DtoStation = __webpack_require__(88);
	
	var _DtoStation2 = _interopRequireDefault(_DtoStation);
	
	var _PointProximityPanel = __webpack_require__(2162);
	
	var _PointProximityPanel2 = _interopRequireDefault(_PointProximityPanel);
	
	var _NoInformationPanel = __webpack_require__(1037);
	
	var _NoInformationPanel2 = _interopRequireDefault(_NoInformationPanel);
	
	var _SourcePanel = __webpack_require__(2164);
	
	var _SourcePanel2 = _interopRequireDefault(_SourcePanel);
	
	var _reactDndHtml5Backend = __webpack_require__(991);
	
	var _reactDndHtml5Backend2 = _interopRequireDefault(_reactDndHtml5Backend);
	
	var _reactDnd = __webpack_require__(218);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PointApp = function (_Component) {
		_inherits(PointApp, _Component);
	
		function PointApp(props) {
			_classCallCheck(this, PointApp);
	
			var _this = _possibleConstructorReturn(this, (PointApp.__proto__ || Object.getPrototypeOf(PointApp)).call(this, props));
	
			_this.getTitleLoad = function () {
				if (_this.props.point && _this.props.point.name && _this.props.siteTypes.length) {
					return '100';
				}
				return _simpleReactI18n2.default.point.loading;
			};
	
			_this.setHeight = function (height) {
				_this.setState({
					height: height
				});
			};
	
			_this.getSiteType = function () {
				var siteType = (0, _lodash.find)(_this.props.siteTypes, function (o) {
					return o.id == _this.props.params.typeId;
				});
				if (siteType) {
					return siteType;
				}
				_AppStore2.default.dispatch((0, _reactRouterRedux.push)(_HomeConstants.PATH_HOME));
				return null;
			};
	
			_this.getTypePoint = function (siteType) {
				var show = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
				if (show) {
					return _react2.default.createElement(
						'div',
						{ className: 'row no-margin' },
						_react2.default.createElement(
							'div',
							{ className: 'col s12' },
							_react2.default.createElement(_TypePointPanel2.default, { parameter: siteType.parameter })
						)
					);
				}
				return null;
			};
	
			_this.calculateDistance = function (point) {
				return (0, _DistanceUtils.getDistanceBetweenCoordsWGS84)([_this.props.point.yCoordinate, _this.props.point.xCoordinate], [point.yCoordinate, point.xCoordinate]);
			};
	
			_this.getProximityPoint = function () {
				if (_this.props.selectedStations.length) {
					return _this.props.selectedStations.map(function (o) {
						return {
							distance: Number(_this.calculateDistance(o)),
							station: o
						};
					});
				}
				return [];
			};
	
			_this.getProximityChart = function (proximityPoint, siteType) {
				if (proximityPoint.length) {
					return _react2.default.createElement(_PointProximityChart2.default, { proximityStation: proximityPoint, siteType: siteType });
				}
				return _react2.default.createElement(_NoInformationPanel2.default, null);
			};
	
			_this.getProximityPanel = function (proximityPoint, siteType) {
				if (proximityPoint.length) {
					return _react2.default.createElement(_PointProximityPanel2.default, { proximityStation: proximityPoint, siteType: siteType });
				}
				return _react2.default.createElement(_NoInformationPanel2.default, null);
			};
	
			_this.getPanel = function () {
				var loadingValue = _this.getTitleLoad();
				if (loadingValue === '100') {
					var siteType = _this.getSiteType();
					var proximityPoint = _this.getProximityPoint();
					return _react2.default.createElement(
						'div',
						{ className: 'row no-margin' },
						_react2.default.createElement(
							'div',
							{ className: 'col s8' },
							_react2.default.createElement(
								'div',
								{ className: 'row no-margin' },
								_react2.default.createElement(
									'div',
									{ className: 'col s12 no-padding' },
									_react2.default.createElement(_PointDescriptionPanel2.default, { id: 'descriptionPanel', setHeight: _this.setHeight })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row no-margin' },
								_react2.default.createElement(
									'div',
									{ className: 'col s12 no-padding' },
									_react2.default.createElement(_PointKeyFiguresPanel2.default, { siteType: siteType })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row no-margin' },
								_react2.default.createElement(
									'div',
									{ className: 'col s12 no-padding' },
									_this.getProximityChart(proximityPoint, siteType)
								)
							),
							_this.getTypePoint(siteType)
						),
						_react2.default.createElement(
							'div',
							{ className: 'col s4' },
							_react2.default.createElement(
								'div',
								{ className: 'row no-margin' },
								_react2.default.createElement(
									'div',
									{ className: 'col s12 no-padding' },
									_react2.default.createElement(_SourcePanel2.default, null)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col s12 no-padding' },
									_react2.default.createElement(_PointMap2.default, { height: _this.state.height })
								),
								_react2.default.createElement(
									'div',
									{ className: 'col s12 no-padding' },
									_this.getProximityPanel(proximityPoint, siteType)
								)
							)
						)
					);
				}
				return _react2.default.createElement(_LoadingPanel2.default, { title: loadingValue });
			};
	
			_this.state = {
				height: 50
			};
			return _this;
		}
	
		_createClass(PointApp, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				//if (this.props.selectedStations.length) {
				_AppStore2.default.dispatch(_PointAction2.default.fetchPoint(this.props.params.id));
				_AppStore2.default.dispatch(_HomeAction2.default.setBackPath(_HomeConstants.PATH_RESEARCH));
				//} else {
				//	AppStore.dispatch(push(PATH_HOME))
				//		}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				_AppStore2.default.dispatch(_PointAction2.default.reset());
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.point && nextProps.point.code) {
					var name = nextProps.point.name ? nextProps.point.name : nextProps.point.code;
					_AppStore2.default.dispatch(_HomeAction2.default.setTitle(nextProps.point.code + ' - ' + name));
				} else {
					_AppStore2.default.dispatch(_HomeAction2.default.setTitle(_simpleReactI18n2.default.point.sheet));
				}
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'row' },
					_react2.default.createElement(
						'div',
						{ className: 'col s12' },
						this.getPanel()
					)
				);
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (document.getElementById('descriptionPanel')) {
					this.setState({
						height: document.getElementById('descriptionPanel').clientHeight
					});
				}
			}
		}]);
	
		return PointApp;
	}(_react.Component);
	
	PointApp.propTypes = {
		params: _propTypes2.default.shape({
			id: _propTypes2.default.number,
			typeId: _propTypes2.default.number
		}),
		point: _propTypes2.default.objectOf(_DtoPoint2.default),
		pointKeyFigures: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoKeyFigures2.default)),
		siteTypes: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoSiteType2.default)),
		selectedStations: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoStation2.default))
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			point: store.PointReducer.point,
			siteTypes: store.ReferentialReducer.siteTypes,
			pointKeyFigures: store.PointReducer.pointKeyFigures,
			selectedStations: store.SitesReducer.selectedStations
		};
	};
	
	var dragContext = (0, _reactDnd.DragDropContext)(_reactDndHtml5Backend2.default)(PointApp);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(dragContext);

/***/ },
/* 2155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _DtoCity = __webpack_require__(87);
	
	var _DtoCity2 = _interopRequireDefault(_DtoCity);
	
	var _DtoPoint = __webpack_require__(86);
	
	var _DtoPoint2 = _interopRequireDefault(_DtoPoint);
	
	var _lodash = __webpack_require__(15);
	
	var _DtoNetwork = __webpack_require__(1038);
	
	var _DtoNetwork2 = _interopRequireDefault(_DtoNetwork);
	
	var _DateUtil = __webpack_require__(67);
	
	var _DtoWatershed = __webpack_require__(183);
	
	var _DtoWatershed2 = _interopRequireDefault(_DtoWatershed);
	
	var _NumberUtils = __webpack_require__(151);
	
	var _SitesAction = __webpack_require__(97);
	
	var _SitesAction2 = _interopRequireDefault(_SitesAction);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _DtoStation = __webpack_require__(88);
	
	var _DtoStation2 = _interopRequireDefault(_DtoStation);
	
	var _Checkbox = __webpack_require__(394);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PointDescriptionPanel = function (_Component) {
		_inherits(PointDescriptionPanel, _Component);
	
		function PointDescriptionPanel(props) {
			_classCallCheck(this, PointDescriptionPanel);
	
			var _this = _possibleConstructorReturn(this, (PointDescriptionPanel.__proto__ || Object.getPrototypeOf(PointDescriptionPanel)).call(this, props));
	
			_this.putInformations = function (title, value) {
				if (value) {
					return _react2.default.createElement(
						'div',
						{ className: 'row no-margin' },
						_react2.default.createElement(
							'div',
							{ className: 'col s2 left-align' },
							_react2.default.createElement(
								'b',
								null,
								title
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'col s10 left-align' },
							value
						)
					);
				}
				return null;
			};
	
			_this.getNetworks = function () {
				if (_this.props.pointNetworks && _this.props.pointNetworks.length) {
					var result = (0, _lodash.orderBy)(_this.props.pointNetworks, ['beginDate'], ['desc']).map(function (o) {
						var dateBegin = o.beginDate ? (0, _DateUtil.getDate)(o.beginDate) : '';
						var endDate = o.endDate ? (0, _DateUtil.getDate)(o.endDate) : '';
						return _react2.default.createElement(
							'div',
							{ className: 'row no-margin' },
							_react2.default.createElement(
								'div',
								{ className: 'col s2 no-padding' },
								o.code
							),
							_react2.default.createElement(
								'div',
								{ className: 'col s6 no-padding truncate' },
								o.name
							),
							_react2.default.createElement(
								'div',
								{ className: 'col s2 no-padding center-align' },
								dateBegin
							),
							_react2.default.createElement(
								'div',
								{ className: 'col s2 no-padding center-align' },
								endDate
							)
						);
					});
					return _this.putInformations(_simpleReactI18n2.default.point.network, result);
				}
				return null;
			};
	
			_this.getWaterShed = function () {
				if (_this.props.watersheds && _this.props.watersheds.length) {
					if (_this.props.point.watershedId) {
						var watershed = (0, _lodash.find)(_this.props.watersheds, function (o) {
							return o.id == _this.props.point.watershedId;
						});
						if (watershed) {
							return _this.putInformations(_simpleReactI18n2.default.point.watershed, watershed.name + ' [' + watershed.code + ']');
						}
						return null;
					}
					return null;
				}
				return null;
			};
	
			_this.getCoordinates = function () {
				if (_this.props.point.xCoordinate && _this.props.point.xCoordinate) {
					var coordinate = _simpleReactI18n2.default.point.longitude + ' : ' + (0, _NumberUtils.formatNumber)(_this.props.point.xCoordinate) + ' ' + _simpleReactI18n2.default.point.latitude + ' : ' + (0, _NumberUtils.formatNumber)(_this.props.point.yCoordinate);
					var finalTotal = function () {
						if (_this.props.point.altitude) {
							return coordinate + ' ' + _simpleReactI18n2.default.point.altitude + ' : ' + _this.props.point.altitude;
						}
						return coordinate;
					}();
					return _this.putInformations(_simpleReactI18n2.default.point.coordinate, finalTotal);
				}
				return null;
			};
	
			_this.updateCheck = function () {
				var station = (0, _lodash.find)(_this.props.stations, function (o) {
					return o.id == _this.props.point.id && o.typeId == _this.props.point.typeId;
				});
				_AppStore2.default.dispatch(_SitesAction2.default.toggleSelectedStations(station));
			};
	
			_this.getCheckStation = function () {
				if (_this.props.selectedStations.length) {
					var result = (0, _lodash.find)(_this.props.selectedStations, function (o) {
						return o.id === _this.props.point.id;
					});
					return !!result;
				}
				return false;
			};
	
			_this.getCheck = function () {
				if (_this.props.selectedStations.length) {
					return _react2.default.createElement(
						'div',
						{ className: 'col s1 no-padding' },
						_react2.default.createElement(
							'div',
							{ className: 'row no-margin' },
							_react2.default.createElement(
								'div',
								{ className: 'col s2 no-padding left' },
								_react2.default.createElement(_Checkbox2.default, {
									checked: _this.getCheckStation(),
									onCheck: function onCheck() {
										return _this.updateCheck();
									}
								})
							)
						)
					);
				}
				return null;
			};
	
			_this.getData = function () {
				var city = function () {
					if (_this.props.point.cityId) {
						var result = (0, _lodash.find)(_this.props.cities, function (o) {
							return o.id == _this.props.point.cityId;
						});
						if (result) {
							return result.postalCode + ' - ' + result.name + ' [' + result.code + ']';
						}
						return null;
					}
					return null;
				}();
				var check = _this.getCheck();
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin valign-wrapper' },
					check,
					_react2.default.createElement(
						'div',
						{ className: 'col s' + (check ? '11' : '12') },
						_react2.default.createElement(
							'div',
							{ className: 'row no-margin' },
							_react2.default.createElement(
								'div',
								{ className: 'col s12' },
								_this.putInformations(_simpleReactI18n2.default.point.denomination, _this.props.point.name),
								_this.putInformations(_simpleReactI18n2.default.point.code, _this.props.point.code),
								_this.putInformations(_simpleReactI18n2.default.point.localization, _this.props.point.localisation),
								_this.putInformations(_simpleReactI18n2.default.point.city, city),
								_this.getCoordinates(),
								_this.getNetworks(),
								_this.getWaterShed()
							)
						)
					)
				);
			};
	
			return _this;
		}
	
		_createClass(PointDescriptionPanel, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'row card', id: this.props.id },
					_react2.default.createElement(
						'div',
						{ className: 'card-content' },
						this.getData()
					)
				);
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				this.props.setHeight(document.getElementById(this.props.id).clientHeight);
			}
		}]);
	
		return PointDescriptionPanel;
	}(_react.Component);
	
	PointDescriptionPanel.propTypes = {
		id: _propTypes2.default.string.isRequired,
		point: _propTypes2.default.objectOf(_DtoPoint2.default),
		cities: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoCity2.default)),
		pointNetworks: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoNetwork2.default)),
		watersheds: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoWatershed2.default)),
		stations: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoStation2.default)),
		selectedStations: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoStation2.default)),
		setHeight: _propTypes2.default.func
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			point: store.PointReducer.point,
			cities: store.ReferentialReducer.cities,
			watersheds: store.ReferentialReducer.watersheds,
			pointNetworks: store.PointReducer.pointNetworks,
			stations: store.SitesReducer.stations,
			selectedStations: store.SitesReducer.selectedStations
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(PointDescriptionPanel);

/***/ },
/* 2156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _DtoPoint = __webpack_require__(86);
	
	var _DtoPoint2 = _interopRequireDefault(_DtoPoint);
	
	var _DtoKeyFigures = __webpack_require__(98);
	
	var _DtoKeyFigures2 = _interopRequireDefault(_DtoKeyFigures);
	
	var _lodash = __webpack_require__(15);
	
	var _DtoSiteType = __webpack_require__(96);
	
	var _DtoSiteType2 = _interopRequireDefault(_DtoSiteType);
	
	var _SiteTypes = __webpack_require__(56);
	
	var _SiteTypes2 = _interopRequireDefault(_SiteTypes);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _StringUtils = __webpack_require__(131);
	
	var _DateUtil = __webpack_require__(67);
	
	var _IndicatorPanel = __webpack_require__(1023);
	
	var _IndicatorPanel2 = _interopRequireDefault(_IndicatorPanel);
	
	var _PositionConstants = __webpack_require__(1055);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PointKeyFiguresPanel = function (_Component) {
		_inherits(PointKeyFiguresPanel, _Component);
	
		function PointKeyFiguresPanel(props) {
			_classCallCheck(this, PointKeyFiguresPanel);
	
			var _this = _possibleConstructorReturn(this, (PointKeyFiguresPanel.__proto__ || Object.getPrototypeOf(PointKeyFiguresPanel)).call(this, props));
	
			_this.createKeyFigureObject = function (title, value) {
				var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _PositionConstants.LEFT_POSITION;
	
				return {
					title: title,
					titlePosition: position,
					number: value
				};
			};
	
			_this.getKeyFigures = function () {
				return (0, _lodash.filter)(_this.props.pointKeyFigures, function (o) {
					return o.typeId == _this.props.siteType.id;
				});
			};
	
			_this.getPiezometerKeyfigures = function () {
				var keyFigures = _this.getKeyFigures();
				if (keyFigures) {
					var keyFiguresToShow = [];
					keyFigures.forEach(function (o) {
						keyFiguresToShow.push(_this.createKeyFigureObject(_simpleReactI18n2.default.measure + (0, _StringUtils.getPlurialWithNumber)(o.nbMeasure), o.nbMeasure, _PositionConstants.RIGHT_POSITION));
						keyFiguresToShow.push(_this.createKeyFigureObject(_simpleReactI18n2.default.of, (0, _DateUtil.getDate)(o.beginDate)));
						keyFiguresToShow.push(_this.createKeyFigureObject(_simpleReactI18n2.default.to, (0, _DateUtil.getDate)(o.endDate)));
					});
					return keyFiguresToShow;
				}
				return [];
			};
	
			_this.getQualitometerKeyfigures = function () {
				var keyFigures = _this.getKeyFigures();
				if (keyFigures && keyFigures.length) {
					var keyFiguresToShow = [];
					if (_this.props.siteType.parameter == _SiteTypes2.default.QUALITOMETER_SURFACE.type) {
						var analysisSum = (0, _lodash.sumBy)(keyFigures, 'nbAnalysis');
						keyFiguresToShow.push(_this.createKeyFigureObject(_simpleReactI18n2.default.analysis + (0, _StringUtils.getPlurialWithNumber)(analysisSum), analysisSum, _PositionConstants.RIGHT_POSITION));
						var firstDate = (0, _lodash.minBy)(keyFigures, 'beginDate');
						if (firstDate) {
							keyFiguresToShow.push(_this.createKeyFigureObject(_simpleReactI18n2.default.of, (0, _DateUtil.getDate)(firstDate.beginDate)));
						}
						var lastDate = (0, _lodash.maxBy)(keyFigures, 'endDate');
						if (lastDate) {
							keyFiguresToShow.push(_this.createKeyFigureObject(_simpleReactI18n2.default.to, (0, _DateUtil.getDate)(lastDate.endDate)));
						}
						keyFiguresToShow.push(_this.createKeyFigureObject(_simpleReactI18n2.default.point.samplingPoint + (0, _StringUtils.getPlurialWithNumber)(keyFigures.length), keyFigures.length));
					} else {
						keyFigures.forEach(function (o) {
							keyFiguresToShow.push(_this.createKeyFigureObject(_simpleReactI18n2.default.analysis + (0, _StringUtils.getPlurialWithNumber)(o.nbAnalysis), o.nbAnalysis, _PositionConstants.RIGHT_POSITION));
							keyFiguresToShow.push(_this.createKeyFigureObject(_simpleReactI18n2.default.of, (0, _DateUtil.getDate)(o.beginDate)));
							keyFiguresToShow.push(_this.createKeyFigureObject(_simpleReactI18n2.default.to, (0, _DateUtil.getDate)(o.endDate)));
						});
					}
					return keyFiguresToShow;
				}
				return [];
			};
	
			_this.getData = function () {
				switch (_this.props.siteType.parameter) {
					case _SiteTypes2.default.QUALITOMETER.type:
					case _SiteTypes2.default.QUALITOMETER_SURFACE.type:
						return _this.getQualitometerKeyfigures();
					case _SiteTypes2.default.PIEZOMETER.type:
					case _SiteTypes2.default.PIEZOMETER_REFERENCE.type:
						return _this.getPiezometerKeyfigures();
					default:
						return [];
				}
			};
	
			return _this;
		}
	
		_createClass(PointKeyFiguresPanel, [{
			key: 'render',
			value: function render() {
				var data = this.getData();
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin' },
					_react2.default.createElement(
						'div',
						{ className: 'col s12 no-padding' },
						_react2.default.createElement(_IndicatorPanel2.default, { datas: data })
					)
				);
			}
		}]);
	
		return PointKeyFiguresPanel;
	}(_react.Component);
	
	PointKeyFiguresPanel.propTypes = {
		siteType: _propTypes2.default.objectOf(_DtoSiteType2.default),
		point: _propTypes2.default.objectOf(_DtoPoint2.default),
		pointKeyFigures: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoKeyFigures2.default)),
		siteTypes: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoSiteType2.default))
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			point: store.PointReducer.point,
			pointKeyFigures: store.PointReducer.pointKeyFigures,
			siteTypes: store.ReferentialReducer.siteTypes
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(PointKeyFiguresPanel);

/***/ },
/* 2157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _OSMSatellite = __webpack_require__(2216);
	
	var _OSMSatellite2 = _interopRequireDefault(_OSMSatellite);
	
	var _SiteTypes = __webpack_require__(56);
	
	var _SiteTypes2 = _interopRequireDefault(_SiteTypes);
	
	var _SingleStationPoint = __webpack_require__(548);
	
	var _SingleStationPoint2 = _interopRequireDefault(_SingleStationPoint);
	
	var _Map = __webpack_require__(289);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _DtoPoint = __webpack_require__(86);
	
	var _DtoPoint2 = _interopRequireDefault(_DtoPoint);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PointMap = function (_Component) {
		_inherits(PointMap, _Component);
	
		function PointMap(props) {
			_classCallCheck(this, PointMap);
	
			var _this = _possibleConstructorReturn(this, (PointMap.__proto__ || Object.getPrototypeOf(PointMap)).call(this, props));
	
			_this.getData = function () {
				if (_this.props.point.xCoordinate && _this.props.point.yCoordinate) {
					var layersGroup1 = [(0, _OSMSatellite2.default)(), (0, _SingleStationPoint2.default)({
						site: _this.props.point,
						type: _SiteTypes2.default[_this.props.point.typeParameter]
					})];
					var mapConf = {
						size: _this.props.height,
						center: [_this.props.point.xCoordinate, _this.props.point.yCoordinate],
						zoom: 18
					};
					return [mapConf, layersGroup1];
				}
				return ['', ''];
			};
	
			return _this;
		}
	
		_createClass(PointMap, [{
			key: 'render',
			value: function render() {
				if (this.props.point) {
					var data = this.getData();
					return _react2.default.createElement(
						'div',
						{ className: 'row map-point-panel no-margin' },
						_react2.default.createElement(
							'div',
							{ className: 'col s12 no-padding' },
							_react2.default.createElement(_Map2.default, { mapConf: data[0], layers: data[1] })
						)
					);
				}
				return null;
			}
		}]);
	
		return PointMap;
	}(_react.Component);
	
	PointMap.propTypes = {
		point: _propTypes2.default.objectOf(_DtoPoint2.default),
		height: _propTypes2.default.number
	};
	
	PointMap.defaultProps = {
		height: 100
	};
	var mapStateToProps = function mapStateToProps(store) {
		return {
			point: store.PointReducer.point
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(PointMap);

/***/ },
/* 2158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _DtoPoint = __webpack_require__(86);
	
	var _DtoPoint2 = _interopRequireDefault(_DtoPoint);
	
	var _QualityPanel = __webpack_require__(2159);
	
	var _QualityPanel2 = _interopRequireDefault(_QualityPanel);
	
	var _SiteTypes = __webpack_require__(56);
	
	var _SiteTypes2 = _interopRequireDefault(_SiteTypes);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TypePointPanel = function (_Component) {
		_inherits(TypePointPanel, _Component);
	
		function TypePointPanel(props) {
			_classCallCheck(this, TypePointPanel);
	
			var _this = _possibleConstructorReturn(this, (TypePointPanel.__proto__ || Object.getPrototypeOf(TypePointPanel)).call(this, props));
	
			_this.getDefaultPanel = function () {
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin' },
					_react2.default.createElement(
						'div',
						{ className: 'col s12 no-padding font-size-20' },
						_simpleReactI18n2.default.warning.noInformationAvailable
					)
				);
			};
	
			_this.getData = function () {
				switch (_this.props.parameter) {
					case _SiteTypes2.default.QUALITOMETER.type:
					case _SiteTypes2.default.QUALITOMETER_SURFACE.type:
						return _react2.default.createElement(_QualityPanel2.default, null);
					default:
						return _this.getDefaultPanel();
				}
			};
	
			return _this;
		}
	
		_createClass(TypePointPanel, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin' },
					_react2.default.createElement(
						'div',
						{ className: 'col s12 no-padding' },
						this.getData()
					)
				);
			}
		}]);
	
		return TypePointPanel;
	}(_react.Component);
	
	TypePointPanel.propTypes = {
		point: _propTypes2.default.objectOf(_DtoPoint2.default),
		parameter: _propTypes2.default.string
	};
	var mapStateToProps = function mapStateToProps(store) {
		return {
			siteTypes: store.ReferentialReducer.siteTypes,
			point: store.PointReducer.point
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(TypePointPanel);

/***/ },
/* 2159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _SamplingSurfacePointPanel = __webpack_require__(2161);
	
	var _SamplingSurfacePointPanel2 = _interopRequireDefault(_SamplingSurfacePointPanel);
	
	var _DtoPoint = __webpack_require__(86);
	
	var _DtoPoint2 = _interopRequireDefault(_DtoPoint);
	
	var _TitlePanel = __webpack_require__(2165);
	
	var _TitlePanel2 = _interopRequireDefault(_TitlePanel);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _PointConstants = __webpack_require__(535);
	
	var _NoInformationPanel = __webpack_require__(1037);
	
	var _NoInformationPanel2 = _interopRequireDefault(_NoInformationPanel);
	
	var _DtoSamplingSurfacePoint = __webpack_require__(379);
	
	var _DtoSamplingSurfacePoint2 = _interopRequireDefault(_DtoSamplingSurfacePoint);
	
	var _SiteTypes = __webpack_require__(56);
	
	var _SiteTypes2 = _interopRequireDefault(_SiteTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QualityPanel = function (_Component) {
		_inherits(QualityPanel, _Component);
	
		function QualityPanel(props) {
			_classCallCheck(this, QualityPanel);
	
			var _this = _possibleConstructorReturn(this, (QualityPanel.__proto__ || Object.getPrototypeOf(QualityPanel)).call(this, props));
	
			_this.getSurfaceQualitometerTabs = function () {
				return [{
					title: _simpleReactI18n2.default.description,
					value: _PointConstants.PANEL_QUALITY_ANALYSIS,
					active: true
				}, {
					title: _simpleReactI18n2.default.point.samplingPoint + '(' + _this.props.samplingSurfacePoints.length + ')',
					value: _PointConstants.PANEL_QUALITY_SAMPLING_POINTS,
					active: false
				}];
			};
	
			_this.getQualitometerTabs = function () {
				return [{
					title: _simpleReactI18n2.default.description,
					value: _PointConstants.PANEL_QUALITY_ANALYSIS,
					active: true
				}];
			};
	
			_this.getTabs = function () {
				var tabs = function () {
					switch (_this.props.point.typeParameter) {
						case _SiteTypes2.default.QUALITOMETER_SURFACE.type:
							return _this.getSurfaceQualitometerTabs();
						default:
							return _this.getQualitometerTabs();
					}
				}();
				if (tabs.length > 1) {
					var finalTabs = tabs.map(function (o) {
						if (o.active) {
							return _react2.default.createElement(
								'li',
								{ className: 'tab active' },
								_react2.default.createElement(
									'a',
									{ onClick: function onClick() {
											return _this.changePanel(o.value);
										} },
									o.title
								)
							);
						}
						return _react2.default.createElement(
							'li',
							{ className: 'tab' },
							_react2.default.createElement(
								'a',
								{ onClick: function onClick() {
										return _this.changePanel(o.value);
									} },
								o.title
							)
						);
					});
					return _react2.default.createElement(
						'ul',
						{ className: 'tabs tabs-fixed-width' },
						finalTabs
					);
				}
				return null;
			};
	
			_this.changePanel = function (value) {
				_this.setState({
					panel: value
				});
			};
	
			_this.getPanel = function () {
				switch (_this.state.panel) {
					case _PointConstants.PANEL_QUALITY_ANALYSIS:
						return _react2.default.createElement(_NoInformationPanel2.default, null);
					case _PointConstants.PANEL_QUALITY_SAMPLING_POINTS:
						return _react2.default.createElement(_SamplingSurfacePointPanel2.default, null);
					default:
						return null;
				}
			};
	
			_this.state = {
				panel: _PointConstants.PANEL_QUALITY_ANALYSIS
			};
			return _this;
		}
	
		_createClass(QualityPanel, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'row card no-margin' },
					_react2.default.createElement(
						'div',
						{ className: 'row no-margin' },
						_react2.default.createElement(
							'div',
							{ className: 'col s12 no-padding' },
							_react2.default.createElement(
								'b',
								null,
								_react2.default.createElement(_TitlePanel2.default, { title: _simpleReactI18n2.default.quality })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'row no-margin' },
						_react2.default.createElement(
							'div',
							{ className: 'col s12 no-padding' },
							this.getTabs()
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'row no-margin' },
						this.getPanel()
					)
				);
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				$('ul.tabs').tabs();
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				$('ul.tabs').tabs();
			}
		}]);
	
		return QualityPanel;
	}(_react.Component);
	
	QualityPanel.propTypes = {
		point: _propTypes2.default.objectOf(_DtoPoint2.default),
		samplingSurfacePoints: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoSamplingSurfacePoint2.default))
	};
	var mapStateToProps = function mapStateToProps(store) {
		return {
			point: store.PointReducer.point,
			samplingSurfacePoints: store.PointReducer.samplingSurfacePoints
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(QualityPanel);

/***/ },
/* 2160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _DtoSamplingSurfacePoint = __webpack_require__(379);
	
	var _DtoSamplingSurfacePoint2 = _interopRequireDefault(_DtoSamplingSurfacePoint);
	
	var _lodash = __webpack_require__(15);
	
	var _SitesPoint = __webpack_require__(549);
	
	var _SitesPoint2 = _interopRequireDefault(_SitesPoint);
	
	var _SingleStationPoint = __webpack_require__(548);
	
	var _SingleStationPoint2 = _interopRequireDefault(_SingleStationPoint);
	
	var _PopupFactory = __webpack_require__(547);
	
	var _PopupFactory2 = _interopRequireDefault(_PopupFactory);
	
	var _OSM = __webpack_require__(290);
	
	var _OSM2 = _interopRequireDefault(_OSM);
	
	var _SiteTypes = __webpack_require__(56);
	
	var _SiteTypes2 = _interopRequireDefault(_SiteTypes);
	
	var _DtoPoint = __webpack_require__(86);
	
	var _DtoPoint2 = _interopRequireDefault(_DtoPoint);
	
	var _DtoSupport = __webpack_require__(150);
	
	var _DtoSupport2 = _interopRequireDefault(_DtoSupport);
	
	var _Map = __webpack_require__(289);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SamplingSurfacePointMapPanel = function (_Component) {
		_inherits(SamplingSurfacePointMapPanel, _Component);
	
		function SamplingSurfacePointMapPanel(props) {
			_classCallCheck(this, SamplingSurfacePointMapPanel);
	
			var _this = _possibleConstructorReturn(this, (SamplingSurfacePointMapPanel.__proto__ || Object.getPrototypeOf(SamplingSurfacePointMapPanel)).call(this, props));
	
			_this.getData = function () {
				if (_this.props.point.xCoordinate && _this.props.point.yCoordinate) {
					var layersGroup1 = [(0, _OSM2.default)()];
	
					var data = _this.props.samplingSurfacePoints.map(function (samplingSurfacePoints) {
						if (samplingSurfacePoints.supportCode) {
							var support = (0, _lodash.find)(_this.props.supports, function (o) {
								return o.id == samplingSurfacePoints.supportCode;
							});
							if (support) {
								return Object.assign({}, samplingSurfacePoints, {
									name: support.name + ' [' + samplingSurfacePoints.supportCode + ']'
								});
							}
							return samplingSurfacePoints;
						}
						return samplingSurfacePoints;
					});
	
					var saplingSurfacePoints = function () {
						return (0, _SitesPoint2.default)({
							site: data,
							type: _SiteTypes2.default.SAMPLING_SURFACE_POINT,
							popup: _PopupFactory2.default.popupSamplingSurfacePoint
						});
					}();
	
					var mapConf = {
						size: _this.props.height,
						center: [_this.props.point.xCoordinate, _this.props.point.yCoordinate],
						zoom: 18
					};
					var stationPoint = (0, _SingleStationPoint2.default)({
						site: _this.props.point,
						type: _SiteTypes2.default[_this.props.point.typeParameter]
					});
					var layers = layersGroup1.concat(saplingSurfacePoints, [stationPoint]);
					return [mapConf, layers];
				}
				return ['', ''];
			};
	
			_this.state = {
				popupFilter: ['Point']
			};
			return _this;
		}
	
		_createClass(SamplingSurfacePointMapPanel, [{
			key: 'render',
			value: function render() {
				if (this.props.samplingSurfacePoints.length) {
					var data = this.getData();
					var popupProps = {
						filters: this.state.popupFilter
					};
					return _react2.default.createElement(
						'div',
						{ className: 'row no-margin' },
						_react2.default.createElement(
							'div',
							{ className: 'col s12 no-padding' },
							_react2.default.createElement(_Map2.default, { mapConf: data[0], layers: data[1], popupProps: popupProps })
						)
					);
				}
				return null;
			}
		}]);
	
		return SamplingSurfacePointMapPanel;
	}(_react.Component);
	
	SamplingSurfacePointMapPanel.propTypes = {
		samplingSurfacePoints: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoSamplingSurfacePoint2.default)),
		point: _propTypes2.default.objectOf(_DtoPoint2.default),
		supports: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoSupport2.default)),
		height: _propTypes2.default.number
	};
	
	SamplingSurfacePointMapPanel.defaultProps = {
		height: 400
	};
	var mapStateToProps = function mapStateToProps(store) {
		return {
			samplingSurfacePoints: store.PointReducer.samplingSurfacePoints,
			supports: store.ReferentialReducer.supports,
			point: store.PointReducer.point
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(SamplingSurfacePointMapPanel);

/***/ },
/* 2161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _DtoSamplingSurfacePoint = __webpack_require__(379);
	
	var _DtoSamplingSurfacePoint2 = _interopRequireDefault(_DtoSamplingSurfacePoint);
	
	var _DtoSupport = __webpack_require__(150);
	
	var _DtoSupport2 = _interopRequireDefault(_DtoSupport);
	
	var _DtoKeyFigures = __webpack_require__(98);
	
	var _DtoKeyFigures2 = _interopRequireDefault(_DtoKeyFigures);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _core = __webpack_require__(116);
	
	var _lodash = __webpack_require__(15);
	
	var _uuid = __webpack_require__(44);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _NumberUtils = __webpack_require__(151);
	
	var _map_sampling_point = __webpack_require__(1061);
	
	var _map_sampling_point2 = _interopRequireDefault(_map_sampling_point);
	
	var _DateUtil = __webpack_require__(67);
	
	var _SamplingSurfacePointMapPanel = __webpack_require__(2160);
	
	var _SamplingSurfacePointMapPanel2 = _interopRequireDefault(_SamplingSurfacePointMapPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SamplingSurfacePointPanel = function (_Component) {
		_inherits(SamplingSurfacePointPanel, _Component);
	
		function SamplingSurfacePointPanel(props) {
			_classCallCheck(this, SamplingSurfacePointPanel);
	
			var _this = _possibleConstructorReturn(this, (SamplingSurfacePointPanel.__proto__ || Object.getPrototypeOf(SamplingSurfacePointPanel)).call(this, props));
	
			_this.createInformation = function (title, value) {
				return title + ' : ' + value;
			};
	
			_this.getLeftAvatar = function () {
				return _react2.default.createElement(_core.Avatar, { src: _map_sampling_point2.default, style: {
						width: 'auto',
						backgroundColor: 'none'
					}
				});
			};
	
			_this.getRightAvatar = function (nbAnalysis) {
				if (nbAnalysis) {
					return _react2.default.createElement(
						_core.Avatar,
						{ size: 40, style: { fontSize: '10px !important' } },
						(0, _NumberUtils.nFormatter)(nbAnalysis)
					);
				}
				return _react2.default.createElement(
					_core.Chip,
					null,
					_simpleReactI18n2.default.noData
				);
			};
	
			_this.getTitle = function (sampling) {
				var support = function () {
					if (sampling.supportCode) {
						var supportRef = (0, _lodash.find)(_this.props.supports, function (o) {
							return o.id == sampling.supportCode;
						});
						if (supportRef) {
							return ' - ' + supportRef.name + ' [' + sampling.supportCode + ']';
						}
						return '';
					}
					return '';
				}();
	
				if (sampling.code) {
					return _this.createInformation(_simpleReactI18n2.default.code, sampling.code) + ' ' + support;
				}
				return support;
			};
	
			_this.getSecondaryText = function (sampling, keyfigures) {
				var keyFigureInformation = function () {
					if (keyfigures) {
						var beginDate = (0, _DateUtil.getDate)(keyfigures.beginDate);
						var endDate = (0, _DateUtil.getDate)(keyfigures.endDate);
						var begin = function () {
							if (beginDate) {
								return _this.createInformation(_simpleReactI18n2.default.firstDate, beginDate);
							}
							return '';
						}();
						var end = function () {
							if (endDate) {
								return _this.createInformation(_simpleReactI18n2.default.lastDate, endDate);
							}
							return '';
						}();
						return begin + '  ' + end;
					}
					return null;
				}();
				if (sampling.status) {
					return _this.createInformation(_simpleReactI18n2.default.status, sampling.status) + '  ' + keyFigureInformation;
				}
				return keyFigureInformation;
			};
	
			_this.getRow = function (sampling) {
				var keyfigures = (0, _lodash.find)(_this.props.pointKeyFigures, function (o) {
					return o.samplingId == sampling.id;
				});
				var nbAnalysis = function () {
					if (keyfigures) {
						return keyfigures.nbAnalysis;
					}
					return 0;
				}();
				return _react2.default.createElement(
					'div',
					{ key: _uuid2.default.v4(), className: 'col s12 no-padding' },
					_react2.default.createElement(_core.ListItem, { key: _uuid2.default.v4(), primaryText: _this.getTitle(sampling), secondaryText: _this.getSecondaryText(sampling, keyfigures),
						leftAvatar: _this.getLeftAvatar(), rightAvatar: _this.getRightAvatar(nbAnalysis) })
				);
			};
	
			_this.getData = function () {
				return _this.props.samplingSurfacePoints.map(function (sampling) {
					return _this.getRow(sampling);
				});
			};
	
			return _this;
		}
	
		_createClass(SamplingSurfacePointPanel, [{
			key: 'render',
			value: function render() {
				if (this.props.samplingSurfacePoints.length) {
					return _react2.default.createElement(
						'div',
						{ className: 'row no-margin' },
						_react2.default.createElement(
							'div',
							{ className: 'row no-margin' },
							_react2.default.createElement(
								'div',
								{ className: 'col s8 no-padding' },
								_react2.default.createElement(
									_core.List,
									null,
									this.getData()
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'col s4 no-padding' },
								_react2.default.createElement(_SamplingSurfacePointMapPanel2.default, null)
							)
						)
					);
				}
				return null;
			}
		}]);
	
		return SamplingSurfacePointPanel;
	}(_react.Component);
	
	SamplingSurfacePointPanel.propTypes = {
		samplingSurfacePoints: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoSamplingSurfacePoint2.default)),
		pointKeyFigures: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoKeyFigures2.default)),
		supports: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoSupport2.default))
	};
	var mapStateToProps = function mapStateToProps(store) {
		return {
			samplingSurfacePoints: store.PointReducer.samplingSurfacePoints,
			pointKeyFigures: store.PointReducer.pointKeyFigures,
			supports: store.ReferentialReducer.supports
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(SamplingSurfacePointPanel);

/***/ },
/* 2162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _lodash = __webpack_require__(15);
	
	var _SiteTypes = __webpack_require__(56);
	
	var _SiteTypes2 = _interopRequireDefault(_SiteTypes);
	
	var _NumberUtils = __webpack_require__(151);
	
	var _uuid = __webpack_require__(44);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _core = __webpack_require__(116);
	
	var _DateUtil = __webpack_require__(67);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _DtoStation = __webpack_require__(88);
	
	var _DtoStation2 = _interopRequireDefault(_DtoStation);
	
	var _DtoKeyFigures = __webpack_require__(98);
	
	var _DtoKeyFigures2 = _interopRequireDefault(_DtoKeyFigures);
	
	var _DtoSiteType = __webpack_require__(96);
	
	var _DtoSiteType2 = _interopRequireDefault(_DtoSiteType);
	
	var _DtoPoint = __webpack_require__(86);
	
	var _DtoPoint2 = _interopRequireDefault(_DtoPoint);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PointProximityPanel = function (_Component) {
		_inherits(PointProximityPanel, _Component);
	
		function PointProximityPanel(props) {
			_classCallCheck(this, PointProximityPanel);
	
			var _this = _possibleConstructorReturn(this, (PointProximityPanel.__proto__ || Object.getPrototypeOf(PointProximityPanel)).call(this, props));
	
			_this.getLeftAvatar = function (referenceType) {
				return _react2.default.createElement(_core.Avatar, { size: 40, src: referenceType.icon, style: {
						width: 'auto',
						backgroundColor: 'none'
					} });
			};
	
			_this.getSecondaryText = function (station) {
				var keyFigureStation = (0, _lodash.find)(_this.props.keyFigures, function (o) {
					return o.stationId == station.id && o.typeId == _this.props.siteType.id;
				});
				if (keyFigureStation && keyFigureStation.endDate) {
					var nbData = keyFigureStation.nbAnalysis ? keyFigureStation.nbAnalysis : keyFigureStation.nbMeasure;
					return nbData + ' - ' + _simpleReactI18n2.default.of + ' ' + (0, _DateUtil.getDate)(keyFigureStation.beginDate) + ' ' + _simpleReactI18n2.default.to + ' ' + (0, _DateUtil.getDate)(keyFigureStation.endDate);
				}
				return '';
			};
	
			_this.getData = function () {
				if (_this.props.proximityStation) {
					var filterByTypes = (0, _lodash.reduce)((0, _lodash.filter)(_this.props.proximityStation, function (o) {
						return o.station.id != _this.props.point.id;
					}), function (result, value) {
						var tmpType = _SiteTypes2.default.getType(value.station.typeId, _this.props.siteTypes);
						if (result[tmpType.type] || (result[tmpType.type] = [])) {
							(result[tmpType.type] || (result[tmpType.type] = [])).push(value);
						}
						return result;
					}, {});
					var result = (0, _lodash.orderBy)(Object.keys(filterByTypes).map(function (type) {
						if (filterByTypes[type].length) {
							var stationOrder = (0, _lodash.orderBy)(filterByTypes[type], 'distance', 'asc')[0];
							var stationSelected = stationOrder.station;
							var referenceType = _SiteTypes2.default[type];
							return {
								stationSelected: stationSelected,
								referenceType: referenceType,
								distance: stationOrder.distance
							};
						}
						return null;
					}), 'distance', 'asc');
	
					return result.map(function (o) {
						return _react2.default.createElement(
							'div',
							{ key: _uuid2.default.v4(), className: 'col s12 no-padding' },
							_react2.default.createElement(_core.ListItem, { key: _uuid2.default.v4(), primaryText: o.stationSelected.name, secondaryText: _this.getSecondaryText(o.stationSelected),
								leftAvatar: _this.getLeftAvatar(o.referenceType),
								rightAvatar: _react2.default.createElement(
									_core.Avatar,
									{ size: 50, style: { fontSize: '5px !important' } },
									(0, _NumberUtils.formatNumber)(o.distance) + ' km'
								) })
						);
					});
				}
				return null;
			};
	
			return _this;
		}
	
		_createClass(PointProximityPanel, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin card' },
					_react2.default.createElement(
						'div',
						{ className: 'card-padding' },
						_react2.default.createElement(
							'div',
							{ className: 'card-title no-padding no-margin-bottom' },
							_react2.default.createElement(
								'h6',
								{ className: 'aquadb-title' },
								_simpleReactI18n2.default.proximityPoints
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'card-content no-padding' },
							_react2.default.createElement(
								'div',
								{ className: 'row no-margin' },
								_react2.default.createElement(
									_core.List,
									null,
									this.getData()
								)
							)
						)
					)
				);
			}
		}]);
	
		return PointProximityPanel;
	}(_react.Component);
	
	PointProximityPanel.propTypes = {
		proximityStation: _propTypes2.default.shape(_propTypes2.default.objectOf({
			distance: _propTypes2.default.number,
			station: _propTypes2.default.instanceOf(_DtoStation2.default)
		})),
		siteType: _propTypes2.default.objectOf(_DtoSiteType2.default),
		point: _propTypes2.default.objectOf(_DtoPoint2.default),
		siteTypes: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoSiteType2.default)),
		keyFigures: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoKeyFigures2.default))
	};
	var mapStateToProps = function mapStateToProps(store) {
		return {
			point: store.PointReducer.point,
			pointKeyFigures: store.PointReducer.pointKeyFigures,
			siteTypes: store.ReferentialReducer.siteTypes,
			keyFigures: store.SitesReducer.keyFigures
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(PointProximityPanel);

/***/ },
/* 2163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _DtoPoint = __webpack_require__(86);
	
	var _DtoPoint2 = _interopRequireDefault(_DtoPoint);
	
	var _DtoStation = __webpack_require__(88);
	
	var _DtoStation2 = _interopRequireDefault(_DtoStation);
	
	var _DtoKeyFigures = __webpack_require__(98);
	
	var _DtoKeyFigures2 = _interopRequireDefault(_DtoKeyFigures);
	
	var _lodash = __webpack_require__(15);
	
	var _echartsForReact = __webpack_require__(1450);
	
	var _echartsForReact2 = _interopRequireDefault(_echartsForReact);
	
	var _DateUtil = __webpack_require__(67);
	
	var _SiteTypes = __webpack_require__(56);
	
	var _SiteTypes2 = _interopRequireDefault(_SiteTypes);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DtoSiteType = __webpack_require__(96);
	
	var _DtoSiteType2 = _interopRequireDefault(_DtoSiteType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PointProximityChart = function (_Component) {
		_inherits(PointProximityChart, _Component);
	
		function PointProximityChart(props) {
			_classCallCheck(this, PointProximityChart);
	
			var _this = _possibleConstructorReturn(this, (PointProximityChart.__proto__ || Object.getPrototypeOf(PointProximityChart)).call(this, props));
	
			_this.getNbData = function (keyFigures) {
				//TODO Get key figures from type
				switch (_this.props.siteType.parameter) {
					case _SiteTypes2.default.QUALITOMETER.type:
					case _SiteTypes2.default.QUALITOMETER_SURFACE.type:
						return keyFigures.nbAnalysis;
					default:
						return keyFigures.nbMeasure;
				}
			};
	
			_this.createTabData = function (value, keyFigures) {
				var station = value.station;
				var stationKeyFigures = (0, _lodash.find)(keyFigures, function (b) {
					return b.stationId == station.id;
				});
				if (stationKeyFigures) {
					var distance = value.distance;
					var nbData = _this.getNbData(stationKeyFigures);
					var name = station.name;
					return {
						id: station.id,
						typeId: station.typeId,
						distance: distance,
						nbData: nbData,
						name: name
					};
				}
				return null;
			};
	
			_this.getData = function () {
				var keyFigures = (0, _lodash.intersectionWith)(_this.props.keyFigures, _this.props.proximityStation, function (a, b) {
					if (b.station) {
						return a.stationId == b.station.id && a.typeId == _this.props.siteType.id && a.endDate;
					}
					return null;
				});
				if (keyFigures && keyFigures.length) {
					var minYear = (0, _DateUtil.getYear)((0, _lodash.minBy)(keyFigures, 'endDate').endDate);
					var rangeYear = (0, _lodash.range)(minYear, (0, _DateUtil.getYear)((0, _moment2.default)().add(1, 'year'))).reverse();
					return (0, _lodash.flatten)(rangeYear.map(function (o) {
						var keyFiguresSelected = (0, _lodash.filter)(keyFigures, function (keyFigure) {
							return (0, _DateUtil.getYear)(keyFigure.endDate) == o;
						});
						if (keyFiguresSelected && keyFiguresSelected.length) {
							var stations = (0, _lodash.intersectionWith)(_this.props.proximityStation, keyFiguresSelected, function (a, b) {
								return a.station.id == b.stationId;
							});
							return stations.map(function (b) {
								return _this.createTabData(b, keyFigures);
							}).map(function (a) {
								return [a.distance, o, a.nbData, a.name];
							});
						}
						return [[null, o]];
					}));
				}
				return null;
			};
	
			_this.getStationData = function () {
				if (_this.props.pointKeyFigures.length) {
					var keyFigure = (0, _lodash.find)(_this.props.pointKeyFigures, function (o) {
						return o.typeId == _this.props.siteType.id;
					});
					if (keyFigure) {
						var year = Number((0, _DateUtil.getYear)(keyFigure.endDate));
						return [[0, year, _this.getNbData(_this.props.pointKeyFigures[0]), _this.props.point.name]];
					}
					return [];
				}
				return [];
			};
	
			_this.getLabel = function () {
				return {
					emphasis: {
						show: true,
						formatter: function formatter(param) {
							return param.data[3] + ' - ' + param.data[2];
						},
						color: 'black',
						position: 'top'
					}
				};
			};
	
			_this.getTitle = function () {
				return _simpleReactI18n2.default.proximityPoints + ' de type : ' + _SiteTypes2.default[_this.props.point.typeParameter].name(0);
			};
	
			_this.getOption = function () {
				var data = _this.getData();
				if (data && data.length) {
					var stationData = _this.getStationData();
					return {
						xAxis: {
							name: _simpleReactI18n2.default.distance + ' (en km)',
							scale: true
						},
						padding: 0,
						yAxis: {
							name: _simpleReactI18n2.default.dataHistory,
							type: 'category',
							scale: true
						},
						toolbox: {
							show: true,
							feature: {
								myTool2: {
									show: true,
									title: _simpleReactI18n2.default.fullScreen,
									icon: 'image://https://www.aquasys.fr/wp-content/uploads/2018/04/Antu_view-fullscreen.svg_.png',
									onclick: function onclick() {
										$('#proximityChart').toggleClass('fullscreen-chart');
										$('#proximityChartContent').toggleClass('fullscreen-chart');
									},
									iconStyle: {}
								},
								dataZoom: {
									yAxisIndex: 'none',
									title: _simpleReactI18n2.default.customZoom
								},
								restore: {
									title: _simpleReactI18n2.default.restore
								},
								saveAsImage: {
									title: _simpleReactI18n2.default.exportFunction
								}
							}
						},
						dataZoom: [{
							show: true,
							realtime: true,
							bottom: -2
						}],
						series: [{
							data: data,
							type: 'scatter',
							symbolSize: function symbolSize(d) {
								return Math.sqrt(d[2]) * 0.95;
							},
							label: _this.getLabel()
						}, {
							type: 'effectScatter',
							symbolSize: function symbolSize(d) {
								return Math.sqrt(d[2]) * 0.95;
							},
							data: stationData,
							label: _this.getLabel()
						}]
					};
				}
				return null;
			};
	
			return _this;
		}
	
		_createClass(PointProximityChart, [{
			key: 'render',
			value: function render() {
				var options = this.getOption();
				if (options) {
					return _react2.default.createElement(
						'div',
						{ className: 'row no-margin card', id: 'proximityChart' },
						_react2.default.createElement(
							'div',
							{ className: 'card-padding' },
							_react2.default.createElement(
								'div',
								{ className: 'card-title no-padding no-margin-bottom' },
								_react2.default.createElement(
									'h6',
									{ className: 'aquadb-title' },
									this.getTitle()
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'card-content no-padding', id: 'proximityChartContent' },
								_react2.default.createElement(_echartsForReact2.default, { option: this.getOption(),
									notMerge: true,
									lazyUpdate: true,
									style: { height: '500px' } })
							)
						)
					);
				}
				return null;
			}
		}]);
	
		return PointProximityChart;
	}(_react.Component);
	
	PointProximityChart.propTypes = {
		point: _propTypes2.default.objectOf(_DtoPoint2.default),
		siteType: _propTypes2.default.objectOf(_DtoSiteType2.default),
		proximityStation: _propTypes2.default.shape(_propTypes2.default.objectOf({
			distance: _propTypes2.default.number,
			station: _propTypes2.default.instanceOf(_DtoStation2.default)
		})),
		pointKeyFigures: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoKeyFigures2.default)),
		keyFigures: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoKeyFigures2.default))
	};
	var mapStateToProps = function mapStateToProps(store) {
		return {
			point: store.PointReducer.point,
			pointKeyFigures: store.PointReducer.pointKeyFigures,
			keyFigures: store.SitesReducer.keyFigures
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(PointProximityChart);

/***/ },
/* 2164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _DtoPoint = __webpack_require__(86);
	
	var _DtoPoint2 = _interopRequireDefault(_DtoPoint);
	
	var _DtoSource = __webpack_require__(222);
	
	var _DtoSource2 = _interopRequireDefault(_DtoSource);
	
	var _lodash = __webpack_require__(15);
	
	var _DateUtil = __webpack_require__(67);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SourcePanel = function (_Component) {
		_inherits(SourcePanel, _Component);
	
		function SourcePanel(props) {
			_classCallCheck(this, SourcePanel);
	
			var _this = _possibleConstructorReturn(this, (SourcePanel.__proto__ || Object.getPrototypeOf(SourcePanel)).call(this, props));
	
			_this.getSources = function () {
				if (_this.props.point.sourceId) {
					var source = (0, _lodash.find)(_this.props.sources, function (o) {
						return o.id === _this.props.point.sourceId;
					});
					if (source) {
						return _react2.default.createElement(
							'div',
							{ className: 'row no-margin valign-wrapper ' },
							_react2.default.createElement(
								'div',
								{ className: 'col s8 no-padding' },
								_simpleReactI18n2.default.source,
								' : ',
								source.name
							),
							_react2.default.createElement(
								'div',
								{ className: 'col s4 no-padding' },
								_react2.default.createElement(
									'a',
									{ href: source.url, target: '_blank' },
									_react2.default.createElement('img', { src: source.logo, height: '50' })
								)
							)
						);
					}
					return null;
				}
				return null;
			};
	
			_this.getLastUpdate = function () {
				if (_this.props.point.lastUpdate) {
					return (0, _DateUtil.getDate)(_this.props.point.lastUpdate);
				}
				return _simpleReactI18n2.default.unknown;
			};
	
			return _this;
		}
	
		_createClass(SourcePanel, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'row card' },
					_react2.default.createElement(
						'div',
						{ className: 'card-padding' },
						_react2.default.createElement(
							'div',
							{ className: 'card-content no-padding' },
							_react2.default.createElement(
								'div',
								{ className: 'row no-margin valign-wrapper ' },
								_react2.default.createElement(
									'div',
									{ className: 'col s6' },
									_react2.default.createElement(
										'div',
										{ className: 'row no-margin' },
										_react2.default.createElement(
											'div',
											{ className: 'col s12 no-padding' },
											_simpleReactI18n2.default.lastUpdate,
											' : ',
											this.getLastUpdate()
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col s6 right-align' },
									this.getSources()
								)
							)
						)
					)
				);
			}
		}]);
	
		return SourcePanel;
	}(_react.Component);
	
	SourcePanel.propTypes = {
		point: _propTypes2.default.objectOf(_DtoPoint2.default),
		sources: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoSource2.default))
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			point: store.PointReducer.point,
			sources: store.AdministrationReducer.sources
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(SourcePanel);

/***/ },
/* 2165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TitlePanel = function (_Component) {
		_inherits(TitlePanel, _Component);
	
		function TitlePanel(props) {
			_classCallCheck(this, TitlePanel);
	
			return _possibleConstructorReturn(this, (TitlePanel.__proto__ || Object.getPrototypeOf(TitlePanel)).call(this, props));
		}
	
		_createClass(TitlePanel, [{
			key: 'render',
			value: function render() {
				if (this.props.title) {
					return _react2.default.createElement(
						'div',
						{ className: 'card-title no-margin' },
						this.props.title
					);
				}
				return null;
			}
		}]);
	
		return TitlePanel;
	}(_react.Component);
	
	TitlePanel.propTypes = {
		title: _propTypes2.default.string.isRequired
	};
	TitlePanel.defaultProps = {
		title: ''
	};
	exports.default = TitlePanel;

/***/ },
/* 2166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.store = undefined;
	exports.PointReducer = PointReducer;
	
	var _PointConstants = __webpack_require__(535);
	
	var _DtoPoint = __webpack_require__(86);
	
	var _DtoPoint2 = _interopRequireDefault(_DtoPoint);
	
	var _DtoKeyFigures = __webpack_require__(98);
	
	var _DtoKeyFigures2 = _interopRequireDefault(_DtoKeyFigures);
	
	var _DtoNetwork = __webpack_require__(1038);
	
	var _DtoNetwork2 = _interopRequireDefault(_DtoNetwork);
	
	var _DtoSamplingSurfacePoint = __webpack_require__(379);
	
	var _DtoSamplingSurfacePoint2 = _interopRequireDefault(_DtoSamplingSurfacePoint);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var store = exports.store = {
		point: undefined,
		pointKeyFigures: [],
		pointNetworks: [],
		samplingSurfacePoints: []
	};
	
	function PointReducer() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		var action = arguments[1];
	
		switch (action.type) {
			case _PointConstants.RECEIVE_POINT:
				{
					return Object.assign({}, state, {
						point: new _DtoPoint2.default(action.point)
					});
				}
			case _PointConstants.RECEIVE_POINT_KEY_FIGURES:
				{
					return Object.assign({}, state, {
						pointKeyFigures: action.pointKeyFigures.map(function (o) {
							return new _DtoKeyFigures2.default(o);
						})
					});
				}
			case _PointConstants.RECEIVE_POINT_NETWORKS:
				{
					return Object.assign({}, state, {
						pointNetworks: action.pointNetworks.map(function (o) {
							return new _DtoNetwork2.default(o);
						})
					});
				}
			case _PointConstants.RECEIVE_SAMPLING_SURFACE_POINT:
				{
					return Object.assign({}, state, {
						samplingSurfacePoints: action.samplingSurfacePoints.map(function (o) {
							return new _DtoSamplingSurfacePoint2.default(o);
						})
					});
				}
			case _PointConstants.RESET_POINT_INFORMATIONS:
				{
					return Object.assign({}, state, store);
				}
			default:
				return state;
		}
	}

/***/ },
/* 2167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.store = undefined;
	exports.ReferentialReducer = ReferentialReducer;
	
	var _ReferentialConstants = __webpack_require__(1039);
	
	var _DtoCity = __webpack_require__(87);
	
	var _DtoCity2 = _interopRequireDefault(_DtoCity);
	
	var _DtoUnit = __webpack_require__(383);
	
	var _DtoUnit2 = _interopRequireDefault(_DtoUnit);
	
	var _DtoRemark = __webpack_require__(285);
	
	var _DtoRemark2 = _interopRequireDefault(_DtoRemark);
	
	var _DtoSupport = __webpack_require__(150);
	
	var _DtoSupport2 = _interopRequireDefault(_DtoSupport);
	
	var _DtoStandardCodification = __webpack_require__(225);
	
	var _DtoStandardCodification2 = _interopRequireDefault(_DtoStandardCodification);
	
	var _DtoParameter = __webpack_require__(224);
	
	var _DtoParameter2 = _interopRequireDefault(_DtoParameter);
	
	var _DtoFilterType = __webpack_require__(130);
	
	var _DtoFilterType2 = _interopRequireDefault(_DtoFilterType);
	
	var _DtoSiteType = __webpack_require__(96);
	
	var _DtoSiteType2 = _interopRequireDefault(_DtoSiteType);
	
	var _DtoWatershed = __webpack_require__(183);
	
	var _DtoWatershed2 = _interopRequireDefault(_DtoWatershed);
	
	var _DtoSimpleStation = __webpack_require__(382);
	
	var _DtoSimpleStation2 = _interopRequireDefault(_DtoSimpleStation);
	
	var _DtoIndicatorType = __webpack_require__(537);
	
	var _DtoIndicatorType2 = _interopRequireDefault(_DtoIndicatorType);
	
	var _DtoIndicator = __webpack_require__(536);
	
	var _DtoIndicator2 = _interopRequireDefault(_DtoIndicator);
	
	var _DtoManagementWater = __webpack_require__(223);
	
	var _DtoManagementWater2 = _interopRequireDefault(_DtoManagementWater);
	
	var _DtoDepartment = __webpack_require__(381);
	
	var _DtoDepartment2 = _interopRequireDefault(_DtoDepartment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var store = exports.store = {
		units: [],
		remarks: [],
		supports: [],
		standardCodifications: [],
		parameters: [],
		cities: [],
		departments: [],
		filterTypes: [],
		siteTypes: [],
		watersheds: [],
		stations: [],
		indicatorTypes: [],
		indicators: [],
		managementWaters: []
	};
	
	function ReferentialReducer() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		var action = arguments[1];
	
		switch (action.type) {
			case _ReferentialConstants.RECEIVE_ALL_UNITS:
				return Object.assign({}, state, {
					units: action.units.map(function (o) {
						return new _DtoUnit2.default(o);
					})
				});
			case _ReferentialConstants.RECEIVE_ALL_REMARKS:
				return Object.assign({}, state, {
					remarks: action.remarks.map(function (o) {
						return new _DtoRemark2.default(o);
					})
				});
			case _ReferentialConstants.RECEIVE_ALL_SUPPORTS:
				return Object.assign({}, state, {
					supports: action.supports.map(function (o) {
						return new _DtoSupport2.default(o);
					})
				});
			case _ReferentialConstants.RECEIVE_ALL_STANDARD_CODIFICATION:
				return Object.assign({}, state, {
					standardCodifications: action.standardCodifications.map(function (o) {
						return new _DtoStandardCodification2.default(o);
					})
				});
			case _ReferentialConstants.RECEIVE_ALL_PARAMETERS:
				return Object.assign({}, state, {
					parameters: action.parameters.map(function (o) {
						return new _DtoParameter2.default(o);
					})
				});
			case _ReferentialConstants.RECEIVE_ALL_CITIES:
				return Object.assign({}, state, {
					cities: action.cities.map(function (o) {
						return new _DtoCity2.default(o);
					})
				});
			case _ReferentialConstants.RECEIVE_ALL_DEPARTMENTS:
				return Object.assign({}, state, {
					departments: action.departments.map(function (o) {
						return new _DtoDepartment2.default(o);
					})
				});
			case _ReferentialConstants.RECEIVE_ALL_FILTER_TYPES:
				return Object.assign({}, state, {
					filterTypes: action.filterTypes.map(function (o) {
						return new _DtoFilterType2.default(o);
					})
				});
			case _ReferentialConstants.RECEIVE_ALL_SITE_TYPES:
				return Object.assign({}, state, {
					siteTypes: action.siteTypes.map(function (o) {
						return new _DtoSiteType2.default(o);
					})
				});
			case _ReferentialConstants.RECEIVE_ALL_WATERSHED:
				return Object.assign({}, state, {
					watersheds: action.watersheds.map(function (o) {
						return new _DtoWatershed2.default(o);
					})
				});
			case _ReferentialConstants.RECEIVE_ALL_STATIONS:
				return Object.assign({}, state, {
					stations: action.stations.map(function (o) {
						return new _DtoSimpleStation2.default(o);
					})
				});
			case _ReferentialConstants.RECEIVE_ALL_INDICATOR_TYPES:
				return Object.assign({}, state, {
					indicatorTypes: action.indicatorTypes.map(function (o) {
						return new _DtoIndicatorType2.default(o);
					})
				});
			case _ReferentialConstants.RECEIVE_ALL_INDICATORS:
				return Object.assign({}, state, {
					indicators: action.indicators.map(function (o) {
						return new _DtoIndicator2.default(o);
					})
				});
			case _ReferentialConstants.RECEIVE_ALL_MANAGEMENT_WATER:
				return Object.assign({}, state, {
					managementWaters: action.managementWaters.map(function (o) {
						return new _DtoManagementWater2.default(o);
					})
				});
			case _ReferentialConstants.RESET_REFERENTIAL:
				return Object.assign({}, state, store);
			default:
				return state;
		}
	}

/***/ },
/* 2168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _resetPasswordPanel = __webpack_require__(2169);
	
	var _resetPasswordPanel2 = _interopRequireDefault(_resetPasswordPanel);
	
	var _reactAquasys = __webpack_require__(49);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _reactRedux = __webpack_require__(18);
	
	var _resetPasswordAction = __webpack_require__(1041);
	
	var _resetPasswordAction2 = _interopRequireDefault(_resetPasswordAction);
	
	var _Snackbar = __webpack_require__(192);
	
	var _Snackbar2 = _interopRequireDefault(_Snackbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResetPasswordApp = function (_Component) {
		_inherits(ResetPasswordApp, _Component);
	
		function ResetPasswordApp(props) {
			_classCallCheck(this, ResetPasswordApp);
	
			var _this = _possibleConstructorReturn(this, (ResetPasswordApp.__proto__ || Object.getPrototypeOf(ResetPasswordApp)).call(this, props));
	
			_this.putMessage = function (value) {
				_AppStore2.default.dispatch(_resetPasswordAction2.default.addMessage(value));
			};
	
			_this.handleRequestClose = function () {
				_AppStore2.default.dispatch(_resetPasswordAction2.default.resetMessage());
			};
	
			return _this;
		}
	
		_createClass(ResetPasswordApp, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ id: 'login-page' },
					_react2.default.createElement(
						'div',
						{ className: 'container-div valign-wrapper' },
						_react2.default.createElement(
							'div',
							{ className: 'container-panel' },
							_react2.default.createElement(
								'div',
								{ className: 'container' },
								_react2.default.createElement(
									'div',
									{ className: 'row' },
									_react2.default.createElement(
										'div',
										{ className: 'col s6 m6 l4 offset-m3 offset-l4' },
										_react2.default.createElement(
											'div',
											{ className: 'row' },
											_react2.default.createElement(_resetPasswordPanel2.default, { putMessage: this.putMessage })
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(_reactAquasys.Toastr, { store: _AppStore2.default }),
					_react2.default.createElement(_Snackbar2.default, {
						open: this.props.open,
						message: this.props.message,
						autoHideDuration: 2000,
						onRequestClose: this.handleRequestClose,
						bodyStyle: { backgroundColor: '#FF0000', color: 'white' },
						style: { backgroundColor: '#FF0000', color: 'white' },
						contentStyle: { backgroundColor: '#FF0000', color: 'white' }
					}),
					_react2.default.createElement(_reactAquasys.Wait, null)
				);
			}
		}]);
	
		return ResetPasswordApp;
	}(_react.Component);
	
	ResetPasswordApp.propTypes = {
		open: _propTypes2.default.bool,
		message: _propTypes2.default.string
	};
	var mapStateToProps = function mapStateToProps(props) {
		return {
			open: props.InitPasswordReducer.open,
			message: props.InitPasswordReducer.message,
			error: props.InitPasswordReducer.error
		};
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ResetPasswordApp);

/***/ },
/* 2169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _lodash = __webpack_require__(15);
	
	var _resetPasswordAction = __webpack_require__(1041);
	
	var _resetPasswordAction2 = _interopRequireDefault(_resetPasswordAction);
	
	var _reactRedux = __webpack_require__(18);
	
	var _basepath = __webpack_require__(180);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var resetPasswordPanel = function (_Component) {
		_inherits(resetPasswordPanel, _Component);
	
		function resetPasswordPanel(props) {
			_classCallCheck(this, resetPasswordPanel);
	
			//const chaine=props.location.search.split('&'); 
			//const param = chaine.split('=');  
			var _this = _possibleConstructorReturn(this, (resetPasswordPanel.__proto__ || Object.getPrototypeOf(resetPasswordPanel)).call(this, props));
	
			_this.onValid = function () {
				if (!_this.state.login) {
					_this.props.putMessage(_simpleReactI18n2.default.error.login);
				} else if (!_this.state.password) {
					_this.props.putMessage(_simpleReactI18n2.default.error.password);
				} else if (!_this.state.confirmPassword) {
					_this.props.putMessage(_simpleReactI18n2.default.error.confirmPassword);
				} else {
					if (!(0, _lodash.isEqual)(_this.state.password, _this.state.confirmPassword)) {
						_this.props.putMessage(_simpleReactI18n2.default.error.samePassword);
					} else {
						_AppStore2.default.dispatch(_resetPasswordAction2.default.resetPassword(_this.state));
					}
				}
			};
	
			_this.onChangeValue = function (key, value) {
				var actualState = Object.assign({}, _this.state);
				actualState[key] = value.trim();
				_this.setState(actualState);
			};
	
			_this.disableCopyPaste = function (event) {
				event.preventDefault();
			};
	
			_this.getContactPanel = function () {
				if (_this.props.error) {
					return _react2.default.createElement(
						'div',
						{ className: 'row no-margin center-align padding-top-10' },
						_react2.default.createElement(
							'div',
							{ className: 'col s12' },
							_react2.default.createElement(
								'a',
								{ className: 'accountActivationContactUs', href: _basepath.aquadbSupport,
									target: '_blank' },
								' ',
								_simpleReactI18n2.default.needHelp
							)
						)
					);
				}
				return null;
			};
	
			var param = window.location.href;
			var tok = param.split('=');
	
			_this.state = {
				login: '',
				password: '',
				confirmPassword: '',
				token: tok[1]
			};
			return _this;
		}
	
		_createClass(resetPasswordPanel, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement('script', { src: 'https://www.google.com/recaptcha/enterprise.js?render=6LcTYUgfAAAAAA9q3nt1a0dqplRNZOXX7Z5oVcfy' }),
					_react2.default.createElement(
						'script',
						null,
						'function onSubmit(token) ',
						this.onValid()
					),
					_react2.default.createElement(
						'div',
						{ className: 'card no-margin z-depth-1 radius10' },
						_react2.default.createElement(
							'div',
							{ className: 'card-content no-padding row no-margin cardLogin' },
							_react2.default.createElement(
								'form',
								null,
								_react2.default.createElement(
									'div',
									{ className: 'row no-margin' },
									_react2.default.createElement(
										'div',
										{ className: 'input-field col s12 center' },
										_react2.default.createElement('img', { src: 'https://www.aquasys.fr/wp-content/uploads/2017/10/AquaDB-grand.png',
											alt: 'logo AquaDB',
											width: '70px', className: 'z-depth-1' })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'row no-margin' },
									_react2.default.createElement(
										'div',
										{ className: 'col s12' },
										_react2.default.createElement(
											'label',
											{ htmlFor: 'login', className: 'valign-wrapper black-text' },
											_react2.default.createElement(
												'i',
												{ className: 'material-icons' },
												'person'
											),
											_simpleReactI18n2.default.login
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col s12' },
										_react2.default.createElement('input', { ref: 'login', id: 'login', type: 'text', className: 'validate', required: true,
											value: this.state.login,
											onChange: function onChange(e) {
												return _this2.onChangeValue('login', e.target.value);
											} })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'row no-margin' },
									_react2.default.createElement(
										'div',
										{ className: 'col s12' },
										_react2.default.createElement(
											'label',
											{ htmlFor: 'password', className: 'valign-wrapper black-text' },
											_react2.default.createElement(
												'i',
												{ className: 'material-icons' },
												'lock_outline'
											),
											_simpleReactI18n2.default.password
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col s12' },
										_react2.default.createElement('input', { ref: 'password', id: 'password', type: 'password', className: 'validate', required: true,
											value: this.state.password,
											onChange: function onChange(e) {
												return _this2.onChangeValue('password', e.target.value);
											} })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'row no-margin' },
									_react2.default.createElement(
										'div',
										{ className: 'col s12' },
										_react2.default.createElement(
											'label',
											{ htmlFor: 'confirmPassword', className: 'valign-wrapper black-text' },
											_react2.default.createElement(
												'i',
												{ className: 'material-icons' },
												'lock_outline'
											),
											_simpleReactI18n2.default.confirmPassword
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col s12' },
										_react2.default.createElement('input', { ref: 'confirmPassword', id: 'confirmPassword', type: 'password',
											className: 'validate',
											value: this.state.confirmPassword,
											onCopy: function onCopy(e) {
												return _this2.disableCopyPaste(e);
											},
											onPaste: function onPaste(e) {
												return _this2.disableCopyPaste(e);
											},
											onChange: function onChange(e) {
												return _this2.onChangeValue('confirmPassword', e.target.value);
											},
											required: true })
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'col l12 m10 s10 offset-m1 offset-s1 padding-bottom-10' },
								_react2.default.createElement(
									'button',
									{ 'data-sitekey': 'site_key', 'data-callback': 'onSubmit', 'data-action': 'submit',
										className: 'g-recaptcha waves-effect col l12 m12 s12 waves-light btn' },
									_simpleReactI18n2.default.validate
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						null,
						this.getContactPanel()
					)
				);
			}
		}]);
	
		return resetPasswordPanel;
	}(_react.Component);
	
	resetPasswordPanel.propTypes = {
		putMessage: _propTypes2.default.func,
		error: _propTypes2.default.bool
	};
	
	var mapStateToProps = function mapStateToProps(props) {
		return {
			error: props.InitPasswordReducer.error
		};
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(resetPasswordPanel);

/***/ },
/* 2170 */
1035,
/* 2171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _SignUpValidationConstants = __webpack_require__(1042);
	
	var _ApplicationConf = __webpack_require__(65);
	
	var _ApplicationConf2 = _interopRequireDefault(_ApplicationConf);
	
	var _isomorphicFetch = __webpack_require__(78);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _reactRouterRedux = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SignUpValidationActions = {
	    signUpValidationFail: function signUpValidationFail(message) {
	        return { type: _SignUpValidationConstants.SIGNUPVALIDATION_FAIL, error: message };
	    },
	    signUpValidation: function signUpValidation(user, token) {
	        return function (dispatch) {
	            return (0, _isomorphicFetch2.default)(_ApplicationConf2.default.activatePath() + '/' + user.login + '?token=' + token, {
	                method: 'POST',
	                headers: {},
	                body: JSON.stringify(user)
	            }).then(function () {
	                dispatch((0, _reactRouterRedux.push)('/login'));
	            }).catch(function (error) {
	                dispatch(SignUpValidationActions.signUpValidationFail(error.text));
	            });
	        };
	    }
	};
	
	exports.default = SignUpValidationActions;

/***/ },
/* 2172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _reactRouterRedux = __webpack_require__(43);
	
	var _SignUpValidationActions = __webpack_require__(2171);
	
	var _SignUpValidationActions2 = _interopRequireDefault(_SignUpValidationActions);
	
	var _HomeConstants = __webpack_require__(53);
	
	var _BetaBanner = __webpack_require__(2100);
	
	var _BetaBanner2 = _interopRequireDefault(_BetaBanner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var toastr = window.toastr;
	
	var SignUpValidationApp = function (_Component) {
		_inherits(SignUpValidationApp, _Component);
	
		function SignUpValidationApp(props) {
			_classCallCheck(this, SignUpValidationApp);
	
			var _this = _possibleConstructorReturn(this, (SignUpValidationApp.__proto__ || Object.getPrototypeOf(SignUpValidationApp)).call(this, props));
	
			_this.handleChange = function (event) {
				_this.setState({ user: Object.assign({}, _this.state.user, _defineProperty({}, event.target.name, event.target.value)) });
			};
	
			_this.onSubmit = function (event) {
				event.preventDefault();
				_AppStore2.default.dispatch(_SignUpValidationActions2.default.signUpValidation(_this.state.user, _this.props.location.query.token));
			};
	
			_this.state = {
				error: '',
				success: '',
				captcha: false,
				user: {
					login: '',
					password: '',
					lastname: '',
					firstname: '',
					mobile: '',
					phone: '',
					address: '',
					city: '',
					postalCode: ''
				}
			};
			return _this;
		}
	
		_createClass(SignUpValidationApp, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				if (!this.props.location.query.token) {
					_AppStore2.default.dispatch((0, _reactRouterRedux.push)(_HomeConstants.PATH_LOGIN));
				} else {
					var login = atob(this.props.location.query.token).split(' ')[0];
					this.setState({ user: Object.assign({}, this.state.user, { login: login }) });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				if (this.state.error) {
					toastr.error(this.state.error, '', { positionClass: 'toast-bottom-right' });
				}
				if (this.state.success) {
					toastr.success(this.state.success, '', { positionClass: 'toast-bottom-right' });
				}
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'div',
						{ className: 'container-div' },
						_react2.default.createElement(_BetaBanner2.default, null),
						_react2.default.createElement(
							'div',
							{ className: 'container-panel' },
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'valign-wrapper' },
									_react2.default.createElement(
										'div',
										{ className: 'center col l12 m12 s12' },
										_react2.default.createElement('img', { src: '/public/pictures/logo.png', className: 'imgAquaDB' })
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col l12 m12 s12' },
									_react2.default.createElement(
										'div',
										{ className: 'col l10 m12 s12 offset-l1 offset-m1 offset-s1 card registerCard z-depth-1' },
										_react2.default.createElement(
											'div',
											{ className: 'row card-content no-padding cardLogin' },
											_react2.default.createElement(
												'h5',
												{ className: 'center titleCard' },
												_simpleReactI18n2.default.signup.toUpperCase()
											),
											_react2.default.createElement(
												'form',
												{ className: 'col l12 m12 s12', onSubmit: this.onSubmit },
												_react2.default.createElement(
													'div',
													{ className: 'row' },
													_react2.default.createElement(
														'div',
														{ className: 'input-field col l6 m12 s12' },
														_react2.default.createElement('input', { ref: 'login', disabled: true, name: 'login', type: 'text', value: this.state.user.login, className: 'validate' }),
														_react2.default.createElement(
															'label',
															{ htmlFor: 'login' },
															_simpleReactI18n2.default.login
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'input-field col l6 m12 s12' },
														_react2.default.createElement('input', { value: this.state.user.password, onChange: this.handleChange, name: 'password', type: 'password', className: 'validate' }),
														_react2.default.createElement(
															'label',
															{ htmlFor: 'login' },
															_simpleReactI18n2.default.password
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'input-field col l6 m12 s12' },
														_react2.default.createElement('input', { value: this.state.user.lastname, onChange: this.handleChange, name: 'lastname', type: 'text', className: 'validate' }),
														_react2.default.createElement(
															'label',
															{ htmlFor: 'lastname' },
															_simpleReactI18n2.default.lastname
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'input-field col l6 m12 s12' },
														_react2.default.createElement('input', { value: this.state.user.firstname, onChange: this.handleChange, name: 'firstname', type: 'text', className: 'validate' }),
														_react2.default.createElement(
															'label',
															{ htmlFor: 'firstname' },
															_simpleReactI18n2.default.firstname
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'input-field col l6 m12 s12' },
														_react2.default.createElement('input', { value: this.state.user.mobile, onChange: this.handleChange, name: 'mobile', type: 'text', className: 'validate' }),
														_react2.default.createElement(
															'label',
															{ htmlFor: 'mobile' },
															_simpleReactI18n2.default.mobile
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'input-field col l6 m12 s12' },
														_react2.default.createElement('input', { value: this.state.user.phone, onChange: this.handleChange, name: 'phone', type: 'text', className: 'validate' }),
														_react2.default.createElement(
															'label',
															{ htmlFor: 'phone' },
															_simpleReactI18n2.default.phone
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'input-field col l12 m12 s12' },
														_react2.default.createElement('input', { value: this.state.user.address, onChange: this.handleChange, name: 'address', type: 'text', className: 'validate' }),
														_react2.default.createElement(
															'label',
															{ htmlFor: 'address' },
															_simpleReactI18n2.default.address
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'input-field col l4 m12 s12' },
														_react2.default.createElement('input', { value: this.state.user.postalCode, onChange: this.handleChange, name: 'postalCode', type: 'text', className: 'validate' }),
														_react2.default.createElement(
															'label',
															{ htmlFor: 'address' },
															_simpleReactI18n2.default.zip
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'input-field col l8 m12 s12' },
														_react2.default.createElement('input', { value: this.state.user.city, onChange: this.handleChange, name: 'city', type: 'text', className: 'validate' }),
														_react2.default.createElement(
															'label',
															{ htmlFor: 'city' },
															_simpleReactI18n2.default.city
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'input-field col l12 m12 s12 offset-m1 offset-s1' },
														_react2.default.createElement(
															'u',
															null,
															_react2.default.createElement(
																'button',
																{ to: 'dashboard', className: 'waves-effect col l12 m12 s12 waves-light btn' },
																_simpleReactI18n2.default.signup
															)
														)
													)
												)
											)
										)
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return SignUpValidationApp;
	}(_react.Component);
	
	SignUpValidationApp.propTypes = {
		location: _propTypes2.default.shape({
			query: _propTypes2.default.shape({
				token: _propTypes2.default.string
			})
		})
	};
	
	exports.default = SignUpValidationApp;

/***/ },
/* 2173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = SignUpValidationReducer;
	
	var _SignUpValidationConstants = __webpack_require__(1042);
	
	function SignUpValidationReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _SignUpValidationConstants.SIGNUPVALIDATION_FAIL:
	            {
	                return Object.assign({}, state, {
	                    error: action.error
	                });
	            }
	        case _SignUpValidationConstants.SIGNUPVALIDATION_SUCCESS:
	            {
	                return Object.assign({}, state, {
	                    success: action.success
	                });
	            }
	        default:
	            return state;
	    }
	}

/***/ },
/* 2174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DtoUser = __webpack_require__(54);
	
	var _DtoUser2 = _interopRequireDefault(_DtoUser);
	
	var _reactRedux = __webpack_require__(18);
	
	var _reactDndHtml5Backend = __webpack_require__(991);
	
	var _reactDndHtml5Backend2 = _interopRequireDefault(_reactDndHtml5Backend);
	
	var _reactDnd = __webpack_require__(218);
	
	var _DtoStation = __webpack_require__(88);
	
	var _DtoStation2 = _interopRequireDefault(_DtoStation);
	
	var _DtoSiteType = __webpack_require__(96);
	
	var _DtoSiteType2 = _interopRequireDefault(_DtoSiteType);
	
	var _StationsTabPanel = __webpack_require__(2176);
	
	var _StationsTabPanel2 = _interopRequireDefault(_StationsTabPanel);
	
	var _SitesAction = __webpack_require__(97);
	
	var _SitesAction2 = _interopRequireDefault(_SitesAction);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _HomeAction = __webpack_require__(52);
	
	var _HomeAction2 = _interopRequireDefault(_HomeAction);
	
	var _TabsSideBar = __webpack_require__(2112);
	
	var _TabsSideBar2 = _interopRequireDefault(_TabsSideBar);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _ReferentialAction = __webpack_require__(380);
	
	var _ReferentialAction2 = _interopRequireDefault(_ReferentialAction);
	
	var _DtoCity = __webpack_require__(87);
	
	var _DtoCity2 = _interopRequireDefault(_DtoCity);
	
	var _ThemeDto = __webpack_require__(129);
	
	var _ThemeDto2 = _interopRequireDefault(_ThemeDto);
	
	var _ResearchTabPanel = __webpack_require__(2175);
	
	var _ResearchTabPanel2 = _interopRequireDefault(_ResearchTabPanel);
	
	var _ThemesTabPanel = __webpack_require__(2177);
	
	var _ThemesTabPanel2 = _interopRequireDefault(_ThemesTabPanel);
	
	var _DtoFilterType = __webpack_require__(130);
	
	var _DtoFilterType2 = _interopRequireDefault(_DtoFilterType);
	
	var _SelectionSaveModal = __webpack_require__(2111);
	
	var _SelectionSaveModal2 = _interopRequireDefault(_SelectionSaveModal);
	
	var _uuid = __webpack_require__(44);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _HomeConstants = __webpack_require__(53);
	
	var _ActionComponent2 = __webpack_require__(283);
	
	var _ActionComponent3 = _interopRequireDefault(_ActionComponent2);
	
	var _ListComponent = __webpack_require__(528);
	
	var _ListComponent2 = _interopRequireDefault(_ListComponent);
	
	var _AdministrationAction = __webpack_require__(61);
	
	var _AdministrationAction2 = _interopRequireDefault(_AdministrationAction);
	
	var _SwitchPanel = __webpack_require__(2113);
	
	var _SwitchPanel2 = _interopRequireDefault(_SwitchPanel);
	
	var _ThemesUtils = __webpack_require__(384);
	
	var _SiteTypes = __webpack_require__(56);
	
	var _SiteTypes2 = _interopRequireDefault(_SiteTypes);
	
	var _PopupFactory = __webpack_require__(547);
	
	var _PopupFactory2 = _interopRequireDefault(_PopupFactory);
	
	var _ApplicationUtils = __webpack_require__(186);
	
	var _LayerUtils = __webpack_require__(2213);
	
	var _SitesPoint = __webpack_require__(549);
	
	var _SitesPoint2 = _interopRequireDefault(_SitesPoint);
	
	var _OSM = __webpack_require__(290);
	
	var _OSM2 = _interopRequireDefault(_OSM);
	
	var _ResearchTypesUtils = __webpack_require__(228);
	
	var _DtoWatershed = __webpack_require__(539);
	
	var _DtoWatershed2 = _interopRequireDefault(_DtoWatershed);
	
	var _DtoRadius = __webpack_require__(2179);
	
	var _DtoRadius2 = _interopRequireDefault(_DtoRadius);
	
	var _ResearchTypes = __webpack_require__(288);
	
	var _ResearchTypes2 = _interopRequireDefault(_ResearchTypes);
	
	var _StringUtils = __webpack_require__(131);
	
	var _DtoLayer = __webpack_require__(372);
	
	var _DtoLayer2 = _interopRequireDefault(_DtoLayer);
	
	var _ApplicationConf = __webpack_require__(65);
	
	var _ApplicationConf2 = _interopRequireDefault(_ApplicationConf);
	
	var _DtoSelectionRow = __webpack_require__(182);
	
	var _DtoSelectionRow2 = _interopRequireDefault(_DtoSelectionRow);
	
	var _DtoManagementWater = __webpack_require__(223);
	
	var _DtoManagementWater2 = _interopRequireDefault(_DtoManagementWater);
	
	var _Map = __webpack_require__(289);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _SelectionAction = __webpack_require__(95);
	
	var _SelectionAction2 = _interopRequireDefault(_SelectionAction);
	
	var _LegendDto = __webpack_require__(373);
	
	var _LegendDto2 = _interopRequireDefault(_LegendDto);
	
	var _CheckStatusAction = __webpack_require__(2211);
	
	var _lodash = __webpack_require__(15);
	
	var _UserUtils = __webpack_require__(1057);
	
	var _DtoUserRole = __webpack_require__(378);
	
	var _DtoUserRole2 = _interopRequireDefault(_DtoUserRole);
	
	var _ToastrAction = __webpack_require__(66);
	
	var _ToastrAction2 = _interopRequireDefault(_ToastrAction);
	
	var _SelectionExportModal = __webpack_require__(1021);
	
	var _SelectionExportModal2 = _interopRequireDefault(_SelectionExportModal);
	
	var _SitesConstants = __webpack_require__(226);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = window.$;
	
	var idCityLayerPanel = 'city_layer_panel';
	var idWatershedLayerPanel = 'watershed_layer_panel';
	
	var SitesApp = function (_ActionComponent) {
		_inherits(SitesApp, _ActionComponent);
	
		function SitesApp(props) {
			_classCallCheck(this, SitesApp);
	
			var _this = _possibleConstructorReturn(this, (SitesApp.__proto__ || Object.getPrototypeOf(SitesApp)).call(this, props));
	
			_initialiseProps.call(_this);
	
			_this.state = {
				height: 250,
				selected: [],
				center: (0, _ApplicationUtils.getDefaultMapCenter)(props.user),
				zoom: (0, _ApplicationUtils.getDefaultZoom)(props.user),
				extent: null,
				layersUrl: []
			};
			_this.setHeight = _this.setHeight.bind(_this);
			_this.setExtent = _this.setExtent.bind(_this);
			return _this;
		}
	
		_createClass(SitesApp, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _this2 = this;
	
				if (!this.props.siteTypes.length) {
					_AppStore2.default.dispatch(_ReferentialAction2.default.fetchSiteTypes());
				}
				if (!this.props.cities.length) {
					_AppStore2.default.dispatch(_ReferentialAction2.default.fetchCities());
				}
				_AppStore2.default.dispatch(_SitesAction2.default.fetchSelectedTypes());
				_AppStore2.default.dispatch(_SitesAction2.default.fetchResearchTypes());
				_AppStore2.default.dispatch(_HomeAction2.default.setTitle(this.getTitlePage(this.props.selectedSelection)));
				if (this.props.selectedFilters.length) {
					var filterTypeDto = this.props.selectedFilters.map(function (o) {
						return (0, _ResearchTypesUtils.createDtoFilter)(_this2.props.filterTypes, o);
					});
					this.initLayers(filterTypeDto, this.props);
				}
				if (this.props.stations && this.props.stations.length > 1) {
					this.setExtent(this.props.stations);
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.setHeight();
				$('.tooltipped').tooltip();
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextprops) {
				var _this3 = this;
	
				if (nextprops.stations && nextprops.stations.length && nextprops.stations.length !== this.props.stations.length || nextprops.selectedTypes && nextprops.selectedTypes.length !== this.props.selectedTypes.length) {
					_AppStore2.default.dispatch(_SitesAction2.default.putStations(this.getFinalStation(nextprops.stations)));
					var filterTypeDto = nextprops.selectedFilters.map(function (o) {
						return (0, _ResearchTypesUtils.createDtoFilter)(_this3.props.filterTypes, o);
					});
					this.initLayers(filterTypeDto, nextprops);
				}
				if (nextprops.stations.length === this.props.stations.length) {
					this.setExtent(nextprops.stations);
				}
				if (nextprops.selectedFilters.length !== this.props.selectedFilters.length) {
					var _filterTypeDto = nextprops.selectedFilters.map(function (o) {
						return (0, _ResearchTypesUtils.createDtoFilter)(nextprops.filterTypes, o);
					});
					this.initLayers(_filterTypeDto, nextprops);
				}
				if (nextprops.selectedSelection) {
					_AppStore2.default.dispatch(_HomeAction2.default.setTitle(this.getTitlePage(nextprops.selectedSelection)));
				}
				if (nextprops.stations.length === 0 && this.props.stations.length && !nextprops.selectedFilters.length) {
					_AppStore2.default.dispatch(_SitesAction2.default.updateCitiesLayers([]));
				}
	
				if (!this.state.layersUrl.length) {
					var layers = (0, _lodash.flatten)(nextprops.selectedThemes.map(function (o) {
						return o.value.layers;
					})).filter(function (o) {
						return o.type !== 'KML';
					});
					var promiseUrlLegend = (0, _CheckStatusAction.urlsCheckStatus)(layers);
					promiseUrlLegend.then(function (url) {
						var layersUrl = (0, _lodash.filter)(url.map(function (o) {
							if (o) {
								var findLayer = function () {
									var result = (0, _lodash.filter)(layers.map(function (layer) {
										if (o.includes(layer.layer)) {
											return layer;
										}
										return null;
									}));
									if (result && result.length) {
										return result[0];
									}
									return null;
								}();
								if (findLayer) {
									return {
										id: findLayer.id,
										url: o
									};
								}
								return null;
							}
							return null;
						}), function (i) {
							return i;
						});
						_this3.setState({
							layersUrl: layersUrl
						});
					});
				}
			}
		}, {
			key: 'getStationTab',
			value: function getStationTab() {
				var pointTitle = (0, _StringUtils.getPlurialWithNumber)(_simpleReactI18n2.default.availablePoint, _simpleReactI18n2.default.availablePoints, this.props.stations.length);
				var hydrologicalAreaTitle = (0, _StringUtils.getPlurialWithNumber)(_simpleReactI18n2.default.lowerWatershedArea, _simpleReactI18n2.default.lowerWatersheds, this.props.watershedSelected.length);
				var title = this.props.stations.length + ' ' + pointTitle + ' ' + _simpleReactI18n2.default.lowerOn + ' ' + this.props.watershedSelected.length + ' ' + hydrologicalAreaTitle;
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin' },
					_react2.default.createElement(
						'div',
						{ className: 'col s12 m12 l12 no-padding' },
						_react2.default.createElement(
							'h6',
							null,
							' ',
							title
						),
						_react2.default.createElement(_StationsTabPanel2.default, { onHover: true })
					)
				);
			}
		}, {
			key: 'getLayersTab',
			value: function getLayersTab() {
				var _this4 = this;
	
				var entities = [];
				var layersSize = [];
	
				(0, _lodash.orderBy)((0, _lodash.filter)(this.props.selectedThemes, ['value.disable', false]), ['value.id'], ['asc']).forEach(function (theme) {
					var color = (0, _ThemesUtils.getColor)(_this4.props.themes, theme.value, 1);
					var size = theme.value.layers.length;
					if (size) {
						var layers = theme.value.layers.map(function (layer, i) {
							var opacityId = _uuid2.default.v4();
							var url = function () {
								var result = (0, _lodash.find)(_this4.state.layersUrl, function (o) {
									return o.id == layer.id;
								});
								if (result) {
									return result.url;
								}
								return null;
							}();
							var img = url ? _react2.default.createElement('img', { src: url, className: 'responsive-img theme-icon center-align' }) : null;
							var legendDto = new _LegendDto2.default({
								id: theme.value.id + '_' + i,
								content: img
							});
							layersSize.push(layer);
							var pictureDiv = function () {
								if (!url) {
									return null;
								}
								return _react2.default.createElement(
									'div',
									{ className: 'col s1 no-padding center clickable',
										onClick: function onClick() {
											return _AppStore2.default.dispatch(_AdministrationAction2.default.addLegend(legendDto));
										} },
									_react2.default.createElement(
										'i',
										{ className: 'material-icons help-icon' },
										'info_outline'
									)
								);
							}();
							var classNameTitle = pictureDiv ? 's9' : 's10';
							return _react2.default.createElement(
								'div',
								{ className: 'help-panel' },
								_react2.default.createElement(
									_SwitchPanel2.default,
									{ key: i, onToggleCheck: function onToggleCheck() {
											return _this4.changeVisibility(layer.id);
										},
										checked: layer.visibility },
									_react2.default.createElement(
										'div',
										{ className: 'row no-margin valign-wrapper' },
										_react2.default.createElement(
											'div',
											{ className: 'col padding-left-20' + classNameTitle },
											_react2.default.createElement(
												'h6',
												null,
												layer.name
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col s2 range-field no-padding' },
											_react2.default.createElement('input', { type: 'range', ref: layer.id, id: opacityId, min: 0, max: 1,
												step: 0.1,
												value: layer.opacity, onChange: function onChange() {
													return _this4.changeOpacity(layer.id);
												} })
										),
										pictureDiv
									)
								)
							);
						});
						var result = {
							title: theme.label + ' ( ' + size + ' )',
							component: layers,
							picture: theme.value.pic,
							color: color
						};
						entities.push(result);
					}
				});
				if (this.props.watershedLayers.length) {
					var watershedLayers = (0, _lodash.orderBy)(this.props.watershedLayers, ['code'], ['asc']).map(function (layer) {
						return _react2.default.createElement(
							_SwitchPanel2.default,
							{ key: _uuid2.default.v4(), onToggleCheck: function onToggleCheck() {
									return _this4.changeWatershedVisibility(layer.id);
								},
								checked: layer.visibility },
							_react2.default.createElement(
								'div',
								{ className: 'row no-margin' },
								_react2.default.createElement(
									'div',
									{ className: 'col s12 no-padding' },
									_react2.default.createElement(
										'h6',
										null,
										layer.code,
										' : ',
										layer.name
									)
								)
							)
						);
					});
					var title = (0, _StringUtils.getPlurial)(_simpleReactI18n2.default.watershedArea, _simpleReactI18n2.default.watersheds, this.props.watershedLayers) + ' (' + this.props.watershedLayers.length + ')';
					var isToogle = this.props.watershedLayers.filter(function (o) {
						return o.visibility;
					}).length === this.props.watershedLayers.length;
					var result = {
						title: title,
						component: watershedLayers,
						isToogle: isToogle,
						id: idWatershedLayerPanel,
						icon: 'texture'
					};
					entities.unshift(result);
				}
				if (this.props.managementWaterLayers.length) {
					var managementWaterLayers = (0, _lodash.orderBy)(this.props.managementWaterLayers, ['code'], ['asc']).map(function (layer) {
						return _react2.default.createElement(
							_SwitchPanel2.default,
							{ key: _uuid2.default.v4(),
								onToggleCheck: function onToggleCheck() {
									return _this4.changeManagementWaterVisibility(layer.id);
								},
								checked: layer.visibility },
							_react2.default.createElement(
								'div',
								{ className: 'row no-margin' },
								_react2.default.createElement(
									'div',
									{ className: 'col s12 no-padding' },
									_react2.default.createElement(
										'h6',
										null,
										layer.code,
										' : ',
										layer.name
									)
								)
							)
						);
					});
					var _result = {
						title: 'SAGE ( ' + this.props.managementWaterLayers.length + ' )',
						component: managementWaterLayers,
						icon: 'texture'
					};
					entities.unshift(_result);
				}
				if (this.props.citiesLayers.length) {
					var citiesLayers = (0, _lodash.orderBy)(this.props.citiesLayers, ['code'], ['asc']).map(function (layer) {
						return _react2.default.createElement(
							_SwitchPanel2.default,
							{ onToggleCheck: function onToggleCheck() {
									return _this4.changeCitiesLayersVisibility(layer.id);
								},
								checked: layer.visibility },
							_react2.default.createElement(
								'div',
								{ className: 'row no-margin' },
								_react2.default.createElement(
									'div',
									{ className: 'col s12 no-padding' },
									_react2.default.createElement(
										'h6',
										null,
										layer.code,
										' : ',
										layer.name
									)
								)
							)
						);
					});
					var sizeCityLayer = this.props.citiesLayers.length;
					var _title = sizeCityLayer > 1 ? _simpleReactI18n2.default.administrativeLimits : _simpleReactI18n2.default.administrativeLimit;
					var _isToogle = this.props.citiesLayers.filter(function (o) {
						return o.visibility;
					}).length === this.props.citiesLayers.length;
					var _result2 = {
						title: _title + ' (' + sizeCityLayer + ')',
						component: citiesLayers,
						isToogle: _isToogle,
						id: idCityLayerPanel,
						icon: 'location_city'
					};
					entities.unshift(_result2);
				}
				return _react2.default.createElement(
					'div',
					{ className: 'row' },
					_react2.default.createElement(
						'div',
						{ className: 'col s12 m12 l12 no-padding' },
						this.getTitle(_simpleReactI18n2.default.layerAvailable, _simpleReactI18n2.default.layersAvailable, layersSize.length),
						entities ? _react2.default.createElement(_ListComponent2.default, { tables: entities, generalFunction: this.resetAllLayers }) : _react2.default.createElement(
							'div',
							null,
							_simpleReactI18n2.default.noLayerAvailable
						)
					)
				);
			}
		}, {
			key: 'getTabsSideBar',
			value: function getTabsSideBar() {
				var content = [{
					icon: 'list',
					title: this.setTitle(_simpleReactI18n2.default.selectData),
					content: this.getStationTab(),
					defaultActive: true
				}, {
					icon: 'filter_list',
					title: this.setTitle(_simpleReactI18n2.default.filterDataByTheme),
					content: _react2.default.createElement(_ThemesTabPanel2.default, null),
					defaultActive: false
				}, {
					icon: 'layers',
					title: this.setTitle(_simpleReactI18n2.default.displayLayers),
					content: this.getLayersTab(),
					defaultActive: false
				}];
				return _react2.default.createElement(_TabsSideBar2.default, { tabs: content, isOpen: !!this.props.stations.length });
			}
		}, {
			key: 'setHeight',
			value: function setHeight() {
				this.setState({ height: document.body.clientHeight - $('#map').offset().top });
			}
		}, {
			key: 'onOpenTopBar',
			value: function onOpenTopBar() {
				var top = $('.ribbon').offset().top;
				var height = document.body.clientHeight - top;
				$('.side-component').css({ height: height + 'px', top: top + 'px' });
			}
		}, {
			key: 'getMapConf',
			value: function getMapConf() {
				return {
					size: this.state.height,
					center: this.state.center,
					zoom: this.state.zoom,
					extent: this.state.extent
				};
			}
		}, {
			key: 'getLayers',
			value: function getLayers() {
				var _this5 = this;
	
				var layers = (0, _lodash.uniqWith)((0, _lodash.flatten)(this.props.selectedThemes.map(function (theme) {
					return theme.value.layers.filter(function (a) {
						return a.visibility;
					}).map(function (layer) {
						return layer;
					});
				})), function (a, b) {
					return a.id === b.id;
				}).map(function (layer) {
					return (0, _LayerUtils.getLayer)(layer);
				});
				var siteTypes = (0, _lodash.uniq)((0, _lodash.flatten)(this.props.selectedThemes.map(function (theme) {
					return theme.value.siteTypes.map(function (t) {
						return t.type;
					});
				})));
				var kmlCities = this.getKmlCities();
				var kmlWatershed = this.getWaterShedKml();
				var kmlManagementWater = this.getManagementWaterKml();
	
				if (this.props.selectedStations.length > 0) {
					var filterByTypes = (0, _lodash.reduce)(this.props.selectedStations, function (acc, v) {
						var type = (0, _lodash.find)(siteTypes, function (t) {
							return t === v.typeParameter;
						});
						if (type) {
							(acc[v.typeId] || (acc[v.typeId] = [])).push(v);
						}
						return acc;
					}, {});
					var points = Object.keys(filterByTypes).map(function (o) {
						return (0, _SitesPoint2.default)({
							site: filterByTypes[o],
							type: _SiteTypes2.default.getType(o, _this5.props.siteTypes),
							link: _HomeConstants.PATH_POINT
						});
					});
	
					return [].concat([(0, _OSM2.default)()], layers, kmlWatershed, kmlManagementWater, kmlCities, points);
				}
				return [].concat([(0, _OSM2.default)()], layers, kmlWatershed, kmlManagementWater, kmlCities);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin', ref: 'refWidth' },
					_react2.default.createElement(_SelectionSaveModal2.default, null),
					_react2.default.createElement(_SelectionExportModal2.default, null),
					_react2.default.createElement(_ResearchTabPanel2.default, { actions: this.getActions(), isLogged: this.props.isLogged, page: _SitesConstants.MAP_RESEARCH }),
					this.getTabsSideBar(),
					_react2.default.createElement(
						'div',
						{ className: 'col s12 no-padding' },
						_react2.default.createElement(
							'div',
							{ className: 'row no-margin', id: 'mapResearch' },
							_react2.default.createElement(_Map2.default, { key: 'radiusResearchPanel', mapConf: this.getMapConf(), layers: this.getLayers(),
								radius: this.getRadius })
						)
					)
				);
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				_AppStore2.default.dispatch(_SelectionAction2.default.resetSelectedSelection());
				_AppStore2.default.dispatch(_SitesAction2.default.reset());
				_AppStore2.default.dispatch(_AdministrationAction2.default.resetSelectedFilters());
				_AppStore2.default.dispatch(_AdministrationAction2.default.resetEntry());
				_AppStore2.default.dispatch(_AdministrationAction2.default.resetSelectedThemes());
			}
		}]);
	
		return SitesApp;
	}(_ActionComponent3.default);
	
	var _initialiseProps = function _initialiseProps() {
		var _this6 = this;
	
		this.getLogged = function () {
			var token = sessionStorage.getItem('TOKEN');
			return !(!token || !atob(token));
		};
	
		this.openModalSave = function () {
			_AppStore2.default.dispatch(_SelectionAction2.default.openModalSelectionSave());
		};
	
		this.getSaveFunction = function () {
			if ((0, _UserUtils.checkBetaUser)(_this6.props.userRoles).length && _this6.props.selections.length === 5) {
				_AppStore2.default.dispatch(_ToastrAction2.default.warning(_simpleReactI18n2.default.warning.selectionLimit));
			} else {
				var isLogged = _this6.getLogged();
				if (isLogged) {
					_this6.openModalSave();
				} else {
					_AppStore2.default.dispatch(_HomeAction2.default.updateLoginModalState(true));
					_AppStore2.default.dispatch(_HomeAction2.default.updateLoginModalActions([_this6.openModalSave]));
				}
			}
		};
	
		this.setModalSelectionExport = function (selection) {
			_AppStore2.default.dispatch(_SelectionAction2.default.openModalSelectionExport(selection));
		};
	
		this.getActions = function () {
			var actions = [];
			if (_this6.props.selectedStations && _this6.props.selectedStations.length) {
				actions.push({
					fn: function fn() {
						return _this6.getSaveFunction();
					},
					icon: 'save',
					title: _simpleReactI18n2.default.saveSelection
				});
			}
			if (_this6.props.selectedSelection && _this6.props.selectedSelection.id) {
				actions.push({
					fn: function fn() {
						return _this6.setModalSelectionExport(_this6.props.selectedSelection);
					},
					icon: 'file_download',
					title: _simpleReactI18n2.default.download
				});
			}
			return actions;
		};
	
		this.setExtent = function (stations) {
			if (stations && stations.length) {
				var minX = (0, _lodash.minBy)(stations, function (s) {
					return s.xCoordinate;
				}).xCoordinate;
				var minY = (0, _lodash.minBy)(stations, function (s) {
					return s.yCoordinate;
				}).yCoordinate;
				var maxX = (0, _lodash.maxBy)(stations, function (s) {
					return s.xCoordinate;
				}).xCoordinate;
				var maxY = (0, _lodash.maxBy)(stations, function (s) {
					return s.yCoordinate;
				}).yCoordinate;
	
				var totalXAverage = (0, _lodash.sumBy)(stations, function (station) {
					return station.xCoordinate;
				}) / stations.length;
				var totalYAverage = (0, _lodash.sumBy)(stations, function (station) {
					return station.yCoordinate;
				}) / stations.length;
				var finalMinX = function () {
					if (minX < 0) {
						return minX + 0.2;
					}
					return minX - 0.2;
				}();
				var finalMaxX = function () {
					if (maxX < 0) {
						return maxX + 0.2;
					}
					return maxX - 0.2;
				}();
				_this6.setState({
					center: [totalXAverage, totalYAverage],
					zoom: 10.5,
					extent: stations.length > 1 ? [finalMinX, minY, finalMaxX, maxY] : null
				});
			}
		};
	
		this.createCityLayer = function (city) {
			var visibility = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
			return {
				id: city.id,
				name: (0, _lodash.capitalize)(city.name),
				code: city.code,
				url: _ApplicationConf2.default.layer.cityLayer(city.code),
				opacity: 1,
				visibility: visibility
			};
		};
	
		this.getCity = function (code) {
			return (0, _lodash.find)(_this6.props.cities, function (a) {
				return a.code == code;
			});
		};
	
		this.initLayers = function (filterTypeDto, props) {
			// City
			var selectedCities = (0, _lodash.filter)(props.selectedStations, function (s) {
				return s.typeParameter === _SiteTypes2.default.CITY.type;
			});
			var filterTypeCity = (0, _lodash.filter)(filterTypeDto, function (o) {
				if (o.filterTypeId) {
					return o.filterTypeId == '1';
				}
				return o;
			});
			var filterCities = filterTypeCity.concat(selectedCities);
			var cityLayers = filterCities.map(function (o) {
				var result = function () {
					var cityResearch = (0, _lodash.find)(filterTypeCity, function (a) {
						return a.value == o.value;
					});
					if (cityResearch) {
						var _city = _this6.getCity(cityResearch.value);
						return _this6.createCityLayer(_city, true);
					}
					var city = _this6.getCity(o.value || o.code);
					return _this6.createCityLayer(city);
				}();
				return new _DtoLayer2.default(result, 'KML');
			});
			_AppStore2.default.dispatch(_SitesAction2.default.updateCitiesLayers(cityLayers));
	
			// Management Water (SAGE)
			var filterManagementWater = (0, _lodash.filter)(filterTypeDto, function (o) {
				if (o.filterTypeId) {
					return o.filterTypeId == '98304';
				}
				return o;
			});
			var managementWaterLayers = filterManagementWater.map(function (o) {
				var managementWater = (0, _lodash.find)(props.managementWaters, function (a) {
					return a.id == o.value;
				});
				var result = {
					id: managementWater.id,
					name: managementWater.name,
					code: managementWater.code,
					url: _ApplicationConf2.default.layer.managementWaterLayer(managementWater.code),
					opacity: 1,
					visibility: true
				};
				return new _DtoLayer2.default(result, 'KML');
			});
			_AppStore2.default.dispatch(_SitesAction2.default.addManagementWaterLayers(managementWaterLayers));
	
			// Watershed
			var filterWatershed = (0, _lodash.filter)(filterTypeDto, function (o) {
				if (o.filterTypeId) {
					return o.filterTypeId == '65536';
				}
				return o;
			});
			var filterWatershedLayers = filterWatershed.map(function (o) {
				var watershed = (0, _lodash.find)(props.watersheds, function (a) {
					return a.id == o.value;
				});
				var result = {
					id: watershed.id,
					name: watershed.name,
					code: watershed.code,
					url: _ApplicationConf2.default.layer.whatershedLayer(watershed.code),
					opacity: 1,
					visibility: true
				};
				return new _DtoLayer2.default(result, 'KML');
			});
			_AppStore2.default.dispatch(_SitesAction2.default.addWatershedLayers(filterWatershedLayers));
		};
	
		this.getTitlePage = function (selection) {
			if (selection && selection.title) {
				return selection.title;
			}
			return _simpleReactI18n2.default.stationResearch;
		};
	
		this.change = function (value) {
			_AppStore2.default.dispatch(_SitesAction2.default.setVisualisation(value));
		};
	
		this.changeVisibility = function (id) {
			var selectedThemeUpdate = Object.assign([], _this6.props.selectedThemes);
			var newSelectedTheme = selectedThemeUpdate.map(function (o) {
				var layers = o.value.layers.map(function (layer) {
					if (layer.id == id) {
						return Object.assign({}, layer, {
							visibility: !layer.visibility
						});
					}
					return layer;
				});
				var result = o;
				o.value.layers = layers;
				return Object.assign({}, o, result);
			});
			_AppStore2.default.dispatch(_AdministrationAction2.default.selectedThemes(newSelectedTheme));
		};
	
		this.changeOpacity = function (id) {
			var selectedThemeUpdate = Object.assign([], _this6.props.selectedThemes);
			var newSelectedTheme = selectedThemeUpdate.map(function (o) {
				var layers = o.value.layers.map(function (layer) {
					if (layer.id == id) {
						return Object.assign({}, layer, {
							opacity: _this6.refs[id].value
						});
					}
					return layer;
				});
				var result = o;
				o.value.layers = layers;
				return Object.assign({}, o, result);
			});
			_AppStore2.default.dispatch(_AdministrationAction2.default.selectedThemes(newSelectedTheme));
		};
	
		this.addOrRemoveSelectedStations = function (layer) {
			var selectedStations = _this6.props.selectedStations.map(function (s) {
				return Object.assign({}, s);
			});
			if (layer.visibility) {
				var stationToAdd = (0, _lodash.filter)(_this6.props.stations, function (o) {
					return o.idWatershed == layer.id;
				});
				return [].concat(selectedStations, stationToAdd);
			}
			var stationToRemove = (0, _lodash.filter)(selectedStations, function (o) {
				return o.idWatershed == layer.id;
			});
			if (stationToRemove.length) {
				return (0, _lodash.pullAllBy)(selectedStations, stationToRemove, 'id');
			}
			return [];
		};
	
		this.changeWatershedVisibility = function (id) {
			var newList = Object.assign([], _this6.props.watershedLayers);
			var findLayer = (0, _lodash.find)(newList, function (a) {
				return a.id == id;
			});
			if (findLayer) {
				findLayer.visibility = !findLayer.visibility;
			}
			_AppStore2.default.dispatch(_SitesAction2.default.updateWatershedLayers(newList));
		};
	
		this.changeManagementWaterVisibility = function (id) {
			var newList = Object.assign([], _this6.props.managementWaterLayers);
			var findLayer = (0, _lodash.find)(newList, function (a) {
				return a.id == id;
			});
			if (findLayer) {
				findLayer.visibility = !findLayer.visibility;
				var stationSelected = _this6.addOrRemoveSelectedStations(findLayer);
				_AppStore2.default.dispatch(_SitesAction2.default.setSelectedStations(stationSelected));
			}
			_AppStore2.default.dispatch(_SitesAction2.default.updateManagementWaterLayers(newList));
		};
	
		this.changeCitiesLayersVisibility = function (id) {
			var newList = Object.assign([], _this6.props.citiesLayers);
			var findLayer = (0, _lodash.find)(newList, function (a) {
				return a.id == id;
			});
			if (findLayer) {
				findLayer.visibility = !findLayer.visibility;
			}
			_AppStore2.default.dispatch(_SitesAction2.default.updateCitiesLayers(newList));
		};
	
		this.changeVisibilityCityLayer = function () {
			var visibility = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
			return _this6.props.citiesLayers.map(function (o) {
				return Object.assign({}, o, {
					visibility: visibility
				});
			});
		};
	
		this.changeVisibilityWatershedsLayer = function () {
			var visibility = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
			return _this6.props.watershedLayers.map(function (o) {
				return Object.assign({}, o, {
					visibility: visibility
				});
			});
		};
	
		this.resetAllLayers = function (id, isCheck) {
			switch (id) {
				case idCityLayerPanel:
					var selectedCityLayer = function () {
						if (isCheck) {
							return _this6.changeVisibilityCityLayer(true);
						}
						return _this6.changeVisibilityCityLayer();
					}();
					_AppStore2.default.dispatch(_SitesAction2.default.updateCitiesLayers(selectedCityLayer));
					break;
				case idWatershedLayerPanel:
					var watershedLayers = function () {
						if (isCheck) {
							return _this6.changeVisibilityWatershedsLayer(true);
						}
						return _this6.changeVisibilityWatershedsLayer();
					}();
					_AppStore2.default.dispatch(_SitesAction2.default.updateWatershedLayers(watershedLayers));
					break;
				default:
					break;
			}
		};
	
		this.getCityLegend = function (defaultStyle) {
			if (_this6.props.citiesLayers.length) {
				var style = Object.assign({}, defaultStyle, {
					backgroundColor: '#ff0000'
				});
				return _react2.default.createElement(
					'div',
					{ key: _uuid2.default.v4(), className: 'row no-margin' },
					_react2.default.createElement(
						'div',
						{ className: 'col s4 theme-icon-column valign-wrapper icon-img' },
						_react2.default.createElement('hr', { style: style })
					),
					_react2.default.createElement(
						'div',
						{ className: 'col s8' },
						_react2.default.createElement(
							'span',
							{ className: 'title' },
							' ',
							_simpleReactI18n2.default.point.city
						)
					)
				);
			}
			return null;
		};
	
		this.getWatershedLegend = function (defaultStyle) {
			if (_this6.props.watershedLayers.length) {
				var style = Object.assign({}, defaultStyle, {
					backgroundColor: '#0000ff'
				});
				return _react2.default.createElement(
					'div',
					{ key: _uuid2.default.v4(), className: 'row no-margin' },
					_react2.default.createElement(
						'div',
						{ className: 'col s4 theme-icon-column valign-wrapper icon-img' },
						_react2.default.createElement('hr', { style: style })
					),
					_react2.default.createElement(
						'div',
						{ className: 'col s8' },
						_react2.default.createElement(
							'span',
							{ className: 'title' },
							' ',
							_simpleReactI18n2.default.point.watershed
						)
					)
				);
			}
			return null;
		};
	
		this.getManagementWaterLegend = function (defaultStyle) {
			if (_this6.props.managementWaterLayers.length) {
				var style = Object.assign({}, defaultStyle, {
					backgroundColor: 'black'
				});
				return _react2.default.createElement(
					'div',
					{ key: _uuid2.default.v4(), className: 'row no-margin' },
					_react2.default.createElement(
						'div',
						{ className: 'col s4 theme-icon-column valign-wrapper icon-img' },
						_react2.default.createElement('hr', { style: style })
					),
					_react2.default.createElement(
						'div',
						{ className: 'col s8' },
						_react2.default.createElement(
							'span',
							{ className: 'title' },
							' ',
							_simpleReactI18n2.default.managementWater
						)
					)
				);
			}
			return null;
		};
	
		this.getDefaultLegends = function () {
			var style = {
				height: '5px',
				width: '100px'
			};
			var layers = [];
			var city = _this6.getCityLegend(style);
			var watershed = _this6.getWatershedLegend(style);
			var managementWater = _this6.getManagementWaterLegend(style);
			if (city) {
				layers.push(city);
			}
			if (watershed) {
				layers.push(watershed);
			}
			if (managementWater) {
				layers.push(managementWater);
			}
			if (layers.length) {
				return {
					title: _simpleReactI18n2.default.defaultLegend + '(' + layers.length + ')',
					component: layers,
					icon: 'location_city'
				};
			}
			return null;
		};
	
		this.getTitle = function (title, plurialTitle, number) {
			return _react2.default.createElement(
				'h6',
				null,
				number,
				' ',
				(0, _StringUtils.getPlurialWithNumber)(title, plurialTitle, number)
			);
		};
	
		this.getSimpleTitle = function (title, number) {
			return _react2.default.createElement(
				'h6',
				null,
				number,
				' ',
				title
			);
		};
	
		this.setTitle = function (title) {
			if (_this6.props.stations.length) {
				return title + ' (' + _this6.props.selectedStations.length + '/' + _this6.props.stations.length + ')';
			}
			return title;
		};
	
		this.openModal = function (id) {
			'';
	
			$('#' + id).modal('open');
		};
	
		this.getRadius = function (coord, radius) {
			var joinParameter = coord.concat(radius.toFixed(2));
			var rad = parseFloat(joinParameter[2]);
			if (rad > 20) {
				_AppStore2.default.dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.error.radiusLimited20km));
				return;
			}
			var radiusDto = new _DtoRadius2.default(joinParameter[0], joinParameter[1], rad);
			var filterTypeRadius = {
				label: 'x: ' + (0, _StringUtils.substringNumber)(radiusDto.longi) + ' y: ' + (0, _StringUtils.substringNumber)(radiusDto.lati) + ' ' + _simpleReactI18n2.default.radius + ': ' + parseFloat(radiusDto.radius),
				value: radiusDto,
				type: _ResearchTypes2.default.RADIUS
			};
			var tmp = _this6.props.selectedFilters.slice();
			tmp.push(filterTypeRadius);
			var selectedFilters = (0, _lodash.uniqWith)(tmp, _lodash.isEqual);
			_AppStore2.default.dispatch(_AdministrationAction2.default.selectedFilters(selectedFilters));
			_SitesAction2.default.launchResearch(selectedFilters, _this6.props.selectedThemes, _this6.props.filterTypes);
		};
	
		this.getKmlCities = function () {
			return _this6.props.citiesLayers.filter(function (a) {
				return a.visibility;
			}).map(function (layer) {
				return (0, _LayerUtils.getLayer)(layer, _PopupFactory2.default.popupKmlCity, {
					title: _simpleReactI18n2.default.town
				});
			});
		};
	
		this.getKmlDepartments = function () {
			return _this6.props.citiesLayers.filter(function (a) {
				return a.visibility;
			}).map(function (layer) {
				return (0, _LayerUtils.getLayer)(layer, _PopupFactory2.default.popupKmlCity, {
					title: _simpleReactI18n2.default.town
				});
			});
		};
	
		this.getWaterShedKml = function () {
			return _this6.props.watershedLayers.filter(function (a) {
				return a.visibility;
			}).map(function (layer) {
				return (0, _LayerUtils.getLayer)(layer, _PopupFactory2.default.popupKmlWaterSheed, {
					title: _simpleReactI18n2.default.watershedArea
				});
			});
		};
	
		this.getManagementWaterKml = function () {
			return _this6.props.managementWaterLayers.filter(function (a) {
				return a.visibility;
			}).map(function (layer) {
				return (0, _LayerUtils.getLayer)(layer, _PopupFactory2.default.popupKmlManagementWater, {
					title: 'SAGE'
				});
			});
		};
	
		this.getFinalStation = function (propsStation) {
			var piezoQualitoStations = (0, _lodash.filter)(propsStation, function (o) {
				return o.isPiezometer == '1' && o.isQualitometer == '1';
			});
			var typePiezometer = _SiteTypes2.default.getTypeByParameter(_SiteTypes2.default.PIEZOMETER.type, _this6.props.siteTypes);
			return piezoQualitoStations.map(function (o) {
				return Object.assign({}, o, {
					typeId: typePiezometer.id,
					typeParameter: typePiezometer.parameter
				});
			});
		};
	};
	
	SitesApp.propTypes = {
		params: _propTypes2.default.shape({
			isOpen: _propTypes2.default.string
		}),
		user: _propTypes2.default.objectOf(_DtoUser2.default),
		isLogged: _propTypes2.default.bool,
		userRoles: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoUserRole2.default)),
		login: _propTypes2.default.string,
		stations: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoStation2.default)),
		cities: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoCity2.default)),
		watersheds: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoWatershed2.default)),
		managementWaters: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoManagementWater2.default)),
		siteTypes: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoSiteType2.default)),
		selectedValue: _propTypes2.default.string,
		oldValue: _propTypes2.default.string,
		radius: _propTypes2.default.string,
		selectedFilters: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			label: _propTypes2.default.string,
			value: _propTypes2.default.object
		})),
		selectedThemes: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			label: _propTypes2.default.string,
			value: _propTypes2.default.instanceOf(_ThemeDto2.default)
		})),
		filterTypes: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoFilterType2.default)),
		themes: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_ThemeDto2.default)),
		watershedSelected: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoWatershed2.default)),
		watershedLayers: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoLayer2.default)),
		managementWaterLayers: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoLayer2.default)),
		citiesLayers: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoLayer2.default)),
		selectedSelection: _propTypes2.default.instanceOf(_DtoSelectionRow2.default),
		selections: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoSelectionRow2.default)),
		selectedStations: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoStation2.default))
	};
	
	SitesApp.defaultProps = {
		login: '',
		isLogged: false
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			user: store.HomeReducer.user,
			userRoles: store.HomeReducer.userRoles,
			stations: store.SitesReducer.stations,
			selectedValue: store.SitesReducer.selectedValue,
			oldValue: store.SitesReducer.oldValue,
			radius: store.SitesReducer.radius,
			siteTypes: store.ReferentialReducer.siteTypes,
			cities: store.ReferentialReducer.cities,
			watersheds: store.ReferentialReducer.watersheds,
			managementWaters: store.ReferentialReducer.managementWaters,
			selectedFilters: store.AdministrationReducer.selectedFilters,
			filterTypes: store.ReferentialReducer.filterTypes,
			selectedThemes: store.AdministrationReducer.selectedThemes,
			themes: store.AdministrationReducer.themes,
			watershedSelected: store.SitesReducer.watershedSelected,
			watershedLayers: store.SitesReducer.watershedLayers,
			managementWaterLayers: store.SitesReducer.managementWaterLayers,
			citiesLayers: store.SitesReducer.citiesLayers,
			selectedSelection: store.SelectionReducer.selectedSelection,
			selections: store.SelectionReducer.selections,
			selectedStations: store.SitesReducer.selectedStations
		};
	};
	
	var dragContext = (0, _reactDnd.DragDropContext)(_reactDndHtml5Backend2.default)(SitesApp);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(dragContext);

/***/ },
/* 2175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Action = __webpack_require__(1017);
	
	var _Action2 = _interopRequireDefault(_Action);
	
	var _SitesAction = __webpack_require__(97);
	
	var _SitesAction2 = _interopRequireDefault(_SitesAction);
	
	var _AdministrationAction = __webpack_require__(61);
	
	var _AdministrationAction2 = _interopRequireDefault(_AdministrationAction);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _reactRedux = __webpack_require__(18);
	
	var _DtoFilterType = __webpack_require__(130);
	
	var _DtoFilterType2 = _interopRequireDefault(_DtoFilterType);
	
	var _ThemeDto = __webpack_require__(129);
	
	var _ThemeDto2 = _interopRequireDefault(_ThemeDto);
	
	var _DtoUser = __webpack_require__(54);
	
	var _DtoUser2 = _interopRequireDefault(_DtoUser);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _lodash = __webpack_require__(15);
	
	var _uuid = __webpack_require__(44);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _ResearchBarPanel = __webpack_require__(1040);
	
	var _ResearchBarPanel2 = _interopRequireDefault(_ResearchBarPanel);
	
	var _ReferentialAction = __webpack_require__(380);
	
	var _ReferentialAction2 = _interopRequireDefault(_ReferentialAction);
	
	var _ToastrAction = __webpack_require__(66);
	
	var _ToastrAction2 = _interopRequireDefault(_ToastrAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResearchTabPanel = function (_Component) {
		_inherits(ResearchTabPanel, _Component);
	
		function ResearchTabPanel(props) {
			_classCallCheck(this, ResearchTabPanel);
	
			var _this = _possibleConstructorReturn(this, (ResearchTabPanel.__proto__ || Object.getPrototypeOf(ResearchTabPanel)).call(this, props));
	
			_this.getDefaultTheme = function (allReferencialThemes) {
				var allThemes = (0, _lodash.flatten)(allReferencialThemes.map(function (o) {
					return o.themes;
				}));
				var filterTheme = (0, _lodash.filter)(allThemes, function (o) {
					return !o.disable;
				});
				return filterTheme.map(function (o) {
					return {
						label: o.title,
						value: o
					};
				});
			};
	
			_this.getDefaultButton = function (action) {
				if (action) {
					return _react2.default.createElement(
						'a',
						{ type: 'submit', 'data-position': 'top', 'data-delay': '5', 'data-tooltip': _simpleReactI18n2.default.research, name: 'action',
							onClick: function onClick() {
								return action();
							} },
						_react2.default.createElement(
							'i',
							{ className: 'material-icons black-text small-research-icon' },
							'search'
						)
					);
				}
				return _react2.default.createElement(
					'a',
					{ type: 'submit', 'data-position': 'top', 'data-delay': '5', 'data-tooltip': _simpleReactI18n2.default.research, name: 'action',
						onClick: function onClick() {
							return action();
						} },
					_react2.default.createElement(
						'i',
						{ className: 'material-icons black-text small-research-icon' },
						'search'
					)
				);
			};
	
			_this.getResearchButton = function () {
				if (_this.props.selectedFilters.length) {
					if (_this.props.selectedThemes.length) {
						return _this.getDefaultButton(function () {
							return _SitesAction2.default.launchResearch(_this.props.selectedFilters, _this.props.selectedThemes, _this.props.filterTypes);
						});
					}
				} else if (_this.props.selectedThemes.length) {
					return _this.getDefaultButton(function () {
						return _AppStore2.default.dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.warning.pleaseFillLeastFilter));
					});
				}
				return _this.getDefaultButton(function () {
					return _AppStore2.default.dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.warning.pleaseFillLeastFilter));
				});
			};
	
			_this.getActions = function () {
				return _this.props.actions.map(function (action) {
					return _react2.default.createElement(_Action2.default, { key: _uuid2.default.v4(), onClick: action.fn, icon: action.icon, component: action.component,
						title: action.title });
				});
			};
	
			return _this;
		}
	
		_createClass(ResearchTabPanel, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				_AppStore2.default.dispatch(_AdministrationAction2.default.fetchThemes());
				if (this.props.filterTypes.length === 0) {
					_AppStore2.default.dispatch(_ReferentialAction2.default.fetchFilterTypes());
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nexprops) {
				if (!nexprops.selectedThemes.length && nexprops.themes.length) {
					var initDefaultTheme = this.getDefaultTheme(nexprops.themes);
					_AppStore2.default.dispatch(_AdministrationAction2.default.selectedThemes(initDefaultTheme));
				}
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'research-map col s6 valign-wrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'search-content no-padding' },
						_react2.default.createElement(
							'div',
							{ className: 'row no-margin valign-wrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'col s11 no-padding' },
								_react2.default.createElement(_ResearchBarPanel2.default, { isResearchMap: true,
									researchClick: this.researchClick,
									actions: this.getResearchButton(),
									isLogged: this.props.isLogged,
									page: this.props.page
								})
							),
							_react2.default.createElement(
								'div',
								{ className: 'col s1 no-padding' },
								_react2.default.createElement(
									'div',
									{ className: 'search-actions' },
									this.getActions()
								)
							)
						)
					)
				);
			}
		}]);
	
		return ResearchTabPanel;
	}(_react.Component);
	
	ResearchTabPanel.propTypes = {
		researchType: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			type: _propTypes2.default.string.isRequired,
			title: _propTypes2.default.string.isRequired,
			icon: _propTypes2.default.string.isRequired,
			component: _propTypes2.default.object,
			comment: _propTypes2.default.string
		})),
		user: _propTypes2.default.objectOf(_DtoUser2.default),
		isLogged: _propTypes2.default.bool,
		selectedFilters: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			label: _propTypes2.default.string,
			value: _propTypes2.default.object
		})),
		selectedThemes: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			label: _propTypes2.default.string,
			value: _propTypes2.default.instanceOf(_ThemeDto2.default)
		})),
		themes: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_ThemeDto2.default)),
		filterTypes: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoFilterType2.default)),
		actions: _propTypes2.default.arrayOf({
			onClick: _propTypes2.default.func.isRequired,
			icon: _propTypes2.default.string,
			title: _propTypes2.default.string,
			component: _propTypes2.default.element
		}),
		page: _propTypes2.default.string
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			user: store.HomeReducer.user,
			selectedFilters: store.AdministrationReducer.selectedFilters,
			filterTypes: store.ReferentialReducer.filterTypes,
			selectedThemes: store.AdministrationReducer.selectedThemes,
			themes: store.AdministrationReducer.themes
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ResearchTabPanel);

/***/ },
/* 2176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(15);
	
	var _reactRedux = __webpack_require__(18);
	
	var _ListComponent = __webpack_require__(528);
	
	var _ListComponent2 = _interopRequireDefault(_ListComponent);
	
	var _DtoStation = __webpack_require__(88);
	
	var _DtoStation2 = _interopRequireDefault(_DtoStation);
	
	var _DtoSamplingPoint = __webpack_require__(1045);
	
	var _DtoSamplingPoint2 = _interopRequireDefault(_DtoSamplingPoint);
	
	var _DtoSiteType = __webpack_require__(96);
	
	var _DtoSiteType2 = _interopRequireDefault(_DtoSiteType);
	
	var _DtoStationRow = __webpack_require__(2181);
	
	var _DtoStationRow2 = _interopRequireDefault(_DtoStationRow);
	
	var _SiteTypes = __webpack_require__(56);
	
	var _SiteTypes2 = _interopRequireDefault(_SiteTypes);
	
	var _CheckPanel = __webpack_require__(1022);
	
	var _CheckPanel2 = _interopRequireDefault(_CheckPanel);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _SitesAction = __webpack_require__(97);
	
	var _SitesAction2 = _interopRequireDefault(_SitesAction);
	
	var _DtoKeyFigures = __webpack_require__(98);
	
	var _DtoKeyFigures2 = _interopRequireDefault(_DtoKeyFigures);
	
	var _DateUtil = __webpack_require__(67);
	
	var _StringUtils = __webpack_require__(131);
	
	var _filter = __webpack_require__(802);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _DtoIndicatorType = __webpack_require__(537);
	
	var _DtoIndicatorType2 = _interopRequireDefault(_DtoIndicatorType);
	
	var _DtoCityIndicator = __webpack_require__(1043);
	
	var _DtoCityIndicator2 = _interopRequireDefault(_DtoCityIndicator);
	
	var _DtoIndicator = __webpack_require__(536);
	
	var _DtoIndicator2 = _interopRequireDefault(_DtoIndicator);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	var _DtoCityInformation = __webpack_require__(1044);
	
	var _DtoCityInformation2 = _interopRequireDefault(_DtoCityInformation);
	
	var _DtoSelectionRow = __webpack_require__(182);
	
	var _DtoSelectionRow2 = _interopRequireDefault(_DtoSelectionRow);
	
	var _ThemeDto = __webpack_require__(129);
	
	var _ThemeDto2 = _interopRequireDefault(_ThemeDto);
	
	var _ThemesUtils = __webpack_require__(384);
	
	var _DtoWatershed = __webpack_require__(539);
	
	var _DtoWatershed2 = _interopRequireDefault(_DtoWatershed);
	
	var _DtoLayer = __webpack_require__(372);
	
	var _DtoLayer2 = _interopRequireDefault(_DtoLayer);
	
	var _ExpansionPanel = __webpack_require__(580);
	
	var _ExpansionPanel2 = _interopRequireDefault(_ExpansionPanel);
	
	var _Typography = __webpack_require__(75);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _ExpansionPanelSummary = __webpack_require__(582);
	
	var _ExpansionPanelSummary2 = _interopRequireDefault(_ExpansionPanelSummary);
	
	var _ExpandMore = __webpack_require__(1335);
	
	var _ExpandMore2 = _interopRequireDefault(_ExpandMore);
	
	var _ExpansionPanelDetails = __webpack_require__(581);
	
	var _ExpansionPanelDetails2 = _interopRequireDefault(_ExpansionPanelDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StationTabPanel = function (_Component) {
		_inherits(StationTabPanel, _Component);
	
		function StationTabPanel(props) {
			_classCallCheck(this, StationTabPanel);
	
			var _this = _possibleConstructorReturn(this, (StationTabPanel.__proto__ || Object.getPrototypeOf(StationTabPanel)).call(this, props));
	
			_this.getTitle = function (station) {
				var title = station.name != station.code ? station.code + ' - ' + station.name : station.code;
				return _react2.default.createElement(
					'span',
					{ className: 'truncate font-size-12' },
					title
				);
			};
	
			_this.getBackgroundColor = function (station) {
				var findStation = (0, _lodash.find)(_this.props.selectedStations, function (o) {
					return o.id == station.id;
				});
				if (!findStation) {
					return 'rgba(128,128,128, 0.1)';
				}
				return 'white';
			};
	
			_this.getInfoComponent = function (data, date, label) {
				var labelPlurial = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : label;
	
				var finalLabel = data > 1 ? labelPlurial : label;
				var last = data > 1 ? _simpleReactI18n2.default.multi.lastMin : _simpleReactI18n2.default.lastMin;
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin' },
					_react2.default.createElement(
						'div',
						{ className: 'col s12 no-padding' },
						_react2.default.createElement(
							'div',
							{ className: 'row no-margin' },
							_react2.default.createElement(
								'span',
								null,
								data,
								' ',
								finalLabel,
								' : ',
								last,
								' ',
								finalLabel,
								' ',
								(0, _DateUtil.getDate)(date)
							)
						)
					)
				);
			};
	
			_this.getDefaultDescription = function (station) {
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin', onMouseLeave: function onMouseLeave() {
							return _this.onHoverFunction({});
						},
						onMouseEnter: function onMouseEnter() {
							return _this.onHoverFunction(station);
						} },
					_this.getTitle(station),
					_react2.default.createElement('div', null)
				);
			};
	
			_this.getNbMeasures = function (station, keyFigure) {
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin', onMouseLeave: function onMouseLeave() {
							return _this.onHoverFunction({});
						},
						onMouseEnter: function onMouseEnter() {
							return _this.onHoverFunction(station);
						} },
					_this.getTitle(station),
					_react2.default.createElement(
						'div',
						{ className: 'row no-margin left' },
						_react2.default.createElement(
							'div',
							{ className: 'col s12 no-padding' },
							_this.getInfoComponent(keyFigure.nbMeasure, keyFigure.endDate, _simpleReactI18n2.default.measureMin, _simpleReactI18n2.default.measuresMin)
						)
					)
				);
			};
	
			_this.getPiezometerDescriptions = function (station) {
				var keyFigure = station.keyFigure;
				if (keyFigure) {
					return _this.getNbMeasures(station, keyFigure);
				}
				return _this.getDefaultDescription(station);
			};
	
			_this.getPluviometerDescriptions = function (station) {
				var keyFigure = station.keyFigure;
				if (keyFigure) {
					return _this.getNbMeasures(station, keyFigure);
				}
				return _this.getDefaultDescription(station);
			};
	
			_this.getQualitometerDescriptions = function (station) {
				var keyFigure = station.keyFigure;
				if (keyFigure) {
					var endDate = keyFigure.endDate ? (0, _DateUtil.getDate)(keyFigure.endDate) : '';
					var nbAnalyse = keyFigure.nbAnalysis ? keyFigure.nbAnalysis : 0;
					if (nbAnalyse) {
						return _react2.default.createElement(
							'div',
							{ className: 'row no-margin', onMouseLeave: function onMouseLeave() {
									return _this.onHoverFunction({});
								},
								onMouseEnter: function onMouseEnter() {
									return _this.onHoverFunction(station);
								} },
							_this.getTitle(station),
							_react2.default.createElement(
								'div',
								{ className: 'row no-margin left' },
								_react2.default.createElement(
									'div',
									{ className: 'col s12 no-padding' },
									_this.getInfoComponent(nbAnalyse, endDate, _simpleReactI18n2.default.lowerAnalysis, _simpleReactI18n2.default.lowerAnalyses)
								)
							)
						);
					}
					return _this.getDefaultDescription(station);
				}
				return _this.getDefaultDescription(station);
			};
	
			_this.getWaterServiceCheck = function () {
				var findService = (0, _lodash.find)(_this.props.selectedThemes, function (o) {
					return o.value.id == '8';
				});
				return !!findService;
			};
	
			_this.getCityDescription = function (point) {
				if (_this.props.cityInformations.length) {
					var findCity = (0, _lodash.find)(_this.props.cityInformations, function (o) {
						return o.code == point.code;
					});
					var cityInformation = function () {
						if (findCity && findCity.population) {
							return _react2.default.createElement(
								'div',
								{ className: 'row no-margin' },
								_react2.default.createElement(
									'span',
									null,
									_simpleReactI18n2.default.population
								),
								' : ',
								findCity.population
							);
						}
						return null;
					}();
					var waterServiceCheck = _this.getWaterServiceCheck();
	
					var completeCityInformation = function () {
						if (waterServiceCheck) {
							if (_this.props.indicatorTypes.length && _this.props.cityIndicators.length && _this.props.indicators.length) {
								var filterIndicators = (0, _filter2.default)(_this.props.cityIndicators, function (o) {
									return o.stationId == point.id;
								});
								if (filterIndicators.length) {
									var listOfIndicators = (0, _lodash.intersectionWith)(_this.props.indicators, filterIndicators, function (a, b) {
										return a.id == b.indicatorId;
									});
									if (listOfIndicators.length) {
										var reduceType = (0, _lodash.reduce)(listOfIndicators, function (result, value) {
											(result[value.typeId] || (result[value.typeId] = [])).push(value);
											return result;
										}, {});
										return Object.keys(reduceType).map(function (o) {
											var indicatorType = (0, _lodash.find)(_this.props.indicatorTypes, function (type) {
												return type.id == o;
											});
											var listOfCityIndicators = (0, _lodash.orderBy)((0, _lodash.intersectionWith)(filterIndicators, reduceType[o], function (a, b) {
												return a.indicatorId == b.id;
											}), ['date'], ['desc']);
											var lastDate = listOfCityIndicators[0].date;
											var nbIndicators = listOfCityIndicators.length;
											return _react2.default.createElement(
												'div',
												{ className: 'row no-margin', key: o },
												_react2.default.createElement(
													'span',
													null,
													indicatorType.mnemonique
												),
												' : ',
												nbIndicators,
												' ',
												(0, _StringUtils.getPlurial)(_simpleReactI18n2.default.indicatorMin, _simpleReactI18n2.default.indicatorsMin, nbIndicators),
												' ',
												(0, _DateUtil.getDate)(lastDate)
											);
										});
									}
									return null;
								}
								return null;
							}
							return null;
						}
						return null;
					}();
	
					return _react2.default.createElement(
						'div',
						{ className: 'row no-margin', onMouseLeave: function onMouseLeave() {
								return _this.onHoverFunction({});
							},
							onMouseEnter: function onMouseEnter() {
								return _this.onHoverFunction(point);
							} },
						_react2.default.createElement(
							'h6',
							null,
							_this.getTitle(point)
						),
						_react2.default.createElement(
							'div',
							{ className: 'row no-margin left' },
							_react2.default.createElement(
								'div',
								{ className: 'col s12 no-padding' },
								cityInformation,
								completeCityInformation
							)
						)
					);
				}
				return _this.getDefaultDescription(point);
			};
	
			_this.getComponentOfType = function (station, type) {
				switch (type) {
					case _SiteTypes2.default.QUALITOMETER.type:
					case _SiteTypes2.default.QUALITOMETER_SURFACE.type:
						return _this.getQualitometerDescriptions(station);
					case _SiteTypes2.default.PIEZOMETER.type:
						return _this.getPiezometerDescriptions(station);
					case _SiteTypes2.default.PLUVIOMETER.type:
						return _this.getPluviometerDescriptions(station);
					case _SiteTypes2.default.CITY.type:
						return _this.getCityDescription(station);
					case _SiteTypes2.default.FISHING_PLACE.type:
						return _this.getDefaultDescription(station);
					default:
						return _this.getDefaultDescription(station);
				}
			};
	
			_this.addOrRemoveSelectedStations = function (idType, isCheck) {
				var selectedStations = Object.assign([], _this.props.selectedStations);
				if (isCheck) {
					var stationToAdd = (0, _filter2.default)(_this.props.stations, function (o) {
						return o.typeId == idType;
					});
					return (0, _lodash.uniqWith)([].concat(selectedStations, stationToAdd), function (a, b) {
						return a.id === b.id;
					});
				}
				var stationToRemove = (0, _filter2.default)(selectedStations, function (o) {
					return o.typeId == idType;
				});
				return (0, _lodash.pullAllBy)(selectedStations, stationToRemove, 'id');
			};
	
			_this.resetAllTypeFunction = function (idType, isCheck) {
				var stationSelected = _this.addOrRemoveSelectedStations(idType, isCheck);
				_AppStore2.default.dispatch(_SitesAction2.default.setSelectedStations(stationSelected));
			};
	
			_this.getCheckTypes = function (typeId) {
				var watershedId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
				var stationsType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
	
				var listOfSites = function () {
					if (stationsType) {
						return (0, _filter2.default)(_this.props.selectedStations, function (o) {
							return (0, _lodash.find)(stationsType, function (b) {
								return b.id === o.id;
							});
						});
					}
					return _this.props.selectedStations;
				}();
				if (listOfSites) {
					return !!(0, _filter2.default)(listOfSites, function (o) {
						if (watershedId) {
							return o.typeId === typeId && o.idWatershed == watershedId;
						}
						return o.typeId === typeId;
					}).length;
				}
				return false;
			};
	
			_this.getReduceFilterType = function (stations) {
				var watershedId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
				var listOfStations = function () {
					if (watershedId) {
						return (0, _filter2.default)(stations, function (o) {
							return o.idWatershed === watershedId;
						});
					}
					return stations;
				}();
				return (0, _lodash.reduce)(listOfStations, function (result, value) {
					var tmpType = _SiteTypes2.default.getType(value.typeId, _this.props.siteTypes);
					(result[tmpType.type] || (result[tmpType.type] = [])).push(value);
					return result;
				}, {});
			};
	
			_this.getListOfStationWithKeyFigures = function (listOfStation, siteType) {
				return (0, _lodash.orderBy)(listOfStation.map(function (station) {
					var keyFigures = function () {
						if (siteType) {
							return (0, _lodash.find)(_this.props.keyFigures, function (o) {
								return o.typeId == siteType.id && o.stationId == station.id;
							});
						}
						return (0, _lodash.find)(_this.props.keyFigures, function (o) {
							return o.stationId == station.id;
						});
					}();
					var nbKeyFigures = function () {
						if (keyFigures) {
							return keyFigures.nbAnalysis + keyFigures.nbMeasure;
						}
						return 0;
					}();
					return Object.assign({}, station, {
						keyFigure: keyFigures,
						nbKeyFigures: nbKeyFigures
					});
				}), 'nbKeyFigures', 'desc');
			};
	
			_this.addOrRemoveSelectedStationsWithIdWaterSged = function (idWatershed, isCheck) {
				var selectedStations = Object.assign([], _this.props.selectedStations);
				if (isCheck) {
					var stationToAdd = (0, _filter2.default)(_this.props.stations, function (o) {
						return o.idWatershed == idWatershed;
					});
					return (0, _lodash.uniqWith)([].concat(selectedStations, stationToAdd), function (a, b) {
						return a.id === b.id;
					});
				}
				var stationToRemove = (0, _filter2.default)(selectedStations, function (o) {
					return o.idWatershed == idWatershed;
				});
				return (0, _lodash.pullAllBy)(selectedStations, stationToRemove, 'id');
			};
	
			_this.checkWaterShed = function (idWatershed, isCheck) {
				var stationSelected = _this.addOrRemoveSelectedStationsWithIdWaterSged(idWatershed, isCheck);
				_AppStore2.default.dispatch(_SitesAction2.default.setSelectedStations(stationSelected));
			};
	
			_this.getWatershedTabs = function () {
				var entities = [];
				if (_this.props.watershedSelected.length) {
					_this.props.watershedSelected.forEach(function (watershed) {
						var filterByTypes = _this.getReduceFilterType(_this.props.stations, watershed.id);
						var sites = (0, _lodash.uniqBy)((0, _lodash.flatten)((0, _lodash.orderBy)((0, _filter2.default)(_this.props.selectedThemes, ['value.disable', false]), ['value.id'], ['asc']).map(function (theme) {
							return theme.value.siteTypes.filter(function (o) {
								return filterByTypes[o.type] && filterByTypes[o.type].length;
							}).map(function (st) {
								var type = st.type;
								var typeSize = filterByTypes[type].length;
								var siteType = _this.props.siteTypes.find(function (o) {
									return o.parameter == type;
								});
								var finalStation = _this.getListOfStationWithKeyFigures(filterByTypes[type], siteType);
								var stationList = finalStation.map(function (station, i) {
									var stationRow = new _DtoStationRow2.default(station);
									var checkedStation = _this.getCheckStation(station.id);
									return _react2.default.createElement(
										_CheckPanel2.default,
										{ key: i,
											onToggleCheck: function onToggleCheck() {
												return _AppStore2.default.dispatch(_SitesAction2.default.toggleSelectedStations(station));
											},
											backgroundColor: _this.getBackgroundColor(station),
											checked: checkedStation },
										_this.getComponentOfType(stationRow, type)
									);
								});
								var idType = siteType.id;
								var isChecked = _this.getCheckTypes(idType, watershed.id);
								return {
									title: _SiteTypes2.default[type].name(typeSize) + ' (' + typeSize + ')',
									component: stationList,
									lightMode: true,
									picture: _SiteTypes2.default[type].icon,
									id: idType,
									isChecked: isChecked
								};
							});
						})), 'id');
						var waterShedCheck = !!_this.props.selectedStations.filter(function (o) {
							return o.idWatershed == watershed.id;
						}).length;
						var nbSites = (0, _lodash.sumBy)(sites, function (a) {
							return a.component.length;
						});
						var result = {
							title: watershed.code + ' - ' + watershed.name + ' (' + nbSites + ')',
							id: watershed.id,
							component: _react2.default.createElement(_ListComponent2.default, { tables: sites, generalFunction: _this.resetAllTypeFunction }),
							isChecked: waterShedCheck
						};
						entities.push(result);
					});
				}
				return _react2.default.createElement(_ListComponent2.default, { tables: entities, generalFunction: _this.checkWaterShed });
			};
	
			_this.getTabs = function () {
				var entities = [];
				var filterByTypes = _this.getReduceFilterType(_this.props.stations);
				(0, _lodash.orderBy)((0, _filter2.default)(_this.props.selectedThemes, ['value.disable', false]), ['value.id'], ['asc']).forEach(function (theme) {
					var color = (0, _ThemesUtils.getColor)(_this.props.themes, theme.value, 1);
					var finalSiteTypes = theme.value.siteTypes.filter(function (o) {
						return filterByTypes[o.type] && filterByTypes[o.type].length;
					});
					var size = finalSiteTypes.length;
					if (size) {
						var siteTypes = finalSiteTypes.map(function (st) {
							var type = st.type;
							var typeSize = filterByTypes[type].length;
							var siteType = _this.props.siteTypes.find(function (o) {
								return o.parameter == type;
							});
							var finalStation = _this.getListOfStationWithKeyFigures(filterByTypes[type]);
							var stationList = finalStation.map(function (station, i) {
								var stationRow = new _DtoStationRow2.default(station);
								var checkedStation = _this.getCheckStation(station.id);
								return _react2.default.createElement(
									_CheckPanel2.default,
									{ key: i,
										onToggleCheck: function onToggleCheck() {
											return _AppStore2.default.dispatch(_SitesAction2.default.toggleSelectedStations(station));
										},
										backgroundColor: _this.getBackgroundColor(station), checked: checkedStation },
									_this.getComponentOfType(stationRow, type)
								);
							});
							var idType = siteType.id;
							var isChecked = _this.getCheckTypes(idType);
							return {
								title: _SiteTypes2.default[type].name(typeSize) + ' (' + typeSize + ')',
								component: stationList,
								lightMode: true,
								picture: _SiteTypes2.default[type].icon,
								id: idType,
								isChecked: isChecked
							};
						});
						var result = {
							title: theme.label + ' (' + (0, _lodash.sumBy)(siteTypes, function (a) {
								return a.component.length;
							}) + ')',
							component: _react2.default.createElement(_ListComponent2.default, { tables: siteTypes, generalFunction: _this.resetAllTypeFunction }),
							picture: theme.value.pic,
							color: color
						};
						entities.push(result);
					}
				});
				return _react2.default.createElement(_ListComponent2.default, { tables: entities });
			};
	
			_this.onHoverFunction = _this.onHoverFunction.bind(_this);
			return _this;
		}
	
		_createClass(StationTabPanel, [{
			key: 'onHoverFunction',
			value: function onHoverFunction(data) {
				if (this.props.onHover) {
					if (data) {
						_AppStore2.default.dispatch(_SitesAction2.default.setCoordinatesHover({
							id: data.id,
							type: data.typeParameter
						}));
					}
				}
			}
		}, {
			key: 'getSurfaceQualitometerDescriptions',
			value: function getSurfaceQualitometerDescriptions(station) {
				var _this2 = this;
	
				var keyFigures = station.keyFigures;
				if (keyFigures && keyFigures.length) {
					var sumAnalysis = (0, _lodash.sumBy)(keyFigures, 'nbAnalysis');
					var sortKeyFigures = (0, _lodash.orderBy)(keyFigures, ['endDate'], ['desc']);
					return _react2.default.createElement(
						'div',
						{ className: 'row no-margin', onMouseLeave: function onMouseLeave() {
								return _this2.onHoverFunction({});
							},
							onMouseEnter: function onMouseEnter() {
								return _this2.onHoverFunction(station);
							} },
						this.getTitle(station),
						_react2.default.createElement(
							'div',
							{ className: 'row no-margin left' },
							_react2.default.createElement(
								'div',
								{ className: 'col s12 no-padding' },
								this.getInfoComponent(sumAnalysis, sortKeyFigures.endDate, _simpleReactI18n2.default.lowerAnalysis, _simpleReactI18n2.default.lowerAnalyses)
							)
						)
					);
				}
				return this.getDefaultDescription(station);
			}
		}, {
			key: 'getCheckStation',
			value: function getCheckStation(idStation) {
				if (this.props.selectedStations.length) {
					var result = (0, _lodash.find)(this.props.selectedStations, function (o) {
						return o.id === idStation;
					});
					return !!result;
				}
				return false;
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.props.stations.length > 0) {
					return _react2.default.createElement(
						'div',
						{ className: 'row no-margin' },
						_react2.default.createElement(
							_ExpansionPanel2.default,
							null,
							_react2.default.createElement(
								_ExpansionPanelSummary2.default,
								{
									expandIcon: _react2.default.createElement(_ExpandMore2.default, null),
									'aria-controls': 'hydrologicalPanel-content',
									id: 'hydrologicalPanel-header'
								},
								_react2.default.createElement(
									_Typography2.default,
									null,
									_simpleReactI18n2.default.selectByHydrologicArea
								)
							),
							_react2.default.createElement(
								_ExpansionPanelDetails2.default,
								{ className: 'no-padding no-margin' },
								this.getWatershedTabs()
							)
						),
						_react2.default.createElement(
							_ExpansionPanel2.default,
							{ defaultExpanded: true },
							_react2.default.createElement(
								_ExpansionPanelSummary2.default,
								{
									expandIcon: _react2.default.createElement(_ExpandMore2.default, null),
									'aria-controls': 'site-content',
									id: 'site-header'
								},
								_react2.default.createElement(
									_Typography2.default,
									null,
									_simpleReactI18n2.default.selectByPointType
								)
							),
							_react2.default.createElement(
								_ExpansionPanelDetails2.default,
								{ className: 'no-padding no-margin' },
								this.getTabs()
							)
						)
					);
				}
				return null;
			}
		}]);
	
		return StationTabPanel;
	}(_react.Component);
	
	StationTabPanel.propTypes = {
		stations: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoStation2.default)),
		samplingPoints: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoSamplingPoint2.default)),
		siteTypes: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoSiteType2.default)),
		keyFigures: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoKeyFigures2.default)),
		selectedStations: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoStation2.default)),
		selectedSelection: _propTypes2.default.instanceOf(_DtoSelectionRow2.default),
		selectedThemes: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			label: _propTypes2.default.string,
			value: _propTypes2.default.instanceOf(_ThemeDto2.default)
		})),
		themes: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_ThemeDto2.default)),
		indicatorTypes: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoIndicatorType2.default)),
		indicators: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoIndicator2.default)),
		cityIndicators: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoCityIndicator2.default)),
		cityInformations: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoCityInformation2.default)),
		watershedSelected: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoWatershed2.default)),
		watershedLayers: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoLayer2.default)),
		userSite: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			id: _propTypes2.default.number
		})),
		onHover: _propTypes2.default.bool
	};
	
	StationTabPanel.defaultProps = {
		entities: [],
		onHover: false
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			siteTypes: store.ReferentialReducer.siteTypes,
			indicatorTypes: store.ReferentialReducer.indicatorTypes,
			indicators: store.ReferentialReducer.indicators,
			userSite: store.DashboardReducer.userSite,
			stations: store.SitesReducer.stations,
			keyFigures: store.SitesReducer.keyFigures,
			samplingPoints: store.SitesReducer.samplingPoints,
			selectedStations: store.SitesReducer.selectedStations,
			selectedSelection: store.SitesReducer.selectedSelection,
			selectedThemes: store.AdministrationReducer.selectedThemes,
			themes: store.AdministrationReducer.themes,
			cityIndicators: store.SitesReducer.cityIndicators,
			watershedSelected: store.SitesReducer.watershedSelected,
			watershedLayers: store.SitesReducer.watershedLayers,
			cityInformations: store.SitesReducer.cityInformations
		};
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(StationTabPanel);

/***/ },
/* 2177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _ThemeDto = __webpack_require__(129);
	
	var _ThemeDto2 = _interopRequireDefault(_ThemeDto);
	
	var _AdministrationAction = __webpack_require__(61);
	
	var _AdministrationAction2 = _interopRequireDefault(_AdministrationAction);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _CheckPanel = __webpack_require__(1022);
	
	var _CheckPanel2 = _interopRequireDefault(_CheckPanel);
	
	var _ThemesUtils = __webpack_require__(384);
	
	var _ListComponent = __webpack_require__(528);
	
	var _ListComponent2 = _interopRequireDefault(_ListComponent);
	
	var _DtoStation = __webpack_require__(88);
	
	var _DtoStation2 = _interopRequireDefault(_DtoStation);
	
	var _lodash = __webpack_require__(15);
	
	var _SitesAction = __webpack_require__(97);
	
	var _SitesAction2 = _interopRequireDefault(_SitesAction);
	
	var _ToastrAction = __webpack_require__(66);
	
	var _ToastrAction2 = _interopRequireDefault(_ToastrAction);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ThemesTabPanel = function (_Component) {
		_inherits(ThemesTabPanel, _Component);
	
		function ThemesTabPanel() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, ThemesTabPanel);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ThemesTabPanel.__proto__ || Object.getPrototypeOf(ThemesTabPanel)).call.apply(_ref, [this].concat(args))), _this), _this.toggleFamily = function (id) {
				var finalSelectedThemes = function () {
					var family = _this.props.themes.find(function (f) {
						return f.id === id;
					});
					var selectedThemes = _this.props.selectedThemes.slice();
	
					var isSelected = !!selectedThemes.find(function (t) {
						return t.value.masterTheme === id;
					});
					if (isSelected) {
						return selectedThemes.filter(function (t) {
							return t.value.masterTheme !== id;
						});
					}
					return selectedThemes.concat(family.themes.filter(function (t) {
						return !t.disable;
					}).map(function (t) {
						return {
							label: t.title,
							value: Object.assign({}, t)
						};
					}));
				}();
				if (!finalSelectedThemes.length) {
					_AppStore2.default.dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.error.pleaseFillLeastTheme));
				} else {
					_AppStore2.default.dispatch(_AdministrationAction2.default.selectedThemes(finalSelectedThemes));
					if (_this.props.selectedStations.length) {
						var siteTypes = (0, _lodash.uniq)((0, _lodash.flatten)(finalSelectedThemes.map(function (th) {
							return th.value.siteTypes.map(function (t) {
								return t.type;
							});
						})));
						var resultStations = (0, _lodash.flatten)(siteTypes.map(function (o) {
							return (0, _lodash.filter)(_this.props.stations, function (b) {
								return b.typeParameter == o;
							});
						}));
						_AppStore2.default.dispatch(_SitesAction2.default.setSelectedStations(resultStations));
					}
				}
			}, _this.toggleTheme = function (theme) {
				return function () {
					var finalSelectedThemes = function () {
						var selectedThemes = _this.props.selectedThemes.slice();
						var isSelected = !!selectedThemes.find(function (t) {
							return t.value.id === theme.id;
						});
						if (isSelected) {
							return selectedThemes.filter(function (t) {
								return t.value.id !== theme.id;
							});
						}
						return selectedThemes.concat([{
							label: theme.title,
							value: Object.assign({}, theme)
						}]);
					}();
					if (!finalSelectedThemes.length) {
						_AppStore2.default.dispatch(_ToastrAction2.default.error(_simpleReactI18n2.default.error.pleaseFillLeastTheme));
					} else {
						if (_this.props.selectedStations.length) {
							var siteTypes = (0, _lodash.uniq)((0, _lodash.flatten)(finalSelectedThemes.map(function (th) {
								return th.value.siteTypes.map(function (t) {
									return t.type;
								});
							})));
							var resultStations = (0, _lodash.flatten)(siteTypes.map(function (o) {
								return (0, _lodash.filter)(_this.props.stations, function (b) {
									return b.typeParameter == o;
								});
							}));
							_AppStore2.default.dispatch(_SitesAction2.default.setSelectedStations(resultStations));
						}
						_AppStore2.default.dispatch(_AdministrationAction2.default.selectedThemes(finalSelectedThemes));
					}
				};
			}, _this.getCheckPanel = function (t) {
				var checked = !!_this.props.selectedThemes.find(function (st) {
					return st.value.id === t.id;
				});
				var f = _this.props.themes.find(function (o) {
					return o.id === t.masterTheme;
				});
				return _react2.default.createElement(
					_CheckPanel2.default,
					{ key: t.id, onToggleCheck: _this.toggleTheme(t, f.id),
						backgroundColor: function backgroundColor() {
							return (0, _ThemesUtils.getColor)(_this.props.themes, t, 1);
						}, checked: checked,
						className: 'theme-row' },
					_this.getPanel(t, 'no-padding')
				);
			}, _this.getPanel = function (t) {
				var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'theme-row';
	
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin' },
					_react2.default.createElement(
						'div',
						{ className: 'col s12 ' + className },
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'div',
								{ className: 'col s2 no-padding' },
								_react2.default.createElement(
									'div',
									{ className: 'iconeTypeResearchWrapper' },
									_react2.default.createElement('img', { className: 'iconeTypeResearch circle responsive-img', src: t.pic })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'col s10 no-padding site-type-title' },
								_react2.default.createElement(
									'b',
									null,
									t.title
								)
							)
						)
					)
				);
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(ThemesTabPanel, [{
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps) {
				return !(0, _lodash.isEqual)(this.props.themes, nextProps.themes) || !(0, _lodash.isEqual)(this.props.selectedThemes, nextProps.selectedThemes) || !(0, _lodash.isEqual)(this.props.selectedStations, nextProps.selectedStations) || !(0, _lodash.isEqual)(this.props.stations, nextProps.stations);
			}
		}, {
			key: 'getContent',
			value: function getContent() {
				var _this2 = this;
	
				var entities = this.props.themes.reduce(function (a, f) {
					var themes = f.themes.filter(function (t) {
						return !t.disable;
					}).map(function (t) {
						return _this2.getCheckPanel(t);
					});
					if (themes && themes.length) {
						var isChecked = !!_this2.props.selectedThemes.filter(function (t) {
							return t.value.masterTheme === f.id;
						}).length;
						a.push({
							title: f.title,
							component: themes,
							picture: f.image,
							id: f.id,
							isChecked: isChecked,
							color: 'rgb(' + f.color + ')'
						});
					}
					return a;
				}, []);
				return _react2.default.createElement(_ListComponent2.default, { tables: entities, generalFunction: this.toggleFamily });
			}
		}, {
			key: 'render',
			value: function render() {
				return this.getContent();
			}
		}]);
	
		return ThemesTabPanel;
	}(_react.Component);
	
	ThemesTabPanel.propTypes = {
		selectedThemes: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			label: _propTypes2.default.string,
			value: _propTypes2.default.instanceOf(_ThemeDto2.default)
		})),
		themes: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_ThemeDto2.default)),
		selectedStations: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoStation2.default)),
		stations: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoStation2.default))
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			selectedThemes: store.AdministrationReducer.selectedThemes,
			themes: store.AdministrationReducer.themes,
			selectedStations: store.SitesReducer.selectedStations,
			stations: store.SitesReducer.stations
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ThemesTabPanel);

/***/ },
/* 2178 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.beginDate = obj.beginDate;
		this.endDate = obj.endDate;
		this.nbMeasure = obj.nbMeasure || 0;
		this.nbDebits = obj.nbDebits || 0;
		this.nbHeight = obj.nbHeight || 0;
		this.nbAnalysis = obj.nbAnalysis || 0;
		this.typeId = obj.typeId;
		this.stationId = obj.stationId;
		this.samplingId = obj.samplingId;
		this.samplingCode = obj.samplingPoint ? obj.samplingPoint.code || '' : '';
	};
	
	exports.default = _class;

/***/ },
/* 2179 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(x, y, radius) {
		_classCallCheck(this, _class);
	
		this.longi = x;
		this.lati = y;
		this.radius = radius;
	};
	
	exports.default = _class;

/***/ },
/* 2180 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.type = obj.type;
		this.icon = obj.icon;
		this.comment = obj.comment;
		this.inDevelop = obj.inDevelop;
		this.title = obj.title;
	};
	
	exports.default = _class;

/***/ },
/* 2181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DtoKeyFiguresRow = __webpack_require__(2178);
	
	var _DtoKeyFiguresRow2 = _interopRequireDefault(_DtoKeyFiguresRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
	  _classCallCheck(this, _class);
	
	  this.id = obj.id;
	  this.code = obj.code;
	  this.keyFigure = obj.keyFigure ? new _DtoKeyFiguresRow2.default(obj.keyFigure) : undefined;
	  this.typeId = obj.typeId;
	  this.typeParameter = obj.typeParameter;
	  this.name = obj.name;
	  this.xCoordinate = obj.xCoordinate;
	  this.yCoordinate = obj.yCoordinate;
	  this.keyFigures = obj.keyFigures ? obj.keyFigures.map(function (o) {
	    return new _DtoKeyFiguresRow2.default(o);
	  }) : [];
	};
	
	exports.default = _class;

/***/ },
/* 2182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.store = undefined;
	exports.SitesReducer = SitesReducer;
	
	var _SitesConstants = __webpack_require__(226);
	
	var _DtoStation = __webpack_require__(88);
	
	var _DtoStation2 = _interopRequireDefault(_DtoStation);
	
	var _unionWith = __webpack_require__(1914);
	
	var _unionWith2 = _interopRequireDefault(_unionWith);
	
	var _DtoKeyFigures = __webpack_require__(98);
	
	var _DtoKeyFigures2 = _interopRequireDefault(_DtoKeyFigures);
	
	var _DtoWatershed = __webpack_require__(539);
	
	var _DtoWatershed2 = _interopRequireDefault(_DtoWatershed);
	
	var _DtoSamplingPoint = __webpack_require__(1045);
	
	var _DtoSamplingPoint2 = _interopRequireDefault(_DtoSamplingPoint);
	
	var _DtoLayer = __webpack_require__(372);
	
	var _DtoLayer2 = _interopRequireDefault(_DtoLayer);
	
	var _MapStyles = __webpack_require__(546);
	
	var _MapStyles2 = _interopRequireDefault(_MapStyles);
	
	var _ApplicationConf = __webpack_require__(65);
	
	var _ApplicationConf2 = _interopRequireDefault(_ApplicationConf);
	
	var _DtoCityIndicator = __webpack_require__(1043);
	
	var _DtoCityIndicator2 = _interopRequireDefault(_DtoCityIndicator);
	
	var _DtoCityInformation = __webpack_require__(1044);
	
	var _DtoCityInformation2 = _interopRequireDefault(_DtoCityInformation);
	
	var _DtoResearchType = __webpack_require__(2180);
	
	var _DtoResearchType2 = _interopRequireDefault(_DtoResearchType);
	
	var _HoverDto = __webpack_require__(1046);
	
	var _HoverDto2 = _interopRequireDefault(_HoverDto);
	
	var _lodash = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var store = exports.store = {
		stations: [],
		selectedStations: [],
		visualisation: _SitesConstants.PANEL_CITY,
		selectedValue: '',
		oldValue: '',
		radius: '',
		selectedTypes: [],
		coordinates: {},
		hover: new _HoverDto2.default(),
		keyFigures: [],
		watershedSelected: [],
		watershedLayers: [],
		citiesLayers: [],
		departmentsLayers: [],
		samplingPoints: [],
		cityIndicators: [],
		cityInformations: [],
		researchTypes: [],
		managementWaterLayers: []
	};
	
	function SitesReducer() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		var action = arguments[1];
	
		switch (action.type) {
			case _SitesConstants.ADD_STATIONS:
				{
					/*const stations = uniqWith([].concat(action.stations.map(el => new DtoStation(el)), state.stations), (a, b) => {
	    	return a.id === b.id && a.typeId === b.typeId
	    })*/
					var stations = [].concat(action.stations.map(function (el) {
						return new _DtoStation2.default(el);
					}), state.stations);
	
					var selectedStations = action.selection && action.selection.stations ? action.selection.stations.map(function (s) {
						return stations.find(function (o) {
							return o.id === s.siteId;
						});
					}).filter(function (o) {
						return o;
					}) : stations;
					return Object.assign({}, state, {
						stations: stations,
						selectedStations: selectedStations,
						coordinates: {}
					});
				}
			case _SitesConstants.PUT_STATIONS:
				{
					var _stations = (0, _unionWith2.default)([].concat(action.stations, state.stations), function (a, b) {
						return a.id === b.id && a.typeId == b.typeId;
					});
					var _selectedStations = action.selection && action.selection.stations ? action.selection.stations.map(function (s) {
						return _stations.find(function (o) {
							return o.id === s.siteId;
						});
					}).filter(function (o) {
						return o;
					}) : _stations;
					return Object.assign({}, state, {
						stations: _stations,
						selectedStations: _selectedStations
					});
				}
			case _SitesConstants.SELECTED_STATIONS:
				{
					return Object.assign({}, state, {
						selectedStations: action.selectedStations,
						coordinates: {}
					});
				}
			case _SitesConstants.SET_OLD_VALUE:
				{
					return Object.assign({}, state, {
						oldValue: action.oldValue
					});
				}
			case _SitesConstants.SET_SELECTED_VALUE:
				{
					return Object.assign({}, state, {
						selectedValue: action.selectedValue
					});
				}
			case _SitesConstants.SET_RADIUS:
				{
					return Object.assign({}, state, {
						radius: action.radius
					});
				}
			case _SitesConstants.SET_VISUALISATION:
				{
					return Object.assign({}, state, {
						visualisation: action.visualisation
					});
				}
			case _SitesConstants.SELECTED_TYPES:
				{
					return Object.assign({}, state, {
						selectedTypes: action.selectedTypes
					});
				}
			case _SitesConstants.WATERSHED_LAYERS:
				{
					return Object.assign({}, state, {
						watershedLayers: (0, _unionWith2.default)([].concat(action.watershedLayers.map(function (el) {
							return new _DtoLayer2.default(el, 'KML', _MapStyles2.default.FILL_BLUE);
						}), state.watershedLayers), function (a, b) {
							return a.id === b.id;
						})
					});
				}
			case _SitesConstants.UPDATE_WATERSHED_LAYERS:
				{
					return Object.assign({}, state, {
						watershedLayers: action.watershedLayers
					});
				}
			case _SitesConstants.MANAGEMENT_WATER_LAYERS:
				{
					return Object.assign({}, state, {
						managementWaterLayers: (0, _unionWith2.default)([].concat(action.managementWaterLayers.map(function (el) {
							return new _DtoLayer2.default(el, 'KML', _MapStyles2.default.FILL_BLACK);
						}), state.managementWaterLayers), function (a, b) {
							return a.id === b.id;
						})
					});
				}
			case _SitesConstants.UPDATE_MANAGEMENT_WATER_LAYERS:
				{
					return Object.assign({}, state, {
						managementWaterLayers: action.managementWaterLayers
					});
				}
			case _SitesConstants.CITIES_LAYERS:
				{
					return Object.assign({}, state, {
						citiesLayers: (0, _lodash.uniqBy)([].concat(action.citiesLayers.map(function (el) {
							return new _DtoLayer2.default(el, 'KML', _MapStyles2.default.FILL_RED);
						}), state.citiesLayers), 'id')
					});
				}
			case _SitesConstants.DEPARTMENTS_LAYERS:
				{
					return Object.assign({}, state, {
						departmentsLayers: (0, _lodash.uniqBy)([].concat(action.departmentsLayers.map(function (el) {
							return new _DtoLayer2.default(el, 'KML', _MapStyles2.default.FILL_RED);
						}), state.departmentsLayers), 'id')
					});
				}
			case _SitesConstants.UPDATE_CITIES_LAYERS:
				{
					return Object.assign({}, state, {
						citiesLayers: (0, _lodash.uniqBy)([].concat(action.citiesLayers, state.citiesLayers), 'id')
					});
				}
			case _SitesConstants.RECEIVE_KEY_FIGURES:
				{
					return Object.assign({}, state, {
						keyFigures: (0, _unionWith2.default)([].concat(action.keyFigures.map(function (el) {
							return new _DtoKeyFigures2.default(el);
						}), state.keyFigures), function (a, b) {
							return a.id === b.id && a.typeId === b.typeId;
						})
					});
				}
			case _SitesConstants.RECEIVE_KEY_FIGURES_SAMPLING_POINTS:
				{
					return Object.assign({}, state, {
						samplingPoints: action.samplingPoints.map(function (el) {
							return new _DtoSamplingPoint2.default(el);
						})
					});
				}
	
			case _SitesConstants.RECEIVE_WATERSHED_SELECTED:
				{
					var watershed = (0, _unionWith2.default)([].concat(action.watershedSelected.map(function (el) {
						return new _DtoWatershed2.default(el);
					}), state.watershedSelected), function (a, b) {
						return a.code === b.code;
					});
					var watershedLayers = (0, _unionWith2.default)([].concat(watershed.map(function (el) {
						return new _DtoLayer2.default(Object.assign({}, el, {
							url: _ApplicationConf2.default.layer.whatershedLayer(el.code)
						}), 'KML', _MapStyles2.default.FILL_BLUE);
					}), state.watershedLayers), function (a, b) {
						return a.id === b.id;
					});
					return Object.assign({}, state, {
						watershedSelected: watershed,
						watershedLayers: watershedLayers
					});
				}
			case _SitesConstants.RECEIVE_CITY_INDICATORS:
				{
					return Object.assign({}, state, {
						cityIndicators: (0, _unionWith2.default)([].concat(action.cityIndicators.map(function (el) {
							return new _DtoCityIndicator2.default(el);
						}), state.cityIndicators), function (a, b) {
							return a.id == b.id;
						})
					});
				}
			case _SitesConstants.RECEIVE_CITY_INFORMATIONS:
				{
					return Object.assign({}, state, {
						cityInformations: (0, _unionWith2.default)([].concat(action.cityInformations.map(function (el) {
							return new _DtoCityInformation2.default(el);
						}), state.cityInformations), function (a, b) {
							return a.code == b.code;
						})
					});
				}
			case _SitesConstants.RECEIVE_RESEARCH_TYPE:
				{
					return Object.assign({}, state, {
						researchTypes: action.researchTypes.map(function (el) {
							return new _DtoResearchType2.default(el);
						})
					});
				}
			case _SitesConstants.SET_HOVER:
				{
					return Object.assign({}, state, {
						hover: new _HoverDto2.default(action.hover)
					});
				}
			case _SitesConstants.RESET_RESEARCH:
				{
					return Object.assign({}, state, store);
				}
			case _SitesConstants.RESET_STATIONS:
				{
					return Object.assign({}, state, {
						stations: [],
						selectedStations: []
					});
				}
			default:
				return state;
		}
	}

/***/ },
/* 2183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _QualitometerPanel = __webpack_require__(2197);
	
	var _QualitometerPanel2 = _interopRequireDefault(_QualitometerPanel);
	
	var _DtoDetailStation = __webpack_require__(227);
	
	var _DtoDetailStation2 = _interopRequireDefault(_DtoDetailStation);
	
	var _DtoDetailStationNetwork = __webpack_require__(543);
	
	var _DtoDetailStationNetwork2 = _interopRequireDefault(_DtoDetailStationNetwork);
	
	var _PiezometerPanel = __webpack_require__(2192);
	
	var _PiezometerPanel2 = _interopRequireDefault(_PiezometerPanel);
	
	var _DtoDetailPiezometerMeasure = __webpack_require__(185);
	
	var _DtoDetailPiezometerMeasure2 = _interopRequireDefault(_DtoDetailPiezometerMeasure);
	
	var _DtoPiezometerMeasure = __webpack_require__(1025);
	
	var _DtoPiezometerMeasure2 = _interopRequireDefault(_DtoPiezometerMeasure);
	
	var _DtoDetailStationSamplingSurfacePoint = __webpack_require__(286);
	
	var _DtoDetailStationSamplingSurfacePoint2 = _interopRequireDefault(_DtoDetailStationSamplingSurfacePoint);
	
	var _DtoPickupOperation = __webpack_require__(287);
	
	var _DtoPickupOperation2 = _interopRequireDefault(_DtoPickupOperation);
	
	var _DtoAnalysis = __webpack_require__(184);
	
	var _DtoAnalysis2 = _interopRequireDefault(_DtoAnalysis);
	
	var _DetailStationAction = __webpack_require__(540);
	
	var _DetailStationAction2 = _interopRequireDefault(_DetailStationAction);
	
	var _HomeAction = __webpack_require__(52);
	
	var _HomeAction2 = _interopRequireDefault(_HomeAction);
	
	var _DescriptionStationPanel = __webpack_require__(2184);
	
	var _DescriptionStationPanel2 = _interopRequireDefault(_DescriptionStationPanel);
	
	var _NetworkPanel = __webpack_require__(2188);
	
	var _NetworkPanel2 = _interopRequireDefault(_NetworkPanel);
	
	var _MapDetailStationPanel = __webpack_require__(541);
	
	var _MapDetailStationPanel2 = _interopRequireDefault(_MapDetailStationPanel);
	
	var _SamplingSurfacePointPanel = __webpack_require__(2198);
	
	var _SamplingSurfacePointPanel2 = _interopRequireDefault(_SamplingSurfacePointPanel);
	
	var _SiteTypes = __webpack_require__(56);
	
	var _SiteTypes2 = _interopRequireDefault(_SiteTypes);
	
	var _IndustrialSitePanel = __webpack_require__(2187);
	
	var _IndustrialSitePanel2 = _interopRequireDefault(_IndustrialSitePanel);
	
	var _PollutedSoilPanel = __webpack_require__(2193);
	
	var _PollutedSoilPanel2 = _interopRequireDefault(_PollutedSoilPanel);
	
	var _ConfirmationModal = __webpack_require__(2108);
	
	var _ConfirmationModal2 = _interopRequireDefault(_ConfirmationModal);
	
	var _uuid = __webpack_require__(44);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _DashboardAction = __webpack_require__(2116);
	
	var _DashboardAction2 = _interopRequireDefault(_DashboardAction);
	
	var _DetailStationConstants = __webpack_require__(542);
	
	var _DtoCity = __webpack_require__(87);
	
	var _DtoCity2 = _interopRequireDefault(_DtoCity);
	
	var _ReferentialAction = __webpack_require__(380);
	
	var _ReferentialAction2 = _interopRequireDefault(_ReferentialAction);
	
	var _DevelopmentUtil = __webpack_require__(2207);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = window.$;
	
	var DetailStationApp = function (_Component) {
		_inherits(DetailStationApp, _Component);
	
		function DetailStationApp(props) {
			_classCallCheck(this, DetailStationApp);
	
			var _this = _possibleConstructorReturn(this, (DetailStationApp.__proto__ || Object.getPrototypeOf(DetailStationApp)).call(this, props));
	
			_this.getSamplingSurfacePointPanel = function () {
				if (_this.props.samplingSurfacePoints.length > 0) {
					return _react2.default.createElement(_SamplingSurfacePointPanel2.default, null);
				}
				return null;
			};
	
			_this.getPiezometerPanel = function () {
				if (_this.props.piezometerMeasures.length > 0) {
					return _react2.default.createElement(_PiezometerPanel2.default, { id: _this.props.params.id });
				}
				return null;
			};
	
			_this.getQualitometerPanel = function () {
				if (_this.props.analysis.length > 0) {
					return _react2.default.createElement(_QualitometerPanel2.default, { id: _this.props.params.id });
				}
				return null;
			};
	
			_this.getNetworkPanel = function () {
				if (_this.props.networks.length > 0) {
					return _react2.default.createElement(_NetworkPanel2.default, { networks: _this.props.networks });
				}
				return null;
			};
	
			_this.onChange = function (id) {
				$('#' + id).animatescroll({ scrollSpeed: 500 });
			};
	
			_this.change = function (value) {
				_this.setState({
					visualisation: value
				});
			};
	
			_this.exportStation = function () {
				_AppStore2.default.dispatch(_DetailStationAction2.default.exportStation(_this.props.params.id));
			};
	
			_this.openModal = function () {
				$('#' + _this.state.id).modal('open');
			};
	
			_this.getContent = function () {
				if (_this.props.station.natureStation && _this.props.station.natureStation[0] == _SiteTypes2.default.INDUSTRIAL_SITE.type) {
					return _react2.default.createElement(
						'div',
						{ className: 'col s12 no-padding' },
						_this.getStationFunction(false, false),
						_react2.default.createElement(
							'div',
							{ className: 'col s12 no-padding' },
							_react2.default.createElement(
								'div',
								{ className: 'row no-margin' },
								_react2.default.createElement(
									'div',
									{ className: 'row no-margin' },
									_react2.default.createElement(
										'div',
										{ className: 'col s12 m12 padding-top-10' },
										_react2.default.createElement(_DescriptionStationPanel2.default, null),
										_react2.default.createElement(_IndustrialSitePanel2.default, { height: _this.state.height })
									)
								)
							)
						)
					);
				} else if (_this.props.station.natureStation && _this.props.station.natureStation[0] == _SiteTypes2.default.POLLUTED_SOIL.type) {
					return _react2.default.createElement(
						'div',
						{ className: 'col s12 no-padding' },
						_this.getStationFunction(false, false),
						_react2.default.createElement(
							'div',
							{ className: 'col s12 no-padding' },
							_react2.default.createElement(
								'div',
								{ className: 'row no-margin' },
								_react2.default.createElement(
									'div',
									{ className: 'row no-margin' },
									_react2.default.createElement(
										'div',
										{ className: 'col s12 m12 padding-top-10' },
										_react2.default.createElement(_DescriptionStationPanel2.default, null),
										_react2.default.createElement(_PollutedSoilPanel2.default, { height: _this.state.height })
									)
								)
							)
						)
					);
				}
				if (_this.state.visualisation === _DetailStationConstants.PANEL_DETAIL) {
					var divStyle = {
						maxHeight: _this.state.height,
						overflowX: 'none',
						overflowY: 'auto'
					};
					return _react2.default.createElement(
						'div',
						{ className: 'col s12 no-padding' },
						_this.getStationFunction(),
						_react2.default.createElement(
							'div',
							{ className: 'col s12 no-padding' },
							_react2.default.createElement(
								'div',
								{ className: 'row no-margin' },
								_react2.default.createElement(
									'div',
									{ className: 'col s4', style: divStyle },
									_react2.default.createElement(_DescriptionStationPanel2.default, { detail: true }),
									_this.getNetworkPanel(),
									_this.getSamplingSurfacePointPanel()
								),
								_react2.default.createElement(
									'div',
									{ className: 'col s8 no-padding' },
									_react2.default.createElement(_MapDetailStationPanel2.default, { height: _this.state.height })
								)
							)
						)
					);
				}
				var piezoQualito = function () {
					var panelPiezo = _this.getPiezometerPanel();
					var panelQualito = _this.getQualitometerPanel();
					if (panelPiezo) {
						if (panelQualito) {
							return _react2.default.createElement(
								'div',
								null,
								panelPiezo,
								' ',
								panelQualito
							);
						}
						return _react2.default.createElement(
							'div',
							null,
							panelPiezo
						);
					}
					if (panelQualito) {
						return _react2.default.createElement(
							'div',
							null,
							panelQualito
						);
					}
					return _react2.default.createElement(
						'div',
						{ className: 'row valign-wrapper inDevelop', style: { minHeight: 'calc(90% - 64px)', paddingBottom: '0px' } },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col s12 m12 l12' },
								(0, _DevelopmentUtil.getDevelopmentPanel)(true)
							)
						)
					);
				}();
				return _react2.default.createElement(
					'div',
					{ className: 'col s12 no-padding' },
					_this.getStationFunction(),
					_react2.default.createElement(
						'div',
						{ className: 'col s12 no-padding' },
						_react2.default.createElement(
							'div',
							{ className: 'row no-margin' },
							_react2.default.createElement(
								'div',
								{ className: 'row no-margin' },
								_react2.default.createElement(
									'div',
									{ className: 'col s12 m12 padding-top-10' },
									_react2.default.createElement(_DescriptionStationPanel2.default, null)
								)
							),
							piezoQualito,
							_react2.default.createElement(
								'a',
								{ onClick: function onClick() {
										return _this.onChange('app');
									}, id: 'back-to-top' },
								_react2.default.createElement('span', null)
							)
						)
					)
				);
			};
	
			_this.getStationFunction = function () {
				var detail = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
				var active = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
				var exportButton = function () {
					if (!active) {
						return _react2.default.createElement(
							'a',
							{ className: 'btn secondary-color white-text', onClick: function onClick() {
									return _this.exportStation();
								}, disabled: true },
							_simpleReactI18n2.default.exportFunction
						);
					}
					return _react2.default.createElement(
						'a',
						{ className: 'btn secondary-color white-text', onClick: function onClick() {
								return _this.exportStation();
							} },
						_simpleReactI18n2.default.exportFunction
					);
				}();
	
				var deleteButton = _react2.default.createElement(
					'a',
					{ className: 'btn red', onClick: function onClick() {
							return _this.openModal();
						} },
					_simpleReactI18n2.default.deleteFunction
				);
				if (detail) {
					return _react2.default.createElement(
						'div',
						{ className: 'fixed-action-btn horizontal station-function', id: 'station-function' },
						_react2.default.createElement(
							'a',
							{ className: 'btn-floating btn-large red right ' },
							_react2.default.createElement(
								'i',
								{ className: 'material-icons' },
								'info'
							)
						),
						_react2.default.createElement(
							'ul',
							null,
							_react2.default.createElement(
								'div',
								{ className: 'row text-center toolbar-function margin-right-0' },
								_react2.default.createElement(
									'div',
									{ className: 'col s12 padding-top-10 ' },
									_react2.default.createElement(
										'div',
										{ className: 'row' },
										_react2.default.createElement(
											'a',
											{ className: 'btn  secondary-color white-text',
												onClick: function onClick() {
													return _this.change(_DetailStationConstants.PANEL_DASHBOARD);
												} },
											_simpleReactI18n2.default.graphicView
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'row' },
										_react2.default.createElement(
											'a',
											{ className: 'btn  secondary-color white-text',
												onClick: function onClick() {
													return _this.change(_DetailStationConstants.PANEL_DETAIL);
												} },
											_simpleReactI18n2.default.cartographicView
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'row' },
										exportButton
									),
									_react2.default.createElement(
										'div',
										{ className: 'row' },
										deleteButton
									)
								)
							)
						)
					);
				}
	
				return _react2.default.createElement(
					'div',
					{ className: 'fixed-action-btn horizontal station-function', id: 'station-function' },
					_react2.default.createElement(
						'a',
						{ className: 'btn-floating btn-large red right ' },
						_react2.default.createElement(
							'i',
							{ className: 'material-icons' },
							'info'
						)
					),
					_react2.default.createElement(
						'ul',
						null,
						_react2.default.createElement(
							'div',
							{ className: 'row text-center toolbar-function margin-right-0' },
							_react2.default.createElement(
								'div',
								{ className: 'col s12 padding-top-10 ' },
								_react2.default.createElement(
									'div',
									{ className: 'row' },
									exportButton
								),
								_react2.default.createElement(
									'div',
									{ className: 'row' },
									deleteButton
								)
							)
						)
					)
				);
			};
	
			_this.state = {
				height: 250,
				visualisation: _DetailStationConstants.PANEL_DASHBOARD,
				id: _uuid2.default.v4()
			};
			return _this;
		}
	
		_createClass(DetailStationApp, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				_AppStore2.default.dispatch(_DetailStationAction2.default.fetchDetailSation(this.props.params.id));
				if (this.props.cities.length === 0) {
					_AppStore2.default.dispatch(_ReferentialAction2.default.fetchCities());
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				_AppStore2.default.dispatch(_DetailStationAction2.default.reset());
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.onChange('app');
				var scrollTrigger = 200; // px
				var backToTop = function backToTop() {
					var scrollTop = $(window).scrollTop();
					if (scrollTop > scrollTrigger) {
						$('#back-to-top').addClass('show');
					} else {
						$('#back-to-top').removeClass('show');
					}
				};
				backToTop();
				$(window).on('scroll', function () {
					backToTop();
				});
				this.setState({
					height: document.documentElement.clientHeight - 64
				});
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextprops) {
				var title = function () {
					if (nextprops.station && nextprops.station.site) {
						if (nextprops.station.site.name && nextprops.station.code) {
							return nextprops.station.site.name + ' (' + nextprops.station.code + ')';
						}
						return _simpleReactI18n2.default.stationForm;
					}
					return _simpleReactI18n2.default.stationForm;
				}();
				_AppStore2.default.dispatch(_HomeAction2.default.setTitle(title));
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin' },
					this.getContent(),
					_react2.default.createElement(_ConfirmationModal2.default, { id: this.state.id, content: '',
						title: 'Suppression du site ' + this.props.station.code, store: _AppStore2.default,
						actionOnValid: _DashboardAction2.default.deleteSites,
						values: [this.props.params.id] })
				);
			}
		}]);
	
		return DetailStationApp;
	}(_react.Component);
	
	DetailStationApp.propTypes = {
		params: _propTypes2.default.shape({
			id: _propTypes2.default.string
		}),
		station: _propTypes2.default.objectOf(_DtoDetailStation2.default),
		networks: _propTypes2.default.arrayOf(_DtoDetailStationNetwork2.default),
		piezometerMeasuresMax: _propTypes2.default.arrayOf(_DtoDetailPiezometerMeasure2.default),
		piezometerMeasuresMin: _propTypes2.default.arrayOf(_DtoDetailPiezometerMeasure2.default),
		piezometerMeasuresMoyenne: _propTypes2.default.arrayOf(_DtoDetailPiezometerMeasure2.default),
		piezometerMeasures: _propTypes2.default.arrayOf(_DtoPiezometerMeasure2.default),
		samplingSurfacePoints: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoDetailStationSamplingSurfacePoint2.default)),
		pickupOperations: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoPickupOperation2.default)),
		analysis: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoAnalysis2.default)),
		cities: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoCity2.default))
	};
	var mapStateToProps = function mapStateToProps(store) {
		return {
			station: store.DetailStationReducer.station,
			networks: store.DetailStationReducer.networks,
			piezometerMeasuresMax: store.DetailStationReducer.piezometerMeasuresMax,
			piezometerMeasuresMin: store.DetailStationReducer.piezometerMeasuresMin,
			piezometerMeasuresMoyenne: store.DetailStationReducer.piezometerMeasuresMoyenne,
			piezometerMeasures: store.DetailStationReducer.piezometerMeasures,
			samplingSurfacePoints: store.DetailStationReducer.samplingSurfacePoints,
			pickupOperations: store.DetailStationReducer.pickupOperations,
			analysis: store.DetailStationReducer.analysis,
			cities: store.ReferentialReducer.cities
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(DetailStationApp);

/***/ },
/* 2184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DtoDetailStation = __webpack_require__(227);
	
	var _DtoDetailStation2 = _interopRequireDefault(_DtoDetailStation);
	
	var _DateUtil = __webpack_require__(67);
	
	var _reactRedux = __webpack_require__(18);
	
	var _lodash = __webpack_require__(15);
	
	var _AppStore = __webpack_require__(21);
	
	var _AppStore2 = _interopRequireDefault(_AppStore);
	
	var _DetailStationAction = __webpack_require__(540);
	
	var _DetailStationAction2 = _interopRequireDefault(_DetailStationAction);
	
	var _DtoCity = __webpack_require__(87);
	
	var _DtoCity2 = _interopRequireDefault(_DtoCity);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DescriptionStationPanel = function (_Component) {
		_inherits(DescriptionStationPanel, _Component);
	
		function DescriptionStationPanel() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, DescriptionStationPanel);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DescriptionStationPanel.__proto__ || Object.getPrototypeOf(DescriptionStationPanel)).call.apply(_ref, [this].concat(args))), _this), _this.getAltitude = function () {
				if (_this.props.station.altitude) {
					var title = _simpleReactI18n2.default.altitude;
					var value = _this.props.station.altitude + ' m';
					if (_this.props.detail) {
						return _this.getDetailLine(title, value);
					}
					return _this.getSummaryLine(title, value);
				}
				return null;
			}, _this.getCity = function () {
				if (_this.props.station.site.city) {
					var city = (0, _lodash.find)(_this.props.cities, function (o) {
						return o.id == _this.props.station.site.city;
					});
					if (city) {
						var title = _simpleReactI18n2.default.town;
						var value = city.name + ' [' + city.code + ']';
						if (_this.props.detail) {
							return _this.getDetailLine(title, value);
						}
						return _this.getSummaryLine(title, value);
					}
					return null;
				}
				return null;
			}, _this.getWaterMass = function () {
				if (_this.props.station.waterMass) {
					var title = _simpleReactI18n2.default.watershed;
					var value = _this.props.station.waterMass.code + ' - ' + _this.props.station.waterMass.name;
					if (_this.props.detail) {
						return _this.getDetailLine(title, value);
					}
					return _this.getSummaryLine(title, value);
				}
				return null;
			}, _this.getHydrologicArea = function () {
				if (_this.props.station.hydrologicArea) {
					var title = _simpleReactI18n2.default.hydrographicEntity;
					var value = _this.props.station.hydrologicArea.code + ' - ' + _this.props.station.hydrologicArea.name;
					if (_this.props.detail) {
						return _this.getDetailLine(title, value);
					}
					return _this.getSummaryLine(title, value);
				}
				return null;
			}, _this.getAddressComplement = function () {
				if (_this.props.station.site.address) {
					var result = _this.props.station.site.address.localizationName;
					if (!result) {
						result = _this.props.station.site.address.address;
					}
					if (result) {
						var title = _simpleReactI18n2.default.localization;
						if (_this.props.detail) {
							return _this.getDetailLine(title, result);
						}
						return _this.getSummaryLine(title, result);
					}
					return null;
				}
				return null;
			}, _this.getStationDate = function () {
				var getBeginDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
				var dateBegin = (0, _DateUtil.getDate)(_this.props.station.beginningDate);
				var dateEnd = (0, _DateUtil.getDate)(_this.props.station.endingDate);
				if (_this.props.detail) {
					var end = dateEnd ? dateEnd : _simpleReactI18n2.default.inProgress;
					return _this.getDetailLine(_simpleReactI18n2.default.openingDate + ' - ' + _simpleReactI18n2.default.closingDate, dateBegin + ' - ' + end);
				} else if (getBeginDate) {
					return _this.getSummaryLine(_simpleReactI18n2.default.openingDate, dateBegin);
				}
				return _this.getSummaryLine(_simpleReactI18n2.default.closingDate, dateEnd);
			}, _this.getCoordinate = function () {
				if (_this.props.station.site.localization) {
					var title = _simpleReactI18n2.default.coordinate;
					var coordinate = 'X: ' + _this.props.station.site.localization.xCoordinate + ' - ' + 'Y: ' + _this.props.station.site.localization.yCoordinate;
					if (_this.props.detail) {
						return _this.getDetailLine(title, coordinate);
					}
					return _this.getSummaryLine(title, coordinate);
				}
				return null;
			}, _this.getDetailLine = function (title, value) {
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin' },
					_react2.default.createElement(
						'b',
						null,
						title
					),
					_react2.default.createElement('br', null),
					_react2.default.createElement(
						'span',
						{ className: 'black-text' },
						' ',
						value
					)
				);
			}, _this.getSummaryLine = function (title, value) {
				return _react2.default.createElement(
					'div',
					{ className: 'row blue-title light no-margin' },
					title,
					' :',
					_react2.default.createElement(
						'span',
						{ className: 'light white-text' },
						' ',
						value
					)
				);
			}, _this.synchroniseButton = function () {
				if (_this.props.station.code && _this.props.station.code.indexOf('X') !== -1) {
					// return (<a className='btn' onClick={ this.synchronise }><span>Synchroniser</span></a>)
					return null;
				}
				return null;
			}, _this.synchronise = function () {
				_AppStore2.default.dispatch(_DetailStationAction2.default.synchroniseAdesSites(_this.props.station.id, _this.props.station.code));
			}, _this.getContent = function () {
				if (_this.props.detail) {
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ className: 'row no-margin white-background' },
							_react2.default.createElement(
								'div',
								{ className: 'col s12 m12 l12 no-padding card-title hide-on-med-and-down no-margin' },
								_react2.default.createElement(
									'div',
									{ className: 'row primary-light white-text no-margin' },
									_react2.default.createElement(
										'div',
										{ className: 'col l12' },
										_react2.default.createElement(
											'h5',
											null,
											_simpleReactI18n2.default.description
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'row no-margin white-background' },
							_react2.default.createElement(
								'div',
								{ className: 'col s12' },
								_this.getCity(),
								_this.getAddressComplement(),
								_this.getStationDate(),
								_this.getHydrologicArea(),
								_this.getWaterMass(),
								_this.getAltitude(),
								_this.getCoordinate()
							)
						)
					);
				}
				return _react2.default.createElement(
					'div',
					{ className: 'row blue-card-dark', id: 'descriptionPanel' },
					_react2.default.createElement(
						'div',
						{ className: 'col s8 ' },
						_this.getCity(),
						_this.getStationDate(true),
						_this.getStationDate(false)
					),
					_react2.default.createElement(
						'div',
						{ className: 'col s4 left' },
						_this.synchroniseButton()
					)
				);
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(DescriptionStationPanel, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					this.getContent()
				);
			}
		}]);
	
		return DescriptionStationPanel;
	}(_react.Component);
	
	DescriptionStationPanel.propTypes = {
		station: _propTypes2.default.instanceOf(_DtoDetailStation2.default),
		cities: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoCity2.default)),
		detail: _propTypes2.default.bool
	};
	
	DescriptionStationPanel.defaultProps = {
		detail: false
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			station: store.DetailStationReducer.station,
			cities: store.ReferentialReducer.cities
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(DescriptionStationPanel);

/***/ },
/* 2185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DtoDetailPiezometerMeasure = __webpack_require__(185);
	
	var _DtoDetailPiezometerMeasure2 = _interopRequireDefault(_DtoDetailPiezometerMeasure);
	
	var _lodash = __webpack_require__(15);
	
	var _DateUtil = __webpack_require__(67);
	
	var _reactRedux = __webpack_require__(18);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndicatorPiezometer = function (_Component) {
		_inherits(IndicatorPiezometer, _Component);
	
		function IndicatorPiezometer() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, IndicatorPiezometer);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = IndicatorPiezometer.__proto__ || Object.getPrototypeOf(IndicatorPiezometer)).call.apply(_ref, [this].concat(args))), _this), _this.getEndingDate = function (list) {
				return _this.getDateByMinOrMax(list, _lodash.maxBy);
			}, _this.getBeginningDate = function (list) {
				return _this.getDateByMinOrMax(list, _lodash.minBy);
			}, _this.getDateByMinOrMax = function (list, filter) {
				var result = filter(list, function (o) {
					return o.date;
				});
				if (result) {
					return (0, _DateUtil.getDate)(result.date);
				}
				return '';
			}, _this.getNbMeasure = function () {
				return _this.props.piezometerMeasures.length;
			}, _this.getMaxMeasure = function (list) {
				return _this.getMeasuresByMinOrMax(list, _lodash.maxBy);
			}, _this.getMinMeasure = function (list) {
				return _this.getMeasuresByMinOrMax(list, _lodash.minBy);
			}, _this.getMeasuresByMinOrMax = function (list, filter) {
				var result = filter(list, function (o) {
					return o.measure;
				});
				if (result) {
					return result.measure;
				}
				return '';
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(IndicatorPiezometer, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'row primary-light white-text no-margin' },
					_react2.default.createElement(
						'div',
						{ className: 'col l6' },
						_react2.default.createElement(
							'h5',
							null,
							_simpleReactI18n2.default.quantity,
							' : ',
							this.getBeginningDate(this.props.piezometerMeasures),
							' -',
							this.getEndingDate(this.props.piezometerMeasures),
							' -',
							this.getNbMeasure()
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'col l3' },
						_react2.default.createElement(
							'h5',
							null,
							_simpleReactI18n2.default.min,
							' : ',
							this.getMinMeasure(this.props.piezometerMeasures)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'col l3' },
						_react2.default.createElement(
							'h5',
							null,
							_simpleReactI18n2.default.max,
							' : ',
							this.getMaxMeasure(this.props.piezometerMeasures)
						)
					)
				);
			}
		}]);
	
		return IndicatorPiezometer;
	}(_react.Component);
	
	IndicatorPiezometer.propTypes = {
		piezometerMeasures: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoDetailPiezometerMeasure2.default))
	};
	
	IndicatorPiezometer.defaultProps = {
		piezometerMeasures: []
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			piezometerMeasures: store.DetailStationReducer.piezometerMeasures
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(IndicatorPiezometer);

/***/ },
/* 2186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(15);
	
	var _DateUtil = __webpack_require__(67);
	
	var _DtoPickupOperation = __webpack_require__(287);
	
	var _DtoPickupOperation2 = _interopRequireDefault(_DtoPickupOperation);
	
	var _DtoAnalysis = __webpack_require__(184);
	
	var _DtoAnalysis2 = _interopRequireDefault(_DtoAnalysis);
	
	var _reactRedux = __webpack_require__(18);
	
	var _StringUtils = __webpack_require__(131);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndicatorQualitometer = function (_Component) {
		_inherits(IndicatorQualitometer, _Component);
	
		function IndicatorQualitometer() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, IndicatorQualitometer);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = IndicatorQualitometer.__proto__ || Object.getPrototypeOf(IndicatorQualitometer)).call.apply(_ref, [this].concat(args))), _this), _this.getEndingDate = function (list) {
				return _this.getDateByMinOrMax(list, _lodash.maxBy);
			}, _this.getBeginningDate = function (list) {
				return _this.getDateByMinOrMax(list, _lodash.minBy);
			}, _this.getDateByMinOrMax = function (list, filter) {
				var result = filter(list, function (o) {
					return o.date;
				});
				if (result) {
					return (0, _DateUtil.getDate)(result.date);
				}
				return '';
			}, _this.getNbChimicalAnalysis = function () {
				return _this.props.analysis.length;
			}, _this.getNbOperation = function () {
				return _this.props.pickupOperations.length;
			}, _this.getNbParameterAnalysed = function () {
				if (_this.props.analysis.length > 0) {
					var parameters = (0, _lodash.uniqBy)(_this.props.analysis, function (analyse) {
						return analyse.parameters;
					});
					return parameters.length;
				}
				return 0;
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(IndicatorQualitometer, [{
			key: 'render',
			value: function render() {
				var valueNbOperation = this.getNbOperation();
				var valueNbChimicalAnalysis = this.getNbChimicalAnalysis();
				var valueNbParameters = this.getNbParameterAnalysed();
				return _react2.default.createElement(
					'div',
					{ className: 'row primary-light white-text no-margin' },
					_react2.default.createElement(
						'div',
						{ className: 'col l12' },
						_react2.default.createElement(
							'h5',
							null,
							_simpleReactI18n2.default.quality,
							' : ',
							this.getBeginningDate(this.props.pickupOperations),
							' -',
							this.getEndingDate(this.props.pickupOperations),
							' -',
							valueNbOperation,
							' ',
							(0, _StringUtils.getPlurialWithNumber)(_simpleReactI18n2.default.lowerOperation, _simpleReactI18n2.default.lowerOperations, valueNbOperation),
							'- ',
							valueNbChimicalAnalysis,
							' ',
							(0, _StringUtils.getPlurialWithNumber)(_simpleReactI18n2.default.lowerAnalysis, _simpleReactI18n2.default.lowerAnalyses, valueNbChimicalAnalysis),
							'- ',
							valueNbParameters,
							' ',
							(0, _StringUtils.getPlurialWithNumber)(_simpleReactI18n2.default.lowerParameter, _simpleReactI18n2.default.lowerParameters, valueNbParameters)
						)
					)
				);
			}
		}]);
	
		return IndicatorQualitometer;
	}(_react.Component);
	
	IndicatorQualitometer.propTypes = {
		pickupOperations: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoPickupOperation2.default)),
		analysis: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoAnalysis2.default))
	};
	
	IndicatorQualitometer.defaultProps = {
		pickupOperations: [],
		analysis: []
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			pickupOperations: store.DetailStationReducer.pickupOperations,
			analysis: store.DetailStationReducer.analysis
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(IndicatorQualitometer);

/***/ },
/* 2187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _DtoDetailStation = __webpack_require__(227);
	
	var _DtoDetailStation2 = _interopRequireDefault(_DtoDetailStation);
	
	var _MapDetailStationPanel = __webpack_require__(541);
	
	var _MapDetailStationPanel2 = _interopRequireDefault(_MapDetailStationPanel);
	
	var _lodash = __webpack_require__(15);
	
	var _DtoIndustrialSite = __webpack_require__(1051);
	
	var _DtoIndustrialSite2 = _interopRequireDefault(_DtoIndustrialSite);
	
	var _DtoIndustrialSeveso = __webpack_require__(1050);
	
	var _DtoIndustrialSeveso2 = _interopRequireDefault(_DtoIndustrialSeveso);
	
	var _DtoIndustrialFamily = __webpack_require__(1049);
	
	var _DtoIndustrialFamily2 = _interopRequireDefault(_DtoIndustrialFamily);
	
	var _DtoIndustrialActivity = __webpack_require__(1048);
	
	var _DtoIndustrialActivity2 = _interopRequireDefault(_DtoIndustrialActivity);
	
	var _DtoCity = __webpack_require__(87);
	
	var _DtoCity2 = _interopRequireDefault(_DtoCity);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndustrialSitePanel = function (_Component) {
		_inherits(IndustrialSitePanel, _Component);
	
		function IndustrialSitePanel() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, IndustrialSitePanel);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = IndustrialSitePanel.__proto__ || Object.getPrototypeOf(IndustrialSitePanel)).call.apply(_ref, [this].concat(args))), _this), _this.getDetailLine = function (title, value) {
				return _react2.default.createElement(
					'div',
					{ className: 'row' },
					_react2.default.createElement(
						'b',
						null,
						title
					),
					_react2.default.createElement('br', null),
					_react2.default.createElement(
						'span',
						{ className: 'black-text' },
						' ',
						value
					),
					_react2.default.createElement('br', null)
				);
			}, _this.getCoordinate = function () {
				if (_this.props.station.site.localization) {
					var title = _simpleReactI18n2.default.point.coordinate;
					var coordinate = 'X: ' + _this.props.station.site.localization.xCoordinate + ' - ' + 'Y: ' + _this.props.station.site.localization.yCoordinate;
					return _this.getDetailLine(title, coordinate);
				}
				return null;
			}, _this.getStandartCode = function (list, code) {
				return (0, _lodash.find)(list, function (o) {
					return o.code == code;
				});
			}, _this.getSector = function () {
				if (_this.props.industrialSite.activityCode) {
					var result = _this.getStandartCode(_this.props.industrialActivity, _this.props.industrialSite.activityCode);
					if (result) {
						return _this.getDetailLine(_simpleReactI18n2.default.activityArea, result.definition);
					}
					return _this.getDetailLine(_simpleReactI18n2.default.activityArea, _simpleReactI18n2.default.notSpecified);
				}
				return _this.getDetailLine(_simpleReactI18n2.default.activityArea, _simpleReactI18n2.default.notSpecified);
			}, _this.getState = function () {
				if (_this.props.industrialSite.state) {
					return _this.getDetailLine(_simpleReactI18n2.default.state, _this.props.industrialSite.state);
				}
				return _this.getDetailLine(_simpleReactI18n2.default.state, _simpleReactI18n2.default.notSpecified);
			}, _this.getNaf = function () {
				return _this.getDetailLine(_simpleReactI18n2.default.nafCode, _simpleReactI18n2.default.notSpecified);
			}, _this.getICPE = function () {
				return _this.getDetailLine(_simpleReactI18n2.default.icpeScheme, _simpleReactI18n2.default.notSpecified);
			}, _this.getSeveso = function () {
				if (_this.props.industrialSite.sevesoCode) {
					var result = _this.getStandartCode(_this.props.industrialSeveso, _this.props.industrialSite.sevesoCode);
					if (result) {
						return _this.getDetailLine('Seveso', result.definition);
					}
					return _this.getDetailLine('Seveso', _simpleReactI18n2.default.notSpecified);
				}
				return _this.getDetailLine('Seveso', _simpleReactI18n2.default.notSpecified);
			}, _this.getFamily = function () {
				if (_this.props.industrialSite.familyCode) {
					var result = _this.getStandartCode(_this.props.industrialFamily, _this.props.industrialSite.familyCode);
					if (result) {
						return _this.getDetailLine(_simpleReactI18n2.default.family, result.definition);
					}
					return _this.getDetailLine(_simpleReactI18n2.default.family, _simpleReactI18n2.default.notSpecified);
				}
				return _this.getDetailLine(_simpleReactI18n2.default.family, _simpleReactI18n2.default.notSpecified);
			}, _this.getComment = function () {
				if (_this.props.station.site && _this.props.station.site.comment) {
					return _this.getDetailLine(_simpleReactI18n2.default.comment, _this.props.station.site.comment);
				}
				return _this.getDetailLine(_simpleReactI18n2.default.comment, _simpleReactI18n2.default.notSpecified);
			}, _this.getCity = function () {
				if (_this.props.station.site.city) {
					var city = (0, _lodash.find)(_this.props.cities, function (o) {
						return o.id == _this.props.station.site.city;
					});
					if (city) {
						var title = _simpleReactI18n2.default.town;
						var value = city.name + ' [' + city.code + ']';
						return _this.getDetailLine(title, value);
					}
					return null;
				}
				return null;
			}, _this.getContent = function () {
				if (_this.props.industrialSite) {
					return _react2.default.createElement(
						'div',
						null,
						_this.getCoordinate(),
						_this.getState(),
						_this.getSector(),
						_this.getFamily(),
						_this.getSeveso(),
						_this.getNaf(),
						_this.getICPE(),
						_this.getComment()
					);
				}
				return _react2.default.createElement(
					'div',
					null,
					_simpleReactI18n2.default.warning.noDataAvailableSite
				);
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(IndustrialSitePanel, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin card-title' },
					_react2.default.createElement(
						'div',
						{ className: 'col s12 m12 l12 no-padding' },
						_react2.default.createElement(
							'div',
							{ className: 'row no-margin white-background' },
							_react2.default.createElement(
								'div',
								{ className: 'col s12 m12 l12 no-padding card-title hide-on-med-and-down no-margin' },
								_react2.default.createElement(
									'div',
									{ className: 'row primary-light white-text no-margin' },
									_react2.default.createElement(
										'div',
										{ className: 'col l12' },
										_react2.default.createElement(
											'h5',
											null,
											_simpleReactI18n2.default.description
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'row no-margin white-background' },
							_react2.default.createElement(
								'div',
								{ className: 'col s6' },
								this.getCity(),
								this.getContent()
							),
							_react2.default.createElement(
								'div',
								{ className: 'col s6 card-title hide-on-med-and-down' },
								_react2.default.createElement(_MapDetailStationPanel2.default, { height: this.props.height - 200 })
							)
						)
					)
				);
			}
		}]);
	
		return IndustrialSitePanel;
	}(_react.Component);
	
	IndustrialSitePanel.propTypes = {
		station: _propTypes2.default.objectOf(_DtoDetailStation2.default),
		height: _propTypes2.default.number,
		cities: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoCity2.default)),
		industrialSite: _propTypes2.default.objectOf(_DtoIndustrialSite2.default),
		industrialActivity: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoIndustrialActivity2.default)),
		industrialFamily: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoIndustrialFamily2.default)),
		industrialSeveso: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoIndustrialSeveso2.default))
	};
	
	IndustrialSitePanel.defaultProps = {
		height: 250
	};
	var mapStateToProps = function mapStateToProps(store) {
		return {
			station: store.DetailStationReducer.station,
			cities: store.ReferentialReducer.cities,
			industrialSite: store.DetailStationReducer.industrialSite,
			industrialActivity: store.DetailStationReducer.industrialActivity,
			industrialFamily: store.DetailStationReducer.industrialFamily,
			industrialSeveso: store.DetailStationReducer.industrialSeveso
		};
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(IndustrialSitePanel);

/***/ },
/* 2188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(15);
	
	var _DtoDetailStationNetwork = __webpack_require__(543);
	
	var _DtoDetailStationNetwork2 = _interopRequireDefault(_DtoDetailStationNetwork);
	
	var _DateUtil = __webpack_require__(67);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NetworkPanel = function (_Component) {
		_inherits(NetworkPanel, _Component);
	
		function NetworkPanel() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, NetworkPanel);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NetworkPanel.__proto__ || Object.getPrototypeOf(NetworkPanel)).call.apply(_ref, [this].concat(args))), _this), _this.getLines = function () {
				var networks = (0, _lodash.orderBy)(_this.props.networks, ['endDate', 'code'], ['desc', 'asc']);
				return networks.map(function (network) {
					var beginDate = (0, _DateUtil.getDate)(network.beginDate);
					var endDate = (0, _DateUtil.getDate)(network.endDate);
	
					var begin = beginDate ? beginDate : '';
					var end = endDate ? endDate : _simpleReactI18n2.default.inProgress;
					return _react2.default.createElement(
						'li',
						{ className: 'collection-item' },
						_react2.default.createElement(
							'span',
							{ className: 'title' },
							network.code,
							' - ',
							network.mnemonique
						),
						_react2.default.createElement(
							'p',
							null,
							_react2.default.createElement(
								'b',
								null,
								_simpleReactI18n2.default.name,
								' : '
							),
							network.name,
							_react2.default.createElement('br', null),
							_react2.default.createElement(
								'b',
								null,
								_simpleReactI18n2.default.fromNetwork,
								' : '
							),
							network.networkemprise,
							_react2.default.createElement('br', null),
							_react2.default.createElement(
								'b',
								null,
								_simpleReactI18n2.default.type,
								' : '
							),
							network.networktype,
							_react2.default.createElement('br', null),
							begin + ' - ' + end
						)
					);
				});
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(NetworkPanel, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin white-background' },
					_react2.default.createElement(
						'div',
						{ className: 'col s12 no-padding' },
						_react2.default.createElement(
							'div',
							{ className: 'row primary-light white-text no-margin' },
							_react2.default.createElement(
								'div',
								{ className: 'col l12' },
								_react2.default.createElement(
									'h5',
									null,
									_simpleReactI18n2.default.point.network,
									' : ',
									this.props.networks.length
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'row no-margin' },
							_react2.default.createElement(
								'ul',
								{ className: 'collection' },
								this.getLines()
							)
						)
					)
				);
			}
		}]);
	
		return NetworkPanel;
	}(_react.Component);
	
	NetworkPanel.propTypes = {
		networks: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoDetailStationNetwork2.default))
	};
	NetworkPanel.defaultProps = {
		networks: []
	};
	
	exports.default = NetworkPanel;

/***/ },
/* 2189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(15);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DtoDetailPiezometerMeasure = __webpack_require__(185);
	
	var _DtoDetailPiezometerMeasure2 = _interopRequireDefault(_DtoDetailPiezometerMeasure);
	
	var _reactAquasys = __webpack_require__(49);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnnualChartPanel = function (_Component) {
		_inherits(AnnualChartPanel, _Component);
	
		function AnnualChartPanel(props) {
			_classCallCheck(this, AnnualChartPanel);
	
			var _this = _possibleConstructorReturn(this, (AnnualChartPanel.__proto__ || Object.getPrototypeOf(AnnualChartPanel)).call(this, props));
	
			_this.getPiezometerMeasuresMax = function () {
				return (0, _lodash.sortBy)(_this.props.piezometerMeasuresMax, ['date']);
			};
	
			_this.getPiezometerMeasuresMin = function () {
				return (0, _lodash.sortBy)(_this.props.piezometerMeasuresMin, ['date']);
			};
	
			_this.getPiezometerMeasuresMoyenne = function () {
				return (0, _lodash.sortBy)(_this.props.piezometerMeasuresMoyenne, ['date']);
			};
	
			_this.formatter = function (measures) {
				return measures.map(function (measure) {
					return {
						x: measure.date,
						y: measure.measure
					};
				});
			};
	
			_this.getChart = function () {
				var dateNow = (0, _moment2.default)().subtract(1, 'years');
				var yearMeasures = (0, _lodash.filter)(_this.props.piezometerMeasures, function (o) {
					return (0, _moment2.default)(o.date).isSameOrAfter(dateNow);
				});
				var year = yearMeasures.map(function (measure) {
					return Object.assign({}, measure, {
						date: parseInt((0, _moment2.default)(measure.date).format('x'))
					});
				});
				var data = _this.formatter(year);
				var dataMax = _this.formatter(_this.getPiezometerMeasuresMax());
				var dataMin = _this.formatter(_this.getPiezometerMeasuresMin());
				var dataMoyenne = _this.formatter(_this.getPiezometerMeasuresMoyenne());
				var maxMin = dataMax.map(function (measure) {
					var minSearch = dataMin.find(function (o) {
						return o.x === measure.x;
					});
					if (minSearch) {
						var concatMeasure = [].concat(minSearch.y, measure.y);
						return Object.assign({}, measure, {
							y: concatMeasure
						});
					}
					return measure;
				});
				var annualSerie = new _reactAquasys.Timeserie({ data: data, color: 'black', name: _simpleReactI18n2.default.annualChronicle });
				var averageSerie = new _reactAquasys.Timeserie({ data: dataMoyenne, color: 'green', name: _simpleReactI18n2.default.middleChronicle, style: 'dash' });
				var areaMinMax = new _reactAquasys.Area({ data: maxMin, color: 'steelblue', name: _simpleReactI18n2.default.envelope });
				var series = [areaMinMax, averageSerie, annualSerie];
				return _react2.default.createElement(_reactAquasys.IChart, { width: _this.state.width, height: '450',
					series: series,
					zoomable: true, legend: true });
			};
	
			_this.state = {
				width: 0
			};
			return _this;
		}
	
		_createClass(AnnualChartPanel, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.setState({ width: this.refs.refWidth.offsetWidth });
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'row white-background', ref: 'refWidth' },
					_react2.default.createElement(
						'div',
						{ className: 'col s12 m12 l12 card-title hide-on-med-and-down no-margin no-padding' },
						_simpleReactI18n2.default.annualChart
					),
					_react2.default.createElement(
						'div',
						{ className: 'col s12 m12 l12 card-title hide-on-med-and-down no-margin no-padding' },
						this.getChart()
					)
				);
			}
		}]);
	
		return AnnualChartPanel;
	}(_react.Component);
	
	AnnualChartPanel.propTypes = {
		piezometerMeasures: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoDetailPiezometerMeasure2.default)),
		piezometerMeasuresMax: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoDetailPiezometerMeasure2.default)),
		piezometerMeasuresMin: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoDetailPiezometerMeasure2.default)),
		piezometerMeasuresMoyenne: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoDetailPiezometerMeasure2.default))
	};
	
	AnnualChartPanel.defaultProps = {
		piezometerMeasures: [],
		piezometerMeasuresMax: [],
		piezometerMeasuresMin: [],
		piezometerMeasuresMoyenne: []
	};
	
	exports.default = AnnualChartPanel;

/***/ },
/* 2190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(15);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DtoDetailPiezometerMeasure = __webpack_require__(185);
	
	var _DtoDetailPiezometerMeasure2 = _interopRequireDefault(_DtoDetailPiezometerMeasure);
	
	var _MathUtil = __webpack_require__(2209);
	
	var _reactAquasys = __webpack_require__(49);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AverageLevelChartPanel = function (_Component) {
		_inherits(AverageLevelChartPanel, _Component);
	
		function AverageLevelChartPanel(props) {
			_classCallCheck(this, AverageLevelChartPanel);
	
			var _this = _possibleConstructorReturn(this, (AverageLevelChartPanel.__proto__ || Object.getPrototypeOf(AverageLevelChartPanel)).call(this, props));
	
			_this.getChart = function () {
				var measureByYear = (0, _lodash.reduce)(_this.props.piezometerMeasures, function (result, value) {
					var yearMeasure = (0, _moment2.default)(value.date).year();
					(result[yearMeasure] || (result[yearMeasure] = [])).push(value.measure);
					return result;
				}, {});
				var actualYear = (0, _moment2.default)().year();
				var averageMeasureByYear = Object.keys(measureByYear).map(function (measures) {
					var result = {
						x: measures,
						y: (0, _MathUtil.getAverage)(measureByYear[measures])
					};
					if (measures == actualYear) {
						result.color = 'red';
					}
					return result;
				});
				var data = (0, _lodash.orderBy)(averageMeasureByYear, ['y'], ['desc']);
				var serie = [new _reactAquasys.Bar({ data: data, color: 'blue', name: 'test' })];
	
				return _react2.default.createElement(_reactAquasys.IChart, { height: '200', series: serie });
			};
	
			_this.state = {
				width: 0
			};
			return _this;
		}
	
		_createClass(AverageLevelChartPanel, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'col s12 m12 l12 no-margin no-padding white-background', ref: 'historyChart' },
					_react2.default.createElement(
						'div',
						{ className: 'col s12 m12 l12 card-title hide-on-med-and-down no-margin no-padding' },
						_simpleReactI18n2.default.annualAverageLevels
					),
					_react2.default.createElement(
						'div',
						{ className: 'col s12 m12 l12 card-title hide-on-med-and-down no-margin no-padding' },
						this.getChart()
					)
				);
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.setState({ width: this.refs.historyChart.offsetWidth });
			}
		}]);
	
		return AverageLevelChartPanel;
	}(_react.Component);
	
	AverageLevelChartPanel.propTypes = {
		piezometerMeasures: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoDetailPiezometerMeasure2.default))
	};
	
	AverageLevelChartPanel.defaultProps = {
		piezometerMeasures: []
	};
	
	exports.default = AverageLevelChartPanel;

/***/ },
/* 2191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DtoDetailPiezometerMeasure = __webpack_require__(185);
	
	var _DtoDetailPiezometerMeasure2 = _interopRequireDefault(_DtoDetailPiezometerMeasure);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactAquasys = __webpack_require__(49);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HistoryChartPanel = function (_Component) {
		_inherits(HistoryChartPanel, _Component);
	
		function HistoryChartPanel(props) {
			_classCallCheck(this, HistoryChartPanel);
	
			var _this = _possibleConstructorReturn(this, (HistoryChartPanel.__proto__ || Object.getPrototypeOf(HistoryChartPanel)).call(this, props));
	
			_this.getChart = function () {
				var data = _this.props.piezometerMeasures.map(function (piezometerMeasure) {
					return {
						x: parseInt((0, _moment2.default)(piezometerMeasure.date).format('x')),
						y: piezometerMeasure.measure
					};
				});
				var historySerie = new _reactAquasys.Timeserie({ data: data, color: 'black', name: 'Historique' });
	
				return _react2.default.createElement(_reactAquasys.IChart, { height: '200', series: [historySerie] });
			};
	
			_this.state = {
				width: 0
			};
			return _this;
		}
	
		_createClass(HistoryChartPanel, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.setState({ width: this.refs.historyChart.offsetWidth });
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'col s12 m12 l12 no-margin no-padding white-background', ref: 'historyChart' },
					_react2.default.createElement(
						'div',
						{ className: 'col s12 m12 l12 card-title hide-on-med-and-down no-margin no-padding' },
						_simpleReactI18n2.default.historicalChart
					),
					_react2.default.createElement(
						'div',
						{ className: 'col s12 m12 l12 card-title hide-on-med-and-down no-margin no-padding' },
						this.getChart()
					)
				);
			}
		}]);
	
		return HistoryChartPanel;
	}(_react.Component);
	
	HistoryChartPanel.propTypes = {
		piezometerMeasures: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoDetailPiezometerMeasure2.default))
	};
	
	HistoryChartPanel.defaultProps = {
		piezometerMeasures: []
	};
	
	exports.default = HistoryChartPanel;

/***/ },
/* 2192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _lodash = __webpack_require__(15);
	
	var _IndicatorPiezometer = __webpack_require__(2185);
	
	var _IndicatorPiezometer2 = _interopRequireDefault(_IndicatorPiezometer);
	
	var _HistoryChartPanel = __webpack_require__(2191);
	
	var _HistoryChartPanel2 = _interopRequireDefault(_HistoryChartPanel);
	
	var _AnnualChartPanel = __webpack_require__(2189);
	
	var _AnnualChartPanel2 = _interopRequireDefault(_AnnualChartPanel);
	
	var _AverageLevelChartPanel = __webpack_require__(2190);
	
	var _AverageLevelChartPanel2 = _interopRequireDefault(_AverageLevelChartPanel);
	
	var _DtoDetailPiezometerMeasure = __webpack_require__(185);
	
	var _DtoDetailPiezometerMeasure2 = _interopRequireDefault(_DtoDetailPiezometerMeasure);
	
	var _DtoPiezometerMeasure = __webpack_require__(1025);
	
	var _DtoPiezometerMeasure2 = _interopRequireDefault(_DtoPiezometerMeasure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PiezometerPanel = function (_Component) {
		_inherits(PiezometerPanel, _Component);
	
		function PiezometerPanel() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, PiezometerPanel);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PiezometerPanel.__proto__ || Object.getPrototypeOf(PiezometerPanel)).call.apply(_ref, [this].concat(args))), _this), _this.getPiezometerMeasures = function () {
				return (0, _lodash.sortBy)(_this.props.piezometerMeasures, ['date']);
			}, _this.getPiezometerMeasureYearChart = function () {
				if (_this.getPiezometerMeasures().length > 0) {
					return _react2.default.createElement(_AnnualChartPanel2.default, { piezometerMeasures: _this.getPiezometerMeasures(),
						piezometerMeasuresMax: _this.props.piezometerMeasuresMax,
						piezometerMeasuresMin: _this.props.piezometerMeasuresMin,
						piezometerMeasuresMoyenne: _this.props.piezometerMeasuresMoyenne
					});
				}
				return null;
			}, _this.getPiezometerMeasureHistoryChart = function () {
				if (_this.getPiezometerMeasures().length > 0) {
					return _react2.default.createElement(_HistoryChartPanel2.default, { piezometerMeasures: _this.getPiezometerMeasures() });
				}
				return null;
			}, _this.getAverageLevelChartPanel = function () {
				if (_this.getPiezometerMeasures().length > 0) {
					return _react2.default.createElement(_AverageLevelChartPanel2.default, { piezometerMeasures: _this.getPiezometerMeasures() });
				}
				return null;
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(PiezometerPanel, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin card-title' },
					_react2.default.createElement(
						'div',
						{ className: 'col s12 m12 l12 ' },
						_react2.default.createElement(
							'div',
							{ className: 'row no-margin white-background' },
							_react2.default.createElement(
								'div',
								{ className: 'col s12 m12 l12 no-padding card-title hide-on-med-and-down no-margin' },
								_react2.default.createElement(_IndicatorPiezometer2.default, null)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'row no-margin white-background' },
							_react2.default.createElement(
								'div',
								{ className: 'col s12 m12 l8 card-title hide-on-med-and-down' },
								this.getPiezometerMeasureYearChart()
							),
							_react2.default.createElement(
								'div',
								{ className: 'col s12 m12 l4 card-title hide-on-med-and-down' },
								_react2.default.createElement(
									'div',
									{ className: 'row no-margin' },
									_react2.default.createElement(
										'div',
										{ className: 'col s12 no-padding' },
										this.getPiezometerMeasureHistoryChart()
									),
									_react2.default.createElement(
										'div',
										{ className: 'col s12 no-padding' },
										this.getAverageLevelChartPanel()
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return PiezometerPanel;
	}(_react.Component);
	
	PiezometerPanel.propTypes = {
		id: _propTypes2.default.string,
		piezometerMeasuresMax: _propTypes2.default.arrayOf(_DtoDetailPiezometerMeasure2.default),
		piezometerMeasuresMin: _propTypes2.default.arrayOf(_DtoDetailPiezometerMeasure2.default),
		piezometerMeasuresMoyenne: _propTypes2.default.arrayOf(_DtoDetailPiezometerMeasure2.default),
		piezometerMeasures: _propTypes2.default.arrayOf(_DtoPiezometerMeasure2.default)
	
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			piezometerMeasuresMax: store.DetailStationReducer.piezometerMeasuresMax,
			piezometerMeasuresMin: store.DetailStationReducer.piezometerMeasuresMin,
			piezometerMeasuresMoyenne: store.DetailStationReducer.piezometerMeasuresMoyenne,
			piezometerMeasures: store.DetailStationReducer.piezometerMeasures
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(PiezometerPanel);

/***/ },
/* 2193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _DtoDetailStation = __webpack_require__(227);
	
	var _DtoDetailStation2 = _interopRequireDefault(_DtoDetailStation);
	
	var _MapDetailStationPanel = __webpack_require__(541);
	
	var _MapDetailStationPanel2 = _interopRequireDefault(_MapDetailStationPanel);
	
	var _lodash = __webpack_require__(15);
	
	var _DtoPollutedSoil = __webpack_require__(1052);
	
	var _DtoPollutedSoil2 = _interopRequireDefault(_DtoPollutedSoil);
	
	var _DtoIcpeActivity = __webpack_require__(1047);
	
	var _DtoIcpeActivity2 = _interopRequireDefault(_DtoIcpeActivity);
	
	var _DtoCity = __webpack_require__(87);
	
	var _DtoCity2 = _interopRequireDefault(_DtoCity);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PollutedSoilPanel = function (_Component) {
		_inherits(PollutedSoilPanel, _Component);
	
		function PollutedSoilPanel() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, PollutedSoilPanel);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PollutedSoilPanel.__proto__ || Object.getPrototypeOf(PollutedSoilPanel)).call.apply(_ref, [this].concat(args))), _this), _this.getDetailLine = function (title, value) {
				return _react2.default.createElement(
					'div',
					{ className: 'row' },
					_react2.default.createElement(
						'b',
						null,
						title
					),
					_react2.default.createElement('br', null),
					_react2.default.createElement(
						'span',
						{ className: 'black-text' },
						' ',
						value
					),
					_react2.default.createElement('br', null)
				);
			}, _this.getStandartCode = function (list, code) {
				return (0, _lodash.find)(list, function (o) {
					return o.code == code;
				});
			}, _this.getICPE = function () {
				if (_this.props.pollutedSoil.icpeActivityCode) {
					var result = _this.getStandartCode(_this.props.icpeActivity, _this.props.pollutedSoil.icpeActivityCode);
					if (result) {
						return _this.getDetailLine(_simpleReactI18n2.default.icpeScheme, result.definition);
					}
					return _this.getDetailLine(_simpleReactI18n2.default.icpeScheme, _simpleReactI18n2.default.notSpecified);
				}
				return _this.getDetailLine(_simpleReactI18n2.default.icpeScheme, _simpleReactI18n2.default.notSpecified);
			}, _this.getCity = function () {
				if (_this.props.station.site.city) {
					var city = (0, _lodash.find)(_this.props.cities, function (o) {
						return o.id == _this.props.station.site.city;
					});
					if (city) {
						var title = _simpleReactI18n2.default.town;
						var value = city.name + ' [' + city.code + ']';
						return _this.getDetailLine(title, value);
					}
					return null;
				}
				return null;
			}, _this.getCoordinate = function () {
				if (_this.props.station.site.localization) {
					var title = _simpleReactI18n2.default.point.coordinate;
					var coordinate = 'X: ' + _this.props.station.site.localization.xCoordinate + ' - ' + 'Y: ' + _this.props.station.site.localization.yCoordinate;
					return _this.getDetailLine(title, coordinate);
				}
				return null;
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(PollutedSoilPanel, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin card-title' },
					_react2.default.createElement(
						'div',
						{ className: 'col s12 m12 l12 no-padding' },
						_react2.default.createElement(
							'div',
							{ className: 'row no-margin white-background' },
							_react2.default.createElement(
								'div',
								{ className: 'col s12 m12 l12 no-padding card-title hide-on-med-and-down no-margin' },
								_react2.default.createElement(
									'div',
									{ className: 'row primary-light white-text no-margin' },
									_react2.default.createElement(
										'div',
										{ className: 'col l12' },
										_react2.default.createElement(
											'h5',
											null,
											_simpleReactI18n2.default.description
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'row no-margin white-background' },
							_react2.default.createElement(
								'div',
								{ className: 'col s6' },
								this.getCity(),
								this.getCoordinate(),
								this.getICPE()
							),
							_react2.default.createElement(
								'div',
								{ className: 'col s6 card-title hide-on-med-and-down' },
								_react2.default.createElement(_MapDetailStationPanel2.default, { height: this.props.height - 200 })
							)
						)
					)
				);
			}
		}]);
	
		return PollutedSoilPanel;
	}(_react.Component);
	
	PollutedSoilPanel.propTypes = {
		station: _propTypes2.default.objectOf(_DtoDetailStation2.default),
		height: _propTypes2.default.number,
		cities: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoCity2.default)),
		pollutedSoil: _propTypes2.default.objectOf(_DtoPollutedSoil2.default),
		icpeActivity: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoIcpeActivity2.default))
	};
	
	PollutedSoilPanel.defaultProps = {
		height: 250
	};
	var mapStateToProps = function mapStateToProps(store) {
		return {
			station: store.DetailStationReducer.station,
			cities: store.ReferentialReducer.cities,
			pollutedSoil: store.DetailStationReducer.pollutedSoil,
			icpeActivity: store.DetailStationReducer.icpeActivity
		};
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(PollutedSoilPanel);

/***/ },
/* 2194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(15);
	
	var _KeyFiguresParmeters = __webpack_require__(2195);
	
	var _KeyFiguresParmeters2 = _interopRequireDefault(_KeyFiguresParmeters);
	
	var _DtoAnalysis = __webpack_require__(184);
	
	var _DtoAnalysis2 = _interopRequireDefault(_DtoAnalysis);
	
	var _reactRedux = __webpack_require__(18);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DtoPickupOperation = __webpack_require__(287);
	
	var _DtoPickupOperation2 = _interopRequireDefault(_DtoPickupOperation);
	
	var _DtoParameter = __webpack_require__(224);
	
	var _DtoParameter2 = _interopRequireDefault(_DtoParameter);
	
	var _AnalysisUtils = __webpack_require__(2206);
	
	var _DtoRemark = __webpack_require__(285);
	
	var _DtoRemark2 = _interopRequireDefault(_DtoRemark);
	
	var _reactAquasys = __webpack_require__(49);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FilterParameterChartPanel = function (_Component) {
		_inherits(FilterParameterChartPanel, _Component);
	
		function FilterParameterChartPanel(props) {
			_classCallCheck(this, FilterParameterChartPanel);
	
			var _this = _possibleConstructorReturn(this, (FilterParameterChartPanel.__proto__ || Object.getPrototypeOf(FilterParameterChartPanel)).call(this, props));
	
			_this.getTitle = function (filterId) {
				if (_this.props.parameters.length > 0 && filterId) {
					var result = (0, _lodash.find)(_this.props.parameters, function (parameter) {
						return parameter.id == filterId;
					});
					if (result) {
						return result.name;
					}
					return filterId;
				}
				return filterId;
			};
	
			_this.getReferencialRemark = function (id) {
				if (_this.props.remarks.length > 0) {
					return (0, _lodash.find)(_this.props.remarks, function (o) {
						return o.id == id;
					});
				}
				return null;
			};
	
			_this.getSeries = function (analysis) {
				var reduceData = (0, _lodash.reduce)(analysis, function (o, v) {
					if (v.remarkCode) {
						(o[v.remarkCode] || (o[v.remarkCode] = [])).push(v);
					}
					return o;
				}, {});
				var line = (0, _lodash.orderBy)(analysis.map(function (sec) {
					return {
						x: parseInt((0, _moment2.default)(sec.analysisDate).format('x')),
						y: sec.result
					};
				}), ['x'], ['asc']);
				if (Object.keys(reduceData).length > 1) {
					var dataResult = Object.keys(reduceData).map(function (rem) {
						var data = (0, _lodash.orderBy)(reduceData[rem].map(function (measure) {
							return {
								x: parseInt((0, _moment2.default)(measure.analysisDate).format('x')),
								y: measure.result
							};
						}), ['x'], ['asc']);
						var plotChoice = (0, _AnalysisUtils.getRemarks)(rem);
						var remarkRef = _this.getReferencialRemark(plotChoice.id);
						return new _reactAquasys.Plot({ data: data, color: 'blue', name: remarkRef ? remarkRef.mnemonique : 'Line', plot: plotChoice.plot });
					});
					return [].concat([new _reactAquasys.Timeserie({ data: line, color: 'blue', name: _simpleReactI18n2.default.reference })], dataResult);
				}
				if (Object.keys(reduceData).length > 0) {
					var plotChoice = (0, _AnalysisUtils.getRemarks)(Object.keys(reduceData)[0]);
					var remarkRef = _this.getReferencialRemark(plotChoice.id);
	
					return [new _reactAquasys.Timeserie({ data: line, color: 'blue', name: remarkRef ? remarkRef.mnemonique : _simpleReactI18n2.default.reference, plot: plotChoice.plot })];
				}
	
				return [new _reactAquasys.Timeserie({ data: line, color: 'blue', name: _simpleReactI18n2.default.reference, plot: 'square' })];
			};
	
			_this.getChart = function () {
				var filterByParameter = (0, _lodash.reduce)(_this.props.analysis, function (result, value) {
					(result[value.parameters] || (result[value.parameters] = [])).push(value);
					return result;
				}, {});
				var dataFilter = Object.keys(filterByParameter).find(function (filter) {
					return filter === _this.props.selectedValue;
				});
				if (!dataFilter) {
					dataFilter = (0, _lodash.head)(Object.keys(filterByParameter).sort());
				}
				var filterBySupport = (0, _lodash.reduce)(filterByParameter[dataFilter], function (result, value) {
					(result[value.support] || (result[value.support] = [])).push(value);
					return result;
				}, {});
				var dataSupportFilter = Object.keys(filterBySupport).find(function (filter) {
					return filter === _this.props.selectedSupport;
				});
				if (!dataSupportFilter) {
					dataSupportFilter = (0, _lodash.head)(Object.keys(filterBySupport).sort());
				}
	
				var dataSelected = (0, _lodash.uniqWith)([].concat(filterByParameter[dataFilter], filterBySupport[dataSupportFilter]), function (a, b) {
					return a.id === b.id;
				});
				var selectedAnalysis = dataSelected.map(function (m) {
					if (m.analysisDate) {
						return m;
					}
					var operation = (0, _lodash.find)(_this.props.pickupOperations, function (o) {
						return o.id === m.pickupOperationId;
					});
					return Object.assign({}, m, {
						analysisDate: operation.date
					});
				});
	
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin' },
					_react2.default.createElement(
						'div',
						{ className: 'col s12 m4 l4 no-padding' },
						_react2.default.createElement(_KeyFiguresParmeters2.default, { analysis: selectedAnalysis })
					),
					_react2.default.createElement(
						'div',
						{ className: 'col s12 m8 l8 no-padding' },
						_react2.default.createElement(_reactAquasys.IChart, { height: '350',
							series: _this.getSeries(selectedAnalysis), legend: true })
					)
				);
			};
	
			_this.state = {
				width: 0
			};
			return _this;
		}
	
		_createClass(FilterParameterChartPanel, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.setState({ width: this.refs.filterParameter.offsetWidth });
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin' },
					_react2.default.createElement(
						'div',
						{ className: 'col s6 m6 l12 no-margin no-padding', ref: 'filterParameter' },
						_react2.default.createElement(
							'div',
							{ className: 'row no-margin' },
							this.getChart()
						)
					)
				);
			}
		}]);
	
		return FilterParameterChartPanel;
	}(_react.Component);
	
	FilterParameterChartPanel.propTypes = {
		analysis: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoAnalysis2.default)),
		pickupOperations: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoPickupOperation2.default)),
		parameters: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoParameter2.default)),
		selectedValue: _propTypes2.default.string,
		selectedSupport: _propTypes2.default.string,
		remarks: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoRemark2.default))
	};
	FilterParameterChartPanel.defaultProps = {
		analysis: [],
		pickupOperations: [],
		parameters: [],
		selectedValue: '',
		selectedSupport: ''
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			analysis: store.DetailStationReducer.analysis,
			pickupOperations: store.DetailStationReducer.pickupOperations,
			parameters: store.ReferentialReducer.parameters,
			remarks: store.ReferentialReducer.remarks
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(FilterParameterChartPanel);

/***/ },
/* 2195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(15);
	
	var _DateUtil = __webpack_require__(67);
	
	var _DtoAnalysis = __webpack_require__(184);
	
	var _DtoAnalysis2 = _interopRequireDefault(_DtoAnalysis);
	
	var _reactRedux = __webpack_require__(18);
	
	var _DtoUnit = __webpack_require__(383);
	
	var _DtoUnit2 = _interopRequireDefault(_DtoUnit);
	
	var _DtoRemark = __webpack_require__(285);
	
	var _DtoRemark2 = _interopRequireDefault(_DtoRemark);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KeyFiguresParmeters = function (_Component) {
		_inherits(KeyFiguresParmeters, _Component);
	
		function KeyFiguresParmeters() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, KeyFiguresParmeters);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = KeyFiguresParmeters.__proto__ || Object.getPrototypeOf(KeyFiguresParmeters)).call.apply(_ref, [this].concat(args))), _this), _this.getEndingDate = function (list) {
				return _this.getDateByMinOrMax(list, _lodash.maxBy);
			}, _this.getBeginningDate = function (list) {
				return _this.getDateByMinOrMax(list, _lodash.minBy);
			}, _this.getDateByMinOrMax = function (list, filter) {
				var result = filter(list, function (o) {
					return o.analysisDate;
				});
				if (result) {
					return (0, _DateUtil.getDate)(result.analysisDate);
				}
				return '';
			}, _this.getMeasuresByMinOrMax = function (list, filter) {
				var result = filter(list, function (o) {
					return o.result;
				});
				if (result) {
					return result;
				}
				return '';
			}, _this.getMeasure = function (filter) {
				var maxMeasure = _this.getMeasuresByMinOrMax(_this.props.analysis, filter);
				if (maxMeasure) {
					return _this.getValue(maxMeasure) + ' (' + (0, _DateUtil.getDate)(maxMeasure.analysisDate) + ')';
				}
				return '';
			}, _this.getRemark = function () {
				var reduceRemark = (0, _lodash.reduce)(_this.props.analysis, function (result, value) {
					if (value.remarkCode) {
						if (result[value.remarkCode]) {
							result[value.remarkCode] = result[value.remarkCode] + 1;
						} else {
							result[value.remarkCode] = 1;
						}
					}
					return result;
				}, {});
	
				if (Object.keys(reduceRemark).length > 0) {
					return Object.keys(reduceRemark).map(function (remark) {
						if (_this.props.remarks.length > 0) {
							var remarkRef = (0, _lodash.find)(_this.props.remarks, function (o) {
								return o.id == remark;
							});
							return _react2.default.createElement(
								'div',
								{ className: 'col l12' },
								_react2.default.createElement(
									'span',
									null,
									remarkRef.mnemonique,
									' : ',
									reduceRemark[remark]
								)
							);
						}
						return _react2.default.createElement(
							'div',
							{ className: 'col l12' },
							_react2.default.createElement(
								'span',
								null,
								remark,
								' : ',
								reduceRemark[remark]
							)
						);
					});
				}
				return _react2.default.createElement(
					'div',
					{ className: 'col l12' },
					_react2.default.createElement(
						'span',
						null,
						_simpleReactI18n2.default.warning.noCodeNoticed
					)
				);
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(KeyFiguresParmeters, [{
			key: 'getValue',
			value: function getValue(analyse) {
				if (analyse.unit) {
					var unit = (0, _lodash.find)(this.props.units, function (o) {
						return o.id == analyse.unit;
					});
					if (unit && unit.symbol) {
						return analyse.result + ' ' + unit.symbol;
					}
					return analyse.result;
				}
				return analyse.result;
			}
		}, {
			key: 'render',
			value: function render() {
				var min = this.getMeasure(_lodash.minBy);
				var max = this.getMeasure(_lodash.maxBy);
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'div',
						{ className: 'row no-margin' },
						_react2.default.createElement(
							'div',
							{ className: 'col l12' },
							_react2.default.createElement(
								'span',
								null,
								_simpleReactI18n2.default.historical,
								' : ',
								this.getBeginningDate(this.props.analysis),
								' -',
								this.getEndingDate(this.props.analysis)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'col l12' },
							_react2.default.createElement(
								'span',
								null,
								_simpleReactI18n2.default.min,
								' : ',
								min
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'col l12' },
							_react2.default.createElement(
								'span',
								null,
								_simpleReactI18n2.default.max,
								' : ',
								max
							)
						),
						this.getRemark()
					)
				);
			}
		}]);
	
		return KeyFiguresParmeters;
	}(_react.Component);
	
	KeyFiguresParmeters.propTypes = {
		analysis: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoAnalysis2.default)),
		units: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoUnit2.default)),
		remarks: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoRemark2.default))
	};
	
	KeyFiguresParmeters.defaultProps = {
		analysis: [],
		units: [],
		remarks: []
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			units: store.ReferentialReducer.units,
			remarks: store.ReferentialReducer.remarks
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(KeyFiguresParmeters);

/***/ },
/* 2196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(15);
	
	var _reactRedux = __webpack_require__(18);
	
	var _DtoAnalysis = __webpack_require__(184);
	
	var _DtoAnalysis2 = _interopRequireDefault(_DtoAnalysis);
	
	var _DtoParameter = __webpack_require__(224);
	
	var _DtoParameter2 = _interopRequireDefault(_DtoParameter);
	
	var _reactAquasys = __webpack_require__(49);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MoleculeDetectedChartPanel = function (_Component) {
		_inherits(MoleculeDetectedChartPanel, _Component);
	
		function MoleculeDetectedChartPanel(props) {
			_classCallCheck(this, MoleculeDetectedChartPanel);
	
			var _this = _possibleConstructorReturn(this, (MoleculeDetectedChartPanel.__proto__ || Object.getPrototypeOf(MoleculeDetectedChartPanel)).call(this, props));
	
			_this.getParameterName = function (filterId) {
				if (_this.props.parameters.length > 0 && filterId) {
					var result = (0, _lodash.find)(_this.props.parameters, function (parameter) {
						return parameter.id == filterId;
					});
					if (result) {
						return result.name;
					}
					return filterId;
				}
				return filterId;
			};
	
			_this.getMostParametersDetected = function () {
				var nbParametes = (0, _lodash.reduce)(_this.props.analysis, function (result, value) {
					if (result[value.parameters]) {
						result[value.parameters] = result[value.parameters] + 1;
					} else {
						result[value.parameters] = 1;
					}
					return result;
				}, {});
				var sortParameter = Object.keys(nbParametes).map(function (parameter) {
					return {
						x: _this.getParameterName(parameter),
						y: nbParametes[parameter]
					};
				});
				var data = (0, _lodash.take)((0, _lodash.orderBy)(sortParameter, ['y'], ['desc']), 10).reverse();
				var serie = new _reactAquasys.HorizontalBar({ data: data, color: 'blue' });
				return _react2.default.createElement(_reactAquasys.IChart, { width: _this.state.width, height: '450',
					series: [serie] });
			};
	
			_this.state = {
				width: 0
			};
			return _this;
		}
	
		_createClass(MoleculeDetectedChartPanel, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.setState({ width: this.refs.mostMoleculeDetected.offsetWidth });
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin' },
					_react2.default.createElement(
						'div',
						{ className: 'col s6 m6 l12 no-margin no-padding' },
						_react2.default.createElement(
							'div',
							{ className: 'row no-margin card-title hide-on-med-and-down no-margin' },
							_simpleReactI18n2.default.mostDetectedMolecules
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'col s6 m6 l12 no-margin no-padding', ref: 'mostMoleculeDetected' },
						_react2.default.createElement(
							'div',
							{ className: 'row no-margin' },
							this.getMostParametersDetected()
						)
					)
				);
			}
		}]);
	
		return MoleculeDetectedChartPanel;
	}(_react.Component);
	
	MoleculeDetectedChartPanel.propTypes = {
		analysis: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoAnalysis2.default)),
		parameters: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoParameter2.default))
	};
	MoleculeDetectedChartPanel.defaultProps = {
		analysis: [],
		parameters: []
	};
	var mapStateToProps = function mapStateToProps(store) {
		return {
			analysis: store.DetailStationReducer.analysis,
			parameters: store.ReferentialReducer.parameters
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(MoleculeDetectedChartPanel);

/***/ },
/* 2197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(18);
	
	var _IndicatorQualitometer = __webpack_require__(2186);
	
	var _IndicatorQualitometer2 = _interopRequireDefault(_IndicatorQualitometer);
	
	var _MoleculeDetectedChartPanel = __webpack_require__(2196);
	
	var _MoleculeDetectedChartPanel2 = _interopRequireDefault(_MoleculeDetectedChartPanel);
	
	var _FilterParameterChartPanel = __webpack_require__(2194);
	
	var _FilterParameterChartPanel2 = _interopRequireDefault(_FilterParameterChartPanel);
	
	var _lodash = __webpack_require__(15);
	
	var _DtoDetailStationSamplingSurfacePoint = __webpack_require__(286);
	
	var _DtoDetailStationSamplingSurfacePoint2 = _interopRequireDefault(_DtoDetailStationSamplingSurfacePoint);
	
	var _DtoAnalysis = __webpack_require__(184);
	
	var _DtoAnalysis2 = _interopRequireDefault(_DtoAnalysis);
	
	var _DtoPickupOperation = __webpack_require__(287);
	
	var _DtoPickupOperation2 = _interopRequireDefault(_DtoPickupOperation);
	
	var _DtoParameter = __webpack_require__(224);
	
	var _DtoParameter2 = _interopRequireDefault(_DtoParameter);
	
	var _DtoSupport = __webpack_require__(150);
	
	var _DtoSupport2 = _interopRequireDefault(_DtoSupport);
	
	var _Select = __webpack_require__(2114);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QualitometerPanel = function (_Component) {
		_inherits(QualitometerPanel, _Component);
	
		function QualitometerPanel(props) {
			_classCallCheck(this, QualitometerPanel);
	
			var _this = _possibleConstructorReturn(this, (QualitometerPanel.__proto__ || Object.getPrototypeOf(QualitometerPanel)).call(this, props));
	
			_this.getMoleculeDetectedChart = function () {
				if (_this.props.pickupOperations.length > 0) {
					return _react2.default.createElement(_MoleculeDetectedChartPanel2.default, null);
				}
				return '';
			};
	
			_this.change = function (value) {
				_this.setState({ selectedValue: value });
			};
	
			_this.changeSupport = function (value) {
				_this.setState({ selectedSupport: value });
			};
	
			_this.getTitle = function (list, filterId) {
				if (list && list.length > 0 && filterId) {
					var result = (0, _lodash.find)(list, function (o) {
						return o.id == filterId;
					});
					if (result) {
						return result.name;
					}
					return filterId;
				}
				return filterId;
			};
	
			_this.getSelectedParameters = function () {
				var nbParametes = (0, _lodash.reduce)(_this.props.analysis, function (result, value) {
					if (result[value.parameters]) {
						result[value.parameters] = result[value.parameters] + 1;
					} else {
						result[value.parameters] = 1;
					}
					return result;
				}, {});
	
				var parameters = Object.keys(nbParametes).map(function (parameter) {
					if (parameter === _this.state.selectedValue) {
						return {
							id: parameter,
							label: _this.getTitle(_this.props.parameters, parameter),
							selected: true
						};
					}
					return {
						id: parameter,
						label: _this.getTitle(_this.props.parameters, parameter)
					};
				});
				var data = (0, _lodash.orderBy)(parameters, ['label'], ['asc']);
				return _react2.default.createElement(_Select2.default, { values: data, title: _simpleReactI18n2.default.parameters,
					change: _this.change });
			};
	
			_this.getSelectedSupport = function () {
				var nbSupport = (0, _lodash.reduce)(_this.props.analysis, function (result, value) {
					if (value.support) {
						if (result[value.support]) {
							result[value.support] = result[value.support] + 1;
						} else {
							result[value.support] = 1;
						}
					}
					return result;
				}, {});
				var supports = Object.keys(nbSupport).map(function (support) {
					if (support === _this.state.selectedSupport) {
						return {
							id: support,
							label: _this.getTitle(_this.props.supports, support),
							selected: true
						};
					}
					return {
						id: support,
						label: _this.getTitle(_this.props.supports, support)
					};
				});
				var data = (0, _lodash.orderBy)(supports, ['label'], ['asc']);
				if (data.length > 1) {
					return _react2.default.createElement(_Select2.default, { values: data, title: _simpleReactI18n2.default.support,
						change: _this.changeSupport });
				}
				return _react2.default.createElement(_Select2.default, { values: data, title: _simpleReactI18n2.default.support,
					change: _this.changeSupport, disabled: true });
			};
	
			_this.state = {
				selectedValue: '1340',
				selectedSupport: '3'
			};
			return _this;
		}
	
		_createClass(QualitometerPanel, [{
			key: 'render',
			value: function render() {
				if (this.props.pickupOperations.length > 0) {
					return _react2.default.createElement(
						'div',
						{ className: 'row no-margin card-title' },
						_react2.default.createElement(
							'div',
							{ className: 'col s12 m12 l12 ' },
							_react2.default.createElement(
								'div',
								{ className: 'row no-margin white-background' },
								_react2.default.createElement(
									'div',
									{ className: 'col s12 m12 l12 no-padding card-title hide-on-med-and-down no-margin' },
									_react2.default.createElement(_IndicatorQualitometer2.default, null)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row no-margin white-background' },
								_react2.default.createElement(
									'div',
									{ className: 'col s12 m8 l8 no-padding' },
									_react2.default.createElement(
										'div',
										{ className: 'row no-margin' },
										_react2.default.createElement(
											'div',
											{ className: 'col s12 m6 l6 no-padding' },
											this.getSelectedParameters()
										),
										_react2.default.createElement(
											'div',
											{ className: 'col s12 m6 l6 no-padding' },
											this.getSelectedSupport()
										),
										_react2.default.createElement(_FilterParameterChartPanel2.default, { selectedValue: this.state.selectedValue,
											selectedSupport: this.state.selectedSupport })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col s6 m4 l4 no-padding' },
									_react2.default.createElement(
										'div',
										{ className: 'row no-margin' },
										this.getMoleculeDetectedChart()
									)
								)
							)
						)
					);
				}
				return _react2.default.createElement(
					'div',
					{ className: 'col s12 m12 l12 card-title hide-on-med-and-down no-margin', id: 'qualitometerPanel' },
					_simpleReactI18n2.default.noDataAvailableQuality
				);
			}
		}]);
	
		return QualitometerPanel;
	}(_react.Component);
	
	QualitometerPanel.propTypes = {
		id: _propTypes2.default.string,
		samplingSurfacePoints: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoDetailStationSamplingSurfacePoint2.default)),
		pickupOperations: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoPickupOperation2.default)),
		analysis: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoAnalysis2.default)),
		parameters: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoParameter2.default)),
		supports: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoSupport2.default))
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			samplingSurfacePoints: store.DetailStationReducer.samplingSurfacePoints,
			pickupOperations: store.DetailStationReducer.pickupOperations,
			analysis: store.DetailStationReducer.analysis,
			parameters: store.ReferentialReducer.parameters,
			supports: store.ReferentialReducer.supports
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(QualitometerPanel);

/***/ },
/* 2198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(15);
	
	var _reactRedux = __webpack_require__(18);
	
	var _DateUtil = __webpack_require__(67);
	
	var _DtoDetailStationSamplingSurfacePoint = __webpack_require__(286);
	
	var _DtoDetailStationSamplingSurfacePoint2 = _interopRequireDefault(_DtoDetailStationSamplingSurfacePoint);
	
	var _DtoSupport = __webpack_require__(150);
	
	var _DtoSupport2 = _interopRequireDefault(_DtoSupport);
	
	var _simpleReactI18n = __webpack_require__(17);
	
	var _simpleReactI18n2 = _interopRequireDefault(_simpleReactI18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SamplingSurfacePointPanel = function (_Component) {
		_inherits(SamplingSurfacePointPanel, _Component);
	
		function SamplingSurfacePointPanel(props) {
			_classCallCheck(this, SamplingSurfacePointPanel);
	
			var _this = _possibleConstructorReturn(this, (SamplingSurfacePointPanel.__proto__ || Object.getPrototypeOf(SamplingSurfacePointPanel)).call(this, props));
	
			_this.getLines = function () {
				var samplings = (0, _lodash.orderBy)(_this.props.samplingSurfacePoints, ['endDate', 'code'], ['desc', 'asc']);
	
				var data = samplings.map(function (samplingSurfacePoints) {
					var support = samplingSurfacePoints.supportCode ? (0, _lodash.find)(_this.props.supports, function (o) {
						return o.id == samplingSurfacePoints.supportCode;
					}) : null;
					if (support) {
						return Object.assign({}, samplingSurfacePoints, {
							name: support.name
						});
					}
					return samplingSurfacePoints;
				});
	
				return data.map(function (samplingSurfacePoints) {
					var beginDate = (0, _DateUtil.getDate)(samplingSurfacePoints.beginDate);
					var endDate = (0, _DateUtil.getDate)(samplingSurfacePoints.endDate);
					var begin = beginDate ? beginDate : '';
					var end = endDate ? endDate : 'En cours';
					return _react2.default.createElement(
						'li',
						{ className: 'collection-item' },
						_react2.default.createElement(
							'span',
							{
								className: 'title' },
							_simpleReactI18n2.default.code,
							': ',
							samplingSurfacePoints.code,
							' - ',
							_simpleReactI18n2.default.support,
							' : ',
							samplingSurfacePoints.name + ' [' + samplingSurfacePoints.supportCode + ']'
						),
						_react2.default.createElement(
							'p',
							null,
							_react2.default.createElement(
								'b',
								null,
								'X : '
							),
							samplingSurfacePoints.xCoordinate,
							_react2.default.createElement('br', null),
							_react2.default.createElement(
								'b',
								null,
								'Y : '
							),
							samplingSurfacePoints.yCoordinate,
							_react2.default.createElement('br', null),
							begin + ' - ' + end
						)
					);
				});
			};
	
			return _this;
		}
	
		_createClass(SamplingSurfacePointPanel, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'row no-margin white-background' },
					_react2.default.createElement(
						'div',
						{ className: 'col s12 no-padding' },
						_react2.default.createElement(
							'div',
							{ className: 'row primary-light white-text no-margin' },
							_react2.default.createElement(
								'div',
								{ className: 'col l12' },
								_react2.default.createElement(
									'h5',
									null,
									_simpleReactI18n2.default.point.samplingPoints,
									' : ',
									this.props.samplingSurfacePoints.length
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'row no-margin' },
							_react2.default.createElement(
								'ul',
								{ className: 'collection' },
								this.getLines()
							)
						)
					)
				);
			}
		}]);
	
		return SamplingSurfacePointPanel;
	}(_react.Component);
	
	SamplingSurfacePointPanel.propTypes = {
		samplingSurfacePoints: _propTypes2.default.arrayOf(_propTypes2.default.objectOf(_DtoDetailStationSamplingSurfacePoint2.default)),
		supports: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_DtoSupport2.default))
	};
	
	SamplingSurfacePointPanel.defaultProps = {
		samplingSurfacePoints: [],
		supports: []
	};
	
	var mapStateToProps = function mapStateToProps(store) {
		return {
			samplingSurfacePoints: store.DetailStationReducer.samplingSurfacePoints,
			supports: store.ReferentialReducer.supports
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(SamplingSurfacePointPanel);

/***/ },
/* 2199 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
		STATION_NATURE_SEAPORT: 'SEAPORT',
		STATION_NATURE_PIEZOMETER: 'PIEZOMETER',
		STATION_NATURE_SECTOR: 'SECTOR',
		STATION_NATURE_PLOT: 'PLOT',
		STATION_NATURE_SOURCE: 'SOURCE',
		STATION_NATURE_QUALITOMETER: 'QUALITOMETER',
		STATION_NATURE_QUALITOMETER_SURFACE: 'QUALITOMETER_SURFACE',
		STATION_NATURE_PLUVIOMETER: 'PLUVIOMETER',
		STATION_NATURE_POLLUTED_SOIL: 'POLLUTED_SOIL',
		STATION_NATURE_INDUSTRIAL_SITE: 'INDUSTRIAL_SITE',
		STATION_NATURE_HYDROLOGICAL_STATION: 'HYDROLOGICAL_STATION',
		STATION_NATURE_TREATMENT_STATION: 'TREATMENT_STATION',
		STATION_NATURE_PIEZO_QUALITO: 'PIEZOQUALITO',
		STATION_NATURE_WATER_COURSE: 'WATER_COURSE',
		STATION_NATURE_WATER_PLAN: 'WATER_PLAN',
		STATION_NATURE_WATER_SHED: 'WATER_SHED',
		STATION_NATURE_COASTLINE: 'COASTLINE',
		STATION_NATURE_PUMPED_VOLUME: 'PUMPED_VOLUME',
		STATION_NATURE_LIMIT: 'LIMIT',
		STATION_NATURE_DEPOSIT: 'DEPOSIT',
		STATION_NATURE_OBSTACLE_FLOW: 'OBSTACLE_FLOW'
	};

/***/ },
/* 2200 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.address = obj.address;
		this.complement = obj.complement;
		this.localizationName = obj.localizationName;
	};
	
	exports.default = _class;

/***/ },
/* 2201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _DtoLocalization = __webpack_require__(2203);
	
	var _DtoLocalization2 = _interopRequireDefault(_DtoLocalization);
	
	var _DtoAddress = __webpack_require__(2200);
	
	var _DtoAddress2 = _interopRequireDefault(_DtoAddress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.id = obj.id;
		this.name = obj.name;
		this.link = obj.link;
		this.city = obj.cityId;
		this.comment = obj.comment;
		this.localization = new _DtoLocalization2.default(obj.dtoSiteLocalization);
		this.address = obj.address ? new _DtoAddress2.default(obj.address) : undefined;
	};
	
	exports.default = _class;

/***/ },
/* 2202 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.name = obj.name;
		this.code = obj.code;
	};
	
	exports.default = _class;

/***/ },
/* 2203 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function _class(obj) {
		_classCallCheck(this, _class);
	
		this.xCoordinate = obj.x_coordinate;
		this.yCoordinate = obj.y_coordinate;
	};
	
	exports.default = _class;

/***/ },
/* 2204 */
539,
/* 2205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.store = undefined;
	exports.DetailStationReducer = DetailStationReducer;
	
	var _DetailStationConstants = __webpack_require__(542);
	
	var _DtoDetailPiezometerMeasure = __webpack_require__(185);
	
	var _DtoDetailPiezometerMeasure2 = _interopRequireDefault(_DtoDetailPiezometerMeasure);
	
	var _DtoDetailStationNetwork = __webpack_require__(543);
	
	var _DtoDetailStationNetwork2 = _interopRequireDefault(_DtoDetailStationNetwork);
	
	var _DtoDetailStationSamplingSurfacePoint = __webpack_require__(286);
	
	var _DtoDetailStationSamplingSurfacePoint2 = _interopRequireDefault(_DtoDetailStationSamplingSurfacePoint);
	
	var _DtoDetailStation = __webpack_require__(227);
	
	var _DtoDetailStation2 = _interopRequireDefault(_DtoDetailStation);
	
	var _DtoPickupOperation = __webpack_require__(287);
	
	var _DtoPickupOperation2 = _interopRequireDefault(_DtoPickupOperation);
	
	var _lodash = __webpack_require__(15);
	
	var _DtoAnalysis = __webpack_require__(184);
	
	var _DtoAnalysis2 = _interopRequireDefault(_DtoAnalysis);
	
	var _DtoParameter = __webpack_require__(224);
	
	var _DtoParameter2 = _interopRequireDefault(_DtoParameter);
	
	var _DtoUnit = __webpack_require__(383);
	
	var _DtoUnit2 = _interopRequireDefault(_DtoUnit);
	
	var _DtoRemark = __webpack_require__(285);
	
	var _DtoRemark2 = _interopRequireDefault(_DtoRemark);
	
	var _DtoSupport = __webpack_require__(150);
	
	var _DtoSupport2 = _interopRequireDefault(_DtoSupport);
	
	var _DtoIndustrialSite = __webpack_require__(1051);
	
	var _DtoIndustrialSite2 = _interopRequireDefault(_DtoIndustrialSite);
	
	var _DtoIndustrialActivity = __webpack_require__(1048);
	
	var _DtoIndustrialActivity2 = _interopRequireDefault(_DtoIndustrialActivity);
	
	var _DtoIndustrialSeveso = __webpack_require__(1050);
	
	var _DtoIndustrialSeveso2 = _interopRequireDefault(_DtoIndustrialSeveso);
	
	var _DtoIndustrialFamily = __webpack_require__(1049);
	
	var _DtoIndustrialFamily2 = _interopRequireDefault(_DtoIndustrialFamily);
	
	var _DtoIcpeActivity = __webpack_require__(1047);
	
	var _DtoIcpeActivity2 = _interopRequireDefault(_DtoIcpeActivity);
	
	var _DtoPollutedSoil = __webpack_require__(1052);
	
	var _DtoPollutedSoil2 = _interopRequireDefault(_DtoPollutedSoil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var store = exports.store = {
		station: {
			site: {
				name: '',
				comment: '',
				localization: {
					xCoordinate: '',
					yCoordinate: ''
				},
				address: {
					address: '',
					complement: '',
					localizationName: ''
				}
			},
			hydrologicArea: {
				name: '',
				code: ''
			},
			waterMass: {
				name: '',
				code: ''
			}
		},
		pickupOperations: [],
		analysis: [],
		piezometerMeasures: [],
		piezometerMeasuresMax: [],
		piezometerMeasuresMin: [],
		piezometerMeasuresMoyenne: [],
		networks: [],
		samplingSurfacePoints: [],
		parameters: [],
		units: [],
		remarks: [],
		supports: [],
		industrialFamily: [],
		industrialActivity: [],
		industrialSeveso: [],
		industrialSite: [],
		pollutedSoil: {},
		icpeActivity: []
	};
	
	function DetailStationReducer() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		var action = arguments[1];
	
		switch (action.type) {
			case _DetailStationConstants.RECEIVE_DETAIL_STATION:
				{
					return Object.assign({}, state, {
						station: new _DtoDetailStation2.default(action.station)
					});
				}
			case _DetailStationConstants.RECEIVE_DETAIL_QUALITO:
				{
					return Object.assign({}, state, {
						station: new _DtoDetailStation2.default(action.station)
					});
				}
			case _DetailStationConstants.RECEIVE_DETAIL_PICKUP_OPERATION:
				{
					return Object.assign({}, state, {
						pickupOperations: (0, _lodash.uniqWith)([].concat(action.pickupOperations.map(function (el) {
							return new _DtoPickupOperation2.default(el);
						}), state.pickupOperations), function (a, b) {
							return a.id === b.id;
						})
					});
				}
			case _DetailStationConstants.RECEIVE_DETAIL_PIEZOMETER_MEASURE:
				{
					return Object.assign({}, state, {
						piezometerMeasures: action.measures.map(function (el) {
							return new _DtoDetailPiezometerMeasure2.default(el);
						})
					});
				}
			case _DetailStationConstants.RECEIVE_DETAIL_PIEZOMETER_MEASURE_STATISTIC_MAX:
				{
					return Object.assign({}, state, {
						piezometerMeasuresMax: action.measures.map(function (el) {
							return new _DtoDetailPiezometerMeasure2.default(el);
						})
					});
				}
			case _DetailStationConstants.RECEIVE_DETAIL_PIEZOMETER_MEASURE_STATISTIC_MIN:
				{
					return Object.assign({}, state, {
						piezometerMeasuresMin: action.measures.map(function (el) {
							return new _DtoDetailPiezometerMeasure2.default(el);
						})
					});
				}
			case _DetailStationConstants.RECEIVE_DETAIL_PIEZOMETER_MEASURE_STATISTIC_MOYENNE:
				{
					return Object.assign({}, state, {
						piezometerMeasuresMoyenne: action.measures.map(function (el) {
							return new _DtoDetailPiezometerMeasure2.default(el);
						})
					});
				}
			case _DetailStationConstants.RECEIVE_DETAIL_STATION_NETWORK:
				{
					return Object.assign({}, state, {
						networks: (0, _lodash.uniqWith)([].concat(action.networks.map(function (el) {
							return new _DtoDetailStationNetwork2.default(el);
						}), state.networks), function (a, b) {
							return a.id === b.id;
						})
					});
				}
			case _DetailStationConstants.RECEIVE_DETAIL_QUALITO_SAMPLING_SURFACE_POINT:
				{
					return Object.assign({}, state, {
						samplingSurfacePoints: (0, _lodash.uniqWith)([].concat(action.samplingSurfacePoints.map(function (el) {
							return new _DtoDetailStationSamplingSurfacePoint2.default(el);
						}), state.samplingSurfacePoints), function (a, b) {
							return a.id === b.id;
						})
					});
				}
			case _DetailStationConstants.ADD_QUALITOMETER_DETAIL_ANALYSIS:
				{
					return Object.assign({}, state, {
						analysis: (0, _lodash.uniqWith)([].concat(action.analysis.map(function (el) {
							return new _DtoAnalysis2.default(el);
						}), state.analysis), function (a, b) {
							return a.id === b.id;
						})
					});
				}
			case _DetailStationConstants.ADD_PARAMETERS:
				{
					return Object.assign({}, state, {
						parameters: (0, _lodash.uniqWith)([].concat(action.parameters.map(function (el) {
							return new _DtoParameter2.default(el);
						}), state.parameters), function (a, b) {
							return a.id === b.id;
						})
					});
				}
			case _DetailStationConstants.ADD_UNITS:
				{
					return Object.assign({}, state, {
						units: (0, _lodash.uniqWith)([].concat(action.units.map(function (el) {
							return new _DtoUnit2.default(el);
						}), state.units), function (a, b) {
							return a.id === b.id;
						})
					});
				}
			case _DetailStationConstants.ADD_REMARKS:
				{
					return Object.assign({}, state, {
						remarks: (0, _lodash.uniqWith)([].concat(action.remarks.map(function (el) {
							return new _DtoRemark2.default(el);
						}), state.remarks), function (a, b) {
							return a.id === b.id;
						})
					});
				}
			case _DetailStationConstants.ADD_SUPPORTS:
				{
					return Object.assign({}, state, {
						supports: (0, _lodash.uniqWith)([].concat(action.supports.map(function (el) {
							return new _DtoSupport2.default(el);
						}), state.supports), function (a, b) {
							return a.id === b.id;
						})
					});
				}
			case _DetailStationConstants.RECEIVE_DETAIL_INDUSTRIAL:
				{
					return Object.assign({}, state, {
						industrialSite: new _DtoIndustrialSite2.default(action.industrialSite)
					});
				}
			case _DetailStationConstants.RECEIVE_INDUSTRIAL_ACTIVITY:
				{
					return Object.assign({}, state, {
						industrialActivity: (0, _lodash.uniqWith)([].concat(action.industrialActivity.map(function (el) {
							return new _DtoIndustrialActivity2.default(el);
						}), state.industrialActivity), function (a, b) {
							return a.type === b.type && a.code === b.code;
						})
					});
				}
			case _DetailStationConstants.RECEIVE_INDUSTRIAL_SEVESO:
				{
					return Object.assign({}, state, {
						industrialSeveso: (0, _lodash.uniqWith)([].concat(action.industrialSeveso.map(function (el) {
							return new _DtoIndustrialSeveso2.default(el);
						}), state.industrialSeveso), function (a, b) {
							return a.type === b.type && a.code === b.code;
						})
					});
				}
			case _DetailStationConstants.RECEIVE_INDUSTRIAL_FAMILY:
				{
					return Object.assign({}, state, {
						industrialFamily: (0, _lodash.uniqWith)([].concat(action.industrialFamily.map(function (el) {
							return new _DtoIndustrialFamily2.default(el);
						}), state.industrialFamily), function (a, b) {
							return a.type === b.type && a.code === b.code;
						})
					});
				}
			case _DetailStationConstants.RECEIVE_ICPE_ACTIVITY:
				{
					return Object.assign({}, state, {
						icpeActivity: (0, _lodash.uniqWith)([].concat(action.icpeActivity.map(function (el) {
							return new _DtoIcpeActivity2.default(el);
						}), state.icpeActivity), function (a, b) {
							return a.type === b.type && a.code === b.code;
						})
					});
				}
			case _DetailStationConstants.RECEIVE_DETAIL_POLLUTED_SOIL:
				{
					return Object.assign({}, state, {
						pollutedSoil: new _DtoPollutedSoil2.default(action.pollutedSoil)
					});
				}
			case _DetailStationConstants.DETAIL_STATION_RESET:
				{
					return Object.assign({}, state, store);
				}
			default:
				return state;
		}
	}

/***/ },
/* 2206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getRemarks = exports.remarks = undefined;
	
	var _lodash = __webpack_require__(15);
	
	var remarks = [{
		id: 2,
		code: 1,
		plot: 'square',
		color: 'blue'
	}, {
		id: 4,
		code: 3,
		plot: 'diamond',
		color: 'red'
	}, {
		id: 11,
		code: 10,
		plot: 'round',
		color: 'orange'
	}, {
		id: 8,
		code: 7,
		plot: 'triangle',
		color: 'black'
	}];
	
	var getRemarks = function getRemarks(id) {
		return (0, _lodash.find)(remarks, function (o) {
			return o.id == id;
		});
	};
	
	exports.remarks = remarks;
	exports.getRemarks = getRemarks;

/***/ },
/* 2207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getDevelopmentPanel = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getDevelopmentPanel = function getDevelopmentPanel() {
		var big = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
		var className = big ? 'inDevelopTitle' : '';
		return _react2.default.createElement(
			'div',
			{ className: className },
			'En d\xE9veloppement'
		);
	};
	
	exports.getDevelopmentPanel = getDevelopmentPanel;

/***/ },
/* 2208 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var google = window.google;
	
	var getDistanceBetweenCoordsWGS84 = function getDistanceBetweenCoordsWGS84(loc1, loc2) {
		var gLoc1 = new google.maps.LatLng(loc1[1], loc1[0]);
		var gLoc2 = new google.maps.LatLng(loc2[1], loc2[0]);
		return (google.maps.geometry.spherical.computeDistanceBetween(gLoc1, gLoc2) / 1000).toFixed();
	};
	
	exports.getDistanceBetweenCoordsWGS84 = getDistanceBetweenCoordsWGS84;

/***/ },
/* 2209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getAverage = undefined;
	
	var _lodash = __webpack_require__(15);
	
	var getAverage = function getAverage(list) {
		var somme = list.reduce(function (a, b) {
			return a + b;
		}, 0);
		return (0, _lodash.round)(somme / list.length, 2);
	};
	
	exports.getAverage = getAverage;

/***/ },
/* 2210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getFieldType = undefined;
	
	var _TypesConstants = __webpack_require__(1056);
	
	var _lodash = __webpack_require__(15);
	
	var getFieldType = function getFieldType(field) {
		var lowerCase = field.toLowerCase();
		if ((0, _lodash.includes)(lowerCase, 'data')) {
			return _TypesConstants.BOOLEAN;
		} else if ((0, _lodash.includes)(lowerCase, 'date')) {
			return _TypesConstants.DATE;
		} else if ((0, _lodash.includes)(lowerCase, 'nb')) {
			return _TypesConstants.NUMBER;
		} else if ((0, _lodash.includes)(lowerCase, 'is')) {
			return _TypesConstants.BOOLEAN;
		} else if ((0, _lodash.includes)(lowerCase, 'function')) {
			return _TypesConstants.FUNCTION;
		} else if ((0, _lodash.includes)(lowerCase, 'state')) {
			return _TypesConstants.STATUS;
		}
		return _TypesConstants.TEXT;
	};
	
	exports.getFieldType = getFieldType;

/***/ },
/* 2211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.urlsCheckStatus = undefined;
	
	var _isomorphicFetch = __webpack_require__(78);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _LegendUtils = __webpack_require__(1059);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fetchUrl = function fetchUrl(url) {
		return (0, _isomorphicFetch2.default)(url, {
			method: "GET"
		}).then(function (response) {
			if (response.status === 200) {
				return url;
			}
			return null;
		}).catch(function () {
			return null;
		});
	};
	var urlsCheckStatus = function urlsCheckStatus(layers) {
		var result = layers.map(function (o) {
			return fetchUrl((0, _LegendUtils.getLegendUrl)(o));
		});
		return Promise.all(result);
	};
	
	exports.urlsCheckStatus = urlsCheckStatus;

/***/ },
/* 2212 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DtoCookie = function DtoCookie(obj) {
		_classCallCheck(this, DtoCookie);
	
		this.advertisingCookies = obj.advertisingCookies;
		this.statisticsCookies = obj.statisticsCookies;
	};
	
	exports.default = DtoCookie;

/***/ },
/* 2213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getKMLLayer = exports.getLayer = undefined;
	
	var _WMS = __webpack_require__(2217);
	
	var _WMS2 = _interopRequireDefault(_WMS);
	
	var _MapStyles = __webpack_require__(546);
	
	var _MapStyles2 = _interopRequireDefault(_MapStyles);
	
	var _KMLLayer = __webpack_require__(2215);
	
	var _KMLLayer2 = _interopRequireDefault(_KMLLayer);
	
	var _ApplicationConf = __webpack_require__(65);
	
	var _ApplicationConf2 = _interopRequireDefault(_ApplicationConf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getLayer = function getLayer(layer, popup, layerTypeTitle) {
		var url = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	
		if (layer && layer.type) {
			var color = layer.color ? layer.color : _MapStyles2.default.FILL_RED;
			switch (layer.type) {
				case 'WMS':
					return (0, _WMS2.default)({
						url: layer.url,
						params: { layers: layer.layer },
						opacity: layer.opacity,
						visibility: layer.visibility,
						popup: popup
					});
				case 'KML':
					var urlKml = function () {
						if (layer.url) {
							return layer.url;
						}
						var layerValue = layer.value ? layer.value : '';
						return url ? url + layerValue : _ApplicationConf2.default.layer.cityLayer(layer.value);
					}();
					return (0, _KMLLayer2.default)({
						url: urlKml,
						style: color,
						headers: true,
						popup: popup,
						type: layerTypeTitle,
						extractStyles: layer.extractStyles
					});
				default:
					return null;
			}
		}
		return null;
	};
	
	var getKMLLayer = function getKMLLayer(layer) {
		layer.type = 'KML';
		return getLayer(layer);
	};
	exports.getLayer = getLayer;
	exports.getKMLLayer = getKMLLayer;

/***/ },
/* 2214 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapException = function (_Error) {
		_inherits(MapException, _Error);
	
		function MapException(message) {
			_classCallCheck(this, MapException);
	
			var name = 'MapException';
	
			var _this = _possibleConstructorReturn(this, (MapException.__proto__ || Object.getPrototypeOf(MapException)).call(this, name + ' : ' + message));
	
			_this.name = name;
			return _this;
		}
	
		return MapException;
	}(Error);
	
	exports.MapException = MapException;

/***/ },
/* 2215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = KMLLayer;
	
	var _ILayers = __webpack_require__(229);
	
	var _ILayers2 = _interopRequireDefault(_ILayers);
	
	var _openlayers = __webpack_require__(110);
	
	var _openlayers2 = _interopRequireDefault(_openlayers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _KMLLayer = function (_Layers) {
		_inherits(_KMLLayer, _Layers);
	
		function _KMLLayer(obj) {
			_classCallCheck(this, _KMLLayer);
	
			var _this = _possibleConstructorReturn(this, (_KMLLayer.__proto__ || Object.getPrototypeOf(_KMLLayer)).call(this));
	
			_this.obj = obj;
			_this.kmlFormatWater = new _openlayers2.default.format.KML({
				extractStyles: obj.extractStyles || false
			});
			_this.layer = _this.createLayer();
			return _this;
		}
	
		_createClass(_KMLLayer, [{
			key: 'createLayer',
			value: function createLayer() {
				var vct = new _openlayers2.default.source.Vector({
					url: this.obj.url,
					format: this.kmlFormatWater
				});
				return new _openlayers2.default.layer.Vector({
					source: vct,
					style: this.obj.style
				});
			}
		}, {
			key: 'getLayer',
			value: function getLayer() {
				return this.layer;
			}
		}, {
			key: 'getPopup',
			value: function getPopup() {
				return this.popup;
			}
		}]);
	
		return _KMLLayer;
	}(_ILayers2.default);
	
	function KMLLayer(args) {
		return new _KMLLayer(args);
	}

/***/ },
/* 2216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = OSMSatellite;
	
	var _ILayers = __webpack_require__(229);
	
	var _ILayers2 = _interopRequireDefault(_ILayers);
	
	var _openlayers = __webpack_require__(110);
	
	var _openlayers2 = _interopRequireDefault(_openlayers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _OSMSatellite = function (_Layers) {
	    _inherits(_OSMSatellite, _Layers);
	
	    function _OSMSatellite() {
	        _classCallCheck(this, _OSMSatellite);
	
	        var _this = _possibleConstructorReturn(this, (_OSMSatellite.__proto__ || Object.getPrototypeOf(_OSMSatellite)).call(this));
	
	        _this.layer = _this.createLayer();
	        return _this;
	    }
	
	    _createClass(_OSMSatellite, [{
	        key: 'createLayer',
	        value: function createLayer() {
	            return new _openlayers2.default.layer.Tile({
	                source: new _openlayers2.default.source.XYZ({
	                    attributions: [new _openlayers2.default.Attribution({
	                        html: 'Tiles &copy Esri &mdash Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
	                    })],
	                    url: 'http://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
	                })
	            });
	        }
	    }, {
	        key: 'getLayer',
	        value: function getLayer() {
	            return this.layer;
	        }
	    }]);
	
	    return _OSMSatellite;
	}(_ILayers2.default);
	
	function OSMSatellite() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	    }
	
	    return new (Function.prototype.bind.apply(_OSMSatellite, [null].concat(args)))();
	}

/***/ },
/* 2217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = WMS;
	
	var _openlayers = __webpack_require__(110);
	
	var _openlayers2 = _interopRequireDefault(_openlayers);
	
	var _ILayers2 = __webpack_require__(229);
	
	var _ILayers3 = _interopRequireDefault(_ILayers2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _WMS = function (_ILayers) {
		_inherits(_WMS, _ILayers);
	
		function _WMS(obj) {
			_classCallCheck(this, _WMS);
	
			var _this = _possibleConstructorReturn(this, (_WMS.__proto__ || Object.getPrototypeOf(_WMS)).call(this));
	
			_this.createLayer = function () {
				return new _openlayers2.default.layer.Tile({
					opacity: _this.getOpacity(),
					visibility: _this.visibility,
					source: new _openlayers2.default.source.TileWMS({
						url: _this.url,
						params: _this.params
					})
				});
			};
	
			_this.getOpacity = function () {
				return _this.opacity ? _this.opacity : 1;
			};
	
			_this.url = obj.url;
			_this.params = obj.params;
			_this.opacity = obj.opacity;
			_this.visibility = obj.visibility;
			_this.popup = obj.popup;
			_this.layer = _this.createLayer();
			return _this;
		}
	
		_createClass(_WMS, [{
			key: 'getLayer',
			value: function getLayer() {
				return this.layer;
			}
		}, {
			key: 'getPopup',
			value: function getPopup() {
				return this.popup;
			}
		}]);
	
		return _WMS;
	}(_ILayers3.default);
	
	function WMS() {
		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}
	
		return new (Function.prototype.bind.apply(_WMS, [null].concat(args)))();
	}

/***/ },
/* 2218 */
/***/ function(module, exports) {

	module.exports = {
		"signin": "Se connecter",
		"signup": "Créer un compte",
		"login": "Identifiant",
		"password": "Mot de passe",
		"confirmPassword": "Confirmer le mot de passe",
		"validate": "Valider",
		"firstname": "Prénom",
		"lastname": "Nom",
		"mobile": "Téléphone mobile",
		"phone": "Téléphone",
		"address": "Adresse",
		"zip": "Code postal",
		"city": "Ville",
		"home": "Accueil",
		"administration": "Administration",
		"administrativeLimits": "Limites administratives",
		"administrativeLimit": "Limite administrative",
		"tutorial": "Didacticiel",
		"signOut": "Déconnexion",
		"connection": "Connexion",
		"legalNotice": "Mentions légales",
		"news": "Actualités",
		"forgotPassword": "Mot de passe oublié ?",
		"needHelp": "Besoin d'aide ?",
		"error": {
			"login": "L'identifiant doit être renseigné",
			"mandatoryTheme": "Vous ne pouvez pas déselectionner ce thême temporairement",
			"password": "Le mot de passe doit être renseigné",
			"confirmPassword": "Le mot de passe de confirmation doit être renseigné",
			"mail": "L'email doit être renseigné",
			"captcha": "Le captcha doit être validé",
			"incorrectEmail": "Adresse e-mail invalide",
			"notFound": "Erreur 404 - Page introuvable",
			"nonexistent": "Station recherchée inexistante",
			"errorDuringExport": "Une erreur est survenue lors de votre export",
			"errorLoadingData": "Erreur lors du chargement des données",
			"noWatershedSelection": "Aucune zone hydrographique trouvée pour cette sélection",
			"pleasePhoneInform": "Merci de renseigner votre téléphone",
			"pleaseNameInform": "Merci de renseigner votre nom",
			"criteriaLimited10": "Nombre de critère limité à 10",
			"radiusLimited20km": "Rayon limité à 20 km",
			"cannotDeleteSite": "Impossible de supprimer vos sites",
			"cannotGetSelection": "Impossible d'obtenir des sélections",
			"cannotSaveInformation": "Impossible d'enregistrer vos informations",
			"errorOccurredExportingSelection": "Une erreur est survenue lors de l'export de votre sélection",
			"errorRequestingCredits": "Une erreur est survenue lors de votre demande de crédits",
			"pleaseFillLeastTheme": "Merci de renseigner au minimum un thème",
			"samePassword": "Les mots de passes ne sont pas identiques",
			"thanksContactSupport": "Merci de contacter le support pour plus d'informations.",
			"notAllowToConnect": "Vous n'êtes pas autorisé à vous connecter.",
			"notRegister": "Vous n'êtes pas renseigné dans notre base de données. Inscrivez-vous !",
			"loginError": "Vous n'êtes pas autorisé à vous connecter"
		},
		"mail": "Adresse e-mail",
		"page": "Page",
		"signupSuccess": "Bienvenue sur AquaDB. Nous vous avons envoyé un mail afin que vous puissiez terminer votre inscription",
		"findEmailSuccess": "Nous vous avons envoyé un mail afin que vous puissiez changer votre mot de passe",
		"name": "Nom",
		"save": "Sauvegarder",
		"success": "Valide",
		"piezometer": "Piézomètre",
		"code": "Code",
		"cityid": "Code commune",
		"nafCode": "Code NAF",
		"icpeScheme": "Régime ICPE",
		"family": "Famille",
		"longitude": "Longitude",
		"longi": "Longitude",
		"zoom": "Zoom",
		"fullScreen": "Plein écran",
		"customZoom": "Zoom personnalisé",
		"latitude": "Latitude",
		"lati": "Latitude",
		"numberOfMeasure": "Nb mesures",
		"firstDate": "Date de début",
		"openingDate": "Date d'ouverture",
		"closingDate": "Date de fermeture",
		"lastDate": "Date de fin",
		"lastMeasure": "Dernière mesure",
		"qualitometer": "Qualitomètre",
		"nbOperation": "Nb operations",
		"nbAnalysis": "Nb analyses",
		"numberAnalysis": "Nombre d'analyses",
		"nbMeasure": "Nb measures",
		"numberMeasure": "Nombre de mesures",
		"surfaceQualitometer": "Qualitomètre de surface",
		"mostDetectedMolecules": "Molécules les plus détectées",
		"pollutedSoil": "Sols pollués",
		"industrialSite": "Sites industriels",
		"siteReseach": "Recherche de sites",
		"stationResearch": "Recherche de points",
		"stationForm": "Fiche station",
		"searchLaunch": "Lancement recherche",
		"advancedSearch": "Recherche avancée",
		"element": "Element",
		"elements": "Elements",
		"lowerOperation": "opération",
		"lowerOperations": "opérations",
		"parameters": "Paramètres",
		"lowerParameter": "paramètre",
		"lowerParameters": "paramètres",
		"quantity": "Quantité",
		"min": "Min",
		"max": "Max",
		"creation": "Création",
		"update": "Mise à jour",
		"restore": "Restaurer",
		"lastExecution": "Dernière éxécution",
		"nbSites": "Nb sites",
		"nbFilters": "Nb filtres",
		"nbThemes": "Nb thèmes",
		"selectYourTheme": "Sélectionner le(les) thème(s) souhaité(s)",
		"town": "Commune",
		"towns": "Communes",
		"watershed": "Masse d'eau",
		"research": "Recherche",
		"researchs": "Recherches",
		"perimeterSearch": "Recherche par périmètre",
		"namePostcodeInsee": "Rechercher en saisissant le nom, le code postal, ou le code INSEE",
		"clickMapDrawCircle": "Cliquez sur la carte et tracez un cercle à partir de ce point",
		"drawShapeAndDoneArea": "Déssiner la forme que vous souhaitez et la recherche s'effectuera dans la zone que vous avez déssinez",
		"uploadKmlAndSearch": "Uploder un KML et la recherche se fera sur ce KML",
		"kmlSearch": "Recherche par KML",
		"citySearch": "Recherche par commune",
		"title": "Titre",
		"filters": "Filtres",
		"selection": "Sélection",
		"selections": "Sélections",
		"site": "Site",
		"filter": "Filtre",
		"station": "Station",
		"stations": "Stations",
		"nbStation": "Stations",
		"themes": "Thèmes",
		"theme": "Thème",
		"map": "Carte",
		"informations": "Informations",
		"myResearch": "Mes recherches",
		"myInformations": "Mes informations",
		"myCredits": "Mes crédits",
		"credits": "Crédits",
		"credit": "Crédit",
		"simpleCredit": "crédit",
		"simplePlurialCredit": "crédits",
		"saveSelectionPlaceholder": "Saisir le titre de la sélection",
		"radius": "Périmètre",
		"drawing": "Dessin",
		"nbFilter": "Nb filtres",
		"nbTheme": "Thèmes",
		"creationDate": "Création",
		"updateDate": "Mise à jour",
		"lastExecutionDate": "Exécution",
		"executionFunction": "Exécuter",
		"deleteFunction": "Supprimer",
		"deleteSelection": "Supprimer la sélection",
		"informationFunction": "Informations",
		"exportFunction": "Exporter",
		"noData": "Pas de données",
		"noSites": "Pas de sites",
		"noNameSelection": "Pas de nom pour cette sélection",
		"analysis": "Analyse",
		"analyses": "Analyses",
		"lowerAnalysis": "analyse",
		"lowerAnalyses": "analyses",
		"measure": "Mesure",
		"measures": "Mesures",
		"measureMin": "mesure",
		"measuresMin": "mesures",
		"sources": "Sources",
		"source": "Source",
		"nbExport": "Nb d'exports",
		"numberExport": "Nombre d'export",
		"lastExport": "Dernier export",
		"dataAvailable": "Données disponibles",
		"sitesAvailable": "Sites disponibles",
		"noDataAvailableQuality": "Qualité - Aucune donnée disponible",
		"isUpdateData": "",
		"export": "Export",
		"exports": "Exports",
		"minute": "minute",
		"seconde": "seconde",
		"secondes": "secondes",
		"selectionCost": "Coût de la sélection",
		"saveSelection": "Enregistrer la sélection",
		"saveTheSelection": "Sauvegarder votre sélection",
		"expiredDownload": "Téléchargement expiré",
		"insufficientCreditExport": "Crédit insuffisant pour l'export",
		"executionTime": "Temps d'exécution",
		"cancel": "Annuler",
		"executeResearch": "Exécuter la recherche",
		"exportSelection": "Exporter la sélection",
		"graphicView": "Vue graphique",
		"cartographicView": "Vue cartographique",
		"nbWatershed": "Zones hydrographiques",
		"watersheds": "Zones hydrographiques",
		"lowerWatersheds": "zones hydrographiques",
		"hydrographicEntity": "Entité hydrographique",
		"annualChart": "Graphique annuel",
		"historicalChart": "Graphique historique",
		"annualAverageLevels": "Niveaux Moyens Annuels",
		"recharge": "Recharger",
		"indicator": "Indicateur",
		"indicatorMin": "indicateur",
		"indicatorsMin": "indicateurs",
		"population": "Population",
		"selectionLoading": "Chargement de vos sélections",
		"uploadingRepositories": "Chargement des référentiels",
		"loadingKeyFigures": "Chargement des chiffres clés",
		"loadingSelectedStations": "Chargement des stations sélectionées",
		"loadingWatershed": "Chargement des zones hydrographiques",
		"loadingCities": "Chargement des communes",
		"loadingStations": "Chargement des stations",
		"loadingYourFilters": "Chargement de vos filtres",
		"status": "Statut",
		"state": "Etat",
		"annualChronicle": "Chronique annuelle",
		"middleChronicle": "Chronique moyenne",
		"envelope": "Enveloppe",
		"fromNetwork": "Emprise",
		"type": "Type",
		"quality": "Qualité",
		"support": "Support",
		"watershedArea": "Zone hydrographique",
		"lowerWatershedArea": "zone hydrographique",
		"point": {
			"denomination": "Dénomination",
			"code": "Code",
			"localization": "Localisation",
			"city": "Commune",
			"network": "Réseaux",
			"watershed": "Zone hydrographique",
			"samplingPoint": "Point de prélèvement",
			"samplingPoints": "Points de prélèvements",
			"coordinate": "Coordonnées",
			"longitude": "Longitude",
			"latitude": "Latitude",
			"altitude": "Altitude",
			"loading": "Chargement de votre point",
			"sheet": "Fiche du point"
		},
		"question": {
			"executeResearch": "Voulez-vous vraiment exécuter cette recherche ?",
			"exportSelection": "Qu'elles informations voulez vous télécharger ?",
			"deleteSelection": "Voulez-vous vraiment supprimer la sélection ?"
		},
		"information": {
			"updateCredit": "Vous devrez recharger votre crédit afin de pouvoir effectuer cette export",
			"contactAddCredit": "Merci de contacter le service commercial AquaDB pour ajouter du crédit",
			"finalCreditAfterExport": "Votre crédit après l'export sera de",
			"successRequestingCredits": "Votre demande de ${ content } crédits à bien été prise en compte"
		},
		"warning": {
			"pleaseMailInform": "Merci de renseigner un email pour votre compte",
			"noSelectionDeletion": "Aucune sélection sélectionnée pour la suppression",
			"noInformationAvailable": "Aucune informations disponibles",
			"noCodeNoticed": "Aucun code remarque",
			"pleaseSiteSelection": "Merci de sélectionner au moins un site",
			"pleaseTitleInform": "Merci de renseigner un titre",
			"pleaseRecreditAccount": "Merci de recréditer votre compte",
			"pleaseFillLeastFilter": "Merci de renseigner au minimum un filtre",
			"noInformationAvailableMunicipalities": "Aucune information disponible sur ces communes",
			"noDataAvailableSite": "Aucune donnée disponible pour ce site",
			"selectionLimit": "Nombre de sélection limité à 5 dans la version Béta"
		},
		"multi": {
			"last": "Dernières",
			"lastMin": "dernières",
			"saved": "enregistrées",
			"your": "Vos"
		},
		"layersAvailable": "Couches cartographiques disponibles",
		"layerAvailable": "Couche cartographique disponible",
		"noLayerAvailable": "Aucune couche cartographique disponible sur ces thèmes",
		"cartographicLayers": "Couches cartographiques",
		"layers": "Couches",
		"siteTypesAvailable": "Types de points disponibles",
		"stationTypes": "Types de points",
		"points": "Points",
		"last": "Dernière",
		"lastMin": "dernière",
		"lowerSelection": "sélection",
		"lowerSelections": "sélections",
		"saved": "enregistrée",
		"accountInformations": "Informations du compte",
		"mapPreferences": "Préférences cartographiques",
		"description": "Description",
		"reference": "Référence",
		"of": "Du",
		"to": "Au",
		"lowerOn": "sur",
		"proximityPoints": "Points à proximité",
		"unknown": "Inconnu",
		"lastUpdate": "Dernière mise à jour",
		"managementWater": "SAGE",
		"ask": "Demander",
		"myAccount": "Mon compte",
		"finish": "Terminer",
		"next": "Suivant",
		"previous": "Précédent",
		"deletedSites": "sites ont bien été supprimés",
		"notYetRegistered": "Pas encore inscrit ?",
		"aquasysCopyright": "@Aquasys",
		"aquasysContact": "contact@aquasys.fr",
		"contactUs": "Nous contacter",
		"aquasys": "Aquasys",
		"aquaDB": "AquaDB",
		"close": "Fermer",
		"activityArea": "Secteur(s) d'activité",
		"notSpecified": "Non renseigné",
		"geographicalCriteriaResearch": "Saisissez le nom ou le code de la zone géographique recherchée",
		"addNewSelection": "Ajouter une sélection",
		"addNewSelectionSuccess": "Votre sélection a bien été ajoutée. Vous recevrez un mail dès que l'ensemble des données sera téléchargé.",
		"receiveEmailDownloadLink": "Vous allez recevoir un mail avec le lien de téléchargement.",
		"savedSelection": "Votre sélection a bien été enregistrée",
		"deletedSelection": "Votre sélection a bien été supprimée",
		"legend": "Légende",
		"defaultLegend": "Légende par défaut",
		"availableCaption": "Légende disponible",
		"availableCaptions": "Légendes disponibles",
		"availablePoint": "Point disponible",
		"availablePoints": "Points disponibles",
		"selectLayerDisplayLegend": "Sélectionner une couche pour afficher la légende correspondante",
		"comment": "Commentaire",
		"dataHistory": "Historique des données",
		"historical": "Historique",
		"distance": "Distance",
		"displayMore": "Afficher plus",
		"availableCredit": "Crédit disponible",
		"availableCredits": "Crédits disponibles",
		"download": "Téléchargement",
		"exportInProgress": "Génération de l'export en cours",
		"inProgress": "En cours",
		"processDevelopment": "En cours de développement",
		"accepted": "J'accepte",
		"stopDisplaying": "Ne plus afficher",
		"selectData": "Sélectionner les points",
		"filterDataByTheme": "Filtrer les points par thème",
		"display": "Afficher",
		"more": "supplémentaire(s)",
		"displayLayers": "Afficher les couches cartographiques",
		"noNewsToDisplay": "Pas d'actualités à afficher",
		"aquadbTitle": "Téléchargez les données open data sur l'eau et l'environnement en 1 clic!",
		"aquadbDevelopedBy": "Un service développé par",
		"cookie": {
			"description": "En continuant votre navigation sur ce site, vous acceptez l’utilisation de cookies pour mesurer l’audience de nos sites et vous proposer du contenu et des publicités ciblées.",
			"more": "En savoir plus et paramétrer les cookies",
			"moreTitle": "Utilisation de cookies dans l'application",
			"communication": "Communication",
			"statistics": "Statistiques",
			"communicationComment": "En contiuant votre navigation sur ce site, vous acceptez l'utilisation de vos informations à des fins de communication interne Aquasys.",
			"statisticsComment": "En contiuant votre navigation sur ce site, vous acceptez l'utilisation de vos informations afin de permettre la génération de statistiques d'utilisation de l'application."
		},
		"selectByHydrologicArea": "Sélectionner par zone hydrographique",
		"selectByPointType": "Sélectionner par type de point",
		"reflate": "Relancer",
		"mySelections": "Mes sélections",
		"advancedResearch": "Recherche avancée",
		"criteriaLimitBeta": "Pour utiliser plus de critères, créez un compte gratuitement.",
		"alreadyRegistered": "Déjà inscrit ?",
		"loginInSuccess": "Bienvenue ",
		"loginOutSuccess": "Déconnexion réalisée avec succès",
		"department": "Département",
		"departments": "Départements",
		"dataSource": "Source de données",
		"cglu": "CGLU",
		"data": "Donnée",
		"datas": "Données",
		"favorite": "Favori",
		"favoriteFunction": "Favori",
		"favoriteResearch": "Recherche favorite",
		"favoriteResearchs": "Recherches favorites",
		"csvExport": "Exporter ma liste de recherche",
		"addCredit": "Ajout de crédits",
		"selectionExportCredit": "Export de la sélection",
		"saveResearch": "Recherche enregistrée",
		"saveResearchs": "Recherches enregistrées",
		"mapGenerate": "Génération de la carte en cours",
		"dataRecuperation": "Récupération des données"
	};

/***/ },
/* 2219 */
/***/ function(module, exports) {

	module.exports = {
		"signin": "Sign In",
		"signup": "Sign Up",
		"login": "Login",
		"password": "Password",
		"confirmPassword": "Confirm password",
		"validate": "Validate",
		"firstname": "Firstname",
		"lastname": "Lastname",
		"mobile": "Mobile",
		"phone": "Phone",
		"address": "Address",
		"zip": "zip code",
		"city": "City",
		"home": "Home",
		"administration": "Administration",
		"administrativeLimits": "Administrative Limits",
		"administrativeLimit": "Administrative Limit",
		"tutorial": "Tutorial",
		"signOut": "SignOut",
		"connection": "Connection",
		"legalNotice": "Legal Notice",
		"news": "News",
		"forgotPassword": "Forgot Password?",
		"needHelp": "Need help ?",
		"error": {
			"login": "Login",
			"mandatoryTheme": "You can't unselect this theme for the moment",
			"password": "Password",
			"mail": "Mail",
			"captcha": "Captcha",
			"incorrectEmail": "Incorrect Email",
			"notFound": "Page Not Found",
			"nonexistent": "None Existent Station",
			"errorDuringExport": "Error During Export",
			"errorLoadingData": "Error While Loadin Data",
			"noWatershedSelection": "No Watershed Found In Your Selection",
			"pleasePhoneInform": "Please Indicate Your Phone Number",
			"pleaseNameInform": "Please Indicate Your Name",
			"criteriaLimited10": "Number of Criterias Limited to 10",
			"radiusLimited20km": "Possible Radius Limited To 20km (12,42 Miles)",
			"cannotDeleteSite": "Impossible To Delete Your Sites",
			"cannotGetSelection": "Cannot Get Selections",
			"cannotSaveInformation": "Cannot Save Your Information",
			"errorOccurredExportingSelection": "Error Occurred During The Export Of Your Selection",
			"errorRequestingCredits": "Error During Your Credit Request",
			"pleaseFillLeastTheme": "Please Fill At Least One Theme",
			"samePassword": "Password are not the same",
			"thanksContactSupport": "Thank's contact support for more informations.",
			"notAllowToConnect": "You're not allow to connect.",
			"notRegister": "You're not register in own database. Please subscribe.",
			"loginError": "Unauthorized login"
		},
		"mail": "Mail Address",
		"page": "Page",
		"signupSuccess": "Welcome to AquaDB. We have sent you an e-mail so you can finish your registration",
		"findEmailSuccess": "We have sent you an e-mail so you can change your password",
		"name": "Name",
		"save": "Save",
		"success": "Successful",
		"piezometer": "Piezometer",
		"code": "Code",
		"cityid": "City ID Number",
		"nafCode": "NAF Code",
		"icpeScheme": "ICPE Scheme",
		"family": "Family",
		"longitude": "Longitude",
		"longi": "Longi",
		"zoom": "Zoom",
		"fullScreen": "Full Screen",
		"customZoom": "Customized Zoom",
		"latitude": "Latitude",
		"lati": "Lati",
		"numberOfMeasure": "Measure Number",
		"firstDate": "Start Date",
		"openingDate": "Opening Date",
		"closingDate": "Closing Date",
		"lastDate": "Ending Date",
		"lastMeasure": "Last Measure",
		"qualitometer": "Qualitometer",
		"nbOperation": "Operation Number",
		"nbAnalysis": "Analysis Number",
		"numberAnalysis": "Number of Analyses",
		"nbMeasure": "nbMeasure",
		"numberMeasure": "numberMeasure",
		"surfaceQualitometer": "Surface Qualitometer",
		"mostDetectedMolecules": "Most Detected Molecules",
		"pollutedSoil": "Polluted Soil",
		"industrialSite": "Industrial Sites",
		"siteReseach": "Site Search",
		"stationResearch": "Point Search",
		"stationForm": "Station Details",
		"searchLaunch": "Search Launch",
		"advancedSearch": "Advanced Search",
		"element": "Item",
		"elements": "Items",
		"lowerOperation": "Lower Operation",
		"lowerOperations": "Lower Operations",
		"parameters": "Parameters",
		"lowerParameter": "Lower Parameter",
		"lowerParameters": "Lower Parameters",
		"quantity": "Quantity",
		"min": "Min",
		"max": "Max",
		"creation": "Creation",
		"update": "Update",
		"restore": "Restore",
		"lastExecution": "Last Execution",
		"nbSites": "Number Of Sites",
		"nbFilters": "Number Of Filters",
		"nbThemes": "Number of Themes",
		"selectYourTheme": "Select Your Themes",
		"town": "City",
		"towns": "Citys",
		"watershed": "Watershed",
		"research": "Search",
		"researchs": "Search",
		"perimeterSearch": "Search By Perimeter ",
		"namePostcodeInsee": "Search Using Name, ZIP or  INSEE code",
		"clickMapDrawCircle": "Click On Map And Draw A Circle From There",
		"drawShapeAndDoneArea": "Draw A Shape, Search Will Be Performed Within Chosen Area",
		"uploadKmlAndSearch": "Upload KML, Search Will Be Performed On KML",
		"kmlSearch": "Search By KML",
		"citySearch": "Search By City",
		"title": "Title",
		"filters": "Filters",
		"selection": "Selection",
		"selections": "Selections",
		"site": "Site",
		"filter": "Filter",
		"station": "Station",
		"stations": "Stations",
		"nbStation": "Station Number",
		"themes": "Themes",
		"theme": "Theme",
		"map": "Map",
		"informations": "Information",
		"myResearch": "My research",
		"myInformations": "My Information",
		"myCredits": "My Credits",
		"credits": "Credits",
		"credit": "Credit",
		"simpleCredit": "credit",
		"simplePlurialCredit": "credits",
		"saveSelectionPlaceholder": "Put selection title",
		"radius": "Radius",
		"drawing": "Drawing",
		"nbFilter": "Number of Filters",
		"nbTheme": "Number of Themes",
		"creationDate": "Creation Date",
		"updateDate": "Last Update",
		"lastExecutionDate": "Last Date Of Execution",
		"executionFunction": "Process",
		"deleteFunction": "Delete",
		"deleteSelection": "Delete Selection",
		"informationFunction": "Informations",
		"exportFunction": "Export",
		"noData": "No Data",
		"noSites": "No sites",
		"noNameSelection": "No Name For This Selection",
		"analysis": "Analysis",
		"analyses": "Analyses",
		"lowerAnalysis": "Lower Analysis",
		"lowerAnalyses": "Lower Analyses",
		"measure": "Measure",
		"measures": "Measures",
		"measureMin": "measure",
		"measuresMin": "measures",
		"sources": "Sources",
		"source": "Source",
		"nbExport": "Numer Of Exports",
		"numberExport": "Number Of Exports",
		"lastExport": "Last Export",
		"dataAvailable": "Available Data",
		"sitesAvailable": "Sites available",
		"noDataAvailableQuality": "Quality - No Data Available",
		"isUpdateData": "Updated Data",
		"export": "Export",
		"exports": "Exports",
		"minute": "Minute",
		"seconde": "seconde",
		"secondes": "secondes",
		"selectionCost": "Selection cost",
		"saveSelection": "Save the selection",
		"saveTheSelection": "Saved selection",
		"expiredDownload": "Download Expired",
		"insufficientCreditExport": "Insufficient Credit To Allow Export",
		"executionTime": "Execution Time",
		"cancel": "Cancel",
		"executeResearch": "Start Searching",
		"exportSelection": "Export the selection",
		"graphicView": "Graphical View",
		"cartographicView": "Map View",
		"nbWatershed": "Watershed Areas",
		"watersheds": "Watershed Areas",
		"lowerWatersheds": "Lower Watershed Areas",
		"hydrographicEntity": "Watershed Entity",
		"annualChart": "Annual Chart",
		"historicalChart": "Historical Chart",
		"annualAverageLevels": "Mean Annual Levels",
		"recharge": "Reload",
		"indicator": "Indicator",
		"indicatorMin": "indicator",
		"indicatorsMin": "indicators",
		"population": "Population",
		"selectionLoading": "Loading Of Your Selection",
		"uploadingRepositories": "Uploading Of Repositories",
		"loadingKeyFigures": "Loading Key Figures",
		"loadingSelectedStations": "Loading Of Selected Stations",
		"loadingWatershed": "Loading watershed",
		"loadingCities": "Loading cities",
		"loadingStations": "Loading stations",
		"loadingYourFilters": "Loading Of Your Filters",
		"status": "Status",
		"state": "State",
		"annualChronicle": "Annual Chronicle",
		"middleChronicle": "Mean Chronicle",
		"envelope": "Envelope",
		"fromNetwork": "Network Based",
		"type": "Type",
		"quality": "Quality",
		"support": "Support",
		"watershedArea": "Watershed Area",
		"lowerWatershedArea": "watershed Area",
		"point": {
			"denomination": "Name",
			"code": "Code",
			"localization": "Localization",
			"city": "City",
			"network": "Network",
			"watershed": "Watershed Area",
			"samplingPoint": "Sampling Point",
			"samplingPoints": "Sampling Points",
			"coordinate": "Coordinates",
			"longitude": "Longitude",
			"latitude": "Latitude",
			"altitude": "Altitude",
			"loading": "Loading Of Your Points",
			"sheet": "Data Sheet"
		},
		"question": {
			"executeResearch": "Do You Really Want To Perform This Search ?",
			"exportSelection": "What information do you want to download?",
			"deleteSelection": "Do You Really Want To Delete This Selection ?"
		},
		"information": {
			"updateCredit": "You Need More Credit To Perform This Export",
			"contactAddCredit": "Please Contact AquaDB For More Credit",
			"finalCreditAfterExport": "After The Export, Your Remaining Credit Will Be"
		},
		"warning": {
			"pleaseMailInform": "Please Enter An E-Mail",
			"noSelectionDeletion": "No Selection Available To Deleate",
			"noInformationAvailable": "No Information Available",
			"noCodeNoticed": "No Notice Code",
			"pleaseSiteSelection": "Please Select At Least One Site",
			"pleaseTitleInform": "Please Add A Title",
			"pleaseRecreditAccount": "Please Recredit My Account",
			"pleaseFillLeastFilter": "Please Choose At Least One Filter",
			"noInformationAvailableMunicipalities": "No Information Available For These Towns",
			"noDataAvailableSite": "No Data Available For This Site",
			"selectionLimit": "Slection limited 5 for Beta version"
		},
		"multi": {
			"last": "Last",
			"lastMin": "last",
			"saved": "Saved",
			"your": "Your"
		},
		"layersAvailable": "Available Layers ",
		"layerAvailable": "Available Layer ",
		"noLayerAvailable": "No Layer Available For These Themes",
		"cartographicLayers": "Map Layers",
		"layers": "Layers",
		"siteTypesAvailable": "Type Of Points Available",
		"stationTypes": "Station Types",
		"points": "Points",
		"last": "Last",
		"lastMin": "last",
		"lowerSelection": "Lower Selection",
		"lowerSelections": "Lower Selections",
		"saved": "Saved",
		"accountInformations": "Account Informations",
		"mapPreferences": "Map Preferences",
		"description": "Description",
		"reference": "Reference",
		"of": "Of",
		"to": "To",
		"lowerOn": "On",
		"proximityPoints": "Points In The Area",
		"unknown": "Unknown",
		"lastUpdate": "Last Update",
		"managementWater": "Water Management",
		"ask": "Ask",
		"myAccount": "My Account",
		"finish": "Finish",
		"next": "Next",
		"previous": "Previous",
		"deletedSites": "Sites Have Been Deleted",
		"notYetRegistered": "Not Yet Registered ?",
		"aquasysCopyright": "Aquasys Copyright",
		"aquasysContact": "Aquasys Contact",
		"contactUs": "Contact Us",
		"aquasys": "Aquasys",
		"aquaDB": "AquaDB",
		"close": "Close",
		"activityArea": "Activity Area",
		"notSpecified": "Not Specified",
		"geographicalCriteriaResearch": "Enter site name, city or hydrological area code",
		"addNewSelection": "Add A New Selection",
		"addNewSelectionSuccess": "Yor New Selection Has Been Successfully Added, You Will Receive An E-Mail As Soon As Your Selection Has Has Been Downloaded",
		"receiveEmailDownloadLink": "You Will Receive An E-Mail With A link To Download",
		"savedSelection": "Your Selection Has been Saved",
		"deletedSelection": "Your Selection Has been deleted",
		"legend": "Keys",
		"defaultLegend": "Default Keys",
		"availableCaption": "Available Key",
		"availableCaptions": "Available Keys",
		"availablePoint": "Available Point",
		"availablePoints": "Available Points",
		"selectLayerDisplayLegend": "Select A Layer To Display Associated Keys",
		"comment": "Comment",
		"dataHistory": "Data History",
		"historical": "Historical",
		"distance": "Distance",
		"displayMore": "Display more",
		"availableCredit": "Available Credit",
		"availableCredits": "Available Credits",
		"download": "Download",
		"exportInProgress": "Export Process In Progress",
		"inProgress": "In Progress",
		"processDevelopment": "Ongoing Development",
		"accepted": "I Accept",
		"stopDisplaying": "No longer display it",
		"selectData": "Select point",
		"filterDataByTheme": "Filter point by theme",
		"display": "Display",
		"more": "more",
		"displayLayers": "Display map layers",
		"noNewsToDisplay": "No news to display",
		"aquadbTitle": "Download water and environment open data in 1 click!",
		"aquadbDevelopedBy": "A service developed by",
		"cookie": {
			"description": "By Staying On This Web Site You Accept Our Use of Cookies for Measurement And Advertising Purposes",
			"more": "Learn More And Manage Cookies",
			"moreTitle": "How We Use Cookies",
			"communication": "Communication",
			"statistics": "Statistics",
			"communicationComment": "By Continuing On This Site You Accet Our Use Of Information Concerning You for Internal Communication Purposes",
			"statisticsComment": "By Continuing On This Site You Accept Our Use Of Information Concerning You In Order To Generate Statistics "
		},
		"selectByHydrologicArea": "Select by hydrographic area",
		"selectByPointType": "Select by point type",
		"reflate": "Reflate",
		"mySelections": "My selections",
		"advancedResearch": "Advanced research",
		"criteriaLimitBeta": "For more research criteria, please create free account",
		"alreadyRegistered": "Already registered ?",
		"loginInSuccess": "Welcome ",
		"loginOutSuccess": "Logout success",
		"department": "Department",
		"departments": "Departments",
		"dataSource": "Data source",
		"cglu": "CGLU",
		"data": "Data",
		"datas": "Data",
		"favorite": "Favorite",
		"favoriteFunction": "Favorite",
		"favoriteResearch": "Favorite research",
		"favoriteResearchs": "Favorites research",
		"csvExport": "Export research list",
		"addCredit": "Add credit",
		"selectionExportCredit": "Selection export",
		"saveResearch": "Save research",
		"saveResearchs": "Save researchs",
		"mapGenerate": "Map loading",
		"dataRecuperation": "Data recuperation"
	};

/***/ },
/* 2220 */
2218,
/* 2221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(1060);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 2222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(1060);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 2223 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/map_Assainissement2.5b03e348.png";

/***/ },
/* 2224 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/map_cavity.d6ab113a.png";

/***/ },
/* 2225 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/map_fishing_place.66cacf4c.png";

/***/ },
/* 2226 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 2227 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/map_industrial_site.86683283.png";

/***/ },
/* 2228 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 2229 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/map_maregraphe2.24732963.png";

/***/ },
/* 2230 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALQAAADrCAYAAADAFbwQAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAMxAAADMQBATDLXAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAACAASURBVHic7Z13YBzVufafd3ZXXXKVbVQNphhsimNjSbZjUDEG0yEYMJCE5KOFEr4QIB+E4CQkuaQAyb03tMB3aQFMCSUhuEkUF8m4gmXcLe2uLMnqxSqrnXnvH7KErLba3TlzZlbz+8fW7sx5H0mP3j1zynsINiMm7eMN48npnEbQMhmYTMTJzJQMwhQAyQDiCEhgwAVgLAAngKQ+TTCAxj5fNBO4hUAtDLQC1MDMVVDIC6CCNHgUFd7yjXPLsZw0I79Xq0KyBZiR5KKihGh/zBxFoWwGnwnQyQBOBjBekqRWAr5i0HYi3q6Ssqni03O/tE0+ENvQACav3BEf5WovAPOFAM0DMAOAQ7auANQCKCKmtUz+NZ78+QdkCzIDo9bQmStLTmSXdikzXQzQeQBHy9YUHrwTUN4n4n+4c7O2gohlK5LBqDL0iWuKJ3cRLyWmZSBkIWK/f3YzlNcVolfceXNLZasxkgj9hX7DjBWlUc0TWq8G+PsA8mH+roTebCXgFa1Le9l74bx62WJEE7GGTl+1LoUcjpsYdBeANNl65EOdAH+gMT1ZUZC1UbYaUUScoTMKN85npgcAXIzRl41HBIM2EPHvPblZH0RaXztiDJ2xuniBpvCDBLpEthYLsZ8If3BT+4vIzfXLFqMHljd02tqNFxFoOYC5srVYmIPMeNS7LuvvVh/btqyh04u+mEma+jgDS2RriSB2EWi5Oz/rLdlCQsVyhj5x7fpMP5TfAnQdAEW2nkiEgCJWHPd4cs/dKVtLsFjH0EVFzgw19k4mPAYgQbacUYCfGX+NYucvDi6a0yRbzEixhKG7Ry7wDEAzZWsZhVQR6B6rdENMbejkoqKEGI79Ixi3wuRaIx1ivNOpqj+qXjz/iGwtw2Fak6SuKclRCK8APE22FpteasF8l6cg503ZQobCfIYuKnJmaDH3MejX6F5XbGMyGHilU2n/UU1ubqtsLf0xlaFTi4rTFBVvgZAtW4vN8DCwmxXl+orcudtla+mLaYa90lZvPJ80bLHNbA0ImK5o2sb0wuIfyNbSF1Nk6IzC4luZ8V+wuxiWhBnPjalPvLt06QyfbC1SDT1jRWlUy4SWFxi4UaYOGz2gT7tcnddULVxYI1WFrMAT161LjO1wvgXCYlkabHTnoMZ0UUVB1l5ZAqQYOn3VuhQ4nB8BOFtGfBuh1BHx5e68nPUyghtu6PSiL2ZCU1cCSDE6tt4kOB1IiY5CWkw0xrqcSHI6kOT85t9E5/HLsZOcDnRoGnwao8WvQmVGs9+PVlVDZWcnajq7UNXpQ2WnD81+VdJ3pQttTLjGm5f9kdGBDTV02pris4hoDcDJRsYNB4WAjJgYnJEYh9MT4jA9Pg6ZsdFIiYlGklPc/oHDHT6Uth7FzpY27GhuRXFjM9pUS63s9IHpWk9B1ntGBjXM0JmrN8zSFGU1gAlGxQyVU+Jjcd74MThvwljMGZOAeIf8jS+dmoaSxhYU1jWisLYRZe0dsiWNhC4ivtGdl7PCqICGGDqjsHg2M1ZBXqGWgJwSH4vvTEnG5ZMnICUmSracgJS2tuGdyhp8UF2HI74u2XKGQwXzDUZNlws39NSiDdNVTfkcwETRsYIlzqHgqikTce0Jk3B2UrxsOSGhMuPz+ia8WVmDlTUN8LMptwh2KURXludl/Ut0IKGGTlu7IRVQ1hOQKTJOsCRHuXBj6iR8P20KxrmcsuXoxhFfF16rqMb/91ajsct0WwTbWeMl3kU5n4gMIszQaR9vGE8u5TN0l9UyBakxUbhnaiquOSEZTjLFJKkQjqoq3jxcg/8uP4wac3VHmjVFOU/k+g8hv9WTP/ooujN6/FoA80W0HyyTo6NwV2YKlqVMgkuJXCP3p03V8D/eKjzjrjRTxq5gaFne/HkVIhoX8ttNX1v8IoCbRbQdDFGKglvSp+DuqamIc5hmHZbhtPhVPO0+jOfcVfBp8of+GLStU2lbKGL5qe6GzijceA8z/VnvdoMlb8JYLD81E1NjY2RLMQ2H2jrwi71l+LTeDFsE6UPP53Ov0Ltsgq6GzijclM+sfYzuQt9SGO9y4lenTsVlk00/3C2Nj47U45f7ylHZKXdxHIOWe/Ozfqlnm7oZOmXlpnSHU9sGiRMnS5LH47HTpmJilL0KNRDNfhUP7zmE96vrZMrQGHyJNz/n33o1qI+hV6xwpE/IKASwUJf2giTWoeDXp07F0hMsM6NuGj6orsPDe8rQ5Jf20FjvUHh2WW5OmR6N6fKklDEh/RFIMvO0uFh8MGembeYQuWzyBKzKOhNzxiTKkjBe0+jvKCrSpZsa9iKF9LWbFgJ4ARK2cy2ZNB4vnX0aTog2/1S1mUl0OnDVlIlo6PLjy5ajMiSkj2UnN738wifhNhRWl+Pkj4qTOqP5K4AywhUSLHdmpuCBaenm2EMWQbxxuAY/31smY3jPr0A7rzx/3oZwGgkrq3ZG4XdGm9mlEJ44fRoetM0shOtSkvHmrOkYa/ySAKcGx8spH26OC6eRkA2duqYkB4TbwwkeLLEOBS+edRq+c4Lp1jlFFLPHJOLdb50hYdUhT3PG+peH00JISe7Y1PY2AKeHEzwY4o6Zed64pMAX2+hCdacPN+3Yg92tbUaGVYmQ5c7L3hLKzSFl6M6o8Q/DQDMnOR14Y9bptpkNZnJ0FN6YdTqmJ4TVCwgWBzT8LdRRj6ANnbJyUzoI94USLBR6uhnnJNkVdGUw3uXE38+ZjlPiYw2LyYRz0rS4kLqzQRtacWpPADDkT9alEJ6ZeQrmjpU2RmoDYGKUC6+dMx2ZBq6LIfCvUoo2B/2wFJSh09duWkjAd4INEgoKAf894xTkThhrRDibAEyJjsLrs6ZjknHLCsY5VH/Q6zxGbujlrADak8EGCJWfTcvAhcnjjApnMwLSYqLxwlmnIUYxaA6NcFtG4aagNoiMWFn6guJrAHwraFEhcM0Jybg94wQjQtkEydlJ8XhqxjQYtE/Cwaz9KpgbRmbo5ayA6JGQJAXJuWMT8R+nnWhEKJsQWZI8HvedaNjhvFemF5XMGenFIzJ0+oKSpTBgb+BYlxN/OWPaqNomZVXumpqKCyYa0iUkqPzYSC8ObOjlrIAgPDsrBPzljGlIjYkWHcpGBwjA708/yZiFYYTFqUXFI6obHtDQGQuLvwPgjLBFBeC2jBScb49oWIrxLif+MuNkOAzYQa9oeHBE1wW6gDW6P3w5wzM9IQ4/Na5PZqMjWWMTcVemIXU3L8tcvTHg7PSwhk5bvfF8EEbcIQ8FJxH+dPpJdr/ZwtwzNRWnip9JVDQlcHIdPkMr4qe478hMwZmJ1izDZdONSyE8Pv0kA4byaNmUzz4bdmvSkIZOKfziNAIJPRg+MzYG90y1fJloGwCzxyTgu6mTBUfh6Kgu17CHFA1paCdrPx3ufT149JQMRBs162QjnAempQvfcc9Et3XPWg/OoG9MLdo2lsHLxMnqLgRTYMw4po1BJDgc+Inoh3vGiWkLSy4c6u1BDe3XfDdC4Io6JxF+cYqpCpLa6MR1KcmYFif2AZEY3x/qvUENrTD/UJgadK/VOCnOLtEViTiJ8NDJ6aLDXDq1aNugkxYDDJ26piSHCeeIUhKlKLhnaqqo5m1MwKKJ4zBL7IaMGJU7rxrsjQHbXBTiW0QquSFlElL7bL7c0XwUrx8+IjJk0Pzy1EzTP6ya8ee2/NTM3qWld2Sm4NavxB1XSIwbAbw44PW+X8zevNl1pMlfDUDI05qTCJ/nnHOcod+vrsPdpftFhAuZXQvnIEHgCVd68EF1He4y2c+tdOGc3qPsGEBByZfYd7RdVDjNyUg5VJBd3ffF49JQbbN6AQSZGeguO5VqgQN5bMKHANwqdk274ldw8YAX+36hMQvdXnVL+hSRzduYjKsmT8QEkePSjMv7v9Rr6NmbN7uAgRfoRc64JMywp7hHFS6FcPUUoUWBFk1eueM4U/UauqrRvwACuxvXp0wS1bSNiblWbFXYWJez7biqt72GdhCfJypqotNhqQ2vpjzprx9W0Ah0H2j6LYFDeATK7/t1r6GZSJihr5oy0bidwjpwuL1TtoSA1JvruLZhWZoiNEsX9P3CCQBTi4piVA0j2uISClcN049KjYnCxZOMOzG51teFksaWYa+p6fLjNIP0hEqzXx32fYWAi5KNPYl6qLMfL5g4Dg/RIWhiPlbOmrxy/aTqxfOPAMcMrWrxcwFNyFz0xCgXzk4c+iNnzphEQ6vHr6tvwrLtu4e9pk0d3ixmoDNA/WYHEZ6eeYpBaoZnYpQL30pKxOam4RNJiJDL5fg2gHeAY10OYm2WiEgAkDthrFE1HHSjS1Aq0RO/+SUexwUCn6EUDVm9/wcATeAm2DwLbnztZPmHUwbCbwGNfVkscKkwUz9DE4mruZFlwUKLdobWnxPjYjBFXMmD2T3ld3uGHoQYekp0lCXPDOwywfHBgbBahgYgcvguPk2NPQMAlMzPNp8AQEi/YKZFZwa72PzpTzW/xAGcM0bgklKFZgKAoqmqsMXJMxMNrfyuG1boQ3dZQGN/zhaY4EjjbkOTpglbEjU93pqG9lugD61az89idykdew5UwIqwOgJpsdasU+ezgKH9FugW9WdSdBRiHaJmjOmYoRUWZuh0qxZeNKBWW9hYQGJ/CN1F08XAmSgqcioMCKkOEu9wYJzxhzfqgssCZrHOypjjEXhOi3MqYtIUCBrhSLPwzhQHmd8uDotaOlngMK7fj6kKMYTMfEyy8IHyTitkaMV6fWgAQo9cVkjJVBgQMjg4xmnN7gYAOC2QocmKnWhAaDeUgVQFggydZPJd08Mh7EFcRxTb0AMhThZm6DEu6xraEl0OC2gcjESHOF8QkUBDW7jLQWx+t7AFx6EBIErgXyIzT1IAEvLYaaUtV/2xglVUS6gciEusLyYoAAtJpUYcJCMKpyU+z62gcSAugb5gIE4BIKRTY2VDx1rg08WqP99ogcmCwHEKBinYqAcOa/68AcD0de0AsZlOJGKXvVKcApCdofvRboGlbO2a+TfyDobgteZxwvrQVtjGNBQNXX7ZEgJS7zO/xsEItFs9PMihQNA6l3YLbGMaioau0Iq4MIDixuYRXasxsClAfZDhaLTAH91giE50CgAhzrNCbYuhqO9jlnerarFg43ZsaWoNeN+rFdVYtm03Vtc2BLz20X1luGnHbuwfQf3k59yVyC3egQNtHb2vNfitaWixGZpZmKE7LJyhqzp9AIA3Dtfgvq8Pwt3eidt37ut9fTC+bm3DY/vd8DPjzp37sbFh6Ez9xCEvXvJWo13VcPeuA2gbps++prYBvz3gxoG2Dizdugtft7ZBY6B6GC1mplHsHyIrAISk0qN+6xq6pLEFd5Xux4O7D0I99hBT3enDsu278XVr24DrNzY048btu3sfJjs0Dd/bsQfvVtUed12HpuHhPWV46lBF72ulLUdx85d7UDmIQf9RVYsf7dzfW0KrxteFq7fswoO7Dw77R2BmBD+fqE4IytBHfNbMIEB3/bsPqusGvL7/aDuWfLET2WMTMSMxHn5mbG9qxbbm1gHzdh2ahnt3HcBz7kpkj0tCm6pidW0j6gYpsrixoRkLN+7AeePHYFp8DNpUDevqm3GgbWB3pFVV8WZljV7fquEIfpg96iRBQ4PVndapjhkMKjPWNzRj/TBdir7sam3DrkGyen86NQ2rahuA2oCXWhqxXQ5qVRgQEmG4/qbN6EVs359bhfWhj/i6LLp8xkYk5e0dgS8KnVaFgaMiWvZpGg53mL9wuI1x+DRt0IdfvWBwg0KCDA0ApSPoO9qMHjwdnaKKngMAFChVChgje7oJgdIW29A237DvqNDuBpi0IwoUBJ4CC5HSFmHJ38aCbGsWUsG/FwKqFTALi7KluVXoR4yNtdjeLDbBsYZqhUHCMnSdrws7W+0sbdNdi+9LwYbWHFSuEDBwSkxHPqlrFNm8jUXY3NSCo4IXrPl96kGFiQ6LDFJU1ySyeRuLsKom8ArEMGmtXjz/iAKgIuClYbC9udWya3dt9GN1rfBP6kMAoEDVhGZolRkrR7A+2CZy2d3aJnqGEAAOAIACJqEZGgDetvDqMJvw+XdNvfAYRLwXAJQujhWaoYHurUYeC5yfbaM/GgMrKg1YQsi0EwCU6sVnHwXgFRoLwLvVEb4u0mZQ1jc0ocKANT2qonwFfLNB9ivRAd+prLVX341CVhjT3VRdOLob6D3rGztFRyxr70Ch+CddGxNR3+XHx+KH60DA/rLc3A6gJ0MrJNzQAPCsu9KIMDYm4SVvteBd3t0wsK3n/8cytGaIoYsbm7G1WdhMu42JaFc1vOytNiQWgzf0/F8BgIS6pJ0ADFnr+bydpUcFKyprUBdiwZ5gIXYU9/xfAYDSpTN8DN5oRPCPaxoG3c1sEzn4mfG8x7DE1Z5UH7+j54veMmBE9KkR0VVm/G6/x4hQNpJ4teII3MbNO2wuXTqjd1/XN4ZWUWSUglW1DSgJo66bjXk5qqr4S5nwyec+0Gd9v+o1dGJD4iYI3F/Yn9/sd9vj0hHIc+5K1A5STEcctKrvV72GLl06w8eMT4ySsb25FR8OUp3IxrpUd/rwvLvKsHgEtEwaoxz37HdcKV0iftswNQB+ua8cTRatomkzkEf3lqPVwKqzzCjcMmfOcR8HxxnaocS8B8Cwkkc1vi48ts9tVDgbgaypbcBHBqyq68fq/i8cZ+iy3FmNzAMvEsmKyhp8Vm/varEy7aqGR/eVGx2WVXZ+2P/FAdX7FdBbxujphgE8tOeQZcvD2gCP7XfLWB684fCiOQM+3gcY2smO92DQrGEP7vZOPLK3zMiQNjqxurYBr1YYM8XdF2IMmngHGPrgojlNAN4Urqgfb1XW4C17Z4ulqOr04f6vD8oYftU00gYdwBj0wCAmflasnsH5+d4y7BnBmSM28tEYuHfXgePOozGQdd78eYPO3gxqaG9eTgmDtg32nkjaVQ23f7VPeP0Gm/B5/KAbG0ZY9F1viOiFod4b8kg3Ap4TI2d4DrS140c798Mv9oBGmzB4t6oWT5dLWzXZ5D/qGHK+ZEhDt0d3vQaIq0w6HEV1jfZDoknZ2tyKB3cfkqiAXzl86ZwhBy2GNHTtggUtkJSlAeC1iiP4a7nwDek2QVDe3oFbvtxryC6UoWCm54d7f9hTZBnaUzBw5rA/jx/wDDgazUYOVceOtasxdOHRAD73FmR/OdwFwxramz+vAoxX9dU0chjAfV8ftE0tmfouP27Yvlt6bRVi+n2gawKe860w/xGCzjIcCSqzbWqJNHb58d3tu7FP/nBqqTt/7r8CXRTQ0OWLcr4GY8CcuZH0mPptIyrw2PRS6+vCddu+xpcmOImBiH4PooBDXwENDQCaA/8RvqTwUJlx/+6DeNFj3Hrb0YynvRNXbtk1okNDDcCbWJvwxkguHJGhK3KziwH8OyxJOqAyY/m+cvxib1nvGdw2+lPa2oart+4yomLoCKHf9N03OBwjMjQAEOERwBy7pv7HW43v79iDVr89o6g3a2sbcc3WXeY5CZhwKKku4cWRXj5iQ7vzsreA8UFoqvTn0/omXLN1F8pMk0WsDQN46lAFfvCluRIFa/zISLMzEIShAUBT6FGYJEsD3R+NS77Yae9NDJOGLj9u/WovnjjkNc8vt5uvvOuyXw/mBgo2Qvra4hUArgn2PtEsS5mE5admIkYZ/m/UzzxqFj+NcToDXrOhoRn37jpgni5GH4jpUndB1j+DuifYIOlr108DnKUARwd7r2imJ8ThD9NPwtlJ8bKlmJ4ujfHHQ1486z5syrMkCfjInZ99cbD3BdXlAABP/vwDDDwV7H1GsLu1DZdv2Ymf7T5k6O5jq/FFYwsu+uIrPF1uTjMD8KlM/zeUG4PO0AAwcd26xNgO5x4QTgjlfiOYHB2FX586FRcmj5MtxTQ0+f144mAFXqqoMquRj0G/8eRn/TykO0MNmbam5IdE/LdQ7zeKvAlj8bNp6ZieECdbijR8moZXKo7gP8sqZO0wCQJ2q22u04dbIjocIRsay1lJ/3bJJgCzQ27DIBQCrpoyEfedmI7UmCjZcgxDZcY/qurwp0NeQ8450QXCFZ687PdDvz0MMgqLZzOjGEDgx2kTEK0oWJYyCf8nfQrSY033TKsbPk3DP6rr8Jy70gyLioLhdU9+9rJwGgjL0ACQUbjxcWZ6INx2jEQhIHfCWNyZmYI5YxJly9GNFr+Ktypr8Iy70pTDcAGo9fnVGdWL5x8Jp5GwDZ22YUMstSs7AJwSblsymD0mEctSknHRpPFIcDhkywkalRmf1TfhnaparKppQIfE3SThQMTXuvNyVoTdjh5i0lZvPJ8UKtSrPRnEOhQsnjgOV06ZiG+PHwMnmfdbUZmxtakVK2sb8F5VLY7I3UWiB+968rOv1qMh3X5raWuKnyXCrXq1J5MJUS6cN34Mzp8wFt8en4QJLpdsSTji68KGhmasrW3Ap/VNaDT9aMWIqepy+c6qWrhQlypDuhk6uagoIUaL3QLgVL3aNAMKATMT4rFg/Bick5SAMxPjhY+UVHT4sO9oG/YcbcdXLUexpanVOqMUwcEgusiTl7VSrwZ1/Vw9NuqxAUBEj41NcLlwZlI8zkiIQ1pMNFJiojA5OgqJDgcSnQ7EOxzY19aO6k4f6n1+EAGJTgdOiI5GolNBfZcfDT4/6ru6UOvrQmWnD94OHyo6OuFp7xxFs5z8pCc/5yd6tqh7RzGtsOR+Yg64mdFmtMM7HUrHuT0nwOpF0Gs5AuH9bO6fMEghahubPrQpGpbqbWZAgKGxnDTF5fweQHYpUZtBIaI7yhflfC2ibf0NDaB84ZxKBbgOQMQ8itvoBT/jzst6WVTrQgwNAOX5WYXM9LCo9m2sBzG2cyzr+hA4IIbIxsFM6YWb3gB4qdA4NlagQfHT7PLFWUIrPQrL0AAAIu5Q2n4IoFRoHBuzozH4BtFmBkQbGkBNbm4rq7gSQKPoWDbmhAg/9+bnGFLXxbAFC5mFJRdrzO8DsN4KIJsw4L978rJvHEkZLz0QnqF7KM/L+heI7jcqno0p2Kq2uW4xysyAhNVx6YXF/wXGnUbHtTGcKk3BuRW52V4jgxqWoXvw1Lp/zOCgai3YWI4OJr7CaDMDktYvn7R685guxb8ewAwZ8W2EwmC+3lOQY/hZl4CEDA10H+7pUPgSAMYfQWojFAIekmXmY/HlkVa4MYuYCgGM3hoDEQQznvMWZN8mU4OUDN2DNy+nRCFaCnvNh/VhrPQ62qU/7Es1NNA9nMeMm2GiqqY2wcI7Xey8Frm50hOTdEMDgLcg+1VmLJetwyYECB5NoYsOLprTJFsKYLJd2ulrN/4nQHfJ1mEzYmoVjReKWtscCqbI0D146jz3AnhXtg6bwBDQAoUuMpOZAZNlaOBY4ZoOZRUYC2RrsRkSH4BLPfnZq2QL6Y+pMjQAeOfNa3epzkuIsV22FptBUYlxgxnNDJjQ0ED3xEunqi4GsFe2FpvjYGa6zV2Q/bZsIUNhSkMDQPXi+UeIHReBUSlbi003TPSgtyDrBdk6hsO0hgYAd8G5B+FwXACgXraWUQ/jd968rD/IlhEI0z0UDsaxKfI1ABJkaxmVEL/kyc2+2ch1zaFi6gzdgzcvp4RIuQKgiCzwZnLe89R6fmgFMwMWMTQAuPPmrgXbtT6MhIHC6M7667B0qWWK7Vmiy9GXjMLiW5nxDCyo3WKUdCjtBTW5ua2yhQSDZTJ0D+687OcIeEi2jginVGO62GpmBiyc5ax4tos1YLfqdyw4vHiuR7aSULCsocFMGYUlzzJwi2wpkQIDRzRyLDycd+4e2VpCxXJdjl6I2F3nvgPAW7KlRAhNrCiLrWxmwMqGBoClS9WkusQbQfSxbCkWp400XFKRO9fy62es2+XoQ8qHm+Mccf5VAObL1mJBfMza5d6CeRGRFCLC0AAwtWjbWFXr/ATA2bK1WAiVQNe787Mipttm7S5HH8pyZzVC9S8BQXiFywiBGXx7JJkZiCBDA4DnggWHweoiAFWytViAB7z5OX+TLUJvIsrQAODJn3+ANe0CAA2ytZgWxq89+dl/lC1DBBHTh+5PalFxtqJhDYB42VpMBeOvnoJs6fUzRBFxGbqHitzsYmJcaa/Q+wYies2zLutu2TpEErGGBgB3QfZqJvwAgCZbi3SIPk5OctyM5RTRP4uI7XL0JWNN8Y+Z8JRsHbIgxva2GP/C2gULWmRrEU1EZ+ge3AXZfwb4Sdk6JHHYryqXjQYzA6PE0ADg+Tz7pwyYdreyCAho0RTlYquunAuFUWNoLCfNqbTfBGC9bCkGoQJ8QySszwiG0WNoAGW5uR0a0+UEWHpF2cjgu935OR/KVmE0o8rQAFBRkFVHfroIkXx6APFvPfk5T8uWIYNRZ2gAKF+cdQgKXQLgqGwt+kMrPJ9lPyJbhSxGpaEBwJObtZmYrgNgmR3NASGscyht34v0sebhGBXj0MORsabkNiZ+RraO8KEDXa7OnKqFC2tkK5HJqM3QPbgLsp4F8CfZOsKkFvAvHu1mBmxDAwA8n2c9QIx3ZOsIkS7W+BpP/vwDsoWYAdvQALCcNC1OuwnAVtlSgoVBP/EuyvlEtg6zMOr70H05ce36TD+cXwCcLFvLiGC87CnI/p5sGWbCztB9OJQ/v5yIrocV6ucxiqN99bfKlmE2bEP3w503dy0B98vWEYBqaP6r9y9ZYq/17ofd5RiCjDXFbzPhatk6BkEjxoXuguzVsoWYETtDD0FbjP9mmPCMFwb9yjbz0NiGHoLaBQtatO5zyNtla+mBgCJvXfljsnWYGdvQw1CRl7WDwQ/K1nGMKgfjeisVH5eB3YcORHeV038ysESuClzizcv+SKIGS2Bn6EAQMav+WwDUydOAv9pmHhm2oUeA54IFh5lY0pgvHeigTnwuHAAAAWZJREFU9p/JiW09bEOPEG9ezrswvha1n6Eus+LRELKwDR0EDkW5B8aWGPuzN3/eJgPjWR7b0EFQlju3iggGffyzu0NpX25MrMjBNnSQuHOznmegUHggwt12VyN4bEMHCxEz0x0QOOFCjHc8eTkfiGo/krENHQIVBVl7AfxCUPONGmk/FtR2xGMbOkQ8de4nwSjWu11iutebP69C73ZHC/ZMYRhkriw5UXPyFgDj9GmRPvTkZ12mT1ujEztDh0H54qxDxPRdAKxDc3sdStR3dWhnVGMbOkzcBVn/BOi3YTbT5FC0y8tyZzXqImoUYxtaBzx5cx8B8Qsh3t6gQFtSljtvt66iRim2ofWAiD3UcTsDrwR3I7uJsaA8f94GMcJGH/ZDoc5krCm5TSP+fwRkDnOZBsLTLtX58MFFc5oMEzcKsA0tghUrHGkTM64gxiUAZgNIB6MdhEoCf0ga3ixflPO1bJmRyP8CIN+E1FGJYH4AAAAASUVORK5CYII="

/***/ },
/* 2231 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/map_pluvio2.0985ed8a.png";

/***/ },
/* 2232 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/map_polluted_soil.ae977325.png";

/***/ },
/* 2233 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/map_quality2.48120b77.png";

/***/ },
/* 2234 */
/***/ function(module, exports) {

	module.exports = "data:image/gif;base64,R0lGODlhEAAQAIQWABMAExoAGiYAJi0ALTMAMxQOEjkAORsOGUAAQE0ATWAAYGYAZikpJTc2MUVEPlJSS21sYm1tY3t6b4mIe6SjlLKxof///////////////////////////////////////yH+EUNyZWF0ZWQgd2l0aCBHSU1QACH5BAEKAB8ALAAAAAAQABAAAAVO4PdNTGCe5vGIXzMoSyzLSPFBxKzLSXPswEVAENwZcsVZApmMLZs8ZvMJXSQGVSsgS3AkoIpD5QArKgSSD6VASLjfbsNhwhpF7vg7XRQCADs="

/***/ },
/* 2235 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Step1.df69ad09.jpg";

/***/ },
/* 2236 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Step2.b1896c98.jpg";

/***/ },
/* 2237 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Step3.c87cf884.jpg";

/***/ },
/* 2238 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Step4.08010599.jpg";

/***/ },
/* 2239 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Step5.73290362.jpg";

/***/ },
/* 2240 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Step6-bg.a86711c9.jpg";

/***/ },
/* 2241 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Step6.89dde63f.png";

/***/ },
/* 2242 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 2243 */
518,
/* 2244 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var createReactClass = __webpack_require__(104)
	var objectAssign = __webpack_require__(32)
	var hoistNonReactStatics = __webpack_require__(2243)
	
	var createReactTimeout = function (React) {
	  var GLOBAL = typeof window === 'undefined' ? global : window
	
	  var setter = function (_setter, _clearer, array) {
	    return function (callback, delta) {
	      var optionalArguments = Array.prototype.slice.call(arguments, 2)
	      var id = _setter(function () {
	        _clearer.call(this, id)
	        if (typeof callback === 'function') {
	          callback.apply(this, optionalArguments)
	        }
	      }.bind(this), delta)
	
	      if (!this[array]) {
	        this[array] = [id]
	      } else {
	        this[array].push(id)
	      }
	      return id
	    }
	  }
	
	  var clearer = function (_clearer, array) {
	    return function (id) {
	      if (this[array]) {
	        var index = this[array].indexOf(id)
	        if (index !== -1) {
	          this[array].splice(index, 1)
	        }
	      }
	      _clearer(id)
	    }
	  }
	
	  var _timeouts = '_ReactTimeout_timeouts'
	  var _clearTimeout = clearer(GLOBAL.clearTimeout, _timeouts)
	  var _setTimeout = setter(GLOBAL.setTimeout, _clearTimeout, _timeouts)
	
	  var _intervals = '_ReactTimeout_intervals'
	  var _clearInterval = clearer(GLOBAL.clearInterval, _intervals)
	  var _setInterval = setter(GLOBAL.setInterval, function () {}, _intervals)
	
	  var _immediates = '_ReactTimeout_immediates'
	  var _clearImmediate = clearer(GLOBAL.clearImmediate, _immediates)
	  var _setImmediate = setter(GLOBAL.setImmediate, _clearImmediate, _immediates)
	
	  var _rafs = '_ReactTimeout_rafs'
	  var _cancelAnimationFrame = clearer(GLOBAL.cancelAnimationFrame, _rafs)
	  var _requestAnimationFrame = setter(GLOBAL.requestAnimationFrame, _cancelAnimationFrame, _rafs)
	
	  var cloneArray = function (a) {
	    return (!a || typeof a.slice !== 'function') ? [] : a.slice(0)
	  }
	
	  var ReactTimeout = function (SourceComponent) {
	    var Component = createReactClass({
	      displayName: 'ReactTimeout',
	
	      setTimeout: _setTimeout,
	      clearTimeout: _clearTimeout,
	
	      setInterval: _setInterval,
	      clearInterval: _clearInterval,
	
	      setImmediate: _setImmediate,
	      clearImmediate: _clearImmediate,
	
	      requestAnimationFrame: _requestAnimationFrame,
	      cancelAnimationFrame: _cancelAnimationFrame,
	
	      componentWillUnmount: function () {
	        cloneArray(this[_timeouts]).forEach(this.clearTimeout)
	        cloneArray(this[_intervals]).forEach(this.clearInterval)
	        cloneArray(this[_immediates]).forEach(this.clearImmediate)
	        cloneArray(this[_rafs]).forEach(this.cancelAnimationFrame)
	      },
	
	      getWrappedInstance: function () {
	        return this.wrappedInstance;
	      },
	
	      render: function () {
	        return React.createElement(
	          SourceComponent,
	          objectAssign(
	            {},
	            this.props,
	            {
	              ref: function (component) { this.wrappedInstance = component; }.bind(this),
	              setTimeout: this.setTimeout,
	              clearTimeout: this.clearTimeout,
	
	              setInterval: this.setInterval,
	              clearInterval: this.clearInterval,
	
	              setImmediate: this.setImmediate,
	              clearImmediate: this.clearImmediate,
	
	              requestAnimationFrame: this.requestAnimationFrame,
	              cancelAnimationFrame: this.cancelAnimationFrame
	            }))
	      }
	    })
	    return hoistNonReactStatics(Component, SourceComponent)
	  }
	
	  return ReactTimeout
	}
	
	module.exports = createReactTimeout
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2245 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(2)
	var createReactTimeout = __webpack_require__(2244)
	
	module.exports = createReactTimeout(React)


/***/ },
/* 2246 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _addClass2 = _interopRequireDefault(__webpack_require__(1446));
	
	var _removeClass = _interopRequireDefault(__webpack_require__(1448));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _Transition = _interopRequireDefault(__webpack_require__(550));
	
	var _PropTypes = __webpack_require__(1064);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var _addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass2.default)(node, c);
	  });
	};
	
	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass.default)(node, c);
	  });
	};
	/**
	 * A transition component inspired by the excellent
	 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
	 * use it if you're using CSS transitions or animations. It's built upon the
	 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
	 * component, so it inherits all of its props.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` states of the transition. The first class is applied and then a
	 * second `*-active` class in order to activate the CSS transition. After the
	 * transition, matching `*-done` class names are applied to persist the
	 * transition state.
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
	 *         <div>
	 *           {"I'll receive my-node-* classes"}
	 *         </div>
	 *       </CSSTransition>
	 *       <button type="button" onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the `in` prop is set to `true`, the child component will first receive
	 * the class `example-enter`, then the `example-enter-active` will be added in
	 * the next tick. `CSSTransition` [forces a
	 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * between before adding the `example-enter-active`. This is an important trick
	 * because it allows us to transition between `example-enter` and
	 * `example-enter-active` even though they were added immediately one after
	 * another. Most notably, this is what makes it possible for us to animate
	 * _appearance_.
	 *
	 * ```css
	 * .my-node-enter {
	 *   opacity: 0;
	 * }
	 * .my-node-enter-active {
	 *   opacity: 1;
	 *   transition: opacity 200ms;
	 * }
	 * .my-node-exit {
	 *   opacity: 1;
	 * }
	 * .my-node-exit-active {
	 *   opacity: 0;
	 *   transition: opacity 200ms;
	 * }
	 * ```
	 *
	 * `*-active` classes represent which styles you want to animate **to**, so it's
	 * important to add `transition` declaration only to them, otherwise transitions
	 * might not behave as intended! This might not be obvious when the transitions
	 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
	 * the example above (minus `transition`), but it becomes apparent in more
	 * complex transitions.
	 *
	 * **Note**: If you're using the
	 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
	 * prop, make sure to define styles for `.appear-*` classes as well.
	 */
	
	
	var CSSTransition = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    _this.appliedClasses = {
	      appear: {},
	      enter: {},
	      exit: {}
	    };
	
	    _this.onEnter = function (maybeNode, maybeAppearing) {
	      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
	          node = _this$resolveArgument[0],
	          appearing = _this$resolveArgument[1];
	
	      _this.removeClasses(node, 'exit');
	
	      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(maybeNode, maybeAppearing);
	      }
	    };
	
	    _this.onEntering = function (maybeNode, maybeAppearing) {
	      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
	          node = _this$resolveArgument2[0],
	          appearing = _this$resolveArgument2[1];
	
	      var type = appearing ? 'appear' : 'enter';
	
	      _this.addClass(node, type, 'active');
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(maybeNode, maybeAppearing);
	      }
	    };
	
	    _this.onEntered = function (maybeNode, maybeAppearing) {
	      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
	          node = _this$resolveArgument3[0],
	          appearing = _this$resolveArgument3[1];
	
	      var type = appearing ? 'appear' : 'enter';
	
	      _this.removeClasses(node, type);
	
	      _this.addClass(node, type, 'done');
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(maybeNode, maybeAppearing);
	      }
	    };
	
	    _this.onExit = function (maybeNode) {
	      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
	          node = _this$resolveArgument4[0];
	
	      _this.removeClasses(node, 'appear');
	
	      _this.removeClasses(node, 'enter');
	
	      _this.addClass(node, 'exit', 'base');
	
	      if (_this.props.onExit) {
	        _this.props.onExit(maybeNode);
	      }
	    };
	
	    _this.onExiting = function (maybeNode) {
	      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
	          node = _this$resolveArgument5[0];
	
	      _this.addClass(node, 'exit', 'active');
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(maybeNode);
	      }
	    };
	
	    _this.onExited = function (maybeNode) {
	      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
	          node = _this$resolveArgument6[0];
	
	      _this.removeClasses(node, 'exit');
	
	      _this.addClass(node, 'exit', 'done');
	
	      if (_this.props.onExited) {
	        _this.props.onExited(maybeNode);
	      }
	    };
	
	    _this.resolveArguments = function (maybeNode, maybeAppearing) {
	      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
	      : [maybeNode, maybeAppearing];
	    };
	
	    _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	      var isStringClassNames = typeof classNames === 'string';
	      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
	      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
	      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
	      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
	      return {
	        baseClassName: baseClassName,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    };
	
	    return _this;
	  }
	
	  var _proto = CSSTransition.prototype;
	
	  _proto.addClass = function addClass(node, type, phase) {
	    var className = this.getClassNames(type)[phase + "ClassName"];
	
	    var _this$getClassNames = this.getClassNames('enter'),
	        doneClassName = _this$getClassNames.doneClassName;
	
	    if (type === 'appear' && phase === 'done' && doneClassName) {
	      className += " " + doneClassName;
	    } // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	
	
	    if (phase === 'active') {
	      /* eslint-disable no-unused-expressions */
	      node && node.scrollTop;
	    }
	
	    if (className) {
	      this.appliedClasses[type][phase] = className;
	
	      _addClass(node, className);
	    }
	  };
	
	  _proto.removeClasses = function removeClasses(node, type) {
	    var _this$appliedClasses$ = this.appliedClasses[type],
	        baseClassName = _this$appliedClasses$.base,
	        activeClassName = _this$appliedClasses$.active,
	        doneClassName = _this$appliedClasses$.done;
	    this.appliedClasses[type] = {};
	
	    if (baseClassName) {
	      removeClass(node, baseClassName);
	    }
	
	    if (activeClassName) {
	      removeClass(node, activeClassName);
	    }
	
	    if (doneClassName) {
	      removeClass(node, doneClassName);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        _ = _this$props.classNames,
	        props = _objectWithoutPropertiesLoose(_this$props, ["classNames"]);
	
	    return /*#__PURE__*/_react.default.createElement(_Transition.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react.default.Component);
	
	CSSTransition.defaultProps = {
	  classNames: ''
	};
	CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
	  /**
	   * The animation classNames applied to the component as it appears, enters,
	   * exits or has finished the transition. A single name can be provided, which
	   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
	   *
	   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
	   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
	   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
	   *
	   * A few details to note about how these classes are applied:
	   *
	   * 1. They are _joined_ with the ones that are already defined on the child
	   *    component, so if you want to add some base styles, you can use
	   *    `className` without worrying that it will be overridden.
	   *
	   * 2. If the transition component mounts with `in={false}`, no classes are
	   *    applied yet. You might be expecting `*-exit-done`, but if you think
	   *    about it, a component cannot finish exiting if it hasn't entered yet.
	   *
	   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
	   *    allows you to define different behavior for when appearing is done and
	   *    when regular entering is done, using selectors like
	   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
	   *    an epic entrance animation when element first appears in the DOM using
	   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
	   *    simply use `fade-enter-done` for defining both cases.
	   *
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  appearDone: 'my-done-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * If you want to set these classes using CSS Modules:
	   *
	   * ```js
	   * import styles from './styles.css';
	   * ```
	   *
	   * you might want to use camelCase in your CSS file, that way could simply
	   * spread them instead of listing them one by one:
	   *
	   * ```js
	   * classNames={{ ...styles }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  appearDone?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: _propTypes.default.func
	}) : {};
	var _default = CSSTransition;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 2247 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(51));
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(1062));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	/**
	 * The `<ReplaceTransition>` component is a specialized `Transition` component
	 * that animates between two children.
	 *
	 * ```jsx
	 * <ReplaceTransition in>
	 *   <Fade><div>I appear first</div></Fade>
	 *   <Fade><div>I replace the above</div></Fade>
	 * </ReplaceTransition>
	 * ```
	 */
	var ReplaceTransition = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(ReplaceTransition, _React$Component);
	
	  function ReplaceTransition() {
	    var _this;
	
	    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
	
	    _this.handleEnter = function () {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _this.handleLifecycle('onEnter', 0, args);
	    };
	
	    _this.handleEntering = function () {
	      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      return _this.handleLifecycle('onEntering', 0, args);
	    };
	
	    _this.handleEntered = function () {
	      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	
	      return _this.handleLifecycle('onEntered', 0, args);
	    };
	
	    _this.handleExit = function () {
	      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	        args[_key5] = arguments[_key5];
	      }
	
	      return _this.handleLifecycle('onExit', 1, args);
	    };
	
	    _this.handleExiting = function () {
	      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	        args[_key6] = arguments[_key6];
	      }
	
	      return _this.handleLifecycle('onExiting', 1, args);
	    };
	
	    _this.handleExited = function () {
	      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        args[_key7] = arguments[_key7];
	      }
	
	      return _this.handleLifecycle('onExited', 1, args);
	    };
	
	    return _this;
	  }
	
	  var _proto = ReplaceTransition.prototype;
	
	  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
	    var _child$props;
	
	    var children = this.props.children;
	
	    var child = _react.default.Children.toArray(children)[idx];
	
	    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
	
	    if (this.props[handler]) {
	      var maybeNode = child.props.nodeRef ? undefined : _reactDom.default.findDOMNode(this);
	      this.props[handler](maybeNode);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        inProp = _this$props.in,
	        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);
	
	    var _React$Children$toArr = _react.default.Children.toArray(children),
	        first = _React$Children$toArr[0],
	        second = _React$Children$toArr[1];
	
	    delete props.onEnter;
	    delete props.onEntering;
	    delete props.onEntered;
	    delete props.onExit;
	    delete props.onExiting;
	    delete props.onExited;
	    return /*#__PURE__*/_react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
	      key: 'first',
	      onEnter: this.handleEnter,
	      onEntering: this.handleEntering,
	      onEntered: this.handleEntered
	    }) : _react.default.cloneElement(second, {
	      key: 'second',
	      onEnter: this.handleExit,
	      onEntering: this.handleExiting,
	      onEntered: this.handleExited
	    }));
	  };
	
	  return ReplaceTransition;
	}(_react.default.Component);
	
	ReplaceTransition.propTypes =  false ? {
	  in: _propTypes.default.bool.isRequired,
	  children: function children(props, propName) {
	    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
	    return null;
	  }
	} : {};
	var _default = ReplaceTransition;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 2248 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.modes = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _Transition = __webpack_require__(550);
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(551));
	
	var _leaveRenders, _enterRenders;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function areChildrenDifferent(oldChildren, newChildren) {
	  if (oldChildren === newChildren) return false;
	
	  if (_react.default.isValidElement(oldChildren) && _react.default.isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) {
	    return false;
	  }
	
	  return true;
	}
	/**
	 * Enum of modes for SwitchTransition component
	 * @enum { string }
	 */
	
	
	var modes = {
	  out: 'out-in',
	  in: 'in-out'
	};
	exports.modes = modes;
	
	var callHook = function callHook(element, name, cb) {
	  return function () {
	    var _element$props;
	
	    element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
	    cb();
	  };
	};
	
	var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function (_ref) {
	  var current = _ref.current,
	      changeState = _ref.changeState;
	  return _react.default.cloneElement(current, {
	    in: false,
	    onExited: callHook(current, 'onExited', function () {
	      changeState(_Transition.ENTERING, null);
	    })
	  });
	}, _leaveRenders[modes.in] = function (_ref2) {
	  var current = _ref2.current,
	      changeState = _ref2.changeState,
	      children = _ref2.children;
	  return [current, _react.default.cloneElement(children, {
	    in: true,
	    onEntered: callHook(children, 'onEntered', function () {
	      changeState(_Transition.ENTERING);
	    })
	  })];
	}, _leaveRenders);
	var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function (_ref3) {
	  var children = _ref3.children,
	      changeState = _ref3.changeState;
	  return _react.default.cloneElement(children, {
	    in: true,
	    onEntered: callHook(children, 'onEntered', function () {
	      changeState(_Transition.ENTERED, _react.default.cloneElement(children, {
	        in: true
	      }));
	    })
	  });
	}, _enterRenders[modes.in] = function (_ref4) {
	  var current = _ref4.current,
	      children = _ref4.children,
	      changeState = _ref4.changeState;
	  return [_react.default.cloneElement(current, {
	    in: false,
	    onExited: callHook(current, 'onExited', function () {
	      changeState(_Transition.ENTERED, _react.default.cloneElement(children, {
	        in: true
	      }));
	    })
	  }), _react.default.cloneElement(children, {
	    in: true
	  })];
	}, _enterRenders);
	/**
	 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
	 * You can use it when you want to control the render between state transitions.
	 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
	 *
	 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
	 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child.
	 *
	 * **Note**: If you want the animation to happen simultaneously
	 * (that is, to have the old child removed and a new child inserted **at the same time**),
	 * you should use
	 * [`TransitionGroup`](https://reactcommunity.org/react-transition-group/transition-group)
	 * instead.
	 *
	 * ```jsx
	 * function App() {
	 *  const [state, setState] = useState(false);
	 *  return (
	 *    <SwitchTransition>
	 *      <CSSTransition
	 *        key={state ? "Goodbye, world!" : "Hello, world!"}
	 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
	 *        classNames='fade'
	 *      >
	 *        <button onClick={() => setState(state => !state)}>
	 *          {state ? "Goodbye, world!" : "Hello, world!"}
	 *        </button>
	 *      </CSSTransition>
	 *    </SwitchTransition>
	 *  );
	 * }
	 * ```
	 *
	 * ```css
	 * .fade-enter{
	 *    opacity: 0;
	 * }
	 * .fade-exit{
	 *    opacity: 1;
	 * }
	 * .fade-enter-active{
	 *    opacity: 1;
	 * }
	 * .fade-exit-active{
	 *    opacity: 0;
	 * }
	 * .fade-enter-active,
	 * .fade-exit-active{
	 *    transition: opacity 500ms;
	 * }
	 * ```
	 */
	
	var SwitchTransition = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(SwitchTransition, _React$Component);
	
	  function SwitchTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    _this.state = {
	      status: _Transition.ENTERED,
	      current: null
	    };
	    _this.appeared = false;
	
	    _this.changeState = function (status, current) {
	      if (current === void 0) {
	        current = _this.state.current;
	      }
	
	      _this.setState({
	        status: status,
	        current: current
	      });
	    };
	
	    return _this;
	  }
	
	  var _proto = SwitchTransition.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	  };
	
	  SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
	    if (props.children == null) {
	      return {
	        current: null
	      };
	    }
	
	    if (state.status === _Transition.ENTERING && props.mode === modes.in) {
	      return {
	        status: _Transition.ENTERING
	      };
	    }
	
	    if (state.current && areChildrenDifferent(state.current, props.children)) {
	      return {
	        status: _Transition.EXITING
	      };
	    }
	
	    return {
	      current: _react.default.cloneElement(props.children, {
	        in: true
	      })
	    };
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        mode = _this$props.mode,
	        _this$state = this.state,
	        status = _this$state.status,
	        current = _this$state.current;
	    var data = {
	      children: children,
	      current: current,
	      changeState: this.changeState,
	      status: status
	    };
	    var component;
	
	    switch (status) {
	      case _Transition.ENTERING:
	        component = enterRenders[mode](data);
	        break;
	
	      case _Transition.EXITING:
	        component = leaveRenders[mode](data);
	        break;
	
	      case _Transition.ENTERED:
	        component = current;
	    }
	
	    return /*#__PURE__*/_react.default.createElement(_TransitionGroupContext.default.Provider, {
	      value: {
	        isMounting: !this.appeared
	      }
	    }, component);
	  };
	
	  return SwitchTransition;
	}(_react.default.Component);
	
	SwitchTransition.propTypes =  false ? {
	  /**
	   * Transition modes.
	   * `out-in`: Current element transitions out first, then when complete, the new element transitions in.
	   * `in-out`: New element transitions in first, then when complete, the current element transitions out.
	   *
	   * @type {'out-in'|'in-out'}
	   */
	  mode: _propTypes.default.oneOf([modes.in, modes.out]),
	
	  /**
	   * Any `Transition` or `CSSTransition` component.
	   */
	  children: _propTypes.default.oneOfType([_propTypes.default.element.isRequired])
	} : {};
	SwitchTransition.defaultProps = {
	  mode: modes.out
	};
	var _default = SwitchTransition;
	exports.default = _default;

/***/ },
/* 2249 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	exports.getInitialChildMapping = getInitialChildMapping;
	exports.getNextChildMapping = getNextChildMapping;
	
	var _react = __webpack_require__(2);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	
	
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  } // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	
	
	  var nextKeysPending = Object.create(null);
	  var pendingKeys = [];
	
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i;
	  var childMapping = {};
	
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	
	    childMapping[nextKey] = getValueForKey(nextKey);
	  } // Finally, add the keys which didn't appear before any key in `next`
	
	
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}
	
	function getProp(child, prop, props) {
	  return props[prop] != null ? props[prop] : child.props[prop];
	}
	
	function getInitialChildMapping(props, onExited) {
	  return getChildMapping(props.children, function (child) {
	    return (0, _react.cloneElement)(child, {
	      onExited: onExited.bind(null, child),
	      in: true,
	      appear: getProp(child, 'appear', props),
	      enter: getProp(child, 'enter', props),
	      exit: getProp(child, 'exit', props)
	    });
	  });
	}
	
	function getNextChildMapping(nextProps, prevChildMapping, onExited) {
	  var nextChildMapping = getChildMapping(nextProps.children);
	  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
	  Object.keys(children).forEach(function (key) {
	    var child = children[key];
	    if (!(0, _react.isValidElement)(child)) return;
	    var hasPrev = (key in prevChildMapping);
	    var hasNext = (key in nextChildMapping);
	    var prevChild = prevChildMapping[key];
	    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
	
	    if (hasNext && (!hasPrev || isLeaving)) {
	      // console.log('entering', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: true,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    } else if (!hasNext && hasPrev && !isLeaving) {
	      // item is old (exiting)
	      // console.log('leaving', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        in: false
	      });
	    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	      // item hasn't changed transition states
	      // copy over the last transition props;
	      // console.log('unchanged', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: prevChild.props.in,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    }
	  });
	  return children;
	}

/***/ },
/* 2250 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.14.0
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var l=__webpack_require__(32),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
	60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
	function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
	function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
	function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
	function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
	0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
	function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
	var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
	exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
	exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
	key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
	exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
	exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ },
/* 2251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(1067);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 2252 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 2253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(552);
	
	var _isPlainObject = __webpack_require__(126);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(1068);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 2254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(257);
	var callBind = __webpack_require__(2255);
	
	var implementation = __webpack_require__(1069);
	var getPolyfill = __webpack_require__(1070);
	var shim = __webpack_require__(2257);
	
	var flagsBound = callBind(implementation);
	
	define(flagsBound, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = flagsBound;


/***/ },
/* 2255 */
[2305, 2256],
/* 2256 */
1921,
/* 2257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var supportsDescriptors = __webpack_require__(257).supportsDescriptors;
	var getPolyfill = __webpack_require__(1070);
	var gOPD = Object.getOwnPropertyDescriptor;
	var defineProperty = Object.defineProperty;
	var TypeErr = TypeError;
	var getProto = Object.getPrototypeOf;
	var regex = /a/;
	
	module.exports = function shimFlags() {
		if (!supportsDescriptors || !getProto) {
			throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
		}
		var polyfill = getPolyfill();
		var proto = getProto(regex);
		var descriptor = gOPD(proto, 'flags');
		if (!descriptor || descriptor.get !== polyfill) {
			defineProperty(proto, 'flags', {
				configurable: true,
				enumerable: false,
				get: polyfill
			});
		}
		return polyfill;
	};


/***/ },
/* 2258 */
/***/ function(module, exports) {

	/** @license React v0.19.1
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var f,g,h,k,l;
	if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
	y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
	typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
	function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
	function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
	function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
	function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
	function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
	exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
	exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
	exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ },
/* 2259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(2258);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ },
/* 2260 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	/**
	 * Created by hustcc on 18/6/9.
	 * Contract: i@hust.cc
	 */
	var id = 1;
	/**
	 * generate unique id in application
	 * @return {string}
	 */
	
	var _default = function _default() {
	  return "".concat(id++);
	};
	
	exports["default"] = _default;

/***/ },
/* 2261 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ver = exports.clear = exports.bind = void 0;
	
	var _sensorPool = __webpack_require__(2262);
	
	/**
	 * Created by hustcc on 18/6/9.[高考时间]
	 * Contract: i@hust.cc
	 */
	
	/**
	 * bind an element with resize callback function
	 * @param {*} element
	 * @param {*} cb
	 */
	var bind = function bind(element, cb) {
	  var sensor = (0, _sensorPool.getSensor)(element); // listen with callback
	
	  sensor.bind(cb); // return unbind function
	
	  return function () {
	    sensor.unbind(cb);
	  };
	};
	/**
	 * clear all the listener and sensor of an element
	 * @param element
	 */
	
	
	exports.bind = bind;
	
	var clear = function clear(element) {
	  var sensor = (0, _sensorPool.getSensor)(element);
	  (0, _sensorPool.removeSensor)(sensor);
	};
	
	exports.clear = clear;
	var ver = "1.0.1";
	exports.ver = ver;

/***/ },
/* 2262 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.removeSensor = exports.getSensor = void 0;
	
	var _id = _interopRequireDefault(__webpack_require__(2260));
	
	var _sensors = __webpack_require__(2263);
	
	var _constant = __webpack_require__(1071);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Created by hustcc on 18/6/9.
	 * Contract: i@hust.cc
	 */
	
	/**
	 * all the sensor objects.
	 * sensor pool
	 */
	var Sensors = {};
	/**
	 * get one sensor
	 * @param element
	 * @returns {*}
	 */
	
	var getSensor = function getSensor(element) {
	  var sensorId = element.getAttribute(_constant.SizeSensorId); // 1. if the sensor exists, then use it
	
	  if (sensorId && Sensors[sensorId]) {
	    return Sensors[sensorId];
	  } // 2. not exist, then create one
	
	
	  var newId = (0, _id["default"])();
	  element.setAttribute(_constant.SizeSensorId, newId);
	  var sensor = (0, _sensors.createSensor)(element); // add sensor into pool
	
	  Sensors[newId] = sensor;
	  return sensor;
	};
	/**
	 * 移除 sensor
	 * @param sensor
	 */
	
	
	exports.getSensor = getSensor;
	
	var removeSensor = function removeSensor(sensor) {
	  var sensorId = sensor.element.getAttribute(_constant.SizeSensorId); // remove attribute
	
	  sensor.element.removeAttribute(_constant.SizeSensorId); // remove event, dom of the sensor used
	
	  sensor.destroy(); // exist, then remove from pool
	
	  if (sensorId && Sensors[sensorId]) {
	    delete Sensors[sensorId];
	  }
	};
	
	exports.removeSensor = removeSensor;

/***/ },
/* 2263 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createSensor = void 0;
	
	var _object = __webpack_require__(2264);
	
	var _resizeObserver = __webpack_require__(2265);
	
	/**
	 * Created by hustcc on 18/7/5.
	 * Contract: i@hust.cc
	 */
	
	/**
	 * sensor strategies
	 */
	// export const createSensor = createObjectSensor;
	var createSensor = typeof ResizeObserver !== 'undefined' ? _resizeObserver.createSensor : _object.createSensor;
	exports.createSensor = createSensor;

/***/ },
/* 2264 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createSensor = void 0;
	
	var _debounce = _interopRequireDefault(__webpack_require__(1072));
	
	var _constant = __webpack_require__(1071);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Created by hustcc on 18/6/9.
	 * Contract: i@hust.cc
	 */
	var createSensor = function createSensor(element) {
	  var sensor = undefined; // callback
	
	  var listeners = [];
	  /**
	   * create object DOM of sensor
	   * @returns {HTMLObjectElement}
	   */
	
	  var newSensor = function newSensor() {
	    // adjust style
	    if (getComputedStyle(element).position === 'static') {
	      element.style.position = 'relative';
	    }
	
	    var obj = document.createElement('object');
	
	    obj.onload = function () {
	      obj.contentDocument.defaultView.addEventListener('resize', resizeListener); // 直接触发一次 resize
	
	      resizeListener();
	    };
	
	    obj.style.display = 'block';
	    obj.style.position = 'absolute';
	    obj.style.top = '0';
	    obj.style.left = '0';
	    obj.style.height = '100%';
	    obj.style.width = '100%';
	    obj.style.overflow = 'hidden';
	    obj.style.pointerEvents = 'none';
	    obj.style.zIndex = '-1';
	    obj.style.opacity = '0';
	    obj.setAttribute('class', _constant.SensorClassName);
	    obj.setAttribute('tabindex', _constant.SensorTabIndex);
	    obj.type = 'text/html'; // append into dom
	
	    element.appendChild(obj); // for ie, should set data attribute delay, or will be white screen
	
	    obj.data = 'about:blank';
	    return obj;
	  };
	  /**
	   * trigger listeners
	   */
	
	
	  var resizeListener = (0, _debounce["default"])(function () {
	    // trigger all listener
	    listeners.forEach(function (listener) {
	      listener(element);
	    });
	  });
	  /**
	   * listen with one callback function
	   * @param cb
	   */
	
	  var bind = function bind(cb) {
	    // if not exist sensor, then create one
	    if (!sensor) {
	      sensor = newSensor();
	    }
	
	    if (listeners.indexOf(cb) === -1) {
	      listeners.push(cb);
	    }
	  };
	  /**
	   * destroy all
	   */
	
	
	  var destroy = function destroy() {
	    if (sensor && sensor.parentNode) {
	      if (sensor.contentDocument) {
	        // remote event
	        sensor.contentDocument.defaultView.removeEventListener('resize', resizeListener);
	      } // remove dom
	
	
	      sensor.parentNode.removeChild(sensor); // initial variable
	
	      sensor = undefined;
	      listeners = [];
	    }
	  };
	  /**
	   * cancel listener bind
	   * @param cb
	   */
	
	
	  var unbind = function unbind(cb) {
	    var idx = listeners.indexOf(cb);
	
	    if (idx !== -1) {
	      listeners.splice(idx, 1);
	    } // no listener, and sensor is exist
	    // then destroy the sensor
	
	
	    if (listeners.length === 0 && sensor) {
	      destroy();
	    }
	  };
	
	  return {
	    element: element,
	    bind: bind,
	    destroy: destroy,
	    unbind: unbind
	  };
	};
	
	exports.createSensor = createSensor;

/***/ },
/* 2265 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createSensor = void 0;
	
	var _debounce = _interopRequireDefault(__webpack_require__(1072));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Created by hustcc on 18/7/5.
	 * Contract: i@hust.cc
	 */
	var createSensor = function createSensor(element) {
	  var sensor = undefined; // callback
	
	  var listeners = [];
	  /**
	   * trigger listeners
	   */
	
	  var resizeListener = (0, _debounce["default"])(function () {
	    // trigger all
	    listeners.forEach(function (listener) {
	      listener(element);
	    });
	  });
	  /**
	   * create ResizeObserver sensor
	   * @returns
	   */
	
	  var newSensor = function newSensor() {
	    var s = new ResizeObserver(resizeListener); // listen element
	
	    s.observe(element); // trigger once
	
	    resizeListener();
	    return s;
	  };
	  /**
	   * listen with callback
	   * @param cb
	   */
	
	
	  var bind = function bind(cb) {
	    if (!sensor) {
	      sensor = newSensor();
	    }
	
	    if (listeners.indexOf(cb) === -1) {
	      listeners.push(cb);
	    }
	  };
	  /**
	   * destroy
	   */
	
	
	  var destroy = function destroy() {
	    sensor.disconnect();
	    listeners = [];
	    sensor = undefined;
	  };
	  /**
	   * cancel bind
	   * @param cb
	   */
	
	
	  var unbind = function unbind(cb) {
	    var idx = listeners.indexOf(cb);
	
	    if (idx !== -1) {
	      listeners.splice(idx, 1);
	    } // no listener, and sensor is exist
	    // then destroy the sensor
	
	
	    if (listeners.length === 0 && sensor) {
	      destroy();
	    }
	  };
	
	  return {
	    element: element,
	    bind: bind,
	    destroy: destroy,
	    unbind: unbind
	  };
	};
	
	exports.createSensor = createSensor;

/***/ },
/* 2266 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(2267);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(291)(module)))

/***/ },
/* 2267 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 2268 */
/***/ function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(1075);
	var bytesToUuid = __webpack_require__(1074);
	
	// **`v1()` - Generate time-based UUID**
	//
	// Inspired by https://github.com/LiosK/UUID.js
	// and http://docs.python.org/library/uuid.html
	
	var _nodeId;
	var _clockseq;
	
	// Previous uuid creation time
	var _lastMSecs = 0;
	var _lastNSecs = 0;
	
	// See https://github.com/uuidjs/uuid for API details
	function v1(options, buf, offset) {
	  var i = buf && offset || 0;
	  var b = buf || [];
	
	  options = options || {};
	  var node = options.node || _nodeId;
	  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
	
	  // node and clockseq need to be initialized to random values if they're not
	  // specified.  We do this lazily to minimize issues related to insufficient
	  // system entropy.  See #189
	  if (node == null || clockseq == null) {
	    var seedBytes = rng();
	    if (node == null) {
	      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	      node = _nodeId = [
	        seedBytes[0] | 0x01,
	        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
	      ];
	    }
	    if (clockseq == null) {
	      // Per 4.2.2, randomize (14 bit) clockseq
	      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
	    }
	  }
	
	  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
	
	  // Per 4.2.1.2, use count of uuid's generated during the current clock
	  // cycle to simulate higher resolution clock
	  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
	
	  // Time since last uuid creation (in msecs)
	  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;
	
	  // Per 4.2.1.2, Bump clockseq on clock regression
	  if (dt < 0 && options.clockseq === undefined) {
	    clockseq = clockseq + 1 & 0x3fff;
	  }
	
	  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	  // time interval
	  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
	    nsecs = 0;
	  }
	
	  // Per 4.2.1.2 Throw error if too many uuids are requested
	  if (nsecs >= 10000) {
	    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	  }
	
	  _lastMSecs = msecs;
	  _lastNSecs = nsecs;
	  _clockseq = clockseq;
	
	  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	  msecs += 12219292800000;
	
	  // `time_low`
	  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	  b[i++] = tl >>> 24 & 0xff;
	  b[i++] = tl >>> 16 & 0xff;
	  b[i++] = tl >>> 8 & 0xff;
	  b[i++] = tl & 0xff;
	
	  // `time_mid`
	  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
	  b[i++] = tmh >>> 8 & 0xff;
	  b[i++] = tmh & 0xff;
	
	  // `time_high_and_version`
	  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	  b[i++] = tmh >>> 16 & 0xff;
	
	  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	  b[i++] = clockseq >>> 8 | 0x80;
	
	  // `clock_seq_low`
	  b[i++] = clockseq & 0xff;
	
	  // `node`
	  for (var n = 0; n < 6; ++n) {
	    b[i + n] = node[n];
	  }
	
	  return buf ? buf : bytesToUuid(b);
	}
	
	module.exports = v1;


/***/ },
/* 2269 */
/***/ function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(1075);
	var bytesToUuid = __webpack_require__(1074);
	
	function v4(options, buf, offset) {
	  var i = buf && offset || 0;
	
	  if (typeof(options) == 'string') {
	    buf = options === 'binary' ? new Array(16) : null;
	    options = null;
	  }
	  options = options || {};
	
	  var rnds = options.random || (options.rng || rng)();
	
	  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	  rnds[6] = (rnds[6] & 0x0f) | 0x40;
	  rnds[8] = (rnds[8] & 0x3f) | 0x80;
	
	  // Copy bytes to buffer, if provided
	  if (buf) {
	    for (var ii = 0; ii < 16; ++ii) {
	      buf[i + ii] = rnds[ii];
	    }
	  }
	
	  return buf || bytesToUuid(rnds);
	}
	
	module.exports = v4;


/***/ },
/* 2270 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.WHATWGFetch = {})));
	}(this, (function (exports) { 'use strict';
	
	  var global =
	    (typeof globalThis !== 'undefined' && globalThis) ||
	    (typeof self !== 'undefined' && self) ||
	    (typeof global !== 'undefined' && global);
	
	  var support = {
	    searchParams: 'URLSearchParams' in global,
	    iterable: 'Symbol' in global && 'iterator' in Symbol,
	    blob:
	      'FileReader' in global &&
	      'Blob' in global &&
	      (function() {
	        try {
	          new Blob();
	          return true
	        } catch (e) {
	          return false
	        }
	      })(),
	    formData: 'FormData' in global,
	    arrayBuffer: 'ArrayBuffer' in global
	  };
	
	  function isDataView(obj) {
	    return obj && DataView.prototype.isPrototypeOf(obj)
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ];
	
	    var isArrayBufferView =
	      ArrayBuffer.isView ||
	      function(obj) {
	        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	      };
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name);
	    }
	    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value);
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift();
	        return {done: value === undefined, value: value}
	      }
	    };
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      };
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {};
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value);
	      }, this);
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1]);
	      }, this);
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name]);
	      }, this);
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name);
	    value = normalizeValue(value);
	    var oldValue = this.map[name];
	    this.map[name] = oldValue ? oldValue + ', ' + value : value;
	  };
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)];
	  };
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name);
	    return this.has(name) ? this.map[name] : null
	  };
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  };
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value);
	  };
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this);
	      }
	    }
	  };
	
	  Headers.prototype.keys = function() {
	    var items = [];
	    this.forEach(function(value, name) {
	      items.push(name);
	    });
	    return iteratorFor(items)
	  };
	
	  Headers.prototype.values = function() {
	    var items = [];
	    this.forEach(function(value) {
	      items.push(value);
	    });
	    return iteratorFor(items)
	  };
	
	  Headers.prototype.entries = function() {
	    var items = [];
	    this.forEach(function(value, name) {
	      items.push([name, value]);
	    });
	    return iteratorFor(items)
	  };
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true;
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result);
	      };
	      reader.onerror = function() {
	        reject(reader.error);
	      };
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader();
	    var promise = fileReaderReady(reader);
	    reader.readAsArrayBuffer(blob);
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader();
	    var promise = fileReaderReady(reader);
	    reader.readAsText(blob);
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf);
	    var chars = new Array(view.length);
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i]);
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength);
	      view.set(new Uint8Array(buf));
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false;
	
	    this._initBody = function(body) {
	      /*
	        fetch-mock wraps the Response object in an ES6 Proxy to
	        provide useful test harness features such as flush. However, on
	        ES5 browsers without fetch or Proxy support pollyfills must be used;
	        the proxy-pollyfill is unable to proxy an attribute unless it exists
	        on the object before the Proxy is created. This change ensures
	        Response.bodyUsed exists on the instance, while maintaining the
	        semantic of setting Request.bodyUsed in the constructor before
	        _initBody is called.
	      */
	      this.bodyUsed = this.bodyUsed;
	      this._bodyInit = body;
	      if (!body) {
	        this._bodyText = '';
	      } else if (typeof body === 'string') {
	        this._bodyText = body;
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body;
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body;
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString();
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer);
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer]);
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body);
	      } else {
	        this._bodyText = body = Object.prototype.toString.call(body);
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8');
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type);
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
	        }
	      }
	    };
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this);
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      };
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          var isConsumed = consumed(this);
	          if (isConsumed) {
	            return isConsumed
	          }
	          if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
	            return Promise.resolve(
	              this._bodyArrayBuffer.buffer.slice(
	                this._bodyArrayBuffer.byteOffset,
	                this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
	              )
	            )
	          } else {
	            return Promise.resolve(this._bodyArrayBuffer)
	          }
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      };
	    }
	
	    this.text = function() {
	      var rejected = consumed(this);
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    };
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      };
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    };
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase();
	    return methods.indexOf(upcased) > -1 ? upcased : method
	  }
	
	  function Request(input, options) {
	    if (!(this instanceof Request)) {
	      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
	    }
	
	    options = options || {};
	    var body = options.body;
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url;
	      this.credentials = input.credentials;
	      if (!options.headers) {
	        this.headers = new Headers(input.headers);
	      }
	      this.method = input.method;
	      this.mode = input.mode;
	      this.signal = input.signal;
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit;
	        input.bodyUsed = true;
	      }
	    } else {
	      this.url = String(input);
	    }
	
	    this.credentials = options.credentials || this.credentials || 'same-origin';
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers);
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET');
	    this.mode = options.mode || this.mode || null;
	    this.signal = options.signal || this.signal;
	    this.referrer = null;
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body);
	
	    if (this.method === 'GET' || this.method === 'HEAD') {
	      if (options.cache === 'no-store' || options.cache === 'no-cache') {
	        // Search for a '_' parameter in the query string
	        var reParamSearch = /([?&])_=[^&]*/;
	        if (reParamSearch.test(this.url)) {
	          // If it already exists then set the value with the current time
	          this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
	        } else {
	          // Otherwise add a new '_' parameter to the end with the current time
	          var reQueryString = /\?/;
	          this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
	        }
	      }
	    }
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, {body: this._bodyInit})
	  };
	
	  function decode(body) {
	    var form = new FormData();
	    body
	      .trim()
	      .split('&')
	      .forEach(function(bytes) {
	        if (bytes) {
	          var split = bytes.split('=');
	          var name = split.shift().replace(/\+/g, ' ');
	          var value = split.join('=').replace(/\+/g, ' ');
	          form.append(decodeURIComponent(name), decodeURIComponent(value));
	        }
	      });
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers();
	    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
	    // https://tools.ietf.org/html/rfc7230#section-3.2
	    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
	    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
	    // https://github.com/github/fetch/issues/748
	    // https://github.com/zloirock/core-js/issues/751
	    preProcessedHeaders
	      .split('\r')
	      .map(function(header) {
	        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header
	      })
	      .forEach(function(line) {
	        var parts = line.split(':');
	        var key = parts.shift().trim();
	        if (key) {
	          var value = parts.join(':').trim();
	          headers.append(key, value);
	        }
	      });
	    return headers
	  }
	
	  Body.call(Request.prototype);
	
	  function Response(bodyInit, options) {
	    if (!(this instanceof Response)) {
	      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
	    }
	    if (!options) {
	      options = {};
	    }
	
	    this.type = 'default';
	    this.status = options.status === undefined ? 200 : options.status;
	    this.ok = this.status >= 200 && this.status < 300;
	    this.statusText = 'statusText' in options ? options.statusText : '';
	    this.headers = new Headers(options.headers);
	    this.url = options.url || '';
	    this._initBody(bodyInit);
	  }
	
	  Body.call(Response.prototype);
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  };
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''});
	    response.type = 'error';
	    return response
	  };
	
	  var redirectStatuses = [301, 302, 303, 307, 308];
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  };
	
	  exports.DOMException = global.DOMException;
	  try {
	    new exports.DOMException();
	  } catch (err) {
	    exports.DOMException = function(message, name) {
	      this.message = message;
	      this.name = name;
	      var error = Error(message);
	      this.stack = error.stack;
	    };
	    exports.DOMException.prototype = Object.create(Error.prototype);
	    exports.DOMException.prototype.constructor = exports.DOMException;
	  }
	
	  function fetch(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init);
	
	      if (request.signal && request.signal.aborted) {
	        return reject(new exports.DOMException('Aborted', 'AbortError'))
	      }
	
	      var xhr = new XMLHttpRequest();
	
	      function abortXhr() {
	        xhr.abort();
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        };
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
	        var body = 'response' in xhr ? xhr.response : xhr.responseText;
	        setTimeout(function() {
	          resolve(new Response(body, options));
	        }, 0);
	      };
	
	      xhr.onerror = function() {
	        setTimeout(function() {
	          reject(new TypeError('Network request failed'));
	        }, 0);
	      };
	
	      xhr.ontimeout = function() {
	        setTimeout(function() {
	          reject(new TypeError('Network request failed'));
	        }, 0);
	      };
	
	      xhr.onabort = function() {
	        setTimeout(function() {
	          reject(new exports.DOMException('Aborted', 'AbortError'));
	        }, 0);
	      };
	
	      function fixUrl(url) {
	        try {
	          return url === '' && global.location.href ? global.location.href : url
	        } catch (e) {
	          return url
	        }
	      }
	
	      xhr.open(request.method, fixUrl(request.url), true);
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true;
	      } else if (request.credentials === 'omit') {
	        xhr.withCredentials = false;
	      }
	
	      if ('responseType' in xhr) {
	        if (support.blob) {
	          xhr.responseType = 'blob';
	        } else if (
	          support.arrayBuffer &&
	          request.headers.get('Content-Type') &&
	          request.headers.get('Content-Type').indexOf('application/octet-stream') !== -1
	        ) {
	          xhr.responseType = 'arraybuffer';
	        }
	      }
	
	      if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers)) {
	        Object.getOwnPropertyNames(init.headers).forEach(function(name) {
	          xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
	        });
	      } else {
	        request.headers.forEach(function(value, name) {
	          xhr.setRequestHeader(name, value);
	        });
	      }
	
	      if (request.signal) {
	        request.signal.addEventListener('abort', abortXhr);
	
	        xhr.onreadystatechange = function() {
	          // DONE (success or failure)
	          if (xhr.readyState === 4) {
	            request.signal.removeEventListener('abort', abortXhr);
	          }
	        };
	      }
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
	    })
	  }
	
	  fetch.polyfill = true;
	
	  if (!global.fetch) {
	    global.fetch = fetch;
	    global.Headers = Headers;
	    global.Request = Request;
	    global.Response = Response;
	  }
	
	  exports.Headers = Headers;
	  exports.Request = Request;
	  exports.Response = Response;
	  exports.fetch = fetch;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 2271 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(3);
	
	var vec2 = __webpack_require__(41);
	
	var Draggable = __webpack_require__(2295);
	
	var Eventful = __webpack_require__(189);
	
	var eventTool = __webpack_require__(113);
	
	var GestureMgr = __webpack_require__(2281);
	
	/**
	 * [The interface between `Handler` and `HandlerProxy`]:
	 *
	 * The default `HandlerProxy` only support the common standard web environment
	 * (e.g., standalone browser, headless browser, embed browser in mobild APP, ...).
	 * But `HandlerProxy` can be replaced to support more non-standard environment
	 * (e.g., mini app), or to support more feature that the default `HandlerProxy`
	 * not provided (like echarts-gl did).
	 * So the interface between `Handler` and `HandlerProxy` should be stable. Do not
	 * make break changes util inevitable. The interface include the public methods
	 * of `Handler` and the events listed in `handlerNames` below, by which `HandlerProxy`
	 * drives `Handler`.
	 */
	
	/**
	 * [Drag outside]:
	 *
	 * That is, triggering `mousemove` and `mouseup` event when the pointer is out of the
	 * zrender area when dragging. That is important for the improvement of the user experience
	 * when dragging something near the boundary without being terminated unexpectedly.
	 *
	 * We originally consider to introduce new events like `pagemovemove` and `pagemouseup`
	 * to resolve this issue. But some drawbacks of it is described in
	 * https://github.com/ecomfe/zrender/pull/536#issuecomment-560286899
	 *
	 * Instead, we referenced the specifications:
	 * https://www.w3.org/TR/touch-events/#the-touchmove-event
	 * https://www.w3.org/TR/2014/WD-DOM-Level-3-Events-20140925/#event-type-mousemove
	 * where the the mousemove/touchmove can be continue to fire if the user began a drag
	 * operation and the pointer has left the boundary. (for the mouse event, browsers
	 * only do it on `document` and when the pointer has left the boundary of the browser.)
	 *
	 * So the default `HandlerProxy` supports this feature similarly: if it is in the dragging
	 * state (see `pointerCapture` in `HandlerProxy`), the `mousemove` and `mouseup` continue
	 * to fire until release the pointer. That is implemented by listen to those event on
	 * `document`.
	 * If we implement some other `HandlerProxy` only for touch device, that would be easier.
	 * The touch event support this feature by default.
	 *
	 * Note:
	 * There might be some cases that the mouse event can not be
	 * received on `document`. For example,
	 * (A) `useCapture` is not supported and some user defined event listeners on the ancestor
	 * of zr dom throw Error .
	 * (B) `useCapture` is not supported Some user defined event listeners on the ancestor of
	 * zr dom call `stopPropagation`.
	 * In these cases, the `mousemove` event might be keep triggered event
	 * if the mouse is released. We try to reduce the side-effect in those cases.
	 * That is, do nothing (especially, `findHover`) in those cases. See `isOutsideBoundary`.
	 *
	 * Note:
	 * If `HandlerProxy` listens to `document` with `useCapture`, `HandlerProxy` needs to
	 * make sure `stopPropagation` and `preventDefault` doing nothing if and only if the event
	 * target is not zrender dom. Becuase it is dangerous to enable users to call them in
	 * `document` capture phase to prevent the propagation to any listener of the webpage.
	 * But they are needed to work when the pointer inside the zrender dom.
	 */
	var SILENT = 'silent';
	
	function makeEventPacket(eveType, targetInfo, event) {
	  return {
	    type: eveType,
	    event: event,
	    // target can only be an element that is not silent.
	    target: targetInfo.target,
	    // topTarget can be a silent element.
	    topTarget: targetInfo.topTarget,
	    cancelBubble: false,
	    offsetX: event.zrX,
	    offsetY: event.zrY,
	    gestureEvent: event.gestureEvent,
	    pinchX: event.pinchX,
	    pinchY: event.pinchY,
	    pinchScale: event.pinchScale,
	    wheelDelta: event.zrDelta,
	    zrByTouch: event.zrByTouch,
	    which: event.which,
	    stop: stopEvent
	  };
	}
	
	function stopEvent() {
	  eventTool.stop(this.event);
	}
	
	function EmptyProxy() {}
	
	EmptyProxy.prototype.dispose = function () {};
	
	var handlerNames = ['click', 'dblclick', 'mousewheel', 'mouseout', 'mouseup', 'mousedown', 'mousemove', 'contextmenu'];
	/**
	 * @alias module:zrender/Handler
	 * @constructor
	 * @extends module:zrender/mixin/Eventful
	 * @param {module:zrender/Storage} storage Storage instance.
	 * @param {module:zrender/Painter} painter Painter instance.
	 * @param {module:zrender/dom/HandlerProxy} proxy HandlerProxy instance.
	 * @param {HTMLElement} painterRoot painter.root (not painter.getViewportRoot()).
	 */
	
	var Handler = function (storage, painter, proxy, painterRoot) {
	  Eventful.call(this);
	  this.storage = storage;
	  this.painter = painter;
	  this.painterRoot = painterRoot;
	  proxy = proxy || new EmptyProxy();
	  /**
	   * Proxy of event. can be Dom, WebGLSurface, etc.
	   */
	
	  this.proxy = null;
	  /**
	   * {target, topTarget, x, y}
	   * @private
	   * @type {Object}
	   */
	
	  this._hovered = {};
	  /**
	   * @private
	   * @type {Date}
	   */
	
	  this._lastTouchMoment;
	  /**
	   * @private
	   * @type {number}
	   */
	
	  this._lastX;
	  /**
	   * @private
	   * @type {number}
	   */
	
	  this._lastY;
	  /**
	   * @private
	   * @type {module:zrender/core/GestureMgr}
	   */
	
	  this._gestureMgr;
	  Draggable.call(this);
	  this.setHandlerProxy(proxy);
	};
	
	Handler.prototype = {
	  constructor: Handler,
	  setHandlerProxy: function (proxy) {
	    if (this.proxy) {
	      this.proxy.dispose();
	    }
	
	    if (proxy) {
	      util.each(handlerNames, function (name) {
	        proxy.on && proxy.on(name, this[name], this);
	      }, this); // Attach handler
	
	      proxy.handler = this;
	    }
	
	    this.proxy = proxy;
	  },
	  mousemove: function (event) {
	    var x = event.zrX;
	    var y = event.zrY;
	    var isOutside = isOutsideBoundary(this, x, y);
	    var lastHovered = this._hovered;
	    var lastHoveredTarget = lastHovered.target; // If lastHoveredTarget is removed from zr (detected by '__zr') by some API call
	    // (like 'setOption' or 'dispatchAction') in event handlers, we should find
	    // lastHovered again here. Otherwise 'mouseout' can not be triggered normally.
	    // See #6198.
	
	    if (lastHoveredTarget && !lastHoveredTarget.__zr) {
	      lastHovered = this.findHover(lastHovered.x, lastHovered.y);
	      lastHoveredTarget = lastHovered.target;
	    }
	
	    var hovered = this._hovered = isOutside ? {
	      x: x,
	      y: y
	    } : this.findHover(x, y);
	    var hoveredTarget = hovered.target;
	    var proxy = this.proxy;
	    proxy.setCursor && proxy.setCursor(hoveredTarget ? hoveredTarget.cursor : 'default'); // Mouse out on previous hovered element
	
	    if (lastHoveredTarget && hoveredTarget !== lastHoveredTarget) {
	      this.dispatchToElement(lastHovered, 'mouseout', event);
	    } // Mouse moving on one element
	
	
	    this.dispatchToElement(hovered, 'mousemove', event); // Mouse over on a new element
	
	    if (hoveredTarget && hoveredTarget !== lastHoveredTarget) {
	      this.dispatchToElement(hovered, 'mouseover', event);
	    }
	  },
	  mouseout: function (event) {
	    var eventControl = event.zrEventControl;
	    var zrIsToLocalDOM = event.zrIsToLocalDOM;
	
	    if (eventControl !== 'only_globalout') {
	      this.dispatchToElement(this._hovered, 'mouseout', event);
	    }
	
	    if (eventControl !== 'no_globalout') {
	      // FIXME: if the pointer moving from the extra doms to realy "outside",
	      // the `globalout` should have been triggered. But currently not.
	      !zrIsToLocalDOM && this.trigger('globalout', {
	        type: 'globalout',
	        event: event
	      });
	    }
	  },
	
	  /**
	   * Resize
	   */
	  resize: function (event) {
	    this._hovered = {};
	  },
	
	  /**
	   * Dispatch event
	   * @param {string} eventName
	   * @param {event=} eventArgs
	   */
	  dispatch: function (eventName, eventArgs) {
	    var handler = this[eventName];
	    handler && handler.call(this, eventArgs);
	  },
	
	  /**
	   * Dispose
	   */
	  dispose: function () {
	    this.proxy.dispose();
	    this.storage = this.proxy = this.painter = null;
	  },
	
	  /**
	   * 设置默认的cursor style
	   * @param {string} [cursorStyle='default'] 例如 crosshair
	   */
	  setCursorStyle: function (cursorStyle) {
	    var proxy = this.proxy;
	    proxy.setCursor && proxy.setCursor(cursorStyle);
	  },
	
	  /**
	   * 事件分发代理
	   *
	   * @private
	   * @param {Object} targetInfo {target, topTarget} 目标图形元素
	   * @param {string} eventName 事件名称
	   * @param {Object} event 事件对象
	   */
	  dispatchToElement: function (targetInfo, eventName, event) {
	    targetInfo = targetInfo || {};
	    var el = targetInfo.target;
	
	    if (el && el.silent) {
	      return;
	    }
	
	    var eventHandler = 'on' + eventName;
	    var eventPacket = makeEventPacket(eventName, targetInfo, event);
	
	    while (el) {
	      el[eventHandler] && (eventPacket.cancelBubble = el[eventHandler].call(el, eventPacket));
	      el.trigger(eventName, eventPacket);
	      el = el.parent;
	
	      if (eventPacket.cancelBubble) {
	        break;
	      }
	    }
	
	    if (!eventPacket.cancelBubble) {
	      // 冒泡到顶级 zrender 对象
	      this.trigger(eventName, eventPacket); // 分发事件到用户自定义层
	      // 用户有可能在全局 click 事件中 dispose，所以需要判断下 painter 是否存在
	
	      this.painter && this.painter.eachOtherLayer(function (layer) {
	        if (typeof layer[eventHandler] === 'function') {
	          layer[eventHandler].call(layer, eventPacket);
	        }
	
	        if (layer.trigger) {
	          layer.trigger(eventName, eventPacket);
	        }
	      });
	    }
	  },
	
	  /**
	   * @private
	   * @param {number} x
	   * @param {number} y
	   * @param {module:zrender/graphic/Displayable} exclude
	   * @return {model:zrender/Element}
	   * @method
	   */
	  findHover: function (x, y, exclude) {
	    var list = this.storage.getDisplayList();
	    var out = {
	      x: x,
	      y: y
	    };
	
	    for (var i = list.length - 1; i >= 0; i--) {
	      var hoverCheckResult;
	
	      if (list[i] !== exclude // getDisplayList may include ignored item in VML mode
	      && !list[i].ignore && (hoverCheckResult = isHover(list[i], x, y))) {
	        !out.topTarget && (out.topTarget = list[i]);
	
	        if (hoverCheckResult !== SILENT) {
	          out.target = list[i];
	          break;
	        }
	      }
	    }
	
	    return out;
	  },
	  processGesture: function (event, stage) {
	    if (!this._gestureMgr) {
	      this._gestureMgr = new GestureMgr();
	    }
	
	    var gestureMgr = this._gestureMgr;
	    stage === 'start' && gestureMgr.clear();
	    var gestureInfo = gestureMgr.recognize(event, this.findHover(event.zrX, event.zrY, null).target, this.proxy.dom);
	    stage === 'end' && gestureMgr.clear(); // Do not do any preventDefault here. Upper application do that if necessary.
	
	    if (gestureInfo) {
	      var type = gestureInfo.type;
	      event.gestureEvent = type;
	      this.dispatchToElement({
	        target: gestureInfo.target
	      }, type, gestureInfo.event);
	    }
	  }
	}; // Common handlers
	
	util.each(['click', 'mousedown', 'mouseup', 'mousewheel', 'dblclick', 'contextmenu'], function (name) {
	  Handler.prototype[name] = function (event) {
	    var x = event.zrX;
	    var y = event.zrY;
	    var isOutside = isOutsideBoundary(this, x, y);
	    var hovered;
	    var hoveredTarget;
	
	    if (name !== 'mouseup' || !isOutside) {
	      // Find hover again to avoid click event is dispatched manually. Or click is triggered without mouseover
	      hovered = this.findHover(x, y);
	      hoveredTarget = hovered.target;
	    }
	
	    if (name === 'mousedown') {
	      this._downEl = hoveredTarget;
	      this._downPoint = [event.zrX, event.zrY]; // In case click triggered before mouseup
	
	      this._upEl = hoveredTarget;
	    } else if (name === 'mouseup') {
	      this._upEl = hoveredTarget;
	    } else if (name === 'click') {
	      if (this._downEl !== this._upEl // Original click event is triggered on the whole canvas element,
	      // including the case that `mousedown` - `mousemove` - `mouseup`,
	      // which should be filtered, otherwise it will bring trouble to
	      // pan and zoom.
	      || !this._downPoint // Arbitrary value
	      || vec2.dist(this._downPoint, [event.zrX, event.zrY]) > 4) {
	        return;
	      }
	
	      this._downPoint = null;
	    }
	
	    this.dispatchToElement(hovered, name, event);
	  };
	});
	
	function isHover(displayable, x, y) {
	  if (displayable[displayable.rectHover ? 'rectContain' : 'contain'](x, y)) {
	    var el = displayable;
	    var isSilent;
	
	    while (el) {
	      // If clipped by ancestor.
	      // FIXME: If clipPath has neither stroke nor fill,
	      // el.clipPath.contain(x, y) will always return false.
	      if (el.clipPath && !el.clipPath.contain(x, y)) {
	        return false;
	      }
	
	      if (el.silent) {
	        isSilent = true;
	      }
	
	      el = el.parent;
	    }
	
	    return isSilent ? SILENT : true;
	  }
	
	  return false;
	}
	/**
	 * See [Drag outside].
	 */
	
	
	function isOutsideBoundary(handlerInstance, x, y) {
	  var painter = handlerInstance.painter;
	  return x < 0 || x > painter.getWidth() || y < 0 || y > painter.getHeight();
	}
	
	util.mixin(Handler, Eventful);
	util.mixin(Handler, Draggable);
	var _default = Handler;
	module.exports = _default;

/***/ },
/* 2272 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(3);
	
	var _config = __webpack_require__(385);
	
	var devicePixelRatio = _config.devicePixelRatio;
	
	var Style = __webpack_require__(558);
	
	var Pattern = __webpack_require__(1087);
	
	/**
	 * @module zrender/Layer
	 * @author pissang(https://www.github.com/pissang)
	 */
	function returnFalse() {
	  return false;
	}
	/**
	 * 创建dom
	 *
	 * @inner
	 * @param {string} id dom id 待用
	 * @param {Painter} painter painter instance
	 * @param {number} number
	 */
	
	
	function createDom(id, painter, dpr) {
	  var newDom = util.createCanvas();
	  var width = painter.getWidth();
	  var height = painter.getHeight();
	  var newDomStyle = newDom.style;
	
	  if (newDomStyle) {
	    // In node or some other non-browser environment
	    newDomStyle.position = 'absolute';
	    newDomStyle.left = 0;
	    newDomStyle.top = 0;
	    newDomStyle.width = width + 'px';
	    newDomStyle.height = height + 'px';
	    newDom.setAttribute('data-zr-dom-id', id);
	  }
	
	  newDom.width = width * dpr;
	  newDom.height = height * dpr;
	  return newDom;
	}
	/**
	 * @alias module:zrender/Layer
	 * @constructor
	 * @extends module:zrender/mixin/Transformable
	 * @param {string} id
	 * @param {module:zrender/Painter} painter
	 * @param {number} [dpr]
	 */
	
	
	var Layer = function (id, painter, dpr) {
	  var dom;
	  dpr = dpr || devicePixelRatio;
	
	  if (typeof id === 'string') {
	    dom = createDom(id, painter, dpr);
	  } // Not using isDom because in node it will return false
	  else if (util.isObject(id)) {
	      dom = id;
	      id = dom.id;
	    }
	
	  this.id = id;
	  this.dom = dom;
	  var domStyle = dom.style;
	
	  if (domStyle) {
	    // Not in node
	    dom.onselectstart = returnFalse; // 避免页面选中的尴尬
	
	    domStyle['-webkit-user-select'] = 'none';
	    domStyle['user-select'] = 'none';
	    domStyle['-webkit-touch-callout'] = 'none';
	    domStyle['-webkit-tap-highlight-color'] = 'rgba(0,0,0,0)';
	    domStyle['padding'] = 0; // eslint-disable-line dot-notation
	
	    domStyle['margin'] = 0; // eslint-disable-line dot-notation
	
	    domStyle['border-width'] = 0;
	  }
	
	  this.domBack = null;
	  this.ctxBack = null;
	  this.painter = painter;
	  this.config = null; // Configs
	
	  /**
	   * 每次清空画布的颜色
	   * @type {string}
	   * @default 0
	   */
	
	  this.clearColor = 0;
	  /**
	   * 是否开启动态模糊
	   * @type {boolean}
	   * @default false
	   */
	
	  this.motionBlur = false;
	  /**
	   * 在开启动态模糊的时候使用，与上一帧混合的alpha值，值越大尾迹越明显
	   * @type {number}
	   * @default 0.7
	   */
	
	  this.lastFrameAlpha = 0.7;
	  /**
	   * Layer dpr
	   * @type {number}
	   */
	
	  this.dpr = dpr;
	};
	
	Layer.prototype = {
	  constructor: Layer,
	  __dirty: true,
	  __used: false,
	  __drawIndex: 0,
	  __startIndex: 0,
	  __endIndex: 0,
	  incremental: false,
	  getElementCount: function () {
	    return this.__endIndex - this.__startIndex;
	  },
	  initContext: function () {
	    this.ctx = this.dom.getContext('2d');
	    this.ctx.dpr = this.dpr;
	  },
	  createBackBuffer: function () {
	    var dpr = this.dpr;
	    this.domBack = createDom('back-' + this.id, this.painter, dpr);
	    this.ctxBack = this.domBack.getContext('2d');
	
	    if (dpr !== 1) {
	      this.ctxBack.scale(dpr, dpr);
	    }
	  },
	
	  /**
	   * @param  {number} width
	   * @param  {number} height
	   */
	  resize: function (width, height) {
	    var dpr = this.dpr;
	    var dom = this.dom;
	    var domStyle = dom.style;
	    var domBack = this.domBack;
	
	    if (domStyle) {
	      domStyle.width = width + 'px';
	      domStyle.height = height + 'px';
	    }
	
	    dom.width = width * dpr;
	    dom.height = height * dpr;
	
	    if (domBack) {
	      domBack.width = width * dpr;
	      domBack.height = height * dpr;
	
	      if (dpr !== 1) {
	        this.ctxBack.scale(dpr, dpr);
	      }
	    }
	  },
	
	  /**
	   * 清空该层画布
	   * @param {boolean} [clearAll]=false Clear all with out motion blur
	   * @param {Color} [clearColor]
	   */
	  clear: function (clearAll, clearColor) {
	    var dom = this.dom;
	    var ctx = this.ctx;
	    var width = dom.width;
	    var height = dom.height;
	    var clearColor = clearColor || this.clearColor;
	    var haveMotionBLur = this.motionBlur && !clearAll;
	    var lastFrameAlpha = this.lastFrameAlpha;
	    var dpr = this.dpr;
	
	    if (haveMotionBLur) {
	      if (!this.domBack) {
	        this.createBackBuffer();
	      }
	
	      this.ctxBack.globalCompositeOperation = 'copy';
	      this.ctxBack.drawImage(dom, 0, 0, width / dpr, height / dpr);
	    }
	
	    ctx.clearRect(0, 0, width, height);
	
	    if (clearColor && clearColor !== 'transparent') {
	      var clearColorGradientOrPattern; // Gradient
	
	      if (clearColor.colorStops) {
	        // Cache canvas gradient
	        clearColorGradientOrPattern = clearColor.__canvasGradient || Style.getGradient(ctx, clearColor, {
	          x: 0,
	          y: 0,
	          width: width,
	          height: height
	        });
	        clearColor.__canvasGradient = clearColorGradientOrPattern;
	      } // Pattern
	      else if (clearColor.image) {
	          clearColorGradientOrPattern = Pattern.prototype.getCanvasPattern.call(clearColor, ctx);
	        }
	
	      ctx.save();
	      ctx.fillStyle = clearColorGradientOrPattern || clearColor;
	      ctx.fillRect(0, 0, width, height);
	      ctx.restore();
	    }
	
	    if (haveMotionBLur) {
	      var domBack = this.domBack;
	      ctx.save();
	      ctx.globalAlpha = lastFrameAlpha;
	      ctx.drawImage(domBack, 0, 0, width, height);
	      ctx.restore();
	    }
	  }
	};
	var _default = Layer;
	module.exports = _default;

/***/ },
/* 2273 */
/***/ function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(385);
	
	var devicePixelRatio = _config.devicePixelRatio;
	
	var util = __webpack_require__(3);
	
	var logError = __webpack_require__(293);
	
	var BoundingRect = __webpack_require__(42);
	
	var timsort = __webpack_require__(555);
	
	var Layer = __webpack_require__(2272);
	
	var requestAnimationFrame = __webpack_require__(1078);
	
	var Image = __webpack_require__(232);
	
	var env = __webpack_require__(55);
	
	var HOVER_LAYER_ZLEVEL = 1e5;
	var CANVAS_ZLEVEL = 314159;
	var EL_AFTER_INCREMENTAL_INC = 0.01;
	var INCREMENTAL_INC = 0.001;
	
	function parseInt10(val) {
	  return parseInt(val, 10);
	}
	
	function isLayerValid(layer) {
	  if (!layer) {
	    return false;
	  }
	
	  if (layer.__builtin__) {
	    return true;
	  }
	
	  if (typeof layer.resize !== 'function' || typeof layer.refresh !== 'function') {
	    return false;
	  }
	
	  return true;
	}
	
	var tmpRect = new BoundingRect(0, 0, 0, 0);
	var viewRect = new BoundingRect(0, 0, 0, 0);
	
	function isDisplayableCulled(el, width, height) {
	  tmpRect.copy(el.getBoundingRect());
	
	  if (el.transform) {
	    tmpRect.applyTransform(el.transform);
	  }
	
	  viewRect.width = width;
	  viewRect.height = height;
	  return !tmpRect.intersect(viewRect);
	}
	
	function isClipPathChanged(clipPaths, prevClipPaths) {
	  // displayable.__clipPaths can only be `null`/`undefined` or an non-empty array.
	  if (clipPaths === prevClipPaths) {
	    return false;
	  }
	
	  if (!clipPaths || !prevClipPaths || clipPaths.length !== prevClipPaths.length) {
	    return true;
	  }
	
	  for (var i = 0; i < clipPaths.length; i++) {
	    if (clipPaths[i] !== prevClipPaths[i]) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function doClip(clipPaths, ctx) {
	  for (var i = 0; i < clipPaths.length; i++) {
	    var clipPath = clipPaths[i];
	    clipPath.setTransform(ctx);
	    ctx.beginPath();
	    clipPath.buildPath(ctx, clipPath.shape);
	    ctx.clip(); // Transform back
	
	    clipPath.restoreTransform(ctx);
	  }
	}
	
	function createRoot(width, height) {
	  var domRoot = document.createElement('div'); // domRoot.onselectstart = returnFalse; // Avoid page selected
	
	  domRoot.style.cssText = ['position:relative', // IOS13 safari probably has a compositing bug (z order of the canvas and the consequent
	  // dom does not act as expected) when some of the parent dom has
	  // `-webkit-overflow-scrolling: touch;` and the webpage is longer than one screen and
	  // the canvas is not at the top part of the page.
	  // Check `https://bugs.webkit.org/show_bug.cgi?id=203681` for more details. We remove
	  // this `overflow:hidden` to avoid the bug.
	  // 'overflow:hidden',
	  'width:' + width + 'px', 'height:' + height + 'px', 'padding:0', 'margin:0', 'border-width:0'].join(';') + ';';
	  return domRoot;
	}
	/**
	 * @alias module:zrender/Painter
	 * @constructor
	 * @param {HTMLElement} root 绘图容器
	 * @param {module:zrender/Storage} storage
	 * @param {Object} opts
	 */
	
	
	var Painter = function (root, storage, opts) {
	  this.type = 'canvas'; // In node environment using node-canvas
	
	  var singleCanvas = !root.nodeName // In node ?
	  || root.nodeName.toUpperCase() === 'CANVAS';
	  this._opts = opts = util.extend({}, opts || {});
	  /**
	   * @type {number}
	   */
	
	  this.dpr = opts.devicePixelRatio || devicePixelRatio;
	  /**
	   * @type {boolean}
	   * @private
	   */
	
	  this._singleCanvas = singleCanvas;
	  /**
	   * 绘图容器
	   * @type {HTMLElement}
	   */
	
	  this.root = root;
	  var rootStyle = root.style;
	
	  if (rootStyle) {
	    rootStyle['-webkit-tap-highlight-color'] = 'transparent';
	    rootStyle['-webkit-user-select'] = rootStyle['user-select'] = rootStyle['-webkit-touch-callout'] = 'none';
	    root.innerHTML = '';
	  }
	  /**
	   * @type {module:zrender/Storage}
	   */
	
	
	  this.storage = storage;
	  /**
	   * @type {Array.<number>}
	   * @private
	   */
	
	  var zlevelList = this._zlevelList = [];
	  /**
	   * @type {Object.<string, module:zrender/Layer>}
	   * @private
	   */
	
	  var layers = this._layers = {};
	  /**
	   * @type {Object.<string, Object>}
	   * @private
	   */
	
	  this._layerConfig = {};
	  /**
	   * zrender will do compositing when root is a canvas and have multiple zlevels.
	   */
	
	  this._needsManuallyCompositing = false;
	
	  if (!singleCanvas) {
	    this._width = this._getSize(0);
	    this._height = this._getSize(1);
	    var domRoot = this._domRoot = createRoot(this._width, this._height);
	    root.appendChild(domRoot);
	  } else {
	    var width = root.width;
	    var height = root.height;
	
	    if (opts.width != null) {
	      width = opts.width;
	    }
	
	    if (opts.height != null) {
	      height = opts.height;
	    }
	
	    this.dpr = opts.devicePixelRatio || 1; // Use canvas width and height directly
	
	    root.width = width * this.dpr;
	    root.height = height * this.dpr;
	    this._width = width;
	    this._height = height; // Create layer if only one given canvas
	    // Device can be specified to create a high dpi image.
	
	    var mainLayer = new Layer(root, this, this.dpr);
	    mainLayer.__builtin__ = true;
	    mainLayer.initContext(); // FIXME Use canvas width and height
	    // mainLayer.resize(width, height);
	
	    layers[CANVAS_ZLEVEL] = mainLayer;
	    mainLayer.zlevel = CANVAS_ZLEVEL; // Not use common zlevel.
	
	    zlevelList.push(CANVAS_ZLEVEL);
	    this._domRoot = root;
	  }
	  /**
	   * @type {module:zrender/Layer}
	   * @private
	   */
	
	
	  this._hoverlayer = null;
	  this._hoverElements = [];
	};
	
	Painter.prototype = {
	  constructor: Painter,
	  getType: function () {
	    return 'canvas';
	  },
	
	  /**
	   * If painter use a single canvas
	   * @return {boolean}
	   */
	  isSingleCanvas: function () {
	    return this._singleCanvas;
	  },
	
	  /**
	   * @return {HTMLDivElement}
	   */
	  getViewportRoot: function () {
	    return this._domRoot;
	  },
	  getViewportRootOffset: function () {
	    var viewportRoot = this.getViewportRoot();
	
	    if (viewportRoot) {
	      return {
	        offsetLeft: viewportRoot.offsetLeft || 0,
	        offsetTop: viewportRoot.offsetTop || 0
	      };
	    }
	  },
	
	  /**
	   * 刷新
	   * @param {boolean} [paintAll=false] 强制绘制所有displayable
	   */
	  refresh: function (paintAll) {
	    var list = this.storage.getDisplayList(true);
	    var zlevelList = this._zlevelList;
	    this._redrawId = Math.random();
	
	    this._paintList(list, paintAll, this._redrawId); // Paint custum layers
	
	
	    for (var i = 0; i < zlevelList.length; i++) {
	      var z = zlevelList[i];
	      var layer = this._layers[z];
	
	      if (!layer.__builtin__ && layer.refresh) {
	        var clearColor = i === 0 ? this._backgroundColor : null;
	        layer.refresh(clearColor);
	      }
	    }
	
	    this.refreshHover();
	    return this;
	  },
	  addHover: function (el, hoverStyle) {
	    if (el.__hoverMir) {
	      return;
	    }
	
	    var elMirror = new el.constructor({
	      style: el.style,
	      shape: el.shape,
	      z: el.z,
	      z2: el.z2,
	      silent: el.silent
	    });
	    elMirror.__from = el;
	    el.__hoverMir = elMirror;
	    hoverStyle && elMirror.setStyle(hoverStyle);
	
	    this._hoverElements.push(elMirror);
	
	    return elMirror;
	  },
	  removeHover: function (el) {
	    var elMirror = el.__hoverMir;
	    var hoverElements = this._hoverElements;
	    var idx = util.indexOf(hoverElements, elMirror);
	
	    if (idx >= 0) {
	      hoverElements.splice(idx, 1);
	    }
	
	    el.__hoverMir = null;
	  },
	  clearHover: function (el) {
	    var hoverElements = this._hoverElements;
	
	    for (var i = 0; i < hoverElements.length; i++) {
	      var from = hoverElements[i].__from;
	
	      if (from) {
	        from.__hoverMir = null;
	      }
	    }
	
	    hoverElements.length = 0;
	  },
	  refreshHover: function () {
	    var hoverElements = this._hoverElements;
	    var len = hoverElements.length;
	    var hoverLayer = this._hoverlayer;
	    hoverLayer && hoverLayer.clear();
	
	    if (!len) {
	      return;
	    }
	
	    timsort(hoverElements, this.storage.displayableSortFunc); // Use a extream large zlevel
	    // FIXME?
	
	    if (!hoverLayer) {
	      hoverLayer = this._hoverlayer = this.getLayer(HOVER_LAYER_ZLEVEL);
	    }
	
	    var scope = {};
	    hoverLayer.ctx.save();
	
	    for (var i = 0; i < len;) {
	      var el = hoverElements[i];
	      var originalEl = el.__from; // Original el is removed
	      // PENDING
	
	      if (!(originalEl && originalEl.__zr)) {
	        hoverElements.splice(i, 1);
	        originalEl.__hoverMir = null;
	        len--;
	        continue;
	      }
	
	      i++; // Use transform
	      // FIXME style and shape ?
	
	      if (!originalEl.invisible) {
	        el.transform = originalEl.transform;
	        el.invTransform = originalEl.invTransform;
	        el.__clipPaths = originalEl.__clipPaths; // el.
	
	        this._doPaintEl(el, hoverLayer, true, scope);
	      }
	    }
	
	    hoverLayer.ctx.restore();
	  },
	  getHoverLayer: function () {
	    return this.getLayer(HOVER_LAYER_ZLEVEL);
	  },
	  _paintList: function (list, paintAll, redrawId) {
	    if (this._redrawId !== redrawId) {
	      return;
	    }
	
	    paintAll = paintAll || false;
	
	    this._updateLayerStatus(list);
	
	    var finished = this._doPaintList(list, paintAll);
	
	    if (this._needsManuallyCompositing) {
	      this._compositeManually();
	    }
	
	    if (!finished) {
	      var self = this;
	      requestAnimationFrame(function () {
	        self._paintList(list, paintAll, redrawId);
	      });
	    }
	  },
	  _compositeManually: function () {
	    var ctx = this.getLayer(CANVAS_ZLEVEL).ctx;
	    var width = this._domRoot.width;
	    var height = this._domRoot.height;
	    ctx.clearRect(0, 0, width, height); // PENDING, If only builtin layer?
	
	    this.eachBuiltinLayer(function (layer) {
	      if (layer.virtual) {
	        ctx.drawImage(layer.dom, 0, 0, width, height);
	      }
	    });
	  },
	  _doPaintList: function (list, paintAll) {
	    var layerList = [];
	
	    for (var zi = 0; zi < this._zlevelList.length; zi++) {
	      var zlevel = this._zlevelList[zi];
	      var layer = this._layers[zlevel];
	
	      if (layer.__builtin__ && layer !== this._hoverlayer && (layer.__dirty || paintAll)) {
	        layerList.push(layer);
	      }
	    }
	
	    var finished = true;
	
	    for (var k = 0; k < layerList.length; k++) {
	      var layer = layerList[k];
	      var ctx = layer.ctx;
	      var scope = {};
	      ctx.save();
	      var start = paintAll ? layer.__startIndex : layer.__drawIndex;
	      var useTimer = !paintAll && layer.incremental && Date.now;
	      var startTime = useTimer && Date.now();
	      var clearColor = layer.zlevel === this._zlevelList[0] ? this._backgroundColor : null; // All elements in this layer are cleared.
	
	      if (layer.__startIndex === layer.__endIndex) {
	        layer.clear(false, clearColor);
	      } else if (start === layer.__startIndex) {
	        var firstEl = list[start];
	
	        if (!firstEl.incremental || !firstEl.notClear || paintAll) {
	          layer.clear(false, clearColor);
	        }
	      }
	
	      if (start === -1) {
	        console.error('For some unknown reason. drawIndex is -1');
	        start = layer.__startIndex;
	      }
	
	      for (var i = start; i < layer.__endIndex; i++) {
	        var el = list[i];
	
	        this._doPaintEl(el, layer, paintAll, scope);
	
	        el.__dirty = el.__dirtyText = false;
	
	        if (useTimer) {
	          // Date.now can be executed in 13,025,305 ops/second.
	          var dTime = Date.now() - startTime; // Give 15 millisecond to draw.
	          // The rest elements will be drawn in the next frame.
	
	          if (dTime > 15) {
	            break;
	          }
	        }
	      }
	
	      layer.__drawIndex = i;
	
	      if (layer.__drawIndex < layer.__endIndex) {
	        finished = false;
	      }
	
	      if (scope.prevElClipPaths) {
	        // Needs restore the state. If last drawn element is in the clipping area.
	        ctx.restore();
	      }
	
	      ctx.restore();
	    }
	
	    if (env.wxa) {
	      // Flush for weixin application
	      util.each(this._layers, function (layer) {
	        if (layer && layer.ctx && layer.ctx.draw) {
	          layer.ctx.draw();
	        }
	      });
	    }
	
	    return finished;
	  },
	  _doPaintEl: function (el, currentLayer, forcePaint, scope) {
	    var ctx = currentLayer.ctx;
	    var m = el.transform;
	
	    if ((currentLayer.__dirty || forcePaint) && // Ignore invisible element
	    !el.invisible // Ignore transparent element
	    && el.style.opacity !== 0 // Ignore scale 0 element, in some environment like node-canvas
	    // Draw a scale 0 element can cause all following draw wrong
	    // And setTransform with scale 0 will cause set back transform failed.
	    && !(m && !m[0] && !m[3]) // Ignore culled element
	    && !(el.culling && isDisplayableCulled(el, this._width, this._height))) {
	      var clipPaths = el.__clipPaths;
	      var prevElClipPaths = scope.prevElClipPaths; // Optimize when clipping on group with several elements
	
	      if (!prevElClipPaths || isClipPathChanged(clipPaths, prevElClipPaths)) {
	        // If has previous clipping state, restore from it
	        if (prevElClipPaths) {
	          ctx.restore();
	          scope.prevElClipPaths = null; // Reset prevEl since context has been restored
	
	          scope.prevEl = null;
	        } // New clipping state
	
	
	        if (clipPaths) {
	          ctx.save();
	          doClip(clipPaths, ctx);
	          scope.prevElClipPaths = clipPaths;
	        }
	      }
	
	      el.beforeBrush && el.beforeBrush(ctx);
	      el.brush(ctx, scope.prevEl || null);
	      scope.prevEl = el;
	      el.afterBrush && el.afterBrush(ctx);
	    }
	  },
	
	  /**
	   * 获取 zlevel 所在层，如果不存在则会创建一个新的层
	   * @param {number} zlevel
	   * @param {boolean} virtual Virtual layer will not be inserted into dom.
	   * @return {module:zrender/Layer}
	   */
	  getLayer: function (zlevel, virtual) {
	    if (this._singleCanvas && !this._needsManuallyCompositing) {
	      zlevel = CANVAS_ZLEVEL;
	    }
	
	    var layer = this._layers[zlevel];
	
	    if (!layer) {
	      // Create a new layer
	      layer = new Layer('zr_' + zlevel, this, this.dpr);
	      layer.zlevel = zlevel;
	      layer.__builtin__ = true;
	
	      if (this._layerConfig[zlevel]) {
	        util.merge(layer, this._layerConfig[zlevel], true);
	      } // TODO Remove EL_AFTER_INCREMENTAL_INC magic number
	      else if (this._layerConfig[zlevel - EL_AFTER_INCREMENTAL_INC]) {
	          util.merge(layer, this._layerConfig[zlevel - EL_AFTER_INCREMENTAL_INC], true);
	        }
	
	      if (virtual) {
	        layer.virtual = virtual;
	      }
	
	      this.insertLayer(zlevel, layer); // Context is created after dom inserted to document
	      // Or excanvas will get 0px clientWidth and clientHeight
	
	      layer.initContext();
	    }
	
	    return layer;
	  },
	  insertLayer: function (zlevel, layer) {
	    var layersMap = this._layers;
	    var zlevelList = this._zlevelList;
	    var len = zlevelList.length;
	    var prevLayer = null;
	    var i = -1;
	    var domRoot = this._domRoot;
	
	    if (layersMap[zlevel]) {
	      logError('ZLevel ' + zlevel + ' has been used already');
	      return;
	    } // Check if is a valid layer
	
	
	    if (!isLayerValid(layer)) {
	      logError('Layer of zlevel ' + zlevel + ' is not valid');
	      return;
	    }
	
	    if (len > 0 && zlevel > zlevelList[0]) {
	      for (i = 0; i < len - 1; i++) {
	        if (zlevelList[i] < zlevel && zlevelList[i + 1] > zlevel) {
	          break;
	        }
	      }
	
	      prevLayer = layersMap[zlevelList[i]];
	    }
	
	    zlevelList.splice(i + 1, 0, zlevel);
	    layersMap[zlevel] = layer; // Vitual layer will not directly show on the screen.
	    // (It can be a WebGL layer and assigned to a ZImage element)
	    // But it still under management of zrender.
	
	    if (!layer.virtual) {
	      if (prevLayer) {
	        var prevDom = prevLayer.dom;
	
	        if (prevDom.nextSibling) {
	          domRoot.insertBefore(layer.dom, prevDom.nextSibling);
	        } else {
	          domRoot.appendChild(layer.dom);
	        }
	      } else {
	        if (domRoot.firstChild) {
	          domRoot.insertBefore(layer.dom, domRoot.firstChild);
	        } else {
	          domRoot.appendChild(layer.dom);
	        }
	      }
	    }
	  },
	  // Iterate each layer
	  eachLayer: function (cb, context) {
	    var zlevelList = this._zlevelList;
	    var z;
	    var i;
	
	    for (i = 0; i < zlevelList.length; i++) {
	      z = zlevelList[i];
	      cb.call(context, this._layers[z], z);
	    }
	  },
	  // Iterate each buildin layer
	  eachBuiltinLayer: function (cb, context) {
	    var zlevelList = this._zlevelList;
	    var layer;
	    var z;
	    var i;
	
	    for (i = 0; i < zlevelList.length; i++) {
	      z = zlevelList[i];
	      layer = this._layers[z];
	
	      if (layer.__builtin__) {
	        cb.call(context, layer, z);
	      }
	    }
	  },
	  // Iterate each other layer except buildin layer
	  eachOtherLayer: function (cb, context) {
	    var zlevelList = this._zlevelList;
	    var layer;
	    var z;
	    var i;
	
	    for (i = 0; i < zlevelList.length; i++) {
	      z = zlevelList[i];
	      layer = this._layers[z];
	
	      if (!layer.__builtin__) {
	        cb.call(context, layer, z);
	      }
	    }
	  },
	
	  /**
	   * 获取所有已创建的层
	   * @param {Array.<module:zrender/Layer>} [prevLayer]
	   */
	  getLayers: function () {
	    return this._layers;
	  },
	  _updateLayerStatus: function (list) {
	    this.eachBuiltinLayer(function (layer, z) {
	      layer.__dirty = layer.__used = false;
	    });
	
	    function updatePrevLayer(idx) {
	      if (prevLayer) {
	        if (prevLayer.__endIndex !== idx) {
	          prevLayer.__dirty = true;
	        }
	
	        prevLayer.__endIndex = idx;
	      }
	    }
	
	    if (this._singleCanvas) {
	      for (var i = 1; i < list.length; i++) {
	        var el = list[i];
	
	        if (el.zlevel !== list[i - 1].zlevel || el.incremental) {
	          this._needsManuallyCompositing = true;
	          break;
	        }
	      }
	    }
	
	    var prevLayer = null;
	    var incrementalLayerCount = 0;
	    var prevZlevel;
	
	    for (var i = 0; i < list.length; i++) {
	      var el = list[i];
	      var zlevel = el.zlevel;
	      var layer;
	
	      if (prevZlevel !== zlevel) {
	        prevZlevel = zlevel;
	        incrementalLayerCount = 0;
	      } // TODO Not use magic number on zlevel.
	      // Each layer with increment element can be separated to 3 layers.
	      //          (Other Element drawn after incremental element)
	      // -----------------zlevel + EL_AFTER_INCREMENTAL_INC--------------------
	      //                      (Incremental element)
	      // ----------------------zlevel + INCREMENTAL_INC------------------------
	      //              (Element drawn before incremental element)
	      // --------------------------------zlevel--------------------------------
	
	
	      if (el.incremental) {
	        layer = this.getLayer(zlevel + INCREMENTAL_INC, this._needsManuallyCompositing);
	        layer.incremental = true;
	        incrementalLayerCount = 1;
	      } else {
	        layer = this.getLayer(zlevel + (incrementalLayerCount > 0 ? EL_AFTER_INCREMENTAL_INC : 0), this._needsManuallyCompositing);
	      }
	
	      if (!layer.__builtin__) {
	        logError('ZLevel ' + zlevel + ' has been used by unkown layer ' + layer.id);
	      }
	
	      if (layer !== prevLayer) {
	        layer.__used = true;
	
	        if (layer.__startIndex !== i) {
	          layer.__dirty = true;
	        }
	
	        layer.__startIndex = i;
	
	        if (!layer.incremental) {
	          layer.__drawIndex = i;
	        } else {
	          // Mark layer draw index needs to update.
	          layer.__drawIndex = -1;
	        }
	
	        updatePrevLayer(i);
	        prevLayer = layer;
	      }
	
	      if (el.__dirty) {
	        layer.__dirty = true;
	
	        if (layer.incremental && layer.__drawIndex < 0) {
	          // Start draw from the first dirty element.
	          layer.__drawIndex = i;
	        }
	      }
	    }
	
	    updatePrevLayer(i);
	    this.eachBuiltinLayer(function (layer, z) {
	      // Used in last frame but not in this frame. Needs clear
	      if (!layer.__used && layer.getElementCount() > 0) {
	        layer.__dirty = true;
	        layer.__startIndex = layer.__endIndex = layer.__drawIndex = 0;
	      } // For incremental layer. In case start index changed and no elements are dirty.
	
	
	      if (layer.__dirty && layer.__drawIndex < 0) {
	        layer.__drawIndex = layer.__startIndex;
	      }
	    });
	  },
	
	  /**
	   * 清除hover层外所有内容
	   */
	  clear: function () {
	    this.eachBuiltinLayer(this._clearLayer);
	    return this;
	  },
	  _clearLayer: function (layer) {
	    layer.clear();
	  },
	  setBackgroundColor: function (backgroundColor) {
	    this._backgroundColor = backgroundColor;
	  },
	
	  /**
	   * 修改指定zlevel的绘制参数
	   *
	   * @param {string} zlevel
	   * @param {Object} config 配置对象
	   * @param {string} [config.clearColor=0] 每次清空画布的颜色
	   * @param {string} [config.motionBlur=false] 是否开启动态模糊
	   * @param {number} [config.lastFrameAlpha=0.7]
	   *                 在开启动态模糊的时候使用，与上一帧混合的alpha值，值越大尾迹越明显
	   */
	  configLayer: function (zlevel, config) {
	    if (config) {
	      var layerConfig = this._layerConfig;
	
	      if (!layerConfig[zlevel]) {
	        layerConfig[zlevel] = config;
	      } else {
	        util.merge(layerConfig[zlevel], config, true);
	      }
	
	      for (var i = 0; i < this._zlevelList.length; i++) {
	        var _zlevel = this._zlevelList[i]; // TODO Remove EL_AFTER_INCREMENTAL_INC magic number
	
	        if (_zlevel === zlevel || _zlevel === zlevel + EL_AFTER_INCREMENTAL_INC) {
	          var layer = this._layers[_zlevel];
	          util.merge(layer, layerConfig[zlevel], true);
	        }
	      }
	    }
	  },
	
	  /**
	   * 删除指定层
	   * @param {number} zlevel 层所在的zlevel
	   */
	  delLayer: function (zlevel) {
	    var layers = this._layers;
	    var zlevelList = this._zlevelList;
	    var layer = layers[zlevel];
	
	    if (!layer) {
	      return;
	    }
	
	    layer.dom.parentNode.removeChild(layer.dom);
	    delete layers[zlevel];
	    zlevelList.splice(util.indexOf(zlevelList, zlevel), 1);
	  },
	
	  /**
	   * 区域大小变化后重绘
	   */
	  resize: function (width, height) {
	    if (!this._domRoot.style) {
	      // Maybe in node or worker
	      if (width == null || height == null) {
	        return;
	      }
	
	      this._width = width;
	      this._height = height;
	      this.getLayer(CANVAS_ZLEVEL).resize(width, height);
	    } else {
	      var domRoot = this._domRoot; // FIXME Why ?
	
	      domRoot.style.display = 'none'; // Save input w/h
	
	      var opts = this._opts;
	      width != null && (opts.width = width);
	      height != null && (opts.height = height);
	      width = this._getSize(0);
	      height = this._getSize(1);
	      domRoot.style.display = ''; // 优化没有实际改变的resize
	
	      if (this._width !== width || height !== this._height) {
	        domRoot.style.width = width + 'px';
	        domRoot.style.height = height + 'px';
	
	        for (var id in this._layers) {
	          if (this._layers.hasOwnProperty(id)) {
	            this._layers[id].resize(width, height);
	          }
	        }
	
	        util.each(this._progressiveLayers, function (layer) {
	          layer.resize(width, height);
	        });
	        this.refresh(true);
	      }
	
	      this._width = width;
	      this._height = height;
	    }
	
	    return this;
	  },
	
	  /**
	   * 清除单独的一个层
	   * @param {number} zlevel
	   */
	  clearLayer: function (zlevel) {
	    var layer = this._layers[zlevel];
	
	    if (layer) {
	      layer.clear();
	    }
	  },
	
	  /**
	   * 释放
	   */
	  dispose: function () {
	    this.root.innerHTML = '';
	    this.root = this.storage = this._domRoot = this._layers = null;
	  },
	
	  /**
	   * Get canvas which has all thing rendered
	   * @param {Object} opts
	   * @param {string} [opts.backgroundColor]
	   * @param {number} [opts.pixelRatio]
	   */
	  getRenderedCanvas: function (opts) {
	    opts = opts || {};
	
	    if (this._singleCanvas && !this._compositeManually) {
	      return this._layers[CANVAS_ZLEVEL].dom;
	    }
	
	    var imageLayer = new Layer('image', this, opts.pixelRatio || this.dpr);
	    imageLayer.initContext();
	    imageLayer.clear(false, opts.backgroundColor || this._backgroundColor);
	
	    if (opts.pixelRatio <= this.dpr) {
	      this.refresh();
	      var width = imageLayer.dom.width;
	      var height = imageLayer.dom.height;
	      var ctx = imageLayer.ctx;
	      this.eachLayer(function (layer) {
	        if (layer.__builtin__) {
	          ctx.drawImage(layer.dom, 0, 0, width, height);
	        } else if (layer.renderToCanvas) {
	          imageLayer.ctx.save();
	          layer.renderToCanvas(imageLayer.ctx);
	          imageLayer.ctx.restore();
	        }
	      });
	    } else {
	      // PENDING, echarts-gl and incremental rendering.
	      var scope = {};
	      var displayList = this.storage.getDisplayList(true);
	
	      for (var i = 0; i < displayList.length; i++) {
	        var el = displayList[i];
	
	        this._doPaintEl(el, imageLayer, true, scope);
	      }
	    }
	
	    return imageLayer.dom;
	  },
	
	  /**
	   * 获取绘图区域宽度
	   */
	  getWidth: function () {
	    return this._width;
	  },
	
	  /**
	   * 获取绘图区域高度
	   */
	  getHeight: function () {
	    return this._height;
	  },
	  _getSize: function (whIdx) {
	    var opts = this._opts;
	    var wh = ['width', 'height'][whIdx];
	    var cwh = ['clientWidth', 'clientHeight'][whIdx];
	    var plt = ['paddingLeft', 'paddingTop'][whIdx];
	    var prb = ['paddingRight', 'paddingBottom'][whIdx];
	
	    if (opts[wh] != null && opts[wh] !== 'auto') {
	      return parseFloat(opts[wh]);
	    }
	
	    var root = this.root; // IE8 does not support getComputedStyle, but it use VML.
	
	    var stl = document.defaultView.getComputedStyle(root);
	    return (root[cwh] || parseInt10(stl[wh]) || parseInt10(root.style[wh])) - (parseInt10(stl[plt]) || 0) - (parseInt10(stl[prb]) || 0) | 0;
	  },
	  pathToImage: function (path, dpr) {
	    dpr = dpr || this.dpr;
	    var canvas = document.createElement('canvas');
	    var ctx = canvas.getContext('2d');
	    var rect = path.getBoundingRect();
	    var style = path.style;
	    var shadowBlurSize = style.shadowBlur * dpr;
	    var shadowOffsetX = style.shadowOffsetX * dpr;
	    var shadowOffsetY = style.shadowOffsetY * dpr;
	    var lineWidth = style.hasStroke() ? style.lineWidth : 0;
	    var leftMargin = Math.max(lineWidth / 2, -shadowOffsetX + shadowBlurSize);
	    var rightMargin = Math.max(lineWidth / 2, shadowOffsetX + shadowBlurSize);
	    var topMargin = Math.max(lineWidth / 2, -shadowOffsetY + shadowBlurSize);
	    var bottomMargin = Math.max(lineWidth / 2, shadowOffsetY + shadowBlurSize);
	    var width = rect.width + leftMargin + rightMargin;
	    var height = rect.height + topMargin + bottomMargin;
	    canvas.width = width * dpr;
	    canvas.height = height * dpr;
	    ctx.scale(dpr, dpr);
	    ctx.clearRect(0, 0, width, height);
	    ctx.dpr = dpr;
	    var pathTransform = {
	      position: path.position,
	      rotation: path.rotation,
	      scale: path.scale
	    };
	    path.position = [leftMargin - rect.x, topMargin - rect.y];
	    path.rotation = 0;
	    path.scale = [1, 1];
	    path.updateTransform();
	
	    if (path) {
	      path.brush(ctx);
	    }
	
	    var ImageShape = Image;
	    var imgShape = new ImageShape({
	      style: {
	        x: 0,
	        y: 0,
	        image: canvas
	      }
	    });
	
	    if (pathTransform.position != null) {
	      imgShape.position = path.position = pathTransform.position;
	    }
	
	    if (pathTransform.rotation != null) {
	      imgShape.rotation = path.rotation = pathTransform.rotation;
	    }
	
	    if (pathTransform.scale != null) {
	      imgShape.scale = path.scale = pathTransform.scale;
	    }
	
	    return imgShape;
	  }
	};
	var _default = Painter;
	module.exports = _default;

/***/ },
/* 2274 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(3);
	
	var env = __webpack_require__(55);
	
	var Group = __webpack_require__(187);
	
	var timsort = __webpack_require__(555);
	
	// Use timsort because in most case elements are partially sorted
	// https://jsfiddle.net/pissang/jr4x7mdm/8/
	function shapeCompareFunc(a, b) {
	  if (a.zlevel === b.zlevel) {
	    if (a.z === b.z) {
	      // if (a.z2 === b.z2) {
	      //     // FIXME Slow has renderidx compare
	      //     // http://stackoverflow.com/questions/20883421/sorting-in-javascript-should-every-compare-function-have-a-return-0-statement
	      //     // https://github.com/v8/v8/blob/47cce544a31ed5577ffe2963f67acb4144ee0232/src/js/array.js#L1012
	      //     return a.__renderidx - b.__renderidx;
	      // }
	      return a.z2 - b.z2;
	    }
	
	    return a.z - b.z;
	  }
	
	  return a.zlevel - b.zlevel;
	}
	/**
	 * 内容仓库 (M)
	 * @alias module:zrender/Storage
	 * @constructor
	 */
	
	
	var Storage = function () {
	  // jshint ignore:line
	  this._roots = [];
	  this._displayList = [];
	  this._displayListLen = 0;
	};
	
	Storage.prototype = {
	  constructor: Storage,
	
	  /**
	   * @param  {Function} cb
	   *
	   */
	  traverse: function (cb, context) {
	    for (var i = 0; i < this._roots.length; i++) {
	      this._roots[i].traverse(cb, context);
	    }
	  },
	
	  /**
	   * 返回所有图形的绘制队列
	   * @param {boolean} [update=false] 是否在返回前更新该数组
	   * @param {boolean} [includeIgnore=false] 是否包含 ignore 的数组, 在 update 为 true 的时候有效
	   *
	   * 详见{@link module:zrender/graphic/Displayable.prototype.updateDisplayList}
	   * @return {Array.<module:zrender/graphic/Displayable>}
	   */
	  getDisplayList: function (update, includeIgnore) {
	    includeIgnore = includeIgnore || false;
	
	    if (update) {
	      this.updateDisplayList(includeIgnore);
	    }
	
	    return this._displayList;
	  },
	
	  /**
	   * 更新图形的绘制队列。
	   * 每次绘制前都会调用，该方法会先深度优先遍历整个树，更新所有Group和Shape的变换并且把所有可见的Shape保存到数组中，
	   * 最后根据绘制的优先级（zlevel > z > 插入顺序）排序得到绘制队列
	   * @param {boolean} [includeIgnore=false] 是否包含 ignore 的数组
	   */
	  updateDisplayList: function (includeIgnore) {
	    this._displayListLen = 0;
	    var roots = this._roots;
	    var displayList = this._displayList;
	
	    for (var i = 0, len = roots.length; i < len; i++) {
	      this._updateAndAddDisplayable(roots[i], null, includeIgnore);
	    }
	
	    displayList.length = this._displayListLen;
	    env.canvasSupported && timsort(displayList, shapeCompareFunc);
	  },
	  _updateAndAddDisplayable: function (el, clipPaths, includeIgnore) {
	    if (el.ignore && !includeIgnore) {
	      return;
	    }
	
	    el.beforeUpdate();
	
	    if (el.__dirty) {
	      el.update();
	    }
	
	    el.afterUpdate();
	    var userSetClipPath = el.clipPath;
	
	    if (userSetClipPath) {
	      // FIXME 效率影响
	      if (clipPaths) {
	        clipPaths = clipPaths.slice();
	      } else {
	        clipPaths = [];
	      }
	
	      var currentClipPath = userSetClipPath;
	      var parentClipPath = el; // Recursively add clip path
	
	      while (currentClipPath) {
	        // clipPath 的变换是基于使用这个 clipPath 的元素
	        currentClipPath.parent = parentClipPath;
	        currentClipPath.updateTransform();
	        clipPaths.push(currentClipPath);
	        parentClipPath = currentClipPath;
	        currentClipPath = currentClipPath.clipPath;
	      }
	    }
	
	    if (el.isGroup) {
	      var children = el._children;
	
	      for (var i = 0; i < children.length; i++) {
	        var child = children[i]; // Force to mark as dirty if group is dirty
	        // FIXME __dirtyPath ?
	
	        if (el.__dirty) {
	          child.__dirty = true;
	        }
	
	        this._updateAndAddDisplayable(child, clipPaths, includeIgnore);
	      } // Mark group clean here
	
	
	      el.__dirty = false;
	    } else {
	      el.__clipPaths = clipPaths;
	      this._displayList[this._displayListLen++] = el;
	    }
	  },
	
	  /**
	   * 添加图形(Shape)或者组(Group)到根节点
	   * @param {module:zrender/Element} el
	   */
	  addRoot: function (el) {
	    if (el.__storage === this) {
	      return;
	    }
	
	    if (el instanceof Group) {
	      el.addChildrenToStorage(this);
	    }
	
	    this.addToStorage(el);
	
	    this._roots.push(el);
	  },
	
	  /**
	   * 删除指定的图形(Shape)或者组(Group)
	   * @param {string|Array.<string>} [el] 如果为空清空整个Storage
	   */
	  delRoot: function (el) {
	    if (el == null) {
	      // 不指定el清空
	      for (var i = 0; i < this._roots.length; i++) {
	        var root = this._roots[i];
	
	        if (root instanceof Group) {
	          root.delChildrenFromStorage(this);
	        }
	      }
	
	      this._roots = [];
	      this._displayList = [];
	      this._displayListLen = 0;
	      return;
	    }
	
	    if (el instanceof Array) {
	      for (var i = 0, l = el.length; i < l; i++) {
	        this.delRoot(el[i]);
	      }
	
	      return;
	    }
	
	    var idx = util.indexOf(this._roots, el);
	
	    if (idx >= 0) {
	      this.delFromStorage(el);
	
	      this._roots.splice(idx, 1);
	
	      if (el instanceof Group) {
	        el.delChildrenFromStorage(this);
	      }
	    }
	  },
	  addToStorage: function (el) {
	    if (el) {
	      el.__storage = this;
	      el.dirty(false);
	    }
	
	    return this;
	  },
	  delFromStorage: function (el) {
	    if (el) {
	      el.__storage = null;
	    }
	
	    return this;
	  },
	
	  /**
	   * 清空并且释放Storage
	   */
	  dispose: function () {
	    this._renderList = this._roots = null;
	  },
	  displayableSortFunc: shapeCompareFunc
	};
	var _default = Storage;
	module.exports = _default;

/***/ },
/* 2275 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(3);
	
	var _event = __webpack_require__(113);
	
	var Dispatcher = _event.Dispatcher;
	
	var requestAnimationFrame = __webpack_require__(1078);
	
	var Animator = __webpack_require__(1077);
	
	/**
	 * Animation main class, dispatch and manage all animation controllers
	 *
	 * @module zrender/animation/Animation
	 * @author pissang(https://github.com/pissang)
	 */
	// TODO Additive animation
	// http://iosoteric.com/additive-animations-animatewithduration-in-ios-8/
	// https://developer.apple.com/videos/wwdc2014/#236
	
	/**
	 * @typedef {Object} IZRenderStage
	 * @property {Function} update
	 */
	
	/**
	 * @alias module:zrender/animation/Animation
	 * @constructor
	 * @param {Object} [options]
	 * @param {Function} [options.onframe]
	 * @param {IZRenderStage} [options.stage]
	 * @example
	 *     var animation = new Animation();
	 *     var obj = {
	 *         x: 100,
	 *         y: 100
	 *     };
	 *     animation.animate(node.position)
	 *         .when(1000, {
	 *             x: 500,
	 *             y: 500
	 *         })
	 *         .when(2000, {
	 *             x: 100,
	 *             y: 100
	 *         })
	 *         .start('spline');
	 */
	var Animation = function (options) {
	  options = options || {};
	  this.stage = options.stage || {};
	
	  this.onframe = options.onframe || function () {}; // private properties
	
	
	  this._clips = [];
	  this._running = false;
	  this._time;
	  this._pausedTime;
	  this._pauseStart;
	  this._paused = false;
	  Dispatcher.call(this);
	};
	
	Animation.prototype = {
	  constructor: Animation,
	
	  /**
	   * Add clip
	   * @param {module:zrender/animation/Clip} clip
	   */
	  addClip: function (clip) {
	    this._clips.push(clip);
	  },
	
	  /**
	   * Add animator
	   * @param {module:zrender/animation/Animator} animator
	   */
	  addAnimator: function (animator) {
	    animator.animation = this;
	    var clips = animator.getClips();
	
	    for (var i = 0; i < clips.length; i++) {
	      this.addClip(clips[i]);
	    }
	  },
	
	  /**
	   * Delete animation clip
	   * @param {module:zrender/animation/Clip} clip
	   */
	  removeClip: function (clip) {
	    var idx = util.indexOf(this._clips, clip);
	
	    if (idx >= 0) {
	      this._clips.splice(idx, 1);
	    }
	  },
	
	  /**
	   * Delete animation clip
	   * @param {module:zrender/animation/Animator} animator
	   */
	  removeAnimator: function (animator) {
	    var clips = animator.getClips();
	
	    for (var i = 0; i < clips.length; i++) {
	      this.removeClip(clips[i]);
	    }
	
	    animator.animation = null;
	  },
	  _update: function () {
	    var time = new Date().getTime() - this._pausedTime;
	
	    var delta = time - this._time;
	    var clips = this._clips;
	    var len = clips.length;
	    var deferredEvents = [];
	    var deferredClips = [];
	
	    for (var i = 0; i < len; i++) {
	      var clip = clips[i];
	      var e = clip.step(time, delta); // Throw out the events need to be called after
	      // stage.update, like destroy
	
	      if (e) {
	        deferredEvents.push(e);
	        deferredClips.push(clip);
	      }
	    } // Remove the finished clip
	
	
	    for (var i = 0; i < len;) {
	      if (clips[i]._needsRemove) {
	        clips[i] = clips[len - 1];
	        clips.pop();
	        len--;
	      } else {
	        i++;
	      }
	    }
	
	    len = deferredEvents.length;
	
	    for (var i = 0; i < len; i++) {
	      deferredClips[i].fire(deferredEvents[i]);
	    }
	
	    this._time = time;
	    this.onframe(delta); // 'frame' should be triggered before stage, because upper application
	    // depends on the sequence (e.g., echarts-stream and finish
	    // event judge)
	
	    this.trigger('frame', delta);
	
	    if (this.stage.update) {
	      this.stage.update();
	    }
	  },
	  _startLoop: function () {
	    var self = this;
	    this._running = true;
	
	    function step() {
	      if (self._running) {
	        requestAnimationFrame(step);
	        !self._paused && self._update();
	      }
	    }
	
	    requestAnimationFrame(step);
	  },
	
	  /**
	   * Start animation.
	   */
	  start: function () {
	    this._time = new Date().getTime();
	    this._pausedTime = 0;
	
	    this._startLoop();
	  },
	
	  /**
	   * Stop animation.
	   */
	  stop: function () {
	    this._running = false;
	  },
	
	  /**
	   * Pause animation.
	   */
	  pause: function () {
	    if (!this._paused) {
	      this._pauseStart = new Date().getTime();
	      this._paused = true;
	    }
	  },
	
	  /**
	   * Resume animation.
	   */
	  resume: function () {
	    if (this._paused) {
	      this._pausedTime += new Date().getTime() - this._pauseStart;
	      this._paused = false;
	    }
	  },
	
	  /**
	   * Clear animation.
	   */
	  clear: function () {
	    this._clips = [];
	  },
	
	  /**
	   * Whether animation finished.
	   */
	  isFinished: function () {
	    return !this._clips.length;
	  },
	
	  /**
	   * Creat animator for a target, whose props can be animated.
	   *
	   * @param  {Object} target
	   * @param  {Object} options
	   * @param  {boolean} [options.loop=false] Whether loop animation.
	   * @param  {Function} [options.getter=null] Get value from target.
	   * @param  {Function} [options.setter=null] Set value to target.
	   * @return {module:zrender/animation/Animation~Animator}
	   */
	  // TODO Gap
	  animate: function (target, options) {
	    options = options || {};
	    var animator = new Animator(target, options.loop, options.getter, options.setter);
	    this.addAnimator(animator);
	    return animator;
	  }
	};
	util.mixin(Animation, Dispatcher);
	var _default = Animation;
	module.exports = _default;

/***/ },
/* 2276 */
/***/ function(module, exports, __webpack_require__) {

	var easingFuncs = __webpack_require__(2277);
	
	/**
	 * 动画主控制器
	 * @config target 动画对象，可以是数组，如果是数组的话会批量分发onframe等事件
	 * @config life(1000) 动画时长
	 * @config delay(0) 动画延迟时间
	 * @config loop(true)
	 * @config gap(0) 循环的间隔时间
	 * @config onframe
	 * @config easing(optional)
	 * @config ondestroy(optional)
	 * @config onrestart(optional)
	 *
	 * TODO pause
	 */
	function Clip(options) {
	  this._target = options.target; // 生命周期
	
	  this._life = options.life || 1000; // 延时
	
	  this._delay = options.delay || 0; // 开始时间
	  // this._startTime = new Date().getTime() + this._delay;// 单位毫秒
	
	  this._initialized = false; // 是否循环
	
	  this.loop = options.loop == null ? false : options.loop;
	  this.gap = options.gap || 0;
	  this.easing = options.easing || 'Linear';
	  this.onframe = options.onframe;
	  this.ondestroy = options.ondestroy;
	  this.onrestart = options.onrestart;
	  this._pausedTime = 0;
	  this._paused = false;
	}
	
	Clip.prototype = {
	  constructor: Clip,
	  step: function (globalTime, deltaTime) {
	    // Set startTime on first step, or _startTime may has milleseconds different between clips
	    // PENDING
	    if (!this._initialized) {
	      this._startTime = globalTime + this._delay;
	      this._initialized = true;
	    }
	
	    if (this._paused) {
	      this._pausedTime += deltaTime;
	      return;
	    }
	
	    var percent = (globalTime - this._startTime - this._pausedTime) / this._life; // 还没开始
	
	    if (percent < 0) {
	      return;
	    }
	
	    percent = Math.min(percent, 1);
	    var easing = this.easing;
	    var easingFunc = typeof easing === 'string' ? easingFuncs[easing] : easing;
	    var schedule = typeof easingFunc === 'function' ? easingFunc(percent) : percent;
	    this.fire('frame', schedule); // 结束
	
	    if (percent === 1) {
	      if (this.loop) {
	        this.restart(globalTime); // 重新开始周期
	        // 抛出而不是直接调用事件直到 stage.update 后再统一调用这些事件
	
	        return 'restart';
	      } // 动画完成将这个控制器标识为待删除
	      // 在Animation.update中进行批量删除
	
	
	      this._needsRemove = true;
	      return 'destroy';
	    }
	
	    return null;
	  },
	  restart: function (globalTime) {
	    var remainder = (globalTime - this._startTime - this._pausedTime) % this._life;
	    this._startTime = globalTime - remainder + this.gap;
	    this._pausedTime = 0;
	    this._needsRemove = false;
	  },
	  fire: function (eventType, arg) {
	    eventType = 'on' + eventType;
	
	    if (this[eventType]) {
	      this[eventType](this._target, arg);
	    }
	  },
	  pause: function () {
	    this._paused = true;
	  },
	  resume: function () {
	    this._paused = false;
	  }
	};
	var _default = Clip;
	module.exports = _default;

/***/ },
/* 2277 */
/***/ function(module, exports) {

	/**
	 * 缓动代码来自 https://github.com/sole/tween.js/blob/master/src/Tween.js
	 * @see http://sole.github.io/tween.js/examples/03_graphs.html
	 * @exports zrender/animation/easing
	 */
	var easing = {
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  linear: function (k) {
	    return k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quadraticIn: function (k) {
	    return k * k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quadraticOut: function (k) {
	    return k * (2 - k);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quadraticInOut: function (k) {
	    if ((k *= 2) < 1) {
	      return 0.5 * k * k;
	    }
	
	    return -0.5 * (--k * (k - 2) - 1);
	  },
	  // 三次方的缓动（t^3）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  cubicIn: function (k) {
	    return k * k * k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  cubicOut: function (k) {
	    return --k * k * k + 1;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  cubicInOut: function (k) {
	    if ((k *= 2) < 1) {
	      return 0.5 * k * k * k;
	    }
	
	    return 0.5 * ((k -= 2) * k * k + 2);
	  },
	  // 四次方的缓动（t^4）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quarticIn: function (k) {
	    return k * k * k * k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quarticOut: function (k) {
	    return 1 - --k * k * k * k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quarticInOut: function (k) {
	    if ((k *= 2) < 1) {
	      return 0.5 * k * k * k * k;
	    }
	
	    return -0.5 * ((k -= 2) * k * k * k - 2);
	  },
	  // 五次方的缓动（t^5）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quinticIn: function (k) {
	    return k * k * k * k * k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quinticOut: function (k) {
	    return --k * k * k * k * k + 1;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quinticInOut: function (k) {
	    if ((k *= 2) < 1) {
	      return 0.5 * k * k * k * k * k;
	    }
	
	    return 0.5 * ((k -= 2) * k * k * k * k + 2);
	  },
	  // 正弦曲线的缓动（sin(t)）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  sinusoidalIn: function (k) {
	    return 1 - Math.cos(k * Math.PI / 2);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  sinusoidalOut: function (k) {
	    return Math.sin(k * Math.PI / 2);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  sinusoidalInOut: function (k) {
	    return 0.5 * (1 - Math.cos(Math.PI * k));
	  },
	  // 指数曲线的缓动（2^t）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  exponentialIn: function (k) {
	    return k === 0 ? 0 : Math.pow(1024, k - 1);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  exponentialOut: function (k) {
	    return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  exponentialInOut: function (k) {
	    if (k === 0) {
	      return 0;
	    }
	
	    if (k === 1) {
	      return 1;
	    }
	
	    if ((k *= 2) < 1) {
	      return 0.5 * Math.pow(1024, k - 1);
	    }
	
	    return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
	  },
	  // 圆形曲线的缓动（sqrt(1-t^2)）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  circularIn: function (k) {
	    return 1 - Math.sqrt(1 - k * k);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  circularOut: function (k) {
	    return Math.sqrt(1 - --k * k);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  circularInOut: function (k) {
	    if ((k *= 2) < 1) {
	      return -0.5 * (Math.sqrt(1 - k * k) - 1);
	    }
	
	    return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
	  },
	  // 创建类似于弹簧在停止前来回振荡的动画
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  elasticIn: function (k) {
	    var s;
	    var a = 0.1;
	    var p = 0.4;
	
	    if (k === 0) {
	      return 0;
	    }
	
	    if (k === 1) {
	      return 1;
	    }
	
	    if (!a || a < 1) {
	      a = 1;
	      s = p / 4;
	    } else {
	      s = p * Math.asin(1 / a) / (2 * Math.PI);
	    }
	
	    return -(a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  elasticOut: function (k) {
	    var s;
	    var a = 0.1;
	    var p = 0.4;
	
	    if (k === 0) {
	      return 0;
	    }
	
	    if (k === 1) {
	      return 1;
	    }
	
	    if (!a || a < 1) {
	      a = 1;
	      s = p / 4;
	    } else {
	      s = p * Math.asin(1 / a) / (2 * Math.PI);
	    }
	
	    return a * Math.pow(2, -10 * k) * Math.sin((k - s) * (2 * Math.PI) / p) + 1;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  elasticInOut: function (k) {
	    var s;
	    var a = 0.1;
	    var p = 0.4;
	
	    if (k === 0) {
	      return 0;
	    }
	
	    if (k === 1) {
	      return 1;
	    }
	
	    if (!a || a < 1) {
	      a = 1;
	      s = p / 4;
	    } else {
	      s = p * Math.asin(1 / a) / (2 * Math.PI);
	    }
	
	    if ((k *= 2) < 1) {
	      return -0.5 * (a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
	    }
	
	    return a * Math.pow(2, -10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;
	  },
	  // 在某一动画开始沿指示的路径进行动画处理前稍稍收回该动画的移动
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  backIn: function (k) {
	    var s = 1.70158;
	    return k * k * ((s + 1) * k - s);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  backOut: function (k) {
	    var s = 1.70158;
	    return --k * k * ((s + 1) * k + s) + 1;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  backInOut: function (k) {
	    var s = 1.70158 * 1.525;
	
	    if ((k *= 2) < 1) {
	      return 0.5 * (k * k * ((s + 1) * k - s));
	    }
	
	    return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
	  },
	  // 创建弹跳效果
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  bounceIn: function (k) {
	    return 1 - easing.bounceOut(1 - k);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  bounceOut: function (k) {
	    if (k < 1 / 2.75) {
	      return 7.5625 * k * k;
	    } else if (k < 2 / 2.75) {
	      return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
	    } else if (k < 2.5 / 2.75) {
	      return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
	    } else {
	      return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
	    }
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  bounceInOut: function (k) {
	    if (k < 0.5) {
	      return easing.bounceIn(k * 2) * 0.5;
	    }
	
	    return easing.bounceOut(k * 2 - 1) * 0.5 + 0.5;
	  }
	};
	var _default = easing;
	module.exports = _default;

/***/ },
/* 2278 */
/***/ function(module, exports, __webpack_require__) {

	var _util = __webpack_require__(1082);
	
	var normalizeRadian = _util.normalizeRadian;
	var PI2 = Math.PI * 2;
	/**
	 * 圆弧描边包含判断
	 * @param  {number}  cx
	 * @param  {number}  cy
	 * @param  {number}  r
	 * @param  {number}  startAngle
	 * @param  {number}  endAngle
	 * @param  {boolean}  anticlockwise
	 * @param  {number} lineWidth
	 * @param  {number}  x
	 * @param  {number}  y
	 * @return {Boolean}
	 */
	
	function containStroke(cx, cy, r, startAngle, endAngle, anticlockwise, lineWidth, x, y) {
	  if (lineWidth === 0) {
	    return false;
	  }
	
	  var _l = lineWidth;
	  x -= cx;
	  y -= cy;
	  var d = Math.sqrt(x * x + y * y);
	
	  if (d - _l > r || d + _l < r) {
	    return false;
	  }
	
	  if (Math.abs(startAngle - endAngle) % PI2 < 1e-4) {
	    // Is a circle
	    return true;
	  }
	
	  if (anticlockwise) {
	    var tmp = startAngle;
	    startAngle = normalizeRadian(endAngle);
	    endAngle = normalizeRadian(tmp);
	  } else {
	    startAngle = normalizeRadian(startAngle);
	    endAngle = normalizeRadian(endAngle);
	  }
	
	  if (startAngle > endAngle) {
	    endAngle += PI2;
	  }
	
	  var angle = Math.atan2(y, x);
	
	  if (angle < 0) {
	    angle += PI2;
	  }
	
	  return angle >= startAngle && angle <= endAngle || angle + PI2 >= startAngle && angle + PI2 <= endAngle;
	}
	
	exports.containStroke = containStroke;

/***/ },
/* 2279 */
/***/ function(module, exports, __webpack_require__) {

	var curve = __webpack_require__(152);
	
	/**
	 * 三次贝塞尔曲线描边包含判断
	 * @param  {number}  x0
	 * @param  {number}  y0
	 * @param  {number}  x1
	 * @param  {number}  y1
	 * @param  {number}  x2
	 * @param  {number}  y2
	 * @param  {number}  x3
	 * @param  {number}  y3
	 * @param  {number}  lineWidth
	 * @param  {number}  x
	 * @param  {number}  y
	 * @return {boolean}
	 */
	function containStroke(x0, y0, x1, y1, x2, y2, x3, y3, lineWidth, x, y) {
	  if (lineWidth === 0) {
	    return false;
	  }
	
	  var _l = lineWidth; // Quick reject
	
	  if (y > y0 + _l && y > y1 + _l && y > y2 + _l && y > y3 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l && y < y3 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l && x > x3 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l && x < x3 - _l) {
	    return false;
	  }
	
	  var d = curve.cubicProjectPoint(x0, y0, x1, y1, x2, y2, x3, y3, x, y, null);
	  return d <= _l / 2;
	}
	
	exports.containStroke = containStroke;

/***/ },
/* 2280 */
/***/ function(module, exports, __webpack_require__) {

	var PathProxy = __webpack_require__(231);
	
	var line = __webpack_require__(1079);
	
	var cubic = __webpack_require__(2279);
	
	var quadratic = __webpack_require__(1081);
	
	var arc = __webpack_require__(2278);
	
	var _util = __webpack_require__(1082);
	
	var normalizeRadian = _util.normalizeRadian;
	
	var curve = __webpack_require__(152);
	
	var windingLine = __webpack_require__(1083);
	
	var CMD = PathProxy.CMD;
	var PI2 = Math.PI * 2;
	var EPSILON = 1e-4;
	
	function isAroundEqual(a, b) {
	  return Math.abs(a - b) < EPSILON;
	} // 临时数组
	
	
	var roots = [-1, -1, -1];
	var extrema = [-1, -1];
	
	function swapExtrema() {
	  var tmp = extrema[0];
	  extrema[0] = extrema[1];
	  extrema[1] = tmp;
	}
	
	function windingCubic(x0, y0, x1, y1, x2, y2, x3, y3, x, y) {
	  // Quick reject
	  if (y > y0 && y > y1 && y > y2 && y > y3 || y < y0 && y < y1 && y < y2 && y < y3) {
	    return 0;
	  }
	
	  var nRoots = curve.cubicRootAt(y0, y1, y2, y3, y, roots);
	
	  if (nRoots === 0) {
	    return 0;
	  } else {
	    var w = 0;
	    var nExtrema = -1;
	    var y0_;
	    var y1_;
	
	    for (var i = 0; i < nRoots; i++) {
	      var t = roots[i]; // Avoid winding error when intersection point is the connect point of two line of polygon
	
	      var unit = t === 0 || t === 1 ? 0.5 : 1;
	      var x_ = curve.cubicAt(x0, x1, x2, x3, t);
	
	      if (x_ < x) {
	        // Quick reject
	        continue;
	      }
	
	      if (nExtrema < 0) {
	        nExtrema = curve.cubicExtrema(y0, y1, y2, y3, extrema);
	
	        if (extrema[1] < extrema[0] && nExtrema > 1) {
	          swapExtrema();
	        }
	
	        y0_ = curve.cubicAt(y0, y1, y2, y3, extrema[0]);
	
	        if (nExtrema > 1) {
	          y1_ = curve.cubicAt(y0, y1, y2, y3, extrema[1]);
	        }
	      }
	
	      if (nExtrema === 2) {
	        // 分成三段单调函数
	        if (t < extrema[0]) {
	          w += y0_ < y0 ? unit : -unit;
	        } else if (t < extrema[1]) {
	          w += y1_ < y0_ ? unit : -unit;
	        } else {
	          w += y3 < y1_ ? unit : -unit;
	        }
	      } else {
	        // 分成两段单调函数
	        if (t < extrema[0]) {
	          w += y0_ < y0 ? unit : -unit;
	        } else {
	          w += y3 < y0_ ? unit : -unit;
	        }
	      }
	    }
	
	    return w;
	  }
	}
	
	function windingQuadratic(x0, y0, x1, y1, x2, y2, x, y) {
	  // Quick reject
	  if (y > y0 && y > y1 && y > y2 || y < y0 && y < y1 && y < y2) {
	    return 0;
	  }
	
	  var nRoots = curve.quadraticRootAt(y0, y1, y2, y, roots);
	
	  if (nRoots === 0) {
	    return 0;
	  } else {
	    var t = curve.quadraticExtremum(y0, y1, y2);
	
	    if (t >= 0 && t <= 1) {
	      var w = 0;
	      var y_ = curve.quadraticAt(y0, y1, y2, t);
	
	      for (var i = 0; i < nRoots; i++) {
	        // Remove one endpoint.
	        var unit = roots[i] === 0 || roots[i] === 1 ? 0.5 : 1;
	        var x_ = curve.quadraticAt(x0, x1, x2, roots[i]);
	
	        if (x_ < x) {
	          // Quick reject
	          continue;
	        }
	
	        if (roots[i] < t) {
	          w += y_ < y0 ? unit : -unit;
	        } else {
	          w += y2 < y_ ? unit : -unit;
	        }
	      }
	
	      return w;
	    } else {
	      // Remove one endpoint.
	      var unit = roots[0] === 0 || roots[0] === 1 ? 0.5 : 1;
	      var x_ = curve.quadraticAt(x0, x1, x2, roots[0]);
	
	      if (x_ < x) {
	        // Quick reject
	        return 0;
	      }
	
	      return y2 < y0 ? unit : -unit;
	    }
	  }
	} // TODO
	// Arc 旋转
	
	
	function windingArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y) {
	  y -= cy;
	
	  if (y > r || y < -r) {
	    return 0;
	  }
	
	  var tmp = Math.sqrt(r * r - y * y);
	  roots[0] = -tmp;
	  roots[1] = tmp;
	  var diff = Math.abs(startAngle - endAngle);
	
	  if (diff < 1e-4) {
	    return 0;
	  }
	
	  if (diff % PI2 < 1e-4) {
	    // Is a circle
	    startAngle = 0;
	    endAngle = PI2;
	    var dir = anticlockwise ? 1 : -1;
	
	    if (x >= roots[0] + cx && x <= roots[1] + cx) {
	      return dir;
	    } else {
	      return 0;
	    }
	  }
	
	  if (anticlockwise) {
	    var tmp = startAngle;
	    startAngle = normalizeRadian(endAngle);
	    endAngle = normalizeRadian(tmp);
	  } else {
	    startAngle = normalizeRadian(startAngle);
	    endAngle = normalizeRadian(endAngle);
	  }
	
	  if (startAngle > endAngle) {
	    endAngle += PI2;
	  }
	
	  var w = 0;
	
	  for (var i = 0; i < 2; i++) {
	    var x_ = roots[i];
	
	    if (x_ + cx > x) {
	      var angle = Math.atan2(y, x_);
	      var dir = anticlockwise ? 1 : -1;
	
	      if (angle < 0) {
	        angle = PI2 + angle;
	      }
	
	      if (angle >= startAngle && angle <= endAngle || angle + PI2 >= startAngle && angle + PI2 <= endAngle) {
	        if (angle > Math.PI / 2 && angle < Math.PI * 1.5) {
	          dir = -dir;
	        }
	
	        w += dir;
	      }
	    }
	  }
	
	  return w;
	}
	
	function containPath(data, lineWidth, isStroke, x, y) {
	  var w = 0;
	  var xi = 0;
	  var yi = 0;
	  var x0 = 0;
	  var y0 = 0;
	
	  for (var i = 0; i < data.length;) {
	    var cmd = data[i++]; // Begin a new subpath
	
	    if (cmd === CMD.M && i > 1) {
	      // Close previous subpath
	      if (!isStroke) {
	        w += windingLine(xi, yi, x0, y0, x, y);
	      } // 如果被任何一个 subpath 包含
	      // if (w !== 0) {
	      //     return true;
	      // }
	
	    }
	
	    if (i === 1) {
	      // 如果第一个命令是 L, C, Q
	      // 则 previous point 同绘制命令的第一个 point
	      //
	      // 第一个命令为 Arc 的情况下会在后面特殊处理
	      xi = data[i];
	      yi = data[i + 1];
	      x0 = xi;
	      y0 = yi;
	    }
	
	    switch (cmd) {
	      case CMD.M:
	        // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
	        // 在 closePath 的时候使用
	        x0 = data[i++];
	        y0 = data[i++];
	        xi = x0;
	        yi = y0;
	        break;
	
	      case CMD.L:
	        if (isStroke) {
	          if (line.containStroke(xi, yi, data[i], data[i + 1], lineWidth, x, y)) {
	            return true;
	          }
	        } else {
	          // NOTE 在第一个命令为 L, C, Q 的时候会计算出 NaN
	          w += windingLine(xi, yi, data[i], data[i + 1], x, y) || 0;
	        }
	
	        xi = data[i++];
	        yi = data[i++];
	        break;
	
	      case CMD.C:
	        if (isStroke) {
	          if (cubic.containStroke(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) {
	            return true;
	          }
	        } else {
	          w += windingCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
	        }
	
	        xi = data[i++];
	        yi = data[i++];
	        break;
	
	      case CMD.Q:
	        if (isStroke) {
	          if (quadratic.containStroke(xi, yi, data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) {
	            return true;
	          }
	        } else {
	          w += windingQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
	        }
	
	        xi = data[i++];
	        yi = data[i++];
	        break;
	
	      case CMD.A:
	        // TODO Arc 判断的开销比较大
	        var cx = data[i++];
	        var cy = data[i++];
	        var rx = data[i++];
	        var ry = data[i++];
	        var theta = data[i++];
	        var dTheta = data[i++]; // TODO Arc 旋转
	
	        i += 1;
	        var anticlockwise = 1 - data[i++];
	        var x1 = Math.cos(theta) * rx + cx;
	        var y1 = Math.sin(theta) * ry + cy; // 不是直接使用 arc 命令
	
	        if (i > 1) {
	          w += windingLine(xi, yi, x1, y1, x, y);
	        } else {
	          // 第一个命令起点还未定义
	          x0 = x1;
	          y0 = y1;
	        } // zr 使用scale来模拟椭圆, 这里也对x做一定的缩放
	
	
	        var _x = (x - cx) * ry / rx + cx;
	
	        if (isStroke) {
	          if (arc.containStroke(cx, cy, ry, theta, theta + dTheta, anticlockwise, lineWidth, _x, y)) {
	            return true;
	          }
	        } else {
	          w += windingArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y);
	        }
	
	        xi = Math.cos(theta + dTheta) * rx + cx;
	        yi = Math.sin(theta + dTheta) * ry + cy;
	        break;
	
	      case CMD.R:
	        x0 = xi = data[i++];
	        y0 = yi = data[i++];
	        var width = data[i++];
	        var height = data[i++];
	        var x1 = x0 + width;
	        var y1 = y0 + height;
	
	        if (isStroke) {
	          if (line.containStroke(x0, y0, x1, y0, lineWidth, x, y) || line.containStroke(x1, y0, x1, y1, lineWidth, x, y) || line.containStroke(x1, y1, x0, y1, lineWidth, x, y) || line.containStroke(x0, y1, x0, y0, lineWidth, x, y)) {
	            return true;
	          }
	        } else {
	          // FIXME Clockwise ?
	          w += windingLine(x1, y0, x1, y1, x, y);
	          w += windingLine(x0, y1, x0, y0, x, y);
	        }
	
	        break;
	
	      case CMD.Z:
	        if (isStroke) {
	          if (line.containStroke(xi, yi, x0, y0, lineWidth, x, y)) {
	            return true;
	          }
	        } else {
	          // Close a subpath
	          w += windingLine(xi, yi, x0, y0, x, y); // 如果被任何一个 subpath 包含
	          // FIXME subpaths may overlap
	          // if (w !== 0) {
	          //     return true;
	          // }
	        }
	
	        xi = x0;
	        yi = y0;
	        break;
	    }
	  }
	
	  if (!isStroke && !isAroundEqual(yi, y0)) {
	    w += windingLine(xi, yi, x0, y0, x, y) || 0;
	  }
	
	  return w !== 0;
	}
	
	function contain(pathData, x, y) {
	  return containPath(pathData, 0, false, x, y);
	}
	
	function containStroke(pathData, lineWidth, x, y) {
	  return containPath(pathData, lineWidth, true, x, y);
	}
	
	exports.contain = contain;
	exports.containStroke = containStroke;

/***/ },
/* 2281 */
/***/ function(module, exports, __webpack_require__) {

	var eventUtil = __webpack_require__(113);
	
	/**
	 * Only implements needed gestures for mobile.
	 */
	var GestureMgr = function () {
	  /**
	   * @private
	   * @type {Array.<Object>}
	   */
	  this._track = [];
	};
	
	GestureMgr.prototype = {
	  constructor: GestureMgr,
	  recognize: function (event, target, root) {
	    this._doTrack(event, target, root);
	
	    return this._recognize(event);
	  },
	  clear: function () {
	    this._track.length = 0;
	    return this;
	  },
	  _doTrack: function (event, target, root) {
	    var touches = event.touches;
	
	    if (!touches) {
	      return;
	    }
	
	    var trackItem = {
	      points: [],
	      touches: [],
	      target: target,
	      event: event
	    };
	
	    for (var i = 0, len = touches.length; i < len; i++) {
	      var touch = touches[i];
	      var pos = eventUtil.clientToLocal(root, touch, {});
	      trackItem.points.push([pos.zrX, pos.zrY]);
	      trackItem.touches.push(touch);
	    }
	
	    this._track.push(trackItem);
	  },
	  _recognize: function (event) {
	    for (var eventName in recognizers) {
	      if (recognizers.hasOwnProperty(eventName)) {
	        var gestureInfo = recognizers[eventName](this._track, event);
	
	        if (gestureInfo) {
	          return gestureInfo;
	        }
	      }
	    }
	  }
	};
	
	function dist(pointPair) {
	  var dx = pointPair[1][0] - pointPair[0][0];
	  var dy = pointPair[1][1] - pointPair[0][1];
	  return Math.sqrt(dx * dx + dy * dy);
	}
	
	function center(pointPair) {
	  return [(pointPair[0][0] + pointPair[1][0]) / 2, (pointPair[0][1] + pointPair[1][1]) / 2];
	}
	
	var recognizers = {
	  pinch: function (track, event) {
	    var trackLen = track.length;
	
	    if (!trackLen) {
	      return;
	    }
	
	    var pinchEnd = (track[trackLen - 1] || {}).points;
	    var pinchPre = (track[trackLen - 2] || {}).points || pinchEnd;
	
	    if (pinchPre && pinchPre.length > 1 && pinchEnd && pinchEnd.length > 1) {
	      var pinchScale = dist(pinchEnd) / dist(pinchPre);
	      !isFinite(pinchScale) && (pinchScale = 1);
	      event.pinchScale = pinchScale;
	      var pinchCenter = center(pinchEnd);
	      event.pinchX = pinchCenter[0];
	      event.pinchY = pinchCenter[1];
	      return {
	        type: 'pinch',
	        target: track[0].target,
	        event: event
	      };
	    }
	  } // Only pinch currently.
	
	};
	var _default = GestureMgr;
	module.exports = _default;

/***/ },
/* 2282 */
/***/ function(module, exports) {

	// Myers' Diff Algorithm
	// Modified from https://github.com/kpdecker/jsdiff/blob/master/src/diff/base.js
	function Diff() {}
	
	Diff.prototype = {
	  diff: function (oldArr, newArr, equals) {
	    if (!equals) {
	      equals = function (a, b) {
	        return a === b;
	      };
	    }
	
	    this.equals = equals;
	    var self = this;
	    oldArr = oldArr.slice();
	    newArr = newArr.slice(); // Allow subclasses to massage the input prior to running
	
	    var newLen = newArr.length;
	    var oldLen = oldArr.length;
	    var editLength = 1;
	    var maxEditLength = newLen + oldLen;
	    var bestPath = [{
	      newPos: -1,
	      components: []
	    }]; // Seed editLength = 0, i.e. the content starts with the same values
	
	    var oldPos = this.extractCommon(bestPath[0], newArr, oldArr, 0);
	
	    if (bestPath[0].newPos + 1 >= newLen && oldPos + 1 >= oldLen) {
	      var indices = [];
	
	      for (var i = 0; i < newArr.length; i++) {
	        indices.push(i);
	      } // Identity per the equality and tokenizer
	
	
	      return [{
	        indices: indices,
	        count: newArr.length
	      }];
	    } // Main worker method. checks all permutations of a given edit length for acceptance.
	
	
	    function execEditLength() {
	      for (var diagonalPath = -1 * editLength; diagonalPath <= editLength; diagonalPath += 2) {
	        var basePath;
	        var addPath = bestPath[diagonalPath - 1];
	        var removePath = bestPath[diagonalPath + 1];
	        var oldPos = (removePath ? removePath.newPos : 0) - diagonalPath;
	
	        if (addPath) {
	          // No one else is going to attempt to use this value, clear it
	          bestPath[diagonalPath - 1] = undefined;
	        }
	
	        var canAdd = addPath && addPath.newPos + 1 < newLen;
	        var canRemove = removePath && 0 <= oldPos && oldPos < oldLen;
	
	        if (!canAdd && !canRemove) {
	          // If this path is a terminal then prune
	          bestPath[diagonalPath] = undefined;
	          continue;
	        } // Select the diagonal that we want to branch from. We select the prior
	        // path whose position in the new string is the farthest from the origin
	        // and does not pass the bounds of the diff graph
	
	
	        if (!canAdd || canRemove && addPath.newPos < removePath.newPos) {
	          basePath = clonePath(removePath);
	          self.pushComponent(basePath.components, undefined, true);
	        } else {
	          basePath = addPath; // No need to clone, we've pulled it from the list
	
	          basePath.newPos++;
	          self.pushComponent(basePath.components, true, undefined);
	        }
	
	        oldPos = self.extractCommon(basePath, newArr, oldArr, diagonalPath); // If we have hit the end of both strings, then we are done
	
	        if (basePath.newPos + 1 >= newLen && oldPos + 1 >= oldLen) {
	          return buildValues(self, basePath.components, newArr, oldArr);
	        } else {
	          // Otherwise track this path as a potential candidate and continue.
	          bestPath[diagonalPath] = basePath;
	        }
	      }
	
	      editLength++;
	    }
	
	    while (editLength <= maxEditLength) {
	      var ret = execEditLength();
	
	      if (ret) {
	        return ret;
	      }
	    }
	  },
	  pushComponent: function (components, added, removed) {
	    var last = components[components.length - 1];
	
	    if (last && last.added === added && last.removed === removed) {
	      // We need to clone here as the component clone operation is just
	      // as shallow array clone
	      components[components.length - 1] = {
	        count: last.count + 1,
	        added: added,
	        removed: removed
	      };
	    } else {
	      components.push({
	        count: 1,
	        added: added,
	        removed: removed
	      });
	    }
	  },
	  extractCommon: function (basePath, newArr, oldArr, diagonalPath) {
	    var newLen = newArr.length;
	    var oldLen = oldArr.length;
	    var newPos = basePath.newPos;
	    var oldPos = newPos - diagonalPath;
	    var commonCount = 0;
	
	    while (newPos + 1 < newLen && oldPos + 1 < oldLen && this.equals(newArr[newPos + 1], oldArr[oldPos + 1])) {
	      newPos++;
	      oldPos++;
	      commonCount++;
	    }
	
	    if (commonCount) {
	      basePath.components.push({
	        count: commonCount
	      });
	    }
	
	    basePath.newPos = newPos;
	    return oldPos;
	  },
	  tokenize: function (value) {
	    return value.slice();
	  },
	  join: function (value) {
	    return value.slice();
	  }
	};
	
	function buildValues(diff, components, newArr, oldArr) {
	  var componentPos = 0;
	  var componentLen = components.length;
	  var newPos = 0;
	  var oldPos = 0;
	
	  for (; componentPos < componentLen; componentPos++) {
	    var component = components[componentPos];
	
	    if (!component.removed) {
	      var indices = [];
	
	      for (var i = newPos; i < newPos + component.count; i++) {
	        indices.push(i);
	      }
	
	      component.indices = indices;
	      newPos += component.count; // Common case
	
	      if (!component.added) {
	        oldPos += component.count;
	      }
	    } else {
	      var indices = [];
	
	      for (var i = oldPos; i < oldPos + component.count; i++) {
	        indices.push(i);
	      }
	
	      component.indices = indices;
	      oldPos += component.count;
	    }
	  }
	
	  return components;
	}
	
	function clonePath(path) {
	  return {
	    newPos: path.newPos,
	    components: path.components.slice(0)
	  };
	}
	
	var arrayDiff = new Diff();
	
	function _default(oldArr, newArr, callback) {
	  return arrayDiff.diff(oldArr, newArr, callback);
	}
	
	module.exports = _default;

/***/ },
/* 2283 */
/***/ function(module, exports) {

	/**
	 * The algoritm is learnt from
	 * https://franklinta.com/2014/09/08/computing-css-matrix3d-transforms/
	 * And we made some optimization for matrix inversion.
	 * Other similar approaches:
	 * "cv::getPerspectiveTransform", "Direct Linear Transformation".
	 */
	var LN2 = Math.log(2);
	
	function determinant(rows, rank, rowStart, rowMask, colMask, detCache) {
	  var cacheKey = rowMask + '-' + colMask;
	  var fullRank = rows.length;
	
	  if (detCache.hasOwnProperty(cacheKey)) {
	    return detCache[cacheKey];
	  }
	
	  if (rank === 1) {
	    // In this case the colMask must be like: `11101111`. We can find the place of `0`.
	    var colStart = Math.round(Math.log((1 << fullRank) - 1 & ~colMask) / LN2);
	    return rows[rowStart][colStart];
	  }
	
	  var subRowMask = rowMask | 1 << rowStart;
	  var subRowStart = rowStart + 1;
	
	  while (rowMask & 1 << subRowStart) {
	    subRowStart++;
	  }
	
	  var sum = 0;
	
	  for (var j = 0, colLocalIdx = 0; j < fullRank; j++) {
	    var colTag = 1 << j;
	
	    if (!(colTag & colMask)) {
	      sum += (colLocalIdx % 2 ? -1 : 1) * rows[rowStart][j] // det(subMatrix(0, j))
	      * determinant(rows, rank - 1, subRowStart, subRowMask, colMask | colTag, detCache);
	      colLocalIdx++;
	    }
	  }
	
	  detCache[cacheKey] = sum;
	  return sum;
	}
	/**
	 * Usage:
	 * ```js
	 * var transformer = buildTransformer(
	 *     [10, 44, 100, 44, 100, 300, 10, 300],
	 *     [50, 54, 130, 14, 140, 330, 14, 220]
	 * );
	 * var out = [];
	 * transformer && transformer([11, 33], out);
	 * ```
	 *
	 * Notice: `buildTransformer` may take more than 10ms in some Android device.
	 *
	 * @param {Array.<number>} src source four points, [x0, y0, x1, y1, x2, y2, x3, y3]
	 * @param {Array.<number>} dest destination four points, [x0, y0, x1, y1, x2, y2, x3, y3]
	 * @return {Function} transformer If fail, return null/undefined.
	 */
	
	
	function buildTransformer(src, dest) {
	  var mA = [[src[0], src[1], 1, 0, 0, 0, -dest[0] * src[0], -dest[0] * src[1]], [0, 0, 0, src[0], src[1], 1, -dest[1] * src[0], -dest[1] * src[1]], [src[2], src[3], 1, 0, 0, 0, -dest[2] * src[2], -dest[2] * src[3]], [0, 0, 0, src[2], src[3], 1, -dest[3] * src[2], -dest[3] * src[3]], [src[4], src[5], 1, 0, 0, 0, -dest[4] * src[4], -dest[4] * src[5]], [0, 0, 0, src[4], src[5], 1, -dest[5] * src[4], -dest[5] * src[5]], [src[6], src[7], 1, 0, 0, 0, -dest[6] * src[6], -dest[6] * src[7]], [0, 0, 0, src[6], src[7], 1, -dest[7] * src[6], -dest[7] * src[7]]];
	  var detCache = {};
	  var det = determinant(mA, 8, 0, 0, 0, detCache);
	
	  if (det === 0) {
	    // can not make transformer when and only when
	    // any three of the markers are collinear.
	    return;
	  } // `invert(mA) * dest`, that is, `adj(mA) / det * dest`.
	
	
	  var vh = [];
	
	  for (var i = 0; i < 8; i++) {
	    for (var j = 0; j < 8; j++) {
	      vh[j] == null && (vh[j] = 0);
	      vh[j] += ((i + j) % 2 ? -1 : 1) * // det(subMatrix(i, j))
	      determinant(mA, 7, i === 0 ? 1 : 0, 1 << i, 1 << j, detCache) / det * dest[i];
	    }
	  }
	
	  return function (out, srcPointX, srcPointY) {
	    var pk = srcPointX * vh[6] + srcPointY * vh[7] + 1;
	    out[0] = (srcPointX * vh[0] + srcPointY * vh[1] + vh[2]) / pk;
	    out[1] = (srcPointX * vh[3] + srcPointY * vh[4] + vh[5]) / pk;
	  };
	}
	
	exports.buildTransformer = buildTransformer;

/***/ },
/* 2284 */
/***/ function(module, exports, __webpack_require__) {

	var _event = __webpack_require__(113);
	
	var addEventListener = _event.addEventListener;
	var removeEventListener = _event.removeEventListener;
	var normalizeEvent = _event.normalizeEvent;
	var getNativeEvent = _event.getNativeEvent;
	
	var zrUtil = __webpack_require__(3);
	
	var Eventful = __webpack_require__(189);
	
	var env = __webpack_require__(55);
	
	/* global document */
	var TOUCH_CLICK_DELAY = 300;
	var globalEventSupported = env.domSupported;
	
	var localNativeListenerNames = function () {
	  var mouseHandlerNames = ['click', 'dblclick', 'mousewheel', 'mouseout', 'mouseup', 'mousedown', 'mousemove', 'contextmenu'];
	  var touchHandlerNames = ['touchstart', 'touchend', 'touchmove'];
	  var pointerEventNameMap = {
	    pointerdown: 1,
	    pointerup: 1,
	    pointermove: 1,
	    pointerout: 1
	  };
	  var pointerHandlerNames = zrUtil.map(mouseHandlerNames, function (name) {
	    var nm = name.replace('mouse', 'pointer');
	    return pointerEventNameMap.hasOwnProperty(nm) ? nm : name;
	  });
	  return {
	    mouse: mouseHandlerNames,
	    touch: touchHandlerNames,
	    pointer: pointerHandlerNames
	  };
	}();
	
	var globalNativeListenerNames = {
	  mouse: ['mousemove', 'mouseup'],
	  pointer: ['pointermove', 'pointerup']
	};
	
	function eventNameFix(name) {
	  return name === 'mousewheel' && env.browser.firefox ? 'DOMMouseScroll' : name;
	}
	
	function isPointerFromTouch(event) {
	  var pointerType = event.pointerType;
	  return pointerType === 'pen' || pointerType === 'touch';
	} // function useMSGuesture(handlerProxy, event) {
	//     return isPointerFromTouch(event) && !!handlerProxy._msGesture;
	// }
	// function onMSGestureChange(proxy, event) {
	//     if (event.translationX || event.translationY) {
	//         // mousemove is carried by MSGesture to reduce the sensitivity.
	//         proxy.handler.dispatchToElement(event.target, 'mousemove', event);
	//     }
	//     if (event.scale !== 1) {
	//         event.pinchX = event.offsetX;
	//         event.pinchY = event.offsetY;
	//         event.pinchScale = event.scale;
	//         proxy.handler.dispatchToElement(event.target, 'pinch', event);
	//     }
	// }
	
	/**
	 * Prevent mouse event from being dispatched after Touch Events action
	 * @see <https://github.com/deltakosh/handjs/blob/master/src/hand.base.js>
	 * 1. Mobile browsers dispatch mouse events 300ms after touchend.
	 * 2. Chrome for Android dispatch mousedown for long-touch about 650ms
	 * Result: Blocking Mouse Events for 700ms.
	 *
	 * @param {DOMHandlerScope} scope
	 */
	
	
	function setTouchTimer(scope) {
	  scope.touching = true;
	
	  if (scope.touchTimer != null) {
	    clearTimeout(scope.touchTimer);
	    scope.touchTimer = null;
	  }
	
	  scope.touchTimer = setTimeout(function () {
	    scope.touching = false;
	    scope.touchTimer = null;
	  }, 700);
	} // Mark touch, which is useful in distinguish touch and
	// mouse event in upper applicatoin.
	
	
	function markTouch(event) {
	  event && (event.zrByTouch = true);
	} // function markTriggeredFromLocal(event) {
	//     event && (event.__zrIsFromLocal = true);
	// }
	// function isTriggeredFromLocal(instance, event) {
	//     return !!(event && event.__zrIsFromLocal);
	// }
	
	
	function normalizeGlobalEvent(instance, event) {
	  // offsetX, offsetY still need to be calculated. They are necessary in the event
	  // handlers of the upper applications. Set `true` to force calculate them.
	  return normalizeEvent(instance.dom, new FakeGlobalEvent(instance, event), true);
	}
	/**
	 * Detect whether the given el is in `painterRoot`.
	 */
	
	
	function isLocalEl(instance, el) {
	  var elTmp = el;
	  var isLocal = false;
	
	  while (elTmp && elTmp.nodeType !== 9 && !(isLocal = elTmp.domBelongToZr || elTmp !== el && elTmp === instance.painterRoot)) {
	    elTmp = elTmp.parentNode;
	  }
	
	  return isLocal;
	}
	/**
	 * Make a fake event but not change the original event,
	 * becuase the global event probably be used by other
	 * listeners not belonging to zrender.
	 * @class
	 */
	
	
	function FakeGlobalEvent(instance, event) {
	  this.type = event.type;
	  this.target = this.currentTarget = instance.dom;
	  this.pointerType = event.pointerType; // Necessray for the force calculation of zrX, zrY
	
	  this.clientX = event.clientX;
	  this.clientY = event.clientY; // Because we do not mount global listeners to touch events,
	  // we do not copy `targetTouches` and `changedTouches` here.
	}
	
	var fakeGlobalEventProto = FakeGlobalEvent.prototype; // we make the default methods on the event do nothing,
	// otherwise it is dangerous. See more details in
	// [Drag outside] in `Handler.js`.
	
	fakeGlobalEventProto.stopPropagation = fakeGlobalEventProto.stopImmediatePropagation = fakeGlobalEventProto.preventDefault = zrUtil.noop;
	/**
	 * Local DOM Handlers
	 * @this {HandlerProxy}
	 */
	
	var localDOMHandlers = {
	  mousedown: function (event) {
	    event = normalizeEvent(this.dom, event);
	    this._mayPointerCapture = [event.zrX, event.zrY];
	    this.trigger('mousedown', event);
	  },
	  mousemove: function (event) {
	    event = normalizeEvent(this.dom, event);
	    var downPoint = this._mayPointerCapture;
	
	    if (downPoint && (event.zrX !== downPoint[0] || event.zrY !== downPoint[1])) {
	      togglePointerCapture(this, true);
	    }
	
	    this.trigger('mousemove', event);
	  },
	  mouseup: function (event) {
	    event = normalizeEvent(this.dom, event);
	    togglePointerCapture(this, false);
	    this.trigger('mouseup', event);
	  },
	  mouseout: function (event) {
	    event = normalizeEvent(this.dom, event); // Similarly to the browser did on `document` and touch event,
	    // `globalout` will be delayed to final pointer cature release.
	
	    if (this._pointerCapturing) {
	      event.zrEventControl = 'no_globalout';
	    } // There might be some doms created by upper layer application
	    // at the same level of painter.getViewportRoot() (e.g., tooltip
	    // dom created by echarts), where 'globalout' event should not
	    // be triggered when mouse enters these doms. (But 'mouseout'
	    // should be triggered at the original hovered element as usual).
	
	
	    var element = event.toElement || event.relatedTarget;
	    event.zrIsToLocalDOM = isLocalEl(this, element);
	    this.trigger('mouseout', event);
	  },
	  touchstart: function (event) {
	    // Default mouse behaviour should not be disabled here.
	    // For example, page may needs to be slided.
	    event = normalizeEvent(this.dom, event);
	    markTouch(event);
	    this._lastTouchMoment = new Date();
	    this.handler.processGesture(event, 'start'); // For consistent event listener for both touch device and mouse device,
	    // we simulate "mouseover-->mousedown" in touch device. So we trigger
	    // `mousemove` here (to trigger `mouseover` inside), and then trigger
	    // `mousedown`.
	
	    localDOMHandlers.mousemove.call(this, event);
	    localDOMHandlers.mousedown.call(this, event);
	  },
	  touchmove: function (event) {
	    event = normalizeEvent(this.dom, event);
	    markTouch(event);
	    this.handler.processGesture(event, 'change'); // Mouse move should always be triggered no matter whether
	    // there is gestrue event, because mouse move and pinch may
	    // be used at the same time.
	
	    localDOMHandlers.mousemove.call(this, event);
	  },
	  touchend: function (event) {
	    event = normalizeEvent(this.dom, event);
	    markTouch(event);
	    this.handler.processGesture(event, 'end');
	    localDOMHandlers.mouseup.call(this, event); // Do not trigger `mouseout` here, in spite of `mousemove`(`mouseover`) is
	    // triggered in `touchstart`. This seems to be illogical, but by this mechanism,
	    // we can conveniently implement "hover style" in both PC and touch device just
	    // by listening to `mouseover` to add "hover style" and listening to `mouseout`
	    // to remove "hover style" on an element, without any additional code for
	    // compatibility. (`mouseout` will not be triggered in `touchend`, so "hover
	    // style" will remain for user view)
	    // click event should always be triggered no matter whether
	    // there is gestrue event. System click can not be prevented.
	
	    if (+new Date() - this._lastTouchMoment < TOUCH_CLICK_DELAY) {
	      localDOMHandlers.click.call(this, event);
	    }
	  },
	  pointerdown: function (event) {
	    localDOMHandlers.mousedown.call(this, event); // if (useMSGuesture(this, event)) {
	    //     this._msGesture.addPointer(event.pointerId);
	    // }
	  },
	  pointermove: function (event) {
	    // FIXME
	    // pointermove is so sensitive that it always triggered when
	    // tap(click) on touch screen, which affect some judgement in
	    // upper application. So, we dont support mousemove on MS touch
	    // device yet.
	    if (!isPointerFromTouch(event)) {
	      localDOMHandlers.mousemove.call(this, event);
	    }
	  },
	  pointerup: function (event) {
	    localDOMHandlers.mouseup.call(this, event);
	  },
	  pointerout: function (event) {
	    // pointerout will be triggered when tap on touch screen
	    // (IE11+/Edge on MS Surface) after click event triggered,
	    // which is inconsistent with the mousout behavior we defined
	    // in touchend. So we unify them.
	    // (check localDOMHandlers.touchend for detailed explanation)
	    if (!isPointerFromTouch(event)) {
	      localDOMHandlers.mouseout.call(this, event);
	    }
	  }
	};
	/**
	 * Othere DOM UI Event handlers for zr dom.
	 * @this {HandlerProxy}
	 */
	
	zrUtil.each(['click', 'mousewheel', 'dblclick', 'contextmenu'], function (name) {
	  localDOMHandlers[name] = function (event) {
	    event = normalizeEvent(this.dom, event);
	    this.trigger(name, event);
	  };
	});
	/**
	 * DOM UI Event handlers for global page.
	 *
	 * [Caution]:
	 * those handlers should both support in capture phase and bubble phase!
	 *
	 * @this {HandlerProxy}
	 */
	
	var globalDOMHandlers = {
	  pointermove: function (event) {
	    // FIXME
	    // pointermove is so sensitive that it always triggered when
	    // tap(click) on touch screen, which affect some judgement in
	    // upper application. So, we dont support mousemove on MS touch
	    // device yet.
	    if (!isPointerFromTouch(event)) {
	      globalDOMHandlers.mousemove.call(this, event);
	    }
	  },
	  pointerup: function (event) {
	    globalDOMHandlers.mouseup.call(this, event);
	  },
	  mousemove: function (event) {
	    this.trigger('mousemove', event);
	  },
	  mouseup: function (event) {
	    var pointerCaptureReleasing = this._pointerCapturing;
	    togglePointerCapture(this, false);
	    this.trigger('mouseup', event);
	
	    if (pointerCaptureReleasing) {
	      event.zrEventControl = 'only_globalout';
	      this.trigger('mouseout', event);
	    }
	  }
	};
	/**
	 * @param {HandlerProxy} instance
	 * @param {DOMHandlerScope} scope
	 */
	
	function mountLocalDOMEventListeners(instance, scope) {
	  var domHandlers = scope.domHandlers;
	
	  if (env.pointerEventsSupported) {
	    // Only IE11+/Edge
	    // 1. On devices that both enable touch and mouse (e.g., MS Surface and lenovo X240),
	    // IE11+/Edge do not trigger touch event, but trigger pointer event and mouse event
	    // at the same time.
	    // 2. On MS Surface, it probablely only trigger mousedown but no mouseup when tap on
	    // screen, which do not occurs in pointer event.
	    // So we use pointer event to both detect touch gesture and mouse behavior.
	    zrUtil.each(localNativeListenerNames.pointer, function (nativeEventName) {
	      mountSingleDOMEventListener(scope, nativeEventName, function (event) {
	        // markTriggeredFromLocal(event);
	        domHandlers[nativeEventName].call(instance, event);
	      });
	    }); // FIXME
	    // Note: MS Gesture require CSS touch-action set. But touch-action is not reliable,
	    // which does not prevent defuault behavior occasionally (which may cause view port
	    // zoomed in but use can not zoom it back). And event.preventDefault() does not work.
	    // So we have to not to use MSGesture and not to support touchmove and pinch on MS
	    // touch screen. And we only support click behavior on MS touch screen now.
	    // MS Gesture Event is only supported on IE11+/Edge and on Windows 8+.
	    // We dont support touch on IE on win7.
	    // See <https://msdn.microsoft.com/en-us/library/dn433243(v=vs.85).aspx>
	    // if (typeof MSGesture === 'function') {
	    //     (this._msGesture = new MSGesture()).target = dom; // jshint ignore:line
	    //     dom.addEventListener('MSGestureChange', onMSGestureChange);
	    // }
	  } else {
	    if (env.touchEventsSupported) {
	      zrUtil.each(localNativeListenerNames.touch, function (nativeEventName) {
	        mountSingleDOMEventListener(scope, nativeEventName, function (event) {
	          // markTriggeredFromLocal(event);
	          domHandlers[nativeEventName].call(instance, event);
	          setTouchTimer(scope);
	        });
	      }); // Handler of 'mouseout' event is needed in touch mode, which will be mounted below.
	      // addEventListener(root, 'mouseout', this._mouseoutHandler);
	    } // 1. Considering some devices that both enable touch and mouse event (like on MS Surface
	    // and lenovo X240, @see #2350), we make mouse event be always listened, otherwise
	    // mouse event can not be handle in those devices.
	    // 2. On MS Surface, Chrome will trigger both touch event and mouse event. How to prevent
	    // mouseevent after touch event triggered, see `setTouchTimer`.
	
	
	    zrUtil.each(localNativeListenerNames.mouse, function (nativeEventName) {
	      mountSingleDOMEventListener(scope, nativeEventName, function (event) {
	        event = getNativeEvent(event);
	
	        if (!scope.touching) {
	          // markTriggeredFromLocal(event);
	          domHandlers[nativeEventName].call(instance, event);
	        }
	      });
	    });
	  }
	}
	/**
	 * @param {HandlerProxy} instance
	 * @param {DOMHandlerScope} scope
	 */
	
	
	function mountGlobalDOMEventListeners(instance, scope) {
	  // Only IE11+/Edge. See the comment in `mountLocalDOMEventListeners`.
	  if (env.pointerEventsSupported) {
	    zrUtil.each(globalNativeListenerNames.pointer, mount);
	  } // Touch event has implemented "drag outside" so we do not mount global listener for touch event.
	  // (see https://www.w3.org/TR/touch-events/#the-touchmove-event)
	  // We do not consider "both-support-touch-and-mouse device" for this feature (see the comment of
	  // `mountLocalDOMEventListeners`) to avoid bugs util some requirements come.
	  else if (!env.touchEventsSupported) {
	      zrUtil.each(globalNativeListenerNames.mouse, mount);
	    }
	
	  function mount(nativeEventName) {
	    function nativeEventListener(event) {
	      event = getNativeEvent(event); // See the reason in [Drag outside] in `Handler.js`
	      // This checking supports both `useCapture` or not.
	      // PENDING: if there is performance issue in some devices,
	      // we probably can not use `useCapture` and change a easier
	      // to judes whether local (mark).
	
	      if (!isLocalEl(instance, event.target)) {
	        event = normalizeGlobalEvent(instance, event);
	        scope.domHandlers[nativeEventName].call(instance, event);
	      }
	    }
	
	    mountSingleDOMEventListener(scope, nativeEventName, nativeEventListener, {
	      capture: true
	    } // See [Drag Outside] in `Handler.js`
	    );
	  }
	}
	
	function mountSingleDOMEventListener(scope, nativeEventName, listener, opt) {
	  scope.mounted[nativeEventName] = listener;
	  scope.listenerOpts[nativeEventName] = opt;
	  addEventListener(scope.domTarget, eventNameFix(nativeEventName), listener, opt);
	}
	
	function unmountDOMEventListeners(scope) {
	  var mounted = scope.mounted;
	
	  for (var nativeEventName in mounted) {
	    if (mounted.hasOwnProperty(nativeEventName)) {
	      removeEventListener(scope.domTarget, eventNameFix(nativeEventName), mounted[nativeEventName], scope.listenerOpts[nativeEventName]);
	    }
	  }
	
	  scope.mounted = {};
	}
	/**
	 * See [Drag Outside] in `Handler.js`.
	 * @implement
	 * @param {boolean} isPointerCapturing Should never be `null`/`undefined`.
	 *        `true`: start to capture pointer if it is not capturing.
	 *        `false`: end the capture if it is capturing.
	 */
	
	
	function togglePointerCapture(instance, isPointerCapturing) {
	  instance._mayPointerCapture = null;
	
	  if (globalEventSupported && instance._pointerCapturing ^ isPointerCapturing) {
	    instance._pointerCapturing = isPointerCapturing;
	    var globalHandlerScope = instance._globalHandlerScope;
	    isPointerCapturing ? mountGlobalDOMEventListeners(instance, globalHandlerScope) : unmountDOMEventListeners(globalHandlerScope);
	  }
	}
	/**
	 * @inner
	 * @class
	 */
	
	
	function DOMHandlerScope(domTarget, domHandlers) {
	  this.domTarget = domTarget;
	  this.domHandlers = domHandlers; // Key: eventName, value: mounted handler funcitons.
	  // Used for unmount.
	
	  this.mounted = {};
	  this.listenerOpts = {};
	  this.touchTimer = null;
	  this.touching = false;
	}
	/**
	 * @public
	 * @class
	 */
	
	
	function HandlerDomProxy(dom, painterRoot) {
	  Eventful.call(this);
	  this.dom = dom;
	  this.painterRoot = painterRoot;
	  this._localHandlerScope = new DOMHandlerScope(dom, localDOMHandlers);
	
	  if (globalEventSupported) {
	    this._globalHandlerScope = new DOMHandlerScope(document, globalDOMHandlers);
	  }
	  /**
	   * @type {boolean}
	   */
	
	
	  this._pointerCapturing = false;
	  /**
	   * @type {Array.<number>} [x, y] or null.
	   */
	
	  this._mayPointerCapture = null;
	  mountLocalDOMEventListeners(this, this._localHandlerScope);
	}
	
	var handlerDomProxyProto = HandlerDomProxy.prototype;
	
	handlerDomProxyProto.dispose = function () {
	  unmountDOMEventListeners(this._localHandlerScope);
	
	  if (globalEventSupported) {
	    unmountDOMEventListeners(this._globalHandlerScope);
	  }
	};
	
	handlerDomProxyProto.setCursor = function (cursorStyle) {
	  this.dom.style && (this.dom.style.cursor = cursorStyle || 'default');
	};
	
	zrUtil.mixin(HandlerDomProxy, Eventful);
	var _default = HandlerDomProxy;
	module.exports = _default;

/***/ },
/* 2285 */
/***/ function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(46);
	
	// CompoundPath to improve performance
	var _default = Path.extend({
	  type: 'compound',
	  shape: {
	    paths: null
	  },
	  _updatePathDirty: function () {
	    var dirtyPath = this.__dirtyPath;
	    var paths = this.shape.paths;
	
	    for (var i = 0; i < paths.length; i++) {
	      // Mark as dirty if any subpath is dirty
	      dirtyPath = dirtyPath || paths[i].__dirtyPath;
	    }
	
	    this.__dirtyPath = dirtyPath;
	    this.__dirty = this.__dirty || dirtyPath;
	  },
	  beforeBrush: function () {
	    this._updatePathDirty();
	
	    var paths = this.shape.paths || [];
	    var scale = this.getGlobalScale(); // Update path scale
	
	    for (var i = 0; i < paths.length; i++) {
	      if (!paths[i].path) {
	        paths[i].createPathProxy();
	      }
	
	      paths[i].path.setScale(scale[0], scale[1], paths[i].segmentIgnoreThreshold);
	    }
	  },
	  buildPath: function (ctx, shape) {
	    var paths = shape.paths || [];
	
	    for (var i = 0; i < paths.length; i++) {
	      paths[i].buildPath(ctx, paths[i].shape, true);
	    }
	  },
	  afterBrush: function () {
	    var paths = this.shape.paths || [];
	
	    for (var i = 0; i < paths.length; i++) {
	      paths[i].__dirtyPath = false;
	    }
	  },
	  getBoundingRect: function () {
	    this._updatePathDirty();
	
	    return Path.prototype.getBoundingRect.call(this);
	  }
	});
	
	module.exports = _default;

/***/ },
/* 2286 */
/***/ function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(3);
	
	var Gradient = __webpack_require__(386);
	
	/**
	 * x, y, r are all percent from 0 to 1
	 * @param {number} [x=0.5]
	 * @param {number} [y=0.5]
	 * @param {number} [r=0.5]
	 * @param {Array.<Object>} [colorStops]
	 * @param {boolean} [globalCoord=false]
	 */
	var RadialGradient = function (x, y, r, colorStops, globalCoord) {
	  // Should do nothing more in this constructor. Because gradient can be
	  // declard by `color: {type: 'radial', colorStops: ...}`, where
	  // this constructor will not be called.
	  this.x = x == null ? 0.5 : x;
	  this.y = y == null ? 0.5 : y;
	  this.r = r == null ? 0.5 : r; // Can be cloned
	
	  this.type = 'radial'; // If use global coord
	
	  this.global = globalCoord || false;
	  Gradient.call(this, colorStops);
	};
	
	RadialGradient.prototype = {
	  constructor: RadialGradient
	};
	zrUtil.inherits(RadialGradient, Gradient);
	var _default = RadialGradient;
	module.exports = _default;

/***/ },
/* 2287 */
/***/ function(module, exports, __webpack_require__) {

	var _vector = __webpack_require__(41);
	
	var v2Min = _vector.min;
	var v2Max = _vector.max;
	var v2Scale = _vector.scale;
	var v2Distance = _vector.distance;
	var v2Add = _vector.add;
	var v2Clone = _vector.clone;
	var v2Sub = _vector.sub;
	
	/**
	 * 贝塞尔平滑曲线
	 * @module zrender/shape/util/smoothBezier
	 * @author pissang (https://www.github.com/pissang)
	 *         Kener (@Kener-林峰, kener.linfeng@gmail.com)
	 *         errorrik (errorrik@gmail.com)
	 */
	
	/**
	 * 贝塞尔平滑曲线
	 * @alias module:zrender/shape/util/smoothBezier
	 * @param {Array} points 线段顶点数组
	 * @param {number} smooth 平滑等级, 0-1
	 * @param {boolean} isLoop
	 * @param {Array} constraint 将计算出来的控制点约束在一个包围盒内
	 *                           比如 [[0, 0], [100, 100]], 这个包围盒会与
	 *                           整个折线的包围盒做一个并集用来约束控制点。
	 * @param {Array} 计算出来的控制点数组
	 */
	function _default(points, smooth, isLoop, constraint) {
	  var cps = [];
	  var v = [];
	  var v1 = [];
	  var v2 = [];
	  var prevPoint;
	  var nextPoint;
	  var min;
	  var max;
	
	  if (constraint) {
	    min = [Infinity, Infinity];
	    max = [-Infinity, -Infinity];
	
	    for (var i = 0, len = points.length; i < len; i++) {
	      v2Min(min, min, points[i]);
	      v2Max(max, max, points[i]);
	    } // 与指定的包围盒做并集
	
	
	    v2Min(min, min, constraint[0]);
	    v2Max(max, max, constraint[1]);
	  }
	
	  for (var i = 0, len = points.length; i < len; i++) {
	    var point = points[i];
	
	    if (isLoop) {
	      prevPoint = points[i ? i - 1 : len - 1];
	      nextPoint = points[(i + 1) % len];
	    } else {
	      if (i === 0 || i === len - 1) {
	        cps.push(v2Clone(points[i]));
	        continue;
	      } else {
	        prevPoint = points[i - 1];
	        nextPoint = points[i + 1];
	      }
	    }
	
	    v2Sub(v, nextPoint, prevPoint); // use degree to scale the handle length
	
	    v2Scale(v, v, smooth);
	    var d0 = v2Distance(point, prevPoint);
	    var d1 = v2Distance(point, nextPoint);
	    var sum = d0 + d1;
	
	    if (sum !== 0) {
	      d0 /= sum;
	      d1 /= sum;
	    }
	
	    v2Scale(v1, v, -d0);
	    v2Scale(v2, v, d1);
	    var cp0 = v2Add([], point, v1);
	    var cp1 = v2Add([], point, v2);
	
	    if (constraint) {
	      v2Max(cp0, cp0, min);
	      v2Min(cp0, cp0, max);
	      v2Max(cp1, cp1, min);
	      v2Min(cp1, cp1, max);
	    }
	
	    cps.push(cp0);
	    cps.push(cp1);
	  }
	
	  if (isLoop) {
	    cps.push(cps.shift());
	  }
	
	  return cps;
	}
	
	module.exports = _default;

/***/ },
/* 2288 */
/***/ function(module, exports, __webpack_require__) {

	var _vector = __webpack_require__(41);
	
	var v2Distance = _vector.distance;
	
	/**
	 * Catmull-Rom spline 插值折线
	 * @module zrender/shape/util/smoothSpline
	 * @author pissang (https://www.github.com/pissang)
	 *         Kener (@Kener-林峰, kener.linfeng@gmail.com)
	 *         errorrik (errorrik@gmail.com)
	 */
	
	/**
	 * @inner
	 */
	function interpolate(p0, p1, p2, p3, t, t2, t3) {
	  var v0 = (p2 - p0) * 0.5;
	  var v1 = (p3 - p1) * 0.5;
	  return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
	}
	/**
	 * @alias module:zrender/shape/util/smoothSpline
	 * @param {Array} points 线段顶点数组
	 * @param {boolean} isLoop
	 * @return {Array}
	 */
	
	
	function _default(points, isLoop) {
	  var len = points.length;
	  var ret = [];
	  var distance = 0;
	
	  for (var i = 1; i < len; i++) {
	    distance += v2Distance(points[i - 1], points[i]);
	  }
	
	  var segs = distance / 2;
	  segs = segs < len ? len : segs;
	
	  for (var i = 0; i < segs; i++) {
	    var pos = i / (segs - 1) * (isLoop ? len : len - 1);
	    var idx = Math.floor(pos);
	    var w = pos - idx;
	    var p0;
	    var p1 = points[idx % len];
	    var p2;
	    var p3;
	
	    if (!isLoop) {
	      p0 = points[idx === 0 ? idx : idx - 1];
	      p2 = points[idx > len - 2 ? len - 1 : idx + 1];
	      p3 = points[idx > len - 3 ? len - 1 : idx + 2];
	    } else {
	      p0 = points[(idx - 1 + len) % len];
	      p2 = points[(idx + 1) % len];
	      p3 = points[(idx + 2) % len];
	    }
	
	    var w2 = w * w;
	    var w3 = w * w2;
	    ret.push([interpolate(p0[0], p1[0], p2[0], p3[0], w, w2, w3), interpolate(p0[1], p1[1], p2[1], p3[1], w, w2, w3)]);
	  }
	
	  return ret;
	}
	
	module.exports = _default;

/***/ },
/* 2289 */
/***/ function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(46);
	
	/**
	 * 圆弧
	 * @module zrender/graphic/shape/Arc
	 */
	var _default = Path.extend({
	  type: 'arc',
	  shape: {
	    cx: 0,
	    cy: 0,
	    r: 0,
	    startAngle: 0,
	    endAngle: Math.PI * 2,
	    clockwise: true
	  },
	  style: {
	    stroke: '#000',
	    fill: null
	  },
	  buildPath: function (ctx, shape) {
	    var x = shape.cx;
	    var y = shape.cy;
	    var r = Math.max(shape.r, 0);
	    var startAngle = shape.startAngle;
	    var endAngle = shape.endAngle;
	    var clockwise = shape.clockwise;
	    var unitX = Math.cos(startAngle);
	    var unitY = Math.sin(startAngle);
	    ctx.moveTo(unitX * r + x, unitY * r + y);
	    ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
	  }
	});
	
	module.exports = _default;

/***/ },
/* 2290 */
/***/ function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(46);
	
	var vec2 = __webpack_require__(41);
	
	var _curve = __webpack_require__(152);
	
	var quadraticSubdivide = _curve.quadraticSubdivide;
	var cubicSubdivide = _curve.cubicSubdivide;
	var quadraticAt = _curve.quadraticAt;
	var cubicAt = _curve.cubicAt;
	var quadraticDerivativeAt = _curve.quadraticDerivativeAt;
	var cubicDerivativeAt = _curve.cubicDerivativeAt;
	
	/**
	 * 贝塞尔曲线
	 * @module zrender/shape/BezierCurve
	 */
	var out = [];
	
	function someVectorAt(shape, t, isTangent) {
	  var cpx2 = shape.cpx2;
	  var cpy2 = shape.cpy2;
	
	  if (cpx2 === null || cpy2 === null) {
	    return [(isTangent ? cubicDerivativeAt : cubicAt)(shape.x1, shape.cpx1, shape.cpx2, shape.x2, t), (isTangent ? cubicDerivativeAt : cubicAt)(shape.y1, shape.cpy1, shape.cpy2, shape.y2, t)];
	  } else {
	    return [(isTangent ? quadraticDerivativeAt : quadraticAt)(shape.x1, shape.cpx1, shape.x2, t), (isTangent ? quadraticDerivativeAt : quadraticAt)(shape.y1, shape.cpy1, shape.y2, t)];
	  }
	}
	
	var _default = Path.extend({
	  type: 'bezier-curve',
	  shape: {
	    x1: 0,
	    y1: 0,
	    x2: 0,
	    y2: 0,
	    cpx1: 0,
	    cpy1: 0,
	    // cpx2: 0,
	    // cpy2: 0
	    // Curve show percent, for animating
	    percent: 1
	  },
	  style: {
	    stroke: '#000',
	    fill: null
	  },
	  buildPath: function (ctx, shape) {
	    var x1 = shape.x1;
	    var y1 = shape.y1;
	    var x2 = shape.x2;
	    var y2 = shape.y2;
	    var cpx1 = shape.cpx1;
	    var cpy1 = shape.cpy1;
	    var cpx2 = shape.cpx2;
	    var cpy2 = shape.cpy2;
	    var percent = shape.percent;
	
	    if (percent === 0) {
	      return;
	    }
	
	    ctx.moveTo(x1, y1);
	
	    if (cpx2 == null || cpy2 == null) {
	      if (percent < 1) {
	        quadraticSubdivide(x1, cpx1, x2, percent, out);
	        cpx1 = out[1];
	        x2 = out[2];
	        quadraticSubdivide(y1, cpy1, y2, percent, out);
	        cpy1 = out[1];
	        y2 = out[2];
	      }
	
	      ctx.quadraticCurveTo(cpx1, cpy1, x2, y2);
	    } else {
	      if (percent < 1) {
	        cubicSubdivide(x1, cpx1, cpx2, x2, percent, out);
	        cpx1 = out[1];
	        cpx2 = out[2];
	        x2 = out[3];
	        cubicSubdivide(y1, cpy1, cpy2, y2, percent, out);
	        cpy1 = out[1];
	        cpy2 = out[2];
	        y2 = out[3];
	      }
	
	      ctx.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x2, y2);
	    }
	  },
	
	  /**
	   * Get point at percent
	   * @param  {number} t
	   * @return {Array.<number>}
	   */
	  pointAt: function (t) {
	    return someVectorAt(this.shape, t, false);
	  },
	
	  /**
	   * Get tangent at percent
	   * @param  {number} t
	   * @return {Array.<number>}
	   */
	  tangentAt: function (t) {
	    var p = someVectorAt(this.shape, t, true);
	    return vec2.normalize(p, p);
	  }
	});
	
	module.exports = _default;

/***/ },
/* 2291 */
/***/ function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(46);
	
	/**
	 * 椭圆形状
	 * @module zrender/graphic/shape/Ellipse
	 */
	var _default = Path.extend({
	  type: 'ellipse',
	  shape: {
	    cx: 0,
	    cy: 0,
	    rx: 0,
	    ry: 0
	  },
	  buildPath: function (ctx, shape) {
	    var k = 0.5522848;
	    var x = shape.cx;
	    var y = shape.cy;
	    var a = shape.rx;
	    var b = shape.ry;
	    var ox = a * k; // 水平控制点偏移量
	
	    var oy = b * k; // 垂直控制点偏移量
	    // 从椭圆的左端点开始顺时针绘制四条三次贝塞尔曲线
	
	    ctx.moveTo(x - a, y);
	    ctx.bezierCurveTo(x - a, y - oy, x - ox, y - b, x, y - b);
	    ctx.bezierCurveTo(x + ox, y - b, x + a, y - oy, x + a, y);
	    ctx.bezierCurveTo(x + a, y + oy, x + ox, y + b, x, y + b);
	    ctx.bezierCurveTo(x - ox, y + b, x - a, y + oy, x - a, y);
	    ctx.closePath();
	  }
	});
	
	module.exports = _default;

/***/ },
/* 2292 */
/***/ function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(46);
	
	/**
	 * 圆环
	 * @module zrender/graphic/shape/Ring
	 */
	var _default = Path.extend({
	  type: 'ring',
	  shape: {
	    cx: 0,
	    cy: 0,
	    r: 0,
	    r0: 0
	  },
	  buildPath: function (ctx, shape) {
	    var x = shape.cx;
	    var y = shape.cy;
	    var PI2 = Math.PI * 2;
	    ctx.moveTo(x + shape.r, y);
	    ctx.arc(x, y, shape.r, 0, PI2, false);
	    ctx.moveTo(x + shape.r0, y);
	    ctx.arc(x, y, shape.r0, 0, PI2, true);
	  }
	});
	
	module.exports = _default;

/***/ },
/* 2293 */
/***/ function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(46);
	
	var fixClipWithShadow = __webpack_require__(1088);
	
	/**
	 * 扇形
	 * @module zrender/graphic/shape/Sector
	 */
	var _default = Path.extend({
	  type: 'sector',
	  shape: {
	    cx: 0,
	    cy: 0,
	    r0: 0,
	    r: 0,
	    startAngle: 0,
	    endAngle: Math.PI * 2,
	    clockwise: true
	  },
	  brush: fixClipWithShadow(Path.prototype.brush),
	  buildPath: function (ctx, shape) {
	    var x = shape.cx;
	    var y = shape.cy;
	    var r0 = Math.max(shape.r0 || 0, 0);
	    var r = Math.max(shape.r, 0);
	    var startAngle = shape.startAngle;
	    var endAngle = shape.endAngle;
	    var clockwise = shape.clockwise;
	    var unitX = Math.cos(startAngle);
	    var unitY = Math.sin(startAngle);
	    ctx.moveTo(unitX * r0 + x, unitY * r0 + y);
	    ctx.lineTo(unitX * r + x, unitY * r + y);
	    ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
	    ctx.lineTo(Math.cos(endAngle) * r0 + x, Math.sin(endAngle) * r0 + y);
	
	    if (r0 !== 0) {
	      ctx.arc(x, y, r0, endAngle, startAngle, clockwise);
	    }
	
	    ctx.closePath();
	  }
	});
	
	module.exports = _default;

/***/ },
/* 2294 */
/***/ function(module, exports, __webpack_require__) {

	var Animator = __webpack_require__(1077);
	
	var logError = __webpack_require__(293);
	
	var _util = __webpack_require__(3);
	
	var isString = _util.isString;
	var isFunction = _util.isFunction;
	var isObject = _util.isObject;
	var isArrayLike = _util.isArrayLike;
	var indexOf = _util.indexOf;
	
	/**
	 * @alias module:zrender/mixin/Animatable
	 * @constructor
	 */
	var Animatable = function () {
	  /**
	   * @type {Array.<module:zrender/animation/Animator>}
	   * @readOnly
	   */
	  this.animators = [];
	};
	
	Animatable.prototype = {
	  constructor: Animatable,
	
	  /**
	   * 动画
	   *
	   * @param {string} path The path to fetch value from object, like 'a.b.c'.
	   * @param {boolean} [loop] Whether to loop animation.
	   * @return {module:zrender/animation/Animator}
	   * @example:
	   *     el.animate('style', false)
	   *         .when(1000, {x: 10} )
	   *         .done(function(){ // Animation done })
	   *         .start()
	   */
	  animate: function (path, loop) {
	    var target;
	    var animatingShape = false;
	    var el = this;
	    var zr = this.__zr;
	
	    if (path) {
	      var pathSplitted = path.split('.');
	      var prop = el; // If animating shape
	
	      animatingShape = pathSplitted[0] === 'shape';
	
	      for (var i = 0, l = pathSplitted.length; i < l; i++) {
	        if (!prop) {
	          continue;
	        }
	
	        prop = prop[pathSplitted[i]];
	      }
	
	      if (prop) {
	        target = prop;
	      }
	    } else {
	      target = el;
	    }
	
	    if (!target) {
	      logError('Property "' + path + '" is not existed in element ' + el.id);
	      return;
	    }
	
	    var animators = el.animators;
	    var animator = new Animator(target, loop);
	    animator.during(function (target) {
	      el.dirty(animatingShape);
	    }).done(function () {
	      // FIXME Animator will not be removed if use `Animator#stop` to stop animation
	      animators.splice(indexOf(animators, animator), 1);
	    });
	    animators.push(animator); // If animate after added to the zrender
	
	    if (zr) {
	      zr.animation.addAnimator(animator);
	    }
	
	    return animator;
	  },
	
	  /**
	   * 停止动画
	   * @param {boolean} forwardToLast If move to last frame before stop
	   */
	  stopAnimation: function (forwardToLast) {
	    var animators = this.animators;
	    var len = animators.length;
	
	    for (var i = 0; i < len; i++) {
	      animators[i].stop(forwardToLast);
	    }
	
	    animators.length = 0;
	    return this;
	  },
	
	  /**
	   * Caution: this method will stop previous animation.
	   * So do not use this method to one element twice before
	   * animation starts, unless you know what you are doing.
	   * @param {Object} target
	   * @param {number} [time=500] Time in ms
	   * @param {string} [easing='linear']
	   * @param {number} [delay=0]
	   * @param {Function} [callback]
	   * @param {Function} [forceAnimate] Prevent stop animation and callback
	   *        immediently when target values are the same as current values.
	   *
	   * @example
	   *  // Animate position
	   *  el.animateTo({
	   *      position: [10, 10]
	   *  }, function () { // done })
	   *
	   *  // Animate shape, style and position in 100ms, delayed 100ms, with cubicOut easing
	   *  el.animateTo({
	   *      shape: {
	   *          width: 500
	   *      },
	   *      style: {
	   *          fill: 'red'
	   *      }
	   *      position: [10, 10]
	   *  }, 100, 100, 'cubicOut', function () { // done })
	   */
	  // TODO Return animation key
	  animateTo: function (target, time, delay, easing, callback, forceAnimate) {
	    animateTo(this, target, time, delay, easing, callback, forceAnimate);
	  },
	
	  /**
	   * Animate from the target state to current state.
	   * The params and the return value are the same as `this.animateTo`.
	   */
	  animateFrom: function (target, time, delay, easing, callback, forceAnimate) {
	    animateTo(this, target, time, delay, easing, callback, forceAnimate, true);
	  }
	};
	
	function animateTo(animatable, target, time, delay, easing, callback, forceAnimate, reverse) {
	  // animateTo(target, time, easing, callback);
	  if (isString(delay)) {
	    callback = easing;
	    easing = delay;
	    delay = 0;
	  } // animateTo(target, time, delay, callback);
	  else if (isFunction(easing)) {
	      callback = easing;
	      easing = 'linear';
	      delay = 0;
	    } // animateTo(target, time, callback);
	    else if (isFunction(delay)) {
	        callback = delay;
	        delay = 0;
	      } // animateTo(target, callback)
	      else if (isFunction(time)) {
	          callback = time;
	          time = 500;
	        } // animateTo(target)
	        else if (!time) {
	            time = 500;
	          } // Stop all previous animations
	
	
	  animatable.stopAnimation();
	  animateToShallow(animatable, '', animatable, target, time, delay, reverse); // Animators may be removed immediately after start
	  // if there is nothing to animate
	
	  var animators = animatable.animators.slice();
	  var count = animators.length;
	
	  function done() {
	    count--;
	
	    if (!count) {
	      callback && callback();
	    }
	  } // No animators. This should be checked before animators[i].start(),
	  // because 'done' may be executed immediately if no need to animate.
	
	
	  if (!count) {
	    callback && callback();
	  } // Start after all animators created
	  // Incase any animator is done immediately when all animation properties are not changed
	
	
	  for (var i = 0; i < animators.length; i++) {
	    animators[i].done(done).start(easing, forceAnimate);
	  }
	}
	/**
	 * @param {string} path=''
	 * @param {Object} source=animatable
	 * @param {Object} target
	 * @param {number} [time=500]
	 * @param {number} [delay=0]
	 * @param {boolean} [reverse] If `true`, animate
	 *        from the `target` to current state.
	 *
	 * @example
	 *  // Animate position
	 *  el._animateToShallow({
	 *      position: [10, 10]
	 *  })
	 *
	 *  // Animate shape, style and position in 100ms, delayed 100ms
	 *  el._animateToShallow({
	 *      shape: {
	 *          width: 500
	 *      },
	 *      style: {
	 *          fill: 'red'
	 *      }
	 *      position: [10, 10]
	 *  }, 100, 100)
	 */
	
	
	function animateToShallow(animatable, path, source, target, time, delay, reverse) {
	  var objShallow = {};
	  var propertyCount = 0;
	
	  for (var name in target) {
	    if (!target.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (source[name] != null) {
	      if (isObject(target[name]) && !isArrayLike(target[name])) {
	        animateToShallow(animatable, path ? path + '.' + name : name, source[name], target[name], time, delay, reverse);
	      } else {
	        if (reverse) {
	          objShallow[name] = source[name];
	          setAttrByPath(animatable, path, name, target[name]);
	        } else {
	          objShallow[name] = target[name];
	        }
	
	        propertyCount++;
	      }
	    } else if (target[name] != null && !reverse) {
	      setAttrByPath(animatable, path, name, target[name]);
	    }
	  }
	
	  if (propertyCount > 0) {
	    animatable.animate(path, false).when(time == null ? 500 : time, objShallow).delay(delay || 0);
	  }
	}
	
	function setAttrByPath(el, path, name, value) {
	  // Attr directly if not has property
	  // FIXME, if some property not needed for element ?
	  if (!path) {
	    el.attr(name, value);
	  } else {
	    // Only support set shape or style
	    var props = {};
	    props[path] = {};
	    props[path][name] = value;
	    el.attr(props);
	  }
	}
	
	var _default = Animatable;
	module.exports = _default;

/***/ },
/* 2295 */
/***/ function(module, exports) {

	// TODO Draggable for group
	// FIXME Draggable on element which has parent rotation or scale
	function Draggable() {
	  this.on('mousedown', this._dragStart, this);
	  this.on('mousemove', this._drag, this);
	  this.on('mouseup', this._dragEnd, this); // `mosuemove` and `mouseup` can be continue to fire when dragging.
	  // See [Drag outside] in `Handler.js`. So we do not need to trigger
	  // `_dragEnd` when globalout. That would brings better user experience.
	  // this.on('globalout', this._dragEnd, this);
	  // this._dropTarget = null;
	  // this._draggingTarget = null;
	  // this._x = 0;
	  // this._y = 0;
	}
	
	Draggable.prototype = {
	  constructor: Draggable,
	  _dragStart: function (e) {
	    var draggingTarget = e.target; // Find if there is draggable in the ancestor
	
	    while (draggingTarget && !draggingTarget.draggable) {
	      draggingTarget = draggingTarget.parent;
	    }
	
	    if (draggingTarget) {
	      this._draggingTarget = draggingTarget;
	      draggingTarget.dragging = true;
	      this._x = e.offsetX;
	      this._y = e.offsetY;
	      this.dispatchToElement(param(draggingTarget, e), 'dragstart', e.event);
	    }
	  },
	  _drag: function (e) {
	    var draggingTarget = this._draggingTarget;
	
	    if (draggingTarget) {
	      var x = e.offsetX;
	      var y = e.offsetY;
	      var dx = x - this._x;
	      var dy = y - this._y;
	      this._x = x;
	      this._y = y;
	      draggingTarget.drift(dx, dy, e);
	      this.dispatchToElement(param(draggingTarget, e), 'drag', e.event);
	      var dropTarget = this.findHover(x, y, draggingTarget).target;
	      var lastDropTarget = this._dropTarget;
	      this._dropTarget = dropTarget;
	
	      if (draggingTarget !== dropTarget) {
	        if (lastDropTarget && dropTarget !== lastDropTarget) {
	          this.dispatchToElement(param(lastDropTarget, e), 'dragleave', e.event);
	        }
	
	        if (dropTarget && dropTarget !== lastDropTarget) {
	          this.dispatchToElement(param(dropTarget, e), 'dragenter', e.event);
	        }
	      }
	    }
	  },
	  _dragEnd: function (e) {
	    var draggingTarget = this._draggingTarget;
	
	    if (draggingTarget) {
	      draggingTarget.dragging = false;
	    }
	
	    this.dispatchToElement(param(draggingTarget, e), 'dragend', e.event);
	
	    if (this._dropTarget) {
	      this.dispatchToElement(param(this._dropTarget, e), 'drop', e.event);
	    }
	
	    this._draggingTarget = null;
	    this._dropTarget = null;
	  }
	};
	
	function param(target, e) {
	  return {
	    target: target,
	    topTarget: e && e.topTarget
	  };
	}
	
	var _default = Draggable;
	module.exports = _default;

/***/ },
/* 2296 */
/***/ function(module, exports, __webpack_require__) {

	var _core = __webpack_require__(562);
	
	var createElement = _core.createElement;
	
	var util = __webpack_require__(3);
	
	var logError = __webpack_require__(293);
	
	var Path = __webpack_require__(46);
	
	var ZImage = __webpack_require__(232);
	
	var ZText = __webpack_require__(188);
	
	var arrayDiff = __webpack_require__(2282);
	
	var GradientManager = __webpack_require__(2298);
	
	var ClippathManager = __webpack_require__(2297);
	
	var ShadowManager = __webpack_require__(2299);
	
	var _graphic = __webpack_require__(563);
	
	var svgPath = _graphic.path;
	var svgImage = _graphic.image;
	var svgText = _graphic.text;
	
	/**
	 * SVG Painter
	 * @module zrender/svg/Painter
	 */
	function parseInt10(val) {
	  return parseInt(val, 10);
	}
	
	function getSvgProxy(el) {
	  if (el instanceof Path) {
	    return svgPath;
	  } else if (el instanceof ZImage) {
	    return svgImage;
	  } else if (el instanceof ZText) {
	    return svgText;
	  } else {
	    return svgPath;
	  }
	}
	
	function checkParentAvailable(parent, child) {
	  return child && parent && child.parentNode !== parent;
	}
	
	function insertAfter(parent, child, prevSibling) {
	  if (checkParentAvailable(parent, child) && prevSibling) {
	    var nextSibling = prevSibling.nextSibling;
	    nextSibling ? parent.insertBefore(child, nextSibling) : parent.appendChild(child);
	  }
	}
	
	function prepend(parent, child) {
	  if (checkParentAvailable(parent, child)) {
	    var firstChild = parent.firstChild;
	    firstChild ? parent.insertBefore(child, firstChild) : parent.appendChild(child);
	  }
	} // function append(parent, child) {
	//     if (checkParentAvailable(parent, child)) {
	//         parent.appendChild(child);
	//     }
	// }
	
	
	function remove(parent, child) {
	  if (child && parent && child.parentNode === parent) {
	    parent.removeChild(child);
	  }
	}
	
	function getTextSvgElement(displayable) {
	  return displayable.__textSvgEl;
	}
	
	function getSvgElement(displayable) {
	  return displayable.__svgEl;
	}
	/**
	 * @alias module:zrender/svg/Painter
	 * @constructor
	 * @param {HTMLElement} root 绘图容器
	 * @param {module:zrender/Storage} storage
	 * @param {Object} opts
	 */
	
	
	var SVGPainter = function (root, storage, opts, zrId) {
	  this.root = root;
	  this.storage = storage;
	  this._opts = opts = util.extend({}, opts || {});
	  var svgDom = createElement('svg');
	  svgDom.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
	  svgDom.setAttribute('version', '1.1');
	  svgDom.setAttribute('baseProfile', 'full');
	  svgDom.style.cssText = 'user-select:none;position:absolute;left:0;top:0;';
	  var bgRoot = createElement('g');
	  svgDom.appendChild(bgRoot);
	  var svgRoot = createElement('g');
	  svgDom.appendChild(svgRoot);
	  this.gradientManager = new GradientManager(zrId, svgRoot);
	  this.clipPathManager = new ClippathManager(zrId, svgRoot);
	  this.shadowManager = new ShadowManager(zrId, svgRoot);
	  var viewport = document.createElement('div');
	  viewport.style.cssText = 'overflow:hidden;position:relative';
	  this._svgDom = svgDom;
	  this._svgRoot = svgRoot;
	  this._backgroundRoot = bgRoot;
	  this._viewport = viewport;
	  root.appendChild(viewport);
	  viewport.appendChild(svgDom);
	  this.resize(opts.width, opts.height);
	  this._visibleList = [];
	};
	
	SVGPainter.prototype = {
	  constructor: SVGPainter,
	  getType: function () {
	    return 'svg';
	  },
	  getViewportRoot: function () {
	    return this._viewport;
	  },
	  getSvgDom: function () {
	    return this._svgDom;
	  },
	  getSvgRoot: function () {
	    return this._svgRoot;
	  },
	  getViewportRootOffset: function () {
	    var viewportRoot = this.getViewportRoot();
	
	    if (viewportRoot) {
	      return {
	        offsetLeft: viewportRoot.offsetLeft || 0,
	        offsetTop: viewportRoot.offsetTop || 0
	      };
	    }
	  },
	  refresh: function () {
	    var list = this.storage.getDisplayList(true);
	
	    this._paintList(list);
	  },
	  setBackgroundColor: function (backgroundColor) {
	    // TODO gradient
	    // Insert a bg rect instead of setting background to viewport.
	    // Otherwise, the exported SVG don't have background.
	    if (this._backgroundRoot && this._backgroundNode) {
	      this._backgroundRoot.removeChild(this._backgroundNode);
	    }
	
	    var bgNode = createElement('rect');
	    bgNode.setAttribute('width', this.getWidth());
	    bgNode.setAttribute('height', this.getHeight());
	    bgNode.setAttribute('x', 0);
	    bgNode.setAttribute('y', 0);
	    bgNode.setAttribute('id', 0);
	    bgNode.style.fill = backgroundColor;
	
	    this._backgroundRoot.appendChild(bgNode);
	
	    this._backgroundNode = bgNode;
	  },
	  _paintList: function (list) {
	    this.gradientManager.markAllUnused();
	    this.clipPathManager.markAllUnused();
	    this.shadowManager.markAllUnused();
	    var svgRoot = this._svgRoot;
	    var visibleList = this._visibleList;
	    var listLen = list.length;
	    var newVisibleList = [];
	    var i;
	
	    for (i = 0; i < listLen; i++) {
	      var displayable = list[i];
	      var svgProxy = getSvgProxy(displayable);
	      var svgElement = getSvgElement(displayable) || getTextSvgElement(displayable);
	
	      if (!displayable.invisible) {
	        if (displayable.__dirty) {
	          svgProxy && svgProxy.brush(displayable); // Update clipPath
	
	          this.clipPathManager.update(displayable); // Update gradient and shadow
	
	          if (displayable.style) {
	            this.gradientManager.update(displayable.style.fill);
	            this.gradientManager.update(displayable.style.stroke);
	            this.shadowManager.update(svgElement, displayable);
	          }
	
	          displayable.__dirty = false;
	        }
	
	        newVisibleList.push(displayable);
	      }
	    }
	
	    var diff = arrayDiff(visibleList, newVisibleList);
	    var prevSvgElement; // First do remove, in case element moved to the head and do remove
	    // after add
	
	    for (i = 0; i < diff.length; i++) {
	      var item = diff[i];
	
	      if (item.removed) {
	        for (var k = 0; k < item.count; k++) {
	          var displayable = visibleList[item.indices[k]];
	          var svgElement = getSvgElement(displayable);
	          var textSvgElement = getTextSvgElement(displayable);
	          remove(svgRoot, svgElement);
	          remove(svgRoot, textSvgElement);
	        }
	      }
	    }
	
	    for (i = 0; i < diff.length; i++) {
	      var item = diff[i];
	
	      if (item.added) {
	        for (var k = 0; k < item.count; k++) {
	          var displayable = newVisibleList[item.indices[k]];
	          var svgElement = getSvgElement(displayable);
	          var textSvgElement = getTextSvgElement(displayable);
	          prevSvgElement ? insertAfter(svgRoot, svgElement, prevSvgElement) : prepend(svgRoot, svgElement);
	
	          if (svgElement) {
	            insertAfter(svgRoot, textSvgElement, svgElement);
	          } else if (prevSvgElement) {
	            insertAfter(svgRoot, textSvgElement, prevSvgElement);
	          } else {
	            prepend(svgRoot, textSvgElement);
	          } // Insert text
	
	
	          insertAfter(svgRoot, textSvgElement, svgElement);
	          prevSvgElement = textSvgElement || svgElement || prevSvgElement; // zrender.Text only create textSvgElement.
	
	          this.gradientManager.addWithoutUpdate(svgElement || textSvgElement, displayable);
	          this.shadowManager.addWithoutUpdate(svgElement || textSvgElement, displayable);
	          this.clipPathManager.markUsed(displayable);
	        }
	      } else if (!item.removed) {
	        for (var k = 0; k < item.count; k++) {
	          var displayable = newVisibleList[item.indices[k]];
	          var svgElement = getSvgElement(displayable);
	          var textSvgElement = getTextSvgElement(displayable);
	          var svgElement = getSvgElement(displayable);
	          var textSvgElement = getTextSvgElement(displayable);
	          this.gradientManager.markUsed(displayable);
	          this.gradientManager.addWithoutUpdate(svgElement || textSvgElement, displayable);
	          this.shadowManager.markUsed(displayable);
	          this.shadowManager.addWithoutUpdate(svgElement || textSvgElement, displayable);
	          this.clipPathManager.markUsed(displayable);
	
	          if (textSvgElement) {
	            // Insert text.
	            insertAfter(svgRoot, textSvgElement, svgElement);
	          }
	
	          prevSvgElement = svgElement || textSvgElement || prevSvgElement;
	        }
	      }
	    }
	
	    this.gradientManager.removeUnused();
	    this.clipPathManager.removeUnused();
	    this.shadowManager.removeUnused();
	    this._visibleList = newVisibleList;
	  },
	  _getDefs: function (isForceCreating) {
	    var svgRoot = this._svgDom;
	    var defs = svgRoot.getElementsByTagName('defs');
	
	    if (defs.length === 0) {
	      // Not exist
	      if (isForceCreating) {
	        var defs = svgRoot.insertBefore(createElement('defs'), // Create new tag
	        svgRoot.firstChild // Insert in the front of svg
	        );
	
	        if (!defs.contains) {
	          // IE doesn't support contains method
	          defs.contains = function (el) {
	            var children = defs.children;
	
	            if (!children) {
	              return false;
	            }
	
	            for (var i = children.length - 1; i >= 0; --i) {
	              if (children[i] === el) {
	                return true;
	              }
	            }
	
	            return false;
	          };
	        }
	
	        return defs;
	      } else {
	        return null;
	      }
	    } else {
	      return defs[0];
	    }
	  },
	  resize: function (width, height) {
	    var viewport = this._viewport; // FIXME Why ?
	
	    viewport.style.display = 'none'; // Save input w/h
	
	    var opts = this._opts;
	    width != null && (opts.width = width);
	    height != null && (opts.height = height);
	    width = this._getSize(0);
	    height = this._getSize(1);
	    viewport.style.display = '';
	
	    if (this._width !== width || this._height !== height) {
	      this._width = width;
	      this._height = height;
	      var viewportStyle = viewport.style;
	      viewportStyle.width = width + 'px';
	      viewportStyle.height = height + 'px';
	      var svgRoot = this._svgDom; // Set width by 'svgRoot.width = width' is invalid
	
	      svgRoot.setAttribute('width', width);
	      svgRoot.setAttribute('height', height);
	    }
	
	    if (this._backgroundNode) {
	      this._backgroundNode.setAttribute('width', width);
	
	      this._backgroundNode.setAttribute('height', height);
	    }
	  },
	
	  /**
	   * 获取绘图区域宽度
	   */
	  getWidth: function () {
	    return this._width;
	  },
	
	  /**
	   * 获取绘图区域高度
	   */
	  getHeight: function () {
	    return this._height;
	  },
	  _getSize: function (whIdx) {
	    var opts = this._opts;
	    var wh = ['width', 'height'][whIdx];
	    var cwh = ['clientWidth', 'clientHeight'][whIdx];
	    var plt = ['paddingLeft', 'paddingTop'][whIdx];
	    var prb = ['paddingRight', 'paddingBottom'][whIdx];
	
	    if (opts[wh] != null && opts[wh] !== 'auto') {
	      return parseFloat(opts[wh]);
	    }
	
	    var root = this.root; // IE8 does not support getComputedStyle, but it use VML.
	
	    var stl = document.defaultView.getComputedStyle(root);
	    return (root[cwh] || parseInt10(stl[wh]) || parseInt10(root.style[wh])) - (parseInt10(stl[plt]) || 0) - (parseInt10(stl[prb]) || 0) | 0;
	  },
	  dispose: function () {
	    this.root.innerHTML = '';
	    this._svgRoot = this._backgroundRoot = this._svgDom = this._backgroundNode = this._viewport = this.storage = null;
	  },
	  clear: function () {
	    if (this._viewport) {
	      this.root.removeChild(this._viewport);
	    }
	  },
	  toDataURL: function () {
	    this.refresh();
	    var html = encodeURIComponent(this._svgDom.outerHTML.replace(/></g, '>\n\r<'));
	    return 'data:image/svg+xml;charset=UTF-8,' + html;
	  }
	}; // Not supported methods
	
	function createMethodNotSupport(method) {
	  return function () {
	    logError('In SVG mode painter not support method "' + method + '"');
	  };
	} // Unsuppoted methods
	
	
	util.each(['getLayer', 'insertLayer', 'eachLayer', 'eachBuiltinLayer', 'eachOtherLayer', 'getLayers', 'modLayer', 'delLayer', 'clearLayer', 'pathToImage'], function (name) {
	  SVGPainter.prototype[name] = createMethodNotSupport(name);
	});
	var _default = SVGPainter;
	module.exports = _default;

/***/ },
/* 2297 */
/***/ function(module, exports, __webpack_require__) {

	var Definable = __webpack_require__(564);
	
	var zrUtil = __webpack_require__(3);
	
	var matrix = __webpack_require__(73);
	
	/**
	 * @file Manages SVG clipPath elements.
	 * @author Zhang Wenli
	 */
	
	/**
	 * Manages SVG clipPath elements.
	 *
	 * @class
	 * @extends Definable
	 * @param   {number}     zrId    zrender instance id
	 * @param   {SVGElement} svgRoot root of SVG document
	 */
	function ClippathManager(zrId, svgRoot) {
	  Definable.call(this, zrId, svgRoot, 'clipPath', '__clippath_in_use__');
	}
	
	zrUtil.inherits(ClippathManager, Definable);
	/**
	 * Update clipPath.
	 *
	 * @param {Displayable} displayable displayable element
	 */
	
	ClippathManager.prototype.update = function (displayable) {
	  var svgEl = this.getSvgElement(displayable);
	
	  if (svgEl) {
	    this.updateDom(svgEl, displayable.__clipPaths, false);
	  }
	
	  var textEl = this.getTextSvgElement(displayable);
	
	  if (textEl) {
	    // Make another clipPath for text, since it's transform
	    // matrix is not the same with svgElement
	    this.updateDom(textEl, displayable.__clipPaths, true);
	  }
	
	  this.markUsed(displayable);
	};
	/**
	 * Create an SVGElement of displayable and create a <clipPath> of its
	 * clipPath
	 *
	 * @param {Displayable} parentEl  parent element
	 * @param {ClipPath[]}  clipPaths clipPaths of parent element
	 * @param {boolean}     isText    if parent element is Text
	 */
	
	
	ClippathManager.prototype.updateDom = function (parentEl, clipPaths, isText) {
	  if (clipPaths && clipPaths.length > 0) {
	    // Has clipPath, create <clipPath> with the first clipPath
	    var defs = this.getDefs(true);
	    var clipPath = clipPaths[0];
	    var clipPathEl;
	    var id;
	    var dom = isText ? '_textDom' : '_dom';
	
	    if (clipPath[dom]) {
	      // Use a dom that is already in <defs>
	      id = clipPath[dom].getAttribute('id');
	      clipPathEl = clipPath[dom]; // Use a dom that is already in <defs>
	
	      if (!defs.contains(clipPathEl)) {
	        // This happens when set old clipPath that has
	        // been previously removed
	        defs.appendChild(clipPathEl);
	      }
	    } else {
	      // New <clipPath>
	      id = 'zr' + this._zrId + '-clip-' + this.nextId;
	      ++this.nextId;
	      clipPathEl = this.createElement('clipPath');
	      clipPathEl.setAttribute('id', id);
	      defs.appendChild(clipPathEl);
	      clipPath[dom] = clipPathEl;
	    } // Build path and add to <clipPath>
	
	
	    var svgProxy = this.getSvgProxy(clipPath);
	
	    if (clipPath.transform && clipPath.parent.invTransform && !isText) {
	      /**
	       * If a clipPath has a parent with transform, the transform
	       * of parent should not be considered when setting transform
	       * of clipPath. So we need to transform back from parent's
	       * transform, which is done by multiplying parent's inverse
	       * transform.
	       */
	      // Store old transform
	      var transform = Array.prototype.slice.call(clipPath.transform); // Transform back from parent, and brush path
	
	      matrix.mul(clipPath.transform, clipPath.parent.invTransform, clipPath.transform);
	      svgProxy.brush(clipPath); // Set back transform of clipPath
	
	      clipPath.transform = transform;
	    } else {
	      svgProxy.brush(clipPath);
	    }
	
	    var pathEl = this.getSvgElement(clipPath);
	    clipPathEl.innerHTML = '';
	    /**
	     * Use `cloneNode()` here to appendChild to multiple parents,
	     * which may happend when Text and other shapes are using the same
	     * clipPath. Since Text will create an extra clipPath DOM due to
	     * different transform rules.
	     */
	
	    clipPathEl.appendChild(pathEl.cloneNode());
	    parentEl.setAttribute('clip-path', 'url(#' + id + ')');
	
	    if (clipPaths.length > 1) {
	      // Make the other clipPaths recursively
	      this.updateDom(clipPathEl, clipPaths.slice(1), isText);
	    }
	  } else {
	    // No clipPath
	    if (parentEl) {
	      parentEl.setAttribute('clip-path', 'none');
	    }
	  }
	};
	/**
	 * Mark a single clipPath to be used
	 *
	 * @param {Displayable} displayable displayable element
	 */
	
	
	ClippathManager.prototype.markUsed = function (displayable) {
	  var that = this; // displayable.__clipPaths can only be `null`/`undefined` or an non-empty array.
	
	  if (displayable.__clipPaths) {
	    zrUtil.each(displayable.__clipPaths, function (clipPath) {
	      if (clipPath._dom) {
	        Definable.prototype.markUsed.call(that, clipPath._dom);
	      }
	
	      if (clipPath._textDom) {
	        Definable.prototype.markUsed.call(that, clipPath._textDom);
	      }
	    });
	  }
	};
	
	var _default = ClippathManager;
	module.exports = _default;

/***/ },
/* 2298 */
/***/ function(module, exports, __webpack_require__) {

	var Definable = __webpack_require__(564);
	
	var zrUtil = __webpack_require__(3);
	
	var logError = __webpack_require__(293);
	
	var colorTool = __webpack_require__(114);
	
	/**
	 * @file Manages SVG gradient elements.
	 * @author Zhang Wenli
	 */
	
	/**
	 * Manages SVG gradient elements.
	 *
	 * @class
	 * @extends Definable
	 * @param   {number}     zrId    zrender instance id
	 * @param   {SVGElement} svgRoot root of SVG document
	 */
	function GradientManager(zrId, svgRoot) {
	  Definable.call(this, zrId, svgRoot, ['linearGradient', 'radialGradient'], '__gradient_in_use__');
	}
	
	zrUtil.inherits(GradientManager, Definable);
	/**
	 * Create new gradient DOM for fill or stroke if not exist,
	 * but will not update gradient if exists.
	 *
	 * @param {SvgElement}  svgElement   SVG element to paint
	 * @param {Displayable} displayable  zrender displayable element
	 */
	
	GradientManager.prototype.addWithoutUpdate = function (svgElement, displayable) {
	  if (displayable && displayable.style) {
	    var that = this;
	    zrUtil.each(['fill', 'stroke'], function (fillOrStroke) {
	      if (displayable.style[fillOrStroke] && (displayable.style[fillOrStroke].type === 'linear' || displayable.style[fillOrStroke].type === 'radial')) {
	        var gradient = displayable.style[fillOrStroke];
	        var defs = that.getDefs(true); // Create dom in <defs> if not exists
	
	        var dom;
	
	        if (gradient._dom) {
	          // Gradient exists
	          dom = gradient._dom;
	
	          if (!defs.contains(gradient._dom)) {
	            // _dom is no longer in defs, recreate
	            that.addDom(dom);
	          }
	        } else {
	          // New dom
	          dom = that.add(gradient);
	        }
	
	        that.markUsed(displayable);
	        var id = dom.getAttribute('id');
	        svgElement.setAttribute(fillOrStroke, 'url(#' + id + ')');
	      }
	    });
	  }
	};
	/**
	 * Add a new gradient tag in <defs>
	 *
	 * @param   {Gradient} gradient zr gradient instance
	 * @return {SVGLinearGradientElement | SVGRadialGradientElement}
	 *                            created DOM
	 */
	
	
	GradientManager.prototype.add = function (gradient) {
	  var dom;
	
	  if (gradient.type === 'linear') {
	    dom = this.createElement('linearGradient');
	  } else if (gradient.type === 'radial') {
	    dom = this.createElement('radialGradient');
	  } else {
	    logError('Illegal gradient type.');
	    return null;
	  } // Set dom id with gradient id, since each gradient instance
	  // will have no more than one dom element.
	  // id may exists before for those dirty elements, in which case
	  // id should remain the same, and other attributes should be
	  // updated.
	
	
	  gradient.id = gradient.id || this.nextId++;
	  dom.setAttribute('id', 'zr' + this._zrId + '-gradient-' + gradient.id);
	  this.updateDom(gradient, dom);
	  this.addDom(dom);
	  return dom;
	};
	/**
	 * Update gradient.
	 *
	 * @param {Gradient} gradient zr gradient instance
	 */
	
	
	GradientManager.prototype.update = function (gradient) {
	  var that = this;
	  Definable.prototype.update.call(this, gradient, function () {
	    var type = gradient.type;
	    var tagName = gradient._dom.tagName;
	
	    if (type === 'linear' && tagName === 'linearGradient' || type === 'radial' && tagName === 'radialGradient') {
	      // Gradient type is not changed, update gradient
	      that.updateDom(gradient, gradient._dom);
	    } else {
	      // Remove and re-create if type is changed
	      that.removeDom(gradient);
	      that.add(gradient);
	    }
	  });
	};
	/**
	 * Update gradient dom
	 *
	 * @param {Gradient} gradient zr gradient instance
	 * @param {SVGLinearGradientElement | SVGRadialGradientElement} dom
	 *                            DOM to update
	 */
	
	
	GradientManager.prototype.updateDom = function (gradient, dom) {
	  if (gradient.type === 'linear') {
	    dom.setAttribute('x1', gradient.x);
	    dom.setAttribute('y1', gradient.y);
	    dom.setAttribute('x2', gradient.x2);
	    dom.setAttribute('y2', gradient.y2);
	  } else if (gradient.type === 'radial') {
	    dom.setAttribute('cx', gradient.x);
	    dom.setAttribute('cy', gradient.y);
	    dom.setAttribute('r', gradient.r);
	  } else {
	    logError('Illegal gradient type.');
	    return;
	  }
	
	  if (gradient.global) {
	    // x1, x2, y1, y2 in range of 0 to canvas width or height
	    dom.setAttribute('gradientUnits', 'userSpaceOnUse');
	  } else {
	    // x1, x2, y1, y2 in range of 0 to 1
	    dom.setAttribute('gradientUnits', 'objectBoundingBox');
	  } // Remove color stops if exists
	
	
	  dom.innerHTML = ''; // Add color stops
	
	  var colors = gradient.colorStops;
	
	  for (var i = 0, len = colors.length; i < len; ++i) {
	    var stop = this.createElement('stop');
	    stop.setAttribute('offset', colors[i].offset * 100 + '%');
	    var color = colors[i].color;
	
	    if (color.indexOf('rgba') > -1) {
	      // Fix Safari bug that stop-color not recognizing alpha #9014
	      var opacity = colorTool.parse(color)[3];
	      var hex = colorTool.toHex(color); // stop-color cannot be color, since:
	      // The opacity value used for the gradient calculation is the
	      // *product* of the value of stop-opacity and the opacity of the
	      // value of stop-color.
	      // See https://www.w3.org/TR/SVG2/pservers.html#StopOpacityProperty
	
	      stop.setAttribute('stop-color', '#' + hex);
	      stop.setAttribute('stop-opacity', opacity);
	    } else {
	      stop.setAttribute('stop-color', colors[i].color);
	    }
	
	    dom.appendChild(stop);
	  } // Store dom element in gradient, to avoid creating multiple
	  // dom instances for the same gradient element
	
	
	  gradient._dom = dom;
	};
	/**
	 * Mark a single gradient to be used
	 *
	 * @param {Displayable} displayable displayable element
	 */
	
	
	GradientManager.prototype.markUsed = function (displayable) {
	  if (displayable.style) {
	    var gradient = displayable.style.fill;
	
	    if (gradient && gradient._dom) {
	      Definable.prototype.markUsed.call(this, gradient._dom);
	    }
	
	    gradient = displayable.style.stroke;
	
	    if (gradient && gradient._dom) {
	      Definable.prototype.markUsed.call(this, gradient._dom);
	    }
	  }
	};
	
	var _default = GradientManager;
	module.exports = _default;

/***/ },
/* 2299 */
/***/ function(module, exports, __webpack_require__) {

	var Definable = __webpack_require__(564);
	
	var zrUtil = __webpack_require__(3);
	
	/**
	 * @file Manages SVG shadow elements.
	 * @author Zhang Wenli
	 */
	
	/**
	 * Manages SVG shadow elements.
	 *
	 * @class
	 * @extends Definable
	 * @param   {number}     zrId    zrender instance id
	 * @param   {SVGElement} svgRoot root of SVG document
	 */
	function ShadowManager(zrId, svgRoot) {
	  Definable.call(this, zrId, svgRoot, ['filter'], '__filter_in_use__', '_shadowDom');
	}
	
	zrUtil.inherits(ShadowManager, Definable);
	/**
	 * Create new shadow DOM for fill or stroke if not exist,
	 * but will not update shadow if exists.
	 *
	 * @param {SvgElement}  svgElement   SVG element to paint
	 * @param {Displayable} displayable  zrender displayable element
	 */
	
	ShadowManager.prototype.addWithoutUpdate = function (svgElement, displayable) {
	  if (displayable && hasShadow(displayable.style)) {
	    // Create dom in <defs> if not exists
	    var dom;
	
	    if (displayable._shadowDom) {
	      // Gradient exists
	      dom = displayable._shadowDom;
	      var defs = this.getDefs(true);
	
	      if (!defs.contains(displayable._shadowDom)) {
	        // _shadowDom is no longer in defs, recreate
	        this.addDom(dom);
	      }
	    } else {
	      // New dom
	      dom = this.add(displayable);
	    }
	
	    this.markUsed(displayable);
	    var id = dom.getAttribute('id');
	    svgElement.style.filter = 'url(#' + id + ')';
	  }
	};
	/**
	 * Add a new shadow tag in <defs>
	 *
	 * @param {Displayable} displayable  zrender displayable element
	 * @return {SVGFilterElement} created DOM
	 */
	
	
	ShadowManager.prototype.add = function (displayable) {
	  var dom = this.createElement('filter'); // Set dom id with shadow id, since each shadow instance
	  // will have no more than one dom element.
	  // id may exists before for those dirty elements, in which case
	  // id should remain the same, and other attributes should be
	  // updated.
	
	  displayable._shadowDomId = displayable._shadowDomId || this.nextId++;
	  dom.setAttribute('id', 'zr' + this._zrId + '-shadow-' + displayable._shadowDomId);
	  this.updateDom(displayable, dom);
	  this.addDom(dom);
	  return dom;
	};
	/**
	 * Update shadow.
	 *
	 * @param {Displayable} displayable  zrender displayable element
	 */
	
	
	ShadowManager.prototype.update = function (svgElement, displayable) {
	  var style = displayable.style;
	
	  if (hasShadow(style)) {
	    var that = this;
	    Definable.prototype.update.call(this, displayable, function () {
	      that.updateDom(displayable, displayable._shadowDom);
	    });
	  } else {
	    // Remove shadow
	    this.remove(svgElement, displayable);
	  }
	};
	/**
	 * Remove DOM and clear parent filter
	 */
	
	
	ShadowManager.prototype.remove = function (svgElement, displayable) {
	  if (displayable._shadowDomId != null) {
	    this.removeDom(svgElement);
	    svgElement.style.filter = '';
	  }
	};
	/**
	 * Update shadow dom
	 *
	 * @param {Displayable} displayable  zrender displayable element
	 * @param {SVGFilterElement} dom DOM to update
	 */
	
	
	ShadowManager.prototype.updateDom = function (displayable, dom) {
	  var domChild = dom.getElementsByTagName('feDropShadow');
	
	  if (domChild.length === 0) {
	    domChild = this.createElement('feDropShadow');
	  } else {
	    domChild = domChild[0];
	  }
	
	  var style = displayable.style;
	  var scaleX = displayable.scale ? displayable.scale[0] || 1 : 1;
	  var scaleY = displayable.scale ? displayable.scale[1] || 1 : 1; // TODO: textBoxShadowBlur is not supported yet
	
	  var offsetX;
	  var offsetY;
	  var blur;
	  var color;
	
	  if (style.shadowBlur || style.shadowOffsetX || style.shadowOffsetY) {
	    offsetX = style.shadowOffsetX || 0;
	    offsetY = style.shadowOffsetY || 0;
	    blur = style.shadowBlur;
	    color = style.shadowColor;
	  } else if (style.textShadowBlur) {
	    offsetX = style.textShadowOffsetX || 0;
	    offsetY = style.textShadowOffsetY || 0;
	    blur = style.textShadowBlur;
	    color = style.textShadowColor;
	  } else {
	    // Remove shadow
	    this.removeDom(dom, style);
	    return;
	  }
	
	  domChild.setAttribute('dx', offsetX / scaleX);
	  domChild.setAttribute('dy', offsetY / scaleY);
	  domChild.setAttribute('flood-color', color); // Divide by two here so that it looks the same as in canvas
	  // See: https://html.spec.whatwg.org/multipage/canvas.html#dom-context-2d-shadowblur
	
	  var stdDx = blur / 2 / scaleX;
	  var stdDy = blur / 2 / scaleY;
	  var stdDeviation = stdDx + ' ' + stdDy;
	  domChild.setAttribute('stdDeviation', stdDeviation); // Fix filter clipping problem
	
	  dom.setAttribute('x', '-100%');
	  dom.setAttribute('y', '-100%');
	  dom.setAttribute('width', Math.ceil(blur / 2 * 200) + '%');
	  dom.setAttribute('height', Math.ceil(blur / 2 * 200) + '%');
	  dom.appendChild(domChild); // Store dom element in shadow, to avoid creating multiple
	  // dom instances for the same shadow element
	
	  displayable._shadowDom = dom;
	};
	/**
	 * Mark a single shadow to be used
	 *
	 * @param {Displayable} displayable displayable element
	 */
	
	
	ShadowManager.prototype.markUsed = function (displayable) {
	  if (displayable._shadowDom) {
	    Definable.prototype.markUsed.call(this, displayable._shadowDom);
	  }
	};
	
	function hasShadow(style) {
	  // TODO: textBoxShadowBlur is not supported yet
	  return style && (style.shadowBlur || style.shadowOffsetX || style.shadowOffsetY || style.textShadowBlur || style.textShadowOffsetX || style.textShadowOffsetY);
	}
	
	var _default = ShadowManager;
	module.exports = _default;

/***/ },
/* 2300 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(563);
	
	var _zrender = __webpack_require__(390);
	
	var registerPainter = _zrender.registerPainter;
	
	var Painter = __webpack_require__(2296);
	
	registerPainter('svg', Painter);

/***/ },
/* 2301 */
/***/ function(module, exports, __webpack_require__) {

	var PathProxy = __webpack_require__(231);
	
	var _vector = __webpack_require__(41);
	
	var v2ApplyTransform = _vector.applyTransform;
	var CMD = PathProxy.CMD;
	var points = [[], [], []];
	var mathSqrt = Math.sqrt;
	var mathAtan2 = Math.atan2;
	
	function _default(path, m) {
	  var data = path.data;
	  var cmd;
	  var nPoint;
	  var i;
	  var j;
	  var k;
	  var p;
	  var M = CMD.M;
	  var C = CMD.C;
	  var L = CMD.L;
	  var R = CMD.R;
	  var A = CMD.A;
	  var Q = CMD.Q;
	
	  for (i = 0, j = 0; i < data.length;) {
	    cmd = data[i++];
	    j = i;
	    nPoint = 0;
	
	    switch (cmd) {
	      case M:
	        nPoint = 1;
	        break;
	
	      case L:
	        nPoint = 1;
	        break;
	
	      case C:
	        nPoint = 3;
	        break;
	
	      case Q:
	        nPoint = 2;
	        break;
	
	      case A:
	        var x = m[4];
	        var y = m[5];
	        var sx = mathSqrt(m[0] * m[0] + m[1] * m[1]);
	        var sy = mathSqrt(m[2] * m[2] + m[3] * m[3]);
	        var angle = mathAtan2(-m[1] / sy, m[0] / sx); // cx
	
	        data[i] *= sx;
	        data[i++] += x; // cy
	
	        data[i] *= sy;
	        data[i++] += y; // Scale rx and ry
	        // FIXME Assume psi is 0 here
	
	        data[i++] *= sx;
	        data[i++] *= sy; // Start angle
	
	        data[i++] += angle; // end angle
	
	        data[i++] += angle; // FIXME psi
	
	        i += 2;
	        j = i;
	        break;
	
	      case R:
	        // x0, y0
	        p[0] = data[i++];
	        p[1] = data[i++];
	        v2ApplyTransform(p, p, m);
	        data[j++] = p[0];
	        data[j++] = p[1]; // x1, y1
	
	        p[0] += data[i++];
	        p[1] += data[i++];
	        v2ApplyTransform(p, p, m);
	        data[j++] = p[0];
	        data[j++] = p[1];
	    }
	
	    for (k = 0; k < nPoint; k++) {
	      var p = points[k];
	      p[0] = data[i++];
	      p[1] = data[i++];
	      v2ApplyTransform(p, p, m); // Write back
	
	      data[j++] = p[0];
	      data[j++] = p[1];
	    }
	  }
	}
	
	module.exports = _default;

/***/ },
/* 2302 */
/***/ function(module, exports, __webpack_require__) {

	var logError = __webpack_require__(293);
	
	var vmlCore = __webpack_require__(1099);
	
	var _util = __webpack_require__(3);
	
	var each = _util.each;
	
	/**
	 * VML Painter.
	 *
	 * @module zrender/vml/Painter
	 */
	function parseInt10(val) {
	  return parseInt(val, 10);
	}
	/**
	 * @alias module:zrender/vml/Painter
	 */
	
	
	function VMLPainter(root, storage) {
	  vmlCore.initVML();
	  this.root = root;
	  this.storage = storage;
	  var vmlViewport = document.createElement('div');
	  var vmlRoot = document.createElement('div');
	  vmlViewport.style.cssText = 'display:inline-block;overflow:hidden;position:relative;width:300px;height:150px;';
	  vmlRoot.style.cssText = 'position:absolute;left:0;top:0;';
	  root.appendChild(vmlViewport);
	  this._vmlRoot = vmlRoot;
	  this._vmlViewport = vmlViewport;
	  this.resize(); // Modify storage
	
	  var oldDelFromStorage = storage.delFromStorage;
	  var oldAddToStorage = storage.addToStorage;
	
	  storage.delFromStorage = function (el) {
	    oldDelFromStorage.call(storage, el);
	
	    if (el) {
	      el.onRemove && el.onRemove(vmlRoot);
	    }
	  };
	
	  storage.addToStorage = function (el) {
	    // Displayable already has a vml node
	    el.onAdd && el.onAdd(vmlRoot);
	    oldAddToStorage.call(storage, el);
	  };
	
	  this._firstPaint = true;
	}
	
	VMLPainter.prototype = {
	  constructor: VMLPainter,
	  getType: function () {
	    return 'vml';
	  },
	
	  /**
	   * @return {HTMLDivElement}
	   */
	  getViewportRoot: function () {
	    return this._vmlViewport;
	  },
	  getViewportRootOffset: function () {
	    var viewportRoot = this.getViewportRoot();
	
	    if (viewportRoot) {
	      return {
	        offsetLeft: viewportRoot.offsetLeft || 0,
	        offsetTop: viewportRoot.offsetTop || 0
	      };
	    }
	  },
	
	  /**
	   * 刷新
	   */
	  refresh: function () {
	    var list = this.storage.getDisplayList(true, true);
	
	    this._paintList(list);
	  },
	  _paintList: function (list) {
	    var vmlRoot = this._vmlRoot;
	
	    for (var i = 0; i < list.length; i++) {
	      var el = list[i];
	
	      if (el.invisible || el.ignore) {
	        if (!el.__alreadyNotVisible) {
	          el.onRemove(vmlRoot);
	        } // Set as already invisible
	
	
	        el.__alreadyNotVisible = true;
	      } else {
	        if (el.__alreadyNotVisible) {
	          el.onAdd(vmlRoot);
	        }
	
	        el.__alreadyNotVisible = false;
	
	        if (el.__dirty) {
	          el.beforeBrush && el.beforeBrush();
	          (el.brushVML || el.brush).call(el, vmlRoot);
	          el.afterBrush && el.afterBrush();
	        }
	      }
	
	      el.__dirty = false;
	    }
	
	    if (this._firstPaint) {
	      // Detached from document at first time
	      // to avoid page refreshing too many times
	      // FIXME 如果每次都先 removeChild 可能会导致一些填充和描边的效果改变
	      this._vmlViewport.appendChild(vmlRoot);
	
	      this._firstPaint = false;
	    }
	  },
	  resize: function (width, height) {
	    var width = width == null ? this._getWidth() : width;
	    var height = height == null ? this._getHeight() : height;
	
	    if (this._width !== width || this._height !== height) {
	      this._width = width;
	      this._height = height;
	      var vmlViewportStyle = this._vmlViewport.style;
	      vmlViewportStyle.width = width + 'px';
	      vmlViewportStyle.height = height + 'px';
	    }
	  },
	  dispose: function () {
	    this.root.innerHTML = '';
	    this._vmlRoot = this._vmlViewport = this.storage = null;
	  },
	  getWidth: function () {
	    return this._width;
	  },
	  getHeight: function () {
	    return this._height;
	  },
	  clear: function () {
	    if (this._vmlViewport) {
	      this.root.removeChild(this._vmlViewport);
	    }
	  },
	  _getWidth: function () {
	    var root = this.root;
	    var stl = root.currentStyle;
	    return (root.clientWidth || parseInt10(stl.width)) - parseInt10(stl.paddingLeft) - parseInt10(stl.paddingRight) | 0;
	  },
	  _getHeight: function () {
	    var root = this.root;
	    var stl = root.currentStyle;
	    return (root.clientHeight || parseInt10(stl.height)) - parseInt10(stl.paddingTop) - parseInt10(stl.paddingBottom) | 0;
	  }
	}; // Not supported methods
	
	function createMethodNotSupport(method) {
	  return function () {
	    logError('In IE8.0 VML mode painter not support method "' + method + '"');
	  };
	} // Unsupported methods
	
	
	each(['getLayer', 'insertLayer', 'eachLayer', 'eachBuiltinLayer', 'eachOtherLayer', 'getLayers', 'modLayer', 'delLayer', 'clearLayer', 'toDataURL', 'pathToImage'], function (name) {
	  VMLPainter.prototype[name] = createMethodNotSupport(name);
	});
	var _default = VMLPainter;
	module.exports = _default;

/***/ },
/* 2303 */
/***/ function(module, exports, __webpack_require__) {

	var env = __webpack_require__(55);
	
	var _vector = __webpack_require__(41);
	
	var applyTransform = _vector.applyTransform;
	
	var BoundingRect = __webpack_require__(42);
	
	var colorTool = __webpack_require__(114);
	
	var textContain = __webpack_require__(79);
	
	var textHelper = __webpack_require__(388);
	
	var RectText = __webpack_require__(1092);
	
	var Displayable = __webpack_require__(294);
	
	var ZImage = __webpack_require__(232);
	
	var Text = __webpack_require__(188);
	
	var Path = __webpack_require__(46);
	
	var PathProxy = __webpack_require__(231);
	
	var Gradient = __webpack_require__(386);
	
	var vmlCore = __webpack_require__(1099);
	
	// http://www.w3.org/TR/NOTE-VML
	// TODO Use proxy like svg instead of overwrite brush methods
	var CMD = PathProxy.CMD;
	var round = Math.round;
	var sqrt = Math.sqrt;
	var abs = Math.abs;
	var cos = Math.cos;
	var sin = Math.sin;
	var mathMax = Math.max;
	
	if (!env.canvasSupported) {
	  var comma = ',';
	  var imageTransformPrefix = 'progid:DXImageTransform.Microsoft';
	  var Z = 21600;
	  var Z2 = Z / 2;
	  var ZLEVEL_BASE = 100000;
	  var Z_BASE = 1000;
	
	  var initRootElStyle = function (el) {
	    el.style.cssText = 'position:absolute;left:0;top:0;width:1px;height:1px;';
	    el.coordsize = Z + ',' + Z;
	    el.coordorigin = '0,0';
	  };
	
	  var encodeHtmlAttribute = function (s) {
	    return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;');
	  };
	
	  var rgb2Str = function (r, g, b) {
	    return 'rgb(' + [r, g, b].join(',') + ')';
	  };
	
	  var append = function (parent, child) {
	    if (child && parent && child.parentNode !== parent) {
	      parent.appendChild(child);
	    }
	  };
	
	  var remove = function (parent, child) {
	    if (child && parent && child.parentNode === parent) {
	      parent.removeChild(child);
	    }
	  };
	
	  var getZIndex = function (zlevel, z, z2) {
	    // z 的取值范围为 [0, 1000]
	    return (parseFloat(zlevel) || 0) * ZLEVEL_BASE + (parseFloat(z) || 0) * Z_BASE + z2;
	  };
	
	  var parsePercent = textHelper.parsePercent;
	  /***************************************************
	   * PATH
	   **************************************************/
	
	  var setColorAndOpacity = function (el, color, opacity) {
	    var colorArr = colorTool.parse(color);
	    opacity = +opacity;
	
	    if (isNaN(opacity)) {
	      opacity = 1;
	    }
	
	    if (colorArr) {
	      el.color = rgb2Str(colorArr[0], colorArr[1], colorArr[2]);
	      el.opacity = opacity * colorArr[3];
	    }
	  };
	
	  var getColorAndAlpha = function (color) {
	    var colorArr = colorTool.parse(color);
	    return [rgb2Str(colorArr[0], colorArr[1], colorArr[2]), colorArr[3]];
	  };
	
	  var updateFillNode = function (el, style, zrEl) {
	    // TODO pattern
	    var fill = style.fill;
	
	    if (fill != null) {
	      // Modified from excanvas
	      if (fill instanceof Gradient) {
	        var gradientType;
	        var angle = 0;
	        var focus = [0, 0]; // additional offset
	
	        var shift = 0; // scale factor for offset
	
	        var expansion = 1;
	        var rect = zrEl.getBoundingRect();
	        var rectWidth = rect.width;
	        var rectHeight = rect.height;
	
	        if (fill.type === 'linear') {
	          gradientType = 'gradient';
	          var transform = zrEl.transform;
	          var p0 = [fill.x * rectWidth, fill.y * rectHeight];
	          var p1 = [fill.x2 * rectWidth, fill.y2 * rectHeight];
	
	          if (transform) {
	            applyTransform(p0, p0, transform);
	            applyTransform(p1, p1, transform);
	          }
	
	          var dx = p1[0] - p0[0];
	          var dy = p1[1] - p0[1];
	          angle = Math.atan2(dx, dy) * 180 / Math.PI; // The angle should be a non-negative number.
	
	          if (angle < 0) {
	            angle += 360;
	          } // Very small angles produce an unexpected result because they are
	          // converted to a scientific notation string.
	
	
	          if (angle < 1e-6) {
	            angle = 0;
	          }
	        } else {
	          gradientType = 'gradientradial';
	          var p0 = [fill.x * rectWidth, fill.y * rectHeight];
	          var transform = zrEl.transform;
	          var scale = zrEl.scale;
	          var width = rectWidth;
	          var height = rectHeight;
	          focus = [// Percent in bounding rect
	          (p0[0] - rect.x) / width, (p0[1] - rect.y) / height];
	
	          if (transform) {
	            applyTransform(p0, p0, transform);
	          }
	
	          width /= scale[0] * Z;
	          height /= scale[1] * Z;
	          var dimension = mathMax(width, height);
	          shift = 2 * 0 / dimension;
	          expansion = 2 * fill.r / dimension - shift;
	        } // We need to sort the color stops in ascending order by offset,
	        // otherwise IE won't interpret it correctly.
	
	
	        var stops = fill.colorStops.slice();
	        stops.sort(function (cs1, cs2) {
	          return cs1.offset - cs2.offset;
	        });
	        var length = stops.length; // Color and alpha list of first and last stop
	
	        var colorAndAlphaList = [];
	        var colors = [];
	
	        for (var i = 0; i < length; i++) {
	          var stop = stops[i];
	          var colorAndAlpha = getColorAndAlpha(stop.color);
	          colors.push(stop.offset * expansion + shift + ' ' + colorAndAlpha[0]);
	
	          if (i === 0 || i === length - 1) {
	            colorAndAlphaList.push(colorAndAlpha);
	          }
	        }
	
	        if (length >= 2) {
	          var color1 = colorAndAlphaList[0][0];
	          var color2 = colorAndAlphaList[1][0];
	          var opacity1 = colorAndAlphaList[0][1] * style.opacity;
	          var opacity2 = colorAndAlphaList[1][1] * style.opacity;
	          el.type = gradientType;
	          el.method = 'none';
	          el.focus = '100%';
	          el.angle = angle;
	          el.color = color1;
	          el.color2 = color2;
	          el.colors = colors.join(','); // When colors attribute is used, the meanings of opacity and o:opacity2
	          // are reversed.
	
	          el.opacity = opacity2; // FIXME g_o_:opacity ?
	
	          el.opacity2 = opacity1;
	        }
	
	        if (gradientType === 'radial') {
	          el.focusposition = focus.join(',');
	        }
	      } else {
	        // FIXME Change from Gradient fill to color fill
	        setColorAndOpacity(el, fill, style.opacity);
	      }
	    }
	  };
	
	  var updateStrokeNode = function (el, style) {
	    // if (style.lineJoin != null) {
	    //     el.joinstyle = style.lineJoin;
	    // }
	    // if (style.miterLimit != null) {
	    //     el.miterlimit = style.miterLimit * Z;
	    // }
	    // if (style.lineCap != null) {
	    //     el.endcap = style.lineCap;
	    // }
	    if (style.lineDash) {
	      el.dashstyle = style.lineDash.join(' ');
	    }
	
	    if (style.stroke != null && !(style.stroke instanceof Gradient)) {
	      setColorAndOpacity(el, style.stroke, style.opacity);
	    }
	  };
	
	  var updateFillAndStroke = function (vmlEl, type, style, zrEl) {
	    var isFill = type === 'fill';
	    var el = vmlEl.getElementsByTagName(type)[0]; // Stroke must have lineWidth
	
	    if (style[type] != null && style[type] !== 'none' && (isFill || !isFill && style.lineWidth)) {
	      vmlEl[isFill ? 'filled' : 'stroked'] = 'true'; // FIXME Remove before updating, or set `colors` will throw error
	
	      if (style[type] instanceof Gradient) {
	        remove(vmlEl, el);
	      }
	
	      if (!el) {
	        el = vmlCore.createNode(type);
	      }
	
	      isFill ? updateFillNode(el, style, zrEl) : updateStrokeNode(el, style);
	      append(vmlEl, el);
	    } else {
	      vmlEl[isFill ? 'filled' : 'stroked'] = 'false';
	      remove(vmlEl, el);
	    }
	  };
	
	  var points = [[], [], []];
	
	  var pathDataToString = function (path, m) {
	    var M = CMD.M;
	    var C = CMD.C;
	    var L = CMD.L;
	    var A = CMD.A;
	    var Q = CMD.Q;
	    var str = [];
	    var nPoint;
	    var cmdStr;
	    var cmd;
	    var i;
	    var xi;
	    var yi;
	    var data = path.data;
	    var dataLength = path.len();
	
	    for (i = 0; i < dataLength;) {
	      cmd = data[i++];
	      cmdStr = '';
	      nPoint = 0;
	
	      switch (cmd) {
	        case M:
	          cmdStr = ' m ';
	          nPoint = 1;
	          xi = data[i++];
	          yi = data[i++];
	          points[0][0] = xi;
	          points[0][1] = yi;
	          break;
	
	        case L:
	          cmdStr = ' l ';
	          nPoint = 1;
	          xi = data[i++];
	          yi = data[i++];
	          points[0][0] = xi;
	          points[0][1] = yi;
	          break;
	
	        case Q:
	        case C:
	          cmdStr = ' c ';
	          nPoint = 3;
	          var x1 = data[i++];
	          var y1 = data[i++];
	          var x2 = data[i++];
	          var y2 = data[i++];
	          var x3;
	          var y3;
	
	          if (cmd === Q) {
	            // Convert quadratic to cubic using degree elevation
	            x3 = x2;
	            y3 = y2;
	            x2 = (x2 + 2 * x1) / 3;
	            y2 = (y2 + 2 * y1) / 3;
	            x1 = (xi + 2 * x1) / 3;
	            y1 = (yi + 2 * y1) / 3;
	          } else {
	            x3 = data[i++];
	            y3 = data[i++];
	          }
	
	          points[0][0] = x1;
	          points[0][1] = y1;
	          points[1][0] = x2;
	          points[1][1] = y2;
	          points[2][0] = x3;
	          points[2][1] = y3;
	          xi = x3;
	          yi = y3;
	          break;
	
	        case A:
	          var x = 0;
	          var y = 0;
	          var sx = 1;
	          var sy = 1;
	          var angle = 0;
	
	          if (m) {
	            // Extract SRT from matrix
	            x = m[4];
	            y = m[5];
	            sx = sqrt(m[0] * m[0] + m[1] * m[1]);
	            sy = sqrt(m[2] * m[2] + m[3] * m[3]);
	            angle = Math.atan2(-m[1] / sy, m[0] / sx);
	          }
	
	          var cx = data[i++];
	          var cy = data[i++];
	          var rx = data[i++];
	          var ry = data[i++];
	          var startAngle = data[i++] + angle;
	          var endAngle = data[i++] + startAngle + angle; // FIXME
	          // var psi = data[i++];
	
	          i++;
	          var clockwise = data[i++];
	          var x0 = cx + cos(startAngle) * rx;
	          var y0 = cy + sin(startAngle) * ry;
	          var x1 = cx + cos(endAngle) * rx;
	          var y1 = cy + sin(endAngle) * ry;
	          var type = clockwise ? ' wa ' : ' at ';
	
	          if (Math.abs(x0 - x1) < 1e-4) {
	            // IE won't render arches drawn counter clockwise if x0 == x1.
	            if (Math.abs(endAngle - startAngle) > 1e-2) {
	              // Offset x0 by 1/80 of a pixel. Use something
	              // that can be represented in binary
	              if (clockwise) {
	                x0 += 270 / Z;
	              }
	            } else {
	              // Avoid case draw full circle
	              if (Math.abs(y0 - cy) < 1e-4) {
	                if (clockwise && x0 < cx || !clockwise && x0 > cx) {
	                  y1 -= 270 / Z;
	                } else {
	                  y1 += 270 / Z;
	                }
	              } else if (clockwise && y0 < cy || !clockwise && y0 > cy) {
	                x1 += 270 / Z;
	              } else {
	                x1 -= 270 / Z;
	              }
	            }
	          }
	
	          str.push(type, round(((cx - rx) * sx + x) * Z - Z2), comma, round(((cy - ry) * sy + y) * Z - Z2), comma, round(((cx + rx) * sx + x) * Z - Z2), comma, round(((cy + ry) * sy + y) * Z - Z2), comma, round((x0 * sx + x) * Z - Z2), comma, round((y0 * sy + y) * Z - Z2), comma, round((x1 * sx + x) * Z - Z2), comma, round((y1 * sy + y) * Z - Z2));
	          xi = x1;
	          yi = y1;
	          break;
	
	        case CMD.R:
	          var p0 = points[0];
	          var p1 = points[1]; // x0, y0
	
	          p0[0] = data[i++];
	          p0[1] = data[i++]; // x1, y1
	
	          p1[0] = p0[0] + data[i++];
	          p1[1] = p0[1] + data[i++];
	
	          if (m) {
	            applyTransform(p0, p0, m);
	            applyTransform(p1, p1, m);
	          }
	
	          p0[0] = round(p0[0] * Z - Z2);
	          p1[0] = round(p1[0] * Z - Z2);
	          p0[1] = round(p0[1] * Z - Z2);
	          p1[1] = round(p1[1] * Z - Z2);
	          str.push( // x0, y0
	          ' m ', p0[0], comma, p0[1], // x1, y0
	          ' l ', p1[0], comma, p0[1], // x1, y1
	          ' l ', p1[0], comma, p1[1], // x0, y1
	          ' l ', p0[0], comma, p1[1]);
	          break;
	
	        case CMD.Z:
	          // FIXME Update xi, yi
	          str.push(' x ');
	      }
	
	      if (nPoint > 0) {
	        str.push(cmdStr);
	
	        for (var k = 0; k < nPoint; k++) {
	          var p = points[k];
	          m && applyTransform(p, p, m); // 不 round 会非常慢
	
	          str.push(round(p[0] * Z - Z2), comma, round(p[1] * Z - Z2), k < nPoint - 1 ? comma : '');
	        }
	      }
	    }
	
	    return str.join('');
	  }; // Rewrite the original path method
	
	
	  Path.prototype.brushVML = function (vmlRoot) {
	    var style = this.style;
	    var vmlEl = this._vmlEl;
	
	    if (!vmlEl) {
	      vmlEl = vmlCore.createNode('shape');
	      initRootElStyle(vmlEl);
	      this._vmlEl = vmlEl;
	    }
	
	    updateFillAndStroke(vmlEl, 'fill', style, this);
	    updateFillAndStroke(vmlEl, 'stroke', style, this);
	    var m = this.transform;
	    var needTransform = m != null;
	    var strokeEl = vmlEl.getElementsByTagName('stroke')[0];
	
	    if (strokeEl) {
	      var lineWidth = style.lineWidth; // Get the line scale.
	      // Determinant of this.m_ means how much the area is enlarged by the
	      // transformation. So its square root can be used as a scale factor
	      // for width.
	
	      if (needTransform && !style.strokeNoScale) {
	        var det = m[0] * m[3] - m[1] * m[2];
	        lineWidth *= sqrt(abs(det));
	      }
	
	      strokeEl.weight = lineWidth + 'px';
	    }
	
	    var path = this.path || (this.path = new PathProxy());
	
	    if (this.__dirtyPath) {
	      path.beginPath();
	      path.subPixelOptimize = false;
	      this.buildPath(path, this.shape);
	      path.toStatic();
	      this.__dirtyPath = false;
	    }
	
	    vmlEl.path = pathDataToString(path, this.transform);
	    vmlEl.style.zIndex = getZIndex(this.zlevel, this.z, this.z2); // Append to root
	
	    append(vmlRoot, vmlEl); // Text
	
	    if (style.text != null) {
	      this.drawRectText(vmlRoot, this.getBoundingRect());
	    } else {
	      this.removeRectText(vmlRoot);
	    }
	  };
	
	  Path.prototype.onRemove = function (vmlRoot) {
	    remove(vmlRoot, this._vmlEl);
	    this.removeRectText(vmlRoot);
	  };
	
	  Path.prototype.onAdd = function (vmlRoot) {
	    append(vmlRoot, this._vmlEl);
	    this.appendRectText(vmlRoot);
	  };
	  /***************************************************
	   * IMAGE
	   **************************************************/
	
	
	  var isImage = function (img) {
	    // FIXME img instanceof Image 如果 img 是一个字符串的时候，IE8 下会报错
	    return typeof img === 'object' && img.tagName && img.tagName.toUpperCase() === 'IMG'; // return img instanceof Image;
	  }; // Rewrite the original path method
	
	
	  ZImage.prototype.brushVML = function (vmlRoot) {
	    var style = this.style;
	    var image = style.image; // Image original width, height
	
	    var ow;
	    var oh;
	
	    if (isImage(image)) {
	      var src = image.src;
	
	      if (src === this._imageSrc) {
	        ow = this._imageWidth;
	        oh = this._imageHeight;
	      } else {
	        var imageRuntimeStyle = image.runtimeStyle;
	        var oldRuntimeWidth = imageRuntimeStyle.width;
	        var oldRuntimeHeight = imageRuntimeStyle.height;
	        imageRuntimeStyle.width = 'auto';
	        imageRuntimeStyle.height = 'auto'; // get the original size
	
	        ow = image.width;
	        oh = image.height; // and remove overides
	
	        imageRuntimeStyle.width = oldRuntimeWidth;
	        imageRuntimeStyle.height = oldRuntimeHeight; // Caching image original width, height and src
	
	        this._imageSrc = src;
	        this._imageWidth = ow;
	        this._imageHeight = oh;
	      }
	
	      image = src;
	    } else {
	      if (image === this._imageSrc) {
	        ow = this._imageWidth;
	        oh = this._imageHeight;
	      }
	    }
	
	    if (!image) {
	      return;
	    }
	
	    var x = style.x || 0;
	    var y = style.y || 0;
	    var dw = style.width;
	    var dh = style.height;
	    var sw = style.sWidth;
	    var sh = style.sHeight;
	    var sx = style.sx || 0;
	    var sy = style.sy || 0;
	    var hasCrop = sw && sh;
	    var vmlEl = this._vmlEl;
	
	    if (!vmlEl) {
	      // FIXME 使用 group 在 left, top 都不是 0 的时候就无法显示了。
	      // vmlEl = vmlCore.createNode('group');
	      vmlEl = vmlCore.doc.createElement('div');
	      initRootElStyle(vmlEl);
	      this._vmlEl = vmlEl;
	    }
	
	    var vmlElStyle = vmlEl.style;
	    var hasRotation = false;
	    var m;
	    var scaleX = 1;
	    var scaleY = 1;
	
	    if (this.transform) {
	      m = this.transform;
	      scaleX = sqrt(m[0] * m[0] + m[1] * m[1]);
	      scaleY = sqrt(m[2] * m[2] + m[3] * m[3]);
	      hasRotation = m[1] || m[2];
	    }
	
	    if (hasRotation) {
	      // If filters are necessary (rotation exists), create them
	      // filters are bog-slow, so only create them if abbsolutely necessary
	      // The following check doesn't account for skews (which don't exist
	      // in the canvas spec (yet) anyway.
	      // From excanvas
	      var p0 = [x, y];
	      var p1 = [x + dw, y];
	      var p2 = [x, y + dh];
	      var p3 = [x + dw, y + dh];
	      applyTransform(p0, p0, m);
	      applyTransform(p1, p1, m);
	      applyTransform(p2, p2, m);
	      applyTransform(p3, p3, m);
	      var maxX = mathMax(p0[0], p1[0], p2[0], p3[0]);
	      var maxY = mathMax(p0[1], p1[1], p2[1], p3[1]);
	      var transformFilter = [];
	      transformFilter.push('M11=', m[0] / scaleX, comma, 'M12=', m[2] / scaleY, comma, 'M21=', m[1] / scaleX, comma, 'M22=', m[3] / scaleY, comma, 'Dx=', round(x * scaleX + m[4]), comma, 'Dy=', round(y * scaleY + m[5]));
	      vmlElStyle.padding = '0 ' + round(maxX) + 'px ' + round(maxY) + 'px 0'; // FIXME DXImageTransform 在 IE11 的兼容模式下不起作用
	
	      vmlElStyle.filter = imageTransformPrefix + '.Matrix(' + transformFilter.join('') + ', SizingMethod=clip)';
	    } else {
	      if (m) {
	        x = x * scaleX + m[4];
	        y = y * scaleY + m[5];
	      }
	
	      vmlElStyle.filter = '';
	      vmlElStyle.left = round(x) + 'px';
	      vmlElStyle.top = round(y) + 'px';
	    }
	
	    var imageEl = this._imageEl;
	    var cropEl = this._cropEl;
	
	    if (!imageEl) {
	      imageEl = vmlCore.doc.createElement('div');
	      this._imageEl = imageEl;
	    }
	
	    var imageELStyle = imageEl.style;
	
	    if (hasCrop) {
	      // Needs know image original width and height
	      if (!(ow && oh)) {
	        var tmpImage = new Image();
	        var self = this;
	
	        tmpImage.onload = function () {
	          tmpImage.onload = null;
	          ow = tmpImage.width;
	          oh = tmpImage.height; // Adjust image width and height to fit the ratio destinationSize / sourceSize
	
	          imageELStyle.width = round(scaleX * ow * dw / sw) + 'px';
	          imageELStyle.height = round(scaleY * oh * dh / sh) + 'px'; // Caching image original width, height and src
	
	          self._imageWidth = ow;
	          self._imageHeight = oh;
	          self._imageSrc = image;
	        };
	
	        tmpImage.src = image;
	      } else {
	        imageELStyle.width = round(scaleX * ow * dw / sw) + 'px';
	        imageELStyle.height = round(scaleY * oh * dh / sh) + 'px';
	      }
	
	      if (!cropEl) {
	        cropEl = vmlCore.doc.createElement('div');
	        cropEl.style.overflow = 'hidden';
	        this._cropEl = cropEl;
	      }
	
	      var cropElStyle = cropEl.style;
	      cropElStyle.width = round((dw + sx * dw / sw) * scaleX);
	      cropElStyle.height = round((dh + sy * dh / sh) * scaleY);
	      cropElStyle.filter = imageTransformPrefix + '.Matrix(Dx=' + -sx * dw / sw * scaleX + ',Dy=' + -sy * dh / sh * scaleY + ')';
	
	      if (!cropEl.parentNode) {
	        vmlEl.appendChild(cropEl);
	      }
	
	      if (imageEl.parentNode !== cropEl) {
	        cropEl.appendChild(imageEl);
	      }
	    } else {
	      imageELStyle.width = round(scaleX * dw) + 'px';
	      imageELStyle.height = round(scaleY * dh) + 'px';
	      vmlEl.appendChild(imageEl);
	
	      if (cropEl && cropEl.parentNode) {
	        vmlEl.removeChild(cropEl);
	        this._cropEl = null;
	      }
	    }
	
	    var filterStr = '';
	    var alpha = style.opacity;
	
	    if (alpha < 1) {
	      filterStr += '.Alpha(opacity=' + round(alpha * 100) + ') ';
	    }
	
	    filterStr += imageTransformPrefix + '.AlphaImageLoader(src=' + image + ', SizingMethod=scale)';
	    imageELStyle.filter = filterStr;
	    vmlEl.style.zIndex = getZIndex(this.zlevel, this.z, this.z2); // Append to root
	
	    append(vmlRoot, vmlEl); // Text
	
	    if (style.text != null) {
	      this.drawRectText(vmlRoot, this.getBoundingRect());
	    }
	  };
	
	  ZImage.prototype.onRemove = function (vmlRoot) {
	    remove(vmlRoot, this._vmlEl);
	    this._vmlEl = null;
	    this._cropEl = null;
	    this._imageEl = null;
	    this.removeRectText(vmlRoot);
	  };
	
	  ZImage.prototype.onAdd = function (vmlRoot) {
	    append(vmlRoot, this._vmlEl);
	    this.appendRectText(vmlRoot);
	  };
	  /***************************************************
	   * TEXT
	   **************************************************/
	
	
	  var DEFAULT_STYLE_NORMAL = 'normal';
	  var fontStyleCache = {};
	  var fontStyleCacheCount = 0;
	  var MAX_FONT_CACHE_SIZE = 100;
	  var fontEl = document.createElement('div');
	
	  var getFontStyle = function (fontString) {
	    var fontStyle = fontStyleCache[fontString];
	
	    if (!fontStyle) {
	      // Clear cache
	      if (fontStyleCacheCount > MAX_FONT_CACHE_SIZE) {
	        fontStyleCacheCount = 0;
	        fontStyleCache = {};
	      }
	
	      var style = fontEl.style;
	      var fontFamily;
	
	      try {
	        style.font = fontString;
	        fontFamily = style.fontFamily.split(',')[0];
	      } catch (e) {}
	
	      fontStyle = {
	        style: style.fontStyle || DEFAULT_STYLE_NORMAL,
	        variant: style.fontVariant || DEFAULT_STYLE_NORMAL,
	        weight: style.fontWeight || DEFAULT_STYLE_NORMAL,
	        size: parseFloat(style.fontSize || 12) | 0,
	        family: fontFamily || 'Microsoft YaHei'
	      };
	      fontStyleCache[fontString] = fontStyle;
	      fontStyleCacheCount++;
	    }
	
	    return fontStyle;
	  };
	
	  var textMeasureEl; // Overwrite measure text method
	
	  textContain.$override('measureText', function (text, textFont) {
	    var doc = vmlCore.doc;
	
	    if (!textMeasureEl) {
	      textMeasureEl = doc.createElement('div');
	      textMeasureEl.style.cssText = 'position:absolute;top:-20000px;left:0;' + 'padding:0;margin:0;border:none;white-space:pre;';
	      vmlCore.doc.body.appendChild(textMeasureEl);
	    }
	
	    try {
	      textMeasureEl.style.font = textFont;
	    } catch (ex) {// Ignore failures to set to invalid font.
	    }
	
	    textMeasureEl.innerHTML = ''; // Don't use innerHTML or innerText because they allow markup/whitespace.
	
	    textMeasureEl.appendChild(doc.createTextNode(text));
	    return {
	      width: textMeasureEl.offsetWidth
	    };
	  });
	  var tmpRect = new BoundingRect();
	
	  var drawRectText = function (vmlRoot, rect, textRect, fromTextEl) {
	    var style = this.style; // Optimize, avoid normalize every time.
	
	    this.__dirty && textHelper.normalizeTextStyle(style, true);
	    var text = style.text; // Convert to string
	
	    text != null && (text += '');
	
	    if (!text) {
	      return;
	    } // Convert rich text to plain text. Rich text is not supported in
	    // IE8-, but tags in rich text template will be removed.
	
	
	    if (style.rich) {
	      var contentBlock = textContain.parseRichText(text, style);
	      text = [];
	
	      for (var i = 0; i < contentBlock.lines.length; i++) {
	        var tokens = contentBlock.lines[i].tokens;
	        var textLine = [];
	
	        for (var j = 0; j < tokens.length; j++) {
	          textLine.push(tokens[j].text);
	        }
	
	        text.push(textLine.join(''));
	      }
	
	      text = text.join('\n');
	    }
	
	    var x;
	    var y;
	    var align = style.textAlign;
	    var verticalAlign = style.textVerticalAlign;
	    var fontStyle = getFontStyle(style.font); // FIXME encodeHtmlAttribute ?
	
	    var font = fontStyle.style + ' ' + fontStyle.variant + ' ' + fontStyle.weight + ' ' + fontStyle.size + 'px "' + fontStyle.family + '"';
	    textRect = textRect || textContain.getBoundingRect(text, font, align, verticalAlign, style.textPadding, style.textLineHeight); // Transform rect to view space
	
	    var m = this.transform; // Ignore transform for text in other element
	
	    if (m && !fromTextEl) {
	      tmpRect.copy(rect);
	      tmpRect.applyTransform(m);
	      rect = tmpRect;
	    }
	
	    if (!fromTextEl) {
	      var textPosition = style.textPosition; // Text position represented by coord
	
	      if (textPosition instanceof Array) {
	        x = rect.x + parsePercent(textPosition[0], rect.width);
	        y = rect.y + parsePercent(textPosition[1], rect.height);
	        align = align || 'left';
	      } else {
	        var res = this.calculateTextPosition ? this.calculateTextPosition({}, style, rect) : textContain.calculateTextPosition({}, style, rect);
	        x = res.x;
	        y = res.y; // Default align and baseline when has textPosition
	
	        align = align || res.textAlign;
	        verticalAlign = verticalAlign || res.textVerticalAlign;
	      }
	    } else {
	      x = rect.x;
	      y = rect.y;
	    }
	
	    x = textContain.adjustTextX(x, textRect.width, align);
	    y = textContain.adjustTextY(y, textRect.height, verticalAlign); // Force baseline 'middle'
	
	    y += textRect.height / 2; // var fontSize = fontStyle.size;
	    // 1.75 is an arbitrary number, as there is no info about the text baseline
	    // switch (baseline) {
	    // case 'hanging':
	    // case 'top':
	    //     y += fontSize / 1.75;
	    //     break;
	    //     case 'middle':
	    //         break;
	    //     default:
	    //     // case null:
	    //     // case 'alphabetic':
	    //     // case 'ideographic':
	    //     // case 'bottom':
	    //         y -= fontSize / 2.25;
	    //         break;
	    // }
	    // switch (align) {
	    //     case 'left':
	    //         break;
	    //     case 'center':
	    //         x -= textRect.width / 2;
	    //         break;
	    //     case 'right':
	    //         x -= textRect.width;
	    //         break;
	    // case 'end':
	    // align = elementStyle.direction == 'ltr' ? 'right' : 'left';
	    // break;
	    // case 'start':
	    // align = elementStyle.direction == 'rtl' ? 'right' : 'left';
	    // break;
	    // default:
	    //     align = 'left';
	    // }
	
	    var createNode = vmlCore.createNode;
	    var textVmlEl = this._textVmlEl;
	    var pathEl;
	    var textPathEl;
	    var skewEl;
	
	    if (!textVmlEl) {
	      textVmlEl = createNode('line');
	      pathEl = createNode('path');
	      textPathEl = createNode('textpath');
	      skewEl = createNode('skew'); // FIXME Why here is not cammel case
	      // Align 'center' seems wrong
	
	      textPathEl.style['v-text-align'] = 'left';
	      initRootElStyle(textVmlEl);
	      pathEl.textpathok = true;
	      textPathEl.on = true;
	      textVmlEl.from = '0 0';
	      textVmlEl.to = '1000 0.05';
	      append(textVmlEl, skewEl);
	      append(textVmlEl, pathEl);
	      append(textVmlEl, textPathEl);
	      this._textVmlEl = textVmlEl;
	    } else {
	      // 这里是在前面 appendChild 保证顺序的前提下
	      skewEl = textVmlEl.firstChild;
	      pathEl = skewEl.nextSibling;
	      textPathEl = pathEl.nextSibling;
	    }
	
	    var coords = [x, y];
	    var textVmlElStyle = textVmlEl.style; // Ignore transform for text in other element
	
	    if (m && fromTextEl) {
	      applyTransform(coords, coords, m);
	      skewEl.on = true;
	      skewEl.matrix = m[0].toFixed(3) + comma + m[2].toFixed(3) + comma + m[1].toFixed(3) + comma + m[3].toFixed(3) + ',0,0'; // Text position
	
	      skewEl.offset = (round(coords[0]) || 0) + ',' + (round(coords[1]) || 0); // Left top point as origin
	
	      skewEl.origin = '0 0';
	      textVmlElStyle.left = '0px';
	      textVmlElStyle.top = '0px';
	    } else {
	      skewEl.on = false;
	      textVmlElStyle.left = round(x) + 'px';
	      textVmlElStyle.top = round(y) + 'px';
	    }
	
	    textPathEl.string = encodeHtmlAttribute(text); // TODO
	
	    try {
	      textPathEl.style.font = font;
	    } // Error font format
	    catch (e) {}
	
	    updateFillAndStroke(textVmlEl, 'fill', {
	      fill: style.textFill,
	      opacity: style.opacity
	    }, this);
	    updateFillAndStroke(textVmlEl, 'stroke', {
	      stroke: style.textStroke,
	      opacity: style.opacity,
	      lineDash: style.lineDash || null // style.lineDash can be `false`.
	
	    }, this);
	    textVmlEl.style.zIndex = getZIndex(this.zlevel, this.z, this.z2); // Attached to root
	
	    append(vmlRoot, textVmlEl);
	  };
	
	  var removeRectText = function (vmlRoot) {
	    remove(vmlRoot, this._textVmlEl);
	    this._textVmlEl = null;
	  };
	
	  var appendRectText = function (vmlRoot) {
	    append(vmlRoot, this._textVmlEl);
	  };
	
	  var list = [RectText, Displayable, ZImage, Path, Text]; // In case Displayable has been mixed in RectText
	
	  for (var i = 0; i < list.length; i++) {
	    var proto = list[i].prototype;
	    proto.drawRectText = drawRectText;
	    proto.removeRectText = removeRectText;
	    proto.appendRectText = appendRectText;
	  }
	
	  Text.prototype.brushVML = function (vmlRoot) {
	    var style = this.style;
	
	    if (style.text != null) {
	      this.drawRectText(vmlRoot, {
	        x: style.x || 0,
	        y: style.y || 0,
	        width: 0,
	        height: 0
	      }, this.getBoundingRect(), true);
	    } else {
	      this.removeRectText(vmlRoot);
	    }
	  };
	
	  Text.prototype.onRemove = function (vmlRoot) {
	    this.removeRectText(vmlRoot);
	  };
	
	  Text.prototype.onAdd = function (vmlRoot) {
	    this.appendRectText(vmlRoot);
	  };
	}

/***/ },
/* 2304 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(2303);
	
	var _zrender = __webpack_require__(390);
	
	var registerPainter = _zrender.registerPainter;
	
	var Painter = __webpack_require__(2302);
	
	registerPainter('vml', Painter);

/***/ },
/* 2305 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	var bind = __webpack_require__(170);
	var GetIntrinsic = __webpack_require__(__webpack_module_template_argument_0__);
	
	var $apply = GetIntrinsic('%Function.prototype.apply%');
	var $call = GetIntrinsic('%Function.prototype.call%');
	var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);
	
	var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
	var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
	var $max = GetIntrinsic('%Math.max%');
	
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
		} catch (e) {
			// IE 8 has a broken defineProperty
			$defineProperty = null;
		}
	}
	
	module.exports = function callBind(originalFunction) {
		var func = $reflectApply(bind, $call, arguments);
		if ($gOPD && $defineProperty) {
			var desc = $gOPD(func, 'length');
			if (desc.configurable) {
				// original length, plus the receiver, minus any additional arguments (after the receiver)
				$defineProperty(
					func,
					'length',
					{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
				);
			}
		}
		return func;
	};
	
	var applyBind = function applyBind() {
		return $reflectApply(bind, $apply, arguments);
	};
	
	if ($defineProperty) {
		$defineProperty(module.exports, 'apply', { value: applyBind });
	} else {
		module.exports.apply = applyBind;
	}


/***/ },
/* 2306 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(28);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 2307 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },
/* 2308 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 2309 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 2310 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.36c708d8.js